/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(776);
	module.exports = __webpack_require__(580);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key;
	                for (i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i;
	            for (i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
	                    matched,
	                    p1,
	                    p2,
	                    p3,
	                    p4
	                ) {
	                    return p1 || p2 || p3 || p4;
	                })
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
	            '_'
	        ),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(669)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^)]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
	        input,
	        array,
	        config,
	        token
	    ) {
	        var era = config._locale.erasParse(input, token, config._strict);
	        if (era) {
	            getParsingFlags(config).era = era;
	        } else {
	            getParsingFlags(config).invalidEra = input;
	        }
	    });
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.1';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(853)(module)))

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(206));
	__export(__webpack_require__(207));
	__export(__webpack_require__(135));
	__export(__webpack_require__(516));
	__export(__webpack_require__(517));
	__export(__webpack_require__(518));
	__export(__webpack_require__(519));
	__export(__webpack_require__(208));
	__export(__webpack_require__(521));
	__export(__webpack_require__(209));
	__export(__webpack_require__(522));
	__export(__webpack_require__(523));
	__export(__webpack_require__(524));
	__export(__webpack_require__(526));
	__export(__webpack_require__(525));
	
	//# sourceMappingURL=index.js.map


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(65);


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(618);
	
	__webpack_require__(621);
	
	__webpack_require__(625);
	
	__webpack_require__(622);
	
	var _logo = __webpack_require__(845);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _orangeToggle = __webpack_require__(641);
	
	var _orangeToggle2 = _interopRequireDefault(_orangeToggle);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouterDom = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { getData } from '../services';
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));
	
	    _this.state = {
	      userId: ""
	
	    };
	    _this.logout = _this.logout.bind(_this);
	    _this.redirectToStories = _this.redirectToStories.bind(_this);
	    return _this;
	  }
	
	  _createClass(Header, [{
	    key: "redirectToStories",
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(val) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                window.location.href = "/insightss/id=" + val;
	
	              case 1:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function redirectToStories(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return redirectToStories;
	    }()
	  }, {
	    key: "logout",
	    value: function logout() {
	      localStorage.removeItem("userId");
	      localStorage.removeItem("userName");
	      localStorage.removeItem("userImage");
	      localStorage.removeItem("guidanceArray");
	      window.location.href = "/";
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var userId = localStorage.getItem("userId");
	      this.setState({
	        userId: userId
	      });
	      (0, _jquery2.default)(".content-right-wrapper").click(function () {
	        (0, _jquery2.default)(".menu-wrapper").removeClass("menu-wrapper-active");
	      });
	
	      //   // setInterval(()=>{
	      //   //   this.getLoginInfocommon()
	      //   // },25000)
	
	      //   if (window.sessionStorage.getItem("userId") === "" || window.sessionStorage.getItem("userId") === null || window.sessionStorage.getItem("userId") === "null") {
	      //     //this.props.history.push('/');
	      //     window.location.href="/"
	      //   }
	      //   const url = new URL(window.location); 
	      //   //url.searchParams.set('', '');
	      //   //alert()
	      //   window.history.pushState({}, '', url);
	    }
	  }, {
	    key: "menuShow",
	    value: function menuShow() {
	      (0, _jquery2.default)(".header-wrapper").toggleClass("menu-wrapper-mobshow");
	    }
	  }, {
	    key: "menuHide",
	    value: function menuHide() {
	      (0, _jquery2.default)(".header-wrapper").removeClass("menu-wrapper-mobshow");
	    }
	
	    // logOut() {
	    //   window.sessionStorage.clear();
	    //   window.location.href = "/"
	
	    // }
	    // getLoginInfocommon() {    
	
	    //     const postData = {
	    //       "functionName": "loginAuth",
	    //       "route": "user",
	    //       "token": window.sessionStorage.getItem('token')
	    //     }
	    //     //console.log('login token....',token)  
	    //     getData(postData).then((data) => {    
	    //       //console.log('login data....',data)   
	    //       if (data.data.response[0].success === "1") {
	
	    //       }
	    //       else {
	    //         this.logOut()
	    //       }
	    //     })
	
	    // }
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      // var roleId = window.sessionStorage.getItem('roleId')
	      var url = "";
	      // if (roleId === "3") {
	      //   url = "/taluk/dashboard"
	      // }
	      // else if (roleId === "2") {
	      //   url = "/doctorDashboard"
	      // }
	      // else if (roleId === "4") {
	      //   url = "/district/dashboard"
	      // }
	      // else if (roleId === "7") {
	      //   url = "/insurance/dashboard"
	      // }
	      // else if (roleId === "5") {
	      //   url = "/state/dashboard"
	      // }
	      var institutionLoginName = window.sessionStorage.getItem('institutionLoginName');
	      var userId = localStorage.getItem("userId");
	      console.log("user.........", userId);
	      return _react2.default.createElement(
	        "div",
	        { className: "header-wrapper", id: "top" },
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "nav",
	            { className: "navbar navbar-expand-lg" },
	            _react2.default.createElement(
	              "button",
	              { className: "navbar-menushow", onClick: function onClick() {
	                  return _this2.menuShow();
	                } },
	              _react2.default.createElement("img", { src: _orangeToggle2.default })
	            ),
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { className: "navbar-brand logo p-0", to: url },
	              _react2.default.createElement("img", { src: _logo2.default })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "menu-wrapper" },
	              _react2.default.createElement(
	                "div",
	                { className: "menuList menuListClose" },
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: "menuListLink" },
	                  "Menu "
	                ),
	                _react2.default.createElement(
	                  "button",
	                  { className: "navbar-close", type: "button", onClick: function onClick() {
	                      return _this2.menuHide();
	                    } },
	                  _react2.default.createElement(
	                    "svg",
	                    { width: "16", height: "17", viewBox: "0 0 16 17", xmlns: "http://www.w3.org/2000/svg" },
	                    _react2.default.createElement("path", { d: "M0.142135 2.00015L1.55635 0.585938L15.6985 14.7281L14.2843 16.1423L0.142135 2.00015Z", fill: "currentColor" }),
	                    _react2.default.createElement("path", { d: "M14.1421 1.0001L15.5563 2.41431L1.41421 16.5564L0 15.1422L14.1421 1.0001Z", fill: "currentColor" })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "menuList menuListHover" },
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: "menuListLink" },
	                  "Resources"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "menuListSub" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "menuList" },
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      { className: "menuListLink", onClick: function onClick() {
	                          return _this2.redirectToStories("Course Reviews");
	                        } },
	                      "Course Reviews"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "menuList" },
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      { className: "menuListLink", onClick: function onClick() {
	                          return _this2.redirectToStories("Stories");
	                        } },
	                      "Stories"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "menuList" },
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      { className: "menuListLink", onClick: function onClick() {
	                          return _this2.redirectToStories("Blogs");
	                        } },
	                      "Blogs"
	                    )
	                  )
	                )
	              ),
	              !userId && _react2.default.createElement(
	                "div",
	                { className: "menuList" },
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: "menuListLink", to: "/assesment/apply" },
	                  "Get Started"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "menuList" },
	                userId ? _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: "menuListLink", to: "/user-dashboard" },
	                  "Dashboard"
	                ) : ""
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "menuList" },
	                userId ? _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: "btn-theme", onClick: this.logout },
	                  "Logout"
	                ) : _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: "btn-theme", to: "/my-account" },
	                  "Login"
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Header;
	}(_react.Component);
	
	exports.default = Header;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twitter = __webpack_require__(848);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _facebook = __webpack_require__(831);
	
	var _facebook2 = _interopRequireDefault(_facebook);
	
	var _linkedin = __webpack_require__(844);
	
	var _linkedin2 = _interopRequireDefault(_linkedin);
	
	var _instagram = __webpack_require__(835);
	
	var _instagram2 = _interopRequireDefault(_instagram);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var footer = function (_Component) {
	  _inherits(footer, _Component);
	
	  function footer() {
	    _classCallCheck(this, footer);
	
	    return _possibleConstructorReturn(this, (footer.__proto__ || Object.getPrototypeOf(footer)).apply(this, arguments));
	  }
	
	  _createClass(footer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _jquery2.default)(".btn-scroll-top").click(function () {
	        document.body.scrollTop = 0;
	        document.documentElement.scrollTop = 0;
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'footer',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6 col-sm-6' },
	              _react2.default.createElement(
	                'p',
	                { style: { fontSize: "16px", marginLeft: "18px" } },
	                ' With Ivanooo, you just don\'t go through hundreds of courses. Narrow down choices. Avoid pitfalls and make better decisions.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 mt-5' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '/assesment/apply', className: 'btn-theme' },
	                  'Get Started'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6 col-sm-6' },
	              _react2.default.createElement(
	                'div',
	                { className: 'footer-right' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'footer-socials' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://www.facebook.com/ivanooolearning' },
	                    _react2.default.createElement('img', { src: _facebook2.default, alt: '' })
	                  ),
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://twitter.com/ivanooolearning' },
	                    _react2.default.createElement('img', { src: _twitter2.default, style: { width: "38px" }, alt: '' })
	                  ),
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://www.linkedin.com/company/ivanooo' },
	                    _react2.default.createElement('img', { src: _linkedin2.default, alt: '' })
	                  ),
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://instagram.com/ivanooo.learning' },
	                    _react2.default.createElement('img', { src: _instagram2.default, alt: '' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'footer-menu' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'a',
	                      { href: '/privacy-policy' },
	                      'Privacy Policy'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'a',
	                      { href: '/about' },
	                      'about'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'a',
	                      { href: '/contact' },
	                      'Contacts'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'a',
	                      { href: '#' },
	                      'Terms of Use'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 copyright-outer' },
	            _react2.default.createElement(
	              'p',
	              { className: 'copyright' },
	              'All \xA9 Rights Reserved | Ivanooo - 2021'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'btn-scroll-top', 'data-scroll': '' },
	          _react2.default.createElement(
	            'svg',
	            { width: '10', height: '6', viewBox: '0 0 10 6', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	            _react2.default.createElement('path', { d: 'M9.84016 0.540385L9.5126 0.210545C9.40951 0.107536 9.27235 0.0507876 9.12577 0.0507876C8.97926 0.0507876 8.84194 0.107536 8.73885 0.210545L5.00224 3.94732L1.26131 0.206399C1.15838 0.10339 1.02107 0.0467224 0.87456 0.0467224C0.728055 0.0467224 0.590655 0.10339 0.487646 0.206399L0.160001 0.534206C-0.0533338 0.747379 -0.0533338 1.09462 0.160001 1.30779L4.61402 5.77783C4.71695 5.88075 4.8541 5.95327 5.00191 5.95327H5.00362C5.1502 5.95327 5.28736 5.88067 5.39029 5.77783L9.84016 1.3199C9.94325 1.21698 9.99984 1.07567 10 0.929169C10 0.782582 9.94325 0.643231 9.84016 0.540385Z', fill: 'currentColor' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return footer;
	}(_react.Component);
	
	exports.default = footer;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.db = exports.storage = exports.database = exports.storyCategoryRef = exports.institutionRef = exports.modeOfLearningRef = exports.countryRef = exports.goalsRef = exports.personnaRef = exports.priceRangeRef = exports.experienceRef = exports.educationRef = exports.skillsRef = exports.expertiseRef = exports.storyRef = exports.testimonialRef = exports.guidance = exports.secUser = exports.courseRef = exports.insightRef = undefined;
	
	var _firebase = __webpack_require__(646);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _app = __webpack_require__(222);
	
	var _firestore = __webpack_require__(645);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  apiKey: 'AIzaSyDUjzwuUU7SdfgCtvj0ukWhI2HBq2Jyz5U',
	  authDomain: 'ivanooo.firebaseapp.com',
	  databaseURL: 'https://ivanooo-default-rtdb.firebaseio.com',
	  projectId: 'ivanooo',
	  storageBucket: 'ivanooo.appspot.com',
	  messagingSenderId: '674732140680'
	};
	
	_firebase2.default.initializeApp(config);
	
	exports.default = _firebase2.default;
	
	var constDatabaseRef = _firebase2.default.database().ref();
	var insightRef = exports.insightRef = constDatabaseRef.child('insights');
	var courseRef = exports.courseRef = constDatabaseRef.child('Course');
	var secUser = exports.secUser = constDatabaseRef.child('SecUser');
	var guidance = exports.guidance = constDatabaseRef.child('Guidance');
	var testimonialRef = exports.testimonialRef = constDatabaseRef.child('testimonials');
	var storyRef = exports.storyRef = constDatabaseRef.child('stories');
	var expertiseRef = exports.expertiseRef = constDatabaseRef.child('expertise');
	var skillsRef = exports.skillsRef = constDatabaseRef.child('skills');
	var educationRef = exports.educationRef = constDatabaseRef.child('education');
	var experienceRef = exports.experienceRef = constDatabaseRef.child('experience');
	var priceRangeRef = exports.priceRangeRef = constDatabaseRef.child('priceRange');
	var personnaRef = exports.personnaRef = constDatabaseRef.child('personna');
	var goalsRef = exports.goalsRef = constDatabaseRef.child('goals');
	var countryRef = exports.countryRef = constDatabaseRef.child('country');
	var modeOfLearningRef = exports.modeOfLearningRef = constDatabaseRef.child('modeOfLearning');
	var institutionRef = exports.institutionRef = constDatabaseRef.child('institution');
	var storyCategoryRef = exports.storyCategoryRef = constDatabaseRef.child('storyCategory');
	var database = exports.database = _firebase2.default.database();
	
	// export const auth = firebase.auth();
	var storage = exports.storage = _firebase2.default.storage();
	var db = exports.db = _firebase2.default.firestore();
	
	// export const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
	// export const messaging = firebase.messaging();

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(606);


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.6.0
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright OpenJS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2021-03-02T17:08Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var flat = arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};
	
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
			// Support: Chrome <=57, Firefox <=52
			// In some browsers, typeof returns "function" for HTML <object> elements
			// (i.e., `typeof document.createElement( "object" ) === "function"`).
			// We don't want to classify *any* DOM node as a function.
			// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
			// Plus for old WebKit, typeof returns "function" for HTML collections
			// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
			return typeof obj === "function" && typeof obj.nodeType !== "number" &&
				typeof obj.item !== "function";
		};
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	var document = window.document;
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.6.0",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},
	
		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
							[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return flat( ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
		function( _i, name ) {
			class2type[ "[object " + name + "]" ] = name.toLowerCase();
		} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.6
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://js.foundation/
	 *
	 * Date: 2021-02-16
	 */
	( function( window ) {
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ( {} ).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		pushNative = arr.push,
		push = arr.push,
		slice = arr.slice,
	
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[ i ] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
			"ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
	
			// "Attribute values must be CSS identifiers [capture 5]
			// or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
	
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
			whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
			"*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
	
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rhtml = /HTML$/i,
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;
	
			return nonHex ?
	
				// Strip the backslash prefix from a non-hex escape sequence
				nonHex :
	
				// Replace a hexadecimal escape sequence with the encoded Unicode code point
				// Support: IE <=11+
				// For values outside the Basic Multilingual Plane (BMP), manually construct a
				// surrogate pair
				high < 0 ?
					String.fromCharCode( high + 0x10000 ) :
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" +
					ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);
	
		// Support: Android<4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
	
				// Can't trust NodeList.length
				while ( ( target[ j++ ] = els[ i++ ] ) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {
	
					// ID selector
					if ( ( m = match[ 1 ] ) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&
	
					// Support: IE 8 only
					// Exclude object elements
					( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
	
						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						if ( newContext !== context || !support.scope ) {
	
							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = nid.replace( rcssescape, fcssescape );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
	
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
	
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );
	
		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {
	
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
	
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split( "|" ),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[ i ] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( ( cur = cur.nextSibling ) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return ( name === "input" || name === "button" ) && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;
	
		// Support: IE <=8
		// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
		// https://bugs.jquery.com/ticket/4833
		return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
		// Safari 4 - 5 only, Opera <=11.6 - 12.x only
		// IE/Edge & older browsers don't support the :scope pseudo-class.
		// Support: Safari 6.0 only
		// Safari 6.0 supports :scope but it's an alias of :root there.
		support.scope = assert( function( el ) {
			docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
			return typeof el.querySelectorAll !== "undefined" &&
				!el.querySelectorAll( ":scope fieldset div" ).length;
		} );
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert( function( el ) {
			el.className = "i";
			return !el.getAttribute( "className" );
		} );
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert( function( el ) {
			el.appendChild( document.createComment( "" ) );
			return !el.getElementsByTagName( "*" ).length;
		} );
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		} );
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter[ "ID" ] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter[ "ID" ] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find[ "TAG" ] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
	
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( ( elem = results[ i++ ] ) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {
	
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert( function( el ) {
	
				var input;
	
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll( "[selected]" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push( "~=" );
				}
	
				// Support: IE 11+, Edge 15 - 18+
				// IE 11/Edge don't find elements on a `[name='']` query in some cases.
				// Adding a temporary attribute to the document before the selection works
				// around the issue.
				// Interestingly, IE 10 & older don't seem to have the issue.
				input = document.createElement( "input" );
				input.setAttribute( "name", "" );
				el.appendChild( input );
				if ( !el.querySelectorAll( "[name='']" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
						whitespace + "*(?:''|\"\")" );
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll( ":checked" ).length ) {
					rbuggyQSA.push( ":checked" );
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push( ".#.+[+~]" );
				}
	
				// Support: Firefox <=3.6 - 5 only
				// Old Firefox doesn't throw on a badly-escaped identifier.
				el.querySelectorAll( "\\\f" );
				rbuggyQSA.push( "[\\r\\n\\f]" );
			} );
	
			assert( function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement( "input" );
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll( "[name=d]" ).length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: Opera 10 - 11 only
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll( "*,:x" );
				rbuggyQSA.push( ",.*:" );
			} );
		}
	
		if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector ) ) ) ) {
	
			assert( function( el ) {
	
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			} );
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				) );
			} :
			function( a, b ) {
				if ( b ) {
					while ( ( b = b.parentNode ) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {
	
				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a == document || a.ownerDocument == preferredDoc &&
					contains( preferredDoc, a ) ) {
					return -1;
				}
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b == document || b.ownerDocument == preferredDoc &&
					contains( preferredDoc, b ) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
	
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				return a == document ? -1 :
					b == document ? 1 :
					/* eslint-enable eqeqeq */
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( ( cur = cur.parentNode ) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( ( cur = cur.parentNode ) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[ i ] === bp[ i ] ) {
				i++;
			}
	
			return i ?
	
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[ i ], bp[ i ] ) :
	
				// Otherwise nodes in our document sort first
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				ap[ i ] == preferredDoc ? -1 :
				bp[ i ] == preferredDoc ? 1 :
				/* eslint-enable eqeqeq */
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		setDocument( elem );
	
		if ( support.matchesSelector && documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
	
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
	
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
	
			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {
	
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
	
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
	
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
	
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
					match[ 5 ] || "" ).replace( runescape, funescape );
	
				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
	
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();
	
				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {
	
					// nth-* requires argument
					if ( !match[ 3 ] ) {
						Sizzle.error( match[ 0 ] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );
	
					// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];
	
				if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
	
					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&
	
					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {
	
					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace +
						")" + className + "(" + whitespace + "|$)" ) ) && classCache(
							className, function( elem ) {
								return pattern.test(
									typeof elem.className === "string" && elem.className ||
									typeof elem.getAttribute !== "undefined" &&
										elem.getAttribute( "class" ) ||
									""
								);
					} );
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					/* eslint-disable max-len */
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
					/* eslint-enable max-len */
	
				};
			},
	
			"CHILD": function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, _context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
	
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || ( node[ expando ] = {} );
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
	
								// Use previously-cached element index if available
								if ( useCache ) {
	
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || ( node[ expando ] = {} );
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										( outerCache[ node.uniqueID ] = {} );
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
	
									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													( outerCache[ node.uniqueID ] = {} );
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
	
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
	
			// Potentially complex pseudos
			"not": markFunction( function( selector ) {
	
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );
	
						// Don't keep the element (issue #299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),
	
			"has": markFunction( function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			} ),
	
			"contains": markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
				};
			} ),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
	
				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement &&
					( !document.hasFocus || document.hasFocus() ) &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
	
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return ( nodeName === "input" && !!elem.checked ) ||
					( nodeName === "option" && !!elem.selected );
			},
	
			"selected": function( elem ) {
	
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
	
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos[ "empty" ]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo( function() {
				return [ 0 ];
			} ),
	
			"last": createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),
	
			"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),
	
			"even": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"odd": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ?
					argument + length :
					argument > length ?
						length :
						argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};
	
	Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {
	
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}
	
			matched = false;
	
			// Combinators
			if ( ( match = rcombinators.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
	
					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrim, " " )
				} );
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
	
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
	
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] ||
								( outerCache[ elem.uniqueID ] = {} );
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = uniqueCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {
	
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[ i ], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts(
					selector || "*",
					context.nodeType ? [ context ] : context,
					[]
				),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
	
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
	
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {
	
								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {
	
							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
	
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
	
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
	
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens
							.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;
	
				if ( outermost ) {
	
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
	
						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
	
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
	
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache(
				selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers )
			);
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {
	
				context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
					.replace( runescape, funescape ), context ) || [] )[ 0 ];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {
	
					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
							context
					) ) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {
	
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert( function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute( "href" ) === "#";
	} ) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		} );
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert( function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	} ) ) {
		addHandle( "value", function( elem, _name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		} );
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert( function( el ) {
		return el.getAttribute( "disabled" ) == null;
	} ) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
					( val = elem.getAttributeNode( name ) ) && val.specified ?
						val.value :
						null;
			}
		} );
	}
	
	return Sizzle;
	
	} )( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	}
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&
	
				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {
	
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the primary Deferred
				primary = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							primary.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( primary.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return primary.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
			}
	
			return primary.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
							value :
							value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 - 11+
	// focus() and blur() are asynchronous, except when they are no-op.
	// So expect focus to be synchronous when the element is already active,
	// and blur to be synchronous when the element is not already active.
	// (focus and blur are always synchronous in other supported browsers,
	// this just defines when we can count on it).
	function expectSync( elem, type ) {
		return ( elem === safeActiveElement() ) === ( type === "focus" );
	}
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),
	
				handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
							return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
							return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", returnTrue );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, expectSync ) {
	
		// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
		if ( !expectSync ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var notAsync, result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					// Saved data should be false in such cases, but might be a leftover capture object
					// from an async native handler (gh-4350)
					if ( !saved.length ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						// Support: IE <=9 - 11+
						// focus() and blur() are asynchronous
						notAsync = expectSync( this, type );
						this[ type ]();
						result = dataPriv.get( this, type );
						if ( saved !== result || notAsync ) {
							dataPriv.set( this, type, false );
						} else {
							result = {};
						}
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
	
							// Support: Chrome 86+
							// In Chrome, if an element having a focusout handler is blurred by
							// clicking outside of it, it invokes the handler synchronously. If
							// that handler calls `.remove()` on the element, the data is cleared,
							// leaving `result` undefined. We need to guard against this.
							return result && result.value;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering the
					// native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved.length ) {
	
					// ...and capture the result
					dataPriv.set( this, type, {
						value: jQuery.event.trigger(
	
							// Support: IE <=9 - 11+
							// Extend with the prototype to reset the above stopImmediatePropagation()
							jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
							saved.slice( 1 ),
							this
						)
					} );
	
					// Abort handling of the native event
					event.stopImmediatePropagation();
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
		which: true
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, expectSync );
	
				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			// Suppress native focus or blur as it's already being fired
			// in leverageNative.
			_default: function() {
				return true;
			},
	
			delegateType: delegateType
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;
	
			if ( events ) {
				dataPriv.remove( dest, "handle events" );
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = flat( args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.call( elem );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},
	
			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			//
			// Support: Firefox 70+
			// Only Firefox includes border widths
			// in computed dimensions. (gh-4529)
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );
	
					table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
					tr.style.cssText = "border:1px solid";
	
					// Support: Chrome 86+
					// Height set through cssText does not get applied.
					// Computed height then comes back as 0.
					tr.style.height = "1px";
					trChild.style.height = "9px";
	
					// Support: Android 8 Chrome 86+
					// In our bodyBackground.html iframe,
					// display for all div elements is set to "inline",
					// which causes a problem only in Android 8 Chrome 86.
					// Ensuring the div is display: block
					// gets around this issue.
					trChild.style.display = "block";
	
					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );
	
					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
						parseInt( trStyle.borderTopWidth, 10 ) +
						parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;
	
					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( _elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||
	
			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||
	
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
	
			// Make sure the element is visible & connected
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"gridArea": true,
			"gridColumn": true,
			"gridColumnEnd": true,
			"gridColumnStart": true,
			"gridRow": true,
			"gridRowEnd": true,
			"gridRowStart": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
				) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
					/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
	
			doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( isValidValue ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
								"" :
								dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	support.focusin = "onfocusin" in window;
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
	
					// Handle: regular nodes (via `this.ownerDocument`), window
					// (via `this.document`) & document (via `this`).
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = { guid: Date.now() };
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, parserErrorElem;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {}
	
		parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
		if ( !xml || parserErrorElem ) {
			jQuery.error( "Invalid XML: " + (
				parserErrorElem ?
					jQuery.map( parserErrorElem.childNodes, function( el ) {
						return el.textContent;
					} ).join( "\n" ) :
					data
			) );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} ).filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} ).map( function( _i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
	
	originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Use a noop converter for missing script but not if jsonp
				if ( !isSuccess &&
					jQuery.inArray( "script", s.dataTypes ) > -1 &&
					jQuery.inArray( "json", s.dataTypes ) < 0 ) {
					s.converters[ "text script" ] = function() {};
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );
	
	
	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( {
			padding: "inner" + name,
			content: type,
			"": "outer" + name
		}, function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
	
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	jQuery.each(
		( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {
	
			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		}
	);
	
	
	
	
	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	};
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(771);
	} else {
	  module.exports = require("./cjs/react-router-dom.js");
	}


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var version_1 = __webpack_require__(125);
	var log_1 = __webpack_require__(24);
	/**
	 * Unconditionally fails, throwing an Error with the given message.
	 *
	 * Returns any so it can be used in expressions:
	 * @example
	 * let futureVar = fail('not implemented yet');
	 */
	function fail(failure) {
	    // Log the failure in addition to throw an exception, just in case the
	    // exception is swallowed.
	    var message = "FIRESTORE (" + version_1.SDK_VERSION + ") INTERNAL ASSERTION FAILED: " + failure;
	    log_1.error(message);
	    // NOTE: We don't use FirestoreError here because these are internal failures
	    // that cannot be handled by the user. (Also it would create a circular
	    // dependency between the error and assert modules which doesn't work.)
	    throw new Error(message);
	}
	exports.fail = fail;
	/**
	 * Fails if the given assertion condition is false, throwing an Error with the
	 * given message if it did.
	 */
	function assert(assertion, message) {
	    if (!assertion) {
	        fail(message);
	    }
	}
	exports.assert = assert;
	
	//# sourceMappingURL=assert.js.map


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _home = __webpack_require__(833);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Menu = function (_Component) {
	  _inherits(Menu, _Component);
	
	  function Menu() {
	    _classCallCheck(this, Menu);
	
	    return _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).apply(this, arguments));
	  }
	
	  _createClass(Menu, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      (0, _jquery2.default)(".menu-toggle").click(function () {
	        (0, _jquery2.default)(".menu-wrapper").toggleClass("menu-wrapper-active");
	      });
	      (0, _jquery2.default)(".menu-wrapper").click(function () {
	        (0, _jquery2.default)(this).addClass("menu-wrapper-active");
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	
	      return _react2.default.createElement(
	        "div",
	        { "class": "menu-wrapper" },
	        window.sessionStorage.getItem('authority') === "STATE" && _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list menu-list-active" },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/state/dashboard" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              " Home"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list menu-list-active" },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/stateFund" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              " Fund Allotment"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list menu-list-active" },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/proceeding" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              " Proceeding"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list menu-list-active" },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/changePassword" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              " Change Password"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list menu-list-active" },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/insuranceClaimList" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Claims"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list menu-list-active" },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/stateLevel/retaggingList" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Re-tagging"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list menu-list-active" },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/stateLevel/ownerShipChange" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Ownership Change"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list menu-list-active" },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/stateLevel/statePolicyList" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Policy List"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list menu-list-active" },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/stateLevel/sateApplicationList" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Application List"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list menu-list-active" },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/reports" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Reports"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list menu-list-active" },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: { pathname: "/newUser", state: { userID: window.sessionStorage.getItem("userId"), fromPage: "pofile" } } },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Profile"
	            )
	          )
	        ),
	        window.sessionStorage.getItem('authority') === "DOCTOR" && _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list menu-list-active" },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/doctorDashboard" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              " Home"
	            )
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: "/doctorFund", "class": "menu-list" },
	            _react2.default.createElement("img", { src: _home2.default }),
	            " Fund"
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: "/ApplicationList", "class": "menu-list" },
	            _react2.default.createElement("img", { src: _home2.default }),
	            " Applications"
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: "/policyApplication", "class": "menu-list" },
	            _react2.default.createElement("img", { src: _home2.default }),
	            " Policies"
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: "/AnimalList", "class": "menu-list" },
	            _react2.default.createElement("img", { src: _home2.default }),
	            " Retagging"
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: "/changeOwner", "class": "menu-list" },
	            _react2.default.createElement("img", { src: _home2.default }),
	            " Change Owner"
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: "/insuranceClaimList", "class": "menu-list" },
	            _react2.default.createElement("img", { src: _home2.default }),
	            " Claims"
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: { pathname: "/newUser", state: { userID: window.sessionStorage.getItem("userId"), fromPage: "pofile" } }, "class": "menu-list" },
	            _react2.default.createElement("img", { src: _home2.default }),
	            " Profile"
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: "/changePassword", "class": "menu-list" },
	            _react2.default.createElement("img", { src: _home2.default }),
	            " Change Password"
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list menu-list-active" },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/reports" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Reports"
	            )
	          )
	        ),
	        window.sessionStorage.getItem('authority') === "TALUK" && _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list menu-list-active" },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/taluk/dashboard" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Home"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list " },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/taluk/talukFundList" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Fund Allotment"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list " },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/taluk/talukApplicationList" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Application List"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list " },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/taluk/talukRetagList" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Retagging List"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list " },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/taluk/talukOwnerShip" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Owner Change"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list " },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/taluk/talukPolicyList" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Policy List"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list " },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/insuranceClaimList" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Claims List"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list " },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: { pathname: "/newUser", state: { userID: window.sessionStorage.getItem("userId"), fromPage: "pofile" } } },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Profile"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list " },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/reports" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Reports"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list " },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/changePassword" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              " Change Password"
	            )
	          )
	        ),
	        window.sessionStorage.getItem('authority') === "DISTRICT" && _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list " },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/district/dashboard" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Home"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list " },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/district/fund" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Fund"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list " },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/district/districtApplicationList" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Application List"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list " },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/district/districtRetagList" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Retagging List"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list " },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/district/districtOwnerShip" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Owner Change"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list " },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/district/districtPolicyList" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Policy List"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list " },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/insuranceClaimList" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Claims List"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list " },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/reports" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Reports"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list " },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: { pathname: "/newUser", state: { userID: window.sessionStorage.getItem("userId"), fromPage: "pofile" } } },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Profile"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list " },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/changePassword" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Change Password"
	            )
	          )
	        ),
	        window.sessionStorage.getItem('authority') === "INSURANCE_COMPANY" && _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list menu-list-active" },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/insurance/dashboard" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Home"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list " },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/policyListing" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Proceedings List"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list " },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/InsuranceClaimList" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Claims"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list " },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/insurance/retaggingList" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Retagged List"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "menu-list " },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "/insurance/ownerChangedList" },
	              _react2.default.createElement("img", { src: _home2.default }),
	              "Owner Change"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Menu;
	}(_react.Component);
	
	exports.default = Menu;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var util_2 = __webpack_require__(2);
	var util_3 = __webpack_require__(2);
	var util_4 = __webpack_require__(2);
	var util_5 = __webpack_require__(2);
	var util_6 = __webpack_require__(2);
	var storage_1 = __webpack_require__(89);
	var util_7 = __webpack_require__(2);
	/**
	 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
	 * @type {function(): number} Generated ID.
	 */
	exports.LUIDGenerator = (function () {
	    var id = 1;
	    return function () {
	        return id++;
	    };
	})();
	/**
	 * Sha1 hash of the input string
	 * @param {!string} str The string to hash
	 * @return {!string} The resulting hash
	 */
	exports.sha1 = function (str) {
	    var utf8Bytes = util_5.stringToByteArray(str);
	    var sha1 = new util_4.Sha1();
	    sha1.update(utf8Bytes);
	    var sha1Bytes = sha1.digest();
	    return util_3.base64.encodeByteArray(sha1Bytes);
	};
	/**
	 * @param {...*} var_args
	 * @return {string}
	 * @private
	 */
	var buildLogMessage_ = function () {
	    var var_args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        var_args[_i] = arguments[_i];
	    }
	    var message = '';
	    for (var i = 0; i < var_args.length; i++) {
	        if (Array.isArray(var_args[i]) ||
	            (var_args[i] &&
	                typeof var_args[i] === 'object' &&
	                typeof var_args[i].length === 'number')) {
	            message += buildLogMessage_.apply(null, var_args[i]);
	        }
	        else if (typeof var_args[i] === 'object') {
	            message += util_6.stringify(var_args[i]);
	        }
	        else {
	            message += var_args[i];
	        }
	        message += ' ';
	    }
	    return message;
	};
	/**
	 * Use this for all debug messages in Firebase.
	 * @type {?function(string)}
	 */
	exports.logger = null;
	/**
	 * Flag to check for log availability on first log message
	 * @type {boolean}
	 * @private
	 */
	var firstLog_ = true;
	/**
	 * The implementation of Firebase.enableLogging (defined here to break dependencies)
	 * @param {boolean|?function(string)} logger_ A flag to turn on logging, or a custom logger
	 * @param {boolean=} persistent Whether or not to persist logging settings across refreshes
	 */
	exports.enableLogging = function (logger_, persistent) {
	    util_1.assert(!persistent || (logger_ === true || logger_ === false), "Can't turn on custom loggers persistently.");
	    if (logger_ === true) {
	        if (typeof console !== 'undefined') {
	            if (typeof console.log === 'function') {
	                exports.logger = console.log.bind(console);
	            }
	            else if (typeof console.log === 'object') {
	                // IE does this.
	                exports.logger = function (message) {
	                    console.log(message);
	                };
	            }
	        }
	        if (persistent)
	            storage_1.SessionStorage.set('logging_enabled', true);
	    }
	    else if (typeof logger_ === 'function') {
	        exports.logger = logger_;
	    }
	    else {
	        exports.logger = null;
	        storage_1.SessionStorage.remove('logging_enabled');
	    }
	};
	/**
	 *
	 * @param {...(string|Arguments)} var_args
	 */
	exports.log = function () {
	    var var_args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        var_args[_i] = arguments[_i];
	    }
	    if (firstLog_ === true) {
	        firstLog_ = false;
	        if (exports.logger === null && storage_1.SessionStorage.get('logging_enabled') === true)
	            exports.enableLogging(true);
	    }
	    if (exports.logger) {
	        var message = buildLogMessage_.apply(null, var_args);
	        exports.logger(message);
	    }
	};
	/**
	 * @param {!string} prefix
	 * @return {function(...[*])}
	 */
	exports.logWrapper = function (prefix) {
	    return function () {
	        var var_args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            var_args[_i] = arguments[_i];
	        }
	        exports.log.apply(void 0, [prefix].concat(var_args));
	    };
	};
	/**
	 * @param {...string} var_args
	 */
	exports.error = function () {
	    var var_args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        var_args[_i] = arguments[_i];
	    }
	    if (typeof console !== 'undefined') {
	        var message = 'FIREBASE INTERNAL ERROR: ' + buildLogMessage_.apply(void 0, var_args);
	        if (typeof console.error !== 'undefined') {
	            console.error(message);
	        }
	        else {
	            console.log(message);
	        }
	    }
	};
	/**
	 * @param {...string} var_args
	 */
	exports.fatal = function () {
	    var var_args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        var_args[_i] = arguments[_i];
	    }
	    var message = buildLogMessage_.apply(void 0, var_args);
	    throw new Error('FIREBASE FATAL ERROR: ' + message);
	};
	/**
	 * @param {...*} var_args
	 */
	exports.warn = function () {
	    var var_args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        var_args[_i] = arguments[_i];
	    }
	    if (typeof console !== 'undefined') {
	        var message = 'FIREBASE WARNING: ' + buildLogMessage_.apply(void 0, var_args);
	        if (typeof console.warn !== 'undefined') {
	            console.warn(message);
	        }
	        else {
	            console.log(message);
	        }
	    }
	};
	/**
	 * Logs a warning if the containing page uses https. Called when a call to new Firebase
	 * does not use https.
	 */
	exports.warnIfPageIsSecure = function () {
	    // Be very careful accessing browser globals. Who knows what may or may not exist.
	    if (typeof window !== 'undefined' &&
	        window.location &&
	        window.location.protocol &&
	        window.location.protocol.indexOf('https:') !== -1) {
	        exports.warn('Insecure Firebase access from a secure page. ' +
	            'Please use https in calls to new Firebase().');
	    }
	};
	/**
	 * @param {!String} methodName
	 */
	exports.warnAboutUnsupportedMethod = function (methodName) {
	    exports.warn(methodName +
	        ' is unsupported and will likely change soon.  ' +
	        'Please do not use.');
	};
	/**
	 * Returns true if data is NaN, or +/- Infinity.
	 * @param {*} data
	 * @return {boolean}
	 */
	exports.isInvalidJSONNumber = function (data) {
	    return (typeof data === 'number' &&
	        (data != data || // NaN
	            data == Number.POSITIVE_INFINITY ||
	            data == Number.NEGATIVE_INFINITY));
	};
	/**
	 * @param {function()} fn
	 */
	exports.executeWhenDOMReady = function (fn) {
	    if (util_7.isNodeSdk() || document.readyState === 'complete') {
	        fn();
	    }
	    else {
	        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
	        // fire before onload), but fall back to onload.
	        var called_1 = false;
	        var wrappedFn_1 = function () {
	            if (!document.body) {
	                setTimeout(wrappedFn_1, Math.floor(10));
	                return;
	            }
	            if (!called_1) {
	                called_1 = true;
	                fn();
	            }
	        };
	        if (document.addEventListener) {
	            document.addEventListener('DOMContentLoaded', wrappedFn_1, false);
	            // fallback to onload.
	            window.addEventListener('load', wrappedFn_1, false);
	        }
	        else if (document.attachEvent) {
	            // IE.
	            document.attachEvent('onreadystatechange', function () {
	                if (document.readyState === 'complete')
	                    wrappedFn_1();
	            });
	            // fallback to onload.
	            window.attachEvent('onload', wrappedFn_1);
	            // jQuery has an extra hack for IE that we could employ (based on
	            // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
	            // I'm hoping we don't need it.
	        }
	    }
	};
	/**
	 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
	 * @type {!string}
	 */
	exports.MIN_NAME = '[MIN_NAME]';
	/**
	 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
	 * @type {!string}
	 */
	exports.MAX_NAME = '[MAX_NAME]';
	/**
	 * Compares valid Firebase key names, plus min and max name
	 * @param {!string} a
	 * @param {!string} b
	 * @return {!number}
	 */
	exports.nameCompare = function (a, b) {
	    if (a === b) {
	        return 0;
	    }
	    else if (a === exports.MIN_NAME || b === exports.MAX_NAME) {
	        return -1;
	    }
	    else if (b === exports.MIN_NAME || a === exports.MAX_NAME) {
	        return 1;
	    }
	    else {
	        var aAsInt = exports.tryParseInt(a), bAsInt = exports.tryParseInt(b);
	        if (aAsInt !== null) {
	            if (bAsInt !== null) {
	                return aAsInt - bAsInt == 0 ? a.length - b.length : aAsInt - bAsInt;
	            }
	            else {
	                return -1;
	            }
	        }
	        else if (bAsInt !== null) {
	            return 1;
	        }
	        else {
	            return a < b ? -1 : 1;
	        }
	    }
	};
	/**
	 * @param {!string} a
	 * @param {!string} b
	 * @return {!number} comparison result.
	 */
	exports.stringCompare = function (a, b) {
	    if (a === b) {
	        return 0;
	    }
	    else if (a < b) {
	        return -1;
	    }
	    else {
	        return 1;
	    }
	};
	/**
	 * @param {string} key
	 * @param {Object} obj
	 * @return {*}
	 */
	exports.requireKey = function (key, obj) {
	    if (obj && key in obj) {
	        return obj[key];
	    }
	    else {
	        throw new Error('Missing required key (' + key + ') in object: ' + util_6.stringify(obj));
	    }
	};
	/**
	 * @param {*} obj
	 * @return {string}
	 */
	exports.ObjectToUniqueKey = function (obj) {
	    if (typeof obj !== 'object' || obj === null)
	        return util_6.stringify(obj);
	    var keys = [];
	    for (var k in obj) {
	        keys.push(k);
	    }
	    // Export as json, but with the keys sorted.
	    keys.sort();
	    var key = '{';
	    for (var i = 0; i < keys.length; i++) {
	        if (i !== 0)
	            key += ',';
	        key += util_6.stringify(keys[i]);
	        key += ':';
	        key += exports.ObjectToUniqueKey(obj[keys[i]]);
	    }
	    key += '}';
	    return key;
	};
	/**
	 * Splits a string into a number of smaller segments of maximum size
	 * @param {!string} str The string
	 * @param {!number} segsize The maximum number of chars in the string.
	 * @return {Array.<string>} The string, split into appropriately-sized chunks
	 */
	exports.splitStringBySize = function (str, segsize) {
	    var len = str.length;
	    if (len <= segsize) {
	        return [str];
	    }
	    var dataSegs = [];
	    for (var c = 0; c < len; c += segsize) {
	        if (c + segsize > len) {
	            dataSegs.push(str.substring(c, len));
	        }
	        else {
	            dataSegs.push(str.substring(c, c + segsize));
	        }
	    }
	    return dataSegs;
	};
	/**
	 * Apply a function to each (key, value) pair in an object or
	 * apply a function to each (index, value) pair in an array
	 * @param {!(Object|Array)} obj The object or array to iterate over
	 * @param {function(?, ?)} fn The function to apply
	 */
	exports.each = function (obj, fn) {
	    if (Array.isArray(obj)) {
	        for (var i = 0; i < obj.length; ++i) {
	            fn(i, obj[i]);
	        }
	    }
	    else {
	        /**
	         * in the conversion of code we removed the goog.object.forEach
	         * function which did a value,key callback. We standardized on
	         * a single impl that does a key, value callback. So we invert
	         * to not have to touch the `each` code points
	         */
	        util_2.forEach(obj, function (key, val) { return fn(val, key); });
	    }
	};
	/**
	 * Like goog.bind, but doesn't bother to create a closure if opt_context is null/undefined.
	 * @param {function(*)} callback Callback function.
	 * @param {?Object=} context Optional context to bind to.
	 * @return {function(*)}
	 */
	exports.bindCallback = function (callback, context) {
	    return context ? callback.bind(context) : callback;
	};
	/**
	 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
	 * I made one modification at the end and removed the NaN / Infinity
	 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
	 * @param {!number} v A double
	 * @return {string}
	 */
	exports.doubleToIEEE754String = function (v) {
	    util_1.assert(!exports.isInvalidJSONNumber(v), 'Invalid JSON number'); // MJL
	    var ebits = 11, fbits = 52;
	    var bias = (1 << (ebits - 1)) - 1, s, e, f, ln, i, bits, str;
	    // Compute sign, exponent, fraction
	    // Skip NaN / Infinity handling --MJL.
	    if (v === 0) {
	        e = 0;
	        f = 0;
	        s = 1 / v === -Infinity ? 1 : 0;
	    }
	    else {
	        s = v < 0;
	        v = Math.abs(v);
	        if (v >= Math.pow(2, 1 - bias)) {
	            // Normalized
	            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
	            e = ln + bias;
	            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
	        }
	        else {
	            // Denormalized
	            e = 0;
	            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
	        }
	    }
	    // Pack sign, exponent, fraction
	    bits = [];
	    for (i = fbits; i; i -= 1) {
	        bits.push(f % 2 ? 1 : 0);
	        f = Math.floor(f / 2);
	    }
	    for (i = ebits; i; i -= 1) {
	        bits.push(e % 2 ? 1 : 0);
	        e = Math.floor(e / 2);
	    }
	    bits.push(s ? 1 : 0);
	    bits.reverse();
	    str = bits.join('');
	    // Return the data as a hex string. --MJL
	    var hexByteString = '';
	    for (i = 0; i < 64; i += 8) {
	        var hexByte = parseInt(str.substr(i, 8), 2).toString(16);
	        if (hexByte.length === 1)
	            hexByte = '0' + hexByte;
	        hexByteString = hexByteString + hexByte;
	    }
	    return hexByteString.toLowerCase();
	};
	/**
	 * Used to detect if we're in a Chrome content script (which executes in an
	 * isolated environment where long-polling doesn't work).
	 * @return {boolean}
	 */
	exports.isChromeExtensionContentScript = function () {
	    return !!(typeof window === 'object' &&
	        window['chrome'] &&
	        window['chrome']['extension'] &&
	        !/^chrome/.test(window.location.href));
	};
	/**
	 * Used to detect if we're in a Windows 8 Store app.
	 * @return {boolean}
	 */
	exports.isWindowsStoreApp = function () {
	    // Check for the presence of a couple WinRT globals
	    return typeof Windows === 'object' && typeof Windows.UI === 'object';
	};
	/**
	 * Converts a server error code to a Javascript Error
	 * @param {!string} code
	 * @param {!Query} query
	 * @return {Error}
	 */
	exports.errorForServerCode = function (code, query) {
	    var reason = 'Unknown Error';
	    if (code === 'too_big') {
	        reason =
	            'The data requested exceeds the maximum size ' +
	                'that can be accessed with a single request.';
	    }
	    else if (code == 'permission_denied') {
	        reason = "Client doesn't have permission to access the desired data.";
	    }
	    else if (code == 'unavailable') {
	        reason = 'The service is unavailable';
	    }
	    var error = new Error(code + ' at ' + query.path.toString() + ': ' + reason);
	    error.code = code.toUpperCase();
	    return error;
	};
	/**
	 * Used to test for integer-looking strings
	 * @type {RegExp}
	 * @private
	 */
	exports.INTEGER_REGEXP_ = new RegExp('^-?\\d{1,10}$');
	/**
	 * If the string contains a 32-bit integer, return it.  Else return null.
	 * @param {!string} str
	 * @return {?number}
	 */
	exports.tryParseInt = function (str) {
	    if (exports.INTEGER_REGEXP_.test(str)) {
	        var intVal = Number(str);
	        if (intVal >= -2147483648 && intVal <= 2147483647) {
	            return intVal;
	        }
	    }
	    return null;
	};
	/**
	 * Helper to run some code but catch any exceptions and re-throw them later.
	 * Useful for preventing user callbacks from breaking internal code.
	 *
	 * Re-throwing the exception from a setTimeout is a little evil, but it's very
	 * convenient (we don't have to try to figure out when is a safe point to
	 * re-throw it), and the behavior seems reasonable:
	 *
	 * * If you aren't pausing on exceptions, you get an error in the console with
	 *   the correct stack trace.
	 * * If you're pausing on all exceptions, the debugger will pause on your
	 *   exception and then again when we rethrow it.
	 * * If you're only pausing on uncaught exceptions, the debugger will only pause
	 *   on us re-throwing it.
	 *
	 * @param {!function()} fn The code to guard.
	 */
	exports.exceptionGuard = function (fn) {
	    try {
	        fn();
	    }
	    catch (e) {
	        // Re-throw exception when it's safe.
	        setTimeout(function () {
	            // It used to be that "throw e" would result in a good console error with
	            // relevant context, but as of Chrome 39, you just get the firebase.js
	            // file/line number where we re-throw it, which is useless. So we log
	            // e.stack explicitly.
	            var stack = e.stack || '';
	            exports.warn('Exception was thrown by user callback.', stack);
	            throw e;
	        }, Math.floor(0));
	    }
	};
	/**
	 * Helper function to safely call opt_callback with the specified arguments.  It:
	 * 1. Turns into a no-op if opt_callback is null or undefined.
	 * 2. Wraps the call inside exceptionGuard to prevent exceptions from breaking our state.
	 *
	 * @param {?Function=} callback Optional onComplete callback.
	 * @param {...*} var_args Arbitrary args to be passed to opt_onComplete
	 */
	exports.callUserCallback = function (callback) {
	    var var_args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        var_args[_i - 1] = arguments[_i];
	    }
	    if (typeof callback === 'function') {
	        exports.exceptionGuard(function () {
	            callback.apply(void 0, var_args);
	        });
	    }
	};
	/**
	 * @return {boolean} true if we think we're currently being crawled.
	 */
	exports.beingCrawled = function () {
	    var userAgent = (typeof window === 'object' &&
	        window['navigator'] &&
	        window['navigator']['userAgent']) ||
	        '';
	    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
	    // believe to support JavaScript/AJAX rendering.
	    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
	    // would have seen the page" is flaky if we don't treat it as a crawler.
	    return (userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0);
	};
	/**
	 * Export a property of an object using a getter function.
	 *
	 * @param {!Object} object
	 * @param {string} name
	 * @param {!function(): *} fnGet
	 */
	exports.exportPropGetter = function (object, name, fnGet) {
	    Object.defineProperty(object, name, { get: fnGet });
	};
	/**
	 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
	 *
	 * It is removed with clearTimeout() as normal.
	 *
	 * @param {Function} fn Function to run.
	 * @param {number} time Milliseconds to wait before running.
	 * @return {number|Object} The setTimeout() return value.
	 */
	exports.setTimeoutNonBlocking = function (fn, time) {
	    var timeout = setTimeout(fn, time);
	    if (typeof timeout === 'object' && timeout['unref']) {
	        timeout['unref']();
	    }
	    return timeout;
	};
	
	//# sourceMappingURL=util.js.map


/***/ },
/* 14 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(37);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 16 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(13);
	var util_2 = __webpack_require__(2);
	/**
	 * An immutable object representing a parsed path.  It's immutable so that you
	 * can pass them around to other functions without worrying about them changing
	 * it.
	 */
	var Path = /** @class */ (function () {
	    /**
	     * @param {string|Array.<string>} pathOrString Path string to parse,
	     *      or another path, or the raw tokens array
	     * @param {number=} pieceNum
	     */
	    function Path(pathOrString, pieceNum) {
	        if (pieceNum === void 0) {
	            this.pieces_ = pathOrString.split('/');
	            // Remove empty pieces.
	            var copyTo = 0;
	            for (var i = 0; i < this.pieces_.length; i++) {
	                if (this.pieces_[i].length > 0) {
	                    this.pieces_[copyTo] = this.pieces_[i];
	                    copyTo++;
	                }
	            }
	            this.pieces_.length = copyTo;
	            this.pieceNum_ = 0;
	        }
	        else {
	            this.pieces_ = pathOrString;
	            this.pieceNum_ = pieceNum;
	        }
	    }
	    Object.defineProperty(Path, "Empty", {
	        /**
	         * Singleton to represent an empty path
	         *
	         * @const
	         */
	        get: function () {
	            return new Path('');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Path.prototype.getFront = function () {
	        if (this.pieceNum_ >= this.pieces_.length)
	            return null;
	        return this.pieces_[this.pieceNum_];
	    };
	    /**
	     * @return {number} The number of segments in this path
	     */
	    Path.prototype.getLength = function () {
	        return this.pieces_.length - this.pieceNum_;
	    };
	    /**
	     * @return {!Path}
	     */
	    Path.prototype.popFront = function () {
	        var pieceNum = this.pieceNum_;
	        if (pieceNum < this.pieces_.length) {
	            pieceNum++;
	        }
	        return new Path(this.pieces_, pieceNum);
	    };
	    /**
	     * @return {?string}
	     */
	    Path.prototype.getBack = function () {
	        if (this.pieceNum_ < this.pieces_.length)
	            return this.pieces_[this.pieces_.length - 1];
	        return null;
	    };
	    Path.prototype.toString = function () {
	        var pathString = '';
	        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
	            if (this.pieces_[i] !== '')
	                pathString += '/' + this.pieces_[i];
	        }
	        return pathString || '/';
	    };
	    Path.prototype.toUrlEncodedString = function () {
	        var pathString = '';
	        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
	            if (this.pieces_[i] !== '')
	                pathString += '/' + encodeURIComponent(String(this.pieces_[i]));
	        }
	        return pathString || '/';
	    };
	    /**
	     * Shallow copy of the parts of the path.
	     *
	     * @param {number=} begin
	     * @return {!Array<string>}
	     */
	    Path.prototype.slice = function (begin) {
	        if (begin === void 0) { begin = 0; }
	        return this.pieces_.slice(this.pieceNum_ + begin);
	    };
	    /**
	     * @return {?Path}
	     */
	    Path.prototype.parent = function () {
	        if (this.pieceNum_ >= this.pieces_.length)
	            return null;
	        var pieces = [];
	        for (var i = this.pieceNum_; i < this.pieces_.length - 1; i++)
	            pieces.push(this.pieces_[i]);
	        return new Path(pieces, 0);
	    };
	    /**
	     * @param {string|!Path} childPathObj
	     * @return {!Path}
	     */
	    Path.prototype.child = function (childPathObj) {
	        var pieces = [];
	        for (var i = this.pieceNum_; i < this.pieces_.length; i++)
	            pieces.push(this.pieces_[i]);
	        if (childPathObj instanceof Path) {
	            for (var i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++) {
	                pieces.push(childPathObj.pieces_[i]);
	            }
	        }
	        else {
	            var childPieces = childPathObj.split('/');
	            for (var i = 0; i < childPieces.length; i++) {
	                if (childPieces[i].length > 0)
	                    pieces.push(childPieces[i]);
	            }
	        }
	        return new Path(pieces, 0);
	    };
	    /**
	     * @return {boolean} True if there are no segments in this path
	     */
	    Path.prototype.isEmpty = function () {
	        return this.pieceNum_ >= this.pieces_.length;
	    };
	    /**
	     * @param {!Path} outerPath
	     * @param {!Path} innerPath
	     * @return {!Path} The path from outerPath to innerPath
	     */
	    Path.relativePath = function (outerPath, innerPath) {
	        var outer = outerPath.getFront(), inner = innerPath.getFront();
	        if (outer === null) {
	            return innerPath;
	        }
	        else if (outer === inner) {
	            return Path.relativePath(outerPath.popFront(), innerPath.popFront());
	        }
	        else {
	            throw new Error('INTERNAL ERROR: innerPath (' +
	                innerPath +
	                ') is not within ' +
	                'outerPath (' +
	                outerPath +
	                ')');
	        }
	    };
	    /**
	     * @param {!Path} left
	     * @param {!Path} right
	     * @return {number} -1, 0, 1 if left is less, equal, or greater than the right.
	     */
	    Path.comparePaths = function (left, right) {
	        var leftKeys = left.slice();
	        var rightKeys = right.slice();
	        for (var i = 0; i < leftKeys.length && i < rightKeys.length; i++) {
	            var cmp = util_1.nameCompare(leftKeys[i], rightKeys[i]);
	            if (cmp !== 0)
	                return cmp;
	        }
	        if (leftKeys.length === rightKeys.length)
	            return 0;
	        return leftKeys.length < rightKeys.length ? -1 : 1;
	    };
	    /**
	     *
	     * @param {Path} other
	     * @return {boolean} true if paths are the same.
	     */
	    Path.prototype.equals = function (other) {
	        if (this.getLength() !== other.getLength()) {
	            return false;
	        }
	        for (var i = this.pieceNum_, j = other.pieceNum_; i <= this.pieces_.length; i++, j++) {
	            if (this.pieces_[i] !== other.pieces_[j]) {
	                return false;
	            }
	        }
	        return true;
	    };
	    /**
	     *
	     * @param {!Path} other
	     * @return {boolean} True if this path is a parent (or the same as) other
	     */
	    Path.prototype.contains = function (other) {
	        var i = this.pieceNum_;
	        var j = other.pieceNum_;
	        if (this.getLength() > other.getLength()) {
	            return false;
	        }
	        while (i < this.pieces_.length) {
	            if (this.pieces_[i] !== other.pieces_[j]) {
	                return false;
	            }
	            ++i;
	            ++j;
	        }
	        return true;
	    };
	    return Path;
	}()); // end Path
	exports.Path = Path;
	/**
	 * Dynamic (mutable) path used to count path lengths.
	 *
	 * This class is used to efficiently check paths for valid
	 * length (in UTF8 bytes) and depth (used in path validation).
	 *
	 * Throws Error exception if path is ever invalid.
	 *
	 * The definition of a path always begins with '/'.
	 */
	var ValidationPath = /** @class */ (function () {
	    /**
	     * @param {!Path} path Initial Path.
	     * @param {string} errorPrefix_ Prefix for any error messages.
	     */
	    function ValidationPath(path, errorPrefix_) {
	        this.errorPrefix_ = errorPrefix_;
	        /** @type {!Array<string>} */
	        this.parts_ = path.slice();
	        /** @type {number} Initialize to number of '/' chars needed in path. */
	        this.byteLength_ = Math.max(1, this.parts_.length);
	        for (var i = 0; i < this.parts_.length; i++) {
	            this.byteLength_ += util_2.stringLength(this.parts_[i]);
	        }
	        this.checkValid_();
	    }
	    Object.defineProperty(ValidationPath, "MAX_PATH_DEPTH", {
	        /** @const {number} Maximum key depth. */
	        get: function () {
	            return 32;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ValidationPath, "MAX_PATH_LENGTH_BYTES", {
	        /** @const {number} Maximum number of (UTF8) bytes in a Firebase path. */
	        get: function () {
	            return 768;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @param {string} child */
	    ValidationPath.prototype.push = function (child) {
	        // Count the needed '/'
	        if (this.parts_.length > 0) {
	            this.byteLength_ += 1;
	        }
	        this.parts_.push(child);
	        this.byteLength_ += util_2.stringLength(child);
	        this.checkValid_();
	    };
	    ValidationPath.prototype.pop = function () {
	        var last = this.parts_.pop();
	        this.byteLength_ -= util_2.stringLength(last);
	        // Un-count the previous '/'
	        if (this.parts_.length > 0) {
	            this.byteLength_ -= 1;
	        }
	    };
	    ValidationPath.prototype.checkValid_ = function () {
	        if (this.byteLength_ > ValidationPath.MAX_PATH_LENGTH_BYTES) {
	            throw new Error(this.errorPrefix_ +
	                'has a key path longer than ' +
	                ValidationPath.MAX_PATH_LENGTH_BYTES +
	                ' bytes (' +
	                this.byteLength_ +
	                ').');
	        }
	        if (this.parts_.length > ValidationPath.MAX_PATH_DEPTH) {
	            throw new Error(this.errorPrefix_ +
	                'path specified exceeds the maximum depth that can be written (' +
	                ValidationPath.MAX_PATH_DEPTH +
	                ') or object contains a cycle ' +
	                this.toErrorString());
	        }
	    };
	    /**
	     * String for use in error messages - uses '.' notation for path.
	     *
	     * @return {string}
	     */
	    ValidationPath.prototype.toErrorString = function () {
	        if (this.parts_.length == 0) {
	            return '';
	        }
	        return "in property '" + this.parts_.join('.') + "'";
	    };
	    return ValidationPath;
	}());
	exports.ValidationPath = ValidationPath;
	
	//# sourceMappingURL=Path.js.map


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var DOMProperty = __webpack_require__(62);
	var ReactDOMComponentFlags = __webpack_require__(370);
	
	var invariant = __webpack_require__(11);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 19 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// TODO(mcg): Change to a string enum once we've upgraded to typescript 2.4.
	//  tslint:disable-next-line:variable-name Intended to look like a TS 2.4 enum
	exports.Code = {
	    // Causes are copied from:
	    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
	    /** Not an error; returned on success. */
	    OK: 'ok',
	    /** The operation was cancelled (typically by the caller). */
	    CANCELLED: 'cancelled',
	    /** Unknown error or an error from a different error domain. */
	    UNKNOWN: 'unknown',
	    /**
	     * Client specified an invalid argument. Note that this differs from
	     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
	     * problematic regardless of the state of the system (e.g., a malformed file
	     * name).
	     */
	    INVALID_ARGUMENT: 'invalid-argument',
	    /**
	     * Deadline expired before operation could complete. For operations that
	     * change the state of the system, this error may be returned even if the
	     * operation has completed successfully. For example, a successful response
	     * from a server could have been delayed long enough for the deadline to
	     * expire.
	     */
	    DEADLINE_EXCEEDED: 'deadline-exceeded',
	    /** Some requested entity (e.g., file or directory) was not found. */
	    NOT_FOUND: 'not-found',
	    /**
	     * Some entity that we attempted to create (e.g., file or directory) already
	     * exists.
	     */
	    ALREADY_EXISTS: 'already-exists',
	    /**
	     * The caller does not have permission to execute the specified operation.
	     * PERMISSION_DENIED must not be used for rejections caused by exhausting
	     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
	     * PERMISSION_DENIED must not be used if the caller can not be identified
	     * (use UNAUTHENTICATED instead for those errors).
	     */
	    PERMISSION_DENIED: 'permission-denied',
	    /**
	     * The request does not have valid authentication credentials for the
	     * operation.
	     */
	    UNAUTHENTICATED: 'unauthenticated',
	    /**
	     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
	     * entire file system is out of space.
	     */
	    RESOURCE_EXHAUSTED: 'resource-exhausted',
	    /**
	     * Operation was rejected because the system is not in a state required for
	     * the operation's execution. For example, directory to be deleted may be
	     * non-empty, an rmdir operation is applied to a non-directory, etc.
	     *
	     * A litmus test that may help a service implementor in deciding
	     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
	     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
	     *  (b) Use ABORTED if the client should retry at a higher-level
	     *      (e.g., restarting a read-modify-write sequence).
	     *  (c) Use FAILED_PRECONDITION if the client should not retry until
	     *      the system state has been explicitly fixed. E.g., if an "rmdir"
	     *      fails because the directory is non-empty, FAILED_PRECONDITION
	     *      should be returned since the client should not retry unless
	     *      they have first fixed up the directory by deleting files from it.
	     *  (d) Use FAILED_PRECONDITION if the client performs conditional
	     *      REST Get/Update/Delete on a resource and the resource on the
	     *      server does not match the condition. E.g., conflicting
	     *      read-modify-write on the same resource.
	     */
	    FAILED_PRECONDITION: 'failed-precondition',
	    /**
	     * The operation was aborted, typically due to a concurrency issue like
	     * sequencer check failures, transaction aborts, etc.
	     *
	     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
	     * and UNAVAILABLE.
	     */
	    ABORTED: 'aborted',
	    /**
	     * Operation was attempted past the valid range. E.g., seeking or reading
	     * past end of file.
	     *
	     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
	     * if the system state changes. For example, a 32-bit file system will
	     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
	     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
	     * an offset past the current file size.
	     *
	     * There is a fair bit of overlap between FAILED_PRECONDITION and
	     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
	     * when it applies so that callers who are iterating through a space can
	     * easily look for an OUT_OF_RANGE error to detect when they are done.
	     */
	    OUT_OF_RANGE: 'out-of-range',
	    /** Operation is not implemented or not supported/enabled in this service. */
	    UNIMPLEMENTED: 'unimplemented',
	    /**
	     * Internal errors. Means some invariants expected by underlying System has
	     * been broken. If you see one of these errors, Something is very broken.
	     */
	    INTERNAL: 'internal',
	    /**
	     * The service is currently unavailable. This is a most likely a transient
	     * condition and may be corrected by retrying with a backoff.
	     *
	     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
	     * and UNAVAILABLE.
	     */
	    UNAVAILABLE: 'unavailable',
	    /** Unrecoverable data loss or corruption. */
	    DATA_LOSS: 'data-loss'
	};
	/**
	 * An error class used for Firestore-generated errors. Ideally we should be
	 * using FirebaseError, but integrating with it is overly arduous at the moment,
	 * so we define our own compatible error class (with a `name` of 'FirebaseError'
	 * and compatible `code` and `message` fields.)
	 */
	var FirestoreError = /** @class */ (function (_super) {
	    __extends(FirestoreError, _super);
	    function FirestoreError(code, message) {
	        var _this = _super.call(this, message) || this;
	        _this.code = code;
	        _this.message = message;
	        _this.name = 'FirebaseError';
	        // HACK: We write a toString property directly because Error is not a real
	        // class and so inheritance does not work correctly. We could alternatively
	        // do the same "back-door inheritance" trick that FirebaseError does.
	        _this.toString = function () { return _this.name + ": [code=" + _this.code + "]: " + _this.message; };
	        return _this;
	    }
	    return FirestoreError;
	}(Error));
	exports.FirestoreError = FirestoreError;
	
	//# sourceMappingURL=error.js.map


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var sorted_map_1 = __webpack_require__(50);
	var sorted_set_1 = __webpack_require__(97);
	var document_key_1 = __webpack_require__(22);
	var EMPTY_MAYBE_DOCUMENT_MAP = new sorted_map_1.SortedMap(document_key_1.DocumentKey.comparator);
	function maybeDocumentMap() {
	    return EMPTY_MAYBE_DOCUMENT_MAP;
	}
	exports.maybeDocumentMap = maybeDocumentMap;
	var EMPTY_DOCUMENT_MAP = new sorted_map_1.SortedMap(document_key_1.DocumentKey.comparator);
	function documentMap() {
	    return EMPTY_DOCUMENT_MAP;
	}
	exports.documentMap = documentMap;
	var EMPTY_DOCUMENT_VERSION_MAP = new sorted_map_1.SortedMap(document_key_1.DocumentKey.comparator);
	function documentVersionMap() {
	    return EMPTY_DOCUMENT_VERSION_MAP;
	}
	exports.documentVersionMap = documentVersionMap;
	var EMPTY_DOCUMENT_KEY_SET = new sorted_set_1.SortedSet(document_key_1.DocumentKey.comparator);
	function documentKeySet() {
	    return EMPTY_DOCUMENT_KEY_SET;
	}
	exports.documentKeySet = documentKeySet;
	
	//# sourceMappingURL=collections.js.map


/***/ },
/* 21 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(10);
	var path_1 = __webpack_require__(49);
	var DocumentKey = /** @class */ (function () {
	    function DocumentKey(path) {
	        this.path = path;
	        assert_1.assert(DocumentKey.isDocumentKey(path), 'Invalid DocumentKey with an odd number of segments: ' +
	            path.toArray().join('/'));
	    }
	    DocumentKey.prototype.equals = function (other) {
	        return (other !== null && path_1.ResourcePath.comparator(this.path, other.path) === 0);
	    };
	    DocumentKey.prototype.toString = function () {
	        return this.path.toString();
	    };
	    DocumentKey.comparator = function (k1, k2) {
	        return path_1.ResourcePath.comparator(k1.path, k2.path);
	    };
	    DocumentKey.isDocumentKey = function (path) {
	        return path.length % 2 === 0;
	    };
	    /**
	     * Creates and returns a new document key with the given segments.
	     *
	     * @param path The segments of the path to the document
	     * @return A new instance of DocumentKey
	     */
	    DocumentKey.fromSegments = function (segments) {
	        return new DocumentKey(new path_1.ResourcePath(segments.slice()));
	    };
	    /**
	     * Creates and returns a new document key using '/' to split the string into
	     * segments.
	     *
	     * @param path The slash-separated path string to the document
	     * @return A new instance of DocumentKey
	     */
	    DocumentKey.fromPathString = function (path) {
	        return new DocumentKey(path_1.ResourcePath.fromString(path));
	    };
	    DocumentKey.EMPTY = new DocumentKey(new path_1.ResourcePath([]));
	    return DocumentKey;
	}());
	exports.DocumentKey = DocumentKey;
	
	//# sourceMappingURL=document_key.js.map


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	*  filename: ej2-base.umd.min.js
	*  version : 19.4.52
	*  Copyright Syncfusion Inc. 2001 - 2020. All rights reserved.
	*  Use of this code is subject to the terms of our license.
	*  A copy of the current license can be obtained at any time by e-mailing
	*  licensing@syncfusion.com. Any infringement will be prosecuted under
	*  applicable laws. 
	*/
	!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.ej={})}(this,function(e){"use strict";function t(e,t){var r=t;return r.unshift(void 0),new(Function.prototype.bind.apply(e,r))}function r(e){var t,r=new Uint16Array(5);(window.msCrypto||window.crypto).getRandomValues(r);var n="ej2"+function(e){for(var t="",r=0;r<5;r++)t+=(r?",":"")+e[r];return t}(r),i=function(r){r.source===window&&"string"==typeof r.data&&r.data.length<=32&&r.data===n&&(e(),t())};return window.addEventListener("message",i,!1),window.postMessage(n,"*"),t=function(){window.removeEventListener("message",i),e=i=n=void 0}}function n(e,t){for(var r=t,n=e.replace(/\[/g,".").replace(/\]/g,"").split("."),i=0;i<n.length&&!u(r);i++)r=r[n[i]];return r}function i(e,t,r){var n,i,o=e.replace(/\[/g,".").replace(/\]/g,"").split("."),a=r||{},s=a,c=o.length;for(n=0;n<c;n++)i=o[n],n+1===c?s[i]=void 0===t?{}:t:l(s[i])&&(s[i]={}),s=s[i];return a}function o(e,t){delete e[t]}function a(e){return!l(e)&&e.constructor==={}.constructor}function s(e,t){if(!l(t))for(var r=e,n=t,i=0,o=Object.keys(t);i<o.length;i++){var s=o[i];l(r.deepMerge)||-1===r.deepMerge.indexOf(s)||!a(n[s])&&!Array.isArray(n[s])?r[s]=n[s]:c(r[s],r[s],n[s],!0)}}function c(e,t,r,n){var i=e&&"object"==typeof e?e:{},o=arguments.length;n&&(o-=1);for(var s=function(e){if(!l[e])return"continue";var t=l[e];Object.keys(t).forEach(function(e){var r,o=i[e],s=t[e],l=Array.isArray(s)&&Array.isArray(o)&&s.length!==o.length,u=!m()||!(o instanceof Event||l);n&&u&&(a(s)||Array.isArray(s))?a(s)?(r=o||{},Array.isArray(r)&&r.hasOwnProperty("isComplexArray")?c(r,{},s,n):i[e]=c(r,{},s,n)):(r=m()?o&&Object.keys(s).length:o||[],i[e]=c([],r,s,n)):i[e]=s})},l=arguments,u=1;u<o;u++)s(u);return i}function l(e){return void 0===e||null===e}function u(e){return void 0===e}function p(e,t){var r;return function(){var n=this,i=arguments;clearTimeout(r),r=setTimeout(function(){return r=null,e.apply(n,i)},t)}}function h(e,t){var r=e;return r===t||!(r===document||!r)&&h(r.parentNode,t)}function d(e){try{throw new Error(e)}catch(e){throw e.message+"\n"+e.stack}}function m(){return te}function f(){if("undefined"!=typeof window){var e=new Uint16Array(5);return(window.msCrypto||window.crypto).getRandomValues(e)}}function g(e,t){var r=ze.test(e)?document.createElementNS("http://www.w3.org/2000/svg",e):document.createElement(e);return void 0===t?r:(r.innerHTML=t.innerHTML?t.innerHTML:"",void 0!==t.className&&(r.className=t.className),void 0!==t.id&&(r.id=t.id),void 0!==t.styles&&r.setAttribute("style",t.styles),void 0!==t.attrs&&E(r,t.attrs),r)}function y(e,t){for(var r=b(t),o=0,s=e;o<s.length;o++)for(var c=s[o],u=0,p=r;u<p.length;u++){var h=p[u];if(a(c)){var d=n("attributes.className",c);l(d)?i("attributes.className",h,c):new RegExp("\\b"+h+"\\b","i").test(d)||i("attributes.className",d+" "+h,c)}else c.classList.contains(h)||c.classList.add(h)}return e}function v(e,t){for(var r=b(t),o=0,s=e;o<s.length;o++){var c=s[o],l=a(c);if(l?n("attributes.className",c):""!==c.className)for(var u=0,p=r;u<p.length;u++){var h=p[u];if(l){var d=n("attributes.className",c).split(" "),m=d.indexOf(h);-1!==m&&d.splice(m,1),i("attributes.className",d.join(" "),c)}else c.classList.remove(h)}}return e}function b(e){var t=[];return"string"==typeof e?t.push(e):t=e,t}function M(e){var t=e;return""===t.style.visibility&&t.offsetWidth>0}function D(e){e.querySelectorAll("script").forEach(function(e){var t=document.createElement("script");t.text=e.innerHTML,document.head.appendChild(t),w(t)})}function w(e){var t=e.parentNode;if(t)return t.removeChild(e)}function E(e,t){for(var r=e,n=0,i=Object.keys(t);n<i.length;n++){var o=i[n];if(a(r)){var s=o;"tabindex"===o&&(s="tabIndex"),r.attributes[s]=t[o]}else r.setAttribute(o,t[o])}return r}function P(e,t,r){return void 0===t&&(t=document),e=O(e),t.querySelector(e)}function S(e,t,r){void 0===t&&(t=document),e=O(e);return t.querySelectorAll(e)}function O(e){var t=/(!|"|\$|%|&|'|\(|\)|\*|\/|:|;|<|=|\?|@|\]|\^|`|{|}|\||\+|~)/g;if(e.match(/#[0-9]/g)||e.match(t)){for(var r=e.split(","),n=0;n<r.length;n++){for(var i=r[n].split(" "),o=0;o<i.length;o++)if(i[o].indexOf("#")>-1&&!i[o].match(/\[.*\]/)){var a=i[o].split("#");if(a[1].match(/^\d/)||a[1].match(t)){var s=i[o].split(".");s[0]=s[0].replace(/#/,"[id='")+"']",i[o]=s.join(".")}}r[n]=i.join(" ")}return r.join(",")}return e}function C(e,t){var r=e;if("function"==typeof r.closest)return r.closest(t);for(;r&&1===r.nodeType;){if(x(r,t))return r;r=r.parentNode}return null}function T(e,t){void 0!==t&&Object.keys(t).forEach(function(r){e.style[r]=t[r]})}function x(e,t){var r=e.matches||e.msMatchesSelector||e.webkitMatchesSelector;return r?r.call(e,t):-1!==[].indexOf.call(document.querySelectorAll(t),e)}function j(e,t){var r,n,i="string"==typeof e?document.getElementById(e):e;for(n=0;n<i.ej2_instances.length;n++)if(r=i.ej2_instances[n],"string"==typeof t){if(t===r.getModuleName())return r}else if(r instanceof t)return r}function N(e,r,n,i){return e.properties.hasOwnProperty(r)&&e.properties[r]instanceof i||(e.properties[r]=t(i,[e,r,n])),e.properties[r]}function F(e,r,n,i,o,a){for(var s=[],c=n?n.length:0,l=0;l<c;l++){var u=i;if(a&&(u=i(n[l],e)),o){var p=t(u,[e,r,{},!0]);p.setProperties(n[l],!0),s.push(p)}else s.push(t(u,[e,r,n[l],!1]))}return s}function R(e,t){return function(){return this.properties.hasOwnProperty(t)||(this.properties[t]=e),this.properties[t]}}function A(e,t,r){return function(){var n=this;if(!this.properties.hasOwnProperty(t)){var i=F(this,t,e,r,!1);this.properties[t]=i}var o=void 0!==this.controlParent&&this.controlParent.ignoreCollectionWatch||this.ignoreCollectionWatch;return this.properties[t].hasOwnProperty("push")||o||["push","pop"].forEach(function(e){var r={value:function(e,t,r,n){return function(){for(var r=[],i=0;i<arguments.length;i++)r[i]=arguments[i];var o=this.propName?this.getParentKey()+"."+t+"-":t+"-";switch(e){case"push":for(var a=0;a<r.length;a++){Array.prototype[e].apply(n,[r[a]]);var s=I(o+(n.length-1),r[a],!this.controlParent,e);this.serverDataBind(s,r[a],!1,e)}break;case"pop":Array.prototype[e].apply(n);var c=I(o+n.length,null,!this.controlParent,e);this.serverDataBind(c,{ejsAction:"pop"},!1,e)}return n}}(e,t,0,n.properties[t]).bind(n),configurable:!0};Object.defineProperty(n.properties[t],e,r)}),this.properties[t].hasOwnProperty("isComplexArray")||Object.defineProperty(this.properties[t],"isComplexArray",{value:!0}),this.properties[t]}}function I(e,t,r,n){var i=e;if(r&&(i={},i[e]=t,t&&"object"==typeof t)){i[e].ejsAction=n}return i}function k(e){return function(t,r){var n={set:function(e,t){return function(r){if(this.properties[t]!==r){var n=this.properties.hasOwnProperty(t)?this.properties[t]:e;this.saveChanges(t,r,n),this.properties[t]=r}}}(e,r),get:R(e,r),enumerable:!0,configurable:!0};Object.defineProperty(t,r,n),G(t,r,"prop",e)}}function H(e,t){return function(r,n){var i={set:function(e,t,r){return function(n){N(this,t,e,r).setProperties(n)}}(e,n,t),get:function(e,t,r){return function(){return N(this,t,e,r)}}(e,n,t),enumerable:!0,configurable:!0};Object.defineProperty(r,n,i),G(r,n,"complexProp",e,t)}}function L(){return function(e,t){var r={set:function(e){var r=this.properties[t];if(r!==e){var n=z(this,t);!1===u(r)&&n.context.removeEventListener(n.prefix,r),n.context.addEventListener(n.prefix,e),this.properties[t]=e}},get:R(void 0,t),enumerable:!0,configurable:!0};Object.defineProperty(e,t,r),G(e,t,"event")}}function B(e){}function G(e,t,r,n,i){u(e.propList)&&(e.propList={props:[],complexProps:[],colProps:[],events:[],propNames:[],complexPropNames:[],colPropNames:[],eventNames:[]}),e.propList[r+"s"].push({propertyName:t,defaultValue:n,type:i}),e.propList[r+"Names"].push(t)}function Y(e){if(u(e.prototype.builderObject)){e.prototype.builderObject={properties:{},propCollections:[],add:function(){this.isPropertyArray=!0,this.propCollections.push(c({},this.properties,{}))}};for(var t=/complex/,r=0,n=Object.keys(e.prototype.propList);r<n.length;r++)for(var i=n[r],o=function(r){t.test(i)?e.prototype.builderObject[r.propertyName]=function(e){var t={};s(t,Y(r.type)),e(t);var n;return n=t.isPropertyArray?t.propCollections:c({},t.properties,{}),this.properties[r.propertyName]=n,t.properties={},t.propCollections=[],t.isPropertyArray=!1,this}:e.prototype.builderObject[r.propertyName]=function(e){return this.properties[r.propertyName]=e,this}},a=0,l=e.prototype.propList[i];a<l.length;a++){o(l[a])}}return e.prototype.builderObject}function z(e,t){if(!1===e.hasOwnProperty("parentObj"))return{context:e,prefix:t};var r=n("propName",e);return r&&(t=r+"-"+t),z(n("parentObj",e),t)}function X(e){var t=e.target,r=this.rippleOptions.selector,n=r?C(t,r):t;if(!(!n||this.rippleOptions&&C(t,this.rippleOptions.ignore))){var i=n.getBoundingClientRect(),o=e.pageX-document.body.scrollLeft,a=e.pageY-(!document.body.scrollTop&&document.documentElement?document.documentElement.scrollTop:document.body.scrollTop),s=Math.max(Math.abs(o-i.left),Math.abs(o-i.right)),c=Math.max(Math.abs(a-i.top),Math.abs(a-i.bottom)),l=Math.sqrt(s*s+c*c),u=2*l+"px",p=o-i.left-l,h=a-i.top-l;this.rippleOptions&&this.rippleOptions.isCenterRipple&&(p=0,h=0,u="100%"),n.classList.add("e-ripple");var d=g("div",{className:"e-ripple-element",styles:"width: "+u+";height: "+u+";left: "+p+"px;top: "+h+"px;transition-duration: "+this.rippleOptions.duration.toString()+"ms;"});n.appendChild(d),window.getComputedStyle(d).getPropertyValue("opacity"),d.style.transform="scale(1)",n!==this.parent&&Ye.add(n,"mouseleave",W,{parent:this.parent,rippleOptions:this.rippleOptions})}}function _(e){$(e,this)}function W(e){$(e,this)}function $(e,t){var r=t.rippleOptions.duration,n=e.target,i=t.rippleOptions.selector,o=i?C(n,i):n;if(o&&(!o||-1!==o.className.indexOf("e-ripple"))){var a=S(".e-ripple-element",o),s=a[a.length-1];s&&(s.style.opacity="0.5"),t.parent!==o&&Ye.remove(o,"mouseleave",W),setTimeout(function(){s&&s.parentNode&&s.parentNode.removeChild(s),o.getElementsByClassName("e-ripple-element").length||o.classList.remove("e-ripple"),t.done&&t.done(e)},r)}}function V(e,t,r){var n='var str="'+function(e,t,r,n){var i=0,o=[],a=e.match(/class="([^"]+|)\s{2}/g),s="";a&&a.forEach(function(t){s=t.replace(/\s\s+/g," "),e=e.replace(t,s)});return e.replace(Dt,"").replace(Nt,"'$1'").replace(Rt,function(e,a,s,c){var l=a.match(Tt);if(l){var u=l[1];if(Pt.test(a))a='";} '+a.replace(l[1],u.replace(jt,function(e){return e=e.trim(),U(e,!wt.test(e)&&-1===o.indexOf(e),t,o,n)}))+'{ \n str = str + "';else if(Et.test(a))a='"; '+a.replace(l[1],u.replace(Ft,function(e){return Z(e,t,o,n)}))+'{ \n str = str + "';else if(Ot.test(a)){var p=l[1].split(" of ");a='"; '+a.replace(l[1],function(e){return o.push(p[0]),o.push(p[0]+"Index"),"var i"+(i+=1)+"=0; i"+i+" < "+U(p[1],!0,t,o,n)+".length; i"+i+"++"})+"{ \n "+p[0]+"= "+U(p[1],!0,t,o,n)+"[i"+i+"]; \n var "+p[0]+"Index=i"+i+'; \n str = str + "'}else{var h=a.split("("),d=r&&r.hasOwnProperty(h[0])?"this.":"global";d=/\./.test(h[0])?"":d;var m=l[1].split(",");0===l[1].length||/data/.test(m[0])||/window./.test(m[0])||(l[1]="global"===d?t+"."+l[1]:l[1]);if(Lt.test(a)&&/\]\./gm.test(a)||/@|\$|#/gm.test(a)){/@|\$|#|\]\./gm.test(a)&&(a='"+ '+("global"===d?"":d)+a.replace(l[1],u.replace(Ht,function(e){return Z(e,t,o,n)}))+'+ "')}else a='" + '+("global"===d?"":d)+a.replace(u,U(l[1].replace(/,( |)data.|,/gi,","+t+".").replace(/,( |)data.window/gi,",window"),"global"!==d,t,o,n))+'+"'}}else St.test(a)?a='"; '+a.replace(St,'} else { \n str = str + "'):a.match(Ct)?a=a.replace(Ct,'"; \n } \n str = str + "'):/@|#|\$/gm.test(a)?(a.match(It)&&(a=q(a)),a='"+'+K(a,-1===o.indexOf(a),t,o)+'"]+"'):a=a.match(It)?'"+'+K(a=q(a),-1===o.indexOf(a),t,o)+'"]+"':'"+'+U(a.replace(/,/gi,"+"+t+"."),-1===o.indexOf(a),t,o,n)+'+"';return a})}(e,"data",t,r)+"\";var valueRegEx = (/value=\\'([A-Za-z0-9 _]*)((.)([\\w)(!-;?-■\\s]+)['])/g);\n    var hrefRegex = (/(?:href)([\\s='\"./]+)([\\w-./?=&\\\\#\"]+)((.)([\\w)(!-;/?-■\\s]+)['])/g);\n    if((str.match(valueRegEx)) && (str.match('svg') === null)){\n        var check = str.match(valueRegEx);\n        var str1 = str;\n        for (var i=0; i < check.length; i++) {\n            var check1 = str.match(valueRegEx)[i].split('value=')[1];\n            var change = check1.match(/^'/) !== null ? check1.replace(/^'/, '\"') : check1;\n            change =change.match(/.$/)[0] === '\\'' ? change.replace(/.$/,'\"') : change;\n            str1 = str1.replace(check1, change);\n        }\n        str = str.replace(str, str1);\n    }\n    else if (str.match(/(?:href='')/) === null) {\n        if((str.match(hrefRegex)) && (str.match('svg') === null)) {\n            var check = str.match(hrefRegex);\n            var str1 = str;\n            for (var i=0; i < check.length; i++) {\n                var check1 = str.match(hrefRegex)[i].split('href=')[1];\n                var change = check1.match(/^'/) !== null ? check1.replace(/^'/, '\"') : check1;\n                change =change.match(/.$/)[0] === '\\'' ? change.replace(/.$/,'\"') : change;\n                str1 = str1.replace(check1, change);\n            }\n            str = str.replace(str, str1);\n        }\n    }\n     return str;";return new Function("data",n).bind(t)}function U(e,t,r,n,i){return!t||xt.test(e)||-1!==n.indexOf(e.split(".")[0])||i?e:r+"."+e}function K(e,t,r,n){return t&&!xt.test(e)&&-1===n.indexOf(e.split(".")[0])?r+'["'+e:e}function q(e){return e=e.match(kt)?e:e.replace(It,"\\\\")}function Z(e,t,r,n){e=e.trim();if(/\window\./gm.test(e))return e;var i=/'|"/gm;return/@|\$|#/gm.test(e)&&(e=K(e,-1===r.indexOf(e),t,r)+'"]'),At.test(e)?function(e,t,r,n){return!t||xt.test(e)||-1!==n.indexOf(e.split(".")[0])||/^\..*/gm.test(e)?e:r+"."+e}(e,!i.test(e)&&-1===r.indexOf(e),t,r):U(e,!i.test(e)&&-1===r.indexOf(e),t,r,n)}function J(){return"-"+Math.random().toString(36).substr(2,5)}var Q="ej2_instances",ee=0,te=!1,re={latn:{_digits:"0123456789",_type:"numeric"}},ne={decimal:".",group:",",percentSign:"%",plusSign:"+",minusSign:"-",infinity:"∞",nan:"NaN",exponential:"E"},ie=[0,1,2,3,4,5,6,7,8,9],oe=function(){function e(){}return e.getMainObject=function(e,t){return n(m()?t:"main."+t,e)},e.getNumberingSystem=function(e){return n("supplemental.numberingSystems",e)||this.numberingSystems},e.reverseObject=function(e,t){for(var r={},n=0,i=t||Object.keys(e);n<i.length;n++){var o=i[n];r.hasOwnProperty(e[o])||(r[e[o]]=o)}return r},e.getSymbolRegex=function(e){var t=e.map(function(e){return e.replace(/([.*+?^=!:${}()|[\]/\\])/g,"\\$1")}).join("|");return new RegExp(t,"g")},e.getSymbolMatch=function(e){for(var t={},r=0,n=Object.keys(ne);r<n.length;r++){var i=n[r];t[e[i]]=ne[i]}return t},e.constructRegex=function(e){for(var t=e.length,r="",n=0;n<t;n++)r+=n!==t-1?e[n]+"|":e[n];return r},e.convertValueParts=function(e,t,r){return e.replace(t,function(e){return r[e]})},e.getDefaultNumberingSystem=function(e){var t={};return t.obj=n("numbers",e),t.nSystem=n("defaultNumberingSystem",t.obj),t},e.getCurrentNumericOptions=function(e,t,r,i){var o={},a=this.getDefaultNumberingSystem(e);if(!u(a.nSystem)||i){var s=i?n("obj.mapperDigits",a):n(a.nSystem+"._digits",t);u(s)||(o.numericPair=this.reverseObject(s,ie),o.numberParseRegex=new RegExp(this.constructRegex(s),"g"),o.numericRegex="["+s[0]+"-"+s[9]+"]",r&&(o.numericRegex=s[0]+"-"+s[9],o.symbolNumberSystem=n(i?"numberSymbols":"symbols-numberSystem-"+a.nSystem,a.obj),o.symbolMatch=this.getSymbolMatch(o.symbolNumberSystem),o.numberSystem=a.nSystem))}return o},e.getNumberMapper=function(e,t,r){var i={mapper:{}},o=this.getDefaultNumberingSystem(e);if(!u(o.nSystem)){i.numberSystem=o.nSystem,i.numberSymbols=n("symbols-numberSystem-"+o.nSystem,o.obj),i.timeSeparator=n("timeSeparator",i.numberSymbols);var a=n(o.nSystem+"._digits",t);if(!u(a))for(var s=0,c=ie;s<c.length;s++){var l=c[s];i.mapper[l]=a[l]}}return i},e.nPair="numericPair",e.nRegex="numericRegex",e.numberingSystems=re,e}(),ae={DJF:"Fdj",ERN:"Nfk",ETB:"Br",NAD:"$",ZAR:"R",XAF:"FCFA",GHS:"GH₵",XDR:"XDR",AED:"د.إ.‏",BHD:"د.ب.‏",DZD:"د.ج.‏",EGP:"ج.م.‏",ILS:"₪",IQD:"د.ع.‏",JOD:"د.ا.‏",KMF:"CF",KWD:"د.ك.‏",LBP:"ل.ل.‏",LYD:"د.ل.‏",MAD:"د.م.‏",MRU:"أ.م.",OMR:"ر.ع.‏",QAR:"ر.ق.‏",SAR:"ر.س.‏",SDG:"ج.س.",SOS:"S",SSP:"£",SYP:"ل.س.‏",TND:"د.ت.‏",YER:"ر.ي.‏",CLP:"$",INR:"₹",TZS:"TSh",EUR:"€",AZN:"₼",RUB:"₽",BYN:"Br",ZMW:"K",BGN:"лв.",NGN:"₦",XOF:"CFA",BDT:"৳",CNY:"¥",BAM:"КМ",UGX:"USh",USD:"$",CZK:"Kč",GBP:"£",DKK:"kr.",KES:"Ksh",CHF:"CHF",MVR:"ރ.",BTN:"Nu.",XCD:"EC$",AUD:"$",BBD:"$",BIF:"FBu",BMD:"$",BSD:"$",BWP:"P",BZD:"$",CAD:"$",NZD:"$",FJD:"$",FKP:"£",GIP:"£",GMD:"D",GYD:"$",HKD:"$",IDR:"Rp",JMD:"$",KYD:"$",LRD:"$",MGA:"Ar",MOP:"MOP$",MUR:"Rs",MWK:"MK",MYR:"RM",PGK:"K",PHP:"₱",PKR:"Rs",RWF:"RF",SBD:"$",SCR:"SR",SEK:"kr",SGD:"$",SHP:"£",SLL:"Le",ANG:"NAf.",SZL:"E",TOP:"T$",TTD:"$",VUV:"VT",WST:"WS$",ARS:"$",BOB:"Bs",BRL:"R$",COP:"$",CRC:"₡",CUP:"$",DOP:"$",GTQ:"Q",HNL:"L",MXN:"$",NIO:"C$",PAB:"B/.",PEN:"S/",PYG:"₲",UYU:"$",VES:"Bs.S",IRR:"ريال",GNF:"FG",CDF:"FC",HTG:"G",XPF:"FCFP",HRK:"kn",HUF:"Ft",AMD:"֏",ISK:"kr",JPY:"¥",GEL:"₾",CVE:"​",KZT:"₸",KHR:"៛",KPW:"₩",KRW:"₩",KGS:"сом",AOA:"Kz",LAK:"₭",MZN:"MTn",MKD:"ден",MNT:"₮",BND:"$",MMK:"K",NOK:"kr",NPR:"रु",AWG:"Afl.",SRD:"$",PLN:"zł",AFN:"؋",STN:"Db",MDL:"L",RON:"lei",UAH:"₴",LKR:"රු.",ALL:"Lekë",RSD:"дин.",TJS:"смн",THB:"฿",TMT:"m.",TRY:"₺",UZS:"сўм",VND:"₫",TWD:"NT$"};!function(e){var t=[28607,28636,28665,28695,28724,28754,28783,28813,28843,28872,28901,28931,28960,28990,29019,29049,29078,29108,29137,29167,29196,29226,29255,29285,29315,29345,29375,29404,29434,29463,29492,29522,29551,29580,29610,29640,29669,29699,29729,29759,29788,29818,29847,29876,29906,29935,29964,29994,30023,30053,30082,30112,30141,30171,30200,30230,30259,30289,30318,30348,30378,30408,30437,30467,30496,30526,30555,30585,30614,30644,30673,30703,30732,30762,30791,30821,30850,30880,30909,30939,30968,30998,31027,31057,31086,31116,31145,31175,31204,31234,31263,31293,31322,31352,31381,31411,31441,31471,31500,31530,31559,31589,31618,31648,31676,31706,31736,31766,31795,31825,31854,31884,31913,31943,31972,32002,32031,32061,32090,32120,32150,32180,32209,32239,32268,32298,32327,32357,32386,32416,32445,32475,32504,32534,32563,32593,32622,32652,32681,32711,32740,32770,32799,32829,32858,32888,32917,32947,32976,33006,33035,33065,33094,33124,33153,33183,33213,33243,33272,33302,33331,33361,33390,33420,33450,33479,33509,33539,33568,33598,33627,33657,33686,33716,33745,33775,33804,33834,33863,33893,33922,33952,33981,34011,34040,34069,34099,34128,34158,34187,34217,34247,34277,34306,34336,34365,34395,34424,34454,34483,34512,34542,34571,34601,34631,34660,34690,34719,34749,34778,34808,34837,34867,34896,34926,34955,34985,35015,35044,35074,35103,35133,35162,35192,35222,35251,35280,35310,35340,35370,35399,35429,35458,35488,35517,35547,35576,35605,35635,35665,35694,35723,35753,35782,35811,35841,35871,35901,35930,35960,35989,36019,36048,36078,36107,36136,36166,36195,36225,36254,36284,36314,36343,36373,36403,36433,36462,36492,36521,36551,36580,36610,36639,36669,36698,36728,36757,36786,36816,36845,36875,36904,36934,36963,36993,37022,37052,37081,37111,37141,37170,37200,37229,37259,37288,37318,37347,37377,37406,37436,37465,37495,37524,37554,37584,37613,37643,37672,37701,37731,37760,37790,37819,37849,37878,37908,37938,37967,37997,38027,38056,38085,38115,38144,38174,38203,38233,38262,38292,38322,38351,38381,38410,38440,38469,38499,38528,38558,38587,38617,38646,38676,38705,38735,38764,38794,38823,38853,38882,38912,38941,38971,39001,39030,39059,39089,39118,39148,39178,39208,39237,39267,39297,39326,39355,39385,39414,39444,39473,39503,39532,39562,39592,39621,39650,39680,39709,39739,39768,39798,39827,39857,39886,39916,39946,39975,40005,40035,40064,40094,40123,40153,40182,40212,40241,40271,40300,40330,40359,40389,40418,40448,40477,40507,40536,40566,40595,40625,40655,40685,40714,40744,40773,40803,40832,40862,40892,40921,40951,40980,41009,41039,41068,41098,41127,41157,41186,41216,41245,41275,41304,41334,41364,41393,41422,41452,41481,41511,41540,41570,41599,41629,41658,41688,41718,41748,41777,41807,41836,41865,41894,41924,41953,41983,42012,42042,42072,42102,42131,42161,42190,42220,42249,42279,42308,42337,42367,42397,42426,42456,42485,42515,42545,42574,42604,42633,42662,42692,42721,42751,42780,42810,42839,42869,42899,42929,42958,42988,43017,43046,43076,43105,43135,43164,43194,43223,43253,43283,43312,43342,43371,43401,43430,43460,43489,43519,43548,43578,43607,43637,43666,43696,43726,43755,43785,43814,43844,43873,43903,43932,43962,43991,44021,44050,44080,44109,44139,44169,44198,44228,44258,44287,44317,44346,44375,44405,44434,44464,44493,44523,44553,44582,44612,44641,44671,44700,44730,44759,44788,44818,44847,44877,44906,44936,44966,44996,45025,45055,45084,45114,45143,45172,45202,45231,45261,45290,45320,45350,45380,45409,45439,45468,45498,45527,45556,45586,45615,45644,45674,45704,45733,45763,45793,45823,45852,45882,45911,45940,45970,45999,46028,46058,46088,46117,46147,46177,46206,46236,46265,46295,46324,46354,46383,46413,46442,46472,46501,46531,46560,46590,46620,46649,46679,46708,46738,46767,46797,46826,46856,46885,46915,46944,46974,47003,47033,47063,47092,47122,47151,47181,47210,47240,47269,47298,47328,47357,47387,47417,47446,47476,47506,47535,47565,47594,47624,47653,47682,47712,47741,47771,47800,47830,47860,47890,47919,47949,47978,48008,48037,48066,48096,48125,48155,48184,48214,48244,48273,48303,48333,48362,48392,48421,48450,48480,48509,48538,48568,48598,48627,48657,48687,48717,48746,48776,48805,48834,48864,48893,48922,48952,48982,49011,49041,49071,49100,49130,49160,49189,49218,49248,49277,49306,49336,49365,49395,49425,49455,49484,49514,49543,49573,49602,49632,49661,49690,49720,49749,49779,49809,49838,49868,49898,49927,49957,49986,50016,50045,50075,50104,50133,50163,50192,50222,50252,50281,50311,50340,50370,50400,50429,50459,50488,50518,50547,50576,50606,50635,50665,50694,50724,50754,50784,50813,50843,50872,50902,50931,50960,50990,51019,51049,51078,51108,51138,51167,51197,51227,51256,51286,51315,51345,51374,51403,51433,51462,51492,51522,51552,51582,51611,51641,51670,51699,51729,51758,51787,51816,51846,51876,51906,51936,51965,51995,52025,52054,52083,52113,52142,52171,52200,52230,52260,52290,52319,52349,52379,52408,52438,52467,52497,52526,52555,52585,52614,52644,52673,52703,52733,52762,52792,52822,52851,52881,52910,52939,52969,52998,53028,53057,53087,53116,53146,53176,53205,53235,53264,53294,53324,53353,53383,53412,53441,53471,53500,53530,53559,53589,53619,53648,53678,53708,53737,53767,53796,53825,53855,53884,53913,53943,53973,54003,54032,54062,54092,54121,54151,54180,54209,54239,54268,54297,54327,54357,54387,54416,54446,54476,54505,54535,54564,54593,54623,54652,54681,54711,54741,54770,54800,54830,54859,54889,54919,54948,54977,55007,55036,55066,55095,55125,55154,55184,55213,55243,55273,55302,55332,55361,55391,55420,55450,55479,55508,55538,55567,55597,55627,55657,55686,55716,55745,55775,55804,55834,55863,55892,55922,55951,55981,56011,56040,56070,56100,56129,56159,56188,56218,56247,56276,56306,56335,56365,56394,56424,56454,56483,56513,56543,56572,56601,56631,56660,56690,56719,56749,56778,56808,56837,56867,56897,56926,56956,56985,57015,57044,57074,57103,57133,57162,57192,57221,57251,57280,57310,57340,57369,57399,57429,57458,57487,57517,57546,57576,57605,57634,57664,57694,57723,57753,57783,57813,57842,57871,57901,57930,57959,57989,58018,58048,58077,58107,58137,58167,58196,58226,58255,58285,58314,58343,58373,58402,58432,58461,58491,58521,58551,58580,58610,58639,58669,58698,58727,58757,58786,58816,58845,58875,58905,58934,58964,58994,59023,59053,59082,59111,59141,59170,59200,59229,59259,59288,59318,59348,59377,59407,59436,59466,59495,59525,59554,59584,59613,59643,59672,59702,59731,59761,59791,59820,59850,59879,59909,59939,59968,59997,60027,60056,60086,60115,60145,60174,60204,60234,60264,60293,60323,60352,60381,60411,60440,60469,60499,60528,60558,60588,60618,60648,60677,60707,60736,60765,60795,60824,60853,60883,60912,60942,60972,61002,61031,61061,61090,61120,61149,61179,61208,61237,61267,61296,61326,61356,61385,61415,61445,61474,61504,61533,61563,61592,61621,61651,61680,61710,61739,61769,61799,61828,61858,61888,61917,61947,61976,62006,62035,62064,62094,62123,62153,62182,62212,62242,62271,62301,62331,62360,62390,62419,62448,62478,62507,62537,62566,62596,62625,62655,62685,62715,62744,62774,62803,62832,62862,62891,62921,62950,62980,63009,63039,63069,63099,63128,63157,63187,63216,63246,63275,63305,63334,63363,63393,63423,63453,63482,63512,63541,63571,63600,63630,63659,63689,63718,63747,63777,63807,63836,63866,63895,63925,63955,63984,64014,64043,64073,64102,64131,64161,64190,64220,64249,64279,64309,64339,64368,64398,64427,64457,64486,64515,64545,64574,64603,64633,64663,64692,64722,64752,64782,64811,64841,64870,64899,64929,64958,64987,65017,65047,65076,65106,65136,65166,65195,65225,65254,65283,65313,65342,65371,65401,65431,65460,65490,65520,65549,65579,65608,65638,65667,65697,65726,65755,65785,65815,65844,65874,65903,65933,65963,65992,66022,66051,66081,66110,66140,66169,66199,66228,66258,66287,66317,66346,66376,66405,66435,66465,66494,66524,66553,66583,66612,66641,66671,66700,66730,66760,66789,66819,66849,66878,66908,66937,66967,66996,67025,67055,67084,67114,67143,67173,67203,67233,67262,67292,67321,67351,67380,67409,67439,67468,67497,67527,67557,67587,67617,67646,67676,67705,67735,67764,67793,67823,67852,67882,67911,67941,67971,68e3,68030,68060,68089,68119,68148,68177,68207,68236,68266,68295,68325,68354,68384,68414,68443,68473,68502,68532,68561,68591,68620,68650,68679,68708,68738,68768,68797,68827,68857,68886,68916,68946,68975,69004,69034,69063,69092,69122,69152,69181,69211,69240,69270,69300,69330,69359,69388,69418,69447,69476,69506,69535,69565,69595,69624,69654,69684,69713,69743,69772,69802,69831,69861,69890,69919,69949,69978,70008,70038,70067,70097,70126,70156,70186,70215,70245,70274,70303,70333,70362,70392,70421,70451,70481,70510,70540,70570,70599,70629,70658,70687,70717,70746,70776,70805,70835,70864,70894,70924,70954,70983,71013,71042,71071,71101,71130,71159,71189,71218,71248,71278,71308,71337,71367,71397,71426,71455,71485,71514,71543,71573,71602,71632,71662,71691,71721,71751,71781,71810,71839,71869,71898,71927,71957,71986,72016,72046,72075,72105,72135,72164,72194,72223,72253,72282,72311,72341,72370,72400,72429,72459,72489,72518,72548,72577,72607,72637,72666,72695,72725,72754,72784,72813,72843,72872,72902,72931,72961,72991,73020,73050,73080,73109,73139,73168,73197,73227,73256,73286,73315,73345,73375,73404,73434,73464,73493,73523,73552,73581,73611,73640,73669,73699,73729,73758,73788,73818,73848,73877,73907,73936,73965,73995,74024,74053,74083,74113,74142,74172,74202,74231,74261,74291,74320,74349,74379,74408,74437,74467,74497,74526,74556,74586,74615,74645,74675,74704,74733,74763,74792,74822,74851,74881,74910,74940,74969,74999,75029,75058,75088,75117,75147,75176,75206,75235,75264,75294,75323,75353,75383,75412,75442,75472,75501,75531,75560,75590,75619,75648,75678,75707,75737,75766,75796,75826,75856,75885,75915,75944,75974,76003,76032,76062,76091,76121,76150,76180,76210,76239,76269,76299,76328,76358,76387,76416,76446,76475,76505,76534,76564,76593,76623,76653,76682,76712,76741,76771,76801,76830,76859,76889,76918,76948,76977,77007,77036,77066,77096,77125,77155,77185,77214,77243,77273,77302,77332,77361,77390,77420,77450,77479,77509,77539,77569,77598,77627,77657,77686,77715,77745,77774,77804,77833,77863,77893,77923,77952,77982,78011,78041,78070,78099,78129,78158,78188,78217,78247,78277,78307,78336,78366,78395,78425,78454,78483,78513,78542,78572,78601,78631,78661,78690,78720,78750,78779,78808,78838,78867,78897,78926,78956,78985,79015,79044,79074,79104,79133,79163,79192,79222,79251,79281,79310,79340,79369,79399,79428,79458,79487,79517,79546,79576,79606,79635,79665,79695,79724,79753,79783,79812,79841,79871,79900,79930,79960,79990];e.getHijriDate=function(e){var r=e.getDate(),n=e.getMonth(),i=e.getFullYear(),o=n+1,a=i;o<3&&(a-=1,o+=12);var s=Math.floor(a/100),c=s-Math.floor(s/4)-2,l=Math.floor(365.25*(a+4716))+Math.floor(30.6001*(o+1))+r-c-1524,u=l+(c=(s=Math.floor((l-1867216.25)/36524.25))-Math.floor(s/4)+1)+1524,p=Math.floor((u-122.1)/365.25),h=Math.floor(365.25*p),d=Math.floor((u-h)/30.6001);r=u-h-Math.floor(30.6001*d),(n=Math.floor((u-h)/20.6001))>13&&(p+=1,n-=12),n-=1,i=p-4716;var m=l-24e5,f=l-1948084,g=Math.floor(f/10631);f-=10631*g;var y=Math.floor((f-.1335)/(10631/30)),v=30*g+y;f-=Math.floor(y*(10631/30)+.1335);var b=Math.floor((f+28.5001)/29.5);13===b&&(b=12);for(var M=f-Math.floor(29.5001*b-29),D=0;D<t.length&&!(t[D]>m);D++);var w=D+16260,E=Math.floor((w-1)/12),P=E+1,S=w-12*E,O=m-t[D-1]+1;return(O+"").length>2&&(O=M,S=b,P=v),{year:P,month:S,date:O}},e.toGregorian=function(e,r,n){var i=n+t[12*(e-1)+1+(r-1)-16260-1]-1+24e5,o=Math.floor(i+.5),a=Math.floor((o-1867216.25)/36524.25),s=1524+(a=o+1+a-Math.floor(a/4)),c=Math.floor((s-122.1)/365.25),l=Math.floor(365.25*c),u=Math.floor((s-l)/30.6001),p=s-l-Math.floor(30.6001*u),h=u-(u>13.5?13:1),d=c-(h>2.5?4716:4715);return d<=0&&h--,new Date(d+"/"+h+"/"+p)}}(e.HijriParser||(e.HijriParser={}));var se=/\/MMMMM|MMMM|MMM|a|LLLL|LLL|EEEEE|EEEE|E|K|cccc|ccc|WW|W|G+|z+/gi,ce=["sun","mon","tue","wed","thu","fri","sat"],le={m:"getMinutes",h:"getHours",H:"getHours",s:"getSeconds",d:"getDate",f:"getMilliseconds"},ue={M:"month",d:"day",E:"weekday",c:"weekday",y:"year",m:"minute",h:"hour",H:"hour",s:"second",L:"month",a:"designator",z:"timeZone",Z:"timeZone",G:"era",f:"milliseconds"},pe=function(){function t(){}return t.dateFormat=function(t,r,i){var o=this,a=e.IntlBase.getDependables(i,t,r.calendar),s=n("parserObject.numbers",a),l=a.dateObject,p={isIslamic:e.IntlBase.islamicRegex.test(r.calendar)};m()&&r.isServerRendered&&(r=e.IntlBase.compareBlazorDateFormats(r,t));var h=r.format||e.IntlBase.getResultantPattern(r.skeleton,a.dateObject,r.type,!1,m()?t:"");if(p.dateSeperator=m()?n("dateSeperator",l):e.IntlBase.getDateSeparator(a.dateObject),u(h))d("Format options or type given must be invalid");else{h=e.IntlBase.ConvertDateToWeekFormat(h),m()&&(h=h.replace(/tt/,"a")),p.pattern=h,p.numMapper=m()?c({},s):oe.getNumberMapper(a.parserObject,oe.getNumberingSystem(i));for(var f=0,g=h.match(se)||[];f<g.length;f++){var y=g[f],v=y.length,b=y[0];switch("K"===b&&(b="h"),b){case"E":case"c":m()?p.weekday=n("days."+e.IntlBase.monthIndex[v],l):p.weekday=a.dateObject[e.IntlBase.days]["stand-alone"][e.IntlBase.monthIndex[v]];break;case"M":case"L":m()?p.month=n("months."+e.IntlBase.monthIndex[v],l):p.month=a.dateObject[e.IntlBase.month]["stand-alone"][e.IntlBase.monthIndex[v]];break;case"a":p.designator=m()?n("dayPeriods",l):n("dayPeriods.format.wide",l);break;case"G":var M=v<=3?"eraAbbr":4===v?"eraNames":"eraNarrow";p.era=m()?n("eras",l):n("eras."+M,a.dateObject);break;case"z":p.timeZone=n("dates.timeZoneNames",a.parserObject)}}}return function(e){return isNaN(e.getDate())?null:o.intDateFormatter(e,p)}},t.intDateFormatter=function(t,r){for(var n="",i=r.pattern.match(e.IntlBase.dateParseRegex),o=this.getCurrentDateValue(t,r.isIslamic),a=0,s=i;a<s.length;a++){var c=s[a],u=c.length,p=c[0];"K"===p&&(p="h");var h=void 0,d="",m=void 0,f=void 0,g="";switch(p){case"M":case"L":h=o.month,u>2?n+=r.month[h]:m=!0;break;case"E":case"c":n+=r.weekday[ce[t.getDay()]];break;case"H":case"h":case"m":case"s":case"d":case"f":if(m=!0,"d"===p)h=o.date;else if("f"===p){m=!1,f=!0;var y=(d=(d=t[le[p]]().toString()).substring(0,u)).length;if(u!==y){if(u>3)continue;for(var v=0;v<u-y;v++)d="0"+d.toString()}g+=d}else h=t[le[p]]();"h"===p&&(h=h%12||12);break;case"y":f=!0,g+=o.year,2===u&&(g=g.substr(g.length-2));break;case"a":var b=t.getHours()<12?"am":"pm";n+=r.designator[b];break;case"G":var M=t.getFullYear()<0?0:1,D=r.era[M];l(D)&&(D=r.era[M?0:1]),n+=D||"";break;case"'":n+="''"===c?"'":c.replace(/'/g,"");break;case"z":var w=t.getTimezoneOffset(),E=u<4?"+H;-H":r.timeZone.hourFormat;E=E.replace(/:/g,r.numMapper.timeSeparator),0===w?n+=r.timeZone.gmtZeroFormat:(f=!0,g=this.getTimeZoneValue(w,E)),g=r.timeZone.gmtFormat.replace(/\{0\}/,g);break;case":":n+=r.numMapper.numberSymbols.timeSeparator;break;case"/":n+=r.dateSeperator;break;case"W":m=!0,h=e.IntlBase.getWeekOfYear(t);break;default:n+=c}m&&(f=!0,g=this.checkTwodigitNumber(h,u)),f&&(n+=oe.convertValueParts(g,e.IntlBase.latnParseRegex,r.numMapper.mapper))}return n},t.getCurrentDateValue=function(t,r){return r?e.HijriParser.getHijriDate(t):{year:t.getFullYear(),month:t.getMonth()+1,date:t.getDate()}},t.checkTwodigitNumber=function(e,t){var r=e+"";return 2===t&&2!==r.length?"0"+r:r},t.getTimeZoneValue=function(e,t){var r=this,n=t.split(";")[e>0?1:0],i=Math.abs(e);return n=n.replace(/HH?|mm/g,function(e){var t=e.length,n=-1!==e.indexOf("H");return r.checkTwodigitNumber(Math.floor(n?i/60:i%60),t)})},t}(),he={ms:"minimumSignificantDigits",ls:"maximumSignificantDigits",mf:"minimumFractionDigits",lf:"maximumFractionDigits"},de=["infinity","nan","group","decimal","exponential"],me=function(){function t(){}return t.numberFormatter=function(t,r,i){var o,a=this,s=c({},r),l={},p={},h=e.IntlBase.getDependables(i,t,"",!0),d=h.numericObject;p.numberMapper=m()?c({},d):oe.getNumberMapper(h.parserObject,oe.getNumberingSystem(i),!0),p.currencySymbol=m()?n("currencySymbol",d):e.IntlBase.getCurrencySymbol(h.numericObject,s.currency||e.defaultCurrencyCode,r.altSymbol),p.percentSymbol=m()?n("numberSymbols.percentSign",d):p.numberMapper.numberSymbols.percentSign,p.minusSymbol=m()?n("numberSymbols.minusSign",d):p.numberMapper.numberSymbols.minusSign;var f=p.numberMapper.numberSymbols;if(r.format&&!e.IntlBase.formatRegex.test(r.format))l=e.IntlBase.customFormat(r.format,p,h.numericObject);else{if(c(s,e.IntlBase.getProperNumericSkeleton(r.format||"N")),s.isCurrency="currency"===s.type,s.isPercent="percent"===s.type,m()||(o=e.IntlBase.getSymbolPattern(s.type,p.numberMapper.numberSystem,h.numericObject,s.isAccount)),s.groupOne=this.checkValueRange(s.maximumSignificantDigits,s.minimumSignificantDigits,!0),this.checkValueRange(s.maximumFractionDigits,s.minimumFractionDigits,!1,!0),u(s.fractionDigits)||(s.minimumFractionDigits=s.maximumFractionDigits=s.fractionDigits),u(s.useGrouping)&&(s.useGrouping=!0),s.isCurrency&&!m()&&(o=o.replace(/\u00A4/g,e.IntlBase.defaultCurrency)),m())l.nData=c({},{},n(s.type+"nData",d)),l.pData=c({},{},n(s.type+"pData",d)),"currency"===s.type&&r.currency&&e.IntlBase.replaceBlazorCurrency([l.pData,l.nData],p.currencySymbol,r.currency);else{var g=o.split(";");l.nData=e.IntlBase.getFormatData(g[1]||"-"+g[0],!0,p.currencySymbol),l.pData=e.IntlBase.getFormatData(g[0],!1,p.currencySymbol),s.useGrouping&&(s.groupSeparator=f[de[2]],s.groupData=this.getGroupingDetails(g[0]))}if(u(s.minimumFractionDigits)&&(s.minimumFractionDigits=l.nData.minimumFraction),u(s.maximumFractionDigits)){var y=l.nData.maximumFraction;s.maximumFractionDigits=u(y)&&s.isPercent?0:y}var v=s.minimumFractionDigits,b=s.maximumFractionDigits;u(v)||u(b)||v>b&&(s.maximumFractionDigits=v)}return c(l.nData,s),c(l.pData,s),function(e){return isNaN(e)?f[de[1]]:isFinite(e)?a.intNumberFormatter(e,l,p):f[de[0]]}},t.getGroupingDetails=function(t){var r={},n=t.match(e.IntlBase.negativeDataRegex);if(n&&n[4]){var i=n[4],o=i.lastIndexOf(",");if(-1!==o){var a=i.split(".")[0];r.primary=a.length-o-1;var s=i.lastIndexOf(",",o-1);-1!==s&&(r.secondary=o-1-s)}}return r},t.checkValueRange=function(e,t,r,n){var i=n?"f":"s",o=0,a=he["l"+i],s=he["m"+i];if(u(e)||(this.checkRange(e,a,n),o++),u(t)||(this.checkRange(t,s,n),o++),2===o){if(!(e<t))return!0;d(s+"specified must be less than the"+a)}else r&&1===o&&d("Both"+s+"and"+s+"must be present");return!1},t.checkRange=function(e,t,r){var n=r?[0,20]:[1,21];(e<n[0]||e>n[1])&&d(t+"value must be within the range"+n[0]+"to"+n[1])},t.intNumberFormatter=function(t,r,n){var i;if(!u(r.nData.type)){t<0?(t*=-1,i=r.nData):i=0===t?r.zeroData||r.pData:r.pData;var o="";return i.isPercent&&(t*=100),i.groupOne?o=this.processSignificantDigits(t,i.minimumSignificantDigits,i.maximumSignificantDigits):(o=this.processFraction(t,i.minimumFractionDigits,i.maximumFractionDigits),i.minimumIntegerDigits&&(o=this.processMinimumIntegers(o,i.minimumIntegerDigits))),"scientific"===i.type&&(o=(o=t.toExponential(i.maximumFractionDigits)).replace("e",n.numberMapper.numberSymbols[de[4]])),o=o.replace(".",n.numberMapper.numberSymbols[de[3]]),i.useGrouping&&(o=this.groupNumbers(o,i.groupData.primary,i.groupSeparator||",",n.numberMapper.numberSymbols[de[3]]||".",i.groupData.secondary)),o=oe.convertValueParts(o,e.IntlBase.latnParseRegex,n.numberMapper.mapper),"N/A"===i.nlead?i.nlead:i.nlead+o+i.nend}},t.processSignificantDigits=function(e,t,r){var n=e+"";return n.length<t?e.toPrecision(t):(n=e.toPrecision(r),+n+"")},t.groupNumbers=function(e,t,r,n,i){for(var o=!l(i)&&0!==i,a=e.split(n),s=a[0],c=s.length,u="";c>t;)u=s.slice(c-t,c)+(u.length?r+u:""),c-=t,o&&(t=i,o=!1);return a[0]=s.slice(0,c)+(u.length?r:"")+u,a.join(n)},t.processFraction=function(e,t,r){var n=(e+"").split(".")[1],i=n?n.length:0;if(t&&i<t){var o="";if(0!==i){o+=e;for(var a=0;a<t-i;a++)o+="0";return o}return o=e.toFixed(t),e.toFixed(t)}return!l(r)&&(i>r||0===r)?e.toFixed(r):e+""},t.processMinimumIntegers=function(e,t){var r=e.split("."),n=r[0],i=n.length;if(i<t){for(var o=0;o<t-i;o++)n="0"+n;r[0]=n}return r.join(".")},t}(),fe=/^[0-9]*$/,ge={minute:"setMinutes",hour:"setHours",second:"setSeconds",day:"setDate",month:"setMonth",milliseconds:"setMilliseconds"},ye=function(){function t(){}return t.dateParser=function(t,r,i){var o=this,a=e.IntlBase.getDependables(i,t,r.calendar),s=oe.getCurrentNumericOptions(a.parserObject,oe.getNumberingSystem(i),!1,m()),c={};m()&&r.isServerRendered&&(r=e.IntlBase.compareBlazorDateFormats(r,t));var p,h=r.format||e.IntlBase.getResultantPattern(r.skeleton,a.dateObject,r.type,!1,m()?t:""),f="";if(u(h))d("Format options or type given must be invalid");else{h=e.IntlBase.ConvertDateToWeekFormat(h),c={isIslamic:e.IntlBase.islamicRegex.test(r.calendar),pattern:h,evalposition:{},culture:t};for(var g=h.match(e.IntlBase.dateParseRegex)||[],y=g.length,v=0,b=0,M=!1,D=s.numericRegex,w=m()?a.parserObject.numbers:oe.getNumberMapper(a.parserObject,oe.getNumberingSystem(i)),E=0;E<y;E++){var P=g[E],S=P.length,O="K"===P[0]?"h":P[0],C=void 0,T=void 0,x=ue[O],j=2===S?"":"?";switch(M&&(v=b,M=!1),O){case"E":case"c":var N=void 0;N=m()?n("days."+e.IntlBase.monthIndex[S],a.dateObject):a.dateObject[e.IntlBase.days]["stand-alone"][e.IntlBase.monthIndex[S]];var F=oe.reverseObject(N);f+="("+Object.keys(F).join("|")+")";break;case"M":case"L":case"d":case"m":case"s":case"h":case"H":case"f":if(T=!0,("M"===O||"L"===O)&&S>2){var R=void 0;R=m()?n("months."+e.IntlBase.monthIndex[S],a.dateObject):a.dateObject.months["stand-alone"][e.IntlBase.monthIndex[S]],c[x]=oe.reverseObject(R),f+="("+Object.keys(c[x]).join("|")+")"}else if("f"===O){if(S>3)continue;C=!0,f+="("+D+D+"?"+D+"?)"}else C=!0,f+="("+D+D+j+")";"h"===O&&(c.hour12=!0);break;case"W":f+="("+D+(1===S?"?":"")+D+")";break;case"y":T=C=!0,f+=2===S?"("+D+D+")":"("+D+"{"+S+",})";break;case"a":T=!0;var A=m()?n("dayPeriods",a.dateObject):n("dayPeriods.format.wide",a.dateObject);c[x]=oe.reverseObject(A),f+="("+Object.keys(c[x]).join("|")+")";break;case"G":T=!0;var I=S<=3?"eraAbbr":4===S?"eraNames":"eraNarrow";c[x]=oe.reverseObject(m()?n("eras",a.dateObject):n("eras."+I,a.dateObject)),f+="("+Object.keys(c[x]).join("|")+"?)";break;case"z":T=0!==(new Date).getTimezoneOffset(),c[x]=n("dates.timeZoneNames",a.parserObject);var k=c[x],H=(p=S<4)?"+H;-H":k.hourFormat;H=H.replace(/:/g,w.timeSeparator),f+="("+this.parseTimeZoneRegx(H,k,D)+")?",M=!0,b=p?6:12;break;case"'":f+="("+P.replace(/'/g,"")+")?";break;default:f+="([\\D])"}T&&(c.evalposition[x]={isNumber:C,pos:E+1+v,hourOnly:p}),E!==y-1||l(f)||(c.parserRegex=new RegExp("^"+f+"$","i"))}}return function(t){var r=o.internalDateParse(t,c,s);if(l(r)||!Object.keys(r).length)return null;if(c.isIslamic){var n={},i=r.year,a=r.day,u=r.month,p=i?i+"":"",h=2===p.length;i&&u&&a&&!h||(n=e.HijriParser.getHijriDate(new Date)),h&&(i=parseInt((n.year+"").slice(0,2)+p,10));var d=e.HijriParser.toGregorian(i||n.year,u||n.month,a||n.date);r.year=d.getFullYear(),r.month=d.getMonth()+1,r.day=d.getDate()}return o.getDateObject(r)}},t.getDateObject=function(e,t){var r=t||new Date;r.setMilliseconds(0);var n=e.year,i=e.designator,o=e.timeZone;if(!u(n)){if((n+"").length<=2){n+=100*Math.floor(r.getFullYear()/100)}r.setFullYear(n)}for(var a=0,s=["hour","minute","second","milliseconds","month","day"];a<s.length;a++){var c=s[a],l=e[c];if(u(l)&&"day"===c&&r.setDate(1),!u(l))if("month"===c){if((l-=1)<0||l>11)return new Date("invalid");var p=r.getDate();r.setDate(1),r[ge[c]](l);var h=new Date(r.getFullYear(),l+1,0).getDate();r.setDate(p<h?p:h)}else{if("day"===c){var d=new Date(r.getFullYear(),r.getMonth()+1,0).getDate();if(l<1||l>d)return null}r[ge[c]](l)}}if(!u(i)){var m=r.getHours();"pm"===i?r.setHours(m+(12===m?0:12)):12===m&&r.setHours(0)}if(!u(o)){var f=o-r.getTimezoneOffset();0!==f&&r.setMinutes(r.getMinutes()+f)}return r},t.internalDateParse=function(e,t,r){var n=e.match(t.parserRegex),i={hour:0,minute:0,second:0};if(l(n))return null;for(var o=0,a=Object.keys(t.evalposition);o<a.length;o++){var s=a[o],c=t.evalposition[s],p=n[c.pos];if(c.isNumber)i[s]=this.internalNumberParser(p,r);else if("timeZone"!==s||u(p))p="month"!==s||t.isIslamic||"en"!==t.culture&&"en-GB"!==t.culture&&"en-US"!==t.culture?p:p[0].toUpperCase()+p.substring(1).toLowerCase(),i[s]=t[s][p];else{var h=c.pos,d=void 0,m=n[h+1],f=!u(m);c.hourOnly?d=60*this.getZoneValue(f,m,n[h+4],r):(d=60*this.getZoneValue(f,m,n[h+7],r),d+=this.getZoneValue(f,n[h+4],n[h+10],r)),l(d)||(i[s]=d)}}return t.hour12&&(i.hour12=!0),i},t.internalNumberParser=function(e,t){return e=oe.convertValueParts(e,t.numberParseRegex,t.numericPair),fe.test(e)?+e:null},t.parseTimeZoneRegx=function(e,t,r){var n,i,o=t.gmtFormat,a="("+r+")("+r+")";return n=e.replace("+","\\+"),n=-1!==e.indexOf("HH")?n.replace(/HH|mm/g,"("+a+")"):n.replace(/H|m/g,"("+a+"?)"),i=n.split(";").map(function(e){return o.replace("{0}",e)}),n=i.join("|")+"|"+t.gmtZeroFormat},t.getZoneValue=function(e,t,r,n){var i=e?t:r;if(!i)return 0;var o=this.internalNumberParser(i,n);return e?-o:o},t}(),ve=/^([^0-9]*)(([0-9,]*[0-9]+)(\.[0-9]+)?)([Ee][+-]?[0-9]+)?([^0-9]*)$/,be=/,/g,Me=["minusSign","infinity"],De=function(){function t(){}return t.numberParser=function(t,r,i){var o,a=this,s=e.IntlBase.getDependables(i,t,"",!0),l={custom:!0};e.IntlBase.formatRegex.test(r.format)||!r.format?(c(l,e.IntlBase.getProperNumericSkeleton(r.format||"N")),l.custom=!1,l.fractionDigits||r.maximumFractionDigits&&(l.maximumFractionDigits=r.maximumFractionDigits)):c(l,e.IntlBase.customFormat(r.format,null,null));var u=n("numbers",s.parserObject);o=oe.getCurrentNumericOptions(s.parserObject,oe.getNumberingSystem(i),!0,m()),l.symbolRegex=oe.getSymbolRegex(Object.keys(o.symbolMatch)),l.infinity=o.symbolNumberSystem[Me[1]];var p;if(m())l.nData=c({},{},n(l.type+"nData",u)),l.pData=c({},{},n(l.type+"pData",u)),"currency"===l.type&&r.currency&&e.IntlBase.replaceBlazorCurrency([l.pData,l.nData],n("currencySymbol",u),r.currency);else if(p=e.IntlBase.getSymbolPattern(l.type,o.numberSystem,s.numericObject,l.isAccount)){var h=(p=p.replace(/\u00A4/g,e.IntlBase.defaultCurrency)).split(";");l.nData=e.IntlBase.getFormatData(h[1]||"-"+h[0],!0,""),l.pData=e.IntlBase.getFormatData(h[0],!0,"")}return function(e){return a.getParsedNumber(e,l,o)}},t.getParsedNumber=function(e,t,r){var n,i,o,a,s,c;if(-1!==e.indexOf(t.infinity))return 1/0;e=oe.convertValueParts(e,t.symbolRegex,r.symbolMatch),0===(e=-1!==(e=oe.convertValueParts(e,r.numberParseRegex,r.numericPair)).indexOf("-")?e.replace("-.","-0."):e).indexOf(".")&&(e="0"+e);var u=e.match(ve);if(l(u))return NaN;a=u[1],o=u[2];var p=u[5];return s=u[6],n=t.custom?a===t.nData.nlead&&s===t.nData.nend:-1!==a.indexOf(t.nData.nlead)&&-1!==s.indexOf(t.nData.nend),i=n?t.nData.isPercent:t.pData.isPercent,o=o.replace(be,""),p&&(o+=p),c=+o,("percent"===t.type||i)&&(c/=100),(t.custom||t.fractionDigits)&&(c=parseFloat(c.toFixed(t.custom?n?t.nData.maximumFractionDigits:t.pData.maximumFractionDigits:t.fractionDigits))),t.maximumFractionDigits&&(c=this.convertMaxFracDigits(o,t,c,n)),n&&(c*=-1),c},t.convertMaxFracDigits=function(e,t,r,n){var i=e.split(".");return i[1]&&i[1].length>t.maximumFractionDigits&&(r=+r.toFixed(t.custom?n?t.nData.maximumFractionDigits:t.pData.maximumFractionDigits:t.maximumFractionDigits)),r},t}(),we=function(){function e(e){this.ranArray=[],this.boundedEvents={},l(e)||(this.context=e)}return e.prototype.on=function(e,t,r,n){if(!l(t)){var i=r||this.context;this.notExist(e)?this.boundedEvents[e]=[{handler:t,context:i}]:l(n)?this.isHandlerPresent(this.boundedEvents[e],t)||this.boundedEvents[e].push({handler:t,context:i}):-1===this.ranArray.indexOf(n)&&(this.ranArray.push(n),this.boundedEvents[e].push({handler:t,context:i,id:n}))}},e.prototype.off=function(e,t,r){if(!this.notExist(e)){var i=n(e,this.boundedEvents);if(t){for(var o=0;o<i.length;o++)if(r){if(i[o].id===r){i.splice(o,1);var a=this.ranArray.indexOf(r);-1!==a&&this.ranArray.splice(a,1);break}}else if(t===i[o].handler){i.splice(o,1);break}}else delete this.boundedEvents[e]}},e.prototype.notify=function(e,t,r,i){if(this.notExist(e))r&&r.call(this,t);else{t&&(t.name=e);var o=n(e,this.boundedEvents).slice(0);if(window.Blazor)return this.blazorCallback(o,t,r,i,0);for(var a=0,s=o;a<s.length;a++){var c=s[a];c.handler.call(c.context,t)}r&&r.call(this,t)}},e.prototype.blazorCallback=function(e,t,r,n,i){var o=this,a=i===e.length-1;if(i<e.length){var s=e[i],l=s.handler.call(s.context,t);if(l&&"function"==typeof l.then){if(!r)return l;l.then(function(l){if(l="string"==typeof l&&o.isJson(l)?JSON.parse(l,o.dateReviver):l,c(t,t,l,!0),!r||!a)return o.blazorCallback(e,t,r,n,i+1);r.call(s.context,t)}).catch(function(e){n&&n.call(s.context,"string"==typeof e&&o.isJson(e)?JSON.parse(e,o.dateReviver):e)})}else{if(!r||!a)return this.blazorCallback(e,t,r,n,i+1);r.call(s.context,t)}}},e.prototype.dateReviver=function(e,t){return m&&"string"==typeof t&&null!==t.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/)?new Date(t):t},e.prototype.isJson=function(e){try{JSON.parse(e)}catch(e){return!1}return!0},e.prototype.destroy=function(){this.boundedEvents=this.context=void 0},e.prototype.notExist=function(e){return!1===this.boundedEvents.hasOwnProperty(e)||this.boundedEvents[e].length<=0},e.prototype.isHandlerPresent=function(e,t){for(var r=0,n=e;r<n.length;r++){if(n[r].handler===t)return!0}return!1},e}(),Ee=new we;e.rightToLeft=!1;var Pe={};e.defaultCulture="en-US",e.defaultCurrencyCode="USD";var Se=["numericObject","dateObject"],Oe=function(){function t(e){e&&(this.culture=e)}return t.prototype.getDateFormat=function(e){return pe.dateFormat(this.getCulture(),e||{type:"date",skeleton:"short"},Pe)},t.prototype.getNumberFormat=function(t){return t&&!t.currency&&(t.currency=e.defaultCurrencyCode),m()&&t&&!t.format&&(t.minimumFractionDigits=0),me.numberFormatter(this.getCulture(),t||{},Pe)},t.prototype.getDateParser=function(e){return ye.dateParser(this.getCulture(),e||{skeleton:"short",type:"date"},Pe)},t.prototype.getNumberParser=function(e){return m()&&e&&!e.format&&(e.minimumFractionDigits=0),De.numberParser(this.getCulture(),e||{format:"N"},Pe)},t.prototype.formatNumber=function(e,t){return this.getNumberFormat(t)(e)},t.prototype.formatDate=function(e,t){return this.getDateFormat(t)(e)},t.prototype.parseDate=function(e,t){return this.getDateParser(t)(e)},t.prototype.parseNumber=function(e,t){return this.getNumberParser(t)(e)},t.prototype.getDatePattern=function(t,r){return e.IntlBase.getActualDateTimeFormat(this.getCulture(),t,Pe,r)},t.prototype.getNumberPattern=function(t,r){return e.IntlBase.getActualNumberFormat(this.getCulture(),t,Pe,r)},t.prototype.getFirstDayOfWeek=function(){return e.IntlBase.getWeekData(this.getCulture(),Pe)},t.prototype.getCulture=function(){return this.culture||e.defaultCulture},t}(),Ce={"en-US":{d:"M/d/y",D:"EEEE, MMMM d, y",f:"EEEE, MMMM d, y h:mm a",F:"EEEE, MMMM d, y h:mm:s a",g:"M/d/y h:mm a",G:"M/d/yyyy h:mm:ss tt",m:"MMMM d",M:"MMMM d",r:"ddd, dd MMM yyyy HH':'mm':'ss 'GMT'",R:"ddd, dd MMM yyyy HH':'mm':'ss 'GMT'",s:"yyyy'-'MM'-'dd'T'HH':'mm':'ss",t:"h:mm tt",T:"h:m:s tt",u:"yyyy'-'MM'-'dd HH':'mm':'ss'Z'",U:"dddd, MMMM d, yyyy h:mm:ss tt",y:"MMMM yyyy",Y:"MMMM yyyy"}};!function(t){function r(e,r,i,o,a){var c,l=i||"date";if(a)c=s({skeleton:e},a).format||s({skeleton:"d"},"en-US").format;else{if(-1!==t.basicPatterns.indexOf(e)){if(c=n(l+"Formats."+e,r),"dateTime"===l){var p=n("dateFormats."+e,r),h=n("timeFormats."+e,r);c=c.replace("{1}",p).replace("{0}",h)}}else c=n("dateTimeFormats.availableFormats."+e,r);u(c)&&"yMd"===e&&(c="M/d/y")}return c}function i(e,r,i,o){var a={},s=i||"gregorian";if(a.parserObject=oe.getMainObject(e,r)||(m()?t.blazorDefaultObject:t.defaultObject),o)a.numericObject=n("numbers",a.parserObject);else{var c=m()?"dates":"dates.calendars."+s;a.dateObject=n(c,a.parserObject)}return a}function o(e,t,r,i){return n(e+"Formats-numberSystem-"+t+(i?".accounting":".standard"),r)||(i?n(e+"Formats-numberSystem-"+t+".standard",r):"")}function a(e){var r=e.match(t.dateConverterMapper);if(r&&m()){var n=3===r[0].length?"EEE":"EEEE";return e.replace(t.dateConverterMapper,n)}return e}function s(e,t){var r=e.format||e.skeleton,i=n((t||"en-US")+"."+r,Ce);return i||(i=n("en-US."+r,Ce)),i&&(i=a(i),e.format=i.replace(/tt/,"a")),e}function p(e){var r=e.match(t.formatRegex),n={},i=r[1].toUpperCase();return n.isAccount="A"===i,n.type=t.patternMatcher[i],e.length>1&&(n.fractionDigits=parseInt(r[2],10)),n}function h(e,r,n,i){var o=i?{}:{nlead:"",nend:""},a=e.match(t.customRegex);if(a){i||(o.nlead=d(a[1],n),o.nend=d(a[10],n),o.groupPattern=a[4]);var s=a[7];if(s&&r){var c=s.match(D);l(c)?o.minimumFraction=0:o.minimumFraction=c.length,o.maximumFraction=s.length-1}}return o}function d(e,r){return e?e.replace(t.defaultCurrency,r):""}function f(e,t,r){return n("currencies."+t+(r?"."+r:".symbol"),e)||n("currencies."+t+".symbol-alt-narrow",e)||"$"}function g(e,r,n){var i={type:"decimal",minimumFractionDigits:0,maximumFractionDigits:0},a=e.match(t.customRegex);if(l(a)||""===a[5]&&"N/A"!==e)return i.type=void 0,i;i.nlead=a[1],i.nend=a[10];var s=a[6],u=!!s.match(/\ $/g),p=-1!==s.replace(/\ $/g,"").indexOf(" ");i.useGrouping=-1!==s.indexOf(",")||p,s=p?s.replace(/,/g,""):s.replace(/,/g,"").replace(/\ $/g,"");var h=a[7];if(-1!==s.indexOf("0")&&(i.minimumIntegerDigits=s.length-s.indexOf("0")),l(h)||(i.minimumFractionDigits=h.lastIndexOf("0"),i.maximumFractionDigits=h.lastIndexOf("#"),-1===i.minimumFractionDigits&&(i.minimumFractionDigits=0),(-1===i.maximumFractionDigits||i.maximumFractionDigits<i.minimumFractionDigits)&&(i.maximumFractionDigits=i.minimumFractionDigits)),l(r)?c(i,y([i.nlead,i.nend],"%","%")):(c(i,y([i.nlead,i.nend],"$",r.currencySymbol)),i.isCurrency||c(i,y([i.nlead,i.nend],"%",r.percentSymbol))),!l(n)){var d=o(i.type,r.numberMapper.numberSystem,n,!1);i.useGrouping&&(i.groupSeparator=p?" ":r.numberMapper.numberSymbols[w[2]],i.groupData=me.getGroupingDetails(d.split(";")[0])),i.nlead=i.nlead.replace(/'/g,""),i.nend=u?" "+i.nend.replace(/'/g,""):i.nend.replace(/'/g,"")}return i}function y(e,t,r){for(var n={nlead:e[0],nend:e[1]},i=0;i<2;i++){var o=e[i],a=o.indexOf(t);if(-1!==a&&(a<o.indexOf("'")||a>o.lastIndexOf("'"))){n[C[i]]=o.substr(0,a)+r+o.substr(a+1),n[C[t]]=!0,n.type=n.isCurrency?"currency":"percent";break}}return n}function v(e,t,r){e+=".";for(var n=0;n<t;n++)e+="0";if(t<r)for(var i=r-t,o=0;o<i;o++)e+="#";return e}function b(e,t){for(var r=e.split("."),n="",i=0;i<t;i++)n+="0";return r[1]?n+"."+r[1]:n}function M(e){var t=e.split("."),r=t[0],n=3-r.length%3;e="";for(var i=(r=(n&&1===n?"#":2===n?"##":"")+r).length-1;i>0;i-=3)e=","+r[i-2]+r[i-1]+r[i]+e;return e=e.slice(1),t[1]?e+"."+t[1]:e}t.negativeDataRegex=/^(('[^']+'|''|[^*#@0,.E])*)(\*.)?((([#,]*[0,]*0+)(\.0*[0-9]*#*)?)|([#,]*@+#*))(E\+?0+)?(('[^']+'|''|[^*#@0,.E])*)$/,t.customRegex=/^(('[^']+'|''|[^*#@0,.])*)(\*.)?((([0#,]*[0,]*[0#]*[0#\ ]*)(\.[0#]*)?)|([#,]*@+#*))(E\+?0+)?(('[^']+'|''|[^*#@0,.E])*)$/,t.latnParseRegex=/0|1|2|3|4|5|6|7|8|9/g;var D=/[0-9]/g;t.defaultCurrency="$";var w=["infinity","nan","group","decimal"],E=/G|M|L|H|c|'| a|yy|y|EEEE|E/g,P={G:"",M:"m",L:"m",H:"h",c:"d","'":'"'," a":" AM/PM",yy:"yy",y:"yyyy",EEEE:"dddd",E:"ddd"};t.dateConverterMapper=/dddd|ddd/gi;var S="sun";t.islamicRegex=/^islamic/;var O={sun:0,mon:1,tue:2,wed:3,thu:4,fri:5,sat:6};t.formatRegex=/(^[ncpae]{1})([0-1]?[0-9]|20)?$/i,t.currencyFormatRegex=/(^[ca]{1})([0-1]?[0-9]|20)?$/i,t.curWithoutNumberRegex=/(c|a)$/gi;var C={$:"isCurrency","%":"isPercent","-":"isNegative",0:"nlead",1:"nend"};t.dateParseRegex=/([a-z])\1*|'([^']|'')+'|''|./gi,t.basicPatterns=["short","medium","long","full"],t.defaultObject={dates:{calendars:{gregorian:{months:{"stand-alone":{abbreviated:{1:"Jan",2:"Feb",3:"Mar",4:"Apr",5:"May",6:"Jun",7:"Jul",8:"Aug",9:"Sep",10:"Oct",11:"Nov",12:"Dec"},narrow:{1:"J",2:"F",3:"M",4:"A",5:"M",6:"J",7:"J",8:"A",9:"S",10:"O",11:"N",12:"D"},wide:{1:"January",2:"February",3:"March",4:"April",5:"May",6:"June",7:"July",8:"August",9:"September",10:"October",11:"November",12:"December"}}},days:{"stand-alone":{abbreviated:{sun:"Sun",mon:"Mon",tue:"Tue",wed:"Wed",thu:"Thu",fri:"Fri",sat:"Sat"},narrow:{sun:"S",mon:"M",tue:"T",wed:"W",thu:"T",fri:"F",sat:"S"},short:{sun:"Su",mon:"Mo",tue:"Tu",wed:"We",thu:"Th",fri:"Fr",sat:"Sa"},wide:{sun:"Sunday",mon:"Monday",tue:"Tuesday",wed:"Wednesday",thu:"Thursday",fri:"Friday",sat:"Saturday"}}},dayPeriods:{format:{wide:{am:"AM",pm:"PM"}}},eras:{eraNames:{0:"Before Christ","0-alt-variant":"Before Common Era",1:"Anno Domini","1-alt-variant":"Common Era"},eraAbbr:{0:"BC","0-alt-variant":"BCE",1:"AD","1-alt-variant":"CE"},eraNarrow:{0:"B","0-alt-variant":"BCE",1:"A","1-alt-variant":"CE"}},dateFormats:{full:"EEEE, MMMM d, y",long:"MMMM d, y",medium:"MMM d, y",short:"M/d/yy"},timeFormats:{full:"h:mm:ss a zzzz",long:"h:mm:ss a z",medium:"h:mm:ss a",short:"h:mm a"},dateTimeFormats:{full:"{1} 'at' {0}",long:"{1} 'at' {0}",medium:"{1}, {0}",short:"{1}, {0}",availableFormats:{d:"d",E:"ccc",Ed:"d E",Ehm:"E h:mm a",EHm:"E HH:mm",Ehms:"E h:mm:ss a",EHms:"E HH:mm:ss",Gy:"y G",GyMMM:"MMM y G",GyMMMd:"MMM d, y G",GyMMMEd:"E, MMM d, y G",h:"h a",H:"HH",hm:"h:mm a",Hm:"HH:mm",hms:"h:mm:ss a",Hms:"HH:mm:ss",hmsv:"h:mm:ss a v",Hmsv:"HH:mm:ss v",hmv:"h:mm a v",Hmv:"HH:mm v",M:"L",Md:"M/d",MEd:"E, M/d",MMM:"LLL",MMMd:"MMM d",MMMEd:"E, MMM d",MMMMd:"MMMM d",ms:"mm:ss",y:"y",yM:"M/y",yMd:"M/d/y",yMEd:"E, M/d/y",yMMM:"MMM y",yMMMd:"MMM d, y",yMMMEd:"E, MMM d, y",yMMMM:"MMMM y"}}},islamic:{months:{"stand-alone":{abbreviated:{1:"Muh.",2:"Saf.",3:"Rab. I",4:"Rab. II",5:"Jum. I",6:"Jum. II",7:"Raj.",8:"Sha.",9:"Ram.",10:"Shaw.",11:"Dhuʻl-Q.",12:"Dhuʻl-H."},narrow:{1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9",10:"10",11:"11",12:"12"},wide:{1:"Muharram",2:"Safar",3:"Rabiʻ I",4:"Rabiʻ II",5:"Jumada I",6:"Jumada II",7:"Rajab",8:"Shaʻban",9:"Ramadan",10:"Shawwal",11:"Dhuʻl-Qiʻdah",12:"Dhuʻl-Hijjah"}}},days:{"stand-alone":{abbreviated:{sun:"Sun",mon:"Mon",tue:"Tue",wed:"Wed",thu:"Thu",fri:"Fri",sat:"Sat"},narrow:{sun:"S",mon:"M",tue:"T",wed:"W",thu:"T",fri:"F",sat:"S"},short:{sun:"Su",mon:"Mo",tue:"Tu",wed:"We",thu:"Th",fri:"Fr",sat:"Sa"},wide:{sun:"Sunday",mon:"Monday",tue:"Tuesday",wed:"Wednesday",thu:"Thursday",fri:"Friday",sat:"Saturday"}}},dayPeriods:{format:{wide:{am:"AM",pm:"PM"}}},eras:{eraNames:{0:"AH"},eraAbbr:{0:"AH"},eraNarrow:{0:"AH"}},dateFormats:{full:"EEEE, MMMM d, y G",long:"MMMM d, y G",medium:"MMM d, y G",short:"M/d/y GGGGG"},timeFormats:{full:"h:mm:ss a zzzz",long:"h:mm:ss a z",medium:"h:mm:ss a",short:"h:mm a"},dateTimeFormats:{full:"{1} 'at' {0}",long:"{1} 'at' {0}",medium:"{1}, {0}",short:"{1}, {0}",availableFormats:{d:"d",E:"ccc",Ed:"d E",Ehm:"E h:mm a",EHm:"E HH:mm",Ehms:"E h:mm:ss a",EHms:"E HH:mm:ss",Gy:"y G",GyMMM:"MMM y G",GyMMMd:"MMM d, y G",GyMMMEd:"E, MMM d, y G",h:"h a",H:"HH",hm:"h:mm a",Hm:"HH:mm",hms:"h:mm:ss a",Hms:"HH:mm:ss",M:"L",Md:"M/d",MEd:"E, M/d",MMM:"LLL",MMMd:"MMM d",MMMEd:"E, MMM d",MMMMd:"MMMM d",ms:"mm:ss",y:"y G",yyyy:"y G",yyyyM:"M/y GGGGG",yyyyMd:"M/d/y GGGGG",yyyyMEd:"E, M/d/y GGGGG",yyyyMMM:"MMM y G",yyyyMMMd:"MMM d, y G",yyyyMMMEd:"E, MMM d, y G",yyyyMMMM:"MMMM y G",yyyyQQQ:"QQQ y G",yyyyQQQQ:"QQQQ y G"}}}},timeZoneNames:{hourFormat:"+HH:mm;-HH:mm",gmtFormat:"GMT{0}",gmtZeroFormat:"GMT"}},numbers:{currencies:{USD:{displayName:"US Dollar",symbol:"$","symbol-alt-narrow":"$"},EUR:{displayName:"Euro",symbol:"€","symbol-alt-narrow":"€"},GBP:{displayName:"British Pound","symbol-alt-narrow":"£"}},defaultNumberingSystem:"latn",minimumGroupingDigits:"1","symbols-numberSystem-latn":{decimal:".",group:",",list:";",percentSign:"%",plusSign:"+",minusSign:"-",exponential:"E",superscriptingExponent:"×",perMille:"‰",infinity:"∞",nan:"NaN",timeSeparator:":"},"decimalFormats-numberSystem-latn":{standard:"#,##0.###"},"percentFormats-numberSystem-latn":{standard:"#,##0%"},"currencyFormats-numberSystem-latn":{standard:"¤#,##0.00",accounting:"¤#,##0.00;(¤#,##0.00)"},"scientificFormats-numberSystem-latn":{standard:"#E0"}}},t.blazorDefaultObject={numbers:{mapper:{0:"0",1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9"},mapperDigits:"0123456789",numberSymbols:{decimal:".",group:",",plusSign:"+",minusSign:"-",percentSign:"%",nan:"NaN",timeSeparator:":",infinity:"∞"},timeSeparator:":",currencySymbol:"$",currencypData:{nlead:"$",nend:"",groupSeparator:",",groupData:{primary:3},maximumFraction:2,minimumFraction:2},percentpData:{nlead:"",nend:"%",groupSeparator:",",groupData:{primary:3},maximumFraction:2,minimumFraction:2},percentnData:{nlead:"-",nend:"%",groupSeparator:",",groupData:{primary:3},maximumFraction:2,minimumFraction:2},currencynData:{nlead:"($",nend:")",groupSeparator:",",groupData:{primary:3},maximumFraction:2,minimumFraction:2},decimalnData:{nlead:"-",nend:"",groupData:{primary:3},maximumFraction:2,minimumFraction:2},decimalpData:{nlead:"",nend:"",groupData:{primary:3},maximumFraction:2,minimumFraction:2}},dates:{dayPeriods:{am:"AM",pm:"PM"},dateSeperator:"/",days:{abbreviated:{sun:"Sun",mon:"Mon",tue:"Tue",wed:"Wed",thu:"Thu",fri:"Fri",sat:"Sat"},short:{sun:"Su",mon:"Mo",tue:"Tu",wed:"We",thu:"Th",fri:"Fr",sat:"Sa"},wide:{sun:"Sunday",mon:"Monday",tue:"Tuesday",wed:"Wednesday",thu:"Thursday",fri:"Friday",sat:"Saturday"}},months:{abbreviated:{1:"Jan",2:"Feb",3:"Mar",4:"Apr",5:"May",6:"Jun",7:"Jul",8:"Aug",9:"Sep",10:"Oct",11:"Nov",12:"Dec"},wide:{1:"January",2:"February",3:"March",4:"April",5:"May",6:"June",7:"July",8:"August",9:"September",10:"October",11:"November",12:"December"}},eras:{1:"AD"}}},t.monthIndex={3:"abbreviated",4:"wide",5:"narrow",1:"abbreviated"},t.month="months",t.days="days",t.patternMatcher={C:"currency",P:"percent",N:"decimal",A:"currency",E:"scientific"},t.getResultantPattern=r,t.getDependables=i,t.getSymbolPattern=o,t.ConvertDateToWeekFormat=a,t.compareBlazorDateFormats=s,t.getProperNumericSkeleton=p,t.getFormatData=h,t.changeCurrencySymbol=d,t.getCurrencySymbol=f,t.customFormat=function(e,t,r){for(var n={},i=e.split(";"),o=["pData","nData","zeroData"],a=0;a<i.length;a++)n[o[a]]=g(i[a],t,r);return l(n.nData)&&(n.nData=c({},n.pData),n.nData.nlead=l(t)?"-"+n.nData.nlead:t.minusSymbol+n.nData.nlead),n},t.customNumberFormat=g,t.isCurrencyPercent=y,t.getDateSeparator=function(e){var t=(n("dateFormats.short",e)||"").match(/[d‏M‏]([^d‏M])[d‏M‏]/i);return t?t[1]:"/"},t.getActualDateTimeFormat=function(e,t,o,a){var c=i(o,e,t.calendar);m()&&(t=s(t,e));var l=t.format||r(t.skeleton,c.dateObject,t.type);if(a){if(-1!==(l=l.replace(E,function(e){return P[e]})).indexOf("z")){var u=l.match(/z/g).length,p=void 0,h={timeZone:{}};h.numMapper=oe.getNumberMapper(c.parserObject,oe.getNumberingSystem(o)),h.timeZone=n("dates.timeZoneNames",c.parserObject);var d=(new Date).getTimezoneOffset(),f=u<4?"+H;-H":h.timeZone.hourFormat;f=f.replace(/:/g,h.numMapper.timeSeparator),0===d?p=h.timeZone.gmtZeroFormat:(p=pe.getTimeZoneValue(d,f),p=h.timeZone.gmtFormat.replace(/\{0\}/,p)),l=l.replace(/[z]+/,'"'+p+'"')}l=l.replace(/ $/,"")}return l},t.getActualNumberFormat=function(r,a,s,l){var u,d=i(s,r,"",!0),g={custom:!0},y=d.numericObject,D={},w=(a.format||"").match(t.currencyFormatRegex),E=t.formatRegex.test(a.format)?p(a.format||"N"):{},P={};if(w){P.numberMapper=m()?c({},d.numericObject):oe.getNumberMapper(d.parserObject,oe.getNumberingSystem(s),!0);var S=m()?n("currencySymbol",d.numericObject):f(d.numericObject,a.currency||e.defaultCurrencyCode,a.altSymbol),O=o("currency",P.numberMapper.numberSystem,d.numericObject,/a/i.test(a.format)),C=(O=O.replace(/\u00A4/g,S)).split(";");D.hasNegativePattern=!!m()||C.length>1,D.nData=m()?n(E.type+"nData",y):h(C[1]||"-"+C[0],!0,S),D.pData=m()?n(E.type+"pData",y):h(C[0],!1,S),w[2]||a.minimumFractionDigits||a.maximumFractionDigits||(u=h(O.split(";")[0],!0,"",!0).minimumFraction)}var T;if(t.formatRegex.test(a.format)||!a.format){if(c(g,p(a.format||"N")),g.custom=!1,T="###0",(g.fractionDigits||a.minimumFractionDigits||a.maximumFractionDigits||u)&&(g.fractionDigits&&(a.minimumFractionDigits=a.maximumFractionDigits=g.fractionDigits),T=v(T,u||g.fractionDigits||a.minimumFractionDigits||0,a.maximumFractionDigits||0)),a.minimumIntegerDigits&&(T=b(T,a.minimumIntegerDigits)),a.useGrouping&&(T=M(T)),"currency"===g.type||g.type&&m()){m()&&"currency"!==g.type&&(D.pData=n(g.type+"pData",y),D.nData=n(g.type+"nData",y));var x=T;T=D.pData.nlead+x+D.pData.nend,(D.hasNegativePattern||m())&&(T+=";"+D.nData.nlead+x+D.nData.nend)}"percent"!==g.type||m()||(T+=" %")}else T=a.format.replace(/'/g,'"');return Object.keys(P).length>0&&(T=l?T:function(e,t){if(-1!==e.indexOf(",")){var r=e.split(",");e=r[0]+n("numberMapper.numberSymbols.group",t)+r[1].replace(".",n("numberMapper.numberSymbols.decimal",t))}else e=e.replace(".",n("numberMapper.numberSymbols.decimal",t));return e}(T,P)),T},t.fractionDigitsPattern=v,t.minimumIntegerPattern=b,t.groupingPattern=M,t.getWeekData=function(e,t){var r=S,i=n("supplemental.weekData.firstDay",t),o=e;return/en-/.test(o)&&(o=o.slice(3)),o=o.slice(0,2).toUpperCase()+o.substr(2),i&&(r=i[o]||i[o.slice(0,2)]||S),O[r]},t.replaceBlazorCurrency=function(e,t,r){var i=function(e){return n(e||"",ae)}(r);if(t!==i)for(var o=0,a=e;o<a.length;o++){var s=a[o];s.nend=s.nend.replace(t,i),s.nlead=s.nlead.replace(t,i)}},t.getWeekOfYear=function(e){var t,r=new Date(e.getFullYear(),0,1),n=r.getDay();n=n>=0?n:n+7;var i=Math.floor((e.getTime()-r.getTime()-6e4*(e.getTimezoneOffset()-r.getTimezoneOffset()))/864e5)+1;if(n<4){if((t=Math.floor((i+n-1)/7)+1)>52){var o=new Date(e.getFullYear()+1,0,1).getDay();t=(o=o>=0?o:o+7)<4?1:53}}else t=Math.floor((i+n-1)/7);return t}}(e.IntlBase||(e.IntlBase={}));var Te=/^(.*?):[ \t]*([^\r\n]*)$/gm,xe="GET",je=function(){function e(e,t,r,n){this.mode=!0,this.emitError=!0,this.options={},"string"==typeof e?(this.url=e,this.type=t?t.toUpperCase():xe,this.mode=!!l(r)||r):"object"==typeof e&&(this.options=e,s(this,this.options)),this.type=this.type?this.type.toUpperCase():xe,this.contentType=void 0!==this.contentType?this.contentType:n}return e.prototype.send=function(e){var t=this;this.data=l(e)?this.data:e;var r={cancel:!1,httpRequest:null};return new Promise(function(e,n){t.httpRequest=new XMLHttpRequest,t.httpRequest.onreadystatechange=function(){t.stateChange(e,n)},l(t.onLoad)||(t.httpRequest.onload=t.onLoad),l(t.onProgress)||(t.httpRequest.onprogress=t.onProgress),l(t.onAbort)||(t.httpRequest.onabort=t.onAbort),l(t.onError)||(t.httpRequest.onerror=t.onError),l(t.onUploadProgress)||(t.httpRequest.upload.onprogress=t.onUploadProgress),t.httpRequest.open(t.type,t.url,t.mode),l(t.data)||null===t.contentType||t.httpRequest.setRequestHeader("Content-Type",t.contentType||"application/json; charset=utf-8"),t.beforeSend&&(r.httpRequest=t.httpRequest,t.beforeSend(r)),r.cancel||t.httpRequest.send(l(t.data)?null:t.data)})},e.prototype.successHandler=function(e){return this.onSuccess&&this.onSuccess(e,this),e},e.prototype.failureHandler=function(e){return this.onFailure&&this.onFailure(this.httpRequest),e},e.prototype.stateChange=function(e,t){var r=this.httpRequest.responseText;if(this.dataType&&"json"===this.dataType.toLowerCase())if(""===r)r=void 0;else try{r=JSON.parse(r)}catch(e){}4===this.httpRequest.readyState&&(this.httpRequest.status>=200&&this.httpRequest.status<=299||304===this.httpRequest.status?e(this.successHandler(r)):this.emitError?t(new Error(this.failureHandler(this.httpRequest.statusText))):e())},e.prototype.getResponseHeader=function(e){var t,r;t={};for(var n=Te.exec(this.httpRequest.getAllResponseHeaders());n;)t[n[1].toLowerCase()]=n[2],n=Te.exec(this.httpRequest.getAllResponseHeaders());return r=t[e.toLowerCase()],l(r)?null:r},e}(),Ne=/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i,Fe=/msie|trident/i,Re=/Trident\/7\./,Ae=/(ipad|iphone|ipod touch)/i,Ie=/(ipad|iphone|ipod touch);.*os 7_\d|(ipad|iphone|ipod touch);.*os 8_\d/i,ke=/android/i,He=/trident|windows phone|edge/i,Le=/(version)[ /]([\w.]+)/i,Be={OPERA:/(opera|opr)(?:.*version|)[ /]([\w.]+)/i,EDGE:/(edge)(?:.*version|)[ /]([\w.]+)/i,CHROME:/(chrome|crios)[ /]([\w.]+)/i,PANTHOMEJS:/(phantomjs)[ /]([\w.]+)/i,SAFARI:/(safari)[ /]([\w.]+)/i,WEBKIT:/(webkit)[ /]([\w.]+)/i,MSIE:/(msie|trident) ([\w.]+)/i,MOZILLA:/(mozilla)(?:.*? rv:([\w.]+)|)/i};"undefined"!=typeof window&&(window.browserDetails=window.browserDetails||{});var Ge=function(){function e(){}return e.extractBrowserDetail=function(){for(var t={culture:{}},r=[],n=0,i=Object.keys(Be);n<i.length;n++){var o=i[n];if(r=e.userAgent.match(Be[o])){if(t.name="opr"===r[1].toLowerCase()?"opera":r[1].toLowerCase(),t.name="crios"===r[1].toLowerCase()?"chrome":t.name,t.version=r[2],t.culture.name=t.culture.language=navigator.language,e.userAgent.match(Re)){t.name="msie";break}var a=e.userAgent.match(Le);"safari"===t.name&&a&&(t.version=a[2]);break}}return t},e.getEvent=function(t){var r={start:{isPointer:"pointerdown",isTouch:"touchstart",isDevice:"mousedown"},move:{isPointer:"pointermove",isTouch:"touchmove",isDevice:"mousemove"},end:{isPointer:"pointerup",isTouch:"touchend",isDevice:"mouseup"},cancel:{isPointer:"pointercancel",isTouch:"touchcancel",isDevice:"mouseleave"}};return e.isPointer?r[t].isPointer:e.isTouch?r[t].isTouch+(e.isDevice?"":" "+r[t].isDevice):r[t].isDevice},e.getTouchStartEvent=function(){return e.getEvent("start")},e.getTouchEndEvent=function(){return e.getEvent("end")},e.getTouchMoveEvent=function(){return e.getEvent("move")},e.getTouchCancelEvent=function(){return e.getEvent("cancel")},e.getValue=function(t,r){var n=window.browserDetails;return void 0===n[t]?n[t]=r.test(e.userAgent):("MacIntel"===navigator.platform&&navigator.maxTouchPoints>1&&!0===e.isTouch&&(n.isIos=!0,n.isDevice=!0,n.isTouch=!0,n.isPointer=!0),n[t])},Object.defineProperty(e,"userAgent",{get:function(){return e.uA},set:function(t){e.uA=t,window.browserDetails={}},enumerable:!0,configurable:!0}),Object.defineProperty(e,"info",{get:function(){return u(window.browserDetails.info)?window.browserDetails.info=e.extractBrowserDetail():window.browserDetails.info},enumerable:!0,configurable:!0}),Object.defineProperty(e,"isIE",{get:function(){return e.getValue("isIE",Fe)},enumerable:!0,configurable:!0}),Object.defineProperty(e,"isTouch",{get:function(){return u(window.browserDetails.isTouch)?window.browserDetails.isTouch="ontouchstart"in window.navigator||window&&window.navigator&&window.navigator.maxTouchPoints>0||"ontouchstart"in window:window.browserDetails.isTouch},enumerable:!0,configurable:!0}),Object.defineProperty(e,"isPointer",{get:function(){return u(window.browserDetails.isPointer)?window.browserDetails.isPointer="pointerEnabled"in window.navigator:window.browserDetails.isPointer},enumerable:!0,configurable:!0}),Object.defineProperty(e,"isMSPointer",{get:function(){return u(window.browserDetails.isMSPointer)?window.browserDetails.isMSPointer="msPointerEnabled"in window.navigator:window.browserDetails.isMSPointer},enumerable:!0,configurable:!0}),Object.defineProperty(e,"isDevice",{get:function(){return e.getValue("isDevice",Ne)},enumerable:!0,configurable:!0}),Object.defineProperty(e,"isIos",{get:function(){return e.getValue("isIos",Ae)},enumerable:!0,configurable:!0}),Object.defineProperty(e,"isIos7",{get:function(){return e.getValue("isIos7",Ie)},enumerable:!0,configurable:!0}),Object.defineProperty(e,"isAndroid",{get:function(){return e.getValue("isAndroid",ke)},enumerable:!0,configurable:!0}),Object.defineProperty(e,"isWebView",{get:function(){return u(window.browserDetails.isWebView)?(window.browserDetails.isWebView=!(u(window.cordova)&&u(window.PhoneGap)&&u(window.phonegap)&&"object"!==window.forge),window.browserDetails.isWebView):window.browserDetails.isWebView},enumerable:!0,configurable:!0}),Object.defineProperty(e,"isWindows",{get:function(){return e.getValue("isWindows",He)},enumerable:!0,configurable:!0}),Object.defineProperty(e,"touchStartEvent",{get:function(){return u(window.browserDetails.touchStartEvent)?window.browserDetails.touchStartEvent=e.getTouchStartEvent():window.browserDetails.touchStartEvent},enumerable:!0,configurable:!0}),Object.defineProperty(e,"touchMoveEvent",{get:function(){return u(window.browserDetails.touchMoveEvent)?window.browserDetails.touchMoveEvent=e.getTouchMoveEvent():window.browserDetails.touchMoveEvent},enumerable:!0,configurable:!0}),Object.defineProperty(e,"touchEndEvent",{get:function(){return u(window.browserDetails.touchEndEvent)?window.browserDetails.touchEndEvent=e.getTouchEndEvent():window.browserDetails.touchEndEvent},enumerable:!0,configurable:!0}),Object.defineProperty(e,"touchCancelEvent",{get:function(){return u(window.browserDetails.touchCancelEvent)?window.browserDetails.touchCancelEvent=e.getTouchCancelEvent():window.browserDetails.touchCancelEvent},enumerable:!0,configurable:!0}),e.uA="undefined"!=typeof navigator?navigator.userAgent:"",e}(),Ye=function(){function e(){}return e.addOrGetEventData=function(e){return"__eventList"in e?e.__eventList.events:(e.__eventList={},e.__eventList.events=[])},e.add=function(t,r,n,i,o){var a,s=e.addOrGetEventData(t);a=o?p(n,o):n,i&&(a=a.bind(i));for(var c=r.split(" "),l=0;l<c.length;l++)s.push({name:c[l],listener:n,debounce:a}),Ge.isIE?t.addEventListener(c[l],a):t.addEventListener(c[l],a,{passive:!1});return a},e.remove=function(t,r,n){for(var i=e.addOrGetEventData(t),o=r.split(" "),a=function(e){var r,a=-1;i&&0!==i.length&&i.some(function(t,i){return t.name===o[e]&&t.listener===n&&(a=i,r=t.debounce,!0)}),-1!==a&&i.splice(a,1),r&&t.removeEventListener(o[e],r)},s=0;s<o.length;s++)a(s)},e.clearEvents=function(t){var r,n;n=c([],n,r=e.addOrGetEventData(t));for(var i=0;i<n.length;i++)t.removeEventListener(n[i].name,n[i].debounce),r.shift()},e.trigger=function(t,r,n){for(var i=0,o=e.addOrGetEventData(t);i<o.length;i++){var a=o[i];a.name===r&&a.debounce.call(this,n)}},e}(),ze=/^svg|^path|^g/,Xe=new RegExp("]"),_e=function(){function e(e,t){this.isRendered=!1,this.isComplexArraySetter=!1,this.isServerRendered=!1,this.allowServerDataBinding=!0,this.isProtectedOnChange=!0,this.properties={},this.changedProperties={},this.oldProperties={},this.bulkChanges={},this.refreshing=!1,this.ignoreCollectionWatch=!1,this.finalUpdate=function(){},this.childChangedProperties={},this.modelObserver=new we(this),u(t)||(this.element="string"==typeof t?document.querySelector(t):t,l(this.element)||(this.isProtectedOnChange=!1,this.addInstance())),u(e)||this.setProperties(e,!0),this.isDestroyed=!1}return e.prototype.setProperties=function(e,t){var r=this.isProtectedOnChange;this.isProtectedOnChange=!!t,s(this,e),!0!==t?(s(this.changedProperties,e),this.dataBind()):m()&&this.isRendered&&this.serverDataBind(e),this.finalUpdate(),this.changedProperties={},this.oldProperties={},this.isProtectedOnChange=r},e.callChildDataBind=function(e,t){for(var r=0,n=Object.keys(e);r<n.length;r++){var i=n[r];if(t[i]instanceof Array)for(var o=0,a=t[i];o<a.length;o++){var s=a[o];void 0!==s.dataBind&&s.dataBind()}else t[i].dataBind()}},e.prototype.clearChanges=function(){this.finalUpdate(),this.changedProperties={},this.oldProperties={},this.childChangedProperties={}},e.prototype.dataBind=function(){if(e.callChildDataBind(this.childChangedProperties,this),Object.getOwnPropertyNames(this.changedProperties).length){var t=this.isProtectedOnChange,r=this.changedProperties,n=this.oldProperties;this.clearChanges(),this.isProtectedOnChange=!0,this.onPropertyChanged(r,n),this.isProtectedOnChange=t}},e.prototype.serverDataBind=function(e){if(m()){e=e||{},c(this.bulkChanges,{},e,!0);this.allowServerDataBinding&&window.sfBlazor.updateModel&&(window.sfBlazor.updateModel(this),this.bulkChanges={})}},e.prototype.saveChanges=function(e,t,n){if(m()){var i={};i[e]=t,this.serverDataBind(i)}this.isProtectedOnChange||(this.oldProperties[e]=n,this.changedProperties[e]=t,this.finalUpdate(),this.finalUpdate=r(this.dataBind.bind(this)))},e.prototype.addEventListener=function(e,t){this.modelObserver.on(e,t)},e.prototype.removeEventListener=function(e,t){this.modelObserver.off(e,t)},e.prototype.trigger=function(e,t,r,i){var o=this;if(!0!==this.isDestroyed){var a=this.isProtectedOnChange;this.isProtectedOnChange=!1;var s=this.modelObserver.notify(e,t,r,i);if(Xe.test(e)){var c=n(e,this);if(c){if(window.Blazor){var l=c.call(this,t);l&&"function"==typeof l.then?r?l.then(function(e){r&&(e="string"==typeof e&&o.modelObserver.isJson(e)?JSON.parse(e):e,r.call(o,e))}).catch(function(e){i&&(e="string"==typeof e&&o.modelObserver.isJson(e)?JSON.parse(e):e,i.call(o,e))}):s=l:r&&r.call(this,t)}else c.call(this,t),r&&r.call(this,t)}else r&&r.call(this,t)}return this.isProtectedOnChange=a,s}},e.prototype.addInstance=function(){var e="e-"+this.getModuleName().toLowerCase();y([this.element],["e-lib",e]),l(this.element.ej2_instances)?i("ej2_instances",[this],this.element):this.element.ej2_instances.push(this)},e.prototype.destroy=function(){var e=this;this.element.ej2_instances=this.element.ej2_instances.filter(function(t){return t!==e}),v([this.element],["e-"+this.getModuleName()]),0===this.element.ej2_instances.length&&v([this.element],["e-lib"]),this.clearChanges(),this.modelObserver.destroy(),this.isDestroyed=!0},e}(),We=function(){var e=function(t,r){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])})(t,r)};return function(t,r){function n(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),$e=function(e,t,r,n){var i,o=arguments.length,a=o<3?t:null===n?n=Object.getOwnPropertyDescriptor(t,r):n;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)a=Reflect.decorate(e,t,r,n);else for(var s=e.length-1;s>=0;s--)(i=e[s])&&(a=(o<3?i(a):o>3?i(t,r,a):i(t,r))||a);return o>3&&a&&Object.defineProperty(t,r,a),a},Ve=function(e){function t(t){var r=e.call(this,t,void 0)||this;return r.easing={ease:"cubic-bezier(0.250, 0.100, 0.250, 1.000)",linear:"cubic-bezier(0.250, 0.250, 0.750, 0.750)",easeIn:"cubic-bezier(0.420, 0.000, 1.000, 1.000)",easeOut:"cubic-bezier(0.000, 0.000, 0.580, 1.000)",easeInOut:"cubic-bezier(0.420, 0.000, 0.580, 1.000)",elasticInOut:"cubic-bezier(0.5,-0.58,0.38,1.81)",elasticIn:"cubic-bezier(0.17,0.67,0.59,1.81)",elasticOut:"cubic-bezier(0.7,-0.75,0.99,1.01)"},r}We(t,e),r=t,t.prototype.animate=function(e,t){t=t||{};var n=this.getModel(t);if("string"==typeof e)for(var i=0,o=Array.prototype.slice.call(S(e,document));i<o.length;i++){var a=o[i];n.element=a,r.delayAnimation(n)}else n.element=e,r.delayAnimation(n)},t.stop=function(e,t){e.style.animation="",e.removeAttribute("e-animate");var r=e.getAttribute("e-animation-id");if(r){var n=parseInt(r,10);cancelAnimationFrame(n),e.removeAttribute("e-animation-id")}t&&t.end&&t.end.call(this,t)},t.delayAnimation=function(e){e.delay?setTimeout(function(){r.applyAnimation(e)},e.delay):r.applyAnimation(e)},t.applyAnimation=function(e){var t=this;e.timeStamp=0;var r=0,n=0,i=0,o=e.duration;e.element.setAttribute("e-animate","true");var a=function(s){try{if(s){i=0===i?s:i,e.timeStamp=s+e.timeStamp-i,i=s,!r&&e.begin&&e.begin.call(t,e),r+=1;var c=e.timeStamp/r;e.timeStamp<o&&e.timeStamp+c<o&&e.element.getAttribute("e-animate")?(e.element.style.animation=e.name+" "+e.duration+"ms "+e.timingFunction,e.progress&&e.progress.call(t,e),requestAnimationFrame(a)):(cancelAnimationFrame(n),e.element.removeAttribute("e-animation-id"),e.element.removeAttribute("e-animate"),e.element.style.animation="",e.end&&e.end.call(t,e))}else n=requestAnimationFrame(a),e.element.setAttribute("e-animation-id",n.toString())}catch(r){cancelAnimationFrame(n),e.element.removeAttribute("e-animation-id"),e.fail&&e.fail.call(t,r)}};a()},t.prototype.getModel=function(e){return{name:e.name||this.name,delay:e.delay||this.delay,duration:void 0!==e.duration?e.duration:this.duration,begin:e.begin||this.begin,end:e.end||this.end,fail:e.fail||this.fail,progress:e.progress||this.progress,timingFunction:this.easing[e.timingFunction]?this.easing[e.timingFunction]:e.timingFunction||this.easing[this.timingFunction]}},t.prototype.onPropertyChanged=function(e,t){},t.prototype.getModuleName=function(){return"animation"},t.prototype.destroy=function(){};var r;return $e([k("FadeIn")],t.prototype,"name",void 0),$e([k(400)],t.prototype,"duration",void 0),$e([k("ease")],t.prototype,"timingFunction",void 0),$e([k(0)],t.prototype,"delay",void 0),$e([L()],t.prototype,"progress",void 0),$e([L()],t.prototype,"begin",void 0),$e([L()],t.prototype,"end",void 0),$e([L()],t.prototype,"fail",void 0),t=r=$e([B],t)}(_e);e.isRippleEnabled=!1;var Ue,Ke=function(){function e(e){this.loadedModules=[],this.parent=e}return e.prototype.inject=function(e,r){var n=e.length;if(0!==n){this.loadedModules.length&&this.clearUnusedModule(e);for(var o=0;o<n;o++)for(var a=e[o],s=0,c=r;s<c.length;s++){var l=c[s],u=a.member;if(l.prototype.getModuleName()===a.member&&!this.isModuleLoaded(u)){var p=t(l,a.args),h=this.getMemberName(u);a.isProperty?i(h,l,this.parent):i(h,p,this.parent);var d=a;d.member=h,this.loadedModules.push(d)}}}else this.clean()},e.prototype.clean=function(){for(var e=0,t=this.loadedModules;e<t.length;e++){var r=t[e];r.isProperty||n(r.member,this.parent).destroy()}this.loadedModules=[]},e.prototype.clearUnusedModule=function(e){for(var t=this,r=e.map(function(e){return t.getMemberName(e.member)}),i=0,a=this.loadedModules.filter(function(e){return-1===r.indexOf(e.member)});i<a.length;i++){var s=a[i];s.isProperty||n(s.member,this.parent).destroy(),this.loadedModules.splice(this.loadedModules.indexOf(s),1),o(this.parent,s.member)}},e.prototype.getMemberName=function(e){return e[0].toLowerCase()+e.substring(1)+"Module"},e.prototype.isModuleLoaded=function(e){for(var t=0,r=this.loadedModules;t<r.length;t++){if(r[t].member===this.getMemberName(e))return!0}return!1},e}(),qe=function(){function e(e,t,r,i){this.isComplexArraySetter=!1,this.properties={},this.changedProperties={},this.childChangedProperties={},this.oldProperties={},this.finalUpdate=function(){},this.callChildDataBind=n("callChildDataBind",_e),this.parentObj=e,this.controlParent=this.parentObj.controlParent||this.parentObj,this.propName=t,this.isParentArray=i,this.setProperties(r,!0)}return e.prototype.updateChange=function(e,t){!0===e?this.parentObj.childChangedProperties[t]=e:delete this.parentObj.childChangedProperties[t],this.parentObj.updateChange&&this.parentObj.updateChange(e,this.parentObj.propName)},e.prototype.updateTimeOut=function(){if(this.parentObj.updateTimeOut)this.parentObj.finalUpdate(),this.parentObj.updateTimeOut();else{var e=setTimeout(this.parentObj.dataBind.bind(this.parentObj));this.finalUpdate=function(){clearTimeout(e)}}},e.prototype.clearChanges=function(){this.finalUpdate(),this.updateChange(!1,this.propName),this.oldProperties={},this.changedProperties={}},e.prototype.setProperties=function(e,t){!0===t?(s(this,e),this.updateChange(!1,this.propName),this.clearChanges()):s(this,e)},e.prototype.dataBind=function(){if(this.callChildDataBind(this.childChangedProperties,this),this.isParentArray){var e=this.parentObj[this.propName].indexOf(this);Object.keys(this.changedProperties).length&&(i(this.propName+"."+e,this.changedProperties,this.parentObj.changedProperties),i(this.propName+"."+e,this.oldProperties,this.parentObj.oldProperties))}else this.parentObj.changedProperties[this.propName]=this.changedProperties,this.parentObj.oldProperties[this.propName]=this.oldProperties;this.clearChanges()},e.prototype.saveChanges=function(e,t,r,n){this.controlParent.isProtectedOnChange||(n||this.serverDataBind(e,t,!0),this.oldProperties[e]=r,this.changedProperties[e]=t,this.updateChange(!0,this.propName),this.finalUpdate(),this.updateTimeOut())},e.prototype.serverDataBind=function(e,t,r,n){if(m()&&!this.parentObj.isComplexArraySetter){var i,o={},a=r?this.getParentKey(!0)+"."+e:e;if(-1!==a.indexOf(".")){var s=a.split(".");i=o;for(var c=0;c<s.length;c++){var l=c===s.length-1;i[s[c]]=l?t:{},i=l?i:i[s[c]]}}else o[a]={},i=o[a],o[a][e]=t;if(this.isParentArray){i.ejsAction=n||"none"}this.controlParent.serverDataBind(o)}},e.prototype.getParentKey=function(e){var t="",r=this.propName;if(this.isParentArray){t=this.parentObj[this.propName].indexOf(this);var n=this.parentObj[this.propName].length;n=e?n:n>0?n-1:0,r+=t=-1!==t?"-"+t:"-"+n}return this.controlParent!==this.parentObj&&(r=this.parentObj.getParentKey()+"."+this.propName+t),r},e}(),Ze=function(){var e=function(t,r){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])})(t,r)};return function(t,r){function n(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),Je=function(e,t,r,n){var i,o=arguments.length,a=o<3?t:null===n?n=Object.getOwnPropertyDescriptor(t,r):n;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)a=Reflect.decorate(e,t,r,n);else for(var s=e.length-1;s>=0;s--)(i=e[s])&&(a=(o<3?i(a):o>3?i(t,r,a):i(t,r))||a);return o>3&&a&&Object.defineProperty(t,r,a),a},Qe=0,et=0;e.versionBasedStatePersistence=!1;var tt=function(t){function r(r,n){var i=t.call(this,r,n)||this;return i.randomId=f(),i.isStringTemplate=!1,i.needsID=!1,i.isReactHybrid=!1,l(i.enableRtl)&&i.setProperties({enableRtl:e.rightToLeft},!0),l(i.locale)&&i.setProperties({locale:e.defaultCulture},!0),i.moduleLoader=new Ke(i),i.localObserver=new we(i),Ee.on("notifyExternalChange",i.detectFunction,i,i.randomId),u(n)||i.appendTo(),i}return Ze(r,t),r.prototype.requiredModules=function(){return[]},r.prototype.destroy=function(){this.isDestroyed||(this.enablePersistence&&this.setPersistData(),this.localObserver.destroy(),this.refreshing||(v([this.element],["e-control"]),this.trigger("destroyed",{cancel:!1}),t.prototype.destroy.call(this),this.moduleLoader.clean(),Ee.off("notifyExternalChange",this.detectFunction,this.randomId)))},r.prototype.refresh=function(){this.refreshing=!0,this.moduleLoader.clean(),this.destroy(),this.clearChanges(),this.localObserver=new we(this),this.preRender(),this.injectModules(),this.render(),this.refreshing=!1},r.prototype.accessMount=function(){this.mount&&!this.isReactHybrid&&this.mount()},r.prototype.getRootElement=function(){return this.isReactHybrid?this.actualElement:this.element},r.prototype.getLocalData=function(){var t=this.getModuleName()+this.element.id;return e.versionBasedStatePersistence?window.localStorage.getItem(t+this.ej2StatePersistenceVersion):window.localStorage.getItem(t)},r.prototype.appendTo=function(e){if(l(e)||"string"!=typeof e?l(e)||(this.element=e):this.element=P(e,document),!l(this.element)){var r="e-"+this.getModuleName().toLowerCase();y([this.element],["e-control",r]),this.isProtectedOnChange=!1,this.needsID&&!this.element.id&&(this.element.id=this.getUniqueID(this.getModuleName())),this.enablePersistence&&(this.mergePersistData(),window.addEventListener("unload",this.setPersistData.bind(this)));var i=n("ej2_instances",this.element);i&&-1!==i.indexOf(this)||t.prototype.addInstance.call(this),this.preRender(),this.injectModules(),this.render(),this.mount?this.accessMount():this.trigger("created")}},r.prototype.renderComplete=function(e){if(m()){window.sfBlazor.renderComplete(this.element,e)}this.isRendered=!0},r.prototype.dataBind=function(){this.injectModules(),t.prototype.dataBind.call(this)},r.prototype.on=function(e,t,r){if("string"==typeof e)this.localObserver.on(e,t,r);else for(var n=0,i=e;n<i.length;n++){var o=i[n];this.localObserver.on(o.event,o.handler,o.context)}},r.prototype.off=function(e,t){if("string"==typeof e)this.localObserver.off(e,t);else for(var r=0,n=e;r<n.length;r++){var i=n[r];this.localObserver.off(i.event,i.handler)}},r.prototype.notify=function(e,t){!0!==this.isDestroyed&&this.localObserver.notify(e,t)},r.prototype.getInjectedModules=function(){return this.injectedModules},r.Inject=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];this.prototype.injectedModules||(this.prototype.injectedModules=[]);for(var r=0;r<e.length;r++)-1===this.prototype.injectedModules.indexOf(e[r])&&this.prototype.injectedModules.push(e[r])},r.prototype.createElement=function(e,t,r){return g(e,t)},r.prototype.triggerStateChange=function(e,t){this.isReactHybrid&&(this.setState(),this.currentContext={calls:e,args:t})},r.prototype.injectModules=function(){this.injectedModules&&this.injectedModules.length&&this.moduleLoader.inject(this.requiredModules(),this.injectedModules)},r.prototype.detectFunction=function(e){var t=Object.keys(e);t.length&&(this[t[0]]=e[t[0]])},r.prototype.mergePersistData=function(){var t;l(t=e.versionBasedStatePersistence?window.localStorage.getItem(this.getModuleName()+this.element.id+this.ej2StatePersistenceVersion):window.localStorage.getItem(this.getModuleName()+this.element.id))||""===t||this.setProperties(JSON.parse(t),!0)},r.prototype.setPersistData=function(){this.isDestroyed||(e.versionBasedStatePersistence?window.localStorage.setItem(this.getModuleName()+this.element.id+this.ej2StatePersistenceVersion,this.getPersistData()):window.localStorage.setItem(this.getModuleName()+this.element.id,this.getPersistData()))},r.prototype.appendReactElement=function(e,t){},r.prototype.renderReactTemplates=function(){},r.prototype.clearTemplate=function(e,t){},r.prototype.getUniqueID=function(e){return this.isHistoryChanged()&&(Qe=0),Ue=this.pageID(location.href),et=history.length,e+"_"+Ue+"_"+Qe++},r.prototype.pageID=function(e){var t=0;if(0===e.length)return t;for(var r=0;r<e.length;r++){t=(t<<5)-t+e.charCodeAt(r),t&=t}return Math.abs(t)},r.prototype.isHistoryChanged=function(){return Ue!==this.pageID(location.href)||et!==history.length},r.prototype.addOnPersist=function(e){for(var t=this,r={},o=0,a=e;o<a.length;o++){var s=a[o],c=void 0;u(c=n(s,this))||i(s,this.getActualProperties(c),r)}return JSON.stringify(r,function(e,r){return t.getActualProperties(r)})},r.prototype.getActualProperties=function(e){return e instanceof qe?n("properties",e):e},r.prototype.ignoreOnPersist=function(e){return JSON.stringify(this.iterateJsonProperties(this.properties,e))},r.prototype.iterateJsonProperties=function(e,t){for(var r={},n=function(n){if(-1===t.indexOf(n)){var o=e[n];if("object"!=typeof o||o instanceof Array)r[n]=o;else{var a=t.filter(function(e){return new RegExp(n+".").test(e)}).map(function(e){return e.replace(n+".","")});r[n]=i.iterateJsonProperties(i.getActualProperties(o),a)}}},i=this,o=0,a=Object.keys(e);o<a.length;o++){n(a[o])}return r},Je([k(!1)],r.prototype,"enablePersistence",void 0),Je([k()],r.prototype,"enableRtl",void 0),Je([k()],r.prototype,"locale",void 0),r=Je([B],r)}(_e);"undefined"!=typeof window&&window.addEventListener("popstate",function(){Qe=0});var rt=function(){var e=function(t,r){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])})(t,r)};return function(t,r){function n(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),nt=function(e,t,r,n){var i,o=arguments.length,a=o<3?t:null===n?n=Object.getOwnPropertyDescriptor(t,r):n;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)a=Reflect.decorate(e,t,r,n);else for(var s=e.length-1;s>=0;s--)(i=e[s])&&(a=(o<3?i(a):o>3?i(t,r,a):i(t,r))||a);return o>3&&a&&Object.defineProperty(t,r,a),a},it={left:0,top:0,bottom:0,right:0},ot={isDragged:!1},at=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return rt(t,e),nt([k(0)],t.prototype,"left",void 0),nt([k(0)],t.prototype,"top",void 0),t}(qe),st=function(e){function t(t,n){var i=e.call(this,n,t)||this;return i.dragLimit=r.getDefaultPosition(),i.borderWidth=r.getDefaultPosition(),i.padding=r.getDefaultPosition(),i.diffX=0,i.prevLeft=0,i.prevTop=0,i.dragProcessStarted=!1,i.eleTop=0,i.tapHoldTimer=0,i.externalInitialize=!1,i.diffY=0,i.parentScrollX=0,i.parentScrollY=0,i.droppables={},i.bind(),i}rt(t,e),r=t,t.prototype.bind=function(){this.toggleEvents(),Ge.isIE&&y([this.element],"e-block-touch"),this.droppables[this.scope]={}},t.getDefaultPosition=function(){return c({},it)},t.prototype.toggleEvents=function(e){var t;u(this.handle)||(t=P(this.handle,this.element));var r=this.enableTapHold&&Ge.isDevice&&Ge.isTouch?this.mobileInitialize:this.initialize;e?Ye.remove(t||this.element,Ge.touchStartEvent,r):Ye.add(t||this.element,Ge.touchStartEvent,r,this)},t.prototype.mobileInitialize=function(e){var t=this,r=e.currentTarget;this.tapHoldTimer=setTimeout(function(){t.externalInitialize=!0,t.removeTapholdTimer(),t.initialize(e,r)},this.tapHoldThreshold),Ye.add(document,Ge.touchMoveEvent,this.removeTapholdTimer,this),Ye.add(document,Ge.touchEndEvent,this.removeTapholdTimer,this)},t.prototype.removeTapholdTimer=function(){clearTimeout(this.tapHoldTimer),Ye.remove(document,Ge.touchMoveEvent,this.removeTapholdTimer),Ye.remove(document,Ge.touchEndEvent,this.removeTapholdTimer)},t.prototype.getScrollableParent=function(e,t){return l(e)?null:e[{vertical:"scrollHeight",horizontal:"scrollWidth"}[t]]>e[{vertical:"clientHeight",horizontal:"clientWidth"}[t]]&&("vertical"===t?e.scrollTop>0:e.scrollLeft>0)?("vertical"===t?(this.parentScrollY=this.parentScrollY+(0===this.parentScrollY?e.scrollTop:e.scrollTop-this.parentScrollY),this.tempScrollHeight=e.scrollHeight):(this.parentScrollX=this.parentScrollX+(0===this.parentScrollX?e.scrollLeft:e.scrollLeft-this.parentScrollX),this.tempScrollWidth=e.scrollWidth),l(e)?e:this.getScrollableParent(e.parentNode,t)):this.getScrollableParent(e.parentNode,t)},t.prototype.getScrollableValues=function(){this.parentScrollX=0,this.parentScrollY=0;this.element.classList.contains("e-dialog")&&this.element.classList.contains("e-dlg-modal"),this.getScrollableParent(this.element.parentNode,"vertical"),this.getScrollableParent(this.element.parentNode,"horizontal")},t.prototype.initialize=function(e,t){if(this.currentStateTarget=e.target,!this.isDragStarted()){if(this.isDragStarted(!0),this.externalInitialize=!1,this.target=e.currentTarget||t,this.dragProcessStarted=!1,this.abort){var r=this.abort;"string"==typeof r&&(r=[r]);for(var n=0;n<r.length;n++)if(!l(C(e.target,r[n])))return void(this.isDragStarted()&&this.isDragStarted(!0))}this.preventDefault&&!u(e.changedTouches)&&"touchstart"!==e.type&&e.preventDefault(),this.element.setAttribute("aria-grabbed","true");var i=this.getCoordinates(e);if(this.initialPosition={x:i.pageX,y:i.pageY},!this.clone){var o=this.element.getBoundingClientRect();this.getScrollableValues(),e.clientX===e.pageX&&(this.parentScrollX=0),e.clientY===e.pageY&&(this.parentScrollY=0),this.relativeXPosition=i.pageX-(o.left+this.parentScrollX),this.relativeYPosition=i.pageY-(o.top+this.parentScrollY)}this.externalInitialize?this.intDragStart(e):(Ye.add(document,Ge.touchMoveEvent,this.intDragStart,this),Ye.add(document,Ge.touchEndEvent,this.intDestroy,this)),this.toggleEvents(!0),"touchstart"!==e.type&&this.isPreventSelect&&document.body.classList.add("e-prevent-select"),this.externalInitialize=!1,Ye.trigger(document.documentElement,Ge.touchStartEvent,e)}},t.prototype.intDragStart=function(e){this.removeTapholdTimer();var t=!u(e.changedTouches);if(!t||1===e.changedTouches.length){t&&e.preventDefault();var r,n=this.getCoordinates(e),i=getComputedStyle(this.element);this.margin={left:parseInt(i.marginLeft,10),top:parseInt(i.marginTop,10),right:parseInt(i.marginRight,10),bottom:parseInt(i.marginBottom,10)};var o=this.element;if(this.clone&&this.dragTarget){var a=C(e.target,this.dragTarget);l(a)||(o=a)}this.isReplaceDragEle&&(o=this.currentStateCheck(e.target,o)),this.offset=this.calculateParentPosition(o),this.position=this.getMousePosition(e,this.isDragScroll);var s=this.initialPosition.x-n.pageX,c=this.initialPosition.y-n.pageY;if(Math.sqrt(s*s+c*c)>=this.distance||this.externalInitialize){var p=this.getHelperElement(e);if(!p||l(p))return;var h=this.helperElement=p;if(this.parentClientRect=this.calculateParentPosition(h.offsetParent),this.dragStart){var d={event:e,element:o,target:this.getProperTargetElement(e),bindEvents:m()?this.bindDragEvents.bind(this):null,dragElement:h};this.trigger("dragStart",d)}this.dragArea?this.setDragArea():(this.dragLimit={left:0,right:0,bottom:0,top:0},this.borderWidth={top:0,left:0}),r={left:this.position.left-this.parentClientRect.left,top:this.position.top-this.parentClientRect.top},this.clone&&!this.enableTailMode&&(this.diffX=this.position.left-this.offset.left,this.diffY=this.position.top-this.offset.top),this.getScrollableValues();var f=getComputedStyle(o),g=parseFloat(f.marginTop);this.clone&&0!==g&&(r.top+=g),this.eleTop=isNaN(parseFloat(f.top))?0:parseFloat(f.top)-this.offset.top,this.enableScrollHandler&&!this.clone&&(r.top-=this.parentScrollY,r.left-=this.parentScrollX);var y=this.getProcessedPositionValue({top:r.top-this.diffY+"px",left:r.left-this.diffX+"px"});this.dragElePosition={top:r.top,left:r.left},T(h,this.getDragPosition({position:"absolute",left:y.left,top:y.top})),Ye.remove(document,Ge.touchMoveEvent,this.intDragStart),Ye.remove(document,Ge.touchEndEvent,this.intDestroy),m()||this.bindDragEvents(h)}}},t.prototype.bindDragEvents=function(e){M(e)?(Ye.add(document,Ge.touchMoveEvent,this.intDrag,this),Ye.add(document,Ge.touchEndEvent,this.intDragStop,this),this.setGlobalDroppables(!1,this.element,e)):(this.toggleEvents(),document.body.classList.remove("e-prevent-select"))},t.prototype.elementInViewport=function(e){for(this.top=e.offsetTop,this.left=e.offsetLeft,this.width=e.offsetWidth,this.height=e.offsetHeight;e.offsetParent;)e=e.offsetParent,this.top+=e.offsetTop,this.left+=e.offsetLeft;return this.top>=window.pageYOffset&&this.left>=window.pageXOffset&&this.top+this.height<=window.pageYOffset+window.innerHeight&&this.left+this.width<=window.pageXOffset+window.innerWidth},t.prototype.getProcessedPositionValue=function(e){return this.queryPositionInfo?this.queryPositionInfo(e):e},t.prototype.calculateParentPosition=function(e){if(l(e))return{left:0,top:0};var t=e.getBoundingClientRect(),r=getComputedStyle(e);return{left:t.left+window.pageXOffset-parseInt(r.marginLeft,10),top:t.top+window.pageYOffset-parseInt(r.marginTop,10)}},t.prototype.intDrag=function(e){if(u(e.changedTouches)||1===e.changedTouches.length){var t,r;this.position=this.getMousePosition(e,this.isDragScroll);var n=this.getDocumentWidthHeight("Height");n<this.position.top&&(this.position.top=n);var i=this.getDocumentWidthHeight("Width");if(i<this.position.left&&(this.position.left=i),this.drag){var o=this.getProperTargetElement(e);this.trigger("drag",{event:e,element:this.element,target:o})}var a=this.checkTargetElement(e);if(a.target&&a.instance){var s=!0;this.hoverObject&&(this.hoverObject.instance!==a.instance?this.triggerOutFunction(e,a):s=!1),s&&(a.instance.dragData[this.scope]=this.droppables[this.scope],a.instance.intOver(e,a.target),this.hoverObject=a)}else this.hoverObject&&this.triggerOutFunction(e,a);var c=this.droppables[this.scope].helper;this.parentClientRect=this.calculateParentPosition(this.helperElement.offsetParent);var p=this.parentClientRect.left,h=this.parentClientRect.top,d=this.getCoordinates(e),m=d.pageX,f=d.pageY,g=this.position.left-this.diffX,y=this.position.top-this.diffY,v=getComputedStyle(c);if(this.dragArea){if(this.pageX!==m||this.skipDistanceCheck){var b=c.offsetWidth+(parseFloat(v.marginLeft)+parseFloat(v.marginRight));t=this.dragLimit.left>g&&g>0?this.dragLimit.left:this.dragLimit.right+window.pageXOffset<g+b&&g>0?g-(g-this.dragLimit.right)+window.pageXOffset-b:g<0?this.dragLimit.left:g}if(this.pageY!==f||this.skipDistanceCheck){var M=c.offsetHeight+(parseFloat(v.marginTop)+parseFloat(v.marginBottom));r=this.dragLimit.top>y&&y>0?this.dragLimit.top:this.dragLimit.bottom+window.pageYOffset<y+M&&y>0?y-(y-this.dragLimit.bottom)+window.pageYOffset-M:y<0?this.dragLimit.top:y}}else t=g,r=y;var D=h+this.borderWidth.top,w=p+this.borderWidth.left;this.dragProcessStarted&&(l(r)&&(r=this.prevTop),l(t)&&(t=this.prevLeft));var E,P;this.dragArea?(this.dragLimit.top=this.clone?this.dragLimit.top:0,E=r-D<0?this.dragLimit.top:r-D,P=t-w<0?this.dragElePosition.left:t-w):(E=r-D,P=t-w);var S=parseFloat(getComputedStyle(this.element).marginTop);if(S>0&&(this.clone&&(E+=S,y<0&&(S+y>=0?E=S+y:E-=S),E=this.dragLimit.bottom<E?this.dragLimit.bottom:E),r-D<0))if(y+S+(c.offsetHeight-D)>=0){var O=this.dragLimit.top+y-D;O+S+D<0?E-=S+D:E=O}else E-=S+D;this.enableScrollHandler&&!this.clone&&(E-=this.parentScrollY,P-=this.parentScrollX);var C=this.getProcessedPositionValue({top:E+"px",left:P+"px"});T(c,this.getDragPosition(C)),!this.elementInViewport(c)&&this.enableAutoScroll&&this.helperElement.scrollIntoView(),this.dragProcessStarted=!0,this.prevLeft=t,this.prevTop=r,this.position.left=t,this.position.top=r,this.pageX=m,this.pageY=f}},t.prototype.triggerOutFunction=function(e,t){this.hoverObject.instance.intOut(e,t.target),this.hoverObject.instance.dragData[this.scope]=null,this.hoverObject=null},t.prototype.getDragPosition=function(e){var t=c({},e);return this.axis&&("x"===this.axis?delete t.top:"y"===this.axis&&delete t.left),t},t.prototype.getDocumentWidthHeight=function(e){var t=document.body,r=document.documentElement;return Math.max(t["scroll"+e],r["scroll"+e],t["offset"+e],r["offset"+e],r["client"+e])},t.prototype.intDragStop=function(e){if(this.dragProcessStarted=!1,u(e.changedTouches)||1===e.changedTouches.length){if(-1!==["touchend","pointerup","mouseup"].indexOf(e.type)){if(this.dragStop){var t=this.getProperTargetElement(e);this.trigger("dragStop",{event:e,element:this.element,target:t,helper:this.helperElement})}this.intDestroy(e)}else this.element.setAttribute("aria-grabbed","false");var r=this.checkTargetElement(e);r.target&&r.instance&&(r.instance.dragStopCalled=!0,r.instance.dragData[this.scope]=this.droppables[this.scope],r.instance.intDrop(e,r.target)),this.setGlobalDroppables(!0),document.body.classList.remove("e-prevent-select")}},t.prototype.intDestroy=function(e){this.dragProcessStarted=!1,this.toggleEvents(),document.body.classList.remove("e-prevent-select"),this.element.setAttribute("aria-grabbed","false"),Ye.remove(document,Ge.touchMoveEvent,this.intDragStart),Ye.remove(document,Ge.touchEndEvent,this.intDragStop),Ye.remove(document,Ge.touchEndEvent,this.intDestroy),Ye.remove(document,Ge.touchMoveEvent,this.intDrag),this.isDragStarted()&&this.isDragStarted(!0)},t.prototype.onPropertyChanged=function(e,t){},t.prototype.getModuleName=function(){return"draggable"},t.prototype.isDragStarted=function(e){return e&&(ot.isDragged=!ot.isDragged),ot.isDragged},t.prototype.setDragArea=function(){var e,t,r,n=0,i=0;if(r="string"===typeof this.dragArea?P(this.dragArea):this.dragArea){var o=r.getBoundingClientRect();e=r.scrollWidth?r.scrollWidth:o.right-o.left,t=r.scrollHeight?r.scrollHeight:o.bottom-o.top;for(var a=["Top","Left","Bottom","Right"],s=getComputedStyle(r),c=0;c<a.length;c++){var l=a[c],u=s["border"+l+"Width"],p=s["padding"+l],h=l.toLowerCase();this.borderWidth[h]=isNaN(parseFloat(u))?0:parseFloat(u),this.padding[h]=isNaN(parseFloat(p))?0:parseFloat(p)}n=o.top,i=o.left,this.dragLimit.left=i+this.borderWidth.left+this.padding.left,this.dragLimit.top=r.offsetTop+this.borderWidth.top+this.padding.top,this.dragLimit.right=i+e-(this.borderWidth.right+this.padding.right),this.dragLimit.bottom=n+t-(this.borderWidth.bottom+this.padding.bottom)}},t.prototype.getProperTargetElement=function(e){var t,r=this.getCoordinates(e),n=this.helperElement.style.pointerEvents||"";return h(e.target,this.helperElement)||-1!==e.type.indexOf("touch")?(this.helperElement.style.pointerEvents="none",t=document.elementFromPoint(r.clientX,r.clientY),this.helperElement.style.pointerEvents=n):t=e.target,t},t.prototype.currentStateCheck=function(e,t){return l(this.currentStateTarget)||this.currentStateTarget===e?l(t)?e:t:this.currentStateTarget},t.prototype.getMousePosition=function(e,t){var r,n,i=void 0!==e.srcElement?e.srcElement:e.target,o=this.getCoordinates(e),a=l(i.offsetParent);return t?(r=this.clone?o.pageX:o.pageX+(a?0:i.offsetParent.scrollLeft)-this.relativeXPosition,n=this.clone?o.pageY:o.pageY+(a?0:i.offsetParent.scrollTop)-this.relativeYPosition):(r=this.clone?o.pageX:o.pageX+window.pageXOffset-this.relativeXPosition,n=this.clone?o.pageY:o.pageY+window.pageYOffset-this.relativeYPosition),{left:r-(this.margin.left+this.cursorAt.left),top:n-(this.margin.top+this.cursorAt.top)}},t.prototype.getCoordinates=function(e){return e.type.indexOf("touch")>-1?e.changedTouches[0]:e},t.prototype.getHelperElement=function(e){var t;return this.clone?this.helper?t=this.helper({sender:e,element:this.target}):(t=g("div",{className:"e-drag-helper e-block-touch",innerHTML:"Draggable"}),document.body.appendChild(t)):t=this.element,t},t.prototype.setGlobalDroppables=function(e,t,r){this.droppables[this.scope]=e?null:{draggable:t,helper:r,draggedElement:this.element}},t.prototype.checkTargetElement=function(e){var t=this.getProperTargetElement(e),r=this.getDropInstance(t);if(!r&&t&&!l(t.parentNode)){var n=C(t.parentNode,".e-droppable")||t.parentElement;n&&(r=this.getDropInstance(n))}return{target:t,instance:r}},t.prototype.getDropInstance=function(e){var t,r=e&&e.ej2_instances;if(r)for(var n=0,i=r;n<i.length;n++){var o=i[n];if("droppable"===o.getModuleName()){t=o;break}}return t},t.prototype.destroy=function(){this.toggleEvents(!0),e.prototype.destroy.call(this)};var r;return nt([H({},at)],t.prototype,"cursorAt",void 0),nt([k(!0)],t.prototype,"clone",void 0),nt([k()],t.prototype,"dragArea",void 0),nt([k()],t.prototype,"isDragScroll",void 0),nt([k()],t.prototype,"isReplaceDragEle",void 0),nt([k(!0)],t.prototype,"isPreventSelect",void 0),nt([L()],t.prototype,"drag",void 0),nt([L()],t.prototype,"dragStart",void 0),nt([L()],t.prototype,"dragStop",void 0),nt([k(1)],t.prototype,"distance",void 0),nt([k()],t.prototype,"handle",void 0),nt([k()],t.prototype,"abort",void 0),nt([k()],t.prototype,"helper",void 0),nt([k("default")],t.prototype,"scope",void 0),nt([k("")],t.prototype,"dragTarget",void 0),nt([k()],t.prototype,"axis",void 0),nt([k()],t.prototype,"queryPositionInfo",void 0),nt([k(!1)],t.prototype,"enableTailMode",void 0),nt([k(!1)],t.prototype,"skipDistanceCheck",void 0),nt([k(!0)],t.prototype,"preventDefault",void 0),nt([k(!1)],t.prototype,"enableAutoScroll",void 0),nt([k(!1)],t.prototype,"enableTapHold",void 0),nt([k(750)],t.prototype,"tapHoldThreshold",void 0),nt([k(!1)],t.prototype,"enableScrollHandler",void 0),t=r=nt([B],t)}(_e),ct=function(){var e=function(t,r){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])})(t,r)};return function(t,r){function n(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),lt=function(e,t,r,n){var i,o=arguments.length,a=o<3?t:null===n?n=Object.getOwnPropertyDescriptor(t,r):n;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)a=Reflect.decorate(e,t,r,n);else for(var s=e.length-1;s>=0;s--)(i=e[s])&&(a=(o<3?i(a):o>3?i(t,r,a):i(t,r))||a);return o>3&&a&&Object.defineProperty(t,r,a),a},ut=function(e){function t(t,r){var n=e.call(this,r,t)||this;return n.mouseOver=!1,n.dragData={},n.dragStopCalled=!1,n.bind(),n}return ct(t,e),t.prototype.bind=function(){this.wireEvents()},t.prototype.wireEvents=function(){Ye.add(this.element,Ge.touchEndEvent,this.intDrop,this)},t.prototype.onPropertyChanged=function(e,t){},t.prototype.getModuleName=function(){return"droppable"},t.prototype.intOver=function(e,t){if(!this.mouseOver){var r=this.dragData[this.scope];this.trigger("over",{event:e,target:t,dragData:r}),this.mouseOver=!0}},t.prototype.intOut=function(e,t){this.mouseOver&&(this.trigger("out",{evt:e,target:t}),this.mouseOver=!1)},t.prototype.intDrop=function(e,t){if(this.dragStopCalled){this.dragStopCalled=!1;var r,n=!0,i=this.dragData[this.scope],o=!!i&&(i.helper&&M(i.helper));o&&(r=this.isDropArea(e,i.helper,t),this.accept&&(n=x(i.helper,this.accept))),o&&this.drop&&r.canDrop&&n&&this.trigger("drop",{event:e,target:r.target,droppedElement:i.helper,dragData:i}),this.mouseOver=!1}},t.prototype.isDropArea=function(e,t,r){var n={canDrop:!0,target:r||e.target},i="touchend"===e.type;if(i||n.target===t){t.style.display="none";var o=i?e.changedTouches[0]:e,a=document.elementFromPoint(o.clientX,o.clientY);n.canDrop=!1,n.canDrop=h(a,this.element),n.canDrop&&(n.target=a),t.style.display=""}return n},t.prototype.destroy=function(){Ye.remove(this.element,Ge.touchEndEvent,this.intDrop),e.prototype.destroy.call(this)},lt([k()],t.prototype,"accept",void 0),lt([k("default")],t.prototype,"scope",void 0),lt([L()],t.prototype,"drop",void 0),lt([L()],t.prototype,"over",void 0),lt([L()],t.prototype,"out",void 0),t=lt([B],t)}(_e),pt=function(){var e=function(t,r){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])})(t,r)};return function(t,r){function n(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),ht=function(e,t,r,n){var i,o=arguments.length,a=o<3?t:null===n?n=Object.getOwnPropertyDescriptor(t,r):n;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)a=Reflect.decorate(e,t,r,n);else for(var s=e.length-1;s>=0;s--)(i=e[s])&&(a=(o<3?i(a):o>3?i(t,r,a):i(t,r))||a);return o>3&&a&&Object.defineProperty(t,r,a),a},dt={backspace:8,tab:9,enter:13,shift:16,control:17,alt:18,pause:19,capslock:20,space:32,escape:27,pageup:33,pagedown:34,end:35,home:36,leftarrow:37,uparrow:38,rightarrow:39,downarrow:40,insert:45,delete:46,f1:112,f2:113,f3:114,f4:115,f5:116,f6:117,f7:118,f8:119,f9:120,f10:121,f11:122,f12:123,semicolon:186,plus:187,comma:188,minus:189,dot:190,forwardslash:191,graveaccent:192,openbracket:219,backslash:220,closebracket:221,singlequote:222},mt=function(e){function t(t,n){var i=e.call(this,n,t)||this;return i.keyPressHandler=function(e){for(var t=e.altKey,n=e.ctrlKey,o=e.shiftKey,a=e.which,s=0,c=Object.keys(i.keyConfigs);s<c.length;s++)for(var l=c[s],u=0,p=i.keyConfigs[l].split(",");u<p.length;u++){var h=p[u],d=r.getKeyConfigData(h.trim());t===d.altKey&&n===d.ctrlKey&&o===d.shiftKey&&a===d.keyCode&&(e.action=l,i.keyAction&&i.keyAction(e))}},i.bind(),i}pt(t,e),r=t,t.prototype.destroy=function(){this.unwireEvents(),e.prototype.destroy.call(this)},t.prototype.onPropertyChanged=function(e,t){},t.prototype.bind=function(){this.wireEvents()},t.prototype.getModuleName=function(){return"keyboard"},t.prototype.wireEvents=function(){this.element.addEventListener(this.eventName,this.keyPressHandler)},t.prototype.unwireEvents=function(){this.element.removeEventListener(this.eventName,this.keyPressHandler)},t.getKeyConfigData=function(e){if(e in this.configCache)return this.configCache[e];var t=e.toLowerCase().split("+"),n={altKey:-1!==t.indexOf("alt"),ctrlKey:-1!==t.indexOf("ctrl"),shiftKey:-1!==t.indexOf("shift"),keyCode:null};return t[t.length-1].length>1&&Number(t[t.length-1])?n.keyCode=Number(t[t.length-1]):n.keyCode=r.getKeyCode(t[t.length-1]),r.configCache[e]=n,n},t.getKeyCode=function(e){return dt[e]||e.toUpperCase().charCodeAt(0)};var r;return t.configCache={},ht([k({})],t.prototype,"keyConfigs",void 0),ht([k("keyup")],t.prototype,"eventName",void 0),ht([L()],t.prototype,"keyAction",void 0),t=r=ht([B],t)}(_e),ft=function(){function t(t,r,n){this.controlName=t,this.localeStrings=r,this.setLocale(n||e.defaultCulture)}return t.prototype.setLocale=function(e){var r=this.intGetControlConstant(t.locale,e);this.currentLocale=r||this.localeStrings},t.load=function(e){this.locale=c(this.locale,e,{},!0)},t.prototype.getConstant=function(e){return l(this.currentLocale[e])?this.localeStrings[e]||"":this.currentLocale[e]},t.prototype.intGetControlConstant=function(e,t){return e[t]?e[t][this.controlName]:null},t.locale={},t}(),gt=function(){var e=function(t,r){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])})(t,r)};return function(t,r){function n(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),yt=function(e,t,r,n){var i,o=arguments.length,a=o<3?t:null===n?n=Object.getOwnPropertyDescriptor(t,r):n;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)a=Reflect.decorate(e,t,r,n);else for(var s=e.length-1;s>=0;s--)(i=e[s])&&(a=(o<3?i(a):o>3?i(t,r,a):i(t,r))||a);return o>3&&a&&Object.defineProperty(t,r,a),a},vt=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return gt(t,e),yt([k(50)],t.prototype,"swipeThresholdDistance",void 0),t}(qe),bt=/(Up|Down)/,Mt=function(e){function t(t,r){var n=e.call(this,r,t)||this;return n.touchAction=!0,n.tapCount=0,n.startEvent=function(e){if(!0===n.touchAction){var t=n.updateChangeTouches(e);void 0!==e.changedTouches&&(n.touchAction=!1),n.isTouchMoved=!1,n.movedDirection="",n.startPoint=n.lastMovedPoint={clientX:t.clientX,clientY:t.clientY},n.startEventData=t,n.hScrollLocked=n.vScrollLocked=!1,n.tStampStart=Date.now(),n.timeOutTapHold=setTimeout(function(){n.tapHoldEvent(e)},n.tapHoldThreshold),Ye.add(n.element,Ge.touchMoveEvent,n.moveEvent,n),Ye.add(n.element,Ge.touchEndEvent,n.endEvent,n),Ye.add(n.element,Ge.touchCancelEvent,n.cancelEvent,n)}},n.moveEvent=function(e){var t=n.updateChangeTouches(e);n.movedPoint=t,n.isTouchMoved=!(t.clientX===n.startPoint.clientX&&t.clientY===n.startPoint.clientY);var r={};if(n.isTouchMoved){clearTimeout(n.timeOutTapHold),n.calcScrollPoints(e);r=c(r,{},{startEvents:n.startEventData,originalEvent:e,startX:n.startPoint.clientX,startY:n.startPoint.clientY,distanceX:n.distanceX,distanceY:n.distanceY,scrollDirection:n.scrollDirection,velocity:n.getVelocity(t)}),n.trigger("scroll",r),n.lastMovedPoint={clientX:t.clientX,clientY:t.clientY}}},n.cancelEvent=function(e){clearTimeout(n.timeOutTapHold),clearTimeout(n.timeOutTap),n.tapCount=0,n.swipeFn(e),Ye.remove(n.element,Ge.touchCancelEvent,n.cancelEvent)},n.endEvent=function(e){n.swipeFn(e),n.isTouchMoved||"function"==typeof n.tap&&(n.trigger("tap",{originalEvent:e,tapCount:++n.tapCount}),n.timeOutTap=setTimeout(function(){n.tapCount=0},n.tapThreshold)),n.modeclear()},n.swipeFn=function(e){clearTimeout(n.timeOutTapHold),clearTimeout(n.timeOutTap);var t=n.updateChangeTouches(e),r=t.clientX-n.startPoint.clientX,i=t.clientY-n.startPoint.clientY;r=Math.floor(r<0?-1*r:r),i=Math.floor(i<0?-1*i:r),n.isTouchMoved=r>1||i>1,n.endPoint=t,n.calcPoints(e);var o={originalEvent:e,startEvents:n.startEventData,startX:n.startPoint.clientX,startY:n.startPoint.clientY,distanceX:n.distanceX,distanceY:n.distanceY,swipeDirection:n.movedDirection,velocity:n.getVelocity(t)};if(n.isTouchMoved){var a=void 0,s=n.swipeSettings.swipeThresholdDistance;a=c(a,n.defaultArgs,o);var l=!1,u=n.element,p=n.isScrollable(u),h=bt.test(n.movedDirection);(s<n.distanceX&&!h||s<n.distanceY&&h)&&(l=!p||n.checkSwipe(u,h)),l&&n.trigger("swipe",a)}n.modeclear()},n.modeclear=function(){n.modeClear=setTimeout(function(){n.touchAction=!0},"function"!=typeof n.tap?0:20),n.lastTapTime=(new Date).getTime(),Ye.remove(n.element,Ge.touchMoveEvent,n.moveEvent),Ye.remove(n.element,Ge.touchEndEvent,n.endEvent),Ye.remove(n.element,Ge.touchCancelEvent,n.cancelEvent)},n.bind(),n}return gt(t,e),t.prototype.onPropertyChanged=function(e,t){},t.prototype.bind=function(){this.wireEvents(),Ge.isIE&&this.element.classList.add("e-block-touch")},t.prototype.destroy=function(){this.unwireEvents(),e.prototype.destroy.call(this)},t.prototype.wireEvents=function(){Ye.add(this.element,Ge.touchStartEvent,this.startEvent,this)},t.prototype.unwireEvents=function(){Ye.remove(this.element,Ge.touchStartEvent,this.startEvent)},t.prototype.getModuleName=function(){return"touch"},t.prototype.isScrollable=function(e){var t=getComputedStyle(e),r=t.overflow+t.overflowX+t.overflowY;return!!/(auto|scroll)/.test(r)},t.prototype.tapHoldEvent=function(e){this.tapCount=0,this.touchAction=!0;var t;Ye.remove(this.element,Ge.touchMoveEvent,this.moveEvent),Ye.remove(this.element,Ge.touchEndEvent,this.endEvent),t={originalEvent:e},this.trigger("tapHold",t),Ye.remove(this.element,Ge.touchCancelEvent,this.cancelEvent)},t.prototype.calcPoints=function(e){var t=this.updateChangeTouches(e);this.defaultArgs={originalEvent:e},this.distanceX=Math.abs(Math.abs(t.clientX)-Math.abs(this.startPoint.clientX)),this.distanceY=Math.abs(Math.abs(t.clientY)-Math.abs(this.startPoint.clientY)),this.distanceX>this.distanceY?this.movedDirection=t.clientX>this.startPoint.clientX?"Right":"Left":this.movedDirection=t.clientY<this.startPoint.clientY?"Up":"Down"},t.prototype.calcScrollPoints=function(e){var t=this.updateChangeTouches(e);this.defaultArgs={originalEvent:e},this.distanceX=Math.abs(Math.abs(t.clientX)-Math.abs(this.lastMovedPoint.clientX)),this.distanceY=Math.abs(Math.abs(t.clientY)-Math.abs(this.lastMovedPoint.clientY)),(this.distanceX>this.distanceY||!0===this.hScrollLocked)&&!1===this.vScrollLocked?(this.scrollDirection=t.clientX>this.lastMovedPoint.clientX?"Right":"Left",this.hScrollLocked=!0):(this.scrollDirection=t.clientY<this.lastMovedPoint.clientY?"Up":"Down",this.vScrollLocked=!0)},t.prototype.getVelocity=function(e){var t=e.clientX,r=e.clientY,n=Date.now(),i=t-this.startPoint.clientX,o=r-this.startPoint.clientX,a=n-this.tStampStart;return Math.sqrt(i*i+o*o)/a},t.prototype.checkSwipe=function(e,t){var r=["scroll","offset"],n=t?["Height","Top"]:["Width","Left"];return e[r[0]+n[0]]<=e[r[1]+n[0]]||(0===e[r[0]+n[1]]||e[r[1]+n[0]]+e[r[0]+n[1]]>=e[r[0]+n[0]])},t.prototype.updateChangeTouches=function(e){return e.changedTouches&&0!==e.changedTouches.length?e.changedTouches[0]:e},yt([L()],t.prototype,"tap",void 0),yt([L()],t.prototype,"tapHold",void 0),yt([L()],t.prototype,"swipe",void 0),yt([L()],t.prototype,"scroll",void 0),yt([k(350)],t.prototype,"tapThreshold",void 0),yt([k(750)],t.prototype,"tapHoldThreshold",void 0),yt([H({},vt)],t.prototype,"swipeSettings",void 0),t=yt([B],t)}(_e),Dt=new RegExp("\\n|\\r|\\s\\s+","g"),wt=new RegExp(/'|"/g),Et=new RegExp("if ?\\("),Pt=new RegExp("else if ?\\("),St=new RegExp("else"),Ot=new RegExp("for ?\\("),Ct=new RegExp("(/if|/for)"),Tt=new RegExp("\\((.*)\\)",""),xt=new RegExp("^[0-9]+$","g"),jt=new RegExp("[\\w\"'.\\s+]+","g"),Nt=new RegExp('"(.*?)"',"g"),Ft=new RegExp("[\\w\"'@#$.\\s-+]+","g"),Rt=new RegExp("\\${([^}]*)}","g"),At=/^\..*/gm,It=/\\/gi,kt=/\\\\/gi,Ht=new RegExp("[\\w\"'@#$.\\s+]+","g"),Lt=/\window\./gm,Bt=/^[\n\r.]+<tr|^<tr/,Gt=/^[\n\r.]+<svg|^<path|^<g/,Yt={},zt={compile:(new(function(){function e(){}return e.prototype.compile=function(e,t,r){return void 0===t&&(t={}),V(e,t)},e}())).compile},Xt=["script","style","iframe[src]",'link[href*="javascript:"]','object[type="text/x-scriptlet"]','object[data^="data:text/html;base64"]','img[src^="data:text/html;base64"]','[src^="javascript:"]','[dynsrc^="javascript:"]','[lowsrc^="javascript:"]','[type^="application/x-shockwave-flash"]'],_t=[{attribute:"href",selector:'[href*="javascript:"]'},{attribute:"background",selector:'[background^="javascript:"]'},{attribute:"style",selector:'[style*="javascript:"]'},{attribute:"style",selector:'[style*="expression("]'},{attribute:"href",selector:'a[href^="data:text/html;base64"]'}],Wt=["onchange","onclick","onmouseover","onmouseout","onkeydown","onload","onerror","onblur","onfocus","onbeforeload","onbeforeunload","onkeyup","onsubmit","onafterprint","onbeforeonload","onbeforeprint","onblur","oncanplay","oncanplaythrough","onchange","onclick","oncontextmenu","ondblclick","ondrag","ondragend","ondragenter","ondragleave","ondragover","ondragstart","ondrop","ondurationchange","onemptied","onended","onerror","onerror","onfocus","onformchange","onforminput","onhaschange","oninput","oninvalid","onkeydown","onkeypress","onkeyup","onload","onloadeddata","onloadedmetadata","onloadstart","onmessage","onmousedown","onmousemove","onmouseout","onmouseover","onmouseup","onmousewheel","onoffline","onoine","ononline","onpagehide","onpageshow","onpause","onplay","onplaying","onpopstate","onprogress","onratechange","onreadystatechange","onredo","onresize","onscroll","onseeked","onseeking","onselect","onstalled","onstorage","onsubmit","onsuspend","ontimeupdate","onundo","onunload","onvolumechange","onwaiting","onmouseenter","onmouseleave","onmousewheel","onstart","onpropertychange"],$t=function(){function e(){}return e.beforeSanitize=function(){return{selectors:{tags:Xt,attributes:_t}}},e.sanitize=function(e){var t=this.beforeSanitize();return this.serializeValue(t,e)},e.serializeValue=function(e,t){this.removeAttrs=e.selectors.attributes,this.removeTags=e.selectors.tags,this.wrapElement=document.createElement("div"),this.wrapElement.innerHTML=t,this.removeXssTags(),this.removeJsEvents(),this.removeXssAttrs();var r=this.wrapElement.innerHTML;return this.removeElement(),r},e.removeElement=function(){for(var e=this.wrapElement.children,t=0;t<e.length;t++)for(var r=e[t].attributes,n=0;n<r.length;n++)this.wrapElement.children[t].removeAttribute(r[n].localName)},e.removeXssTags=function(){var e=this.wrapElement.querySelectorAll(this.removeTags.join(","));e.length>0&&e.forEach(function(e){w(e)})},e.removeJsEvents=function(){var e=this.wrapElement.querySelectorAll("["+Wt.join("],[")+"]");e.length>0&&e.forEach(function(e){Wt.forEach(function(t){e.hasAttribute(t)&&e.removeAttribute(t)})})},e.removeXssAttrs=function(){var e=this;this.removeAttrs.forEach(function(t,r){var n=e.wrapElement.querySelectorAll(t.selector);n.length>0&&n.forEach(function(e){e.removeAttribute(t.attribute)})})},e}();e.blazorCultureFormats=Ce,e.Ajax=je,e.Animation=Ve,e.rippleEffect=function(t,r,n){var i=function(e){return{selector:e&&e.selector?e.selector:null,ignore:e&&e.ignore?e.ignore:null,rippleFlag:e&&e.rippleFlag,isCenterRipple:e&&e.isCenterRipple,duration:e&&e.duration?e.duration:350}}(r);return!1===i.rippleFlag||void 0===i.rippleFlag&&!e.isRippleEnabled?function(){}:(t.setAttribute("data-ripple","true"),Ye.add(t,"mousedown",X,{parent:t,rippleOptions:i}),Ye.add(t,"mouseup",_,{parent:t,rippleOptions:i,done:n}),Ye.add(t,"mouseleave",W,{parent:t,rippleOptions:i}),Ge.isPointer&&Ye.add(t,"transitionend",W,{parent:t,rippleOptions:i}),function(){t.removeAttribute("data-ripple"),Ye.remove(t,"mousedown",X),Ye.remove(t,"mouseup",_),Ye.remove(t,"mouseleave",W),Ye.remove(t,"transitionend",W)})},e.enableRipple=function(t){return e.isRippleEnabled=t,e.isRippleEnabled},e.Base=_e,e.getComponent=j,e.removeChildInstance=function(e){for(var t=[].slice.call(e.getElementsByClassName("e-control")),r=0;r<t.length;r++){var n=t[r].classList[1].split("e-")[1],i=j(t[r],n);u(i)||i.destroy()}},e.Browser=Ge,e.enableVersionBasedPersistence=function(t){e.versionBasedStatePersistence=t},e.Component=tt,e.ChildProperty=qe,e.Position=at,e.Draggable=st,e.Droppable=ut,e.EventHandler=Ye,e.onIntlChange=Ee,e.cldrData=Pe,e.Internationalization=Oe,e.setCulture=function(t){e.defaultCulture=t,Ee.notify("notifyExternalChange",{locale:e.defaultCulture})},e.setCurrencyCode=function(t){e.defaultCurrencyCode=t,Ee.notify("notifyExternalChange",{currencyCode:e.defaultCurrencyCode})},e.loadCldr=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];for(var r=0,n=e;r<n.length;r++){var i=n[r];c(Pe,i,{},!0)}},e.enableRtl=function(t){void 0===t&&(t=!0),e.rightToLeft=t,Ee.notify("notifyExternalChange",{enableRtl:e.rightToLeft})},e.getNumericObject=function(t,r){var i=e.IntlBase.getDependables(Pe,t,"",!0)[Se[0]],o=e.IntlBase.getDependables(Pe,t,"")[Se[1]],a=n("defaultNumberingSystem",i),s=m()?n("numberSymbols",i):n("symbols-numberSystem-"+a,i),l=e.IntlBase.getSymbolPattern(r||"decimal",a,i,!1);return c(s,e.IntlBase.getFormatData(l,!0,"",!0),{dateSeparator:e.IntlBase.getDateSeparator(o)})},e.getNumberDependable=function(t,r){var n=e.IntlBase.getDependables(Pe,t,"",!0);return e.IntlBase.getCurrencySymbol(n.numericObject,r)},e.getDefaultDateObject=function(t){return e.IntlBase.getDependables(Pe,"",t,!1)[Se[1]]},e.KeyboardEvents=mt,e.L10n=ft,e.ModuleLoader=Ke,e.Property=k,e.Complex=H,e.ComplexFactory=function(e){return function(t,r){var n={set:function(e,t,r){return function(n){var i=r(n,this);N(this,t,e,i).setProperties(n)}}({},r,e),get:function(e,t,r){return function(){var n=r({});return this.properties.hasOwnProperty(t)?this.properties[t]:N(this,t,e,n)}}({},r,e),enumerable:!0,configurable:!0};Object.defineProperty(t,r,n),G(t,r,"complexProp",{},e)}},e.Collection=function(e,t){return function(r,n){var i={set:function(e,t,r){return function(n){this.isComplexArraySetter=!0;var i=F(this,t,e,r,!1),o=F(this,t,n,r,!0);this.isComplexArraySetter=!1,this.saveChanges(t,o,i),this.properties[t]=o}}(e,n,t),get:A(e,n,t),enumerable:!0,configurable:!0};Object.defineProperty(r,n,i),G(r,n,"colProp",e,t)}},e.CollectionFactory=function(e){return function(t,r){var n={set:function(e,t,r){return function(n){var i=this.properties.hasOwnProperty(t)?this.properties[t]:e,o=F(this,t,n,r,!0,!0);this.saveChanges(t,o,i),this.properties[t]=o}}([],r,e),get:function(e,t,r){return function(){var n=r({});if(!this.properties.hasOwnProperty(t)){var i=F(this,t,e,n,!1);this.properties[t]=i}return this.properties[t]}}([],r,e),enumerable:!0,configurable:!0};Object.defineProperty(t,r,n),G(t,r,"colProp",{},e)}},e.Event=L,e.NotifyPropertyChanges=B,e.CreateBuilder=function(e){var t=function(e){return this.element=e,this};return function(r){return t.prototype.hasOwnProperty("create")||((t.prototype=Y(e)).create=function(){var t=c({},{},this.properties);return this.properties={},new e(t,this.element)}),new t(r)}},e.SwipeSettings=vt,e.Touch=Mt,e.blazorTemplates=Yt,e.getRandomId=J,e.compile=function(e,t,r){var n=zt.compile(e,t,r);return function(e,t,r,i,o,a,s){var c=n(e,t,r,s),u="BlazorTemplateId";if(m()&&!o){var p=i+J();if(Yt[i]||(Yt[i]=[]),l(a))e[u]=p,Yt[i].push(e);else for(var h=0,d=Object.keys(Yt[i][a]);h<d.length;h++){var f=d[h];f!==u&&e[f]&&(Yt[i][a][f]=e[f]),f===u&&(p=Yt[i][a][f])}return"rowTemplate"===r?[g("tr",{id:p,className:"e-blazor-template"})]:[g("div",{id:p,className:"e-blazor-template"})]}return"string"==typeof c?Gt.test(c)?g("svg",{innerHTML:c}).childNodes:g(Bt.test(c)?"table":"div",{innerHTML:c}).childNodes:c}},e.updateBlazorTemplate=function(e,t,r,n,i){m()&&(window.sfBlazor.updateTemplate(t,Yt[e],e,r,i),!1!==n&&(Yt[e]=[]))},e.resetBlazorTemplate=function(e,t,r){var n=document.getElementById(e);if(n)for(var i=n.getElementsByClassName("blazor-inner-template"),o=0;o<i.length;o++){var a=" ";a=l(r)?i[o].getAttribute("data-templateId"):i[r].getAttribute("data-templateId");var s=document.getElementById(a);if(s)for(var c=s.childNodes.length,u=0;u<c;u++)l(r)?i[o].appendChild(s.childNodes[0]):(i[r].appendChild(s.childNodes[0]),o=i.length)}},e.setTemplateEngine=function(e){zt.compile=e.compile},e.getTemplateEngine=function(){return zt.compile},e.disableBlazorMode=function(){te=!1},e.createInstance=t,e.setImmediate=r,e.getValue=n,e.setValue=i,e.deleteObject=o,e.isObject=a,e.getEnumValue=function(e,t){return e[t]},e.merge=s,e.extend=c,e.isNullOrUndefined=l,e.isUndefined=u,e.getUniqueID=function(e){return e+"_"+ee++},e.debounce=p,e.queryParams=function(e){for(var t=[],r=0,n=Object.keys(e);r<n.length;r++){var i=n[r];t.push(encodeURIComponent(i)+"="+encodeURIComponent(""+e[i]))}return t.join("&")},e.isObjectArray=function(e){var t=Object.prototype.toString;return"[object Array]"===t.call(e)&&"[object Object]"===t.call(e[0])},e.compareElementParent=h,e.throwError=d,e.print=function(e,t){var r=document.createElement("div"),n=[].slice.call(document.getElementsByTagName("head")[0].querySelectorAll("base, link, style")),i=[].slice.call(document.getElementsByTagName("body")[0].querySelectorAll("link, style"));if(i.length)for(var o=0,a=i.length;o<a;o++)n.push(i[o]);var s="";l(t)&&(t=window.open("","print","height=452,width=1024,tabbar=no")),r.appendChild(e.cloneNode(!0));var c=0;for(a=n.length;c<a;c++)s+=n[c].outerHTML;t.document.write("<!DOCTYPE html> <html><head>"+s+"</head><body>"+r.innerHTML+"<script> (function() { window.ready = true; })(); <\/script></body></html>"),t.document.close(),t.focus();var u=setInterval(function(){t.ready&&(t.print(),t.close(),clearInterval(u))},500);return t},e.formatUnit=function(e){var t=e+"";return t.match(/auto|cm|mm|in|px|pt|pc|%|em|ex|ch|rem|vw|vh|vmin|vmax/)?t:t+"px"},e.enableBlazorMode=function(){te=!0},e.isBlazor=m,e.getElement=function(e){return e instanceof Node||!m()||l(e.xPath)?e:document.evaluate(e.xPath,document,null,XPathResult.FIRST_ORDERED_NODE_TYPE,null).singleNodeValue},e.getInstance=function(e,t){var r="string"==typeof e?document.querySelector(e):e;if(r[Q])for(var n=0,i=r[Q];n<i.length;n++){var o=i[n];if(o instanceof t)return o}return null},e.addInstance=function(e,t){var r="string"==typeof e?document.querySelector(e):e;r[Q]?r[Q].push(t):r[Q]=[t]},e.uniqueID=f,e.createElement=g,e.addClass=y,e.removeClass=v,e.isVisible=M,e.prepend=function(e,t,r){for(var n=document.createDocumentFragment(),i=0,o=e;i<o.length;i++){var a=o[i];n.appendChild(a)}return t.insertBefore(n,t.firstElementChild),r&&D(t),e},e.append=function(e,t,r){for(var n=document.createDocumentFragment(),i=0,o=e;i<o.length;i++){var a=o[i];n.appendChild(a)}return t.appendChild(n),r&&D(t),e},e.detach=w,e.remove=function(e){var t=e.parentNode;Ye.clearEvents(e),t.removeChild(e)},e.attributes=E,e.select=P,e.selectAll=S,e.closest=C,e.siblings=function(e){for(var t=[],r=0,n=Array.prototype.slice.call(e.parentNode.childNodes);r<n.length;r++){var i=n[r];i.nodeType===Node.ELEMENT_NODE&&e!==i&&t.push(i)}return t},e.getAttributeOrDefault=function(e,t,r){var i,o=a(e);return i=o?n("attributes."+t,e):e.getAttribute(t),l(i)&&r&&(o?e.attributes[t]=r:e.setAttribute(t,r.toString()),i=r),i},e.setStyleAttribute=T,e.classList=function(e,t,r){y([e],t),v([e],r)},e.matches=x,e.includeInnerHTML=function(e,t){e.innerHTML=t},e.containsClass=function(e,t){return a(e)?new RegExp("\\b"+t+"\\b","i").test(e.attributes.className):e.classList.contains(t)},e.cloneNode=function(e,t){return a(e)?t?c({},{},e,!0):void 0:e.cloneNode(t)},e.Observer=we,e.SanitizeHtmlHelper=$t,Object.defineProperty(e,"__esModule",{value:!0})});
	//# sourceMappingURL=ej2-base.umd.min.js.map


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/* tslint:disable:no-console */
	var version_1 = __webpack_require__(125);
	var platform_1 = __webpack_require__(40);
	var LogLevel;
	(function (LogLevel) {
	    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
	    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
	    LogLevel[LogLevel["SILENT"] = 2] = "SILENT";
	})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
	var logLevel = LogLevel.ERROR;
	// Helper methods are needed because variables can't be exported as read/write
	function getLogLevel() {
	    return logLevel;
	}
	exports.getLogLevel = getLogLevel;
	function setLogLevel(newLevel) {
	    logLevel = newLevel;
	}
	exports.setLogLevel = setLogLevel;
	function debug(tag, msg) {
	    var obj = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        obj[_i - 2] = arguments[_i];
	    }
	    if (logLevel <= LogLevel.DEBUG) {
	        var time = new Date().toISOString();
	        var args = obj.map(argToString);
	        console.log.apply(console, ["Firestore (" + version_1.SDK_VERSION + ") " + time + " [" + tag + "]: " + msg].concat(args));
	    }
	}
	exports.debug = debug;
	function error(msg) {
	    var obj = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        obj[_i - 1] = arguments[_i];
	    }
	    if (logLevel <= LogLevel.ERROR) {
	        var time = new Date().toISOString();
	        var args = obj.map(argToString);
	        console.error.apply(console, ["Firestore (" + version_1.SDK_VERSION + ") " + time + ": " + msg].concat(args));
	    }
	}
	exports.error = error;
	/**
	 * Converts an additional log parameter to a string representation.
	 */
	function argToString(obj) {
	    if (typeof obj === 'string') {
	        return obj;
	    }
	    else {
	        var platform = platform_1.PlatformSupport.getPlatform();
	        try {
	            return platform.formatJSON(obj);
	        }
	        catch (e) {
	            // Converting to JSON failed, just log the object directly
	            return obj;
	        }
	    }
	}
	
	//# sourceMappingURL=log.js.map


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(10);
	// tslint:disable-next-line:class-as-namespace
	var AutoId = /** @class */ (function () {
	    function AutoId() {
	    }
	    AutoId.newId = function () {
	        // Alphanumeric characters
	        var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	        var autoId = '';
	        for (var i = 0; i < 20; i++) {
	            autoId += chars.charAt(Math.floor(Math.random() * chars.length));
	        }
	        assert_1.assert(autoId.length === 20, 'Invalid auto ID: ' + autoId);
	        return autoId;
	    };
	    return AutoId;
	}());
	exports.AutoId = AutoId;
	function primitiveComparator(left, right) {
	    if (left < right)
	        return -1;
	    if (left > right)
	        return 1;
	    return 0;
	}
	exports.primitiveComparator = primitiveComparator;
	/** Helper to compare nullable (or undefined-able) objects using equals(). */
	function equals(left, right) {
	    if (left !== null && left !== undefined) {
	        return !!(right && left.equals(right));
	    }
	    else {
	        // HACK: Explicitly cast since TypeScript's type narrowing apparently isn't
	        // smart enough.
	        return left === right;
	    }
	}
	exports.equals = equals;
	/** Helper to compare arrays using equals(). */
	function arrayEquals(left, right) {
	    if (left.length !== right.length) {
	        return false;
	    }
	    for (var i = 0; i < left.length; i++) {
	        if (!left[i].equals(right[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	exports.arrayEquals = arrayEquals;
	/**
	 * Returns the largest lexicographically smaller string of equal or smaller
	 * length. Returns an empty string if there is no such predecessor (if the input
	 * is empty).
	 *
	 * Strings returned from this method can be invalid UTF-16 but this is sufficent
	 * in use for indexeddb because that depends on lexicographical ordering but
	 * shouldn't be used elsewhere.
	 */
	function immediatePredecessor(s) {
	    // We can decrement the last character in the string and be done
	    // unless that character is 0 (0x0000), in which case we have to erase the
	    // last character.
	    var lastIndex = s.length - 1;
	    if (s.length === 0) {
	        // Special case the empty string.
	        return '';
	    }
	    else if (s.charAt(lastIndex) === '\0') {
	        return s.substring(0, lastIndex);
	    }
	    else {
	        return (s.substring(0, lastIndex) +
	            String.fromCharCode(s.charCodeAt(lastIndex) - 1));
	    }
	}
	exports.immediatePredecessor = immediatePredecessor;
	/**
	 * Returns the immediate lexicographically-following string. This is useful to
	 * construct an inclusive range for indexeddb iterators.
	 */
	function immediateSuccessor(s) {
	    // Return the input string, with an additional NUL byte appended.
	    return s + '\0';
	}
	exports.immediateSuccessor = immediateSuccessor;
	
	//# sourceMappingURL=misc.js.map


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Index_1 = __webpack_require__(88);
	var util_1 = __webpack_require__(13);
	var Node_1 = __webpack_require__(30);
	var LeafNode_1 = __webpack_require__(87);
	var nodeFromJSON;
	var MAX_NODE;
	function setNodeFromJSON(val) {
	    nodeFromJSON = val;
	}
	exports.setNodeFromJSON = setNodeFromJSON;
	function setMaxNode(val) {
	    MAX_NODE = val;
	}
	exports.setMaxNode = setMaxNode;
	/**
	 * @constructor
	 * @extends {Index}
	 * @private
	 */
	var PriorityIndex = /** @class */ (function (_super) {
	    __extends(PriorityIndex, _super);
	    function PriorityIndex() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.compare = function (a, b) {
	        var aPriority = a.node.getPriority();
	        var bPriority = b.node.getPriority();
	        var indexCmp = aPriority.compareTo(bPriority);
	        if (indexCmp === 0) {
	            return util_1.nameCompare(a.name, b.name);
	        }
	        else {
	            return indexCmp;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.isDefinedOn = function (node) {
	        return !node.getPriority().isEmpty();
	    };
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
	        return !oldNode.getPriority().equals(newNode.getPriority());
	    };
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.minPost = function () {
	        return Node_1.NamedNode.MIN;
	    };
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.maxPost = function () {
	        return new Node_1.NamedNode(util_1.MAX_NAME, new LeafNode_1.LeafNode('[PRIORITY-POST]', MAX_NODE));
	    };
	    /**
	     * @param {*} indexValue
	     * @param {string} name
	     * @return {!NamedNode}
	     */
	    PriorityIndex.prototype.makePost = function (indexValue, name) {
	        var priorityNode = nodeFromJSON(indexValue);
	        return new Node_1.NamedNode(name, new LeafNode_1.LeafNode('[PRIORITY-POST]', priorityNode));
	    };
	    /**
	     * @return {!string} String representation for inclusion in a query spec
	     */
	    PriorityIndex.prototype.toString = function () {
	        return '.priority';
	    };
	    return PriorityIndex;
	}(Index_1.Index));
	exports.PriorityIndex = PriorityIndex;
	exports.PRIORITY_INDEX = new PriorityIndex();
	
	//# sourceMappingURL=PriorityIndex.js.map


/***/ },
/* 27 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var util_2 = __webpack_require__(13);
	var SortedMap_1 = __webpack_require__(90);
	var Node_1 = __webpack_require__(30);
	var snap_1 = __webpack_require__(178);
	var PriorityIndex_1 = __webpack_require__(26);
	var KeyIndex_1 = __webpack_require__(67);
	var IndexMap_1 = __webpack_require__(173);
	var LeafNode_1 = __webpack_require__(87);
	var comparators_1 = __webpack_require__(175);
	// TODO: For memory savings, don't store priorityNode_ if it's empty.
	var EMPTY_NODE;
	/**
	 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
	 * (i.e. nodes with children).  It implements Node and stores the
	 * list of children in the children property, sorted by child name.
	 *
	 * @constructor
	 * @implements {Node}
	 */
	var ChildrenNode = /** @class */ (function () {
	    /**
	     *
	     * @param {!SortedMap.<string, !Node>} children_ List of children
	     * of this node..
	     * @param {?Node} priorityNode_ The priority of this node (as a snapshot node).
	     * @param {!IndexMap} indexMap_
	     */
	    function ChildrenNode(children_, priorityNode_, indexMap_) {
	        this.children_ = children_;
	        this.priorityNode_ = priorityNode_;
	        this.indexMap_ = indexMap_;
	        this.lazyHash_ = null;
	        /**
	         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
	         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
	         * class instead of an empty ChildrenNode.
	         */
	        if (this.priorityNode_) {
	            snap_1.validatePriorityNode(this.priorityNode_);
	        }
	        if (this.children_.isEmpty()) {
	            util_1.assert(!this.priorityNode_ || this.priorityNode_.isEmpty(), 'An empty node cannot have a priority');
	        }
	    }
	    Object.defineProperty(ChildrenNode, "EMPTY_NODE", {
	        get: function () {
	            return (EMPTY_NODE ||
	                (EMPTY_NODE = new ChildrenNode(new SortedMap_1.SortedMap(comparators_1.NAME_COMPARATOR), null, IndexMap_1.IndexMap.Default)));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @inheritDoc */
	    ChildrenNode.prototype.isLeafNode = function () {
	        return false;
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.getPriority = function () {
	        return this.priorityNode_ || EMPTY_NODE;
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.updatePriority = function (newPriorityNode) {
	        if (this.children_.isEmpty()) {
	            // Don't allow priorities on empty nodes
	            return this;
	        }
	        else {
	            return new ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.getImmediateChild = function (childName) {
	        // Hack to treat priority as a regular child
	        if (childName === '.priority') {
	            return this.getPriority();
	        }
	        else {
	            var child = this.children_.get(childName);
	            return child === null ? EMPTY_NODE : child;
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.getChild = function (path) {
	        var front = path.getFront();
	        if (front === null)
	            return this;
	        return this.getImmediateChild(front).getChild(path.popFront());
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.hasChild = function (childName) {
	        return this.children_.get(childName) !== null;
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.updateImmediateChild = function (childName, newChildNode) {
	        util_1.assert(newChildNode, 'We should always be passing snapshot nodes');
	        if (childName === '.priority') {
	            return this.updatePriority(newChildNode);
	        }
	        else {
	            var namedNode = new Node_1.NamedNode(childName, newChildNode);
	            var newChildren = void 0, newIndexMap = void 0, newPriority = void 0;
	            if (newChildNode.isEmpty()) {
	                newChildren = this.children_.remove(childName);
	                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
	            }
	            else {
	                newChildren = this.children_.insert(childName, newChildNode);
	                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
	            }
	            newPriority = newChildren.isEmpty() ? EMPTY_NODE : this.priorityNode_;
	            return new ChildrenNode(newChildren, newPriority, newIndexMap);
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.updateChild = function (path, newChildNode) {
	        var front = path.getFront();
	        if (front === null) {
	            return newChildNode;
	        }
	        else {
	            util_1.assert(path.getFront() !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
	            var newImmediateChild = this.getImmediateChild(front).updateChild(path.popFront(), newChildNode);
	            return this.updateImmediateChild(front, newImmediateChild);
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.isEmpty = function () {
	        return this.children_.isEmpty();
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.numChildren = function () {
	        return this.children_.count();
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.val = function (exportFormat) {
	        if (this.isEmpty())
	            return null;
	        var obj = {};
	        var numKeys = 0, maxKey = 0, allIntegerKeys = true;
	        this.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (key, childNode) {
	            obj[key] = childNode.val(exportFormat);
	            numKeys++;
	            if (allIntegerKeys && ChildrenNode.INTEGER_REGEXP_.test(key)) {
	                maxKey = Math.max(maxKey, Number(key));
	            }
	            else {
	                allIntegerKeys = false;
	            }
	        });
	        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
	            // convert to array.
	            var array = [];
	            for (var key in obj)
	                array[key] = obj[key];
	            return array;
	        }
	        else {
	            if (exportFormat && !this.getPriority().isEmpty()) {
	                obj['.priority'] = this.getPriority().val();
	            }
	            return obj;
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.hash = function () {
	        if (this.lazyHash_ === null) {
	            var toHash_1 = '';
	            if (!this.getPriority().isEmpty())
	                toHash_1 +=
	                    'priority:' +
	                        snap_1.priorityHashText(this.getPriority().val()) +
	                        ':';
	            this.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (key, childNode) {
	                var childHash = childNode.hash();
	                if (childHash !== '')
	                    toHash_1 += ':' + key + ':' + childHash;
	            });
	            this.lazyHash_ = toHash_1 === '' ? '' : util_2.sha1(toHash_1);
	        }
	        return this.lazyHash_;
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.getPredecessorChildName = function (childName, childNode, index) {
	        var idx = this.resolveIndex_(index);
	        if (idx) {
	            var predecessor = idx.getPredecessorKey(new Node_1.NamedNode(childName, childNode));
	            return predecessor ? predecessor.name : null;
	        }
	        else {
	            return this.children_.getPredecessorKey(childName);
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {?string}
	     */
	    ChildrenNode.prototype.getFirstChildName = function (indexDefinition) {
	        var idx = this.resolveIndex_(indexDefinition);
	        if (idx) {
	            var minKey = idx.minKey();
	            return minKey && minKey.name;
	        }
	        else {
	            return this.children_.minKey();
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {?NamedNode}
	     */
	    ChildrenNode.prototype.getFirstChild = function (indexDefinition) {
	        var minKey = this.getFirstChildName(indexDefinition);
	        if (minKey) {
	            return new Node_1.NamedNode(minKey, this.children_.get(minKey));
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * Given an index, return the key name of the largest value we have, according to that index
	     * @param {!Index} indexDefinition
	     * @return {?string}
	     */
	    ChildrenNode.prototype.getLastChildName = function (indexDefinition) {
	        var idx = this.resolveIndex_(indexDefinition);
	        if (idx) {
	            var maxKey = idx.maxKey();
	            return maxKey && maxKey.name;
	        }
	        else {
	            return this.children_.maxKey();
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {?NamedNode}
	     */
	    ChildrenNode.prototype.getLastChild = function (indexDefinition) {
	        var maxKey = this.getLastChildName(indexDefinition);
	        if (maxKey) {
	            return new Node_1.NamedNode(maxKey, this.children_.get(maxKey));
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.forEachChild = function (index, action) {
	        var idx = this.resolveIndex_(index);
	        if (idx) {
	            return idx.inorderTraversal(function (wrappedNode) {
	                return action(wrappedNode.name, wrappedNode.node);
	            });
	        }
	        else {
	            return this.children_.inorderTraversal(action);
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {SortedMapIterator}
	     */
	    ChildrenNode.prototype.getIterator = function (indexDefinition) {
	        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
	    };
	    /**
	     *
	     * @param {!NamedNode} startPost
	     * @param {!Index} indexDefinition
	     * @return {!SortedMapIterator}
	     */
	    ChildrenNode.prototype.getIteratorFrom = function (startPost, indexDefinition) {
	        var idx = this.resolveIndex_(indexDefinition);
	        if (idx) {
	            return idx.getIteratorFrom(startPost, function (key) { return key; });
	        }
	        else {
	            var iterator = this.children_.getIteratorFrom(startPost.name, Node_1.NamedNode.Wrap);
	            var next = iterator.peek();
	            while (next != null && indexDefinition.compare(next, startPost) < 0) {
	                iterator.getNext();
	                next = iterator.peek();
	            }
	            return iterator;
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {!SortedMapIterator}
	     */
	    ChildrenNode.prototype.getReverseIterator = function (indexDefinition) {
	        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
	    };
	    /**
	     * @param {!NamedNode} endPost
	     * @param {!Index} indexDefinition
	     * @return {!SortedMapIterator}
	     */
	    ChildrenNode.prototype.getReverseIteratorFrom = function (endPost, indexDefinition) {
	        var idx = this.resolveIndex_(indexDefinition);
	        if (idx) {
	            return idx.getReverseIteratorFrom(endPost, function (key) {
	                return key;
	            });
	        }
	        else {
	            var iterator = this.children_.getReverseIteratorFrom(endPost.name, Node_1.NamedNode.Wrap);
	            var next = iterator.peek();
	            while (next != null && indexDefinition.compare(next, endPost) > 0) {
	                iterator.getNext();
	                next = iterator.peek();
	            }
	            return iterator;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.compareTo = function (other) {
	        if (this.isEmpty()) {
	            if (other.isEmpty()) {
	                return 0;
	            }
	            else {
	                return -1;
	            }
	        }
	        else if (other.isLeafNode() || other.isEmpty()) {
	            return 1;
	        }
	        else if (other === exports.MAX_NODE) {
	            return -1;
	        }
	        else {
	            // Must be another node with children.
	            return 0;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.withIndex = function (indexDefinition) {
	        if (indexDefinition === KeyIndex_1.KEY_INDEX ||
	            this.indexMap_.hasIndex(indexDefinition)) {
	            return this;
	        }
	        else {
	            var newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
	            return new ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.isIndexed = function (index) {
	        return index === KeyIndex_1.KEY_INDEX || this.indexMap_.hasIndex(index);
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.equals = function (other) {
	        if (other === this) {
	            return true;
	        }
	        else if (other.isLeafNode()) {
	            return false;
	        }
	        else {
	            var otherChildrenNode = other;
	            if (!this.getPriority().equals(otherChildrenNode.getPriority())) {
	                return false;
	            }
	            else if (this.children_.count() === otherChildrenNode.children_.count()) {
	                var thisIter = this.getIterator(PriorityIndex_1.PRIORITY_INDEX);
	                var otherIter = otherChildrenNode.getIterator(PriorityIndex_1.PRIORITY_INDEX);
	                var thisCurrent = thisIter.getNext();
	                var otherCurrent = otherIter.getNext();
	                while (thisCurrent && otherCurrent) {
	                    if (thisCurrent.name !== otherCurrent.name ||
	                        !thisCurrent.node.equals(otherCurrent.node)) {
	                        return false;
	                    }
	                    thisCurrent = thisIter.getNext();
	                    otherCurrent = otherIter.getNext();
	                }
	                return thisCurrent === null && otherCurrent === null;
	            }
	            else {
	                return false;
	            }
	        }
	    };
	    /**
	     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
	     * instead.
	     *
	     * @private
	     * @param {!Index} indexDefinition
	     * @return {?SortedMap.<NamedNode, Node>}
	     */
	    ChildrenNode.prototype.resolveIndex_ = function (indexDefinition) {
	        if (indexDefinition === KeyIndex_1.KEY_INDEX) {
	            return null;
	        }
	        else {
	            return this.indexMap_.get(indexDefinition.toString());
	        }
	    };
	    /**
	     * @private
	     * @type {RegExp}
	     */
	    ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
	    return ChildrenNode;
	}());
	exports.ChildrenNode = ChildrenNode;
	/**
	 * @constructor
	 * @extends {ChildrenNode}
	 * @private
	 */
	var MaxNode = /** @class */ (function (_super) {
	    __extends(MaxNode, _super);
	    function MaxNode() {
	        return _super.call(this, new SortedMap_1.SortedMap(comparators_1.NAME_COMPARATOR), ChildrenNode.EMPTY_NODE, IndexMap_1.IndexMap.Default) || this;
	    }
	    MaxNode.prototype.compareTo = function (other) {
	        if (other === this) {
	            return 0;
	        }
	        else {
	            return 1;
	        }
	    };
	    MaxNode.prototype.equals = function (other) {
	        // Not that we every compare it, but MAX_NODE is only ever equal to itself
	        return other === this;
	    };
	    MaxNode.prototype.getPriority = function () {
	        return this;
	    };
	    MaxNode.prototype.getImmediateChild = function (childName) {
	        return ChildrenNode.EMPTY_NODE;
	    };
	    MaxNode.prototype.isEmpty = function () {
	        return false;
	    };
	    return MaxNode;
	}(ChildrenNode));
	exports.MaxNode = MaxNode;
	/**
	 * Marker that will sort higher than any other snapshot.
	 * @type {!MAX_NODE}
	 * @const
	 */
	exports.MAX_NODE = new MaxNode();
	Object.defineProperties(Node_1.NamedNode, {
	    MIN: {
	        value: new Node_1.NamedNode(util_2.MIN_NAME, ChildrenNode.EMPTY_NODE)
	    },
	    MAX: {
	        value: new Node_1.NamedNode(util_2.MAX_NAME, exports.MAX_NODE)
	    }
	});
	/**
	 * Reference Extensions
	 */
	KeyIndex_1.KeyIndex.__EMPTY_NODE = ChildrenNode.EMPTY_NODE;
	LeafNode_1.LeafNode.__childrenNodeConstructor = ChildrenNode;
	snap_1.setMaxNode(exports.MAX_NODE);
	PriorityIndex_1.setMaxNode(exports.MAX_NODE);
	
	//# sourceMappingURL=ChildrenNode.js.map


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(10);
	/**
	 * PersistencePromise<> is essentially a re-implementation of Promise<> except
	 * it has a .next() method instead of .then() and .next() and .catch() callbacks
	 * are executed synchronously when a PersistencePromise resolves rather than
	 * asynchronously (Promise<> implementations use setImmediate() or similar).
	 *
	 * This is necessary to interoperate with IndexedDB which will automatically
	 * commit transactions if control is returned to the event loop without
	 * synchronously initiating another operation on the transaction.
	 *
	 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
	 * Promises.
	 */
	var PersistencePromise = /** @class */ (function () {
	    function PersistencePromise(callback) {
	        var _this = this;
	        // NOTE: next/catchCallback will always point to our own wrapper functions,
	        // not the user's raw next() or catch() callbacks.
	        this.nextCallback = null;
	        this.catchCallback = null;
	        // When the operation resolves, we'll set result or error and mark isDone.
	        this.result = undefined;
	        this.error = null;
	        this.isDone = false;
	        // Set to true when .then() or .catch() are called and prevents additional
	        // chaining.
	        this.callbackAttached = false;
	        callback(function (value) {
	            _this.isDone = true;
	            _this.result = value;
	            if (_this.nextCallback) {
	                // value should be defined unless T is Void, but we can't express
	                // that in the type system.
	                _this.nextCallback(value);
	            }
	        }, function (error) {
	            _this.isDone = true;
	            _this.error = error;
	            if (_this.catchCallback) {
	                _this.catchCallback(error);
	            }
	        });
	    }
	    PersistencePromise.prototype.catch = function (fn) {
	        return this.next(undefined, fn);
	    };
	    PersistencePromise.prototype.next = function (nextFn, catchFn) {
	        var _this = this;
	        if (this.callbackAttached) {
	            assert_1.fail('Called next() or catch() twice for PersistencePromise');
	        }
	        this.callbackAttached = true;
	        if (this.isDone) {
	            if (!this.error) {
	                return this.wrapSuccess(nextFn, this.result);
	            }
	            else {
	                return this.wrapFailure(catchFn, this.error);
	            }
	        }
	        else {
	            return new PersistencePromise(function (resolve, reject) {
	                _this.nextCallback = function (value) {
	                    _this.wrapSuccess(nextFn, value).next(resolve, reject);
	                };
	                _this.catchCallback = function (error) {
	                    _this.wrapFailure(catchFn, error).next(resolve, reject);
	                };
	            });
	        }
	    };
	    PersistencePromise.prototype.toPromise = function () {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            _this.next(resolve, reject);
	        });
	    };
	    PersistencePromise.prototype.wrapUserFunction = function (fn) {
	        try {
	            var result = fn();
	            if (result instanceof PersistencePromise) {
	                return result;
	            }
	            else {
	                return PersistencePromise.resolve(result);
	            }
	        }
	        catch (e) {
	            return PersistencePromise.reject(e);
	        }
	    };
	    PersistencePromise.prototype.wrapSuccess = function (nextFn, value) {
	        if (nextFn) {
	            return this.wrapUserFunction(function () { return nextFn(value); });
	        }
	        else {
	            // If there's no nextFn, then R must be the same as T but we
	            // can't express that in the type system.
	            return PersistencePromise.resolve(value);
	        }
	    };
	    PersistencePromise.prototype.wrapFailure = function (catchFn, error) {
	        if (catchFn) {
	            return this.wrapUserFunction(function () { return catchFn(error); });
	        }
	        else {
	            return PersistencePromise.reject(error);
	        }
	    };
	    PersistencePromise.resolve = function (result) {
	        return new PersistencePromise(function (resolve, reject) {
	            resolve(result);
	        });
	    };
	    PersistencePromise.reject = function (error) {
	        return new PersistencePromise(function (resolve, reject) {
	            reject(error);
	        });
	    };
	    PersistencePromise.waitFor = function (all) {
	        return all.reduce(function (promise, nextPromise, idx) {
	            return promise.next(function () {
	                return nextPromise;
	            });
	        }, PersistencePromise.resolve());
	    };
	    PersistencePromise.map = function (all) {
	        var results = [];
	        var first = true;
	        // initial is ignored, so we can cheat on the type.
	        var initial = PersistencePromise.resolve(null);
	        return all
	            .reduce(function (promise, nextPromise) {
	            return promise.next(function (result) {
	                if (!first) {
	                    results.push(result);
	                }
	                first = false;
	                return nextPromise;
	            });
	        }, initial)
	            .next(function (result) {
	            results.push(result);
	            return results;
	        });
	    };
	    return PersistencePromise;
	}());
	exports.PersistencePromise = PersistencePromise;
	
	//# sourceMappingURL=persistence_promise.js.map


/***/ },
/* 30 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 *
	 * @param {!string} name
	 * @param {!Node} node
	 * @constructor
	 * @struct
	 */
	var NamedNode = /** @class */ (function () {
	    function NamedNode(name, node) {
	        this.name = name;
	        this.node = node;
	    }
	    /**
	     *
	     * @param {!string} name
	     * @param {!Node} node
	     * @return {NamedNode}
	     */
	    NamedNode.Wrap = function (name, node) {
	        return new NamedNode(name, node);
	    };
	    return NamedNode;
	}());
	exports.NamedNode = NamedNode;
	
	//# sourceMappingURL=Node.js.map


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var timestamp_1 = __webpack_require__(55);
	/**
	 * A version of a document in Firestore. This corresponds to the version
	 * timestamp, such as update_time or read_time.
	 */
	var SnapshotVersion = /** @class */ (function () {
	    function SnapshotVersion(timestamp) {
	        this.timestamp = timestamp;
	    }
	    // TODO(b/34176344): Once we no longer need to use the old alpha protos,
	    // delete this constructor and use a timestamp-backed version everywhere.
	    SnapshotVersion.fromMicroseconds = function (value) {
	        var seconds = Math.floor(value / 1e6);
	        var nanos = (value % 1e6) * 1e3;
	        return new SnapshotVersion(new timestamp_1.Timestamp(seconds, nanos));
	    };
	    SnapshotVersion.fromTimestamp = function (value) {
	        return new SnapshotVersion(value);
	    };
	    SnapshotVersion.forDeletedDoc = function () {
	        return SnapshotVersion.MIN;
	    };
	    SnapshotVersion.prototype.compareTo = function (other) {
	        return this.timestamp.compareTo(other.timestamp);
	    };
	    SnapshotVersion.prototype.equals = function (other) {
	        return this.timestamp.equals(other.timestamp);
	    };
	    /** Returns a number representation of the version for use in spec tests. */
	    SnapshotVersion.prototype.toMicroseconds = function () {
	        // Convert to microseconds.
	        return this.timestamp.seconds * 1e6 + this.timestamp.nanos / 1000;
	    };
	    SnapshotVersion.prototype.toString = function () {
	        return 'SnapshotVersion(' + this.timestamp.toString() + ')';
	    };
	    SnapshotVersion.prototype.toTimestamp = function () {
	        return this.timestamp;
	    };
	    SnapshotVersion.MIN = new SnapshotVersion(new timestamp_1.Timestamp(0, 0));
	    return SnapshotVersion;
	}());
	exports.SnapshotVersion = SnapshotVersion;
	
	//# sourceMappingURL=snapshot_version.js.map


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(10);
	var document_key_1 = __webpack_require__(22);
	var Document = /** @class */ (function () {
	    function Document(key, version, data, options) {
	        this.key = key;
	        this.version = version;
	        this.data = data;
	        this.hasLocalMutations = options.hasLocalMutations;
	    }
	    Document.prototype.field = function (path) {
	        return this.data.field(path);
	    };
	    Document.prototype.fieldValue = function (path) {
	        var field = this.field(path);
	        return field ? field.value() : undefined;
	    };
	    Document.prototype.value = function () {
	        return this.data.value();
	    };
	    Document.prototype.equals = function (other) {
	        return (other instanceof Document &&
	            this.key.equals(other.key) &&
	            this.version.equals(other.version) &&
	            this.data.equals(other.data) &&
	            this.hasLocalMutations === other.hasLocalMutations);
	    };
	    Document.prototype.toString = function () {
	        return ("Document(" + this.key + ", " + this.version + ", " + this.data.toString() + ", " +
	            ("{hasLocalMutations: " + this.hasLocalMutations + "})"));
	    };
	    Document.compareByKey = function (d1, d2) {
	        return document_key_1.DocumentKey.comparator(d1.key, d2.key);
	    };
	    Document.compareByField = function (field, d1, d2) {
	        var v1 = d1.field(field);
	        var v2 = d2.field(field);
	        if (v1 !== undefined && v2 !== undefined) {
	            return v1.compareTo(v2);
	        }
	        else {
	            return assert_1.fail("Trying to compare documents on fields that don't exist");
	        }
	    };
	    return Document;
	}());
	exports.Document = Document;
	/**
	 * A class representing a deleted document.
	 * Version is set to 0 if we don't point to any specific time, otherwise it
	 * denotes time we know it didn't exist at.
	 */
	var NoDocument = /** @class */ (function () {
	    function NoDocument(key, version) {
	        this.key = key;
	        this.version = version;
	    }
	    NoDocument.prototype.toString = function () {
	        return "NoDocument(" + this.key + ", " + this.version + ")";
	    };
	    NoDocument.prototype.equals = function (other) {
	        return (other && other.version.equals(this.version) && other.key.equals(this.key));
	    };
	    NoDocument.compareByKey = function (d1, d2) {
	        return document_key_1.DocumentKey.comparator(d1.key, d2.key);
	    };
	    return NoDocument;
	}());
	exports.NoDocument = NoDocument;
	
	//# sourceMappingURL=document.js.map


/***/ },
/* 33 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @return False if the object is undefined or null, true otherwise.
	 */
	function isDef(p) {
	    return p != null;
	}
	exports.isDef = isDef;
	function isJustDef(p) {
	    return p !== void 0;
	}
	exports.isJustDef = isJustDef;
	function isFunction(p) {
	    return typeof p === 'function';
	}
	exports.isFunction = isFunction;
	function isObject(p) {
	    return typeof p === 'object';
	}
	exports.isObject = isObject;
	function isNonNullObject(p) {
	    return isObject(p) && p !== null;
	}
	exports.isNonNullObject = isNonNullObject;
	function isNonArrayObject(p) {
	    return isObject(p) && !Array.isArray(p);
	}
	exports.isNonArrayObject = isNonArrayObject;
	function isString(p) {
	    return typeof p === 'string' || p instanceof String;
	}
	exports.isString = isString;
	function isNumber(p) {
	    return typeof p === 'number' || p instanceof Number;
	}
	exports.isNumber = isNumber;
	function isNativeBlob(p) {
	    return isNativeBlobDefined() && p instanceof Blob;
	}
	exports.isNativeBlob = isNativeBlob;
	function isNativeBlobDefined() {
	    return typeof Blob !== 'undefined';
	}
	exports.isNativeBlobDefined = isNativeBlobDefined;
	
	//# sourceMappingURL=type.js.map


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var firebaseApp_1 = __webpack_require__(417);
	exports.firebase = firebaseApp_1.createFirebaseNamespace();
	exports.default = exports.firebase;
	
	
	//# sourceMappingURL=index.js.map


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(10);
	function contains(obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	}
	exports.contains = contains;
	function get(obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key) ? obj[key] : null;
	}
	exports.get = get;
	function size(obj) {
	    var count = 0;
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            count++;
	        }
	    }
	    return count;
	}
	exports.size = size;
	/** Returns the given value if it's defined or the defaultValue otherwise. */
	function defaulted(value, defaultValue) {
	    return value !== undefined ? value : defaultValue;
	}
	exports.defaulted = defaulted;
	function forEachNumber(obj, fn) {
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            var num = parseInt(key, 10);
	            if (!isNaN(num)) {
	                fn(num, obj[key]);
	            }
	        }
	    }
	}
	exports.forEachNumber = forEachNumber;
	function forEach(obj, fn) {
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            fn(key, obj[key]);
	        }
	    }
	}
	exports.forEach = forEach;
	function lookupOrInsert(obj, key, valFn) {
	    if (!contains(obj, key)) {
	        obj[key] = valFn();
	    }
	    return obj[key];
	}
	exports.lookupOrInsert = lookupOrInsert;
	function isEmpty(obj) {
	    assert_1.assert(obj != null && typeof obj === 'object', 'isEmpty() expects object parameter.');
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            return false;
	        }
	    }
	    return true;
	}
	exports.isEmpty = isEmpty;
	function shallowCopy(obj) {
	    assert_1.assert(obj && typeof obj === 'object', 'shallowCopy() expects object parameter.');
	    var result = {};
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            result[key] = obj[key];
	        }
	    }
	    return result;
	}
	exports.shallowCopy = shallowCopy;
	
	//# sourceMappingURL=obj.js.map


/***/ },
/* 37 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(672)();
	}


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14),
	    _assign = __webpack_require__(16);
	
	var CallbackQueue = __webpack_require__(368);
	var PooledClass = __webpack_require__(53);
	var ReactFeatureFlags = __webpack_require__(373);
	var ReactReconciler = __webpack_require__(63);
	var Transaction = __webpack_require__(109);
	
	var invariant = __webpack_require__(11);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(10);
	/**
	 * Provides singleton helpers where setup code can inject a platform at runtime.
	 * setPlatform needs to be set before Firestore is used and must be set exactly
	 * once.
	 */
	var PlatformSupport = /** @class */ (function () {
	    function PlatformSupport() {
	    }
	    PlatformSupport.setPlatform = function (platform) {
	        if (PlatformSupport.platform) {
	            assert_1.fail('Platform already defined');
	        }
	        PlatformSupport.platform = platform;
	    };
	    PlatformSupport.getPlatform = function () {
	        if (!PlatformSupport.platform) {
	            assert_1.fail('Platform not set');
	        }
	        return PlatformSupport.platform;
	    };
	    return PlatformSupport;
	}());
	exports.PlatformSupport = PlatformSupport;
	/**
	 * Returns the representation of an empty "proto" byte string for the
	 * platform.
	 */
	function emptyByteString() {
	    return PlatformSupport.getPlatform().emptyByteString;
	}
	exports.emptyByteString = emptyByteString;
	
	//# sourceMappingURL=platform.js.map


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var constants_1 = __webpack_require__(99);
	var FirebaseStorageError = /** @class */ (function () {
	    function FirebaseStorageError(code, message) {
	        this.code_ = prependCode(code);
	        this.message_ = 'Firebase Storage: ' + message;
	        this.serverResponse_ = null;
	        this.name_ = 'FirebaseError';
	    }
	    FirebaseStorageError.prototype.codeProp = function () {
	        return this.code;
	    };
	    FirebaseStorageError.prototype.codeEquals = function (code) {
	        return prependCode(code) === this.codeProp();
	    };
	    FirebaseStorageError.prototype.serverResponseProp = function () {
	        return this.serverResponse_;
	    };
	    FirebaseStorageError.prototype.setServerResponseProp = function (serverResponse) {
	        this.serverResponse_ = serverResponse;
	    };
	    Object.defineProperty(FirebaseStorageError.prototype, "name", {
	        get: function () {
	            return this.name_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseStorageError.prototype, "code", {
	        get: function () {
	            return this.code_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseStorageError.prototype, "message", {
	        get: function () {
	            return this.message_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseStorageError.prototype, "serverResponse", {
	        get: function () {
	            return this.serverResponse_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return FirebaseStorageError;
	}());
	exports.FirebaseStorageError = FirebaseStorageError;
	exports.errors = {};
	exports.Code = {
	    // Shared between all platforms
	    UNKNOWN: 'unknown',
	    OBJECT_NOT_FOUND: 'object-not-found',
	    BUCKET_NOT_FOUND: 'bucket-not-found',
	    PROJECT_NOT_FOUND: 'project-not-found',
	    QUOTA_EXCEEDED: 'quota-exceeded',
	    UNAUTHENTICATED: 'unauthenticated',
	    UNAUTHORIZED: 'unauthorized',
	    RETRY_LIMIT_EXCEEDED: 'retry-limit-exceeded',
	    INVALID_CHECKSUM: 'invalid-checksum',
	    CANCELED: 'canceled',
	    // JS specific
	    INVALID_EVENT_NAME: 'invalid-event-name',
	    INVALID_URL: 'invalid-url',
	    INVALID_DEFAULT_BUCKET: 'invalid-default-bucket',
	    NO_DEFAULT_BUCKET: 'no-default-bucket',
	    CANNOT_SLICE_BLOB: 'cannot-slice-blob',
	    SERVER_FILE_WRONG_SIZE: 'server-file-wrong-size',
	    NO_DOWNLOAD_URL: 'no-download-url',
	    INVALID_ARGUMENT: 'invalid-argument',
	    INVALID_ARGUMENT_COUNT: 'invalid-argument-count',
	    APP_DELETED: 'app-deleted',
	    INVALID_ROOT_OPERATION: 'invalid-root-operation',
	    INVALID_FORMAT: 'invalid-format',
	    INTERNAL_ERROR: 'internal-error'
	};
	function prependCode(code) {
	    return 'storage/' + code;
	}
	exports.prependCode = prependCode;
	function unknown() {
	    var message = 'An unknown error occurred, please check the error payload for ' +
	        'server response.';
	    return new FirebaseStorageError(exports.Code.UNKNOWN, message);
	}
	exports.unknown = unknown;
	function objectNotFound(path) {
	    return new FirebaseStorageError(exports.Code.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
	}
	exports.objectNotFound = objectNotFound;
	function bucketNotFound(bucket) {
	    return new FirebaseStorageError(exports.Code.BUCKET_NOT_FOUND, "Bucket '" + bucket + "' does not exist.");
	}
	exports.bucketNotFound = bucketNotFound;
	function projectNotFound(project) {
	    return new FirebaseStorageError(exports.Code.PROJECT_NOT_FOUND, "Project '" + project + "' does not exist.");
	}
	exports.projectNotFound = projectNotFound;
	function quotaExceeded(bucket) {
	    return new FirebaseStorageError(exports.Code.QUOTA_EXCEEDED, "Quota for bucket '" +
	        bucket +
	        "' exceeded, please view quota on " +
	        'https://firebase.google.com/pricing/.');
	}
	exports.quotaExceeded = quotaExceeded;
	function unauthenticated() {
	    var message = 'User is not authenticated, please authenticate using Firebase ' +
	        'Authentication and try again.';
	    return new FirebaseStorageError(exports.Code.UNAUTHENTICATED, message);
	}
	exports.unauthenticated = unauthenticated;
	function unauthorized(path) {
	    return new FirebaseStorageError(exports.Code.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
	}
	exports.unauthorized = unauthorized;
	function retryLimitExceeded() {
	    return new FirebaseStorageError(exports.Code.RETRY_LIMIT_EXCEEDED, 'Max retry time for operation exceeded, please try again.');
	}
	exports.retryLimitExceeded = retryLimitExceeded;
	function invalidChecksum(path, checksum, calculated) {
	    return new FirebaseStorageError(exports.Code.INVALID_CHECKSUM, "Uploaded/downloaded object '" +
	        path +
	        "' has checksum '" +
	        checksum +
	        "' which does not match '" +
	        calculated +
	        "'. Please retry the upload/download.");
	}
	exports.invalidChecksum = invalidChecksum;
	function canceled() {
	    return new FirebaseStorageError(exports.Code.CANCELED, 'User canceled the upload/download.');
	}
	exports.canceled = canceled;
	function invalidEventName(name) {
	    return new FirebaseStorageError(exports.Code.INVALID_EVENT_NAME, "Invalid event name '" + name + "'.");
	}
	exports.invalidEventName = invalidEventName;
	function invalidUrl(url) {
	    return new FirebaseStorageError(exports.Code.INVALID_URL, "Invalid URL '" + url + "'.");
	}
	exports.invalidUrl = invalidUrl;
	function invalidDefaultBucket(bucket) {
	    return new FirebaseStorageError(exports.Code.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
	}
	exports.invalidDefaultBucket = invalidDefaultBucket;
	function noDefaultBucket() {
	    return new FirebaseStorageError(exports.Code.NO_DEFAULT_BUCKET, 'No default bucket ' +
	        "found. Did you set the '" +
	        constants_1.configOption +
	        "' property when initializing the app?");
	}
	exports.noDefaultBucket = noDefaultBucket;
	function cannotSliceBlob() {
	    return new FirebaseStorageError(exports.Code.CANNOT_SLICE_BLOB, 'Cannot slice blob for upload. Please retry the upload.');
	}
	exports.cannotSliceBlob = cannotSliceBlob;
	function serverFileWrongSize() {
	    return new FirebaseStorageError(exports.Code.SERVER_FILE_WRONG_SIZE, 'Server recorded incorrect upload file size, please retry the upload.');
	}
	exports.serverFileWrongSize = serverFileWrongSize;
	function noDownloadURL() {
	    return new FirebaseStorageError(exports.Code.NO_DOWNLOAD_URL, 'The given file does not have any download URLs.');
	}
	exports.noDownloadURL = noDownloadURL;
	function invalidArgument(index, fnName, message) {
	    return new FirebaseStorageError(exports.Code.INVALID_ARGUMENT, 'Invalid argument in `' + fnName + '` at index ' + index + ': ' + message);
	}
	exports.invalidArgument = invalidArgument;
	function invalidArgumentCount(argMin, argMax, fnName, real) {
	    var countPart;
	    var plural;
	    if (argMin === argMax) {
	        countPart = argMin;
	        plural = argMin === 1 ? 'argument' : 'arguments';
	    }
	    else {
	        countPart = 'between ' + argMin + ' and ' + argMax;
	        plural = 'arguments';
	    }
	    return new FirebaseStorageError(exports.Code.INVALID_ARGUMENT_COUNT, 'Invalid argument count in `' +
	        fnName +
	        '`: Expected ' +
	        countPart +
	        ' ' +
	        plural +
	        ', received ' +
	        real +
	        '.');
	}
	exports.invalidArgumentCount = invalidArgumentCount;
	function appDeleted() {
	    return new FirebaseStorageError(exports.Code.APP_DELETED, 'The Firebase app was deleted.');
	}
	exports.appDeleted = appDeleted;
	/**
	 * @param name The name of the operation that was invalid.
	 */
	function invalidRootOperation(name) {
	    return new FirebaseStorageError(exports.Code.INVALID_ROOT_OPERATION, "The operation '" +
	        name +
	        "' cannot be performed on a root reference, create a non-root " +
	        "reference using child, such as .child('file.png').");
	}
	exports.invalidRootOperation = invalidRootOperation;
	/**
	 * @param format The format that was not valid.
	 * @param message A message describing the format violation.
	 */
	function invalidFormat(format, message) {
	    return new FirebaseStorageError(exports.Code.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
	}
	exports.invalidFormat = invalidFormat;
	/**
	 * @param message A message describing the internal error.
	 */
	function internalError(message) {
	    throw new FirebaseStorageError(exports.Code.INTERNAL_ERROR, 'Internal error: ' + message);
	}
	exports.internalError = internalError;
	
	//# sourceMappingURL=error.js.map


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	*  filename: ej2-buttons.umd.min.js
	*  version : 19.4.55
	*  Copyright Syncfusion Inc. 2001 - 2020. All rights reserved.
	*  Use of this code is subject to the terms of our license.
	*  A copy of the current license can be obtained at any time by e-mailing
	*  licensing@syncfusion.com. Any infringement will be prosecuted under
	*  applicable laws. 
	*/
	!function(e,t){ true?t(exports,__webpack_require__(23)):"function"==typeof define&&define.amd?define(["exports","@syncfusion/ej2-base"],t):t(e.ej={},e.ej2Base)}(this,function(e,t){"use strict";function i(e,i,s,n,r,a){var l=n;if(n.tagName===i){var o=t.getValue("ej2_instances",n);l=e("input",{attrs:{type:s}});for(var c=["change","cssClass","label","labelPosition","id"],h=0,p=n.attributes.length;h<p;h++)-1===c.indexOf(n.attributes[h].nodeName)&&l.setAttribute(n.attributes[h].nodeName,n.attributes[h].nodeValue);t.attributes(n,{class:r,role:a,"aria-checked":"false"}),n.appendChild(l),t.setValue("ej2_instances",o,l),t.deleteObject(n,"ej2_instances")}return l}function s(e){for(var t,i=e.childNodes,s=0;s<i.length;s++)if(3===(t=i[s]).nodeType)return t;return null}function n(e,i,s){"INPUT"===s?(i.parentNode.insertBefore(e.element,i),t.detach(i),e.element.checked=!1,["name","value","disabled"].forEach(function(t){e.element.removeAttribute(t)})):(["role","aria-checked","class"].forEach(function(e){i.removeAttribute(e)}),i.innerHTML="")}function r(e,s,n,r,a){r=i(e.createElement,s,"checkbox",r,n,a),e.element=r,"checkbox"!==e.element.getAttribute("type")&&e.element.setAttribute("type","checkbox"),e.element.id||(e.element.id=t.getUniqueID("e-"+a))}function a(e,t){if(t){var i=document.createEvent("MouseEvents");i.initEvent(e.type,!1,!0),t.dispatchEvent(i)}}function l(e,t){e.element.getAttribute("ejs-for")&&t.appendChild(e.createElement("input",{attrs:{name:e.name||e.element.name,value:"false",type:"hidden"}}))}var o=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),c=function(e,t,i,s){var n,r=arguments.length,a=r<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)a=Reflect.decorate(e,t,i,s);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(a=(r<3?n(a):r>3?n(t,i,a):n(t,i))||a);return r>3&&a&&Object.defineProperty(t,i,a),a},h=new t.Observer,p="e-rtl",d="e-btn",u="e-primary",m="e-icon-btn",f=function(e){function i(t,i){return e.call(this,t,i)||this}return o(i,e),i.prototype.preRender=function(){},i.prototype.render=function(){this.initialize(),this.removeRippleEffect=t.rippleEffect(this.element,{selector:"."+d}),this.renderComplete()},i.prototype.initialize=function(){if(this.cssClass&&t.addClass([this.element],this.cssClass.split(" ")),this.isPrimary&&this.element.classList.add(u),!t.isBlazor()||t.isBlazor()&&"progress-btn"!==this.getModuleName()){if(this.content){var e=this.enableHtmlSanitizer?t.SanitizeHtmlHelper.sanitize(this.content):this.content;this.element.innerHTML=e}this.setIconCss()}this.enableRtl&&this.element.classList.add(p),this.disabled?this.controlStatus(this.disabled):this.wireEvents()},i.prototype.controlStatus=function(e){this.element.disabled=e},i.prototype.setIconCss=function(){if(this.iconCss){var e=this.createElement("span",{className:"e-btn-icon "+this.iconCss});this.element.textContent.trim()?(e.classList.add("e-icon-"+this.iconPosition.toLowerCase()),"Top"!==this.iconPosition&&"Bottom"!==this.iconPosition||this.element.classList.add("e-"+this.iconPosition.toLowerCase()+"-icon-btn")):this.element.classList.add(m);var t=this.element.childNodes[0];!t||"Left"!==this.iconPosition&&"Top"!==this.iconPosition?this.element.appendChild(e):this.element.insertBefore(e,t)}},i.prototype.wireEvents=function(){this.isToggle&&t.EventHandler.add(this.element,"click",this.btnClickHandler,this)},i.prototype.unWireEvents=function(){this.isToggle&&t.EventHandler.remove(this.element,"click",this.btnClickHandler)},i.prototype.btnClickHandler=function(){this.element.classList.contains("e-active")?this.element.classList.remove("e-active"):this.element.classList.add("e-active")},i.prototype.destroy=function(){var i=[u,p,m,"e-success","e-info","e-danger","e-warning","e-flat","e-outline","e-small","e-bigger","e-active","e-round","e-top-icon-btn","e-bottom-icon-btn"];this.cssClass&&(i=i.concat(this.cssClass.split(" "))),e.prototype.destroy.call(this),t.removeClass([this.element],i),this.element.getAttribute("class")||this.element.removeAttribute("class"),this.disabled&&this.element.removeAttribute("disabled"),this.content&&(this.element.innerHTML=this.element.innerHTML.replace(this.content,""));var s=this.element.querySelector("span.e-btn-icon");s&&t.detach(s),this.unWireEvents(),t.isRippleEnabled&&this.removeRippleEffect()},i.prototype.getModuleName=function(){return"btn"},i.prototype.getPersistData=function(){return this.addOnPersist([])},i.Inject=function(){},i.prototype.onPropertyChanged=function(e,i){for(var n=this.element.querySelector("span.e-btn-icon"),r=0,a=Object.keys(e);r<a.length;r++){switch(a[r]){case"isPrimary":e.isPrimary?this.element.classList.add(u):this.element.classList.remove(u);break;case"disabled":this.controlStatus(e.disabled);break;case"iconCss":n?e.iconCss?(n.className="e-btn-icon "+e.iconCss,this.element.textContent.trim()&&("Left"===this.iconPosition?n.classList.add("e-icon-left"):n.classList.add("e-icon-right"))):t.detach(n):this.setIconCss();break;case"iconPosition":t.removeClass([this.element],["e-top-icon-btn","e-bottom-icon-btn"]),(n=this.element.querySelector("span.e-btn-icon"))&&t.detach(n),this.setIconCss();break;case"cssClass":i.cssClass&&t.removeClass([this.element],i.cssClass.split(" ")),e.cssClass&&t.addClass([this.element],e.cssClass.split(" "));break;case"enableRtl":e.enableRtl?this.element.classList.add(p):this.element.classList.remove(p);break;case"content":s(this.element)||this.element.classList.remove(m),(!t.isBlazor()||t.isBlazor()&&!this.isServerRendered&&"progress-btn"!==this.getModuleName())&&(this.enableHtmlSanitizer&&(e.content=t.SanitizeHtmlHelper.sanitize(e.content)),this.element.innerHTML=e.content,this.setIconCss());break;case"isToggle":e.isToggle?t.EventHandler.add(this.element,"click",this.btnClickHandler,this):(t.EventHandler.remove(this.element,"click",this.btnClickHandler),t.removeClass([this.element],["e-active"]))}}},i.prototype.click=function(){this.element.click()},i.prototype.focusIn=function(){this.element.focus()},c([t.Property("Left")],i.prototype,"iconPosition",void 0),c([t.Property("")],i.prototype,"iconCss",void 0),c([t.Property(!1)],i.prototype,"disabled",void 0),c([t.Property(!1)],i.prototype,"isPrimary",void 0),c([t.Property("")],i.prototype,"cssClass",void 0),c([t.Property("")],i.prototype,"content",void 0),c([t.Property(!1)],i.prototype,"isToggle",void 0),c([t.Property()],i.prototype,"locale",void 0),c([t.Property(!1)],i.prototype,"enableHtmlSanitizer",void 0),c([t.Event()],i.prototype,"created",void 0),i=c([t.NotifyPropertyChanges],i)}(t.Component),v=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),y=function(e,t,i,s){var n,r=arguments.length,a=r<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)a=Reflect.decorate(e,t,i,s);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(a=(r<3?n(a):r>3?n(t,i,a):n(t,i))||a);return r>3&&a&&Object.defineProperty(t,i,a),a},b="e-checkbox-disabled",g="e-frame",C="e-ripple-container",k="e-ripple-check",E="e-ripple-stop",H="e-checkbox-wrapper",S=["title","class","style","disabled","readonly","name","value"],A=function(e){function s(t,i){var s=e.call(this,t,i)||this;return s.isFocused=!1,s.isMouseClick=!1,s.clickTriggered=!1,s}return v(s,e),s.prototype.changeState=function(e){var i,s,n=this.getWrapper().getElementsByClassName(g)[0];t.isRippleEnabled&&(s=this.getWrapper().getElementsByClassName(C)[0]),"check"===e?(n.classList.remove("e-stop"),n.classList.add("e-check"),s&&(s.classList.remove(E),s.classList.add(k)),i="true",this.element.checked=!0):"uncheck"===e?(t.removeClass([n],["e-check","e-stop"]),s&&t.removeClass([s],[k,E]),i="false",this.element.checked=!1):(n.classList.remove("e-check"),n.classList.add("e-stop"),s&&(s.classList.remove(k),s.classList.add(E)),i="mixed",this.element.indeterminate=!0),this.getWrapper().setAttribute("aria-checked",i)},s.prototype.clickHandler=function(e){if("INPUT"===e.target.tagName&&this.clickTriggered)this.clickTriggered=!1;else{"SPAN"!==e.target.tagName&&"LABEL"!==e.target.tagName||(this.clickTriggered=!0),this.isMouseClick&&(this.focusOutHandler(),this.isMouseClick=!1),this.indeterminate?(this.changeState(this.checked?"check":"uncheck"),this.indeterminate=!1,this.element.indeterminate=!1):this.checked?(this.changeState("uncheck"),this.checked=!1):(this.changeState("check"),this.checked=!0);var t={checked:this.updateVueArrayModel(!1),event:e};this.trigger("change",t),e.stopPropagation()}},s.prototype.destroy=function(){var i=this,s=this.getWrapper();e.prototype.destroy.call(this),this.wrapper&&(s=this.wrapper,this.disabled||this.unWireEvents(),"INPUT"===this.tagName?(this.getWrapper()&&s.parentNode&&s.parentNode.insertBefore(this.element,s),t.detach(s),this.element.checked=!1,this.indeterminate&&(this.element.indeterminate=!1),["name","value","disabled"].forEach(function(e){i.element.removeAttribute(e)})):(["role","aria-checked","class"].forEach(function(e){s.removeAttribute(e)}),s.innerHTML=""))},s.prototype.focusHandler=function(){this.isFocused=!0},s.prototype.focusOutHandler=function(){var e=this.getWrapper();e&&e.classList.remove("e-focus"),this.isFocused=!1},s.prototype.getModuleName=function(){return"checkbox"},s.prototype.getPersistData=function(){return this.addOnPersist(["checked","indeterminate"])},s.prototype.getWrapper=function(){return this.element&&this.element.parentElement?this.element.parentElement.parentElement:null},s.prototype.initialize=function(){t.isNullOrUndefined(this.initialCheckedValue)&&(this.initialCheckedValue=this.checked),this.name&&this.element.setAttribute("name",this.name),this.value&&(this.element.setAttribute("value",this.value),this.isVue&&"boolean"==typeof this.value&&!0===this.value&&this.setProperties({checked:!0},!0)),this.checked&&this.changeState("check"),this.indeterminate&&this.changeState(),this.disabled&&this.setDisabled()},s.prototype.initWrapper=function(){var e=this.element.parentElement;e.classList.contains(H)||(e=this.createElement("div",{className:H,attrs:{role:"checkbox","aria-checked":"false"}}),this.element.parentNode.insertBefore(e,this.element));var i=this.createElement("label",{attrs:{for:this.element.id}}),s=this.createElement("span",{className:"e-icons "+g});if(e.classList.add("e-wrapper"),this.enableRtl&&e.classList.add("e-rtl"),this.cssClass&&t.addClass([e],this.cssClass.split(" ")),e.appendChild(i),i.appendChild(this.element),l(this,i),i.appendChild(s),t.isRippleEnabled){var n=this.createElement("span",{className:C});"Before"===this.labelPosition?i.appendChild(n):i.insertBefore(n,s),t.rippleEffect(n,{duration:400,isCenterRipple:!0})}this.label&&this.setText(this.label)},s.prototype.keyUpHandler=function(){this.isFocused&&this.getWrapper().classList.add("e-focus")},s.prototype.labelMouseDownHandler=function(e){this.isMouseClick=!0;a(e,this.getWrapper().getElementsByClassName(C)[0])},s.prototype.labelMouseUpHandler=function(e){this.isMouseClick=!0;var t=this.getWrapper().getElementsByClassName(C)[0];if(t){for(var i=t.querySelectorAll(".e-ripple-element"),s=0;s<i.length-1;s++)t.removeChild(t.childNodes[s]);a(e,t)}},s.prototype.onPropertyChanged=function(e,i){for(var s=this.getWrapper(),n=0,r=Object.keys(e);n<r.length;n++){switch(r[n]){case"checked":this.indeterminate=!1,this.element.indeterminate=!1,this.changeState(e.checked?"check":"uncheck");break;case"indeterminate":e.indeterminate?this.changeState():(this.element.indeterminate=!1,this.changeState(this.checked?"check":"uncheck"));break;case"disabled":e.disabled?(this.setDisabled(),this.wrapper=this.getWrapper(),this.unWireEvents()):(this.element.disabled=!1,s.classList.remove(b),s.setAttribute("aria-disabled","false"),this.wireEvents());break;case"cssClass":i.cssClass&&t.removeClass([s],i.cssClass.split(" ")),e.cssClass&&t.addClass([s],e.cssClass.split(" "));break;case"enableRtl":e.enableRtl?s.classList.add("e-rtl"):s.classList.remove("e-rtl");break;case"label":this.setText(e.label);break;case"labelPosition":var a=s.getElementsByClassName("e-label")[0],l=s.getElementsByTagName("label")[0];t.detach(a),"After"===e.labelPosition?l.appendChild(a):l.insertBefore(a,s.getElementsByClassName(g)[0]);break;case"name":this.element.setAttribute("name",e.name);break;case"value":if(this.isVue&&"object"==typeof e.value)break;this.element.setAttribute("value",e.value);break;case"htmlAttributes":this.updateHtmlAttributeToWrapper()}}},s.prototype.preRender=function(){var e=this.element;this.tagName=this.element.tagName,e=i(this.createElement,"EJS-CHECKBOX","checkbox",e,H,"checkbox"),this.element=e,"checkbox"!==this.element.getAttribute("type")&&this.element.setAttribute("type","checkbox"),this.element.id||(this.element.id=t.getUniqueID("e-"+this.getModuleName()))},s.prototype.render=function(){this.initWrapper(),this.initialize(),this.disabled||this.wireEvents(),this.updateHtmlAttributeToWrapper(),this.updateVueArrayModel(!0),this.renderComplete(),this.wrapper=this.getWrapper()},s.prototype.setDisabled=function(){var e=this.getWrapper();this.element.disabled=!0,e.classList.add(b),e.setAttribute("aria-disabled","true")},s.prototype.setText=function(e){var i=this.getWrapper();if(i){var s=i.getElementsByClassName("e-label")[0];if(s)s.textContent=e;else{e=this.enableHtmlSanitizer?t.SanitizeHtmlHelper.sanitize(e):e,s=this.createElement("span",{className:"e-label",innerHTML:e});var n=i.getElementsByTagName("label")[0];"Before"===this.labelPosition?n.insertBefore(s,i.getElementsByClassName(g)[0]):n.appendChild(s)}}},s.prototype.changeHandler=function(e){e.stopPropagation()},s.prototype.formResetHandler=function(){this.checked=this.initialCheckedValue,this.element.checked=this.initialCheckedValue},s.prototype.unWireEvents=function(){var e=this.wrapper;t.EventHandler.remove(e,"click",this.clickHandler),t.EventHandler.remove(this.element,"keyup",this.keyUpHandler),t.EventHandler.remove(this.element,"focus",this.focusHandler),t.EventHandler.remove(this.element,"focusout",this.focusOutHandler);var i=e.getElementsByTagName("label")[0];t.EventHandler.remove(i,"mousedown",this.labelMouseDownHandler),t.EventHandler.remove(i,"mouseup",this.labelMouseUpHandler);var s=t.closest(this.element,"form");s&&t.EventHandler.remove(s,"reset",this.formResetHandler),"EJS-CHECKBOX"===this.tagName&&t.EventHandler.remove(this.element,"change",this.changeHandler)},s.prototype.wireEvents=function(){var e=this.getWrapper();t.EventHandler.add(e,"click",this.clickHandler,this),t.EventHandler.add(this.element,"keyup",this.keyUpHandler,this),t.EventHandler.add(this.element,"focus",this.focusHandler,this),t.EventHandler.add(this.element,"focusout",this.focusOutHandler,this);var i=e.getElementsByTagName("label")[0];t.EventHandler.add(i,"mousedown",this.labelMouseDownHandler,this),t.EventHandler.add(i,"mouseup",this.labelMouseUpHandler,this);var s=t.closest(this.element,"form");s&&t.EventHandler.add(s,"reset",this.formResetHandler,this),"EJS-CHECKBOX"===this.tagName&&t.EventHandler.add(this.element,"change",this.changeHandler,this)},s.prototype.updateVueArrayModel=function(e){if(this.isVue&&"object"==typeof this.value){var t=this.element.value;if(t&&this.value){if(!e){var i=this.value.indexOf(t);return this.checked?i<0&&this.value.push(t):i>-1&&this.value.splice(i,1),this.value}for(var s=0;s<this.value.length;s++)t===this.value[s]&&(this.changeState("check"),this.setProperties({checked:!0},!0))}}return this.element.checked},s.prototype.updateHtmlAttributeToWrapper=function(){if(!t.isNullOrUndefined(this.htmlAttributes))for(var e=0,i=Object.keys(this.htmlAttributes);e<i.length;e++){var s=i[e];if(S.indexOf(s)>-1){var n=this.getWrapper();if("class"===s)t.addClass([n],this.htmlAttributes[s].split(" "));else if("title"===s)n.setAttribute(s,this.htmlAttributes[s]);else if("style"===s){this.getWrapper().getElementsByClassName(g)[0].setAttribute(s,this.htmlAttributes[s])}else this.element.setAttribute(s,this.htmlAttributes[s])}}},s.prototype.click=function(){this.element.click()},s.prototype.focusIn=function(){this.element.focus()},y([t.Event()],s.prototype,"change",void 0),y([t.Event()],s.prototype,"created",void 0),y([t.Property(!1)],s.prototype,"checked",void 0),y([t.Property("")],s.prototype,"cssClass",void 0),y([t.Property(!1)],s.prototype,"disabled",void 0),y([t.Property(!1)],s.prototype,"indeterminate",void 0),y([t.Property("")],s.prototype,"label",void 0),y([t.Property("After")],s.prototype,"labelPosition",void 0),y([t.Property("")],s.prototype,"name",void 0),y([t.Property("")],s.prototype,"value",void 0),y([t.Property(!1)],s.prototype,"enableHtmlSanitizer",void 0),y([t.Property({})],s.prototype,"htmlAttributes",void 0),s=y([t.NotifyPropertyChanges],s)}(t.Component),P=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),x=function(e,t,i,s){var n,r=arguments.length,a=r<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)a=Reflect.decorate(e,t,i,s);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(a=(r<3?n(a):r>3?n(t,i,a):n(t,i))||a);return r>3&&a&&Object.defineProperty(t,i,a),a},L="e-ripple-container",N="e-radio-wrapper",T=["title","class","style","disabled","readonly","name","value"],w=function(e){function s(t,i){var s=e.call(this,t,i)||this;return s.isFocused=!1,s}P(s,e),n=s,s.prototype.changeHandler=function(e){this.checked=!0,this.dataBind();var t=this.element.getAttribute("value");t=this.isVue&&t?this.element.value:this.value,this.trigger("change",{value:t,event:e}),"EJS-RADIOBUTTON"===this.tagName&&e.stopPropagation()},s.prototype.updateChange=function(){for(var e,i,s=this.getRadioGroup(),r=0;r<s.length;r++)(e=s[r])!==this.element&&((i=t.getInstance(e,n)).checked=!1,"EJS-RADIOBUTTON"===this.tagName&&(i.angularValue=this.value))},s.prototype.destroy=function(){var i=this,s=this.wrapper;e.prototype.destroy.call(this),s&&(this.disabled||this.unWireEvents(),"INPUT"===this.tagName?(s.parentNode&&s.parentNode.insertBefore(this.element,s),t.detach(s),this.element.checked=!1,["name","value","disabled"].forEach(function(e){i.element.removeAttribute(e)})):(["role","aria-checked","class"].forEach(function(e){s.removeAttribute(e)}),s.innerHTML=""))},s.prototype.focusHandler=function(){this.isFocused=!0},s.prototype.focusOutHandler=function(){var e=this.getLabel();e&&e.classList.remove("e-focus")},s.prototype.getModuleName=function(){return"radio"},s.prototype.getSelectedValue=function(){for(var e,t=this.getRadioGroup(),i=0,s=t.length;i<s;i++)if((e=t[i]).checked)return e.value;return""},s.prototype.getRadioGroup=function(){return document.querySelectorAll('input.e-radio[name="'+this.element.getAttribute("name")+'"]')},s.prototype.getPersistData=function(){return this.addOnPersist(["checked"])},s.prototype.getWrapper=function(){return this.element?this.element.parentElement:null},s.prototype.getLabel=function(){return this.element?this.element.nextElementSibling:null},s.prototype.initialize=function(){t.isNullOrUndefined(this.initialCheckedValue)&&(this.initialCheckedValue=this.checked),this.initWrapper(),this.updateHtmlAttribute(),this.name&&this.element.setAttribute("name",this.name);var e=this.element.getAttribute("value");this.isVue&&e&&e===this.value&&(this.checked=!0),(this.isVue?this.value&&!e:this.value)&&this.element.setAttribute("value",this.value),this.checked&&(this.element.checked=!0),this.disabled&&this.setDisabled()},s.prototype.initWrapper=function(){var e,i=this.element.parentElement;i.classList.contains(N)||(i=this.createElement("div",{className:N}),this.element.parentNode.insertBefore(i,this.element));var s=this.createElement("label",{attrs:{for:this.element.id}});i.appendChild(this.element),i.appendChild(s),t.isRippleEnabled&&(e=this.createElement("span",{className:L}),s.appendChild(e),t.rippleEffect(e,{duration:400,isCenterRipple:!0})),i.classList.add("e-wrapper"),this.enableRtl&&s.classList.add("e-rtl"),this.cssClass&&t.addClass([i],this.cssClass.split(" ")),this.label&&this.setText(this.label)},s.prototype.keyUpHandler=function(){this.isFocused&&this.getLabel().classList.add("e-focus")},s.prototype.labelRippleHandler=function(e){a(e,this.getLabel().getElementsByClassName(L)[0])},s.prototype.formResetHandler=function(){this.checked=this.initialCheckedValue,this.initialCheckedValue&&t.attributes(this.element,{checked:"true"})},s.prototype.onPropertyChanged=function(e,i){for(var s=this.getWrapper(),n=this.getLabel(),r=0,a=Object.keys(e);r<a.length;r++){switch(a[r]){case"checked":e.checked&&this.updateChange(),this.element.checked=e.checked;break;case"disabled":e.disabled?(this.setDisabled(),this.unWireEvents()):(this.element.disabled=!1,this.wireEvents());break;case"cssClass":i.cssClass&&t.removeClass([s],i.cssClass.split(" ")),e.cssClass&&t.addClass([s],e.cssClass.split(" "));break;case"enableRtl":e.enableRtl?n.classList.add("e-rtl"):n.classList.remove("e-rtl");break;case"label":this.setText(e.label);break;case"labelPosition":"Before"===e.labelPosition?n.classList.add("e-right"):n.classList.remove("e-right");break;case"name":this.element.setAttribute("name",e.name);break;case"value":if(!t.isNullOrUndefined(this.htmlAttributes)&&this.htmlAttributes.value)break;this.element.setAttribute("value",e.value);break;case"htmlAttributes":this.updateHtmlAttribute()}}},s.prototype.preRender=function(){var e=this.element;if(this.formElement=t.closest(this.element,"form"),this.tagName=this.element.tagName,e=i(this.createElement,"EJS-RADIOBUTTON","radio",e,N,"radio"),this.element=e,"radio"!==this.element.getAttribute("type")&&this.element.setAttribute("type","radio"),this.element.id||(this.element.id=t.getUniqueID("e-"+this.getModuleName())),"EJS-RADIOBUTTON"===this.tagName){var s=this.element.getAttribute("formcontrolname");s&&(this.setProperties({name:s},!0),this.element.setAttribute("name",s))}},s.prototype.render=function(){this.initialize(),this.disabled||this.wireEvents(),this.renderComplete(),this.wrapper=this.getWrapper()},s.prototype.setDisabled=function(){this.element.disabled=!0},s.prototype.setText=function(e){var i=this.getLabel(),s=i.getElementsByClassName("e-label")[0];s?s.textContent=e:(e=this.enableHtmlSanitizer?t.SanitizeHtmlHelper.sanitize(e):e,s=this.createElement("span",{className:"e-label",innerHTML:e}),i.appendChild(s)),"Before"===this.labelPosition?this.getLabel().classList.add("e-right"):this.getLabel().classList.remove("e-right")},s.prototype.updateHtmlAttribute=function(){if(!t.isNullOrUndefined(this.htmlAttributes))for(var e=0,i=Object.keys(this.htmlAttributes);e<i.length;e++){var s=i[e];if(T.indexOf(s)>-1){var n=this.element.parentElement;"class"===s?t.addClass([n],this.htmlAttributes[s].split(" ")):"title"===s||"style"===s?n.setAttribute(s,this.htmlAttributes[s]):this.element.setAttribute(s,this.htmlAttributes[s])}}},s.prototype.unWireEvents=function(){var e=this.wrapper;t.EventHandler.remove(this.element,"change",this.changeHandler),t.EventHandler.remove(this.element,"focus",this.focusHandler),t.EventHandler.remove(this.element,"focusout",this.focusOutHandler),t.EventHandler.remove(this.element,"keyup",this.keyUpHandler);var i=e.getElementsByTagName("label")[0];i&&(t.EventHandler.remove(i,"mousedown",this.labelRippleHandler),t.EventHandler.remove(i,"mouseup",this.labelRippleHandler)),this.formElement&&t.EventHandler.remove(this.formElement,"reset",this.formResetHandler)},s.prototype.wireEvents=function(){var e=this.getLabel();t.EventHandler.add(this.element,"change",this.changeHandler,this),t.EventHandler.add(this.element,"keyup",this.keyUpHandler,this),t.EventHandler.add(this.element,"focus",this.focusHandler,this),t.EventHandler.add(this.element,"focusout",this.focusOutHandler,this);var i=e.getElementsByClassName("e-label")[0];i&&(t.EventHandler.add(i,"mousedown",this.labelRippleHandler,this),t.EventHandler.add(i,"mouseup",this.labelRippleHandler,this)),this.formElement&&t.EventHandler.add(this.formElement,"reset",this.formResetHandler,this)},s.prototype.click=function(){this.element.click()},s.prototype.focusIn=function(){this.element.focus()};var n;return x([t.Event()],s.prototype,"change",void 0),x([t.Event()],s.prototype,"created",void 0),x([t.Property(!1)],s.prototype,"checked",void 0),x([t.Property("")],s.prototype,"cssClass",void 0),x([t.Property(!1)],s.prototype,"disabled",void 0),x([t.Property("")],s.prototype,"label",void 0),x([t.Property("After")],s.prototype,"labelPosition",void 0),x([t.Property("")],s.prototype,"name",void 0),x([t.Property("")],s.prototype,"value",void 0),x([t.Property(!1)],s.prototype,"enableHtmlSanitizer",void 0),x([t.Property({})],s.prototype,"htmlAttributes",void 0),s=n=x([t.NotifyPropertyChanges],s)}(t.Component),O=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),I=function(e,t,i,s){var n,r=arguments.length,a=r<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)a=Reflect.decorate(e,t,i,s);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(a=(r<3?n(a):r>3?n(t,i,a):n(t,i))||a);return r>3&&a&&Object.defineProperty(t,i,a),a},R="e-switch-disabled",W="e-ripple-container",j="e-ripple-check",M="e-switch-wrapper",B="e-switch-active",U=function(e){function i(t,i){var s=e.call(this,t,i)||this;return s.isFocused=!1,s.isDrag=!1,s}return O(i,e),i.prototype.changeState=function(e){var i,s,n=this.getWrapper(),r=n.querySelector(".e-switch-inner"),a=n.querySelector(".e-switch-handle");t.isRippleEnabled&&(s=n.getElementsByClassName(W)[0]),e?(t.addClass([r,a],B),i="true",this.element.checked=!0,this.checked=!0,s&&t.addClass([s],[j])):(t.removeClass([r,a],B),i="false",this.element.checked=!1,this.checked=!1,s&&t.removeClass([s],[j])),n.setAttribute("aria-checked",i)},i.prototype.clickHandler=function(e){this.isDrag=!1,this.focusOutHandler(),this.changeState(!this.checked),this.element.focus();var t={checked:this.element.checked,event:e};this.trigger("change",t)},i.prototype.destroy=function(){e.prototype.destroy.call(this),this.disabled||this.unWireEvents(),n(this,this.getWrapper(),this.tagName)},i.prototype.focusHandler=function(){this.isFocused=!0},i.prototype.focusOutHandler=function(){this.getWrapper().classList.remove("e-focus")},i.prototype.getModuleName=function(){return"switch"},i.prototype.getPersistData=function(){return this.addOnPersist(["checked"])},i.prototype.getWrapper=function(){return this.element.parentElement},i.prototype.initialize=function(){t.isNullOrUndefined(this.initialSwitchCheckedValue)&&(this.initialSwitchCheckedValue=this.checked),this.name&&this.element.setAttribute("name",this.name),this.value&&this.element.setAttribute("value",this.value),this.checked&&this.changeState(!0),this.disabled&&this.setDisabled(),(this.onLabel||this.offLabel)&&this.setLabel(this.onLabel,this.offLabel)},i.prototype.initWrapper=function(){var e=this.element.parentElement;e.classList.contains(M)||(e=this.createElement("div",{className:M,attrs:{role:"switch","aria-checked":"false"}}),this.element.parentNode.insertBefore(e,this.element));var i=this.createElement("span",{className:"e-switch-inner"}),s=this.createElement("span",{className:"e-switch-on"}),n=this.createElement("span",{className:"e-switch-off"}),r=this.createElement("span",{className:"e-switch-handle"});if(e.appendChild(this.element),l(this,e),i.appendChild(s),i.appendChild(n),e.appendChild(i),e.appendChild(r),t.isRippleEnabled){var a=this.createElement("span",{className:W});r.appendChild(a),t.rippleEffect(a,{duration:400,isCenterRipple:!0})}e.classList.add("e-wrapper"),this.enableRtl&&e.classList.add("e-rtl"),this.cssClass&&t.addClass([e],this.cssClass.split(" "))},i.prototype.onPropertyChanged=function(e,i){for(var s=this.getWrapper(),n=0,r=Object.keys(e);n<r.length;n++){switch(r[n]){case"checked":this.changeState(e.checked);break;case"disabled":e.disabled?(this.setDisabled(),this.unWireEvents()):(this.element.disabled=!1,s.classList.remove(R),s.setAttribute("aria-disabled","false"),this.wireEvents());break;case"value":this.element.setAttribute("value",e.value);break;case"name":this.element.setAttribute("name",e.name);break;case"onLabel":case"offLabel":this.setLabel(e.onLabel,e.offLabel);break;case"enableRtl":e.enableRtl?s.classList.add("e-rtl"):s.classList.remove("e-rtl");break;case"cssClass":i.cssClass&&t.removeClass([s],i.cssClass.split(" ")),e.cssClass&&t.addClass([s],e.cssClass.split(" "))}}},i.prototype.preRender=function(){var e=this.element;this.formElement=t.closest(this.element,"form"),this.tagName=this.element.tagName,r(this,"EJS-SWITCH",M,e,this.getModuleName())},i.prototype.render=function(){this.initWrapper(),this.initialize(),this.disabled||this.wireEvents(),this.renderComplete()},i.prototype.rippleHandler=function(e){a(e,this.getWrapper().getElementsByClassName(W)[0]),"mousedown"===e.type&&e.currentTarget.classList.contains("e-switch-wrapper")&&1===e.which&&(this.isDrag=!0,this.isFocused=!1)},i.prototype.rippleTouchHandler=function(e){var t=this.getWrapper().getElementsByClassName(W)[0];if(t){var i=document.createEvent("MouseEvents");i.initEvent(e,!1,!0),t.dispatchEvent(i)}},i.prototype.setDisabled=function(){var e=this.getWrapper();this.element.disabled=!0,e.classList.add(R),e.setAttribute("aria-disabled","true")},i.prototype.setLabel=function(e,t){var i=this.getWrapper();e&&(i.querySelector(".e-switch-on").textContent=e),t&&(i.querySelector(".e-switch-off").textContent=t)},i.prototype.switchFocusHandler=function(){this.isFocused&&this.getWrapper().classList.add("e-focus")},i.prototype.switchMouseUp=function(e){var t=e.target;"touchmove"===e.type&&e.preventDefault(),"touchstart"===e.type&&(this.isDrag=!0,this.rippleTouchHandler("mousedown")),this.isDrag&&("mouseup"===e.type&&t.className.indexOf("e-switch")<0||"touchend"===e.type)&&(this.clickHandler(e),this.rippleTouchHandler("mouseup"),e.preventDefault())},i.prototype.formResetHandler=function(){this.checked=this.initialSwitchCheckedValue,this.element.checked=this.initialSwitchCheckedValue},i.prototype.toggle=function(){this.clickHandler()},i.prototype.wireEvents=function(){var e=this.getWrapper();this.delegateMouseUpHandler=this.switchMouseUp.bind(this),this.delegateKeyUpHandler=this.switchFocusHandler.bind(this),t.EventHandler.add(e,"click",this.clickHandler,this),t.EventHandler.add(this.element,"focus",this.focusHandler,this),t.EventHandler.add(this.element,"focusout",this.focusOutHandler,this),t.EventHandler.add(this.element,"mouseup",this.delegateMouseUpHandler,this),t.EventHandler.add(this.element,"keyup",this.delegateKeyUpHandler,this),t.EventHandler.add(e,"mousedown mouseup",this.rippleHandler,this),t.EventHandler.add(e,"touchstart touchmove touchend",this.switchMouseUp,this),this.formElement&&t.EventHandler.add(this.formElement,"reset",this.formResetHandler,this)},i.prototype.unWireEvents=function(){var e=this.getWrapper();t.EventHandler.remove(e,"click",this.clickHandler),t.EventHandler.remove(this.element,"focus",this.focusHandler),t.EventHandler.remove(this.element,"focusout",this.focusOutHandler),t.EventHandler.remove(this.element,"mouseup",this.delegateMouseUpHandler),t.EventHandler.remove(this.element,"keyup",this.delegateKeyUpHandler),t.EventHandler.remove(e,"mousedown mouseup",this.rippleHandler),t.EventHandler.remove(e,"touchstart touchmove touchend",this.switchMouseUp),this.formElement&&t.EventHandler.remove(this.formElement,"reset",this.formResetHandler)},i.prototype.click=function(){this.element.click()},i.prototype.focusIn=function(){this.element.focus()},I([t.Event()],i.prototype,"change",void 0),I([t.Event()],i.prototype,"created",void 0),I([t.Property(!1)],i.prototype,"checked",void 0),I([t.Property("")],i.prototype,"cssClass",void 0),I([t.Property(!1)],i.prototype,"disabled",void 0),I([t.Property("")],i.prototype,"name",void 0),I([t.Property("")],i.prototype,"onLabel",void 0),I([t.Property("")],i.prototype,"offLabel",void 0),I([t.Property("")],i.prototype,"value",void 0),i=I([t.NotifyPropertyChanges],i)}(t.Component),_=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),D=function(e,t,i,s){var n,r=arguments.length,a=r<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)a=Reflect.decorate(e,t,i,s);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(a=(r<3?n(a):r>3?n(t,i,a):n(t,i))||a);return r>3&&a&&Object.defineProperty(t,i,a),a},q={chipSet:"e-chip-set",chip:"e-chip",avatar:"e-chip-avatar",text:"e-chip-text",icon:"e-chip-icon",delete:"e-chip-delete",deleteIcon:"e-dlt-btn",multiSelection:"e-multi-selection",singleSelection:"e-selection",active:"e-active",chipWrapper:"e-chip-avatar-wrap",iconWrapper:"e-chip-icon-wrap",focused:"e-focused",disabled:"e-disabled",rtl:"e-rtl"},V=function(e){function i(t,i){var s=e.call(this,t,i)||this;return s.multiSelectedChip=[],s}return _(i,e),i.prototype.preRender=function(){},i.prototype.chipType=function(){return this.chips&&this.chips.length&&this.chips.length>0},i.prototype.render=function(){this.type=this.chips.length?"chipset":this.text||this.element.innerText?"chip":"chipset",this.setAttributes(),this.createChip(),this.setRtl(),this.select(this.selectedChips,void 0),this.wireEvent(!1),this.rippleFunction=t.rippleEffect(this.element,{selector:".e-chip"}),this.renderComplete()},i.prototype.createChip=function(){this.innerText=this.element.innerText&&0!==this.element.innerText.length?this.element.innerText.trim():this.element.innerText,this.element.innerHTML="",this.chipCreation("chip"===this.type?[this.innerText?this.innerText:this.text]:this.chips)},i.prototype.setAttributes=function(){"chip"===this.type?(this.element.tabIndex=0,this.element.setAttribute("role","option")):(this.element.classList.add(q.chipSet),this.element.setAttribute("role","listbox"),"Multiple"===this.selection?(this.element.classList.add(q.multiSelection),this.element.setAttribute("aria-multiselectable","true")):"Single"===this.selection?(this.element.classList.add(q.singleSelection),this.element.setAttribute("aria-multiselectable","false")):this.element.setAttribute("aria-multiselectable","false"))},i.prototype.setRtl=function(){this.element.classList[this.enableRtl?"add":"remove"](q.rtl)},i.prototype.chipCreation=function(e){for(var i=[],s=0;s<e.length;s++){var n=this.getFieldValues(e[s]),r=this.elementCreation(n),a=(q.chip+" "+(n.enabled?" ":q.disabled)+" "+(n.avatarIconCss||n.avatarText?q.chipWrapper:n.leadingIconCss?q.iconWrapper:" ")+" "+n.cssClass).split(" ").filter(function(e){return e});if(this.chipType()){var l=this.createElement("DIV",{className:a.join(" "),attrs:{tabIndex:"0",role:"option","aria-label":n.text,"aria-selected":"false"}});n.value&&l.setAttribute("data-value",n.value.toString()),t.append(r,l),i.push(l)}else i=r,t.addClass([this.element],a),this.element.setAttribute("aria-label",n.text),n.value&&this.element.setAttribute("data-value",n.value.toString())}t.append(i,this.element)},i.prototype.getFieldValues=function(e){var i=!("false"===this.enabled.toString());return{text:"object"==typeof e?e.text?e.text.toString():this.text.toString():this.chipType()?e.toString():this.innerText?this.innerText:this.text.toString(),cssClass:"object"==typeof e&&e.cssClass?e.cssClass.toString():this.cssClass.toString(),leadingIconCss:"object"==typeof e&&e.leadingIconCss?e.leadingIconCss.toString():this.leadingIconCss.toString(),avatarIconCss:"object"==typeof e&&e.avatarIconCss?e.avatarIconCss.toString():this.avatarIconCss.toString(),avatarText:"object"==typeof e&&e.avatarText?e.avatarText.toString():this.avatarText.toString(),trailingIconCss:"object"==typeof e&&e.trailingIconCss?e.trailingIconCss.toString():this.trailingIconCss.toString(),enabled:"object"==typeof e?t.isNullOrUndefined(e.enabled)?i:"false"!==e.enabled.toString():i,value:"object"==typeof e&&e.value?e.value.toString():null,leadingIconUrl:"object"==typeof e&&e.leadingIconUrl?e.leadingIconUrl.toString():this.leadingIconUrl,trailingIconUrl:"object"==typeof e&&e.trailingIconUrl?e.trailingIconUrl.toString():this.trailingIconUrl}},i.prototype.elementCreation=function(e){var t=[];if(e.avatarText||e.avatarIconCss){var i=(q.avatar+" "+e.avatarIconCss).trim(),s=this.createElement("span",{className:i});s.innerText=e.avatarText,t.push(s)}else if(e.leadingIconCss){i=(q.icon+" "+e.leadingIconCss).trim();var n=this.createElement("span",{className:i});t.push(n)}else if(e.leadingIconUrl){i=(q.avatar+" image-url").trim();(n=this.createElement("span",{className:i})).style.backgroundImage="url("+e.leadingIconUrl+")",t.push(n)}var r=this.createElement("span",{className:q.text});if(r.innerText=e.text,t.push(r),e.trailingIconCss||this.chipType()&&this.enableDelete){i=(q.delete+" "+(e.trailingIconCss?e.trailingIconCss:q.deleteIcon)).trim();var a=this.createElement("span",{className:i});t.push(a)}else if(e.trailingIconUrl){i="trailing-icon-url".trim();var l=this.createElement("span",{className:i});l.style.backgroundImage="url("+e.trailingIconUrl+")",t.push(l)}return t},i.prototype.find=function(e){var t,i=e instanceof HTMLElement?e:this.element.querySelectorAll("."+q.chip)[e];return i&&this.chipType()&&((t={text:void 0,index:void 0,element:void 0,data:void 0}).index=Array.prototype.slice.call(this.element.querySelectorAll("."+q.chip)).indexOf(i),t.text="object"==typeof this.chips[t.index]?this.chips[t.index].text?this.chips[t.index].text.toString():"":this.chips[t.index].toString(),t.data=this.chips[t.index],t.element=i),t},i.prototype.add=function(e){var t;if("chip"!==this.type){var i=e instanceof Array?e:[e];(t=this.chips).push.apply(t,i),this.chipCreation(i)}},i.prototype.select=function(e,t){this.onSelect(e,!1,t)},i.prototype.multiSelection=function(e){for(var t=this.element.querySelectorAll(".e-chip"),i=0;i<e.length;i++)if("string"==typeof e[i]){for(var s=0;s<t.length;s++)if(e[i]!==s&&e[i]===t[s].attributes[5].value){this.multiSelectedChip.push(s);break}}else this.multiSelectedChip.push(e[i])},i.prototype.onSelect=function(e,t,i){var s,n,r;if(this.chipType()&&"None"!==this.selection){if(t)for(var a=this.element.querySelectorAll("."+q.chip),l=0;l<a.length;l++)a[l].setAttribute("aria-selected","false"),a[l].classList.remove(q.active);var o=e instanceof Array?e:[e];for(l=0;l<o.length;l++){var c=o[l]instanceof HTMLElement?o[l]:this.element.querySelectorAll("."+q.chip)[o[l]];if("index"!==i)for(var h=0;h<this.chips.length;h++){n=this.element.querySelectorAll("."+q.chip)[h];var p=this.getFieldValues(this.chips[h]);"value"===i?null!==p.value&&(r=n.dataset.value):"text"===i&&(r=n.innerText),r===o[l].toString()&&(s=h,c=this.element.querySelectorAll("."+q.chip)[s])}c instanceof HTMLElement&&this.selectionHandler(c)}}},i.prototype.remove=function(e){var t=this;if(this.chipType()){var i=e instanceof Array?e:[e],s=[],n=this.element.querySelectorAll("."+q.chip);i.forEach(function(e){var t=e instanceof HTMLElement?e:n[e];t instanceof HTMLElement&&s.push(t)}),s.forEach(function(e){var i=t.element.querySelectorAll("."+q.chip),s=Array.prototype.slice.call(i).indexOf(e);t.deleteHandler(e,s)})}},i.prototype.getSelectedChips=function(){var e;if(this.chipType()&&"None"!==this.selection){for(var i={texts:[],Indexes:[],data:[],elements:[]},s=this.element.querySelectorAll("."+q.active),n=0;n<s.length;n++){var r=s[n];i.elements.push(r);var a=Array.prototype.slice.call(this.element.querySelectorAll("."+q.chip)).indexOf(r);i.Indexes.push(a),i.data.push(this.chips[a]);var l="object"==typeof this.chips[a]?this.chips[a].text?this.chips[a].text.toString():null:this.chips[a].toString();i.texts.push(l)}var o={text:i.texts[0],index:i.Indexes[0],data:i.data[0],element:i.elements[0]};e=t.isNullOrUndefined(o.index)?void 0:"Multiple"===this.selection?i:o}return e},i.prototype.wireEvent=function(e){e?(t.EventHandler.remove(this.element,"click",this.clickHandler),t.EventHandler.remove(this.element,"focusout",this.focusOutHandler),t.EventHandler.remove(this.element,"keydown",this.keyHandler),t.EventHandler.remove(this.element,"keyup",this.keyHandler)):(t.EventHandler.add(this.element,"click",this.clickHandler,this),t.EventHandler.add(this.element,"focusout",this.focusOutHandler,this),t.EventHandler.add(this.element,"keydown",this.keyHandler,this),t.EventHandler.add(this.element,"keyup",this.keyHandler,this))},i.prototype.keyHandler=function(e){e.target.classList.contains(q.chip)&&("keydown"===e.type?13===e.keyCode?this.clickHandler(e):46===e.keyCode&&this.enableDelete&&this.clickHandler(e,!0):9===e.keyCode&&this.focusInHandler(e.target))},i.prototype.focusInHandler=function(e){e.classList.contains(q.focused)||e.classList.add(q.focused)},i.prototype.focusOutHandler=function(e){var i=t.closest(e.target,"."+q.chip),s=this.chipType()?this.element.querySelector("."+q.focused):this.element.classList.contains(q.focused)?this.element:null;i&&s&&s.classList.remove(q.focused)},i.prototype.clickHandler=function(e,i){var s=this;void 0===i&&(i=!1);var n=t.closest(e.target,"."+q.chip);if(n){var r=void 0;if(this.chipType())r=this.find(n);else{var a=Array.prototype.slice.call(this.element.querySelectorAll("."+q.chip)).indexOf(n);r={text:this.innerText?this.innerText:this.text,element:n,data:this.text,index:a}}r.event=e,r.cancel=!1,this.trigger("beforeClick",r,function(t){t.cancel||s.clickEventHandler(t.element,e,i)})}},i.prototype.clickEventHandler=function(e,t,i){var s=this;if(this.chipType()){var n=this.find(e);n.event=t;if((t.target.classList.contains(q.deleteIcon)?t.target:i?e.querySelector("."+q.deleteIcon):void 0)&&this.enableDelete){n.cancel=!1;var r=n;this.trigger("delete",r,function(t){if(!t.cancel){s.deleteHandler(t.element,t.index),s.selectionHandler(e),n.selected=t.element.classList.contains(q.active);var i=n;s.trigger("click",i)}})}else if("None"!==this.selection){this.selectionHandler(e),n.selected=e.classList.contains(q.active);var a=n;this.trigger("click",a)}else{this.focusInHandler(e);var l=n;this.trigger("click",l)}}else{this.focusInHandler(e);l={text:this.innerText?this.innerText:this.text,element:e,data:this.text,event:t};this.trigger("click",l)}},i.prototype.selectionHandler=function(e){if("Single"===this.selection){var t=this.element.querySelector("."+q.active);t&&t!==e&&(t.classList.remove(q.active),t.setAttribute("aria-selected","false")),this.setProperties({selectedChips:null},!0)}else this.setProperties({selectedChips:[]},!0);e.classList.contains(q.active)?(e.classList.remove(q.active),e.setAttribute("aria-selected","false")):(e.classList.add(q.active),e.setAttribute("aria-selected","true")),this.updateSelectedChips()},i.prototype.updateSelectedChips=function(){for(var e,t=this.element.querySelectorAll(".e-chip"),i=[],s=[],n=null,r=0;r<t.length;r++){var a=this.element.querySelectorAll(".e-chip")[r];if("true"===a.getAttribute("aria-selected")){if(e=a.getAttribute("data-value"),"Single"===this.selection&&a.classList.contains("e-active")){n=e||r;break}n=e?s.push(e):i.push(r)}}this.setProperties({selectedChips:"Single"===this.selection?n:e?s:i},!0)},i.prototype.deleteHandler=function(e,i){var s=this.find(e);this.chips.splice(i,1),this.setProperties({chips:this.chips},!0),t.detach(e),this.trigger("deleted",s)},i.prototype.destroy=function(){t.removeClass([this.element],[q.chipSet,q.chip,q.rtl,q.multiSelection,q.singleSelection,q.disabled,q.chipWrapper,q.iconWrapper,q.active,q.focused].concat(this.cssClass.toString().split(" ").filter(function(e){return e}))),this.removeMultipleAttributes(["tabindex","role","aria-label","aria-multiselectable"],this.element),this.wireEvent(!0),this.rippleFunction(),e.prototype.destroy.call(this),this.element.innerHTML="",this.element.innerText=this.innerText},i.prototype.removeMultipleAttributes=function(e,t){e.forEach(function(e){t.removeAttribute(e)})},i.prototype.getPersistData=function(){return this.addOnPersist([])},i.prototype.getModuleName=function(){return"chip-list"},i.prototype.onPropertyChanged=function(e,i){for(var s=0,n=Object.keys(e);s<n.length;s++){switch(n[s]){case"chips":case"text":case"avatarText":case"avatarIconCss":case"leadingIconCss":case"trailingIconCss":case"selection":case"enableDelete":case"enabled":this.refresh();break;case"cssClass":this.chipType()?this.refresh():(t.removeClass([this.element],i.cssClass.toString().split(" ").filter(function(e){return e})),t.addClass([this.element],e.cssClass.toString().split(" ").filter(function(e){return e})));break;case"selectedChips":t.removeClass(this.element.querySelectorAll(".e-active"),"e-active"),"Multiple"===this.selection?(this.multiSelectedChip=[],this.multiSelection(e.selectedChips),this.onSelect(this.multiSelectedChip,!0,void 0),this.updateSelectedChips()):this.onSelect(e.selectedChips,!0,void 0);break;case"enableRtl":this.setRtl()}}},D([t.Property([])],i.prototype,"chips",void 0),D([t.Property("")],i.prototype,"text",void 0),D([t.Property("")],i.prototype,"avatarText",void 0),D([t.Property("")],i.prototype,"avatarIconCss",void 0),D([t.Property("")],i.prototype,"leadingIconCss",void 0),D([t.Property("")],i.prototype,"trailingIconCss",void 0),D([t.Property("")],i.prototype,"leadingIconUrl",void 0),D([t.Property("")],i.prototype,"trailingIconUrl",void 0),D([t.Property("")],i.prototype,"cssClass",void 0),D([t.Property(!0)],i.prototype,"enabled",void 0),D([t.Property([])],i.prototype,"selectedChips",void 0),D([t.Property("None")],i.prototype,"selection",void 0),D([t.Property(!1)],i.prototype,"enableDelete",void 0),D([t.Event()],i.prototype,"created",void 0),D([t.Event()],i.prototype,"click",void 0),D([t.Event()],i.prototype,"beforeClick",void 0),D([t.Event()],i.prototype,"delete",void 0),D([t.Event()],i.prototype,"deleted",void 0),i=D([t.NotifyPropertyChanges],i)}(t.Component),z=function(){return function(){}}();e.wrapperInitialize=i,e.getTextNode=s,e.destroy=n,e.preRender=r,e.createCheckBox=function(e,i,s){void 0===i&&(i=!1),void 0===s&&(s={});var n=e("div",{className:"e-checkbox-wrapper e-css"});if(s.cssClass&&t.addClass([n],s.cssClass.split(" ")),s.enableRtl&&n.classList.add("e-rtl"),i){var r=e("span",{className:"e-ripple-container"});t.rippleEffect(r,{isCenterRipple:!0,duration:400}),n.appendChild(r)}var a=e("span",{className:"e-frame e-icons"});if(s.checked&&a.classList.add("e-check"),n.appendChild(a),s.label){var l=e("span",{className:"e-label"});s.disableHtmlEncode?l.textContent=s.label:l.innerHTML=s.label,n.appendChild(l)}return n},e.rippleMouseHandler=a,e.setHiddenInput=l,e.buttonObserver=h,e.Button=f,e.CheckBox=A,e.RadioButton=w,e.Switch=U,e.classNames=q,e.ChipList=V,e.Chip=z,Object.defineProperty(e,"__esModule",{value:!0})});
	//# sourceMappingURL=ej2-buttons.umd.min.js.map


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var PooledClass = __webpack_require__(53);
	
	var emptyFunction = __webpack_require__(37);
	var warning = __webpack_require__(15);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 44 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/delete.a4c36aa8.png";

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	*  filename: ej2-popups.umd.min.js
	*  version : 19.4.53
	*  Copyright Syncfusion Inc. 2001 - 2020. All rights reserved.
	*  Use of this code is subject to the terms of our license.
	*  A copy of the current license can be obtained at any time by e-mailing
	*  licensing@syncfusion.com. Any infringement will be prosecuted under
	*  applicable laws. 
	*/
	!function(t,e){ true?e(exports,__webpack_require__(23),__webpack_require__(42)):"function"==typeof define&&define.amd?define(["exports","@syncfusion/ej2-base","@syncfusion/ej2-buttons"],e):e(t.ej={},t.ej2Base,t.ej2Buttons)}(this,function(t,e,i){"use strict";function o(t,i){var o=!1,n={left:0,top:0},s=t;if(!t||!i)return n;for(e.isNullOrUndefined(i.offsetParent)&&"fixed"===i.style.position&&(o=!0);(i.offsetParent||o)&&t&&i.offsetParent!==t;)n.left+=t.offsetLeft,n.top+=t.offsetTop,t=t.offsetParent;for(t=s;(i.offsetParent||o)&&t&&i.offsetParent!==t;)n.left-=t.scrollLeft,n.top-=t.scrollTop,t=t.parentElement;return n}function n(t,e,i,o,n){if(gt=void 0,gt=n,Bt=!!o,!t)return{left:0,top:0};e||(e="left"),i||(i="top"),vt=t.ownerDocument,yt=t;return function(t,e,i){switch(mt=yt.getBoundingClientRect(),e+t){case"topcenter":s(f(),i),l(p(),i);break;case"topright":s(u(),i),l(p(),i);break;case"centercenter":s(f(),i),l(d(),i);break;case"centerright":s(u(),i),l(d(),i);break;case"centerleft":s(c(),i),l(d(),i);break;case"bottomcenter":s(f(),i),l(h(),i);break;case"bottomright":s(u(),i),l(h(),i);break;case"bottomleft":s(c(),i),l(h(),i);break;default:case"topleft":s(c(),i),l(p(),i)}return i}(e.toLowerCase(),i.toLowerCase(),{left:0,top:0})}function s(t,e){e.left=t}function l(t,e){e.top=t}function r(){return vt.documentElement.scrollTop||vt.body.scrollTop}function a(){return vt.documentElement.scrollLeft||vt.body.scrollLeft}function h(){return Bt?mt.bottom:mt.bottom+r()}function d(){return p()+mt.height/2}function p(){return Bt?mt.top:mt.top+r()}function c(){return mt.left+a()}function u(){var t=yt&&yt.classList.contains("e-date-range-wrapper")?gt?gt.width:0:gt&&mt.width>=gt.width?gt.width:0;return mt.right+a()-t}function f(){return c()+mt.width/2}function m(t,e,i,o){if(void 0===e&&(e=null),void 0===i&&(i={X:!1,Y:!1}),!i.Y&&!i.X)return{left:0,top:0};var s=t.getBoundingClientRect();if(Et=e,bt=t.ownerDocument,o||(o=n(t,"left","top")),i.X){var l=Et?w():z(),r=x(),a=H(),h=r-o.left,d=o.left+s.width-a;s.width>l?o.left=h>0&&d<=0?a-s.width:d>0&&h<=0?r:h>d?a-s.width:r:h>0?o.left+=h:d>0&&(o.left-=d)}if(i.Y){var p=Et?N():R(),c=P(),u=B(),f=c-o.top,m=o.top+s.height-u;s.height>p?o.top=f>0&&m<=0?u-s.height:m>0&&f<=0?c:f>m?u-s.height:c:f>0?o.top+=f:m>0&&(o.top-=m)}return o}function g(t,e,i,o){void 0===e&&(e=null);var s=n(t,"left","top");i&&(s.left=i),o&&(s.top=o);var l=[];Et=e,bt=t.ownerDocument;var r=t.getBoundingClientRect(),a=s.top,h=s.left,d=s.left+r.width,p=O(a,s.top+r.height),c=b(h,d);return p.topSide&&l.push("top"),c.rightSide&&l.push("right"),c.leftSide&&l.push("left"),p.bottomSide&&l.push("bottom"),l}function y(t,e,i,o,s,l,r,a,h){if(void 0===r&&(r=null),void 0===a&&(a={X:!0,Y:!0}),e&&t&&s&&l&&(a.X||a.Y)){var d,p={TL:null,TR:null,BL:null,BR:null},c={TL:null,TR:null,BL:null,BR:null};if("none"===window.getComputedStyle(t).display){var u=t.style.visibility;t.style.visibility="hidden",t.style.display="block",d=t.getBoundingClientRect(),t.style.removeProperty("display"),t.style.visibility=u}else d=t.getBoundingClientRect();var f={posX:s,posY:l,offsetX:i,offsetY:o,position:{left:0,top:0}};Et=r,bt=e.ownerDocument,function(t,e,i,o,s){i.position=n(t,i.posX,i.posY,o,s),e.TL=n(t,"left","top",o,s),e.TR=n(t,"right","top",o,s),e.BR=n(t,"left","bottom",o,s),e.BL=n(t,"right","bottom",o,s)}(e,p,f,h,d),v(c,f,d),a.X&&E(e,c,p,f,d,!0),a.Y&&p.TL.top>-1&&C(e,c,p,f,d,!0),function(t,e,i){var o=0,s=0;if(null!=t.offsetParent&&("absolute"===getComputedStyle(t.offsetParent).position||"relative"===getComputedStyle(t.offsetParent).position)){var l=n(t.offsetParent,"left","top",!1,i);o=l.left,s=l.top}t.style.top=e.position.top+e.offsetY-s+"px",t.style.left=e.position.left+e.offsetX-o+"px"}(t,f,d)}}function v(t,e,i){t.TL={top:e.position.top+e.offsetY,left:e.position.left+e.offsetX},t.TR={top:t.TL.top,left:t.TL.left+i.width},t.BL={top:t.TL.top+i.height,left:t.TL.left},t.BR={top:t.TL.top+i.height,left:t.TL.left+i.width}}function b(t,e){var i=!1,o=!1;return t-k()<x()&&(i=!0),e>H()&&(o=!0),{leftSide:i,rightSide:o}}function E(t,e,i,o,s,l){var r=b(e.TL.left,e.TR.left);i.TL.left-k()<=x()&&(r.leftSide=!1),i.TR.left>H()&&(r.rightSide=!1),(r.leftSide&&!r.rightSide||!r.leftSide&&r.rightSide)&&("right"===o.posX?o.posX="left":o.posX="right",o.offsetX=o.offsetX+s.width,o.offsetX=-1*o.offsetX,o.position=n(t,o.posX,o.posY,!1),v(e,o,s),l&&E(t,e,i,o,s,!1))}function C(t,e,i,o,s,l){var r=O(e.TL.top,e.BL.top);i.TL.top-U()<=P()&&(r.topSide=!1),i.BL.top>=B()&&t.getBoundingClientRect().bottom<window.innerHeight&&(r.bottomSide=!1),(r.topSide&&!r.bottomSide||!r.topSide&&r.bottomSide)&&("top"===o.posY?o.posY="bottom":o.posY="top",o.offsetY=o.offsetY+s.height,o.offsetY=-1*o.offsetY,o.position=n(t,o.posX,o.posY,!1,s),v(e,o,s),l&&C(t,e,i,o,s,!1))}function O(t,e){var i=!1,o=!1;return t-U()<P()&&(i=!0),e>B()&&(o=!0),{topSide:i,bottomSide:o}}function w(){return Et.getBoundingClientRect().width}function N(){return Et.getBoundingClientRect().height}function T(){return Et.getBoundingClientRect().left}function S(){return Et.getBoundingClientRect().top}function P(){return Et?S():0}function x(){return Et?T():0}function H(){return Et?k()+T()+w():k()+z()}function B(){return Et?U()+S()+N():U()+R()}function U(){return bt.documentElement.scrollTop||bt.body.scrollTop}function k(){return bt.documentElement.scrollLeft||bt.body.scrollLeft}function R(){return window.innerHeight}function z(){var t=window.innerWidth,i=document.documentElement.getBoundingClientRect();return t-(t-(e.isNullOrUndefined(document.documentElement)?0:i.width))}function M(t,e){for(var i=getComputedStyle(t),o=[],n=/(auto|scroll)/,s=t.parentElement;s&&"HTML"!==s.tagName;){var l=getComputedStyle(s);"absolute"===i.position&&"static"===l.position||!n.test(l.overflow+l.overflowY+l.overflowX)||o.push(s),s=s.parentElement}return e||o.push(document),o}function L(t){for(var i=t.parentElement,o=[];i&&"BODY"!==i.tagName;){var n=document.defaultView.getComputedStyle(i,null).getPropertyValue("z-index"),s=document.defaultView.getComputedStyle(i,null).getPropertyValue("position");"auto"!==n&&"static"!==s&&o.push(n),i=i.parentElement}for(var l=[],r=0;r<document.body.children.length;r++)if(!t.isEqualNode(document.body.children[r])){n=document.defaultView.getComputedStyle(document.body.children[r],null).getPropertyValue("z-index"),s=document.defaultView.getComputedStyle(document.body.children[r],null).getPropertyValue("position");"auto"!==n&&"static"!==s&&l.push(n)}l.push("999");var a=[];if(!e.isNullOrUndefined(t.parentElement)&&"BODY"!==t.parentElement.tagName){var h=[].slice.call(t.parentElement.children);for(r=0;r<h.length;r++)if(!t.isEqualNode(h[r])){n=document.defaultView.getComputedStyle(h[r],null).getPropertyValue("z-index"),s=document.defaultView.getComputedStyle(h[r],null).getPropertyValue("position");"auto"!==n&&"static"!==s&&a.push(n)}}var d=o.concat(l,a),p=Math.max.apply(Math,d)+1;return p>2147483647?2147483647:p}function I(t){Qt=t.resizeBegin,$t=t.resizing,te=t.resizeComplete,Ct=A(t.element),Pt=A(t.boundary);for(var i=t.direction.split(" "),o=0;o<i.length;o++)if(_t.indexOf(i[o])>=0&&i[o])!function(t){F();var i=e.createElement("span",{attrs:{unselectable:"on",contenteditable:"false"}});i.setAttribute("class","e-dialog-border-resize e-"+t),"south"===t&&(i.style.height="2px",i.style.width="100%",i.style.bottom="0px",i.style.left="0px");"north"===t&&(i.style.height="2px",i.style.width="100%",i.style.top="0px",i.style.left="0px");"east"===t&&(i.style.height="100%",i.style.width="2px",i.style.right="0px",i.style.top="0px");"west"===t&&(i.style.height="100%",i.style.width="2px",i.style.left="0px",i.style.top="0px");Ct.appendChild(i)}(i[o]);else if(""!==i[o].trim()){var n=e.createElement("div",{className:"e-icons "+Xt+" e-"+i[o]});Ct.appendChild(n)}wt=t.minHeight,Tt=t.minWidth,St=t.maxWidth,Nt=t.maxHeight,t.proxy&&t.proxy.element&&t.proxy.element.classList.contains("e-dialog")?Y(t.proxy):Y()}function A(t){var i;return e.isNullOrUndefined(t)||(i="string"==typeof t?document.querySelector(t):t),i}function Y(t){e.isNullOrUndefined(t)&&(t=this);for(var i=Ct.querySelectorAll("."+Xt),o=0;o<i.length;o++){Ot=i[o],e.EventHandler.add(Ot,"mousedown",D,t);var n="msie"===e.Browser.info.name?"pointerdown":"touchstart";e.EventHandler.add(Ot,n,q,t)}var s=Ct.querySelectorAll(".e-dialog-border-resize");if(!e.isNullOrUndefined(s))for(o=0;o<s.length;o++){Ot=s[o],e.EventHandler.add(Ot,"mousedown",D,t);n="msie"===e.Browser.info.name?"pointerdown":"touchstart";e.EventHandler.add(Ot,n,q,t)}}function X(t){return t.indexOf("mouse")>-1?"mouse":"touch"}function D(t){if(t.preventDefault(),Ct=t.target.parentElement,F(),Kt=t.pageX,Jt=t.pageY,t.target.classList.add(Dt),e.isNullOrUndefined(Qt)||(Ht=this,!0!==Qt(t,Ht))){this.targetEle&&Ct&&Ct.querySelector("."+jt)&&(this.target,Pt=null,St=this.targetEle.clientWidth,Nt=this.targetEle.clientHeight);var i=e.isNullOrUndefined(Pt)?document:Pt;e.EventHandler.add(i,"mousemove",_,this),e.EventHandler.add(document,"mouseup",j,this);for(var o=0;o<Ft.length;o++)ee=!Ct.classList.contains(Ft[o])}}function j(t){var i="msie"===e.Browser.info.name?"pointermove":"touchmove",o="msie"===e.Browser.info.name?"pointerup":"touchend",n=e.isNullOrUndefined(Pt)?document:Pt,s="msie"===e.Browser.info.name?"pointerdown":"touchstart";e.EventHandler.remove(n,"mousemove",_),e.EventHandler.remove(n,i,_),e.EventHandler.remove(n,s,_),e.isNullOrUndefined(document.body.querySelector("."+Dt))||document.body.querySelector("."+Dt).classList.remove(Dt),e.isNullOrUndefined(te)||te(t,Ht=this),e.EventHandler.remove(document,"mouseup",j),e.EventHandler.remove(document,o,j)}function F(){Wt=parseFloat(getComputedStyle(Ct,null).getPropertyValue("width").replace("px","")),Vt=parseFloat(getComputedStyle(Ct,null).getPropertyValue("height").replace("px","")),Zt=Ct.getBoundingClientRect().left,Gt=Ct.getBoundingClientRect().top}function q(t){Ct=t.target.parentElement,F();var i=t.touches?t.changedTouches[0]:t;if(Kt=i.pageX,Jt=i.pageY,e.isNullOrUndefined(Qt)||(Ht=this,!0!==Qt(t,Ht))){var o="msie"===e.Browser.info.name?"pointermove":"touchmove",n="msie"===e.Browser.info.name?"pointerup":"touchend",s=e.isNullOrUndefined(Pt)?document:Pt;e.EventHandler.add(s,o,_,this),e.EventHandler.add(document,n,j)}}function _(t){if(t.target.classList.contains(Xt)&&t.target.classList.contains(Dt)?Ot=t.target:e.isNullOrUndefined(document.body.querySelector("."+Dt))||(Ot=document.body.querySelector("."+Dt)),!e.isNullOrUndefined(Ot)){for(var i="",o=0;o<Yt.length;o++)Ot.classList.contains("e-"+Yt[o])&&(i=Yt[o]);switch(e.isNullOrUndefined($t)||$t(t,Ht=this),i){case"south":V(t);break;case"north":Z(t);break;case"west":G(t);break;case"east":K(t);break;case"south-east":V(t),K(t);break;case"south-west":V(t),G(t);break;case"north-east":Z(t),K(t);break;case"north-west":Z(t),G(t)}}}function W(t){return t.getBoundingClientRect()}function V(t){var i,o=document.documentElement.clientHeight,n=!1,s=(t.touches?t.changedTouches[0]:t).pageY,l=W(Ct);e.isNullOrUndefined(Pt)||(i=W(Pt)),e.isNullOrUndefined(Pt)?e.isNullOrUndefined(Pt)&&(o-s>=0||l.top<0)&&(n=!0):n=!0;var r=Vt+(s-Jt);r=r>wt?r:wt;var a=0;e.isNullOrUndefined(Pt)||(a=i.top);var h=e.isNullOrUndefined(Pt)?0:Pt.offsetHeight-Pt.clientHeight,d=l.top-a-h/2;if(d=d<0?0:d,l.top>0&&d+r>Nt){if(n=!1,Ct.classList.contains(qt))return;Ct.style.height=Nt-parseInt(d.toString(),10)+"px"}else{var p=0;if(n){l.top<0&&o+(l.height+l.top)>0&&r+(p=l.top)<=30&&(r=l.height-(l.height+l.top)+30),r+l.top>=Nt&&(Ct.style.height=l.height+(o-(l.height+l.top))+"px");var c=e.isNullOrUndefined(Pt)?p:d;r>=wt&&r+c<=Nt&&(Ct.style.height=r+"px")}}}function Z(t){var i,o=!1,n="mouse"===X(t.type)?t.pageY:t.touches[0].pageY,s=W(Ct);e.isNullOrUndefined(Pt)||(i=W(Pt)),!e.isNullOrUndefined(Pt)&&s.top-i.top>0?o=!0:e.isNullOrUndefined(Pt)&&n>0&&(o=!0);var l=Vt-(n-Jt);if(o&&l>=wt&&l<=Nt){var r=0;e.isNullOrUndefined(Pt)||(r=i.top);var a=Gt-r+(n-Jt);a=a>0?a:1,Ct.style.height=l+"px",Ct.style.top=a+"px"}}function G(t){var i,o=document.documentElement.clientWidth,n=!1;e.isNullOrUndefined(Pt)||(i=W(Pt));var s="mouse"===X(t.type)?t.pageX:t.touches[0].pageX,l=W(Ct),r=e.isNullOrUndefined(Pt)?0:Pt.offsetWidth-Pt.clientWidth,a=e.isNullOrUndefined(Pt)?0:i.left,h=e.isNullOrUndefined(Pt)?0:i.width;e.isNullOrUndefined(xt)&&(e.isNullOrUndefined(Pt)?xt=o:(xt=l.left-a-r/2+l.width,xt+=h-r-xt)),!e.isNullOrUndefined(Pt)&&Math.floor(l.left-i.left+l.width+(i.right-l.right))-r<=St?n=!0:e.isNullOrUndefined(Pt)&&s>=0&&(n=!0);var d=Wt-(s-Kt);if(ee&&(d=d>xt?xt:d),n&&d>=Tt&&d<=St){var p=0;e.isNullOrUndefined(Pt)||(p=i.left);var c=Zt-p+(s-Kt);c=c>0?c:1,d!==ie&&oe&&(Ct.style.width=d+"px"),ee&&(Ct.style.left=c+"px",oe=1!==c)}ie=d}function K(t){var i,o=document.documentElement.clientWidth,n=!1;e.isNullOrUndefined(Pt)||(i=W(Pt));var s=(t.touches?t.changedTouches[0]:t).pageX,l=W(Ct);!e.isNullOrUndefined(Pt)&&(l.left-i.left+l.width<=St||l.right-i.left>=l.width)?n=!0:e.isNullOrUndefined(Pt)&&o-s>0&&(n=!0);var r=Wt+(s-Kt),a=0;if(e.isNullOrUndefined(Pt)||(a=i.left),l.left-a+r>St){if(n=!1,Ct.classList.contains(qt))return;Ct.style.width=St-(l.left-a)+"px"}n&&r>=Tt&&r<=St&&(Ct.style.width=r+"px")}function J(){for(var t=Ct.querySelectorAll("."+Xt),i=0;i<t.length;i++)e.detach(t[i]);var o=Ct.querySelectorAll(".e-dialog-border-resize");if(!e.isNullOrUndefined(o))for(i=0;i<o.length;i++)e.detach(o[i])}function Q(t,i){if(t.target){var o,n=e.isNullOrUndefined(i)?e.createElement:i,s=function(t,e){var i=e("div",{}),o=e("div",{});return i.classList.add(oi),o.classList.add(ni),t.appendChild(i),i.appendChild(o),{wrap:i,inner_wrap:o}}(t.target,n);if(e.isNullOrUndefined(t.cssClass)||s.wrap.classList.add(t.cssClass),e.isNullOrUndefined(t.template)&&e.isNullOrUndefined(hi)){var l=e.isNullOrUndefined(t.type)?function(t){return window.getComputedStyle(t,":after").getPropertyValue("content").replace(/['"]+/g,"")}(s.wrap):t.type;o=function(t,e){var i;switch(e){case"Material":i=Fe;break;case"Fabric":i=qe;break;case"Tailwind":case"Tailwind-dark":i=qe;break;case"Bootstrap4":i=We;break;case"Bootstrap5":i=Ve;break;default:i=_e}return t=t?parseFloat(t+""):i,"Bootstrap"===e?t:t/2}(e.isNullOrUndefined(t.width)?void 0:t.width,l),$(l,s.wrap,o,n),e.isNullOrUndefined(t.label)||function(t,e,i){var o=i("div",{});o.classList.add(ri),o.innerHTML=e,t.appendChild(o)}(s.inner_wrap,t.label,n)}else{var r=e.isNullOrUndefined(t.template)?hi:t.template;s.wrap.classList.add(ai),function(t,i,o){e.isNullOrUndefined(o)||t.classList.add(o);t.querySelector(".e-spinner-inner").innerHTML=i}(s.wrap,r,di)}s.wrap.classList.add(Ge),s=null}}function $(t,i,o,n){var s=i.querySelector("."+ni),l=s.querySelector("svg");switch(e.isNullOrUndefined(l)||s.removeChild(l),t){case"Material":!function(t,e,i){var o=et();je[o]={timeOut:0,type:"Material",radius:e},ot(t,o,i,Ke),st(e,t,"Material",Ke)}(s,o,n);break;case"Fabric":!function(t,e,i){var o=et();je[o]={timeOut:0,type:"Fabric",radius:e},it(t,o,Je,i),ht(e,t,Je)}(s,o,n);break;case"Bootstrap":!function(t,e,i){var o=et();je[o]={timeOut:0,type:"Bootstrap",radius:e},function(t,e,i){var o=document.createElementNS("http://www.w3.org/2000/svg","svg");o.setAttribute("id",e),o.setAttribute("class",$e),o.setAttribute("viewBox","0 0 64 64"),t.insertBefore(o,t.firstChild);for(var n=0;n<=7;n++){var s=document.createElementNS("http://www.w3.org/2000/svg","circle");s.setAttribute("class",si+"_"+n),s.setAttribute("r","2"),s.setAttribute("transform","translate(32,32)"),o.appendChild(s)}}(t,o),function(t,e){var i=t.querySelector("svg.e-spin-bootstrap");i.style.width=i.style.height=e+"px";for(var o=90,n=0;n<=7;n++){var s=dt(0,0,24,o),l=i.querySelector("."+si+"_"+n);l.setAttribute("cx",s.x+""),l.setAttribute("cy",s.y+""),o=o>=360?0:o,o+=45}}(t,e)}(s,o);break;case"HighContrast":!function(t,e,i){var o=et();je[o]={timeOut:0,type:"HighContrast",radius:e},it(t,o,ii,i),ht(e,t,ii)}(s,o,n);break;case"Bootstrap4":!function(t,e,i){var o=et();je[o]={timeOut:0,type:"Bootstrap4",radius:e},ot(t,o,i,ti),st(e,t,"Bootstrap4",ti)}(s,o,n);break;case"Bootstrap5":!function(t,e,i){var o=et();je[o]={timeOut:0,type:"Bootstrap5",radius:e},ot(t,o,i,ei),st(e,t,"Bootstrap5",ei)}(s,o,n);break;case"Tailwind":case"Tailwind-dark":!function(t,e,i){var o=et();je[o]={timeOut:0,type:"Tailwind",radius:e},it(t,o,Qe,i),ht(e,t,Qe)}(s,o,n)}}function tt(t,e){function i(t){o.push(t),t===s&&1!==r||(t<=n&&t>1&&!l?t=parseFloat((t-.2).toFixed(2)):1===t?(t=7,t=parseFloat((t+.2).toFixed(2)),l=!0):t<8&&l?8===(t=parseFloat((t+.2).toFixed(2)))&&(l=!1):t<=8&&!l&&(t=parseFloat((t-.2).toFixed(2))),++r,i(t))}var o=[],n=t,s=e,l=!1,r=1;return i(n),o}function et(){for(var t="",e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",i=0;i<5;i++)t+=e.charAt(Math.floor(Math.random()*e.length));return t}function it(t,e,i,o){var n=document.createElementNS("http://www.w3.org/2000/svg","svg");n.setAttribute("id",e),n.setAttribute("class",i);var s=document.createElementNS("http://www.w3.org/2000/svg","path");s.setAttribute("class",si);var l=document.createElementNS("http://www.w3.org/2000/svg","path");l.setAttribute("class",li),t.insertBefore(n,t.firstChild),n.appendChild(s),n.appendChild(l)}function ot(t,e,i,o){var n=document.createElementNS("http://www.w3.org/2000/svg","svg"),s=document.createElementNS("http://www.w3.org/2000/svg","path");n.setAttribute("class",o),n.setAttribute("id",e),s.setAttribute("class",si),t.insertBefore(n,t.firstChild),n.appendChild(s)}function nt(t){!function(t,i,o,n,s,l,r){function a(i){var s=Math.max(0,Math.min((new Date).getTime()-d,n));!function(t,i){if(!e.isNullOrUndefined(i.querySelector("svg.e-spin-material"))&&!e.isNullOrUndefined(i.querySelector("svg.e-spin-material").querySelector("path.e-path-circle"))){var o=i.querySelector("svg.e-spin-material"),n=o.querySelector("path.e-path-circle");n.setAttribute("stroke-dashoffset",rt(c,u,t,l)+""),n.setAttribute("transform","rotate("+f+" "+c/2+" "+c/2+")")}}(o(s,t,p,n),i.container),h===i.globalInfo[i.uniqueID].previousId&&s<n?je[i.uniqueID].timeOut=setTimeout(a.bind(null,i),1):nt(i)}var h=++r.globalInfo[r.uniqueID].previousId,d=(new Date).getTime(),p=i-t,c=function(t){return parseFloat(t)}(2*r.globalInfo[r.uniqueID].radius+""),u=lt(c),f=-90*(r.globalInfo[r.uniqueID].count||0);a(r)}(1,149,at,1333,t.globalInfo[t.uniqueID].count,75,t),t.globalInfo[t.uniqueID].count=++t.globalInfo[t.uniqueID].count%4}function st(t,e,i,o){var n=2*t,s=e.querySelector("svg."+o),l=s.querySelector("path.e-path-circle"),r=lt(n),a=n/2+"px";s.setAttribute("viewBox","0 0 "+n+" "+n),s.style.width=s.style.height=n+"px",s.style.transformOrigin=a+" "+a+" "+a,l.setAttribute("d",function(t,e){var i=t/2,o=e/2;return"M"+i+","+o+"A"+(i-o)+","+(i-o)+" 0 1 1 "+o+","+i}(n,r)),"Material"===i&&(l.setAttribute("stroke-width",r+""),l.setAttribute("stroke-dasharray",(n-r)*Math.PI*.75+""),l.setAttribute("stroke-dashoffset",rt(n,r,1,75)+""))}function lt(t){return.1*t}function rt(t,e,i,o){return(t-e)*Math.PI*(3*o/100-i/100)}function at(t,e,i,o){var n=(t/=o)*t,s=n*t;return e+i*(6*s*n+-15*n*n+10*s)}function ht(t,e,i){var o=t,n=t,s=2*t,l=e.querySelector("."+i),r=l.querySelector(".e-path-circle"),a=l.querySelector(".e-path-arc"),h=s/2+"px";r.setAttribute("d",function(t,e,i){return["M",t,e,"m",-i,0,"a",i,i,0,1,0,2*i,0,"a",i,i,0,1,0,2*-i,0].join(" ")}(o,n,t)),a.setAttribute("d",function(t,e,i,o,n){var s=dt(t,e,i,n),l=dt(t,e,i,o);return["M",s.x,s.y,"A",i,i,0,0,0,l.x,l.y].join(" ")}(o,n,t,315,45)),l.setAttribute("viewBox","0 0 "+s+" "+s),l.style.transformOrigin=h+" "+h+" "+h,l.style.width=l.style.height=s+"px"}function dt(t,e,i,o){var n=(o-90)*Math.PI/180;return{x:t+i*Math.cos(n),y:e+i*Math.sin(n)}}function pt(t){ct(t,!1),t=null}function ct(t,i){var o;if(t&&(o=t.classList.contains(oi)?t:t.querySelector("."+oi)),t&&o){var n=o.querySelector("."+ni);if(i?!o.classList.contains(ai)&&!o.classList.contains(Ge):!o.classList.contains(ai)&&!o.classList.contains(Ze)){var s=o.querySelector("svg");if(e.isNullOrUndefined(s))return;var l=s.getAttribute("id");switch(je[l].isAnimate=!i,je[l].type){case"Material":i?clearTimeout(je[l].timeOut):function(t,e,i){var o={};je[e].timeOut=0,o[e]=function(t,e,i,o){return{radius:e,count:i,previousId:o}}(0,i,0,0),nt({uniqueID:e,container:t,globalInfo:o,timeOutVar:0})}(n,l,je[l].radius);break;case"Bootstrap":i?clearTimeout(je[l].timeOut):function(t){for(var e=t.querySelector("svg.e-spin-bootstrap").getAttribute("id"),i=1;i<=8;i++)!function(t,e,i,o,n){function s(e){je[n].isAnimate&&(++l,t.setAttribute("r",e+""),l>=o.length&&(l=0),je[n].timeOut=setTimeout(s.bind(null,o[l]),18))}var l=0;s(e)}(t.getElementsByClassName("e-path-circle_"+(8===i?0:i))[0],i,0,tt(i,i),e)}(n)}}i?e.classList(o,[Ge],[Ze]):e.classList(o,[Ze],[Ge]),t=null}}function ut(t){ct(t,!0),t=null}function ft(t,i){var o=e.isNullOrUndefined(i)?e.createElement:i;void 0!==t.template&&(hi=t.template,void 0!==t.template&&(di=t.cssClass));for(var n=document.querySelectorAll("."+oi),s=0;s<n.length;s++)!function(t,i,o,n,s){e.isNullOrUndefined(t)&&!i.classList.contains(ai)?(!function(t,i,o,n){e.isNullOrUndefined(o)||t.classList.add(o);var s=t.querySelector("svg"),l="Bootstrap"===i?parseFloat(s.style.height):parseFloat(s.style.height)/2;if(s.getAttribute("class").split(/\s/).indexOf("e-spin-material")>=0){var r=s.getAttribute("id");clearTimeout(je[r].timeOut)}$(i,t,l,n)}(i,o,n,s),i.classList.contains(Ze)?(i.classList.remove(Ze),pt(i)):(i.classList.remove(Ge),ut(i))):(hi=t,e.isNullOrUndefined(n)||(di=n))}(t.template,n[s],t.type,t.cssClass,o)}var mt,gt,yt,vt,bt,Et,Ct,Ot,wt,Nt,Tt,St,Pt,xt,Ht,Bt=!1,Ut=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function o(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(o.prototype=i.prototype,new o)}}(),kt=function(t,e,i,o){var n,s=arguments.length,l=s<3?e:null===o?o=Object.getOwnPropertyDescriptor(e,i):o;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)l=Reflect.decorate(t,e,i,o);else for(var r=t.length-1;r>=0;r--)(n=t[r])&&(l=(s<3?n(l):s>3?n(e,i,l):n(e,i))||l);return s>3&&l&&Object.defineProperty(e,i,l),l},Rt=function(t){function i(){return null!==t&&t.apply(this,arguments)||this}return Ut(i,t),kt([e.Property("left")],i.prototype,"X",void 0),kt([e.Property("top")],i.prototype,"Y",void 0),i}(e.ChildProperty),zt="e-popup",Mt="e-rtl",Lt="e-popup-open",It="e-popup-close",At=function(t){function i(e,i){return t.call(this,i,e)||this}return Ut(i,t),i.prototype.onPropertyChanged=function(t,i){for(var o=0,n=Object.keys(t);o<n.length;o++){switch(n[o]){case"width":e.setStyleAttribute(this.element,{width:e.formatUnit(t.width)});break;case"height":e.setStyleAttribute(this.element,{height:e.formatUnit(t.height)});break;case"zIndex":e.setStyleAttribute(this.element,{zIndex:t.zIndex});break;case"enableRtl":this.setEnableRtl();break;case"position":case"relateTo":this.refreshPosition();break;case"offsetX":var s=t.offsetX-i.offsetX;this.element.style.left=(parseInt(this.element.style.left,10)+s).toString()+"px";break;case"offsetY":var l=t.offsetY-i.offsetY;this.element.style.top=(parseInt(this.element.style.top,10)+l).toString()+"px";break;case"content":this.setContent();break;case"actionOnScroll":"none"!==t.actionOnScroll?this.wireScrollEvents():this.unwireScrollEvents()}}},i.prototype.getModuleName=function(){return"popup"},i.prototype.resolveCollision=function(){this.checkCollision()},i.prototype.getPersistData=function(){return this.addOnPersist([])},i.prototype.destroy=function(){this.element.classList.remove(zt,Mt,Lt,It),this.unwireEvents(),t.prototype.destroy.call(this)},i.prototype.render=function(){this.element.classList.add(zt);var t={};1e3!==this.zIndex&&(t.zIndex=this.zIndex),"auto"!==this.width&&(t.width=e.formatUnit(this.width)),"auto"!==this.height&&(t.height=e.formatUnit(this.height)),e.setStyleAttribute(this.element,t),this.fixedParent=!1,this.setEnableRtl(),this.setContent()},i.prototype.wireEvents=function(){e.Browser.isDevice&&e.EventHandler.add(window,"orientationchange",this.orientationOnChange,this),"none"!==this.actionOnScroll&&this.wireScrollEvents()},i.prototype.wireScrollEvents=function(){if(this.getRelateToElement())for(var t=0,i=this.getScrollableParent(this.getRelateToElement());t<i.length;t++){var o=i[t];e.EventHandler.add(o,"scroll",this.scrollRefresh,this)}},i.prototype.unwireEvents=function(){e.Browser.isDevice&&e.EventHandler.remove(window,"orientationchange",this.orientationOnChange),"none"!==this.actionOnScroll&&this.unwireScrollEvents()},i.prototype.unwireScrollEvents=function(){if(this.getRelateToElement())for(var t=0,i=this.getScrollableParent(this.getRelateToElement());t<i.length;t++){var o=i[t];e.EventHandler.remove(o,"scroll",this.scrollRefresh)}},i.prototype.getRelateToElement=function(){var t=""===this.relateTo||e.isNullOrUndefined(this.relateTo)?document.body:this.relateTo;return this.setProperties({relateTo:t},!0),"string"==typeof this.relateTo?document.querySelector(this.relateTo):this.relateTo},i.prototype.scrollRefresh=function(t){if("reposition"===this.actionOnScroll?e.isNullOrUndefined(this.element)||this.element.offsetParent===t.target||this.element.offsetParent&&"BODY"===this.element.offsetParent.tagName&&null==t.target.parentElement||this.refreshPosition():"hide"===this.actionOnScroll&&this.hide(),"none"!==this.actionOnScroll&&this.getRelateToElement()){var i=this.isElementOnViewport(this.getRelateToElement(),t.target);i||this.targetInvisibleStatus?i&&(this.targetInvisibleStatus=!1):(this.trigger("targetExitViewport"),this.targetInvisibleStatus=!0)}},i.prototype.isElementOnViewport=function(t,e){for(var i=this.getScrollableParent(t),o=0;o<i.length;o++)if(!this.isElementVisible(t,i[o]))return!1;return!0},i.prototype.isElementVisible=function(t,i){var o=this.checkGetBoundingClientRect(t);if(!o.height||!o.width)return!1;if(e.isNullOrUndefined(this.checkGetBoundingClientRect(i))){var s=window,l=s.scrollY,r=s.scrollX,a=s.scrollX+s.outerWidth,h=s.scrollY+s.outerHeight,d=n(t),p=d.top,c=d.left,u=d.left+o.width,f=d.top+o.height;return h-p>0&&a-c>0&&u-r>0&&f-l>0}var m=i.getBoundingClientRect();return!(o.bottom<m.top||o.bottom>m.bottom||o.right>m.right||o.left<m.left)},i.prototype.preRender=function(){},i.prototype.setEnableRtl=function(){this.reposition(),this.enableRtl?this.element.classList.add(Mt):this.element.classList.remove(Mt)},i.prototype.setContent=function(){if(!e.isNullOrUndefined(this.content))if(this.element.innerHTML="","string"==typeof this.content)this.element.textContent=this.content;else{var t=this.getRelateToElement(),i=this.content.props;t.classList.contains("e-dropdown-btn")&&!e.isNullOrUndefined(i)||this.element.appendChild(this.content)}},i.prototype.orientationOnChange=function(){var t=this;setTimeout(function(){t.refreshPosition()},200)},i.prototype.refreshPosition=function(t,i){e.isNullOrUndefined(t)||this.checkFixedParent(t),this.reposition(),i||this.checkCollision()},i.prototype.reposition=function(){var t,i,o=this.getRelateToElement();if("number"==typeof this.position.X&&"number"==typeof this.position.Y)t={left:this.position.X,top:this.position.Y};else if("string"==typeof this.position.X&&"number"==typeof this.position.Y||"number"==typeof this.position.X&&"string"==typeof this.position.Y){var n=void 0,s=this.element.style.display;this.element.style.display="block",this.element.classList.contains("e-dlg-modal")&&(n=this.element.parentElement.style.display,this.element.parentElement.style.display="block"),i=this.getAnchorPosition(o,this.element,this.position,this.offsetX,this.offsetY),t="string"==typeof this.position.X?{left:i.left,top:this.position.Y}:{left:this.position.X,top:i.top},this.element.style.display=s,this.element.classList.contains("e-dlg-modal")&&(this.element.parentElement.style.display=n)}else if(o){s=this.element.style.display;this.element.style.display="block",t=this.getAnchorPosition(o,this.element,this.position,this.offsetX,this.offsetY),this.element.style.display=s}else t={left:0,top:0};e.isNullOrUndefined(t)||(this.element.style.left=t.left+"px",this.element.style.top=t.top+"px")},i.prototype.checkGetBoundingClientRect=function(t){try{return t.getBoundingClientRect()}catch(t){return null}},i.prototype.getAnchorPosition=function(t,i,s,l,r){var a=this.checkGetBoundingClientRect(i),h=this.checkGetBoundingClientRect(t);if(e.isNullOrUndefined(a)||e.isNullOrUndefined(h))return null;var d=t,p={left:0,top:0};switch(i.offsetParent&&"BODY"===i.offsetParent.tagName&&"BODY"===t.tagName?p=n(t):(i.classList.contains("e-dlg-modal")&&"BODY"!==d.tagName&&(i=i.parentElement),p=o(d,i)),s.X){default:case"left":break;case"center":i.classList.contains("e-dlg-modal")&&"BODY"===d.tagName&&"container"===this.targetType?p.left+=window.innerWidth/2-a.width/2:"container"===this.targetType?p.left+=h.width/2-a.width/2:p.left+=h.width/2;break;case"right":i.classList.contains("e-dlg-modal")&&"BODY"===d.tagName&&"container"===this.targetType?p.left+=window.innerWidth-a.width:"container"===this.targetType?p.left+=h.width-a.width:p.left+=h.width}switch(s.Y){default:case"top":break;case"center":i.classList.contains("e-dlg-modal")&&"BODY"===d.tagName&&"container"===this.targetType?p.top+=window.innerHeight/2-a.height/2:"container"===this.targetType?p.top+=h.height/2-a.height/2:p.top+=h.height/2;break;case"bottom":i.classList.contains("e-dlg-modal")&&"BODY"===d.tagName&&"container"===this.targetType?p.top+=window.innerHeight-a.height:"container"===this.targetType?p.top+=h.height-a.height:p.top+=h.height}return p.left+=l,p.top+=r,p},i.prototype.callFlip=function(t){var e=this.getRelateToElement();y(this.element,e,this.offsetX,this.offsetY,this.position.X,this.position.Y,this.viewPortElement,t,this.fixedParent)},i.prototype.callFit=function(t){if(0!==g(this.element,this.viewPortElement).length)if(e.isNullOrUndefined(this.viewPortElement)){var i=m(this.element,this.viewPortElement,t);t.X&&(this.element.style.left=i.left+"px"),t.Y&&(this.element.style.top=i.top+"px")}else{var o=this.checkGetBoundingClientRect(this.element),n=this.checkGetBoundingClientRect(this.viewPortElement);if(e.isNullOrUndefined(o)||e.isNullOrUndefined(n))return null;t&&!0===t.Y&&(n.top>o.top?this.element.style.top="0px":n.bottom<o.bottom&&(this.element.style.top=parseInt(this.element.style.top,10)-(o.bottom-n.bottom)+"px")),t&&!0===t.X&&(n.right<o.right?this.element.style.left=parseInt(this.element.style.left,10)-(o.right-n.right)+"px":n.left>o.left&&(this.element.style.left=parseInt(this.element.style.left,10)+(n.left-o.left)+"px"))}},i.prototype.checkCollision=function(){var t=this.collision.X,e=this.collision.Y;"none"===t&&"none"===e||("flip"===t&&"flip"===e?this.callFlip({X:!0,Y:!0}):"fit"===t&&"fit"===e?this.callFit({X:!0,Y:!0}):("flip"===t?this.callFlip({X:!0,Y:!1}):"flip"===e&&this.callFlip({Y:!0,X:!1}),"fit"===t?this.callFit({X:!0,Y:!1}):"fit"===e&&this.callFit({X:!1,Y:!0})))},i.prototype.show=function(t,i){var o=this;if(this.wireEvents(),1e3===this.zIndex||!e.isNullOrUndefined(i)){var n=e.isNullOrUndefined(i)?this.element:i;this.zIndex=L(n),e.setStyleAttribute(this.element,{zIndex:this.zIndex})}t=e.isNullOrUndefined(t)||"object"!=typeof t?this.showAnimation:t,"none"===this.collision.X&&"none"===this.collision.Y||(e.removeClass([this.element],It),e.addClass([this.element],Lt),this.checkCollision(),e.removeClass([this.element],Lt),e.addClass([this.element],It)),e.isNullOrUndefined(t)?(e.removeClass([this.element],It),e.addClass([this.element],Lt),this.trigger("open")):(t.begin=function(){o.isDestroyed||(e.removeClass([o.element],It),e.addClass([o.element],Lt))},t.end=function(){o.isDestroyed||o.trigger("open")},new e.Animation(t).animate(this.element))},i.prototype.hide=function(t){var i=this;t=e.isNullOrUndefined(t)||"object"!=typeof t?this.hideAnimation:t,e.isNullOrUndefined(t)?(e.removeClass([this.element],Lt),e.addClass([this.element],It),this.trigger("close")):(t.end=function(){i.isDestroyed||(e.removeClass([i.element],Lt),e.addClass([i.element],It),i.trigger("close"))},new e.Animation(t).animate(this.element)),this.unwireEvents()},i.prototype.getScrollableParent=function(t){return this.checkFixedParent(t),M(t,this.fixedParent)},i.prototype.checkFixedParent=function(t){for(var i=t.parentElement;i&&"HTML"!==i.tagName;){var o=getComputedStyle(i);"fixed"===o.position&&!e.isNullOrUndefined(this.element)&&this.element.offsetParent&&"BODY"===this.element.offsetParent.tagName&&(this.element.style.top=window.scrollY>parseInt(this.element.style.top)?e.formatUnit(window.scrollY-parseInt(this.element.style.top)):e.formatUnit(parseInt(this.element.style.top)-window.scrollY),this.element.style.position="fixed",this.fixedParent=!0),i=i.parentElement,!e.isNullOrUndefined(this.element)&&e.isNullOrUndefined(this.element.offsetParent)&&"fixed"===o.position&&"fixed"===this.element.style.position&&(this.fixedParent=!0)}},kt([e.Property("auto")],i.prototype,"height",void 0),kt([e.Property("auto")],i.prototype,"width",void 0),kt([e.Property(null)],i.prototype,"content",void 0),kt([e.Property("container")],i.prototype,"targetType",void 0),kt([e.Property(null)],i.prototype,"viewPortElement",void 0),kt([e.Property({X:"none",Y:"none"})],i.prototype,"collision",void 0),kt([e.Property("")],i.prototype,"relateTo",void 0),kt([e.Complex({},Rt)],i.prototype,"position",void 0),kt([e.Property(0)],i.prototype,"offsetX",void 0),kt([e.Property(0)],i.prototype,"offsetY",void 0),kt([e.Property(1e3)],i.prototype,"zIndex",void 0),kt([e.Property(!1)],i.prototype,"enableRtl",void 0),kt([e.Property("reposition")],i.prototype,"actionOnScroll",void 0),kt([e.Property(null)],i.prototype,"showAnimation",void 0),kt([e.Property(null)],i.prototype,"hideAnimation",void 0),kt([e.Event()],i.prototype,"open",void 0),kt([e.Event()],i.prototype,"close",void 0),kt([e.Event()],i.prototype,"targetExitViewport",void 0),i=kt([e.NotifyPropertyChanges],i)}(e.Component),Yt=["north-west","north","north-east","west","east","south-west","south","south-east"],Xt="e-resize-handle",Dt="e-focused-handle",jt="e-dlg-resizable",Ft=["e-restrict-left"],qt="e-resize-viewport",_t=["north","west","east","south"],Wt=0,Vt=0,Zt=0,Gt=0,Kt=0,Jt=0,Qt=null,$t=null,te=null,ee=!0,ie=0,oe=!0,ne=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function o(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(o.prototype=i.prototype,new o)}}(),se=function(t,e,i,o){var n,s=arguments.length,l=s<3?e:null===o?o=Object.getOwnPropertyDescriptor(e,i):o;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)l=Reflect.decorate(t,e,i,o);else for(var r=t.length-1;r>=0;r--)(n=t[r])&&(l=(s<3?n(l):s>3?n(e,i,l):n(e,i))||l);return s>3&&l&&Object.defineProperty(e,i,l),l},le=function(t){function i(){return null!==t&&t.apply(this,arguments)||this}return ne(i,t),se([e.Property(!0)],i.prototype,"isFlat",void 0),se([e.Property()],i.prototype,"buttonModel",void 0),se([e.Property("Button")],i.prototype,"type",void 0),se([e.Event()],i.prototype,"click",void 0),i}(e.ChildProperty),re=function(t){function i(){return null!==t&&t.apply(this,arguments)||this}return ne(i,t),se([e.Property("Fade")],i.prototype,"effect",void 0),se([e.Property(400)],i.prototype,"duration",void 0),se([e.Property(0)],i.prototype,"delay",void 0),i}(e.ChildProperty),ae="e-dialog",he="e-dlg-header-content",de="e-footer-content",pe="e-dlg-modal",ce="e-icon-dlg-close",ue="e-dlg-target",fe="e-scroll-disabled",me="e-dlg-fullscreen",ge="e-dlg-closeicon-btn",ye="Information",ve="e-scroll-disabled",be="e-alert-dialog",Ee="e-confirm-dialog",Ce="e-dlg-resizable",Oe="e-restrict-left",we="e-resize-viewport",Ne="user action",Te=function(t){function o(e,i){var o=t.call(this,e,i)||this;return o.dlgClosedBy=Ne,o}return ne(o,t),o.prototype.render=function(){this.initialize(),this.initRender(),this.wireEvents(),"100%"===this.width&&(this.element.style.width=""),""!==this.minHeight&&(this.element.style.minHeight=e.formatUnit(this.minHeight)),this.enableResize&&(this.setResize(),"None"===this.animationSettings.effect&&this.getMinHeight()),this.renderComplete()},o.prototype.preRender=function(){var t=this;this.headerContent=null,this.allowMaxHeight=!0,this.preventVisibility=!0,this.clonedEle=this.element.cloneNode(!0),this.closeIconClickEventHandler=function(e){t.dlgClosedBy="close icon",t.hide(e)},this.dlgOverlayClickEventHandler=function(e){t.dlgClosedBy="overlayClick",e.preventFocus=!1,t.trigger("overlayClick",e,function(e){e.preventFocus||t.focusContent(),t.dlgClosedBy=Ne})};if(this.l10n=new e.L10n("dialog",{close:"Close"},this.locale),this.checkPositionData(),e.isNullOrUndefined(this.target)){var i=this.isProtectedOnChange;this.isProtectedOnChange=!0,this.target=document.body,this.isProtectedOnChange=i}},o.prototype.isNumberValue=function(t){return/^[-+]?\d*\.?\d+$/.test(t)},o.prototype.checkPositionData=function(){if(!e.isNullOrUndefined(this.position)){if(!e.isNullOrUndefined(this.position.X)&&"number"!=typeof this.position.X){if(this.isNumberValue(this.position.X)){var t=this.isProtectedOnChange;this.isProtectedOnChange=!0,this.position.X=parseFloat(this.position.X),this.isProtectedOnChange=t}}if(!e.isNullOrUndefined(this.position.Y)&&"number"!=typeof this.position.Y){if(this.isNumberValue(this.position.Y)){t=this.isProtectedOnChange;this.isProtectedOnChange=!0,this.position.Y=parseFloat(this.position.Y),this.isProtectedOnChange=t}}}},o.prototype.getEle=function(t,e){for(var i=void 0,o=0;o<t.length;o++)if(t[o].classList.contains(e)){i=t[o];break}return i},o.prototype.getMinHeight=function(){var t="0px",i="0px";e.isNullOrUndefined(this.element.querySelector("."+he))||(t=getComputedStyle(this.headerContent).height);var o=this.getEle(this.element.children,de);e.isNullOrUndefined(o)||(i=getComputedStyle(o).height);var n=parseInt(t.slice(0,t.indexOf("p")),10),s=parseInt(i.slice(0,i.indexOf("p")),10);return function(t){wt=t}(n+30+(isNaN(s)?0:s)),n+30+s},o.prototype.onResizeStart=function(t,e){return e.trigger("resizeStart",t),t.cancel},o.prototype.onResizing=function(t,e){e.trigger("resizing",t)},o.prototype.onResizeComplete=function(t,e){e.trigger("resizeStop",t)},o.prototype.setResize=function(){if(this.enableResize){if(this.isBlazorServerRender()&&!e.isNullOrUndefined(this.element.querySelector(".e-icons.e-resize-handle")))return;this.element.classList.add(Ce);for(var t=getComputedStyle(this.element).minHeight,i=getComputedStyle(this.element).minWidth,o="",n=0;n<this.resizeHandles.length;n++){if("All"===this.resizeHandles[n]){o="south north east west north-east north-west south-east south-west";break}var s="";switch(this.resizeHandles[n].toString()){case"SouthEast":s="south-east";break;case"SouthWest":s="south-west";break;case"NorthEast":s="north-east";break;case"NorthWest":s="north-west";break;default:s=this.resizeHandles[n].toString()}o+=s.toLocaleLowerCase()+" "}this.enableRtl&&"south-east"===o.trim()?o="south-west":this.enableRtl&&"south-west"===o.trim()&&(o="south-east"),this.isModal&&this.enableRtl?this.element.classList.add(Oe):this.isModal&&this.target===document.body&&this.element.classList.add(we),I({element:this.element,direction:o,minHeight:parseInt(t.slice(0,i.indexOf("p")),10),maxHeight:this.targetEle.clientHeight,minWidth:parseInt(i.slice(0,i.indexOf("p")),10),maxWidth:this.targetEle.clientWidth,boundary:this.target===document.body?null:this.targetEle,resizeBegin:this.onResizeStart.bind(this),resizeComplete:this.onResizeComplete.bind(this),resizing:this.onResizing.bind(this),proxy:this}),this.wireWindowResizeEvent()}else J(),this.unWireWindowResizeEvent(),this.isModal?this.element.classList.remove(Oe):this.element.classList.remove(we),this.element.classList.remove(Ce)},o.prototype.getFocusElement=function(t){var e=t.querySelectorAll('input,select,textarea,button:enabled,a,[contenteditable="true"],[tabindex]');return{element:e[e.length-1]}},o.prototype.keyDown=function(t){var i=this;if(9===t.keyCode&&this.isModal){var o=void 0;e.isNullOrUndefined(this.btnObj)||(o=this.btnObj[this.btnObj.length-1]),e.isNullOrUndefined(this.btnObj)&&!e.isNullOrUndefined(this.ftrTemplateContent)&&(o=this.getFocusElement(this.ftrTemplateContent)),e.isNullOrUndefined(this.btnObj)&&e.isNullOrUndefined(this.ftrTemplateContent)&&!e.isNullOrUndefined(this.contentEle)&&(o=this.getFocusElement(this.contentEle)),e.isNullOrUndefined(o)||document.activeElement!==o.element||t.shiftKey||(t.preventDefault(),this.focusableElements(this.element).focus()),document.activeElement===this.focusableElements(this.element)&&t.shiftKey&&(t.preventDefault(),e.isNullOrUndefined(o)||o.element.focus())}var n=document.activeElement,s=["input","textarea"].indexOf(n.tagName.toLowerCase())>-1,l=!1;if(s||(l=n.hasAttribute("contenteditable")&&"true"===n.getAttribute("contenteditable")),27===t.keyCode&&this.closeOnEscape&&(this.dlgClosedBy="escape",document.querySelector(".e-popup-open:not(.e-dialog)")||this.hide(t)),13===t.keyCode&&!t.ctrlKey&&"textarea"!==n.tagName.toLowerCase()&&s&&!e.isNullOrUndefined(this.primaryButtonEle)||13===t.keyCode&&t.ctrlKey&&("textarea"===n.tagName.toLowerCase()||l)&&!e.isNullOrUndefined(this.primaryButtonEle)){var r;this.buttons.some(function(t,i){r=i;var o=t.buttonModel;return!e.isNullOrUndefined(o)&&!0===o.isPrimary})&&"function"==typeof this.buttons[r].click&&setTimeout(function(){i.buttons[r].click.call(i,t)})}},o.prototype.initialize=function(){e.isNullOrUndefined(this.target)||(this.targetEle="string"==typeof this.target?document.querySelector(this.target):this.target),this.isBlazorServerRender()||e.addClass([this.element],ae),e.Browser.isDevice&&e.addClass([this.element],"e-device"),this.isBlazorServerRender()||this.setCSSClass(),this.setMaxHeight()},o.prototype.initRender=function(){var t=this;if(this.initialRender=!0,this.isBlazorServerRender()||e.attributes(this.element,{role:"dialog"}),1e3===this.zIndex?(this.setzIndex(this.element,!1),this.calculatezIndex=!0):this.calculatezIndex=!1,this.isBlazorServerRender()&&e.isNullOrUndefined(this.headerContent)&&(this.headerContent=this.element.getElementsByClassName("e-dlg-header-content")[0]),this.isBlazorServerRender()&&e.isNullOrUndefined(this.contentEle)&&(this.contentEle=this.element.querySelector("#"+this.element.id+"_dialog-content")),this.isBlazorServerRender()||(this.setTargetContent(),""===this.header||e.isNullOrUndefined(this.header)||this.setHeader(),this.renderCloseIcon(),this.setContent(),""===this.footerTemplate||e.isNullOrUndefined(this.footerTemplate)?e.isNullOrUndefined(this.buttons[0].buttonModel)||this.setButton():this.setFooterTemplate()),this.isBlazorServerRender()&&(e.isNullOrUndefined(this.buttons[0].buttonModel)||""!==this.footerTemplate||this.setButton()),this.allowDragging&&!e.isNullOrUndefined(this.headerContent)&&this.setAllowDragging(),this.isBlazorServerRender()||(e.attributes(this.element,{"aria-modal":this.isModal?"true":"false"}),this.isModal&&this.setIsModal()),this.isBlazorServerRender()&&e.isNullOrUndefined(this.dlgContainer)){this.dlgContainer=this.element.parentElement;for(var i=0,o=this.dlgContainer.children;i<o.length;i++)o[i].classList.contains("e-dlg-overlay")&&(this.dlgOverlay=o[i])}if(!0!==this.element.classList.contains(be)&&!0!==this.element.classList.contains(Ee)&&!e.isNullOrUndefined(this.element.parentElement)){var n=this.isModal?this.dlgContainer.parentElement:this.element.parentElement;this.refElement=this.createElement("div",{className:"e-dlg-ref-element"}),n.insertBefore(this.refElement,this.isModal?this.dlgContainer:this.element)}e.isNullOrUndefined(this.targetEle)||(this.isModal?this.targetEle.appendChild(this.dlgContainer):this.targetEle.appendChild(this.element)),this.popupObj=new At(this.element,{height:this.height,width:this.width,zIndex:this.zIndex,relateTo:this.target,actionOnScroll:"none",enableRtl:this.enableRtl,open:function(e){var i={container:t.isModal?t.dlgContainer:t.element,element:t.element,target:t.target,preventFocus:!1};t.enableResize&&t.resetResizeIcon(),t.trigger("open",i,function(e){e.preventFocus||t.focusContent()})},close:function(i){t.isModal&&e.addClass([t.dlgOverlay],"e-fade"),t.unBindEvent(t.element),t.isModal&&(t.dlgContainer.style.display="none"),t.trigger("close",t.closeArgs);var o=document.activeElement;e.isNullOrUndefined(o)||e.isNullOrUndefined(o.blur)||o.blur(),e.isNullOrUndefined(t.storeActiveElement)||e.isNullOrUndefined(t.storeActiveElement.focus)||t.storeActiveElement.focus()}}),this.positionChange(),this.setEnableRTL(),this.isBlazorServerRender()||(e.addClass([this.element],"e-popup-close"),this.isModal&&this.setOverlayZindex()),this.visible?this.show():this.isModal&&(this.dlgOverlay.style.display="none"),this.initialRender=!1},o.prototype.resetResizeIcon=function(){var t=this.getMinHeight();if(this.targetEle.offsetHeight<t){var i=this.enableRtl?"e-south-west":"e-south-east",o=this.element.querySelector("."+i);e.isNullOrUndefined(o)||(o.style.bottom="-"+t.toString()+"px")}},o.prototype.setOverlayZindex=function(t){var i;i=e.isNullOrUndefined(t)?parseInt(this.element.style.zIndex,10)?parseInt(this.element.style.zIndex,10):this.zIndex:t,this.dlgOverlay.style.zIndex=(i-1).toString(),this.dlgContainer.style.zIndex=i.toString()},o.prototype.positionChange=function(){this.isModal&&(isNaN(parseFloat(this.position.X))||isNaN(parseFloat(this.position.Y)))?!isNaN(parseFloat(this.position.X))&&isNaN(parseFloat(this.position.Y))||isNaN(parseFloat(this.position.X))&&!isNaN(parseFloat(this.position.Y))?this.setPopupPosition():(this.element.style.top="0px",this.element.style.left="0px",this.dlgContainer.classList.add("e-dlg-"+this.position.X+"-"+this.position.Y)):this.setPopupPosition()},o.prototype.setPopupPosition=function(){this.popupObj.setProperties({position:{X:this.position.X,Y:this.position.Y}})},o.prototype.setAllowDragging=function(){var t=this;this.dragObj=new e.Draggable(this.element,{clone:!1,isDragScroll:!0,abort:".e-dlg-closeicon-btn",handle:".e-dlg-header-content",dragStart:function(i){t.trigger("dragStart",i,function(t){e.isBlazor()&&t.bindEvents(i.dragElement)})},dragStop:function(i){t.isModal&&(e.isNullOrUndefined(t.position)||t.dlgContainer.classList.remove("e-dlg-"+t.position.X+"-"+t.position.Y),t.element.style.position="relative"),t.trigger("dragStop",i),t.element.classList.remove(Oe)},drag:function(e){t.trigger("drag",e)}}),e.isNullOrUndefined(this.targetEle)||(this.dragObj.dragArea=this.targetEle)},o.prototype.setButton=function(){if(!this.isBlazorServerRender()){this.buttonContent=[],this.btnObj=[];for(var t=0;t<this.buttons.length;t++){var o=e.isNullOrUndefined(this.buttons[t].type)?"button":this.buttons[t].type.toLowerCase(),n=this.createElement("button",{attrs:{type:o}});this.buttonContent.push(n.outerHTML)}this.setFooterTemplate()}t=0;for(var s,l=this.element.children;t<l.length;t++)l[t].classList.contains(de)&&(s=l[t].querySelectorAll("button"));for(t=0;t<this.buttons.length;t++)this.isBlazorServerRender()||(this.btnObj[t]=new i.Button(this.buttons[t].buttonModel)),this.isBlazorServerRender()&&(this.ftrTemplateContent=this.element.querySelector("."+de)),!e.isNullOrUndefined(this.ftrTemplateContent)&&s.length>0&&("function"==typeof this.buttons[t].click&&e.EventHandler.add(s[t],"click",this.buttons[t].click,this),"object"==typeof this.buttons[t].click&&e.EventHandler.add(s[t],"click",this.buttonClickHandler.bind(this,t),this)),this.isBlazorServerRender()||e.isNullOrUndefined(this.ftrTemplateContent)||(this.btnObj[t].appendTo(this.ftrTemplateContent.children[t]),this.buttons[t].isFlat&&this.btnObj[t].element.classList.add("e-flat"),this.primaryButtonEle=this.element.getElementsByClassName("e-primary")[0])},o.prototype.buttonClickHandler=function(t){this.trigger("buttons["+t+"].click",{})},o.prototype.setContent=function(){e.attributes(this.element,{"aria-describedby":this.element.id+"_dialog-content"}),this.contentEle=this.createElement("div",{className:"e-dlg-content",id:this.element.id+"_dialog-content"}),this.innerContentElement?this.contentEle.appendChild(this.innerContentElement):(e.isNullOrUndefined(this.content)||""===this.content)&&this.initialRender||("string"!=typeof this.content||e.isBlazor()?this.content instanceof HTMLElement?this.contentEle.appendChild(this.content):this.setTemplate(this.content,this.contentEle,"content"):this.contentEle.innerHTML=this.sanitizeHelper(this.content)),e.isNullOrUndefined(this.headerContent)?this.element.insertBefore(this.contentEle,this.element.children[0]):this.element.insertBefore(this.contentEle,this.element.children[1]),"auto"===this.height&&(this.isBlazorServerRender()||!e.Browser.isIE||""!==this.element.style.width||e.isNullOrUndefined(this.width)||(this.element.style.width=e.formatUnit(this.width)),this.setMaxHeight())},o.prototype.setTemplate=function(t,i,o){var n,s;s=i.classList.contains("e-dlg-header")?this.element.id+"header":i.classList.contains(de)?this.element.id+"footerTemplate":this.element.id+"content";var l;e.isNullOrUndefined(t.outerHTML)?"string"!=typeof t||e.isBlazor()&&!this.isStringTemplate?(n=e.compile(t),l=t):i.innerHTML=this.sanitizeHelper(t):i.appendChild(t);var r=[];if(!e.isNullOrUndefined(n)){for(var a=0,h=n({},this,o,s,!(e.isBlazor()&&!this.isStringTemplate&&0===l.indexOf("<div>Blazor"))||this.isStringTemplate);a<h.length;a++){var d=h[a];r.push(d)}e.append([].slice.call(r),i)}},o.prototype.sanitizeHelper=function(t){if(this.enableHtmlSanitizer){var i=e.SanitizeHtmlHelper.beforeSanitize();e.extend(i,i,{cancel:!1,helper:null}),this.trigger("beforeSanitizeHtml",i),i.cancel&&!e.isNullOrUndefined(i.helper)?t=i.helper(t):i.cancel||(t=e.SanitizeHtmlHelper.serializeValue(i,t))}return t},o.prototype.setMaxHeight=function(){if(this.allowMaxHeight){var t=this.element.style.display;this.element.style.display="none",this.element.style.maxHeight=!e.isNullOrUndefined(this.target)&&this.targetEle.offsetHeight<window.innerHeight?this.targetEle.offsetHeight-20+"px":window.innerHeight-20+"px",this.element.style.display=t,e.Browser.isIE&&"auto"===this.height&&!e.isNullOrUndefined(this.contentEle)&&this.element.offsetHeight<this.contentEle.offsetHeight&&(this.element.style.height="inherit")}},o.prototype.setEnableRTL=function(){this.isBlazorServerRender()||(this.enableRtl?e.addClass([this.element],"e-rtl"):e.removeClass([this.element],"e-rtl")),e.isNullOrUndefined(this.element.querySelector(".e-resize-handle"))||(J(),this.setResize())},o.prototype.setTargetContent=function(){var t=this;if(e.isNullOrUndefined(this.content)||""===this.content){var i=""!==this.element.innerHTML.replace(/\s|<(\/?|\/?)(!--!--)>/g,"");(this.element.children.length>0||i)&&(this.innerContentElement=document.createDocumentFragment(),[].slice.call(this.element.childNodes).forEach(function(e){8!==e.nodeType&&t.innerContentElement.appendChild(e)}))}},o.prototype.setHeader=function(){this.headerEle?this.headerEle.innerHTML="":this.headerEle=this.createElement("div",{id:this.element.id+"_title",className:"e-dlg-header"}),this.createHeaderContent(),this.headerContent.appendChild(this.headerEle),this.setTemplate(this.header,this.headerEle,"header"),e.attributes(this.element,{"aria-labelledby":this.element.id}),this.element.insertBefore(this.headerContent,this.element.children[0])},o.prototype.setFooterTemplate=function(){this.ftrTemplateContent?this.ftrTemplateContent.innerHTML="":this.ftrTemplateContent=this.createElement("div",{className:de}),""===this.footerTemplate||e.isNullOrUndefined(this.footerTemplate)?this.ftrTemplateContent.innerHTML=this.buttonContent.join(""):this.setTemplate(this.footerTemplate,this.ftrTemplateContent,"footerTemplate"),this.element.appendChild(this.ftrTemplateContent)},o.prototype.createHeaderContent=function(){e.isNullOrUndefined(this.headerContent)&&(this.headerContent=this.createElement("div",{id:this.element.id+"_dialog-header",className:he}))},o.prototype.renderCloseIcon=function(){this.showCloseIcon&&(this.closeIcon=this.createElement("button",{className:ge,attrs:{type:"button"}}),this.closeIconBtnObj=new i.Button({cssClass:"e-flat",iconCss:ce+" e-icons"}),this.closeIconTitle(),e.isNullOrUndefined(this.headerContent)?(this.createHeaderContent(),e.prepend([this.closeIcon],this.headerContent),this.element.insertBefore(this.headerContent,this.element.children[0])):e.prepend([this.closeIcon],this.headerContent),this.closeIconBtnObj.appendTo(this.closeIcon))},o.prototype.closeIconTitle=function(){this.l10n.setLocale(this.locale);var t=this.l10n.getConstant("close");this.closeIcon.setAttribute("title",t),this.closeIcon.setAttribute("aria-label",t)},o.prototype.setCSSClass=function(t){this.cssClass&&e.addClass([this.element],this.cssClass.split(" ")),t&&e.removeClass([this.element],t.split(" "))},o.prototype.setIsModal=function(){this.dlgContainer=this.createElement("div",{className:"e-dlg-container"}),this.element.classList.remove("e-popup-open"),this.element.parentNode.insertBefore(this.dlgContainer,this.element),this.dlgContainer.appendChild(this.element),e.addClass([this.element],pe),this.dlgOverlay=this.createElement("div",{className:"e-dlg-overlay"}),this.dlgOverlay.style.zIndex=(this.zIndex-1).toString(),this.dlgContainer.appendChild(this.dlgOverlay)},o.prototype.getValidFocusNode=function(t){for(var e,i=0;i<t.length;i++){if(((e=t[i]).clientHeight>0||"a"===e.tagName.toLowerCase()&&e.hasAttribute("href"))&&e.tabIndex>-1&&!e.disabled&&!this.disableElement(e,'[disabled],[aria-disabled="true"],[type="hidden"]'))return e;e=null}return e},o.prototype.focusableElements=function(t){if(!e.isNullOrUndefined(t)){var i=t.querySelectorAll('input,select,textarea,button,a,[contenteditable="true"],[tabindex]');return this.getValidFocusNode(i)}return null},o.prototype.getAutoFocusNode=function(t){var i=t.querySelector("."+ge),o=t.querySelectorAll("[autofocus]"),n=this.getValidFocusNode(o);if(e.isBlazor()&&(this.primaryButtonEle=this.element.getElementsByClassName("e-primary")[0]),e.isNullOrUndefined(n)){if(n=this.focusableElements(this.contentEle),!e.isNullOrUndefined(n))return i=n;if(!e.isNullOrUndefined(this.primaryButtonEle))return this.element.querySelector(".e-primary")}else i=n;return i},o.prototype.disableElement=function(t,e){var i=t?t.matches||t.webkitMatchesSelector||t.msGetRegionContent:null;if(i)for(;t;t=t.parentNode)if(t instanceof Element&&i.call(t,e))return t;return null},o.prototype.focusContent=function(){var t=this.getAutoFocusNode(this.element),i=e.isNullOrUndefined(t)?this.element:t,o=e.Browser.userAgent;(o.indexOf("MSIE ")>0||o.indexOf("Trident/")>0)&&this.element.focus(),i.focus(),this.bindEvent(this.element)},o.prototype.bindEvent=function(t){e.EventHandler.add(t,"keydown",this.keyDown,this)},o.prototype.unBindEvent=function(t){e.EventHandler.remove(t,"keydown",this.keyDown)},o.prototype.updateSanitizeContent=function(){this.isBlazorServerRender()||(this.contentEle.innerHTML=this.sanitizeHelper(this.content))},o.prototype.isBlazorServerRender=function(){return e.isBlazor()&&this.isServerRendered},o.prototype.getModuleName=function(){return"dialog"},o.prototype.onPropertyChanged=function(t,i){if(this.element.classList.contains(ae))for(var o=0,n=Object.keys(t);o<n.length;o++){switch(n[o]){case"content":e.isNullOrUndefined(this.content)||""===this.content?e.isNullOrUndefined(this.contentEle)||(e.detach(this.contentEle),this.contentEle=null):(this.isBlazorServerRender()&&(this.contentEle=this.element.querySelector(".e-dlg-content")),e.isNullOrUndefined(this.contentEle)||"dialog"===this.contentEle.getAttribute("role")?this.isBlazorServerRender()&&!e.isNullOrUndefined(this.element.querySelector(".e-dlg-content"))||this.setContent():(this.isBlazorServerRender()||(this.contentEle.innerHTML=""),"function"==typeof this.content?(this.clearTemplate(["content"]),e.detach(this.contentEle),this.contentEle=null,this.setContent()):"string"==typeof this.content?this.isBlazorServerRender()&&""===this.contentEle.innerText?this.contentEle.insertAdjacentHTML("beforeend",this.sanitizeHelper(this.content)):this.updateSanitizeContent():this.contentEle.appendChild(this.content),this.setMaxHeight()));break;case"header":""===this.header||e.isNullOrUndefined(this.header)?this.headerEle&&(e.detach(this.headerEle),this.headerEle=null):this.isBlazorServerRender()&&!e.isNullOrUndefined(this.element.querySelector(".e-dlg-header-content"))||this.setHeader();break;case"footerTemplate":if(""===this.footerTemplate||e.isNullOrUndefined(this.footerTemplate)){if(!this.ftrTemplateContent)return;e.detach(this.ftrTemplateContent),this.ftrTemplateContent=null,this.buttons=[{}]}else this.isBlazorServerRender()&&!e.isNullOrUndefined(this.element.querySelector(".e-footer-content"))||this.setFooterTemplate(),this.buttons=[{}];break;case"showCloseIcon":this.element.getElementsByClassName(ce).length>0?this.showCloseIcon||""!==this.header&&!e.isNullOrUndefined(this.header)?this.showCloseIcon?this.isBlazorServerRender()&&this.wireEvents():e.detach(this.closeIcon):(e.detach(this.headerContent),this.headerContent=null):(this.isBlazorServerRender()||this.renderCloseIcon(),this.wireEvents());break;case"locale":this.showCloseIcon&&this.closeIconTitle();break;case"visible":this.visible?this.show():this.hide();break;case"isModal":this.updateIsModal();break;case"height":e.setStyleAttribute(this.element,{height:e.formatUnit(t.height)});break;case"width":e.setStyleAttribute(this.element,{width:e.formatUnit(t.width)});break;case"zIndex":this.popupObj.zIndex=this.zIndex,this.isModal&&this.setOverlayZindex(this.zIndex),this.element.style.zIndex!==this.zIndex.toString()&&(this.calculatezIndex=!1);break;case"cssClass":this.setCSSClass(i.cssClass);break;case"buttons":var s=this.buttons.length;e.isNullOrUndefined(this.ftrTemplateContent)||this.isBlazorServerRender()||(e.detach(this.ftrTemplateContent),this.ftrTemplateContent=null);for(var l=0;l<s;l++)e.isNullOrUndefined(this.buttons[l].buttonModel)||(this.footerTemplate="",this.setButton());break;case"allowDragging":this.allowDragging&&!e.isNullOrUndefined(this.headerContent)?this.setAllowDragging():this.dragObj.destroy();break;case"target":this.setTarget(t.target);break;case"position":if(this.checkPositionData(),this.isModal){var r=e.isNullOrUndefined(i.position.X)?this.position.X:i.position.X,a=e.isNullOrUndefined(i.position.Y)?this.position.Y:i.position.Y;this.dlgContainer.classList.contains("e-dlg-"+r+"-"+a)&&this.dlgContainer.classList.remove("e-dlg-"+r+"-"+a)}this.positionChange();break;case"enableRtl":this.setEnableRTL();break;case"enableResize":this.setResize()}}},o.prototype.setTarget=function(t){this.popupObj.relateTo=t,this.target=t,this.targetEle="string"==typeof this.target?document.querySelector(this.target):this.target,this.dragObj&&(this.dragObj.dragArea=this.targetEle),this.setMaxHeight(),this.isModal&&this.updateIsModal(),this.enableResize&&this.setResize()},o.prototype.updateIsModal=function(){if(this.element.setAttribute("aria-modal",this.isModal?"true":"false"),this.isModal)e.isNullOrUndefined(this.dlgOverlay)&&(this.setIsModal(),this.element.style.top="0px",this.element.style.left="0px",e.isNullOrUndefined(this.targetEle)||this.targetEle.appendChild(this.dlgContainer));else{for(e.removeClass([this.element],pe),e.removeClass([document.body],[ue,fe]),e.detach(this.dlgOverlay);this.dlgContainer.firstChild;)this.dlgContainer.parentElement.insertBefore(this.dlgContainer.firstChild,this.dlgContainer);this.dlgContainer.parentElement.removeChild(this.dlgContainer)}this.visible&&this.show(),this.positionChange(),this.isModal&&this.dlgOverlay&&e.EventHandler.add(this.dlgOverlay,"click",this.dlgOverlayClickEventHandler,this)},o.prototype.setzIndex=function(t,e){var i=this.isProtectedOnChange;this.isProtectedOnChange=!0,this.zIndex=L(t),this.isProtectedOnChange=i,e&&(this.popupObj.zIndex=this.zIndex)},o.prototype.windowResizeHandler=function(){!function(t){St=t}(this.targetEle.clientWidth),function(t){Nt=t}(this.targetEle.clientHeight),this.setMaxHeight()},o.prototype.getPersistData=function(){return this.addOnPersist([])},o.prototype.destroy=function(){if(!this.isDestroyed){var i=["e-rtl",pe,Ce,Oe,me,"e-device"],o=["role","aria-modal","aria-labelledby","aria-describedby","aria-grabbed","tabindex","style"];if(e.removeClass([this.targetEle],[ue,fe]),!e.isNullOrUndefined(this.element)&&this.element.classList.contains(me)&&e.removeClass([document.body],[ue,fe]),this.isModal&&e.removeClass([e.isNullOrUndefined(this.targetEle)?document.body:this.targetEle],fe),this.unWireEvents(),!e.isNullOrUndefined(this.btnObj))for(var n=0;n<this.btnObj.length;n++)this.btnObj[n].destroy();if(e.isNullOrUndefined(this.dragObj)||this.dragObj.destroy(),!e.isNullOrUndefined(this.popupObj.element)&&this.popupObj.element.classList.contains("e-popup")&&this.popupObj.destroy(),e.removeClass([this.element],i),e.isNullOrUndefined(this.cssClass)||""===this.cssClass||e.removeClass([this.element],this.cssClass.split(" ")),e.isNullOrUndefined(this.refElement)||e.isNullOrUndefined(this.refElement.parentElement)||(this.refElement.parentElement.insertBefore(this.isModal?this.dlgContainer:this.element,this.refElement),e.detach(this.refElement),this.refElement=void 0),this.isModal&&!this.isBlazorServerRender()&&(e.detach(this.dlgOverlay),this.dlgContainer.parentNode.insertBefore(this.element,this.dlgContainer),e.detach(this.dlgContainer)),this.isBlazorServerRender()||(this.element.innerHTML=this.clonedEle.innerHTML),this.isBlazorServerRender()&&!e.isNullOrUndefined(this.element.children))for(n=0;n<=this.element.children.length;n++)n-=n,e.detach(this.element.children[n]);for(n=0;n<o.length;n++)this.element.removeAttribute(o[n]);this.isBlazorServerRender()?this.isDestroyed=!0:t.prototype.destroy.call(this),this.isReact&&this.clearTemplate()}},o.prototype.wireWindowResizeEvent=function(){window.addEventListener("resize",this.windowResizeHandler.bind(this))},o.prototype.unWireWindowResizeEvent=function(){window.removeEventListener("resize",this.windowResizeHandler.bind(this))},o.prototype.wireEvents=function(){this.isBlazorServerRender()&&this.showCloseIcon&&(this.closeIcon=this.element.getElementsByClassName("e-dlg-closeicon-btn")[0]),this.showCloseIcon&&e.EventHandler.add(this.closeIcon,"click",this.closeIconClickEventHandler,this),this.isModal&&this.dlgOverlay&&e.EventHandler.add(this.dlgOverlay,"click",this.dlgOverlayClickEventHandler,this)},o.prototype.unWireEvents=function(){if(this.showCloseIcon&&e.EventHandler.remove(this.closeIcon,"click",this.closeIconClickEventHandler),this.isModal&&e.EventHandler.remove(this.dlgOverlay,"click",this.dlgOverlayClickEventHandler),this.buttons.length>0&&!e.isNullOrUndefined(this.buttons[0].buttonModel)&&""===this.footerTemplate)for(var t=0;t<this.buttons.length;t++)"function"==typeof this.buttons[t].click&&e.EventHandler.remove(this.ftrTemplateContent.children[t],"click",this.buttons[t].click)},o.prototype.refreshPosition=function(){this.popupObj.refreshPosition()},o.prototype.getDimension=function(){return{width:this.element.offsetWidth,height:this.element.offsetHeight}},o.prototype.show=function(t){var i=this;if(this.element.classList.contains(ae)){if(!this.element.classList.contains("e-popup-open")||!e.isNullOrUndefined(t)){e.isNullOrUndefined(t)||this.fullScreen(t);var o=e.isBlazor()?{cancel:!1,element:this.element,container:this.isModal?this.dlgContainer:this.element,maxHeight:this.element.style.maxHeight}:{cancel:!1,element:this.element,container:this.isModal?this.dlgContainer:this.element,target:this.target,maxHeight:this.element.style.maxHeight};this.trigger("beforeOpen",o,function(t){if(!t.cancel){i.element.style.maxHeight!==o.maxHeight&&(i.allowMaxHeight=!1,i.element.style.maxHeight=o.maxHeight),i.storeActiveElement=document.activeElement,i.element.tabIndex=-1,i.isModal&&!e.isNullOrUndefined(i.dlgOverlay)&&(i.dlgOverlay.style.display="block",i.dlgContainer.style.display="flex",e.removeClass([i.dlgOverlay],"e-fade"),e.isNullOrUndefined(i.targetEle)?e.addClass([document.body],[ue,fe]):(i.targetEle===document.body?i.dlgContainer.style.position="fixed":i.dlgContainer.style.position="absolute",i.dlgOverlay.style.position="absolute",i.element.style.position="relative",e.addClass([i.targetEle],[ue,fe])));var n={name:i.animationSettings.effect+"In",duration:i.animationSettings.duration,delay:i.animationSettings.delay},s=i.isModal?i.element.parentElement:i.element;i.calculatezIndex&&(i.setzIndex(s,!0),e.setStyleAttribute(i.element,{zIndex:i.zIndex}),i.isModal&&i.setOverlayZindex(i.zIndex)),"None"===i.animationSettings.effect?i.popupObj.show():i.popupObj.show(n),i.dialogOpen=!0;var l=i.isProtectedOnChange;i.isProtectedOnChange=!0,i.visible=!0,i.preventVisibility=!0,i.isProtectedOnChange=l}})}this.isReact&&this.renderReactTemplates()}},o.prototype.hide=function(t){var i=this;if(this.element.classList.contains(ae)&&this.preventVisibility){var o=e.isBlazor()?{cancel:!1,isInteracted:!!t,element:this.element,container:this.isModal?this.dlgContainer:this.element,event:t}:{cancel:!1,isInteracted:!!t,element:this.element,target:this.target,container:this.isModal?this.dlgContainer:this.element,event:t,closedBy:this.dlgClosedBy};this.closeArgs=o,this.trigger("beforeClose",o,function(t){if(!t.cancel){i.isModal&&(e.isNullOrUndefined(i.targetEle)||e.removeClass([i.targetEle],[ue,fe])),document.body.classList.contains(ue)&&document.body.classList.contains(fe)&&e.removeClass([document.body],[ue,fe]);var o={name:i.animationSettings.effect+"Out",duration:i.animationSettings.duration,delay:i.animationSettings.delay};"None"===i.animationSettings.effect?i.popupObj.hide():i.popupObj.hide(o),i.dialogOpen=!1;var n=i.isProtectedOnChange;i.isProtectedOnChange=!0,i.visible=!1,i.preventVisibility=!1,i.isProtectedOnChange=n}i.dlgClosedBy=Ne})}},o.prototype.fullScreen=function(t){this.element.offsetTop,this.element.offsetLeft;if(t){e.addClass([this.element],me);var i=this.element.style.display;this.element.style.display="none",this.element.style.maxHeight=e.isNullOrUndefined(this.target)?window.innerHeight+"px":this.targetEle.offsetHeight+"px",this.element.style.display=i,e.addClass([document.body],[ue,fe]),this.allowDragging&&!e.isNullOrUndefined(this.dragObj)&&this.dragObj.destroy()}else e.removeClass([this.element],me),e.removeClass([document.body],[ue,fe]),this.allowDragging&&!e.isNullOrUndefined(this.headerContent)&&this.setAllowDragging();return t},o.prototype.getButtons=function(t){return e.isNullOrUndefined(t)?this.btnObj:this.btnObj[t]},se([e.Property("")],o.prototype,"content",void 0),se([e.Property(!0)],o.prototype,"enableHtmlSanitizer",void 0),se([e.Property(!1)],o.prototype,"showCloseIcon",void 0),se([e.Property(!1)],o.prototype,"isModal",void 0),se([e.Property("")],o.prototype,"header",void 0),se([e.Property(!0)],o.prototype,"visible",void 0),se([e.Property(!1)],o.prototype,"enableResize",void 0),se([e.Property(["South-East"])],o.prototype,"resizeHandles",void 0),se([e.Property("auto")],o.prototype,"height",void 0),se([e.Property("")],o.prototype,"minHeight",void 0),se([e.Property("100%")],o.prototype,"width",void 0),se([e.Property("")],o.prototype,"cssClass",void 0),se([e.Property(1e3)],o.prototype,"zIndex",void 0),se([e.Property(null)],o.prototype,"target",void 0),se([e.Property("")],o.prototype,"footerTemplate",void 0),se([e.Property(!1)],o.prototype,"allowDragging",void 0),se([e.Collection([{}],le)],o.prototype,"buttons",void 0),se([e.Property(!0)],o.prototype,"closeOnEscape",void 0),se([e.Complex({},re)],o.prototype,"animationSettings",void 0),se([e.Complex({X:"center",Y:"center"},Rt)],o.prototype,"position",void 0),se([e.Event()],o.prototype,"created",void 0),se([e.Event()],o.prototype,"open",void 0),se([e.Event()],o.prototype,"beforeSanitizeHtml",void 0),se([e.Event()],o.prototype,"beforeOpen",void 0),se([e.Event()],o.prototype,"close",void 0),se([e.Event()],o.prototype,"beforeClose",void 0),se([e.Event()],o.prototype,"dragStart",void 0),se([e.Event()],o.prototype,"dragStop",void 0),se([e.Event()],o.prototype,"drag",void 0),se([e.Event()],o.prototype,"overlayClick",void 0),se([e.Event()],o.prototype,"resizeStart",void 0),se([e.Event()],o.prototype,"resizing",void 0),se([e.Event()],o.prototype,"resizeStop",void 0),se([e.Event()],o.prototype,"destroyed",void 0),o=se([e.NotifyPropertyChanges],o)}(e.Component);!function(t){function i(t,e){var i=new Te(t);return i.appendTo(e),i}function o(t,i){return t.header=e.isNullOrUndefined(i.title)?ye:i.title,t.content=e.isNullOrUndefined(i.content)?"":i.content,t.isModal=!!e.isNullOrUndefined(i.isModal)||i.isModal,t.showCloseIcon=!e.isNullOrUndefined(i.showCloseIcon)&&i.showCloseIcon,t.allowDragging=!e.isNullOrUndefined(i.isDraggable)&&i.isDraggable,t.closeOnEscape=!e.isNullOrUndefined(i.closeOnEscape)&&i.closeOnEscape,t.position=e.isNullOrUndefined(i.position)?{X:"center",Y:"top"}:i.position,t.animationSettings=e.isNullOrUndefined(i.animationSettings)?{effect:"Fade",duration:400,delay:0}:i.animationSettings,t.cssClass=e.isNullOrUndefined(i.cssClass)?"":i.cssClass,t.zIndex=e.isNullOrUndefined(i.zIndex)?1e3:i.zIndex,t.open=e.isNullOrUndefined(i.open)?null:i.open,t}function n(t,i,o){var n=o;return e.isNullOrUndefined(i.text)||(n.buttonModel.content=i.text),e.isNullOrUndefined(i.icon)||(n.buttonModel.iconCss=i.icon),e.isNullOrUndefined(i.cssClass)||(n.buttonModel.cssClass=i.cssClass),e.isNullOrUndefined(i.click)||(n.click=i.click),n}t.alert=function(t){var s=e.createElement("div",{className:be});document.body.appendChild(s);var l;return l=i("string"==typeof t?{content:t,position:{X:"center",Y:"top"},isModal:!0,header:ye,buttons:[{buttonModel:{isPrimary:!0,content:"OK"},click:function(){this.hide()}}]}:function(t){var i={};return i.buttons=[],i=o(i,t),i=function(t,i){var o=[{buttonModel:{isPrimary:!0,content:"OK"},click:function(){this.hide()}}];return e.isNullOrUndefined(i.okButton)?t.buttons=o:t.buttons[0]=n(t.buttons[0],i.okButton,o[0]),t}(i,t)}(t),s),l.close=function(){t&&t.close&&t.close.apply(l),l.destroy(),l.element.classList.contains("e-dlg-modal")?(l.element.parentElement.remove(),l.target.classList.remove(ve)):l.element.remove()},l},t.confirm=function(t){var s=e.createElement("div",{className:Ee});document.body.appendChild(s);var l;return l=i("string"==typeof t?{position:{X:"center",Y:"top"},content:t,isModal:!0,header:ye,buttons:[{buttonModel:{isPrimary:!0,content:"OK"},click:function(){this.hide()}},{buttonModel:{content:"Cancel"},click:function(){this.hide()}}]}:function(t){var i={};return i.buttons=[],i=o(i,t),i=function(t,i){var o={buttonModel:{isPrimary:!0,content:"OK"},click:function(){this.hide()}},s={buttonModel:{content:"Cancel"},click:function(){this.hide()}};return e.isNullOrUndefined(i.okButton)?t.buttons[0]=o:t.buttons[0]=n(t.buttons[0],i.okButton,o),e.isNullOrUndefined(i.cancelButton)?t.buttons[1]=s:t.buttons[1]=n(t.buttons[1],i.cancelButton,s),t}(i,t)}(t),s),l.close=function(){t&&t.close&&t.close.apply(l),l.destroy(),l.element.classList.contains("e-dlg-modal")?(l.element.parentElement.remove(),l.target.classList.remove(ve)):l.element.remove()},l}}(t.DialogUtility||(t.DialogUtility={}));var Se=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function o(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(o.prototype=i.prototype,new o)}}(),Pe=function(t,e,i,o){var n,s=arguments.length,l=s<3?e:null===o?o=Object.getOwnPropertyDescriptor(e,i):o;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)l=Reflect.decorate(t,e,i,o);else for(var r=t.length-1;r>=0;r--)(n=t[r])&&(l=(s<3?n(l):s>3?n(e,i,l):n(e,i))||l);return s>3&&l&&Object.defineProperty(e,i,l),l},xe="e-tooltip",He="e-tooltip-wrap",Be="e-tip-content",Ue="e-arrow-tip",ke="e-arrow-tip-outer",Re="e-arrow-tip-inner",ze="e-tip-bottom",Me="e-tip-top",Le="e-tip-right",Ie="e-popup-open",Ae="e-popup-close",Ye="e-tooltip-popup-container",Xe=function(t){function i(){return null!==t&&t.apply(this,arguments)||this}return Se(i,t),Pe([e.Property({effect:"FadeIn",duration:150,delay:0})],i.prototype,"open",void 0),Pe([e.Property({effect:"FadeOut",duration:150,delay:0})],i.prototype,"close",void 0),i}(e.ChildProperty),De=function(t){function i(e,i){var o=t.call(this,e,i)||this;return o.mouseMoveEvent=null,o.mouseMoveTarget=null,o.containerElement=null,o.isBodyContainer=!0,o}return Se(i,t),i.prototype.initialize=function(){this.formatPosition(),e.addClass([this.element],xe)},i.prototype.formatPosition=function(){var t,e;0===this.position.indexOf("Top")||0===this.position.indexOf("Bottom")?(t=this.position.split(/(?=[A-Z])/),this.tooltipPositionY=t[0],this.tooltipPositionX=t[1]):(e=this.position.split(/(?=[A-Z])/),this.tooltipPositionX=e[0],this.tooltipPositionY=e[1])},i.prototype.renderArrow=function(){this.setTipClass(this.position);var t=this.createElement("div",{className:Ue+" "+this.tipClass});t.appendChild(this.createElement("div",{className:ke+" "+this.tipClass})),t.appendChild(this.createElement("div",{className:Re+" "+this.tipClass})),this.tooltipEle.appendChild(t)},i.prototype.setTipClass=function(t){0===t.indexOf("Right")?this.tipClass="e-tip-left":0===t.indexOf("Bottom")?this.tipClass=Me:0===t.indexOf("Left")?this.tipClass=Le:this.tipClass=ze},i.prototype.renderPopup=function(t){var e=this.mouseTrail?{top:0,left:0}:this.getTooltipPosition(t);this.tooltipEle.classList.remove("e-lib"),this.popupObj=new At(this.tooltipEle,{height:this.height,width:this.width,position:{X:e.left,Y:e.top},enableRtl:this.enableRtl,open:this.openPopupHandler.bind(this),close:this.closePopupHandler.bind(this)})},i.prototype.getTooltipPosition=function(t){this.tooltipEle.style.display="block";var e=n(t,this.tooltipPositionX,this.tooltipPositionY,!this.isBodyContainer,this.isBodyContainer?null:this.containerElement.getBoundingClientRect()),i=this.calculateTooltipOffset(this.position),o=this.calculateElementPosition(e,i),s=o[0],l=o[1],r=this.collisionFlipFit(t,s,l);return this.tooltipEle.style.display="",r},i.prototype.windowResize=function(){this.reposition(this.findTarget())},i.prototype.reposition=function(t){if(this.popupObj&&t){var e=this.getTooltipPosition(t);this.popupObj.position={X:e.left,Y:e.top},this.popupObj.dataBind()}},i.prototype.openPopupHandler=function(){!this.mouseTrail&&this.needTemplateReposition()&&this.reposition(this.findTarget()),this.trigger("afterOpen",this.tooltipEventArgs)},i.prototype.closePopupHandler=function(){this.clearTemplate(["content"]),this.clear(),this.trigger("afterClose",this.tooltipEventArgs)},i.prototype.calculateTooltipOffset=function(t){var i={top:0,left:0},o=this.tooltipEle.offsetWidth,n=this.tooltipEle.offsetHeight,s=e.select("."+Ue,this.tooltipEle),l=s?s.offsetWidth:0,r=s?s.offsetHeight:0,a=this.showTipPointer?0:8,h=r/2+2+(this.tooltipEle.offsetHeight-this.tooltipEle.clientHeight),d=l/2+2+(this.tooltipEle.offsetWidth-this.tooltipEle.clientWidth);switch(this.mouseTrail&&(a+=2),t){case"RightTop":i.left+=l+a,i.top-=n-h;break;case"RightCenter":i.left+=l+a,i.top-=n/2;break;case"RightBottom":i.left+=l+a,i.top-=h;break;case"BottomRight":i.top+=r+a,i.left-=d;break;case"BottomCenter":i.top+=r+a,i.left-=o/2;break;case"BottomLeft":i.top+=r+a,i.left-=o-d;break;case"LeftBottom":i.left-=l+o+a,i.top-=h;break;case"LeftCenter":i.left-=l+o+a,i.top-=n/2;break;case"LeftTop":i.left-=l+o+a,i.top-=n-h;break;case"TopLeft":i.top-=n+r+a,i.left-=o-d;break;case"TopRight":i.top-=n+r+a,i.left-=d;break;default:i.top-=n+r+a,i.left-=o/2}return i.left+=this.offsetX,i.top+=this.offsetY,i},i.prototype.updateTipPosition=function(t){var i=e.selectAll("."+Ue+",."+ke+",."+Re,this.tooltipEle),o=[ze,Me,"e-tip-left",Le];e.removeClass(i,o),this.setTipClass(t),e.addClass(i,this.tipClass)},i.prototype.adjustArrow=function(t,i,o,n){if(!1!==this.showTipPointer){this.updateTipPosition(i);var s,l;this.tooltipEle.style.display="block";var r=this.tooltipEle.clientWidth,a=this.tooltipEle.clientHeight,h=e.select("."+Ue,this.tooltipEle),d=e.select("."+Re,this.tooltipEle),p=h.offsetWidth,c=h.offsetHeight;if(this.tooltipEle.style.display="",this.tipClass===ze||this.tipClass===Me){if(this.tipClass===ze?(l="99.9%",d.style.top="-"+(c-2)+"px"):(l=-(c-1)+"px",d.style.top="-"+(c-6)+"px"),t){s=(u="Center"!==o||r>t.offsetWidth||this.mouseTrail)&&"Left"===o||!u&&"End"===this.tipPointerPosition?r-p-2+"px":u&&"Right"===o||!u&&"Start"===this.tipPointerPosition?"2px":r/2-p/2+"px"}}else{this.tipClass===Le?(s="99.9%",d.style.left="-"+(p-2)+"px"):(s=-(p-1)+"px",d.style.left=p-2-p+"px");var u;l=(u="Center"!==n||a>t.offsetHeight||this.mouseTrail)&&"Top"===n||!u&&"End"===this.tipPointerPosition?a-c-2+"px":u&&"Bottom"===n||!u&&"Start"===this.tipPointerPosition?"2px":a/2-c/2+"px"}h.style.top=l,h.style.left=s}},i.prototype.renderContent=function(t){var i=e.select("."+Be,this.tooltipEle);if(this.cssClass&&e.addClass([this.tooltipEle],this.cssClass.split(" ")),t&&!e.isNullOrUndefined(t.getAttribute("title"))&&(t.setAttribute("data-content",t.getAttribute("title")),t.removeAttribute("title")),e.isNullOrUndefined(this.content))t&&!e.isNullOrUndefined(t.getAttribute("data-content"))&&(i.innerHTML=t.getAttribute("data-content"));else if(i.innerHTML="",this.content instanceof HTMLElement)i.appendChild(this.content);else if("string"==typeof this.content)this.enableHtmlSanitizer&&this.setProperties({content:e.SanitizeHtmlHelper.sanitize(this.content)},!0),i[this.enableHtmlParse?"innerHTML":"textContent"]=this.content;else{var o=e.compile(this.content)({},this,"content",this.element.id+"content",void 0,void 0,i);o&&e.append(o,i),this.renderReactTemplates()}},i.prototype.renderCloseIcon=function(){if(this.isSticky){var t=this.createElement("div",{className:"e-icons e-tooltip-close"});this.tooltipEle.appendChild(t),e.EventHandler.add(t,e.Browser.touchStartEvent,this.onStickyClose,this)}},i.prototype.addDescribedBy=function(t,i){var o=(t.getAttribute("aria-describedby")||"").split(/\s+/);o.indexOf(i)<0&&o.push(i),e.attributes(t,{"aria-describedby":o.join(" ").trim(),"data-tooltip-id":i})},i.prototype.removeDescribedBy=function(t){var e=t.getAttribute("data-tooltip-id"),i=(t.getAttribute("aria-describedby")||"").split(/\s+/),o=i.indexOf(e);-1!==o&&i.splice(o,1),t.removeAttribute("data-tooltip-id");var n=i.join(" ").trim();n?t.setAttribute("aria-describedby",n):t.removeAttribute("aria-describedby")},i.prototype.tapHoldHandler=function(t){clearTimeout(this.autoCloseTimer),this.targetHover(t.originalEvent)},i.prototype.touchEndHandler=function(t){var e=this;if(!this.isSticky){this.autoCloseTimer=setTimeout(function(){e.close()},1500)}},i.prototype.targetClick=function(t){var i;i=this.target?e.closest(t.target,this.target):this.element,e.isNullOrUndefined(i)||(null===i.getAttribute("data-tooltip-id")?this.targetHover(t):this.isSticky||this.hideTooltip(this.animation.close,t,i))},i.prototype.targetHover=function(t){var i;if(i=this.target?e.closest(t.target,this.target):this.element,!(e.isNullOrUndefined(i)||null!==i.getAttribute("data-tooltip-id")&&0===this.closeDelay)){for(var o=0,n=[].slice.call(e.selectAll('[data-tooltip-id= "'+this.ctrlId+'_content"]',document));o<n.length;o++){var s=n[o];this.restoreElement(s)}this.showTooltip(i,this.animation.open,t)}},i.prototype.mouseMoveBeforeOpen=function(t){this.mouseMoveEvent=t},i.prototype.mouseMoveBeforeRemove=function(){this.mouseMoveTarget&&e.EventHandler.remove(this.mouseMoveTarget,"mousemove touchstart",this.mouseMoveBeforeOpen)},i.prototype.showTooltip=function(t,i,o){var n=this;clearTimeout(this.showTimer),clearTimeout(this.hideTimer),this.openDelay&&this.mouseTrail&&(this.mouseMoveBeforeRemove(),this.mouseMoveTarget=t,e.EventHandler.add(this.mouseMoveTarget,"mousemove touchstart",this.mouseMoveBeforeOpen,this)),this.tooltipEventArgs={type:o?o.type:null,cancel:!1,target:t,event:o||null,element:this.tooltipEle,isInteracted:!e.isNullOrUndefined(o)};this.trigger("beforeRender",this.tooltipEventArgs,function(e){n.beforeRenderCallback(e,t,o,i)}.bind(this))},i.prototype.beforeRenderCallback=function(t,i,o,n){t.cancel?(this.isHidden=!0,this.clear(),this.mouseMoveBeforeRemove()):(this.isHidden=!1,e.isNullOrUndefined(this.tooltipEle)?(this.ctrlId=this.element.getAttribute("id")?e.getUniqueID(this.element.getAttribute("id")):e.getUniqueID("tooltip"),this.tooltipEle=this.createElement("div",{className:He+" e-popup e-lib",attrs:{role:"tooltip","aria-hidden":"false",id:this.ctrlId+"_content"},styles:"width:"+e.formatUnit(this.width)+";height:"+e.formatUnit(this.height)+";position:absolute;"}),this.tooltipBeforeRender(i,this),this.tooltipAfterRender(i,o,n,this)):i&&(this.adjustArrow(i,this.position,this.tooltipPositionX,this.tooltipPositionY),this.addDescribedBy(i,this.ctrlId+"_content"),this.renderContent(i),e.Animation.stop(this.tooltipEle),this.reposition(i),this.tooltipAfterRender(i,o,n,this)))},i.prototype.appendContainer=function(t){"string"==typeof this.container?"body"===this.container?this.containerElement=document.body:(this.isBodyContainer=!1,this.containerElement=e.select(this.container,document)):this.container instanceof HTMLElement&&(this.containerElement=this.container,this.isBodyContainer="BODY"===this.containerElement.tagName),this.isBodyContainer||e.addClass([this.containerElement],Ye),this.containerElement.appendChild(t.tooltipEle)},i.prototype.tooltipBeforeRender=function(t,i){t&&(e.Browser.isDevice&&e.addClass([i.tooltipEle],"e-bigger"),"auto"!==i.width&&(i.tooltipEle.style.maxWidth=e.formatUnit(i.width)),i.tooltipEle.appendChild(i.createElement("div",{className:Be})),this.appendContainer(i),e.removeClass([i.tooltipEle],"e-hidden"),i.addDescribedBy(t,i.ctrlId+"_content"),i.renderContent(t),e.addClass([i.tooltipEle],Ie),i.showTipPointer&&i.renderArrow(),i.renderCloseIcon(),i.renderPopup(t),i.adjustArrow(t,i.position,i.tooltipPositionX,i.tooltipPositionY),e.Animation.stop(i.tooltipEle),i.reposition(t))},i.prototype.tooltipAfterRender=function(t,i,o,n){if(t){e.removeClass([n.tooltipEle],Ie),e.addClass([n.tooltipEle],Ae),n.tooltipEventArgs={type:i?i.type:null,cancel:!1,target:t,event:i||null,element:n.tooltipEle,isInteracted:!e.isNullOrUndefined(i)},n.needTemplateReposition()&&!n.mouseTrail&&(n.tooltipEle.style.display="none");n.trigger("beforeOpen",n.tooltipEventArgs,function(e){n.beforeOpenCallback(e,t,o,i)}.bind(n))}},i.prototype.beforeOpenCallback=function(t,i,o,n){var s=this;if(t.cancel)this.isHidden=!0,this.clear(),this.mouseMoveBeforeRemove(),this.restoreElement(i);else{var l={name:o.effect,duration:o.duration,delay:o.delay,timingFunction:"easeOut"};if("None"===o.effect&&(l=void 0),this.openDelay>0){this.showTimer=setTimeout(function(){s.mouseTrail&&e.EventHandler.add(i,"mousemove touchstart mouseenter",s.onMouseMove,s),s.popupObj&&(s.popupObj.show(l,i),s.mouseMoveEvent&&s.mouseTrail&&s.onMouseMove(s.mouseMoveEvent))},this.openDelay)}else this.popupObj&&this.popupObj.show(l,i)}n&&this.wireMouseEvents(n,i)},i.prototype.needTemplateReposition=function(){return!e.isNullOrUndefined(this.viewContainerRef)&&"string"!=typeof this.viewContainerRef},i.prototype.checkCollision=function(t,e,i){var o={left:e,top:i,position:this.position,horizontal:this.tooltipPositionX,vertical:this.tooltipPositionY},n=g(this.tooltipEle,this.checkCollideTarget(),e,i);return n.length>0&&(o.horizontal=n.indexOf("left")>=0?"Right":n.indexOf("right")>=0?"Left":this.tooltipPositionX,o.vertical=n.indexOf("top")>=0?"Bottom":n.indexOf("bottom")>=0?"Top":this.tooltipPositionY),o},i.prototype.calculateElementPosition=function(t,e){return[this.isBodyContainer?t.left+e.left:t.left-this.containerElement.offsetLeft+e.left+window.pageXOffset+this.containerElement.scrollLeft,this.isBodyContainer?t.top+e.top:t.top-this.containerElement.offsetTop+e.top+window.pageYOffset+this.containerElement.scrollTop]},i.prototype.collisionFlipFit=function(t,i,o){var s=this.checkCollision(t,i,o),l=s.position;this.tooltipPositionY!==s.vertical&&(l=0===this.position.indexOf("Bottom")||0===this.position.indexOf("Top")?s.vertical+this.tooltipPositionX:this.tooltipPositionX+s.vertical),this.tooltipPositionX!==s.horizontal&&(0===l.indexOf("Left")&&(s.vertical="LeftTop"===l||"LeftCenter"===l?"Top":"Bottom",l=s.vertical+"Left"),0===l.indexOf("Right")&&(s.vertical="RightTop"===l||"RightCenter"===l?"Top":"Bottom",l=s.vertical+"Right"),s.horizontal=this.tooltipPositionX),this.tooltipEventArgs={type:null,cancel:!1,target:t,event:null,element:this.tooltipEle,collidedPosition:l},this.trigger("beforeCollision",this.tooltipEventArgs);var r=s.vertical,a=s.horizontal;if(s.position!==l){var h=n(t,a,r,!this.isBodyContainer,this.isBodyContainer?null:this.containerElement.getBoundingClientRect());this.adjustArrow(t,l,a,r);var d=this.calculateTooltipOffset(l);d.top-=this.getOffSetPosition("TopBottom",l,this.offsetY),d.left-=this.getOffSetPosition("RightLeft",l,this.offsetX),s.position=l;var p=this.calculateElementPosition(h,d);s.left=p[0],s.top=p[1]}else this.adjustArrow(t,l,a,r);var c={left:s.left,top:s.top},u=this.isBodyContainer?m(this.tooltipEle,this.checkCollideTarget(),{X:!0,Y:!1},c).left:c.left;if(this.tooltipEle.style.display="block",this.showTipPointer&&(0===l.indexOf("Bottom")||0===l.indexOf("Top"))){var f=e.select("."+Ue,this.tooltipEle),g=parseInt(f.style.left,10)-(u-s.left);g<0?g=0:g+f.offsetWidth>this.tooltipEle.clientWidth&&(g=this.tooltipEle.clientWidth-f.offsetWidth),f.style.left=g.toString()+"px"}return this.tooltipEle.style.display="",c.left=u,c},i.prototype.getOffSetPosition=function(t,e,i){return-1!==t.indexOf(this.position.split(/(?=[A-Z])/)[0])&&-1!==t.indexOf(e.split(/(?=[A-Z])/)[0])?2*i:0},i.prototype.checkCollideTarget=function(){return!this.windowCollision&&this.target?this.element:null},i.prototype.hideTooltip=function(t,e,i){var o=this;if(this.closeDelay>0){clearTimeout(this.hideTimer),clearTimeout(this.showTimer);this.hideTimer=setTimeout(function(){o.closeDelay&&o.tooltipEle&&o.isTooltipOpen||o.tooltipHide(t,e,i)},this.closeDelay)}else this.tooltipHide(t,e,i)},i.prototype.tooltipHide=function(t,i,o){var n,s=this;n=i?this.target?o||i.target:this.element:e.select('[data-tooltip-id= "'+this.ctrlId+'_content"]',document),this.tooltipEventArgs={type:i?i.type:null,cancel:!1,target:n,event:i||null,element:this.tooltipEle,isInteracted:!e.isNullOrUndefined(i)},this.trigger("beforeClose",this.tooltipEventArgs,function(e){e.cancel?s.isHidden=!1:(s.mouseMoveBeforeRemove(),s.popupHide(t,n))})},i.prototype.popupHide=function(t,e){e&&this.restoreElement(e),this.isHidden=!0;var i={name:t.effect,duration:t.duration,delay:t.delay,timingFunction:"easeIn"};"None"===t.effect&&(i=void 0),this.popupObj&&this.popupObj.hide(i)},i.prototype.restoreElement=function(t){this.unwireMouseEvents(t),e.isNullOrUndefined(t.getAttribute("data-content"))||(t.setAttribute("title",t.getAttribute("data-content")),t.removeAttribute("data-content")),this.removeDescribedBy(t)},i.prototype.clear=function(){this.tooltipEle&&(e.removeClass([this.tooltipEle],Ae),e.addClass([this.tooltipEle],Ie)),this.isHidden&&(this.popupObj&&this.popupObj.destroy(),this.tooltipEle&&e.remove(this.tooltipEle),this.tooltipEle=null,this.popupObj=null)},i.prototype.tooltipHover=function(t){this.tooltipEle&&(this.isTooltipOpen=!0)},i.prototype.tooltipMouseOut=function(t){this.isTooltipOpen=!1,this.hideTooltip(this.animation.close,t,this.findTarget())},i.prototype.onMouseOut=function(t){var i=t.relatedTarget;if(i&&!this.mouseTrail){var o=e.closest(i,"."+He+".e-lib.e-popup");o?e.EventHandler.add(o,"mouseleave",this.tooltipElementMouseOut,this):(this.hideTooltip(this.animation.close,t,this.findTarget()),0===this.closeDelay&&this.clear())}else this.hideTooltip(this.animation.close,t,this.findTarget()),this.clear()},i.prototype.tooltipElementMouseOut=function(t){this.hideTooltip(this.animation.close,t,this.findTarget()),e.EventHandler.remove(this.element,"mouseleave",this.tooltipElementMouseOut),this.clear()},i.prototype.onStickyClose=function(t){this.close()},i.prototype.onMouseMove=function(t){var i=0,o=0;t.type.indexOf("touch")>-1?(t.preventDefault(),i=t.touches[0].pageX,o=t.touches[0].pageY):(i=t.pageX,o=t.pageY),e.Animation.stop(this.tooltipEle),e.removeClass([this.tooltipEle],Ae),e.addClass([this.tooltipEle],Ie),this.adjustArrow(t.target,this.position,this.tooltipPositionX,this.tooltipPositionY);var n=this.calculateTooltipOffset(this.position),s=i+n.left+this.offsetX,l=o+n.top+this.offsetY,r=this.checkCollision(t.target,s,l);if(this.tooltipPositionX!==r.horizontal||this.tooltipPositionY!==r.vertical){var a=0===this.position.indexOf("Bottom")||0===this.position.indexOf("Top")?r.vertical+r.horizontal:r.horizontal+r.vertical;r.position=a,this.adjustArrow(t.target,r.position,r.horizontal,r.vertical);var h=this.calculateTooltipOffset(r.position);r.left=i+h.left-this.offsetX,r.top=o+h.top-this.offsetY}this.tooltipEle.style.left=r.left+"px",this.tooltipEle.style.top=r.top+"px"},i.prototype.keyDown=function(t){this.tooltipEle&&27===t.keyCode&&this.close()},i.prototype.touchEnd=function(t){this.tooltipEle&&null===e.closest(t.target,"."+xe)&&!this.isSticky&&this.close()},i.prototype.scrollHandler=function(t){this.tooltipEle&&(e.closest(t.target,"."+He+".e-lib.e-popup")||this.close())},i.prototype.render=function(){this.initialize(),this.wireEvents(this.opensOn),this.renderComplete()},i.prototype.preRender=function(){this.tipClass=ze,this.tooltipPositionX="Center",this.tooltipPositionY="Top",this.isHidden=!0},i.prototype.wireEvents=function(t){for(var i=0,o=this.getTriggerList(t);i<o.length;i++){var n=o[i];if("Custom"===n)return;"Focus"===n&&this.wireFocusEvents(),"Click"===n&&e.EventHandler.add(this.element,e.Browser.touchStartEvent,this.targetClick,this),"Hover"===n&&(e.Browser.isDevice?(this.touchModule=new e.Touch(this.element,{tapHoldThreshold:500,tapHold:this.tapHoldHandler.bind(this)}),e.EventHandler.add(this.element,e.Browser.touchEndEvent,this.touchEndHandler,this)):e.EventHandler.add(this.element,"mouseover",this.targetHover,this))}e.EventHandler.add(document,"touchend",this.touchEnd,this),e.EventHandler.add(document,"scroll wheel",this.scrollHandler,this),e.EventHandler.add(window,"resize",this.windowResize,this),e.EventHandler.add(document,"keydown",this.keyDown,this)},i.prototype.getTriggerList=function(t){return"Auto"===t&&(t=e.Browser.isDevice?"Hover":"Hover Focus"),t.split(" ")},i.prototype.wireFocusEvents=function(){if(e.isNullOrUndefined(this.target))e.EventHandler.add(this.element,"focus",this.targetHover,this);else for(var t=0,i=[].slice.call(e.selectAll(this.target,this.element));t<i.length;t++){var o=i[t];e.EventHandler.add(o,"focus",this.targetHover,this)}},i.prototype.wireMouseEvents=function(t,i){this.tooltipEle&&(this.isSticky||("focus"===t.type&&e.EventHandler.add(i,"blur",this.onMouseOut,this),"mouseover"===t.type&&e.EventHandler.add(i,"mouseleave",this.onMouseOut,this),this.closeDelay&&(e.EventHandler.add(this.tooltipEle,"mouseenter",this.tooltipHover,this),e.EventHandler.add(this.tooltipEle,"mouseleave",this.tooltipMouseOut,this))),this.mouseTrail&&0===this.openDelay&&e.EventHandler.add(i,"mousemove touchstart mouseenter",this.onMouseMove,this))},i.prototype.unwireEvents=function(t){for(var i=0,o=this.getTriggerList(t);i<o.length;i++){var n=o[i];if("Custom"===n)return;"Focus"===n&&this.unwireFocusEvents(),"Click"===n&&e.EventHandler.remove(this.element,e.Browser.touchStartEvent,this.targetClick),"Hover"===n&&(e.Browser.isDevice?(this.touchModule&&this.touchModule.destroy(),e.EventHandler.remove(this.element,e.Browser.touchEndEvent,this.touchEndHandler)):e.EventHandler.remove(this.element,"mouseover",this.targetHover))}e.EventHandler.remove(document,"touchend",this.touchEnd),e.EventHandler.remove(document,"scroll wheel",this.scrollHandler),e.EventHandler.remove(window,"resize",this.windowResize),e.EventHandler.remove(document,"keydown",this.keyDown)},i.prototype.unwireFocusEvents=function(){if(e.isNullOrUndefined(this.target))e.EventHandler.remove(this.element,"focus",this.targetHover);else for(var t=0,i=[].slice.call(e.selectAll(this.target,this.element));t<i.length;t++){var o=i[t];e.EventHandler.remove(o,"focus",this.targetHover)}},i.prototype.unwireMouseEvents=function(t){if(!this.isSticky){for(var i=0,o=this.getTriggerList(this.opensOn);i<o.length;i++){var n=o[i];"Focus"===n&&e.EventHandler.remove(t,"blur",this.onMouseOut),"Hover"!==n||e.Browser.isDevice||e.EventHandler.remove(t,"mouseleave",this.onMouseOut)}this.closeDelay&&(e.EventHandler.remove(t,"mouseenter",this.tooltipHover),e.EventHandler.remove(t,"mouseleave",this.tooltipMouseOut))}this.mouseTrail&&e.EventHandler.remove(t,"mousemove touchstart mouseenter",this.onMouseMove)},i.prototype.findTarget=function(){return e.select('[data-tooltip-id= "'+this.ctrlId+'_content"]',document)},i.prototype.getModuleName=function(){return"tooltip"},i.prototype.getPersistData=function(){return this.addOnPersist([])},i.prototype.onPropertyChanged=function(t,i){for(var o=this.findTarget(),n=0,s=Object.keys(t);n<s.length;n++){switch(s[n]){case"width":this.tooltipEle&&o&&(this.tooltipEle.style.width=this.tooltipEle.style.maxWidth=e.formatUnit(t.width),this.reposition(o));break;case"height":this.tooltipEle&&o&&(this.tooltipEle.style.height=e.formatUnit(t.height),this.reposition(o));break;case"content":this.tooltipEle&&this.renderContent();break;case"opensOn":this.unwireEvents(i.opensOn),this.wireEvents(t.opensOn);break;case"position":if(this.formatPosition(),this.tooltipEle&&o){var l=e.select("."+Re,this.tooltipEle);l.style.top=l.style.left=null,this.reposition(o)}break;case"tipPointerPosition":this.tooltipEle&&o&&this.reposition(o);break;case"offsetX":if(this.tooltipEle){var r=t.offsetX-i.offsetX;this.tooltipEle.style.left=(parseInt(this.tooltipEle.style.left,10)+r).toString()+"px"}break;case"offsetY":if(this.tooltipEle){var a=t.offsetY-i.offsetY;this.tooltipEle.style.top=(parseInt(this.tooltipEle.style.top,10)+a).toString()+"px"}break;case"cssClass":this.tooltipEle&&(i.cssClass&&e.removeClass([this.tooltipEle],i.cssClass.split(" ")),t.cssClass&&e.addClass([this.tooltipEle],t.cssClass.split(" ")));break;case"enableRtl":this.tooltipEle&&(this.enableRtl?e.addClass([this.tooltipEle],"e-rtl"):e.removeClass([this.tooltipEle],"e-rtl"));break;case"container":e.isNullOrUndefined(this.containerElement)||e.removeClass([this.containerElement],Ye),this.container=t.container,this.tooltipEle&&o&&(this.appendContainer(this),this.reposition(o))}}},i.prototype.open=function(t,i){e.isNullOrUndefined(i)&&(i=this.animation.open),e.isNullOrUndefined(t)&&(t=this.element),"none"!==t.style.display&&this.showTooltip(t,i)},i.prototype.close=function(t){t||(t=this.animation.close),this.hideTooltip(t)},i.prototype.refresh=function(t){this.tooltipEle&&this.renderContent(t),this.popupObj&&t&&this.reposition(t)},i.prototype.destroy=function(){t.prototype.destroy.call(this),this.tooltipEle&&e.remove(this.tooltipEle),this.popupObj&&this.popupObj.destroy(),e.removeClass([this.element],xe),this.unwireEvents(this.opensOn),this.unwireMouseEvents(this.element),this.tooltipEle=null,this.popupObj=null},Pe([e.Property("auto")],i.prototype,"width",void 0),Pe([e.Property("auto")],i.prototype,"height",void 0),Pe([e.Property()],i.prototype,"content",void 0),Pe([e.Property("body")],i.prototype,"container",void 0),Pe([e.Property()],i.prototype,"target",void 0),Pe([e.Property("TopCenter")],i.prototype,"position",void 0),Pe([e.Property(0)],i.prototype,"offsetX",void 0),Pe([e.Property(0)],i.prototype,"offsetY",void 0),Pe([e.Property(!0)],i.prototype,"showTipPointer",void 0),Pe([e.Property(!0)],i.prototype,"enableHtmlParse",void 0),Pe([e.Property(!1)],i.prototype,"windowCollision",void 0),Pe([e.Property("Auto")],i.prototype,"tipPointerPosition",void 0),Pe([e.Property("Auto")],i.prototype,"opensOn",void 0),Pe([e.Property(!1)],i.prototype,"mouseTrail",void 0),Pe([e.Property(!1)],i.prototype,"isSticky",void 0),Pe([e.Complex({},Xe)],i.prototype,"animation",void 0),Pe([e.Property(0)],i.prototype,"openDelay",void 0),Pe([e.Property(0)],i.prototype,"closeDelay",void 0),Pe([e.Property()],i.prototype,"cssClass",void 0),Pe([e.Property(!1)],i.prototype,"enableHtmlSanitizer",void 0),Pe([e.Event()],i.prototype,"beforeRender",void 0),Pe([e.Event()],i.prototype,"beforeOpen",void 0),Pe([e.Event()],i.prototype,"afterOpen",void 0),Pe([e.Event()],i.prototype,"beforeClose",void 0),Pe([e.Event()],i.prototype,"afterClose",void 0),Pe([e.Event()],i.prototype,"beforeCollision",void 0),Pe([e.Event()],i.prototype,"created",void 0),Pe([e.Event()],i.prototype,"destroyed",void 0),i=Pe([e.NotifyPropertyChanges],i)}(e.Component),je={},Fe=30,qe=30,_e=30,We=36,Ve=36,Ze="e-spin-show",Ge="e-spin-hide",Ke="e-spin-material",Je="e-spin-fabric",Qe="e-spin-tailwind",$e="e-spin-bootstrap",ti="e-spin-bootstrap4",ei="e-spin-bootstrap5",ii="e-spin-high-contrast",oi="e-spinner-pane",ni="e-spinner-inner",si="e-path-circle",li="e-path-arc",ri="e-spin-label",ai="e-spin-template",hi=null,di=null;t.PositionData=Rt,t.Popup=At,t.getScrollableParent=M,t.getZindexPartial=L,t.getMaxZindex=function(t){void 0===t&&(t=["*"]);for(var e=[],i=0;i<t.length;i++)for(var o=document.getElementsByTagName(t[i]),n=0;n<o.length;n++){var s=document.defaultView.getComputedStyle(o[n],null).getPropertyValue("z-index"),l=document.defaultView.getComputedStyle(o[n],null).getPropertyValue("position");"auto"!==s&&"static"!==l&&e.push(s)}var r=Math.max.apply(Math,e)+1;return r>2147483647?2147483647:r},t.calculateRelativeBasedPosition=o,t.calculatePosition=n,t.fit=m,t.isCollide=g,t.flip=y,t.ButtonProps=le,t.AnimationSettings=re,t.Dialog=Te,t.Animation=Xe,t.Tooltip=De,t.Spinner=function(t,e,i,o){switch(t){case"Create":Q({type:o,target:document.querySelector(e.target),cssClass:e.cssClass,label:e.label,width:e.width});break;case"Show":pt(document.querySelector(i));break;case"Hide":ut(document.querySelector(i));break;case"Set":ft({cssClass:e.cssClass,type:o})}},t.createSpinner=Q,t.showSpinner=pt,t.hideSpinner=ut,t.setSpinner=ft,Object.defineProperty(t,"__esModule",{value:!0})});
	//# sourceMappingURL=ej2-popups.umd.min.js.map


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	/**
	 *
	 * @enum
	 */
	var OperationType;
	(function (OperationType) {
	    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
	    OperationType[OperationType["MERGE"] = 1] = "MERGE";
	    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
	    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
	})(OperationType = exports.OperationType || (exports.OperationType = {}));
	/**
	 * @param {boolean} fromUser
	 * @param {boolean} fromServer
	 * @param {?string} queryId
	 * @param {boolean} tagged
	 * @constructor
	 */
	var OperationSource = /** @class */ (function () {
	    function OperationSource(fromUser, fromServer, queryId, tagged) {
	        this.fromUser = fromUser;
	        this.fromServer = fromServer;
	        this.queryId = queryId;
	        this.tagged = tagged;
	        util_1.assert(!tagged || fromServer, 'Tagged queries must be from server.');
	    }
	    /**
	     * @const
	     * @type {!OperationSource}
	     */
	    OperationSource.User = new OperationSource(
	    /*fromUser=*/ true, false, null, 
	    /*tagged=*/ false);
	    /**
	     * @const
	     * @type {!OperationSource}
	     */
	    OperationSource.Server = new OperationSource(false, 
	    /*fromServer=*/ true, null, 
	    /*tagged=*/ false);
	    /**
	     * @param {string} queryId
	     * @return {!OperationSource}
	     */
	    OperationSource.forServerTaggedQuery = function (queryId) {
	        return new OperationSource(false, 
	        /*fromServer=*/ true, queryId, 
	        /*tagged=*/ true);
	    };
	    return OperationSource;
	}());
	exports.OperationSource = OperationSource;
	
	//# sourceMappingURL=Operation.js.map


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Path_1 = __webpack_require__(17);
	var util_1 = __webpack_require__(2);
	var util_2 = __webpack_require__(13);
	var util_3 = __webpack_require__(2);
	var util_4 = __webpack_require__(2);
	/**
	 * True for invalid Firebase keys
	 * @type {RegExp}
	 * @private
	 */
	exports.INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
	/**
	 * True for invalid Firebase paths.
	 * Allows '/' in paths.
	 * @type {RegExp}
	 * @private
	 */
	exports.INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
	/**
	 * Maximum number of characters to allow in leaf value
	 * @type {number}
	 * @private
	 */
	exports.MAX_LEAF_SIZE_ = 10 * 1024 * 1024;
	/**
	 * @param {*} key
	 * @return {boolean}
	 */
	exports.isValidKey = function (key) {
	    return (typeof key === 'string' && key.length !== 0 && !exports.INVALID_KEY_REGEX_.test(key));
	};
	/**
	 * @param {string} pathString
	 * @return {boolean}
	 */
	exports.isValidPathString = function (pathString) {
	    return (typeof pathString === 'string' &&
	        pathString.length !== 0 &&
	        !exports.INVALID_PATH_REGEX_.test(pathString));
	};
	/**
	 * @param {string} pathString
	 * @return {boolean}
	 */
	exports.isValidRootPathString = function (pathString) {
	    if (pathString) {
	        // Allow '/.info/' at the beginning.
	        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
	    }
	    return exports.isValidPathString(pathString);
	};
	/**
	 * @param {*} priority
	 * @return {boolean}
	 */
	exports.isValidPriority = function (priority) {
	    return (priority === null ||
	        typeof priority === 'string' ||
	        (typeof priority === 'number' && !util_2.isInvalidJSONNumber(priority)) ||
	        (priority && typeof priority === 'object' && util_1.contains(priority, '.sv')));
	};
	/**
	 * Pre-validate a datum passed as an argument to Firebase function.
	 *
	 * @param {string} fnName
	 * @param {number} argumentNumber
	 * @param {*} data
	 * @param {!Path} path
	 * @param {boolean} optional
	 */
	exports.validateFirebaseDataArg = function (fnName, argumentNumber, data, path, optional) {
	    if (optional && data === undefined)
	        return;
	    exports.validateFirebaseData(util_3.errorPrefix(fnName, argumentNumber, optional), data, path);
	};
	/**
	 * Validate a data object client-side before sending to server.
	 *
	 * @param {string} errorPrefix
	 * @param {*} data
	 * @param {!Path|!ValidationPath} path_
	 */
	exports.validateFirebaseData = function (errorPrefix, data, path_) {
	    var path = path_ instanceof Path_1.Path ? new Path_1.ValidationPath(path_, errorPrefix) : path_;
	    if (data === undefined) {
	        throw new Error(errorPrefix + 'contains undefined ' + path.toErrorString());
	    }
	    if (typeof data === 'function') {
	        throw new Error(errorPrefix +
	            'contains a function ' +
	            path.toErrorString() +
	            ' with contents = ' +
	            data.toString());
	    }
	    if (util_2.isInvalidJSONNumber(data)) {
	        throw new Error(errorPrefix + 'contains ' + data.toString() + ' ' + path.toErrorString());
	    }
	    // Check max leaf size, but try to avoid the utf8 conversion if we can.
	    if (typeof data === 'string' &&
	        data.length > exports.MAX_LEAF_SIZE_ / 3 &&
	        util_4.stringLength(data) > exports.MAX_LEAF_SIZE_) {
	        throw new Error(errorPrefix +
	            'contains a string greater than ' +
	            exports.MAX_LEAF_SIZE_ +
	            ' utf8 bytes ' +
	            path.toErrorString() +
	            " ('" +
	            data.substring(0, 50) +
	            "...')");
	    }
	    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
	    // to save extra walking of large objects.
	    if (data && typeof data === 'object') {
	        var hasDotValue_1 = false, hasActualChild_1 = false;
	        util_1.forEach(data, function (key, value) {
	            if (key === '.value') {
	                hasDotValue_1 = true;
	            }
	            else if (key !== '.priority' && key !== '.sv') {
	                hasActualChild_1 = true;
	                if (!exports.isValidKey(key)) {
	                    throw new Error(errorPrefix +
	                        ' contains an invalid key (' +
	                        key +
	                        ') ' +
	                        path.toErrorString() +
	                        '.  Keys must be non-empty strings ' +
	                        'and can\'t contain ".", "#", "$", "/", "[", or "]"');
	                }
	            }
	            path.push(key);
	            exports.validateFirebaseData(errorPrefix, value, path);
	            path.pop();
	        });
	        if (hasDotValue_1 && hasActualChild_1) {
	            throw new Error(errorPrefix +
	                ' contains ".value" child ' +
	                path.toErrorString() +
	                ' in addition to actual children.');
	        }
	    }
	};
	/**
	 * Pre-validate paths passed in the firebase function.
	 *
	 * @param {string} errorPrefix
	 * @param {Array<!Path>} mergePaths
	 */
	exports.validateFirebaseMergePaths = function (errorPrefix, mergePaths) {
	    var i, curPath;
	    for (i = 0; i < mergePaths.length; i++) {
	        curPath = mergePaths[i];
	        var keys = curPath.slice();
	        for (var j = 0; j < keys.length; j++) {
	            if (keys[j] === '.priority' && j === keys.length - 1) {
	                // .priority is OK
	            }
	            else if (!exports.isValidKey(keys[j])) {
	                throw new Error(errorPrefix +
	                    'contains an invalid key (' +
	                    keys[j] +
	                    ') in path ' +
	                    curPath.toString() +
	                    '. Keys must be non-empty strings ' +
	                    'and can\'t contain ".", "#", "$", "/", "[", or "]"');
	            }
	        }
	    }
	    // Check that update keys are not descendants of each other.
	    // We rely on the property that sorting guarantees that ancestors come
	    // right before descendants.
	    mergePaths.sort(Path_1.Path.comparePaths);
	    var prevPath = null;
	    for (i = 0; i < mergePaths.length; i++) {
	        curPath = mergePaths[i];
	        if (prevPath !== null && prevPath.contains(curPath)) {
	            throw new Error(errorPrefix +
	                'contains a path ' +
	                prevPath.toString() +
	                ' that is ancestor of another path ' +
	                curPath.toString());
	        }
	        prevPath = curPath;
	    }
	};
	/**
	 * pre-validate an object passed as an argument to firebase function (
	 * must be an object - e.g. for firebase.update()).
	 *
	 * @param {string} fnName
	 * @param {number} argumentNumber
	 * @param {*} data
	 * @param {!Path} path
	 * @param {boolean} optional
	 */
	exports.validateFirebaseMergeDataArg = function (fnName, argumentNumber, data, path, optional) {
	    if (optional && data === undefined)
	        return;
	    var errorPrefix = util_3.errorPrefix(fnName, argumentNumber, optional);
	    if (!(data && typeof data === 'object') || Array.isArray(data)) {
	        throw new Error(errorPrefix + ' must be an object containing the children to replace.');
	    }
	    var mergePaths = [];
	    util_1.forEach(data, function (key, value) {
	        var curPath = new Path_1.Path(key);
	        exports.validateFirebaseData(errorPrefix, value, path.child(curPath));
	        if (curPath.getBack() === '.priority') {
	            if (!exports.isValidPriority(value)) {
	                throw new Error(errorPrefix +
	                    "contains an invalid value for '" +
	                    curPath.toString() +
	                    "', which must be a valid " +
	                    'Firebase priority (a string, finite number, server value, or null).');
	            }
	        }
	        mergePaths.push(curPath);
	    });
	    exports.validateFirebaseMergePaths(errorPrefix, mergePaths);
	};
	exports.validatePriority = function (fnName, argumentNumber, priority, optional) {
	    if (optional && priority === undefined)
	        return;
	    if (util_2.isInvalidJSONNumber(priority))
	        throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
	            'is ' +
	            priority.toString() +
	            ', but must be a valid Firebase priority (a string, finite number, ' +
	            'server value, or null).');
	    // Special case to allow importing data with a .sv.
	    if (!exports.isValidPriority(priority))
	        throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid Firebase priority ' +
	            '(a string, finite number, server value, or null).');
	};
	exports.validateEventType = function (fnName, argumentNumber, eventType, optional) {
	    if (optional && eventType === undefined)
	        return;
	    switch (eventType) {
	        case 'value':
	        case 'child_added':
	        case 'child_removed':
	        case 'child_changed':
	        case 'child_moved':
	            break;
	        default:
	            throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
	                'must be a valid event type = "value", "child_added", "child_removed", ' +
	                '"child_changed", or "child_moved".');
	    }
	};
	exports.validateKey = function (fnName, argumentNumber, key, optional) {
	    if (optional && key === undefined)
	        return;
	    if (!exports.isValidKey(key))
	        throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
	            'was an invalid key = "' +
	            key +
	            '".  Firebase keys must be non-empty strings and ' +
	            'can\'t contain ".", "#", "$", "/", "[", or "]").');
	};
	exports.validatePathString = function (fnName, argumentNumber, pathString, optional) {
	    if (optional && pathString === undefined)
	        return;
	    if (!exports.isValidPathString(pathString))
	        throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
	            'was an invalid path = "' +
	            pathString +
	            '". Paths must be non-empty strings and ' +
	            'can\'t contain ".", "#", "$", "[", or "]"');
	};
	exports.validateRootPathString = function (fnName, argumentNumber, pathString, optional) {
	    if (pathString) {
	        // Allow '/.info/' at the beginning.
	        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
	    }
	    exports.validatePathString(fnName, argumentNumber, pathString, optional);
	};
	exports.validateWritablePath = function (fnName, path) {
	    if (path.getFront() === '.info') {
	        throw new Error(fnName + " failed = Can't modify data under /.info/");
	    }
	};
	exports.validateUrl = function (fnName, argumentNumber, parsedUrl) {
	    // TODO = Validate server better.
	    var pathString = parsedUrl.path.toString();
	    if (!(typeof parsedUrl.repoInfo.host === 'string') ||
	        parsedUrl.repoInfo.host.length === 0 ||
	        !exports.isValidKey(parsedUrl.repoInfo.namespace) ||
	        (pathString.length !== 0 && !exports.isValidRootPathString(pathString))) {
	        throw new Error(util_3.errorPrefix(fnName, argumentNumber, false) +
	            'must be a valid firebase URL and ' +
	            'the path can\'t contain ".", "#", "$", "[", or "]".');
	    }
	};
	exports.validateCredential = function (fnName, argumentNumber, cred, optional) {
	    if (optional && cred === undefined)
	        return;
	    if (!(typeof cred === 'string'))
	        throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid credential (a string).');
	};
	exports.validateBoolean = function (fnName, argumentNumber, bool, optional) {
	    if (optional && bool === undefined)
	        return;
	    if (typeof bool !== 'boolean')
	        throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) + 'must be a boolean.');
	};
	exports.validateString = function (fnName, argumentNumber, string, optional) {
	    if (optional && string === undefined)
	        return;
	    if (!(typeof string === 'string')) {
	        throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid string.');
	    }
	};
	exports.validateObject = function (fnName, argumentNumber, obj, optional) {
	    if (optional && obj === undefined)
	        return;
	    if (!(obj && typeof obj === 'object') || obj === null) {
	        throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid object.');
	    }
	};
	exports.validateObjectContainsKey = function (fnName, argumentNumber, obj, key, optional, opt_type) {
	    var objectContainsKey = obj && typeof obj === 'object' && util_1.contains(obj, key);
	    if (!objectContainsKey) {
	        if (optional) {
	            return;
	        }
	        else {
	            throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
	                'must contain the key "' +
	                key +
	                '"');
	        }
	    }
	    if (opt_type) {
	        var val = util_1.safeGet(obj, key);
	        if ((opt_type === 'number' && !(typeof val === 'number')) ||
	            (opt_type === 'string' && !(typeof val === 'string')) ||
	            (opt_type === 'boolean' && !(typeof val === 'boolean')) ||
	            (opt_type === 'function' && !(typeof val === 'function')) ||
	            (opt_type === 'object' && !(typeof val === 'object') && val)) {
	            if (optional) {
	                throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
	                    'contains invalid value for key "' +
	                    key +
	                    '" (must be of type "' +
	                    opt_type +
	                    '")');
	            }
	            else {
	                throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
	                    'must contain the key "' +
	                    key +
	                    '" with type "' +
	                    opt_type +
	                    '"');
	            }
	        }
	    }
	};
	
	//# sourceMappingURL=validation.js.map


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(10);
	var error_1 = __webpack_require__(19);
	exports.DOCUMENT_KEY_NAME = '__name__';
	/**
	 * Path represents an ordered sequence of string segments.
	 */
	var Path = /** @class */ (function () {
	    function Path(segments, offset, length) {
	        this.init(segments, offset, length);
	    }
	    /**
	     * An initialization method that can be called from outside the constructor.
	     * We need this so that we can have a non-static construct method that returns
	     * the polymorphic `this` type.
	     */
	    Path.prototype.init = function (segments, offset, length) {
	        if (offset === undefined) {
	            offset = 0;
	        }
	        else if (offset > segments.length) {
	            assert_1.fail('offset ' + offset + ' out of range ' + segments.length);
	        }
	        if (length === undefined) {
	            length = segments.length - offset;
	        }
	        else if (length > segments.length - offset) {
	            assert_1.fail('length ' + length + ' out of range ' + (segments.length - offset));
	        }
	        this.segments = segments;
	        this.offset = offset;
	        this.len = length;
	    };
	    /**
	     * Constructs a new instance of Path using the same concrete type as `this`.
	     * We need this instead of using the normal constructor, because polymorphic
	     * `this` doesn't work on static methods.
	     */
	    Path.prototype.construct = function (segments, offset, length) {
	        var path = Object.create(Object.getPrototypeOf(this));
	        path.init(segments, offset, length);
	        return path;
	    };
	    Object.defineProperty(Path.prototype, "length", {
	        get: function () {
	            return this.len;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Path.prototype.equals = function (other) {
	        return Path.comparator(this, other) === 0;
	    };
	    Path.prototype.child = function (nameOrPath) {
	        var segments = this.segments.slice(this.offset, this.limit());
	        if (nameOrPath instanceof Path) {
	            nameOrPath.forEach(function (segment) {
	                segments.push(segment);
	            });
	        }
	        else if (typeof nameOrPath === 'string') {
	            segments.push(nameOrPath);
	        }
	        else {
	            assert_1.fail('Unknown parameter type for Path.child(): ' + nameOrPath);
	        }
	        return this.construct(segments);
	    };
	    /** The index of one past the last segment of the path. */
	    Path.prototype.limit = function () {
	        return this.offset + this.length;
	    };
	    Path.prototype.popFirst = function (size) {
	        size = size === undefined ? 1 : size;
	        assert_1.assert(this.length >= size, "Can't call popFirst() with less segments");
	        return this.construct(this.segments, this.offset + size, this.length - size);
	    };
	    Path.prototype.popLast = function () {
	        assert_1.assert(!this.isEmpty(), "Can't call popLast() on empty path");
	        return this.construct(this.segments, this.offset, this.length - 1);
	    };
	    Path.prototype.firstSegment = function () {
	        assert_1.assert(!this.isEmpty(), "Can't call firstSegment() on empty path");
	        return this.segments[this.offset];
	    };
	    Path.prototype.lastSegment = function () {
	        assert_1.assert(!this.isEmpty(), "Can't call lastSegment() on empty path");
	        return this.segments[this.limit() - 1];
	    };
	    Path.prototype.get = function (index) {
	        assert_1.assert(index < this.length, 'Index out of range');
	        return this.segments[this.offset + index];
	    };
	    Path.prototype.isEmpty = function () {
	        return this.length === 0;
	    };
	    Path.prototype.isPrefixOf = function (other) {
	        if (other.length < this.length) {
	            return false;
	        }
	        for (var i = 0; i < this.length; i++) {
	            if (this.get(i) !== other.get(i)) {
	                return false;
	            }
	        }
	        return true;
	    };
	    Path.prototype.forEach = function (fn) {
	        for (var i = this.offset, end = this.limit(); i < end; i++) {
	            fn(this.segments[i]);
	        }
	    };
	    Path.prototype.toArray = function () {
	        return this.segments.slice(this.offset, this.limit());
	    };
	    Path.comparator = function (p1, p2) {
	        var len = Math.min(p1.length, p2.length);
	        for (var i = 0; i < len; i++) {
	            var left = p1.get(i);
	            var right = p2.get(i);
	            if (left < right)
	                return -1;
	            if (left > right)
	                return 1;
	        }
	        if (p1.length < p2.length)
	            return -1;
	        if (p1.length > p2.length)
	            return 1;
	        return 0;
	    };
	    return Path;
	}());
	exports.Path = Path;
	/**
	 * A slash-separated path for navigating resources (documents and collections)
	 * within Firestore.
	 */
	var ResourcePath = /** @class */ (function (_super) {
	    __extends(ResourcePath, _super);
	    function ResourcePath() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ResourcePath.prototype.canonicalString = function () {
	        // NOTE: The client is ignorant of any path segments containing escape
	        // sequences (e.g. __id123__) and just passes them through raw (they exist
	        // for legacy reasons and should not be used frequently).
	        return this.toArray().join('/');
	    };
	    ResourcePath.prototype.toString = function () {
	        return this.canonicalString();
	    };
	    /**
	     * Creates a resource path from the given slash-delimited string.
	     */
	    ResourcePath.fromString = function (path) {
	        // NOTE: The client is ignorant of any path segments containing escape
	        // sequences (e.g. __id123__) and just passes them through raw (they exist
	        // for legacy reasons and should not be used frequently).
	        if (path.indexOf('//') >= 0) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Invalid path (" + path + "). Paths must not contain // in them.");
	        }
	        // We may still have an empty segment at the beginning or end if they had a
	        // leading or trailing slash (which we allow).
	        var segments = path.split('/').filter(function (segment) { return segment.length > 0; });
	        return new ResourcePath(segments);
	    };
	    ResourcePath.EMPTY_PATH = new ResourcePath([]);
	    return ResourcePath;
	}(Path));
	exports.ResourcePath = ResourcePath;
	var identifierRegExp = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
	/** A dot-separated path for navigating sub-objects within a document. */
	var FieldPath = /** @class */ (function (_super) {
	    __extends(FieldPath, _super);
	    function FieldPath() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Returns true if the string could be used as a segment in a field path
	     * without escaping.
	     */
	    FieldPath.isValidIdentifier = function (segment) {
	        return identifierRegExp.test(segment);
	    };
	    FieldPath.prototype.canonicalString = function () {
	        return this.toArray()
	            .map(function (str) {
	            str = str.replace('\\', '\\\\').replace('`', '\\`');
	            if (!FieldPath.isValidIdentifier(str)) {
	                str = '`' + str + '`';
	            }
	            return str;
	        })
	            .join('.');
	    };
	    FieldPath.prototype.toString = function () {
	        return this.canonicalString();
	    };
	    /**
	     * Returns true if this field references the key of a document.
	     */
	    FieldPath.prototype.isKeyField = function () {
	        return this.length === 1 && this.get(0) === exports.DOCUMENT_KEY_NAME;
	    };
	    /**
	     * The field designating the key of a document.
	     */
	    FieldPath.keyField = function () {
	        return new FieldPath([exports.DOCUMENT_KEY_NAME]);
	    };
	    /**
	     * Parses a field string from the given server-formatted string.
	     *
	     * - Splitting the empty string is not allowed (for now at least).
	     * - Empty segments within the string (e.g. if there are two consecutive
	     *   separators) are not allowed.
	     *
	     * TODO(b/37244157): we should make this more strict. Right now, it allows
	     * non-identifier path components, even if they aren't escaped.
	     */
	    FieldPath.fromServerFormat = function (path) {
	        var segments = [];
	        var current = '';
	        var i = 0;
	        var addCurrentSegment = function () {
	            if (current.length === 0) {
	                throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not be empty, begin " +
	                    "with '.', end with '.', or contain '..'");
	            }
	            segments.push(current);
	            current = '';
	        };
	        var inBackticks = false;
	        while (i < path.length) {
	            var c = path[i];
	            if (c === '\\') {
	                if (i + 1 === path.length) {
	                    throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Path has trailing escape character: ' + path);
	                }
	                var next = path[i + 1];
	                if (!(next === '\\' || next === '.' || next === '`')) {
	                    throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Path has invalid escape sequence: ' + path);
	                }
	                current += next;
	                i += 2;
	            }
	            else if (c === '`') {
	                inBackticks = !inBackticks;
	                i++;
	            }
	            else if (c === '.' && !inBackticks) {
	                addCurrentSegment();
	                i++;
	            }
	            else {
	                current += c;
	                i++;
	            }
	        }
	        addCurrentSegment();
	        if (inBackticks) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Unterminated ` in path: ' + path);
	        }
	        return new FieldPath(segments);
	    };
	    FieldPath.EMPTY_PATH = new FieldPath([]);
	    return FieldPath;
	}(Path));
	exports.FieldPath = FieldPath;
	
	//# sourceMappingURL=path.js.map


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(10);
	// An immutable sorted map implementation, based on a Left-leaning Red-Black
	// tree.
	var SortedMap = /** @class */ (function () {
	    function SortedMap(comparator, root) {
	        this.comparator = comparator;
	        this.root = root ? root : LLRBNode.EMPTY;
	    }
	    // Returns a copy of the map, with the specified key/value added or replaced.
	    SortedMap.prototype.insert = function (key, value) {
	        return new SortedMap(this.comparator, this.root
	            .insert(key, value, this.comparator)
	            .copy(null, null, LLRBNode.BLACK, null, null));
	    };
	    // Returns a copy of the map, with the specified key removed.
	    SortedMap.prototype.remove = function (key) {
	        return new SortedMap(this.comparator, this.root
	            .remove(key, this.comparator)
	            .copy(null, null, LLRBNode.BLACK, null, null));
	    };
	    // Returns the value of the node with the given key, or null.
	    SortedMap.prototype.get = function (key) {
	        var node = this.root;
	        while (!node.isEmpty()) {
	            var cmp = this.comparator(key, node.key);
	            if (cmp === 0) {
	                return node.value;
	            }
	            else if (cmp < 0) {
	                node = node.left;
	            }
	            else if (cmp > 0) {
	                node = node.right;
	            }
	        }
	        return null;
	    };
	    // Returns the key of the item *before* the specified key, or null if key is
	    // the first item.
	    SortedMap.prototype.getPredecessorKey = function (key) {
	        var node = this.root;
	        var rightParent = null;
	        while (!node.isEmpty()) {
	            var cmp = this.comparator(key, node.key);
	            if (cmp === 0) {
	                if (!node.left.isEmpty()) {
	                    node = node.left;
	                    while (!node.right.isEmpty())
	                        node = node.right;
	                    return node.key;
	                }
	                else if (rightParent) {
	                    return rightParent.key;
	                }
	                else {
	                    return null; // first item.
	                }
	            }
	            else if (cmp < 0) {
	                node = node.left;
	            }
	            else if (cmp > 0) {
	                rightParent = node;
	                node = node.right;
	            }
	        }
	        throw assert_1.fail('Attempted to find predecessor key for a nonexistent key.' +
	            '  What gives?');
	    };
	    // Returns the index of the element in this sorted map, or -1 if it doesn't
	    // exist.
	    SortedMap.prototype.indexOf = function (key) {
	        // Number of nodes that were pruned when descending right
	        var prunedNodes = 0;
	        var node = this.root;
	        while (!node.isEmpty()) {
	            var cmp = this.comparator(key, node.key);
	            if (cmp === 0) {
	                return prunedNodes + node.left.size;
	            }
	            else if (cmp < 0) {
	                node = node.left;
	            }
	            else {
	                // Count all nodes left of the node plus the node itself
	                prunedNodes += node.left.size + 1;
	                node = node.right;
	            }
	        }
	        // Node not found
	        return -1;
	    };
	    SortedMap.prototype.isEmpty = function () {
	        return this.root.isEmpty();
	    };
	    Object.defineProperty(SortedMap.prototype, "size", {
	        // Returns the total number of nodes in the map.
	        get: function () {
	            return this.root.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    // Returns the minimum key in the map.
	    SortedMap.prototype.minKey = function () {
	        return this.root.minKey();
	    };
	    // Returns the maximum key in the map.
	    SortedMap.prototype.maxKey = function () {
	        return this.root.maxKey();
	    };
	    // Traverses the map in key order and calls the specified action function
	    // for each key/value pair. If action returns true, traversal is aborted.
	    // Returns the first truthy value returned by action, or the last falsey
	    // value returned by action.
	    SortedMap.prototype.inorderTraversal = function (action) {
	        return this.root.inorderTraversal(action);
	    };
	    SortedMap.prototype.forEach = function (fn) {
	        this.inorderTraversal(function (k, v) {
	            fn(k, v);
	            return false;
	        });
	    };
	    // Traverses the map in reverse key order and calls the specified action
	    // function for each key/value pair. If action returns true, traversal is
	    // aborted.
	    // Returns the first truthy value returned by action, or the last falsey
	    // value returned by action.
	    SortedMap.prototype.reverseTraversal = function (action) {
	        return this.root.reverseTraversal(action);
	    };
	    SortedMap.prototype.getIterator = function (resultGenerator) {
	        return new SortedMapIterator(this.root, null, this.comparator, false, resultGenerator);
	    };
	    SortedMap.prototype.getIteratorFrom = function (key, resultGenerator) {
	        return new SortedMapIterator(this.root, key, this.comparator, false, resultGenerator);
	    };
	    SortedMap.prototype.getReverseIterator = function (resultGenerator) {
	        return new SortedMapIterator(this.root, null, this.comparator, true, resultGenerator);
	    };
	    SortedMap.prototype.getReverseIteratorFrom = function (key, resultGenerator) {
	        return new SortedMapIterator(this.root, key, this.comparator, true, resultGenerator);
	    };
	    return SortedMap;
	}()); // end SortedMap
	exports.SortedMap = SortedMap;
	// An iterator over an LLRBNode.
	var SortedMapIterator = /** @class */ (function () {
	    function SortedMapIterator(node, startKey, comparator, isReverse, resultGenerator) {
	        this.resultGenerator = resultGenerator || null;
	        this.isReverse = isReverse;
	        this.nodeStack = [];
	        var cmp = 1;
	        while (!node.isEmpty()) {
	            cmp = startKey ? comparator(node.key, startKey) : 1;
	            // flip the comparison if we're going in reverse
	            if (isReverse)
	                cmp *= -1;
	            if (cmp < 0) {
	                // This node is less than our start key. ignore it
	                if (this.isReverse) {
	                    node = node.left;
	                }
	                else {
	                    node = node.right;
	                }
	            }
	            else if (cmp === 0) {
	                // This node is exactly equal to our start key. Push it on the stack,
	                // but stop iterating;
	                this.nodeStack.push(node);
	                break;
	            }
	            else {
	                // This node is greater than our start key, add it to the stack and move
	                // to the next one
	                this.nodeStack.push(node);
	                if (this.isReverse) {
	                    node = node.right;
	                }
	                else {
	                    node = node.left;
	                }
	            }
	        }
	    }
	    SortedMapIterator.prototype.getNext = function () {
	        assert_1.assert(this.nodeStack.length > 0, 'getNext() called on iterator when hasNext() is false.');
	        var node = this.nodeStack.pop();
	        var result;
	        if (this.resultGenerator)
	            result = this.resultGenerator(node.key, node.value);
	        else
	            result = { key: node.key, value: node.value };
	        if (this.isReverse) {
	            node = node.left;
	            while (!node.isEmpty()) {
	                this.nodeStack.push(node);
	                node = node.right;
	            }
	        }
	        else {
	            node = node.right;
	            while (!node.isEmpty()) {
	                this.nodeStack.push(node);
	                node = node.left;
	            }
	        }
	        return result;
	    };
	    SortedMapIterator.prototype.hasNext = function () {
	        return this.nodeStack.length > 0;
	    };
	    SortedMapIterator.prototype.peek = function () {
	        if (this.nodeStack.length === 0)
	            return null;
	        var node = this.nodeStack[this.nodeStack.length - 1];
	        if (this.resultGenerator) {
	            return this.resultGenerator(node.key, node.value);
	        }
	        else {
	            return { key: node.key, value: node.value };
	        }
	    };
	    return SortedMapIterator;
	}()); // end SortedMapIterator
	exports.SortedMapIterator = SortedMapIterator;
	// Represents a node in a Left-leaning Red-Black tree.
	var LLRBNode = /** @class */ (function () {
	    function LLRBNode(key, value, color, left, right) {
	        this.key = key;
	        this.value = value;
	        this.color = color != null ? color : LLRBNode.RED;
	        this.left = left != null ? left : LLRBNode.EMPTY;
	        this.right = right != null ? right : LLRBNode.EMPTY;
	        this.size = this.left.size + 1 + this.right.size;
	    }
	    // Returns a copy of the current node, optionally replacing pieces of it.
	    LLRBNode.prototype.copy = function (key, value, color, left, right) {
	        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
	    };
	    LLRBNode.prototype.isEmpty = function () {
	        return false;
	    };
	    // Traverses the tree in key order and calls the specified action function
	    // for each node. If action returns true, traversal is aborted.
	    // Returns the first truthy value returned by action, or the last falsey
	    // value returned by action.
	    LLRBNode.prototype.inorderTraversal = function (action) {
	        return (this.left.inorderTraversal(action) ||
	            action(this.key, this.value) ||
	            this.right.inorderTraversal(action));
	    };
	    // Traverses the tree in reverse key order and calls the specified action
	    // function for each node. If action returns true, traversal is aborted.
	    // Returns the first truthy value returned by action, or the last falsey
	    // value returned by action.
	    LLRBNode.prototype.reverseTraversal = function (action) {
	        return (this.right.reverseTraversal(action) ||
	            action(this.key, this.value) ||
	            this.left.reverseTraversal(action));
	    };
	    // Returns the minimum node in the tree.
	    LLRBNode.prototype.min = function () {
	        if (this.left.isEmpty()) {
	            return this;
	        }
	        else {
	            return this.left.min();
	        }
	    };
	    // Returns the maximum key in the tree.
	    LLRBNode.prototype.minKey = function () {
	        return this.min().key;
	    };
	    // Returns the maximum key in the tree.
	    LLRBNode.prototype.maxKey = function () {
	        if (this.right.isEmpty()) {
	            return this.key;
	        }
	        else {
	            return this.right.maxKey();
	        }
	    };
	    // Returns new tree, with the key/value added.
	    LLRBNode.prototype.insert = function (key, value, comparator) {
	        var n = this;
	        var cmp = comparator(key, n.key);
	        if (cmp < 0) {
	            n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
	        }
	        else if (cmp === 0) {
	            n = n.copy(null, value, null, null, null);
	        }
	        else {
	            n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
	        }
	        return n.fixUp();
	    };
	    LLRBNode.prototype.removeMin = function () {
	        if (this.left.isEmpty()) {
	            return LLRBNode.EMPTY;
	        }
	        var n = this;
	        if (!n.left.isRed() && !n.left.left.isRed())
	            n = n.moveRedLeft();
	        n = n.copy(null, null, null, n.left.removeMin(), null);
	        return n.fixUp();
	    };
	    // Returns new tree, with the specified item removed.
	    LLRBNode.prototype.remove = function (key, comparator) {
	        var smallest;
	        var n = this;
	        if (comparator(key, n.key) < 0) {
	            if (!n.left.isEmpty() && !n.left.isRed() && !n.left.left.isRed()) {
	                n = n.moveRedLeft();
	            }
	            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
	        }
	        else {
	            if (n.left.isRed())
	                n = n.rotateRight();
	            if (!n.right.isEmpty() && !n.right.isRed() && !n.right.left.isRed()) {
	                n = n.moveRedRight();
	            }
	            if (comparator(key, n.key) === 0) {
	                if (n.right.isEmpty()) {
	                    return LLRBNode.EMPTY;
	                }
	                else {
	                    smallest = n.right.min();
	                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin());
	                }
	            }
	            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
	        }
	        return n.fixUp();
	    };
	    LLRBNode.prototype.isRed = function () {
	        return this.color;
	    };
	    // Returns new tree after performing any needed rotations.
	    LLRBNode.prototype.fixUp = function () {
	        var n = this;
	        if (n.right.isRed() && !n.left.isRed())
	            n = n.rotateLeft();
	        if (n.left.isRed() && n.left.left.isRed())
	            n = n.rotateRight();
	        if (n.left.isRed() && n.right.isRed())
	            n = n.colorFlip();
	        return n;
	    };
	    LLRBNode.prototype.moveRedLeft = function () {
	        var n = this.colorFlip();
	        if (n.right.left.isRed()) {
	            n = n.copy(null, null, null, null, n.right.rotateRight());
	            n = n.rotateLeft();
	            n = n.colorFlip();
	        }
	        return n;
	    };
	    LLRBNode.prototype.moveRedRight = function () {
	        var n = this.colorFlip();
	        if (n.left.left.isRed()) {
	            n = n.rotateRight();
	            n = n.colorFlip();
	        }
	        return n;
	    };
	    LLRBNode.prototype.rotateLeft = function () {
	        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
	        return this.right.copy(null, null, this.color, nl, null);
	    };
	    LLRBNode.prototype.rotateRight = function () {
	        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
	        return this.left.copy(null, null, this.color, null, nr);
	    };
	    LLRBNode.prototype.colorFlip = function () {
	        var left = this.left.copy(null, null, !this.left.color, null, null);
	        var right = this.right.copy(null, null, !this.right.color, null, null);
	        return this.copy(null, null, !this.color, left, right);
	    };
	    // For testing.
	    LLRBNode.prototype.checkMaxDepth = function () {
	        var blackDepth = this.check();
	        if (Math.pow(2.0, blackDepth) <= this.size + 1) {
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    // In a balanced RB tree, the black-depth (number of black nodes) from root to
	    // leaves is equal on both sides.  This function verifies that or asserts.
	    LLRBNode.prototype.check = function () {
	        if (this.isRed() && this.left.isRed()) {
	            throw assert_1.fail('Red node has red child(' + this.key + ',' + this.value + ')');
	        }
	        if (this.right.isRed()) {
	            throw assert_1.fail('Right child of (' + this.key + ',' + this.value + ') is red');
	        }
	        var blackDepth = this.left.check();
	        if (blackDepth !== this.right.check()) {
	            throw assert_1.fail('Black depths differ');
	        }
	        else {
	            return blackDepth + (this.isRed() ? 0 : 1);
	        }
	    };
	    LLRBNode.EMPTY = null;
	    LLRBNode.RED = true;
	    LLRBNode.BLACK = false;
	    return LLRBNode;
	}()); // end LLRBNode
	exports.LLRBNode = LLRBNode;
	// Represents an empty node (a leaf node in the Red-Black Tree).
	var LLRBEmptyNode = /** @class */ (function () {
	    function LLRBEmptyNode() {
	        this.size = 0;
	    }
	    // Returns a copy of the current node.
	    LLRBEmptyNode.prototype.copy = function (key, value, color, left, right) {
	        return this;
	    };
	    // Returns a copy of the tree, with the specified key/value added.
	    LLRBEmptyNode.prototype.insert = function (key, value, comparator) {
	        return new LLRBNode(key, value);
	    };
	    // Returns a copy of the tree, with the specified key removed.
	    LLRBEmptyNode.prototype.remove = function (key, comparator) {
	        return this;
	    };
	    LLRBEmptyNode.prototype.isEmpty = function () {
	        return true;
	    };
	    LLRBEmptyNode.prototype.inorderTraversal = function (action) {
	        return false;
	    };
	    LLRBEmptyNode.prototype.reverseTraversal = function (action) {
	        return false;
	    };
	    LLRBEmptyNode.prototype.minKey = function () {
	        return null;
	    };
	    LLRBEmptyNode.prototype.maxKey = function () {
	        return null;
	    };
	    LLRBEmptyNode.prototype.isRed = function () {
	        return false;
	    };
	    // For testing.
	    LLRBEmptyNode.prototype.checkMaxDepth = function () {
	        return true;
	    };
	    LLRBEmptyNode.prototype.check = function () {
	        return 0;
	    };
	    return LLRBEmptyNode;
	}()); // end LLRBEmptyNode
	exports.LLRBEmptyNode = LLRBEmptyNode;
	LLRBNode.EMPTY = new LLRBEmptyNode();
	
	//# sourceMappingURL=sorted_map.js.map


/***/ },
/* 51 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @fileoverview Implements the promise abstraction interface for external
	 * (public SDK) packaging, which just passes through to the firebase-app impl.
	 */
	/**
	 * @template T
	 * @param {function((function(T): void),
	 *                  (function(!Error): void))} resolver
	 */
	function make(resolver) {
	    return new Promise(resolver);
	}
	exports.make = make;
	/**
	 * @template T
	 */
	function resolve(value) {
	    return Promise.resolve(value);
	}
	exports.resolve = resolve;
	function reject(error) {
	    return Promise.reject(error);
	}
	exports.reject = reject;
	
	//# sourceMappingURL=promise_external.js.map


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/arrow-forward.57bc4a1b.svg";

/***/ },
/* 53 */
[855, 14],
/* 54 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @constructor
	 * @struct
	 * @param {!string} type The event type
	 * @param {!Node} snapshotNode The data
	 * @param {string=} childName The name for this child, if it's a child event
	 * @param {Node=} oldSnap Used for intermediate processing of child changed events
	 * @param {string=} prevName The name for the previous child, if applicable
	 */
	var Change = /** @class */ (function () {
	    function Change(type, snapshotNode, childName, oldSnap, prevName) {
	        this.type = type;
	        this.snapshotNode = snapshotNode;
	        this.childName = childName;
	        this.oldSnap = oldSnap;
	        this.prevName = prevName;
	    }
	    /**
	     * @param {!Node} snapshot
	     * @return {!Change}
	     */
	    Change.valueChange = function (snapshot) {
	        return new Change(Change.VALUE, snapshot);
	    };
	    /**
	     * @param {string} childKey
	     * @param {!Node} snapshot
	     * @return {!Change}
	     */
	    Change.childAddedChange = function (childKey, snapshot) {
	        return new Change(Change.CHILD_ADDED, snapshot, childKey);
	    };
	    /**
	     * @param {string} childKey
	     * @param {!Node} snapshot
	     * @return {!Change}
	     */
	    Change.childRemovedChange = function (childKey, snapshot) {
	        return new Change(Change.CHILD_REMOVED, snapshot, childKey);
	    };
	    /**
	     * @param {string} childKey
	     * @param {!Node} newSnapshot
	     * @param {!Node} oldSnapshot
	     * @return {!Change}
	     */
	    Change.childChangedChange = function (childKey, newSnapshot, oldSnapshot) {
	        return new Change(Change.CHILD_CHANGED, newSnapshot, childKey, oldSnapshot);
	    };
	    /**
	     * @param {string} childKey
	     * @param {!Node} snapshot
	     * @return {!Change}
	     */
	    Change.childMovedChange = function (childKey, snapshot) {
	        return new Change(Change.CHILD_MOVED, snapshot, childKey);
	    };
	    //event types
	    /** Event type for a child added */
	    Change.CHILD_ADDED = 'child_added';
	    /** Event type for a child removed */
	    Change.CHILD_REMOVED = 'child_removed';
	    /** Event type for a child changed */
	    Change.CHILD_CHANGED = 'child_changed';
	    /** Event type for a child moved */
	    Change.CHILD_MOVED = 'child_moved';
	    /** Event type for a value change */
	    Change.VALUE = 'value';
	    return Change;
	}());
	exports.Change = Change;
	
	//# sourceMappingURL=Change.js.map


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(10);
	var misc_1 = __webpack_require__(25);
	// A RegExp matching ISO 8601 UTC timestamps with optional fraction.
	var isoRegExp = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
	var Timestamp = /** @class */ (function () {
	    function Timestamp(seconds, nanos) {
	        this.seconds = seconds;
	        this.nanos = nanos;
	        assert_1.assert(nanos >= 0, 'timestamp nanoseconds out of range: ' + nanos);
	        assert_1.assert(nanos < 1e9, 'timestamp nanoseconds out of range' + nanos);
	        // Midnight at the beginning of 1/1/1 is the earliest Firestore supports.
	        assert_1.assert(seconds >= -62135596800, 'timestamp seconds out of range: ' + seconds);
	        // This will break in the year 10,000.
	        assert_1.assert(seconds < 253402300800, 'timestamp seconds out of range' + seconds);
	    }
	    Timestamp.now = function () {
	        return Timestamp.fromEpochMilliseconds(Date.now());
	    };
	    Timestamp.fromDate = function (date) {
	        return Timestamp.fromEpochMilliseconds(date.getTime());
	    };
	    Timestamp.fromEpochMilliseconds = function (milliseconds) {
	        var seconds = Math.floor(milliseconds / 1000);
	        var nanos = (milliseconds - seconds * 1000) * 1e6;
	        return new Timestamp(seconds, nanos);
	    };
	    Timestamp.fromISOString = function (utc) {
	        // The date string can have higher precision (nanos) than the Date class
	        // (millis), so we do some custom parsing here.
	        // Parse the nanos right out of the string.
	        var nanos = 0;
	        var fraction = isoRegExp.exec(utc);
	        assert_1.assert(!!fraction, 'invalid timestamp: ' + utc);
	        if (fraction[1]) {
	            // Pad the fraction out to 9 digits (nanos).
	            var nanoStr = fraction[1];
	            nanoStr = (nanoStr + '000000000').substr(0, 9);
	            nanos = parseInt(nanoStr, 10);
	        }
	        // Parse the date to get the seconds.
	        var date = new Date(utc);
	        var seconds = Math.floor(date.getTime() / 1000);
	        return new Timestamp(seconds, nanos);
	    };
	    Timestamp.prototype.toDate = function () {
	        return new Date(this.toEpochMilliseconds());
	    };
	    Timestamp.prototype.toEpochMilliseconds = function () {
	        return this.seconds * 1000 + this.nanos / 1e6;
	    };
	    Timestamp.prototype.compareTo = function (other) {
	        if (this.seconds === other.seconds) {
	            return misc_1.primitiveComparator(this.nanos, other.nanos);
	        }
	        return misc_1.primitiveComparator(this.seconds, other.seconds);
	    };
	    Timestamp.prototype.equals = function (other) {
	        return other.seconds === this.seconds && other.nanos === this.nanos;
	    };
	    Timestamp.prototype.toString = function () {
	        return 'Timestamp(seconds=' + this.seconds + ', nanos=' + this.nanos + ')';
	    };
	    return Timestamp;
	}());
	exports.Timestamp = Timestamp;
	
	//# sourceMappingURL=timestamp.js.map


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(10);
	var encoded_resource_path_1 = __webpack_require__(126);
	exports.SCHEMA_VERSION = 1;
	/** Performs database creation and (in the future) upgrades between versions. */
	function createOrUpgradeDb(db, oldVersion) {
	    assert_1.assert(oldVersion === 0, 'Unexpected upgrade from version ' + oldVersion);
	    db.createObjectStore(DbMutationQueue.store, {
	        keyPath: DbMutationQueue.keyPath
	    });
	    // TODO(mikelehen): Get rid of "as any" if/when TypeScript fixes their
	    // types. https://github.com/Microsoft/TypeScript/issues/14322
	    db.createObjectStore(
	    // tslint:disable-next-line:no-any
	    DbMutationBatch.store, { keyPath: DbMutationBatch.keyPath });
	    var targetDocumentsStore = db.createObjectStore(
	    // tslint:disable-next-line:no-any
	    DbTargetDocument.store, { keyPath: DbTargetDocument.keyPath });
	    targetDocumentsStore.createIndex(DbTargetDocument.documentTargetsIndex, DbTargetDocument.documentTargetsKeyPath, { unique: true });
	    var targetStore = db.createObjectStore(DbTarget.store, {
	        keyPath: DbTarget.keyPath
	    });
	    // NOTE: This is unique only because the TargetId is the suffix.
	    targetStore.createIndex(DbTarget.queryTargetsIndexName, DbTarget.queryTargetsKeyPath, { unique: true });
	    // NOTE: keys for these stores are specified explicitly rather than using a
	    // keyPath.
	    db.createObjectStore(DbDocumentMutation.store);
	    db.createObjectStore(DbRemoteDocument.store);
	    db.createObjectStore(DbOwner.store);
	    db.createObjectStore(DbTargetGlobal.store);
	}
	exports.createOrUpgradeDb = createOrUpgradeDb;
	/**
	 * Wrapper class to store timestamps (seconds and nanos) in IndexedDb objects.
	 */
	var DbTimestamp = /** @class */ (function () {
	    function DbTimestamp(seconds, nanos) {
	        this.seconds = seconds;
	        this.nanos = nanos;
	    }
	    return DbTimestamp;
	}());
	exports.DbTimestamp = DbTimestamp;
	/**
	 * A singleton object to be stored in the 'owner' store in IndexedDb.
	 *
	 * A given database can be owned by a single tab at a given time. That tab
	 * must validate that it is still the owner before every write operation and
	 * should regularly write an updated timestamp to prevent other tabs from
	 * "stealing" ownership of the db.
	 */
	var DbOwner = /** @class */ (function () {
	    function DbOwner(ownerId, leaseTimestampMs) {
	        this.ownerId = ownerId;
	        this.leaseTimestampMs = leaseTimestampMs;
	    }
	    /** Name of the IndexedDb object store. */
	    DbOwner.store = 'owner';
	    return DbOwner;
	}());
	exports.DbOwner = DbOwner;
	/**
	 * An object to be stored in the 'mutationQueues' store in IndexedDb.
	 *
	 * Each user gets a single queue of MutationBatches to apply to the server.
	 * DbMutationQueue tracks the metadata about the queue.
	 */
	var DbMutationQueue = /** @class */ (function () {
	    function DbMutationQueue(
	        /**
	         * The normalized user ID to which this queue belongs.
	         */
	        userId, 
	        /**
	         * An identifier for the highest numbered batch that has been acknowledged
	         * by the server. All MutationBatches in this queue with batchIds less
	         * than or equal to this value are considered to have been acknowledged by
	         * the server.
	         */
	        lastAcknowledgedBatchId, 
	        /**
	         * A stream token that was previously sent by the server.
	         *
	         * See StreamingWriteRequest in datastore.proto for more details about
	         * usage.
	         *
	         * After sending this token, earlier tokens may not be used anymore so
	         * only a single stream token is retained.
	         */
	        lastStreamToken) {
	        this.userId = userId;
	        this.lastAcknowledgedBatchId = lastAcknowledgedBatchId;
	        this.lastStreamToken = lastStreamToken;
	    }
	    /** Name of the IndexedDb object store.  */
	    DbMutationQueue.store = 'mutationQueues';
	    /** Keys are automatically assigned via the userId property. */
	    DbMutationQueue.keyPath = 'userId';
	    return DbMutationQueue;
	}());
	exports.DbMutationQueue = DbMutationQueue;
	/**
	 * An object to be stored in the 'mutations' store in IndexedDb.
	 *
	 * Represents a batch of user-level mutations intended to be sent to the server
	 * in a single write. Each user-level batch gets a separate DbMutationBatch
	 * with a new batchId.
	 */
	var DbMutationBatch = /** @class */ (function () {
	    function DbMutationBatch(
	        /**
	         * The normalized user ID to which this batch belongs.
	         */
	        userId, 
	        /**
	         * An identifier for this batch, allocated by the mutation queue in a
	         * monotonically increasing manner.
	         */
	        batchId, 
	        /**
	         * The local write time of the batch, stored as milliseconds since the
	         * epoch.
	         */
	        localWriteTimeMs, 
	        /**
	         * A list of mutations to apply. All mutations will be applied atomically.
	         *
	         * Mutations are serialized via JsonProtoSerializer.toMutation().
	         */
	        mutations) {
	        this.userId = userId;
	        this.batchId = batchId;
	        this.localWriteTimeMs = localWriteTimeMs;
	        this.mutations = mutations;
	    }
	    /** Name of the IndexedDb object store.  */
	    DbMutationBatch.store = 'mutations';
	    /** Keys are automatically assigned via the userId, batchId properties. */
	    DbMutationBatch.keyPath = ['userId', 'batchId'];
	    return DbMutationBatch;
	}());
	exports.DbMutationBatch = DbMutationBatch;
	/**
	 * An object to be stored in the 'documentMutations' store in IndexedDb.
	 *
	 * A manually maintained index of all the mutation batches that affect a given
	 * document key. The rows in this table are references based on the contents of
	 * DbMutationBatch.mutations.
	 */
	var DbDocumentMutation = /** @class */ (function () {
	    function DbDocumentMutation() {
	    }
	    /**
	     * Creates a [userId] key for use in the DbDocumentMutations index to iterate
	     * over all of a user's document mutations.
	     */
	    DbDocumentMutation.prefixForUser = function (userId) {
	        return [userId];
	    };
	    /**
	     * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
	     * index to iterate over all at document mutations for a given path or lower.
	     */
	    DbDocumentMutation.prefixForPath = function (userId, path) {
	        return [userId, encoded_resource_path_1.encode(path)];
	    };
	    /**
	     * Creates a full index key of [userId, encodedPath, batchId] for inserting
	     * and deleting into the DbDocumentMutations index.
	     */
	    DbDocumentMutation.key = function (userId, path, batchId) {
	        return [userId, encoded_resource_path_1.encode(path), batchId];
	    };
	    DbDocumentMutation.store = 'documentMutations';
	    /**
	     * Because we store all the useful information for this store in the key,
	     * there is no useful information to store as the value. The raw (unencoded)
	     * path cannot be stored because IndexedDb doesn't store prototype
	     * information.
	     */
	    DbDocumentMutation.PLACEHOLDER = new DbDocumentMutation();
	    return DbDocumentMutation;
	}());
	exports.DbDocumentMutation = DbDocumentMutation;
	/**
	 * Represents the known absence of a document at a particular version.
	 * Stored in IndexedDb as part of a DbRemoteDocument object.
	 */
	var DbNoDocument = /** @class */ (function () {
	    function DbNoDocument(path, readTime) {
	        this.path = path;
	        this.readTime = readTime;
	    }
	    return DbNoDocument;
	}());
	exports.DbNoDocument = DbNoDocument;
	/**
	 * An object to be stored in the 'remoteDocuments' store in IndexedDb. It
	 * represents either a cached document (if it exists) or a cached "no-document"
	 * (if it is known to not exist).
	 *
	 * Note: This is the persisted equivalent of a MaybeDocument and could perhaps
	 * be made more general if necessary.
	 */
	var DbRemoteDocument = /** @class */ (function () {
	    function DbRemoteDocument(
	        /**
	         * Set to an instance of a DbNoDocument if it is known that no document
	         * exists.
	         */
	        noDocument, 
	        /**
	         * Set to an instance of a Document if there's a cached version of the
	         * document.
	         */
	        document) {
	        this.noDocument = noDocument;
	        this.document = document;
	    }
	    DbRemoteDocument.store = 'remoteDocuments';
	    return DbRemoteDocument;
	}());
	exports.DbRemoteDocument = DbRemoteDocument;
	/**
	 * An object to be stored in the 'targets' store in IndexedDb.
	 *
	 * This is based on and should be kept in sync with the proto used in the iOS
	 * client.
	 *
	 * Each query the client listens to against the server is tracked on disk so
	 * that the query can be efficiently resumed on restart.
	 */
	var DbTarget = /** @class */ (function () {
	    function DbTarget(
	        /**
	         * An auto-generated sequential numeric identifier for the query.
	         *
	         * Queries are stored using their canonicalId as the key, but these
	         * canonicalIds can be quite long so we additionally assign a unique
	         * queryId which can be used by referenced data structures (e.g.
	         * indexes) to minimize the on-disk cost.
	         */
	        targetId, 
	        /**
	         * The canonical string representing this query. This is not unique.
	         */
	        canonicalId, 
	        /**
	         * The last readTime received from the Watch Service for this query.
	         *
	         * This is the same value as TargetChange.read_time in the protos.
	         */
	        readTime, 
	        /**
	         * An opaque, server-assigned token that allows watching a query to be
	         * resumed after disconnecting without retransmitting all the data
	         * that matches the query. The resume token essentially identifies a
	         * point in time from which the server should resume sending results.
	         *
	         * This is related to the snapshotVersion in that the resumeToken
	         * effectively also encodes that value, but the resumeToken is opaque
	         * and sometimes encodes additional information.
	         *
	         * A consequence of this is that the resumeToken should be used when
	         * asking the server to reason about where this client is in the watch
	         * stream, but the client should use the snapshotVersion for its own
	         * purposes.
	         *
	         * This is the same value as TargetChange.resume_token in the protos.
	         */
	        resumeToken, 
	        /**
	         * A sequence number representing the last time this query was
	         * listened to, used for garbage collection purposes.
	         *
	         * Conventionally this would be a timestamp value, but device-local
	         * clocks are unreliable and they must be able to create new listens
	         * even while disconnected. Instead this should be a monotonically
	         * increasing number that's incremented on each listen call.
	         *
	         * This is different from the queryId since the queryId is an
	         * immutable identifier assigned to the Query on first use while
	         * lastListenSequenceNumber is updated every time the query is
	         * listened to.
	         */
	        lastListenSequenceNumber, 
	        /**
	         * The query for this target.
	         *
	         * Because canonical ids are not unique we must store the actual query. We
	         * use the proto to have an object we can persist without having to
	         * duplicate translation logic to and from a `Query` object.
	         */
	        query) {
	        this.targetId = targetId;
	        this.canonicalId = canonicalId;
	        this.readTime = readTime;
	        this.resumeToken = resumeToken;
	        this.lastListenSequenceNumber = lastListenSequenceNumber;
	        this.query = query;
	    }
	    DbTarget.store = 'targets';
	    /** Keys are automatically assigned via the targetId property. */
	    DbTarget.keyPath = 'targetId';
	    /** The name of the queryTargets index. */
	    DbTarget.queryTargetsIndexName = 'queryTargetsIndex';
	    /**
	     * The index of all canonicalIds to the targets that they match. This is not
	     * a unique mapping because canonicalId does not promise a unique name for all
	     * possible queries, so we append the targetId to make the mapping unique.
	     */
	    DbTarget.queryTargetsKeyPath = ['canonicalId', 'targetId'];
	    return DbTarget;
	}());
	exports.DbTarget = DbTarget;
	/**
	 * An object representing an association between a target and a document.
	 * Stored in the targetDocument object store to store the documents tracked by a
	 * particular target.
	 */
	var DbTargetDocument = /** @class */ (function () {
	    function DbTargetDocument(
	        /**
	         * The targetId identifying a target.
	         */
	        targetId, 
	        /**
	         * The path to the document, as encoded in the key.
	         */
	        path) {
	        this.targetId = targetId;
	        this.path = path;
	    }
	    /** Name of the IndexedDb object store.  */
	    DbTargetDocument.store = 'targetDocuments';
	    /** Keys are automatically assigned via the targetId, path properties. */
	    DbTargetDocument.keyPath = ['targetId', 'path'];
	    /** The index name for the reverse index. */
	    DbTargetDocument.documentTargetsIndex = 'documentTargetsIndex';
	    /** We also need to create the reverse index for these properties. */
	    DbTargetDocument.documentTargetsKeyPath = ['path', 'targetId'];
	    return DbTargetDocument;
	}());
	exports.DbTargetDocument = DbTargetDocument;
	/**
	 * A record of global state tracked across all Targets, tracked separately
	 * to avoid the need for extra indexes.
	 *
	 * This should be kept in-sync with the proto used in the iOS client.
	 */
	var DbTargetGlobal = /** @class */ (function () {
	    function DbTargetGlobal(
	        /**
	         * The highest numbered target id across all targets.
	         *
	         * See DbTarget.targetId.
	         */
	        highestTargetId, 
	        /**
	         * The highest numbered lastListenSequenceNumber across all targets.
	         *
	         * See DbTarget.lastListenSequenceNumber.
	         */
	        highestListenSequenceNumber, 
	        /**
	         * A global snapshot version representing the last consistent snapshot we
	         * received from the backend. This is monotonically increasing and any
	         * snapshots received from the backend prior to this version (e.g. for
	         * targets resumed with a resumeToken) should be suppressed (buffered)
	         * until the backend has caught up to this snapshot version again. This
	         * prevents our cache from ever going backwards in time.
	         */
	        lastRemoteSnapshotVersion) {
	        this.highestTargetId = highestTargetId;
	        this.highestListenSequenceNumber = highestListenSequenceNumber;
	        this.lastRemoteSnapshotVersion = lastRemoteSnapshotVersion;
	    }
	    /**
	     * The key string used for the single object that exists in the
	     * DbTargetGlobal store.
	     */
	    DbTargetGlobal.key = 'targetGlobalKey';
	    DbTargetGlobal.store = 'targetGlobal';
	    return DbTargetGlobal;
	}());
	exports.DbTargetGlobal = DbTargetGlobal;
	/**
	 * The list of all IndexedDB stored used by the SDK. This is used when creating
	 * transactions so that access across all stores is done atomically.
	 */
	exports.ALL_STORES = [
	    DbMutationQueue.store,
	    DbMutationBatch.store,
	    DbDocumentMutation.store,
	    DbRemoteDocument.store,
	    DbTarget.store,
	    DbOwner.store,
	    DbTargetGlobal.store,
	    DbTargetDocument.store
	];
	
	//# sourceMappingURL=indexeddb_schema.js.map


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(10);
	var misc_1 = __webpack_require__(25);
	var sorted_map_1 = __webpack_require__(50);
	var document_key_1 = __webpack_require__(22);
	var TypeOrder;
	(function (TypeOrder) {
	    // This order is defined by the backend.
	    TypeOrder[TypeOrder["NullValue"] = 0] = "NullValue";
	    TypeOrder[TypeOrder["BooleanValue"] = 1] = "BooleanValue";
	    TypeOrder[TypeOrder["NumberValue"] = 2] = "NumberValue";
	    TypeOrder[TypeOrder["TimestampValue"] = 3] = "TimestampValue";
	    TypeOrder[TypeOrder["StringValue"] = 4] = "StringValue";
	    TypeOrder[TypeOrder["BlobValue"] = 5] = "BlobValue";
	    TypeOrder[TypeOrder["RefValue"] = 6] = "RefValue";
	    TypeOrder[TypeOrder["GeoPointValue"] = 7] = "GeoPointValue";
	    TypeOrder[TypeOrder["ArrayValue"] = 8] = "ArrayValue";
	    TypeOrder[TypeOrder["ObjectValue"] = 9] = "ObjectValue";
	})(TypeOrder = exports.TypeOrder || (exports.TypeOrder = {}));
	/**
	 * A field value represents a datatype as stored by Firestore.
	 */
	var FieldValue = /** @class */ (function () {
	    function FieldValue() {
	    }
	    FieldValue.prototype.toString = function () {
	        var val = this.value();
	        return val === null ? 'null' : val.toString();
	    };
	    FieldValue.prototype.defaultCompareTo = function (other) {
	        assert_1.assert(this.typeOrder !== other.typeOrder, 'Default compareTo should not be used for values of same type.');
	        var cmp = misc_1.primitiveComparator(this.typeOrder, other.typeOrder);
	        return cmp;
	    };
	    return FieldValue;
	}());
	exports.FieldValue = FieldValue;
	var NullValue = /** @class */ (function (_super) {
	    __extends(NullValue, _super);
	    function NullValue() {
	        var _this = _super.call(this) || this;
	        _this.typeOrder = TypeOrder.NullValue;
	        // internalValue is unused but we add it to work around
	        // https://github.com/Microsoft/TypeScript/issues/15585
	        _this.internalValue = null;
	        return _this;
	    }
	    NullValue.prototype.value = function () {
	        return null;
	    };
	    NullValue.prototype.equals = function (other) {
	        return other instanceof NullValue;
	    };
	    NullValue.prototype.compareTo = function (other) {
	        if (other instanceof NullValue) {
	            return 0;
	        }
	        return this.defaultCompareTo(other);
	    };
	    NullValue.INSTANCE = new NullValue();
	    return NullValue;
	}(FieldValue));
	exports.NullValue = NullValue;
	var BooleanValue = /** @class */ (function (_super) {
	    __extends(BooleanValue, _super);
	    function BooleanValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.BooleanValue;
	        return _this;
	    }
	    BooleanValue.prototype.value = function () {
	        return this.internalValue;
	    };
	    BooleanValue.prototype.equals = function (other) {
	        return (other instanceof BooleanValue &&
	            this.internalValue === other.internalValue);
	    };
	    BooleanValue.prototype.compareTo = function (other) {
	        if (other instanceof BooleanValue) {
	            return misc_1.primitiveComparator(this, other);
	        }
	        return this.defaultCompareTo(other);
	    };
	    BooleanValue.of = function (value) {
	        return value ? BooleanValue.TRUE : BooleanValue.FALSE;
	    };
	    BooleanValue.TRUE = new BooleanValue(true);
	    BooleanValue.FALSE = new BooleanValue(false);
	    return BooleanValue;
	}(FieldValue));
	exports.BooleanValue = BooleanValue;
	/** Base class for IntegerValue and DoubleValue. */
	var NumberValue = /** @class */ (function (_super) {
	    __extends(NumberValue, _super);
	    function NumberValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.NumberValue;
	        return _this;
	    }
	    NumberValue.prototype.value = function () {
	        return this.internalValue;
	    };
	    NumberValue.prototype.compareTo = function (other) {
	        if (other instanceof NumberValue) {
	            return numericComparator(this.internalValue, other.internalValue);
	        }
	        return this.defaultCompareTo(other);
	    };
	    return NumberValue;
	}(FieldValue));
	exports.NumberValue = NumberValue;
	/** Utility function to compare doubles (using Firestore semantics for NaN). */
	function numericComparator(left, right) {
	    if (left < right) {
	        return -1;
	    }
	    else if (left > right) {
	        return 1;
	    }
	    else if (left === right) {
	        return 0;
	    }
	    else {
	        // one or both are NaN.
	        if (isNaN(left)) {
	            return isNaN(right) ? 0 : -1;
	        }
	        else {
	            return 1;
	        }
	    }
	}
	/**
	 * Utility function to check numbers for equality using Firestore semantics
	 * (NaN === NaN, -0.0 !== 0.0).
	 */
	function numericEquals(left, right) {
	    // Implemented based on Object.is() polyfill from
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	    if (left === right) {
	        // +0 != -0
	        return left !== 0 || 1 / left === 1 / right;
	    }
	    else {
	        // NaN == NaN
	        return left !== left && right !== right;
	    }
	}
	var IntegerValue = /** @class */ (function (_super) {
	    __extends(IntegerValue, _super);
	    function IntegerValue(internalValue) {
	        return _super.call(this, internalValue) || this;
	    }
	    IntegerValue.prototype.equals = function (other) {
	        // NOTE: DoubleValue and IntegerValue instances may compareTo() the same,
	        // but that doesn't make them equal via equals().
	        if (other instanceof IntegerValue) {
	            return numericEquals(this.internalValue, other.internalValue);
	        }
	        else {
	            return false;
	        }
	    };
	    return IntegerValue;
	}(NumberValue));
	exports.IntegerValue = IntegerValue;
	var DoubleValue = /** @class */ (function (_super) {
	    __extends(DoubleValue, _super);
	    function DoubleValue(internalValue) {
	        var _this = _super.call(this, internalValue) || this;
	        _this.internalValue = internalValue;
	        return _this;
	    }
	    DoubleValue.prototype.equals = function (other) {
	        // NOTE: DoubleValue and IntegerValue instances may compareTo() the same,
	        // but that doesn't make them equal via equals().
	        if (other instanceof DoubleValue) {
	            return numericEquals(this.internalValue, other.internalValue);
	        }
	        else {
	            return false;
	        }
	    };
	    DoubleValue.NAN = new DoubleValue(NaN);
	    DoubleValue.POSITIVE_INFINITY = new DoubleValue(Infinity);
	    DoubleValue.NEGATIVE_INFINITY = new DoubleValue(-Infinity);
	    return DoubleValue;
	}(NumberValue));
	exports.DoubleValue = DoubleValue;
	// TODO(b/37267885): Add truncation support
	var StringValue = /** @class */ (function (_super) {
	    __extends(StringValue, _super);
	    function StringValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.StringValue;
	        return _this;
	    }
	    StringValue.prototype.value = function () {
	        return this.internalValue;
	    };
	    StringValue.prototype.equals = function (other) {
	        return (other instanceof StringValue && this.internalValue === other.internalValue);
	    };
	    StringValue.prototype.compareTo = function (other) {
	        if (other instanceof StringValue) {
	            return misc_1.primitiveComparator(this.internalValue, other.internalValue);
	        }
	        return this.defaultCompareTo(other);
	    };
	    return StringValue;
	}(FieldValue));
	exports.StringValue = StringValue;
	var TimestampValue = /** @class */ (function (_super) {
	    __extends(TimestampValue, _super);
	    function TimestampValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.TimestampValue;
	        return _this;
	    }
	    TimestampValue.prototype.value = function () {
	        return this.internalValue.toDate();
	    };
	    TimestampValue.prototype.equals = function (other) {
	        return (other instanceof TimestampValue &&
	            this.internalValue.equals(other.internalValue));
	    };
	    TimestampValue.prototype.compareTo = function (other) {
	        if (other instanceof TimestampValue) {
	            return this.internalValue.compareTo(other.internalValue);
	        }
	        else if (other instanceof ServerTimestampValue) {
	            // Concrete timestamps come before server timestamps.
	            return -1;
	        }
	        else {
	            return this.defaultCompareTo(other);
	        }
	    };
	    return TimestampValue;
	}(FieldValue));
	exports.TimestampValue = TimestampValue;
	/**
	 * Represents a locally-applied ServerTimestamp.
	 *
	 * Notes:
	 * - ServerTimestampValue instances are created as the result of applying a
	 *   TransformMutation (see TransformMutation.applyTo()). They can only exist in
	 *   the local view of a document. Therefore they do not need to be parsed or
	 *   serialized.
	 * - When evaluated locally (e.g. for snapshot.data()), they evaluate to null.
	 * - With respect to other ServerTimestampValues, they sort by their
	 *   localWriteTime.
	 */
	var ServerTimestampValue = /** @class */ (function (_super) {
	    __extends(ServerTimestampValue, _super);
	    function ServerTimestampValue(localWriteTime) {
	        var _this = _super.call(this) || this;
	        _this.localWriteTime = localWriteTime;
	        _this.typeOrder = TypeOrder.TimestampValue;
	        return _this;
	    }
	    ServerTimestampValue.prototype.value = function () {
	        return null;
	    };
	    ServerTimestampValue.prototype.equals = function (other) {
	        return (other instanceof ServerTimestampValue &&
	            this.localWriteTime.equals(other.localWriteTime));
	    };
	    ServerTimestampValue.prototype.compareTo = function (other) {
	        if (other instanceof ServerTimestampValue) {
	            return this.localWriteTime.compareTo(other.localWriteTime);
	        }
	        else if (other instanceof TimestampValue) {
	            // Server timestamps come after all concrete timestamps.
	            return 1;
	        }
	        else {
	            return this.defaultCompareTo(other);
	        }
	    };
	    ServerTimestampValue.prototype.toString = function () {
	        return '<ServerTimestamp localTime=' + this.localWriteTime.toString() + '>';
	    };
	    return ServerTimestampValue;
	}(FieldValue));
	exports.ServerTimestampValue = ServerTimestampValue;
	var BlobValue = /** @class */ (function (_super) {
	    __extends(BlobValue, _super);
	    function BlobValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.BlobValue;
	        return _this;
	    }
	    BlobValue.prototype.value = function () {
	        return this.internalValue;
	    };
	    BlobValue.prototype.equals = function (other) {
	        return (other instanceof BlobValue &&
	            this.internalValue._equals(other.internalValue));
	    };
	    BlobValue.prototype.compareTo = function (other) {
	        if (other instanceof BlobValue) {
	            return this.internalValue._compareTo(other.internalValue);
	        }
	        return this.defaultCompareTo(other);
	    };
	    return BlobValue;
	}(FieldValue));
	exports.BlobValue = BlobValue;
	var RefValue = /** @class */ (function (_super) {
	    __extends(RefValue, _super);
	    function RefValue(databaseId, key) {
	        var _this = _super.call(this) || this;
	        _this.databaseId = databaseId;
	        _this.key = key;
	        _this.typeOrder = TypeOrder.RefValue;
	        return _this;
	    }
	    RefValue.prototype.value = function () {
	        return this.key;
	    };
	    RefValue.prototype.equals = function (other) {
	        if (other instanceof RefValue) {
	            return (this.key.equals(other.key) && this.databaseId.equals(other.databaseId));
	        }
	        else {
	            return false;
	        }
	    };
	    RefValue.prototype.compareTo = function (other) {
	        if (other instanceof RefValue) {
	            var cmp = this.databaseId.compareTo(other.databaseId);
	            return cmp !== 0 ? cmp : document_key_1.DocumentKey.comparator(this.key, other.key);
	        }
	        return this.defaultCompareTo(other);
	    };
	    return RefValue;
	}(FieldValue));
	exports.RefValue = RefValue;
	var GeoPointValue = /** @class */ (function (_super) {
	    __extends(GeoPointValue, _super);
	    function GeoPointValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.GeoPointValue;
	        return _this;
	    }
	    GeoPointValue.prototype.value = function () {
	        return this.internalValue;
	    };
	    GeoPointValue.prototype.equals = function (other) {
	        return (other instanceof GeoPointValue &&
	            this.internalValue._equals(other.internalValue));
	    };
	    GeoPointValue.prototype.compareTo = function (other) {
	        if (other instanceof GeoPointValue) {
	            return this.internalValue._compareTo(other.internalValue);
	        }
	        return this.defaultCompareTo(other);
	    };
	    return GeoPointValue;
	}(FieldValue));
	exports.GeoPointValue = GeoPointValue;
	var ObjectValue = /** @class */ (function (_super) {
	    __extends(ObjectValue, _super);
	    function ObjectValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.ObjectValue;
	        return _this;
	    }
	    ObjectValue.prototype.value = function () {
	        var result = {};
	        this.internalValue.inorderTraversal(function (key, val) {
	            result[key] = val.value();
	        });
	        return result;
	    };
	    ObjectValue.prototype.forEach = function (action) {
	        this.internalValue.inorderTraversal(action);
	    };
	    ObjectValue.prototype.equals = function (other) {
	        if (other instanceof ObjectValue) {
	            var it1 = this.internalValue.getIterator();
	            var it2 = other.internalValue.getIterator();
	            while (it1.hasNext() && it2.hasNext()) {
	                var next1 = it1.getNext();
	                var next2 = it2.getNext();
	                if (next1.key !== next2.key || !next1.value.equals(next2.value)) {
	                    return false;
	                }
	            }
	            return !it1.hasNext() && !it2.hasNext();
	        }
	        return false;
	    };
	    ObjectValue.prototype.compareTo = function (other) {
	        if (other instanceof ObjectValue) {
	            var it1 = this.internalValue.getIterator();
	            var it2 = other.internalValue.getIterator();
	            while (it1.hasNext() && it2.hasNext()) {
	                var next1 = it1.getNext();
	                var next2 = it2.getNext();
	                var cmp = misc_1.primitiveComparator(next1.key, next2.key) ||
	                    next1.value.compareTo(next2.value);
	                if (cmp) {
	                    return cmp;
	                }
	            }
	            // Only equal if both iterators are exhausted
	            return misc_1.primitiveComparator(it1.hasNext(), it2.hasNext());
	        }
	        else {
	            return this.defaultCompareTo(other);
	        }
	    };
	    ObjectValue.prototype.set = function (path, to) {
	        assert_1.assert(!path.isEmpty(), 'Cannot set field for empty path on ObjectValue');
	        if (path.length === 1) {
	            return this.setChild(path.firstSegment(), to);
	        }
	        else {
	            var child = this.child(path.firstSegment());
	            if (!(child instanceof ObjectValue)) {
	                child = ObjectValue.EMPTY;
	            }
	            var newChild = child.set(path.popFirst(), to);
	            return this.setChild(path.firstSegment(), newChild);
	        }
	    };
	    ObjectValue.prototype.delete = function (path) {
	        assert_1.assert(!path.isEmpty(), 'Cannot delete field for empty path on ObjectValue');
	        if (path.length === 1) {
	            return new ObjectValue(this.internalValue.remove(path.firstSegment()));
	        }
	        else {
	            // nested field
	            var child = this.child(path.firstSegment());
	            if (child instanceof ObjectValue) {
	                var newChild = child.delete(path.popFirst());
	                return new ObjectValue(this.internalValue.insert(path.firstSegment(), newChild));
	            }
	            else {
	                // Don't actually change a primitive value to an object for a delete
	                return this;
	            }
	        }
	    };
	    ObjectValue.prototype.contains = function (path) {
	        return this.field(path) !== undefined;
	    };
	    ObjectValue.prototype.field = function (path) {
	        assert_1.assert(!path.isEmpty(), "Can't get field of empty path");
	        var field = this;
	        path.forEach(function (pathSegment) {
	            if (field instanceof ObjectValue) {
	                field = field.internalValue.get(pathSegment) || undefined;
	            }
	            else {
	                field = undefined;
	            }
	        });
	        return field;
	    };
	    ObjectValue.prototype.toString = function () {
	        return JSON.stringify(this.value());
	    };
	    ObjectValue.prototype.child = function (childName) {
	        return this.internalValue.get(childName) || undefined;
	    };
	    ObjectValue.prototype.setChild = function (childName, value) {
	        return new ObjectValue(this.internalValue.insert(childName, value));
	    };
	    ObjectValue.EMPTY = new ObjectValue(new sorted_map_1.SortedMap(misc_1.primitiveComparator));
	    return ObjectValue;
	}(FieldValue));
	exports.ObjectValue = ObjectValue;
	var ArrayValue = /** @class */ (function (_super) {
	    __extends(ArrayValue, _super);
	    function ArrayValue(internalValue) {
	        var _this = _super.call(this) || this;
	        _this.internalValue = internalValue;
	        _this.typeOrder = TypeOrder.ArrayValue;
	        return _this;
	    }
	    ArrayValue.prototype.value = function () {
	        return this.internalValue.map(function (v) { return v.value(); });
	    };
	    ArrayValue.prototype.forEach = function (action) {
	        this.internalValue.forEach(action);
	    };
	    ArrayValue.prototype.equals = function (other) {
	        if (other instanceof ArrayValue) {
	            if (this.internalValue.length !== other.internalValue.length) {
	                return false;
	            }
	            for (var i = 0; i < this.internalValue.length; i++) {
	                if (!this.internalValue[i].equals(other.internalValue[i])) {
	                    return false;
	                }
	            }
	            return true;
	        }
	        return false;
	    };
	    ArrayValue.prototype.compareTo = function (other) {
	        if (other instanceof ArrayValue) {
	            var minLength = Math.min(this.internalValue.length, other.internalValue.length);
	            for (var i = 0; i < minLength; i++) {
	                var cmp = this.internalValue[i].compareTo(other.internalValue[i]);
	                if (cmp) {
	                    return cmp;
	                }
	            }
	            return misc_1.primitiveComparator(this.internalValue.length, other.internalValue.length);
	        }
	        else {
	            return this.defaultCompareTo(other);
	        }
	    };
	    ArrayValue.prototype.toString = function () {
	        return JSON.stringify(this.value());
	    };
	    return ArrayValue;
	}(FieldValue));
	exports.ArrayValue = ArrayValue;
	
	//# sourceMappingURL=field_value.js.map


/***/ },
/* 58 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @fileoverview Contains methods for working with objects.
	 */
	function contains(obj, prop) {
	    return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	exports.contains = contains;
	function forEach(obj, f) {
	    for (var key in obj) {
	        if (contains(obj, key)) {
	            f(key, obj[key]);
	        }
	    }
	}
	exports.forEach = forEach;
	function clone(obj) {
	    if (obj == null) {
	        return {};
	    }
	    var c = {};
	    forEach(obj, function (key, val) {
	        c[key] = val;
	    });
	    return c;
	}
	exports.clone = clone;
	
	//# sourceMappingURL=object.js.map


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	*  filename: ej2-inputs.umd.min.js
	*  version : 19.4.52
	*  Copyright Syncfusion Inc. 2001 - 2020. All rights reserved.
	*  Use of this code is subject to the terms of our license.
	*  A copy of the current license can be obtained at any time by e-mailing
	*  licensing@syncfusion.com. Any infringement will be prosecuted under
	*  applicable laws. 
	*/
	!function(t,e){ true?e(exports,__webpack_require__(23),__webpack_require__(46),__webpack_require__(136)):"function"==typeof define&&define.amd?define(["exports","@syncfusion/ej2-base","@syncfusion/ej2-popups","@syncfusion/ej2-splitbuttons"],e):e(t.ej={},t.ej2Base,t.ej2Popups,t.ej2Splitbuttons)}(this,function(t,e,i,s){"use strict";function n(){if(e.attributes(this.element,{role:"textbox",autocomplete:"off",autocorrect:"off",autocapitalize:"off",spellcheck:"false","aria-live":"assertive","aria-valuenow":""}),this.mask){for(var t=this.mask.split("]"),i=0;i<t.length;i++)if("\\"===t[i][t[i].length-1]){t[i]=t[i]+"]";for(var s=t[i].split("["),n=0;n<s.length;n++)"\\"===s[n][s[n].length-1]&&(s[n]=s[n]+"["),p.call(this,s[n])}else{if((s=t[i].split("[")).length>1){var a=!1;for(n=0;n<s.length;n++)"\\"===s[n]?(this.customRegExpCollec.push("["),this.hiddenMask+=s[n]+"["):""===s[n]?a=!0:""!==s[n]&&a||n===s.length-1?(this.customRegExpCollec.push("["+s[n]+"]"),this.hiddenMask+=this.promptChar,a=!1):p.call(this,s[n])}else p.call(this,s[0])}if(this.escapeMaskValue=this.hiddenMask,this.promptMask=this.hiddenMask.replace(/[09?LCAa#&]/g,this.promptChar),!e.isNullOrUndefined(this.customCharacters))for(i=0;i<this.promptMask.length;i++)e.isNullOrUndefined(this.customCharacters[this.promptMask[i]])||(this.promptMask=this.promptMask.replace(new RegExp(this.promptMask[i],"g"),this.promptChar));var r=0;if(this.hiddenMask.match(new RegExp(/\\/)))for(i=0;i<this.hiddenMask.length;i++){n=0;i>=1&&(n=i),n-=r=this.hiddenMask.length-this.promptMask.length,i>0&&"\\"!==this.hiddenMask[i-1]&&(">"===this.hiddenMask[i]||"<"===this.hiddenMask[i]||"|"===this.hiddenMask[i])&&(this.promptMask=this.promptMask.substring(0,n)+this.promptMask.substring(i+1-r,this.promptMask.length),this.escapeMaskValue=this.escapeMaskValue.substring(0,n)+this.escapeMaskValue.substring(i+1-r,this.escapeMaskValue.length)),"\\"===this.hiddenMask[i]&&(this.promptMask=this.promptMask.substring(0,n)+this.hiddenMask[i+1]+this.promptMask.substring(i+2-r,this.promptMask.length),this.escapeMaskValue=this.escapeMaskValue.substring(0,n)+this.escapeMaskValue[i+1]+this.escapeMaskValue.substring(i+2-r,this.escapeMaskValue.length))}else this.promptMask=this.promptMask.replace(/[>|<]/g,""),this.escapeMaskValue=this.hiddenMask.replace(/[>|<]/g,"");e.attributes(this.element,{"aria-invalid":"false"})}}function a(){V.call(this,this.promptMask),R.call(this,this.value)}function r(){e.EventHandler.add(this.element,"keydown",S,this),e.EventHandler.add(this.element,"keypress",T,this),e.EventHandler.add(this.element,"keyup",A,this),e.EventHandler.add(this.element,"input",x,this),e.EventHandler.add(this.element,"focus",f,this),e.EventHandler.add(this.element,"blur",y,this),e.EventHandler.add(this.element,"paste",b,this),e.EventHandler.add(this.element,"cut",C,this),e.EventHandler.add(this.element,"drop",E,this),e.EventHandler.add(this.element,"mousedown",m,this),e.EventHandler.add(this.element,"mouseup",v,this),this.enabled&&(o.call(this),this.formElement&&e.EventHandler.add(this.formElement,"reset",d,this))}function l(){e.EventHandler.remove(this.element,"keydown",S),e.EventHandler.remove(this.element,"keypress",T),e.EventHandler.remove(this.element,"keyup",A),e.EventHandler.remove(this.element,"input",x),e.EventHandler.remove(this.element,"focus",f),e.EventHandler.remove(this.element,"blur",y),e.EventHandler.remove(this.element,"paste",b),e.EventHandler.remove(this.element,"cut",C),e.EventHandler.remove(this.element,"mousedown",m),e.EventHandler.remove(this.element,"mouseup",v),this.formElement&&e.EventHandler.remove(this.formElement,"reset",d)}function o(){this.showClearButton&&e.EventHandler.add(this.inputObj.clearButton,"mousedown touchstart",h,this)}function h(t){t.preventDefault(),this.inputObj.clearButton.classList.contains("e-clear-icon-hide")&&!this.inputObj.container.classList.contains("e-static-clear")||(function(t){var e=this.element.value;V.call(this,this.promptMask),this.redoCollec.unshift({value:this.promptMask,startIndex:this.element.selectionStart,endIndex:this.element.selectionEnd}),L.call(this,t,e),this.element.setSelectionRange(0,0)}.call(this,t),this.value="")}function d(){"EJS-MASKEDTEXTBOX"===this.element.tagName?V.call(this,this.promptMask):this.value=this.initInputValue}function c(t){return t.value}function u(t,i){var s="",n=0,a=!1,r=e.isNullOrUndefined(i)?e.isNullOrUndefined(t)||e.isNullOrUndefined(this)?i:t.value:i;if(r!==this.promptMask)for(var l=0;l<this.customRegExpCollec.length;l++)a&&(a=!1),">"!==this.customRegExpCollec[n]&&"<"!==this.customRegExpCollec[n]&&"|"!==this.customRegExpCollec[n]&&"\\"!==this.customRegExpCollec[n]||(--l,a=!0),a||r[l]!==this.promptChar&&!e.isNullOrUndefined(this.customRegExpCollec[n])&&(this._callPasteHandler||!e.isNullOrUndefined(this.regExpCollec[this.customRegExpCollec[n]])||this.customRegExpCollec[n].length>2&&"["===this.customRegExpCollec[n][0]&&"]"===this.customRegExpCollec[n][this.customRegExpCollec[n].length-1]||!e.isNullOrUndefined(this.customCharacters)&&!e.isNullOrUndefined(this.customCharacters[this.customRegExpCollec[n]]))&&""!==r&&(s+=r[l]),++n;return(null===this.mask||""===this.mask&&void 0!==this.value)&&(s=r),s}function p(t){for(var e=0;e<t.length;e++)this.hiddenMask+=t[e],"\\"!==t[e]&&this.customRegExpCollec.push(t[e])}function m(){this.isClicked=!0}function v(){this.isClicked=!1}function f(t){var i=this,s=this.element,n=0,a=u.call(this,s),r=!1,l=!1,o={selectionStart:s.selectionStart,event:t,value:this.value,maskedValue:s.value,container:this.inputObj.container,selectionEnd:s.selectionEnd};if(this.isClicked||g.call(this,o,s),this.mask&&(null!==a&&""!==a||"Always"===this.floatLabelType||null===this.placeholder||""===this.placeholder||(s.value=this.promptMask),setTimeout(function(){if(s.selectionStart===i.promptMask.length||s.value[s.selectionStart]===i.promptChar)r=!0;else for(var t=s.selectionStart;t<i.promptMask.length;t++){if(s.value[t]===i.promptChar){r=!0;break}if(s.value[t]!==i.promptMask[t]){r=!1;break}}}),setTimeout(function(){var t=s.selectionStart-1;if(t===i.promptMask.length-1||s.value[t]===i.promptChar)l=!0;else for(var e=t;e>=0;e--){if(s.value[e]===i.promptChar){l=!0;break}if(s.value[e]!==i.promptMask[e]){l=!1;break}}}),this.isClicked||"Always"!==this.floatLabelType&&(null===a||""===a)&&null!==this.placeholder&&""!==this.placeholder)){for(n=0;n<this.promptMask.length;n++)if(s.value[n]===this.promptChar){setTimeout(function(){(r||l)&&(s.selectionEnd=n,s.selectionStart=n),o={selectionStart:s.selectionStart,event:t,value:i.value,maskedValue:s.value,container:i.inputObj.container,selectionEnd:s.selectionEnd},g.call(i,o,s)});break}e.isNullOrUndefined(s.value.match(this.promptChar))&&(o={selectionStart:s.selectionStart,event:t,value:this.value,maskedValue:s.value,container:this.inputObj.container,selectionEnd:s.selectionEnd},g.call(this,o,s)),this.isClicked=!1}}function g(t,e){this.trigger("focus",t,function(t){e.selectionStart=t.selectionStart,e.selectionEnd=t.selectionEnd})}function y(t){if(this.blurEventArgs={event:t,value:this.value,maskedValue:this.element.value,container:this.inputObj.container},this.trigger("blur",this.blurEventArgs),this.mask&&(this.isFocus=!1,this.placeholder&&this.element.value===this.promptMask&&"Always"!==this.floatLabelType)){V.call(this,"");var i=this.element.parentNode.querySelector(".e-float-text");"Auto"===this.floatLabelType&&!e.isNullOrUndefined(i)&&i.classList.contains(tt)&&e.removeClass([i],tt)}}function b(t){var e=this;if(this.mask&&!this.readonly){var i=this.element.selectionStart,s=this.element.selectionEnd,n=this.element.value;V.call(this,""),this._callPasteHandler=!0,setTimeout(function(){var a=e.element.value.replace(/ /g,"");e.redoCollec.length>0&&e.redoCollec[0].value===e.element.value&&(a=u.call(e,e.element)),V.call(e,n),e.element.selectionStart=i,e.element.selectionEnd=s;var r=0;e.maskKeyPress=!0;do{w.call(e,a[r],!1,null),++r}while(r<a.length);if(e.maskKeyPress=!1,e._callPasteHandler=!1,e.element.value===n){var l=0;e.maskKeyPress=!0;do{w.call(e,a[l],!1,null),++l}while(l<a.length);e.maskKeyPress=!1}else L.call(e,t,n)},1)}}function C(t){var e=this;if(this.mask&&!this.readonly){var i=this.element.value,s=this.element.selectionStart,n=this.element.selectionEnd;this.undoCollec.push({value:this.element.value,startIndex:this.element.selectionStart,endIndex:this.element.selectionEnd});var a=this.element.value.substring(0,s)+this.promptMask.substring(s,n)+this.element.value.substring(n);setTimeout(function(){V.call(e,a),e.element.selectionStart=e.element.selectionEnd=s,e.element.value!==i&&L.call(e,t,null)},0)}}function E(t){t.preventDefault()}function x(t){if(!0!==e.Browser.isIE||""!==this.element.value||"Never"!==this.floatLabelType){if(e.extend(t,{ctrlKey:!1,keyCode:229}),this.mask){if(""===this.element.value&&this.redoCollec.unshift({value:this.promptMask,startIndex:this.element.selectionStart,endIndex:this.element.selectionEnd}),1===this.element.value.length&&(this.element.value=this.element.value+this.promptMask,this.element.setSelectionRange(1,1)),this._callPasteHandler||O.call(this,t),this.element.value.length>this.promptMask.length){var i=this.element.selectionStart,s=this.element.value.length-this.promptMask.length,n=this.element.value.substring(i-s,i);this.maskKeyPress=!1;var a=0;do{w.call(this,n[a],t.ctrlKey,t),++a}while(a<n.length);this.element.value!==this.preEleVal&&L.call(this,t,null)}var r=u.call(this,this.element);this.prevValue=r,this.value=r,""===r&&(V.call(this,this.promptMask),this.element.setSelectionRange(0,0))}}}function S(t){if(this.mask&&!this.readonly){229!==t.keyCode&&(!t.ctrlKey||89!==t.keyCode&&90!==t.keyCode||t.preventDefault(),O.call(this,t));var e=this.element.value;if(t.ctrlKey&&(89===t.keyCode||90===t.keyCode)){var i=void 0;90===t.keyCode&&this.undoCollec.length>0&&e!==this.undoCollec[this.undoCollec.length-1].value?(i=this.undoCollec[this.undoCollec.length-1],this.redoCollec.unshift({value:this.element.value,startIndex:this.element.selectionStart,endIndex:this.element.selectionEnd}),V.call(this,i.value),this.element.selectionStart=i.startIndex,this.element.selectionEnd=i.endIndex,this.undoCollec.splice(this.undoCollec.length-1,1)):89===t.keyCode&&this.redoCollec.length>0&&e!==this.redoCollec[0].value&&(i=this.redoCollec[0],this.undoCollec.push({value:this.element.value,startIndex:this.element.selectionStart,endIndex:this.element.selectionEnd}),V.call(this,i.value),this.element.selectionStart=i.startIndex,this.element.selectionEnd=i.endIndex,this.redoCollec.splice(0,1))}}}function k(){var t,e=this.element.selectionStart,i=this.element.selectionEnd;this.redoCollec.length>0?(t=this.redoCollec[0],V.call(this,t.value),t.startIndex-e==1?(this.element.selectionStart=t.startIndex,this.element.selectionEnd=t.endIndex):(this.element.selectionStart=e+1,this.element.selectionEnd=i+1)):(V.call(this,this.promptMask),this.element.selectionStart=this.element.selectionEnd=e)}function P(t,e,i){return"input"===i.type&&(t=!1,e=this.element.value,V.call(this,this.promptMask),R.call(this,e)),t}function O(t){var i,s=!1,n=!1;this.element.value.length<this.promptMask.length&&(s=!0,i=this.element.value,s=P.call(this,s,i,t),k.call(this)),this.element.value.length>=this.promptMask.length&&"input"===t.type&&(s=P.call(this,s,i,t));var a=this.element.selectionStart,r=this.element.selectionEnd,l=this.element.selectionStart,o=this.element.selectionEnd,h=this.hiddenMask.replace(/[>|\\<]/g,""),d=h[l-1],c=this.element.selectionEnd;if(s||8===t.keyCode||46===t.keyCode){this.undoCollec.push({value:this.element.value,startIndex:this.element.selectionStart,endIndex:o});var u=!1,p=this.element.value;if(l>0||(8===t.keyCode||46===t.keyCode)&&l<this.element.value.length&&this.element.selectionEnd-l!==this.element.value.length){var m=l;l!==o?(l=o,46===t.keyCode&&(u=!0)):46===t.keyCode?++m:--m;for(var v=l;8===t.keyCode||s||u?v>m:v<m;8===t.keyCode||s||u?v--:v++)for(var f=l;8===t.keyCode||s||u?f>0:f<this.element.value.length;8===t.keyCode||s||u?f--:f++){var g=void 0;(8===t.keyCode||u)&&(a!==r&&a!==l||a===r)||s?(d=h[f-1],g=l-1):(d=h[f],g=l,++l);var y=this.element.value[g];if(e.isNullOrUndefined(this.regExpCollec[d])&&!e.isNullOrUndefined(this.customCharacters)&&e.isNullOrUndefined(this.customCharacters[d])&&this.hiddenMask[g]!==this.promptChar&&"["!==this.customRegExpCollec[g][0]&&"]"!==this.customRegExpCollec[g][this.customRegExpCollec[g].length-1]||this.promptMask[g]!==this.promptChar&&e.isNullOrUndefined(this.customCharacters))this.element.selectionStart=this.element.selectionEnd=g,t.preventDefault(),46!==t.keyCode||u||++this.element.selectionStart;else{var b=this.element.value,C=this.promptChar,E=b.substring(0,g)+C+b.substring(l,b.length);V.call(this,E),t.preventDefault(),46!==t.keyCode||u||g++,this.element.selectionStart=this.element.selectionEnd=g,n=!0}if(l=this.element.selectionStart,!n&&8===t.keyCode||u||!n&&46!==t.keyCode?g=l-1:(g=l,n=!1),y=this.element.value[g],a!==r&&this.element.selectionStart===a||this.promptMask[g]===this.promptChar||y!==this.promptMask[g]&&this.promptMask[g]!==this.promptChar&&!e.isNullOrUndefined(this.customCharacters))break}}46===t.keyCode&&u&&n&&(this.element.selectionStart=this.element.selectionEnd=c),0===this.element.selectionStart&&this.element.selectionEnd===this.element.value.length&&(V.call(this,this.promptMask),t.preventDefault(),this.element.selectionStart=this.element.selectionEnd=l),this.redoCollec.unshift({value:this.element.value,startIndex:this.element.selectionStart,endIndex:this.element.selectionEnd}),this.element.value!==p&&L.call(this,t,i)}}function T(t){if(this.mask&&!this.readonly){var e=this.element.value;if(!t.ctrlKey||t.ctrlKey&&"KeyA"!==t.code&&"KeyY"!==t.code&&"KeyZ"!==t.code&&"KeyX"!==t.code&&"KeyC"!==t.code&&"KeyV"!==t.code){this.maskKeyPress=!0;var i=t.key;"Spacebar"===i&&(i=String.fromCharCode(t.keyCode)),i?i&&1===i.length&&(w.call(this,i,t.ctrlKey,t),t.preventDefault()):(this.isIosInvalid=!0,w.call(this,String.fromCharCode(t.keyCode),t.ctrlKey,t),t.preventDefault(),this.isIosInvalid=!1),32===t.keyCode&&" "===i&&" "===this.promptChar&&(this.element.selectionStart=this.element.selectionEnd=this.element.selectionStart-i.length)}this.element.value!==e&&L.call(this,t,e)}}function L(t,i){var s=this.isProtectedOnChange;if(!e.isNullOrUndefined(this.changeEventArgs)&&!this.isInitial){var n={};this.changeEventArgs={value:this.element.value,maskedValue:this.element.value,isInteraction:!1,isInteracted:!1},this.mask&&(this.changeEventArgs.value=u.call(this,this.element)),e.isNullOrUndefined(t)||(this.changeEventArgs.isInteracted=!0,this.changeEventArgs.isInteraction=!0,this.changeEventArgs.event=t),this.isProtectedOnChange=!0,this.value=this.changeEventArgs.value,this.isProtectedOnChange=s,e.merge(n,this.changeEventArgs),this.isAngular&&this.preventChange?this.preventChange=!1:this.trigger("change",n)}this.preEleVal=this.element.value,this.prevValue=u.call(this,this.element),e.attributes(this.element,{"aria-valuenow":this.element.value})}function A(t){if(this.mask&&!this.readonly){var i=void 0;if(this.maskKeyPress||229!==t.keyCode)U.call(this);else{var s=void 0;if(1===this.element.value.length&&(this.element.value=this.element.value+this.promptMask,this.element.setSelectionRange(1,1)),this.element.value.length>this.promptMask.length){var n=this.element.selectionStart,a=this.element.value.length-this.promptMask.length,r=this.element.value.substring(n-a,n);if(this.undoCollec.length>0){i=this.undoCollec[this.undoCollec.length-1];var l=this.element.selectionStart;s=i.value;var o=i.value.substring(l-a,l);i=this.redoCollec[0],r=r.trim();var h=e.Browser.isAndroid&&""===r;h||o===r||i.value.substring(l-a,l)===r?h&&H.call(this,t,l-1,this.element.selectionEnd-1,r,t.ctrlKey,!1):w.call(this,r,t.ctrlKey,t)}else s=this.promptMask,w.call(this,r,t.ctrlKey,t);this.maskKeyPress=!1,L.call(this,t,s)}}var d=u.call(this,this.element);(0!==this.element.selectionStart||this.promptMask!==this.element.value||""!==d||""===d&&this.value!==d)&&(this.prevValue=d,this.value=d)}else L.call(this,t);if(0===this.element.selectionStart&&0===this.element.selectionEnd){var c=this.element;setTimeout(function(){c.setSelectionRange(0,0)},0)}}function N(t){this.maskKeyPress||function(t){if(t.length>1&&this.promptMask.length+t.length<this.element.value.length){var e=this.redoCollec[0].value.substring(0,this.redoCollec[0].startIndex)+t+this.redoCollec[0].value.substring(this.redoCollec[0].startIndex,this.redoCollec[0].value.length);V.call(this,e),this.element.selectionStart=this.element.selectionEnd=this.redoCollec[0].startIndex+t.length}this.element.selectionStart=this.element.selectionStart-t.length,this.element.selectionEnd=this.element.selectionEnd-t.length}.call(this,t)}function w(t,i,s){if(N.call(this,t),!e.isNullOrUndefined(this)&&!e.isNullOrUndefined(t))for(var n,a,r=this.element.selectionStart,l=r,o=!1,h=this.element.value,d=!1,c=!1,u=0;u<t.length;u++){var p=t[u];if(r=this.element.selectionStart,this.maskKeyPress||l!==r||(r+=u),!this.maskKeyPress||r<this.promptMask.length){for(var m=r;m<this.promptMask.length;m++){n=this.escapeMaskValue[r],"\\"===this.hiddenMask[r]&&this.hiddenMask[r+1]===t&&(c=!0),(e.isNullOrUndefined(this.regExpCollec[n])&&(e.isNullOrUndefined(this.customCharacters)||!e.isNullOrUndefined(this.customCharacters)&&e.isNullOrUndefined(this.customCharacters[n]))&&this.hiddenMask[r]!==this.promptChar&&"["!==this.customRegExpCollec[r][0]&&"]"!==this.customRegExpCollec[r][this.customRegExpCollec[r].length-1]||this.promptMask[r]!==this.promptChar&&e.isNullOrUndefined(this.customCharacters)||this.promptChar===n&&this.escapeMaskValue===this.mask)&&(this.element.selectionStart=this.element.selectionEnd=r+1,r=this.element.selectionStart,n=this.hiddenMask[r])}if(e.isNullOrUndefined(this.customCharacters)||e.isNullOrUndefined(this.customCharacters[n]))!e.isNullOrUndefined(this.regExpCollec[n])&&p.match(new RegExp(this.regExpCollec[n]))&&this.promptMask[r]===this.promptChar?o=!0:this.promptMask[r]===this.promptChar&&"["===this.customRegExpCollec[r][0]&&"]"===this.customRegExpCollec[r][this.customRegExpCollec[r].length-1]&&p.match(new RegExp(this.customRegExpCollec[r]))&&(o=!0);else{var v=this.customCharacters[n].split(",");for(m=0;m<v.length;m++)if(p.match(new RegExp("["+v[m]+"]"))){o=!0;break}}if((!this.maskKeyPress||r<this.hiddenMask.length)&&o){if(0===u)if(this.maskKeyPress)this.undoCollec.push({value:h,startIndex:r,endIndex:r});else{var f=this.element.selectionStart,g=this.element.selectionEnd;this.redoCollec.length>0?(a=this.redoCollec[0].value,V.call(this,a),this.undoCollec.push(this.redoCollec[0])):(this.undoCollec.push({value:this.promptMask,startIndex:r,endIndex:r}),a=this.promptMask,V.call(this,a)),this.element.selectionStart=f,this.element.selectionEnd=g}r=this.element.selectionStart,function(t,e,i,s,n){this.hiddenMask.length>this.promptMask.length&&(i=function(t,e){var i,s,n=e,a=0;for(s=0;s<this.hiddenMask.length;s++)if("\\"===this.hiddenMask[s]&&(i=n.substring(0,s)+"\\"+n.substring(s,n.length)),">"!==this.hiddenMask[s]&&"<"!==this.hiddenMask[s]&&"|"!==this.hiddenMask[s]||(this.hiddenMask[s]!==n[s]&&(i=n.substring(0,s)+this.hiddenMask[s]+n.substring(s,n.length)),++a),i){if(i[s]===this.promptChar&&s>this.element.selectionStart||this.element.value.indexOf(this.promptChar)<0&&this.element.selectionStart+a===s){a=0;break}n=i}for(;s>=0&&i;){if(0===s||"\\"!==i[s-1]){if(">"===i[s]){t=t.toUpperCase();break}if("<"===i[s]){t=t.toLowerCase();break}if("|"===i[s])break}--s}return t}.call(this,i,this.element.value));if(!n){var a=this.element.value,r=a.substring(0,e)+i+a.substring(e+1,a.length);V.call(this,r),this.element.selectionStart=this.element.selectionEnd=e+1}}.call(this,s,r,p,a,c),d=!0,u===t.length-1&&this.redoCollec.unshift({value:this.element.value,startIndex:this.element.selectionStart,endIndex:this.element.selectionEnd}),o=!1}else r=this.element.selectionStart,H.call(this,s,r,l,t,i,d);u!==t.length-1||o||(!e.Browser.isAndroid||e.Browser.isAndroid&&r<this.promptMask.length)&&this.redoCollec.unshift({value:this.element.value,startIndex:this.element.selectionStart,endIndex:this.element.selectionEnd})}else 1!==t.length||i||e.isNullOrUndefined(s)||B.call(this)}}function H(t,i,s,n,a,r){if(!this.maskKeyPress){var l=this.element.value;i>=this.promptMask.length?V.call(this,l.substring(0,i)):(s===i?V.call(this,l.substring(0,i)+l.substring(i+1,l.length)):this.promptMask.length===this.element.value.length?V.call(this,l.substring(0,i)+l.substring(i,l.length)):V.call(this,l.substring(0,s)+l.substring(s+1,l.length)),this.element.selectionStart=this.element.selectionEnd=r||this.element.value[s]!==this.promptChar?i:s),B.call(this)}1!==n.length||a||e.isNullOrUndefined(t)||B.call(this)}function B(){var t=this,i=this.element.parentNode,s=200;i.classList.contains(J)||i.classList.contains($)?e.addClass([i],G):e.addClass([this.element],G),!0===this.isIosInvalid&&(s=400),e.attributes(this.element,{"aria-invalid":"true"}),setTimeout(function(){t.maskKeyPress||U.call(t)},s)}function U(){var t=this.element.parentNode;e.isNullOrUndefined(t)||e.removeClass([t],G),e.removeClass([this.element],G),e.attributes(this.element,{"aria-invalid":"false"})}function R(t){if(this.mask&&void 0!==t&&(void 0===this.prevValue||this.prevValue!==t)){if(this.maskKeyPress=!0,V.call(this,this.promptMask),""===t||null===t&&"Never"===this.floatLabelType&&this.placeholder||(this.element.selectionStart=0,this.element.selectionEnd=0),null!==t)for(var i=0;i<t.length;i++)w.call(this,t[i],!1,null);var s=u.call(this,this.element);this.prevValue=s,this.value=s,L.call(this,null,null),this.maskKeyPress=!1;var n=this.element.parentNode.querySelector(".e-float-text");this.element.value===this.promptMask&&"Auto"===this.floatLabelType&&this.placeholder&&!e.isNullOrUndefined(n)&&n.classList.contains(tt)&&!this.isFocus&&(e.removeClass([n],tt),e.addClass([n],et),V.call(this,""))}(null===this.mask||""===this.mask&&void 0!==this.value)&&V.call(this,this.value)}function V(i,s){!this.isFocus&&"Auto"===this.floatLabelType&&this.placeholder&&e.isNullOrUndefined(this.value)&&(i="");var n=u.call(this,s||this.element,i);null===n||""===n?(t.Input.setValue(i,s||this.element,this.floatLabelType,!1),this.showClearButton&&this.inputObj.clearButton.classList.add("e-clear-icon-hide")):t.Input.setValue(i,s||this.element,this.floatLabelType,this.showClearButton)}function F(t){e.addClass([t.element],Q);var i={element:t.element,mask:t.mask,promptMask:"",hiddenMask:"",escapeMaskValue:"",promptChar:t.promptChar?t.promptChar.length>1?t.promptChar=t.promptChar[0]:t.promptChar:"_",value:t.value?t.value:null,regExpCollec:it,customRegExpCollec:[],customCharacters:t.customCharacters,undoCollec:[],redoCollec:[],maskKeyPress:!1,prevValue:""};return n.call(i),i}function M(t){var i;return!e.isNullOrUndefined(t)&&t.element.classList.contains(Q)&&(i=F(t)),i}var I={RTL:"e-rtl",DISABLE:"e-disabled",INPUT:"e-input",TEXTAREA:"e-multi-line-input",INPUTGROUP:"e-input-group",FLOATINPUT:"e-float-input",FLOATLINE:"e-float-line",FLOATTEXT:"e-float-text",CLEARICON:"e-clear-icon",CLEARICONHIDE:"e-clear-icon-hide",LABELTOP:"e-label-top",LABELBOTTOM:"e-label-bottom",NOFLOATLABEL:"e-no-float-label",INPUTCUSTOMTAG:"e-input-custom-tag",FLOATCUSTOMTAG:"e-float-custom-tag"};!function(t){function i(t){s(t.floatLabelType,t.element),t.element.addEventListener("focus",function(){var t=c(this);(t.classList.contains("e-input-group")||t.classList.contains("e-outline")||t.classList.contains("e-filled"))&&t.classList.add("e-input-focus")}),t.element.addEventListener("blur",function(){var t=c(this);(t.classList.contains("e-input-group")||t.classList.contains("e-outline")||t.classList.contains("e-filled"))&&t.classList.remove("e-input-focus")}),t.element.addEventListener("input",function(){s(w,t.element)})}function s(t,i){var s=i.value;""!==s&&!e.isNullOrUndefined(s)&&i.parentElement?i.parentElement.classList.add("e-valid-input"):"Always"!==t&&i.parentElement&&i.parentElement.classList.remove("e-valid-input")}function n(){var t=c(this).getElementsByClassName("e-float-text")[0];e.isNullOrUndefined(t)||(e.addClass([t],I.LABELTOP),t.classList.contains(I.LABELBOTTOM)&&e.removeClass([t],I.LABELBOTTOM))}function a(){var t=c(this);if(t.getElementsByTagName("textarea")[0]?""===t.getElementsByTagName("textarea")[0].value:""===t.getElementsByTagName("input")[0].value){var i=t.getElementsByClassName("e-float-text")[0];e.isNullOrUndefined(i)||(i.classList.contains(I.LABELTOP)&&e.removeClass([i],I.LABELTOP),e.addClass([i],I.LABELBOTTOM))}}function r(t){t.addEventListener("focus",n),t.addEventListener("blur",a)}function l(t,i,s){var n=e.isNullOrUndefined(s)?e.createElement:s;"Auto"===t.floatLabelType&&r(t.element),e.isNullOrUndefined(i.container)?(i.container=m(t,I.FLOATINPUT,I.FLOATCUSTOMTAG,"div",n),t.element.parentNode&&t.element.parentNode.insertBefore(i.container,t.element)):(e.isNullOrUndefined(t.customTag)||i.container.classList.add(I.FLOATCUSTOMTAG),i.container.classList.add(I.FLOATINPUT));var a=n("span",{className:I.FLOATLINE}),l=n("label",{className:I.FLOATTEXT});if(e.isNullOrUndefined(t.element.id)||""===t.element.id||(l.id="label_"+t.element.id.replace(/ /g,"_"),e.attributes(t.element,{"aria-labelledby":l.id})),e.isNullOrUndefined(t.element.placeholder)||""===t.element.placeholder||(l.innerText=v(t.element.placeholder),t.element.removeAttribute("placeholder")),e.isNullOrUndefined(t.properties)||e.isNullOrUndefined(t.properties.placeholder)||""===t.properties.placeholder||(l.innerText=v(t.properties.placeholder)),l.innerText||i.container.classList.add(I.NOFLOATLABEL),i.container.classList.contains("e-float-icon-left")){var o=i.container.querySelector(".e-input-in-wrap");o.appendChild(t.element),o.appendChild(a),o.appendChild(l)}else i.container.appendChild(t.element),i.container.appendChild(a),i.container.appendChild(l);d(t.element.value,l),"Always"===t.floatLabelType&&(l.classList.contains(I.LABELBOTTOM)&&e.removeClass([l],I.LABELBOTTOM),e.addClass([l],I.LABELTOP)),"Auto"===t.floatLabelType&&(t.element.addEventListener("input",function(e){d(t.element.value,l,t.element)}),t.element.addEventListener("blur",function(e){d(t.element.value,l)})),e.isNullOrUndefined(t.element.getAttribute("id"))||l.setAttribute("for",t.element.getAttribute("id"))}function o(t,e){"Always"===t&&e.classList.contains("e-outline")&&e.classList.add("e-valid-input")}function h(t,i){t?e.removeClass([i],I.CLEARICONHIDE):e.addClass([i],I.CLEARICONHIDE)}function d(t,i,s){if(void 0===s&&(s=null),t)e.addClass([i],I.LABELTOP),i.classList.contains(I.LABELBOTTOM)&&e.removeClass([i],I.LABELBOTTOM);else{(null==s||s!==document.activeElement)&&(i.classList.contains(I.LABELTOP)&&e.removeClass([i],I.LABELTOP),e.addClass([i],I.LABELBOTTOM))}}function c(t){var i=e.isNullOrUndefined(t.parentNode)?t:t.parentNode;return i&&i.classList.contains("e-input-in-wrap")&&(i=i.parentNode),i}function u(t,i,s){(void 0==H||H)&&i.addEventListener("click",function(s){t.classList.contains(I.DISABLE)||t.readOnly||(s.preventDefault(),t!==document.activeElement&&t.focus(),t.value="",e.addClass([i],I.CLEARICONHIDE))}),t.addEventListener("input",function(e){h(t.value,i)}),t.addEventListener("focus",function(e){h(t.value,i)}),t.addEventListener("blur",function(t){setTimeout(function(){e.addClass([i],I.CLEARICONHIDE)},200)})}function p(t,e){if(c(t).classList.contains(I.FLOATINPUT)&&"Auto"===e){var i=c(t).getElementsByClassName("e-float-text")[0];d(t.value,i,t)}}function m(t,i,s,n,a){var r,l=e.isNullOrUndefined(a)?e.createElement:a;return e.isNullOrUndefined(t.customTag)?r=l(n,{className:i}):(r=l(t.customTag,{className:i})).classList.add(s),r.classList.add("e-control-wrapper"),r}function v(t){var i="";if(!e.isNullOrUndefined(t)&&""!==t){var s=document.createElement("span");s.innerHTML='<input  placeholder="'+t+'"/>';i=s.children[0].placeholder}return i}function f(t,i,s){e.isNullOrUndefined(s)||""===s||e.removeClass(i,s.split(" ")),e.isNullOrUndefined(t)||""===t||e.addClass(i,t.split(" "))}function g(t,i){t=v(t);var s=c(i);s.classList.contains(I.FLOATINPUT)?e.isNullOrUndefined(t)||""===t?(s.classList.add(I.NOFLOATLABEL),s.getElementsByClassName(I.FLOATTEXT)[0].textContent=""):(s.getElementsByClassName(I.FLOATTEXT)[0].textContent=t,s.classList.remove(I.NOFLOATLABEL),i.removeAttribute("placeholder")):e.isNullOrUndefined(t)||""===t?(i.removeAttribute("placeholder"),i.removeAttribute("aria-placeholder")):e.attributes(i,{placeholder:t,"aria-placeholder":t})}function y(t,i,s){t?e.attributes(i,{readonly:""}):i.removeAttribute("readonly"),e.isNullOrUndefined(s)||p(i,s)}function b(t,i){t?e.addClass(i,I.RTL):e.removeClass(i,I.RTL)}function C(t,i,s,n){var a={disabled:"disabled","aria-disabled":"true"},r=!e.isNullOrUndefined(n);t?(i.classList.remove(I.DISABLE),x(a,i),r&&e.removeClass([n],I.DISABLE)):(i.classList.add(I.DISABLE),S(a,i),r&&e.addClass([n],I.DISABLE)),e.isNullOrUndefined(s)||p(i,s)}function E(t,i,s,n,a){var r=e.isNullOrUndefined(a)?e.createElement:a;t?s.clearButton=function(t,i,s,n){var a=(e.isNullOrUndefined(n)?e.createElement:n)("span",{className:I.CLEARICON}),r=i.container;e.isNullOrUndefined(s)?(i.container.classList.contains(I.FLOATINPUT)?i.container.querySelector("."+I.FLOATTEXT):t).insertAdjacentElement("afterend",a):r.appendChild(a);return!e.isNullOrUndefined(r)&&r.classList.contains(I.FLOATINPUT)&&e.addClass([r],I.INPUTGROUP),e.addClass([a],I.CLEARICONHIDE),u(t,a),a.setAttribute("aria-label","close"),a}(i,s,n,r):(e.remove(s.clearButton),s.clearButton=null)}function x(t,e){for(var i=0,s=Object.keys(t);i<s.length;i++){var n=s[i],a=c(e);"disabled"===n&&e.classList.remove(I.DISABLE),"disabled"===n&&a.classList.contains(I.INPUTGROUP)&&a.classList.remove(I.DISABLE),"placeholder"===n&&a.classList.contains(I.FLOATINPUT)?a.getElementsByClassName(I.FLOATTEXT)[0].textContent="":e.removeAttribute(n)}}function S(t,e){for(var i=0,s=Object.keys(t);i<s.length;i++){var n=s[i],a=c(e);"disabled"===n&&e.classList.add(I.DISABLE),"disabled"===n&&a.classList.contains(I.INPUTGROUP)&&a.classList.add(I.DISABLE),"placeholder"===n&&a.classList.contains(I.FLOATINPUT)?a.getElementsByClassName(I.FLOATTEXT)[0].textContent=t[n]:e.setAttribute(n,t[n])}}function k(t,i,s){var n=[];n.push(s);var a=e.isNullOrUndefined(s)?i.querySelectorAll(".e-input-group-icon"):n;if(t&&a.length>0)for(var r=0;r<a.length;r++)a[r].addEventListener("mousedown",P,!1),a[r].addEventListener("mouseup",O,!1);else if(a.length>0)for(r=0;r<a.length;r++)a[r].removeEventListener("mousedown",P,this),a[r].removeEventListener("mouseup",O,this)}function P(){for(var t=this.parentElement;!t.classList.contains("e-input-group");)t=t.parentElement;!function(t,e){t.classList.contains("e-disabled")||t.querySelector("input").readOnly||e.classList.add("e-input-btn-ripple")}(t,this)}function O(){var t=this;setTimeout(function(){t.classList.remove("e-input-btn-ripple")},500)}function T(t,e){var i=e("span",{className:t});return i.classList.add("e-input-group-icon"),i}function L(t,i,s,n){var a=e.isNullOrUndefined(n)?e.createElement:n,r=T(t,a);i.classList.add("e-float-icon-left");var l=i.querySelector(".e-input-in-wrap");if(e.isNullOrUndefined(l)){l=a("span",{className:"e-input-in-wrap"}),s.parentNode.insertBefore(l,s);var o=i.querySelectorAll(s.tagName+" ~ *");l.appendChild(s);for(var h=0;h<o.length;h++)l.appendChild(o[h])}return l.parentNode.insertBefore(r,l),i.classList.contains(I.INPUTGROUP)||i.classList.add(I.INPUTGROUP),k(!0,i,r),r}function A(t,i,s){var n=T(t,e.isNullOrUndefined(s)?e.createElement:s);i.classList.contains(I.INPUTGROUP)||i.classList.add(I.INPUTGROUP);return(i.classList.contains("e-float-icon-left")?i.querySelector(".e-input-in-wrap"):i).appendChild(n),k(!0,i,n),n}function N(t,e){"hidden"===e.type?t.classList.add("e-hidden"):t.classList.contains("e-hidden")&&t.classList.remove("e-hidden")}var w,H=!0;t.createInput=function(t,s){var n=e.isNullOrUndefined(s)?e.createElement:s,a={container:null,buttons:[],clearButton:null};if(w=t.floatLabelType,H=t.bindClearAction,e.isNullOrUndefined(t.floatLabelType)||"Never"===t.floatLabelType?(a.container=m(t,I.INPUTGROUP,I.INPUTCUSTOMTAG,"span",n),t.element.parentNode.insertBefore(a.container,t.element),e.addClass([t.element],I.INPUT),a.container.appendChild(t.element)):l(t,a,n),i(t),e.isNullOrUndefined(t.properties)||e.isNullOrUndefined(t.properties.showClearButton)||!t.properties.showClearButton||"TEXTAREA"===t.element.tagName||(E(t.properties.showClearButton,t.element,a,!0,n),a.clearButton.setAttribute("role","button"),a.container.classList.contains(I.FLOATINPUT)&&e.addClass([a.container],I.INPUTGROUP)),!e.isNullOrUndefined(t.buttons)&&"TEXTAREA"!==t.element.tagName)for(var r=0;r<t.buttons.length;r++)a.buttons.push(A(t.buttons[r],a.container,n));return e.isNullOrUndefined(t.element)||"TEXTAREA"!==t.element.tagName||e.addClass([a.container],I.TEXTAREA),N(a.container,t.element),a=function(t,i){if(!e.isNullOrUndefined(t.properties))for(var s=0,n=Object.keys(t.properties);s<n.length;s++){var a=n[s];switch(a){case"cssClass":f(t.properties.cssClass,[i.container]),o(t.floatLabelType,i.container);break;case"enabled":C(t.properties.enabled,t.element,t.floatLabelType,i.container);break;case"enableRtl":b(t.properties.enableRtl,[i.container]);break;case"placeholder":g(t.properties.placeholder,t.element);break;case"readonly":y(t.properties.readonly,t.element)}}return i}(t,a)},t.bindInitialEvent=i,t.wireFloatingEvents=r,t.wireClearBtnEvents=u,t.setValue=function(t,i,n,a){if(i.value=t,e.isNullOrUndefined(n)||"Auto"!==n||p(i,n),!e.isNullOrUndefined(a)&&a){var r=c(i);if(!e.isNullOrUndefined(r)){var l=r.getElementsByClassName(I.CLEARICON)[0];e.isNullOrUndefined(l)||(i.value&&r.classList.contains("e-input-focus")?e.removeClass([l],I.CLEARICONHIDE):e.addClass([l],I.CLEARICONHIDE))}}s(n,i)},t.setCssClass=f,t.setWidth=function(t,i){"number"==typeof t?i.style.width=e.formatUnit(t):"string"==typeof t&&(i.style.width=t.match(/px|%|em/)?t:e.formatUnit(t))},t.setPlaceholder=g,t.setReadonly=y,t.setEnableRtl=b,t.setEnabled=C,t.setClearButton=E,t.removeAttributes=x,t.addAttributes=S,t.removeFloating=function(t){var i=t.container;if(!e.isNullOrUndefined(i)&&i.classList.contains(I.FLOATINPUT)){var s=i.querySelector("textarea")?i.querySelector("textarea"):i.querySelector("input"),r=i.querySelector("."+I.FLOATTEXT).textContent,l=null!==i.querySelector(".e-clear-icon");e.detach(i.querySelector("."+I.FLOATLINE)),e.detach(i.querySelector("."+I.FLOATTEXT)),e.classList(i,[I.INPUTGROUP],[I.FLOATINPUT]),function(t){t.removeEventListener("focus",n),t.removeEventListener("blur",a)}(s),e.attributes(s,{placeholder:r}),s.classList.add(I.INPUT),l||"INPUT"!==s.tagName||s.removeAttribute("required")}},t.addFloating=function(t,i,s,n){var a=e.isNullOrUndefined(n)?e.createElement:n,r=e.closest(t,"."+I.INPUTGROUP);if(w=i,"Never"!==i){var h=r.tagName,d={element:t,floatLabelType:i,customTag:h="DIV"!==h&&"SPAN"!==h?h:null,properties:{placeholder:s}},c=r.querySelector(".e-clear-icon"),u={container:r};t.classList.remove(I.INPUT),l(d,u,a);var p=r.classList.contains("e-float-icon-left");if(e.isNullOrUndefined(c)&&(c=p?r.querySelector(".e-input-in-wrap").querySelector(".e-input-group-icon"):r.querySelector(".e-input-group-icon")),e.isNullOrUndefined(c))p&&(c=r.querySelector(".e-input-group-icon")),e.isNullOrUndefined(c)&&r.classList.remove(I.INPUTGROUP);else{var m=r.querySelector("."+I.FLOATLINE),v=r.querySelector("."+I.FLOATTEXT),f=p?r.querySelector(".e-input-in-wrap"):r;f.insertBefore(t,c),f.insertBefore(m,c),f.insertBefore(v,c)}}o(i,t.parentElement)},t.setRipple=function(t,e){for(var i=0;i<e.length;i++)k(t,e[i].container)},t.addIcon=function(t,e,i,s,n){var a="string"==typeof e?e.split(","):e;if("append"===t.toLowerCase())for(var r=0,l=a;r<l.length;r++)A(l[r],i,n);else for(var o=0,h=a;o<h.length;o++)L(h[o],i,s,n)},t.prependSpan=L,t.appendSpan=A,t.validateInputType=N}(t.Input||(t.Input={}));var D=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function s(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),z=function(t,e,i,s){var n,a=arguments.length,r=a<3?e:null===s?s=Object.getOwnPropertyDescriptor(e,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(t,e,i,s);else for(var l=t.length-1;l>=0;l--)(n=t[l])&&(r=(a<3?n(r):a>3?n(e,i,r):n(e,i))||r);return a>3&&r&&Object.defineProperty(e,i,r),r},q="e-input-group-icon",W="e-spin-up",j="increment",_="decrement",X=new RegExp("^(-)?(\\d*)$"),K="e-input-focus",Z=["title","style","class"],Y=function(i){function s(t,e){var s=i.call(this,t,e)||this;return s.isVue=!1,s.preventChange=!1,s.isAngular=!1,s.isDynamicChange=!1,s.numericOptions=t,s}return D(s,i),s.prototype.preRender=function(){this.isPrevFocused=!1,this.decimalSeparator=".",this.intRegExp=new RegExp("/^(-)?(d*)$/"),this.isCalled=!1;var t=e.getValue("ej2_instances",this.element);if(this.cloneElement=this.element.cloneNode(!0),e.removeClass([this.cloneElement],["e-control","e-numerictextbox","e-lib"]),this.angularTagName=null,this.formEle=e.closest(this.element,"form"),"EJS-NUMERICTEXTBOX"===this.element.tagName){this.angularTagName=this.element.tagName;for(var i=this.createElement("input"),s=0;s<this.element.attributes.length;s++){"id"!==this.element.attributes[s].nodeName&&(i.setAttribute(this.element.attributes[s].nodeName,this.element.attributes[s].nodeValue),i.innerHTML=this.element.innerHTML)}this.element.hasAttribute("name")&&this.element.removeAttribute("name"),this.element.classList.remove("e-control","e-numerictextbox"),this.element.appendChild(i),this.element=i,e.setValue("ej2_instances",t,this.element)}e.attributes(this.element,{role:"spinbutton",tabindex:"0",autocomplete:"off","aria-live":"assertive"});var n={incrementTitle:"Increment value",decrementTitle:"Decrement value",placeholder:this.placeholder};this.l10n=new e.L10n("numerictextbox",n,this.locale),""!==this.l10n.getConstant("placeholder")&&this.setProperties({placeholder:this.placeholder||this.l10n.getConstant("placeholder")},!0),this.isValidState=!0,this.inputStyle=null,this.inputName=null,this.cultureInfo={},this.initCultureInfo(),this.initCultureFunc(),this.prevValue=this.value,this.updateHTMLAttrToElement(),this.checkAttributes(!1),this.formEle&&(this.inputEleValue=this.value),this.validateMinMax(),this.validateStep(),null===this.placeholder&&this.updatePlaceholder()},s.prototype.render=function(){"input"===this.element.tagName.toLowerCase()&&(this.createWrapper(),this.showSpinButton&&this.spinBtnCreation(),this.setElementWidth(this.width),this.container.classList.contains("e-input-group")||this.container.classList.add("e-input-group"),this.changeValue(null===this.value||isNaN(this.value)?null:this.strictMode?this.trimValue(this.value):this.value),this.wireEvents(),null===this.value||isNaN(this.value)||this.decimals&&this.setProperties({value:this.roundNumber(this.value,this.decimals)},!0),(this.element.getAttribute("value")||this.value)&&(this.element.setAttribute("value",this.element.value),this.hiddenInput.setAttribute("value",this.hiddenInput.value)),this.elementPrevValue=this.element.value,this.element.hasAttribute("data-val")&&this.element.setAttribute("data-val","false"),this.renderComplete())},s.prototype.checkAttributes=function(t){for(var i=0,s=t?e.isNullOrUndefined(this.htmlAttributes)?[]:Object.keys(this.htmlAttributes):["value","min","max","step","disabled","readonly","style","name","placeholder"];i<s.length;i++){var n=s[i];if(!e.isNullOrUndefined(this.element.getAttribute(n)))switch(n){case"disabled":if(e.isNullOrUndefined(this.numericOptions)||void 0===this.numericOptions.enabled||t){var a="disabled"!==this.element.getAttribute(n)&&""!==this.element.getAttribute(n)&&"true"!==this.element.getAttribute(n);this.setProperties({enabled:a},!t)}break;case"readonly":if(e.isNullOrUndefined(this.numericOptions)||void 0===this.numericOptions.readonly||t){var r="readonly"===this.element.getAttribute(n)||""===this.element.getAttribute(n)||"true"===this.element.getAttribute(n);this.setProperties({readonly:r},!t)}break;case"placeholder":(e.isNullOrUndefined(this.numericOptions)||void 0===this.numericOptions.placeholder||t)&&this.setProperties({placeholder:this.element.placeholder},!t);break;case"value":if(e.isNullOrUndefined(this.numericOptions)||void 0===this.numericOptions.value||t){var l=this.instance.getNumberParser({format:"n"})(this.element.getAttribute(n));this.setProperties(e.setValue(n,l,{}),!t)}break;case"min":if(e.isNullOrUndefined(this.numericOptions)||void 0===this.numericOptions.min||t){var o=this.instance.getNumberParser({format:"n"})(this.element.getAttribute(n));null===o||isNaN(o)||this.setProperties(e.setValue(n,o,{}),!t)}break;case"max":if(e.isNullOrUndefined(this.numericOptions)||void 0===this.numericOptions.max||t){var h=this.instance.getNumberParser({format:"n"})(this.element.getAttribute(n));null===h||isNaN(h)||this.setProperties(e.setValue(n,h,{}),!t)}break;case"step":if(e.isNullOrUndefined(this.numericOptions)||void 0===this.numericOptions.step||t){var d=this.instance.getNumberParser({format:"n"})(this.element.getAttribute(n));null===d||isNaN(d)||this.setProperties(e.setValue(n,d,{}),!t)}break;case"style":this.inputStyle=this.element.getAttribute(n);break;case"name":this.inputName=this.element.getAttribute(n);break;default:var c=this.instance.getNumberParser({format:"n"})(this.element.getAttribute(n));(null!==c&&!isNaN(c)||"value"===n)&&this.setProperties(e.setValue(n,c,{}),!0)}}},s.prototype.updatePlaceholder=function(){this.setProperties({placeholder:this.l10n.getConstant("placeholder")},!0)},s.prototype.initCultureFunc=function(){this.instance=new e.Internationalization(this.locale)},s.prototype.initCultureInfo=function(){this.cultureInfo.format=this.format,null!==e.getValue("currency",this)&&(e.setValue("currency",this.currency,this.cultureInfo),this.setProperties({currencyCode:this.currency},!0))},s.prototype.createWrapper=function(){var i=this.cssClass;e.isNullOrUndefined(this.cssClass)||""===this.cssClass||(i=this.getNumericValidClassList(this.cssClass));var s=t.Input.createInput({element:this.element,floatLabelType:this.floatLabelType,properties:{readonly:this.readonly,placeholder:this.placeholder,cssClass:i,enableRtl:this.enableRtl,showClearButton:this.showClearButton,enabled:this.enabled}},this.createElement);this.inputWrapper=s,this.container=s.container,this.container.setAttribute("class","e-control-wrapper e-numeric "+this.container.getAttribute("class")),this.updateHTMLAttrToWrapper(),this.readonly&&e.attributes(this.element,{"aria-readonly":"true"}),this.hiddenInput=this.createElement("input",{attrs:{type:"text",validateHidden:"true",class:"e-numeric-hidden"}}),this.inputName=null!==this.inputName?this.inputName:this.element.id,this.element.removeAttribute("name"),e.attributes(this.hiddenInput,{name:this.inputName}),this.container.insertBefore(this.hiddenInput,this.container.childNodes[1]),this.updateDataAttribute(!1),null!==this.inputStyle&&e.attributes(this.container,{style:this.inputStyle})},s.prototype.updateDataAttribute=function(t){var e={};if(t)e=this.htmlAttributes;else for(var i=0;i<this.element.attributes.length;i++)e[this.element.attributes[i].name]=this.element.getAttribute(this.element.attributes[i].name);for(var s=0,n=Object.keys(e);s<n.length;s++){var a=n[s];0===a.indexOf("data")&&this.hiddenInput.setAttribute(a,e[a])}},s.prototype.updateHTMLAttrToElement=function(){if(!e.isNullOrUndefined(this.htmlAttributes))for(var t=0,i=Object.keys(this.htmlAttributes);t<i.length;t++){var s=i[t];Z.indexOf(s)<0&&this.element.setAttribute(s,this.htmlAttributes[s])}},s.prototype.updateCssClass=function(e,i){t.Input.setCssClass(this.getNumericValidClassList(e),[this.container],this.getNumericValidClassList(i))},s.prototype.getNumericValidClassList=function(t){var i=t;return e.isNullOrUndefined(t)||""===t||(i=t.replace(/\s+/g," ").trim()),i},s.prototype.updateHTMLAttrToWrapper=function(){if(!e.isNullOrUndefined(this.htmlAttributes))for(var t=0,i=Object.keys(this.htmlAttributes);t<i.length;t++){var s=i[t];if(Z.indexOf(s)>-1)if("class"===s){var n=this.getNumericValidClassList(this.htmlAttributes[s]);""!==n&&e.addClass([this.container],n.split(" "))}else if("style"===s){var a=this.container.getAttribute(s);a=e.isNullOrUndefined(a)?this.htmlAttributes[s]:a+this.htmlAttributes[s],this.container.setAttribute(s,a)}else this.container.setAttribute(s,this.htmlAttributes[s])}},s.prototype.setElementWidth=function(t){e.isNullOrUndefined(t)||("number"==typeof t?this.container.style.width=e.formatUnit(t):"string"==typeof t&&(this.container.style.width=t.match(/px|%|em/)?t:e.formatUnit(t)))},s.prototype.spinBtnCreation=function(){this.spinDown=t.Input.appendSpan(q+" e-spin-down",this.container,this.createElement),e.attributes(this.spinDown,{title:this.l10n.getConstant("decrementTitle"),"aria-label":this.l10n.getConstant("decrementTitle")}),this.spinUp=t.Input.appendSpan(q+" "+W,this.container,this.createElement),e.attributes(this.spinUp,{title:this.l10n.getConstant("incrementTitle"),"aria-label":this.l10n.getConstant("incrementTitle")}),this.wireSpinBtnEvents()},s.prototype.validateMinMax=function(){("number"!=typeof this.min||isNaN(this.min))&&this.setProperties({min:-Number.MAX_VALUE},!0),("number"!=typeof this.max||isNaN(this.max))&&this.setProperties({max:Number.MAX_VALUE},!0),null!==this.decimals&&(this.min!==-Number.MAX_VALUE&&this.setProperties({min:this.instance.getNumberParser({format:"n"})(this.formattedValue(this.decimals,this.min))},!0),this.max!==Number.MAX_VALUE&&this.setProperties({max:this.instance.getNumberParser({format:"n"})(this.formattedValue(this.decimals,this.max))},!0)),this.setProperties({min:this.min>this.max?this.max:this.min},!0),e.attributes(this.element,{"aria-valuemin":this.min.toString(),"aria-valuemax":this.max.toString()})},s.prototype.formattedValue=function(t,e){return this.instance.getNumberFormat({maximumFractionDigits:t,minimumFractionDigits:t,useGrouping:!1})(e)},s.prototype.validateStep=function(){null!==this.decimals&&this.setProperties({step:this.instance.getNumberParser({format:"n"})(this.formattedValue(this.decimals,this.step))},!0)},s.prototype.action=function(t,e){this.isInteract=!0;var i=this.isFocused?this.instance.getNumberParser({format:"n"})(this.element.value):this.value;this.changeValue(this.performAction(i,this.step,t)),this.raiseChangeEvent(e)},s.prototype.checkErrorClass=function(){this.isValidState?e.removeClass([this.container],"e-error"):e.addClass([this.container],"e-error"),e.attributes(this.element,{"aria-invalid":this.isValidState?"false":"true"})},s.prototype.bindClearEvent=function(){this.showClearButton&&e.EventHandler.add(this.inputWrapper.clearButton,"mousedown touchstart",this.resetHandler,this)},s.prototype.resetHandler=function(t){t.preventDefault(),this.inputWrapper.clearButton.classList.contains("e-clear-icon-hide")&&!this.inputWrapper.container.classList.contains("e-static-clear")||this.clear(t),this.isInteract=!0,this.raiseChangeEvent(t)},s.prototype.clear=function(t){this.setProperties({value:null},!0),this.setElementValue(""),this.hiddenInput.value="";if(e.closest(this.element,"form")){var i=this.element.nextElementSibling,s=document.createEvent("KeyboardEvent");s.initEvent("keyup",!1,!0),i.dispatchEvent(s)}},s.prototype.resetFormHandler=function(){"EJS-NUMERICTEXTBOX"===this.element.tagName?this.updateValue(null):this.updateValue(this.inputEleValue)},s.prototype.setSpinButton=function(){e.isNullOrUndefined(this.spinDown)||e.attributes(this.spinDown,{title:this.l10n.getConstant("decrementTitle"),"aria-label":this.l10n.getConstant("decrementTitle")}),e.isNullOrUndefined(this.spinUp)||e.attributes(this.spinUp,{title:this.l10n.getConstant("incrementTitle"),"aria-label":this.l10n.getConstant("incrementTitle")})},s.prototype.wireEvents=function(){e.EventHandler.add(this.element,"focus",this.focusHandler,this),e.EventHandler.add(this.element,"blur",this.focusOutHandler,this),e.EventHandler.add(this.element,"keydown",this.keyDownHandler,this),e.EventHandler.add(this.element,"keyup",this.keyUpHandler,this),e.EventHandler.add(this.element,"input",this.inputHandler,this),e.EventHandler.add(this.element,"keypress",this.keyPressHandler,this),e.EventHandler.add(this.element,"change",this.changeHandler,this),e.EventHandler.add(this.element,"paste",this.pasteHandler,this),this.enabled&&(this.bindClearEvent(),this.formEle&&e.EventHandler.add(this.formEle,"reset",this.resetFormHandler,this))},s.prototype.wireSpinBtnEvents=function(){e.EventHandler.add(this.spinUp,e.Browser.touchStartEvent,this.mouseDownOnSpinner,this),e.EventHandler.add(this.spinDown,e.Browser.touchStartEvent,this.mouseDownOnSpinner,this),e.EventHandler.add(this.spinUp,e.Browser.touchEndEvent,this.mouseUpOnSpinner,this),e.EventHandler.add(this.spinDown,e.Browser.touchEndEvent,this.mouseUpOnSpinner,this),e.EventHandler.add(this.spinUp,e.Browser.touchMoveEvent,this.touchMoveOnSpinner,this),e.EventHandler.add(this.spinDown,e.Browser.touchMoveEvent,this.touchMoveOnSpinner,this)},s.prototype.unwireEvents=function(){e.EventHandler.remove(this.element,"focus",this.focusHandler),e.EventHandler.remove(this.element,"blur",this.focusOutHandler),e.EventHandler.remove(this.element,"keyup",this.keyUpHandler),e.EventHandler.remove(this.element,"input",this.inputHandler),e.EventHandler.remove(this.element,"keydown",this.keyDownHandler),e.EventHandler.remove(this.element,"keypress",this.keyPressHandler),e.EventHandler.remove(this.element,"change",this.changeHandler),e.EventHandler.remove(this.element,"paste",this.pasteHandler),this.formEle&&e.EventHandler.remove(this.formEle,"reset",this.resetFormHandler)},s.prototype.unwireSpinBtnEvents=function(){e.EventHandler.remove(this.spinUp,e.Browser.touchStartEvent,this.mouseDownOnSpinner),e.EventHandler.remove(this.spinDown,e.Browser.touchStartEvent,this.mouseDownOnSpinner),e.EventHandler.remove(this.spinUp,e.Browser.touchEndEvent,this.mouseUpOnSpinner),e.EventHandler.remove(this.spinDown,e.Browser.touchEndEvent,this.mouseUpOnSpinner),e.EventHandler.remove(this.spinUp,e.Browser.touchMoveEvent,this.touchMoveOnSpinner),e.EventHandler.remove(this.spinDown,e.Browser.touchMoveEvent,this.touchMoveOnSpinner)},s.prototype.changeHandler=function(t){t.stopPropagation(),this.element.value.length||this.setProperties({value:null},!0);var e=this.instance.getNumberParser({format:"n"})(this.element.value);this.updateValue(e,t)},s.prototype.raiseChangeEvent=function(t){if(this.prevValue!==this.value){var i={};this.changeEventArgs={value:this.value,previousValue:this.prevValue,isInteracted:this.isInteract,isInteraction:this.isInteract,event:t},t&&(this.changeEventArgs.event=t),void 0===this.changeEventArgs.event&&(this.changeEventArgs.isInteracted=!1,this.changeEventArgs.isInteraction=!1),e.merge(i,this.changeEventArgs),this.prevValue=this.value,this.isInteract=!1,this.elementPrevValue=this.element.value,this.preventChange=!1,this.trigger("change",i)}},s.prototype.pasteHandler=function(){var t=this;if(this.enabled&&!this.readonly){var e=this.element.value;setTimeout(function(){t.numericRegex().test(t.element.value)||t.setElementValue(e)})}},s.prototype.preventHandler=function(){var t=this,i=!!navigator.platform&&/iPad|iPhone|iPod/.test(navigator.platform);setTimeout(function(){if(t.element.selectionStart>0){var s=t.element.selectionStart,n=t.element.selectionStart-1,a=t.element.value.split(""),r=e.getNumericObject(t.locale),l=e.getValue("decimal",r),o=l.charCodeAt(0);" "===t.element.value[n]&&t.element.selectionStart>0&&!i?(e.isNullOrUndefined(t.prevVal)?t.element.value=t.element.value.trim():0!==n?t.element.value=t.prevVal:0===n&&(t.element.value=t.element.value.trim()),t.element.setSelectionRange(n,n)):isNaN(parseFloat(t.element.value[t.element.selectionStart-1]))&&45!==t.element.value[t.element.selectionStart-1].charCodeAt(0)?(a.indexOf(t.element.value[t.element.selectionStart-1])!==a.lastIndexOf(t.element.value[t.element.selectionStart-1])&&t.element.value[t.element.selectionStart-1].charCodeAt(0)===o||t.element.value[t.element.selectionStart-1].charCodeAt(0)!==o)&&(t.element.value=t.element.value.substring(0,n)+t.element.value.substring(s,t.element.value.length),t.element.setSelectionRange(n,n),isNaN(parseFloat(t.element.value[t.element.selectionStart-1]))&&t.element.selectionStart>0&&t.element.value.length&&t.preventHandler()):isNaN(parseFloat(t.element.value[t.element.selectionStart-2]))&&t.element.selectionStart>1&&45!==t.element.value[t.element.selectionStart-2].charCodeAt(0)&&(a.indexOf(t.element.value[t.element.selectionStart-2])!==a.lastIndexOf(t.element.value[t.element.selectionStart-2])&&t.element.value[t.element.selectionStart-2].charCodeAt(0)===o||t.element.value[t.element.selectionStart-2].charCodeAt(0)!==o)&&(t.element.setSelectionRange(n,n),t.nextEle=t.element.value[t.element.selectionStart],t.cursorPosChanged=!0,t.preventHandler()),!0===t.cursorPosChanged&&t.element.value[t.element.selectionStart]===t.nextEle&&isNaN(parseFloat(t.element.value[t.element.selectionStart-1]))&&(t.element.setSelectionRange(t.element.selectionStart+1,t.element.selectionStart+1),t.cursorPosChanged=!1,t.nextEle=null),""===t.element.value.trim()&&t.element.setSelectionRange(0,0),t.element.selectionStart>0&&(45===t.element.value[t.element.selectionStart-1].charCodeAt(0)&&t.element.selectionStart>1&&(e.isNullOrUndefined(t.prevVal)?t.element.value=t.element.value:t.element.value=t.prevVal,t.element.setSelectionRange(t.element.selectionStart,t.element.selectionStart)),t.element.value[t.element.selectionStart-1]===l&&0===t.decimals&&t.validateDecimalOnType&&(t.element.value=t.element.value.substring(0,n)+t.element.value.substring(s,t.element.value.length))),t.prevVal=t.element.value}})},s.prototype.keyUpHandler=function(){if(this.enabled&&!this.readonly){!(!!navigator.platform&&/iPad|iPhone|iPod/.test(navigator.platform))&&e.Browser.isDevice&&this.preventHandler();var t=this.instance.getNumberParser({format:"n"})(this.element.value);t=null===t||isNaN(t)?null:t,this.hiddenInput.value=t||0===t?t.toString():null;if(e.closest(this.element,"form")){var i=this.element.nextElementSibling,s=document.createEvent("KeyboardEvent");s.initEvent("keyup",!1,!0),i.dispatchEvent(s)}}},s.prototype.inputHandler=function(t){if(this.enabled&&!this.readonly){var i=!!navigator.platform&&/iPad|iPhone|iPod/.test(navigator.platform);if((navigator.userAgent.toLowerCase().indexOf("firefox")>-1||i)&&e.Browser.isDevice&&this.preventHandler(),this.isAngular&&this.element.value!==e.getValue("decimal",e.getNumericObject(this.locale))&&this.element.value!==e.getValue("minusSign",e.getNumericObject(this.locale))){var s=this.instance.getNumberParser({format:"n"})(this.element.value);s=isNaN(s)?null:s,this.localChange({value:s}),this.preventChange=!0}if(this.isVue){var n=this.instance.getNumberParser({format:"n"})(this.element.value),a=this.instance.getNumberParser({format:"n"})(this.elementPrevValue);new RegExp("[^1-9]+$").test(this.element.value)&&(n=this.value);var r={event:t,value:null===n||isNaN(n)?null:n,previousValue:null===a||isNaN(a)?null:a};this.preventChange=!0,this.elementPrevValue=this.element.value,this.trigger("input",r)}}},s.prototype.keyDownHandler=function(t){if(!this.readonly)switch(t.keyCode){case 38:t.preventDefault(),this.action(j,t);break;case 40:t.preventDefault(),this.action(_,t)}},s.prototype.performAction=function(t,e,i){(null===t||isNaN(t))&&(t=0);var s=i===j?t+e:t-e;return s=this.correctRounding(t,e,s),this.strictMode?this.trimValue(s):s},s.prototype.correctRounding=function(t,e,i){var s=new RegExp("[,.](.*)"),n=s.test(t.toString()),a=s.test(e.toString());if(n||a){var r=n?s.exec(t.toString())[0].length:0,l=a?s.exec(e.toString())[0].length:0,o=Math.max(r,l);return t=this.roundValue(i,o)}return i},s.prototype.roundValue=function(t,e){e=e||0;var i=Math.pow(10,e);return t*=i,t=Math.round(t)/i},s.prototype.updateValue=function(t,e){e&&(this.isInteract=!0),null===t||isNaN(t)||this.decimals&&(t=this.roundNumber(t,this.decimals)),this.changeValue(null===t||isNaN(t)?null:this.strictMode?this.trimValue(t):t),this.isDynamicChange||this.raiseChangeEvent(e)},s.prototype.updateCurrency=function(t,i){e.setValue(t,i,this.cultureInfo),this.updateValue(this.value)},s.prototype.changeValue=function(t){if(t||0===t){var e=this.getNumberOfDecimals(t);this.setProperties({value:this.roundNumber(t,e)},!0)}else t=null,this.setProperties({value:t},!0);this.modifyText(),this.strictMode||this.validateState()},s.prototype.modifyText=function(){if(this.value||0===this.value){var t=this.formatNumber(),i=this.isFocused?t:this.instance.getNumberFormat(this.cultureInfo)(this.value);this.setElementValue(i),e.attributes(this.element,{"aria-valuenow":t}),this.hiddenInput.value=this.value.toString(),null!==this.value&&this.serverDecimalSeparator&&(this.hiddenInput.value=this.hiddenInput.value.replace(".",this.serverDecimalSeparator))}else this.setElementValue(""),this.element.removeAttribute("aria-valuenow"),this.hiddenInput.value=null},s.prototype.setElementValue=function(e,i){t.Input.setValue(e,i||this.element,this.floatLabelType,this.showClearButton)},s.prototype.validateState=function(){this.isValidState=!0,(this.value||0===this.value)&&(this.isValidState=!(this.value>this.max||this.value<this.min)),this.checkErrorClass()},s.prototype.getNumberOfDecimals=function(t){var i,s=new RegExp("[eE][-+]?([0-9]+)"),n=t.toString();if(s.test(n)){var a=s.exec(n);e.isNullOrUndefined(a)||(n=t.toFixed(Math.min(parseInt(a[1],10),20)))}var r=n.split(".")[1];return i=r&&r.length?r.length:0,null!==this.decimals&&(i=i<this.decimals?i:this.decimals),i},s.prototype.formatNumber=function(){var t=this.getNumberOfDecimals(this.value);return this.instance.getNumberFormat({maximumFractionDigits:t,minimumFractionDigits:t,useGrouping:!1})(this.value)},s.prototype.trimValue=function(t){return t>this.max?this.max:t<this.min?this.min:t},s.prototype.roundNumber=function(t,e){var i=t,s=e||0,n=i.toString().split("e"),a=(i=Math.round(Number(n[0]+"e"+(n[1]?Number(n[1])+s:s)))).toString().split("e");return i=Number(a[0]+"e"+(a[1]?Number(a[1])-s:-s)),Number(i.toFixed(s))},s.prototype.cancelEvent=function(t){return t.preventDefault(),!1},s.prototype.keyPressHandler=function(t){if(!this.enabled||this.readonly)return!0;if(!e.Browser.isDevice&&"11.0"===e.Browser.info.version&&13===t.keyCode){var i=this.instance.getNumberParser({format:"n"})(this.element.value);return this.updateValue(i,t),!0}if(0===t.which||t.metaKey||t.ctrlKey||8===t.keyCode||13===t.keyCode)return!0;var s=String.fromCharCode(t.which),n=this.element.value;return n=n.substring(0,this.element.selectionStart)+s+n.substring(this.element.selectionEnd),!!this.numericRegex().test(n)||(t.preventDefault(),t.stopPropagation(),!1)},s.prototype.numericRegex=function(){var t=e.getNumericObject(this.locale),i=e.getValue("decimal",t),s="*";return"."===i&&(i="\\"+i),0===this.decimals&&this.validateDecimalOnType?X:(this.decimals&&this.validateDecimalOnType&&(s="{0,"+this.decimals+"}"),new RegExp("^(-)?(((\\d+("+i+"\\d"+s+")?)|("+i+"\\d"+s+")))?$"))},s.prototype.mouseWheel=function(t){t.preventDefault();var e,i=t;i.wheelDelta?e=i.wheelDelta/120:i.detail&&(e=-i.detail/3),e>0?this.action(j,t):e<0&&this.action(_,t),this.cancelEvent(t)},s.prototype.focusHandler=function(t){var i=this;if(this.focusEventArgs={event:t,value:this.value,container:this.container},this.trigger("focus",this.focusEventArgs),this.enabled&&!this.readonly){if(this.isFocused=!0,e.removeClass([this.container],"e-error"),this.prevValue=this.value,this.value||0===this.value){var s=this.formatNumber();if(this.setElementValue(s),!this.isPrevFocused)if(e.Browser.isDevice||"11.0"!==e.Browser.info.version){var n=e.Browser.isDevice&&e.Browser.isIos?600:0;setTimeout(function(){i.element.setSelectionRange(0,s.length)},n)}else this.element.setSelectionRange(0,s.length)}e.Browser.isDevice||e.EventHandler.add(this.element,"mousewheel DOMMouseScroll",this.mouseWheel,this)}},s.prototype.focusOutHandler=function(t){var i=this;if(this.blurEventArgs={event:t,value:this.value,container:this.container},this.trigger("blur",this.blurEventArgs),this.enabled&&!this.readonly){if(this.isPrevFocused){if(t.preventDefault(),e.Browser.isDevice){var s=this.element.value;this.element.focus(),this.isPrevFocused=!1;var n=this.element;setTimeout(function(){i.setElementValue(s,n)},200)}}else{this.isFocused=!1,this.element.value.length||this.setProperties({value:null},!0);var a=this.instance.getNumberParser({format:"n"})(this.element.value);this.updateValue(a),e.Browser.isDevice||e.EventHandler.remove(this.element,"mousewheel DOMMouseScroll",this.mouseWheel)}if(e.closest(this.element,"form")){var r=this.element.nextElementSibling,l=document.createEvent("FocusEvent");l.initEvent("focusout",!1,!0),r.dispatchEvent(l)}}},s.prototype.mouseDownOnSpinner=function(t){var i=this;if(this.isFocused&&(this.isPrevFocused=!0,t.preventDefault()),this.getElementData(t)){this.getElementData(t);var s=t.currentTarget,n=s.classList.contains(W)?j:_;e.EventHandler.add(s,"mouseleave",this.mouseUpClick,this),this.timeOut=setInterval(function(){i.isCalled=!0,i.action(n,t)},150),e.EventHandler.add(document,"mouseup",this.mouseUpClick,this)}},s.prototype.touchMoveOnSpinner=function(t){var e;if("touchmove"===t.type){var i=t.touches;e=i.length&&document.elementFromPoint(i[0].pageX,i[0].pageY)}else e=document.elementFromPoint(t.clientX,t.clientY);e.classList.contains(q)||clearInterval(this.timeOut)},s.prototype.mouseUpOnSpinner=function(t){if(this.prevValue=this.value,this.isPrevFocused&&(this.element.focus(),e.Browser.isDevice||(this.isPrevFocused=!1)),e.Browser.isDevice||t.preventDefault(),this.getElementData(t)){var i=t.currentTarget,s=i.classList.contains(W)?j:_;e.EventHandler.remove(i,"mouseleave",this.mouseUpClick),this.isCalled||this.action(s,t),this.isCalled=!1,e.EventHandler.remove(document,"mouseup",this.mouseUpClick);if(e.closest(this.element,"form")){var n=this.element.nextElementSibling,a=document.createEvent("KeyboardEvent");a.initEvent("keyup",!1,!0),n.dispatchEvent(a)}}},s.prototype.getElementData=function(t){return!(t.which&&3===t.which||t.button&&2===t.button||!this.enabled||this.readonly)&&(clearInterval(this.timeOut),!0)},s.prototype.floatLabelTypeUpdate=function(){t.Input.removeFloating(this.inputWrapper);var e=this.hiddenInput;this.hiddenInput.remove(),t.Input.addFloating(this.element,this.floatLabelType,this.placeholder,this.createElement),this.container.insertBefore(e,this.container.childNodes[1])},s.prototype.mouseUpClick=function(t){t.stopPropagation(),clearInterval(this.timeOut),this.isCalled=!1,e.EventHandler.remove(this.spinUp,"mouseleave",this.mouseUpClick),e.EventHandler.remove(this.spinDown,"mouseleave",this.mouseUpClick)},s.prototype.increment=function(t){void 0===t&&(t=this.step),this.isInteract=!1,this.changeValue(this.performAction(this.value,t,j)),this.raiseChangeEvent()},s.prototype.decrement=function(t){void 0===t&&(t=this.step),this.isInteract=!1,this.changeValue(this.performAction(this.value,t,_)),this.raiseChangeEvent()},s.prototype.destroy=function(){this.unwireEvents(),e.detach(this.hiddenInput),this.showSpinButton&&(this.unwireSpinBtnEvents(),e.detach(this.spinUp),e.detach(this.spinDown));for(var t=["aria-labelledby","role","autocomplete","aria-readonly","autocorrect","aria-disabled","aria-placeholder","autocapitalize","spellcheck","aria-autocomplete","tabindex","aria-valuemin","aria-valuemax","aria-live","aria-valuenow","aria-invalid"],s=0;s<t.length;s++)this.element.removeAttribute(t[s]);this.element.classList.remove("e-input"),this.container.insertAdjacentElement("afterend",this.element),e.detach(this.container),i.prototype.destroy.call(this)},s.prototype.getText=function(){return this.element.value},s.prototype.focusIn=function(){document.activeElement!==this.element&&this.enabled&&(this.element.focus(),e.addClass([this.container],[K]))},s.prototype.focusOut=function(){document.activeElement===this.element&&this.enabled&&(this.element.blur(),e.removeClass([this.container],[K]))},s.prototype.getPersistData=function(){return this.addOnPersist(["value"])},s.prototype.onPropertyChanged=function(i,s){for(var n=0,a=Object.keys(i);n<a.length;n++){var r=a[n];switch(r){case"width":this.setElementWidth(i.width);break;case"cssClass":this.updateCssClass(i.cssClass,s.cssClass);break;case"enabled":t.Input.setEnabled(i.enabled,this.element);break;case"enableRtl":t.Input.setEnableRtl(i.enableRtl,[this.container]);break;case"readonly":t.Input.setReadonly(i.readonly,this.element),this.readonly?e.attributes(this.element,{"aria-readonly":"true"}):this.element.removeAttribute("aria-readonly");break;case"htmlAttributes":this.updateHTMLAttrToElement(),this.updateHTMLAttrToWrapper(),this.updateDataAttribute(!0),this.checkAttributes(!0),t.Input.validateInputType(this.container,this.element);break;case"placeholder":t.Input.setPlaceholder(i.placeholder,this.element);break;case"step":this.step=i.step,this.validateStep();break;case"showSpinButton":this.updateSpinButton(i);break;case"showClearButton":this.updateClearButton(i);break;case"floatLabelType":this.floatLabelType=i.floatLabelType,this.floatLabelTypeUpdate();break;case"value":this.isDynamicChange=(this.isAngular||this.isVue)&&this.preventChange,this.updateValue(i.value),this.isDynamicChange&&(this.preventChange=!1,this.isDynamicChange=!1);break;case"min":case"max":e.setValue(r,e.getValue(r,i),this),this.validateMinMax(),this.updateValue(this.value);break;case"strictMode":this.strictMode=i.strictMode,this.updateValue(this.value),this.validateState();break;case"locale":this.initCultureFunc(),this.l10n.setLocale(this.locale),this.setSpinButton(),this.updatePlaceholder(),t.Input.setPlaceholder(this.placeholder,this.element),this.updateValue(this.value);break;case"currency":var l=e.getValue(r,i);this.setProperties({currencyCode:l},!0),this.updateCurrency(r,l);break;case"currencyCode":var o=e.getValue(r,i);this.setProperties({currency:o},!0),this.updateCurrency("currency",o);break;case"format":e.setValue(r,e.getValue(r,i),this),this.initCultureInfo(),this.updateValue(this.value);break;case"decimals":this.decimals=i.decimals,this.updateValue(this.value)}}},s.prototype.updateClearButton=function(e){t.Input.setClearButton(e.showClearButton,this.element,this.inputWrapper,void 0,this.createElement),this.bindClearEvent()},s.prototype.updateSpinButton=function(t){t.showSpinButton?this.spinBtnCreation():(e.detach(this.spinUp),e.detach(this.spinDown))},s.prototype.getModuleName=function(){return"numerictextbox"},z([e.Property("")],s.prototype,"cssClass",void 0),z([e.Property(null)],s.prototype,"value",void 0),z([e.Property(-Number.MAX_VALUE)],s.prototype,"min",void 0),z([e.Property(Number.MAX_VALUE)],s.prototype,"max",void 0),z([e.Property(1)],s.prototype,"step",void 0),z([e.Property(null)],s.prototype,"width",void 0),z([e.Property(null)],s.prototype,"placeholder",void 0),z([e.Property({})],s.prototype,"htmlAttributes",void 0),z([e.Property(!0)],s.prototype,"showSpinButton",void 0),z([e.Property(!1)],s.prototype,"readonly",void 0),z([e.Property(!0)],s.prototype,"enabled",void 0),z([e.Property(!1)],s.prototype,"showClearButton",void 0),z([e.Property(!1)],s.prototype,"enablePersistence",void 0),z([e.Property("n2")],s.prototype,"format",void 0),z([e.Property(null)],s.prototype,"decimals",void 0),z([e.Property(null)],s.prototype,"currency",void 0),z([e.Property(null)],s.prototype,"currencyCode",void 0),z([e.Property(!0)],s.prototype,"strictMode",void 0),z([e.Property(!1)],s.prototype,"validateDecimalOnType",void 0),z([e.Property("Never")],s.prototype,"floatLabelType",void 0),z([e.Event()],s.prototype,"created",void 0),z([e.Event()],s.prototype,"destroyed",void 0),z([e.Event()],s.prototype,"change",void 0),z([e.Event()],s.prototype,"focus",void 0),z([e.Event()],s.prototype,"blur",void 0),s=z([e.NotifyPropertyChanges],s)}(e.Component),G="e-error",J="e-input-group",$="e-float-input",Q="e-utility-mask",tt="e-label-top",et="e-label-bottom",it={0:"[0-9]",9:"[0-9 ]","#":"[0-9 +-]",L:"[A-Za-z]","?":"[A-Za-z ]","&":"[^ ]+",C:"[^]+",A:"[A-Za-z0-9]",a:"[A-Za-z0-9 ]"},st=function(){return function(){}}(),nt=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function s(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),at=function(t,e,i,s){var n,a=arguments.length,r=a<3?e:null===s?s=Object.getOwnPropertyDescriptor(e,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(t,e,i,s);else for(var l=t.length-1;l>=0;l--)(n=t[l])&&(r=(a<3?n(r):a>3?n(e,i,r):n(e,i))||r);return a>3&&r&&Object.defineProperty(e,i,r),r},rt="e-input-focus",lt=["title","style","class"],ot=function(i){function s(t,e){var s=i.call(this,t,e)||this;return s.initInputValue="",s.isAngular=!1,s.preventChange=!1,s.isClicked=!1,s.maskOptions=t,s}return nt(s,i),s.prototype.getModuleName=function(){return"maskedtextbox"},s.prototype.preRender=function(){this.promptMask="",this.hiddenMask="",this.escapeMaskValue="",this.regExpCollec=it,this.customRegExpCollec=[],this.undoCollec=[],this.redoCollec=[],this.changeEventArgs={},this.focusEventArgs={},this.blurEventArgs={},this.maskKeyPress=!1,this.isFocus=!1,this.isInitial=!1,this.isIosInvalid=!1;var t=e.getValue("ej2_instances",this.element);if(this.cloneElement=this.element.cloneNode(!0),e.removeClass([this.cloneElement],["e-control","e-maskedtextbox","e-lib"]),this.angularTagName=null,this.formElement=e.closest(this.element,"form"),"EJS-MASKEDTEXTBOX"===this.element.tagName){this.angularTagName=this.element.tagName;for(var i=this.createElement("input"),s=0;s<this.element.attributes.length;s++)i.setAttribute(this.element.attributes[s].nodeName,this.element.attributes[s].nodeValue),i.innerHTML=this.element.innerHTML;this.element.hasAttribute("id")&&this.element.removeAttribute("id"),this.element.classList.remove("e-control","e-maskedtextbox"),this.element.classList.add("e-mask-container"),this.element.appendChild(i),this.element=i,e.setValue("ej2_instances",t,this.element)}this.updateHTMLAttrToElement(),this.checkHtmlAttributes(!1),this.formElement&&(this.initInputValue=this.value)},s.prototype.getPersistData=function(){return this.addOnPersist(["value"])},s.prototype.render=function(){"input"===this.element.tagName.toLowerCase()&&("Never"===this.floatLabelType&&e.addClass([this.element],"e-input"),this.createWrapper(),this.updateHTMLAttrToWrapper(),""===this.element.name&&this.element.setAttribute("name",this.element.id),this.isInitial=!0,this.resetMaskedTextBox(),this.isInitial=!1,this.setMaskPlaceholder(!0,!1),this.setWidth(this.width),this.preEleVal=this.element.value,e.Browser.isDevice||"11.0"!==e.Browser.info.version&&"edge"!==e.Browser.info.name||this.element.blur(),e.Browser.isDevice&&e.Browser.isIos&&this.element.blur(),(this.element.getAttribute("value")||this.value)&&this.element.setAttribute("value",this.element.value),this.renderComplete())},s.prototype.updateHTMLAttrToElement=function(){if(!e.isNullOrUndefined(this.htmlAttributes))for(var t=0,i=Object.keys(this.htmlAttributes);t<i.length;t++){var s=i[t];lt.indexOf(s)<0&&this.element.setAttribute(s,this.htmlAttributes[s])}},s.prototype.updateCssClass=function(e,i){t.Input.setCssClass(this.getValidClassList(e),[this.inputObj.container],this.getValidClassList(i))},s.prototype.getValidClassList=function(t){var i=t;return e.isNullOrUndefined(t)||""===t||(i=t.replace(/\s+/g," ").trim()),i},s.prototype.updateHTMLAttrToWrapper=function(){if(!e.isNullOrUndefined(this.htmlAttributes))for(var t=0,i=Object.keys(this.htmlAttributes);t<i.length;t++){var s=i[t];if(lt.indexOf(s)>-1)if("class"===s){var n=this.htmlAttributes[s].replace(/\s+/g," ").trim();""!==n&&e.addClass([this.inputObj.container],n.split(" "))}else if("style"===s){var a=this.inputObj.container.getAttribute(s);a=e.isNullOrUndefined(a)?this.htmlAttributes[s]:a+this.htmlAttributes[s],this.inputObj.container.setAttribute(s,a)}else this.inputObj.container.setAttribute(s,this.htmlAttributes[s])}},s.prototype.resetMaskedTextBox=function(){this.promptMask="",this.hiddenMask="",this.escapeMaskValue="",this.customRegExpCollec=[],this.undoCollec=[],this.redoCollec=[],this.promptChar.length>1&&(this.promptChar=this.promptChar[0]),n.call(this),a.call(this),(null===this.mask||""===this.mask&&void 0!==this.value)&&V.call(this,this.value);var t=u.call(this,this.element);this.prevValue=t,this.value=t,this.isInitial||l.call(this),r.call(this)},s.prototype.setMaskPlaceholder=function(e,i){(i||this.placeholder)&&(t.Input.setPlaceholder(this.placeholder,this.element),(this.element.value===this.promptMask&&e&&"Always"!==this.floatLabelType||this.element.value===this.promptMask&&"Never"===this.floatLabelType)&&V.call(this,""))},s.prototype.setWidth=function(t){if(!e.isNullOrUndefined(t))if("number"==typeof t)this.inputObj.container.style.width=e.formatUnit(t),this.element.style.width=e.formatUnit(t);else if("string"==typeof t){var i=t.match(/px|%|em/)?t:e.formatUnit(t);this.inputObj.container.style.width=i,this.element.style.width=i}},s.prototype.checkHtmlAttributes=function(t){for(var i=0,s=t?e.isNullOrUndefined(this.htmlAttributes)?[]:Object.keys(this.htmlAttributes):["placeholder","disabled","value","readonly"];i<s.length;i++){var n=s[i];if(!e.isNullOrUndefined(this.element.getAttribute(n)))switch(n){case"placeholder":(e.isNullOrUndefined(this.maskOptions)||void 0===this.maskOptions.placeholder||t)&&this.setProperties({placeholder:this.element.placeholder},!t);break;case"disabled":if(e.isNullOrUndefined(this.maskOptions)||void 0===this.maskOptions.enabled||t){var a="disabled"!==this.element.getAttribute(n)&&""!==this.element.getAttribute(n)&&"true"!==this.element.getAttribute(n);this.setProperties({enabled:a},!t)}break;case"value":(e.isNullOrUndefined(this.maskOptions)||void 0===this.maskOptions.value||t)&&this.setProperties({value:this.element.value},!t);break;case"readonly":if(e.isNullOrUndefined(this.maskOptions)||void 0===this.maskOptions.readonly||t){var r="readonly"===this.element.getAttribute(n)||""===this.element.getAttribute(n)||"true"===this.element.getAttribute(n);this.setProperties({readonly:r},!t)}}}},s.prototype.createWrapper=function(){var i=this.cssClass;e.isNullOrUndefined(this.cssClass)||""===this.cssClass||(i=this.getValidClassList(this.cssClass)),this.inputObj=t.Input.createInput({element:this.element,floatLabelType:this.floatLabelType,properties:{enableRtl:this.enableRtl,cssClass:i,enabled:this.enabled,readonly:this.readonly,placeholder:this.placeholder,showClearButton:this.showClearButton}},this.createElement),this.inputObj.container.setAttribute("class","e-control-wrapper e-mask "+this.inputObj.container.getAttribute("class"))},s.prototype.onPropertyChanged=function(e,i){for(var s=0,n=Object.keys(e);s<n.length;s++){switch(n[s]){case"value":R.call(this,this.value),this.placeholder&&this.setMaskPlaceholder(!1,!1);break;case"placeholder":this.setMaskPlaceholder(!0,!0);break;case"width":this.setWidth(e.width);break;case"cssClass":this.updateCssClass(e.cssClass,i.cssClass);break;case"enabled":t.Input.setEnabled(e.enabled,this.element,this.floatLabelType,this.inputObj.container);break;case"readonly":t.Input.setReadonly(e.readonly,this.element);break;case"enableRtl":t.Input.setEnableRtl(e.enableRtl,[this.inputObj.container]);break;case"customCharacters":this.customCharacters=e.customCharacters,this.resetMaskedTextBox();break;case"showClearButton":t.Input.setClearButton(e.showClearButton,this.element,this.inputObj,void 0,this.createElement),o.call(this);break;case"floatLabelType":this.floatLabelType=e.floatLabelType,t.Input.removeFloating(this.inputObj),t.Input.addFloating(this.element,this.floatLabelType,this.placeholder,this.createElement);break;case"htmlAttributes":this.updateHTMLAttrToElement(),this.updateHTMLAttrToWrapper(),this.checkHtmlAttributes(!0);break;case"mask":var a=this.value;this.mask=e.mask,this.updateValue(a);break;case"promptChar":e.promptChar.length>1&&(e.promptChar=e.promptChar[0]),e.promptChar?this.promptChar=e.promptChar:this.promptChar="_";var r=this.element.value.replace(new RegExp("["+i.promptChar+"]","g"),this.promptChar);this.promptMask===this.element.value&&(r=this.promptMask.replace(new RegExp("["+i.promptChar+"]","g"),this.promptChar)),this.promptMask=this.promptMask.replace(new RegExp("["+i.promptChar+"]","g"),this.promptChar),this.undoCollec=this.redoCollec=[],V.call(this,r)}}this.preventChange=this.isAngular&&this.preventChange?!this.preventChange:this.preventChange},s.prototype.updateValue=function(t){this.resetMaskedTextBox(),R.call(this,t)},s.prototype.getMaskedValue=function(){return c.call(this,this.element)},s.prototype.focusIn=function(){document.activeElement!==this.element&&this.enabled&&(this.element.focus(),e.addClass([this.inputObj.container],[rt]))},s.prototype.focusOut=function(){document.activeElement===this.element&&this.enabled&&(this.element.blur(),e.removeClass([this.inputObj.container],[rt]))},s.prototype.destroy=function(){l.call(this);for(var t=["aria-labelledby","role","autocomplete","aria-readonly","autocorrect","aria-disabled","aria-placeholder","autocapitalize","spellcheck","aria-autocomplete","aria-live","aria-valuenow","aria-invalid"],s=0;s<t.length;s++)this.element.removeAttribute(t[s]);this.element.classList.remove("e-input"),this.inputObj.container.insertAdjacentElement("afterend",this.element),e.detach(this.inputObj.container),i.prototype.destroy.call(this)},at([e.Property(null)],s.prototype,"cssClass",void 0),at([e.Property(null)],s.prototype,"width",void 0),at([e.Property(null)],s.prototype,"placeholder",void 0),at([e.Property("Never")],s.prototype,"floatLabelType",void 0),at([e.Property({})],s.prototype,"htmlAttributes",void 0),at([e.Property(!0)],s.prototype,"enabled",void 0),at([e.Property(!1)],s.prototype,"readonly",void 0),at([e.Property(!1)],s.prototype,"showClearButton",void 0),at([e.Property(!1)],s.prototype,"enablePersistence",void 0),at([e.Property(null)],s.prototype,"mask",void 0),at([e.Property("_")],s.prototype,"promptChar",void 0),at([e.Property(null)],s.prototype,"value",void 0),at([e.Property(null)],s.prototype,"customCharacters",void 0),at([e.Event()],s.prototype,"created",void 0),at([e.Event()],s.prototype,"destroyed",void 0),at([e.Event()],s.prototype,"change",void 0),at([e.Event()],s.prototype,"focus",void 0),at([e.Event()],s.prototype,"blur",void 0),s=at([e.NotifyPropertyChanges],s)}(e.Component),ht=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function s(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),dt=function(t,e,i,s){var n,a=arguments.length,r=a<3?e:null===s?s=Object.getOwnPropertyDescriptor(e,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(t,e,i,s);else for(var l=t.length-1;l>=0;l--)(n=t[l])&&(r=(a<3?n(r):a>3?n(e,i,r):n(e,i))||r);return a>3&&r&&Object.defineProperty(e,i,r),r},ct=function(t){function i(){return null!==t&&t.apply(this,arguments)||this}return ht(i,t),dt([e.Property("None")],i.prototype,"placement",void 0),dt([e.Property(10)],i.prototype,"largeStep",void 0),dt([e.Property(1)],i.prototype,"smallStep",void 0),dt([e.Property(!1)],i.prototype,"showSmallTicks",void 0),dt([e.Property(null)],i.prototype,"format",void 0),i}(e.ChildProperty),ut=function(t){function i(){return null!==t&&t.apply(this,arguments)||this}return ht(i,t),dt([e.Property(null)],i.prototype,"color",void 0),dt([e.Property(null)],i.prototype,"start",void 0),dt([e.Property(null)],i.prototype,"end",void 0),i}(e.ChildProperty),pt=function(t){function i(){return null!==t&&t.apply(this,arguments)||this}return ht(i,t),dt([e.Property(!1)],i.prototype,"enabled",void 0),dt([e.Property(null)],i.prototype,"minStart",void 0),dt([e.Property(null)],i.prototype,"minEnd",void 0),dt([e.Property(null)],i.prototype,"maxStart",void 0),dt([e.Property(null)],i.prototype,"maxEnd",void 0),dt([e.Property(!1)],i.prototype,"startHandleFixed",void 0),dt([e.Property(!1)],i.prototype,"endHandleFixed",void 0),i}(e.ChildProperty),mt=function(t){function i(){return null!==t&&t.apply(this,arguments)||this}return ht(i,t),dt([e.Property("")],i.prototype,"cssClass",void 0),dt([e.Property("Before")],i.prototype,"placement",void 0),dt([e.Property("Focus")],i.prototype,"showOn",void 0),dt([e.Property(!1)],i.prototype,"isVisible",void 0),dt([e.Property(null)],i.prototype,"format",void 0),i}(e.ChildProperty),vt="e-slider",ft="e-rtl",gt="e-slider-input",yt="e-control-wrapper",bt="e-handle",Ct="e-range",Et="e-slider-button",xt="e-first-button",St="e-second-button",kt="e-scale",Pt="e-tick",Ot="e-large",Tt="e-tick-value",Lt="e-slider-tooltip",At="e-slider-hover",Nt="e-handle-first",wt="e-handle-second",Ht="e-disabled",Bt="e-slider-container",Ut="e-slider-horizontal-before",Rt="e-slider-horizontal-after",Vt="e-slider-vertical-before",Ft="e-slider-vertical-after",Mt="e-material-tooltip-open",It="e-tooltip-active",Dt="e-material-slider",zt="e-slider-track",qt="e-slider-horizantal-color",Wt="e-slider-vertical-color",jt="e-handle-focused",_t="e-vertical",Xt="e-horizontal",Kt="e-handle-start",Zt="e-material-tooltip-start",Yt="e-tab-handle",Gt="e-button-icon",Jt="e-small-size",$t="e-tick-pos",Qt="e-first-tick",te="e-last-tick",ee="e-slider-btn",ie="e-tab-track",se="e-tab-range",ne="e-handle-active",ae="e-material-handle",re="e-material-range",le="e-material-default",oe="e-material-tooltip-show",he="e-material-tooltip-hide",de="e-read-only",ce="e-limits",ue="e-limit-bar",pe="e-limit-first",me="e-limit-second",ve="e-drag-horizontal",fe="e-drag-vertical",ge=function(t){function s(e,i){var s=t.call(this,e,i)||this;return s.horDir="left",s.verDir="bottom",s.transition={handle:"left .4s cubic-bezier(.25, .8, .25, 1), right .4s cubic-bezier(.25, .8, .25, 1), top .4s cubic-bezier(.25, .8, .25, 1) , bottom .4s cubic-bezier(.25, .8, .25, 1)",rangeBar:"all .4s cubic-bezier(.25, .8, .25, 1)"},s.transitionOnMaterialTooltip={handle:"left 1ms ease-out, right 1ms ease-out, bottom 1ms ease-out, top 1ms ease-out",rangeBar:"left 1ms ease-out, right 1ms ease-out, bottom 1ms ease-out, width 1ms ease-out, height 1ms ease-out"},s.scaleTransform="transform .4s cubic-bezier(.25, .8, .25, 1)",s.customAriaText=null,s.drag=!0,s.isDragComplete=!1,s.initialTooltip=!0,s}return ht(s,t),s.prototype.preRender=function(){this.l10n=new e.L10n("slider",{incrementTitle:"Increase",decrementTitle:"Decrease"},this.locale),this.isElementFocused=!1,this.tickElementCollection=[],this.tooltipFormatInfo={},this.ticksFormatInfo={},this.initCultureInfo(),this.initCultureFunc(),this.formChecker()},s.prototype.formChecker=function(){var t=e.closest(this.element,"form");t?(this.isForm=!0,e.isNullOrUndefined(this.formResetValue)||this.setProperties({value:this.formResetValue},!0),this.formResetValue=this.value,"Range"!==this.type||!e.isNullOrUndefined(this.formResetValue)&&"object"==typeof this.formResetValue?e.isNullOrUndefined(this.formResetValue)&&(this.formResetValue=parseFloat(e.formatUnit(this.min))):this.formResetValue=[parseFloat(e.formatUnit(this.min)),parseFloat(e.formatUnit(this.max))],this.formElement=t):this.isForm=!1},s.prototype.initCultureFunc=function(){this.internationalization=new e.Internationalization(this.locale)},s.prototype.initCultureInfo=function(){this.tooltipFormatInfo.format=e.isNullOrUndefined(this.tooltip.format)?null:this.tooltip.format,this.ticksFormatInfo.format=e.isNullOrUndefined(this.ticks.format)?null:this.ticks.format},s.prototype.formatString=function(t,e){var i=null,s=null;if(t||0===t){i=this.formatNumber(t);var n=this.numberOfDecimals(t);s=this.internationalization.getNumberFormat(e)(this.makeRoundNumber(t,n))}return{elementVal:i,formatString:s}},s.prototype.formatNumber=function(t){var e=this.numberOfDecimals(t);return this.internationalization.getNumberFormat({maximumFractionDigits:e,minimumFractionDigits:e,useGrouping:!1})(t)},s.prototype.numberOfDecimals=function(t){var e=t.toString().split(".")[1];return e&&e.length?e.length:0},s.prototype.makeRoundNumber=function(t,e){var i=e||0;return Number(t.toFixed(i))},s.prototype.fractionalToInteger=function(t){t=0===this.numberOfDecimals(t)?Number(t).toFixed(this.noOfDecimals):t;for(var e=1,i=0;i<this.noOfDecimals;i++)e*=10;return t=Number((t*e).toFixed(0))},s.prototype.render=function(){var t=this;this.initialize(),this.initRender(),this.wireEvents(),this.setZindex(),this.renderComplete(),"EJS-SLIDER"===this.element.tagName&&"none"==this.getTheme(this.sliderContainer)&&setTimeout(function(){t.refresh()},0)},s.prototype.initialize=function(){e.addClass([this.element],vt),this.setCSSClass()},s.prototype.setElementWidth=function(t){e.isNullOrUndefined(t)||("number"==typeof t?this.sliderContainer.style.width=e.formatUnit(t):"string"==typeof t&&(this.sliderContainer.style.width=t.match(/px|%|em/)?t:e.formatUnit(t)))},s.prototype.setCSSClass=function(t){t&&e.removeClass([this.element],t.split(" ")),this.cssClass&&e.addClass([this.element],this.cssClass.split(" "))},s.prototype.setEnabled=function(){this.enabled?(e.removeClass([this.sliderContainer],[Ht]),this.tooltip.isVisible&&this.tooltipElement&&"Always"===this.tooltip.showOn&&this.tooltipElement.classList.remove(Ht),this.wireEvents()):(e.addClass([this.sliderContainer],[Ht]),this.tooltip.isVisible&&this.tooltipElement&&"Always"===this.tooltip.showOn&&this.tooltipElement.classList.add(Ht),this.unwireEvents())},s.prototype.getTheme=function(t){return window.getComputedStyle(t,":after").getPropertyValue("content").replace(/['"]+/g,"")},s.prototype.initRender=function(){this.sliderContainer=this.createElement("div",{className:Bt+" "+yt}),this.element.parentNode.insertBefore(this.sliderContainer,this.element),this.sliderContainer.appendChild(this.element),this.sliderTrack=this.createElement("div",{className:zt}),this.element.appendChild(this.sliderTrack),this.setElementWidth(this.width),this.element.tabIndex=-1,this.getThemeInitialization(),this.setHandler(),this.createRangeBar(),this.limits.enabled&&this.createLimitBar(),this.setOrientClass(),this.hiddenInput=this.createElement("input",{attrs:{type:"hidden",value:e.isNullOrUndefined(this.value)?this.min.toString():this.value.toString(),name:this.element.getAttribute("name")||this.element.getAttribute("id")||"_"+(1e3*Math.random()).toFixed(0)+"slider",class:gt}}),this.hiddenInput.tabIndex=-1,this.sliderContainer.appendChild(this.hiddenInput),this.showButtons&&this.setButtons(),this.setEnableRTL(),"Range"===this.type?this.rangeValueUpdate():this.value=e.isNullOrUndefined(this.value)?parseFloat(e.formatUnit(this.min.toString())):this.value,this.previousVal="Range"!==this.type?this.checkHandleValue(parseFloat(e.formatUnit(this.value.toString()))):[this.checkHandleValue(parseFloat(e.formatUnit(this.value[0].toString()))),this.checkHandleValue(parseFloat(e.formatUnit(this.value[1].toString())))],this.previousChanged=this.previousVal,e.isNullOrUndefined(this.element.hasAttribute("name"))||this.element.removeAttribute("name"),this.setValue(),this.limits.enabled&&this.setLimitBar(),"None"!==this.ticks.placement&&this.renderScale(),this.tooltip.isVisible&&this.renderTooltip(),this.enabled?e.removeClass([this.sliderContainer],[Ht]):e.addClass([this.sliderContainer],[Ht]),this.readonly?e.addClass([this.sliderContainer],[de]):e.removeClass([this.sliderContainer],[de])},s.prototype.getThemeInitialization=function(){this.isMaterial="material"===this.getTheme(this.sliderContainer)||"material-dark"===this.getTheme(this.sliderContainer),this.isBootstrap="bootstrap"===this.getTheme(this.sliderContainer)||"bootstrap-dark"===this.getTheme(this.sliderContainer),this.isBootstrap4="bootstrap4"===this.getTheme(this.sliderContainer),this.isTailwind="tailwind"===this.getTheme(this.sliderContainer)||"tailwind-dark"===this.getTheme(this.sliderContainer),this.isBootstrap5="bootstrap5"===this.getTheme(this.sliderContainer),this.isMaterialTooltip=this.isMaterial&&"Range"!==this.type&&this.tooltip.isVisible},s.prototype.createRangeBar=function(){"Default"!==this.type&&(this.rangeBar=this.createElement("div",{attrs:{class:Ct}}),this.element.appendChild(this.rangeBar),this.drag&&"Range"===this.type&&("Horizontal"===this.orientation?this.rangeBar.classList.add(ve):this.rangeBar.classList.add(fe)))},s.prototype.createLimitBar=function(){var t="Range"!==this.type?ue:pe;t+=" "+ce,this.limitBarFirst=this.createElement("div",{attrs:{class:t}}),this.element.appendChild(this.limitBarFirst),"Range"===this.type&&(this.limitBarSecond=this.createElement("div",{attrs:{class:me+" "+ce}}),this.element.appendChild(this.limitBarSecond))},s.prototype.setOrientClass=function(){"Vertical"!==this.orientation?(this.sliderContainer.classList.remove(_t),this.sliderContainer.classList.add(Xt),this.firstHandle.setAttribute("aria-orientation","horizontal"),"Range"===this.type&&this.secondHandle.setAttribute("aria-orientation","horizontal")):(this.sliderContainer.classList.remove(Xt),this.sliderContainer.classList.add(_t),this.firstHandle.setAttribute("aria-orientation","vertical"),"Range"===this.type&&this.secondHandle.setAttribute("aria-orientation","vertical"))},s.prototype.setAriaAttributes=function(t){var i=this,s=this.min,n=this.max;if(!e.isNullOrUndefined(this.customValues)&&this.customValues.length>0&&(s=this.customValues[0],n=this.customValues[this.customValues.length-1]),"Range"!==this.type)e.attributes(t,{"aria-valuemin":s.toString(),"aria-valuemax":n.toString()});else{(!e.isNullOrUndefined(this.customValues)&&this.customValues.length>0?[[s.toString(),this.customValues[this.value[1]].toString()],[this.customValues[this.value[0]].toString(),n.toString()]]:[[s.toString(),this.value[1].toString()],[this.value[0].toString(),n.toString()]]).forEach(function(t,s){var n=0===s?i.firstHandle:i.secondHandle;n&&e.attributes(n,{"aria-valuemin":t[0],"aria-valuemax":t[1]})})}},s.prototype.createSecondHandle=function(){this.secondHandle=this.createElement("div",{attrs:{class:bt,role:"slider",tabIndex:"0"}}),this.secondHandle.classList.add(wt),this.element.appendChild(this.secondHandle)},s.prototype.createFirstHandle=function(){this.firstHandle=this.createElement("div",{attrs:{class:bt,role:"slider",tabIndex:"0"}}),this.firstHandle.classList.add(Nt),this.element.appendChild(this.firstHandle),this.isMaterialTooltip&&(this.materialHandle=this.createElement("div",{attrs:{class:bt+" "+ae}}),this.element.appendChild(this.materialHandle))},s.prototype.wireFirstHandleEvt=function(t){t?(e.EventHandler.remove(this.firstHandle,"mousedown touchstart",this.handleFocus),e.EventHandler.remove(this.firstHandle,"transitionend",this.transitionEnd),e.EventHandler.remove(this.firstHandle,"mouseenter touchenter",this.handleOver),e.EventHandler.remove(this.firstHandle,"mouseleave touchend",this.handleLeave)):(e.EventHandler.add(this.firstHandle,"mousedown touchstart",this.handleFocus,this),e.EventHandler.add(this.firstHandle,"transitionend",this.transitionEnd,this),e.EventHandler.add(this.firstHandle,"mouseenter touchenter",this.handleOver,this),e.EventHandler.add(this.firstHandle,"mouseleave touchend",this.handleLeave,this))},s.prototype.wireSecondHandleEvt=function(t){t?(e.EventHandler.remove(this.secondHandle,"mousedown touchstart",this.handleFocus),e.EventHandler.remove(this.secondHandle,"transitionend",this.transitionEnd),e.EventHandler.remove(this.secondHandle,"mouseenter touchenter",this.handleOver),e.EventHandler.remove(this.secondHandle,"mouseleave touchend",this.handleLeave)):(e.EventHandler.add(this.secondHandle,"mousedown touchstart",this.handleFocus,this),e.EventHandler.add(this.secondHandle,"transitionend",this.transitionEnd,this),e.EventHandler.add(this.secondHandle,"mouseenter touchenter",this.handleOver,this),e.EventHandler.add(this.secondHandle,"mouseleave touchend",this.handleLeave,this))},s.prototype.handleStart=function(){"Range"!==this.type&&(this.firstHandle.classList[0===this.handlePos1?"add":"remove"](Kt),this.isMaterialTooltip&&(this.materialHandle.classList[0===this.handlePos1?"add":"remove"](Kt),this.tooltipElement&&this.tooltipElement.classList[0===this.handlePos1?"add":"remove"](Zt)))},s.prototype.transitionEnd=function(t){"transform"!==t.propertyName&&(this.handleStart(),this.getHandle().style.transition="none","Default"!==this.type&&(this.rangeBar.style.transition="none"),this.isMaterial&&this.tooltip.isVisible&&"Default"===this.type&&(this.tooltipElement.style.transition=this.transition.handle),this.tooltipToggle(this.getHandle()),this.closeTooltip())},s.prototype.handleFocusOut=function(){this.firstHandle.classList.contains(jt)&&this.firstHandle.classList.remove(jt),"Range"===this.type&&this.secondHandle.classList.contains(jt)&&this.secondHandle.classList.remove(jt)},s.prototype.handleFocus=function(t){this.focusSliderElement(),this.sliderBarClick(t),t.currentTarget===this.firstHandle?(this.firstHandle.classList.add(jt),this.firstHandle.classList.add(Yt)):(this.secondHandle.classList.add(jt),this.secondHandle.classList.add(Yt)),e.EventHandler.add(document,"mousemove touchmove",this.sliderBarMove,this),e.EventHandler.add(document,"mouseup touchend",this.sliderBarUp,this)},s.prototype.handleOver=function(t){this.tooltip.isVisible&&"Hover"===this.tooltip.showOn&&this.tooltipToggle(t.currentTarget),"Default"===this.type&&this.tooltipToggle(this.getHandle())},s.prototype.handleLeave=function(t){!this.tooltip.isVisible||"Hover"!==this.tooltip.showOn||t.currentTarget.classList.contains(jt)||t.currentTarget.classList.contains(Yt)||this.closeTooltip()},s.prototype.setHandler=function(){this.min>this.max&&(this.min=this.max),this.createFirstHandle(),"Range"===this.type&&this.createSecondHandle()},s.prototype.setEnableRTL=function(){this.enableRtl&&"Vertical"!==this.orientation?e.addClass([this.sliderContainer],ft):e.removeClass([this.sliderContainer],ft);var t="Vertical"!==this.orientation?this.horDir:this.verDir;this.enableRtl?(this.horDir="right",this.verDir="bottom"):(this.horDir="left",this.verDir="bottom");t!==("Vertical"!==this.orientation?this.horDir:this.verDir)&&"Horizontal"===this.orientation&&(e.setStyleAttribute(this.firstHandle,{right:"",left:"auto"}),"Range"===this.type&&e.setStyleAttribute(this.secondHandle,{top:"",left:"auto"})),this.setBarColor()},s.prototype.tooltipValue=function(){var t,e=this,i={value:this.value,text:""};this.initialTooltip&&(this.initialTooltip=!1,this.setTooltipContent(),i.text=t=this.tooltipObj.content,this.trigger("tooltipChange",i,function(i){e.addTooltipClass(i.text),t!==i.text&&(e.customAriaText=i.text,e.tooltipObj.content=i.text,e.setAriaAttrValue(e.firstHandle),"Range"===e.type&&e.setAriaAttrValue(e.secondHandle))}),this.isMaterialTooltip&&this.setPreviousVal("change",this.value))},s.prototype.setTooltipContent=function(){var t;t=this.formatContent(this.tooltipFormatInfo,!1),this.tooltipObj.content=t},s.prototype.formatContent=function(t,i){var s="",n=this.handleVal1,a=this.handleVal2;return!e.isNullOrUndefined(this.customValues)&&this.customValues.length>0&&(n=this.customValues[this.handleVal1],a=this.customValues[this.handleVal2]),i?("Range"===this.type?s=this.enableRtl&&"Vertical"!==this.orientation?e.isNullOrUndefined(this.tooltip)||e.isNullOrUndefined(this.tooltip.format)?a.toString()+" - "+n.toString():this.formatString(a,t).elementVal+" - "+this.formatString(n,t).elementVal:e.isNullOrUndefined(this.tooltip)||e.isNullOrUndefined(this.tooltip.format)?n.toString()+" - "+a.toString():this.formatString(n,t).elementVal+" - "+this.formatString(a,t).elementVal:e.isNullOrUndefined(n)||(s=e.isNullOrUndefined(this.tooltip)||e.isNullOrUndefined(this.tooltip.format)?n.toString():this.formatString(n,t).elementVal),s):("Range"===this.type?s=this.enableRtl&&"Vertical"!==this.orientation?e.isNullOrUndefined(t.format)?a.toString()+" - "+n.toString():this.formatString(a,t).formatString+" - "+this.formatString(n,t).formatString:e.isNullOrUndefined(t.format)?n.toString()+" - "+a.toString():this.formatString(n,t).formatString+" - "+this.formatString(a,t).formatString:e.isNullOrUndefined(n)||(s=e.isNullOrUndefined(t.format)?n.toString():this.formatString(n,t).formatString),s)},s.prototype.addTooltipClass=function(t){if(this.isMaterialTooltip){var e=t.toString().length;if(this.tooltipElement){i=e>4?{oldCss:le,newCss:re}:{oldCss:re,newCss:le};this.tooltipElement.classList.remove(i.oldCss),this.tooltipElement.classList.contains(i.newCss)||(this.tooltipElement.classList.add(i.newCss),this.tooltipElement.style.transform=e>4?"scale(1)":this.getTooltipTransformProperties(this.previousTooltipClass).rotate)}else{var i=e>4?re:le;this.tooltipObj.cssClass=Lt+" "+i}}},s.prototype.tooltipPlacement=function(){return"Horizontal"===this.orientation?"Before"===this.tooltip.placement?"TopCenter":"BottomCenter":"Before"===this.tooltip.placement?"LeftCenter":"RightCenter"},s.prototype.tooltipBeforeOpen=function(t){this.tooltipElement=t.element,this.tooltip.cssClass&&e.addClass([this.tooltipElement],this.tooltip.cssClass.split(" ").filter(function(t){return t})),t.target.removeAttribute("aria-describedby"),this.isMaterialTooltip&&(this.tooltipElement.firstElementChild.classList.add(he),this.handleStart(),this.setTooltipTransform())},s.prototype.tooltipCollision=function(t){if(this.isBootstrap||this.isBootstrap4||this.isMaterial&&!this.isMaterialTooltip){var e=this.isBootstrap4?3:6;switch(t){case"TopCenter":this.tooltipObj.setProperties({offsetY:-e},!1);break;case"BottomCenter":this.tooltipObj.setProperties({offsetY:e},!1);break;case"LeftCenter":this.tooltipObj.setProperties({offsetX:-e},!1);break;case"RightCenter":this.tooltipObj.setProperties({offsetX:e},!1)}}},s.prototype.materialTooltipEventCallBack=function(t){this.sliderBarClick(t),e.EventHandler.add(document,"mousemove touchmove",this.sliderBarMove,this),e.EventHandler.add(document,"mouseup touchend",this.sliderBarUp,this)},s.prototype.wireMaterialTooltipEvent=function(t){this.isMaterialTooltip&&(t?e.EventHandler.remove(this.tooltipElement,"mousedown touchstart",this.materialTooltipEventCallBack):e.EventHandler.add(this.tooltipElement,"mousedown touchstart",this.materialTooltipEventCallBack,this))},s.prototype.tooltipPositionCalculation=function(t){var e;switch(t){case"TopCenter":e=Ut;break;case"BottomCenter":e=Rt;break;case"LeftCenter":e=Vt;break;case"RightCenter":e=Ft}return e},s.prototype.getTooltipTransformProperties=function(t){var e;if(this.tooltipElement){var i="Horizontal"===this.orientation?this.tooltipElement.clientHeight+14-this.tooltipElement.clientHeight/2:this.tooltipElement.clientWidth+14-this.tooltipElement.clientWidth/2;e="Horizontal"===this.orientation?t===Ut?{rotate:"rotate(45deg)",translate:"translateY("+i+"px)"}:{rotate:"rotate(225deg)",translate:"translateY("+-i+"px)"}:t===Vt?{rotate:"rotate(-45deg)",translate:"translateX("+i+"px)"}:{rotate:"rotate(-225deg)",translate:"translateX("+-i+"px)"}}return e},s.prototype.openMaterialTooltip=function(){var t=this;if(this.isMaterialTooltip){this.refreshTooltip(this.firstHandle);var e=this.tooltipElement.firstElementChild;e.classList.remove(he),e.classList.add(oe),this.firstHandle.style.cursor="default",this.tooltipElement.style.transition=this.scaleTransform,this.tooltipElement.classList.add(Mt),this.materialHandle.style.transform="scale(0)",e.innerText.length>4?this.tooltipElement.style.transform="scale(1)":this.tooltipElement.style.transform=this.getTooltipTransformProperties(this.previousTooltipClass).rotate,"Default"===this.type?setTimeout(function(){t.tooltipElement.style.transition=t.transition.handle},2500):setTimeout(function(){t.tooltipElement.style.transition="none"},2500)}},s.prototype.closeMaterialTooltip=function(){var t=this;if(this.isMaterialTooltip){var e=this.tooltipElement.firstElementChild;this.tooltipElement.style.transition=this.scaleTransform,e.classList.remove(oe),e.classList.add(he),this.firstHandle.style.cursor="-webkit-grab",this.firstHandle.style.cursor="grab",this.materialHandle&&(this.materialHandle.style.transform="scale(1)"),this.tooltipElement.classList.remove(Mt),this.setTooltipTransform(),this.tooltipTarget=void 0,setTimeout(function(){t.tooltipElement.style.transition="none"},2500)}},s.prototype.checkTooltipPosition=function(t){var e=this.tooltipPositionCalculation(t.collidedPosition);void 0!==this.tooltipCollidedPosition&&this.tooltipCollidedPosition===t.collidedPosition&&t.element.classList.contains(e)||(this.isMaterialTooltip&&(void 0!==e&&(t.element.classList.remove(this.previousTooltipClass),t.element.classList.add(e),this.previousTooltipClass=e),t.element.style.transform&&t.element.classList.contains(Mt)&&t.element.firstElementChild.innerText.length<=4&&(t.element.style.transform=this.getTooltipTransformProperties(this.previousTooltipClass).rotate)),this.tooltipCollidedPosition=t.collidedPosition),this.isMaterialTooltip&&this.tooltipElement&&-1!==this.tooltipElement.style.transform.indexOf("translate")&&this.setTooltipTransform()},s.prototype.setTooltipTransform=function(){var t=this.getTooltipTransformProperties(this.previousTooltipClass);this.tooltipElement.firstElementChild.innerText.length>4?this.tooltipElement.style.transform=t.translate+" scale(0.01)":this.tooltipElement.style.transform=t.translate+" "+t.rotate+" scale(0.01)"},s.prototype.renderTooltip=function(){this.tooltipObj=new i.Tooltip({showTipPointer:this.isBootstrap||this.isMaterial||this.isBootstrap4||this.isTailwind||this.isBootstrap5,cssClass:Lt,height:this.isMaterial?30:"auto",animation:{open:{effect:"None"},close:{effect:"FadeOut",duration:500}},opensOn:"Custom",beforeOpen:this.tooltipBeforeOpen.bind(this),beforeCollision:this.checkTooltipPosition.bind(this),beforeClose:this.tooltipBeforeClose.bind(this),enableHtmlSanitizer:this.enableHtmlSanitizer}),this.tooltipObj.appendTo(this.firstHandle),this.initializeTooltipProps()},s.prototype.initializeTooltipProps=function(){var t="Auto"===this.tooltip.showOn?"Hover":this.tooltip.showOn;this.setProperties({tooltip:{showOn:t}},!0),this.tooltipObj.position=this.tooltipPlacement(),this.tooltipCollision(this.tooltipObj.position),[this.firstHandle,this.rangeBar,this.secondHandle].forEach(function(t){e.isNullOrUndefined(t)||(t.style.transition="none")}),this.isMaterialTooltip&&(this.sliderContainer.classList.add(Dt),this.tooltipValue(),this.tooltipObj.animation.close.effect="None",this.tooltipObj.open(this.firstHandle))},s.prototype.tooltipBeforeClose=function(){this.tooltipElement=void 0,this.tooltipCollidedPosition=void 0},s.prototype.setButtons=function(){this.firstBtn=this.createElement("div",{className:Et+" "+xt}),this.firstBtn.appendChild(this.createElement("span",{className:Gt})),this.isTailwind&&this.firstBtn.querySelector("span").classList.add("e-icons"),this.firstBtn.tabIndex=-1,this.secondBtn=this.createElement("div",{className:Et+" "+St}),this.secondBtn.appendChild(this.createElement("span",{className:Gt})),this.isTailwind&&this.secondBtn.querySelector("span").classList.add("e-icons"),this.secondBtn.tabIndex=-1,this.sliderContainer.classList.add(ee),this.sliderContainer.appendChild(this.firstBtn),this.sliderContainer.appendChild(this.secondBtn),this.sliderContainer.appendChild(this.element),this.buttonTitle()},s.prototype.buttonTitle=function(){var t=this.enableRtl&&"Vertical"!==this.orientation;this.l10n.setLocale(this.locale);var i=this.l10n.getConstant("decrementTitle"),s=this.l10n.getConstant("incrementTitle");e.attributes(t?this.secondBtn:this.firstBtn,{"aria-label":i,title:i}),e.attributes(t?this.firstBtn:this.secondBtn,{"aria-label":s,title:s})},s.prototype.buttonFocusOut=function(){this.isMaterial&&this.getHandle().classList.remove("e-large-thumb-size")},s.prototype.repeatButton=function(t){var e,i=this.handleValueUpdate(),s=this.enableRtl&&"Vertical"!==this.orientation;t.target.parentElement.classList.contains(xt)||t.target.classList.contains(xt)?e=s?this.add(i,parseFloat(this.step.toString()),!0):this.add(i,parseFloat(this.step.toString()),!1):(t.target.parentElement.classList.contains(St)||t.target.classList.contains(St))&&(e=s?this.add(i,parseFloat(this.step.toString()),!1):this.add(i,parseFloat(this.step.toString()),!0)),this.limits.enabled&&(e=this.getLimitCorrectedValues(e)),e>=this.min&&e<=this.max&&(this.changeHandleValue(e),this.tooltipToggle(this.getHandle()))},s.prototype.repeatHandlerMouse=function(t){t.preventDefault(),"mousedown"!==t.type&&"touchstart"!==t.type||(this.buttonClick(t),this.repeatInterval=setInterval(this.repeatButton.bind(this),180,t))},s.prototype.materialChange=function(){this.getHandle().classList.contains("e-large-thumb-size")||this.getHandle().classList.add("e-large-thumb-size")},s.prototype.focusHandle=function(){this.getHandle().classList.contains(Yt)||this.getHandle().classList.add(Yt)},s.prototype.repeatHandlerUp=function(t){this.changeEvent("changed",t),this.closeTooltip(),clearInterval(this.repeatInterval),this.getHandle().focus()},s.prototype.customTickCounter=function(t){var i=4;return!e.isNullOrUndefined(this.customValues)&&this.customValues.length>0&&(t>4&&(i=3),t>7&&(i=2),t>14&&(i=1),t>28&&(i=0)),i},s.prototype.renderScale=function(){var t="Vertical"===this.orientation?"v":"h";this.noOfDecimals=this.numberOfDecimals(this.step),this.ul=this.createElement("ul",{className:kt+" e-"+t+"-scale "+Pt+"-"+this.ticks.placement.toLowerCase(),attrs:{role:"presentation",tabIndex:"-1","aria-hidden":"true"}}),this.ul.style.zIndex="-1",e.Browser.isAndroid&&"h"===t&&this.ul.classList.add($t);var i=this.ticks.smallStep;this.ticks.showSmallTicks?i<=0&&(i=parseFloat(e.formatUnit(this.step))):i=this.ticks.largeStep>0?this.ticks.largeStep:parseFloat(e.formatUnit(this.max))-parseFloat(e.formatUnit(this.min));var s=this.fractionalToInteger(this.min),n=this.fractionalToInteger(this.max),a=this.fractionalToInteger(i),r=!e.isNullOrUndefined(this.customValues)&&this.customValues.length>0&&this.customValues.length-1,l=this.customTickCounter(r),o=!e.isNullOrUndefined(this.customValues)&&this.customValues.length>0?r*l+r:Math.abs((n-s)/a);this.element.appendChild(this.ul);var h,d=parseFloat(this.min.toString());"v"===t&&(d=parseFloat(this.max.toString()));var c,u=0,p=100/o;p===1/0&&(p=5);for(var m=0,v=!e.isNullOrUndefined(this.customValues)&&this.customValues.length>0?this.customValues.length-1:0,f=0;m<=o;m++){if(h=this.createElement("li",{attrs:{class:Pt,role:"presentation",tabIndex:"-1","aria-hidden":"true"}}),!e.isNullOrUndefined(this.customValues)&&this.customValues.length>0)(c=m%(l+1)==0)&&("h"===t?(d=this.customValues[f],f++):(d=this.customValues[v],v--),h.setAttribute("title",d.toString()));else if(h.setAttribute("title",d.toString()),0===this.numberOfDecimals(this.max)&&0===this.numberOfDecimals(this.min)&&0===this.numberOfDecimals(this.step))c="h"===t?(d-parseFloat(this.min.toString()))%this.ticks.largeStep==0:Math.abs(d-parseFloat(this.max.toString()))%this.ticks.largeStep==0;else{var g=this.fractionalToInteger(this.ticks.largeStep),y=this.fractionalToInteger(d);c="h"===t?(y-s)%g==0:Math.abs(y-parseFloat(n.toString()))%g==0}c&&h.classList.add(Ot),"h"===t?h.style.width=p+"%":h.style.height=p+"%";var b=c?"Both"===this.ticks.placement?2:1:0;if(c)for(var C=0;C<b;C++)this.createTick(h,d,p);else e.isNullOrUndefined(this.customValues)&&this.formatTicksValue(h,d);this.ul.appendChild(h),this.tickElementCollection.push(h);var E=void 0;e.isNullOrUndefined(this.customValues)&&(E=this.numberOfDecimals(i)>this.numberOfDecimals(d)?this.numberOfDecimals(i):this.numberOfDecimals(d),d="h"===t?this.makeRoundNumber(d+i,E):this.makeRoundNumber(d-i,E),u=this.makeRoundNumber(u+i,E))}this.ticksAlignment(t,p)},s.prototype.ticksAlignment=function(t,e,i){void 0===i&&(i=!0),this.firstChild=this.ul.firstElementChild,this.lastChild=this.ul.lastElementChild,this.firstChild.classList.add(Qt),this.lastChild.classList.add(te),this.sliderContainer.classList.add(kt+"-"+this.ticks.placement.toLowerCase()),"h"===t?(this.firstChild.style.width=e/2+"%",this.lastChild.style.width=e/2+"%"):(this.firstChild.style.height=e/2+"%",this.lastChild.style.height=e/2+"%");var s={ticksWrapper:this.ul,tickElements:this.tickElementCollection};i&&this.trigger("renderedTicks",s),this.scaleAlignment()},s.prototype.createTick=function(t,i,s){var n=this.createElement("span",{className:Tt+" "+Pt+"-"+this.ticks.placement.toLowerCase(),attrs:{role:"presentation",tabIndex:"-1","aria-hidden":"true"}});t.appendChild(n),e.isNullOrUndefined(this.customValues)?this.formatTicksValue(t,i,n,s):this.enableHtmlSanitizer?n.innerHTML=e.SanitizeHtmlHelper.sanitize(i.toString()):n.innerHTML=i.toString()},s.prototype.formatTicksValue=function(t,i,s,n){var a=this,r=this.formatNumber(i),l={value:i,text:e.isNullOrUndefined(this.ticks)||e.isNullOrUndefined(this.ticks.format)?r:this.formatString(i,this.ticksFormatInfo).formatString,tickElement:t};this.trigger("renderingTicks",l,function(i){t.setAttribute("title",i.text.toString()),s&&(a.enableHtmlSanitizer?s.innerHTML=e.SanitizeHtmlHelper.sanitize(i.text.toString()):s.innerHTML=i.text.toString())})},s.prototype.scaleAlignment=function(){this.tickValuePosition();this.orientation;"Vertical"===this.orientation?this.element.getBoundingClientRect().width<=15?this.sliderContainer.classList.add(Jt):this.sliderContainer.classList.remove(Jt):this.element.getBoundingClientRect().height<=15?this.sliderContainer.classList.add(Jt):this.sliderContainer.classList.remove(Jt)},s.prototype.tickValuePosition=function(){this.firstChild=this.element.querySelector("ul").children[0];var t,i,s=this.firstChild.getBoundingClientRect(),n=this.ticks.smallStep,a=Math.abs(parseFloat(e.formatUnit(this.max))-parseFloat(e.formatUnit(this.min)))/n;this.firstChild.children.length>0&&(t=this.firstChild.children[0].getBoundingClientRect());var r,l=[this.sliderContainer.querySelectorAll("."+Pt+"."+Ot+" ."+Tt)];r="Both"===this.ticks.placement?[].slice.call(l[0],2):[].slice.call(l[0],1);for(var o="Vertical"===this.orientation?2*s.height:2*s.width,h=0;h<this.firstChild.children.length;h++)"Vertical"===this.orientation?this.firstChild.children[h].style.top=-t.height/2+"px":this.enableRtl?this.firstChild.children[h].style.left=(o-this.firstChild.children[h].getBoundingClientRect().width)/2+"px":this.firstChild.children[h].style.left=-t.width/2+"px";for(h=0;h<r.length;h++)i=r[h].getBoundingClientRect(),"Vertical"===this.orientation?e.setStyleAttribute(r[h],{top:(o-i.height)/2+"px"}):e.setStyleAttribute(r[h],{left:(o-i.width)/2+"px"});this.enableRtl&&this.lastChild.children.length&&0!==a&&(this.lastChild.children[0].style.left=-this.lastChild.getBoundingClientRect().width/2+"px","Both"===this.ticks.placement&&(this.lastChild.children[1].style.left=-this.lastChild.getBoundingClientRect().width/2+"px")),0===a&&("Horizontal"===this.orientation&&(this.enableRtl?(this.firstChild.classList.remove(te),this.firstChild.style.right=this.firstHandle.style.right,this.firstChild.children[0].style.left=this.firstChild.getBoundingClientRect().width/2+2+"px","Both"===this.ticks.placement&&(this.firstChild.children[1].style.left=this.firstChild.getBoundingClientRect().width/2+2+"px")):(this.firstChild.classList.remove(te),this.firstChild.style.left=this.firstHandle.style.left)),"Vertical"===this.orientation&&this.firstChild.classList.remove(te))},s.prototype.setAriaAttrValue=function(t){var i,s=!e.isNullOrUndefined(this.ticks)&&!e.isNullOrUndefined(this.ticks.format),n=s?this.formatContent(this.tooltipFormatInfo,!1):this.formatContent(this.ticksFormatInfo,!1),a=s?this.formatContent(this.ticksFormatInfo,!0):this.formatContent(this.tooltipFormatInfo,!0);i=2===(n=this.customAriaText?this.customAriaText:n).split(" - ").length?n.split(" - "):[n,n],this.setAriaAttributes(t),"Range"!==this.type?e.attributes(t,{"aria-valuenow":a,"aria-valuetext":n}):this.enableRtl?t===this.firstHandle?e.attributes(t,{"aria-valuenow":a.split(" - ")[1],"aria-valuetext":i[1]}):e.attributes(t,{"aria-valuenow":a.split(" - ")[0],"aria-valuetext":i[0]}):t===this.firstHandle?e.attributes(t,{"aria-valuenow":a.split(" - ")[0],"aria-valuetext":i[0]}):e.attributes(t,{"aria-valuenow":a.split(" - ")[1],"aria-valuetext":i[1]})},s.prototype.handleValueUpdate=function(){return"Range"===this.type?1===this.activeHandle?this.handleVal1:this.handleVal2:this.handleVal1},s.prototype.getLimitCorrectedValues=function(t){return t="MinRange"===this.type||"Default"===this.type?this.getLimitValueAndPosition(t,this.limits.minStart,this.limits.minEnd)[0]:1===this.activeHandle?this.getLimitValueAndPosition(t,this.limits.minStart,this.limits.minEnd)[0]:this.getLimitValueAndPosition(t,this.limits.maxStart,this.limits.maxEnd)[0]},s.prototype.focusSliderElement=function(){this.isElementFocused||(this.element.focus(),this.isElementFocused=!0)},s.prototype.buttonClick=function(t){this.focusSliderElement();var i,s=this.enableRtl&&"Vertical"!==this.orientation,n=this.handleValueUpdate();40===t.keyCode||37===t.keyCode||t.currentTarget.classList.contains(xt)?i=s?this.add(n,parseFloat(this.step.toString()),!0):this.add(n,parseFloat(this.step.toString()),!1):38===t.keyCode||39===t.keyCode||t.currentTarget.classList.contains(St)?i=s?this.add(n,parseFloat(this.step.toString()),!1):this.add(n,parseFloat(this.step.toString()),!0):33===t.keyCode||t.currentTarget.classList.contains(xt)?i=s?this.add(n,parseFloat(this.ticks.largeStep.toString()),!1):this.add(n,parseFloat(this.ticks.largeStep.toString()),!0):34===t.keyCode||t.currentTarget.classList.contains(St)?i=s?this.add(n,parseFloat(this.ticks.largeStep.toString()),!0):this.add(n,parseFloat(this.ticks.largeStep.toString()),!1):36===t.keyCode?i=parseFloat(this.min.toString()):35===t.keyCode&&(i=parseFloat(this.max.toString())),this.limits.enabled&&(i=this.getLimitCorrectedValues(i)),this.changeHandleValue(i),!this.isMaterial||this.tooltip.isVisible||this.getHandle().classList.contains(Yt)||this.materialChange(),this.tooltipToggle(this.getHandle()),this.getHandle().focus(),this.focusHandle(),t.currentTarget.classList.contains(xt)&&e.EventHandler.add(this.firstBtn,"mouseup touchend",this.buttonUp,this),t.currentTarget.classList.contains(St)&&e.EventHandler.add(this.secondBtn,"mouseup touchend",this.buttonUp,this)},s.prototype.tooltipToggle=function(t){this.isMaterialTooltip?this.tooltipElement.classList.contains(Mt)?this.refreshTooltip(this.firstHandle):this.openMaterialTooltip():this.tooltipElement?this.refreshTooltip(t):this.openTooltip(t)},s.prototype.buttonUp=function(t){t.currentTarget.classList.contains(xt)&&e.EventHandler.remove(this.firstBtn,"mouseup touchend",this.buttonUp),t.currentTarget.classList.contains(St)&&e.EventHandler.remove(this.secondBtn,"mouseup touchend",this.buttonUp)},s.prototype.setRangeBar=function(){"Horizontal"===this.orientation?"MinRange"===this.type?(this.enableRtl?this.rangeBar.style.right="0px":this.rangeBar.style.left="0px",e.setStyleAttribute(this.rangeBar,{width:e.isNullOrUndefined(this.handlePos1)?0:this.handlePos1+"px"})):(this.enableRtl?this.rangeBar.style.right=this.handlePos1+"px":this.rangeBar.style.left=this.handlePos1+"px",e.setStyleAttribute(this.rangeBar,{width:this.handlePos2-this.handlePos1+"px"})):"MinRange"===this.type?(this.rangeBar.style.bottom="0px",e.setStyleAttribute(this.rangeBar,{height:e.isNullOrUndefined(this.handlePos1)?0:this.handlePos1+"px"})):(this.rangeBar.style.bottom=this.handlePos1+"px",e.setStyleAttribute(this.rangeBar,{height:this.handlePos2-this.handlePos1+"px"}))},s.prototype.checkValidValueAndPos=function(t){return t=this.checkHandleValue(t),t=this.checkHandlePosition(t)},s.prototype.setLimitBarPositions=function(t,e,i,s){"Horizontal"===this.orientation?this.enableRtl?(this.limitBarFirst.style.right=t+"px",this.limitBarFirst.style.width=e-t+"px"):(this.limitBarFirst.style.left=t+"px",this.limitBarFirst.style.width=e-t+"px"):(this.limitBarFirst.style.bottom=t+"px",this.limitBarFirst.style.height=e-t+"px"),"Range"===this.type&&("Horizontal"===this.orientation?this.enableRtl?(this.limitBarSecond.style.right=i+"px",this.limitBarSecond.style.width=s-i+"px"):(this.limitBarSecond.style.left=i+"px",this.limitBarSecond.style.width=s-i+"px"):(this.limitBarSecond.style.bottom=i+"px",this.limitBarSecond.style.height=s-i+"px"))},s.prototype.setLimitBar=function(){if("Default"===this.type||"MinRange"===this.type){var t=this.getLimitValueAndPosition(this.limits.minStart,this.limits.minStart,this.limits.minEnd,!0)[0];t=this.checkValidValueAndPos(t);var e=this.getLimitValueAndPosition(this.limits.minEnd,this.limits.minStart,this.limits.minEnd,!0)[0];e=this.checkValidValueAndPos(e),this.setLimitBarPositions(t,e)}else if("Range"===this.type){var i=this.getLimitValueAndPosition(this.limits.minStart,this.limits.minStart,this.limits.minEnd,!0)[0];i=this.checkValidValueAndPos(i);var s=this.getLimitValueAndPosition(this.limits.minEnd,this.limits.minStart,this.limits.minEnd,!0)[0];s=this.checkValidValueAndPos(s);var n=this.getLimitValueAndPosition(this.limits.maxStart,this.limits.maxStart,this.limits.maxEnd,!0)[0];n=this.checkValidValueAndPos(n);var a=this.getLimitValueAndPosition(this.limits.maxEnd,this.limits.maxStart,this.limits.maxEnd,!0)[0];a=this.checkValidValueAndPos(a),this.setLimitBarPositions(i,s,n,a)}},s.prototype.getLimitValueAndPosition=function(t,i,s,n){return e.isNullOrUndefined(i)&&(i=this.min,e.isNullOrUndefined(t)&&n&&(t=i)),e.isNullOrUndefined(s)&&(s=this.max,e.isNullOrUndefined(t)&&n&&(t=s)),t<i&&(t=i),t>s&&(t=s),[t,this.checkHandlePosition(t)]},s.prototype.setValue=function(){if(!e.isNullOrUndefined(this.customValues)&&this.customValues.length>0&&(this.min=0,this.max=this.customValues.length-1,this.setBarColor()),this.setAriaAttributes(this.firstHandle),this.handleVal1=e.isNullOrUndefined(this.value)?this.checkHandleValue(parseFloat(this.min.toString())):this.checkHandleValue(parseFloat(this.value.toString())),this.handlePos1=this.checkHandlePosition(this.handleVal1),this.preHandlePos1=this.handlePos1,e.isNullOrUndefined(this.activeHandle)?"Range"===this.type?this.activeHandle=2:this.activeHandle=1:this.activeHandle=this.activeHandle,"Default"===this.type||"MinRange"===this.type){if(this.limits.enabled){var t=this.getLimitValueAndPosition(this.handleVal1,this.limits.minStart,this.limits.minEnd);this.handleVal1=t[0],this.handlePos1=t[1],this.preHandlePos1=this.handlePos1}this.setHandlePosition(null),this.handleStart(),this.value=this.handleVal1,this.setAriaAttrValue(this.firstHandle),this.changeEvent("changed",null)}else this.validateRangeValue();"Default"!==this.type&&this.setRangeBar(),this.limits.enabled&&this.setLimitBar()},s.prototype.rangeValueUpdate=function(){null!==this.value&&"object"==typeof this.value||(this.value=[parseFloat(e.formatUnit(this.min)),parseFloat(e.formatUnit(this.max))])},s.prototype.validateRangeValue=function(){this.rangeValueUpdate(),this.setRangeValue()},s.prototype.modifyZindex=function(){"Range"===this.type?1===this.activeHandle?(this.firstHandle.style.zIndex=this.zIndex+4+"",this.secondHandle.style.zIndex=this.zIndex+3+""):(this.firstHandle.style.zIndex=this.zIndex+3+"",this.secondHandle.style.zIndex=this.zIndex+4+""):this.isMaterialTooltip&&this.tooltipElement&&(this.tooltipElement.style.zIndex=i.getZindexPartial(this.element)+"")},s.prototype.setHandlePosition=function(t){var e,i=this,s=1===this.activeHandle?this.handlePos1:this.handlePos2;e=this.isMaterialTooltip?[this.firstHandle,this.materialHandle]:[this.getHandle()],this.handleStart(),e.forEach(function(t){"Horizontal"===i.orientation?i.enableRtl?t.style.right=s+"px":t.style.left=s+"px":t.style.bottom=s+"px"}),this.changeEvent("change",t)},s.prototype.getHandle=function(){return 1===this.activeHandle?this.firstHandle:this.secondHandle},s.prototype.setRangeValue=function(){this.updateRangeValue(),this.activeHandle=1,this.setHandlePosition(null),this.activeHandle=2,this.setHandlePosition(null),this.activeHandle=1},s.prototype.changeEvent=function(t,e){var i="change"===t?this.previousVal:this.previousChanged;if("Range"!==this.type)this.setProperties({value:this.handleVal1},!0),i===this.value||this.isMaterialTooltip&&this.initialTooltip||(this.trigger(t,this.changeEventArgs(t,e)),this.initialTooltip=!0,this.setPreviousVal(t,this.value)),this.setAriaAttrValue(this.firstHandle);else{var s=this.value=[this.handleVal1,this.handleVal2];this.setProperties({value:s},!0),(i.length===this.value.length&&this.value[0]!==i[0]||this.value[1]!==i[1])&&(this.initialTooltip=!1,this.trigger(t,this.changeEventArgs(t,e)),this.initialTooltip=!0,this.setPreviousVal(t,this.value)),this.setAriaAttrValue(this.getHandle())}this.hiddenInput.value=this.value.toString()},s.prototype.changeEventArgs=function(t,i){var s;return this.tooltip.isVisible&&this.tooltipObj&&this.initialTooltip?(this.tooltipValue(),s={value:this.value,previousValue:"change"===t?this.previousVal:this.previousChanged,action:t,text:this.tooltipObj.content,isInteracted:!e.isNullOrUndefined(i)}):s={value:this.value,previousValue:"change"===t?this.previousVal:this.previousChanged,action:t,text:e.isNullOrUndefined(this.ticksFormatInfo.format)?this.value.toString():"Range"!==this.type?this.formatString(this.value,this.ticksFormatInfo).formatString:this.formatString(this.value[0],this.ticksFormatInfo).formatString+" - "+this.formatString(this.value[1],this.ticksFormatInfo).formatString,isInteracted:!e.isNullOrUndefined(i)},s},s.prototype.setPreviousVal=function(t,e){"change"===t?this.previousVal=e:this.previousChanged=e},s.prototype.updateRangeValue=function(){var t=this.value.toString().split(",").map(Number);if(this.enableRtl&&"Vertical"!==this.orientation||this.rtl?this.value=[t[1],t[0]]:this.value=[t[0],t[1]],this.enableRtl&&"Vertical"!==this.orientation?(this.handleVal1=this.checkHandleValue(this.value[1]),this.handleVal2=this.checkHandleValue(this.value[0])):(this.handleVal1=this.checkHandleValue(this.value[0]),this.handleVal2=this.checkHandleValue(this.value[1])),this.handlePos1=this.checkHandlePosition(this.handleVal1),this.handlePos2=this.checkHandlePosition(this.handleVal2),this.handlePos1>this.handlePos2&&(this.handlePos1=this.handlePos2,this.handleVal1=this.handleVal2),this.preHandlePos1=this.handlePos1,this.preHandlePos2=this.handlePos2,this.limits.enabled){this.activeHandle=1;var e=this.getLimitValueAndPosition(this.handleVal1,this.limits.minStart,this.limits.minEnd);this.handleVal1=e[0],this.handlePos1=e[1],this.preHandlePos1=this.handlePos1,this.activeHandle=2,e=this.getLimitValueAndPosition(this.handleVal2,this.limits.maxStart,this.limits.maxEnd),this.handleVal2=e[0],this.handlePos2=e[1],this.preHandlePos2=this.handlePos2}},s.prototype.checkHandlePosition=function(t){var i;return t=100*(t-parseFloat(e.formatUnit(this.min)))/(parseFloat(e.formatUnit(this.max))-parseFloat(e.formatUnit(this.min))),i="Horizontal"===this.orientation?this.element.getBoundingClientRect().width*(t/100):this.element.getBoundingClientRect().height*(t/100),parseFloat(e.formatUnit(this.max))===parseFloat(e.formatUnit(this.min))&&(i="Horizontal"===this.orientation?this.element.getBoundingClientRect().width:this.element.getBoundingClientRect().height),i},s.prototype.checkHandleValue=function(t){if(this.min>this.max&&(this.min=this.max),this.min===this.max)return parseFloat(e.formatUnit(this.max));var i=this.tempStartEnd();return t<i.start?t=i.start:t>i.end&&(t=i.end),t},s.prototype.reposition=function(){var t=this;this.firstHandle.style.transition="none","Default"!==this.type&&(this.rangeBar.style.transition="none"),"Range"===this.type&&(this.secondHandle.style.transition="none"),this.handlePos1=this.checkHandlePosition(this.handleVal1),this.handleVal2&&(this.handlePos2=this.checkHandlePosition(this.handleVal2)),"Horizontal"===this.orientation?(this.enableRtl?this.firstHandle.style.right=this.handlePos1+"px":this.firstHandle.style.left=this.handlePos1+"px",this.isMaterialTooltip&&(this.enableRtl?this.materialHandle.style.right=this.handlePos1+"px":this.materialHandle.style.left=this.handlePos1+"px"),"MinRange"===this.type?(this.enableRtl?this.rangeBar.style.right="0px":this.rangeBar.style.left="0px",e.setStyleAttribute(this.rangeBar,{width:e.isNullOrUndefined(this.handlePos1)?0:this.handlePos1+"px"})):"Range"===this.type&&(this.enableRtl?this.secondHandle.style.right=this.handlePos2+"px":this.secondHandle.style.left=this.handlePos2+"px",this.enableRtl?this.rangeBar.style.right=this.handlePos1+"px":this.rangeBar.style.left=this.handlePos1+"px",e.setStyleAttribute(this.rangeBar,{width:this.handlePos2-this.handlePos1+"px"}))):(this.firstHandle.style.bottom=this.handlePos1+"px",this.isMaterialTooltip&&(this.materialHandle.style.bottom=this.handlePos1+"px"),"MinRange"===this.type?(this.rangeBar.style.bottom="0px",e.setStyleAttribute(this.rangeBar,{height:e.isNullOrUndefined(this.handlePos1)?0:this.handlePos1+"px"})):"Range"===this.type&&(this.secondHandle.style.bottom=this.handlePos2+"px",this.rangeBar.style.bottom=this.handlePos1+"px",e.setStyleAttribute(this.rangeBar,{height:this.handlePos2-this.handlePos1+"px"}))),this.limits.enabled&&this.setLimitBar(),"None"!==this.ticks.placement&&this.ul&&(this.removeElement(this.ul),this.ul=void 0,this.renderScale()),this.handleStart(),this.tooltip.isVisible||setTimeout(function(){t.firstHandle.style.transition=t.scaleTransform,"Range"===t.type&&(t.secondHandle.style.transition=t.scaleTransform)}),this.refreshTooltip(this.tooltipTarget),this.setBarColor()},s.prototype.changeHandleValue=function(t){var e=null;1===this.activeHandle?(this.limits.enabled&&this.limits.startHandleFixed||(this.handleVal1=this.checkHandleValue(t),this.handlePos1=this.checkHandlePosition(this.handleVal1),"Range"===this.type&&this.handlePos1>this.handlePos2&&(this.handlePos1=this.handlePos2,this.handleVal1=this.handleVal2),this.handlePos1!==this.preHandlePos1&&(e=this.preHandlePos1=this.handlePos1)),this.modifyZindex()):(this.limits.enabled&&this.limits.endHandleFixed||(this.handleVal2=this.checkHandleValue(t),this.handlePos2=this.checkHandlePosition(this.handleVal2),"Range"===this.type&&this.handlePos2<this.handlePos1&&(this.handlePos2=this.handlePos1,this.handleVal2=this.handleVal1),this.handlePos2!==this.preHandlePos2&&(e=this.preHandlePos2=this.handlePos2)),this.modifyZindex()),null!==e&&("Default"!==this.type&&this.setRangeBar(),this.setHandlePosition(null))},s.prototype.tempStartEnd=function(){return this.min>this.max?{start:this.max,end:this.min}:{start:this.min,end:this.max}},s.prototype.xyToPosition=function(t){if(this.min===this.max)return 100;if("Horizontal"===this.orientation){var e=t.x-this.element.getBoundingClientRect().left,i=this.element.offsetWidth/100;this.val=e/i}else{var s=t.y-this.element.getBoundingClientRect().top;i=this.element.offsetHeight/100;this.val=100-s/i}var n=this.stepValueCalculation(this.val);return n<0?n=0:n>100&&(n=100),this.enableRtl&&"Vertical"!==this.orientation&&(n=100-n),"Horizontal"===this.orientation?this.element.getBoundingClientRect().width*(n/100):this.element.getBoundingClientRect().height*(n/100)},s.prototype.stepValueCalculation=function(t){0===this.step&&(this.step=1);var i=parseFloat(e.formatUnit(this.step))/((parseFloat(e.formatUnit(this.max))-parseFloat(e.formatUnit(this.min)))/100),s=t%Math.abs(i);return 0!==s&&(i/2>s?t-=s:t+=Math.abs(i)-s),t},s.prototype.add=function(t,e,i){var s=Math.pow(10,3);return i?(Math.round(t*s)+Math.round(e*s))/s:(Math.round(t*s)-Math.round(e*s))/s},s.prototype.positionToValue=function(t){var i,s=parseFloat(e.formatUnit(this.max))-parseFloat(e.formatUnit(this.min));i="Horizontal"===this.orientation?t/this.element.getBoundingClientRect().width*s:t/this.element.getBoundingClientRect().height*s;return this.add(i,parseFloat(this.min.toString()),!0)},s.prototype.sliderBarClick=function(t){t.preventDefault();var e;"mousedown"===t.type||"mouseup"===t.type||"click"===t.type?e={x:t.clientX,y:t.clientY}:"touchend"!==t.type&&"touchstart"!==t.type||(e={x:t.changedTouches[0].clientX,y:t.changedTouches[0].clientY});var i=this.xyToPosition(e),s=this.positionToValue(i);if("Range"===this.type&&this.handlePos2-i<i-this.handlePos1){if(this.activeHandle=2,!this.limits.enabled||!this.limits.endHandleFixed){if(this.limits.enabled){s=(n=this.getLimitValueAndPosition(s,this.limits.maxStart,this.limits.maxEnd))[0],i=n[1]}this.secondHandle.classList.add(ne),this.handlePos2=this.preHandlePos2=i,this.handleVal2=s}this.modifyZindex(),this.secondHandle.focus()}else{if(this.activeHandle=1,!this.limits.enabled||!this.limits.startHandleFixed){if(this.limits.enabled){var n;s=(n=this.getLimitValueAndPosition(s,this.limits.minStart,this.limits.minEnd))[0],i=n[1]}this.firstHandle.classList.add(ne),this.handlePos1=this.preHandlePos1=i,this.handleVal1=s}this.modifyZindex(),this.firstHandle.focus()}this.isMaterialTooltip&&this.tooltipElement.classList.add(It);var a=this.element.querySelector("."+Yt);a&&this.getHandle()!==a&&a.classList.remove(Yt);var r=1===this.activeHandle?this.firstHandle:this.secondHandle;if(t.target===r)return!this.isMaterial||this.tooltip.isVisible||this.getHandle().classList.contains(Yt)||this.materialChange(),this.sliderBarUp(t),void this.tooltipToggle(this.getHandle());if(this.checkRepeatedValue(s)){var l=this.isMaterial&&this.tooltip.isVisible?this.transitionOnMaterialTooltip:this.transition;this.getHandle().style.transition=l.handle,"Default"!==this.type&&(this.rangeBar.style.transition=l.rangeBar),this.setHandlePosition(t),this.isMaterialTooltip&&(this.initialTooltip=!1),this.changeEvent("changed",t),"Default"!==this.type&&this.setRangeBar()}},s.prototype.handleValueAdjust=function(t,e,i){1===i?(this.handleVal1=e,this.handleVal2=this.handleVal1+this.minDiff):2===i&&(this.handleVal2=e,this.handleVal1=this.handleVal2-this.minDiff),this.handlePos1=this.checkHandlePosition(this.handleVal1),this.handlePos2=this.checkHandlePosition(this.handleVal2)},s.prototype.dragRangeBarMove=function(t){var e,i;"touchmove"!==t.type&&t.preventDefault(),this.rangeBarDragged=!0;var s;this.rangeBar.style.transition="none",this.firstHandle.style.transition="none",this.secondHandle.style.transition="none";var n,a;if("mousemove"===t.type?(n=(e=[t.clientX,t.clientY])[0],a=e[1]):(n=(i=[t.changedTouches[0].clientX,t.changedTouches[0].clientY])[0],a=i[1]),!(this.limits.enabled&&this.limits.startHandleFixed||this.limits.enabled&&this.limits.endHandleFixed)){if(s=this.enableRtl?{x:n+this.secondPartRemain,y:a+this.secondPartRemain}:{x:n-this.firstPartRemain,y:a+this.secondPartRemain},this.handlePos1=this.xyToPosition(s),this.handleVal1=this.positionToValue(this.handlePos1),s=this.enableRtl?{x:n-this.firstPartRemain,y:a-this.firstPartRemain}:{x:n+this.secondPartRemain,y:a-this.firstPartRemain},this.handlePos2=this.xyToPosition(s),this.handleVal2=this.positionToValue(this.handlePos2),this.limits.enabled){var r=this.getLimitValueAndPosition(this.handleVal1,this.limits.minStart,this.limits.minEnd);this.handleVal1=r[0],this.handlePos1=r[1],this.handleVal1===this.limits.minEnd&&this.handleValueAdjust(this.handleVal1,this.limits.minEnd,1),this.handleVal1===this.limits.minStart&&this.handleValueAdjust(this.handleVal1,this.limits.minStart,1),r=this.getLimitValueAndPosition(this.handleVal2,this.limits.maxStart,this.limits.maxEnd),this.handleVal2=r[0],this.handlePos2=r[1],this.handleVal2===this.limits.maxStart&&this.handleValueAdjust(this.handleVal2,this.limits.maxStart,2),this.handleVal2===this.limits.maxEnd&&this.handleValueAdjust(this.handleVal2,this.limits.maxEnd,2)}this.handleVal2===this.max&&this.handleValueAdjust(this.handleVal2,this.max,2),this.handleVal1===this.min&&this.handleValueAdjust(this.handleVal1,this.min,1)}this.activeHandle=1,this.setHandlePosition(t),this.activeHandle=2,this.setHandlePosition(t),this.tooltipToggle(this.rangeBar),this.setRangeBar()},s.prototype.sliderBarUp=function(t){this.changeEvent("changed",t),this.handleFocusOut(),this.firstHandle.classList.remove(ne),"Range"===this.type&&(this.initialTooltip=!1,this.secondHandle.classList.remove(ne)),this.closeTooltip(),this.isMaterial&&(this.getHandle().classList.remove("e-large-thumb-size"),this.isMaterialTooltip&&this.tooltipElement.classList.remove(It)),e.EventHandler.remove(document,"mousemove touchmove",this.sliderBarMove),e.EventHandler.remove(document,"mouseup touchend",this.sliderBarUp)},s.prototype.sliderBarMove=function(t){"touchmove"!==t.type&&t.preventDefault();var e;e="mousemove"===t.type?{x:t.clientX,y:t.clientY}:{x:t.changedTouches[0].clientX,y:t.changedTouches[0].clientY};var i=this.xyToPosition(e),s=this.positionToValue(i);if(i=Math.round(i),"Range"!==this.type&&1===this.activeHandle){if(!this.limits.enabled||!this.limits.startHandleFixed){if(this.limits.enabled){var n=this.getLimitValueAndPosition(s,this.limits.minStart,this.limits.minEnd);i=n[1],s=n[0]}this.handlePos1=i,this.handleVal1=s}this.firstHandle.classList.add(ne)}if("Range"===this.type)if(1===this.activeHandle){if(this.firstHandle.classList.add(ne),!(this.limits.enabled&&this.limits.startHandleFixed||(i>this.handlePos2&&(i=this.handlePos2,s=this.handleVal2),i===this.preHandlePos1))){if(this.limits.enabled){s=(a=this.getLimitValueAndPosition(s,this.limits.minStart,this.limits.minEnd))[0],i=a[1]}this.handlePos1=this.preHandlePos1=i,this.handleVal1=s,this.activeHandle=1}}else if(2===this.activeHandle&&(this.secondHandle.classList.add(ne),!(this.limits.enabled&&this.limits.endHandleFixed||(i<this.handlePos1&&(i=this.handlePos1,s=this.handleVal1),i===this.preHandlePos2)))){if(this.limits.enabled){var a;s=(a=this.getLimitValueAndPosition(s,this.limits.maxStart,this.limits.maxEnd))[0],i=a[1]}this.handlePos2=this.preHandlePos2=i,this.handleVal2=s,this.activeHandle=2}this.checkRepeatedValue(s)&&(this.getHandle().style.transition=this.scaleTransform,"Default"!==this.type&&(this.rangeBar.style.transition="none"),this.setHandlePosition(t),!this.isMaterial||this.tooltip.isVisible||this.getHandle().classList.contains(Yt)||this.materialChange(),this.tooltipToggle(this.getHandle()),"Default"!==this.type&&this.setRangeBar())},s.prototype.dragRangeBarUp=function(t){this.rangeBarDragged?this.isDragComplete=!0:(this.focusSliderElement(),this.sliderBarClick(t)),this.changeEvent("changed",t),this.closeTooltip(),e.EventHandler.remove(document,"mousemove touchmove",this.dragRangeBarMove),e.EventHandler.remove(document,"mouseup touchend",this.dragRangeBarUp),this.rangeBarDragged=!1},s.prototype.checkRepeatedValue=function(t){if("Range"===this.type){if(t===(this.enableRtl&&"Vertical"!==this.orientation?1===this.activeHandle?this.previousVal[1]:this.previousVal[0]:1===this.activeHandle?this.previousVal[0]:this.previousVal[1]))return 0}else if(t===this.previousVal)return 0;return 1},s.prototype.refreshTooltip=function(t){this.tooltip.isVisible&&this.tooltipObj&&(this.tooltipValue(),t&&(this.tooltipObj.refresh(t),this.tooltipTarget=t))},s.prototype.openTooltip=function(t){this.tooltip.isVisible&&this.tooltipObj&&!this.isMaterialTooltip&&(this.tooltipValue(),this.tooltipObj.open(t),this.tooltipTarget=t)},s.prototype.closeTooltip=function(){this.tooltip.isVisible&&this.tooltipObj&&"Always"!==this.tooltip.showOn&&!this.isMaterialTooltip&&(this.tooltipValue(),this.tooltipObj.close(),this.tooltipTarget=void 0)},s.prototype.keyDown=function(t){switch(t.keyCode){case 37:case 38:case 39:case 40:case 33:case 34:case 36:case 35:t.preventDefault(),this.buttonClick(t)}},s.prototype.wireButtonEvt=function(t){t?(e.EventHandler.remove(this.firstBtn,"mouseleave touchleave",this.buttonFocusOut),e.EventHandler.remove(this.secondBtn,"mouseleave touchleave",this.buttonFocusOut),e.EventHandler.remove(this.firstBtn,"mousedown touchstart",this.repeatHandlerMouse),e.EventHandler.remove(this.firstBtn,"mouseup mouseleave touchup touchend",this.repeatHandlerUp),e.EventHandler.remove(this.secondBtn,"mousedown touchstart",this.repeatHandlerMouse),e.EventHandler.remove(this.secondBtn,"mouseup mouseleave touchup touchend",this.repeatHandlerUp),e.EventHandler.remove(this.firstBtn,"focusout",this.sliderFocusOut),e.EventHandler.remove(this.secondBtn,"focusout",this.sliderFocusOut)):(e.EventHandler.add(this.firstBtn,"mouseleave touchleave",this.buttonFocusOut,this),e.EventHandler.add(this.secondBtn,"mouseleave touchleave",this.buttonFocusOut,this),e.EventHandler.add(this.firstBtn,"mousedown touchstart",this.repeatHandlerMouse,this),e.EventHandler.add(this.firstBtn,"mouseup mouseleave touchup touchend",this.repeatHandlerUp,this),e.EventHandler.add(this.secondBtn,"mousedown touchstart",this.repeatHandlerMouse,this),e.EventHandler.add(this.secondBtn,"mouseup mouseleave touchup touchend",this.repeatHandlerUp,this),e.EventHandler.add(this.firstBtn,"focusout",this.sliderFocusOut,this),e.EventHandler.add(this.secondBtn,"focusout",this.sliderFocusOut,this))},s.prototype.rangeBarMousedown=function(t){var i,s;if(t.preventDefault(),this.focusSliderElement(),"Range"===this.type&&this.drag&&t.target===this.rangeBar){var n=void 0,a=void 0;"mousedown"===t.type?(n=(i=[t.clientX,t.clientY])[0],a=i[1]):"touchstart"===t.type&&(n=(s=[t.changedTouches[0].clientX,t.changedTouches[0].clientY])[0],a=s[1]),"Horizontal"===this.orientation?(this.firstPartRemain=n-this.rangeBar.getBoundingClientRect().left,this.secondPartRemain=this.rangeBar.getBoundingClientRect().right-n):(this.firstPartRemain=a-this.rangeBar.getBoundingClientRect().top,this.secondPartRemain=this.rangeBar.getBoundingClientRect().bottom-a),this.minDiff=this.handleVal2-this.handleVal1,this.tooltipToggle(this.rangeBar);var r=this.element.querySelector("."+Yt);r&&r.classList.remove(Yt),e.EventHandler.add(document,"mousemove touchmove",this.dragRangeBarMove,this),e.EventHandler.add(document,"mouseup touchend",this.dragRangeBarUp,this)}},s.prototype.elementClick=function(t){this.isDragComplete?this.isDragComplete=!1:(t.preventDefault(),this.focusSliderElement(),this.sliderBarClick(t),this.focusHandle())},s.prototype.wireEvents=function(){this.onresize=this.reposition.bind(this),window.addEventListener("resize",this.onresize),this.enabled&&!this.readonly&&(e.EventHandler.add(this.element,"click",this.elementClick,this),"Range"===this.type&&this.drag&&e.EventHandler.add(this.rangeBar,"mousedown touchstart",this.rangeBarMousedown,this),e.EventHandler.add(this.sliderContainer,"keydown",this.keyDown,this),e.EventHandler.add(this.sliderContainer,"keyup",this.keyUp,this),e.EventHandler.add(this.element,"focusout",this.sliderFocusOut,this),e.EventHandler.add(this.sliderContainer,"mouseover mouseout touchstart touchend",this.hover,this),this.wireFirstHandleEvt(!1),"Range"===this.type&&this.wireSecondHandleEvt(!1),this.showButtons&&this.wireButtonEvt(!1),this.wireMaterialTooltipEvent(!1),this.isForm&&e.EventHandler.add(this.formElement,"reset",this.formResetHandler,this))},s.prototype.unwireEvents=function(){e.EventHandler.remove(this.element,"click",this.elementClick),"Range"===this.type&&this.drag&&e.EventHandler.remove(this.rangeBar,"mousedown touchstart",this.rangeBarMousedown),e.EventHandler.remove(this.sliderContainer,"keydown",this.keyDown),e.EventHandler.remove(this.sliderContainer,"keyup",this.keyUp),e.EventHandler.remove(this.element,"focusout",this.sliderFocusOut),e.EventHandler.remove(this.sliderContainer,"mouseover mouseout touchstart touchend",this.hover),this.wireFirstHandleEvt(!0),"Range"===this.type&&this.wireSecondHandleEvt(!0),this.showButtons&&this.wireButtonEvt(!0),this.wireMaterialTooltipEvent(!0),e.EventHandler.remove(this.element,"reset",this.formResetHandler)},s.prototype.formResetHandler=function(){this.setProperties({value:this.formResetValue},!0),this.setValue()},s.prototype.keyUp=function(t){if(9===t.keyCode&&t.target.classList.contains(bt)&&(this.focusSliderElement(),!t.target.classList.contains(Yt))){this.element.querySelector("."+Yt)&&this.element.querySelector("."+Yt).classList.remove(Yt),t.target.classList.add(Yt);var e=t.target.parentElement;e===this.element&&(e.querySelector("."+zt).classList.add(ie),"Range"!==this.type&&"MinRange"!==this.type||e.querySelector("."+Ct).classList.add(se)),"Range"===this.type&&(t.target.previousSibling.classList.contains(bt)?this.activeHandle=2:this.activeHandle=1),this.getHandle().focus(),this.tooltipToggle(this.getHandle())}this.closeTooltip(),this.changeEvent("changed",t)},s.prototype.hover=function(t){if(!e.isNullOrUndefined(t))if("mouseover"===t.type||"touchmove"===t.type||"mousemove"===t.type||"pointermove"===t.type||"touchstart"===t.type)this.sliderContainer.classList.add(At);else{this.sliderContainer.classList.remove(At);var i=t.currentTarget;this.tooltip.isVisible&&"Always"!==this.tooltip.showOn&&this.tooltipObj&&this.isMaterialTooltip&&!i.classList.contains(jt)&&!i.classList.contains(Yt)&&this.closeMaterialTooltip()}},s.prototype.sliderFocusOut=function(t){t.relatedTarget!==this.secondHandle&&t.relatedTarget!==this.firstHandle&&t.relatedTarget!==this.element&&t.relatedTarget!==this.firstBtn&&t.relatedTarget!==this.secondBtn&&(this.closeMaterialTooltip(),this.closeTooltip(),this.element.querySelector("."+Yt)&&this.element.querySelector("."+Yt).classList.remove(Yt),this.element.querySelector("."+ie)&&(this.element.querySelector("."+ie).classList.remove(ie),"Range"!==this.type&&"MinRange"!==this.type||!this.element.querySelector("."+se)||this.element.querySelector("."+se).classList.remove(se)),this.hiddenInput.focus(),this.hiddenInput.blur(),this.isElementFocused=!1)},s.prototype.removeElement=function(t){t.parentNode&&t.parentNode.removeChild(t)},s.prototype.changeSliderType=function(t,i){this.isMaterialTooltip&&this.materialHandle&&(this.sliderContainer.classList.remove(Dt),this.removeElement(this.materialHandle),this.materialHandle=void 0),this.removeElement(this.firstHandle),this.firstHandle=void 0,"Default"!==t&&("Range"===t&&(this.removeElement(this.secondHandle),this.secondHandle=void 0),this.removeElement(this.rangeBar),this.rangeBar=void 0),this.tooltip.isVisible&&!e.isNullOrUndefined(this.tooltipObj)&&(this.tooltipObj.destroy(),this.tooltipElement=void 0,this.tooltipCollidedPosition=void 0),this.limits.enabled&&("MinRange"===t||"Default"===t?e.isNullOrUndefined(this.limitBarFirst)||(this.removeElement(this.limitBarFirst),this.limitBarFirst=void 0):e.isNullOrUndefined(this.limitBarSecond)||(this.removeElement(this.limitBarSecond),this.limitBarSecond=void 0)),this.activeHandle=1,this.getThemeInitialization(),"Range"===this.type&&this.rangeValueUpdate(),this.createRangeBar(),this.limits.enabled&&this.createLimitBar(),this.setHandler(),this.setOrientClass(),this.wireFirstHandleEvt(!1),"Range"===this.type&&this.wireSecondHandleEvt(!1),this.setValue(),this.tooltip.isVisible&&(this.renderTooltip(),this.wireMaterialTooltipEvent(!1)),this.setBarColor(),"tooltip"!==i&&this.updateConfig()},s.prototype.changeRtl=function(){if(this.enableRtl||"Range"!==this.type||(this.value=[this.handleVal2,this.handleVal1]),this.updateConfig(),this.tooltip.isVisible&&this.tooltipObj.refresh(this.firstHandle),this.showButtons){var t=this.enableRtl&&"Vertical"!==this.orientation;e.attributes(t?this.secondBtn:this.firstBtn,{"aria-label":"Decrease",title:"Decrease"}),e.attributes(t?this.firstBtn:this.secondBtn,{"aria-label":"Increase",title:"Increase"})}},s.prototype.changeOrientation=function(){this.changeSliderType(this.type,"null")},s.prototype.updateConfig=function(){this.setEnableRTL(),this.setValue(),this.tooltip.isVisible&&this.refreshTooltip(this.tooltipTarget),"None"!==this.ticks.placement&&this.ul&&(this.removeElement(this.ul),this.ul=void 0,this.renderScale()),this.limitsPropertyChange()},s.prototype.limitsPropertyChange=function(){this.limits.enabled?(e.isNullOrUndefined(this.limitBarFirst)&&"Range"!==this.type&&this.createLimitBar(),e.isNullOrUndefined(this.limitBarFirst)&&e.isNullOrUndefined(this.limitBarSecond)&&"Range"===this.type&&this.createLimitBar(),this.setLimitBar(),this.setValue()):(e.isNullOrUndefined(this.limitBarFirst)||e.detach(this.limitBarFirst),e.isNullOrUndefined(this.limitBarSecond)||e.detach(this.limitBarSecond))},s.prototype.getPersistData=function(){return this.addOnPersist(["value"])},s.prototype.destroy=function(){t.prototype.destroy.call(this),this.unwireEvents(),window.removeEventListener("resize",this.onresize),e.removeClass([this.sliderContainer],[Ht]),this.firstHandle.removeAttribute("aria-orientation"),"Range"===this.type&&this.secondHandle.removeAttribute("aria-orientation"),this.sliderContainer.parentNode.insertBefore(this.element,this.sliderContainer),e.detach(this.sliderContainer),this.tooltip.isVisible&&this.tooltipObj.destroy(),this.element.innerHTML=""},s.prototype.onPropertyChanged=function(t,i){for(var s=this,n=0,a=Object.keys(t);n<a.length;n++){var r=a[n];switch(r){case"cssClass":this.setCSSClass(i.cssClass);break;case"value":if(t&&i){var l=e.isNullOrUndefined(t.value)?"Range"===this.type?[this.min,this.max]:this.min:t.value;this.setProperties({value:l},!0),e.isNullOrUndefined(i.value)||i.value.toString()===l.toString()||(this.setValue(),this.refreshTooltip(this.tooltipTarget),"Range"===this.type&&(e.isNullOrUndefined(t.value)||i.value[1]===l[1]?this.activeHandle=1:this.activeHandle=2))}break;case"min":case"step":case"max":this.setMinMaxValue();break;case"tooltip":e.isNullOrUndefined(t.tooltip)||e.isNullOrUndefined(i.tooltip)||this.setTooltip(r);break;case"type":e.isNullOrUndefined(i)||!Object.keys(i).length||e.isNullOrUndefined(i.type)||(this.changeSliderType(i.type,r),this.setZindex());break;case"enableRtl":i.enableRtl!==t.enableRtl&&"Vertical"!==this.orientation&&(this.rtl=i.enableRtl,this.changeRtl());break;case"limits":this.limitsPropertyChange();break;case"orientation":this.changeOrientation();break;case"ticks":e.isNullOrUndefined(this.sliderContainer.querySelector("."+kt))||(e.detach(this.ul),Array.prototype.forEach.call(this.sliderContainer.classList,function(t){t.match(/e-scale-/)&&s.sliderContainer.classList.remove(t)})),"None"!==this.ticks.placement&&(this.renderScale(),this.setZindex());break;case"locale":this.showButtons&&this.buttonTitle();break;case"showButtons":t.showButtons?(this.setButtons(),this.reposition(),this.enabled&&!this.readonly&&this.wireButtonEvt(!1)):this.firstBtn&&this.secondBtn&&(this.sliderContainer.removeChild(this.firstBtn),this.sliderContainer.removeChild(this.secondBtn),this.sliderContainer.classList.remove(ee),this.firstBtn=void 0,this.secondBtn=void 0,this.reposition());break;case"enabled":this.setEnabled();break;case"readonly":this.setReadOnly();break;case"customValues":this.setValue(),this.reposition();break;case"colorRange":this.reposition();break;case"width":this.setElementWidth(t.width),this.setMinMaxValue(),this.limits&&this.limitsPropertyChange()}}},s.prototype.setReadOnly=function(){this.readonly?(this.unwireEvents(),this.sliderContainer.classList.add(de)):(this.wireEvents(),this.sliderContainer.classList.remove(de))},s.prototype.setMinMaxValue=function(){var t=this;this.setValue(),this.refreshTooltip(this.tooltipTarget),e.isNullOrUndefined(this.sliderContainer.querySelector("."+kt))||this.ul&&(e.detach(this.ul),Array.prototype.forEach.call(this.sliderContainer.classList,function(e){e.match(/e-scale-/)&&t.sliderContainer.classList.remove(e)})),"None"!==this.ticks.placement&&(this.renderScale(),this.setZindex())},s.prototype.setZindex=function(){this.zIndex=6,e.isNullOrUndefined(this.ticks)||"None"===this.ticks.placement||(this.ul.style.zIndex=this.zIndex+-7+"",this.element.style.zIndex=this.zIndex+2+""),this.isMaterial||e.isNullOrUndefined(this.ticks)||"Both"!==this.ticks.placement||(this.element.style.zIndex=this.zIndex+2+""),this.firstHandle.style.zIndex=this.zIndex+3+"","Range"===this.type&&(this.secondHandle.style.zIndex=this.zIndex+4+"")},s.prototype.setTooltip=function(t){this.changeSliderType(this.type,t)},s.prototype.setBarColor=function(){for(var t,i,s=this.sliderTrack.lastElementChild;s;)this.sliderTrack.removeChild(s),s=this.sliderTrack.lastElementChild;for(var n=0;n<this.colorRange.length;n++)if(!e.isNullOrUndefined(this.colorRange[n].start)&&!e.isNullOrUndefined(this.colorRange[n].end)&&this.colorRange[n].end>this.colorRange[n].start){this.colorRange[n].start<this.min&&(this.colorRange[n].start=this.min),this.colorRange[n].end>this.max&&(this.colorRange[n].end=this.max);var a=this.checkHandlePosition(this.colorRange[n].start),r=this.checkHandlePosition(this.colorRange[n].end),l=this.createElement("div");l.style.backgroundColor=this.colorRange[n].color,l.style.border="1px solid "+this.colorRange[n].color,"Horizontal"===this.orientation?(i=qt,t=this.enableRtl?e.isNullOrUndefined(this.customValues)?this.checkHandlePosition(this.max)-this.checkHandlePosition(this.colorRange[n].end):this.checkHandlePosition(this.customValues.length-this.colorRange[n].end-1):this.checkHandlePosition(this.colorRange[n].start),l.style.width=r-a+"px",l.style.left=t+"px"):(i=Wt,t=this.checkHandlePosition(this.colorRange[n].start),l.style.height=r-a+"px",l.style.bottom=t+"px"),l.classList.add(i),this.sliderTrack.appendChild(l)}},s.prototype.getModuleName=function(){return"slider"},dt([e.Property(null)],s.prototype,"value",void 0),dt([e.Property(null)],s.prototype,"customValues",void 0),dt([e.Property(1)],s.prototype,"step",void 0),dt([e.Property(null)],s.prototype,"width",void 0),dt([e.Property(0)],s.prototype,"min",void 0),dt([e.Property(100)],s.prototype,"max",void 0),dt([e.Property(!1)],s.prototype,"readonly",void 0),dt([e.Property("Default")],s.prototype,"type",void 0),dt([e.Collection([{}],ut)],s.prototype,"colorRange",void 0),dt([e.Complex({},ct)],s.prototype,"ticks",void 0),dt([e.Complex({},pt)],s.prototype,"limits",void 0),dt([e.Property(!0)],s.prototype,"enabled",void 0),dt([e.Complex({},mt)],s.prototype,"tooltip",void 0),dt([e.Property(!1)],s.prototype,"showButtons",void 0),dt([e.Property(!0)],s.prototype,"enableAnimation",void 0),dt([e.Property("Horizontal")],s.prototype,"orientation",void 0),dt([e.Property("")],s.prototype,"cssClass",void 0),dt([e.Property(!1)],s.prototype,"enableHtmlSanitizer",void 0),dt([e.Event()],s.prototype,"created",void 0),dt([e.Event()],s.prototype,"change",void 0),dt([e.Event()],s.prototype,"changed",void 0),dt([e.Event()],s.prototype,"renderingTicks",void 0),dt([e.Event()],s.prototype,"renderedTicks",void 0),dt([e.Event()],s.prototype,"tooltipChange",void 0),s=dt([e.NotifyPropertyChanges],s)}(e.Component),ye=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function s(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),be=function(t,e,i,s){var n,a=arguments.length,r=a<3?e:null===s?s=Object.getOwnPropertyDescriptor(e,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(t,e,i,s);else for(var l=t.length-1;l>=0;l--)(n=t[l])&&(r=(a<3?n(r):a>3?n(e,i,r):n(e,i))||r);return a>3&&r&&Object.defineProperty(e,i,r),r},Ce={EMAIL:new RegExp("^[A-Za-z0-9._%+-]{1,}@[A-Za-z0-9._%+-]{1,}([.]{1}[a-zA-Z0-9]{2,}|[.]{1}[a-zA-Z0-9]{2,4}[.]{1}[a-zA-Z0-9]{2,4})$"),URL:/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/m,DATE_ISO:new RegExp("^([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$"),DIGITS:new RegExp("^[0-9]*$"),PHONE:new RegExp("^[+]?[0-9]{9,13}$"),CREDITCARD:new RegExp("^\\d{13,16}$")};!function(t){t[t.Message=0]="Message",t[t.Label=1]="Label"}(t.ErrorOption||(t.ErrorOption={}));var Ee=function(i){function s(t,s){var n=i.call(this,s,t)||this;if(n.validated=[],n.errorRules=[],n.allowSubmit=!1,n.required="required",n.infoElement=null,n.inputElement=null,n.selectQuery="input:not([type=reset]):not([type=button]), select, textarea",n.localyMessage={},n.defaultMessages={required:"This field is required.",email:"Please enter a valid email address.",url:"Please enter a valid URL.",date:"Please enter a valid date.",dateIso:"Please enter a valid date ( ISO ).",creditcard:"Please enter valid card number",number:"Please enter a valid number.",digits:"Please enter only digits.",maxLength:"Please enter no more than {0} characters.",minLength:"Please enter at least {0} characters.",rangeLength:"Please enter a value between {0} and {1} characters long.",range:"Please enter a value between {0} and {1}.",max:"Please enter a value less than or equal to {0}.",min:"Please enter a value greater than or equal to {0}.",regex:"Please enter a correct value.",tel:"Please enter a valid phone number.",pattern:"Please enter a correct pattern value.",equalTo:"Please enter the valid match text"},void 0===n.rules&&(n.rules={}),n.l10n=new e.L10n("formValidator",n.defaultMessages,n.locale),n.locale&&n.localeFunc(),e.onIntlChange.on("notifyExternalChange",n.afterLocalization,n),t="string"==typeof t?e.select(t,document):t,null!=n.element)return n.element.setAttribute("novalidate",""),n.inputElements=e.selectAll(n.selectQuery,n.element),n.createHTML5Rules(),n.wireEvents(),n}ye(s,i),n=s,s.prototype.addRules=function(t,i){t&&(this.rules.hasOwnProperty(t)?e.extend(this.rules[t],i,{}):this.rules[t]=i)},s.prototype.removeRules=function(t,i){if(t||i)if(this.rules[t]&&!i)delete this.rules[t];else{if(e.isNullOrUndefined(this.rules[t]&&i))return;for(var s=0;s<i.length;s++)delete this.rules[t][i[s]]}else this.rules={}},s.prototype.validate=function(t){var e=Object.keys(this.rules);if(t&&e.length)return this.validateRules(t),-1!==e.indexOf(t)&&0===this.errorRules.filter(function(e){return e.name===t}).length;this.errorRules=[];for(var i=0,s=e;i<s.length;i++){var n=s[i];this.validateRules(n)}return 0===this.errorRules.length},s.prototype.reset=function(){this.element.reset(),this.clearForm()},s.prototype.getInputElement=function(t){return this.inputElement=e.select('[name="'+t+'"]',this.element),this.inputElement},s.prototype.destroy=function(){this.reset(),this.unwireEvents(),this.rules={};for(var t=0,s=e.selectAll("."+this.errorClass+", ."+this.validClass,this.element);t<s.length;t++){var n=s[t];e.detach(n)}i.prototype.destroy.call(this),e.onIntlChange.off("notifyExternalChange",this.afterLocalization)},s.prototype.onPropertyChanged=function(t,e){for(var i=0,s=Object.keys(t);i<s.length;i++){switch(s[i]){case"locale":this.localeFunc()}}},s.prototype.localeFunc=function(){for(var t=0,e=Object.keys(this.defaultMessages);t<e.length;t++){var i=e[t];this.l10n.setLocale(this.locale);var s=this.l10n.getConstant(i);this.localyMessage[i]=s}},s.prototype.getModuleName=function(){return"formValidator"},s.prototype.afterLocalization=function(t){this.locale=t.locale,this.localeFunc()},s.prototype.refresh=function(){this.unwireEvents(),this.inputElements=e.selectAll(this.selectQuery,this.element),this.wireEvents()},s.prototype.clearForm=function(){this.errorRules=[],this.validated=[];for(var t=0,i=e.selectAll(this.selectQuery,this.element);t<i.length;t++){var s=i[t];s.removeAttribute("aria-invalid"),s.classList.remove(this.errorClass),s.name.length>0&&(this.getInputElement(s.name),this.getErrorElement(s.name),this.hideMessage(s.name)),s.classList.remove(this.validClass)}},s.prototype.createHTML5Rules=function(){for(var t=["required","validateHidden","regex","rangeLength","maxLength","minLength","dateIso","digits","pattern","data-val-required","type","data-validation","min","max","range","equalTo","data-val-minlength-min","data-val-equalto-other","data-val-maxlength-max","data-val-range-min","data-val-regex-pattern","data-val-length-max","data-val-creditcard","data-val-phone"],e=["hidden","email","url","date","number","tel"],i=0,s=this.inputElements;i<s.length;i++){for(var n=s[i],a={},r=0,l=t;r<l.length;r++){var o=l[r];if(null!==n.getAttribute(o))switch(o){case"required":this.defRule(n,a,o,n.required);break;case"data-validation":o=n.getAttribute(o),this.defRule(n,a,o,!0);break;case"type":-1!==e.indexOf(n.type)&&this.defRule(n,a,n.type,!0);break;case"rangeLength":case"range":this.defRule(n,a,o,JSON.parse(n.getAttribute(o)));break;case"equalTo":var h=n.getAttribute(o);this.defRule(n,a,o,h);break;default:"true"===n.getAttribute("data-val")?this.annotationRule(n,a,o,n.getAttribute(o)):this.defRule(n,a,o,n.getAttribute(o))}}0!==Object.keys(a).length&&this.addRules(n.name,a)}},s.prototype.annotationRule=function(t,e,i,s){var n=i.split("-"),a=["required","creditcard","phone","maxlength","minlength","range","regex","equalto"],r=n[n.length-1],l=n[n.length-2];if(-1!==a.indexOf(r))switch(r){case"required":this.defRule(t,e,"required",s);break;case"creditcard":this.defRule(t,e,"creditcard",s);break;case"phone":this.defRule(t,e,"tel",s)}else if(-1!==a.indexOf(l))switch(l){case"maxlength":this.defRule(t,e,"maxLength",s);break;case"minlength":this.defRule(t,e,"minLength",s);break;case"range":var o=t.getAttribute("data-val-range-min"),h=t.getAttribute("data-val-range-max");this.defRule(t,e,"range",[o,h]);break;case"equalto":var d=t.getAttribute(i).split(".");this.defRule(t,e,"equalTo",d[d.length-1]);break;case"regex":this.defRule(t,e,"regex",s)}},s.prototype.defRule=function(t,e,i,s){var n,a=t.getAttribute("data-"+i+"-message"),r=t.getAttribute("data-val-"+i);this.rules[t.name]&&"validateHidden"!==i&&"hidden"!==i&&(this.getInputElement(t.name),n=this.getErrorMessage(this.rules[t.name][i],i)),a?s=[s,a]:r?s=[s,r]:n&&(s=[s,n]),e[i]=s},s.prototype.wireEvents=function(){for(var t=0,i=this.inputElements;t<i.length;t++){var s=i[t];n.isCheckable(s)?e.EventHandler.add(s,"click",this.clickHandler,this):"SELECT"===s.tagName?e.EventHandler.add(s,"change",this.changeHandler,this):(e.EventHandler.add(s,"focusout",this.focusOutHandler,this),e.EventHandler.add(s,"keyup",this.keyUpHandler,this))}e.EventHandler.add(this.element,"submit",this.submitHandler,this),e.EventHandler.add(this.element,"reset",this.resetHandler,this)},s.prototype.unwireEvents=function(){for(var t=0,i=this.inputElements;t<i.length;t++){var s=i[t];e.EventHandler.clearEvents(s)}e.EventHandler.remove(this.element,"submit",this.submitHandler),e.EventHandler.remove(this.element,"reset",this.resetHandler)},s.prototype.focusOutHandler=function(t){this.trigger("focusout",t);var e=t.target;this.rules[e.name]&&(this.rules[e.name][this.required]||e.value.length>0?this.validate(e.name):-1===this.validated.indexOf(e.name)&&this.validated.push(e.name))},s.prototype.keyUpHandler=function(t){this.trigger("keyup",t);var e=t.target;(9!==t.which||this.rules[e.name]&&(!this.rules[e.name]||this.rules[e.name][this.required]))&&-1!==this.validated.indexOf(e.name)&&this.rules[e.name]&&-1===[16,17,18,20,35,36,37,38,39,40,45,144,225].indexOf(t.which)&&this.validate(e.name)},s.prototype.clickHandler=function(t){this.trigger("click",t);var e=t.target;"submit"!==e.type?this.validate(e.name):null!==e.getAttribute("formnovalidate")&&(this.allowSubmit=!0)},s.prototype.changeHandler=function(t){this.trigger("change",t);var e=t.target;this.validate(e.name)},s.prototype.submitHandler=function(t){this.trigger("submit",t),this.allowSubmit||this.validate()?this.allowSubmit=!1:t.preventDefault()},s.prototype.resetHandler=function(){this.clearForm()},s.prototype.validateRules=function(t){if(this.rules[t]){var e=Object.keys(this.rules[t]),i=!1,s=!1,n=e.indexOf("validateHidden"),a=e.indexOf("hidden");if(this.getInputElement(t),-1!==a&&(i=!0),-1!==n&&(s=!0),!i||i&&s){-1!==n&&e.splice(n,1),-1!==a&&e.splice(a-1,1),this.getErrorElement(t);for(var r=0,l=e;r<l.length;r++){var o=l[r],h=this.getErrorMessage(this.rules[t][o],o),d={name:t,message:h},c={inputName:t,element:this.inputElement,message:h};if(!this.isValid(t,o)&&!this.inputElement.classList.contains(this.ignore)){this.removeErrorRules(t),this.errorRules.push(d),this.inputElement.setAttribute("aria-invalid","true"),this.inputElement.setAttribute("aria-describedby",this.inputElement.id+"-info"),this.inputElement.classList.add(this.errorClass),this.inputElement.classList.remove(this.validClass),this.infoElement?this.showMessage(d):this.createErrorElement(t,d.message,this.inputElement),c.errorElement=this.infoElement,c.status="failure",this.inputElement.classList.add(this.errorClass),this.inputElement.classList.remove(this.validClass),this.optionalValidationStatus(t,c),this.trigger("validationComplete",c),"required"===o&&this.inputElement.setAttribute("aria-required","true");break}this.hideMessage(t),c.status="success",this.trigger("validationComplete",c)}}}},s.prototype.optionalValidationStatus=function(t,i){this.rules[t][this.required]||this.inputElement.value.length||e.isNullOrUndefined(this.infoElement)||(this.infoElement.innerHTML=this.inputElement.value,this.infoElement.setAttribute("aria-invalid","false"),i.status="",this.hideMessage(t))},s.prototype.isValid=function(t,i){var s=this.rules[t][i],a=s instanceof Array&&"string"==typeof s[1]?s[0]:s,r=this.rules[t][i],l={value:this.inputElement.value,param:a,element:this.inputElement,formElement:this.element};if(this.trigger("validationBegin",l),!l.param&&"required"===i)return!0;if(r&&"function"==typeof r[0]){return r[0].call(this,{element:this.inputElement,value:this.inputElement.value})}return n.isCheckable(this.inputElement)?"required"!==i||e.selectAll('input[name="'+t+'"]:checked',this.element).length>0:n.checkValidator[i](l)},s.prototype.getErrorMessage=function(t,i){var s=this.inputElement.getAttribute("data-"+i+"-message")?this.inputElement.getAttribute("data-"+i+"-message"):t instanceof Array&&"string"==typeof t[1]?t[1]:0!==Object.keys(this.localyMessage).length?this.localyMessage[i]:this.defaultMessages[i],n=s.match(/{(\d)}/g);if(!e.isNullOrUndefined(n))for(var a=0;a<n.length;a++){var r=t instanceof Array?t[a]:t;s=s.replace(n[a],r)}return s},s.prototype.createErrorElement=function(i,s,n){var a=e.createElement(this.errorElement,{className:this.errorClass,innerHTML:s,attrs:{for:i}});if(this.errorOption===t.ErrorOption.Message&&(a.classList.remove(this.errorClass),a.classList.add("e-message"),a=e.createElement(this.errorContainer,{className:this.errorClass,innerHTML:a.outerHTML})),a.id=this.inputElement.name+"-info",this.element.querySelector('[data-valmsg-for="'+n.id+'"]'))this.element.querySelector('[data-valmsg-for="'+n.id+'"]').appendChild(a);else if(!0===n.hasAttribute("data-msg-containerid")){var r=n.getAttribute("data-msg-containerid");e.select("#"+r,this.element).appendChild(a)}else null!=this.customPlacement?this.customPlacement.call(this,this.inputElement,a):this.inputElement.parentNode.insertBefore(a,this.inputElement.nextSibling);a.style.display="block",this.getErrorElement(i),this.validated.push(i),this.checkRequired(i)},s.prototype.getErrorElement=function(t){return this.infoElement=e.select(this.errorElement+"."+this.errorClass,this.inputElement.parentElement),this.infoElement||(this.infoElement=e.select(this.errorElement+"."+this.errorClass+'[for="'+t+'"]',this.element)),this.infoElement},s.prototype.removeErrorRules=function(t){for(var e=0;e<this.errorRules.length;e++){this.errorRules[e].name===t&&this.errorRules.splice(e,1)}},s.prototype.showMessage=function(t){this.infoElement.style.display="block",this.infoElement.innerHTML=t.message,this.checkRequired(t.name)},s.prototype.hideMessage=function(t){this.infoElement&&(this.infoElement.style.display="none",this.removeErrorRules(t),this.inputElement.classList.add(this.validClass),this.inputElement.classList.remove(this.errorClass),this.inputElement.setAttribute("aria-invalid","false"))},s.prototype.checkRequired=function(t){this.rules[t][this.required]||this.inputElement.value.length||e.isNullOrUndefined(this.infoElement)||(this.infoElement.innerHTML=this.inputElement.value,this.infoElement.setAttribute("aria-invalid","false"),this.hideMessage(t))},s.isCheckable=function(t){var e=t.getAttribute("type");return e&&("checkbox"===e||"radio"===e||"submit"===e)};var n;return s.checkValidator={required:function(t){return isNaN(Date.parse(t.value))?t.value.toString().length>0:!isNaN(new Date(t.value).getTime())},email:function(t){return Ce.EMAIL.test(t.value)},url:function(t){return Ce.URL.test(t.value)},dateIso:function(t){return Ce.DATE_ISO.test(t.value)},tel:function(t){return Ce.PHONE.test(t.value)},creditcard:function(t){return Ce.CREDITCARD.test(t.value)},number:function(t){return!isNaN(Number(t.value))&&-1===t.value.indexOf(" ")},digits:function(t){return Ce.DIGITS.test(t.value)},maxLength:function(t){return t.value.length<=t.param},minLength:function(t){return t.value.length>=t.param},rangeLength:function(t){var e=t.param;return t.value.length>=e[0]&&t.value.length<=e[1]},range:function(t){var e=t.param;return!isNaN(Number(t.value))&&Number(t.value)>=e[0]&&Number(t.value)<=e[1]},date:function(t){return!isNaN(new Date(t.value).getTime())},max:function(t){return isNaN(Number(t.value))?new Date(t.value).getTime()<=new Date(JSON.parse(JSON.stringify(t.param))).getTime():+t.value<=t.param},min:function(t){if(isNaN(Number(t.value))){if(-1!==t.value.indexOf(",")){var e=t.value.replace(/,/g,"");return parseFloat(e)>=t.param}return new Date(t.value).getTime()>=new Date(JSON.parse(JSON.stringify(t.param))).getTime()}return+t.value>=t.param},regex:function(t){return new RegExp(t.param).test(t.value)},equalTo:function(t){var e=t.formElement.querySelector("#"+t.param);return t.param=e.value,t.param===t.value}},be([e.Property("")],s.prototype,"locale",void 0),be([e.Property("e-hidden")],s.prototype,"ignore",void 0),be([e.Property()],s.prototype,"rules",void 0),be([e.Property("e-error")],s.prototype,"errorClass",void 0),be([e.Property("e-valid")],s.prototype,"validClass",void 0),be([e.Property("label")],s.prototype,"errorElement",void 0),be([e.Property("div")],s.prototype,"errorContainer",void 0),be([e.Property(t.ErrorOption.Label)],s.prototype,"errorOption",void 0),be([e.Event()],s.prototype,"focusout",void 0),be([e.Event()],s.prototype,"keyup",void 0),be([e.Event()],s.prototype,"click",void 0),be([e.Event()],s.prototype,"change",void 0),be([e.Event()],s.prototype,"submit",void 0),be([e.Event()],s.prototype,"validationBegin",void 0),be([e.Event()],s.prototype,"validationComplete",void 0),be([e.Event()],s.prototype,"customPlacement",void 0),s=n=be([e.NotifyPropertyChanges],s)}(e.Base),xe=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function s(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),Se=function(t,e,i,s){var n,a=arguments.length,r=a<3?e:null===s?s=Object.getOwnPropertyDescriptor(e,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(t,e,i,s);else for(var l=t.length-1;l>=0;l--)(n=t[l])&&(r=(a<3?n(r):a>3?n(e,i,r):n(e,i))||r);return a>3&&r&&Object.defineProperty(e,i,r),r},ke="e-file-drop",Pe="e-upload-file-list",Oe="e-file-status",Te="e-file-remove-btn",Le="e-file-delete-btn",Ae="e-file-abort-btn",Ne="e-file-reload-btn",we="e-upload-drag-hover",He="e-upload-progress-wrap",Be="e-upload-progress-bar",Ue="e-progress-bar-text",Re="e-upload-progress",Ve="e-upload-success",Fe="e-upload-fails",Me="e-file-container",Ie="e-validation-fails",De="e-disabled",ze="e-clear-icon-focus",qe="e-file-pause-btn",We="e-file-play-btn",je="e-restrict-retry",_e=["title","style","class"],Xe="e-file-invalid",Ke=function(t){function i(){return null!==t&&t.apply(this,arguments)||this}return xe(i,t),Se([e.Property("")],i.prototype,"name",void 0),Se([e.Property(null)],i.prototype,"size",void 0),Se([e.Property("")],i.prototype,"type",void 0),i}(e.ChildProperty),Ze=function(t){function i(){return null!==t&&t.apply(this,arguments)||this}return xe(i,t),Se([e.Property("Browse...")],i.prototype,"browse",void 0),Se([e.Property("Upload")],i.prototype,"upload",void 0),Se([e.Property("Clear")],i.prototype,"clear",void 0),i}(e.ChildProperty),Ye=function(t){function i(){return null!==t&&t.apply(this,arguments)||this}return xe(i,t),Se([e.Property("")],i.prototype,"saveUrl",void 0),Se([e.Property("")],i.prototype,"removeUrl",void 0),Se([e.Property(0)],i.prototype,"chunkSize",void 0),Se([e.Property(3)],i.prototype,"retryCount",void 0),Se([e.Property(500)],i.prototype,"retryAfterDelay",void 0),i}(e.ChildProperty),Ge=function(t){function s(e,i){var s=t.call(this,e,i)||this;return s.initialAttr={accept:null,multiple:!1,disabled:!1},s.uploadedFilesData=[],s.base64String=[],s.isForm=!1,s.allTypes=!1,s.pausedData=[],s.uploadMetaData=[],s.tabIndex="0",s.btnTabIndex="0",s.disableKeyboardNavigation=!1,s.count=-1,s.actionCompleteCount=0,s.flag=!0,s.selectedFiles=[],s.uploaderName="UploadFiles",s.fileStreams=[],s.newFileRef=0,s.isFirstFileOnSelection=!1,s.dragCounter=0,s.fileList=[],s.filesData=[],s.uploaderOptions=e,s}return xe(s,t),s.prototype.onPropertyChanged=function(t,i){for(var s=0,n=Object.keys(t);s<n.length;s++){switch(n[s]){case"allowedExtensions":this.setExtensions(this.allowedExtensions),this.clearAll();break;case"enabled":this.setControlStatus();break;case"multiple":this.setMultipleSelection();break;case"enableRtl":this.setRTL(),this.reRenderFileList();break;case"buttons":this.buttons.browse=e.isNullOrUndefined(this.buttons.browse)?"":this.buttons.browse,this.buttons.clear=e.isNullOrUndefined(this.buttons.clear)?"":this.buttons.clear,this.buttons.upload=e.isNullOrUndefined(this.buttons.upload)?"":this.buttons.upload,this.renderButtonTemplates();break;case"dropArea":this.unBindDropEvents(),this.updateDropArea();break;case"htmlAttributes":this.updateHTMLAttrToElement(),this.updateHTMLAttrToWrapper(),this.checkHTMLAttributes(!0);break;case"files":this.renderPreLoadFiles();break;case"directoryUpload":this.updateDirectoryAttributes();break;case"template":this.clearAll();break;case"minFileSize":case"maxFileSize":case"autoUpload":case"sequentialUpload":this.clearAll();break;case"locale":this.l10n.setLocale(this.locale),this.setLocalizedTexts(),this.preLocaleObj=e.getValue("currentLocale",this.l10n);break;case"cssClass":this.setCSSClass(i.cssClass)}}},s.prototype.setLocalizedTexts=function(){e.isNullOrUndefined(this.template)&&("string"==typeof this.buttons.browse&&(this.browseButton.innerText="Browse..."===this.buttons.browse?this.localizedTexts("Browse"):this.buttons.browse,this.browseButton.setAttribute("title",this.browseButton.innerText),this.uploadWrapper&&!e.isNullOrUndefined(this.uploadWrapper.querySelector("."+ke))&&(this.uploadWrapper.querySelector("."+ke).innerHTML=this.localizedTexts("dropFilesHint"))),this.updateFileList())},s.prototype.getKeyValue=function(t){for(var e,i=0,s=Object.keys(this.preLocaleObj);i<s.length;i++){var n=s[i];this.preLocaleObj[n]===t&&(e=n)}return e},s.prototype.updateFileList=function(){if(this.fileList.length>0&&!e.isNullOrUndefined(this.uploadWrapper.querySelector(".e-upload-files")))for(var t=0;t<this.fileList.length;t++)this.fileList[t].querySelector(".e-file-status").innerHTML=this.localizedTexts(this.getKeyValue(this.filesData[t].status)),this.filesData[t].status=this.localizedTexts(this.getKeyValue(this.filesData[t].status)),this.fileList[t].classList.contains(Ve)&&this.fileList[t].querySelector(".e-icons").setAttribute("title",this.localizedTexts("delete")),this.fileList[t].querySelector(".e-file-play-btn")&&this.fileList[t].querySelector(".e-icons").setAttribute("title",this.localizedTexts("resume")),this.fileList[t].querySelector(".e-file-remove-btn")&&this.fileList[t].querySelector(".e-icons").setAttribute("title",this.localizedTexts("remove")),this.fileList[t].querySelector(".e-file-reload-btn")&&this.fileList[t].querySelector(".e-icons").setAttribute("title",this.localizedTexts("retry")),this.autoUpload||(this.uploadButton.innerText="Upload"===this.buttons.upload?this.localizedTexts("Upload"):this.buttons.upload,this.uploadButton.setAttribute("title",this.localizedTexts("Upload")),this.clearButton.innerText="Clear"===this.buttons.clear?this.localizedTexts("Clear"):this.buttons.clear,this.clearButton.setAttribute("title",this.localizedTexts("Clear")))},s.prototype.reRenderFileList=function(){this.listParent&&(e.detach(this.listParent),this.listParent=null,this.fileList=[],this.createFileList(this.filesData),this.actionButtons&&(this.removeActionButtons(),this.renderActionButtons(),this.checkActionButtonStatus()))},s.prototype.preRender=function(){this.localeText={Browse:"Browse...",Clear:"Clear",Upload:"Upload",dropFilesHint:"Or drop files here",invalidMaxFileSize:"File size is too large",invalidMinFileSize:"File size is too small",invalidFileType:"File type is not allowed",uploadFailedMessage:"File failed to upload",uploadSuccessMessage:"File uploaded successfully",removedSuccessMessage:"File removed successfully",removedFailedMessage:"Unable to remove file",inProgress:"Uploading",readyToUploadMessage:"Ready to upload",abort:"Abort",remove:"Remove",cancel:"Cancel",delete:"Delete file",pauseUpload:"File upload paused",pause:"Pause",resume:"Resume",retry:"Retry",fileUploadCancel:"File upload canceled",invalidFileSelection:"Invalid files selected",totalFiles:"Total files",size:"Size"},this.l10n=new e.L10n("uploader",this.localeText,this.locale),this.preLocaleObj=e.getValue("currentLocale",this.l10n),this.formRendered(),this.updateHTMLAttrToElement(),this.checkHTMLAttributes(!1);var t=e.getValue("ej2_instances",this.element);if("EJS-UPLOADER"===this.element.tagName){for(var i=this.createElement("input",{attrs:{type:"file"}}),s=0;s<this.element.attributes.length;s++)i.setAttribute(this.element.attributes[s].nodeName,this.element.attributes[s].nodeValue),i.innerHTML=this.element.innerHTML;i.hasAttribute("name")||i.setAttribute("name","UploadFiles"),this.element.appendChild(i),this.element=i,e.setValue("ej2_instances",t,this.element)}t[0].isPureReactComponent&&(e.isNullOrUndefined(t[0].props.name)?!e.isNullOrUndefined(t[0].props.id)&&e.isNullOrUndefined(t[0].props.name)?this.element.setAttribute("name",t[0].props.id):this.element.setAttribute("name","UploadFiles"):this.element.setAttribute("name",t[0].props.name)),e.isNullOrUndefined(this.element.getAttribute("name"))&&this.element.setAttribute("name",this.element.getAttribute("id")),this.element.hasAttribute("type")||this.element.setAttribute("type","file"),this.updateDirectoryAttributes(),this.keyConfigs={enter:"enter"},this.element.hasAttribute("tabindex")&&(this.tabIndex=this.element.getAttribute("tabindex")),this.browserName=e.Browser.info.name,this.uploaderName=this.element.getAttribute("name")},s.prototype.formRendered=function(){var t=e.closest(this.element,"form");if(!e.isNullOrUndefined(t))for(;t&&t!==document.documentElement;t=t.parentElement)"FORM"===t.tagName&&(this.isForm=!0,this.formElement=t,t.setAttribute("enctype","multipart/form-data"),t.setAttribute("encoding","multipart/form-data"))},s.prototype.getPersistData=function(){return this.addOnPersist(["filesData"])},s.prototype.getModuleName=function(){return"uploader"},s.prototype.updateDirectoryAttributes=function(){this.directoryUpload?(this.element.setAttribute("directory","true"),this.element.setAttribute("webkitdirectory","true")):(this.element.removeAttribute("directory"),this.element.removeAttribute("webkitdirectory"))},s.prototype.render=function(){this.renderBrowseButton(),this.initializeUpload(),this.updateHTMLAttrToWrapper(),this.wireEvents(),this.setMultipleSelection(),this.setExtensions(this.allowedExtensions),this.setRTL(),this.renderPreLoadFiles(),this.setControlStatus(),this.setCSSClass()},s.prototype.renderBrowseButton=function(){this.browseButton=this.createElement("button",{className:"e-css e-btn",attrs:{type:"button"}}),this.browseButton.setAttribute("tabindex",this.tabIndex),"string"==typeof this.buttons.browse?(this.browseButton.textContent="Browse..."===this.buttons.browse?this.localizedTexts("Browse"):this.buttons.browse,this.browseButton.setAttribute("title",this.browseButton.innerText)):this.browseButton.appendChild(this.buttons.browse),this.element.setAttribute("aria-label","Uploader")},s.prototype.renderActionButtons=function(){this.element.setAttribute("tabindex","-1"),this.actionButtons=this.createElement("div",{className:"e-upload-actions"}),this.uploadButton=this.createElement("button",{className:"e-file-upload-btn e-css e-btn e-flat e-primary",attrs:{type:"button",tabindex:this.btnTabIndex}}),this.clearButton=this.createElement("button",{className:"e-file-clear-btn e-css e-btn e-flat",attrs:{type:"button",tabindex:this.btnTabIndex}}),this.actionButtons.appendChild(this.clearButton),this.actionButtons.appendChild(this.uploadButton),this.renderButtonTemplates(),this.uploadWrapper.appendChild(this.actionButtons),this.browseButton.blur(),this.isPreloadFiles||this.uploadButton.focus(),this.wireActionButtonEvents()},s.prototype.serverActionButtonsEventBind=function(t){t&&!this.isForm&&(this.browseButton.blur(),this.actionButtons=t,this.uploadButton=this.actionButtons.querySelector(".e-file-upload-btn"),this.clearButton=this.actionButtons.querySelector(".e-file-clear-btn"),this.uploadButton.focus(),this.unwireActionButtonEvents(),this.wireActionButtonEvents(),this.checkActionButtonStatus())},s.prototype.wireActionButtonEvents=function(){e.EventHandler.add(this.uploadButton,"click",this.uploadButtonClick,this),e.EventHandler.add(this.clearButton,"click",this.clearButtonClick,this)},s.prototype.unwireActionButtonEvents=function(){e.EventHandler.remove(this.uploadButton,"click",this.uploadButtonClick),e.EventHandler.remove(this.clearButton,"click",this.clearButtonClick)},s.prototype.removeActionButtons=function(){this.actionButtons&&(this.unwireActionButtonEvents(),e.detach(this.actionButtons),this.actionButtons=null)},s.prototype.renderButtonTemplates=function(){if("string"==typeof this.buttons.browse?(this.browseButton.textContent="Browse..."===this.buttons.browse?this.localizedTexts("Browse"):this.buttons.browse,this.browseButton.setAttribute("title",this.browseButton.textContent)):(this.browseButton.innerHTML="",this.browseButton.appendChild(this.buttons.browse)),this.uploadButton){var t=e.isNullOrUndefined(this.buttons.upload)?"Upload":this.buttons.upload;this.buttons.upload=t,"string"==typeof this.buttons.upload?(this.uploadButton.textContent="Upload"===this.buttons.upload?this.localizedTexts("Upload"):this.buttons.upload,this.uploadButton.setAttribute("title",this.uploadButton.textContent)):(this.uploadButton.innerHTML="",this.uploadButton.appendChild(this.buttons.upload))}if(this.clearButton){var i=e.isNullOrUndefined(this.buttons.clear)?"Clear":this.buttons.clear;this.buttons.clear=i,"string"==typeof this.buttons.clear?(this.clearButton.textContent="Clear"===this.buttons.clear?this.localizedTexts("Clear"):this.buttons.clear,this.clearButton.setAttribute("title",this.clearButton.textContent)):(this.clearButton.innerHTML="",this.clearButton.appendChild(this.buttons.clear))}},s.prototype.initializeUpload=function(){this.element.setAttribute("tabindex","-1");var t=this.createElement("span",{className:"e-file-select"});this.element.parentElement.insertBefore(t,this.element),this.dropAreaWrapper=this.createElement("div",{className:"e-file-select-wrap"}),this.element.parentElement.insertBefore(this.dropAreaWrapper,this.element),t.appendChild(this.element),this.dropAreaWrapper.appendChild(this.browseButton),this.dropAreaWrapper.appendChild(t),this.uploadWrapper=this.createElement("div",{className:"e-upload e-control-wrapper"}),this.dropAreaWrapper.parentElement.insertBefore(this.uploadWrapper,this.dropAreaWrapper),this.uploadWrapper.appendChild(this.dropAreaWrapper),this.setDropArea()},s.prototype.renderPreLoadFiles=function(){if(this.files.length){if(this.enablePersistence&&this.filesData.length)return void this.createFileList(this.filesData);if(e.isNullOrUndefined(this.files[0].size))return;this.isPreloadFiles=!0;var t=[].slice.call(this.files),i=[];this.multiple||(this.clearData(),t=[t[0]]);for(var s=0,n=t;s<n.length;s++){var a=n[s],r={name:a.name+"."+a.type.split(".")[a.type.split(".").length-1],rawFile:"",size:a.size,status:this.localizedTexts("uploadSuccessMessage"),type:a.type,validationMessages:{minSize:"",maxSize:""},statusCode:"2"};i.push(r),this.filesData.push(r)}this.createFileList(i),this.autoUpload||!this.listParent||this.actionButtons||this.isForm&&!this.allowUpload()||!this.showFileList||this.renderActionButtons(),this.checkActionButtonStatus(),this.sequentialUpload&&(this.count=this.filesData.length-1),this.isPreloadFiles=!1}},s.prototype.checkActionButtonStatus=function(){if(this.actionButtons){var t=this.uploadWrapper.querySelectorAll("."+Ie).length+this.uploadWrapper.querySelectorAll(".e-upload-fails:not(.e-upload-progress)").length+this.uploadWrapper.querySelectorAll("span."+Ve).length+this.uploadWrapper.querySelectorAll("span."+Re).length;t>0&&t===this.uploadWrapper.querySelectorAll("li").length?this.uploadButton.setAttribute("disabled","disabled"):this.uploadButton.removeAttribute("disabled")}},s.prototype.setDropArea=function(){var t=this.dropAreaWrapper.querySelector(".e-file-drop");if(this.dropArea){this.dropZoneElement="string"!=typeof this.dropArea?this.dropArea:e.select(this.dropArea,document);for(var i=this.element,s=!1;i.parentNode;)(i=i.parentNode)===this.dropZoneElement&&(s=!0,t?t.innerHTML=this.localizedTexts("dropFilesHint"):this.createDropTextHint());!s&&t&&e.remove(t)}else e.isNullOrUndefined(this.uploaderOptions)||void 0!==this.uploaderOptions.dropArea||(this.createDropTextHint(),this.dropZoneElement=this.uploadWrapper,this.setProperties({dropArea:this.uploadWrapper},!0));this.bindDropEvents()},s.prototype.updateDropArea=function(){if(this.dropArea)this.setDropArea();else{this.dropZoneElement=null;var t=this.dropAreaWrapper.querySelector(".e-file-drop");t&&e.remove(t)}},s.prototype.createDropTextHint=function(){var t=this.createElement("span",{className:ke});t.innerHTML=this.localizedTexts("dropFilesHint"),this.dropAreaWrapper.appendChild(t)},s.prototype.updateHTMLAttrToElement=function(){if(!e.isNullOrUndefined(this.htmlAttributes))for(var t=0,i=Object.keys(this.htmlAttributes);t<i.length;t++){var s=i[t];_e.indexOf(s)<0&&this.element.setAttribute(s,this.htmlAttributes[s])}},s.prototype.updateHTMLAttrToWrapper=function(){if(!e.isNullOrUndefined(this.htmlAttributes))for(var t=0,i=Object.keys(this.htmlAttributes);t<i.length;t++){var s=i[t];if(_e.indexOf(s)>-1)if("class"===s){var n=this.htmlAttributes[s].replace(/\s+/g," ").trim();""!==n&&e.addClass([this.uploadWrapper],n.split(" "))}else if("style"===s){var a=this.uploadWrapper.getAttribute(s);a=e.isNullOrUndefined(a)?this.htmlAttributes[s]:a+this.htmlAttributes[s],this.uploadWrapper.setAttribute(s,a)}else this.uploadWrapper.setAttribute(s,this.htmlAttributes[s])}},s.prototype.setMultipleSelection=function(){if(this.multiple&&!this.element.hasAttribute("multiple")){var t=document.createAttribute("multiple");t.value="multiple",this.element.setAttributeNode(t)}else this.multiple||this.element.removeAttribute("multiple")},s.prototype.checkAutoUpload=function(t){this.autoUpload?(this.sequentialUpload?this.sequenceUpload(t):this.upload(t),this.removeActionButtons()):this.actionButtons||this.renderActionButtons(),this.checkActionButtonStatus()},s.prototype.sequenceUpload=function(t){if(this.filesData.length-t.length==0||"1"!==this.filesData[this.filesData.length-t.length-1].statusCode){++this.count;var e=!this.showFileList;"object"==typeof this.filesData[this.count]?(this.isFirstFileOnSelection=!1,this.upload(this.filesData[this.count],e),"0"===this.filesData[this.count].statusCode&&this.sequenceUpload(t)):--this.count}},s.prototype.setCSSClass=function(t){var i=this.cssClass;e.isNullOrUndefined(this.cssClass)||""===this.cssClass||(i=this.cssClass.replace(/\s+/g," ").trim()),e.isNullOrUndefined(this.cssClass)||""===i||e.addClass([this.uploadWrapper],i.split(i.indexOf(",")>-1?",":" "));var s=t;e.isNullOrUndefined(t)||(s=t.replace(/\s+/g," ").trim()),e.isNullOrUndefined(t)||""===s||e.removeClass([this.uploadWrapper],s.split(" "))},s.prototype.wireEvents=function(){e.EventHandler.add(this.browseButton,"click",this.browseButtonClick,this),e.EventHandler.add(this.element,"change",this.onSelectFiles,this),e.EventHandler.add(document,"click",this.removeFocus,this),this.keyboardModule=new e.KeyboardEvents(this.uploadWrapper,{keyAction:this.keyActionHandler.bind(this),keyConfigs:this.keyConfigs,eventName:"keydown"}),this.isForm&&e.EventHandler.add(this.formElement,"reset",this.resetForm,this)},s.prototype.unWireEvents=function(){e.EventHandler.remove(this.browseButton,"click",this.browseButtonClick),e.EventHandler.remove(this.element,"change",this.onSelectFiles),e.EventHandler.remove(document,"click",this.removeFocus),this.isForm&&e.EventHandler.remove(this.formElement,"reset",this.resetForm),this.keyboardModule&&this.keyboardModule.destroy()},s.prototype.resetForm=function(){this.clearAll()},s.prototype.keyActionHandler=function(t){var i=t.target;switch(t.action){case"enter":if(t.target===this.clearButton)this.clearButtonClick();else if(t.target===this.uploadButton)this.uploadButtonClick();else if(t.target===this.browseButton)this.browseButtonClick();else if(i.classList.contains(qe)){(s=this.getCurrentMetaData(null,t)).file.statusCode="4",s.file.status=this.localizedTexts("pauseUpload"),this.abortUpload(s,!1)}else if(i.classList.contains(We))this.resumeUpload(this.getCurrentMetaData(null,t),t);else if(i.classList.contains(Ne)){var s=this.getCurrentMetaData(null,t);if(e.isNullOrUndefined(s)){var n=t.target.parentElement,a=this.filesData[this.fileList.indexOf(n)];this.retry(a)}else s.file.statusCode="1",s.file.status=this.localizedTexts("readyToUploadMessage"),this.chunkUpload(s.file)}else this.removeFiles(t),i.classList.contains(Ae)||this.browseButton.focus();t.preventDefault(),t.stopPropagation()}},s.prototype.getCurrentMetaData=function(t,i){var s,n;if(e.isNullOrUndefined(t)){var a=i.target.parentElement;s=this.filesData[this.fileList.indexOf(a)]}else s=t;for(var r=0;r<this.uploadMetaData.length;r++)this.uploadMetaData[r].file.name===s.name&&(n=this.uploadMetaData[r]);return n},s.prototype.removeFocus=function(){this.uploadWrapper&&this.listParent&&this.listParent.querySelector("."+ze)&&(document.activeElement.blur(),this.listParent.querySelector("."+ze).classList.remove(ze))},s.prototype.browseButtonClick=function(){this.element.click()},s.prototype.uploadButtonClick=function(){this.sequentialUpload?this.sequenceUpload(this.filesData):this.upload(this.filesData)},s.prototype.clearButtonClick=function(){this.clearAll(),this.sequentialUpload&&(this.count=-1),this.actionCompleteCount=0},s.prototype.bindDropEvents=function(){this.dropZoneElement&&(e.EventHandler.add(this.dropZoneElement,"drop",this.dropElement,this),e.EventHandler.add(this.dropZoneElement,"dragover",this.dragHover,this),e.EventHandler.add(this.dropZoneElement,"dragleave",this.onDragLeave,this),e.EventHandler.add(this.dropZoneElement,"paste",this.onPasteFile,this),e.EventHandler.add(this.dropZoneElement,"dragenter",this.onDragEnter,this))},s.prototype.unBindDropEvents=function(){this.dropZoneElement&&(e.EventHandler.remove(this.dropZoneElement,"drop",this.dropElement),e.EventHandler.remove(this.dropZoneElement,"dragover",this.dragHover),e.EventHandler.remove(this.dropZoneElement,"dragleave",this.onDragLeave),e.EventHandler.remove(this.dropZoneElement,"dragenter",this.onDragEnter))},s.prototype.onDragEnter=function(t){this.enabled&&(this.dropZoneElement.classList.add(we),this.dragCounter=this.dragCounter+1,t.preventDefault(),t.stopPropagation())},s.prototype.onDragLeave=function(){this.enabled&&(this.dragCounter=this.dragCounter-1,this.dragCounter||this.dropZoneElement.classList.remove(we))},s.prototype.dragHover=function(t){this.enabled&&("Default"!==this.dropEffect&&(t.dataTransfer.dropEffect=this.dropEffect.toLowerCase()),t.preventDefault(),t.stopPropagation())},s.prototype.dropElement=function(t){this.dragCounter=0,this.dropZoneElement.classList.remove(we),this.onSelectFiles(t),t.preventDefault(),t.stopPropagation()},s.prototype.onPasteFile=function(t){var e=t.clipboardData.items;if(1===e.length){var i=[].slice.call(e)[0];"file"===i.kind&&i.type.match("^image/")&&this.renderSelectedFiles(t,[i.getAsFile()],!1,!0)}},s.prototype.getSelectedFiles=function(t){for(var e=[],i=this.fileList[t],s=this.getFilesData(),n=+i.getAttribute("data-files-count"),a=0,r=0;r<t;r++)a+=+this.fileList[r].getAttribute("data-files-count");for(var l=a;l<a+n;l++)e.push(s[l]);return e},s.prototype.removeFiles=function(t){if(this.enabled){var s=t.target.parentElement,n=this.fileList.indexOf(s),a=this.fileList[n],r=this.isFormUpload(),l=r?this.getSelectedFiles(n):this.getFilesInArray(this.filesData[n]);if(!e.isNullOrUndefined(l)){if(t.target.classList.contains(Ae)&&!r){if(l[0].statusCode="5",!e.isNullOrUndefined(a)){var o=a.querySelector("."+Ae);i.createSpinner({target:o,width:"20px"}),i.showSpinner(o)}this.sequentialUpload&&this.uploadSequential(),a.classList.contains(je)||this.checkActionComplete(!0)}else e.closest(t.target,".e-spinner-pane")||this.remove(l,!1,!1,!0,t);this.element.value="",this.checkActionButtonStatus()}}},s.prototype.removeFilesData=function(t,i){var s;if(i)this.showFileList||(s=this.filesData.indexOf(t),this.filesData.splice(s,1));else{var n=this.getLiElement(t);e.isNullOrUndefined(n)||(e.detach(n),s=this.fileList.indexOf(n),this.fileList.splice(s,1),this.filesData.splice(s,1),0!==this.fileList.length||e.isNullOrUndefined(this.listParent)||(e.detach(this.listParent),this.listParent=null,this.removeActionButtons()),this.sequentialUpload&&s<=this.count&&--this.count)}},s.prototype.removeUploadedFile=function(t,i,s,n){var a=this,r=t,l=new e.Ajax(this.asyncSettings.removeUrl,"POST",!0,null);l.emitError=!1;var o=new FormData;l.beforeSend=function(e){i.currentRequest=l.httpRequest,s?a.removingEventCallback(i,o,r,t):a.trigger("removing",i,function(i){i.cancel?e.cancel=!0:a.removingEventCallback(i,o,r,t)})},l.onLoad=function(t){return a.removeCompleted(t,r,n),{}},l.onError=function(t){return a.removeFailed(t,r,n),{}},l.send(o)},s.prototype.removingEventCallback=function(t,s,n,a){var r=this.element.getAttribute("name"),l=this.getLiElement(a);if(!(e.isNullOrUndefined(l)||e.isNullOrUndefined(l.querySelector("."+Le))&&e.isNullOrUndefined(l.querySelector("."+Te)))){var o=l.querySelector("."+Le)?l.querySelector("."+Le):l.querySelector("."+Te);i.createSpinner({target:o,width:"20px"}),i.showSpinner(o)}t.postRawFile&&!e.isNullOrUndefined(n.rawFile)&&""!==n.rawFile?s.append(r,n.rawFile,n.name):s.append(r,n.name),this.updateFormData(s,t.customFormData)},s.prototype.updateFormData=function(t,e){if(e.length>0&&e[0])for(var i=function(i){var s=e[i],n=Object.keys(s).map(function(t){return s[t]});t.append(Object.keys(s)[0],n)},s=0;s<e.length;s++)i(s)},s.prototype.updateCustomheader=function(t,e){if(e.length>0&&e[0])for(var i=function(i){var s=e[i],n=Object.keys(s).map(function(t){return s[t]});t.setRequestHeader(Object.keys(s)[0],n)},s=0;s<e.length;s++)i(s)},s.prototype.removeCompleted=function(t,e,i){var s=t&&t.currentTarget?this.getResponse(t):null,n=t.target;if(4===n.readyState&&n.status>=200&&n.status<=299){var a={e:t,response:s,operation:"remove",file:this.updateStatus(e,this.localizedTexts("removedSuccessMessage"),"2")};this.trigger("success",a),this.removeFilesData(e,i);var r=this.uploadedFilesData.indexOf(e);this.uploadedFilesData.splice(r,1),this.trigger("change",{files:this.uploadedFilesData})}else this.removeFailed(t,e,i)},s.prototype.removeFailed=function(t,s,n){var a={e:t,response:t&&t.currentTarget?this.getResponse(t):null,operation:"remove",file:this.updateStatus(s,this.localizedTexts("removedFailedMessage"),"0")};if(!n){var r=this.filesData.indexOf(s),l=this.fileList[r];if(l){l.classList.remove(Ve),l.classList.add(Fe);var o=l.querySelector("."+Oe);o&&(o.classList.remove(Ve),o.classList.add(Fe))}this.checkActionButtonStatus()}this.trigger("failure",a);var h=this.getLiElement(s);if(!e.isNullOrUndefined(h)&&!e.isNullOrUndefined(h.querySelector("."+Le))){var d=h.querySelector("."+Le);i.hideSpinner(d),e.detach(h.querySelector(".e-spinner-pane"))}},s.prototype.getFilesFromFolder=function(t){this.filesEntries=[];var e=this.multiple?t.dataTransfer.items:[t.dataTransfer.items[0]];if(this.checkDirectoryUpload(e))for(var i=function(i){var n=e[i].webkitGetAsEntry();if(n.isFile){var a=[];n.file(function(t){var e=n.fullPath;a.push({path:e,file:t})}),s.renderSelectedFiles(t,a,!0)}else n.isDirectory&&s.traverseFileTree(n,t)},s=this,n=0;n<e.length;n++)i(n)},s.prototype.checkDirectoryUpload=function(t){for(var e=0;t&&e<t.length;e++){if(t[e].webkitGetAsEntry().isDirectory)return!0}return!1},s.prototype.traverseFileTree=function(t,e){if(t.isFile)this.filesEntries.push(t);else if(t.isDirectory){var i=t.createReader();this.readFileFromDirectory(i,e)}},s.prototype.readFileFromDirectory=function(t,e){var i=this;t.readEntries(function(s){for(var n=0;n<s.length;n++)i.traverseFileTree(s[n],e);i.pushFilesEntries(e),s.length&&i.readFileFromDirectory(t)})},s.prototype.pushFilesEntries=function(t){for(var e=this,i=[],s=function(s){n.filesEntries[s].file(function(n){if(e.filesEntries.length){var a=e.filesEntries[s].fullPath;i.push({path:a,file:n}),s===e.filesEntries.length-1&&(e.filesEntries=[],e.renderSelectedFiles(t,i,!0))}})},n=this,a=0;a<this.filesEntries.length;a++)s(a)},s.prototype.onSelectFiles=function(t){if(this.enabled){var e;if("drop"===t.type)if(this.directoryUpload)this.getFilesFromFolder(t);else{var i=this.sortFilesList=t.dataTransfer.files;"msie"!==this.browserName&&"edge"!==this.browserName&&"safari"!==this.browserName&&(this.element.files=i),i.length>0&&(e=this.multiple?this.sortFileList(i):[i[0]],this.renderSelectedFiles(t,e))}else e=[].slice.call(t.target.files),this.renderSelectedFiles(t,e)}},s.prototype.getBase64=function(t){return new Promise(function(e,i){var s=new FileReader;s.readAsDataURL(t),s.onload=function(){return e(s.result)},s.onerror=function(t){return i(t)}})},s.prototype.renderSelectedFiles=function(t,e,i,s){var n=this;this.base64String=[];var a={event:t,cancel:!1,filesData:[],isModified:!1,modifiedFilesData:[],progressInterval:"",isCanceled:!1,currentRequest:null,customFormData:null};if(e.length<1)return a.isCanceled=!0,void this.trigger("selected",a);this.flag=!0;var r=[];this.multiple||(this.clearData(!0),e=[e[0]]);for(var l=0;l<e.length;l++){var o=i?e[l].file:e[l];this.updateInitialFileDetails(t,e,o,l,r,i,s)}a.filesData=r,this.allowedExtensions.indexOf("*")>-1&&(this.allTypes=!0),this.allTypes||(r=this.checkExtension(r)),this.trigger("selected",a,function(t){n._internalRenderSelect(t,r)})},s.prototype.updateInitialFileDetails=function(t,i,s,n,a,r,l){var o={name:r?i[n].path.substring(1,i[n].path.length):l?e.getUniqueID(s.name.substring(0,s.name.lastIndexOf(".")))+"."+this.getFileType(s.name):this.directoryUpload?i[n].webkitRelativePath:s.name,rawFile:s,size:s.size,status:this.localizedTexts("readyToUploadMessage"),type:this.getFileType(s.name),validationMessages:this.validatedFileSize(s.size),statusCode:"1",id:e.getUniqueID(s.name.substring(0,s.name.lastIndexOf(".")))+"."+this.getFileType(s.name)};l&&(o.fileSource="paste"),o.status=""!==o.validationMessages.minSize?this.localizedTexts("invalidMinFileSize"):""!==o.validationMessages.maxSize?this.localizedTexts("invalidMaxFileSize"):o.status,""===o.validationMessages.minSize&&""===o.validationMessages.maxSize||(o.statusCode="0"),a.push(o)},s.prototype._internalRenderSelect=function(t,i){if(!t.cancel){if(this.selectedFiles=this.selectedFiles.concat(i),this.btnTabIndex=this.disableKeyboardNavigation?"-1":"0",this.showFileList){if(t.isModified&&t.modifiedFilesData.length>0){for(var s=0;s<t.modifiedFilesData.length;s++)for(var n=0;n<i.length;n++)t.modifiedFilesData[s].id===i[n].id&&(t.modifiedFilesData[s].rawFile=i[n].rawFile);var a=this.allTypes?t.modifiedFilesData:this.checkExtension(t.modifiedFilesData);this.updateSortedFileList(a),this.filesData=a,this.isForm&&!this.allowUpload()||this.checkAutoUpload(a)}else this.createFileList(i,!0),this.filesData=this.filesData.concat(i),this.isForm&&!this.allowUpload()||this.checkAutoUpload(i);e.isNullOrUndefined(t.progressInterval)||""===t.progressInterval||(this.progressInterval=t.progressInterval)}else this.filesData=this.filesData.concat(i),this.autoUpload&&this.upload(this.filesData,!0);this.raiseActionComplete(),this.isFirstFileOnSelection=!0}},s.prototype.allowUpload=function(){var t=!1;return this.isForm&&!e.isNullOrUndefined(this.asyncSettings.saveUrl)&&""!==this.asyncSettings.saveUrl&&(t=!0),t},s.prototype.isFormUpload=function(){var t=!1;return!this.isForm||!e.isNullOrUndefined(this.asyncSettings.saveUrl)&&""!==this.asyncSettings.saveUrl||!e.isNullOrUndefined(this.asyncSettings.removeUrl)&&""!==this.asyncSettings.removeUrl||(t=!0),t},s.prototype.clearData=function(t){e.isNullOrUndefined(this.listParent)||(e.detach(this.listParent),this.listParent=null),"msie"===this.browserName||t||(this.element.value=""),this.fileList=[],this.filesData=[],this.removeActionButtons()},s.prototype.updateSortedFileList=function(t){var i=this.createElement("div",{id:"clonewrapper"}),s=-1;if(this.listParent){for(var n=0;n<this.listParent.querySelectorAll("li").length;n++){var a=this.listParent.querySelectorAll("li")[n];i.appendChild(a.cloneNode(!0))}for(var r=0,l=this.listParent.querySelectorAll("li");r<l.length;r++){var o=l[r];e.detach(o)}this.removeActionButtons();var h=[].slice.call(i.childNodes);e.detach(this.listParent),this.listParent=null,this.fileList=[],this.createParentUL();for(var d=0;d<t.length;d++){for(var c=0;c<this.filesData.length;c++)this.filesData[c].name===t[d].name&&(this.listParent.appendChild(h[c]),e.EventHandler.add(h[c].querySelector(".e-icons"),"click",this.removeFiles,this),this.fileList.push(h[c]),s=d);s!==d&&this.createFileList([t[d]])}}else this.createFileList(t)},s.prototype.isBlank=function(t){return!t||/^\s*$/.test(t)},s.prototype.checkExtension=function(t){var e=t;if(!this.isBlank(this.allowedExtensions)){for(var i=[],s=0,n=this.allowedExtensions.split(",");s<n.length;s++){var a=n[s];i.push(a.trim().toLocaleLowerCase())}for(var r=0;r<t.length;r++)-1===i.indexOf(("."+t[r].type).toLocaleLowerCase())&&(t[r].status=this.localizedTexts("invalidFileType"),t[r].statusCode="0")}return e},s.prototype.validatedFileSize=function(t){var e="",i="";t<this.minFileSize?e=this.localizedTexts("invalidMinFileSize"):t>this.maxFileSize?i=this.localizedTexts("invalidMaxFileSize"):(e="",i="");return{minSize:e,maxSize:i}},s.prototype.isPreLoadFile=function(t){for(var e=!1,i=0;i<this.files.length;i++)this.files[i].name===t.name.slice(0,t.name.lastIndexOf("."))&&this.files[i].type===t.type&&(e=!0);return e},s.prototype.createCustomfileList=function(t){this.createParentUL();for(var i=0,s=t;i<s.length;i++){var n=s[i],a=this.createElement("li",{className:Pe,attrs:{"data-file-name":n.name}});this.uploadTemplateFn=this.templateComplier(this.template);var r=this.uploadTemplateFn(n,this,"template",this.element.id+"Template",this.isStringTemplate,null,a);if(r){var l=[].slice.call(r);e.append(l,a)}var o=t.indexOf(n),h={element:a,fileInfo:n,index:o,isPreload:this.isPreLoadFile(n)},d={element:a,fileInfo:n,index:o,isPreload:this.isPreLoadFile(n)};this.trigger("rendering",h),this.trigger("fileListRendering",d),this.listParent.appendChild(a),this.fileList.push(a)}this.renderReactTemplates()},s.prototype.createParentUL=function(){e.isNullOrUndefined(this.listParent)&&(this.listParent=this.createElement("ul",{className:"e-upload-files"}),this.uploadWrapper.appendChild(this.listParent))},s.prototype.formFileList=function(t,i){var s=this.createElement("li",{className:Pe});s.setAttribute("data-files-count",t.length+"");for(var n,a=this.createElement("span",{className:Me}),r=0,l=t;r<l.length;r++){var o=l[r],h=this.createElement("span",{className:"e-file-name"});h.innerHTML=this.getFileNameOnly(o.name);var d=this.createElement("span",{className:"e-file-type"}),c=this.getFileType(o.name);if(d.innerHTML="."+c,c||d.classList.add("e-hidden"),this.enableRtl){var u=this.createElement("span",{className:"e-rtl-container"});u.appendChild(d),u.appendChild(h),a.appendChild(u)}else a.appendChild(h),a.appendChild(d);this.truncateName(h),n=this.formValidateFileInfo(o,s)}s.appendChild(a),this.setListToFileInfo(t,s);var p=this.listParent.querySelectorAll("li").length,m=this.createElement("span");if(s.classList.contains(Xe)?(m.classList.add(Oe),m.classList.add(Xe),m.innerText=t.length>1?this.localizedTexts("invalidFileSelection"):n):(m.classList.add(t.length>1?"e-file-information":"e-file-size"),m.innerText=t.length>1?this.localizedTexts("totalFiles")+": "+t.length+" , "+this.localizedTexts("size")+": "+this.bytesToSize(this.getFileSize(t)):this.bytesToSize(t[0].size),this.createFormInput(t)),a.appendChild(m),e.isNullOrUndefined(s.querySelector(".e-icons"))){var v=this.createElement("span",{className:"e-icons",attrs:{tabindex:this.btnTabIndex}});"msie"===this.browserName&&v.classList.add("e-msie"),v.setAttribute("title",this.localizedTexts("remove")),s.appendChild(a),s.appendChild(v),e.EventHandler.add(v,"click",this.removeFiles,this),v.classList.add(Te)}var f={element:s,fileInfo:this.mergeFileInfo(t,s),index:p,isPreload:this.isPreLoadFile(this.mergeFileInfo(t,s))},g={element:s,fileInfo:this.mergeFileInfo(t,s),index:p,isPreload:this.isPreLoadFile(this.mergeFileInfo(t,s))};this.trigger("rendering",f),this.trigger("fileListRendering",g),this.listParent.appendChild(s),this.fileList.push(s)},s.prototype.formValidateFileInfo=function(t,e){var i=t.status,s=this.validatedFileSize(t.size);""===s.minSize&&""===s.maxSize||(this.addInvalidClass(e),i=""!==s.minSize?this.localizedTexts("invalidMinFileSize"):""!==s.maxSize?this.localizedTexts("invalidMaxFileSize"):i);var n=this.checkExtension(this.getFilesInArray(t))[0].status;return n===this.localizedTexts("invalidFileType")&&(this.addInvalidClass(e),i=n),i},s.prototype.addInvalidClass=function(t){t.classList.add(Xe)},s.prototype.createFormInput=function(t){var e=this.element.cloneNode(!0);e.classList.add("e-hidden-file-input");for(var i=0,s=t;i<s.length;i++){s[i].input=e}e.setAttribute("name",this.uploaderName),this.uploadWrapper.querySelector(".e-file-select").appendChild(e),"msie"!==this.browserName&&"edge"!==this.browserName&&(this.element.value="")},s.prototype.getFileSize=function(t){for(var e=0,i=0,s=t;i<s.length;i++){e+=s[i].size}return e},s.prototype.mergeFileInfo=function(t,e){for(var i={name:"",rawFile:"",size:0,status:"",type:"",validationMessages:{minSize:"",maxSize:""},statusCode:"1",list:e},s=[],n="",a=0,r=t;a<r.length;a++){var l=r[a];s.push(l.name),n=l.type}return i.name=s.join(", "),i.size=this.getFileSize(t),i.type=n,i.status=this.statusForFormUpload(t,e),i},s.prototype.statusForFormUpload=function(t,e){for(var i,s=!0,n=0,a=t;n<a.length;n++){var r=a[n];i=r.status;var l=this.validatedFileSize(r.size);""===l.minSize&&""===l.maxSize||(s=!1,i=""!==l.minSize?this.localizedTexts("invalidMinFileSize"):""!==l.maxSize?this.localizedTexts("invalidMaxFileSize"):i);var o=this.checkExtension(this.getFilesInArray(r))[0].status;o===this.localizedTexts("invalidFileType")&&(s=!1,i=o)}return s?i=this.localizedTexts("totalFiles")+": "+t.length+" , "+this.localizedTexts("size")+": "+this.bytesToSize(this.getFileSize(t)):(e.classList.add(Xe),i=t.length>1?this.localizedTexts("invalidFileSelection"):i),i},s.prototype.formCustomFileList=function(t,i){this.createParentUL();var s=this.createElement("li",{className:Pe});s.setAttribute("data-files-count",t.length+""),this.setListToFileInfo(t,s);var n=this.mergeFileInfo(t,s);s.setAttribute("data-file-name",n.name),this.uploadTemplateFn=this.templateComplier(this.template);var a=this.uploadTemplateFn(n,this,"template",this.element.id+"Template",this.isStringTemplate,null,s);if(a){var r=[].slice.call(a);e.append(r,s)}var l=this.listParent.querySelectorAll("li").length;s.classList.contains(Xe)||this.createFormInput(t);var o={element:s,fileInfo:n,index:l,isPreload:this.isPreLoadFile(n)},h={element:s,fileInfo:n,index:l,isPreload:this.isPreLoadFile(n)};this.trigger("rendering",o),this.trigger("fileListRendering",h),this.listParent.appendChild(s),this.fileList.push(s),this.renderReactTemplates()},s.prototype.createFileList=function(t,i){if(this.createParentUL(),""===this.template||e.isNullOrUndefined(this.template))if(this.isFormUpload())this.uploadWrapper.classList.add("e-form-upload"),this.formFileList(t,this.element.files);else for(var s=0,n=t;s<n.length;s++){var a=n[s],r=this.createElement("li",{className:Pe,attrs:{"data-file-name":a.name,"data-files-count":"1"}}),l=this.createElement("span",{className:Me}),o=this.createElement("span",{className:"e-file-name",attrs:{title:a.name}});o.innerHTML=this.getFileNameOnly(a.name);var h=this.createElement("span",{className:"e-file-type"}),d=this.getFileType(a.name);if(h.innerHTML="."+d,d||h.classList.add("e-hidden"),this.enableRtl){var c=this.createElement("span",{className:"e-rtl-container"});c.appendChild(h),c.appendChild(o),l.appendChild(c)}else l.appendChild(o),l.appendChild(h);var u=this.createElement("span",{className:"e-file-size"});u.innerHTML=this.bytesToSize(a.size),l.appendChild(u);var p=this.createElement("span",{className:Oe});l.appendChild(p),p.innerHTML=a.status,r.appendChild(l);var m=this.createElement("span",{className:" e-icons",attrs:{tabindex:this.btnTabIndex}});"msie"===this.browserName&&m.classList.add("e-msie"),m.setAttribute("title",this.localizedTexts("remove")),r.appendChild(m),e.EventHandler.add(m,"click",this.removeFiles,this),"2"===a.statusCode?(p.classList.add(Ve),m.classList.add(Le),m.setAttribute("title",this.localizedTexts("delete"))):"1"!==a.statusCode&&(p.classList.remove(Ve),p.classList.add(Ie)),this.autoUpload&&"1"===a.statusCode&&""!==this.asyncSettings.saveUrl&&(p.innerHTML=""),m.classList.contains(Le)||m.classList.add(Te);var v=t.indexOf(a),f={element:r,fileInfo:a,index:v,isPreload:this.isPreLoadFile(a)},g={element:r,fileInfo:a,index:v,isPreload:this.isPreLoadFile(a)};this.trigger("rendering",f),this.trigger("fileListRendering",g),this.listParent.appendChild(r),this.fileList.push(r),this.truncateName(o);var y=this.flag;this.isPreLoadFile(a)&&(this.flag=!1,this.checkActionComplete(!0),this.flag=y)}else this.isFormUpload()?(this.uploadWrapper.classList.add("e-form-upload"),this.formCustomFileList(t,this.element.files)):this.createCustomfileList(t)},s.prototype.getSlicedName=function(t){var e=t.textContent;t.dataset.tail=e.slice(e.length-10)},s.prototype.setListToFileInfo=function(t,e){for(var i=0,s=t;i<s.length;i++){s[i].list=e}},s.prototype.truncateName=function(t){var e=t;"edge"!==this.browserName&&e.offsetWidth<e.scrollWidth?this.getSlicedName(e):e.offsetWidth+1<e.scrollWidth&&this.getSlicedName(e)},s.prototype.getFileType=function(t){var e,i=t.lastIndexOf(".");return i>=0&&(e=t.substring(i+1)),e||""},s.prototype.getFileNameOnly=function(t){var e=this.getFileType(t);return e=t.split("."+e)[0]},s.prototype.setInitialAttributes=function(){if(this.initialAttr.accept&&this.element.setAttribute("accept",this.initialAttr.accept),this.initialAttr.disabled&&this.element.setAttribute("disabled","disabled"),this.initialAttr.multiple){var t=document.createAttribute("multiple");this.element.setAttributeNode(t)}},s.prototype.filterfileList=function(t){for(var e=[],i=0;i<t.length;i++)this.getLiElement(t[i]).classList.contains(Ve)||e.push(t[i]);return e},s.prototype.updateStatus=function(t,i,s,n){if(void 0===n&&(n=!0),""===i||e.isNullOrUndefined(i)||""===s||e.isNullOrUndefined(s)||(t.status=i,t.statusCode=s),n){var a=this.getLiElement(t);e.isNullOrUndefined(a)||e.isNullOrUndefined(a.querySelector("."+Oe))||""===i||e.isNullOrUndefined(i)||(a.querySelector("."+Oe).textContent=i)}return t},s.prototype.getLiElement=function(t){for(var i,s=0;s<this.filesData.length;s++)e.isNullOrUndefined(t)||(e.isNullOrUndefined(this.filesData[s].id)||e.isNullOrUndefined(t.id)?this.filesData[s].name!==t.name:this.filesData[s].name!==t.name||this.filesData[s].id!==t.id)||(i=s);return this.fileList[i]},s.prototype.createProgressBar=function(t){var e=this.createElement("span",{className:He}),i=this.createElement("progressbar",{className:Be,attrs:{value:"0",max:"100"}}),s=this.createElement("span",{className:"e-progress-inner-wrap"});i.setAttribute("style","width: 0%");var n=this.createElement("span",{className:Ue});n.textContent="0%",s.appendChild(i),e.appendChild(s),e.appendChild(n),t.querySelector("."+Me).appendChild(e)},s.prototype.updateProgressbar=function(t,i){if(!isNaN(Math.round(t.loaded/t.total*100))&&!e.isNullOrUndefined(i.querySelector("."+Be)))if(e.isNullOrUndefined(this.progressInterval)||""===this.progressInterval)this.changeProgressValue(i,Math.round(t.loaded/t.total*100).toString()+"%");else{var s=Math.round(t.loaded/t.total*100)%parseInt(this.progressInterval,10);0!==s&&100!==s||this.changeProgressValue(i,Math.round(t.loaded/t.total*100).toString()+"%")}},s.prototype.changeProgressValue=function(t,e){t.querySelector("."+Be).setAttribute("style","width:"+e),t.querySelector("."+Ue).textContent=e},s.prototype.uploadInProgress=function(t,i,s,n){var a=this.getLiElement(i);if(!e.isNullOrUndefined(a)||s){if(e.isNullOrUndefined(a))this.cancelUploadingFile(i,t,n);else{"5"===i.statusCode&&this.cancelUploadingFile(i,t,n,a),a.querySelectorAll("."+He).length>0||!a.querySelector("."+Oe)||(a.querySelector("."+Oe).classList.add(Re),this.createProgressBar(a),this.updateProgressBarClasses(a,Re),a.querySelector("."+Oe).classList.remove(Fe)),this.updateProgressbar(t,a);var r=a.querySelector("."+Te);e.isNullOrUndefined(r)||(r.classList.add(Ae,Re),r.setAttribute("title",this.localizedTexts("abort")),r.classList.remove(Te))}var l={e:t,operation:"upload",file:this.updateStatus(i,this.localizedTexts("inProgress"),"3")};this.trigger("progress",l)}},s.prototype.cancelUploadingFile=function(t,s,n,a){var r=this;if("5"===t.statusCode){var l={event:s,fileData:t,cancel:!1,customFormData:[]};this.trigger("canceling",l,function(s){if(s.cancel){if(t.statusCode="3",!e.isNullOrUndefined(a)){var l=a.querySelector("."+Ae);e.isNullOrUndefined(l)||(i.hideSpinner(l),e.detach(a.querySelector(".e-spinner-pane")))}}else{n.emitError=!1,n.httpRequest.abort();var o=new FormData;if("5"===t.statusCode){var h=r.element.getAttribute("name");o.append(h,t.name),o.append("cancel-uploading",t.name),r.updateFormData(o,s.customFormData);var d=new e.Ajax(r.asyncSettings.removeUrl,"POST",!0,null);d.emitError=!1,d.onLoad=function(e){return r.removecanceledFile(e,t),{}},d.send(o)}}})}},s.prototype.removecanceledFile=function(t,s){var n=this.getLiElement(s);if(!n.querySelector("."+Ne)&&!e.isNullOrUndefined(n.querySelector("."+Ae))){this.updateStatus(s,this.localizedTexts("fileUploadCancel"),"5"),this.renderFailureState(t,s,n);var a=n.querySelector("."+Te);e.isNullOrUndefined(n)||(i.hideSpinner(a),e.isNullOrUndefined(n.querySelector(".e-spinner-pane"))||e.detach(n.querySelector(".e-spinner-pane")));var r={event:t,response:t&&t.currentTarget?this.getResponse(t):null,operation:"cancel",file:s};this.trigger("success",r)}},s.prototype.renderFailureState=function(t,i,s){var n=this;this.updateProgressBarClasses(s,Fe),this.removeProgressbar(s,"failure"),e.isNullOrUndefined(s.querySelector(".e-file-status"))||s.querySelector(".e-file-status").classList.add(Fe);var a=s.querySelector("."+Ae);if(!e.isNullOrUndefined(a)){a.classList.remove(Ae,Re),a.classList.add(Te),a.setAttribute("title",this.localizedTexts("remove")),this.pauseButton=this.createElement("span",{className:"e-icons e-file-reload-btn",attrs:{tabindex:this.btnTabIndex}}),a.parentElement.insertBefore(this.pauseButton,a),this.pauseButton.setAttribute("title",this.localizedTexts("retry"));s.querySelector("."+Ne).addEventListener("click",function(t){n.reloadcanceledFile(t,i,s,!1)},!1)}},s.prototype.reloadcanceledFile=function(t,i,s,n){i.statusCode="1",i.status=this.localizedTexts("readyToUploadMessage"),n||(e.isNullOrUndefined(s.querySelector("."+Oe))||s.querySelector("."+Oe).classList.remove(Fe),e.isNullOrUndefined(s.querySelector("."+Ne))||e.detach(s.querySelector("."+Ne)),this.pauseButton=null),s.classList.add(je),this.upload([i])},s.prototype.uploadComplete=function(t,i,s){var n=t.target;if(4===n.readyState&&n.status>=200&&n.status<=299){var a=this.getLiElement(i);if(e.isNullOrUndefined(a)&&(!s||e.isNullOrUndefined(s)))return;if(!e.isNullOrUndefined(a)){this.updateProgressBarClasses(a,Ve),this.removeProgressbar(a,"success");var r=a.querySelector("."+Ae);e.isNullOrUndefined(r)||(r.classList.add(Le),r.setAttribute("title",this.localizedTexts("delete")),r.classList.remove(Ae),r.classList.remove(Re))}this.raiseSuccessEvent(t,i)}else this.uploadFailed(t,i)},s.prototype.getResponse=function(t){var e=t.currentTarget;return{readyState:e.readyState,statusCode:e.status,statusText:e.statusText,headers:e.getAllResponseHeaders(),withCredentials:e.withCredentials}},s.prototype.raiseSuccessEvent=function(t,s){var n=this,a=t&&t.currentTarget?this.getResponse(t):null,r=this.localizedTexts("uploadSuccessMessage"),l={e:t,response:a,operation:"upload",file:this.updateStatus(s,r,"2",!1),statusText:r},o=this.getLiElement(s);if(!e.isNullOrUndefined(o)){var h=o.querySelector(".e-spinner-pane");e.isNullOrUndefined(h)||(i.hideSpinner(o),e.detach(h))}this.trigger("success",l,function(t){n.updateStatus(s,t.statusText,"2"),n.uploadedFilesData.push(s),n.trigger("change",{file:n.uploadedFilesData}),n.checkActionButtonStatus(),n.fileList.length>0&&(n.getLiElement(s).classList.contains(je)?n.getLiElement(s).classList.remove(je):(n.uploadSequential(),n.checkActionComplete(!0)))})},s.prototype.uploadFailed=function(t,i){var s=this,n=this.getLiElement(i),a=t&&t.currentTarget?this.getResponse(t):null,r=this.localizedTexts("uploadFailedMessage"),l={e:t,response:a,operation:"upload",file:this.updateStatus(i,r,"0",!1),statusText:r};e.isNullOrUndefined(n)||this.renderFailureState(t,i,n),this.trigger("failure",l,function(t){s.updateStatus(i,t.statusText,"0"),s.checkActionButtonStatus(),s.uploadSequential(),s.checkActionComplete(!0)})},s.prototype.uploadSequential=function(){this.sequentialUpload&&(this.autoUpload?this.checkAutoUpload(this.filesData):this.uploadButtonClick())},s.prototype.checkActionComplete=function(t){t?++this.actionCompleteCount:--this.actionCompleteCount,this.raiseActionComplete()},s.prototype.raiseActionComplete=function(){if(this.filesData.length===this.actionCompleteCount&&this.flag){this.flag=!1;var t={fileData:[]};t.fileData=this.getSelectedFileStatus(this.selectedFiles),this.trigger("actionComplete",t)}},s.prototype.getSelectedFileStatus=function(t){for(var e=[],i=0,s=0;s<t.length;s++)for(var n=t[s],a=0;a<this.filesData.length;a++)this.filesData[a].name===n.name&&(e[i]=this.filesData[a],++i);return e},s.prototype.updateProgressBarClasses=function(t,i){var s=t.querySelector("."+Be);e.isNullOrUndefined(s)||s.classList.add(i)},s.prototype.removeProgressbar=function(t,i){var s=this;e.isNullOrUndefined(t.querySelector("."+He))||(this.progressAnimation=new e.Animation({duration:1250}),this.progressAnimation.animate(t.querySelector("."+He),{name:"FadeOut"}),this.progressAnimation.animate(t.querySelector("."+Ue),{name:"FadeOut"}),setTimeout(function(){s.animateProgressBar(t,i)},750))},s.prototype.animateProgressBar=function(t,i){"success"===i?(t.classList.add(Ve),e.isNullOrUndefined(t.querySelector("."+Oe))||(t.querySelector("."+Oe).classList.remove(Re),this.progressAnimation.animate(t.querySelector("."+Oe),{name:"FadeIn"}),t.querySelector("."+Oe).classList.add(Ve))):e.isNullOrUndefined(t.querySelector("."+Oe))||(t.querySelector("."+Oe).classList.remove(Re),this.progressAnimation.animate(t.querySelector("."+Oe),{name:"FadeIn"}),t.querySelector("."+Oe).classList.add(Fe)),t.querySelector("."+He)&&e.detach(t.querySelector("."+He))},s.prototype.setExtensions=function(t){""===t||e.isNullOrUndefined(t)?this.element.removeAttribute("accept"):this.element.setAttribute("accept",t)},s.prototype.templateComplier=function(t){if(t)try{if(e.selectAll(t,document).length)return e.compile(e.select(t,document).innerHTML.trim())}catch(i){return e.compile(t)}},s.prototype.setRTL=function(){this.enableRtl?e.addClass([this.uploadWrapper],"e-rtl"):e.removeClass([this.uploadWrapper],"e-rtl")},s.prototype.localizedTexts=function(t){return this.l10n.setLocale(this.locale),this.l10n.getConstant(t)},s.prototype.setControlStatus=function(){this.enabled?(this.uploadWrapper.classList.contains(De)&&this.uploadWrapper.classList.remove(De),!e.isNullOrUndefined(this.browseButton)&&this.element.hasAttribute("disabled")&&(this.element.removeAttribute("disabled"),this.browseButton.removeAttribute("disabled")),!e.isNullOrUndefined(this.clearButton)&&this.clearButton.hasAttribute("disabled")&&this.clearButton.removeAttribute("disabled"),!e.isNullOrUndefined(this.uploadButton)&&this.uploadButton.hasAttribute("disabled")&&this.uploadButton.hasAttribute("disabled")):(this.uploadWrapper.classList.add(De),this.element.setAttribute("disabled","disabled"),this.browseButton.setAttribute("disabled","disabled"),e.isNullOrUndefined(this.clearButton)||this.clearButton.setAttribute("disabled","disabled"),e.isNullOrUndefined(this.uploadButton)||this.uploadButton.setAttribute("disabled","disabled"))},s.prototype.checkHTMLAttributes=function(t){for(var i=0,s=t?e.isNullOrUndefined(this.htmlAttributes)?[]:Object.keys(this.htmlAttributes):["accept","multiple","disabled"];i<s.length;i++){var n=s[i];if(!e.isNullOrUndefined(this.element.getAttribute(n)))switch(n){case"accept":(e.isNullOrUndefined(this.uploaderOptions)||void 0===this.uploaderOptions.allowedExtensions||t)&&(this.setProperties({allowedExtensions:this.element.getAttribute("accept")},!t),this.initialAttr.accept=this.allowedExtensions);break;case"multiple":if(e.isNullOrUndefined(this.uploaderOptions)||void 0===this.uploaderOptions.multiple||t){var a="multiple"===this.element.getAttribute(n)||""===this.element.getAttribute(n)||"true"===this.element.getAttribute(n);this.setProperties({multiple:a},!t),this.initialAttr.multiple=!0}break;case"disabled":if(e.isNullOrUndefined(this.uploaderOptions)||void 0===this.uploaderOptions.enabled||t){var r="disabled"!==this.element.getAttribute(n)&&""!==this.element.getAttribute(n)&&"true"!==this.element.getAttribute(n);this.setProperties({enabled:r},!t),this.initialAttr.disabled=!0}}}},s.prototype.chunkUpload=function(t,e,i){var s=Math.min(this.asyncSettings.chunkSize,t.size),n={chunkIndex:0,blob:t.rawFile.slice(0,s),file:t,start:0,end:s,retryCount:0,request:null};this.sendRequest(t,n,e,i)},s.prototype.sendRequest=function(t,i,s,n){var a=this,r=new FormData,l=t.rawFile.slice(i.start,i.end);r.append("chunkFile",l,t.name),r.append(this.uploaderName,l,t.name),r.append("chunk-index",i.chunkIndex.toString()),r.append("chunkIndex",i.chunkIndex.toString());var o=Math.max(Math.ceil(t.size/this.asyncSettings.chunkSize),1);r.append("total-chunk",o.toString()),r.append("totalChunk",o.toString());var h=new e.Ajax({url:this.asyncSettings.saveUrl,type:"POST",async:!0,contentType:null});h.emitError=!1,h.onLoad=function(t){return a.chunkUploadComplete(t,i,s),{}},h.onUploadProgress=function(t){return a.chunkUploadInProgress(t,i,s),{}};var d={fileData:t,customFormData:[],cancel:!1,chunkSize:0===this.asyncSettings.chunkSize?null:this.asyncSettings.chunkSize};h.beforeSend=function(e){d.currentRequest=h.httpRequest,d.currentChunkIndex=i.chunkIndex,0===d.currentChunkIndex?a.trigger("uploading",d,function(i){a.uploadingEventCallback(r,i,e,t)}):a.trigger("chunkUploading",d,function(i){a.uploadingEventCallback(r,i,e,t)})},h.onError=function(t){return a.chunkUploadFailed(t,i,s),{}},h.send(r),i.request=h},s.prototype.uploadingEventCallback=function(t,e,i,s){e.cancel?this.eventCancelByArgs(i,e,s):this.updateFormData(t,e.customFormData)},s.prototype.eventCancelByArgs=function(t,i,s){var n=this;if(t.cancel=!0,"5"!==i.fileData.statusCode){i.fileData.statusCode="5",i.fileData.status=this.localizedTexts("fileUploadCancel");var a=this.getLiElement(i.fileData);if(a){e.isNullOrUndefined(a.querySelector("."+Oe))||(a.querySelector("."+Oe).innerHTML=this.localizedTexts("fileUploadCancel"),a.querySelector("."+Oe).classList.add(Fe)),this.pauseButton=this.createElement("span",{className:"e-icons e-file-reload-btn",attrs:{tabindex:this.btnTabIndex}});var r=a.querySelector("."+Te);r&&r.parentElement.insertBefore(this.pauseButton,r),this.pauseButton.setAttribute("title",this.localizedTexts("retry")),this.pauseButton.addEventListener("click",function(t){n.reloadcanceledFile(t,s,a)},!1),this.checkActionButtonStatus()}}},s.prototype.checkChunkUpload=function(){return!(this.asyncSettings.chunkSize<=0||e.isNullOrUndefined(this.asyncSettings.chunkSize))},s.prototype.chunkUploadComplete=function(t,s,n){var a,r=this,l=t.target;if(4===l.readyState&&l.status>=200&&l.status<300){var o=t&&t.currentTarget?this.getResponse(t):null,h=Math.max(Math.ceil(s.file.size/this.asyncSettings.chunkSize),1),d={event:t,file:s.file,chunkIndex:s.chunkIndex,totalChunk:h,chunkSize:this.asyncSettings.chunkSize,response:o};if(this.trigger("chunkSuccess",d),!e.isNullOrUndefined(n)&&n||(a=this.getLiElement(s.file)),this.updateMetaData(s),s.end===s.file.size&&(s.file.statusCode="3"),"5"===s.file.statusCode){var c={event:t,fileData:s.file,cancel:!1,customFormData:[]};this.trigger("canceling",c,function(t){if(t.cancel){s.file.statusCode="3";var o=a.querySelector("."+Ae);e.isNullOrUndefined(a)||e.isNullOrUndefined(o)||(i.hideSpinner(o),e.detach(a.querySelector(".e-spinner-pane"))),r.sendNextRequest(s)}else{s.request.emitError=!1,l.abort();var h=new FormData,d=r.element.getAttribute("name");h.append(d,s.file.name),h.append("cancel-uploading",s.file.name),h.append("cancelUploading",s.file.name),r.updateFormData(h,t.customFormData);var c=new e.Ajax(r.asyncSettings.removeUrl,"POST",!0,null);c.emitError=!1,c.onLoad=function(t){return r.removeChunkFile(t,s,n),{}},c.send(h)}})}else{if(h-1===s.chunkIndex&&h>s.chunkIndex){var u=this.pausedData.indexOf(s);return u>=0&&this.pausedData.splice(u,1),e.isNullOrUndefined(this.template)&&(e.isNullOrUndefined(n)||!n)&&a&&(a&&!e.isNullOrUndefined(a.querySelector("."+qe))&&e.detach(a.querySelector("."+qe)),this.removeChunkProgressBar(s)),void this.raiseSuccessEvent(t,s.file)}"4"!==s.file.statusCode&&this.sendNextRequest(s)}}else this.chunkUploadFailed(t,s)},s.prototype.sendNextRequest=function(t){t.start=t.end,t.end+=this.asyncSettings.chunkSize,t.end=Math.min(t.end,t.file.size),t.chunkIndex+=1,this.sendRequest(t.file,t)},s.prototype.removeChunkFile=function(t,s,n){if(e.isNullOrUndefined(this.template)&&e.isNullOrUndefined(n)&&!n){var a=this.getLiElement(s.file),r=a.querySelector("."+Ae),l=r;this.updateStatus(s.file,this.localizedTexts("fileUploadCancel"),"5"),this.updateProgressBarClasses(a,Fe),this.removeProgressbar(a,"failure"),r&&r.classList.remove(Ae),r&&r.classList.add(Te),r&&r.setAttribute("title",this.localizedTexts("remove"));var o=a.querySelector("."+qe);o&&o.classList.add(Ne),o&&o.classList.remove(qe),o&&o.setAttribute("title",this.localizedTexts("retry")),e.isNullOrUndefined(a)||e.isNullOrUndefined(r)||e.isNullOrUndefined(a.querySelector(".e-spinner-pane"))||(i.hideSpinner(l),e.detach(a.querySelector(".e-spinner-pane")))}},s.prototype.pauseUpload=function(t,e,i){t.file.statusCode="4",t.file.status=this.localizedTexts("pause"),this.updateMetaData(t);var s={event:e||null,file:t.file,chunkIndex:t.chunkIndex,chunkCount:Math.round(t.file.size/this.asyncSettings.chunkSize),chunkSize:this.asyncSettings.chunkSize};this.abortUpload(t,i,s)},s.prototype.abortUpload=function(t,i,s){"4"!==t.file.statusCode&&(t.request.emitError=!1,t.request.httpRequest.abort());var n=this.getLiElement(t.file);if(e.isNullOrUndefined(this.template)&&(e.isNullOrUndefined(i)||!i)){var a=n.querySelector("."+qe);a.classList.remove(qe),a.classList.add(We),a.setAttribute("title",this.localizedTexts("resume")),a.nextElementSibling.classList.add(Te),a.nextElementSibling.classList.remove(Ae),a.nextElementSibling.setAttribute("title",this.localizedTexts("remove"))}for(var r=0;r<this.pausedData.length;r++)this.pausedData[r].file.name===t.file.name&&this.pausedData.splice(r,1);this.pausedData.push(t),this.trigger("pausing",s)},s.prototype.resumeUpload=function(t,i,s){var n,a=this.getLiElement(t.file);e.isNullOrUndefined(a)||(n=a.querySelector("."+We)),e.isNullOrUndefined(n)||!e.isNullOrUndefined(s)&&s||(n.classList.remove(We),n.classList.add(qe),n.setAttribute("title",this.localizedTexts("pause")),n.nextElementSibling.classList.remove(Te),n.nextElementSibling.classList.add(Ae),n.nextElementSibling.setAttribute("title",this.localizedTexts("abort"))),t.file.status=this.localizedTexts("inProgress"),t.file.statusCode="3",this.updateMetaData(t);var r={event:i||null,file:t.file,chunkIndex:t.chunkIndex,chunkCount:Math.round(t.file.size/this.asyncSettings.chunkSize),chunkSize:this.asyncSettings.chunkSize};this.trigger("resuming",r);for(var l=0;l<this.pausedData.length;l++)this.pausedData[l].end===this.pausedData[l].file.size?this.chunkUploadComplete(i,t,s):this.pausedData[l].file.name===t.file.name&&(this.pausedData[l].start=this.pausedData[l].end,this.pausedData[l].end=this.pausedData[l].end+this.asyncSettings.chunkSize,this.pausedData[l].end=Math.min(this.pausedData[l].end,this.pausedData[l].file.size),this.pausedData[l].chunkIndex=this.pausedData[l].chunkIndex+1,this.sendRequest(this.pausedData[l].file,this.pausedData[l],s))},s.prototype.updateMetaData=function(t){-1===this.uploadMetaData.indexOf(t)?this.uploadMetaData.push(t):(this.uploadMetaData.splice(this.uploadMetaData.indexOf(t),1),this.uploadMetaData.push(t))},s.prototype.removeChunkProgressBar=function(t){var i=this.getLiElement(t.file);if(!e.isNullOrUndefined(i)){this.updateProgressBarClasses(i,Ve),this.removeProgressbar(i,"success");var s=i.querySelector("."+Ae);e.isNullOrUndefined(s)||(s.classList.add(Le),s.setAttribute("title",this.localizedTexts("delete")),s.classList.remove(Ae,Re))}},s.prototype.chunkUploadFailed=function(t,i,s){var n,a=this,r=Math.max(Math.ceil(i.file.size/this.asyncSettings.chunkSize),1);!e.isNullOrUndefined(this.template)||!e.isNullOrUndefined(s)&&s||(n=this.getLiElement(i.file));var l=t&&t.currentTarget?this.getResponse(t):null,o={event:t,file:i.file,chunkIndex:i.chunkIndex,totalChunk:r,chunkSize:this.asyncSettings.chunkSize,cancel:!1,response:l};this.trigger("chunkFailure",o,function(r){if(!r.cancel)if(i.retryCount<a.asyncSettings.retryCount)setTimeout(function(){a.retryRequest(n,i,s)},a.asyncSettings.retryAfterDelay);else{if(!e.isNullOrUndefined(n)){var o=n.querySelector("."+qe)?n.querySelector("."+qe):n.querySelector("."+We);e.isNullOrUndefined(o)||(o.classList.add(Ne),o.classList.remove(qe,We)),a.updateProgressBarClasses(n,Fe),a.removeProgressbar(n,"failure"),n.querySelector(".e-icons").classList.remove(Re);var h=n.querySelector("."+Ae)?n.querySelector("."+Ae):n.querySelector("."+Te);h.classList.remove(Ae),e.isNullOrUndefined(n.querySelector("."+qe))||e.detach(n.querySelector("."+qe)),i.start>0?(h.classList.add(Le),h.setAttribute("title",a.localizedTexts("delete"))):(h.classList.add(Te),h.setAttribute("title",a.localizedTexts("remove")))}i.retryCount=0;var d=i.file,c=a.localizedTexts("uploadFailedMessage"),u={e:t,response:l,operation:"upload",file:a.updateStatus(d,c,"0",!1),statusText:c};a.trigger("failure",u,function(t){a.updateStatus(d,t.statusText,"0"),a.uploadSequential(),a.checkActionComplete(!0)})}})},s.prototype.retryRequest=function(t,i,s){e.isNullOrUndefined(this.template)&&(e.isNullOrUndefined(s)||!s)&&t&&this.updateProgressBarClasses(t,Fe),i.retryCount+=1,this.sendRequest(i.file,i)},s.prototype.checkPausePlayAction=function(t){var e=t.target,i=t.target.parentElement,s=this.fileList.indexOf(i),n=this.filesData[s],a=this.getCurrentMetaData(n);e.classList.contains(qe)?this.pauseUpload(a,t):e.classList.contains(We)?this.resumeUpload(a,t):e.classList.contains(Ne)&&(a.file.status===this.localizedTexts("fileUploadCancel")?this.retryUpload(a,!1):this.retryUpload(a,!0))},s.prototype.retryUpload=function(t,e){e?(t.end=t.end+this.asyncSettings.chunkSize,t.start=t.start+this.asyncSettings.chunkSize,this.sendRequest(t.file,t)):(t.file.statusCode="1",t.file.status=this.localizedTexts("readyToUploadMessage"),this.chunkUpload(t.file)),this.getLiElement(t.file).classList.add(je)},s.prototype.chunkUploadInProgress=function(t,i,s){var n=this;if("4"!==i.file.statusCode){"4"!==i.file.statusCode&&"5"!==i.file.statusCode&&(i.file.statusCode="3",i.file.status=this.localizedTexts("inProgress")),this.updateMetaData(i);var a=this.getLiElement(i.file);if(!e.isNullOrUndefined(a)){var r=a.querySelector("."+Ne);if(e.isNullOrUndefined(r)||(r.classList.add(qe),r.setAttribute("title",this.localizedTexts("pause")),r.classList.remove(Ne)),!e.isNullOrUndefined(a)){if(!(a.querySelectorAll("."+He).length>0)){var l=a.querySelector("."+Oe);e.isNullOrUndefined(this.template)&&(l.classList.add(Re),l.classList.remove(Fe),this.createProgressBar(a),this.updateProgressBarClasses(a,Re));var o=a.querySelector("."+Te)?a.querySelector("."+Te):a.querySelector("."+Le);e.isNullOrUndefined(o)||(o.classList.add(Ae),o.setAttribute("title",this.localizedTexts("abort")),o.classList.remove(Te))}if(!isNaN(Math.round(t.loaded/t.total*100))&&e.isNullOrUndefined(this.template)&&"4"!==i.file.statusCode){var h=void 0,d=Math.ceil(i.file.size/this.asyncSettings.chunkSize)-1;this.asyncSettings.chunkSize&&d&&(h=Math.round(i.chunkIndex/d*100),this.changeProgressValue(a,h.toString()+"%"))}0===i.chunkIndex&&this.checkActionButtonStatus()}if(e.isNullOrUndefined(a.querySelector("."+qe))&&e.isNullOrUndefined(this.template)&&e.isNullOrUndefined(a.querySelector("."+Le))){this.pauseButton=this.createElement("span",{className:"e-icons e-file-pause-btn",attrs:{tabindex:this.btnTabIndex}}),"msie"===this.browserName&&this.pauseButton.classList.add("e-msie");var c=a.querySelector("."+Ae);c.parentElement.insertBefore(this.pauseButton,c),this.pauseButton.setAttribute("title",this.localizedTexts("pause")),this.pauseButton.addEventListener("click",function(t){n.checkPausePlayAction(t)},!1)}}}},s.prototype.bytesToSize=function(t){var e=-1;if(!t)return"0.0 KB";do{t/=1024,e++}while(t>99);return e>=2&&(t*=1024,e=1),Math.max(t,0).toFixed(1)+" "+["KB","MB"][e]},s.prototype.sortFileList=function(t){for(var e=t=t||this.sortFilesList,i=[],s=0;s<e.length;s++)i.push(e[s].name);for(var n=[],a=0,r=i.sort();a<r.length;a++){var l=r[a];for(s=0;s<e.length;s++)l===e[s].name&&n.push(e[s])}return n},s.prototype.destroy=function(){this.element.value=null,this.clearTemplate(),this.clearAll(),this.unWireEvents(),this.unBindDropEvents(),this.multiple&&this.element.removeAttribute("multiple"),this.enabled||this.element.removeAttribute("disabled"),this.element.removeAttribute("accept"),this.setInitialAttributes();for(var i=0,s=["aria-label","directory","webkitdirectory","tabindex"];i<s.length;i++){var n=s[i];this.element.removeAttribute(n)}e.isNullOrUndefined(this.uploadWrapper)||(this.uploadWrapper.parentElement.appendChild(this.element),e.detach(this.uploadWrapper)),this.uploadWrapper=null,t.prototype.destroy.call(this)},s.prototype.upload=function(t,e){var i=this;if(t=t||this.filesData,this.sequentialUpload&&(this.isFirstFileOnSelection||e))this.sequenceUpload(t);else{var s=this.getFilesInArray(t);this.trigger("beforeUpload",{customFormData:[],currentRequest:null,cancel:!1},function(t){t.cancel||i.uploadFiles(s,e)})}},s.prototype.getFilesInArray=function(t){var e=[];return t instanceof Array?e=t:e.push(t),e},s.prototype.serverReadFileBase64=function(t,e,i){var s=this;return new Promise(function(n,a){var r=s.fileStreams[t].rawFile;try{var l=new FileReader;l.onload=function(t){return function(){try{var e=t.result,i=e?e.split(";base64,")[1]:null;n(i)}catch(t){a(t)}}}(l),l.readAsDataURL(r.slice(e,e+i))}catch(t){a(t)}})},s.prototype.uploadFileCount=function(t){var e=this.filesData;if(!e||0===e.length)return-1;return e.length},s.prototype.getFileRead=function(t,e){var i=this.filesData;if(!i||0===i.length)return-1;var s=i[t],n=this.newFileRef++;return this.fileStreams[n]=s,n},s.prototype.getFileInfo=function(t,e){var i=this.filesData;if(!i||0===i.length)return null;return i[t]?this.filesData[t]:null},s.prototype.uploadFiles=function(t,i){var s=[];if(""!==this.asyncSettings.saveUrl&&!e.isNullOrUndefined(this.asyncSettings.saveUrl)){if(!i||e.isNullOrUndefined(i))if(this.multiple)s=this.filterfileList(t);else{var n=[];n.push(t[0]),s=this.filterfileList(n)}else s=t;for(var a=0;a<s.length;a++)this.uploadFilesRequest(s,a,i)}},s.prototype.uploadFilesRequest=function(t,i,s){var n=this,a=this.checkChunkUpload(),r=new e.Ajax(this.asyncSettings.saveUrl,"POST",!0,null);r.emitError=!1;var l={fileData:t[i],customFormData:[],cancel:!1},o=new FormData;if(r.beforeSend=function(e){l.currentRequest=r.httpRequest,n.trigger("uploading",l,function(s){s.cancel&&n.eventCancelByArgs(e,s,t[i]),n.updateFormData(o,s.customFormData)})},"1"===t[i].statusCode){var h=this.element.getAttribute("name");o.append(h,t[i].rawFile,t[i].name),a&&t[i].size>this.asyncSettings.chunkSize?this.chunkUpload(t[i],s,i):(r.onLoad=function(e){return l.cancel?{}:(n.uploadComplete(e,t[i],s),{})},r.onUploadProgress=function(e){return l.cancel?{}:(n.uploadInProgress(e,t[i],s,r),{})},r.onError=function(e){return n.uploadFailed(e,t[i]),{}},r.send(o))}},s.prototype.spliceFiles=function(t){for(var e=this.fileList[t],i=this.getFilesData(),s=+e.getAttribute("data-files-count"),n=0,a=0;a<t;a++)n+=+this.fileList[a].getAttribute("data-files-count");for(var r=n+s-1;r>=n;r--)i.splice(r,1)},s.prototype.remove=function(t,i,s,n,a){var r=this;e.isNullOrUndefined(n)&&(n=!0);var l={event:a,cancel:!1,filesData:[],customFormData:[],postRawFile:n,currentRequest:null};this.trigger("beforeRemove",{cancel:!1,customFormData:[],currentRequest:null},function(n){if(!n.cancel)if(r.isFormUpload())l.filesData=t,r.trigger("removing",l,function(i){if(!i.cancel)for(var s=!1,n=void 0,a=0,l=r.getFilesInArray(t);a<l.length;a++){var o=l[a];if(s||(n=r.fileList.indexOf(o.list)),n>-1){var h=e.isNullOrUndefined(o.input)?null:o.input;h&&e.detach(h),r.spliceFiles(n),e.detach(r.fileList[n]),r.fileList.splice(n,1),s=!0,n=-1}}});else if(r.isForm&&(e.isNullOrUndefined(r.asyncSettings.removeUrl)||""===r.asyncSettings.removeUrl))l.filesData=r.getFilesData(),r.trigger("removing",l,function(t){t.cancel||r.clearAll()});else{var o=[];(t=e.isNullOrUndefined(t)?r.filesData:t)instanceof Array?o=t:o.push(t),l.filesData=o;for(var h=r.asyncSettings.removeUrl,d=""!==h&&!e.isNullOrUndefined(h),c=function(t){var e=r.uploadedFilesData.indexOf(t);("2"===t.statusCode||"4"===t.statusCode||"0"===t.statusCode&&-1!==e)&&d?r.removeUploadedFile(t,l,s,i):s?r.removeFilesData(t,i):r.trigger("removing",l,function(e){e.cancel||r.removeFilesData(t,i)}),a&&!a.target.classList.contains(Te)&&r.checkActionComplete(!1)},u=0,p=o;u<p.length;u++){c(p[u])}}})},s.prototype.clearAll=function(){var t=this;if(e.isNullOrUndefined(this.listParent))return"msie"!==this.browserName&&(this.element.value=""),void(this.filesData=[]);var i={cancel:!1,filesData:this.filesData};this.trigger("clearing",i,function(e){e.cancel||(t.clearData(),t.actionCompleteCount=0,t.count=-1)})},s.prototype.getFilesData=function(t){return e.isNullOrUndefined(t)?this.filesData:this.getSelectedFiles(t)},s.prototype.pause=function(t,e){t=t||this.filesData;var i=this.getFilesInArray(t);this.pauseUploading(i,e)},s.prototype.pauseUploading=function(t,e){for(var i=this.getFiles(t),s=0;s<i.length;s++)"3"===i[s].statusCode&&this.pauseUpload(this.getCurrentMetaData(i[s],null),null,e)},s.prototype.getFiles=function(t){var i=[];return e.isNullOrUndefined(t)||t instanceof Array?i=t:i.push(t),i},s.prototype.resume=function(t,e){t=t||this.filesData;var i=this.getFilesInArray(t);this.resumeFiles(i,e)},s.prototype.resumeFiles=function(t,e){for(var i=this.getFiles(t),s=0;s<i.length;s++)"4"===i[s].statusCode&&this.resumeUpload(this.getCurrentMetaData(i[s],null),null,e)},s.prototype.retry=function(t,e,i){t=t||this.filesData;var s=this.getFilesInArray(t);this.sequentialUpload&&this.isFirstFileOnSelection&&(this.isFirstFileOnSelection=!1),this.retryFailedFiles(s,e,i)},s.prototype.retryFailedFiles=function(t,e,i){for(var s=this.getFiles(t),n=0;n<s.length;n++)if("5"===s[n].statusCode||"0"===s[n].statusCode)if(this.asyncSettings.chunkSize>0)this.retryUpload(this.getCurrentMetaData(s[n],null),e);else{var a=void 0;i||(a=this.fileList[this.filesData.indexOf(s[n])]),this.reloadcanceledFile(null,s[n],a,i)}},s.prototype.cancel=function(t){t=t||this.filesData;var e=this.getFilesInArray(t);this.cancelUpload(e)},s.prototype.cancelUpload=function(t){var e=this.getFiles(t);if(this.asyncSettings.chunkSize>0){for(var i=0;i<e.length;i++)if("3"===e[i].statusCode){var s=this.getCurrentMetaData(e[i],null);s.file.statusCode="5",s.file.status=this.localizedTexts("fileUploadCancel"),this.updateMetaData(s),this.showHideUploadSpinner(e[i])}}else for(i=0;i<e.length;i++)"3"===e[i].statusCode&&(e[i].statusCode="5",e[i].status=this.localizedTexts("fileUploadCancel"),this.showHideUploadSpinner(e[i]))},s.prototype.showHideUploadSpinner=function(t){var s=this.getLiElement(t);if(!e.isNullOrUndefined(s)&&e.isNullOrUndefined(this.template)){var n=s.querySelector("."+Ae);i.createSpinner({target:n,width:"20px"}),i.showSpinner(n)}},Se([e.Complex({saveUrl:"",removeUrl:""},Ye)],s.prototype,"asyncSettings",void 0),Se([e.Property(!1)],s.prototype,"sequentialUpload",void 0),Se([e.Property({})],s.prototype,"htmlAttributes",void 0),Se([e.Property("")],s.prototype,"cssClass",void 0),Se([e.Property(!0)],s.prototype,"enabled",void 0),Se([e.Property(null)],s.prototype,"template",void 0),Se([e.Property(!0)],s.prototype,"multiple",void 0),Se([e.Property(!0)],s.prototype,"autoUpload",void 0),Se([e.Complex({},Ze)],s.prototype,"buttons",void 0),Se([e.Property("")],s.prototype,"allowedExtensions",void 0),Se([e.Property(0)],s.prototype,"minFileSize",void 0),Se([e.Property(3e7)],s.prototype,"maxFileSize",void 0),Se([e.Property(null)],s.prototype,"dropArea",void 0),Se([e.Collection([{}],Ke)],s.prototype,"files",void 0),Se([e.Property(!0)],s.prototype,"showFileList",void 0),Se([e.Property(!1)],s.prototype,"directoryUpload",void 0),Se([e.Property("Default")],s.prototype,"dropEffect",void 0),Se([e.Event()],s.prototype,"created",void 0),Se([e.Event()],s.prototype,"actionComplete",void 0),Se([e.Event()],s.prototype,"rendering",void 0),Se([e.Event()],s.prototype,"beforeUpload",void 0),Se([e.Event()],s.prototype,"fileListRendering",void 0),Se([e.Event()],s.prototype,"selected",void 0),Se([e.Event()],s.prototype,"uploading",void 0),Se([e.Event()],s.prototype,"success",void 0),Se([e.Event()],s.prototype,"failure",void 0),Se([e.Event()],s.prototype,"removing",void 0),Se([e.Event()],s.prototype,"beforeRemove",void 0),Se([e.Event()],s.prototype,"clearing",void 0),Se([e.Event()],s.prototype,"progress",void 0),Se([e.Event()],s.prototype,"change",void 0),Se([e.Event()],s.prototype,"chunkSuccess",void 0),Se([e.Event()],s.prototype,"chunkFailure",void 0),Se([e.Event()],s.prototype,"chunkUploading",void 0),Se([e.Event()],s.prototype,"canceling",void 0),Se([e.Event()],s.prototype,"pausing",void 0),Se([e.Event()],s.prototype,"resuming",void 0),s=Se([e.NotifyPropertyChanges],s)}(e.Component),Je=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function s(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),$e=function(t,e,i,s){var n,a=arguments.length,r=a<3?e:null===s?s=Object.getOwnPropertyDescriptor(e,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(t,e,i,s);else for(var l=t.length-1;l>=0;l--)(n=t[l])&&(r=(a<3?n(r):a>3?n(e,i,r):n(e,i))||r);return a>3&&r&&Object.defineProperty(e,i,r),r},Qe="e-ctrl-btn",ti="e-switch-ctrl-btn",ei="e-value-switch-btn",ii="e-hide-hex-value",si="e-hide-opacity",ni="e-hide-switchable-value",ai="e-hide-value",ri="e-hide-valueswitcher",li="e-hsv-color",oi="e-selected-value",hi="e-mode-switch-btn",di="e-nocolor-item",ci="e-opacity-value",ui="e-palette",pi="e-color-palette",mi="e-color-picker",vi="e-preview-container",fi="e-previous",gi="e-show-value",yi="e-selected",bi="e-split-preview",Ci=["#000000","#f44336","#e91e63","#9c27b0","#673ab7","#2196f3","#03a9f4","#00bcd4","#009688","#ffeb3b","#ffffff","#ffebee","#fce4ec","#f3e5f5","#ede7f6","#e3f2fd","#e1f5fe","#e0f7fa","#e0f2f1","#fffde7","#f2f2f2","#ffcdd2","#f8bbd0","#e1bee7","#d1c4e9","#bbdefb","#b3e5fc","#b2ebf2","#b2dfdb","#fff9c4","#e6e6e6","#ef9a9a","#f48fb1","#ce93d8","#b39ddb","#90caf9","#81d4fa","#80deea","#80cbc4","#fff59d","#cccccc","#e57373","#f06292","#ba68c8","#9575cd","#64b5f6","#4fc3f7","#4dd0e1","#4db6ac","#fff176","#b3b3b3","#ef5350","#ec407a","#ab47bc","#7e57c2","#42a5f5","#29b6f6","#26c6da","#26a69a","#ffee58","#999999","#e53935","#d81b60","#8e24aa","#5e35b1","#1e88e5","#039be5","#00acc1","#00897b","#fdd835","#808080","#d32f2f","#c2185b","#7b1fa2","#512da8","#1976d2","#0288d1","#0097a7","#00796b","#fbc02d","#666666","#c62828","#ad1457","#6a1b9a","#4527a0","#1565c0","#0277bd","#00838f","#00695c","#f9a825","#4d4d4d","#b71c1c","#880e4f","#4a148c","#311b92","#0d47a1","#01579b","#006064","#004d40","#f57f17"],Ei=function(n){function a(t,e){return n.call(this,t,e)||this}return Je(a,n),a.prototype.preRender=function(){var t=this.element;this.formElement=e.closest(this.element,"form"),this.formElement&&e.EventHandler.add(this.formElement,"reset",this.formResetHandler,this);this.l10n=new e.L10n("colorpicker",{Apply:"Apply",Cancel:"Cancel",ModeSwitcher:"Switch Mode"},this.locale),t.getAttribute("ejs-for")&&!t.getAttribute("name")&&t.setAttribute("name",t.id)},a.prototype.render=function(){this.initWrapper(),this.inline?this.createWidget():this.createSplitBtn(),this.enableOpacity||e.addClass([this.container.parentElement],si),this.renderComplete()},a.prototype.initWrapper=function(){var t=this.createElement("div",{className:"e-"+this.getModuleName()+"-wrapper"});this.element.parentNode.insertBefore(t,this.element),t.appendChild(this.element),e.attributes(this.element,{tabindex:"-1",spellcheck:"false"}),this.container=this.createElement("div",{className:"e-container"}),this.getWrapper().appendChild(this.container);var i=this.value?this.roundValue(this.value).toLowerCase():"#008000ff";this.noColor&&"Palette"===this.mode&&""===this.value&&(i="");var s=i.slice(0,7);e.isNullOrUndefined(this.initialInputValue)&&(this.initialInputValue=s),this.element.value=s,this.enableOpacity?this.setProperties({value:i},!0):this.setProperties({value:s},!0),this.enableRtl&&t.classList.add("e-rtl"),this.cssClass&&e.addClass([t],this.cssClass.split(" ")),this.tileRipple=e.rippleEffect(this.container,{selector:".e-tile"}),this.ctrlBtnRipple=e.rippleEffect(this.container,{selector:".e-btn"})},a.prototype.getWrapper=function(){return this.element.parentElement},a.prototype.createWidget=function(){"Palette"===this.mode?(this.createPalette(),this.inline||this.firstPaletteFocus()):(this.createPicker(),this.inline||this.getDragHandler().focus()),this.isRgb=!0,this.createInput(),this.createCtrlBtn(),this.disabled||this.wireEvents(),this.inline&&this.disabled&&this.toggleDisabled(!0),e.Browser.isDevice&&this.refreshPopupPos()},a.prototype.createSplitBtn=function(){var t=this,n=this.createElement("button",{className:"e-split-colorpicker"});this.getWrapper().appendChild(n),this.splitBtn=new s.SplitButton({iconCss:"e-selected-color",target:this.container,disabled:this.disabled,enableRtl:this.enableRtl,createPopupOnClick:this.createPopupOnClick,open:this.onOpen.bind(this),click:function(){t.trigger("change",{currentValue:{hex:t.value.slice(0,7),rgba:t.convertToRgbString(t.hexToRgb(t.value))},previousValue:{hex:null,rgba:null},value:t.value})}}),this.splitBtn.createElement=this.createElement,this.splitBtn.appendTo(n);var a=this.createElement("span",{className:bi});e.select(".e-selected-color",n).appendChild(a),a.style.backgroundColor=this.convertToRgbString(this.hexToRgb(this.value));var r=this.getPopupEle();if(e.addClass([r],"e-colorpicker-popup"),this.cssClass&&e.addClass([r],this.cssClass.split(" ")),e.Browser.isDevice){var l=this.getPopupInst();l.relateTo=document.body,l.position={X:"center",Y:"center"},l.targetType="container",l.collision={X:"fit",Y:"fit"},l.offsetY=4,r.style.zIndex=i.getZindexPartial(this.splitBtn.element).toString()}this.bindCallBackEvent()},a.prototype.onOpen=function(){this.trigger("open",{element:this.container})},a.prototype.getPopupInst=function(){return e.getInstance(this.getPopupEle(),i.Popup)},a.prototype.bindCallBackEvent=function(){var t=this;this.splitBtn.beforeOpen=function(i){var n=new s.Deferred;return t.trigger("beforeOpen",i,function(s){if(!s.cancel){var a=t.getPopupEle();a.style.top=e.formatUnit(0+pageYOffset),a.style.left=e.formatUnit(0+pageXOffset),a.style.display="block",t.createWidget(),a.style.display="",e.Browser.isDevice&&(t.modal=t.createElement("div"),t.modal.className="e-"+t.getModuleName()+" e-modal",t.modal.style.display="none",document.body.insertBefore(t.modal,a),document.body.className+=" e-colorpicker-overflow",t.modal.style.display="block",t.modal.style.zIndex=(Number(a.style.zIndex)-1).toString())}i.cancel=s.cancel,n.resolve(s)}),n},this.splitBtn.beforeClose=function(i){var n=new s.Deferred;if(e.isNullOrUndefined(i.event))n.resolve(i);else{var a={element:t.container,event:i.event,cancel:!1};t.trigger("beforeClose",a,function(s){e.Browser.isDevice&&i.event.target===t.modal&&(s.cancel=!0),s.cancel||t.onPopupClose(),i.cancel=s.cancel,n.resolve(s)})}return n}},a.prototype.onPopupClose=function(){this.unWireEvents(),this.destroyOtherComp(),this.container.style.width="",e.select("."+bi,this.splitBtn.element).style.backgroundColor=this.convertToRgbString(this.hexToRgb(this.value)),this.container.innerHTML="",e.removeClass([this.container],[mi,pi]),e.Browser.isDevice&&this.modal&&(e.removeClass([document.body],"e-colorpicker-overflow"),this.modal.style.display="none",this.modal.outerHTML="",this.modal=null)},a.prototype.createPalette=function(){if(e.classList(this.container,[pi],[mi]),this.presetColors){var t=this.createElement("div",{className:"e-custom-palette"});this.appendElement(t);var i=Object.keys(this.presetColors);if(1===i.length)this.appendPalette(this.presetColors[i[0]],i[0],t);else for(var s=0,n=i.length;s<n;s++)this.appendPalette(this.presetColors[i[s]],i[s],t);e.selectAll(".e-row",t).length>10&&e.addClass([t],"e-palette-group")}else this.appendPalette(Ci,"default");"Palette"===this.mode&&!this.modeSwitcher&&this.noColor&&this.setNoColor();var a=parseInt(getComputedStyle(this.container).borderBottomWidth,10);this.container.style.width=e.formatUnit(this.container.children[0].offsetWidth+a+a),this.rgb=this.hexToRgb(this.roundValue(this.value)),this.hsv=this.rgbToHsv.apply(this,this.rgb)},a.prototype.firstPaletteFocus=function(){e.select("."+yi,this.container.children[0])||e.selectAll("."+ui,this.container)[0].focus()},a.prototype.appendPalette=function(t,e,i){var s=this.createElement("div",{className:ui,attrs:{tabindex:"0"}});i?i.appendChild(s):this.appendElement(s);for(var n,a,r,l=0,o=t.length;l<o;l++)0!==l&&l%this.columns!=0||(n=this.createElement("div",{className:"e-row",attrs:{role:"presentation"}}),s.appendChild(n)),r=this.roundValue(t[l]).toLowerCase(),a=this.createElement("span",{className:"e-tile",attrs:{role:"gridcell","aria-label":r,"aria-selected":"false"}}),this.trigger("beforeTileRender",{element:a,presetName:e,value:t[l]}),n.appendChild(a),this.value===r&&(this.addTileSelection(a),s.focus()),a.style.backgroundColor=this.convertToRgbString(this.hexToRgb(r))},a.prototype.setNoColor=function(){var t=this.container.querySelector(".e-row").children[0];t.classList.add(di),this.value||(t.classList.add(yi),e.closest(t,"."+ui).focus()),["aria-selected","aria-label"].forEach(function(e){t.removeAttribute(e)}),t.style.backgroundColor=""},a.prototype.appendElement=function(t,e){void 0===e&&(e=0);var i=this.container.children[e];i?this.container.insertBefore(t,i):this.container.appendChild(t)},a.prototype.addTileSelection=function(t){t.classList.add(yi),t.setAttribute("aria-selected","true")},a.prototype.createPicker=function(){e.classList(this.container,[mi],[pi]);var t=this.createElement("div",{className:"e-hsv-container"});this.appendElement(t),t.appendChild(this.createElement("div",{className:li}));var i=this.createElement("span",{className:"e-handler",attrs:{tabindex:"0"}});t.appendChild(i),null===this.value&&(this.value="#008000ff"),this.rgb=this.hexToRgb(this.value),this.hsv=this.rgbToHsv.apply(this,this.rgb),this.setHsvContainerBg(),this.setHandlerPosition(),this.createSlider(),this.createDragTooltip()},a.prototype.setHsvContainerBg=function(t){void 0===t&&(t=this.hsv[0]),this.getHsvContainer().style.backgroundColor=this.convertToRgbString(this.hsvToRgb(t,100,100,1))},a.prototype.getHsvContainer=function(){return e.select(".e-hsv-container",this.container)},a.prototype.setHandlerPosition=function(){var t=this.getDragHandler(),i=e.select("."+li,this.container);this.enableRtl?t.style.left=e.formatUnit(i.offsetWidth*Math.abs(100-this.hsv[1])/100):t.style.left=e.formatUnit(i.offsetWidth*this.hsv[1]/100),t.style.top=e.formatUnit(i.offsetHeight*(100-this.hsv[2])/100)},a.prototype.createSlider=function(){var t=this.createElement("div",{className:"e-slider-preview"});this.appendElement(t,1),this.createPreview(t);var e=this.createElement("div",{className:"e-colorpicker-slider"});t.insertBefore(e,t.children[0]);var i=this.createElement("div",{className:"e-hue-slider"});e.appendChild(i),this.hueSlider=new ge({value:this.hsv[0],min:0,max:359,enableRtl:this.enableRtl,enabled:!this.disabled,change:this.hueChange.bind(this)}),this.hueSlider.createElement=this.createElement,this.hueSlider.appendTo(i),this.enableOpacity&&(i=this.createElement("div",{className:"e-opacity-slider"}),e.appendChild(i),this.createOpacitySlider(i))},a.prototype.createOpacitySlider=function(t){this.opacitySlider=new ge({value:100*this.rgb[3],min:0,max:100,enableRtl:this.enableRtl,enabled:!this.disabled,change:this.opacityChange.bind(this)}),this.opacitySlider.createElement=this.createElement,this.opacitySlider.appendTo(t);var e=this.createElement("div",{className:"e-opacity-empty-track"});t.appendChild(e),this.updateOpacitySliderBg()},a.prototype.updateOpacitySliderBg=function(){var t=this.enableRtl?"to left":"to right",i=e.select(".e-opacity-empty-track",this.opacitySlider.element);i&&(i.style.background="linear-gradient("+t+", rgba("+this.rgb.slice(0,3)+", 0) 0%, "+this.convertToRgbString(this.rgb.slice(0,3))+" 100%)")},a.prototype.hueChange=function(t){this.hsv[0]=t.value,this.setHsvContainerBg(),this.convertToOtherFormat()},a.prototype.opacityChange=function(t){var e=t.value,i=this.rgbToHex(this.rgb);this.hsv[3]=e/100,this.rgb[3]=e/100;var s=this.rgbToHex(this.rgb);this.updateOpacityInput(e);var n=this.convertToRgbString(this.rgb);this.updatePreview(n),this.triggerEvent(s,i,n)},a.prototype.updateOpacityInput=function(t){if(this.enableOpacity&&!this.getWrapper().classList.contains(ai)){var i=e.getInstance(e.select("."+ci,this.container),Y);i.value=t,i.dataBind()}},a.prototype.createPreview=function(t){var e=this.createElement("div",{className:vi});t.appendChild(e);var i=this.createElement("span",{className:"e-preview e-current"});e.appendChild(i);var s=this.convertToRgbString(this.rgb);i.style.backgroundColor=s,i=this.createElement("span",{className:"e-preview "+fi}),e.appendChild(i),i.style.backgroundColor=s},a.prototype.isPicker=function(){return!this.container.classList.contains(pi)},a.prototype.getPopupEle=function(){return this.container.parentElement},a.prototype.createNumericInput=function(t,e,i,s){var n=this,a=new Y({value:e,placeholder:i,min:0,max:s,format:"###.##",showSpinButton:!1,floatLabelType:"Always",enableRtl:this.enableRtl,enabled:!this.disabled,readonly:!this.isPicker(),change:function(t){t.event&&n.inputHandler(t.event)}});a.createElement=this.createElement,a.appendTo(t)},a.prototype.createInput=function(){var e=this.isPicker(),i=this.getWrapper();if(e&&!i.classList.contains(ai)||!e&&i.classList.contains(gi)){var s=this.createElement("div",{className:oi});e?this.appendElement(s,2):this.appendElement(s,1);var n=this.createElement("div",{className:"e-input-container"});if(s.appendChild(n),i.classList.contains(ri)||this.appendValueSwitchBtn(s),!i.classList.contains(ii)){var a=this.createElement("input",{className:"e-hex",attrs:{maxlength:"7",spellcheck:"false"}});n.appendChild(a),t.Input.createInput({element:a,floatLabelType:"Always",properties:{placeholder:"HEX",enableRtl:this.enableRtl,enabled:!this.disabled,readonly:!this.isPicker()}},this.createElement),t.Input.setValue(this.value.slice(0,7),a),a.addEventListener("input",this.inputHandler.bind(this))}if(!i.classList.contains(ni)){var r=void 0,l=void 0;this.isRgb?(r="RGB",l=this.rgb):(r="HSV",l=this.hsv);for(var o=["rh","gs","bv"],h=0;h<3;h++)this.createNumericInput(n.appendChild(this.createElement("input",{className:"e-"+o[h]+"-value"})),l[h],r[h],255);this.enableOpacity&&this.appendOpacityValue(n)}}},a.prototype.appendOpacityValue=function(t){this.createNumericInput(t.appendChild(this.createElement("input",{className:ci})),100*this.rgb[3],"A",100)},a.prototype.appendValueSwitchBtn=function(t){var e=this.createElement("button",{className:"e-icons e-css e-btn e-flat e-icon-btn "+ei});t.appendChild(e),this.isPicker()&&!this.getWrapper().classList.contains(ni)&&e.addEventListener("click",this.formatSwitchHandler.bind(this))},a.prototype.createCtrlBtn=function(){if(this.modeSwitcher||this.showButtons){this.l10n.setLocale(this.locale);var t=this.createElement("div",{className:ti});if(this.container.appendChild(t),this.showButtons){var e=this.createElement("div",{className:Qe});t.appendChild(e);var i=this.l10n.getConstant("Apply");e.appendChild(this.createElement("button",{innerHTML:i,className:"e-btn e-css e-flat e-primary e-small e-apply",attrs:{title:i}}));var s=this.l10n.getConstant("Cancel");e.appendChild(this.createElement("button",{innerHTML:s,className:"e-btn e-css e-flat e-small e-cancel",attrs:{title:s}}))}this.modeSwitcher&&this.appendModeSwitchBtn()}},a.prototype.appendModeSwitchBtn=function(){var t=this.createElement("button",{className:"e-icons e-btn e-flat e-icon-btn "+hi,attrs:{title:this.l10n.getConstant("ModeSwitcher")}});e.select("."+ti,this.container).insertBefore(t,e.select("."+Qe,this.container))},a.prototype.createDragTooltip=function(){var t=this,s=new i.Tooltip({opensOn:"Custom",showTipPointer:!1,cssClass:"e-color-picker-tooltip",beforeOpen:function(e){t.tooltipEle=e.element},animation:{open:{effect:"None"},close:{effect:"None"}}});s.createElement=this.createElement,s.appendTo(this.container),s.open(this.container),this.tooltipEle.style.zIndex=i.getZindexPartial(this.tooltipEle).toString(),e.select(".e-tip-content",this.tooltipEle).appendChild(this.createElement("div",{className:"e-tip-transparent"}))},a.prototype.getTooltipInst=function(){return e.getInstance(this.container,i.Tooltip)},a.prototype.setTooltipOffset=function(t){this.getTooltipInst().offsetY=t},a.prototype.toggleDisabled=function(t){t?this.getWrapper().classList.add("e-disabled"):this.getWrapper().classList.remove("e-disabled"),this.showButtons&&[].slice.call(e.selectAll(".e-btn",this.container)).forEach(function(i){t?e.attributes(i,{disabled:""}):i.removeAttribute("disabled")})},a.prototype.convertToRgbString=function(t){return t.length?4===t.length?"rgba("+t.join()+")":"rgb("+t.join()+")":""},a.prototype.convertToHsvString=function(t){return 4===t.length?"hsva("+t.join()+")":"hsv("+t.join()+")"},a.prototype.updateHsv=function(){this.hsv[1]=this.hsv[1]>100?100:this.hsv[1],this.hsv[2]=this.hsv[2]>100?100:this.hsv[2],this.setHandlerPosition()},a.prototype.convertToOtherFormat=function(t){void 0===t&&(t=!1);var e=this.rgbToHex(this.rgb);this.rgb=this.hsvToRgb.apply(this,this.hsv);var i=this.rgbToHex(this.rgb),s=this.convertToRgbString(this.rgb);this.updatePreview(s),this.updateInput(i),this.triggerEvent(i,e,s,t)},a.prototype.updateInput=function(i){var s=this.getWrapper();s.classList.contains(ai)||(s.classList.contains(ii)||t.Input.setValue(i.substr(0,7),e.select(".e-hex",this.container)),s.classList.contains(ni)||(this.isRgb?this.updateValue(this.rgb,!1):this.updateValue(this.hsv,!1)))},a.prototype.updatePreview=function(t){this.enableOpacity&&this.updateOpacitySliderBg(),e.select(".e-tip-transparent",this.tooltipEle).style.backgroundColor=t,e.select("."+vi+" .e-current",this.container).style.backgroundColor=t,e.select("."+vi+" ."+fi,this.container).style.backgroundColor=this.convertToRgbString(this.hexToRgb(this.value))},a.prototype.getDragHandler=function(){return e.select(".e-handler",this.container)},a.prototype.removeTileSelection=function(){[].slice.call(e.selectAll("."+yi,this.container.children[0])).forEach(function(t){t.classList.remove(yi),t.setAttribute("aria-selected","false")})},a.prototype.convertRgbToNumberArray=function(t){return t.slice(t.indexOf("(")+1,t.indexOf(")")).split(",").map(function(t,e){return 3!==e?parseInt(t,10):parseFloat(t)})},a.prototype.getValue=function(t,e){if(t||(t=this.value),e=e?e.toLowerCase():"hex","r"===t[0]){var i=this.convertRgbToNumberArray(t);if("hex"===e||"hexa"===e){var s=this.rgbToHex(i);return"hex"===e?s.slice(0,7):s}return"hsv"===e?this.convertToHsvString(this.rgbToHsv.apply(this,i.slice(0,3))):"hsva"===e?this.convertToHsvString(this.rgbToHsv.apply(this,i)):"null"}if("h"===t[0]){i=this.hsvToRgb.apply(this,this.convertRgbToNumberArray(t));if("rgba"===e)return this.convertToRgbString(i);if("hex"===e||"hexa"===e){s=this.rgbToHex(i);return"hex"===e?s.slice(0,7):s}return"rgb"===e?this.convertToRgbString(i.slice(0,3)):"null"}t=this.roundValue(t);var n=this.hexToRgb(t);return"rgb"!==e&&"hsv"!==e||(n=n.slice(0,3)),"rgba"===e||"rgb"===e?this.convertToRgbString(n):"hsva"===e||"hsv"===e?this.convertToHsvString(this.rgbToHsv.apply(this,n)):"hex"===e?t.slice(0,7):"a"===e?n[3].toString():"null"},a.prototype.toggle=function(){this.container.parentElement.classList.contains("e-popup-close")?this.splitBtn.toggle():this.closePopup(null)},a.prototype.getModuleName=function(){return"colorpicker"},a.prototype.getPersistData=function(){return this.addOnPersist(["value"])},a.prototype.wireEvents=function(){if(this.isPicker()){var t=this.getDragHandler();e.EventHandler.add(t,"keydown",this.pickerKeyDown,this),e.EventHandler.add(this.getHsvContainer(),"mousedown touchstart",this.handlerDown,this),(this.modeSwitcher||this.showButtons)&&this.addCtrlSwitchEvent(),e.EventHandler.add(e.select("."+fi,this.container),"click",this.previewHandler,this)}else e.EventHandler.add(this.container,"click",this.paletteClickHandler,this),e.EventHandler.add(this.container,"keydown",this.paletteKeyDown,this)},a.prototype.formResetHandler=function(){this.value=this.initialInputValue,e.attributes(this.element,{value:this.initialInputValue})},a.prototype.addCtrlSwitchEvent=function(){var t=e.select("."+ti,this.container);t&&e.EventHandler.add(t,"click",this.btnClickHandler,this)},a.prototype.pickerKeyDown=function(t){switch(t.keyCode){case 39:this.handlerDragPosition(1,this.enableRtl?-1:1,t);break;case 37:this.handlerDragPosition(1,this.enableRtl?1:-1,t);break;case 38:this.handlerDragPosition(2,1,t);break;case 40:this.handlerDragPosition(2,-1,t);break;case 13:t.preventDefault();var e=this.rgbToHex(this.rgb);this.enterKeyHandler(e,t)}},a.prototype.enterKeyHandler=function(t,e){this.triggerChangeEvent(t),this.inline||(this.closePopup(e),this.splitBtn.element.focus())},a.prototype.closePopup=function(t){var e=this,i={element:this.container,event:t,cancel:!1};this.trigger("beforeClose",i,function(t){t.cancel||(e.splitBtn.toggle(),e.onPopupClose())})},a.prototype.triggerChangeEvent=function(t){var e=t.slice(0,7);this.trigger("change",{currentValue:{hex:e,rgba:this.convertToRgbString(this.rgb)},previousValue:{hex:this.value.slice(0,7),rgba:this.convertToRgbString(this.hexToRgb(this.value))},value:this.enableOpacity?t:e}),this.enableOpacity?this.setProperties({value:t},!0):this.setProperties({value:e},!0),this.element.value=e||"#000000"},a.prototype.handlerDragPosition=function(t,e,i){i.preventDefault(),this.hsv[t]+=e*(i.ctrlKey?1:3),this.hsv[t]<0&&(this.hsv[t]=0),this.updateHsv(),this.convertToOtherFormat(!0)},a.prototype.handlerDown=function(t){t.preventDefault(),"mousedown"===t.type?(this.clientX=Math.abs(t.pageX-pageXOffset),this.clientY=Math.abs(t.pageY-pageYOffset),this.setTooltipOffset(8)):(this.clientX=Math.abs(t.changedTouches[0].pageX-pageXOffset),this.clientY=Math.abs(t.changedTouches[0].pageY-pageYOffset),this.setTooltipOffset(-8)),this.setHsv(this.clientX,this.clientY),this.getDragHandler().style.transition="left .4s cubic-bezier(.25, .8, .25, 1), top .4s cubic-bezier(.25, .8, .25, 1)",this.updateHsv(),this.convertToOtherFormat(),this.getDragHandler().focus(),e.EventHandler.add(document,"mousemove touchmove",this.handlerMove,this),e.EventHandler.add(document,"mouseup touchend",this.handlerEnd,this)},a.prototype.handlerMove=function(t){"touchmove"!==t.type&&t.preventDefault();var i,s;"mousemove"===t.type?(i=Math.abs(t.pageX-pageXOffset),s=Math.abs(t.pageY-pageYOffset)):(i=Math.abs(t.changedTouches[0].pageX-pageXOffset),s=Math.abs(t.changedTouches[0].pageY-pageYOffset)),this.setHsv(i,s);var n=this.getDragHandler();this.updateHsv(),this.convertToOtherFormat(),this.getTooltipInst().refresh(n),this.tooltipEle.style.transform||(Math.abs(this.clientX-i)>8||Math.abs(this.clientY-s)>8)&&(e.select("."+li,this.container).style.cursor="pointer",n.style.transition="none",this.inline||(this.tooltipEle.style.zIndex=(parseInt(this.getPopupEle().style.zIndex,10)+1).toString()),this.tooltipEle.style.transform="rotate(45deg)",n.classList.add("e-hide-handler"))},a.prototype.setHsv=function(t,i){var s=e.select("."+li,this.container),n=s.getBoundingClientRect();t=this.enableRtl?t>n.right?0:Math.abs(t-n.right):t>n.left?Math.abs(t-n.left):0,i=i>n.top?Math.abs(i-n.top):0,this.hsv[2]=Math.round(10*Number(100*(s.offsetHeight-Math.max(0,Math.min(s.offsetHeight,i-s.offsetTop)))/s.offsetHeight))/10,this.hsv[1]=Math.round(10*Number(100*Math.max(0,Math.min(s.offsetWidth,t-s.offsetLeft))/s.offsetWidth))/10},a.prototype.handlerEnd=function(t){"touchend"!==t.type&&t.preventDefault(),e.EventHandler.remove(document,"mousemove touchmove",this.handlerMove),e.EventHandler.remove(document,"mouseup touchend",this.handlerEnd);var i=this.getDragHandler();e.select("."+li,this.container).style.cursor="",this.tooltipEle.style.transform&&(this.tooltipEle.style.transform="",i.classList.remove("e-hide-handler")),this.inline||this.showButtons||this.closePopup(t)},a.prototype.btnClickHandler=function(t){var i=t.target;e.closest(i,"."+hi)?(t.stopPropagation(),this.switchToPalette()):(i.classList.contains("e-apply")||i.classList.contains("e-cancel"))&&this.ctrlBtnClick(i,t)},a.prototype.switchToPalette=function(){this.trigger("beforeModeSwitch",{element:this.container,mode:"Palette"}),this.unWireEvents(),this.destroyOtherComp(),e.detach(e.select(".e-slider-preview",this.container)),this.getWrapper().classList.contains(ai)||e.remove(e.select("."+oi,this.container)),e.detach(this.getHsvContainer()),this.createPalette(),this.firstPaletteFocus(),this.createInput(),this.refreshPopupPos(),this.wireEvents(),this.trigger("onModeSwitch",{element:this.container,mode:"Palette"})},a.prototype.refreshPopupPos=function(){if(!this.inline){var t=this.getPopupEle();t.style.left=e.formatUnit(0+pageXOffset),t.style.top=e.formatUnit(0+pageYOffset),this.getPopupInst().refreshPosition(this.splitBtn.element.parentElement)}},a.prototype.formatSwitchHandler=function(){this.isRgb?(this.updateValue(this.hsv,!0,3,[360,100,100]),this.isRgb=!1):(this.updateValue(this.rgb,!0,2),this.isRgb=!0)},a.prototype.updateValue=function(t,i,s,n){for(var a,r=["e-rh-value","e-gs-value","e-bv-value"],l=0,o=r.length;l<o;l++)(a=e.getInstance(e.select("."+r[l],this.container),Y)).value=Math.round(t[l]),i&&(a.placeholder=r[l].substr(s,1).toUpperCase(),a.max=n?n[l]:255),a.dataBind()},a.prototype.previewHandler=function(t){var i=t.target,s=this.rgbToHex(this.rgb);this.rgb=this.convertRgbToNumberArray(i.style.backgroundColor),this.rgb[3]||(this.rgb[3]=1);var n=this.rgbToHex(this.rgb),a=this.rgbToHsv.apply(this,this.rgb);a[0]!==this.hsv[0]&&(this.hueSlider.setProperties({value:a[0]},!0),this.hueSlider.refresh()),this.setHsvContainerBg(a[0]),this.enableOpacity&&a[3]!==this.hsv[3]&&(this.opacitySlider.setProperties({value:100*a[3]},!0),this.opacitySlider.refresh(),this.updateOpacitySliderBg()),this.hsv=a,this.setHandlerPosition(),this.updateInput(n),e.select("."+vi+" .e-current",this.container).style.backgroundColor=this.convertToRgbString(this.rgb),this.triggerEvent(n,s,this.convertToRgbString(this.rgb))},a.prototype.paletteClickHandler=function(t){t.preventDefault();var i=t.target;if(i.classList.contains("e-tile")){if(this.removeTileSelection(),this.addTileSelection(i),i.classList.contains(di))this.noColorTile();else{var s=i.getAttribute("aria-label"),n=this.rgbToHex(this.rgb);this.rgb=this.hexToRgb(this.roundValue(s)),this.hsv=this.rgbToHsv.apply(this,this.rgb),this.getWrapper().classList.contains(gi)&&this.updateInput(s),this.triggerEvent(s,n,this.convertToRgbString(this.rgb))}this.inline||this.showButtons||this.closePopup(t)}else e.closest(i,"."+hi)?this.switchToPicker():i.classList.contains("e-apply")||i.classList.contains("e-cancel")?this.ctrlBtnClick(i,t):this.getWrapper().classList.contains(gi)&&e.closest(i,"."+ei)&&this.formatSwitchHandler()},a.prototype.noColorTile=function(t){void 0===t&&(t=!1);var e=this.rgbToHex(this.rgb);this.rgb=[],this.hsv=[],this.triggerEvent("",e,"",t)},a.prototype.switchToPicker=function(){var t=this.getWrapper();this.trigger("beforeModeSwitch",{element:this.container,mode:"Picker"}),this.unWireEvents(),[].slice.call(e.selectAll("."+ui,this.container)).forEach(function(t){e.detach(t)}),t.classList.contains(gi)&&e.detach(e.select("."+oi,this.container)),this.container.style.width="";var i=e.select(".e-custom-palette",this.container);this.presetColors&&e.remove(i),this.createPicker(),this.getDragHandler().focus(),this.createInput(),this.refreshPopupPos(),this.wireEvents(),this.trigger("onModeSwitch",{element:this.container,mode:"Picker"})},a.prototype.ctrlBtnClick=function(t,e){if(t.classList.contains("e-apply")){var i=this.rgbToHex(this.rgb);this.triggerChangeEvent(i)}this.inline||(this.closePopup(e),this.splitBtn.element.focus())},a.prototype.paletteKeyDown=function(t){var i=t.target;if(i.classList.contains(ui)){var s,n,a=[].slice.call(e.selectAll(".e-tile",i)),r=a.filter(function(t){return t.classList.contains("e-selected")}).pop();switch(!t.altKey&&t.keyCode){case 39:t.preventDefault(),s=r?a[this.tilePosition(a,r,this.enableRtl?-1:1)]:a[this.enableRtl?a.length-1:0],this.keySelectionChanges(s);break;case 37:t.preventDefault(),s=r?a[this.tilePosition(a,r,this.enableRtl?1:-1)]:a[this.enableRtl?0:a.length-1],this.keySelectionChanges(s);break;case 38:t.preventDefault(),s=a[n=r?this.tilePosition(a,r,-this.columns):0]?a[n]:a[n-this.columns],this.keySelectionChanges(s);break;case 40:t.preventDefault(),a[n=r?this.tilePosition(a,r,this.columns):a.length-1]?s=a[n]:(n%=a.length,s=a[n+=a[a.length-1].parentElement.childElementCount]),this.keySelectionChanges(s);break;case 13:if(t.preventDefault(),r){var l=r.getAttribute("aria-label");this.enterKeyHandler(l||"",t)}}}},a.prototype.keySelectionChanges=function(t){if(this.removeTileSelection(),this.addTileSelection(t),t.classList.contains(di))this.noColorTile(!0);else{var e=t.getAttribute("aria-label"),i=this.rgbToHex(this.rgb);this.rgb=this.hexToRgb(e),this.hsv=this.rgbToHsv.apply(this,this.rgb),this.getWrapper().classList.contains(gi)&&this.updateInput(e),this.triggerEvent(e,i,this.convertToRgbString(this.rgb),!0)}},a.prototype.tilePosition=function(t,e,i){var s=(t=Array.prototype.slice.call(t)).length,n=this.columns-t[s-1].parentElement.childElementCount,a=t.indexOf(e);return(a+=i)<0?a+=s+n:a%=s+n,a},a.prototype.inputHandler=function(t){var i=t.target;if(i.value.length){var s,n;switch(e.select(".e-float-text",i.parentElement).textContent){case"HEX":var a="";if(("#"===i.value[0]&&5!==i.value.length||"#"!==i.value[0]&&4!==i.value.length)&&(a=this.roundValue(i.value)),9!==a.length)return;n=this.rgbToHex(this.rgb),this.rgb=this.hexToRgb(a+a.substr(-2)),this.inputValueChange(this.rgbToHsv.apply(this,this.rgb),n,i.value);break;case"R":this.rgb[0]!==Number(i.value)&&(n=this.rgbToHex(this.rgb),this.rgb[0]=Number(i.value),s=this.rgbToHsv.apply(this,this.rgb),this.inputValueChange(s,n));break;case"G":this.rgb[1]!==Number(i.value)&&(n=this.rgbToHex(this.rgb),this.rgb[1]=Number(i.value),s=this.rgbToHsv.apply(this,this.rgb),this.inputValueChange(s,n));break;case"B":this.rgb[2]!==Number(i.value)&&(n=this.rgbToHex(this.rgb),this.rgb[2]=Number(i.value),s=this.rgbToHsv.apply(this,this.rgb),this.inputValueChange(s,n));break;case"H":this.hueSlider.value=Number(i.value);break;case"S":this.hsv[1]!==Number(i.value)&&(this.hsv[1]=Number(i.value),this.updateHsv(),this.convertToOtherFormat());break;case"V":this.hsv[2]!==Number(i.value)&&(this.hsv[2]=Number(i.value),this.updateHsv(),this.convertToOtherFormat());break;case"A":this.opacitySlider.value=Number(i.value)}}},a.prototype.inputValueChange=function(t,e,i){t[0]!==this.hsv[0]&&(this.hueSlider.setProperties({value:t[0]},!0),this.hueSlider.refresh(),this.setHsvContainerBg(t[0])),this.hsv=t;var s=this.rgbToHex(this.rgb);this.setHandlerPosition(),this.updateInput(i||s);var n=this.convertToRgbString(this.rgb);this.updatePreview(n),this.triggerEvent(s,e,n)},a.prototype.triggerEvent=function(t,e,i,s){void 0===s&&(s=!1);var n=t.slice(0,7);this.showButtons||s?this.trigger("select",{currentValue:{hex:n,rgba:i},previousValue:{hex:e.slice(0,7),rgba:this.convertToRgbString(this.hexToRgb(e))}}):(this.trigger("change",{currentValue:{hex:n,rgba:i},previousValue:{hex:this.value.slice(0,7),rgba:this.convertToRgbString(this.hexToRgb(this.value))},value:t}),this.enableOpacity?this.setProperties({value:t},!0):this.setProperties({value:n},!0),this.element.value=n||"#000000")},a.prototype.destroy=function(){var t=this,i=this.getWrapper();n.prototype.destroy.call(this),["tabindex","spellcheck"].forEach(function(e){t.element.removeAttribute(e)}),this.inline?(this.unWireEvents(),this.destroyOtherComp()):(this.isPopupOpen()&&(this.unWireEvents(),this.destroyOtherComp()),this.splitBtn.destroy(),this.splitBtn=null),this.tileRipple(),this.tileRipple=null,this.ctrlBtnRipple(),this.ctrlBtnRipple=null,this.element.nextElementSibling&&e.detach(this.element.nextElementSibling),i&&(i.parentElement.insertBefore(this.element,i),e.detach(i)),this.container=null,this.formElement&&e.EventHandler.remove(this.formElement,"reset",this.formResetHandler)},a.prototype.destroyOtherComp=function(){if(this.isPicker()){this.hueSlider.destroy(),this.enableOpacity&&(this.opacitySlider.destroy(),this.opacitySlider=null),this.hueSlider=null;var t=this.getTooltipInst();t.close(),t.destroy(),this.tooltipEle=null}},a.prototype.isPopupOpen=function(){return this.getPopupEle().classList.contains("e-popup-open")},a.prototype.unWireEvents=function(){if(this.isPicker()){var t=this.getDragHandler();e.EventHandler.remove(t,"keydown",this.pickerKeyDown),e.EventHandler.remove(this.getHsvContainer(),"mousedown touchstart",this.handlerDown),(this.modeSwitcher||this.showButtons)&&e.EventHandler.remove(e.select("."+ti,this.container),"click",this.btnClickHandler),e.EventHandler.remove(e.select("."+fi,this.container),"click",this.previewHandler)}else e.EventHandler.remove(this.container,"click",this.paletteClickHandler),e.EventHandler.remove(this.container,"keydown",this.paletteKeyDown)},a.prototype.roundValue=function(t){if(!t)return"";"#"!==t[0]&&(t="#"+t);var e=t.length;if(4===e&&(t+="f",e=5),5===e){for(var i="",s=1,n=t.length;s<n;s++)i+=t.charAt(s)+t.charAt(s);t="#"+i,e=9}return 7===e&&(t+="ff"),t},a.prototype.hexToRgb=function(t){if(!t)return[];9!==(t=t.trim()).length&&(t=this.roundValue(t));var e=Number((parseInt(t.slice(-2),16)/255).toFixed(2));t=t.slice(1,7);var i=parseInt(t,16),s=[];return s.push(i>>16&255),s.push(i>>8&255),s.push(255&i),s.push(e),s},a.prototype.rgbToHsv=function(t,i,s,n){if(this.rgb&&!this.rgb.length)return[];t/=255,i/=255,s/=255;var a,r=Math.max(t,i,s),l=Math.min(t,i,s),o=r,h=r-l,d=0===r?0:h/r;if(r===l)a=0;else{switch(r){case t:a=(i-s)/h+(i<s?6:0);break;case i:a=(s-t)/h+2;break;case s:a=(t-i)/h+4}a/=6}var c=[Math.round(360*a),Math.round(1e3*d)/10,Math.round(1e3*o)/10];return e.isNullOrUndefined(n)||c.push(n),c},a.prototype.hsvToRgb=function(t,i,s,n){var a,r,l;if(i/=100,s/=100,0===i)return a=r=l=s,[Math.round(255*a),Math.round(255*r),Math.round(255*l),n];t/=60;var o=Math.floor(t),h=t-o,d=s*(1-i),c=s*(1-i*h),u=s*(1-i*(1-h));switch(o){case 0:a=s,r=u,l=d;break;case 1:a=c,r=s,l=d;break;case 2:a=d,r=s,l=u;break;case 3:a=d,r=c,l=s;break;case 4:a=u,r=d,l=s;break;default:a=s,r=d,l=c}var p=[Math.round(255*a),Math.round(255*r),Math.round(255*l)];return e.isNullOrUndefined(n)||p.push(n),p},a.prototype.rgbToHex=function(t){return t.length?"#"+this.hex(t[0])+this.hex(t[1])+this.hex(t[2])+(e.isNullOrUndefined(t[3])?"":0!==t[3]?(Math.round(255*t[3])+65536).toString(16).substr(-2):"00"):""},a.prototype.hex=function(t){return("0"+t.toString(16)).slice(-2)},a.prototype.changeModeSwitcherProp=function(t){var i=e.select("."+ti,this.container);t?i?this.appendModeSwitchBtn():(this.createCtrlBtn(),this.isPicker()&&!this.disabled&&this.addCtrlSwitchEvent()):i&&(this.showButtons?e.detach(e.select("."+hi,i)):e.remove(i))},a.prototype.changeShowBtnProps=function(t){var i=e.select("."+ti,this.container);t?(i&&e.remove(i),this.createCtrlBtn(),this.isPicker()&&!this.disabled&&this.addCtrlSwitchEvent()):this.modeSwitcher?e.detach(e.select("."+Qe,i)):e.remove(i)},a.prototype.changeValueProp=function(t){if(this.isPicker())this.rgb=this.hexToRgb(t),this.hsv=this.rgbToHsv.apply(this,this.rgb),this.setHandlerPosition(),e.detach(e.closest(this.hueSlider.element,".e-slider-preview")),this.createSlider(),this.setHsvContainerBg(),this.updateInput(t),4===this.rgb.length&&this.updateOpacityInput(100*this.rgb[3]);else{this.removeTileSelection();var i=this.container.querySelector('span[aria-label="'+this.roundValue(t)+'"]');i&&this.addTileSelection(i)}},a.prototype.setInputEleProps=function(){e.remove(e.select("."+oi,this.container)),this.createInput()},a.prototype.changeDisabledProp=function(t){this.isPicker()&&(this.hueSlider.enabled=!t,this.opacitySlider.enabled=!t,this.setInputEleProps()),t?(this.toggleDisabled(!0),this.unWireEvents()):(this.toggleDisabled(!1),this.wireEvents())},a.prototype.changeCssClassProps=function(t,i){var s=this.getWrapper(),n=this.getPopupEle();i&&e.removeClass([s,n],i.split(" ")),t&&e.addClass([s,n],t.split(" "))},a.prototype.changeRtlProps=function(t){t?e.addClass([this.getWrapper()],"e-rtl"):e.removeClass([this.getWrapper()],"e-rtl")},a.prototype.changePaletteProps=function(){e.detach(this.container.children[0]),this.container.style.width="",this.createPalette()},a.prototype.changeOpacityProps=function(t){var i=this.getWrapper();t?(e.removeClass([this.container.parentElement],si),this.createOpacitySlider(e.select(".e-colorpicker-slider",this.container).appendChild(this.createElement("div",{className:"e-opacity-slider"}))),i.classList.contains(ai)||i.classList.contains(ni)||this.appendOpacityValue(e.select(".e-input-container",this.container))):(e.addClass([this.container.parentElement],si),this.opacitySlider.destroy(),e.remove(this.opacitySlider.element),this.opacitySlider=null,i.classList.contains(ai)||i.classList.contains(ni)||e.remove(e.select("."+ci,this.container).parentElement))},a.prototype.onPropertyChanged=function(t,i){var n=this;if(!e.isNullOrUndefined(t.value)){var a=this.roundValue(t.value);if(9===a.length){this.element.value=this.roundValue(a).slice(0,7);var r=this.splitBtn&&e.select("."+bi,this.splitBtn.element);r&&(r.style.backgroundColor=this.convertToRgbString(this.hexToRgb(t.value)))}else this.value=i.value}if(!this.inline&&e.isNullOrUndefined(t.inline)){if(this.splitBtn.setProperties(s.getModel(t,["disabled","enableRtl"])),!this.isPopupOpen())return this.changeCssClassProps(t.cssClass,i.cssClass),void this.changeRtlProps(t.enableRtl)}for(var l=function(s){switch(s){case"inline":t.inline?(o.getWrapper().appendChild(o.container),o.splitBtn.destroy(),e.detach(o.element.nextElementSibling),o.container.children.length||o.createWidget()):(o.destroyOtherComp(),o.unWireEvents(),o.container.innerHTML="",o.createSplitBtn());break;case"cssClass":o.changeCssClassProps(t.cssClass,i.cssClass);var a=t.cssClass.split(" ").concat(i.cssClass.split(" ")),r=0;(a=a.reduce(function(t,e){return t.indexOf(e)<0&&t.push(e),t},[])).forEach(function(t){if(0===r&&(t===ai||t===ri||t===gi||t===ii||t===ni)){e.select("."+oi,n.container)&&e.remove(e.select("."+oi,n.container)),n.createInput(),r++}});break;case"enableRtl":o.isPicker()&&(o.hueSlider.enableRtl=t.enableRtl,o.enableOpacity&&(o.opacitySlider.enableRtl=t.enableRtl),o.setInputEleProps()),o.changeRtlProps(t.enableRtl);break;case"disabled":o.changeDisabledProp(t.disabled);break;case"value":o.value!==i.value&&o.changeValueProp(t.value);break;case"showButtons":o.changeShowBtnProps(t.showButtons);break;case"mode":"Picker"===t.mode?o.switchToPicker():o.switchToPalette();break;case"modeSwitcher":o.changeModeSwitcherProp(t.modeSwitcher);break;case"columns":case"presetColors":o.isPicker()||o.changePaletteProps();break;case"noColor":t.noColor?"Palette"!==o.mode||o.modeSwitcher||o.setNoColor():o.changePaletteProps();break;case"enableOpacity":o.changeOpacityProps(t.enableOpacity)}},o=this,h=0,d=Object.keys(t);h<d.length;h++){l(d[h])}},a.prototype.focusIn=function(){this.element.parentElement.focus()},$e([e.Property("#008000ff")],a.prototype,"value",void 0),$e([e.Property("")],a.prototype,"cssClass",void 0),$e([e.Property(!1)],a.prototype,"disabled",void 0),$e([e.Property("Picker")],a.prototype,"mode",void 0),$e([e.Property(!0)],a.prototype,"modeSwitcher",void 0),$e([e.Property(null)],a.prototype,"presetColors",void 0),$e([e.Property(!0)],a.prototype,"showButtons",void 0),$e([e.Property(10)],a.prototype,"columns",void 0),$e([e.Property(!1)],a.prototype,"inline",void 0),$e([e.Property(!1)],a.prototype,"noColor",void 0),$e([e.Property(!1)],a.prototype,"enablePersistence",void 0),$e([e.Property(!0)],a.prototype,"enableOpacity",void 0),$e([e.Property(!1)],a.prototype,"createPopupOnClick",void 0),$e([e.Event()],a.prototype,"select",void 0),$e([e.Event()],a.prototype,"change",void 0),$e([e.Event()],a.prototype,"beforeTileRender",void 0),$e([e.Event()],a.prototype,"beforeOpen",void 0),$e([e.Event()],a.prototype,"open",void 0),$e([e.Event()],a.prototype,"beforeClose",void 0),$e([e.Event()],a.prototype,"beforeModeSwitch",void 0),$e([e.Event()],a.prototype,"onModeSwitch",void 0),$e([e.Event()],a.prototype,"created",void 0),a=$e([e.NotifyPropertyChanges],a)}(e.Component),xi=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function s(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),Si=function(t,e,i,s){var n,a=arguments.length,r=a<3?e:null===s?s=Object.getOwnPropertyDescriptor(e,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(t,e,i,s);else for(var l=t.length-1;l>=0;l--)(n=t[l])&&(r=(a<3?n(r):a>3?n(e,i,r):n(e,i))||r);return a>3&&r&&Object.defineProperty(e,i,r),r},ki=["title","style","class"],Pi=function(i){function s(t,e){var s=i.call(this,t,e)||this;return s.previousValue=null,s.isAngular=!1,s.isHiddenInput=!1,s.isForm=!1,s.inputPreviousValue=null,s.isVue=!1,s.textboxOptions=t,s}return xi(s,i),s.prototype.onPropertyChanged=function(i,s){for(var n=0,a=Object.keys(i);n<a.length;n++){switch(a[n]){case"floatLabelType":t.Input.removeFloating(this.textboxWrapper),t.Input.addFloating(this.respectiveElement,this.floatLabelType,this.placeholder);break;case"enabled":t.Input.setEnabled(this.enabled,this.respectiveElement,this.floatLabelType,this.textboxWrapper.container),this.bindClearEvent();break;case"width":t.Input.setWidth(i.width,this.textboxWrapper.container);break;case"value":var r=this.isProtectedOnChange;this.isProtectedOnChange=!0,this.isBlank(this.value)||(this.value=this.value.toString()),this.isProtectedOnChange=r,t.Input.setValue(this.value,this.respectiveElement,this.floatLabelType,this.showClearButton),this.isHiddenInput&&(this.element.value=this.respectiveElement.value),this.inputPreviousValue=this.respectiveElement.value,(this.isAngular||this.isVue)&&!0===this.preventChange?(this.previousValue=this.isAngular?this.value:this.previousValue,this.preventChange=!1):(e.isNullOrUndefined(this.isAngular)||!this.isAngular||this.isAngular&&!this.preventChange||this.isAngular&&e.isNullOrUndefined(this.preventChange))&&this.raiseChangeEvent();break;case"htmlAttributes":this.updateHTMLAttrToElement(),this.updateHTMLAttrToWrapper(),this.checkAttributes(!0),t.Input.validateInputType(this.textboxWrapper.container,this.element);break;case"readonly":t.Input.setReadonly(this.readonly,this.respectiveElement);break;case"type":"TEXTAREA"!==this.respectiveElement.tagName&&(this.respectiveElement.setAttribute("type",this.type),t.Input.validateInputType(this.textboxWrapper.container,this.element),this.raiseChangeEvent());break;case"showClearButton":"TEXTAREA"!==this.respectiveElement.tagName&&(t.Input.setClearButton(this.showClearButton,this.respectiveElement,this.textboxWrapper),this.bindClearEvent());break;case"enableRtl":t.Input.setEnableRtl(this.enableRtl,[this.textboxWrapper.container]);break;case"placeholder":t.Input.setPlaceholder(this.placeholder,this.respectiveElement);break;case"autocomplete":"on"!==this.autocomplete&&""!==this.autocomplete?this.respectiveElement.autocomplete=this.autocomplete:this.removeAttributes(["autocomplete"]);break;case"cssClass":this.updateCssClass(i.cssClass,s.cssClass);break;case"locale":this.globalize=new e.Internationalization(this.locale),this.l10n.setLocale(this.locale),this.setProperties({placeholder:this.l10n.getConstant("placeholder")},!0),t.Input.setPlaceholder(this.placeholder,this.respectiveElement)}}},s.prototype.getModuleName=function(){return"textbox"},s.prototype.isBlank=function(t){return!t||/^\s*$/.test(t)},s.prototype.preRender=function(){if(this.cloneElement=this.element.cloneNode(!0),this.formElement=e.closest(this.element,"form"),e.isNullOrUndefined(this.formElement)||(this.isForm=!0),"EJS-TEXTBOX"===this.element.tagName){for(var t=e.getValue("ej2_instances",this.element),i=this.multiline?this.createElement("textarea"):this.createElement("input"),s=0;s<this.element.attributes.length;s++){"id"!==(r=this.element.attributes[s].nodeName)&&(i.setAttribute(r,this.element.attributes[s].nodeValue),i.innerHTML=this.element.innerHTML,"name"===r&&this.element.removeAttribute("name"))}this.element.appendChild(i),this.element=i,e.setValue("ej2_instances",t,this.element)}this.updateHTMLAttrToElement(),this.checkAttributes(!1),"TEXTAREA"!==this.element.tagName&&this.element.setAttribute("type",this.type),this.element.setAttribute("role","textbox"),this.globalize=new e.Internationalization(this.locale);var n={placeholder:this.placeholder};if(this.l10n=new e.L10n("textbox",n,this.locale),""!==this.l10n.getConstant("placeholder")&&this.setProperties({placeholder:this.placeholder||this.l10n.getConstant("placeholder")},!0),this.element.hasAttribute("id")||this.element.setAttribute("id",e.getUniqueID("textbox")),this.element.hasAttribute("name")||this.element.setAttribute("name",this.element.getAttribute("id")),"INPUT"===this.element.tagName&&this.multiline){this.isHiddenInput=!0,this.textarea=this.createElement("textarea"),this.element.parentNode.insertBefore(this.textarea,this.element),this.element.setAttribute("type","hidden"),this.textarea.setAttribute("name",this.element.getAttribute("name")),this.element.removeAttribute("name"),this.textarea.setAttribute("role",this.element.getAttribute("role")),this.element.removeAttribute("role"),this.textarea.setAttribute("id",e.getUniqueID("textarea"));var a=["placeholder","disabled","value","readonly","type","autocomplete"];for(s=0;s<this.element.attributes.length;s++){var r=this.element.attributes[s].nodeName;this.element.hasAttribute(r)&&ki.indexOf(r)<0&&"id"!==r&&"type"!==r&&"e-mappinguid"!==r&&(this.textarea.setAttribute(r,this.element.attributes[s].nodeValue),a.indexOf(r)<0&&(this.element.removeAttribute(r),s--))}}},s.prototype.checkAttributes=function(t){for(var i=0,s=t?e.isNullOrUndefined(this.htmlAttributes)?[]:Object.keys(this.htmlAttributes):["placeholder","disabled","value","readonly","type","autocomplete"];i<s.length;i++){var n=s[i];if(!e.isNullOrUndefined(this.element.getAttribute(n)))switch(n){case"disabled":if(e.isNullOrUndefined(this.textboxOptions)||void 0===this.textboxOptions.enabled||t){var a="disabled"!==this.element.getAttribute(n)&&""!==this.element.getAttribute(n)&&"true"!==this.element.getAttribute(n);this.setProperties({enabled:a},!t)}break;case"readonly":if(e.isNullOrUndefined(this.textboxOptions)||void 0===this.textboxOptions.readonly||t){var r="readonly"===this.element.getAttribute(n)||""===this.element.getAttribute(n)||"true"===this.element.getAttribute(n);this.setProperties({readonly:r},!t)}break;case"placeholder":(e.isNullOrUndefined(this.textboxOptions)||void 0===this.textboxOptions.placeholder||t)&&this.setProperties({placeholder:this.element.placeholder},!t);break;case"autocomplete":if(e.isNullOrUndefined(this.textboxOptions)||void 0===this.textboxOptions.autocomplete||t){var l="off"===this.element.autocomplete?"off":"on";this.setProperties({autocomplete:l},!t)}break;case"value":(e.isNullOrUndefined(this.textboxOptions)||void 0===this.textboxOptions.value||t)&&this.setProperties({value:this.element.value},!t);break;case"type":(e.isNullOrUndefined(this.textboxOptions)||void 0===this.textboxOptions.type||t)&&this.setProperties({type:this.element.type},!t)}}},s.prototype.render=function(){var i=this.cssClass;e.isNullOrUndefined(this.cssClass)||""===this.cssClass||(i=this.getInputValidClassList(this.cssClass)),this.respectiveElement=this.isHiddenInput?this.textarea:this.element,this.textboxWrapper=t.Input.createInput({element:this.respectiveElement,floatLabelType:this.floatLabelType,properties:{enabled:this.enabled,enableRtl:this.enableRtl,cssClass:i,readonly:this.readonly,placeholder:this.placeholder,showClearButton:this.showClearButton}}),this.updateHTMLAttrToWrapper(),this.isHiddenInput&&this.respectiveElement.parentNode.insertBefore(this.element,this.respectiveElement),this.wireEvents(),e.isNullOrUndefined(this.value)||(t.Input.setValue(this.value,this.respectiveElement,this.floatLabelType,this.showClearButton),this.isHiddenInput&&(this.element.value=this.respectiveElement.value)),e.isNullOrUndefined(this.value)||(this.initialValue=this.value,this.setInitialValue()),"on"!==this.autocomplete&&""!==this.autocomplete?this.respectiveElement.autocomplete=this.autocomplete:e.isNullOrUndefined(this.textboxOptions)||void 0===this.textboxOptions.autocomplete||this.removeAttributes(["autocomplete"]),this.previousValue=this.value,this.inputPreviousValue=this.value,this.respectiveElement.defaultValue=this.respectiveElement.value,t.Input.setWidth(this.width,this.textboxWrapper.container),this.renderComplete()},s.prototype.updateHTMLAttrToWrapper=function(){if(!e.isNullOrUndefined(this.htmlAttributes))for(var t=0,i=Object.keys(this.htmlAttributes);t<i.length;t++){var s=i[t];if(ki.indexOf(s)>-1)if("class"===s){var n=this.getInputValidClassList(this.htmlAttributes[s]);""!==n&&e.addClass([this.textboxWrapper.container],n.split(" "))}else if("style"===s){var a=this.textboxWrapper.container.getAttribute(s);a=e.isNullOrUndefined(a)?this.htmlAttributes[s]:a+this.htmlAttributes[s],this.textboxWrapper.container.setAttribute(s,a)}else this.textboxWrapper.container.setAttribute(s,this.htmlAttributes[s])}},s.prototype.updateHTMLAttrToElement=function(){if(!e.isNullOrUndefined(this.htmlAttributes))for(var t=0,i=Object.keys(this.htmlAttributes);t<i.length;t++){var s=i[t];ki.indexOf(s)<0&&this.element.setAttribute(s,this.htmlAttributes[s])}},s.prototype.updateCssClass=function(e,i){t.Input.setCssClass(this.getInputValidClassList(e),[this.textboxWrapper.container],this.getInputValidClassList(i))},s.prototype.getInputValidClassList=function(t){var i=t;return e.isNullOrUndefined(t)||""===t||(i=t.replace(/\s+/g," ").trim()),i},s.prototype.setInitialValue=function(){this.isAngular||this.respectiveElement.setAttribute("value",this.initialValue)},s.prototype.wireEvents=function(){e.EventHandler.add(this.respectiveElement,"focus",this.focusHandler,this),e.EventHandler.add(this.respectiveElement,"blur",this.focusOutHandler,this),e.EventHandler.add(this.respectiveElement,"input",this.inputHandler,this),e.EventHandler.add(this.respectiveElement,"change",this.changeHandler,this),this.isForm&&e.EventHandler.add(this.formElement,"reset",this.resetForm,this),this.bindClearEvent(),!e.isNullOrUndefined(this.textboxWrapper.container.querySelector(".e-float-text"))&&"Auto"===this.floatLabelType&&this.textboxWrapper.container.classList.contains("e-autofill")&&this.textboxWrapper.container.classList.contains("e-outline")&&e.EventHandler.add(this.textboxWrapper.container.querySelector(".e-float-text"),"animationstart",this.animationHandler,this)},s.prototype.animationHandler=function(){this.textboxWrapper.container.classList.add("e-valid-input");var t=this.textboxWrapper.container.querySelector(".e-float-text");e.isNullOrUndefined(t)||(t.classList.add("e-label-top"),t.classList.contains("e-label-bottom")&&t.classList.remove("e-label-bottom"))},s.prototype.resetValue=function(t){var e=this.isProtectedOnChange;this.isProtectedOnChange=!0,this.value=t,this.isProtectedOnChange=e},s.prototype.resetForm=function(){if(this.isAngular?this.resetValue(""):this.resetValue(this.initialValue),!e.isNullOrUndefined(this.textboxWrapper)){var t=this.textboxWrapper.container.querySelector(".e-float-text");e.isNullOrUndefined(t)||(e.isNullOrUndefined(this.initialValue)||""===this.initialValue?(t.classList.add("e-label-bottom"),t.classList.remove("e-label-top")):""!==this.initialValue&&(t.classList.add("e-label-top"),t.classList.remove("e-label-bottom")))}},s.prototype.focusHandler=function(t){var e={container:this.textboxWrapper.container,event:t,value:this.value};this.trigger("focus",e)},s.prototype.focusOutHandler=function(t){null===this.previousValue&&null===this.value&&""===this.respectiveElement.value||this.previousValue===this.respectiveElement.value||this.raiseChangeEvent(t,!0);var e={container:this.textboxWrapper.container,event:t,value:this.value};this.trigger("blur",e)},s.prototype.inputHandler=function(t){var e={event:t,value:this.respectiveElement.value,previousValue:this.inputPreviousValue,container:this.textboxWrapper.container};this.inputPreviousValue=this.respectiveElement.value,this.isAngular&&(this.localChange({value:this.respectiveElement.value}),this.preventChange=!0),this.isVue&&(this.preventChange=!0),this.trigger("input",e),t.stopPropagation()},s.prototype.changeHandler=function(t){this.setProperties({value:this.respectiveElement.value},!0),this.raiseChangeEvent(t,!0),t.stopPropagation()},s.prototype.raiseChangeEvent=function(t,e){var i={event:t,value:this.value,previousValue:this.previousValue,container:this.textboxWrapper.container,isInteraction:e||!1,isInteracted:e||!1};this.preventChange=!1,this.trigger("change",i),this.previousValue=this.value},s.prototype.bindClearEvent=function(){this.showClearButton&&"TEXTAREA"!==this.respectiveElement.tagName&&(this.enabled?e.EventHandler.add(this.textboxWrapper.clearButton,"mousedown touchstart",this.resetInputHandler,this):e.EventHandler.remove(this.textboxWrapper.clearButton,"mousedown touchstart",this.resetInputHandler))},s.prototype.resetInputHandler=function(e){if(e.preventDefault(),!this.textboxWrapper.clearButton.classList.contains("e-clear-icon-hide")||this.textboxWrapper.container.classList.contains("e-static-clear")){t.Input.setValue("",this.respectiveElement,this.floatLabelType,this.showClearButton),this.isHiddenInput&&(this.element.value=this.respectiveElement.value),this.setProperties({value:this.respectiveElement.value},!0);var i={event:e,value:this.respectiveElement.value,previousValue:this.inputPreviousValue,container:this.textboxWrapper.container};this.trigger("input",i),this.inputPreviousValue=this.respectiveElement.value,this.raiseChangeEvent(e,!0)}},s.prototype.unWireEvents=function(){e.EventHandler.remove(this.respectiveElement,"focus",this.focusHandler),e.EventHandler.remove(this.respectiveElement,"blur",this.focusOutHandler),e.EventHandler.remove(this.respectiveElement,"input",this.inputHandler),e.EventHandler.remove(this.respectiveElement,"change",this.changeHandler),this.isForm&&e.EventHandler.remove(this.formElement,"reset",this.resetForm),!e.isNullOrUndefined(this.textboxWrapper.container.querySelector(".e-float-text"))&&"Auto"===this.floatLabelType&&this.textboxWrapper.container.classList.contains("e-outline")&&this.textboxWrapper.container.classList.contains("e-autofill")&&e.EventHandler.remove(this.textboxWrapper.container.querySelector(".e-float-text"),"animationstart",this.animationHandler)},s.prototype.destroy=function(){this.unWireEvents(),"INPUT"===this.element.tagName&&this.multiline&&(e.detach(this.textboxWrapper.container.getElementsByTagName("textarea")[0]),this.respectiveElement=this.element,this.element.removeAttribute("type")),this.respectiveElement.value=this.respectiveElement.defaultValue,this.respectiveElement.classList.remove("e-input"),this.removeAttributes(["aria-placeholder","aria-disabled","aria-readonly","aria-labelledby"]),e.isNullOrUndefined(this.textboxWrapper)||(this.textboxWrapper.container.insertAdjacentElement("afterend",this.respectiveElement),e.detach(this.textboxWrapper.container)),this.textboxWrapper=null,i.prototype.destroy.call(this)},s.prototype.addIcon=function(e,i){t.Input.addIcon(e,i,this.textboxWrapper.container,this.respectiveElement,this.createElement)},s.prototype.getPersistData=function(){return this.addOnPersist(["value"])},s.prototype.addAttributes=function(e){for(var i=0,s=Object.keys(e);i<s.length;i++){var n=s[i];"disabled"===n?(this.setProperties({enabled:!1},!0),t.Input.setEnabled(this.enabled,this.respectiveElement,this.floatLabelType,this.textboxWrapper.container)):"readonly"===n?(this.setProperties({readonly:!0},!0),t.Input.setReadonly(this.readonly,this.respectiveElement)):"class"===n?this.respectiveElement.classList.add(e[n]):"placeholder"===n?(this.setProperties({placeholder:e[n]},!0),t.Input.setPlaceholder(this.placeholder,this.respectiveElement)):("rows"===n&&this.respectiveElement.tagName,this.respectiveElement.setAttribute(n,e[n]))}},s.prototype.removeAttributes=function(e){for(var i=0,s=e;i<s.length;i++){var n=s[i];"disabled"===n?(this.setProperties({enabled:!0},!0),t.Input.setEnabled(this.enabled,this.respectiveElement,this.floatLabelType,this.textboxWrapper.container)):"readonly"===n?(this.setProperties({readonly:!1},!0),t.Input.setReadonly(this.readonly,this.respectiveElement)):"placeholder"===n?(this.setProperties({placeholder:null},!0),t.Input.setPlaceholder(this.placeholder,this.respectiveElement)):this.respectiveElement.removeAttribute(n)}},s.prototype.focusIn=function(){document.activeElement!==this.respectiveElement&&this.enabled&&(this.respectiveElement.focus(),(this.textboxWrapper.container.classList.contains("e-input-group")||this.textboxWrapper.container.classList.contains("e-outline")||this.textboxWrapper.container.classList.contains("e-filled"))&&e.addClass([this.textboxWrapper.container],["e-input-focus"]))},s.prototype.focusOut=function(){document.activeElement===this.respectiveElement&&this.enabled&&(this.respectiveElement.blur(),(this.textboxWrapper.container.classList.contains("e-input-group")||this.textboxWrapper.container.classList.contains("e-outline")||this.textboxWrapper.container.classList.contains("e-filled"))&&e.removeClass([this.textboxWrapper.container],["e-input-focus"]))},Si([e.Property("text")],s.prototype,"type",void 0),Si([e.Property(!1)],s.prototype,"readonly",void 0),Si([e.Property(null)],s.prototype,"value",void 0),Si([e.Property("Never")],s.prototype,"floatLabelType",void 0),Si([e.Property("")],s.prototype,"cssClass",void 0),Si([e.Property(null)],s.prototype,"placeholder",void 0),Si([e.Property("on")],s.prototype,"autocomplete",void 0),Si([e.Property({})],s.prototype,"htmlAttributes",void 0),Si([e.Property(!1)],s.prototype,"multiline",void 0),Si([e.Property(!0)],s.prototype,"enabled",void 0),Si([e.Property(!1)],s.prototype,"showClearButton",void 0),Si([e.Property(!1)],s.prototype,"enablePersistence",void 0),Si([e.Property(null)],s.prototype,"width",void 0),Si([e.Event()],s.prototype,"created",void 0),Si([e.Event()],s.prototype,"destroyed",void 0),Si([e.Event()],s.prototype,"change",void 0),Si([e.Event()],s.prototype,"blur",void 0),Si([e.Event()],s.prototype,"focus",void 0),Si([e.Event()],s.prototype,"input",void 0),s=Si([e.NotifyPropertyChanges],s)}(e.Component),Oi=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function s(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),Ti=function(t){function i(){var e=null!==t&&t.apply(this,arguments)||this;return e.minDistance=5,e.previous=0,e.interval=30,e.timeout=null,e.isSignatureEmpty=!0,e.backgroundLoaded=null,e.clearArray=[],e.isBlazor=!1,e}return Oi(i,t),i.prototype.initialize=function(t,i,s){this.element=t,this.canvasContext=this.element.getContext("2d"),this.canvasContext.canvas.tabIndex=0,i&&(this.setBlazorParameter(i),this.dotnetRef=s),this.setHTMLProperties(),e.isNullOrUndefined(this.signatureValue)&&this.updateSnapCollection(!0),this.wireEvents(),this.isSignatureEmpty=!0,this.isBlazor||this.trigger("created",null)},i.prototype.setBlazorParameter=function(t){this.isBlazor=!0,this.backgroundColor=t.backgroundColor,this.backgroundImage=t.backgroundImage,this.disabled=t.disabled,this.isReadOnly=t.isReadOnly,this.maxStrokeWidth=t.maxStrokeWidth||2,this.minStrokeWidth=t.minStrokeWidth||.5,this.velocity=t.velocity||.7,this.strokeColor=t.strokeColor||"#000000",this.saveWithBackground=t.saveWithBackground,this.interval=30,this.previous=0,this.minDistance=5,this.signatureValue=t.signatureValue,this.signatureValue&&this.loadPersistedSignature()},i.prototype.wireEvents=function(){!e.isNullOrUndefined(this.pointColl)||this.isReadOnly||this.disabled?this.pointColl&&(e.EventHandler.add(this.canvasContext.canvas,"mousemove touchmove",this.mouseMoveHandler,this),e.EventHandler.add(this.canvasContext.canvas,"mouseup touchend",this.mouseUpHandler,this),e.EventHandler.add(document,"mouseup",this.mouseUpHandler,this)):(e.EventHandler.add(this.canvasContext.canvas,"mousedown touchstart",this.mouseDownHandler,this),e.EventHandler.add(this.canvasContext.canvas,"keydown",this.keyboardHandler,this),window.addEventListener("resize",this.resizeHandler.bind(this)))},i.prototype.unwireEvents=function(t){"mouseup"===t||"touchend"===t?(e.EventHandler.remove(this.canvasContext.canvas,"mousemove touchmove",this.mouseMoveHandler),e.EventHandler.remove(this.canvasContext.canvas,"mouseup touchend",this.mouseUpHandler),e.EventHandler.remove(document,"mouseup",this.mouseUpHandler)):(e.EventHandler.remove(this.canvasContext.canvas,"mousedown touchstart",this.mouseDownHandler),e.EventHandler.remove(this.canvasContext.canvas,"mousemove touchmove",this.mouseMoveHandler),e.EventHandler.remove(this.canvasContext.canvas,"mouseup touchend",this.mouseUpHandler),e.EventHandler.remove(document,"mouseup",this.mouseUpHandler),e.EventHandler.remove(this.canvasContext.canvas,"keydown",this.keyboardHandler),window.removeEventListener("resize",this.resizeHandler))},i.prototype.setHTMLProperties=function(){150===this.element.height&&(this.element.height=this.element.offsetHeight),300===this.element.width&&(this.element.width=this.element.offsetWidth),this.canvasContext.scale(1,1),this.canvasContext.fillStyle=this.strokeColor,this.backgroundImage?this.canvasContext.canvas.style.backgroundImage="url("+this.backgroundImage+")":this.backgroundColor&&(this.canvasContext.canvas.style.backgroundColor=this.backgroundColor)},i.prototype.mouseDownHandler=function(t){1!==t.buttons&&2!==t.buttons&&"touchstart"!==t.type||("touchstart"===t.type&&(t.preventDefault(),t.stopPropagation()),this.beginStroke(t),this.wireEvents())},i.prototype.mouseMoveHandler=function(t){1!==t.buttons&&2!==t.buttons&&"touchmove"!==t.type||("touchmove"===t.type&&(t.preventDefault(),t.stopPropagation()),this.interval?this.updateStrokeWithThrottle(t):this.updateStroke(t))},i.prototype.mouseUpHandler=function(t){"touchstart"===t.type&&(t.preventDefault(),t.stopPropagation()),this.endDraw(),this.updateSnapCollection(),this.unwireEvents(t.type),this.isBlazor?this.dotnetRef.invokeMethodAsync("TriggerEventAsync","mouseUp"):this.trigger("change",{actionName:"strokeUpdate"}),this.signatureValue=this.snapColl[this.incStep]},i.prototype.keyboardHandler=function(t){var e=this,i={fileName:"Signature",type:"Png",cancel:!1};switch(t.key){case"Delete":this.clear();break;case t.ctrlKey&&"s":this.isBlazor?this.dotnetRef.invokeMethodAsync("TriggerEventAsync","beforeSave"):this.trigger("beforeSave",i,function(t){i.cancel||e.save(t.type,t.fileName)}),t.preventDefault(),t.stopImmediatePropagation();break;case t.ctrlKey&&"z":this.undo();break;case t.ctrlKey&&"y":this.redo()}},i.prototype.resizeHandler=function(){var t=this;this.canvasContext.canvas.width=this.element.offsetWidth,this.canvasContext.canvas.height=this.element.offsetHeight,this.canvasContext.scale(1,1);var e=new Image;e.src=this.snapColl[this.incStep],e.onload=function(){t.canvasContext.clearRect(0,0,t.element.width,t.element.height),t.canvasContext.drawImage(e,0,0,t.element.width,t.element.height)}},i.prototype.beginStroke=function(t){this.refresh(),this.updateStroke(t)},i.prototype.updateStroke=function(t){var e=this.createPoint(t);this.addPoint(e)},i.prototype.updateStrokeWithThrottle=function(t){var e=Date.now(),i=this.interval-(e-this.previous);this.storedArgs=t,i<=0||i>this.interval?(this.timeout&&(clearTimeout(this.timeout),this.timeout=null),this.previous=e,this.updateStroke(this.storedArgs),this.timeout||(this.storedArgs=null)):this.timeout||(this.timeout=window.setTimeout(this.delay.bind(this),i))},i.prototype.delay=function(){this.previous=Date.now(),this.timeout=null,this.updateStroke(this.storedArgs),this.timeout||(this.storedArgs=null)},i.prototype.createPoint=function(t){var e=this.canvasContext.canvas.getBoundingClientRect();return"mousedown"===t.type||"mousemove"===t.type?this.point(t.clientX-e.left,t.clientY-e.top,(new Date).getTime()):this.point(t.touches[0].clientX-e.left,t.touches[0].clientY-e.top,(new Date).getTime())},i.prototype.point=function(t,e,i){return this.pointX=t,this.pointY=e,this.time=i||(new Date).getTime(),{x:this.pointX,y:this.pointY,time:this.time}},i.prototype.addPoint=function(t){var e,i,s=this.pointColl,n=s.length>0&&s[s.length-1],a=!!n&&this.distanceTo(n)<=this.minDistance;n&&n&&a||(s.push(t),s.length>2&&(3===s.length&&s.unshift(s[0]),e=this.calculateCurveControlPoints(s[0],s[1],s[2]).controlPoint2,i=this.calculateCurveControlPoints(s[1],s[2],s[3]).controlPoint1,this.startPoint=s[1],this.controlPoint1=e,this.controlPoint2=i,this.endPoint=s[2],this.startDraw(),s.shift()))},i.prototype.startDraw=function(){var t;t=this.pointVelocityCalc(this.startPoint),t=this.velocity*t+(1-this.velocity)*this.lastVelocity;var e=Math.max(this.maxStrokeWidth/(t+1),this.minStrokeWidth);this.curveDraw(this.lastWidth,e),this.lastVelocity=t,this.lastWidth=e},i.prototype.endDraw=function(){var t=this.pointColl.length>2,e=this.pointColl[0];!t&&e&&this.strokeDraw(e)},i.prototype.curveDraw=function(t,e){var i,s,n,a,r,l,o,h,d,c,u=this.canvasContext,p=e-t,m=this.bezierLengthCalc(),v=2*Math.ceil(m);for(u.beginPath(),s=0;s<v;s++)r=(a=(n=s/v)*n)*n,d=(h=(o=(l=1-n)*l)*l)*this.startPoint.x,d+=3*o*n*this.controlPoint1.x,d+=3*l*a*this.controlPoint2.x,d+=r*this.endPoint.x,c=h*this.startPoint.y,c+=3*o*n*this.controlPoint1.y,c+=3*l*a*this.controlPoint2.y,c+=r*this.endPoint.y,i=Math.min(t+r*p,this.maxStrokeWidth),this.arcDraw(d,c,i);u.closePath(),u.fill(),this.isSignatureEmpty=!1},i.prototype.strokeDraw=function(t){var e=this.canvasContext,i=(this.minStrokeWidth+this.maxStrokeWidth)/2;e.beginPath(),this.arcDraw(t.x,t.y,i),e.closePath(),e.fill(),this.isSignatureEmpty=!1},i.prototype.arcDraw=function(t,e,i){var s=this.canvasContext;s.moveTo(t,e),s.arc(t,e,i,0,2*Math.PI,!1)},i.prototype.calculateCurveControlPoints=function(t,e,i){var s=t.x-e.x,n=t.y-e.y,a=e.x-i.x,r=e.y-i.y,l=(t.x+e.x)/2,o=(t.y+e.y)/2,h=(e.x+i.x)/2,d=(e.y+i.y)/2,c=Math.sqrt(s*s+n*n),u=Math.sqrt(a*a+r*r),p=u/(c+u),m=h+(l-h)*p,v=d+(o-d)*p,f=e.x-m,g=e.y-v;return{controlPoint1:this.point(l+f,o+g,0),controlPoint2:this.point(h+f,d+g,0)}},i.prototype.bezierLengthCalc=function(){var t,e,i,s,n,a,r,l,o=0;for(t=0;t<=10;t++)e=t/10,i=this.bezierPointCalc(e,this.startPoint.x,this.controlPoint1.x,this.controlPoint2.x,this.endPoint.x),s=this.bezierPointCalc(e,this.startPoint.y,this.controlPoint1.y,this.controlPoint2.y,this.endPoint.y),t>0&&(r=i-n,l=s-a,o+=Math.sqrt(r*r+l*l)),n=i,a=s;return o},i.prototype.bezierPointCalc=function(t,e,i,s,n){return e*(1-t)*(1-t)*(1-t)+3*i*(1-t)*(1-t)*t+3*s*(1-t)*t*t+n*t*t*t},i.prototype.pointVelocityCalc=function(t){return this.time!==t.time?this.distanceTo(t)/(this.time-t.time):0},i.prototype.distanceTo=function(t){return Math.sqrt(Math.pow(this.pointX-t.x,2)+Math.pow(this.pointY-t.y,2))},i.prototype.isRead=function(t){t?e.EventHandler.remove(this.canvasContext.canvas,"mousedown touchstart",this.mouseDownHandler):this.disabled||e.EventHandler.add(this.canvasContext.canvas,"mousedown touchstart",this.mouseDownHandler,this)},i.prototype.enableOrDisable=function(t){this.disabled=t,t?(this.reDraw("0.5"),this.isRead(!0)):(this.reDraw("1"),this.isRead(!1))},i.prototype.reDraw=function(t){var e=this.canvasContext.getImageData(0,0,this.element.width,this.element.height);this.canvasContext.clearRect(0,0,this.element.width,this.element.height),this.element.style.opacity=t,this.canvasContext.putImageData(e,0,0)},i.prototype.updateSnapCollection=function(t){if(e.isNullOrUndefined(this.incStep)?(this.incStep=-1,this.incStep++,this.snapColl=[],this.clearArray=[]):this.incStep++,this.incStep<this.snapColl.length&&(this.snapColl.length=this.incStep),this.incStep>0){var i=this.createElement("canvas",{className:"e-"+this.getModuleName()+"-wrapper"}),s=i.getContext("2d");i.width=this.canvasContext.canvas.width,i.height=this.canvasContext.canvas.height,s.drawImage(this.canvasContext.canvas,0,0,i.width,i.height),this.snapColl.push(i.toDataURL())}else this.snapColl.push(this.canvasContext.canvas.toDataURL());t&&this.clearArray.push(this.incStep)},i.prototype.setBackgroundImage=function(t){var e=this,i=new Image;i.crossOrigin="anonymous",i.src=t,i.onload=function(){e.canvasContext.globalCompositeOperation="source-over",e.canvasContext.drawImage(i,0,0,e.element.width,e.element.height),e.updateSnapCollection(),e.saveBackground(!0)},this.canvasContext.clearRect(0,0,this.canvasContext.canvas.width,this.canvasContext.canvas.height)},i.prototype.setBackgroundColor=function(t){var e=this.canvasContext;e.strokeStyle=t;var i,s;for(i=1;i<=e.canvas.width;i++)for(s=1;s<=e.canvas.height;s++)e.strokeRect(0,0,i,s);this.updateSnapCollection()},i.prototype.loadPersistedSignature=function(){if(!e.isNullOrUndefined(this.signatureValue)){var t=this,i=new Image;i.src=this.signatureValue,i.onload=function(){t.canvasContext.clearRect(0,0,t.element.width,t.element.height),t.canvasContext.drawImage(i,0,0),t.updateSnapCollection()},this.isSignatureEmpty=!1}},i.prototype.getBlob=function(t){for(var e=t.split(","),i=e[0].match(/:(.*?);/)[1],s=atob(e[1]),n=s.length,a=new Uint8Array(n);n--;)a[n]=s.charCodeAt(n);return new Blob([a],{type:i})},i.prototype.download=function(t,e){var i=URL.createObjectURL(t),s=document.createElement("a");s.href=i,s.target="_parent",s.download=e,(document.body||document.documentElement).appendChild(s),s.click(),s.parentNode.removeChild(s)},i.prototype.refresh=function(){this.pointColl=[],this.lastVelocity=0,this.lastWidth=(this.minStrokeWidth+this.maxStrokeWidth)/2},i.prototype.clear=function(){this.canvasContext.clearRect(0,0,this.canvasContext.canvas.width,this.canvasContext.canvas.height),this.refresh(),this.updateSnapCollection(!0),this.isSignatureEmpty=!0,this.isBlazor?this.dotnetRef.invokeMethodAsync("TriggerEventAsync","Clear"):this.trigger("change",{actionName:"clear"})},i.prototype.undo=function(){var t=this;if(this.incStep>0){this.incStep--;var e=new Image;e.src=this.snapColl[this.incStep],e.onload=function(){t.canvasContext.clearRect(0,0,t.element.width,t.element.height),t.canvasContext.drawImage(e,0,0,t.element.width,t.element.height)}}this.isClear(),this.isBlazor?this.dotnetRef.invokeMethodAsync("TriggerEventAsync","Undo"):this.trigger("change",{actionName:"undo"})},i.prototype.redo=function(){var t=this;if(this.incStep<this.snapColl.length-1){this.incStep++;var e=new Image;e.src=this.snapColl[this.incStep],e.onload=function(){t.canvasContext.clearRect(0,0,t.element.width,t.element.height),t.canvasContext.drawImage(e,0,0,t.element.width,t.element.height)}}this.isClear(),this.isBlazor?this.dotnetRef.invokeMethodAsync("TriggerEventAsync","Redo"):this.trigger("change",{actionName:"redo"})},i.prototype.isClear=function(){if(this.clearArray){for(var t=!1,e=0;e<this.clearArray.length;e++)this.clearArray[e]===this.incStep&&(this.isSignatureEmpty=!0,t=!0);t||(this.isSignatureEmpty=!1)}},i.prototype.isEmpty=function(){return this.isSignatureEmpty},i.prototype.canUndo=function(){return this.incStep>0},i.prototype.canRedo=function(){return this.incStep<this.snapColl.length-1},i.prototype.draw=function(t,e,i){this.canvasContext.clearRect(0,0,this.canvasContext.canvas.width,this.canvasContext.canvas.height),e=e||"Arial",i=i||30,this.canvasContext.font=i+"px "+e,this.canvasContext.textAlign="center",this.canvasContext.textBaseline="middle",this.canvasContext.fillText(t,this.element.width/2,this.element.height/2),this.updateSnapCollection(),this.isSignatureEmpty=!1},i.prototype.load=function(t,e,i){i=i||this.element.height,e=e||this.element.width,this.canvasContext.clearRect(0,0,this.canvasContext.canvas.width,this.canvasContext.canvas.height);var s=this,n=new Image;n.src=t,n.onload=function(){Promise.all([createImageBitmap(n,0,0,e,i)]).then(function(t){var n=document.createElement("canvas");n.width=e,n.height=i,n.getContext("2d").drawImage(t[0],0,0),s.canvasContext.drawImage(n,0,0,e,i,0,0,s.element.width,s.element.height),s.updateSnapCollection()})},this.isSignatureEmpty=!1},i.prototype.saveBackground=function(t){var e;if(e=t&&this.backgroundImage?this.snapColl[this.incStep-1]:this.snapColl[this.incStep],t||(this.canvasContext.clearRect(0,0,this.canvasContext.canvas.width,this.canvasContext.canvas.height),this.backgroundImage?this.setBackgroundImage(this.backgroundImage):this.backgroundColor&&(this.setBackgroundColor(this.backgroundColor),t=!0)),t){var i=this,s=new Image;s.crossOrigin="anonymous",s.src=e,s.onload=function(){i.backgroundLoaded=!0,i.canvasContext.globalCompositeOperation="source-over",i.canvasContext.drawImage(s,0,0,i.element.width,i.element.height),i.save(i.fileType,i.fileName)}}},i.prototype.save=function(t,e){if(this.saveWithBackground&&null==this.backgroundLoaded&&(this.backgroundImage||this.backgroundColor))this.backgroundLoaded=!1,this.fileType=t,this.fileName=e,this.saveBackground(!1);else if("Svg"===t)e=e||"Signature",this.toSVG(e);else if("Jpeg"===t)if(e=e||"Signature",!this.saveWithBackground||this.saveWithBackground&&!this.backgroundImage&&!this.backgroundColor)this.toJPEG(e);else{var i=this.canvasContext.canvas.toDataURL("image/jpeg");this.download(this.getBlob(i),e+".jpeg")}else{e=e||"Signature";i=this.canvasContext.canvas.toDataURL("image/png");this.download(this.getBlob(i),e+".png")}this.saveWithBackground&&this.backgroundLoaded&&this.resetSnap()},i.prototype.resetSnap=function(){this.canvasContext.clearRect(0,0,this.canvasContext.canvas.width,this.canvasContext.canvas.height);var t=this,e=new Image;e.src=this.snapColl[this.incStep-1],e.onload=function(){t.canvasContext.drawImage(e,0,0,t.element.width,t.element.height),t.updateSnapCollection()},this.backgroundLoaded=null,this.snapColl.pop(),this.incStep--,this.snapColl.pop(),this.incStep--},i.prototype.toJPEG=function(t){var e=this,i=this.snapColl[this.incStep];this.setBackgroundColor("#ffffff");var s=this,n=new Image;n.crossOrigin="anonymous",n.src=i,n.onload=function(){s.canvasContext.globalCompositeOperation="source-over",s.canvasContext.drawImage(n,0,0,s.element.width,s.element.height);var i=s.canvasContext.canvas.toDataURL("image/jpeg");s.download(s.getBlob(i),t+".jpeg"),s.canvasContext.clearRect(0,0,s.canvasContext.canvas.width,s.canvasContext.canvas.height),e.resizeHandler()},this.snapColl.pop(),this.incStep--},i.prototype.toSVG=function(t){var e=this.canvasContext.canvas.toDataURL(),i=document.createElementNS("http://www.w3.org/2000/svg","svg");i.setAttribute("width",this.canvasContext.canvas.width.toString()),i.setAttribute("height",this.canvasContext.canvas.height.toString());var s=document.createElementNS("http://www.w3.org/2000/svg","image");s.setAttributeNS(null,"height",this.canvasContext.canvas.height.toString()),s.setAttributeNS(null,"width",this.canvasContext.canvas.width.toString()),s.setAttributeNS("http://www.w3.org/1999/xlink","xlink:href",e),i.appendChild(s);var n='<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="'+this.canvasContext.canvas.width+'" height="'+this.canvasContext.canvas.height+'">'+i.innerHTML+"</svg>",a="data:image/svg+xml;base64,"+btoa(n);return null==t?a:(this.download(this.getBlob(a),t+".svg"),null)},i.prototype.saveAsBlob=function(){return this.getBlob(this.canvasContext.canvas.toDataURL("image/png"))},i.prototype.getSignature=function(t){if("Jpeg"===t){for(var e=this.canvasContext.getImageData(0,0,this.element.width,this.element.height),i=e.data,s=0;s<i.length;s+=4)i[s+3]<255&&(i[s]=255-i[s],i[s+1]=255-i[s+1],i[s+2]=255-i[s+2],i[s+3]=255-i[s+3]);this.canvasContext.putImageData(e,0,0);var n=this.canvasContext.canvas.toDataURL("image/jpeg");return this.resizeHandler(),n}return"Svg"===t?this.toSVG(null):this.canvasContext.canvas.toDataURL("image/png")},i.prototype.getModuleName=function(){return"signature"},i.prototype.getPersistData=function(){return this.signatureValue=this.snapColl[this.incStep],this.addOnPersist(["signatureValue"])},i.prototype.destroy=function(){this.unwireEvents(null),e.removeClass([this.element],"e-"+this.getModuleName()),this.element.removeAttribute("tabindex"),this.pointColl=null,t.prototype.destroy.call(this)},i.prototype.propertyChanged=function(t,e){var i=this.canvasContext;switch(t){case"backgroundColor":i.canvas.style.backgroundColor=e,this.backgroundColor=e;break;case"backgroundImage":i.canvas.style.backgroundImage="url("+e+")",this.backgroundImage=e;break;case"strokeColor":i.fillStyle=e,this.strokeColor=e;break;case"saveWithBackground":this.saveWithBackground=e;break;case"maxStrokeWidth":this.maxStrokeWidth=e;break;case"minStrokeWidth":this.minStrokeWidth=e;break;case"velocity":this.velocity=e;break;case"isReadOnly":this.isRead(e);break;case"disabled":this.enableOrDisable(e)}},i}(e.Component),Li=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function s(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),Ai=function(t,e,i,s){var n,a=arguments.length,r=a<3?e:null===s?s=Object.getOwnPropertyDescriptor(e,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(t,e,i,s);else for(var l=t.length-1;l>=0;l--)(n=t[l])&&(r=(a<3?n(r):a>3?n(e,i,r):n(e,i))||r);return a>3&&r&&Object.defineProperty(e,i,r),r},Ni=function(t){function i(e,i){return t.call(this,e,i)||this}return Li(i,t),i.prototype.preRender=function(){},i.prototype.render=function(){this.initialize()},i.prototype.initialize=function(){e.addClass([this.element],"e-"+this.getModuleName()),t.prototype.initialize.call(this,this.element),this.enablePersistence&&this.loadPersistedSignature()},i.prototype.getModuleName=function(){return"signature"},i.prototype.getPersistData=function(){return this.addOnPersist(["signatureValue"])},i.prototype.onPropertyChanged=function(e,i){for(var s=0,n=Object.keys(e);s<n.length;s++){var a=n[s];switch(a){case"backgroundColor":t.prototype.propertyChanged.call(this,a,e.backgroundColor);break;case"backgroundImage":t.prototype.propertyChanged.call(this,a,e.backgroundImage);break;case"strokeColor":e.strokeColor!==i.strokeColor&&t.prototype.propertyChanged.call(this,a,e.strokeColor);break;case"saveWithBackground":t.prototype.propertyChanged.call(this,a,e.saveWithBackground);break;case"isReadOnly":t.prototype.propertyChanged.call(this,a,e.isReadOnly);break;case"disabled":t.prototype.propertyChanged.call(this,a,e.disabled)}}},Ai([e.Property("")],i.prototype,"backgroundColor",void 0),Ai([e.Property("")],i.prototype,"backgroundImage",void 0),Ai([e.Property(!1)],i.prototype,"disabled",void 0),Ai([e.Property(!1)],i.prototype,"isReadOnly",void 0),Ai([e.Property(!0)],i.prototype,"saveWithBackground",void 0),Ai([e.Property("#000000")],i.prototype,"strokeColor",void 0),Ai([e.Property(.5)],i.prototype,"minStrokeWidth",void 0),Ai([e.Property(2)],i.prototype,"maxStrokeWidth",void 0),Ai([e.Property(.7)],i.prototype,"velocity",void 0),Ai([e.Property("en-US")],i.prototype,"locale",void 0),Ai([e.Property(!1)],i.prototype,"enableRtl",void 0),Ai([e.Property(!1)],i.prototype,"enablePersistence",void 0),Ai([e.Event()],i.prototype,"beforeSave",void 0),Ai([e.Event()],i.prototype,"change",void 0),Ai([e.Event()],i.prototype,"created",void 0),i=Ai([e.NotifyPropertyChanges],i)}(Ti);t.NumericTextBox=Y,t.regularExpressions=it,t.createMask=n,t.applyMask=a,t.wireEvents=r,t.unwireEvents=l,t.bindClearEvent=o,t.unstrippedValue=c,t.strippedValue=u,t.maskInputMouseDownHandler=m,t.maskInputMouseUpHandler=v,t.maskInputFocusHandler=f,t.triggerFocus=g,t.maskInputBlurHandler=y,t.maskInputDropHandler=E,t.mobileRemoveFunction=k,t.setMaskValue=R,t.setElementValue=V,t.maskInput=function(t){var e=F(t);a.call(e);var i=u.call(this,this.element);this.prevValue=i,this.value=i,t.mask&&(l.call(e),r.call(e))},t.getVal=function(t){return u.call(M(t),t.element)},t.getMaskedVal=function(t){return c.call(M(t),t.element)},t.MaskUndo=st,t.MaskedTextBox=ot,t.TicksData=ct,t.ColorRangeData=ut,t.LimitData=pt,t.TooltipData=mt,t.Slider=ge,t.regex=Ce,t.FormValidator=Ee,t.FilesProp=Ke,t.ButtonsProps=Ze,t.AsyncSettings=Ye,t.Uploader=Ge,t.ColorPicker=Ei,t.TextBox=Pi,t.Signature=Ni,t.SignatureBase=Ti,Object.defineProperty(t,"__esModule",{value:!0})});
	//# sourceMappingURL=ej2-inputs.umd.min.js.map


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/checkmark.b8187469.9504d7ec.svg";

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(143);
	var setInnerHTML = __webpack_require__(111);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(151);
	var setTextContent = __webpack_require__(386);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var invariant = __webpack_require__(11);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(711);
	var ReactInstrumentation = __webpack_require__(34);
	
	var warning = __webpack_require__(15);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var Parser = __webpack_require__(397);
	var DomHandler = __webpack_require__(394);
	
	function defineProp(name, value) {
	    delete module.exports[name];
	    module.exports[name] = value;
	    return value;
	}
	
	module.exports = {
	    Parser: Parser,
	    Tokenizer: __webpack_require__(398),
	    ElementType: __webpack_require__(83),
	    DomHandler: DomHandler,
	    get FeedHandler() {
	        return defineProp("FeedHandler", __webpack_require__(764));
	    },
	    get Stream() {
	        return defineProp("Stream", __webpack_require__(766));
	    },
	    get WritableStream() {
	        return defineProp("WritableStream", __webpack_require__(399));
	    },
	    get ProxyHandler() {
	        return defineProp("ProxyHandler", __webpack_require__(765));
	    },
	    get DomUtils() {
	        return defineProp("DomUtils", __webpack_require__(396));
	    },
	    get CollectingHandler() {
	        return defineProp(
	            "CollectingHandler",
	            __webpack_require__(763)
	        );
	    },
	    // For legacy support
	    DefaultHandler: DomHandler,
	    get RssHandler() {
	        return defineProp("RssHandler", this.FeedHandler);
	    },
	    //helper methods
	    parseDOM: function(data, options) {
	        var handler = new DomHandler(options);
	        new Parser(handler, options).end(data);
	        return handler.dom;
	    },
	    parseFeed: function(feed, options) {
	        var handler = new module.exports.FeedHandler(options);
	        new Parser(handler, options).end(feed);
	        return handler.dom;
	    },
	    createDomStream: function(cb, options, elementCb) {
	        var handler = new DomHandler(cb, options, elementCb);
	        return new Parser(handler, options);
	    },
	    // List of all events that the parser emits
	    EVENTS: {
	        /* Format: eventname: number of arguments */
	        attribute: 2,
	        cdatastart: 0,
	        cdataend: 0,
	        text: 1,
	        processinginstruction: 2,
	        comment: 1,
	        commentend: 0,
	        closetag: 1,
	        opentag: 2,
	        opentagname: 1,
	        error: 1,
	        end: 0
	    }
	};


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var ReactBaseClasses = __webpack_require__(405);
	var ReactChildren = __webpack_require__(799);
	var ReactDOMFactories = __webpack_require__(800);
	var ReactElement = __webpack_require__(66);
	var ReactPropTypes = __webpack_require__(801);
	var ReactVersion = __webpack_require__(802);
	
	var createReactClass = __webpack_require__(803);
	var onlyChild = __webpack_require__(807);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var ReactCurrentOwner = __webpack_require__(44);
	
	var warning = __webpack_require__(15);
	var canDefineProperty = __webpack_require__(409);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(407);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Index_1 = __webpack_require__(88);
	var Node_1 = __webpack_require__(30);
	var util_1 = __webpack_require__(13);
	var util_2 = __webpack_require__(2);
	var __EMPTY_NODE;
	var KeyIndex = /** @class */ (function (_super) {
	    __extends(KeyIndex, _super);
	    function KeyIndex() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Object.defineProperty(KeyIndex, "__EMPTY_NODE", {
	        get: function () {
	            return __EMPTY_NODE;
	        },
	        set: function (val) {
	            __EMPTY_NODE = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.compare = function (a, b) {
	        return util_1.nameCompare(a.name, b.name);
	    };
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.isDefinedOn = function (node) {
	        // We could probably return true here (since every node has a key), but it's never called
	        // so just leaving unimplemented for now.
	        throw util_2.assertionError('KeyIndex.isDefinedOn not expected to be called.');
	    };
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
	        return false; // The key for a node never changes.
	    };
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.minPost = function () {
	        return Node_1.NamedNode.MIN;
	    };
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.maxPost = function () {
	        // TODO: This should really be created once and cached in a static property, but
	        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
	        return new Node_1.NamedNode(util_1.MAX_NAME, __EMPTY_NODE);
	    };
	    /**
	     * @param {*} indexValue
	     * @param {string} name
	     * @return {!NamedNode}
	     */
	    KeyIndex.prototype.makePost = function (indexValue, name) {
	        util_2.assert(typeof indexValue === 'string', 'KeyIndex indexValue must always be a string.');
	        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
	        return new Node_1.NamedNode(indexValue, __EMPTY_NODE);
	    };
	    /**
	     * @return {!string} String representation for inclusion in a query spec
	     */
	    KeyIndex.prototype.toString = function () {
	        return '.key';
	    };
	    return KeyIndex;
	}(Index_1.Index));
	exports.KeyIndex = KeyIndex;
	exports.KEY_INDEX = new KeyIndex();
	
	//# sourceMappingURL=KeyIndex.js.map


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ChildrenNode_1 = __webpack_require__(28);
	var LeafNode_1 = __webpack_require__(87);
	var Node_1 = __webpack_require__(30);
	var util_1 = __webpack_require__(2);
	var util_2 = __webpack_require__(2);
	var childSet_1 = __webpack_require__(174);
	var comparators_1 = __webpack_require__(175);
	var IndexMap_1 = __webpack_require__(173);
	var PriorityIndex_1 = __webpack_require__(26);
	var USE_HINZE = true;
	/**
	 * Constructs a snapshot node representing the passed JSON and returns it.
	 * @param {*} json JSON to create a node for.
	 * @param {?string|?number=} priority Optional priority to use.  This will be ignored if the
	 * passed JSON contains a .priority property.
	 * @return {!Node}
	 */
	function nodeFromJSON(json, priority) {
	    if (priority === void 0) { priority = null; }
	    if (json === null) {
	        return ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	    }
	    if (typeof json === 'object' && '.priority' in json) {
	        priority = json['.priority'];
	    }
	    util_2.assert(priority === null ||
	        typeof priority === 'string' ||
	        typeof priority === 'number' ||
	        (typeof priority === 'object' && '.sv' in priority), 'Invalid priority type found: ' + typeof priority);
	    if (typeof json === 'object' && '.value' in json && json['.value'] !== null) {
	        json = json['.value'];
	    }
	    // Valid leaf nodes include non-objects or server-value wrapper objects
	    if (typeof json !== 'object' || '.sv' in json) {
	        var jsonLeaf = json;
	        return new LeafNode_1.LeafNode(jsonLeaf, nodeFromJSON(priority));
	    }
	    if (!(json instanceof Array) && USE_HINZE) {
	        var children_1 = [];
	        var childrenHavePriority_1 = false;
	        var hinzeJsonObj_1 = json;
	        util_1.forEach(hinzeJsonObj_1, function (key, child) {
	            if (typeof key !== 'string' || key.substring(0, 1) !== '.') {
	                // Ignore metadata nodes
	                var childNode = nodeFromJSON(hinzeJsonObj_1[key]);
	                if (!childNode.isEmpty()) {
	                    childrenHavePriority_1 =
	                        childrenHavePriority_1 || !childNode.getPriority().isEmpty();
	                    children_1.push(new Node_1.NamedNode(key, childNode));
	                }
	            }
	        });
	        if (children_1.length == 0) {
	            return ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	        }
	        var childSet = childSet_1.buildChildSet(children_1, comparators_1.NAME_ONLY_COMPARATOR, function (namedNode) { return namedNode.name; }, comparators_1.NAME_COMPARATOR);
	        if (childrenHavePriority_1) {
	            var sortedChildSet = childSet_1.buildChildSet(children_1, PriorityIndex_1.PRIORITY_INDEX.getCompare());
	            return new ChildrenNode_1.ChildrenNode(childSet, nodeFromJSON(priority), new IndexMap_1.IndexMap({ '.priority': sortedChildSet }, { '.priority': PriorityIndex_1.PRIORITY_INDEX }));
	        }
	        else {
	            return new ChildrenNode_1.ChildrenNode(childSet, nodeFromJSON(priority), IndexMap_1.IndexMap.Default);
	        }
	    }
	    else {
	        var node_1 = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	        var jsonObj_1 = json;
	        util_1.forEach(jsonObj_1, function (key, childData) {
	            if (util_1.contains(jsonObj_1, key)) {
	                if (key.substring(0, 1) !== '.') {
	                    // ignore metadata nodes.
	                    var childNode = nodeFromJSON(childData);
	                    if (childNode.isLeafNode() || !childNode.isEmpty())
	                        node_1 = node_1.updateImmediateChild(key, childNode);
	                }
	            }
	        });
	        return node_1.updatePriority(nodeFromJSON(priority));
	    }
	}
	exports.nodeFromJSON = nodeFromJSON;
	PriorityIndex_1.setNodeFromJSON(nodeFromJSON);
	
	//# sourceMappingURL=nodeFromJSON.js.map


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var snapshot_version_1 = __webpack_require__(31);
	var platform_1 = __webpack_require__(40);
	/** An enumeration of the different purposes we have for queries. */
	var QueryPurpose;
	(function (QueryPurpose) {
	    /** A regular, normal query. */
	    QueryPurpose[QueryPurpose["Listen"] = 0] = "Listen";
	    /**
	     * The query was used to refill a query after an existence filter mismatch.
	     */
	    QueryPurpose[QueryPurpose["ExistenceFilterMismatch"] = 1] = "ExistenceFilterMismatch";
	    /** The query was used to resolve a limbo document. */
	    QueryPurpose[QueryPurpose["LimboResolution"] = 2] = "LimboResolution";
	})(QueryPurpose = exports.QueryPurpose || (exports.QueryPurpose = {}));
	/**
	 * An immutable set of metadata that the local store tracks for each query.
	 */
	var QueryData = /** @class */ (function () {
	    function QueryData(
	        /** The query being listened to. */
	        query, 
	        /**
	         * The target ID to which the query corresponds; Assigned by the
	         * LocalStore for user listens and by the SyncEngine for limbo watches.
	         */
	        targetId, 
	        /** The purpose of the query. */
	        purpose, 
	        /** The latest snapshot version seen for this target. */
	        snapshotVersion, 
	        /**
	         * An opaque, server-assigned token that allows watching a query to be
	         * resumed after disconnecting without retransmitting all the data that
	         * matches the query. The resume token essentially identifies a point in
	         * time from which the server should resume sending results.
	         */
	        resumeToken) {
	        if (snapshotVersion === void 0) { snapshotVersion = snapshot_version_1.SnapshotVersion.MIN; }
	        if (resumeToken === void 0) { resumeToken = platform_1.emptyByteString(); }
	        this.query = query;
	        this.targetId = targetId;
	        this.purpose = purpose;
	        this.snapshotVersion = snapshotVersion;
	        this.resumeToken = resumeToken;
	    }
	    /**
	     * Creates a new query data instance with an updated snapshot version and
	     * resume token.
	     */
	    QueryData.prototype.update = function (updated) {
	        return new QueryData(this.query, this.targetId, this.purpose, updated.snapshotVersion, updated.resumeToken);
	    };
	    QueryData.prototype.equals = function (other) {
	        return (this.targetId === other.targetId &&
	            this.purpose === other.purpose &&
	            this.snapshotVersion.equals(other.snapshotVersion) &&
	            this.resumeToken === other.resumeToken &&
	            this.query.equals(other.query));
	    };
	    return QueryData;
	}());
	exports.QueryData = QueryData;
	
	//# sourceMappingURL=query_data.js.map


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var collections_1 = __webpack_require__(20);
	var assert_1 = __webpack_require__(10);
	var misc = __webpack_require__(25);
	exports.BATCHID_UNKNOWN = -1;
	/**
	 * A batch of mutations that will be sent as one unit to the backend.
	 */
	var MutationBatch = /** @class */ (function () {
	    function MutationBatch(batchId, localWriteTime, mutations) {
	        this.batchId = batchId;
	        this.localWriteTime = localWriteTime;
	        this.mutations = mutations;
	    }
	    /**
	     * Applies all the mutations in this MutationBatch to the specified document
	     * to create a new remote document
	     *
	     * @param docKey The key of the document to apply mutations to.
	     * @param maybeDoc The document to apply mutations to.
	     * @param batchResult The result of applying the MutationBatch to the
	     * backend.
	     */
	    MutationBatch.prototype.applyToRemoteDocument = function (docKey, maybeDoc, batchResult) {
	        if (maybeDoc) {
	            assert_1.assert(maybeDoc.key.equals(docKey), "applyToRemoteDocument: key " + docKey + " should match maybeDoc key\n        " + maybeDoc.key);
	        }
	        var mutationResults = batchResult.mutationResults;
	        assert_1.assert(mutationResults.length === this.mutations.length, "Mismatch between mutations length\n      (" + this.mutations.length + ") and mutation results length\n      (" + mutationResults.length + ").");
	        for (var i = 0; i < this.mutations.length; i++) {
	            var mutation = this.mutations[i];
	            if (mutation.key.equals(docKey)) {
	                var mutationResult = mutationResults[i];
	                maybeDoc = mutation.applyToRemoteDocument(maybeDoc, mutationResult);
	            }
	        }
	        return maybeDoc;
	    };
	    /**
	     * Computes the local view of a document given all the mutations in this
	     * batch.
	     *
	     * @param docKey The key of the document to apply mutations to.
	     * @param maybeDoc The document to apply mutations to.
	     */
	    MutationBatch.prototype.applyToLocalView = function (docKey, maybeDoc) {
	        if (maybeDoc) {
	            assert_1.assert(maybeDoc.key.equals(docKey), "applyToLocalDocument: key " + docKey + " should match maybeDoc key\n        " + maybeDoc.key);
	        }
	        for (var i = 0; i < this.mutations.length; i++) {
	            var mutation = this.mutations[i];
	            if (mutation.key.equals(docKey)) {
	                maybeDoc = mutation.applyToLocalView(maybeDoc, this.localWriteTime);
	            }
	        }
	        return maybeDoc;
	    };
	    MutationBatch.prototype.keys = function () {
	        var keySet = collections_1.documentKeySet();
	        for (var _i = 0, _a = this.mutations; _i < _a.length; _i++) {
	            var mutation = _a[_i];
	            keySet = keySet.add(mutation.key);
	        }
	        return keySet;
	    };
	    MutationBatch.prototype.equals = function (other) {
	        return (this.batchId === other.batchId &&
	            misc.arrayEquals(this.mutations, other.mutations));
	    };
	    /**
	     * Returns true if this mutation batch has already been removed from the
	     * mutation queue.
	     *
	     * Note that not all implementations of the MutationQueue necessarily use
	     * tombstones as part of their implementation and generally speaking no code
	     * outside the mutation queues should really care about this.
	     */
	    MutationBatch.prototype.isTombstone = function () {
	        return this.mutations.length === 0;
	    };
	    /** Converts this batch into a tombstone */
	    MutationBatch.prototype.toTombstone = function () {
	        return new MutationBatch(this.batchId, this.localWriteTime, []);
	    };
	    return MutationBatch;
	}());
	exports.MutationBatch = MutationBatch;
	/** The result of applying a mutation batch to the backend. */
	var MutationBatchResult = /** @class */ (function () {
	    function MutationBatchResult(batch, commitVersion, mutationResults, streamToken, 
	        /**
	         * A pre-computed mapping from each mutated document to the resulting
	         * version.
	         */
	        docVersions) {
	        this.batch = batch;
	        this.commitVersion = commitVersion;
	        this.mutationResults = mutationResults;
	        this.streamToken = streamToken;
	        this.docVersions = docVersions;
	    }
	    /**
	     * Creates a new MutationBatchResult for the given batch and results. There
	     * must be one result for each mutation in the batch. This static factory
	     * caches a document=>version mapping (docVersions).
	     */
	    MutationBatchResult.from = function (batch, commitVersion, results, streamToken) {
	        assert_1.assert(batch.mutations.length === results.length, 'Mutations sent ' +
	            batch.mutations.length +
	            ' must equal results received ' +
	            results.length);
	        var versionMap = collections_1.documentVersionMap();
	        var mutations = batch.mutations;
	        for (var i = 0; i < mutations.length; i++) {
	            var version = results[i].version;
	            if (version === null) {
	                // deletes don't have a version, so we substitute the commitVersion
	                // of the entire batch.
	                version = commitVersion;
	            }
	            versionMap = versionMap.insert(mutations[i].key, version);
	        }
	        return new MutationBatchResult(batch, commitVersion, results, streamToken, versionMap);
	    };
	    return MutationBatchResult;
	}());
	exports.MutationBatchResult = MutationBatchResult;
	
	//# sourceMappingURL=mutation_batch.js.map


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var snapshot_version_1 = __webpack_require__(31);
	var collections_1 = __webpack_require__(20);
	var platform_1 = __webpack_require__(40);
	/**
	 * An event from the RemoteStore. It is split into targetChanges (changes to the
	 * state or the set of documents in our watched targets) and documentUpdates
	 * (changes to the actual documents).
	 */
	var RemoteEvent = /** @class */ (function () {
	    function RemoteEvent(
	        /**
	         * The snapshot version this event brings us up to, or MIN if not set.
	         */
	        snapshotVersion, 
	        /**
	         * A map from target to changes to the target. See TargetChange.
	         */
	        targetChanges, 
	        /**
	         * A set of which documents have changed or been deleted, along with the
	         * doc's new values (if not deleted).
	         */
	        documentUpdates) {
	        this.snapshotVersion = snapshotVersion;
	        this.targetChanges = targetChanges;
	        this.documentUpdates = documentUpdates;
	    }
	    RemoteEvent.prototype.addDocumentUpdate = function (doc) {
	        this.documentUpdates = this.documentUpdates.insert(doc.key, doc);
	    };
	    RemoteEvent.prototype.handleExistenceFilterMismatch = function (targetId) {
	        /*
	         * An existence filter mismatch will reset the query and we need to reset
	         * the mapping to contain no documents and an empty resume token.
	         *
	         * Note:
	         *   * The reset mapping is empty, specifically forcing the consumer of the
	         *     change to forget all keys for this targetID;
	         *   * The resume snapshot for this target must be reset
	         *   * The target must be unacked because unwatching and rewatching
	         *     introduces a race for changes.
	         */
	        this.targetChanges[targetId] = {
	            mapping: new ResetMapping(),
	            snapshotVersion: snapshot_version_1.SnapshotVersion.MIN,
	            currentStatusUpdate: CurrentStatusUpdate.MarkNotCurrent,
	            resumeToken: platform_1.emptyByteString()
	        };
	    };
	    return RemoteEvent;
	}());
	exports.RemoteEvent = RemoteEvent;
	/**
	 * Represents an update to the current status of a target, either explicitly
	 * having no new state, or the new value to set. Note "current" has special
	 * meaning for in the RPC protocol that implies that a target is both up-to-date
	 * and consistent with the rest of the watch stream.
	 */
	var CurrentStatusUpdate;
	(function (CurrentStatusUpdate) {
	    /** The current status is not affected and should not be modified. */
	    CurrentStatusUpdate[CurrentStatusUpdate["None"] = 0] = "None";
	    /** The target must be marked as no longer "current". */
	    CurrentStatusUpdate[CurrentStatusUpdate["MarkNotCurrent"] = 1] = "MarkNotCurrent";
	    /** The target must be marked as "current". */
	    CurrentStatusUpdate[CurrentStatusUpdate["MarkCurrent"] = 2] = "MarkCurrent";
	})(CurrentStatusUpdate = exports.CurrentStatusUpdate || (exports.CurrentStatusUpdate = {}));
	var EMPTY_KEY_SET = collections_1.documentKeySet();
	var ResetMapping = /** @class */ (function () {
	    function ResetMapping() {
	        this.docs = EMPTY_KEY_SET;
	    }
	    Object.defineProperty(ResetMapping.prototype, "documents", {
	        get: function () {
	            return this.docs;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ResetMapping.prototype.add = function (key) {
	        this.docs = this.docs.add(key);
	    };
	    ResetMapping.prototype.delete = function (key) {
	        this.docs = this.docs.delete(key);
	    };
	    ResetMapping.prototype.equals = function (other) {
	        return other !== null && this.docs.equals(other.docs);
	    };
	    return ResetMapping;
	}());
	exports.ResetMapping = ResetMapping;
	var UpdateMapping = /** @class */ (function () {
	    function UpdateMapping() {
	        this.addedDocuments = EMPTY_KEY_SET;
	        this.removedDocuments = EMPTY_KEY_SET;
	    }
	    UpdateMapping.prototype.applyToKeySet = function (keys) {
	        var result = keys;
	        this.addedDocuments.forEach(function (key) { return (result = result.add(key)); });
	        this.removedDocuments.forEach(function (key) { return (result = result.delete(key)); });
	        return result;
	    };
	    UpdateMapping.prototype.add = function (key) {
	        this.addedDocuments = this.addedDocuments.add(key);
	        this.removedDocuments = this.removedDocuments.delete(key);
	    };
	    UpdateMapping.prototype.delete = function (key) {
	        this.addedDocuments = this.addedDocuments.delete(key);
	        this.removedDocuments = this.removedDocuments.add(key);
	    };
	    UpdateMapping.prototype.equals = function (other) {
	        return (other !== null &&
	            this.addedDocuments.equals(other.addedDocuments) &&
	            this.removedDocuments.equals(other.removedDocuments));
	    };
	    return UpdateMapping;
	}());
	exports.UpdateMapping = UpdateMapping;
	
	//# sourceMappingURL=remote_event.js.map


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(10);
	var error_1 = __webpack_require__(19);
	var obj = __webpack_require__(36);
	/**
	 * Validates the invocation of functionName has the exact number of arguments.
	 *
	 * Forward the magic "arguments" variable as second parameter on which the
	 * parameter validation is performed:
	 * validateExactNumberOfArgs('myFunction', arguments, 2);
	 */
	function validateExactNumberOfArgs(functionName, args, numberOfArgs) {
	    if (args.length !== numberOfArgs) {
	        throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function " + functionName + "() requires " +
	            formatPlural(numberOfArgs, 'argument') +
	            ', but was called with ' +
	            formatPlural(args.length, 'argument') +
	            '.');
	    }
	}
	exports.validateExactNumberOfArgs = validateExactNumberOfArgs;
	/**
	 * Validates the invocation of functionName has at least the provided number of
	 * arguments (but can have many more).
	 *
	 * Forward the magic "arguments" variable as second parameter on which the
	 * parameter validation is performed:
	 * validateAtLeastNumberOfArgs('myFunction', arguments, 2);
	 */
	function validateAtLeastNumberOfArgs(functionName, args, minNumberOfArgs) {
	    if (args.length < minNumberOfArgs) {
	        throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function " + functionName + "() requires at least " +
	            formatPlural(minNumberOfArgs, 'argument') +
	            ', but was called with ' +
	            formatPlural(args.length, 'argument') +
	            '.');
	    }
	}
	exports.validateAtLeastNumberOfArgs = validateAtLeastNumberOfArgs;
	/**
	 * Validates the invocation of functionName has number of arguments between
	 * the values provided.
	 *
	 * Forward the magic "arguments" variable as second parameter on which the
	 * parameter validation is performed:
	 * validateBetweenNumberOfArgs('myFunction', arguments, 2, 3);
	 */
	function validateBetweenNumberOfArgs(functionName, args, minNumberOfArgs, maxNumberOfArgs) {
	    if (args.length < minNumberOfArgs || args.length > maxNumberOfArgs) {
	        throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function " + functionName + "() requires between " + minNumberOfArgs + " and " +
	            (maxNumberOfArgs + " arguments, but was called with ") +
	            formatPlural(args.length, 'argument') +
	            '.');
	    }
	}
	exports.validateBetweenNumberOfArgs = validateBetweenNumberOfArgs;
	/**
	 * Validates the provided argument is an array and has as least the expected
	 * number of elements.
	 */
	function validateNamedArrayAtLeastNumberOfElements(functionName, value, name, minNumberOfElements) {
	    if (!(value instanceof Array) || value.length < minNumberOfElements) {
	        throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + name + " argument to be an " +
	            'array with at least ' +
	            (formatPlural(minNumberOfElements, 'element') + "."));
	    }
	}
	exports.validateNamedArrayAtLeastNumberOfElements = validateNamedArrayAtLeastNumberOfElements;
	/**
	 * Validates the provided positional argument has the native JavaScript type
	 * using typeof checks.
	 */
	function validateArgType(functionName, type, position, argument) {
	    validateType(functionName, type, ordinal(position) + " argument", argument);
	}
	exports.validateArgType = validateArgType;
	/**
	 * Validates the provided argument has the native JavaScript type using
	 * typeof checks or is undefined.
	 */
	function validateOptionalArgType(functionName, type, position, argument) {
	    if (argument !== undefined) {
	        validateArgType(functionName, type, position, argument);
	    }
	}
	exports.validateOptionalArgType = validateOptionalArgType;
	/**
	 * Validates the provided named option has the native JavaScript type using
	 * typeof checks.
	 */
	function validateNamedType(functionName, type, optionName, argument) {
	    validateType(functionName, type, optionName + " option", argument);
	}
	exports.validateNamedType = validateNamedType;
	/**
	 * Validates the provided named option has the native JavaScript type using
	 * typeof checks or is undefined.
	 */
	function validateNamedOptionalType(functionName, type, optionName, argument) {
	    if (argument !== undefined) {
	        validateNamedType(functionName, type, optionName, argument);
	    }
	}
	exports.validateNamedOptionalType = validateNamedOptionalType;
	/** Helper to validate the type of a provided input. */
	function validateType(functionName, type, inputName, input) {
	    if (typeof input !== type || (type === 'object' && !isPlainObject(input))) {
	        var description = valueDescription(input);
	        throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + inputName + " " +
	            ("to be of type " + type + ", but it was: " + description));
	    }
	}
	/**
	 * Returns true iff it's a non-null object without a custom prototype
	 * (i.e. excludes Array, Date, etc.).
	 */
	function isPlainObject(input) {
	    return (typeof input === 'object' &&
	        input !== null &&
	        Object.getPrototypeOf(input) === Object.prototype);
	}
	exports.isPlainObject = isPlainObject;
	/** Returns a string describing the type / value of the provided input. */
	function valueDescription(input) {
	    if (input === undefined) {
	        return 'undefined';
	    }
	    else if (input === null) {
	        return 'null';
	    }
	    else if (typeof input === 'string') {
	        if (input.length > 20) {
	            input = input.substring(0, 20) + "...";
	        }
	        return JSON.stringify(input);
	    }
	    else if (typeof input === 'number' || typeof input === 'boolean') {
	        return '' + input;
	    }
	    else if (typeof input === 'object') {
	        if (input instanceof Array) {
	            return 'an array';
	        }
	        else {
	            var customObjectName = tryGetCustomObjectType(input);
	            if (customObjectName) {
	                return "a custom " + customObjectName + " object";
	            }
	            else {
	                return 'an object';
	            }
	        }
	    }
	    else if (typeof input === 'function') {
	        return 'a function';
	    }
	    else {
	        return assert_1.fail('Unknown wrong type: ' + typeof input);
	    }
	}
	exports.valueDescription = valueDescription;
	/** Hacky method to try to get the constructor name for an object. */
	function tryGetCustomObjectType(input) {
	    if (input.constructor) {
	        var funcNameRegex = /function\s+([^\s(]+)\s*\(/;
	        var results = funcNameRegex.exec(input.constructor.toString());
	        if (results && results.length > 1) {
	            return results[1];
	        }
	    }
	    return null;
	}
	exports.tryGetCustomObjectType = tryGetCustomObjectType;
	/** Validates the provided argument is defined. */
	function validateDefined(functionName, position, argument) {
	    if (argument === undefined) {
	        throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function " + functionName + "() requires a valid " + ordinal(position) + " " +
	            "argument, but it was undefined.");
	    }
	}
	exports.validateDefined = validateDefined;
	/**
	 * Validates the provided positional argument is an object, and its keys and
	 * values match the expected keys and types provided in optionTypes.
	 */
	function validateOptionNames(functionName, options, optionNames) {
	    obj.forEach(options, function (key, _) {
	        if (optionNames.indexOf(key) < 0) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Unknown option '" + key + "' passed to function " + functionName + "(). " +
	                'Available options: ' +
	                optionNames.join(', '));
	        }
	    });
	}
	exports.validateOptionNames = validateOptionNames;
	/**
	 * Helper method to throw an error that the provided argument did not pass
	 * an instanceof check.
	 */
	function invalidClassError(functionName, type, position, argument) {
	    var description = valueDescription(argument);
	    return new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + ordinal(position) + " " +
	        ("argument to be a " + type + ", but it was: " + description));
	}
	exports.invalidClassError = invalidClassError;
	/** Converts a number to its english word representation */
	function ordinal(num) {
	    switch (num) {
	        case 1:
	            return 'first';
	        case 2:
	            return 'second';
	        case 3:
	            return 'third';
	        default:
	            return num + 'th';
	    }
	}
	/**
	 * Formats the given word as plural conditionally given the preceding number.
	 */
	function formatPlural(num, str) {
	    return num + " " + str + (num === 1 ? '' : 's');
	}
	
	//# sourceMappingURL=input_validation.js.map


/***/ },
/* 73 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// Untyped Number alias we can use to check for ES6 methods / properties.
	// tslint:disable-next-line:no-any variable-name
	var NumberAsAny = Number;
	/**
	 * Minimum safe integer in Javascript because of floating point precision.
	 * Added to not rely on ES6 features.
	 */
	exports.MIN_SAFE_INTEGER = NumberAsAny.MIN_SAFE_INTEGER || -(Math.pow(2, 53) - 1);
	/**
	 * Maximum safe integer in Javascript because of floating point precision.
	 * Added to not rely on ES6 features.
	 */
	exports.MAX_SAFE_INTEGER = NumberAsAny.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
	/**
	 * Returns whether an number is an integer, uses native implementation if
	 * available.
	 * Added to not rely on ES6 features.
	 * @param value The value to test for being an integer
	 */
	exports.isInteger = NumberAsAny.isInteger ||
	    (function (value) {
	        return typeof value === 'number' &&
	            isFinite(value) &&
	            Math.floor(value) === value;
	    });
	/**
	 * Returns whether a variable is either undefined or null.
	 */
	function isNullOrUndefined(value) {
	    return value === null || value === undefined;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	/**
	 * Returns whether a value is an integer and in the safe integer range
	 * @param value The value to test for being an integer and in the safe range
	 */
	function isSafeInteger(value) {
	    return (exports.isInteger(value) &&
	        value <= exports.MAX_SAFE_INTEGER &&
	        value >= exports.MIN_SAFE_INTEGER);
	}
	exports.isSafeInteger = isSafeInteger;
	/**
	 * Safely checks if the number is NaN.
	 */
	function safeIsNaN(value) {
	    if (NumberAsAny.IsNaN) {
	        return NumberAsAny.IsNaN(value);
	    }
	    else {
	        return typeof value === 'number' && isNaN(value);
	    }
	}
	exports.safeIsNaN = safeIsNaN;
	
	//# sourceMappingURL=types.js.map


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var errorsExports = __webpack_require__(41);
	exports.StringFormat = {
	    RAW: 'raw',
	    BASE64: 'base64',
	    BASE64URL: 'base64url',
	    DATA_URL: 'data_url'
	};
	function formatValidator(stringFormat) {
	    switch (stringFormat) {
	        case exports.StringFormat.RAW:
	        case exports.StringFormat.BASE64:
	        case exports.StringFormat.BASE64URL:
	        case exports.StringFormat.DATA_URL:
	            return;
	        default:
	            throw 'Expected one of the event types: [' +
	                exports.StringFormat.RAW +
	                ', ' +
	                exports.StringFormat.BASE64 +
	                ', ' +
	                exports.StringFormat.BASE64URL +
	                ', ' +
	                exports.StringFormat.DATA_URL +
	                '].';
	    }
	}
	exports.formatValidator = formatValidator;
	/**
	 * @struct
	 */
	var StringData = /** @class */ (function () {
	    function StringData(data, opt_contentType) {
	        this.data = data;
	        this.contentType = opt_contentType || null;
	    }
	    return StringData;
	}());
	exports.StringData = StringData;
	function dataFromString(format, string) {
	    switch (format) {
	        case exports.StringFormat.RAW:
	            return new StringData(utf8Bytes_(string));
	        case exports.StringFormat.BASE64:
	        case exports.StringFormat.BASE64URL:
	            return new StringData(base64Bytes_(format, string));
	        case exports.StringFormat.DATA_URL:
	            return new StringData(dataURLBytes_(string), dataURLContentType_(string));
	    }
	    // assert(false);
	    throw errorsExports.unknown();
	}
	exports.dataFromString = dataFromString;
	function utf8Bytes_(string) {
	    var b = [];
	    for (var i = 0; i < string.length; i++) {
	        var c = string.charCodeAt(i);
	        if (c <= 127) {
	            b.push(c);
	        }
	        else {
	            if (c <= 2047) {
	                b.push(192 | (c >> 6), 128 | (c & 63));
	            }
	            else {
	                if ((c & 64512) == 55296) {
	                    // The start of a surrogate pair.
	                    var valid = i < string.length - 1 &&
	                        (string.charCodeAt(i + 1) & 64512) == 56320;
	                    if (!valid) {
	                        // The second surrogate wasn't there.
	                        b.push(239, 191, 189);
	                    }
	                    else {
	                        var hi = c;
	                        var lo = string.charCodeAt(++i);
	                        c = 65536 | ((hi & 1023) << 10) | (lo & 1023);
	                        b.push(240 | (c >> 18), 128 | ((c >> 12) & 63), 128 | ((c >> 6) & 63), 128 | (c & 63));
	                    }
	                }
	                else {
	                    if ((c & 64512) == 56320) {
	                        // Invalid low surrogate.
	                        b.push(239, 191, 189);
	                    }
	                    else {
	                        b.push(224 | (c >> 12), 128 | ((c >> 6) & 63), 128 | (c & 63));
	                    }
	                }
	            }
	        }
	    }
	    return new Uint8Array(b);
	}
	exports.utf8Bytes_ = utf8Bytes_;
	function percentEncodedBytes_(string) {
	    var decoded;
	    try {
	        decoded = decodeURIComponent(string);
	    }
	    catch (e) {
	        throw errorsExports.invalidFormat(exports.StringFormat.DATA_URL, 'Malformed data URL.');
	    }
	    return utf8Bytes_(decoded);
	}
	exports.percentEncodedBytes_ = percentEncodedBytes_;
	function base64Bytes_(format, string) {
	    switch (format) {
	        case exports.StringFormat.BASE64: {
	            var hasMinus = string.indexOf('-') !== -1;
	            var hasUnder = string.indexOf('_') !== -1;
	            if (hasMinus || hasUnder) {
	                var invalidChar = hasMinus ? '-' : '_';
	                throw errorsExports.invalidFormat(format, "Invalid character '" +
	                    invalidChar +
	                    "' found: is it base64url encoded?");
	            }
	            break;
	        }
	        case exports.StringFormat.BASE64URL: {
	            var hasPlus = string.indexOf('+') !== -1;
	            var hasSlash = string.indexOf('/') !== -1;
	            if (hasPlus || hasSlash) {
	                var invalidChar = hasPlus ? '+' : '/';
	                throw errorsExports.invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
	            }
	            string = string.replace(/-/g, '+').replace(/_/g, '/');
	            break;
	        }
	    }
	    var bytes;
	    try {
	        bytes = atob(string);
	    }
	    catch (e) {
	        throw errorsExports.invalidFormat(format, 'Invalid character found');
	    }
	    var array = new Uint8Array(bytes.length);
	    for (var i = 0; i < bytes.length; i++) {
	        array[i] = bytes.charCodeAt(i);
	    }
	    return array;
	}
	exports.base64Bytes_ = base64Bytes_;
	/**
	 * @struct
	 */
	var DataURLParts = /** @class */ (function () {
	    function DataURLParts(dataURL) {
	        this.base64 = false;
	        this.contentType = null;
	        var matches = dataURL.match(/^data:([^,]+)?,/);
	        if (matches === null) {
	            throw errorsExports.invalidFormat(exports.StringFormat.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
	        }
	        var middle = matches[1] || null;
	        if (middle != null) {
	            this.base64 = endsWith(middle, ';base64');
	            this.contentType = this.base64
	                ? middle.substring(0, middle.length - ';base64'.length)
	                : middle;
	        }
	        this.rest = dataURL.substring(dataURL.indexOf(',') + 1);
	    }
	    return DataURLParts;
	}());
	function dataURLBytes_(string) {
	    var parts = new DataURLParts(string);
	    if (parts.base64) {
	        return base64Bytes_(exports.StringFormat.BASE64, parts.rest);
	    }
	    else {
	        return percentEncodedBytes_(parts.rest);
	    }
	}
	exports.dataURLBytes_ = dataURLBytes_;
	function dataURLContentType_(string) {
	    var parts = new DataURLParts(string);
	    return parts.contentType;
	}
	exports.dataURLContentType_ = dataURLContentType_;
	function endsWith(s, end) {
	    var longEnough = s.length >= end.length;
	    if (!longEnough) {
	        return false;
	    }
	    return s.substring(s.length - end.length) === end;
	}
	
	//# sourceMappingURL=string.js.map


/***/ },
/* 75 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TaskEvent = {
	    /** Triggered whenever the task changes or progress is updated. */
	    STATE_CHANGED: 'state_changed'
	};
	exports.InternalTaskState = {
	    RUNNING: 'running',
	    PAUSING: 'pausing',
	    PAUSED: 'paused',
	    SUCCESS: 'success',
	    CANCELING: 'canceling',
	    CANCELED: 'canceled',
	    ERROR: 'error'
	};
	exports.TaskState = {
	    /** The task is currently transferring data. */
	    RUNNING: 'running',
	    /** The task was paused by the user. */
	    PAUSED: 'paused',
	    /** The task completed successfully. */
	    SUCCESS: 'success',
	    /** The task was canceled. */
	    CANCELED: 'canceled',
	    /** The task failed with an error. */
	    ERROR: 'error'
	};
	function taskStateFromInternalTaskState(state) {
	    switch (state) {
	        case exports.InternalTaskState.RUNNING:
	        case exports.InternalTaskState.PAUSING:
	        case exports.InternalTaskState.CANCELING:
	            return exports.TaskState.RUNNING;
	        case exports.InternalTaskState.PAUSED:
	            return exports.TaskState.PAUSED;
	        case exports.InternalTaskState.SUCCESS:
	            return exports.TaskState.SUCCESS;
	        case exports.InternalTaskState.CANCELED:
	            return exports.TaskState.CANCELED;
	        case exports.InternalTaskState.ERROR:
	            return exports.TaskState.ERROR;
	        default:
	            // TODO(andysoto): assert(false);
	            return exports.TaskState.ERROR;
	    }
	}
	exports.taskStateFromInternalTaskState = taskStateFromInternalTaskState;
	
	//# sourceMappingURL=taskenums.js.map


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	*  filename: ej2-data.umd.min.js
	*  version : 19.4.54
	*  Copyright Syncfusion Inc. 2001 - 2020. All rights reserved.
	*  Use of this code is subject to the terms of our license.
	*  A copy of the current license can be obtained at any time by e-mailing
	*  licensing@syncfusion.com. Any infringement will be prosecuted under
	*  applicable laws. 
	*/
	!function(e,t){ true?t(exports,__webpack_require__(23)):"function"==typeof define&&define.amd?define(["exports","@syncfusion/ej2-base"],t):t(e.ej={},e.ej2Base)}(this,function(e,t){"use strict";var r=function(){function e(e){return this.subQuery=null,this.isChild=!1,this.distincts=[],this.queries=[],this.key="",this.fKey="","string"==typeof e?this.fromTable=e:e&&e instanceof Array&&(this.lookups=e),this.expands=[],this.sortedColumns=[],this.groupedColumns=[],this.subQuery=null,this.isChild=!1,this.params=[],this.lazyLoad=[],this}return e.prototype.setKey=function(e){return this.key=e,this},e.prototype.using=function(e){return this.dataManager=e,this},e.prototype.execute=function(e,t,r,n){return(e=e||this.dataManager)?e.executeQuery(this,t,r,n):a.throwError('Query - execute() : dataManager needs to be is set using "using" function or should be passed as argument')},e.prototype.executeLocal=function(e){return(e=e||this.dataManager)?e.executeLocal(this):a.throwError('Query - executeLocal() : dataManager needs to be is set using "using" function or should be passed as argument')},e.prototype.clone=function(){var t=new e;return t.queries=this.queries.slice(0),t.key=this.key,t.isChild=this.isChild,t.dataManager=this.dataManager,t.fromTable=this.fromTable,t.params=this.params.slice(0),t.expands=this.expands.slice(0),t.sortedColumns=this.sortedColumns.slice(0),t.groupedColumns=this.groupedColumns.slice(0),t.subQuerySelector=this.subQuerySelector,t.subQuery=this.subQuery,t.fKey=this.fKey,t.isCountRequired=this.isCountRequired,t.distincts=this.distincts.slice(0),t.lazyLoad=this.lazyLoad.slice(0),t},e.prototype.from=function(e){return this.fromTable=e,this},e.prototype.addParams=function(e,t){return"function"==typeof t?this.params.push({key:e,fn:t}):this.params.push({key:e,value:t}),this},e.prototype.distinct=function(e){return this.distincts="string"==typeof e?[].slice.call([e],0):e.slice(0),this},e.prototype.expand=function(e){return this.expands="string"==typeof e?[].slice.call([e],0):e.slice(0),this},e.prototype.where=function(e,t,r,o,a){t=t?t.toLowerCase():null;var s=null;return"string"==typeof e?s=new n(e,t,r,o,a):e instanceof n&&(s=e),this.queries.push({fn:"onWhere",e:s}),this},e.prototype.search=function(e,t,r,n,o){"string"==typeof t&&(t=[t]),r&&"none"!==r||(r="contains");var s=a.fnOperators[r];return this.queries.push({fn:"onSearch",e:{fieldNames:t,operator:r,searchKey:e,ignoreCase:n,ignoreAccent:o,comparer:s}}),this},e.prototype.sortBy=function(e,t,r){return this.sortByForeignKey(e,t,r)},e.prototype.sortByForeignKey=function(r,n,o,s){var i,u,c=t.isNullOrUndefined(s)?"ascending":s;if("string"==typeof r&&a.endsWith(r.toLowerCase()," desc")&&(r=r.replace(/ desc$/i,""),n="descending"),n&&"string"!=typeof n||(c=n?n.toLowerCase():"ascending",n=a.fnSort(n)),o){i=e.filterQueries(this.queries,"onSortBy");for(var l=0;l<i.length;l++)if("string"==typeof(u=i[l].e.fieldName)){if(u===r)return this}else if(u instanceof Array)for(var p=0;p<u.length;p++)if(u[p]===r||r.toLowerCase()===u[p]+" desc")return this}return this.queries.push({fn:"onSortBy",e:{fieldName:r,comparer:n,direction:c}}),this},e.prototype.sortByDesc=function(e){return this.sortBy(e,"descending")},e.prototype.group=function(e,t,r){return this.sortBy(e,null,!0),this.queries.push({fn:"onGroup",e:{fieldName:e,comparer:t||null,format:r||null}}),this},e.prototype.page=function(e,t){return this.queries.push({fn:"onPage",e:{pageIndex:e,pageSize:t}}),this},e.prototype.range=function(e,t){return this.queries.push({fn:"onRange",e:{start:e,end:t}}),this},e.prototype.take=function(e){return this.queries.push({fn:"onTake",e:{nos:e}}),this},e.prototype.skip=function(e){return this.queries.push({fn:"onSkip",e:{nos:e}}),this},e.prototype.select=function(e){return"string"==typeof e&&(e=[].slice.call([e],0)),this.queries.push({fn:"onSelect",e:{fieldNames:e}}),this},e.prototype.hierarchy=function(e,t){return this.subQuerySelector=t,this.subQuery=e,this},e.prototype.foreignKey=function(e){return this.fKey=e,this},e.prototype.requiresCount=function(){return this.isCountRequired=!0,this},e.prototype.aggregate=function(e,t){return this.queries.push({fn:"onAggregates",e:{field:t,type:e}}),this},e.filterQueries=function(e,t){return e.filter(function(e){return e.fn===t})},e.filterQueryLists=function(e,t){for(var r=e.filter(function(e){return-1!==t.indexOf(e.fn)}),n={},o=0;o<r.length;o++)n[r[o].fn]||(n[r[o].fn]=r[o].e);return n},e}(),n=function(){function e(t,r,n,o,s){return void 0===o&&(o=!1),this.ignoreAccent=!1,this.isComplex=!1,"string"==typeof t?(this.field=t,this.operator=r.toLowerCase(),this.value=n,this.ignoreCase=o,this.ignoreAccent=s,this.isComplex=!1,this.comparer=a.fnOperators.processOperator(this.operator)):(t instanceof e&&n instanceof e||n instanceof Array)&&(this.isComplex=!0,this.condition=r.toLowerCase(),this.predicates=[t],n instanceof Array?[].push.apply(this.predicates,n):this.predicates.push(n)),this}return e.and=function(){for(var t=[],r=0;r<arguments.length;r++)t[r]=arguments[r];return e.combinePredicates([].slice.call(t,0),"and")},e.prototype.and=function(t,r,n,o,a){return e.combine(this,t,r,n,"and",o,a)},e.or=function(){for(var t=[],r=0;r<arguments.length;r++)t[r]=arguments[r];return e.combinePredicates([].slice.call(t,0),"or")},e.prototype.or=function(t,r,n,o,a){return e.combine(this,t,r,n,"or",o,a)},e.fromJson=function(e){if(e instanceof Array){for(var t=[],r=0,n=e.length;r<n;r++)t.push(this.fromJSONData(e[r]));return t}var o=e;return this.fromJSONData(o)},e.prototype.validate=function(e){var t,r,n=this.predicates?this.predicates:[];if(!this.isComplex&&this.comparer)return this.comparer.call(this,a.getObject(this.field,e),this.value,this.ignoreCase,this.ignoreAccent);t="and"===this.condition;for(var o=0;o<n.length;o++)if(r=n[o].validate(e),t){if(!r)return!1}else if(r)return!0;return t},e.prototype.toJson=function(){var e,t;if(this.isComplex){e=[],t=this.predicates;for(var r=0;r<t.length;r++)e.push(t[r].toJson())}return{isComplex:this.isComplex,field:this.field,operator:this.operator,value:this.value,ignoreCase:this.ignoreCase,ignoreAccent:this.ignoreAccent,condition:this.condition,predicates:e}},e.combinePredicates=function(t,r){if(1===t.length){if(!(t[0]instanceof Array))return t[0];t=t[0]}return new e(t[0],r,t.slice(1))},e.combine=function(t,r,n,o,s,i,u){return r instanceof e?e[s](t,r):"string"==typeof r?e[s](t,new e(r,n,o,i,u)):a.throwError("Predicate - "+s+" : invalid arguments")},e.fromJSONData=function(t){for(var r=t.predicates||[],n=r.length,o=[],a=0;a<n;a++)o.push(this.fromJSONData(r[a]));return t.isComplex?new e(o[0],t.condition,o.slice(1)):new e(t.field,t.operator,t.value,t.ignoreCase,t.ignoreAccent)},e}(),o={GroupGuid:"{271bbba0-1ee7}"},a=function(){function e(){}return e.getValue=function(e,t){return"function"==typeof e?e.call(t||{}):e},e.endsWith=function(e,t){return e.slice&&e.slice(-t.length)===t},e.startsWith=function(e,t){return e.slice(0,t.length)===t},e.fnSort=function(t){return"ascending"===(t=t?e.toLowerCase(t):"ascending")?this.fnAscending:this.fnDescending},e.fnAscending=function(e,r){return t.isNullOrUndefined(e)&&t.isNullOrUndefined(r)?-1:null===r||void 0===r?-1:"string"==typeof e?e.localeCompare(r):null===e||void 0===e?1:e-r},e.fnDescending=function(e,r){return t.isNullOrUndefined(e)&&t.isNullOrUndefined(r)?-1:null===r||void 0===r?1:"string"==typeof e?-1*e.localeCompare(r):null===e||void 0===e?-1:r-e},e.extractFields=function(e,t){for(var r={},n=0;n<t.length;n++)r=this.setValue(t[n],this.getObject(t[n],e),r);return r},e.select=function(e,t){for(var r=[],n=0;n<e.length;n++)r.push(this.extractFields(e[n],t));return r},e.group=function(r,n,a,s,i,u,c){s=s||1;var l=r;if(l.GroupGuid===o.GroupGuid){for(var p=function(e){if(t.isNullOrUndefined(i))l[e].items=d.group(l[e].items,n,a,l.level+1,null,u,c),l[e].count=l[e].items.length;else{var r=-1,o=i.filter(function(t){return t.key===l[e].key});r=i.indexOf(o[0]),l[e].items=d.group(l[e].items,n,a,l.level+1,i[r].items,u,c),l[e].count=i[r].count}},d=this,h=0;h<l.length;h++)p(h);return l.childLevels+=1,l}var f={},g=[];g.GroupGuid=o.GroupGuid,g.level=s,g.childLevels=0,g.records=l;for(var y=function(e){var r=v.getVal(l,e,n);if(t.isNullOrUndefined(u)||(r=u(r,n)),!f[r]&&(f[r]={key:r,count:0,items:[],aggregates:{},field:n},g.push(f[r]),!t.isNullOrUndefined(i))){var o=i.filter(function(e){return e.key===f[r].key});f[r].count=o[0].count}f[r].count=t.isNullOrUndefined(i)?f[r].count+=1:f[r].count,(!c||c&&a.length)&&f[r].items.push(l[e])},v=this,m=0;m<l.length;m++)y(m);if(a&&a.length){var S=function(r){for(var n={},o=void 0,s=a,u=0;u<a.length;u++)if(o=e.aggregates[a[u].type],t.isNullOrUndefined(i))o&&(n[s[u].field+" - "+s[u].type]=o(g[r].items,s[u].field));else{var c=i.filter(function(e){return e.key===g[r].key});o&&(n[s[u].field+" - "+s[u].type]=o(c[0].items,s[u].field))}g[r].aggregates=n};for(m=0;m<g.length;m++)S(m)}if(c&&g.length&&a.length)for(m=0;m<g.length;m++)g[m].items=[];return l.length&&g||l},e.buildHierarchy=function(e,t,r,n,o){var a,s={};for(n.result&&(n=n.result),n.GroupGuid&&this.throwError("DataManager: Do not have support Grouping in hierarchy"),a=0;a<n.length;a++){(s[i=this.getObject(e,n[a])]||(s[i]=[])).push(n[a])}for(a=0;a<r.length;a++){var i=this.getObject(o||e,r[a]);r[a][t]=s[i]}},e.getFieldList=function(e,t,r){if(void 0===r&&(r=""),void 0===t||null===t)return this.getFieldList(e,[],r);for(var n=e,o=0,a=Object.keys(e);o<a.length;o++){var s=a[o];"object"!=typeof n[s]||n[s]instanceof Array?t.push(r+s):this.getFieldList(n[s],t,r+s+".")}return t},e.getObject=function(e,t){if(!e)return t;if(t){if(-1===e.indexOf("."))return t[e];for(var r=t,n=e.split("."),o=0;o<n.length&&null!=r;o++)r=r[n[o]];return r}},e.setValue=function(e,r,n){var o,a,s=e.toString().split("."),i=n||{},u=i,c=s.length;for(o=0;o<c;o++)a=s[o],o+1===c?u[a]=void 0===r?void 0:r:t.isNullOrUndefined(u[a])&&(u[a]={}),u=u[a];return i},e.sort=function(e,t,r){if(e.length<=1)return e;var n=parseInt((e.length/2).toString(),10),o=e.slice(0,n),a=e.slice(n);return o=this.sort(o,t,r),a=this.sort(a,t,r),this.merge(o,a,t,r)},e.ignoreDiacritics=function(t){if("string"!=typeof t)return t;return t.split("").map(function(t){return t in e.diacritics?e.diacritics[t]:t}).join("")},e.merge=function(e,t,r,n){for(var o,a=[];e.length>0||t.length>0;)o=e.length>0&&t.length>0?n?n(this.getVal(e,0,r),this.getVal(t,0,r),e[0],t[0])<=0?e:t:e[0][r]<e[0][r]?e:t:e.length>0?e:t,a.push(o.shift());return a},e.getVal=function(e,t,r){return r?this.getObject(r,e[t]):e[t]},e.toLowerCase=function(e){return e?"string"==typeof e?e.toLowerCase():e.toString():0===e||!1===e?e.toString():""},e.callAdaptorFunction=function(e,r,n,o){if(r in e){var a=e[r](n,o);t.isNullOrUndefined(a)||(n=a)}return n},e.getAddParams=function(t,r,n){var o={};return e.callAdaptorFunction(t,"addParams",{dm:r,query:n,params:n.params,reqParams:o}),o},e.isPlainObject=function(e){return!!e&&e.constructor===Object},e.isCors=function(){var e=null;try{e=new window.XMLHttpRequest}catch(e){}return!!e&&"withCredentials"in e},e.getGuid=function(e){var t;return(e||"")+"00000000-0000-4000-0000-000000000000".replace(/0/g,function(e,r){if("crypto"in window&&"getRandomValues"in crypto){var n=new Uint8Array(1);window.crypto.getRandomValues(n),t=n[0]%16|0}else t=16*Math.random()|0;return"0123456789abcdef"[19===r?3&t|8:t]})},e.isNull=function(e){return void 0===e||null===e},e.getItemFromComparer=function(r,n,o){var a,s,i,u=0,c="string"==typeof e.getVal(r,0,n);if(r.length)for(;t.isNullOrUndefined(a)&&u<r.length;)a=e.getVal(r,u,n),i=r[u++];for(;u<r.length;u++)s=e.getVal(r,u,n),t.isNullOrUndefined(s)||(c&&(a=+a,s=+s),o(a,s)>0&&(a=s,i=r[u]));return i},e.distinct=function(r,n,o){o=!t.isNullOrUndefined(o)&&o;var a,s=[],i={};return r.forEach(function(t,u){(a="object"==typeof r[u]?e.getVal(r,u,n):r[u])in i||(s.push(o?r[u]:a),i[a]=1)}),s},e.processData=function(e,t){var r=this.prepareQuery(e),n=new S(t);e.requiresCounts&&r.requiresCount();var o=n.executeLocal(r),a={result:e.requiresCounts?o.result:o,count:o.count,aggregates:JSON.stringify(o.aggregates)};return e.requiresCounts?a:o},e.prepareQuery=function(o){var a=this,s=new r;if(o.select&&s.select(o.select),o.where){e.parse.parseJson(o.where).filter(function(e){if(t.isNullOrUndefined(e.condition))s.where(e.field,e.operator,e.value,e.ignoreCase,e.ignoreAccent);else{var r=[];e.field?r.push(new n(e.field,e.operator,e.value,e.ignoreCase,e.ignoreAccent)):r=r.concat(a.getPredicate(e.predicates)),"or"==e.condition?s.where(n.or(r)):"and"==e.condition&&s.where(n.and(r))}})}if(o.search){e.parse.parseJson(o.search).filter(function(e){return s.search(e.key,e.fields,e.operator,e.ignoreCase,e.ignoreAccent)})}return o.aggregates&&o.aggregates.filter(function(e){return s.aggregate(e.type,e.field)}),o.sorted&&o.sorted.filter(function(e){return s.sortBy(e.name,e.direction)}),o.skip&&s.skip(o.skip),o.take&&s.take(o.take),o.group&&o.group.filter(function(e){return s.group(e)}),s},e.getPredicate=function(e){for(var t=[],r=0;r<e.length;r++){var o=e[r];if(o.field)t.push(new n(o.field,o.operator,o.value,o.ignoreCase,o.ignoreAccent));else{for(var a=[],s=this.getPredicate(o.predicates),i=0,u=Object.keys(s);i<u.length;i++){var c=u[i];a.push(s[c])}t.push("or"==o.condition?n.or(a):n.and(a))}}return t},e.serverTimezoneOffset=null,e.timeZoneHandling=!0,e.throwError=function(e){try{throw new Error(e)}catch(e){throw e.message+"\n"+e.stack}},e.aggregates={sum:function(t,r){for(var n,o=0,a="number"!=typeof e.getVal(t,0,r),s=0;s<t.length;s++)n=e.getVal(t,s,r),isNaN(n)||null===n||(a&&(n=+n),o+=n);return o},average:function(t,r){return e.aggregates.sum(t,r)/t.length},min:function(t,r){var n;return"function"==typeof r&&(n=r,r=null),e.getObject(r,e.getItemFromComparer(t,r,n||e.fnAscending))},max:function(t,r){var n;return"function"==typeof r&&(n=r,r=null),e.getObject(r,e.getItemFromComparer(t,r,n||e.fnDescending))},truecount:function(e,t){return new S(e).executeLocal((new r).where(t,"equal",!0,!0)).length},falsecount:function(e,t){return new S(e).executeLocal((new r).where(t,"equal",!1,!0)).length},count:function(e,t){return e.length}},e.operatorSymbols={"<":"lessthan",">":"greaterthan","<=":"lessthanorequal",">=":"greaterthanorequal","==":"equal","!=":"notequal","*=":"contains","$=":"endswith","^=":"startswith"},e.odBiOperator={"<":" lt ",">":" gt ","<=":" le ",">=":" ge ","==":" eq ","!=":" ne ",lessthan:" lt ",lessthanorequal:" le ",greaterthan:" gt ",greaterthanorequal:" ge ",equal:" eq ",notequal:" ne "},e.odUniOperator={"$=":"endswith","^=":"startswith","*=":"substringof",endswith:"endswith",startswith:"startswith",contains:"substringof"},e.odv4UniOperator={"$=":"endswith","^=":"startswith","*=":"contains",endswith:"endswith",startswith:"startswith",contains:"contains"},e.diacritics={"Ⓐ":"A","Ａ":"A","À":"A","Á":"A","Â":"A","Ầ":"A","Ấ":"A","Ẫ":"A","Ẩ":"A","Ã":"A","Ā":"A","Ă":"A","Ằ":"A","Ắ":"A","Ẵ":"A","Ẳ":"A","Ȧ":"A","Ǡ":"A","Ä":"A","Ǟ":"A","Ả":"A","Å":"A","Ǻ":"A","Ǎ":"A","Ȁ":"A","Ȃ":"A","Ạ":"A","Ậ":"A","Ặ":"A","Ḁ":"A","Ą":"A","Ⱥ":"A","Ɐ":"A","Ꜳ":"AA","Æ":"AE","Ǽ":"AE","Ǣ":"AE","Ꜵ":"AO","Ꜷ":"AU","Ꜹ":"AV","Ꜻ":"AV","Ꜽ":"AY","Ⓑ":"B","Ｂ":"B","Ḃ":"B","Ḅ":"B","Ḇ":"B","Ƀ":"B","Ƃ":"B","Ɓ":"B","Ⓒ":"C","Ｃ":"C","Ć":"C","Ĉ":"C","Ċ":"C","Č":"C","Ç":"C","Ḉ":"C","Ƈ":"C","Ȼ":"C","Ꜿ":"C","Ⓓ":"D","Ｄ":"D","Ḋ":"D","Ď":"D","Ḍ":"D","Ḑ":"D","Ḓ":"D","Ḏ":"D","Đ":"D","Ƌ":"D","Ɗ":"D","Ɖ":"D","Ꝺ":"D","Ǳ":"DZ","Ǆ":"DZ","ǲ":"Dz","ǅ":"Dz","Ⓔ":"E","Ｅ":"E","È":"E","É":"E","Ê":"E","Ề":"E","Ế":"E","Ễ":"E","Ể":"E","Ẽ":"E","Ē":"E","Ḕ":"E","Ḗ":"E","Ĕ":"E","Ė":"E","Ë":"E","Ẻ":"E","Ě":"E","Ȅ":"E","Ȇ":"E","Ẹ":"E","Ệ":"E","Ȩ":"E","Ḝ":"E","Ę":"E","Ḙ":"E","Ḛ":"E","Ɛ":"E","Ǝ":"E","Ⓕ":"F","Ｆ":"F","Ḟ":"F","Ƒ":"F","Ꝼ":"F","Ⓖ":"G","Ｇ":"G","Ǵ":"G","Ĝ":"G","Ḡ":"G","Ğ":"G","Ġ":"G","Ǧ":"G","Ģ":"G","Ǥ":"G","Ɠ":"G","Ꞡ":"G","Ᵹ":"G","Ꝿ":"G","Ⓗ":"H","Ｈ":"H","Ĥ":"H","Ḣ":"H","Ḧ":"H","Ȟ":"H","Ḥ":"H","Ḩ":"H","Ḫ":"H","Ħ":"H","Ⱨ":"H","Ⱶ":"H","Ɥ":"H","Ⓘ":"I","Ｉ":"I","Ì":"I","Í":"I","Î":"I","Ĩ":"I","Ī":"I","Ĭ":"I","İ":"I","Ï":"I","Ḯ":"I","Ỉ":"I","Ǐ":"I","Ȉ":"I","Ȋ":"I","Ị":"I","Į":"I","Ḭ":"I","Ɨ":"I","Ⓙ":"J","Ｊ":"J","Ĵ":"J","Ɉ":"J","Ⓚ":"K","Ｋ":"K","Ḱ":"K","Ǩ":"K","Ḳ":"K","Ķ":"K","Ḵ":"K","Ƙ":"K","Ⱪ":"K","Ꝁ":"K","Ꝃ":"K","Ꝅ":"K","Ꞣ":"K","Ⓛ":"L","Ｌ":"L","Ŀ":"L","Ĺ":"L","Ľ":"L","Ḷ":"L","Ḹ":"L","Ļ":"L","Ḽ":"L","Ḻ":"L","Ł":"L","Ƚ":"L","Ɫ":"L","Ⱡ":"L","Ꝉ":"L","Ꝇ":"L","Ꞁ":"L","Ǉ":"LJ","ǈ":"Lj","Ⓜ":"M","Ｍ":"M","Ḿ":"M","Ṁ":"M","Ṃ":"M","Ɱ":"M","Ɯ":"M","Ⓝ":"N","Ｎ":"N","Ǹ":"N","Ń":"N","Ñ":"N","Ṅ":"N","Ň":"N","Ṇ":"N","Ņ":"N","Ṋ":"N","Ṉ":"N","Ƞ":"N","Ɲ":"N","Ꞑ":"N","Ꞥ":"N","Ǌ":"NJ","ǋ":"Nj","Ⓞ":"O","Ｏ":"O","Ò":"O","Ó":"O","Ô":"O","Ồ":"O","Ố":"O","Ỗ":"O","Ổ":"O","Õ":"O","Ṍ":"O","Ȭ":"O","Ṏ":"O","Ō":"O","Ṑ":"O","Ṓ":"O","Ŏ":"O","Ȯ":"O","Ȱ":"O","Ö":"O","Ȫ":"O","Ỏ":"O","Ő":"O","Ǒ":"O","Ȍ":"O","Ȏ":"O","Ơ":"O","Ờ":"O","Ớ":"O","Ỡ":"O","Ở":"O","Ợ":"O","Ọ":"O","Ộ":"O","Ǫ":"O","Ǭ":"O","Ø":"O","Ǿ":"O","Ɔ":"O","Ɵ":"O","Ꝋ":"O","Ꝍ":"O","Ƣ":"OI","Ꝏ":"OO","Ȣ":"OU","Ⓟ":"P","Ｐ":"P","Ṕ":"P","Ṗ":"P","Ƥ":"P","Ᵽ":"P","Ꝑ":"P","Ꝓ":"P","Ꝕ":"P","Ⓠ":"Q","Ｑ":"Q","Ꝗ":"Q","Ꝙ":"Q","Ɋ":"Q","Ⓡ":"R","Ｒ":"R","Ŕ":"R","Ṙ":"R","Ř":"R","Ȑ":"R","Ȓ":"R","Ṛ":"R","Ṝ":"R","Ŗ":"R","Ṟ":"R","Ɍ":"R","Ɽ":"R","Ꝛ":"R","Ꞧ":"R","Ꞃ":"R","Ⓢ":"S","Ｓ":"S","ẞ":"S","Ś":"S","Ṥ":"S","Ŝ":"S","Ṡ":"S","Š":"S","Ṧ":"S","Ṣ":"S","Ṩ":"S","Ș":"S","Ş":"S","Ȿ":"S","Ꞩ":"S","Ꞅ":"S","Ⓣ":"T","Ｔ":"T","Ṫ":"T","Ť":"T","Ṭ":"T","Ț":"T","Ţ":"T","Ṱ":"T","Ṯ":"T","Ŧ":"T","Ƭ":"T","Ʈ":"T","Ⱦ":"T","Ꞇ":"T","Ꜩ":"TZ","Ⓤ":"U","Ｕ":"U","Ù":"U","Ú":"U","Û":"U","Ũ":"U","Ṹ":"U","Ū":"U","Ṻ":"U","Ŭ":"U","Ü":"U","Ǜ":"U","Ǘ":"U","Ǖ":"U","Ǚ":"U","Ủ":"U","Ů":"U","Ű":"U","Ǔ":"U","Ȕ":"U","Ȗ":"U","Ư":"U","Ừ":"U","Ứ":"U","Ữ":"U","Ử":"U","Ự":"U","Ụ":"U","Ṳ":"U","Ų":"U","Ṷ":"U","Ṵ":"U","Ʉ":"U","Ⓥ":"V","Ｖ":"V","Ṽ":"V","Ṿ":"V","Ʋ":"V","Ꝟ":"V","Ʌ":"V","Ꝡ":"VY","Ⓦ":"W","Ｗ":"W","Ẁ":"W","Ẃ":"W","Ŵ":"W","Ẇ":"W","Ẅ":"W","Ẉ":"W","Ⱳ":"W","Ⓧ":"X","Ｘ":"X","Ẋ":"X","Ẍ":"X","Ⓨ":"Y","Ｙ":"Y","Ỳ":"Y","Ý":"Y","Ŷ":"Y","Ỹ":"Y","Ȳ":"Y","Ẏ":"Y","Ÿ":"Y","Ỷ":"Y","Ỵ":"Y","Ƴ":"Y","Ɏ":"Y","Ỿ":"Y","Ⓩ":"Z","Ｚ":"Z","Ź":"Z","Ẑ":"Z","Ż":"Z","Ž":"Z","Ẓ":"Z","Ẕ":"Z","Ƶ":"Z","Ȥ":"Z","Ɀ":"Z","Ⱬ":"Z","Ꝣ":"Z","ⓐ":"a","ａ":"a","ẚ":"a","à":"a","á":"a","â":"a","ầ":"a","ấ":"a","ẫ":"a","ẩ":"a","ã":"a","ā":"a","ă":"a","ằ":"a","ắ":"a","ẵ":"a","ẳ":"a","ȧ":"a","ǡ":"a","ä":"a","ǟ":"a","ả":"a","å":"a","ǻ":"a","ǎ":"a","ȁ":"a","ȃ":"a","ạ":"a","ậ":"a","ặ":"a","ḁ":"a","ą":"a","ⱥ":"a","ɐ":"a","ꜳ":"aa","æ":"ae","ǽ":"ae","ǣ":"ae","ꜵ":"ao","ꜷ":"au","ꜹ":"av","ꜻ":"av","ꜽ":"ay","ⓑ":"b","ｂ":"b","ḃ":"b","ḅ":"b","ḇ":"b","ƀ":"b","ƃ":"b","ɓ":"b","ⓒ":"c","ｃ":"c","ć":"c","ĉ":"c","ċ":"c","č":"c","ç":"c","ḉ":"c","ƈ":"c","ȼ":"c","ꜿ":"c","ↄ":"c","ⓓ":"d","ｄ":"d","ḋ":"d","ď":"d","ḍ":"d","ḑ":"d","ḓ":"d","ḏ":"d","đ":"d","ƌ":"d","ɖ":"d","ɗ":"d","ꝺ":"d","ǳ":"dz","ǆ":"dz","ⓔ":"e","ｅ":"e","è":"e","é":"e","ê":"e","ề":"e","ế":"e","ễ":"e","ể":"e","ẽ":"e","ē":"e","ḕ":"e","ḗ":"e","ĕ":"e","ė":"e","ë":"e","ẻ":"e","ě":"e","ȅ":"e","ȇ":"e","ẹ":"e","ệ":"e","ȩ":"e","ḝ":"e","ę":"e","ḙ":"e","ḛ":"e","ɇ":"e","ɛ":"e","ǝ":"e","ⓕ":"f","ｆ":"f","ḟ":"f","ƒ":"f","ꝼ":"f","ⓖ":"g","ｇ":"g","ǵ":"g","ĝ":"g","ḡ":"g","ğ":"g","ġ":"g","ǧ":"g","ģ":"g","ǥ":"g","ɠ":"g","ꞡ":"g","ᵹ":"g","ꝿ":"g","ⓗ":"h","ｈ":"h","ĥ":"h","ḣ":"h","ḧ":"h","ȟ":"h","ḥ":"h","ḩ":"h","ḫ":"h","ẖ":"h","ħ":"h","ⱨ":"h","ⱶ":"h","ɥ":"h","ƕ":"hv","ⓘ":"i","ｉ":"i","ì":"i","í":"i","î":"i","ĩ":"i","ī":"i","ĭ":"i","ï":"i","ḯ":"i","ỉ":"i","ǐ":"i","ȉ":"i","ȋ":"i","ị":"i","į":"i","ḭ":"i","ɨ":"i","ı":"i","ⓙ":"j","ｊ":"j","ĵ":"j","ǰ":"j","ɉ":"j","ⓚ":"k","ｋ":"k","ḱ":"k","ǩ":"k","ḳ":"k","ķ":"k","ḵ":"k","ƙ":"k","ⱪ":"k","ꝁ":"k","ꝃ":"k","ꝅ":"k","ꞣ":"k","ⓛ":"l","ｌ":"l","ŀ":"l","ĺ":"l","ľ":"l","ḷ":"l","ḹ":"l","ļ":"l","ḽ":"l","ḻ":"l","ſ":"l","ł":"l","ƚ":"l","ɫ":"l","ⱡ":"l","ꝉ":"l","ꞁ":"l","ꝇ":"l","ǉ":"lj","ⓜ":"m","ｍ":"m","ḿ":"m","ṁ":"m","ṃ":"m","ɱ":"m","ɯ":"m","ⓝ":"n","ｎ":"n","ǹ":"n","ń":"n","ñ":"n","ṅ":"n","ň":"n","ṇ":"n","ņ":"n","ṋ":"n","ṉ":"n","ƞ":"n","ɲ":"n","ŉ":"n","ꞑ":"n","ꞥ":"n","ǌ":"nj","ⓞ":"o","ｏ":"o","ò":"o","ó":"o","ô":"o","ồ":"o","ố":"o","ỗ":"o","ổ":"o","õ":"o","ṍ":"o","ȭ":"o","ṏ":"o","ō":"o","ṑ":"o","ṓ":"o","ŏ":"o","ȯ":"o","ȱ":"o","ö":"o","ȫ":"o","ỏ":"o","ő":"o","ǒ":"o","ȍ":"o","ȏ":"o","ơ":"o","ờ":"o","ớ":"o","ỡ":"o","ở":"o","ợ":"o","ọ":"o","ộ":"o","ǫ":"o","ǭ":"o","ø":"o","ǿ":"o","ɔ":"o","ꝋ":"o","ꝍ":"o","ɵ":"o","ƣ":"oi","ȣ":"ou","ꝏ":"oo","ⓟ":"p","ｐ":"p","ṕ":"p","ṗ":"p","ƥ":"p","ᵽ":"p","ꝑ":"p","ꝓ":"p","ꝕ":"p","ⓠ":"q","ｑ":"q","ɋ":"q","ꝗ":"q","ꝙ":"q","ⓡ":"r","ｒ":"r","ŕ":"r","ṙ":"r","ř":"r","ȑ":"r","ȓ":"r","ṛ":"r","ṝ":"r","ŗ":"r","ṟ":"r","ɍ":"r","ɽ":"r","ꝛ":"r","ꞧ":"r","ꞃ":"r","ⓢ":"s","ｓ":"s","ß":"s","ś":"s","ṥ":"s","ŝ":"s","ṡ":"s","š":"s","ṧ":"s","ṣ":"s","ṩ":"s","ș":"s","ş":"s","ȿ":"s","ꞩ":"s","ꞅ":"s","ẛ":"s","ⓣ":"t","ｔ":"t","ṫ":"t","ẗ":"t","ť":"t","ṭ":"t","ț":"t","ţ":"t","ṱ":"t","ṯ":"t","ŧ":"t","ƭ":"t","ʈ":"t","ⱦ":"t","ꞇ":"t","ꜩ":"tz","ⓤ":"u","ｕ":"u","ù":"u","ú":"u","û":"u","ũ":"u","ṹ":"u","ū":"u","ṻ":"u","ŭ":"u","ü":"u","ǜ":"u","ǘ":"u","ǖ":"u","ǚ":"u","ủ":"u","ů":"u","ű":"u","ǔ":"u","ȕ":"u","ȗ":"u","ư":"u","ừ":"u","ứ":"u","ữ":"u","ử":"u","ự":"u","ụ":"u","ṳ":"u","ų":"u","ṷ":"u","ṵ":"u","ʉ":"u","ⓥ":"v","ｖ":"v","ṽ":"v","ṿ":"v","ʋ":"v","ꝟ":"v","ʌ":"v","ꝡ":"vy","ⓦ":"w","ｗ":"w","ẁ":"w","ẃ":"w","ŵ":"w","ẇ":"w","ẅ":"w","ẘ":"w","ẉ":"w","ⱳ":"w","ⓧ":"x","ｘ":"x","ẋ":"x","ẍ":"x","ⓨ":"y","ｙ":"y","ỳ":"y","ý":"y","ŷ":"y","ỹ":"y","ȳ":"y","ẏ":"y","ÿ":"y","ỷ":"y","ẙ":"y","ỵ":"y","ƴ":"y","ɏ":"y","ỿ":"y","ⓩ":"z","ｚ":"z","ź":"z","ẑ":"z","ż":"z","ž":"z","ẓ":"z","ẕ":"z","ƶ":"z","ȥ":"z","ɀ":"z","ⱬ":"z","ꝣ":"z","Ά":"Α","Έ":"Ε","Ή":"Η","Ί":"Ι","Ϊ":"Ι","Ό":"Ο","Ύ":"Υ","Ϋ":"Υ","Ώ":"Ω","ά":"α","έ":"ε","ή":"η","ί":"ι","ϊ":"ι","ΐ":"ι","ό":"ο","ύ":"υ","ϋ":"υ","ΰ":"υ","ω":"ω","ς":"σ"},e.fnOperators={equal:function(t,r,n,o){return o&&(t=e.ignoreDiacritics(t),r=e.ignoreDiacritics(r)),n?e.toLowerCase(t)===e.toLowerCase(r):t===r},notequal:function(t,r,n,o){return o&&(t=e.ignoreDiacritics(t),r=e.ignoreDiacritics(r)),!e.fnOperators.equal(t,r,n)},lessthan:function(r,n,o){return o?e.toLowerCase(r)<e.toLowerCase(n):(t.isNullOrUndefined(r)&&(r=void 0),r<n)},greaterthan:function(t,r,n){return n?e.toLowerCase(t)>e.toLowerCase(r):t>r},lessthanorequal:function(r,n,o){return o?e.toLowerCase(r)<=e.toLowerCase(n):(t.isNullOrUndefined(r)&&(r=void 0),r<=n)},greaterthanorequal:function(t,r,n){return n?e.toLowerCase(t)>=e.toLowerCase(r):t>=r},contains:function(r,n,o,a){return a&&(r=e.ignoreDiacritics(r),n=e.ignoreDiacritics(n)),o?!t.isNullOrUndefined(r)&&!t.isNullOrUndefined(n)&&-1!==e.toLowerCase(r).indexOf(e.toLowerCase(n)):!t.isNullOrUndefined(r)&&!t.isNullOrUndefined(n)&&-1!==r.toString().indexOf(n)},notnull:function(e){return null!==e},isnull:function(e){return null===e},startswith:function(t,r,n,o){return o&&(t=e.ignoreDiacritics(t),r=e.ignoreDiacritics(r)),n?t&&r&&e.startsWith(e.toLowerCase(t),e.toLowerCase(r)):t&&r&&e.startsWith(t,r)},endswith:function(t,r,n,o){return o&&(t=e.ignoreDiacritics(t),r=e.ignoreDiacritics(r)),n?t&&r&&e.endsWith(e.toLowerCase(t),e.toLowerCase(r)):t&&r&&e.endsWith(t,r)},processSymbols:function(t){var r=e.operatorSymbols[t];if(r){return e.fnOperators[r]}return e.throwError("Query - Process Operator : Invalid operator")},processOperator:function(t){var r=e.fnOperators[t];return r||e.fnOperators.processSymbols(t)}},e.parse={parseJson:function(t){return"string"==typeof t?t=JSON.parse(t,e.parse.jsonReviver):t instanceof Array?e.parse.iterateAndReviveArray(t):"object"==typeof t&&null!==t&&e.parse.iterateAndReviveJson(t),t},iterateAndReviveArray:function(t){for(var r=0;r<t.length;r++)"object"==typeof t[r]&&null!==t[r]?e.parse.iterateAndReviveJson(t[r]):"string"!=typeof t[r]||/^[\s]*\[|^[\s]*\{(.)+:|\"/g.test(t[r])?t[r]=e.parse.parseJson(t[r]):t[r]=e.parse.jsonReviver("",t[r])},iterateAndReviveJson:function(t){for(var r,n=0,o=Object.keys(t);n<o.length;n++){var a=o[n];e.startsWith(a,"__")||("object"==typeof(r=t[a])?r instanceof Array?e.parse.iterateAndReviveArray(r):r&&e.parse.iterateAndReviveJson(r):t[a]=e.parse.jsonReviver(t[a],r))}},jsonReviver:function(t,r){if("string"==typeof r){var n=/^\/Date\(([+-]?[0-9]+)([+-][0-9]{4})?\)\/$/.exec(r),o=e.timeZoneHandling?e.serverTimezoneOffset:null;if(n)return e.dateParse.toTimeZone(new Date(parseInt(n[1],10)),o,!0);if(/^(\d{4}\-\d\d\-\d\d([tT][\d:\.]*){1})([zZ]|([+\-])(\d\d):?(\d\d))?$/.test(r)){var a=r.indexOf("Z")>-1||r.indexOf("z")>-1,s=r.split(/[^0-9.]/);if(a)r=e.dateParse.toTimeZone(new Date(parseInt(s[0],10),parseInt(s[1],10)-1,parseInt(s[2],10),parseInt(s[3],10),parseInt(s[4],10),parseInt(s[5],10)),e.serverTimezoneOffset,!1);else{var i=new Date(parseInt(s[0],10),parseInt(s[1],10)-1,parseInt(s[2],10),parseInt(s[3],10),parseInt(s[4],10),parseInt(s[5],10)),u=parseInt(s[6],10),c=parseInt(s[7],10);if(isNaN(u)&&isNaN(c))return i;r.indexOf("+")>-1?i.setHours(i.getHours()-u,i.getMinutes()-c):i.setHours(i.getHours()+u,i.getMinutes()+c),r=e.dateParse.toTimeZone(i,e.serverTimezoneOffset,!1)}null==e.serverTimezoneOffset&&(r=e.dateParse.addSelfOffset(r))}}return r},isJson:function(t){return"string"==typeof t[0]?t:e.parse.parseJson(t)},isGuid:function(e){return null!=/[A-Fa-f0-9]{8}(?:-[A-Fa-f0-9]{4}){3}-[A-Fa-f0-9]{12}/i.exec(e)},replacer:function(t,r){return e.isPlainObject(t)?e.parse.jsonReplacer(t,r):t instanceof Array?e.parse.arrayReplacer(t):t instanceof Date?e.parse.jsonReplacer({val:t},r).val:t},jsonReplacer:function(t,r){for(var n,o=0,a=Object.keys(t);o<a.length;o++){var s=a[o];if((n=t[s])instanceof Date){var i=n;null==e.serverTimezoneOffset?t[s]=e.dateParse.toTimeZone(i,null).toJSON():(i=new Date(+i+36e5*e.serverTimezoneOffset),t[s]=e.dateParse.toTimeZone(e.dateParse.addSelfOffset(i),null).toJSON())}}return t},arrayReplacer:function(t){for(var r=0;r<t.length;r++)e.isPlainObject(t[r])?t[r]=e.parse.jsonReplacer(t[r]):t[r]instanceof Date&&(t[r]=e.parse.jsonReplacer({date:t[r]}).date);return t},jsonDateReplacer:function(t,r){if("value"===t&&r){if("string"==typeof r){var n=/^\/Date\(([+-]?[0-9]+)([+-][0-9]{4})?\)\/$/.exec(r);if(n)r=e.dateParse.toTimeZone(new Date(parseInt(n[1],10)),null,!0);else if(/^(\d{4}\-\d\d\-\d\d([tT][\d:\.]*){1})([zZ]|([+\-])(\d\d):?(\d\d))?$/.test(r)){var o=r.split(/[^0-9]/);r=e.dateParse.toTimeZone(new Date(parseInt(o[0],10),parseInt(o[1],10)-1,parseInt(o[2],10),parseInt(o[3],10),parseInt(o[4],10),parseInt(o[5],10)),null,!0)}}if(r instanceof Date)return r=e.dateParse.addSelfOffset(r),null===e.serverTimezoneOffset?e.dateParse.toTimeZone(e.dateParse.addSelfOffset(r),null).toJSON():(r=e.dateParse.toTimeZone(r,r.getTimezoneOffset()/60*2-e.serverTimezoneOffset,!1)).toJSON()}return r}},e.dateParse={addSelfOffset:function(e){return new Date(+e-6e4*e.getTimezoneOffset())},toUTC:function(e){return new Date(+e+6e4*e.getTimezoneOffset())},toTimeZone:function(t,r,n){if(null===r)return t;var o=n?e.dateParse.toUTC(t):t;return new Date(+o-36e5*r)},toLocalTime:function(e){var t=e,r=-t.getTimezoneOffset(),n=r>=0?"+":"-",o=function(e){var t=Math.floor(Math.abs(e));return(t<10?"0":"")+t};return t.getFullYear()+"-"+o(t.getMonth()+1)+"-"+o(t.getDate())+"T"+o(t.getHours())+":"+o(t.getMinutes())+":"+o(t.getSeconds())+n+o(r/60)+":"+o(r%60)}},e}(),s=function(){var e=function(t,r){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])})(t,r)};return function(t,r){function n(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(n.prototype=r.prototype,new n)}}(),i={GroupGuid:"{271bbba0-1ee7}"},u=function(){function e(t){this.options={from:"table",requestType:"json",sortBy:"sorted",select:"select",skip:"skip",group:"group",take:"take",search:"search",count:"requiresCounts",where:"where",aggregates:"aggregates",expand:"expand"},this.type=e,this.dataSource=t,this.pvt={}}return e.prototype.processResponse=function(e,t,r,n){return e},e}(),c=function(e){function n(){return null!==e&&e.apply(this,arguments)||this}return s(n,e),n.prototype.processQuery=function(e,t){for(var r,n,o,a=e.dataSource.json.slice(0),s=a.length,i=!0,u={},c=0,l=[],p=0;p<t.lazyLoad.length;p++)c++,u[t.lazyLoad[p].key]=t.lazyLoad[p].value;var d={};for(p=0;p<t.queries.length;p++)"onPage"!==(n=t.queries[p]).fn&&"onGroup"!==n.fn||!t.lazyLoad.length?(r=this[n.fn].call(this,a,n.e,t),"onAggregates"===n.fn?d[n.e.field+" - "+n.e.type]=r:a=void 0!==r?r:a,"onPage"!==n.fn&&"onSkip"!==n.fn&&"onTake"!==n.fn&&"onRange"!==n.fn||(i=!1),i&&(s=a.length)):("onGroup"===n.fn&&l.push(n.e),"onPage"===n.fn&&(o=n.e));if(c){var h={query:t,lazyLoad:u,result:a,group:l,page:o},f=this.lazyLoadGroup(h);a=f.result,s=f.count}return t.isCountRequired&&(a={result:a,count:s,aggregates:d}),a},n.prototype.lazyLoadGroup=function(e){var r=0,n=this.getAggregate(e.query),o=e.result;if(t.isNullOrUndefined(e.lazyLoad.onDemandGroupInfo)){u=e.group[0].fieldName;r=(o=a.group(o,u,n,null,null,e.group[0].comparer,!0)).length;c=o;e.page&&(o=this.onPage(o,e.page,e.query)),this.formGroupResult(o,c)}else{for(var s=e.lazyLoad.onDemandGroupInfo,i=s.where.length-1;i>=0;i--)o=this.onWhere(o,s.where[i]);if(e.group.length!==s.level){var u=e.group[s.level].fieldName;o=a.group(o,u,n,null,null,e.group[0].comparer,!0)}r=o.length;var c=o;o=(o=o.slice(s.skip)).slice(0,s.take),e.group.length!==s.level&&this.formGroupResult(o,c)}return{result:o,count:r}},n.prototype.formGroupResult=function(e,t){if(e.length&&t.length){e.GroupGuid=t.GroupGuid,e.childLevels=t.childLevels,e.level=t.level,e.records=t.records}return e},n.prototype.getAggregate=function(e){var t=r.filterQueries(e.queries,"onAggregates"),n=[];if(t.length)for(var o=void 0,s=0;s<t.length;s++)o=t[s].e,n.push({type:o.type,field:a.getValue(o.field,e)});return n},n.prototype.batchRequest=function(e,t,r){var n,o=t.deletedRecords.length;for(n=0;n<t.addedRecords.length;n++)this.insert(e,t.addedRecords[n]);for(n=0;n<t.changedRecords.length;n++)this.update(e,r.key,t.changedRecords[n]);for(n=0;n<o;n++)this.remove(e,r.key,t.deletedRecords[n]);return t},n.prototype.onWhere=function(e,t){return e&&e.length?e.filter(function(e){if(t)return t.validate(e)}):e},n.prototype.onAggregates=function(e,t){var r=a.aggregates[t.type];return e&&r&&0!==e.length?r(e,t.field):null},n.prototype.onSearch=function(e,t){return e&&e.length?(0===t.fieldNames.length&&a.getFieldList(e[0],t.fieldNames),e.filter(function(e){for(var r=0;r<t.fieldNames.length;r++)if(t.comparer.call(e,a.getObject(t.fieldNames[r],e),t.searchKey,t.ignoreCase,t.ignoreAccent))return!0;return!1})):e},n.prototype.onSortBy=function(e,t,r){if(!e||!e.length)return e;var n,o=a.getValue(t.fieldName,r);if(!o)return e.sort(t.comparer);if(o instanceof Array){for(var s=(o=o.slice(0)).length-1;s>=0;s--)o[s]&&(n=t.comparer,a.endsWith(o[s]," desc")&&(n=a.fnSort("descending"),o[s]=o[s].replace(" desc","")),e=a.sort(e,o[s],n));return e}return a.sort(e,o,t.comparer)},n.prototype.onGroup=function(e,t,r){if(!e||!e.length)return e;var n=this.getAggregate(r);return a.group(e,a.getValue(t.fieldName,r),n,null,null,t.comparer)},n.prototype.onPage=function(e,t,r){var n=a.getValue(t.pageSize,r),o=(a.getValue(t.pageIndex,r)-1)*n,s=o+n;return e&&e.length?e.slice(o,s):e},n.prototype.onRange=function(e,t){return e&&e.length?e.slice(a.getValue(t.start),a.getValue(t.end)):e},n.prototype.onTake=function(e,t){return e&&e.length?e.slice(0,a.getValue(t.nos)):e},n.prototype.onSkip=function(e,t){return e&&e.length?e.slice(a.getValue(t.nos)):e},n.prototype.onSelect=function(e,t){return e&&e.length?a.select(e,a.getValue(t.fieldNames)):e},n.prototype.insert=function(e,r,n,o,a){return t.isNullOrUndefined(a)?e.dataSource.json.push(r):e.dataSource.json.splice(a,0,r)},n.prototype.remove=function(e,t,r,n){var o,s=e.dataSource.json;for("object"!=typeof r||r instanceof Date||(r=a.getObject(t,r)),o=0;o<s.length&&a.getObject(t,s[o])!==r;o++);return o!==s.length?s.splice(o,1):null},n.prototype.update=function(e,r,n,o){var a,s,i=e.dataSource.json;for(t.isNullOrUndefined(r)||(s=t.getValue(r,n)),a=0;a<i.length&&(t.isNullOrUndefined(r)||t.getValue(r,i[a])!==s);a++);return a<i.length?t.merge(i[a],n):null},n}(u),l=function(e){function o(){return null!==e&&e.apply(this,arguments)||this}return s(o,e),o.prototype.processQuery=function(e,n,o){var s,i,u=this.getQueryRequest(n),c=r.filterQueryLists(n.queries,["onSelect","onPage","onSkip","onTake","onRange"]),l=n.params,p=e.dataSource.url,d=null,h=this.options,f={sorts:[],groups:[],filters:[],searches:[],aggregates:[]};"onPage"in c?(s=c.onPage,i=((i=a.getValue(s.pageIndex,n))-1)*(d=a.getValue(s.pageSize,n))):"onRange"in c&&(i=(s=c.onRange).start,d=s.end-s.start);for(var g=0;g<u.sorts.length;g++)s=a.getValue(u.sorts[g].e.fieldName,n),f.sorts.push(a.callAdaptorFunction(this,"onEachSort",{name:s,direction:u.sorts[g].e.direction},n));o&&(s=this.getFiltersFrom(o,n))&&f.filters.push(a.callAdaptorFunction(this,"onEachWhere",s.toJson(),n));for(g=0;g<u.filters.length;g++){var y=a.callAdaptorFunction(this,"onEachWhere",u.filters[g].e.toJson(),n);this.getModuleName&&"ODataV4Adaptor"===this.getModuleName()&&!t.isNullOrUndefined(u.filters[g].e.key)&&u.filters.length>1&&(y="("+y+")"),f.filters.push(y);for(var v=0,m="object"==typeof f.filters[g]?Object.keys(f.filters[g]):[];v<m.length;v++){var S=m[v];a.isNull(f[S])&&delete f[S]}}for(g=0;g<u.searches.length;g++)s=u.searches[g].e,f.searches.push(a.callAdaptorFunction(this,"onEachSearch",{fields:s.fieldNames,operator:s.operator,key:s.searchKey,ignoreCase:s.ignoreCase},n));for(g=0;g<u.groups.length;g++)f.groups.push(a.getValue(u.groups[g].e.fieldName,n));for(g=0;g<u.aggregates.length;g++)s=u.aggregates[g].e,f.aggregates.push({type:s.type,field:a.getValue(s.field,n)});var O={};if(this.getRequestQuery(h,n,c,f,O),a.callAdaptorFunction(this,"addParams",{dm:e,query:n,params:l,reqParams:O}),n.lazyLoad.length)for(g=0;g<n.lazyLoad.length;g++)O[n.lazyLoad[g].key]=n.lazyLoad[g].value;for(var b=0,A=Object.keys(O);b<A.length;b++){S=A[b];(a.isNull(O[S])||""===O[S]||0===O[S].length)&&delete O[S]}h.skip in O&&h.take in O||null===d||(O[h.skip]=a.callAdaptorFunction(this,"onSkip",i,n),O[h.take]=a.callAdaptorFunction(this,"onTake",d,n));var R=this.pvt;return this.pvt={},"json"===this.options.requestType?{data:JSON.stringify(O,a.parse.jsonDateReplacer),url:p,pvtData:R,type:"POST",contentType:"application/json; charset=utf-8"}:(s=this.convertToQueryString(O,n,e),s=(-1!==e.dataSource.url.indexOf("?")?"&":"/")+s,{type:"GET",url:s.length?p.replace(/\/*$/,s):p,pvtData:R})},o.prototype.getRequestQuery=function(e,t,r,n,o){var s=o;s[e.from]=t.fromTable,e.apply&&t.distincts.length&&(s[e.apply]="onDistinct"in this?a.callAdaptorFunction(this,"onDistinct",t.distincts):""),!t.distincts.length&&e.expand&&(s[e.expand]="onExpand"in this&&"onSelect"in r?a.callAdaptorFunction(this,"onExpand",{selects:a.getValue(r.onSelect.fieldNames,t),expands:t.expands},t):t.expands),s[e.select]="onSelect"in r&&!t.distincts.length?a.callAdaptorFunction(this,"onSelect",a.getValue(r.onSelect.fieldNames,t),t):"",s[e.count]=t.isCountRequired?a.callAdaptorFunction(this,"onCount",t.isCountRequired,t):"",s[e.search]=n.searches.length?a.callAdaptorFunction(this,"onSearch",n.searches,t):"",s[e.skip]="onSkip"in r?a.callAdaptorFunction(this,"onSkip",a.getValue(r.onSkip.nos,t),t):"",s[e.take]="onTake"in r?a.callAdaptorFunction(this,"onTake",a.getValue(r.onTake.nos,t),t):"",s[e.where]=n.filters.length||n.searches.length?a.callAdaptorFunction(this,"onWhere",n.filters,t):"",s[e.sortBy]=n.sorts.length?a.callAdaptorFunction(this,"onSortBy",n.sorts,t):"",s[e.group]=n.groups.length?a.callAdaptorFunction(this,"onGroup",n.groups,t):"",s[e.aggregates]=n.aggregates.length?a.callAdaptorFunction(this,"onAggregates",n.aggregates,t):"",s.param=[]},o.prototype.convertToQueryString=function(e,t,r){return""},o.prototype.processResponse=function(e,r,n,o,s,i){if(o&&o.getResponseHeader("Content-Type")&&-1!==o.getResponseHeader("Content-Type").indexOf("application/json")){var u=a.timeZoneHandling;r&&!r.timeZoneHandling&&(a.timeZoneHandling=!1),e=a.parse.parseJson(e),a.timeZoneHandling=u}var c=s,l=c.pvtData||{},p=e?e.groupDs:[];if(o&&o.getResponseHeader("Content-Type")&&-1!==o.getResponseHeader("Content-Type").indexOf("xml"))return n.isCountRequired?{result:[],count:0}:[];var d=JSON.parse(c.data);if(d&&"batch"===d.action&&e&&e.addedRecords)return i.addedRecords=e.addedRecords,i;e&&e.d&&(e=e.d);var h={};e&&"count"in e&&(h.count=e.count),h.result=e&&e.result?e.result:e;var f=!1;if(Array.isArray(e.result)&&e.result.length){if(t.isNullOrUndefined(e.result[0].key)||(h.result=this.formRemoteGroupedData(h.result,1,l.groups.length-1)),n&&n.lazyLoad.length&&l.groups.length)for(var g=0;g<n.lazyLoad.length;g++)if("onDemandGroupInfo"===n.lazyLoad[g].key){var y=n.lazyLoad[g].value.level;l.groups.length===y&&(f=!0)}}return f||this.getAggregateResult(l,e,h,p,n),a.isNull(h.count)?h.result:{result:h.result,count:h.count,aggregates:h.aggregates}},o.prototype.formRemoteGroupedData=function(e,r,n){for(var o=0;o<e.length;o++)e[o].items.length&&Object.keys(e[o].items[0]).indexOf("key")>-1&&this.formRemoteGroupedData(e[o].items,r+1,n-1);return e.GroupGuid=i.GroupGuid,e.level=r,e.childLevels=n,e.records=e[0].items.length?this.getGroupedRecords(e,!t.isNullOrUndefined(e[0].items.records)):[],e},o.prototype.getGroupedRecords=function(e,t){for(var r=[],n=0;n<e.length;n++)if(t)r=r.concat(e[n].items.records);else for(var o=0;o<e[n].items.length;o++)r.push(e[n].items[o]);return r},o.prototype.onGroup=function(e){return this.pvt.groups=e,e},o.prototype.onAggregates=function(e){this.pvt.aggregates=e},o.prototype.batchRequest=function(e,r,n,o,s){return{type:"POST",url:e.dataSource.batchUrl||e.dataSource.crudUrl||e.dataSource.removeUrl||e.dataSource.url,contentType:"application/json; charset=utf-8",dataType:"json",data:JSON.stringify(t.extend({},{changed:r.changedRecords,added:r.addedRecords,deleted:r.deletedRecords,action:"batch",table:n[void 0],key:n[void 0]},a.getAddParams(this,e,o)))}},o.prototype.beforeSend=function(e,t){},o.prototype.insert=function(e,r,n,o){return{url:e.dataSource.insertUrl||e.dataSource.crudUrl||e.dataSource.url,data:JSON.stringify(t.extend({},{value:r,table:n,action:"insert"},a.getAddParams(this,e,o)))}},o.prototype.remove=function(e,r,n,o,s){return{type:"POST",url:e.dataSource.removeUrl||e.dataSource.crudUrl||e.dataSource.url,data:JSON.stringify(t.extend({},{key:n,keyColumn:r,table:o,action:"remove"},a.getAddParams(this,e,s)))}},o.prototype.update=function(e,r,n,o,s){return{type:"POST",url:e.dataSource.updateUrl||e.dataSource.crudUrl||e.dataSource.url,data:JSON.stringify(t.extend({},{value:n,action:"update",keyColumn:r,key:a.getObject(r,n),table:o},a.getAddParams(this,e,s)))}},o.prototype.getFiltersFrom=function(e,t){var r,o=t.fKey,s=o,i=t.key,u=[];"object"!=typeof e[0]&&(s=null);for(var c=0;c<e.length;c++)r="object"==typeof e[0]?a.getObject(i||s,e[c]):e[c],u.push(new n(o,"equal",r));return n.or(u)},o.prototype.getAggregateResult=function(e,n,o,s,i){var u=n;if(n&&n.result&&(u=n.result),e&&e.aggregates&&e.aggregates.length){var c=e.aggregates,l=void 0,p=u,d={};n.aggregate&&(p=n.aggregate);for(var h=0;h<c.length;h++)(l=a.aggregates[c[h].type])&&(d[c[h].field+" - "+c[h].type]=l(p,c[h].field));o.aggregates=d}var f=Array.isArray(n.result)&&n.result.length&&!t.isNullOrUndefined(n.result[0].key);if(e&&e.groups&&e.groups.length&&!f){var g=e.groups;for(h=0;h<g.length;h++){t.isNullOrUndefined(s)||(s=a.group(s,g[h]));var y=r.filterQueries(i.queries,"onGroup")[h].e;u=a.group(u,g[h],e.aggregates,null,s,y.comparer)}o.result=u}return o},o.prototype.getQueryRequest=function(e){var t={sorts:[],groups:[],filters:[],searches:[],aggregates:[]};return t.sorts=r.filterQueries(e.queries,"onSortBy"),t.groups=r.filterQueries(e.queries,"onGroup"),t.filters=r.filterQueries(e.queries,"onWhere"),t.searches=r.filterQueries(e.queries,"onSearch"),t.aggregates=r.filterQueries(e.queries,"onAggregates"),t},o.prototype.addParams=function(e){var t=e.reqParams;e.params.length&&(t.params={});for(var r=0,n=e.params;r<n.length;r++){var o=n[r];if(t[o.key])throw new Error("Query() - addParams: Custom Param is conflicting other request arguments");t[o.key]=o.value,o.fn&&(t[o.key]=o.fn.call(e.query,o.key,e.query,e.dm)),t.params[o.key]=t[o.key]}},o}(u),p=function(e){function r(r){var n=e.call(this)||this;return n.options=t.extend({},n.options,{requestType:"get",accept:"application/json;odata=light;q=1,application/json;odata=verbose;q=0.5",multipartAccept:"multipart/mixed",sortBy:"$orderby",select:"$select",skip:"$skip",take:"$top",count:"$inlinecount",where:"$filter",expand:"$expand",batch:"$batch",changeSet:"--changeset_",batchPre:"batch_",contentId:"Content-Id: ",batchContent:"Content-Type: multipart/mixed; boundary=",changeSetContent:"Content-Type: application/http\nContent-Transfer-Encoding: binary ",batchChangeSetContentType:"Content-Type: application/json; charset=utf-8 ",updateType:"PUT"}),t.extend(n.options,r||{}),n}return s(r,e),r.prototype.getModuleName=function(){return"ODataAdaptor"},r.prototype.onPredicate=function(e,n,o){var s,i,u="",c=e.value,l=typeof c,p=e.field?r.getField(e.field):null;if(c instanceof Date&&(c="datetime'"+a.parse.replacer(c)+"'"),"string"===l&&(c=c.replace(/'/g,"''"),e.ignoreCase&&(c=c.toLowerCase()),c="'"+(c=encodeURIComponent(c))+"'",o&&(p="cast("+p+", 'Edm.String')"),a.parse.isGuid(c)&&(i="guid"),e.ignoreCase&&(i||(p="tolower("+p+")"),c=c.toLowerCase())),s=a.odBiOperator[e.operator])return u+=p,u+=s,i&&(u+=i),u+c;if("substringof"===(s=t.isNullOrUndefined(this.getModuleName)||"ODataV4Adaptor"!==this.getModuleName()?a.odUniOperator[e.operator]:a.odv4UniOperator[e.operator])){var d=c;c=p,p=d}return u+=s+"(",u+=p+",",i&&(u+=i),u+=c+")"},r.prototype.addParams=function(t){e.prototype.addParams.call(this,t),delete t.reqParams.params},r.prototype.onComplexPredicate=function(e,t,r){for(var n=[],o=0;o<e.predicates.length;o++)n.push("("+this.onEachWhere(e.predicates[o],t,r)+")");return n.join(" "+e.condition+" ")},r.prototype.onEachWhere=function(e,t,r){return e.isComplex?this.onComplexPredicate(e,t,r):this.onPredicate(e,t,r)},r.prototype.onWhere=function(e){return this.pvt.search&&e.push(this.onEachWhere(this.pvt.search,null,!0)),e.join(" and ")},r.prototype.onEachSearch=function(e){e.fields&&0===e.fields.length&&a.throwError("Query() - Search : oData search requires list of field names to search");for(var t=this.pvt.search||[],r=0;r<e.fields.length;r++)t.push(new n(e.fields[r],e.operator,e.key,e.ignoreCase));this.pvt.search=t},r.prototype.onSearch=function(e){return this.pvt.search=n.or(this.pvt.search),""},r.prototype.onEachSort=function(e){var t=[];if(e.name instanceof Array)for(var n=0;n<e.name.length;n++)t.push(r.getField(e.name[n])+("descending"===e.direction?" desc":""));else t.push(r.getField(e.name)+("descending"===e.direction?" desc":""));return t.join(",")},r.prototype.onSortBy=function(e){return e.reverse().join(",")},r.prototype.onGroup=function(e){return this.pvt.groups=e,[]},r.prototype.onSelect=function(e){for(var t=0;t<e.length;t++)e[t]=r.getField(e[t]);return e.join(",")},r.prototype.onAggregates=function(e){return this.pvt.aggregates=e,""},r.prototype.onCount=function(e){return!0===e?"allpages":""},r.prototype.beforeSend=function(e,t,r){a.endsWith(r.url,this.options.batch)&&"post"===r.type.toLowerCase()?(t.setRequestHeader("Accept",this.options.multipartAccept),t.setRequestHeader("DataServiceVersion","2.0"),t.overrideMimeType("text/plain; charset=x-user-defined")):t.setRequestHeader("Accept",this.options.accept),t.setRequestHeader("DataServiceVersion","2.0"),t.setRequestHeader("MaxDataServiceVersion","2.0")},r.prototype.processResponse=function(e,r,n,o,s,i){var u="odata.metadata";if(s&&"GET"===s.type&&!this.rootUrl&&e[u]){var c=e[u].split("/$metadata#");this.rootUrl=c[0],this.resourceTableName=c[1]}if(!t.isNullOrUndefined(e.d)){var l=n&&n.isCountRequired?e.d.results:e.d;if(!t.isNullOrUndefined(l))for(var p=0;p<l.length;p++)t.isNullOrUndefined(l[p].__metadata)||delete l[p].__metadata}var d=s&&s.pvtData,h=this.processBatchResponse(e,n,o,s,i);if(h)return h;var f=o&&s.getResponseHeader("DataServiceVersion"),g=null,y=f&&parseInt(f,10)||2;if(n&&n.isCountRequired){var v="__count";(e[v]||e["odata.count"])&&(g=e[v]||e["odata.count"]),e.d&&(e=e.d),(e[v]||e["odata.count"])&&(g=e[v]||e["odata.count"])}3===y&&e.value&&(e=e.value),e.d&&(e=e.d),y<3&&e.results&&(e=e.results);var m={};return m.count=g,m.result=e,this.getAggregateResult(d,e,m,null,n),a.isNull(g)?m.result:{result:m.result,count:m.count,aggregates:m.aggregates}},r.prototype.convertToQueryString=function(e,t,r){var n=[],o=e.table||"";delete e.table,r.dataSource.requiresFormat&&(e.$format="json");for(var a=0,s=Object.keys(e);a<s.length;a++){var i=s[a];n.push(i+"="+e[i])}return n=n.join("&"),r.dataSource.url&&-1!==r.dataSource.url.indexOf("?")&&!o?n:n.length?o+"?"+n:o||""},r.prototype.localTimeReplacer=function(e,r){for(var n=0,o=t.isNullOrUndefined(r)?[]:Object.keys(r);n<o.length;n++){var s=o[n];r[s]instanceof Date&&(r[s]=a.dateParse.toLocalTime(r[s]))}return r},r.prototype.insert=function(e,t,r){return{url:(e.dataSource.insertUrl||e.dataSource.url).replace(/\/*$/,r?"/"+r:""),data:JSON.stringify(t,this.options.localTime?this.localTimeReplacer:null)}},r.prototype.remove=function(e,t,r,n){var o;return o="string"!=typeof r||a.parse.isGuid(r)?"("+r+")":"('"+r+"')",{type:"DELETE",url:(e.dataSource.removeUrl||e.dataSource.url).replace(/\/*$/,n?"/"+n:"")+o}},r.prototype.update=function(e,r,n,o,s,i){"PATCH"!==this.options.updateType||t.isNullOrUndefined(i)||(n=this.compareAndRemove(n,i,r));var u;return u="string"!=typeof n[r]||a.parse.isGuid(n[r])?"("+n[r]+")":"('"+n[r]+"')",{type:this.options.updateType,url:(e.dataSource.updateUrl||e.dataSource.url).replace(/\/*$/,o?"/"+o:"")+u,data:JSON.stringify(n,this.options.localTime?this.localTimeReplacer:null),accept:this.options.accept}},r.prototype.batchRequest=function(e,t,r,n,o){var s=r.guid=a.getGuid(this.options.batchPre),i=this.rootUrl?this.rootUrl+"/"+this.options.batch:e.dataSource.url.replace(/\/*$/,"/"+this.options.batch);r.url=this.resourceTableName?this.resourceTableName:r.url;var u={url:r.url,key:r.key,cid:1,cSet:a.getGuid(this.options.changeSet)},c="--"+s+"\n";return c+="Content-Type: multipart/mixed; boundary="+u.cSet.replace("--","")+"\n",this.pvt.changeSet=0,c+=this.generateInsertRequest(t.addedRecords,u,e),c+=this.generateUpdateRequest(t.changedRecords,u,e,o?o.changedRecords:[]),c+=this.generateDeleteRequest(t.deletedRecords,u,e),c+=u.cSet+"--\n",c+="--"+s+"--",{type:"POST",url:i,dataType:"json",contentType:"multipart/mixed; charset=UTF-8;boundary="+s,data:c}},r.prototype.generateDeleteRequest=function(e,t,r){if(!e)return"";var n={method:"DELETE ",url:function(e,t,r){var n=a.getObject(r,e[t]);if("number"==typeof n||a.parse.isGuid(n))return"("+n+")";if(n instanceof Date){return"("+e[t][r].toJSON()+")"}return"('"+n+"')"},data:function(e,t){return""}};return this.generateBodyContent(e,t,n,r)+"\n"},r.prototype.generateInsertRequest=function(e,t,r){if(!e)return"";var n={method:"POST ",url:function(e,t,r){return""},data:function(e,t){return JSON.stringify(e[t])+"\n\n"}};return this.generateBodyContent(e,t,n,r)},r.prototype.generateUpdateRequest=function(e,t,r,n){var o=this;if(!e)return"";e.forEach(function(e){return e=o.compareAndRemove(e,n.filter(function(r){return a.getObject(t.key,r)===a.getObject(t.key,e)})[0],t.key)});var s={method:this.options.updateType+" ",url:function(e,t,r){if("number"==typeof e[t][r]||a.parse.isGuid(e[t][r]))return"("+e[t][r]+")";if(e[t][r]instanceof Date){return"("+e[t][r].toJSON()+")"}return"('"+e[t][r]+"')"},data:function(e,t){return JSON.stringify(e[t])+"\n\n"}};return this.generateBodyContent(e,t,s,r)},r.getField=function(e){return e.replace(/\./g,"/")},r.prototype.generateBodyContent=function(e,r,n,o){for(var a="",s=0;s<e.length;s++)a+="\n"+r.cSet+"\n",a+=this.options.changeSetContent+"\n\n",a+=n.method,"POST "===n.method?a+=(o.dataSource.insertUrl||o.dataSource.crudUrl||r.url)+n.url(e,s,r.key)+" HTTP/1.1\n":"PUT "===n.method||"PATCH "===n.method?a+=(o.dataSource.updateUrl||o.dataSource.crudUrl||r.url)+n.url(e,s,r.key)+" HTTP/1.1\n":"DELETE "===n.method&&(a+=(o.dataSource.removeUrl||o.dataSource.crudUrl||r.url)+n.url(e,s,r.key)+" HTTP/1.1\n"),a+="Accept: "+this.options.accept+"\n",a+="Content-Id: "+this.pvt.changeSet+++"\n",a+=this.options.batchChangeSetContentType+"\n",t.isNullOrUndefined(e[s]["@odata.etag"])?a+="\n":(a+="If-Match: "+e[s]["@odata.etag"]+"\n\n",delete e[s]["@odata.etag"]),a+=n.data(e,s);return a},r.prototype.processBatchResponse=function(e,r,n,o,s){if(n&&n.getResponseHeader("Content-Type")&&-1!==n.getResponseHeader("Content-Type").indexOf("xml"))return r.isCountRequired?{result:[],count:0}:[];if(o&&this.options.batch&&a.endsWith(o.url,this.options.batch)&&"post"===o.type.toLowerCase()){var i=n.getResponseHeader("Content-Type"),u=void 0,c=void 0,l=e+"";if(i=i.substring(i.indexOf("=batchresponse")+1),(l=l.split(i)).length<2)return{};l=l[1];var p=/(?:\bContent-Type.+boundary=)(changesetresponse.+)/i.exec(l);p&&l.replace(p[0],"");for(var d=p?p[1]:"",h=(l=l.split(d)).length;h>-1;h--)/\bContent-ID:/i.test(l[h])&&/\bHTTP.+201/.test(l[h])&&(u=parseInt(/\bContent-ID: (\d+)/i.exec(l[h])[1],10),s.addedRecords[u]&&(c=a.parse.parseJson(/^\{.+\}/m.exec(l[h])[0]),t.extend({},s.addedRecords[u],this.processResponse(c))));return s}return null},r.prototype.compareAndRemove=function(e,r,n){var o=this;return t.isNullOrUndefined(r)?e:(Object.keys(e).forEach(function(t){if(t!==n&&"@odata.etag"!==t)if(a.isPlainObject(e[t])){o.compareAndRemove(e[t],r[t]);0===Object.keys(e[t]).filter(function(e){return"@odata.etag"!==e}).length&&delete e[t]}else e[t]===r[t]?delete e[t]:e[t]&&r[t]&&e[t].valueOf()===r[t].valueOf()&&delete e[t]}),e)},r}(l),d=function(e){function n(r){var n=e.call(this,r)||this;return n.options=t.extend({},n.options,{requestType:"get",accept:"application/json, text/javascript, */*; q=0.01",multipartAccept:"multipart/mixed",sortBy:"$orderby",select:"$select",skip:"$skip",take:"$top",count:"$count",search:"$search",where:"$filter",expand:"$expand",batch:"$batch",changeSet:"--changeset_",batchPre:"batch_",contentId:"Content-Id: ",batchContent:"Content-Type: multipart/mixed; boundary=",changeSetContent:"Content-Type: application/http\nContent-Transfer-Encoding: binary ",batchChangeSetContentType:"Content-Type: application/json; charset=utf-8 ",updateType:"PATCH",localTime:!1,apply:"$apply"}),t.extend(n.options,r||{}),n}return s(n,e),n.prototype.getModuleName=function(){return"ODataV4Adaptor"},n.prototype.onCount=function(e){return!0===e?"true":""},n.prototype.onPredicate=function(t,n,o){var s="",i=t.value,u=i instanceof Date;if(n instanceof r)for(var c=this.getQueryRequest(n),l=0;l<c.filters.length;l++)c.filters[l].e.key===t.value&&(o=!0);return s=e.prototype.onPredicate.call(this,t,n,o),u&&(s=s.replace(/datetime'(.*)'$/,"$1")),a.parse.isGuid(i)&&(s=s.replace("guid","").replace(/'/g,"")),s},n.prototype.onEachSearch=function(e){var t=this.pvt.searches||[];t.push(e.key),this.pvt.searches=t},n.prototype.onSearch=function(e){return this.pvt.searches.join(" OR ")},n.prototype.onExpand=function(e){var t=this,r={},n={},o=e.expands.slice(),a=[];return e.selects.filter(function(e){return e.indexOf(".")>-1}).forEach(function(e){var n=e.split(".");if(n[0]in r||(r[n[0]]=[]),2==n.length)r[n[0]].length&&-1!==Object.keys(r).indexOf(n[0])?-1!==r[n[0]][0].indexOf("$expand")&&-1===r[n[0]][0].indexOf(";$select=")?r[n[0]][0]=r[n[0]][0]+";$select="+n[1]:r[n[0]][0]=r[n[0]][0]+","+n[1]:r[n[0]].push("$select="+n[1]);else{for(var o="$select="+n[n.length-1],a="",s="",i=1;i<n.length-1;i++)a=a+"$expand="+n[i]+"(",s+=")";var u=a+o+s;if(r[n[0]].length&&-1!==Object.keys(r).indexOf(n[0])&&t.expandQueryIndex(r[n[0]],!0)){var c=t.expandQueryIndex(r[n[0]]);r[n[0]][c]=r[n[0]][c]+u.replace("$expand=",",")}else r[n[0]].push(u)}}),Object.keys(r).forEach(function(e){-1===o.indexOf(e)&&o.push(e)}),o.forEach(function(e){n[e]=e in r?e+"("+r[e].join(";")+")":e}),Object.keys(n).forEach(function(e){return a.push(n[e])}),a.join(",")},n.prototype.expandQueryIndex=function(e,t){for(var r=0;r<e.length;r++)if(-1!==e[r].indexOf("$expand"))return!!t||r;return!t&&0},n.prototype.onDistinct=function(e){return"groupby(("+e.map(function(e){return p.getField(e)}).join(",")+"))"},n.prototype.onSelect=function(t){return e.prototype.onSelect.call(this,t.filter(function(e){return-1===e.indexOf(".")}))},n.prototype.beforeSend=function(e,t,r){"POST"!==r.type&&"PUT"!==r.type&&"PATCH"!==r.type||t.setRequestHeader("Prefer","return=representation"),t.setRequestHeader("Accept",this.options.accept)},n.prototype.processResponse=function(r,n,o,s,i,u){if(i&&"GET"===i.type&&!this.rootUrl&&r["@odata.context"]){var c=r["@odata.context"].split("/$metadata#");this.rootUrl=c[0],this.resourceTableName=c[1]}var l=i&&i.pvtData,p=e.prototype.processBatchResponse.call(this,r,o,s,i,u);if(p)return p;var d=null;o&&o.isCountRequired&&"@odata.count"in r&&(d=r["@odata.count"]),r=t.isNullOrUndefined(r.value)?r:r.value;var h={};return h.count=d,h.result=r,this.getAggregateResult(l,r,h,null,o),a.isNull(d)?h.result:{result:h.result,count:d,aggregates:h.aggregates}},n}(p),h=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return s(t,e),t.prototype.getModuleName=function(){return"WebApiAdaptor"},t.prototype.insert=function(e,t,r){return{type:"POST",url:e.dataSource.url,data:JSON.stringify(t)}},t.prototype.remove=function(e,t,r,n){return{type:"DELETE",url:e.dataSource.url+"/"+r,data:JSON.stringify(r)}},t.prototype.update=function(e,t,r,n){return{type:"PUT",url:e.dataSource.url,data:JSON.stringify(r)}},t.prototype.batchRequest=function(e,t,r){var n=this,o=r.guid=a.getGuid(this.options.batchPre),s=e.dataSource.url.replace(/\/*$/,"/"+this.options.batch);r.url=this.resourceTableName?this.resourceTableName:r.url;for(var i=[],u=function(n,a){t.addedRecords.forEach(function(a,s){var u=function(e,t,r){return""};i.push("--"+o),i.push("Content-Type: application/http; msgtype=request",""),i.push("POST /api/"+(e.dataSource.insertUrl||e.dataSource.crudUrl||r.url)+u(t.addedRecords,n,r.key)+" HTTP/1.1"),i.push("Content-Type: application/json; charset=utf-8"),i.push("Host: "+location.host),i.push("",a?JSON.stringify(a):"")})},c=0,l=t.addedRecords.length;c<l;c++)u(c);var p=function(a,s){t.changedRecords.forEach(function(s,u){n.options.updateType;var c=function(e,t,r){return""};i.push("--"+o),i.push("Content-Type: application/http; msgtype=request",""),i.push("PUT /api/"+(e.dataSource.updateUrl||e.dataSource.crudUrl||r.url)+c(t.changedRecords,a,r.key)+" HTTP/1.1"),i.push("Content-Type: application/json; charset=utf-8"),i.push("Host: "+location.host),i.push("",s?JSON.stringify(s):"")})};for(c=0,l=t.changedRecords.length;c<l;c++)p(c);var d=function(n,s){t.deletedRecords.forEach(function(s,u){var c=function(e,t,r){var n=a.getObject(r,e[t]);if("number"==typeof n||a.parse.isGuid(n))return"/"+n;if(n instanceof Date){return"/"+e[t][r].toJSON()}return"/'"+n+"'"};i.push("--"+o),i.push("Content-Type: application/http; msgtype=request",""),i.push("DELETE /api/"+(e.dataSource.removeUrl||e.dataSource.crudUrl||r.url)+c(t.deletedRecords,n,r.key)+" HTTP/1.1"),i.push("Content-Type: application/json; charset=utf-8"),i.push("Host: "+location.host),i.push("",s?JSON.stringify(s):"")})};for(c=0,l=t.deletedRecords.length;c<l;c++)d(c);return i.push("--"+o+"--",""),{type:"POST",url:s,contentType:"multipart/mixed; boundary="+o,data:i.join("\r\n")}},t.prototype.beforeSend=function(e,t,r){t.setRequestHeader("Accept","application/json, text/javascript, */*; q=0.01")},t.prototype.processResponse=function(e,t,r,n,o,s){var i=o&&o.pvtData,u=null,c={};if(o&&"post"!==o.type.toLowerCase()){var l=n&&o.getResponseHeader("DataServiceVersion"),p=l&&parseInt(l,10)||2;r&&r.isCountRequired&&(a.isNull(e.Count)||(u=e.Count)),p<3&&e.Items&&(e=e.Items),c.count=u,c.result=e,this.getAggregateResult(i,e,c,null,r)}return c.result=c.result||e,a.isNull(u)?c.result:{result:c.result,count:c.count,aggregates:c.aggregates}},t}(p),f=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return s(t,e),t.prototype.processQuery=function(e,t,r){var n=(new l).processQuery(e,t,r),o=a.parse.parseJson(n.data),s={};if(o.param)for(var i=0;i<o.param.length;i++){var u=o.param[i],c=Object.keys(u)[0];s[c]=u[c]}s.value=o;return{data:JSON.stringify(s),url:n.url,pvtData:n.pvtData,type:"POST",contentType:"application/json; charset=utf-8"}},t}(l),g=function(e){function r(){var r=e.call(this)||this;return t.setValue("beforeSend",l.prototype.beforeSend,r),r}return s(r,e),r.prototype.insert=function(e,r,n,o,s){return this.pvt.position=s,this.updateType="add",{url:e.dataSource.insertUrl||e.dataSource.crudUrl||e.dataSource.url,data:JSON.stringify(t.extend({},{value:r,table:n,action:"insert"},a.getAddParams(this,e,o)))}},r.prototype.remove=function(r,n,o,s,i){return e.prototype.remove.call(this,r,n,o),{type:"POST",url:r.dataSource.removeUrl||r.dataSource.crudUrl||r.dataSource.url,data:JSON.stringify(t.extend({},{key:o,keyColumn:n,table:s,action:"remove"},a.getAddParams(this,r,i)))}},r.prototype.update=function(e,r,n,o,s){return this.updateType="update",this.updateKey=r,{type:"POST",url:e.dataSource.updateUrl||e.dataSource.crudUrl||e.dataSource.url,data:JSON.stringify(t.extend({},{value:n,action:"update",keyColumn:r,key:n[r],table:o},a.getAddParams(this,e,s)))}},r.prototype.processResponse=function(t,r,n,o,s,i,u){var c;if(t="batch"===(s?JSON.parse(s.data):t).action?a.parse.parseJson(t):t,"add"===this.updateType&&e.prototype.insert.call(this,r,t,null,null,this.pvt.position),"update"===this.updateType&&e.prototype.update.call(this,r,this.updateKey,t),this.updateType=void 0,t.added)for(c=0;c<t.added.length;c++)e.prototype.insert.call(this,r,t.added[c]);if(t.changed)for(c=0;c<t.changed.length;c++)e.prototype.update.call(this,r,u.key,t.changed[c]);if(t.deleted)for(c=0;c<t.deleted.length;c++)e.prototype.remove.call(this,r,u.key,t.deleted[c]);return t},r.prototype.batchRequest=function(e,r,n,o,s){return{type:"POST",url:e.dataSource.batchUrl||e.dataSource.crudUrl||e.dataSource.url,contentType:"application/json; charset=utf-8",dataType:"json",data:JSON.stringify(t.extend({},{changed:r.changedRecords,added:r.addedRecords,deleted:r.deletedRecords,action:"batch",table:n.url,key:n.key},a.getAddParams(this,e,o)))}},r.prototype.addParams=function(e){(new l).addParams(e)},r}(c),y=function(e){function r(r){var n=e.call(this)||this;return n.options=t.extend({},n.options,{getData:new Function,addRecord:new Function,updateRecord:new Function,deleteRecord:new Function,batchUpdate:new Function}),t.extend(n.options,r||{}),n}return s(r,e),r.prototype.getModuleName=function(){return"CustomDataAdaptor"},r}(l),v=function(e){function r(t){var r=e.call(this)||this;return r.opt=t,r.schema=r.opt.response,r.query=r.opt.query,r.getVariables=r.opt.getVariables?r.opt.getVariables:function(){},r.getQuery=function(){return r.query},r}return s(r,e),r.prototype.getModuleName=function(){return"GraphQLAdaptor"},r.prototype.processQuery=function(t,r){var n=e.prototype.processQuery.apply(this,arguments),o=JSON.parse(n.data),a={};["skip","take","sorted","table","select","where","search","requiresCounts","aggregates","params"].filter(function(e){a[e]="searchwhereparams".indexOf(e)>-1?JSON.stringify(o[e]):o[e]});var s=this.getVariables()||{};s.datamanager=a;var i=JSON.stringify({query:this.getQuery(),variables:s});return n.data=i,n},r.prototype.processResponse=function(e,r,n,o,s){var i,u,c=e,l=t.getValue(this.schema.result,c.data);this.schema.count&&(i=t.getValue(this.schema.count,c.data)),this.schema.aggregates&&(u=t.getValue(this.schema.aggregates,c.data),u=t.isNullOrUndefined(u)?u:a.parse.parseJson(u));var p=s.pvtData||{},d={result:l,aggregates:u},h=d;return p&&p.groups&&p.groups.length&&this.getAggregateResult(p,h,d,null,n),t.isNullOrUndefined(i)?d.result:{result:d.result,count:i,aggregates:u}},r.prototype.insert=function(){var t=e.prototype.insert.apply(this,arguments);return this.generateCrudData(t,"insert")},r.prototype.update=function(){var t=e.prototype.update.apply(this,arguments);return this.generateCrudData(t,"update")},r.prototype.remove=function(){var t=e.prototype.remove.apply(this,arguments);return this.generateCrudData(t,"remove")},r.prototype.batchRequest=function(t,r,n,o,a){var s=e.prototype.batchRequest.apply(this,arguments),i=JSON.parse(s.data);return i.key=n.key,s.data=JSON.stringify(i),this.generateCrudData(s,"batch")},r.prototype.generateCrudData=function(e,t){var r=JSON.parse(e.data);return e.data=JSON.stringify({query:this.opt.getMutation(t),variables:r}),e},r}(l),m=function(e){function n(r,n,o){var s=e.call(this)||this;s.isCrudAction=!1,s.isInsertAction=!1,t.isNullOrUndefined(r)||(s.cacheAdaptor=r),s.pageSize=o,s.guidId=a.getGuid("cacheAdaptor");window.localStorage.setItem(s.guidId,JSON.stringify({keys:[],results:[]}));var i=s.guidId;return t.isNullOrUndefined(n)||setInterval(function(){var e;e=a.parse.parseJson(window.localStorage.getItem(i));for(var t=[],r=0;r<e.results.length;r++){var o=+new Date,s=+new Date(e.results[r].timeStamp);e.results[r].timeStamp=o-s,o-s>n&&t.push(r)}for(r=0;r<t.length;r++)e.results.splice(t[r],1),e.keys.splice(t[r],1);window.localStorage.removeItem(i),window.localStorage.setItem(i,JSON.stringify(e))},n),s}return s(n,e),n.prototype.generateKey=function(e,t){var n=this.getQueryRequest(t),o=r.filterQueryLists(t.queries,["onSelect","onPage","onSkip","onTake","onRange"]),a=e;"onPage"in o&&(a+=o.onPage.pageIndex),n.sorts.forEach(function(e){a+=e.e.direction+e.e.fieldName}),n.groups.forEach(function(e){a+=e.e.fieldName}),n.searches.forEach(function(e){a+=e.e.searchKey});for(var s=0;s<n.filters.length;s++){var i=n.filters[s];if(i.e.isComplex){var u=t.clone();u.queries=[];for(var c=0;c<i.e.predicates.length;c++)u.queries.push({fn:"onWhere",e:i.e.predicates[c],filter:t.queries.filter});a+=i.e.condition+this.generateKey(e,u)}else a+=i.e.field+i.e.operator+i.e.value}return a},n.prototype.processQuery=function(e,t,r){var n,o=this.generateKey(e.dataSource.url,t),s=(n=a.parse.parseJson(window.localStorage.getItem(this.guidId)))?n.results[n.keys.indexOf(o)]:null;return null==s||this.isCrudAction||this.isInsertAction?(this.isCrudAction=null,this.isInsertAction=null,this.cacheAdaptor.processQuery.apply(this.cacheAdaptor,[].slice.call(arguments,0))):s},n.prototype.processResponse=function(e,t,r,n,o,s){if(this.isInsertAction||o&&this.cacheAdaptor.options.batch&&a.endsWith(o.url,this.cacheAdaptor.options.batch)&&"post"===o.type.toLowerCase())return this.cacheAdaptor.processResponse(e,t,r,n,o,s);e=this.cacheAdaptor.processResponse.apply(this.cacheAdaptor,[].slice.call(arguments,0));var i=r?this.generateKey(t.dataSource.url,r):t.dataSource.url,u={},c=(u=a.parse.parseJson(window.localStorage.getItem(this.guidId))).keys.indexOf(i);for(-1!==c&&(u.results.splice(c,1),u.keys.splice(c,1)),u.results[u.keys.push(i)-1]={keys:i,result:e.result,timeStamp:new Date,count:e.count};u.results.length>this.pageSize;)u.results.splice(0,1),u.keys.splice(0,1);return window.localStorage.setItem(this.guidId,JSON.stringify(u)),e},n.prototype.beforeSend=function(e,r,n){!t.isNullOrUndefined(this.cacheAdaptor.options.batch)&&a.endsWith(n.url,this.cacheAdaptor.options.batch)&&"post"===n.type.toLowerCase()&&r.setRequestHeader("Accept",this.cacheAdaptor.options.multipartAccept),e.dataSource.crossDomain||r.setRequestHeader("Accept",this.cacheAdaptor.options.accept)},n.prototype.update=function(e,t,r,n){return this.isCrudAction=!0,this.cacheAdaptor.update(e,t,r,n)},n.prototype.insert=function(e,t,r){return this.isInsertAction=!0,this.cacheAdaptor.insert(e,t,r)},n.prototype.remove=function(e,t,r,n){return this.isCrudAction=!0,this.cacheAdaptor.remove(e,t,r,n)},n.prototype.batchRequest=function(e,t,r){return this.cacheAdaptor.batchRequest(e,t,r)},n}(l),S=function(){function e(e,n,o){var s=this;this.dateParse=!0,this.timeZoneHandling=!0,this.requests=[],e||this.dataSource||(e=[]),o=o||e.adaptor,e&&!1===e.timeZoneHandling&&(this.timeZoneHandling=e.timeZoneHandling);var i;return e instanceof Array?i={json:e,offline:!0}:"object"==typeof e?(e.json||(e.json=[]),i={url:e.url,insertUrl:e.insertUrl,removeUrl:e.removeUrl,updateUrl:e.updateUrl,crudUrl:e.crudUrl,batchUrl:e.batchUrl,json:e.json,headers:e.headers,accept:e.accept,data:e.data,timeTillExpiration:e.timeTillExpiration,cachingPageSize:e.cachingPageSize,enableCaching:e.enableCaching,requestType:e.requestType,key:e.key,crossDomain:e.crossDomain,jsonp:e.jsonp,dataType:e.dataType,offline:void 0!==e.offline?e.offline:!(e.adaptor instanceof g||e.adaptor instanceof y)&&!e.url,requiresFormat:e.requiresFormat}):a.throwError("DataManager: Invalid arguments"),void 0!==i.requiresFormat||a.isCors()||(i.requiresFormat=!!t.isNullOrUndefined(i.crossDomain)||i.crossDomain),void 0===i.dataType&&(i.dataType="json"),this.dataSource=i,this.defaultQuery=n,i.url&&i.offline&&!i.json.length?(this.isDataAvailable=!1,this.adaptor=o||new p,this.dataSource.offline=!1,this.ready=this.executeQuery(n||new r),this.ready.then(function(e){s.dataSource.offline=!0,s.isDataAvailable=!0,i.json=e.result,s.adaptor=new c})):this.adaptor=i.offline?new c:new p,!i.jsonp&&this.adaptor instanceof p&&(i.jsonp="callback"),this.adaptor=o||this.adaptor,i.enableCaching&&(this.adaptor=new m(this.adaptor,i.timeTillExpiration,i.cachingPageSize)),this}return e.prototype.setDefaultQuery=function(e){return this.defaultQuery=e,this},e.prototype.executeLocal=function(n){this.defaultQuery||n instanceof r||a.throwError("DataManager - executeLocal() : A query is required to execute"),this.dataSource.json||a.throwError("DataManager - executeLocal() : Json data is required to execute"),n=n||this.defaultQuery;var o=this.adaptor.processQuery(this,n);if(n.subQuery){var s=n.subQuery.fromTable,i=n.subQuery.lookups,u=n.isCountRequired?o.result:o;i&&i instanceof Array&&a.buildHierarchy(n.subQuery.fKey,s,u,i,n.subQuery.key);for(var c=0;c<u.length;c++)u[c][s]instanceof Array&&(u[c]=t.extend({},{},u[c]),u[c][s]=this.adaptor.processResponse(n.subQuery.using(new e(u[c][s].slice(0))).executeLocal(),this,n))}return this.adaptor.processResponse(o,this,n)},e.prototype.executeQuery=function(n,o,s,i){var u=this,c="makeRequest";"function"==typeof n&&(i=s,s=o,o=n,n=null),n||(n=this.defaultQuery),n instanceof r||a.throwError("DataManager - executeQuery() : A query is required to execute");var l=new O,p={query:n};if(!this.dataSource.offline&&void 0!==this.dataSource.url&&""!==this.dataSource.url||!t.isNullOrUndefined(this.adaptor[c])||this.isCustomDataAdaptor(this.adaptor)){var d=this.adaptor.processQuery(this,n);t.isNullOrUndefined(this.adaptor[c])?!t.isNullOrUndefined(d.url)||this.isCustomDataAdaptor(this.adaptor)?this.makeRequest(d,l,p,n):(p=e.getDeferedArgs(n,d,p),l.resolve(p)):this.adaptor[c](d,l,p,n)}else e.nextTick(function(){var t=u.executeLocal(n);p=e.getDeferedArgs(n,t,p),l.resolve(p)});return(o||s)&&l.promise.then(o,s),i&&l.promise.then(i,i),l.promise},e.getDeferedArgs=function(e,t,r){return e.isCountRequired?(r.result=t.result,r.count=t.count,r.aggregates=t.aggregates):r.result=t,r},e.nextTick=function(e){(window.setImmediate||window.setTimeout)(e,0)},e.prototype.extendRequest=function(e,r,n){return t.extend({},{type:"GET",dataType:this.dataSource.dataType,crossDomain:this.dataSource.crossDomain,jsonp:this.dataSource.jsonp,cache:!0,processData:!1,onSuccess:r,onFailure:n},e)},e.prototype.makeRequest=function(e,r,n,o){var s=this,i=!!o.subQuerySelector,u=function(e){n.error=e,r.reject(n)},c=function(e,t,o,a,s,i,u){n.xhr=o,n.count=t?parseInt(t.toString(),10):0,n.result=e,n.request=a,n.aggregates=i,n.actual=s,n.virtualSelectRecords=u,r.resolve(n)},l=function(e,t){var r=new O,l={parent:n};o.subQuery.isChild=!0;var p=s.adaptor.processQuery(s,o.subQuery,e?s.adaptor.processResponse(e):t),d=s.makeRequest(p,r,l,o.subQuery);return i||r.then(function(t){e&&(a.buildHierarchy(o.subQuery.fKey,o.subQuery.fromTable,e,t,o.subQuery.key),c(e,t.count,t.xhr))},u),d},p=this.extendRequest(e,function(e,r){if(s.isGraphQLAdaptor(s.adaptor)&&!t.isNullOrUndefined(e.errors))return u(e.errors);s.isCustomDataAdaptor(s.adaptor)&&(r=t.extend({},s.ajaxReqOption,r)),-1===r.httpRequest.getResponseHeader("Content-Type").indexOf("xml")&&s.dateParse&&(e=a.parse.parseJson(e));var n=s.adaptor.processResponse(e,s,o,r.httpRequest,r),p=0,d=null,h=e.virtualSelectRecords;o.isCountRequired&&(p=n.count,d=n.aggregates,n=n.result),o.subQuery?i||l(n,r):c(n,p,r.httpRequest,r.type,e,d,h)},u);if(this.isCustomDataAdaptor(this.adaptor)){this.ajaxReqOption=p;var d=p;this.adaptor.options.getData({data:d.data,onSuccess:d.onSuccess,onFailure:d.onFailure})}else{var h=new t.Ajax(p);h.beforeSend=function(){s.beforeSend(h.httpRequest,h)},(p=h.send()).catch(function(e){return!0}),this.requests.push(h)}if(i){var f=o.subQuerySelector.call(this,{query:o.subQuery,parent:o});f&&f.length?Promise.all([p,l(null,f)]).then(function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var r=e[0],n=s.adaptor.processResponse(r[0],s,o,s.requests[0].httpRequest,s.requests[0]),u=0;o.isCountRequired&&(u=n.count,n=n.result);var l=s.adaptor.processResponse(r[1],s,o.subQuery,s.requests[1].httpRequest,s.requests[1]);u=0,o.subQuery.isCountRequired&&(u=l.count,l=l.result),a.buildHierarchy(o.subQuery.fKey,o.subQuery.fromTable,n,l,o.subQuery.key),i=!1,c(n,u,s.requests[0].httpRequest)}):i=!1}return p},e.prototype.beforeSend=function(e,t){this.adaptor.beforeSend(this,e,t);for(var r,n=this.dataSource.headers,o=0;n&&o<n.length;o++){r=[];for(var a=0,s=Object.keys(n[o]);a<s.length;a++){var i=s[a];r.push(i),e.setRequestHeader(i,n[o][i])}}},e.prototype.saveChanges=function(e,n,o,a,s){var i=this;o instanceof r&&(a=o,o=null);var u={url:o,key:n||this.dataSource.key},c=this.adaptor.batchRequest(this,e,u,a||new r,s);if(this.dataSource.offline)return c;if(t.isNullOrUndefined(this.adaptor.doAjaxRequest)){if(this.isCustomDataAdaptor(this.adaptor))return this.doAjaxRequest(c,this.adaptor.options.batchUpdate);var l=new O,p=new t.Ajax(c);return p.beforeSend=function(){i.beforeSend(p.httpRequest,p)},p.onSuccess=function(r,n){i.isGraphQLAdaptor(i.adaptor)&&(t.isNullOrUndefined(r.errors)||p.onFailure(JSON.stringify(r.errors))),l.resolve(i.adaptor.processResponse(r,i,null,n.httpRequest,n,e,u))},p.onFailure=function(e){l.reject([{error:e}])},p.send().catch(function(e){return!0}),l.promise}return this.adaptor.doAjaxRequest(c)},e.prototype.insert=function(e,n,o,a){n instanceof r&&(o=n,n=null);var s=this.adaptor.insert(this,e,n,o,a);return this.dataSource.offline?s:t.isNullOrUndefined(this.adaptor.doAjaxRequest)?this.doAjaxRequest(s,this.adaptor.options.addRecord):this.adaptor.doAjaxRequest(s)},e.prototype.remove=function(e,n,o,s){"object"==typeof n&&(n=a.getObject(e,n)),o instanceof r&&(s=o,o=null);var i=this.adaptor.remove(this,e,n,o,s);if(this.dataSource.offline)return i;if(t.isNullOrUndefined(this.adaptor.doAjaxRequest)){var u=this.adaptor.options.deleteRecord;return this.doAjaxRequest(i,u)}return this.adaptor.doAjaxRequest(i)},e.prototype.update=function(e,n,o,a,s){o instanceof r&&(a=o,o=null);var i=this.adaptor.update(this,e,n,o,a,s);if(this.dataSource.offline)return i;if(t.isNullOrUndefined(this.adaptor.doAjaxRequest)){var u=this.adaptor.options.updateRecord;return this.doAjaxRequest(i,u)}return this.adaptor.doAjaxRequest(i)},e.prototype.isCustomDataAdaptor=function(e){return this.adaptor.getModuleName&&"CustomDataAdaptor"===this.adaptor.getModuleName()},e.prototype.isGraphQLAdaptor=function(e){return this.adaptor.getModuleName&&"GraphQLAdaptor"===this.adaptor.getModuleName()},e.prototype.successFunc=function(e,r){if(this.isGraphQLAdaptor(this.adaptor)){var n=JSON.parse(e);t.isNullOrUndefined(n.errors)||this.failureFunc(JSON.stringify(n.errors))}this.isCustomDataAdaptor(this.adaptor)&&(r=t.extend({},this.ajaxReqOption,r));try{a.parse.parseJson(e)}catch(t){e=[]}e=this.adaptor.processResponse(a.parse.parseJson(e),this,null,r.httpRequest,r),this.ajaxDeffered.resolve(e)},e.prototype.failureFunc=function(e){this.ajaxDeffered.reject([{error:e}])},e.prototype.doAjaxRequest=function(e,r){var n=this;if(e=t.extend({},{type:"POST",contentType:"application/json; charset=utf-8",processData:!1},e),this.ajaxDeffered=new O,this.isCustomDataAdaptor(this.adaptor))this.ajaxReqOption=e,r.call(this,{data:e.data,onSuccess:this.successFunc.bind(this),onFailure:this.failureFunc.bind(this)});else{var o=new t.Ajax(e);o.beforeSend=function(){n.beforeSend(o.httpRequest,o)},o.onSuccess=this.successFunc.bind(this),o.onFailure=this.failureFunc.bind(this),o.send().catch(function(e){return!0})}return this.ajaxDeffered.promise},e}(),O=function(){return function(){var e=this;this.promise=new Promise(function(t,r){e.resolve=t,e.reject=r}),this.then=this.promise.then.bind(this.promise),this.catch=this.promise.catch.bind(this.promise)}}();e.DataManager=S,e.Deferred=O,e.Query=r,e.Predicate=n,e.Adaptor=u,e.JsonAdaptor=c,e.UrlAdaptor=l,e.ODataAdaptor=p,e.ODataV4Adaptor=d,e.WebApiAdaptor=h,e.WebMethodAdaptor=f,e.RemoteSaveAdaptor=g,e.CustomDataAdaptor=y,e.GraphQLAdaptor=v,e.CacheAdaptor=m,e.DataUtil=a,Object.defineProperty(e,"__esModule",{value:!0})});
	//# sourceMappingURL=ej2-data.umd.min.js.map


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2018 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString === Object.prototype.toString) {
						for (var key in arg) {
							if (hasOwn.call(arg, key) && arg[key]) {
								classes.push(key);
							}
						}
					} else {
						classes.push(arg.toString());
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	// This is CodeMirror (https://codemirror.net), a code editor
	// implemented in JavaScript on top of the browser's DOM.
	//
	// You can find some technical background for some of the code below
	// at http://marijnhaverbeke.nl/blog/#cm-internals .
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global = global || self, global.CodeMirror = factory());
	}(this, (function () { 'use strict';
	
	  // Kludges for bugs and behavior differences that can't be feature
	  // detected are enabled based on userAgent etc sniffing.
	  var userAgent = navigator.userAgent;
	  var platform = navigator.platform;
	
	  var gecko = /gecko\/\d/i.test(userAgent);
	  var ie_upto10 = /MSIE \d/.test(userAgent);
	  var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(userAgent);
	  var edge = /Edge\/(\d+)/.exec(userAgent);
	  var ie = ie_upto10 || ie_11up || edge;
	  var ie_version = ie && (ie_upto10 ? document.documentMode || 6 : +(edge || ie_11up)[1]);
	  var webkit = !edge && /WebKit\//.test(userAgent);
	  var qtwebkit = webkit && /Qt\/\d+\.\d+/.test(userAgent);
	  var chrome = !edge && /Chrome\//.test(userAgent);
	  var presto = /Opera\//.test(userAgent);
	  var safari = /Apple Computer/.test(navigator.vendor);
	  var mac_geMountainLion = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(userAgent);
	  var phantom = /PhantomJS/.test(userAgent);
	
	  var ios = safari && (/Mobile\/\w+/.test(userAgent) || navigator.maxTouchPoints > 2);
	  var android = /Android/.test(userAgent);
	  // This is woefully incomplete. Suggestions for alternative methods welcome.
	  var mobile = ios || android || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(userAgent);
	  var mac = ios || /Mac/.test(platform);
	  var chromeOS = /\bCrOS\b/.test(userAgent);
	  var windows = /win/i.test(platform);
	
	  var presto_version = presto && userAgent.match(/Version\/(\d*\.\d*)/);
	  if (presto_version) { presto_version = Number(presto_version[1]); }
	  if (presto_version && presto_version >= 15) { presto = false; webkit = true; }
	  // Some browsers use the wrong event properties to signal cmd/ctrl on OS X
	  var flipCtrlCmd = mac && (qtwebkit || presto && (presto_version == null || presto_version < 12.11));
	  var captureRightClick = gecko || (ie && ie_version >= 9);
	
	  function classTest(cls) { return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*") }
	
	  var rmClass = function(node, cls) {
	    var current = node.className;
	    var match = classTest(cls).exec(current);
	    if (match) {
	      var after = current.slice(match.index + match[0].length);
	      node.className = current.slice(0, match.index) + (after ? match[1] + after : "");
	    }
	  };
	
	  function removeChildren(e) {
	    for (var count = e.childNodes.length; count > 0; --count)
	      { e.removeChild(e.firstChild); }
	    return e
	  }
	
	  function removeChildrenAndAdd(parent, e) {
	    return removeChildren(parent).appendChild(e)
	  }
	
	  function elt(tag, content, className, style) {
	    var e = document.createElement(tag);
	    if (className) { e.className = className; }
	    if (style) { e.style.cssText = style; }
	    if (typeof content == "string") { e.appendChild(document.createTextNode(content)); }
	    else if (content) { for (var i = 0; i < content.length; ++i) { e.appendChild(content[i]); } }
	    return e
	  }
	  // wrapper for elt, which removes the elt from the accessibility tree
	  function eltP(tag, content, className, style) {
	    var e = elt(tag, content, className, style);
	    e.setAttribute("role", "presentation");
	    return e
	  }
	
	  var range;
	  if (document.createRange) { range = function(node, start, end, endNode) {
	    var r = document.createRange();
	    r.setEnd(endNode || node, end);
	    r.setStart(node, start);
	    return r
	  }; }
	  else { range = function(node, start, end) {
	    var r = document.body.createTextRange();
	    try { r.moveToElementText(node.parentNode); }
	    catch(e) { return r }
	    r.collapse(true);
	    r.moveEnd("character", end);
	    r.moveStart("character", start);
	    return r
	  }; }
	
	  function contains(parent, child) {
	    if (child.nodeType == 3) // Android browser always returns false when child is a textnode
	      { child = child.parentNode; }
	    if (parent.contains)
	      { return parent.contains(child) }
	    do {
	      if (child.nodeType == 11) { child = child.host; }
	      if (child == parent) { return true }
	    } while (child = child.parentNode)
	  }
	
	  function activeElt() {
	    // IE and Edge may throw an "Unspecified Error" when accessing document.activeElement.
	    // IE < 10 will throw when accessed while the page is loading or in an iframe.
	    // IE > 9 and Edge will throw when accessed in an iframe if document.body is unavailable.
	    var activeElement;
	    try {
	      activeElement = document.activeElement;
	    } catch(e) {
	      activeElement = document.body || null;
	    }
	    while (activeElement && activeElement.shadowRoot && activeElement.shadowRoot.activeElement)
	      { activeElement = activeElement.shadowRoot.activeElement; }
	    return activeElement
	  }
	
	  function addClass(node, cls) {
	    var current = node.className;
	    if (!classTest(cls).test(current)) { node.className += (current ? " " : "") + cls; }
	  }
	  function joinClasses(a, b) {
	    var as = a.split(" ");
	    for (var i = 0; i < as.length; i++)
	      { if (as[i] && !classTest(as[i]).test(b)) { b += " " + as[i]; } }
	    return b
	  }
	
	  var selectInput = function(node) { node.select(); };
	  if (ios) // Mobile Safari apparently has a bug where select() is broken.
	    { selectInput = function(node) { node.selectionStart = 0; node.selectionEnd = node.value.length; }; }
	  else if (ie) // Suppress mysterious IE10 errors
	    { selectInput = function(node) { try { node.select(); } catch(_e) {} }; }
	
	  function bind(f) {
	    var args = Array.prototype.slice.call(arguments, 1);
	    return function(){return f.apply(null, args)}
	  }
	
	  function copyObj(obj, target, overwrite) {
	    if (!target) { target = {}; }
	    for (var prop in obj)
	      { if (obj.hasOwnProperty(prop) && (overwrite !== false || !target.hasOwnProperty(prop)))
	        { target[prop] = obj[prop]; } }
	    return target
	  }
	
	  // Counts the column offset in a string, taking tabs into account.
	  // Used mostly to find indentation.
	  function countColumn(string, end, tabSize, startIndex, startValue) {
	    if (end == null) {
	      end = string.search(/[^\s\u00a0]/);
	      if (end == -1) { end = string.length; }
	    }
	    for (var i = startIndex || 0, n = startValue || 0;;) {
	      var nextTab = string.indexOf("\t", i);
	      if (nextTab < 0 || nextTab >= end)
	        { return n + (end - i) }
	      n += nextTab - i;
	      n += tabSize - (n % tabSize);
	      i = nextTab + 1;
	    }
	  }
	
	  var Delayed = function() {
	    this.id = null;
	    this.f = null;
	    this.time = 0;
	    this.handler = bind(this.onTimeout, this);
	  };
	  Delayed.prototype.onTimeout = function (self) {
	    self.id = 0;
	    if (self.time <= +new Date) {
	      self.f();
	    } else {
	      setTimeout(self.handler, self.time - +new Date);
	    }
	  };
	  Delayed.prototype.set = function (ms, f) {
	    this.f = f;
	    var time = +new Date + ms;
	    if (!this.id || time < this.time) {
	      clearTimeout(this.id);
	      this.id = setTimeout(this.handler, ms);
	      this.time = time;
	    }
	  };
	
	  function indexOf(array, elt) {
	    for (var i = 0; i < array.length; ++i)
	      { if (array[i] == elt) { return i } }
	    return -1
	  }
	
	  // Number of pixels added to scroller and sizer to hide scrollbar
	  var scrollerGap = 50;
	
	  // Returned or thrown by various protocols to signal 'I'm not
	  // handling this'.
	  var Pass = {toString: function(){return "CodeMirror.Pass"}};
	
	  // Reused option objects for setSelection & friends
	  var sel_dontScroll = {scroll: false}, sel_mouse = {origin: "*mouse"}, sel_move = {origin: "+move"};
	
	  // The inverse of countColumn -- find the offset that corresponds to
	  // a particular column.
	  function findColumn(string, goal, tabSize) {
	    for (var pos = 0, col = 0;;) {
	      var nextTab = string.indexOf("\t", pos);
	      if (nextTab == -1) { nextTab = string.length; }
	      var skipped = nextTab - pos;
	      if (nextTab == string.length || col + skipped >= goal)
	        { return pos + Math.min(skipped, goal - col) }
	      col += nextTab - pos;
	      col += tabSize - (col % tabSize);
	      pos = nextTab + 1;
	      if (col >= goal) { return pos }
	    }
	  }
	
	  var spaceStrs = [""];
	  function spaceStr(n) {
	    while (spaceStrs.length <= n)
	      { spaceStrs.push(lst(spaceStrs) + " "); }
	    return spaceStrs[n]
	  }
	
	  function lst(arr) { return arr[arr.length-1] }
	
	  function map(array, f) {
	    var out = [];
	    for (var i = 0; i < array.length; i++) { out[i] = f(array[i], i); }
	    return out
	  }
	
	  function insertSorted(array, value, score) {
	    var pos = 0, priority = score(value);
	    while (pos < array.length && score(array[pos]) <= priority) { pos++; }
	    array.splice(pos, 0, value);
	  }
	
	  function nothing() {}
	
	  function createObj(base, props) {
	    var inst;
	    if (Object.create) {
	      inst = Object.create(base);
	    } else {
	      nothing.prototype = base;
	      inst = new nothing();
	    }
	    if (props) { copyObj(props, inst); }
	    return inst
	  }
	
	  var nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
	  function isWordCharBasic(ch) {
	    return /\w/.test(ch) || ch > "\x80" &&
	      (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch))
	  }
	  function isWordChar(ch, helper) {
	    if (!helper) { return isWordCharBasic(ch) }
	    if (helper.source.indexOf("\\w") > -1 && isWordCharBasic(ch)) { return true }
	    return helper.test(ch)
	  }
	
	  function isEmpty(obj) {
	    for (var n in obj) { if (obj.hasOwnProperty(n) && obj[n]) { return false } }
	    return true
	  }
	
	  // Extending unicode characters. A series of a non-extending char +
	  // any number of extending chars is treated as a single unit as far
	  // as editing and measuring is concerned. This is not fully correct,
	  // since some scripts/fonts/browsers also treat other configurations
	  // of code points as a group.
	  var extendingChars = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
	  function isExtendingChar(ch) { return ch.charCodeAt(0) >= 768 && extendingChars.test(ch) }
	
	  // Returns a number from the range [`0`; `str.length`] unless `pos` is outside that range.
	  function skipExtendingChars(str, pos, dir) {
	    while ((dir < 0 ? pos > 0 : pos < str.length) && isExtendingChar(str.charAt(pos))) { pos += dir; }
	    return pos
	  }
	
	  // Returns the value from the range [`from`; `to`] that satisfies
	  // `pred` and is closest to `from`. Assumes that at least `to`
	  // satisfies `pred`. Supports `from` being greater than `to`.
	  function findFirst(pred, from, to) {
	    // At any point we are certain `to` satisfies `pred`, don't know
	    // whether `from` does.
	    var dir = from > to ? -1 : 1;
	    for (;;) {
	      if (from == to) { return from }
	      var midF = (from + to) / 2, mid = dir < 0 ? Math.ceil(midF) : Math.floor(midF);
	      if (mid == from) { return pred(mid) ? from : to }
	      if (pred(mid)) { to = mid; }
	      else { from = mid + dir; }
	    }
	  }
	
	  // BIDI HELPERS
	
	  function iterateBidiSections(order, from, to, f) {
	    if (!order) { return f(from, to, "ltr", 0) }
	    var found = false;
	    for (var i = 0; i < order.length; ++i) {
	      var part = order[i];
	      if (part.from < to && part.to > from || from == to && part.to == from) {
	        f(Math.max(part.from, from), Math.min(part.to, to), part.level == 1 ? "rtl" : "ltr", i);
	        found = true;
	      }
	    }
	    if (!found) { f(from, to, "ltr"); }
	  }
	
	  var bidiOther = null;
	  function getBidiPartAt(order, ch, sticky) {
	    var found;
	    bidiOther = null;
	    for (var i = 0; i < order.length; ++i) {
	      var cur = order[i];
	      if (cur.from < ch && cur.to > ch) { return i }
	      if (cur.to == ch) {
	        if (cur.from != cur.to && sticky == "before") { found = i; }
	        else { bidiOther = i; }
	      }
	      if (cur.from == ch) {
	        if (cur.from != cur.to && sticky != "before") { found = i; }
	        else { bidiOther = i; }
	      }
	    }
	    return found != null ? found : bidiOther
	  }
	
	  // Bidirectional ordering algorithm
	  // See http://unicode.org/reports/tr9/tr9-13.html for the algorithm
	  // that this (partially) implements.
	
	  // One-char codes used for character types:
	  // L (L):   Left-to-Right
	  // R (R):   Right-to-Left
	  // r (AL):  Right-to-Left Arabic
	  // 1 (EN):  European Number
	  // + (ES):  European Number Separator
	  // % (ET):  European Number Terminator
	  // n (AN):  Arabic Number
	  // , (CS):  Common Number Separator
	  // m (NSM): Non-Spacing Mark
	  // b (BN):  Boundary Neutral
	  // s (B):   Paragraph Separator
	  // t (S):   Segment Separator
	  // w (WS):  Whitespace
	  // N (ON):  Other Neutrals
	
	  // Returns null if characters are ordered as they appear
	  // (left-to-right), or an array of sections ({from, to, level}
	  // objects) in the order in which they occur visually.
	  var bidiOrdering = (function() {
	    // Character types for codepoints 0 to 0xff
	    var lowTypes = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN";
	    // Character types for codepoints 0x600 to 0x6f9
	    var arabicTypes = "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111";
	    function charType(code) {
	      if (code <= 0xf7) { return lowTypes.charAt(code) }
	      else if (0x590 <= code && code <= 0x5f4) { return "R" }
	      else if (0x600 <= code && code <= 0x6f9) { return arabicTypes.charAt(code - 0x600) }
	      else if (0x6ee <= code && code <= 0x8ac) { return "r" }
	      else if (0x2000 <= code && code <= 0x200b) { return "w" }
	      else if (code == 0x200c) { return "b" }
	      else { return "L" }
	    }
	
	    var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
	    var isNeutral = /[stwN]/, isStrong = /[LRr]/, countsAsLeft = /[Lb1n]/, countsAsNum = /[1n]/;
	
	    function BidiSpan(level, from, to) {
	      this.level = level;
	      this.from = from; this.to = to;
	    }
	
	    return function(str, direction) {
	      var outerType = direction == "ltr" ? "L" : "R";
	
	      if (str.length == 0 || direction == "ltr" && !bidiRE.test(str)) { return false }
	      var len = str.length, types = [];
	      for (var i = 0; i < len; ++i)
	        { types.push(charType(str.charCodeAt(i))); }
	
	      // W1. Examine each non-spacing mark (NSM) in the level run, and
	      // change the type of the NSM to the type of the previous
	      // character. If the NSM is at the start of the level run, it will
	      // get the type of sor.
	      for (var i$1 = 0, prev = outerType; i$1 < len; ++i$1) {
	        var type = types[i$1];
	        if (type == "m") { types[i$1] = prev; }
	        else { prev = type; }
	      }
	
	      // W2. Search backwards from each instance of a European number
	      // until the first strong type (R, L, AL, or sor) is found. If an
	      // AL is found, change the type of the European number to Arabic
	      // number.
	      // W3. Change all ALs to R.
	      for (var i$2 = 0, cur = outerType; i$2 < len; ++i$2) {
	        var type$1 = types[i$2];
	        if (type$1 == "1" && cur == "r") { types[i$2] = "n"; }
	        else if (isStrong.test(type$1)) { cur = type$1; if (type$1 == "r") { types[i$2] = "R"; } }
	      }
	
	      // W4. A single European separator between two European numbers
	      // changes to a European number. A single common separator between
	      // two numbers of the same type changes to that type.
	      for (var i$3 = 1, prev$1 = types[0]; i$3 < len - 1; ++i$3) {
	        var type$2 = types[i$3];
	        if (type$2 == "+" && prev$1 == "1" && types[i$3+1] == "1") { types[i$3] = "1"; }
	        else if (type$2 == "," && prev$1 == types[i$3+1] &&
	                 (prev$1 == "1" || prev$1 == "n")) { types[i$3] = prev$1; }
	        prev$1 = type$2;
	      }
	
	      // W5. A sequence of European terminators adjacent to European
	      // numbers changes to all European numbers.
	      // W6. Otherwise, separators and terminators change to Other
	      // Neutral.
	      for (var i$4 = 0; i$4 < len; ++i$4) {
	        var type$3 = types[i$4];
	        if (type$3 == ",") { types[i$4] = "N"; }
	        else if (type$3 == "%") {
	          var end = (void 0);
	          for (end = i$4 + 1; end < len && types[end] == "%"; ++end) {}
	          var replace = (i$4 && types[i$4-1] == "!") || (end < len && types[end] == "1") ? "1" : "N";
	          for (var j = i$4; j < end; ++j) { types[j] = replace; }
	          i$4 = end - 1;
	        }
	      }
	
	      // W7. Search backwards from each instance of a European number
	      // until the first strong type (R, L, or sor) is found. If an L is
	      // found, then change the type of the European number to L.
	      for (var i$5 = 0, cur$1 = outerType; i$5 < len; ++i$5) {
	        var type$4 = types[i$5];
	        if (cur$1 == "L" && type$4 == "1") { types[i$5] = "L"; }
	        else if (isStrong.test(type$4)) { cur$1 = type$4; }
	      }
	
	      // N1. A sequence of neutrals takes the direction of the
	      // surrounding strong text if the text on both sides has the same
	      // direction. European and Arabic numbers act as if they were R in
	      // terms of their influence on neutrals. Start-of-level-run (sor)
	      // and end-of-level-run (eor) are used at level run boundaries.
	      // N2. Any remaining neutrals take the embedding direction.
	      for (var i$6 = 0; i$6 < len; ++i$6) {
	        if (isNeutral.test(types[i$6])) {
	          var end$1 = (void 0);
	          for (end$1 = i$6 + 1; end$1 < len && isNeutral.test(types[end$1]); ++end$1) {}
	          var before = (i$6 ? types[i$6-1] : outerType) == "L";
	          var after = (end$1 < len ? types[end$1] : outerType) == "L";
	          var replace$1 = before == after ? (before ? "L" : "R") : outerType;
	          for (var j$1 = i$6; j$1 < end$1; ++j$1) { types[j$1] = replace$1; }
	          i$6 = end$1 - 1;
	        }
	      }
	
	      // Here we depart from the documented algorithm, in order to avoid
	      // building up an actual levels array. Since there are only three
	      // levels (0, 1, 2) in an implementation that doesn't take
	      // explicit embedding into account, we can build up the order on
	      // the fly, without following the level-based algorithm.
	      var order = [], m;
	      for (var i$7 = 0; i$7 < len;) {
	        if (countsAsLeft.test(types[i$7])) {
	          var start = i$7;
	          for (++i$7; i$7 < len && countsAsLeft.test(types[i$7]); ++i$7) {}
	          order.push(new BidiSpan(0, start, i$7));
	        } else {
	          var pos = i$7, at = order.length, isRTL = direction == "rtl" ? 1 : 0;
	          for (++i$7; i$7 < len && types[i$7] != "L"; ++i$7) {}
	          for (var j$2 = pos; j$2 < i$7;) {
	            if (countsAsNum.test(types[j$2])) {
	              if (pos < j$2) { order.splice(at, 0, new BidiSpan(1, pos, j$2)); at += isRTL; }
	              var nstart = j$2;
	              for (++j$2; j$2 < i$7 && countsAsNum.test(types[j$2]); ++j$2) {}
	              order.splice(at, 0, new BidiSpan(2, nstart, j$2));
	              at += isRTL;
	              pos = j$2;
	            } else { ++j$2; }
	          }
	          if (pos < i$7) { order.splice(at, 0, new BidiSpan(1, pos, i$7)); }
	        }
	      }
	      if (direction == "ltr") {
	        if (order[0].level == 1 && (m = str.match(/^\s+/))) {
	          order[0].from = m[0].length;
	          order.unshift(new BidiSpan(0, 0, m[0].length));
	        }
	        if (lst(order).level == 1 && (m = str.match(/\s+$/))) {
	          lst(order).to -= m[0].length;
	          order.push(new BidiSpan(0, len - m[0].length, len));
	        }
	      }
	
	      return direction == "rtl" ? order.reverse() : order
	    }
	  })();
	
	  // Get the bidi ordering for the given line (and cache it). Returns
	  // false for lines that are fully left-to-right, and an array of
	  // BidiSpan objects otherwise.
	  function getOrder(line, direction) {
	    var order = line.order;
	    if (order == null) { order = line.order = bidiOrdering(line.text, direction); }
	    return order
	  }
	
	  // EVENT HANDLING
	
	  // Lightweight event framework. on/off also work on DOM nodes,
	  // registering native DOM handlers.
	
	  var noHandlers = [];
	
	  var on = function(emitter, type, f) {
	    if (emitter.addEventListener) {
	      emitter.addEventListener(type, f, false);
	    } else if (emitter.attachEvent) {
	      emitter.attachEvent("on" + type, f);
	    } else {
	      var map = emitter._handlers || (emitter._handlers = {});
	      map[type] = (map[type] || noHandlers).concat(f);
	    }
	  };
	
	  function getHandlers(emitter, type) {
	    return emitter._handlers && emitter._handlers[type] || noHandlers
	  }
	
	  function off(emitter, type, f) {
	    if (emitter.removeEventListener) {
	      emitter.removeEventListener(type, f, false);
	    } else if (emitter.detachEvent) {
	      emitter.detachEvent("on" + type, f);
	    } else {
	      var map = emitter._handlers, arr = map && map[type];
	      if (arr) {
	        var index = indexOf(arr, f);
	        if (index > -1)
	          { map[type] = arr.slice(0, index).concat(arr.slice(index + 1)); }
	      }
	    }
	  }
	
	  function signal(emitter, type /*, values...*/) {
	    var handlers = getHandlers(emitter, type);
	    if (!handlers.length) { return }
	    var args = Array.prototype.slice.call(arguments, 2);
	    for (var i = 0; i < handlers.length; ++i) { handlers[i].apply(null, args); }
	  }
	
	  // The DOM events that CodeMirror handles can be overridden by
	  // registering a (non-DOM) handler on the editor for the event name,
	  // and preventDefault-ing the event in that handler.
	  function signalDOMEvent(cm, e, override) {
	    if (typeof e == "string")
	      { e = {type: e, preventDefault: function() { this.defaultPrevented = true; }}; }
	    signal(cm, override || e.type, cm, e);
	    return e_defaultPrevented(e) || e.codemirrorIgnore
	  }
	
	  function signalCursorActivity(cm) {
	    var arr = cm._handlers && cm._handlers.cursorActivity;
	    if (!arr) { return }
	    var set = cm.curOp.cursorActivityHandlers || (cm.curOp.cursorActivityHandlers = []);
	    for (var i = 0; i < arr.length; ++i) { if (indexOf(set, arr[i]) == -1)
	      { set.push(arr[i]); } }
	  }
	
	  function hasHandler(emitter, type) {
	    return getHandlers(emitter, type).length > 0
	  }
	
	  // Add on and off methods to a constructor's prototype, to make
	  // registering events on such objects more convenient.
	  function eventMixin(ctor) {
	    ctor.prototype.on = function(type, f) {on(this, type, f);};
	    ctor.prototype.off = function(type, f) {off(this, type, f);};
	  }
	
	  // Due to the fact that we still support jurassic IE versions, some
	  // compatibility wrappers are needed.
	
	  function e_preventDefault(e) {
	    if (e.preventDefault) { e.preventDefault(); }
	    else { e.returnValue = false; }
	  }
	  function e_stopPropagation(e) {
	    if (e.stopPropagation) { e.stopPropagation(); }
	    else { e.cancelBubble = true; }
	  }
	  function e_defaultPrevented(e) {
	    return e.defaultPrevented != null ? e.defaultPrevented : e.returnValue == false
	  }
	  function e_stop(e) {e_preventDefault(e); e_stopPropagation(e);}
	
	  function e_target(e) {return e.target || e.srcElement}
	  function e_button(e) {
	    var b = e.which;
	    if (b == null) {
	      if (e.button & 1) { b = 1; }
	      else if (e.button & 2) { b = 3; }
	      else if (e.button & 4) { b = 2; }
	    }
	    if (mac && e.ctrlKey && b == 1) { b = 3; }
	    return b
	  }
	
	  // Detect drag-and-drop
	  var dragAndDrop = function() {
	    // There is *some* kind of drag-and-drop support in IE6-8, but I
	    // couldn't get it to work yet.
	    if (ie && ie_version < 9) { return false }
	    var div = elt('div');
	    return "draggable" in div || "dragDrop" in div
	  }();
	
	  var zwspSupported;
	  function zeroWidthElement(measure) {
	    if (zwspSupported == null) {
	      var test = elt("span", "\u200b");
	      removeChildrenAndAdd(measure, elt("span", [test, document.createTextNode("x")]));
	      if (measure.firstChild.offsetHeight != 0)
	        { zwspSupported = test.offsetWidth <= 1 && test.offsetHeight > 2 && !(ie && ie_version < 8); }
	    }
	    var node = zwspSupported ? elt("span", "\u200b") :
	      elt("span", "\u00a0", null, "display: inline-block; width: 1px; margin-right: -1px");
	    node.setAttribute("cm-text", "");
	    return node
	  }
	
	  // Feature-detect IE's crummy client rect reporting for bidi text
	  var badBidiRects;
	  function hasBadBidiRects(measure) {
	    if (badBidiRects != null) { return badBidiRects }
	    var txt = removeChildrenAndAdd(measure, document.createTextNode("A\u062eA"));
	    var r0 = range(txt, 0, 1).getBoundingClientRect();
	    var r1 = range(txt, 1, 2).getBoundingClientRect();
	    removeChildren(measure);
	    if (!r0 || r0.left == r0.right) { return false } // Safari returns null in some cases (#2780)
	    return badBidiRects = (r1.right - r0.right < 3)
	  }
	
	  // See if "".split is the broken IE version, if so, provide an
	  // alternative way to split lines.
	  var splitLinesAuto = "\n\nb".split(/\n/).length != 3 ? function (string) {
	    var pos = 0, result = [], l = string.length;
	    while (pos <= l) {
	      var nl = string.indexOf("\n", pos);
	      if (nl == -1) { nl = string.length; }
	      var line = string.slice(pos, string.charAt(nl - 1) == "\r" ? nl - 1 : nl);
	      var rt = line.indexOf("\r");
	      if (rt != -1) {
	        result.push(line.slice(0, rt));
	        pos += rt + 1;
	      } else {
	        result.push(line);
	        pos = nl + 1;
	      }
	    }
	    return result
	  } : function (string) { return string.split(/\r\n?|\n/); };
	
	  var hasSelection = window.getSelection ? function (te) {
	    try { return te.selectionStart != te.selectionEnd }
	    catch(e) { return false }
	  } : function (te) {
	    var range;
	    try {range = te.ownerDocument.selection.createRange();}
	    catch(e) {}
	    if (!range || range.parentElement() != te) { return false }
	    return range.compareEndPoints("StartToEnd", range) != 0
	  };
	
	  var hasCopyEvent = (function () {
	    var e = elt("div");
	    if ("oncopy" in e) { return true }
	    e.setAttribute("oncopy", "return;");
	    return typeof e.oncopy == "function"
	  })();
	
	  var badZoomedRects = null;
	  function hasBadZoomedRects(measure) {
	    if (badZoomedRects != null) { return badZoomedRects }
	    var node = removeChildrenAndAdd(measure, elt("span", "x"));
	    var normal = node.getBoundingClientRect();
	    var fromRange = range(node, 0, 1).getBoundingClientRect();
	    return badZoomedRects = Math.abs(normal.left - fromRange.left) > 1
	  }
	
	  // Known modes, by name and by MIME
	  var modes = {}, mimeModes = {};
	
	  // Extra arguments are stored as the mode's dependencies, which is
	  // used by (legacy) mechanisms like loadmode.js to automatically
	  // load a mode. (Preferred mechanism is the require/define calls.)
	  function defineMode(name, mode) {
	    if (arguments.length > 2)
	      { mode.dependencies = Array.prototype.slice.call(arguments, 2); }
	    modes[name] = mode;
	  }
	
	  function defineMIME(mime, spec) {
	    mimeModes[mime] = spec;
	  }
	
	  // Given a MIME type, a {name, ...options} config object, or a name
	  // string, return a mode config object.
	  function resolveMode(spec) {
	    if (typeof spec == "string" && mimeModes.hasOwnProperty(spec)) {
	      spec = mimeModes[spec];
	    } else if (spec && typeof spec.name == "string" && mimeModes.hasOwnProperty(spec.name)) {
	      var found = mimeModes[spec.name];
	      if (typeof found == "string") { found = {name: found}; }
	      spec = createObj(found, spec);
	      spec.name = found.name;
	    } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(spec)) {
	      return resolveMode("application/xml")
	    } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(spec)) {
	      return resolveMode("application/json")
	    }
	    if (typeof spec == "string") { return {name: spec} }
	    else { return spec || {name: "null"} }
	  }
	
	  // Given a mode spec (anything that resolveMode accepts), find and
	  // initialize an actual mode object.
	  function getMode(options, spec) {
	    spec = resolveMode(spec);
	    var mfactory = modes[spec.name];
	    if (!mfactory) { return getMode(options, "text/plain") }
	    var modeObj = mfactory(options, spec);
	    if (modeExtensions.hasOwnProperty(spec.name)) {
	      var exts = modeExtensions[spec.name];
	      for (var prop in exts) {
	        if (!exts.hasOwnProperty(prop)) { continue }
	        if (modeObj.hasOwnProperty(prop)) { modeObj["_" + prop] = modeObj[prop]; }
	        modeObj[prop] = exts[prop];
	      }
	    }
	    modeObj.name = spec.name;
	    if (spec.helperType) { modeObj.helperType = spec.helperType; }
	    if (spec.modeProps) { for (var prop$1 in spec.modeProps)
	      { modeObj[prop$1] = spec.modeProps[prop$1]; } }
	
	    return modeObj
	  }
	
	  // This can be used to attach properties to mode objects from
	  // outside the actual mode definition.
	  var modeExtensions = {};
	  function extendMode(mode, properties) {
	    var exts = modeExtensions.hasOwnProperty(mode) ? modeExtensions[mode] : (modeExtensions[mode] = {});
	    copyObj(properties, exts);
	  }
	
	  function copyState(mode, state) {
	    if (state === true) { return state }
	    if (mode.copyState) { return mode.copyState(state) }
	    var nstate = {};
	    for (var n in state) {
	      var val = state[n];
	      if (val instanceof Array) { val = val.concat([]); }
	      nstate[n] = val;
	    }
	    return nstate
	  }
	
	  // Given a mode and a state (for that mode), find the inner mode and
	  // state at the position that the state refers to.
	  function innerMode(mode, state) {
	    var info;
	    while (mode.innerMode) {
	      info = mode.innerMode(state);
	      if (!info || info.mode == mode) { break }
	      state = info.state;
	      mode = info.mode;
	    }
	    return info || {mode: mode, state: state}
	  }
	
	  function startState(mode, a1, a2) {
	    return mode.startState ? mode.startState(a1, a2) : true
	  }
	
	  // STRING STREAM
	
	  // Fed to the mode parsers, provides helper functions to make
	  // parsers more succinct.
	
	  var StringStream = function(string, tabSize, lineOracle) {
	    this.pos = this.start = 0;
	    this.string = string;
	    this.tabSize = tabSize || 8;
	    this.lastColumnPos = this.lastColumnValue = 0;
	    this.lineStart = 0;
	    this.lineOracle = lineOracle;
	  };
	
	  StringStream.prototype.eol = function () {return this.pos >= this.string.length};
	  StringStream.prototype.sol = function () {return this.pos == this.lineStart};
	  StringStream.prototype.peek = function () {return this.string.charAt(this.pos) || undefined};
	  StringStream.prototype.next = function () {
	    if (this.pos < this.string.length)
	      { return this.string.charAt(this.pos++) }
	  };
	  StringStream.prototype.eat = function (match) {
	    var ch = this.string.charAt(this.pos);
	    var ok;
	    if (typeof match == "string") { ok = ch == match; }
	    else { ok = ch && (match.test ? match.test(ch) : match(ch)); }
	    if (ok) {++this.pos; return ch}
	  };
	  StringStream.prototype.eatWhile = function (match) {
	    var start = this.pos;
	    while (this.eat(match)){}
	    return this.pos > start
	  };
	  StringStream.prototype.eatSpace = function () {
	    var start = this.pos;
	    while (/[\s\u00a0]/.test(this.string.charAt(this.pos))) { ++this.pos; }
	    return this.pos > start
	  };
	  StringStream.prototype.skipToEnd = function () {this.pos = this.string.length;};
	  StringStream.prototype.skipTo = function (ch) {
	    var found = this.string.indexOf(ch, this.pos);
	    if (found > -1) {this.pos = found; return true}
	  };
	  StringStream.prototype.backUp = function (n) {this.pos -= n;};
	  StringStream.prototype.column = function () {
	    if (this.lastColumnPos < this.start) {
	      this.lastColumnValue = countColumn(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
	      this.lastColumnPos = this.start;
	    }
	    return this.lastColumnValue - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
	  };
	  StringStream.prototype.indentation = function () {
	    return countColumn(this.string, null, this.tabSize) -
	      (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
	  };
	  StringStream.prototype.match = function (pattern, consume, caseInsensitive) {
	    if (typeof pattern == "string") {
	      var cased = function (str) { return caseInsensitive ? str.toLowerCase() : str; };
	      var substr = this.string.substr(this.pos, pattern.length);
	      if (cased(substr) == cased(pattern)) {
	        if (consume !== false) { this.pos += pattern.length; }
	        return true
	      }
	    } else {
	      var match = this.string.slice(this.pos).match(pattern);
	      if (match && match.index > 0) { return null }
	      if (match && consume !== false) { this.pos += match[0].length; }
	      return match
	    }
	  };
	  StringStream.prototype.current = function (){return this.string.slice(this.start, this.pos)};
	  StringStream.prototype.hideFirstChars = function (n, inner) {
	    this.lineStart += n;
	    try { return inner() }
	    finally { this.lineStart -= n; }
	  };
	  StringStream.prototype.lookAhead = function (n) {
	    var oracle = this.lineOracle;
	    return oracle && oracle.lookAhead(n)
	  };
	  StringStream.prototype.baseToken = function () {
	    var oracle = this.lineOracle;
	    return oracle && oracle.baseToken(this.pos)
	  };
	
	  // Find the line object corresponding to the given line number.
	  function getLine(doc, n) {
	    n -= doc.first;
	    if (n < 0 || n >= doc.size) { throw new Error("There is no line " + (n + doc.first) + " in the document.") }
	    var chunk = doc;
	    while (!chunk.lines) {
	      for (var i = 0;; ++i) {
	        var child = chunk.children[i], sz = child.chunkSize();
	        if (n < sz) { chunk = child; break }
	        n -= sz;
	      }
	    }
	    return chunk.lines[n]
	  }
	
	  // Get the part of a document between two positions, as an array of
	  // strings.
	  function getBetween(doc, start, end) {
	    var out = [], n = start.line;
	    doc.iter(start.line, end.line + 1, function (line) {
	      var text = line.text;
	      if (n == end.line) { text = text.slice(0, end.ch); }
	      if (n == start.line) { text = text.slice(start.ch); }
	      out.push(text);
	      ++n;
	    });
	    return out
	  }
	  // Get the lines between from and to, as array of strings.
	  function getLines(doc, from, to) {
	    var out = [];
	    doc.iter(from, to, function (line) { out.push(line.text); }); // iter aborts when callback returns truthy value
	    return out
	  }
	
	  // Update the height of a line, propagating the height change
	  // upwards to parent nodes.
	  function updateLineHeight(line, height) {
	    var diff = height - line.height;
	    if (diff) { for (var n = line; n; n = n.parent) { n.height += diff; } }
	  }
	
	  // Given a line object, find its line number by walking up through
	  // its parent links.
	  function lineNo(line) {
	    if (line.parent == null) { return null }
	    var cur = line.parent, no = indexOf(cur.lines, line);
	    for (var chunk = cur.parent; chunk; cur = chunk, chunk = chunk.parent) {
	      for (var i = 0;; ++i) {
	        if (chunk.children[i] == cur) { break }
	        no += chunk.children[i].chunkSize();
	      }
	    }
	    return no + cur.first
	  }
	
	  // Find the line at the given vertical position, using the height
	  // information in the document tree.
	  function lineAtHeight(chunk, h) {
	    var n = chunk.first;
	    outer: do {
	      for (var i$1 = 0; i$1 < chunk.children.length; ++i$1) {
	        var child = chunk.children[i$1], ch = child.height;
	        if (h < ch) { chunk = child; continue outer }
	        h -= ch;
	        n += child.chunkSize();
	      }
	      return n
	    } while (!chunk.lines)
	    var i = 0;
	    for (; i < chunk.lines.length; ++i) {
	      var line = chunk.lines[i], lh = line.height;
	      if (h < lh) { break }
	      h -= lh;
	    }
	    return n + i
	  }
	
	  function isLine(doc, l) {return l >= doc.first && l < doc.first + doc.size}
	
	  function lineNumberFor(options, i) {
	    return String(options.lineNumberFormatter(i + options.firstLineNumber))
	  }
	
	  // A Pos instance represents a position within the text.
	  function Pos(line, ch, sticky) {
	    if ( sticky === void 0 ) sticky = null;
	
	    if (!(this instanceof Pos)) { return new Pos(line, ch, sticky) }
	    this.line = line;
	    this.ch = ch;
	    this.sticky = sticky;
	  }
	
	  // Compare two positions, return 0 if they are the same, a negative
	  // number when a is less, and a positive number otherwise.
	  function cmp(a, b) { return a.line - b.line || a.ch - b.ch }
	
	  function equalCursorPos(a, b) { return a.sticky == b.sticky && cmp(a, b) == 0 }
	
	  function copyPos(x) {return Pos(x.line, x.ch)}
	  function maxPos(a, b) { return cmp(a, b) < 0 ? b : a }
	  function minPos(a, b) { return cmp(a, b) < 0 ? a : b }
	
	  // Most of the external API clips given positions to make sure they
	  // actually exist within the document.
	  function clipLine(doc, n) {return Math.max(doc.first, Math.min(n, doc.first + doc.size - 1))}
	  function clipPos(doc, pos) {
	    if (pos.line < doc.first) { return Pos(doc.first, 0) }
	    var last = doc.first + doc.size - 1;
	    if (pos.line > last) { return Pos(last, getLine(doc, last).text.length) }
	    return clipToLen(pos, getLine(doc, pos.line).text.length)
	  }
	  function clipToLen(pos, linelen) {
	    var ch = pos.ch;
	    if (ch == null || ch > linelen) { return Pos(pos.line, linelen) }
	    else if (ch < 0) { return Pos(pos.line, 0) }
	    else { return pos }
	  }
	  function clipPosArray(doc, array) {
	    var out = [];
	    for (var i = 0; i < array.length; i++) { out[i] = clipPos(doc, array[i]); }
	    return out
	  }
	
	  var SavedContext = function(state, lookAhead) {
	    this.state = state;
	    this.lookAhead = lookAhead;
	  };
	
	  var Context = function(doc, state, line, lookAhead) {
	    this.state = state;
	    this.doc = doc;
	    this.line = line;
	    this.maxLookAhead = lookAhead || 0;
	    this.baseTokens = null;
	    this.baseTokenPos = 1;
	  };
	
	  Context.prototype.lookAhead = function (n) {
	    var line = this.doc.getLine(this.line + n);
	    if (line != null && n > this.maxLookAhead) { this.maxLookAhead = n; }
	    return line
	  };
	
	  Context.prototype.baseToken = function (n) {
	    if (!this.baseTokens) { return null }
	    while (this.baseTokens[this.baseTokenPos] <= n)
	      { this.baseTokenPos += 2; }
	    var type = this.baseTokens[this.baseTokenPos + 1];
	    return {type: type && type.replace(/( |^)overlay .*/, ""),
	            size: this.baseTokens[this.baseTokenPos] - n}
	  };
	
	  Context.prototype.nextLine = function () {
	    this.line++;
	    if (this.maxLookAhead > 0) { this.maxLookAhead--; }
	  };
	
	  Context.fromSaved = function (doc, saved, line) {
	    if (saved instanceof SavedContext)
	      { return new Context(doc, copyState(doc.mode, saved.state), line, saved.lookAhead) }
	    else
	      { return new Context(doc, copyState(doc.mode, saved), line) }
	  };
	
	  Context.prototype.save = function (copy) {
	    var state = copy !== false ? copyState(this.doc.mode, this.state) : this.state;
	    return this.maxLookAhead > 0 ? new SavedContext(state, this.maxLookAhead) : state
	  };
	
	
	  // Compute a style array (an array starting with a mode generation
	  // -- for invalidation -- followed by pairs of end positions and
	  // style strings), which is used to highlight the tokens on the
	  // line.
	  function highlightLine(cm, line, context, forceToEnd) {
	    // A styles array always starts with a number identifying the
	    // mode/overlays that it is based on (for easy invalidation).
	    var st = [cm.state.modeGen], lineClasses = {};
	    // Compute the base array of styles
	    runMode(cm, line.text, cm.doc.mode, context, function (end, style) { return st.push(end, style); },
	            lineClasses, forceToEnd);
	    var state = context.state;
	
	    // Run overlays, adjust style array.
	    var loop = function ( o ) {
	      context.baseTokens = st;
	      var overlay = cm.state.overlays[o], i = 1, at = 0;
	      context.state = true;
	      runMode(cm, line.text, overlay.mode, context, function (end, style) {
	        var start = i;
	        // Ensure there's a token end at the current position, and that i points at it
	        while (at < end) {
	          var i_end = st[i];
	          if (i_end > end)
	            { st.splice(i, 1, end, st[i+1], i_end); }
	          i += 2;
	          at = Math.min(end, i_end);
	        }
	        if (!style) { return }
	        if (overlay.opaque) {
	          st.splice(start, i - start, end, "overlay " + style);
	          i = start + 2;
	        } else {
	          for (; start < i; start += 2) {
	            var cur = st[start+1];
	            st[start+1] = (cur ? cur + " " : "") + "overlay " + style;
	          }
	        }
	      }, lineClasses);
	      context.state = state;
	      context.baseTokens = null;
	      context.baseTokenPos = 1;
	    };
	
	    for (var o = 0; o < cm.state.overlays.length; ++o) loop( o );
	
	    return {styles: st, classes: lineClasses.bgClass || lineClasses.textClass ? lineClasses : null}
	  }
	
	  function getLineStyles(cm, line, updateFrontier) {
	    if (!line.styles || line.styles[0] != cm.state.modeGen) {
	      var context = getContextBefore(cm, lineNo(line));
	      var resetState = line.text.length > cm.options.maxHighlightLength && copyState(cm.doc.mode, context.state);
	      var result = highlightLine(cm, line, context);
	      if (resetState) { context.state = resetState; }
	      line.stateAfter = context.save(!resetState);
	      line.styles = result.styles;
	      if (result.classes) { line.styleClasses = result.classes; }
	      else if (line.styleClasses) { line.styleClasses = null; }
	      if (updateFrontier === cm.doc.highlightFrontier)
	        { cm.doc.modeFrontier = Math.max(cm.doc.modeFrontier, ++cm.doc.highlightFrontier); }
	    }
	    return line.styles
	  }
	
	  function getContextBefore(cm, n, precise) {
	    var doc = cm.doc, display = cm.display;
	    if (!doc.mode.startState) { return new Context(doc, true, n) }
	    var start = findStartLine(cm, n, precise);
	    var saved = start > doc.first && getLine(doc, start - 1).stateAfter;
	    var context = saved ? Context.fromSaved(doc, saved, start) : new Context(doc, startState(doc.mode), start);
	
	    doc.iter(start, n, function (line) {
	      processLine(cm, line.text, context);
	      var pos = context.line;
	      line.stateAfter = pos == n - 1 || pos % 5 == 0 || pos >= display.viewFrom && pos < display.viewTo ? context.save() : null;
	      context.nextLine();
	    });
	    if (precise) { doc.modeFrontier = context.line; }
	    return context
	  }
	
	  // Lightweight form of highlight -- proceed over this line and
	  // update state, but don't save a style array. Used for lines that
	  // aren't currently visible.
	  function processLine(cm, text, context, startAt) {
	    var mode = cm.doc.mode;
	    var stream = new StringStream(text, cm.options.tabSize, context);
	    stream.start = stream.pos = startAt || 0;
	    if (text == "") { callBlankLine(mode, context.state); }
	    while (!stream.eol()) {
	      readToken(mode, stream, context.state);
	      stream.start = stream.pos;
	    }
	  }
	
	  function callBlankLine(mode, state) {
	    if (mode.blankLine) { return mode.blankLine(state) }
	    if (!mode.innerMode) { return }
	    var inner = innerMode(mode, state);
	    if (inner.mode.blankLine) { return inner.mode.blankLine(inner.state) }
	  }
	
	  function readToken(mode, stream, state, inner) {
	    for (var i = 0; i < 10; i++) {
	      if (inner) { inner[0] = innerMode(mode, state).mode; }
	      var style = mode.token(stream, state);
	      if (stream.pos > stream.start) { return style }
	    }
	    throw new Error("Mode " + mode.name + " failed to advance stream.")
	  }
	
	  var Token = function(stream, type, state) {
	    this.start = stream.start; this.end = stream.pos;
	    this.string = stream.current();
	    this.type = type || null;
	    this.state = state;
	  };
	
	  // Utility for getTokenAt and getLineTokens
	  function takeToken(cm, pos, precise, asArray) {
	    var doc = cm.doc, mode = doc.mode, style;
	    pos = clipPos(doc, pos);
	    var line = getLine(doc, pos.line), context = getContextBefore(cm, pos.line, precise);
	    var stream = new StringStream(line.text, cm.options.tabSize, context), tokens;
	    if (asArray) { tokens = []; }
	    while ((asArray || stream.pos < pos.ch) && !stream.eol()) {
	      stream.start = stream.pos;
	      style = readToken(mode, stream, context.state);
	      if (asArray) { tokens.push(new Token(stream, style, copyState(doc.mode, context.state))); }
	    }
	    return asArray ? tokens : new Token(stream, style, context.state)
	  }
	
	  function extractLineClasses(type, output) {
	    if (type) { for (;;) {
	      var lineClass = type.match(/(?:^|\s+)line-(background-)?(\S+)/);
	      if (!lineClass) { break }
	      type = type.slice(0, lineClass.index) + type.slice(lineClass.index + lineClass[0].length);
	      var prop = lineClass[1] ? "bgClass" : "textClass";
	      if (output[prop] == null)
	        { output[prop] = lineClass[2]; }
	      else if (!(new RegExp("(?:^|\\s)" + lineClass[2] + "(?:$|\\s)")).test(output[prop]))
	        { output[prop] += " " + lineClass[2]; }
	    } }
	    return type
	  }
	
	  // Run the given mode's parser over a line, calling f for each token.
	  function runMode(cm, text, mode, context, f, lineClasses, forceToEnd) {
	    var flattenSpans = mode.flattenSpans;
	    if (flattenSpans == null) { flattenSpans = cm.options.flattenSpans; }
	    var curStart = 0, curStyle = null;
	    var stream = new StringStream(text, cm.options.tabSize, context), style;
	    var inner = cm.options.addModeClass && [null];
	    if (text == "") { extractLineClasses(callBlankLine(mode, context.state), lineClasses); }
	    while (!stream.eol()) {
	      if (stream.pos > cm.options.maxHighlightLength) {
	        flattenSpans = false;
	        if (forceToEnd) { processLine(cm, text, context, stream.pos); }
	        stream.pos = text.length;
	        style = null;
	      } else {
	        style = extractLineClasses(readToken(mode, stream, context.state, inner), lineClasses);
	      }
	      if (inner) {
	        var mName = inner[0].name;
	        if (mName) { style = "m-" + (style ? mName + " " + style : mName); }
	      }
	      if (!flattenSpans || curStyle != style) {
	        while (curStart < stream.start) {
	          curStart = Math.min(stream.start, curStart + 5000);
	          f(curStart, curStyle);
	        }
	        curStyle = style;
	      }
	      stream.start = stream.pos;
	    }
	    while (curStart < stream.pos) {
	      // Webkit seems to refuse to render text nodes longer than 57444
	      // characters, and returns inaccurate measurements in nodes
	      // starting around 5000 chars.
	      var pos = Math.min(stream.pos, curStart + 5000);
	      f(pos, curStyle);
	      curStart = pos;
	    }
	  }
	
	  // Finds the line to start with when starting a parse. Tries to
	  // find a line with a stateAfter, so that it can start with a
	  // valid state. If that fails, it returns the line with the
	  // smallest indentation, which tends to need the least context to
	  // parse correctly.
	  function findStartLine(cm, n, precise) {
	    var minindent, minline, doc = cm.doc;
	    var lim = precise ? -1 : n - (cm.doc.mode.innerMode ? 1000 : 100);
	    for (var search = n; search > lim; --search) {
	      if (search <= doc.first) { return doc.first }
	      var line = getLine(doc, search - 1), after = line.stateAfter;
	      if (after && (!precise || search + (after instanceof SavedContext ? after.lookAhead : 0) <= doc.modeFrontier))
	        { return search }
	      var indented = countColumn(line.text, null, cm.options.tabSize);
	      if (minline == null || minindent > indented) {
	        minline = search - 1;
	        minindent = indented;
	      }
	    }
	    return minline
	  }
	
	  function retreatFrontier(doc, n) {
	    doc.modeFrontier = Math.min(doc.modeFrontier, n);
	    if (doc.highlightFrontier < n - 10) { return }
	    var start = doc.first;
	    for (var line = n - 1; line > start; line--) {
	      var saved = getLine(doc, line).stateAfter;
	      // change is on 3
	      // state on line 1 looked ahead 2 -- so saw 3
	      // test 1 + 2 < 3 should cover this
	      if (saved && (!(saved instanceof SavedContext) || line + saved.lookAhead < n)) {
	        start = line + 1;
	        break
	      }
	    }
	    doc.highlightFrontier = Math.min(doc.highlightFrontier, start);
	  }
	
	  // Optimize some code when these features are not used.
	  var sawReadOnlySpans = false, sawCollapsedSpans = false;
	
	  function seeReadOnlySpans() {
	    sawReadOnlySpans = true;
	  }
	
	  function seeCollapsedSpans() {
	    sawCollapsedSpans = true;
	  }
	
	  // TEXTMARKER SPANS
	
	  function MarkedSpan(marker, from, to) {
	    this.marker = marker;
	    this.from = from; this.to = to;
	  }
	
	  // Search an array of spans for a span matching the given marker.
	  function getMarkedSpanFor(spans, marker) {
	    if (spans) { for (var i = 0; i < spans.length; ++i) {
	      var span = spans[i];
	      if (span.marker == marker) { return span }
	    } }
	  }
	
	  // Remove a span from an array, returning undefined if no spans are
	  // left (we don't store arrays for lines without spans).
	  function removeMarkedSpan(spans, span) {
	    var r;
	    for (var i = 0; i < spans.length; ++i)
	      { if (spans[i] != span) { (r || (r = [])).push(spans[i]); } }
	    return r
	  }
	
	  // Add a span to a line.
	  function addMarkedSpan(line, span, op) {
	    var inThisOp = op && window.WeakSet && (op.markedSpans || (op.markedSpans = new WeakSet));
	    if (inThisOp && inThisOp.has(line.markedSpans)) {
	      line.markedSpans.push(span);
	    } else {
	      line.markedSpans = line.markedSpans ? line.markedSpans.concat([span]) : [span];
	      if (inThisOp) { inThisOp.add(line.markedSpans); }
	    }
	    span.marker.attachLine(line);
	  }
	
	  // Used for the algorithm that adjusts markers for a change in the
	  // document. These functions cut an array of spans at a given
	  // character position, returning an array of remaining chunks (or
	  // undefined if nothing remains).
	  function markedSpansBefore(old, startCh, isInsert) {
	    var nw;
	    if (old) { for (var i = 0; i < old.length; ++i) {
	      var span = old[i], marker = span.marker;
	      var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= startCh : span.from < startCh);
	      if (startsBefore || span.from == startCh && marker.type == "bookmark" && (!isInsert || !span.marker.insertLeft)) {
	        var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= startCh : span.to > startCh)
	        ;(nw || (nw = [])).push(new MarkedSpan(marker, span.from, endsAfter ? null : span.to));
	      }
	    } }
	    return nw
	  }
	  function markedSpansAfter(old, endCh, isInsert) {
	    var nw;
	    if (old) { for (var i = 0; i < old.length; ++i) {
	      var span = old[i], marker = span.marker;
	      var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= endCh : span.to > endCh);
	      if (endsAfter || span.from == endCh && marker.type == "bookmark" && (!isInsert || span.marker.insertLeft)) {
	        var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= endCh : span.from < endCh)
	        ;(nw || (nw = [])).push(new MarkedSpan(marker, startsBefore ? null : span.from - endCh,
	                                              span.to == null ? null : span.to - endCh));
	      }
	    } }
	    return nw
	  }
	
	  // Given a change object, compute the new set of marker spans that
	  // cover the line in which the change took place. Removes spans
	  // entirely within the change, reconnects spans belonging to the
	  // same marker that appear on both sides of the change, and cuts off
	  // spans partially within the change. Returns an array of span
	  // arrays with one element for each line in (after) the change.
	  function stretchSpansOverChange(doc, change) {
	    if (change.full) { return null }
	    var oldFirst = isLine(doc, change.from.line) && getLine(doc, change.from.line).markedSpans;
	    var oldLast = isLine(doc, change.to.line) && getLine(doc, change.to.line).markedSpans;
	    if (!oldFirst && !oldLast) { return null }
	
	    var startCh = change.from.ch, endCh = change.to.ch, isInsert = cmp(change.from, change.to) == 0;
	    // Get the spans that 'stick out' on both sides
	    var first = markedSpansBefore(oldFirst, startCh, isInsert);
	    var last = markedSpansAfter(oldLast, endCh, isInsert);
	
	    // Next, merge those two ends
	    var sameLine = change.text.length == 1, offset = lst(change.text).length + (sameLine ? startCh : 0);
	    if (first) {
	      // Fix up .to properties of first
	      for (var i = 0; i < first.length; ++i) {
	        var span = first[i];
	        if (span.to == null) {
	          var found = getMarkedSpanFor(last, span.marker);
	          if (!found) { span.to = startCh; }
	          else if (sameLine) { span.to = found.to == null ? null : found.to + offset; }
	        }
	      }
	    }
	    if (last) {
	      // Fix up .from in last (or move them into first in case of sameLine)
	      for (var i$1 = 0; i$1 < last.length; ++i$1) {
	        var span$1 = last[i$1];
	        if (span$1.to != null) { span$1.to += offset; }
	        if (span$1.from == null) {
	          var found$1 = getMarkedSpanFor(first, span$1.marker);
	          if (!found$1) {
	            span$1.from = offset;
	            if (sameLine) { (first || (first = [])).push(span$1); }
	          }
	        } else {
	          span$1.from += offset;
	          if (sameLine) { (first || (first = [])).push(span$1); }
	        }
	      }
	    }
	    // Make sure we didn't create any zero-length spans
	    if (first) { first = clearEmptySpans(first); }
	    if (last && last != first) { last = clearEmptySpans(last); }
	
	    var newMarkers = [first];
	    if (!sameLine) {
	      // Fill gap with whole-line-spans
	      var gap = change.text.length - 2, gapMarkers;
	      if (gap > 0 && first)
	        { for (var i$2 = 0; i$2 < first.length; ++i$2)
	          { if (first[i$2].to == null)
	            { (gapMarkers || (gapMarkers = [])).push(new MarkedSpan(first[i$2].marker, null, null)); } } }
	      for (var i$3 = 0; i$3 < gap; ++i$3)
	        { newMarkers.push(gapMarkers); }
	      newMarkers.push(last);
	    }
	    return newMarkers
	  }
	
	  // Remove spans that are empty and don't have a clearWhenEmpty
	  // option of false.
	  function clearEmptySpans(spans) {
	    for (var i = 0; i < spans.length; ++i) {
	      var span = spans[i];
	      if (span.from != null && span.from == span.to && span.marker.clearWhenEmpty !== false)
	        { spans.splice(i--, 1); }
	    }
	    if (!spans.length) { return null }
	    return spans
	  }
	
	  // Used to 'clip' out readOnly ranges when making a change.
	  function removeReadOnlyRanges(doc, from, to) {
	    var markers = null;
	    doc.iter(from.line, to.line + 1, function (line) {
	      if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
	        var mark = line.markedSpans[i].marker;
	        if (mark.readOnly && (!markers || indexOf(markers, mark) == -1))
	          { (markers || (markers = [])).push(mark); }
	      } }
	    });
	    if (!markers) { return null }
	    var parts = [{from: from, to: to}];
	    for (var i = 0; i < markers.length; ++i) {
	      var mk = markers[i], m = mk.find(0);
	      for (var j = 0; j < parts.length; ++j) {
	        var p = parts[j];
	        if (cmp(p.to, m.from) < 0 || cmp(p.from, m.to) > 0) { continue }
	        var newParts = [j, 1], dfrom = cmp(p.from, m.from), dto = cmp(p.to, m.to);
	        if (dfrom < 0 || !mk.inclusiveLeft && !dfrom)
	          { newParts.push({from: p.from, to: m.from}); }
	        if (dto > 0 || !mk.inclusiveRight && !dto)
	          { newParts.push({from: m.to, to: p.to}); }
	        parts.splice.apply(parts, newParts);
	        j += newParts.length - 3;
	      }
	    }
	    return parts
	  }
	
	  // Connect or disconnect spans from a line.
	  function detachMarkedSpans(line) {
	    var spans = line.markedSpans;
	    if (!spans) { return }
	    for (var i = 0; i < spans.length; ++i)
	      { spans[i].marker.detachLine(line); }
	    line.markedSpans = null;
	  }
	  function attachMarkedSpans(line, spans) {
	    if (!spans) { return }
	    for (var i = 0; i < spans.length; ++i)
	      { spans[i].marker.attachLine(line); }
	    line.markedSpans = spans;
	  }
	
	  // Helpers used when computing which overlapping collapsed span
	  // counts as the larger one.
	  function extraLeft(marker) { return marker.inclusiveLeft ? -1 : 0 }
	  function extraRight(marker) { return marker.inclusiveRight ? 1 : 0 }
	
	  // Returns a number indicating which of two overlapping collapsed
	  // spans is larger (and thus includes the other). Falls back to
	  // comparing ids when the spans cover exactly the same range.
	  function compareCollapsedMarkers(a, b) {
	    var lenDiff = a.lines.length - b.lines.length;
	    if (lenDiff != 0) { return lenDiff }
	    var aPos = a.find(), bPos = b.find();
	    var fromCmp = cmp(aPos.from, bPos.from) || extraLeft(a) - extraLeft(b);
	    if (fromCmp) { return -fromCmp }
	    var toCmp = cmp(aPos.to, bPos.to) || extraRight(a) - extraRight(b);
	    if (toCmp) { return toCmp }
	    return b.id - a.id
	  }
	
	  // Find out whether a line ends or starts in a collapsed span. If
	  // so, return the marker for that span.
	  function collapsedSpanAtSide(line, start) {
	    var sps = sawCollapsedSpans && line.markedSpans, found;
	    if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
	      sp = sps[i];
	      if (sp.marker.collapsed && (start ? sp.from : sp.to) == null &&
	          (!found || compareCollapsedMarkers(found, sp.marker) < 0))
	        { found = sp.marker; }
	    } }
	    return found
	  }
	  function collapsedSpanAtStart(line) { return collapsedSpanAtSide(line, true) }
	  function collapsedSpanAtEnd(line) { return collapsedSpanAtSide(line, false) }
	
	  function collapsedSpanAround(line, ch) {
	    var sps = sawCollapsedSpans && line.markedSpans, found;
	    if (sps) { for (var i = 0; i < sps.length; ++i) {
	      var sp = sps[i];
	      if (sp.marker.collapsed && (sp.from == null || sp.from < ch) && (sp.to == null || sp.to > ch) &&
	          (!found || compareCollapsedMarkers(found, sp.marker) < 0)) { found = sp.marker; }
	    } }
	    return found
	  }
	
	  // Test whether there exists a collapsed span that partially
	  // overlaps (covers the start or end, but not both) of a new span.
	  // Such overlap is not allowed.
	  function conflictingCollapsedRange(doc, lineNo, from, to, marker) {
	    var line = getLine(doc, lineNo);
	    var sps = sawCollapsedSpans && line.markedSpans;
	    if (sps) { for (var i = 0; i < sps.length; ++i) {
	      var sp = sps[i];
	      if (!sp.marker.collapsed) { continue }
	      var found = sp.marker.find(0);
	      var fromCmp = cmp(found.from, from) || extraLeft(sp.marker) - extraLeft(marker);
	      var toCmp = cmp(found.to, to) || extraRight(sp.marker) - extraRight(marker);
	      if (fromCmp >= 0 && toCmp <= 0 || fromCmp <= 0 && toCmp >= 0) { continue }
	      if (fromCmp <= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.to, from) >= 0 : cmp(found.to, from) > 0) ||
	          fromCmp >= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.from, to) <= 0 : cmp(found.from, to) < 0))
	        { return true }
	    } }
	  }
	
	  // A visual line is a line as drawn on the screen. Folding, for
	  // example, can cause multiple logical lines to appear on the same
	  // visual line. This finds the start of the visual line that the
	  // given line is part of (usually that is the line itself).
	  function visualLine(line) {
	    var merged;
	    while (merged = collapsedSpanAtStart(line))
	      { line = merged.find(-1, true).line; }
	    return line
	  }
	
	  function visualLineEnd(line) {
	    var merged;
	    while (merged = collapsedSpanAtEnd(line))
	      { line = merged.find(1, true).line; }
	    return line
	  }
	
	  // Returns an array of logical lines that continue the visual line
	  // started by the argument, or undefined if there are no such lines.
	  function visualLineContinued(line) {
	    var merged, lines;
	    while (merged = collapsedSpanAtEnd(line)) {
	      line = merged.find(1, true).line
	      ;(lines || (lines = [])).push(line);
	    }
	    return lines
	  }
	
	  // Get the line number of the start of the visual line that the
	  // given line number is part of.
	  function visualLineNo(doc, lineN) {
	    var line = getLine(doc, lineN), vis = visualLine(line);
	    if (line == vis) { return lineN }
	    return lineNo(vis)
	  }
	
	  // Get the line number of the start of the next visual line after
	  // the given line.
	  function visualLineEndNo(doc, lineN) {
	    if (lineN > doc.lastLine()) { return lineN }
	    var line = getLine(doc, lineN), merged;
	    if (!lineIsHidden(doc, line)) { return lineN }
	    while (merged = collapsedSpanAtEnd(line))
	      { line = merged.find(1, true).line; }
	    return lineNo(line) + 1
	  }
	
	  // Compute whether a line is hidden. Lines count as hidden when they
	  // are part of a visual line that starts with another line, or when
	  // they are entirely covered by collapsed, non-widget span.
	  function lineIsHidden(doc, line) {
	    var sps = sawCollapsedSpans && line.markedSpans;
	    if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
	      sp = sps[i];
	      if (!sp.marker.collapsed) { continue }
	      if (sp.from == null) { return true }
	      if (sp.marker.widgetNode) { continue }
	      if (sp.from == 0 && sp.marker.inclusiveLeft && lineIsHiddenInner(doc, line, sp))
	        { return true }
	    } }
	  }
	  function lineIsHiddenInner(doc, line, span) {
	    if (span.to == null) {
	      var end = span.marker.find(1, true);
	      return lineIsHiddenInner(doc, end.line, getMarkedSpanFor(end.line.markedSpans, span.marker))
	    }
	    if (span.marker.inclusiveRight && span.to == line.text.length)
	      { return true }
	    for (var sp = (void 0), i = 0; i < line.markedSpans.length; ++i) {
	      sp = line.markedSpans[i];
	      if (sp.marker.collapsed && !sp.marker.widgetNode && sp.from == span.to &&
	          (sp.to == null || sp.to != span.from) &&
	          (sp.marker.inclusiveLeft || span.marker.inclusiveRight) &&
	          lineIsHiddenInner(doc, line, sp)) { return true }
	    }
	  }
	
	  // Find the height above the given line.
	  function heightAtLine(lineObj) {
	    lineObj = visualLine(lineObj);
	
	    var h = 0, chunk = lineObj.parent;
	    for (var i = 0; i < chunk.lines.length; ++i) {
	      var line = chunk.lines[i];
	      if (line == lineObj) { break }
	      else { h += line.height; }
	    }
	    for (var p = chunk.parent; p; chunk = p, p = chunk.parent) {
	      for (var i$1 = 0; i$1 < p.children.length; ++i$1) {
	        var cur = p.children[i$1];
	        if (cur == chunk) { break }
	        else { h += cur.height; }
	      }
	    }
	    return h
	  }
	
	  // Compute the character length of a line, taking into account
	  // collapsed ranges (see markText) that might hide parts, and join
	  // other lines onto it.
	  function lineLength(line) {
	    if (line.height == 0) { return 0 }
	    var len = line.text.length, merged, cur = line;
	    while (merged = collapsedSpanAtStart(cur)) {
	      var found = merged.find(0, true);
	      cur = found.from.line;
	      len += found.from.ch - found.to.ch;
	    }
	    cur = line;
	    while (merged = collapsedSpanAtEnd(cur)) {
	      var found$1 = merged.find(0, true);
	      len -= cur.text.length - found$1.from.ch;
	      cur = found$1.to.line;
	      len += cur.text.length - found$1.to.ch;
	    }
	    return len
	  }
	
	  // Find the longest line in the document.
	  function findMaxLine(cm) {
	    var d = cm.display, doc = cm.doc;
	    d.maxLine = getLine(doc, doc.first);
	    d.maxLineLength = lineLength(d.maxLine);
	    d.maxLineChanged = true;
	    doc.iter(function (line) {
	      var len = lineLength(line);
	      if (len > d.maxLineLength) {
	        d.maxLineLength = len;
	        d.maxLine = line;
	      }
	    });
	  }
	
	  // LINE DATA STRUCTURE
	
	  // Line objects. These hold state related to a line, including
	  // highlighting info (the styles array).
	  var Line = function(text, markedSpans, estimateHeight) {
	    this.text = text;
	    attachMarkedSpans(this, markedSpans);
	    this.height = estimateHeight ? estimateHeight(this) : 1;
	  };
	
	  Line.prototype.lineNo = function () { return lineNo(this) };
	  eventMixin(Line);
	
	  // Change the content (text, markers) of a line. Automatically
	  // invalidates cached information and tries to re-estimate the
	  // line's height.
	  function updateLine(line, text, markedSpans, estimateHeight) {
	    line.text = text;
	    if (line.stateAfter) { line.stateAfter = null; }
	    if (line.styles) { line.styles = null; }
	    if (line.order != null) { line.order = null; }
	    detachMarkedSpans(line);
	    attachMarkedSpans(line, markedSpans);
	    var estHeight = estimateHeight ? estimateHeight(line) : 1;
	    if (estHeight != line.height) { updateLineHeight(line, estHeight); }
	  }
	
	  // Detach a line from the document tree and its markers.
	  function cleanUpLine(line) {
	    line.parent = null;
	    detachMarkedSpans(line);
	  }
	
	  // Convert a style as returned by a mode (either null, or a string
	  // containing one or more styles) to a CSS style. This is cached,
	  // and also looks for line-wide styles.
	  var styleToClassCache = {}, styleToClassCacheWithMode = {};
	  function interpretTokenStyle(style, options) {
	    if (!style || /^\s*$/.test(style)) { return null }
	    var cache = options.addModeClass ? styleToClassCacheWithMode : styleToClassCache;
	    return cache[style] ||
	      (cache[style] = style.replace(/\S+/g, "cm-$&"))
	  }
	
	  // Render the DOM representation of the text of a line. Also builds
	  // up a 'line map', which points at the DOM nodes that represent
	  // specific stretches of text, and is used by the measuring code.
	  // The returned object contains the DOM node, this map, and
	  // information about line-wide styles that were set by the mode.
	  function buildLineContent(cm, lineView) {
	    // The padding-right forces the element to have a 'border', which
	    // is needed on Webkit to be able to get line-level bounding
	    // rectangles for it (in measureChar).
	    var content = eltP("span", null, null, webkit ? "padding-right: .1px" : null);
	    var builder = {pre: eltP("pre", [content], "CodeMirror-line"), content: content,
	                   col: 0, pos: 0, cm: cm,
	                   trailingSpace: false,
	                   splitSpaces: cm.getOption("lineWrapping")};
	    lineView.measure = {};
	
	    // Iterate over the logical lines that make up this visual line.
	    for (var i = 0; i <= (lineView.rest ? lineView.rest.length : 0); i++) {
	      var line = i ? lineView.rest[i - 1] : lineView.line, order = (void 0);
	      builder.pos = 0;
	      builder.addToken = buildToken;
	      // Optionally wire in some hacks into the token-rendering
	      // algorithm, to deal with browser quirks.
	      if (hasBadBidiRects(cm.display.measure) && (order = getOrder(line, cm.doc.direction)))
	        { builder.addToken = buildTokenBadBidi(builder.addToken, order); }
	      builder.map = [];
	      var allowFrontierUpdate = lineView != cm.display.externalMeasured && lineNo(line);
	      insertLineContent(line, builder, getLineStyles(cm, line, allowFrontierUpdate));
	      if (line.styleClasses) {
	        if (line.styleClasses.bgClass)
	          { builder.bgClass = joinClasses(line.styleClasses.bgClass, builder.bgClass || ""); }
	        if (line.styleClasses.textClass)
	          { builder.textClass = joinClasses(line.styleClasses.textClass, builder.textClass || ""); }
	      }
	
	      // Ensure at least a single node is present, for measuring.
	      if (builder.map.length == 0)
	        { builder.map.push(0, 0, builder.content.appendChild(zeroWidthElement(cm.display.measure))); }
	
	      // Store the map and a cache object for the current logical line
	      if (i == 0) {
	        lineView.measure.map = builder.map;
	        lineView.measure.cache = {};
	      } else {
	  (lineView.measure.maps || (lineView.measure.maps = [])).push(builder.map)
	        ;(lineView.measure.caches || (lineView.measure.caches = [])).push({});
	      }
	    }
	
	    // See issue #2901
	    if (webkit) {
	      var last = builder.content.lastChild;
	      if (/\bcm-tab\b/.test(last.className) || (last.querySelector && last.querySelector(".cm-tab")))
	        { builder.content.className = "cm-tab-wrap-hack"; }
	    }
	
	    signal(cm, "renderLine", cm, lineView.line, builder.pre);
	    if (builder.pre.className)
	      { builder.textClass = joinClasses(builder.pre.className, builder.textClass || ""); }
	
	    return builder
	  }
	
	  function defaultSpecialCharPlaceholder(ch) {
	    var token = elt("span", "\u2022", "cm-invalidchar");
	    token.title = "\\u" + ch.charCodeAt(0).toString(16);
	    token.setAttribute("aria-label", token.title);
	    return token
	  }
	
	  // Build up the DOM representation for a single token, and add it to
	  // the line map. Takes care to render special characters separately.
	  function buildToken(builder, text, style, startStyle, endStyle, css, attributes) {
	    if (!text) { return }
	    var displayText = builder.splitSpaces ? splitSpaces(text, builder.trailingSpace) : text;
	    var special = builder.cm.state.specialChars, mustWrap = false;
	    var content;
	    if (!special.test(text)) {
	      builder.col += text.length;
	      content = document.createTextNode(displayText);
	      builder.map.push(builder.pos, builder.pos + text.length, content);
	      if (ie && ie_version < 9) { mustWrap = true; }
	      builder.pos += text.length;
	    } else {
	      content = document.createDocumentFragment();
	      var pos = 0;
	      while (true) {
	        special.lastIndex = pos;
	        var m = special.exec(text);
	        var skipped = m ? m.index - pos : text.length - pos;
	        if (skipped) {
	          var txt = document.createTextNode(displayText.slice(pos, pos + skipped));
	          if (ie && ie_version < 9) { content.appendChild(elt("span", [txt])); }
	          else { content.appendChild(txt); }
	          builder.map.push(builder.pos, builder.pos + skipped, txt);
	          builder.col += skipped;
	          builder.pos += skipped;
	        }
	        if (!m) { break }
	        pos += skipped + 1;
	        var txt$1 = (void 0);
	        if (m[0] == "\t") {
	          var tabSize = builder.cm.options.tabSize, tabWidth = tabSize - builder.col % tabSize;
	          txt$1 = content.appendChild(elt("span", spaceStr(tabWidth), "cm-tab"));
	          txt$1.setAttribute("role", "presentation");
	          txt$1.setAttribute("cm-text", "\t");
	          builder.col += tabWidth;
	        } else if (m[0] == "\r" || m[0] == "\n") {
	          txt$1 = content.appendChild(elt("span", m[0] == "\r" ? "\u240d" : "\u2424", "cm-invalidchar"));
	          txt$1.setAttribute("cm-text", m[0]);
	          builder.col += 1;
	        } else {
	          txt$1 = builder.cm.options.specialCharPlaceholder(m[0]);
	          txt$1.setAttribute("cm-text", m[0]);
	          if (ie && ie_version < 9) { content.appendChild(elt("span", [txt$1])); }
	          else { content.appendChild(txt$1); }
	          builder.col += 1;
	        }
	        builder.map.push(builder.pos, builder.pos + 1, txt$1);
	        builder.pos++;
	      }
	    }
	    builder.trailingSpace = displayText.charCodeAt(text.length - 1) == 32;
	    if (style || startStyle || endStyle || mustWrap || css || attributes) {
	      var fullStyle = style || "";
	      if (startStyle) { fullStyle += startStyle; }
	      if (endStyle) { fullStyle += endStyle; }
	      var token = elt("span", [content], fullStyle, css);
	      if (attributes) {
	        for (var attr in attributes) { if (attributes.hasOwnProperty(attr) && attr != "style" && attr != "class")
	          { token.setAttribute(attr, attributes[attr]); } }
	      }
	      return builder.content.appendChild(token)
	    }
	    builder.content.appendChild(content);
	  }
	
	  // Change some spaces to NBSP to prevent the browser from collapsing
	  // trailing spaces at the end of a line when rendering text (issue #1362).
	  function splitSpaces(text, trailingBefore) {
	    if (text.length > 1 && !/  /.test(text)) { return text }
	    var spaceBefore = trailingBefore, result = "";
	    for (var i = 0; i < text.length; i++) {
	      var ch = text.charAt(i);
	      if (ch == " " && spaceBefore && (i == text.length - 1 || text.charCodeAt(i + 1) == 32))
	        { ch = "\u00a0"; }
	      result += ch;
	      spaceBefore = ch == " ";
	    }
	    return result
	  }
	
	  // Work around nonsense dimensions being reported for stretches of
	  // right-to-left text.
	  function buildTokenBadBidi(inner, order) {
	    return function (builder, text, style, startStyle, endStyle, css, attributes) {
	      style = style ? style + " cm-force-border" : "cm-force-border";
	      var start = builder.pos, end = start + text.length;
	      for (;;) {
	        // Find the part that overlaps with the start of this text
	        var part = (void 0);
	        for (var i = 0; i < order.length; i++) {
	          part = order[i];
	          if (part.to > start && part.from <= start) { break }
	        }
	        if (part.to >= end) { return inner(builder, text, style, startStyle, endStyle, css, attributes) }
	        inner(builder, text.slice(0, part.to - start), style, startStyle, null, css, attributes);
	        startStyle = null;
	        text = text.slice(part.to - start);
	        start = part.to;
	      }
	    }
	  }
	
	  function buildCollapsedSpan(builder, size, marker, ignoreWidget) {
	    var widget = !ignoreWidget && marker.widgetNode;
	    if (widget) { builder.map.push(builder.pos, builder.pos + size, widget); }
	    if (!ignoreWidget && builder.cm.display.input.needsContentAttribute) {
	      if (!widget)
	        { widget = builder.content.appendChild(document.createElement("span")); }
	      widget.setAttribute("cm-marker", marker.id);
	    }
	    if (widget) {
	      builder.cm.display.input.setUneditable(widget);
	      builder.content.appendChild(widget);
	    }
	    builder.pos += size;
	    builder.trailingSpace = false;
	  }
	
	  // Outputs a number of spans to make up a line, taking highlighting
	  // and marked text into account.
	  function insertLineContent(line, builder, styles) {
	    var spans = line.markedSpans, allText = line.text, at = 0;
	    if (!spans) {
	      for (var i$1 = 1; i$1 < styles.length; i$1+=2)
	        { builder.addToken(builder, allText.slice(at, at = styles[i$1]), interpretTokenStyle(styles[i$1+1], builder.cm.options)); }
	      return
	    }
	
	    var len = allText.length, pos = 0, i = 1, text = "", style, css;
	    var nextChange = 0, spanStyle, spanEndStyle, spanStartStyle, collapsed, attributes;
	    for (;;) {
	      if (nextChange == pos) { // Update current marker set
	        spanStyle = spanEndStyle = spanStartStyle = css = "";
	        attributes = null;
	        collapsed = null; nextChange = Infinity;
	        var foundBookmarks = [], endStyles = (void 0);
	        for (var j = 0; j < spans.length; ++j) {
	          var sp = spans[j], m = sp.marker;
	          if (m.type == "bookmark" && sp.from == pos && m.widgetNode) {
	            foundBookmarks.push(m);
	          } else if (sp.from <= pos && (sp.to == null || sp.to > pos || m.collapsed && sp.to == pos && sp.from == pos)) {
	            if (sp.to != null && sp.to != pos && nextChange > sp.to) {
	              nextChange = sp.to;
	              spanEndStyle = "";
	            }
	            if (m.className) { spanStyle += " " + m.className; }
	            if (m.css) { css = (css ? css + ";" : "") + m.css; }
	            if (m.startStyle && sp.from == pos) { spanStartStyle += " " + m.startStyle; }
	            if (m.endStyle && sp.to == nextChange) { (endStyles || (endStyles = [])).push(m.endStyle, sp.to); }
	            // support for the old title property
	            // https://github.com/codemirror/CodeMirror/pull/5673
	            if (m.title) { (attributes || (attributes = {})).title = m.title; }
	            if (m.attributes) {
	              for (var attr in m.attributes)
	                { (attributes || (attributes = {}))[attr] = m.attributes[attr]; }
	            }
	            if (m.collapsed && (!collapsed || compareCollapsedMarkers(collapsed.marker, m) < 0))
	              { collapsed = sp; }
	          } else if (sp.from > pos && nextChange > sp.from) {
	            nextChange = sp.from;
	          }
	        }
	        if (endStyles) { for (var j$1 = 0; j$1 < endStyles.length; j$1 += 2)
	          { if (endStyles[j$1 + 1] == nextChange) { spanEndStyle += " " + endStyles[j$1]; } } }
	
	        if (!collapsed || collapsed.from == pos) { for (var j$2 = 0; j$2 < foundBookmarks.length; ++j$2)
	          { buildCollapsedSpan(builder, 0, foundBookmarks[j$2]); } }
	        if (collapsed && (collapsed.from || 0) == pos) {
	          buildCollapsedSpan(builder, (collapsed.to == null ? len + 1 : collapsed.to) - pos,
	                             collapsed.marker, collapsed.from == null);
	          if (collapsed.to == null) { return }
	          if (collapsed.to == pos) { collapsed = false; }
	        }
	      }
	      if (pos >= len) { break }
	
	      var upto = Math.min(len, nextChange);
	      while (true) {
	        if (text) {
	          var end = pos + text.length;
	          if (!collapsed) {
	            var tokenText = end > upto ? text.slice(0, upto - pos) : text;
	            builder.addToken(builder, tokenText, style ? style + spanStyle : spanStyle,
	                             spanStartStyle, pos + tokenText.length == nextChange ? spanEndStyle : "", css, attributes);
	          }
	          if (end >= upto) {text = text.slice(upto - pos); pos = upto; break}
	          pos = end;
	          spanStartStyle = "";
	        }
	        text = allText.slice(at, at = styles[i++]);
	        style = interpretTokenStyle(styles[i++], builder.cm.options);
	      }
	    }
	  }
	
	
	  // These objects are used to represent the visible (currently drawn)
	  // part of the document. A LineView may correspond to multiple
	  // logical lines, if those are connected by collapsed ranges.
	  function LineView(doc, line, lineN) {
	    // The starting line
	    this.line = line;
	    // Continuing lines, if any
	    this.rest = visualLineContinued(line);
	    // Number of logical lines in this visual line
	    this.size = this.rest ? lineNo(lst(this.rest)) - lineN + 1 : 1;
	    this.node = this.text = null;
	    this.hidden = lineIsHidden(doc, line);
	  }
	
	  // Create a range of LineView objects for the given lines.
	  function buildViewArray(cm, from, to) {
	    var array = [], nextPos;
	    for (var pos = from; pos < to; pos = nextPos) {
	      var view = new LineView(cm.doc, getLine(cm.doc, pos), pos);
	      nextPos = pos + view.size;
	      array.push(view);
	    }
	    return array
	  }
	
	  var operationGroup = null;
	
	  function pushOperation(op) {
	    if (operationGroup) {
	      operationGroup.ops.push(op);
	    } else {
	      op.ownsGroup = operationGroup = {
	        ops: [op],
	        delayedCallbacks: []
	      };
	    }
	  }
	
	  function fireCallbacksForOps(group) {
	    // Calls delayed callbacks and cursorActivity handlers until no
	    // new ones appear
	    var callbacks = group.delayedCallbacks, i = 0;
	    do {
	      for (; i < callbacks.length; i++)
	        { callbacks[i].call(null); }
	      for (var j = 0; j < group.ops.length; j++) {
	        var op = group.ops[j];
	        if (op.cursorActivityHandlers)
	          { while (op.cursorActivityCalled < op.cursorActivityHandlers.length)
	            { op.cursorActivityHandlers[op.cursorActivityCalled++].call(null, op.cm); } }
	      }
	    } while (i < callbacks.length)
	  }
	
	  function finishOperation(op, endCb) {
	    var group = op.ownsGroup;
	    if (!group) { return }
	
	    try { fireCallbacksForOps(group); }
	    finally {
	      operationGroup = null;
	      endCb(group);
	    }
	  }
	
	  var orphanDelayedCallbacks = null;
	
	  // Often, we want to signal events at a point where we are in the
	  // middle of some work, but don't want the handler to start calling
	  // other methods on the editor, which might be in an inconsistent
	  // state or simply not expect any other events to happen.
	  // signalLater looks whether there are any handlers, and schedules
	  // them to be executed when the last operation ends, or, if no
	  // operation is active, when a timeout fires.
	  function signalLater(emitter, type /*, values...*/) {
	    var arr = getHandlers(emitter, type);
	    if (!arr.length) { return }
	    var args = Array.prototype.slice.call(arguments, 2), list;
	    if (operationGroup) {
	      list = operationGroup.delayedCallbacks;
	    } else if (orphanDelayedCallbacks) {
	      list = orphanDelayedCallbacks;
	    } else {
	      list = orphanDelayedCallbacks = [];
	      setTimeout(fireOrphanDelayed, 0);
	    }
	    var loop = function ( i ) {
	      list.push(function () { return arr[i].apply(null, args); });
	    };
	
	    for (var i = 0; i < arr.length; ++i)
	      loop( i );
	  }
	
	  function fireOrphanDelayed() {
	    var delayed = orphanDelayedCallbacks;
	    orphanDelayedCallbacks = null;
	    for (var i = 0; i < delayed.length; ++i) { delayed[i](); }
	  }
	
	  // When an aspect of a line changes, a string is added to
	  // lineView.changes. This updates the relevant part of the line's
	  // DOM structure.
	  function updateLineForChanges(cm, lineView, lineN, dims) {
	    for (var j = 0; j < lineView.changes.length; j++) {
	      var type = lineView.changes[j];
	      if (type == "text") { updateLineText(cm, lineView); }
	      else if (type == "gutter") { updateLineGutter(cm, lineView, lineN, dims); }
	      else if (type == "class") { updateLineClasses(cm, lineView); }
	      else if (type == "widget") { updateLineWidgets(cm, lineView, dims); }
	    }
	    lineView.changes = null;
	  }
	
	  // Lines with gutter elements, widgets or a background class need to
	  // be wrapped, and have the extra elements added to the wrapper div
	  function ensureLineWrapped(lineView) {
	    if (lineView.node == lineView.text) {
	      lineView.node = elt("div", null, null, "position: relative");
	      if (lineView.text.parentNode)
	        { lineView.text.parentNode.replaceChild(lineView.node, lineView.text); }
	      lineView.node.appendChild(lineView.text);
	      if (ie && ie_version < 8) { lineView.node.style.zIndex = 2; }
	    }
	    return lineView.node
	  }
	
	  function updateLineBackground(cm, lineView) {
	    var cls = lineView.bgClass ? lineView.bgClass + " " + (lineView.line.bgClass || "") : lineView.line.bgClass;
	    if (cls) { cls += " CodeMirror-linebackground"; }
	    if (lineView.background) {
	      if (cls) { lineView.background.className = cls; }
	      else { lineView.background.parentNode.removeChild(lineView.background); lineView.background = null; }
	    } else if (cls) {
	      var wrap = ensureLineWrapped(lineView);
	      lineView.background = wrap.insertBefore(elt("div", null, cls), wrap.firstChild);
	      cm.display.input.setUneditable(lineView.background);
	    }
	  }
	
	  // Wrapper around buildLineContent which will reuse the structure
	  // in display.externalMeasured when possible.
	  function getLineContent(cm, lineView) {
	    var ext = cm.display.externalMeasured;
	    if (ext && ext.line == lineView.line) {
	      cm.display.externalMeasured = null;
	      lineView.measure = ext.measure;
	      return ext.built
	    }
	    return buildLineContent(cm, lineView)
	  }
	
	  // Redraw the line's text. Interacts with the background and text
	  // classes because the mode may output tokens that influence these
	  // classes.
	  function updateLineText(cm, lineView) {
	    var cls = lineView.text.className;
	    var built = getLineContent(cm, lineView);
	    if (lineView.text == lineView.node) { lineView.node = built.pre; }
	    lineView.text.parentNode.replaceChild(built.pre, lineView.text);
	    lineView.text = built.pre;
	    if (built.bgClass != lineView.bgClass || built.textClass != lineView.textClass) {
	      lineView.bgClass = built.bgClass;
	      lineView.textClass = built.textClass;
	      updateLineClasses(cm, lineView);
	    } else if (cls) {
	      lineView.text.className = cls;
	    }
	  }
	
	  function updateLineClasses(cm, lineView) {
	    updateLineBackground(cm, lineView);
	    if (lineView.line.wrapClass)
	      { ensureLineWrapped(lineView).className = lineView.line.wrapClass; }
	    else if (lineView.node != lineView.text)
	      { lineView.node.className = ""; }
	    var textClass = lineView.textClass ? lineView.textClass + " " + (lineView.line.textClass || "") : lineView.line.textClass;
	    lineView.text.className = textClass || "";
	  }
	
	  function updateLineGutter(cm, lineView, lineN, dims) {
	    if (lineView.gutter) {
	      lineView.node.removeChild(lineView.gutter);
	      lineView.gutter = null;
	    }
	    if (lineView.gutterBackground) {
	      lineView.node.removeChild(lineView.gutterBackground);
	      lineView.gutterBackground = null;
	    }
	    if (lineView.line.gutterClass) {
	      var wrap = ensureLineWrapped(lineView);
	      lineView.gutterBackground = elt("div", null, "CodeMirror-gutter-background " + lineView.line.gutterClass,
	                                      ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px; width: " + (dims.gutterTotalWidth) + "px"));
	      cm.display.input.setUneditable(lineView.gutterBackground);
	      wrap.insertBefore(lineView.gutterBackground, lineView.text);
	    }
	    var markers = lineView.line.gutterMarkers;
	    if (cm.options.lineNumbers || markers) {
	      var wrap$1 = ensureLineWrapped(lineView);
	      var gutterWrap = lineView.gutter = elt("div", null, "CodeMirror-gutter-wrapper", ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px"));
	      gutterWrap.setAttribute("aria-hidden", "true");
	      cm.display.input.setUneditable(gutterWrap);
	      wrap$1.insertBefore(gutterWrap, lineView.text);
	      if (lineView.line.gutterClass)
	        { gutterWrap.className += " " + lineView.line.gutterClass; }
	      if (cm.options.lineNumbers && (!markers || !markers["CodeMirror-linenumbers"]))
	        { lineView.lineNumber = gutterWrap.appendChild(
	          elt("div", lineNumberFor(cm.options, lineN),
	              "CodeMirror-linenumber CodeMirror-gutter-elt",
	              ("left: " + (dims.gutterLeft["CodeMirror-linenumbers"]) + "px; width: " + (cm.display.lineNumInnerWidth) + "px"))); }
	      if (markers) { for (var k = 0; k < cm.display.gutterSpecs.length; ++k) {
	        var id = cm.display.gutterSpecs[k].className, found = markers.hasOwnProperty(id) && markers[id];
	        if (found)
	          { gutterWrap.appendChild(elt("div", [found], "CodeMirror-gutter-elt",
	                                     ("left: " + (dims.gutterLeft[id]) + "px; width: " + (dims.gutterWidth[id]) + "px"))); }
	      } }
	    }
	  }
	
	  function updateLineWidgets(cm, lineView, dims) {
	    if (lineView.alignable) { lineView.alignable = null; }
	    var isWidget = classTest("CodeMirror-linewidget");
	    for (var node = lineView.node.firstChild, next = (void 0); node; node = next) {
	      next = node.nextSibling;
	      if (isWidget.test(node.className)) { lineView.node.removeChild(node); }
	    }
	    insertLineWidgets(cm, lineView, dims);
	  }
	
	  // Build a line's DOM representation from scratch
	  function buildLineElement(cm, lineView, lineN, dims) {
	    var built = getLineContent(cm, lineView);
	    lineView.text = lineView.node = built.pre;
	    if (built.bgClass) { lineView.bgClass = built.bgClass; }
	    if (built.textClass) { lineView.textClass = built.textClass; }
	
	    updateLineClasses(cm, lineView);
	    updateLineGutter(cm, lineView, lineN, dims);
	    insertLineWidgets(cm, lineView, dims);
	    return lineView.node
	  }
	
	  // A lineView may contain multiple logical lines (when merged by
	  // collapsed spans). The widgets for all of them need to be drawn.
	  function insertLineWidgets(cm, lineView, dims) {
	    insertLineWidgetsFor(cm, lineView.line, lineView, dims, true);
	    if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
	      { insertLineWidgetsFor(cm, lineView.rest[i], lineView, dims, false); } }
	  }
	
	  function insertLineWidgetsFor(cm, line, lineView, dims, allowAbove) {
	    if (!line.widgets) { return }
	    var wrap = ensureLineWrapped(lineView);
	    for (var i = 0, ws = line.widgets; i < ws.length; ++i) {
	      var widget = ws[i], node = elt("div", [widget.node], "CodeMirror-linewidget" + (widget.className ? " " + widget.className : ""));
	      if (!widget.handleMouseEvents) { node.setAttribute("cm-ignore-events", "true"); }
	      positionLineWidget(widget, node, lineView, dims);
	      cm.display.input.setUneditable(node);
	      if (allowAbove && widget.above)
	        { wrap.insertBefore(node, lineView.gutter || lineView.text); }
	      else
	        { wrap.appendChild(node); }
	      signalLater(widget, "redraw");
	    }
	  }
	
	  function positionLineWidget(widget, node, lineView, dims) {
	    if (widget.noHScroll) {
	  (lineView.alignable || (lineView.alignable = [])).push(node);
	      var width = dims.wrapperWidth;
	      node.style.left = dims.fixedPos + "px";
	      if (!widget.coverGutter) {
	        width -= dims.gutterTotalWidth;
	        node.style.paddingLeft = dims.gutterTotalWidth + "px";
	      }
	      node.style.width = width + "px";
	    }
	    if (widget.coverGutter) {
	      node.style.zIndex = 5;
	      node.style.position = "relative";
	      if (!widget.noHScroll) { node.style.marginLeft = -dims.gutterTotalWidth + "px"; }
	    }
	  }
	
	  function widgetHeight(widget) {
	    if (widget.height != null) { return widget.height }
	    var cm = widget.doc.cm;
	    if (!cm) { return 0 }
	    if (!contains(document.body, widget.node)) {
	      var parentStyle = "position: relative;";
	      if (widget.coverGutter)
	        { parentStyle += "margin-left: -" + cm.display.gutters.offsetWidth + "px;"; }
	      if (widget.noHScroll)
	        { parentStyle += "width: " + cm.display.wrapper.clientWidth + "px;"; }
	      removeChildrenAndAdd(cm.display.measure, elt("div", [widget.node], null, parentStyle));
	    }
	    return widget.height = widget.node.parentNode.offsetHeight
	  }
	
	  // Return true when the given mouse event happened in a widget
	  function eventInWidget(display, e) {
	    for (var n = e_target(e); n != display.wrapper; n = n.parentNode) {
	      if (!n || (n.nodeType == 1 && n.getAttribute("cm-ignore-events") == "true") ||
	          (n.parentNode == display.sizer && n != display.mover))
	        { return true }
	    }
	  }
	
	  // POSITION MEASUREMENT
	
	  function paddingTop(display) {return display.lineSpace.offsetTop}
	  function paddingVert(display) {return display.mover.offsetHeight - display.lineSpace.offsetHeight}
	  function paddingH(display) {
	    if (display.cachedPaddingH) { return display.cachedPaddingH }
	    var e = removeChildrenAndAdd(display.measure, elt("pre", "x", "CodeMirror-line-like"));
	    var style = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle;
	    var data = {left: parseInt(style.paddingLeft), right: parseInt(style.paddingRight)};
	    if (!isNaN(data.left) && !isNaN(data.right)) { display.cachedPaddingH = data; }
	    return data
	  }
	
	  function scrollGap(cm) { return scrollerGap - cm.display.nativeBarWidth }
	  function displayWidth(cm) {
	    return cm.display.scroller.clientWidth - scrollGap(cm) - cm.display.barWidth
	  }
	  function displayHeight(cm) {
	    return cm.display.scroller.clientHeight - scrollGap(cm) - cm.display.barHeight
	  }
	
	  // Ensure the lineView.wrapping.heights array is populated. This is
	  // an array of bottom offsets for the lines that make up a drawn
	  // line. When lineWrapping is on, there might be more than one
	  // height.
	  function ensureLineHeights(cm, lineView, rect) {
	    var wrapping = cm.options.lineWrapping;
	    var curWidth = wrapping && displayWidth(cm);
	    if (!lineView.measure.heights || wrapping && lineView.measure.width != curWidth) {
	      var heights = lineView.measure.heights = [];
	      if (wrapping) {
	        lineView.measure.width = curWidth;
	        var rects = lineView.text.firstChild.getClientRects();
	        for (var i = 0; i < rects.length - 1; i++) {
	          var cur = rects[i], next = rects[i + 1];
	          if (Math.abs(cur.bottom - next.bottom) > 2)
	            { heights.push((cur.bottom + next.top) / 2 - rect.top); }
	        }
	      }
	      heights.push(rect.bottom - rect.top);
	    }
	  }
	
	  // Find a line map (mapping character offsets to text nodes) and a
	  // measurement cache for the given line number. (A line view might
	  // contain multiple lines when collapsed ranges are present.)
	  function mapFromLineView(lineView, line, lineN) {
	    if (lineView.line == line)
	      { return {map: lineView.measure.map, cache: lineView.measure.cache} }
	    if (lineView.rest) {
	      for (var i = 0; i < lineView.rest.length; i++)
	        { if (lineView.rest[i] == line)
	          { return {map: lineView.measure.maps[i], cache: lineView.measure.caches[i]} } }
	      for (var i$1 = 0; i$1 < lineView.rest.length; i$1++)
	        { if (lineNo(lineView.rest[i$1]) > lineN)
	          { return {map: lineView.measure.maps[i$1], cache: lineView.measure.caches[i$1], before: true} } }
	    }
	  }
	
	  // Render a line into the hidden node display.externalMeasured. Used
	  // when measurement is needed for a line that's not in the viewport.
	  function updateExternalMeasurement(cm, line) {
	    line = visualLine(line);
	    var lineN = lineNo(line);
	    var view = cm.display.externalMeasured = new LineView(cm.doc, line, lineN);
	    view.lineN = lineN;
	    var built = view.built = buildLineContent(cm, view);
	    view.text = built.pre;
	    removeChildrenAndAdd(cm.display.lineMeasure, built.pre);
	    return view
	  }
	
	  // Get a {top, bottom, left, right} box (in line-local coordinates)
	  // for a given character.
	  function measureChar(cm, line, ch, bias) {
	    return measureCharPrepared(cm, prepareMeasureForLine(cm, line), ch, bias)
	  }
	
	  // Find a line view that corresponds to the given line number.
	  function findViewForLine(cm, lineN) {
	    if (lineN >= cm.display.viewFrom && lineN < cm.display.viewTo)
	      { return cm.display.view[findViewIndex(cm, lineN)] }
	    var ext = cm.display.externalMeasured;
	    if (ext && lineN >= ext.lineN && lineN < ext.lineN + ext.size)
	      { return ext }
	  }
	
	  // Measurement can be split in two steps, the set-up work that
	  // applies to the whole line, and the measurement of the actual
	  // character. Functions like coordsChar, that need to do a lot of
	  // measurements in a row, can thus ensure that the set-up work is
	  // only done once.
	  function prepareMeasureForLine(cm, line) {
	    var lineN = lineNo(line);
	    var view = findViewForLine(cm, lineN);
	    if (view && !view.text) {
	      view = null;
	    } else if (view && view.changes) {
	      updateLineForChanges(cm, view, lineN, getDimensions(cm));
	      cm.curOp.forceUpdate = true;
	    }
	    if (!view)
	      { view = updateExternalMeasurement(cm, line); }
	
	    var info = mapFromLineView(view, line, lineN);
	    return {
	      line: line, view: view, rect: null,
	      map: info.map, cache: info.cache, before: info.before,
	      hasHeights: false
	    }
	  }
	
	  // Given a prepared measurement object, measures the position of an
	  // actual character (or fetches it from the cache).
	  function measureCharPrepared(cm, prepared, ch, bias, varHeight) {
	    if (prepared.before) { ch = -1; }
	    var key = ch + (bias || ""), found;
	    if (prepared.cache.hasOwnProperty(key)) {
	      found = prepared.cache[key];
	    } else {
	      if (!prepared.rect)
	        { prepared.rect = prepared.view.text.getBoundingClientRect(); }
	      if (!prepared.hasHeights) {
	        ensureLineHeights(cm, prepared.view, prepared.rect);
	        prepared.hasHeights = true;
	      }
	      found = measureCharInner(cm, prepared, ch, bias);
	      if (!found.bogus) { prepared.cache[key] = found; }
	    }
	    return {left: found.left, right: found.right,
	            top: varHeight ? found.rtop : found.top,
	            bottom: varHeight ? found.rbottom : found.bottom}
	  }
	
	  var nullRect = {left: 0, right: 0, top: 0, bottom: 0};
	
	  function nodeAndOffsetInLineMap(map, ch, bias) {
	    var node, start, end, collapse, mStart, mEnd;
	    // First, search the line map for the text node corresponding to,
	    // or closest to, the target character.
	    for (var i = 0; i < map.length; i += 3) {
	      mStart = map[i];
	      mEnd = map[i + 1];
	      if (ch < mStart) {
	        start = 0; end = 1;
	        collapse = "left";
	      } else if (ch < mEnd) {
	        start = ch - mStart;
	        end = start + 1;
	      } else if (i == map.length - 3 || ch == mEnd && map[i + 3] > ch) {
	        end = mEnd - mStart;
	        start = end - 1;
	        if (ch >= mEnd) { collapse = "right"; }
	      }
	      if (start != null) {
	        node = map[i + 2];
	        if (mStart == mEnd && bias == (node.insertLeft ? "left" : "right"))
	          { collapse = bias; }
	        if (bias == "left" && start == 0)
	          { while (i && map[i - 2] == map[i - 3] && map[i - 1].insertLeft) {
	            node = map[(i -= 3) + 2];
	            collapse = "left";
	          } }
	        if (bias == "right" && start == mEnd - mStart)
	          { while (i < map.length - 3 && map[i + 3] == map[i + 4] && !map[i + 5].insertLeft) {
	            node = map[(i += 3) + 2];
	            collapse = "right";
	          } }
	        break
	      }
	    }
	    return {node: node, start: start, end: end, collapse: collapse, coverStart: mStart, coverEnd: mEnd}
	  }
	
	  function getUsefulRect(rects, bias) {
	    var rect = nullRect;
	    if (bias == "left") { for (var i = 0; i < rects.length; i++) {
	      if ((rect = rects[i]).left != rect.right) { break }
	    } } else { for (var i$1 = rects.length - 1; i$1 >= 0; i$1--) {
	      if ((rect = rects[i$1]).left != rect.right) { break }
	    } }
	    return rect
	  }
	
	  function measureCharInner(cm, prepared, ch, bias) {
	    var place = nodeAndOffsetInLineMap(prepared.map, ch, bias);
	    var node = place.node, start = place.start, end = place.end, collapse = place.collapse;
	
	    var rect;
	    if (node.nodeType == 3) { // If it is a text node, use a range to retrieve the coordinates.
	      for (var i$1 = 0; i$1 < 4; i$1++) { // Retry a maximum of 4 times when nonsense rectangles are returned
	        while (start && isExtendingChar(prepared.line.text.charAt(place.coverStart + start))) { --start; }
	        while (place.coverStart + end < place.coverEnd && isExtendingChar(prepared.line.text.charAt(place.coverStart + end))) { ++end; }
	        if (ie && ie_version < 9 && start == 0 && end == place.coverEnd - place.coverStart)
	          { rect = node.parentNode.getBoundingClientRect(); }
	        else
	          { rect = getUsefulRect(range(node, start, end).getClientRects(), bias); }
	        if (rect.left || rect.right || start == 0) { break }
	        end = start;
	        start = start - 1;
	        collapse = "right";
	      }
	      if (ie && ie_version < 11) { rect = maybeUpdateRectForZooming(cm.display.measure, rect); }
	    } else { // If it is a widget, simply get the box for the whole widget.
	      if (start > 0) { collapse = bias = "right"; }
	      var rects;
	      if (cm.options.lineWrapping && (rects = node.getClientRects()).length > 1)
	        { rect = rects[bias == "right" ? rects.length - 1 : 0]; }
	      else
	        { rect = node.getBoundingClientRect(); }
	    }
	    if (ie && ie_version < 9 && !start && (!rect || !rect.left && !rect.right)) {
	      var rSpan = node.parentNode.getClientRects()[0];
	      if (rSpan)
	        { rect = {left: rSpan.left, right: rSpan.left + charWidth(cm.display), top: rSpan.top, bottom: rSpan.bottom}; }
	      else
	        { rect = nullRect; }
	    }
	
	    var rtop = rect.top - prepared.rect.top, rbot = rect.bottom - prepared.rect.top;
	    var mid = (rtop + rbot) / 2;
	    var heights = prepared.view.measure.heights;
	    var i = 0;
	    for (; i < heights.length - 1; i++)
	      { if (mid < heights[i]) { break } }
	    var top = i ? heights[i - 1] : 0, bot = heights[i];
	    var result = {left: (collapse == "right" ? rect.right : rect.left) - prepared.rect.left,
	                  right: (collapse == "left" ? rect.left : rect.right) - prepared.rect.left,
	                  top: top, bottom: bot};
	    if (!rect.left && !rect.right) { result.bogus = true; }
	    if (!cm.options.singleCursorHeightPerLine) { result.rtop = rtop; result.rbottom = rbot; }
	
	    return result
	  }
	
	  // Work around problem with bounding client rects on ranges being
	  // returned incorrectly when zoomed on IE10 and below.
	  function maybeUpdateRectForZooming(measure, rect) {
	    if (!window.screen || screen.logicalXDPI == null ||
	        screen.logicalXDPI == screen.deviceXDPI || !hasBadZoomedRects(measure))
	      { return rect }
	    var scaleX = screen.logicalXDPI / screen.deviceXDPI;
	    var scaleY = screen.logicalYDPI / screen.deviceYDPI;
	    return {left: rect.left * scaleX, right: rect.right * scaleX,
	            top: rect.top * scaleY, bottom: rect.bottom * scaleY}
	  }
	
	  function clearLineMeasurementCacheFor(lineView) {
	    if (lineView.measure) {
	      lineView.measure.cache = {};
	      lineView.measure.heights = null;
	      if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
	        { lineView.measure.caches[i] = {}; } }
	    }
	  }
	
	  function clearLineMeasurementCache(cm) {
	    cm.display.externalMeasure = null;
	    removeChildren(cm.display.lineMeasure);
	    for (var i = 0; i < cm.display.view.length; i++)
	      { clearLineMeasurementCacheFor(cm.display.view[i]); }
	  }
	
	  function clearCaches(cm) {
	    clearLineMeasurementCache(cm);
	    cm.display.cachedCharWidth = cm.display.cachedTextHeight = cm.display.cachedPaddingH = null;
	    if (!cm.options.lineWrapping) { cm.display.maxLineChanged = true; }
	    cm.display.lineNumChars = null;
	  }
	
	  function pageScrollX() {
	    // Work around https://bugs.chromium.org/p/chromium/issues/detail?id=489206
	    // which causes page_Offset and bounding client rects to use
	    // different reference viewports and invalidate our calculations.
	    if (chrome && android) { return -(document.body.getBoundingClientRect().left - parseInt(getComputedStyle(document.body).marginLeft)) }
	    return window.pageXOffset || (document.documentElement || document.body).scrollLeft
	  }
	  function pageScrollY() {
	    if (chrome && android) { return -(document.body.getBoundingClientRect().top - parseInt(getComputedStyle(document.body).marginTop)) }
	    return window.pageYOffset || (document.documentElement || document.body).scrollTop
	  }
	
	  function widgetTopHeight(lineObj) {
	    var ref = visualLine(lineObj);
	    var widgets = ref.widgets;
	    var height = 0;
	    if (widgets) { for (var i = 0; i < widgets.length; ++i) { if (widgets[i].above)
	      { height += widgetHeight(widgets[i]); } } }
	    return height
	  }
	
	  // Converts a {top, bottom, left, right} box from line-local
	  // coordinates into another coordinate system. Context may be one of
	  // "line", "div" (display.lineDiv), "local"./null (editor), "window",
	  // or "page".
	  function intoCoordSystem(cm, lineObj, rect, context, includeWidgets) {
	    if (!includeWidgets) {
	      var height = widgetTopHeight(lineObj);
	      rect.top += height; rect.bottom += height;
	    }
	    if (context == "line") { return rect }
	    if (!context) { context = "local"; }
	    var yOff = heightAtLine(lineObj);
	    if (context == "local") { yOff += paddingTop(cm.display); }
	    else { yOff -= cm.display.viewOffset; }
	    if (context == "page" || context == "window") {
	      var lOff = cm.display.lineSpace.getBoundingClientRect();
	      yOff += lOff.top + (context == "window" ? 0 : pageScrollY());
	      var xOff = lOff.left + (context == "window" ? 0 : pageScrollX());
	      rect.left += xOff; rect.right += xOff;
	    }
	    rect.top += yOff; rect.bottom += yOff;
	    return rect
	  }
	
	  // Coverts a box from "div" coords to another coordinate system.
	  // Context may be "window", "page", "div", or "local"./null.
	  function fromCoordSystem(cm, coords, context) {
	    if (context == "div") { return coords }
	    var left = coords.left, top = coords.top;
	    // First move into "page" coordinate system
	    if (context == "page") {
	      left -= pageScrollX();
	      top -= pageScrollY();
	    } else if (context == "local" || !context) {
	      var localBox = cm.display.sizer.getBoundingClientRect();
	      left += localBox.left;
	      top += localBox.top;
	    }
	
	    var lineSpaceBox = cm.display.lineSpace.getBoundingClientRect();
	    return {left: left - lineSpaceBox.left, top: top - lineSpaceBox.top}
	  }
	
	  function charCoords(cm, pos, context, lineObj, bias) {
	    if (!lineObj) { lineObj = getLine(cm.doc, pos.line); }
	    return intoCoordSystem(cm, lineObj, measureChar(cm, lineObj, pos.ch, bias), context)
	  }
	
	  // Returns a box for a given cursor position, which may have an
	  // 'other' property containing the position of the secondary cursor
	  // on a bidi boundary.
	  // A cursor Pos(line, char, "before") is on the same visual line as `char - 1`
	  // and after `char - 1` in writing order of `char - 1`
	  // A cursor Pos(line, char, "after") is on the same visual line as `char`
	  // and before `char` in writing order of `char`
	  // Examples (upper-case letters are RTL, lower-case are LTR):
	  //     Pos(0, 1, ...)
	  //     before   after
	  // ab     a|b     a|b
	  // aB     a|B     aB|
	  // Ab     |Ab     A|b
	  // AB     B|A     B|A
	  // Every position after the last character on a line is considered to stick
	  // to the last character on the line.
	  function cursorCoords(cm, pos, context, lineObj, preparedMeasure, varHeight) {
	    lineObj = lineObj || getLine(cm.doc, pos.line);
	    if (!preparedMeasure) { preparedMeasure = prepareMeasureForLine(cm, lineObj); }
	    function get(ch, right) {
	      var m = measureCharPrepared(cm, preparedMeasure, ch, right ? "right" : "left", varHeight);
	      if (right) { m.left = m.right; } else { m.right = m.left; }
	      return intoCoordSystem(cm, lineObj, m, context)
	    }
	    var order = getOrder(lineObj, cm.doc.direction), ch = pos.ch, sticky = pos.sticky;
	    if (ch >= lineObj.text.length) {
	      ch = lineObj.text.length;
	      sticky = "before";
	    } else if (ch <= 0) {
	      ch = 0;
	      sticky = "after";
	    }
	    if (!order) { return get(sticky == "before" ? ch - 1 : ch, sticky == "before") }
	
	    function getBidi(ch, partPos, invert) {
	      var part = order[partPos], right = part.level == 1;
	      return get(invert ? ch - 1 : ch, right != invert)
	    }
	    var partPos = getBidiPartAt(order, ch, sticky);
	    var other = bidiOther;
	    var val = getBidi(ch, partPos, sticky == "before");
	    if (other != null) { val.other = getBidi(ch, other, sticky != "before"); }
	    return val
	  }
	
	  // Used to cheaply estimate the coordinates for a position. Used for
	  // intermediate scroll updates.
	  function estimateCoords(cm, pos) {
	    var left = 0;
	    pos = clipPos(cm.doc, pos);
	    if (!cm.options.lineWrapping) { left = charWidth(cm.display) * pos.ch; }
	    var lineObj = getLine(cm.doc, pos.line);
	    var top = heightAtLine(lineObj) + paddingTop(cm.display);
	    return {left: left, right: left, top: top, bottom: top + lineObj.height}
	  }
	
	  // Positions returned by coordsChar contain some extra information.
	  // xRel is the relative x position of the input coordinates compared
	  // to the found position (so xRel > 0 means the coordinates are to
	  // the right of the character position, for example). When outside
	  // is true, that means the coordinates lie outside the line's
	  // vertical range.
	  function PosWithInfo(line, ch, sticky, outside, xRel) {
	    var pos = Pos(line, ch, sticky);
	    pos.xRel = xRel;
	    if (outside) { pos.outside = outside; }
	    return pos
	  }
	
	  // Compute the character position closest to the given coordinates.
	  // Input must be lineSpace-local ("div" coordinate system).
	  function coordsChar(cm, x, y) {
	    var doc = cm.doc;
	    y += cm.display.viewOffset;
	    if (y < 0) { return PosWithInfo(doc.first, 0, null, -1, -1) }
	    var lineN = lineAtHeight(doc, y), last = doc.first + doc.size - 1;
	    if (lineN > last)
	      { return PosWithInfo(doc.first + doc.size - 1, getLine(doc, last).text.length, null, 1, 1) }
	    if (x < 0) { x = 0; }
	
	    var lineObj = getLine(doc, lineN);
	    for (;;) {
	      var found = coordsCharInner(cm, lineObj, lineN, x, y);
	      var collapsed = collapsedSpanAround(lineObj, found.ch + (found.xRel > 0 || found.outside > 0 ? 1 : 0));
	      if (!collapsed) { return found }
	      var rangeEnd = collapsed.find(1);
	      if (rangeEnd.line == lineN) { return rangeEnd }
	      lineObj = getLine(doc, lineN = rangeEnd.line);
	    }
	  }
	
	  function wrappedLineExtent(cm, lineObj, preparedMeasure, y) {
	    y -= widgetTopHeight(lineObj);
	    var end = lineObj.text.length;
	    var begin = findFirst(function (ch) { return measureCharPrepared(cm, preparedMeasure, ch - 1).bottom <= y; }, end, 0);
	    end = findFirst(function (ch) { return measureCharPrepared(cm, preparedMeasure, ch).top > y; }, begin, end);
	    return {begin: begin, end: end}
	  }
	
	  function wrappedLineExtentChar(cm, lineObj, preparedMeasure, target) {
	    if (!preparedMeasure) { preparedMeasure = prepareMeasureForLine(cm, lineObj); }
	    var targetTop = intoCoordSystem(cm, lineObj, measureCharPrepared(cm, preparedMeasure, target), "line").top;
	    return wrappedLineExtent(cm, lineObj, preparedMeasure, targetTop)
	  }
	
	  // Returns true if the given side of a box is after the given
	  // coordinates, in top-to-bottom, left-to-right order.
	  function boxIsAfter(box, x, y, left) {
	    return box.bottom <= y ? false : box.top > y ? true : (left ? box.left : box.right) > x
	  }
	
	  function coordsCharInner(cm, lineObj, lineNo, x, y) {
	    // Move y into line-local coordinate space
	    y -= heightAtLine(lineObj);
	    var preparedMeasure = prepareMeasureForLine(cm, lineObj);
	    // When directly calling `measureCharPrepared`, we have to adjust
	    // for the widgets at this line.
	    var widgetHeight = widgetTopHeight(lineObj);
	    var begin = 0, end = lineObj.text.length, ltr = true;
	
	    var order = getOrder(lineObj, cm.doc.direction);
	    // If the line isn't plain left-to-right text, first figure out
	    // which bidi section the coordinates fall into.
	    if (order) {
	      var part = (cm.options.lineWrapping ? coordsBidiPartWrapped : coordsBidiPart)
	                   (cm, lineObj, lineNo, preparedMeasure, order, x, y);
	      ltr = part.level != 1;
	      // The awkward -1 offsets are needed because findFirst (called
	      // on these below) will treat its first bound as inclusive,
	      // second as exclusive, but we want to actually address the
	      // characters in the part's range
	      begin = ltr ? part.from : part.to - 1;
	      end = ltr ? part.to : part.from - 1;
	    }
	
	    // A binary search to find the first character whose bounding box
	    // starts after the coordinates. If we run across any whose box wrap
	    // the coordinates, store that.
	    var chAround = null, boxAround = null;
	    var ch = findFirst(function (ch) {
	      var box = measureCharPrepared(cm, preparedMeasure, ch);
	      box.top += widgetHeight; box.bottom += widgetHeight;
	      if (!boxIsAfter(box, x, y, false)) { return false }
	      if (box.top <= y && box.left <= x) {
	        chAround = ch;
	        boxAround = box;
	      }
	      return true
	    }, begin, end);
	
	    var baseX, sticky, outside = false;
	    // If a box around the coordinates was found, use that
	    if (boxAround) {
	      // Distinguish coordinates nearer to the left or right side of the box
	      var atLeft = x - boxAround.left < boxAround.right - x, atStart = atLeft == ltr;
	      ch = chAround + (atStart ? 0 : 1);
	      sticky = atStart ? "after" : "before";
	      baseX = atLeft ? boxAround.left : boxAround.right;
	    } else {
	      // (Adjust for extended bound, if necessary.)
	      if (!ltr && (ch == end || ch == begin)) { ch++; }
	      // To determine which side to associate with, get the box to the
	      // left of the character and compare it's vertical position to the
	      // coordinates
	      sticky = ch == 0 ? "after" : ch == lineObj.text.length ? "before" :
	        (measureCharPrepared(cm, preparedMeasure, ch - (ltr ? 1 : 0)).bottom + widgetHeight <= y) == ltr ?
	        "after" : "before";
	      // Now get accurate coordinates for this place, in order to get a
	      // base X position
	      var coords = cursorCoords(cm, Pos(lineNo, ch, sticky), "line", lineObj, preparedMeasure);
	      baseX = coords.left;
	      outside = y < coords.top ? -1 : y >= coords.bottom ? 1 : 0;
	    }
	
	    ch = skipExtendingChars(lineObj.text, ch, 1);
	    return PosWithInfo(lineNo, ch, sticky, outside, x - baseX)
	  }
	
	  function coordsBidiPart(cm, lineObj, lineNo, preparedMeasure, order, x, y) {
	    // Bidi parts are sorted left-to-right, and in a non-line-wrapping
	    // situation, we can take this ordering to correspond to the visual
	    // ordering. This finds the first part whose end is after the given
	    // coordinates.
	    var index = findFirst(function (i) {
	      var part = order[i], ltr = part.level != 1;
	      return boxIsAfter(cursorCoords(cm, Pos(lineNo, ltr ? part.to : part.from, ltr ? "before" : "after"),
	                                     "line", lineObj, preparedMeasure), x, y, true)
	    }, 0, order.length - 1);
	    var part = order[index];
	    // If this isn't the first part, the part's start is also after
	    // the coordinates, and the coordinates aren't on the same line as
	    // that start, move one part back.
	    if (index > 0) {
	      var ltr = part.level != 1;
	      var start = cursorCoords(cm, Pos(lineNo, ltr ? part.from : part.to, ltr ? "after" : "before"),
	                               "line", lineObj, preparedMeasure);
	      if (boxIsAfter(start, x, y, true) && start.top > y)
	        { part = order[index - 1]; }
	    }
	    return part
	  }
	
	  function coordsBidiPartWrapped(cm, lineObj, _lineNo, preparedMeasure, order, x, y) {
	    // In a wrapped line, rtl text on wrapping boundaries can do things
	    // that don't correspond to the ordering in our `order` array at
	    // all, so a binary search doesn't work, and we want to return a
	    // part that only spans one line so that the binary search in
	    // coordsCharInner is safe. As such, we first find the extent of the
	    // wrapped line, and then do a flat search in which we discard any
	    // spans that aren't on the line.
	    var ref = wrappedLineExtent(cm, lineObj, preparedMeasure, y);
	    var begin = ref.begin;
	    var end = ref.end;
	    if (/\s/.test(lineObj.text.charAt(end - 1))) { end--; }
	    var part = null, closestDist = null;
	    for (var i = 0; i < order.length; i++) {
	      var p = order[i];
	      if (p.from >= end || p.to <= begin) { continue }
	      var ltr = p.level != 1;
	      var endX = measureCharPrepared(cm, preparedMeasure, ltr ? Math.min(end, p.to) - 1 : Math.max(begin, p.from)).right;
	      // Weigh against spans ending before this, so that they are only
	      // picked if nothing ends after
	      var dist = endX < x ? x - endX + 1e9 : endX - x;
	      if (!part || closestDist > dist) {
	        part = p;
	        closestDist = dist;
	      }
	    }
	    if (!part) { part = order[order.length - 1]; }
	    // Clip the part to the wrapped line.
	    if (part.from < begin) { part = {from: begin, to: part.to, level: part.level}; }
	    if (part.to > end) { part = {from: part.from, to: end, level: part.level}; }
	    return part
	  }
	
	  var measureText;
	  // Compute the default text height.
	  function textHeight(display) {
	    if (display.cachedTextHeight != null) { return display.cachedTextHeight }
	    if (measureText == null) {
	      measureText = elt("pre", null, "CodeMirror-line-like");
	      // Measure a bunch of lines, for browsers that compute
	      // fractional heights.
	      for (var i = 0; i < 49; ++i) {
	        measureText.appendChild(document.createTextNode("x"));
	        measureText.appendChild(elt("br"));
	      }
	      measureText.appendChild(document.createTextNode("x"));
	    }
	    removeChildrenAndAdd(display.measure, measureText);
	    var height = measureText.offsetHeight / 50;
	    if (height > 3) { display.cachedTextHeight = height; }
	    removeChildren(display.measure);
	    return height || 1
	  }
	
	  // Compute the default character width.
	  function charWidth(display) {
	    if (display.cachedCharWidth != null) { return display.cachedCharWidth }
	    var anchor = elt("span", "xxxxxxxxxx");
	    var pre = elt("pre", [anchor], "CodeMirror-line-like");
	    removeChildrenAndAdd(display.measure, pre);
	    var rect = anchor.getBoundingClientRect(), width = (rect.right - rect.left) / 10;
	    if (width > 2) { display.cachedCharWidth = width; }
	    return width || 10
	  }
	
	  // Do a bulk-read of the DOM positions and sizes needed to draw the
	  // view, so that we don't interleave reading and writing to the DOM.
	  function getDimensions(cm) {
	    var d = cm.display, left = {}, width = {};
	    var gutterLeft = d.gutters.clientLeft;
	    for (var n = d.gutters.firstChild, i = 0; n; n = n.nextSibling, ++i) {
	      var id = cm.display.gutterSpecs[i].className;
	      left[id] = n.offsetLeft + n.clientLeft + gutterLeft;
	      width[id] = n.clientWidth;
	    }
	    return {fixedPos: compensateForHScroll(d),
	            gutterTotalWidth: d.gutters.offsetWidth,
	            gutterLeft: left,
	            gutterWidth: width,
	            wrapperWidth: d.wrapper.clientWidth}
	  }
	
	  // Computes display.scroller.scrollLeft + display.gutters.offsetWidth,
	  // but using getBoundingClientRect to get a sub-pixel-accurate
	  // result.
	  function compensateForHScroll(display) {
	    return display.scroller.getBoundingClientRect().left - display.sizer.getBoundingClientRect().left
	  }
	
	  // Returns a function that estimates the height of a line, to use as
	  // first approximation until the line becomes visible (and is thus
	  // properly measurable).
	  function estimateHeight(cm) {
	    var th = textHeight(cm.display), wrapping = cm.options.lineWrapping;
	    var perLine = wrapping && Math.max(5, cm.display.scroller.clientWidth / charWidth(cm.display) - 3);
	    return function (line) {
	      if (lineIsHidden(cm.doc, line)) { return 0 }
	
	      var widgetsHeight = 0;
	      if (line.widgets) { for (var i = 0; i < line.widgets.length; i++) {
	        if (line.widgets[i].height) { widgetsHeight += line.widgets[i].height; }
	      } }
	
	      if (wrapping)
	        { return widgetsHeight + (Math.ceil(line.text.length / perLine) || 1) * th }
	      else
	        { return widgetsHeight + th }
	    }
	  }
	
	  function estimateLineHeights(cm) {
	    var doc = cm.doc, est = estimateHeight(cm);
	    doc.iter(function (line) {
	      var estHeight = est(line);
	      if (estHeight != line.height) { updateLineHeight(line, estHeight); }
	    });
	  }
	
	  // Given a mouse event, find the corresponding position. If liberal
	  // is false, it checks whether a gutter or scrollbar was clicked,
	  // and returns null if it was. forRect is used by rectangular
	  // selections, and tries to estimate a character position even for
	  // coordinates beyond the right of the text.
	  function posFromMouse(cm, e, liberal, forRect) {
	    var display = cm.display;
	    if (!liberal && e_target(e).getAttribute("cm-not-content") == "true") { return null }
	
	    var x, y, space = display.lineSpace.getBoundingClientRect();
	    // Fails unpredictably on IE[67] when mouse is dragged around quickly.
	    try { x = e.clientX - space.left; y = e.clientY - space.top; }
	    catch (e$1) { return null }
	    var coords = coordsChar(cm, x, y), line;
	    if (forRect && coords.xRel > 0 && (line = getLine(cm.doc, coords.line).text).length == coords.ch) {
	      var colDiff = countColumn(line, line.length, cm.options.tabSize) - line.length;
	      coords = Pos(coords.line, Math.max(0, Math.round((x - paddingH(cm.display).left) / charWidth(cm.display)) - colDiff));
	    }
	    return coords
	  }
	
	  // Find the view element corresponding to a given line. Return null
	  // when the line isn't visible.
	  function findViewIndex(cm, n) {
	    if (n >= cm.display.viewTo) { return null }
	    n -= cm.display.viewFrom;
	    if (n < 0) { return null }
	    var view = cm.display.view;
	    for (var i = 0; i < view.length; i++) {
	      n -= view[i].size;
	      if (n < 0) { return i }
	    }
	  }
	
	  // Updates the display.view data structure for a given change to the
	  // document. From and to are in pre-change coordinates. Lendiff is
	  // the amount of lines added or subtracted by the change. This is
	  // used for changes that span multiple lines, or change the way
	  // lines are divided into visual lines. regLineChange (below)
	  // registers single-line changes.
	  function regChange(cm, from, to, lendiff) {
	    if (from == null) { from = cm.doc.first; }
	    if (to == null) { to = cm.doc.first + cm.doc.size; }
	    if (!lendiff) { lendiff = 0; }
	
	    var display = cm.display;
	    if (lendiff && to < display.viewTo &&
	        (display.updateLineNumbers == null || display.updateLineNumbers > from))
	      { display.updateLineNumbers = from; }
	
	    cm.curOp.viewChanged = true;
	
	    if (from >= display.viewTo) { // Change after
	      if (sawCollapsedSpans && visualLineNo(cm.doc, from) < display.viewTo)
	        { resetView(cm); }
	    } else if (to <= display.viewFrom) { // Change before
	      if (sawCollapsedSpans && visualLineEndNo(cm.doc, to + lendiff) > display.viewFrom) {
	        resetView(cm);
	      } else {
	        display.viewFrom += lendiff;
	        display.viewTo += lendiff;
	      }
	    } else if (from <= display.viewFrom && to >= display.viewTo) { // Full overlap
	      resetView(cm);
	    } else if (from <= display.viewFrom) { // Top overlap
	      var cut = viewCuttingPoint(cm, to, to + lendiff, 1);
	      if (cut) {
	        display.view = display.view.slice(cut.index);
	        display.viewFrom = cut.lineN;
	        display.viewTo += lendiff;
	      } else {
	        resetView(cm);
	      }
	    } else if (to >= display.viewTo) { // Bottom overlap
	      var cut$1 = viewCuttingPoint(cm, from, from, -1);
	      if (cut$1) {
	        display.view = display.view.slice(0, cut$1.index);
	        display.viewTo = cut$1.lineN;
	      } else {
	        resetView(cm);
	      }
	    } else { // Gap in the middle
	      var cutTop = viewCuttingPoint(cm, from, from, -1);
	      var cutBot = viewCuttingPoint(cm, to, to + lendiff, 1);
	      if (cutTop && cutBot) {
	        display.view = display.view.slice(0, cutTop.index)
	          .concat(buildViewArray(cm, cutTop.lineN, cutBot.lineN))
	          .concat(display.view.slice(cutBot.index));
	        display.viewTo += lendiff;
	      } else {
	        resetView(cm);
	      }
	    }
	
	    var ext = display.externalMeasured;
	    if (ext) {
	      if (to < ext.lineN)
	        { ext.lineN += lendiff; }
	      else if (from < ext.lineN + ext.size)
	        { display.externalMeasured = null; }
	    }
	  }
	
	  // Register a change to a single line. Type must be one of "text",
	  // "gutter", "class", "widget"
	  function regLineChange(cm, line, type) {
	    cm.curOp.viewChanged = true;
	    var display = cm.display, ext = cm.display.externalMeasured;
	    if (ext && line >= ext.lineN && line < ext.lineN + ext.size)
	      { display.externalMeasured = null; }
	
	    if (line < display.viewFrom || line >= display.viewTo) { return }
	    var lineView = display.view[findViewIndex(cm, line)];
	    if (lineView.node == null) { return }
	    var arr = lineView.changes || (lineView.changes = []);
	    if (indexOf(arr, type) == -1) { arr.push(type); }
	  }
	
	  // Clear the view.
	  function resetView(cm) {
	    cm.display.viewFrom = cm.display.viewTo = cm.doc.first;
	    cm.display.view = [];
	    cm.display.viewOffset = 0;
	  }
	
	  function viewCuttingPoint(cm, oldN, newN, dir) {
	    var index = findViewIndex(cm, oldN), diff, view = cm.display.view;
	    if (!sawCollapsedSpans || newN == cm.doc.first + cm.doc.size)
	      { return {index: index, lineN: newN} }
	    var n = cm.display.viewFrom;
	    for (var i = 0; i < index; i++)
	      { n += view[i].size; }
	    if (n != oldN) {
	      if (dir > 0) {
	        if (index == view.length - 1) { return null }
	        diff = (n + view[index].size) - oldN;
	        index++;
	      } else {
	        diff = n - oldN;
	      }
	      oldN += diff; newN += diff;
	    }
	    while (visualLineNo(cm.doc, newN) != newN) {
	      if (index == (dir < 0 ? 0 : view.length - 1)) { return null }
	      newN += dir * view[index - (dir < 0 ? 1 : 0)].size;
	      index += dir;
	    }
	    return {index: index, lineN: newN}
	  }
	
	  // Force the view to cover a given range, adding empty view element
	  // or clipping off existing ones as needed.
	  function adjustView(cm, from, to) {
	    var display = cm.display, view = display.view;
	    if (view.length == 0 || from >= display.viewTo || to <= display.viewFrom) {
	      display.view = buildViewArray(cm, from, to);
	      display.viewFrom = from;
	    } else {
	      if (display.viewFrom > from)
	        { display.view = buildViewArray(cm, from, display.viewFrom).concat(display.view); }
	      else if (display.viewFrom < from)
	        { display.view = display.view.slice(findViewIndex(cm, from)); }
	      display.viewFrom = from;
	      if (display.viewTo < to)
	        { display.view = display.view.concat(buildViewArray(cm, display.viewTo, to)); }
	      else if (display.viewTo > to)
	        { display.view = display.view.slice(0, findViewIndex(cm, to)); }
	    }
	    display.viewTo = to;
	  }
	
	  // Count the number of lines in the view whose DOM representation is
	  // out of date (or nonexistent).
	  function countDirtyView(cm) {
	    var view = cm.display.view, dirty = 0;
	    for (var i = 0; i < view.length; i++) {
	      var lineView = view[i];
	      if (!lineView.hidden && (!lineView.node || lineView.changes)) { ++dirty; }
	    }
	    return dirty
	  }
	
	  function updateSelection(cm) {
	    cm.display.input.showSelection(cm.display.input.prepareSelection());
	  }
	
	  function prepareSelection(cm, primary) {
	    if ( primary === void 0 ) primary = true;
	
	    var doc = cm.doc, result = {};
	    var curFragment = result.cursors = document.createDocumentFragment();
	    var selFragment = result.selection = document.createDocumentFragment();
	
	    var customCursor = cm.options.$customCursor;
	    if (customCursor) { primary = true; }
	    for (var i = 0; i < doc.sel.ranges.length; i++) {
	      if (!primary && i == doc.sel.primIndex) { continue }
	      var range = doc.sel.ranges[i];
	      if (range.from().line >= cm.display.viewTo || range.to().line < cm.display.viewFrom) { continue }
	      var collapsed = range.empty();
	      if (customCursor) {
	        var head = customCursor(cm, range);
	        if (head) { drawSelectionCursor(cm, head, curFragment); }
	      } else if (collapsed || cm.options.showCursorWhenSelecting) {
	        drawSelectionCursor(cm, range.head, curFragment);
	      }
	      if (!collapsed)
	        { drawSelectionRange(cm, range, selFragment); }
	    }
	    return result
	  }
	
	  // Draws a cursor for the given range
	  function drawSelectionCursor(cm, head, output) {
	    var pos = cursorCoords(cm, head, "div", null, null, !cm.options.singleCursorHeightPerLine);
	
	    var cursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor"));
	    cursor.style.left = pos.left + "px";
	    cursor.style.top = pos.top + "px";
	    cursor.style.height = Math.max(0, pos.bottom - pos.top) * cm.options.cursorHeight + "px";
	
	    if (/\bcm-fat-cursor\b/.test(cm.getWrapperElement().className)) {
	      var charPos = charCoords(cm, head, "div", null, null);
	      var width = charPos.right - charPos.left;
	      cursor.style.width = (width > 0 ? width : cm.defaultCharWidth()) + "px";
	    }
	
	    if (pos.other) {
	      // Secondary cursor, shown when on a 'jump' in bi-directional text
	      var otherCursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor CodeMirror-secondarycursor"));
	      otherCursor.style.display = "";
	      otherCursor.style.left = pos.other.left + "px";
	      otherCursor.style.top = pos.other.top + "px";
	      otherCursor.style.height = (pos.other.bottom - pos.other.top) * .85 + "px";
	    }
	  }
	
	  function cmpCoords(a, b) { return a.top - b.top || a.left - b.left }
	
	  // Draws the given range as a highlighted selection
	  function drawSelectionRange(cm, range, output) {
	    var display = cm.display, doc = cm.doc;
	    var fragment = document.createDocumentFragment();
	    var padding = paddingH(cm.display), leftSide = padding.left;
	    var rightSide = Math.max(display.sizerWidth, displayWidth(cm) - display.sizer.offsetLeft) - padding.right;
	    var docLTR = doc.direction == "ltr";
	
	    function add(left, top, width, bottom) {
	      if (top < 0) { top = 0; }
	      top = Math.round(top);
	      bottom = Math.round(bottom);
	      fragment.appendChild(elt("div", null, "CodeMirror-selected", ("position: absolute; left: " + left + "px;\n                             top: " + top + "px; width: " + (width == null ? rightSide - left : width) + "px;\n                             height: " + (bottom - top) + "px")));
	    }
	
	    function drawForLine(line, fromArg, toArg) {
	      var lineObj = getLine(doc, line);
	      var lineLen = lineObj.text.length;
	      var start, end;
	      function coords(ch, bias) {
	        return charCoords(cm, Pos(line, ch), "div", lineObj, bias)
	      }
	
	      function wrapX(pos, dir, side) {
	        var extent = wrappedLineExtentChar(cm, lineObj, null, pos);
	        var prop = (dir == "ltr") == (side == "after") ? "left" : "right";
	        var ch = side == "after" ? extent.begin : extent.end - (/\s/.test(lineObj.text.charAt(extent.end - 1)) ? 2 : 1);
	        return coords(ch, prop)[prop]
	      }
	
	      var order = getOrder(lineObj, doc.direction);
	      iterateBidiSections(order, fromArg || 0, toArg == null ? lineLen : toArg, function (from, to, dir, i) {
	        var ltr = dir == "ltr";
	        var fromPos = coords(from, ltr ? "left" : "right");
	        var toPos = coords(to - 1, ltr ? "right" : "left");
	
	        var openStart = fromArg == null && from == 0, openEnd = toArg == null && to == lineLen;
	        var first = i == 0, last = !order || i == order.length - 1;
	        if (toPos.top - fromPos.top <= 3) { // Single line
	          var openLeft = (docLTR ? openStart : openEnd) && first;
	          var openRight = (docLTR ? openEnd : openStart) && last;
	          var left = openLeft ? leftSide : (ltr ? fromPos : toPos).left;
	          var right = openRight ? rightSide : (ltr ? toPos : fromPos).right;
	          add(left, fromPos.top, right - left, fromPos.bottom);
	        } else { // Multiple lines
	          var topLeft, topRight, botLeft, botRight;
	          if (ltr) {
	            topLeft = docLTR && openStart && first ? leftSide : fromPos.left;
	            topRight = docLTR ? rightSide : wrapX(from, dir, "before");
	            botLeft = docLTR ? leftSide : wrapX(to, dir, "after");
	            botRight = docLTR && openEnd && last ? rightSide : toPos.right;
	          } else {
	            topLeft = !docLTR ? leftSide : wrapX(from, dir, "before");
	            topRight = !docLTR && openStart && first ? rightSide : fromPos.right;
	            botLeft = !docLTR && openEnd && last ? leftSide : toPos.left;
	            botRight = !docLTR ? rightSide : wrapX(to, dir, "after");
	          }
	          add(topLeft, fromPos.top, topRight - topLeft, fromPos.bottom);
	          if (fromPos.bottom < toPos.top) { add(leftSide, fromPos.bottom, null, toPos.top); }
	          add(botLeft, toPos.top, botRight - botLeft, toPos.bottom);
	        }
	
	        if (!start || cmpCoords(fromPos, start) < 0) { start = fromPos; }
	        if (cmpCoords(toPos, start) < 0) { start = toPos; }
	        if (!end || cmpCoords(fromPos, end) < 0) { end = fromPos; }
	        if (cmpCoords(toPos, end) < 0) { end = toPos; }
	      });
	      return {start: start, end: end}
	    }
	
	    var sFrom = range.from(), sTo = range.to();
	    if (sFrom.line == sTo.line) {
	      drawForLine(sFrom.line, sFrom.ch, sTo.ch);
	    } else {
	      var fromLine = getLine(doc, sFrom.line), toLine = getLine(doc, sTo.line);
	      var singleVLine = visualLine(fromLine) == visualLine(toLine);
	      var leftEnd = drawForLine(sFrom.line, sFrom.ch, singleVLine ? fromLine.text.length + 1 : null).end;
	      var rightStart = drawForLine(sTo.line, singleVLine ? 0 : null, sTo.ch).start;
	      if (singleVLine) {
	        if (leftEnd.top < rightStart.top - 2) {
	          add(leftEnd.right, leftEnd.top, null, leftEnd.bottom);
	          add(leftSide, rightStart.top, rightStart.left, rightStart.bottom);
	        } else {
	          add(leftEnd.right, leftEnd.top, rightStart.left - leftEnd.right, leftEnd.bottom);
	        }
	      }
	      if (leftEnd.bottom < rightStart.top)
	        { add(leftSide, leftEnd.bottom, null, rightStart.top); }
	    }
	
	    output.appendChild(fragment);
	  }
	
	  // Cursor-blinking
	  function restartBlink(cm) {
	    if (!cm.state.focused) { return }
	    var display = cm.display;
	    clearInterval(display.blinker);
	    var on = true;
	    display.cursorDiv.style.visibility = "";
	    if (cm.options.cursorBlinkRate > 0)
	      { display.blinker = setInterval(function () {
	        if (!cm.hasFocus()) { onBlur(cm); }
	        display.cursorDiv.style.visibility = (on = !on) ? "" : "hidden";
	      }, cm.options.cursorBlinkRate); }
	    else if (cm.options.cursorBlinkRate < 0)
	      { display.cursorDiv.style.visibility = "hidden"; }
	  }
	
	  function ensureFocus(cm) {
	    if (!cm.hasFocus()) {
	      cm.display.input.focus();
	      if (!cm.state.focused) { onFocus(cm); }
	    }
	  }
	
	  function delayBlurEvent(cm) {
	    cm.state.delayingBlurEvent = true;
	    setTimeout(function () { if (cm.state.delayingBlurEvent) {
	      cm.state.delayingBlurEvent = false;
	      if (cm.state.focused) { onBlur(cm); }
	    } }, 100);
	  }
	
	  function onFocus(cm, e) {
	    if (cm.state.delayingBlurEvent && !cm.state.draggingText) { cm.state.delayingBlurEvent = false; }
	
	    if (cm.options.readOnly == "nocursor") { return }
	    if (!cm.state.focused) {
	      signal(cm, "focus", cm, e);
	      cm.state.focused = true;
	      addClass(cm.display.wrapper, "CodeMirror-focused");
	      // This test prevents this from firing when a context
	      // menu is closed (since the input reset would kill the
	      // select-all detection hack)
	      if (!cm.curOp && cm.display.selForContextMenu != cm.doc.sel) {
	        cm.display.input.reset();
	        if (webkit) { setTimeout(function () { return cm.display.input.reset(true); }, 20); } // Issue #1730
	      }
	      cm.display.input.receivedFocus();
	    }
	    restartBlink(cm);
	  }
	  function onBlur(cm, e) {
	    if (cm.state.delayingBlurEvent) { return }
	
	    if (cm.state.focused) {
	      signal(cm, "blur", cm, e);
	      cm.state.focused = false;
	      rmClass(cm.display.wrapper, "CodeMirror-focused");
	    }
	    clearInterval(cm.display.blinker);
	    setTimeout(function () { if (!cm.state.focused) { cm.display.shift = false; } }, 150);
	  }
	
	  // Read the actual heights of the rendered lines, and update their
	  // stored heights to match.
	  function updateHeightsInViewport(cm) {
	    var display = cm.display;
	    var prevBottom = display.lineDiv.offsetTop;
	    var viewTop = Math.max(0, display.scroller.getBoundingClientRect().top);
	    var oldHeight = display.lineDiv.getBoundingClientRect().top;
	    var mustScroll = 0;
	    for (var i = 0; i < display.view.length; i++) {
	      var cur = display.view[i], wrapping = cm.options.lineWrapping;
	      var height = (void 0), width = 0;
	      if (cur.hidden) { continue }
	      oldHeight += cur.line.height;
	      if (ie && ie_version < 8) {
	        var bot = cur.node.offsetTop + cur.node.offsetHeight;
	        height = bot - prevBottom;
	        prevBottom = bot;
	      } else {
	        var box = cur.node.getBoundingClientRect();
	        height = box.bottom - box.top;
	        // Check that lines don't extend past the right of the current
	        // editor width
	        if (!wrapping && cur.text.firstChild)
	          { width = cur.text.firstChild.getBoundingClientRect().right - box.left - 1; }
	      }
	      var diff = cur.line.height - height;
	      if (diff > .005 || diff < -.005) {
	        if (oldHeight < viewTop) { mustScroll -= diff; }
	        updateLineHeight(cur.line, height);
	        updateWidgetHeight(cur.line);
	        if (cur.rest) { for (var j = 0; j < cur.rest.length; j++)
	          { updateWidgetHeight(cur.rest[j]); } }
	      }
	      if (width > cm.display.sizerWidth) {
	        var chWidth = Math.ceil(width / charWidth(cm.display));
	        if (chWidth > cm.display.maxLineLength) {
	          cm.display.maxLineLength = chWidth;
	          cm.display.maxLine = cur.line;
	          cm.display.maxLineChanged = true;
	        }
	      }
	    }
	    if (Math.abs(mustScroll) > 2) { display.scroller.scrollTop += mustScroll; }
	  }
	
	  // Read and store the height of line widgets associated with the
	  // given line.
	  function updateWidgetHeight(line) {
	    if (line.widgets) { for (var i = 0; i < line.widgets.length; ++i) {
	      var w = line.widgets[i], parent = w.node.parentNode;
	      if (parent) { w.height = parent.offsetHeight; }
	    } }
	  }
	
	  // Compute the lines that are visible in a given viewport (defaults
	  // the the current scroll position). viewport may contain top,
	  // height, and ensure (see op.scrollToPos) properties.
	  function visibleLines(display, doc, viewport) {
	    var top = viewport && viewport.top != null ? Math.max(0, viewport.top) : display.scroller.scrollTop;
	    top = Math.floor(top - paddingTop(display));
	    var bottom = viewport && viewport.bottom != null ? viewport.bottom : top + display.wrapper.clientHeight;
	
	    var from = lineAtHeight(doc, top), to = lineAtHeight(doc, bottom);
	    // Ensure is a {from: {line, ch}, to: {line, ch}} object, and
	    // forces those lines into the viewport (if possible).
	    if (viewport && viewport.ensure) {
	      var ensureFrom = viewport.ensure.from.line, ensureTo = viewport.ensure.to.line;
	      if (ensureFrom < from) {
	        from = ensureFrom;
	        to = lineAtHeight(doc, heightAtLine(getLine(doc, ensureFrom)) + display.wrapper.clientHeight);
	      } else if (Math.min(ensureTo, doc.lastLine()) >= to) {
	        from = lineAtHeight(doc, heightAtLine(getLine(doc, ensureTo)) - display.wrapper.clientHeight);
	        to = ensureTo;
	      }
	    }
	    return {from: from, to: Math.max(to, from + 1)}
	  }
	
	  // SCROLLING THINGS INTO VIEW
	
	  // If an editor sits on the top or bottom of the window, partially
	  // scrolled out of view, this ensures that the cursor is visible.
	  function maybeScrollWindow(cm, rect) {
	    if (signalDOMEvent(cm, "scrollCursorIntoView")) { return }
	
	    var display = cm.display, box = display.sizer.getBoundingClientRect(), doScroll = null;
	    if (rect.top + box.top < 0) { doScroll = true; }
	    else if (rect.bottom + box.top > (window.innerHeight || document.documentElement.clientHeight)) { doScroll = false; }
	    if (doScroll != null && !phantom) {
	      var scrollNode = elt("div", "\u200b", null, ("position: absolute;\n                         top: " + (rect.top - display.viewOffset - paddingTop(cm.display)) + "px;\n                         height: " + (rect.bottom - rect.top + scrollGap(cm) + display.barHeight) + "px;\n                         left: " + (rect.left) + "px; width: " + (Math.max(2, rect.right - rect.left)) + "px;"));
	      cm.display.lineSpace.appendChild(scrollNode);
	      scrollNode.scrollIntoView(doScroll);
	      cm.display.lineSpace.removeChild(scrollNode);
	    }
	  }
	
	  // Scroll a given position into view (immediately), verifying that
	  // it actually became visible (as line heights are accurately
	  // measured, the position of something may 'drift' during drawing).
	  function scrollPosIntoView(cm, pos, end, margin) {
	    if (margin == null) { margin = 0; }
	    var rect;
	    if (!cm.options.lineWrapping && pos == end) {
	      // Set pos and end to the cursor positions around the character pos sticks to
	      // If pos.sticky == "before", that is around pos.ch - 1, otherwise around pos.ch
	      // If pos == Pos(_, 0, "before"), pos and end are unchanged
	      end = pos.sticky == "before" ? Pos(pos.line, pos.ch + 1, "before") : pos;
	      pos = pos.ch ? Pos(pos.line, pos.sticky == "before" ? pos.ch - 1 : pos.ch, "after") : pos;
	    }
	    for (var limit = 0; limit < 5; limit++) {
	      var changed = false;
	      var coords = cursorCoords(cm, pos);
	      var endCoords = !end || end == pos ? coords : cursorCoords(cm, end);
	      rect = {left: Math.min(coords.left, endCoords.left),
	              top: Math.min(coords.top, endCoords.top) - margin,
	              right: Math.max(coords.left, endCoords.left),
	              bottom: Math.max(coords.bottom, endCoords.bottom) + margin};
	      var scrollPos = calculateScrollPos(cm, rect);
	      var startTop = cm.doc.scrollTop, startLeft = cm.doc.scrollLeft;
	      if (scrollPos.scrollTop != null) {
	        updateScrollTop(cm, scrollPos.scrollTop);
	        if (Math.abs(cm.doc.scrollTop - startTop) > 1) { changed = true; }
	      }
	      if (scrollPos.scrollLeft != null) {
	        setScrollLeft(cm, scrollPos.scrollLeft);
	        if (Math.abs(cm.doc.scrollLeft - startLeft) > 1) { changed = true; }
	      }
	      if (!changed) { break }
	    }
	    return rect
	  }
	
	  // Scroll a given set of coordinates into view (immediately).
	  function scrollIntoView(cm, rect) {
	    var scrollPos = calculateScrollPos(cm, rect);
	    if (scrollPos.scrollTop != null) { updateScrollTop(cm, scrollPos.scrollTop); }
	    if (scrollPos.scrollLeft != null) { setScrollLeft(cm, scrollPos.scrollLeft); }
	  }
	
	  // Calculate a new scroll position needed to scroll the given
	  // rectangle into view. Returns an object with scrollTop and
	  // scrollLeft properties. When these are undefined, the
	  // vertical/horizontal position does not need to be adjusted.
	  function calculateScrollPos(cm, rect) {
	    var display = cm.display, snapMargin = textHeight(cm.display);
	    if (rect.top < 0) { rect.top = 0; }
	    var screentop = cm.curOp && cm.curOp.scrollTop != null ? cm.curOp.scrollTop : display.scroller.scrollTop;
	    var screen = displayHeight(cm), result = {};
	    if (rect.bottom - rect.top > screen) { rect.bottom = rect.top + screen; }
	    var docBottom = cm.doc.height + paddingVert(display);
	    var atTop = rect.top < snapMargin, atBottom = rect.bottom > docBottom - snapMargin;
	    if (rect.top < screentop) {
	      result.scrollTop = atTop ? 0 : rect.top;
	    } else if (rect.bottom > screentop + screen) {
	      var newTop = Math.min(rect.top, (atBottom ? docBottom : rect.bottom) - screen);
	      if (newTop != screentop) { result.scrollTop = newTop; }
	    }
	
	    var gutterSpace = cm.options.fixedGutter ? 0 : display.gutters.offsetWidth;
	    var screenleft = cm.curOp && cm.curOp.scrollLeft != null ? cm.curOp.scrollLeft : display.scroller.scrollLeft - gutterSpace;
	    var screenw = displayWidth(cm) - display.gutters.offsetWidth;
	    var tooWide = rect.right - rect.left > screenw;
	    if (tooWide) { rect.right = rect.left + screenw; }
	    if (rect.left < 10)
	      { result.scrollLeft = 0; }
	    else if (rect.left < screenleft)
	      { result.scrollLeft = Math.max(0, rect.left + gutterSpace - (tooWide ? 0 : 10)); }
	    else if (rect.right > screenw + screenleft - 3)
	      { result.scrollLeft = rect.right + (tooWide ? 0 : 10) - screenw; }
	    return result
	  }
	
	  // Store a relative adjustment to the scroll position in the current
	  // operation (to be applied when the operation finishes).
	  function addToScrollTop(cm, top) {
	    if (top == null) { return }
	    resolveScrollToPos(cm);
	    cm.curOp.scrollTop = (cm.curOp.scrollTop == null ? cm.doc.scrollTop : cm.curOp.scrollTop) + top;
	  }
	
	  // Make sure that at the end of the operation the current cursor is
	  // shown.
	  function ensureCursorVisible(cm) {
	    resolveScrollToPos(cm);
	    var cur = cm.getCursor();
	    cm.curOp.scrollToPos = {from: cur, to: cur, margin: cm.options.cursorScrollMargin};
	  }
	
	  function scrollToCoords(cm, x, y) {
	    if (x != null || y != null) { resolveScrollToPos(cm); }
	    if (x != null) { cm.curOp.scrollLeft = x; }
	    if (y != null) { cm.curOp.scrollTop = y; }
	  }
	
	  function scrollToRange(cm, range) {
	    resolveScrollToPos(cm);
	    cm.curOp.scrollToPos = range;
	  }
	
	  // When an operation has its scrollToPos property set, and another
	  // scroll action is applied before the end of the operation, this
	  // 'simulates' scrolling that position into view in a cheap way, so
	  // that the effect of intermediate scroll commands is not ignored.
	  function resolveScrollToPos(cm) {
	    var range = cm.curOp.scrollToPos;
	    if (range) {
	      cm.curOp.scrollToPos = null;
	      var from = estimateCoords(cm, range.from), to = estimateCoords(cm, range.to);
	      scrollToCoordsRange(cm, from, to, range.margin);
	    }
	  }
	
	  function scrollToCoordsRange(cm, from, to, margin) {
	    var sPos = calculateScrollPos(cm, {
	      left: Math.min(from.left, to.left),
	      top: Math.min(from.top, to.top) - margin,
	      right: Math.max(from.right, to.right),
	      bottom: Math.max(from.bottom, to.bottom) + margin
	    });
	    scrollToCoords(cm, sPos.scrollLeft, sPos.scrollTop);
	  }
	
	  // Sync the scrollable area and scrollbars, ensure the viewport
	  // covers the visible area.
	  function updateScrollTop(cm, val) {
	    if (Math.abs(cm.doc.scrollTop - val) < 2) { return }
	    if (!gecko) { updateDisplaySimple(cm, {top: val}); }
	    setScrollTop(cm, val, true);
	    if (gecko) { updateDisplaySimple(cm); }
	    startWorker(cm, 100);
	  }
	
	  function setScrollTop(cm, val, forceScroll) {
	    val = Math.max(0, Math.min(cm.display.scroller.scrollHeight - cm.display.scroller.clientHeight, val));
	    if (cm.display.scroller.scrollTop == val && !forceScroll) { return }
	    cm.doc.scrollTop = val;
	    cm.display.scrollbars.setScrollTop(val);
	    if (cm.display.scroller.scrollTop != val) { cm.display.scroller.scrollTop = val; }
	  }
	
	  // Sync scroller and scrollbar, ensure the gutter elements are
	  // aligned.
	  function setScrollLeft(cm, val, isScroller, forceScroll) {
	    val = Math.max(0, Math.min(val, cm.display.scroller.scrollWidth - cm.display.scroller.clientWidth));
	    if ((isScroller ? val == cm.doc.scrollLeft : Math.abs(cm.doc.scrollLeft - val) < 2) && !forceScroll) { return }
	    cm.doc.scrollLeft = val;
	    alignHorizontally(cm);
	    if (cm.display.scroller.scrollLeft != val) { cm.display.scroller.scrollLeft = val; }
	    cm.display.scrollbars.setScrollLeft(val);
	  }
	
	  // SCROLLBARS
	
	  // Prepare DOM reads needed to update the scrollbars. Done in one
	  // shot to minimize update/measure roundtrips.
	  function measureForScrollbars(cm) {
	    var d = cm.display, gutterW = d.gutters.offsetWidth;
	    var docH = Math.round(cm.doc.height + paddingVert(cm.display));
	    return {
	      clientHeight: d.scroller.clientHeight,
	      viewHeight: d.wrapper.clientHeight,
	      scrollWidth: d.scroller.scrollWidth, clientWidth: d.scroller.clientWidth,
	      viewWidth: d.wrapper.clientWidth,
	      barLeft: cm.options.fixedGutter ? gutterW : 0,
	      docHeight: docH,
	      scrollHeight: docH + scrollGap(cm) + d.barHeight,
	      nativeBarWidth: d.nativeBarWidth,
	      gutterWidth: gutterW
	    }
	  }
	
	  var NativeScrollbars = function(place, scroll, cm) {
	    this.cm = cm;
	    var vert = this.vert = elt("div", [elt("div", null, null, "min-width: 1px")], "CodeMirror-vscrollbar");
	    var horiz = this.horiz = elt("div", [elt("div", null, null, "height: 100%; min-height: 1px")], "CodeMirror-hscrollbar");
	    vert.tabIndex = horiz.tabIndex = -1;
	    place(vert); place(horiz);
	
	    on(vert, "scroll", function () {
	      if (vert.clientHeight) { scroll(vert.scrollTop, "vertical"); }
	    });
	    on(horiz, "scroll", function () {
	      if (horiz.clientWidth) { scroll(horiz.scrollLeft, "horizontal"); }
	    });
	
	    this.checkedZeroWidth = false;
	    // Need to set a minimum width to see the scrollbar on IE7 (but must not set it on IE8).
	    if (ie && ie_version < 8) { this.horiz.style.minHeight = this.vert.style.minWidth = "18px"; }
	  };
	
	  NativeScrollbars.prototype.update = function (measure) {
	    var needsH = measure.scrollWidth > measure.clientWidth + 1;
	    var needsV = measure.scrollHeight > measure.clientHeight + 1;
	    var sWidth = measure.nativeBarWidth;
	
	    if (needsV) {
	      this.vert.style.display = "block";
	      this.vert.style.bottom = needsH ? sWidth + "px" : "0";
	      var totalHeight = measure.viewHeight - (needsH ? sWidth : 0);
	      // A bug in IE8 can cause this value to be negative, so guard it.
	      this.vert.firstChild.style.height =
	        Math.max(0, measure.scrollHeight - measure.clientHeight + totalHeight) + "px";
	    } else {
	      this.vert.scrollTop = 0;
	      this.vert.style.display = "";
	      this.vert.firstChild.style.height = "0";
	    }
	
	    if (needsH) {
	      this.horiz.style.display = "block";
	      this.horiz.style.right = needsV ? sWidth + "px" : "0";
	      this.horiz.style.left = measure.barLeft + "px";
	      var totalWidth = measure.viewWidth - measure.barLeft - (needsV ? sWidth : 0);
	      this.horiz.firstChild.style.width =
	        Math.max(0, measure.scrollWidth - measure.clientWidth + totalWidth) + "px";
	    } else {
	      this.horiz.style.display = "";
	      this.horiz.firstChild.style.width = "0";
	    }
	
	    if (!this.checkedZeroWidth && measure.clientHeight > 0) {
	      if (sWidth == 0) { this.zeroWidthHack(); }
	      this.checkedZeroWidth = true;
	    }
	
	    return {right: needsV ? sWidth : 0, bottom: needsH ? sWidth : 0}
	  };
	
	  NativeScrollbars.prototype.setScrollLeft = function (pos) {
	    if (this.horiz.scrollLeft != pos) { this.horiz.scrollLeft = pos; }
	    if (this.disableHoriz) { this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz"); }
	  };
	
	  NativeScrollbars.prototype.setScrollTop = function (pos) {
	    if (this.vert.scrollTop != pos) { this.vert.scrollTop = pos; }
	    if (this.disableVert) { this.enableZeroWidthBar(this.vert, this.disableVert, "vert"); }
	  };
	
	  NativeScrollbars.prototype.zeroWidthHack = function () {
	    var w = mac && !mac_geMountainLion ? "12px" : "18px";
	    this.horiz.style.height = this.vert.style.width = w;
	    this.horiz.style.pointerEvents = this.vert.style.pointerEvents = "none";
	    this.disableHoriz = new Delayed;
	    this.disableVert = new Delayed;
	  };
	
	  NativeScrollbars.prototype.enableZeroWidthBar = function (bar, delay, type) {
	    bar.style.pointerEvents = "auto";
	    function maybeDisable() {
	      // To find out whether the scrollbar is still visible, we
	      // check whether the element under the pixel in the bottom
	      // right corner of the scrollbar box is the scrollbar box
	      // itself (when the bar is still visible) or its filler child
	      // (when the bar is hidden). If it is still visible, we keep
	      // it enabled, if it's hidden, we disable pointer events.
	      var box = bar.getBoundingClientRect();
	      var elt = type == "vert" ? document.elementFromPoint(box.right - 1, (box.top + box.bottom) / 2)
	          : document.elementFromPoint((box.right + box.left) / 2, box.bottom - 1);
	      if (elt != bar) { bar.style.pointerEvents = "none"; }
	      else { delay.set(1000, maybeDisable); }
	    }
	    delay.set(1000, maybeDisable);
	  };
	
	  NativeScrollbars.prototype.clear = function () {
	    var parent = this.horiz.parentNode;
	    parent.removeChild(this.horiz);
	    parent.removeChild(this.vert);
	  };
	
	  var NullScrollbars = function () {};
	
	  NullScrollbars.prototype.update = function () { return {bottom: 0, right: 0} };
	  NullScrollbars.prototype.setScrollLeft = function () {};
	  NullScrollbars.prototype.setScrollTop = function () {};
	  NullScrollbars.prototype.clear = function () {};
	
	  function updateScrollbars(cm, measure) {
	    if (!measure) { measure = measureForScrollbars(cm); }
	    var startWidth = cm.display.barWidth, startHeight = cm.display.barHeight;
	    updateScrollbarsInner(cm, measure);
	    for (var i = 0; i < 4 && startWidth != cm.display.barWidth || startHeight != cm.display.barHeight; i++) {
	      if (startWidth != cm.display.barWidth && cm.options.lineWrapping)
	        { updateHeightsInViewport(cm); }
	      updateScrollbarsInner(cm, measureForScrollbars(cm));
	      startWidth = cm.display.barWidth; startHeight = cm.display.barHeight;
	    }
	  }
	
	  // Re-synchronize the fake scrollbars with the actual size of the
	  // content.
	  function updateScrollbarsInner(cm, measure) {
	    var d = cm.display;
	    var sizes = d.scrollbars.update(measure);
	
	    d.sizer.style.paddingRight = (d.barWidth = sizes.right) + "px";
	    d.sizer.style.paddingBottom = (d.barHeight = sizes.bottom) + "px";
	    d.heightForcer.style.borderBottom = sizes.bottom + "px solid transparent";
	
	    if (sizes.right && sizes.bottom) {
	      d.scrollbarFiller.style.display = "block";
	      d.scrollbarFiller.style.height = sizes.bottom + "px";
	      d.scrollbarFiller.style.width = sizes.right + "px";
	    } else { d.scrollbarFiller.style.display = ""; }
	    if (sizes.bottom && cm.options.coverGutterNextToScrollbar && cm.options.fixedGutter) {
	      d.gutterFiller.style.display = "block";
	      d.gutterFiller.style.height = sizes.bottom + "px";
	      d.gutterFiller.style.width = measure.gutterWidth + "px";
	    } else { d.gutterFiller.style.display = ""; }
	  }
	
	  var scrollbarModel = {"native": NativeScrollbars, "null": NullScrollbars};
	
	  function initScrollbars(cm) {
	    if (cm.display.scrollbars) {
	      cm.display.scrollbars.clear();
	      if (cm.display.scrollbars.addClass)
	        { rmClass(cm.display.wrapper, cm.display.scrollbars.addClass); }
	    }
	
	    cm.display.scrollbars = new scrollbarModel[cm.options.scrollbarStyle](function (node) {
	      cm.display.wrapper.insertBefore(node, cm.display.scrollbarFiller);
	      // Prevent clicks in the scrollbars from killing focus
	      on(node, "mousedown", function () {
	        if (cm.state.focused) { setTimeout(function () { return cm.display.input.focus(); }, 0); }
	      });
	      node.setAttribute("cm-not-content", "true");
	    }, function (pos, axis) {
	      if (axis == "horizontal") { setScrollLeft(cm, pos); }
	      else { updateScrollTop(cm, pos); }
	    }, cm);
	    if (cm.display.scrollbars.addClass)
	      { addClass(cm.display.wrapper, cm.display.scrollbars.addClass); }
	  }
	
	  // Operations are used to wrap a series of changes to the editor
	  // state in such a way that each change won't have to update the
	  // cursor and display (which would be awkward, slow, and
	  // error-prone). Instead, display updates are batched and then all
	  // combined and executed at once.
	
	  var nextOpId = 0;
	  // Start a new operation.
	  function startOperation(cm) {
	    cm.curOp = {
	      cm: cm,
	      viewChanged: false,      // Flag that indicates that lines might need to be redrawn
	      startHeight: cm.doc.height, // Used to detect need to update scrollbar
	      forceUpdate: false,      // Used to force a redraw
	      updateInput: 0,       // Whether to reset the input textarea
	      typing: false,           // Whether this reset should be careful to leave existing text (for compositing)
	      changeObjs: null,        // Accumulated changes, for firing change events
	      cursorActivityHandlers: null, // Set of handlers to fire cursorActivity on
	      cursorActivityCalled: 0, // Tracks which cursorActivity handlers have been called already
	      selectionChanged: false, // Whether the selection needs to be redrawn
	      updateMaxLine: false,    // Set when the widest line needs to be determined anew
	      scrollLeft: null, scrollTop: null, // Intermediate scroll position, not pushed to DOM yet
	      scrollToPos: null,       // Used to scroll to a specific position
	      focus: false,
	      id: ++nextOpId,          // Unique ID
	      markArrays: null         // Used by addMarkedSpan
	    };
	    pushOperation(cm.curOp);
	  }
	
	  // Finish an operation, updating the display and signalling delayed events
	  function endOperation(cm) {
	    var op = cm.curOp;
	    if (op) { finishOperation(op, function (group) {
	      for (var i = 0; i < group.ops.length; i++)
	        { group.ops[i].cm.curOp = null; }
	      endOperations(group);
	    }); }
	  }
	
	  // The DOM updates done when an operation finishes are batched so
	  // that the minimum number of relayouts are required.
	  function endOperations(group) {
	    var ops = group.ops;
	    for (var i = 0; i < ops.length; i++) // Read DOM
	      { endOperation_R1(ops[i]); }
	    for (var i$1 = 0; i$1 < ops.length; i$1++) // Write DOM (maybe)
	      { endOperation_W1(ops[i$1]); }
	    for (var i$2 = 0; i$2 < ops.length; i$2++) // Read DOM
	      { endOperation_R2(ops[i$2]); }
	    for (var i$3 = 0; i$3 < ops.length; i$3++) // Write DOM (maybe)
	      { endOperation_W2(ops[i$3]); }
	    for (var i$4 = 0; i$4 < ops.length; i$4++) // Read DOM
	      { endOperation_finish(ops[i$4]); }
	  }
	
	  function endOperation_R1(op) {
	    var cm = op.cm, display = cm.display;
	    maybeClipScrollbars(cm);
	    if (op.updateMaxLine) { findMaxLine(cm); }
	
	    op.mustUpdate = op.viewChanged || op.forceUpdate || op.scrollTop != null ||
	      op.scrollToPos && (op.scrollToPos.from.line < display.viewFrom ||
	                         op.scrollToPos.to.line >= display.viewTo) ||
	      display.maxLineChanged && cm.options.lineWrapping;
	    op.update = op.mustUpdate &&
	      new DisplayUpdate(cm, op.mustUpdate && {top: op.scrollTop, ensure: op.scrollToPos}, op.forceUpdate);
	  }
	
	  function endOperation_W1(op) {
	    op.updatedDisplay = op.mustUpdate && updateDisplayIfNeeded(op.cm, op.update);
	  }
	
	  function endOperation_R2(op) {
	    var cm = op.cm, display = cm.display;
	    if (op.updatedDisplay) { updateHeightsInViewport(cm); }
	
	    op.barMeasure = measureForScrollbars(cm);
	
	    // If the max line changed since it was last measured, measure it,
	    // and ensure the document's width matches it.
	    // updateDisplay_W2 will use these properties to do the actual resizing
	    if (display.maxLineChanged && !cm.options.lineWrapping) {
	      op.adjustWidthTo = measureChar(cm, display.maxLine, display.maxLine.text.length).left + 3;
	      cm.display.sizerWidth = op.adjustWidthTo;
	      op.barMeasure.scrollWidth =
	        Math.max(display.scroller.clientWidth, display.sizer.offsetLeft + op.adjustWidthTo + scrollGap(cm) + cm.display.barWidth);
	      op.maxScrollLeft = Math.max(0, display.sizer.offsetLeft + op.adjustWidthTo - displayWidth(cm));
	    }
	
	    if (op.updatedDisplay || op.selectionChanged)
	      { op.preparedSelection = display.input.prepareSelection(); }
	  }
	
	  function endOperation_W2(op) {
	    var cm = op.cm;
	
	    if (op.adjustWidthTo != null) {
	      cm.display.sizer.style.minWidth = op.adjustWidthTo + "px";
	      if (op.maxScrollLeft < cm.doc.scrollLeft)
	        { setScrollLeft(cm, Math.min(cm.display.scroller.scrollLeft, op.maxScrollLeft), true); }
	      cm.display.maxLineChanged = false;
	    }
	
	    var takeFocus = op.focus && op.focus == activeElt();
	    if (op.preparedSelection)
	      { cm.display.input.showSelection(op.preparedSelection, takeFocus); }
	    if (op.updatedDisplay || op.startHeight != cm.doc.height)
	      { updateScrollbars(cm, op.barMeasure); }
	    if (op.updatedDisplay)
	      { setDocumentHeight(cm, op.barMeasure); }
	
	    if (op.selectionChanged) { restartBlink(cm); }
	
	    if (cm.state.focused && op.updateInput)
	      { cm.display.input.reset(op.typing); }
	    if (takeFocus) { ensureFocus(op.cm); }
	  }
	
	  function endOperation_finish(op) {
	    var cm = op.cm, display = cm.display, doc = cm.doc;
	
	    if (op.updatedDisplay) { postUpdateDisplay(cm, op.update); }
	
	    // Abort mouse wheel delta measurement, when scrolling explicitly
	    if (display.wheelStartX != null && (op.scrollTop != null || op.scrollLeft != null || op.scrollToPos))
	      { display.wheelStartX = display.wheelStartY = null; }
	
	    // Propagate the scroll position to the actual DOM scroller
	    if (op.scrollTop != null) { setScrollTop(cm, op.scrollTop, op.forceScroll); }
	
	    if (op.scrollLeft != null) { setScrollLeft(cm, op.scrollLeft, true, true); }
	    // If we need to scroll a specific position into view, do so.
	    if (op.scrollToPos) {
	      var rect = scrollPosIntoView(cm, clipPos(doc, op.scrollToPos.from),
	                                   clipPos(doc, op.scrollToPos.to), op.scrollToPos.margin);
	      maybeScrollWindow(cm, rect);
	    }
	
	    // Fire events for markers that are hidden/unidden by editing or
	    // undoing
	    var hidden = op.maybeHiddenMarkers, unhidden = op.maybeUnhiddenMarkers;
	    if (hidden) { for (var i = 0; i < hidden.length; ++i)
	      { if (!hidden[i].lines.length) { signal(hidden[i], "hide"); } } }
	    if (unhidden) { for (var i$1 = 0; i$1 < unhidden.length; ++i$1)
	      { if (unhidden[i$1].lines.length) { signal(unhidden[i$1], "unhide"); } } }
	
	    if (display.wrapper.offsetHeight)
	      { doc.scrollTop = cm.display.scroller.scrollTop; }
	
	    // Fire change events, and delayed event handlers
	    if (op.changeObjs)
	      { signal(cm, "changes", cm, op.changeObjs); }
	    if (op.update)
	      { op.update.finish(); }
	  }
	
	  // Run the given function in an operation
	  function runInOp(cm, f) {
	    if (cm.curOp) { return f() }
	    startOperation(cm);
	    try { return f() }
	    finally { endOperation(cm); }
	  }
	  // Wraps a function in an operation. Returns the wrapped function.
	  function operation(cm, f) {
	    return function() {
	      if (cm.curOp) { return f.apply(cm, arguments) }
	      startOperation(cm);
	      try { return f.apply(cm, arguments) }
	      finally { endOperation(cm); }
	    }
	  }
	  // Used to add methods to editor and doc instances, wrapping them in
	  // operations.
	  function methodOp(f) {
	    return function() {
	      if (this.curOp) { return f.apply(this, arguments) }
	      startOperation(this);
	      try { return f.apply(this, arguments) }
	      finally { endOperation(this); }
	    }
	  }
	  function docMethodOp(f) {
	    return function() {
	      var cm = this.cm;
	      if (!cm || cm.curOp) { return f.apply(this, arguments) }
	      startOperation(cm);
	      try { return f.apply(this, arguments) }
	      finally { endOperation(cm); }
	    }
	  }
	
	  // HIGHLIGHT WORKER
	
	  function startWorker(cm, time) {
	    if (cm.doc.highlightFrontier < cm.display.viewTo)
	      { cm.state.highlight.set(time, bind(highlightWorker, cm)); }
	  }
	
	  function highlightWorker(cm) {
	    var doc = cm.doc;
	    if (doc.highlightFrontier >= cm.display.viewTo) { return }
	    var end = +new Date + cm.options.workTime;
	    var context = getContextBefore(cm, doc.highlightFrontier);
	    var changedLines = [];
	
	    doc.iter(context.line, Math.min(doc.first + doc.size, cm.display.viewTo + 500), function (line) {
	      if (context.line >= cm.display.viewFrom) { // Visible
	        var oldStyles = line.styles;
	        var resetState = line.text.length > cm.options.maxHighlightLength ? copyState(doc.mode, context.state) : null;
	        var highlighted = highlightLine(cm, line, context, true);
	        if (resetState) { context.state = resetState; }
	        line.styles = highlighted.styles;
	        var oldCls = line.styleClasses, newCls = highlighted.classes;
	        if (newCls) { line.styleClasses = newCls; }
	        else if (oldCls) { line.styleClasses = null; }
	        var ischange = !oldStyles || oldStyles.length != line.styles.length ||
	          oldCls != newCls && (!oldCls || !newCls || oldCls.bgClass != newCls.bgClass || oldCls.textClass != newCls.textClass);
	        for (var i = 0; !ischange && i < oldStyles.length; ++i) { ischange = oldStyles[i] != line.styles[i]; }
	        if (ischange) { changedLines.push(context.line); }
	        line.stateAfter = context.save();
	        context.nextLine();
	      } else {
	        if (line.text.length <= cm.options.maxHighlightLength)
	          { processLine(cm, line.text, context); }
	        line.stateAfter = context.line % 5 == 0 ? context.save() : null;
	        context.nextLine();
	      }
	      if (+new Date > end) {
	        startWorker(cm, cm.options.workDelay);
	        return true
	      }
	    });
	    doc.highlightFrontier = context.line;
	    doc.modeFrontier = Math.max(doc.modeFrontier, context.line);
	    if (changedLines.length) { runInOp(cm, function () {
	      for (var i = 0; i < changedLines.length; i++)
	        { regLineChange(cm, changedLines[i], "text"); }
	    }); }
	  }
	
	  // DISPLAY DRAWING
	
	  var DisplayUpdate = function(cm, viewport, force) {
	    var display = cm.display;
	
	    this.viewport = viewport;
	    // Store some values that we'll need later (but don't want to force a relayout for)
	    this.visible = visibleLines(display, cm.doc, viewport);
	    this.editorIsHidden = !display.wrapper.offsetWidth;
	    this.wrapperHeight = display.wrapper.clientHeight;
	    this.wrapperWidth = display.wrapper.clientWidth;
	    this.oldDisplayWidth = displayWidth(cm);
	    this.force = force;
	    this.dims = getDimensions(cm);
	    this.events = [];
	  };
	
	  DisplayUpdate.prototype.signal = function (emitter, type) {
	    if (hasHandler(emitter, type))
	      { this.events.push(arguments); }
	  };
	  DisplayUpdate.prototype.finish = function () {
	    for (var i = 0; i < this.events.length; i++)
	      { signal.apply(null, this.events[i]); }
	  };
	
	  function maybeClipScrollbars(cm) {
	    var display = cm.display;
	    if (!display.scrollbarsClipped && display.scroller.offsetWidth) {
	      display.nativeBarWidth = display.scroller.offsetWidth - display.scroller.clientWidth;
	      display.heightForcer.style.height = scrollGap(cm) + "px";
	      display.sizer.style.marginBottom = -display.nativeBarWidth + "px";
	      display.sizer.style.borderRightWidth = scrollGap(cm) + "px";
	      display.scrollbarsClipped = true;
	    }
	  }
	
	  function selectionSnapshot(cm) {
	    if (cm.hasFocus()) { return null }
	    var active = activeElt();
	    if (!active || !contains(cm.display.lineDiv, active)) { return null }
	    var result = {activeElt: active};
	    if (window.getSelection) {
	      var sel = window.getSelection();
	      if (sel.anchorNode && sel.extend && contains(cm.display.lineDiv, sel.anchorNode)) {
	        result.anchorNode = sel.anchorNode;
	        result.anchorOffset = sel.anchorOffset;
	        result.focusNode = sel.focusNode;
	        result.focusOffset = sel.focusOffset;
	      }
	    }
	    return result
	  }
	
	  function restoreSelection(snapshot) {
	    if (!snapshot || !snapshot.activeElt || snapshot.activeElt == activeElt()) { return }
	    snapshot.activeElt.focus();
	    if (!/^(INPUT|TEXTAREA)$/.test(snapshot.activeElt.nodeName) &&
	        snapshot.anchorNode && contains(document.body, snapshot.anchorNode) && contains(document.body, snapshot.focusNode)) {
	      var sel = window.getSelection(), range = document.createRange();
	      range.setEnd(snapshot.anchorNode, snapshot.anchorOffset);
	      range.collapse(false);
	      sel.removeAllRanges();
	      sel.addRange(range);
	      sel.extend(snapshot.focusNode, snapshot.focusOffset);
	    }
	  }
	
	  // Does the actual updating of the line display. Bails out
	  // (returning false) when there is nothing to be done and forced is
	  // false.
	  function updateDisplayIfNeeded(cm, update) {
	    var display = cm.display, doc = cm.doc;
	
	    if (update.editorIsHidden) {
	      resetView(cm);
	      return false
	    }
	
	    // Bail out if the visible area is already rendered and nothing changed.
	    if (!update.force &&
	        update.visible.from >= display.viewFrom && update.visible.to <= display.viewTo &&
	        (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo) &&
	        display.renderedView == display.view && countDirtyView(cm) == 0)
	      { return false }
	
	    if (maybeUpdateLineNumberWidth(cm)) {
	      resetView(cm);
	      update.dims = getDimensions(cm);
	    }
	
	    // Compute a suitable new viewport (from & to)
	    var end = doc.first + doc.size;
	    var from = Math.max(update.visible.from - cm.options.viewportMargin, doc.first);
	    var to = Math.min(end, update.visible.to + cm.options.viewportMargin);
	    if (display.viewFrom < from && from - display.viewFrom < 20) { from = Math.max(doc.first, display.viewFrom); }
	    if (display.viewTo > to && display.viewTo - to < 20) { to = Math.min(end, display.viewTo); }
	    if (sawCollapsedSpans) {
	      from = visualLineNo(cm.doc, from);
	      to = visualLineEndNo(cm.doc, to);
	    }
	
	    var different = from != display.viewFrom || to != display.viewTo ||
	      display.lastWrapHeight != update.wrapperHeight || display.lastWrapWidth != update.wrapperWidth;
	    adjustView(cm, from, to);
	
	    display.viewOffset = heightAtLine(getLine(cm.doc, display.viewFrom));
	    // Position the mover div to align with the current scroll position
	    cm.display.mover.style.top = display.viewOffset + "px";
	
	    var toUpdate = countDirtyView(cm);
	    if (!different && toUpdate == 0 && !update.force && display.renderedView == display.view &&
	        (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo))
	      { return false }
	
	    // For big changes, we hide the enclosing element during the
	    // update, since that speeds up the operations on most browsers.
	    var selSnapshot = selectionSnapshot(cm);
	    if (toUpdate > 4) { display.lineDiv.style.display = "none"; }
	    patchDisplay(cm, display.updateLineNumbers, update.dims);
	    if (toUpdate > 4) { display.lineDiv.style.display = ""; }
	    display.renderedView = display.view;
	    // There might have been a widget with a focused element that got
	    // hidden or updated, if so re-focus it.
	    restoreSelection(selSnapshot);
	
	    // Prevent selection and cursors from interfering with the scroll
	    // width and height.
	    removeChildren(display.cursorDiv);
	    removeChildren(display.selectionDiv);
	    display.gutters.style.height = display.sizer.style.minHeight = 0;
	
	    if (different) {
	      display.lastWrapHeight = update.wrapperHeight;
	      display.lastWrapWidth = update.wrapperWidth;
	      startWorker(cm, 400);
	    }
	
	    display.updateLineNumbers = null;
	
	    return true
	  }
	
	  function postUpdateDisplay(cm, update) {
	    var viewport = update.viewport;
	
	    for (var first = true;; first = false) {
	      if (!first || !cm.options.lineWrapping || update.oldDisplayWidth == displayWidth(cm)) {
	        // Clip forced viewport to actual scrollable area.
	        if (viewport && viewport.top != null)
	          { viewport = {top: Math.min(cm.doc.height + paddingVert(cm.display) - displayHeight(cm), viewport.top)}; }
	        // Updated line heights might result in the drawn area not
	        // actually covering the viewport. Keep looping until it does.
	        update.visible = visibleLines(cm.display, cm.doc, viewport);
	        if (update.visible.from >= cm.display.viewFrom && update.visible.to <= cm.display.viewTo)
	          { break }
	      } else if (first) {
	        update.visible = visibleLines(cm.display, cm.doc, viewport);
	      }
	      if (!updateDisplayIfNeeded(cm, update)) { break }
	      updateHeightsInViewport(cm);
	      var barMeasure = measureForScrollbars(cm);
	      updateSelection(cm);
	      updateScrollbars(cm, barMeasure);
	      setDocumentHeight(cm, barMeasure);
	      update.force = false;
	    }
	
	    update.signal(cm, "update", cm);
	    if (cm.display.viewFrom != cm.display.reportedViewFrom || cm.display.viewTo != cm.display.reportedViewTo) {
	      update.signal(cm, "viewportChange", cm, cm.display.viewFrom, cm.display.viewTo);
	      cm.display.reportedViewFrom = cm.display.viewFrom; cm.display.reportedViewTo = cm.display.viewTo;
	    }
	  }
	
	  function updateDisplaySimple(cm, viewport) {
	    var update = new DisplayUpdate(cm, viewport);
	    if (updateDisplayIfNeeded(cm, update)) {
	      updateHeightsInViewport(cm);
	      postUpdateDisplay(cm, update);
	      var barMeasure = measureForScrollbars(cm);
	      updateSelection(cm);
	      updateScrollbars(cm, barMeasure);
	      setDocumentHeight(cm, barMeasure);
	      update.finish();
	    }
	  }
	
	  // Sync the actual display DOM structure with display.view, removing
	  // nodes for lines that are no longer in view, and creating the ones
	  // that are not there yet, and updating the ones that are out of
	  // date.
	  function patchDisplay(cm, updateNumbersFrom, dims) {
	    var display = cm.display, lineNumbers = cm.options.lineNumbers;
	    var container = display.lineDiv, cur = container.firstChild;
	
	    function rm(node) {
	      var next = node.nextSibling;
	      // Works around a throw-scroll bug in OS X Webkit
	      if (webkit && mac && cm.display.currentWheelTarget == node)
	        { node.style.display = "none"; }
	      else
	        { node.parentNode.removeChild(node); }
	      return next
	    }
	
	    var view = display.view, lineN = display.viewFrom;
	    // Loop over the elements in the view, syncing cur (the DOM nodes
	    // in display.lineDiv) with the view as we go.
	    for (var i = 0; i < view.length; i++) {
	      var lineView = view[i];
	      if (lineView.hidden) ; else if (!lineView.node || lineView.node.parentNode != container) { // Not drawn yet
	        var node = buildLineElement(cm, lineView, lineN, dims);
	        container.insertBefore(node, cur);
	      } else { // Already drawn
	        while (cur != lineView.node) { cur = rm(cur); }
	        var updateNumber = lineNumbers && updateNumbersFrom != null &&
	          updateNumbersFrom <= lineN && lineView.lineNumber;
	        if (lineView.changes) {
	          if (indexOf(lineView.changes, "gutter") > -1) { updateNumber = false; }
	          updateLineForChanges(cm, lineView, lineN, dims);
	        }
	        if (updateNumber) {
	          removeChildren(lineView.lineNumber);
	          lineView.lineNumber.appendChild(document.createTextNode(lineNumberFor(cm.options, lineN)));
	        }
	        cur = lineView.node.nextSibling;
	      }
	      lineN += lineView.size;
	    }
	    while (cur) { cur = rm(cur); }
	  }
	
	  function updateGutterSpace(display) {
	    var width = display.gutters.offsetWidth;
	    display.sizer.style.marginLeft = width + "px";
	    // Send an event to consumers responding to changes in gutter width.
	    signalLater(display, "gutterChanged", display);
	  }
	
	  function setDocumentHeight(cm, measure) {
	    cm.display.sizer.style.minHeight = measure.docHeight + "px";
	    cm.display.heightForcer.style.top = measure.docHeight + "px";
	    cm.display.gutters.style.height = (measure.docHeight + cm.display.barHeight + scrollGap(cm)) + "px";
	  }
	
	  // Re-align line numbers and gutter marks to compensate for
	  // horizontal scrolling.
	  function alignHorizontally(cm) {
	    var display = cm.display, view = display.view;
	    if (!display.alignWidgets && (!display.gutters.firstChild || !cm.options.fixedGutter)) { return }
	    var comp = compensateForHScroll(display) - display.scroller.scrollLeft + cm.doc.scrollLeft;
	    var gutterW = display.gutters.offsetWidth, left = comp + "px";
	    for (var i = 0; i < view.length; i++) { if (!view[i].hidden) {
	      if (cm.options.fixedGutter) {
	        if (view[i].gutter)
	          { view[i].gutter.style.left = left; }
	        if (view[i].gutterBackground)
	          { view[i].gutterBackground.style.left = left; }
	      }
	      var align = view[i].alignable;
	      if (align) { for (var j = 0; j < align.length; j++)
	        { align[j].style.left = left; } }
	    } }
	    if (cm.options.fixedGutter)
	      { display.gutters.style.left = (comp + gutterW) + "px"; }
	  }
	
	  // Used to ensure that the line number gutter is still the right
	  // size for the current document size. Returns true when an update
	  // is needed.
	  function maybeUpdateLineNumberWidth(cm) {
	    if (!cm.options.lineNumbers) { return false }
	    var doc = cm.doc, last = lineNumberFor(cm.options, doc.first + doc.size - 1), display = cm.display;
	    if (last.length != display.lineNumChars) {
	      var test = display.measure.appendChild(elt("div", [elt("div", last)],
	                                                 "CodeMirror-linenumber CodeMirror-gutter-elt"));
	      var innerW = test.firstChild.offsetWidth, padding = test.offsetWidth - innerW;
	      display.lineGutter.style.width = "";
	      display.lineNumInnerWidth = Math.max(innerW, display.lineGutter.offsetWidth - padding) + 1;
	      display.lineNumWidth = display.lineNumInnerWidth + padding;
	      display.lineNumChars = display.lineNumInnerWidth ? last.length : -1;
	      display.lineGutter.style.width = display.lineNumWidth + "px";
	      updateGutterSpace(cm.display);
	      return true
	    }
	    return false
	  }
	
	  function getGutters(gutters, lineNumbers) {
	    var result = [], sawLineNumbers = false;
	    for (var i = 0; i < gutters.length; i++) {
	      var name = gutters[i], style = null;
	      if (typeof name != "string") { style = name.style; name = name.className; }
	      if (name == "CodeMirror-linenumbers") {
	        if (!lineNumbers) { continue }
	        else { sawLineNumbers = true; }
	      }
	      result.push({className: name, style: style});
	    }
	    if (lineNumbers && !sawLineNumbers) { result.push({className: "CodeMirror-linenumbers", style: null}); }
	    return result
	  }
	
	  // Rebuild the gutter elements, ensure the margin to the left of the
	  // code matches their width.
	  function renderGutters(display) {
	    var gutters = display.gutters, specs = display.gutterSpecs;
	    removeChildren(gutters);
	    display.lineGutter = null;
	    for (var i = 0; i < specs.length; ++i) {
	      var ref = specs[i];
	      var className = ref.className;
	      var style = ref.style;
	      var gElt = gutters.appendChild(elt("div", null, "CodeMirror-gutter " + className));
	      if (style) { gElt.style.cssText = style; }
	      if (className == "CodeMirror-linenumbers") {
	        display.lineGutter = gElt;
	        gElt.style.width = (display.lineNumWidth || 1) + "px";
	      }
	    }
	    gutters.style.display = specs.length ? "" : "none";
	    updateGutterSpace(display);
	  }
	
	  function updateGutters(cm) {
	    renderGutters(cm.display);
	    regChange(cm);
	    alignHorizontally(cm);
	  }
	
	  // The display handles the DOM integration, both for input reading
	  // and content drawing. It holds references to DOM nodes and
	  // display-related state.
	
	  function Display(place, doc, input, options) {
	    var d = this;
	    this.input = input;
	
	    // Covers bottom-right square when both scrollbars are present.
	    d.scrollbarFiller = elt("div", null, "CodeMirror-scrollbar-filler");
	    d.scrollbarFiller.setAttribute("cm-not-content", "true");
	    // Covers bottom of gutter when coverGutterNextToScrollbar is on
	    // and h scrollbar is present.
	    d.gutterFiller = elt("div", null, "CodeMirror-gutter-filler");
	    d.gutterFiller.setAttribute("cm-not-content", "true");
	    // Will contain the actual code, positioned to cover the viewport.
	    d.lineDiv = eltP("div", null, "CodeMirror-code");
	    // Elements are added to these to represent selection and cursors.
	    d.selectionDiv = elt("div", null, null, "position: relative; z-index: 1");
	    d.cursorDiv = elt("div", null, "CodeMirror-cursors");
	    // A visibility: hidden element used to find the size of things.
	    d.measure = elt("div", null, "CodeMirror-measure");
	    // When lines outside of the viewport are measured, they are drawn in this.
	    d.lineMeasure = elt("div", null, "CodeMirror-measure");
	    // Wraps everything that needs to exist inside the vertically-padded coordinate system
	    d.lineSpace = eltP("div", [d.measure, d.lineMeasure, d.selectionDiv, d.cursorDiv, d.lineDiv],
	                      null, "position: relative; outline: none");
	    var lines = eltP("div", [d.lineSpace], "CodeMirror-lines");
	    // Moved around its parent to cover visible view.
	    d.mover = elt("div", [lines], null, "position: relative");
	    // Set to the height of the document, allowing scrolling.
	    d.sizer = elt("div", [d.mover], "CodeMirror-sizer");
	    d.sizerWidth = null;
	    // Behavior of elts with overflow: auto and padding is
	    // inconsistent across browsers. This is used to ensure the
	    // scrollable area is big enough.
	    d.heightForcer = elt("div", null, null, "position: absolute; height: " + scrollerGap + "px; width: 1px;");
	    // Will contain the gutters, if any.
	    d.gutters = elt("div", null, "CodeMirror-gutters");
	    d.lineGutter = null;
	    // Actual scrollable element.
	    d.scroller = elt("div", [d.sizer, d.heightForcer, d.gutters], "CodeMirror-scroll");
	    d.scroller.setAttribute("tabIndex", "-1");
	    // The element in which the editor lives.
	    d.wrapper = elt("div", [d.scrollbarFiller, d.gutterFiller, d.scroller], "CodeMirror");
	
	    // This attribute is respected by automatic translation systems such as Google Translate,
	    // and may also be respected by tools used by human translators.
	    d.wrapper.setAttribute('translate', 'no');
	
	    // Work around IE7 z-index bug (not perfect, hence IE7 not really being supported)
	    if (ie && ie_version < 8) { d.gutters.style.zIndex = -1; d.scroller.style.paddingRight = 0; }
	    if (!webkit && !(gecko && mobile)) { d.scroller.draggable = true; }
	
	    if (place) {
	      if (place.appendChild) { place.appendChild(d.wrapper); }
	      else { place(d.wrapper); }
	    }
	
	    // Current rendered range (may be bigger than the view window).
	    d.viewFrom = d.viewTo = doc.first;
	    d.reportedViewFrom = d.reportedViewTo = doc.first;
	    // Information about the rendered lines.
	    d.view = [];
	    d.renderedView = null;
	    // Holds info about a single rendered line when it was rendered
	    // for measurement, while not in view.
	    d.externalMeasured = null;
	    // Empty space (in pixels) above the view
	    d.viewOffset = 0;
	    d.lastWrapHeight = d.lastWrapWidth = 0;
	    d.updateLineNumbers = null;
	
	    d.nativeBarWidth = d.barHeight = d.barWidth = 0;
	    d.scrollbarsClipped = false;
	
	    // Used to only resize the line number gutter when necessary (when
	    // the amount of lines crosses a boundary that makes its width change)
	    d.lineNumWidth = d.lineNumInnerWidth = d.lineNumChars = null;
	    // Set to true when a non-horizontal-scrolling line widget is
	    // added. As an optimization, line widget aligning is skipped when
	    // this is false.
	    d.alignWidgets = false;
	
	    d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
	
	    // Tracks the maximum line length so that the horizontal scrollbar
	    // can be kept static when scrolling.
	    d.maxLine = null;
	    d.maxLineLength = 0;
	    d.maxLineChanged = false;
	
	    // Used for measuring wheel scrolling granularity
	    d.wheelDX = d.wheelDY = d.wheelStartX = d.wheelStartY = null;
	
	    // True when shift is held down.
	    d.shift = false;
	
	    // Used to track whether anything happened since the context menu
	    // was opened.
	    d.selForContextMenu = null;
	
	    d.activeTouch = null;
	
	    d.gutterSpecs = getGutters(options.gutters, options.lineNumbers);
	    renderGutters(d);
	
	    input.init(d);
	  }
	
	  // Since the delta values reported on mouse wheel events are
	  // unstandardized between browsers and even browser versions, and
	  // generally horribly unpredictable, this code starts by measuring
	  // the scroll effect that the first few mouse wheel events have,
	  // and, from that, detects the way it can convert deltas to pixel
	  // offsets afterwards.
	  //
	  // The reason we want to know the amount a wheel event will scroll
	  // is that it gives us a chance to update the display before the
	  // actual scrolling happens, reducing flickering.
	
	  var wheelSamples = 0, wheelPixelsPerUnit = null;
	  // Fill in a browser-detected starting value on browsers where we
	  // know one. These don't have to be accurate -- the result of them
	  // being wrong would just be a slight flicker on the first wheel
	  // scroll (if it is large enough).
	  if (ie) { wheelPixelsPerUnit = -.53; }
	  else if (gecko) { wheelPixelsPerUnit = 15; }
	  else if (chrome) { wheelPixelsPerUnit = -.7; }
	  else if (safari) { wheelPixelsPerUnit = -1/3; }
	
	  function wheelEventDelta(e) {
	    var dx = e.wheelDeltaX, dy = e.wheelDeltaY;
	    if (dx == null && e.detail && e.axis == e.HORIZONTAL_AXIS) { dx = e.detail; }
	    if (dy == null && e.detail && e.axis == e.VERTICAL_AXIS) { dy = e.detail; }
	    else if (dy == null) { dy = e.wheelDelta; }
	    return {x: dx, y: dy}
	  }
	  function wheelEventPixels(e) {
	    var delta = wheelEventDelta(e);
	    delta.x *= wheelPixelsPerUnit;
	    delta.y *= wheelPixelsPerUnit;
	    return delta
	  }
	
	  function onScrollWheel(cm, e) {
	    var delta = wheelEventDelta(e), dx = delta.x, dy = delta.y;
	    var pixelsPerUnit = wheelPixelsPerUnit;
	    if (e.deltaMode === 0) {
	      dx = e.deltaX;
	      dy = e.deltaY;
	      pixelsPerUnit = 1;
	    }
	
	    var display = cm.display, scroll = display.scroller;
	    // Quit if there's nothing to scroll here
	    var canScrollX = scroll.scrollWidth > scroll.clientWidth;
	    var canScrollY = scroll.scrollHeight > scroll.clientHeight;
	    if (!(dx && canScrollX || dy && canScrollY)) { return }
	
	    // Webkit browsers on OS X abort momentum scrolls when the target
	    // of the scroll event is removed from the scrollable element.
	    // This hack (see related code in patchDisplay) makes sure the
	    // element is kept around.
	    if (dy && mac && webkit) {
	      outer: for (var cur = e.target, view = display.view; cur != scroll; cur = cur.parentNode) {
	        for (var i = 0; i < view.length; i++) {
	          if (view[i].node == cur) {
	            cm.display.currentWheelTarget = cur;
	            break outer
	          }
	        }
	      }
	    }
	
	    // On some browsers, horizontal scrolling will cause redraws to
	    // happen before the gutter has been realigned, causing it to
	    // wriggle around in a most unseemly way. When we have an
	    // estimated pixels/delta value, we just handle horizontal
	    // scrolling entirely here. It'll be slightly off from native, but
	    // better than glitching out.
	    if (dx && !gecko && !presto && pixelsPerUnit != null) {
	      if (dy && canScrollY)
	        { updateScrollTop(cm, Math.max(0, scroll.scrollTop + dy * pixelsPerUnit)); }
	      setScrollLeft(cm, Math.max(0, scroll.scrollLeft + dx * pixelsPerUnit));
	      // Only prevent default scrolling if vertical scrolling is
	      // actually possible. Otherwise, it causes vertical scroll
	      // jitter on OSX trackpads when deltaX is small and deltaY
	      // is large (issue #3579)
	      if (!dy || (dy && canScrollY))
	        { e_preventDefault(e); }
	      display.wheelStartX = null; // Abort measurement, if in progress
	      return
	    }
	
	    // 'Project' the visible viewport to cover the area that is being
	    // scrolled into view (if we know enough to estimate it).
	    if (dy && pixelsPerUnit != null) {
	      var pixels = dy * pixelsPerUnit;
	      var top = cm.doc.scrollTop, bot = top + display.wrapper.clientHeight;
	      if (pixels < 0) { top = Math.max(0, top + pixels - 50); }
	      else { bot = Math.min(cm.doc.height, bot + pixels + 50); }
	      updateDisplaySimple(cm, {top: top, bottom: bot});
	    }
	
	    if (wheelSamples < 20 && e.deltaMode !== 0) {
	      if (display.wheelStartX == null) {
	        display.wheelStartX = scroll.scrollLeft; display.wheelStartY = scroll.scrollTop;
	        display.wheelDX = dx; display.wheelDY = dy;
	        setTimeout(function () {
	          if (display.wheelStartX == null) { return }
	          var movedX = scroll.scrollLeft - display.wheelStartX;
	          var movedY = scroll.scrollTop - display.wheelStartY;
	          var sample = (movedY && display.wheelDY && movedY / display.wheelDY) ||
	            (movedX && display.wheelDX && movedX / display.wheelDX);
	          display.wheelStartX = display.wheelStartY = null;
	          if (!sample) { return }
	          wheelPixelsPerUnit = (wheelPixelsPerUnit * wheelSamples + sample) / (wheelSamples + 1);
	          ++wheelSamples;
	        }, 200);
	      } else {
	        display.wheelDX += dx; display.wheelDY += dy;
	      }
	    }
	  }
	
	  // Selection objects are immutable. A new one is created every time
	  // the selection changes. A selection is one or more non-overlapping
	  // (and non-touching) ranges, sorted, and an integer that indicates
	  // which one is the primary selection (the one that's scrolled into
	  // view, that getCursor returns, etc).
	  var Selection = function(ranges, primIndex) {
	    this.ranges = ranges;
	    this.primIndex = primIndex;
	  };
	
	  Selection.prototype.primary = function () { return this.ranges[this.primIndex] };
	
	  Selection.prototype.equals = function (other) {
	    if (other == this) { return true }
	    if (other.primIndex != this.primIndex || other.ranges.length != this.ranges.length) { return false }
	    for (var i = 0; i < this.ranges.length; i++) {
	      var here = this.ranges[i], there = other.ranges[i];
	      if (!equalCursorPos(here.anchor, there.anchor) || !equalCursorPos(here.head, there.head)) { return false }
	    }
	    return true
	  };
	
	  Selection.prototype.deepCopy = function () {
	    var out = [];
	    for (var i = 0; i < this.ranges.length; i++)
	      { out[i] = new Range(copyPos(this.ranges[i].anchor), copyPos(this.ranges[i].head)); }
	    return new Selection(out, this.primIndex)
	  };
	
	  Selection.prototype.somethingSelected = function () {
	    for (var i = 0; i < this.ranges.length; i++)
	      { if (!this.ranges[i].empty()) { return true } }
	    return false
	  };
	
	  Selection.prototype.contains = function (pos, end) {
	    if (!end) { end = pos; }
	    for (var i = 0; i < this.ranges.length; i++) {
	      var range = this.ranges[i];
	      if (cmp(end, range.from()) >= 0 && cmp(pos, range.to()) <= 0)
	        { return i }
	    }
	    return -1
	  };
	
	  var Range = function(anchor, head) {
	    this.anchor = anchor; this.head = head;
	  };
	
	  Range.prototype.from = function () { return minPos(this.anchor, this.head) };
	  Range.prototype.to = function () { return maxPos(this.anchor, this.head) };
	  Range.prototype.empty = function () { return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch };
	
	  // Take an unsorted, potentially overlapping set of ranges, and
	  // build a selection out of it. 'Consumes' ranges array (modifying
	  // it).
	  function normalizeSelection(cm, ranges, primIndex) {
	    var mayTouch = cm && cm.options.selectionsMayTouch;
	    var prim = ranges[primIndex];
	    ranges.sort(function (a, b) { return cmp(a.from(), b.from()); });
	    primIndex = indexOf(ranges, prim);
	    for (var i = 1; i < ranges.length; i++) {
	      var cur = ranges[i], prev = ranges[i - 1];
	      var diff = cmp(prev.to(), cur.from());
	      if (mayTouch && !cur.empty() ? diff > 0 : diff >= 0) {
	        var from = minPos(prev.from(), cur.from()), to = maxPos(prev.to(), cur.to());
	        var inv = prev.empty() ? cur.from() == cur.head : prev.from() == prev.head;
	        if (i <= primIndex) { --primIndex; }
	        ranges.splice(--i, 2, new Range(inv ? to : from, inv ? from : to));
	      }
	    }
	    return new Selection(ranges, primIndex)
	  }
	
	  function simpleSelection(anchor, head) {
	    return new Selection([new Range(anchor, head || anchor)], 0)
	  }
	
	  // Compute the position of the end of a change (its 'to' property
	  // refers to the pre-change end).
	  function changeEnd(change) {
	    if (!change.text) { return change.to }
	    return Pos(change.from.line + change.text.length - 1,
	               lst(change.text).length + (change.text.length == 1 ? change.from.ch : 0))
	  }
	
	  // Adjust a position to refer to the post-change position of the
	  // same text, or the end of the change if the change covers it.
	  function adjustForChange(pos, change) {
	    if (cmp(pos, change.from) < 0) { return pos }
	    if (cmp(pos, change.to) <= 0) { return changeEnd(change) }
	
	    var line = pos.line + change.text.length - (change.to.line - change.from.line) - 1, ch = pos.ch;
	    if (pos.line == change.to.line) { ch += changeEnd(change).ch - change.to.ch; }
	    return Pos(line, ch)
	  }
	
	  function computeSelAfterChange(doc, change) {
	    var out = [];
	    for (var i = 0; i < doc.sel.ranges.length; i++) {
	      var range = doc.sel.ranges[i];
	      out.push(new Range(adjustForChange(range.anchor, change),
	                         adjustForChange(range.head, change)));
	    }
	    return normalizeSelection(doc.cm, out, doc.sel.primIndex)
	  }
	
	  function offsetPos(pos, old, nw) {
	    if (pos.line == old.line)
	      { return Pos(nw.line, pos.ch - old.ch + nw.ch) }
	    else
	      { return Pos(nw.line + (pos.line - old.line), pos.ch) }
	  }
	
	  // Used by replaceSelections to allow moving the selection to the
	  // start or around the replaced test. Hint may be "start" or "around".
	  function computeReplacedSel(doc, changes, hint) {
	    var out = [];
	    var oldPrev = Pos(doc.first, 0), newPrev = oldPrev;
	    for (var i = 0; i < changes.length; i++) {
	      var change = changes[i];
	      var from = offsetPos(change.from, oldPrev, newPrev);
	      var to = offsetPos(changeEnd(change), oldPrev, newPrev);
	      oldPrev = change.to;
	      newPrev = to;
	      if (hint == "around") {
	        var range = doc.sel.ranges[i], inv = cmp(range.head, range.anchor) < 0;
	        out[i] = new Range(inv ? to : from, inv ? from : to);
	      } else {
	        out[i] = new Range(from, from);
	      }
	    }
	    return new Selection(out, doc.sel.primIndex)
	  }
	
	  // Used to get the editor into a consistent state again when options change.
	
	  function loadMode(cm) {
	    cm.doc.mode = getMode(cm.options, cm.doc.modeOption);
	    resetModeState(cm);
	  }
	
	  function resetModeState(cm) {
	    cm.doc.iter(function (line) {
	      if (line.stateAfter) { line.stateAfter = null; }
	      if (line.styles) { line.styles = null; }
	    });
	    cm.doc.modeFrontier = cm.doc.highlightFrontier = cm.doc.first;
	    startWorker(cm, 100);
	    cm.state.modeGen++;
	    if (cm.curOp) { regChange(cm); }
	  }
	
	  // DOCUMENT DATA STRUCTURE
	
	  // By default, updates that start and end at the beginning of a line
	  // are treated specially, in order to make the association of line
	  // widgets and marker elements with the text behave more intuitive.
	  function isWholeLineUpdate(doc, change) {
	    return change.from.ch == 0 && change.to.ch == 0 && lst(change.text) == "" &&
	      (!doc.cm || doc.cm.options.wholeLineUpdateBefore)
	  }
	
	  // Perform a change on the document data structure.
	  function updateDoc(doc, change, markedSpans, estimateHeight) {
	    function spansFor(n) {return markedSpans ? markedSpans[n] : null}
	    function update(line, text, spans) {
	      updateLine(line, text, spans, estimateHeight);
	      signalLater(line, "change", line, change);
	    }
	    function linesFor(start, end) {
	      var result = [];
	      for (var i = start; i < end; ++i)
	        { result.push(new Line(text[i], spansFor(i), estimateHeight)); }
	      return result
	    }
	
	    var from = change.from, to = change.to, text = change.text;
	    var firstLine = getLine(doc, from.line), lastLine = getLine(doc, to.line);
	    var lastText = lst(text), lastSpans = spansFor(text.length - 1), nlines = to.line - from.line;
	
	    // Adjust the line structure
	    if (change.full) {
	      doc.insert(0, linesFor(0, text.length));
	      doc.remove(text.length, doc.size - text.length);
	    } else if (isWholeLineUpdate(doc, change)) {
	      // This is a whole-line replace. Treated specially to make
	      // sure line objects move the way they are supposed to.
	      var added = linesFor(0, text.length - 1);
	      update(lastLine, lastLine.text, lastSpans);
	      if (nlines) { doc.remove(from.line, nlines); }
	      if (added.length) { doc.insert(from.line, added); }
	    } else if (firstLine == lastLine) {
	      if (text.length == 1) {
	        update(firstLine, firstLine.text.slice(0, from.ch) + lastText + firstLine.text.slice(to.ch), lastSpans);
	      } else {
	        var added$1 = linesFor(1, text.length - 1);
	        added$1.push(new Line(lastText + firstLine.text.slice(to.ch), lastSpans, estimateHeight));
	        update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
	        doc.insert(from.line + 1, added$1);
	      }
	    } else if (text.length == 1) {
	      update(firstLine, firstLine.text.slice(0, from.ch) + text[0] + lastLine.text.slice(to.ch), spansFor(0));
	      doc.remove(from.line + 1, nlines);
	    } else {
	      update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
	      update(lastLine, lastText + lastLine.text.slice(to.ch), lastSpans);
	      var added$2 = linesFor(1, text.length - 1);
	      if (nlines > 1) { doc.remove(from.line + 1, nlines - 1); }
	      doc.insert(from.line + 1, added$2);
	    }
	
	    signalLater(doc, "change", doc, change);
	  }
	
	  // Call f for all linked documents.
	  function linkedDocs(doc, f, sharedHistOnly) {
	    function propagate(doc, skip, sharedHist) {
	      if (doc.linked) { for (var i = 0; i < doc.linked.length; ++i) {
	        var rel = doc.linked[i];
	        if (rel.doc == skip) { continue }
	        var shared = sharedHist && rel.sharedHist;
	        if (sharedHistOnly && !shared) { continue }
	        f(rel.doc, shared);
	        propagate(rel.doc, doc, shared);
	      } }
	    }
	    propagate(doc, null, true);
	  }
	
	  // Attach a document to an editor.
	  function attachDoc(cm, doc) {
	    if (doc.cm) { throw new Error("This document is already in use.") }
	    cm.doc = doc;
	    doc.cm = cm;
	    estimateLineHeights(cm);
	    loadMode(cm);
	    setDirectionClass(cm);
	    cm.options.direction = doc.direction;
	    if (!cm.options.lineWrapping) { findMaxLine(cm); }
	    cm.options.mode = doc.modeOption;
	    regChange(cm);
	  }
	
	  function setDirectionClass(cm) {
	  (cm.doc.direction == "rtl" ? addClass : rmClass)(cm.display.lineDiv, "CodeMirror-rtl");
	  }
	
	  function directionChanged(cm) {
	    runInOp(cm, function () {
	      setDirectionClass(cm);
	      regChange(cm);
	    });
	  }
	
	  function History(prev) {
	    // Arrays of change events and selections. Doing something adds an
	    // event to done and clears undo. Undoing moves events from done
	    // to undone, redoing moves them in the other direction.
	    this.done = []; this.undone = [];
	    this.undoDepth = prev ? prev.undoDepth : Infinity;
	    // Used to track when changes can be merged into a single undo
	    // event
	    this.lastModTime = this.lastSelTime = 0;
	    this.lastOp = this.lastSelOp = null;
	    this.lastOrigin = this.lastSelOrigin = null;
	    // Used by the isClean() method
	    this.generation = this.maxGeneration = prev ? prev.maxGeneration : 1;
	  }
	
	  // Create a history change event from an updateDoc-style change
	  // object.
	  function historyChangeFromChange(doc, change) {
	    var histChange = {from: copyPos(change.from), to: changeEnd(change), text: getBetween(doc, change.from, change.to)};
	    attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
	    linkedDocs(doc, function (doc) { return attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1); }, true);
	    return histChange
	  }
	
	  // Pop all selection events off the end of a history array. Stop at
	  // a change event.
	  function clearSelectionEvents(array) {
	    while (array.length) {
	      var last = lst(array);
	      if (last.ranges) { array.pop(); }
	      else { break }
	    }
	  }
	
	  // Find the top change event in the history. Pop off selection
	  // events that are in the way.
	  function lastChangeEvent(hist, force) {
	    if (force) {
	      clearSelectionEvents(hist.done);
	      return lst(hist.done)
	    } else if (hist.done.length && !lst(hist.done).ranges) {
	      return lst(hist.done)
	    } else if (hist.done.length > 1 && !hist.done[hist.done.length - 2].ranges) {
	      hist.done.pop();
	      return lst(hist.done)
	    }
	  }
	
	  // Register a change in the history. Merges changes that are within
	  // a single operation, or are close together with an origin that
	  // allows merging (starting with "+") into a single event.
	  function addChangeToHistory(doc, change, selAfter, opId) {
	    var hist = doc.history;
	    hist.undone.length = 0;
	    var time = +new Date, cur;
	    var last;
	
	    if ((hist.lastOp == opId ||
	         hist.lastOrigin == change.origin && change.origin &&
	         ((change.origin.charAt(0) == "+" && hist.lastModTime > time - (doc.cm ? doc.cm.options.historyEventDelay : 500)) ||
	          change.origin.charAt(0) == "*")) &&
	        (cur = lastChangeEvent(hist, hist.lastOp == opId))) {
	      // Merge this change into the last event
	      last = lst(cur.changes);
	      if (cmp(change.from, change.to) == 0 && cmp(change.from, last.to) == 0) {
	        // Optimized case for simple insertion -- don't want to add
	        // new changesets for every character typed
	        last.to = changeEnd(change);
	      } else {
	        // Add new sub-event
	        cur.changes.push(historyChangeFromChange(doc, change));
	      }
	    } else {
	      // Can not be merged, start a new event.
	      var before = lst(hist.done);
	      if (!before || !before.ranges)
	        { pushSelectionToHistory(doc.sel, hist.done); }
	      cur = {changes: [historyChangeFromChange(doc, change)],
	             generation: hist.generation};
	      hist.done.push(cur);
	      while (hist.done.length > hist.undoDepth) {
	        hist.done.shift();
	        if (!hist.done[0].ranges) { hist.done.shift(); }
	      }
	    }
	    hist.done.push(selAfter);
	    hist.generation = ++hist.maxGeneration;
	    hist.lastModTime = hist.lastSelTime = time;
	    hist.lastOp = hist.lastSelOp = opId;
	    hist.lastOrigin = hist.lastSelOrigin = change.origin;
	
	    if (!last) { signal(doc, "historyAdded"); }
	  }
	
	  function selectionEventCanBeMerged(doc, origin, prev, sel) {
	    var ch = origin.charAt(0);
	    return ch == "*" ||
	      ch == "+" &&
	      prev.ranges.length == sel.ranges.length &&
	      prev.somethingSelected() == sel.somethingSelected() &&
	      new Date - doc.history.lastSelTime <= (doc.cm ? doc.cm.options.historyEventDelay : 500)
	  }
	
	  // Called whenever the selection changes, sets the new selection as
	  // the pending selection in the history, and pushes the old pending
	  // selection into the 'done' array when it was significantly
	  // different (in number of selected ranges, emptiness, or time).
	  function addSelectionToHistory(doc, sel, opId, options) {
	    var hist = doc.history, origin = options && options.origin;
	
	    // A new event is started when the previous origin does not match
	    // the current, or the origins don't allow matching. Origins
	    // starting with * are always merged, those starting with + are
	    // merged when similar and close together in time.
	    if (opId == hist.lastSelOp ||
	        (origin && hist.lastSelOrigin == origin &&
	         (hist.lastModTime == hist.lastSelTime && hist.lastOrigin == origin ||
	          selectionEventCanBeMerged(doc, origin, lst(hist.done), sel))))
	      { hist.done[hist.done.length - 1] = sel; }
	    else
	      { pushSelectionToHistory(sel, hist.done); }
	
	    hist.lastSelTime = +new Date;
	    hist.lastSelOrigin = origin;
	    hist.lastSelOp = opId;
	    if (options && options.clearRedo !== false)
	      { clearSelectionEvents(hist.undone); }
	  }
	
	  function pushSelectionToHistory(sel, dest) {
	    var top = lst(dest);
	    if (!(top && top.ranges && top.equals(sel)))
	      { dest.push(sel); }
	  }
	
	  // Used to store marked span information in the history.
	  function attachLocalSpans(doc, change, from, to) {
	    var existing = change["spans_" + doc.id], n = 0;
	    doc.iter(Math.max(doc.first, from), Math.min(doc.first + doc.size, to), function (line) {
	      if (line.markedSpans)
	        { (existing || (existing = change["spans_" + doc.id] = {}))[n] = line.markedSpans; }
	      ++n;
	    });
	  }
	
	  // When un/re-doing restores text containing marked spans, those
	  // that have been explicitly cleared should not be restored.
	  function removeClearedSpans(spans) {
	    if (!spans) { return null }
	    var out;
	    for (var i = 0; i < spans.length; ++i) {
	      if (spans[i].marker.explicitlyCleared) { if (!out) { out = spans.slice(0, i); } }
	      else if (out) { out.push(spans[i]); }
	    }
	    return !out ? spans : out.length ? out : null
	  }
	
	  // Retrieve and filter the old marked spans stored in a change event.
	  function getOldSpans(doc, change) {
	    var found = change["spans_" + doc.id];
	    if (!found) { return null }
	    var nw = [];
	    for (var i = 0; i < change.text.length; ++i)
	      { nw.push(removeClearedSpans(found[i])); }
	    return nw
	  }
	
	  // Used for un/re-doing changes from the history. Combines the
	  // result of computing the existing spans with the set of spans that
	  // existed in the history (so that deleting around a span and then
	  // undoing brings back the span).
	  function mergeOldSpans(doc, change) {
	    var old = getOldSpans(doc, change);
	    var stretched = stretchSpansOverChange(doc, change);
	    if (!old) { return stretched }
	    if (!stretched) { return old }
	
	    for (var i = 0; i < old.length; ++i) {
	      var oldCur = old[i], stretchCur = stretched[i];
	      if (oldCur && stretchCur) {
	        spans: for (var j = 0; j < stretchCur.length; ++j) {
	          var span = stretchCur[j];
	          for (var k = 0; k < oldCur.length; ++k)
	            { if (oldCur[k].marker == span.marker) { continue spans } }
	          oldCur.push(span);
	        }
	      } else if (stretchCur) {
	        old[i] = stretchCur;
	      }
	    }
	    return old
	  }
	
	  // Used both to provide a JSON-safe object in .getHistory, and, when
	  // detaching a document, to split the history in two
	  function copyHistoryArray(events, newGroup, instantiateSel) {
	    var copy = [];
	    for (var i = 0; i < events.length; ++i) {
	      var event = events[i];
	      if (event.ranges) {
	        copy.push(instantiateSel ? Selection.prototype.deepCopy.call(event) : event);
	        continue
	      }
	      var changes = event.changes, newChanges = [];
	      copy.push({changes: newChanges});
	      for (var j = 0; j < changes.length; ++j) {
	        var change = changes[j], m = (void 0);
	        newChanges.push({from: change.from, to: change.to, text: change.text});
	        if (newGroup) { for (var prop in change) { if (m = prop.match(/^spans_(\d+)$/)) {
	          if (indexOf(newGroup, Number(m[1])) > -1) {
	            lst(newChanges)[prop] = change[prop];
	            delete change[prop];
	          }
	        } } }
	      }
	    }
	    return copy
	  }
	
	  // The 'scroll' parameter given to many of these indicated whether
	  // the new cursor position should be scrolled into view after
	  // modifying the selection.
	
	  // If shift is held or the extend flag is set, extends a range to
	  // include a given position (and optionally a second position).
	  // Otherwise, simply returns the range between the given positions.
	  // Used for cursor motion and such.
	  function extendRange(range, head, other, extend) {
	    if (extend) {
	      var anchor = range.anchor;
	      if (other) {
	        var posBefore = cmp(head, anchor) < 0;
	        if (posBefore != (cmp(other, anchor) < 0)) {
	          anchor = head;
	          head = other;
	        } else if (posBefore != (cmp(head, other) < 0)) {
	          head = other;
	        }
	      }
	      return new Range(anchor, head)
	    } else {
	      return new Range(other || head, head)
	    }
	  }
	
	  // Extend the primary selection range, discard the rest.
	  function extendSelection(doc, head, other, options, extend) {
	    if (extend == null) { extend = doc.cm && (doc.cm.display.shift || doc.extend); }
	    setSelection(doc, new Selection([extendRange(doc.sel.primary(), head, other, extend)], 0), options);
	  }
	
	  // Extend all selections (pos is an array of selections with length
	  // equal the number of selections)
	  function extendSelections(doc, heads, options) {
	    var out = [];
	    var extend = doc.cm && (doc.cm.display.shift || doc.extend);
	    for (var i = 0; i < doc.sel.ranges.length; i++)
	      { out[i] = extendRange(doc.sel.ranges[i], heads[i], null, extend); }
	    var newSel = normalizeSelection(doc.cm, out, doc.sel.primIndex);
	    setSelection(doc, newSel, options);
	  }
	
	  // Updates a single range in the selection.
	  function replaceOneSelection(doc, i, range, options) {
	    var ranges = doc.sel.ranges.slice(0);
	    ranges[i] = range;
	    setSelection(doc, normalizeSelection(doc.cm, ranges, doc.sel.primIndex), options);
	  }
	
	  // Reset the selection to a single range.
	  function setSimpleSelection(doc, anchor, head, options) {
	    setSelection(doc, simpleSelection(anchor, head), options);
	  }
	
	  // Give beforeSelectionChange handlers a change to influence a
	  // selection update.
	  function filterSelectionChange(doc, sel, options) {
	    var obj = {
	      ranges: sel.ranges,
	      update: function(ranges) {
	        this.ranges = [];
	        for (var i = 0; i < ranges.length; i++)
	          { this.ranges[i] = new Range(clipPos(doc, ranges[i].anchor),
	                                     clipPos(doc, ranges[i].head)); }
	      },
	      origin: options && options.origin
	    };
	    signal(doc, "beforeSelectionChange", doc, obj);
	    if (doc.cm) { signal(doc.cm, "beforeSelectionChange", doc.cm, obj); }
	    if (obj.ranges != sel.ranges) { return normalizeSelection(doc.cm, obj.ranges, obj.ranges.length - 1) }
	    else { return sel }
	  }
	
	  function setSelectionReplaceHistory(doc, sel, options) {
	    var done = doc.history.done, last = lst(done);
	    if (last && last.ranges) {
	      done[done.length - 1] = sel;
	      setSelectionNoUndo(doc, sel, options);
	    } else {
	      setSelection(doc, sel, options);
	    }
	  }
	
	  // Set a new selection.
	  function setSelection(doc, sel, options) {
	    setSelectionNoUndo(doc, sel, options);
	    addSelectionToHistory(doc, doc.sel, doc.cm ? doc.cm.curOp.id : NaN, options);
	  }
	
	  function setSelectionNoUndo(doc, sel, options) {
	    if (hasHandler(doc, "beforeSelectionChange") || doc.cm && hasHandler(doc.cm, "beforeSelectionChange"))
	      { sel = filterSelectionChange(doc, sel, options); }
	
	    var bias = options && options.bias ||
	      (cmp(sel.primary().head, doc.sel.primary().head) < 0 ? -1 : 1);
	    setSelectionInner(doc, skipAtomicInSelection(doc, sel, bias, true));
	
	    if (!(options && options.scroll === false) && doc.cm && doc.cm.getOption("readOnly") != "nocursor")
	      { ensureCursorVisible(doc.cm); }
	  }
	
	  function setSelectionInner(doc, sel) {
	    if (sel.equals(doc.sel)) { return }
	
	    doc.sel = sel;
	
	    if (doc.cm) {
	      doc.cm.curOp.updateInput = 1;
	      doc.cm.curOp.selectionChanged = true;
	      signalCursorActivity(doc.cm);
	    }
	    signalLater(doc, "cursorActivity", doc);
	  }
	
	  // Verify that the selection does not partially select any atomic
	  // marked ranges.
	  function reCheckSelection(doc) {
	    setSelectionInner(doc, skipAtomicInSelection(doc, doc.sel, null, false));
	  }
	
	  // Return a selection that does not partially select any atomic
	  // ranges.
	  function skipAtomicInSelection(doc, sel, bias, mayClear) {
	    var out;
	    for (var i = 0; i < sel.ranges.length; i++) {
	      var range = sel.ranges[i];
	      var old = sel.ranges.length == doc.sel.ranges.length && doc.sel.ranges[i];
	      var newAnchor = skipAtomic(doc, range.anchor, old && old.anchor, bias, mayClear);
	      var newHead = skipAtomic(doc, range.head, old && old.head, bias, mayClear);
	      if (out || newAnchor != range.anchor || newHead != range.head) {
	        if (!out) { out = sel.ranges.slice(0, i); }
	        out[i] = new Range(newAnchor, newHead);
	      }
	    }
	    return out ? normalizeSelection(doc.cm, out, sel.primIndex) : sel
	  }
	
	  function skipAtomicInner(doc, pos, oldPos, dir, mayClear) {
	    var line = getLine(doc, pos.line);
	    if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
	      var sp = line.markedSpans[i], m = sp.marker;
	
	      // Determine if we should prevent the cursor being placed to the left/right of an atomic marker
	      // Historically this was determined using the inclusiveLeft/Right option, but the new way to control it
	      // is with selectLeft/Right
	      var preventCursorLeft = ("selectLeft" in m) ? !m.selectLeft : m.inclusiveLeft;
	      var preventCursorRight = ("selectRight" in m) ? !m.selectRight : m.inclusiveRight;
	
	      if ((sp.from == null || (preventCursorLeft ? sp.from <= pos.ch : sp.from < pos.ch)) &&
	          (sp.to == null || (preventCursorRight ? sp.to >= pos.ch : sp.to > pos.ch))) {
	        if (mayClear) {
	          signal(m, "beforeCursorEnter");
	          if (m.explicitlyCleared) {
	            if (!line.markedSpans) { break }
	            else {--i; continue}
	          }
	        }
	        if (!m.atomic) { continue }
	
	        if (oldPos) {
	          var near = m.find(dir < 0 ? 1 : -1), diff = (void 0);
	          if (dir < 0 ? preventCursorRight : preventCursorLeft)
	            { near = movePos(doc, near, -dir, near && near.line == pos.line ? line : null); }
	          if (near && near.line == pos.line && (diff = cmp(near, oldPos)) && (dir < 0 ? diff < 0 : diff > 0))
	            { return skipAtomicInner(doc, near, pos, dir, mayClear) }
	        }
	
	        var far = m.find(dir < 0 ? -1 : 1);
	        if (dir < 0 ? preventCursorLeft : preventCursorRight)
	          { far = movePos(doc, far, dir, far.line == pos.line ? line : null); }
	        return far ? skipAtomicInner(doc, far, pos, dir, mayClear) : null
	      }
	    } }
	    return pos
	  }
	
	  // Ensure a given position is not inside an atomic range.
	  function skipAtomic(doc, pos, oldPos, bias, mayClear) {
	    var dir = bias || 1;
	    var found = skipAtomicInner(doc, pos, oldPos, dir, mayClear) ||
	        (!mayClear && skipAtomicInner(doc, pos, oldPos, dir, true)) ||
	        skipAtomicInner(doc, pos, oldPos, -dir, mayClear) ||
	        (!mayClear && skipAtomicInner(doc, pos, oldPos, -dir, true));
	    if (!found) {
	      doc.cantEdit = true;
	      return Pos(doc.first, 0)
	    }
	    return found
	  }
	
	  function movePos(doc, pos, dir, line) {
	    if (dir < 0 && pos.ch == 0) {
	      if (pos.line > doc.first) { return clipPos(doc, Pos(pos.line - 1)) }
	      else { return null }
	    } else if (dir > 0 && pos.ch == (line || getLine(doc, pos.line)).text.length) {
	      if (pos.line < doc.first + doc.size - 1) { return Pos(pos.line + 1, 0) }
	      else { return null }
	    } else {
	      return new Pos(pos.line, pos.ch + dir)
	    }
	  }
	
	  function selectAll(cm) {
	    cm.setSelection(Pos(cm.firstLine(), 0), Pos(cm.lastLine()), sel_dontScroll);
	  }
	
	  // UPDATING
	
	  // Allow "beforeChange" event handlers to influence a change
	  function filterChange(doc, change, update) {
	    var obj = {
	      canceled: false,
	      from: change.from,
	      to: change.to,
	      text: change.text,
	      origin: change.origin,
	      cancel: function () { return obj.canceled = true; }
	    };
	    if (update) { obj.update = function (from, to, text, origin) {
	      if (from) { obj.from = clipPos(doc, from); }
	      if (to) { obj.to = clipPos(doc, to); }
	      if (text) { obj.text = text; }
	      if (origin !== undefined) { obj.origin = origin; }
	    }; }
	    signal(doc, "beforeChange", doc, obj);
	    if (doc.cm) { signal(doc.cm, "beforeChange", doc.cm, obj); }
	
	    if (obj.canceled) {
	      if (doc.cm) { doc.cm.curOp.updateInput = 2; }
	      return null
	    }
	    return {from: obj.from, to: obj.to, text: obj.text, origin: obj.origin}
	  }
	
	  // Apply a change to a document, and add it to the document's
	  // history, and propagating it to all linked documents.
	  function makeChange(doc, change, ignoreReadOnly) {
	    if (doc.cm) {
	      if (!doc.cm.curOp) { return operation(doc.cm, makeChange)(doc, change, ignoreReadOnly) }
	      if (doc.cm.state.suppressEdits) { return }
	    }
	
	    if (hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange")) {
	      change = filterChange(doc, change, true);
	      if (!change) { return }
	    }
	
	    // Possibly split or suppress the update based on the presence
	    // of read-only spans in its range.
	    var split = sawReadOnlySpans && !ignoreReadOnly && removeReadOnlyRanges(doc, change.from, change.to);
	    if (split) {
	      for (var i = split.length - 1; i >= 0; --i)
	        { makeChangeInner(doc, {from: split[i].from, to: split[i].to, text: i ? [""] : change.text, origin: change.origin}); }
	    } else {
	      makeChangeInner(doc, change);
	    }
	  }
	
	  function makeChangeInner(doc, change) {
	    if (change.text.length == 1 && change.text[0] == "" && cmp(change.from, change.to) == 0) { return }
	    var selAfter = computeSelAfterChange(doc, change);
	    addChangeToHistory(doc, change, selAfter, doc.cm ? doc.cm.curOp.id : NaN);
	
	    makeChangeSingleDoc(doc, change, selAfter, stretchSpansOverChange(doc, change));
	    var rebased = [];
	
	    linkedDocs(doc, function (doc, sharedHist) {
	      if (!sharedHist && indexOf(rebased, doc.history) == -1) {
	        rebaseHist(doc.history, change);
	        rebased.push(doc.history);
	      }
	      makeChangeSingleDoc(doc, change, null, stretchSpansOverChange(doc, change));
	    });
	  }
	
	  // Revert a change stored in a document's history.
	  function makeChangeFromHistory(doc, type, allowSelectionOnly) {
	    var suppress = doc.cm && doc.cm.state.suppressEdits;
	    if (suppress && !allowSelectionOnly) { return }
	
	    var hist = doc.history, event, selAfter = doc.sel;
	    var source = type == "undo" ? hist.done : hist.undone, dest = type == "undo" ? hist.undone : hist.done;
	
	    // Verify that there is a useable event (so that ctrl-z won't
	    // needlessly clear selection events)
	    var i = 0;
	    for (; i < source.length; i++) {
	      event = source[i];
	      if (allowSelectionOnly ? event.ranges && !event.equals(doc.sel) : !event.ranges)
	        { break }
	    }
	    if (i == source.length) { return }
	    hist.lastOrigin = hist.lastSelOrigin = null;
	
	    for (;;) {
	      event = source.pop();
	      if (event.ranges) {
	        pushSelectionToHistory(event, dest);
	        if (allowSelectionOnly && !event.equals(doc.sel)) {
	          setSelection(doc, event, {clearRedo: false});
	          return
	        }
	        selAfter = event;
	      } else if (suppress) {
	        source.push(event);
	        return
	      } else { break }
	    }
	
	    // Build up a reverse change object to add to the opposite history
	    // stack (redo when undoing, and vice versa).
	    var antiChanges = [];
	    pushSelectionToHistory(selAfter, dest);
	    dest.push({changes: antiChanges, generation: hist.generation});
	    hist.generation = event.generation || ++hist.maxGeneration;
	
	    var filter = hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange");
	
	    var loop = function ( i ) {
	      var change = event.changes[i];
	      change.origin = type;
	      if (filter && !filterChange(doc, change, false)) {
	        source.length = 0;
	        return {}
	      }
	
	      antiChanges.push(historyChangeFromChange(doc, change));
	
	      var after = i ? computeSelAfterChange(doc, change) : lst(source);
	      makeChangeSingleDoc(doc, change, after, mergeOldSpans(doc, change));
	      if (!i && doc.cm) { doc.cm.scrollIntoView({from: change.from, to: changeEnd(change)}); }
	      var rebased = [];
	
	      // Propagate to the linked documents
	      linkedDocs(doc, function (doc, sharedHist) {
	        if (!sharedHist && indexOf(rebased, doc.history) == -1) {
	          rebaseHist(doc.history, change);
	          rebased.push(doc.history);
	        }
	        makeChangeSingleDoc(doc, change, null, mergeOldSpans(doc, change));
	      });
	    };
	
	    for (var i$1 = event.changes.length - 1; i$1 >= 0; --i$1) {
	      var returned = loop( i$1 );
	
	      if ( returned ) return returned.v;
	    }
	  }
	
	  // Sub-views need their line numbers shifted when text is added
	  // above or below them in the parent document.
	  function shiftDoc(doc, distance) {
	    if (distance == 0) { return }
	    doc.first += distance;
	    doc.sel = new Selection(map(doc.sel.ranges, function (range) { return new Range(
	      Pos(range.anchor.line + distance, range.anchor.ch),
	      Pos(range.head.line + distance, range.head.ch)
	    ); }), doc.sel.primIndex);
	    if (doc.cm) {
	      regChange(doc.cm, doc.first, doc.first - distance, distance);
	      for (var d = doc.cm.display, l = d.viewFrom; l < d.viewTo; l++)
	        { regLineChange(doc.cm, l, "gutter"); }
	    }
	  }
	
	  // More lower-level change function, handling only a single document
	  // (not linked ones).
	  function makeChangeSingleDoc(doc, change, selAfter, spans) {
	    if (doc.cm && !doc.cm.curOp)
	      { return operation(doc.cm, makeChangeSingleDoc)(doc, change, selAfter, spans) }
	
	    if (change.to.line < doc.first) {
	      shiftDoc(doc, change.text.length - 1 - (change.to.line - change.from.line));
	      return
	    }
	    if (change.from.line > doc.lastLine()) { return }
	
	    // Clip the change to the size of this doc
	    if (change.from.line < doc.first) {
	      var shift = change.text.length - 1 - (doc.first - change.from.line);
	      shiftDoc(doc, shift);
	      change = {from: Pos(doc.first, 0), to: Pos(change.to.line + shift, change.to.ch),
	                text: [lst(change.text)], origin: change.origin};
	    }
	    var last = doc.lastLine();
	    if (change.to.line > last) {
	      change = {from: change.from, to: Pos(last, getLine(doc, last).text.length),
	                text: [change.text[0]], origin: change.origin};
	    }
	
	    change.removed = getBetween(doc, change.from, change.to);
	
	    if (!selAfter) { selAfter = computeSelAfterChange(doc, change); }
	    if (doc.cm) { makeChangeSingleDocInEditor(doc.cm, change, spans); }
	    else { updateDoc(doc, change, spans); }
	    setSelectionNoUndo(doc, selAfter, sel_dontScroll);
	
	    if (doc.cantEdit && skipAtomic(doc, Pos(doc.firstLine(), 0)))
	      { doc.cantEdit = false; }
	  }
	
	  // Handle the interaction of a change to a document with the editor
	  // that this document is part of.
	  function makeChangeSingleDocInEditor(cm, change, spans) {
	    var doc = cm.doc, display = cm.display, from = change.from, to = change.to;
	
	    var recomputeMaxLength = false, checkWidthStart = from.line;
	    if (!cm.options.lineWrapping) {
	      checkWidthStart = lineNo(visualLine(getLine(doc, from.line)));
	      doc.iter(checkWidthStart, to.line + 1, function (line) {
	        if (line == display.maxLine) {
	          recomputeMaxLength = true;
	          return true
	        }
	      });
	    }
	
	    if (doc.sel.contains(change.from, change.to) > -1)
	      { signalCursorActivity(cm); }
	
	    updateDoc(doc, change, spans, estimateHeight(cm));
	
	    if (!cm.options.lineWrapping) {
	      doc.iter(checkWidthStart, from.line + change.text.length, function (line) {
	        var len = lineLength(line);
	        if (len > display.maxLineLength) {
	          display.maxLine = line;
	          display.maxLineLength = len;
	          display.maxLineChanged = true;
	          recomputeMaxLength = false;
	        }
	      });
	      if (recomputeMaxLength) { cm.curOp.updateMaxLine = true; }
	    }
	
	    retreatFrontier(doc, from.line);
	    startWorker(cm, 400);
	
	    var lendiff = change.text.length - (to.line - from.line) - 1;
	    // Remember that these lines changed, for updating the display
	    if (change.full)
	      { regChange(cm); }
	    else if (from.line == to.line && change.text.length == 1 && !isWholeLineUpdate(cm.doc, change))
	      { regLineChange(cm, from.line, "text"); }
	    else
	      { regChange(cm, from.line, to.line + 1, lendiff); }
	
	    var changesHandler = hasHandler(cm, "changes"), changeHandler = hasHandler(cm, "change");
	    if (changeHandler || changesHandler) {
	      var obj = {
	        from: from, to: to,
	        text: change.text,
	        removed: change.removed,
	        origin: change.origin
	      };
	      if (changeHandler) { signalLater(cm, "change", cm, obj); }
	      if (changesHandler) { (cm.curOp.changeObjs || (cm.curOp.changeObjs = [])).push(obj); }
	    }
	    cm.display.selForContextMenu = null;
	  }
	
	  function replaceRange(doc, code, from, to, origin) {
	    var assign;
	
	    if (!to) { to = from; }
	    if (cmp(to, from) < 0) { (assign = [to, from], from = assign[0], to = assign[1]); }
	    if (typeof code == "string") { code = doc.splitLines(code); }
	    makeChange(doc, {from: from, to: to, text: code, origin: origin});
	  }
	
	  // Rebasing/resetting history to deal with externally-sourced changes
	
	  function rebaseHistSelSingle(pos, from, to, diff) {
	    if (to < pos.line) {
	      pos.line += diff;
	    } else if (from < pos.line) {
	      pos.line = from;
	      pos.ch = 0;
	    }
	  }
	
	  // Tries to rebase an array of history events given a change in the
	  // document. If the change touches the same lines as the event, the
	  // event, and everything 'behind' it, is discarded. If the change is
	  // before the event, the event's positions are updated. Uses a
	  // copy-on-write scheme for the positions, to avoid having to
	  // reallocate them all on every rebase, but also avoid problems with
	  // shared position objects being unsafely updated.
	  function rebaseHistArray(array, from, to, diff) {
	    for (var i = 0; i < array.length; ++i) {
	      var sub = array[i], ok = true;
	      if (sub.ranges) {
	        if (!sub.copied) { sub = array[i] = sub.deepCopy(); sub.copied = true; }
	        for (var j = 0; j < sub.ranges.length; j++) {
	          rebaseHistSelSingle(sub.ranges[j].anchor, from, to, diff);
	          rebaseHistSelSingle(sub.ranges[j].head, from, to, diff);
	        }
	        continue
	      }
	      for (var j$1 = 0; j$1 < sub.changes.length; ++j$1) {
	        var cur = sub.changes[j$1];
	        if (to < cur.from.line) {
	          cur.from = Pos(cur.from.line + diff, cur.from.ch);
	          cur.to = Pos(cur.to.line + diff, cur.to.ch);
	        } else if (from <= cur.to.line) {
	          ok = false;
	          break
	        }
	      }
	      if (!ok) {
	        array.splice(0, i + 1);
	        i = 0;
	      }
	    }
	  }
	
	  function rebaseHist(hist, change) {
	    var from = change.from.line, to = change.to.line, diff = change.text.length - (to - from) - 1;
	    rebaseHistArray(hist.done, from, to, diff);
	    rebaseHistArray(hist.undone, from, to, diff);
	  }
	
	  // Utility for applying a change to a line by handle or number,
	  // returning the number and optionally registering the line as
	  // changed.
	  function changeLine(doc, handle, changeType, op) {
	    var no = handle, line = handle;
	    if (typeof handle == "number") { line = getLine(doc, clipLine(doc, handle)); }
	    else { no = lineNo(handle); }
	    if (no == null) { return null }
	    if (op(line, no) && doc.cm) { regLineChange(doc.cm, no, changeType); }
	    return line
	  }
	
	  // The document is represented as a BTree consisting of leaves, with
	  // chunk of lines in them, and branches, with up to ten leaves or
	  // other branch nodes below them. The top node is always a branch
	  // node, and is the document object itself (meaning it has
	  // additional methods and properties).
	  //
	  // All nodes have parent links. The tree is used both to go from
	  // line numbers to line objects, and to go from objects to numbers.
	  // It also indexes by height, and is used to convert between height
	  // and line object, and to find the total height of the document.
	  //
	  // See also http://marijnhaverbeke.nl/blog/codemirror-line-tree.html
	
	  function LeafChunk(lines) {
	    this.lines = lines;
	    this.parent = null;
	    var height = 0;
	    for (var i = 0; i < lines.length; ++i) {
	      lines[i].parent = this;
	      height += lines[i].height;
	    }
	    this.height = height;
	  }
	
	  LeafChunk.prototype = {
	    chunkSize: function() { return this.lines.length },
	
	    // Remove the n lines at offset 'at'.
	    removeInner: function(at, n) {
	      for (var i = at, e = at + n; i < e; ++i) {
	        var line = this.lines[i];
	        this.height -= line.height;
	        cleanUpLine(line);
	        signalLater(line, "delete");
	      }
	      this.lines.splice(at, n);
	    },
	
	    // Helper used to collapse a small branch into a single leaf.
	    collapse: function(lines) {
	      lines.push.apply(lines, this.lines);
	    },
	
	    // Insert the given array of lines at offset 'at', count them as
	    // having the given height.
	    insertInner: function(at, lines, height) {
	      this.height += height;
	      this.lines = this.lines.slice(0, at).concat(lines).concat(this.lines.slice(at));
	      for (var i = 0; i < lines.length; ++i) { lines[i].parent = this; }
	    },
	
	    // Used to iterate over a part of the tree.
	    iterN: function(at, n, op) {
	      for (var e = at + n; at < e; ++at)
	        { if (op(this.lines[at])) { return true } }
	    }
	  };
	
	  function BranchChunk(children) {
	    this.children = children;
	    var size = 0, height = 0;
	    for (var i = 0; i < children.length; ++i) {
	      var ch = children[i];
	      size += ch.chunkSize(); height += ch.height;
	      ch.parent = this;
	    }
	    this.size = size;
	    this.height = height;
	    this.parent = null;
	  }
	
	  BranchChunk.prototype = {
	    chunkSize: function() { return this.size },
	
	    removeInner: function(at, n) {
	      this.size -= n;
	      for (var i = 0; i < this.children.length; ++i) {
	        var child = this.children[i], sz = child.chunkSize();
	        if (at < sz) {
	          var rm = Math.min(n, sz - at), oldHeight = child.height;
	          child.removeInner(at, rm);
	          this.height -= oldHeight - child.height;
	          if (sz == rm) { this.children.splice(i--, 1); child.parent = null; }
	          if ((n -= rm) == 0) { break }
	          at = 0;
	        } else { at -= sz; }
	      }
	      // If the result is smaller than 25 lines, ensure that it is a
	      // single leaf node.
	      if (this.size - n < 25 &&
	          (this.children.length > 1 || !(this.children[0] instanceof LeafChunk))) {
	        var lines = [];
	        this.collapse(lines);
	        this.children = [new LeafChunk(lines)];
	        this.children[0].parent = this;
	      }
	    },
	
	    collapse: function(lines) {
	      for (var i = 0; i < this.children.length; ++i) { this.children[i].collapse(lines); }
	    },
	
	    insertInner: function(at, lines, height) {
	      this.size += lines.length;
	      this.height += height;
	      for (var i = 0; i < this.children.length; ++i) {
	        var child = this.children[i], sz = child.chunkSize();
	        if (at <= sz) {
	          child.insertInner(at, lines, height);
	          if (child.lines && child.lines.length > 50) {
	            // To avoid memory thrashing when child.lines is huge (e.g. first view of a large file), it's never spliced.
	            // Instead, small slices are taken. They're taken in order because sequential memory accesses are fastest.
	            var remaining = child.lines.length % 25 + 25;
	            for (var pos = remaining; pos < child.lines.length;) {
	              var leaf = new LeafChunk(child.lines.slice(pos, pos += 25));
	              child.height -= leaf.height;
	              this.children.splice(++i, 0, leaf);
	              leaf.parent = this;
	            }
	            child.lines = child.lines.slice(0, remaining);
	            this.maybeSpill();
	          }
	          break
	        }
	        at -= sz;
	      }
	    },
	
	    // When a node has grown, check whether it should be split.
	    maybeSpill: function() {
	      if (this.children.length <= 10) { return }
	      var me = this;
	      do {
	        var spilled = me.children.splice(me.children.length - 5, 5);
	        var sibling = new BranchChunk(spilled);
	        if (!me.parent) { // Become the parent node
	          var copy = new BranchChunk(me.children);
	          copy.parent = me;
	          me.children = [copy, sibling];
	          me = copy;
	       } else {
	          me.size -= sibling.size;
	          me.height -= sibling.height;
	          var myIndex = indexOf(me.parent.children, me);
	          me.parent.children.splice(myIndex + 1, 0, sibling);
	        }
	        sibling.parent = me.parent;
	      } while (me.children.length > 10)
	      me.parent.maybeSpill();
	    },
	
	    iterN: function(at, n, op) {
	      for (var i = 0; i < this.children.length; ++i) {
	        var child = this.children[i], sz = child.chunkSize();
	        if (at < sz) {
	          var used = Math.min(n, sz - at);
	          if (child.iterN(at, used, op)) { return true }
	          if ((n -= used) == 0) { break }
	          at = 0;
	        } else { at -= sz; }
	      }
	    }
	  };
	
	  // Line widgets are block elements displayed above or below a line.
	
	  var LineWidget = function(doc, node, options) {
	    if (options) { for (var opt in options) { if (options.hasOwnProperty(opt))
	      { this[opt] = options[opt]; } } }
	    this.doc = doc;
	    this.node = node;
	  };
	
	  LineWidget.prototype.clear = function () {
	    var cm = this.doc.cm, ws = this.line.widgets, line = this.line, no = lineNo(line);
	    if (no == null || !ws) { return }
	    for (var i = 0; i < ws.length; ++i) { if (ws[i] == this) { ws.splice(i--, 1); } }
	    if (!ws.length) { line.widgets = null; }
	    var height = widgetHeight(this);
	    updateLineHeight(line, Math.max(0, line.height - height));
	    if (cm) {
	      runInOp(cm, function () {
	        adjustScrollWhenAboveVisible(cm, line, -height);
	        regLineChange(cm, no, "widget");
	      });
	      signalLater(cm, "lineWidgetCleared", cm, this, no);
	    }
	  };
	
	  LineWidget.prototype.changed = function () {
	      var this$1 = this;
	
	    var oldH = this.height, cm = this.doc.cm, line = this.line;
	    this.height = null;
	    var diff = widgetHeight(this) - oldH;
	    if (!diff) { return }
	    if (!lineIsHidden(this.doc, line)) { updateLineHeight(line, line.height + diff); }
	    if (cm) {
	      runInOp(cm, function () {
	        cm.curOp.forceUpdate = true;
	        adjustScrollWhenAboveVisible(cm, line, diff);
	        signalLater(cm, "lineWidgetChanged", cm, this$1, lineNo(line));
	      });
	    }
	  };
	  eventMixin(LineWidget);
	
	  function adjustScrollWhenAboveVisible(cm, line, diff) {
	    if (heightAtLine(line) < ((cm.curOp && cm.curOp.scrollTop) || cm.doc.scrollTop))
	      { addToScrollTop(cm, diff); }
	  }
	
	  function addLineWidget(doc, handle, node, options) {
	    var widget = new LineWidget(doc, node, options);
	    var cm = doc.cm;
	    if (cm && widget.noHScroll) { cm.display.alignWidgets = true; }
	    changeLine(doc, handle, "widget", function (line) {
	      var widgets = line.widgets || (line.widgets = []);
	      if (widget.insertAt == null) { widgets.push(widget); }
	      else { widgets.splice(Math.min(widgets.length, Math.max(0, widget.insertAt)), 0, widget); }
	      widget.line = line;
	      if (cm && !lineIsHidden(doc, line)) {
	        var aboveVisible = heightAtLine(line) < doc.scrollTop;
	        updateLineHeight(line, line.height + widgetHeight(widget));
	        if (aboveVisible) { addToScrollTop(cm, widget.height); }
	        cm.curOp.forceUpdate = true;
	      }
	      return true
	    });
	    if (cm) { signalLater(cm, "lineWidgetAdded", cm, widget, typeof handle == "number" ? handle : lineNo(handle)); }
	    return widget
	  }
	
	  // TEXTMARKERS
	
	  // Created with markText and setBookmark methods. A TextMarker is a
	  // handle that can be used to clear or find a marked position in the
	  // document. Line objects hold arrays (markedSpans) containing
	  // {from, to, marker} object pointing to such marker objects, and
	  // indicating that such a marker is present on that line. Multiple
	  // lines may point to the same marker when it spans across lines.
	  // The spans will have null for their from/to properties when the
	  // marker continues beyond the start/end of the line. Markers have
	  // links back to the lines they currently touch.
	
	  // Collapsed markers have unique ids, in order to be able to order
	  // them, which is needed for uniquely determining an outer marker
	  // when they overlap (they may nest, but not partially overlap).
	  var nextMarkerId = 0;
	
	  var TextMarker = function(doc, type) {
	    this.lines = [];
	    this.type = type;
	    this.doc = doc;
	    this.id = ++nextMarkerId;
	  };
	
	  // Clear the marker.
	  TextMarker.prototype.clear = function () {
	    if (this.explicitlyCleared) { return }
	    var cm = this.doc.cm, withOp = cm && !cm.curOp;
	    if (withOp) { startOperation(cm); }
	    if (hasHandler(this, "clear")) {
	      var found = this.find();
	      if (found) { signalLater(this, "clear", found.from, found.to); }
	    }
	    var min = null, max = null;
	    for (var i = 0; i < this.lines.length; ++i) {
	      var line = this.lines[i];
	      var span = getMarkedSpanFor(line.markedSpans, this);
	      if (cm && !this.collapsed) { regLineChange(cm, lineNo(line), "text"); }
	      else if (cm) {
	        if (span.to != null) { max = lineNo(line); }
	        if (span.from != null) { min = lineNo(line); }
	      }
	      line.markedSpans = removeMarkedSpan(line.markedSpans, span);
	      if (span.from == null && this.collapsed && !lineIsHidden(this.doc, line) && cm)
	        { updateLineHeight(line, textHeight(cm.display)); }
	    }
	    if (cm && this.collapsed && !cm.options.lineWrapping) { for (var i$1 = 0; i$1 < this.lines.length; ++i$1) {
	      var visual = visualLine(this.lines[i$1]), len = lineLength(visual);
	      if (len > cm.display.maxLineLength) {
	        cm.display.maxLine = visual;
	        cm.display.maxLineLength = len;
	        cm.display.maxLineChanged = true;
	      }
	    } }
	
	    if (min != null && cm && this.collapsed) { regChange(cm, min, max + 1); }
	    this.lines.length = 0;
	    this.explicitlyCleared = true;
	    if (this.atomic && this.doc.cantEdit) {
	      this.doc.cantEdit = false;
	      if (cm) { reCheckSelection(cm.doc); }
	    }
	    if (cm) { signalLater(cm, "markerCleared", cm, this, min, max); }
	    if (withOp) { endOperation(cm); }
	    if (this.parent) { this.parent.clear(); }
	  };
	
	  // Find the position of the marker in the document. Returns a {from,
	  // to} object by default. Side can be passed to get a specific side
	  // -- 0 (both), -1 (left), or 1 (right). When lineObj is true, the
	  // Pos objects returned contain a line object, rather than a line
	  // number (used to prevent looking up the same line twice).
	  TextMarker.prototype.find = function (side, lineObj) {
	    if (side == null && this.type == "bookmark") { side = 1; }
	    var from, to;
	    for (var i = 0; i < this.lines.length; ++i) {
	      var line = this.lines[i];
	      var span = getMarkedSpanFor(line.markedSpans, this);
	      if (span.from != null) {
	        from = Pos(lineObj ? line : lineNo(line), span.from);
	        if (side == -1) { return from }
	      }
	      if (span.to != null) {
	        to = Pos(lineObj ? line : lineNo(line), span.to);
	        if (side == 1) { return to }
	      }
	    }
	    return from && {from: from, to: to}
	  };
	
	  // Signals that the marker's widget changed, and surrounding layout
	  // should be recomputed.
	  TextMarker.prototype.changed = function () {
	      var this$1 = this;
	
	    var pos = this.find(-1, true), widget = this, cm = this.doc.cm;
	    if (!pos || !cm) { return }
	    runInOp(cm, function () {
	      var line = pos.line, lineN = lineNo(pos.line);
	      var view = findViewForLine(cm, lineN);
	      if (view) {
	        clearLineMeasurementCacheFor(view);
	        cm.curOp.selectionChanged = cm.curOp.forceUpdate = true;
	      }
	      cm.curOp.updateMaxLine = true;
	      if (!lineIsHidden(widget.doc, line) && widget.height != null) {
	        var oldHeight = widget.height;
	        widget.height = null;
	        var dHeight = widgetHeight(widget) - oldHeight;
	        if (dHeight)
	          { updateLineHeight(line, line.height + dHeight); }
	      }
	      signalLater(cm, "markerChanged", cm, this$1);
	    });
	  };
	
	  TextMarker.prototype.attachLine = function (line) {
	    if (!this.lines.length && this.doc.cm) {
	      var op = this.doc.cm.curOp;
	      if (!op.maybeHiddenMarkers || indexOf(op.maybeHiddenMarkers, this) == -1)
	        { (op.maybeUnhiddenMarkers || (op.maybeUnhiddenMarkers = [])).push(this); }
	    }
	    this.lines.push(line);
	  };
	
	  TextMarker.prototype.detachLine = function (line) {
	    this.lines.splice(indexOf(this.lines, line), 1);
	    if (!this.lines.length && this.doc.cm) {
	      var op = this.doc.cm.curOp
	      ;(op.maybeHiddenMarkers || (op.maybeHiddenMarkers = [])).push(this);
	    }
	  };
	  eventMixin(TextMarker);
	
	  // Create a marker, wire it up to the right lines, and
	  function markText(doc, from, to, options, type) {
	    // Shared markers (across linked documents) are handled separately
	    // (markTextShared will call out to this again, once per
	    // document).
	    if (options && options.shared) { return markTextShared(doc, from, to, options, type) }
	    // Ensure we are in an operation.
	    if (doc.cm && !doc.cm.curOp) { return operation(doc.cm, markText)(doc, from, to, options, type) }
	
	    var marker = new TextMarker(doc, type), diff = cmp(from, to);
	    if (options) { copyObj(options, marker, false); }
	    // Don't connect empty markers unless clearWhenEmpty is false
	    if (diff > 0 || diff == 0 && marker.clearWhenEmpty !== false)
	      { return marker }
	    if (marker.replacedWith) {
	      // Showing up as a widget implies collapsed (widget replaces text)
	      marker.collapsed = true;
	      marker.widgetNode = eltP("span", [marker.replacedWith], "CodeMirror-widget");
	      if (!options.handleMouseEvents) { marker.widgetNode.setAttribute("cm-ignore-events", "true"); }
	      if (options.insertLeft) { marker.widgetNode.insertLeft = true; }
	    }
	    if (marker.collapsed) {
	      if (conflictingCollapsedRange(doc, from.line, from, to, marker) ||
	          from.line != to.line && conflictingCollapsedRange(doc, to.line, from, to, marker))
	        { throw new Error("Inserting collapsed marker partially overlapping an existing one") }
	      seeCollapsedSpans();
	    }
	
	    if (marker.addToHistory)
	      { addChangeToHistory(doc, {from: from, to: to, origin: "markText"}, doc.sel, NaN); }
	
	    var curLine = from.line, cm = doc.cm, updateMaxLine;
	    doc.iter(curLine, to.line + 1, function (line) {
	      if (cm && marker.collapsed && !cm.options.lineWrapping && visualLine(line) == cm.display.maxLine)
	        { updateMaxLine = true; }
	      if (marker.collapsed && curLine != from.line) { updateLineHeight(line, 0); }
	      addMarkedSpan(line, new MarkedSpan(marker,
	                                         curLine == from.line ? from.ch : null,
	                                         curLine == to.line ? to.ch : null), doc.cm && doc.cm.curOp);
	      ++curLine;
	    });
	    // lineIsHidden depends on the presence of the spans, so needs a second pass
	    if (marker.collapsed) { doc.iter(from.line, to.line + 1, function (line) {
	      if (lineIsHidden(doc, line)) { updateLineHeight(line, 0); }
	    }); }
	
	    if (marker.clearOnEnter) { on(marker, "beforeCursorEnter", function () { return marker.clear(); }); }
	
	    if (marker.readOnly) {
	      seeReadOnlySpans();
	      if (doc.history.done.length || doc.history.undone.length)
	        { doc.clearHistory(); }
	    }
	    if (marker.collapsed) {
	      marker.id = ++nextMarkerId;
	      marker.atomic = true;
	    }
	    if (cm) {
	      // Sync editor state
	      if (updateMaxLine) { cm.curOp.updateMaxLine = true; }
	      if (marker.collapsed)
	        { regChange(cm, from.line, to.line + 1); }
	      else if (marker.className || marker.startStyle || marker.endStyle || marker.css ||
	               marker.attributes || marker.title)
	        { for (var i = from.line; i <= to.line; i++) { regLineChange(cm, i, "text"); } }
	      if (marker.atomic) { reCheckSelection(cm.doc); }
	      signalLater(cm, "markerAdded", cm, marker);
	    }
	    return marker
	  }
	
	  // SHARED TEXTMARKERS
	
	  // A shared marker spans multiple linked documents. It is
	  // implemented as a meta-marker-object controlling multiple normal
	  // markers.
	  var SharedTextMarker = function(markers, primary) {
	    this.markers = markers;
	    this.primary = primary;
	    for (var i = 0; i < markers.length; ++i)
	      { markers[i].parent = this; }
	  };
	
	  SharedTextMarker.prototype.clear = function () {
	    if (this.explicitlyCleared) { return }
	    this.explicitlyCleared = true;
	    for (var i = 0; i < this.markers.length; ++i)
	      { this.markers[i].clear(); }
	    signalLater(this, "clear");
	  };
	
	  SharedTextMarker.prototype.find = function (side, lineObj) {
	    return this.primary.find(side, lineObj)
	  };
	  eventMixin(SharedTextMarker);
	
	  function markTextShared(doc, from, to, options, type) {
	    options = copyObj(options);
	    options.shared = false;
	    var markers = [markText(doc, from, to, options, type)], primary = markers[0];
	    var widget = options.widgetNode;
	    linkedDocs(doc, function (doc) {
	      if (widget) { options.widgetNode = widget.cloneNode(true); }
	      markers.push(markText(doc, clipPos(doc, from), clipPos(doc, to), options, type));
	      for (var i = 0; i < doc.linked.length; ++i)
	        { if (doc.linked[i].isParent) { return } }
	      primary = lst(markers);
	    });
	    return new SharedTextMarker(markers, primary)
	  }
	
	  function findSharedMarkers(doc) {
	    return doc.findMarks(Pos(doc.first, 0), doc.clipPos(Pos(doc.lastLine())), function (m) { return m.parent; })
	  }
	
	  function copySharedMarkers(doc, markers) {
	    for (var i = 0; i < markers.length; i++) {
	      var marker = markers[i], pos = marker.find();
	      var mFrom = doc.clipPos(pos.from), mTo = doc.clipPos(pos.to);
	      if (cmp(mFrom, mTo)) {
	        var subMark = markText(doc, mFrom, mTo, marker.primary, marker.primary.type);
	        marker.markers.push(subMark);
	        subMark.parent = marker;
	      }
	    }
	  }
	
	  function detachSharedMarkers(markers) {
	    var loop = function ( i ) {
	      var marker = markers[i], linked = [marker.primary.doc];
	      linkedDocs(marker.primary.doc, function (d) { return linked.push(d); });
	      for (var j = 0; j < marker.markers.length; j++) {
	        var subMarker = marker.markers[j];
	        if (indexOf(linked, subMarker.doc) == -1) {
	          subMarker.parent = null;
	          marker.markers.splice(j--, 1);
	        }
	      }
	    };
	
	    for (var i = 0; i < markers.length; i++) loop( i );
	  }
	
	  var nextDocId = 0;
	  var Doc = function(text, mode, firstLine, lineSep, direction) {
	    if (!(this instanceof Doc)) { return new Doc(text, mode, firstLine, lineSep, direction) }
	    if (firstLine == null) { firstLine = 0; }
	
	    BranchChunk.call(this, [new LeafChunk([new Line("", null)])]);
	    this.first = firstLine;
	    this.scrollTop = this.scrollLeft = 0;
	    this.cantEdit = false;
	    this.cleanGeneration = 1;
	    this.modeFrontier = this.highlightFrontier = firstLine;
	    var start = Pos(firstLine, 0);
	    this.sel = simpleSelection(start);
	    this.history = new History(null);
	    this.id = ++nextDocId;
	    this.modeOption = mode;
	    this.lineSep = lineSep;
	    this.direction = (direction == "rtl") ? "rtl" : "ltr";
	    this.extend = false;
	
	    if (typeof text == "string") { text = this.splitLines(text); }
	    updateDoc(this, {from: start, to: start, text: text});
	    setSelection(this, simpleSelection(start), sel_dontScroll);
	  };
	
	  Doc.prototype = createObj(BranchChunk.prototype, {
	    constructor: Doc,
	    // Iterate over the document. Supports two forms -- with only one
	    // argument, it calls that for each line in the document. With
	    // three, it iterates over the range given by the first two (with
	    // the second being non-inclusive).
	    iter: function(from, to, op) {
	      if (op) { this.iterN(from - this.first, to - from, op); }
	      else { this.iterN(this.first, this.first + this.size, from); }
	    },
	
	    // Non-public interface for adding and removing lines.
	    insert: function(at, lines) {
	      var height = 0;
	      for (var i = 0; i < lines.length; ++i) { height += lines[i].height; }
	      this.insertInner(at - this.first, lines, height);
	    },
	    remove: function(at, n) { this.removeInner(at - this.first, n); },
	
	    // From here, the methods are part of the public interface. Most
	    // are also available from CodeMirror (editor) instances.
	
	    getValue: function(lineSep) {
	      var lines = getLines(this, this.first, this.first + this.size);
	      if (lineSep === false) { return lines }
	      return lines.join(lineSep || this.lineSeparator())
	    },
	    setValue: docMethodOp(function(code) {
	      var top = Pos(this.first, 0), last = this.first + this.size - 1;
	      makeChange(this, {from: top, to: Pos(last, getLine(this, last).text.length),
	                        text: this.splitLines(code), origin: "setValue", full: true}, true);
	      if (this.cm) { scrollToCoords(this.cm, 0, 0); }
	      setSelection(this, simpleSelection(top), sel_dontScroll);
	    }),
	    replaceRange: function(code, from, to, origin) {
	      from = clipPos(this, from);
	      to = to ? clipPos(this, to) : from;
	      replaceRange(this, code, from, to, origin);
	    },
	    getRange: function(from, to, lineSep) {
	      var lines = getBetween(this, clipPos(this, from), clipPos(this, to));
	      if (lineSep === false) { return lines }
	      if (lineSep === '') { return lines.join('') }
	      return lines.join(lineSep || this.lineSeparator())
	    },
	
	    getLine: function(line) {var l = this.getLineHandle(line); return l && l.text},
	
	    getLineHandle: function(line) {if (isLine(this, line)) { return getLine(this, line) }},
	    getLineNumber: function(line) {return lineNo(line)},
	
	    getLineHandleVisualStart: function(line) {
	      if (typeof line == "number") { line = getLine(this, line); }
	      return visualLine(line)
	    },
	
	    lineCount: function() {return this.size},
	    firstLine: function() {return this.first},
	    lastLine: function() {return this.first + this.size - 1},
	
	    clipPos: function(pos) {return clipPos(this, pos)},
	
	    getCursor: function(start) {
	      var range = this.sel.primary(), pos;
	      if (start == null || start == "head") { pos = range.head; }
	      else if (start == "anchor") { pos = range.anchor; }
	      else if (start == "end" || start == "to" || start === false) { pos = range.to(); }
	      else { pos = range.from(); }
	      return pos
	    },
	    listSelections: function() { return this.sel.ranges },
	    somethingSelected: function() {return this.sel.somethingSelected()},
	
	    setCursor: docMethodOp(function(line, ch, options) {
	      setSimpleSelection(this, clipPos(this, typeof line == "number" ? Pos(line, ch || 0) : line), null, options);
	    }),
	    setSelection: docMethodOp(function(anchor, head, options) {
	      setSimpleSelection(this, clipPos(this, anchor), clipPos(this, head || anchor), options);
	    }),
	    extendSelection: docMethodOp(function(head, other, options) {
	      extendSelection(this, clipPos(this, head), other && clipPos(this, other), options);
	    }),
	    extendSelections: docMethodOp(function(heads, options) {
	      extendSelections(this, clipPosArray(this, heads), options);
	    }),
	    extendSelectionsBy: docMethodOp(function(f, options) {
	      var heads = map(this.sel.ranges, f);
	      extendSelections(this, clipPosArray(this, heads), options);
	    }),
	    setSelections: docMethodOp(function(ranges, primary, options) {
	      if (!ranges.length) { return }
	      var out = [];
	      for (var i = 0; i < ranges.length; i++)
	        { out[i] = new Range(clipPos(this, ranges[i].anchor),
	                           clipPos(this, ranges[i].head || ranges[i].anchor)); }
	      if (primary == null) { primary = Math.min(ranges.length - 1, this.sel.primIndex); }
	      setSelection(this, normalizeSelection(this.cm, out, primary), options);
	    }),
	    addSelection: docMethodOp(function(anchor, head, options) {
	      var ranges = this.sel.ranges.slice(0);
	      ranges.push(new Range(clipPos(this, anchor), clipPos(this, head || anchor)));
	      setSelection(this, normalizeSelection(this.cm, ranges, ranges.length - 1), options);
	    }),
	
	    getSelection: function(lineSep) {
	      var ranges = this.sel.ranges, lines;
	      for (var i = 0; i < ranges.length; i++) {
	        var sel = getBetween(this, ranges[i].from(), ranges[i].to());
	        lines = lines ? lines.concat(sel) : sel;
	      }
	      if (lineSep === false) { return lines }
	      else { return lines.join(lineSep || this.lineSeparator()) }
	    },
	    getSelections: function(lineSep) {
	      var parts = [], ranges = this.sel.ranges;
	      for (var i = 0; i < ranges.length; i++) {
	        var sel = getBetween(this, ranges[i].from(), ranges[i].to());
	        if (lineSep !== false) { sel = sel.join(lineSep || this.lineSeparator()); }
	        parts[i] = sel;
	      }
	      return parts
	    },
	    replaceSelection: function(code, collapse, origin) {
	      var dup = [];
	      for (var i = 0; i < this.sel.ranges.length; i++)
	        { dup[i] = code; }
	      this.replaceSelections(dup, collapse, origin || "+input");
	    },
	    replaceSelections: docMethodOp(function(code, collapse, origin) {
	      var changes = [], sel = this.sel;
	      for (var i = 0; i < sel.ranges.length; i++) {
	        var range = sel.ranges[i];
	        changes[i] = {from: range.from(), to: range.to(), text: this.splitLines(code[i]), origin: origin};
	      }
	      var newSel = collapse && collapse != "end" && computeReplacedSel(this, changes, collapse);
	      for (var i$1 = changes.length - 1; i$1 >= 0; i$1--)
	        { makeChange(this, changes[i$1]); }
	      if (newSel) { setSelectionReplaceHistory(this, newSel); }
	      else if (this.cm) { ensureCursorVisible(this.cm); }
	    }),
	    undo: docMethodOp(function() {makeChangeFromHistory(this, "undo");}),
	    redo: docMethodOp(function() {makeChangeFromHistory(this, "redo");}),
	    undoSelection: docMethodOp(function() {makeChangeFromHistory(this, "undo", true);}),
	    redoSelection: docMethodOp(function() {makeChangeFromHistory(this, "redo", true);}),
	
	    setExtending: function(val) {this.extend = val;},
	    getExtending: function() {return this.extend},
	
	    historySize: function() {
	      var hist = this.history, done = 0, undone = 0;
	      for (var i = 0; i < hist.done.length; i++) { if (!hist.done[i].ranges) { ++done; } }
	      for (var i$1 = 0; i$1 < hist.undone.length; i$1++) { if (!hist.undone[i$1].ranges) { ++undone; } }
	      return {undo: done, redo: undone}
	    },
	    clearHistory: function() {
	      var this$1 = this;
	
	      this.history = new History(this.history);
	      linkedDocs(this, function (doc) { return doc.history = this$1.history; }, true);
	    },
	
	    markClean: function() {
	      this.cleanGeneration = this.changeGeneration(true);
	    },
	    changeGeneration: function(forceSplit) {
	      if (forceSplit)
	        { this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null; }
	      return this.history.generation
	    },
	    isClean: function (gen) {
	      return this.history.generation == (gen || this.cleanGeneration)
	    },
	
	    getHistory: function() {
	      return {done: copyHistoryArray(this.history.done),
	              undone: copyHistoryArray(this.history.undone)}
	    },
	    setHistory: function(histData) {
	      var hist = this.history = new History(this.history);
	      hist.done = copyHistoryArray(histData.done.slice(0), null, true);
	      hist.undone = copyHistoryArray(histData.undone.slice(0), null, true);
	    },
	
	    setGutterMarker: docMethodOp(function(line, gutterID, value) {
	      return changeLine(this, line, "gutter", function (line) {
	        var markers = line.gutterMarkers || (line.gutterMarkers = {});
	        markers[gutterID] = value;
	        if (!value && isEmpty(markers)) { line.gutterMarkers = null; }
	        return true
	      })
	    }),
	
	    clearGutter: docMethodOp(function(gutterID) {
	      var this$1 = this;
	
	      this.iter(function (line) {
	        if (line.gutterMarkers && line.gutterMarkers[gutterID]) {
	          changeLine(this$1, line, "gutter", function () {
	            line.gutterMarkers[gutterID] = null;
	            if (isEmpty(line.gutterMarkers)) { line.gutterMarkers = null; }
	            return true
	          });
	        }
	      });
	    }),
	
	    lineInfo: function(line) {
	      var n;
	      if (typeof line == "number") {
	        if (!isLine(this, line)) { return null }
	        n = line;
	        line = getLine(this, line);
	        if (!line) { return null }
	      } else {
	        n = lineNo(line);
	        if (n == null) { return null }
	      }
	      return {line: n, handle: line, text: line.text, gutterMarkers: line.gutterMarkers,
	              textClass: line.textClass, bgClass: line.bgClass, wrapClass: line.wrapClass,
	              widgets: line.widgets}
	    },
	
	    addLineClass: docMethodOp(function(handle, where, cls) {
	      return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
	        var prop = where == "text" ? "textClass"
	                 : where == "background" ? "bgClass"
	                 : where == "gutter" ? "gutterClass" : "wrapClass";
	        if (!line[prop]) { line[prop] = cls; }
	        else if (classTest(cls).test(line[prop])) { return false }
	        else { line[prop] += " " + cls; }
	        return true
	      })
	    }),
	    removeLineClass: docMethodOp(function(handle, where, cls) {
	      return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
	        var prop = where == "text" ? "textClass"
	                 : where == "background" ? "bgClass"
	                 : where == "gutter" ? "gutterClass" : "wrapClass";
	        var cur = line[prop];
	        if (!cur) { return false }
	        else if (cls == null) { line[prop] = null; }
	        else {
	          var found = cur.match(classTest(cls));
	          if (!found) { return false }
	          var end = found.index + found[0].length;
	          line[prop] = cur.slice(0, found.index) + (!found.index || end == cur.length ? "" : " ") + cur.slice(end) || null;
	        }
	        return true
	      })
	    }),
	
	    addLineWidget: docMethodOp(function(handle, node, options) {
	      return addLineWidget(this, handle, node, options)
	    }),
	    removeLineWidget: function(widget) { widget.clear(); },
	
	    markText: function(from, to, options) {
	      return markText(this, clipPos(this, from), clipPos(this, to), options, options && options.type || "range")
	    },
	    setBookmark: function(pos, options) {
	      var realOpts = {replacedWith: options && (options.nodeType == null ? options.widget : options),
	                      insertLeft: options && options.insertLeft,
	                      clearWhenEmpty: false, shared: options && options.shared,
	                      handleMouseEvents: options && options.handleMouseEvents};
	      pos = clipPos(this, pos);
	      return markText(this, pos, pos, realOpts, "bookmark")
	    },
	    findMarksAt: function(pos) {
	      pos = clipPos(this, pos);
	      var markers = [], spans = getLine(this, pos.line).markedSpans;
	      if (spans) { for (var i = 0; i < spans.length; ++i) {
	        var span = spans[i];
	        if ((span.from == null || span.from <= pos.ch) &&
	            (span.to == null || span.to >= pos.ch))
	          { markers.push(span.marker.parent || span.marker); }
	      } }
	      return markers
	    },
	    findMarks: function(from, to, filter) {
	      from = clipPos(this, from); to = clipPos(this, to);
	      var found = [], lineNo = from.line;
	      this.iter(from.line, to.line + 1, function (line) {
	        var spans = line.markedSpans;
	        if (spans) { for (var i = 0; i < spans.length; i++) {
	          var span = spans[i];
	          if (!(span.to != null && lineNo == from.line && from.ch >= span.to ||
	                span.from == null && lineNo != from.line ||
	                span.from != null && lineNo == to.line && span.from >= to.ch) &&
	              (!filter || filter(span.marker)))
	            { found.push(span.marker.parent || span.marker); }
	        } }
	        ++lineNo;
	      });
	      return found
	    },
	    getAllMarks: function() {
	      var markers = [];
	      this.iter(function (line) {
	        var sps = line.markedSpans;
	        if (sps) { for (var i = 0; i < sps.length; ++i)
	          { if (sps[i].from != null) { markers.push(sps[i].marker); } } }
	      });
	      return markers
	    },
	
	    posFromIndex: function(off) {
	      var ch, lineNo = this.first, sepSize = this.lineSeparator().length;
	      this.iter(function (line) {
	        var sz = line.text.length + sepSize;
	        if (sz > off) { ch = off; return true }
	        off -= sz;
	        ++lineNo;
	      });
	      return clipPos(this, Pos(lineNo, ch))
	    },
	    indexFromPos: function (coords) {
	      coords = clipPos(this, coords);
	      var index = coords.ch;
	      if (coords.line < this.first || coords.ch < 0) { return 0 }
	      var sepSize = this.lineSeparator().length;
	      this.iter(this.first, coords.line, function (line) { // iter aborts when callback returns a truthy value
	        index += line.text.length + sepSize;
	      });
	      return index
	    },
	
	    copy: function(copyHistory) {
	      var doc = new Doc(getLines(this, this.first, this.first + this.size),
	                        this.modeOption, this.first, this.lineSep, this.direction);
	      doc.scrollTop = this.scrollTop; doc.scrollLeft = this.scrollLeft;
	      doc.sel = this.sel;
	      doc.extend = false;
	      if (copyHistory) {
	        doc.history.undoDepth = this.history.undoDepth;
	        doc.setHistory(this.getHistory());
	      }
	      return doc
	    },
	
	    linkedDoc: function(options) {
	      if (!options) { options = {}; }
	      var from = this.first, to = this.first + this.size;
	      if (options.from != null && options.from > from) { from = options.from; }
	      if (options.to != null && options.to < to) { to = options.to; }
	      var copy = new Doc(getLines(this, from, to), options.mode || this.modeOption, from, this.lineSep, this.direction);
	      if (options.sharedHist) { copy.history = this.history
	      ; }(this.linked || (this.linked = [])).push({doc: copy, sharedHist: options.sharedHist});
	      copy.linked = [{doc: this, isParent: true, sharedHist: options.sharedHist}];
	      copySharedMarkers(copy, findSharedMarkers(this));
	      return copy
	    },
	    unlinkDoc: function(other) {
	      if (other instanceof CodeMirror) { other = other.doc; }
	      if (this.linked) { for (var i = 0; i < this.linked.length; ++i) {
	        var link = this.linked[i];
	        if (link.doc != other) { continue }
	        this.linked.splice(i, 1);
	        other.unlinkDoc(this);
	        detachSharedMarkers(findSharedMarkers(this));
	        break
	      } }
	      // If the histories were shared, split them again
	      if (other.history == this.history) {
	        var splitIds = [other.id];
	        linkedDocs(other, function (doc) { return splitIds.push(doc.id); }, true);
	        other.history = new History(null);
	        other.history.done = copyHistoryArray(this.history.done, splitIds);
	        other.history.undone = copyHistoryArray(this.history.undone, splitIds);
	      }
	    },
	    iterLinkedDocs: function(f) {linkedDocs(this, f);},
	
	    getMode: function() {return this.mode},
	    getEditor: function() {return this.cm},
	
	    splitLines: function(str) {
	      if (this.lineSep) { return str.split(this.lineSep) }
	      return splitLinesAuto(str)
	    },
	    lineSeparator: function() { return this.lineSep || "\n" },
	
	    setDirection: docMethodOp(function (dir) {
	      if (dir != "rtl") { dir = "ltr"; }
	      if (dir == this.direction) { return }
	      this.direction = dir;
	      this.iter(function (line) { return line.order = null; });
	      if (this.cm) { directionChanged(this.cm); }
	    })
	  });
	
	  // Public alias.
	  Doc.prototype.eachLine = Doc.prototype.iter;
	
	  // Kludge to work around strange IE behavior where it'll sometimes
	  // re-fire a series of drag-related events right after the drop (#1551)
	  var lastDrop = 0;
	
	  function onDrop(e) {
	    var cm = this;
	    clearDragCursor(cm);
	    if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e))
	      { return }
	    e_preventDefault(e);
	    if (ie) { lastDrop = +new Date; }
	    var pos = posFromMouse(cm, e, true), files = e.dataTransfer.files;
	    if (!pos || cm.isReadOnly()) { return }
	    // Might be a file drop, in which case we simply extract the text
	    // and insert it.
	    if (files && files.length && window.FileReader && window.File) {
	      var n = files.length, text = Array(n), read = 0;
	      var markAsReadAndPasteIfAllFilesAreRead = function () {
	        if (++read == n) {
	          operation(cm, function () {
	            pos = clipPos(cm.doc, pos);
	            var change = {from: pos, to: pos,
	                          text: cm.doc.splitLines(
	                              text.filter(function (t) { return t != null; }).join(cm.doc.lineSeparator())),
	                          origin: "paste"};
	            makeChange(cm.doc, change);
	            setSelectionReplaceHistory(cm.doc, simpleSelection(clipPos(cm.doc, pos), clipPos(cm.doc, changeEnd(change))));
	          })();
	        }
	      };
	      var readTextFromFile = function (file, i) {
	        if (cm.options.allowDropFileTypes &&
	            indexOf(cm.options.allowDropFileTypes, file.type) == -1) {
	          markAsReadAndPasteIfAllFilesAreRead();
	          return
	        }
	        var reader = new FileReader;
	        reader.onerror = function () { return markAsReadAndPasteIfAllFilesAreRead(); };
	        reader.onload = function () {
	          var content = reader.result;
	          if (/[\x00-\x08\x0e-\x1f]{2}/.test(content)) {
	            markAsReadAndPasteIfAllFilesAreRead();
	            return
	          }
	          text[i] = content;
	          markAsReadAndPasteIfAllFilesAreRead();
	        };
	        reader.readAsText(file);
	      };
	      for (var i = 0; i < files.length; i++) { readTextFromFile(files[i], i); }
	    } else { // Normal drop
	      // Don't do a replace if the drop happened inside of the selected text.
	      if (cm.state.draggingText && cm.doc.sel.contains(pos) > -1) {
	        cm.state.draggingText(e);
	        // Ensure the editor is re-focused
	        setTimeout(function () { return cm.display.input.focus(); }, 20);
	        return
	      }
	      try {
	        var text$1 = e.dataTransfer.getData("Text");
	        if (text$1) {
	          var selected;
	          if (cm.state.draggingText && !cm.state.draggingText.copy)
	            { selected = cm.listSelections(); }
	          setSelectionNoUndo(cm.doc, simpleSelection(pos, pos));
	          if (selected) { for (var i$1 = 0; i$1 < selected.length; ++i$1)
	            { replaceRange(cm.doc, "", selected[i$1].anchor, selected[i$1].head, "drag"); } }
	          cm.replaceSelection(text$1, "around", "paste");
	          cm.display.input.focus();
	        }
	      }
	      catch(e$1){}
	    }
	  }
	
	  function onDragStart(cm, e) {
	    if (ie && (!cm.state.draggingText || +new Date - lastDrop < 100)) { e_stop(e); return }
	    if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) { return }
	
	    e.dataTransfer.setData("Text", cm.getSelection());
	    e.dataTransfer.effectAllowed = "copyMove";
	
	    // Use dummy image instead of default browsers image.
	    // Recent Safari (~6.0.2) have a tendency to segfault when this happens, so we don't do it there.
	    if (e.dataTransfer.setDragImage && !safari) {
	      var img = elt("img", null, null, "position: fixed; left: 0; top: 0;");
	      img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
	      if (presto) {
	        img.width = img.height = 1;
	        cm.display.wrapper.appendChild(img);
	        // Force a relayout, or Opera won't use our image for some obscure reason
	        img._top = img.offsetTop;
	      }
	      e.dataTransfer.setDragImage(img, 0, 0);
	      if (presto) { img.parentNode.removeChild(img); }
	    }
	  }
	
	  function onDragOver(cm, e) {
	    var pos = posFromMouse(cm, e);
	    if (!pos) { return }
	    var frag = document.createDocumentFragment();
	    drawSelectionCursor(cm, pos, frag);
	    if (!cm.display.dragCursor) {
	      cm.display.dragCursor = elt("div", null, "CodeMirror-cursors CodeMirror-dragcursors");
	      cm.display.lineSpace.insertBefore(cm.display.dragCursor, cm.display.cursorDiv);
	    }
	    removeChildrenAndAdd(cm.display.dragCursor, frag);
	  }
	
	  function clearDragCursor(cm) {
	    if (cm.display.dragCursor) {
	      cm.display.lineSpace.removeChild(cm.display.dragCursor);
	      cm.display.dragCursor = null;
	    }
	  }
	
	  // These must be handled carefully, because naively registering a
	  // handler for each editor will cause the editors to never be
	  // garbage collected.
	
	  function forEachCodeMirror(f) {
	    if (!document.getElementsByClassName) { return }
	    var byClass = document.getElementsByClassName("CodeMirror"), editors = [];
	    for (var i = 0; i < byClass.length; i++) {
	      var cm = byClass[i].CodeMirror;
	      if (cm) { editors.push(cm); }
	    }
	    if (editors.length) { editors[0].operation(function () {
	      for (var i = 0; i < editors.length; i++) { f(editors[i]); }
	    }); }
	  }
	
	  var globalsRegistered = false;
	  function ensureGlobalHandlers() {
	    if (globalsRegistered) { return }
	    registerGlobalHandlers();
	    globalsRegistered = true;
	  }
	  function registerGlobalHandlers() {
	    // When the window resizes, we need to refresh active editors.
	    var resizeTimer;
	    on(window, "resize", function () {
	      if (resizeTimer == null) { resizeTimer = setTimeout(function () {
	        resizeTimer = null;
	        forEachCodeMirror(onResize);
	      }, 100); }
	    });
	    // When the window loses focus, we want to show the editor as blurred
	    on(window, "blur", function () { return forEachCodeMirror(onBlur); });
	  }
	  // Called when the window resizes
	  function onResize(cm) {
	    var d = cm.display;
	    // Might be a text scaling operation, clear size caches.
	    d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
	    d.scrollbarsClipped = false;
	    cm.setSize();
	  }
	
	  var keyNames = {
	    3: "Pause", 8: "Backspace", 9: "Tab", 13: "Enter", 16: "Shift", 17: "Ctrl", 18: "Alt",
	    19: "Pause", 20: "CapsLock", 27: "Esc", 32: "Space", 33: "PageUp", 34: "PageDown", 35: "End",
	    36: "Home", 37: "Left", 38: "Up", 39: "Right", 40: "Down", 44: "PrintScrn", 45: "Insert",
	    46: "Delete", 59: ";", 61: "=", 91: "Mod", 92: "Mod", 93: "Mod",
	    106: "*", 107: "=", 109: "-", 110: ".", 111: "/", 145: "ScrollLock",
	    173: "-", 186: ";", 187: "=", 188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\",
	    221: "]", 222: "'", 224: "Mod", 63232: "Up", 63233: "Down", 63234: "Left", 63235: "Right", 63272: "Delete",
	    63273: "Home", 63275: "End", 63276: "PageUp", 63277: "PageDown", 63302: "Insert"
	  };
	
	  // Number keys
	  for (var i = 0; i < 10; i++) { keyNames[i + 48] = keyNames[i + 96] = String(i); }
	  // Alphabetic keys
	  for (var i$1 = 65; i$1 <= 90; i$1++) { keyNames[i$1] = String.fromCharCode(i$1); }
	  // Function keys
	  for (var i$2 = 1; i$2 <= 12; i$2++) { keyNames[i$2 + 111] = keyNames[i$2 + 63235] = "F" + i$2; }
	
	  var keyMap = {};
	
	  keyMap.basic = {
	    "Left": "goCharLeft", "Right": "goCharRight", "Up": "goLineUp", "Down": "goLineDown",
	    "End": "goLineEnd", "Home": "goLineStartSmart", "PageUp": "goPageUp", "PageDown": "goPageDown",
	    "Delete": "delCharAfter", "Backspace": "delCharBefore", "Shift-Backspace": "delCharBefore",
	    "Tab": "defaultTab", "Shift-Tab": "indentAuto",
	    "Enter": "newlineAndIndent", "Insert": "toggleOverwrite",
	    "Esc": "singleSelection"
	  };
	  // Note that the save and find-related commands aren't defined by
	  // default. User code or addons can define them. Unknown commands
	  // are simply ignored.
	  keyMap.pcDefault = {
	    "Ctrl-A": "selectAll", "Ctrl-D": "deleteLine", "Ctrl-Z": "undo", "Shift-Ctrl-Z": "redo", "Ctrl-Y": "redo",
	    "Ctrl-Home": "goDocStart", "Ctrl-End": "goDocEnd", "Ctrl-Up": "goLineUp", "Ctrl-Down": "goLineDown",
	    "Ctrl-Left": "goGroupLeft", "Ctrl-Right": "goGroupRight", "Alt-Left": "goLineStart", "Alt-Right": "goLineEnd",
	    "Ctrl-Backspace": "delGroupBefore", "Ctrl-Delete": "delGroupAfter", "Ctrl-S": "save", "Ctrl-F": "find",
	    "Ctrl-G": "findNext", "Shift-Ctrl-G": "findPrev", "Shift-Ctrl-F": "replace", "Shift-Ctrl-R": "replaceAll",
	    "Ctrl-[": "indentLess", "Ctrl-]": "indentMore",
	    "Ctrl-U": "undoSelection", "Shift-Ctrl-U": "redoSelection", "Alt-U": "redoSelection",
	    "fallthrough": "basic"
	  };
	  // Very basic readline/emacs-style bindings, which are standard on Mac.
	  keyMap.emacsy = {
	    "Ctrl-F": "goCharRight", "Ctrl-B": "goCharLeft", "Ctrl-P": "goLineUp", "Ctrl-N": "goLineDown",
	    "Ctrl-A": "goLineStart", "Ctrl-E": "goLineEnd", "Ctrl-V": "goPageDown", "Shift-Ctrl-V": "goPageUp",
	    "Ctrl-D": "delCharAfter", "Ctrl-H": "delCharBefore", "Alt-Backspace": "delWordBefore", "Ctrl-K": "killLine",
	    "Ctrl-T": "transposeChars", "Ctrl-O": "openLine"
	  };
	  keyMap.macDefault = {
	    "Cmd-A": "selectAll", "Cmd-D": "deleteLine", "Cmd-Z": "undo", "Shift-Cmd-Z": "redo", "Cmd-Y": "redo",
	    "Cmd-Home": "goDocStart", "Cmd-Up": "goDocStart", "Cmd-End": "goDocEnd", "Cmd-Down": "goDocEnd", "Alt-Left": "goGroupLeft",
	    "Alt-Right": "goGroupRight", "Cmd-Left": "goLineLeft", "Cmd-Right": "goLineRight", "Alt-Backspace": "delGroupBefore",
	    "Ctrl-Alt-Backspace": "delGroupAfter", "Alt-Delete": "delGroupAfter", "Cmd-S": "save", "Cmd-F": "find",
	    "Cmd-G": "findNext", "Shift-Cmd-G": "findPrev", "Cmd-Alt-F": "replace", "Shift-Cmd-Alt-F": "replaceAll",
	    "Cmd-[": "indentLess", "Cmd-]": "indentMore", "Cmd-Backspace": "delWrappedLineLeft", "Cmd-Delete": "delWrappedLineRight",
	    "Cmd-U": "undoSelection", "Shift-Cmd-U": "redoSelection", "Ctrl-Up": "goDocStart", "Ctrl-Down": "goDocEnd",
	    "fallthrough": ["basic", "emacsy"]
	  };
	  keyMap["default"] = mac ? keyMap.macDefault : keyMap.pcDefault;
	
	  // KEYMAP DISPATCH
	
	  function normalizeKeyName(name) {
	    var parts = name.split(/-(?!$)/);
	    name = parts[parts.length - 1];
	    var alt, ctrl, shift, cmd;
	    for (var i = 0; i < parts.length - 1; i++) {
	      var mod = parts[i];
	      if (/^(cmd|meta|m)$/i.test(mod)) { cmd = true; }
	      else if (/^a(lt)?$/i.test(mod)) { alt = true; }
	      else if (/^(c|ctrl|control)$/i.test(mod)) { ctrl = true; }
	      else if (/^s(hift)?$/i.test(mod)) { shift = true; }
	      else { throw new Error("Unrecognized modifier name: " + mod) }
	    }
	    if (alt) { name = "Alt-" + name; }
	    if (ctrl) { name = "Ctrl-" + name; }
	    if (cmd) { name = "Cmd-" + name; }
	    if (shift) { name = "Shift-" + name; }
	    return name
	  }
	
	  // This is a kludge to keep keymaps mostly working as raw objects
	  // (backwards compatibility) while at the same time support features
	  // like normalization and multi-stroke key bindings. It compiles a
	  // new normalized keymap, and then updates the old object to reflect
	  // this.
	  function normalizeKeyMap(keymap) {
	    var copy = {};
	    for (var keyname in keymap) { if (keymap.hasOwnProperty(keyname)) {
	      var value = keymap[keyname];
	      if (/^(name|fallthrough|(de|at)tach)$/.test(keyname)) { continue }
	      if (value == "...") { delete keymap[keyname]; continue }
	
	      var keys = map(keyname.split(" "), normalizeKeyName);
	      for (var i = 0; i < keys.length; i++) {
	        var val = (void 0), name = (void 0);
	        if (i == keys.length - 1) {
	          name = keys.join(" ");
	          val = value;
	        } else {
	          name = keys.slice(0, i + 1).join(" ");
	          val = "...";
	        }
	        var prev = copy[name];
	        if (!prev) { copy[name] = val; }
	        else if (prev != val) { throw new Error("Inconsistent bindings for " + name) }
	      }
	      delete keymap[keyname];
	    } }
	    for (var prop in copy) { keymap[prop] = copy[prop]; }
	    return keymap
	  }
	
	  function lookupKey(key, map, handle, context) {
	    map = getKeyMap(map);
	    var found = map.call ? map.call(key, context) : map[key];
	    if (found === false) { return "nothing" }
	    if (found === "...") { return "multi" }
	    if (found != null && handle(found)) { return "handled" }
	
	    if (map.fallthrough) {
	      if (Object.prototype.toString.call(map.fallthrough) != "[object Array]")
	        { return lookupKey(key, map.fallthrough, handle, context) }
	      for (var i = 0; i < map.fallthrough.length; i++) {
	        var result = lookupKey(key, map.fallthrough[i], handle, context);
	        if (result) { return result }
	      }
	    }
	  }
	
	  // Modifier key presses don't count as 'real' key presses for the
	  // purpose of keymap fallthrough.
	  function isModifierKey(value) {
	    var name = typeof value == "string" ? value : keyNames[value.keyCode];
	    return name == "Ctrl" || name == "Alt" || name == "Shift" || name == "Mod"
	  }
	
	  function addModifierNames(name, event, noShift) {
	    var base = name;
	    if (event.altKey && base != "Alt") { name = "Alt-" + name; }
	    if ((flipCtrlCmd ? event.metaKey : event.ctrlKey) && base != "Ctrl") { name = "Ctrl-" + name; }
	    if ((flipCtrlCmd ? event.ctrlKey : event.metaKey) && base != "Mod") { name = "Cmd-" + name; }
	    if (!noShift && event.shiftKey && base != "Shift") { name = "Shift-" + name; }
	    return name
	  }
	
	  // Look up the name of a key as indicated by an event object.
	  function keyName(event, noShift) {
	    if (presto && event.keyCode == 34 && event["char"]) { return false }
	    var name = keyNames[event.keyCode];
	    if (name == null || event.altGraphKey) { return false }
	    // Ctrl-ScrollLock has keyCode 3, same as Ctrl-Pause,
	    // so we'll use event.code when available (Chrome 48+, FF 38+, Safari 10.1+)
	    if (event.keyCode == 3 && event.code) { name = event.code; }
	    return addModifierNames(name, event, noShift)
	  }
	
	  function getKeyMap(val) {
	    return typeof val == "string" ? keyMap[val] : val
	  }
	
	  // Helper for deleting text near the selection(s), used to implement
	  // backspace, delete, and similar functionality.
	  function deleteNearSelection(cm, compute) {
	    var ranges = cm.doc.sel.ranges, kill = [];
	    // Build up a set of ranges to kill first, merging overlapping
	    // ranges.
	    for (var i = 0; i < ranges.length; i++) {
	      var toKill = compute(ranges[i]);
	      while (kill.length && cmp(toKill.from, lst(kill).to) <= 0) {
	        var replaced = kill.pop();
	        if (cmp(replaced.from, toKill.from) < 0) {
	          toKill.from = replaced.from;
	          break
	        }
	      }
	      kill.push(toKill);
	    }
	    // Next, remove those actual ranges.
	    runInOp(cm, function () {
	      for (var i = kill.length - 1; i >= 0; i--)
	        { replaceRange(cm.doc, "", kill[i].from, kill[i].to, "+delete"); }
	      ensureCursorVisible(cm);
	    });
	  }
	
	  function moveCharLogically(line, ch, dir) {
	    var target = skipExtendingChars(line.text, ch + dir, dir);
	    return target < 0 || target > line.text.length ? null : target
	  }
	
	  function moveLogically(line, start, dir) {
	    var ch = moveCharLogically(line, start.ch, dir);
	    return ch == null ? null : new Pos(start.line, ch, dir < 0 ? "after" : "before")
	  }
	
	  function endOfLine(visually, cm, lineObj, lineNo, dir) {
	    if (visually) {
	      if (cm.doc.direction == "rtl") { dir = -dir; }
	      var order = getOrder(lineObj, cm.doc.direction);
	      if (order) {
	        var part = dir < 0 ? lst(order) : order[0];
	        var moveInStorageOrder = (dir < 0) == (part.level == 1);
	        var sticky = moveInStorageOrder ? "after" : "before";
	        var ch;
	        // With a wrapped rtl chunk (possibly spanning multiple bidi parts),
	        // it could be that the last bidi part is not on the last visual line,
	        // since visual lines contain content order-consecutive chunks.
	        // Thus, in rtl, we are looking for the first (content-order) character
	        // in the rtl chunk that is on the last line (that is, the same line
	        // as the last (content-order) character).
	        if (part.level > 0 || cm.doc.direction == "rtl") {
	          var prep = prepareMeasureForLine(cm, lineObj);
	          ch = dir < 0 ? lineObj.text.length - 1 : 0;
	          var targetTop = measureCharPrepared(cm, prep, ch).top;
	          ch = findFirst(function (ch) { return measureCharPrepared(cm, prep, ch).top == targetTop; }, (dir < 0) == (part.level == 1) ? part.from : part.to - 1, ch);
	          if (sticky == "before") { ch = moveCharLogically(lineObj, ch, 1); }
	        } else { ch = dir < 0 ? part.to : part.from; }
	        return new Pos(lineNo, ch, sticky)
	      }
	    }
	    return new Pos(lineNo, dir < 0 ? lineObj.text.length : 0, dir < 0 ? "before" : "after")
	  }
	
	  function moveVisually(cm, line, start, dir) {
	    var bidi = getOrder(line, cm.doc.direction);
	    if (!bidi) { return moveLogically(line, start, dir) }
	    if (start.ch >= line.text.length) {
	      start.ch = line.text.length;
	      start.sticky = "before";
	    } else if (start.ch <= 0) {
	      start.ch = 0;
	      start.sticky = "after";
	    }
	    var partPos = getBidiPartAt(bidi, start.ch, start.sticky), part = bidi[partPos];
	    if (cm.doc.direction == "ltr" && part.level % 2 == 0 && (dir > 0 ? part.to > start.ch : part.from < start.ch)) {
	      // Case 1: We move within an ltr part in an ltr editor. Even with wrapped lines,
	      // nothing interesting happens.
	      return moveLogically(line, start, dir)
	    }
	
	    var mv = function (pos, dir) { return moveCharLogically(line, pos instanceof Pos ? pos.ch : pos, dir); };
	    var prep;
	    var getWrappedLineExtent = function (ch) {
	      if (!cm.options.lineWrapping) { return {begin: 0, end: line.text.length} }
	      prep = prep || prepareMeasureForLine(cm, line);
	      return wrappedLineExtentChar(cm, line, prep, ch)
	    };
	    var wrappedLineExtent = getWrappedLineExtent(start.sticky == "before" ? mv(start, -1) : start.ch);
	
	    if (cm.doc.direction == "rtl" || part.level == 1) {
	      var moveInStorageOrder = (part.level == 1) == (dir < 0);
	      var ch = mv(start, moveInStorageOrder ? 1 : -1);
	      if (ch != null && (!moveInStorageOrder ? ch >= part.from && ch >= wrappedLineExtent.begin : ch <= part.to && ch <= wrappedLineExtent.end)) {
	        // Case 2: We move within an rtl part or in an rtl editor on the same visual line
	        var sticky = moveInStorageOrder ? "before" : "after";
	        return new Pos(start.line, ch, sticky)
	      }
	    }
	
	    // Case 3: Could not move within this bidi part in this visual line, so leave
	    // the current bidi part
	
	    var searchInVisualLine = function (partPos, dir, wrappedLineExtent) {
	      var getRes = function (ch, moveInStorageOrder) { return moveInStorageOrder
	        ? new Pos(start.line, mv(ch, 1), "before")
	        : new Pos(start.line, ch, "after"); };
	
	      for (; partPos >= 0 && partPos < bidi.length; partPos += dir) {
	        var part = bidi[partPos];
	        var moveInStorageOrder = (dir > 0) == (part.level != 1);
	        var ch = moveInStorageOrder ? wrappedLineExtent.begin : mv(wrappedLineExtent.end, -1);
	        if (part.from <= ch && ch < part.to) { return getRes(ch, moveInStorageOrder) }
	        ch = moveInStorageOrder ? part.from : mv(part.to, -1);
	        if (wrappedLineExtent.begin <= ch && ch < wrappedLineExtent.end) { return getRes(ch, moveInStorageOrder) }
	      }
	    };
	
	    // Case 3a: Look for other bidi parts on the same visual line
	    var res = searchInVisualLine(partPos + dir, dir, wrappedLineExtent);
	    if (res) { return res }
	
	    // Case 3b: Look for other bidi parts on the next visual line
	    var nextCh = dir > 0 ? wrappedLineExtent.end : mv(wrappedLineExtent.begin, -1);
	    if (nextCh != null && !(dir > 0 && nextCh == line.text.length)) {
	      res = searchInVisualLine(dir > 0 ? 0 : bidi.length - 1, dir, getWrappedLineExtent(nextCh));
	      if (res) { return res }
	    }
	
	    // Case 4: Nowhere to move
	    return null
	  }
	
	  // Commands are parameter-less actions that can be performed on an
	  // editor, mostly used for keybindings.
	  var commands = {
	    selectAll: selectAll,
	    singleSelection: function (cm) { return cm.setSelection(cm.getCursor("anchor"), cm.getCursor("head"), sel_dontScroll); },
	    killLine: function (cm) { return deleteNearSelection(cm, function (range) {
	      if (range.empty()) {
	        var len = getLine(cm.doc, range.head.line).text.length;
	        if (range.head.ch == len && range.head.line < cm.lastLine())
	          { return {from: range.head, to: Pos(range.head.line + 1, 0)} }
	        else
	          { return {from: range.head, to: Pos(range.head.line, len)} }
	      } else {
	        return {from: range.from(), to: range.to()}
	      }
	    }); },
	    deleteLine: function (cm) { return deleteNearSelection(cm, function (range) { return ({
	      from: Pos(range.from().line, 0),
	      to: clipPos(cm.doc, Pos(range.to().line + 1, 0))
	    }); }); },
	    delLineLeft: function (cm) { return deleteNearSelection(cm, function (range) { return ({
	      from: Pos(range.from().line, 0), to: range.from()
	    }); }); },
	    delWrappedLineLeft: function (cm) { return deleteNearSelection(cm, function (range) {
	      var top = cm.charCoords(range.head, "div").top + 5;
	      var leftPos = cm.coordsChar({left: 0, top: top}, "div");
	      return {from: leftPos, to: range.from()}
	    }); },
	    delWrappedLineRight: function (cm) { return deleteNearSelection(cm, function (range) {
	      var top = cm.charCoords(range.head, "div").top + 5;
	      var rightPos = cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div");
	      return {from: range.from(), to: rightPos }
	    }); },
	    undo: function (cm) { return cm.undo(); },
	    redo: function (cm) { return cm.redo(); },
	    undoSelection: function (cm) { return cm.undoSelection(); },
	    redoSelection: function (cm) { return cm.redoSelection(); },
	    goDocStart: function (cm) { return cm.extendSelection(Pos(cm.firstLine(), 0)); },
	    goDocEnd: function (cm) { return cm.extendSelection(Pos(cm.lastLine())); },
	    goLineStart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStart(cm, range.head.line); },
	      {origin: "+move", bias: 1}
	    ); },
	    goLineStartSmart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStartSmart(cm, range.head); },
	      {origin: "+move", bias: 1}
	    ); },
	    goLineEnd: function (cm) { return cm.extendSelectionsBy(function (range) { return lineEnd(cm, range.head.line); },
	      {origin: "+move", bias: -1}
	    ); },
	    goLineRight: function (cm) { return cm.extendSelectionsBy(function (range) {
	      var top = cm.cursorCoords(range.head, "div").top + 5;
	      return cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div")
	    }, sel_move); },
	    goLineLeft: function (cm) { return cm.extendSelectionsBy(function (range) {
	      var top = cm.cursorCoords(range.head, "div").top + 5;
	      return cm.coordsChar({left: 0, top: top}, "div")
	    }, sel_move); },
	    goLineLeftSmart: function (cm) { return cm.extendSelectionsBy(function (range) {
	      var top = cm.cursorCoords(range.head, "div").top + 5;
	      var pos = cm.coordsChar({left: 0, top: top}, "div");
	      if (pos.ch < cm.getLine(pos.line).search(/\S/)) { return lineStartSmart(cm, range.head) }
	      return pos
	    }, sel_move); },
	    goLineUp: function (cm) { return cm.moveV(-1, "line"); },
	    goLineDown: function (cm) { return cm.moveV(1, "line"); },
	    goPageUp: function (cm) { return cm.moveV(-1, "page"); },
	    goPageDown: function (cm) { return cm.moveV(1, "page"); },
	    goCharLeft: function (cm) { return cm.moveH(-1, "char"); },
	    goCharRight: function (cm) { return cm.moveH(1, "char"); },
	    goColumnLeft: function (cm) { return cm.moveH(-1, "column"); },
	    goColumnRight: function (cm) { return cm.moveH(1, "column"); },
	    goWordLeft: function (cm) { return cm.moveH(-1, "word"); },
	    goGroupRight: function (cm) { return cm.moveH(1, "group"); },
	    goGroupLeft: function (cm) { return cm.moveH(-1, "group"); },
	    goWordRight: function (cm) { return cm.moveH(1, "word"); },
	    delCharBefore: function (cm) { return cm.deleteH(-1, "codepoint"); },
	    delCharAfter: function (cm) { return cm.deleteH(1, "char"); },
	    delWordBefore: function (cm) { return cm.deleteH(-1, "word"); },
	    delWordAfter: function (cm) { return cm.deleteH(1, "word"); },
	    delGroupBefore: function (cm) { return cm.deleteH(-1, "group"); },
	    delGroupAfter: function (cm) { return cm.deleteH(1, "group"); },
	    indentAuto: function (cm) { return cm.indentSelection("smart"); },
	    indentMore: function (cm) { return cm.indentSelection("add"); },
	    indentLess: function (cm) { return cm.indentSelection("subtract"); },
	    insertTab: function (cm) { return cm.replaceSelection("\t"); },
	    insertSoftTab: function (cm) {
	      var spaces = [], ranges = cm.listSelections(), tabSize = cm.options.tabSize;
	      for (var i = 0; i < ranges.length; i++) {
	        var pos = ranges[i].from();
	        var col = countColumn(cm.getLine(pos.line), pos.ch, tabSize);
	        spaces.push(spaceStr(tabSize - col % tabSize));
	      }
	      cm.replaceSelections(spaces);
	    },
	    defaultTab: function (cm) {
	      if (cm.somethingSelected()) { cm.indentSelection("add"); }
	      else { cm.execCommand("insertTab"); }
	    },
	    // Swap the two chars left and right of each selection's head.
	    // Move cursor behind the two swapped characters afterwards.
	    //
	    // Doesn't consider line feeds a character.
	    // Doesn't scan more than one line above to find a character.
	    // Doesn't do anything on an empty line.
	    // Doesn't do anything with non-empty selections.
	    transposeChars: function (cm) { return runInOp(cm, function () {
	      var ranges = cm.listSelections(), newSel = [];
	      for (var i = 0; i < ranges.length; i++) {
	        if (!ranges[i].empty()) { continue }
	        var cur = ranges[i].head, line = getLine(cm.doc, cur.line).text;
	        if (line) {
	          if (cur.ch == line.length) { cur = new Pos(cur.line, cur.ch - 1); }
	          if (cur.ch > 0) {
	            cur = new Pos(cur.line, cur.ch + 1);
	            cm.replaceRange(line.charAt(cur.ch - 1) + line.charAt(cur.ch - 2),
	                            Pos(cur.line, cur.ch - 2), cur, "+transpose");
	          } else if (cur.line > cm.doc.first) {
	            var prev = getLine(cm.doc, cur.line - 1).text;
	            if (prev) {
	              cur = new Pos(cur.line, 1);
	              cm.replaceRange(line.charAt(0) + cm.doc.lineSeparator() +
	                              prev.charAt(prev.length - 1),
	                              Pos(cur.line - 1, prev.length - 1), cur, "+transpose");
	            }
	          }
	        }
	        newSel.push(new Range(cur, cur));
	      }
	      cm.setSelections(newSel);
	    }); },
	    newlineAndIndent: function (cm) { return runInOp(cm, function () {
	      var sels = cm.listSelections();
	      for (var i = sels.length - 1; i >= 0; i--)
	        { cm.replaceRange(cm.doc.lineSeparator(), sels[i].anchor, sels[i].head, "+input"); }
	      sels = cm.listSelections();
	      for (var i$1 = 0; i$1 < sels.length; i$1++)
	        { cm.indentLine(sels[i$1].from().line, null, true); }
	      ensureCursorVisible(cm);
	    }); },
	    openLine: function (cm) { return cm.replaceSelection("\n", "start"); },
	    toggleOverwrite: function (cm) { return cm.toggleOverwrite(); }
	  };
	
	
	  function lineStart(cm, lineN) {
	    var line = getLine(cm.doc, lineN);
	    var visual = visualLine(line);
	    if (visual != line) { lineN = lineNo(visual); }
	    return endOfLine(true, cm, visual, lineN, 1)
	  }
	  function lineEnd(cm, lineN) {
	    var line = getLine(cm.doc, lineN);
	    var visual = visualLineEnd(line);
	    if (visual != line) { lineN = lineNo(visual); }
	    return endOfLine(true, cm, line, lineN, -1)
	  }
	  function lineStartSmart(cm, pos) {
	    var start = lineStart(cm, pos.line);
	    var line = getLine(cm.doc, start.line);
	    var order = getOrder(line, cm.doc.direction);
	    if (!order || order[0].level == 0) {
	      var firstNonWS = Math.max(start.ch, line.text.search(/\S/));
	      var inWS = pos.line == start.line && pos.ch <= firstNonWS && pos.ch;
	      return Pos(start.line, inWS ? 0 : firstNonWS, start.sticky)
	    }
	    return start
	  }
	
	  // Run a handler that was bound to a key.
	  function doHandleBinding(cm, bound, dropShift) {
	    if (typeof bound == "string") {
	      bound = commands[bound];
	      if (!bound) { return false }
	    }
	    // Ensure previous input has been read, so that the handler sees a
	    // consistent view of the document
	    cm.display.input.ensurePolled();
	    var prevShift = cm.display.shift, done = false;
	    try {
	      if (cm.isReadOnly()) { cm.state.suppressEdits = true; }
	      if (dropShift) { cm.display.shift = false; }
	      done = bound(cm) != Pass;
	    } finally {
	      cm.display.shift = prevShift;
	      cm.state.suppressEdits = false;
	    }
	    return done
	  }
	
	  function lookupKeyForEditor(cm, name, handle) {
	    for (var i = 0; i < cm.state.keyMaps.length; i++) {
	      var result = lookupKey(name, cm.state.keyMaps[i], handle, cm);
	      if (result) { return result }
	    }
	    return (cm.options.extraKeys && lookupKey(name, cm.options.extraKeys, handle, cm))
	      || lookupKey(name, cm.options.keyMap, handle, cm)
	  }
	
	  // Note that, despite the name, this function is also used to check
	  // for bound mouse clicks.
	
	  var stopSeq = new Delayed;
	
	  function dispatchKey(cm, name, e, handle) {
	    var seq = cm.state.keySeq;
	    if (seq) {
	      if (isModifierKey(name)) { return "handled" }
	      if (/\'$/.test(name))
	        { cm.state.keySeq = null; }
	      else
	        { stopSeq.set(50, function () {
	          if (cm.state.keySeq == seq) {
	            cm.state.keySeq = null;
	            cm.display.input.reset();
	          }
	        }); }
	      if (dispatchKeyInner(cm, seq + " " + name, e, handle)) { return true }
	    }
	    return dispatchKeyInner(cm, name, e, handle)
	  }
	
	  function dispatchKeyInner(cm, name, e, handle) {
	    var result = lookupKeyForEditor(cm, name, handle);
	
	    if (result == "multi")
	      { cm.state.keySeq = name; }
	    if (result == "handled")
	      { signalLater(cm, "keyHandled", cm, name, e); }
	
	    if (result == "handled" || result == "multi") {
	      e_preventDefault(e);
	      restartBlink(cm);
	    }
	
	    return !!result
	  }
	
	  // Handle a key from the keydown event.
	  function handleKeyBinding(cm, e) {
	    var name = keyName(e, true);
	    if (!name) { return false }
	
	    if (e.shiftKey && !cm.state.keySeq) {
	      // First try to resolve full name (including 'Shift-'). Failing
	      // that, see if there is a cursor-motion command (starting with
	      // 'go') bound to the keyname without 'Shift-'.
	      return dispatchKey(cm, "Shift-" + name, e, function (b) { return doHandleBinding(cm, b, true); })
	          || dispatchKey(cm, name, e, function (b) {
	               if (typeof b == "string" ? /^go[A-Z]/.test(b) : b.motion)
	                 { return doHandleBinding(cm, b) }
	             })
	    } else {
	      return dispatchKey(cm, name, e, function (b) { return doHandleBinding(cm, b); })
	    }
	  }
	
	  // Handle a key from the keypress event
	  function handleCharBinding(cm, e, ch) {
	    return dispatchKey(cm, "'" + ch + "'", e, function (b) { return doHandleBinding(cm, b, true); })
	  }
	
	  var lastStoppedKey = null;
	  function onKeyDown(e) {
	    var cm = this;
	    if (e.target && e.target != cm.display.input.getField()) { return }
	    cm.curOp.focus = activeElt();
	    if (signalDOMEvent(cm, e)) { return }
	    // IE does strange things with escape.
	    if (ie && ie_version < 11 && e.keyCode == 27) { e.returnValue = false; }
	    var code = e.keyCode;
	    cm.display.shift = code == 16 || e.shiftKey;
	    var handled = handleKeyBinding(cm, e);
	    if (presto) {
	      lastStoppedKey = handled ? code : null;
	      // Opera has no cut event... we try to at least catch the key combo
	      if (!handled && code == 88 && !hasCopyEvent && (mac ? e.metaKey : e.ctrlKey))
	        { cm.replaceSelection("", null, "cut"); }
	    }
	    if (gecko && !mac && !handled && code == 46 && e.shiftKey && !e.ctrlKey && document.execCommand)
	      { document.execCommand("cut"); }
	
	    // Turn mouse into crosshair when Alt is held on Mac.
	    if (code == 18 && !/\bCodeMirror-crosshair\b/.test(cm.display.lineDiv.className))
	      { showCrossHair(cm); }
	  }
	
	  function showCrossHair(cm) {
	    var lineDiv = cm.display.lineDiv;
	    addClass(lineDiv, "CodeMirror-crosshair");
	
	    function up(e) {
	      if (e.keyCode == 18 || !e.altKey) {
	        rmClass(lineDiv, "CodeMirror-crosshair");
	        off(document, "keyup", up);
	        off(document, "mouseover", up);
	      }
	    }
	    on(document, "keyup", up);
	    on(document, "mouseover", up);
	  }
	
	  function onKeyUp(e) {
	    if (e.keyCode == 16) { this.doc.sel.shift = false; }
	    signalDOMEvent(this, e);
	  }
	
	  function onKeyPress(e) {
	    var cm = this;
	    if (e.target && e.target != cm.display.input.getField()) { return }
	    if (eventInWidget(cm.display, e) || signalDOMEvent(cm, e) || e.ctrlKey && !e.altKey || mac && e.metaKey) { return }
	    var keyCode = e.keyCode, charCode = e.charCode;
	    if (presto && keyCode == lastStoppedKey) {lastStoppedKey = null; e_preventDefault(e); return}
	    if ((presto && (!e.which || e.which < 10)) && handleKeyBinding(cm, e)) { return }
	    var ch = String.fromCharCode(charCode == null ? keyCode : charCode);
	    // Some browsers fire keypress events for backspace
	    if (ch == "\x08") { return }
	    if (handleCharBinding(cm, e, ch)) { return }
	    cm.display.input.onKeyPress(e);
	  }
	
	  var DOUBLECLICK_DELAY = 400;
	
	  var PastClick = function(time, pos, button) {
	    this.time = time;
	    this.pos = pos;
	    this.button = button;
	  };
	
	  PastClick.prototype.compare = function (time, pos, button) {
	    return this.time + DOUBLECLICK_DELAY > time &&
	      cmp(pos, this.pos) == 0 && button == this.button
	  };
	
	  var lastClick, lastDoubleClick;
	  function clickRepeat(pos, button) {
	    var now = +new Date;
	    if (lastDoubleClick && lastDoubleClick.compare(now, pos, button)) {
	      lastClick = lastDoubleClick = null;
	      return "triple"
	    } else if (lastClick && lastClick.compare(now, pos, button)) {
	      lastDoubleClick = new PastClick(now, pos, button);
	      lastClick = null;
	      return "double"
	    } else {
	      lastClick = new PastClick(now, pos, button);
	      lastDoubleClick = null;
	      return "single"
	    }
	  }
	
	  // A mouse down can be a single click, double click, triple click,
	  // start of selection drag, start of text drag, new cursor
	  // (ctrl-click), rectangle drag (alt-drag), or xwin
	  // middle-click-paste. Or it might be a click on something we should
	  // not interfere with, such as a scrollbar or widget.
	  function onMouseDown(e) {
	    var cm = this, display = cm.display;
	    if (signalDOMEvent(cm, e) || display.activeTouch && display.input.supportsTouch()) { return }
	    display.input.ensurePolled();
	    display.shift = e.shiftKey;
	
	    if (eventInWidget(display, e)) {
	      if (!webkit) {
	        // Briefly turn off draggability, to allow widgets to do
	        // normal dragging things.
	        display.scroller.draggable = false;
	        setTimeout(function () { return display.scroller.draggable = true; }, 100);
	      }
	      return
	    }
	    if (clickInGutter(cm, e)) { return }
	    var pos = posFromMouse(cm, e), button = e_button(e), repeat = pos ? clickRepeat(pos, button) : "single";
	    window.focus();
	
	    // #3261: make sure, that we're not starting a second selection
	    if (button == 1 && cm.state.selectingText)
	      { cm.state.selectingText(e); }
	
	    if (pos && handleMappedButton(cm, button, pos, repeat, e)) { return }
	
	    if (button == 1) {
	      if (pos) { leftButtonDown(cm, pos, repeat, e); }
	      else if (e_target(e) == display.scroller) { e_preventDefault(e); }
	    } else if (button == 2) {
	      if (pos) { extendSelection(cm.doc, pos); }
	      setTimeout(function () { return display.input.focus(); }, 20);
	    } else if (button == 3) {
	      if (captureRightClick) { cm.display.input.onContextMenu(e); }
	      else { delayBlurEvent(cm); }
	    }
	  }
	
	  function handleMappedButton(cm, button, pos, repeat, event) {
	    var name = "Click";
	    if (repeat == "double") { name = "Double" + name; }
	    else if (repeat == "triple") { name = "Triple" + name; }
	    name = (button == 1 ? "Left" : button == 2 ? "Middle" : "Right") + name;
	
	    return dispatchKey(cm,  addModifierNames(name, event), event, function (bound) {
	      if (typeof bound == "string") { bound = commands[bound]; }
	      if (!bound) { return false }
	      var done = false;
	      try {
	        if (cm.isReadOnly()) { cm.state.suppressEdits = true; }
	        done = bound(cm, pos) != Pass;
	      } finally {
	        cm.state.suppressEdits = false;
	      }
	      return done
	    })
	  }
	
	  function configureMouse(cm, repeat, event) {
	    var option = cm.getOption("configureMouse");
	    var value = option ? option(cm, repeat, event) : {};
	    if (value.unit == null) {
	      var rect = chromeOS ? event.shiftKey && event.metaKey : event.altKey;
	      value.unit = rect ? "rectangle" : repeat == "single" ? "char" : repeat == "double" ? "word" : "line";
	    }
	    if (value.extend == null || cm.doc.extend) { value.extend = cm.doc.extend || event.shiftKey; }
	    if (value.addNew == null) { value.addNew = mac ? event.metaKey : event.ctrlKey; }
	    if (value.moveOnDrag == null) { value.moveOnDrag = !(mac ? event.altKey : event.ctrlKey); }
	    return value
	  }
	
	  function leftButtonDown(cm, pos, repeat, event) {
	    if (ie) { setTimeout(bind(ensureFocus, cm), 0); }
	    else { cm.curOp.focus = activeElt(); }
	
	    var behavior = configureMouse(cm, repeat, event);
	
	    var sel = cm.doc.sel, contained;
	    if (cm.options.dragDrop && dragAndDrop && !cm.isReadOnly() &&
	        repeat == "single" && (contained = sel.contains(pos)) > -1 &&
	        (cmp((contained = sel.ranges[contained]).from(), pos) < 0 || pos.xRel > 0) &&
	        (cmp(contained.to(), pos) > 0 || pos.xRel < 0))
	      { leftButtonStartDrag(cm, event, pos, behavior); }
	    else
	      { leftButtonSelect(cm, event, pos, behavior); }
	  }
	
	  // Start a text drag. When it ends, see if any dragging actually
	  // happen, and treat as a click if it didn't.
	  function leftButtonStartDrag(cm, event, pos, behavior) {
	    var display = cm.display, moved = false;
	    var dragEnd = operation(cm, function (e) {
	      if (webkit) { display.scroller.draggable = false; }
	      cm.state.draggingText = false;
	      if (cm.state.delayingBlurEvent) {
	        if (cm.hasFocus()) { cm.state.delayingBlurEvent = false; }
	        else { delayBlurEvent(cm); }
	      }
	      off(display.wrapper.ownerDocument, "mouseup", dragEnd);
	      off(display.wrapper.ownerDocument, "mousemove", mouseMove);
	      off(display.scroller, "dragstart", dragStart);
	      off(display.scroller, "drop", dragEnd);
	      if (!moved) {
	        e_preventDefault(e);
	        if (!behavior.addNew)
	          { extendSelection(cm.doc, pos, null, null, behavior.extend); }
	        // Work around unexplainable focus problem in IE9 (#2127) and Chrome (#3081)
	        if ((webkit && !safari) || ie && ie_version == 9)
	          { setTimeout(function () {display.wrapper.ownerDocument.body.focus({preventScroll: true}); display.input.focus();}, 20); }
	        else
	          { display.input.focus(); }
	      }
	    });
	    var mouseMove = function(e2) {
	      moved = moved || Math.abs(event.clientX - e2.clientX) + Math.abs(event.clientY - e2.clientY) >= 10;
	    };
	    var dragStart = function () { return moved = true; };
	    // Let the drag handler handle this.
	    if (webkit) { display.scroller.draggable = true; }
	    cm.state.draggingText = dragEnd;
	    dragEnd.copy = !behavior.moveOnDrag;
	    on(display.wrapper.ownerDocument, "mouseup", dragEnd);
	    on(display.wrapper.ownerDocument, "mousemove", mouseMove);
	    on(display.scroller, "dragstart", dragStart);
	    on(display.scroller, "drop", dragEnd);
	
	    cm.state.delayingBlurEvent = true;
	    setTimeout(function () { return display.input.focus(); }, 20);
	    // IE's approach to draggable
	    if (display.scroller.dragDrop) { display.scroller.dragDrop(); }
	  }
	
	  function rangeForUnit(cm, pos, unit) {
	    if (unit == "char") { return new Range(pos, pos) }
	    if (unit == "word") { return cm.findWordAt(pos) }
	    if (unit == "line") { return new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0))) }
	    var result = unit(cm, pos);
	    return new Range(result.from, result.to)
	  }
	
	  // Normal selection, as opposed to text dragging.
	  function leftButtonSelect(cm, event, start, behavior) {
	    if (ie) { delayBlurEvent(cm); }
	    var display = cm.display, doc = cm.doc;
	    e_preventDefault(event);
	
	    var ourRange, ourIndex, startSel = doc.sel, ranges = startSel.ranges;
	    if (behavior.addNew && !behavior.extend) {
	      ourIndex = doc.sel.contains(start);
	      if (ourIndex > -1)
	        { ourRange = ranges[ourIndex]; }
	      else
	        { ourRange = new Range(start, start); }
	    } else {
	      ourRange = doc.sel.primary();
	      ourIndex = doc.sel.primIndex;
	    }
	
	    if (behavior.unit == "rectangle") {
	      if (!behavior.addNew) { ourRange = new Range(start, start); }
	      start = posFromMouse(cm, event, true, true);
	      ourIndex = -1;
	    } else {
	      var range = rangeForUnit(cm, start, behavior.unit);
	      if (behavior.extend)
	        { ourRange = extendRange(ourRange, range.anchor, range.head, behavior.extend); }
	      else
	        { ourRange = range; }
	    }
	
	    if (!behavior.addNew) {
	      ourIndex = 0;
	      setSelection(doc, new Selection([ourRange], 0), sel_mouse);
	      startSel = doc.sel;
	    } else if (ourIndex == -1) {
	      ourIndex = ranges.length;
	      setSelection(doc, normalizeSelection(cm, ranges.concat([ourRange]), ourIndex),
	                   {scroll: false, origin: "*mouse"});
	    } else if (ranges.length > 1 && ranges[ourIndex].empty() && behavior.unit == "char" && !behavior.extend) {
	      setSelection(doc, normalizeSelection(cm, ranges.slice(0, ourIndex).concat(ranges.slice(ourIndex + 1)), 0),
	                   {scroll: false, origin: "*mouse"});
	      startSel = doc.sel;
	    } else {
	      replaceOneSelection(doc, ourIndex, ourRange, sel_mouse);
	    }
	
	    var lastPos = start;
	    function extendTo(pos) {
	      if (cmp(lastPos, pos) == 0) { return }
	      lastPos = pos;
	
	      if (behavior.unit == "rectangle") {
	        var ranges = [], tabSize = cm.options.tabSize;
	        var startCol = countColumn(getLine(doc, start.line).text, start.ch, tabSize);
	        var posCol = countColumn(getLine(doc, pos.line).text, pos.ch, tabSize);
	        var left = Math.min(startCol, posCol), right = Math.max(startCol, posCol);
	        for (var line = Math.min(start.line, pos.line), end = Math.min(cm.lastLine(), Math.max(start.line, pos.line));
	             line <= end; line++) {
	          var text = getLine(doc, line).text, leftPos = findColumn(text, left, tabSize);
	          if (left == right)
	            { ranges.push(new Range(Pos(line, leftPos), Pos(line, leftPos))); }
	          else if (text.length > leftPos)
	            { ranges.push(new Range(Pos(line, leftPos), Pos(line, findColumn(text, right, tabSize)))); }
	        }
	        if (!ranges.length) { ranges.push(new Range(start, start)); }
	        setSelection(doc, normalizeSelection(cm, startSel.ranges.slice(0, ourIndex).concat(ranges), ourIndex),
	                     {origin: "*mouse", scroll: false});
	        cm.scrollIntoView(pos);
	      } else {
	        var oldRange = ourRange;
	        var range = rangeForUnit(cm, pos, behavior.unit);
	        var anchor = oldRange.anchor, head;
	        if (cmp(range.anchor, anchor) > 0) {
	          head = range.head;
	          anchor = minPos(oldRange.from(), range.anchor);
	        } else {
	          head = range.anchor;
	          anchor = maxPos(oldRange.to(), range.head);
	        }
	        var ranges$1 = startSel.ranges.slice(0);
	        ranges$1[ourIndex] = bidiSimplify(cm, new Range(clipPos(doc, anchor), head));
	        setSelection(doc, normalizeSelection(cm, ranges$1, ourIndex), sel_mouse);
	      }
	    }
	
	    var editorSize = display.wrapper.getBoundingClientRect();
	    // Used to ensure timeout re-tries don't fire when another extend
	    // happened in the meantime (clearTimeout isn't reliable -- at
	    // least on Chrome, the timeouts still happen even when cleared,
	    // if the clear happens after their scheduled firing time).
	    var counter = 0;
	
	    function extend(e) {
	      var curCount = ++counter;
	      var cur = posFromMouse(cm, e, true, behavior.unit == "rectangle");
	      if (!cur) { return }
	      if (cmp(cur, lastPos) != 0) {
	        cm.curOp.focus = activeElt();
	        extendTo(cur);
	        var visible = visibleLines(display, doc);
	        if (cur.line >= visible.to || cur.line < visible.from)
	          { setTimeout(operation(cm, function () {if (counter == curCount) { extend(e); }}), 150); }
	      } else {
	        var outside = e.clientY < editorSize.top ? -20 : e.clientY > editorSize.bottom ? 20 : 0;
	        if (outside) { setTimeout(operation(cm, function () {
	          if (counter != curCount) { return }
	          display.scroller.scrollTop += outside;
	          extend(e);
	        }), 50); }
	      }
	    }
	
	    function done(e) {
	      cm.state.selectingText = false;
	      counter = Infinity;
	      // If e is null or undefined we interpret this as someone trying
	      // to explicitly cancel the selection rather than the user
	      // letting go of the mouse button.
	      if (e) {
	        e_preventDefault(e);
	        display.input.focus();
	      }
	      off(display.wrapper.ownerDocument, "mousemove", move);
	      off(display.wrapper.ownerDocument, "mouseup", up);
	      doc.history.lastSelOrigin = null;
	    }
	
	    var move = operation(cm, function (e) {
	      if (e.buttons === 0 || !e_button(e)) { done(e); }
	      else { extend(e); }
	    });
	    var up = operation(cm, done);
	    cm.state.selectingText = up;
	    on(display.wrapper.ownerDocument, "mousemove", move);
	    on(display.wrapper.ownerDocument, "mouseup", up);
	  }
	
	  // Used when mouse-selecting to adjust the anchor to the proper side
	  // of a bidi jump depending on the visual position of the head.
	  function bidiSimplify(cm, range) {
	    var anchor = range.anchor;
	    var head = range.head;
	    var anchorLine = getLine(cm.doc, anchor.line);
	    if (cmp(anchor, head) == 0 && anchor.sticky == head.sticky) { return range }
	    var order = getOrder(anchorLine);
	    if (!order) { return range }
	    var index = getBidiPartAt(order, anchor.ch, anchor.sticky), part = order[index];
	    if (part.from != anchor.ch && part.to != anchor.ch) { return range }
	    var boundary = index + ((part.from == anchor.ch) == (part.level != 1) ? 0 : 1);
	    if (boundary == 0 || boundary == order.length) { return range }
	
	    // Compute the relative visual position of the head compared to the
	    // anchor (<0 is to the left, >0 to the right)
	    var leftSide;
	    if (head.line != anchor.line) {
	      leftSide = (head.line - anchor.line) * (cm.doc.direction == "ltr" ? 1 : -1) > 0;
	    } else {
	      var headIndex = getBidiPartAt(order, head.ch, head.sticky);
	      var dir = headIndex - index || (head.ch - anchor.ch) * (part.level == 1 ? -1 : 1);
	      if (headIndex == boundary - 1 || headIndex == boundary)
	        { leftSide = dir < 0; }
	      else
	        { leftSide = dir > 0; }
	    }
	
	    var usePart = order[boundary + (leftSide ? -1 : 0)];
	    var from = leftSide == (usePart.level == 1);
	    var ch = from ? usePart.from : usePart.to, sticky = from ? "after" : "before";
	    return anchor.ch == ch && anchor.sticky == sticky ? range : new Range(new Pos(anchor.line, ch, sticky), head)
	  }
	
	
	  // Determines whether an event happened in the gutter, and fires the
	  // handlers for the corresponding event.
	  function gutterEvent(cm, e, type, prevent) {
	    var mX, mY;
	    if (e.touches) {
	      mX = e.touches[0].clientX;
	      mY = e.touches[0].clientY;
	    } else {
	      try { mX = e.clientX; mY = e.clientY; }
	      catch(e$1) { return false }
	    }
	    if (mX >= Math.floor(cm.display.gutters.getBoundingClientRect().right)) { return false }
	    if (prevent) { e_preventDefault(e); }
	
	    var display = cm.display;
	    var lineBox = display.lineDiv.getBoundingClientRect();
	
	    if (mY > lineBox.bottom || !hasHandler(cm, type)) { return e_defaultPrevented(e) }
	    mY -= lineBox.top - display.viewOffset;
	
	    for (var i = 0; i < cm.display.gutterSpecs.length; ++i) {
	      var g = display.gutters.childNodes[i];
	      if (g && g.getBoundingClientRect().right >= mX) {
	        var line = lineAtHeight(cm.doc, mY);
	        var gutter = cm.display.gutterSpecs[i];
	        signal(cm, type, cm, line, gutter.className, e);
	        return e_defaultPrevented(e)
	      }
	    }
	  }
	
	  function clickInGutter(cm, e) {
	    return gutterEvent(cm, e, "gutterClick", true)
	  }
	
	  // CONTEXT MENU HANDLING
	
	  // To make the context menu work, we need to briefly unhide the
	  // textarea (making it as unobtrusive as possible) to let the
	  // right-click take effect on it.
	  function onContextMenu(cm, e) {
	    if (eventInWidget(cm.display, e) || contextMenuInGutter(cm, e)) { return }
	    if (signalDOMEvent(cm, e, "contextmenu")) { return }
	    if (!captureRightClick) { cm.display.input.onContextMenu(e); }
	  }
	
	  function contextMenuInGutter(cm, e) {
	    if (!hasHandler(cm, "gutterContextMenu")) { return false }
	    return gutterEvent(cm, e, "gutterContextMenu", false)
	  }
	
	  function themeChanged(cm) {
	    cm.display.wrapper.className = cm.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") +
	      cm.options.theme.replace(/(^|\s)\s*/g, " cm-s-");
	    clearCaches(cm);
	  }
	
	  var Init = {toString: function(){return "CodeMirror.Init"}};
	
	  var defaults = {};
	  var optionHandlers = {};
	
	  function defineOptions(CodeMirror) {
	    var optionHandlers = CodeMirror.optionHandlers;
	
	    function option(name, deflt, handle, notOnInit) {
	      CodeMirror.defaults[name] = deflt;
	      if (handle) { optionHandlers[name] =
	        notOnInit ? function (cm, val, old) {if (old != Init) { handle(cm, val, old); }} : handle; }
	    }
	
	    CodeMirror.defineOption = option;
	
	    // Passed to option handlers when there is no old value.
	    CodeMirror.Init = Init;
	
	    // These two are, on init, called from the constructor because they
	    // have to be initialized before the editor can start at all.
	    option("value", "", function (cm, val) { return cm.setValue(val); }, true);
	    option("mode", null, function (cm, val) {
	      cm.doc.modeOption = val;
	      loadMode(cm);
	    }, true);
	
	    option("indentUnit", 2, loadMode, true);
	    option("indentWithTabs", false);
	    option("smartIndent", true);
	    option("tabSize", 4, function (cm) {
	      resetModeState(cm);
	      clearCaches(cm);
	      regChange(cm);
	    }, true);
	
	    option("lineSeparator", null, function (cm, val) {
	      cm.doc.lineSep = val;
	      if (!val) { return }
	      var newBreaks = [], lineNo = cm.doc.first;
	      cm.doc.iter(function (line) {
	        for (var pos = 0;;) {
	          var found = line.text.indexOf(val, pos);
	          if (found == -1) { break }
	          pos = found + val.length;
	          newBreaks.push(Pos(lineNo, found));
	        }
	        lineNo++;
	      });
	      for (var i = newBreaks.length - 1; i >= 0; i--)
	        { replaceRange(cm.doc, val, newBreaks[i], Pos(newBreaks[i].line, newBreaks[i].ch + val.length)); }
	    });
	    option("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\ufeff\ufff9-\ufffc]/g, function (cm, val, old) {
	      cm.state.specialChars = new RegExp(val.source + (val.test("\t") ? "" : "|\t"), "g");
	      if (old != Init) { cm.refresh(); }
	    });
	    option("specialCharPlaceholder", defaultSpecialCharPlaceholder, function (cm) { return cm.refresh(); }, true);
	    option("electricChars", true);
	    option("inputStyle", mobile ? "contenteditable" : "textarea", function () {
	      throw new Error("inputStyle can not (yet) be changed in a running editor") // FIXME
	    }, true);
	    option("spellcheck", false, function (cm, val) { return cm.getInputField().spellcheck = val; }, true);
	    option("autocorrect", false, function (cm, val) { return cm.getInputField().autocorrect = val; }, true);
	    option("autocapitalize", false, function (cm, val) { return cm.getInputField().autocapitalize = val; }, true);
	    option("rtlMoveVisually", !windows);
	    option("wholeLineUpdateBefore", true);
	
	    option("theme", "default", function (cm) {
	      themeChanged(cm);
	      updateGutters(cm);
	    }, true);
	    option("keyMap", "default", function (cm, val, old) {
	      var next = getKeyMap(val);
	      var prev = old != Init && getKeyMap(old);
	      if (prev && prev.detach) { prev.detach(cm, next); }
	      if (next.attach) { next.attach(cm, prev || null); }
	    });
	    option("extraKeys", null);
	    option("configureMouse", null);
	
	    option("lineWrapping", false, wrappingChanged, true);
	    option("gutters", [], function (cm, val) {
	      cm.display.gutterSpecs = getGutters(val, cm.options.lineNumbers);
	      updateGutters(cm);
	    }, true);
	    option("fixedGutter", true, function (cm, val) {
	      cm.display.gutters.style.left = val ? compensateForHScroll(cm.display) + "px" : "0";
	      cm.refresh();
	    }, true);
	    option("coverGutterNextToScrollbar", false, function (cm) { return updateScrollbars(cm); }, true);
	    option("scrollbarStyle", "native", function (cm) {
	      initScrollbars(cm);
	      updateScrollbars(cm);
	      cm.display.scrollbars.setScrollTop(cm.doc.scrollTop);
	      cm.display.scrollbars.setScrollLeft(cm.doc.scrollLeft);
	    }, true);
	    option("lineNumbers", false, function (cm, val) {
	      cm.display.gutterSpecs = getGutters(cm.options.gutters, val);
	      updateGutters(cm);
	    }, true);
	    option("firstLineNumber", 1, updateGutters, true);
	    option("lineNumberFormatter", function (integer) { return integer; }, updateGutters, true);
	    option("showCursorWhenSelecting", false, updateSelection, true);
	
	    option("resetSelectionOnContextMenu", true);
	    option("lineWiseCopyCut", true);
	    option("pasteLinesPerSelection", true);
	    option("selectionsMayTouch", false);
	
	    option("readOnly", false, function (cm, val) {
	      if (val == "nocursor") {
	        onBlur(cm);
	        cm.display.input.blur();
	      }
	      cm.display.input.readOnlyChanged(val);
	    });
	
	    option("screenReaderLabel", null, function (cm, val) {
	      val = (val === '') ? null : val;
	      cm.display.input.screenReaderLabelChanged(val);
	    });
	
	    option("disableInput", false, function (cm, val) {if (!val) { cm.display.input.reset(); }}, true);
	    option("dragDrop", true, dragDropChanged);
	    option("allowDropFileTypes", null);
	
	    option("cursorBlinkRate", 530);
	    option("cursorScrollMargin", 0);
	    option("cursorHeight", 1, updateSelection, true);
	    option("singleCursorHeightPerLine", true, updateSelection, true);
	    option("workTime", 100);
	    option("workDelay", 100);
	    option("flattenSpans", true, resetModeState, true);
	    option("addModeClass", false, resetModeState, true);
	    option("pollInterval", 100);
	    option("undoDepth", 200, function (cm, val) { return cm.doc.history.undoDepth = val; });
	    option("historyEventDelay", 1250);
	    option("viewportMargin", 10, function (cm) { return cm.refresh(); }, true);
	    option("maxHighlightLength", 10000, resetModeState, true);
	    option("moveInputWithCursor", true, function (cm, val) {
	      if (!val) { cm.display.input.resetPosition(); }
	    });
	
	    option("tabindex", null, function (cm, val) { return cm.display.input.getField().tabIndex = val || ""; });
	    option("autofocus", null);
	    option("direction", "ltr", function (cm, val) { return cm.doc.setDirection(val); }, true);
	    option("phrases", null);
	  }
	
	  function dragDropChanged(cm, value, old) {
	    var wasOn = old && old != Init;
	    if (!value != !wasOn) {
	      var funcs = cm.display.dragFunctions;
	      var toggle = value ? on : off;
	      toggle(cm.display.scroller, "dragstart", funcs.start);
	      toggle(cm.display.scroller, "dragenter", funcs.enter);
	      toggle(cm.display.scroller, "dragover", funcs.over);
	      toggle(cm.display.scroller, "dragleave", funcs.leave);
	      toggle(cm.display.scroller, "drop", funcs.drop);
	    }
	  }
	
	  function wrappingChanged(cm) {
	    if (cm.options.lineWrapping) {
	      addClass(cm.display.wrapper, "CodeMirror-wrap");
	      cm.display.sizer.style.minWidth = "";
	      cm.display.sizerWidth = null;
	    } else {
	      rmClass(cm.display.wrapper, "CodeMirror-wrap");
	      findMaxLine(cm);
	    }
	    estimateLineHeights(cm);
	    regChange(cm);
	    clearCaches(cm);
	    setTimeout(function () { return updateScrollbars(cm); }, 100);
	  }
	
	  // A CodeMirror instance represents an editor. This is the object
	  // that user code is usually dealing with.
	
	  function CodeMirror(place, options) {
	    var this$1 = this;
	
	    if (!(this instanceof CodeMirror)) { return new CodeMirror(place, options) }
	
	    this.options = options = options ? copyObj(options) : {};
	    // Determine effective options based on given values and defaults.
	    copyObj(defaults, options, false);
	
	    var doc = options.value;
	    if (typeof doc == "string") { doc = new Doc(doc, options.mode, null, options.lineSeparator, options.direction); }
	    else if (options.mode) { doc.modeOption = options.mode; }
	    this.doc = doc;
	
	    var input = new CodeMirror.inputStyles[options.inputStyle](this);
	    var display = this.display = new Display(place, doc, input, options);
	    display.wrapper.CodeMirror = this;
	    themeChanged(this);
	    if (options.lineWrapping)
	      { this.display.wrapper.className += " CodeMirror-wrap"; }
	    initScrollbars(this);
	
	    this.state = {
	      keyMaps: [],  // stores maps added by addKeyMap
	      overlays: [], // highlighting overlays, as added by addOverlay
	      modeGen: 0,   // bumped when mode/overlay changes, used to invalidate highlighting info
	      overwrite: false,
	      delayingBlurEvent: false,
	      focused: false,
	      suppressEdits: false, // used to disable editing during key handlers when in readOnly mode
	      pasteIncoming: -1, cutIncoming: -1, // help recognize paste/cut edits in input.poll
	      selectingText: false,
	      draggingText: false,
	      highlight: new Delayed(), // stores highlight worker timeout
	      keySeq: null,  // Unfinished key sequence
	      specialChars: null
	    };
	
	    if (options.autofocus && !mobile) { display.input.focus(); }
	
	    // Override magic textarea content restore that IE sometimes does
	    // on our hidden textarea on reload
	    if (ie && ie_version < 11) { setTimeout(function () { return this$1.display.input.reset(true); }, 20); }
	
	    registerEventHandlers(this);
	    ensureGlobalHandlers();
	
	    startOperation(this);
	    this.curOp.forceUpdate = true;
	    attachDoc(this, doc);
	
	    if ((options.autofocus && !mobile) || this.hasFocus())
	      { setTimeout(function () {
	        if (this$1.hasFocus() && !this$1.state.focused) { onFocus(this$1); }
	      }, 20); }
	    else
	      { onBlur(this); }
	
	    for (var opt in optionHandlers) { if (optionHandlers.hasOwnProperty(opt))
	      { optionHandlers[opt](this, options[opt], Init); } }
	    maybeUpdateLineNumberWidth(this);
	    if (options.finishInit) { options.finishInit(this); }
	    for (var i = 0; i < initHooks.length; ++i) { initHooks[i](this); }
	    endOperation(this);
	    // Suppress optimizelegibility in Webkit, since it breaks text
	    // measuring on line wrapping boundaries.
	    if (webkit && options.lineWrapping &&
	        getComputedStyle(display.lineDiv).textRendering == "optimizelegibility")
	      { display.lineDiv.style.textRendering = "auto"; }
	  }
	
	  // The default configuration options.
	  CodeMirror.defaults = defaults;
	  // Functions to run when options are changed.
	  CodeMirror.optionHandlers = optionHandlers;
	
	  // Attach the necessary event handlers when initializing the editor
	  function registerEventHandlers(cm) {
	    var d = cm.display;
	    on(d.scroller, "mousedown", operation(cm, onMouseDown));
	    // Older IE's will not fire a second mousedown for a double click
	    if (ie && ie_version < 11)
	      { on(d.scroller, "dblclick", operation(cm, function (e) {
	        if (signalDOMEvent(cm, e)) { return }
	        var pos = posFromMouse(cm, e);
	        if (!pos || clickInGutter(cm, e) || eventInWidget(cm.display, e)) { return }
	        e_preventDefault(e);
	        var word = cm.findWordAt(pos);
	        extendSelection(cm.doc, word.anchor, word.head);
	      })); }
	    else
	      { on(d.scroller, "dblclick", function (e) { return signalDOMEvent(cm, e) || e_preventDefault(e); }); }
	    // Some browsers fire contextmenu *after* opening the menu, at
	    // which point we can't mess with it anymore. Context menu is
	    // handled in onMouseDown for these browsers.
	    on(d.scroller, "contextmenu", function (e) { return onContextMenu(cm, e); });
	    on(d.input.getField(), "contextmenu", function (e) {
	      if (!d.scroller.contains(e.target)) { onContextMenu(cm, e); }
	    });
	
	    // Used to suppress mouse event handling when a touch happens
	    var touchFinished, prevTouch = {end: 0};
	    function finishTouch() {
	      if (d.activeTouch) {
	        touchFinished = setTimeout(function () { return d.activeTouch = null; }, 1000);
	        prevTouch = d.activeTouch;
	        prevTouch.end = +new Date;
	      }
	    }
	    function isMouseLikeTouchEvent(e) {
	      if (e.touches.length != 1) { return false }
	      var touch = e.touches[0];
	      return touch.radiusX <= 1 && touch.radiusY <= 1
	    }
	    function farAway(touch, other) {
	      if (other.left == null) { return true }
	      var dx = other.left - touch.left, dy = other.top - touch.top;
	      return dx * dx + dy * dy > 20 * 20
	    }
	    on(d.scroller, "touchstart", function (e) {
	      if (!signalDOMEvent(cm, e) && !isMouseLikeTouchEvent(e) && !clickInGutter(cm, e)) {
	        d.input.ensurePolled();
	        clearTimeout(touchFinished);
	        var now = +new Date;
	        d.activeTouch = {start: now, moved: false,
	                         prev: now - prevTouch.end <= 300 ? prevTouch : null};
	        if (e.touches.length == 1) {
	          d.activeTouch.left = e.touches[0].pageX;
	          d.activeTouch.top = e.touches[0].pageY;
	        }
	      }
	    });
	    on(d.scroller, "touchmove", function () {
	      if (d.activeTouch) { d.activeTouch.moved = true; }
	    });
	    on(d.scroller, "touchend", function (e) {
	      var touch = d.activeTouch;
	      if (touch && !eventInWidget(d, e) && touch.left != null &&
	          !touch.moved && new Date - touch.start < 300) {
	        var pos = cm.coordsChar(d.activeTouch, "page"), range;
	        if (!touch.prev || farAway(touch, touch.prev)) // Single tap
	          { range = new Range(pos, pos); }
	        else if (!touch.prev.prev || farAway(touch, touch.prev.prev)) // Double tap
	          { range = cm.findWordAt(pos); }
	        else // Triple tap
	          { range = new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0))); }
	        cm.setSelection(range.anchor, range.head);
	        cm.focus();
	        e_preventDefault(e);
	      }
	      finishTouch();
	    });
	    on(d.scroller, "touchcancel", finishTouch);
	
	    // Sync scrolling between fake scrollbars and real scrollable
	    // area, ensure viewport is updated when scrolling.
	    on(d.scroller, "scroll", function () {
	      if (d.scroller.clientHeight) {
	        updateScrollTop(cm, d.scroller.scrollTop);
	        setScrollLeft(cm, d.scroller.scrollLeft, true);
	        signal(cm, "scroll", cm);
	      }
	    });
	
	    // Listen to wheel events in order to try and update the viewport on time.
	    on(d.scroller, "mousewheel", function (e) { return onScrollWheel(cm, e); });
	    on(d.scroller, "DOMMouseScroll", function (e) { return onScrollWheel(cm, e); });
	
	    // Prevent wrapper from ever scrolling
	    on(d.wrapper, "scroll", function () { return d.wrapper.scrollTop = d.wrapper.scrollLeft = 0; });
	
	    d.dragFunctions = {
	      enter: function (e) {if (!signalDOMEvent(cm, e)) { e_stop(e); }},
	      over: function (e) {if (!signalDOMEvent(cm, e)) { onDragOver(cm, e); e_stop(e); }},
	      start: function (e) { return onDragStart(cm, e); },
	      drop: operation(cm, onDrop),
	      leave: function (e) {if (!signalDOMEvent(cm, e)) { clearDragCursor(cm); }}
	    };
	
	    var inp = d.input.getField();
	    on(inp, "keyup", function (e) { return onKeyUp.call(cm, e); });
	    on(inp, "keydown", operation(cm, onKeyDown));
	    on(inp, "keypress", operation(cm, onKeyPress));
	    on(inp, "focus", function (e) { return onFocus(cm, e); });
	    on(inp, "blur", function (e) { return onBlur(cm, e); });
	  }
	
	  var initHooks = [];
	  CodeMirror.defineInitHook = function (f) { return initHooks.push(f); };
	
	  // Indent the given line. The how parameter can be "smart",
	  // "add"/null, "subtract", or "prev". When aggressive is false
	  // (typically set to true for forced single-line indents), empty
	  // lines are not indented, and places where the mode returns Pass
	  // are left alone.
	  function indentLine(cm, n, how, aggressive) {
	    var doc = cm.doc, state;
	    if (how == null) { how = "add"; }
	    if (how == "smart") {
	      // Fall back to "prev" when the mode doesn't have an indentation
	      // method.
	      if (!doc.mode.indent) { how = "prev"; }
	      else { state = getContextBefore(cm, n).state; }
	    }
	
	    var tabSize = cm.options.tabSize;
	    var line = getLine(doc, n), curSpace = countColumn(line.text, null, tabSize);
	    if (line.stateAfter) { line.stateAfter = null; }
	    var curSpaceString = line.text.match(/^\s*/)[0], indentation;
	    if (!aggressive && !/\S/.test(line.text)) {
	      indentation = 0;
	      how = "not";
	    } else if (how == "smart") {
	      indentation = doc.mode.indent(state, line.text.slice(curSpaceString.length), line.text);
	      if (indentation == Pass || indentation > 150) {
	        if (!aggressive) { return }
	        how = "prev";
	      }
	    }
	    if (how == "prev") {
	      if (n > doc.first) { indentation = countColumn(getLine(doc, n-1).text, null, tabSize); }
	      else { indentation = 0; }
	    } else if (how == "add") {
	      indentation = curSpace + cm.options.indentUnit;
	    } else if (how == "subtract") {
	      indentation = curSpace - cm.options.indentUnit;
	    } else if (typeof how == "number") {
	      indentation = curSpace + how;
	    }
	    indentation = Math.max(0, indentation);
	
	    var indentString = "", pos = 0;
	    if (cm.options.indentWithTabs)
	      { for (var i = Math.floor(indentation / tabSize); i; --i) {pos += tabSize; indentString += "\t";} }
	    if (pos < indentation) { indentString += spaceStr(indentation - pos); }
	
	    if (indentString != curSpaceString) {
	      replaceRange(doc, indentString, Pos(n, 0), Pos(n, curSpaceString.length), "+input");
	      line.stateAfter = null;
	      return true
	    } else {
	      // Ensure that, if the cursor was in the whitespace at the start
	      // of the line, it is moved to the end of that space.
	      for (var i$1 = 0; i$1 < doc.sel.ranges.length; i$1++) {
	        var range = doc.sel.ranges[i$1];
	        if (range.head.line == n && range.head.ch < curSpaceString.length) {
	          var pos$1 = Pos(n, curSpaceString.length);
	          replaceOneSelection(doc, i$1, new Range(pos$1, pos$1));
	          break
	        }
	      }
	    }
	  }
	
	  // This will be set to a {lineWise: bool, text: [string]} object, so
	  // that, when pasting, we know what kind of selections the copied
	  // text was made out of.
	  var lastCopied = null;
	
	  function setLastCopied(newLastCopied) {
	    lastCopied = newLastCopied;
	  }
	
	  function applyTextInput(cm, inserted, deleted, sel, origin) {
	    var doc = cm.doc;
	    cm.display.shift = false;
	    if (!sel) { sel = doc.sel; }
	
	    var recent = +new Date - 200;
	    var paste = origin == "paste" || cm.state.pasteIncoming > recent;
	    var textLines = splitLinesAuto(inserted), multiPaste = null;
	    // When pasting N lines into N selections, insert one line per selection
	    if (paste && sel.ranges.length > 1) {
	      if (lastCopied && lastCopied.text.join("\n") == inserted) {
	        if (sel.ranges.length % lastCopied.text.length == 0) {
	          multiPaste = [];
	          for (var i = 0; i < lastCopied.text.length; i++)
	            { multiPaste.push(doc.splitLines(lastCopied.text[i])); }
	        }
	      } else if (textLines.length == sel.ranges.length && cm.options.pasteLinesPerSelection) {
	        multiPaste = map(textLines, function (l) { return [l]; });
	      }
	    }
	
	    var updateInput = cm.curOp.updateInput;
	    // Normal behavior is to insert the new text into every selection
	    for (var i$1 = sel.ranges.length - 1; i$1 >= 0; i$1--) {
	      var range = sel.ranges[i$1];
	      var from = range.from(), to = range.to();
	      if (range.empty()) {
	        if (deleted && deleted > 0) // Handle deletion
	          { from = Pos(from.line, from.ch - deleted); }
	        else if (cm.state.overwrite && !paste) // Handle overwrite
	          { to = Pos(to.line, Math.min(getLine(doc, to.line).text.length, to.ch + lst(textLines).length)); }
	        else if (paste && lastCopied && lastCopied.lineWise && lastCopied.text.join("\n") == textLines.join("\n"))
	          { from = to = Pos(from.line, 0); }
	      }
	      var changeEvent = {from: from, to: to, text: multiPaste ? multiPaste[i$1 % multiPaste.length] : textLines,
	                         origin: origin || (paste ? "paste" : cm.state.cutIncoming > recent ? "cut" : "+input")};
	      makeChange(cm.doc, changeEvent);
	      signalLater(cm, "inputRead", cm, changeEvent);
	    }
	    if (inserted && !paste)
	      { triggerElectric(cm, inserted); }
	
	    ensureCursorVisible(cm);
	    if (cm.curOp.updateInput < 2) { cm.curOp.updateInput = updateInput; }
	    cm.curOp.typing = true;
	    cm.state.pasteIncoming = cm.state.cutIncoming = -1;
	  }
	
	  function handlePaste(e, cm) {
	    var pasted = e.clipboardData && e.clipboardData.getData("Text");
	    if (pasted) {
	      e.preventDefault();
	      if (!cm.isReadOnly() && !cm.options.disableInput)
	        { runInOp(cm, function () { return applyTextInput(cm, pasted, 0, null, "paste"); }); }
	      return true
	    }
	  }
	
	  function triggerElectric(cm, inserted) {
	    // When an 'electric' character is inserted, immediately trigger a reindent
	    if (!cm.options.electricChars || !cm.options.smartIndent) { return }
	    var sel = cm.doc.sel;
	
	    for (var i = sel.ranges.length - 1; i >= 0; i--) {
	      var range = sel.ranges[i];
	      if (range.head.ch > 100 || (i && sel.ranges[i - 1].head.line == range.head.line)) { continue }
	      var mode = cm.getModeAt(range.head);
	      var indented = false;
	      if (mode.electricChars) {
	        for (var j = 0; j < mode.electricChars.length; j++)
	          { if (inserted.indexOf(mode.electricChars.charAt(j)) > -1) {
	            indented = indentLine(cm, range.head.line, "smart");
	            break
	          } }
	      } else if (mode.electricInput) {
	        if (mode.electricInput.test(getLine(cm.doc, range.head.line).text.slice(0, range.head.ch)))
	          { indented = indentLine(cm, range.head.line, "smart"); }
	      }
	      if (indented) { signalLater(cm, "electricInput", cm, range.head.line); }
	    }
	  }
	
	  function copyableRanges(cm) {
	    var text = [], ranges = [];
	    for (var i = 0; i < cm.doc.sel.ranges.length; i++) {
	      var line = cm.doc.sel.ranges[i].head.line;
	      var lineRange = {anchor: Pos(line, 0), head: Pos(line + 1, 0)};
	      ranges.push(lineRange);
	      text.push(cm.getRange(lineRange.anchor, lineRange.head));
	    }
	    return {text: text, ranges: ranges}
	  }
	
	  function disableBrowserMagic(field, spellcheck, autocorrect, autocapitalize) {
	    field.setAttribute("autocorrect", autocorrect ? "" : "off");
	    field.setAttribute("autocapitalize", autocapitalize ? "" : "off");
	    field.setAttribute("spellcheck", !!spellcheck);
	  }
	
	  function hiddenTextarea() {
	    var te = elt("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; min-height: 1em; outline: none");
	    var div = elt("div", [te], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
	    // The textarea is kept positioned near the cursor to prevent the
	    // fact that it'll be scrolled into view on input from scrolling
	    // our fake cursor out of view. On webkit, when wrap=off, paste is
	    // very slow. So make the area wide instead.
	    if (webkit) { te.style.width = "1000px"; }
	    else { te.setAttribute("wrap", "off"); }
	    // If border: 0; -- iOS fails to open keyboard (issue #1287)
	    if (ios) { te.style.border = "1px solid black"; }
	    disableBrowserMagic(te);
	    return div
	  }
	
	  // The publicly visible API. Note that methodOp(f) means
	  // 'wrap f in an operation, performed on its `this` parameter'.
	
	  // This is not the complete set of editor methods. Most of the
	  // methods defined on the Doc type are also injected into
	  // CodeMirror.prototype, for backwards compatibility and
	  // convenience.
	
	  function addEditorMethods(CodeMirror) {
	    var optionHandlers = CodeMirror.optionHandlers;
	
	    var helpers = CodeMirror.helpers = {};
	
	    CodeMirror.prototype = {
	      constructor: CodeMirror,
	      focus: function(){window.focus(); this.display.input.focus();},
	
	      setOption: function(option, value) {
	        var options = this.options, old = options[option];
	        if (options[option] == value && option != "mode") { return }
	        options[option] = value;
	        if (optionHandlers.hasOwnProperty(option))
	          { operation(this, optionHandlers[option])(this, value, old); }
	        signal(this, "optionChange", this, option);
	      },
	
	      getOption: function(option) {return this.options[option]},
	      getDoc: function() {return this.doc},
	
	      addKeyMap: function(map, bottom) {
	        this.state.keyMaps[bottom ? "push" : "unshift"](getKeyMap(map));
	      },
	      removeKeyMap: function(map) {
	        var maps = this.state.keyMaps;
	        for (var i = 0; i < maps.length; ++i)
	          { if (maps[i] == map || maps[i].name == map) {
	            maps.splice(i, 1);
	            return true
	          } }
	      },
	
	      addOverlay: methodOp(function(spec, options) {
	        var mode = spec.token ? spec : CodeMirror.getMode(this.options, spec);
	        if (mode.startState) { throw new Error("Overlays may not be stateful.") }
	        insertSorted(this.state.overlays,
	                     {mode: mode, modeSpec: spec, opaque: options && options.opaque,
	                      priority: (options && options.priority) || 0},
	                     function (overlay) { return overlay.priority; });
	        this.state.modeGen++;
	        regChange(this);
	      }),
	      removeOverlay: methodOp(function(spec) {
	        var overlays = this.state.overlays;
	        for (var i = 0; i < overlays.length; ++i) {
	          var cur = overlays[i].modeSpec;
	          if (cur == spec || typeof spec == "string" && cur.name == spec) {
	            overlays.splice(i, 1);
	            this.state.modeGen++;
	            regChange(this);
	            return
	          }
	        }
	      }),
	
	      indentLine: methodOp(function(n, dir, aggressive) {
	        if (typeof dir != "string" && typeof dir != "number") {
	          if (dir == null) { dir = this.options.smartIndent ? "smart" : "prev"; }
	          else { dir = dir ? "add" : "subtract"; }
	        }
	        if (isLine(this.doc, n)) { indentLine(this, n, dir, aggressive); }
	      }),
	      indentSelection: methodOp(function(how) {
	        var ranges = this.doc.sel.ranges, end = -1;
	        for (var i = 0; i < ranges.length; i++) {
	          var range = ranges[i];
	          if (!range.empty()) {
	            var from = range.from(), to = range.to();
	            var start = Math.max(end, from.line);
	            end = Math.min(this.lastLine(), to.line - (to.ch ? 0 : 1)) + 1;
	            for (var j = start; j < end; ++j)
	              { indentLine(this, j, how); }
	            var newRanges = this.doc.sel.ranges;
	            if (from.ch == 0 && ranges.length == newRanges.length && newRanges[i].from().ch > 0)
	              { replaceOneSelection(this.doc, i, new Range(from, newRanges[i].to()), sel_dontScroll); }
	          } else if (range.head.line > end) {
	            indentLine(this, range.head.line, how, true);
	            end = range.head.line;
	            if (i == this.doc.sel.primIndex) { ensureCursorVisible(this); }
	          }
	        }
	      }),
	
	      // Fetch the parser token for a given character. Useful for hacks
	      // that want to inspect the mode state (say, for completion).
	      getTokenAt: function(pos, precise) {
	        return takeToken(this, pos, precise)
	      },
	
	      getLineTokens: function(line, precise) {
	        return takeToken(this, Pos(line), precise, true)
	      },
	
	      getTokenTypeAt: function(pos) {
	        pos = clipPos(this.doc, pos);
	        var styles = getLineStyles(this, getLine(this.doc, pos.line));
	        var before = 0, after = (styles.length - 1) / 2, ch = pos.ch;
	        var type;
	        if (ch == 0) { type = styles[2]; }
	        else { for (;;) {
	          var mid = (before + after) >> 1;
	          if ((mid ? styles[mid * 2 - 1] : 0) >= ch) { after = mid; }
	          else if (styles[mid * 2 + 1] < ch) { before = mid + 1; }
	          else { type = styles[mid * 2 + 2]; break }
	        } }
	        var cut = type ? type.indexOf("overlay ") : -1;
	        return cut < 0 ? type : cut == 0 ? null : type.slice(0, cut - 1)
	      },
	
	      getModeAt: function(pos) {
	        var mode = this.doc.mode;
	        if (!mode.innerMode) { return mode }
	        return CodeMirror.innerMode(mode, this.getTokenAt(pos).state).mode
	      },
	
	      getHelper: function(pos, type) {
	        return this.getHelpers(pos, type)[0]
	      },
	
	      getHelpers: function(pos, type) {
	        var found = [];
	        if (!helpers.hasOwnProperty(type)) { return found }
	        var help = helpers[type], mode = this.getModeAt(pos);
	        if (typeof mode[type] == "string") {
	          if (help[mode[type]]) { found.push(help[mode[type]]); }
	        } else if (mode[type]) {
	          for (var i = 0; i < mode[type].length; i++) {
	            var val = help[mode[type][i]];
	            if (val) { found.push(val); }
	          }
	        } else if (mode.helperType && help[mode.helperType]) {
	          found.push(help[mode.helperType]);
	        } else if (help[mode.name]) {
	          found.push(help[mode.name]);
	        }
	        for (var i$1 = 0; i$1 < help._global.length; i$1++) {
	          var cur = help._global[i$1];
	          if (cur.pred(mode, this) && indexOf(found, cur.val) == -1)
	            { found.push(cur.val); }
	        }
	        return found
	      },
	
	      getStateAfter: function(line, precise) {
	        var doc = this.doc;
	        line = clipLine(doc, line == null ? doc.first + doc.size - 1: line);
	        return getContextBefore(this, line + 1, precise).state
	      },
	
	      cursorCoords: function(start, mode) {
	        var pos, range = this.doc.sel.primary();
	        if (start == null) { pos = range.head; }
	        else if (typeof start == "object") { pos = clipPos(this.doc, start); }
	        else { pos = start ? range.from() : range.to(); }
	        return cursorCoords(this, pos, mode || "page")
	      },
	
	      charCoords: function(pos, mode) {
	        return charCoords(this, clipPos(this.doc, pos), mode || "page")
	      },
	
	      coordsChar: function(coords, mode) {
	        coords = fromCoordSystem(this, coords, mode || "page");
	        return coordsChar(this, coords.left, coords.top)
	      },
	
	      lineAtHeight: function(height, mode) {
	        height = fromCoordSystem(this, {top: height, left: 0}, mode || "page").top;
	        return lineAtHeight(this.doc, height + this.display.viewOffset)
	      },
	      heightAtLine: function(line, mode, includeWidgets) {
	        var end = false, lineObj;
	        if (typeof line == "number") {
	          var last = this.doc.first + this.doc.size - 1;
	          if (line < this.doc.first) { line = this.doc.first; }
	          else if (line > last) { line = last; end = true; }
	          lineObj = getLine(this.doc, line);
	        } else {
	          lineObj = line;
	        }
	        return intoCoordSystem(this, lineObj, {top: 0, left: 0}, mode || "page", includeWidgets || end).top +
	          (end ? this.doc.height - heightAtLine(lineObj) : 0)
	      },
	
	      defaultTextHeight: function() { return textHeight(this.display) },
	      defaultCharWidth: function() { return charWidth(this.display) },
	
	      getViewport: function() { return {from: this.display.viewFrom, to: this.display.viewTo}},
	
	      addWidget: function(pos, node, scroll, vert, horiz) {
	        var display = this.display;
	        pos = cursorCoords(this, clipPos(this.doc, pos));
	        var top = pos.bottom, left = pos.left;
	        node.style.position = "absolute";
	        node.setAttribute("cm-ignore-events", "true");
	        this.display.input.setUneditable(node);
	        display.sizer.appendChild(node);
	        if (vert == "over") {
	          top = pos.top;
	        } else if (vert == "above" || vert == "near") {
	          var vspace = Math.max(display.wrapper.clientHeight, this.doc.height),
	          hspace = Math.max(display.sizer.clientWidth, display.lineSpace.clientWidth);
	          // Default to positioning above (if specified and possible); otherwise default to positioning below
	          if ((vert == 'above' || pos.bottom + node.offsetHeight > vspace) && pos.top > node.offsetHeight)
	            { top = pos.top - node.offsetHeight; }
	          else if (pos.bottom + node.offsetHeight <= vspace)
	            { top = pos.bottom; }
	          if (left + node.offsetWidth > hspace)
	            { left = hspace - node.offsetWidth; }
	        }
	        node.style.top = top + "px";
	        node.style.left = node.style.right = "";
	        if (horiz == "right") {
	          left = display.sizer.clientWidth - node.offsetWidth;
	          node.style.right = "0px";
	        } else {
	          if (horiz == "left") { left = 0; }
	          else if (horiz == "middle") { left = (display.sizer.clientWidth - node.offsetWidth) / 2; }
	          node.style.left = left + "px";
	        }
	        if (scroll)
	          { scrollIntoView(this, {left: left, top: top, right: left + node.offsetWidth, bottom: top + node.offsetHeight}); }
	      },
	
	      triggerOnKeyDown: methodOp(onKeyDown),
	      triggerOnKeyPress: methodOp(onKeyPress),
	      triggerOnKeyUp: onKeyUp,
	      triggerOnMouseDown: methodOp(onMouseDown),
	
	      execCommand: function(cmd) {
	        if (commands.hasOwnProperty(cmd))
	          { return commands[cmd].call(null, this) }
	      },
	
	      triggerElectric: methodOp(function(text) { triggerElectric(this, text); }),
	
	      findPosH: function(from, amount, unit, visually) {
	        var dir = 1;
	        if (amount < 0) { dir = -1; amount = -amount; }
	        var cur = clipPos(this.doc, from);
	        for (var i = 0; i < amount; ++i) {
	          cur = findPosH(this.doc, cur, dir, unit, visually);
	          if (cur.hitSide) { break }
	        }
	        return cur
	      },
	
	      moveH: methodOp(function(dir, unit) {
	        var this$1 = this;
	
	        this.extendSelectionsBy(function (range) {
	          if (this$1.display.shift || this$1.doc.extend || range.empty())
	            { return findPosH(this$1.doc, range.head, dir, unit, this$1.options.rtlMoveVisually) }
	          else
	            { return dir < 0 ? range.from() : range.to() }
	        }, sel_move);
	      }),
	
	      deleteH: methodOp(function(dir, unit) {
	        var sel = this.doc.sel, doc = this.doc;
	        if (sel.somethingSelected())
	          { doc.replaceSelection("", null, "+delete"); }
	        else
	          { deleteNearSelection(this, function (range) {
	            var other = findPosH(doc, range.head, dir, unit, false);
	            return dir < 0 ? {from: other, to: range.head} : {from: range.head, to: other}
	          }); }
	      }),
	
	      findPosV: function(from, amount, unit, goalColumn) {
	        var dir = 1, x = goalColumn;
	        if (amount < 0) { dir = -1; amount = -amount; }
	        var cur = clipPos(this.doc, from);
	        for (var i = 0; i < amount; ++i) {
	          var coords = cursorCoords(this, cur, "div");
	          if (x == null) { x = coords.left; }
	          else { coords.left = x; }
	          cur = findPosV(this, coords, dir, unit);
	          if (cur.hitSide) { break }
	        }
	        return cur
	      },
	
	      moveV: methodOp(function(dir, unit) {
	        var this$1 = this;
	
	        var doc = this.doc, goals = [];
	        var collapse = !this.display.shift && !doc.extend && doc.sel.somethingSelected();
	        doc.extendSelectionsBy(function (range) {
	          if (collapse)
	            { return dir < 0 ? range.from() : range.to() }
	          var headPos = cursorCoords(this$1, range.head, "div");
	          if (range.goalColumn != null) { headPos.left = range.goalColumn; }
	          goals.push(headPos.left);
	          var pos = findPosV(this$1, headPos, dir, unit);
	          if (unit == "page" && range == doc.sel.primary())
	            { addToScrollTop(this$1, charCoords(this$1, pos, "div").top - headPos.top); }
	          return pos
	        }, sel_move);
	        if (goals.length) { for (var i = 0; i < doc.sel.ranges.length; i++)
	          { doc.sel.ranges[i].goalColumn = goals[i]; } }
	      }),
	
	      // Find the word at the given position (as returned by coordsChar).
	      findWordAt: function(pos) {
	        var doc = this.doc, line = getLine(doc, pos.line).text;
	        var start = pos.ch, end = pos.ch;
	        if (line) {
	          var helper = this.getHelper(pos, "wordChars");
	          if ((pos.sticky == "before" || end == line.length) && start) { --start; } else { ++end; }
	          var startChar = line.charAt(start);
	          var check = isWordChar(startChar, helper)
	            ? function (ch) { return isWordChar(ch, helper); }
	            : /\s/.test(startChar) ? function (ch) { return /\s/.test(ch); }
	            : function (ch) { return (!/\s/.test(ch) && !isWordChar(ch)); };
	          while (start > 0 && check(line.charAt(start - 1))) { --start; }
	          while (end < line.length && check(line.charAt(end))) { ++end; }
	        }
	        return new Range(Pos(pos.line, start), Pos(pos.line, end))
	      },
	
	      toggleOverwrite: function(value) {
	        if (value != null && value == this.state.overwrite) { return }
	        if (this.state.overwrite = !this.state.overwrite)
	          { addClass(this.display.cursorDiv, "CodeMirror-overwrite"); }
	        else
	          { rmClass(this.display.cursorDiv, "CodeMirror-overwrite"); }
	
	        signal(this, "overwriteToggle", this, this.state.overwrite);
	      },
	      hasFocus: function() { return this.display.input.getField() == activeElt() },
	      isReadOnly: function() { return !!(this.options.readOnly || this.doc.cantEdit) },
	
	      scrollTo: methodOp(function (x, y) { scrollToCoords(this, x, y); }),
	      getScrollInfo: function() {
	        var scroller = this.display.scroller;
	        return {left: scroller.scrollLeft, top: scroller.scrollTop,
	                height: scroller.scrollHeight - scrollGap(this) - this.display.barHeight,
	                width: scroller.scrollWidth - scrollGap(this) - this.display.barWidth,
	                clientHeight: displayHeight(this), clientWidth: displayWidth(this)}
	      },
	
	      scrollIntoView: methodOp(function(range, margin) {
	        if (range == null) {
	          range = {from: this.doc.sel.primary().head, to: null};
	          if (margin == null) { margin = this.options.cursorScrollMargin; }
	        } else if (typeof range == "number") {
	          range = {from: Pos(range, 0), to: null};
	        } else if (range.from == null) {
	          range = {from: range, to: null};
	        }
	        if (!range.to) { range.to = range.from; }
	        range.margin = margin || 0;
	
	        if (range.from.line != null) {
	          scrollToRange(this, range);
	        } else {
	          scrollToCoordsRange(this, range.from, range.to, range.margin);
	        }
	      }),
	
	      setSize: methodOp(function(width, height) {
	        var this$1 = this;
	
	        var interpret = function (val) { return typeof val == "number" || /^\d+$/.test(String(val)) ? val + "px" : val; };
	        if (width != null) { this.display.wrapper.style.width = interpret(width); }
	        if (height != null) { this.display.wrapper.style.height = interpret(height); }
	        if (this.options.lineWrapping) { clearLineMeasurementCache(this); }
	        var lineNo = this.display.viewFrom;
	        this.doc.iter(lineNo, this.display.viewTo, function (line) {
	          if (line.widgets) { for (var i = 0; i < line.widgets.length; i++)
	            { if (line.widgets[i].noHScroll) { regLineChange(this$1, lineNo, "widget"); break } } }
	          ++lineNo;
	        });
	        this.curOp.forceUpdate = true;
	        signal(this, "refresh", this);
	      }),
	
	      operation: function(f){return runInOp(this, f)},
	      startOperation: function(){return startOperation(this)},
	      endOperation: function(){return endOperation(this)},
	
	      refresh: methodOp(function() {
	        var oldHeight = this.display.cachedTextHeight;
	        regChange(this);
	        this.curOp.forceUpdate = true;
	        clearCaches(this);
	        scrollToCoords(this, this.doc.scrollLeft, this.doc.scrollTop);
	        updateGutterSpace(this.display);
	        if (oldHeight == null || Math.abs(oldHeight - textHeight(this.display)) > .5 || this.options.lineWrapping)
	          { estimateLineHeights(this); }
	        signal(this, "refresh", this);
	      }),
	
	      swapDoc: methodOp(function(doc) {
	        var old = this.doc;
	        old.cm = null;
	        // Cancel the current text selection if any (#5821)
	        if (this.state.selectingText) { this.state.selectingText(); }
	        attachDoc(this, doc);
	        clearCaches(this);
	        this.display.input.reset();
	        scrollToCoords(this, doc.scrollLeft, doc.scrollTop);
	        this.curOp.forceScroll = true;
	        signalLater(this, "swapDoc", this, old);
	        return old
	      }),
	
	      phrase: function(phraseText) {
	        var phrases = this.options.phrases;
	        return phrases && Object.prototype.hasOwnProperty.call(phrases, phraseText) ? phrases[phraseText] : phraseText
	      },
	
	      getInputField: function(){return this.display.input.getField()},
	      getWrapperElement: function(){return this.display.wrapper},
	      getScrollerElement: function(){return this.display.scroller},
	      getGutterElement: function(){return this.display.gutters}
	    };
	    eventMixin(CodeMirror);
	
	    CodeMirror.registerHelper = function(type, name, value) {
	      if (!helpers.hasOwnProperty(type)) { helpers[type] = CodeMirror[type] = {_global: []}; }
	      helpers[type][name] = value;
	    };
	    CodeMirror.registerGlobalHelper = function(type, name, predicate, value) {
	      CodeMirror.registerHelper(type, name, value);
	      helpers[type]._global.push({pred: predicate, val: value});
	    };
	  }
	
	  // Used for horizontal relative motion. Dir is -1 or 1 (left or
	  // right), unit can be "codepoint", "char", "column" (like char, but
	  // doesn't cross line boundaries), "word" (across next word), or
	  // "group" (to the start of next group of word or
	  // non-word-non-whitespace chars). The visually param controls
	  // whether, in right-to-left text, direction 1 means to move towards
	  // the next index in the string, or towards the character to the right
	  // of the current position. The resulting position will have a
	  // hitSide=true property if it reached the end of the document.
	  function findPosH(doc, pos, dir, unit, visually) {
	    var oldPos = pos;
	    var origDir = dir;
	    var lineObj = getLine(doc, pos.line);
	    var lineDir = visually && doc.direction == "rtl" ? -dir : dir;
	    function findNextLine() {
	      var l = pos.line + lineDir;
	      if (l < doc.first || l >= doc.first + doc.size) { return false }
	      pos = new Pos(l, pos.ch, pos.sticky);
	      return lineObj = getLine(doc, l)
	    }
	    function moveOnce(boundToLine) {
	      var next;
	      if (unit == "codepoint") {
	        var ch = lineObj.text.charCodeAt(pos.ch + (dir > 0 ? 0 : -1));
	        if (isNaN(ch)) {
	          next = null;
	        } else {
	          var astral = dir > 0 ? ch >= 0xD800 && ch < 0xDC00 : ch >= 0xDC00 && ch < 0xDFFF;
	          next = new Pos(pos.line, Math.max(0, Math.min(lineObj.text.length, pos.ch + dir * (astral ? 2 : 1))), -dir);
	        }
	      } else if (visually) {
	        next = moveVisually(doc.cm, lineObj, pos, dir);
	      } else {
	        next = moveLogically(lineObj, pos, dir);
	      }
	      if (next == null) {
	        if (!boundToLine && findNextLine())
	          { pos = endOfLine(visually, doc.cm, lineObj, pos.line, lineDir); }
	        else
	          { return false }
	      } else {
	        pos = next;
	      }
	      return true
	    }
	
	    if (unit == "char" || unit == "codepoint") {
	      moveOnce();
	    } else if (unit == "column") {
	      moveOnce(true);
	    } else if (unit == "word" || unit == "group") {
	      var sawType = null, group = unit == "group";
	      var helper = doc.cm && doc.cm.getHelper(pos, "wordChars");
	      for (var first = true;; first = false) {
	        if (dir < 0 && !moveOnce(!first)) { break }
	        var cur = lineObj.text.charAt(pos.ch) || "\n";
	        var type = isWordChar(cur, helper) ? "w"
	          : group && cur == "\n" ? "n"
	          : !group || /\s/.test(cur) ? null
	          : "p";
	        if (group && !first && !type) { type = "s"; }
	        if (sawType && sawType != type) {
	          if (dir < 0) {dir = 1; moveOnce(); pos.sticky = "after";}
	          break
	        }
	
	        if (type) { sawType = type; }
	        if (dir > 0 && !moveOnce(!first)) { break }
	      }
	    }
	    var result = skipAtomic(doc, pos, oldPos, origDir, true);
	    if (equalCursorPos(oldPos, result)) { result.hitSide = true; }
	    return result
	  }
	
	  // For relative vertical movement. Dir may be -1 or 1. Unit can be
	  // "page" or "line". The resulting position will have a hitSide=true
	  // property if it reached the end of the document.
	  function findPosV(cm, pos, dir, unit) {
	    var doc = cm.doc, x = pos.left, y;
	    if (unit == "page") {
	      var pageSize = Math.min(cm.display.wrapper.clientHeight, window.innerHeight || document.documentElement.clientHeight);
	      var moveAmount = Math.max(pageSize - .5 * textHeight(cm.display), 3);
	      y = (dir > 0 ? pos.bottom : pos.top) + dir * moveAmount;
	
	    } else if (unit == "line") {
	      y = dir > 0 ? pos.bottom + 3 : pos.top - 3;
	    }
	    var target;
	    for (;;) {
	      target = coordsChar(cm, x, y);
	      if (!target.outside) { break }
	      if (dir < 0 ? y <= 0 : y >= doc.height) { target.hitSide = true; break }
	      y += dir * 5;
	    }
	    return target
	  }
	
	  // CONTENTEDITABLE INPUT STYLE
	
	  var ContentEditableInput = function(cm) {
	    this.cm = cm;
	    this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null;
	    this.polling = new Delayed();
	    this.composing = null;
	    this.gracePeriod = false;
	    this.readDOMTimeout = null;
	  };
	
	  ContentEditableInput.prototype.init = function (display) {
	      var this$1 = this;
	
	    var input = this, cm = input.cm;
	    var div = input.div = display.lineDiv;
	    div.contentEditable = true;
	    disableBrowserMagic(div, cm.options.spellcheck, cm.options.autocorrect, cm.options.autocapitalize);
	
	    function belongsToInput(e) {
	      for (var t = e.target; t; t = t.parentNode) {
	        if (t == div) { return true }
	        if (/\bCodeMirror-(?:line)?widget\b/.test(t.className)) { break }
	      }
	      return false
	    }
	
	    on(div, "paste", function (e) {
	      if (!belongsToInput(e) || signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }
	      // IE doesn't fire input events, so we schedule a read for the pasted content in this way
	      if (ie_version <= 11) { setTimeout(operation(cm, function () { return this$1.updateFromDOM(); }), 20); }
	    });
	
	    on(div, "compositionstart", function (e) {
	      this$1.composing = {data: e.data, done: false};
	    });
	    on(div, "compositionupdate", function (e) {
	      if (!this$1.composing) { this$1.composing = {data: e.data, done: false}; }
	    });
	    on(div, "compositionend", function (e) {
	      if (this$1.composing) {
	        if (e.data != this$1.composing.data) { this$1.readFromDOMSoon(); }
	        this$1.composing.done = true;
	      }
	    });
	
	    on(div, "touchstart", function () { return input.forceCompositionEnd(); });
	
	    on(div, "input", function () {
	      if (!this$1.composing) { this$1.readFromDOMSoon(); }
	    });
	
	    function onCopyCut(e) {
	      if (!belongsToInput(e) || signalDOMEvent(cm, e)) { return }
	      if (cm.somethingSelected()) {
	        setLastCopied({lineWise: false, text: cm.getSelections()});
	        if (e.type == "cut") { cm.replaceSelection("", null, "cut"); }
	      } else if (!cm.options.lineWiseCopyCut) {
	        return
	      } else {
	        var ranges = copyableRanges(cm);
	        setLastCopied({lineWise: true, text: ranges.text});
	        if (e.type == "cut") {
	          cm.operation(function () {
	            cm.setSelections(ranges.ranges, 0, sel_dontScroll);
	            cm.replaceSelection("", null, "cut");
	          });
	        }
	      }
	      if (e.clipboardData) {
	        e.clipboardData.clearData();
	        var content = lastCopied.text.join("\n");
	        // iOS exposes the clipboard API, but seems to discard content inserted into it
	        e.clipboardData.setData("Text", content);
	        if (e.clipboardData.getData("Text") == content) {
	          e.preventDefault();
	          return
	        }
	      }
	      // Old-fashioned briefly-focus-a-textarea hack
	      var kludge = hiddenTextarea(), te = kludge.firstChild;
	      cm.display.lineSpace.insertBefore(kludge, cm.display.lineSpace.firstChild);
	      te.value = lastCopied.text.join("\n");
	      var hadFocus = activeElt();
	      selectInput(te);
	      setTimeout(function () {
	        cm.display.lineSpace.removeChild(kludge);
	        hadFocus.focus();
	        if (hadFocus == div) { input.showPrimarySelection(); }
	      }, 50);
	    }
	    on(div, "copy", onCopyCut);
	    on(div, "cut", onCopyCut);
	  };
	
	  ContentEditableInput.prototype.screenReaderLabelChanged = function (label) {
	    // Label for screenreaders, accessibility
	    if(label) {
	      this.div.setAttribute('aria-label', label);
	    } else {
	      this.div.removeAttribute('aria-label');
	    }
	  };
	
	  ContentEditableInput.prototype.prepareSelection = function () {
	    var result = prepareSelection(this.cm, false);
	    result.focus = activeElt() == this.div;
	    return result
	  };
	
	  ContentEditableInput.prototype.showSelection = function (info, takeFocus) {
	    if (!info || !this.cm.display.view.length) { return }
	    if (info.focus || takeFocus) { this.showPrimarySelection(); }
	    this.showMultipleSelections(info);
	  };
	
	  ContentEditableInput.prototype.getSelection = function () {
	    return this.cm.display.wrapper.ownerDocument.getSelection()
	  };
	
	  ContentEditableInput.prototype.showPrimarySelection = function () {
	    var sel = this.getSelection(), cm = this.cm, prim = cm.doc.sel.primary();
	    var from = prim.from(), to = prim.to();
	
	    if (cm.display.viewTo == cm.display.viewFrom || from.line >= cm.display.viewTo || to.line < cm.display.viewFrom) {
	      sel.removeAllRanges();
	      return
	    }
	
	    var curAnchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
	    var curFocus = domToPos(cm, sel.focusNode, sel.focusOffset);
	    if (curAnchor && !curAnchor.bad && curFocus && !curFocus.bad &&
	        cmp(minPos(curAnchor, curFocus), from) == 0 &&
	        cmp(maxPos(curAnchor, curFocus), to) == 0)
	      { return }
	
	    var view = cm.display.view;
	    var start = (from.line >= cm.display.viewFrom && posToDOM(cm, from)) ||
	        {node: view[0].measure.map[2], offset: 0};
	    var end = to.line < cm.display.viewTo && posToDOM(cm, to);
	    if (!end) {
	      var measure = view[view.length - 1].measure;
	      var map = measure.maps ? measure.maps[measure.maps.length - 1] : measure.map;
	      end = {node: map[map.length - 1], offset: map[map.length - 2] - map[map.length - 3]};
	    }
	
	    if (!start || !end) {
	      sel.removeAllRanges();
	      return
	    }
	
	    var old = sel.rangeCount && sel.getRangeAt(0), rng;
	    try { rng = range(start.node, start.offset, end.offset, end.node); }
	    catch(e) {} // Our model of the DOM might be outdated, in which case the range we try to set can be impossible
	    if (rng) {
	      if (!gecko && cm.state.focused) {
	        sel.collapse(start.node, start.offset);
	        if (!rng.collapsed) {
	          sel.removeAllRanges();
	          sel.addRange(rng);
	        }
	      } else {
	        sel.removeAllRanges();
	        sel.addRange(rng);
	      }
	      if (old && sel.anchorNode == null) { sel.addRange(old); }
	      else if (gecko) { this.startGracePeriod(); }
	    }
	    this.rememberSelection();
	  };
	
	  ContentEditableInput.prototype.startGracePeriod = function () {
	      var this$1 = this;
	
	    clearTimeout(this.gracePeriod);
	    this.gracePeriod = setTimeout(function () {
	      this$1.gracePeriod = false;
	      if (this$1.selectionChanged())
	        { this$1.cm.operation(function () { return this$1.cm.curOp.selectionChanged = true; }); }
	    }, 20);
	  };
	
	  ContentEditableInput.prototype.showMultipleSelections = function (info) {
	    removeChildrenAndAdd(this.cm.display.cursorDiv, info.cursors);
	    removeChildrenAndAdd(this.cm.display.selectionDiv, info.selection);
	  };
	
	  ContentEditableInput.prototype.rememberSelection = function () {
	    var sel = this.getSelection();
	    this.lastAnchorNode = sel.anchorNode; this.lastAnchorOffset = sel.anchorOffset;
	    this.lastFocusNode = sel.focusNode; this.lastFocusOffset = sel.focusOffset;
	  };
	
	  ContentEditableInput.prototype.selectionInEditor = function () {
	    var sel = this.getSelection();
	    if (!sel.rangeCount) { return false }
	    var node = sel.getRangeAt(0).commonAncestorContainer;
	    return contains(this.div, node)
	  };
	
	  ContentEditableInput.prototype.focus = function () {
	    if (this.cm.options.readOnly != "nocursor") {
	      if (!this.selectionInEditor() || activeElt() != this.div)
	        { this.showSelection(this.prepareSelection(), true); }
	      this.div.focus();
	    }
	  };
	  ContentEditableInput.prototype.blur = function () { this.div.blur(); };
	  ContentEditableInput.prototype.getField = function () { return this.div };
	
	  ContentEditableInput.prototype.supportsTouch = function () { return true };
	
	  ContentEditableInput.prototype.receivedFocus = function () {
	      var this$1 = this;
	
	    var input = this;
	    if (this.selectionInEditor())
	      { setTimeout(function () { return this$1.pollSelection(); }, 20); }
	    else
	      { runInOp(this.cm, function () { return input.cm.curOp.selectionChanged = true; }); }
	
	    function poll() {
	      if (input.cm.state.focused) {
	        input.pollSelection();
	        input.polling.set(input.cm.options.pollInterval, poll);
	      }
	    }
	    this.polling.set(this.cm.options.pollInterval, poll);
	  };
	
	  ContentEditableInput.prototype.selectionChanged = function () {
	    var sel = this.getSelection();
	    return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset ||
	      sel.focusNode != this.lastFocusNode || sel.focusOffset != this.lastFocusOffset
	  };
	
	  ContentEditableInput.prototype.pollSelection = function () {
	    if (this.readDOMTimeout != null || this.gracePeriod || !this.selectionChanged()) { return }
	    var sel = this.getSelection(), cm = this.cm;
	    // On Android Chrome (version 56, at least), backspacing into an
	    // uneditable block element will put the cursor in that element,
	    // and then, because it's not editable, hide the virtual keyboard.
	    // Because Android doesn't allow us to actually detect backspace
	    // presses in a sane way, this code checks for when that happens
	    // and simulates a backspace press in this case.
	    if (android && chrome && this.cm.display.gutterSpecs.length && isInGutter(sel.anchorNode)) {
	      this.cm.triggerOnKeyDown({type: "keydown", keyCode: 8, preventDefault: Math.abs});
	      this.blur();
	      this.focus();
	      return
	    }
	    if (this.composing) { return }
	    this.rememberSelection();
	    var anchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
	    var head = domToPos(cm, sel.focusNode, sel.focusOffset);
	    if (anchor && head) { runInOp(cm, function () {
	      setSelection(cm.doc, simpleSelection(anchor, head), sel_dontScroll);
	      if (anchor.bad || head.bad) { cm.curOp.selectionChanged = true; }
	    }); }
	  };
	
	  ContentEditableInput.prototype.pollContent = function () {
	    if (this.readDOMTimeout != null) {
	      clearTimeout(this.readDOMTimeout);
	      this.readDOMTimeout = null;
	    }
	
	    var cm = this.cm, display = cm.display, sel = cm.doc.sel.primary();
	    var from = sel.from(), to = sel.to();
	    if (from.ch == 0 && from.line > cm.firstLine())
	      { from = Pos(from.line - 1, getLine(cm.doc, from.line - 1).length); }
	    if (to.ch == getLine(cm.doc, to.line).text.length && to.line < cm.lastLine())
	      { to = Pos(to.line + 1, 0); }
	    if (from.line < display.viewFrom || to.line > display.viewTo - 1) { return false }
	
	    var fromIndex, fromLine, fromNode;
	    if (from.line == display.viewFrom || (fromIndex = findViewIndex(cm, from.line)) == 0) {
	      fromLine = lineNo(display.view[0].line);
	      fromNode = display.view[0].node;
	    } else {
	      fromLine = lineNo(display.view[fromIndex].line);
	      fromNode = display.view[fromIndex - 1].node.nextSibling;
	    }
	    var toIndex = findViewIndex(cm, to.line);
	    var toLine, toNode;
	    if (toIndex == display.view.length - 1) {
	      toLine = display.viewTo - 1;
	      toNode = display.lineDiv.lastChild;
	    } else {
	      toLine = lineNo(display.view[toIndex + 1].line) - 1;
	      toNode = display.view[toIndex + 1].node.previousSibling;
	    }
	
	    if (!fromNode) { return false }
	    var newText = cm.doc.splitLines(domTextBetween(cm, fromNode, toNode, fromLine, toLine));
	    var oldText = getBetween(cm.doc, Pos(fromLine, 0), Pos(toLine, getLine(cm.doc, toLine).text.length));
	    while (newText.length > 1 && oldText.length > 1) {
	      if (lst(newText) == lst(oldText)) { newText.pop(); oldText.pop(); toLine--; }
	      else if (newText[0] == oldText[0]) { newText.shift(); oldText.shift(); fromLine++; }
	      else { break }
	    }
	
	    var cutFront = 0, cutEnd = 0;
	    var newTop = newText[0], oldTop = oldText[0], maxCutFront = Math.min(newTop.length, oldTop.length);
	    while (cutFront < maxCutFront && newTop.charCodeAt(cutFront) == oldTop.charCodeAt(cutFront))
	      { ++cutFront; }
	    var newBot = lst(newText), oldBot = lst(oldText);
	    var maxCutEnd = Math.min(newBot.length - (newText.length == 1 ? cutFront : 0),
	                             oldBot.length - (oldText.length == 1 ? cutFront : 0));
	    while (cutEnd < maxCutEnd &&
	           newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1))
	      { ++cutEnd; }
	    // Try to move start of change to start of selection if ambiguous
	    if (newText.length == 1 && oldText.length == 1 && fromLine == from.line) {
	      while (cutFront && cutFront > from.ch &&
	             newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)) {
	        cutFront--;
	        cutEnd++;
	      }
	    }
	
	    newText[newText.length - 1] = newBot.slice(0, newBot.length - cutEnd).replace(/^\u200b+/, "");
	    newText[0] = newText[0].slice(cutFront).replace(/\u200b+$/, "");
	
	    var chFrom = Pos(fromLine, cutFront);
	    var chTo = Pos(toLine, oldText.length ? lst(oldText).length - cutEnd : 0);
	    if (newText.length > 1 || newText[0] || cmp(chFrom, chTo)) {
	      replaceRange(cm.doc, newText, chFrom, chTo, "+input");
	      return true
	    }
	  };
	
	  ContentEditableInput.prototype.ensurePolled = function () {
	    this.forceCompositionEnd();
	  };
	  ContentEditableInput.prototype.reset = function () {
	    this.forceCompositionEnd();
	  };
	  ContentEditableInput.prototype.forceCompositionEnd = function () {
	    if (!this.composing) { return }
	    clearTimeout(this.readDOMTimeout);
	    this.composing = null;
	    this.updateFromDOM();
	    this.div.blur();
	    this.div.focus();
	  };
	  ContentEditableInput.prototype.readFromDOMSoon = function () {
	      var this$1 = this;
	
	    if (this.readDOMTimeout != null) { return }
	    this.readDOMTimeout = setTimeout(function () {
	      this$1.readDOMTimeout = null;
	      if (this$1.composing) {
	        if (this$1.composing.done) { this$1.composing = null; }
	        else { return }
	      }
	      this$1.updateFromDOM();
	    }, 80);
	  };
	
	  ContentEditableInput.prototype.updateFromDOM = function () {
	      var this$1 = this;
	
	    if (this.cm.isReadOnly() || !this.pollContent())
	      { runInOp(this.cm, function () { return regChange(this$1.cm); }); }
	  };
	
	  ContentEditableInput.prototype.setUneditable = function (node) {
	    node.contentEditable = "false";
	  };
	
	  ContentEditableInput.prototype.onKeyPress = function (e) {
	    if (e.charCode == 0 || this.composing) { return }
	    e.preventDefault();
	    if (!this.cm.isReadOnly())
	      { operation(this.cm, applyTextInput)(this.cm, String.fromCharCode(e.charCode == null ? e.keyCode : e.charCode), 0); }
	  };
	
	  ContentEditableInput.prototype.readOnlyChanged = function (val) {
	    this.div.contentEditable = String(val != "nocursor");
	  };
	
	  ContentEditableInput.prototype.onContextMenu = function () {};
	  ContentEditableInput.prototype.resetPosition = function () {};
	
	  ContentEditableInput.prototype.needsContentAttribute = true;
	
	  function posToDOM(cm, pos) {
	    var view = findViewForLine(cm, pos.line);
	    if (!view || view.hidden) { return null }
	    var line = getLine(cm.doc, pos.line);
	    var info = mapFromLineView(view, line, pos.line);
	
	    var order = getOrder(line, cm.doc.direction), side = "left";
	    if (order) {
	      var partPos = getBidiPartAt(order, pos.ch);
	      side = partPos % 2 ? "right" : "left";
	    }
	    var result = nodeAndOffsetInLineMap(info.map, pos.ch, side);
	    result.offset = result.collapse == "right" ? result.end : result.start;
	    return result
	  }
	
	  function isInGutter(node) {
	    for (var scan = node; scan; scan = scan.parentNode)
	      { if (/CodeMirror-gutter-wrapper/.test(scan.className)) { return true } }
	    return false
	  }
	
	  function badPos(pos, bad) { if (bad) { pos.bad = true; } return pos }
	
	  function domTextBetween(cm, from, to, fromLine, toLine) {
	    var text = "", closing = false, lineSep = cm.doc.lineSeparator(), extraLinebreak = false;
	    function recognizeMarker(id) { return function (marker) { return marker.id == id; } }
	    function close() {
	      if (closing) {
	        text += lineSep;
	        if (extraLinebreak) { text += lineSep; }
	        closing = extraLinebreak = false;
	      }
	    }
	    function addText(str) {
	      if (str) {
	        close();
	        text += str;
	      }
	    }
	    function walk(node) {
	      if (node.nodeType == 1) {
	        var cmText = node.getAttribute("cm-text");
	        if (cmText) {
	          addText(cmText);
	          return
	        }
	        var markerID = node.getAttribute("cm-marker"), range;
	        if (markerID) {
	          var found = cm.findMarks(Pos(fromLine, 0), Pos(toLine + 1, 0), recognizeMarker(+markerID));
	          if (found.length && (range = found[0].find(0)))
	            { addText(getBetween(cm.doc, range.from, range.to).join(lineSep)); }
	          return
	        }
	        if (node.getAttribute("contenteditable") == "false") { return }
	        var isBlock = /^(pre|div|p|li|table|br)$/i.test(node.nodeName);
	        if (!/^br$/i.test(node.nodeName) && node.textContent.length == 0) { return }
	
	        if (isBlock) { close(); }
	        for (var i = 0; i < node.childNodes.length; i++)
	          { walk(node.childNodes[i]); }
	
	        if (/^(pre|p)$/i.test(node.nodeName)) { extraLinebreak = true; }
	        if (isBlock) { closing = true; }
	      } else if (node.nodeType == 3) {
	        addText(node.nodeValue.replace(/\u200b/g, "").replace(/\u00a0/g, " "));
	      }
	    }
	    for (;;) {
	      walk(from);
	      if (from == to) { break }
	      from = from.nextSibling;
	      extraLinebreak = false;
	    }
	    return text
	  }
	
	  function domToPos(cm, node, offset) {
	    var lineNode;
	    if (node == cm.display.lineDiv) {
	      lineNode = cm.display.lineDiv.childNodes[offset];
	      if (!lineNode) { return badPos(cm.clipPos(Pos(cm.display.viewTo - 1)), true) }
	      node = null; offset = 0;
	    } else {
	      for (lineNode = node;; lineNode = lineNode.parentNode) {
	        if (!lineNode || lineNode == cm.display.lineDiv) { return null }
	        if (lineNode.parentNode && lineNode.parentNode == cm.display.lineDiv) { break }
	      }
	    }
	    for (var i = 0; i < cm.display.view.length; i++) {
	      var lineView = cm.display.view[i];
	      if (lineView.node == lineNode)
	        { return locateNodeInLineView(lineView, node, offset) }
	    }
	  }
	
	  function locateNodeInLineView(lineView, node, offset) {
	    var wrapper = lineView.text.firstChild, bad = false;
	    if (!node || !contains(wrapper, node)) { return badPos(Pos(lineNo(lineView.line), 0), true) }
	    if (node == wrapper) {
	      bad = true;
	      node = wrapper.childNodes[offset];
	      offset = 0;
	      if (!node) {
	        var line = lineView.rest ? lst(lineView.rest) : lineView.line;
	        return badPos(Pos(lineNo(line), line.text.length), bad)
	      }
	    }
	
	    var textNode = node.nodeType == 3 ? node : null, topNode = node;
	    if (!textNode && node.childNodes.length == 1 && node.firstChild.nodeType == 3) {
	      textNode = node.firstChild;
	      if (offset) { offset = textNode.nodeValue.length; }
	    }
	    while (topNode.parentNode != wrapper) { topNode = topNode.parentNode; }
	    var measure = lineView.measure, maps = measure.maps;
	
	    function find(textNode, topNode, offset) {
	      for (var i = -1; i < (maps ? maps.length : 0); i++) {
	        var map = i < 0 ? measure.map : maps[i];
	        for (var j = 0; j < map.length; j += 3) {
	          var curNode = map[j + 2];
	          if (curNode == textNode || curNode == topNode) {
	            var line = lineNo(i < 0 ? lineView.line : lineView.rest[i]);
	            var ch = map[j] + offset;
	            if (offset < 0 || curNode != textNode) { ch = map[j + (offset ? 1 : 0)]; }
	            return Pos(line, ch)
	          }
	        }
	      }
	    }
	    var found = find(textNode, topNode, offset);
	    if (found) { return badPos(found, bad) }
	
	    // FIXME this is all really shaky. might handle the few cases it needs to handle, but likely to cause problems
	    for (var after = topNode.nextSibling, dist = textNode ? textNode.nodeValue.length - offset : 0; after; after = after.nextSibling) {
	      found = find(after, after.firstChild, 0);
	      if (found)
	        { return badPos(Pos(found.line, found.ch - dist), bad) }
	      else
	        { dist += after.textContent.length; }
	    }
	    for (var before = topNode.previousSibling, dist$1 = offset; before; before = before.previousSibling) {
	      found = find(before, before.firstChild, -1);
	      if (found)
	        { return badPos(Pos(found.line, found.ch + dist$1), bad) }
	      else
	        { dist$1 += before.textContent.length; }
	    }
	  }
	
	  // TEXTAREA INPUT STYLE
	
	  var TextareaInput = function(cm) {
	    this.cm = cm;
	    // See input.poll and input.reset
	    this.prevInput = "";
	
	    // Flag that indicates whether we expect input to appear real soon
	    // now (after some event like 'keypress' or 'input') and are
	    // polling intensively.
	    this.pollingFast = false;
	    // Self-resetting timeout for the poller
	    this.polling = new Delayed();
	    // Used to work around IE issue with selection being forgotten when focus moves away from textarea
	    this.hasSelection = false;
	    this.composing = null;
	  };
	
	  TextareaInput.prototype.init = function (display) {
	      var this$1 = this;
	
	    var input = this, cm = this.cm;
	    this.createField(display);
	    var te = this.textarea;
	
	    display.wrapper.insertBefore(this.wrapper, display.wrapper.firstChild);
	
	    // Needed to hide big blue blinking cursor on Mobile Safari (doesn't seem to work in iOS 8 anymore)
	    if (ios) { te.style.width = "0px"; }
	
	    on(te, "input", function () {
	      if (ie && ie_version >= 9 && this$1.hasSelection) { this$1.hasSelection = null; }
	      input.poll();
	    });
	
	    on(te, "paste", function (e) {
	      if (signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }
	
	      cm.state.pasteIncoming = +new Date;
	      input.fastPoll();
	    });
	
	    function prepareCopyCut(e) {
	      if (signalDOMEvent(cm, e)) { return }
	      if (cm.somethingSelected()) {
	        setLastCopied({lineWise: false, text: cm.getSelections()});
	      } else if (!cm.options.lineWiseCopyCut) {
	        return
	      } else {
	        var ranges = copyableRanges(cm);
	        setLastCopied({lineWise: true, text: ranges.text});
	        if (e.type == "cut") {
	          cm.setSelections(ranges.ranges, null, sel_dontScroll);
	        } else {
	          input.prevInput = "";
	          te.value = ranges.text.join("\n");
	          selectInput(te);
	        }
	      }
	      if (e.type == "cut") { cm.state.cutIncoming = +new Date; }
	    }
	    on(te, "cut", prepareCopyCut);
	    on(te, "copy", prepareCopyCut);
	
	    on(display.scroller, "paste", function (e) {
	      if (eventInWidget(display, e) || signalDOMEvent(cm, e)) { return }
	      if (!te.dispatchEvent) {
	        cm.state.pasteIncoming = +new Date;
	        input.focus();
	        return
	      }
	
	      // Pass the `paste` event to the textarea so it's handled by its event listener.
	      var event = new Event("paste");
	      event.clipboardData = e.clipboardData;
	      te.dispatchEvent(event);
	    });
	
	    // Prevent normal selection in the editor (we handle our own)
	    on(display.lineSpace, "selectstart", function (e) {
	      if (!eventInWidget(display, e)) { e_preventDefault(e); }
	    });
	
	    on(te, "compositionstart", function () {
	      var start = cm.getCursor("from");
	      if (input.composing) { input.composing.range.clear(); }
	      input.composing = {
	        start: start,
	        range: cm.markText(start, cm.getCursor("to"), {className: "CodeMirror-composing"})
	      };
	    });
	    on(te, "compositionend", function () {
	      if (input.composing) {
	        input.poll();
	        input.composing.range.clear();
	        input.composing = null;
	      }
	    });
	  };
	
	  TextareaInput.prototype.createField = function (_display) {
	    // Wraps and hides input textarea
	    this.wrapper = hiddenTextarea();
	    // The semihidden textarea that is focused when the editor is
	    // focused, and receives input.
	    this.textarea = this.wrapper.firstChild;
	  };
	
	  TextareaInput.prototype.screenReaderLabelChanged = function (label) {
	    // Label for screenreaders, accessibility
	    if(label) {
	      this.textarea.setAttribute('aria-label', label);
	    } else {
	      this.textarea.removeAttribute('aria-label');
	    }
	  };
	
	  TextareaInput.prototype.prepareSelection = function () {
	    // Redraw the selection and/or cursor
	    var cm = this.cm, display = cm.display, doc = cm.doc;
	    var result = prepareSelection(cm);
	
	    // Move the hidden textarea near the cursor to prevent scrolling artifacts
	    if (cm.options.moveInputWithCursor) {
	      var headPos = cursorCoords(cm, doc.sel.primary().head, "div");
	      var wrapOff = display.wrapper.getBoundingClientRect(), lineOff = display.lineDiv.getBoundingClientRect();
	      result.teTop = Math.max(0, Math.min(display.wrapper.clientHeight - 10,
	                                          headPos.top + lineOff.top - wrapOff.top));
	      result.teLeft = Math.max(0, Math.min(display.wrapper.clientWidth - 10,
	                                           headPos.left + lineOff.left - wrapOff.left));
	    }
	
	    return result
	  };
	
	  TextareaInput.prototype.showSelection = function (drawn) {
	    var cm = this.cm, display = cm.display;
	    removeChildrenAndAdd(display.cursorDiv, drawn.cursors);
	    removeChildrenAndAdd(display.selectionDiv, drawn.selection);
	    if (drawn.teTop != null) {
	      this.wrapper.style.top = drawn.teTop + "px";
	      this.wrapper.style.left = drawn.teLeft + "px";
	    }
	  };
	
	  // Reset the input to correspond to the selection (or to be empty,
	  // when not typing and nothing is selected)
	  TextareaInput.prototype.reset = function (typing) {
	    if (this.contextMenuPending || this.composing) { return }
	    var cm = this.cm;
	    if (cm.somethingSelected()) {
	      this.prevInput = "";
	      var content = cm.getSelection();
	      this.textarea.value = content;
	      if (cm.state.focused) { selectInput(this.textarea); }
	      if (ie && ie_version >= 9) { this.hasSelection = content; }
	    } else if (!typing) {
	      this.prevInput = this.textarea.value = "";
	      if (ie && ie_version >= 9) { this.hasSelection = null; }
	    }
	  };
	
	  TextareaInput.prototype.getField = function () { return this.textarea };
	
	  TextareaInput.prototype.supportsTouch = function () { return false };
	
	  TextareaInput.prototype.focus = function () {
	    if (this.cm.options.readOnly != "nocursor" && (!mobile || activeElt() != this.textarea)) {
	      try { this.textarea.focus(); }
	      catch (e) {} // IE8 will throw if the textarea is display: none or not in DOM
	    }
	  };
	
	  TextareaInput.prototype.blur = function () { this.textarea.blur(); };
	
	  TextareaInput.prototype.resetPosition = function () {
	    this.wrapper.style.top = this.wrapper.style.left = 0;
	  };
	
	  TextareaInput.prototype.receivedFocus = function () { this.slowPoll(); };
	
	  // Poll for input changes, using the normal rate of polling. This
	  // runs as long as the editor is focused.
	  TextareaInput.prototype.slowPoll = function () {
	      var this$1 = this;
	
	    if (this.pollingFast) { return }
	    this.polling.set(this.cm.options.pollInterval, function () {
	      this$1.poll();
	      if (this$1.cm.state.focused) { this$1.slowPoll(); }
	    });
	  };
	
	  // When an event has just come in that is likely to add or change
	  // something in the input textarea, we poll faster, to ensure that
	  // the change appears on the screen quickly.
	  TextareaInput.prototype.fastPoll = function () {
	    var missed = false, input = this;
	    input.pollingFast = true;
	    function p() {
	      var changed = input.poll();
	      if (!changed && !missed) {missed = true; input.polling.set(60, p);}
	      else {input.pollingFast = false; input.slowPoll();}
	    }
	    input.polling.set(20, p);
	  };
	
	  // Read input from the textarea, and update the document to match.
	  // When something is selected, it is present in the textarea, and
	  // selected (unless it is huge, in which case a placeholder is
	  // used). When nothing is selected, the cursor sits after previously
	  // seen text (can be empty), which is stored in prevInput (we must
	  // not reset the textarea when typing, because that breaks IME).
	  TextareaInput.prototype.poll = function () {
	      var this$1 = this;
	
	    var cm = this.cm, input = this.textarea, prevInput = this.prevInput;
	    // Since this is called a *lot*, try to bail out as cheaply as
	    // possible when it is clear that nothing happened. hasSelection
	    // will be the case when there is a lot of text in the textarea,
	    // in which case reading its value would be expensive.
	    if (this.contextMenuPending || !cm.state.focused ||
	        (hasSelection(input) && !prevInput && !this.composing) ||
	        cm.isReadOnly() || cm.options.disableInput || cm.state.keySeq)
	      { return false }
	
	    var text = input.value;
	    // If nothing changed, bail.
	    if (text == prevInput && !cm.somethingSelected()) { return false }
	    // Work around nonsensical selection resetting in IE9/10, and
	    // inexplicable appearance of private area unicode characters on
	    // some key combos in Mac (#2689).
	    if (ie && ie_version >= 9 && this.hasSelection === text ||
	        mac && /[\uf700-\uf7ff]/.test(text)) {
	      cm.display.input.reset();
	      return false
	    }
	
	    if (cm.doc.sel == cm.display.selForContextMenu) {
	      var first = text.charCodeAt(0);
	      if (first == 0x200b && !prevInput) { prevInput = "\u200b"; }
	      if (first == 0x21da) { this.reset(); return this.cm.execCommand("undo") }
	    }
	    // Find the part of the input that is actually new
	    var same = 0, l = Math.min(prevInput.length, text.length);
	    while (same < l && prevInput.charCodeAt(same) == text.charCodeAt(same)) { ++same; }
	
	    runInOp(cm, function () {
	      applyTextInput(cm, text.slice(same), prevInput.length - same,
	                     null, this$1.composing ? "*compose" : null);
	
	      // Don't leave long text in the textarea, since it makes further polling slow
	      if (text.length > 1000 || text.indexOf("\n") > -1) { input.value = this$1.prevInput = ""; }
	      else { this$1.prevInput = text; }
	
	      if (this$1.composing) {
	        this$1.composing.range.clear();
	        this$1.composing.range = cm.markText(this$1.composing.start, cm.getCursor("to"),
	                                           {className: "CodeMirror-composing"});
	      }
	    });
	    return true
	  };
	
	  TextareaInput.prototype.ensurePolled = function () {
	    if (this.pollingFast && this.poll()) { this.pollingFast = false; }
	  };
	
	  TextareaInput.prototype.onKeyPress = function () {
	    if (ie && ie_version >= 9) { this.hasSelection = null; }
	    this.fastPoll();
	  };
	
	  TextareaInput.prototype.onContextMenu = function (e) {
	    var input = this, cm = input.cm, display = cm.display, te = input.textarea;
	    if (input.contextMenuPending) { input.contextMenuPending(); }
	    var pos = posFromMouse(cm, e), scrollPos = display.scroller.scrollTop;
	    if (!pos || presto) { return } // Opera is difficult.
	
	    // Reset the current text selection only if the click is done outside of the selection
	    // and 'resetSelectionOnContextMenu' option is true.
	    var reset = cm.options.resetSelectionOnContextMenu;
	    if (reset && cm.doc.sel.contains(pos) == -1)
	      { operation(cm, setSelection)(cm.doc, simpleSelection(pos), sel_dontScroll); }
	
	    var oldCSS = te.style.cssText, oldWrapperCSS = input.wrapper.style.cssText;
	    var wrapperBox = input.wrapper.offsetParent.getBoundingClientRect();
	    input.wrapper.style.cssText = "position: static";
	    te.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (e.clientY - wrapperBox.top - 5) + "px; left: " + (e.clientX - wrapperBox.left - 5) + "px;\n      z-index: 1000; background: " + (ie ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);";
	    var oldScrollY;
	    if (webkit) { oldScrollY = window.scrollY; } // Work around Chrome issue (#2712)
	    display.input.focus();
	    if (webkit) { window.scrollTo(null, oldScrollY); }
	    display.input.reset();
	    // Adds "Select all" to context menu in FF
	    if (!cm.somethingSelected()) { te.value = input.prevInput = " "; }
	    input.contextMenuPending = rehide;
	    display.selForContextMenu = cm.doc.sel;
	    clearTimeout(display.detectingSelectAll);
	
	    // Select-all will be greyed out if there's nothing to select, so
	    // this adds a zero-width space so that we can later check whether
	    // it got selected.
	    function prepareSelectAllHack() {
	      if (te.selectionStart != null) {
	        var selected = cm.somethingSelected();
	        var extval = "\u200b" + (selected ? te.value : "");
	        te.value = "\u21da"; // Used to catch context-menu undo
	        te.value = extval;
	        input.prevInput = selected ? "" : "\u200b";
	        te.selectionStart = 1; te.selectionEnd = extval.length;
	        // Re-set this, in case some other handler touched the
	        // selection in the meantime.
	        display.selForContextMenu = cm.doc.sel;
	      }
	    }
	    function rehide() {
	      if (input.contextMenuPending != rehide) { return }
	      input.contextMenuPending = false;
	      input.wrapper.style.cssText = oldWrapperCSS;
	      te.style.cssText = oldCSS;
	      if (ie && ie_version < 9) { display.scrollbars.setScrollTop(display.scroller.scrollTop = scrollPos); }
	
	      // Try to detect the user choosing select-all
	      if (te.selectionStart != null) {
	        if (!ie || (ie && ie_version < 9)) { prepareSelectAllHack(); }
	        var i = 0, poll = function () {
	          if (display.selForContextMenu == cm.doc.sel && te.selectionStart == 0 &&
	              te.selectionEnd > 0 && input.prevInput == "\u200b") {
	            operation(cm, selectAll)(cm);
	          } else if (i++ < 10) {
	            display.detectingSelectAll = setTimeout(poll, 500);
	          } else {
	            display.selForContextMenu = null;
	            display.input.reset();
	          }
	        };
	        display.detectingSelectAll = setTimeout(poll, 200);
	      }
	    }
	
	    if (ie && ie_version >= 9) { prepareSelectAllHack(); }
	    if (captureRightClick) {
	      e_stop(e);
	      var mouseup = function () {
	        off(window, "mouseup", mouseup);
	        setTimeout(rehide, 20);
	      };
	      on(window, "mouseup", mouseup);
	    } else {
	      setTimeout(rehide, 50);
	    }
	  };
	
	  TextareaInput.prototype.readOnlyChanged = function (val) {
	    if (!val) { this.reset(); }
	    this.textarea.disabled = val == "nocursor";
	    this.textarea.readOnly = !!val;
	  };
	
	  TextareaInput.prototype.setUneditable = function () {};
	
	  TextareaInput.prototype.needsContentAttribute = false;
	
	  function fromTextArea(textarea, options) {
	    options = options ? copyObj(options) : {};
	    options.value = textarea.value;
	    if (!options.tabindex && textarea.tabIndex)
	      { options.tabindex = textarea.tabIndex; }
	    if (!options.placeholder && textarea.placeholder)
	      { options.placeholder = textarea.placeholder; }
	    // Set autofocus to true if this textarea is focused, or if it has
	    // autofocus and no other element is focused.
	    if (options.autofocus == null) {
	      var hasFocus = activeElt();
	      options.autofocus = hasFocus == textarea ||
	        textarea.getAttribute("autofocus") != null && hasFocus == document.body;
	    }
	
	    function save() {textarea.value = cm.getValue();}
	
	    var realSubmit;
	    if (textarea.form) {
	      on(textarea.form, "submit", save);
	      // Deplorable hack to make the submit method do the right thing.
	      if (!options.leaveSubmitMethodAlone) {
	        var form = textarea.form;
	        realSubmit = form.submit;
	        try {
	          var wrappedSubmit = form.submit = function () {
	            save();
	            form.submit = realSubmit;
	            form.submit();
	            form.submit = wrappedSubmit;
	          };
	        } catch(e) {}
	      }
	    }
	
	    options.finishInit = function (cm) {
	      cm.save = save;
	      cm.getTextArea = function () { return textarea; };
	      cm.toTextArea = function () {
	        cm.toTextArea = isNaN; // Prevent this from being ran twice
	        save();
	        textarea.parentNode.removeChild(cm.getWrapperElement());
	        textarea.style.display = "";
	        if (textarea.form) {
	          off(textarea.form, "submit", save);
	          if (!options.leaveSubmitMethodAlone && typeof textarea.form.submit == "function")
	            { textarea.form.submit = realSubmit; }
	        }
	      };
	    };
	
	    textarea.style.display = "none";
	    var cm = CodeMirror(function (node) { return textarea.parentNode.insertBefore(node, textarea.nextSibling); },
	      options);
	    return cm
	  }
	
	  function addLegacyProps(CodeMirror) {
	    CodeMirror.off = off;
	    CodeMirror.on = on;
	    CodeMirror.wheelEventPixels = wheelEventPixels;
	    CodeMirror.Doc = Doc;
	    CodeMirror.splitLines = splitLinesAuto;
	    CodeMirror.countColumn = countColumn;
	    CodeMirror.findColumn = findColumn;
	    CodeMirror.isWordChar = isWordCharBasic;
	    CodeMirror.Pass = Pass;
	    CodeMirror.signal = signal;
	    CodeMirror.Line = Line;
	    CodeMirror.changeEnd = changeEnd;
	    CodeMirror.scrollbarModel = scrollbarModel;
	    CodeMirror.Pos = Pos;
	    CodeMirror.cmpPos = cmp;
	    CodeMirror.modes = modes;
	    CodeMirror.mimeModes = mimeModes;
	    CodeMirror.resolveMode = resolveMode;
	    CodeMirror.getMode = getMode;
	    CodeMirror.modeExtensions = modeExtensions;
	    CodeMirror.extendMode = extendMode;
	    CodeMirror.copyState = copyState;
	    CodeMirror.startState = startState;
	    CodeMirror.innerMode = innerMode;
	    CodeMirror.commands = commands;
	    CodeMirror.keyMap = keyMap;
	    CodeMirror.keyName = keyName;
	    CodeMirror.isModifierKey = isModifierKey;
	    CodeMirror.lookupKey = lookupKey;
	    CodeMirror.normalizeKeyMap = normalizeKeyMap;
	    CodeMirror.StringStream = StringStream;
	    CodeMirror.SharedTextMarker = SharedTextMarker;
	    CodeMirror.TextMarker = TextMarker;
	    CodeMirror.LineWidget = LineWidget;
	    CodeMirror.e_preventDefault = e_preventDefault;
	    CodeMirror.e_stopPropagation = e_stopPropagation;
	    CodeMirror.e_stop = e_stop;
	    CodeMirror.addClass = addClass;
	    CodeMirror.contains = contains;
	    CodeMirror.rmClass = rmClass;
	    CodeMirror.keyNames = keyNames;
	  }
	
	  // EDITOR CONSTRUCTOR
	
	  defineOptions(CodeMirror);
	
	  addEditorMethods(CodeMirror);
	
	  // Set up methods on CodeMirror's prototype to redirect to the editor's document.
	  var dontDelegate = "iter insert remove copy getEditor constructor".split(" ");
	  for (var prop in Doc.prototype) { if (Doc.prototype.hasOwnProperty(prop) && indexOf(dontDelegate, prop) < 0)
	    { CodeMirror.prototype[prop] = (function(method) {
	      return function() {return method.apply(this.doc, arguments)}
	    })(Doc.prototype[prop]); } }
	
	  eventMixin(Doc);
	  CodeMirror.inputStyles = {"textarea": TextareaInput, "contenteditable": ContentEditableInput};
	
	  // Extra arguments are stored as the mode's dependencies, which is
	  // used by (legacy) mechanisms like loadmode.js to automatically
	  // load a mode. (Preferred mechanism is the require/define calls.)
	  CodeMirror.defineMode = function(name/*, mode, …*/) {
	    if (!CodeMirror.defaults.mode && name != "null") { CodeMirror.defaults.mode = name; }
	    defineMode.apply(this, arguments);
	  };
	
	  CodeMirror.defineMIME = defineMIME;
	
	  // Minimal default mode.
	  CodeMirror.defineMode("null", function () { return ({token: function (stream) { return stream.skipToEnd(); }}); });
	  CodeMirror.defineMIME("text/plain", "null");
	
	  // EXTENSIONS
	
	  CodeMirror.defineExtension = function (name, func) {
	    CodeMirror.prototype[name] = func;
	  };
	  CodeMirror.defineDocExtension = function (name, func) {
	    Doc.prototype[name] = func;
	  };
	
	  CodeMirror.fromTextArea = fromTextArea;
	
	  addLegacyProps(CodeMirror);
	
	  CodeMirror.version = "5.65.2";
	
	  return CodeMirror;
	
	})));


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var EventPluginRegistry = __webpack_require__(144);
	var EventPluginUtils = __webpack_require__(145);
	var ReactErrorUtils = __webpack_require__(149);
	
	var accumulateInto = __webpack_require__(379);
	var forEachAccumulated = __webpack_require__(380);
	var invariant = __webpack_require__(11);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(79);
	var EventPluginUtils = __webpack_require__(145);
	
	var accumulateInto = __webpack_require__(379);
	var forEachAccumulated = __webpack_require__(380);
	var warning = __webpack_require__(15);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 81 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(43);
	
	var getEventTarget = __webpack_require__(154);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 83 */
/***/ function(module, exports) {

	//Types of elements found in the DOM
	module.exports = {
		Text: "text", //Text
		Directive: "directive", //<? ... ?>
		Comment: "comment", //<!-- ... -->
		Script: "script", //<script> tags
		Style: "style", //<style> tags
		Tag: "tag", //Any tag
		CDATA: "cdata", //<![CDATA[ ... ]]>
		Doctype: "doctype",
	
		isTag: function(elem){
			return elem.type === "tag" || elem.type === "script" || elem.type === "style";
		}
	};


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clamp = clamp;
	exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = exports.safePreventDefault = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function clamp(number, lowerBound, upperBound) {
	  return Math.max(lowerBound, Math.min(number, upperBound));
	}
	
	var safePreventDefault = function safePreventDefault(event) {
	  var passiveEvents = ["onTouchStart", "onTouchMove", "onWheel"];
	
	  if (!passiveEvents.includes(event._reactName)) {
	    event.preventDefault();
	  }
	};
	
	exports.safePreventDefault = safePreventDefault;
	
	var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
	  var onDemandSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
	      onDemandSlides.push(slideIndex);
	    }
	  }
	
	  return onDemandSlides;
	}; // return list of slides that need to be present
	
	
	exports.getOnDemandLazySlides = getOnDemandLazySlides;
	
	var getRequiredLazySlides = function getRequiredLazySlides(spec) {
	  var requiredSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    requiredSlides.push(slideIndex);
	  }
	
	  return requiredSlides;
	}; // startIndex that needs to be present
	
	
	exports.getRequiredLazySlides = getRequiredLazySlides;
	
	var lazyStartIndex = function lazyStartIndex(spec) {
	  return spec.currentSlide - lazySlidesOnLeft(spec);
	};
	
	exports.lazyStartIndex = lazyStartIndex;
	
	var lazyEndIndex = function lazyEndIndex(spec) {
	  return spec.currentSlide + lazySlidesOnRight(spec);
	};
	
	exports.lazyEndIndex = lazyEndIndex;
	
	var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
	  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
	};
	
	exports.lazySlidesOnLeft = lazySlidesOnLeft;
	
	var lazySlidesOnRight = function lazySlidesOnRight(spec) {
	  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
	}; // get width of an element
	
	
	exports.lazySlidesOnRight = lazySlidesOnRight;
	
	var getWidth = function getWidth(elem) {
	  return elem && elem.offsetWidth || 0;
	};
	
	exports.getWidth = getWidth;
	
	var getHeight = function getHeight(elem) {
	  return elem && elem.offsetHeight || 0;
	};
	
	exports.getHeight = getHeight;
	
	var getSwipeDirection = function getSwipeDirection(touchObject) {
	  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var xDist, yDist, r, swipeAngle;
	  xDist = touchObject.startX - touchObject.curX;
	  yDist = touchObject.startY - touchObject.curY;
	  r = Math.atan2(yDist, xDist);
	  swipeAngle = Math.round(r * 180 / Math.PI);
	
	  if (swipeAngle < 0) {
	    swipeAngle = 360 - Math.abs(swipeAngle);
	  }
	
	  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	    return "left";
	  }
	
	  if (swipeAngle >= 135 && swipeAngle <= 225) {
	    return "right";
	  }
	
	  if (verticalSwiping === true) {
	    if (swipeAngle >= 35 && swipeAngle <= 135) {
	      return "up";
	    } else {
	      return "down";
	    }
	  }
	
	  return "vertical";
	}; // whether or not we can go next
	
	
	exports.getSwipeDirection = getSwipeDirection;
	
	var canGoNext = function canGoNext(spec) {
	  var canGo = true;
	
	  if (!spec.infinite) {
	    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
	      canGo = false;
	    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
	      canGo = false;
	    }
	  }
	
	  return canGo;
	}; // given an object and a list of keys, return new object with given keys
	
	
	exports.canGoNext = canGoNext;
	
	var extractObject = function extractObject(spec, keys) {
	  var newObject = {};
	  keys.forEach(function (key) {
	    return newObject[key] = spec[key];
	  });
	  return newObject;
	}; // get initialized state
	
	
	exports.extractObject = extractObject;
	
	var initializedState = function initializedState(spec) {
	  // spec also contains listRef, trackRef
	  var slideCount = _react["default"].Children.count(spec.children);
	
	  var listNode = spec.listRef;
	  var listWidth = Math.ceil(getWidth(listNode));
	  var trackNode = spec.trackRef && spec.trackRef.node;
	  var trackWidth = Math.ceil(getWidth(trackNode));
	  var slideWidth;
	
	  if (!spec.vertical) {
	    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
	
	    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
	      centerPaddingAdj *= listWidth / 100;
	    }
	
	    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
	  } else {
	    slideWidth = listWidth;
	  }
	
	  var slideHeight = listNode && getHeight(listNode.querySelector('[data-index="0"]'));
	  var listHeight = slideHeight * spec.slidesToShow;
	  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
	
	  if (spec.rtl && spec.currentSlide === undefined) {
	    currentSlide = slideCount - 1 - spec.initialSlide;
	  }
	
	  var lazyLoadedList = spec.lazyLoadedList || [];
	  var slidesToLoad = getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
	    currentSlide: currentSlide,
	    lazyLoadedList: lazyLoadedList
	  }));
	  lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
	  var state = {
	    slideCount: slideCount,
	    slideWidth: slideWidth,
	    listWidth: listWidth,
	    trackWidth: trackWidth,
	    currentSlide: currentSlide,
	    slideHeight: slideHeight,
	    listHeight: listHeight,
	    lazyLoadedList: lazyLoadedList
	  };
	
	  if (spec.autoplaying === null && spec.autoplay) {
	    state["autoplaying"] = "playing";
	  }
	
	  return state;
	};
	
	exports.initializedState = initializedState;
	
	var slideHandler = function slideHandler(spec) {
	  var waitForAnimate = spec.waitForAnimate,
	      animating = spec.animating,
	      fade = spec.fade,
	      infinite = spec.infinite,
	      index = spec.index,
	      slideCount = spec.slideCount,
	      lazyLoad = spec.lazyLoad,
	      currentSlide = spec.currentSlide,
	      centerMode = spec.centerMode,
	      slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      useCSS = spec.useCSS;
	  var lazyLoadedList = spec.lazyLoadedList;
	  if (waitForAnimate && animating) return {};
	  var animationSlide = index,
	      finalSlide,
	      animationLeft,
	      finalLeft;
	  var state = {},
	      nextState = {};
	  var targetSlide = infinite ? index : clamp(index, 0, slideCount - 1);
	
	  if (fade) {
	    if (!infinite && (index < 0 || index >= slideCount)) return {};
	
	    if (index < 0) {
	      animationSlide = index + slideCount;
	    } else if (index >= slideCount) {
	      animationSlide = index - slideCount;
	    }
	
	    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
	      lazyLoadedList = lazyLoadedList.concat(animationSlide);
	    }
	
	    state = {
	      animating: true,
	      currentSlide: animationSlide,
	      lazyLoadedList: lazyLoadedList,
	      targetSlide: animationSlide
	    };
	    nextState = {
	      animating: false,
	      targetSlide: animationSlide
	    };
	  } else {
	    finalSlide = animationSlide;
	
	    if (animationSlide < 0) {
	      finalSlide = animationSlide + slideCount;
	      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
	    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
	      animationSlide = finalSlide = currentSlide;
	    } else if (centerMode && animationSlide >= slideCount) {
	      animationSlide = infinite ? slideCount : slideCount - 1;
	      finalSlide = infinite ? 0 : slideCount - 1;
	    } else if (animationSlide >= slideCount) {
	      finalSlide = animationSlide - slideCount;
	      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
	    }
	
	    if (!infinite && animationSlide + slidesToShow >= slideCount) {
	      finalSlide = slideCount - slidesToShow;
	    }
	
	    animationLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
	      slideIndex: animationSlide
	    }));
	    finalLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
	      slideIndex: finalSlide
	    }));
	
	    if (!infinite) {
	      if (animationLeft === finalLeft) animationSlide = finalSlide;
	      animationLeft = finalLeft;
	    }
	
	    if (lazyLoad) {
	      lazyLoadedList = lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
	        currentSlide: animationSlide
	      })));
	    }
	
	    if (!useCSS) {
	      state = {
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
	          left: finalLeft
	        })),
	        lazyLoadedList: lazyLoadedList,
	        targetSlide: targetSlide
	      };
	    } else {
	      state = {
	        animating: true,
	        currentSlide: finalSlide,
	        trackStyle: getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
	          left: animationLeft
	        })),
	        lazyLoadedList: lazyLoadedList,
	        targetSlide: targetSlide
	      };
	      nextState = {
	        animating: false,
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
	          left: finalLeft
	        })),
	        swipeLeft: null,
	        targetSlide: targetSlide
	      };
	    }
	  }
	
	  return {
	    state: state,
	    nextState: nextState
	  };
	};
	
	exports.slideHandler = slideHandler;
	
	var changeSlide = function changeSlide(spec, options) {
	  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	  var slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      slideCount = spec.slideCount,
	      currentSlide = spec.currentSlide,
	      previousTargetSlide = spec.targetSlide,
	      lazyLoad = spec.lazyLoad,
	      infinite = spec.infinite;
	  unevenOffset = slideCount % slidesToScroll !== 0;
	  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	  if (options.message === "previous") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	    targetSlide = currentSlide - slideOffset;
	
	    if (lazyLoad && !infinite) {
	      previousInt = currentSlide - slideOffset;
	      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	    }
	
	    if (!infinite) {
	      targetSlide = previousTargetSlide - slidesToScroll;
	    }
	  } else if (options.message === "next") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	    targetSlide = currentSlide + slideOffset;
	
	    if (lazyLoad && !infinite) {
	      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	    }
	
	    if (!infinite) {
	      targetSlide = previousTargetSlide + slidesToScroll;
	    }
	  } else if (options.message === "dots") {
	    // Click on dots
	    targetSlide = options.index * options.slidesToScroll;
	  } else if (options.message === "children") {
	    // Click on the slides
	    targetSlide = options.index;
	
	    if (infinite) {
	      var direction = siblingDirection(_objectSpread(_objectSpread({}, spec), {}, {
	        targetSlide: targetSlide
	      }));
	
	      if (targetSlide > options.currentSlide && direction === "left") {
	        targetSlide = targetSlide - slideCount;
	      } else if (targetSlide < options.currentSlide && direction === "right") {
	        targetSlide = targetSlide + slideCount;
	      }
	    }
	  } else if (options.message === "index") {
	    targetSlide = Number(options.index);
	  }
	
	  return targetSlide;
	};
	
	exports.changeSlide = changeSlide;
	
	var keyHandler = function keyHandler(e, accessibility, rtl) {
	  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
	  if (e.keyCode === 37) return rtl ? "next" : "previous";
	  if (e.keyCode === 39) return rtl ? "previous" : "next";
	  return "";
	};
	
	exports.keyHandler = keyHandler;
	
	var swipeStart = function swipeStart(e, swipe, draggable) {
	  e.target.tagName === "IMG" && safePreventDefault(e);
	  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
	  return {
	    dragging: true,
	    touchObject: {
	      startX: e.touches ? e.touches[0].pageX : e.clientX,
	      startY: e.touches ? e.touches[0].pageY : e.clientY,
	      curX: e.touches ? e.touches[0].pageX : e.clientX,
	      curY: e.touches ? e.touches[0].pageY : e.clientY
	    }
	  };
	};
	
	exports.swipeStart = swipeStart;
	
	var swipeMove = function swipeMove(e, spec) {
	  // spec also contains, trackRef and slideIndex
	  var scrolling = spec.scrolling,
	      animating = spec.animating,
	      vertical = spec.vertical,
	      swipeToSlide = spec.swipeToSlide,
	      verticalSwiping = spec.verticalSwiping,
	      rtl = spec.rtl,
	      currentSlide = spec.currentSlide,
	      edgeFriction = spec.edgeFriction,
	      edgeDragged = spec.edgeDragged,
	      onEdge = spec.onEdge,
	      swiped = spec.swiped,
	      swiping = spec.swiping,
	      slideCount = spec.slideCount,
	      slidesToScroll = spec.slidesToScroll,
	      infinite = spec.infinite,
	      touchObject = spec.touchObject,
	      swipeEvent = spec.swipeEvent,
	      listHeight = spec.listHeight,
	      listWidth = spec.listWidth;
	  if (scrolling) return;
	  if (animating) return safePreventDefault(e);
	  if (vertical && swipeToSlide && verticalSwiping) safePreventDefault(e);
	  var swipeLeft,
	      state = {};
	  var curLeft = getTrackLeft(spec);
	  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	
	  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
	    return {
	      scrolling: true
	    };
	  }
	
	  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
	  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	  var dotCount = Math.ceil(slideCount / slidesToScroll);
	  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
	  var touchSwipeLength = touchObject.swipeLength;
	
	  if (!infinite) {
	    if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
	      touchSwipeLength = touchObject.swipeLength * edgeFriction;
	
	      if (edgeDragged === false && onEdge) {
	        onEdge(swipeDirection);
	        state["edgeDragged"] = true;
	      }
	    }
	  }
	
	  if (!swiped && swipeEvent) {
	    swipeEvent(swipeDirection);
	    state["swiped"] = true;
	  }
	
	  if (!vertical) {
	    if (!rtl) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft - touchSwipeLength * positionOffset;
	    }
	  } else {
	    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
	  }
	
	  if (verticalSwiping) {
	    swipeLeft = curLeft + touchSwipeLength * positionOffset;
	  }
	
	  state = _objectSpread(_objectSpread({}, state), {}, {
	    touchObject: touchObject,
	    swipeLeft: swipeLeft,
	    trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
	      left: swipeLeft
	    }))
	  });
	
	  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	    return state;
	  }
	
	  if (touchObject.swipeLength > 10) {
	    state["swiping"] = true;
	    safePreventDefault(e);
	  }
	
	  return state;
	};
	
	exports.swipeMove = swipeMove;
	
	var swipeEnd = function swipeEnd(e, spec) {
	  var dragging = spec.dragging,
	      swipe = spec.swipe,
	      touchObject = spec.touchObject,
	      listWidth = spec.listWidth,
	      touchThreshold = spec.touchThreshold,
	      verticalSwiping = spec.verticalSwiping,
	      listHeight = spec.listHeight,
	      swipeToSlide = spec.swipeToSlide,
	      scrolling = spec.scrolling,
	      onSwipe = spec.onSwipe,
	      targetSlide = spec.targetSlide,
	      currentSlide = spec.currentSlide,
	      infinite = spec.infinite;
	
	  if (!dragging) {
	    if (swipe) safePreventDefault(e);
	    return {};
	  }
	
	  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
	  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.
	
	  var state = {
	    dragging: false,
	    edgeDragged: false,
	    scrolling: false,
	    swiping: false,
	    swiped: false,
	    swipeLeft: null,
	    touchObject: {}
	  };
	
	  if (scrolling) {
	    return state;
	  }
	
	  if (!touchObject.swipeLength) {
	    return state;
	  }
	
	  if (touchObject.swipeLength > minSwipe) {
	    safePreventDefault(e);
	
	    if (onSwipe) {
	      onSwipe(swipeDirection);
	    }
	
	    var slideCount, newSlide;
	    var activeSlide = infinite ? currentSlide : targetSlide;
	
	    switch (swipeDirection) {
	      case "left":
	      case "up":
	        newSlide = activeSlide + getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 0;
	        break;
	
	      case "right":
	      case "down":
	        newSlide = activeSlide - getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 1;
	        break;
	
	      default:
	        slideCount = activeSlide;
	    }
	
	    state["triggerSlideHandler"] = slideCount;
	  } else {
	    // Adjust the track back to it's original position.
	    var currentLeft = getTrackLeft(spec);
	    state["trackStyle"] = getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
	      left: currentLeft
	    }));
	  }
	
	  return state;
	};
	
	exports.swipeEnd = swipeEnd;
	
	var getNavigableIndexes = function getNavigableIndexes(spec) {
	  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
	  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var indexes = [];
	
	  while (breakpoint < max) {
	    indexes.push(breakpoint);
	    breakpoint = counter + spec.slidesToScroll;
	    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
	  }
	
	  return indexes;
	};
	
	exports.getNavigableIndexes = getNavigableIndexes;
	
	var checkNavigable = function checkNavigable(spec, index) {
	  var navigables = getNavigableIndexes(spec);
	  var prevNavigable = 0;
	
	  if (index > navigables[navigables.length - 1]) {
	    index = navigables[navigables.length - 1];
	  } else {
	    for (var n in navigables) {
	      if (index < navigables[n]) {
	        index = prevNavigable;
	        break;
	      }
	
	      prevNavigable = navigables[n];
	    }
	  }
	
	  return index;
	};
	
	exports.checkNavigable = checkNavigable;
	
	var getSlideCount = function getSlideCount(spec) {
	  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
	
	  if (spec.swipeToSlide) {
	    var swipedSlide;
	    var slickList = spec.listRef;
	    var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
	    Array.from(slides).every(function (slide) {
	      if (!spec.vertical) {
	        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      } else {
	        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      }
	
	      return true;
	    });
	
	    if (!swipedSlide) {
	      return 0;
	    }
	
	    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
	    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
	    return slidesTraversed;
	  } else {
	    return spec.slidesToScroll;
	  }
	};
	
	exports.getSlideCount = getSlideCount;
	
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error("Keys Missing:", spec);
	};
	
	exports.checkSpecKeys = checkSpecKeys;
	
	var getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
	  var trackWidth, trackHeight;
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	
	  if (!spec.vertical) {
	    trackWidth = getTotalSlides(spec) * spec.slideWidth;
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    transition: "",
	    WebkitTransition: ""
	  };
	
	  if (spec.useTransform) {
	    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
	    style = _objectSpread(_objectSpread({}, style), {}, {
	      WebkitTransform: WebkitTransform,
	      transform: transform,
	      msTransform: msTransform
	    });
	  } else {
	    if (spec.vertical) {
	      style["top"] = spec.left;
	    } else {
	      style["left"] = spec.left;
	    }
	  }
	
	  if (spec.fade) style = {
	    opacity: 1
	  };
	  if (trackWidth) style.width = trackWidth;
	  if (trackHeight) style.height = trackHeight; // Fallback for IE8
	
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + "px";
	    } else {
	      style.marginTop = spec.left + "px";
	    }
	  }
	
	  return style;
	};
	
	exports.getTrackCSS = getTrackCSS;
	
	var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
	  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined
	
	  if (spec.useTransform) {
	    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
	    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
	  } else {
	    if (spec.vertical) {
	      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
	    } else {
	      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	
	  return style;
	};
	
	exports.getTrackAnimateCSS = getTrackAnimateCSS;
	
	var getTrackLeft = function getTrackLeft(spec) {
	  if (spec.unslick) {
	    return 0;
	  }
	
	  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
	  var slideIndex = spec.slideIndex,
	      trackRef = spec.trackRef,
	      infinite = spec.infinite,
	      centerMode = spec.centerMode,
	      slideCount = spec.slideCount,
	      slidesToShow = spec.slidesToShow,
	      slidesToScroll = spec.slidesToScroll,
	      slideWidth = spec.slideWidth,
	      listWidth = spec.listWidth,
	      variableWidth = spec.variableWidth,
	      slideHeight = spec.slideHeight,
	      fade = spec.fade,
	      vertical = spec.vertical;
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (fade || spec.slideCount === 1) {
	    return 0;
	  }
	
	  var slidesToOffset = 0;
	
	  if (infinite) {
	    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
	    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
	
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
	    } // shift current slide to center of the frame
	
	
	    if (centerMode) {
	      slidesToOffset += parseInt(slidesToShow / 2);
	    }
	  } else {
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
	    }
	
	    if (centerMode) {
	      slidesToOffset = parseInt(slidesToShow / 2);
	    }
	  }
	
	  slideOffset = slidesToOffset * slideWidth;
	  verticalOffset = slidesToOffset * slideHeight;
	
	  if (!vertical) {
	    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
	  }
	
	  if (variableWidth === true) {
	    var targetSlideIndex;
	    var trackElem = trackRef && trackRef.node;
	    targetSlideIndex = slideIndex + getPreClones(spec);
	    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	
	    if (centerMode === true) {
	      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
	      targetSlide = trackElem && trackElem.children[targetSlideIndex];
	      targetLeft = 0;
	
	      for (var slide = 0; slide < targetSlideIndex; slide++) {
	        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
	      }
	
	      targetLeft -= parseInt(spec.centerPadding);
	      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
	    }
	  }
	
	  return targetLeft;
	};
	
	exports.getTrackLeft = getTrackLeft;
	
	var getPreClones = function getPreClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	
	  if (spec.variableWidth) {
	    return spec.slideCount;
	  }
	
	  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
	};
	
	exports.getPreClones = getPreClones;
	
	var getPostClones = function getPostClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	
	  return spec.slideCount;
	};
	
	exports.getPostClones = getPostClones;
	
	var getTotalSlides = function getTotalSlides(spec) {
	  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
	};
	
	exports.getTotalSlides = getTotalSlides;
	
	var siblingDirection = function siblingDirection(spec) {
	  if (spec.targetSlide > spec.currentSlide) {
	    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
	      return "left";
	    }
	
	    return "right";
	  } else {
	    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
	      return "right";
	    }
	
	    return "left";
	  }
	};
	
	exports.siblingDirection = siblingDirection;
	
	var slidesOnRight = function slidesOnRight(_ref) {
	  var slidesToShow = _ref.slidesToShow,
	      centerMode = _ref.centerMode,
	      rtl = _ref.rtl,
	      centerPadding = _ref.centerPadding;
	
	  // returns no of slides on the right of active slide
	  if (centerMode) {
	    var right = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) right += 1;
	    if (rtl && slidesToShow % 2 === 0) right += 1;
	    return right;
	  }
	
	  if (rtl) {
	    return 0;
	  }
	
	  return slidesToShow - 1;
	};
	
	exports.slidesOnRight = slidesOnRight;
	
	var slidesOnLeft = function slidesOnLeft(_ref2) {
	  var slidesToShow = _ref2.slidesToShow,
	      centerMode = _ref2.centerMode,
	      rtl = _ref2.rtl,
	      centerPadding = _ref2.centerPadding;
	
	  // returns no of slides on the left of active slide
	  if (centerMode) {
	    var left = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) left += 1;
	    if (!rtl && slidesToShow % 2 === 0) left += 1;
	    return left;
	  }
	
	  if (rtl) {
	    return slidesToShow - 1;
	  }
	
	  return 0;
	};
	
	exports.slidesOnLeft = slidesOnLeft;
	
	var canUseDOM = function canUseDOM() {
	  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
	};
	
	exports.canUseDOM = canUseDOM;

/***/ },
/* 85 */
14,
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ServerValues_1 = __webpack_require__(182);
	var nodeFromJSON_1 = __webpack_require__(68);
	var Path_1 = __webpack_require__(17);
	var SparseSnapshotTree_1 = __webpack_require__(170);
	var SyncTree_1 = __webpack_require__(428);
	var SnapshotHolder_1 = __webpack_require__(427);
	var util_1 = __webpack_require__(2);
	var util_2 = __webpack_require__(13);
	var util_3 = __webpack_require__(2);
	var AuthTokenProvider_1 = __webpack_require__(423);
	var StatsManager_1 = __webpack_require__(118);
	var StatsReporter_1 = __webpack_require__(434);
	var StatsListener_1 = __webpack_require__(179);
	var EventQueue_1 = __webpack_require__(445);
	var PersistentConnection_1 = __webpack_require__(167);
	var ReadonlyRestClient_1 = __webpack_require__(425);
	var Database_1 = __webpack_require__(164);
	var INTERRUPT_REASON = 'repo_interrupt';
	/**
	 * A connection to a single data repository.
	 */
	var Repo = /** @class */ (function () {
	    /**
	     * @param {!RepoInfo} repoInfo_
	     * @param {boolean} forceRestClient
	     * @param {!FirebaseApp} app
	     */
	    function Repo(repoInfo_, forceRestClient, app) {
	        var _this = this;
	        this.repoInfo_ = repoInfo_;
	        this.app = app;
	        this.dataUpdateCount = 0;
	        this.statsListener_ = null;
	        this.eventQueue_ = new EventQueue_1.EventQueue();
	        this.nextWriteId_ = 1;
	        this.interceptServerDataCallback_ = null;
	        // A list of data pieces and paths to be set when this client disconnects.
	        this.onDisconnect_ = new SparseSnapshotTree_1.SparseSnapshotTree();
	        /**
	         * TODO: This should be @private but it's used by test_access.js and internal.js
	         * @type {?PersistentConnection}
	         */
	        this.persistentConnection_ = null;
	        /** @type {!AuthTokenProvider} */
	        var authTokenProvider = new AuthTokenProvider_1.AuthTokenProvider(app);
	        this.stats_ = StatsManager_1.StatsManager.getCollection(repoInfo_);
	        if (forceRestClient || util_2.beingCrawled()) {
	            this.server_ = new ReadonlyRestClient_1.ReadonlyRestClient(this.repoInfo_, this.onDataUpdate_.bind(this), authTokenProvider);
	            // Minor hack: Fire onConnect immediately, since there's no actual connection.
	            setTimeout(this.onConnectStatus_.bind(this, true), 0);
	        }
	        else {
	            var authOverride = app.options['databaseAuthVariableOverride'];
	            // Validate authOverride
	            if (typeof authOverride !== 'undefined' && authOverride !== null) {
	                if (typeof authOverride !== 'object') {
	                    throw new Error('Only objects are supported for option databaseAuthVariableOverride');
	                }
	                try {
	                    util_1.stringify(authOverride);
	                }
	                catch (e) {
	                    throw new Error('Invalid authOverride provided: ' + e);
	                }
	            }
	            this.persistentConnection_ = new PersistentConnection_1.PersistentConnection(this.repoInfo_, this.onDataUpdate_.bind(this), this.onConnectStatus_.bind(this), this.onServerInfoUpdate_.bind(this), authTokenProvider, authOverride);
	            this.server_ = this.persistentConnection_;
	        }
	        authTokenProvider.addTokenChangeListener(function (token) {
	            _this.server_.refreshAuthToken(token);
	        });
	        // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
	        // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
	        this.statsReporter_ = StatsManager_1.StatsManager.getOrCreateReporter(repoInfo_, function () { return new StatsReporter_1.StatsReporter(_this.stats_, _this.server_); });
	        this.transactions_init_();
	        // Used for .info.
	        this.infoData_ = new SnapshotHolder_1.SnapshotHolder();
	        this.infoSyncTree_ = new SyncTree_1.SyncTree({
	            startListening: function (query, tag, currentHashFn, onComplete) {
	                var infoEvents = [];
	                var node = _this.infoData_.getNode(query.path);
	                // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
	                // on initial data...
	                if (!node.isEmpty()) {
	                    infoEvents = _this.infoSyncTree_.applyServerOverwrite(query.path, node);
	                    setTimeout(function () {
	                        onComplete('ok');
	                    }, 0);
	                }
	                return infoEvents;
	            },
	            stopListening: function () { }
	        });
	        this.updateInfo_('connected', false);
	        this.serverSyncTree_ = new SyncTree_1.SyncTree({
	            startListening: function (query, tag, currentHashFn, onComplete) {
	                _this.server_.listen(query, currentHashFn, tag, function (status, data) {
	                    var events = onComplete(status, data);
	                    _this.eventQueue_.raiseEventsForChangedPath(query.path, events);
	                });
	                // No synchronous events for network-backed sync trees
	                return [];
	            },
	            stopListening: function (query, tag) {
	                _this.server_.unlisten(query, tag);
	            }
	        });
	    }
	    /**
	     * @return {string}  The URL corresponding to the root of this Firebase.
	     */
	    Repo.prototype.toString = function () {
	        return ((this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host);
	    };
	    /**
	     * @return {!string} The namespace represented by the repo.
	     */
	    Repo.prototype.name = function () {
	        return this.repoInfo_.namespace;
	    };
	    /**
	     * @return {!number} The time in milliseconds, taking the server offset into account if we have one.
	     */
	    Repo.prototype.serverTime = function () {
	        var offsetNode = this.infoData_.getNode(new Path_1.Path('.info/serverTimeOffset'));
	        var offset = offsetNode.val() || 0;
	        return new Date().getTime() + offset;
	    };
	    /**
	     * Generate ServerValues using some variables from the repo object.
	     * @return {!Object}
	     */
	    Repo.prototype.generateServerValues = function () {
	        return ServerValues_1.generateWithValues({
	            timestamp: this.serverTime()
	        });
	    };
	    /**
	     * Called by realtime when we get new messages from the server.
	     *
	     * @private
	     * @param {string} pathString
	     * @param {*} data
	     * @param {boolean} isMerge
	     * @param {?number} tag
	     */
	    Repo.prototype.onDataUpdate_ = function (pathString, data, isMerge, tag) {
	        // For testing.
	        this.dataUpdateCount++;
	        var path = new Path_1.Path(pathString);
	        data = this.interceptServerDataCallback_
	            ? this.interceptServerDataCallback_(pathString, data)
	            : data;
	        var events = [];
	        if (tag) {
	            if (isMerge) {
	                var taggedChildren = util_3.map(data, function (raw) {
	                    return nodeFromJSON_1.nodeFromJSON(raw);
	                });
	                events = this.serverSyncTree_.applyTaggedQueryMerge(path, taggedChildren, tag);
	            }
	            else {
	                var taggedSnap = nodeFromJSON_1.nodeFromJSON(data);
	                events = this.serverSyncTree_.applyTaggedQueryOverwrite(path, taggedSnap, tag);
	            }
	        }
	        else if (isMerge) {
	            var changedChildren = util_3.map(data, function (raw) {
	                return nodeFromJSON_1.nodeFromJSON(raw);
	            });
	            events = this.serverSyncTree_.applyServerMerge(path, changedChildren);
	        }
	        else {
	            var snap = nodeFromJSON_1.nodeFromJSON(data);
	            events = this.serverSyncTree_.applyServerOverwrite(path, snap);
	        }
	        var affectedPath = path;
	        if (events.length > 0) {
	            // Since we have a listener outstanding for each transaction, receiving any events
	            // is a proxy for some change having occurred.
	            affectedPath = this.rerunTransactions_(path);
	        }
	        this.eventQueue_.raiseEventsForChangedPath(affectedPath, events);
	    };
	    /**
	     * TODO: This should be @private but it's used by test_access.js and internal.js
	     * @param {?function(!string, *):*} callback
	     * @private
	     */
	    Repo.prototype.interceptServerData_ = function (callback) {
	        this.interceptServerDataCallback_ = callback;
	    };
	    /**
	     * @param {!boolean} connectStatus
	     * @private
	     */
	    Repo.prototype.onConnectStatus_ = function (connectStatus) {
	        this.updateInfo_('connected', connectStatus);
	        if (connectStatus === false) {
	            this.runOnDisconnectEvents_();
	        }
	    };
	    /**
	     * @param {!Object} updates
	     * @private
	     */
	    Repo.prototype.onServerInfoUpdate_ = function (updates) {
	        var _this = this;
	        util_2.each(updates, function (value, key) {
	            _this.updateInfo_(key, value);
	        });
	    };
	    /**
	     *
	     * @param {!string} pathString
	     * @param {*} value
	     * @private
	     */
	    Repo.prototype.updateInfo_ = function (pathString, value) {
	        var path = new Path_1.Path('/.info/' + pathString);
	        var newNode = nodeFromJSON_1.nodeFromJSON(value);
	        this.infoData_.updateSnapshot(path, newNode);
	        var events = this.infoSyncTree_.applyServerOverwrite(path, newNode);
	        this.eventQueue_.raiseEventsForChangedPath(path, events);
	    };
	    /**
	     * @return {!number}
	     * @private
	     */
	    Repo.prototype.getNextWriteId_ = function () {
	        return this.nextWriteId_++;
	    };
	    /**
	     * @param {!Path} path
	     * @param {*} newVal
	     * @param {number|string|null} newPriority
	     * @param {?function(?Error, *=)} onComplete
	     */
	    Repo.prototype.setWithPriority = function (path, newVal, newPriority, onComplete) {
	        var _this = this;
	        this.log_('set', {
	            path: path.toString(),
	            value: newVal,
	            priority: newPriority
	        });
	        // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
	        // (b) store unresolved paths on JSON parse
	        var serverValues = this.generateServerValues();
	        var newNodeUnresolved = nodeFromJSON_1.nodeFromJSON(newVal, newPriority);
	        var newNode = ServerValues_1.resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
	        var writeId = this.getNextWriteId_();
	        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, writeId, true);
	        this.eventQueue_.queueEvents(events);
	        this.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), function (status, errorReason) {
	            var success = status === 'ok';
	            if (!success) {
	                util_2.warn('set at ' + path + ' failed: ' + status);
	            }
	            var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId, !success);
	            _this.eventQueue_.raiseEventsForChangedPath(path, clearEvents);
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	        var affectedPath = this.abortTransactions_(path);
	        this.rerunTransactions_(affectedPath);
	        // We queued the events above, so just flush the queue here
	        this.eventQueue_.raiseEventsForChangedPath(affectedPath, []);
	    };
	    /**
	     * @param {!Path} path
	     * @param {!Object} childrenToMerge
	     * @param {?function(?Error, *=)} onComplete
	     */
	    Repo.prototype.update = function (path, childrenToMerge, onComplete) {
	        var _this = this;
	        this.log_('update', { path: path.toString(), value: childrenToMerge });
	        // Start with our existing data and merge each child into it.
	        var empty = true;
	        var serverValues = this.generateServerValues();
	        var changedChildren = {};
	        util_3.forEach(childrenToMerge, function (changedKey, changedValue) {
	            empty = false;
	            var newNodeUnresolved = nodeFromJSON_1.nodeFromJSON(changedValue);
	            changedChildren[changedKey] = ServerValues_1.resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
	        });
	        if (!empty) {
	            var writeId_1 = this.getNextWriteId_();
	            var events = this.serverSyncTree_.applyUserMerge(path, changedChildren, writeId_1);
	            this.eventQueue_.queueEvents(events);
	            this.server_.merge(path.toString(), childrenToMerge, function (status, errorReason) {
	                var success = status === 'ok';
	                if (!success) {
	                    util_2.warn('update at ' + path + ' failed: ' + status);
	                }
	                var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId_1, !success);
	                var affectedPath = clearEvents.length > 0 ? _this.rerunTransactions_(path) : path;
	                _this.eventQueue_.raiseEventsForChangedPath(affectedPath, clearEvents);
	                _this.callOnCompleteCallback(onComplete, status, errorReason);
	            });
	            util_3.forEach(childrenToMerge, function (changedPath) {
	                var affectedPath = _this.abortTransactions_(path.child(changedPath));
	                _this.rerunTransactions_(affectedPath);
	            });
	            // We queued the events above, so just flush the queue here
	            this.eventQueue_.raiseEventsForChangedPath(path, []);
	        }
	        else {
	            util_2.log("update() called with empty data.  Don't do anything.");
	            this.callOnCompleteCallback(onComplete, 'ok');
	        }
	    };
	    /**
	     * Applies all of the changes stored up in the onDisconnect_ tree.
	     * @private
	     */
	    Repo.prototype.runOnDisconnectEvents_ = function () {
	        var _this = this;
	        this.log_('onDisconnectEvents');
	        var serverValues = this.generateServerValues();
	        var resolvedOnDisconnectTree = ServerValues_1.resolveDeferredValueTree(this.onDisconnect_, serverValues);
	        var events = [];
	        resolvedOnDisconnectTree.forEachTree(Path_1.Path.Empty, function (path, snap) {
	            events = events.concat(_this.serverSyncTree_.applyServerOverwrite(path, snap));
	            var affectedPath = _this.abortTransactions_(path);
	            _this.rerunTransactions_(affectedPath);
	        });
	        this.onDisconnect_ = new SparseSnapshotTree_1.SparseSnapshotTree();
	        this.eventQueue_.raiseEventsForChangedPath(Path_1.Path.Empty, events);
	    };
	    /**
	     * @param {!Path} path
	     * @param {?function(?Error, *=)} onComplete
	     */
	    Repo.prototype.onDisconnectCancel = function (path, onComplete) {
	        var _this = this;
	        this.server_.onDisconnectCancel(path.toString(), function (status, errorReason) {
	            if (status === 'ok') {
	                _this.onDisconnect_.forget(path);
	            }
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	    };
	    /**
	     * @param {!Path} path
	     * @param {*} value
	     * @param {?function(?Error, *=)} onComplete
	     */
	    Repo.prototype.onDisconnectSet = function (path, value, onComplete) {
	        var _this = this;
	        var newNode = nodeFromJSON_1.nodeFromJSON(value);
	        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
	            if (status === 'ok') {
	                _this.onDisconnect_.remember(path, newNode);
	            }
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	    };
	    /**
	     * @param {!Path} path
	     * @param {*} value
	     * @param {*} priority
	     * @param {?function(?Error, *=)} onComplete
	     */
	    Repo.prototype.onDisconnectSetWithPriority = function (path, value, priority, onComplete) {
	        var _this = this;
	        var newNode = nodeFromJSON_1.nodeFromJSON(value, priority);
	        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
	            if (status === 'ok') {
	                _this.onDisconnect_.remember(path, newNode);
	            }
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	    };
	    /**
	     * @param {!Path} path
	     * @param {*} childrenToMerge
	     * @param {?function(?Error, *=)} onComplete
	     */
	    Repo.prototype.onDisconnectUpdate = function (path, childrenToMerge, onComplete) {
	        var _this = this;
	        if (util_3.isEmpty(childrenToMerge)) {
	            util_2.log("onDisconnect().update() called with empty data.  Don't do anything.");
	            this.callOnCompleteCallback(onComplete, 'ok');
	            return;
	        }
	        this.server_.onDisconnectMerge(path.toString(), childrenToMerge, function (status, errorReason) {
	            if (status === 'ok') {
	                util_3.forEach(childrenToMerge, function (childName, childNode) {
	                    var newChildNode = nodeFromJSON_1.nodeFromJSON(childNode);
	                    _this.onDisconnect_.remember(path.child(childName), newChildNode);
	                });
	            }
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	    };
	    /**
	     * @param {!Query} query
	     * @param {!EventRegistration} eventRegistration
	     */
	    Repo.prototype.addEventCallbackForQuery = function (query, eventRegistration) {
	        var events;
	        if (query.path.getFront() === '.info') {
	            events = this.infoSyncTree_.addEventRegistration(query, eventRegistration);
	        }
	        else {
	            events = this.serverSyncTree_.addEventRegistration(query, eventRegistration);
	        }
	        this.eventQueue_.raiseEventsAtPath(query.path, events);
	    };
	    /**
	     * @param {!Query} query
	     * @param {?EventRegistration} eventRegistration
	     */
	    Repo.prototype.removeEventCallbackForQuery = function (query, eventRegistration) {
	        // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
	        // a little bit by handling the return values anyways.
	        var events;
	        if (query.path.getFront() === '.info') {
	            events = this.infoSyncTree_.removeEventRegistration(query, eventRegistration);
	        }
	        else {
	            events = this.serverSyncTree_.removeEventRegistration(query, eventRegistration);
	        }
	        this.eventQueue_.raiseEventsAtPath(query.path, events);
	    };
	    Repo.prototype.interrupt = function () {
	        if (this.persistentConnection_) {
	            this.persistentConnection_.interrupt(INTERRUPT_REASON);
	        }
	    };
	    Repo.prototype.resume = function () {
	        if (this.persistentConnection_) {
	            this.persistentConnection_.resume(INTERRUPT_REASON);
	        }
	    };
	    Repo.prototype.stats = function (showDelta) {
	        if (showDelta === void 0) { showDelta = false; }
	        if (typeof console === 'undefined')
	            return;
	        var stats;
	        if (showDelta) {
	            if (!this.statsListener_)
	                this.statsListener_ = new StatsListener_1.StatsListener(this.stats_);
	            stats = this.statsListener_.get();
	        }
	        else {
	            stats = this.stats_.get();
	        }
	        var longestName = Object.keys(stats).reduce(function (previousValue, currentValue) {
	            return Math.max(currentValue.length, previousValue);
	        }, 0);
	        util_3.forEach(stats, function (stat, value) {
	            // pad stat names to be the same length (plus 2 extra spaces).
	            for (var i = stat.length; i < longestName + 2; i++)
	                stat += ' ';
	            console.log(stat + value);
	        });
	    };
	    Repo.prototype.statsIncrementCounter = function (metric) {
	        this.stats_.incrementCounter(metric);
	        this.statsReporter_.includeStat(metric);
	    };
	    /**
	     * @param {...*} var_args
	     * @private
	     */
	    Repo.prototype.log_ = function () {
	        var var_args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            var_args[_i] = arguments[_i];
	        }
	        var prefix = '';
	        if (this.persistentConnection_) {
	            prefix = this.persistentConnection_.id + ':';
	        }
	        util_2.log.apply(void 0, [prefix].concat(var_args));
	    };
	    /**
	     * @param {?function(?Error, *=)} callback
	     * @param {!string} status
	     * @param {?string=} errorReason
	     */
	    Repo.prototype.callOnCompleteCallback = function (callback, status, errorReason) {
	        if (callback) {
	            util_2.exceptionGuard(function () {
	                if (status == 'ok') {
	                    callback(null);
	                }
	                else {
	                    var code = (status || 'error').toUpperCase();
	                    var message = code;
	                    if (errorReason)
	                        message += ': ' + errorReason;
	                    var error = new Error(message);
	                    error.code = code;
	                    callback(error);
	                }
	            });
	        }
	    };
	    Object.defineProperty(Repo.prototype, "database", {
	        get: function () {
	            return this.__database || (this.__database = new Database_1.Database(this));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Repo;
	}());
	exports.Repo = Repo;
	
	//# sourceMappingURL=Repo.js.map


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var util_2 = __webpack_require__(13);
	var snap_1 = __webpack_require__(178);
	var __childrenNodeConstructor;
	/**
	 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
	 * implements Node and stores the value of the node (a string,
	 * number, or boolean) accessible via getValue().
	 */
	var LeafNode = /** @class */ (function () {
	    /**
	     * @implements {Node}
	     * @param {!(string|number|boolean|Object)} value_ The value to store in this leaf node.
	     *                                         The object type is possible in the event of a deferred value
	     * @param {!Node=} priorityNode_ The priority of this node.
	     */
	    function LeafNode(value_, priorityNode_) {
	        if (priorityNode_ === void 0) { priorityNode_ = LeafNode.__childrenNodeConstructor.EMPTY_NODE; }
	        this.value_ = value_;
	        this.priorityNode_ = priorityNode_;
	        this.lazyHash_ = null;
	        util_1.assert(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
	        snap_1.validatePriorityNode(this.priorityNode_);
	    }
	    Object.defineProperty(LeafNode, "__childrenNodeConstructor", {
	        get: function () {
	            return __childrenNodeConstructor;
	        },
	        set: function (val) {
	            __childrenNodeConstructor = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @inheritDoc */
	    LeafNode.prototype.isLeafNode = function () {
	        return true;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.getPriority = function () {
	        return this.priorityNode_;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.updatePriority = function (newPriorityNode) {
	        return new LeafNode(this.value_, newPriorityNode);
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.getImmediateChild = function (childName) {
	        // Hack to treat priority as a regular child
	        if (childName === '.priority') {
	            return this.priorityNode_;
	        }
	        else {
	            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
	        }
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.getChild = function (path) {
	        if (path.isEmpty()) {
	            return this;
	        }
	        else if (path.getFront() === '.priority') {
	            return this.priorityNode_;
	        }
	        else {
	            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.hasChild = function () {
	        return false;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.getPredecessorChildName = function (childName, childNode) {
	        return null;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.updateImmediateChild = function (childName, newChildNode) {
	        if (childName === '.priority') {
	            return this.updatePriority(newChildNode);
	        }
	        else if (newChildNode.isEmpty() && childName !== '.priority') {
	            return this;
	        }
	        else {
	            return LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
	        }
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.updateChild = function (path, newChildNode) {
	        var front = path.getFront();
	        if (front === null) {
	            return newChildNode;
	        }
	        else if (newChildNode.isEmpty() && front !== '.priority') {
	            return this;
	        }
	        else {
	            util_1.assert(front !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
	            return this.updateImmediateChild(front, LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild(path.popFront(), newChildNode));
	        }
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.isEmpty = function () {
	        return false;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.numChildren = function () {
	        return 0;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.forEachChild = function (index, action) {
	        return false;
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.val = function (exportFormat) {
	        if (exportFormat && !this.getPriority().isEmpty())
	            return {
	                '.value': this.getValue(),
	                '.priority': this.getPriority().val()
	            };
	        else
	            return this.getValue();
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.hash = function () {
	        if (this.lazyHash_ === null) {
	            var toHash = '';
	            if (!this.priorityNode_.isEmpty())
	                toHash +=
	                    'priority:' +
	                        snap_1.priorityHashText(this.priorityNode_.val()) +
	                        ':';
	            var type = typeof this.value_;
	            toHash += type + ':';
	            if (type === 'number') {
	                toHash += util_2.doubleToIEEE754String(this.value_);
	            }
	            else {
	                toHash += this.value_;
	            }
	            this.lazyHash_ = util_2.sha1(toHash);
	        }
	        return this.lazyHash_;
	    };
	    /**
	     * Returns the value of the leaf node.
	     * @return {Object|string|number|boolean} The value of the node.
	     */
	    LeafNode.prototype.getValue = function () {
	        return this.value_;
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.compareTo = function (other) {
	        if (other === LeafNode.__childrenNodeConstructor.EMPTY_NODE) {
	            return 1;
	        }
	        else if (other instanceof LeafNode.__childrenNodeConstructor) {
	            return -1;
	        }
	        else {
	            util_1.assert(other.isLeafNode(), 'Unknown node type');
	            return this.compareToLeafNode_(other);
	        }
	    };
	    /**
	     * Comparison specifically for two leaf nodes
	     * @param {!LeafNode} otherLeaf
	     * @return {!number}
	     * @private
	     */
	    LeafNode.prototype.compareToLeafNode_ = function (otherLeaf) {
	        var otherLeafType = typeof otherLeaf.value_;
	        var thisLeafType = typeof this.value_;
	        var otherIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
	        var thisIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
	        util_1.assert(otherIndex >= 0, 'Unknown leaf type: ' + otherLeafType);
	        util_1.assert(thisIndex >= 0, 'Unknown leaf type: ' + thisLeafType);
	        if (otherIndex === thisIndex) {
	            // Same type, compare values
	            if (thisLeafType === 'object') {
	                // Deferred value nodes are all equal, but we should also never get to this point...
	                return 0;
	            }
	            else {
	                // Note that this works because true > false, all others are number or string comparisons
	                if (this.value_ < otherLeaf.value_) {
	                    return -1;
	                }
	                else if (this.value_ === otherLeaf.value_) {
	                    return 0;
	                }
	                else {
	                    return 1;
	                }
	            }
	        }
	        else {
	            return thisIndex - otherIndex;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.withIndex = function () {
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.isIndexed = function () {
	        return true;
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.equals = function (other) {
	        /**
	         * @inheritDoc
	         */
	        if (other === this) {
	            return true;
	        }
	        else if (other.isLeafNode()) {
	            var otherLeaf = other;
	            return (this.value_ === otherLeaf.value_ &&
	                this.priorityNode_.equals(otherLeaf.priorityNode_));
	        }
	        else {
	            return false;
	        }
	    };
	    /**
	     * The sort order for comparing leaf nodes of different types. If two leaf nodes have
	     * the same type, the comparison falls back to their value
	     * @type {Array.<!string>}
	     * @const
	     */
	    LeafNode.VALUE_TYPE_ORDER = ['object', 'boolean', 'number', 'string'];
	    return LeafNode;
	}());
	exports.LeafNode = LeafNode;
	
	//# sourceMappingURL=LeafNode.js.map


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Node_1 = __webpack_require__(30);
	var util_1 = __webpack_require__(13);
	/**
	 *
	 * @constructor
	 */
	var Index = /** @class */ (function () {
	    function Index() {
	    }
	    /**
	     * @return {function(!NamedNode, !NamedNode):number} A standalone comparison function for
	     * this index
	     */
	    Index.prototype.getCompare = function () {
	        return this.compare.bind(this);
	    };
	    /**
	     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
	     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
	     *
	     * @param {!Node} oldNode
	     * @param {!Node} newNode
	     * @return {boolean} True if the portion of the snapshot being indexed changed between oldNode and newNode
	     */
	    Index.prototype.indexedValueChanged = function (oldNode, newNode) {
	        var oldWrapped = new Node_1.NamedNode(util_1.MIN_NAME, oldNode);
	        var newWrapped = new Node_1.NamedNode(util_1.MIN_NAME, newNode);
	        return this.compare(oldWrapped, newWrapped) !== 0;
	    };
	    /**
	     * @return {!NamedNode} a node wrapper that will sort equal to or less than
	     * any other node wrapper, using this index
	     */
	    Index.prototype.minPost = function () {
	        return Node_1.NamedNode.MIN;
	    };
	    return Index;
	}());
	exports.Index = Index;
	
	//# sourceMappingURL=Index.js.map


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var DOMStorageWrapper_1 = __webpack_require__(435);
	var MemoryStorage_1 = __webpack_require__(436);
	/**
	 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
	 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
	 * to reflect this type
	 *
	 * @param {string} domStorageName Name of the underlying storage object
	 *   (e.g. 'localStorage' or 'sessionStorage').
	 * @return {?} Turning off type information until a common interface is defined.
	 */
	var createStoragefor = function (domStorageName) {
	    try {
	        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
	        // so it must be inside the try/catch.
	        if (typeof window !== 'undefined' &&
	            typeof window[domStorageName] !== 'undefined') {
	            // Need to test cache. Just because it's here doesn't mean it works
	            var domStorage = window[domStorageName];
	            domStorage.setItem('firebase:sentinel', 'cache');
	            domStorage.removeItem('firebase:sentinel');
	            return new DOMStorageWrapper_1.DOMStorageWrapper(domStorage);
	        }
	    }
	    catch (e) { }
	    // Failed to create wrapper.  Just return in-memory storage.
	    // TODO: log?
	    return new MemoryStorage_1.MemoryStorage();
	};
	/** A storage object that lasts across sessions */
	exports.PersistentStorage = createStoragefor('localStorage');
	/** A storage object that only lasts one session */
	exports.SessionStorage = createStoragefor('sessionStorage');
	
	//# sourceMappingURL=storage.js.map


/***/ },
/* 90 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * An iterator over an LLRBNode.
	 */
	var SortedMapIterator = /** @class */ (function () {
	    /**
	     * @template K, V, T
	     * @param {LLRBNode|LLRBEmptyNode} node Node to iterate.
	     * @param {?K} startKey
	     * @param {function(K, K): number} comparator
	     * @param {boolean} isReverse_ Whether or not to iterate in reverse
	     * @param {(function(K, V):T)=} resultGenerator_
	     */
	    function SortedMapIterator(node, startKey, comparator, isReverse_, resultGenerator_) {
	        if (resultGenerator_ === void 0) { resultGenerator_ = null; }
	        this.isReverse_ = isReverse_;
	        this.resultGenerator_ = resultGenerator_;
	        /** @private
	         * @type {Array.<!LLRBNode>}
	         */
	        this.nodeStack_ = [];
	        var cmp = 1;
	        while (!node.isEmpty()) {
	            node = node;
	            cmp = startKey ? comparator(node.key, startKey) : 1;
	            // flip the comparison if we're going in reverse
	            if (isReverse_)
	                cmp *= -1;
	            if (cmp < 0) {
	                // This node is less than our start key. ignore it
	                if (this.isReverse_) {
	                    node = node.left;
	                }
	                else {
	                    node = node.right;
	                }
	            }
	            else if (cmp === 0) {
	                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
	                this.nodeStack_.push(node);
	                break;
	            }
	            else {
	                // This node is greater than our start key, add it to the stack and move to the next one
	                this.nodeStack_.push(node);
	                if (this.isReverse_) {
	                    node = node.right;
	                }
	                else {
	                    node = node.left;
	                }
	            }
	        }
	    }
	    SortedMapIterator.prototype.getNext = function () {
	        if (this.nodeStack_.length === 0)
	            return null;
	        var node = this.nodeStack_.pop();
	        var result;
	        if (this.resultGenerator_)
	            result = this.resultGenerator_(node.key, node.value);
	        else
	            result = { key: node.key, value: node.value };
	        if (this.isReverse_) {
	            node = node.left;
	            while (!node.isEmpty()) {
	                this.nodeStack_.push(node);
	                node = node.right;
	            }
	        }
	        else {
	            node = node.right;
	            while (!node.isEmpty()) {
	                this.nodeStack_.push(node);
	                node = node.left;
	            }
	        }
	        return result;
	    };
	    SortedMapIterator.prototype.hasNext = function () {
	        return this.nodeStack_.length > 0;
	    };
	    SortedMapIterator.prototype.peek = function () {
	        if (this.nodeStack_.length === 0)
	            return null;
	        var node = this.nodeStack_[this.nodeStack_.length - 1];
	        if (this.resultGenerator_) {
	            return this.resultGenerator_(node.key, node.value);
	        }
	        else {
	            return { key: node.key, value: node.value };
	        }
	    };
	    return SortedMapIterator;
	}());
	exports.SortedMapIterator = SortedMapIterator;
	/**
	 * Represents a node in a Left-leaning Red-Black tree.
	 */
	var LLRBNode = /** @class */ (function () {
	    /**
	     * @template K, V
	     * @param {!K} key Key associated with this node.
	     * @param {!V} value Value associated with this node.
	     * @param {?boolean} color Whether this node is red.
	     * @param {?(LLRBNode|LLRBEmptyNode)=} left Left child.
	     * @param {?(LLRBNode|LLRBEmptyNode)=} right Right child.
	     */
	    function LLRBNode(key, value, color, left, right) {
	        this.key = key;
	        this.value = value;
	        this.color = color != null ? color : LLRBNode.RED;
	        this.left =
	            left != null ? left : SortedMap.EMPTY_NODE;
	        this.right =
	            right != null ? right : SortedMap.EMPTY_NODE;
	    }
	    /**
	     * Returns a copy of the current node, optionally replacing pieces of it.
	     *
	     * @param {?K} key New key for the node, or null.
	     * @param {?V} value New value for the node, or null.
	     * @param {?boolean} color New color for the node, or null.
	     * @param {?LLRBNode|LLRBEmptyNode} left New left child for the node, or null.
	     * @param {?LLRBNode|LLRBEmptyNode} right New right child for the node, or null.
	     * @return {!LLRBNode} The node copy.
	     */
	    LLRBNode.prototype.copy = function (key, value, color, left, right) {
	        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
	    };
	    /**
	     * @return {number} The total number of nodes in the tree.
	     */
	    LLRBNode.prototype.count = function () {
	        return this.left.count() + 1 + this.right.count();
	    };
	    /**
	     * @return {boolean} True if the tree is empty.
	     */
	    LLRBNode.prototype.isEmpty = function () {
	        return false;
	    };
	    /**
	     * Traverses the tree in key order and calls the specified action function
	     * for each node.
	     *
	     * @param {function(!K, !V):*} action Callback function to be called for each
	     *   node.  If it returns true, traversal is aborted.
	     * @return {*} The first truthy value returned by action, or the last falsey
	     *   value returned by action
	     */
	    LLRBNode.prototype.inorderTraversal = function (action) {
	        return (this.left.inorderTraversal(action) ||
	            action(this.key, this.value) ||
	            this.right.inorderTraversal(action));
	    };
	    /**
	     * Traverses the tree in reverse key order and calls the specified action function
	     * for each node.
	     *
	     * @param {function(!Object, !Object)} action Callback function to be called for each
	     * node.  If it returns true, traversal is aborted.
	     * @return {*} True if traversal was aborted.
	     */
	    LLRBNode.prototype.reverseTraversal = function (action) {
	        return (this.right.reverseTraversal(action) ||
	            action(this.key, this.value) ||
	            this.left.reverseTraversal(action));
	    };
	    /**
	     * @return {!Object} The minimum node in the tree.
	     * @private
	     */
	    LLRBNode.prototype.min_ = function () {
	        if (this.left.isEmpty()) {
	            return this;
	        }
	        else {
	            return this.left.min_();
	        }
	    };
	    /**
	     * @return {!K} The maximum key in the tree.
	     */
	    LLRBNode.prototype.minKey = function () {
	        return this.min_().key;
	    };
	    /**
	     * @return {!K} The maximum key in the tree.
	     */
	    LLRBNode.prototype.maxKey = function () {
	        if (this.right.isEmpty()) {
	            return this.key;
	        }
	        else {
	            return this.right.maxKey();
	        }
	    };
	    /**
	     *
	     * @param {!Object} key Key to insert.
	     * @param {!Object} value Value to insert.
	     * @param {Comparator} comparator Comparator.
	     * @return {!LLRBNode} New tree, with the key/value added.
	     */
	    LLRBNode.prototype.insert = function (key, value, comparator) {
	        var cmp, n;
	        n = this;
	        cmp = comparator(key, n.key);
	        if (cmp < 0) {
	            n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
	        }
	        else if (cmp === 0) {
	            n = n.copy(null, value, null, null, null);
	        }
	        else {
	            n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
	        }
	        return n.fixUp_();
	    };
	    /**
	     * @private
	     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the minimum key removed.
	     */
	    LLRBNode.prototype.removeMin_ = function () {
	        if (this.left.isEmpty()) {
	            return SortedMap.EMPTY_NODE;
	        }
	        var n = this;
	        if (!n.left.isRed_() && !n.left.left.isRed_())
	            n = n.moveRedLeft_();
	        n = n.copy(null, null, null, n.left.removeMin_(), null);
	        return n.fixUp_();
	    };
	    /**
	     * @param {!Object} key The key of the item to remove.
	     * @param {Comparator} comparator Comparator.
	     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the specified item removed.
	     */
	    LLRBNode.prototype.remove = function (key, comparator) {
	        var n, smallest;
	        n = this;
	        if (comparator(key, n.key) < 0) {
	            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) {
	                n = n.moveRedLeft_();
	            }
	            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
	        }
	        else {
	            if (n.left.isRed_())
	                n = n.rotateRight_();
	            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) {
	                n = n.moveRedRight_();
	            }
	            if (comparator(key, n.key) === 0) {
	                if (n.right.isEmpty()) {
	                    return SortedMap.EMPTY_NODE;
	                }
	                else {
	                    smallest = n.right.min_();
	                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
	                }
	            }
	            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
	        }
	        return n.fixUp_();
	    };
	    /**
	     * @private
	     * @return {boolean} Whether this is a RED node.
	     */
	    LLRBNode.prototype.isRed_ = function () {
	        return this.color;
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree after performing any needed rotations.
	     */
	    LLRBNode.prototype.fixUp_ = function () {
	        var n = this;
	        if (n.right.isRed_() && !n.left.isRed_())
	            n = n.rotateLeft_();
	        if (n.left.isRed_() && n.left.left.isRed_())
	            n = n.rotateRight_();
	        if (n.left.isRed_() && n.right.isRed_())
	            n = n.colorFlip_();
	        return n;
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after moveRedLeft.
	     */
	    LLRBNode.prototype.moveRedLeft_ = function () {
	        var n = this.colorFlip_();
	        if (n.right.left.isRed_()) {
	            n = n.copy(null, null, null, null, n.right.rotateRight_());
	            n = n.rotateLeft_();
	            n = n.colorFlip_();
	        }
	        return n;
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after moveRedRight.
	     */
	    LLRBNode.prototype.moveRedRight_ = function () {
	        var n = this.colorFlip_();
	        if (n.left.left.isRed_()) {
	            n = n.rotateRight_();
	            n = n.colorFlip_();
	        }
	        return n;
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after rotateLeft.
	     */
	    LLRBNode.prototype.rotateLeft_ = function () {
	        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
	        return this.right.copy(null, null, this.color, nl, null);
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after rotateRight.
	     */
	    LLRBNode.prototype.rotateRight_ = function () {
	        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
	        return this.left.copy(null, null, this.color, null, nr);
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after colorFlip.
	     */
	    LLRBNode.prototype.colorFlip_ = function () {
	        var left = this.left.copy(null, null, !this.left.color, null, null);
	        var right = this.right.copy(null, null, !this.right.color, null, null);
	        return this.copy(null, null, !this.color, left, right);
	    };
	    /**
	     * For testing.
	     *
	     * @private
	     * @return {boolean} True if all is well.
	     */
	    LLRBNode.prototype.checkMaxDepth_ = function () {
	        var blackDepth = this.check_();
	        return Math.pow(2.0, blackDepth) <= this.count() + 1;
	    };
	    /**
	     * @private
	     * @return {number} Not sure what this returns exactly. :-).
	     */
	    LLRBNode.prototype.check_ = function () {
	        var blackDepth;
	        if (this.isRed_() && this.left.isRed_()) {
	            throw new Error('Red node has red child(' + this.key + ',' + this.value + ')');
	        }
	        if (this.right.isRed_()) {
	            throw new Error('Right child of (' + this.key + ',' + this.value + ') is red');
	        }
	        blackDepth = this.left.check_();
	        if (blackDepth !== this.right.check_()) {
	            throw new Error('Black depths differ');
	        }
	        else {
	            return blackDepth + (this.isRed_() ? 0 : 1);
	        }
	    };
	    LLRBNode.RED = true;
	    LLRBNode.BLACK = false;
	    return LLRBNode;
	}());
	exports.LLRBNode = LLRBNode;
	/**
	 * Represents an empty node (a leaf node in the Red-Black Tree).
	 */
	var LLRBEmptyNode = /** @class */ (function () {
	    function LLRBEmptyNode() {
	    }
	    /**
	     * Returns a copy of the current node.
	     *
	     * @return {!LLRBEmptyNode} The node copy.
	     */
	    LLRBEmptyNode.prototype.copy = function (key, value, color, left, right) {
	        return this;
	    };
	    /**
	     * Returns a copy of the tree, with the specified key/value added.
	     *
	     * @param {!K} key Key to be added.
	     * @param {!V} value Value to be added.
	     * @param {Comparator} comparator Comparator.
	     * @return {!LLRBNode} New tree, with item added.
	     */
	    LLRBEmptyNode.prototype.insert = function (key, value, comparator) {
	        return new LLRBNode(key, value, null);
	    };
	    /**
	     * Returns a copy of the tree, with the specified key removed.
	     *
	     * @param {!K} key The key to remove.
	     * @param {Comparator} comparator Comparator.
	     * @return {!LLRBEmptyNode} New tree, with item removed.
	     */
	    LLRBEmptyNode.prototype.remove = function (key, comparator) {
	        return this;
	    };
	    /**
	     * @return {number} The total number of nodes in the tree.
	     */
	    LLRBEmptyNode.prototype.count = function () {
	        return 0;
	    };
	    /**
	     * @return {boolean} True if the tree is empty.
	     */
	    LLRBEmptyNode.prototype.isEmpty = function () {
	        return true;
	    };
	    /**
	     * Traverses the tree in key order and calls the specified action function
	     * for each node.
	     *
	     * @param {function(!K, !V):*} action Callback function to be called for each
	     * node.  If it returns true, traversal is aborted.
	     * @return {boolean} True if traversal was aborted.
	     */
	    LLRBEmptyNode.prototype.inorderTraversal = function (action) {
	        return false;
	    };
	    /**
	     * Traverses the tree in reverse key order and calls the specified action function
	     * for each node.
	     *
	     * @param {function(!K, !V)} action Callback function to be called for each
	     * node.  If it returns true, traversal is aborted.
	     * @return {boolean} True if traversal was aborted.
	     */
	    LLRBEmptyNode.prototype.reverseTraversal = function (action) {
	        return false;
	    };
	    /**
	     * @return {null}
	     */
	    LLRBEmptyNode.prototype.minKey = function () {
	        return null;
	    };
	    /**
	     * @return {null}
	     */
	    LLRBEmptyNode.prototype.maxKey = function () {
	        return null;
	    };
	    /**
	     * @private
	     * @return {number} Not sure what this returns exactly. :-).
	     */
	    LLRBEmptyNode.prototype.check_ = function () {
	        return 0;
	    };
	    /**
	     * @private
	     * @return {boolean} Whether this node is red.
	     */
	    LLRBEmptyNode.prototype.isRed_ = function () {
	        return false;
	    };
	    return LLRBEmptyNode;
	}());
	exports.LLRBEmptyNode = LLRBEmptyNode;
	/**
	 * An immutable sorted map implementation, based on a Left-leaning Red-Black
	 * tree.
	 */
	var SortedMap = /** @class */ (function () {
	    /**
	     * @template K, V
	     * @param {function(K, K):number} comparator_ Key comparator.
	     * @param {LLRBNode=} root_ (Optional) Root node for the map.
	     */
	    function SortedMap(comparator_, root_) {
	        if (root_ === void 0) { root_ = SortedMap.EMPTY_NODE; }
	        this.comparator_ = comparator_;
	        this.root_ = root_;
	    }
	    /**
	     * Returns a copy of the map, with the specified key/value added or replaced.
	     * (TODO: We should perhaps rename this method to 'put')
	     *
	     * @param {!K} key Key to be added.
	     * @param {!V} value Value to be added.
	     * @return {!SortedMap.<K, V>} New map, with item added.
	     */
	    SortedMap.prototype.insert = function (key, value) {
	        return new SortedMap(this.comparator_, this.root_
	            .insert(key, value, this.comparator_)
	            .copy(null, null, LLRBNode.BLACK, null, null));
	    };
	    /**
	     * Returns a copy of the map, with the specified key removed.
	     *
	     * @param {!K} key The key to remove.
	     * @return {!SortedMap.<K, V>} New map, with item removed.
	     */
	    SortedMap.prototype.remove = function (key) {
	        return new SortedMap(this.comparator_, this.root_
	            .remove(key, this.comparator_)
	            .copy(null, null, LLRBNode.BLACK, null, null));
	    };
	    /**
	     * Returns the value of the node with the given key, or null.
	     *
	     * @param {!K} key The key to look up.
	     * @return {?V} The value of the node with the given key, or null if the
	     * key doesn't exist.
	     */
	    SortedMap.prototype.get = function (key) {
	        var cmp;
	        var node = this.root_;
	        while (!node.isEmpty()) {
	            cmp = this.comparator_(key, node.key);
	            if (cmp === 0) {
	                return node.value;
	            }
	            else if (cmp < 0) {
	                node = node.left;
	            }
	            else if (cmp > 0) {
	                node = node.right;
	            }
	        }
	        return null;
	    };
	    /**
	     * Returns the key of the item *before* the specified key, or null if key is the first item.
	     * @param {K} key The key to find the predecessor of
	     * @return {?K} The predecessor key.
	     */
	    SortedMap.prototype.getPredecessorKey = function (key) {
	        var cmp, node = this.root_, rightParent = null;
	        while (!node.isEmpty()) {
	            cmp = this.comparator_(key, node.key);
	            if (cmp === 0) {
	                if (!node.left.isEmpty()) {
	                    node = node.left;
	                    while (!node.right.isEmpty())
	                        node = node.right;
	                    return node.key;
	                }
	                else if (rightParent) {
	                    return rightParent.key;
	                }
	                else {
	                    return null; // first item.
	                }
	            }
	            else if (cmp < 0) {
	                node = node.left;
	            }
	            else if (cmp > 0) {
	                rightParent = node;
	                node = node.right;
	            }
	        }
	        throw new Error('Attempted to find predecessor key for a nonexistent key.  What gives?');
	    };
	    /**
	     * @return {boolean} True if the map is empty.
	     */
	    SortedMap.prototype.isEmpty = function () {
	        return this.root_.isEmpty();
	    };
	    /**
	     * @return {number} The total number of nodes in the map.
	     */
	    SortedMap.prototype.count = function () {
	        return this.root_.count();
	    };
	    /**
	     * @return {?K} The minimum key in the map.
	     */
	    SortedMap.prototype.minKey = function () {
	        return this.root_.minKey();
	    };
	    /**
	     * @return {?K} The maximum key in the map.
	     */
	    SortedMap.prototype.maxKey = function () {
	        return this.root_.maxKey();
	    };
	    /**
	     * Traverses the map in key order and calls the specified action function
	     * for each key/value pair.
	     *
	     * @param {function(!K, !V):*} action Callback function to be called
	     * for each key/value pair.  If action returns true, traversal is aborted.
	     * @return {*} The first truthy value returned by action, or the last falsey
	     *   value returned by action
	     */
	    SortedMap.prototype.inorderTraversal = function (action) {
	        return this.root_.inorderTraversal(action);
	    };
	    /**
	     * Traverses the map in reverse key order and calls the specified action function
	     * for each key/value pair.
	     *
	     * @param {function(!Object, !Object)} action Callback function to be called
	     * for each key/value pair.  If action returns true, traversal is aborted.
	     * @return {*} True if the traversal was aborted.
	     */
	    SortedMap.prototype.reverseTraversal = function (action) {
	        return this.root_.reverseTraversal(action);
	    };
	    /**
	     * Returns an iterator over the SortedMap.
	     * @template T
	     * @param {(function(K, V):T)=} resultGenerator
	     * @return {SortedMapIterator.<K, V, T>} The iterator.
	     */
	    SortedMap.prototype.getIterator = function (resultGenerator) {
	        return new SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
	    };
	    SortedMap.prototype.getIteratorFrom = function (key, resultGenerator) {
	        return new SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
	    };
	    SortedMap.prototype.getReverseIteratorFrom = function (key, resultGenerator) {
	        return new SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
	    };
	    SortedMap.prototype.getReverseIterator = function (resultGenerator) {
	        return new SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
	    };
	    /**
	     * Always use the same empty node, to reduce memory.
	     * @const
	     */
	    SortedMap.EMPTY_NODE = new LLRBEmptyNode();
	    return SortedMap;
	}());
	exports.SortedMap = SortedMap;
	
	//# sourceMappingURL=SortedMap.js.map


/***/ },
/* 91 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
	 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
	 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
	 * whether a node potentially had children removed due to a filter.
	 */
	var CacheNode = /** @class */ (function () {
	    /**
	     * @param {!Node} node_
	     * @param {boolean} fullyInitialized_
	     * @param {boolean} filtered_
	     */
	    function CacheNode(node_, fullyInitialized_, filtered_) {
	        this.node_ = node_;
	        this.fullyInitialized_ = fullyInitialized_;
	        this.filtered_ = filtered_;
	    }
	    /**
	     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
	     * @return {boolean}
	     */
	    CacheNode.prototype.isFullyInitialized = function () {
	        return this.fullyInitialized_;
	    };
	    /**
	     * Returns whether this node is potentially missing children due to a filter applied to the node
	     * @return {boolean}
	     */
	    CacheNode.prototype.isFiltered = function () {
	        return this.filtered_;
	    };
	    /**
	     * @param {!Path} path
	     * @return {boolean}
	     */
	    CacheNode.prototype.isCompleteForPath = function (path) {
	        if (path.isEmpty()) {
	            return this.isFullyInitialized() && !this.filtered_;
	        }
	        var childKey = path.getFront();
	        return this.isCompleteForChild(childKey);
	    };
	    /**
	     * @param {!string} key
	     * @return {boolean}
	     */
	    CacheNode.prototype.isCompleteForChild = function (key) {
	        return ((this.isFullyInitialized() && !this.filtered_) || this.node_.hasChild(key));
	    };
	    /**
	     * @return {!Node}
	     */
	    CacheNode.prototype.getNode = function () {
	        return this.node_;
	    };
	    return CacheNode;
	}());
	exports.CacheNode = CacheNode;
	
	//# sourceMappingURL=CacheNode.js.map


/***/ },
/* 92 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PROTOCOL_VERSION = '5';
	exports.VERSION_PARAM = 'v';
	exports.TRANSPORT_SESSION_PARAM = 's';
	exports.REFERER_PARAM = 'r';
	exports.FORGE_REF = 'f';
	exports.FORGE_DOMAIN = 'firebaseio.com';
	exports.LAST_SESSION_PARAM = 'ls';
	exports.WEBSOCKET = 'websocket';
	exports.LONG_POLLING = 'long_polling';
	
	//# sourceMappingURL=Constants.js.map


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var document_key_1 = __webpack_require__(22);
	var assert_1 = __webpack_require__(10);
	var sorted_map_1 = __webpack_require__(50);
	var ChangeType;
	(function (ChangeType) {
	    ChangeType[ChangeType["Added"] = 0] = "Added";
	    ChangeType[ChangeType["Removed"] = 1] = "Removed";
	    ChangeType[ChangeType["Modified"] = 2] = "Modified";
	    ChangeType[ChangeType["Metadata"] = 3] = "Metadata";
	})(ChangeType = exports.ChangeType || (exports.ChangeType = {}));
	var SyncState;
	(function (SyncState) {
	    SyncState[SyncState["Local"] = 0] = "Local";
	    SyncState[SyncState["Synced"] = 1] = "Synced";
	})(SyncState = exports.SyncState || (exports.SyncState = {}));
	/**
	 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
	 * duplicate events for the same doc.
	 */
	var DocumentChangeSet = /** @class */ (function () {
	    function DocumentChangeSet() {
	        this.changeMap = new sorted_map_1.SortedMap(document_key_1.DocumentKey.comparator);
	    }
	    DocumentChangeSet.prototype.track = function (change) {
	        var key = change.doc.key;
	        var oldChange = this.changeMap.get(key);
	        if (!oldChange) {
	            this.changeMap = this.changeMap.insert(key, change);
	            return;
	        }
	        // Merge the new change with the existing change.
	        if (change.type !== ChangeType.Added &&
	            oldChange.type === ChangeType.Metadata) {
	            this.changeMap = this.changeMap.insert(key, change);
	        }
	        else if (change.type === ChangeType.Metadata &&
	            oldChange.type !== ChangeType.Removed) {
	            this.changeMap = this.changeMap.insert(key, {
	                type: oldChange.type,
	                doc: change.doc
	            });
	        }
	        else if (change.type === ChangeType.Modified &&
	            oldChange.type === ChangeType.Modified) {
	            this.changeMap = this.changeMap.insert(key, {
	                type: ChangeType.Modified,
	                doc: change.doc
	            });
	        }
	        else if (change.type === ChangeType.Modified &&
	            oldChange.type === ChangeType.Added) {
	            this.changeMap = this.changeMap.insert(key, {
	                type: ChangeType.Added,
	                doc: change.doc
	            });
	        }
	        else if (change.type === ChangeType.Removed &&
	            oldChange.type === ChangeType.Added) {
	            this.changeMap = this.changeMap.remove(key);
	        }
	        else if (change.type === ChangeType.Removed &&
	            oldChange.type === ChangeType.Modified) {
	            this.changeMap = this.changeMap.insert(key, {
	                type: ChangeType.Removed,
	                doc: oldChange.doc
	            });
	        }
	        else if (change.type === ChangeType.Added &&
	            oldChange.type === ChangeType.Removed) {
	            this.changeMap = this.changeMap.insert(key, {
	                type: ChangeType.Modified,
	                doc: change.doc
	            });
	        }
	        else {
	            // This includes these cases, which don't make sense:
	            // Added->Added
	            // Removed->Removed
	            // Modified->Added
	            // Removed->Modified
	            // Metadata->Added
	            // Removed->Metadata
	            assert_1.fail('unsupported combination of changes: ' +
	                JSON.stringify(change) +
	                ' after ' +
	                JSON.stringify(oldChange));
	        }
	    };
	    DocumentChangeSet.prototype.getChanges = function () {
	        var changes = [];
	        this.changeMap.inorderTraversal(function (key, change) {
	            changes.push(change);
	        });
	        return changes;
	    };
	    return DocumentChangeSet;
	}());
	exports.DocumentChangeSet = DocumentChangeSet;
	
	//# sourceMappingURL=view_snapshot.js.map


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var collections_1 = __webpack_require__(20);
	var document_key_1 = __webpack_require__(22);
	var misc_1 = __webpack_require__(25);
	var sorted_set_1 = __webpack_require__(97);
	var persistence_promise_1 = __webpack_require__(29);
	/**
	 * A collection of references to a document from some kind of numbered entity
	 * (either a target ID or batch ID). As references are added to or removed from
	 * the set corresponding events are emitted to a registered garbage collector.
	 *
	 * Each reference is represented by a DocumentReference object. Each of them
	 * contains enough information to uniquely identify the reference. They are all
	 * stored primarily in a set sorted by key. A document is considered garbage if
	 * there's no references in that set (this can be efficiently checked thanks to
	 * sorting by key).
	 *
	 * ReferenceSet also keeps a secondary set that contains references sorted by
	 * IDs. This one is used to efficiently implement removal of all references by
	 * some target ID.
	 */
	var ReferenceSet = /** @class */ (function () {
	    function ReferenceSet() {
	        // A set of outstanding references to a document sorted by key.
	        this.refsByKey = new sorted_set_1.SortedSet(DocReference.compareByKey);
	        // A set of outstanding references to a document sorted by target id.
	        this.refsByTarget = new sorted_set_1.SortedSet(DocReference.compareByTargetId);
	        /** Keeps track of keys that have references */
	        this.garbageCollector = null;
	    }
	    /** Returns true if the reference set contains no references. */
	    ReferenceSet.prototype.isEmpty = function () {
	        return this.refsByKey.isEmpty();
	    };
	    /** Adds a reference to the given document key for the given ID. */
	    ReferenceSet.prototype.addReference = function (key, id) {
	        var ref = new DocReference(key, id);
	        this.refsByKey = this.refsByKey.add(ref);
	        this.refsByTarget = this.refsByTarget.add(ref);
	    };
	    /** Add references to the given document keys for the given ID. */
	    ReferenceSet.prototype.addReferences = function (keys, id) {
	        var _this = this;
	        keys.forEach(function (key) { return _this.addReference(key, id); });
	    };
	    /**
	     * Removes a reference to the given document key for the given
	     * ID.
	     */
	    ReferenceSet.prototype.removeReference = function (key, id) {
	        this.removeRef(new DocReference(key, id));
	    };
	    ReferenceSet.prototype.removeReferences = function (keys, id) {
	        var _this = this;
	        keys.forEach(function (key) { return _this.removeReference(key, id); });
	    };
	    /**
	     * Clears all references with a given ID. Calls removeRef() for each key
	     * removed.
	     */
	    ReferenceSet.prototype.removeReferencesForId = function (id) {
	        var _this = this;
	        var emptyKey = document_key_1.DocumentKey.EMPTY;
	        var startRef = new DocReference(emptyKey, id);
	        var endRef = new DocReference(emptyKey, id + 1);
	        this.refsByTarget.forEachInRange([startRef, endRef], function (ref) {
	            _this.removeRef(ref);
	        });
	    };
	    ReferenceSet.prototype.removeAllReferences = function () {
	        var _this = this;
	        this.refsByKey.forEach(function (ref) { return _this.removeRef(ref); });
	    };
	    ReferenceSet.prototype.removeRef = function (ref) {
	        this.refsByKey = this.refsByKey.delete(ref);
	        this.refsByTarget = this.refsByTarget.delete(ref);
	        if (this.garbageCollector !== null) {
	            this.garbageCollector.addPotentialGarbageKey(ref.key);
	        }
	    };
	    ReferenceSet.prototype.referencesForId = function (id) {
	        var emptyKey = document_key_1.DocumentKey.EMPTY;
	        var startRef = new DocReference(emptyKey, id);
	        var endRef = new DocReference(emptyKey, id + 1);
	        var keys = collections_1.documentKeySet();
	        this.refsByTarget.forEachInRange([startRef, endRef], function (ref) {
	            keys = keys.add(ref.key);
	        });
	        return keys;
	    };
	    ReferenceSet.prototype.setGarbageCollector = function (garbageCollector) {
	        this.garbageCollector = garbageCollector;
	    };
	    ReferenceSet.prototype.containsKey = function (txn, key) {
	        var ref = new DocReference(key, 0);
	        var firstRef = this.refsByKey.firstAfterOrEqual(ref);
	        return persistence_promise_1.PersistencePromise.resolve(firstRef !== null && key.equals(firstRef.key));
	    };
	    return ReferenceSet;
	}());
	exports.ReferenceSet = ReferenceSet;
	var DocReference = /** @class */ (function () {
	    function DocReference(key, targetOrBatchId) {
	        this.key = key;
	        this.targetOrBatchId = targetOrBatchId;
	    }
	    /** Compare by key then by ID */
	    DocReference.compareByKey = function (left, right) {
	        return (document_key_1.DocumentKey.comparator(left.key, right.key) ||
	            misc_1.primitiveComparator(left.targetOrBatchId, right.targetOrBatchId));
	    };
	    /** Compare by ID then by key */
	    DocReference.compareByTargetId = function (left, right) {
	        return (misc_1.primitiveComparator(left.targetOrBatchId, right.targetOrBatchId) ||
	            document_key_1.DocumentKey.comparator(left.key, right.key));
	    };
	    return DocReference;
	}());
	exports.DocReference = DocReference;
	
	//# sourceMappingURL=reference_set.js.map


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(10);
	var log_1 = __webpack_require__(24);
	var persistence_promise_1 = __webpack_require__(29);
	var LOG_TAG = 'SimpleDb';
	/**
	 * Provides a wrapper around IndexedDb with a simplified interface that uses
	 * Promise-like return values to chain operations. Real promises cannot be used
	 * since .then() continuations are executed asynchronously (e.g. via
	 * .setImmediate), which would cause IndexedDB to end the transaction.
	 * See PersistencePromise for more details.
	 */
	var SimpleDb = /** @class */ (function () {
	    function SimpleDb(db) {
	        this.db = db;
	    }
	    /** Opens the specified database, creating or upgrading it if necessary. */
	    SimpleDb.openOrCreate = function (name, version, runUpgrade) {
	        assert_1.assert(SimpleDb.isAvailable(), 'IndexedDB not supported in current environment.');
	        log_1.debug(LOG_TAG, 'Opening database:', name);
	        return new persistence_promise_1.PersistencePromise(function (resolve, reject) {
	            // TODO(mikelehen): Investigate browser compatibility.
	            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
	            // suggests IE9 and older WebKit browsers handle upgrade
	            // differently.
	            var request = window.indexedDB.open(name, version);
	            request.onsuccess = function (event) {
	                var db = event.target.result;
	                resolve(new SimpleDb(db));
	            };
	            request.onerror = function (event) {
	                reject(event.target.error);
	            };
	            request.onupgradeneeded = function (event) {
	                log_1.debug(LOG_TAG, 'Database "' + name + '" requires upgrade from version:', event.oldVersion);
	                // TODO(mikelehen): If/when we need to do an actual data
	                // migration, we'll want to wrap db in a SimpleDb and have the
	                // runUpgrade function return a PersistencePromise, since we'll
	                // likely need to do async reads and writes. For now we're
	                // cheating and just passing the raw IndexedDB in, since
	                // createObjectStore(), etc. are synchronous.
	                var db = event.target.result;
	                runUpgrade(db, event.oldVersion);
	            };
	        }).toPromise();
	    };
	    /** Deletes the specified database. */
	    SimpleDb.delete = function (name) {
	        log_1.debug(LOG_TAG, 'Removing database:', name);
	        return wrapRequest(window.indexedDB.deleteDatabase(name)).toPromise();
	    };
	    /** Returns true if IndexedDB is available in the current environment. */
	    SimpleDb.isAvailable = function () {
	        if (typeof window === 'undefined' || window.indexedDB == null) {
	            return false;
	        }
	        // We extensively use indexed array values and compound keys,
	        // which IE and Edge do not support. However, they still have indexedDB
	        // defined on the window, so we need to check for them here and make sure
	        // to return that persistence is not enabled for those browsers.
	        // For tracking support of this feature, see here:
	        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
	        // Check the UA string to find out the browser.
	        var ua = window.navigator.userAgent;
	        // IE 10
	        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
	        // IE 11
	        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
	        // Edge
	        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
	        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
	        if (ua.indexOf('MSIE ') > 0 ||
	            ua.indexOf('Trident/') > 0 ||
	            ua.indexOf('Edge/') > 0) {
	            return false;
	        }
	        else {
	            return true;
	        }
	    };
	    SimpleDb.prototype.runTransaction = function (mode, objectStores, transactionFn) {
	        var transaction = new SimpleDbTransaction(this.db, mode, objectStores);
	        var transactionFnResult = transactionFn(transaction)
	            .catch(function (error) {
	            // Abort the transaction if there was an
	            // error.
	            transaction.abort();
	            return persistence_promise_1.PersistencePromise.reject(error);
	        })
	            .toPromise();
	        // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
	        // fire), but still return the original transactionFnResult back to the
	        // caller.
	        return transaction.completionPromise.then(function () { return transactionFnResult; });
	    };
	    SimpleDb.prototype.close = function () {
	        this.db.close();
	    };
	    return SimpleDb;
	}());
	exports.SimpleDb = SimpleDb;
	/**
	 * A controller for iterating over a key range or index. It allows an iterate
	 * callback to delete the currently-referenced object, or jump to a new key
	 * within the key range or index.
	 */
	var IterationController = /** @class */ (function () {
	    function IterationController(dbCursor) {
	        this.dbCursor = dbCursor;
	        this.shouldStop = false;
	        this.nextKey = null;
	    }
	    Object.defineProperty(IterationController.prototype, "isDone", {
	        get: function () {
	            return this.shouldStop;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(IterationController.prototype, "skipToKey", {
	        get: function () {
	            return this.nextKey;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(IterationController.prototype, "cursor", {
	        set: function (value) {
	            this.dbCursor = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * This function can be called to stop iteration at any point.
	     */
	    IterationController.prototype.done = function () {
	        this.shouldStop = true;
	    };
	    /**
	     * This function can be called to skip to that next key, which could be
	     * an index or a primary key.
	     */
	    IterationController.prototype.skip = function (key) {
	        this.nextKey = key;
	    };
	    /**
	     * Delete the current cursor value from the object store.
	     *
	     * NOTE: You CANNOT do this with a keysOnly query.
	     */
	    IterationController.prototype.delete = function () {
	        return wrapRequest(this.dbCursor.delete());
	    };
	    return IterationController;
	}());
	exports.IterationController = IterationController;
	/**
	 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
	 * specific object store.
	 */
	var SimpleDbTransaction = /** @class */ (function () {
	    function SimpleDbTransaction(db, mode, objectStoresNames) {
	        var _this = this;
	        this.aborted = false;
	        this.transaction = db.transaction(objectStoresNames, mode);
	        this.completionPromise = new Promise(function (resolve, reject) {
	            // We consider aborting to be "normal" and just resolve the promise.
	            // May need to revisit if/when we actually need to abort transactions.
	            _this.transaction.onabort = _this.transaction.oncomplete = function (event) {
	                resolve();
	            };
	            _this.transaction.onerror = function (event) {
	                reject(event.target.error);
	            };
	        });
	    }
	    SimpleDbTransaction.prototype.abort = function () {
	        if (!this.aborted) {
	            log_1.debug(LOG_TAG, 'Aborting transaction.');
	            this.aborted = true;
	            this.transaction.abort();
	        }
	    };
	    /**
	     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
	     * operations performed on the SimpleDbStore happen within the context of this
	     * transaction and it cannot be used anymore once the transaction is
	     * completed.
	     *
	     * Note that we can't actually enforce that the KeyType and ValueType are
	     * correct, but they allow type safety through the rest of the consuming code.
	     */
	    SimpleDbTransaction.prototype.store = function (storeName) {
	        var store = this.transaction.objectStore(storeName);
	        assert_1.assert(!!store, 'Object store not part of transaction: ' + storeName);
	        return new SimpleDbStore(store);
	    };
	    return SimpleDbTransaction;
	}());
	exports.SimpleDbTransaction = SimpleDbTransaction;
	/**
	 * A wrapper around an IDBObjectStore providing an API that:
	 *
	 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
	 * methods for acting against the object store.
	 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
	 * method return a PersistencePromise instead.
	 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
	 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
	 */
	var SimpleDbStore = /** @class */ (function () {
	    function SimpleDbStore(store) {
	        this.store = store;
	    }
	    SimpleDbStore.prototype.put = function (keyOrValue, value) {
	        var request;
	        if (value !== undefined) {
	            log_1.debug(LOG_TAG, 'PUT', this.store.name, keyOrValue, value);
	            request = this.store.put(value, keyOrValue);
	        }
	        else {
	            log_1.debug(LOG_TAG, 'PUT', this.store.name, '<auto-key>', keyOrValue);
	            request = this.store.put(keyOrValue);
	        }
	        return wrapRequest(request);
	    };
	    /**
	     * Gets the object with the specified key from the specified store, or null
	     * if no object exists with the specified key.
	     *
	     * @key The key of the object to get.
	     * @return The object with the specified key or null if no object exists.
	     */
	    SimpleDbStore.prototype.get = function (key) {
	        var _this = this;
	        var request = this.store.get(key);
	        // tslint:disable-next-line:no-any We're doing an unsafe cast to ValueType.
	        return wrapRequest(request).next(function (result) {
	            // Normalize nonexistence to null.
	            if (result === undefined) {
	                result = null;
	            }
	            log_1.debug(LOG_TAG, 'GET', _this.store.name, key, result);
	            return result;
	        });
	    };
	    SimpleDbStore.prototype.delete = function (key) {
	        log_1.debug(LOG_TAG, 'DELETE', this.store.name, key);
	        var request = this.store.delete(key);
	        return wrapRequest(request);
	    };
	    SimpleDbStore.prototype.loadAll = function (indexOrRange, range) {
	        var cursor = this.cursor(this.options(indexOrRange, range));
	        var results = [];
	        return this.iterateCursor(cursor, function (key, value) {
	            results.push(value);
	        }).next(function () {
	            return results;
	        });
	    };
	    SimpleDbStore.prototype.deleteAll = function (indexOrRange, range) {
	        log_1.debug(LOG_TAG, 'DELETE ALL', this.store.name);
	        var options = this.options(indexOrRange, range);
	        options.keysOnly = false;
	        var cursor = this.cursor(options);
	        return this.iterateCursor(cursor, function (key, value, control) {
	            // NOTE: Calling delete() on a cursor is documented as more efficient than
	            // calling delete() on an object store with a single key
	            // (https://developer.mozilla.org/en-US/docs/Web/API/IDBObjectStore/delete),
	            // however, this requires us *not* to use a keysOnly cursor
	            // (https://developer.mozilla.org/en-US/docs/Web/API/IDBCursor/delete). We
	            // may want to compare the performance of each method.
	            return control.delete();
	        });
	    };
	    SimpleDbStore.prototype.iterate = function (optionsOrCallback, callback) {
	        var options;
	        if (!callback) {
	            options = {};
	            callback = optionsOrCallback;
	        }
	        else {
	            options = optionsOrCallback;
	        }
	        var cursor = this.cursor(options);
	        return this.iterateCursor(cursor, callback);
	    };
	    SimpleDbStore.prototype.iterateCursor = function (cursorRequest, fn) {
	        var results = [];
	        return new persistence_promise_1.PersistencePromise(function (resolve, reject) {
	            cursorRequest.onerror = function (event) {
	                reject(event.target.error);
	            };
	            cursorRequest.onsuccess = function (event) {
	                var cursor = event.target.result;
	                if (!cursor) {
	                    resolve();
	                    return;
	                }
	                var controller = new IterationController(cursor);
	                var userResult = fn(cursor.primaryKey, cursor.value, controller);
	                if (userResult instanceof persistence_promise_1.PersistencePromise) {
	                    results.push(userResult);
	                }
	                if (controller.isDone) {
	                    resolve();
	                }
	                else if (controller.skipToKey === null) {
	                    cursor.continue();
	                }
	                else {
	                    cursor.continue(controller.skipToKey);
	                }
	            };
	        }).next(function () {
	            return persistence_promise_1.PersistencePromise.waitFor(results);
	        });
	    };
	    SimpleDbStore.prototype.options = function (indexOrRange, range) {
	        var indexName = undefined;
	        if (indexOrRange !== undefined) {
	            if (typeof indexOrRange === 'string') {
	                indexName = indexOrRange;
	            }
	            else {
	                assert_1.assert(range === undefined, '3rd argument must not be defined if 2nd is a range.');
	                range = indexOrRange;
	            }
	        }
	        return { index: indexName, range: range };
	    };
	    SimpleDbStore.prototype.cursor = function (options) {
	        var direction = 'next';
	        if (options.reverse) {
	            direction = 'prev';
	        }
	        if (options.index) {
	            var index = this.store.index(options.index);
	            if (options.keysOnly) {
	                return index.openKeyCursor(options.range, direction);
	            }
	            else {
	                return index.openCursor(options.range, direction);
	            }
	        }
	        else {
	            return this.store.openCursor(options.range, direction);
	        }
	    };
	    return SimpleDbStore;
	}());
	exports.SimpleDbStore = SimpleDbStore;
	/**
	 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
	 * handlers to resolve / reject the PersistencePromise as appropriate.
	 */
	function wrapRequest(request) {
	    return new persistence_promise_1.PersistencePromise(function (resolve, reject) {
	        request.onsuccess = function (event) {
	            var result = event.target.result;
	            resolve(result);
	        };
	        request.onerror = function (event) {
	            reject(event.target.error);
	        };
	    });
	}
	
	//# sourceMappingURL=simple_db.js.map


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var snapshot_version_1 = __webpack_require__(31);
	var assert_1 = __webpack_require__(10);
	var misc = __webpack_require__(25);
	var document_1 = __webpack_require__(32);
	var field_value_1 = __webpack_require__(57);
	/**
	 * Provides a set of fields that can be used to partially patch a document.
	 * FieldMask is used in conjunction with ObjectValue.
	 * Examples:
	 *   foo - Overwrites foo entirely with the provided value. If foo is not
	 *         present in the companion ObjectValue, the field is deleted.
	 *   foo.bar - Overwrites only the field bar of the object foo.
	 *             If foo is not an object, foo is replaced with an object
	 *             containing foo
	 */
	var FieldMask = /** @class */ (function () {
	    function FieldMask(fields) {
	        this.fields = fields;
	        // TODO(dimond): validation of FieldMask
	    }
	    FieldMask.prototype.equals = function (other) {
	        return misc.arrayEquals(this.fields, other.fields);
	    };
	    return FieldMask;
	}());
	exports.FieldMask = FieldMask;
	/** Transforms a value into a server-generated timestamp. */
	var ServerTimestampTransform = /** @class */ (function () {
	    function ServerTimestampTransform() {
	    }
	    ServerTimestampTransform.prototype.equals = function (other) {
	        return other instanceof ServerTimestampTransform;
	    };
	    ServerTimestampTransform.instance = new ServerTimestampTransform();
	    return ServerTimestampTransform;
	}());
	exports.ServerTimestampTransform = ServerTimestampTransform;
	/** A field path and the TransformOperation to perform upon it. */
	var FieldTransform = /** @class */ (function () {
	    function FieldTransform(field, transform) {
	        this.field = field;
	        this.transform = transform;
	    }
	    FieldTransform.prototype.equals = function (other) {
	        return (this.field.equals(other.field) && this.transform.equals(other.transform));
	    };
	    return FieldTransform;
	}());
	exports.FieldTransform = FieldTransform;
	/** The result of successfully applying a mutation to the backend. */
	var MutationResult = /** @class */ (function () {
	    function MutationResult(
	        /**
	         * The version at which the mutation was committed or null for a delete.
	         */
	        version, 
	        /**
	         * The resulting fields returned from the backend after a
	         * TransformMutation has been committed. Contains one FieldValue for each
	         * FieldTransform that was in the mutation.
	         *
	         * Will be null if the mutation was not a TransformMutation.
	         */
	        transformResults) {
	        this.version = version;
	        this.transformResults = transformResults;
	    }
	    return MutationResult;
	}());
	exports.MutationResult = MutationResult;
	var MutationType;
	(function (MutationType) {
	    MutationType[MutationType["Set"] = 0] = "Set";
	    MutationType[MutationType["Patch"] = 1] = "Patch";
	    MutationType[MutationType["Transform"] = 2] = "Transform";
	    MutationType[MutationType["Delete"] = 3] = "Delete";
	})(MutationType = exports.MutationType || (exports.MutationType = {}));
	/**
	 * Encodes a precondition for a mutation. This follows the model that the
	 * backend accepts with the special case of an explicit "empty" precondition
	 * (meaning no precondition).
	 */
	var Precondition = /** @class */ (function () {
	    function Precondition(updateTime, exists) {
	        this.updateTime = updateTime;
	        this.exists = exists;
	        assert_1.assert(updateTime === undefined || exists === undefined, 'Precondition can specify "exists" or "updateTime" but not both');
	    }
	    /** Creates a new Precondition with an exists flag. */
	    Precondition.exists = function (exists) {
	        return new Precondition(undefined, exists);
	    };
	    /** Creates a new Precondition based on a version a document exists at. */
	    Precondition.updateTime = function (version) {
	        return new Precondition(version);
	    };
	    Object.defineProperty(Precondition.prototype, "isNone", {
	        /** Returns whether this Precondition is empty. */
	        get: function () {
	            return this.updateTime === undefined && this.exists === undefined;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns true if the preconditions is valid for the given document
	     * (or null if no document is available).
	     */
	    Precondition.prototype.isValidFor = function (maybeDoc) {
	        if (this.updateTime !== undefined) {
	            return (maybeDoc instanceof document_1.Document && maybeDoc.version.equals(this.updateTime));
	        }
	        else if (this.exists !== undefined) {
	            if (this.exists) {
	                return maybeDoc instanceof document_1.Document;
	            }
	            else {
	                return maybeDoc === null || maybeDoc instanceof document_1.NoDocument;
	            }
	        }
	        else {
	            assert_1.assert(this.isNone, 'Precondition should be empty');
	            return true;
	        }
	    };
	    Precondition.prototype.equals = function (other) {
	        return (misc.equals(this.updateTime, other.updateTime) &&
	            this.exists === other.exists);
	    };
	    Precondition.NONE = new Precondition();
	    return Precondition;
	}());
	exports.Precondition = Precondition;
	/**
	 * A mutation describes a self-contained change to a document. Mutations can
	 * create, replace, delete, and update subsets of documents.
	 *
	 * Mutations not only act on the value of the document but also it version.
	 * In the case of Set, Patch, and Transform mutations we preserve the existing
	 * version. In the case of Delete mutations, we reset the version to 0.
	 *
	 * Here's the expected transition table.
	 *
	 * MUTATION           APPLIED TO            RESULTS IN
	 *
	 * SetMutation        Document(v3)          Document(v3)
	 * SetMutation        NoDocument(v3)        Document(v0)
	 * SetMutation        null                  Document(v0)
	 * PatchMutation      Document(v3)          Document(v3)
	 * PatchMutation      NoDocument(v3)        NoDocument(v3)
	 * PatchMutation      null                  null
	 * TransformMutation  Document(v3)          Document(v3)
	 * TransformMutation  NoDocument(v3)        NoDocument(v3)
	 * TransformMutation  null                  null
	 * DeleteMutation     Document(v3)          NoDocument(v0)
	 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
	 * DeleteMutation     null                  NoDocument(v0)
	 *
	 * Note that TransformMutations don't create Documents (in the case of being
	 * applied to a NoDocument), even though they would on the backend. This is
	 * because the client always combines the TransformMutation with a SetMutation
	 * or PatchMutation and we only want to apply the transform if the prior
	 * mutation resulted in a Document (always true for a SetMutation, but not
	 * necessarily for a PatchMutation).
	 *
	 * ## Subclassing Notes
	 *
	 * Subclasses of Mutation need to implement applyToRemoteDocument() and
	 * applyToLocalView() to implement the actual behavior of applying the mutation
	 * to some source document.
	 */
	var Mutation = /** @class */ (function () {
	    function Mutation() {
	    }
	    Mutation.prototype.verifyKeyMatches = function (maybeDoc) {
	        if (maybeDoc != null) {
	            assert_1.assert(maybeDoc.key.equals(this.key), 'Can only apply a mutation to a document with the same key');
	        }
	    };
	    /**
	     * Returns the version from the given document for use as the result of a
	     * mutation. Mutations are defined to return the version of the base document
	     * only if it is an existing document. Deleted and unknown documents have a
	     * post-mutation version of SnapshotVersion.MIN.
	     */
	    Mutation.getPostMutationVersion = function (maybeDoc) {
	        if (maybeDoc instanceof document_1.Document) {
	            return maybeDoc.version;
	        }
	        else {
	            return snapshot_version_1.SnapshotVersion.MIN;
	        }
	    };
	    return Mutation;
	}());
	exports.Mutation = Mutation;
	/**
	 * A mutation that creates or replaces the document at the given key with the
	 * object value contents.
	 */
	var SetMutation = /** @class */ (function (_super) {
	    __extends(SetMutation, _super);
	    function SetMutation(key, value, precondition) {
	        var _this = _super.call(this) || this;
	        _this.key = key;
	        _this.value = value;
	        _this.precondition = precondition;
	        _this.type = MutationType.Set;
	        return _this;
	    }
	    SetMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
	        this.verifyKeyMatches(maybeDoc);
	        assert_1.assert(mutationResult.transformResults == null, 'Transform results received by SetMutation.');
	        // Unlike applyToLocalView, if we're applying a mutation to a remote
	        // document the server has accepted the mutation so the precondition must
	        // have held.
	        var version = Mutation.getPostMutationVersion(maybeDoc);
	        return new document_1.Document(this.key, version, this.value, {
	            hasLocalMutations: false
	        });
	    };
	    SetMutation.prototype.applyToLocalView = function (maybeDoc, localWriteTime) {
	        this.verifyKeyMatches(maybeDoc);
	        if (!this.precondition.isValidFor(maybeDoc)) {
	            return maybeDoc;
	        }
	        var version = Mutation.getPostMutationVersion(maybeDoc);
	        return new document_1.Document(this.key, version, this.value, {
	            hasLocalMutations: true
	        });
	    };
	    SetMutation.prototype.equals = function (other) {
	        return (other instanceof SetMutation &&
	            this.key.equals(other.key) &&
	            this.value.equals(other.value) &&
	            this.precondition.equals(other.precondition));
	    };
	    return SetMutation;
	}(Mutation));
	exports.SetMutation = SetMutation;
	/**
	 * A mutation that modifies fields of the document at the given key with the
	 * given values. The values are applied through a field mask:
	 *
	 *  * When a field is in both the mask and the values, the corresponding field
	 *    is updated.
	 *  * When a field is in neither the mask nor the values, the corresponding
	 *    field is unmodified.
	 *  * When a field is in the mask but not in the values, the corresponding field
	 *    is deleted.
	 *  * When a field is not in the mask but is in the values, the values map is
	 *    ignored.
	 */
	var PatchMutation = /** @class */ (function (_super) {
	    __extends(PatchMutation, _super);
	    function PatchMutation(key, data, fieldMask, precondition) {
	        var _this = _super.call(this) || this;
	        _this.key = key;
	        _this.data = data;
	        _this.fieldMask = fieldMask;
	        _this.precondition = precondition;
	        _this.type = MutationType.Patch;
	        return _this;
	    }
	    PatchMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
	        this.verifyKeyMatches(maybeDoc);
	        assert_1.assert(mutationResult.transformResults == null, 'Transform results received by PatchMutation.');
	        // TODO(mcg): Relax enforcement of this precondition
	        //
	        // We shouldn't actually enforce the precondition since it already passed on
	        // the backend, but we may not have a local version of the document to
	        // patch, so we use the precondition to prevent incorrectly putting a
	        // partial document into our cache.
	        if (!this.precondition.isValidFor(maybeDoc)) {
	            return maybeDoc;
	        }
	        var version = Mutation.getPostMutationVersion(maybeDoc);
	        var newData = this.patchDocument(maybeDoc);
	        return new document_1.Document(this.key, version, newData, {
	            hasLocalMutations: false
	        });
	    };
	    PatchMutation.prototype.applyToLocalView = function (maybeDoc, localWriteTime) {
	        this.verifyKeyMatches(maybeDoc);
	        if (!this.precondition.isValidFor(maybeDoc)) {
	            return maybeDoc;
	        }
	        var version = Mutation.getPostMutationVersion(maybeDoc);
	        var newData = this.patchDocument(maybeDoc);
	        return new document_1.Document(this.key, version, newData, {
	            hasLocalMutations: true
	        });
	    };
	    PatchMutation.prototype.equals = function (other) {
	        return (other instanceof PatchMutation &&
	            this.key.equals(other.key) &&
	            this.fieldMask.equals(other.fieldMask) &&
	            this.precondition.equals(other.precondition));
	    };
	    /**
	     * Patches the data of document if available or creates a new document. Note
	     * that this does not check whether or not the precondition of this patch
	     * holds.
	     */
	    PatchMutation.prototype.patchDocument = function (maybeDoc) {
	        var data;
	        if (maybeDoc instanceof document_1.Document) {
	            data = maybeDoc.data;
	        }
	        else {
	            data = field_value_1.ObjectValue.EMPTY;
	        }
	        return this.patchObject(data);
	    };
	    PatchMutation.prototype.patchObject = function (data) {
	        for (var _i = 0, _a = this.fieldMask.fields; _i < _a.length; _i++) {
	            var fieldPath = _a[_i];
	            var newValue = this.data.field(fieldPath);
	            if (newValue !== undefined) {
	                data = data.set(fieldPath, newValue);
	            }
	            else {
	                data = data.delete(fieldPath);
	            }
	        }
	        return data;
	    };
	    return PatchMutation;
	}(Mutation));
	exports.PatchMutation = PatchMutation;
	/**
	 * A mutation that modifies specific fields of the document with transform
	 * operations. Currently the only supported transform is a server timestamp, but
	 * IP Address, increment(n), etc. could be supported in the future.
	 *
	 * It is somewhat similar to a PatchMutation in that it patches specific fields
	 * and has no effect when applied to a null or NoDocument (see comment on
	 * Mutation for rationale).
	 */
	var TransformMutation = /** @class */ (function (_super) {
	    __extends(TransformMutation, _super);
	    function TransformMutation(key, fieldTransforms) {
	        var _this = _super.call(this) || this;
	        _this.key = key;
	        _this.fieldTransforms = fieldTransforms;
	        _this.type = MutationType.Transform;
	        // NOTE: We set a precondition of exists: true as a safety-check, since we
	        // always combine TransformMutations with a SetMutation or PatchMutation which
	        // (if successful) should end up with an existing document.
	        _this.precondition = Precondition.exists(true);
	        return _this;
	    }
	    TransformMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
	        this.verifyKeyMatches(maybeDoc);
	        assert_1.assert(mutationResult.transformResults != null, 'Transform results missing for TransformMutation.');
	        var transformResults = mutationResult.transformResults;
	        // TODO(mcg): Relax enforcement of this precondition
	        //
	        // We shouldn't actually enforce the precondition since it already passed on
	        // the backend, but we may not have a local version of the document to
	        // patch, so we use the precondition to prevent incorrectly putting a
	        // partial document into our cache.
	        if (!this.precondition.isValidFor(maybeDoc)) {
	            return maybeDoc;
	        }
	        var doc = this.requireDocument(maybeDoc);
	        var newData = this.transformObject(doc.data, transformResults);
	        return new document_1.Document(this.key, doc.version, newData, {
	            hasLocalMutations: false
	        });
	    };
	    TransformMutation.prototype.applyToLocalView = function (maybeDoc, localWriteTime) {
	        this.verifyKeyMatches(maybeDoc);
	        if (!this.precondition.isValidFor(maybeDoc)) {
	            return maybeDoc;
	        }
	        var doc = this.requireDocument(maybeDoc);
	        var transformResults = this.localTransformResults(localWriteTime);
	        var newData = this.transformObject(doc.data, transformResults);
	        return new document_1.Document(this.key, doc.version, newData, {
	            hasLocalMutations: true
	        });
	    };
	    TransformMutation.prototype.equals = function (other) {
	        return (other instanceof TransformMutation &&
	            this.key.equals(other.key) &&
	            misc.arrayEquals(this.fieldTransforms, other.fieldTransforms) &&
	            this.precondition.equals(other.precondition));
	    };
	    /**
	     * Asserts that the given MaybeDocument is actually a Document and verifies
	     * that it matches the key for this mutation. Since we only support
	     * transformations with precondition exists this method is guaranteed to be
	     * safe.
	     */
	    TransformMutation.prototype.requireDocument = function (maybeDoc) {
	        assert_1.assert(maybeDoc instanceof document_1.Document, 'Unknown MaybeDocument type ' + maybeDoc);
	        var doc = maybeDoc;
	        assert_1.assert(doc.key.equals(this.key), 'Can only transform a document with the same key');
	        return doc;
	    };
	    /**
	     * Creates a list of "transform results" (a transform result is a field value
	     * representing the result of applying a transform) for use when applying a
	     * TransformMutation locally.
	     *
	     * @param localWriteTime The local time of the transform mutation (used to
	     *     generate ServerTimestampValues).
	     * @return The transform results list.
	     */
	    TransformMutation.prototype.localTransformResults = function (localWriteTime) {
	        var transformResults = [];
	        for (var _i = 0, _a = this.fieldTransforms; _i < _a.length; _i++) {
	            var fieldTransform = _a[_i];
	            var transform = fieldTransform.transform;
	            if (transform instanceof ServerTimestampTransform) {
	                transformResults.push(new field_value_1.ServerTimestampValue(localWriteTime));
	            }
	            else {
	                return assert_1.fail('Encountered unknown transform: ' + transform);
	            }
	        }
	        return transformResults;
	    };
	    TransformMutation.prototype.transformObject = function (data, transformResults) {
	        assert_1.assert(transformResults.length === this.fieldTransforms.length, 'TransformResults length mismatch.');
	        for (var i = 0; i < this.fieldTransforms.length; i++) {
	            var fieldTransform = this.fieldTransforms[i];
	            var transform = fieldTransform.transform;
	            var fieldPath = fieldTransform.field;
	            if (transform instanceof ServerTimestampTransform) {
	                data = data.set(fieldPath, transformResults[i]);
	            }
	            else {
	                return assert_1.fail('Encountered unknown transform: ' + transform);
	            }
	        }
	        return data;
	    };
	    return TransformMutation;
	}(Mutation));
	exports.TransformMutation = TransformMutation;
	/** A mutation that deletes the document at the given key. */
	var DeleteMutation = /** @class */ (function (_super) {
	    __extends(DeleteMutation, _super);
	    function DeleteMutation(key, precondition) {
	        var _this = _super.call(this) || this;
	        _this.key = key;
	        _this.precondition = precondition;
	        _this.type = MutationType.Delete;
	        return _this;
	    }
	    DeleteMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
	        this.verifyKeyMatches(maybeDoc);
	        assert_1.assert(mutationResult.transformResults == null, 'Transform results received by DeleteMutation.');
	        // Unlike applyToLocalView, if we're applying a mutation to a remote
	        // document the server has accepted the mutation so the precondition must
	        // have held.
	        return new document_1.NoDocument(this.key, snapshot_version_1.SnapshotVersion.MIN);
	    };
	    DeleteMutation.prototype.applyToLocalView = function (maybeDoc, localWriteTime) {
	        this.verifyKeyMatches(maybeDoc);
	        if (!this.precondition.isValidFor(maybeDoc)) {
	            return maybeDoc;
	        }
	        if (maybeDoc) {
	            assert_1.assert(maybeDoc.key.equals(this.key), 'Can only apply mutation to document with same key');
	        }
	        return new document_1.NoDocument(this.key, snapshot_version_1.SnapshotVersion.forDeletedDoc());
	    };
	    DeleteMutation.prototype.equals = function (other) {
	        return (other instanceof DeleteMutation &&
	            this.key.equals(other.key) &&
	            this.precondition.equals(other.precondition));
	    };
	    return DeleteMutation;
	}(Mutation));
	exports.DeleteMutation = DeleteMutation;
	
	//# sourceMappingURL=mutation.js.map


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var sorted_map_1 = __webpack_require__(50);
	/**
	 * SortedSet is an immutable (copy-on-write) collection that holds elements
	 * in order specified by the provided comparator.
	 *
	 * NOTE: if provided comparator returns 0 for two elements, we consider them to
	 * be equal!
	 */
	var SortedSet = /** @class */ (function () {
	    function SortedSet(comparator) {
	        this.comparator = comparator;
	        this.data = new sorted_map_1.SortedMap(this.comparator);
	    }
	    /**
	     * Creates a SortedSet from the keys of the map.
	     * This is currently implemented as an O(n) copy.
	     */
	    SortedSet.fromMapKeys = function (map) {
	        var keys = new SortedSet(map.comparator);
	        map.forEach(function (key) {
	            keys = keys.add(key);
	        });
	        return keys;
	    };
	    SortedSet.prototype.has = function (elem) {
	        return this.data.get(elem) !== null;
	    };
	    SortedSet.prototype.first = function () {
	        return this.data.minKey();
	    };
	    SortedSet.prototype.last = function () {
	        return this.data.maxKey();
	    };
	    Object.defineProperty(SortedSet.prototype, "size", {
	        get: function () {
	            return this.data.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SortedSet.prototype.indexOf = function (elem) {
	        return this.data.indexOf(elem);
	    };
	    /** Iterates elements in order defined by "comparator" */
	    SortedSet.prototype.forEach = function (cb) {
	        this.data.inorderTraversal(function (k, v) {
	            cb(k);
	            return false;
	        });
	    };
	    /** Iterates over `elem`s such that: range[0] <= elem < range[1]. */
	    SortedSet.prototype.forEachInRange = function (range, cb) {
	        var iter = this.data.getIteratorFrom(range[0]);
	        while (iter.hasNext()) {
	            var elem = iter.getNext();
	            if (this.comparator(elem.key, range[1]) >= 0)
	                return;
	            cb(elem.key);
	        }
	    };
	    /**
	     * Iterates over `elem`s such that: start <= elem until false is returned.
	     */
	    SortedSet.prototype.forEachWhile = function (cb, start) {
	        var iter;
	        if (start !== undefined) {
	            iter = this.data.getIteratorFrom(start);
	        }
	        else {
	            iter = this.data.getIterator();
	        }
	        while (iter.hasNext()) {
	            var elem = iter.getNext();
	            var result = cb(elem.key);
	            if (!result)
	                return;
	        }
	    };
	    /** Finds the least element greater than or equal to `elem`. */
	    SortedSet.prototype.firstAfterOrEqual = function (elem) {
	        var iter = this.data.getIteratorFrom(elem);
	        return iter.hasNext() ? iter.getNext().key : null;
	    };
	    /** Inserts or updates an element */
	    SortedSet.prototype.add = function (elem) {
	        return this.copy(this.data.remove(elem).insert(elem, true));
	    };
	    /** Deletes an element */
	    SortedSet.prototype.delete = function (elem) {
	        if (!this.has(elem))
	            return this;
	        return this.copy(this.data.remove(elem));
	    };
	    SortedSet.prototype.isEmpty = function () {
	        return this.data.isEmpty();
	    };
	    SortedSet.prototype.unionWith = function (other) {
	        var result = this;
	        other.forEach(function (elem) {
	            result = result.add(elem);
	        });
	        return result;
	    };
	    SortedSet.prototype.equals = function (other) {
	        if (!(other instanceof SortedSet))
	            return false;
	        if (this.size !== other.size)
	            return false;
	        var thisIt = this.data.getIterator();
	        var otherIt = other.data.getIterator();
	        while (thisIt.hasNext()) {
	            var thisElem = thisIt.getNext().key;
	            var otherElem = otherIt.getNext().key;
	            if (this.comparator(thisElem, otherElem) !== 0)
	                return false;
	        }
	        return true;
	    };
	    SortedSet.prototype.toString = function () {
	        var result = [];
	        this.forEach(function (elem) { return result.push(elem); });
	        return 'SortedSet(' + result.toString() + ')';
	    };
	    SortedSet.prototype.copy = function (data) {
	        var result = new SortedSet(this.comparator);
	        result.data = data;
	        return result;
	    };
	    return SortedSet;
	}());
	exports.SortedSet = SortedSet;
	
	//# sourceMappingURL=sorted_set.js.map


/***/ },
/* 98 */
/***/ function(module, exports) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	var CODES = {
	    AVAILABLE_IN_WINDOW: 'only-available-in-window',
	    AVAILABLE_IN_SW: 'only-available-in-sw',
	    SHOULD_BE_INHERITED: 'should-be-overriden',
	    BAD_SENDER_ID: 'bad-sender-id',
	    INCORRECT_GCM_SENDER_ID: 'incorrect-gcm-sender-id',
	    PERMISSION_DEFAULT: 'permission-default',
	    PERMISSION_BLOCKED: 'permission-blocked',
	    UNSUPPORTED_BROWSER: 'unsupported-browser',
	    NOTIFICATIONS_BLOCKED: 'notifications-blocked',
	    FAILED_DEFAULT_REGISTRATION: 'failed-serviceworker-registration',
	    SW_REGISTRATION_EXPECTED: 'sw-registration-expected',
	    GET_SUBSCRIPTION_FAILED: 'get-subscription-failed',
	    INVALID_SAVED_TOKEN: 'invalid-saved-token',
	    SW_REG_REDUNDANT: 'sw-reg-redundant',
	    TOKEN_SUBSCRIBE_FAILED: 'token-subscribe-failed',
	    TOKEN_SUBSCRIBE_NO_TOKEN: 'token-subscribe-no-token',
	    TOKEN_SUBSCRIBE_NO_PUSH_SET: 'token-subscribe-no-push-set',
	    USE_SW_BEFORE_GET_TOKEN: 'use-sw-before-get-token',
	    INVALID_DELETE_TOKEN: 'invalid-delete-token',
	    DELETE_TOKEN_NOT_FOUND: 'delete-token-not-found',
	    DELETE_SCOPE_NOT_FOUND: 'delete-scope-not-found',
	    BG_HANDLER_FUNCTION_EXPECTED: 'bg-handler-function-expected',
	    NO_WINDOW_CLIENT_TO_MSG: 'no-window-client-to-msg',
	    UNABLE_TO_RESUBSCRIBE: 'unable-to-resubscribe',
	    NO_FCM_TOKEN_FOR_RESUBSCRIBE: 'no-fcm-token-for-resubscribe',
	    FAILED_TO_DELETE_TOKEN: 'failed-to-delete-token',
	    NO_SW_IN_REG: 'no-sw-in-reg',
	    BAD_SCOPE: 'bad-scope',
	    BAD_VAPID_KEY: 'bad-vapid-key',
	    BAD_SUBSCRIPTION: 'bad-subscription',
	    BAD_TOKEN: 'bad-token',
	    BAD_PUSH_SET: 'bad-push-set',
	    FAILED_DELETE_VAPID_KEY: 'failed-delete-vapid-key'
	};
	var ERROR_MAP = (_a = {},
	    _a[CODES.AVAILABLE_IN_WINDOW] = 'This method is available in a Window context.',
	    _a[CODES.AVAILABLE_IN_SW] = 'This method is available in a service worker ' + 'context.',
	    _a[CODES.SHOULD_BE_INHERITED] = 'This method should be overriden by ' + 'extended classes.',
	    _a[CODES.BAD_SENDER_ID] = "Please ensure that 'messagingSenderId' is set " +
	        'correctly in the options passed into firebase.initializeApp().',
	    _a[CODES.PERMISSION_DEFAULT] = 'The required permissions were not granted and ' + 'dismissed instead.',
	    _a[CODES.PERMISSION_BLOCKED] = 'The required permissions were not granted and ' + 'blocked instead.',
	    _a[CODES.UNSUPPORTED_BROWSER] = "This browser doesn't support the API's " +
	        'required to use the firebase SDK.',
	    _a[CODES.NOTIFICATIONS_BLOCKED] = 'Notifications have been blocked.',
	    _a[CODES.FAILED_DEFAULT_REGISTRATION] = 'We are unable to register the ' +
	        'default service worker. {$browserErrorMessage}',
	    _a[CODES.SW_REGISTRATION_EXPECTED] = 'A service worker registration was the ' + 'expected input.',
	    _a[CODES.GET_SUBSCRIPTION_FAILED] = 'There was an error when trying to get ' +
	        'any existing Push Subscriptions.',
	    _a[CODES.INVALID_SAVED_TOKEN] = 'Unable to access details of the saved token.',
	    _a[CODES.SW_REG_REDUNDANT] = 'The service worker being used for push was made ' + 'redundant.',
	    _a[CODES.TOKEN_SUBSCRIBE_FAILED] = 'A problem occured while subscribing the ' + 'user to FCM: {$message}',
	    _a[CODES.TOKEN_SUBSCRIBE_NO_TOKEN] = 'FCM returned no token when subscribing ' + 'the user to push.',
	    _a[CODES.TOKEN_SUBSCRIBE_NO_PUSH_SET] = 'FCM returned an invalid response ' + 'when getting an FCM token.',
	    _a[CODES.USE_SW_BEFORE_GET_TOKEN] = 'You must call useServiceWorker() before ' +
	        'calling getToken() to ensure your service worker is used.',
	    _a[CODES.INVALID_DELETE_TOKEN] = 'You must pass a valid token into ' +
	        'deleteToken(), i.e. the token from getToken().',
	    _a[CODES.DELETE_TOKEN_NOT_FOUND] = 'The deletion attempt for token could not ' +
	        'be performed as the token was not found.',
	    _a[CODES.DELETE_SCOPE_NOT_FOUND] = 'The deletion attempt for service worker ' +
	        'scope could not be performed as the scope was not found.',
	    _a[CODES.BG_HANDLER_FUNCTION_EXPECTED] = 'The input to ' + 'setBackgroundMessageHandler() must be a function.',
	    _a[CODES.NO_WINDOW_CLIENT_TO_MSG] = 'An attempt was made to message a ' + 'non-existant window client.',
	    _a[CODES.UNABLE_TO_RESUBSCRIBE] = 'There was an error while re-subscribing ' +
	        'the FCM token for push messaging. Will have to resubscribe the ' +
	        'user on next visit. {$message}',
	    _a[CODES.NO_FCM_TOKEN_FOR_RESUBSCRIBE] = 'Could not find an FCM token ' +
	        'and as a result, unable to resubscribe. Will have to resubscribe the ' +
	        'user on next visit.',
	    _a[CODES.FAILED_TO_DELETE_TOKEN] = 'Unable to delete the currently saved token.',
	    _a[CODES.NO_SW_IN_REG] = 'Even though the service worker registration was ' +
	        'successful, there was a problem accessing the service worker itself.',
	    _a[CODES.INCORRECT_GCM_SENDER_ID] = "Please change your web app manifest's " +
	        "'gcm_sender_id' value to '103953800507' to use Firebase messaging.",
	    _a[CODES.BAD_SCOPE] = 'The service worker scope must be a string with at ' +
	        'least one character.',
	    _a[CODES.BAD_VAPID_KEY] = 'The public VAPID key must be a string with at ' + 'least one character.',
	    _a[CODES.BAD_SUBSCRIPTION] = 'The subscription must be a valid ' + 'PushSubscription.',
	    _a[CODES.BAD_TOKEN] = 'The FCM Token used for storage / lookup was not ' +
	        'a valid token string.',
	    _a[CODES.BAD_PUSH_SET] = 'The FCM push set used for storage / lookup was not ' +
	        'not a valid push set string.',
	    _a[CODES.FAILED_DELETE_VAPID_KEY] = 'The VAPID key could not be deleted.',
	    _a);
	exports.default = {
	    codes: CODES,
	    map: ERROR_MAP
	};
	var _a;
	
	//# sourceMappingURL=errors.js.map


/***/ },
/* 99 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @fileoverview Constants used in the Firebase Storage library.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Domain and scheme for API calls.
	 */
	exports.domainBase = 'https://firebasestorage.googleapis.com';
	/**
	 * Domain and scheme for object downloads.
	 */
	exports.downloadBase = 'https://firebasestorage.googleapis.com';
	/**
	 * Base URL for non-upload calls to the API.
	 */
	exports.apiBaseUrl = '/v0';
	/**
	 * Base URL for upload calls to the API.
	 */
	exports.apiUploadBaseUrl = '/v0';
	function setDomainBase(domainBase) {
	    domainBase = domainBase;
	}
	exports.setDomainBase = setDomainBase;
	exports.configOption = 'storageBucket';
	/**
	 * 1 minute
	 */
	exports.shortMaxOperationRetryTime = 1 * 60 * 1000;
	/**
	 * 2 minutes
	 */
	exports.defaultMaxOperationRetryTime = 2 * 60 * 1000;
	/**
	 * 10 minutes
	 */
	exports.defaultMaxUploadRetryTime = 10 * 60 * 100;
	/**
	 * This is the value of Number.MIN_SAFE_INTEGER, which is not well supported
	 * enough for us to use it directly.
	 */
	exports.minSafeInteger = -9007199254740991;
	
	//# sourceMappingURL=constants.js.map


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @fileoverview Functionality related to the parsing/composition of bucket/
	 * object location.
	 */
	var errorsExports = __webpack_require__(41);
	/**
	 * @struct
	 */
	var Location = /** @class */ (function () {
	    function Location(bucket, path) {
	        this.bucket = bucket;
	        this.path_ = path;
	    }
	    Object.defineProperty(Location.prototype, "path", {
	        get: function () {
	            return this.path_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Location.prototype.fullServerUrl = function () {
	        var encode = encodeURIComponent;
	        return '/b/' + encode(this.bucket) + '/o/' + encode(this.path);
	    };
	    Location.prototype.bucketOnlyServerUrl = function () {
	        var encode = encodeURIComponent;
	        return '/b/' + encode(this.bucket) + '/o';
	    };
	    Location.makeFromBucketSpec = function (bucketString) {
	        var bucketLocation;
	        try {
	            bucketLocation = Location.makeFromUrl(bucketString);
	        }
	        catch (e) {
	            // Not valid URL, use as-is. This lets you put bare bucket names in
	            // config.
	            return new Location(bucketString, '');
	        }
	        if (bucketLocation.path === '') {
	            return bucketLocation;
	        }
	        else {
	            throw errorsExports.invalidDefaultBucket(bucketString);
	        }
	    };
	    Location.makeFromUrl = function (url) {
	        var location = null;
	        var bucketDomain = '([A-Za-z0-9.\\-]+)';
	        function gsModify(loc) {
	            if (loc.path.charAt(loc.path.length - 1) === '/') {
	                loc.path_ = loc.path_.slice(0, -1);
	            }
	        }
	        var gsPath = '(/(.*))?$';
	        var path = '(/([^?#]*).*)?$';
	        var gsRegex = new RegExp('^gs://' + bucketDomain + gsPath, 'i');
	        var gsIndices = { bucket: 1, path: 3 };
	        function httpModify(loc) {
	            loc.path_ = decodeURIComponent(loc.path);
	        }
	        var version = 'v[A-Za-z0-9_]+';
	        var httpRegex = new RegExp('^https?://firebasestorage\\.googleapis\\.com/' +
	            version +
	            '/b/' +
	            bucketDomain +
	            '/o' +
	            path, 'i');
	        var httpIndices = { bucket: 1, path: 3 };
	        var groups = [
	            { regex: gsRegex, indices: gsIndices, postModify: gsModify },
	            { regex: httpRegex, indices: httpIndices, postModify: httpModify }
	        ];
	        for (var i = 0; i < groups.length; i++) {
	            var group = groups[i];
	            var captures = group.regex.exec(url);
	            if (captures) {
	                var bucketValue = captures[group.indices.bucket];
	                var pathValue = captures[group.indices.path];
	                if (!pathValue) {
	                    pathValue = '';
	                }
	                location = new Location(bucketValue, pathValue);
	                group.postModify(location);
	                break;
	            }
	        }
	        if (location == null) {
	            throw errorsExports.invalidUrl(url);
	        }
	        return location;
	    };
	    return Location;
	}());
	exports.Location = Location;
	
	//# sourceMappingURL=location.js.map


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	*  filename: ej2-lists.umd.min.js
	*  version : 19.4.55
	*  Copyright Syncfusion Inc. 2001 - 2020. All rights reserved.
	*  Use of this code is subject to the terms of our license.
	*  A copy of the current license can be obtained at any time by e-mailing
	*  licensing@syncfusion.com. Any infringement will be prosecuted under
	*  applicable laws. 
	*/
	!function(e,t){ true?t(exports,__webpack_require__(23),__webpack_require__(76),__webpack_require__(42)):"function"==typeof define&&define.amd?define(["exports","@syncfusion/ej2-base","@syncfusion/ej2-data","@syncfusion/ej2-buttons"],t):t(e.ej={},e.ej2Base,e.ej2Data,e.ej2Buttons)}(this,function(e,t,i,s){"use strict";function n(e,i){var s={};if(t.isNullOrUndefined(e)||"string"==typeof e||"number"==typeof e||!t.isNullOrUndefined(e.isHeader))return e;for(var n=0,l=Object.keys(i);n<l.length;n++){var r=i[l[n]],a=t.isNullOrUndefined(r)||"string"!=typeof r?void 0:t.getValue(r,e);t.isNullOrUndefined(a)||(s[r]=a)}return s}function l(e){if(e)try{if(document.querySelector(e))return t.compile(document.querySelector(e).innerHTML.trim())}catch(i){return t.compile(e)}}function r(e,i,s,n){var l=[];if(i||(i=e),s&&s.length?s.forEach(function(t){l.push(e.children[t])}):l=[].slice.call(e.children),t.isNullOrUndefined(n))l.forEach(function(e){i.appendChild(e)});else{var r=i.children[n];l.forEach(function(e){i.insertBefore(e,r)})}}e.cssClass={li:"e-list-item",ul:"e-list-parent e-ul",group:"e-list-group-item",icon:"e-list-icon",text:"e-list-text",check:"e-list-check",checked:"e-checked",selected:"e-selected",expanded:"e-expanded",textContent:"e-text-content",hasChild:"e-has-child",level:"e-level",url:"e-list-url",collapsible:"e-icon-collapsible",disabled:"e-disabled",image:"e-list-img",iconWrapper:"e-icon-wrapper",anchorWrap:"e-anchor-wrap",navigable:"e-navigable"},function(s){function r(e,t,i,s,n){return w(e,a(e,t,i,s,n),null,s)}function a(i,s,n,l,r){var a=[],o=t.extend({},L,l);e.cssClass=y(o.moduleName);for(var c=v(),h=0;h<s.length;h++)if(!t.isNullOrUndefined(s[h])){var d=void 0;if(o.itemCreating&&"function"==typeof o.itemCreating){var u={dataSource:s,curData:s[h],text:s[h],options:o};o.itemCreating(u)}if(d=n?I(i,s[h],void 0,null,null,[],null,c,h,l):x(i,s[h],void 0,null,null,l,r),o.itemCreated&&"function"==typeof o.itemCreated){u={dataSource:s,curData:s[h],text:s[h],item:d,options:o};o.itemCreated(u)}a.push(d)}return a}function o(i,l,r,a,o,h){var d=t.extend({},L,r);e.cssClass=y(d.moduleName);var u,p=!h||"listview"!=h.getModuleName()&&"multiselect"!=h.getModuleName()?t.extend({},s.defaultMappedFields,d.fields):d.fields,g=t.extend({},S,d.ariaAttributes),b=[];a&&(g.level=a);var w,C,V=[];l&&l.length&&!t.isNullOrUndefined(m(l).item)&&!m(l).item.hasOwnProperty(p.id)&&(u=v());for(var E=0;E<l.length;E++){var O=n(l[E],p);if(!t.isNullOrUndefined(l[E])){if(d.itemCreating&&"function"==typeof d.itemCreating){var k={dataSource:l,curData:l[E],text:O[p.text],options:d,fields:p};d.itemCreating(k)}var D=l[E];d.itemCreating&&"function"==typeof d.itemCreating&&(O=n(l[E],p)),O.hasOwnProperty(p.id)&&!t.isNullOrUndefined(O[p.id])&&(u=O[p.id]);var H=[];if(d.showCheckBox&&(d.itemNavigable&&(O[p.url]||O[p.urlAttributes])?b.push(i("input",{className:e.cssClass.check,attrs:{type:"checkbox"}})):H.push(i("input",{className:e.cssClass.check,attrs:{type:"checkbox"}}))),!0===o)d.showIcon&&O.hasOwnProperty(p.iconCss)&&!t.isNullOrUndefined(O[p.iconCss])&&H.push(i("span",{className:e.cssClass.icon+" "+O[p.iconCss]})),C=(w=I(i,D,O,p,d.itemClass,H,!(!D.hasOwnProperty("isHeader")||!D.isHeader),u,E,r)).querySelector("."+e.cssClass.anchorWrap),d.itemNavigable&&b.length&&t.prepend(b,w.firstElementChild);else{if((w=x(i,D,O,p,d.itemClass,r,h)).classList.add(e.cssClass.level+"-"+g.level),w.setAttribute("aria-level",g.level.toString()),C=w.querySelector("."+e.cssClass.anchorWrap),O.hasOwnProperty(p.tooltip)&&w.setAttribute("title",O[p.tooltip]),O.hasOwnProperty(p.htmlAttributes)&&O[p.htmlAttributes]&&f(w,O[p.htmlAttributes]),O.hasOwnProperty(p.enabled)&&!1===O[p.enabled]&&w.classList.add(e.cssClass.disabled),O.hasOwnProperty(p.isVisible)&&!1===O[p.isVisible]&&(w.style.display="none"),O.hasOwnProperty(p.imageUrl)&&!t.isNullOrUndefined(O[p.imageUrl])&&!d.template){var N={src:O[p.imageUrl]};t.merge(N,O[p.imageAttributes]);var B=i("img",{className:e.cssClass.image,attrs:N});C?C.insertAdjacentElement("afterbegin",B):t.prepend([B],w.firstElementChild)}if(d.showIcon&&O.hasOwnProperty(p.iconCss)&&!t.isNullOrUndefined(O[p.iconCss])&&!d.template){var T=i("div",{className:e.cssClass.icon+" "+O[p.iconCss]});C?C.insertAdjacentElement("afterbegin",T):t.prepend([T],w.firstElementChild)}H.length&&t.prepend(H,w.firstElementChild),d.itemNavigable&&b.length&&t.prepend(b,w.firstElementChild),function(i,s,n,l,r,a,o){var h=s[n.child]||[],d=s[n.hasChildren];if(h.length&&(d=!0,a.classList.add(e.cssClass.hasChild),r.processSubChild)){var u=c(i,h,r,++o);a.appendChild(u)}if(r.expandCollapse&&d&&!r.template){a.firstElementChild.classList.add(e.cssClass.iconWrapper);var p="Left"===r.expandIconPosition?t.prepend:t.append;p([i("div",{className:"e-icons "+r.expandIconClass})],a.querySelector("."+e.cssClass.textContent))}}(i,O,p,0,d,w,g.level)}if(C&&t.addClass([w],[e.cssClass.navigable]),d.itemCreated&&"function"==typeof d.itemCreated){k={dataSource:l,curData:l[E],text:O[p.text],item:w,options:d,fields:p};d.itemCreated(k)}b=[],V.push(w)}}return V}function c(e,i,s,n,l,r){var a=t.extend({},L,s);return w(e,o(e,i,s,n,l,r),a.listClass,s)}function h(e,t){if(t&&e){return Array.prototype.slice.call(t).indexOf(e)}}function d(e,t,s){if(void 0===s&&(s=new i.Query),"Ascending"===e)s.sortBy(t,"ascending",!0);else if("Descending"===e)s.sortBy(t,"descending",!0);else for(var n=0;n<s.queries.length;n++)"onSortBy"===s.queries[n].fn&&s.queries.splice(n,1);return s}function u(e,t){return new i.DataManager(e).executeLocal(t)}function p(e,i){var n=t.extend({},L,i),l=t.extend({},s.defaultMappedFields,n.fields),r=e.cloneNode(!0),a=[];r.classList.add("json-parent");var o=r.querySelectorAll(".json-parent>li");r.classList.remove("json-parent");for(var c=0;c<o.length;c++){for(var h=o[c],d=h.querySelector("a"),u=h.querySelector("ul"),m={},f=d?d.childNodes:h.childNodes,I=Object.keys(f),y=0;y<f.length;y++)f[Number(I[y])].hasChildNodes()||(m[l.text]=f[Number(I[y])].textContent);var b=g(h);b.id?(m[l.id]=b.id,delete b.id):m[l.id]=v(),Object.keys(b).length&&(m[l.htmlAttributes]=b),d&&(b=g(d),Object.keys(b).length&&(m[l.urlAttributes]=b)),u&&(m[l.child]=p(u,i)),a.push(m)}return a}function m(e){for(var i={typeof:null,item:null},s=0;s<e.length;s++)if(!t.isNullOrUndefined(e[s]))return i={typeof:typeof e[s],item:e[s]};return i}function f(e,i){var s={};t.merge(s,i),s.class&&(t.addClass([e],s.class.split(" ")),delete s.class),t.attributes(e,s)}function g(e){for(var t={},i=e.attributes,s=0;s<i.length;s++)t[i[s].nodeName]=i[s].nodeValue;return t}function v(){return Math.floor(65536*(1+Math.random())).toString(16).substring(1)}function I(i,s,n,l,r,a,o,c,h,d){var u,p=t.extend({},L,d),m=t.extend({},S,p.ariaAttributes),g=s,v=s;"string"!=typeof s&&"number"!=typeof s&&"boolean"!=typeof s&&(u=s,g="boolean"==typeof n[l.text]||"number"==typeof n[l.text]?n[l.text]:n[l.text]||"",v=n[l.value]);var I;I=t.isNullOrUndefined(u)||t.isNullOrUndefined(n[l.id])||""===n[l.id]?c+"-"+h:c;var y=i("li",{className:(!0===o?e.cssClass.group:e.cssClass.li)+" "+(t.isNullOrUndefined(r)?"":r),id:I,attrs:""!==m.groupItemRole&&""!==m.itemRole?{role:!0===o?m.groupItemRole:m.itemRole}:{}});return u&&n.hasOwnProperty(l.enabled)&&"false"===n[l.enabled].toString()&&y.classList.add(e.cssClass.disabled),o?y.innerText=g:(y.setAttribute("data-value",t.isNullOrUndefined(v)?"null":v),y.setAttribute("role","option"),u&&n.hasOwnProperty(l.htmlAttributes)&&n[l.htmlAttributes]&&f(y,n[l.htmlAttributes]),a.length&&!p.itemNavigable&&t.append(a,y),u&&(n[l.url]||n[l.urlAttributes]&&n[l.urlAttributes].href)?y.appendChild(b(i,u,l,g,a,p.itemNavigable)):(a.length&&p.itemNavigable&&t.append(a,y),y.appendChild(document.createTextNode(g)))),y}function y(e){return{li:"e-"+e+"-item",ul:"e-"+e+"-parent e-ul",group:"e-"+e+"-group-item",icon:"e-"+e+"-icon",text:"e-"+e+"-text",check:"e-"+e+"-check",checked:"e-checked",selected:"e-selected",expanded:"e-expanded",textContent:"e-text-content",hasChild:"e-has-child",level:"e-level",url:"e-"+e+"-url",collapsible:"e-icon-collapsible",disabled:"e-disabled",image:"e-"+e+"-img",iconWrapper:"e-icon-wrapper",anchorWrap:"e-anchor-wrap",navigable:"e-navigable"}}function b(i,s,l,r,a,o){var c=n(s,l),h={href:c[l.url]};c.hasOwnProperty(l.urlAttributes)&&c[l.urlAttributes]&&(t.merge(h,c[l.urlAttributes]),h.href=c[l.url]?c[l.url]:c[l.urlAttributes].href);var d;if(o){d=i("a",{className:e.cssClass.text+" "+e.cssClass.url});var u=i("div",{className:e.cssClass.anchorWrap});a&&a.length&&t.append(a,u),u.appendChild(document.createTextNode(r)),t.append([u],d)}else d=i("a",{className:e.cssClass.text+" "+e.cssClass.url,innerHTML:r});return f(d,h),d}function x(i,s,n,r,a,o,c){var h,d,u,p=t.extend({},L,o),m=t.extend({},S,p.ariaAttributes),f=s;"string"!=typeof s&&"number"!=typeof s&&(u=s,f=n[r.text]||"",h=t.isNullOrUndefined(n._id)?n[r.id]:n._id,d=!(!s.hasOwnProperty("isHeader")||!s.isHeader)),o&&o.enableHtmlSanitizer&&(f=f);var g=i("li",{className:(!0===d?e.cssClass.group:e.cssClass.li)+" "+(t.isNullOrUndefined(a)?"":a),attrs:""!==m.groupItemRole&&""!==m.itemRole?{role:!0===d?m.groupItemRole:m.itemRole}:{}});if(!0==!t.isNullOrUndefined(h)?g.setAttribute("data-uid",h):g.setAttribute("data-uid",v()),d&&o&&o.groupTemplate){var I=l(o.groupTemplate);if(c&&"listview"!=c.getModuleName()){(y=I(s,c,"groupTemplate",p.groupTemplateID,!!p.isStringTemplate,null,g))&&t.append(y,g)}else t.append(I(s,c,"groupTemplate",p.groupTemplateID,!!p.isStringTemplate),g)}else if(!d&&o&&o.template){I=l(o.template);if(c&&"listview"!=c.getModuleName()){var y;(y=I(s,c,"template",p.templateID,!!p.isStringTemplate,null,g))&&t.append(y,g)}else t.append(I(s,c,"template",p.templateID,!!p.isStringTemplate),g)}else{var x=i("div",{className:e.cssClass.textContent,attrs:""!==m.wrapperRole?{role:m.wrapperRole}:{}});if(u&&(n[r.url]||n[r.urlAttributes]&&n[r.urlAttributes].href))x.appendChild(b(i,u,r,f,null,p.itemNavigable));else{var w=i("span",{className:e.cssClass.text,attrs:""!==m.itemText?{role:m.itemText}:{}});o&&o.enableHtmlSanitizer?w.innerText=f:w.innerHTML=f,x.appendChild(w)}g.appendChild(x)}return g}function w(i,s,n,l){var r=t.extend({},L,l),a=t.extend({},S,r.ariaAttributes);e.cssClass=y(r.moduleName);var o=i("ul",{className:e.cssClass.ul+" "+(t.isNullOrUndefined(n)?"":n),attrs:""!==a.listRole?{role:a.listRole}:{}});return t.append(s,o),o}s.defaultMappedFields={id:"id",text:"text",url:"url",value:"value",isChecked:"isChecked",enabled:"enabled",expanded:"expanded",selected:"selected",iconCss:"iconCss",child:"child",isVisible:"isVisible",hasChildren:"hasChildren",tooltip:"tooltip",htmlAttributes:"htmlAttributes",urlAttributes:"urlAttributes",imageAttributes:"imageAttributes",imageUrl:"imageUrl",groupBy:null,sortBy:null};var S={level:1,listRole:"presentation",itemRole:"presentation",groupItemRole:"group",itemText:"list-item",wrapperRole:"presentation"},L={showCheckBox:!1,showIcon:!1,enableHtmlSanitizer:!1,expandCollapse:!1,fields:s.defaultMappedFields,ariaAttributes:S,listClass:"",itemClass:"",processSubChild:!1,sortOrder:"None",template:null,groupTemplate:null,headerTemplate:null,expandIconClass:"e-icon-collapsible",moduleName:"list",expandIconPosition:"Right",itemNavigable:!1};s.createList=function(e,i,s,n,l){var a=t.extend({},L,s),o=t.extend({},S,a.ariaAttributes),h=m(i).typeof;return"string"===h||"number"===h?r(e,i,n,s,l):c(e,i,s,o.level,n,l)},s.createListFromArray=r,s.createListItemFromArray=a,s.createListItemFromJson=o,s.createListFromJson=c,s.getSiblingLI=function(i,s,n){if(e.cssClass=y(L.moduleName),i&&i.length){var l,r,a=Array.prototype.slice.call(i);for(l=a[(r=s?h(s,a):!0===n?a.length:-1)+(!0===n?-1:1)];l&&(!t.isVisible(l)||l.classList.contains(e.cssClass.disabled));)l=a[r+=!0===n?-1:1];return l}},s.indexOf=h,s.groupDataSource=function(e,n,l){void 0===l&&(l="None");var r=t.extend({},s.defaultMappedFields,n),a=(new i.Query).group(r.groupBy),o=u(e,a=d(l,"key",a));e=[];for(var c=0;c<o.length;c++){var h=o[c].items,p={};p[r.text]=o[c].key,p.isHeader=!0;var m=r.text;"id"===m&&(p[m="text"]=o[c].key),p._id="group-list-item-"+(o[c].key?o[c].key.toString().trim():"undefined"),p.items=h,e.push(p);for(var f=0;f<h.length;f++)e.push(h[f])}return e},s.addSorting=d,s.getDataSource=u,s.createJsonFromElement=p,s.renderContentTemplate=function(i,r,a,o,c,h){e.cssClass=y(L.moduleName);for(var d,u=i("ul",{className:e.cssClass.ul,attrs:{role:"presentation"}}),p=t.extend({},L,c),m=t.extend({},s.defaultMappedFields,o),f=l(r),g=[],I=v(),b=0;b<a.length;b++){var x=n(a[b],m),w=a[b],S=w.isHeader;if(d="string"==typeof a[b]||"number"==typeof a[b]?w:x[m.value],p.itemCreating&&"function"==typeof p.itemCreating){var C={dataSource:a,curData:w,text:d,options:p,fields:m};p.itemCreating(C)}p.itemCreating&&"function"==typeof p.itemCreating&&(x=n(a[b],m),d="string"==typeof a[b]||"number"==typeof a[b]?w:x[m.value]);var V=i("li",{id:I+"-"+b,className:S?e.cssClass.group:e.cssClass.li,attrs:{role:"presentation"}});if(S)"string"==typeof a[b]||"number"==typeof a[b]?V.innerText=w:V.innerText=x[m.text];else{var E=S?p.groupTemplateID:p.templateID;if(S)h&&"listview"!=h.getModuleName()?(O=f(w,h,"headerTemplate",E,!!p.isStringTemplate,null,V))&&t.append(O,V):t.append(f(w,h,"headerTemplate",E,!!p.isStringTemplate),V);else if(h&&"listview"!=h.getModuleName()){var O;(O=f(w,h,"template",E,!!p.isStringTemplate,null,V))&&t.append(O,V)}else t.append(f(w,h,"template",E,!!p.isStringTemplate),V);V.setAttribute("data-value",t.isNullOrUndefined(d)?"null":d),V.setAttribute("role","option")}p.itemCreated&&"function"==typeof p.itemCreated&&(C={dataSource:a,curData:w,text:d,item:V,options:p,fields:m},p.itemCreated(C)),g.push(V)}return t.append(g,u),u},s.renderGroupTemplate=function(e,i,n,r,a,o){for(var c=l(e),h=t.extend({},s.defaultMappedFields,n),d=t.extend({},L,a),u=h.groupBy,p=0,m=r;p<m.length;p++){var f=m[p],g={};if(g[u]=f.textContent,f.innerHTML="",o&&"listview"!=o.getModuleName()){var v=c(g,o,"groupTemplate",d.groupTemplateID,!!d.isStringTemplate,null,f);v&&t.append(v,f)}else t.append(c(g,o,"groupTemplate",d.groupTemplateID,!!d.isStringTemplate),f)}return r},s.generateId=v,s.generateUL=w,s.generateIcon=function(i,s,n,l){var r=t.extend({},L,l);return e.cssClass=y(r.moduleName),("Left"===r.expandIconPosition?t.prepend:t.append)([i("div",{className:"e-icons "+r.expandIconClass+" "+(t.isNullOrUndefined(n)?"":n)})],s.querySelector("."+e.cssClass.textContent)),s}}(e.ListBase||(e.ListBase={}));var a=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),o=function(e,t,i,s){var n,l=arguments.length,r=l<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(e,t,i,s);else for(var a=e.length-1;a>=0;a--)(n=e[a])&&(r=(l<3?n(r):l>3?n(t,i,r):n(t,i))||r);return l>3&&r&&Object.defineProperty(t,i,r),r},c={None:[],SlideLeft:["SlideRightOut","SlideLeftOut","SlideLeftIn","SlideRightIn"],SlideDown:["SlideTopOut","SlideBottomOut","SlideBottomIn","SlideTopIn"],Zoom:["FadeOut","FadeZoomOut","FadeZoomIn","FadeIn"],Fade:["FadeOut","FadeOut","FadeIn","FadeIn"]},h={None:[],SlideLeft:["SlideLeftOut","SlideRightOut","SlideRightIn","SlideLeftIn"],SlideDown:["SlideBottomOut","SlideTopOut","SlideTopIn","SlideBottomIn"],Zoom:["FadeZoomOut","FadeOut","FadeIn","FadeZoomIn"],Fade:["FadeOut","FadeOut","FadeIn","FadeIn"]},d={root:"e-listview",hover:"e-hover",selected:"e-active",focused:"e-focused",parentItem:"e-list-parent",listItem:"e-list-item",listIcon:"e-list-icon",textContent:"e-text-content",listItemText:"e-list-text",groupListItem:"e-list-group-item",hasChild:"e-has-child",view:"e-view",header:"e-list-header",headerText:"e-headertext",headerTemplateText:"e-headertemplate-text",text:"e-text",disable:"e-disabled",content:"e-content",icon:"e-icons",backIcon:"e-icon-back",checkboxWrapper:"e-checkbox-wrapper",checkbox:"e-checkbox",checked:"e-check",checklist:"e-checklist",checkboxIcon:"e-frame",checkboxRight:"e-checkbox-right",checkboxLeft:"e-checkbox-left",listviewCheckbox:"e-listview-checkbox",itemCheckList:"e-checklist",virtualElementContainer:"e-list-virtualcontainer"},u="GroupTemplate",p=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return a(i,e),o([t.Property("id")],i.prototype,"id",void 0),o([t.Property("text")],i.prototype,"text",void 0),o([t.Property("isChecked")],i.prototype,"isChecked",void 0),o([t.Property("isVisible")],i.prototype,"isVisible",void 0),o([t.Property("enabled")],i.prototype,"enabled",void 0),o([t.Property("iconCss")],i.prototype,"iconCss",void 0),o([t.Property("child")],i.prototype,"child",void 0),o([t.Property("tooltip")],i.prototype,"tooltip",void 0),o([t.Property("groupBy")],i.prototype,"groupBy",void 0),o([t.Property("text")],i.prototype,"sortBy",void 0),o([t.Property("htmlAttributes")],i.prototype,"htmlAttributes",void 0),o([t.Property("tableName")],i.prototype,"tableName",void 0),i}(t.ChildProperty),m=function(l){function r(e,t){var i=l.call(this,e,t)||this;return i.previousSelectedItems=[],i.hiddenItems=[],i.enabledItems=[],i.disabledItems=[],i}return a(r,l),r.prototype.onPropertyChanged=function(e,i){for(var s=0,n=Object.keys(e);s<n.length;s++){switch(n[s]){case"htmlAttributes":this.setHTMLAttribute();break;case"cssClass":this.setCSSClass(i.cssClass);break;case"enable":this.setEnable();break;case"width":case"height":this.setSize();break;case"enableRtl":this.setEnableRTL();break;case"fields":this.listBaseOption.fields=this.fields.properties,this.enableVirtualization?this.virtualizationModule.reRenderUiVirtualization():this.reRender();break;case"headerTitle":this.curDSLevel.length||this.header(this.headerTitle,!1,"header");break;case"query":this.enableVirtualization?this.virtualizationModule.reRenderUiVirtualization():this.reRender();break;case"showHeader":this.header(this.headerTitle,!1,"header");break;case"enableVirtualization":t.isNullOrUndefined(this.contentContainer)||t.detach(this.contentContainer),this.refresh();break;case"showCheckBox":case"checkBoxPosition":this.enableVirtualization?this.virtualizationModule.reRenderUiVirtualization():this.setCheckbox();break;case"dataSource":this.enableVirtualization?this.virtualizationModule.reRenderUiVirtualization():this.reRender();break;case"sortOrder":case"template":this.enableVirtualization||this.refresh();break;case"showIcon":this.enableVirtualization?this.virtualizationModule.reRenderUiVirtualization():(this.listBaseOption.showIcon=this.showIcon,this.curViewDS=this.getSubDS(),this.resetCurrentList())}}},r.prototype.setHTMLAttribute=function(){Object.keys(this.htmlAttributes).length&&t.attributes(this.element,this.htmlAttributes)},r.prototype.setCSSClass=function(e){this.cssClass&&t.addClass([this.element],this.cssClass.split(" ").filter(function(e){return e})),e&&t.removeClass([this.element],e.split(" ").filter(function(e){return e}))},r.prototype.setSize=function(){this.element.style.height=t.formatUnit(this.height),this.element.style.width=t.formatUnit(this.width),this.isWindow=!this.element.clientHeight},r.prototype.setEnable=function(){this.enableElement(this.element,this.enable)},r.prototype.setEnableRTL=function(){this.enableRtl?this.element.classList.add("e-rtl"):this.element.classList.remove("e-rtl")},r.prototype.enableElement=function(e,t){t?e.classList.remove(d.disable):e.classList.add(d.disable)},r.prototype.header=function(e,i,s){if(void 0===this.headerEle&&this.showHeader){this.enableHtmlSanitizer&&this.setProperties({headerTitle:t.SanitizeHtmlHelper.sanitize(this.headerTitle)},!0),this.headerEle=this.createElement("div",{className:d.header});var n=this.createElement("span",{className:d.headerText,innerHTML:this.headerTitle}),l=this.createElement("div",{className:d.text,innerHTML:n.outerHTML}),r=this.createElement("div",{className:d.icon+" "+d.backIcon+" e-but-back",attrs:{style:"display:none;"}});if(this.headerEle.appendChild(r),this.headerEle.appendChild(l),this.headerTemplate){var a=t.compile(this.headerTemplate),o=this.createElement("div",{className:d.headerTemplateText}),c=a({},this,s,this.LISTVIEW_HEADERTEMPLATE_ID,null,null,this.headerEle);c&&t.append(c,o),t.append([o],this.headerEle),this.isReact&&this.renderReactTemplates()}this.headerTemplate&&this.headerTitle&&l.classList.add("header"),this.element.classList.add("e-has-header"),t.prepend([this.headerEle],this.element)}else if(this.headerEle)if(this.showHeader){this.headerEle.style.display="";l=this.headerEle.querySelector("."+d.headerText),r=this.headerEle.querySelector("."+d.backIcon);this.enableHtmlSanitizer&&(e=t.SanitizeHtmlHelper.sanitize(e)),l.innerHTML=e,this.headerTemplate&&i&&(l.parentElement.classList.remove("header"),this.headerEle.querySelector("."+d.headerTemplateText).classList.add("nested-header")),this.headerTemplate&&!i&&(l.parentElement.classList.add("header"),this.headerEle.querySelector("."+d.headerTemplateText).classList.remove("nested-header"),this.headerEle.querySelector("."+d.headerTemplateText).classList.add("header")),r.style.display=!0===i?"":"none"}else this.headerEle.style.display="none"},r.prototype.switchView=function(e,t,i){var s=this;if(e&&t){var n=e.style.position,l="hidden"!==this.element.style.overflow?this.element.style.overflow:"";e.style.position="absolute",e.classList.add("e-view");var r=void 0,a=this.animation.duration;if(this.animation.effect)r=this.enableRtl?h[this.animation.effect]:c[this.animation.effect];else{r=c.SlideLeft,i=this.enableRtl,a=0}this.element.style.overflow="hidden",this.aniObj.animate(e,{name:!0===i?r[0]:r[1],duration:a,timingFunction:this.animation.easing,end:function(t){e.style.display="none",s.element.style.overflow=l,e.style.position=n,e.classList.remove("e-view")}}),t.style.display="",this.aniObj.animate(t,{name:!0===i?r[2]:r[3],duration:a,timingFunction:this.animation.easing,end:function(){s.trigger("actionComplete")}}),this.curUL=t}},r.prototype.preRender=function(){if(this.template)try{document.querySelectorAll(this.template).length&&this.setProperties({template:document.querySelector(this.template).innerHTML.trim()},!0)}catch(e){t.compile(this.template)}this.listBaseOption={template:this.template,headerTemplate:this.headerTemplate,groupTemplate:this.groupTemplate,expandCollapse:!0,listClass:"",ariaAttributes:{itemRole:"option",listRole:"presentation",itemText:"",groupItemRole:"group",wrapperRole:"presentation"},fields:this.fields.properties,sortOrder:this.sortOrder,showIcon:this.showIcon,itemCreated:this.renderCheckbox.bind(this),templateID:this.element.id+"Template",groupTemplateID:""+this.element.id+u,enableHtmlSanitizer:this.enableHtmlSanitizer},this.initialization()},r.prototype.initialization=function(){this.curDSLevel=[],this.animateOptions={},this.curViewDS=[],this.currentLiElements=[],this.isNestedList=!1,this.selectedData=[],this.selectedId=[],this.LISTVIEW_TEMPLATE_ID=this.element.id+"Template",this.LISTVIEW_GROUPTEMPLATE_ID=""+this.element.id+u,this.LISTVIEW_HEADERTEMPLATE_ID=this.element.id+"HeaderTemplate",this.aniObj=new t.Animation(this.animateOptions),this.removeElement(this.curUL),this.removeElement(this.ulElement),this.removeElement(this.headerEle),this.removeElement(this.contentContainer),this.curUL=this.ulElement=this.liCollection=this.headerEle=this.contentContainer=void 0},r.prototype.renderCheckbox=function(e){if(e.item.classList.contains(d.hasChild)&&(this.isNestedList=!0),this.showCheckBox&&this.isValidLI(e.item)){var t=void 0;(t=s.createCheckBox(this.createElement,!1,{checked:!1,enableRtl:this.enableRtl,cssClass:d.listviewCheckbox})).setAttribute("role","checkbox");var i=t.querySelector("."+d.checkboxIcon);e.item.classList.add(d.itemCheckList),e.item.firstElementChild.classList.add(d.checkbox),"string"!=typeof this.dataSource[0]&&"number"!=typeof this.dataSource[0]?n(e.curData,this.listBaseOption.fields)[this.listBaseOption.fields.isChecked]&&this.checkInternally(e,t):"string"!=typeof this.dataSource[0]&&"number"!=typeof this.dataSource[0]||-1===this.selectedData.indexOf(e.text)||this.checkInternally(e,t),t.setAttribute("aria-checked",i.classList.contains(d.checked)?"true":"false"),"Left"===this.checkBoxPosition?(t.classList.add(d.checkboxLeft),e.item.firstElementChild.classList.add(d.checkboxLeft),e.item.firstElementChild.insertBefore(t,e.item.firstElementChild.childNodes[0])):(t.classList.add(d.checkboxRight),e.item.firstElementChild.classList.add(d.checkboxRight),e.item.firstElementChild.appendChild(t)),this.currentLiElements.push(e.item),"Left"===this.checkBoxPosition?this.virtualCheckBox=e.item.firstElementChild.children[0]:this.virtualCheckBox=e.item.firstElementChild.lastElementChild}},r.prototype.checkInternally=function(e,t){e.item.classList.add(d.selected),e.item.setAttribute("aria-selected","true"),t.querySelector("."+d.checkboxIcon).classList.add(d.checked),t.setAttribute("aria-checked","true")},r.prototype.checkItem=function(e){this.toggleCheckBase(e,!0)},r.prototype.toggleCheckBase=function(e,i){if(this.showCheckBox){var s=e;if(e instanceof Object&&e.constructor!==HTMLLIElement&&(s=this.getLiFromObjOrElement(e)),!t.isNullOrUndefined(s)){var n=s.querySelector("."+d.checkboxIcon);!0===i?s.classList.add(d.selected):s.classList.remove(d.selected),s.setAttribute("aria-selected",i?"true":"false"),!0===i?n.classList.add(d.checked):n.classList.remove(d.checked),n.parentElement.setAttribute("aria-checked",i?"true":"false")}this.setSelectedItemData(s)}},r.prototype.uncheckItem=function(e){this.toggleCheckBase(e,!1)},r.prototype.checkAllItems=function(){this.toggleAllCheckBase(!0)},r.prototype.uncheckAllItems=function(){this.toggleAllCheckBase(!1)},r.prototype.toggleAllCheckBase=function(e){if(this.showCheckBox){for(var t=0;t<this.liCollection.length;t++){var i=this.liCollection[t].querySelector("."+d.checkboxIcon);i&&(e?i.classList.contains(d.checked)||this.checkItem(this.liCollection[t]):i.classList.contains(d.checked)&&this.uncheckItem(this.liCollection[t]))}this.enableVirtualization&&this.virtualizationModule.checkedItem(e)}},r.prototype.setCheckbox=function(){if(this.showCheckBox)for(var e=Array.prototype.slice.call(this.element.querySelectorAll("."+d.listItem)),t={item:void 0,curData:void 0,dataSource:void 0,fields:void 0,options:void 0,text:""},i=0;i<e.length;i++){var s=e[i];t.item=s,t.curData=this.getItemData(s),s.querySelector("."+d.checkboxWrapper)&&this.removeElement(s.querySelector("."+d.checkboxWrapper)),this.renderCheckbox(t),t.item.classList.contains(d.selected)&&this.checkInternally(t,t.item.querySelector("."+d.checkboxWrapper))}else{for(e=Array.prototype.slice.call(this.element.querySelectorAll("."+d.itemCheckList)),i=0;i<e.length;i++){(s=e[i]).classList.remove(d.selected),s.firstElementChild.classList.remove(d.checkbox),this.removeElement(s.querySelector("."+d.checkboxWrapper))}this.selectedItems&&this.selectedItems.item.classList.add(d.selected)}},r.prototype.refreshItemHeight=function(){this.virtualizationModule&&this.virtualizationModule.refreshItemHeight()},r.prototype.clickHandler=function(e){var i,s=e.target,n=s.classList;if(n.contains(d.backIcon)||n.contains(d.headerText))this.showCheckBox&&this.curDSLevel[this.curDSLevel.length-1]&&this.uncheckAllItems(),this.back();else{var l=t.closest(s.parentNode,"."+d.listItem);if(null===l&&(l=s),this.removeFocus(),this.enable&&this.showCheckBox&&this.isValidLI(l))if(e.target.classList.contains(d.checkboxIcon)){if(l.classList.add(d.focused),t.isNullOrUndefined(l.querySelector("."+d.checked))){var r={curData:void 0,dataSource:void 0,fields:void 0,options:void 0,text:void 0,item:l};this.checkInternally(r,r.item.querySelector("."+d.checkboxWrapper))}else this.uncheckItem(l),l.classList.add(d.focused);if(this.enableVirtualization&&this.virtualizationModule.setCheckboxLI(l,e),e){var a=this.selectEventData(l,e),o=l.querySelector("."+d.checkboxIcon);t.merge(a,{isChecked:o.classList.contains(d.checked)}),this.trigger("select",a)}}else l.classList.contains(d.hasChild)?(this.removeHover(),this.removeSelect(),this.removeSelect(l),this.setSelectLI(l,e),l.classList.remove(d.selected)):this.setCheckboxLI(l,e);else this.setSelectLI(l,e);i=t.closest(e.target,"li"),t.isNullOrUndefined(i)||i.classList.contains("e-has-child")&&!e.target.parentElement.classList.contains("e-listview-checkbox")&&i.classList.add(d.disable)}},r.prototype.removeElement=function(e){return e&&e.parentNode&&e.parentNode.removeChild(e)},r.prototype.hoverHandler=function(e){var i=t.closest(e.target.parentNode,"."+d.listItem);this.setHoverLI(i)},r.prototype.leaveHandler=function(e){this.removeHover()},r.prototype.homeKeyHandler=function(e,t){if(Object.keys(this.dataSource).length&&this.curUL){this.selectedItems&&this.selectedItems.item.setAttribute("aria-selected","false");var i=this.curUL.querySelectorAll("."+d.listItem),s=this.curUL.querySelector("."+d.focused)||this.curUL.querySelector("."+d.selected);s&&(s.classList.remove(d.focused),this.showCheckBox||s.classList.remove(d.selected));var n=t?i.length-1:0;i[n].classList.contains(d.hasChild)||this.showCheckBox?i[n].classList.add(d.focused):this.setSelectLI(i[n],e),i[n]?this.element.setAttribute("aria-activedescendant",i[n].id.toString()):this.element.removeAttribute("aria-activedescendant")}},r.prototype.onArrowKeyDown=function(i,s){var n,l;return!t.isNullOrUndefined(this.curUL.querySelector("."+d.hasChild))||this.showCheckBox?(l=this.curUL.querySelector("."+d.focused)||this.curUL.querySelector("."+d.selected),n=e.ListBase.getSiblingLI(this.curUL.querySelectorAll("."+d.listItem),l,s),t.isNullOrUndefined(n)||(l&&(l.classList.remove(d.focused),this.showCheckBox||l.classList.remove(d.selected)),n.classList.contains(d.hasChild)||this.showCheckBox?n.classList.add(d.focused):this.setSelectLI(n,i))):(l=this.curUL.querySelector("."+d.selected),n=e.ListBase.getSiblingLI(this.curUL.querySelectorAll("."+d.listItem),l,s),this.setSelectLI(n,i)),n?this.element.setAttribute("aria-activedescendant",n.id.toString()):this.element.removeAttribute("aria-activedescendant"),n},r.prototype.arrowKeyHandler=function(e,t){var i=this;if(e.preventDefault(),Object.keys(this.dataSource).length&&this.curUL){var s=this.onArrowKeyDown(e,t),n=this.element.getBoundingClientRect().top,l=this.element.getBoundingClientRect().height,r=this.curUL.querySelector("."+d.listItem).getBoundingClientRect(),a=void 0,o=void 0;if(this.fields.groupBy&&(o=this.curUL.querySelector("."+d.groupListItem).getBoundingClientRect()),s){var c=s.getBoundingClientRect().top,h=s.getBoundingClientRect().height;if(t)(a=this.isWindow?c:c-n)<0&&(!0===this.isWindow?window.scroll(0,pageYOffset+a):this.element.scrollTop=this.element.scrollTop+a);else{var u=this.isWindow?window.innerHeight:l;(a=this.isWindow?c+h:c-n+h)>u&&(!0===this.isWindow?window.scroll(0,pageYOffset+(a-u)):this.element.scrollTop=this.element.scrollTop+(a-u))}}else if(this.enableVirtualization&&t&&this.virtualizationModule.uiFirstIndex)this.onUIScrolled=function(){i.onArrowKeyDown(e,t),i.onUIScrolled=void 0},a=this.virtualizationModule.listItemHeight,!0===this.isWindow?window.scroll(0,pageYOffset-a):this.element.scrollTop=this.element.scrollTop-a;else if(t)if(this.showHeader&&this.headerEle){var p=o?o.top:r.top,m=this.headerEle.getBoundingClientRect();a=m.top<0?m.height-p:0,!0===this.isWindow?window.scroll(0,pageYOffset-a):this.element.scrollTop=0}else this.fields.groupBy&&(a=this.isWindow?o.top<0?o.top:0:n-r.top+o.height,!0===this.isWindow?window.scroll(0,pageYOffset+a):this.element.scrollTop=this.element.scrollTop-a)}},r.prototype.enterKeyHandler=function(e){if(Object.keys(this.dataSource).length&&this.curUL){var i=!t.isNullOrUndefined(this.curUL.querySelector("."+d.hasChild)),s=this.curUL.querySelector("."+d.focused);i&&s&&(s.classList.remove(d.focused),this.showCheckBox&&(this.removeSelect(),this.removeSelect(s),this.removeHover()),this.setSelectLI(s,e))}},r.prototype.spaceKeyHandler=function(e){if(this.enable&&this.showCheckBox&&Object.keys(this.dataSource).length&&this.curUL){var i=this.curUL.querySelector("."+d.focused),s=void 0,n=void 0;if(!t.isNullOrUndefined(i)&&t.isNullOrUndefined(i.querySelector("."+d.checked))){var l={curData:void 0,dataSource:void 0,fields:void 0,options:void 0,text:void 0,item:i};s=l.item.querySelector("."+d.checkboxWrapper),this.checkInternally(l,s),n=s.querySelector("."+d.checkboxIcon+"."+d.icon)}else this.uncheckItem(i);var r=this.selectEventData(i,e);t.merge(r,{isChecked:!!n&&n.classList.contains(d.checked)}),this.trigger("select",r)}},r.prototype.keyActionHandler=function(e){switch(e.keyCode){case 36:this.homeKeyHandler(e);break;case 35:this.homeKeyHandler(e,!0);break;case 40:this.arrowKeyHandler(e);break;case 38:this.arrowKeyHandler(e,!0);break;case 13:this.enterKeyHandler(e);break;case 8:this.showCheckBox&&this.curDSLevel[this.curDSLevel.length-1]&&this.uncheckAllItems(),this.back();break;case 32:this.spaceKeyHandler(e)}},r.prototype.swipeActionHandler=function(e){"Right"===e.swipeDirection&&e.velocity>.5&&"touchend"===e.originalEvent.type&&(this.showCheckBox&&this.curDSLevel[this.curDSLevel.length-1]&&this.uncheckAllItems(),this.back())},r.prototype.focusout=function(){if(Object.keys(this.dataSource).length&&this.curUL){var e=this.curUL.querySelector("."+d.focused),t=this.curUL.querySelector("[aria-selected = true]");e&&(e.classList.remove(d.focused),t&&!this.showCheckBox&&t.classList.add(d.selected))}},r.prototype.wireEvents=function(){t.EventHandler.add(this.element,"keydown",this.keyActionHandler,this),t.EventHandler.add(this.element,"click",this.clickHandler,this),t.EventHandler.add(this.element,"mouseover",this.hoverHandler,this),t.EventHandler.add(this.element,"mouseout",this.leaveHandler,this),t.EventHandler.add(this.element,"focusout",this.focusout,this),this.touchModule=new t.Touch(this.element,{swipe:this.swipeActionHandler.bind(this)})},r.prototype.unWireEvents=function(){t.EventHandler.remove(this.element,"click",this.clickHandler),t.EventHandler.remove(this.element,"mouseover",this.hoverHandler),t.EventHandler.remove(this.element,"mouseout",this.leaveHandler),t.EventHandler.remove(this.element,"mouseover",this.hoverHandler),t.EventHandler.remove(this.element,"mouseout",this.leaveHandler),this.touchModule.destroy()},r.prototype.removeFocus=function(){for(var e=0,t=this.element.querySelectorAll("."+d.focused);e<t.length;e++){t[e].classList.remove(d.focused)}},r.prototype.removeHover=function(){var e=this.element.querySelector("."+d.hover);e&&e.classList.remove(d.hover)},r.prototype.removeSelect=function(e){if(t.isNullOrUndefined(e))for(var i=0,s=this.element.querySelectorAll("."+d.selected);i<s.length;i++){var n=s[i];this.showCheckBox&&n.querySelector("."+d.checked)||(n.setAttribute("aria-selected","false"),n.classList.remove(d.selected))}else e.classList.remove(d.selected),e.setAttribute("aria-selected","false")},r.prototype.isValidLI=function(e){return e&&e.classList.contains(d.listItem)&&!e.classList.contains(d.groupListItem)&&!e.classList.contains(d.disable)},r.prototype.setCheckboxLI=function(e,i){if(this.isValidLI(e)&&this.enable&&this.showCheckBox){this.curUL.querySelector("."+d.focused)&&this.curUL.querySelector("."+d.focused).classList.remove(d.focused),e.classList.add(d.focused);var s=e.querySelector("."+d.checkboxWrapper),n=s.querySelector("."+d.checkboxIcon+"."+d.icon);this.removeHover(),n.classList.contains(d.checked)?(n.classList.remove(d.checked),e.classList.remove(d.selected),e.setAttribute("aria-selected","false")):(n.classList.add(d.checked),e.classList.add(d.selected),e.setAttribute("aria-selected","true")),s.setAttribute("aria-checked",n.classList.contains(d.checked)?"true":"false");var l=this.selectEventData(e,i);t.merge(l,{isChecked:n.classList.contains(d.checked)}),this.enableVirtualization&&this.virtualizationModule.setCheckboxLI(e,i),this.trigger("select",l),this.setSelectedItemData(e),this.renderSubList(e)}},r.prototype.selectEventData=function(e,i){var s,l=this.getItemData(e),r=n(l,this.listBaseOption.fields);s=!t.isNullOrUndefined(l)&&"string"==typeof this.dataSource[0]||"number"==typeof this.dataSource[0]?{item:e,text:e&&e.innerText.trim(),data:this.dataSource}:{item:e,text:r&&r[this.listBaseOption.fields.text],data:l};var a={};return t.merge(a,s),i&&t.merge(a,{isInteracted:!0,event:i,index:this.curUL&&Array.prototype.indexOf.call(this.curUL.children,e)}),a},r.prototype.setSelectedItemData=function(e){var i=this.getItemData(e),s=n(i,this.listBaseOption.fields);t.isNullOrUndefined(i)||"string"!=typeof this.dataSource[0]&&"number"!=typeof this.dataSource[0]?this.selectedItems={item:e,text:s&&s[this.listBaseOption.fields.text],data:i}:this.selectedItems={item:e,text:e&&e.innerText.trim(),data:this.dataSource}},r.prototype.setSelectLI=function(e,t){if(this.isValidLI(e)&&!e.classList.contains(d.selected)&&this.enable){this.showCheckBox||this.removeSelect(),e.classList.add(d.selected),e.setAttribute("aria-selected","true"),this.removeHover(),this.setSelectedItemData(e),this.enableVirtualization&&this.virtualizationModule.setSelectLI(e,t);var i=this.selectEventData(e,t);this.trigger("select",i),this.selectedLI=e,this.renderSubList(e)}},r.prototype.setHoverLI=function(e){if(this.isValidLI(e)&&!e.classList.contains(d.hover)&&this.enable){var i=this.element.querySelectorAll("."+d.hover);i&&i.length&&t.removeClass(i,d.hover),e.classList.contains(d.selected)&&!this.showCheckBox||e.classList.add(d.hover)}},r.prototype.getSubDS=function(){var e=this.curDSLevel;if(e.length){for(var t=this.localData,i=0,s=e;i<s.length;i++){var l=s[i],r={};r[this.fields.id]=l,this.curDSJSON=this.findItemFromDS(t,r);var a=n(this.curDSJSON,this.listBaseOption.fields);t=this.curDSJSON?a[this.fields.child]:t}return t}return this.localData},r.prototype.getItemData=function(e){var s,n=this.dataSource instanceof i.DataManager?this.localData:this.dataSource,l=this.getElementUID(e);return s=t.isNullOrUndefined(this.element.querySelector("."+d.hasChild))&&this.fields.groupBy?this.curViewDS:n,this.findItemFromDS(s,l)},r.prototype.findItemFromDS=function(e,i,s){var l,r=this;return e&&e.length&&i?e.some(function(a){var o=n(a,r.listBaseOption.fields);if(!i[r.fields.id]&&!i[r.fields.text]||i[r.fields.id]&&(!t.isNullOrUndefined(o[r.fields.id])&&o[r.fields.id].toString())!==i[r.fields.id].toString()||i[r.fields.text]&&o[r.fields.text]!==i[r.fields.text])if("object"!=typeof a&&-1!==e.indexOf(a))l=s?e:a;else if(!t.isNullOrUndefined(i[r.fields.id])&&t.isNullOrUndefined(o[r.fields.id])){var c=r.element.querySelector('[data-uid="'+i[r.fields.id]+'"]');c&&c.innerText.trim()===o[r.fields.text]&&(l=a)}else o.hasOwnProperty(r.fields.child)&&o[r.fields.child].length&&(l=r.findItemFromDS(o[r.fields.child],i,s));else l=s?e:a;return!!l}):l=e,l},r.prototype.getQuery=function(){var t=[],s=this.query?this.query:new i.Query;if(!this.query){for(var n=0,l=Object.keys(this.fields.properties);n<l.length;n++){var r=l[n];"tableName"!==r&&this.fields[r]&&this.fields[r]!==e.ListBase.defaultMappedFields[r]&&-1===t.indexOf(this.fields[r])&&t.push(this.fields[r])}s.select(t),this.fields.properties.hasOwnProperty("tableName")&&s.from(this.fields.tableName)}return s},r.prototype.setViewDataSource=function(i){void 0===i&&(i=this.localData),i&&this.fields.groupBy?"None"!==this.sortOrder?this.curViewDS=e.ListBase.groupDataSource(e.ListBase.getDataSource(i,e.ListBase.addSorting(this.sortOrder,t.isNullOrUndefined(this.fields.sortBy)?this.fields.text:this.fields.sortBy)),this.listBaseOption.fields,this.sortOrder):this.curViewDS=e.ListBase.groupDataSource(i,this.listBaseOption.fields,this.sortOrder):i&&"None"!==this.sortOrder?this.curViewDS=e.ListBase.getDataSource(i,e.ListBase.addSorting(this.sortOrder,t.isNullOrUndefined(this.fields.sortBy)?this.fields.text:this.fields.sortBy)):this.curViewDS=i},r.prototype.isInAnimation=function(){return this.curUL.classList.contains(".e-animate")},r.prototype.renderRemoteLists=function(e,t){this.isDestroyed||(this.localData=e.result,t.removeElement(t.contentContainer),this.renderList(),this.trigger("actionComplete",e))},r.prototype.triggerActionFailure=function(e){this.isDestroyed||this.trigger("actionFailure",e)},r.prototype.setLocalData=function(){var s=this;this.trigger("actionBegin");var n=this;if(this.dataSource instanceof i.DataManager)this.dataSource.ready?this.dataSource.ready.then(function(e){s.isOffline=s.dataSource.dataSource.offline,s.dataSource instanceof i.DataManager&&s.isOffline&&s.renderRemoteLists(e,n)}).catch(function(e){s.triggerActionFailure(e)}):this.dataSource.executeQuery(this.getQuery()).then(function(e){s.renderRemoteLists(e,n)}).catch(function(e){s.triggerActionFailure(e)});else if(this.dataSource&&this.dataSource.length)this.localData=this.dataSource,this.renderList(),this.trigger("actionComplete",{data:this.localData});else{var l=this.element.querySelector("ul");l&&(t.remove(l),this.setProperties({dataSource:e.ListBase.createJsonFromElement(l)},!0),this.localData=this.dataSource,this.renderList(),this.trigger("actionComplete",{data:this.localData}))}},r.prototype.reRender=function(){this.removeElement(this.headerEle),this.removeElement(this.ulElement),this.removeElement(this.contentContainer),this.isReact&&this.clearTemplate(),-1===Object.keys(window).indexOf("ejsInterop")&&(this.element.innerHTML=""),this.headerEle=this.ulElement=this.liCollection=void 0,this.header(),this.setLocalData()},r.prototype.resetCurrentList=function(){this.setViewDataSource(this.curViewDS),this.contentContainer.innerHTML="",this.createList(),this.renderIntoDom(this.curUL)},r.prototype.setAttributes=function(e){for(var t=0;t<e.length;t++){var i=e[t];i.classList.contains("e-list-item")&&(i.setAttribute("id",this.element.id+"_"+i.getAttribute("data-uid")),i.setAttribute("aria-selected","false"),i.setAttribute("tabindex","-1"))}},r.prototype.createList=function(){this.currentLiElements=[],this.isNestedList=!1,this.ulElement=this.curUL=e.ListBase.createList(this.createElement,this.curViewDS,this.listBaseOption,null,this),this.liCollection=this.curUL.querySelectorAll("."+d.listItem),this.setAttributes(this.liCollection)},r.prototype.exceptionEvent=function(e){this.trigger("actionFailure",e)},r.prototype.UpdateCurrentUL=function(){this.ulElement=this.curUL=this.element.querySelector("."+d.parentItem),this.curUL&&(this.liCollection=this.curUL.querySelectorAll("."+d.listItem))},r.prototype.renderSubList=function(i){this.liElement=i;var s=i.getAttribute("data-uid");if(i.classList.contains(d.hasChild)&&s){var l=t.closest(i.parentNode,"."+d.parentItem),r=this.element.querySelector("[pid='"+s+"']");if(this.curDSLevel.push(s),this.setViewDataSource(this.getSubDS()),!r){var a=this.curViewDS;r=e.ListBase.createListFromJson(this.createElement,a,this.listBaseOption,this.curDSLevel.length,null,this),this.isReact&&this.renderReactTemplates();var o=r.querySelectorAll("."+d.listItem);this.setAttributes(o),r.setAttribute("pID",s),r.style.display="none",this.renderIntoDom(r)}if(this.switchView(l,r),this.liCollection=this.curUL.querySelectorAll("."+d.listItem),this.selectedItems){var c=n(this.selectedItems.data,this.listBaseOption.fields);this.header(c[this.listBaseOption.fields.text],!0,"header")}this.selectedLI=void 0}},r.prototype.renderIntoDom=function(e){this.contentContainer.appendChild(e)},r.prototype.renderList=function(e){this.setViewDataSource(e),this.enableVirtualization?(Object.keys(this.dataSource).length&&(!this.template&&!this.groupTemplate||this.virtualizationModule.isNgTemplate()||(this.isReact?("string"==typeof this.template&&(this.listBaseOption.template=null),"string"==typeof this.groupTemplate&&(this.listBaseOption.groupTemplate=null)):(this.listBaseOption.template=null,this.listBaseOption.groupTemplate=null),this.listBaseOption.itemCreated=this.virtualizationModule.createUIItem.bind(this.virtualizationModule))),this.virtualizationModule.uiVirtualization()):(this.createList(),this.contentContainer=this.createElement("div",{className:d.content}),this.element.appendChild(this.contentContainer),this.renderIntoDom(this.ulElement),this.isReact&&this.renderReactTemplates())},r.prototype.getElementUID=function(e){var t={};return e instanceof Element?t[this.fields.id]=e.getAttribute("data-uid"):t=e,t},r.prototype.render=function(){this.element.classList.add(d.root),t.attributes(this.element,{role:"list",tabindex:"0"}),this.setCSSClass(),this.setEnableRTL(),this.setEnable(),this.setSize(),this.wireEvents(),this.header(),this.setLocalData(),this.setHTMLAttribute(),this.rippleFn=t.rippleEffect(this.element,{selector:"."+d.listItem}),this.renderComplete()},r.prototype.destroy=function(){this.isReact&&this.clearTemplate(),this.unWireEvents();var e=[d.root,d.disable,"e-rtl","e-has-header","e-lib"].concat(this.cssClass.split(" ").filter(function(e){return e}));t.removeClass([this.element],e),this.element.removeAttribute("role"),this.element.removeAttribute("tabindex"),this.curUL=this.ulElement=this.liCollection=this.headerEle=void 0,this.element.innerHTML="",l.prototype.destroy.call(this)},r.prototype.back=function(){var e=this.curDSLevel[this.curDSLevel.length-1];if(void 0!==e&&!this.isInAnimation()){this.curDSLevel.pop(),this.setViewDataSource(this.getSubDS());var i=this.element.querySelector("[data-uid='"+e+"']"),s=this.curUL;i?i=i.parentElement:(this.createList(),this.renderIntoDom(this.ulElement),i=this.curUL);var l=n(this.curDSJSON,this.listBaseOption.fields)[this.fields.text];this.switchView(s,i,!0),this.removeFocus();var r=this.element.querySelector("[data-uid='"+e+"']");r.classList.remove(d.disable),r.classList.add(d.focused),this.showCheckBox&&r.querySelector("."+d.checkboxIcon).classList.contains(d.checked)?r.setAttribute("aria-selected","true"):(r.classList.remove(d.selected),r.setAttribute("aria-selected","false")),this.liCollection=this.curUL.querySelectorAll("."+d.listItem),this.enableHtmlSanitizer&&this.setProperties({headerTitle:t.SanitizeHtmlHelper.sanitize(this.headerTitle)},!0),this.header(this.curDSLevel.length?l:this.headerTitle,!!this.curDSLevel.length,"header")}},r.prototype.selectItem=function(e){this.enableVirtualization?this.virtualizationModule.selectItem(e):this.showCheckBox?this.setCheckboxLI(this.getLiFromObjOrElement(e)):!0===t.isNullOrUndefined(e)?this.removeSelect():this.setSelectLI(this.getLiFromObjOrElement(e))},r.prototype.getLiFromObjOrElement=function(e){var s,l=this.dataSource instanceof i.DataManager?this.localData:this.dataSource;if(!t.isNullOrUndefined(e))if("string"==typeof l[0]||"number"==typeof l[0])if(e instanceof Element){for(var r=e.getAttribute("data-uid").toString(),a=0;a<this.liCollection.length;a++)if(this.liCollection[a].getAttribute("data-uid").toString()===r){s=this.liCollection[a];break}}else Array.prototype.some.call(this.curUL.querySelectorAll("."+d.listItem),function(t){return t.innerText.trim()===e.toString()&&(s=t,!0)});else{var o=this.getItemData(e),c=n(o,this.listBaseOption.fields);if(o&&(s=this.element.querySelector('[data-uid="'+c[this.fields.id]+'"]'),!this.enableVirtualization&&t.isNullOrUndefined(s))){var h=this.element.querySelectorAll("."+d.listItem);for(a=0;a<h.length;a++)h[a].innerText.trim()===c[this.fields.text]&&(s=h[a])}}return s},r.prototype.selectMultipleItems=function(e){if(!t.isNullOrUndefined(e))for(var i=0;i<e.length;i++)t.isNullOrUndefined(e[i])||this.selectItem(e[i])},r.prototype.getParentId=function(){var e=[];if(this.isNestedList)for(var t=this.curDSLevel.length-1;t>=0;t--)e.push(this.curDSLevel[t]);return e},r.prototype.getSelectedItems=function(){var e,s=!1;this.selectedId=[];var l=this.dataSource instanceof i.DataManager?this.localData:this.dataSource;if(this.enableVirtualization&&!s)e=this.virtualizationModule.getSelectedItems(),s=!0;else if(this.showCheckBox&&!s){var r=this.curUL.getElementsByClassName(d.selected),a=[],o=[];this.selectedId=[];for(var c=[],h=0;h<r.length;h++)if("string"==typeof l[0]||"number"==typeof l[0])a.push(r[h].innerText.trim());else{var u=this.getItemData(r[h]),p=n(u,this.listBaseOption.fields);this.isNestedList?c.push({data:u,parentId:this.getParentId()}):o.push(u),p?(a.push(p[this.listBaseOption.fields.text]),this.selectedId.push(p[this.listBaseOption.fields.id])):(a.push(void 0),this.selectedId.push(void 0))}"string"!=typeof l[0]&&"number"!=typeof l[0]||s||(e={item:r,data:l,text:a},s=!0),this.isNestedList&&!s?(e={item:r,data:c,text:a},s=!0):s||(e={item:r,data:o,text:a},s=!0)}else if(!s){var m=this.element.getElementsByClassName(d.selected)[0];p=n(this.getItemData(m),this.listBaseOption.fields);"string"!=typeof l[0]&&"number"!=typeof l[0]||s?s||(t.isNullOrUndefined(p)||t.isNullOrUndefined(m)?(e=void 0,s=!0):(this.selectedId.push(p[this.listBaseOption.fields.id]),e={text:p[this.listBaseOption.fields.text],item:m,data:this.getItemData(m)},s=!0)):(e=t.isNullOrUndefined(m)?void 0:{item:m,data:l,text:m.innerText.trim()},s=!0)}return e},r.prototype.findItem=function(e){return this.getItemData(e)},r.prototype.enableItem=function(e){this.setItemState(e,!0),this.enableVirtualization&&this.virtualizationModule.enableItem(e)},r.prototype.disableItem=function(e){this.setItemState(e,!1),this.enableVirtualization&&this.virtualizationModule.disableItem(e)},r.prototype.setItemState=function(e,t){var i=this.getItemData(e),s=n(i,this.listBaseOption.fields);if(i){var l=this.element.querySelector('[data-uid="'+s[this.fields.id]+'"]');t?(l&&l.classList.remove(d.disable),delete i[this.fields.enabled]):t||(l&&l.classList.add(d.disable),i[this.fields.enabled]=!1)}},r.prototype.showItem=function(e){this.showHideItem(e,!1,""),this.enableVirtualization&&this.virtualizationModule.showItem(e)},r.prototype.hideItem=function(e){this.showHideItem(e,!0,"none"),this.enableVirtualization&&this.virtualizationModule.hideItem(e)},r.prototype.showHideItem=function(e,t,i){var s=this.getItemData(e),l=n(s,this.listBaseOption.fields);if(s){var r=this.element.querySelector('[data-uid="'+l[this.fields.id]+'"]');r&&(r.style.display=i),t?s[this.fields.isVisible]=!1:delete s[this.fields.isVisible]}},r.prototype.addItem=function(e,t){void 0===t&&(t=void 0);var s=this.dataSource instanceof i.DataManager?this.localData:this.dataSource;this.addItemInternally(e,t,s)},r.prototype.addItemInternally=function(e,t,i){if(e instanceof Array)if(this.enableVirtualization)this.virtualizationModule.addItem(e,t,i);else{var s=this.findItemFromDS(i,t),l=void 0;if(s){(l=n(s,this.listBaseOption.fields)[this.fields.child])||(l=[]),l=l.concat(e)}if(s instanceof Array){for(var r=0;r<e.length;r++){i.push(e[r]),this.setViewDataSource(i);var a=this.contentContainer?this.contentContainer.children[0]:null;this.contentContainer&&a?this.addItemIntoDom(e[r],a,this.curViewDS):this.reRender()}this.liCollection=this.curUL.querySelectorAll("."+d.listItem)}else s&&(s[this.fields.child]=l,this.addItemInNestedList(s,e))}},r.prototype.addItemInNestedList=function(i,s){var n=i[this.fields.id],l=i[this.fields.child],r=this.element.querySelector("[pid='"+n+"']"),a=this.element.querySelector("[data-uid='"+n+"']"),o=r||(a?t.closest(a,"ul"):null),c=r?l:[i];if(!!a&&!a.classList.contains(d.hasChild)){var h=e.ListBase.createListItemFromJson(this.createElement,c,this.listBaseOption,null,null,this);this.setAttributes(h),o.insertBefore(h[0],a),t.detach(a)}if(r&&s)for(var u=0;u<s.length;u++)c.push(s[u]),this.addItemIntoDom(s[u],o,c)},r.prototype.addItemIntoDom=function(e,t,i){var s=i.indexOf(e);this.addListItem(e,s,t,i);var n=i[s-1];n&&n.isHeader&&1===n.items.length&&this.addListItem(n,s-1,t,i)},r.prototype.addListItem=function(t,i,s,n){var l=this.getLiFromObjOrElement(n[i+1])||this.getLiFromObjOrElement(n[i+2])||null,r=e.ListBase.createListItemFromJson(this.createElement,[t],this.listBaseOption,null,null,this);if(this.setAttributes(r),this.template&&this.isReact&&this.renderReactTemplates(),this.fields.groupBy&&n[i+1]&&n[i+1].isHeader){var a=this.getLiFromObjOrElement(n[i-1]);a&&(l=a.nextElementSibling)}s.insertBefore(r[0],l)},r.prototype.removeItem=function(e){var t=this.dataSource instanceof i.DataManager?this.localData:this.dataSource;this.enableVirtualization?this.virtualizationModule.removeItem(e):this.removeItemFromList(e,t)},r.prototype.removeItemFromList=function(i,s){var n,l=this,r=this.curViewDS,a=i instanceof Element?this.getElementUID(i):i;if(n=this.findItemFromDS(s,a,!0)){var o;o=this.findItemFromDS(n,a);var c=r.indexOf(o),h=this.getLiFromObjOrElement(i),u=void 0;this.validateNestedView(h),this.fields.groupBy&&this.curViewDS[c-1]&&r[c-1].isHeader&&1===r[c-1].items.length&&h&&h.previousElementSibling.classList.contains(d.groupListItem)&&(t.isNullOrUndefined(h.nextElementSibling)||h.nextElementSibling&&h.nextElementSibling.classList.contains(d.groupListItem))&&(u=h.previousElementSibling),h&&t.detach(h),u&&t.detach(u);var p=n.length-1<=0?this.findParent(this.localData,this.fields.id,function(e){return e===o[l.fields.id]},null):null,m=n.indexOf(o);if(n.splice(m,1),this.setViewDataSource(s),p&&p.parent&&Array.isArray(p.parent[this.fields.child])&&p.parent[this.fields.child].length<=0){var f=this.getLiFromObjOrElement(p.parent);if(f){var g=e.ListBase.createListItemFromJson(this.createElement,[p.parent],this.listBaseOption,null,null,this);this.setAttributes(g),f.parentElement.insertBefore(g[0],f),f.parentElement.removeChild(f)}}n.length<=0&&this.back(),this.liCollection=Array.prototype.slice.call(this.element.querySelectorAll("."+d.listItem))}},r.prototype.validateNestedView=function(e){var t=e?e.getAttribute("data-uid").toString().toLowerCase():null;if(t&&this.curDSLevel&&this.curDSLevel.length>0)for(;this.curDSLevel.some(function(e){return e.toString().toLowerCase()===t});)this.back()},r.prototype.removeMultipleItems=function(e){if(e.length)for(var t=0;t<e.length;t++)this.removeItem(e[t])},r.prototype.findParent=function(e,i,s,n){if(e.hasOwnProperty(i)&&!0===s(e[i]))return t.extend({},e);for(var l=0;l<Object.keys(e).length;l++)if(e[Object.keys(e)[l]]&&"object"==typeof e[Object.keys(e)[l]]){var r=this.findParent(e[Object.keys(e)[l]],i,s,e);if(null!=r)return r.parent||(r.parent=n),r}return null},r.prototype.getModuleName=function(){return"listview"},r.prototype.requiredModules=function(){var e=[];return this.enableVirtualization&&e.push({args:[this],member:"virtualization"}),e},r.prototype.getPersistData=function(){return this.addOnPersist(["cssClass","enableRtl","htmlAttributes","enable","fields","animation","headerTitle","sortOrder","showIcon","height","width","showCheckBox","checkBoxPosition"])},o([t.Property("")],r.prototype,"cssClass",void 0),o([t.Property(!1)],r.prototype,"enableVirtualization",void 0),o([t.Property({})],r.prototype,"htmlAttributes",void 0),o([t.Property(!0)],r.prototype,"enable",void 0),o([t.Property([])],r.prototype,"dataSource",void 0),o([t.Property()],r.prototype,"query",void 0),o([t.Complex(e.ListBase.defaultMappedFields,p)],r.prototype,"fields",void 0),o([t.Property({effect:"SlideLeft",duration:400,easing:"ease"})],r.prototype,"animation",void 0),o([t.Property("None")],r.prototype,"sortOrder",void 0),o([t.Property(!1)],r.prototype,"showIcon",void 0),o([t.Property(!1)],r.prototype,"showCheckBox",void 0),o([t.Property("Left")],r.prototype,"checkBoxPosition",void 0),o([t.Property("")],r.prototype,"headerTitle",void 0),o([t.Property(!1)],r.prototype,"showHeader",void 0),o([t.Property(!1)],r.prototype,"enableHtmlSanitizer",void 0),o([t.Property("")],r.prototype,"height",void 0),o([t.Property("")],r.prototype,"width",void 0),o([t.Property(null)],r.prototype,"template",void 0),o([t.Property(null)],r.prototype,"headerTemplate",void 0),o([t.Property(null)],r.prototype,"groupTemplate",void 0),o([t.Event()],r.prototype,"select",void 0),o([t.Event()],r.prototype,"actionBegin",void 0),o([t.Event()],r.prototype,"actionComplete",void 0),o([t.Event()],r.prototype,"actionFailure",void 0),r=o([t.NotifyPropertyChanges],r)}(t.Component),f=function(){function s(e){this.elementDifference=0,this.listViewInstance=e}return s.prototype.isNgTemplate=function(){return!t.isNullOrUndefined(this.listViewInstance.templateRef)&&"string"!=typeof this.listViewInstance.templateRef},s.prototype.uiVirtualization=function(){this.wireScrollEvent(!1);var i=this.listViewInstance.curViewDS,s=i.slice(0,1);this.listViewInstance.ulElement=this.listViewInstance.curUL=e.ListBase.createList(this.listViewInstance.createElement,s,this.listViewInstance.listBaseOption,null,this.listViewInstance),this.listViewInstance.contentContainer=this.listViewInstance.createElement("div",{className:d.content}),this.listViewInstance.element.appendChild(this.listViewInstance.contentContainer),this.listViewInstance.contentContainer.appendChild(this.listViewInstance.ulElement),this.listItemHeight=this.listViewInstance.ulElement.firstElementChild.getBoundingClientRect().height,this.expectedDomItemCount=this.ValidateItemCount(1e4),this.domItemCount=this.ValidateItemCount(Object.keys(this.listViewInstance.curViewDS).length),this.uiFirstIndex=0,this.uiLastIndex=this.domItemCount-1;var n=i.slice(1,this.domItemCount),l=e.ListBase.createListItemFromJson(this.listViewInstance.createElement,n,this.listViewInstance.listBaseOption,null,null,this.listViewInstance);t.append(l,this.listViewInstance.ulElement),this.listViewInstance.liCollection=this.listViewInstance.curUL.querySelectorAll("li"),this.topElement=this.listViewInstance.createElement("div"),this.listViewInstance.ulElement.insertBefore(this.topElement,this.listViewInstance.ulElement.firstElementChild),this.bottomElement=this.listViewInstance.createElement("div"),this.listViewInstance.ulElement.insertBefore(this.bottomElement,null),this.totalHeight=Object.keys(i).length*this.listItemHeight-this.domItemCount*this.listItemHeight,this.topElement.style.height="0px",this.bottomElement.style.height=this.totalHeight+"px",this.topElementHeight=0,this.bottomElementHeight=this.totalHeight,this.listDiff=0,this.uiIndicesInitialization()},s.prototype.wireScrollEvent=function(e){e?!0===this.listViewInstance.isWindow?(window.removeEventListener("scroll",this.onVirtualScroll),window.removeEventListener("scroll",this.updateUl)):(t.EventHandler.remove(this.listViewInstance.element,"scroll",this.onVirtualUiScroll),t.EventHandler.remove(this.listViewInstance.element,"scroll",this.updateUlContainer)):this.listViewInstance.isWindow?(this.onVirtualScroll=this.onVirtualUiScroll.bind(this),window.addEventListener("scroll",this.onVirtualScroll)):t.EventHandler.add(this.listViewInstance.element,"scroll",this.onVirtualUiScroll,this)},s.prototype.updateUlContainer=function(e){var i,s=this.listViewInstance.ulElement.querySelector("."+d.virtualElementContainer);t.isNullOrUndefined(this.listViewInstance.liElementHeight)&&this.listViewInstance.updateLiElementHeight(),((i=this.listViewInstance.isWindow?Math.round(e.target.documentElement.scrollTop/this.listViewInstance.liElementHeight)-2:Math.round(e.target.scrollTop/this.listViewInstance.liElementHeight)-2)-1)*this.listViewInstance.liElementHeight<0?s.style.top="0px":s.style.top=i*this.listViewInstance.liElementHeight+"px"},s.prototype.ValidateItemCount=function(e){var i,s=parseFloat(t.formatUnit(this.listViewInstance.height));return(i=this.listViewInstance.isWindow?Math.round(window.innerHeight/this.listItemHeight*3):"string"==typeof this.listViewInstance.height&&-1!==this.listViewInstance.height.indexOf("%")?Math.round(this.listViewInstance.element.getBoundingClientRect().height/this.listItemHeight*1.5):Math.round(s/this.listItemHeight*1.5))>e&&(i=e),i},s.prototype.uiIndicesInitialization=function(){this.uiIndices={activeIndices:[],disabledItemIndices:[],hiddenItemIndices:[]};for(var e=this.listViewInstance.curViewDS,i=0;i<e.length;i++)this.listViewInstance.showCheckBox&&e[i][this.listViewInstance.fields.isChecked]&&this.uiIndices.activeIndices.push(i),t.isNullOrUndefined(e[i][this.listViewInstance.fields.enabled])||e[i][this.listViewInstance.fields.enabled]||this.uiIndices.disabledItemIndices.push(i);if(this.isNgTemplate())for(var s=this.listViewInstance.element.querySelectorAll("."+d.listItem),n=0;n<s.length;n++)s[n].context=this.listViewInstance.viewContainerRef.get(n).context},s.prototype.refreshItemHeight=function(){if(this.listViewInstance.curViewDS.length){var e=this.listViewInstance.curViewDS;this.listItemHeight=this.topElement.nextSibling.getBoundingClientRect().height,this.totalHeight=Object.keys(e).length*this.listItemHeight-this.domItemCount*this.listItemHeight,this.bottomElementHeight=this.totalHeight,this.bottomElement.style.height=this.totalHeight+"px"}},s.prototype.getscrollerHeight=function(e){return this.listViewInstance.isWindow?pageYOffset-e<=0?0:pageYOffset-e:this.listViewInstance.element.scrollTop-e<=0?0:this.listViewInstance.element.scrollTop-e},s.prototype.onVirtualUiScroll=function(e){var i,s;s=this.listViewInstance.isWindow?this.listViewInstance.ulElement.getBoundingClientRect().top-document.documentElement.getBoundingClientRect().top:this.listViewInstance.headerEle?this.listViewInstance.headerEle.getBoundingClientRect().height:0,this.scrollPosition=t.isNullOrUndefined(this.scrollPosition)?0:this.scrollPosition;var n=this.getscrollerHeight(s);if(this.topElementHeight=this.listItemHeight*Math.floor(n/this.listItemHeight),this.bottomElementHeight=this.totalHeight-this.topElementHeight,i=n<=this.totalHeight?[this.topElementHeight,this.bottomElementHeight]:[this.totalHeight,0],this.topElementHeight=i[0],this.bottomElementHeight=i[1],this.topElementHeight!==parseFloat(this.topElement.style.height))if(this.topElement.style.height=this.topElementHeight+"px",this.bottomElement.style.height=this.bottomElementHeight+"px",n>this.scrollPosition){(l=Math.round(this.topElementHeight/this.listItemHeight-this.listDiff))>this.expectedDomItemCount+5?this.onLongScroll(l,!0):this.onNormalScroll(l,!0)}else{var l;(l=Math.round(this.listDiff-this.topElementHeight/this.listItemHeight))>this.expectedDomItemCount+5?this.onLongScroll(l,!1):this.onNormalScroll(l,!1)}this.listDiff=Math.round(this.topElementHeight/this.listItemHeight),"function"==typeof this.listViewInstance.onUIScrolled&&this.listViewInstance.onUIScrolled(),this.scrollPosition=n},s.prototype.onLongScroll=function(e,t){for(var i=t?this.uiFirstIndex+e:this.uiFirstIndex-e,s=this.listViewInstance.ulElement.querySelectorAll("li"),n=0;n<s.length;n++)this.updateUI(s[n],i),i++;this.uiLastIndex=t?this.uiLastIndex+e:this.uiLastIndex-e,this.uiFirstIndex=t?this.uiFirstIndex+e:this.uiFirstIndex-e},s.prototype.onNormalScroll=function(e,t){if(t)for(var i=0;i<e;i++){var s=++this.uiLastIndex;this.updateUI(this.topElement.nextElementSibling,s,this.bottomElement),this.uiFirstIndex++}else for(i=0;i<e;i++){s=--this.uiFirstIndex;var n=this.topElement.nextSibling;this.updateUI(this.bottomElement.previousElementSibling,s,n),this.uiLastIndex--}},s.prototype.updateUiContent=function(i,s){var n=this.listViewInstance.curViewDS;if("string"==typeof this.listViewInstance.dataSource[0]||"number"==typeof this.listViewInstance.dataSource[0]?(i.dataset.uid=e.ListBase.generateId(),i.getElementsByClassName(d.listItemText)[0].innerHTML=this.listViewInstance.curViewDS[s].toString()):(i.dataset.uid=n[s][this.listViewInstance.fields.id]?n[s][this.listViewInstance.fields.id]:e.ListBase.generateId(),i.getElementsByClassName(d.listItemText)[0].innerHTML=n[s][this.listViewInstance.fields.text]),this.listViewInstance.showIcon&&(i.querySelector("."+d.listIcon)&&t.detach(i.querySelector("."+d.listIcon)),this.listViewInstance.curViewDS[s][this.listViewInstance.fields.iconCss])){var l=i.querySelector("."+d.textContent),r=this.listViewInstance.createElement("div",{className:d.listIcon+" "+this.listViewInstance.curViewDS[s][this.listViewInstance.fields.iconCss]});l.insertBefore(r,i.querySelector("."+d.listItemText))}if(this.listViewInstance.showCheckBox&&this.listViewInstance.fields.groupBy){this.checkListWrapper||(this.checkListWrapper=this.listViewInstance.curUL.querySelector("."+d.checkboxWrapper).cloneNode(!0));l=i.querySelector("."+d.textContent);this.listViewInstance.curViewDS[s].isHeader?i.querySelector("."+d.checkboxWrapper)&&(i.classList.remove(d.checklist),l.classList.remove(d.checkbox),t.detach(i.querySelector("."+d.checkboxWrapper))):i.querySelector("."+d.checkboxWrapper)||(i.classList.add(d.checklist),l.classList.add(d.checkbox),l.insertBefore(this.checkListWrapper.cloneNode(!0),i.querySelector("."+d.listItemText)))}},s.prototype.changeElementAttributes=function(e,i){if(e.classList.remove(d.disable),this.uiIndices.disabledItemIndices.length&&-1!==this.uiIndices.disabledItemIndices.indexOf(i)&&e.classList.add(d.disable),e.style.display="",this.uiIndices.hiddenItemIndices.length&&-1!==this.uiIndices.hiddenItemIndices.indexOf(i)&&(e.style.display="none"),this.listViewInstance.showCheckBox){var s=e.querySelector("."+d.checkboxWrapper);e.classList.remove(d.selected),e.classList.remove(d.focused),s&&(s.removeAttribute("aria-checked"),s.firstElementChild.classList.remove(d.checked)),this.uiIndices.activeIndices.length&&-1!==this.uiIndices.activeIndices.indexOf(i)&&!this.listViewInstance.curUL.querySelector(d.selected)&&(e.classList.add(d.selected),s.firstElementChild.classList.add(d.checked),s.setAttribute("aria-checked","true"),this.activeIndex===i&&e.classList.add(d.focused))}else e.classList.remove(d.selected),e.removeAttribute("aria-selected"),t.isNullOrUndefined(this.activeIndex)||this.activeIndex!==i||this.listViewInstance.curUL.querySelector(d.selected)||(e.classList.add(d.selected),e.setAttribute("aria-selected","true"));this.listViewInstance.fields.groupBy&&(this.listViewInstance.curViewDS[i].isHeader?e.classList.contains(d.listItem)&&(e.classList.remove(d.listItem),e.setAttribute("role","group"),e.classList.add(d.groupListItem)):e.classList.contains(d.groupListItem)&&(e.classList.remove(d.groupListItem),e.setAttribute("role","listitem"),e.classList.add(d.listItem)))},s.prototype.findDSAndIndexFromId=function(e,i){var s=this,n={};return i=this.listViewInstance.getElementUID(i),t.isNullOrUndefined(i)||e.some(function(e,t){return!!(i[s.listViewInstance.fields.id]&&i[s.listViewInstance.fields.id]===(e[s.listViewInstance.fields.id]&&e[s.listViewInstance.fields.id])||i===e)&&(n.index=t,n.data=e,!0)}),n},s.prototype.getSelectedItems=function(){var e=this;if(!t.isNullOrUndefined(this.activeIndex)||this.listViewInstance.showCheckBox&&this.uiIndices.activeIndices.length){var s=[],n=[];if("string"==typeof this.listViewInstance.dataSource[0]||"number"==typeof this.listViewInstance.dataSource[0]){var l=this.listViewInstance.curViewDS;if(this.listViewInstance.showCheckBox){for(var r=this.uiIndices.activeIndices,a=0;a<r.length;a++)s.push(l[r[a]]);return{text:s,data:s,index:this.uiIndices.activeIndices.map(function(t){return e.listViewInstance.dataSource.indexOf(l[t])})}}return{text:l[this.activeIndex],data:l[this.activeIndex],index:this.listViewInstance.dataSource.indexOf(l[this.activeIndex])}}var o=this.listViewInstance.curViewDS,c=this.listViewInstance.fields.text;if(this.listViewInstance.showCheckBox){var h=this.uiIndices.activeIndices;for(a=0;a<h.length;a++)n.push(o[h[a]][c]),s.push(o[h[a]]);var d=this.listViewInstance.dataSource instanceof i.DataManager?o:this.listViewInstance.dataSource;return{text:n,data:s,index:this.uiIndices.activeIndices.map(function(e){return d.indexOf(o[e])})}}var u=this.listViewInstance.dataSource instanceof i.DataManager?o:this.listViewInstance.dataSource;return{text:o[this.activeIndex][this.listViewInstance.fields.text],data:o[this.activeIndex],index:u.indexOf(o[this.activeIndex])}}},s.prototype.selectItem=function(e){var i=this.findDSAndIndexFromId(this.listViewInstance.curViewDS,e);if(Object.keys(i).length){var s=this.activeIndex===i.index,n=void 0;if(this.activeIndex=i.index,this.listViewInstance.showCheckBox&&(-1===this.uiIndices.activeIndices.indexOf(i.index)?(n=!0,this.uiIndices.activeIndices.push(i.index)):(n=!1,this.uiIndices.activeIndices.splice(this.uiIndices.activeIndices.indexOf(i.index),1)),this.listViewInstance.curUL.querySelector("."+d.focused)&&this.listViewInstance.curUL.querySelector("."+d.focused).classList.remove(d.focused)),this.listViewInstance.getLiFromObjOrElement(e))this.listViewInstance.showCheckBox?this.listViewInstance.setCheckboxLI(this.listViewInstance.getLiFromObjOrElement(e)):this.listViewInstance.setSelectLI(this.listViewInstance.getLiFromObjOrElement(e));else{var l=void 0;if("string"==typeof this.listViewInstance.dataSource[0]||"number"==typeof this.listViewInstance.dataSource[0])l={text:this.listViewInstance.curViewDS[this.activeIndex],data:this.listViewInstance.curViewDS[this.activeIndex],index:this.activeIndex};else{var r=this.listViewInstance.curViewDS;l={text:r[this.activeIndex][this.listViewInstance.fields.text],data:r[this.activeIndex],index:this.activeIndex}}this.listViewInstance.showCheckBox?(l.isChecked=n,this.listViewInstance.trigger("select",l)):s||(this.listViewInstance.removeSelect(),this.listViewInstance.trigger("select",l))}}else t.isNullOrUndefined(e)&&!this.listViewInstance.showCheckBox&&(this.listViewInstance.removeSelect(),this.activeIndex=void 0)},s.prototype.enableItem=function(e){var t=this.findDSAndIndexFromId(this.listViewInstance.curViewDS,e);Object.keys(t).length&&this.uiIndices.disabledItemIndices.splice(this.uiIndices.disabledItemIndices.indexOf(t.index),1)},s.prototype.disableItem=function(e){var t=this.findDSAndIndexFromId(this.listViewInstance.curViewDS,e);Object.keys(t).length&&-1===this.uiIndices.disabledItemIndices.indexOf(t.index)&&this.uiIndices.disabledItemIndices.push(t.index)},s.prototype.showItem=function(e){var t=this.findDSAndIndexFromId(this.listViewInstance.curViewDS,e);Object.keys(t).length&&this.uiIndices.hiddenItemIndices.splice(this.uiIndices.hiddenItemIndices.indexOf(t.index),1)},s.prototype.hideItem=function(e){var t=this.findDSAndIndexFromId(this.listViewInstance.curViewDS,e);Object.keys(t).length&&-1===this.uiIndices.hiddenItemIndices.indexOf(t.index)&&this.uiIndices.hiddenItemIndices.push(t.index)},s.prototype.removeItem=function(e){var t,s=this.listViewInstance.curViewDS,n=this.findDSAndIndexFromId(s,e);Object.keys(n).length&&(t=n.data,s[n.index-1]&&s[n.index-1].isHeader&&1===s[n.index-1].items.length?(this.removeUiItem(n.index-1),this.removeUiItem(n.index-1)):this.removeUiItem(n.index));var l=this.listViewInstance.dataSource instanceof i.DataManager?this.listViewInstance.localData:this.listViewInstance.dataSource,r=l.indexOf(t);-1!==r&&(l.splice(r,1),this.listViewInstance.setViewDataSource(l)),this.listViewInstance.liCollection=this.listViewInstance.curUL.querySelectorAll("li")},s.prototype.setCheckboxLI=function(e,t){var i=Array.prototype.indexOf.call(this.listViewInstance.curUL.querySelectorAll("li"),e)+this.uiFirstIndex;this.activeIndex=Array.prototype.indexOf.call(this.listViewInstance.curUL.querySelectorAll("li"),e)+this.uiFirstIndex,e.classList.contains(d.selected)?-1===this.uiIndices.activeIndices.indexOf(i)&&this.uiIndices.activeIndices.push(i):this.uiIndices.activeIndices.splice(this.uiIndices.activeIndices.indexOf(i),1)},s.prototype.setSelectLI=function(e,t){this.activeIndex=Array.prototype.indexOf.call(this.listViewInstance.curUL.querySelectorAll("li"),e)+this.uiFirstIndex},s.prototype.checkedItem=function(e){if(e){this.uiIndices.activeIndices=[],this.activeIndex=void 0;for(var t=this.listViewInstance.curViewDS,i=0;i<t.length;i++)t[i].isHeader||this.uiIndices.activeIndices.push(i)}else this.activeIndex=void 0,this.uiIndices.activeIndices=[]},s.prototype.addUiItem=function(e){var t=this.listViewInstance.curViewDS;if(this.changeUiIndices(e,!0),this.activeIndex&&this.activeIndex>=e&&this.activeIndex++,this.listViewInstance.showCheckBox&&t[e][this.listViewInstance.fields.isChecked]&&this.uiIndices.activeIndices.push(e),parseFloat(this.bottomElement.style.height)||parseFloat(this.topElement.style.height)||(this.bottomElement.style.height=parseFloat(this.bottomElement.style.height)+this.listItemHeight+"px"),parseFloat(this.bottomElement.style.height)){var i=this.listViewInstance.curUL.lastElementChild.previousSibling;(s=this.listViewInstance.getLiFromObjOrElement(t[e+1])||this.listViewInstance.getLiFromObjOrElement(t[e+2]))&&(this.bottomElement.style.height=parseFloat(this.bottomElement.style.height)+this.listItemHeight+"px",this.updateUI(i,e,s))}else{i=this.listViewInstance.curUL.firstElementChild.nextSibling;var s=void 0;s=Object.keys(this.listViewInstance.curViewDS).length-1===e?this.listViewInstance.curUL.lastElementChild:this.listViewInstance.getLiFromObjOrElement(t[e+1])||this.listViewInstance.getLiFromObjOrElement(t[e+2]),this.topElement.style.height=parseFloat(this.topElement.style.height)+this.listItemHeight+"px",this.uiFirstIndex++,this.uiLastIndex++,s&&(this.updateUI(i,e,s),!0===this.listViewInstance.isWindow?window.scrollTo(0,pageYOffset+this.listItemHeight):this.listViewInstance.element.scrollTop+=this.listItemHeight)}this.totalHeight+=this.listItemHeight,this.listDiff=Math.round(parseFloat(this.topElement.style.height)/this.listItemHeight)},s.prototype.removeUiItem=function(e){this.totalHeight-=this.listItemHeight;var i=this.listViewInstance.curViewDS[e],s=this.listViewInstance.getLiFromObjOrElement(i);if(this.listViewInstance.curViewDS.splice(e,1),this.activeIndex&&this.activeIndex>=e&&this.activeIndex--,s)if(this.domItemCount>Object.keys(this.listViewInstance.curViewDS).length)t.detach(s),this.domItemCount--,this.uiLastIndex--,this.totalHeight=0;else{if(s.classList.contains(d.disable)&&(s.classList.remove(d.disable),this.uiIndices.disabledItemIndices.splice(this.uiIndices.disabledItemIndices.indexOf(e),1)),"none"===s.style.display&&(s.style.display="",this.uiIndices.hiddenItemIndices.splice(this.uiIndices.hiddenItemIndices.indexOf(e),1)),this.listViewInstance.showCheckBox&&s.classList.contains(d.selected)){this.listViewInstance.removeSelect(),this.uiIndices.activeIndices.splice(this.uiIndices.activeIndices.indexOf(e),1);var n=s.querySelector("."+d.checkboxWrapper);n.removeAttribute("aria-checked"),n.firstElementChild.classList.remove(d.checked),s.classList.contains(d.focused)&&(s.classList.remove(d.focused),this.activeIndex=void 0)}else s.classList.contains(d.selected)&&(this.listViewInstance.removeSelect(),this.activeIndex=void 0);parseFloat(this.bottomElement.style.height)||parseFloat(this.topElement.style.height)?parseFloat(this.bottomElement.style.height)?(this.bottomElement.style.height=parseFloat(this.bottomElement.style.height)-this.listItemHeight+"px",this.updateUI(s,this.uiLastIndex,this.bottomElement)):(this.topElement.style.height=parseFloat(this.topElement.style.height)-this.listItemHeight+"px",this.updateUI(s,this.uiFirstIndex-1,this.topElement.nextSibling),this.uiLastIndex--,this.uiFirstIndex--):this.updateUI(s,this.uiLastIndex,this.bottomElement)}this.changeUiIndices(e,!1),this.listDiff=Math.round(parseFloat(this.topElement.style.height)/this.listItemHeight)},s.prototype.changeUiIndices=function(e,t){for(var i=Object.keys(this.uiIndices),s=0;s<i.length;s++)this.uiIndices[i[s]]=this.uiIndices[i[s]].map(function(i){return i>=e?t?++i:--i:i})},s.prototype.addItem=function(e,t,i){for(var s=0;s<e.length;s++){var n=e[s];if(i.push(n),this.listViewInstance.setViewDataSource(i),this.domItemCount)if(this.domItemCount<this.expectedDomItemCount){if(this.listViewInstance.findItemFromDS(i,t)instanceof Array){if(this.listViewInstance.ulElement){var l=this.listViewInstance.curViewDS.indexOf(n);this.createAndInjectNewItem(n,l);(r=this.listViewInstance.curViewDS[l-1])&&r.isHeader&&1===r.items.length&&(--l,this.createAndInjectNewItem(r,l))}this.listViewInstance.liCollection=this.listViewInstance.curUL.querySelectorAll("li")}}else{l=this.listViewInstance.curViewDS.indexOf(n);this.addUiItem(l);var r;(r=this.listViewInstance.curViewDS[l-1])&&r.isHeader&&1===r.items.length&&this.addUiItem(l-1)}else!this.listViewInstance.template&&!this.listViewInstance.groupTemplate||this.isNgTemplate()||(this.listViewInstance.listBaseOption.template=null,this.listViewInstance.listBaseOption.groupTemplate=null,this.listViewInstance.listBaseOption.itemCreated=this.createUIItem.bind(this)),this.uiVirtualization()}},s.prototype.createAndInjectNewItem=function(t,i){var s,n=e.ListBase.createListItemFromJson(this.listViewInstance.createElement,[t],this.listViewInstance.listBaseOption,null,null,this.listViewInstance);if(s=Object.keys(this.listViewInstance.curViewDS).length-1===i?this.listViewInstance.curUL.lastElementChild:this.listViewInstance.getLiFromObjOrElement(this.listViewInstance.curViewDS[i+1])||this.listViewInstance.getLiFromObjOrElement(this.listViewInstance.curViewDS[i+2]),this.listViewInstance.fields.groupBy&&this.listViewInstance.curViewDS[i+1]&&this.listViewInstance.curViewDS[i+1].isHeader){var l=this.listViewInstance.getLiFromObjOrElement(this.listViewInstance.curViewDS[i-1]);l&&(s=l.nextElementSibling)}this.listViewInstance.ulElement.insertBefore(n[0],s),this.domItemCount++,this.bottomElementHeight<=0&&this.uiLastIndex++,this.refreshItemHeight()},s.prototype.createUIItem=function(e){var i=this.listViewInstance.template,s=this.listViewInstance.createElement("div"),n='<div class="e-text-content" role="presentation"> <span class="e-list-text"> ${'+this.listViewInstance.fields.text+"} </span></div>";if(this.listViewInstance.isReact&&(n=null),this.listViewInstance.showCheckBox){if(this.listViewInstance.renderCheckbox(e),!t.isNullOrUndefined(this.listViewInstance.virtualCheckBox)&&!t.isNullOrUndefined(this.listViewInstance.virtualCheckBox.outerHTML)){var l=document.createElement("div");l.innerHTML=this.listViewInstance.template||n,l.children&&l.children[0]&&(l.children[0].classList.add("e-checkbox"),"Left"===this.listViewInstance.checkBoxPosition?l.children[0].classList.add("e-checkbox-left"):l.children[0].classList.add("e-checkbox-right"),"Left"===this.listViewInstance.checkBoxPosition?l.children[0].insertBefore(this.listViewInstance.virtualCheckBox,l.childNodes[0].children[0]):l.children[0].appendChild(this.listViewInstance.virtualCheckBox),this.listViewInstance.template=l.innerHTML)}s.innerHTML=this.listViewInstance.template,this.listViewInstance.template=i}else s.innerHTML=this.listViewInstance.template||n;var r=s.getElementsByTagName("*"),a=this.listViewInstance.createElement("div");this.listViewInstance.fields.groupBy&&(a.innerHTML=this.listViewInstance.groupTemplate||n);var o=a.getElementsByTagName("*");e.curData.isHeader&&(this.headerData=e.curData),this.templateData=e.curData.isHeader?e.curData.items[0]:e.curData,(!this.listViewInstance.isReact||"string"==typeof this.listViewInstance.template&&!e.item.classList.contains("e-list-group-item")||"string"==typeof this.listViewInstance.groupTemplate&&e.item.classList.contains("e-list-group-item"))&&(e.item.innerHTML=""),e.item.context={data:e.curData,nodes:{flatTemplateNodes:[],groupTemplateNodes:[]}};for(var c=0;c<r.length;c++)this.compileTemplate(r[c],e.item,!1);for(c=0;c<o.length;c++)this.compileTemplate(o[c],e.item,!0);e.item.context.template=e.curData.isHeader?s.firstElementChild:a.firstElementChild,e.item.context.type=e.curData.isHeader?"flatList":"groupList";var h=e.curData.isHeader?a:s;h.firstElementChild&&e.item.insertBefore(h.firstElementChild,null)},s.prototype.compileTemplate=function(e,t,i){this.textProperty(e,t,i),this.classProperty(e,t,i),this.attributeProperty(e,t,i)},s.prototype.onChange=function(e,i){i.context.data=e;var s=i.context.nodes.groupTemplateNodes,n=i.context.nodes.flatTemplateNodes;if(!t.isNullOrUndefined(e.isHeader)&&e.isHeader&&"groupList"===i.context.type){var l=i.firstElementChild;t.detach(i.firstElementChild),i.insertBefore(i.context.template,null),i.context.template=l,i.context.type="flatList";for(var r=0;r<s.length;r++)s[r].onChange(e)}else if(e.isHeader||"flatList"!==i.context.type)if(e.isHeader)for(r=0;r<s.length;r++)s[r].onChange(e);else for(r=0;r<n.length;r++)n[r].onChange(e);else{l=i.firstElementChild;t.detach(i.firstElementChild),i.insertBefore(i.context.template,null),i.context.template=l,i.context.type="groupList";for(var r=0;r<n.length;r++)n[r].onChange(e)}},s.prototype.updateContextData=function(e,t,i){i?e.context.nodes.groupTemplateNodes.push(t):e.context.nodes.flatTemplateNodes.push(t)},s.prototype.classProperty=function(e,i,s){for(var n,l=new RegExp("\\${([^}]*)}","g"),r=[];null!==n;){var a=l.exec(e.className);r.push(a),null===(n=a)&&r.pop()}if(r&&r.length)for(var o=function(n){var l,a=r[n];l=-1!==a[1].indexOf("?")&&-1!==a[1].indexOf(":")?new Function("data","return "+a[1].replace(/\$/g,"data.")):new Function("data","return data."+a[1]);var o={};o.bindedvalue=l(s?c.headerData:c.templateData),o.onChange=function(i){o.bindedvalue&&t.removeClass([e],o.bindedvalue.split(" ").filter(function(e){return e}));var s=l(i);s&&t.addClass([e],s.split(" ").filter(function(e){return e})),o.bindedvalue=s};for(var h=a[0].split(" "),d=0;d<h.length;d++)e.classList.remove(h[d]);o.bindedvalue&&t.addClass([e],o.bindedvalue.split(" ").filter(function(e){return e})),c.updateContextData(i,o,s)},c=this,h=0;h<r.length;h++)o(h)},s.prototype.attributeProperty=function(e,t,i){for(var s=[],n=0;n<e.attributes.length;n++)s.push(e.attributes[n].nodeName);-1!==s.indexOf("class")&&s.splice(s.indexOf("class"),1);var l=function(n){var l,a,o=s[n],c=new RegExp("\\${([^}]*)}","g").exec(o)||[],h=new RegExp("\\${([^}]*)}","g").exec(e.getAttribute(o))||[];if(c.length||h.length){c[1]&&(l=new Function("data","return data."+c[1])),h[1]&&(a=-1!==h[1].indexOf("?")&&-1!==h[1].indexOf(":")?new Function("data","return "+h[1].replace(/\$/g,"data.")):new Function("data","return data."+h[1]));var d={};d.bindedvalue=i?[void 0===c[1]?void 0:l(r.headerData),void 0===h[1]?void 0:a(r.headerData)]:[void 0===c[1]?void 0:l(r.templateData),void 0===h[1]?void 0:a(r.templateData)],d.attrName=void 0===d.bindedvalue[0]?o:d.bindedvalue[0],d.onChange=function(t){var i=void 0===d.bindedvalue[1]?e.getAttribute(d.attrName):a(t);e.removeAttribute(d.attrName),d.attrName=void 0===d.bindedvalue[0]?d.attrName:l(t),e.setAttribute(d.attrName,i),d.bindedvalue=[void 0===d.bindedvalue[0]?void 0:l(t),void 0===d.bindedvalue[1]?void 0:a(t)]};var u=void 0===d.bindedvalue[1]?e.getAttribute(o):d.bindedvalue[1];e.removeAttribute(o),e.setAttribute(d.attrName,u),r.updateContextData(t,d,i)}},r=this;for(n=0;n<s.length;n++)l(n)},s.prototype.textProperty=function(e,t,i){for(var s,n=new RegExp("\\${([^}]*)}","g"),l=[];null!==s;){var r=n.exec(e.innerText);l.push(r),null===(s=r)&&l.pop()}var a=Array.prototype.some.call(e.children,function(e){return!!new RegExp("\\${([^}]*)}","g").exec(e.innerText)});if(l&&l.length&&!a)for(var o=function(s){var n,r=l[s],a={};n=-1!==r[1].indexOf("?")&&-1!==r[1].indexOf(":")?new Function("data","return "+r[1].replace(/\$/g,"data.")):new Function("data","return data."+r[1]),a.bindedvalue=n(i?c.headerData:c.templateData),a.onChange=function(t){e.innerText=e.innerText.replace(a.bindedvalue,n(t)),a.bindedvalue=n(t)},e.innerText=e.innerText.replace(r[0],a.bindedvalue),c.updateContextData(t,a,i)},c=this,h=0;h<l.length;h++)o(h)},s.prototype.reRenderUiVirtualization=function(){this.wireScrollEvent(!0),this.listViewInstance.contentContainer&&t.detach(this.listViewInstance.contentContainer),this.listViewInstance.preRender(),this.domItemCount=0,this.listViewInstance.header(),this.listViewInstance.setLocalData()},s.prototype.updateUI=function(t,i,s){var n=this.isNgTemplate()?this.onNgChange:this.onChange;if(this.listViewInstance.template||this.listViewInstance.groupTemplate){var l=this.listViewInstance.curViewDS[i];t.dataset.uid=l[this.listViewInstance.fields.id]?l[this.listViewInstance.fields.id]:e.ListBase.generateId(),n(l,t,this)}else this.updateUiContent(t,i);this.changeElementAttributes(t,i),s&&this.listViewInstance.ulElement.insertBefore(t,s)},s.prototype.onNgChange=function(e,i,s){for(var n=t.compile(s.listViewInstance.template)(e);i.lastChild;)i.removeChild(i.lastChild);i.appendChild(n[0])},s.prototype.getModuleName=function(){return"virtualization"},s.prototype.destroy=function(){this.wireScrollEvent(!0)},s}(),g=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),v=function(e,t,i,s){var n,l=arguments.length,r=l<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(e,t,i,s);else for(var a=e.length-1;a>=0;a--)(n=e[a])&&(r=(l<3?n(r):l>3?n(t,i,r):n(t,i))||r);return l>3&&r&&Object.defineProperty(t,i,r),r},I=function(e){function i(i,s){var n=e.call(this,s,i)||this;return n.getHelper=function(e){var i=n.getSortableElement(e.sender.target);if(!n.isValidTarget(i,n))return!1;var s;return n.helper?s=n.helper({sender:i,element:e.element}):((s=i.cloneNode(!0)).style.width=i.offsetWidth+"px",s.style.height=i.offsetHeight+"px"),t.addClass([s],["e-sortableclone"]),document.body.appendChild(s),s},n.onDrag=function(e){n.trigger("drag",{event:e.event,element:n.element,target:e.target});var i=n.getSortableInstance(e.target),s=n.getSortableElement(e.target,i);if((n.isValidTarget(s,i)||e.target.className.indexOf("e-list-group-item")>-1)&&(n.curTarget!==s||!t.isNullOrUndefined(i.placeHolder))&&(!i.placeHolderElement||i.placeHolderElement!==e.target)){if(e.target.className.indexOf("e-list-group-item")>-1&&(s=e.target),n.curTarget=s,n.target===s)return;var l=n.getIndex(i.placeHolderElement,i),r=n.getPlaceHolder(s,i),a=void 0;if(r){l=t.isNullOrUndefined(l)?n.getIndex(n.target):l,a=n.getIndex(s,i,e.event);var o=n.isPlaceHolderPresent(i);if(o&&l===a)return;o&&t.remove(i.placeHolderElement),i.placeHolderElement=r,e.target.className.indexOf("e-list-group-item")>-1?i.element.insertBefore(i.placeHolderElement,i.element.children[a]):i.element!==n.element&&a===i.element.childElementCount?i.element.appendChild(i.placeHolderElement):i.element.insertBefore(i.placeHolderElement,i.element.children[a]),n.refreshDisabled(l,a,i)}else{l=t.isNullOrUndefined(l)?n.getIndex(n.target):n.getIndex(s,i)<l||!l?l:l-1,a=n.getIndex(s,i);var c=i.element!==n.element?a:l<a?a+1:a;n.updateItemClass(i),i.element.insertBefore(n.target,i.element.children[c]),n.refreshDisabled(l,a,i),n.curTarget=n.target,n.trigger("drop",{droppedElement:n.target,element:i.element,previousIndex:l,currentIndex:a,target:e.target,helper:document.getElementsByClassName("e-sortableclone")[0],event:e.event,scope:n.scope})}}if(i=n.getSortableInstance(n.curTarget),t.isNullOrUndefined(s)&&e.target!==i.placeHolderElement)n.isPlaceHolderPresent(i)&&n.removePlaceHolder(i);else{var h;[].slice.call(document.getElementsByClassName("e-sortable-placeholder")).forEach(function(e){(h=n.getSortableInstance(e)).element&&h!==i&&n.removePlaceHolder(h)})}},n.onDragStart=function(e){n.target=n.getSortableElement(e.target);var i=!1;n.target.classList.add("e-grabbed"),n.curTarget=n.target,e.helper=document.getElementsByClassName("e-sortableclone")[0];var s={cancel:!1,element:n.element,target:n.target};n.trigger("beforeDragStart",s,function(t){t.cancel&&(i=t.cancel,n.onDragStop(e))}),i||(t.isBlazor?n.trigger("dragStart",{event:e.event,element:n.element,target:n.target,bindEvents:e.bindEvents,dragElement:e.dragElement}):n.trigger("dragStart",{event:e.event,element:n.element,target:n.target}))},n.onDragStop=function(e){var i,s,l,r=n.getSortableInstance(n.curTarget);i=n.getIndex(n.target);var a=n.isPlaceHolderPresent(r);if(a){var o=n.getIndex(r.placeHolderElement,r),c={previousIndex:i,currentIndex:o,target:e.target,droppedElement:n.target,helper:e.helper,cancel:!1,handled:!1};n.trigger("beforeDrop",c,function(s){if(!s.cancel){if(l=s.handled,n.updateItemClass(r),s.handled){var a=n.target.cloneNode(!0);n.target.classList.remove("e-grabbed"),n.target=a}r.element.insertBefore(n.target,r.placeHolderElement);var o=n.getIndex(n.target,r);i=n===r&&i-o>1?i-1:i,n.trigger("drop",{event:e.event,element:r.element,previousIndex:i,currentIndex:o,target:e.target,helper:e.helper,droppedElement:n.target,scopeName:n.scope,handled:l})}t.remove(r.placeHolderElement)})}if(r=n.getSortableInstance(e.target),s=r.element.childElementCount,i=n.getIndex(n.target),r.element===e.target||!a&&n.curTarget===n.target){var h={previousIndex:i,currentIndex:n.curTarget===n.target?i:s,target:e.target,droppedElement:n.target,helper:e.helper,cancel:!1};n.trigger("beforeDrop",h,function(t){r.element!==e.target||t.cancel||(n.updateItemClass(r),r.element.appendChild(n.target),n.trigger("drop",{event:e.event,element:r.element,previousIndex:i,currentIndex:s,target:e.target,helper:e.helper,droppedElement:n.target,scopeName:n.scope}))})}n.target.classList.remove("e-grabbed"),n.target=null,n.curTarget=null,t.remove(e.helper),t.getComponent(n.element,t.Draggable).intDestroy(e.event)},n.bind(),n}g(i,e),s=i,i.prototype.bind=function(){this.element.id||(this.element.id=t.getUniqueID("sortable")),this.itemClass||(this.itemClass="e-sort-item",this.dataBind()),this.initializeDraggable()},i.prototype.initializeDraggable=function(){new t.Draggable(this.element,{helper:this.getHelper,dragStart:this.onDragStart,drag:this.onDrag,dragStop:this.onDragStop,dragTarget:"."+this.itemClass,enableTapHold:!0,tapHoldThreshold:200,queryPositionInfo:this.queryPositionInfo,distance:5})},i.prototype.getPlaceHolder=function(e,t){if(t.placeHolder){var i=t.placeHolder({element:t.element,grabbedElement:this.target,target:e});return i.classList.add("e-sortable-placeholder"),i}return null},i.prototype.isValidTarget=function(e,i){return e&&t.compareElementParent(e,i.element)&&e.classList.contains(i.itemClass)&&!e.classList.contains("e-disabled")},i.prototype.removePlaceHolder=function(e){t.remove(e.placeHolderElement),e.placeHolderElement=null},i.prototype.updateItemClass=function(e){this!==e&&(this.target.classList.remove(this.itemClass),this.target.classList.add(e.itemClass))},i.prototype.getSortableInstance=function(e){if(e=t.closest(e,".e-"+this.getModuleName())){var i=t.getComponent(e,s);return i.scope&&this.scope&&i.scope===this.scope?i:this}return this},i.prototype.refreshDisabled=function(e,t,i){if(i===this)for(var s=void 0,n=e<t,l=void 0,r=n?e:t,a=n?t:e;r<=a;)(s=this.element.children[r]).classList.contains("e-disabled")?(l=this.getIndex(s),this.element.insertBefore(s,this.element.children[n?l+2:l-1]),r=n?l+2:l+1):r++},i.prototype.getIndex=function(e,i,s){void 0===i&&(i=this);var n,l;return[].slice.call(i.element.children).forEach(function(i,r){if(i.classList.contains("e-sortable-placeholder")&&(l=!0),i!==e);else if(n=r,!t.isNullOrUndefined(s)){l&&(n-=1);var a=e.getBoundingClientRect(),o=a.bottom-(a.bottom-a.top)/2;n=s.clientY<=o?n:n+1}}),n},i.prototype.getSortableElement=function(e,i){return void 0===i&&(i=this),t.closest(e,"."+i.itemClass)},i.prototype.queryPositionInfo=function(e){return e.left=pageXOffset?parseFloat(e.left)-pageXOffset+"px":e.left,e.top=pageYOffset?parseFloat(e.top)-pageYOffset+"px":e.top,e},i.prototype.isPlaceHolderPresent=function(e){return e.placeHolderElement&&!!t.closest(e.placeHolderElement,"#"+e.element.id)},i.prototype.moveTo=function(e,t,i){r(this.element,e,t,i)},i.prototype.destroy=function(){"e-sort-item"===this.itemClass&&(this.itemClass=null,this.dataBind()),t.getComponent(this.element,t.Draggable).destroy(),e.prototype.destroy.call(this)},i.prototype.getModuleName=function(){return"sortable"},i.prototype.onPropertyChanged=function(e,t){for(var i=0,s=Object.keys(e);i<s.length;i++){switch(s[i]){case"itemClass":[].slice.call(this.element.children).forEach(function(i){i.classList.contains(t.itemClass)&&i.classList.remove(t.itemClass),e.itemClass&&i.classList.add(e.itemClass)})}}};var s;return v([t.Property(!1)],i.prototype,"enableAnimation",void 0),v([t.Property(null)],i.prototype,"itemClass",void 0),v([t.Property(null)],i.prototype,"scope",void 0),v([t.Property()],i.prototype,"helper",void 0),v([t.Property()],i.prototype,"placeHolder",void 0),v([t.Event()],i.prototype,"drag",void 0),v([t.Event()],i.prototype,"beforeDragStart",void 0),v([t.Event()],i.prototype,"dragStart",void 0),v([t.Event()],i.prototype,"beforeDrop",void 0),v([t.Event()],i.prototype,"drop",void 0),i=s=v([t.NotifyPropertyChanges],i)}(t.Base);e.classNames=d,e.FieldSettings=p,e.ListView=m,e.Virtualization=f,e.getFieldValues=n,e.Sortable=I,e.moveTo=r,Object.defineProperty(e,"__esModule",{value:!0})});
	//# sourceMappingURL=ej2-lists.umd.min.js.map


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	*  filename: ej2-navigations.umd.min.js
	*  version : 19.4.56
	*  Copyright Syncfusion Inc. 2001 - 2020. All rights reserved.
	*  Use of this code is subject to the terms of our license.
	*  A copy of the current license can be obtained at any time by e-mailing
	*  licensing@syncfusion.com. Any infringement will be prosecuted under
	*  applicable laws. 
	*/
	!function(e,t){ true?t(exports,__webpack_require__(23),__webpack_require__(101),__webpack_require__(46),__webpack_require__(42),__webpack_require__(76),__webpack_require__(59)):"function"==typeof define&&define.amd?define(["exports","@syncfusion/ej2-base","@syncfusion/ej2-lists","@syncfusion/ej2-popups","@syncfusion/ej2-buttons","@syncfusion/ej2-data","@syncfusion/ej2-inputs"],t):t(e.ej={},e.ej2Base,e.ej2Lists,e.ej2Popups,e.ej2Buttons,e.ej2Data,e.ej2Inputs)}(this,function(e,t,i,s,n,r,l){"use strict";function o(e,t,i,s,n,r){var l,o,d=t.parentElement;if("vscroll"===s?(l=r||t.getBoundingClientRect().height,o=i.getBoundingClientRect().height):(l=t.getBoundingClientRect().width,o=i.getBoundingClientRect().width),l<o)return a(e,t,i,s,n,r);if(d){var h=d.getBoundingClientRect().width;return h<l&&"hscroll"===s?(o=h,t.style.maxWidth=h+"px",a(e,t,i,s,n,r)):i}return i}function a(e,i,s,n,r,l){var o=e("div",{className:"e-menu-"+n});i.appendChild(o),o.appendChild(s),l?(o.style.overflow="hidden",o.style.height=l+"px"):(o.style.maxHeight=i.style.maxHeight,i.style.overflow="hidden");return"vscroll"===n?new B({enableRtl:r},o).scrollStep=t.select(".e-"+n+"-bar",i).offsetHeight/2:new O({enableRtl:r},o).scrollStep=t.select(".e-"+n+"-bar",i).offsetWidth,o}function d(e,i,s){if(e){var n=t.select(".e-menu-parent",i);n?s&&s!==n||(e.destroy(),i.parentElement.appendChild(n),t.detach(i)):(e.destroy(),t.detach(i))}}var h=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),c=function(e,t,i,s){var n,r=arguments.length,l=r<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)l=Reflect.decorate(e,t,i,s);else for(var o=e.length-1;o>=0;o--)(n=e[o])&&(l=(r<3?n(l):r>3?n(t,i,l):n(t,i))||l);return r>3&&l&&Object.defineProperty(t,i,l),l},p="e-rtl",u="e-overlay",f="e-nav-arrow",m="e-nav-right-arrow",v="e-nav-left-arrow",g="e-scroll-nav",y="e-scroll-right-nav",b="e-scroll-left-nav",C="e-scroll-device",E="e-scroll-overlay",N="e-scroll-right-overlay",x="e-scroll-left-overlay",O=function(e){function i(t,i){return e.call(this,t,i)||this}return h(i,e),i.prototype.preRender=function(){this.browser=t.Browser.info.name,this.browserCheck="mozilla"===this.browser,this.isDevice=t.Browser.isDevice,this.customStep=!0;var e=this.element;this.ieCheck="edge"===this.browser||"msie"===this.browser,this.initialize(),""===e.id&&(e.id=t.getUniqueID("hscroll"),this.uniqueId=!0),e.style.display="block",this.enableRtl&&e.classList.add(p)},i.prototype.render=function(){this.touchModule=new t.Touch(this.element,{scroll:this.touchHandler.bind(this),swipe:this.swipeHandler.bind(this)}),t.EventHandler.add(this.scrollEle,"scroll",this.scrollHandler,this),this.isDevice?(this.element.classList.add(C),this.createOverlay(this.element)):this.createNavIcon(this.element),this.setScrollState()},i.prototype.setScrollState=function(){t.isNullOrUndefined(this.scrollStep)||this.scrollStep<0?(this.scrollStep=this.scrollEle.offsetWidth,this.customStep=!1):this.customStep=!0},i.prototype.initialize=function(){var e=this.createElement("div",{className:"e-hscroll-content"}),t=this.createElement("div",{className:"e-hscroll-bar"});t.setAttribute("tabindex","-1");for(var i=this.element,s=0,n=[].slice.call(i.children);s<n.length;s++){var r=n[s];e.appendChild(r)}t.appendChild(e),i.appendChild(t),t.style.overflowX="hidden",this.scrollEle=t,this.scrollItems=e},i.prototype.getPersistData=function(){return this.addOnPersist(["scrollStep"])},i.prototype.getModuleName=function(){return"hScroll"},i.prototype.destroy=function(){var i=this.element;i.style.display="",i.classList.remove("e-hscroll"),i.classList.remove(C);var s=t.selectAll(".e-"+i.id+"_nav."+g,i),n=t.selectAll("."+E,i);[].slice.call(n).forEach(function(e){t.detach(e)});for(var r=0,l=[].slice.call(this.scrollItems.children);r<l.length;r++){var o=l[r];i.appendChild(o)}this.uniqueId&&this.element.removeAttribute("id"),t.detach(this.scrollEle),s.length>0&&(t.detach(s[0]),t.isNullOrUndefined(s[1])||t.detach(s[1])),t.EventHandler.remove(this.scrollEle,"scroll",this.scrollHandler),this.touchModule.destroy(),this.touchModule=null,e.prototype.destroy.call(this)},i.prototype.disable=function(e){var i=t.selectAll(".e-scroll-nav:not(."+u+")",this.element);e?this.element.classList.add(u):this.element.classList.remove(u),[].slice.call(i).forEach(function(t){t.setAttribute("tabindex",e?"-1":"0")})},i.prototype.createOverlay=function(e){var t=e.id.concat("_nav"),i=this.createElement("div",{className:E+" "+N}),s="e-"+e.id.concat("_nav "+g+" "+y),n=this.createElement("div",{id:t.concat("_right"),className:s}),r=this.createElement("div",{className:m+" "+f+" e-icons"});n.appendChild(r);var l=this.createElement("div",{className:E+" "+x});this.ieCheck&&n.classList.add("e-ie-align"),e.appendChild(i),e.appendChild(n),e.insertBefore(l,e.firstChild),this.eventBinding([n])},i.prototype.createNavIcon=function(e){var t=e.id.concat("_nav"),i="e-"+e.id.concat("_nav "+g+" "+y),s=this.createElement("div",{id:t.concat("_right"),className:i});s.setAttribute("aria-disabled","false");var n=this.createElement("div",{className:m+" "+f+" e-icons"}),r="e-"+e.id.concat("_nav "+g+" "+b),l=this.createElement("div",{id:t.concat("_left"),className:r+" "+u});l.setAttribute("aria-disabled","true");var o=this.createElement("div",{className:v+" "+f+" e-icons"});l.appendChild(o),s.appendChild(n),e.appendChild(s),e.insertBefore(l,e.firstChild),this.ieCheck&&(s.classList.add("e-ie-align"),l.classList.add("e-ie-align")),this.eventBinding([s,l])},i.prototype.onKeyPress=function(e){var t=this;if("Enter"===e.key){this.keyTimer=window.setTimeout(function(){t.keyTimeout=!0,t.eleScrolling(10,e.target,!0)},100)}},i.prototype.onKeyUp=function(e){"Enter"===e.key&&(this.keyTimeout?this.keyTimeout=!1:e.target.click(),clearTimeout(this.keyTimer))},i.prototype.eventBinding=function(e){var i=this;[].slice.call(e).forEach(function(e){new t.Touch(e,{tapHold:i.tabHoldHandler.bind(i),tapHoldThreshold:500}),e.addEventListener("keydown",i.onKeyPress.bind(i)),e.addEventListener("keyup",i.onKeyUp.bind(i)),e.addEventListener("mouseup",i.repeatScroll.bind(i)),e.addEventListener("touchend",i.repeatScroll.bind(i)),e.addEventListener("contextmenu",function(e){e.preventDefault()}),t.EventHandler.add(e,"click",i.clickEventHandler,i)})},i.prototype.repeatScroll=function(){clearInterval(this.timeout)},i.prototype.tabHoldHandler=function(e){var t=this,i=e.originalEvent.target;i=this.contains(i,g)?i.firstElementChild:i;this.timeout=window.setInterval(function(){t.eleScrolling(10,i,!0)},50)},i.prototype.contains=function(e,t){return e.classList.contains(t)},i.prototype.eleScrolling=function(e,t,i){var s=this.element,n=t.classList;n.contains(g)&&(n=t.querySelector("."+f).classList),this.contains(s,p)&&this.browserCheck&&(e=-e),!this.contains(s,p)||this.browserCheck||this.ieCheck?n.contains(m)?this.frameScrollRequest(e,"add",i):this.frameScrollRequest(e,"",i):n.contains(v)?this.frameScrollRequest(e,"add",i):this.frameScrollRequest(e,"",i)},i.prototype.clickEventHandler=function(e){this.eleScrolling(this.scrollStep,e.target,!1)},i.prototype.swipeHandler=function(e){var t,i=this.scrollEle;t=e.velocity<=1?e.distanceX/(10*e.velocity):e.distanceX/e.velocity;var s=.5,n=function(){var r=Math.sin(s);r<=0?window.cancelAnimationFrame(r):("Left"===e.swipeDirection?i.scrollLeft+=t*r:"Right"===e.swipeDirection&&(i.scrollLeft-=t*r),s-=.5,window.requestAnimationFrame(n))};n()},i.prototype.scrollUpdating=function(e,t){"add"===t?this.scrollEle.scrollLeft+=e:this.scrollEle.scrollLeft-=e},i.prototype.frameScrollRequest=function(e,i,s){var n=this;if(s)this.scrollUpdating(e,i);else{this.customStep||[].slice.call(t.selectAll("."+E,this.element)).forEach(function(t){e-=t.offsetWidth});var r=function(){var t,s;n.contains(n.element,p)&&n.browserCheck?(t=-e,s=-10):(t=e,s=10),t<10?window.cancelAnimationFrame(s):(n.scrollUpdating(s,i),e-=s,window.requestAnimationFrame(r))};r()}},i.prototype.touchHandler=function(e){var t=this.scrollEle,i=e.distanceX;this.ieCheck&&this.contains(this.element,p)&&(i=-i),"Left"===e.scrollDirection?t.scrollLeft=t.scrollLeft+i:"Right"===e.scrollDirection&&(t.scrollLeft=t.scrollLeft-i)},i.prototype.arrowDisabling=function(e,i){if(this.isDevice){var s=(t.isNullOrUndefined(e)?i:e).querySelector("."+f);t.isNullOrUndefined(e)?t.classList(s,[m],[v]):t.classList(s,[v],[m])}else e.classList.add(u),e.setAttribute("aria-disabled","true"),e.removeAttribute("tabindex"),i.classList.remove(u),i.setAttribute("aria-disabled","false"),i.setAttribute("tabindex","0");this.repeatScroll()},i.prototype.scrollHandler=function(e){var t=e.target,i=t.offsetWidth,s=(this.element,this.element.querySelector("."+b)),n=this.element.querySelector("."+y),r=this.element.querySelector("."+x),l=this.element.querySelector("."+N),o=t.scrollLeft;if(o<=0&&(o=-o),this.isDevice&&(!this.enableRtl||this.browserCheck||this.ieCheck||(r=this.element.querySelector("."+N),l=this.element.querySelector("."+x)),r.style.width=o<40?o+"px":"40px",t.scrollWidth-Math.ceil(i+o)<40?l.style.width=t.scrollWidth-Math.ceil(i+o)+"px":l.style.width="40px"),0===o)this.arrowDisabling(s,n);else if(Math.ceil(i+o+.1)>=t.scrollWidth)this.arrowDisabling(n,s);else{var a=this.element.querySelector("."+g+"."+u);a&&(a.classList.remove(u),a.setAttribute("aria-disabled","false"),a.setAttribute("tabindex","0"))}},i.prototype.onPropertyChanged=function(e,t){for(var i=0,s=Object.keys(e);i<s.length;i++){switch(s[i]){case"scrollStep":this.setScrollState();break;case"enableRtl":e.enableRtl?this.element.classList.add(p):this.element.classList.remove(p)}}},c([t.Property(null)],i.prototype,"scrollStep",void 0),i=c([t.NotifyPropertyChanges],i)}(t.Component),I=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),S=function(e,t,i,s){var n,r=arguments.length,l=r<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)l=Reflect.decorate(e,t,i,s);else for(var o=e.length-1;o>=0;o--)(n=e[o])&&(l=(r<3?n(l):r>3?n(t,i,l):n(t,i))||l);return r>3&&l&&Object.defineProperty(t,i,l),l},w="e-overlay",k="e-nav-arrow",L="e-nav-up-arrow",A="e-nav-down-arrow",D="e-scroll-nav",M="e-scroll-up-nav",P="e-scroll-down-nav",T="e-scroll-device",H="e-scroll-overlay",U="e-scroll-up-overlay",R="e-scroll-down-overlay",B=function(e){function i(t,i){return e.call(this,t,i)||this}return I(i,e),i.prototype.preRender=function(){this.browser=t.Browser.info.name,this.browserCheck="mozilla"===this.browser,this.isDevice=t.Browser.isDevice,this.customStep=!0;var e=this.element;this.ieCheck="edge"===this.browser||"msie"===this.browser,this.initialize(),""===e.id&&(e.id=t.getUniqueID("vscroll"),this.uniqueId=!0),e.style.display="block",this.enableRtl&&e.classList.add("e-rtl")},i.prototype.render=function(){this.touchModule=new t.Touch(this.element,{scroll:this.touchHandler.bind(this),swipe:this.swipeHandler.bind(this)}),t.EventHandler.add(this.scrollEle,"scroll",this.scrollEventHandler,this),this.isDevice?(this.element.classList.add(T),this.createOverlayElement(this.element)):this.createNavIcon(this.element),this.setScrollState(),t.EventHandler.add(this.element,"wheel",this.wheelEventHandler,this)},i.prototype.setScrollState=function(){t.isNullOrUndefined(this.scrollStep)||this.scrollStep<0?(this.scrollStep=this.scrollEle.offsetHeight,this.customStep=!1):this.customStep=!0},i.prototype.initialize=function(){var e=t.createElement("div",{className:"e-vscroll-content"}),i=t.createElement("div",{className:"e-vscroll-bar"});i.setAttribute("tabindex","-1");for(var s=this.element,n=0,r=[].slice.call(s.children);n<r.length;n++){var l=r[n];e.appendChild(l)}i.appendChild(e),s.appendChild(i),i.style.overflow="hidden",this.scrollEle=i,this.scrollItems=e},i.prototype.getPersistData=function(){return this.addOnPersist(["scrollStep"])},i.prototype.getModuleName=function(){return"vScroll"},i.prototype.destroy=function(){var i=this.element;i.style.display="",t.removeClass([this.element],["e-vscroll",T]);var s=t.selectAll(".e-"+i.id+"_nav."+D,i),n=t.selectAll("."+H,i);[].slice.call(n).forEach(function(e){t.detach(e)});for(var r=0,l=[].slice.call(this.scrollItems.children);r<l.length;r++){var o=l[r];i.appendChild(o)}this.uniqueId&&this.element.removeAttribute("id"),t.detach(this.scrollEle),s.length>0&&(t.detach(s[0]),t.isNullOrUndefined(s[1])||t.detach(s[1])),t.EventHandler.remove(this.scrollEle,"scroll",this.scrollEventHandler),this.touchModule.destroy(),this.touchModule=null,e.prototype.destroy.call(this)},i.prototype.disable=function(e){var i=t.selectAll(".e-scroll-nav:not(."+w+")",this.element);e?this.element.classList.add(w):this.element.classList.remove(w),[].slice.call(i).forEach(function(t){t.setAttribute("tabindex",e?"-1":"0")})},i.prototype.createOverlayElement=function(e){var i=e.id.concat("_nav"),s=t.createElement("div",{className:H+" "+R}),n="e-"+e.id.concat("_nav "+D+" "+P),r=t.createElement("div",{id:i.concat("down"),className:n}),l=t.createElement("div",{className:A+" "+k+" e-icons"});r.appendChild(l);var o=t.createElement("div",{className:H+" "+U});this.ieCheck&&r.classList.add("e-ie-align"),e.appendChild(s),e.appendChild(r),e.insertBefore(o,e.firstChild),this.eventBinding([r])},i.prototype.createNavIcon=function(e){var i=e.id.concat("_nav"),s="e-"+e.id.concat("_nav "+D+" "+P),n=t.createElement("div",{id:i.concat("_down"),className:s});n.setAttribute("aria-disabled","false");var r=t.createElement("div",{className:A+" "+k+" e-icons"}),l="e-"+e.id.concat("_nav "+D+" "+M),o=t.createElement("div",{id:i.concat("_up"),className:l+" "+w});o.setAttribute("aria-disabled","true");var a=t.createElement("div",{className:L+" "+k+" e-icons"});o.appendChild(a),n.appendChild(r),n.setAttribute("tabindex","0"),e.appendChild(n),e.insertBefore(o,e.firstChild),this.ieCheck&&(n.classList.add("e-ie-align"),o.classList.add("e-ie-align")),this.eventBinding([n,o])},i.prototype.onKeyPress=function(e){var t=this;if("Enter"===e.key){this.keyTimer=window.setTimeout(function(){t.keyTimeout=!0,t.eleScrolling(10,e.target,!0)},100)}},i.prototype.onKeyUp=function(e){"Enter"===e.key&&(this.keyTimeout?this.keyTimeout=!1:e.target.click(),clearTimeout(this.keyTimer))},i.prototype.eventBinding=function(e){var i=this;[].slice.call(e).forEach(function(e){new t.Touch(e,{tapHold:i.tabHoldHandler.bind(i),tapHoldThreshold:500}),e.addEventListener("keydown",i.onKeyPress.bind(i)),e.addEventListener("keyup",i.onKeyUp.bind(i)),e.addEventListener("mouseup",i.repeatScroll.bind(i)),e.addEventListener("touchend",i.repeatScroll.bind(i)),e.addEventListener("contextmenu",function(e){e.preventDefault()}),t.EventHandler.add(e,"click",i.clickEventHandler,i)})},i.prototype.repeatScroll=function(){clearInterval(this.timeout)},i.prototype.tabHoldHandler=function(e){var t=this,i=e.originalEvent.target;i=this.contains(i,D)?i.firstElementChild:i;this.timeout=window.setInterval(function(){t.eleScrolling(10,i,!0)},50)},i.prototype.contains=function(e,t){return e.classList.contains(t)},i.prototype.eleScrolling=function(e,t,i){var s=t.classList;s.contains(D)&&(s=t.querySelector("."+k).classList),s.contains(A)?this.frameScrollRequest(e,"add",i):s.contains(L)&&this.frameScrollRequest(e,"",i)},i.prototype.clickEventHandler=function(e){this.eleScrolling(this.scrollStep,e.target,!1)},i.prototype.wheelEventHandler=function(e){e.preventDefault(),this.frameScrollRequest(this.scrollStep,e.deltaY>0?"add":"",!1)},i.prototype.swipeHandler=function(e){var t,i=this.scrollEle;t=e.velocity<=1?e.distanceY/(10*e.velocity):e.distanceY/e.velocity;var s=.5,n=function(){var r=Math.sin(s);r<=0?window.cancelAnimationFrame(r):("Up"===e.swipeDirection?i.scrollTop+=t*r:"Down"===e.swipeDirection&&(i.scrollTop-=t*r),s-=.02,window.requestAnimationFrame(n))};n()},i.prototype.scrollUpdating=function(e,t){"add"===t?this.scrollEle.scrollTop+=e:this.scrollEle.scrollTop-=e},i.prototype.frameScrollRequest=function(e,i,s){var n=this;if(s)this.scrollUpdating(e,i);else{this.customStep||[].slice.call(t.selectAll("."+H,this.element)).forEach(function(t){e-=t.offsetHeight});var r=function(){e<10?window.cancelAnimationFrame(10):(n.scrollUpdating(10,i),e-=10,window.requestAnimationFrame(r))};r()}},i.prototype.touchHandler=function(e){var t=this.scrollEle,i=e.distanceY;"Up"===e.scrollDirection?t.scrollTop=t.scrollTop+i:"Down"===e.scrollDirection&&(t.scrollTop=t.scrollTop-i)},i.prototype.arrowDisabling=function(e,i){if(this.isDevice){var s=(t.isNullOrUndefined(e)?i:e).querySelector("."+k);t.isNullOrUndefined(e)?t.classList(s,[A],[L]):t.classList(s,[L],[A])}else e.classList.add(w),e.setAttribute("aria-disabled","true"),e.removeAttribute("tabindex"),i.classList.remove(w),i.setAttribute("aria-disabled","false"),i.setAttribute("tabindex","0");this.repeatScroll()},i.prototype.scrollEventHandler=function(e){var t=e.target,i=t.offsetHeight,s=this.element.querySelector("."+M),n=this.element.querySelector("."+P),r=this.element.querySelector("."+U),l=this.element.querySelector("."+R),o=t.scrollTop;if(o<=0&&(o=-o),this.isDevice&&(r.style.height=o<40?o+"px":"40px",t.scrollHeight-Math.ceil(i+o)<40?l.style.height=t.scrollHeight-Math.ceil(i+o)+"px":l.style.height="40px"),0===o)this.arrowDisabling(s,n);else if(Math.ceil(i+o+.1)>=t.scrollHeight)this.arrowDisabling(n,s);else{var a=this.element.querySelector("."+D+"."+w);a&&(a.classList.remove(w),a.setAttribute("aria-disabled","false"),a.setAttribute("tabindex","0"))}},i.prototype.onPropertyChanged=function(e,t){for(var i=0,s=Object.keys(e);i<s.length;i++){switch(s[i]){case"scrollStep":this.setScrollState();break;case"enableRtl":e.enableRtl?this.element.classList.add("e-rtl"):this.element.classList.remove("e-rtl")}}},S([t.Property(null)],i.prototype,"scrollStep",void 0),i=S([t.NotifyPropertyChanges],i)}(t.Component),j=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),q=function(e,t,i,s){var n,r=arguments.length,l=r<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)l=Reflect.decorate(e,t,i,s);else for(var o=e.length-1;o>=0;o--)(n=e[o])&&(l=(r<3?n(l):r>3?n(t,i,l):n(t,i))||l);return r>3&&l&&Object.defineProperty(t,i,l),l},F="e-focused",W="e-menu-header",V="e-selected",_="e-separator",z="uparrow",K="downarrow",Y="leftarrow",X="rightarrow",G="e-menu-item",Q="e-disabled",J="e-menu-hide",Z="e-menu-popup",$=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return j(i,e),q([t.Property("id")],i.prototype,"itemId",void 0),q([t.Property("parentId")],i.prototype,"parentId",void 0),q([t.Property("text")],i.prototype,"text",void 0),q([t.Property("iconCss")],i.prototype,"iconCss",void 0),q([t.Property("url")],i.prototype,"url",void 0),q([t.Property("separator")],i.prototype,"separator",void 0),q([t.Property("items")],i.prototype,"children",void 0),i}(t.ChildProperty),ee=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return j(i,e),q([t.Property(null)],i.prototype,"iconCss",void 0),q([t.Property("")],i.prototype,"id",void 0),q([t.Property(!1)],i.prototype,"separator",void 0),q([t.Collection([],i)],i.prototype,"items",void 0),q([t.Property("")],i.prototype,"text",void 0),q([t.Property("")],i.prototype,"url",void 0),i}(t.ChildProperty),te=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return j(i,e),q([t.Property("SlideDown")],i.prototype,"effect",void 0),q([t.Property(400)],i.prototype,"duration",void 0),q([t.Property("ease")],i.prototype,"easing",void 0),i}(t.ChildProperty),ie=function(e){function n(i,s){var n=e.call(this,i,s)||this;return n.navIdx=[],n.animation=new t.Animation({}),n.isTapHold=!1,n.tempItem=[],n.showSubMenuOn="Auto",n}return j(n,e),n.prototype.preRender=function(){if(!this.isMenu){var e=void 0;if("EJS-CONTEXTMENU"===this.element.tagName){e=this.createElement("ul",{id:t.getUniqueID(this.getModuleName()),className:"e-control e-lib e-"+this.getModuleName()});var i=t.getValue("ej2_instances",this.element);t.removeClass([this.element],["e-control","e-lib","e-"+this.getModuleName()]),this.clonedElement=this.element,this.element=e,t.setValue("ej2_instances",i,this.element)}else{e=this.createElement("ul",{id:t.getUniqueID(this.getModuleName())}),t.append([].slice.call(this.element.cloneNode(!0).children),e);var s=this.element.nextElementSibling;s?this.element.parentElement.insertBefore(e,s):this.element.parentElement.appendChild(e),this.clonedElement=e}this.clonedElement.style.display="none"}if("EJS-MENU"===this.element.tagName){for(var n=this.element,r=t.getValue("ej2_instances",n),l=(e=this.createElement("ul"),this.createElement("EJS-MENU",{className:"e-"+this.getModuleName()+"-wrapper"})),o=0,a=n.attributes.length;o<a;o++)e.setAttribute(n.attributes[o].nodeName,n.attributes[o].nodeValue);n.parentNode.insertBefore(l,n),t.detach(n),n=e,l.appendChild(n),t.setValue("ej2_instances",r,n),this.clonedElement=l,this.element=n,this.element.id||(this.element.id=t.getUniqueID(this.getModuleName()))}},n.prototype.render=function(){var e=this;this.initialize(),this.renderItems(),this.wireEvents(),this.renderComplete();var t=this.getWrapper();this.template&&this.enableScrolling&&(this.isReact||this.isAngular)&&requestAnimationFrame(function(){o(e.createElement,t,e.element,"hscroll",e.enableRtl)})},n.prototype.initialize=function(){var e=this.getWrapper();e||(e=this.createElement("div",{className:"e-"+this.getModuleName()+"-wrapper"}),this.isMenu?this.element.parentElement.insertBefore(e,this.element):document.body.appendChild(e)),this.cssClass&&t.addClass([e],this.cssClass.split(" ")),this.enableRtl&&e.classList.add("e-rtl"),e.appendChild(this.element),this.isMenu&&this.hamburgerMode&&(this.target||this.createHeaderContainer(e)),this.defaultOption=this.showItemOnClick},n.prototype.renderItems=function(){if(!this.items.length){var e=i.ListBase.createJsonFromElement(this.element,{fields:{child:"items"}});this.setProperties({items:e},!0),t.isBlazor()&&!this.isMenu?this.element=this.removeChildElement(this.element):this.element.innerHTML=""}var s=this.createItems(this.items);if(t.append(Array.prototype.slice.call(s.children),this.element),this.element.classList.add("e-menu-parent"),this.isMenu&&(!this.hamburgerMode&&this.element.classList.contains("e-vertical")&&this.setBlankIconStyle(this.element),this.enableScrolling)){var n=this.getWrapper();this.element.classList.contains("e-vertical")?o(this.createElement,n,this.element,"vscroll",this.enableRtl):o(this.createElement,n,this.element,"hscroll",this.enableRtl)}},n.prototype.wireEvents=function(){var e=this.getWrapper();if(this.target){for(var i=void 0,n=t.selectAll(this.target),r=0,l=n.length;r<l;r++)i=n[r],this.isMenu?t.EventHandler.add(i,"click",this.menuHeaderClickHandler,this):t.Browser.isIos?new t.Touch(i,{tapHold:this.touchHandler.bind(this)}):t.EventHandler.add(i,"contextmenu",this.cmenuHandler,this);if(this.targetElement=i,!this.isMenu){t.EventHandler.add(this.targetElement,"scroll",this.scrollHandler,this);for(var o=0,a=s.getScrollableParent(this.targetElement);o<a.length;o++){var d=a[o];t.EventHandler.add(d,"scroll",this.scrollHandler,this)}}}t.Browser.isDevice||(this.delegateMoverHandler=this.moverHandler.bind(this),this.delegateMouseDownHandler=this.mouseDownHandler.bind(this),t.EventHandler.add(this.isMenu?document:e,"mouseover",this.delegateMoverHandler,this),t.EventHandler.add(document,"mousedown",this.delegateMouseDownHandler,this)),this.delegateClickHandler=this.clickHandler.bind(this),t.EventHandler.add(document,"click",this.delegateClickHandler,this),this.wireKeyboardEvent(e),this.rippleFn=t.rippleEffect(e,{selector:"."+G})},n.prototype.wireKeyboardEvent=function(e){var i={downarrow:K,uparrow:z,enter:"enter",leftarrow:Y,rightarrow:X,escape:"escape"};this.isMenu&&(i.home="home",i.end="end"),new t.KeyboardEvents(e,{keyAction:this.keyBoardHandler.bind(this),keyConfigs:i})},n.prototype.mouseDownHandler=function(e){t.closest(e.target,".e-"+this.getModuleName()+"-wrapper")===this.getWrapper()||t.closest(e.target,".e-"+this.getModuleName()+"-popup")||this.closeMenu(this.isMenu?null:this.navIdx.length,e)},n.prototype.keyBoardHandler=function(e){var i="",s=e.target,n=this.isMenu&&!this.hamburgerMode&&!this.element.classList.contains("e-vertical")&&this.navIdx.length<1;if(e.preventDefault(),this.enableScrolling&&13===e.keyCode&&s.classList.contains("e-scroll-nav")&&this.removeLIStateByClass([F,V],[t.closest(s,".e-"+this.getModuleName()+"-wrapper")]),n)switch(e.action){case X:i=X,e.action=K;break;case Y:i=Y,e.action=z;break;case K:i=K,e.action=X;break;case z:i=z,e.action=""}else if(this.enableRtl)switch(e.action){case Y:n=!0,i=Y,e.action=X;break;case X:n=!0,i=X,e.action=Y}switch(e.action){case K:case z:case"end":case"home":this.upDownKeyHandler(e);break;case X:this.rightEnterKeyHandler(e);break;case Y:this.leftEscKeyHandler(e);break;case"enter":this.hamburgerMode&&"SPAN"===s.tagName&&s.classList.contains("e-menu-icon")?this.menuHeaderClickHandler(e):this.rightEnterKeyHandler(e);break;case"escape":this.leftEscKeyHandler(e)}n&&(e.action=i)},n.prototype.upDownKeyHandler=function(e){var t=this.getUlByNavIdx(),i=e.action===K||"home"===e.action?0:t.childElementCount-1,s=i,n=this.getLIByClass(t,F);n&&("end"!==e.action&&"home"!==e.action&&(s=this.getIdx(t,n)),n.classList.remove(F),"end"!==e.action&&"home"!==e.action&&(e.action===K?s++:s--,s===(e.action===K?t.childElementCount:-1)&&(s=i)));var r=t.children[s];s=this.isValidLI(r,s,e.action),t.children[s].classList.add(F),t.children[s].focus()},n.prototype.isValidLI=function(e,t,i){var s=this.getUlByNavIdx();return(e.classList.contains(_)||e.classList.contains(Q)||e.classList.contains(J))&&(i===K||i===X?t++:t--),((e=s.children[t]).classList.contains(_)||e.classList.contains(Q)||e.classList.contains(J))&&(t=this.isValidLI(e,t,i)),t},n.prototype.getUlByNavIdx=function(e){if(void 0===e&&(e=this.navIdx.length),this.isMenu){var i=[this.getWrapper()].concat([].slice.call(t.selectAll("."+Z)))[e];return t.isNullOrUndefined(i)?null:t.select(".e-menu-parent",i)}return this.getWrapper().children[e]},n.prototype.rightEnterKeyHandler=function(e){var t,i=this.getUlByNavIdx(),s=this.getLIByClass(i,F);if(s){var n=this.getIdx(i,s),r=this.navIdx.concat(n),l=this.getItem(r);l.items.length?(this.navIdx.push(n),this.keyType="right",this.action=e.action,this.openMenu(s,l,-1,-1,e)):"enter"===e.action&&(this.isMenu&&0===this.navIdx.length?this.removeLIStateByClass([V],[this.getWrapper()]):s.classList.remove(F),s.classList.add(V),t={element:s,item:l,event:e},this.trigger("select",t),this.closeMenu(null,e))}},n.prototype.leftEscKeyHandler=function(e){this.navIdx.length?(this.keyType="left",this.closeMenu(this.navIdx.length,e)):"escape"===e.action&&this.closeMenu(null,e)},n.prototype.scrollHandler=function(e){this.closeMenu(null,e)},n.prototype.touchHandler=function(e){this.isTapHold=!0,this.cmenuHandler(e.originalEvent)},n.prototype.cmenuHandler=function(e){e.preventDefault(),this.isCMenu=!0,this.pageX=e.changedTouches?e.changedTouches[0].pageX+1:e.pageX+1,this.pageY=e.changedTouches?e.changedTouches[0].pageY+1:e.pageY+1,this.closeMenu(null,e),this.isCMenu&&(this.canOpen(e.target)&&this.openMenu(null,null,this.pageY,this.pageX,e),this.isCMenu=!1)},n.prototype.closeMenu=function(e,i,n){var r=this;if(void 0===e&&(e=0),void 0===i&&(i=null),this.isMenuVisible()){var l,o,a=void 0,h=this.getWrapper(),c=void 0,p=this.getPopups(),u=!1,f=this.isMenu?p.length+1:h.childElementCount,m=this.isMenu&&1!==f?t.select(".e-ul",p[f-2]):t.selectAll(".e-menu-parent",h)[f-1];if(this.isMenu&&m.classList.contains("e-menu")&&((a=this.getLIByClass(m,V))&&a.classList.remove(V),u=!0),!u){var v=i&&i.target&&this.getLI(i.target);l=this.navIdx.length?this.getItem(this.navIdx):null,o=l?l.items:this.items,c={element:m,parentItem:l,items:o,event:i,cancel:!1,isFocused:!0},this.trigger("beforeClose",c,function(a){var h,c,p,u="",f=!a.cancel;(f||r.isCMenu)&&(r.isMenu?(h=t.closest(m,"."+Z),r.hamburgerMode&&(h.parentElement.style.minHeight="",t.closest(m,".e-menu-item").setAttribute("aria-expanded","false")),r.unWireKeyboardEvent(h),d(t.getInstance(h.children[0],B),h.children[0]),(p=t.getInstance(h,s.Popup)).hide(),u=h.id,p.destroy(),t.detach(h)):r.toggleAnimation(m,!1),c={element:m,parentItem:l,items:o},r.trigger("onClose",c),r.navIdx.pop()),r.updateReactTemplate();var g,y,b,C=r.getWrapper()&&r.getUlByNavIdx();r.isCMenu&&(r.canOpen(i.target)&&r.openMenu(null,null,r.pageY,r.pageX,i),r.isCMenu=!1),r.isMenu&&C&&u.length&&(g=new RegExp("(.*)-ej2menu-"+r.element.id+"-popup").exec(u)[1],y=C.querySelector('[id="'+g+'"]'),b=v&&C.querySelector('[id="'+v.id+'"]'));var E=v&&v.querySelectorAll(".e-menu-item");if(f&&r.hamburgerMode&&e&&!E.length)r.afterCloseMenu(i);else if(f&&!r.hamburgerMode&&r.navIdx.length&&y&&!b&&"left"!==r.keyType){var N=i&&i.target.classList.contains("e-vscroll")?t.closest(i.target,".e-menu-wrapper"):null;N?(N=N.querySelector(".e-menu-item"),(r.showItemOnClick||N&&r.getIndex(N.id,!0).length<=r.navIdx.length)&&r.closeMenu(r.navIdx[r.navIdx.length-1],i,!0)):r.closeMenu(r.navIdx[r.navIdx.length-1],i)}else if(f&&!n&&!e&&(r.hamburgerMode&&r.navIdx.length||1===r.navIdx.length))r.closeMenu(null,i);else if(f&&t.isNullOrUndefined(e)&&r.navIdx.length)r.closeMenu(null,i);else if(!f||r.isMenu||e||0!==r.navIdx.length||r.isMenusClosed)if(f&&r.isMenu&&i&&i.target&&0!==r.navIdx.length&&t.closest(i.target,".e-menu-parent.e-control"))r.closeMenu(0,i);else{if(!f||"right"!==r.keyType&&"click"!==r.keyType){var x=r.getUlByNavIdx(),O=r.getLIByClass(x,V);if(O&&(O.setAttribute("aria-expanded","false"),O.classList.remove(V),(a.isFocused&&v||"left"===r.keyType)&&(O.classList.add(F),O.focus())),!f&&r.hamburgerMode&&v&&"false"===v.getAttribute("aria-expanded")&&"true"===v.getAttribute("aria-haspopup")){t.closest(v,".e-menu-parent.e-control")?r.navIdx=[]:r.navIdx.pop(),r.navIdx.push(r.cliIdx);var I=r.getItem(r.navIdx);v.setAttribute("aria-expanded","true"),r.openMenu(v,I,-1,-1,i)}}else r.afterCloseMenu(i);r.navIdx.length<1&&("Hover"!==r.showSubMenuOn&&"Click"!==r.showSubMenuOn||(r.showItemOnClick=r.defaultOption,r.showSubMenuOn="Auto"))}else r.isMenusClosed=!0,r.closeMenu(0,i);r.removeStateWrapper()})}}},n.prototype.updateReactTemplate=function(){if(this.isReact&&this.template&&0===this.navIdx.length){var e=this.portals.splice(0,this.items.length);this.clearTemplate(["template"]),this.portals=e,this.renderReactTemplates()}},n.prototype.getMenuItemModel=function(e,i){if(t.isNullOrUndefined(e))return null;t.isNullOrUndefined(i)&&(i=0);var s=this.getFields(i);return{text:e[s.text],id:e[s.id],items:e[s.child],separator:e[s.separator],iconCss:e[s.iconCss],url:e[s.url]}},n.prototype.getPopups=function(){var e=this,i=[];return[].slice.call(document.querySelectorAll("."+Z)).forEach(function(s){!t.isNullOrUndefined(s.querySelector("."+G))&&e.getIndex(s.querySelector("."+G).id,!0).length&&i.push(s)}),i},n.prototype.isMenuVisible=function(){return this.navIdx.length>0||this.element.classList.contains("e-contextmenu")&&t.isVisible(this.element).valueOf()},n.prototype.canOpen=function(e){var i=!0;if(this.filter){i=!1;for(var s=this.filter.split(" "),n=0,r=s.length;n<r;n++)if(t.closest(e,"."+s[n])){i=!0;break}}return i},n.prototype.openMenu=function(e,i,n,r,l,o){var a=this;void 0===n&&(n=0),void 0===r&&(r=0),void 0===l&&(l=null),void 0===o&&(o=this.targetElement);var d=this.getWrapper();this.lItem=e;var h=""!==this.element.id?this.element.id:"menu";if(this.isMenusClosed=!1,t.isNullOrUndefined(n)&&(n=-1),t.isNullOrUndefined(r)&&(r=-1),e){if(this.uList=this.createItems(i[this.getField("children",this.navIdx.length-1)]),!this.isMenu&&t.Browser.isDevice){d.lastChild.style.display="none";var c={text:i[this.getField("text")].toString(),iconCss:"e-icons e-previous"},p=new ee(this.items[0],"items",c,!0),u=this.createItems([p]).children[0];u.classList.add(W),this.uList.insertBefore(u,this.uList.children[0])}this.isMenu?(this.popupWrapper=this.createElement("div",{className:"e-"+this.getModuleName()+"-wrapper "+Z,id:e.id+"-ej2menu-"+h+"-popup"}),this.hamburgerMode?(n=e.offsetHeight,e.appendChild(this.popupWrapper)):document.body.appendChild(this.popupWrapper),this.isNestedOrVertical=this.element.classList.contains("e-vertical")||1!==this.navIdx.length,this.popupObj=this.generatePopup(this.popupWrapper,this.uList,e,this.isNestedOrVertical),this.template&&this.renderReactTemplates(),this.hamburgerMode?this.calculateIndentSize(this.uList,e):(this.cssClass&&t.addClass([this.popupWrapper],this.cssClass.split(" ")),this.popupObj.hide()),this.hamburgerMode||this.showItemOnClick||!this.hoverDelay?this.triggerBeforeOpen(e,this.uList,i,l,0,0,"menu"):(window.clearInterval(this.timer),this.timer=window.setTimeout(function(){a.triggerBeforeOpen(e,a.uList,i,l,0,0,"menu")},this.hoverDelay))):(this.uList.style.zIndex=this.element.style.zIndex,d.appendChild(this.uList),!this.showItemOnClick&&this.hoverDelay?(window.clearInterval(this.timer),this.timer=window.setTimeout(function(){a.triggerBeforeOpen(e,a.uList,i,l,n,r,"none")},this.hoverDelay)):this.triggerBeforeOpen(e,this.uList,i,l,n,r,"none"))}else this.uList=this.element,this.uList.style.zIndex=s.getZindexPartial(o||this.element).toString(),this.triggerBeforeOpen(e,this.uList,i,l,n,r,"none")},n.prototype.calculateIndentSize=function(e,t){var i=getComputedStyle(t),s=parseInt(i.textIndent,10);this.navIdx.length<2&&!t.classList.contains("e-blankicon")?s*=2:s+=s/4,e.style.textIndent=s+"px";var n=e.querySelectorAll(".e-blankicon");if(n&&n.length)for(var r=e.querySelector(".e-menu-icon"),l=getComputedStyle(r),o=parseInt(l.marginRight,10)+r.offsetWidth+s,a=0;a<n.length;a++)n[a].style.textIndent=o+"px"},n.prototype.generatePopup=function(e,i,n,r){var l=this,o=new s.Popup(e,{actionOnScroll:this.hamburgerMode?"none":"reposition",relateTo:n,collision:this.hamburgerMode?{X:"none",Y:"none"}:{X:r||this.enableRtl?"none":"flip",Y:"fit"},position:r&&!this.hamburgerMode?{X:"right",Y:"top"}:{X:"left",Y:"bottom"},targetType:"relative",enableRtl:this.enableRtl,content:i,open:function(){var e=t.select(".e-menu-vscroll",o.element);e&&(e.style.height="inherit",e.style.maxHeight="");var i=t.select(".e-ul",o.element);o.element.style.maxHeight="",i.focus(),l.triggerOpen(i)}});return o},n.prototype.createHeaderContainer=function(e){e=e||this.getWrapper();var i=this.createElement("span",{className:"e-"+this.getModuleName()+"-header"}),s=this.enableHtmlSanitizer?t.SanitizeHtmlHelper.sanitize(this.title):this.title,n=this.createElement("span",{className:"e-"+this.getModuleName()+"-title",innerHTML:s}),r=this.createElement("span",{className:"e-icons e-"+this.getModuleName()+"-icon",attrs:{tabindex:"0"}});i.appendChild(n),i.appendChild(r),e.insertBefore(i,this.element)},n.prototype.openHamburgerMenu=function(e){this.hamburgerMode&&this.triggerBeforeOpen(null,this.element,null,e,0,0,"hamburger")},n.prototype.closeHamburgerMenu=function(e){var t=this,i={element:this.element,parentItem:null,event:e,items:this.items,cancel:!1};this.trigger("beforeClose",i,function(i){i.cancel||(t.closeMenu(null,e),t.element.classList.add("e-hide-menu"),t.trigger("onClose",{element:t.element,parentItem:null,items:t.items}))})},n.prototype.callFit=function(e,t,i,n,r){return s.fit(e,null,{X:t,Y:i},{top:n,left:r})},n.prototype.triggerBeforeOpen=function(e,i,s,n,r,l,a){var d=this,h=e?s[this.getField("children",this.navIdx.length-1)]:this.items,c={element:i,items:h,parentItem:s,event:n,cancel:!1,top:r,left:l,showSubMenuOn:"Auto"},p=a;this.trigger("beforeOpen",c,function(r){switch(p){case"menu":d.hamburgerMode||("Auto"!==r.showSubMenuOn&&(d.showItemOnClick=!d.defaultOption,d.showSubMenuOn=r.showSubMenuOn),d.top=r.top,d.left=r.left),d.popupWrapper.style.display="block",d.hamburgerMode||(d.popupWrapper.style.maxHeight=d.popupWrapper.getBoundingClientRect().height+"px",d.enableScrolling&&o(d.createElement,d.popupWrapper,d.uList,"vscroll",d.enableRtl),d.checkScrollOffset(n)),d.hamburgerMode||d.left||d.top?(d.popupObj.collision={X:"none",Y:"none"},d.popupWrapper.style.display=""):(d.popupObj.refreshPosition(d.lItem,!0),d.left=parseInt(d.popupWrapper.style.left,10),d.top=parseInt(d.popupWrapper.style.top,10),d.enableRtl&&(d.left=d.isNestedOrVertical?d.left-d.popupWrapper.offsetWidth-d.lItem.parentElement.offsetWidth+2:d.left-d.popupWrapper.offsetWidth+d.lItem.offsetWidth),d.template&&(d.isReact||d.isAngular)?requestAnimationFrame(function(){d.collision(),d.popupWrapper.style.display=""}):(d.collision(),d.popupWrapper.style.display=""));break;case"none":d.top=r.top,d.left=r.left;break;case"hamburger":r.cancel||(d.element.classList.remove("e-hide-menu"),d.triggerOpen(d.element))}if("hamburger"!==p)if(r.cancel)d.isMenu?(d.popupObj.destroy(),t.detach(d.popupWrapper)):i.className.indexOf("e-ul")>-1&&t.detach(i),d.navIdx.pop();else if(d.isMenu)if(d.hamburgerMode)d.popupWrapper.style.top=d.top+"px",d.popupWrapper.style.left="0px",d.toggleAnimation(d.popupWrapper);else{d.setBlankIconStyle(d.popupWrapper),d.wireKeyboardEvent(d.popupWrapper),t.rippleEffect(d.popupWrapper,{selector:"."+G}),"fixed"===d.popupWrapper.style.position&&d.top>0?(d.popupWrapper.style.left=d.left+"px",d.popupWrapper.style.top=d.top+scrollY+"px"):(d.popupWrapper.style.left=d.left+"px",d.popupWrapper.style.top=d.top+"px");var l="None"!==d.animationSettings.effect?{name:d.animationSettings.effect,duration:d.animationSettings.duration,timingFunction:d.animationSettings.easing}:null;d.popupObj.show(l,d.lItem)}else d.setBlankIconStyle(d.uList),d.setPosition(d.lItem,d.uList,d.top,d.left),d.toggleAnimation(d.uList);if("right"===d.keyType){var a=d.getUlByNavIdx();if(e.classList.remove(F),d.isMenu&&1===d.navIdx.length&&d.removeLIStateByClass([V],[d.getWrapper()]),e.classList.add(V),"enter"===d.action){var h={element:e,item:s,event:n};d.trigger("select",h)}e.focus(),a=d.getUlByNavIdx();var c=d.isValidLI(a.children[0],0,d.action);a.children[c].classList.add(F),a.children[c].focus()}})},n.prototype.collision=function(){var e;if(e=s.isCollide(this.popupWrapper,null,this.left,this.top),(this.isNestedOrVertical||this.enableRtl)&&(e.indexOf("right")>-1||e.indexOf("left")>-1)){this.popupObj.collision.X="none";var i=t.closest(this.lItem,".e-"+this.getModuleName()+"-wrapper").offsetWidth;this.left=this.enableRtl?s.calculatePosition(this.lItem,this.isNestedOrVertical?"right":"left","top").left:this.left-this.popupWrapper.offsetWidth-i+2}((e=s.isCollide(this.popupWrapper,null,this.left,this.top)).indexOf("left")>-1||e.indexOf("right")>-1)&&(this.left=this.callFit(this.popupWrapper,!0,!1,this.top,this.left).left),this.popupWrapper.style.left=this.left+"px"},n.prototype.setBlankIconStyle=function(e){var t=[].slice.call(e.getElementsByClassName("e-blankicon"));if(t.length){var i=e.querySelector(".e-menu-item:not(.e-blankicon):not(.e-separator)"),s=i.querySelector(".e-menu-icon");if(s){var n=this.enableRtl?{padding:"paddingRight",margin:"marginLeft"}:{padding:"paddingLeft",margin:"marginRight"},r=getComputedStyle(s),l=parseInt(r.fontSize,10);parseInt(r.width,10)&&parseInt(r.width,10)>l&&(l=parseInt(r.width,10));var o=l+parseInt(r[n.margin],10)+parseInt(getComputedStyle(i)[n.padding],10)+"px";t.forEach(function(e){e.style[n.padding]=o})}}},n.prototype.checkScrollOffset=function(e){var i=this.getWrapper();if(i.children[0].classList.contains("e-menu-hscroll")&&1===this.navIdx.length){var s=t.isNullOrUndefined(e)?this.element:t.closest(e.target,"."+G),n=t.select(".e-hscroll-bar",i);n.scrollLeft>s.offsetLeft&&(n.scrollLeft-=n.scrollLeft-s.offsetLeft);var r=n.scrollLeft+n.offsetWidth,l=s.offsetLeft+s.offsetWidth;r<l&&(n.scrollLeft+=l-r)}},n.prototype.setPosition=function(e,i,n,r){if(this.toggleVisiblity(i),i===this.element||r>-1&&n>-1){if((d=s.isCollide(i,null,r,n)).indexOf("right")>-1&&(r-=i.offsetWidth),d.indexOf("bottom")>-1){if((n=(o=this.callFit(i,!1,!0,n,r)).top-20)<0){var l=pageYOffset+document.documentElement.clientHeight-i.getBoundingClientRect().height;l>-1&&(n=l)}}if((d=s.isCollide(i,null,r,n)).indexOf("left")>-1){r=(o=this.callFit(i,!0,!1,n,r)).left}}else if(t.Browser.isDevice)n=Number(this.element.style.top.replace("px","")),r=Number(this.element.style.left.replace("px",""));else{var o,a=this.enableRtl?"left":"right";n=(o=s.calculatePosition(e,a,"top")).top,r=o.left;var d,h=(d=s.isCollide(i,null,this.enableRtl?r-i.offsetWidth:r,n)).indexOf("left")>-1||d.indexOf("right")>-1;h&&(r=(o=s.calculatePosition(e,this.enableRtl?"right":"left","top")).left),(this.enableRtl||h)&&(r=this.enableRtl&&h?r:r-i.offsetWidth),d.indexOf("bottom")>-1&&(n=(o=this.callFit(i,!1,!0,n,r)).top)}this.toggleVisiblity(i,!1),i.style.top=n+"px",i.style.left=r+"px"},n.prototype.toggleVisiblity=function(e,t){void 0===t&&(t=!0),e.style.visibility=t?"hidden":"",e.style.display=t?"block":"none"},n.prototype.createItems=function(e){var s=this,n=this.navIdx?this.navIdx.length:0,r=this.getFields(n),l=this.hasField(e,this.getField("iconCss",n)),o={showIcon:l,moduleName:"menu",fields:r,template:this.template,itemNavigable:!0,itemCreating:function(e){e.curData[e.fields[r.id]]||(e.curData[e.fields[r.id]]=t.getUniqueID("menuitem")),e.curData.htmlAttributes={role:"menuitem",tabindex:"-1"},s.isMenu&&!e.curData[s.getField("separator",n)]&&(e.curData.htmlAttributes["aria-label"]=e.curData[e.fields.text]),""===e.curData[e.fields[r.iconCss]]&&(e.curData[e.fields[r.iconCss]]=null)},itemCreated:function(e){if(e.curData[s.getField("separator",n)]&&(e.item.classList.add(_),e.item.removeAttribute("role")),!l||e.curData[e.fields.iconCss]||e.curData[s.getField("separator",n)]||e.item.classList.add("e-blankicon"),e.curData[e.fields.child]&&e.curData[e.fields.child].length){var t=s.createElement("span",{className:"e-icons e-caret"});e.item.appendChild(t),e.item.setAttribute("aria-haspopup","true"),e.item.setAttribute("aria-expanded","false"),s.isMenu||e.item.removeAttribute("role"),e.item.classList.add("e-menu-caret-icon")}s.isMenu&&s.template&&(e.item.setAttribute("id",e.curData[e.fields.id].toString()),e.item.removeAttribute("data-uid"),e.item.classList.contains("e-level-1")&&e.item.classList.remove("e-level-1"),e.item.classList.contains("e-has-child")&&e.item.classList.remove("e-has-child"));var i={item:e.curData,element:e.item};s.trigger("beforeItemRender",i)}};this.setProperties({items:this.items},!0),this.isMenu&&(o.templateID=this.element.id+"Template");var a=i.ListBase.createList(this.createElement,e,o,!this.template,this);return a.setAttribute("tabindex","0"),this.isMenu&&a.setAttribute("role","menu"),a},n.prototype.moverHandler=function(e){var i=e.target;this.liTrgt=i;var s=this.getLI(i),n=s?t.closest(s,".e-"+this.getModuleName()+"-wrapper"):this.getWrapper(),r=this.getWrapper(),l=new RegExp("-ej2menu-(.*)-popup"),o=!1;if(n){if((""!==n.id?l.exec(n.id)[1]:n.querySelector("ul").id)!==this.element.id){if(this.removeLIStateByClass([F,V],[this.getWrapper()]),!this.navIdx.length)return;o=!0}s&&t.closest(s,".e-"+this.getModuleName()+"-wrapper")&&!o?(this.removeLIStateByClass([F],this.isMenu?[n].concat(this.getPopups()):[n]),this.removeLIStateByClass([F],this.isMenu?[r].concat(this.getPopups()):[r]),s.classList.add(F),this.showItemOnClick||this.clickHandler(e)):this.isMenu&&this.showItemOnClick&&!o&&this.removeLIStateByClass([F],[n].concat(this.getPopups())),this.isMenu&&(this.showItemOnClick||i.parentElement===n||t.closest(i,".e-"+this.getModuleName()+"-popup")||s&&(!s||this.getIndex(s.id,!0).length)||"Hover"===this.showSubMenuOn?o&&!this.showItemOnClick&&this.navIdx.length&&(this.isClosed=!0,this.closeMenu(null,e)):(this.removeLIStateByClass([F],[n]),this.navIdx.length&&(this.isClosed=!0,this.closeMenu(null,e))),this.isClosed||this.removeStateWrapper(),this.isClosed=!1)}},n.prototype.removeStateWrapper=function(){if(this.liTrgt){var e=t.closest(this.liTrgt,".e-menu-vscroll");"DIV"===this.liTrgt.tagName&&e&&this.removeLIStateByClass([F,V],[e])}},n.prototype.removeLIStateByClass=function(e,i){for(var s,n=function(n){e.forEach(function(e){(s=t.select("."+e,i[n]))&&s.classList.remove(e)})},r=0;r<i.length;r++)n(r)},n.prototype.getField=function(e,t){void 0===t&&(t=0);var i=this.fields[e];return"string"==typeof i?i:i[t]?i[t].toString():i[i.length-1].toString()},n.prototype.getFields=function(e){return void 0===e&&(e=0),{id:this.getField("itemId",e),iconCss:this.getField("iconCss",e),text:this.getField("text",e),url:this.getField("url",e),child:this.getField("children",e),separator:this.getField("separator",e)}},n.prototype.hasField=function(e,t){for(var i=0,s=e.length;i<s;i++)if(e[i][t])return!0;return!1},n.prototype.menuHeaderClickHandler=function(e){t.closest(e.target,".e-menu-wrapper").querySelector("ul.e-menu-parent").id===this.element.id&&(this.element.classList.contains("e-hide-menu")?this.openHamburgerMenu(e):this.closeHamburgerMenu(e))},n.prototype.clickHandler=function(e){if(this.isTapHold)this.isTapHold=!1;else{var i=this.getWrapper(),s=e.target,n=this.cli=this.getLI(s),r=new RegExp("-ej2menu-(.*)-popup"),l=n?t.closest(n,".e-"+this.getModuleName()+"-wrapper"):null,o=n&&l&&(this.isMenu?this.getIndex(n.id,!0).length>0:i.firstElementChild.id===l.firstElementChild.id);if(t.Browser.isDevice&&this.isMenu&&(this.removeLIStateByClass([F],[i].concat(this.getPopups())),this.mouseDownHandler(e)),n&&l&&this.isMenu){var a=l.id?r.exec(l.id)[1]:l.querySelector(".e-menu-parent").id;if(this.element.id!==a)return}if(o&&"click"===e.type&&!n.classList.contains(W)){this.setLISelected(n);var d=this.getIndex(n.id,!0),h={element:n,item:this.getItem(d),event:e};this.trigger("select",h)}if(o&&("mouseover"===e.type||t.Browser.isDevice||this.showItemOnClick)){var c=void 0;if(n.classList.contains(W)){c=i.children[this.navIdx.length-1],this.toggleAnimation(c);(f=this.getLIByClass(c,V))&&f.classList.remove(V),t.detach(n.parentNode),this.navIdx.pop()}else if(!n.classList.contains(_)){this.showSubMenu=!0;var p=n.parentNode;if(this.cliIdx=this.getIdx(p,n),this.isMenu||!t.Browser.isDevice){var u=this.isMenu?Array.prototype.indexOf.call([i].concat(this.getPopups()),t.closest(p,".e-"+this.getModuleName()+"-wrapper")):this.getIdx(i,p);if(this.navIdx[u]===this.cliIdx&&(this.showSubMenu=!1),u!==this.navIdx.length&&("mouseover"!==e.type||this.showSubMenu)){var f;(f=this.getLIByClass(p,V))&&f.classList.remove(V),this.isClosed=!0,this.keyType="click",this.showItemOnClick&&this.setLISelected(n),this.closeMenu(u+1,e),this.showItemOnClick&&this.setLISelected(n)}}this.isClosed||this.afterCloseMenu(e),this.isClosed=!1}}else if(this.isMenu&&"DIV"===s.tagName&&this.navIdx.length&&t.closest(s,".e-menu-vscroll")){var m=t.closest(s,"."+Z),v=Array.prototype.indexOf.call(this.getPopups(),m)+1;v<this.navIdx.length&&(this.closeMenu(v+1,e),m&&this.removeLIStateByClass([F,V],[m]))}else this.isMenu&&this.hamburgerMode&&"SPAN"===s.tagName&&s.classList.contains("e-menu-icon")?this.menuHeaderClickHandler(e):"UL"===s.tagName&&(this.isMenu?!s.parentElement.classList.contains("e-menu-wrapper")||this.getIndex(s.querySelector("."+G).id,!0).length:s.parentElement===i)||(n||this.removeLIStateByClass([V],[i]),n&&n.querySelector(".e-caret")||this.closeMenu(null,e))}},n.prototype.afterCloseMenu=function(e){var i;if(this.showSubMenu){i=this.showItemOnClick&&0===this.navIdx.length?t.closest(e.target,".e-menu-parent.e-control"):t.closest(this.element,".e-menu-parent.e-control");var s=this.navIdx.concat(this.cliIdx),n=this.getItem(s);if(n&&n[this.getField("children",s.length-1)]&&n[this.getField("children",s.length-1)].length?(("mouseover"===e.type||t.Browser.isDevice&&this.isMenu)&&this.setLISelected(this.cli),(!this.hamburgerMode&&i||this.hamburgerMode&&"false"===this.cli.getAttribute("aria-expanded"))&&(this.cli.setAttribute("aria-expanded","true"),this.navIdx.push(this.cliIdx),this.openMenu(this.cli,n,null,null,e))):"mouseover"!==e.type&&this.closeMenu(null,e),!i){var r=this.getUlByNavIdx(),l=this.getLIByClass(r,V);l&&(l.setAttribute("aria-expanded","false"),l.classList.remove(V))}}this.keyType=""},n.prototype.setLISelected=function(e){var t=this.getLIByClass(e.parentElement,V);t&&t.classList.remove(V),this.isMenu||e.classList.remove(F),e.classList.add(V)},n.prototype.getLIByClass=function(e,t){for(var i=0,s=e.children.length;i<s;i++)if(e.children[i].classList.contains(t))return e.children[i];return null},n.prototype.getItemIndex=function(e,t){var i;i="string"==typeof e?e:e.id;var s=!1!==t;return this.getIndex(i,s)},n.prototype.setItem=function(e,t,i){var s;s=i?t||e.id:t||e.text;var n=this.getIndex(s,i),r=this.getItem(n);r.iconCss=e.iconCss||r.iconCss,r.text=e.text||r.text,r.url=e.url||r.url,r.separator=e.separator||r.separator},n.prototype.getItem=function(e){var t=(e=e.slice()).pop();return this.getItems(e)[t]},n.prototype.getItems=function(e){for(var t=this.items,i=0;i<e.length;i++)t=t[e[i]][this.getField("children",i)];return t},n.prototype.setItems=function(e,t){var i=this.getItems(t);i.splice(0,i.length);for(var s=0;s<e.length;s++)i.splice(s,0,e[s])},n.prototype.getIdx=function(e,t,i){void 0===i&&(i=!0);var s=Array.prototype.indexOf.call(e.children,t);return i&&e.children[0].classList.contains(W)&&s--,s},n.prototype.getLI=function(e){return"LI"===e.tagName&&e.classList.contains("e-menu-item")?e:t.closest(e,"li.e-menu-item")},n.prototype.updateItemsByNavIdx=function(){for(var e=this.items,t=0,i=0;i<this.navIdx.length&&(e=e[i].items);i++){t++;var s=this.getUlByNavIdx(t);if(!s)break;this.updateItem(s,e)}},n.prototype.removeChildElement=function(e){for(;e.firstElementChild;)e.removeChild(e.firstElementChild);return e},n.prototype.onPropertyChanged=function(e,i){for(var s=this,n=this.getWrapper(),r=function(r){switch(r){case"cssClass":i.cssClass&&t.removeClass([n],i.cssClass.split(" ")),e.cssClass&&t.addClass([n],e.cssClass.split(" "));break;case"enableRtl":n.classList.toggle("e-rtl");break;case"showItemOnClick":l.unWireEvents(),l.showItemOnClick=e.showItemOnClick,l.wireEvents();break;case"enableScrolling":if(e.enableScrolling){var a;l.element.classList.contains("e-vertical")?o(l.createElement,n,l.element,"vscroll",l.enableRtl):o(l.createElement,n,l.element,"hscroll",l.enableRtl),l.getPopups().forEach(function(e){a=t.select(".e-ul",e),o(s.createElement,e,a,"vscroll",s.enableRtl)})}else{var h=n.children[0];l.element.classList.contains("e-vertical")?d(t.getInstance(h,B),h):d(t.getInstance(h,O),h),n.style.overflow="",n.appendChild(l.element),l.getPopups().forEach(function(e){h=e.children[0],d(t.getInstance(h,B),h),e.style.overflow=""})}break;case"items":var c=void 0,p=void 0,u=void 0;if(Object.keys(i.items).length){var f=Object.keys(e.items);for(m=0;m<f.length;m++)(p=l.getChangedItemIndex(e,[],Number(f[m]))).length<=l.getWrapper().children.length&&(c=p.pop(),u=l.getItems(p),l.insertAfter([u[c]],u[c].text),l.removeItem(u,p,c),l.setItems(u,p)),p.length=0}else{if(l.updateItem(l.element,l.items),!l.hamburgerMode)for(var m=1,v=n.childElementCount;m<v;m++)t.detach(n.lastElementChild);l.navIdx=[]}}},l=this,a=0,h=Object.keys(e);a<h.length;a++){r(h[a])}},n.prototype.updateItem=function(e,i){t.isBlazor()&&!this.isMenu?e=this.removeChildElement(e):e.innerHTML="";[].slice.call(this.createItems(i).children).forEach(function(t){e.appendChild(t)})},n.prototype.getChangedItemIndex=function(e,t,i){t.push(i);var s=Object.keys(e.items[i]).pop();if("items"===s){var n=e.items[i],r=Object.keys(n.items).pop();r&&this.getChangedItemIndex(n,t,Number(r))}else"isParentArray"===s&&t.length>1&&t.pop();return t},n.prototype.removeItem=function(e,i,s){e.splice(s,1);var n=this.getWrapper().children;i.length<n.length&&t.detach(n[i.length].children[s])},n.prototype.unWireEvents=function(e){void 0===e&&(e=this.target);var i=this.getWrapper();if(e){for(var n=void 0,r=void 0,l=t.selectAll(e),o=0,a=l.length;o<a;o++)n=l[o],this.isMenu?t.EventHandler.remove(n,"click",this.menuHeaderClickHandler):t.Browser.isIos?(r=t.getInstance(n,t.Touch))&&r.destroy():t.EventHandler.remove(n,"contextmenu",this.cmenuHandler);if(!this.isMenu){t.EventHandler.remove(this.targetElement,"scroll",this.scrollHandler);for(var d=0,h=s.getScrollableParent(this.targetElement);d<h.length;d++){var c=h[d];t.EventHandler.remove(c,"scroll",this.scrollHandler)}}}t.Browser.isDevice||(t.EventHandler.remove(this.isMenu?document:i,"mouseover",this.delegateMoverHandler),t.EventHandler.remove(document,"mousedown",this.delegateMouseDownHandler)),t.EventHandler.remove(document,"click",this.delegateClickHandler),this.unWireKeyboardEvent(i),this.rippleFn()},n.prototype.unWireKeyboardEvent=function(e){var i=t.getInstance(e,t.KeyboardEvents);i&&i.destroy()},n.prototype.toggleAnimation=function(e,t){var i=this;void 0===t&&(t=!0);var s,n;"None"!==this.animationSettings.effect&&t?this.animation.animate(e,{name:this.animationSettings.effect,duration:this.animationSettings.duration,timingFunction:this.animationSettings.easing,begin:function(e){i.hamburgerMode?(n=e.element.parentElement,e.element.style.position="absolute",s=n.offsetHeight,e.element.style.maxHeight=e.element.offsetHeight+"px",n.style.maxHeight=""):(e.element.style.display="block",e.element.style.maxHeight=e.element.getBoundingClientRect().height+"px")},progress:function(e){i.hamburgerMode&&(n.style.minHeight=s+e.element.offsetHeight+"px")},end:function(e){i.hamburgerMode?(e.element.style.position="",e.element.style.maxHeight="",n.style.minHeight="",e.element.style.top="0px",e.element.children[0].focus(),i.triggerOpen(e.element.children[0])):i.end(e.element,t)}}):this.end(e,t)},n.prototype.triggerOpen=function(e){var t=this.navIdx.length?this.getItem(this.navIdx):null,i={element:e,parentItem:t,items:t?t.items:this.items};this.trigger("onOpen",i)},n.prototype.end=function(e,i){if(i)if(e.style.display="block",e.style.maxHeight="",this.triggerOpen(e),e.querySelector("."+F))e.querySelector("."+F).focus();else{var s=this.getWrapper().children[this.getIdx(this.getWrapper(),e)-1];s?s.querySelector("."+V).focus():this.element.focus()}else if(e===this.element){var n=this.getLIByClass(this.element,F);n&&n.classList.remove(F);var r=this.getLIByClass(this.element,V);r&&r.classList.remove(V),e.style.display="none"}else t.detach(e)},n.prototype.getPersistData=function(){return""},n.prototype.getWrapper=function(){return t.closest(this.element,".e-"+this.getModuleName()+"-wrapper")},n.prototype.getIndex=function(e,t,i,s,n,r){void 0===i&&(i=this.items),void 0===s&&(s=[]),void 0===n&&(n=!1),void 0===r&&(r=0);var l;r=n?r+1:0;for(var o=0,a=i.length;o<a;o++){if(l=i[o],(t?l[this.getField("itemId",r)]:l[this.getField("text",r)])===e){s.push(o);break}if(l[this.getField("children",r)]&&l[this.getField("children",r)].length){if(-1!==(s=this.getIndex(e,t,l[this.getField("children",r)],s,!0,r))[s.length-1]){s.unshift(o);break}o!==a-1&&s.pop()}else o===a-1&&s.push(-1)}return n||-1!==s[0]?s:[]},n.prototype.enableItems=function(e,i,s){void 0===i&&(i=!0);for(var n,r,l,o,a=Q,d=0;d<e.length;d++){if(l=this.getIndex(e[d],s),this.navIdx.length){if(1!==l.length){o=!1;for(var h=0,c=l.length-1;h<c;h++)if(l[h]!==this.navIdx[h]){o=!0;break}if(o)continue}}else if(1!==l.length)continue;r=l.pop(),(n=this.getUlByNavIdx(l.length))&&(i?this.isMenu?(n.children[r].classList.remove(a),n.children[r].removeAttribute("aria-disabled")):t.Browser.isDevice&&!n.classList.contains("e-contextmenu")?n.children[r+1].classList.remove(a):n.children[r].classList.remove(a):this.isMenu?(n.children[r].classList.add(a),n.children[r].setAttribute("aria-disabled","true")):t.Browser.isDevice&&!n.classList.contains("e-contextmenu")?n.children[r+1].classList.add(a):n.children[r].classList.add(a))}},n.prototype.showItems=function(e,t){this.showHideItems(e,!1,t)},n.prototype.hideItems=function(e,t){this.showHideItems(e,!0,t)},n.prototype.showHideItems=function(e,i,s){for(var n,r,l,o=0;o<e.length;o++)r=(l=this.getIndex(e[o],s)).pop(),(n=this.getUlByNavIdx(l.length))&&(i?t.Browser.isDevice&&!n.classList.contains("e-contextmenu")?n.children[r+1].classList.add(J):n.children[r].classList.add(J):t.Browser.isDevice&&!n.classList.contains("e-contextmenu")?n.children[r+1].classList.remove(J):n.children[r].classList.remove(J))},n.prototype.removeItems=function(e,t){for(var i,s,n,r=0;r<e.length;r++)i=(s=this.getIndex(e[r],t)).pop(),n=this.getItems(s),this.removeItem(n,s,i)},n.prototype.insertAfter=function(e,t,i){this.insertItems(e,t,i)},n.prototype.insertBefore=function(e,t,i){this.insertItems(e,t,i,!1)},n.prototype.insertItems=function(e,i,s,n){void 0===n&&(n=!0);for(var r,l,o,a,d,h=0;h<e.length;h++){l=(o=this.getIndex(i,s)).pop(),a=this.getItems(o),d=new ee(a[0],"items",e[h],!0),a.splice(n?l+1:l,0,d);var c=this.isMenu?[this.getWrapper()].concat(this.getPopups()):[].slice.call(this.getWrapper().children);if(o.length<c.length){l=n?l+1:l,r=this.createItems(a).children[l];var p=this.isMenu?t.select(".e-menu-parent",c[o.length]):c[o.length];p.insertBefore(r,p.children[l])}}},n.prototype.removeAttributes=function(){var e=this;["top","left","display","z-index"].forEach(function(t){e.element.style.removeProperty(t)}),["role","tabindex","class","style"].forEach(function(t){"class"===t&&e.element.classList.contains("e-menu-parent")&&e.element.classList.remove("e-menu-parent"),-1!==["class","style"].indexOf(t)&&e.element.getAttribute(t)||e.element.removeAttribute(t),e.isMenu&&"class"===t&&e.element.classList.contains("e-vertical")&&e.element.classList.remove("e-vertical")})},n.prototype.destroy=function(){var i=this.getWrapper();if(i){if(this.unWireEvents(),this.isMenu)this.closeMenu(),t.isBlazor()&&!this.isMenu?this.element=this.removeChildElement(this.element):this.element.innerHTML="",this.removeAttributes(),i.parentNode.insertBefore(this.element,i),this.clonedElement=null;else{if(this.clonedElement.style.display="","EJS-CONTEXTMENU"===this.clonedElement.tagName)t.addClass([this.clonedElement],["e-control","e-lib","e-"+this.getModuleName()]),this.element=this.clonedElement;else if(this.refreshing&&this.clonedElement.childElementCount&&"LI"===this.clonedElement.children[0].tagName&&this.setProperties({items:[]},!0),document.getElementById(this.clonedElement.id)){var s=this.clonedElement.nextElementSibling;s&&s!==i?this.clonedElement.parentElement.insertBefore(this.element,s):this.clonedElement.parentElement.appendChild(this.element),t.isBlazor()&&!this.isMenu?this.element=this.removeChildElement(this.element):this.element.innerHTML="",t.append([].slice.call(this.clonedElement.children),this.element),t.detach(this.clonedElement),this.removeAttributes()}this.clonedElement=null}this.isMenu&&this.clonedElement?(t.detach(this.element),i.style.display="",i.classList.remove("e-"+this.getModuleName()+"-wrapper"),i.removeAttribute("data-ripple")):t.detach(i),e.prototype.destroy.call(this),this.template&&this.clearTemplate(["template"])}},q([t.Event()],n.prototype,"beforeItemRender",void 0),q([t.Event()],n.prototype,"beforeOpen",void 0),q([t.Event()],n.prototype,"onOpen",void 0),q([t.Event()],n.prototype,"beforeClose",void 0),q([t.Event()],n.prototype,"onClose",void 0),q([t.Event()],n.prototype,"select",void 0),q([t.Event()],n.prototype,"created",void 0),q([t.Property("")],n.prototype,"cssClass",void 0),q([t.Property(0)],n.prototype,"hoverDelay",void 0),q([t.Property(!1)],n.prototype,"showItemOnClick",void 0),q([t.Property("")],n.prototype,"target",void 0),q([t.Property("")],n.prototype,"filter",void 0),q([t.Property(null)],n.prototype,"template",void 0),q([t.Property(!1)],n.prototype,"enableScrolling",void 0),q([t.Property(!1)],n.prototype,"enableHtmlSanitizer",void 0),q([t.Complex({itemId:"id",text:"text",parentId:"parentId",iconCss:"iconCss",url:"url",separator:"separator",children:"items"},$)],n.prototype,"fields",void 0),q([t.Collection([],ee)],n.prototype,"items",void 0),q([t.Complex({duration:400,easing:"ease",effect:"SlideDown"},te)],n.prototype,"animationSettings",void 0),n=q([t.NotifyPropertyChanges],n)}(t.Component),se=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),ne=function(e,t,i,s){var n,r=arguments.length,l=r<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)l=Reflect.decorate(e,t,i,s);else for(var o=e.length-1;o>=0;o--)(n=e[o])&&(l=(r<3?n(l):r>3?n(t,i,l):n(t,i))||l);return r>3&&l&&Object.defineProperty(t,i,l),l},re="e-vertical",le="e-toolbar-items",oe="e-toolbar-item",ae="e-rtl",de="e-separator",he="e-popup-up-icon",ce="e-popup-down-icon",pe="e-overlay",ue="e-popup-text",fe="e-overflow-show",me="e-overflow-hide",ve="e-hor-nav",ge="e-toolbar-center",ye="e-tbar-pos",be="e-toolbar-pop",Ce="e-toolbar-popup",Ee="e-nav-active",Ne="e-ignore",xe="e-popup-alone",Oe="e-hidden",Ie="e-toolbar-multirow",Se="e-multirow-separator",we="e-extended-separator",ke="e-extended-toolbar",Le="e-toolbar-extended",Ae="e-tbar-extended",De=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return se(i,e),ne([t.Property("")],i.prototype,"id",void 0),ne([t.Property("")],i.prototype,"text",void 0),ne([t.Property("auto")],i.prototype,"width",void 0),ne([t.Property("")],i.prototype,"cssClass",void 0),ne([t.Property(!1)],i.prototype,"showAlwaysInPopup",void 0),ne([t.Property(!1)],i.prototype,"disabled",void 0),ne([t.Property("")],i.prototype,"prefixIcon",void 0),ne([t.Property("")],i.prototype,"suffixIcon",void 0),ne([t.Property(!0)],i.prototype,"visible",void 0),ne([t.Property("None")],i.prototype,"overflow",void 0),ne([t.Property("")],i.prototype,"template",void 0),ne([t.Property("Button")],i.prototype,"type",void 0),ne([t.Property("Both")],i.prototype,"showTextOn",void 0),ne([t.Property(null)],i.prototype,"htmlAttributes",void 0),ne([t.Property("")],i.prototype,"tooltipText",void 0),ne([t.Property("Left")],i.prototype,"align",void 0),ne([t.Event()],i.prototype,"click",void 0),i}(t.ChildProperty),Me=function(e){function i(t,i){var s=e.call(this,t,i)||this;return s.resizeContext=s.resize.bind(s),s.keyConfigs={moveLeft:"leftarrow",moveRight:"rightarrow",moveUp:"uparrow",moveDown:"downarrow",popupOpen:"enter",popupClose:"escape",tab:"tab",home:"home",end:"end"},s}return se(i,e),i.prototype.destroy=function(){var i=this;(this.isReact||this.isAngular)&&this.clearTemplate();var s=this.element.querySelectorAll(".e-control.e-btn");for([].slice.call(s).forEach(function(e){t.isNullOrUndefined(e)||t.isNullOrUndefined(e.ej2_instances)||t.isNullOrUndefined(e.ej2_instances[0])||e.ej2_instances[0].isDestroyed||e.ej2_instances[0].destroy()}),this.unwireEvents(),this.tempId.forEach(function(e){t.isNullOrUndefined(i.element.querySelector(e))||(document.body.appendChild(i.element.querySelector(e)).style.display="none")}),this.destroyItems();this.element.lastElementChild;)this.element.removeChild(this.element.lastElementChild);this.trgtEle&&(this.element.appendChild(this.ctrlTem),this.trgtEle=null,this.ctrlTem=null),this.popObj&&(this.popObj.destroy(),t.detach(this.popObj.element)),this.activeEle&&(this.activeEle=null),this.popObj=null,this.tbarAlign=null,this.remove(this.element,"e-toolpop"),this.cssClass&&t.removeClass([this.element],this.cssClass.split(" ")),this.element.removeAttribute("style"),["aria-disabled","aria-orientation","aria-haspopup","role"].forEach(function(e){return i.element.removeAttribute(e)}),e.prototype.destroy.call(this)},i.prototype.preRender=function(){var e={enableCollision:this.enableCollision,scrollStep:this.scrollStep};this.trigger("beforeCreate",e),this.enableCollision=e.enableCollision,this.scrollStep=e.scrollStep,this.scrollModule=null,this.popObj=null,this.tempId=[],this.tbarItemsCol=this.items,this.isVertical=!!this.element.classList.contains(re),this.isExtendedOpen=!1,this.popupPriCount=0,this.enableRtl&&this.add(this.element,ae)},i.prototype.wireEvents=function(){t.EventHandler.add(this.element,"click",this.clickHandler,this),window.addEventListener("resize",this.resizeContext),this.allowKeyboard&&this.wireKeyboardEvent()},i.prototype.wireKeyboardEvent=function(){this.keyModule=new t.KeyboardEvents(this.element,{keyAction:this.keyActionHandler.bind(this),keyConfigs:this.keyConfigs}),t.EventHandler.add(this.element,"keydown",this.docKeyDown,this),this.element.setAttribute("tabIndex","0")},i.prototype.unwireKeyboardEvent=function(){this.keyModule&&(t.EventHandler.remove(this.element,"keydown",this.docKeyDown),this.keyModule.destroy(),this.keyModule=null)},i.prototype.docKeyDown=function(e){if("INPUT"!==e.target.tagName){var i=!t.isNullOrUndefined(this.popObj)&&t.isVisible(this.popObj.element)&&"Extended"!==this.overflowMode;9===e.keyCode&&!0===e.target.classList.contains("e-hor-nav")&&i&&this.popObj.hide({name:"FadeOut",duration:100});(40===e.keyCode||38===e.keyCode||35===e.keyCode||36===e.keyCode)&&e.preventDefault()}},i.prototype.unwireEvents=function(){t.EventHandler.remove(this.element,"click",this.clickHandler),this.destroyScroll(),this.unwireKeyboardEvent(),window.removeEventListener("resize",this.resizeContext),t.EventHandler.remove(document,"scroll",this.docEvent),t.EventHandler.remove(document,"click",this.docEvent)},i.prototype.clearProperty=function(){this.tbarEle=[],this.tbarAlgEle={lefts:[],centers:[],rights:[]}},i.prototype.docEvent=function(e){var i=t.closest(e.target,".e-popup");this.popObj&&t.isVisible(this.popObj.element)&&!i&&"Popup"===this.overflowMode&&this.popObj.hide({name:"FadeOut",duration:100})},i.prototype.destroyScroll=function(){this.scrollModule&&(this.tbarAlign&&this.add(this.scrollModule.element,ye),this.scrollModule.destroy(),this.scrollModule=null)},i.prototype.destroyItems=function(){if(this.element&&[].slice.call(this.element.querySelectorAll("."+oe)).forEach(function(e){t.detach(e)}),this.tbarAlign){var e=this.element.querySelector("."+le);[].slice.call(e.children).forEach(function(e){t.detach(e)}),this.tbarAlign=!1,this.remove(e,ye)}this.clearProperty()},i.prototype.destroyMode=function(){this.scrollModule&&(this.remove(this.scrollModule.element,ae),this.destroyScroll()),this.remove(this.element,Ae),this.remove(this.element,ke);var e=this.element.querySelector(".e-toolbar-multirow");e&&this.remove(e,Ie),this.popObj&&this.popupRefresh(this.popObj.element,!0)},i.prototype.add=function(e,t){e.classList.add(t)},i.prototype.remove=function(e,t){e.classList.remove(t)},i.prototype.elementFocus=function(e){var t=e.firstElementChild;t?(t.focus(),this.activeEleSwitch(e)):e.focus()},i.prototype.clstElement=function(e,i){return e&&this.popObj&&t.isVisible(this.popObj.element)?this.popObj.element.querySelector("."+oe):this.element===i||e?this.element.querySelector("."+oe+":not(."+pe+" ):not(."+de+" ):not(."+Oe+" )"):t.closest(i,"."+oe)},i.prototype.keyHandling=function(e,i,s,n,r){var l,o,a=this.popObj,d=this.element,h={name:"FadeOut",duration:100},c="moveUp"===i.action?"previous":"next";switch(i.action){case"moveRight":if(this.isVertical)return;d===s?this.elementFocus(e):n||this.eleFocus(e,"next");break;case"moveLeft":if(this.isVertical)return;n||this.eleFocus(e,"previous");break;case"home":case"end":if(e){var p=t.closest(e,".e-popup"),u=this.element.querySelector("."+Le);"Extended"===this.overflowMode&&u&&u.classList.contains("e-popup-open")&&(p="end"===i.action?u:null),p?t.isVisible(this.popObj.element)&&(o=[].slice.call(p.children),l="home"===i.action?o[0]:o[o.length-1]):(o=this.element.querySelectorAll("."+le+" ."+oe+":not(."+de+")"),l="home"===i.action?o[0]:o[o.length-1]),l&&this.elementFocus(l)}break;case"moveUp":case"moveDown":if(this.isVertical)"moveUp"===i.action?this.eleFocus(e,"previous"):this.eleFocus(e,"next");else if(a&&t.closest(s,".e-popup")){var f=a.element,m=f.firstElementChild;if("previous"===c&&m===e||"next"===c&&f.lastElementChild===e)return;this.eleFocus(e,c)}else"moveDown"===i.action&&a&&t.isVisible(a.element)&&this.elementFocus(e);break;case"tab":if(!r&&!n){var v=e.firstElementChild;d===s&&(this.activeEle?this.activeEle.focus():(this.activeEleRemove(v),v.focus()),this.element.removeAttribute("tabindex"))}break;case"popupClose":a&&"Extended"!==this.overflowMode&&a.hide(h);break;case"popupOpen":if(!n)return;a&&!t.isVisible(a.element)?(a.element.style.top=d.offsetHeight+"px",a.show({name:"FadeIn",duration:100})):a.hide(h)}},i.prototype.keyActionHandler=function(e){var t=e.target;if("INPUT"!==t.tagName&&"TEXTAREA"!==t.tagName&&!this.element.classList.contains(pe)){e.preventDefault();var i=t.classList.contains(ve),s=t.classList.contains("e-scroll-nav"),n=this.clstElement(i,t);(n||s)&&this.keyHandling(n,e,t,i,s)}},i.prototype.disable=function(e){var i=this.element;e?i.classList.add(pe):i.classList.remove(pe),i.setAttribute("tabindex",e?"-1":"0"),this.activeEle&&this.activeEle.setAttribute("tabindex",e?"-1":"0"),this.scrollModule&&this.scrollModule.disable(e),this.popObj&&(t.isVisible(this.popObj.element)&&"Extended"!==this.overflowMode&&this.popObj.hide(),i.querySelector("#"+i.id+"_nav").setAttribute("tabindex",e?"-1":"0"))},i.prototype.eleContains=function(e){return e.classList.contains(de)||e.classList.contains(pe)||e.getAttribute("disabled")||e.classList.contains(Oe)||!t.isVisible(e)},i.prototype.eleFocus=function(e,i){var s=Object(e)[i+"ElementSibling"];if(s){if(this.eleContains(s))return void this.eleFocus(s,i);this.elementFocus(s)}else if(this.tbarAlign){var n=Object(e.parentElement)[i+"ElementSibling"];if(t.isNullOrUndefined(n)||0!==n.children.length||(n=Object(n)[i+"ElementSibling"]),!t.isNullOrUndefined(n)&&n.children.length>0)if("next"===i){var r=n.querySelector("."+oe);this.eleContains(r)?this.eleFocus(r,i):(r.firstElementChild.focus(),this.activeEleSwitch(r))}else{r=n.lastElementChild;this.eleContains(r)?this.eleFocus(r,i):this.elementFocus(r)}}},i.prototype.clickHandler=function(e){var i=this,s=e.target,n=this.element,r=!t.isNullOrUndefined(t.closest(s,"."+be)),l=s.classList,o=t.closest(s,"."+ve);o||(o=s),n.children[0].classList.contains("e-hscroll")||n.children[0].classList.contains("e-vscroll")||!l.contains(ve)||(l=s.querySelector(".e-icons").classList),(l.contains(he)||l.contains(ce))&&this.popupClickHandler(n,o,ae);var a,d=t.closest(e.target,"."+oe);if(!t.isNullOrUndefined(d)&&!d.classList.contains(pe)||o.classList.contains(ve)){if(d){a=this.items[this.tbarEle.indexOf(d)]}var h={originalEvent:e,item:a};a&&!t.isNullOrUndefined(a.click)&&this.trigger("items["+this.tbarEle.indexOf(d)+"].click",h),h.cancel||this.trigger("clicked",h,function(e){!t.isNullOrUndefined(i.popObj)&&r&&!e.cancel&&"Popup"===i.overflowMode&&e.item&&"Input"!==e.item.type&&i.popObj.hide({name:"FadeOut",duration:100})})}},i.prototype.popupClickHandler=function(e,i,s){var n=this.popObj;t.isVisible(n.element)?(i.classList.remove(Ee),n.hide({name:"FadeOut",duration:100})):(e.classList.contains(s)&&(n.enableRtl=!0,n.position={X:"left",Y:"top"}),0!==n.offsetX||e.classList.contains(s)||(n.enableRtl=!1,n.position={X:"right",Y:"top"}),n.dataBind(),n.refreshPosition(),n.element.style.top=this.getElementOffsetY()+"px","Extended"===this.overflowMode&&(n.element.style.minHeight="0px"),i.classList.add(Ee),n.show({name:"FadeIn",duration:100}))},i.prototype.render=function(){this.initialize(),this.renderControl(),this.wireEvents(),this.renderComplete()},i.prototype.initialize=function(){var e=t.formatUnit(this.width),i=t.formatUnit(this.height);"msie"===t.Browser.info.name&&"auto"===this.height&&"MultiRow"!==this.overflowMode||t.setStyleAttribute(this.element,{height:i}),t.setStyleAttribute(this.element,{width:e});var s={role:"toolbar","aria-disabled":"false","aria-haspopup":"false","aria-orientation":this.isVertical?"vertical":"horizontal"};t.attributes(this.element,s),this.cssClass&&t.addClass([this.element],this.cssClass.split(" "))},i.prototype.renderControl=function(){var e=this.element;this.trgtEle=e.children.length>0?e.querySelector("div"):null,this.tbarAlgEle={lefts:[],centers:[],rights:[]},this.renderItems(),this.renderLayout()},i.prototype.renderLayout=function(){this.renderOverflowMode(),this.tbarAlign&&this.itemPositioning(),this.popObj&&this.popObj.element.childElementCount>1&&this.checkPopupRefresh(this.element,this.popObj.element)&&this.popupRefresh(this.popObj.element,!1),this.separator()},i.prototype.itemsAlign=function(e,t){var i,s;this.tbarEle||(this.tbarEle=[]);for(var n=0;n<e.length;n++)i=this.renderSubComponent(e[n],n),-1===this.tbarEle.indexOf(i)&&this.tbarEle.push(i),this.tbarAlign||this.tbarItemAlign(e[n],t,n),(s=t.querySelector(".e-toolbar-"+e[n].align.toLowerCase()))?(e[n].showAlwaysInPopup&&"Show"!==e[n].overflow||this.tbarAlgEle[(e[n].align+"s").toLowerCase()].push(i),s.appendChild(i)):t.appendChild(i);if(this.isReact){this.notify("render-react-toolbar-template",this.portals),this.renderReactTemplates()}},i.prototype.changeOrientation=function(){var e=this.element;this.isVertical?(e.classList.remove(re),this.isVertical=!1,"auto"!==this.height&&"100%"!==this.height||(e.style.height=this.height),e.setAttribute("aria-orientation","horizontal")):(e.classList.add(re),this.isVertical=!0,e.setAttribute("aria-orientation","vertical"),t.setStyleAttribute(this.element,{height:t.formatUnit(this.height),width:t.formatUnit(this.width)})),this.destroyMode(),this.refreshOverflow()},i.prototype.initScroll=function(e,i){!this.scrollModule&&this.checkOverflow(e,i[0])&&(this.tbarAlign&&this.element.querySelector("."+le+" ."+ge).removeAttribute("style"),this.isVertical?this.scrollModule=new B({scrollStep:this.scrollStep,enableRtl:this.enableRtl},i[0]):this.scrollModule=new O({scrollStep:this.scrollStep,enableRtl:this.enableRtl},i[0]),this.remove(this.scrollModule.element,ye),t.setStyleAttribute(this.element,{overflow:"hidden"}))},i.prototype.itemWidthCal=function(e){var i,s=this,n=0;return[].slice.call(t.selectAll("."+oe,e)).forEach(function(e){t.isVisible(e)&&(i=window.getComputedStyle(e),n+=s.isVertical?e.offsetHeight:e.offsetWidth,n+=parseFloat(s.isVertical?i.marginTop:i.marginRight),n+=parseFloat(s.isVertical?i.marginBottom:i.marginLeft))}),n},i.prototype.getScrollCntEle=function(e){var t=this.isVertical?".e-vscroll-content":".e-hscroll-content";return e.querySelector(t)},i.prototype.checkOverflow=function(e,i){if(t.isNullOrUndefined(e)||t.isNullOrUndefined(i)||!t.isVisible(e))return!1;var s=this.isVertical?e.offsetHeight:e.offsetWidth,n=this.isVertical?i.offsetHeight:i.offsetWidth;(this.tbarAlign||this.scrollModule||s===n)&&(n=this.itemWidthCal(this.scrollModule?this.getScrollCntEle(i):i));var r=e.querySelector("."+ve),l=e.querySelector(".e-scroll-nav"),o=0;return r?o=this.isVertical?r.offsetHeight:r.offsetWidth:l&&(o=this.isVertical?2*l.offsetHeight:2*l.offsetWidth),n>s-o},i.prototype.refreshOverflow=function(){this.resize()},i.prototype.toolbarAlign=function(e){this.tbarAlign&&(this.add(e,ye),this.itemPositioning())},i.prototype.renderOverflowMode=function(){var e=this.element,i=e.querySelector("."+le),s=this.popupPriCount>0;if(e&&e.children.length>0)switch(this.offsetWid=e.offsetWidth,this.remove(this.element,"e-toolpop"),"msie"===t.Browser.info.name&&"auto"===this.height&&(e.style.height=""),this.overflowMode){case"Scrollable":t.isNullOrUndefined(this.scrollModule)&&this.initScroll(e,[].slice.call(e.getElementsByClassName(le)));break;case"Popup":this.add(this.element,"e-toolpop"),this.tbarAlign&&this.removePositioning(),(this.checkOverflow(e,i)||s)&&this.setOverflowAttributes(e),this.toolbarAlign(i);break;case"MultiRow":this.add(i,Ie),this.checkOverflow(e,i)&&this.tbarAlign&&(this.removePositioning(),this.add(i,"e-multirow-pos")),"hidden"===e.style.overflow&&(e.style.overflow=""),"msie"!==t.Browser.info.name&&"auto"===e.style.height||(e.style.height="auto");break;case"Extended":this.add(this.element,ke),(this.checkOverflow(e,i)||s)&&(this.tbarAlign&&this.removePositioning(),this.setOverflowAttributes(e)),this.toolbarAlign(i)}},i.prototype.setOverflowAttributes=function(e){this.createPopupEle(e,[].slice.call(t.selectAll("."+le+" ."+oe,e))),this.element.querySelector("."+ve).setAttribute("tabIndex","0"),this.element.querySelector("."+ve).setAttribute("role","list")},i.prototype.separator=function(){var e=this.element,t=[].slice.call(e.querySelectorAll("."+de)),i=e.querySelector("."+Se),s=e.querySelector("."+we),n="MultiRow"===this.overflowMode?i:s;null!==n&&("MultiRow"===this.overflowMode?n.classList.remove(Se):"Extended"===this.overflowMode&&n.classList.remove(we));for(var r=0;r<=t.length-1;r++)t[r].offsetLeft<30&&0!==t[r].offsetLeft&&("MultiRow"===this.overflowMode?t[r].classList.add(Se):"Extended"===this.overflowMode&&t[r].classList.add(we))},i.prototype.createPopupEle=function(e,i){var s=e.querySelector("."+ve),n=this.isVertical;s||this.createPopupIcon(e),s=e.querySelector("."+ve);var r=n?s.offsetHeight:s.offsetWidth,l=(n?e.offsetHeight:e.offsetWidth)-r;this.element.classList.remove("e-rtl"),t.setStyleAttribute(this.element,{direction:"initial"}),this.checkPriority(e,i,l,!0),this.enableRtl&&this.element.classList.add("e-rtl"),this.element.style.removeProperty("direction"),this.createPopup()},i.prototype.pushingPoppedEle=function(e,i,s,n,r){var l=e.element,o=[].slice.call(t.selectAll("."+Ce,l.querySelector("."+le))),a=t.selectAll("."+fe,s),d=0,h=0;o.forEach(function(l,o){a=t.selectAll("."+fe,s),l.classList.contains(fe)&&a.length>0?e.tbResize&&a.length>o?(s.insertBefore(l,a[o]),++h):(s.insertBefore(l,s.children[a.length]),++h):l.classList.contains(fe)?(s.insertBefore(l,s.firstChild),++h):e.tbResize&&l.classList.contains(me)&&s.children.length>0&&0===a.length?(s.insertBefore(l,s.firstChild),++h):l.classList.contains(me)?i.push(l):e.tbResize?(s.insertBefore(l,s.childNodes[d+h]),++d):s.appendChild(l),l.classList.contains(de)?t.setStyleAttribute(l,{display:"",height:r+"px"}):t.setStyleAttribute(l,{display:"",height:n+"px"})}),i.forEach(function(e){s.appendChild(e)});for(var c=t.selectAll("."+oe,l.querySelector("."+le)),p=c.length-1;p>=0;p--){var u=c[p];if(!u.classList.contains(de)||"Extended"===this.overflowMode)break;t.setStyleAttribute(u,{display:"none"})}},i.prototype.createPopup=function(){var e,i,s=this.element;"Extended"===this.overflowMode&&(i=s.querySelector("."+de+":not(."+Ce+")"),e="auto"===s.style.height||""===s.style.height?null:i.offsetHeight);var n,r=s.querySelector("."+oe+":not(."+de+"):not(."+Ce+")"),l="auto"===s.style.height||""===s.style.height?null:r&&r.offsetHeight;if(t.select("#"+s.id+"_popup."+be,s))n=t.select("#"+s.id+"_popup."+be,s);else{var o=this.createElement("div",{id:s.id+"_popup",className:be+" "+Le}),a=this.createElement("div",{id:s.id+"_popup",className:be});n="Extended"===this.overflowMode?o:a}this.pushingPoppedEle(this,[],n,l,e),this.popupInit(s,n)},i.prototype.getElementOffsetY=function(){return"Extended"===this.overflowMode&&"border-box"===window.getComputedStyle(this.element).getPropertyValue("box-sizing")?this.element.clientHeight:this.element.offsetHeight},i.prototype.popupInit=function(e,i){if(this.popObj){var n=this.popObj.element;t.setStyleAttribute(n,{maxHeight:"",display:"block"}),t.setStyleAttribute(n,{maxHeight:n.offsetHeight+"px",display:""})}else{e.appendChild(i),t.setStyleAttribute(this.element,{overflow:""});var r=window.getComputedStyle(this.element),l=new s.Popup(null,{relateTo:this.element,offsetY:this.isVertical?0:this.getElementOffsetY(),enableRtl:this.enableRtl,open:this.popupOpen.bind(this),close:this.popupClose.bind(this),collision:{Y:this.enableCollision?"flip":"none"},position:this.enableRtl?{X:"left",Y:"top"}:{X:"right",Y:"top"}});if(l.appendTo(i),"Extended"===this.overflowMode&&(l.width=parseFloat(r.width)+2*parseFloat(r.borderRightWidth),l.offsetX=0),t.EventHandler.add(document,"scroll",this.docEvent.bind(this)),t.EventHandler.add(document,"click ",this.docEvent.bind(this)),l.element.style.maxHeight=l.element.offsetHeight+"px",this.isVertical&&(l.element.style.visibility="hidden"),this.isExtendedOpen){var o=this.element.querySelector("."+ve);o.classList.add(Ee),t.classList(o.firstElementChild,[he],[ce]),this.element.querySelector("."+Le).classList.add("e-popup-open")}else l.hide();this.popObj=l,this.element.setAttribute("aria-haspopup","true")}},i.prototype.tbarPopupHandler=function(e){"Extended"===this.overflowMode&&(e?this.add(this.element,Ae):this.remove(this.element,Ae))},i.prototype.popupOpen=function(e){var i=this.popObj;this.isVertical||(i.offsetY=this.getElementOffsetY(),i.dataBind());var n=this.popObj.element,r=this.popObj.element.parentElement,l=r.querySelector("."+ve);t.setStyleAttribute(i.element,{height:"auto",maxHeight:""}),i.element.style.maxHeight=i.element.offsetHeight+"px","Extended"===this.overflowMode&&(i.element.style.minHeight="");var o=n.offsetTop+n.offsetHeight+s.calculatePosition(r).top,a=l.firstElementChild;l.classList.add(Ee),t.classList(a,[he],[ce]),this.tbarPopupHandler(!0);var d=t.isNullOrUndefined(window.scrollY)?0:window.scrollY;if(!this.isVertical&&window.innerHeight+d<o&&this.element.offsetTop<n.offsetHeight){var h=n.offsetHeight-(o-window.innerHeight-d+5);i.height=h+"px";for(var c=0;c<=n.childElementCount;c++){var p=n.children[c];if(p.offsetTop+p.offsetHeight>h){h=p.offsetTop;break}}t.setStyleAttribute(i.element,{maxHeight:h+"px"})}else if(this.isVertical){var u=this.element.getBoundingClientRect();t.setStyleAttribute(i.element,{maxHeight:u.top+this.element.offsetHeight+"px",bottom:0,visibility:""})}if(i){var f=n.getBoundingClientRect();f.right>document.documentElement.clientWidth&&f.width>r.getBoundingClientRect().width&&(i.collision={Y:"none"},i.dataBind()),i.refreshPosition()}},i.prototype.popupClose=function(e){var i=this.element.querySelector("."+ve),s=i.firstElementChild;i.classList.remove(Ee),t.classList(s,[ce],[he]),this.tbarPopupHandler(!1)},i.prototype.checkPriority=function(e,i,s,n){for(var r,l=this.popupPriCount>0,o=s,a=0,d=0,h=0,c=function(e,t){var i=!1;return t.forEach(function(t){e.classList.contains(t)&&(i=!0)}),i},p=i.length-1;p>=0;p--){var u=void 0,f=window.getComputedStyle(i[p]);this.isVertical?(u=parseFloat(f.marginTop),u+=parseFloat(f.marginBottom)):(u=parseFloat(f.marginRight),u+=parseFloat(f.marginLeft));var m=i[p]===this.tbarEle[0];m&&(this.tbarEleMrgn=u),r=this.isVertical?i[p].offsetHeight:i[p].offsetWidth;var v=m?r+u:r;if(c(i[p],[xe])&&l&&(i[p].classList.add(Ce),this.isVertical?t.setStyleAttribute(i[p],{display:"none",minHeight:v+"px"}):t.setStyleAttribute(i[p],{display:"none",minWidth:v+"px"}),h++),this.isVertical?i[p].offsetTop+i[p].offsetHeight+u>s:i[p].offsetLeft+i[p].offsetWidth+u>s){if(i[p].classList.contains(de)){if("Extended"===this.overflowMode){if(d===h){c(g=i[p],[de,Ne])&&(i[p].classList.add(Ce),h++)}d++}else if("Popup"===this.overflowMode){if(a>0&&d===h){var g;c(g=i[p+d+(a-1)],[de,Ne])&&t.setStyleAttribute(g,{display:"none"})}a++,d=0,h=0}}else d++;i[p].classList.contains(fe)&&n?s-=(this.isVertical?i[p].offsetHeight:i[p].offsetWidth)+u:c(i[p],[de,Ne])?s-=(this.isVertical?i[p].offsetHeight:i[p].offsetWidth)+u:(i[p].classList.add(Ce),this.isVertical?t.setStyleAttribute(i[p],{display:"none",minHeight:v+"px"}):t.setStyleAttribute(i[p],{display:"none",minWidth:v+"px"}),h++)}}if(n){var y=t.selectAll("."+oe+":not(."+Ce+")",this.element);this.checkPriority(e,y,o,!1)}},i.prototype.createPopupIcon=function(e){var i=e.id.concat("_nav"),s="e-"+e.id.concat("_nav e-hor-nav");s="Extended"===this.overflowMode?s+" e-expended-nav":s;var n=this.createElement("div",{id:i,className:s});"msie"!==t.Browser.info.name&&"edge"!==t.Browser.info.name||n.classList.add("e-ie-align");var r=this.createElement("div",{className:ce+" e-icons"});n.appendChild(r),n.setAttribute("tabindex","0"),n.setAttribute("role","list"),e.appendChild(n)},i.prototype.tbarPriRef=function(e,i,s,n,r,l,o,a){var d=a,h=this.popObj.element,c=t.selectAll("."+Ce+":not(."+fe+")",h).length,p=function(e,t){return e.classList.contains(t)};if(0===t.selectAll(".e-toolbar-item:not(.e-separator):not(.e-overflow-show)",e).length){var u=e.children[i-(i-s)-1],f=!t.isNullOrUndefined(u)&&p(u,Ne);if(!t.isNullOrUndefined(u)&&p(u,de)&&!t.isVisible(u)||f){u.style.display="inherit";var m=u.offsetWidth+2*parseFloat(window.getComputedStyle(u).marginRight),v=u.previousElementSibling;l+m<o||r?(e.insertBefore(n,e.children[i+d-(i-s)]),t.isNullOrUndefined(v)||(v.style.display="")):v.classList.contains(de)&&(v.style.display="none"),u.style.display=""}else e.insertBefore(n,e.children[i+d-(i-s)])}else e.insertBefore(n,e.children[i+d-c])},i.prototype.popupRefresh=function(e,i){var s=this,n=this.element,r=this.isVertical,l=n.querySelector("."+le),o=n.querySelector("."+ve);if(!t.isNullOrUndefined(o)){l.removeAttribute("style"),e.style.display="block";var a;a=r?n.offsetHeight-(o.offsetHeight+l.offsetHeight):n.offsetWidth-(o.offsetWidth+l.offsetWidth);var d=0;[].slice.call(e.children).forEach(function(e){d+=s.popupEleWidth(e),t.setStyleAttribute(e,{position:""})}),a+(r?o.offsetHeight:o.offsetWidth)>d&&0===this.popupPriCount&&(i=!0),this.popupEleRefresh(a,e,i),e.style.display="",0===e.children.length&&o&&this.popObj&&(t.detach(o),o=null,this.popObj.destroy(),t.detach(this.popObj.element),this.popObj=null,n.setAttribute("aria-haspopup","false"))}},i.prototype.ignoreEleFetch=function(e,t){var i=[].slice.call(t.querySelectorAll("."+Ne)),s=[],n=0;return i.length>0?(i.forEach(function(e){s.push([].slice.call(t.children).indexOf(e))}),s.forEach(function(t){t<=e&&n++}),n):0},i.prototype.checkPopupRefresh=function(e,t){t.style.display="block";var i=this.popupEleWidth(t.firstElementChild);t.firstElementChild.style.removeProperty("Position");var s=e.offsetWidth-e.querySelector("."+ve).offsetWidth,n=e.querySelector("."+le).offsetWidth;return t.style.removeProperty("display"),s>i+n},i.prototype.popupEleWidth=function(e){e.style.position="absolute";var i=this.isVertical?e.offsetHeight:e.offsetWidth,s=e.querySelector(".e-tbar-btn-text");if(e.classList.contains("e-tbtn-align")||e.classList.contains(ue)){var n=e.children[0];!t.isNullOrUndefined(s)&&e.classList.contains(ue)?s.style.display="none":!t.isNullOrUndefined(s)&&e.classList.contains("e-toolbar-text")&&(s.style.display="block"),n.style.minWidth="0%",i=parseFloat(this.isVertical?e.style.minHeight:e.style.minWidth),n.style.minWidth="",n.style.minHeight="",t.isNullOrUndefined(s)||(s.style.display="")}return i},i.prototype.popupEleRefresh=function(e,i,s){for(var n,r,l=this.popupPriCount>0,o=this.tbarEle,a=this.element.querySelector("."+le),d=0,h=function(i){if(i.classList.contains(xe)&&l&&!s)return"continue";var h=c.popupEleWidth(i);if(i===c.tbarEle[0]&&(h+=c.tbarEleMrgn),i.style.position="",!(h<e||s))return"break";if(t.setStyleAttribute(i,{minWidth:"",height:"",minHeight:""}),i.classList.contains(me)||i.classList.remove(Ce),r=c.tbarEle.indexOf(i),c.tbarAlign){var p=c.items[r].align;r=c.tbarAlgEle[(p+"s").toLowerCase()].indexOf(i),o=c.tbarAlgEle[(p+"s").toLowerCase()],a=c.element.querySelector("."+le+" .e-toolbar-"+p.toLowerCase())}var u=0;"Extended"!==c.overflowMode&&o.slice(0,r).forEach(function(t){(t.classList.contains(fe)||t.classList.contains(de))&&(t.classList.contains(de)&&(t.style.display="",e-=t.offsetWidth),u++)}),d=c.ignoreEleFetch(r,a),i.classList.contains(fe)?(c.tbarPriRef(a,r,u,i,s,h,e,d),e-=i.offsetWidth):0===r?(a.insertBefore(i,a.firstChild),e-=i.offsetWidth):(n=t.selectAll("."+fe,c.popObj.element).length,a.insertBefore(i,a.children[r+d-n]),e-=i.offsetWidth),i.style.height=""},c=this,p=0,u=[].slice.call(i.children);p<u.length;p++){if("break"===h(u[p]))break}this.checkOverflow(this.element,this.element.getElementsByClassName(le)[0])&&!s&&this.renderOverflowMode()},i.prototype.removePositioning=function(){var e=this.element.querySelector("."+le);if(!t.isNullOrUndefined(e)&&e.classList.contains(ye)){this.remove(e,ye);var i=[].slice.call(e.childNodes);i[1].removeAttribute("style"),i[2].removeAttribute("style")}},i.prototype.refreshPositioning=function(){var e=this.element.querySelector("."+le);this.add(e,ye),this.itemPositioning()},i.prototype.itemPositioning=function(){var e,i=this.element.querySelector("."+le);if(!t.isNullOrUndefined(i)&&i.classList.contains(ye)){var s,n=this.element.querySelector("."+ve);if(this.scrollModule){var r=this.isVertical?"e-vscroll-content":"e-hscroll-content";s=[].slice.call(i.querySelector("."+r).children)}else s=[].slice.call(i.childNodes);e=this.isVertical?s[0].offsetHeight+s[2].offsetHeight:s[0].offsetWidth+s[2].offsetWidth;var l=this.isVertical?this.element.offsetHeight:this.element.offsetWidth;if(n){l-=this.isVertical?n.offsetHeight:n.offsetWidth;var o=(this.isVertical?n.offsetHeight:n.offsetWidth)+"px";s[2].removeAttribute("style"),this.isVertical?this.enableRtl?s[2].style.top=o:s[2].style.bottom=o:this.enableRtl?s[2].style.left=o:s[2].style.right=o}if(!(l<=e)){var a=(l-e-(this.isVertical?s[1].offsetHeight:s[1].offsetWidth))/2;s[1].removeAttribute("style");var d=(this.isVertical?s[0].offsetHeight:s[0].offsetWidth)+a+"px";this.isVertical?this.enableRtl?s[1].style.marginBottom=d:s[1].style.marginTop=d:this.enableRtl?s[1].style.marginRight=d:s[1].style.marginLeft=d}}},i.prototype.tbarItemAlign=function(e,t,i){var s=this;if(!e.showAlwaysInPopup||"Show"===e.overflow){var n=[];if(n.push(this.createElement("div",{className:"e-toolbar-left"})),n.push(this.createElement("div",{className:ge})),n.push(this.createElement("div",{className:"e-toolbar-right"})),0===i&&"Left"!==e.align)n.forEach(function(e){t.appendChild(e)}),this.tbarAlign=!0,this.add(t,ye);else if("Left"!==e.align){var r=t.childNodes,l=n[0];[].slice.call(r).forEach(function(e){s.tbarAlgEle.lefts.push(e),l.appendChild(e)}),t.appendChild(l),t.appendChild(n[1]),t.appendChild(n[2]),this.tbarAlign=!0,this.add(t,ye)}}},i.prototype.ctrlTemplate=function(){var e=this;this.ctrlTem=this.trgtEle.cloneNode(!0),this.add(this.trgtEle,le),this.tbarEle=[];[].slice.call(this.trgtEle.children).forEach(function(t){"DIV"===t.tagName&&(e.tbarEle.push(t),t.setAttribute("aria-disabled","false"),e.add(t,oe))})},i.prototype.renderItems=function(){var e=this.element,t=this.items;if(null!=this.trgtEle)this.ctrlTemplate();else if(e&&t.length>0){var i=void 0;e&&e.children.length>0&&(i=e.querySelector("."+le)),i||(i=this.createElement("div",{className:le})),this.itemsAlign(t,i),e.appendChild(i)}},i.prototype.setAttr=function(e,t){for(var i,s=Object.keys(e),n=0;n<s.length;n++)"class"===(i=s[n])?this.add(t,e[i]):t.setAttribute(i,e[i])},i.prototype.enableItems=function(e,i){var s,n=e,r=n.length;t.isNullOrUndefined(i)&&(i=!0);var l=function(e,t){e?(t.classList.remove(pe),t.setAttribute("aria-disabled","false")):(t.classList.add(pe),t.setAttribute("aria-disabled","true"))};if(!t.isNullOrUndefined(r)&&r>=1){for(var o=0,a=[].slice.call(n);o<r;o++){var d=a[o];if("number"==typeof d){if(s=this.getElementByIndex(d),t.isNullOrUndefined(s))return;n[o]=s}else s=d;l(i,s)}i?t.removeClass(n,pe):t.addClass(n,pe)}else{if("number"==typeof n){if(s=this.getElementByIndex(n),t.isNullOrUndefined(s))return}else s=e;l(i,s)}},i.prototype.getElementByIndex=function(e){return this.tbarEle[e]?this.tbarEle[e]:null},i.prototype.addItems=function(e,i){var s;this.extendedOpen();var n=this.element.querySelector("."+le);if(t.isNullOrUndefined(n))this.itemsRerender(e);else{var r,l="Left";t.isNullOrUndefined(i)&&(i=0),e.forEach(function(e){t.isNullOrUndefined(e.align)||"Left"===e.align||"Left"!==l||(l=e.align)});for(var o=0,a=e;o<a.length;o++){var d=a[o];if(t.isNullOrUndefined(d.type)&&(d.type="Button"),s=t.selectAll("."+oe,this.element),d.align=l,r=this.renderSubComponent(d,i),this.tbarEle.length>=i&&s.length>=0){t.isNullOrUndefined(this.scrollModule)&&this.destroyMode();var h="L"===d.align[0]?0:"C"===d.align[0]?1:2,c=void 0;this.tbarAlign||"Left"===l?this.tbarAlign?((c=t.closest(s[0],"."+le).children[h]).insertBefore(r,c.children[i]),this.tbarAlgEle[(d.align+"s").toLowerCase()].splice(i,0,r),this.refreshPositioning()):0===s.length?(s=t.selectAll("."+le,this.element))[0].appendChild(r):s[0].parentNode.insertBefore(r,s[i]):(this.tbarItemAlign(d,n,1),this.tbarAlign=!0,(c=t.closest(s[0],"."+le).children[h]).appendChild(r),this.tbarAlgEle[(d.align+"s").toLowerCase()].push(r),this.refreshPositioning()),this.items.splice(i,0,d),this.tbarEle.splice(i,0,r),i++,this.offsetWid=n.offsetWidth}}n.style.width="",this.renderOverflowMode(),this.isReact&&this.renderReactTemplates()}},i.prototype.removeItems=function(e){var i,s=e,n=[].slice.call(t.selectAll("."+oe,this.element));if("number"==typeof s)i=parseInt(e.toString(),10),this.removeItemByIndex(i,n);else if(s&&s.length>1)for(var r=0,l=[].slice.call(s);r<l.length;r++){var o=l[r];i=this.tbarEle.indexOf(o),this.removeItemByIndex(i,n),n=t.selectAll("."+oe,this.element)}else{o=s&&s.length&&1===s.length?s[0]:e;i=n.indexOf(o),this.removeItemByIndex(i,n)}this.resize()},i.prototype.removeItemByIndex=function(e,i){if(this.tbarEle[e]&&i[e]){var s=this.tbarEle.indexOf(i[e]);if(this.tbarAlign){var n=this.tbarAlgEle[(this.items[s].align+"s").toLowerCase()].indexOf(this.tbarEle[s]);this.tbarAlgEle[(this.items[s].align+"s").toLowerCase()].splice(n,1)}this.isReact&&this.clearTemplate();var r=i[e].querySelector(".e-control.e-btn");t.isNullOrUndefined(r)||t.isNullOrUndefined(r.ej2_instances[0])||r.ej2_instances[0].isDestroyed||r.ej2_instances[0].destroy(),t.detach(i[e]),this.items.splice(s,1),this.tbarEle.splice(s,1)}},i.prototype.templateRender=function(e,i,s,n){var r,l=s.type,o=e;if("object"==typeof e&&(r="function"==typeof o.appendTo),"string"!=typeof e&&r){if("Input"===l){h=this.createElement("input");s.id?h.id=s.id:h.id=t.getUniqueID("tbr-ipt"),i.appendChild(h),o.appendTo(h)}}else{var a=void 0,d=e;d="string"==typeof e?e.trim():e;try{if("object"!=typeof e||t.isNullOrUndefined(e.tagName)){if(document.querySelectorAll(d).length){var h,c=(h=document.querySelector(d)).outerHTML.trim();i.appendChild(h),h.style.display="",t.isNullOrUndefined(c)||this.tempId.push(d)}}else i.appendChild(e)}catch(e){a=t.compile(d)}var p=void 0;if(!t.isNullOrUndefined(a)){var u=this.element.id+n+"_template";p=a({},this,"template",u,this.isStringTemplate)}!t.isNullOrUndefined(p)&&p.length>0&&[].slice.call(p).forEach(function(e){t.isNullOrUndefined(e.tagName)||(e.style.display=""),i.appendChild(e)})}this.add(i,"e-template"),this.tbarEle.push(i)},i.prototype.buttonRendering=function(e,i){var s=this.createElement("button",{className:"e-tbar-btn"});s.setAttribute("type","button");var r,l,o=e.text;e.id?s.id=e.id:s.id=t.getUniqueID("e-tbr-btn");var a=this.createElement("span",{className:"e-tbar-btn-text"});o?(a.innerHTML=this.enableHtmlSanitizer?t.SanitizeHtmlHelper.sanitize(o):o,s.appendChild(a),s.classList.add("e-tbtn-txt")):this.add(i,"e-tbtn-align"),(e.prefixIcon||e.suffixIcon)&&(e.prefixIcon&&e.suffixIcon||e.prefixIcon?(r=e.prefixIcon+" e-icons",l="Left"):(r=e.suffixIcon+" e-icons",l="Right"));var d=new n.Button({iconCss:r,iconPosition:l});return d.createElement=this.createElement,d.appendTo(s),e.width&&t.setStyleAttribute(s,{width:t.formatUnit(e.width)}),s},i.prototype.renderSubComponent=function(e,i){var s,n=this.createElement("div",{className:oe});n.setAttribute("aria-disabled","false");var r=this.createElement("div",{innerHTML:this.enableHtmlSanitizer?t.SanitizeHtmlHelper.sanitize(e.tooltipText):e.tooltipText});if(this.tbarEle||(this.tbarEle=[]),e.htmlAttributes&&this.setAttr(e.htmlAttributes,n),e.tooltipText&&n.setAttribute("title",r.textContent),e.cssClass&&(n.className=n.className+" "+e.cssClass),e.template)this.templateRender(e.template,n,e,i);else switch(e.type){case"Button":(s=this.buttonRendering(e,n)).setAttribute("tabindex","-1"),s.setAttribute("aria-label",e.text||e.tooltipText),n.appendChild(s),n.addEventListener("click",this.itemClick.bind(this));break;case"Separator":this.add(n,de)}if(e.showTextOn){var l=e.showTextOn;"Toolbar"===l?(this.add(n,"e-toolbar-text"),this.add(n,"e-tbtn-align")):"Overflow"===l&&this.add(n,ue)}if(e.overflow){var o=e.overflow;"Show"===o?this.add(n,fe):"Hide"===o&&(n.classList.contains(de)||this.add(n,me))}return"Show"!==e.overflow&&e.showAlwaysInPopup&&!n.classList.contains(de)&&(this.add(n,xe),this.popupPriCount++),e.disabled&&this.add(n,pe),!1===e.visible&&this.add(n,Oe),n},i.prototype.itemClick=function(e){this.activeEleSwitch(e.currentTarget)},i.prototype.activeEleSwitch=function(e){this.activeEleRemove(e.firstElementChild),this.activeEle.focus()},i.prototype.activeEleRemove=function(e){t.isNullOrUndefined(this.activeEle)||this.activeEle.setAttribute("tabindex","-1"),this.activeEle=e,t.isNullOrUndefined(this.trgtEle)&&!e.parentElement.classList.contains("e-template")?e.removeAttribute("tabindex"):this.activeEle.setAttribute("tabindex","0")},i.prototype.getPersistData=function(){return this.addOnPersist([])},i.prototype.getModuleName=function(){return"toolbar"},i.prototype.itemsRerender=function(e){this.items=this.tbarItemsCol,(this.isReact||this.isAngular)&&this.clearTemplate(),this.destroyMode(),this.destroyItems(),this.items=e,this.tbarItemsCol=this.items,this.renderItems(),this.renderOverflowMode(),this.isReact&&this.renderReactTemplates()},i.prototype.resize=function(){var e=this.element;this.tbResize=!0,this.tbarAlign&&this.itemPositioning(),this.popObj&&"Popup"===this.overflowMode&&this.popObj.hide();var i=this.checkOverflow(e,e.getElementsByClassName(le)[0]);if(!i){this.destroyScroll();var s=e.querySelector("."+le);t.isNullOrUndefined(s)||(this.remove(s,"e-multirow-pos"),this.tbarAlign&&this.add(s,ye))}if(!i||!this.scrollModule||this.offsetWid!==e.offsetWidth){if((this.offsetWid>e.offsetWidth||i)&&this.renderOverflowMode(),this.popObj){if("Extended"===this.overflowMode){var n=window.getComputedStyle(this.element);this.popObj.width=parseFloat(n.width)+2*parseFloat(n.borderRightWidth)}this.tbarAlign&&this.removePositioning(),this.popupRefresh(this.popObj.element,!1),this.tbarAlign&&this.refreshPositioning()}this.element.querySelector(".e-hscroll-bar")&&(this.scrollStep=this.element.querySelector(".e-hscroll-bar").offsetWidth),this.offsetWid=e.offsetWidth,this.tbResize=!1,this.separator()}},i.prototype.extendedOpen=function(){var e=this.element.querySelector("."+Le);"Extended"===this.overflowMode&&e&&(this.isExtendedOpen=e.classList.contains("e-popup-open"))},i.prototype.onPropertyChanged=function(e,i){var s=this.element,n=s.offsetWidth;this.extendedOpen();for(var r=0,l=Object.keys(e);r<l.length;r++){switch(l[r]){case"items":if(e.items instanceof Array&&i.items instanceof Array)this.itemsRerender(e.items);else for(var o=Object.keys(e.items),a=0;a<o.length;a++){var d=parseInt(Object.keys(e.items)[a],10),h=Object.keys(e.items[d])[0],c=Object(e.items[d])[h];if("function"!=typeof c){if(this.tbarAlign||"align"===h){this.refresh(),this.trigger("created");break}var p="showAlwaysInPopup"===h&&!c,u="overflow"===h&&0!==this.popupPriCount;(p||this.items[d].showAlwaysInPopup&&u)&&--this.popupPriCount,t.isNullOrUndefined(this.scrollModule)&&this.destroyMode();var f=[].slice.call(t.selectAll("."+le+" ."+oe,s));this.isReact&&this.clearTemplate(),t.detach(f[d]),this.tbarEle.splice(d,1),this.addItems([this.items[d]],d),this.items.splice(d,1),this.items[d].template&&this.tbarEle.splice(this.items.length,1)}}break;case"width":t.setStyleAttribute(s,{width:t.formatUnit(e.width)}),this.renderOverflowMode(),this.popObj&&n<s.offsetWidth&&this.popupRefresh(this.popObj.element,!1);break;case"height":t.setStyleAttribute(this.element,{height:t.formatUnit(e.height)});break;case"overflowMode":this.destroyMode(),this.renderOverflowMode(),this.enableRtl&&this.add(s,ae),this.refreshOverflow();break;case"enableRtl":e.enableRtl?this.add(s,ae):this.remove(s,ae),t.isNullOrUndefined(this.scrollModule)||(e.enableRtl?this.add(this.scrollModule.element,ae):this.remove(this.scrollModule.element,ae)),t.isNullOrUndefined(this.popObj)||(e.enableRtl?this.add(this.popObj.element,ae):this.remove(this.popObj.element,ae)),this.tbarAlign&&this.itemPositioning();break;case"scrollStep":this.scrollModule&&(this.scrollModule.scrollStep=this.scrollStep);break;case"enableCollision":this.popObj&&(this.popObj.collision={Y:this.enableCollision?"flip":"none"});break;case"cssClass":i.cssClass&&t.removeClass([this.element],i.cssClass.split(" ")),e.cssClass&&t.addClass([this.element],e.cssClass.split(" "));break;case"allowKeyboard":this.unwireKeyboardEvent(),e.allowKeyboard&&this.wireKeyboardEvent()}}},i.prototype.hideItem=function(e,i){var s,n,r="object"==typeof e,l=e,o=[].slice.call(t.selectAll("."+oe,this.element));if(r)n=e;else if(this.tbarEle[l]){n=[].slice.call(t.selectAll("."+oe,this.element))[l]}if(n){if(i?n.classList.add(Oe):n.classList.remove(Oe),i&&t.isNullOrUndefined(this.element.getAttribute("tabindex"))&&!n.classList.contains(de)){if(t.isNullOrUndefined(n.firstElementChild.getAttribute("tabindex"))){n.firstElementChild.setAttribute("tabindex","-1");var a=[].slice.call(t.selectAll("."+oe,this.element));r&&(l=a.indexOf(n));for(var d=a[++l];d;){if(!this.eleContains(d)){d.firstElementChild.removeAttribute("tabindex");break}d=a[++l]}}}else if(t.isNullOrUndefined(this.element.getAttribute("tabindex"))&&!n.classList.contains(de))for(var h=!1,c=!1,p=o[s=0];p;)if(p.classList.contains(de))p=o[++s];else if(t.isNullOrUndefined(p.firstElementChild.getAttribute("tabindex")))p.firstElementChild.setAttribute("tabindex","-1"),h=!0;else{if(h&&c)break;this.eleContains(p)||(p.firstElementChild.removeAttribute("tabindex"),c=!0),p=o[++s]}this.refreshOverflow()}},ne([t.Collection([],De)],i.prototype,"items",void 0),ne([t.Property("auto")],i.prototype,"width",void 0),ne([t.Property("auto")],i.prototype,"height",void 0),ne([t.Property("")],i.prototype,"cssClass",void 0),ne([t.Property("Scrollable")],i.prototype,"overflowMode",void 0),ne([t.Property()],i.prototype,"scrollStep",void 0),ne([t.Property(!0)],i.prototype,"enableCollision",void 0),ne([t.Property(!0)],i.prototype,"enableHtmlSanitizer",void 0),ne([t.Property(!0)],i.prototype,"allowKeyboard",void 0),ne([t.Event()],i.prototype,"clicked",void 0),ne([t.Event()],i.prototype,"created",void 0),ne([t.Event()],i.prototype,"destroyed",void 0),ne([t.Event()],i.prototype,"beforeCreate",void 0),i=ne([t.NotifyPropertyChanges],i)}(t.Component),Pe=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),Te=function(e,t,i,s){var n,r=arguments.length,l=r<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)l=Reflect.decorate(e,t,i,s);else for(var o=e.length-1;o>=0;o--)(n=e[o])&&(l=(r<3?n(l):r>3?n(t,i,l):n(t,i))||l);return r>3&&l&&Object.defineProperty(t,i,l),l},He="e-acrdn-root",Ue="e-accordion",Re="e-acrdn-item",Be="e-acrdn-header",je="e-acrdn-header-content",qe="e-acrdn-panel",Fe="e-acrdn-content",We="e-toggle-icon",Ve="e-content-hide",_e="e-selected",ze="e-active",Ke="e-overlay",Ye="e-toggle-animation",Xe="e-expand-state",Ge="e-accordion-container",Qe=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return Pe(i,e),Te([t.Property("SlideDown")],i.prototype,"effect",void 0),Te([t.Property(400)],i.prototype,"duration",void 0),Te([t.Property("linear")],i.prototype,"easing",void 0),i}(t.ChildProperty),Je=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return Pe(i,e),Te([t.Complex({effect:"SlideUp",duration:400,easing:"linear"},Qe)],i.prototype,"collapse",void 0),Te([t.Complex({effect:"SlideDown",duration:400,easing:"linear"},Qe)],i.prototype,"expand",void 0),i}(t.ChildProperty),Ze=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return Pe(i,e),Te([t.Property(null)],i.prototype,"content",void 0),Te([t.Property(null)],i.prototype,"header",void 0),Te([t.Property(null)],i.prototype,"cssClass",void 0),Te([t.Property(null)],i.prototype,"iconCss",void 0),Te([t.Property(!1)],i.prototype,"expanded",void 0),Te([t.Property(!0)],i.prototype,"visible",void 0),Te([t.Property(!1)],i.prototype,"disabled",void 0),Te([t.Property()],i.prototype,"id",void 0),i}(t.ChildProperty),$e=function(e){function i(t,i){var s=e.call(this,t,i)||this;return s.keyConfigs={moveUp:"uparrow",moveDown:"downarrow",enter:"enter",space:"space",home:"home",end:"end"},s}return Pe(i,e),i.prototype.destroy=function(){var i=this;(this.isReact||this.isAngular||this.isVue)&&this.clearTemplate();var s=this.element;if(e.prototype.destroy.call(this),this.unwireEvents(),this.isDestroy=!0,this.restoreContent(null),[].slice.call(s.children).forEach(function(e){s.removeChild(e)}),this.trgtEle){for(this.trgtEle=null;this.ctrlTem.firstElementChild;)s.appendChild(this.ctrlTem.firstElementChild);this.ctrlTem=null}s.classList.remove(He),s.removeAttribute("style"),["aria-disabled","aria-multiselectable","role","data-ripple"].forEach(function(e){i.element.removeAttribute(e)}),!this.isNested&&t.isRippleEnabled&&this.removeRippleEffect()},i.prototype.preRender=function(){var e=t.closest(this.element,"."+qe);this.isNested=!1,this.templateEle=[],this.isDestroy||(this.isDestroy=!1),t.isNullOrUndefined(e)?this.element.classList.add(He):(e.classList.add("e-nested"),this.isNested=!0),this.enableRtl&&this.add(this.element,"e-rtl")},i.prototype.add=function(e,t){e.classList.add(t)},i.prototype.remove=function(e,t){e.classList.remove(t)},i.prototype.render=function(){this.initializeHeaderTemplate(),this.initializeItemTemplate(),this.initialize(),this.renderControl(),this.wireEvents(),this.renderComplete()},i.prototype.initialize=function(){var e=t.formatUnit(this.width),i=t.formatUnit(this.height);t.setStyleAttribute(this.element,{width:e,height:i});t.isNullOrUndefined(this.initExpand)&&(this.initExpand=[]),this.expandedIndices.length>0&&(this.initExpand=this.expandedIndices),t.attributes(this.element,{"aria-disabled":"false",role:"presentation","aria-multiselectable":"true"}),"Single"===this.expandMode&&this.element.setAttribute("aria-multiselectable","false")},i.prototype.renderControl=function(){this.trgtEle=this.element.children.length>0?t.select("div",this.element):null,this.renderItems(),this.initItemExpand()},i.prototype.wireFocusEvents=function(){for(var e=0,i=[].slice.call(this.element.querySelectorAll("."+Re));e<i.length;e++){var s=i[e],n=s.querySelector("."+Be);s.childElementCount>0&&n&&(t.EventHandler.clearEvents(n),t.EventHandler.add(n,"focus",this.focusIn,this),t.EventHandler.add(n,"blur",this.focusOut,this))}},i.prototype.unwireEvents=function(){t.EventHandler.remove(this.element,"click",this.clickHandler),t.isNullOrUndefined(this.keyModule)||this.keyModule.destroy()},i.prototype.wireEvents=function(){t.EventHandler.add(this.element,"click",this.clickHandler,this),this.isNested||this.isDestroy||(this.removeRippleEffect=t.rippleEffect(this.element,{selector:"."+Be})),this.isNested||(this.keyModule=new t.KeyboardEvents(this.element,{keyAction:this.keyActionHandler.bind(this),keyConfigs:this.keyConfigs,eventName:"keydown"}))},i.prototype.templateParser=function(e){if(e)try{if(document.querySelectorAll(e).length)return t.compile(document.querySelector(e).innerHTML.trim())}catch(i){return t.compile(e)}},i.prototype.initializeHeaderTemplate=function(){this.headerTemplate&&(this.headerTemplateFn=this.templateParser(this.headerTemplate))},i.prototype.initializeItemTemplate=function(){this.itemTemplate&&(this.itemTemplateFn=this.templateParser(this.itemTemplate))},i.prototype.getHeaderTemplate=function(){return this.headerTemplateFn},i.prototype.getItemTemplate=function(){return this.itemTemplateFn},i.prototype.focusIn=function(e){e.target.parentElement.classList.add("e-item-focus")},i.prototype.focusOut=function(e){e.target.parentElement.classList.remove("e-item-focus")},i.prototype.ctrlTemplate=function(){this.ctrlTem=this.element.cloneNode(!0);var e,i=t.select("."+Ge,this.element);e=i?i.children:this.element.children;var s=[];[].slice.call(e).forEach(function(e){s.push({header:e.childElementCount>0&&e.children[0]?e.children[0]:"",content:e.childElementCount>1&&e.children[1]?e.children[1]:""}),e.parentNode.removeChild(e)}),i&&this.element.removeChild(i),this.setProperties({items:s},!0)},i.prototype.toggleIconGenerate=function(){var e=this.createElement("div",{className:We}),t=this.createElement("span",{className:"e-tgl-collapse-icon e-icons"});return e.appendChild(t),e},i.prototype.initItemExpand=function(){var e=this.initExpand.length;if(0!==e){if("Single"===this.expandMode)this.expandItem(!0,this.initExpand[e-1]);else for(var t=0;t<e;t++)this.expandItem(!0,this.initExpand[t]);this.isReact&&this.renderReactTemplates()}},i.prototype.renderItems=function(){var e,i,s=this,n=this.element;if(t.isNullOrUndefined(this.trgtEle)||this.ctrlTemplate(),this.dataSource.length>0)this.dataSource.forEach(function(e,r){i=s.renderInnerItem(e,r),n.appendChild(i),i.childElementCount>0&&(t.EventHandler.add(i.querySelector("."+Be),"focus",s.focusIn,s),t.EventHandler.add(i.querySelector("."+Be),"blur",s.focusOut,s))});else{var r=this.items;n&&r.length>0&&r.forEach(function(i,r){e=s.renderInnerItem(i,r),n.appendChild(e),e.childElementCount>0&&(t.EventHandler.add(e.querySelector("."+Be),"focus",s.focusIn,s),t.EventHandler.add(e.querySelector("."+Be),"blur",s.focusOut,s))})}this.isReact&&this.renderReactTemplates()},i.prototype.clickHandler=function(e){var i,s=e.target,n=this.getItems(),r={};if(t.closest(s,"."+Ue)===this.element){s.classList.add("e-target");var l=t.closest(s,"."+Re),o=t.closest(s,"."+Be),a=t.closest(s,"."+qe);l&&(t.isNullOrUndefined(o)||t.isNullOrUndefined(a))&&(o=l.children[0],a=l.children[1]),o&&(i=t.select("."+We,o));var d;o?d=t.closest(o,"."+Re):a&&(d=t.closest(a,"."+Re));var h=this.getIndexByItem(l);d&&(r.item=n[this.getIndexByItem(d)]),r.originalEvent=e;!(!t.isNullOrUndefined(i)&&l.childElementCount<=1)||!t.isNullOrUndefined(a)&&t.isNullOrUndefined(t.select("."+Be+" ."+We,d))?this.afterContentRender(s,r,l,o,a,d):(l.appendChild(this.contentRendering(h)),this.ariaAttrUpdate(l),this.afterContentRender(s,r,l,o,a,d)),this.isReact&&this.renderReactTemplates()}},i.prototype.afterContentRender=function(e,i,s,n,r,l){var o=this,a=[];this.trigger("clicked",i);var d=r&&!t.isNullOrUndefined(t.select(".e-target",r)),h=r&&!t.isNullOrUndefined(t.select("."+Ue,r))&&t.isNullOrUndefined(t.closest(e,".e-acrdn-panel .e-accordion")),c=r&&t.isNullOrUndefined(t.select("."+Ue,r))||!(t.closest(e,"."+Ue)===this.element);if(d=d&&(h||c),e.classList.remove("e-target"),!(e.classList.contains(qe)||e.classList.contains(Fe)||d)){var p=this.element.querySelector("."+Ge),u=p?p.children:this.element.children;[].slice.call(u).forEach(function(e){e.classList.contains(ze)&&a.push(e)});var f=[].slice.call(this.element.querySelectorAll("."+Re+" [e-animate]"));if(f.length>0)for(var m=0,v=f;m<v.length;m++){var g=v[m];a.push(g.parentElement)}var y=-1!==a.indexOf(l)&&"true"===r.getAttribute("e-animate"),b=!1;if(!t.isNullOrUndefined(s)&&!t.isNullOrUndefined(n)){var C=t.select("."+qe,s),E=t.closest(s,"."+He).querySelector("."+Xe);if(t.isNullOrUndefined(C))return;b=E===s,!t.isVisible(C)||y&&!l.classList.contains(_e)?(a.length>0&&"Single"===this.expandMode&&!y&&a.forEach(function(e){o.collapse(t.select("."+qe,e)),e.classList.remove(Xe)}),this.expand(C)):this.collapse(C),t.isNullOrUndefined(E)||b||E.classList.remove(Xe)}}},i.prototype.eleMoveFocus=function(e,i,s){var n,r=t.closest(s,"."+Re);s===i?n=("moveUp"===e?s.lastElementChild:s).querySelector("."+Be):s.classList.contains(Be)&&(r="moveUp"===e?r.previousElementSibling:r.nextElementSibling)&&(n=t.select("."+Be,r)),n&&n.focus()},i.prototype.keyActionHandler=function(e){var i=e.target,s=t.closest(e.target,Be);if(!t.isNullOrUndefined(s)||i.classList.contains(Ue)||i.classList.contains(Be)){var n,r=this.element;switch(e.action){case"moveUp":case"moveDown":this.eleMoveFocus(e.action,r,i);break;case"space":case"enter":n=i.nextElementSibling,!t.isNullOrUndefined(n)&&n.classList.contains(qe)?"true"!==n.getAttribute("e-animate")&&i.click():i.click(),e.preventDefault();break;case"home":case"end":("home"===e.action?r.firstElementChild.children[0]:r.lastElementChild.children[0]).focus(),e.preventDefault()}}},i.prototype.headerEleGenerate=function(){var e=this.createElement("div",{className:Be,id:t.getUniqueID("acrdn_header")}),i={tabindex:"0",role:"heading","aria-label":"collapsed","aria-disabled":"false","aria-level":this.getItems().length.toString()};return t.attributes(e,i),e},i.prototype.renderInnerItem=function(e,i){var s=this.createElement("div",{className:Re,id:e.id||t.getUniqueID("acrdn_item"),attrs:{"aria-expanded":"false",role:"row"}});if(this.headerTemplate){var n=this.headerEleGenerate(),r=this.createElement("div",{className:je});return n.appendChild(r),t.append(this.getHeaderTemplate()(e,this,"headerTemplate",this.element.id+"_headerTemplate",!1),r),s.appendChild(n),n.appendChild(this.toggleIconGenerate()),this.add(s,"e-select"),s}if(e.header&&this.angularnativeCondiCheck(e,"header")){this.enableHtmlSanitizer&&"string"==typeof e.header&&(e.header=t.SanitizeHtmlHelper.sanitize(e.header));n=this.headerEleGenerate(),r=this.createElement("div",{className:je});n.appendChild(r),n.appendChild(this.fetchElement(r,e.header,i,!0)),s.appendChild(n)}var l=t.select("."+Be,s);if(!e.expanded||t.isNullOrUndefined(i)||this.enablePersistence||-1===this.initExpand.indexOf(i)&&this.initExpand.push(i),e.cssClass&&t.addClass([s],e.cssClass.split(" ")),e.disabled&&t.addClass([s],Ke),!1===e.visible&&t.addClass([s],"e-hide"),e.iconCss){var o=this.createElement("div",{className:"e-acrdn-header-icon"}),a=this.createElement("span",{className:e.iconCss+" e-icons"});o.appendChild(a),t.isNullOrUndefined(l)?((l=this.headerEleGenerate()).appendChild(o),s.appendChild(l)):l.insertBefore(o,l.childNodes[0])}if(e.content&&this.angularnativeCondiCheck(e,"content")){var d=this.toggleIconGenerate();t.isNullOrUndefined(l)&&(l=this.headerEleGenerate(),s.appendChild(l)),l.appendChild(d),this.add(s,"e-select")}return s},i.prototype.angularnativeCondiCheck=function(e,i){var s="content"===i?e.content:e.header;if(this.isAngular&&!t.isNullOrUndefined(s.elementRef)){var n=s.elementRef.nativeElement.data;if(t.isNullOrUndefined(n)||""===n||-1===n.indexOf("bindings="))return!0;var r=JSON.parse(s.elementRef.nativeElement.data.replace("bindings=",""));return!(!t.isNullOrUndefined(r)&&"false"===r["ng-reflect-ng-if"])}return!0},i.prototype.fetchElement=function(e,i,s,n){var r,l;try{if(document.querySelectorAll(i).length&&"Button"!==i){var o=document.querySelector(i);l=o.outerHTML.trim(),e.appendChild(o),o.style.display=""}}catch(s){"string"==typeof i?e.innerHTML=t.SanitizeHtmlHelper.sanitize(i):!t.isNullOrUndefined(this.trgtEle)&&i instanceof HTMLElement?(e.appendChild(i),e.firstElementChild.style.display=""):r=t.compile(i)}var a;if(!t.isNullOrUndefined(r)){this.isReact&&this.renderReactTemplates();var d=void 0,h=void 0;e.classList.contains(je)?(d=this.element.id+s+"_header",h="header"):e.classList.contains(Fe)&&(d=this.element.id+s+"_content",h="content"),a=r({},this,h,d,this.isStringTemplate)}return t.isNullOrUndefined(a)||!(a.length>0)||t.isNullOrUndefined(a[0].tagName)&&1===a.length?0===e.childElementCount&&(e.innerHTML=t.SanitizeHtmlHelper.sanitize(i)):[].slice.call(a).forEach(function(i){t.isNullOrUndefined(i.tagName)||(i.style.display=""),e.appendChild(i)}),t.isNullOrUndefined(l)||-1===this.templateEle.indexOf(i)&&this.templateEle.push(i),e},i.prototype.ariaAttrUpdate=function(e){var i=t.select("."+Be,e),s=t.select("."+qe,e);i.setAttribute("aria-controls",s.id),s.setAttribute("aria-labelledby",i.id),s.setAttribute("role","definition")},i.prototype.contentRendering=function(e){var i=this.createElement("div",{className:qe+" "+Ve,id:t.getUniqueID("acrdn_panel")});t.attributes(i,{"aria-hidden":"true"});var s=this.createElement("div",{className:Fe});return this.dataSource.length>0?(this.isReact&&this.renderReactTemplates(),t.append(this.getItemTemplate()(this.dataSource[e],this,"itemTemplate",this.element.id+"_itemTemplate",!1),s),i.appendChild(s)):(this.enableHtmlSanitizer&&(this.items[e].content,1)&&(this.items[e].content=t.SanitizeHtmlHelper.sanitize(this.items[e].content)),i.appendChild(this.fetchElement(s,this.items[e].content,e,!1))),i},i.prototype.expand=function(e){var i=this,s=this.getItems(),n=t.closest(e,"."+Re);if(!(t.isNullOrUndefined(e)||t.isVisible(e)&&"true"!==e.getAttribute("e-animate")||n.classList.contains(Ke))){var r=t.closest(n,"."+He).querySelector("."+Xe),l={name:this.animation.expand.effect,duration:this.animation.expand.duration,timingFunction:this.animation.expand.easing},o=t.select("."+We,n).firstElementChild,a={element:n,item:s[this.getIndexByItem(n)],index:this.getIndexByItem(n),content:n.querySelector("."+qe),isExpanded:!0};this.trigger("expanding",a,function(s){s.cancel||(o.classList.add(Ye),i.expandedItemsPush(n),t.isNullOrUndefined(r)||r.classList.remove(Xe),n.classList.add(Xe),"None"===l.name?(i.expandProgress("begin",o,e,n,s),i.expandProgress("end",o,e,n,s)):i.expandAnimation(l.name,o,e,n,l,s))})}},i.prototype.expandAnimation=function(e,i,s,n,r,l){var o,a=this;this.lastActiveItemId=n.id,"SlideDown"===e?(r.begin=function(){a.expandProgress("begin",i,s,n,l),s.style.position="absolute",o=n.offsetHeight,s.style.maxHeight=s.offsetHeight+"px",n.style.maxHeight=""},r.progress=function(){n.style.minHeight=o+s.offsetHeight+"px"},r.end=function(){t.setStyleAttribute(s,{position:"",maxHeight:""}),n.style.minHeight="",a.expandProgress("end",i,s,n,l)}):(r.begin=function(){a.expandProgress("begin",i,s,n,l)},r.end=function(){a.expandProgress("end",i,s,n,l)}),new t.Animation(r).animate(s)},i.prototype.expandProgress=function(e,i,s,n,r){this.remove(s,Ve),this.add(n,_e),this.add(i,"e-expand-icon"),"end"===e&&(this.add(n,ze),s.setAttribute("aria-hidden","false"),t.attributes(n,{"aria-expanded":"true"}),t.attributes(s.previousElementSibling,{"aria-label":"expanded"}),i.classList.remove(Ye),this.trigger("expanded",r))},i.prototype.expandedItemsPush=function(e){var t=this.getIndexByItem(e);if(-1===this.expandedIndices.indexOf(t)){var i=[].slice.call(this.expandedIndices);i.push(t),this.setProperties({expandedIndices:i},!0)}},i.prototype.getIndexByItem=function(e){var t=this.getItemElements();return[].slice.call(t).indexOf(e)},i.prototype.getItemElements=function(){var e=[],t=this.element.children;return[].slice.call(t).forEach(function(t){t.classList.contains(Re)&&e.push(t)}),e},i.prototype.expandedItemsPop=function(e){var t=this.getIndexByItem(e),i=[].slice.call(this.expandedIndices);i.splice(i.indexOf(t),1),this.setProperties({expandedIndices:i},!0)},i.prototype.collapse=function(e){var i=this,s=this.getItems(),n=t.closest(e,"."+Re);if(!t.isNullOrUndefined(e)&&t.isVisible(e)&&!n.classList.contains(Ke)){var r={name:this.animation.collapse.effect,duration:this.animation.collapse.duration,timingFunction:this.animation.collapse.easing},l=t.select("."+We,n).firstElementChild,o={element:n,item:s[this.getIndexByItem(n)],index:this.getIndexByItem(n),content:n.querySelector("."+qe),isExpanded:!1};this.trigger("expanding",o,function(t){t.cancel||(i.expandedItemsPop(n),n.classList.remove(Xe),l.classList.add(Ye),"None"===r.name?(i.collapseProgress("begin",l,e,n,t),i.collapseProgress("end",l,e,n,t)):i.collapseAnimation(r.name,e,n,l,r,t))})}},i.prototype.collapseAnimation=function(e,i,s,n,r,l){var o,a,d,h,c=this;this.lastActiveItemId=s.id,"SlideUp"===e?(r.begin=function(){d=s.offsetHeight,s.style.minHeight=d+"px",i.style.position="absolute",o=s.offsetHeight,a=i.offsetHeight,i.style.maxHeight=a+"px",c.collapseProgress("begin",n,i,s,l)},r.progress=function(){(h=o-(a-i.offsetHeight))<d&&(s.style.minHeight=h+"px")},r.end=function(){i.style.display="none",c.collapseProgress("end",n,i,s,l),s.style.minHeight="",t.setStyleAttribute(i,{position:"",maxHeight:"",display:""})}):(r.begin=function(){c.collapseProgress("begin",n,i,s,l)},r.end=function(){c.collapseProgress("end",n,i,s,l)}),new t.Animation(r).animate(i)},i.prototype.collapseProgress=function(e,i,s,n,r){this.remove(i,"e-expand-icon"),this.remove(n,_e),"end"===e&&(this.add(s,Ve),i.classList.remove(Ye),this.remove(n,ze),s.setAttribute("aria-hidden","true"),t.attributes(n,{"aria-expanded":"false"}),t.attributes(s.previousElementSibling,{"aria-label":"collapsed"}),this.trigger("expanded",r))},i.prototype.getModuleName=function(){return"accordion"},i.prototype.itemAttribUpdate=function(){var e=this.getItems(),i=this.getItemElements(),s=e.length;i.forEach(function(e){t.select("."+Be,e).setAttribute("aria-level",""+s)})},i.prototype.getItems=function(){return this.itemTemplate&&this.headerTemplate?this.dataSource:this.items},i.prototype.addItem=function(e,i){var s=this,n=this.element,r=this.getItemElements(),l=this.getItems();if(t.isNullOrUndefined(i)&&(i=l.length),n.childElementCount>=i){(e instanceof Array?e:[e]).forEach(function(e,o){var a=i+o;l.splice(a,0,e);var d=s.renderInnerItem(e,a);n.childElementCount===a?n.appendChild(d):n.insertBefore(d,r[a]),t.EventHandler.add(d.querySelector("."+Be),"focus",s.focusIn,s),t.EventHandler.add(d.querySelector("."+Be),"blur",s.focusOut,s),s.itemAttribUpdate(),s.expandedIndices=[],s.expandedItemRefresh(n),e&&e.expanded&&s.expandItem(!0,a)})}this.isReact&&this.renderReactTemplates()},i.prototype.expandedItemRefresh=function(e){var t=this,i=this.getItemElements();[].slice.call(i).forEach(function(e){e.classList.contains(_e)&&t.expandedItemsPush(e)})},i.prototype.removeItem=function(e){this.isReact&&this.clearTemplate(["headerTemplate","itemTemplate"],e);var i=this.getItemElements()[e],s=this.getItems();t.isNullOrUndefined(i)||(this.restoreContent(e),t.detach(i),s.splice(e,1),this.itemAttribUpdate(),this.expandedIndices=[],this.expandedItemRefresh(this.element))},i.prototype.select=function(e){var i=this.getItemElements()[e];t.isNullOrUndefined(i)||t.isNullOrUndefined(t.select("."+Be,i))||i.children[0].focus()},i.prototype.hideItem=function(e,i){var s=this.getItemElements()[e];t.isNullOrUndefined(s)||(t.isNullOrUndefined(i)&&(i=!0),i?this.add(s,"e-hide"):this.remove(s,"e-hide"))},i.prototype.enableItem=function(e,i){var s=this.getItemElements()[e];if(!t.isNullOrUndefined(s)){var n=s.firstElementChild;i?(this.remove(s,Ke),t.attributes(n,{tabindex:"0","aria-disabled":"false"}),n.focus()):(s.classList.contains(ze)&&(this.expandItem(!1,e),this.eleMoveFocus("movedown",this.element,n)),this.add(s,Ke),n.setAttribute("aria-disabled","true"),n.removeAttribute("tabindex"))}},i.prototype.expandItem=function(e,i){var s=this,n=this.getItemElements();if(t.isNullOrUndefined(i))if("Single"===this.expandMode&&e){var r=n[n.length-1];this.itemExpand(e,r,this.getIndexByItem(r))}else{var l=t.select("#"+this.lastActiveItemId,this.element);[].slice.call(n).forEach(function(t){s.itemExpand(e,t,s.getIndexByItem(t)),t.classList.remove(Xe)});var o=t.select("."+Xe,this.element);o&&o.classList.remove(Xe),l&&l.classList.add(Xe)}else{r=n[i];if(t.isNullOrUndefined(r)||!r.classList.contains("e-select")||r.classList.contains(ze)&&e)return;"Single"===this.expandMode&&this.expandItem(!1),this.itemExpand(e,r,i)}},i.prototype.itemExpand=function(e,i,s){var n=i.children[1];i.classList.contains(Ke)||(t.isNullOrUndefined(n)&&e?(n=this.contentRendering(s),i.appendChild(n),this.ariaAttrUpdate(i),this.expand(n)):t.isNullOrUndefined(n)||(e?this.expand(n):this.collapse(n)),this.isReact&&this.renderReactTemplates())},i.prototype.destroyItems=function(){this.restoreContent(null),(this.isReact||this.isAngular||this.isVue)&&this.clearTemplate(),[].slice.call(this.element.querySelectorAll("."+Re)).forEach(function(e){t.detach(e)})},i.prototype.restoreContent=function(e){var i;i=t.isNullOrUndefined(e)?this.element:this.element.querySelectorAll("."+Re)[e],this.templateEle.forEach(function(e){t.isNullOrUndefined(i.querySelector(e))||(document.body.appendChild(i.querySelector(e)).style.display="none")})},i.prototype.updateItem=function(e,i){if(!t.isNullOrUndefined(e)){var s=this.getItems(),n=s[i];s.splice(i,1),this.restoreContent(i),t.detach(e),this.addItem(n,i)}},i.prototype.setTemplate=function(e,t,i){t.innerHTML="",this.templateCompile(t,e,i),this.isReact&&this.renderReactTemplates()},i.prototype.templateCompile=function(e,t,i){var s=this.createElement("div");this.fetchElement(s,t,i,!1),0!==s.childNodes.length&&[].slice.call(s.childNodes).forEach(function(t){e.appendChild(t)})},i.prototype.getPersistData=function(){return this.addOnPersist(["expandedIndices"])},i.prototype.onPropertyChanged=function(e,i){for(var s=this.element,n=!1,r=0,l=Object.keys(e);r<l.length;r++){switch(l[r]){case"items":if(e.items instanceof Array&&i.items instanceof Array)n=!0;else for(var o=Object.keys(e.items),a=0;a<o.length;a++){var d=parseInt(Object.keys(e.items)[a],10),h=Object.keys(e.items[d])[0],c=t.selectAll("."+Re,this.element)[d],p=Object(i.items[d])[h],u=Object(e.items[d])[h];if(("header"===h||"iconCss"===h||"expanded"===h||"content"===h&&""===p)&&this.updateItem(c,d),"cssClass"!==h||t.isNullOrUndefined(c)||(c.classList.remove(p),c.classList.add(u)),"visible"!==h||t.isNullOrUndefined(c)||(!1===Object(e.items[d])[h]?c.classList.add("e-hide"):c.classList.remove("e-hide")),"disabled"!==h||t.isNullOrUndefined(c)||this.enableItem(d,!u),"content"===h&&!t.isNullOrUndefined(c)&&2===c.children.length)if("function"==typeof u){var f=c.querySelector("."+Fe);f.innerHTML="",this.setTemplate(u,f,d)}else c.classList.contains(_e)&&this.expandItem(!1,d),t.detach(c.querySelector("."+qe))}break;case"dataSource":case"expandedIndices":null===this.expandedIndices&&(this.expandedIndices=[]),n=!0;break;case"headerTemplate":this.initializeHeaderTemplate(),n=!0;break;case"itemTemplate":this.initializeItemTemplate(),n=!0;break;case"enableRtl":e.enableRtl?this.add(s,"e-rtl"):this.remove(s,"e-rtl");break;case"height":t.setStyleAttribute(this.element,{height:t.formatUnit(e.height)});break;case"width":t.setStyleAttribute(this.element,{width:t.formatUnit(e.width)});break;case"expandMode":"Single"===e.expandMode?(this.element.setAttribute("aria-multiselectable","false"),this.expandedIndices.length>1&&this.expandItem(!1)):this.element.setAttribute("aria-multiselectable","true")}}n&&(this.initExpand=[],this.expandedIndices.length>0&&(this.initExpand=this.expandedIndices),this.destroyItems(),this.renderItems(),this.initItemExpand())},Te([t.Collection([],Ze)],i.prototype,"items",void 0),Te([t.Property([])],i.prototype,"dataSource",void 0),Te([t.Property()],i.prototype,"itemTemplate",void 0),Te([t.Property()],i.prototype,"headerTemplate",void 0),Te([t.Property("100%")],i.prototype,"width",void 0),Te([t.Property("auto")],i.prototype,"height",void 0),Te([t.Property([])],i.prototype,"expandedIndices",void 0),Te([t.Property("Multiple")],i.prototype,"expandMode",void 0),Te([t.Property(!1)],i.prototype,"enableHtmlSanitizer",void 0),Te([t.Complex({},Je)],i.prototype,"animation",void 0),Te([t.Event()],i.prototype,"clicked",void 0),Te([t.Event()],i.prototype,"expanding",void 0),Te([t.Event()],i.prototype,"expanded",void 0),Te([t.Event()],i.prototype,"created",void 0),Te([t.Event()],i.prototype,"destroyed",void 0),i=Te([t.NotifyPropertyChanges],i)}(t.Component),et=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),tt=function(e,t,i,s){var n,r=arguments.length,l=r<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)l=Reflect.decorate(e,t,i,s);else for(var o=e.length-1;o>=0;o--)(n=e[o])&&(l=(r<3?n(l):r>3?n(t,i,l):n(t,i))||l);return r>3&&l&&Object.defineProperty(t,i,l),l},it=function(e){function i(t,i){return e.call(this,t,i)||this}return et(i,e),i.prototype.preRender=function(){this.isMenu=!1,this.element.id=this.element.id||t.getUniqueID("ej2-contextmenu"),e.prototype.preRender.call(this)},i.prototype.initialize=function(){e.prototype.initialize.call(this),t.attributes(this.element,{role:"menubar",tabindex:"0"}),this.element.style.zIndex=s.getZindexPartial(this.element).toString()},i.prototype.open=function(t,i,s){e.prototype.openMenu.call(this,null,null,t,i,null,s)},i.prototype.close=function(){e.prototype.closeMenu.call(this)},i.prototype.onPropertyChanged=function(t,i){e.prototype.onPropertyChanged.call(this,t,i);for(var s=0,n=Object.keys(t);s<n.length;s++){switch(n[s]){case"filter":this.close(),this.filter=t.filter;break;case"target":this.unWireEvents(i.target),this.wireEvents()}}},i.prototype.getModuleName=function(){return"contextmenu"},tt([t.Property("")],i.prototype,"target",void 0),tt([t.Property("")],i.prototype,"filter",void 0),tt([t.Collection([],ee)],i.prototype,"items",void 0),i=tt([t.NotifyPropertyChanges],i)}(ie),st=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),nt=function(e,t,i,s){var n,r=arguments.length,l=r<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)l=Reflect.decorate(e,t,i,s);else for(var o=e.length-1;o>=0;o--)(n=e[o])&&(l=(r<3?n(l):r>3?n(t,i,l):n(t,i))||l);return r>3&&l&&Object.defineProperty(t,i,l),l},rt="e-vertical",lt="e-hamburger",ot=function(e){function i(t,i){var s=e.call(this,t,i)||this;return s.tempItems=[],s}return st(i,e),i.prototype.getModuleName=function(){return"menu"},i.prototype.preRender=function(){if(this.isMenu=!0,this.element.id=this.element.id||t.getUniqueID("ej2-menu"),this.template)try{document.querySelectorAll(this.template).length&&(this.template=document.querySelector(this.template).innerHTML.trim(),this.clearChanges())}catch(e){}else this.updateMenuItems(this.items);e.prototype.preRender.call(this)},i.prototype.initialize=function(){e.prototype.initialize.call(this),t.attributes(this.element,{role:"menubar",tabindex:"0"}),"Vertical"===this.orientation?(this.element.classList.add(rt),this.hamburgerMode&&!this.target&&this.element.previousElementSibling.classList.add(rt),this.element.setAttribute("aria-orientation","vertical")):t.Browser.isDevice&&!this.enableScrolling&&this.element.parentElement.classList.add("e-scrollable"),this.hamburgerMode&&(this.element.parentElement.classList.add(lt),"Horizontal"===this.orientation&&this.element.classList.add("e-hide-menu"))},i.prototype.updateMenuItems=function(e){this.tempItems=e,this.items=[],this.tempItems.map(this.createMenuItems,this),this.setProperties({items:this.items},!0),this.tempItems=[]},i.prototype.onPropertyChanged=function(i,s){for(var n=this,r=0,l=Object.keys(i);r<l.length;r++){switch(l[r]){case"orientation":"Vertical"===i.orientation?(this.element.classList.add(rt),this.hamburgerMode&&(this.target||this.element.previousElementSibling.classList.add(rt),this.element.classList.remove("e-hide-menu")),this.element.setAttribute("aria-orientation","vertical")):(this.element.classList.remove(rt),this.hamburgerMode&&(this.target||this.element.previousElementSibling.classList.remove(rt),this.element.classList.add("e-hide-menu")),this.element.removeAttribute("aria-orientation"));break;case"items":Object.keys(s.items).length||this.updateMenuItems(i.items);break;case"hamburgerMode":this.element.previousElementSibling||e.prototype.createHeaderContainer.call(this),i.hamburgerMode?(this.element.parentElement.classList.add(lt),[].slice.call(this.element.getElementsByClassName("e-blankicon")).forEach(function(e){e.style[n.enableRtl?"paddingRight":"paddingLeft"]=""})):(this.element.parentElement.classList.remove(lt),"Vertical"===this.orientation&&this.setBlankIconStyle(this.element)),"Vertical"===this.orientation?(this.target||this.element.previousElementSibling.classList.add(rt),this.element.classList.remove("e-hide-menu")):(this.target?this.element.previousElementSibling.classList.add(rt):this.element.previousElementSibling.classList.remove(rt),this.element.classList[i.hamburgerMode?"add":"remove"]("e-hide-menu"));break;case"title":this.hamburgerMode&&this.element.previousElementSibling&&(i.title=this.enableHtmlSanitizer?t.SanitizeHtmlHelper.sanitize(i.title):i.title,this.element.previousElementSibling.querySelector(".e-menu-title").innerHTML=i.title);break;case"target":this.hamburgerMode&&(this.unWireEvents(s.target),this.wireEvents(),"Horizontal"===this.orientation&&(i.target?this.element.previousElementSibling.classList.add(rt):(this.element.previousElementSibling||e.prototype.createHeaderContainer.call(this),this.element.previousElementSibling.classList.remove(rt)),this.element.classList.add("e-hide-menu")))}}e.prototype.onPropertyChanged.call(this,i,s)},i.prototype.createMenuItems=function(e){var t,i,s=this.items,n=this.getField("parentId");if(e[n]){for(t=this.getIndex(e[n].toString(),!0),i=0;i<t.length;i++)s[t[i]].items||(s[t[i]].items=[]),s=s[t[i]].items;s.push(e)}else this.items.push(e)},i.prototype.open=function(){e.prototype.openHamburgerMenu.call(this)},i.prototype.close=function(){e.prototype.closeHamburgerMenu.call(this)},nt([t.Property("Horizontal")],i.prototype,"orientation",void 0),nt([t.Property("")],i.prototype,"target",void 0),nt([t.Property(null)],i.prototype,"template",void 0),nt([t.Property(!1)],i.prototype,"enableScrolling",void 0),nt([t.Property(!1)],i.prototype,"hamburgerMode",void 0),nt([t.Property("Menu")],i.prototype,"title",void 0),nt([t.Property(!1)],i.prototype,"enableHtmlSanitizer",void 0),nt([t.Complex({itemId:"id",text:"text",parentId:"parentId",iconCss:"iconCss",url:"url",separator:"separator",children:"items"},$)],i.prototype,"fields",void 0),i=nt([t.NotifyPropertyChanges],i)}(ie),at=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),dt=function(e,t,i,s){var n,r=arguments.length,l=r<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)l=Reflect.decorate(e,t,i,s);else for(var o=e.length-1;o>=0;o--)(n=e[o])&&(l=(r<3?n(l):r>3?n(t,i,l):n(t,i))||l);return r>3&&l&&Object.defineProperty(t,i,l),l},ht="e-tab-header",ct="e-content",pt="e-nested",ut="e-item",ft="e-template",mt="e-active",vt="e-disable",gt="e-hidden",yt="e-close-icon",bt="e-close-show",Ct="e-tab-text",Et="e-indicator",Nt="e-tab-wrap",xt="e-text-wrap",Ot="e-toolbar-items",It="e-toolbar-item",St="e-toolbar-popup",wt="e-progress",kt="e-vertical-tab",Lt="e-vertical",At="e-vertical-right",Dt="e-horizontal-bottom",Mt="e-fill-mode",Pt="e-reorder-active-item",Tt=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return at(i,e),dt([t.Property("SlideLeftIn")],i.prototype,"effect",void 0),dt([t.Property(600)],i.prototype,"duration",void 0),dt([t.Property("ease")],i.prototype,"easing",void 0),i}(t.ChildProperty),Ht=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return at(i,e),dt([t.Complex({effect:"SlideLeftIn",duration:600,easing:"ease"},Tt)],i.prototype,"previous",void 0),dt([t.Complex({effect:"SlideRightIn",duration:600,easing:"ease"},Tt)],i.prototype,"next",void 0),i}(t.ChildProperty),Ut=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return at(i,e),dt([t.Property("")],i.prototype,"text",void 0),dt([t.Property("")],i.prototype,"iconCss",void 0),dt([t.Property("left")],i.prototype,"iconPosition",void 0),i}(t.ChildProperty),Rt=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return at(i,e),dt([t.Complex({},Ut)],i.prototype,"header",void 0),dt([t.Property(null)],i.prototype,"headerTemplate",void 0),dt([t.Property("")],i.prototype,"content",void 0),dt([t.Property("")],i.prototype,"cssClass",void 0),dt([t.Property(!1)],i.prototype,"disabled",void 0),dt([t.Property(!0)],i.prototype,"visible",void 0),dt([t.Property()],i.prototype,"id",void 0),i}(t.ChildProperty),Bt=function(e){function i(t,i){var s=e.call(this,t,i)||this;return s.show={},s.hide={},s.maxHeight=0,s.title="Close",s.isInteracted=!1,s.lastIndex=0,s.isAdd=!1,s.isIconAlone=!1,s.draggableItems=[],s.resizeContext=s.refreshActiveTabBorder.bind(s),s.keyConfigs={tab:"tab",home:"home",end:"end",enter:"enter",space:"space",delete:"delete",moveLeft:"leftarrow",moveRight:"rightarrow",moveUp:"uparrow",moveDown:"downarrow"},s}return at(i,e),i.prototype.destroy=function(){var i=this;if(this.isReact&&this.clearTemplate(),t.isNullOrUndefined(this.tbObj)||this.tbObj.destroy(),this.unWireEvents(),["role","aria-disabled","aria-activedescendant","tabindex","aria-orientation"].forEach(function(e){i.element.removeAttribute(e)}),this.expTemplateContent(),this.isTemplate){var s=t.select(".e-tab > ."+ct,this.element);this.element.classList.remove(ft),t.isNullOrUndefined(s)||(s.innerHTML=this.cnt)}else for(;this.element.firstElementChild;)t.remove(this.element.firstElementChild);e.prototype.destroy.call(this),this.trigger("destroyed")},i.prototype.refresh=function(){this.isReact&&this.clearTemplate(),e.prototype.refresh.call(this),this.isReact&&this.renderReactTemplates()},i.prototype.preRender=function(){var e=t.closest(this.element,"."+ct);this.prevIndex=0,this.isNested=!1,this.isPopup=!1,this.initRender=!0,this.isSwipeed=!1,this.itemIndexArray=[],this.templateEle=[],t.isNullOrUndefined(e)||(e.parentElement.classList.add(pt),this.isNested=!0);var i=t.Browser.info.name,s="msie"===i?"e-ie":"edge"===i?"e-edge":"safari"===i?"e-safari":"";t.setStyleAttribute(this.element,{width:t.formatUnit(this.width),height:t.formatUnit(this.height)}),this.setCssClass(this.element,this.cssClass,!0),t.attributes(this.element,{role:"tablist","aria-disabled":"false","aria-activedescendant":""}),this.setCssClass(this.element,s,!0),this.updatePopAnimationConfig()},i.prototype.render=function(){this.btnCls=this.createElement("span",{className:"e-icons "+yt,attrs:{title:this.title}}),this.tabId=this.element.id.length>0?"-"+this.element.id:t.getRandomId(),this.renderContainer(),this.wireEvents(),this.initRender=!1},i.prototype.renderContainer=function(){var e=this.element;if(this.items.forEach(function(e,i){t.isNullOrUndefined(e.id)&&!t.isNullOrUndefined(e.setProperties)&&e.setProperties({id:"tabitem_"+i.toString()},!0)}),this.items.length>0&&0===e.children.length)e.appendChild(this.createElement("div",{className:ct})),this.setOrientation(this.headerPlacement,this.createElement("div",{className:ht})),this.isTemplate=!1;else if(this.element.children.length>0){this.isTemplate=!0,e.classList.add(ft);var i=e.querySelector("."+ht);i&&"Bottom"===this.headerPlacement&&this.setOrientation(this.headerPlacement,i)}if(!t.isNullOrUndefined(t.select("."+ht,this.element))&&!t.isNullOrUndefined(t.select("."+ct,this.element))){if(this.renderHeader(),this.tbItems=t.select("."+ht+" ."+Ot,this.element),t.isNullOrUndefined(this.tbItems)||t.rippleEffect(this.tbItems,{selector:".e-tab-wrap"}),this.renderContent(),t.selectAll("."+It,this.element).length>0){this.tbItems=t.select("."+ht+" ."+Ot,this.element),this.bdrLine=this.createElement("div",{className:Et+" "+gt+" e-ignore"});var s=t.select("."+this.scrCntClass,this.tbItems);t.isNullOrUndefined(s)?this.tbItems.insertBefore(this.bdrLine,this.tbItems.firstChild):s.insertBefore(this.bdrLine,s.firstChild),this.setContentHeight(!0),this.select(this.selectedItem)}if(!t.isNullOrUndefined(this.tbItem))for(var n=0;n<this.items.length;n++){var r=this.items[n].id;this.tbItem[n].setAttribute("data-id",r)}this.setRTL(this.enableRtl)}},i.prototype.serverItemsChanged=function(){if(this.enableAnimation=!1,this.setActive(this.selectedItem,!0),"Dynamic"!==this.loadOn&&!t.isNullOrUndefined(this.cntEle)){var e=[].slice.call(this.cntEle.children),i=ct+this.tabId+"_"+this.selectedItem;e.forEach(function(e){e.classList.contains(mt)&&e.id!==i&&e.classList.remove(mt),e.id===i&&e.classList.add(mt)}),this.prevIndex=this.selectedItem,this.triggerAnimation(ut+this.tabId+"_"+this.selectedItem,!1)}this.enableAnimation=!0},i.prototype.headerReady=function(){if(this.initRender=!0,this.hdrEle=this.getTabHeader(),this.setOrientation(this.headerPlacement,this.hdrEle),t.isNullOrUndefined(this.hdrEle)||(this.tbObj=this.hdrEle&&this.hdrEle.ej2_instances[0]),this.tbObj.clicked=this.clickHandler.bind(this),this.tbObj.on("onItemsChanged",this.serverItemsChanged.bind(this)),this.tbItems=t.select("."+ht+" ."+Ot,this.element),t.isNullOrUndefined(this.tbItems)||t.rippleEffect(this.tbItems,{selector:".e-tab-wrap"}),t.selectAll("."+It,this.element).length>0){this.bdrLine=t.select("."+Et+".e-ignore",this.element);var e=t.select("."+this.scrCntClass,this.tbItems);t.isNullOrUndefined(e)?this.tbItems.insertBefore(this.bdrLine,this.tbItems.firstElementChild):e.insertBefore(this.bdrLine,e.firstElementChild),this.select(this.selectedItem)}if(this.cntEle=t.select(".e-tab > ."+ct,this.element),t.isNullOrUndefined(this.cntEle)||(this.touchModule=new t.Touch(this.cntEle,{swipe:this.swipeHandler.bind(this)})),"Demand"===this.loadOn){var i=this.setActiveContent();this.triggerAnimation(i,!1)}this.initRender=!1,this.renderComplete()},i.prototype.setActiveContent=function(){var e=ut+this.tabId+"_"+this.selectedItem,i=this.getTrgContent(this.cntEle,this.extIndex(e));return t.isNullOrUndefined(i)||i.classList.add(mt),e},i.prototype.renderHeader=function(){var e=this,i=this.headerPlacement,s=[];if(this.hdrEle=this.getTabHeader(),this.addVerticalClass(),this.isTemplate){this.element.children.length>1&&this.element.children[1].classList.contains(ht)&&this.setProperties({headerPlacement:"Bottom"},!0);for(var n=this.hdrEle.children.length,r=[],l=0;l<n;l++)r.push(this.hdrEle.children.item(l).innerHTML);if(n>0){for(;this.hdrEle.firstElementChild;)t.detach(this.hdrEle.firstElementChild);var o=this.createElement("div",{className:"e-items"});this.hdrEle.appendChild(o),r.forEach(function(i,s){e.lastIndex=s;var n={className:ut,id:ut+e.tabId+"_"+s,attrs:{role:"tab","aria-controls":ct+e.tabId+"_"+s,"aria-selected":"false"}},r=e.createElement("span",{className:Ct,innerHTML:i,attrs:{role:"presentation"}}).outerHTML,l=e.createElement("div",{className:xt,innerHTML:r+e.btnCls.outerHTML}).outerHTML,a=e.createElement("div",{className:Nt,innerHTML:l,attrs:{tabIndex:"-1"}});o.appendChild(e.createElement("div",n)),t.selectAll(".e-item",o)[s].appendChild(a)})}}else s=this.parseObject(this.items,0);this.tbObj=new Me({width:"Left"===i||"Right"===i?"auto":"100%",height:"Left"===i||"Right"===i?"100%":"auto",overflowMode:this.overflowMode,items:0!==s.length?s:[],clicked:this.clickHandler.bind(this),scrollStep:this.scrollStep,enableHtmlSanitizer:this.enableHtmlSanitizer}),this.tbObj.isStringTemplate=!0,this.tbObj.createElement=this.createElement,this.tbObj.appendTo(this.hdrEle),t.attributes(this.hdrEle,{"aria-label":"tab-header"}),this.updateOrientationAttribute(),this.setCloseButton(this.showCloseButton)},i.prototype.renderContent=function(){this.cntEle=t.select("."+ct,this.element);var e=t.selectAll("."+It,this.element);if(this.isTemplate){this.cnt=this.cntEle.children.length>0?this.cntEle.innerHTML:"";for(var i=this.cntEle.children,s=0;s<e.length;s++)i.length-1>=s&&(t.addClass([i.item(s)],ut),t.attributes(i.item(s),{role:"tabpanel","aria-labelledby":ut+this.tabId+"_"+s}),i.item(s).id=ct+this.tabId+"_"+s)}},i.prototype.reRenderItems=function(){this.renderContainer(),t.isNullOrUndefined(this.cntEle)||(this.touchModule=new t.Touch(this.cntEle,{swipe:this.swipeHandler.bind(this)}))},i.prototype.parseObject=function(e,i){var s,n=this,r=t.selectAll(".e-tab-header ."+It,this.element).length,l=[],o=[];return e.forEach(function(e,a){var d=t.isNullOrUndefined(e.header)||t.isNullOrUndefined(e.header.iconPosition)?"":e.header.iconPosition,h=t.isNullOrUndefined(e.header)||t.isNullOrUndefined(e.header.iconCss)?"":e.header.iconCss;if(t.isNullOrUndefined(e.headerTemplate)&&(t.isNullOrUndefined(e.header)||t.isNullOrUndefined(e.header.text)||0===e.header.text.length&&""===h))o.push(a);else{var c=e.headerTemplate||e.header.text;"string"==typeof c&&n.enableHtmlSanitizer&&(c=t.SanitizeHtmlHelper.sanitize(c));var p;if(n.isReplace&&!t.isNullOrUndefined(n.tbId)&&""!==n.tbId){var u=n.tbId.indexOf("_");p=parseInt(n.tbId.substring(u+1),10),n.tbId=""}else p=i+a;var f=n.isAdd?r+a:n.lastIndex+1;n.lastIndex=0===r?a:n.isReplace?p:f;var m=e.disabled?" e-disable e-overlay":"",v=!1===e.visible?" "+gt:"";s=n.createElement("div",{className:Ct,attrs:{role:"presentation"}});var g=c instanceof Object?c.outerHTML:c,y=!t.isNullOrUndefined(g)&&""!==g;t.isNullOrUndefined(c.tagName)?n.headerTextCompile(s,c,a):s.appendChild(c);var b=n.createElement("span",{className:"e-icons e-tab-icon e-icon-"+d+" "+h}),C=n.createElement("div",{className:xt});C.appendChild(s),""!==c&&void 0!==c&&""!==h?("left"===d||"top"===d?C.insertBefore(b,C.firstElementChild):C.appendChild(b),s,n.isIconAlone=!1):(""===h?s:b)===b&&(t.detach(s),C.appendChild(b),n.isIconAlone=!0);var E=e.disabled?{}:{tabIndex:"-1"};C.appendChild(n.btnCls.cloneNode(!0));var N=n.createElement("div",{className:Nt,attrs:E});N.appendChild(C),n.itemIndexArray===[]?n.itemIndexArray.push(ut+n.tabId+"_"+n.lastIndex):n.itemIndexArray.splice(i+a,0,ut+n.tabId+"_"+n.lastIndex);var x={htmlAttributes:{id:ut+n.tabId+"_"+n.lastIndex,role:"tab","aria-selected":"false"},template:N};x.cssClass=(void 0!==e.cssClass?e.cssClass:" ")+" "+m+" "+v+" "+(""!==h?"e-i"+d:"")+" "+(y?"":"e-icon"),"top"!==d&&"bottom"!==d||n.element.classList.add("e-vertical-icon"),l.push(x),a++}}),this.isAdd||o.forEach(function(e){n.items.splice(e,1)}),this.isIconAlone?this.element.classList.add("e-icon-tab"):this.element.classList.remove("e-icon-tab"),l},i.prototype.removeActiveClass=function(){var e=this.getTabHeader();if(e){var i=t.selectAll("."+It+"."+mt,e);[].slice.call(i).forEach(function(e){return e.classList.remove(mt)})}},i.prototype.checkPopupOverflow=function(e){this.tbPop=t.select(".e-toolbar-pop",this.element);var i=t.select(".e-hor-nav",this.element),s=t.select("."+Ot,this.element),n=s.lastChild,r=!1;return!this.isVertical()&&(this.enableRtl&&i.offsetLeft+i.offsetWidth>s.offsetLeft||!this.enableRtl&&i.offsetLeft<s.offsetWidth)?r=!0:this.isVertical()&&i.offsetTop<n.offsetTop+n.offsetHeight&&(r=!0),r&&(e.classList.add(St),this.tbPop.insertBefore(e,t.selectAll("."+St,this.tbPop)[0])),!0},i.prototype.popupHandler=function(e){var i=e.querySelector(".e-ripple-element");t.isNullOrUndefined(i)||(i.outerHTML="",e.querySelector("."+Nt).classList.remove("e-ripple")),this.tbItem=t.selectAll("."+Ot+" ."+It,this.hdrEle);var s=this.tbItem[this.tbItem.length-1];if(0!==this.tbItem.length){if(e.classList.remove(St),e.removeAttribute("style"),this.tbItems.appendChild(e),this.actEleId=e.id,this.checkPopupOverflow(s)){var n=this.tbItems.lastChild.previousElementSibling;this.checkPopupOverflow(n)}this.isPopup=!0}return t.selectAll("."+It,this.tbItems).length-1},i.prototype.updateOrientationAttribute=function(){t.attributes(this.element,{"aria-orientation":this.isVertical()?"vertical":"horizontal"})},i.prototype.setCloseButton=function(e){var i=t.select("."+ht,this.element);!0===e?i.classList.add(bt):i.classList.remove(bt),this.tbObj.refreshOverflow(),this.refreshActiveTabBorder()},i.prototype.prevCtnAnimation=function(e,t){this.enableRtl||this.element.classList.contains("e-rtl");return this.isPopup||e<=t?"SlideLeftIn"===this.animation.previous.effect?{name:"SlideLeftOut",duration:this.animation.previous.duration,timingFunction:this.animation.previous.easing}:null:"SlideRightIn"===this.animation.next.effect?{name:"SlideRightOut",duration:this.animation.next.duration,timingFunction:this.animation.next.easing}:null},i.prototype.triggerPrevAnimation=function(e,i){var s=this,n=this.prevCtnAnimation(i,this.selectedItem);t.isNullOrUndefined(n)?e.classList.remove(mt):(n.begin=function(){t.setStyleAttribute(e,{position:"absolute"}),e.classList.add(wt),e.classList.add("e-view")},n.end=function(){e.style.display="none",e.classList.remove(mt),e.classList.remove(wt),e.classList.remove("e-view"),t.setStyleAttribute(e,{display:"",position:""}),0!==e.childNodes.length||s.isTemplate||t.detach(e)},new t.Animation(n).animate(e))},i.prototype.triggerAnimation=function(e,i){var s,n=this,r=this.prevIndex;[].slice.call(this.element.querySelector("."+ct).children).forEach(function(e){e.id===n.prevActiveEle&&(s=e)});var l=this.tbItem[r],o=this.getTrgContent(this.cntEle,this.extIndex(e));if(t.isNullOrUndefined(s)&&!t.isNullOrUndefined(l)){var a=this.extIndex(l.id);s=this.getTrgContent(this.cntEle,a)}if(t.isNullOrUndefined(o)||(this.prevActiveEle=o.id),this.initRender||!1===i||this.animation==={}||t.isNullOrUndefined(this.animation))s&&s!==o&&s.classList.remove(mt);else{var d,h=t.select("."+ct,this.element);if(this.prevIndex>this.selectedItem&&!this.isPopup){var c=this.animation.previous.effect;d={name:"None"===c?"":"SlideLeftIn"!==c?c:"SlideLeftIn",duration:this.animation.previous.duration,timingFunction:this.animation.previous.easing}}else if(this.isPopup||this.prevIndex<this.selectedItem||this.prevIndex===this.selectedItem){var p=this.animation.next.effect;d={name:"None"===p?"":"SlideRightIn"!==p?p:"SlideRightIn",duration:this.animation.next.duration,timingFunction:this.animation.next.easing}}d.progress=function(){h.classList.add(wt),n.setActiveBorder()},d.end=function(){h.classList.remove(wt),o.classList.add(mt)},this.initRender||t.isNullOrUndefined(s)||this.triggerPrevAnimation(s,r),this.isPopup=!1,""===d.name?o.classList.add(mt):new t.Animation(d).animate(o)}},i.prototype.keyPressed=function(e){var i=t.closest(e,"."+ht+" ."+It),s=this.getEleIndex(i);!t.isNullOrUndefined(this.popEle)&&e.classList.contains("e-hor-nav")?this.popEle.classList.contains("e-popup-open")?this.popObj.hide(this.hide):this.popObj.show(this.show):e.classList.contains("e-scroll-nav")?e.click():t.isNullOrUndefined(i)||!1!==i.classList.contains(mt)||(this.selectTab(s,null,!0),t.isNullOrUndefined(this.popEle)||this.popObj.hide(this.hide))},i.prototype.getTabHeader=function(){if(!t.isNullOrUndefined(this.element)){var e=[].slice.call(this.element.children).filter(function(e){return e.classList.contains(ht)});if(e.length>0)return e[0];var i=[].slice.call(this.element.children).filter(function(e){return!e.classList.contains("blazor-template")})[0];if(i)return[].slice.call(i.children).filter(function(e){return e.classList.contains(ht)})[0]}},i.prototype.getEleIndex=function(e){return Array.prototype.indexOf.call(t.selectAll("."+It,this.getTabHeader()),e)},i.prototype.extIndex=function(e){return e.replace(ut+this.tabId+"_","")},i.prototype.expTemplateContent=function(){var e=this;this.templateEle.forEach(function(i){t.isNullOrUndefined(e.element.querySelector(i))||(document.body.appendChild(e.element.querySelector(i)).style.display="none")})},i.prototype.templateCompile=function(e,t,i){var s=this.createElement("div");this.compileElement(s,t,"content",i),0!==s.childNodes.length&&e.appendChild(s),this.isReact&&this.renderReactTemplates()},i.prototype.compileElement=function(e,i,s,n){var r;"string"==typeof i?(i=i.trim(),e.innerHTML=t.SanitizeHtmlHelper.sanitize(i)):r=t.compile(i);var l;t.isNullOrUndefined(r)||(l=r({},this,s)),!t.isNullOrUndefined(r)&&l.length>0&&[].slice.call(l).forEach(function(t){e.appendChild(t)})},i.prototype.headerTextCompile=function(e,t,i){this.compileElement(e,t,"headerTemplate",i)},i.prototype.getContent=function(e,i,s,n){var r;if("string"==typeof(i=t.isNullOrUndefined(i)?"":i)||t.isNullOrUndefined(i.innerHTML))if("string"==typeof i&&this.enableHtmlSanitizer&&(i=t.SanitizeHtmlHelper.sanitize(i)),"."===i[0]||"#"===i[0])if(document.querySelectorAll(i).length){var l=document.querySelector(i);r=l.outerHTML.trim(),"clone"===s?e.appendChild(l.cloneNode(!0)):(e.appendChild(l),l.style.display="")}else this.templateCompile(e,i,n);else this.templateCompile(e,i,n);else e.appendChild(i);t.isNullOrUndefined(r)||-1===this.templateEle.indexOf(i.toString())&&this.templateEle.push(i.toString())},i.prototype.getTrgContent=function(e,i){return this.element.classList.contains(pt)?t.select(".e-nested> .e-content > #"+ct+this.tabId+"_"+i,this.element):this.findEle(e.children,ct+this.tabId+"_"+i)},i.prototype.findEle=function(e,t){for(var i,s=0;s<e.length;s++)if(e[s].id===t){i=e[s];break}return i},i.prototype.isVertical=function(){var e="Left"===this.headerPlacement||"Right"===this.headerPlacement;return this.scrCntClass=e?"e-vscroll-content":"e-hscroll-content",e},i.prototype.addVerticalClass=function(){if(this.isVertical()){var e="Left"===this.headerPlacement?"e-vertical-left":At;t.addClass([this.hdrEle],[Lt,e]),this.element.classList.contains(pt)?t.addClass([this.hdrEle],[kt,e]):t.addClass([this.element],[kt,e])}"Bottom"===this.headerPlacement&&t.addClass([this.hdrEle],[Dt])},i.prototype.updatePopAnimationConfig=function(){this.show={name:this.isVertical()?"FadeIn":"SlideDown",duration:100},this.hide={name:this.isVertical()?"FadeOut":"SlideUp",duration:100}},i.prototype.changeOrientation=function(e){this.setOrientation(e,this.hdrEle);var i=this.hdrEle.querySelector("."+mt),s=!!this.hdrEle.classList.contains(Lt);t.removeClass([this.element],[kt]),t.removeClass([this.hdrEle],[Lt,"e-vertical-left",At]),s!==this.isVertical()&&(this.changeToolbarOrientation(),!t.isNullOrUndefined(i)&&i.classList.contains(St)&&this.popupHandler(i)),this.addVerticalClass(),this.updateOrientationAttribute(),this.setActiveBorder(),this.focusItem()},i.prototype.focusItem=function(){var e=t.select(" #e-item"+this.tabId+"_"+this.selectedItem,this.hdrEle);t.isNullOrUndefined(e)||e.firstElementChild.focus()},i.prototype.changeToolbarOrientation=function(){this.tbObj.setProperties({height:this.isVertical()?"100%":"auto",width:this.isVertical()?"auto":"100%"},!0),this.tbObj.changeOrientation(),this.updatePopAnimationConfig()},i.prototype.setOrientation=function(e,i){var s=Array.prototype.indexOf.call(this.element.children,i),n=Array.prototype.indexOf.call(this.element.children,this.element.querySelector("."+ct));"Bottom"===e&&n>s?this.element.appendChild(i):(t.removeClass([i],[Dt]),this.element.insertBefore(i,t.select("."+ct,this.element)))},i.prototype.setCssClass=function(e,t,i){if(""!==t)for(var s=t.split(" "),n=0;n<s.length;n++)i?e.classList.add(s[n]):e.classList.remove(s[n])},i.prototype.setContentHeight=function(e){if(this.element.classList.contains(Mt)&&t.removeClass([this.element],[Mt]),!t.isNullOrUndefined(this.cntEle)){var i=this.getTabHeader();if("None"===this.heightAdjustMode){if("auto"===this.height)return;this.isVertical()||t.setStyleAttribute(this.cntEle,{height:this.element.offsetHeight-i.offsetHeight+"px"})}else if("Fill"===this.heightAdjustMode)t.addClass([this.element],[Mt]),t.setStyleAttribute(this.element,{height:"100%"}),t.setStyleAttribute(this.cntEle,{height:this.element.offsetHeight-i.offsetHeight+"px"});else if("Auto"===this.heightAdjustMode){if(!0===this.isTemplate)for(var s=t.selectAll(".e-content > .e-item",this.element),n=0;n<s.length;n++)s[n].setAttribute("style","display:block; visibility: visible"),this.maxHeight=Math.max(this.maxHeight,this.getHeight(s[n])),s[n].style.removeProperty("display"),s[n].style.removeProperty("visibility");else{this.cntEle=t.select("."+ct,this.element),!0===e&&this.cntEle.appendChild(this.createElement("div",{id:ct+this.tabId+"_0",className:"e-item "+mt,attrs:{role:"tabpanel","aria-labelledby":ut+this.tabId+"_0"}}));var r=this.cntEle.children.item(0);for(n=0;n<this.items.length;n++)for(this.getContent(r,this.items[n].content,"clone",n),this.maxHeight=Math.max(this.maxHeight,this.getHeight(r));r.firstChild;)r.removeChild(r.firstChild);this.isReact&&this.clearTemplate(["content"]),this.templateEle=[],this.getContent(r,this.items[0].content,"render",0),this.prevIndex!==this.selectedItem&&r.classList.remove(mt)}t.setStyleAttribute(this.cntEle,{height:this.maxHeight+"px"})}else t.setStyleAttribute(this.cntEle,{height:"auto"})}},i.prototype.getHeight=function(e){var t=window.getComputedStyle(e);return e.offsetHeight+parseFloat(t.getPropertyValue("padding-top"))+parseFloat(t.getPropertyValue("padding-bottom"))+parseFloat(t.getPropertyValue("margin-top"))+parseFloat(t.getPropertyValue("margin-bottom"))},i.prototype.setActiveBorder=function(){var e=this.getTabHeader(),i=t.select("."+It+"."+mt,e);if(!t.isNullOrUndefined(i)){this.reorderActiveTab?e&&e.classList.remove(Pt):(i.classList.contains(St)&&!this.bdrLine.classList.contains(gt)&&this.bdrLine.classList.add(gt),e&&!e.classList.contains(Pt)&&e.classList.add(Pt));var s=t.closest(i,".e-tab");if(this.element===s){this.tbItems=t.select("."+Ot,e);var n=t.select("."+Et,e),r=t.select("."+Ot+" ."+this.scrCntClass,e);if(this.isVertical()){t.setStyleAttribute(n,{left:"",right:""});0!==(t.isNullOrUndefined(r)?this.tbItems.offsetHeight:r.offsetHeight)?t.setStyleAttribute(n,{top:i.offsetTop+"px",height:i.offsetHeight+"px"}):t.setStyleAttribute(n,{top:0,height:0})}else{if("MultiRow"===this.overflowMode){var l=t.select("."+Et,this.element);t.setStyleAttribute(l,{top:i.offsetHeight+i.offsetTop+"px",height:""})}else t.setStyleAttribute(n,{top:"",height:""});var o=t.isNullOrUndefined(r)?this.tbItems.offsetWidth:r.offsetWidth;0!==o?t.setStyleAttribute(n,{left:i.offsetLeft+"px",right:o-(i.offsetLeft+i.offsetWidth)+"px"}):t.setStyleAttribute(n,{left:"auto",right:"auto"})}t.isNullOrUndefined(this.bdrLine)||i.classList.contains(St)||this.bdrLine.classList.remove(gt)}}},i.prototype.setActive=function(e,i,s){void 0===i&&(i=!1),void 0===s&&(s=!1),this.tbItem=t.selectAll("."+It,this.getTabHeader());var n=this.tbItem[e];if(!(e<0||isNaN(e)||0===this.tbItem.length))if(e>=0&&!i&&(this.allowServerDataBinding=!1,this.setProperties({selectedItem:e},!0),this.allowServerDataBinding=!0,this.initRender||this.serverDataBind()),n.classList.contains(mt))this.setActiveBorder();else{if(!this.isTemplate){var r=this.tbItem[this.prevIndex];t.isNullOrUndefined(r)||r.removeAttribute("aria-controls"),t.attributes(n,{"aria-controls":ct+this.tabId+"_"+e})}var l=n.id;this.removeActiveClass(),n.classList.add(mt),this.tbItem[this.prevIndex].setAttribute("aria-selected","false"),n.setAttribute("aria-selected","true");var o=Number(this.extIndex(l));if(t.isNullOrUndefined(this.prevActiveEle)&&(this.prevActiveEle=ct+this.tabId+"_"+o),t.attributes(this.element,{"aria-activedescendant":l}),this.isTemplate){if(t.select("."+ct,this.element).children.length>0){var a=this.findEle(t.select("."+ct,this.element).children,ct+this.tabId+"_"+o);t.isNullOrUndefined(a)||a.classList.add(mt),this.triggerAnimation(l,this.enableAnimation)}}else{this.cntEle=t.select(".e-tab > ."+ct,this.element);var d=this.getTrgContent(this.cntEle,this.extIndex(l));if(t.isNullOrUndefined(d)){this.cntEle.appendChild(this.createElement("div",{id:ct+this.tabId+"_"+this.extIndex(l),className:"e-item "+mt,attrs:{role:"tabpanel","aria-labelledby":ut+this.tabId+"_"+this.extIndex(l)}}));var h=this.getTrgContent(this.cntEle,this.extIndex(l)),c=Array.prototype.indexOf.call(this.itemIndexArray,l);this.getContent(h,this.items[c].content,"render",c)}else d.classList.add(mt);this.triggerAnimation(l,this.enableAnimation)}if(this.setActiveBorder(),this.refreshItemVisibility(n),!this.initRender&&!i){n.firstElementChild.focus();var p={previousItem:this.prevItem,previousIndex:this.prevIndex,selectedItem:n,selectedIndex:e,selectedContent:t.select("#"+ct+this.tabId+"_"+this.selectingID,this.content),isSwiped:this.isSwipeed,isInteracted:s};this.trigger("selected",p)}}},i.prototype.contentReady=function(){var e=this.setActiveContent();this.triggerAnimation(e,this.enableAnimation)},i.prototype.setItems=function(e){this.isReplace=!0,this.tbItems=t.select("."+Ot,this.getTabHeader()),this.tbObj.items=this.parseObject(e,0),this.tbObj.dataBind(),this.isReplace=!1},i.prototype.setRTL=function(e){this.tbObj.enableRtl=e,this.tbObj.dataBind(),this.setCssClass(this.element,"e-rtl",e),this.refreshActiveBorder()},i.prototype.refreshActiveBorder=function(){t.isNullOrUndefined(this.bdrLine)||this.bdrLine.classList.add(gt),this.setActiveBorder()},i.prototype.showPopup=function(e){var i=t.select(".e-popup.e-toolbar-pop",this.hdrEle);if(i.classList.contains("e-popup-close")){var s=i&&i.ej2_instances[0];s.position.X="Left"===this.headerPlacement?"left":"right",s.dataBind(),s.show(e)}},i.prototype.bindDraggable=function(){var e=this;if(this.allowDragAndDrop){this.element.querySelector("."+ht).querySelectorAll("."+It).forEach(function(t){e.initializeDrag(t)})}},i.prototype.wireEvents=function(){this.bindDraggable(),window.addEventListener("resize",this.resizeContext),t.EventHandler.add(this.element,"mouseover",this.hoverHandler,this),t.EventHandler.add(this.element,"keydown",this.spaceKeyDown,this),t.isNullOrUndefined(this.cntEle)||(this.touchModule=new t.Touch(this.cntEle,{swipe:this.swipeHandler.bind(this)})),this.keyModule=new t.KeyboardEvents(this.element,{keyAction:this.keyHandler.bind(this),keyConfigs:this.keyConfigs}),this.tabKeyModule=new t.KeyboardEvents(this.element,{keyAction:this.keyHandler.bind(this),keyConfigs:{openPopup:"shift+f10",tab:"tab",shiftTab:"shift+tab"},eventName:"keydown"})},i.prototype.unWireEvents=function(){t.isNullOrUndefined(this.keyModule)||this.keyModule.destroy(),t.isNullOrUndefined(this.tabKeyModule)||this.tabKeyModule.destroy(),t.isNullOrUndefined(this.cntEle)||t.isNullOrUndefined(this.touchModule)||this.touchModule.destroy(),window.removeEventListener("resize",this.resizeContext),t.EventHandler.remove(this.element,"mouseover",this.hoverHandler),t.EventHandler.remove(this.element,"keydown",this.spaceKeyDown),this.element.classList.remove("e-rtl"),this.element.classList.remove("e-focused")},i.prototype.clickHandler=function(e){this.element.classList.remove("e-focused");var i=e.originalEvent.target,s=t.closest(i,"."+It),n=this.getEleIndex(s);i.classList.contains(yt)?this.removeTab(n):this.isVertical()&&t.closest(i,".e-hor-nav")?this.showPopup(this.show):(this.isPopup=!1,t.isNullOrUndefined(s)||n===this.selectedItem&&n===this.prevIndex||this.selectTab(n,e.originalEvent,!0))},i.prototype.swipeHandler=function(e){if(!(e.velocity<3&&t.isNullOrUndefined(e.originalEvent.changedTouches))){if(e.originalEvent&&this.isNested&&e.originalEvent.stopPropagation(),this.isSwipeed=!0,"Right"===e.swipeDirection&&0!==this.selectedItem){for(var i=this.selectedItem-1;i>=0;i--)if(!this.tbItem[i].classList.contains(gt)){this.selectTab(i,null,!0);break}}else if("Left"===e.swipeDirection&&this.selectedItem!==t.selectAll("."+It,this.element).length-1)for(var s=this.selectedItem+1;s<this.tbItem.length;s++)if(!this.tbItem[s].classList.contains(gt)){this.selectTab(s,null,!0);break}this.isSwipeed=!1}},i.prototype.spaceKeyDown=function(e){if(32===e.keyCode&&32===e.which||35===e.keyCode&&35===e.which){var i=t.closest(e.target,"."+ht);t.isNullOrUndefined(i)||e.preventDefault()}},i.prototype.keyHandler=function(e){if(!this.element.classList.contains(vt)){this.element.classList.add("e-focused");var i=e.target,s=this.getTabHeader(),n=t.select("."+mt,s);this.popEle=t.select(".e-toolbar-pop",s),t.isNullOrUndefined(this.popEle)||(this.popObj=this.popEle.ej2_instances[0]);var r=t.closest(document.activeElement,"."+It),l=t.closest(i,"."+It);switch(e.action){case"space":case"enter":if(i.parentElement.classList.contains(vt))return;if("enter"===e.action&&i.classList.contains("e-hor-nav")){this.showPopup(this.show);break}this.keyPressed(i);break;case"tab":case"shiftTab":i.classList.contains(Nt)&&!1===t.closest(i,"."+It).classList.contains(mt)&&i.setAttribute("tabindex","-1"),this.popObj&&t.isVisible(this.popObj.element)&&this.popObj.hide(this.hide),n.children.item(0).setAttribute("tabindex","0");break;case"moveLeft":case"moveRight":t.isNullOrUndefined(r)||this.refreshItemVisibility(r);break;case"openPopup":e.preventDefault(),!t.isNullOrUndefined(this.popEle)&&this.popEle.classList.contains("e-popup-close")&&this.popObj.show(this.show);break;case"delete":if(!0===this.showCloseButton&&!t.isNullOrUndefined(l)){var o=l.nextSibling;!t.isNullOrUndefined(o)&&o.classList.contains(It)&&o.firstElementChild.focus(),this.removeTab(this.getEleIndex(l))}this.setActiveBorder()}}},i.prototype.refreshActiveTabBorder=function(){var e=t.select("."+It+"."+St+"."+mt,this.element);!t.isNullOrUndefined(e)&&this.reorderActiveTab&&this.select(this.getEleIndex(e)),this.refreshActiveBorder()},i.prototype.refreshItemVisibility=function(e){var i=t.select("."+this.scrCntClass,this.tbItems);if(!this.isVertical()&&!t.isNullOrUndefined(i)){var s=t.select(".e-hscroll-bar",this.tbItems),n=s.scrollLeft,r=n+s.offsetWidth,l=e.offsetLeft,o=e.offsetWidth,a=e.offsetLeft+e.offsetWidth;if(n<l&&r<a){var d=r-l;s.scrollLeft=n+(o-d)}else if(n>l&&r>a){d=a-n;s.scrollLeft=n-(o-d)}}},i.prototype.hoverHandler=function(e){var i=e.target;!t.isNullOrUndefined(i.classList)&&i.classList.contains(yt)&&i.setAttribute("title",new t.L10n("tab",{closeButtonTitle:this.title},this.locale).getConstant("closeButtonTitle"))},i.prototype.evalOnPropertyChangeItems=function(e,i){if(e.items instanceof Array&&i.items instanceof Array)if(this.lastIndex=0,t.isNullOrUndefined(this.tbObj))this.reRenderItems();else{this.isRect&&this.clearTemplate(),this.setItems(e.items),this.templateEle.length>0&&this.expTemplateContent(),this.templateEle=[];for(var s=t.select(".e-tab > ."+ct,this.element);s.firstElementChild;)t.detach(s.firstElementChild);this.select(this.selectedItem)}else for(var n=Object.keys(e.items),r=0;r<n.length;r++)for(var l=parseInt(Object.keys(e.items)[r],10),o=Object.keys(e.items[l]),a=0;a<o.length;a++){var d=Object(i.items[l])[o[a]],h=Object(e.items[l])[o[a]],c=this.element.querySelectorAll("."+It)[l],p=void 0;if(c&&!t.isNullOrUndefined(c.id)&&""!==c.id){var u=c.id.lastIndexOf("_");p=parseInt(c.id.substring(u+1),10)}else p=l;var f=t.select("."+Ot+" #"+ut+this.tabId+"_"+p,this.element),m=t.select(".e-content #"+ct+this.tabId+"_"+p,this.element);if("header"===o[a]||"headerTemplate"===o[a]){var v=t.isNullOrUndefined(this.items[l].header)||t.isNullOrUndefined(this.items[l].header.iconCss)?"":this.items[l].header.iconCss;if(""===(this.items[l].headerTemplate||this.items[l].header.text)&&""===v)this.removeTab(l);else{this.tbId=c.id;var g=[];g.push(this.items[l]),this.items.splice(l,1),this.itemIndexArray.splice(l,1),this.tbObj.items.splice(l,1);var y=f.classList.contains(gt);t.detach(f),this.isReplace=!0,this.addTab(g,l),y&&this.hideTab(l),this.isReplace=!1}}if("content"===o[a]&&!t.isNullOrUndefined(m)){if(("string"==typeof h||t.isNullOrUndefined(h.innerHTML))&&("."===h[0]||"#"===h[0])&&h.length){var b=document.querySelector(h);m.appendChild(b),b.style.display=""}else""===h&&"#"===d[0]?(document.body.appendChild(this.element.querySelector(d)).style.display="none",m.innerHTML=h):this.isReact?(m.innerHTML="",this.templateCompile(m,h,l)):"function"!=typeof h&&(m.innerHTML=h)}"cssClass"===o[a]&&(t.isNullOrUndefined(f)||(f.classList.remove(d),f.classList.add(h)),t.isNullOrUndefined(m)||(m.classList.remove(d),m.classList.add(h))),"disabled"===o[a]&&this.enableTab(l,!0!==h),"visible"===o[a]&&this.hideTab(l,!0!==h)}},i.prototype.initializeDrag=function(e){var i=this;this.dragArea=t.isNullOrUndefined(this.dragArea)?"#"+this.element.id+" ."+ht:this.dragArea;var s=new t.Draggable(e,{dragArea:this.dragArea,dragTarget:"."+It,clone:!0,helper:this.helper.bind(this),dragStart:this.itemDragStart.bind(this),drag:function(e){var s,n,r=i.getEleIndex(i.dragItem),l={draggedItem:i.dragItem,event:e.event,target:e.target,droppedItem:e.target.closest("."+It),clonedElement:i.cloneElement,index:r};if(t.isNullOrUndefined(e.target.closest(".e-tab"))||e.target.closest(".e-tab").isEqualNode(i.element)||i.dragArea==="."+ht){if(e.target.closest(i.dragArea)||"Popup"===i.overflowMode?(document.body.style.cursor="",i.dragItem.querySelector("."+Nt).style.visibility="hidden",i.cloneElement.classList.contains(gt)&&t.removeClass([i.cloneElement],gt)):(document.body.style.cursor="not-allowed",t.addClass([i.cloneElement],gt),i.dragItem.classList.contains(gt)&&t.removeClass([i.dragItem],gt),i.dragItem.querySelector("."+Nt).style.visibility="visible"),"Scrollable"===i.overflowMode&&!t.isNullOrUndefined(i.element.querySelector(".e-hscroll"))){var o=i.element.querySelector(".e-scroll-right-nav"),a=i.element.querySelector(".e-scroll-left-nav"),d=i.element.querySelector(".e-hscroll-bar");!t.isNullOrUndefined(o)&&Math.abs(o.offsetWidth/2+o.offsetLeft)>i.cloneElement.offsetLeft+i.cloneElement.offsetWidth&&(d.scrollLeft-=10),!t.isNullOrUndefined(a)&&Math.abs(a.offsetLeft+a.offsetWidth-i.cloneElement.offsetLeft)>a.offsetWidth/2&&(d.scrollLeft+=10)}i.cloneElement.style.pointerEvents="none",n=t.closest(e.target,"."+It+".e-draggable");var h=0;"Scrollable"!==i.overflowMode||t.isNullOrUndefined(i.element.querySelector(".e-hscroll"))||(h=i.element.querySelector(".e-hscroll-content").offsetWidth),null!=n&&!n.isSameNode(i.dragItem)&&n.closest(".e-tab").isSameNode(i.dragItem.closest(".e-tab"))&&((s=i.getEleIndex(n))<r&&Math.abs(n.offsetLeft+n.offsetWidth-i.cloneElement.offsetLeft)>n.offsetWidth/2&&i.dragAction(n,r,s),s>r&&Math.abs(n.offsetWidth/2)+n.offsetLeft-h<i.cloneElement.offsetLeft+i.cloneElement.offsetWidth&&i.dragAction(n,r,s)),i.droppedIndex=i.getEleIndex(i.dragItem),i.trigger("dragging",l)}else i.trigger("dragging",l)},dragStop:this.itemDragStop.bind(this)});this.draggableItems.push(s)},i.prototype.helper=function(e){return this.cloneElement=this.createElement("div"),e.element&&(this.cloneElement=e.element.cloneNode(!0),t.addClass([this.cloneElement],"e-tab-clone-element"),this.element.querySelector("."+ht).classList.contains(bt)&&t.addClass([this.cloneElement],bt),t.removeClass([this.cloneElement.querySelector("."+Nt)],"e-ripple"),t.isNullOrUndefined(this.cloneElement.querySelector(".e-ripple-element"))||t.remove(this.cloneElement.querySelector(".e-ripple-element")),document.body.appendChild(this.cloneElement)),this.cloneElement},i.prototype.itemDragStart=function(e){var i=this;this.draggingItems=this.items.map(function(e){return e}),this.dragItem=e.element;var s={draggedItem:e.element,event:e.event,target:e.target,droppedItem:null,index:this.getEleIndex(this.dragItem),clonedElement:this.cloneElement,cancel:!1};this.trigger("onDragStart",s,function(e){e.cancel?t.detach(i.cloneElement):(i.removeActiveClass(),t.addClass([i.tbItems.querySelector("."+Et)],gt),i.dragItem.querySelector("."+Nt).style.visibility="hidden")})},i.prototype.dragAction=function(e,t,i){if(this.items.length>0){var s=this.draggingItems[t];this.draggingItems.splice(t,1),this.draggingItems.splice(i,0,s)}if("MultiRow"===this.overflowMode&&e.parentNode.insertBefore(this.dragItem,e.nextElementSibling),t>i)if(this.dragItem.parentElement.isSameNode(e.parentElement))this.dragItem.parentNode.insertBefore(this.dragItem,e);else if("Extended"===this.overflowMode)if(e.isSameNode(e.parentElement.lastChild)){var n=this.dragItem.parentNode;e.parentNode.insertBefore(this.dragItem,e),n.insertBefore(e.parentElement.lastChild,n.childNodes[0])}else this.dragItem.parentNode.insertBefore(e.parentElement.lastChild,this.dragItem.parentElement.childNodes[0]),e.parentNode.insertBefore(this.dragItem,e);else{var r=e.parentElement.lastChild;if(e.isSameNode(r)){n=this.dragItem.parentNode;e.parentNode.insertBefore(this.dragItem,e),n.insertBefore(r,n.childNodes[0])}else this.dragItem.parentNode.insertBefore(e.parentElement.lastChild,this.dragItem.parentElement.childNodes[0]),e.parentNode.insertBefore(this.dragItem,e)}t<i&&(this.dragItem.parentElement.isSameNode(e.parentElement)?this.dragItem.parentNode.insertBefore(e,this.dragItem):"Extended"===this.overflowMode?(this.dragItem.parentElement.appendChild(e.parentElement.firstElementChild),e.parentNode.insertBefore(this.dragItem,e.nextSibling)):(this.dragItem.parentNode.insertBefore(e.parentElement.lastChild,this.dragItem.parentElement.childNodes[0]),e.parentNode.insertBefore(this.dragItem,e)))},i.prototype.itemDragStop=function(e){var i=this;t.detach(this.cloneElement),this.dragItem.querySelector("."+Nt).style.visibility="visible",document.body.style.cursor="";var s={draggedItem:this.dragItem,event:e.event,target:e.target,droppedItem:this.tbItem[this.droppedIndex],clonedElement:null,index:this.droppedIndex,cancel:!1};this.trigger("dragged",s,function(e){e.cancel?i.refresh():i.items.length>0&&i.draggingItems.length>0?(i.items=i.draggingItems,i.selectedItem=i.droppedIndex,i.refresh()):(i.dragItem.querySelector("."+Nt).style.visibility="",t.removeClass([i.tbItems.querySelector("."+Et)],gt),i.selectTab(i.droppedIndex,null,!0))})},i.prototype.enableTab=function(e,i){var s=t.selectAll("."+It,this.element)[e];t.isNullOrUndefined(s)||(!0===i?(s.classList.remove(vt,"e-overlay"),s.firstElementChild.setAttribute("tabindex","-1")):(s.classList.add(vt,"e-overlay"),s.firstElementChild.removeAttribute("tabindex"),s.classList.contains(mt)&&this.select(e+1)),t.isNullOrUndefined(this.items[e])||(this.items[e].disabled=!i,this.dataBind()),s.setAttribute("aria-disabled",!0===i?"false":"true"))},i.prototype.addTab=function(e,t){var i=this,s={addedItems:e,cancel:!1};this.isReplace?this.addingTabContent(e,t):this.trigger("adding",s,function(s){s.cancel||i.addingTabContent(e,t)}),this.isReact&&this.renderReactTemplates()},i.prototype.addingTabContent=function(e,i){var s=this,n=0;if(this.hdrEle=t.select("."+ht,this.element),t.isNullOrUndefined(this.hdrEle))this.items=e,this.reRenderItems();else{var r=t.selectAll(".e-tab-header ."+It,this.element).length;if(0!==r&&(n=this.lastIndex+1),t.isNullOrUndefined(i)&&(i=r-1),r<i||i<0||isNaN(i))return;0!==r||t.isNullOrUndefined(this.hdrEle)||(this.hdrEle.style.display=""),t.isNullOrUndefined(this.bdrLine)||this.bdrLine.classList.add(gt),this.tbItems=t.select("."+Ot,this.getTabHeader()),this.isAdd=!0;var l=this.parseObject(e,i);this.isAdd=!1;var o,a=0;e.forEach(function(e,r){if(o=e.headerTemplate||e.header.text,t.isNullOrUndefined(e.headerTemplate||e.header)||t.isNullOrUndefined(o)||0===o.length&&t.isNullOrUndefined(e.header.iconCss)||(s.items.splice(i+a,0,e),a++),s.isTemplate&&!t.isNullOrUndefined(e.header)&&!t.isNullOrUndefined(e.header.text)){var l=n+r,d=s.createElement("div",{id:ct+s.tabId+"_"+l,className:ut,attrs:{role:"tabpanel","aria-labelledby":"e-item_"+l}});s.cntEle.insertBefore(d,s.cntEle.children[i+r]);var h=s.getTrgContent(s.cntEle,l.toString());s.getContent(h,e.content,"render",i)}}),this.tbObj.addItems(l,i),this.isReplace||this.trigger("added",{addedItems:e}),this.selectedItem===i?this.select(i):this.setActiveBorder(),this.bindDraggable()}},i.prototype.removeTab=function(e){var i=this,s=t.selectAll("."+It,this.element)[e];if(!t.isNullOrUndefined(s)){var n={removedItem:s,removedIndex:e,cancel:!1};this.trigger("removing",n,function(n){if(!n.cancel){i.tbObj.removeItems(e),i.allowDragAndDrop&&e!==Array.prototype.indexOf.call(i.itemIndexArray,s.id)&&(e=Array.prototype.indexOf.call(i.itemIndexArray,s.id)),i.items.splice(e,1),i.itemIndexArray.splice(e,1),i.refreshActiveBorder();var r=t.select("#"+ct+i.tabId+"_"+i.extIndex(s.id),t.select("."+ct,i.element));t.isNullOrUndefined(r)||t.detach(r),i.trigger("removed",n),s.classList.contains(mt)&&(e=e>t.selectAll("."+It+":not(."+St+")",i.element).length-1?e-1:e,i.enableAnimation=!1,i.selectedItem=e,i.select(e)),0===t.selectAll("."+It,i.element).length&&(i.hdrEle.style.display="none"),i.enableAnimation=!0}})}},i.prototype.hideTab=function(e,i){var s,n=t.selectAll("."+It,this.element)[e];if(!t.isNullOrUndefined(n)){if(t.isNullOrUndefined(i)&&(i=!0),this.bdrLine.classList.add(gt),!0===i)if(n.classList.add(gt),0!==(s=t.selectAll("."+It+":not(."+gt+")",this.tbItems)).length&&n.classList.contains(mt)){if(0!==e)for(var r=e-1;r>=0;r--){if(!this.tbItem[r].classList.contains(gt)){this.select(r);break}if(0===r)for(var l=e+1;l<this.tbItem.length;l++)if(!this.tbItem[l].classList.contains(gt)){this.select(l);break}}else for(l=e+1;l<this.tbItem.length;l++)if(!this.tbItem[l].classList.contains(gt)){this.select(l);break}}else 0===s.length&&this.element.classList.add(gt);else this.element.classList.remove(gt),s=t.selectAll("."+It+":not(."+gt+")",this.tbItems),n.classList.remove(gt),0===s.length&&this.select(e);this.setActiveBorder(),n.setAttribute("aria-hidden",""+i),"Popup"===this.overflowMode&&this.tbObj&&this.tbObj.refreshOverflow()}},i.prototype.selectTab=function(e,t,i){void 0===t&&(t=null),void 0===i&&(i=!1),this.isInteracted=i,this.select(e,t)},i.prototype.select=function(e,i){var s=this,n=this.getTabHeader();this.tbItems=t.select("."+Ot,n),this.tbItem=t.selectAll("."+It,n),this.content=t.select("."+ct,this.element),this.prevItem=this.tbItem[this.prevIndex],t.isNullOrUndefined(this.selectedItem)||this.selectedItem<0||this.tbItem.length<=this.selectedItem||isNaN(this.selectedItem)?this.selectedItem=0:this.selectedID=this.extIndex(this.tbItem[this.selectedItem].id);var r=this.tbItem[e];t.isNullOrUndefined(r)?this.selectedID="0":this.selectingID=this.extIndex(r.id),t.isNullOrUndefined(this.prevItem)||this.prevItem.classList.contains(vt)||this.prevItem.children.item(0).setAttribute("tabindex","-1");var l={event:i,previousItem:this.prevItem,previousIndex:this.prevIndex,selectedItem:this.tbItem[this.selectedItem],selectedIndex:this.selectedItem,selectedContent:t.isNullOrUndefined(this.content)?null:t.select("#"+ct+this.tabId+"_"+this.selectedID,this.content),selectingItem:r,selectingIndex:e,selectingContent:t.isNullOrUndefined(this.content)?null:t.select("#"+ct+this.tabId+"_"+this.selectingID,this.content),isSwiped:this.isSwipeed,isInteracted:this.isInteracted,cancel:!1};this.initRender?this.selectingContent(e,this.isInteracted):this.trigger("selecting",l,function(t){t.cancel||s.selectingContent(e,s.isInteracted)}),this.isInteracted=!1},i.prototype.selectingContent=function(e,i){if("number"==typeof e){if(!t.isNullOrUndefined(this.tbItem[e])&&(this.tbItem[e].classList.contains(vt)||this.tbItem[e].classList.contains(gt)))for(var s=e+1;s<this.items.length;s++){if(!1===this.items[s].disabled&&!0===this.items[s].visible){e=s;break}e=0}if(this.tbItem.length>e&&e>=0&&!isNaN(e))if(this.prevIndex=this.selectedItem,this.tbItem[e].classList.contains(St)&&this.reorderActiveTab){if(this.setActive(this.popupHandler(this.tbItem[e]),null,i),!t.isNullOrUndefined(this.items)&&this.items.length>0&&this.allowDragAndDrop){this.tbItem=t.selectAll("."+Ot+" ."+It,this.hdrEle);var n=this.items[e];this.items.splice(e,1),this.items.splice(this.tbItem.length-1,0,n)}}else this.setActive(e,null,i);else this.setActive(0,null,i)}else e instanceof HTMLElement&&this.setActive(this.getEleIndex(e),null,i)},i.prototype.getItemIndex=function(e){for(var t,i=0;i<this.tbItem.length;i++){if(e===this.tbItem[i].getAttribute("data-id")){t=i;break}}return t},i.prototype.disable=function(e){this.setCssClass(this.element,vt,e),this.element.setAttribute("aria-disabled",""+e)},i.prototype.getPersistData=function(){return this.addOnPersist(["selectedItem","actEleId"])},i.prototype.getModuleName=function(){return"tab"},i.prototype.onPropertyChanged=function(e,i){for(var s=this,n=0,r=Object.keys(e);n<r.length;n++){switch(r[n]){case"width":t.setStyleAttribute(this.element,{width:t.formatUnit(e.width)});break;case"height":t.setStyleAttribute(this.element,{height:t.formatUnit(e.height)}),this.setContentHeight(!1);break;case"cssClass":""===i.cssClass||t.isNullOrUndefined(i.cssClass)?this.setCssClass(this.element,e.cssClass,!0):(this.setCssClass(this.element,i.cssClass,!1),this.setCssClass(this.element,e.cssClass,!0));break;case"items":this.evalOnPropertyChangeItems(e,i);break;case"showCloseButton":this.setCloseButton(e.showCloseButton);break;case"reorderActiveTab":this.refreshActiveTabBorder();break;case"selectedItem":this.selectedItem=i.selectedItem,this.select(e.selectedItem);break;case"headerPlacement":this.changeOrientation(e.headerPlacement);break;case"enableRtl":this.setRTL(e.enableRtl);break;case"overflowMode":this.tbObj.overflowMode=e.overflowMode,this.tbObj.dataBind(),this.refreshActiveTabBorder();break;case"heightAdjustMode":this.setContentHeight(!1),this.select(this.selectedItem);break;case"scrollStep":this.tbObj&&(this.tbObj.scrollStep=this.scrollStep);break;case"allowDragAndDrop":this.bindDraggable();break;case"dragArea":this.allowDragAndDrop&&(this.draggableItems.forEach(function(e){e.dragArea=s.dragArea}),this.refresh())}}},i.prototype.refreshActiveTab=function(){if(this.isReact&&this.clearTemplate(),this.isTemplate){var e=this.element.querySelector("."+Ot),i=this.element.querySelector("."+It+"."+mt),s=i.id,n=s.indexOf("_"),r=parseInt(s.substring(n+1),10),l=i.innerText,o=this.element.querySelector("."+ct).querySelector("."+mt).children[0],a=o.innerHTML;t.detach(i),t.detach(o);var d={className:It+" "+ft+" "+mt,id:ut+this.tabId+"_"+r,attrs:{role:"tab","aria-controls":ct+this.tabId+"_"+r,"aria-disabled":"false","aria-selected":"true"}},h=this.createElement("span",{className:Ct,innerHTML:l,attrs:{role:"presentation"}}).outerHTML,c=this.createElement("div",{className:xt,innerHTML:h+this.btnCls.outerHTML}).outerHTML,p=this.createElement("div",{className:Nt,innerHTML:c,attrs:{tabIndex:"-1"}});e.insertBefore(this.createElement("div",d),e.children[r+1]),this.element.querySelector("."+It+"."+mt).appendChild(p);N=this.createElement("div",{innerHTML:a});this.element.querySelector("."+ct).querySelector("."+mt).appendChild(N)}else if(this.element.querySelector("."+It+"."+mt)){t.detach(this.element.querySelector("."+It+"."+mt).children[0]),t.detach(this.element.querySelector("."+ct).querySelector("."+mt).children[0]);var u=this.items[this.selectedItem],f=t.isNullOrUndefined(u.header)||t.isNullOrUndefined(u.header.iconPosition)?"":u.header.iconPosition,m=t.isNullOrUndefined(u.header)||t.isNullOrUndefined(u.header.iconCss)?"":u.header.iconCss,v=u.headerTemplate||u.header.text,g=this.createElement("div",{className:Ct,attrs:{role:"presentation"}});t.isNullOrUndefined(v.tagName)?this.headerTextCompile(g,v,this.selectedItem):g.appendChild(v);var y=this.createElement("span",{className:"e-icons e-tab-icon e-icon-"+f+" "+m}),b=this.createElement("div",{className:xt});b.appendChild(g),""!==v&&void 0!==v&&""!==m?("left"===f||"top"===f?b.insertBefore(y,b.firstElementChild):b.appendChild(y),g,this.isIconAlone=!1):(""===m?g:y)===y&&(t.detach(g),b.appendChild(y),this.isIconAlone=!0);var C=u.disabled?{}:{tabIndex:"-1"};b.appendChild(this.btnCls.cloneNode(!0));var E=this.createElement("div",{className:Nt,attrs:C});E.appendChild(b),"top"!==f&&"bottom"!==f||this.element.classList.add("e-vertical-icon"),this.element.querySelector("."+It+"."+mt).appendChild(E);var N=this.createElement("div"),x=u.content,O=void 0;if("string"==typeof x||t.isNullOrUndefined(x.innerHTML))if("string"==typeof x&&this.enableHtmlSanitizer&&(x=t.SanitizeHtmlHelper.sanitize(x)),"."===x[0]||"#"===x[0])if(document.querySelectorAll(x).length){var I=document.querySelector(x);O=I.outerHTML.trim(),N.appendChild(I),I.style.display=""}else this.compileElement(N,x,"content",this.selectedItem);else this.compileElement(N,x,"content",this.selectedItem);else N.appendChild(x);t.isNullOrUndefined(O)||-1===this.templateEle.indexOf(x.toString())&&this.templateEle.push(x.toString()),this.element.querySelector(".e-item."+mt).appendChild(N)}this.isReact&&this.renderReactTemplates()},dt([t.Collection([],Rt)],i.prototype,"items",void 0),dt([t.Property("100%")],i.prototype,"width",void 0),dt([t.Property("auto")],i.prototype,"height",void 0),dt([t.Property("")],i.prototype,"cssClass",void 0),dt([t.Property(0)],i.prototype,"selectedItem",void 0),dt([t.Property("Top")],i.prototype,"headerPlacement",void 0),dt([t.Property("Content")],i.prototype,"heightAdjustMode",void 0),dt([t.Property("Scrollable")],i.prototype,"overflowMode",void 0),dt([t.Property("Dynamic")],i.prototype,"loadOn",void 0),dt([t.Property(!1)],i.prototype,"enablePersistence",void 0),dt([t.Property(!1)],i.prototype,"enableHtmlSanitizer",void 0),dt([t.Property(!1)],i.prototype,"showCloseButton",void 0),dt([t.Property(!0)],i.prototype,"reorderActiveTab",void 0),dt([t.Property()],i.prototype,"scrollStep",void 0),dt([t.Property()],i.prototype,"dragArea",void 0),dt([t.Property(!1)],i.prototype,"allowDragAndDrop",void 0),dt([t.Complex({},Ht)],i.prototype,"animation",void 0),dt([t.Event()],i.prototype,"created",void 0),dt([t.Event()],i.prototype,"adding",void 0),dt([t.Event()],i.prototype,"added",void 0),dt([t.Event()],i.prototype,"selecting",void 0),dt([t.Event()],i.prototype,"selected",void 0),dt([t.Event()],i.prototype,"removing",void 0),dt([t.Event()],i.prototype,"removed",void 0),dt([t.Event()],i.prototype,"onDragStart",void 0),dt([t.Event()],i.prototype,"dragging",void 0),dt([t.Event()],i.prototype,"dragged",void 0),dt([t.Event()],i.prototype,"destroyed",void 0),i=dt([t.NotifyPropertyChanges],i)}(t.Component),jt=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),qt=function(e,t,i,s){var n,r=arguments.length,l=r<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)l=Reflect.decorate(e,t,i,s);else for(var o=e.length-1;o>=0;o--)(n=e[o])&&(l=(r<3?n(l):r>3?n(t,i,l):n(t,i))||l);return r>3&&l&&Object.defineProperty(t,i,l),l},Ft="e-treeview",Wt="e-icon-collapsible",Vt="e-icon-expandable",_t="e-list-item",zt="e-list-text",Kt="e-list-parent",Yt="e-hover",Xt="e-active",Gt="e-icons-spinner",Qt="e-process",Jt="e-icons",Zt="e-text-content",$t="e-tree-input",ei="e-dragging",ti="e-sibling",ii="e-drop-in",si="e-drop-next",ni="e-drop-out",ri="e-fullrow",li="e-selected",oi="e-expanded",ai="e-node-collapsed",di="e-check",hi="e-stop",ci="e-checkbox-wrapper",pi="e-frame",ui="e-node-focus",fi="e-animation-active",mi={treeRole:"tree",itemRole:"treeitem",listRole:"group",itemText:"",wrapperRole:""},vi=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return jt(i,e),qt([t.Property("child")],i.prototype,"child",void 0),qt([t.Property([])],i.prototype,"dataSource",void 0),qt([t.Property("expanded")],i.prototype,"expanded",void 0),qt([t.Property("hasChildren")],i.prototype,"hasChildren",void 0),qt([t.Property("htmlAttributes")],i.prototype,"htmlAttributes",void 0),qt([t.Property("iconCss")],i.prototype,"iconCss",void 0),qt([t.Property("id")],i.prototype,"id",void 0),qt([t.Property("imageUrl")],i.prototype,"imageUrl",void 0),qt([t.Property("isChecked")],i.prototype,"isChecked",void 0),qt([t.Property("parentID")],i.prototype,"parentID",void 0),qt([t.Property(null)],i.prototype,"query",void 0),qt([t.Property("selected")],i.prototype,"selected",void 0),qt([t.Property(null)],i.prototype,"tableName",void 0),qt([t.Property("text")],i.prototype,"text",void 0),qt([t.Property("tooltip")],i.prototype,"tooltip",void 0),qt([t.Property("navigateUrl")],i.prototype,"navigateUrl",void 0),i}(t.ChildProperty),gi=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return jt(i,e),qt([t.Property("SlideDown")],i.prototype,"effect",void 0),qt([t.Property(400)],i.prototype,"duration",void 0),qt([t.Property("linear")],i.prototype,"easing",void 0),i}(t.ChildProperty),yi=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return jt(i,e),qt([t.Complex({effect:"SlideUp",duration:400,easing:"linear"},gi)],i.prototype,"collapse",void 0),qt([t.Complex({effect:"SlideDown",duration:400,easing:"linear"},gi)],i.prototype,"expand",void 0),i}(t.ChildProperty),bi=function(e){function o(t,i){var s=e.call(this,t,i)||this;return s.isRefreshed=!1,s.preventExpand=!1,s.checkedElement=[],s.disableNode=[],s.validArr=[],s.validNodes=[],s.expandChildren=[],s.isFieldChange=!1,s.changeDataSource=!1,s.hasTemplate=!1,s.isFirstRender=!1,s.mouseDownStatus=!1,s}jt(o,e),a=o,o.prototype.getModuleName=function(){return"treeview"},o.prototype.preRender=function(){var e=this;this.checkActionNodes=[],this.parentNodeCheck=[],this.dragStartAction=!1,this.isAnimate=!1,this.keyConfigs={escape:"escape",end:"end",enter:"enter",f2:"f2",home:"home",moveDown:"downarrow",moveLeft:"leftarrow",moveRight:"rightarrow",moveUp:"uparrow",ctrlDown:"ctrl+downarrow",ctrlUp:"ctrl+uparrow",ctrlEnter:"ctrl+enter",ctrlHome:"ctrl+home",ctrlEnd:"ctrl+end",ctrlA:"ctrl+A",shiftDown:"shift+downarrow",shiftUp:"shift+uparrow",shiftEnter:"shift+enter",shiftHome:"shift+home",shiftEnd:"shift+end",csDown:"ctrl+shift+downarrow",csUp:"ctrl+shift+uparrow",csEnter:"ctrl+shift+enter",csHome:"ctrl+shift+home",csEnd:"ctrl+shift+end",space:"space"},this.listBaseOption={expandCollapse:!0,showIcon:!0,expandIconClass:Vt,ariaAttributes:mi,expandIconPosition:"Left",itemCreated:function(t){e.beforeNodeCreate(t)},enableHtmlSanitizer:this.enableHtmlSanitizer,itemNavigable:this.fullRowNavigable},this.updateListProp(this.fields),this.aniObj=new t.Animation({}),this.treeList=[],this.isLoaded=!1,this.isInitalExpand=!1,this.expandChildren=[],this.index=0,this.setTouchClass(),t.isNullOrUndefined(this.selectedNodes)&&this.setProperties({selectedNodes:[]},!0),t.isNullOrUndefined(this.checkedNodes)&&this.setProperties({checkedNodes:[]},!0),t.isNullOrUndefined(this.expandedNodes)?this.setProperties({expandedNodes:[]},!0):this.isInitalExpand=!0},o.prototype.getPersistData=function(){return this.addOnPersist(["selectedNodes","checkedNodes","expandedNodes"])},o.prototype.render=function(){this.initialRender=!0,this.initialize(),this.setDataBinding(!1),this.setDisabledMode(),this.setExpandOnType(),this.disabled||this.setRipple(),this.wireEditingEvents(this.allowEditing),this.setDragAndDrop(this.allowDragAndDrop),this.disabled||this.wireEvents(),this.initialRender=!1,this.renderComplete()},o.prototype.initialize=function(){this.element.setAttribute("role","tree"),this.element.setAttribute("tabindex","0"),this.element.setAttribute("aria-activedescendant",this.element.id+"_active"),this.setCssClass(null,this.cssClass),this.setEnableRtl(),this.setFullRow(this.fullRowSelect),this.setTextWrap(),this.nodeTemplateFn=this.templateComplier(this.nodeTemplate)},o.prototype.setDisabledMode=function(){this.disabled?this.element.classList.add("e-disabled"):this.element.classList.remove("e-disabled")},o.prototype.setEnableRtl=function(){(this.enableRtl?t.addClass:t.removeClass)([this.element],"e-rtl")},o.prototype.setRipple=function(){var e={selector:".e-fullrow,.e-text-content",ignore:"."+Zt+" > ."+Jt+",.e-input-group,.e-input, ."+ci};this.rippleFn=t.rippleEffect(this.element,e);var i={selector:"."+Zt+" > ."+Jt,isCenterRipple:!0};this.rippleIconFn=t.rippleEffect(this.element,i)},o.prototype.setFullRow=function(e){(e?t.addClass:t.removeClass)([this.element],"e-fullrow-wrap")},o.prototype.setMultiSelect=function(e){var i=t.select("."+Kt,this.element);e?i.setAttribute("aria-multiselectable","true"):i.removeAttribute("aria-multiselectable")},o.prototype.templateComplier=function(e){if(e){this.hasTemplate=!0,this.element.classList.add("e-interaction");try{if(document.querySelectorAll(e).length)return t.compile(document.querySelector(e).innerHTML.trim())}catch(i){return t.compile(e)}}this.element.classList.remove("e-interaction")},o.prototype.setDataBinding=function(e){var i=this;this.treeList.push("false"),this.fields.dataSource instanceof r.DataManager?(this.isOffline=this.fields.dataSource.dataSource.offline,this.fields.dataSource.ready?this.fields.dataSource.ready.then(function(e){i.isOffline=i.fields.dataSource.dataSource.offline,i.fields.dataSource instanceof r.DataManager&&i.isOffline&&(i.treeList.pop(),i.treeData=e.result,i.isNumberTypeId=i.getType(),i.setRootData(),i.renderItems(!0),0!==i.treeList.length||i.isLoaded||i.finalize())}).catch(function(e){i.trigger("actionFailure",{error:e})}):this.fields.dataSource.executeQuery(this.getQuery(this.fields)).then(function(t){i.treeList.pop(),i.treeData=t.result,i.isNumberTypeId=i.getType(),i.setRootData(),e&&(i.changeDataSource=!0),i.renderItems(!0),i.changeDataSource=!1,0!==i.treeList.length||i.isLoaded||i.finalize()}).catch(function(e){i.trigger("actionFailure",{error:e})})):(this.treeList.pop(),t.isNullOrUndefined(this.fields.dataSource)?this.rootData=this.treeData=[]:(this.treeData=JSON.parse(JSON.stringify(this.fields.dataSource)),this.setRootData()),this.isNumberTypeId=this.getType(),this.renderItems(!1)),0!==this.treeList.length||this.isLoaded||this.finalize()},o.prototype.getQuery=function(e,s){void 0===s&&(s=null);var n,l=[];if(e.query)n=e.query.clone();else{n=new r.Query;for(var o=this.getActualProperties(e),a=0,d=Object.keys(o);a<d.length;a++){var h=d[a];"dataSource"!==h&&"tableName"!==h&&"child"!==h&&e[h]&&"url"!==h&&-1===l.indexOf(e[h])&&l.push(e[h])}n.select(l),o.hasOwnProperty("tableName")&&n.from(e.tableName)}return i.ListBase.addSorting(this.sortOrder,e.text,n),t.isNullOrUndefined(s)||t.isNullOrUndefined(e.parentID)||n.where(e.parentID,"equal",this.isNumberTypeId?parseFloat(s):s),n},o.prototype.getType=function(){return!!this.treeData[0]&&"number"==typeof t.getValue(this.fields.id,this.treeData[0])},o.prototype.setRootData=function(){if(this.dataType=this.getDataType(this.treeData,this.fields),1===this.dataType){this.groupedData=this.getGroupedData(this.treeData,this.fields.parentID);var e=this.getChildNodes(this.treeData,void 0,!0);t.isNullOrUndefined(e)?this.rootData=[]:this.rootData=e}else this.rootData=this.treeData},o.prototype.renderItems=function(e){this.listBaseOption.ariaAttributes.level=1;var s=this.getSortedData(this.rootData);this.ulElement=i.ListBase.createList(this.createElement,e?this.rootData:s,this.listBaseOption),this.element.appendChild(this.ulElement);var n=this.ulElement.querySelectorAll(".e-list-item");if(!1===this.loadOnDemand)for(var r=0;r<n.length;)this.renderChildNodes(n[r],!0,null,!0),r++;(1===t.selectAll("."+Kt,this.element).length&&n&&0!==n.length||this.loadOnDemand)&&this.finalizeNode(this.element),this.parentNodeCheck=[],this.parentCheckData=[],this.updateCheckedStateFromDS(),this.autoCheck&&this.showCheckBox&&!this.isLoaded&&this.updateParentCheckState()},o.prototype.updateCheckedStateFromDS=function(e){if(this.validNodes=[],this.treeData&&this.showCheckBox){if(1===this.dataType){for(var i=this.fields,s=new r.DataManager(this.treeData).executeLocal((new r.Query).where(i.isChecked,"equal",!0,!1)),n=0;n<s.length;n++){var l=s[n][this.fields.id]?s[n][this.fields.id].toString():null;s[n][this.fields.parentID]&&s[n][this.fields.parentID].toString();if(-1!==this.checkedNodes.indexOf(l)||this.isLoaded||this.checkedNodes.push(l),s[n][this.fields.hasChildren])for(var o=s[n][this.fields.id],a=new r.DataManager(this.treeData).executeLocal((new r.Query).where(i.parentID,"equal",o,!1)),d=0;d<a.length;d++){var h=a[d][this.fields.id]?a[d][this.fields.id].toString():null;-1===this.checkedNodes.indexOf(h)&&this.autoCheck&&this.checkedNodes.push(h)}}for(n=0;n<this.checkedNodes.length;n++){var c=this.fields,p=new r.DataManager(this.treeData).executeLocal((new r.Query).where(c.id,"equal",this.checkedNodes[n],!0));if(p[0]&&this.autoCheck&&(this.getCheckedNodeDetails(c,p),this.checkIndeterminateState(p[0])),p.length>0){var u=p[0][this.fields.id]?p[0][this.fields.id].toString():null;this.checkedNodes.indexOf(u)>-1&&-1===this.validNodes.indexOf(u)&&this.validNodes.push(u)}for(var f=new r.DataManager(this.treeData).executeLocal((new r.Query).where(c.parentID,"equal",this.checkedNodes[n],!0)),m=0;m<f.length;m++){u=f[m][this.fields.id]?f[m][this.fields.id].toString():null;-1===this.checkedNodes.indexOf(u)&&this.autoCheck&&this.checkedNodes.push(u),this.checkedNodes.indexOf(u)>-1&&-1===this.validNodes.indexOf(u)&&this.validNodes.push(u)}}}else if(2===this.dataType||this.fields.dataSource instanceof r.DataManager&&this.isOffline)for(m=0;m<this.treeData.length;m++){var v=this.treeData[m][this.fields.id]?this.treeData[m][this.fields.id].toString():"";this.treeData[m][this.fields.isChecked]&&!this.isLoaded&&-1===this.checkedNodes.indexOf(v)&&this.checkedNodes.push(v),this.checkedNodes.indexOf(v)>-1&&-1===this.validNodes.indexOf(v)&&this.validNodes.push(v);var g=t.getValue(this.fields.child.toString(),this.treeData[m]);g&&this.updateChildCheckState(g,this.treeData[m])}this.setProperties({checkedNodes:this.validNodes},!0)}},o.prototype.getCheckedNodeDetails=function(e,i){var s=i[0][this.fields.parentID]?i[0][this.fields.parentID].toString():null,n=0,l=this.element.querySelector('[data-uid="'+i[0][this.fields.id]+'"]'),o=this.element.querySelector('[data-uid="'+i[0][this.fields.parentID]+'"]');if(l||o){if(o){t.select("."+di,o)||this.changeState(o,"indeterminate",null,!0,!0)}}else{this.parentNodeCheck.length;-1===this.parentNodeCheck.indexOf(s)&&this.parentNodeCheck.push(s);for(var a=this.getChildNodes(this.treeData,s),d=0;d<a.length;d++){var h=a[d][this.fields.id]?a[d][this.fields.id].toString():null;-1!==this.checkedNodes.indexOf(h)&&n++,n===a.length&&-1===this.checkedNodes.indexOf(s)&&this.checkedNodes.push(s)}var c=new r.DataManager(this.treeData).executeLocal((new r.Query).where(e.id,"equal",s,!0));this.getCheckedNodeDetails(e,c)}},o.prototype.updateParentCheckState=function(){for(var e,i=t.selectAll(".e-stop",this.element),s=0;s<i.length;s++){var n=t.closest(i[s],"."+_t),l=n.getAttribute("data-uid").toString(),o=0;if(e=1===this.dataType?new r.DataManager(this.treeData).executeLocal((new r.Query).where(this.fields.parentID,"equal",l,!0)):this.getChildNodes(this.treeData,l)){for(var a=0;a<e.length;a++){var d=e[a][this.fields.id].toString();-1!==this.checkedNodes.indexOf(d)&&o++}if(o===e.length){var h=n.getAttribute("data-uid");-1===this.checkedNodes.indexOf(h)&&this.checkedNodes.push(h),this.changeState(n,"check",null,!0,!0)}else 0===o&&0===this.checkedNodes.length&&this.changeState(n,"uncheck",null,!0,!0)}}},o.prototype.checkIndeterminateState=function(e){var t;if(t=1===this.dataType?this.element.querySelector('[data-uid="'+e[this.fields.parentID]+'"]'):this.element.querySelector('[data-uid="'+e[this.fields.id]+'"]')){"true"!==t.querySelector("."+ci).getAttribute("aria-checked")&&this.changeState(t,"indeterminate",null,!0,!0)}else if(2===this.dataType){this.parentNodeCheck.length;-1===this.parentNodeCheck.indexOf(e[this.fields.id].toString())&&this.parentNodeCheck.push(e[this.fields.id].toString())}},o.prototype.updateChildCheckState=function(e,i){for(var s=0,n=i[this.fields.id]?i[this.fields.id].toString():"",r=0;r<e.length;r++){var l=e[r][this.fields.id]?e[r][this.fields.id].toString():"";e[r][this.fields.isChecked]&&!this.isLoaded&&-1===this.checkedNodes.indexOf(l)&&this.checkedNodes.push(l),-1!==this.checkedNodes.indexOf(n)&&-1===this.checkedNodes.indexOf(l)&&this.autoCheck&&this.checkedNodes.push(l),-1!==this.checkedNodes.indexOf(l)&&this.autoCheck&&s++,this.checkedNodes.indexOf(l)>-1&&-1===this.validNodes.indexOf(l)&&this.validNodes.push(l);var o=t.getValue(this.fields.child.toString(),e[r]);o&&(this.parentCheckData.push(i),this.updateChildCheckState(o,e[r])),s===e.length&&this.autoCheck&&-1===this.checkedNodes.indexOf(n)&&this.checkedNodes.push(n)}if(0!==s&&this.autoCheck){this.checkIndeterminateState(i);for(var a=0;a<this.parentCheckData.length;a++)i!==this.parentCheckData[a]&&this.parentCheckData[a]&&this.checkIndeterminateState(this.parentCheckData[a])}this.parentCheckData=[]},o.prototype.beforeNodeCreate=function(e){if(this.showCheckBox){var i=n.createCheckBox(this.createElement,!0,{cssClass:this.touchClass});i.setAttribute("role","checkbox");var s=t.select("div."+Jt,e.item),r=e.item.getAttribute("data-uid");e.item.childNodes[0].insertBefore(i,e.item.childNodes[0].childNodes[t.isNullOrUndefined(s)?0:1]);var l=t.getValue(e.fields.isChecked,e.curData);this.checkedNodes.indexOf(r)>-1?(t.select("."+pi,i).classList.add(di),i.setAttribute("aria-checked","true"),this.addCheck(e.item)):t.isNullOrUndefined(l)||"true"!==l.toString()?i.setAttribute("aria-checked","false"):(t.select("."+pi,i).classList.add(di),i.setAttribute("aria-checked","true"),this.addCheck(e.item));var o=t.select("."+pi,i);t.EventHandler.add(o,"mousedown",this.frameMouseHandler,this),t.EventHandler.add(o,"mouseup",this.frameMouseHandler,this)}this.fullRowSelect&&this.createFullRow(e.item),this.allowMultiSelection&&!e.item.classList.contains(li)&&e.item.setAttribute("aria-selected","false");var a=e.fields;if(this.addActionClass(e,a.selected,li),this.addActionClass(e,a.expanded,oi),!t.isNullOrUndefined(this.nodeTemplateFn)){var d=e.item.querySelector("."+zt),h=e.item.getAttribute("data-uid");d.innerHTML="",this.renderNodeTemplate(e.curData,d,h)}var c={node:e.item,nodeData:e.curData,text:e.text};this.isRefreshed||this.trigger("drawNode",c)},o.prototype.frameMouseHandler=function(e){var i=t.select(".e-ripple-container",e.target.parentElement);n.rippleMouseHandler(e,i)},o.prototype.addActionClass=function(e,i,s){var n=e.curData,r=t.getValue(i,n);t.isNullOrUndefined(r)||"false"===r.toString()||e.item.classList.add(s)},o.prototype.getDataType=function(e,i){if(this.fields.dataSource instanceof r.DataManager){for(var s=0;s<e.length;s++)if(this.isOffline){if("string"==typeof i.child&&t.isNullOrUndefined(t.getValue(i.child,e[s]))&&!t.isNullOrUndefined(t.getValue(i.parentID,e[s])))return 1}else if("string"==typeof i.child&&t.isNullOrUndefined(t.getValue(i.child,e[s])))return 1;return 2}s=0;for(var n=e.length;s<n;s++){if("string"==typeof i.child&&!t.isNullOrUndefined(t.getValue(i.child,e[s])))return 2;if(!t.isNullOrUndefined(t.getValue(i.parentID,e[s]))||!t.isNullOrUndefined(t.getValue(i.hasChildren,e[s])))return 1}return 1},o.prototype.getGroupedData=function(e,t){for(var s=(new r.Query).group(t),n=i.ListBase.getDataSource(e,s),l=[],o=0;o<n.length;o++){var a=n[o].items;l.push(a)}return l},o.prototype.getSortedData=function(e){return e&&"None"!==this.sortOrder&&(e=i.ListBase.getDataSource(e,i.ListBase.addSorting(this.sortOrder,this.fields.text))),e},o.prototype.finalizeNode=function(e){for(var i=t.selectAll(".e-list-img",e),s=0;s<i.length;s++)i[s].setAttribute("alt","e-list-img");if(this.isLoaded){for(var n=t.selectAll("."+li,e),r=0;r<n.length;r++){this.selectNode(n[r],null);break}t.removeClass(n,li)}for(var l=t.selectAll("."+_t+":not(."+oi+")",e),o=0;o<l.length;o++){var a=t.select("div."+Jt,l[o]);a&&a.classList.contains(Vt)&&this.disableExpandAttr(l[o])}var d=t.selectAll("."+oi,e);if(!this.isInitalExpand)for(r=0;r<d.length;r++)this.renderChildNodes(d[r]);t.removeClass(d,oi),this.updateList(),this.isLoaded&&this.updateCheckedProp()},o.prototype.updateCheckedProp=function(){if(this.showCheckBox){var e=[].concat([],this.checkedNodes);this.setProperties({checkedNodes:e},!0)}},o.prototype.ensureIndeterminate=function(){if(this.autoCheck)for(var e=t.selectAll("li",this.element),i=0;i<e.length;i++)e[i].classList.contains(_t)&&(t.select("."+Kt,e[i])?this.ensureParentCheckState(e[i]):this.ensureChildCheckState(e[i]));else{var s=t.selectAll(".e-stop",this.element);for(i=0;i<s.length;i++)s[i].classList.remove(hi)}},o.prototype.ensureParentCheckState=function(e){if(!t.isNullOrUndefined(e)){if(e.classList.contains(Ft))return;var i=e;e.classList.contains(_t)&&(i=t.select("."+Kt,e));var s=t.selectAll("."+di,i),n=t.selectAll(".e-stop",i),r=t.selectAll("."+_t,i),l=e.getElementsByClassName(ci)[0];r.length===s.length?this.changeState(l,"check",null,!0,!0):s.length>0||n.length>0?this.changeState(l,"indeterminate",null,!0,!0):0===s.length&&this.changeState(l,"uncheck",null,!0,!0);var o=t.closest(e,"."+Kt);if(!t.isNullOrUndefined(o)){var a=t.closest(o,"."+_t);this.ensureParentCheckState(a)}}},o.prototype.ensureChildCheckState=function(e,i){if(!t.isNullOrUndefined(e)){var s=t.select("."+Kt,e),n=void 0;if(!t.isNullOrUndefined(s)){n=t.selectAll("."+ci,s);for(var r=e.getElementsByClassName(pi)[0].classList.contains(di),l=e.getElementsByClassName(pi)[0].classList.contains(hi),o=s.querySelectorAll("li"),a=(s.parentElement.getAttribute("aria-expanded"),void 0),d=0;d<n.length;d++){var h=o[d].getAttribute("data-uid");if(t.isNullOrUndefined(this.currentLoadData)||t.isNullOrUndefined(t.getValue(this.fields.isChecked,this.currentLoadData[d]))){var c=n[d].getElementsByClassName(pi)[0].classList.contains(di);r?a="check":c&&!this.isLoaded?a="check":-1!==this.checkedNodes.indexOf(h)&&this.isLoaded&&(l||r)?a="check":o[d].classList.contains("e-has-child")&&!t.isUndefined(this.parentNodeCheck)&&this.autoCheck&&(r||l)&&-1!==this.parentNodeCheck.indexOf(h)?(a="indeterminate",this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(h),1)):1===this.dataType&&!t.isUndefined(this.parentNodeCheck)&&this.autoCheck&&(r||l)&&-1!==this.parentNodeCheck.indexOf(h)?(a="indeterminate",this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(h),1)):a="uncheck"}else a=t.getValue(this.fields.isChecked,this.currentLoadData[d])?"check":"uncheck",-1!==this.ele&&(a=r?"check":"uncheck"),"uncheck"===a&&!t.isUndefined(this.parentNodeCheck)&&this.autoCheck&&-1!==this.parentNodeCheck.indexOf(h)&&(this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(h),1),a="indeterminate");this.changeState(n[d],a,i,!0,!0)}}this.autoCheck&&this.isLoaded&&this.updateParentCheckState()}},o.prototype.doCheckBoxAction=function(e,i){t.selectAll("."+_t,this.element);if(t.isNullOrUndefined(e)){var s=t.selectAll("."+ci,this.element);if(this.loadOnDemand)for(var n=0;n<s.length;n++)this.updateFieldChecked(s[n],i),this.changeState(s[n],i?"check":"uncheck",null,null,null,i);else for(n=0;n<s.length;n++)this.updateFieldChecked(s[n],i),this.changeState(s[n],i?"check":"uncheck")}else for(var r=e.length;r>=0;r--){var l=void 0;if(l=1===e.length?this.getElement(e[r-1]):this.getElement(e[r]),t.isNullOrUndefined(l)){var o=void 0;if(""!==(o=e[r-e.length]?e[r-e.length].toString():e[r]?e[r].toString():null)&&i&&o)this.setValidCheckedNode(o),this.dynamicCheckState(o,i);else if(-1!==this.checkedNodes.indexOf(o)&&""!==o&&!i){this.checkedNodes.splice(this.checkedNodes.indexOf(o),1);var a=this.getChildNodes(this.treeData,o);if(a){for(var d=0;d<a.length;d++){var h=a[d][this.fields.id]?a[d][this.fields.id].toString():null;if(-1!==this.checkedNodes.indexOf(h)){this.checkedNodes.splice(this.checkedNodes.indexOf(h),1);var c=this.element.querySelector('[data-uid="'+h+'"]');c&&this.changeState(c,"uncheck",null)}}-1!==this.parentNodeCheck.indexOf(o)&&this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(o),1)}o&&this.dynamicCheckState(o,i),this.updateField(this.treeData,this.fields,o,"isChecked",null)}}else{var p=t.select("."+Kt+" ."+ci,l);this.validateCheckNode(p,!i,l,null)}}if(e)for(var u=0;u<e.length;u++){o=e[u]?e[u].toString():"";i||this.updateField(this.treeData,this.fields,o,"isChecked",null)}this.autoCheck&&this.updateParentCheckState()},o.prototype.updateFieldChecked=function(e,i){var s=t.closest(e,"."+_t),n=s.getAttribute("data-uid");"true"!==this.getNodeData(s).isChecked||i||this.updateField(this.treeData,this.fields,n,"isChecked",null)},o.prototype.dynamicCheckState=function(e,i){if(1===this.dataType){var s=0,n=new r.DataManager(this.treeData).executeLocal((new r.Query).where(this.fields.id,"equal",e,!0));if(n[0]){var l=n[0][this.fields.id]?n[0][this.fields.id].toString():null,o=n[0][this.fields.parentID]?n[0][this.fields.parentID].toString():null,a=((u=this.element.querySelector('[data-uid="'+o+'"]'))&&t.select(".e-stop",u),u?t.select("."+di,u):null),d=this.element.querySelector('[data-uid="'+l+'"]'),h=this.getChildNodes(this.treeData,o);if(h)for(var c=0;c<h.length;c++){var p=h[c][this.fields.id]?h[c][this.fields.id].toString():null;-1!==this.checkedNodes.indexOf(p)&&s++}-1!==this.checkedNodes.indexOf(e)&&u&&l===e&&this.autoCheck?this.changeState(u,"indeterminate",null):-1===this.checkedNodes.indexOf(e)&&d&&l===e&&!i?this.changeState(d,"uncheck",null):-1!==this.checkedNodes.indexOf(e)&&d&&l===e&&i?this.changeState(d,"check",null):-1===this.checkedNodes.indexOf(e)&&!d&&u&&l===e&&this.autoCheck&&0!==s?this.changeState(u,"indeterminate",null):-1===this.checkedNodes.indexOf(e)&&!d&&u&&l===e&&this.autoCheck&&0===s?this.changeState(u,"uncheck",null):d||u||l!==e||!this.autoCheck||this.updateIndeterminate(e,i)}}else if(2===this.dataType||this.fields.dataSource instanceof r.DataManager&&this.isOffline){l=void 0;var u=void 0;for(a=void 0,c=0;c<this.treeData.length;c++){l=this.treeData[c][this.fields.id]?this.treeData[c][this.fields.id].toString():"",a=(u=this.element.querySelector('[data-uid="'+l+'"]'))?t.select("."+di,u):null,-1===this.checkedNodes.indexOf(l)&&u&&a&&!i&&this.changeState(u,"uncheck",null);var f=t.getValue(this.fields.child.toString(),this.treeData[c]);f&&this.updateChildIndeterminate(f,l,e,i,l)}}},o.prototype.updateIndeterminate=function(e,t){var i,s=this.getTreeData(e),n=0;1===this.dataType&&(i=s[0][this.fields.parentID]?s[0][this.fields.parentID].toString():null);var r=this.getChildNodes(this.treeData,i);if(r)for(var l=0;l<r.length;l++){var o=r[l][this.fields.id]?r[l][this.fields.id].toString():null;-1!==this.checkedNodes.indexOf(o)&&n++}var a=this.element.querySelector('[data-uid="'+i+'"]');a&&t?this.changeState(a,"indeterminate",null):!t&&a&&-1===this.parentNodeCheck.indexOf(i)&&0!==n?this.changeState(a,"indeterminate",null):!t&&a&&-1===this.parentNodeCheck.indexOf(i)&&0===n?this.changeState(a,"uncheck",null):a||(t||-1!==this.checkedNodes.indexOf(i)||-1===this.parentNodeCheck.indexOf(i)?t&&-1===this.checkedNodes.indexOf(i)&&-1===this.parentNodeCheck.indexOf(i)?this.parentNodeCheck.push(i):t||-1===this.checkedNodes.indexOf(i)||-1!==this.parentNodeCheck.indexOf(i)||0===n||this.parentNodeCheck.push(i):this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(i),1),this.updateIndeterminate(i,t),-1===this.checkedNodes.indexOf(i)||t||this.checkedNodes.splice(this.checkedNodes.indexOf(i),1))},o.prototype.updateChildIndeterminate=function(e,i,s,n,r){for(var l=0,o=0;o<e.length;o++){var a=e[o][this.fields.id]?e[o][this.fields.id].toString():"";-1!==this.checkedNodes.indexOf(a)&&l++;var d=this.element.querySelector('[data-uid="'+i+'"]'),h=d?t.select(".e-stop",d):null,c=d?t.select("."+di,d):null,p=this.element.querySelector('[data-uid="'+a+'"]'),u=p?t.select("."+di,p):null;if(-1!==this.checkedNodes.indexOf(s)&&d&&a===s&&this.autoCheck)this.changeState(d,"indeterminate",null);else if(-1!==this.checkedNodes.indexOf(s)||!d||p||a!==s||n){if(-1===this.checkedNodes.indexOf(s)&&p&&a===s&&!n)this.changeState(p,"uncheck",null);else if(-1===this.checkedNodes.indexOf(s)&&h&&a===s&&this.autoCheck&&0===l&&!n)h.classList.remove(hi);else if(-1===this.checkedNodes.indexOf(s)&&!p&&c&&a===s&&0===l)this.changeState(d,"uncheck",null);else if(-1===this.checkedNodes.indexOf(a)&&p&&u&&0===l)this.changeState(p,"uncheck",null);else if(!p&&!d&&a===s||-1!==this.parentNodeCheck.indexOf(i)&&this.autoCheck){var f=this.element.querySelector('[data-uid="'+r+'"]');n&&0!==l?this.changeState(f,"indeterminate",null):n&&l===e.length&&-1===this.checkedNodes.indexOf(i)?this.checkedNodes.push(i):n||0!==l||-1===this.parentNodeCheck.indexOf(i)||this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(i)),-1===this.parentNodeCheck.indexOf(i)&&this.parentNodeCheck.push(i)}}else this.autoCheck?this.changeState(d,"uncheck",null):0!==l?this.changeState(d,"indeterminate",null):this.changeState(d,"uncheck",null);var m=t.getValue(this.fields.child.toString(),e[o]);m&&this.updateChildIndeterminate(m,a,s,n,r)}},o.prototype.changeState=function(e,i,s,n,r,l){var o,a=this,d=t.closest(e,"."+_t);e===d&&(e=t.select("."+ci,d)),n?this.nodeCheckAction(e,i,d,o,s,n,r,l):(this.checkActionNodes=[],o=this.getCheckEvent(d,i,s),this.trigger("nodeChecking",o,function(t){t.cancel||a.nodeCheckAction(e,i,d,t,s,n,r,l)}))},o.prototype.nodeCheckAction=function(e,i,s,n,r,l,o,a){var d,h=e.getElementsByClassName(pi)[0];if("check"!==i||h.classList.contains(di)?"uncheck"===i&&(h.classList.contains(di)||h.classList.contains(hi))?(t.removeClass([h],[di,hi]),this.removeCheck(s),d="false"):"indeterminate"===i&&this.autoCheck&&(h.classList.remove(di),h.classList.add(hi),this.removeCheck(s),d="mixed"):(h.classList.remove(hi),h.classList.add(di),this.addCheck(s),d="true"),d="check"===i?"true":"uncheck"===i?"false":d,t.isNullOrUndefined(d)||e.setAttribute("aria-checked",d),o){var c=[].concat([],this.checkActionNodes);n=this.getCheckEvent(s,i,r),t.isUndefined(l)&&(n.data=c)}void 0!==a&&this.ensureStateChange(s,a),l||t.isNullOrUndefined(d)||(e.setAttribute("aria-checked",d),n.data[0].checked=d,this.trigger("nodeChecked",n),this.checkActionNodes=[])},o.prototype.addCheck=function(e){var i=e.getAttribute("data-uid");t.isNullOrUndefined(i)||-1!==this.checkedNodes.indexOf(i)||this.checkedNodes.push(i)},o.prototype.removeCheck=function(e){var t=this.checkedNodes.indexOf(e.getAttribute("data-uid"));t>-1&&this.checkedNodes.splice(t,1)},o.prototype.getCheckEvent=function(e,i,s){this.checkActionNodes.push(this.getNodeData(e));var n=this.checkActionNodes;return{action:i,cancel:!1,isInteracted:!t.isNullOrUndefined(s),node:e,data:n}},o.prototype.finalize=function(){var e=t.select("."+Kt,this.element);if(!t.isNullOrUndefined(e)){e.setAttribute("role",mi.treeRole),this.setMultiSelect(this.allowMultiSelection);var i=t.select("."+_t,this.element);i&&(t.addClass([i],ui),this.updateIdAttr(null,i)),this.allowTextWrap&&this.updateWrap(),this.renderReactTemplates(),this.hasPid=!!this.rootData[0]&&this.rootData[0].hasOwnProperty(this.fields.parentID),this.doExpandAction()}},o.prototype.setTextWrap=function(){(this.allowTextWrap?t.addClass:t.removeClass)([this.element],"e-text-wrap"),t.Browser.isIE&&(this.allowTextWrap?t.addClass:t.removeClass)([this.element],"e-ie-wrap")},o.prototype.updateWrap=function(e){if(this.fullRowSelect)for(var i=e?t.selectAll("."+_t,e):this.liList,s=i.length,n=0;n<s;n++)this.calculateWrap(i[n])},o.prototype.calculateWrap=function(e){var i=t.select("."+ri,e);i&&i.nextElementSibling&&(i.style.height=this.allowTextWrap?i.nextElementSibling.offsetHeight+"px":"")},o.prototype.doExpandAction=function(){var e=this.expandedNodes;if(this.isInitalExpand&&e.length>0)if(this.setProperties({expandedNodes:[]},!0),this.fields.dataSource instanceof r.DataManager)this.expandGivenNodes(e);else{for(var i=0;i<e.length;i++){var s=t.select('[data-uid="'+e[i]+'"]',this.element);if(t.isNullOrUndefined(s))e[i]&&-1===this.expandChildren.indexOf(e[i])&&this.expandChildren.push(e[i].toString());else{var n=t.select("."+Vt,t.select("."+Zt,s));t.isNullOrUndefined(n)||this.expandAction(s,n,null)}}this.afterFinalized()}else this.afterFinalized()},o.prototype.expandGivenNodes=function(e){var t=this;this.expandCallback(e[this.index],function(){t.index++,t.index<e.length?t.expandGivenNodes(e):t.afterFinalized()})},o.prototype.expandCallback=function(e,i){var s=t.select('[data-uid="'+e+'"]',this.element);if(t.isNullOrUndefined(s))i();else{var n=t.select("."+Vt,t.select("."+Zt,s));t.isNullOrUndefined(n)?i():this.expandAction(s,n,null,!1,i)}},o.prototype.afterFinalized=function(){if(this.doSelectionAction(),this.updateCheckedProp(),this.isAnimate=!0,this.isInitalExpand=!1,!this.isLoaded||this.isFieldChange){var e={data:this.treeData};this.trigger("dataBound",e)}this.isLoaded=!0},o.prototype.doSelectionAction=function(){var e=t.selectAll("."+li,this.element),i=this.selectedNodes;if(i.length>0){this.setProperties({selectedNodes:[]},!0);for(var s=0;s<i.length;s++){var n=t.select('[data-uid="'+i[s]+'"]',this.element);if(n&&!n.classList.contains("e-active")?this.selectNode(n,null,!0):this.selectedNodes.push(i[s]),!this.allowMultiSelection)break}}else this.selectGivenNodes(e);t.removeClass(e,li)},o.prototype.selectGivenNodes=function(e){for(var t=0;t<e.length&&(e[t].classList.contains("e-disable")||this.selectNode(e[t],null,!0),this.allowMultiSelection);t++);},o.prototype.clickHandler=function(e){var i=e.originalEvent.target;if(t.EventHandler.remove(this.element,"contextmenu",this.preventContextMenu),i&&!this.dragStartAction){var s=i.classList,n=t.closest(i,"."+_t);if(n){if(3!==e.originalEvent.which){var r=t.select(".e-ripple-element",n),l=t.select("."+Jt,n);if(this.removeHover(),this.setFocusElement(n),this.showCheckBox&&!n.classList.contains("e-disable")){var o=t.closest(i,"."+ci);if(!t.isNullOrUndefined(o)){var a=t.select("."+pi,o);return this.validateCheckNode(o,a.classList.contains(di),n,e.originalEvent),void this.triggerClickEvent(e.originalEvent,n)}}s.contains(Vt)?this.expandAction(n,i,e):s.contains(Wt)?this.collapseNode(n,i,e):r&&l?l.classList.contains("e-ripple")&&l.classList.contains(Vt)?this.expandAction(n,l,e):l.classList.contains("e-ripple")&&l.classList.contains(Wt)?this.collapseNode(n,l,e):s.contains(Kt)||s.contains(_t)||this.toggleSelect(n,e.originalEvent,!1):s.contains(Kt)||s.contains(_t)||this.toggleSelect(n,e.originalEvent,!1)}this.triggerClickEvent(e.originalEvent,n)}}},o.prototype.nodeCheckedEvent=function(e,i,s){t.closest(e,"."+_t);var n=this.getCheckEvent(e,i?"uncheck":"check",s);n.data=n.data.splice(0,n.data.length-1),this.trigger("nodeChecked",n)},o.prototype.triggerClickEvent=function(e,t){var i={event:e,node:t};this.trigger("nodeClicked",i)},o.prototype.expandNode=function(e,i,s){var n=this;if(this.renderReactTemplates(),i.classList.contains(Gt)&&this.hideSpinner(i),this.initialRender||i.classList.add("interaction"),!0!==s||!0===s&&e.classList.contains("e-expanded")){if(!0!==this.preventExpand){t.removeClass([i],Vt),t.addClass([i],Wt);var l=0,o=0,a=this,d=t.select("."+Kt,e),h=e;this.setHeight(h,d);var c=t.select("."+_t+"."+Xt,e);this.isAnimate&&!this.isRefreshed?this.aniObj.animate(d,{name:this.animation.expand.effect,duration:this.animation.expand.duration,timingFunction:this.animation.expand.easing,begin:function(i){h.style.overflow="hidden",!t.isNullOrUndefined(c)&&c instanceof HTMLElement&&c.classList.add(fi),l=h.offsetHeight,o=t.select("."+Zt,e).offsetHeight},progress:function(e){e.element.style.display="block",a.animateHeight(e,l,o)},end:function(e){e.element.style.display="block",!t.isNullOrUndefined(c)&&c instanceof HTMLElement&&c.classList.remove(fi),n.expandedNode(h,d,i)}}):this.expandedNode(h,d,i)}}else{t.select("."+Kt,e).style.display="none",this.fields.dataSource instanceof r.DataManager==!0&&(this.preventExpand=!1)}this.initialRender&&i.classList.add("interaction")},o.prototype.expandedNode=function(e,i,s){i.style.display="block",e.style.display="block",e.style.overflow="",e.style.height="",t.removeClass([s],Qt),this.addExpand(e),this.allowTextWrap&&this.isLoaded&&this.isFirstRender&&(this.updateWrap(e),this.isFirstRender=!1),this.isLoaded&&this.expandArgs&&!this.isRefreshed&&(this.expandArgs=this.getExpandEvent(e,null),this.trigger("nodeExpanded",this.expandArgs))},o.prototype.addExpand=function(e){e.setAttribute("aria-expanded","true"),t.removeClass([e],ai);var i=e.getAttribute("data-uid");t.isNullOrUndefined(i)||-1!==this.expandedNodes.indexOf(i)||this.expandedNodes.push(i)},o.prototype.collapseNode=function(e,i,s){var n=this;if(!i.classList.contains(Qt)){t.addClass([i],Qt);var r;this.isLoaded?(r=this.getExpandEvent(e,s),this.trigger("nodeCollapsing",r,function(s){s.cancel?t.removeClass([i],Qt):n.nodeCollapseAction(e,i,s)})):this.nodeCollapseAction(e,i,r)}},o.prototype.nodeCollapseAction=function(e,i,s){var n=this;t.removeClass([i],Wt),t.addClass([i],Vt);var r=0,l=0,o=this,a=t.select("."+Kt,e),d=e,h=t.select("."+_t+"."+Xt,e);this.isAnimate?this.aniObj.animate(a,{name:this.animation.collapse.effect,duration:this.animation.collapse.duration,timingFunction:this.animation.collapse.easing,begin:function(i){d.style.overflow="hidden",!t.isNullOrUndefined(h)&&h instanceof HTMLElement&&h.classList.add(fi),r=t.select("."+Zt,e).offsetHeight,l=d.offsetHeight},progress:function(e){o.animateHeight(e,r,l)},end:function(e){e.element.style.display="none",!t.isNullOrUndefined(h)&&h instanceof HTMLElement&&h.classList.remove(fi),n.collapsedNode(d,a,i,s)}}):this.collapsedNode(d,a,i,s)},o.prototype.collapsedNode=function(e,i,s,n){i.style.display="none",e.style.overflow="",e.style.height="",t.removeClass([s],Qt),this.removeExpand(e),this.isLoaded&&(n=this.getExpandEvent(e,null),this.trigger("nodeCollapsed",n))},o.prototype.removeExpand=function(e,t){t?e.removeAttribute("aria-expanded"):this.disableExpandAttr(e);var i=this.expandedNodes.indexOf(e.getAttribute("data-uid"));i>-1&&this.expandedNodes.splice(i,1)},o.prototype.disableExpandAttr=function(e){e.setAttribute("aria-expanded","false"),t.addClass([e],ai)},o.prototype.setHeight=function(e,t){t.style.display="block",t.style.visibility="hidden",e.style.height=e.offsetHeight+"px",t.style.display="none",t.style.visibility=""},o.prototype.animateHeight=function(e,t,i){var s=(i-t)*((e.duration-e.timeStamp)/e.duration)+t;e.element.parentElement.style.height=s+"px"},o.prototype.renderChildNodes=function(e,s,n,l){var o=this,a=t.select("div."+Jt,e);if(!t.isNullOrUndefined(a)){this.showSpinner(a);var d;if(this.fields.dataSource instanceof r.DataManager){var h=this.parents(e,"."+Kt).length,c=this.getChildFields(this.fields,h,1);if(t.isNullOrUndefined(c)||t.isNullOrUndefined(c.dataSource))return t.detach(a),void this.removeExpand(e,!0);this.treeList.push("false"),this.fields.dataSource instanceof r.DataManager&&this.isOffline?(this.treeList.pop(),d=this.getChildNodes(this.treeData,e.getAttribute("data-uid")),this.loadChild(d,c,a,e,s,n,l)):c.dataSource.executeQuery(this.getQuery(c,e.getAttribute("data-uid"))).then(function(t){o.treeList.pop(),d=t.result,1===o.dataType&&(o.dataType=2),o.loadChild(d,c,a,e,s,n,l)}).catch(function(e){o.trigger("actionFailure",{error:e})})}else{if(d=this.getChildNodes(this.treeData,e.getAttribute("data-uid")),this.currentLoadData=this.getSortedData(d),t.isNullOrUndefined(d)||0===d.length)return t.detach(a),void this.removeExpand(e,!0);this.listBaseOption.ariaAttributes.level=parseFloat(e.getAttribute("aria-level"))+1,e.appendChild(i.ListBase.createList(this.createElement,this.currentLoadData,this.listBaseOption)),this.expandNode(e,a,l),this.setSelectionForChildNodes(d),this.ensureCheckNode(e),this.finalizeNode(e),this.disableTreeNodes(d),this.renderSubChild(e,s,l)}}},o.prototype.loadChild=function(e,s,n,l,o,a,d){if(this.currentLoadData=e,t.isNullOrUndefined(e)||0===e.length)t.detach(n),this.removeExpand(l,!0);else{if(this.updateListProp(s),this.fields.dataSource instanceof r.DataManager&&!this.isOffline){var h=l.getAttribute("data-uid"),c=this.getNodeObject(h);t.setValue("child",e,c)}this.listBaseOption.ariaAttributes.level=parseFloat(l.getAttribute("aria-level"))+1,l.appendChild(i.ListBase.createList(this.createElement,e,this.listBaseOption)),this.expandNode(l,n,d),this.setSelectionForChildNodes(e),this.ensureCheckNode(l),this.finalizeNode(l),this.disableTreeNodes(e),this.renderSubChild(l,o,d)}a&&a(),0!==this.treeList.length||this.isLoaded||this.finalize()},o.prototype.disableTreeNodes=function(e){for(var t=0;t<e.length;){var i=e[t][this.fields.id]?e[t][this.fields.id].toString():null;void 0!==this.disableNode&&-1!==this.disableNode.indexOf(i)&&this.doDisableAction([i]),t++}},o.prototype.setSelectionForChildNodes=function(e){var t;for(t=0;t<e.length;t++){var i=e[t][this.fields.id]?e[t][this.fields.id].toString():null;void 0!==this.selectedNodes&&-1!==this.selectedNodes.indexOf(i)&&this.doSelectionAction()}},o.prototype.ensureCheckNode=function(e){this.showCheckBox&&(this.ele=this.checkedElement?this.checkedElement.indexOf(e.getAttribute("data-uid")):null,this.autoCheck&&(this.ensureChildCheckState(e),this.ensureParentCheckState(e))),this.currentLoadData=null},o.prototype.getFields=function(e,t,i){return t===i?e:this.getFields(this.getChildMapper(e),t,i+1)},o.prototype.getChildFields=function(e,t,i){return t===i?this.getChildMapper(e):this.getChildFields(this.getChildMapper(e),t,i+1)},o.prototype.getChildMapper=function(e){return"string"==typeof e.child||t.isNullOrUndefined(e.child)?e:e.child},o.prototype.getChildNodes=function(e,i,s){void 0===s&&(s=!1);var n;if(t.isNullOrUndefined(e))return n;if(1===this.dataType)return this.getChildGroup(this.groupedData,i,s);if("string"==typeof this.fields.child)for(var r=0,l=e.length;r<l;r++){var o=t.getValue(this.fields.id,e[r]);if(o&&o.toString()===i)return t.getValue(this.fields.child,e[r]);if(!t.isNullOrUndefined(t.getValue(this.fields.child,e[r]))&&void 0!==(n=this.getChildNodes(t.getValue(this.fields.child,e[r]),i)))break}return n},o.prototype.getChildGroup=function(e,i,s){if(!t.isNullOrUndefined(e))for(var n=0,r=e.length;n<r;n++){if(t.isNullOrUndefined(e[n][0])||t.isNullOrUndefined(t.getValue(this.fields.parentID,e[n][0])))return s?e[n]:[];if(t.getValue(this.fields.parentID,e[n][0]).toString()===i)return e[n]}},o.prototype.renderSubChild=function(e,i,s){if(i)for(var n=t.selectAll("."+Vt,e),r=0,l=n.length;r<l;r++){var o=n[r];if(e.querySelector(".e-icons")!==n[r]){var a=t.closest(o,"."+_t);this.expandArgs=this.getExpandEvent(a,null),!0!==s&&this.trigger("nodeExpanding",this.expandArgs),this.renderChildNodes(a,i,null,s)}}},o.prototype.toggleSelect=function(e,t,i){e.classList.contains("e-disable")||(this.allowMultiSelection&&(t&&t.ctrlKey||i)&&this.isActive(e)?this.unselectNode(e,t):this.selectNode(e,t,i))},o.prototype.isActive=function(e){return!!e.classList.contains(Xt)},o.prototype.selectNode=function(e,i,s){var n=this;if(t.isNullOrUndefined(e)||!this.allowMultiSelection&&this.isActive(e)&&!t.isNullOrUndefined(i))this.setFocusElement(e);else{var r;this.isLoaded?(r=this.getSelectEvent(e,"select",i),this.trigger("nodeSelecting",r,function(t){t.cancel||n.nodeSelectAction(e,i,t,s)})):this.nodeSelectAction(e,i,r,s)}},o.prototype.nodeSelectAction=function(e,i,s,n){if(this.allowMultiSelection&&(n||i&&(!i||i.ctrlKey))||this.removeSelectAll(),this.allowMultiSelection&&i&&i.shiftKey){this.startNode||(this.startNode=e);var r=this.liList.indexOf(this.startNode),l=this.liList.indexOf(e);if(r>l){var o=r;r=l,l=o}for(var a=r;a<=l;a++){var d=this.liList[a];t.isVisible(d)&&!d.classList.contains("e-disable")&&this.addSelect(d)}}else this.startNode=e,this.addSelect(e);this.setFocusElement(e),this.isLoaded&&(s.nodeData=this.getNodeData(e),this.trigger("nodeSelected",s))},o.prototype.unselectNode=function(e,t){var i,s=this;this.isLoaded?(i=this.getSelectEvent(e,"un-select",t),this.trigger("nodeSelecting",i,function(t){t.cancel||s.nodeUnselectAction(e,t)})):this.nodeUnselectAction(e,i)},o.prototype.nodeUnselectAction=function(e,t){this.removeSelect(e),this.setFocusElement(e),this.isLoaded&&(t.nodeData=this.getNodeData(e),this.trigger("nodeSelected",t))},o.prototype.setFocusElement=function(e){if(!t.isNullOrUndefined(e)){var i=this.getFocusedNode();i&&t.removeClass([i],ui),t.addClass([e],ui),this.updateIdAttr(i,e)}},o.prototype.addSelect=function(e){e.setAttribute("aria-selected","true"),t.addClass([e],Xt);var i=e.getAttribute("data-uid");t.isNullOrUndefined(i)||-1!==this.selectedNodes.indexOf(i)||this.selectedNodes.push(i)},o.prototype.removeSelect=function(e){this.allowMultiSelection?e.setAttribute("aria-selected","false"):e.removeAttribute("aria-selected"),t.removeClass([e],Xt);var i=this.selectedNodes.indexOf(e.getAttribute("data-uid"));i>-1&&this.selectedNodes.splice(i,1)},o.prototype.removeSelectAll=function(){for(var e=this.element.querySelectorAll("."+Xt),i=0,s=e;i<s.length;i++){var n=s[i];this.allowMultiSelection?n.setAttribute("aria-selected","false"):n.removeAttribute("aria-selected")}t.removeClass(e,Xt),this.setProperties({selectedNodes:[]},!0)},o.prototype.getSelectEvent=function(e,i,s){var n=this.getNodeData(e);return{action:i,cancel:!1,isInteracted:!t.isNullOrUndefined(s),node:e,nodeData:n}},o.prototype.setExpandOnType=function(){this.expandOnType="Auto"===this.expandOn?t.Browser.isDevice?"Click":"DblClick":this.expandOn},o.prototype.expandHandler=function(e){var i=e.originalEvent.target;!i||i.classList.contains("e-input")||i.classList.contains(Ft)||i.classList.contains(Kt)||i.classList.contains(_t)||i.classList.contains(Jt)||this.showCheckBox&&t.closest(i,"."+ci)||this.expandCollapseAction(t.closest(i,"."+_t),e)},o.prototype.expandCollapseAction=function(e,i){var s=t.select("div."+Jt,e);if(s&&!s.classList.contains(Qt)){var n=s.classList;n.contains(Vt)?this.expandAction(e,s,i):n.contains(Wt)&&this.collapseNode(e,s,i)}},o.prototype.expandAction=function(e,i,s,n,r){var l=this;i.classList.contains(Qt)||(t.addClass([i],Qt),this.isLoaded&&!this.isRefreshed?(this.expandArgs=this.getExpandEvent(e,s),this.trigger("nodeExpanding",this.expandArgs,function(s){s.cancel?t.removeClass([i],Qt):l.nodeExpandAction(e,i,n,r)})):this.nodeExpandAction(e,i,n,r))},o.prototype.nodeExpandAction=function(e,i,s,n){var r=t.select("."+Kt,e);if(r&&"UL"===r.nodeName)this.expandNode(e,i);else{this.isFirstRender=!0,this.renderChildNodes(e,s,n);for(var l=t.selectAll("."+_t,e),o=0;o<l.length;o++){var a=this.getId(l[o]);if(-1!==this.expandChildren.indexOf(a)&&void 0!==this.expandChildren){var d=t.select("."+Vt,t.select("."+Zt,l[o]));t.isNullOrUndefined(d)||this.expandAction(l[o],d,null),this.expandChildren.splice(this.expandChildren.indexOf(a),1)}}}},o.prototype.keyActionHandler=function(e){var i=this,s=e.target,n=this.getFocusedNode();if(s&&s.classList.contains("e-input")){var r=s;"enter"===e.action?(r.blur(),this.element.focus(),t.addClass([n],Yt)):"escape"===e.action&&(r.value=this.oldText,r.blur(),this.element.focus(),t.addClass([n],Yt))}else{e.preventDefault();var l={cancel:!1,event:e,node:n};this.trigger("keyPress",l,function(s){if(!s.cancel)switch(e.action){case"space":i.showCheckBox&&i.checkNode(e);break;case"moveRight":i.openNode(!i.enableRtl,e);break;case"moveLeft":i.openNode(!!i.enableRtl,e);break;case"shiftDown":i.shiftKeySelect(!0,e);break;case"moveDown":case"ctrlDown":case"csDown":i.navigateNode(!0);break;case"shiftUp":i.shiftKeySelect(!1,e);break;case"moveUp":case"ctrlUp":case"csUp":i.navigateNode(!1);break;case"home":case"shiftHome":case"ctrlHome":case"csHome":i.navigateRootNode(!0);break;case"end":case"shiftEnd":case"ctrlEnd":case"csEnd":i.navigateRootNode(!1);break;case"enter":case"ctrlEnter":case"shiftEnter":case"csEnter":i.toggleSelect(n,e);break;case"f2":i.allowEditing&&!n.classList.contains("e-disable")&&i.createTextbox(n,e);break;case"ctrlA":if(i.allowMultiSelection){var r=t.selectAll("."+_t+":not(."+Xt+")",i.element);i.selectGivenNodes(r)}}})}},o.prototype.navigateToFocus=function(e){var i=this.getFocusedNode().querySelector("."+Zt),s=i.getBoundingClientRect(),n=this.getScrollParent(this.element);if(!t.isNullOrUndefined(n)){var r=n.getBoundingClientRect();s.bottom>r.bottom?n.scrollTop+=s.bottom-r.bottom:s.top<r.top&&(n.scrollTop-=r.top-s.top)}this.isVisibleInViewport(i)||i.scrollIntoView(e)},o.prototype.isVisibleInViewport=function(e){var t=e.getBoundingClientRect();return t.top>=0&&t.left>=0&&t.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&t.right<=(window.innerWidth||document.documentElement.clientWidth)},o.prototype.getScrollParent=function(e){return t.isNullOrUndefined(e)?null:e.scrollHeight>e.clientHeight?e:this.getScrollParent(e.parentElement)},o.prototype.shiftKeySelect=function(e,t){if(this.allowMultiSelection){var i=this.getFocusedNode(),s=e?this.getNextNode(i):this.getPrevNode(i);this.removeHover(),this.setFocusElement(s),this.toggleSelect(s,t,!1),this.navigateToFocus(!e)}else this.navigateNode(e)},o.prototype.checkNode=function(e){var i=this.getFocusedNode(),s=t.select("."+ci,i),n=t.select(" ."+pi,s).classList.contains(di);i.classList.contains("e-disable")||0==i.getElementsByClassName("e-checkbox-disabled").length&&this.validateCheckNode(s,n,i,e)},o.prototype.validateCheckNode=function(e,i,s,n){var r=this,l=t.closest(e,"."+_t);this.checkActionNodes=[];var o=i?"false":"true";t.isNullOrUndefined(o)||e.setAttribute("aria-checked",o);var a=this.getCheckEvent(l,i?"uncheck":"check",n);this.trigger("nodeChecking",a,function(t){t.cancel||r.nodeCheckingAction(e,i,s,t,n)})},o.prototype.nodeCheckingAction=function(e,i,s,n,r){if(-1===this.checkedElement.indexOf(s.getAttribute("data-uid"))&&(this.checkedElement.push(s.getAttribute("data-uid")),this.autoCheck)){var l=this.getChildNodes(this.treeData,s.getAttribute("data-uid"));null!==l?this.allCheckNode(l,this.checkedElement,null,null,!1):l=null}if(this.changeState(e,i?"uncheck":"check",r,!0),this.autoCheck){this.ensureChildCheckState(s),this.ensureParentCheckState(t.closest(t.closest(s,"."+Kt),"."+_t));var o=void 0;"check"===n.action?o=!0:"uncheck"===n.action&&(o=!1),this.ensureStateChange(s,o)}this.nodeCheckedEvent(e,i,r)},o.prototype.ensureStateChange=function(e,i){var s=t.select("."+Kt,e),n=e.getAttribute("data-uid"),l=this.fields;if(1===this.dataType&&this.autoCheck)for(var o=new r.DataManager(this.treeData).executeLocal((new r.Query).where(l.parentID,"equal",n,!0)),a=0;a<o.length;a++){var d=o[a][this.fields.id]?o[a][this.fields.id].toString():null,h=o[a][this.fields.isChecked]?o[a][this.fields.isChecked].toString():null;if(-1!==this.checkedNodes.indexOf(n)&&-1===this.checkedNodes.indexOf(d)){this.checkedNodes.push(d);var c=this.getChildNodes(this.treeData,d);this.getChildItems(c,i),-1!==this.parentNodeCheck.indexOf(d)&&this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(d),1)}else if(-1===this.checkedNodes.indexOf(n)&&null===s&&-1!==this.checkedNodes.indexOf(d)){if(this.checkedNodes.splice(this.checkedNodes.indexOf(d),1),"true"===h&&this.updateField(this.treeData,this.fields,d,"isChecked",null),-1===this.checkedNodes.indexOf(n)&&null===s||-1!==this.parentNodeCheck.indexOf(d)){var p=this.getChildNodes(this.treeData,d);this.getChildItems(p,i),-1!==this.parentNodeCheck.indexOf(d)&&this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(d),1)}}else{c=this.getChildNodes(this.treeData,d);this.getChildItems(c,i)}}else if(1!==this.dataType||this.autoCheck){(c=this.getChildNodes(this.treeData,n))&&this.childStateChange(c,n,s,i)}else if(i)for(a=0;a<this.treeData.length;a++){var u=this.treeData[a][this.fields.id]?this.treeData[a][this.fields.id].toString():null;-1===this.checkedNodes.indexOf(u)&&this.checkedNodes.push(u)}else{for(var f=new r.DataManager(this.treeData).executeLocal((new r.Query).where(l.isChecked,"equal",!0,!1)),a=0;a<f.length;a++){var m=f[a][this.fields.id]?f[a][this.fields.id].toString():null;-1!==this.checkedNodes.indexOf(m)&&this.checkedNodes.splice(this.checkedNodes.indexOf(m),1),this.updateField(this.treeData,this.fields,m,"isChecked",null)}this.checkedNodes=[]}},o.prototype.getChildItems=function(e,t){for(var i=0;i<e.length;i++){var s=e[i][this.fields.id]?e[i][this.fields.id].toString():null,n=e[i][this.fields.isChecked]?e[i][this.fields.isChecked].toString():null;-1===this.checkedNodes.indexOf(s)||t||this.checkedNodes.splice(this.checkedNodes.indexOf(s),1),-1===this.checkedNodes.indexOf(s)&&t&&this.checkedNodes.push(s),"true"!==n||t||this.updateField(this.treeData,this.fields,s,"isChecked",null);var r=this.getChildNodes(this.treeData,s);r.length>0&&this.getChildItems(r,t)}},o.prototype.childStateChange=function(e,t,i,s){for(var n=0;n<e.length;n++){var r=e[n][this.fields.id]?e[n][this.fields.id].toString():"",l=e[n][this.fields.isChecked]?e[n][this.fields.isChecked].toString():null;this.autoCheck?-1!==this.checkedNodes.indexOf(t)&&-1===this.checkedNodes.indexOf(r)?(this.checkedNodes.push(r),-1!==this.parentNodeCheck.indexOf(r)&&this.parentNodeCheck.splice(this.parentNodeCheck.indexOf(r),1)):-1!==this.checkedNodes.indexOf(t)||-1===this.checkedNodes.indexOf(r)||s||(this.checkedNodes.splice(this.checkedNodes.indexOf(r),1),"true"===l&&this.updateField(this.treeData,this.fields,r,"isChecked",null)):this.autoCheck||(s?-1===this.checkedNodes.indexOf(r)&&this.checkedNodes.push(r):(-1!==this.checkedNodes.indexOf(r)&&this.checkedNodes.splice(this.checkedNodes.indexOf(r),1),this.updateField(this.treeData,this.fields,r,"isChecked",null),this.checkedNodes=[]));var o=this.getChildNodes([e[n]],r);o&&this.childStateChange(o,t,i,s)}},o.prototype.allCheckNode=function(e,i,s,n,r){if(e)for(var l=0;l<e.length;l++){var o=t.getValue(this.fields.id,e[l]),a=this.element.querySelector('[data-uid="'+o+'"]');!1!==r&&-1===this.checkedElement.indexOf(o.toString())&&(null===a&&!t.isNullOrUndefined(e[l][this.fields.isChecked])&&-1===i.indexOf(o.toString())||0===n||2===s)&&(!1!==e[l][this.fields.isChecked]||2===s?i.push(o.toString()):n=null,n=!1!==e[l][this.fields.isChecked]||2===s?0:null),-1===i.indexOf(o.toString())&&t.isNullOrUndefined(s)&&i.push(o.toString());var d=t.getValue(this.fields.child.toString(),e[l]);if(!0===t.getValue(this.fields.hasChildren,e[l])||d){var h=t.getValue(this.fields.id,e[l]),c=void 0;(c=1===this.dataType?this.getChildNodes(this.treeData,h.toString()):d)&&(t.isNullOrUndefined(r)?this.allCheckNode(c,i,s,n):this.allCheckNode(c,i,s,n,r),n=null)}n=null}},o.prototype.openNode=function(e,i){var s=this.getFocusedNode(),n=t.select("div."+Jt,s);if(e){if(!n)return;n.classList.contains(Vt)?this.expandAction(s,n,i):this.focusNextNode(s,!0)}else if(n&&n.classList.contains(Wt))this.collapseNode(s,n,i);else{var r=t.closest(t.closest(s,"."+Kt),"."+_t);if(!r)return;r.classList.contains("e-disable")||(this.setFocus(s,r),this.navigateToFocus(!0))}},o.prototype.navigateNode=function(e){var t=this.getFocusedNode();this.focusNextNode(t,e)},o.prototype.navigateRootNode=function(e){var t=this.getFocusedNode(),i=e?this.getRootNode():this.getEndNode();i.classList.contains("e-disable")||(this.setFocus(t,i),this.navigateToFocus(e))},o.prototype.getFocusedNode=function(){var e,i=t.select("."+_t+"."+ui,this.element);return t.isNullOrUndefined(i)&&(e=t.select("."+_t,this.element)),t.isNullOrUndefined(i)?t.isNullOrUndefined(e)?this.element.firstElementChild:e:i},o.prototype.focusNextNode=function(e,t){var i=t?this.getNextNode(e):this.getPrevNode(e);if(this.setFocus(e,i),this.navigateToFocus(!t),i.classList.contains("e-disable")){var s=i.lastChild;null==i.previousSibling&&i.classList.contains("e-level-1")?this.focusNextNode(i,!0):null==i.nextSibling&&i.classList.contains("e-node-collapsed")?this.focusNextNode(i,!1):null==i.nextSibling&&s.classList.contains(Zt)?this.focusNextNode(i,!1):this.focusNextNode(i,t)}},o.prototype.getNextNode=function(e){var i,s=this.liList.indexOf(e);do{if(s++,i=this.liList[s],t.isNullOrUndefined(i))return e}while(!t.isVisible(i));return i},o.prototype.getPrevNode=function(e){var i,s=this.liList.indexOf(e);do{if(s--,i=this.liList[s],t.isNullOrUndefined(i))return e}while(!t.isVisible(i));return i},o.prototype.getRootNode=function(){var e,i=0;do{e=this.liList[i],i++}while(!t.isVisible(e));return e},o.prototype.getEndNode=function(){var e,i=this.liList.length-1;do{e=this.liList[i],i--}while(!t.isVisible(e));return e},o.prototype.setFocus=function(e,i){t.removeClass([e],[Yt,ui]),i.classList.contains("e-disable")||(t.addClass([i],[Yt,ui]),this.updateIdAttr(e,i))},o.prototype.updateIdAttr=function(e,t){this.element.removeAttribute("aria-activedescendant"),e&&e.removeAttribute("id"),t.setAttribute("id",this.element.id+"_active"),this.element.setAttribute("aria-activedescendant",this.element.id+"_active")},o.prototype.focusIn=function(){this.mouseDownStatus||t.addClass([this.getFocusedNode()],Yt),this.mouseDownStatus=!1},o.prototype.focusOut=function(){t.removeClass([this.getFocusedNode()],Yt)},o.prototype.onMouseOver=function(e){var i=e.target,s=i.classList,n=t.closest(i,"."+_t);!n||s.contains(Kt)||s.contains(_t)?this.removeHover():n&&!n.classList.contains("e-disable")&&this.setHover(n)},o.prototype.setHover=function(e){e.classList.contains(Yt)||(this.removeHover(),t.addClass([e],Yt))},o.prototype.onMouseLeave=function(e){this.removeHover()},o.prototype.removeHover=function(){var e=t.selectAll("."+Yt,this.element);e&&e.length&&t.removeClass(e,Yt)},o.prototype.getNodeData=function(e,i){if(!t.isNullOrUndefined(e)&&e.classList.contains(_t)&&!t.isNullOrUndefined(t.closest(e,".e-control"))&&t.closest(e,".e-control").classList.contains(Ft)){var s=e.getAttribute("data-uid"),n=this.getText(e,i),r=t.closest(e.parentNode,"."+_t),l=r?r.getAttribute("data-uid"):null,o=e.classList.contains(Xt),a="true"===e.getAttribute("aria-expanded"),d=null!==e.getAttribute("aria-expanded")||null!=(t.select("."+Vt,e)||t.select("."+Wt,e)),h=null;return this.showCheckBox&&(h=t.select("."+ci,e).getAttribute("aria-checked")),{id:s,text:n,parentID:l,selected:o,expanded:a,isChecked:h,hasChildren:d}}return{id:"",text:"",parentID:"",selected:!1,expanded:!1,isChecked:"",hasChildren:!1}},o.prototype.getText=function(e,i){if(i){var s=this.getNodeObject(e.getAttribute("data-uid")),n=parseFloat(e.getAttribute("aria-level")),r=this.getFields(this.fields,n,1);return t.getValue(r.text,s)}return t.select("."+zt,e).textContent},o.prototype.getExpandEvent=function(e,i){var s=this.getNodeData(e);return{cancel:!1,isInteracted:!t.isNullOrUndefined(i),node:e,nodeData:s,event:i}},o.prototype.renderNodeTemplate=function(e,i,s){var n=this.nodeTemplateFn(e,this,"nodeTemplate"+s,this.element.id+"nodeTemplate",this.isStringTemplate,void 0,i);n&&(n=Array.prototype.slice.call(n),t.append(n,i))},o.prototype.destroyTemplate=function(e){this.clearTemplate(["nodeTemplate"+e.getAttribute("data-uid")])},o.prototype.reRenderNodes=function(){this.updateListProp(this.fields),t.Browser.isIE?(this.ulElement=this.element.querySelector(".e-list-parent.e-ul"),this.ulElement.parentElement.removeChild(this.ulElement)):this.element.innerHTML="",t.isNullOrUndefined(this.nodeTemplateFn)||this.clearTemplate(),this.setTouchClass(),this.setProperties({selectedNodes:[],checkedNodes:[],expandedNodes:[]},!0),this.checkedElement=[],this.isLoaded=!1,this.setDataBinding(!0)},o.prototype.setCssClass=function(e,i){t.isNullOrUndefined(e)||""===e||t.removeClass([this.element],e.split(" ")),t.isNullOrUndefined(i)||""===i||t.addClass([this.element],i.split(" "))},o.prototype.editingHandler=function(e){var i=e.target;if(!(!i||i.classList.contains(Ft)||i.classList.contains(Kt)||i.classList.contains(_t)||i.classList.contains(Jt)||i.classList.contains("e-input")||i.classList.contains("e-input-group"))){var s=t.closest(i,"."+_t);this.createTextbox(s,e)}},o.prototype.createTextbox=function(e,i){var s=this,n=t.select("."+$t,this.element);n&&n.blur();var r=t.select("."+zt,e);this.updateOldText(e);var o=this.createElement("input",{className:$t,attrs:{value:this.oldText}}),a=this.getEditEvent(e,null,o.outerHTML);this.trigger("nodeEditing",a,function(i){if(!i.cancel){var n="width:"+(r.offsetWidth+5)+"px";t.addClass([e],"e-editing"),t.isNullOrUndefined(s.nodeTemplateFn)||s.destroyTemplate(e),r.innerHTML=a.innerHtml;var o=t.select("."+$t,r);s.inputObj=l.Input.createInput({element:o,properties:{enableRtl:s.enableRtl}},s.createElement),s.inputObj.container.setAttribute("style",n),o.focus();var d=o;d.setSelectionRange(0,d.value.length),s.wireInputEvents(o)}})},o.prototype.updateOldText=function(e){var i=e.getAttribute("data-uid");this.editData=this.getNodeObject(i);var s=parseFloat(e.getAttribute("aria-level"));this.editFields=this.getFields(this.fields,s,1),this.oldText=t.getValue(this.editFields.text,this.editData)},o.prototype.inputFocusOut=function(e){if(t.select("."+$t,this.element)){var i=e.target,s=i.value,n=t.closest(i,"."+zt),l=t.closest(i,"."+_t);t.detach(this.inputObj.container),this.fields.dataSource instanceof r.DataManager&&!this.isOffline?this.crudOperation("update",null,l,s,null,null,!0):this.appendNewText(l,n,s,!0)}},o.prototype.appendNewText=function(e,t,i,s){var n=this,r=this.getEditEvent(e,i,null);this.trigger("nodeEdited",r,function(r){i=r.cancel?r.oldText:r.newText,n.updateText(e,t,i,s),r.oldText!==i&&n.triggerEvent()})},o.prototype.updateText=function(e,i,s,n){var r=t.setValue(this.editFields.text,s,this.editData);if(t.isNullOrUndefined(this.nodeTemplateFn))i.innerText=s;else{i.innerText="";var l=e.getAttribute("data-uid");this.renderNodeTemplate(r,i,l),this.renderReactTemplates()}n&&(t.removeClass([e],"e-editing"),i.focus()),this.allowTextWrap&&this.calculateWrap(e)},o.prototype.getElement=function(e){return t.isNullOrUndefined(e)?null:"string"==typeof e?this.element.querySelector('[data-uid="'+e+'"]'):"object"==typeof e?t.getElement(e):null},o.prototype.getId=function(e){return t.isNullOrUndefined(e)?null:"string"==typeof e?e:"object"==typeof e?t.getElement(e).getAttribute("data-uid"):null},o.prototype.getEditEvent=function(e,t,i){return{cancel:!1,newText:t,node:e,nodeData:this.getNodeData(e),oldText:this.oldText,innerHtml:i}},o.prototype.getNodeObject=function(e){if(!t.isNullOrUndefined(e)){if(1!==this.dataType)return this.getChildNodeObject(this.treeData,this.fields,e);for(var i=0,s=this.treeData.length;i<s;i++){var n=t.getValue(this.fields.id,this.treeData[i]);if(!t.isNullOrUndefined(this.treeData[i])&&!t.isNullOrUndefined(n)&&n.toString()===e)return this.treeData[i]}}},o.prototype.getChildNodeObject=function(e,i,s){var n;if(t.isNullOrUndefined(e))return n;for(var l=0,o=e.length;l<o;l++){var a=t.getValue(i.id,e[l]);if(e[l]&&a&&a.toString()===s)return e[l];if("string"!=typeof i.child||t.isNullOrUndefined(t.getValue(i.child,e[l]))){if(this.fields.dataSource instanceof r.DataManager&&!t.isNullOrUndefined(t.getValue("child",e[l]))){if(void 0!==(n=this.getChildNodeObject(t.getValue("child",e[l]),this.getChildMapper(i),s)))break}}else{var d=t.getValue(i.child,e[l]);if(void 0!==(n=this.getChildNodeObject(d,this.getChildMapper(i),s)))break}}return n},o.prototype.setDragAndDrop=function(e){e&&!this.disabled?this.initializeDrag():this.destroyDrag()},o.prototype.initializeDrag=function(){var e,i=this,s=this;this.dragObj=new t.Draggable(this.element,{enableTailMode:!0,enableAutoScroll:!0,dragArea:this.dragArea,dragTarget:"."+Zt,helper:function(n){i.dragTarget=n.sender.target;var r=t.closest(i.dragTarget,"."+Ft),l=t.closest(i.dragTarget,"."+Zt);if(i.dragLi=t.closest(i.dragTarget,"."+_t),i.fullRowSelect&&!l&&i.dragTarget.classList.contains(ri)&&(l=i.dragTarget.nextElementSibling),!i.dragTarget||!n.element.isSameNode(r)||!l||i.dragTarget.classList.contains(Ft)||i.dragTarget.classList.contains(Kt)||i.dragTarget.classList.contains(_t)||i.dragLi.classList.contains("e-disable"))return!1;var o=l.cloneNode(!0);if(t.isNullOrUndefined(t.select("div."+Jt,o))){var a=s.createElement("div",{className:Jt+" "+Vt});o.insertBefore(a,o.children[0])}var d="e-drag-item "+Ft+" "+i.cssClass+" "+(i.enableRtl?"e-rtl":"");(e=s.createElement("div",{className:d})).appendChild(o);var h=i.selectedNodes.length;if(h>1&&i.allowMultiSelection&&i.dragLi.classList.contains(Xt)){var c=s.createElement("span",{className:"e-drop-count",innerHTML:""+h});e.appendChild(c)}return document.body.appendChild(e),document.body.style.cursor="",i.dragData=i.getNodeData(i.dragLi),e},dragStart:function(s){t.addClass([i.element],ei);var n,r=t.closest(s.target,".e-list-item");r&&(n=parseInt(r.getAttribute("aria-level"),10));var l=i.getDragEvent(s.event,i,null,s.target,null,e,n);l.draggedNode.classList.contains("e-editing")?(i.dragObj.intDestroy(s.event),i.dragCancelAction(e)):i.trigger("nodeDragStart",l,function(t){t.cancel?(i.dragObj.intDestroy(s.event),i.dragCancelAction(e)):i.dragStartAction=!0})},drag:function(s){i.dragObj.setProperties({cursorAt:{top:!t.isNullOrUndefined(s.event.targetTouches)||t.Browser.isDevice?60:-20}}),i.dragAction(s,e)},dragStop:function(e){t.removeClass([i.element],ei),i.removeVirtualEle();var s=e.target,n=t.closest(s,".e-droppable");s&&n||(t.detach(e.helper),document.body.style.cursor="");var r,l=t.closest(s,".e-list-item");l&&(r=parseInt(l.getAttribute("aria-level"),10));var o=i.getDragEvent(e.event,i,s,s,null,e.helper,r);o.preventTargetExpand=!1,i.trigger("nodeDragStop",o,function(s){i.dragParent=s.draggedParentNode,i.preventExpand=s.preventTargetExpand,s.cancel&&(e.helper.parentNode&&t.detach(e.helper),document.body.style.cursor=""),i.dragStartAction=!1})}}),this.dropObj=new t.Droppable(this.element,{out:function(e){t.isNullOrUndefined(e)||e.target.classList.contains(ti)||(document.body.style.cursor="not-allowed")},over:function(e){document.body.style.cursor=""},drop:function(e){i.dropAction(e)}})},o.prototype.dragCancelAction=function(e){t.detach(e),t.removeClass([this.element],ei),this.dragStartAction=!1},o.prototype.dragAction=function(e,i){var s=t.closest(e.target,".e-droppable"),n=t.closest(e.target,"."+Zt),r=t.select("div."+Jt,i);t.removeClass([r],[ii,si,ni,"e-no-drop"]),this.removeVirtualEle(),document.body.style.cursor="";var l=e.target.classList;if(this.fullRowSelect&&!n&&!t.isNullOrUndefined(l)&&l.contains(ri)&&(n=e.target.nextElementSibling),s){var o=t.closest(e.target,"."+_t),a=t.closest(e.target,"."+ci),d=t.closest(e.target,"."+Wt),h=t.closest(e.target,"."+Vt);if(!s.classList.contains(Ft)||n&&!o.isSameNode(this.dragLi)&&!this.isDescendant(this.dragLi,o))if(this.hasTemplate&&o){var c=t.select(this.fullRowSelect?"."+ri:"."+Zt,o);if(e&&!h&&!d&&e.event.offsetY<7&&!a||h&&e.event.offsetY<5||d&&e.event.offsetX<3){var p=this.fullRowSelect?1:0;this.appendIndicator(o,r,p)}else if(e&&!h&&!d&&!a&&c&&e.event.offsetY>c.offsetHeight-10||h&&e.event.offsetY>19||d&&e.event.offsetX>19){p=this.fullRowSelect?2:1;this.appendIndicator(o,r,p)}else t.addClass([r],ii)}else if(o&&e&&!h&&!d&&e.event.offsetY<7&&!a||h&&e.event.offsetY<5||d&&e.event.offsetX<3){p=this.fullRowSelect?1:0;this.appendIndicator(o,r,p)}else if(o&&e&&!h&&!d&&e.target.offsetHeight>0&&e.event.offsetY>e.target.offsetHeight-10&&!a||h&&e.event.offsetY>19||d&&e.event.offsetX>19){p=this.fullRowSelect?2:1;this.appendIndicator(o,r,p)}else t.addClass([r],ii);else"LI"!==e.target.nodeName||o.isSameNode(this.dragLi)||this.isDescendant(this.dragLi,o)?e.target.classList.contains(ti)?t.addClass([r],si):t.addClass([r],ni):(t.addClass([r],si),this.renderVirtualEle(e))}else t.addClass([r],"e-no-drop"),document.body.style.cursor="not-allowed";var u,f=t.closest(e.target,".e-list-item");f&&(u=parseInt(f.getAttribute("aria-level"),10));var m=this.getDragEvent(e.event,this,e.target,e.target,null,i,u);m.dropIndicator&&t.removeClass([r],m.dropIndicator),this.trigger("nodeDragging",m),m.dropIndicator&&t.addClass([r],m.dropIndicator)},o.prototype.appendIndicator=function(e,i,s){t.addClass([i],si);var n=this.createElement("div",{className:ti});e.insertBefore(n,e.children[s])},o.prototype.dropAction=function(e){var i,s,n,l=e.event.offsetY,o=e.target,d=!1;n=e.dragData.draggable;for(var h=0;h<n.ej2_instances.length;h++)if(n.ej2_instances[h]instanceof a){i=n.ej2_instances[h];break}if(i&&i.dragTarget){var c=i.dragTarget,p=t.closest(c,"."+_t),u=t.closest(o,"."+_t);if(null==u&&o.classList.contains(Ft)&&(u=o.firstElementChild),t.detach(e.droppedElement),document.body.style.cursor="",!u||u.isSameNode(p)||this.isDescendant(p,u))return void(this.fields.dataSource instanceof r.DataManager==!1&&(this.preventExpand=!1));if(i.allowMultiSelection&&p.classList.contains(Xt)){var f=t.selectAll("."+Xt,i.element);if(e.target.offsetHeight<=33&&l>e.target.offsetHeight-10&&l>6)for(h=f.length-1;h>=0;h--)u.isSameNode(f[h])||this.isDescendant(f[h],u)||this.appendNode(o,f[h],u,e,i,l);else for(h=0;h<f.length;h++)u.isSameNode(f[h])||this.isDescendant(f[h],u)||this.appendNode(o,f[h],u,e,i,l)}else this.appendNode(o,p,u,e,i,l);s=parseInt(p.getAttribute("aria-level"),10),d=!0}this.fields.dataSource instanceof r.DataManager==!1&&(this.preventExpand=!1),this.trigger("nodeDropped",this.getDragEvent(e.event,i,o,e.target,e.dragData.draggedElement,null,s,d)),i.element.id!==this.element.id&&i.triggerEvent(),this.triggerEvent()},o.prototype.appendNode=function(e,i,s,n,r,l){var o=t.closest(e,"."+ci),a=t.closest(n.target,"."+Wt),d=t.closest(n.target,"."+Vt);i.classList.contains("e-disable")||o||!(d&&n.event.offsetY<5||a&&n.event.offsetX<3||d&&n.event.offsetY>19||a&&n.event.offsetX>19||!d&&!a)?this.dropAsChildNode(i,s,r,null,n,l,!0):"LI"===e.nodeName?this.dropAsSiblingNode(i,s,n,r):e.firstElementChild&&e.classList.contains(Ft)?"UL"===e.firstElementChild.nodeName&&this.dropAsSiblingNode(i,s,n,r):e.classList.contains("e-icon-collapsible")||e.classList.contains("e-icon-expandable")?this.dropAsSiblingNode(i,s,n,r):this.dropAsChildNode(i,s,r,null,n,l)},o.prototype.dropAsSiblingNode=function(e,i,s,n){var r,l=t.closest(i,"."+Kt),o=t.closest(e,"."+Kt),a=t.closest(o,"."+_t);if(s.target.offsetHeight>0&&s.event.offsetY>s.target.offsetHeight-2?r=!1:s.event.offsetY<2?r=!0:(s.target.classList.contains("e-icon-expandable")||s.target.classList.contains("e-icon-collapsible"))&&(s.event.offsetY<5||s.event.offsetX<3?r=!0:(s.event.offsetY>15||s.event.offsetX>17)&&(r=!1)),s.target.classList.contains("e-icon-expandable")||s.target.classList.contains("e-icon-collapsible")){var d=s.target.closest("li");l.insertBefore(e,r?d:d.nextElementSibling)}else l.insertBefore(e,r?s.target:s.target.nextElementSibling);this.moveData(e,i,l,r,n),this.updateElement(o,a),this.updateAriaLevel(e),n.element.id===this.element.id?this.updateList():(n.updateInstance(),this.updateInstance())},o.prototype.dropAsChildNode=function(e,i,s,n,r,l,o){var a,d=t.closest(e,"."+Kt),h=t.closest(d,"."+_t),c=t.closest(i,"."+Kt);if(r&&r.target&&(a=t.select(this.fullRowSelect?"."+ri:"."+Zt,i)),r&&l<7&&!o)c.insertBefore(e,i),this.moveData(e,i,c,!0,s);else if(r&&r.target.offsetHeight>0&&l>r.target.offsetHeight-10&&!o&&!this.hasTemplate)c.insertBefore(e,i.nextElementSibling),this.moveData(e,i,c,!1,s);else if(this.hasTemplate&&a&&l>a.offsetHeight-10&&!o)c.insertBefore(e,i.nextElementSibling),this.moveData(e,i,c,!1,s);else{var p=this.expandParent(i),u=p.childNodes[n];p.insertBefore(e,u),this.moveData(e,u,p,!0,s)}this.updateElement(d,h),this.updateAriaLevel(e),s.element.id===this.element.id?this.updateList():(s.updateInstance(),this.updateInstance())},o.prototype.moveData=function(e,i,s,n,r){var l=t.closest(s,"."+_t),o=this.getId(e),a=r.updateChildField(r.treeData,r.fields,o,null,null,!0),d=this.getId(i),h=this.getDataPos(this.treeData,this.fields,d),c=this.getId(l);if(1===this.dataType){this.updateField(this.treeData,this.fields,c,"hasChildren",!0);var p=t.isNullOrUndefined(h)?this.treeData.length:n?h:h+1;if(t.isNullOrUndefined(c)&&!this.hasPid)delete a[0][this.fields.parentID];else{var u=this.isNumberTypeId?parseFloat(c):c;t.setValue(this.fields.parentID,u,a[0])}if(this.treeData.splice(p,0,a[0]),r.element.id!==this.element.id){var f=r.removeChildNodes(o);p++;for(var m=0,v=f.length;m<v;m++)this.treeData.splice(p,0,f[m]),p++;r.groupedData=r.getGroupedData(r.treeData,r.fields.parentID)}this.groupedData=this.getGroupedData(this.treeData,this.fields.parentID)}else this.addChildData(this.treeData,this.fields,c,a,n?h:h+1)},o.prototype.expandParent=function(e){var s=t.select("div."+Jt,e);s&&s.classList.contains(Vt)&&!0!==this.preventExpand&&this.expandAction(e,s,null);var n=t.select("."+Kt,e);if(!0===this.preventExpand&&!n&&s&&this.renderChildNodes(e),n=t.select("."+Kt,e),t.isNullOrUndefined(n)||!0!==this.preventExpand||(n.style.display="none"),t.isNullOrUndefined(n)||!1!==this.preventExpand||(n.style.display="block"),t.isNullOrUndefined(n)&&!0===this.preventExpand){t.isNullOrUndefined(s)&&i.ListBase.generateIcon(this.createElement,e,Vt,this.listBaseOption);(r=t.select("div."+Jt,e))&&r.classList.add("e-icon-expandable"),n=i.ListBase.generateUL(this.createElement,[],null,this.listBaseOption),e.appendChild(n),r?t.removeClass([r],Wt):i.ListBase.generateIcon(this.createElement,e,Vt,this.listBaseOption),e.setAttribute("aria-expanded","false"),n.style.display="none"}if(t.isNullOrUndefined(n)){this.trigger("nodeExpanding",this.getExpandEvent(e,null)),t.isNullOrUndefined(s)&&i.ListBase.generateIcon(this.createElement,e,Wt,this.listBaseOption);var r;(r=t.select("div."+Jt,e))?t.removeClass([r],Vt):(i.ListBase.generateIcon(this.createElement,e,Wt,this.listBaseOption),r=t.select("div."+Jt,e),t.removeClass([r],Vt)),n=i.ListBase.generateUL(this.createElement,[],null,this.listBaseOption),e.appendChild(n),this.addExpand(e),this.trigger("nodeExpanded",this.getExpandEvent(e,null))}return n},o.prototype.updateElement=function(e,i){if(i&&0===e.childElementCount){var s=t.select("div."+Jt,i);t.detach(e),t.detach(s);var n=this.getId(i);this.updateField(this.treeData,this.fields,n,"hasChildren",!1),this.removeExpand(i,!0)}},o.prototype.updateAriaLevel=function(e){var i=this.parents(e,"."+Kt).length;e.setAttribute("aria-level",""+i),this.updateChildAriaLevel(t.select("."+Kt,e),i+1)},o.prototype.updateChildAriaLevel=function(e,i){if(!t.isNullOrUndefined(e))for(var s=e.childNodes,n=0,r=s.length;n<r;n++){var l=s[n];l.setAttribute("aria-level",""+i),this.updateChildAriaLevel(t.select("."+Kt,l),i+1)}},o.prototype.renderVirtualEle=function(e){var t;e.event.offsetY>e.target.offsetHeight-2?t=!1:e.event.offsetY<2&&(t=!0);var i=this.createElement("div",{className:ti}),s=this.fullRowSelect?t?1:2:t?0:1;e.target.insertBefore(i,e.target.children[s])},o.prototype.removeVirtualEle=function(){var e=t.select("."+ti);e&&t.detach(e)},o.prototype.destroyDrag=function(){this.dragObj&&this.dropObj&&(this.dragObj.destroy(),this.dropObj.destroy())},o.prototype.getDragEvent=function(e,i,s,n,l,o,a,d){var h=s?t.closest(s,"."+_t):null,c=h?this.getNodeData(h):null,p=i?i.dragLi:l,u=i?i.dragData:null,f=s?this.parents(s,"."+_t):null,m=i.dragLi.parentElement,v=i.dragLi?t.closest(m,"."+_t):null,g=null,y=null,b=[si,ii,ni,"e-no-drop"],C=null,E=!0===d?p:h,N=E?t.closest(E,".e-list-parent"):null,x=0,O=null;if(v=i.dragLi&&null===v?t.closest(m,"."+Ft):v,v=!0===d?this.dragParent:v,o)for(;x<4;){if(t.select("."+Jt,o).classList.contains(b[x])){C=b[x];break}x++}if(N){var I=0;for(x=0;x<N.childElementCount;x++){if(I=!0!==d&&N.children[x]===p&&h!==p?++I:I,!0!==d&&N.children[x].classList.contains("e-hover")){y=e.offsetY>=23?x+1:x;break}if(N.children[x]===E){e.offsetY,y=x;break}}y=0!==I?--y:y,O="e-drop-in"==C?"Inside":e.offsetY<7?"Before":"After"}if(s&&(g=0===f.length?null:s.classList.contains(_t)?f[0]:f[1]),h===p&&(g=h),s&&n.offsetHeight<=33&&e.offsetY<n.offsetHeight-10&&e.offsetY>6&&(g=h,!0!==d)){a=++a;var S=g?t.select(".e-list-parent",g):null;if(y=S?S.children.length:0,!(this.fields.dataSource instanceof r.DataManager)&&null===S&&g){var w=g.hasAttribute("data-uid")?this.getChildNodes(this.fields.dataSource,g.getAttribute("data-uid").toString()):null;y=w?w.length:0}}return{cancel:!1,clonedNode:o,event:e,draggedNode:p,draggedNodeData:u,droppedNode:h,droppedNodeData:c,dropIndex:y,dropLevel:a,draggedParentNode:v,dropTarget:g,dropIndicator:C,target:n,position:O}},o.prototype.addFullRow=function(e){var i=this.liList.length;if(e)for(var s=0;s<i;s++)this.createFullRow(this.liList[s]);else for(s=0;s<i;s++){var n=t.select("."+ri,this.liList[s]);t.detach(n)}},o.prototype.createFullRow=function(e){var t=this.createElement("div",{className:ri});e.insertBefore(t,e.childNodes[0])},o.prototype.addMultiSelect=function(e){if(e)for(var i=0,s=t.selectAll("."+_t+':not([aria-selected="true"])',this.element);i<s.length;i++){s[i].setAttribute("aria-selected","false")}else for(var n=0,r=t.selectAll("."+_t+'[aria-selected="false"]',this.element);n<r.length;n++){r[n].removeAttribute("aria-selected")}},o.prototype.collapseByLevel=function(e,i,s){if(i>0&&!t.isNullOrUndefined(e))for(var n=this.getVisibleNodes(s,e.childNodes),r=0,l=n.length;r<l;r++){var o=n[r],a=t.select("."+Wt,t.select("."+Zt,o));t.isNullOrUndefined(a)||this.collapseNode(o,a,null),this.collapseByLevel(t.select("."+Kt,o),i-1,s)}},o.prototype.collapseAllNodes=function(e){for(var i=this.getVisibleNodes(e,t.selectAll("."+Wt,this.element)),s=0,n=i.length;s<n;s++){var r=i[s],l=t.closest(r,"."+_t);this.collapseNode(l,r,null)}},o.prototype.expandByLevel=function(e,i,s){if(i>0&&!t.isNullOrUndefined(e))for(var n=this.getVisibleNodes(s,e.childNodes),r=0,l=n.length;r<l;r++){var o=n[r],a=t.select("."+Vt,t.select("."+Zt,o));t.isNullOrUndefined(a)||this.expandAction(o,a,null),this.expandByLevel(t.select("."+Kt,o),i-1,s)}},o.prototype.expandAllNodes=function(e){for(var i=this.getVisibleNodes(e,t.selectAll("."+Vt,this.element)),s=0,n=i.length;s<n;s++){var r=i[s],l=t.closest(r,"."+_t);this.expandAction(l,r,null,!0)}},o.prototype.getVisibleNodes=function(e,i){var s=Array.prototype.slice.call(i);if(e)for(var n=0;n<s.length;n++)t.isVisible(s[n])||(s.splice(n,1),n--);return s},o.prototype.removeNode=function(e){var i=t.closest(e,"."+Kt),s=t.closest(i,"."+_t);t.isNullOrUndefined(this.nodeTemplateFn)||this.destroyTemplate(e),t.detach(e),this.updateElement(i,s),this.removeData(e)},o.prototype.updateInstance=function(){this.updateList(),this.updateSelectedNodes(),this.updateExpandedNodes()},o.prototype.updateList=function(){this.liList=Array.prototype.slice.call(t.selectAll("."+_t,this.element))},o.prototype.updateSelectedNodes=function(){this.setProperties({selectedNodes:[]},!0);var e=t.selectAll("."+Xt,this.element);this.selectGivenNodes(e)},o.prototype.updateExpandedNodes=function(){this.setProperties({expandedNodes:[]},!0);for(var e=t.selectAll('[aria-expanded="true"]',this.element),i=0,s=e.length;i<s;i++)this.addExpand(e[i])},o.prototype.removeData=function(e){if(1===this.dataType){var t=new r.DataManager(this.treeData),i=this.getId(e),s={},n=this.isNumberTypeId?parseFloat(i):i;s[this.fields.id]=n,t.remove(this.fields.id,s),this.removeChildNodes(i)}else{i=this.getId(e);this.updateChildField(this.treeData,this.fields,i,null,null,!0)}},o.prototype.removeChildNodes=function(e){var i=this.getChildGroup(this.groupedData,e,!1),s=[];if(i)for(var n=0,l=i.length;n<l;n++){var o=new r.DataManager(this.treeData),a=t.getValue(this.fields.id,i[n]).toString(),d={},h=this.isNumberTypeId?parseFloat(a):a;d[this.fields.id]=h;var c=o.remove(this.fields.id,d);s.push(c[0]),this.removeChildNodes(a)}return s},o.prototype.doGivenAction=function(e,i,s){for(var n=0,r=e.length;n<r;n++){var l=this.getElement(e[n]);if(!t.isNullOrUndefined(l)){var o=t.select("."+i,t.select("."+Zt,l));t.isNullOrUndefined(o)||(s?this.expandAction(l,o,null):this.collapseNode(l,o,null))}}},o.prototype.addGivenNodes=function(e,s,n,r,l){if(0!==e.length){var o=this.getSortedData(e),a=s?parseFloat(s.getAttribute("aria-level"))+1:1;r&&this.updateMapper(a);for(var d,h=i.ListBase.createListItemFromJson(this.createElement,o,this.listBaseOption,a),c=(d=l||(s?this.expandParent(s):t.select("."+Kt,this.element))).childNodes[n],p=0;p<h.length;p++)d.insertBefore(h[p],c);var u=this.getId(s);if(1===this.dataType){this.updateField(this.treeData,this.fields,u,"hasChildren",!0);for(var f=this.getId(c),m=t.isNullOrUndefined(f)?this.treeData.length:this.getDataPos(this.treeData,this.fields,f),v=0;v<e.length;v++){if(!t.isNullOrUndefined(u)){var g=this.isNumberTypeId?parseFloat(u):u;t.setValue(this.fields.parentID,g,e[v])}this.treeData.splice(m,0,e[v]),m++}}else this.addChildData(this.treeData,this.fields,u,e,n);this.finalizeNode(d)}},o.prototype.updateMapper=function(e){var t=1===e?this.fields:this.getChildFields(this.fields,e-1,1);this.updateListProp(t)},o.prototype.updateListProp=function(e){var t=this.getActualProperties(e);this.listBaseOption.fields=t,this.listBaseOption.fields.url=t.hasOwnProperty("navigateUrl")?t.navigateUrl:"navigateUrl"},o.prototype.getDataPos=function(e,i,s){for(var n=null,l=0,o=e.length;l<o;l++){var a=t.getValue(i.id,e[l]);if(e[l]&&a&&a.toString()===s)return l;if("string"!=typeof i.child||t.isNullOrUndefined(t.getValue(i.child,e[l]))){if(this.fields.dataSource instanceof r.DataManager&&!t.isNullOrUndefined(t.getValue("child",e[l]))){var d=t.getValue("child",e[l]);if(null!==(n=this.getDataPos(d,this.getChildMapper(i),s)))break}}else{var h=t.getValue(i.child,e[l]);if(null!==(n=this.getDataPos(h,this.getChildMapper(i),s)))break}}return n},o.prototype.addChildData=function(e,i,s,n,l){var o;if(t.isNullOrUndefined(s)){l=t.isNullOrUndefined(l)?e.length:l;for(var a=0,d=n.length;a<d;a++)e.splice(l,0,n[a]),l++;return o}for(var h=0,c=e.length;h<c;h++){var p=t.getValue(i.id,e[h]);if(e[h]&&p&&p.toString()===s){if("string"==typeof i.child&&e[h].hasOwnProperty(i.child)&&null!==e[h][i.child]||this.fields.dataSource instanceof r.DataManager&&e[h].hasOwnProperty("child")){var u="string"==typeof i.child?i.child:"child",f=t.getValue(u,e[h]);t.isNullOrUndefined(f)&&(f=[]),l=t.isNullOrUndefined(l)?f.length:l;for(a=0,d=n.length;a<d;a++)f.splice(l,0,n[a]),l++}else{u="string"==typeof i.child?i.child:"child";e[h][u]=n}return!0}if("string"!=typeof i.child||t.isNullOrUndefined(t.getValue(i.child,e[h]))){if(this.fields.dataSource instanceof r.DataManager&&!t.isNullOrUndefined(t.getValue("child",e[h]))){f=t.getValue("child",e[h]);if(void 0!==(o=this.addChildData(f,this.getChildMapper(i),s,n,l)))break}}else{var m=t.getValue(i.child,e[h]);if(void 0!==(o=this.addChildData(m,this.getChildMapper(i),s,n,l)))break}}return o},o.prototype.doDisableAction=function(e){var i=this.nodeType(e),s=this.checkValidId(i);this.validArr=[];for(var n=0,r=s.length;n<r;n++){var l=s[n][this.fields.id].toString();l&&-1===this.disableNode.indexOf(l)&&this.disableNode.push(l);var o=this.getElement(l);o&&(o.setAttribute("aria-disabled","true"),t.addClass([o],"e-disable"))}},o.prototype.doEnableAction=function(e){for(var i=this.nodeType(e),s=0,n=i.length;s<n;s++){var r=this.getElement(i[s]),l=i[s];l&&-1!==this.disableNode.indexOf(l)&&this.disableNode.splice(this.disableNode.indexOf(l),1),r&&(r.removeAttribute("aria-disabled"),t.removeClass([r],"e-disable"))}},o.prototype.nodeType=function(e){for(var t=[],i=0,s=e.length;i<s;i++){var n=void 0;"string"==typeof e[i]?n=e[i]?e[i].toString():null:"object"==typeof e[i]&&(n=e[i]?e[i].getAttribute("data-uid").toString():null),-1==t.indexOf(n)&&t.push(n)}return t},o.prototype.checkValidId=function(e){var i=this;if(1===this.dataType)this.validArr=this.treeData.filter(function(t){return-1!==e.indexOf(t[i.fields.id]?t[i.fields.id].toString():null)});else if(2===this.dataType)for(var s=0;s<this.treeData.length;s++){var n=this.treeData[s][this.fields.id]?this.treeData[s][this.fields.id].toString():null;-1!==e.indexOf(n)&&this.validArr.push(this.treeData[s]);var r=t.getValue(this.fields.child.toString(),this.treeData[s]);r&&this.filterNestedChild(r,e)}return this.validArr},o.prototype.filterNestedChild=function(e,i){for(var s=0;s<e.length;s++){var n=e[s][this.fields.id]?e[s][this.fields.id].toString():null;-1!==i.indexOf(n)&&this.validArr.push(e[s]);var r=t.getValue(this.fields.child.toString(),e[s]);r&&this.filterNestedChild(r,i)}},o.prototype.setTouchClass=function(){var e=t.closest(this.element,".e-bigger");this.touchClass=t.isNullOrUndefined(e)?"":"e-small"},o.prototype.updatePersistProp=function(){this.removeField(this.treeData,this.fields,["selected","expanded"]);for(var e=this.selectedNodes,t=0,i=e.length;t<i;t++)this.updateField(this.treeData,this.fields,e[t],"selected",!0);for(var s=this.expandedNodes,n=0,r=s.length;n<r;n++)this.updateField(this.treeData,this.fields,s[n],"expanded",!0);if(this.showCheckBox){this.removeField(this.treeData,this.fields,["isChecked"]);var l=this.checkedNodes,o=0;for(r=l.length;o<r;o++)this.updateField(this.treeData,this.fields,l[o],"isChecked",!0)}},o.prototype.removeField=function(e,i,s){if(!t.isNullOrUndefined(e)&&!t.isNullOrUndefined(i))for(var n=0,l=e.length;n<l;n++){for(var o=0;o<s.length;o++){var a=this.getMapperProp(i,s[o]);t.isNullOrUndefined(e[n][a])||delete e[n][a]}"string"!=typeof i.child||t.isNullOrUndefined(t.getValue(i.child,e[n]))?this.fields.dataSource instanceof r.DataManager&&!t.isNullOrUndefined(t.getValue("child",e[n]))&&this.removeField(t.getValue("child",e[n]),this.getChildMapper(i),s):this.removeField(t.getValue(i.child,e[n]),this.getChildMapper(i),s)}},o.prototype.getMapperProp=function(e,i){switch(i){case"selected":return t.isNullOrUndefined(e.selected)?"selected":e.selected;case"expanded":return t.isNullOrUndefined(e.expanded)?"expanded":e.expanded;case"isChecked":return t.isNullOrUndefined(e.isChecked)?"isChecked":e.isChecked;case"hasChildren":return t.isNullOrUndefined(e.hasChildren)?"hasChildren":e.hasChildren;default:return i}},o.prototype.updateField=function(e,i,s,n,l){if(!t.isNullOrUndefined(s))if(1===this.dataType){var o=this.isNumberTypeId?parseFloat(s):s,a=new r.DataManager(this.treeData).executeLocal((new r.Query).where(i.id,"equal",o,!1));t.setValue(this.getMapperProp(i,n),l,a[0])}else this.updateChildField(e,i,s,n,l)},o.prototype.updateChildField=function(e,i,s,n,l,o){var a;if(t.isNullOrUndefined(e))return a;for(var d=0,h=e.length;d<h;d++){var c=t.getValue(i.id,e[d]);if(e[d]&&c&&c.toString()===s)return o?a=e.splice(d,1):(t.setValue(this.getMapperProp(i,n),l,e[d]),a=[]),a;if("string"!=typeof i.child||t.isNullOrUndefined(t.getValue(i.child,e[d]))){if(this.fields.dataSource instanceof r.DataManager&&!t.isNullOrUndefined(t.getValue("child",e[d]))){var p=t.getValue("child",e[d]);if(void 0!==(a=this.updateChildField(p,this.getChildMapper(i),s,n,l,o)))break}}else{var u=t.getValue(i.child,e[d]);if(void 0!==(a=this.updateChildField(u,this.getChildMapper(i),s,n,l,o)))break}}return a},o.prototype.triggerEvent=function(){this.renderReactTemplates();var e={data:this.treeData};this.trigger("dataSourceChanged",e)},o.prototype.wireInputEvents=function(e){t.EventHandler.add(e,"blur",this.inputFocusOut,this)},o.prototype.wireEditingEvents=function(e){var i=this;if(e&&!this.disabled){var s=this;this.touchEditObj=new t.Touch(this.element,{tap:function(e){i.isDoubleTapped(e)&&2===e.tapCount&&(e.originalEvent.preventDefault(),s.editingHandler(e.originalEvent))}})}else this.touchEditObj&&this.touchEditObj.destroy()},o.prototype.wireClickEvent=function(e){if(e){var i=this;this.touchClickObj=new t.Touch(this.element,{tap:function(e){i.clickHandler(e)}})}else this.touchClickObj&&this.touchClickObj.destroy()},o.prototype.wireExpandOnEvent=function(e){var i=this;if(e){var s=this;this.touchExpandObj=new t.Touch(this.element,{tap:function(e){("Click"===i.expandOnType||"DblClick"===i.expandOnType&&i.isDoubleTapped(e)&&2===e.tapCount)&&3!==e.originalEvent.which&&s.expandHandler(e)}})}else this.touchExpandObj&&this.touchExpandObj.destroy()},o.prototype.mouseDownHandler=function(e){this.mouseDownStatus=!0,(e.shiftKey||e.ctrlKey)&&e.preventDefault(),e.ctrlKey&&this.allowMultiSelection&&t.EventHandler.add(this.element,"contextmenu",this.preventContextMenu,this)},o.prototype.preventContextMenu=function(e){e.preventDefault()},o.prototype.wireEvents=function(){t.EventHandler.add(this.element,"mousedown",this.mouseDownHandler,this),this.wireClickEvent(!0),"None"!==this.expandOnType&&this.wireExpandOnEvent(!0),t.EventHandler.add(this.element,"focus",this.focusIn,this),t.EventHandler.add(this.element,"blur",this.focusOut,this),t.EventHandler.add(this.element,"mouseover",this.onMouseOver,this),t.EventHandler.add(this.element,"mouseout",this.onMouseLeave,this),this.keyboardModule=new t.KeyboardEvents(this.element,{keyAction:this.keyActionHandler.bind(this),keyConfigs:this.keyConfigs,eventName:"keydown"})},o.prototype.unWireEvents=function(){t.EventHandler.remove(this.element,"mousedown",this.mouseDownHandler),this.wireClickEvent(!1),this.wireExpandOnEvent(!1),t.EventHandler.remove(this.element,"focus",this.focusIn),t.EventHandler.remove(this.element,"blur",this.focusOut),t.EventHandler.remove(this.element,"mouseover",this.onMouseOver),t.EventHandler.remove(this.element,"mouseout",this.onMouseLeave),this.disabled||this.keyboardModule.destroy()},o.prototype.parents=function(e,i){for(var s=[],n=e.parentNode;!t.isNullOrUndefined(n);)t.matches(n,i)&&s.push(n),n=n.parentNode;return s},o.prototype.isDoubleTapped=function(e){var i,s=e.originalEvent.target;return s&&e.tapCount&&(1===e.tapCount?this.firstTap=t.closest(s,"."+_t):2===e.tapCount&&(i=t.closest(s,"."+_t))),this.firstTap===i},o.prototype.isDescendant=function(e,i){for(var s=i.parentNode;!t.isNullOrUndefined(s);){if(s===e)return!0;s=s.parentNode}return!1},o.prototype.showSpinner=function(e){t.addClass([e],Gt),s.createSpinner({target:e,width:t.Browser.isDevice?16:14},this.createElement),s.showSpinner(e)},o.prototype.hideSpinner=function(e){s.hideSpinner(e),e.innerHTML="",t.removeClass([e],Gt)},o.prototype.setCheckedNodes=function(e){e=JSON.parse(JSON.stringify(e)),this.uncheckAll(this.checkedNodes),this.setIndeterminate(e),e.length>0&&this.checkAll(e)},o.prototype.setValidCheckedNode=function(e){if(1===this.dataType){var i=this.fields,s=new r.DataManager(this.treeData).executeLocal((new r.Query).where(i.id,"equal",e,!0));if(s[0]&&(this.setChildCheckState(s,e,s[0]),this.autoCheck)){for(var n=s[0][this.fields.parentID]?s[0][this.fields.parentID].toString():null,l=this.getChildNodes(this.treeData,n),o=0,a=0;a<l.length;a++){var d=l[a][this.fields.id].toString();-1!==this.checkedNodes.indexOf(d)&&o++}o===l.length&&-1===this.checkedNodes.indexOf(n)&&n&&this.checkedNodes.push(n)}}else if(2===this.dataType)for(var h=0;h<this.treeData.length;h++){if((this.treeData[h][this.fields.id]?this.treeData[h][this.fields.id].toString():"")===e&&-1===this.checkedNodes.indexOf(e)){this.checkedNodes.push(e);break}var c=t.getValue(this.fields.child.toString(),this.treeData[h]);c&&this.setChildCheckState(c,e,this.treeData[h])}},o.prototype.setChildCheckState=function(e,i,s){var n,r=0;if(1===this.dataType){s&&(n=s[this.fields.id]?s[this.fields.id].toString():null);for(var l=0;l<e.length;l++){var o=e[l][this.fields.id]?e[l][this.fields.id].toString():null;s&&n&&this.autoCheck&&-1!==this.checkedNodes.indexOf(n)&&-1===this.checkedNodes.indexOf(o)&&this.checkedNodes.push(o),o===i&&-1===this.checkedNodes.indexOf(i)&&this.checkedNodes.push(i);(d=this.getChildNodes(this.treeData,o))&&this.setChildCheckState(d,i,s)}}else{s&&(n=s[this.fields.id]?s[this.fields.id].toString():"");for(l=0;l<e.length;l++){var a=e[l][this.fields.id]?e[l][this.fields.id].toString():"";s&&n&&this.autoCheck&&-1!==this.checkedNodes.indexOf(n)&&-1===this.checkedNodes.indexOf(a)&&this.checkedNodes.push(a),a===i&&-1===this.checkedNodes.indexOf(i)&&this.checkedNodes.push(i);var d;(d=t.getValue(this.fields.child.toString(),e[l]))&&this.setChildCheckState(d,i,e[l]),-1!==this.checkedNodes.indexOf(a)&&this.autoCheck&&r++,r===e.length&&-1===this.checkedNodes.indexOf(n)&&this.autoCheck&&this.checkedNodes.push(n)}}},o.prototype.setIndeterminate=function(e){for(var t=0;t<e.length;t++)this.setValidCheckedNode(e[t])},o.prototype.updatePosition=function(e,t,i,s){if(1===this.dataType){var n=this.getDataPos(this.treeData,this.fields,e);if(this.treeData.splice(n,1,t),i){this.removeChildNodes(e);for(var r=0;r<s.length;r++)this.treeData.splice(n,0,s[r]),n++}this.groupedData=this.getGroupedData(this.treeData,this.fields.parentID)}else this.updateChildPosition(this.treeData,this.fields,e,[t],void 0)},o.prototype.updateChildPosition=function(e,i,s,n,l){for(var o,a=0,d=e.length;a<d;a++){var h=t.getValue(i.id,e[a]);if(e[a]&&h&&h.toString()===s)return e[a]=n[0],!0;if("string"!=typeof i.child||t.isNullOrUndefined(t.getValue(i.child,e[a]))){if(this.fields.dataSource instanceof r.DataManager&&!t.isNullOrUndefined(t.getValue("child",e[a]))){var c=t.getValue("child",e[a]);if(void 0!==(o=this.updateChildPosition(c,this.getChildMapper(i),s,n,l)))break}}else{var p=t.getValue(i.child,e[a]);if(void 0!==(o=this.updateChildPosition(p,this.getChildMapper(i),s,n,l)))break}}return o},o.prototype.dynamicState=function(){this.setDragAndDrop(this.allowDragAndDrop),this.wireEditingEvents(this.allowEditing),this.disabled?(this.unWireEvents(),this.rippleFn(),this.rippleIconFn()):(this.wireEvents(),this.setRipple())},o.prototype.crudOperation=function(e,i,s,n,r,l,o){var a,d=this,h=this.fields.dataSource,c=[],p=this.getQuery(this.fields),u=this.fields.id,f={addedRecords:[],deletedRecords:[],changedRecords:[]},m=[];i?m=this.nodeType(i):s&&("string"==typeof s?m[0]=s.toString():"object"==typeof s&&(m[0]=s.getAttribute("data-uid").toString()));for(var v=0,g=m.length;v<g;v++){var y=this.getElement(m[v]);if(!t.isNullOrUndefined(y)){var b=this.getNodeObject(m[v]);c.push(b)}}switch(e){case"delete":1==i.length?a=h.remove(u,c[0],p.fromTable,p):(f.deletedRecords=c,a=h.saveChanges(f,u,p.fromTable,p)),a.then(function(e){return d.deleteSuccess(m)}).catch(function(e){return d.dmFailure(e)});break;case"update":c[0][this.fields.text]=n,(a=h.update(u,c[0],p.fromTable,p)).then(function(e){return d.editSucess(s,n,o)}).catch(function(e){return d.dmFailure(e,s,o)});break;case"insert":if(1==r.length)a=h.insert(r[0],p.fromTable,p);else{var C=[];for(v=0,g=r.length;v<g;v++)C.push(r[v]);f.addedRecords=C,a=h.saveChanges(f,u,p.fromTable,p)}a.then(function(e){var t=d.getElement(s);d.addSuccess(r,t,l),d.preventExpand=!1}).catch(function(e){return d.dmFailure(e)})}},o.prototype.deleteSuccess=function(e){for(var i=0,s=e.length;i<s;i++){var n=this.getElement(e[i]);t.isNullOrUndefined(n)||this.removeNode(n)}this.updateInstance(),1===this.dataType&&(this.groupedData=this.getGroupedData(this.treeData,this.fields.parentID)),this.triggerEvent()},o.prototype.editSucess=function(e,i,s){var n=this.getElement(e),r=t.select("."+zt,n);this.appendNewText(n,r,i,s)},o.prototype.addSuccess=function(e,t,i){var s,n=t?t.querySelector("."+Jt):null,r=this;t&&n&&n.classList.contains(Vt)&&null===t.querySelector("."+Kt)?r.renderChildNodes(t,null,function(){s=t.querySelector("."+Kt),r.addGivenNodes(e,t,i,!0,s),r.triggerEvent()}):(this.addGivenNodes(e,t,i,!0),this.triggerEvent())},o.prototype.dmFailure=function(e,t,i){t&&this.updatePreviousText(t,i),this.trigger("actionFailure",{error:e})},o.prototype.updatePreviousText=function(e,i){var s=this.getElement(e),n=t.select("."+zt,s);this.updateText(s,n,this.oldText,i)},o.prototype.onPropertyChanged=function(e,i){for(var s=0,n=Object.keys(e);s<n.length;s++){switch(n[s]){case"allowDragAndDrop":this.setDragAndDrop(this.allowDragAndDrop);break;case"dragArea":this.allowDragAndDrop&&(this.dragObj.dragArea=this.dragArea);break;case"allowEditing":this.wireEditingEvents(this.allowEditing);break;case"allowMultiSelection":if(this.selectedNodes.length>1){var r=this.getElement(this.selectedNodes[0]);this.isLoaded=!1,this.removeSelectAll(),this.selectNode(r,null),this.isLoaded=!0}this.setMultiSelect(this.allowMultiSelection),this.addMultiSelect(this.allowMultiSelection);break;case"allowTextWrap":this.setTextWrap(),this.updateWrap();break;case"checkedNodes":this.showCheckBox&&(this.checkedNodes=i.checkedNodes,this.setCheckedNodes(e.checkedNodes));break;case"autoCheck":this.showCheckBox&&(this.autoCheck=e.autoCheck,this.ensureIndeterminate());break;case"cssClass":this.setCssClass(i.cssClass,e.cssClass);break;case"enableRtl":this.setEnableRtl();break;case"expandedNodes":this.isAnimate=!1,this.setProperties({expandedNodes:[]},!0),this.collapseAll(),this.isInitalExpand=!0,this.setProperties({expandedNodes:t.isNullOrUndefined(e.expandedNodes)?[]:e.expandedNodes},!0),this.doExpandAction(),this.isInitalExpand=!1,this.isAnimate=!0;break;case"expandOn":this.wireExpandOnEvent(!1),this.setExpandOnType(),"None"===this.expandOnType||this.disabled||this.wireExpandOnEvent(!0);break;case"disabled":this.setDisabledMode(),this.dynamicState();break;case"fields":this.isAnimate=!1,this.isFieldChange=!0,this.initialRender=!0,this.reRenderNodes(),this.initialRender=!1,this.isAnimate=!0,this.isFieldChange=!1;break;case"fullRowSelect":this.setFullRow(this.fullRowSelect),this.addFullRow(this.fullRowSelect),this.allowTextWrap&&(this.setTextWrap(),this.updateWrap());break;case"loadOnDemand":if(!1===this.loadOnDemand&&!this.onLoaded){for(var l=this.element.querySelectorAll("li"),o=0;o<l.length;)"true"!==l[o].getAttribute("aria-expanded")&&this.renderChildNodes(l[o],!0,null,!0),o++;this.onLoaded=!0}break;case"nodeTemplate":this.hasTemplate=!1,this.nodeTemplateFn=this.templateComplier(this.nodeTemplate),this.reRenderNodes();break;case"selectedNodes":this.removeSelectAll(),this.setProperties({selectedNodes:e.selectedNodes},!0),this.doSelectionAction();break;case"showCheckBox":case"sortOrder":this.reRenderNodes();break;case"fullRowNavigable":this.setProperties({fullRowNavigable:e.fullRowNavigable},!0),this.listBaseOption.itemNavigable=e.fullRowNavigable,this.reRenderNodes()}}},o.prototype.destroy=function(){this.clearTemplate(),this.element.removeAttribute("aria-activedescendant"),this.element.removeAttribute("tabindex"),this.unWireEvents(),this.wireEditingEvents(!1),this.disabled||(this.rippleFn(),this.rippleIconFn()),this.setCssClass(this.cssClass,null),this.setDragAndDrop(!1),this.setFullRow(!1),this.ulElement&&this.ulElement.parentElement&&this.ulElement.parentElement.removeChild(this.ulElement),e.prototype.destroy.call(this)},o.prototype.addNodes=function(e,i,s,n){if(!t.isNullOrUndefined(e)){e=JSON.parse(JSON.stringify(e));var l=this.getElement(i);if(this.preventExpand=n,this.fields.dataSource instanceof r.DataManager)this.isOffline?this.addSuccess(e,l,s):this.crudOperation("insert",null,i,null,e,s,this.preventExpand);else if(2===this.dataType)this.addGivenNodes(e,l,s);else{if(l)this.addGivenNodes(e,l,s);else{e=this.getSortedData(e);for(var o=0;o<e.length;o++){var a=t.getValue(this.fields.parentID,e[o]);l=a?this.getElement(a.toString()):a,this.addGivenNodes([e[o]],l,s)}}this.groupedData=this.getGroupedData(this.treeData,this.fields.parentID)}this.updateCheckedStateFromDS(),this.showCheckBox&&l&&this.ensureParentCheckState(l),this.fields.dataSource instanceof r.DataManager==!1&&(this.preventExpand=!1,this.triggerEvent())}},o.prototype.beginEdit=function(e){var i=this.getElement(e);t.isNullOrUndefined(i)||this.disabled||this.createTextbox(i,null)},o.prototype.checkAll=function(e){this.showCheckBox&&this.doCheckBoxAction(e,!0)},o.prototype.collapseAll=function(e,i,s){t.isNullOrUndefined(e)?i>0?this.collapseByLevel(t.select("."+Kt,this.element),i,s):this.collapseAllNodes(s):this.doGivenAction(e,Wt,!1)},o.prototype.disableNodes=function(e){t.isNullOrUndefined(e)||this.doDisableAction(e)},o.prototype.enableNodes=function(e){t.isNullOrUndefined(e)||this.doEnableAction(e)},o.prototype.ensureVisible=function(e){var i=this.getElement(e);if(!t.isNullOrUndefined(i)){var s=this.parents(i,"."+_t);this.expandAll(s),setTimeout(function(){i.scrollIntoView(!0)},450)}},o.prototype.expandAll=function(e,i,s){t.isNullOrUndefined(e)?i>0?this.expandByLevel(t.select("."+Kt,this.element),i,s):this.expandAllNodes(s):this.doGivenAction(e,Vt,!0)},o.prototype.getAllCheckedNodes=function(){return this.checkedNodes},o.prototype.getDisabledNodes=function(){return this.disableNode},o.prototype.getNode=function(e){var t=this.getElement(e);return this.getNodeData(t,!0)},o.prototype.getTreeData=function(e){var i=this.getId(e);if(this.updatePersistProp(),t.isNullOrUndefined(i))return this.treeData;var s=this.getNodeObject(i);return t.isNullOrUndefined(s)?[]:[s]},o.prototype.moveNodes=function(e,i,s,n){var l=this.getElement(i);if(!t.isNullOrUndefined(l)){for(var o=0;o<e.length;o++){var a=this.getElement(e[o]);t.isNullOrUndefined(a)||l.isSameNode(a)||this.isDescendant(a,l)||(this.preventExpand=n,this.dropAsChildNode(a,l,this,s))}this.fields.dataSource instanceof r.DataManager==!1&&(this.preventExpand=!1),this.triggerEvent()}},o.prototype.refreshNode=function(e,s){if(!t.isNullOrUndefined(e)&&!t.isNullOrUndefined(s)){var n,r=!1;if(1==this.dataType&&s.length>1)r=!0;else if(2==this.dataType&&1===s.length){var l=t.getValue(this.fields.child.toString(),s[0]);t.isNullOrUndefined(l)||(r=!0)}var o=this.getElement(e);n=o?o.getAttribute("data-uid"):e?e.toString():null,this.refreshData=this.getNodeObject(n),s=JSON.parse(JSON.stringify(s));var a,d;if(1==this.dataType&&r){for(var h=0;h<s.length;h++)if(t.isNullOrUndefined(s[h][this.fields.parentID])){d=s[h],s.splice(h,1);break}a=t.extend({},this.refreshData,d)}else a=t.extend({},this.refreshData,s[0]);if(t.isNullOrUndefined(o))this.updatePosition(n,a,r,s);else{this.isRefreshed=!0;var c=parseFloat(o.getAttribute("aria-level")),p=i.ListBase.createListItemFromJson(this.createElement,[a],this.listBaseOption,c),u=t.select("."+Kt,o),f=t.getValue(this.fields.child.toString(),a);if(r&&u||r&&!t.isNullOrUndefined(f)){var m=o.parentElement,v=Array.prototype.indexOf.call(m.childNodes,o);t.remove(o),m.insertBefore(p[0],m.childNodes[v]),this.updatePosition(n,a,r,s),r&&u&&this.expandAll([n])}else{var g=t.select("."+Zt,o),y=t.select("."+Zt,p[0]),b=t.select("div."+Jt,g),C=t.select("div."+Jt,y);b&&C&&(C.classList.contains(Vt)&&b.classList.contains(Wt)?(t.removeClass([C],Vt),t.addClass([C],Wt)):C.classList.contains(Wt)&&b.classList.contains(Vt)?(t.removeClass([C],Wt),t.addClass([C],Vt)):b.classList.contains("interaction")&&t.addClass([C],"interaction")),t.remove(g);var E=t.select("."+ri,o);E.parentNode.insertBefore(y,E.nextSibling),this.updatePosition(n,a,r,s)}if(o=this.getElement(e),a[this.fields.tooltip]&&o.setAttribute("title",a[this.fields.tooltip]),a.hasOwnProperty(this.fields.htmlAttributes)&&a[this.fields.htmlAttributes]){var N={};t.merge(N,a[this.fields.htmlAttributes]),N.class?(t.addClass([o],N.class.split(" ")),delete N.class):t.attributes(o,N)}-1!==this.selectedNodes.indexOf(n)&&(o.setAttribute("aria-selected","true"),t.addClass([o],Xt)),this.isRefreshed=!1,this.triggerEvent()}}},o.prototype.removeNodes=function(e){t.isNullOrUndefined(e)||(this.fields.dataSource instanceof r.DataManager&&!this.isOffline?this.crudOperation("delete",e):this.deleteSuccess(e))},o.prototype.updateNode=function(e,i){var s=this;if(!t.isNullOrUndefined(e)&&!t.isNullOrUndefined(i)&&this.allowEditing){var n=this.getElement(e);if(!t.isNullOrUndefined(n)){var l=t.select("."+zt,n);this.updateOldText(n);var o=this.getEditEvent(n,null,null);this.trigger("nodeEditing",o,function(t){t.cancel||(s.fields.dataSource instanceof r.DataManager&&!s.isOffline?s.crudOperation("update",null,e,i,null,null,!1):s.appendNewText(n,l,i,!1))})}}},o.prototype.uncheckAll=function(e){this.showCheckBox&&this.doCheckBoxAction(e,!1)};var a;return qt([t.Property(!1)],o.prototype,"allowDragAndDrop",void 0),qt([t.Property(!1)],o.prototype,"allowEditing",void 0),qt([t.Property(!1)],o.prototype,"allowMultiSelection",void 0),qt([t.Property(!1)],o.prototype,"allowTextWrap",void 0),qt([t.Complex({},yi)],o.prototype,"animation",void 0),qt([t.Property()],o.prototype,"checkedNodes",void 0),qt([t.Property("")],o.prototype,"cssClass",void 0),qt([t.Property(!1)],o.prototype,"disabled",void 0),qt([t.Property(null)],o.prototype,"dragArea",void 0),qt([t.Property(!1)],o.prototype,"enableHtmlSanitizer",void 0),qt([t.Property(!1)],o.prototype,"enablePersistence",void 0),qt([t.Property()],o.prototype,"expandedNodes",void 0),qt([t.Property("Auto")],o.prototype,"expandOn",void 0),qt([t.Complex({},vi)],o.prototype,"fields",void 0),qt([t.Property(!0)],o.prototype,"fullRowSelect",void 0),qt([t.Property(!0)],o.prototype,"loadOnDemand",void 0),qt([t.Property()],o.prototype,"locale",void 0),qt([t.Property()],o.prototype,"nodeTemplate",void 0),qt([t.Property()],o.prototype,"selectedNodes",void 0),qt([t.Property("None")],o.prototype,"sortOrder",void 0),qt([t.Property(!1)],o.prototype,"showCheckBox",void 0),qt([t.Property(!0)],o.prototype,"autoCheck",void 0),qt([t.Property(!1)],o.prototype,"fullRowNavigable",void 0),qt([t.Event()],o.prototype,"actionFailure",void 0),qt([t.Event()],o.prototype,"created",void 0),qt([t.Event()],o.prototype,"dataBound",void 0),qt([t.Event()],o.prototype,"dataSourceChanged",void 0),qt([t.Event()],o.prototype,"drawNode",void 0),qt([t.Event()],o.prototype,"destroyed",void 0),qt([t.Event()],o.prototype,"keyPress",void 0),qt([t.Event()],o.prototype,"nodeChecked",void 0),qt([t.Event()],o.prototype,"nodeChecking",void 0),qt([t.Event()],o.prototype,"nodeClicked",void 0),qt([t.Event()],o.prototype,"nodeCollapsed",void 0),qt([t.Event()],o.prototype,"nodeCollapsing",void 0),qt([t.Event()],o.prototype,"nodeDragging",void 0),qt([t.Event()],o.prototype,"nodeDragStart",void 0),qt([t.Event()],o.prototype,"nodeDragStop",void 0),qt([t.Event()],o.prototype,"nodeDropped",void 0),qt([t.Event()],o.prototype,"nodeEdited",void 0),qt([t.Event()],o.prototype,"nodeEditing",void 0),qt([t.Event()],o.prototype,"nodeExpanded",void 0),qt([t.Event()],o.prototype,"nodeExpanding",void 0),qt([t.Event()],o.prototype,"nodeSelected",void 0),qt([t.Event()],o.prototype,"nodeSelecting",void 0),o=a=qt([t.NotifyPropertyChanges],o)}(t.Component),Ci=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),Ei=function(e,t,i,s){var n,r=arguments.length,l=r<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)l=Reflect.decorate(e,t,i,s);else for(var o=e.length-1;o>=0;o--)(n=e[o])&&(l=(r<3?n(l):r>3?n(t,i,l):n(t,i))||l);return r>3&&l&&Object.defineProperty(t,i,l),l},Ni="e-close",xi="e-open",Oi="e-transition",Ii="e-right",Si="e-over",wi="e-push",ki="e-visibility",Li="e-disable-animation",Ai="e-sidebar-context",Di="e-sidebar-absolute",Mi=function(e){function i(t,i){return e.call(this,t,i)||this}return Ci(i,e),i.prototype.preRender=function(){this.setWidth()},i.prototype.render=function(){this.initialize(),this.wireEvents(),this.renderComplete()},i.prototype.initialize=function(){this.setTarget(),this.addClass(),this.setZindex(),this.enableDock&&this.setDock(),this.isOpen?(this.show(),this.firstRender=!0):this.setMediaQuery(),this.checkType(!0),this.setType(this.type),this.setCloseOnDocumentClick(),this.setEnableRTL(),t.Browser.isDevice&&(this.windowWidth=window.innerWidth)},i.prototype.setEnableRTL=function(){(this.enableRtl?t.addClass:t.removeClass)([this.element],"e-rtl")},i.prototype.setTarget=function(){this.targetEle=this.element.nextElementSibling,this.sidebarEleCopy=this.element.cloneNode(!0),"string"==typeof this.target&&this.setProperties({target:document.querySelector(this.target)},!0),this.target&&(this.target.insertBefore(this.element,this.target.children[0]),t.addClass([this.element],Di),t.addClass([this.target],Ai),this.targetEle=this.getTargetElement())},i.prototype.getTargetElement=function(){for(var e=this.element.nextElementSibling;!t.isNullOrUndefined(e)&&e.classList.contains("e-sidebar");)e=e.nextElementSibling;return e},i.prototype.setCloseOnDocumentClick=function(){this.closeOnDocumentClick?t.EventHandler.add(document,"mousedown touchstart",this.documentclickHandler,this):t.EventHandler.remove(document,"mousedown touchstart",this.documentclickHandler)},i.prototype.setWidth=function(){this.enableDock&&"Left"===this.position?t.setStyleAttribute(this.element,{width:this.setDimension(this.dockSize)}):this.enableDock&&"Right"===this.position?t.setStyleAttribute(this.element,{width:this.setDimension(this.dockSize)}):this.enableDock||t.setStyleAttribute(this.element,{width:this.setDimension(this.width)})},i.prototype.setDimension=function(e){return e="number"==typeof e?t.formatUnit(e):"string"==typeof e?e.match(/px|%|em/)?e:t.formatUnit(e):"100%"},i.prototype.setZindex=function(){t.setStyleAttribute(this.element,{"z-index":""+this.zIndex})},i.prototype.addClass=function(){"EJS-SIDEBAR"===this.element.tagName&&t.addClass([this.element],"e-sidebar-display");var e=document.querySelector(".e-main-content");t.isNullOrUndefined(e||this.targetEle)||t.addClass([e||this.targetEle],["e-content-animation"]),this.tabIndex=this.element.hasAttribute("tabindex")?this.element.getAttribute("tabindex"):"0",this.enableDock||"Auto"===this.type||t.addClass([this.element],[ki]),t.removeClass([this.element],[xi,Ni,Ii,"e-left","e-slide",wi,Si]),this.element.classList.add("e-sidebar"),t.addClass([this.element],"Right"===this.position?Ii:"e-left"),this.enableDock&&t.addClass([this.element],"e-dock"),this.element.setAttribute("tabindex",this.tabIndex),"Auto"!==this.type||t.Browser.isDevice?this.isOpen||t.addClass([this.element],Ni):this.show()},i.prototype.checkType=function(e){"Push"!==this.type&&"Over"!==this.type&&"Slide"!==this.type?this.type="Auto":this.element.classList.contains(Ni)||e||this.hide()},i.prototype.transitionEnd=function(e){this.setDock(),t.isNullOrUndefined(e)||this.firstRender||this.triggerChange(),this.firstRender=!1,t.EventHandler.remove(this.element,"transitionend",this.transitionEnd)},i.prototype.destroyBackDrop=function(){var e=document.querySelector(".e-main-content")||this.targetEle;this.target&&this.showBackdrop&&e?t.removeClass([e],"e-backdrop"):this.showBackdrop&&this.modal&&(this.modal.style.display="none",this.modal.outerHTML="",this.modal=null)},i.prototype.hide=function(e){var i=this,s={model:this,element:this.element,cancel:!1,isInteracted:!t.isNullOrUndefined(e),event:e||null};this.trigger("close",s,function(e){if(!e.cancel){if(i.element.classList.contains(Ni))return;i.element.classList.contains(xi)&&!i.animate&&i.triggerChange(),t.addClass([i.element],Ni),t.removeClass([i.element],xi),t.setStyleAttribute(i.element,{width:t.formatUnit(i.enableDock?i.dockSize:i.width)}),i.setType(i.type);var s=document.querySelector(".e-main-content")||i.targetEle;!i.enableDock&&s&&(s.style.transform="translateX(0px)",s.style["Left"===i.position?"marginLeft":"marginRight"]="0px"),i.destroyBackDrop(),i.setAnimation(),"Slide"===i.type&&document.body.classList.remove("e-sidebar-overflow"),i.setProperties({isOpen:!1},!0),i.enableDock&&setTimeout(function(){return i.setTimeOut()},50),t.EventHandler.add(i.element,"transitionend",i.transitionEnd,i)}})},i.prototype.setTimeOut=function(){var e=document.querySelector(".e-main-content")||this.targetEle,t=this.element.getBoundingClientRect().width;!this.element.classList.contains(xi)||!e||"Over"===this.type&&this.enableDock?this.element.classList.contains(Ni)&&e&&("Left"===this.position?e.style.marginLeft=this.setDimension("auto"===this.dockSize?t:this.dockSize):e.style.marginRight=this.setDimension("auto"===this.dockSize?t:this.dockSize)):"Left"===this.position?e.style.marginLeft=this.setDimension("auto"===this.width?t:this.width):e.style.marginRight=this.setDimension("auto"===this.width?t:this.width)},i.prototype.show=function(e){var i=this,s={model:this,element:this.element,cancel:!1,isInteracted:!t.isNullOrUndefined(e),event:e||null};this.trigger("open",s,function(e){if(!e.cancel){if(t.removeClass([i.element],ki),i.element.classList.contains(xi))return;i.element.classList.contains(Ni)&&!i.animate&&i.triggerChange(),t.addClass([i.element],[xi,Oi]),t.setStyleAttribute(i.element,{transform:""}),t.removeClass([i.element],Ni),t.setStyleAttribute(i.element,{width:t.formatUnit(i.width)}),i.setType(i.type),i.createBackDrop(),i.setAnimation(),"Slide"===i.type&&document.body.classList.add("e-sidebar-overflow"),i.setProperties({isOpen:!0},!0),t.EventHandler.add(i.element,"transitionend",i.transitionEnd,i)}})},i.prototype.setAnimation=function(){this.animate?t.removeClass([this.element],Li):t.addClass([this.element],Li)},i.prototype.triggerChange=function(){var e={name:"change",element:this.element};this.trigger("change",e)},i.prototype.setDock=function(){this.enableDock&&"Left"===this.position&&!this.getState()?t.setStyleAttribute(this.element,{transform:"translateX(-100%) translateX("+this.setDimension(this.dockSize)+")"}):this.enableDock&&"Right"===this.position&&!this.getState()&&t.setStyleAttribute(this.element,{transform:"translateX(100%) translateX(-"+this.setDimension(this.dockSize)+")"}),this.element.classList.contains(Ni)&&this.enableDock&&t.setStyleAttribute(this.element,{width:this.setDimension(this.dockSize)})},i.prototype.createBackDrop=function(){if(this.target&&this.showBackdrop&&this.getState()){var e=document.querySelector(".e-main-content")||this.targetEle;t.addClass([e],"e-backdrop")}else this.showBackdrop&&!this.modal&&this.getState()&&(this.modal=this.createElement("div"),this.modal.className="e-sidebar-overlay",this.modal.style.display="block",document.body.appendChild(this.modal))},i.prototype.getPersistData=function(){return this.addOnPersist(["type","position","isOpen"])},i.prototype.getModuleName=function(){return"sidebar"},i.prototype.toggle=function(){this.element.classList.contains(xi)?this.hide():this.show()},i.prototype.getState=function(){return!!this.element.classList.contains(xi)},i.prototype.setMediaQuery=function(){if(this.mediaQuery){("string"==typeof this.mediaQuery?window.matchMedia(this.mediaQuery).matches:this.mediaQuery.matches)&&this.windowWidth!==window.innerWidth?this.show():this.getState()&&this.windowWidth!==window.innerWidth&&this.hide()}},i.prototype.resize=function(){"Auto"===this.type&&(t.Browser.isDevice?t.addClass([this.element],Si):t.addClass([this.element],wi)),this.setMediaQuery(),t.Browser.isDevice&&(this.windowWidth=window.innerWidth)},i.prototype.documentclickHandler=function(e){t.closest(e.target,".e-control.e-sidebar")||this.hide(e)},i.prototype.enableGestureHandler=function(e){!this.isOpen&&"Left"===this.position&&"Right"===e.swipeDirection&&e.startX<=20&&e.distanceX>=50&&e.velocity>=.5?this.show():this.isOpen&&"Left"===this.position&&"Left"===e.swipeDirection?this.hide():this.isOpen&&"Right"===this.position&&"Right"===e.swipeDirection?this.hide():!this.isOpen&&"Right"===this.position&&"Left"===e.swipeDirection&&window.innerWidth-e.startX<=20&&e.distanceX>=50&&e.velocity>=.5&&this.show()},i.prototype.setEnableGestures=function(){this.enableGestures?(this.mainContentEle=new t.Touch(document.body,{swipe:this.enableGestureHandler.bind(this)}),this.sidebarEle=new t.Touch(this.element,{swipe:this.enableGestureHandler.bind(this)})):this.mainContentEle&&this.sidebarEle&&(this.mainContentEle.destroy(),this.sidebarEle.destroy())},i.prototype.wireEvents=function(){this.setEnableGestures(),t.EventHandler.add(window,"resize",this.resize,this)},i.prototype.unWireEvents=function(){t.EventHandler.remove(window,"resize",this.resize),t.EventHandler.remove(document,"mousedown touchstart",this.documentclickHandler),this.mainContentEle&&this.mainContentEle.destroy(),this.sidebarEle&&this.sidebarEle.destroy()},i.prototype.onPropertyChanged=function(i,s){for(var n=document.querySelector(".e-main-content")||this.targetEle,r=this.isServerRendered,l=0,o=Object.keys(i);l<o.length;l++){switch(o[l]){case"isOpen":this.isOpen?this.show():this.hide();break;case"width":this.setWidth(),this.getState()||this.setDock();break;case"animate":this.setAnimation();break;case"type":this.checkType(!1),t.removeClass([this.element],[ki]),this.addClass(),t.addClass([this.element],"Auto"===this.type?t.Browser.isDevice?["e-over"]:["e-push"]:["e-"+this.type.toLowerCase()]);break;case"position":this.element.style.transform="",this.setDock(),n&&(n.style["Left"===this.position?"marginRight":"marginLeft"]="0px"),"Right"===this.position?(t.removeClass([this.element],"e-left"),t.addClass([this.element],Ii)):(t.removeClass([this.element],Ii),t.addClass([this.element],"e-left")),this.setType(this.type);break;case"showBackdrop":this.showBackdrop?this.createBackDrop():this.modal&&(this.modal.style.display="none",this.modal.outerHTML="",this.modal=null);break;case"target":"string"==typeof this.target&&this.setProperties({target:document.querySelector(this.target)},!0),t.isNullOrUndefined(this.target)&&(t.removeClass([this.element],Di),t.removeClass([s.target],Ai),t.setStyleAttribute(n,{"margin-left":0,"margin-right":0}),document.body.insertAdjacentElement("afterbegin",this.element)),this.isServerRendered=!1,e.prototype.refresh.call(this),this.isServerRendered=r;break;case"closeOnDocumentClick":this.setCloseOnDocumentClick();break;case"enableDock":this.getState()||this.setDock();break;case"zIndex":this.setZindex();break;case"mediaQuery":this.setMediaQuery();break;case"enableGestures":this.setEnableGestures();break;case"enableRtl":this.setEnableRTL()}}},i.prototype.setType=function(e){var i=this.element.getBoundingClientRect().width;this.setZindex();var s=document.querySelector(".e-main-content")||this.targetEle;s&&(s.style.transform="translateX(0px)",t.Browser.isDevice||"Auto"===this.type||"Over"===this.type&&this.enableDock||(s.style["Left"===this.position?"marginLeft":"marginRight"]="0px"));var n=(this.position,i+"px"),r="Left"===this.position?i:-i;switch(t.removeClass([this.element],[wi,Si,"e-slide"]),e){case"Push":t.addClass([this.element],[wi]),s&&(this.enableDock||this.element.classList.contains(xi))&&(s.style["Left"===this.position?"marginLeft":"marginRight"]=n);break;case"Slide":t.addClass([this.element],["e-slide"]),s&&(this.enableDock||this.element.classList.contains(xi))&&(s.style.transform="translateX("+r+"px)");break;case"Over":t.addClass([this.element],[Si]),this.enableDock&&(this.element.classList.contains(Ni)||this.isOpen)&&s&&(s.style["Left"===this.position?"marginLeft":"marginRight"]=this.setDimension(this.dockSize));break;case"Auto":t.addClass([this.element],[Oi]),t.Browser.isDevice?s&&this.enableDock&&!this.getState()?(s.style["Left"===this.position?"marginLeft":"marginRight"]=n,t.addClass([this.element],wi)):t.addClass([this.element],Si):(t.addClass([this.element],wi),s&&(this.enableDock||this.element.classList.contains(xi))&&(s.style["Left"===this.position?"marginLeft":"marginRight"]=n)),this.createBackDrop()}},i.prototype.destroy=function(){e.prototype.destroy.call(this),this.target&&t.removeClass([this.target],Ai),this.destroyBackDrop(),this.element&&(t.removeClass([this.element],[xi,Ni,wi,"e-slide",Si,"e-left",Ii,Oi]),t.removeClass([this.element],Di),this.element.style.width="",this.element.style.zIndex="",this.element.style.transform="",t.isNullOrUndefined(this.sidebarEleCopy.getAttribute("tabindex"))?this.element.removeAttribute("tabindex"):this.element.setAttribute("tabindex",this.tabIndex)),this.windowWidth=null;var i=document.querySelector(".e-main-content")||this.targetEle;t.isNullOrUndefined(i)||(i.style.margin="",i.style.transform=""),this.unWireEvents()},Ei([t.Property("auto")],i.prototype,"dockSize",void 0),Ei([t.Property(null)],i.prototype,"mediaQuery",void 0),Ei([t.Property(!1)],i.prototype,"enableDock",void 0),Ei([t.Property("en-US")],i.prototype,"locale",void 0),Ei([t.Property(!1)],i.prototype,"enablePersistence",void 0),Ei([t.Property(!0)],i.prototype,"enableGestures",void 0),Ei([t.Property(!1)],i.prototype,"isOpen",void 0),Ei([t.Property(!1)],i.prototype,"enableRtl",void 0),Ei([t.Property(!0)],i.prototype,"animate",void 0),Ei([t.Property("auto")],i.prototype,"height",void 0),Ei([t.Property(!1)],i.prototype,"closeOnDocumentClick",void 0),Ei([t.Property("Left")],i.prototype,"position",void 0),Ei([t.Property(null)],i.prototype,"target",void 0),Ei([t.Property(!1)],i.prototype,"showBackdrop",void 0),Ei([t.Property("Auto")],i.prototype,"type",void 0),Ei([t.Property("auto")],i.prototype,"width",void 0),Ei([t.Property(1e3)],i.prototype,"zIndex",void 0),Ei([t.Event()],i.prototype,"created",void 0),Ei([t.Event()],i.prototype,"close",void 0),Ei([t.Event()],i.prototype,"open",void 0),Ei([t.Event()],i.prototype,"change",void 0),Ei([t.Event()],i.prototype,"destroyed",void 0),i=Ei([t.NotifyPropertyChanges],i)}(t.Component),Pi=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),Ti=function(e,t,i,s){var n,r=arguments.length,l=r<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)l=Reflect.decorate(e,t,i,s);else for(var o=e.length-1;o>=0;o--)(n=e[o])&&(l=(r<3?n(l):r>3?n(t,i,l):n(t,i))||l);return r>3&&l&&Object.defineProperty(t,i,l),l},Hi="e-icon-right",Ui="e-breadcrumb-text",Ri="e-breadcrumb-icon",Bi="e-breadcrumb-menu",ji="e-breadcrumb-item",qi="e-breadcrumb-popup",Fi="e-breadcrumb-wrap-mode",Wi="e-breadcrumb-scroll-mode",Vi="e-disabled",_i="aria-disabled",zi=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return Pi(i,e),Ti([t.Property("")],i.prototype,"text",void 0),Ti([t.Property("")],i.prototype,"url",void 0),Ti([t.Property(null)],i.prototype,"iconCss",void 0),Ti([t.Property(!1)],i.prototype,"disabled",void 0),i}(t.ChildProperty),Ki=function(e){function n(t,i){return e.call(this,t,i)||this}return Pi(n,e),n.prototype.preRender=function(){},n.prototype.render=function(){this.initialize(),this.renderItems(this.items),this.wireEvents()},n.prototype.initialize=function(){this._maxItems=this.maxItems,this.element.setAttribute("aria-label","breadcrumb"),this.cssClass&&t.addClass([this.element],this.cssClass.split(" ")),this.enableRtl&&this.element.classList.add("e-rtl"),this.disabled&&(this.element.classList.add(Vi),this.element.setAttribute(_i,"true")),"Wrap"===this.overflowMode?this.element.classList.add(Fi):"Scroll"===this.overflowMode&&this.element.classList.add(Wi),this.initItems(),this.initPvtProps()},n.prototype.initPvtProps=function(){"Hidden"===this.overflowMode&&this._maxItems>0&&(this.endIndex=this.getEndIndex(),this.startIndex=this.endIndex+1-(this._maxItems-1)),"Menu"===this.overflowMode&&(this._maxItems>=0?(this.startIndex=this._maxItems>1?1:0,this.endIndex=this.getEndIndex(),this.popupUl=this.createElement("ul",{attrs:{TABINDEX:"0",role:"menu"}})):this.startIndex=this.endIndex=null)},n.prototype.getEndIndex=function(){var e,t=this;return this.activeItem?this.items.forEach(function(i,s){i.url!==t.activeItem&&i.text!==t.activeItem||(e=s)}):e=this.items.length-1,e},n.prototype.initItems=function(){if(!this.items.length){var e=void 0,t=void 0,i=[];if(this.url){var s=new URL(this.url,window.location.origin);e=s.origin+"/",t=s.href.split(e)[1].split("/")}else e=window.location.origin+"/",t=window.location.href.split(e)[1].split("/");i.push({iconCss:"e-icons e-home",url:e});for(var n=0;n<t.length;n++)t[n]&&(i.push({text:t[n],url:e+t[n]}),e+=t[n]+"/");this.setProperties({items:i},!0)}},n.prototype.renderItems=function(e){var s,n,r=this,l=this.element.classList.contains(Hi),o=e.length;if(o){var a,d=void 0,h=void 0,c=0,p=void 0,u=2*o-1,f=!1,m=this.createElement("ol",{className:"Wrap"===this.overflowMode?"e-breadcrumb-wrapped-ol":""}),v=this.createElement("ol",{className:"Wrap"===this.overflowMode?"e-breadcrumb-first-ol":""}),g=this.hasField(e,"iconCss"),y="Collapsed"===this.overflowMode&&this._maxItems>0&&o>this._maxItems&&!this.isExpanded,b="Hidden"===this.overflowMode&&this._maxItems>0;"Menu"===this.overflowMode&&this.popupUl&&(this.popupUl.innerHTML="");for(var C={moduleName:this.getModuleName(),showIcon:g,itemNavigable:!0,itemCreated:function(e){var i=e.curData.isLastItem;i&&e.item.children.length&&!r.itemTemplate&&(delete e.curData.isLastItem,a||r.enableActiveItemNavigation||(e.item.innerHTML=r.createElement("span",{className:Ui,innerHTML:e.item.children[0].innerHTML}).outerHTML)),!e.curData.iconCss||e.curData.text||r.itemTemplate||e.item.classList.add("e-icon-item"),b&&e.item.setAttribute("item-index",c.toString());var s={item:t.extend({},e.curData.properties?e.curData.properties:e.curData),element:e.item,cancel:!1};r.trigger("beforeItemRender",s),f=s.cancel;var n=l||s.element.classList.contains(Hi);n&&e.curData.iconCss&&!r.itemTemplate&&e.item.querySelector(".e-anchor-wrap").appendChild(e.item.querySelector("."+Ri)),s.item.disabled&&(e.item.setAttribute(_i,"true"),e.item.classList.add(Vi)),(s.item.disabled||r.disabled)&&e.item.children.length&&!r.itemTemplate&&e.item.children[0].setAttribute("tabindex","-1"),e.curData.isEmptyUrl&&(e.item.children[0].removeAttribute("href"),!(!i||i&&r.enableActiveItemNavigation)||s.item.disabled||r.disabled||(e.item.children[0].setAttribute("tabindex","0"),t.EventHandler.add(e.item.children[0],"keydown",r.keyDownHandler,r))),i&&e.item.setAttribute("data-active-item",""),r.itemTemplate||r.beforeItemRenderChanges(e.curData,s.item,e.item,n)}},E=0;E<u;E%2&&c++,E++)if(d=this.activeItem&&(this.activeItem===e[c].url||this.activeItem===e[c].text),!(y&&E>1&&E<u-2)&&(!b||!(c<this.startIndex||c>this.endIndex)||E%2&&c===this.startIndex-1||0===c)){E%2?(p=this.createElement("div",{className:"e-breadcrumb-item-wrapper"}),C.template=this.separatorTemplate?this.separatorTemplate:"/",C.itemClass="e-breadcrumb-separator",n=!1,s=[{previousItem:e[c],nextItem:e[c+1]}]):(C.itemClass="",this.itemTemplate?(C.template=this.itemTemplate,n=!1):n=!0,(s=[t.extend({},e[c].properties?e[c].properties:e[c])])[0].url||this.itemTemplate||(s=[t.extend({},s[0],{isEmptyUrl:!0,url:"#"})]),h=(b||"Menu"===this.overflowMode)&&c===this.endIndex,((E===u-1||h)&&!this.itemTemplate||d)&&(s[0].isLastItem=!0));var N=m,x=this.startIndex+this.endIndex-this._maxItems;if("Menu"===this.overflowMode&&(c>=this.startIndex&&c<=x&&(!(E%2)||c!==x)&&this.endIndex>=this._maxItems&&this._maxItems>0||0===this._maxItems)){if(E%2)continue;N=this.popupUl,h&&(a=!0)}else"Wrap"===this.overflowMode&&(N=0===E?v:p);var O=i.ListBase.createList(this.createElement,s,C,n,this).childNodes;if(f){if(b||y||"Menu"===this.overflowMode||"Wrap"===this.overflowMode)return e.splice(c,1),this.initPvtProps(),this.reRenderItems();(E===u-1||h)&&t.remove(N.lastElementChild)}else t.append(O,N);if("Wrap"===this.overflowMode&&0!==E&&E%2==0&&m.appendChild(p),y&&1===E){var I=this.createElement("li",{className:"e-icons e-breadcrumb-collapsed",attrs:{TABINDEX:"0"}});t.EventHandler.add(I,"keyup",this.expandHandler,this),m.appendChild(I)}if("Menu"===this.overflowMode&&this.startIndex===E&&this.endIndex>=this._maxItems&&this._maxItems>=0){var S=this.getMenuElement();t.EventHandler.add(S,"keyup",this.keyDownHandler,this),m.appendChild(S)}if(d||h)break;f&&E++}this.isReact&&this.renderReactTemplates(),"Wrap"===this.overflowMode&&this.element.appendChild(v),this.element.appendChild(m),this.calculateMaxItems()}},n.prototype.calculateMaxItems=function(){if("Hidden"===this.overflowMode||"Collapsed"===this.overflowMode||"Menu"===this.overflowMode){var e=void 0,i=this.element.offsetWidth,s=[].slice.call(this.element.children[0].children).reverse(),n="Menu"===this.overflowMode?0:s[s.length-1].offsetWidth+(s[s.length-2]?s[s.length-2].offsetWidth:0);if("Menu"===this.overflowMode){var r=this.getMenuElement();this.element.appendChild(r),n+=r.offsetWidth,t.remove(r)}for(var l=0;l<s.length-2;l++){if(n>i){if(e=Math.ceil((l-1)/2)+("Menu"===this.overflowMode&&l<=2?0:1),(this.maxItems>e&&!(this.maxItems>-1&&-1==e)||-1==this.maxItems)&&this._maxItems!=e)return this._maxItems=e,this.initPvtProps(),this.reRenderItems();break}if("Menu"===this.overflowMode&&2===l&&(n+=s[s.length-1].offsetWidth+s[s.length-2].offsetWidth)>i)return this._maxItems=1,this.initPvtProps(),this.reRenderItems();"Menu"===this.overflowMode&&s[l].classList.contains(Bi)||(n+=s[l].offsetWidth)}}else if(("Wrap"===this.overflowMode||"Scroll"===this.overflowMode)&&this._maxItems>0){i=0;if((s=this.element.querySelectorAll("."+ji)).length>this._maxItems+this._maxItems-1){for(l="Wrap"===this.overflowMode?1:0;l<this._maxItems+this._maxItems-1;l++)i+=s[l].offsetWidth;i=i+5+2*parseInt(getComputedStyle(this.element.children[0]).paddingLeft,10),"Wrap"===this.overflowMode?this.element.querySelector(".e-breadcrumb-wrapped-ol").style.width=i+"px":this.element.style.width=i+"px"}}},n.prototype.hasField=function(e,t){for(var i=0,s=e.length;i<s;i++)if(e[i][t])return!0;return!1},n.prototype.getMenuElement=function(){return this.createElement("li",{className:"e-icons e-breadcrumb-menu",attrs:{TABINDEX:"0"}})},n.prototype.beforeItemRenderChanges=function(e,i,s,n){var r=s.querySelector(".e-anchor-wrap");if(i.text!==e.text&&r.childNodes.forEach(function(e){e.nodeType===Node.TEXT_NODE&&(e.textContent=i.text)}),i.iconCss!==e.iconCss&&r){var l=s.querySelector("."+Ri);if(l)i.iconCss?(t.removeClass([l],e.iconCss.split(" ")),t.addClass([l],i.iconCss.split(" "))):t.remove(l);else if(i.iconCss){var o=this.createElement("span",{className:Ri+" "+i.iconCss});n?t.append([o],r):r.insertBefore(o,r.childNodes[0])}}if(i.url!==e.url&&this.enableNavigation){var a=s.querySelector("a."+Ui);a&&(i.url?a.setAttribute("href",i.url):a.removeAttribute("href"))}},n.prototype.reRenderItems=function(){this.element.innerHTML="",this.renderItems(this.items)},n.prototype.clickHandler=function(e){var i=t.closest(e.target,"."+ji+":not(.e-breadcrumb-separator)");if(this.enableNavigation||e.preventDefault(),i&&(t.closest(e.target,"."+Ui)||this.itemTemplate)){var s=void 0;s="Wrap"===this.overflowMode?[].slice.call(this.element.querySelectorAll("."+ji)).indexOf(i):[].slice.call(i.parentElement.children).indexOf(i),"Menu"===this.overflowMode?t.closest(e.target,"."+qi)?(s+=this.startIndex,this.endIndex=s,"keydown"===e.type&&this.documentClickHandler(e)):this.element.querySelector("."+Bi)?s>[].slice.call(this.element.children[0].children).indexOf(this.element.querySelector("."+Bi))?(s+=2*this.popupUl.childElementCount-2,s=Math.floor(s/2),this.endIndex=s):this.startIndex=this.endIndex=s:(s=Math.floor(s/2),this.startIndex=this.endIndex=s):s=Math.floor(s/2),"Hidden"===this.overflowMode&&this._maxItems>0&&0!==this.endIndex&&(s=parseInt(i.getAttribute("item-index"),10),this.startIndex>1&&(this.startIndex-=this.endIndex-s),this.endIndex=s),this.trigger("itemClick",{element:i,item:this.items[s],event:e}),this.activeItem=this.items[s].url||this.items[s].text,this.dataBind()}e.target.classList.contains("e-breadcrumb-collapsed")&&(this.isExpanded=!0,this.reRenderItems()),e.target.classList.contains(Bi)&&this.renderPopup()},n.prototype.renderPopup=function(){var e=this,t=this.createElement("div",{className:qi+" "+this.cssClass+(this.enableRtl?" e-rtl":"")});document.body.appendChild(t),this.popupObj=new s.Popup(t,{content:this.popupUl,relateTo:this.element.querySelector("."+Bi),enableRtl:this.enableRtl,position:{X:"left",Y:"bottom"},collision:{X:"fit",Y:"flip"},open:function(){e.popupUl.focus()}}),this.popupWireEvents(),this.popupObj.show()},n.prototype.documentClickHandler=function(e){"Menu"===this.overflowMode&&this.popupObj&&this.popupObj.element.classList.contains("e-popup-open")&&!t.closest(e.target,"."+Bi)&&(this.popupObj.hide(),this.popupObj.destroy(),t.detach(this.popupObj.element))},n.prototype.resize=function(){this._maxItems=this.maxItems,this.initPvtProps(),this.reRenderItems()},n.prototype.expandHandler=function(e){"Enter"===e.key&&(this.isExpanded=!0,this.reRenderItems())},n.prototype.keyDownHandler=function(e){"Enter"===e.key&&this.clickHandler(e)},n.prototype.popupKeyDownHandler=function(e){"Escape"===e.key&&this.documentClickHandler(e)},n.prototype.onPropertyChanged=function(e,i){for(var s=0,n=Object.keys(e);s<n.length;s++){switch(n[s]){case"items":case"enableActiveItemNavigation":this.reRenderItems();break;case"activeItem":this._maxItems=this.maxItems,this.initPvtProps(),this.reRenderItems();break;case"overflowMode":case"maxItems":this._maxItems=this.maxItems,this.initPvtProps(),this.reRenderItems(),"Wrap"===i.overflowMode?this.element.classList.remove(Fi):"Wrap"===e.overflowMode&&this.element.classList.add(Fi),"Scroll"===i.overflowMode?this.element.classList.remove(Wi):"Scroll"===e.overflowMode&&this.element.classList.add(Wi);break;case"url":this.initItems(),this.reRenderItems();break;case"cssClass":i.cssClass&&t.removeClass([this.element],i.cssClass.split(" ")),e.cssClass&&t.addClass([this.element],e.cssClass.split(" ")),(i.cssClass&&i.cssClass.indexOf(Hi)>-1&&!(e.cssClass&&e.cssClass.indexOf(Hi)>-1)||!(i.cssClass&&i.cssClass.indexOf(Hi)>-1)&&e.cssClass&&e.cssClass.indexOf(Hi)>-1)&&this.reRenderItems();break;case"enableRtl":this.element.classList.toggle("e-rtl");break;case"disabled":this.element.classList.toggle(Vi),this.element.setAttribute(_i,e.disabled+"")}}},n.prototype.wireEvents=function(){this.delegateClickHanlder=this.documentClickHandler.bind(this),t.EventHandler.add(document,"click",this.delegateClickHanlder,this),t.EventHandler.add(this.element,"click",this.clickHandler,this),window.addEventListener("resize",this.resize.bind(this))},n.prototype.popupWireEvents=function(){t.EventHandler.add(this.popupObj.element,"click",this.clickHandler,this),t.EventHandler.add(this.popupObj.element,"keydown",this.popupKeyDownHandler,this)},n.prototype.unWireEvents=function(){t.EventHandler.remove(document,"click",this.delegateClickHanlder),t.EventHandler.remove(this.element,"click",this.clickHandler),window.removeEventListener("resize",this.resize.bind(this)),this.popupObj&&(t.EventHandler.remove(this.popupObj.element,"click",this.clickHandler),t.EventHandler.remove(this.popupObj.element,"keydown",this.popupKeyDownHandler))},n.prototype.getPersistData=function(){return this.addOnPersist(["activeItem"])},n.prototype.getModuleName=function(){return"breadcrumb"},n.prototype.destroy=function(){var i=this,s=[],n=["aria-label"];this.cssClass&&s.concat(this.cssClass.split(" ")),this.enableRtl&&s.push("e-rtl"),this.disabled&&(s.push(Vi),n.push(_i)),"Wrap"===this.overflowMode?s.push(Fi):"Scroll"===this.overflowMode&&s.push(Wi),this.unWireEvents(),this.element.innerHTML="",t.removeClass([this.element],s),n.forEach(function(e){i.element.removeAttribute(e)}),e.prototype.destroy.call(this)},Ti([t.Property("")],n.prototype,"url",void 0),Ti([t.Collection([],zi)],n.prototype,"items",void 0),Ti([t.Property("")],n.prototype,"activeItem",void 0),Ti([t.Property(-1)],n.prototype,"maxItems",void 0),Ti([t.Property("Menu")],n.prototype,"overflowMode",void 0),Ti([t.Property("")],n.prototype,"cssClass",void 0),Ti([t.Property(null)],n.prototype,"itemTemplate",void 0),Ti([t.Property("/")],n.prototype,"separatorTemplate",void 0),Ti([t.Property(!0)],n.prototype,"enableNavigation",void 0),Ti([t.Property(!1)],n.prototype,"enableActiveItemNavigation",void 0),Ti([t.Property(!1)],n.prototype,"disabled",void 0),Ti([t.Property("")],n.prototype,"locale",void 0),Ti([t.Event()],n.prototype,"beforeItemRender",void 0),Ti([t.Event()],n.prototype,"itemClick",void 0),Ti([t.Event()],n.prototype,"created",void 0),n=Ti([t.NotifyPropertyChanges],n)}(t.Component);e.MenuAnimationSettings=te,e.MenuItem=ee,e.HScroll=O,e.VScroll=B,e.addScrolling=o,e.destroyScroll=d,e.Item=De,e.Toolbar=Me,e.AccordionActionSettings=Qe,e.AccordionAnimationSettings=Je,e.AccordionItem=Ze,e.Accordion=$e,e.ContextMenu=it,e.Menu=ot,e.TabActionSettings=Tt,e.TabAnimationSettings=Ht,e.Header=Ut,e.TabItem=Rt,e.Tab=Bt,e.FieldsSettings=vi,e.ActionSettings=gi,e.NodeAnimationSettings=yi,e.TreeView=bi,e.Sidebar=Mi,e.BreadcrumbItem=zi,e.Breadcrumb=Ki,Object.defineProperty(e,"__esModule",{value:!0})});
	//# sourceMappingURL=ej2-navigations.umd.min.js.map


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(620);
	
	var _ej2Base = __webpack_require__(23);
	
	var _ej2ReactRichtexteditor = __webpack_require__(536);
	
	var _codemirror = __webpack_require__(78);
	
	var CodeMirror = _interopRequireWildcard(_codemirror);
	
	__webpack_require__(215);
	
	__webpack_require__(214);
	
	__webpack_require__(609);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var newStoriesEditor = function (_Component) {
	    _inherits(newStoriesEditor, _Component);
	
	    function newStoriesEditor() {
	        _classCallCheck(this, newStoriesEditor);
	
	        var _this = _possibleConstructorReturn(this, (newStoriesEditor.__proto__ || Object.getPrototypeOf(newStoriesEditor)).apply(this, arguments));
	
	        _this.hostUrl = 'https://ej2-aspcore-service.azurewebsites.net/';
	        // Rich Text Editor items list
	        _this.items = ['Bold', 'Italic', 'Underline', 'StrikeThrough', 'FontName', 'FontSize', 'FontColor', 'BackgroundColor', 'LowerCase', 'UpperCase', '|', 'Formats', 'Alignments', 'NumberFormatList', 'BulletFormatList', 'Outdent', 'Indent', 'SuperScript', 'SubScript', '|', 'CreateTable', 'CreateLink', 'Image', 'FileManager', '|', 'ClearFormat', 'Print', 'SourceCode', 'FullScreen', '|', 'Undo', 'Redo'];
	        _this.fileManagerSettings = {
	            enable: true,
	            path: '/Pictures/Food',
	            ajaxSettings: {
	                url: _this.hostUrl + 'api/FileManager/FileOperations',
	                getImageUrl: _this.hostUrl + 'api/FileManager/GetImage',
	                uploadUrl: _this.hostUrl + 'api/FileManager/Upload',
	                downloadUrl: _this.hostUrl + 'api/FileManager/Download'
	            }
	        };
	        _this.quickToolbarSettings = {
	            table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
	        };
	        //Rich Text Editor ToolbarSettings
	        _this.toolbarSettings = {
	            items: _this.items
	        };
	        return _this;
	    }
	
	    _createClass(newStoriesEditor, [{
	        key: 'mirrorConversion',
	        value: function mirrorConversion(e) {
	            this.textArea = this.rteObj.contentModule.getEditPanel();
	            var id = this.rteObj.getID() + 'mirror-view';
	            var mirrorView = this.rteObj.element.querySelector('#' + id);
	            var charCount = this.rteObj.element.querySelector('.e-rte-character-count');
	            if (e.targetItem === 'Preview') {
	                this.textArea.style.display = 'block';
	                mirrorView.style.display = 'none';
	                this.textArea.innerHTML = this.myCodeMirror.getValue();
	                charCount.style.display = 'block';
	            } else {
	                if (!mirrorView) {
	                    mirrorView = (0, _ej2Base.createElement)('div', { className: 'e-content' });
	                    mirrorView.id = id;
	                    this.textArea.parentNode.appendChild(mirrorView);
	                } else {
	                    mirrorView.innerHTML = '';
	                }
	                this.textArea.style.display = 'none';
	                mirrorView.style.display = 'block';
	                this.renderCodeMirror(mirrorView, this.rteObj.value);
	                charCount.style.display = 'none';
	            }
	        }
	    }, {
	        key: 'renderCodeMirror',
	        value: function renderCodeMirror(mirrorView, content) {
	            this.myCodeMirror = CodeMirror(mirrorView, {
	                value: content,
	                lineNumbers: true,
	                mode: 'text/html',
	                lineWrapping: true
	            });
	        }
	    }, {
	        key: 'handleFullScreen',
	        value: function handleFullScreen(e) {
	            var sbCntEle = document.querySelector('.sb-content.e-view');
	            var sbHdrEle = document.querySelector('.sb-header.e-view');
	            var leftBar = void 0;
	            var transformElement = void 0;
	            if (_ej2Base.Browser.isDevice) {
	                leftBar = document.querySelector('#right-sidebar');
	                transformElement = document.querySelector('.sample-browser.e-view.e-content-animation');
	            } else {
	                leftBar = document.querySelector('#left-sidebar');
	                transformElement = document.querySelector('#right-pane');
	            }
	            if (e.targetItem === 'Maximize') {
	                if (_ej2Base.Browser.isDevice && _ej2Base.Browser.isIos) {
	                    (0, _ej2Base.addClass)([sbCntEle, sbHdrEle], ['hide-header']);
	                }
	                (0, _ej2Base.addClass)([leftBar], ['e-close']);
	                (0, _ej2Base.removeClass)([leftBar], ['e-open']);
	                if (!_ej2Base.Browser.isDevice) {
	                    transformElement.style.marginLeft = '0px';
	                }
	                transformElement.style.transform = 'inherit';
	            } else if (e.targetItem === 'Minimize') {
	                if (_ej2Base.Browser.isDevice && _ej2Base.Browser.isIos) {
	                    (0, _ej2Base.removeClass)([sbCntEle, sbHdrEle], ['hide-header']);
	                }
	                (0, _ej2Base.removeClass)([leftBar], ['e-close']);
	                if (!_ej2Base.Browser.isDevice) {
	                    (0, _ej2Base.addClass)([leftBar], ['e-open']);
	                    transformElement.style.marginLeft = leftBar.offsetWidth + 'px';
	                }
	                transformElement.style.transform = 'translateX(0px)';
	            }
	        }
	    }, {
	        key: 'actionCompleteHandler',
	        value: function actionCompleteHandler(e) {
	            var _this2 = this;
	
	            if (e.targetItem && (e.targetItem === 'SourceCode' || e.targetItem === 'Preview')) {
	                this.rteObj.sourceCodeModule.getPanel().style.display = 'none';
	                this.mirrorConversion(e);
	            } else {
	                setTimeout(function () {
	                    _this2.rteObj.toolbarModule.refreshToolbarOverflow();
	                }, 1000);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'control-pane' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'control-section', id: 'rteTools' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'rte-control-section' },
	                        _react2.default.createElement(
	                            _ej2ReactRichtexteditor.RichTextEditorComponent,
	                            { id: "toolsRTE" + this.props.textEditorName, ref: function ref(richtexteditor) {
	                                    _this3.rteObj = richtexteditor;
	                                }, showCharCount: true, actionBegin: this.handleFullScreen.bind(this), actionComplete: this.actionCompleteHandler.bind(this), maxLength: 100000, toolbarSettings: this.toolbarSettings, fileManagerSettings: this.fileManagerSettings, quickToolbarSettings: this.quickToolbarSettings },
	                            _react2.default.createElement(_ej2ReactRichtexteditor.Inject, { services: [_ej2ReactRichtexteditor.Toolbar, _ej2ReactRichtexteditor.Image, _ej2ReactRichtexteditor.Link, _ej2ReactRichtexteditor.HtmlEditor, _ej2ReactRichtexteditor.Count, _ej2ReactRichtexteditor.QuickToolbar, _ej2ReactRichtexteditor.Table, _ej2ReactRichtexteditor.FileManager] })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return newStoriesEditor;
	}(_react.Component);
	
	exports.default = newStoriesEditor;

/***/ },
/* 104 */
/***/ function(module, exports) {

	function toVal(mix) {
		var k, y, str='';
	
		if (typeof mix === 'string' || typeof mix === 'number') {
			str += mix;
		} else if (typeof mix === 'object') {
			if (Array.isArray(mix)) {
				for (k=0; k < mix.length; k++) {
					if (mix[k]) {
						if (y = toVal(mix[k])) {
							str && (str += ' ');
							str += y;
						}
					}
				}
			} else {
				for (k in mix) {
					if (mix[k]) {
						str && (str += ' ');
						str += k;
					}
				}
			}
		}
	
		return str;
	}
	
	module.exports = function () {
		var i=0, tmp, x, str='';
		while (i < arguments.length) {
			if (tmp = arguments[i++]) {
				if (x = toVal(tmp)) {
					str && (str += ' ');
					str += x
				}
			}
		}
		return str;
	}


/***/ },
/* 105 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ },
/* 106 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var EventPluginRegistry = __webpack_require__(144);
	var ReactEventEmitterMixin = __webpack_require__(703);
	var ViewportMetrics = __webpack_require__(378);
	
	var getVendorPrefixedEventName = __webpack_require__(735);
	var isEventSupported = __webpack_require__(155);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(82);
	var ViewportMetrics = __webpack_require__(378);
	
	var getEventModifierState = __webpack_require__(153);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var invariant = __webpack_require__(11);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 110 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(27);
	var DOMNamespaces = __webpack_require__(143);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(151);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 112 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.isTabPanel = exports.isTabList = exports.isTab = void 0;
	
	function makeTypeChecker(tabsRole) {
	  return function (element) {
	    return !!element.type && element.type.tabsRole === tabsRole;
	  };
	}
	
	var isTab = makeTypeChecker('Tab');
	exports.isTab = isTab;
	var isTabList = makeTypeChecker('TabList');
	exports.isTabList = isTabList;
	var isTabPanel = makeTypeChecker('TabPanel');
	exports.isTabPanel = isTabPanel;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ },
/* 114 */
/***/ function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var validation_1 = __webpack_require__(48);
	var Path_1 = __webpack_require__(17);
	var PriorityIndex_1 = __webpack_require__(26);
	/**
	 * Class representing a firebase data snapshot.  It wraps a SnapshotNode and
	 * surfaces the public methods (val, forEach, etc.) we want to expose.
	 */
	var DataSnapshot = /** @class */ (function () {
	    /**
	     * @param {!Node} node_ A SnapshotNode to wrap.
	     * @param {!Reference} ref_ The ref of the location this snapshot came from.
	     * @param {!Index} index_ The iteration order for this snapshot
	     */
	    function DataSnapshot(node_, ref_, index_) {
	        this.node_ = node_;
	        this.ref_ = ref_;
	        this.index_ = index_;
	    }
	    /**
	     * Retrieves the snapshot contents as JSON.  Returns null if the snapshot is
	     * empty.
	     *
	     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
	     */
	    DataSnapshot.prototype.val = function () {
	        util_1.validateArgCount('DataSnapshot.val', 0, 0, arguments.length);
	        return this.node_.val();
	    };
	    /**
	     * Returns the snapshot contents as JSON, including priorities of node.  Suitable for exporting
	     * the entire node contents.
	     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
	     */
	    DataSnapshot.prototype.exportVal = function () {
	        util_1.validateArgCount('DataSnapshot.exportVal', 0, 0, arguments.length);
	        return this.node_.val(true);
	    };
	    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
	    // for end-users
	    DataSnapshot.prototype.toJSON = function () {
	        // Optional spacer argument is unnecessary because we're depending on recursion rather than stringifying the content
	        util_1.validateArgCount('DataSnapshot.toJSON', 0, 1, arguments.length);
	        return this.exportVal();
	    };
	    /**
	     * Returns whether the snapshot contains a non-null value.
	     *
	     * @return {boolean} Whether the snapshot contains a non-null value, or is empty.
	     */
	    DataSnapshot.prototype.exists = function () {
	        util_1.validateArgCount('DataSnapshot.exists', 0, 0, arguments.length);
	        return !this.node_.isEmpty();
	    };
	    /**
	     * Returns a DataSnapshot of the specified child node's contents.
	     *
	     * @param {!string} childPathString Path to a child.
	     * @return {!DataSnapshot} DataSnapshot for child node.
	     */
	    DataSnapshot.prototype.child = function (childPathString) {
	        util_1.validateArgCount('DataSnapshot.child', 0, 1, arguments.length);
	        // Ensure the childPath is a string (can be a number)
	        childPathString = String(childPathString);
	        validation_1.validatePathString('DataSnapshot.child', 1, childPathString, false);
	        var childPath = new Path_1.Path(childPathString);
	        var childRef = this.ref_.child(childPath);
	        return new DataSnapshot(this.node_.getChild(childPath), childRef, PriorityIndex_1.PRIORITY_INDEX);
	    };
	    /**
	     * Returns whether the snapshot contains a child at the specified path.
	     *
	     * @param {!string} childPathString Path to a child.
	     * @return {boolean} Whether the child exists.
	     */
	    DataSnapshot.prototype.hasChild = function (childPathString) {
	        util_1.validateArgCount('DataSnapshot.hasChild', 1, 1, arguments.length);
	        validation_1.validatePathString('DataSnapshot.hasChild', 1, childPathString, false);
	        var childPath = new Path_1.Path(childPathString);
	        return !this.node_.getChild(childPath).isEmpty();
	    };
	    /**
	     * Returns the priority of the object, or null if no priority was set.
	     *
	     * @return {string|number|null} The priority.
	     */
	    DataSnapshot.prototype.getPriority = function () {
	        util_1.validateArgCount('DataSnapshot.getPriority', 0, 0, arguments.length);
	        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
	        return this.node_.getPriority().val();
	    };
	    /**
	     * Iterates through child nodes and calls the specified action for each one.
	     *
	     * @param {function(!DataSnapshot)} action Callback function to be called
	     * for each child.
	     * @return {boolean} True if forEach was canceled by action returning true for
	     * one of the child nodes.
	     */
	    DataSnapshot.prototype.forEach = function (action) {
	        var _this = this;
	        util_1.validateArgCount('DataSnapshot.forEach', 1, 1, arguments.length);
	        util_1.validateCallback('DataSnapshot.forEach', 1, action, false);
	        if (this.node_.isLeafNode())
	            return false;
	        var childrenNode = this.node_;
	        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
	        return !!childrenNode.forEachChild(this.index_, function (key, node) {
	            return action(new DataSnapshot(node, _this.ref_.child(key), PriorityIndex_1.PRIORITY_INDEX));
	        });
	    };
	    /**
	     * Returns whether this DataSnapshot has children.
	     * @return {boolean} True if the DataSnapshot contains 1 or more child nodes.
	     */
	    DataSnapshot.prototype.hasChildren = function () {
	        util_1.validateArgCount('DataSnapshot.hasChildren', 0, 0, arguments.length);
	        if (this.node_.isLeafNode())
	            return false;
	        else
	            return !this.node_.isEmpty();
	    };
	    Object.defineProperty(DataSnapshot.prototype, "key", {
	        get: function () {
	            return this.ref_.getKey();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns the number of children for this DataSnapshot.
	     * @return {number} The number of children that this DataSnapshot contains.
	     */
	    DataSnapshot.prototype.numChildren = function () {
	        util_1.validateArgCount('DataSnapshot.numChildren', 0, 0, arguments.length);
	        return this.node_.numChildren();
	    };
	    /**
	     * @return {Reference} The Firebase reference for the location this snapshot's data came from.
	     */
	    DataSnapshot.prototype.getRef = function () {
	        util_1.validateArgCount('DataSnapshot.ref', 0, 0, arguments.length);
	        return this.ref_;
	    };
	    Object.defineProperty(DataSnapshot.prototype, "ref", {
	        get: function () {
	            return this.getRef();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return DataSnapshot;
	}());
	exports.DataSnapshot = DataSnapshot;
	
	//# sourceMappingURL=DataSnapshot.js.map


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var onDisconnect_1 = __webpack_require__(166);
	var TransactionResult_1 = __webpack_require__(420);
	var util_1 = __webpack_require__(13);
	var NextPushId_1 = __webpack_require__(437);
	var Query_1 = __webpack_require__(165);
	var Repo_1 = __webpack_require__(86);
	var Path_1 = __webpack_require__(17);
	var QueryParams_1 = __webpack_require__(447);
	var validation_1 = __webpack_require__(48);
	var util_2 = __webpack_require__(2);
	var util_3 = __webpack_require__(2);
	var SyncPoint_1 = __webpack_require__(171);
	var Reference = /** @class */ (function (_super) {
	    __extends(Reference, _super);
	    /**
	     * Call options:
	     *   new Reference(Repo, Path) or
	     *   new Reference(url: string, string|RepoManager)
	     *
	     * Externally - this is the firebase.database.Reference type.
	     *
	     * @param {!Repo} repo
	     * @param {(!Path)} path
	     * @extends {Query}
	     */
	    function Reference(repo, path) {
	        var _this = this;
	        if (!(repo instanceof Repo_1.Repo)) {
	            throw new Error('new Reference() no longer supported - use app.database().');
	        }
	        // call Query's constructor, passing in the repo and path.
	        _this = _super.call(this, repo, path, QueryParams_1.QueryParams.DEFAULT, false) || this;
	        return _this;
	    }
	    /** @return {?string} */
	    Reference.prototype.getKey = function () {
	        util_2.validateArgCount('Reference.key', 0, 0, arguments.length);
	        if (this.path.isEmpty())
	            return null;
	        else
	            return this.path.getBack();
	    };
	    /**
	     * @param {!(string|Path)} pathString
	     * @return {!Reference}
	     */
	    Reference.prototype.child = function (pathString) {
	        util_2.validateArgCount('Reference.child', 1, 1, arguments.length);
	        if (typeof pathString === 'number') {
	            pathString = String(pathString);
	        }
	        else if (!(pathString instanceof Path_1.Path)) {
	            if (this.path.getFront() === null)
	                validation_1.validateRootPathString('Reference.child', 1, pathString, false);
	            else
	                validation_1.validatePathString('Reference.child', 1, pathString, false);
	        }
	        return new Reference(this.repo, this.path.child(pathString));
	    };
	    /** @return {?Reference} */
	    Reference.prototype.getParent = function () {
	        util_2.validateArgCount('Reference.parent', 0, 0, arguments.length);
	        var parentPath = this.path.parent();
	        return parentPath === null ? null : new Reference(this.repo, parentPath);
	    };
	    /** @return {!Reference} */
	    Reference.prototype.getRoot = function () {
	        util_2.validateArgCount('Reference.root', 0, 0, arguments.length);
	        var ref = this;
	        while (ref.getParent() !== null) {
	            ref = ref.getParent();
	        }
	        return ref;
	    };
	    /** @return {!Database} */
	    Reference.prototype.databaseProp = function () {
	        return this.repo.database;
	    };
	    /**
	     * @param {*} newVal
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.set = function (newVal, onComplete) {
	        util_2.validateArgCount('Reference.set', 1, 2, arguments.length);
	        validation_1.validateWritablePath('Reference.set', this.path);
	        validation_1.validateFirebaseDataArg('Reference.set', 1, newVal, this.path, false);
	        util_2.validateCallback('Reference.set', 2, onComplete, true);
	        var deferred = new util_3.Deferred();
	        this.repo.setWithPriority(this.path, newVal, 
	        /*priority=*/ null, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {!Object} objectToMerge
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.update = function (objectToMerge, onComplete) {
	        util_2.validateArgCount('Reference.update', 1, 2, arguments.length);
	        validation_1.validateWritablePath('Reference.update', this.path);
	        if (Array.isArray(objectToMerge)) {
	            var newObjectToMerge = {};
	            for (var i = 0; i < objectToMerge.length; ++i) {
	                newObjectToMerge['' + i] = objectToMerge[i];
	            }
	            objectToMerge = newObjectToMerge;
	            util_1.warn('Passing an Array to Firebase.update() is deprecated. ' +
	                'Use set() if you want to overwrite the existing data, or ' +
	                'an Object with integer keys if you really do want to ' +
	                'only update some of the children.');
	        }
	        validation_1.validateFirebaseMergeDataArg('Reference.update', 1, objectToMerge, this.path, false);
	        util_2.validateCallback('Reference.update', 2, onComplete, true);
	        var deferred = new util_3.Deferred();
	        this.repo.update(this.path, objectToMerge, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {*} newVal
	     * @param {string|number|null} newPriority
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.setWithPriority = function (newVal, newPriority, onComplete) {
	        util_2.validateArgCount('Reference.setWithPriority', 2, 3, arguments.length);
	        validation_1.validateWritablePath('Reference.setWithPriority', this.path);
	        validation_1.validateFirebaseDataArg('Reference.setWithPriority', 1, newVal, this.path, false);
	        validation_1.validatePriority('Reference.setWithPriority', 2, newPriority, false);
	        util_2.validateCallback('Reference.setWithPriority', 3, onComplete, true);
	        if (this.getKey() === '.length' || this.getKey() === '.keys')
	            throw 'Reference.setWithPriority failed: ' +
	                this.getKey() +
	                ' is a read-only object.';
	        var deferred = new util_3.Deferred();
	        this.repo.setWithPriority(this.path, newVal, newPriority, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.remove = function (onComplete) {
	        util_2.validateArgCount('Reference.remove', 0, 1, arguments.length);
	        validation_1.validateWritablePath('Reference.remove', this.path);
	        util_2.validateCallback('Reference.remove', 1, onComplete, true);
	        return this.set(null, onComplete);
	    };
	    /**
	     * @param {function(*):*} transactionUpdate
	     * @param {(function(?Error, boolean, ?DataSnapshot))=} onComplete
	     * @param {boolean=} applyLocally
	     * @return {!Promise}
	     */
	    Reference.prototype.transaction = function (transactionUpdate, onComplete, applyLocally) {
	        util_2.validateArgCount('Reference.transaction', 1, 3, arguments.length);
	        validation_1.validateWritablePath('Reference.transaction', this.path);
	        util_2.validateCallback('Reference.transaction', 1, transactionUpdate, false);
	        util_2.validateCallback('Reference.transaction', 2, onComplete, true);
	        // NOTE: applyLocally is an internal-only option for now.  We need to decide if we want to keep it and how
	        // to expose it.
	        validation_1.validateBoolean('Reference.transaction', 3, applyLocally, true);
	        if (this.getKey() === '.length' || this.getKey() === '.keys')
	            throw 'Reference.transaction failed: ' +
	                this.getKey() +
	                ' is a read-only object.';
	        if (applyLocally === undefined)
	            applyLocally = true;
	        var deferred = new util_3.Deferred();
	        if (typeof onComplete === 'function') {
	            deferred.promise.catch(function () { });
	        }
	        var promiseComplete = function (error, committed, snapshot) {
	            if (error) {
	                deferred.reject(error);
	            }
	            else {
	                deferred.resolve(new TransactionResult_1.TransactionResult(committed, snapshot));
	            }
	            if (typeof onComplete === 'function') {
	                onComplete(error, committed, snapshot);
	            }
	        };
	        this.repo.startTransaction(this.path, transactionUpdate, promiseComplete, applyLocally);
	        return deferred.promise;
	    };
	    /**
	     * @param {string|number|null} priority
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.setPriority = function (priority, onComplete) {
	        util_2.validateArgCount('Reference.setPriority', 1, 2, arguments.length);
	        validation_1.validateWritablePath('Reference.setPriority', this.path);
	        validation_1.validatePriority('Reference.setPriority', 1, priority, false);
	        util_2.validateCallback('Reference.setPriority', 2, onComplete, true);
	        var deferred = new util_3.Deferred();
	        this.repo.setWithPriority(this.path.child('.priority'), priority, null, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {*=} value
	     * @param {function(?Error)=} onComplete
	     * @return {!Reference}
	     */
	    Reference.prototype.push = function (value, onComplete) {
	        util_2.validateArgCount('Reference.push', 0, 2, arguments.length);
	        validation_1.validateWritablePath('Reference.push', this.path);
	        validation_1.validateFirebaseDataArg('Reference.push', 1, value, this.path, true);
	        util_2.validateCallback('Reference.push', 2, onComplete, true);
	        var now = this.repo.serverTime();
	        var name = NextPushId_1.nextPushId(now);
	        // push() returns a ThennableReference whose promise is fulfilled with a regular Reference.
	        // We use child() to create handles to two different references. The first is turned into a
	        // ThennableReference below by adding then() and catch() methods and is used as the
	        // return value of push(). The second remains a regular Reference and is used as the fulfilled
	        // value of the first ThennableReference.
	        var thennablePushRef = this.child(name);
	        var pushRef = this.child(name);
	        var promise;
	        if (value != null) {
	            promise = thennablePushRef.set(value, onComplete).then(function () { return pushRef; });
	        }
	        else {
	            promise = Promise.resolve(pushRef);
	        }
	        thennablePushRef.then = promise.then.bind(promise);
	        thennablePushRef.catch = promise.then.bind(promise, undefined);
	        if (typeof onComplete === 'function') {
	            promise.catch(function () { });
	        }
	        return thennablePushRef;
	    };
	    /**
	     * @return {!OnDisconnect}
	     */
	    Reference.prototype.onDisconnect = function () {
	        validation_1.validateWritablePath('Reference.onDisconnect', this.path);
	        return new onDisconnect_1.OnDisconnect(this.repo, this.path);
	    };
	    Object.defineProperty(Reference.prototype, "database", {
	        get: function () {
	            return this.databaseProp();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "key", {
	        get: function () {
	            return this.getKey();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "parent", {
	        get: function () {
	            return this.getParent();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "root", {
	        get: function () {
	            return this.getRoot();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Reference;
	}(Query_1.Query));
	exports.Reference = Reference;
	/**
	 * Define reference constructor in various modules
	 *
	 * We are doing this here to avoid several circular
	 * dependency issues
	 */
	Query_1.Query.__referenceConstructor = Reference;
	SyncPoint_1.SyncPoint.__referenceConstructor = Reference;
	
	//# sourceMappingURL=Reference.js.map


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var Repo_1 = __webpack_require__(86);
	var util_2 = __webpack_require__(13);
	var parser_1 = __webpack_require__(183);
	var validation_1 = __webpack_require__(48);
	__webpack_require__(426);
	/** @const {string} */
	var DATABASE_URL_OPTION = 'databaseURL';
	var _staticInstance;
	/**
	 * Creates and caches Repo instances.
	 */
	var RepoManager = /** @class */ (function () {
	    function RepoManager() {
	        /**
	         * @private {!Object.<string, Object<string, !fb.core.Repo>>}
	         */
	        this.repos_ = {};
	        /**
	         * If true, new Repos will be created to use ReadonlyRestClient (for testing purposes).
	         * @private {boolean}
	         */
	        this.useRestClient_ = false;
	    }
	    RepoManager.getInstance = function () {
	        if (!_staticInstance) {
	            _staticInstance = new RepoManager();
	        }
	        return _staticInstance;
	    };
	    // TODO(koss): Remove these functions unless used in tests?
	    RepoManager.prototype.interrupt = function () {
	        for (var appName in this.repos_) {
	            for (var dbUrl in this.repos_[appName]) {
	                this.repos_[appName][dbUrl].interrupt();
	            }
	        }
	    };
	    RepoManager.prototype.resume = function () {
	        for (var appName in this.repos_) {
	            for (var dbUrl in this.repos_[appName]) {
	                this.repos_[appName][dbUrl].resume();
	            }
	        }
	    };
	    /**
	     * This function should only ever be called to CREATE a new database instance.
	     *
	     * @param {!FirebaseApp} app
	     * @return {!Database}
	     */
	    RepoManager.prototype.databaseFromApp = function (app, url) {
	        var dbUrl = url || app.options[DATABASE_URL_OPTION];
	        if (dbUrl === undefined) {
	            util_2.fatal("Can't determine Firebase Database URL.  Be sure to include " +
	                DATABASE_URL_OPTION +
	                ' option when calling firebase.intializeApp().');
	        }
	        var parsedUrl = parser_1.parseRepoInfo(dbUrl);
	        var repoInfo = parsedUrl.repoInfo;
	        validation_1.validateUrl('Invalid Firebase Database URL', 1, parsedUrl);
	        if (!parsedUrl.path.isEmpty()) {
	            util_2.fatal('Database URL must point to the root of a Firebase Database ' +
	                '(not including a child path).');
	        }
	        var repo = this.createRepo(repoInfo, app);
	        return repo.database;
	    };
	    /**
	     * Remove the repo and make sure it is disconnected.
	     *
	     * @param {!Repo} repo
	     */
	    RepoManager.prototype.deleteRepo = function (repo) {
	        var appRepos = util_1.safeGet(this.repos_, repo.app.name);
	        // This should never happen...
	        if (!appRepos || util_1.safeGet(appRepos, repo.repoInfo_.toURLString()) !== repo) {
	            util_2.fatal("Database " + repo.app.name + "(" + repo.repoInfo_ + ") has already been deleted.");
	        }
	        repo.interrupt();
	        delete appRepos[repo.repoInfo_.toURLString()];
	    };
	    /**
	     * Ensures a repo doesn't already exist and then creates one using the
	     * provided app.
	     *
	     * @param {!RepoInfo} repoInfo The metadata about the Repo
	     * @param {!FirebaseApp} app
	     * @return {!Repo} The Repo object for the specified server / repoName.
	     */
	    RepoManager.prototype.createRepo = function (repoInfo, app) {
	        var appRepos = util_1.safeGet(this.repos_, app.name);
	        if (!appRepos) {
	            appRepos = {};
	            this.repos_[app.name] = appRepos;
	        }
	        var repo = util_1.safeGet(appRepos, repoInfo.toURLString());
	        if (repo) {
	            util_2.fatal('Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.');
	        }
	        repo = new Repo_1.Repo(repoInfo, this.useRestClient_, app);
	        appRepos[repoInfo.toURLString()] = repo;
	        return repo;
	    };
	    /**
	     * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
	     * @param {boolean} forceRestClient
	     */
	    RepoManager.prototype.forceRestClient = function (forceRestClient) {
	        this.useRestClient_ = forceRestClient;
	    };
	    return RepoManager;
	}());
	exports.RepoManager = RepoManager;
	
	//# sourceMappingURL=RepoManager.js.map


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var StatsCollection_1 = __webpack_require__(433);
	var StatsManager = /** @class */ (function () {
	    function StatsManager() {
	    }
	    StatsManager.getCollection = function (repoInfo) {
	        var hashString = repoInfo.toString();
	        if (!this.collections_[hashString]) {
	            this.collections_[hashString] = new StatsCollection_1.StatsCollection();
	        }
	        return this.collections_[hashString];
	    };
	    StatsManager.getOrCreateReporter = function (repoInfo, creatorFunction) {
	        var hashString = repoInfo.toString();
	        if (!this.reporters_[hashString]) {
	            this.reporters_[hashString] = creatorFunction();
	        }
	        return this.reporters_[hashString];
	    };
	    StatsManager.collections_ = {};
	    StatsManager.reporters_ = {};
	    return StatsManager;
	}());
	exports.StatsManager = StatsManager;
	
	//# sourceMappingURL=StatsManager.js.map


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var SortedMap_1 = __webpack_require__(90);
	var Path_1 = __webpack_require__(17);
	var util_1 = __webpack_require__(13);
	var util_2 = __webpack_require__(2);
	var emptyChildrenSingleton;
	/**
	 * Singleton empty children collection.
	 *
	 * @const
	 * @type {!SortedMap.<string, !ImmutableTree.<?>>}
	 */
	var EmptyChildren = function () {
	    if (!emptyChildrenSingleton) {
	        emptyChildrenSingleton = new SortedMap_1.SortedMap(util_1.stringCompare);
	    }
	    return emptyChildrenSingleton;
	};
	/**
	 * A tree with immutable elements.
	 */
	var ImmutableTree = /** @class */ (function () {
	    /**
	     * @template T
	     * @param {?T} value
	     * @param {SortedMap.<string, !ImmutableTree.<T>>=} children
	     */
	    function ImmutableTree(value, children) {
	        if (children === void 0) { children = EmptyChildren(); }
	        this.value = value;
	        this.children = children;
	    }
	    /**
	     * @template T
	     * @param {!Object.<string, !T>} obj
	     * @return {!ImmutableTree.<!T>}
	     */
	    ImmutableTree.fromObject = function (obj) {
	        var tree = ImmutableTree.Empty;
	        util_2.forEach(obj, function (childPath, childSnap) {
	            tree = tree.set(new Path_1.Path(childPath), childSnap);
	        });
	        return tree;
	    };
	    /**
	     * True if the value is empty and there are no children
	     * @return {boolean}
	     */
	    ImmutableTree.prototype.isEmpty = function () {
	        return this.value === null && this.children.isEmpty();
	    };
	    /**
	     * Given a path and predicate, return the first node and the path to that node
	     * where the predicate returns true.
	     *
	     * TODO Do a perf test -- If we're creating a bunch of {path: value:} objects
	     * on the way back out, it may be better to pass down a pathSoFar obj.
	     *
	     * @param {!Path} relativePath The remainder of the path
	     * @param {function(T):boolean} predicate The predicate to satisfy to return a
	     *   node
	     * @return {?{path:!Path, value:!T}}
	     */
	    ImmutableTree.prototype.findRootMostMatchingPathAndValue = function (relativePath, predicate) {
	        if (this.value != null && predicate(this.value)) {
	            return { path: Path_1.Path.Empty, value: this.value };
	        }
	        else {
	            if (relativePath.isEmpty()) {
	                return null;
	            }
	            else {
	                var front = relativePath.getFront();
	                var child = this.children.get(front);
	                if (child !== null) {
	                    var childExistingPathAndValue = child.findRootMostMatchingPathAndValue(relativePath.popFront(), predicate);
	                    if (childExistingPathAndValue != null) {
	                        var fullPath = new Path_1.Path(front).child(childExistingPathAndValue.path);
	                        return { path: fullPath, value: childExistingPathAndValue.value };
	                    }
	                    else {
	                        return null;
	                    }
	                }
	                else {
	                    return null;
	                }
	            }
	        }
	    };
	    /**
	     * Find, if it exists, the shortest subpath of the given path that points a defined
	     * value in the tree
	     * @param {!Path} relativePath
	     * @return {?{path: !Path, value: !T}}
	     */
	    ImmutableTree.prototype.findRootMostValueAndPath = function (relativePath) {
	        return this.findRootMostMatchingPathAndValue(relativePath, function () { return true; });
	    };
	    /**
	     * @param {!Path} relativePath
	     * @return {!ImmutableTree.<T>} The subtree at the given path
	     */
	    ImmutableTree.prototype.subtree = function (relativePath) {
	        if (relativePath.isEmpty()) {
	            return this;
	        }
	        else {
	            var front = relativePath.getFront();
	            var childTree = this.children.get(front);
	            if (childTree !== null) {
	                return childTree.subtree(relativePath.popFront());
	            }
	            else {
	                return ImmutableTree.Empty;
	            }
	        }
	    };
	    /**
	     * Sets a value at the specified path.
	     *
	     * @param {!Path} relativePath Path to set value at.
	     * @param {?T} toSet Value to set.
	     * @return {!ImmutableTree.<T>} Resulting tree.
	     */
	    ImmutableTree.prototype.set = function (relativePath, toSet) {
	        if (relativePath.isEmpty()) {
	            return new ImmutableTree(toSet, this.children);
	        }
	        else {
	            var front = relativePath.getFront();
	            var child = this.children.get(front) || ImmutableTree.Empty;
	            var newChild = child.set(relativePath.popFront(), toSet);
	            var newChildren = this.children.insert(front, newChild);
	            return new ImmutableTree(this.value, newChildren);
	        }
	    };
	    /**
	     * Removes the value at the specified path.
	     *
	     * @param {!Path} relativePath Path to value to remove.
	     * @return {!ImmutableTree.<T>} Resulting tree.
	     */
	    ImmutableTree.prototype.remove = function (relativePath) {
	        if (relativePath.isEmpty()) {
	            if (this.children.isEmpty()) {
	                return ImmutableTree.Empty;
	            }
	            else {
	                return new ImmutableTree(null, this.children);
	            }
	        }
	        else {
	            var front = relativePath.getFront();
	            var child = this.children.get(front);
	            if (child) {
	                var newChild = child.remove(relativePath.popFront());
	                var newChildren = void 0;
	                if (newChild.isEmpty()) {
	                    newChildren = this.children.remove(front);
	                }
	                else {
	                    newChildren = this.children.insert(front, newChild);
	                }
	                if (this.value === null && newChildren.isEmpty()) {
	                    return ImmutableTree.Empty;
	                }
	                else {
	                    return new ImmutableTree(this.value, newChildren);
	                }
	            }
	            else {
	                return this;
	            }
	        }
	    };
	    /**
	     * Gets a value from the tree.
	     *
	     * @param {!Path} relativePath Path to get value for.
	     * @return {?T} Value at path, or null.
	     */
	    ImmutableTree.prototype.get = function (relativePath) {
	        if (relativePath.isEmpty()) {
	            return this.value;
	        }
	        else {
	            var front = relativePath.getFront();
	            var child = this.children.get(front);
	            if (child) {
	                return child.get(relativePath.popFront());
	            }
	            else {
	                return null;
	            }
	        }
	    };
	    /**
	     * Replace the subtree at the specified path with the given new tree.
	     *
	     * @param {!Path} relativePath Path to replace subtree for.
	     * @param {!ImmutableTree} newTree New tree.
	     * @return {!ImmutableTree} Resulting tree.
	     */
	    ImmutableTree.prototype.setTree = function (relativePath, newTree) {
	        if (relativePath.isEmpty()) {
	            return newTree;
	        }
	        else {
	            var front = relativePath.getFront();
	            var child = this.children.get(front) || ImmutableTree.Empty;
	            var newChild = child.setTree(relativePath.popFront(), newTree);
	            var newChildren = void 0;
	            if (newChild.isEmpty()) {
	                newChildren = this.children.remove(front);
	            }
	            else {
	                newChildren = this.children.insert(front, newChild);
	            }
	            return new ImmutableTree(this.value, newChildren);
	        }
	    };
	    /**
	     * Performs a depth first fold on this tree. Transforms a tree into a single
	     * value, given a function that operates on the path to a node, an optional
	     * current value, and a map of child names to folded subtrees
	     * @template V
	     * @param {function(Path, ?T, Object.<string, V>):V} fn
	     * @return {V}
	     */
	    ImmutableTree.prototype.fold = function (fn) {
	        return this.fold_(Path_1.Path.Empty, fn);
	    };
	    /**
	     * Recursive helper for public-facing fold() method
	     * @template V
	     * @param {!Path} pathSoFar
	     * @param {function(Path, ?T, Object.<string, V>):V} fn
	     * @return {V}
	     * @private
	     */
	    ImmutableTree.prototype.fold_ = function (pathSoFar, fn) {
	        var accum = {};
	        this.children.inorderTraversal(function (childKey, childTree) {
	            accum[childKey] = childTree.fold_(pathSoFar.child(childKey), fn);
	        });
	        return fn(pathSoFar, this.value, accum);
	    };
	    /**
	     * Find the first matching value on the given path. Return the result of applying f to it.
	     * @template V
	     * @param {!Path} path
	     * @param {!function(!Path, !T):?V} f
	     * @return {?V}
	     */
	    ImmutableTree.prototype.findOnPath = function (path, f) {
	        return this.findOnPath_(path, Path_1.Path.Empty, f);
	    };
	    ImmutableTree.prototype.findOnPath_ = function (pathToFollow, pathSoFar, f) {
	        var result = this.value ? f(pathSoFar, this.value) : false;
	        if (result) {
	            return result;
	        }
	        else {
	            if (pathToFollow.isEmpty()) {
	                return null;
	            }
	            else {
	                var front = pathToFollow.getFront();
	                var nextChild = this.children.get(front);
	                if (nextChild) {
	                    return nextChild.findOnPath_(pathToFollow.popFront(), pathSoFar.child(front), f);
	                }
	                else {
	                    return null;
	                }
	            }
	        }
	    };
	    /**
	     *
	     * @param {!Path} path
	     * @param {!function(!Path, !T)} f
	     * @returns {!ImmutableTree.<T>}
	     */
	    ImmutableTree.prototype.foreachOnPath = function (path, f) {
	        return this.foreachOnPath_(path, Path_1.Path.Empty, f);
	    };
	    ImmutableTree.prototype.foreachOnPath_ = function (pathToFollow, currentRelativePath, f) {
	        if (pathToFollow.isEmpty()) {
	            return this;
	        }
	        else {
	            if (this.value) {
	                f(currentRelativePath, this.value);
	            }
	            var front = pathToFollow.getFront();
	            var nextChild = this.children.get(front);
	            if (nextChild) {
	                return nextChild.foreachOnPath_(pathToFollow.popFront(), currentRelativePath.child(front), f);
	            }
	            else {
	                return ImmutableTree.Empty;
	            }
	        }
	    };
	    /**
	     * Calls the given function for each node in the tree that has a value.
	     *
	     * @param {function(!Path, !T)} f A function to be called with
	     *   the path from the root of the tree to a node, and the value at that node.
	     *   Called in depth-first order.
	     */
	    ImmutableTree.prototype.foreach = function (f) {
	        this.foreach_(Path_1.Path.Empty, f);
	    };
	    ImmutableTree.prototype.foreach_ = function (currentRelativePath, f) {
	        this.children.inorderTraversal(function (childName, childTree) {
	            childTree.foreach_(currentRelativePath.child(childName), f);
	        });
	        if (this.value) {
	            f(currentRelativePath, this.value);
	        }
	    };
	    /**
	     *
	     * @param {function(string, !T)} f
	     */
	    ImmutableTree.prototype.foreachChild = function (f) {
	        this.children.inorderTraversal(function (childName, childTree) {
	            if (childTree.value) {
	                f(childName, childTree.value);
	            }
	        });
	    };
	    ImmutableTree.Empty = new ImmutableTree(null);
	    return ImmutableTree;
	}());
	exports.ImmutableTree = ImmutableTree;
	
	//# sourceMappingURL=ImmutableTree.js.map


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var Change_1 = __webpack_require__(54);
	var ChildrenNode_1 = __webpack_require__(28);
	var PriorityIndex_1 = __webpack_require__(26);
	/**
	 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
	 *
	 * @constructor
	 * @implements {NodeFilter}
	 * @param {!Index} index
	 */
	var IndexedFilter = /** @class */ (function () {
	    function IndexedFilter(index_) {
	        this.index_ = index_;
	    }
	    IndexedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
	        util_1.assert(snap.isIndexed(this.index_), 'A node must be indexed if only a child is updated');
	        var oldChild = snap.getImmediateChild(key);
	        // Check if anything actually changed.
	        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
	            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
	            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
	            // to avoid treating these cases as "nothing changed."
	            if (oldChild.isEmpty() == newChild.isEmpty()) {
	                // Nothing changed.
	                // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
	                //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
	                return snap;
	            }
	        }
	        if (optChangeAccumulator != null) {
	            if (newChild.isEmpty()) {
	                if (snap.hasChild(key)) {
	                    optChangeAccumulator.trackChildChange(Change_1.Change.childRemovedChange(key, oldChild));
	                }
	                else {
	                    util_1.assert(snap.isLeafNode(), 'A child remove without an old child only makes sense on a leaf node');
	                }
	            }
	            else if (oldChild.isEmpty()) {
	                optChangeAccumulator.trackChildChange(Change_1.Change.childAddedChange(key, newChild));
	            }
	            else {
	                optChangeAccumulator.trackChildChange(Change_1.Change.childChangedChange(key, newChild, oldChild));
	            }
	        }
	        if (snap.isLeafNode() && newChild.isEmpty()) {
	            return snap;
	        }
	        else {
	            // Make sure the node is indexed
	            return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
	        if (optChangeAccumulator != null) {
	            if (!oldSnap.isLeafNode()) {
	                oldSnap.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (key, childNode) {
	                    if (!newSnap.hasChild(key)) {
	                        optChangeAccumulator.trackChildChange(Change_1.Change.childRemovedChange(key, childNode));
	                    }
	                });
	            }
	            if (!newSnap.isLeafNode()) {
	                newSnap.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (key, childNode) {
	                    if (oldSnap.hasChild(key)) {
	                        var oldChild = oldSnap.getImmediateChild(key);
	                        if (!oldChild.equals(childNode)) {
	                            optChangeAccumulator.trackChildChange(Change_1.Change.childChangedChange(key, childNode, oldChild));
	                        }
	                    }
	                    else {
	                        optChangeAccumulator.trackChildChange(Change_1.Change.childAddedChange(key, childNode));
	                    }
	                });
	            }
	        }
	        return newSnap.withIndex(this.index_);
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
	        if (oldSnap.isEmpty()) {
	            return ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	        }
	        else {
	            return oldSnap.updatePriority(newPriority);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.filtersNodes = function () {
	        return false;
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.getIndexedFilter = function () {
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.getIndex = function () {
	        return this.index_;
	    };
	    return IndexedFilter;
	}());
	exports.IndexedFilter = IndexedFilter;
	
	//# sourceMappingURL=IndexedFilter.js.map


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var platform_1 = __webpack_require__(40);
	var api_1 = __webpack_require__(128);
	var error_1 = __webpack_require__(19);
	var input_validation_1 = __webpack_require__(72);
	var misc_1 = __webpack_require__(25);
	/** Helper function to assert Uint8Array is available at runtime. */
	function assertUint8ArrayAvailable() {
	    if (typeof Uint8Array === 'undefined') {
	        throw new error_1.FirestoreError(error_1.Code.UNIMPLEMENTED, 'Uint8Arrays are not available in this environment.');
	    }
	}
	/** Helper function to assert Base64 functions are available at runtime. */
	function assertBase64Available() {
	    if (!platform_1.PlatformSupport.getPlatform().base64Available) {
	        throw new error_1.FirestoreError(error_1.Code.UNIMPLEMENTED, 'Blobs are unavailable in Firestore in this environment.');
	    }
	}
	/**
	 * Immutable class holding a blob (binary data).
	 * This class is directly exposed in the public API.
	 *
	 * Note that while you can't hide the constructor in JavaScript code, we are
	 * using the hack above to make sure no-one outside this module can call it.
	 */
	var Blob = /** @class */ (function () {
	    function Blob(binaryString) {
	        assertBase64Available();
	        this._binaryString = binaryString;
	    }
	    Blob.fromBase64String = function (base64) {
	        input_validation_1.validateExactNumberOfArgs('Blob.fromBase64String', arguments, 1);
	        input_validation_1.validateArgType('Blob.fromBase64String', 'string', 1, base64);
	        assertBase64Available();
	        try {
	            var binaryString = platform_1.PlatformSupport.getPlatform().atob(base64);
	            return new Blob(binaryString);
	        }
	        catch (e) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Failed to construct Blob from Base64 string: ' + e);
	        }
	    };
	    Blob.fromUint8Array = function (array) {
	        input_validation_1.validateExactNumberOfArgs('Blob.fromUint8Array', arguments, 1);
	        assertUint8ArrayAvailable();
	        if (!(array instanceof Uint8Array)) {
	            throw input_validation_1.invalidClassError('Blob.fromUint8Array', 'Uint8Array', 1, array);
	        }
	        // We can't call array.map directly because it expects the return type to
	        // be a Uint8Array, whereas we can convert it to a regular array by invoking
	        // map on the Array prototype.
	        var binaryString = Array.prototype.map
	            .call(array, function (char) {
	            return String.fromCharCode(char);
	        })
	            .join('');
	        return new Blob(binaryString);
	    };
	    Blob.prototype.toBase64 = function () {
	        input_validation_1.validateExactNumberOfArgs('Blob.toBase64', arguments, 0);
	        assertBase64Available();
	        return platform_1.PlatformSupport.getPlatform().btoa(this._binaryString);
	    };
	    Blob.prototype.toUint8Array = function () {
	        input_validation_1.validateExactNumberOfArgs('Blob.toUint8Array', arguments, 0);
	        assertUint8ArrayAvailable();
	        var buffer = new Uint8Array(this._binaryString.length);
	        for (var i = 0; i < this._binaryString.length; i++) {
	            buffer[i] = this._binaryString.charCodeAt(i);
	        }
	        return buffer;
	    };
	    Blob.prototype.toString = function () {
	        return 'Blob(base64: ' + this.toBase64() + ')';
	    };
	    /**
	     * Actually private to JS consumers of our API, so this function is prefixed
	     * with an underscore.
	     */
	    Blob.prototype._equals = function (other) {
	        return this._binaryString === other._binaryString;
	    };
	    /**
	     * Actually private to JS consumers of our API, so this function is prefixed
	     * with an underscore.
	     */
	    Blob.prototype._compareTo = function (other) {
	        return misc_1.primitiveComparator(this._binaryString, other._binaryString);
	    };
	    return Blob;
	}());
	exports.Blob = Blob;
	// Public instance that disallows construction at runtime. This constructor is
	// used when exporting Blob on firebase.firestore.Blob and will be called Blob
	// publicly. Internally we still use Blob which has a type checked private
	// constructor. Note that Blob and PublicBlob can be used interchangeably in
	// instanceof checks.
	// For our internal TypeScript code PublicBlob doesn't exist as a type, and so
	// we need to use Blob as type and export it too.
	// tslint:disable-next-line:variable-name We're treating this as a class name.
	exports.PublicBlob = api_1.makeConstructorPrivate(Blob, 'Use Blob.fromUint8Array() or Blob.fromBase64String() instead.');
	
	//# sourceMappingURL=blob.js.map


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var path_1 = __webpack_require__(49);
	var error_1 = __webpack_require__(19);
	var input_validation_1 = __webpack_require__(72);
	// The objects that are a part of this API are exposed to third-parties as
	// compiled javascript so we want to flag our private members with a leading
	// underscore to discourage their use.
	// tslint:disable:strip-private-property-underscore
	/**
	 * A FieldPath refers to a field in a document. The path may consist of a single
	 * field name (referring to a top-level field in the document), or a list of
	 * field names (referring to a nested field in the document).
	 */
	var FieldPath = /** @class */ (function () {
	    /**
	     * Creates a FieldPath from the provided field names. If more than one field
	     * name is provided, the path will point to a nested field in a document.
	     *
	     * @param fieldNames A list of field names.
	     */
	    function FieldPath() {
	        var fieldNames = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            fieldNames[_i] = arguments[_i];
	        }
	        input_validation_1.validateNamedArrayAtLeastNumberOfElements('FieldPath', fieldNames, 'fieldNames', 1);
	        for (var i = 0; i < fieldNames.length; ++i) {
	            input_validation_1.validateArgType('FieldPath', 'string', i, fieldNames[i]);
	            if (fieldNames[i].length === 0) {
	                throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). " +
	                    'Field names must not be empty.');
	            }
	        }
	        this._internalPath = new path_1.FieldPath(fieldNames);
	    }
	    FieldPath.documentId = function () {
	        return FieldPath._DOCUMENT_ID;
	    };
	    /**
	     * Internal Note: The backend doesn't technically support querying by
	     * document ID. Instead it queries by the entire document name (full path
	     * included), but in the cases we currently support documentId(), the net
	     * effect is the same.
	     */
	    FieldPath._DOCUMENT_ID = new FieldPath(path_1.FieldPath.keyField().canonicalString());
	    return FieldPath;
	}());
	exports.FieldPath = FieldPath;
	/**
	 * Matches any characters in a field path string that are reserved.
	 */
	var RESERVED = new RegExp('[~\\*/\\[\\]]');
	/**
	 * Parses a field path string into a FieldPath, treating dots as separators.
	 */
	function fromDotSeparatedString(path) {
	    var found = path.search(RESERVED);
	    if (found >= 0) {
	        throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not contain " +
	            "'~', '*', '/', '[', or ']'");
	    }
	    try {
	        return new (FieldPath.bind.apply(FieldPath, [void 0].concat(path.split('.'))))();
	    }
	    catch (e) {
	        throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not be empty, " +
	            "begin with '.', end with '.', or contain '..'");
	    }
	}
	exports.fromDotSeparatedString = fromDotSeparatedString;
	
	//# sourceMappingURL=field_path.js.map


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var error_1 = __webpack_require__(19);
	var input_validation_1 = __webpack_require__(72);
	var misc_1 = __webpack_require__(25);
	/**
	 * Immutable class representing a geo point as latitude-longitude pair.
	 * This class is directly exposed in the public API, including its constructor.
	 */
	var GeoPoint = /** @class */ (function () {
	    function GeoPoint(latitude, longitude) {
	        input_validation_1.validateExactNumberOfArgs('GeoPoint', arguments, 2);
	        input_validation_1.validateArgType('GeoPoint', 'number', 1, latitude);
	        input_validation_1.validateArgType('GeoPoint', 'number', 2, longitude);
	        if (!isFinite(latitude) || latitude < -90 || latitude > 90) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Latitude must be a number between -90 and 90, but was: ' + latitude);
	        }
	        if (!isFinite(longitude) || longitude < -180 || longitude > 180) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Longitude must be a number between -180 and 180, but was: ' + longitude);
	        }
	        this._lat = latitude;
	        this._long = longitude;
	    }
	    Object.defineProperty(GeoPoint.prototype, "latitude", {
	        /**
	         * Returns the latitude of this geo point, a number between -90 and 90.
	         */
	        get: function () {
	            return this._lat;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GeoPoint.prototype, "longitude", {
	        /**
	         * Returns the longitude of this geo point, a number between -180 and 180.
	         */
	        get: function () {
	            return this._long;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Actually private to JS consumers of our API, so this function is prefixed
	     * with an underscore.
	     */
	    GeoPoint.prototype._equals = function (other) {
	        return this._lat === other._lat && this._long === other._long;
	    };
	    /**
	     * Actually private to JS consumers of our API, so this function is prefixed
	     * with an underscore.
	     */
	    GeoPoint.prototype._compareTo = function (other) {
	        return (misc_1.primitiveComparator(this._lat, other._lat) ||
	            misc_1.primitiveComparator(this._long, other._long));
	    };
	    return GeoPoint;
	}());
	exports.GeoPoint = GeoPoint;
	
	//# sourceMappingURL=geo_point.js.map


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var document_1 = __webpack_require__(32);
	var document_key_1 = __webpack_require__(22);
	var field_value_1 = __webpack_require__(57);
	var path_1 = __webpack_require__(49);
	var assert_1 = __webpack_require__(10);
	var error_1 = __webpack_require__(19);
	var types_1 = __webpack_require__(73);
	var Query = /** @class */ (function () {
	    function Query(path, explicitOrderBy, filters, limit, startAt, endAt) {
	        if (explicitOrderBy === void 0) { explicitOrderBy = []; }
	        if (filters === void 0) { filters = []; }
	        if (limit === void 0) { limit = null; }
	        if (startAt === void 0) { startAt = null; }
	        if (endAt === void 0) { endAt = null; }
	        this.path = path;
	        this.explicitOrderBy = explicitOrderBy;
	        this.filters = filters;
	        this.limit = limit;
	        this.startAt = startAt;
	        this.endAt = endAt;
	        this.memoizedCanonicalId = null;
	        this.memoizedOrderBy = null;
	        if (this.startAt) {
	            this.assertValidBound(this.startAt);
	        }
	        if (this.endAt) {
	            this.assertValidBound(this.endAt);
	        }
	    }
	    Query.atPath = function (path) {
	        return new Query(path);
	    };
	    Object.defineProperty(Query.prototype, "orderBy", {
	        get: function () {
	            if (this.memoizedOrderBy === null) {
	                var inequalityField = this.getInequalityFilterField();
	                var firstOrderByField = this.getFirstOrderByField();
	                if (inequalityField !== null && firstOrderByField === null) {
	                    // In order to implicitly add key ordering, we must also add the
	                    // inequality filter field for it to be a valid query.
	                    // Note that the default inequality field and key ordering is ascending.
	                    if (inequalityField.isKeyField()) {
	                        this.memoizedOrderBy = [KEY_ORDERING_ASC];
	                    }
	                    else {
	                        this.memoizedOrderBy = [
	                            new OrderBy(inequalityField),
	                            KEY_ORDERING_ASC
	                        ];
	                    }
	                }
	                else {
	                    assert_1.assert(inequalityField === null ||
	                        (firstOrderByField !== null &&
	                            inequalityField.equals(firstOrderByField)), 'First orderBy should match inequality field.');
	                    this.memoizedOrderBy = [];
	                    var foundKeyOrdering = false;
	                    for (var _i = 0, _a = this.explicitOrderBy; _i < _a.length; _i++) {
	                        var orderBy = _a[_i];
	                        this.memoizedOrderBy.push(orderBy);
	                        if (orderBy.field.isKeyField()) {
	                            foundKeyOrdering = true;
	                        }
	                    }
	                    if (!foundKeyOrdering) {
	                        // The order of the implicit key ordering always matches the last
	                        // explicit order by
	                        var lastDirection = this.explicitOrderBy.length > 0
	                            ? this.explicitOrderBy[this.explicitOrderBy.length - 1].dir
	                            : Direction.ASCENDING;
	                        this.memoizedOrderBy.push(lastDirection === Direction.ASCENDING
	                            ? KEY_ORDERING_ASC
	                            : KEY_ORDERING_DESC);
	                    }
	                }
	            }
	            return this.memoizedOrderBy;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Query.prototype.addFilter = function (filter) {
	        assert_1.assert(this.getInequalityFilterField() == null ||
	            !(filter instanceof RelationFilter) ||
	            !filter.isInequality() ||
	            filter.field.equals(this.getInequalityFilterField()), 'Query must only have one inequality field.');
	        assert_1.assert(!document_key_1.DocumentKey.isDocumentKey(this.path), 'No filtering allowed for document query');
	        var newFilters = this.filters.concat([filter]);
	        return new Query(this.path, this.explicitOrderBy.slice(), newFilters, this.limit, this.startAt, this.endAt);
	    };
	    Query.prototype.addOrderBy = function (orderBy) {
	        assert_1.assert(!document_key_1.DocumentKey.isDocumentKey(this.path), 'No ordering allowed for document query');
	        assert_1.assert(!this.startAt && !this.endAt, 'Bounds must be set after orderBy');
	        // TODO(dimond): validate that orderBy does not list the same key twice.
	        var newOrderBy = this.explicitOrderBy.concat([orderBy]);
	        return new Query(this.path, newOrderBy, this.filters.slice(), this.limit, this.startAt, this.endAt);
	    };
	    Query.prototype.withLimit = function (limit) {
	        return new Query(this.path, this.explicitOrderBy.slice(), this.filters.slice(), limit, this.startAt, this.endAt);
	    };
	    Query.prototype.withStartAt = function (bound) {
	        return new Query(this.path, this.explicitOrderBy.slice(), this.filters.slice(), this.limit, bound, this.endAt);
	    };
	    Query.prototype.withEndAt = function (bound) {
	        return new Query(this.path, this.explicitOrderBy.slice(), this.filters.slice(), this.limit, this.startAt, bound);
	    };
	    // TODO(b/29183165): This is used to get a unique string from a query to, for
	    // example, use as a dictionary key, but the implementation is subject to
	    // collisions. Make it collision-free.
	    Query.prototype.canonicalId = function () {
	        if (this.memoizedCanonicalId === null) {
	            var canonicalId = this.path.canonicalString();
	            canonicalId += '|f:';
	            for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
	                var filter = _a[_i];
	                canonicalId += filter.canonicalId();
	                canonicalId += ',';
	            }
	            canonicalId += '|ob:';
	            // TODO(dimond): make this collision resistant
	            for (var _b = 0, _c = this.orderBy; _b < _c.length; _b++) {
	                var orderBy = _c[_b];
	                canonicalId += orderBy.canonicalId();
	                canonicalId += ',';
	            }
	            if (!types_1.isNullOrUndefined(this.limit)) {
	                canonicalId += '|l:';
	                canonicalId += this.limit;
	            }
	            if (this.startAt) {
	                canonicalId += '|lb:';
	                canonicalId += this.startAt.canonicalId();
	            }
	            if (this.endAt) {
	                canonicalId += '|ub:';
	                canonicalId += this.endAt.canonicalId();
	            }
	            this.memoizedCanonicalId = canonicalId;
	        }
	        return this.memoizedCanonicalId;
	    };
	    Query.prototype.toString = function () {
	        var str = 'Query(' + this.path.canonicalString();
	        if (this.filters.length > 0) {
	            str += ", filters: [" + this.filters.join(', ') + "]";
	        }
	        if (!types_1.isNullOrUndefined(this.limit)) {
	            str += ', limit: ' + this.limit;
	        }
	        if (this.explicitOrderBy.length > 0) {
	            str += ", orderBy: [" + this.explicitOrderBy.join(', ') + "]";
	        }
	        if (this.startAt) {
	            str += ', startAt: ' + this.startAt.canonicalId();
	        }
	        if (this.endAt) {
	            str += ', endAt: ' + this.endAt.canonicalId();
	        }
	        return str + ')';
	    };
	    Query.prototype.equals = function (other) {
	        if (this.limit !== other.limit) {
	            return false;
	        }
	        if (this.orderBy.length !== other.orderBy.length) {
	            return false;
	        }
	        for (var i = 0; i < this.orderBy.length; i++) {
	            if (!this.orderBy[i].equals(other.orderBy[i])) {
	                return false;
	            }
	        }
	        if (this.filters.length !== other.filters.length) {
	            return false;
	        }
	        for (var i = 0; i < this.filters.length; i++) {
	            if (!this.filters[i].equals(other.filters[i])) {
	                return false;
	            }
	        }
	        if (!this.path.equals(other.path)) {
	            return false;
	        }
	        if (this.startAt !== null
	            ? !this.startAt.equals(other.startAt)
	            : other.startAt !== null) {
	            return false;
	        }
	        return this.endAt !== null
	            ? this.endAt.equals(other.endAt)
	            : other.endAt === null;
	    };
	    Query.prototype.docComparator = function (d1, d2) {
	        var comparedOnKeyField = false;
	        for (var _i = 0, _a = this.orderBy; _i < _a.length; _i++) {
	            var orderBy = _a[_i];
	            var comp = orderBy.compare(d1, d2);
	            if (comp !== 0)
	                return comp;
	            comparedOnKeyField = comparedOnKeyField || orderBy.field.isKeyField();
	        }
	        // Assert that we actually compared by key
	        assert_1.assert(comparedOnKeyField, "orderBy used that doesn't compare on key field");
	        return 0;
	    };
	    Query.prototype.matches = function (doc) {
	        return (this.matchesAncestor(doc) &&
	            this.matchesOrderBy(doc) &&
	            this.matchesFilters(doc) &&
	            this.matchesBounds(doc));
	    };
	    Query.prototype.hasLimit = function () {
	        return !types_1.isNullOrUndefined(this.limit);
	    };
	    Query.prototype.getFirstOrderByField = function () {
	        return this.explicitOrderBy.length > 0
	            ? this.explicitOrderBy[0].field
	            : null;
	    };
	    Query.prototype.getInequalityFilterField = function () {
	        for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
	            var filter = _a[_i];
	            if (filter instanceof RelationFilter && filter.isInequality()) {
	                return filter.field;
	            }
	        }
	        return null;
	    };
	    Query.prototype.isDocumentQuery = function () {
	        return document_key_1.DocumentKey.isDocumentKey(this.path) && this.filters.length === 0;
	    };
	    Query.prototype.matchesAncestor = function (doc) {
	        var docPath = doc.key.path;
	        if (document_key_1.DocumentKey.isDocumentKey(this.path)) {
	            // exact match for document queries
	            return this.path.equals(docPath);
	        }
	        else {
	            // shallow ancestor queries by default
	            return (this.path.isPrefixOf(docPath) && this.path.length === docPath.length - 1);
	        }
	    };
	    /**
	     * A document must have a value for every ordering clause in order to show up
	     * in the results.
	     */
	    Query.prototype.matchesOrderBy = function (doc) {
	        for (var _i = 0, _a = this.explicitOrderBy; _i < _a.length; _i++) {
	            var orderBy = _a[_i];
	            // order by key always matches
	            if (!orderBy.field.isKeyField() &&
	                doc.field(orderBy.field) === undefined) {
	                return false;
	            }
	        }
	        return true;
	    };
	    Query.prototype.matchesFilters = function (doc) {
	        for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
	            var filter = _a[_i];
	            if (!filter.matches(doc)) {
	                return false;
	            }
	        }
	        return true;
	    };
	    /**
	     * Makes sure a document is within the bounds, if provided.
	     */
	    Query.prototype.matchesBounds = function (doc) {
	        if (this.startAt && !this.startAt.sortsBeforeDocument(this.orderBy, doc)) {
	            return false;
	        }
	        if (this.endAt && this.endAt.sortsBeforeDocument(this.orderBy, doc)) {
	            return false;
	        }
	        return true;
	    };
	    Query.prototype.assertValidBound = function (bound) {
	        assert_1.assert(bound.position.length <= this.orderBy.length, 'Bound is longer than orderBy');
	    };
	    return Query;
	}());
	exports.Query = Query;
	var RelationOp = /** @class */ (function () {
	    function RelationOp(name) {
	        this.name = name;
	    }
	    RelationOp.fromString = function (op) {
	        switch (op) {
	            case '<':
	                return RelationOp.LESS_THAN;
	            case '<=':
	                return RelationOp.LESS_THAN_OR_EQUAL;
	            case '==':
	                return RelationOp.EQUAL;
	            case '>=':
	                return RelationOp.GREATER_THAN_OR_EQUAL;
	            case '>':
	                return RelationOp.GREATER_THAN;
	            default:
	                return assert_1.fail('Unknown relation: ' + op);
	        }
	    };
	    RelationOp.prototype.toString = function () {
	        return this.name;
	    };
	    RelationOp.prototype.equals = function (other) {
	        return this.name === other.name;
	    };
	    RelationOp.LESS_THAN = new RelationOp('<');
	    RelationOp.LESS_THAN_OR_EQUAL = new RelationOp('<=');
	    RelationOp.EQUAL = new RelationOp('==');
	    RelationOp.GREATER_THAN = new RelationOp('>');
	    RelationOp.GREATER_THAN_OR_EQUAL = new RelationOp('>=');
	    return RelationOp;
	}());
	exports.RelationOp = RelationOp;
	var RelationFilter = /** @class */ (function () {
	    function RelationFilter(field, op, value) {
	        this.field = field;
	        this.op = op;
	        this.value = value;
	    }
	    RelationFilter.prototype.matches = function (doc) {
	        if (this.field.isKeyField()) {
	            assert_1.assert(this.value instanceof field_value_1.RefValue, 'Comparing on key, but filter value not a RefValue');
	            var refValue = this.value;
	            var comparison = document_key_1.DocumentKey.comparator(doc.key, refValue.key);
	            return this.matchesComparison(comparison);
	        }
	        else {
	            var val = doc.field(this.field);
	            return val !== undefined && this.matchesValue(val);
	        }
	    };
	    RelationFilter.prototype.matchesValue = function (value) {
	        // Only compare types with matching backend order (such as double and int).
	        if (this.value.typeOrder !== value.typeOrder) {
	            return false;
	        }
	        return this.matchesComparison(value.compareTo(this.value));
	    };
	    RelationFilter.prototype.matchesComparison = function (comparison) {
	        switch (this.op) {
	            case RelationOp.LESS_THAN:
	                return comparison < 0;
	            case RelationOp.LESS_THAN_OR_EQUAL:
	                return comparison <= 0;
	            case RelationOp.EQUAL:
	                return comparison === 0;
	            case RelationOp.GREATER_THAN:
	                return comparison > 0;
	            case RelationOp.GREATER_THAN_OR_EQUAL:
	                return comparison >= 0;
	            default:
	                return assert_1.fail('Unknown relation op' + this.op);
	        }
	    };
	    RelationFilter.prototype.isInequality = function () {
	        return this.op !== RelationOp.EQUAL;
	    };
	    RelationFilter.prototype.canonicalId = function () {
	        // TODO(b/29183165): Technically, this won't be unique if two values have
	        // the same description, such as the int 3 and the string "3". So we should
	        // add the types in here somehow, too.
	        return (this.field.canonicalString() + this.op.toString() + this.value.toString());
	    };
	    RelationFilter.prototype.equals = function (other) {
	        if (other instanceof RelationFilter) {
	            return (this.op.equals(other.op) &&
	                this.field.equals(other.field) &&
	                this.value.equals(other.value));
	        }
	        else {
	            return false;
	        }
	    };
	    RelationFilter.prototype.toString = function () {
	        return this.field.canonicalString() + " " + this.op + " " + this.value.value();
	    };
	    return RelationFilter;
	}());
	exports.RelationFilter = RelationFilter;
	/**
	 * Filter that matches 'null' values.
	 */
	var NullFilter = /** @class */ (function () {
	    function NullFilter(field) {
	        this.field = field;
	    }
	    NullFilter.prototype.matches = function (doc) {
	        var val = doc.field(this.field);
	        return val !== undefined && val.value() === null;
	    };
	    NullFilter.prototype.canonicalId = function () {
	        return this.field.canonicalString() + ' IS null';
	    };
	    NullFilter.prototype.toString = function () {
	        return this.field.canonicalString() + " IS null";
	    };
	    NullFilter.prototype.equals = function (other) {
	        if (other instanceof NullFilter) {
	            return this.field.equals(other.field);
	        }
	        else {
	            return false;
	        }
	    };
	    return NullFilter;
	}());
	exports.NullFilter = NullFilter;
	/**
	 * Filter that matches 'NaN' values.
	 */
	var NanFilter = /** @class */ (function () {
	    function NanFilter(field) {
	        this.field = field;
	    }
	    NanFilter.prototype.matches = function (doc) {
	        var val = doc.field(this.field).value();
	        return typeof val === 'number' && isNaN(val);
	    };
	    NanFilter.prototype.canonicalId = function () {
	        return this.field.canonicalString() + ' IS NaN';
	    };
	    NanFilter.prototype.toString = function () {
	        return this.field.canonicalString() + " IS NaN";
	    };
	    NanFilter.prototype.equals = function (other) {
	        if (other instanceof NanFilter) {
	            return this.field.equals(other.field);
	        }
	        else {
	            return false;
	        }
	    };
	    return NanFilter;
	}());
	exports.NanFilter = NanFilter;
	/**
	 * Creates a filter based on the provided arguments.
	 */
	function fieldFilter(field, op, value) {
	    if (value.equals(field_value_1.NullValue.INSTANCE)) {
	        if (op !== RelationOp.EQUAL) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Invalid query. You can only perform equals ' + 'comparisons on null.');
	        }
	        return new NullFilter(field);
	    }
	    else if (value.equals(field_value_1.DoubleValue.NAN)) {
	        if (op !== RelationOp.EQUAL) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Invalid query. You can only perform equals ' + 'comparisons on NaN.');
	        }
	        return new NanFilter(field);
	    }
	    else {
	        return new RelationFilter(field, op, value);
	    }
	}
	exports.fieldFilter = fieldFilter;
	/**
	 * The direction of sorting in an order by.
	 */
	var Direction = /** @class */ (function () {
	    function Direction(name) {
	        this.name = name;
	    }
	    Direction.prototype.toString = function () {
	        return this.name;
	    };
	    Direction.ASCENDING = new Direction('asc');
	    Direction.DESCENDING = new Direction('desc');
	    return Direction;
	}());
	exports.Direction = Direction;
	/**
	 * Represents a bound of a query.
	 *
	 * The bound is specified with the given components representing a position and
	 * whether it's just before or just after the position (relative to whatever the
	 * query order is).
	 *
	 * The position represents a logical index position for a query. It's a prefix
	 * of values for the (potentially implicit) order by clauses of a query.
	 *
	 * Bound provides a function to determine whether a document comes before or
	 * after a bound. This is influenced by whether the position is just before or
	 * just after the provided values.
	 */
	var Bound = /** @class */ (function () {
	    function Bound(position, before) {
	        this.position = position;
	        this.before = before;
	    }
	    Bound.prototype.canonicalId = function () {
	        // TODO(b/29183165): Make this collision robust.
	        var canonicalId = this.before ? 'b:' : 'a:';
	        for (var _i = 0, _a = this.position; _i < _a.length; _i++) {
	            var component = _a[_i];
	            canonicalId += component.toString();
	        }
	        return canonicalId;
	    };
	    /**
	     * Returns true if a document sorts before a bound using the provided sort
	     * order.
	     */
	    Bound.prototype.sortsBeforeDocument = function (orderBy, doc) {
	        assert_1.assert(this.position.length <= orderBy.length, "Bound has more components than query's orderBy");
	        var comparison = 0;
	        for (var i = 0; i < this.position.length; i++) {
	            var orderByComponent = orderBy[i];
	            var component = this.position[i];
	            if (orderByComponent.field.isKeyField()) {
	                assert_1.assert(component instanceof field_value_1.RefValue, 'Bound has a non-key value where the key path is being used.');
	                comparison = document_key_1.DocumentKey.comparator(component.key, doc.key);
	            }
	            else {
	                var docValue = doc.field(orderByComponent.field);
	                assert_1.assert(docValue !== undefined, 'Field should exist since document matched the orderBy already.');
	                comparison = component.compareTo(docValue);
	            }
	            if (orderByComponent.dir === Direction.DESCENDING) {
	                comparison = comparison * -1;
	            }
	            if (comparison !== 0) {
	                break;
	            }
	        }
	        return this.before ? comparison <= 0 : comparison < 0;
	    };
	    Bound.prototype.equals = function (other) {
	        if (other === null) {
	            return false;
	        }
	        if (this.before !== other.before ||
	            this.position.length !== other.position.length) {
	            return false;
	        }
	        for (var i = 0; i < this.position.length; i++) {
	            var thisPosition = this.position[i];
	            var otherPosition = other.position[i];
	            return thisPosition.equals(otherPosition);
	        }
	        return true;
	    };
	    return Bound;
	}());
	exports.Bound = Bound;
	/**
	 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
	 */
	var OrderBy = /** @class */ (function () {
	    function OrderBy(field, dir) {
	        this.field = field;
	        if (dir === undefined) {
	            dir = Direction.ASCENDING;
	        }
	        this.dir = dir;
	        this.isKeyOrderBy = field.isKeyField();
	    }
	    OrderBy.prototype.compare = function (d1, d2) {
	        var comparison = this.isKeyOrderBy
	            ? document_1.Document.compareByKey(d1, d2)
	            : document_1.Document.compareByField(this.field, d1, d2);
	        switch (this.dir) {
	            case Direction.ASCENDING:
	                return comparison;
	            case Direction.DESCENDING:
	                return -1 * comparison;
	            default:
	                return assert_1.fail('Unknown direction: ' + this.dir);
	        }
	    };
	    OrderBy.prototype.canonicalId = function () {
	        // TODO(b/29183165): Make this collision robust.
	        return this.field.canonicalString() + this.dir.toString();
	    };
	    OrderBy.prototype.toString = function () {
	        return this.field.canonicalString() + " (" + this.dir + ")";
	    };
	    OrderBy.prototype.equals = function (other) {
	        return this.dir === other.dir && this.field.equals(other.field);
	    };
	    return OrderBy;
	}());
	exports.OrderBy = OrderBy;
	var KEY_ORDERING_ASC = new OrderBy(path_1.FieldPath.keyField(), Direction.ASCENDING);
	var KEY_ORDERING_DESC = new OrderBy(path_1.FieldPath.keyField(), Direction.DESCENDING);
	
	//# sourceMappingURL=query.js.map


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var app_1 = __webpack_require__(35);
	/** The semver (www.semver.org) version of the SDK. */
	exports.SDK_VERSION = app_1.default.SDK_VERSION;
	
	//# sourceMappingURL=version.js.map


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var path_1 = __webpack_require__(49);
	var assert_1 = __webpack_require__(10);
	var escapeChar = '\u0001';
	var encodedSeparatorChar = '\u0001';
	var encodedNul = '\u0010';
	var encodedEscape = '\u0011';
	/**
	 * Encodes a resource path into a IndexedDb-compatible string form.
	 */
	function encode(path) {
	    var result = '';
	    for (var i = 0; i < path.length; i++) {
	        if (result.length > 0) {
	            result = encodeSeparator(result);
	        }
	        result = encodeSegment(path.get(i), result);
	    }
	    return encodeSeparator(result);
	}
	exports.encode = encode;
	/** Encodes a single segment of a resource path into the given result */
	function encodeSegment(segment, resultBuf) {
	    var result = resultBuf;
	    var length = segment.length;
	    for (var i = 0; i < length; i++) {
	        var c = segment.charAt(i);
	        switch (c) {
	            case '\0':
	                result += escapeChar + encodedNul;
	                break;
	            case escapeChar:
	                result += escapeChar + encodedEscape;
	                break;
	            default:
	                result += c;
	        }
	    }
	    return result;
	}
	/** Encodes a path separator into the given result */
	function encodeSeparator(result) {
	    return result + escapeChar + encodedSeparatorChar;
	}
	/**
	 * Decodes the given IndexedDb-compatible string form of a resource path into
	 * a ResourcePath instance. Note that this method is not suitable for use with
	 * decoding resource names from the server; those are One Platform format
	 * strings.
	 */
	function decode(path) {
	    // Event the empty path must encode as a path of at least length 2. A path
	    // with exactly 2 must be the empty path.
	    var length = path.length;
	    assert_1.assert(length >= 2, 'Invalid path ' + path);
	    if (length === 2) {
	        assert_1.assert(path.charAt(0) === escapeChar && path.charAt(1) === encodedSeparatorChar, 'Non-empty path ' + path + ' had length 2');
	        return path_1.ResourcePath.EMPTY_PATH;
	    }
	    // Escape characters cannot exist past the second-to-last position in the
	    // source value.
	    var lastReasonableEscapeIndex = length - 2;
	    var segments = [];
	    var segmentBuilder = '';
	    for (var start = 0; start < length;) {
	        // The last two characters of a valid encoded path must be a separator, so
	        // there must be an end to this segment.
	        var end = path.indexOf(escapeChar, start);
	        if (end < 0 || end > lastReasonableEscapeIndex) {
	            assert_1.fail('Invalid encoded resource path: "' + path + '"');
	        }
	        var next = path.charAt(end + 1);
	        switch (next) {
	            case encodedSeparatorChar:
	                var currentPiece = path.substring(start, end);
	                var segment = void 0;
	                if (segmentBuilder.length === 0) {
	                    // Avoid copying for the common case of a segment that excludes \0
	                    // and \001
	                    segment = currentPiece;
	                }
	                else {
	                    segmentBuilder += currentPiece;
	                    segment = segmentBuilder;
	                    segmentBuilder = '';
	                }
	                segments.push(segment);
	                break;
	            case encodedNul:
	                segmentBuilder += path.substring(start, end);
	                segmentBuilder += '\0';
	                break;
	            case encodedEscape:
	                // The escape character can be used in the output to encode itself.
	                segmentBuilder += path.substring(start, end + 1);
	                break;
	            default:
	                assert_1.fail('Invalid encoded resource path: "' + path + '"');
	        }
	        start = end + 2;
	    }
	    return new path_1.ResourcePath(segments);
	}
	exports.decode = decode;
	/**
	 * Computes the prefix successor of the given path, computed by encode above.
	 * A prefix successor is the first key that cannot be prefixed by the given
	 * path. It's useful for defining the end of a prefix scan such that all keys
	 * in the scan have the same prefix.
	 *
	 * Note that this is not a general prefix successor implementation, which is
	 * tricky to get right with Strings, given that they encode down to UTF-8.
	 * Instead this relies on the fact that all paths encoded by this class are
	 * always terminated with a separator, and so a successor can always be
	 * cheaply computed by incrementing the last character of the path.
	 */
	function prefixSuccessor(path) {
	    var c = path.charCodeAt(path.length - 1);
	    // TODO(mcg): this really should be a general thing, but not worth it right
	    // now
	    assert_1.assert(c === 1, 'successor may only operate on paths generated by encode');
	    return path.substring(0, path.length - 1) + String.fromCharCode(c + 1);
	}
	exports.prefixSuccessor = prefixSuccessor;
	
	//# sourceMappingURL=encoded_resource_path.js.map


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(10);
	var error_1 = __webpack_require__(19);
	var log = __webpack_require__(24);
	/**
	 * Error Codes describing the different ways GRPC can fail. These are copied
	 * directly from GRPC's sources here:
	 *
	 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
	 *
	 * Important! The names of these identifiers matter because the string forms
	 * are used for reverse lookups from the webchannel stream. Do NOT change the
	 * names of these identifiers.
	 */
	var RpcCode;
	(function (RpcCode) {
	    RpcCode[RpcCode["OK"] = 0] = "OK";
	    RpcCode[RpcCode["CANCELLED"] = 1] = "CANCELLED";
	    RpcCode[RpcCode["UNKNOWN"] = 2] = "UNKNOWN";
	    RpcCode[RpcCode["INVALID_ARGUMENT"] = 3] = "INVALID_ARGUMENT";
	    RpcCode[RpcCode["DEADLINE_EXCEEDED"] = 4] = "DEADLINE_EXCEEDED";
	    RpcCode[RpcCode["NOT_FOUND"] = 5] = "NOT_FOUND";
	    RpcCode[RpcCode["ALREADY_EXISTS"] = 6] = "ALREADY_EXISTS";
	    RpcCode[RpcCode["PERMISSION_DENIED"] = 7] = "PERMISSION_DENIED";
	    RpcCode[RpcCode["UNAUTHENTICATED"] = 16] = "UNAUTHENTICATED";
	    RpcCode[RpcCode["RESOURCE_EXHAUSTED"] = 8] = "RESOURCE_EXHAUSTED";
	    RpcCode[RpcCode["FAILED_PRECONDITION"] = 9] = "FAILED_PRECONDITION";
	    RpcCode[RpcCode["ABORTED"] = 10] = "ABORTED";
	    RpcCode[RpcCode["OUT_OF_RANGE"] = 11] = "OUT_OF_RANGE";
	    RpcCode[RpcCode["UNIMPLEMENTED"] = 12] = "UNIMPLEMENTED";
	    RpcCode[RpcCode["INTERNAL"] = 13] = "INTERNAL";
	    RpcCode[RpcCode["UNAVAILABLE"] = 14] = "UNAVAILABLE";
	    RpcCode[RpcCode["DATA_LOSS"] = 15] = "DATA_LOSS";
	})(RpcCode || (RpcCode = {}));
	function isPermanentError(code) {
	    switch (code) {
	        case error_1.Code.OK:
	            return assert_1.fail('Treated status OK as error');
	        case error_1.Code.CANCELLED:
	        case error_1.Code.UNKNOWN:
	        case error_1.Code.DEADLINE_EXCEEDED:
	        case error_1.Code.RESOURCE_EXHAUSTED:
	        case error_1.Code.INTERNAL:
	        case error_1.Code.UNAVAILABLE:
	        // Unauthenticated means something went wrong with our token and we need
	        // to retry with new credentials which will happen automatically.
	        // TODO(b/37325376): Give up after second unauthenticated error.
	        case error_1.Code.UNAUTHENTICATED:
	            return false;
	        case error_1.Code.INVALID_ARGUMENT:
	        case error_1.Code.NOT_FOUND:
	        case error_1.Code.ALREADY_EXISTS:
	        case error_1.Code.PERMISSION_DENIED:
	        case error_1.Code.FAILED_PRECONDITION:
	        // Aborted might be retried in some scenarios, but that is dependant on
	        // the context and should handled individually by the calling code.
	        // See https://cloud.google.com/apis/design/errors.
	        case error_1.Code.ABORTED:
	        case error_1.Code.OUT_OF_RANGE:
	        case error_1.Code.UNIMPLEMENTED:
	        case error_1.Code.DATA_LOSS:
	            return true;
	        default:
	            return assert_1.fail('Unknown status code: ' + code);
	    }
	}
	exports.isPermanentError = isPermanentError;
	/**
	 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
	 *
	 * @returns The Code equivalent to the given status string or undefined if
	 *     there is no match.
	 */
	function mapCodeFromRpcStatus(status) {
	    // tslint:disable-next-line:no-any lookup by string
	    var code = RpcCode[status];
	    if (code === undefined) {
	        return undefined;
	    }
	    return mapCodeFromRpcCode(code);
	}
	exports.mapCodeFromRpcStatus = mapCodeFromRpcStatus;
	/**
	 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
	 * are not the same as HTTP status codes.
	 *
	 * @returns The Code equivalent to the given GRPC status code. Fails if there
	 *     is no match.
	 */
	function mapCodeFromRpcCode(code) {
	    if (code === undefined) {
	        // This shouldn't normally happen, but in certain error cases (like trying
	        // to send invalid proto messages) we may get an error with no GRPC code.
	        log.error('GRPC error has no .code');
	        return error_1.Code.UNKNOWN;
	    }
	    switch (code) {
	        case RpcCode.OK:
	            return error_1.Code.OK;
	        case RpcCode.CANCELLED:
	            return error_1.Code.CANCELLED;
	        case RpcCode.UNKNOWN:
	            return error_1.Code.UNKNOWN;
	        case RpcCode.DEADLINE_EXCEEDED:
	            return error_1.Code.DEADLINE_EXCEEDED;
	        case RpcCode.RESOURCE_EXHAUSTED:
	            return error_1.Code.RESOURCE_EXHAUSTED;
	        case RpcCode.INTERNAL:
	            return error_1.Code.INTERNAL;
	        case RpcCode.UNAVAILABLE:
	            return error_1.Code.UNAVAILABLE;
	        case RpcCode.UNAUTHENTICATED:
	            return error_1.Code.UNAUTHENTICATED;
	        case RpcCode.INVALID_ARGUMENT:
	            return error_1.Code.INVALID_ARGUMENT;
	        case RpcCode.NOT_FOUND:
	            return error_1.Code.NOT_FOUND;
	        case RpcCode.ALREADY_EXISTS:
	            return error_1.Code.ALREADY_EXISTS;
	        case RpcCode.PERMISSION_DENIED:
	            return error_1.Code.PERMISSION_DENIED;
	        case RpcCode.FAILED_PRECONDITION:
	            return error_1.Code.FAILED_PRECONDITION;
	        case RpcCode.ABORTED:
	            return error_1.Code.ABORTED;
	        case RpcCode.OUT_OF_RANGE:
	            return error_1.Code.OUT_OF_RANGE;
	        case RpcCode.UNIMPLEMENTED:
	            return error_1.Code.UNIMPLEMENTED;
	        case RpcCode.DATA_LOSS:
	            return error_1.Code.DATA_LOSS;
	        default:
	            return assert_1.fail('Unknown status code: ' + code);
	    }
	}
	exports.mapCodeFromRpcCode = mapCodeFromRpcCode;
	/**
	 * Maps an RPC code from a Code. This is the reverse operation from
	 * mapCodeFromRpcCode and should really only be used in tests.
	 */
	function mapRpcCodeFromCode(code) {
	    if (code === undefined) {
	        return RpcCode.OK;
	    }
	    switch (code) {
	        case error_1.Code.OK:
	            return RpcCode.OK;
	        case error_1.Code.CANCELLED:
	            return RpcCode.CANCELLED;
	        case error_1.Code.UNKNOWN:
	            return RpcCode.UNKNOWN;
	        case error_1.Code.DEADLINE_EXCEEDED:
	            return RpcCode.DEADLINE_EXCEEDED;
	        case error_1.Code.RESOURCE_EXHAUSTED:
	            return RpcCode.RESOURCE_EXHAUSTED;
	        case error_1.Code.INTERNAL:
	            return RpcCode.INTERNAL;
	        case error_1.Code.UNAVAILABLE:
	            return RpcCode.UNAVAILABLE;
	        case error_1.Code.UNAUTHENTICATED:
	            return RpcCode.UNAUTHENTICATED;
	        case error_1.Code.INVALID_ARGUMENT:
	            return RpcCode.INVALID_ARGUMENT;
	        case error_1.Code.NOT_FOUND:
	            return RpcCode.NOT_FOUND;
	        case error_1.Code.ALREADY_EXISTS:
	            return RpcCode.ALREADY_EXISTS;
	        case error_1.Code.PERMISSION_DENIED:
	            return RpcCode.PERMISSION_DENIED;
	        case error_1.Code.FAILED_PRECONDITION:
	            return RpcCode.FAILED_PRECONDITION;
	        case error_1.Code.ABORTED:
	            return RpcCode.ABORTED;
	        case error_1.Code.OUT_OF_RANGE:
	            return RpcCode.OUT_OF_RANGE;
	        case error_1.Code.UNIMPLEMENTED:
	            return RpcCode.UNIMPLEMENTED;
	        case error_1.Code.DATA_LOSS:
	            return RpcCode.DATA_LOSS;
	        default:
	            return assert_1.fail('Unknown status code: ' + code);
	    }
	}
	exports.mapRpcCodeFromCode = mapRpcCodeFromCode;
	/**
	 * Converts an HTTP Status Code to the equivalent error code.
	 *
	 * @param status An HTTP Status Code, like 200, 404, 503, etc.
	 * @returns The equivalent Code. Unknown status codes are mapped to
	 *     Code.UNKNOWN.
	 */
	function mapCodeFromHttpStatus(status) {
	    // The canonical error codes for Google APIs [1] specify mapping onto HTTP
	    // status codes but the mapping is not bijective. In each case of ambiguity
	    // this function chooses a primary error.
	    //
	    // [1]
	    // https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
	    switch (status) {
	        case 200:// OK
	            return error_1.Code.OK;
	        case 400:// Bad Request
	            return error_1.Code.INVALID_ARGUMENT;
	        // Other possibilities based on the forward mapping
	        // return Code.FAILED_PRECONDITION;
	        // return Code.OUT_OF_RANGE;
	        case 401:// Unauthorized
	            return error_1.Code.UNAUTHENTICATED;
	        case 403:// Forbidden
	            return error_1.Code.PERMISSION_DENIED;
	        case 404:// Not Found
	            return error_1.Code.NOT_FOUND;
	        case 409:// Conflict
	            return error_1.Code.ABORTED;
	        // Other possibilities:
	        // return Code.ALREADY_EXISTS;
	        case 416:// Range Not Satisfiable
	            return error_1.Code.OUT_OF_RANGE;
	        case 429:// Too Many Requests
	            return error_1.Code.RESOURCE_EXHAUSTED;
	        case 499:// Client Closed Request
	            return error_1.Code.CANCELLED;
	        case 500:// Internal Server Error
	            return error_1.Code.UNKNOWN;
	        // Other possibilities:
	        // return Code.INTERNAL;
	        // return Code.DATA_LOSS;
	        case 501:// Unimplemented
	            return error_1.Code.UNIMPLEMENTED;
	        case 503:// Service Unavailable
	            return error_1.Code.UNAVAILABLE;
	        case 504:// Gateway Timeout
	            return error_1.Code.DEADLINE_EXCEEDED;
	        default:
	            if (status >= 200 && status < 300)
	                return error_1.Code.OK;
	            if (status >= 400 && status < 500)
	                return error_1.Code.FAILED_PRECONDITION;
	            if (status >= 500 && status < 600)
	                return error_1.Code.INTERNAL;
	            return error_1.Code.UNKNOWN;
	    }
	}
	exports.mapCodeFromHttpStatus = mapCodeFromHttpStatus;
	
	//# sourceMappingURL=rpc_error.js.map


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// We are doing some heavy reflective stuff, lots of any casting necessary
	/* tslint:disable:no-any */
	var error_1 = __webpack_require__(19);
	/**
	 * Helper function to prevent instantiation through the constructor.
	 *
	 * This method creates a new constructor that throws when it's invoked.
	 * The prototype of that constructor is then set to the prototype of the hidden
	 * "class" to expose all the prototype methods and allow for instanceof
	 * checks.
	 *
	 * To also make all the static methods available, all properties of the
	 * original constructor are copied to the new constructor.
	 */
	function makeConstructorPrivate(cls, optionalMessage) {
	    function PublicConstructor() {
	        var error = 'This constructor is private.';
	        if (optionalMessage) {
	            error += ' ';
	            error += optionalMessage;
	        }
	        throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, error);
	    }
	    // Make sure instanceof checks work and all methods are exposed on the public
	    // constructor
	    PublicConstructor.prototype = cls.prototype;
	    // Copy any static methods/members
	    for (var staticProperty in cls) {
	        if (cls.hasOwnProperty(staticProperty)) {
	            PublicConstructor[staticProperty] = cls[staticProperty];
	        }
	    }
	    return PublicConstructor;
	}
	exports.makeConstructorPrivate = makeConstructorPrivate;
	
	//# sourceMappingURL=api.js.map


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var objUtil = __webpack_require__(36);
	/**
	 * A map implementation that uses objects as keys. Objects must implement the
	 * Equatable interface and must be immutable. Entries in the map are stored
	 * together with the key being produced from the mapKeyFn. This map
	 * automatically handles collisions of keys.
	 */
	var ObjectMap = /** @class */ (function () {
	    function ObjectMap(mapKeyFn) {
	        this.mapKeyFn = mapKeyFn;
	        /**
	         * The inner map for a key -> value pair. Due to the possibility of
	         * collisions we keep a list of entries that we do a linear search through
	         * to find an actual match. Note that collisions should be rare, so we still
	         * expect near constant time lookups in practice.
	         */
	        this.inner = {};
	    }
	    /** Get a value for this key, or undefined if it does not exist. */
	    ObjectMap.prototype.get = function (key) {
	        var id = this.mapKeyFn(key);
	        var matches = this.inner[id];
	        if (matches === undefined) {
	            return undefined;
	        }
	        for (var _i = 0, matches_1 = matches; _i < matches_1.length; _i++) {
	            var _a = matches_1[_i], otherKey = _a[0], value = _a[1];
	            if (otherKey.equals(key)) {
	                return value;
	            }
	        }
	        return undefined;
	    };
	    ObjectMap.prototype.has = function (key) {
	        return this.get(key) !== undefined;
	    };
	    /** Put this key and value in the map. */
	    ObjectMap.prototype.set = function (key, value) {
	        var id = this.mapKeyFn(key);
	        var matches = this.inner[id];
	        if (matches === undefined) {
	            this.inner[id] = [[key, value]];
	            return;
	        }
	        for (var i = 0; i < matches.length; i++) {
	            if (matches[i][0].equals(key)) {
	                matches[i] = [key, value];
	                return;
	            }
	        }
	        matches.push([key, value]);
	    };
	    /**
	     * Remove this key from the map. Returns a boolean if anything was deleted.
	     */
	    ObjectMap.prototype.delete = function (key) {
	        var id = this.mapKeyFn(key);
	        var matches = this.inner[id];
	        if (matches === undefined) {
	            return false;
	        }
	        for (var i = 0; i < matches.length; i++) {
	            if (matches[i][0].equals(key)) {
	                if (matches.length === 1) {
	                    delete this.inner[id];
	                }
	                else {
	                    matches.splice(i, 1);
	                }
	                return true;
	            }
	        }
	        return false;
	    };
	    ObjectMap.prototype.forEach = function (fn) {
	        objUtil.forEach(this.inner, function (_, entries) {
	            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
	                var _a = entries_1[_i], k = _a[0], v = _a[1];
	                fn(k, v);
	            }
	        });
	    };
	    ObjectMap.prototype.isEmpty = function () {
	        return objUtil.isEmpty(this.inner);
	    };
	    return ObjectMap;
	}());
	exports.ObjectMap = ObjectMap;
	
	//# sourceMappingURL=obj_map.js.map


/***/ },
/* 130 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Deferred = /** @class */ (function () {
	    function Deferred() {
	        var _this = this;
	        this.promise = new Promise(function (resolve, reject) {
	            _this.resolve = resolve;
	            _this.reject = reject;
	        });
	    }
	    return Deferred;
	}());
	exports.Deferred = Deferred;
	/**
	 * Takes an array of values and sequences them using the promise (or value)
	 * returned by the supplied callback. The callback for each item is called
	 * after the promise is resolved for the previous item.
	 * The function returns a promise which is resolved after the promise for
	 * the last item is resolved.
	 */
	function sequence(values, fn, initialValue) {
	    var result = Promise.resolve(initialValue);
	    values.forEach(function (value) {
	        result = result.then(function (lastResult) { return fn(value, lastResult); });
	    });
	    return result;
	}
	exports.sequence = sequence;
	
	//# sourceMappingURL=promise.js.map


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var errorsExports = __webpack_require__(41);
	var MetadataUtils = __webpack_require__(133);
	var type = __webpack_require__(33);
	/**
	 * @param name Name of the function.
	 * @param specs Argument specs.
	 * @param passed The actual arguments passed to the function.
	 * @throws {fbs.Error} If the arguments are invalid.
	 */
	function validate(name, specs, passed) {
	    var minArgs = specs.length;
	    var maxArgs = specs.length;
	    for (var i = 0; i < specs.length; i++) {
	        if (specs[i].optional) {
	            minArgs = i;
	            break;
	        }
	    }
	    var validLength = minArgs <= passed.length && passed.length <= maxArgs;
	    if (!validLength) {
	        throw errorsExports.invalidArgumentCount(minArgs, maxArgs, name, passed.length);
	    }
	    for (var i = 0; i < passed.length; i++) {
	        try {
	            specs[i].validator(passed[i]);
	        }
	        catch (e) {
	            if (e instanceof Error) {
	                throw errorsExports.invalidArgument(i, name, e.message);
	            }
	            else {
	                throw errorsExports.invalidArgument(i, name, e);
	            }
	        }
	    }
	}
	exports.validate = validate;
	/**
	 * @struct
	 */
	var ArgSpec = /** @class */ (function () {
	    function ArgSpec(validator, opt_optional) {
	        var self = this;
	        this.validator = function (p) {
	            if (self.optional && !type.isJustDef(p)) {
	                return;
	            }
	            validator(p);
	        };
	        this.optional = !!opt_optional;
	    }
	    return ArgSpec;
	}());
	exports.ArgSpec = ArgSpec;
	function and_(v1, v2) {
	    return function (p) {
	        v1(p);
	        v2(p);
	    };
	}
	exports.and_ = and_;
	function stringSpec(opt_validator, opt_optional) {
	    function stringValidator(p) {
	        if (!type.isString(p)) {
	            throw 'Expected string.';
	        }
	    }
	    var validator;
	    if (opt_validator) {
	        validator = and_(stringValidator, opt_validator);
	    }
	    else {
	        validator = stringValidator;
	    }
	    return new ArgSpec(validator, opt_optional);
	}
	exports.stringSpec = stringSpec;
	function uploadDataSpec() {
	    function validator(p) {
	        var valid = p instanceof Uint8Array ||
	            p instanceof ArrayBuffer ||
	            (type.isNativeBlobDefined() && p instanceof Blob);
	        if (!valid) {
	            throw 'Expected Blob or File.';
	        }
	    }
	    return new ArgSpec(validator);
	}
	exports.uploadDataSpec = uploadDataSpec;
	function metadataSpec(opt_optional) {
	    return new ArgSpec(MetadataUtils.metadataValidator, opt_optional);
	}
	exports.metadataSpec = metadataSpec;
	function nonNegativeNumberSpec() {
	    function validator(p) {
	        var valid = type.isNumber(p) && p >= 0;
	        if (!valid) {
	            throw 'Expected a number 0 or greater.';
	        }
	    }
	    return new ArgSpec(validator);
	}
	exports.nonNegativeNumberSpec = nonNegativeNumberSpec;
	function looseObjectSpec(opt_validator, opt_optional) {
	    function validator(p) {
	        var isLooseObject = p === null || (type.isDef(p) && p instanceof Object);
	        if (!isLooseObject) {
	            throw 'Expected an Object.';
	        }
	        if (opt_validator !== undefined && opt_validator !== null) {
	            opt_validator(p);
	        }
	    }
	    return new ArgSpec(validator, opt_optional);
	}
	exports.looseObjectSpec = looseObjectSpec;
	function nullFunctionSpec(opt_optional) {
	    function validator(p) {
	        var valid = p === null || type.isFunction(p);
	        if (!valid) {
	            throw 'Expected a Function.';
	        }
	    }
	    return new ArgSpec(validator, opt_optional);
	}
	exports.nullFunctionSpec = nullFunctionSpec;
	
	//# sourceMappingURL=args.js.map


/***/ },
/* 132 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Returns true if the object is contained in the array (compared with ===).
	 * @template T
	 */
	function contains(array, elem) {
	    return array.indexOf(elem) !== -1;
	}
	exports.contains = contains;
	/**
	 * Returns a shallow copy of the array or array-like object (e.g. arguments).
	 * @template T
	 */
	function clone(arraylike) {
	    return Array.prototype.slice.call(arraylike);
	}
	exports.clone = clone;
	/**
	 * Removes the given element from the given array, if it is contained.
	 * Directly modifies the passed-in array.
	 * @template T
	 */
	function remove(array, elem) {
	    var i = array.indexOf(elem);
	    if (i !== -1) {
	        array.splice(i, 1);
	    }
	}
	exports.remove = remove;
	
	//# sourceMappingURL=array.js.map


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var json = __webpack_require__(506);
	var location_1 = __webpack_require__(100);
	var path = __webpack_require__(202);
	var type = __webpack_require__(33);
	var UrlUtils = __webpack_require__(134);
	function noXform_(metadata, value) {
	    return value;
	}
	exports.noXform_ = noXform_;
	/**
	 * @struct
	 */
	var Mapping = /** @class */ (function () {
	    function Mapping(server, opt_local, opt_writable, opt_xform) {
	        this.server = server;
	        this.local = opt_local || server;
	        this.writable = !!opt_writable;
	        this.xform = opt_xform || noXform_;
	    }
	    return Mapping;
	}());
	exports.Mapping = Mapping;
	var mappings_ = null;
	function xformPath(fullPath) {
	    var valid = type.isString(fullPath);
	    if (!valid || fullPath.length < 2) {
	        return fullPath;
	    }
	    else {
	        fullPath = fullPath;
	        return path.lastComponent(fullPath);
	    }
	}
	exports.xformPath = xformPath;
	function getMappings() {
	    if (mappings_) {
	        return mappings_;
	    }
	    var mappings = [];
	    mappings.push(new Mapping('bucket'));
	    mappings.push(new Mapping('generation'));
	    mappings.push(new Mapping('metageneration'));
	    mappings.push(new Mapping('name', 'fullPath', true));
	    function mappingsXformPath(metadata, fullPath) {
	        return xformPath(fullPath);
	    }
	    var nameMapping = new Mapping('name');
	    nameMapping.xform = mappingsXformPath;
	    mappings.push(nameMapping);
	    /**
	     * Coerces the second param to a number, if it is defined.
	     */
	    function xformSize(metadata, size) {
	        if (type.isDef(size)) {
	            return +size;
	        }
	        else {
	            return size;
	        }
	    }
	    var sizeMapping = new Mapping('size');
	    sizeMapping.xform = xformSize;
	    mappings.push(sizeMapping);
	    mappings.push(new Mapping('timeCreated'));
	    mappings.push(new Mapping('updated'));
	    mappings.push(new Mapping('md5Hash', null, true));
	    mappings.push(new Mapping('cacheControl', null, true));
	    mappings.push(new Mapping('contentDisposition', null, true));
	    mappings.push(new Mapping('contentEncoding', null, true));
	    mappings.push(new Mapping('contentLanguage', null, true));
	    mappings.push(new Mapping('contentType', null, true));
	    mappings.push(new Mapping('metadata', 'customMetadata', true));
	    /**
	     * Transforms a comma-separated string of tokens into a list of download
	     * URLs.
	     */
	    function xformTokens(metadata, tokens) {
	        var valid = type.isString(tokens) && tokens.length > 0;
	        if (!valid) {
	            // This can happen if objects are uploaded through GCS and retrieved
	            // through list, so we don't want to throw an Error.
	            return [];
	        }
	        var encode = encodeURIComponent;
	        var tokensList = tokens.split(',');
	        var urls = tokensList.map(function (token) {
	            var bucket = metadata['bucket'];
	            var path = metadata['fullPath'];
	            var urlPart = '/b/' + encode(bucket) + '/o/' + encode(path);
	            var base = UrlUtils.makeDownloadUrl(urlPart);
	            var queryString = UrlUtils.makeQueryString({
	                alt: 'media',
	                token: token
	            });
	            return base + queryString;
	        });
	        return urls;
	    }
	    mappings.push(new Mapping('downloadTokens', 'downloadURLs', false, xformTokens));
	    mappings_ = mappings;
	    return mappings_;
	}
	exports.getMappings = getMappings;
	function addRef(metadata, authWrapper) {
	    function generateRef() {
	        var bucket = metadata['bucket'];
	        var path = metadata['fullPath'];
	        var loc = new location_1.Location(bucket, path);
	        return authWrapper.makeStorageReference(loc);
	    }
	    Object.defineProperty(metadata, 'ref', { get: generateRef });
	}
	exports.addRef = addRef;
	function fromResource(authWrapper, resource, mappings) {
	    var metadata = {};
	    metadata['type'] = 'file';
	    var len = mappings.length;
	    for (var i = 0; i < len; i++) {
	        var mapping = mappings[i];
	        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
	    }
	    addRef(metadata, authWrapper);
	    return metadata;
	}
	exports.fromResource = fromResource;
	function fromResourceString(authWrapper, resourceString, mappings) {
	    var obj = json.jsonObjectOrNull(resourceString);
	    if (obj === null) {
	        return null;
	    }
	    var resource = obj;
	    return fromResource(authWrapper, resource, mappings);
	}
	exports.fromResourceString = fromResourceString;
	function toResourceString(metadata, mappings) {
	    var resource = {};
	    var len = mappings.length;
	    for (var i = 0; i < len; i++) {
	        var mapping = mappings[i];
	        if (mapping.writable) {
	            resource[mapping.server] = metadata[mapping.local];
	        }
	    }
	    return JSON.stringify(resource);
	}
	exports.toResourceString = toResourceString;
	function metadataValidator(p) {
	    var validType = p && type.isObject(p);
	    if (!validType) {
	        throw 'Expected Metadata object.';
	    }
	    for (var key in p) {
	        var val = p[key];
	        if (key === 'customMetadata') {
	            if (!type.isObject(val)) {
	                throw 'Expected object for \'customMetadata\' mapping.';
	            }
	        }
	        else {
	            if (type.isNonNullObject(val)) {
	                throw "Mapping for '" + key + "' cannot be an object.";
	            }
	        }
	    }
	}
	exports.metadataValidator = metadataValidator;
	
	//# sourceMappingURL=metadata.js.map


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @fileoverview Functions to create and manipulate URLs for the server API.
	 */
	var constants = __webpack_require__(99);
	var object = __webpack_require__(58);
	function makeNormalUrl(urlPart) {
	    return constants.domainBase + constants.apiBaseUrl + urlPart;
	}
	exports.makeNormalUrl = makeNormalUrl;
	function makeDownloadUrl(urlPart) {
	    return constants.downloadBase + constants.apiBaseUrl + urlPart;
	}
	exports.makeDownloadUrl = makeDownloadUrl;
	function makeUploadUrl(urlPart) {
	    return constants.domainBase + constants.apiUploadBaseUrl + urlPart;
	}
	exports.makeUploadUrl = makeUploadUrl;
	function makeQueryString(params) {
	    var encode = encodeURIComponent;
	    var queryPart = '?';
	    object.forEach(params, function (key, val) {
	        var nextPart = encode(key) + '=' + encode(val);
	        queryPart = queryPart + nextPart + '&';
	    });
	    // Chop off the extra '&' or '?' on the end
	    queryPart = queryPart.slice(0, -1);
	    return queryPart;
	}
	exports.makeQueryString = makeQueryString;
	
	//# sourceMappingURL=url.js.map


/***/ },
/* 135 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
	 */
	exports.CONSTANTS = {
	    /**
	     * @define {boolean} Whether this is the client Node.js SDK.
	     */
	    NODE_CLIENT: false,
	    /**
	     * @define {boolean} Whether this is the Admin Node.js SDK.
	     */
	    NODE_ADMIN: false,
	    /**
	     * Firebase SDK Version
	     */
	    SDK_VERSION: '${JSCORE_VERSION}'
	};
	
	//# sourceMappingURL=constants.js.map


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	*  filename: ej2-splitbuttons.umd.min.js
	*  version : 19.4.52
	*  Copyright Syncfusion Inc. 2001 - 2020. All rights reserved.
	*  Use of this code is subject to the terms of our license.
	*  A copy of the current license can be obtained at any time by e-mailing
	*  licensing@syncfusion.com. Any infringement will be prosecuted under
	*  applicable laws. 
	*/
	!function(e,t){ true?t(exports,__webpack_require__(23),__webpack_require__(42),__webpack_require__(46)):"function"==typeof define&&define.amd?define(["exports","@syncfusion/ej2-base","@syncfusion/ej2-buttons","@syncfusion/ej2-popups"],t):t(e.ej={},e.ej2Base,e.ej2Buttons,e.ej2Popups)}(this,function(e,t,i,s){"use strict";function n(e,i){for(var s=t.extend({},e),n=0,o=Object.keys(s);n<o.length;n++){var r=o[n];i.indexOf(r)<0&&t.deleteObject(s,r)}return s}function o(e,i){var s=40===i?0:e.childElementCount-1,n=s,o=e.querySelector(".e-selected");o&&o.classList.remove("e-selected");for(var a=0,p=e.children.length;a<p;a++)e.children[a].classList.contains("e-focused")&&(n=a,e.children[a].classList.remove("e-focused"),40===i?n++:n--,n===(40===i?e.childElementCount:-1)&&(n=s));-1!==(n=r(e,e.children[n],n,i))&&(t.addClass([e.children[n]],"e-focused"),e.children[n].focus())}function r(e,t,i,s,n){if(void 0===n&&(n=0),(t.classList.contains("e-separator")||t.classList.contains("e-disabled"))&&(i===(40===s?e.childElementCount-1:0)?i=40===s?0:e.childElementCount-1:40===s?i++:i--),(t=e.children[i]).classList.contains("e-separator")||t.classList.contains("e-disabled")){if(++n===e.childElementCount)return i=-1;i=r(e,t,i,s,n)}return i}function a(e){var i=[].slice.call(e.getElementsByClassName("e-blank-icon"));if(i.length){var s=e.querySelector(".e-item:not(.e-blank-icon):not(.e-separator)");if(!t.isNullOrUndefined(s)){s.classList.contains("e-url")&&(s=s.querySelector(".e-menu-url"));var n,o=s.querySelector(".e-menu-icon"),r=e.classList.contains("e-rtl");n=r?{padding:"paddingRight",margin:"marginLeft"}:{padding:"paddingLeft",margin:"marginRight"};var a=parseInt(getComputedStyle(o).fontSize,10)+parseInt(getComputedStyle(o)[n.margin],10)+parseInt(getComputedStyle(s).paddingLeft,10)+"px";i.forEach(function(e){e.classList.contains("e-url")?e.querySelector(".e-menu-url").style[n.padding]=a:e.style[n.padding]=a})}}}var p=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),l=function(e,t,i,s){var n,o=arguments.length,r=o<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(e,t,i,s);else for(var a=e.length-1;a>=0;a--)(n=e[a])&&(r=(o<3?n(r):o>3?n(t,i,r):n(t,i))||r);return o>3&&r&&Object.defineProperty(t,i,r),r},c=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return p(i,e),l([t.Property("")],i.prototype,"iconCss",void 0),l([t.Property("")],i.prototype,"id",void 0),l([t.Property(!1)],i.prototype,"separator",void 0),l([t.Property("")],i.prototype,"text",void 0),l([t.Property("")],i.prototype,"url",void 0),l([t.Property(!1)],i.prototype,"disabled",void 0),i}(t.ChildProperty),h=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),d=function(e,t,i,s){var n,o=arguments.length,r=o<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(e,t,i,s);else for(var a=e.length-1;a>=0;a--)(n=e[a])&&(r=(o<3?n(r):o>3?n(t,i,r):n(t,i))||r);return o>3&&r&&Object.defineProperty(t,i,r),r},u="e-menu-icon",m="e-item",y="e-dropdown-popup",f="e-separator",v="e-vertical",g=function(e){function r(t,i){var s=e.call(this,t,i)||this;return s.isPopupCreated=!0,s}return h(r,e),r.prototype.preRender=function(){},r.prototype.getPersistData=function(){return this.addOnPersist([])},r.prototype.toggle=function(){this.canOpen()?this.openPopUp():this.closePopup()},r.prototype.render=function(){this.initialize(),this.disabled||this.wireEvents(),this.renderComplete()},r.prototype.addItems=function(e,t){for(var i,s=this.items.length,n=0,o=this.items.length;n<o;n++)if(t===this.items[n].text){s=n;break}for(var r=e.length-1;r>=0;r--)i=new c(this,"items",e[r],!0),this.items.splice(s,0,i);this.canOpen()||this.createItems()},r.prototype.removeItems=function(e,t){for(var i=!1,s=0,n=e.length;s<n;s++)for(var o=0,r=this.items.length;o<r;o++)if(e[s]===(t?this.items[o].id:this.items[o].text)){this.items.splice(o,1),i=!0;break}i&&this.getULElement()&&this.createItems()},r.prototype.createPopup=function(){var e,i=this.createElement("div",{className:y,id:this.element.id+"-popup"});document.body.appendChild(i),this.dropDown=new s.Popup(i,{relateTo:this.element,collision:{X:"fit",Y:"flip"},position:{X:"left",Y:"bottom"},targetType:"relative",content:this.target?this.getTargetElement():"",enableRtl:this.enableRtl}),"fixed"===this.dropDown.element.style.position&&this.dropDown.refreshPosition(this.element),this.dropDown.hide(),t.attributes(this.element,(e={},e["aria-haspopup"]=this.items.length||this.target?"true":"false",e["aria-expanded"]="false",e["aria-owns"]=this.getPopUpElement().id,e.type="button",e["aria-label"]=this.element.textContent+" dropdownbutton",e)),this.cssClass&&t.addClass([i],this.cssClass.split(" ")),this.isPopupCreated=!0},r.prototype.getTargetElement=function(){return"string"==typeof this.target?t.select(this.target):this.target},r.prototype.createItems=function(e){var i,s,n,o,r=this.items,p=this.hasIcon(this.items,"iconCss"),l=this.getULElement();l?l.innerHTML="":l=this.createElement("ul",{attrs:{role:"menu",tabindex:"0"}});for(var c=0;c<r.length;c++){s=r[c];var h=this.enableHtmlSanitizer?t.SanitizeHtmlHelper.sanitize(s.text):s.text;n=this.createElement("li",{innerHTML:s.url?"":h,className:s.separator?m+" "+f:m,attrs:{role:"menuItem",tabindex:"-1"},id:s.id?s.id:t.getUniqueID("e-"+this.getModuleName()+"-item")}),s.url&&(n.appendChild(this.createAnchor(s)),n.classList.add("e-url")),s.iconCss?(i=this.createElement("span",{className:u+" "+s.iconCss}),s.url?n.childNodes[0].appendChild(i):n.insertBefore(i,n.childNodes[0])):p&&!s.separator&&n.classList.add("e-blank-icon"),s.disabled&&n.classList.add("e-disabled"),o={item:s,element:n},this.trigger("beforeItemRender",o),l.appendChild(n)}e&&this.getPopUpElement().appendChild(l),p&&a(this.getPopUpElement())},r.prototype.hasIcon=function(e,t){for(var i=0,s=e.length;i<s;i++)if(e[i][t])return!0;return!1},r.prototype.createAnchor=function(e){var i=this.enableHtmlSanitizer?t.SanitizeHtmlHelper.sanitize(e.text):e.text;return this.createElement("a",{className:"e-menu-text e-menu-url",innerHTML:i,attrs:{href:e.url}})},r.prototype.initialize=function(){this.button=new i.Button({iconCss:this.iconCss,iconPosition:this.iconPosition,cssClass:this.cssClass,content:this.content,disabled:this.disabled,enableRtl:this.enableRtl,enablePersistence:this.enablePersistence}),this.button.createElement=this.createElement,this.button.appendTo(this.element),this.element.id||(this.element.id=t.getUniqueID("e-"+this.getModuleName())),this.appendArrowSpan(),this.setActiveElem([this.element]),this.target&&!this.isColorPicker()||!this.createPopupOnClick?this.createPopup():this.isPopupCreated=!1},r.prototype.isColorPicker=function(){if(!this.element)return!1;var e=this.element.previousSibling;return!!(e&&e.classList&&e.classList.contains("e-split-colorpicker"))},r.prototype.appendArrowSpan=function(){this.element.appendChild(this.createElement("span",{className:"e-btn-icon e-icons e-icon-"+(this.cssClass.indexOf(v)>-1?"bottom":"right")+" e-caret"}))},r.prototype.setActiveElem=function(e){this.activeElem=e},r.prototype.getModuleName=function(){return"dropdown-btn"},r.prototype.canOpen=function(){var e=!1;return this.isPopupCreated&&(e=this.getPopUpElement().classList.contains("e-popup-close")),e},r.prototype.destroy=function(){var i=this;if(e.prototype.destroy.call(this),"dropdown-btn"===this.getModuleName()){var s;this.element.querySelector("span.e-caret")&&t.detach(this.element.querySelector("span.e-caret")),this.cssClass&&(s=this.cssClass.split(" ")),this.button.destroy(),s&&t.removeClass([this.element],s),t.removeClass(this.activeElem,["e-active"]);(this.element.getAttribute("class")?["aria-haspopup","aria-expanded","aria-owns","type"]:["aria-haspopup","aria-expanded","aria-owns","type","class"]).forEach(function(e){i.element.removeAttribute(e)}),this.popupUnWireEvents(),this.destroyPopup(),this.isPopupCreated=!1,this.disabled||this.unWireEvents()}},r.prototype.destroyPopup=function(){if(this.isPopupCreated){if(this.dropDown.destroy(),this.getPopUpElement()){var e=document.getElementById(this.getPopUpElement().id);e&&(t.removeClass([e],["e-popup-open","e-popup-close"]),t.detach(e))}t.EventHandler.remove(this.getPopUpElement(),"click",this.clickHandler),t.EventHandler.remove(this.getPopUpElement(),"keydown",this.keyBoardHandler),this.isPopupCreated&&(this.dropDown=void 0)}this.isPopupCreated=!1},r.prototype.getPopUpElement=function(){var e=null;return this.dropDown&&(e=this.dropDown.element),e},r.prototype.getULElement=function(){var e=null;return this.getPopUpElement()&&(e=this.getPopUpElement().children[0]),e},r.prototype.wireEvents=function(){this.delegateMousedownHandler=this.mousedownHandler.bind(this),this.createPopupOnClick||t.EventHandler.add(document,"mousedown touchstart",this.delegateMousedownHandler,this),t.EventHandler.add(this.element,"click",this.clickHandler,this),t.EventHandler.add(this.element,"keydown",this.keyBoardHandler,this)},r.prototype.popupWireEvents=function(){var e=this.getPopUpElement();this.createPopupOnClick&&t.EventHandler.add(document,"mousedown touchstart",this.delegateMousedownHandler,this),e&&(t.EventHandler.add(e,"click",this.clickHandler,this),t.EventHandler.add(e,"keydown",this.keyBoardHandler,this)),this.rippleFn=t.rippleEffect(e,{selector:"."+m})},r.prototype.popupUnWireEvents=function(){var e=this.getPopUpElement();this.createPopupOnClick&&t.EventHandler.remove(document,"mousedown touchstart",this.delegateMousedownHandler),e&&e.parentElement&&(t.EventHandler.remove(e,"click",this.clickHandler),t.EventHandler.remove(e,"keydown",this.keyBoardHandler))},r.prototype.keyBoardHandler=function(e){if(e.target!==this.element||9!==e.keyCode&&(e.altKey||40!==e.keyCode)&&38!==e.keyCode)switch(e.keyCode){case 38:case 40:!e.altKey||38!==e.keyCode&&40!==e.keyCode?this.upDownKeyHandler(e):this.keyEventHandler(e);break;case 9:case 13:case 27:case 32:this.keyEventHandler(e)}},r.prototype.upDownKeyHandler=function(e){(!this.target||38!==e.keyCode&&40!==e.keyCode)&&(e.preventDefault(),o(this.getULElement(),e.keyCode))},r.prototype.keyEventHandler=function(e){(!this.target||13!==e.keyCode&&9!==e.keyCode)&&(e.target&&e.target.className.indexOf("e-edit-template")>-1&&32===e.keyCode||(9!==e.keyCode&&e.preventDefault(),27===e.keyCode||38===e.keyCode||9===e.keyCode?this.canOpen()||this.closePopup(e,this.element):this.clickHandler(e)))},r.prototype.getLI=function(e){return"LI"===e.tagName?e:t.closest(e,"li")},r.prototype.mousedownHandler=function(e){var i=e.target;!this.dropDown||this.canOpen()||t.closest(i,'[id="'+this.getPopUpElement().id+'"]')||t.closest(i,'[id="'+this.element.id+'"]')||this.closePopup(e)},r.prototype.clickHandler=function(e){var i=e.target;if(t.closest(i,'[id="'+this.element.id+'"]'))!this.createPopupOnClick||this.target&&!this.isColorPicker()?this.getPopUpElement().classList.contains("e-popup-close")?this.openPopUp(e):this.closePopup(e):this.isPopupCreated?this.closePopup(e,this.activeElem[0]):(this.createPopup(),this.openPopUp(e));else if(t.closest(i,'[id="'+this.getPopUpElement().id+'"]')){var s=void 0,n=void 0,o=void 0,r=this.getLI(i);r&&(n=Array.prototype.indexOf.call(this.getULElement().children,r),(o=this.items[n])&&(s={element:r,item:o},this.trigger("select",s)),this.closePopup(e,this.activeElem[0]))}},r.prototype.openPopUp=function(e){var i=this;void 0===e&&(e=null);var s=this.getPopUpElement();if(this.target)if(this.activeElem.length>1){var n=t.getComponent(this.activeElem[0],"split-btn");n.isReact&&s.childNodes.length<1&&n.appendReactElement(this.getTargetElement(),this.getPopUpElement())}else this.isReact&&s.childNodes.length<1&&this.appendReactElement(this.getTargetElement(),this.getPopUpElement());else this.createItems(!0);var o=this.getULElement();this.popupWireEvents();var r={element:o,items:this.items,event:e,cancel:!1};this.trigger("beforeOpen",r,function(e){if(!e.cancel){var s=i.getULElement();i.dropDown.show(null,i.element),t.addClass([i.element],"e-active"),i.element.setAttribute("aria-expanded","true"),s.focus();var n={element:s,items:i.items};i.trigger("open",n)}})},r.prototype.closePopup=function(e,i){var s=this;void 0===e&&(e=null);var n={element:this.getULElement(),items:this.items,event:e,cancel:!1},o=this.getPopUpElement();o&&t.EventHandler.remove(o,"keydown",this.keyBoardHandler),this.trigger("beforeClose",n,function(e){if(!e.cancel){s.popupUnWireEvents();var n=s.getULElement(),o=n.querySelector(".e-selected");o&&o.classList.remove("e-selected"),s.dropDown.hide(),t.removeClass(s.activeElem,"e-active"),s.element.setAttribute("aria-expanded","false"),i&&i.focus();var r={element:n,items:s.items};s.trigger("close",r),!s.target&&n&&t.detach(n),s.target&&!s.isColorPicker()||s.createPopupOnClick&&s.destroyPopup(),s.target&&(s.isPopupCreated=!s.createPopupOnClick)}})},r.prototype.unWireEvents=function(){this.createPopupOnClick||t.EventHandler.remove(document,"mousedown touchstart",this.delegateMousedownHandler),t.EventHandler.remove(this.element,"click",this.clickHandler),t.EventHandler.remove(this.element,"keydown",this.keyBoardHandler),this.isPopupCreated&&(t.EventHandler.remove(this.getPopUpElement(),"click",this.clickHandler),t.EventHandler.remove(this.getPopUpElement(),"keydown",this.keyBoardHandler))},r.prototype.onPropertyChanged=function(e,i){this.button.setProperties(n(e,["content","cssClass","iconCss","iconPosition","disabled","enableRtl"]));var s;this.isPopupCreated&&(s=this.getPopUpElement(),this.dropDown.setProperties(n(e,["enableRtl"])));for(var o=0,r=Object.keys(e);o<r.length;o++){switch(r[o]){case"content":this.element.querySelector("span.e-caret")||this.appendArrowSpan();break;case"disabled":e.disabled?(this.unWireEvents(),this.isPopupCreated&&!this.canOpen()&&this.closePopup()):this.wireEvents();break;case"cssClass":if(e.cssClass.indexOf(v)>-1){var a=this.element.querySelector("span.e-caret");t.classList(a,["e-icon-bottom"],["e-icon-right"])}this.isPopupCreated&&(i.cssClass&&t.removeClass([s],i.cssClass.split(" ")),e.cssClass&&t.addClass([s],e.cssClass.split(" ")));break;case"target":this.dropDown.content=this.getTargetElement(),this.dropDown.dataBind();break;case"items":this.isPopupCreated&&this.getULElement()&&this.createItems();break;case"createPopupOnClick":e.createPopupOnClick?this.destroyPopup():this.createPopup()}}},r.prototype.focusIn=function(){this.element.focus()},d([t.Property("")],r.prototype,"content",void 0),d([t.Property("")],r.prototype,"cssClass",void 0),d([t.Property(!1)],r.prototype,"disabled",void 0),d([t.Property("")],r.prototype,"iconCss",void 0),d([t.Property("Left")],r.prototype,"iconPosition",void 0),d([t.Property(!1)],r.prototype,"enableHtmlSanitizer",void 0),d([t.Collection([],c)],r.prototype,"items",void 0),d([t.Property(!1)],r.prototype,"createPopupOnClick",void 0),d([t.Property("")],r.prototype,"target",void 0),d([t.Event()],r.prototype,"beforeItemRender",void 0),d([t.Event()],r.prototype,"beforeOpen",void 0),d([t.Event()],r.prototype,"beforeClose",void 0),d([t.Event()],r.prototype,"close",void 0),d([t.Event()],r.prototype,"open",void 0),d([t.Event()],r.prototype,"select",void 0),d([t.Event()],r.prototype,"created",void 0),r=d([t.NotifyPropertyChanges],r)}(t.Component),b=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),C=function(e,t,i,s){var n,o=arguments.length,r=o<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(e,t,i,s);else for(var a=e.length-1;a>=0;a--)(n=e[a])&&(r=(o<3?n(r):o>3?n(t,i,r):n(t,i))||r);return o>3&&r&&Object.defineProperty(t,i,r),r},P="EJS-SPLITBUTTON",E=function(e){function s(t,i){return e.call(this,t,i)||this}return b(s,e),s.prototype.preRender=function(){var e=this.element;if(e.tagName===P){for(var i=t.getValue("ej2_instances",e),s=this.createElement("button",{attrs:{type:"button"}}),n=this.createElement(P,{className:"e-"+this.getModuleName()+"-wrapper"}),o=0,r=e.attributes.length;o<r;o++)s.setAttribute(e.attributes[o].nodeName,e.attributes[o].nodeValue);e.parentNode.insertBefore(n,e),t.detach(e),e=s,n.appendChild(e),t.setValue("ej2_instances",i,e),this.wrapper=n,this.element=e}this.element.id||(this.element.id=t.getUniqueID("e-"+this.getModuleName()))},s.prototype.render=function(){this.initWrapper(),this.createPrimaryButton(),this.renderControl()},s.prototype.renderControl=function(){this.createSecondaryButton(),this.setActiveElem([this.element,this.secondaryBtnObj.element]),this.setAria(),this.wireEvents(),this.renderComplete()},s.prototype.addItems=function(t,i){e.prototype.addItems.call(this,t,i),this.secondaryBtnObj.items=this.items},s.prototype.removeItems=function(t,i){e.prototype.removeItems.call(this,t,i),this.secondaryBtnObj.items=this.items},s.prototype.initWrapper=function(){this.wrapper||(this.wrapper=this.createElement("div",{className:"e-"+this.getModuleName()+"-wrapper"}),this.element.parentNode.insertBefore(this.wrapper,this.element)),this.element.classList.remove("e-"+this.getModuleName()),this.enableRtl&&this.wrapper.classList.add("e-rtl"),this.cssClass&&t.addClass([this.wrapper],this.cssClass.split(" "))},s.prototype.createPrimaryButton=function(){var e={cssClass:this.cssClass,enableRtl:this.enableRtl,iconCss:this.iconCss,iconPosition:this.iconPosition,content:this.content,disabled:this.disabled};this.primaryBtnObj=new i.Button(e),this.primaryBtnObj.createElement=this.createElement,this.primaryBtnObj.appendTo(this.element),this.element.classList.add("e-"+this.getModuleName()),this.element.type="button",this.wrapper.appendChild(this.element)},s.prototype.createSecondaryButton=function(){var e=this,t=this.createElement("button",{className:"e-icon-btn",attrs:{tabindex:"-1"},id:this.element.id+"_dropdownbtn"});this.wrapper.appendChild(t);var i={cssClass:this.cssClass,disabled:this.disabled,enableRtl:this.enableRtl,items:this.items,target:this.target,createPopupOnClick:this.createPopupOnClick};i.beforeItemRender=function(t){e.createPopupOnClick&&(e.secondaryBtnObj.dropDown.relateTo=e.wrapper,e.dropDown=e.secondaryBtnObj.dropDown),e.trigger("beforeItemRender",t)},i.open=function(t){e.trigger("open",t)},i.close=function(t){e.trigger("close",t)},i.select=function(t){e.trigger("select",t)},i.beforeOpen=function(t){var i=new w;return e.trigger("beforeOpen",t,function(e){i.resolve(e)}),i},i.beforeClose=function(t){var i=new w;return e.trigger("beforeClose",t,function(e){i.resolve(e)}),i},this.secondaryBtnObj=new g(i),this.secondaryBtnObj.createElement=this.createElement,this.secondaryBtnObj.appendTo(t),this.createPopupOnClick||(this.secondaryBtnObj.dropDown.relateTo=this.wrapper,this.dropDown=this.secondaryBtnObj.dropDown),this.secondaryBtnObj.activeElem=[this.element,this.secondaryBtnObj.element],this.secondaryBtnObj.element.querySelector(".e-btn-icon").classList.remove("e-icon-right")},s.prototype.setAria=function(){t.attributes(this.element,{"aria-expanded":"false","aria-haspopup":"true","aria-label":this.element.textContent+" splitbutton","aria-owns":this.element.id+"_dropdownbtn-popup"})},s.prototype.getModuleName=function(){return"split-btn"},s.prototype.toggle=function(){this.secondaryBtnObj.toggle()},s.prototype.destroy=function(){var i=this,s=["e-rtl"];if(this.cssClass&&(s=s.concat(this.cssClass.split(" "))),this.element){var n=document.getElementById(this.element.id);n&&n.parentElement===this.wrapper&&(this.wrapper.tagName===P?(this.wrapper.innerHTML="",t.removeClass([this.wrapper],["e-rtl","e-"+this.getModuleName()+"-wrapper"]),t.removeClass([this.wrapper],this.cssClass.split(" "))):(t.removeClass([this.element],s),["aria-label","aria-haspopup","aria-expanded","aria-owns","type"].forEach(function(e){i.element.removeAttribute(e)}),this.wrapper.parentNode.insertBefore(this.element,this.wrapper),t.remove(this.wrapper)),this.unWireEvents())}this.primaryBtnObj.destroy(),this.secondaryBtnObj.destroy(),e.prototype.destroy.call(this),this.element.getAttribute("class")||this.element.removeAttribute("class")},s.prototype.wireEvents=function(){t.EventHandler.add(this.element,"click",this.primaryBtnClickHandler,this),new t.KeyboardEvents(this.element,{keyAction:this.btnKeyBoardHandler.bind(this),keyConfigs:{altdownarrow:"alt+downarrow"}})},s.prototype.unWireEvents=function(){t.EventHandler.remove(this.element,"click",this.primaryBtnClickHandler),t.getInstance(this.element,t.KeyboardEvents).destroy()},s.prototype.primaryBtnClickHandler=function(){this.trigger("click",{element:this.element})},s.prototype.btnKeyBoardHandler=function(e){switch(e.action){case"altdownarrow":this.clickHandler(e)}},s.prototype.onPropertyChanged=function(e,i){var s=["content","iconCss","iconPosition","cssClass","disabled","enableRtl"];this.primaryBtnObj.setProperties(n(e,s)),s=["beforeOpen","beforeItemRender","select","open","close","cssClass","disabled","enableRtl","createPopupOnClick"],Object.keys(e).indexOf("items")>-1&&(this.secondaryBtnObj.items=e.items,this.secondaryBtnObj.dataBind()),this.secondaryBtnObj.setProperties(n(e,s));for(var o=0,r=Object.keys(e);o<r.length;o++){switch(r[o]){case"cssClass":i.cssClass&&t.removeClass([this.wrapper],i.cssClass.split(" ")),t.addClass([this.wrapper],e.cssClass.split(" "));break;case"enableRtl":e.enableRtl?t.addClass([this.wrapper],"e-rtl"):t.removeClass([this.wrapper],"e-rtl")}}},s.prototype.focusIn=function(){this.element.focus()},C([t.Property("")],s.prototype,"content",void 0),C([t.Property("")],s.prototype,"cssClass",void 0),C([t.Property(!1)],s.prototype,"disabled",void 0),C([t.Property("")],s.prototype,"iconCss",void 0),C([t.Property("Left")],s.prototype,"iconPosition",void 0),C([t.Property(!1)],s.prototype,"createPopupOnClick",void 0),C([t.Collection([],c)],s.prototype,"items",void 0),C([t.Property("")],s.prototype,"target",void 0),C([t.Event()],s.prototype,"beforeItemRender",void 0),C([t.Event()],s.prototype,"beforeOpen",void 0),C([t.Event()],s.prototype,"beforeClose",void 0),C([t.Event()],s.prototype,"click",void 0),C([t.Event()],s.prototype,"close",void 0),C([t.Event()],s.prototype,"open",void 0),C([t.Event()],s.prototype,"select",void 0),C([t.Event()],s.prototype,"created",void 0),s=C([t.NotifyPropertyChanges],s)}(g),w=function(){return function(){var e=this;this.promise=new Promise(function(t,i){e.resolve=t,e.reject=i}),this.catch=this.promise.catch.bind(this.promise),this.then=this.promise.then.bind(this.promise)}}(),k=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),O=function(e,t,i,s){var n,o=arguments.length,r=o<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(e,t,i,s);else for(var a=e.length-1;a>=0;a--)(n=e[a])&&(r=(o<3?n(r):o>3?n(t,i,r):n(t,i))||r);return o>3&&r&&Object.defineProperty(t,i,r),r},S="e-hide-spinner",H="e-progress-active",L="e-btn-content",B=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return k(i,e),O([t.Property(null)],i.prototype,"template",void 0),O([t.Property(16)],i.prototype,"width",void 0),O([t.Property("Left")],i.prototype,"position",void 0),i}(t.ChildProperty),j=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return k(i,e),O([t.Property(400)],i.prototype,"duration",void 0),O([t.Property("None")],i.prototype,"effect",void 0),O([t.Property("ease")],i.prototype,"easing",void 0),i}(t.ChildProperty),N=function(e){function i(t,i){var s=e.call(this,t,i)||this;return s.step=1,s}return k(i,e),i.prototype.preRender=function(){e.prototype.preRender.call(this)},i.prototype.render=function(){e.prototype.render.call(this),this.init(),this.wireEvents(),this.setAria(),this.renderComplete()},i.prototype.start=function(e){this.isPaused=!1,this.startProgress(e||this.percent,this.progressTime)},i.prototype.stop=function(){this.isPaused=!0,cancelAnimationFrame(this.timerId)},i.prototype.progressComplete=function(){this.isPaused=!1,this.finishProgress()},i.prototype.getModuleName=function(){return"progress-btn"},i.prototype.destroy=function(){var i=this,s=[S,H,"e-round-corner","e-"+e.prototype.getModuleName.call(this),"e-spin-"+this.spinSettings.position.toLowerCase()];e.prototype.destroy.call(this),this.unWireEvents(),this.element.innerHTML="",this.cssClass&&(s=s.concat(this.cssClass.split(" "))),t.removeClass([this.element],s);(this.element.getAttribute("class")?["aria-label","aria-valuemin","aria-valuemax","aria-valuenow"]:["aria-label","aria-valuemin","aria-valuemax","aria-valuenow","class"]).forEach(function(e){i.element.removeAttribute(e)}),this.disabled&&this.element.removeAttribute("disabled")},i.prototype.init=function(){this.element.classList.add("e-"+e.prototype.getModuleName.call(this)),this.setContent(),this.createSpinner(),this.enableProgress&&this.createProgress()},i.prototype.createSpinner=function(){var e=this.createElement("span",{className:"e-spinner"});this.setSpinPosition(e),s.createSpinner({target:e,width:this.spinSettings.width||16,template:this.spinSettings.template},this.createElement)},i.prototype.getSpinner=function(){return this.element.getElementsByClassName("e-spinner")[0]},i.prototype.getProgress=function(){return this.element.getElementsByClassName("e-progress")[0]},i.prototype.setSpinPosition=function(e){var t=this.spinSettings.position||"Left";"Left"===t||"Top"===t?this.element.insertBefore(e,this.element.getElementsByClassName(L)[0]):this.element.appendChild(e),this.element.classList.add("e-spin-"+t.toLowerCase())},i.prototype.createProgress=function(){this.element.appendChild(this.createElement("span",{className:"e-progress"}))},i.prototype.setContent=function(){var e;e=this.element.innerHTML,this.enableHtmlSanitizer&&(e=t.SanitizeHtmlHelper.sanitize(this.element.innerHTML)),this.element.innerHTML="",this.element.appendChild(this.createElement("span",{className:L,innerHTML:e}))},i.prototype.setContentIcon=function(e){var t=this.createElement("span",{className:L,innerHTML:e});if(this.iconCss){var i=this.createElement("span",{className:"e-btn-icon "+this.iconCss});this.element.textContent.trim()?(i.classList.add("e-icon-"+this.iconPosition.toLowerCase()),"Top"!==this.iconPosition&&"Bottom"!==this.iconPosition||this.element.classList.add("e-"+this.iconPosition.toLowerCase()+"-icon-btn")):this.element.classList.add("e-icon-btn");var s=t.childNodes[0];!s||"Left"!==this.iconPosition&&"Top"!==this.iconPosition?t.appendChild(i):t.insertBefore(i,s)}this.element.appendChild(t)},i.prototype.clickHandler=function(){this.element.classList.contains(H)||this.startProgress()},i.prototype.startProgress=function(e,t){var i=this.element.classList,n=i.contains("e-vertical");i.add(H),i.contains(S)||s.showSpinner(this.element),this.startAnimate(Date.now(),t||0,t?Date.now()-1*this.duration/100:Date.now(),e||0,0,this.step,0,n),this.startContAnimate()},i.prototype.startAnimate=function(e,t,i,s,n,o,r,a){var p=this;try{var l=e-i,c=this.duration*o/100,h=l?l<c?l-c:l%c:0;this.progressTime=t=t+l-h,i=e-h,s+=(l-h)/this.duration*100;var d={percent:n=(t-r)%c==0||100===s?s:n,currentDuration:t,step:o};this.eIsVertical=a,0===s?this.trigger("begin",d,function(e){p.successCallback(e,s,n,t,r,h,i)}):100===s||t===this.duration?this.trigger("end",d,function(e){p.successCallback(e,s,n,t,r,h,i)}):this.trigger("progress",d,function(e){p.successCallback(e,s,n,t,r,h,i)})}catch(e){cancelAnimationFrame(this.timerId),this.trigger("fail",e)}},i.prototype.successCallback=function(e,t,i,s,n,o,r){var a=this,p=t,l=i,c=o,h=s,d=n,u=r,m=this.eIsVertical;p!==e.percent&&e.percent!==l&&(p=e.percent),this.percent=p,this.step=e.step,(h-d)%(this.duration*e.step/100)!=0&&100!==p||(this.timerId=requestAnimationFrame(function(){a.enableProgress&&(a.getProgress().style[m?"height":"width"]=p+"%"),a.element.setAttribute("aria-valuenow",p.toString())}),l=p,d=h),this.isPaused||(h<this.duration&&p<100?this.interval=window.setTimeout(function(){a.startAnimate(Date.now(),h,u,p,l,e.step,d,m)},this.duration/100-c):this.interval=window.setTimeout(function(){a.progressTime=a.percent=0,a.enableProgress&&(a.getProgress().style[m?"height":"width"]="0%"),a.element.setAttribute("aria-valuenow","0"),a.hideSpin()},100))},i.prototype.startContAnimate=function(){var e=this,i=this.element.getElementsByClassName(L)[0];"None"!==this.animationSettings.effect?new t.Animation({}).animate(i,{duration:this.animationSettings.duration,name:"Progress"+this.animationSettings.effect,timingFunction:this.animationSettings.easing,begin:function(){"Center"===e.spinSettings.position&&e.setSpinnerSize()},end:function(){i.classList.add("e-animate-end")}}):"Center"===this.spinSettings.position&&this.setSpinnerSize()},i.prototype.finishProgress=function(){var e=this.element.classList,t=e.contains("e-vertical");e.add(H);for(var i=this.percent;i<100;i++)(i+=10)>100&&(i=100),this.enableProgress&&(this.getProgress().style[t?"height":"width"]=this.percent<100?i+"%":"100%");this.element.setAttribute("aria-valuenow","0"),this.hideSpin();var s={step:this.step,currentDuration:this.progressTime,percent:100};clearTimeout(this.interval),this.trigger("end",s),this.progressTime=this.percent=0},i.prototype.setSpinnerSize=function(){var e=this.element.getElementsByClassName(L)[0],t=this.getSpinner();t.style.width=Math.max(t.offsetWidth,e.offsetWidth)+"px",t.style.height=Math.max(t.offsetHeight,e.offsetHeight)+"px",e.classList.add("e-cont-animate")},i.prototype.hideSpin=function(){var e=this.element.getElementsByClassName(L)[0];if(this.element.classList.contains(S)||s.hideSpinner(this.element),this.element.classList.remove(H),"None"!==this.animationSettings.effect&&e.classList.remove("e-animate-end"),"Center"===this.spinSettings.position){var t=this.getSpinner();e.classList.remove("e-cont-animate"),t.style.width="auto",t.style.height="auto"}},i.prototype.setIconSpan=function(){var e=this.element.getElementsByClassName(L)[0],t=this.element.getElementsByClassName("e-btn-icon")[0];!e.childNodes[0]||"Left"!==this.iconPosition&&"Top"!==this.iconPosition?e.appendChild(t):e.insertBefore(t,e.childNodes[0])},i.prototype.setAria=function(){t.attributes(this.element,{"aria-label":this.element.textContent+" progress","aria-valuemin":"0","aria-valuemax":"100","aria-valuenow":"0"})},i.prototype.wireEvents=function(){t.EventHandler.add(this.element,"click",this.clickHandler,this)},i.prototype.unWireEvents=function(){t.EventHandler.remove(this.element,"click",this.clickHandler)},i.prototype.onPropertyChanged=function(i,n){var o=this.element,r=!1;this.element.querySelector(".e-spinner-pane").classList.contains("e-spin-show")&&(r=!0),e.prototype.onPropertyChanged.call(this,i,n);for(var a=0,p=Object.keys(i);a<p.length;a++){switch(p[a]){case"content":this.setContent(),this.createSpinner(),r&&(s.showSpinner(this.element),r=!1),this.enableProgress&&this.createProgress(),o.setAttribute("aria-label",o.textContent+" progress");break;case"iconCss":n.iconCss||this.setIconSpan();break;case"iconPosition":this.setIconSpan();break;case"enableProgress":i.enableProgress?this.createProgress():t.remove(this.getProgress());break;case"spinSettings":i.spinSettings.position&&(o.classList.remove("e-spin-"+n.spinSettings.position.toLowerCase()),this.setSpinPosition(this.getSpinner())),(i.spinSettings.template||i.spinSettings.width)&&(o.removeChild(this.getSpinner()),this.createSpinner())}}},i.prototype.focusIn=function(){this.element.focus()},O([t.Property(!1)],i.prototype,"enableProgress",void 0),O([t.Property(2e3)],i.prototype,"duration",void 0),O([t.Property("Left")],i.prototype,"iconPosition",void 0),O([t.Property("")],i.prototype,"iconCss",void 0),O([t.Property(!1)],i.prototype,"disabled",void 0),O([t.Property(!1)],i.prototype,"isPrimary",void 0),O([t.Property("")],i.prototype,"cssClass",void 0),O([t.Property("")],i.prototype,"content",void 0),O([t.Property(!1)],i.prototype,"isToggle",void 0),O([t.Property(!1)],i.prototype,"enableHtmlSanitizer",void 0),O([t.Complex({},B)],i.prototype,"spinSettings",void 0),O([t.Complex({},j)],i.prototype,"animationSettings",void 0),O([t.Event()],i.prototype,"created",void 0),O([t.Event()],i.prototype,"begin",void 0),O([t.Event()],i.prototype,"progress",void 0),O([t.Event()],i.prototype,"end",void 0),O([t.Event()],i.prototype,"fail",void 0),i=O([t.NotifyPropertyChanges],i)}(i.Button);e.getModel=n,e.upDownKeyHandler=o,e.setBlankIconStyle=a,e.Item=c,e.DropDownButton=g,e.SplitButton=E,e.Deferred=w,e.createButtonGroup=function(e,s,n){void 0===s&&(s={});var o,r,a,p;t.isNullOrUndefined(n)&&(n=t.createElement);var l=document.querySelector(e);t.addClass([l],["e-btn-group","e-css"]),l.setAttribute("role","group");var c=l.children;s.buttons=s.buttons||[];for(var h=0,d=0;d<c.length;h++,d++)o=c[d],null!==(p=s.buttons[h])&&("BUTTON"===o.tagName?r=o:(r=n("label"),(a=c[d+1])?l.insertBefore(r,a):l.appendChild(r),o.id&&r.setAttribute("for",o.id),p&&p.disabled&&(o.disabled=!0),d++),s.cssClass&&p&&!p.cssClass&&(p.cssClass=s.cssClass),new i.Button(p||{},r));return l},e.SpinSettings=B,e.AnimationSettings=j,e.ProgressButton=N,Object.defineProperty(e,"__esModule",{value:!0})});
	//# sourceMappingURL=ej2-splitbuttons.umd.min.js.map


/***/ },
/* 137 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 139 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/linkedin.e8ffb9db.svg";

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/upload-folder.b82f93a0.svg";

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(61);
	var Danger = __webpack_require__(680);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactInstrumentation = __webpack_require__(34);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(151);
	var setInnerHTML = __webpack_require__(111);
	var setTextContent = __webpack_require__(386);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 143 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var ReactErrorUtils = __webpack_require__(149);
	
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(15);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 146 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var ReactPropTypesSecret = __webpack_require__(709);
	var propTypesFactory = __webpack_require__(364);
	
	var React = __webpack_require__(65);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(15);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var invariant = __webpack_require__(11);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var ReactCurrentOwner = __webpack_require__(44);
	var ReactInstanceMap = __webpack_require__(81);
	var ReactInstrumentation = __webpack_require__(34);
	var ReactUpdates = __webpack_require__(39);
	
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(15);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 151 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 152 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 153 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 154 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(27);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 156 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var emptyFunction = __webpack_require__(37);
	var warning = __webpack_require__(15);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = processNodes;
	
	var _isEmptyTextNode = __webpack_require__(750);
	
	var _isEmptyTextNode2 = _interopRequireDefault(_isEmptyTextNode);
	
	var _convertNodeToElement = __webpack_require__(388);
	
	var _convertNodeToElement2 = _interopRequireDefault(_convertNodeToElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Processes the nodes generated by htmlparser2 and convert them all into React elements
	 *
	 * @param {Object[]} nodes List of nodes to process
	 * @param {Function} transform Transform function to optionally apply to nodes
	 * @returns {React.Element[]} The list of processed React elements
	 */
	function processNodes(nodes, transform) {
	
	  return nodes.filter(function (node) {
	    return !(0, _isEmptyTextNode2.default)(node);
	  }).map(function (node, index) {
	
	    // return the result of the transform function if applicable
	    var transformed = void 0;
	    if (typeof transform === 'function') {
	      transformed = transform(node, index);
	      if (transformed === null || !!transformed) {
	        return transformed;
	      }
	    }
	
	    // otherwise convert the node as standard
	    return (0, _convertNodeToElement2.default)(node, index, transform);
	  });
	}

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(767);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.deepForEach = deepForEach;
	exports.deepMap = deepMap;
	
	var _react = __webpack_require__(3);
	
	var _elementTypes = __webpack_require__(112);
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function isTabChild(child) {
	  return (0, _elementTypes.isTab)(child) || (0, _elementTypes.isTabList)(child) || (0, _elementTypes.isTabPanel)(child);
	}
	
	function deepMap(children, callback) {
	  return _react.Children.map(children, function (child) {
	    // null happens when conditionally rendering TabPanel/Tab
	    // see https://github.com/reactjs/react-tabs/issues/37
	    if (child === null) return null;
	
	    if (isTabChild(child)) {
	      return callback(child);
	    }
	
	    if (child.props && child.props.children && typeof child.props.children === 'object') {
	      // Clone the child that has children and map them too
	      return /*#__PURE__*/(0, _react.cloneElement)(child, _extends({}, child.props, {
	        children: deepMap(child.props.children, callback)
	      }));
	    }
	
	    return child;
	  });
	}
	
	function deepForEach(children, callback) {
	  return _react.Children.forEach(children, function (child) {
	    // null happens when conditionally rendering TabPanel/Tab
	    // see https://github.com/reactjs/react-tabs/issues/37
	    if (child === null) return;
	
	    if ((0, _elementTypes.isTab)(child) || (0, _elementTypes.isTabPanel)(child)) {
	      callback(child);
	    } else if (child.props && child.props.children && typeof child.props.children === 'object') {
	      if ((0, _elementTypes.isTabList)(child)) callback(child);
	      deepForEach(child.props.children, callback);
	    }
	  });
	}

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.resetIdCounter = exports.Tabs = exports.TabPanel = exports.TabList = exports.Tab = void 0;
	
	var _Tabs = _interopRequireDefault(__webpack_require__(795));
	
	exports.Tabs = _Tabs["default"];
	
	var _TabList = _interopRequireDefault(__webpack_require__(793));
	
	exports.TabList = _TabList["default"];
	
	var _Tab = _interopRequireDefault(__webpack_require__(792));
	
	exports.Tab = _Tab["default"];
	
	var _TabPanel = _interopRequireDefault(__webpack_require__(794));
	
	exports.TabPanel = _TabPanel["default"];
	
	var _uuid = __webpack_require__(404);
	
	exports.resetIdCounter = _uuid.reset;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    var provided = typeof message === 'function' ? message() : message;
	    var value = provided ? prefix + ": " + provided : prefix;
	    throw new Error(value);
	}
	
	module.exports = invariant;


/***/ },
/* 163 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(13);
	var parser_1 = __webpack_require__(183);
	var Path_1 = __webpack_require__(17);
	var Reference_1 = __webpack_require__(116);
	var Repo_1 = __webpack_require__(86);
	var RepoManager_1 = __webpack_require__(117);
	var util_2 = __webpack_require__(2);
	var validation_1 = __webpack_require__(48);
	/**
	 * Class representing a firebase database.
	 * @implements {FirebaseService}
	 */
	var Database = /** @class */ (function () {
	    /**
	     * The constructor should not be called by users of our public API.
	     * @param {!Repo} repo_
	     */
	    function Database(repo_) {
	        this.repo_ = repo_;
	        if (!(repo_ instanceof Repo_1.Repo)) {
	            util_1.fatal("Don't call new Database() directly - please use firebase.database().");
	        }
	        /** @type {Reference} */
	        this.root_ = new Reference_1.Reference(repo_, Path_1.Path.Empty);
	        this.INTERNAL = new DatabaseInternals(this);
	    }
	    Object.defineProperty(Database.prototype, "app", {
	        get: function () {
	            return this.repo_.app;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns a reference to the root or the path specified in opt_pathString.
	     * @param {string=} pathString
	     * @return {!Reference} Firebase reference.
	     */
	    Database.prototype.ref = function (pathString) {
	        this.checkDeleted_('ref');
	        util_2.validateArgCount('database.ref', 0, 1, arguments.length);
	        return pathString !== undefined ? this.root_.child(pathString) : this.root_;
	    };
	    /**
	     * Returns a reference to the root or the path specified in url.
	     * We throw a exception if the url is not in the same domain as the
	     * current repo.
	     * @param {string} url
	     * @return {!Reference} Firebase reference.
	     */
	    Database.prototype.refFromURL = function (url) {
	        /** @const {string} */
	        var apiName = 'database.refFromURL';
	        this.checkDeleted_(apiName);
	        util_2.validateArgCount(apiName, 1, 1, arguments.length);
	        var parsedURL = parser_1.parseRepoInfo(url);
	        validation_1.validateUrl(apiName, 1, parsedURL);
	        var repoInfo = parsedURL.repoInfo;
	        if (repoInfo.host !== this.repo_.repoInfo_.host) {
	            util_1.fatal(apiName +
	                ': Host name does not match the current database: ' +
	                '(found ' +
	                repoInfo.host +
	                ' but expected ' +
	                this.repo_.repoInfo_.host +
	                ')');
	        }
	        return this.ref(parsedURL.path.toString());
	    };
	    /**
	     * @param {string} apiName
	     */
	    Database.prototype.checkDeleted_ = function (apiName) {
	        if (this.repo_ === null) {
	            util_1.fatal('Cannot call ' + apiName + ' on a deleted database.');
	        }
	    };
	    // Make individual repo go offline.
	    Database.prototype.goOffline = function () {
	        util_2.validateArgCount('database.goOffline', 0, 0, arguments.length);
	        this.checkDeleted_('goOffline');
	        this.repo_.interrupt();
	    };
	    Database.prototype.goOnline = function () {
	        util_2.validateArgCount('database.goOnline', 0, 0, arguments.length);
	        this.checkDeleted_('goOnline');
	        this.repo_.resume();
	    };
	    Database.ServerValue = {
	        TIMESTAMP: {
	            '.sv': 'timestamp'
	        }
	    };
	    return Database;
	}());
	exports.Database = Database;
	var DatabaseInternals = /** @class */ (function () {
	    /** @param {!Database} database */
	    function DatabaseInternals(database) {
	        this.database = database;
	    }
	    /** @return {Promise<void>} */
	    DatabaseInternals.prototype.delete = function () {
	        this.database.checkDeleted_('delete');
	        RepoManager_1.RepoManager.getInstance().deleteRepo(this.database.repo_);
	        this.database.repo_ = null;
	        this.database.root_ = null;
	        this.database.INTERNAL = null;
	        this.database = null;
	        return Promise.resolve();
	    };
	    return DatabaseInternals;
	}());
	exports.DatabaseInternals = DatabaseInternals;
	
	//# sourceMappingURL=Database.js.map


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var KeyIndex_1 = __webpack_require__(67);
	var PriorityIndex_1 = __webpack_require__(26);
	var ValueIndex_1 = __webpack_require__(177);
	var PathIndex_1 = __webpack_require__(176);
	var util_2 = __webpack_require__(13);
	var Path_1 = __webpack_require__(17);
	var validation_1 = __webpack_require__(48);
	var util_3 = __webpack_require__(2);
	var EventRegistration_1 = __webpack_require__(446);
	var util_4 = __webpack_require__(2);
	var __referenceConstructor;
	/**
	 * A Query represents a filter to be applied to a firebase location.  This object purely represents the
	 * query expression (and exposes our public API to build the query).  The actual query logic is in ViewBase.js.
	 *
	 * Since every Firebase reference is a query, Firebase inherits from this object.
	 */
	var Query = /** @class */ (function () {
	    function Query(repo, path, queryParams_, orderByCalled_) {
	        this.repo = repo;
	        this.path = path;
	        this.queryParams_ = queryParams_;
	        this.orderByCalled_ = orderByCalled_;
	    }
	    Object.defineProperty(Query, "__referenceConstructor", {
	        get: function () {
	            util_1.assert(__referenceConstructor, 'Reference.ts has not been loaded');
	            return __referenceConstructor;
	        },
	        set: function (val) {
	            __referenceConstructor = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Validates start/end values for queries.
	     * @param {!QueryParams} params
	     * @private
	     */
	    Query.validateQueryEndpoints_ = function (params) {
	        var startNode = null;
	        var endNode = null;
	        if (params.hasStart()) {
	            startNode = params.getIndexStartValue();
	        }
	        if (params.hasEnd()) {
	            endNode = params.getIndexEndValue();
	        }
	        if (params.getIndex() === KeyIndex_1.KEY_INDEX) {
	            var tooManyArgsError = 'Query: When ordering by key, you may only pass one argument to ' +
	                'startAt(), endAt(), or equalTo().';
	            var wrongArgTypeError = 'Query: When ordering by key, the argument passed to startAt(), endAt(),' +
	                'or equalTo() must be a string.';
	            if (params.hasStart()) {
	                var startName = params.getIndexStartName();
	                if (startName != util_2.MIN_NAME) {
	                    throw new Error(tooManyArgsError);
	                }
	                else if (typeof startNode !== 'string') {
	                    throw new Error(wrongArgTypeError);
	                }
	            }
	            if (params.hasEnd()) {
	                var endName = params.getIndexEndName();
	                if (endName != util_2.MAX_NAME) {
	                    throw new Error(tooManyArgsError);
	                }
	                else if (typeof endNode !== 'string') {
	                    throw new Error(wrongArgTypeError);
	                }
	            }
	        }
	        else if (params.getIndex() === PriorityIndex_1.PRIORITY_INDEX) {
	            if ((startNode != null && !validation_1.isValidPriority(startNode)) ||
	                (endNode != null && !validation_1.isValidPriority(endNode))) {
	                throw new Error('Query: When ordering by priority, the first argument passed to startAt(), ' +
	                    'endAt(), or equalTo() must be a valid priority value (null, a number, or a string).');
	            }
	        }
	        else {
	            util_1.assert(params.getIndex() instanceof PathIndex_1.PathIndex ||
	                params.getIndex() === ValueIndex_1.VALUE_INDEX, 'unknown index type.');
	            if ((startNode != null && typeof startNode === 'object') ||
	                (endNode != null && typeof endNode === 'object')) {
	                throw new Error('Query: First argument passed to startAt(), endAt(), or equalTo() cannot be ' +
	                    'an object.');
	            }
	        }
	    };
	    /**
	     * Validates that limit* has been called with the correct combination of parameters
	     * @param {!QueryParams} params
	     * @private
	     */
	    Query.validateLimit_ = function (params) {
	        if (params.hasStart() &&
	            params.hasEnd() &&
	            params.hasLimit() &&
	            !params.hasAnchoredLimit()) {
	            throw new Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");
	        }
	    };
	    /**
	     * Validates that no other order by call has been made
	     * @param {!string} fnName
	     * @private
	     */
	    Query.prototype.validateNoPreviousOrderByCall_ = function (fnName) {
	        if (this.orderByCalled_ === true) {
	            throw new Error(fnName + ": You can't combine multiple orderBy calls.");
	        }
	    };
	    /**
	     * @return {!QueryParams}
	     */
	    Query.prototype.getQueryParams = function () {
	        return this.queryParams_;
	    };
	    /**
	     * @return {!Reference}
	     */
	    Query.prototype.getRef = function () {
	        util_3.validateArgCount('Query.ref', 0, 0, arguments.length);
	        // This is a slight hack. We cannot goog.require('fb.api.Firebase'), since Firebase requires fb.api.Query.
	        // However, we will always export 'Firebase' to the global namespace, so it's guaranteed to exist by the time this
	        // method gets called.
	        return new Query.__referenceConstructor(this.repo, this.path);
	    };
	    /**
	     * @param {!string} eventType
	     * @param {!function(DataSnapshot, string=)} callback
	     * @param {(function(Error)|Object)=} cancelCallbackOrContext
	     * @param {Object=} context
	     * @return {!function(DataSnapshot, string=)}
	     */
	    Query.prototype.on = function (eventType, callback, cancelCallbackOrContext, context) {
	        util_3.validateArgCount('Query.on', 2, 4, arguments.length);
	        validation_1.validateEventType('Query.on', 1, eventType, false);
	        util_3.validateCallback('Query.on', 2, callback, false);
	        var ret = Query.getCancelAndContextArgs_('Query.on', cancelCallbackOrContext, context);
	        if (eventType === 'value') {
	            this.onValueEvent(callback, ret.cancel, ret.context);
	        }
	        else {
	            var callbacks = {};
	            callbacks[eventType] = callback;
	            this.onChildEvent(callbacks, ret.cancel, ret.context);
	        }
	        return callback;
	    };
	    /**
	     * @param {!function(!DataSnapshot)} callback
	     * @param {?function(Error)} cancelCallback
	     * @param {?Object} context
	     * @protected
	     */
	    Query.prototype.onValueEvent = function (callback, cancelCallback, context) {
	        var container = new EventRegistration_1.ValueEventRegistration(callback, cancelCallback || null, context || null);
	        this.repo.addEventCallbackForQuery(this, container);
	    };
	    /**
	     * @param {!Object.<string, !function(!DataSnapshot, ?string)>} callbacks
	     * @param {?function(Error)} cancelCallback
	     * @param {?Object} context
	     * @protected
	     */
	    Query.prototype.onChildEvent = function (callbacks, cancelCallback, context) {
	        var container = new EventRegistration_1.ChildEventRegistration(callbacks, cancelCallback, context);
	        this.repo.addEventCallbackForQuery(this, container);
	    };
	    /**
	     * @param {string=} eventType
	     * @param {(function(!DataSnapshot, ?string=))=} callback
	     * @param {Object=} context
	     */
	    Query.prototype.off = function (eventType, callback, context) {
	        util_3.validateArgCount('Query.off', 0, 3, arguments.length);
	        validation_1.validateEventType('Query.off', 1, eventType, true);
	        util_3.validateCallback('Query.off', 2, callback, true);
	        util_3.validateContextObject('Query.off', 3, context, true);
	        var container = null;
	        var callbacks = null;
	        if (eventType === 'value') {
	            var valueCallback = callback || null;
	            container = new EventRegistration_1.ValueEventRegistration(valueCallback, null, context || null);
	        }
	        else if (eventType) {
	            if (callback) {
	                callbacks = {};
	                callbacks[eventType] = callback;
	            }
	            container = new EventRegistration_1.ChildEventRegistration(callbacks, null, context || null);
	        }
	        this.repo.removeEventCallbackForQuery(this, container);
	    };
	    /**
	     * Attaches a listener, waits for the first event, and then removes the listener
	     * @param {!string} eventType
	     * @param {!function(!DataSnapshot, string=)} userCallback
	     * @param cancelOrContext
	     * @param context
	     * @return {!firebase.Promise}
	     */
	    Query.prototype.once = function (eventType, userCallback, cancelOrContext, context) {
	        var _this = this;
	        util_3.validateArgCount('Query.once', 1, 4, arguments.length);
	        validation_1.validateEventType('Query.once', 1, eventType, false);
	        util_3.validateCallback('Query.once', 2, userCallback, true);
	        var ret = Query.getCancelAndContextArgs_('Query.once', cancelOrContext, context);
	        // TODO: Implement this more efficiently (in particular, use 'get' wire protocol for 'value' event)
	        // TODO: consider actually wiring the callbacks into the promise. We cannot do this without a breaking change
	        // because the API currently expects callbacks will be called synchronously if the data is cached, but this is
	        // against the Promise specification.
	        var firstCall = true;
	        var deferred = new util_4.Deferred();
	        // A dummy error handler in case a user wasn't expecting promises
	        deferred.promise.catch(function () { });
	        var onceCallback = function (snapshot) {
	            // NOTE: Even though we unsubscribe, we may get called multiple times if a single action (e.g. set() with JSON)
	            // triggers multiple events (e.g. child_added or child_changed).
	            if (firstCall) {
	                firstCall = false;
	                _this.off(eventType, onceCallback);
	                if (userCallback) {
	                    userCallback.bind(ret.context)(snapshot);
	                }
	                deferred.resolve(snapshot);
	            }
	        };
	        this.on(eventType, onceCallback, 
	        /*cancel=*/ function (err) {
	            _this.off(eventType, onceCallback);
	            if (ret.cancel)
	                ret.cancel.bind(ret.context)(err);
	            deferred.reject(err);
	        });
	        return deferred.promise;
	    };
	    /**
	     * Set a limit and anchor it to the start of the window.
	     * @param {!number} limit
	     * @return {!Query}
	     */
	    Query.prototype.limitToFirst = function (limit) {
	        util_3.validateArgCount('Query.limitToFirst', 1, 1, arguments.length);
	        if (typeof limit !== 'number' ||
	            Math.floor(limit) !== limit ||
	            limit <= 0) {
	            throw new Error('Query.limitToFirst: First argument must be a positive integer.');
	        }
	        if (this.queryParams_.hasLimit()) {
	            throw new Error('Query.limitToFirst: Limit was already set (by another call to limit, ' +
	                'limitToFirst, or limitToLast).');
	        }
	        return new Query(this.repo, this.path, this.queryParams_.limitToFirst(limit), this.orderByCalled_);
	    };
	    /**
	     * Set a limit and anchor it to the end of the window.
	     * @param {!number} limit
	     * @return {!Query}
	     */
	    Query.prototype.limitToLast = function (limit) {
	        util_3.validateArgCount('Query.limitToLast', 1, 1, arguments.length);
	        if (typeof limit !== 'number' ||
	            Math.floor(limit) !== limit ||
	            limit <= 0) {
	            throw new Error('Query.limitToLast: First argument must be a positive integer.');
	        }
	        if (this.queryParams_.hasLimit()) {
	            throw new Error('Query.limitToLast: Limit was already set (by another call to limit, ' +
	                'limitToFirst, or limitToLast).');
	        }
	        return new Query(this.repo, this.path, this.queryParams_.limitToLast(limit), this.orderByCalled_);
	    };
	    /**
	     * Given a child path, return a new query ordered by the specified grandchild path.
	     * @param {!string} path
	     * @return {!Query}
	     */
	    Query.prototype.orderByChild = function (path) {
	        util_3.validateArgCount('Query.orderByChild', 1, 1, arguments.length);
	        if (path === '$key') {
	            throw new Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');
	        }
	        else if (path === '$priority') {
	            throw new Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');
	        }
	        else if (path === '$value') {
	            throw new Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');
	        }
	        validation_1.validatePathString('Query.orderByChild', 1, path, false);
	        this.validateNoPreviousOrderByCall_('Query.orderByChild');
	        var parsedPath = new Path_1.Path(path);
	        if (parsedPath.isEmpty()) {
	            throw new Error('Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.');
	        }
	        var index = new PathIndex_1.PathIndex(parsedPath);
	        var newParams = this.queryParams_.orderBy(index);
	        Query.validateQueryEndpoints_(newParams);
	        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
	    };
	    /**
	     * Return a new query ordered by the KeyIndex
	     * @return {!Query}
	     */
	    Query.prototype.orderByKey = function () {
	        util_3.validateArgCount('Query.orderByKey', 0, 0, arguments.length);
	        this.validateNoPreviousOrderByCall_('Query.orderByKey');
	        var newParams = this.queryParams_.orderBy(KeyIndex_1.KEY_INDEX);
	        Query.validateQueryEndpoints_(newParams);
	        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
	    };
	    /**
	     * Return a new query ordered by the PriorityIndex
	     * @return {!Query}
	     */
	    Query.prototype.orderByPriority = function () {
	        util_3.validateArgCount('Query.orderByPriority', 0, 0, arguments.length);
	        this.validateNoPreviousOrderByCall_('Query.orderByPriority');
	        var newParams = this.queryParams_.orderBy(PriorityIndex_1.PRIORITY_INDEX);
	        Query.validateQueryEndpoints_(newParams);
	        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
	    };
	    /**
	     * Return a new query ordered by the ValueIndex
	     * @return {!Query}
	     */
	    Query.prototype.orderByValue = function () {
	        util_3.validateArgCount('Query.orderByValue', 0, 0, arguments.length);
	        this.validateNoPreviousOrderByCall_('Query.orderByValue');
	        var newParams = this.queryParams_.orderBy(ValueIndex_1.VALUE_INDEX);
	        Query.validateQueryEndpoints_(newParams);
	        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
	    };
	    /**
	     * @param {number|string|boolean|null} value
	     * @param {?string=} name
	     * @return {!Query}
	     */
	    Query.prototype.startAt = function (value, name) {
	        if (value === void 0) { value = null; }
	        util_3.validateArgCount('Query.startAt', 0, 2, arguments.length);
	        validation_1.validateFirebaseDataArg('Query.startAt', 1, value, this.path, true);
	        validation_1.validateKey('Query.startAt', 2, name, true);
	        var newParams = this.queryParams_.startAt(value, name);
	        Query.validateLimit_(newParams);
	        Query.validateQueryEndpoints_(newParams);
	        if (this.queryParams_.hasStart()) {
	            throw new Error('Query.startAt: Starting point was already set (by another call to startAt ' +
	                'or equalTo).');
	        }
	        // Calling with no params tells us to start at the beginning.
	        if (value === undefined) {
	            value = null;
	            name = null;
	        }
	        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
	    };
	    /**
	     * @param {number|string|boolean|null} value
	     * @param {?string=} name
	     * @return {!Query}
	     */
	    Query.prototype.endAt = function (value, name) {
	        if (value === void 0) { value = null; }
	        util_3.validateArgCount('Query.endAt', 0, 2, arguments.length);
	        validation_1.validateFirebaseDataArg('Query.endAt', 1, value, this.path, true);
	        validation_1.validateKey('Query.endAt', 2, name, true);
	        var newParams = this.queryParams_.endAt(value, name);
	        Query.validateLimit_(newParams);
	        Query.validateQueryEndpoints_(newParams);
	        if (this.queryParams_.hasEnd()) {
	            throw new Error('Query.endAt: Ending point was already set (by another call to endAt or ' +
	                'equalTo).');
	        }
	        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
	    };
	    /**
	     * Load the selection of children with exactly the specified value, and, optionally,
	     * the specified name.
	     * @param {number|string|boolean|null} value
	     * @param {string=} name
	     * @return {!Query}
	     */
	    Query.prototype.equalTo = function (value, name) {
	        util_3.validateArgCount('Query.equalTo', 1, 2, arguments.length);
	        validation_1.validateFirebaseDataArg('Query.equalTo', 1, value, this.path, false);
	        validation_1.validateKey('Query.equalTo', 2, name, true);
	        if (this.queryParams_.hasStart()) {
	            throw new Error('Query.equalTo: Starting point was already set (by another call to startAt or ' +
	                'equalTo).');
	        }
	        if (this.queryParams_.hasEnd()) {
	            throw new Error('Query.equalTo: Ending point was already set (by another call to endAt or ' +
	                'equalTo).');
	        }
	        return this.startAt(value, name).endAt(value, name);
	    };
	    /**
	     * @return {!string} URL for this location.
	     */
	    Query.prototype.toString = function () {
	        util_3.validateArgCount('Query.toString', 0, 0, arguments.length);
	        return this.repo.toString() + this.path.toUrlEncodedString();
	    };
	    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
	    // for end-users.
	    Query.prototype.toJSON = function () {
	        // An optional spacer argument is unnecessary for a string.
	        util_3.validateArgCount('Query.toJSON', 0, 1, arguments.length);
	        return this.toString();
	    };
	    /**
	     * An object representation of the query parameters used by this Query.
	     * @return {!Object}
	     */
	    Query.prototype.queryObject = function () {
	        return this.queryParams_.getQueryObject();
	    };
	    /**
	     * @return {!string}
	     */
	    Query.prototype.queryIdentifier = function () {
	        var obj = this.queryObject();
	        var id = util_2.ObjectToUniqueKey(obj);
	        return id === '{}' ? 'default' : id;
	    };
	    /**
	     * Return true if this query and the provided query are equivalent; otherwise, return false.
	     * @param {Query} other
	     * @return {boolean}
	     */
	    Query.prototype.isEqual = function (other) {
	        util_3.validateArgCount('Query.isEqual', 1, 1, arguments.length);
	        if (!(other instanceof Query)) {
	            var error = 'Query.isEqual failed: First argument must be an instance of firebase.database.Query.';
	            throw new Error(error);
	        }
	        var sameRepo = this.repo === other.repo;
	        var samePath = this.path.equals(other.path);
	        var sameQueryIdentifier = this.queryIdentifier() === other.queryIdentifier();
	        return sameRepo && samePath && sameQueryIdentifier;
	    };
	    /**
	     * Helper used by .on and .once to extract the context and or cancel arguments.
	     * @param {!string} fnName The function name (on or once)
	     * @param {(function(Error)|Object)=} cancelOrContext
	     * @param {Object=} context
	     * @return {{cancel: ?function(Error), context: ?Object}}
	     * @private
	     */
	    Query.getCancelAndContextArgs_ = function (fnName, cancelOrContext, context) {
	        var ret = { cancel: null, context: null };
	        if (cancelOrContext && context) {
	            ret.cancel = cancelOrContext;
	            util_3.validateCallback(fnName, 3, ret.cancel, true);
	            ret.context = context;
	            util_3.validateContextObject(fnName, 4, ret.context, true);
	        }
	        else if (cancelOrContext) {
	            // we have either a cancel callback or a context.
	            if (typeof cancelOrContext === 'object' && cancelOrContext !== null) {
	                // it's a context!
	                ret.context = cancelOrContext;
	            }
	            else if (typeof cancelOrContext === 'function') {
	                ret.cancel = cancelOrContext;
	            }
	            else {
	                throw new Error(util_3.errorPrefix(fnName, 3, true) +
	                    ' must either be a cancel callback or a context object.');
	            }
	        }
	        return ret;
	    };
	    Object.defineProperty(Query.prototype, "ref", {
	        get: function () {
	            return this.getRef();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Query;
	}());
	exports.Query = Query;
	
	//# sourceMappingURL=Query.js.map


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var validation_1 = __webpack_require__(48);
	var util_2 = __webpack_require__(13);
	var util_3 = __webpack_require__(2);
	/**
	 * @constructor
	 */
	var OnDisconnect = /** @class */ (function () {
	    /**
	     * @param {!Repo} repo_
	     * @param {!Path} path_
	     */
	    function OnDisconnect(repo_, path_) {
	        this.repo_ = repo_;
	        this.path_ = path_;
	    }
	    /**
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.cancel = function (onComplete) {
	        util_1.validateArgCount('OnDisconnect.cancel', 0, 1, arguments.length);
	        util_1.validateCallback('OnDisconnect.cancel', 1, onComplete, true);
	        var deferred = new util_3.Deferred();
	        this.repo_.onDisconnectCancel(this.path_, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.remove = function (onComplete) {
	        util_1.validateArgCount('OnDisconnect.remove', 0, 1, arguments.length);
	        validation_1.validateWritablePath('OnDisconnect.remove', this.path_);
	        util_1.validateCallback('OnDisconnect.remove', 1, onComplete, true);
	        var deferred = new util_3.Deferred();
	        this.repo_.onDisconnectSet(this.path_, null, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {*} value
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.set = function (value, onComplete) {
	        util_1.validateArgCount('OnDisconnect.set', 1, 2, arguments.length);
	        validation_1.validateWritablePath('OnDisconnect.set', this.path_);
	        validation_1.validateFirebaseDataArg('OnDisconnect.set', 1, value, this.path_, false);
	        util_1.validateCallback('OnDisconnect.set', 2, onComplete, true);
	        var deferred = new util_3.Deferred();
	        this.repo_.onDisconnectSet(this.path_, value, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {*} value
	     * @param {number|string|null} priority
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.setWithPriority = function (value, priority, onComplete) {
	        util_1.validateArgCount('OnDisconnect.setWithPriority', 2, 3, arguments.length);
	        validation_1.validateWritablePath('OnDisconnect.setWithPriority', this.path_);
	        validation_1.validateFirebaseDataArg('OnDisconnect.setWithPriority', 1, value, this.path_, false);
	        validation_1.validatePriority('OnDisconnect.setWithPriority', 2, priority, false);
	        util_1.validateCallback('OnDisconnect.setWithPriority', 3, onComplete, true);
	        var deferred = new util_3.Deferred();
	        this.repo_.onDisconnectSetWithPriority(this.path_, value, priority, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {!Object} objectToMerge
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.update = function (objectToMerge, onComplete) {
	        util_1.validateArgCount('OnDisconnect.update', 1, 2, arguments.length);
	        validation_1.validateWritablePath('OnDisconnect.update', this.path_);
	        if (Array.isArray(objectToMerge)) {
	            var newObjectToMerge = {};
	            for (var i = 0; i < objectToMerge.length; ++i) {
	                newObjectToMerge['' + i] = objectToMerge[i];
	            }
	            objectToMerge = newObjectToMerge;
	            util_2.warn('Passing an Array to firebase.database.onDisconnect().update() is deprecated. Use set() if you want to overwrite the ' +
	                'existing data, or an Object with integer keys if you really do want to only update some of the children.');
	        }
	        validation_1.validateFirebaseMergeDataArg('OnDisconnect.update', 1, objectToMerge, this.path_, false);
	        util_1.validateCallback('OnDisconnect.update', 2, onComplete, true);
	        var deferred = new util_3.Deferred();
	        this.repo_.onDisconnectUpdate(this.path_, objectToMerge, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    return OnDisconnect;
	}());
	exports.OnDisconnect = OnDisconnect;
	
	//# sourceMappingURL=onDisconnect.js.map


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var app_1 = __webpack_require__(35);
	var util_1 = __webpack_require__(2);
	var util_2 = __webpack_require__(2);
	var util_3 = __webpack_require__(2);
	var util_4 = __webpack_require__(13);
	var Path_1 = __webpack_require__(17);
	var VisibilityMonitor_1 = __webpack_require__(440);
	var OnlineMonitor_1 = __webpack_require__(438);
	var util_5 = __webpack_require__(2);
	var Connection_1 = __webpack_require__(187);
	var util_6 = __webpack_require__(2);
	var util_7 = __webpack_require__(2);
	var ServerActions_1 = __webpack_require__(169);
	var RECONNECT_MIN_DELAY = 1000;
	var RECONNECT_MAX_DELAY_DEFAULT = 60 * 5 * 1000; // 5 minutes in milliseconds (Case: 1858)
	var RECONNECT_MAX_DELAY_FOR_ADMINS = 30 * 1000; // 30 seconds for admin clients (likely to be a backend server)
	var RECONNECT_DELAY_MULTIPLIER = 1.3;
	var RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
	var SERVER_KILL_INTERRUPT_REASON = 'server_kill';
	// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
	var INVALID_AUTH_TOKEN_THRESHOLD = 3;
	/**
	 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
	 *
	 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
	 * in quotes to make sure the closure compiler does not minify them.
	 */
	var PersistentConnection = /** @class */ (function (_super) {
	    __extends(PersistentConnection, _super);
	    /**
	     * @implements {ServerActions}
	     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
	     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
	     * @param onConnectStatus_
	     * @param onServerInfoUpdate_
	     * @param authTokenProvider_
	     * @param authOverride_
	     */
	    function PersistentConnection(repoInfo_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, authOverride_) {
	        var _this = _super.call(this) || this;
	        _this.repoInfo_ = repoInfo_;
	        _this.onDataUpdate_ = onDataUpdate_;
	        _this.onConnectStatus_ = onConnectStatus_;
	        _this.onServerInfoUpdate_ = onServerInfoUpdate_;
	        _this.authTokenProvider_ = authTokenProvider_;
	        _this.authOverride_ = authOverride_;
	        // Used for diagnostic logging.
	        _this.id = PersistentConnection.nextPersistentConnectionId_++;
	        _this.log_ = util_4.logWrapper('p:' + _this.id + ':');
	        /** @private {Object} */
	        _this.interruptReasons_ = {};
	        _this.listens_ = {};
	        _this.outstandingPuts_ = [];
	        _this.outstandingPutCount_ = 0;
	        _this.onDisconnectRequestQueue_ = [];
	        _this.connected_ = false;
	        _this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	        _this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_DEFAULT;
	        _this.securityDebugCallback_ = null;
	        _this.lastSessionId = null;
	        /** @private {number|null} */
	        _this.establishConnectionTimer_ = null;
	        /** @private {boolean} */
	        _this.visible_ = false;
	        // Before we get connected, we keep a queue of pending messages to send.
	        _this.requestCBHash_ = {};
	        _this.requestNumber_ = 0;
	        /** @private {?{
	         *   sendRequest(Object),
	         *   close()
	         * }} */
	        _this.realtime_ = null;
	        /** @private {string|null} */
	        _this.authToken_ = null;
	        _this.forceTokenRefresh_ = false;
	        _this.invalidAuthTokenCount_ = 0;
	        _this.firstConnection_ = true;
	        _this.lastConnectionAttemptTime_ = null;
	        _this.lastConnectionEstablishedTime_ = null;
	        if (authOverride_ && !util_7.isNodeSdk()) {
	            throw new Error('Auth override specified in options, but not supported on non Node.js platforms');
	        }
	        _this.scheduleConnect_(0);
	        VisibilityMonitor_1.VisibilityMonitor.getInstance().on('visible', _this.onVisible_, _this);
	        if (repoInfo_.host.indexOf('fblocal') === -1) {
	            OnlineMonitor_1.OnlineMonitor.getInstance().on('online', _this.onOnline_, _this);
	        }
	        return _this;
	    }
	    /**
	     * @param {!string} action
	     * @param {*} body
	     * @param {function(*)=} onResponse
	     * @protected
	     */
	    PersistentConnection.prototype.sendRequest = function (action, body, onResponse) {
	        var curReqNum = ++this.requestNumber_;
	        var msg = { r: curReqNum, a: action, b: body };
	        this.log_(util_2.stringify(msg));
	        util_3.assert(this.connected_, "sendRequest call when we're not connected not allowed.");
	        this.realtime_.sendRequest(msg);
	        if (onResponse) {
	            this.requestCBHash_[curReqNum] = onResponse;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.listen = function (query, currentHashFn, tag, onComplete) {
	        var queryId = query.queryIdentifier();
	        var pathString = query.path.toString();
	        this.log_('Listen called for ' + pathString + ' ' + queryId);
	        this.listens_[pathString] = this.listens_[pathString] || {};
	        util_3.assert(query.getQueryParams().isDefault() ||
	            !query.getQueryParams().loadsAllData(), 'listen() called for non-default but complete query');
	        util_3.assert(!this.listens_[pathString][queryId], 'listen() called twice for same path/queryId.');
	        var listenSpec = {
	            onComplete: onComplete,
	            hashFn: currentHashFn,
	            query: query,
	            tag: tag
	        };
	        this.listens_[pathString][queryId] = listenSpec;
	        if (this.connected_) {
	            this.sendListen_(listenSpec);
	        }
	    };
	    /**
	     * @param {!{onComplete(),
	     *           hashFn():!string,
	     *           query: !Query,
	     *           tag: ?number}} listenSpec
	     * @private
	     */
	    PersistentConnection.prototype.sendListen_ = function (listenSpec) {
	        var _this = this;
	        var query = listenSpec.query;
	        var pathString = query.path.toString();
	        var queryId = query.queryIdentifier();
	        this.log_('Listen on ' + pathString + ' for ' + queryId);
	        var req = { /*path*/ p: pathString };
	        var action = 'q';
	        // Only bother to send query if it's non-default.
	        if (listenSpec.tag) {
	            req['q'] = query.queryObject();
	            req['t'] = listenSpec.tag;
	        }
	        req['h'] = listenSpec.hashFn();
	        this.sendRequest(action, req, function (message) {
	            var payload = message['d'];
	            var status = message['s'];
	            // print warnings in any case...
	            PersistentConnection.warnOnListenWarnings_(payload, query);
	            var currentListenSpec = _this.listens_[pathString] && _this.listens_[pathString][queryId];
	            // only trigger actions if the listen hasn't been removed and readded
	            if (currentListenSpec === listenSpec) {
	                _this.log_('listen response', message);
	                if (status !== 'ok') {
	                    _this.removeListen_(pathString, queryId);
	                }
	                if (listenSpec.onComplete) {
	                    listenSpec.onComplete(status, payload);
	                }
	            }
	        });
	    };
	    /**
	     * @param {*} payload
	     * @param {!Query} query
	     * @private
	     */
	    PersistentConnection.warnOnListenWarnings_ = function (payload, query) {
	        if (payload && typeof payload === 'object' && util_1.contains(payload, 'w')) {
	            var warnings = util_1.safeGet(payload, 'w');
	            if (Array.isArray(warnings) && ~warnings.indexOf('no_index')) {
	                var indexSpec = '".indexOn": "' +
	                    query
	                        .getQueryParams()
	                        .getIndex()
	                        .toString() +
	                    '"';
	                var indexPath = query.path.toString();
	                util_4.warn("Using an unspecified index. Your data will be downloaded and " +
	                    ("filtered on the client. Consider adding " + indexSpec + " at ") +
	                    (indexPath + " to your security rules for better performance."));
	            }
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.refreshAuthToken = function (token) {
	        this.authToken_ = token;
	        this.log_('Auth token refreshed');
	        if (this.authToken_) {
	            this.tryAuth();
	        }
	        else {
	            //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
	            //the credential so we dont become authenticated next time we connect.
	            if (this.connected_) {
	                this.sendRequest('unauth', {}, function () { });
	            }
	        }
	        this.reduceReconnectDelayIfAdminCredential_(token);
	    };
	    /**
	     * @param {!string} credential
	     * @private
	     */
	    PersistentConnection.prototype.reduceReconnectDelayIfAdminCredential_ = function (credential) {
	        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
	        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
	        var isFirebaseSecret = credential && credential.length === 40;
	        if (isFirebaseSecret || util_5.isAdmin(credential)) {
	            this.log_('Admin auth credential detected.  Reducing max reconnect time.');
	            this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
	        }
	    };
	    /**
	     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
	     * a auth revoked (the connection is closed).
	     */
	    PersistentConnection.prototype.tryAuth = function () {
	        var _this = this;
	        if (this.connected_ && this.authToken_) {
	            var token_1 = this.authToken_;
	            var authMethod = util_5.isValidFormat(token_1) ? 'auth' : 'gauth';
	            var requestData = { cred: token_1 };
	            if (this.authOverride_ === null) {
	                requestData['noauth'] = true;
	            }
	            else if (typeof this.authOverride_ === 'object') {
	                requestData['authvar'] = this.authOverride_;
	            }
	            this.sendRequest(authMethod, requestData, function (res) {
	                var status = res['s'];
	                var data = res['d'] || 'error';
	                if (_this.authToken_ === token_1) {
	                    if (status === 'ok') {
	                        _this.invalidAuthTokenCount_ = 0;
	                    }
	                    else {
	                        // Triggers reconnect and force refresh for auth token
	                        _this.onAuthRevoked_(status, data);
	                    }
	                }
	            });
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.unlisten = function (query, tag) {
	        var pathString = query.path.toString();
	        var queryId = query.queryIdentifier();
	        this.log_('Unlisten called for ' + pathString + ' ' + queryId);
	        util_3.assert(query.getQueryParams().isDefault() ||
	            !query.getQueryParams().loadsAllData(), 'unlisten() called for non-default but complete query');
	        var listen = this.removeListen_(pathString, queryId);
	        if (listen && this.connected_) {
	            this.sendUnlisten_(pathString, queryId, query.queryObject(), tag);
	        }
	    };
	    PersistentConnection.prototype.sendUnlisten_ = function (pathString, queryId, queryObj, tag) {
	        this.log_('Unlisten on ' + pathString + ' for ' + queryId);
	        var req = { /*path*/ p: pathString };
	        var action = 'n';
	        // Only bother sending queryId if it's non-default.
	        if (tag) {
	            req['q'] = queryObj;
	            req['t'] = tag;
	        }
	        this.sendRequest(action, req);
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.onDisconnectPut = function (pathString, data, onComplete) {
	        if (this.connected_) {
	            this.sendOnDisconnect_('o', pathString, data, onComplete);
	        }
	        else {
	            this.onDisconnectRequestQueue_.push({
	                pathString: pathString,
	                action: 'o',
	                data: data,
	                onComplete: onComplete
	            });
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.onDisconnectMerge = function (pathString, data, onComplete) {
	        if (this.connected_) {
	            this.sendOnDisconnect_('om', pathString, data, onComplete);
	        }
	        else {
	            this.onDisconnectRequestQueue_.push({
	                pathString: pathString,
	                action: 'om',
	                data: data,
	                onComplete: onComplete
	            });
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.onDisconnectCancel = function (pathString, onComplete) {
	        if (this.connected_) {
	            this.sendOnDisconnect_('oc', pathString, null, onComplete);
	        }
	        else {
	            this.onDisconnectRequestQueue_.push({
	                pathString: pathString,
	                action: 'oc',
	                data: null,
	                onComplete: onComplete
	            });
	        }
	    };
	    PersistentConnection.prototype.sendOnDisconnect_ = function (action, pathString, data, onComplete) {
	        var request = { /*path*/ p: pathString, /*data*/ d: data };
	        this.log_('onDisconnect ' + action, request);
	        this.sendRequest(action, request, function (response) {
	            if (onComplete) {
	                setTimeout(function () {
	                    onComplete(response['s'], response['d']);
	                }, Math.floor(0));
	            }
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.put = function (pathString, data, onComplete, hash) {
	        this.putInternal('p', pathString, data, onComplete, hash);
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.merge = function (pathString, data, onComplete, hash) {
	        this.putInternal('m', pathString, data, onComplete, hash);
	    };
	    PersistentConnection.prototype.putInternal = function (action, pathString, data, onComplete, hash) {
	        var request = {
	            /*path*/ p: pathString,
	            /*data*/ d: data
	        };
	        if (hash !== undefined)
	            request['h'] = hash;
	        // TODO: Only keep track of the most recent put for a given path?
	        this.outstandingPuts_.push({
	            action: action,
	            request: request,
	            onComplete: onComplete
	        });
	        this.outstandingPutCount_++;
	        var index = this.outstandingPuts_.length - 1;
	        if (this.connected_) {
	            this.sendPut_(index);
	        }
	        else {
	            this.log_('Buffering put: ' + pathString);
	        }
	    };
	    PersistentConnection.prototype.sendPut_ = function (index) {
	        var _this = this;
	        var action = this.outstandingPuts_[index].action;
	        var request = this.outstandingPuts_[index].request;
	        var onComplete = this.outstandingPuts_[index].onComplete;
	        this.outstandingPuts_[index].queued = this.connected_;
	        this.sendRequest(action, request, function (message) {
	            _this.log_(action + ' response', message);
	            delete _this.outstandingPuts_[index];
	            _this.outstandingPutCount_--;
	            // Clean up array occasionally.
	            if (_this.outstandingPutCount_ === 0) {
	                _this.outstandingPuts_ = [];
	            }
	            if (onComplete)
	                onComplete(message['s'], message['d']);
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.reportStats = function (stats) {
	        var _this = this;
	        // If we're not connected, we just drop the stats.
	        if (this.connected_) {
	            var request = { /*counters*/ c: stats };
	            this.log_('reportStats', request);
	            this.sendRequest(/*stats*/ 's', request, function (result) {
	                var status = result['s'];
	                if (status !== 'ok') {
	                    var errorReason = result['d'];
	                    _this.log_('reportStats', 'Error sending stats: ' + errorReason);
	                }
	            });
	        }
	    };
	    /**
	     * @param {*} message
	     * @private
	     */
	    PersistentConnection.prototype.onDataMessage_ = function (message) {
	        if ('r' in message) {
	            // this is a response
	            this.log_('from server: ' + util_2.stringify(message));
	            var reqNum = message['r'];
	            var onResponse = this.requestCBHash_[reqNum];
	            if (onResponse) {
	                delete this.requestCBHash_[reqNum];
	                onResponse(message['b']);
	            }
	        }
	        else if ('error' in message) {
	            throw 'A server-side error has occurred: ' + message['error'];
	        }
	        else if ('a' in message) {
	            // a and b are action and body, respectively
	            this.onDataPush_(message['a'], message['b']);
	        }
	    };
	    PersistentConnection.prototype.onDataPush_ = function (action, body) {
	        this.log_('handleServerMessage', action, body);
	        if (action === 'd')
	            this.onDataUpdate_(body['p'], body['d'], 
	            /*isMerge*/ false, body['t']);
	        else if (action === 'm')
	            this.onDataUpdate_(body['p'], body['d'], 
	            /*isMerge=*/ true, body['t']);
	        else if (action === 'c')
	            this.onListenRevoked_(body['p'], body['q']);
	        else if (action === 'ac')
	            this.onAuthRevoked_(body['s'], body['d']);
	        else if (action === 'sd')
	            this.onSecurityDebugPacket_(body);
	        else
	            util_4.error('Unrecognized action received from server: ' +
	                util_2.stringify(action) +
	                '\nAre you using the latest client?');
	    };
	    PersistentConnection.prototype.onReady_ = function (timestamp, sessionId) {
	        this.log_('connection ready');
	        this.connected_ = true;
	        this.lastConnectionEstablishedTime_ = new Date().getTime();
	        this.handleTimestamp_(timestamp);
	        this.lastSessionId = sessionId;
	        if (this.firstConnection_) {
	            this.sendConnectStats_();
	        }
	        this.restoreState_();
	        this.firstConnection_ = false;
	        this.onConnectStatus_(true);
	    };
	    PersistentConnection.prototype.scheduleConnect_ = function (timeout) {
	        var _this = this;
	        util_3.assert(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
	        if (this.establishConnectionTimer_) {
	            clearTimeout(this.establishConnectionTimer_);
	        }
	        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
	        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
	        this.establishConnectionTimer_ = setTimeout(function () {
	            _this.establishConnectionTimer_ = null;
	            _this.establishConnection_();
	        }, Math.floor(timeout));
	    };
	    /**
	     * @param {boolean} visible
	     * @private
	     */
	    PersistentConnection.prototype.onVisible_ = function (visible) {
	        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
	        if (visible &&
	            !this.visible_ &&
	            this.reconnectDelay_ === this.maxReconnectDelay_) {
	            this.log_('Window became visible.  Reducing delay.');
	            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	            if (!this.realtime_) {
	                this.scheduleConnect_(0);
	            }
	        }
	        this.visible_ = visible;
	    };
	    PersistentConnection.prototype.onOnline_ = function (online) {
	        if (online) {
	            this.log_('Browser went online.');
	            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	            if (!this.realtime_) {
	                this.scheduleConnect_(0);
	            }
	        }
	        else {
	            this.log_('Browser went offline.  Killing connection.');
	            if (this.realtime_) {
	                this.realtime_.close();
	            }
	        }
	    };
	    PersistentConnection.prototype.onRealtimeDisconnect_ = function () {
	        this.log_('data client disconnected');
	        this.connected_ = false;
	        this.realtime_ = null;
	        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
	        this.cancelSentTransactions_();
	        // Clear out the pending requests.
	        this.requestCBHash_ = {};
	        if (this.shouldReconnect_()) {
	            if (!this.visible_) {
	                this.log_("Window isn't visible.  Delaying reconnect.");
	                this.reconnectDelay_ = this.maxReconnectDelay_;
	                this.lastConnectionAttemptTime_ = new Date().getTime();
	            }
	            else if (this.lastConnectionEstablishedTime_) {
	                // If we've been connected long enough, reset reconnect delay to minimum.
	                var timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
	                if (timeSinceLastConnectSucceeded > RECONNECT_DELAY_RESET_TIMEOUT)
	                    this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	                this.lastConnectionEstablishedTime_ = null;
	            }
	            var timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
	            var reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
	            reconnectDelay = Math.random() * reconnectDelay;
	            this.log_('Trying to reconnect in ' + reconnectDelay + 'ms');
	            this.scheduleConnect_(reconnectDelay);
	            // Adjust reconnect delay for next time.
	            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * RECONNECT_DELAY_MULTIPLIER);
	        }
	        this.onConnectStatus_(false);
	    };
	    PersistentConnection.prototype.establishConnection_ = function () {
	        if (this.shouldReconnect_()) {
	            this.log_('Making a connection attempt');
	            this.lastConnectionAttemptTime_ = new Date().getTime();
	            this.lastConnectionEstablishedTime_ = null;
	            var onDataMessage_1 = this.onDataMessage_.bind(this);
	            var onReady_1 = this.onReady_.bind(this);
	            var onDisconnect_1 = this.onRealtimeDisconnect_.bind(this);
	            var connId_1 = this.id + ':' + PersistentConnection.nextConnectionId_++;
	            var self_1 = this;
	            var lastSessionId_1 = this.lastSessionId;
	            var canceled_1 = false;
	            var connection_1 = null;
	            var closeFn_1 = function () {
	                if (connection_1) {
	                    connection_1.close();
	                }
	                else {
	                    canceled_1 = true;
	                    onDisconnect_1();
	                }
	            };
	            var sendRequestFn = function (msg) {
	                util_3.assert(connection_1, "sendRequest call when we're not connected not allowed.");
	                connection_1.sendRequest(msg);
	            };
	            this.realtime_ = {
	                close: closeFn_1,
	                sendRequest: sendRequestFn
	            };
	            var forceRefresh = this.forceTokenRefresh_;
	            this.forceTokenRefresh_ = false;
	            // First fetch auth token, and establish connection after fetching the token was successful
	            this.authTokenProvider_
	                .getToken(forceRefresh)
	                .then(function (result) {
	                if (!canceled_1) {
	                    util_4.log('getToken() completed. Creating connection.');
	                    self_1.authToken_ = result && result.accessToken;
	                    connection_1 = new Connection_1.Connection(connId_1, self_1.repoInfo_, onDataMessage_1, onReady_1, onDisconnect_1, 
	                    /* onKill= */ function (reason) {
	                        util_4.warn(reason + ' (' + self_1.repoInfo_.toString() + ')');
	                        self_1.interrupt(SERVER_KILL_INTERRUPT_REASON);
	                    }, lastSessionId_1);
	                }
	                else {
	                    util_4.log('getToken() completed but was canceled');
	                }
	            })
	                .then(null, function (error) {
	                self_1.log_('Failed to get token: ' + error);
	                if (!canceled_1) {
	                    if (util_6.CONSTANTS.NODE_ADMIN) {
	                        // This may be a critical error for the Admin Node.js SDK, so log a warning.
	                        // But getToken() may also just have temporarily failed, so we still want to
	                        // continue retrying.
	                        util_4.warn(error);
	                    }
	                    closeFn_1();
	                }
	            });
	        }
	    };
	    /**
	     * @param {string} reason
	     */
	    PersistentConnection.prototype.interrupt = function (reason) {
	        util_4.log('Interrupting connection for reason: ' + reason);
	        this.interruptReasons_[reason] = true;
	        if (this.realtime_) {
	            this.realtime_.close();
	        }
	        else {
	            if (this.establishConnectionTimer_) {
	                clearTimeout(this.establishConnectionTimer_);
	                this.establishConnectionTimer_ = null;
	            }
	            if (this.connected_) {
	                this.onRealtimeDisconnect_();
	            }
	        }
	    };
	    /**
	     * @param {string} reason
	     */
	    PersistentConnection.prototype.resume = function (reason) {
	        util_4.log('Resuming connection for reason: ' + reason);
	        delete this.interruptReasons_[reason];
	        if (util_1.isEmpty(this.interruptReasons_)) {
	            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	            if (!this.realtime_) {
	                this.scheduleConnect_(0);
	            }
	        }
	    };
	    PersistentConnection.prototype.handleTimestamp_ = function (timestamp) {
	        var delta = timestamp - new Date().getTime();
	        this.onServerInfoUpdate_({ serverTimeOffset: delta });
	    };
	    PersistentConnection.prototype.cancelSentTransactions_ = function () {
	        for (var i = 0; i < this.outstandingPuts_.length; i++) {
	            var put = this.outstandingPuts_[i];
	            if (put && /*hash*/ 'h' in put.request && put.queued) {
	                if (put.onComplete)
	                    put.onComplete('disconnect');
	                delete this.outstandingPuts_[i];
	                this.outstandingPutCount_--;
	            }
	        }
	        // Clean up array occasionally.
	        if (this.outstandingPutCount_ === 0)
	            this.outstandingPuts_ = [];
	    };
	    /**
	     * @param {!string} pathString
	     * @param {Array.<*>=} query
	     * @private
	     */
	    PersistentConnection.prototype.onListenRevoked_ = function (pathString, query) {
	        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
	        var queryId;
	        if (!query) {
	            queryId = 'default';
	        }
	        else {
	            queryId = query.map(function (q) { return util_4.ObjectToUniqueKey(q); }).join('$');
	        }
	        var listen = this.removeListen_(pathString, queryId);
	        if (listen && listen.onComplete)
	            listen.onComplete('permission_denied');
	    };
	    /**
	     * @param {!string} pathString
	     * @param {!string} queryId
	     * @return {{queries:Array.<Query>, onComplete:function(string)}}
	     * @private
	     */
	    PersistentConnection.prototype.removeListen_ = function (pathString, queryId) {
	        var normalizedPathString = new Path_1.Path(pathString).toString(); // normalize path.
	        var listen;
	        if (this.listens_[normalizedPathString] !== undefined) {
	            listen = this.listens_[normalizedPathString][queryId];
	            delete this.listens_[normalizedPathString][queryId];
	            if (util_1.getCount(this.listens_[normalizedPathString]) === 0) {
	                delete this.listens_[normalizedPathString];
	            }
	        }
	        else {
	            // all listens for this path has already been removed
	            listen = undefined;
	        }
	        return listen;
	    };
	    PersistentConnection.prototype.onAuthRevoked_ = function (statusCode, explanation) {
	        util_4.log('Auth token revoked: ' + statusCode + '/' + explanation);
	        this.authToken_ = null;
	        this.forceTokenRefresh_ = true;
	        this.realtime_.close();
	        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
	            // We'll wait a couple times before logging the warning / increasing the
	            // retry period since oauth tokens will report as "invalid" if they're
	            // just expired. Plus there may be transient issues that resolve themselves.
	            this.invalidAuthTokenCount_++;
	            if (this.invalidAuthTokenCount_ >= INVALID_AUTH_TOKEN_THRESHOLD) {
	                // Set a long reconnect delay because recovery is unlikely
	                this.reconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
	                // Notify the auth token provider that the token is invalid, which will log
	                // a warning
	                this.authTokenProvider_.notifyForInvalidToken();
	            }
	        }
	    };
	    PersistentConnection.prototype.onSecurityDebugPacket_ = function (body) {
	        if (this.securityDebugCallback_) {
	            this.securityDebugCallback_(body);
	        }
	        else {
	            if ('msg' in body && typeof console !== 'undefined') {
	                console.log('FIREBASE: ' + body['msg'].replace('\n', '\nFIREBASE: '));
	            }
	        }
	    };
	    PersistentConnection.prototype.restoreState_ = function () {
	        var _this = this;
	        //Re-authenticate ourselves if we have a credential stored.
	        this.tryAuth();
	        // Puts depend on having received the corresponding data update from the server before they complete, so we must
	        // make sure to send listens before puts.
	        util_1.forEach(this.listens_, function (pathString, queries) {
	            util_1.forEach(queries, function (key, listenSpec) {
	                _this.sendListen_(listenSpec);
	            });
	        });
	        for (var i = 0; i < this.outstandingPuts_.length; i++) {
	            if (this.outstandingPuts_[i])
	                this.sendPut_(i);
	        }
	        while (this.onDisconnectRequestQueue_.length) {
	            var request = this.onDisconnectRequestQueue_.shift();
	            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
	        }
	    };
	    /**
	     * Sends client stats for first connection
	     * @private
	     */
	    PersistentConnection.prototype.sendConnectStats_ = function () {
	        var stats = {};
	        var clientName = 'js';
	        if (util_6.CONSTANTS.NODE_ADMIN) {
	            clientName = 'admin_node';
	        }
	        else if (util_6.CONSTANTS.NODE_CLIENT) {
	            clientName = 'node';
	        }
	        stats['sdk.' + clientName + '.' + app_1.default.SDK_VERSION.replace(/\./g, '-')] = 1;
	        if (util_7.isMobileCordova()) {
	            stats['framework.cordova'] = 1;
	        }
	        else if (util_7.isReactNative()) {
	            stats['framework.reactnative'] = 1;
	        }
	        this.reportStats(stats);
	    };
	    /**
	     * @return {boolean}
	     * @private
	     */
	    PersistentConnection.prototype.shouldReconnect_ = function () {
	        var online = OnlineMonitor_1.OnlineMonitor.getInstance().currentlyOnline();
	        return util_1.isEmpty(this.interruptReasons_) && online;
	    };
	    /**
	     * @private
	     */
	    PersistentConnection.nextPersistentConnectionId_ = 0;
	    /**
	     * Counter for number of connections created. Mainly used for tagging in the logs
	     * @type {number}
	     * @private
	     */
	    PersistentConnection.nextConnectionId_ = 0;
	    return PersistentConnection;
	}(ServerActions_1.ServerActions));
	exports.PersistentConnection = PersistentConnection;
	
	//# sourceMappingURL=PersistentConnection.js.map


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var util_2 = __webpack_require__(2);
	var storage_1 = __webpack_require__(89);
	var Constants_1 = __webpack_require__(92);
	/**
	 * A class that holds metadata about a Repo object
	 *
	 * @constructor
	 */
	var RepoInfo = /** @class */ (function () {
	    /**
	     * @param {string} host Hostname portion of the url for the repo
	     * @param {boolean} secure Whether or not this repo is accessed over ssl
	     * @param {string} namespace The namespace represented by the repo
	     * @param {boolean} webSocketOnly Whether to prefer websockets over all other transports (used by Nest).
	     * @param {string=} persistenceKey Override the default session persistence storage key
	     */
	    function RepoInfo(host, secure, namespace, webSocketOnly, persistenceKey) {
	        if (persistenceKey === void 0) { persistenceKey = ''; }
	        this.secure = secure;
	        this.namespace = namespace;
	        this.webSocketOnly = webSocketOnly;
	        this.persistenceKey = persistenceKey;
	        this.host = host.toLowerCase();
	        this.domain = this.host.substr(this.host.indexOf('.') + 1);
	        this.internalHost = storage_1.PersistentStorage.get('host:' + host) || this.host;
	    }
	    RepoInfo.prototype.needsQueryParam = function () {
	        return this.host !== this.internalHost;
	    };
	    RepoInfo.prototype.isCacheableHost = function () {
	        return this.internalHost.substr(0, 2) === 's-';
	    };
	    RepoInfo.prototype.isDemoHost = function () {
	        return this.domain === 'firebaseio-demo.com';
	    };
	    RepoInfo.prototype.isCustomHost = function () {
	        return (this.domain !== 'firebaseio.com' && this.domain !== 'firebaseio-demo.com');
	    };
	    RepoInfo.prototype.updateHost = function (newHost) {
	        if (newHost !== this.internalHost) {
	            this.internalHost = newHost;
	            if (this.isCacheableHost()) {
	                storage_1.PersistentStorage.set('host:' + this.host, this.internalHost);
	            }
	        }
	    };
	    /**
	     * Returns the websocket URL for this repo
	     * @param {string} type of connection
	     * @param {Object} params list
	     * @return {string} The URL for this repo
	     */
	    RepoInfo.prototype.connectionURL = function (type, params) {
	        util_1.assert(typeof type === 'string', 'typeof type must == string');
	        util_1.assert(typeof params === 'object', 'typeof params must == object');
	        var connURL;
	        if (type === Constants_1.WEBSOCKET) {
	            connURL =
	                (this.secure ? 'wss://' : 'ws://') + this.internalHost + '/.ws?';
	        }
	        else if (type === Constants_1.LONG_POLLING) {
	            connURL =
	                (this.secure ? 'https://' : 'http://') + this.internalHost + '/.lp?';
	        }
	        else {
	            throw new Error('Unknown connection type: ' + type);
	        }
	        if (this.needsQueryParam()) {
	            params['ns'] = this.namespace;
	        }
	        var pairs = [];
	        util_2.forEach(params, function (key, value) {
	            pairs.push(key + '=' + value);
	        });
	        return connURL + pairs.join('&');
	    };
	    /** @return {string} */
	    RepoInfo.prototype.toString = function () {
	        var str = this.toURLString();
	        if (this.persistenceKey) {
	            str += '<' + this.persistenceKey + '>';
	        }
	        return str;
	    };
	    /** @return {string} */
	    RepoInfo.prototype.toURLString = function () {
	        return (this.secure ? 'https://' : 'http://') + this.host;
	    };
	    return RepoInfo;
	}());
	exports.RepoInfo = RepoInfo;
	
	//# sourceMappingURL=RepoInfo.js.map


/***/ },
/* 169 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Interface defining the set of actions that can be performed against the Firebase server
	 * (basically corresponds to our wire protocol).
	 *
	 * @interface
	 */
	var ServerActions = /** @class */ (function () {
	    function ServerActions() {
	    }
	    /**
	     * @param {string} pathString
	     * @param {*} data
	     * @param {function(string, string)=} onComplete
	     * @param {string=} hash
	     */
	    ServerActions.prototype.put = function (pathString, data, onComplete, hash) { };
	    /**
	     * @param {string} pathString
	     * @param {*} data
	     * @param {function(string, ?string)} onComplete
	     * @param {string=} hash
	     */
	    ServerActions.prototype.merge = function (pathString, data, onComplete, hash) { };
	    /**
	     * Refreshes the auth token for the current connection.
	     * @param {string} token The authentication token
	     */
	    ServerActions.prototype.refreshAuthToken = function (token) { };
	    /**
	     * @param {string} pathString
	     * @param {*} data
	     * @param {function(string, string)=} onComplete
	     */
	    ServerActions.prototype.onDisconnectPut = function (pathString, data, onComplete) { };
	    /**
	     * @param {string} pathString
	     * @param {*} data
	     * @param {function(string, string)=} onComplete
	     */
	    ServerActions.prototype.onDisconnectMerge = function (pathString, data, onComplete) { };
	    /**
	     * @param {string} pathString
	     * @param {function(string, string)=} onComplete
	     */
	    ServerActions.prototype.onDisconnectCancel = function (pathString, onComplete) { };
	    /**
	     * @param {Object.<string, *>} stats
	     */
	    ServerActions.prototype.reportStats = function (stats) { };
	    return ServerActions;
	}());
	exports.ServerActions = ServerActions;
	
	//# sourceMappingURL=ServerActions.js.map


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Path_1 = __webpack_require__(17);
	var PriorityIndex_1 = __webpack_require__(26);
	var CountedSet_1 = __webpack_require__(180);
	/**
	 * Helper class to store a sparse set of snapshots.
	 *
	 * @constructor
	 */
	var SparseSnapshotTree = /** @class */ (function () {
	    function SparseSnapshotTree() {
	        /**
	         * @private
	         * @type {Node}
	         */
	        this.value_ = null;
	        /**
	         * @private
	         * @type {CountedSet}
	         */
	        this.children_ = null;
	    }
	    /**
	     * Gets the node stored at the given path if one exists.
	     *
	     * @param {!Path} path Path to look up snapshot for.
	     * @return {?Node} The retrieved node, or null.
	     */
	    SparseSnapshotTree.prototype.find = function (path) {
	        if (this.value_ != null) {
	            return this.value_.getChild(path);
	        }
	        else if (!path.isEmpty() && this.children_ != null) {
	            var childKey = path.getFront();
	            path = path.popFront();
	            if (this.children_.contains(childKey)) {
	                var childTree = this.children_.get(childKey);
	                return childTree.find(path);
	            }
	            else {
	                return null;
	            }
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * Stores the given node at the specified path. If there is already a node
	     * at a shallower path, it merges the new data into that snapshot node.
	     *
	     * @param {!Path} path Path to look up snapshot for.
	     * @param {!Node} data The new data, or null.
	     */
	    SparseSnapshotTree.prototype.remember = function (path, data) {
	        if (path.isEmpty()) {
	            this.value_ = data;
	            this.children_ = null;
	        }
	        else if (this.value_ !== null) {
	            this.value_ = this.value_.updateChild(path, data);
	        }
	        else {
	            if (this.children_ == null) {
	                this.children_ = new CountedSet_1.CountedSet();
	            }
	            var childKey = path.getFront();
	            if (!this.children_.contains(childKey)) {
	                this.children_.add(childKey, new SparseSnapshotTree());
	            }
	            var child = this.children_.get(childKey);
	            path = path.popFront();
	            child.remember(path, data);
	        }
	    };
	    /**
	     * Purge the data at path from the cache.
	     *
	     * @param {!Path} path Path to look up snapshot for.
	     * @return {boolean} True if this node should now be removed.
	     */
	    SparseSnapshotTree.prototype.forget = function (path) {
	        if (path.isEmpty()) {
	            this.value_ = null;
	            this.children_ = null;
	            return true;
	        }
	        else {
	            if (this.value_ !== null) {
	                if (this.value_.isLeafNode()) {
	                    // We're trying to forget a node that doesn't exist
	                    return false;
	                }
	                else {
	                    var value = this.value_;
	                    this.value_ = null;
	                    var self_1 = this;
	                    value.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (key, tree) {
	                        self_1.remember(new Path_1.Path(key), tree);
	                    });
	                    return this.forget(path);
	                }
	            }
	            else if (this.children_ !== null) {
	                var childKey = path.getFront();
	                path = path.popFront();
	                if (this.children_.contains(childKey)) {
	                    var safeToRemove = this.children_.get(childKey).forget(path);
	                    if (safeToRemove) {
	                        this.children_.remove(childKey);
	                    }
	                }
	                if (this.children_.isEmpty()) {
	                    this.children_ = null;
	                    return true;
	                }
	                else {
	                    return false;
	                }
	            }
	            else {
	                return true;
	            }
	        }
	    };
	    /**
	     * Recursively iterates through all of the stored tree and calls the
	     * callback on each one.
	     *
	     * @param {!Path} prefixPath Path to look up node for.
	     * @param {!Function} func The function to invoke for each tree.
	     */
	    SparseSnapshotTree.prototype.forEachTree = function (prefixPath, func) {
	        if (this.value_ !== null) {
	            func(prefixPath, this.value_);
	        }
	        else {
	            this.forEachChild(function (key, tree) {
	                var path = new Path_1.Path(prefixPath.toString() + '/' + key);
	                tree.forEachTree(path, func);
	            });
	        }
	    };
	    /**
	     * Iterates through each immediate child and triggers the callback.
	     *
	     * @param {!Function} func The function to invoke for each child.
	     */
	    SparseSnapshotTree.prototype.forEachChild = function (func) {
	        if (this.children_ !== null) {
	            this.children_.each(function (key, tree) {
	                func(key, tree);
	            });
	        }
	    };
	    return SparseSnapshotTree;
	}());
	exports.SparseSnapshotTree = SparseSnapshotTree;
	
	//# sourceMappingURL=SparseSnapshotTree.js.map


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var CacheNode_1 = __webpack_require__(91);
	var ChildrenNode_1 = __webpack_require__(28);
	var util_1 = __webpack_require__(2);
	var util_2 = __webpack_require__(2);
	var ViewCache_1 = __webpack_require__(184);
	var View_1 = __webpack_require__(448);
	var __referenceConstructor;
	/**
	 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
	 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
	 * and user writes (set, transaction, update).
	 *
	 * It's responsible for:
	 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
	 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
	 *    applyUserOverwrite, etc.)
	 */
	var SyncPoint = /** @class */ (function () {
	    function SyncPoint() {
	        /**
	         * The Views being tracked at this location in the tree, stored as a map where the key is a
	         * queryId and the value is the View for that query.
	         *
	         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
	         *
	         * @type {!Object.<!string, !View>}
	         * @private
	         */
	        this.views_ = {};
	    }
	    Object.defineProperty(SyncPoint, "__referenceConstructor", {
	        get: function () {
	            util_1.assert(__referenceConstructor, 'Reference.ts has not been loaded');
	            return __referenceConstructor;
	        },
	        set: function (val) {
	            util_1.assert(!__referenceConstructor, '__referenceConstructor has already been defined');
	            __referenceConstructor = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {boolean}
	     */
	    SyncPoint.prototype.isEmpty = function () {
	        return util_2.isEmpty(this.views_);
	    };
	    /**
	     *
	     * @param {!Operation} operation
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} optCompleteServerCache
	     * @return {!Array.<!Event>}
	     */
	    SyncPoint.prototype.applyOperation = function (operation, writesCache, optCompleteServerCache) {
	        var queryId = operation.source.queryId;
	        if (queryId !== null) {
	            var view = util_2.safeGet(this.views_, queryId);
	            util_1.assert(view != null, 'SyncTree gave us an op for an invalid query.');
	            return view.applyOperation(operation, writesCache, optCompleteServerCache);
	        }
	        else {
	            var events_1 = [];
	            util_2.forEach(this.views_, function (key, view) {
	                events_1 = events_1.concat(view.applyOperation(operation, writesCache, optCompleteServerCache));
	            });
	            return events_1;
	        }
	    };
	    /**
	     * Add an event callback for the specified query.
	     *
	     * @param {!Query} query
	     * @param {!EventRegistration} eventRegistration
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} serverCache Complete server cache, if we have it.
	     * @param {boolean} serverCacheComplete
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncPoint.prototype.addEventRegistration = function (query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
	        var queryId = query.queryIdentifier();
	        var view = util_2.safeGet(this.views_, queryId);
	        if (!view) {
	            // TODO: make writesCache take flag for complete server node
	            var eventCache = writesCache.calcCompleteEventCache(serverCacheComplete ? serverCache : null);
	            var eventCacheComplete = false;
	            if (eventCache) {
	                eventCacheComplete = true;
	            }
	            else if (serverCache instanceof ChildrenNode_1.ChildrenNode) {
	                eventCache = writesCache.calcCompleteEventChildren(serverCache);
	                eventCacheComplete = false;
	            }
	            else {
	                eventCache = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	                eventCacheComplete = false;
	            }
	            var viewCache = new ViewCache_1.ViewCache(new CacheNode_1.CacheNode(
	            /** @type {!Node} */ (eventCache), eventCacheComplete, false), new CacheNode_1.CacheNode(
	            /** @type {!Node} */ (serverCache), serverCacheComplete, false));
	            view = new View_1.View(query, viewCache);
	            this.views_[queryId] = view;
	        }
	        // This is guaranteed to exist now, we just created anything that was missing
	        view.addEventRegistration(eventRegistration);
	        return view.getInitialEvents(eventRegistration);
	    };
	    /**
	     * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
	     *
	     * If query is the default query, we'll check all views for the specified eventRegistration.
	     * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
	     *
	     * @param {!Query} query
	     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
	     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
	     * @return {{removed:!Array.<!Query>, events:!Array.<!Event>}} removed queries and any cancel events
	     */
	    SyncPoint.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
	        var queryId = query.queryIdentifier();
	        var removed = [];
	        var cancelEvents = [];
	        var hadCompleteView = this.hasCompleteView();
	        if (queryId === 'default') {
	            // When you do ref.off(...), we search all views for the registration to remove.
	            var self_1 = this;
	            util_2.forEach(this.views_, function (viewQueryId, view) {
	                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
	                if (view.isEmpty()) {
	                    delete self_1.views_[viewQueryId];
	                    // We'll deal with complete views later.
	                    if (!view
	                        .getQuery()
	                        .getQueryParams()
	                        .loadsAllData()) {
	                        removed.push(view.getQuery());
	                    }
	                }
	            });
	        }
	        else {
	            // remove the callback from the specific view.
	            var view = util_2.safeGet(this.views_, queryId);
	            if (view) {
	                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
	                if (view.isEmpty()) {
	                    delete this.views_[queryId];
	                    // We'll deal with complete views later.
	                    if (!view
	                        .getQuery()
	                        .getQueryParams()
	                        .loadsAllData()) {
	                        removed.push(view.getQuery());
	                    }
	                }
	            }
	        }
	        if (hadCompleteView && !this.hasCompleteView()) {
	            // We removed our last complete view.
	            removed.push(new SyncPoint.__referenceConstructor(query.repo, query.path));
	        }
	        return { removed: removed, events: cancelEvents };
	    };
	    /**
	     * @return {!Array.<!View>}
	     */
	    SyncPoint.prototype.getQueryViews = function () {
	        var _this = this;
	        var values = Object.keys(this.views_).map(function (key) { return _this.views_[key]; });
	        return values.filter(function (view) {
	            return !view
	                .getQuery()
	                .getQueryParams()
	                .loadsAllData();
	        });
	    };
	    /**
	     *
	     * @param {!Path} path The path to the desired complete snapshot
	     * @return {?Node} A complete cache, if it exists
	     */
	    SyncPoint.prototype.getCompleteServerCache = function (path) {
	        var serverCache = null;
	        util_2.forEach(this.views_, function (key, view) {
	            serverCache = serverCache || view.getCompleteServerCache(path);
	        });
	        return serverCache;
	    };
	    /**
	     * @param {!Query} query
	     * @return {?View}
	     */
	    SyncPoint.prototype.viewForQuery = function (query) {
	        var params = query.getQueryParams();
	        if (params.loadsAllData()) {
	            return this.getCompleteView();
	        }
	        else {
	            var queryId = query.queryIdentifier();
	            return util_2.safeGet(this.views_, queryId);
	        }
	    };
	    /**
	     * @param {!Query} query
	     * @return {boolean}
	     */
	    SyncPoint.prototype.viewExistsForQuery = function (query) {
	        return this.viewForQuery(query) != null;
	    };
	    /**
	     * @return {boolean}
	     */
	    SyncPoint.prototype.hasCompleteView = function () {
	        return this.getCompleteView() != null;
	    };
	    /**
	     * @return {?View}
	     */
	    SyncPoint.prototype.getCompleteView = function () {
	        var completeView = util_2.findValue(this.views_, function (view) {
	            return view
	                .getQuery()
	                .getQueryParams()
	                .loadsAllData();
	        });
	        return completeView || null;
	    };
	    return SyncPoint;
	}());
	exports.SyncPoint = SyncPoint;
	
	//# sourceMappingURL=SyncPoint.js.map


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Operation_1 = __webpack_require__(47);
	var Path_1 = __webpack_require__(17);
	/**
	 * @param {!OperationSource} source
	 * @param {!Path} path
	 * @param {!Node} snap
	 * @constructor
	 * @implements {Operation}
	 */
	var Overwrite = /** @class */ (function () {
	    function Overwrite(source, path, snap) {
	        this.source = source;
	        this.path = path;
	        this.snap = snap;
	        /** @inheritDoc */
	        this.type = Operation_1.OperationType.OVERWRITE;
	    }
	    Overwrite.prototype.operationForChild = function (childName) {
	        if (this.path.isEmpty()) {
	            return new Overwrite(this.source, Path_1.Path.Empty, this.snap.getImmediateChild(childName));
	        }
	        else {
	            return new Overwrite(this.source, this.path.popFront(), this.snap);
	        }
	    };
	    return Overwrite;
	}());
	exports.Overwrite = Overwrite;
	
	//# sourceMappingURL=Overwrite.js.map


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var childSet_1 = __webpack_require__(174);
	var util_2 = __webpack_require__(2);
	var Node_1 = __webpack_require__(30);
	var PriorityIndex_1 = __webpack_require__(26);
	var KeyIndex_1 = __webpack_require__(67);
	var _defaultIndexMap;
	var fallbackObject = {};
	/**
	 *
	 * @param {Object.<string, FallbackType|SortedMap.<NamedNode, Node>>} indexes
	 * @param {Object.<string, Index>} indexSet
	 * @constructor
	 */
	var IndexMap = /** @class */ (function () {
	    function IndexMap(indexes_, indexSet_) {
	        this.indexes_ = indexes_;
	        this.indexSet_ = indexSet_;
	    }
	    Object.defineProperty(IndexMap, "Default", {
	        /**
	         * The default IndexMap for nodes without a priority
	         * @type {!IndexMap}
	         * @const
	         */
	        get: function () {
	            util_1.assert(fallbackObject && PriorityIndex_1.PRIORITY_INDEX, 'ChildrenNode.ts has not been loaded');
	            _defaultIndexMap =
	                _defaultIndexMap ||
	                    new IndexMap({ '.priority': fallbackObject }, { '.priority': PriorityIndex_1.PRIORITY_INDEX });
	            return _defaultIndexMap;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     *
	     * @param {!string} indexKey
	     * @return {?SortedMap.<NamedNode, Node>}
	     */
	    IndexMap.prototype.get = function (indexKey) {
	        var sortedMap = util_2.safeGet(this.indexes_, indexKey);
	        if (!sortedMap)
	            throw new Error('No index defined for ' + indexKey);
	        if (sortedMap === fallbackObject) {
	            // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
	            // regular child map
	            return null;
	        }
	        else {
	            return sortedMap;
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {boolean}
	     */
	    IndexMap.prototype.hasIndex = function (indexDefinition) {
	        return util_2.contains(this.indexSet_, indexDefinition.toString());
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @param {!SortedMap.<string, !Node>} existingChildren
	     * @return {!IndexMap}
	     */
	    IndexMap.prototype.addIndex = function (indexDefinition, existingChildren) {
	        util_1.assert(indexDefinition !== KeyIndex_1.KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
	        var childList = [];
	        var sawIndexedValue = false;
	        var iter = existingChildren.getIterator(Node_1.NamedNode.Wrap);
	        var next = iter.getNext();
	        while (next) {
	            sawIndexedValue =
	                sawIndexedValue || indexDefinition.isDefinedOn(next.node);
	            childList.push(next);
	            next = iter.getNext();
	        }
	        var newIndex;
	        if (sawIndexedValue) {
	            newIndex = childSet_1.buildChildSet(childList, indexDefinition.getCompare());
	        }
	        else {
	            newIndex = fallbackObject;
	        }
	        var indexName = indexDefinition.toString();
	        var newIndexSet = util_2.clone(this.indexSet_);
	        newIndexSet[indexName] = indexDefinition;
	        var newIndexes = util_2.clone(this.indexes_);
	        newIndexes[indexName] = newIndex;
	        return new IndexMap(newIndexes, newIndexSet);
	    };
	    /**
	     * Ensure that this node is properly tracked in any indexes that we're maintaining
	     * @param {!NamedNode} namedNode
	     * @param {!SortedMap.<string, !Node>} existingChildren
	     * @return {!IndexMap}
	     */
	    IndexMap.prototype.addToIndexes = function (namedNode, existingChildren) {
	        var _this = this;
	        var newIndexes = util_2.map(this.indexes_, function (indexedChildren, indexName) {
	            var index = util_2.safeGet(_this.indexSet_, indexName);
	            util_1.assert(index, 'Missing index implementation for ' + indexName);
	            if (indexedChildren === fallbackObject) {
	                // Check to see if we need to index everything
	                if (index.isDefinedOn(namedNode.node)) {
	                    // We need to build this index
	                    var childList = [];
	                    var iter = existingChildren.getIterator(Node_1.NamedNode.Wrap);
	                    var next = iter.getNext();
	                    while (next) {
	                        if (next.name != namedNode.name) {
	                            childList.push(next);
	                        }
	                        next = iter.getNext();
	                    }
	                    childList.push(namedNode);
	                    return childSet_1.buildChildSet(childList, index.getCompare());
	                }
	                else {
	                    // No change, this remains a fallback
	                    return fallbackObject;
	                }
	            }
	            else {
	                var existingSnap = existingChildren.get(namedNode.name);
	                var newChildren = indexedChildren;
	                if (existingSnap) {
	                    newChildren = newChildren.remove(new Node_1.NamedNode(namedNode.name, existingSnap));
	                }
	                return newChildren.insert(namedNode, namedNode.node);
	            }
	        });
	        return new IndexMap(newIndexes, this.indexSet_);
	    };
	    /**
	     * Create a new IndexMap instance with the given value removed
	     * @param {!NamedNode} namedNode
	     * @param {!SortedMap.<string, !Node>} existingChildren
	     * @return {!IndexMap}
	     */
	    IndexMap.prototype.removeFromIndexes = function (namedNode, existingChildren) {
	        var newIndexes = util_2.map(this.indexes_, function (indexedChildren) {
	            if (indexedChildren === fallbackObject) {
	                // This is the fallback. Just return it, nothing to do in this case
	                return indexedChildren;
	            }
	            else {
	                var existingSnap = existingChildren.get(namedNode.name);
	                if (existingSnap) {
	                    return indexedChildren.remove(new Node_1.NamedNode(namedNode.name, existingSnap));
	                }
	                else {
	                    // No record of this child
	                    return indexedChildren;
	                }
	            }
	        });
	        return new IndexMap(newIndexes, this.indexSet_);
	    };
	    return IndexMap;
	}());
	exports.IndexMap = IndexMap;
	
	//# sourceMappingURL=IndexMap.js.map


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var SortedMap_1 = __webpack_require__(90);
	var SortedMap_2 = __webpack_require__(90);
	var LOG_2 = Math.log(2);
	/**
	 * @constructor
	 */
	var Base12Num = /** @class */ (function () {
	    /**
	     * @param {number} length
	     */
	    function Base12Num(length) {
	        var logBase2 = function (num) {
	            return parseInt((Math.log(num) / LOG_2), 10);
	        };
	        var bitMask = function (bits) { return parseInt(Array(bits + 1).join('1'), 2); };
	        this.count = logBase2(length + 1);
	        this.current_ = this.count - 1;
	        var mask = bitMask(this.count);
	        this.bits_ = (length + 1) & mask;
	    }
	    /**
	     * @return {boolean}
	     */
	    Base12Num.prototype.nextBitIsOne = function () {
	        //noinspection JSBitwiseOperatorUsage
	        var result = !(this.bits_ & (0x1 << this.current_));
	        this.current_--;
	        return result;
	    };
	    return Base12Num;
	}());
	/**
	 * Takes a list of child nodes and constructs a SortedSet using the given comparison
	 * function
	 *
	 * Uses the algorithm described in the paper linked here:
	 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
	 *
	 * @template K, V
	 * @param {Array.<!NamedNode>} childList Unsorted list of children
	 * @param {function(!NamedNode, !NamedNode):number} cmp The comparison method to be used
	 * @param {(function(NamedNode):K)=} keyFn An optional function to extract K from a node wrapper, if K's
	 *                                                        type is not NamedNode
	 * @param {(function(K, K):number)=} mapSortFn An optional override for comparator used by the generated sorted map
	 * @return {SortedMap.<K, V>}
	 */
	exports.buildChildSet = function (childList, cmp, keyFn, mapSortFn) {
	    childList.sort(cmp);
	    var buildBalancedTree = function (low, high) {
	        var length = high - low;
	        var namedNode;
	        var key;
	        if (length == 0) {
	            return null;
	        }
	        else if (length == 1) {
	            namedNode = childList[low];
	            key = keyFn ? keyFn(namedNode) : namedNode;
	            return new SortedMap_1.LLRBNode(key, namedNode.node, SortedMap_1.LLRBNode.BLACK, null, null);
	        }
	        else {
	            var middle = parseInt((length / 2), 10) + low;
	            var left = buildBalancedTree(low, middle);
	            var right = buildBalancedTree(middle + 1, high);
	            namedNode = childList[middle];
	            key = keyFn ? keyFn(namedNode) : namedNode;
	            return new SortedMap_1.LLRBNode(key, namedNode.node, SortedMap_1.LLRBNode.BLACK, left, right);
	        }
	    };
	    var buildFrom12Array = function (base12) {
	        var node = null;
	        var root = null;
	        var index = childList.length;
	        var buildPennant = function (chunkSize, color) {
	            var low = index - chunkSize;
	            var high = index;
	            index -= chunkSize;
	            var childTree = buildBalancedTree(low + 1, high);
	            var namedNode = childList[low];
	            var key = keyFn ? keyFn(namedNode) : namedNode;
	            attachPennant(new SortedMap_1.LLRBNode(key, namedNode.node, color, null, childTree));
	        };
	        var attachPennant = function (pennant) {
	            if (node) {
	                node.left = pennant;
	                node = pennant;
	            }
	            else {
	                root = pennant;
	                node = pennant;
	            }
	        };
	        for (var i = 0; i < base12.count; ++i) {
	            var isOne = base12.nextBitIsOne();
	            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
	            var chunkSize = Math.pow(2, base12.count - (i + 1));
	            if (isOne) {
	                buildPennant(chunkSize, SortedMap_1.LLRBNode.BLACK);
	            }
	            else {
	                // current == 2
	                buildPennant(chunkSize, SortedMap_1.LLRBNode.BLACK);
	                buildPennant(chunkSize, SortedMap_1.LLRBNode.RED);
	            }
	        }
	        return root;
	    };
	    var base12 = new Base12Num(childList.length);
	    var root = buildFrom12Array(base12);
	    return new SortedMap_2.SortedMap(mapSortFn || cmp, root);
	};
	
	//# sourceMappingURL=childSet.js.map


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(13);
	function NAME_ONLY_COMPARATOR(left, right) {
	    return util_1.nameCompare(left.name, right.name);
	}
	exports.NAME_ONLY_COMPARATOR = NAME_ONLY_COMPARATOR;
	function NAME_COMPARATOR(left, right) {
	    return util_1.nameCompare(left, right);
	}
	exports.NAME_COMPARATOR = NAME_COMPARATOR;
	
	//# sourceMappingURL=comparators.js.map


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var util_2 = __webpack_require__(13);
	var Index_1 = __webpack_require__(88);
	var ChildrenNode_1 = __webpack_require__(28);
	var Node_1 = __webpack_require__(30);
	var nodeFromJSON_1 = __webpack_require__(68);
	/**
	 * @param {!Path} indexPath
	 * @constructor
	 * @extends {Index}
	 */
	var PathIndex = /** @class */ (function (_super) {
	    __extends(PathIndex, _super);
	    function PathIndex(indexPath_) {
	        var _this = _super.call(this) || this;
	        _this.indexPath_ = indexPath_;
	        util_1.assert(!indexPath_.isEmpty() && indexPath_.getFront() !== '.priority', "Can't create PathIndex with empty path or .priority key");
	        return _this;
	    }
	    /**
	     * @param {!Node} snap
	     * @return {!Node}
	     * @protected
	     */
	    PathIndex.prototype.extractChild = function (snap) {
	        return snap.getChild(this.indexPath_);
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.isDefinedOn = function (node) {
	        return !node.getChild(this.indexPath_).isEmpty();
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.compare = function (a, b) {
	        var aChild = this.extractChild(a.node);
	        var bChild = this.extractChild(b.node);
	        var indexCmp = aChild.compareTo(bChild);
	        if (indexCmp === 0) {
	            return util_2.nameCompare(a.name, b.name);
	        }
	        else {
	            return indexCmp;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.makePost = function (indexValue, name) {
	        var valueNode = nodeFromJSON_1.nodeFromJSON(indexValue);
	        var node = ChildrenNode_1.ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
	        return new Node_1.NamedNode(name, node);
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.maxPost = function () {
	        var node = ChildrenNode_1.ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, ChildrenNode_1.MAX_NODE);
	        return new Node_1.NamedNode(util_2.MAX_NAME, node);
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.toString = function () {
	        return this.indexPath_.slice().join('/');
	    };
	    return PathIndex;
	}(Index_1.Index));
	exports.PathIndex = PathIndex;
	
	//# sourceMappingURL=PathIndex.js.map


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Index_1 = __webpack_require__(88);
	var Node_1 = __webpack_require__(30);
	var util_1 = __webpack_require__(13);
	var nodeFromJSON_1 = __webpack_require__(68);
	/**
	 * @constructor
	 * @extends {Index}
	 * @private
	 */
	var ValueIndex = /** @class */ (function (_super) {
	    __extends(ValueIndex, _super);
	    function ValueIndex() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.compare = function (a, b) {
	        var indexCmp = a.node.compareTo(b.node);
	        if (indexCmp === 0) {
	            return util_1.nameCompare(a.name, b.name);
	        }
	        else {
	            return indexCmp;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.isDefinedOn = function (node) {
	        return true;
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
	        return !oldNode.equals(newNode);
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.minPost = function () {
	        return Node_1.NamedNode.MIN;
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.maxPost = function () {
	        return Node_1.NamedNode.MAX;
	    };
	    /**
	     * @param {*} indexValue
	     * @param {string} name
	     * @return {!NamedNode}
	     */
	    ValueIndex.prototype.makePost = function (indexValue, name) {
	        var valueNode = nodeFromJSON_1.nodeFromJSON(indexValue);
	        return new Node_1.NamedNode(name, valueNode);
	    };
	    /**
	     * @return {!string} String representation for inclusion in a query spec
	     */
	    ValueIndex.prototype.toString = function () {
	        return '.value';
	    };
	    return ValueIndex;
	}(Index_1.Index));
	exports.ValueIndex = ValueIndex;
	exports.VALUE_INDEX = new ValueIndex();
	
	//# sourceMappingURL=ValueIndex.js.map


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var util_2 = __webpack_require__(13);
	var util_3 = __webpack_require__(2);
	var MAX_NODE;
	function setMaxNode(val) {
	    MAX_NODE = val;
	}
	exports.setMaxNode = setMaxNode;
	/**
	 * @param {(!string|!number)} priority
	 * @return {!string}
	 */
	exports.priorityHashText = function (priority) {
	    if (typeof priority === 'number')
	        return 'number:' + util_2.doubleToIEEE754String(priority);
	    else
	        return 'string:' + priority;
	};
	/**
	 * Validates that a priority snapshot Node is valid.
	 *
	 * @param {!Node} priorityNode
	 */
	exports.validatePriorityNode = function (priorityNode) {
	    if (priorityNode.isLeafNode()) {
	        var val = priorityNode.val();
	        util_1.assert(typeof val === 'string' ||
	            typeof val === 'number' ||
	            (typeof val === 'object' && util_3.contains(val, '.sv')), 'Priority must be a string or number.');
	    }
	    else {
	        util_1.assert(priorityNode === MAX_NODE || priorityNode.isEmpty(), 'priority of unexpected type.');
	    }
	    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
	    util_1.assert(priorityNode === MAX_NODE || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
	};
	
	//# sourceMappingURL=snap.js.map


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	/**
	 * Returns the delta from the previous call to get stats.
	 *
	 * @param collection_ The collection to "listen" to.
	 * @constructor
	 */
	var StatsListener = /** @class */ (function () {
	    function StatsListener(collection_) {
	        this.collection_ = collection_;
	        this.last_ = null;
	    }
	    StatsListener.prototype.get = function () {
	        var newStats = this.collection_.get();
	        var delta = util_1.clone(newStats);
	        if (this.last_) {
	            util_1.forEach(this.last_, function (stat, value) {
	                delta[stat] = delta[stat] - value;
	            });
	        }
	        this.last_ = newStats;
	        return delta;
	    };
	    return StatsListener;
	}());
	exports.StatsListener = StatsListener;
	
	//# sourceMappingURL=StatsListener.js.map


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	/**
	 * Implements a set with a count of elements.
	 *
	 * @template K, V
	 */
	var CountedSet = /** @class */ (function () {
	    function CountedSet() {
	        this.set = {};
	    }
	    /**
	     * @param {!K} item
	     * @param {V} val
	     */
	    CountedSet.prototype.add = function (item, val) {
	        this.set[item] = val !== null ? val : true;
	    };
	    /**
	     * @param {!K} key
	     * @return {boolean}
	     */
	    CountedSet.prototype.contains = function (key) {
	        return util_1.contains(this.set, key);
	    };
	    /**
	     * @param {!K} item
	     * @return {V}
	     */
	    CountedSet.prototype.get = function (item) {
	        return this.contains(item) ? this.set[item] : undefined;
	    };
	    /**
	     * @param {!K} item
	     */
	    CountedSet.prototype.remove = function (item) {
	        delete this.set[item];
	    };
	    /**
	     * Deletes everything in the set
	     */
	    CountedSet.prototype.clear = function () {
	        this.set = {};
	    };
	    /**
	     * True if there's nothing in the set
	     * @return {boolean}
	     */
	    CountedSet.prototype.isEmpty = function () {
	        return util_1.isEmpty(this.set);
	    };
	    /**
	     * @return {number} The number of items in the set
	     */
	    CountedSet.prototype.count = function () {
	        return util_1.getCount(this.set);
	    };
	    /**
	     * Run a function on each k,v pair in the set
	     * @param {function(K, V)} fn
	     */
	    CountedSet.prototype.each = function (fn) {
	        util_1.forEach(this.set, function (k, v) { return fn(k, v); });
	    };
	    /**
	     * Mostly for debugging
	     * @return {Array.<K>} The keys present in this CountedSet
	     */
	    CountedSet.prototype.keys = function () {
	        var keys = [];
	        util_1.forEach(this.set, function (k) {
	            keys.push(k);
	        });
	        return keys;
	    };
	    return CountedSet;
	}());
	exports.CountedSet = CountedSet;
	
	//# sourceMappingURL=CountedSet.js.map


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	/**
	 * Base class to be used if you want to emit events. Call the constructor with
	 * the set of allowed event names.
	 */
	var EventEmitter = /** @class */ (function () {
	    /**
	     * @param {!Array.<string>} allowedEvents_
	     */
	    function EventEmitter(allowedEvents_) {
	        this.allowedEvents_ = allowedEvents_;
	        this.listeners_ = {};
	        util_1.assert(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, 'Requires a non-empty array');
	    }
	    /**
	     * To be called by derived classes to trigger events.
	     * @param {!string} eventType
	     * @param {...*} var_args
	     */
	    EventEmitter.prototype.trigger = function (eventType) {
	        var var_args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            var_args[_i - 1] = arguments[_i];
	        }
	        if (Array.isArray(this.listeners_[eventType])) {
	            // Clone the list, since callbacks could add/remove listeners.
	            var listeners = this.listeners_[eventType].slice();
	            for (var i = 0; i < listeners.length; i++) {
	                listeners[i].callback.apply(listeners[i].context, var_args);
	            }
	        }
	    };
	    EventEmitter.prototype.on = function (eventType, callback, context) {
	        this.validateEventType_(eventType);
	        this.listeners_[eventType] = this.listeners_[eventType] || [];
	        this.listeners_[eventType].push({ callback: callback, context: context });
	        var eventData = this.getInitialEvent(eventType);
	        if (eventData) {
	            callback.apply(context, eventData);
	        }
	    };
	    EventEmitter.prototype.off = function (eventType, callback, context) {
	        this.validateEventType_(eventType);
	        var listeners = this.listeners_[eventType] || [];
	        for (var i = 0; i < listeners.length; i++) {
	            if (listeners[i].callback === callback &&
	                (!context || context === listeners[i].context)) {
	                listeners.splice(i, 1);
	                return;
	            }
	        }
	    };
	    EventEmitter.prototype.validateEventType_ = function (eventType) {
	        util_1.assert(this.allowedEvents_.find(function (et) {
	            return et === eventType;
	        }), 'Unknown event: ' + eventType);
	    };
	    return EventEmitter;
	}());
	exports.EventEmitter = EventEmitter;
	
	//# sourceMappingURL=EventEmitter.js.map


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var Path_1 = __webpack_require__(17);
	var SparseSnapshotTree_1 = __webpack_require__(170);
	var LeafNode_1 = __webpack_require__(87);
	var nodeFromJSON_1 = __webpack_require__(68);
	var PriorityIndex_1 = __webpack_require__(26);
	/**
	 * Generate placeholders for deferred values.
	 * @param {?Object} values
	 * @return {!Object}
	 */
	exports.generateWithValues = function (values) {
	    values = values || {};
	    values['timestamp'] = values['timestamp'] || new Date().getTime();
	    return values;
	};
	/**
	 * Value to use when firing local events. When writing server values, fire
	 * local events with an approximate value, otherwise return value as-is.
	 * @param {(Object|string|number|boolean)} value
	 * @param {!Object} serverValues
	 * @return {!(string|number|boolean)}
	 */
	exports.resolveDeferredValue = function (value, serverValues) {
	    if (!value || typeof value !== 'object') {
	        return value;
	    }
	    else {
	        util_1.assert('.sv' in value, 'Unexpected leaf node or priority contents');
	        return serverValues[value['.sv']];
	    }
	};
	/**
	 * Recursively replace all deferred values and priorities in the tree with the
	 * specified generated replacement values.
	 * @param {!SparseSnapshotTree} tree
	 * @param {!Object} serverValues
	 * @return {!SparseSnapshotTree}
	 */
	exports.resolveDeferredValueTree = function (tree, serverValues) {
	    var resolvedTree = new SparseSnapshotTree_1.SparseSnapshotTree();
	    tree.forEachTree(new Path_1.Path(''), function (path, node) {
	        resolvedTree.remember(path, exports.resolveDeferredValueSnapshot(node, serverValues));
	    });
	    return resolvedTree;
	};
	/**
	 * Recursively replace all deferred values and priorities in the node with the
	 * specified generated replacement values.  If there are no server values in the node,
	 * it'll be returned as-is.
	 * @param {!Node} node
	 * @param {!Object} serverValues
	 * @return {!Node}
	 */
	exports.resolveDeferredValueSnapshot = function (node, serverValues) {
	    var rawPri = node.getPriority().val();
	    var priority = exports.resolveDeferredValue(rawPri, serverValues);
	    var newNode;
	    if (node.isLeafNode()) {
	        var leafNode = node;
	        var value = exports.resolveDeferredValue(leafNode.getValue(), serverValues);
	        if (value !== leafNode.getValue() ||
	            priority !== leafNode.getPriority().val()) {
	            return new LeafNode_1.LeafNode(value, nodeFromJSON_1.nodeFromJSON(priority));
	        }
	        else {
	            return node;
	        }
	    }
	    else {
	        var childrenNode = node;
	        newNode = childrenNode;
	        if (priority !== childrenNode.getPriority().val()) {
	            newNode = newNode.updatePriority(new LeafNode_1.LeafNode(priority));
	        }
	        childrenNode.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (childName, childNode) {
	            var newChildNode = exports.resolveDeferredValueSnapshot(childNode, serverValues);
	            if (newChildNode !== childNode) {
	                newNode = newNode.updateImmediateChild(childName, newChildNode);
	            }
	        });
	        return newNode;
	    }
	};
	
	//# sourceMappingURL=ServerValues.js.map


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Path_1 = __webpack_require__(17);
	var RepoInfo_1 = __webpack_require__(168);
	var util_1 = __webpack_require__(13);
	/**
	 * @param {!string} pathString
	 * @return {string}
	 */
	function decodePath(pathString) {
	    var pathStringDecoded = '';
	    var pieces = pathString.split('/');
	    for (var i = 0; i < pieces.length; i++) {
	        if (pieces[i].length > 0) {
	            var piece = pieces[i];
	            try {
	                piece = decodeURIComponent(piece.replace(/\+/g, ' '));
	            }
	            catch (e) { }
	            pathStringDecoded += '/' + piece;
	        }
	    }
	    return pathStringDecoded;
	}
	/**
	 *
	 * @param {!string} dataURL
	 * @return {{repoInfo: !RepoInfo, path: !Path}}
	 */
	exports.parseRepoInfo = function (dataURL) {
	    var parsedUrl = exports.parseURL(dataURL), namespace = parsedUrl.subdomain;
	    if (parsedUrl.domain === 'firebase') {
	        util_1.fatal(parsedUrl.host +
	            ' is no longer supported. ' +
	            'Please use <YOUR FIREBASE>.firebaseio.com instead');
	    }
	    // Catch common error of uninitialized namespace value.
	    if (!namespace || namespace == 'undefined') {
	        util_1.fatal('Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com');
	    }
	    if (!parsedUrl.secure) {
	        util_1.warnIfPageIsSecure();
	    }
	    var webSocketOnly = parsedUrl.scheme === 'ws' || parsedUrl.scheme === 'wss';
	    return {
	        repoInfo: new RepoInfo_1.RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, webSocketOnly),
	        path: new Path_1.Path(parsedUrl.pathString)
	    };
	};
	/**
	 *
	 * @param {!string} dataURL
	 * @return {{host: string, port: number, domain: string, subdomain: string, secure: boolean, scheme: string, pathString: string}}
	 */
	exports.parseURL = function (dataURL) {
	    // Default to empty strings in the event of a malformed string.
	    var host = '', domain = '', subdomain = '', pathString = '';
	    // Always default to SSL, unless otherwise specified.
	    var secure = true, scheme = 'https', port = 443;
	    // Don't do any validation here. The caller is responsible for validating the result of parsing.
	    if (typeof dataURL === 'string') {
	        // Parse scheme.
	        var colonInd = dataURL.indexOf('//');
	        if (colonInd >= 0) {
	            scheme = dataURL.substring(0, colonInd - 1);
	            dataURL = dataURL.substring(colonInd + 2);
	        }
	        // Parse host and path.
	        var slashInd = dataURL.indexOf('/');
	        if (slashInd === -1) {
	            slashInd = dataURL.length;
	        }
	        host = dataURL.substring(0, slashInd);
	        pathString = decodePath(dataURL.substring(slashInd));
	        var parts = host.split('.');
	        if (parts.length === 3) {
	            // Normalize namespaces to lowercase to share storage / connection.
	            domain = parts[1];
	            subdomain = parts[0].toLowerCase();
	        }
	        else if (parts.length === 2) {
	            domain = parts[0];
	        }
	        // If we have a port, use scheme for determining if it's secure.
	        colonInd = host.indexOf(':');
	        if (colonInd >= 0) {
	            secure = scheme === 'https' || scheme === 'wss';
	            port = parseInt(host.substring(colonInd + 1), 10);
	        }
	    }
	    return {
	        host: host,
	        port: port,
	        domain: domain,
	        subdomain: subdomain,
	        secure: secure,
	        scheme: scheme,
	        pathString: pathString
	    };
	};
	
	//# sourceMappingURL=parser.js.map


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ChildrenNode_1 = __webpack_require__(28);
	var CacheNode_1 = __webpack_require__(91);
	/**
	 * Stores the data we have cached for a view.
	 *
	 * serverSnap is the cached server data, eventSnap is the cached event data (server data plus any local writes).
	 *
	 * @constructor
	 */
	var ViewCache = /** @class */ (function () {
	    /**
	     *
	     * @param {!CacheNode} eventCache_
	     * @param {!CacheNode} serverCache_
	     */
	    function ViewCache(eventCache_, serverCache_) {
	        this.eventCache_ = eventCache_;
	        this.serverCache_ = serverCache_;
	    }
	    /**
	     * @param {!Node} eventSnap
	     * @param {boolean} complete
	     * @param {boolean} filtered
	     * @return {!ViewCache}
	     */
	    ViewCache.prototype.updateEventSnap = function (eventSnap, complete, filtered) {
	        return new ViewCache(new CacheNode_1.CacheNode(eventSnap, complete, filtered), this.serverCache_);
	    };
	    /**
	     * @param {!Node} serverSnap
	     * @param {boolean} complete
	     * @param {boolean} filtered
	     * @return {!ViewCache}
	     */
	    ViewCache.prototype.updateServerSnap = function (serverSnap, complete, filtered) {
	        return new ViewCache(this.eventCache_, new CacheNode_1.CacheNode(serverSnap, complete, filtered));
	    };
	    /**
	     * @return {!CacheNode}
	     */
	    ViewCache.prototype.getEventCache = function () {
	        return this.eventCache_;
	    };
	    /**
	     * @return {?Node}
	     */
	    ViewCache.prototype.getCompleteEventSnap = function () {
	        return this.eventCache_.isFullyInitialized()
	            ? this.eventCache_.getNode()
	            : null;
	    };
	    /**
	     * @return {!CacheNode}
	     */
	    ViewCache.prototype.getServerCache = function () {
	        return this.serverCache_;
	    };
	    /**
	     * @return {?Node}
	     */
	    ViewCache.prototype.getCompleteServerSnap = function () {
	        return this.serverCache_.isFullyInitialized()
	            ? this.serverCache_.getNode()
	            : null;
	    };
	    /**
	     * @const
	     * @type {ViewCache}
	     */
	    ViewCache.Empty = new ViewCache(new CacheNode_1.CacheNode(ChildrenNode_1.ChildrenNode.EMPTY_NODE, 
	    /*fullyInitialized=*/ false, 
	    /*filtered=*/ false), new CacheNode_1.CacheNode(ChildrenNode_1.ChildrenNode.EMPTY_NODE, 
	    /*fullyInitialized=*/ false, 
	    /*filtered=*/ false));
	    return ViewCache;
	}());
	exports.ViewCache = ViewCache;
	
	//# sourceMappingURL=ViewCache.js.map


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var IndexedFilter_1 = __webpack_require__(120);
	var PriorityIndex_1 = __webpack_require__(26);
	var Node_1 = __webpack_require__(30);
	var ChildrenNode_1 = __webpack_require__(28);
	/**
	 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
	 *
	 * @constructor
	 * @implements {NodeFilter}
	 */
	var RangedFilter = /** @class */ (function () {
	    /**
	     * @param {!QueryParams} params
	     */
	    function RangedFilter(params) {
	        this.indexedFilter_ = new IndexedFilter_1.IndexedFilter(params.getIndex());
	        this.index_ = params.getIndex();
	        this.startPost_ = RangedFilter.getStartPost_(params);
	        this.endPost_ = RangedFilter.getEndPost_(params);
	    }
	    /**
	     * @return {!NamedNode}
	     */
	    RangedFilter.prototype.getStartPost = function () {
	        return this.startPost_;
	    };
	    /**
	     * @return {!NamedNode}
	     */
	    RangedFilter.prototype.getEndPost = function () {
	        return this.endPost_;
	    };
	    /**
	     * @param {!NamedNode} node
	     * @return {boolean}
	     */
	    RangedFilter.prototype.matches = function (node) {
	        return (this.index_.compare(this.getStartPost(), node) <= 0 &&
	            this.index_.compare(node, this.getEndPost()) <= 0);
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
	        if (!this.matches(new Node_1.NamedNode(key, newChild))) {
	            newChild = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	        }
	        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
	        if (newSnap.isLeafNode()) {
	            // Make sure we have a children node with the correct index, not a leaf node;
	            newSnap = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	        }
	        var filtered = newSnap.withIndex(this.index_);
	        // Don't support priorities on queries
	        filtered = filtered.updatePriority(ChildrenNode_1.ChildrenNode.EMPTY_NODE);
	        var self = this;
	        newSnap.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (key, childNode) {
	            if (!self.matches(new Node_1.NamedNode(key, childNode))) {
	                filtered = filtered.updateImmediateChild(key, ChildrenNode_1.ChildrenNode.EMPTY_NODE);
	            }
	        });
	        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
	        // Don't support priorities on queries
	        return oldSnap;
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.filtersNodes = function () {
	        return true;
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.getIndexedFilter = function () {
	        return this.indexedFilter_;
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.getIndex = function () {
	        return this.index_;
	    };
	    /**
	     * @param {!QueryParams} params
	     * @return {!NamedNode}
	     * @private
	     */
	    RangedFilter.getStartPost_ = function (params) {
	        if (params.hasStart()) {
	            var startName = params.getIndexStartName();
	            return params.getIndex().makePost(params.getIndexStartValue(), startName);
	        }
	        else {
	            return params.getIndex().minPost();
	        }
	    };
	    /**
	     * @param {!QueryParams} params
	     * @return {!NamedNode}
	     * @private
	     */
	    RangedFilter.getEndPost_ = function (params) {
	        if (params.hasEnd()) {
	            var endName = params.getIndexEndName();
	            return params.getIndex().makePost(params.getIndexEndValue(), endName);
	        }
	        else {
	            return params.getIndex().maxPost();
	        }
	    };
	    return RangedFilter;
	}());
	exports.RangedFilter = RangedFilter;
	
	//# sourceMappingURL=RangedFilter.js.map


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(13);
	var CountedSet_1 = __webpack_require__(180);
	var StatsManager_1 = __webpack_require__(118);
	var PacketReceiver_1 = __webpack_require__(452);
	var Constants_1 = __webpack_require__(92);
	var util_2 = __webpack_require__(2);
	var util_3 = __webpack_require__(2);
	// URL query parameters associated with longpolling
	exports.FIREBASE_LONGPOLL_START_PARAM = 'start';
	exports.FIREBASE_LONGPOLL_CLOSE_COMMAND = 'close';
	exports.FIREBASE_LONGPOLL_COMMAND_CB_NAME = 'pLPCommand';
	exports.FIREBASE_LONGPOLL_DATA_CB_NAME = 'pRTLPCB';
	exports.FIREBASE_LONGPOLL_ID_PARAM = 'id';
	exports.FIREBASE_LONGPOLL_PW_PARAM = 'pw';
	exports.FIREBASE_LONGPOLL_SERIAL_PARAM = 'ser';
	exports.FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = 'cb';
	exports.FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = 'seg';
	exports.FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = 'ts';
	exports.FIREBASE_LONGPOLL_DATA_PARAM = 'd';
	exports.FIREBASE_LONGPOLL_DISCONN_FRAME_PARAM = 'disconn';
	exports.FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = 'dframe';
	//Data size constants.
	//TODO: Perf: the maximum length actually differs from browser to browser.
	// We should check what browser we're on and set accordingly.
	var MAX_URL_DATA_SIZE = 1870;
	var SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
	var MAX_PAYLOAD_SIZE = MAX_URL_DATA_SIZE - SEG_HEADER_SIZE;
	/**
	 * Keepalive period
	 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
	 * length of 30 seconds that we can't exceed.
	 * @const
	 * @type {number}
	 */
	var KEEPALIVE_REQUEST_INTERVAL = 25000;
	/**
	 * How long to wait before aborting a long-polling connection attempt.
	 * @const
	 * @type {number}
	 */
	var LP_CONNECT_TIMEOUT = 30000;
	/**
	 * This class manages a single long-polling connection.
	 *
	 * @constructor
	 * @implements {Transport}
	 */
	var BrowserPollConnection = /** @class */ (function () {
	    /**
	     * @param {string} connId An identifier for this connection, used for logging
	     * @param {RepoInfo} repoInfo The info for the endpoint to send data to.
	     * @param {string=} transportSessionId Optional transportSessionid if we are reconnecting for an existing
	     *                                         transport session
	     * @param {string=}  lastSessionId Optional lastSessionId if the PersistentConnection has already created a
	     *                                     connection previously
	     */
	    function BrowserPollConnection(connId, repoInfo, transportSessionId, lastSessionId) {
	        this.connId = connId;
	        this.repoInfo = repoInfo;
	        this.transportSessionId = transportSessionId;
	        this.lastSessionId = lastSessionId;
	        this.bytesSent = 0;
	        this.bytesReceived = 0;
	        this.everConnected_ = false;
	        this.log_ = util_1.logWrapper(connId);
	        this.stats_ = StatsManager_1.StatsManager.getCollection(repoInfo);
	        this.urlFn = function (params) {
	            return repoInfo.connectionURL(Constants_1.LONG_POLLING, params);
	        };
	    }
	    /**
	     *
	     * @param {function(Object)} onMessage Callback when messages arrive
	     * @param {function()} onDisconnect Callback with connection lost.
	     */
	    BrowserPollConnection.prototype.open = function (onMessage, onDisconnect) {
	        var _this = this;
	        this.curSegmentNum = 0;
	        this.onDisconnect_ = onDisconnect;
	        this.myPacketOrderer = new PacketReceiver_1.PacketReceiver(onMessage);
	        this.isClosed_ = false;
	        this.connectTimeoutTimer_ = setTimeout(function () {
	            _this.log_('Timed out trying to connect.');
	            // Make sure we clear the host cache
	            _this.onClosed_();
	            _this.connectTimeoutTimer_ = null;
	        }, Math.floor(LP_CONNECT_TIMEOUT));
	        // Ensure we delay the creation of the iframe until the DOM is loaded.
	        util_1.executeWhenDOMReady(function () {
	            if (_this.isClosed_)
	                return;
	            //Set up a callback that gets triggered once a connection is set up.
	            _this.scriptTagHolder = new FirebaseIFrameScriptHolder(function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                var command = args[0], arg1 = args[1], arg2 = args[2], arg3 = args[3], arg4 = args[4];
	                _this.incrementIncomingBytes_(args);
	                if (!_this.scriptTagHolder)
	                    return; // we closed the connection.
	                if (_this.connectTimeoutTimer_) {
	                    clearTimeout(_this.connectTimeoutTimer_);
	                    _this.connectTimeoutTimer_ = null;
	                }
	                _this.everConnected_ = true;
	                if (command == exports.FIREBASE_LONGPOLL_START_PARAM) {
	                    _this.id = arg1;
	                    _this.password = arg2;
	                }
	                else if (command === exports.FIREBASE_LONGPOLL_CLOSE_COMMAND) {
	                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
	                    if (arg1) {
	                        // We aren't expecting any more data (other than what the server's already in the process of sending us
	                        // through our already open polls), so don't send any more.
	                        _this.scriptTagHolder.sendNewPolls = false;
	                        // arg1 in this case is the last response number sent by the server. We should try to receive
	                        // all of the responses up to this one before closing
	                        _this.myPacketOrderer.closeAfter(arg1, function () {
	                            _this.onClosed_();
	                        });
	                    }
	                    else {
	                        _this.onClosed_();
	                    }
	                }
	                else {
	                    throw new Error('Unrecognized command received: ' + command);
	                }
	            }, function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                var pN = args[0], data = args[1];
	                _this.incrementIncomingBytes_(args);
	                _this.myPacketOrderer.handleResponse(pN, data);
	            }, function () {
	                _this.onClosed_();
	            }, _this.urlFn);
	            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
	            //from cache.
	            var urlParams = {};
	            urlParams[exports.FIREBASE_LONGPOLL_START_PARAM] = 't';
	            urlParams[exports.FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
	            if (_this.scriptTagHolder.uniqueCallbackIdentifier)
	                urlParams[exports.FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = _this.scriptTagHolder.uniqueCallbackIdentifier;
	            urlParams[Constants_1.VERSION_PARAM] = Constants_1.PROTOCOL_VERSION;
	            if (_this.transportSessionId) {
	                urlParams[Constants_1.TRANSPORT_SESSION_PARAM] = _this.transportSessionId;
	            }
	            if (_this.lastSessionId) {
	                urlParams[Constants_1.LAST_SESSION_PARAM] = _this.lastSessionId;
	            }
	            if (!util_3.isNodeSdk() &&
	                typeof location !== 'undefined' &&
	                location.href &&
	                location.href.indexOf(Constants_1.FORGE_DOMAIN) !== -1) {
	                urlParams[Constants_1.REFERER_PARAM] = Constants_1.FORGE_REF;
	            }
	            var connectURL = _this.urlFn(urlParams);
	            _this.log_('Connecting via long-poll to ' + connectURL);
	            _this.scriptTagHolder.addTag(connectURL, function () {
	                /* do nothing */
	            });
	        });
	    };
	    /**
	     * Call this when a handshake has completed successfully and we want to consider the connection established
	     */
	    BrowserPollConnection.prototype.start = function () {
	        this.scriptTagHolder.startLongPoll(this.id, this.password);
	        this.addDisconnectPingFrame(this.id, this.password);
	    };
	    /**
	     * Forces long polling to be considered as a potential transport
	     */
	    BrowserPollConnection.forceAllow = function () {
	        BrowserPollConnection.forceAllow_ = true;
	    };
	    /**
	     * Forces longpolling to not be considered as a potential transport
	     */
	    BrowserPollConnection.forceDisallow = function () {
	        BrowserPollConnection.forceDisallow_ = true;
	    };
	    // Static method, use string literal so it can be accessed in a generic way
	    BrowserPollConnection.isAvailable = function () {
	        // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
	        // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
	        return (BrowserPollConnection.forceAllow_ ||
	            (!BrowserPollConnection.forceDisallow_ &&
	                typeof document !== 'undefined' &&
	                document.createElement != null &&
	                !util_1.isChromeExtensionContentScript() &&
	                !util_1.isWindowsStoreApp() &&
	                !util_3.isNodeSdk()));
	    };
	    /**
	     * No-op for polling
	     */
	    BrowserPollConnection.prototype.markConnectionHealthy = function () { };
	    /**
	     * Stops polling and cleans up the iframe
	     * @private
	     */
	    BrowserPollConnection.prototype.shutdown_ = function () {
	        this.isClosed_ = true;
	        if (this.scriptTagHolder) {
	            this.scriptTagHolder.close();
	            this.scriptTagHolder = null;
	        }
	        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
	        if (this.myDisconnFrame) {
	            document.body.removeChild(this.myDisconnFrame);
	            this.myDisconnFrame = null;
	        }
	        if (this.connectTimeoutTimer_) {
	            clearTimeout(this.connectTimeoutTimer_);
	            this.connectTimeoutTimer_ = null;
	        }
	    };
	    /**
	     * Triggered when this transport is closed
	     * @private
	     */
	    BrowserPollConnection.prototype.onClosed_ = function () {
	        if (!this.isClosed_) {
	            this.log_('Longpoll is closing itself');
	            this.shutdown_();
	            if (this.onDisconnect_) {
	                this.onDisconnect_(this.everConnected_);
	                this.onDisconnect_ = null;
	            }
	        }
	    };
	    /**
	     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
	     * that we've left.
	     */
	    BrowserPollConnection.prototype.close = function () {
	        if (!this.isClosed_) {
	            this.log_('Longpoll is being closed.');
	            this.shutdown_();
	        }
	    };
	    /**
	     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
	     * broken into chunks (since URLs have a small maximum length).
	     * @param {!Object} data The JSON data to transmit.
	     */
	    BrowserPollConnection.prototype.send = function (data) {
	        var dataStr = util_2.stringify(data);
	        this.bytesSent += dataStr.length;
	        this.stats_.incrementCounter('bytes_sent', dataStr.length);
	        //first, lets get the base64-encoded data
	        var base64data = util_2.base64Encode(dataStr);
	        //We can only fit a certain amount in each URL, so we need to split this request
	        //up into multiple pieces if it doesn't fit in one request.
	        var dataSegs = util_1.splitStringBySize(base64data, MAX_PAYLOAD_SIZE);
	        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
	        //of segments so that we can reassemble the packet on the server.
	        for (var i = 0; i < dataSegs.length; i++) {
	            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
	            this.curSegmentNum++;
	        }
	    };
	    /**
	     * This is how we notify the server that we're leaving.
	     * We aren't able to send requests with DHTML on a window close event, but we can
	     * trigger XHR requests in some browsers (everything but Opera basically).
	     * @param {!string} id
	     * @param {!string} pw
	     */
	    BrowserPollConnection.prototype.addDisconnectPingFrame = function (id, pw) {
	        if (util_3.isNodeSdk())
	            return;
	        this.myDisconnFrame = document.createElement('iframe');
	        var urlParams = {};
	        urlParams[exports.FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = 't';
	        urlParams[exports.FIREBASE_LONGPOLL_ID_PARAM] = id;
	        urlParams[exports.FIREBASE_LONGPOLL_PW_PARAM] = pw;
	        this.myDisconnFrame.src = this.urlFn(urlParams);
	        this.myDisconnFrame.style.display = 'none';
	        document.body.appendChild(this.myDisconnFrame);
	    };
	    /**
	     * Used to track the bytes received by this client
	     * @param {*} args
	     * @private
	     */
	    BrowserPollConnection.prototype.incrementIncomingBytes_ = function (args) {
	        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
	        var bytesReceived = util_2.stringify(args).length;
	        this.bytesReceived += bytesReceived;
	        this.stats_.incrementCounter('bytes_received', bytesReceived);
	    };
	    return BrowserPollConnection;
	}());
	exports.BrowserPollConnection = BrowserPollConnection;
	/*********************************************************************************************
	 * A wrapper around an iframe that is used as a long-polling script holder.
	 * @constructor
	 *********************************************************************************************/
	var FirebaseIFrameScriptHolder = /** @class */ (function () {
	    /**
	     * @param commandCB - The callback to be called when control commands are recevied from the server.
	     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
	     * @param onDisconnect - The callback to be triggered when this tag holder is closed
	     * @param urlFn - A function that provides the URL of the endpoint to send data to.
	     */
	    function FirebaseIFrameScriptHolder(commandCB, onMessageCB, onDisconnect, urlFn) {
	        this.onDisconnect = onDisconnect;
	        this.urlFn = urlFn;
	        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
	        //problems in some browsers.
	        /**
	         * @type {CountedSet.<number, number>}
	         */
	        this.outstandingRequests = new CountedSet_1.CountedSet();
	        //A queue of the pending segments waiting for transmission to the server.
	        this.pendingSegs = [];
	        //A serial number. We use this for two things:
	        // 1) A way to ensure the browser doesn't cache responses to polls
	        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
	        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
	        //    JSONP code in the order it was added to the iframe.
	        this.currentSerial = Math.floor(Math.random() * 100000000);
	        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
	        // incoming data from the server that we're waiting for).
	        this.sendNewPolls = true;
	        if (!util_3.isNodeSdk()) {
	            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
	            //iframes where we put the long-polling script tags. We have two callbacks:
	            //   1) Command Callback - Triggered for control issues, like starting a connection.
	            //   2) Message Callback - Triggered when new data arrives.
	            this.uniqueCallbackIdentifier = util_1.LUIDGenerator();
	            window[exports.FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
	            window[exports.FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
	            //Create an iframe for us to add script tags to.
	            this.myIFrame = FirebaseIFrameScriptHolder.createIFrame_();
	            // Set the iframe's contents.
	            var script = '';
	            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
	            // for ie9, but ie8 needs to do it again in the document itself.
	            if (this.myIFrame.src &&
	                this.myIFrame.src.substr(0, 'javascript:'.length) === 'javascript:') {
	                var currentDomain = document.domain;
	                script = '<script>document.domain="' + currentDomain + '";</script>';
	            }
	            var iframeContents = '<html><body>' + script + '</body></html>';
	            try {
	                this.myIFrame.doc.open();
	                this.myIFrame.doc.write(iframeContents);
	                this.myIFrame.doc.close();
	            }
	            catch (e) {
	                util_1.log('frame writing exception');
	                if (e.stack) {
	                    util_1.log(e.stack);
	                }
	                util_1.log(e);
	            }
	        }
	        else {
	            this.commandCB = commandCB;
	            this.onMessageCB = onMessageCB;
	        }
	    }
	    /**
	     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
	     * actually use.
	     * @private
	     * @return {Element}
	     */
	    FirebaseIFrameScriptHolder.createIFrame_ = function () {
	        var iframe = document.createElement('iframe');
	        iframe.style.display = 'none';
	        // This is necessary in order to initialize the document inside the iframe
	        if (document.body) {
	            document.body.appendChild(iframe);
	            try {
	                // If document.domain has been modified in IE, this will throw an error, and we need to set the
	                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
	                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
	                var a = iframe.contentWindow.document;
	                if (!a) {
	                    // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
	                    util_1.log('No IE domain setting required');
	                }
	            }
	            catch (e) {
	                var domain = document.domain;
	                iframe.src =
	                    "javascript:void((function(){document.open();document.domain='" +
	                        domain +
	                        "';document.close();})())";
	            }
	        }
	        else {
	            // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
	            // never gets hit.
	            throw 'Document body has not initialized. Wait to initialize Firebase until after the document is ready.';
	        }
	        // Get the document of the iframe in a browser-specific way.
	        if (iframe.contentDocument) {
	            iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
	        }
	        else if (iframe.contentWindow) {
	            iframe.doc = iframe.contentWindow.document; // Internet Explorer
	        }
	        else if (iframe.document) {
	            iframe.doc = iframe.document; //others?
	        }
	        return iframe;
	    };
	    /**
	     * Cancel all outstanding queries and remove the frame.
	     */
	    FirebaseIFrameScriptHolder.prototype.close = function () {
	        var _this = this;
	        //Mark this iframe as dead, so no new requests are sent.
	        this.alive = false;
	        if (this.myIFrame) {
	            //We have to actually remove all of the html inside this iframe before removing it from the
	            //window, or IE will continue loading and executing the script tags we've already added, which
	            //can lead to some errors being thrown. Setting innerHTML seems to be the easiest way to do this.
	            this.myIFrame.doc.body.innerHTML = '';
	            setTimeout(function () {
	                if (_this.myIFrame !== null) {
	                    document.body.removeChild(_this.myIFrame);
	                    _this.myIFrame = null;
	                }
	            }, Math.floor(0));
	        }
	        if (util_3.isNodeSdk() && this.myID) {
	            var urlParams = {};
	            urlParams[exports.FIREBASE_LONGPOLL_DISCONN_FRAME_PARAM] = 't';
	            urlParams[exports.FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
	            urlParams[exports.FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
	            var theURL = this.urlFn(urlParams);
	            FirebaseIFrameScriptHolder.nodeRestRequest(theURL);
	        }
	        // Protect from being called recursively.
	        var onDisconnect = this.onDisconnect;
	        if (onDisconnect) {
	            this.onDisconnect = null;
	            onDisconnect();
	        }
	    };
	    /**
	     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
	     * @param {!string} id - The ID of this connection
	     * @param {!string} pw - The password for this connection
	     */
	    FirebaseIFrameScriptHolder.prototype.startLongPoll = function (id, pw) {
	        this.myID = id;
	        this.myPW = pw;
	        this.alive = true;
	        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
	        while (this.newRequest_()) { }
	    };
	    /**
	     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
	     * too many outstanding requests and we are still alive.
	     *
	     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
	     * needed.
	     */
	    FirebaseIFrameScriptHolder.prototype.newRequest_ = function () {
	        // We keep one outstanding request open all the time to receive data, but if we need to send data
	        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
	        // close the old request.
	        if (this.alive &&
	            this.sendNewPolls &&
	            this.outstandingRequests.count() < (this.pendingSegs.length > 0 ? 2 : 1)) {
	            //construct our url
	            this.currentSerial++;
	            var urlParams = {};
	            urlParams[exports.FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
	            urlParams[exports.FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
	            urlParams[exports.FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
	            var theURL = this.urlFn(urlParams);
	            //Now add as much data as we can.
	            var curDataString = '';
	            var i = 0;
	            while (this.pendingSegs.length > 0) {
	                //first, lets see if the next segment will fit.
	                var nextSeg = this.pendingSegs[0];
	                if (nextSeg.d.length + SEG_HEADER_SIZE + curDataString.length <=
	                    MAX_URL_DATA_SIZE) {
	                    //great, the segment will fit. Lets append it.
	                    var theSeg = this.pendingSegs.shift();
	                    curDataString =
	                        curDataString +
	                            '&' +
	                            exports.FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM +
	                            i +
	                            '=' +
	                            theSeg.seg +
	                            '&' +
	                            exports.FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET +
	                            i +
	                            '=' +
	                            theSeg.ts +
	                            '&' +
	                            exports.FIREBASE_LONGPOLL_DATA_PARAM +
	                            i +
	                            '=' +
	                            theSeg.d;
	                    i++;
	                }
	                else {
	                    break;
	                }
	            }
	            theURL = theURL + curDataString;
	            this.addLongPollTag_(theURL, this.currentSerial);
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    /**
	     * Queue a packet for transmission to the server.
	     * @param segnum - A sequential id for this packet segment used for reassembly
	     * @param totalsegs - The total number of segments in this packet
	     * @param data - The data for this segment.
	     */
	    FirebaseIFrameScriptHolder.prototype.enqueueSegment = function (segnum, totalsegs, data) {
	        //add this to the queue of segments to send.
	        this.pendingSegs.push({ seg: segnum, ts: totalsegs, d: data });
	        //send the data immediately if there isn't already data being transmitted, unless
	        //startLongPoll hasn't been called yet.
	        if (this.alive) {
	            this.newRequest_();
	        }
	    };
	    /**
	     * Add a script tag for a regular long-poll request.
	     * @param {!string} url - The URL of the script tag.
	     * @param {!number} serial - The serial number of the request.
	     * @private
	     */
	    FirebaseIFrameScriptHolder.prototype.addLongPollTag_ = function (url, serial) {
	        var _this = this;
	        //remember that we sent this request.
	        this.outstandingRequests.add(serial, 1);
	        var doNewRequest = function () {
	            _this.outstandingRequests.remove(serial);
	            _this.newRequest_();
	        };
	        // If this request doesn't return on its own accord (by the server sending us some data), we'll
	        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
	        var keepaliveTimeout = setTimeout(doNewRequest, Math.floor(KEEPALIVE_REQUEST_INTERVAL));
	        var readyStateCB = function () {
	            // Request completed.  Cancel the keepalive.
	            clearTimeout(keepaliveTimeout);
	            // Trigger a new request so we can continue receiving data.
	            doNewRequest();
	        };
	        this.addTag(url, readyStateCB);
	    };
	    /**
	     * Add an arbitrary script tag to the iframe.
	     * @param {!string} url - The URL for the script tag source.
	     * @param {!function()} loadCB - A callback to be triggered once the script has loaded.
	     */
	    FirebaseIFrameScriptHolder.prototype.addTag = function (url, loadCB) {
	        var _this = this;
	        if (util_3.isNodeSdk()) {
	            this.doNodeLongPoll(url, loadCB);
	        }
	        else {
	            setTimeout(function () {
	                try {
	                    // if we're already closed, don't add this poll
	                    if (!_this.sendNewPolls)
	                        return;
	                    var newScript_1 = _this.myIFrame.doc.createElement('script');
	                    newScript_1.type = 'text/javascript';
	                    newScript_1.async = true;
	                    newScript_1.src = url;
	                    newScript_1.onload = newScript_1.onreadystatechange = function () {
	                        var rstate = newScript_1.readyState;
	                        if (!rstate || rstate === 'loaded' || rstate === 'complete') {
	                            newScript_1.onload = newScript_1.onreadystatechange = null;
	                            if (newScript_1.parentNode) {
	                                newScript_1.parentNode.removeChild(newScript_1);
	                            }
	                            loadCB();
	                        }
	                    };
	                    newScript_1.onerror = function () {
	                        util_1.log('Long-poll script failed to load: ' + url);
	                        _this.sendNewPolls = false;
	                        _this.close();
	                    };
	                    _this.myIFrame.doc.body.appendChild(newScript_1);
	                }
	                catch (e) {
	                    // TODO: we should make this error visible somehow
	                }
	            }, Math.floor(1));
	        }
	    };
	    return FirebaseIFrameScriptHolder;
	}());
	exports.FirebaseIFrameScriptHolder = FirebaseIFrameScriptHolder;
	
	//# sourceMappingURL=BrowserPollConnection.js.map


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(13);
	var storage_1 = __webpack_require__(89);
	var Constants_1 = __webpack_require__(92);
	var TransportManager_1 = __webpack_require__(451);
	// Abort upgrade attempt if it takes longer than 60s.
	var UPGRADE_TIMEOUT = 60000;
	// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
	// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
	var DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
	// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
	// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
	// but we've sent/received enough bytes, we don't cancel the connection.
	var BYTES_SENT_HEALTHY_OVERRIDE = 10 * 1024;
	var BYTES_RECEIVED_HEALTHY_OVERRIDE = 100 * 1024;
	var MESSAGE_TYPE = 't';
	var MESSAGE_DATA = 'd';
	var CONTROL_SHUTDOWN = 's';
	var CONTROL_RESET = 'r';
	var CONTROL_ERROR = 'e';
	var CONTROL_PONG = 'o';
	var SWITCH_ACK = 'a';
	var END_TRANSMISSION = 'n';
	var PING = 'p';
	var SERVER_HELLO = 'h';
	/**
	 * Creates a new real-time connection to the server using whichever method works
	 * best in the current browser.
	 *
	 * @constructor
	 */
	var Connection = /** @class */ (function () {
	    /**
	     * @param {!string} id - an id for this connection
	     * @param {!RepoInfo} repoInfo_ - the info for the endpoint to connect to
	     * @param {function(Object)} onMessage_ - the callback to be triggered when a server-push message arrives
	     * @param {function(number, string)} onReady_ - the callback to be triggered when this connection is ready to send messages.
	     * @param {function()} onDisconnect_ - the callback to be triggered when a connection was lost
	     * @param {function(string)} onKill_ - the callback to be triggered when this connection has permanently shut down.
	     * @param {string=} lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
	     */
	    function Connection(id, repoInfo_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId) {
	        this.id = id;
	        this.repoInfo_ = repoInfo_;
	        this.onMessage_ = onMessage_;
	        this.onReady_ = onReady_;
	        this.onDisconnect_ = onDisconnect_;
	        this.onKill_ = onKill_;
	        this.lastSessionId = lastSessionId;
	        this.connectionCount = 0;
	        this.pendingDataMessages = [];
	        this.state_ = 0 /* CONNECTING */;
	        this.log_ = util_1.logWrapper('c:' + this.id + ':');
	        this.transportManager_ = new TransportManager_1.TransportManager(repoInfo_);
	        this.log_('Connection created');
	        this.start_();
	    }
	    /**
	     * Starts a connection attempt
	     * @private
	     */
	    Connection.prototype.start_ = function () {
	        var _this = this;
	        var conn = this.transportManager_.initialTransport();
	        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, undefined, this.lastSessionId);
	        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
	        // can consider the transport healthy.
	        this.primaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
	        var onMessageReceived = this.connReceiver_(this.conn_);
	        var onConnectionLost = this.disconnReceiver_(this.conn_);
	        this.tx_ = this.conn_;
	        this.rx_ = this.conn_;
	        this.secondaryConn_ = null;
	        this.isHealthy_ = false;
	        /*
	         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
	         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
	         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
	         * still have the context of your originating frame.
	         */
	        setTimeout(function () {
	            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
	            _this.conn_ && _this.conn_.open(onMessageReceived, onConnectionLost);
	        }, Math.floor(0));
	        var healthyTimeout_ms = conn['healthyTimeout'] || 0;
	        if (healthyTimeout_ms > 0) {
	            this.healthyTimeout_ = util_1.setTimeoutNonBlocking(function () {
	                _this.healthyTimeout_ = null;
	                if (!_this.isHealthy_) {
	                    if (_this.conn_ &&
	                        _this.conn_.bytesReceived > BYTES_RECEIVED_HEALTHY_OVERRIDE) {
	                        _this.log_('Connection exceeded healthy timeout but has received ' +
	                            _this.conn_.bytesReceived +
	                            ' bytes.  Marking connection healthy.');
	                        _this.isHealthy_ = true;
	                        _this.conn_.markConnectionHealthy();
	                    }
	                    else if (_this.conn_ &&
	                        _this.conn_.bytesSent > BYTES_SENT_HEALTHY_OVERRIDE) {
	                        _this.log_('Connection exceeded healthy timeout but has sent ' +
	                            _this.conn_.bytesSent +
	                            ' bytes.  Leaving connection alive.');
	                        // NOTE: We don't want to mark it healthy, since we have no guarantee that the bytes have made it to
	                        // the server.
	                    }
	                    else {
	                        _this.log_('Closing unhealthy connection after timeout.');
	                        _this.close();
	                    }
	                }
	            }, Math.floor(healthyTimeout_ms));
	        }
	    };
	    /**
	     * @return {!string}
	     * @private
	     */
	    Connection.prototype.nextTransportId_ = function () {
	        return 'c:' + this.id + ':' + this.connectionCount++;
	    };
	    Connection.prototype.disconnReceiver_ = function (conn) {
	        var _this = this;
	        return function (everConnected) {
	            if (conn === _this.conn_) {
	                _this.onConnectionLost_(everConnected);
	            }
	            else if (conn === _this.secondaryConn_) {
	                _this.log_('Secondary connection lost.');
	                _this.onSecondaryConnectionLost_();
	            }
	            else {
	                _this.log_('closing an old connection');
	            }
	        };
	    };
	    Connection.prototype.connReceiver_ = function (conn) {
	        var _this = this;
	        return function (message) {
	            if (_this.state_ != 2 /* DISCONNECTED */) {
	                if (conn === _this.rx_) {
	                    _this.onPrimaryMessageReceived_(message);
	                }
	                else if (conn === _this.secondaryConn_) {
	                    _this.onSecondaryMessageReceived_(message);
	                }
	                else {
	                    _this.log_('message on old connection');
	                }
	            }
	        };
	    };
	    /**
	     *
	     * @param {Object} dataMsg An arbitrary data message to be sent to the server
	     */
	    Connection.prototype.sendRequest = function (dataMsg) {
	        // wrap in a data message envelope and send it on
	        var msg = { t: 'd', d: dataMsg };
	        this.sendData_(msg);
	    };
	    Connection.prototype.tryCleanupConnection = function () {
	        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
	            this.log_('cleaning up and promoting a connection: ' + this.secondaryConn_.connId);
	            this.conn_ = this.secondaryConn_;
	            this.secondaryConn_ = null;
	            // the server will shutdown the old connection
	        }
	    };
	    Connection.prototype.onSecondaryControl_ = function (controlData) {
	        if (MESSAGE_TYPE in controlData) {
	            var cmd = controlData[MESSAGE_TYPE];
	            if (cmd === SWITCH_ACK) {
	                this.upgradeIfSecondaryHealthy_();
	            }
	            else if (cmd === CONTROL_RESET) {
	                // Most likely the session wasn't valid. Abandon the switch attempt
	                this.log_('Got a reset on secondary, closing it');
	                this.secondaryConn_.close();
	                // If we were already using this connection for something, than we need to fully close
	                if (this.tx_ === this.secondaryConn_ ||
	                    this.rx_ === this.secondaryConn_) {
	                    this.close();
	                }
	            }
	            else if (cmd === CONTROL_PONG) {
	                this.log_('got pong on secondary.');
	                this.secondaryResponsesRequired_--;
	                this.upgradeIfSecondaryHealthy_();
	            }
	        }
	    };
	    Connection.prototype.onSecondaryMessageReceived_ = function (parsedData) {
	        var layer = util_1.requireKey('t', parsedData);
	        var data = util_1.requireKey('d', parsedData);
	        if (layer == 'c') {
	            this.onSecondaryControl_(data);
	        }
	        else if (layer == 'd') {
	            // got a data message, but we're still second connection. Need to buffer it up
	            this.pendingDataMessages.push(data);
	        }
	        else {
	            throw new Error('Unknown protocol layer: ' + layer);
	        }
	    };
	    Connection.prototype.upgradeIfSecondaryHealthy_ = function () {
	        if (this.secondaryResponsesRequired_ <= 0) {
	            this.log_('Secondary connection is healthy.');
	            this.isHealthy_ = true;
	            this.secondaryConn_.markConnectionHealthy();
	            this.proceedWithUpgrade_();
	        }
	        else {
	            // Send a ping to make sure the connection is healthy.
	            this.log_('sending ping on secondary.');
	            this.secondaryConn_.send({ t: 'c', d: { t: PING, d: {} } });
	        }
	    };
	    Connection.prototype.proceedWithUpgrade_ = function () {
	        // tell this connection to consider itself open
	        this.secondaryConn_.start();
	        // send ack
	        this.log_('sending client ack on secondary');
	        this.secondaryConn_.send({ t: 'c', d: { t: SWITCH_ACK, d: {} } });
	        // send end packet on primary transport, switch to sending on this one
	        // can receive on this one, buffer responses until end received on primary transport
	        this.log_('Ending transmission on primary');
	        this.conn_.send({ t: 'c', d: { t: END_TRANSMISSION, d: {} } });
	        this.tx_ = this.secondaryConn_;
	        this.tryCleanupConnection();
	    };
	    Connection.prototype.onPrimaryMessageReceived_ = function (parsedData) {
	        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
	        var layer = util_1.requireKey('t', parsedData);
	        var data = util_1.requireKey('d', parsedData);
	        if (layer == 'c') {
	            this.onControl_(data);
	        }
	        else if (layer == 'd') {
	            this.onDataMessage_(data);
	        }
	    };
	    Connection.prototype.onDataMessage_ = function (message) {
	        this.onPrimaryResponse_();
	        // We don't do anything with data messages, just kick them up a level
	        this.onMessage_(message);
	    };
	    Connection.prototype.onPrimaryResponse_ = function () {
	        if (!this.isHealthy_) {
	            this.primaryResponsesRequired_--;
	            if (this.primaryResponsesRequired_ <= 0) {
	                this.log_('Primary connection is healthy.');
	                this.isHealthy_ = true;
	                this.conn_.markConnectionHealthy();
	            }
	        }
	    };
	    Connection.prototype.onControl_ = function (controlData) {
	        var cmd = util_1.requireKey(MESSAGE_TYPE, controlData);
	        if (MESSAGE_DATA in controlData) {
	            var payload = controlData[MESSAGE_DATA];
	            if (cmd === SERVER_HELLO) {
	                this.onHandshake_(payload);
	            }
	            else if (cmd === END_TRANSMISSION) {
	                this.log_('recvd end transmission on primary');
	                this.rx_ = this.secondaryConn_;
	                for (var i = 0; i < this.pendingDataMessages.length; ++i) {
	                    this.onDataMessage_(this.pendingDataMessages[i]);
	                }
	                this.pendingDataMessages = [];
	                this.tryCleanupConnection();
	            }
	            else if (cmd === CONTROL_SHUTDOWN) {
	                // This was previously the 'onKill' callback passed to the lower-level connection
	                // payload in this case is the reason for the shutdown. Generally a human-readable error
	                this.onConnectionShutdown_(payload);
	            }
	            else if (cmd === CONTROL_RESET) {
	                // payload in this case is the host we should contact
	                this.onReset_(payload);
	            }
	            else if (cmd === CONTROL_ERROR) {
	                util_1.error('Server Error: ' + payload);
	            }
	            else if (cmd === CONTROL_PONG) {
	                this.log_('got pong on primary.');
	                this.onPrimaryResponse_();
	                this.sendPingOnPrimaryIfNecessary_();
	            }
	            else {
	                util_1.error('Unknown control packet command: ' + cmd);
	            }
	        }
	    };
	    /**
	     *
	     * @param {Object} handshake The handshake data returned from the server
	     * @private
	     */
	    Connection.prototype.onHandshake_ = function (handshake) {
	        var timestamp = handshake.ts;
	        var version = handshake.v;
	        var host = handshake.h;
	        this.sessionId = handshake.s;
	        this.repoInfo_.updateHost(host);
	        // if we've already closed the connection, then don't bother trying to progress further
	        if (this.state_ == 0 /* CONNECTING */) {
	            this.conn_.start();
	            this.onConnectionEstablished_(this.conn_, timestamp);
	            if (Constants_1.PROTOCOL_VERSION !== version) {
	                util_1.warn('Protocol version mismatch detected');
	            }
	            // TODO: do we want to upgrade? when? maybe a delay?
	            this.tryStartUpgrade_();
	        }
	    };
	    Connection.prototype.tryStartUpgrade_ = function () {
	        var conn = this.transportManager_.upgradeTransport();
	        if (conn) {
	            this.startUpgrade_(conn);
	        }
	    };
	    Connection.prototype.startUpgrade_ = function (conn) {
	        var _this = this;
	        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.sessionId);
	        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
	        // can consider the transport healthy.
	        this.secondaryResponsesRequired_ =
	            conn['responsesRequiredToBeHealthy'] || 0;
	        var onMessage = this.connReceiver_(this.secondaryConn_);
	        var onDisconnect = this.disconnReceiver_(this.secondaryConn_);
	        this.secondaryConn_.open(onMessage, onDisconnect);
	        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
	        util_1.setTimeoutNonBlocking(function () {
	            if (_this.secondaryConn_) {
	                _this.log_('Timed out trying to upgrade.');
	                _this.secondaryConn_.close();
	            }
	        }, Math.floor(UPGRADE_TIMEOUT));
	    };
	    Connection.prototype.onReset_ = function (host) {
	        this.log_('Reset packet received.  New host: ' + host);
	        this.repoInfo_.updateHost(host);
	        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
	        // We don't currently support resets after the connection has already been established
	        if (this.state_ === 1 /* CONNECTED */) {
	            this.close();
	        }
	        else {
	            // Close whatever connections we have open and start again.
	            this.closeConnections_();
	            this.start_();
	        }
	    };
	    Connection.prototype.onConnectionEstablished_ = function (conn, timestamp) {
	        var _this = this;
	        this.log_('Realtime connection established.');
	        this.conn_ = conn;
	        this.state_ = 1 /* CONNECTED */;
	        if (this.onReady_) {
	            this.onReady_(timestamp, this.sessionId);
	            this.onReady_ = null;
	        }
	        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
	        // send some pings.
	        if (this.primaryResponsesRequired_ === 0) {
	            this.log_('Primary connection is healthy.');
	            this.isHealthy_ = true;
	        }
	        else {
	            util_1.setTimeoutNonBlocking(function () {
	                _this.sendPingOnPrimaryIfNecessary_();
	            }, Math.floor(DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
	        }
	    };
	    Connection.prototype.sendPingOnPrimaryIfNecessary_ = function () {
	        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
	        if (!this.isHealthy_ && this.state_ === 1 /* CONNECTED */) {
	            this.log_('sending ping on primary.');
	            this.sendData_({ t: 'c', d: { t: PING, d: {} } });
	        }
	    };
	    Connection.prototype.onSecondaryConnectionLost_ = function () {
	        var conn = this.secondaryConn_;
	        this.secondaryConn_ = null;
	        if (this.tx_ === conn || this.rx_ === conn) {
	            // we are relying on this connection already in some capacity. Therefore, a failure is real
	            this.close();
	        }
	    };
	    /**
	     *
	     * @param {boolean} everConnected Whether or not the connection ever reached a server. Used to determine if
	     * we should flush the host cache
	     * @private
	     */
	    Connection.prototype.onConnectionLost_ = function (everConnected) {
	        this.conn_ = null;
	        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
	        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
	        if (!everConnected && this.state_ === 0 /* CONNECTING */) {
	            this.log_('Realtime connection failed.');
	            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
	            if (this.repoInfo_.isCacheableHost()) {
	                storage_1.PersistentStorage.remove('host:' + this.repoInfo_.host);
	                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
	                this.repoInfo_.internalHost = this.repoInfo_.host;
	            }
	        }
	        else if (this.state_ === 1 /* CONNECTED */) {
	            this.log_('Realtime connection lost.');
	        }
	        this.close();
	    };
	    /**
	     *
	     * @param {string} reason
	     * @private
	     */
	    Connection.prototype.onConnectionShutdown_ = function (reason) {
	        this.log_('Connection shutdown command received. Shutting down...');
	        if (this.onKill_) {
	            this.onKill_(reason);
	            this.onKill_ = null;
	        }
	        // We intentionally don't want to fire onDisconnect (kill is a different case),
	        // so clear the callback.
	        this.onDisconnect_ = null;
	        this.close();
	    };
	    Connection.prototype.sendData_ = function (data) {
	        if (this.state_ !== 1 /* CONNECTED */) {
	            throw 'Connection is not connected';
	        }
	        else {
	            this.tx_.send(data);
	        }
	    };
	    /**
	     * Cleans up this connection, calling the appropriate callbacks
	     */
	    Connection.prototype.close = function () {
	        if (this.state_ !== 2 /* DISCONNECTED */) {
	            this.log_('Closing realtime connection.');
	            this.state_ = 2 /* DISCONNECTED */;
	            this.closeConnections_();
	            if (this.onDisconnect_) {
	                this.onDisconnect_();
	                this.onDisconnect_ = null;
	            }
	        }
	    };
	    /**
	     *
	     * @private
	     */
	    Connection.prototype.closeConnections_ = function () {
	        this.log_('Shutting down all connections');
	        if (this.conn_) {
	            this.conn_.close();
	            this.conn_ = null;
	        }
	        if (this.secondaryConn_) {
	            this.secondaryConn_.close();
	            this.secondaryConn_ = null;
	        }
	        if (this.healthyTimeout_) {
	            clearTimeout(this.healthyTimeout_);
	            this.healthyTimeout_ = null;
	        }
	    };
	    return Connection;
	}());
	exports.Connection = Connection;
	
	//# sourceMappingURL=Connection.js.map


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var app_1 = __webpack_require__(35);
	var util_1 = __webpack_require__(2);
	var util_2 = __webpack_require__(13);
	var StatsManager_1 = __webpack_require__(118);
	var Constants_1 = __webpack_require__(92);
	var util_3 = __webpack_require__(2);
	var storage_1 = __webpack_require__(89);
	var util_4 = __webpack_require__(2);
	var util_5 = __webpack_require__(2);
	var WEBSOCKET_MAX_FRAME_SIZE = 16384;
	var WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
	var WebSocketImpl = null;
	if (typeof MozWebSocket !== 'undefined') {
	    WebSocketImpl = MozWebSocket;
	}
	else if (typeof WebSocket !== 'undefined') {
	    WebSocketImpl = WebSocket;
	}
	function setWebSocketImpl(impl) {
	    WebSocketImpl = impl;
	}
	exports.setWebSocketImpl = setWebSocketImpl;
	/**
	 * Create a new websocket connection with the given callbacks.
	 * @constructor
	 * @implements {Transport}
	 */
	var WebSocketConnection = /** @class */ (function () {
	    /**
	     * @param {string} connId identifier for this transport
	     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
	     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
	     *                                         session
	     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
	     */
	    function WebSocketConnection(connId, repoInfo, transportSessionId, lastSessionId) {
	        this.connId = connId;
	        this.keepaliveTimer = null;
	        this.frames = null;
	        this.totalFrames = 0;
	        this.bytesSent = 0;
	        this.bytesReceived = 0;
	        this.log_ = util_2.logWrapper(this.connId);
	        this.stats_ = StatsManager_1.StatsManager.getCollection(repoInfo);
	        this.connURL = WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId);
	    }
	    /**
	     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
	     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
	     *                                         session
	     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
	     * @return {string} connection url
	     * @private
	     */
	    WebSocketConnection.connectionURL_ = function (repoInfo, transportSessionId, lastSessionId) {
	        var urlParams = {};
	        urlParams[Constants_1.VERSION_PARAM] = Constants_1.PROTOCOL_VERSION;
	        if (!util_5.isNodeSdk() &&
	            typeof location !== 'undefined' &&
	            location.href &&
	            location.href.indexOf(Constants_1.FORGE_DOMAIN) !== -1) {
	            urlParams[Constants_1.REFERER_PARAM] = Constants_1.FORGE_REF;
	        }
	        if (transportSessionId) {
	            urlParams[Constants_1.TRANSPORT_SESSION_PARAM] = transportSessionId;
	        }
	        if (lastSessionId) {
	            urlParams[Constants_1.LAST_SESSION_PARAM] = lastSessionId;
	        }
	        return repoInfo.connectionURL(Constants_1.WEBSOCKET, urlParams);
	    };
	    /**
	     *
	     * @param onMessage Callback when messages arrive
	     * @param onDisconnect Callback with connection lost.
	     */
	    WebSocketConnection.prototype.open = function (onMessage, onDisconnect) {
	        var _this = this;
	        this.onDisconnect = onDisconnect;
	        this.onMessage = onMessage;
	        this.log_('Websocket connecting to ' + this.connURL);
	        this.everConnected_ = false;
	        // Assume failure until proven otherwise.
	        storage_1.PersistentStorage.set('previous_websocket_failure', true);
	        try {
	            if (util_5.isNodeSdk()) {
	                var device = util_3.CONSTANTS.NODE_ADMIN ? 'AdminNode' : 'Node';
	                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
	                var options = {
	                    headers: {
	                        'User-Agent': "Firebase/" + Constants_1.PROTOCOL_VERSION + "/" + app_1.default.SDK_VERSION + "/" + process.platform + "/" + device
	                    }
	                };
	                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
	                var env = process['env'];
	                var proxy = this.connURL.indexOf('wss://') == 0
	                    ? env['HTTPS_PROXY'] || env['https_proxy']
	                    : env['HTTP_PROXY'] || env['http_proxy'];
	                if (proxy) {
	                    options['proxy'] = { origin: proxy };
	                }
	                this.mySock = new WebSocketImpl(this.connURL, [], options);
	            }
	            else {
	                this.mySock = new WebSocketImpl(this.connURL);
	            }
	        }
	        catch (e) {
	            this.log_('Error instantiating WebSocket.');
	            var error = e.message || e.data;
	            if (error) {
	                this.log_(error);
	            }
	            this.onClosed_();
	            return;
	        }
	        this.mySock.onopen = function () {
	            _this.log_('Websocket connected.');
	            _this.everConnected_ = true;
	        };
	        this.mySock.onclose = function () {
	            _this.log_('Websocket connection was disconnected.');
	            _this.mySock = null;
	            _this.onClosed_();
	        };
	        this.mySock.onmessage = function (m) {
	            _this.handleIncomingFrame(m);
	        };
	        this.mySock.onerror = function (e) {
	            _this.log_('WebSocket error.  Closing connection.');
	            var error = e.message || e.data;
	            if (error) {
	                _this.log_(error);
	            }
	            _this.onClosed_();
	        };
	    };
	    /**
	     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
	     */
	    WebSocketConnection.prototype.start = function () { };
	    WebSocketConnection.forceDisallow = function () {
	        WebSocketConnection.forceDisallow_ = true;
	    };
	    WebSocketConnection.isAvailable = function () {
	        var isOldAndroid = false;
	        if (typeof navigator !== 'undefined' && navigator.userAgent) {
	            var oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
	            var oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
	            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
	                if (parseFloat(oldAndroidMatch[1]) < 4.4) {
	                    isOldAndroid = true;
	                }
	            }
	        }
	        return (!isOldAndroid &&
	            WebSocketImpl !== null &&
	            !WebSocketConnection.forceDisallow_);
	    };
	    /**
	     * Returns true if we previously failed to connect with this transport.
	     * @return {boolean}
	     */
	    WebSocketConnection.previouslyFailed = function () {
	        // If our persistent storage is actually only in-memory storage,
	        // we default to assuming that it previously failed to be safe.
	        return (storage_1.PersistentStorage.isInMemoryStorage ||
	            storage_1.PersistentStorage.get('previous_websocket_failure') === true);
	    };
	    WebSocketConnection.prototype.markConnectionHealthy = function () {
	        storage_1.PersistentStorage.remove('previous_websocket_failure');
	    };
	    WebSocketConnection.prototype.appendFrame_ = function (data) {
	        this.frames.push(data);
	        if (this.frames.length == this.totalFrames) {
	            var fullMess = this.frames.join('');
	            this.frames = null;
	            var jsonMess = util_4.jsonEval(fullMess);
	            //handle the message
	            this.onMessage(jsonMess);
	        }
	    };
	    /**
	     * @param {number} frameCount The number of frames we are expecting from the server
	     * @private
	     */
	    WebSocketConnection.prototype.handleNewFrameCount_ = function (frameCount) {
	        this.totalFrames = frameCount;
	        this.frames = [];
	    };
	    /**
	     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
	     * @param {!String} data
	     * @return {?String} Any remaining data to be process, or null if there is none
	     * @private
	     */
	    WebSocketConnection.prototype.extractFrameCount_ = function (data) {
	        util_1.assert(this.frames === null, 'We already have a frame buffer');
	        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
	        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
	        if (data.length <= 6) {
	            var frameCount = Number(data);
	            if (!isNaN(frameCount)) {
	                this.handleNewFrameCount_(frameCount);
	                return null;
	            }
	        }
	        this.handleNewFrameCount_(1);
	        return data;
	    };
	    /**
	     * Process a websocket frame that has arrived from the server.
	     * @param mess The frame data
	     */
	    WebSocketConnection.prototype.handleIncomingFrame = function (mess) {
	        if (this.mySock === null)
	            return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
	        var data = mess['data'];
	        this.bytesReceived += data.length;
	        this.stats_.incrementCounter('bytes_received', data.length);
	        this.resetKeepAlive();
	        if (this.frames !== null) {
	            // we're buffering
	            this.appendFrame_(data);
	        }
	        else {
	            // try to parse out a frame count, otherwise, assume 1 and process it
	            var remainingData = this.extractFrameCount_(data);
	            if (remainingData !== null) {
	                this.appendFrame_(remainingData);
	            }
	        }
	    };
	    /**
	     * Send a message to the server
	     * @param {Object} data The JSON object to transmit
	     */
	    WebSocketConnection.prototype.send = function (data) {
	        this.resetKeepAlive();
	        var dataStr = util_4.stringify(data);
	        this.bytesSent += dataStr.length;
	        this.stats_.incrementCounter('bytes_sent', dataStr.length);
	        //We can only fit a certain amount in each websocket frame, so we need to split this request
	        //up into multiple pieces if it doesn't fit in one request.
	        var dataSegs = util_2.splitStringBySize(dataStr, WEBSOCKET_MAX_FRAME_SIZE);
	        //Send the length header
	        if (dataSegs.length > 1) {
	            this.sendString_(String(dataSegs.length));
	        }
	        //Send the actual data in segments.
	        for (var i = 0; i < dataSegs.length; i++) {
	            this.sendString_(dataSegs[i]);
	        }
	    };
	    WebSocketConnection.prototype.shutdown_ = function () {
	        this.isClosed_ = true;
	        if (this.keepaliveTimer) {
	            clearInterval(this.keepaliveTimer);
	            this.keepaliveTimer = null;
	        }
	        if (this.mySock) {
	            this.mySock.close();
	            this.mySock = null;
	        }
	    };
	    WebSocketConnection.prototype.onClosed_ = function () {
	        if (!this.isClosed_) {
	            this.log_('WebSocket is closing itself');
	            this.shutdown_();
	            // since this is an internal close, trigger the close listener
	            if (this.onDisconnect) {
	                this.onDisconnect(this.everConnected_);
	                this.onDisconnect = null;
	            }
	        }
	    };
	    /**
	     * External-facing close handler.
	     * Close the websocket and kill the connection.
	     */
	    WebSocketConnection.prototype.close = function () {
	        if (!this.isClosed_) {
	            this.log_('WebSocket is being closed');
	            this.shutdown_();
	        }
	    };
	    /**
	     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
	     * the last activity.
	     */
	    WebSocketConnection.prototype.resetKeepAlive = function () {
	        var _this = this;
	        clearInterval(this.keepaliveTimer);
	        this.keepaliveTimer = setInterval(function () {
	            //If there has been no websocket activity for a while, send a no-op
	            if (_this.mySock) {
	                _this.sendString_('0');
	            }
	            _this.resetKeepAlive();
	        }, Math.floor(WEBSOCKET_KEEPALIVE_INTERVAL));
	    };
	    /**
	     * Send a string over the websocket.
	     *
	     * @param {string} str String to send.
	     * @private
	     */
	    WebSocketConnection.prototype.sendString_ = function (str) {
	        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
	        // calls for some unknown reason.  We treat these as an error and disconnect.
	        // See https://app.asana.com/0/58926111402292/68021340250410
	        try {
	            this.mySock.send(str);
	        }
	        catch (e) {
	            this.log_('Exception thrown from WebSocket.send():', e.message || e.data, 'Closing connection.');
	            setTimeout(this.onClosed_.bind(this), 0);
	        }
	    };
	    /**
	     * Number of response before we consider the connection "healthy."
	     * @type {number}
	     */
	    WebSocketConnection.responsesRequiredToBeHealthy = 2;
	    /**
	     * Time to wait for the connection te become healthy before giving up.
	     * @type {number}
	     */
	    WebSocketConnection.healthyTimeout = 30000;
	    return WebSocketConnection;
	}());
	exports.WebSocketConnection = WebSocketConnection;
	
	//# sourceMappingURL=WebSocketConnection.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(106)))

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var api_1 = __webpack_require__(128);
	/**
	 * An opaque base class for FieldValue sentinel objects in our public API,
	 * with public static methods for creating said sentinel objects.
	 */
	// tslint:disable-next-line:class-as-namespace  We use this as a base class.
	var FieldValueImpl = /** @class */ (function () {
	    function FieldValueImpl() {
	    }
	    FieldValueImpl.delete = function () {
	        return DeleteFieldValueImpl.instance;
	    };
	    FieldValueImpl.serverTimestamp = function () {
	        return ServerTimestampFieldValueImpl.instance;
	    };
	    return FieldValueImpl;
	}());
	exports.FieldValueImpl = FieldValueImpl;
	var DeleteFieldValueImpl = /** @class */ (function (_super) {
	    __extends(DeleteFieldValueImpl, _super);
	    function DeleteFieldValueImpl() {
	        return _super.call(this) || this;
	    }
	    /** Singleton instance. */
	    DeleteFieldValueImpl.instance = new DeleteFieldValueImpl();
	    return DeleteFieldValueImpl;
	}(FieldValueImpl));
	exports.DeleteFieldValueImpl = DeleteFieldValueImpl;
	var ServerTimestampFieldValueImpl = /** @class */ (function (_super) {
	    __extends(ServerTimestampFieldValueImpl, _super);
	    function ServerTimestampFieldValueImpl() {
	        return _super.call(this) || this;
	    }
	    /** Singleton instance. */
	    ServerTimestampFieldValueImpl.instance = new ServerTimestampFieldValueImpl();
	    return ServerTimestampFieldValueImpl;
	}(FieldValueImpl));
	exports.ServerTimestampFieldValueImpl = ServerTimestampFieldValueImpl;
	// Public instance that disallows construction at runtime. This constructor is
	// used when exporting FieldValueImpl on firebase.firestore.FieldValue and will
	// be called FieldValue publicly. Internally we still use FieldValueImpl which
	// has a type-checked private constructor. Note that FieldValueImpl and
	// PublicFieldValue can be used interchangeably in instanceof checks.
	// For our internal TypeScript code PublicFieldValue doesn't exist as a type,
	// and so we need to use FieldValueImpl as type and export it too.
	// tslint:disable-next-line:variable-name  We treat this as a class name.
	exports.PublicFieldValue = api_1.makeConstructorPrivate(FieldValueImpl, 'Use FieldValue.<field>() instead.');
	
	//# sourceMappingURL=field_value.js.map


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var misc_1 = __webpack_require__(25);
	var DatabaseInfo = /** @class */ (function () {
	    /**
	     * Constructs a DatabaseInfo using the provided host, databaseId and
	     * persistenceKey.
	     *
	     * @param databaseId The database to use.
	     * @param persistenceKey A unique identifier for this Firestore's local
	     * storage (used in conjunction with the databaseId).
	     * @param host The Firestore backend host to connect to.
	     * @param ssl Whether to use SSL when connecting.
	     */
	    function DatabaseInfo(databaseId, persistenceKey, host, ssl) {
	        this.databaseId = databaseId;
	        this.persistenceKey = persistenceKey;
	        this.host = host;
	        this.ssl = ssl;
	    }
	    return DatabaseInfo;
	}());
	exports.DatabaseInfo = DatabaseInfo;
	/** The default database name for a project. */
	var DEFAULT_DATABASE_NAME = '(default)';
	/** Represents the database ID a Firestore client is associated with. */
	var DatabaseId = /** @class */ (function () {
	    function DatabaseId(projectId, database) {
	        this.projectId = projectId;
	        this.database = database ? database : DEFAULT_DATABASE_NAME;
	    }
	    Object.defineProperty(DatabaseId.prototype, "isDefaultDatabase", {
	        get: function () {
	            return this.database === DEFAULT_DATABASE_NAME;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DatabaseId.prototype.equals = function (other) {
	        return (other instanceof DatabaseId &&
	            other.projectId === this.projectId &&
	            other.database === this.database);
	    };
	    DatabaseId.prototype.compareTo = function (other) {
	        return (misc_1.primitiveComparator(this.projectId, other.projectId) ||
	            misc_1.primitiveComparator(this.database, other.database));
	    };
	    return DatabaseId;
	}());
	exports.DatabaseId = DatabaseId;
	
	//# sourceMappingURL=database_info.js.map


/***/ },
/* 191 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var RESERVED_BITS = 1;
	var GeneratorIds;
	(function (GeneratorIds) {
	    GeneratorIds[GeneratorIds["LocalStore"] = 0] = "LocalStore";
	    GeneratorIds[GeneratorIds["SyncEngine"] = 1] = "SyncEngine";
	})(GeneratorIds || (GeneratorIds = {}));
	/**
	 * TargetIdGenerator generates monotonically increasing integer IDs. There are
	 * separate generators for different scopes. While these generators will operate
	 * independently of each other, they are scoped, such that no two generators
	 * will ever produce the same ID. This is useful, because sometimes the backend
	 * may group IDs from separate parts of the client into the same ID space.
	 */
	var TargetIdGenerator = /** @class */ (function () {
	    function TargetIdGenerator(generatorId, initAfter) {
	        if (initAfter === void 0) { initAfter = 0; }
	        this.generatorId = generatorId;
	        // Replace the generator part of initAfter with this generator's ID.
	        var afterWithoutGenerator = (initAfter >> RESERVED_BITS) << RESERVED_BITS;
	        var afterGenerator = initAfter - afterWithoutGenerator;
	        if (afterGenerator >= generatorId) {
	            // For example, if:
	            //   this.generatorId = 0b0000
	            //   after = 0b1011
	            //   afterGenerator = 0b0001
	            // Then:
	            //   previous = 0b1010
	            //   next = 0b1100
	            this.previousId = afterWithoutGenerator | this.generatorId;
	        }
	        else {
	            // For example, if:
	            //   this.generatorId = 0b0001
	            //   after = 0b1010
	            //   afterGenerator = 0b0000
	            // Then:
	            //   previous = 0b1001
	            //   next = 0b1011
	            this.previousId =
	                (afterWithoutGenerator | this.generatorId) - (1 << RESERVED_BITS);
	        }
	    }
	    TargetIdGenerator.prototype.next = function () {
	        this.previousId += 1 << RESERVED_BITS;
	        return this.previousId;
	    };
	    TargetIdGenerator.forLocalStore = function (initAfter) {
	        if (initAfter === void 0) { initAfter = 0; }
	        return new TargetIdGenerator(GeneratorIds.LocalStore, initAfter);
	    };
	    TargetIdGenerator.forSyncEngine = function () {
	        return new TargetIdGenerator(GeneratorIds.SyncEngine);
	    };
	    return TargetIdGenerator;
	}());
	exports.TargetIdGenerator = TargetIdGenerator;
	
	//# sourceMappingURL=target_id_generator.js.map


/***/ },
/* 192 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** Describes the online state of the Firestore client */
	var OnlineState;
	(function (OnlineState) {
	    /**
	     * The Firestore client is in an unknown online state. This means the client
	     * is either not actively trying to establish a connection or it was
	     * previously in an unknown state and is trying to establish a connection.
	     */
	    OnlineState[OnlineState["Unknown"] = 0] = "Unknown";
	    /**
	     * The client is connected and the connections are healthy. This state is
	     * reached after a successful connection and there has been at least one
	     * succesful message received from the backends.
	     */
	    OnlineState[OnlineState["Healthy"] = 1] = "Healthy";
	    /**
	     * The client has tried to establish a connection but has failed.
	     * This state is reached after either a connection attempt failed or a
	     * healthy stream was closed for unexpected reasons.
	     */
	    OnlineState[OnlineState["Failed"] = 2] = "Failed";
	})(OnlineState = exports.OnlineState || (exports.OnlineState = {}));
	
	//# sourceMappingURL=types.js.map


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var collections_1 = __webpack_require__(20);
	var persistence_promise_1 = __webpack_require__(29);
	/**
	 * A garbage collector implementation that eagerly collects documents as soon as
	 * they're no longer referenced in any of its registered GarbageSources.
	 *
	 * This implementation keeps track of a set of keys that are potentially garbage
	 * without keeping an exact reference count. During collectGarbage, the
	 * collector verifies that all potential garbage keys actually have no
	 * references by consulting its list of garbage sources.
	 */
	var EagerGarbageCollector = /** @class */ (function () {
	    function EagerGarbageCollector() {
	        this.isEager = true;
	        /**
	         * The garbage collectible sources to double-check during garbage collection.
	         */
	        this.sources = [];
	        /**
	         * A set of potentially garbage keys.
	         * PORTING NOTE: This would be a mutable set if Javascript had one.
	         */
	        this.potentialGarbage = collections_1.documentKeySet();
	    }
	    EagerGarbageCollector.prototype.addGarbageSource = function (garbageSource) {
	        this.sources.push(garbageSource);
	        garbageSource.setGarbageCollector(this);
	    };
	    EagerGarbageCollector.prototype.removeGarbageSource = function (garbageSource) {
	        this.sources.splice(this.sources.indexOf(garbageSource), 1);
	        garbageSource.setGarbageCollector(null);
	    };
	    EagerGarbageCollector.prototype.addPotentialGarbageKey = function (key) {
	        this.potentialGarbage = this.potentialGarbage.add(key);
	    };
	    EagerGarbageCollector.prototype.collectGarbage = function (txn) {
	        var _this = this;
	        var promises = [];
	        var garbageKeys = collections_1.documentKeySet();
	        this.potentialGarbage.forEach(function (key) {
	            var hasRefsPromise = _this.documentHasAnyReferences(txn, key);
	            promises.push(hasRefsPromise.next(function (hasRefs) {
	                // If there are no references, get the key.
	                if (!hasRefs) {
	                    garbageKeys = garbageKeys.add(key);
	                }
	                return persistence_promise_1.PersistencePromise.resolve();
	            }));
	        });
	        // Clear locally retained potential keys and returned confirmed garbage.
	        this.potentialGarbage = collections_1.documentKeySet();
	        return persistence_promise_1.PersistencePromise.waitFor(promises).next(function () { return garbageKeys; });
	    };
	    EagerGarbageCollector.prototype.documentHasAnyReferences = function (txn, key) {
	        var initial = persistence_promise_1.PersistencePromise.resolve(false);
	        return this.sources
	            .map(function (source) { return function () { return source.containsKey(txn, key); }; })
	            .reduce(function (promise, nextPromise) {
	            return promise.next(function (result) {
	                if (result) {
	                    return persistence_promise_1.PersistencePromise.resolve(true);
	                }
	                else {
	                    return nextPromise();
	                }
	            });
	        }, initial);
	    };
	    return EagerGarbageCollector;
	}());
	exports.EagerGarbageCollector = EagerGarbageCollector;
	
	//# sourceMappingURL=eager_garbage_collector.js.map


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(10);
	var sorted_map_1 = __webpack_require__(50);
	var collections_1 = __webpack_require__(20);
	var document_key_1 = __webpack_require__(22);
	/**
	 * DocumentSet is an immutable (copy-on-write) collection that holds documents
	 * in order specified by the provided comparator. We always add a document key
	 * comparator on top of what is provided to guarantee document equality based on
	 * the key.
	 */
	var DocumentSet = /** @class */ (function () {
	    /** The default ordering is by key if the comparator is omitted */
	    function DocumentSet(comp) {
	        // We are adding document key comparator to the end as it's the only
	        // guaranteed unique property of a document.
	        if (comp) {
	            this.comparator = function (d1, d2) {
	                return comp(d1, d2) || document_key_1.DocumentKey.comparator(d1.key, d2.key);
	            };
	        }
	        else {
	            this.comparator = function (d1, d2) {
	                return document_key_1.DocumentKey.comparator(d1.key, d2.key);
	            };
	        }
	        this.keyedMap = collections_1.documentMap();
	        this.sortedSet = new sorted_map_1.SortedMap(this.comparator);
	    }
	    /**
	     * Returns an empty copy of the existing DocumentSet, using the same
	     * comparator.
	     */
	    DocumentSet.emptySet = function (oldSet) {
	        return new DocumentSet(oldSet.comparator);
	    };
	    DocumentSet.prototype.has = function (key) {
	        return this.keyedMap.get(key) != null;
	    };
	    DocumentSet.prototype.get = function (key) {
	        return this.keyedMap.get(key);
	    };
	    DocumentSet.prototype.first = function () {
	        return this.sortedSet.minKey();
	    };
	    DocumentSet.prototype.last = function () {
	        return this.sortedSet.maxKey();
	    };
	    DocumentSet.prototype.isEmpty = function () {
	        return this.sortedSet.isEmpty();
	    };
	    /**
	     * Returns previous document or null if it's a first doc.
	     *
	     * @param key A key that MUST be present in the DocumentSet.
	     */
	    DocumentSet.prototype.prevDoc = function (key) {
	        assert_1.assert(this.has(key), 'Trying to get a previous document to non-existing key: ' + key);
	        var doc = this.keyedMap.get(key);
	        return this.sortedSet.getPredecessorKey(doc);
	    };
	    /**
	     * Returns the index of the provided key in the document set, or -1 if the
	     * document key is not present in the set;
	     */
	    DocumentSet.prototype.indexOf = function (key) {
	        var doc = this.keyedMap.get(key);
	        return doc ? this.sortedSet.indexOf(doc) : -1;
	    };
	    Object.defineProperty(DocumentSet.prototype, "size", {
	        get: function () {
	            return this.sortedSet.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** Iterates documents in order defined by "comparator" */
	    DocumentSet.prototype.forEach = function (cb) {
	        this.sortedSet.inorderTraversal(function (k, v) {
	            cb(k);
	            return false;
	        });
	    };
	    /** Inserts or updates a document with the same key */
	    DocumentSet.prototype.add = function (doc) {
	        // First remove the element if we have it.
	        var set = this.delete(doc.key);
	        return set.copy(set.keyedMap.insert(doc.key, doc), set.sortedSet.insert(doc, null));
	    };
	    /** Deletes a document with a given key */
	    DocumentSet.prototype.delete = function (key) {
	        var doc = this.get(key);
	        if (!doc) {
	            return this;
	        }
	        return this.copy(this.keyedMap.remove(key), this.sortedSet.remove(doc));
	    };
	    DocumentSet.prototype.equals = function (other) {
	        if (!(other instanceof DocumentSet))
	            return false;
	        if (this.size !== other.size)
	            return false;
	        var thisIt = this.sortedSet.getIterator();
	        var otherIt = other.sortedSet.getIterator();
	        while (thisIt.hasNext()) {
	            var thisDoc = thisIt.getNext().key;
	            var otherDoc = otherIt.getNext().key;
	            if (!thisDoc.equals(otherDoc))
	                return false;
	        }
	        return true;
	    };
	    DocumentSet.prototype.toString = function () {
	        var docStrings = [];
	        this.forEach(function (doc) {
	            docStrings.push(doc.toString());
	        });
	        if (docStrings.length === 0) {
	            return 'DocumentSet ()';
	        }
	        else {
	            return 'DocumentSet (\n  ' + docStrings.join('  \n') + '\n)';
	        }
	    };
	    DocumentSet.prototype.copy = function (keyedMap, sortedSet) {
	        var newSet = new DocumentSet();
	        newSet.comparator = this.comparator;
	        newSet.keyedMap = keyedMap;
	        newSet.sortedSet = sortedSet;
	        return newSet;
	    };
	    return DocumentSet;
	}());
	exports.DocumentSet = DocumentSet;
	
	//# sourceMappingURL=document_set.js.map


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var blob_1 = __webpack_require__(121);
	var geo_point_1 = __webpack_require__(123);
	var database_info_1 = __webpack_require__(190);
	var query_1 = __webpack_require__(124);
	var snapshot_version_1 = __webpack_require__(31);
	var timestamp_1 = __webpack_require__(55);
	var query_data_1 = __webpack_require__(69);
	var document_1 = __webpack_require__(32);
	var document_key_1 = __webpack_require__(22);
	var fieldValue = __webpack_require__(57);
	var mutation_1 = __webpack_require__(96);
	var path_1 = __webpack_require__(49);
	var assert_1 = __webpack_require__(10);
	var error_1 = __webpack_require__(19);
	var obj = __webpack_require__(36);
	var typeUtils = __webpack_require__(73);
	var existence_filter_1 = __webpack_require__(484);
	var rpc_error_1 = __webpack_require__(127);
	var watch_change_1 = __webpack_require__(196);
	var DIRECTIONS = (function () {
	    var dirs = {};
	    dirs[query_1.Direction.ASCENDING.name] = 'ASCENDING';
	    dirs[query_1.Direction.DESCENDING.name] = 'DESCENDING';
	    return dirs;
	})();
	var OPERATORS = (function () {
	    var ops = {};
	    ops[query_1.RelationOp.LESS_THAN.name] = 'LESS_THAN';
	    ops[query_1.RelationOp.LESS_THAN_OR_EQUAL.name] = 'LESS_THAN_OR_EQUAL';
	    ops[query_1.RelationOp.GREATER_THAN.name] = 'GREATER_THAN';
	    ops[query_1.RelationOp.GREATER_THAN_OR_EQUAL.name] = 'GREATER_THAN_OR_EQUAL';
	    ops[query_1.RelationOp.EQUAL.name] = 'EQUAL';
	    return ops;
	})();
	function assertPresent(value, description) {
	    assert_1.assert(!typeUtils.isNullOrUndefined(value), description + ' is missing');
	}
	function parseInt64(value) {
	    // TODO(bjornick): Handle int64 greater than 53 bits.
	    if (typeof value === 'number') {
	        return value;
	    }
	    else if (typeof value === 'string') {
	        return parseInt(value, 10);
	    }
	    else {
	        return assert_1.fail("can't parse " + value);
	    }
	}
	/**
	 * Generates JsonObject values for the Datastore API suitable for sending to
	 * either GRPC stub methods or via the JSON/HTTP REST API.
	 * TODO(klimt): We can remove the databaseId argument if we keep the full
	 * resource name in documents.
	 */
	var JsonProtoSerializer = /** @class */ (function () {
	    function JsonProtoSerializer(databaseId, options) {
	        this.databaseId = databaseId;
	        this.options = options;
	    }
	    JsonProtoSerializer.prototype.emptyByteString = function () {
	        if (this.options.useProto3Json) {
	            return '';
	        }
	        else {
	            return new Uint8Array(0);
	        }
	    };
	    JsonProtoSerializer.prototype.unsafeCastProtoByteString = function (byteString) {
	        // byteStrings can be either string or UInt8Array, but the typings say
	        // it's always a string. Cast as string to avoid type check failing
	        return byteString;
	    };
	    JsonProtoSerializer.prototype.fromRpcStatus = function (status) {
	        var code = status.code === undefined
	            ? error_1.Code.UNKNOWN
	            : rpc_error_1.mapCodeFromRpcCode(status.code);
	        return new error_1.FirestoreError(code, status.message || '');
	    };
	    /**
	     * Returns a value for a number (or undefined) that's appropriate to put into
	     * a google.protobuf.Int32Value proto.
	     * DO NOT USE THIS FOR ANYTHING ELSE.
	     * This method cheats. It's typed as returning "number" because that's what
	     * our generated proto interfaces say Int32Value must be. But GRPC actually
	     * expects a { value: <number> } struct.
	     */
	    JsonProtoSerializer.prototype.toInt32Value = function (val) {
	        if (!typeUtils.isNullOrUndefined(val)) {
	            return { value: val };
	        }
	        else {
	            return undefined;
	        }
	    };
	    /**
	     * Returns a number (or null) from a google.protobuf.Int32Value proto.
	     * DO NOT USE THIS FOR ANYTHING ELSE.
	     * This method cheats. It's typed as accepting "number" because that's what
	     * our generated proto interfaces say Int32Value must be, but it actually
	     * accepts { value: number } to match our serialization in toInt32Value().
	     */
	    JsonProtoSerializer.prototype.fromInt32Value = function (val) {
	        var result;
	        if (typeof val === 'object') {
	            result = val.value;
	        }
	        else {
	            // We accept raw numbers (without the {value: ... } wrapper) for
	            // compatibility with legacy persisted data.
	            result = val;
	        }
	        return typeUtils.isNullOrUndefined(result) ? null : result;
	    };
	    /**
	     * Returns a value for a Date that's appropriate to put into a proto.
	     * DO NOT USE THIS FOR ANYTHING ELSE.
	     * This method cheats. It's typed as returning "string" because that's what
	     * our generated proto interfaces say dates must be. But it's easier and safer
	     * to actually return a Timestamp proto.
	     */
	    JsonProtoSerializer.prototype.toTimestamp = function (timestamp) {
	        return {
	            seconds: timestamp.seconds,
	            nanos: timestamp.nanos
	            // tslint:disable-next-line:no-any
	        };
	    };
	    JsonProtoSerializer.prototype.fromTimestamp = function (date) {
	        // The json interface (for the browser) will return an iso timestamp string,
	        // while the proto js library (for node) will return a
	        // google.protobuf.Timestamp instance.
	        if (typeof date === 'string') {
	            // TODO(b/37282237): Use strings for Proto3 timestamps
	            // assert(this.options.useProto3Json,
	            //   'The timestamp string format requires Proto3.');
	            return timestamp_1.Timestamp.fromISOString(date);
	        }
	        else {
	            assert_1.assert(!!date, 'Cannot deserialize null or undefined timestamp.');
	            // TODO(b/37282237): Use strings for Proto3 timestamps
	            // assert(!this.options.useProto3Json,
	            //   'The timestamp instance format requires Proto JS.');
	            var seconds = parseInt64(date.seconds || '0');
	            var nanos = date.nanos || 0;
	            return new timestamp_1.Timestamp(seconds, nanos);
	        }
	    };
	    /**
	     * Returns a value for bytes that's appropriate to put in a proto.
	     * DO NOT USE THIS FOR ANYTHING ELSE.
	     * This method cheats. It's typed as returning "string" because that's what
	     * our generated proto interfaces say bytes must be. But it should return
	     * an Uint8Array in Node.
	     */
	    JsonProtoSerializer.prototype.toBytes = function (bytes) {
	        if (this.options.useProto3Json) {
	            return bytes.toBase64();
	        }
	        else {
	            // The typings say it's a string, but it needs to be a Uint8Array in Node.
	            return this.unsafeCastProtoByteString(bytes.toUint8Array());
	        }
	    };
	    /**
	     * Parse the blob from the protos into the internal Blob class. Note that the
	     * typings assume all blobs are strings, but they are actually Uint8Arrays
	     * on Node.
	     */
	    JsonProtoSerializer.prototype.fromBlob = function (blob) {
	        if (typeof blob === 'string') {
	            assert_1.assert(this.options.useProto3Json, 'Expected bytes to be passed in as Uint8Array, but got a string instead.');
	            return blob_1.Blob.fromBase64String(blob);
	        }
	        else {
	            assert_1.assert(!this.options.useProto3Json, 'Expected bytes to be passed in as string, but got something else instead.');
	            return blob_1.Blob.fromUint8Array(blob);
	        }
	    };
	    JsonProtoSerializer.prototype.toVersion = function (version) {
	        return this.toTimestamp(version.toTimestamp());
	    };
	    JsonProtoSerializer.prototype.fromVersion = function (version) {
	        assert_1.assert(!!version, "Trying to deserialize version that isn't set");
	        return snapshot_version_1.SnapshotVersion.fromTimestamp(this.fromTimestamp(version));
	    };
	    JsonProtoSerializer.prototype.toResourceName = function (databaseId, path) {
	        return this.fullyQualifiedPrefixPath(databaseId)
	            .child('documents')
	            .child(path)
	            .canonicalString();
	    };
	    JsonProtoSerializer.prototype.fromResourceName = function (name) {
	        var resource = path_1.ResourcePath.fromString(name);
	        assert_1.assert(this.isValidResourceName(resource), 'Tried to deserialize invalid key ' + resource.toString());
	        return resource;
	    };
	    JsonProtoSerializer.prototype.toName = function (key) {
	        return this.toResourceName(this.databaseId, key.path);
	    };
	    JsonProtoSerializer.prototype.fromName = function (name) {
	        var resource = this.fromResourceName(name);
	        assert_1.assert(resource.get(1) === this.databaseId.projectId, 'Tried to deserialize key from different project: ' +
	            resource.get(1) +
	            ' vs ' +
	            this.databaseId.projectId);
	        assert_1.assert((!resource.get(3) && !this.databaseId.database) ||
	            resource.get(3) === this.databaseId.database, 'Tried to deserialize key from different database: ' +
	            resource.get(3) +
	            ' vs ' +
	            this.databaseId.database);
	        return new document_key_1.DocumentKey(this.extractLocalPathFromResourceName(resource));
	    };
	    JsonProtoSerializer.prototype.toQueryPath = function (path) {
	        if (path.length === 0) {
	            // If the path is empty, the backend requires we leave off the /documents
	            // at the end.
	            return this.encodedDatabaseId;
	        }
	        return this.toResourceName(this.databaseId, path);
	    };
	    JsonProtoSerializer.prototype.fromQueryPath = function (name) {
	        var resourceName = this.fromResourceName(name);
	        if (resourceName.length === 4) {
	            return path_1.ResourcePath.EMPTY_PATH;
	        }
	        return this.extractLocalPathFromResourceName(resourceName);
	    };
	    Object.defineProperty(JsonProtoSerializer.prototype, "encodedDatabaseId", {
	        get: function () {
	            var path = new path_1.ResourcePath([
	                'projects',
	                this.databaseId.projectId,
	                'databases',
	                this.databaseId.database
	            ]);
	            return path.canonicalString();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    JsonProtoSerializer.prototype.fullyQualifiedPrefixPath = function (databaseId) {
	        return new path_1.ResourcePath([
	            'projects',
	            databaseId.projectId,
	            'databases',
	            databaseId.database
	        ]);
	    };
	    JsonProtoSerializer.prototype.extractLocalPathFromResourceName = function (resourceName) {
	        assert_1.assert(resourceName.length > 4 && resourceName.get(4) === 'documents', 'tried to deserialize invalid key ' + resourceName.toString());
	        return resourceName.popFirst(5);
	    };
	    JsonProtoSerializer.prototype.isValidResourceName = function (path) {
	        // Resource names have at least 4 components (project ID, database ID)
	        return (path.length >= 4 &&
	            path.get(0) === 'projects' &&
	            path.get(2) === 'databases');
	    };
	    JsonProtoSerializer.prototype.toValue = function (val) {
	        if (val instanceof fieldValue.NullValue) {
	            return { nullValue: 'NULL_VALUE' };
	        }
	        else if (val instanceof fieldValue.BooleanValue) {
	            return { booleanValue: val.value() };
	        }
	        else if (val instanceof fieldValue.IntegerValue) {
	            return { integerValue: '' + val.value() };
	        }
	        else if (val instanceof fieldValue.DoubleValue) {
	            var doubleValue = val.value();
	            if (this.options.useProto3Json) {
	                // Proto 3 let's us encode NaN and Infinity as string values as
	                // expected by the backend. This is currently not checked by our unit
	                // tests because they rely on protobuf.js.
	                if (isNaN(doubleValue)) {
	                    return { doubleValue: 'NaN' };
	                }
	                else if (doubleValue === Infinity) {
	                    return { doubleValue: 'Infinity' };
	                }
	                else if (doubleValue === -Infinity) {
	                    return { doubleValue: '-Infinity' };
	                }
	            }
	            return { doubleValue: val.value() };
	        }
	        else if (val instanceof fieldValue.StringValue) {
	            return { stringValue: val.value() };
	        }
	        else if (val instanceof fieldValue.ObjectValue) {
	            return { mapValue: this.toMapValue(val) };
	        }
	        else if (val instanceof fieldValue.ArrayValue) {
	            return { arrayValue: this.toArrayValue(val) };
	        }
	        else if (val instanceof fieldValue.TimestampValue) {
	            return {
	                timestampValue: this.toTimestamp(val.internalValue)
	            };
	        }
	        else if (val instanceof fieldValue.GeoPointValue) {
	            return {
	                geoPointValue: {
	                    latitude: val.value().latitude,
	                    longitude: val.value().longitude
	                }
	            };
	        }
	        else if (val instanceof fieldValue.BlobValue) {
	            return {
	                bytesValue: this.toBytes(val.value())
	            };
	        }
	        else if (val instanceof fieldValue.RefValue) {
	            return {
	                referenceValue: this.toResourceName(val.databaseId, val.key.path)
	            };
	        }
	        else {
	            return assert_1.fail('Unknown FieldValue ' + JSON.stringify(val));
	        }
	    };
	    JsonProtoSerializer.prototype.fromValue = function (obj) {
	        var _this = this;
	        // tslint:disable-next-line:no-any
	        var type = obj['value_type'];
	        if (hasTag(obj, type, 'nullValue')) {
	            return fieldValue.NullValue.INSTANCE;
	        }
	        else if (hasTag(obj, type, 'booleanValue')) {
	            return fieldValue.BooleanValue.of(obj.booleanValue);
	        }
	        else if (hasTag(obj, type, 'integerValue')) {
	            return new fieldValue.IntegerValue(parseInt64(obj.integerValue));
	        }
	        else if (hasTag(obj, type, 'doubleValue')) {
	            if (this.options.useProto3Json) {
	                // Proto 3 uses the string values 'NaN' and 'Infinity'.
	                if (obj.doubleValue === 'NaN') {
	                    return fieldValue.DoubleValue.NAN;
	                }
	                else if (obj.doubleValue === 'Infinity') {
	                    return fieldValue.DoubleValue.POSITIVE_INFINITY;
	                }
	                else if (obj.doubleValue === '-Infinity') {
	                    return fieldValue.DoubleValue.NEGATIVE_INFINITY;
	                }
	            }
	            return new fieldValue.DoubleValue(obj.doubleValue);
	        }
	        else if (hasTag(obj, type, 'stringValue')) {
	            return new fieldValue.StringValue(obj.stringValue);
	        }
	        else if (hasTag(obj, type, 'mapValue')) {
	            return this.fromFields(obj.mapValue.fields || {});
	        }
	        else if (hasTag(obj, type, 'arrayValue')) {
	            // "values" is not present if the array is empty
	            assertPresent(obj.arrayValue, 'arrayValue');
	            var values = obj.arrayValue.values || [];
	            return new fieldValue.ArrayValue(values.map(function (v) { return _this.fromValue(v); }));
	        }
	        else if (hasTag(obj, type, 'timestampValue')) {
	            assertPresent(obj.timestampValue, 'timestampValue');
	            return new fieldValue.TimestampValue(this.fromTimestamp(obj.timestampValue));
	        }
	        else if (hasTag(obj, type, 'geoPointValue')) {
	            assertPresent(obj.geoPointValue, 'geoPointValue');
	            var latitude = obj.geoPointValue.latitude || 0;
	            var longitude = obj.geoPointValue.longitude || 0;
	            return new fieldValue.GeoPointValue(new geo_point_1.GeoPoint(latitude, longitude));
	        }
	        else if (hasTag(obj, type, 'bytesValue')) {
	            assertPresent(obj.bytesValue, 'bytesValue');
	            var blob = this.fromBlob(obj.bytesValue);
	            return new fieldValue.BlobValue(blob);
	        }
	        else if (hasTag(obj, type, 'referenceValue')) {
	            assertPresent(obj.referenceValue, 'referenceValue');
	            var resourceName = this.fromResourceName(obj.referenceValue);
	            var dbId = new database_info_1.DatabaseId(resourceName.get(1), resourceName.get(3));
	            var key = new document_key_1.DocumentKey(this.extractLocalPathFromResourceName(resourceName));
	            return new fieldValue.RefValue(dbId, key);
	        }
	        else {
	            return assert_1.fail('Unknown Value proto ' + JSON.stringify(obj));
	        }
	    };
	    /** Creates an api.Document from key and fields (but no create/update time) */
	    JsonProtoSerializer.prototype.toMutationDocument = function (key, fields) {
	        return {
	            name: this.toName(key),
	            fields: this.toFields(fields)
	        };
	    };
	    JsonProtoSerializer.prototype.toDocument = function (document) {
	        assert_1.assert(!document.hasLocalMutations, "Can't serialize documents with mutations.");
	        return {
	            name: this.toName(document.key),
	            fields: this.toFields(document.data),
	            updateTime: this.toTimestamp(document.version.toTimestamp())
	        };
	    };
	    JsonProtoSerializer.prototype.fromDocument = function (document) {
	        return new document_1.Document(this.fromName(document.name), this.fromVersion(document.updateTime), this.fromFields(document.fields || {}), { hasLocalMutations: false });
	    };
	    JsonProtoSerializer.prototype.toFields = function (fields) {
	        var _this = this;
	        var result = {};
	        fields.forEach(function (key, value) {
	            result[key] = _this.toValue(value);
	        });
	        return result;
	    };
	    JsonProtoSerializer.prototype.fromFields = function (object) {
	        var _this = this;
	        // Proto map<string, Value> gets mapped to Object, so cast it.
	        var map = object;
	        var result = fieldValue.ObjectValue.EMPTY;
	        obj.forEach(map, function (key, value) {
	            result = result.set(new path_1.FieldPath([key]), _this.fromValue(value));
	        });
	        return result;
	    };
	    JsonProtoSerializer.prototype.toMapValue = function (map) {
	        return {
	            fields: this.toFields(map)
	        };
	    };
	    JsonProtoSerializer.prototype.toArrayValue = function (array) {
	        var _this = this;
	        var result = [];
	        array.forEach(function (value) {
	            result.push(_this.toValue(value));
	        });
	        return { values: result };
	    };
	    JsonProtoSerializer.prototype.fromFound = function (doc) {
	        assert_1.assert(!!doc.found, 'Tried to deserialize a found document from a missing document.');
	        assertPresent(doc.found.name, 'doc.found.name');
	        assertPresent(doc.found.updateTime, 'doc.found.updateTime');
	        var key = this.fromName(doc.found.name);
	        var version = this.fromVersion(doc.found.updateTime);
	        var fields = this.fromFields(doc.found.fields || {});
	        return new document_1.Document(key, version, fields, { hasLocalMutations: false });
	    };
	    JsonProtoSerializer.prototype.fromMissing = function (result) {
	        assert_1.assert(!!result.missing, 'Tried to deserialize a missing document from a found document.');
	        assert_1.assert(!!result.readTime, 'Tried to deserialize a missing document without a read time.');
	        var key = this.fromName(result.missing);
	        var version = this.fromVersion(result.readTime);
	        return new document_1.NoDocument(key, version);
	    };
	    JsonProtoSerializer.prototype.fromMaybeDocument = function (result) {
	        // tslint:disable-next-line:no-any
	        var type = result['result'];
	        if (hasTag(result, type, 'found')) {
	            return this.fromFound(result);
	        }
	        else if (hasTag(result, type, 'missing')) {
	            return this.fromMissing(result);
	        }
	        return assert_1.fail('invalid batch get response: ' + JSON.stringify(result));
	    };
	    JsonProtoSerializer.prototype.toWatchTargetChangeState = function (state) {
	        switch (state) {
	            case watch_change_1.WatchTargetChangeState.Added:
	                return 'ADD';
	            case watch_change_1.WatchTargetChangeState.Current:
	                return 'CURRENT';
	            case watch_change_1.WatchTargetChangeState.NoChange:
	                return 'NO_CHANGE';
	            case watch_change_1.WatchTargetChangeState.Removed:
	                return 'REMOVE';
	            case watch_change_1.WatchTargetChangeState.Reset:
	                return 'RESET';
	            default:
	                return assert_1.fail('Unknown WatchTargetChangeState: ' + state);
	        }
	    };
	    JsonProtoSerializer.prototype.toTestWatchChange = function (watchChange) {
	        if (watchChange instanceof watch_change_1.ExistenceFilterChange) {
	            return {
	                filter: {
	                    count: watchChange.existenceFilter.count,
	                    targetId: watchChange.targetId
	                }
	            };
	        }
	        if (watchChange instanceof watch_change_1.DocumentWatchChange) {
	            if (watchChange.newDoc instanceof document_1.Document) {
	                var doc = watchChange.newDoc;
	                return {
	                    documentChange: {
	                        document: {
	                            name: this.toName(doc.key),
	                            fields: this.toFields(doc.data),
	                            updateTime: this.toVersion(doc.version)
	                        },
	                        targetIds: watchChange.updatedTargetIds,
	                        removedTargetIds: watchChange.removedTargetIds
	                    }
	                };
	            }
	            else if (watchChange.newDoc instanceof document_1.NoDocument) {
	                var doc = watchChange.newDoc;
	                return {
	                    documentDelete: {
	                        document: this.toName(doc.key),
	                        readTime: this.toVersion(doc.version),
	                        removedTargetIds: watchChange.removedTargetIds
	                    }
	                };
	            }
	            else if (watchChange.newDoc === null) {
	                return {
	                    documentRemove: {
	                        document: this.toName(watchChange.key),
	                        removedTargetIds: watchChange.removedTargetIds
	                    }
	                };
	            }
	        }
	        if (watchChange instanceof watch_change_1.WatchTargetChange) {
	            var cause = undefined;
	            if (watchChange.cause) {
	                cause = {
	                    code: rpc_error_1.mapRpcCodeFromCode(watchChange.cause.code),
	                    message: watchChange.cause.message
	                };
	            }
	            return {
	                targetChange: {
	                    targetChangeType: this.toWatchTargetChangeState(watchChange.state),
	                    targetIds: watchChange.targetIds,
	                    resumeToken: this.unsafeCastProtoByteString(watchChange.resumeToken),
	                    cause: cause
	                }
	            };
	        }
	        return assert_1.fail('Unrecognized watch change: ' + JSON.stringify(watchChange));
	    };
	    JsonProtoSerializer.prototype.fromWatchChange = function (change) {
	        // tslint:disable-next-line:no-any
	        var type = change['response_type'];
	        var watchChange;
	        if (hasTag(change, type, 'targetChange')) {
	            assertPresent(change.targetChange, 'targetChange');
	            // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
	            // if unset
	            var state = this.fromWatchTargetChangeState(change.targetChange.targetChangeType || 'NO_CHANGE');
	            var targetIds = change.targetChange.targetIds || [];
	            var resumeToken = change.targetChange.resumeToken || this.emptyByteString();
	            var causeProto = change.targetChange.cause;
	            var cause = causeProto && this.fromRpcStatus(causeProto);
	            watchChange = new watch_change_1.WatchTargetChange(state, targetIds, resumeToken, cause || null);
	        }
	        else if (hasTag(change, type, 'documentChange')) {
	            assertPresent(change.documentChange, 'documentChange');
	            assertPresent(change.documentChange.document, 'documentChange.name');
	            assertPresent(change.documentChange.document.name, 'documentChange.document.name');
	            assertPresent(change.documentChange.document.updateTime, 'documentChange.document.updateTime');
	            var entityChange = change.documentChange;
	            var key = this.fromName(entityChange.document.name);
	            var version = this.fromVersion(entityChange.document.updateTime);
	            var fields = this.fromFields(entityChange.document.fields || {});
	            var doc = new document_1.Document(key, version, fields, {
	                hasLocalMutations: false
	            });
	            var updatedTargetIds = entityChange.targetIds || [];
	            var removedTargetIds = entityChange.removedTargetIds || [];
	            watchChange = new watch_change_1.DocumentWatchChange(updatedTargetIds, removedTargetIds, doc.key, doc);
	        }
	        else if (hasTag(change, type, 'documentDelete')) {
	            assertPresent(change.documentDelete, 'documentDelete');
	            assertPresent(change.documentDelete.document, 'documentDelete.document');
	            var docDelete = change.documentDelete;
	            var key = this.fromName(docDelete.document);
	            var version = docDelete.readTime
	                ? this.fromVersion(docDelete.readTime)
	                : snapshot_version_1.SnapshotVersion.forDeletedDoc();
	            var doc = new document_1.NoDocument(key, version);
	            var removedTargetIds = docDelete.removedTargetIds || [];
	            watchChange = new watch_change_1.DocumentWatchChange([], removedTargetIds, doc.key, doc);
	        }
	        else if (hasTag(change, type, 'documentRemove')) {
	            assertPresent(change.documentRemove, 'documentRemove');
	            assertPresent(change.documentRemove.document, 'documentRemove');
	            var docRemove = change.documentRemove;
	            var key = this.fromName(docRemove.document);
	            var removedTargetIds = docRemove.removedTargetIds || [];
	            watchChange = new watch_change_1.DocumentWatchChange([], removedTargetIds, key, null);
	        }
	        else if (hasTag(change, type, 'filter')) {
	            // TODO(dimond): implement existence filter parsing with strategy.
	            assertPresent(change.filter, 'filter');
	            assertPresent(change.filter.targetId, 'filter.targetId');
	            var filter = change.filter;
	            var count = filter.count || 0;
	            var existenceFilter = new existence_filter_1.ExistenceFilter(count);
	            var targetId = filter.targetId;
	            watchChange = new watch_change_1.ExistenceFilterChange(targetId, existenceFilter);
	        }
	        else {
	            return assert_1.fail('Unknown change type ' + JSON.stringify(change));
	        }
	        return watchChange;
	    };
	    JsonProtoSerializer.prototype.fromWatchTargetChangeState = function (state) {
	        if (state === 'NO_CHANGE') {
	            return watch_change_1.WatchTargetChangeState.NoChange;
	        }
	        else if (state === 'ADD') {
	            return watch_change_1.WatchTargetChangeState.Added;
	        }
	        else if (state === 'REMOVE') {
	            return watch_change_1.WatchTargetChangeState.Removed;
	        }
	        else if (state === 'CURRENT') {
	            return watch_change_1.WatchTargetChangeState.Current;
	        }
	        else if (state === 'RESET') {
	            return watch_change_1.WatchTargetChangeState.Reset;
	        }
	        else {
	            return assert_1.fail('Got unexpected TargetChange.state: ' + state);
	        }
	    };
	    JsonProtoSerializer.prototype.versionFromListenResponse = function (change) {
	        // We have only reached a consistent snapshot for the entire stream if there
	        // is a read_time set and it applies to all targets (i.e. the list of
	        // targets is empty). The backend is guaranteed to send such responses.
	        // tslint:disable-next-line:no-any
	        var type = change['response_type'];
	        if (!hasTag(change, type, 'targetChange')) {
	            return snapshot_version_1.SnapshotVersion.MIN;
	        }
	        var targetChange = change.targetChange;
	        if (targetChange.targetIds && targetChange.targetIds.length) {
	            return snapshot_version_1.SnapshotVersion.MIN;
	        }
	        if (!targetChange.readTime) {
	            return snapshot_version_1.SnapshotVersion.MIN;
	        }
	        return this.fromVersion(targetChange.readTime);
	    };
	    JsonProtoSerializer.prototype.toMutation = function (mutation) {
	        var _this = this;
	        var result;
	        if (mutation instanceof mutation_1.SetMutation) {
	            result = {
	                update: this.toMutationDocument(mutation.key, mutation.value)
	            };
	        }
	        else if (mutation instanceof mutation_1.DeleteMutation) {
	            result = { delete: this.toName(mutation.key) };
	        }
	        else if (mutation instanceof mutation_1.PatchMutation) {
	            result = {
	                update: this.toMutationDocument(mutation.key, mutation.data),
	                updateMask: this.toDocumentMask(mutation.fieldMask)
	            };
	        }
	        else if (mutation instanceof mutation_1.TransformMutation) {
	            result = {
	                transform: {
	                    document: this.toName(mutation.key),
	                    fieldTransforms: mutation.fieldTransforms.map(function (transform) {
	                        return _this.toFieldTransform(transform);
	                    })
	                }
	            };
	        }
	        else {
	            return assert_1.fail('Unknown mutation type ' + mutation.type);
	        }
	        if (!mutation.precondition.isNone) {
	            result.currentDocument = this.toPrecondition(mutation.precondition);
	        }
	        return result;
	    };
	    JsonProtoSerializer.prototype.fromMutation = function (proto) {
	        var _this = this;
	        var precondition = proto.currentDocument
	            ? this.fromPrecondition(proto.currentDocument)
	            : mutation_1.Precondition.NONE;
	        if (proto.update) {
	            assertPresent(proto.update.name, 'name');
	            var key = this.fromName(proto.update.name);
	            var value = this.fromFields(proto.update.fields || {});
	            if (proto.updateMask) {
	                var fieldMask = this.fromDocumentMask(proto.updateMask);
	                return new mutation_1.PatchMutation(key, value, fieldMask, precondition);
	            }
	            else {
	                return new mutation_1.SetMutation(key, value, precondition);
	            }
	        }
	        else if (proto.delete) {
	            var key = this.fromName(proto.delete);
	            return new mutation_1.DeleteMutation(key, precondition);
	        }
	        else if (proto.transform) {
	            var key = this.fromName(proto.transform.document);
	            var fieldTransforms = proto.transform.fieldTransforms.map(function (transform) {
	                return _this.fromFieldTransform(transform);
	            });
	            assert_1.assert(precondition.exists === true, 'Transforms only support precondition "exists == true"');
	            return new mutation_1.TransformMutation(key, fieldTransforms);
	        }
	        else {
	            return assert_1.fail('unknown mutation proto: ' + JSON.stringify(proto));
	        }
	    };
	    JsonProtoSerializer.prototype.toPrecondition = function (precondition) {
	        assert_1.assert(!precondition.isNone, "Can't serialize an empty precondition");
	        if (precondition.updateTime !== undefined) {
	            return {
	                updateTime: this.toVersion(precondition.updateTime)
	            };
	        }
	        else if (precondition.exists !== undefined) {
	            return { exists: precondition.exists };
	        }
	        else {
	            return assert_1.fail('Unknown precondition');
	        }
	    };
	    JsonProtoSerializer.prototype.fromPrecondition = function (precondition) {
	        if (precondition.updateTime !== undefined) {
	            return mutation_1.Precondition.updateTime(this.fromVersion(precondition.updateTime));
	        }
	        else if (precondition.exists !== undefined) {
	            return mutation_1.Precondition.exists(precondition.exists);
	        }
	        else {
	            return mutation_1.Precondition.NONE;
	        }
	    };
	    JsonProtoSerializer.prototype.fromWriteResult = function (proto) {
	        var _this = this;
	        // NOTE: Deletes don't have an updateTime.
	        var version = proto.updateTime
	            ? this.fromVersion(proto.updateTime)
	            : null;
	        var transformResults = null;
	        if (proto.transformResults && proto.transformResults.length > 0) {
	            transformResults = proto.transformResults.map(function (result) {
	                return _this.fromValue(result);
	            });
	        }
	        return new mutation_1.MutationResult(version, transformResults);
	    };
	    JsonProtoSerializer.prototype.fromWriteResults = function (protos) {
	        var _this = this;
	        return (protos || []).map(function (proto) { return _this.fromWriteResult(proto); });
	    };
	    JsonProtoSerializer.prototype.toFieldTransform = function (fieldTransform) {
	        assert_1.assert(fieldTransform.transform instanceof mutation_1.ServerTimestampTransform, 'Unknown transform: ' + fieldTransform.transform);
	        return {
	            fieldPath: fieldTransform.field.canonicalString(),
	            setToServerValue: 'REQUEST_TIME'
	        };
	    };
	    JsonProtoSerializer.prototype.fromFieldTransform = function (proto) {
	        assert_1.assert(proto.setToServerValue === 'REQUEST_TIME', 'Unknown transform proto: ' + JSON.stringify(proto));
	        var fieldPath = path_1.FieldPath.fromServerFormat(proto.fieldPath);
	        return new mutation_1.FieldTransform(fieldPath, mutation_1.ServerTimestampTransform.instance);
	    };
	    JsonProtoSerializer.prototype.toDocumentsTarget = function (query) {
	        return { documents: [this.toQueryPath(query.path)] };
	    };
	    JsonProtoSerializer.prototype.fromDocumentsTarget = function (documentsTarget) {
	        var count = documentsTarget.documents.length;
	        assert_1.assert(count === 1, 'DocumentsTarget contained other than 1 document: ' + count);
	        var name = documentsTarget.documents[0];
	        return query_1.Query.atPath(this.fromQueryPath(name));
	    };
	    JsonProtoSerializer.prototype.toQueryTarget = function (query) {
	        // Dissect the path into parent, collectionId, and optional key filter.
	        var result = { structuredQuery: {} };
	        if (query.path.isEmpty()) {
	            result.parent = this.toQueryPath(path_1.ResourcePath.EMPTY_PATH);
	        }
	        else {
	            var path = query.path;
	            assert_1.assert(path.length % 2 !== 0, 'Document queries with filters are not supported.');
	            result.parent = this.toQueryPath(path.popLast());
	            result.structuredQuery.from = [{ collectionId: path.lastSegment() }];
	        }
	        var where = this.toFilter(query.filters);
	        if (where) {
	            result.structuredQuery.where = where;
	        }
	        var orderBy = this.toOrder(query.orderBy);
	        if (orderBy) {
	            result.structuredQuery.orderBy = orderBy;
	        }
	        var limit = this.toInt32Value(query.limit);
	        if (limit !== undefined) {
	            result.structuredQuery.limit = limit;
	        }
	        if (query.startAt) {
	            result.structuredQuery.startAt = this.toCursor(query.startAt);
	        }
	        if (query.endAt) {
	            result.structuredQuery.endAt = this.toCursor(query.endAt);
	        }
	        return result;
	    };
	    JsonProtoSerializer.prototype.fromQueryTarget = function (target) {
	        var path = this.fromQueryPath(target.parent);
	        var query = target.structuredQuery;
	        var fromCount = query.from ? query.from.length : 0;
	        if (fromCount > 0) {
	            assert_1.assert(fromCount === 1, 'StructuredQuery.from with more than one collection is not supported.');
	            var from = query.from[0];
	            path = path.child(from.collectionId);
	        }
	        var filterBy = [];
	        if (query.where) {
	            filterBy = this.fromFilter(query.where);
	        }
	        var orderBy = [];
	        if (query.orderBy) {
	            orderBy = this.fromOrder(query.orderBy);
	        }
	        var limit = null;
	        if (query.limit) {
	            limit = this.fromInt32Value(query.limit);
	        }
	        var startAt = null;
	        if (query.startAt) {
	            startAt = this.fromCursor(query.startAt);
	        }
	        var endAt = null;
	        if (query.endAt) {
	            endAt = this.fromCursor(query.endAt);
	        }
	        return new query_1.Query(path, orderBy, filterBy, limit, startAt, endAt);
	    };
	    JsonProtoSerializer.prototype.toListenRequestLabels = function (queryData) {
	        var value = this.toLabel(queryData.purpose);
	        if (value == null) {
	            return null;
	        }
	        else {
	            return {
	                'goog-listen-tags': value
	            };
	        }
	    };
	    JsonProtoSerializer.prototype.toLabel = function (purpose) {
	        switch (purpose) {
	            case query_data_1.QueryPurpose.Listen:
	                return null;
	            case query_data_1.QueryPurpose.ExistenceFilterMismatch:
	                return 'existence-filter-mismatch';
	            case query_data_1.QueryPurpose.LimboResolution:
	                return 'limbo-document';
	            default:
	                return assert_1.fail('Unrecognized query purpose: ' + purpose);
	        }
	    };
	    JsonProtoSerializer.prototype.toTarget = function (queryData) {
	        var result;
	        var query = queryData.query;
	        if (query.isDocumentQuery()) {
	            result = { documents: this.toDocumentsTarget(query) };
	        }
	        else {
	            result = { query: this.toQueryTarget(query) };
	        }
	        result.targetId = queryData.targetId;
	        if (queryData.resumeToken.length > 0) {
	            result.resumeToken = this.unsafeCastProtoByteString(queryData.resumeToken);
	        }
	        return result;
	    };
	    JsonProtoSerializer.prototype.toFilter = function (filters) {
	        var _this = this;
	        if (filters.length === 0)
	            return;
	        var protos = filters.map(function (filter) {
	            return filter instanceof query_1.RelationFilter
	                ? _this.toRelationFilter(filter)
	                : _this.toUnaryFilter(filter);
	        });
	        if (protos.length === 1) {
	            return protos[0];
	        }
	        return { compositeFilter: { op: 'AND', filters: protos } };
	    };
	    JsonProtoSerializer.prototype.fromFilter = function (filter) {
	        var _this = this;
	        if (!filter) {
	            return [];
	        }
	        else if (filter.unaryFilter !== undefined) {
	            return [this.fromUnaryFilter(filter)];
	        }
	        else if (filter.fieldFilter !== undefined) {
	            return [this.fromRelationFilter(filter)];
	        }
	        else if (filter.compositeFilter !== undefined) {
	            return filter.compositeFilter.filters
	                .map(function (f) { return _this.fromFilter(f); })
	                .reduce(function (accum, current) { return accum.concat(current); });
	        }
	        else {
	            return assert_1.fail('Unknown filter: ' + JSON.stringify(filter));
	        }
	    };
	    JsonProtoSerializer.prototype.toOrder = function (orderBys) {
	        var _this = this;
	        if (orderBys.length === 0)
	            return;
	        return orderBys.map(function (order) { return _this.toPropertyOrder(order); });
	    };
	    JsonProtoSerializer.prototype.fromOrder = function (orderBys) {
	        var _this = this;
	        return orderBys.map(function (order) { return _this.fromPropertyOrder(order); });
	    };
	    JsonProtoSerializer.prototype.toCursor = function (cursor) {
	        var _this = this;
	        return {
	            before: cursor.before,
	            values: cursor.position.map(function (component) { return _this.toValue(component); })
	        };
	    };
	    JsonProtoSerializer.prototype.fromCursor = function (cursor) {
	        var _this = this;
	        var before = !!cursor.before;
	        var position = cursor.values.map(function (component) { return _this.fromValue(component); });
	        return new query_1.Bound(position, before);
	    };
	    // visible for testing
	    JsonProtoSerializer.prototype.toDirection = function (dir) {
	        return DIRECTIONS[dir.name];
	    };
	    // visible for testing
	    JsonProtoSerializer.prototype.fromDirection = function (dir) {
	        switch (dir) {
	            case 'ASCENDING':
	                return query_1.Direction.ASCENDING;
	            case 'DESCENDING':
	                return query_1.Direction.DESCENDING;
	            default:
	                return undefined;
	        }
	    };
	    // visible for testing
	    JsonProtoSerializer.prototype.toOperatorName = function (op) {
	        return OPERATORS[op.name];
	    };
	    JsonProtoSerializer.prototype.fromOperatorName = function (op) {
	        switch (op) {
	            case 'EQUAL':
	                return query_1.RelationOp.EQUAL;
	            case 'GREATER_THAN':
	                return query_1.RelationOp.GREATER_THAN;
	            case 'GREATER_THAN_OR_EQUAL':
	                return query_1.RelationOp.GREATER_THAN_OR_EQUAL;
	            case 'LESS_THAN':
	                return query_1.RelationOp.LESS_THAN;
	            case 'LESS_THAN_OR_EQUAL':
	                return query_1.RelationOp.LESS_THAN_OR_EQUAL;
	            case 'OPERATOR_UNSPECIFIED':
	                return assert_1.fail('Unspecified relation');
	            default:
	                return assert_1.fail('Unknown relation');
	        }
	    };
	    JsonProtoSerializer.prototype.toFieldPathReference = function (path) {
	        return { fieldPath: path.canonicalString() };
	    };
	    JsonProtoSerializer.prototype.fromFieldPathReference = function (fieldReference) {
	        return path_1.FieldPath.fromServerFormat(fieldReference.fieldPath);
	    };
	    // visible for testing
	    JsonProtoSerializer.prototype.toPropertyOrder = function (orderBy) {
	        return {
	            field: this.toFieldPathReference(orderBy.field),
	            direction: this.toDirection(orderBy.dir)
	        };
	    };
	    JsonProtoSerializer.prototype.fromPropertyOrder = function (orderBy) {
	        return new query_1.OrderBy(this.fromFieldPathReference(orderBy.field), this.fromDirection(orderBy.direction));
	    };
	    // visible for testing
	    JsonProtoSerializer.prototype.toRelationFilter = function (filter) {
	        if (filter instanceof query_1.RelationFilter) {
	            return {
	                fieldFilter: {
	                    field: this.toFieldPathReference(filter.field),
	                    op: this.toOperatorName(filter.op),
	                    value: this.toValue(filter.value)
	                }
	            };
	        }
	        else {
	            return assert_1.fail('Unrecognized filter: ' + JSON.stringify(filter));
	        }
	    };
	    JsonProtoSerializer.prototype.fromRelationFilter = function (filter) {
	        return new query_1.RelationFilter(this.fromFieldPathReference(filter.fieldFilter.field), this.fromOperatorName(filter.fieldFilter.op), this.fromValue(filter.fieldFilter.value));
	    };
	    // visible for testing
	    JsonProtoSerializer.prototype.toUnaryFilter = function (filter) {
	        if (filter instanceof query_1.NanFilter) {
	            return {
	                unaryFilter: {
	                    field: this.toFieldPathReference(filter.field),
	                    op: 'IS_NAN'
	                }
	            };
	        }
	        else if (filter instanceof query_1.NullFilter) {
	            return {
	                unaryFilter: {
	                    field: this.toFieldPathReference(filter.field),
	                    op: 'IS_NULL'
	                }
	            };
	        }
	        else {
	            return assert_1.fail('Unrecognized filter: ' + JSON.stringify(filter));
	        }
	    };
	    JsonProtoSerializer.prototype.fromUnaryFilter = function (filter) {
	        switch (filter.unaryFilter.op) {
	            case 'IS_NAN':
	                var nanField = this.fromFieldPathReference(filter.unaryFilter.field);
	                return new query_1.NanFilter(nanField);
	            case 'IS_NULL':
	                var nullField = this.fromFieldPathReference(filter.unaryFilter.field);
	                return new query_1.NullFilter(nullField);
	            case 'OPERATOR_UNSPECIFIED':
	                return assert_1.fail('Unspecified filter');
	            default:
	                return assert_1.fail('Unknown filter');
	        }
	    };
	    JsonProtoSerializer.prototype.toDocumentMask = function (fieldMask) {
	        return {
	            fieldPaths: fieldMask.fields.map(function (field) { return field.canonicalString(); })
	        };
	    };
	    JsonProtoSerializer.prototype.fromDocumentMask = function (proto) {
	        var paths = proto.fieldPaths || [];
	        var fields = paths.map(function (path) { return path_1.FieldPath.fromServerFormat(path); });
	        return new mutation_1.FieldMask(fields);
	    };
	    return JsonProtoSerializer;
	}());
	exports.JsonProtoSerializer = JsonProtoSerializer;
	/**
	 * Checks for a specific oneof tag in a protocol buffer message.
	 *
	 * This intentionally accommodates two distinct cases:
	 *
	 * 1) Messages containing a type tag: these are the format produced by GRPC in
	 * return values. These may contain default-value mappings for all tags in the
	 * oneof but the type tag specifies which one was actually set.
	 *
	 * 2) Messages that don't contain a type tag: these are the format required by
	 * GRPC as inputs. If we emitted objects with type tags, ProtoBuf.js would
	 * choke claiming that the tags aren't fields in the Message.
	 *
	 * Allowing both formats here makes the serializer able to consume the outputs
	 * it produces: for all messages it supports, fromX(toX(value)) == value.
	 *
	 * Note that case 2 suffers from ambiguity: if multiple tags are present
	 * without a type tag then the callers are structured in such a way that the
	 * first invocation will win. Since we only parse in this mode when parsing
	 * the output of a serialize method this works, but it's not a general
	 * solution.
	 *
	 * Unfortunately there is no general solution here because proto3 makes it
	 * impossible to distinguish unset from explicitly set fields: both have the
	 * default value for the type. Without the type tag but multiple value tags
	 * it's possible to have default values for each tag in the oneof and not be
	 * able to know which was actually in effect.
	 */
	function hasTag(obj, type, tag) {
	    return type === tag || (!type && tag in obj);
	}
	
	//# sourceMappingURL=serializer.js.map


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var collections_1 = __webpack_require__(20);
	var platform_1 = __webpack_require__(40);
	var assert_1 = __webpack_require__(10);
	var objUtils = __webpack_require__(36);
	var remote_event_1 = __webpack_require__(71);
	/**
	 * Represents a changed document and a list of target ids to which this change
	 * applies.
	 *
	 * If document has been deleted NoDocument will be provided.
	 */
	var DocumentWatchChange = /** @class */ (function () {
	    function DocumentWatchChange(
	        /** The new document applies to all of these targets. */
	        updatedTargetIds, 
	        /** The new document is removed from all of these targets. */
	        removedTargetIds, 
	        /** The key of the document for this change. */
	        key, 
	        /**
	         * The new document or NoDocument if it was deleted. Is null if the
	         * document went out of view without the server sending a new document.
	         */
	        newDoc) {
	        this.updatedTargetIds = updatedTargetIds;
	        this.removedTargetIds = removedTargetIds;
	        this.key = key;
	        this.newDoc = newDoc;
	    }
	    return DocumentWatchChange;
	}());
	exports.DocumentWatchChange = DocumentWatchChange;
	var ExistenceFilterChange = /** @class */ (function () {
	    function ExistenceFilterChange(targetId, existenceFilter) {
	        this.targetId = targetId;
	        this.existenceFilter = existenceFilter;
	    }
	    return ExistenceFilterChange;
	}());
	exports.ExistenceFilterChange = ExistenceFilterChange;
	var WatchTargetChangeState;
	(function (WatchTargetChangeState) {
	    WatchTargetChangeState[WatchTargetChangeState["NoChange"] = 0] = "NoChange";
	    WatchTargetChangeState[WatchTargetChangeState["Added"] = 1] = "Added";
	    WatchTargetChangeState[WatchTargetChangeState["Removed"] = 2] = "Removed";
	    WatchTargetChangeState[WatchTargetChangeState["Current"] = 3] = "Current";
	    WatchTargetChangeState[WatchTargetChangeState["Reset"] = 4] = "Reset";
	})(WatchTargetChangeState = exports.WatchTargetChangeState || (exports.WatchTargetChangeState = {}));
	var WatchTargetChange = /** @class */ (function () {
	    function WatchTargetChange(
	        /** What kind of change occurred to the watch target. */
	        state, 
	        /** The target IDs that were added/removed/set. */
	        targetIds, 
	        /**
	         * An opaque, server-assigned token that allows watching a query to be
	         * resumed after disconnecting without retransmitting all the data that
	         * matches the query. The resume token essentially identifies a point in
	         * time from which the server should resume sending results.
	         */
	        resumeToken, 
	        /** An RPC error indicating why the watch failed. */
	        cause) {
	        if (resumeToken === void 0) { resumeToken = platform_1.emptyByteString(); }
	        if (cause === void 0) { cause = null; }
	        this.state = state;
	        this.targetIds = targetIds;
	        this.resumeToken = resumeToken;
	        this.cause = cause;
	    }
	    return WatchTargetChange;
	}());
	exports.WatchTargetChange = WatchTargetChange;
	/**
	 * A helper class to accumulate watch changes into a RemoteEvent and other
	 * target information.
	 */
	var WatchChangeAggregator = /** @class */ (function () {
	    function WatchChangeAggregator(snapshotVersion, listenTargets, pendingTargetResponses) {
	        this.snapshotVersion = snapshotVersion;
	        this.listenTargets = listenTargets;
	        /** The existence filter - if any - for the given target IDs. */
	        this.existenceFilters = {};
	        /** Keeps track of the current target mappings */
	        this.targetChanges = {};
	        /** Keeps track of document to update */
	        this.documentUpdates = collections_1.maybeDocumentMap();
	        /** Whether this aggregator was frozen and can no longer be modified */
	        this.frozen = false;
	        this.pendingTargetResponses = objUtils.shallowCopy(pendingTargetResponses);
	    }
	    /** Aggregates a watch change into the current state */
	    WatchChangeAggregator.prototype.add = function (watchChange) {
	        assert_1.assert(!this.frozen, 'Trying to modify frozen WatchChangeAggregator.');
	        if (watchChange instanceof DocumentWatchChange) {
	            this.addDocumentChange(watchChange);
	        }
	        else if (watchChange instanceof WatchTargetChange) {
	            this.addTargetChange(watchChange);
	        }
	        else if (watchChange instanceof ExistenceFilterChange) {
	            this.addExistenceFilterChange(watchChange);
	        }
	        else {
	            assert_1.fail('Unknown watch change: ' + watchChange);
	        }
	    };
	    /** Aggregates all provided watch changes to the current state in order */
	    WatchChangeAggregator.prototype.addChanges = function (watchChanges) {
	        var _this = this;
	        assert_1.assert(!this.frozen, 'Trying to modify frozen WatchChangeAggregator.');
	        watchChanges.forEach(function (change) { return _this.add(change); });
	    };
	    /**
	     * Converts the current state into a remote event with the snapshot version
	     * provided via the constructor.
	     */
	    WatchChangeAggregator.prototype.createRemoteEvent = function () {
	        var _this = this;
	        var targetChanges = this.targetChanges;
	        // Remove all the non-active targets from the remote event.
	        objUtils.forEachNumber(this.targetChanges, function (targetId) {
	            if (!_this.isActiveTarget(targetId)) {
	                delete targetChanges[targetId];
	            }
	        });
	        // Mark this aggregator as frozen so no further modifications are made
	        this.frozen = true;
	        return new remote_event_1.RemoteEvent(this.snapshotVersion, targetChanges, this.documentUpdates);
	    };
	    WatchChangeAggregator.prototype.ensureTargetChange = function (targetId) {
	        var change = this.targetChanges[targetId];
	        if (!change) {
	            // Create an UpdateMapping by default, since resets are always explicit.
	            change = {
	                currentStatusUpdate: remote_event_1.CurrentStatusUpdate.None,
	                snapshotVersion: this.snapshotVersion,
	                mapping: new remote_event_1.UpdateMapping(),
	                resumeToken: platform_1.emptyByteString()
	            };
	            this.targetChanges[targetId] = change;
	        }
	        return change;
	    };
	    /**
	     * We need to wait for watch to ack targets before we process those events,
	     * so to know if a target is active, there must be no pending acks we're
	     * waiting for and it must be in the current list of targets that the client
	     * cares about.
	     *
	     * This method is visible for testing.
	     */
	    WatchChangeAggregator.prototype.isActiveTarget = function (targetId) {
	        return (!objUtils.contains(this.pendingTargetResponses, targetId) &&
	            objUtils.contains(this.listenTargets, targetId));
	    };
	    WatchChangeAggregator.prototype.addDocumentChange = function (docChange) {
	        var relevant = false;
	        for (var _i = 0, _a = docChange.updatedTargetIds; _i < _a.length; _i++) {
	            var targetId = _a[_i];
	            if (this.isActiveTarget(targetId)) {
	                var change = this.ensureTargetChange(targetId);
	                change.mapping.add(docChange.key);
	                relevant = true;
	            }
	        }
	        for (var _b = 0, _c = docChange.removedTargetIds; _b < _c.length; _b++) {
	            var targetId = _c[_b];
	            if (this.isActiveTarget(targetId)) {
	                var change = this.ensureTargetChange(targetId);
	                change.mapping.delete(docChange.key);
	                relevant = true;
	            }
	        }
	        // Only update the document if there is a new document to replace to an
	        // active target that is being listened to, this might be just a target
	        // update instead.
	        if (docChange.newDoc && relevant) {
	            this.documentUpdates = this.documentUpdates.insert(docChange.key, docChange.newDoc);
	        }
	    };
	    WatchChangeAggregator.prototype.addTargetChange = function (targetChange) {
	        var _this = this;
	        targetChange.targetIds.forEach(function (targetId) {
	            var change = _this.ensureTargetChange(targetId);
	            switch (targetChange.state) {
	                case WatchTargetChangeState.NoChange:
	                    if (_this.isActiveTarget(targetId)) {
	                        // Creating the change above satisfies the semantics of no-change.
	                        applyResumeToken(change, targetChange.resumeToken);
	                    }
	                    break;
	                case WatchTargetChangeState.Added:
	                    // We need to decrement the number of pending acks needed from watch
	                    // for this targetId.
	                    _this.recordTargetResponse(targetId);
	                    if (!objUtils.contains(_this.pendingTargetResponses, targetId)) {
	                        // We have a freshly added target, so we need to reset any state
	                        // that we had previously This can happen e.g. when remove and add
	                        // back a target for existence filter mismatches.
	                        change.mapping = new remote_event_1.UpdateMapping();
	                        change.currentStatusUpdate = remote_event_1.CurrentStatusUpdate.None;
	                        delete _this.existenceFilters[targetId];
	                    }
	                    applyResumeToken(change, targetChange.resumeToken);
	                    break;
	                case WatchTargetChangeState.Removed:
	                    // We need to keep track of removed targets to we can
	                    // post-filter and remove any target changes.
	                    // We need to decrement the number of pending acks needed from watch
	                    // for this targetId.
	                    _this.recordTargetResponse(targetId);
	                    assert_1.assert(!targetChange.cause, 'WatchChangeAggregator does not handle errored targets');
	                    break;
	                case WatchTargetChangeState.Current:
	                    if (_this.isActiveTarget(targetId)) {
	                        change.currentStatusUpdate = remote_event_1.CurrentStatusUpdate.MarkCurrent;
	                        applyResumeToken(change, targetChange.resumeToken);
	                    }
	                    break;
	                case WatchTargetChangeState.Reset:
	                    if (_this.isActiveTarget(targetId)) {
	                        // Overwrite any existing target mapping with a reset
	                        // mapping. Every subsequent update will modify the reset
	                        // mapping, not an update mapping.
	                        change.mapping = new remote_event_1.ResetMapping();
	                        applyResumeToken(change, targetChange.resumeToken);
	                    }
	                    break;
	                default:
	                    assert_1.fail('Unknown target watch change state: ' + targetChange.state);
	            }
	        });
	    };
	    /**
	     * Record that we get a watch target add/remove by decrementing the number of
	     * pending target responses that we have.
	     */
	    WatchChangeAggregator.prototype.recordTargetResponse = function (targetId) {
	        var newCount = (this.pendingTargetResponses[targetId] || 0) - 1;
	        if (newCount === 0) {
	            delete this.pendingTargetResponses[targetId];
	        }
	        else {
	            this.pendingTargetResponses[targetId] = newCount;
	        }
	    };
	    WatchChangeAggregator.prototype.addExistenceFilterChange = function (change) {
	        if (this.isActiveTarget(change.targetId)) {
	            this.existenceFilters[change.targetId] = change.existenceFilter;
	        }
	    };
	    return WatchChangeAggregator;
	}());
	exports.WatchChangeAggregator = WatchChangeAggregator;
	/**
	 * Applies the resume token to the TargetChange, but only when it has a new
	 * value. null and empty resumeTokens are discarded.
	 */
	function applyResumeToken(change, resumeToken) {
	    if (resumeToken.length > 0) {
	        change.resumeToken = resumeToken;
	    }
	}
	
	//# sourceMappingURL=watch_change.js.map


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var errors_1 = __webpack_require__(98);
	var token_manager_1 = __webpack_require__(495);
	var notification_permission_1 = __webpack_require__(199);
	var SENDER_ID_OPTION_NAME = 'messagingSenderId';
	var ControllerInterface = /** @class */ (function () {
	    /**
	     * An interface of the Messaging Service API
	     * @param {!firebase.app.App} app
	     */
	    function ControllerInterface(app) {
	        var _this = this;
	        this.errorFactory_ = new util_1.ErrorFactory('messaging', 'Messaging', errors_1.default.map);
	        if (!app.options[SENDER_ID_OPTION_NAME] ||
	            typeof app.options[SENDER_ID_OPTION_NAME] !== 'string') {
	            throw this.errorFactory_.create(errors_1.default.codes.BAD_SENDER_ID);
	        }
	        this.messagingSenderId_ = app.options[SENDER_ID_OPTION_NAME];
	        this.tokenManager_ = new token_manager_1.default();
	        this.app = app;
	        this.INTERNAL = {};
	        this.INTERNAL.delete = function () { return _this.delete; };
	    }
	    /**
	     * @export
	     * @return {Promise<string> | Promise<null>} Returns a promise that
	     * resolves to an FCM token.
	     */
	    ControllerInterface.prototype.getToken = function () {
	        var _this = this;
	        // Check with permissions
	        var currentPermission = this.getNotificationPermission_();
	        if (currentPermission !== notification_permission_1.default.granted) {
	            if (currentPermission === notification_permission_1.default.denied) {
	                return Promise.reject(this.errorFactory_.create(errors_1.default.codes.NOTIFICATIONS_BLOCKED));
	            }
	            // We must wait for permission to be granted
	            return Promise.resolve(null);
	        }
	        return this.getSWRegistration_().then(function (registration) {
	            return _this.tokenManager_
	                .getSavedToken(_this.messagingSenderId_, registration)
	                .then(function (token) {
	                if (token) {
	                    return token;
	                }
	                return _this.tokenManager_.createToken(_this.messagingSenderId_, registration);
	            });
	        });
	    };
	    /**
	     * This method deletes tokens that the token manager looks after and then
	     * unregisters the push subscription if it exists.
	     * @export
	     * @param {string} token
	     * @return {Promise<void>}
	     */
	    ControllerInterface.prototype.deleteToken = function (token) {
	        var _this = this;
	        return this.tokenManager_.deleteToken(token).then(function () {
	            return _this.getSWRegistration_()
	                .then(function (registration) {
	                if (registration) {
	                    return registration.pushManager.getSubscription();
	                }
	            })
	                .then(function (subscription) {
	                if (subscription) {
	                    return subscription.unsubscribe();
	                }
	            });
	        });
	    };
	    ControllerInterface.prototype.getSWRegistration_ = function () {
	        throw this.errorFactory_.create(errors_1.default.codes.SHOULD_BE_INHERITED);
	    };
	    //
	    // The following methods should only be available in the window.
	    //
	    ControllerInterface.prototype.requestPermission = function () {
	        throw this.errorFactory_.create(errors_1.default.codes.AVAILABLE_IN_WINDOW);
	    };
	    /**
	     * @export
	     * @param {!ServiceWorkerRegistration} registration
	     */
	    ControllerInterface.prototype.useServiceWorker = function (registration) {
	        throw this.errorFactory_.create(errors_1.default.codes.AVAILABLE_IN_WINDOW);
	    };
	    /**
	     * @export
	     * @param {!firebase.Observer|function(*)} nextOrObserver
	     * @param {function(!Error)=} optError
	     * @param {function()=} optCompleted
	     * @return {!function()}
	     */
	    ControllerInterface.prototype.onMessage = function (nextOrObserver, optError, optCompleted) {
	        throw this.errorFactory_.create(errors_1.default.codes.AVAILABLE_IN_WINDOW);
	    };
	    /**
	     * @export
	     * @param {!firebase.Observer|function()} nextOrObserver An observer object
	     * or a function triggered on token refresh.
	     * @param {function(!Error)=} optError Optional A function
	     * triggered on token refresh error.
	     * @param {function()=} optCompleted Optional function triggered when the
	     * observer is removed.
	     * @return {!function()} The unsubscribe function for the observer.
	     */
	    ControllerInterface.prototype.onTokenRefresh = function (nextOrObserver, optError, optCompleted) {
	        throw this.errorFactory_.create(errors_1.default.codes.AVAILABLE_IN_WINDOW);
	    };
	    //
	    // The following methods are used by the service worker only.
	    //
	    /**
	     * @export
	     * @param {function(Object)} callback
	     */
	    ControllerInterface.prototype.setBackgroundMessageHandler = function (callback) {
	        throw this.errorFactory_.create(errors_1.default.codes.AVAILABLE_IN_SW);
	    };
	    //
	    // The following methods are used by the service themselves and not exposed
	    // publicly or not expected to be used by developers.
	    //
	    /**
	     * This method is required to adhere to the Firebase interface.
	     * It closes any currently open indexdb database connections.
	     */
	    ControllerInterface.prototype.delete = function () {
	        return this.tokenManager_.closeDatabase();
	    };
	    /**
	     * Returns the current Notification Permission state.
	     * @private
	     * @return {string} The currenct permission state.
	     */
	    ControllerInterface.prototype.getNotificationPermission_ = function () {
	        return Notification.permission;
	    };
	    /**
	     * @protected
	     * @returns {TokenManager}
	     */
	    ControllerInterface.prototype.getTokenManager = function () {
	        return this.tokenManager_;
	    };
	    return ControllerInterface;
	}());
	exports.default = ControllerInterface;
	
	//# sourceMappingURL=controller-interface.js.map


/***/ },
/* 198 */
/***/ function(module, exports) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	var FCM_APPLICATION_SERVER_KEY = [
	    0x04,
	    0x33,
	    0x94,
	    0xf7,
	    0xdf,
	    0xa1,
	    0xeb,
	    0xb1,
	    0xdc,
	    0x03,
	    0xa2,
	    0x5e,
	    0x15,
	    0x71,
	    0xdb,
	    0x48,
	    0xd3,
	    0x2e,
	    0xed,
	    0xed,
	    0xb2,
	    0x34,
	    0xdb,
	    0xb7,
	    0x47,
	    0x3a,
	    0x0c,
	    0x8f,
	    0xc4,
	    0xcc,
	    0xe1,
	    0x6f,
	    0x3c,
	    0x8c,
	    0x84,
	    0xdf,
	    0xab,
	    0xb6,
	    0x66,
	    0x3e,
	    0xf2,
	    0x0c,
	    0xd4,
	    0x8b,
	    0xfe,
	    0xe3,
	    0xf9,
	    0x76,
	    0x2f,
	    0x14,
	    0x1c,
	    0x63,
	    0x08,
	    0x6a,
	    0x6f,
	    0x2d,
	    0xb1,
	    0x1a,
	    0x95,
	    0xb0,
	    0xce,
	    0x37,
	    0xc0,
	    0x9c,
	    0x6e
	];
	var SUBSCRIPTION_DETAILS = {
	    userVisibleOnly: true,
	    applicationServerKey: new Uint8Array(FCM_APPLICATION_SERVER_KEY)
	};
	exports.default = {
	    ENDPOINT: 'https://fcm.googleapis.com',
	    APPLICATION_SERVER_KEY: FCM_APPLICATION_SERVER_KEY,
	    SUBSCRIPTION_OPTIONS: SUBSCRIPTION_DETAILS
	};
	
	//# sourceMappingURL=fcm-details.js.map


/***/ },
/* 199 */
/***/ function(module, exports) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    granted: 'granted',
	    default: 'default',
	    denied: 'denied'
	};
	
	//# sourceMappingURL=notification-permission.js.map


/***/ },
/* 200 */
/***/ function(module, exports) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	// These fields are strings to prevent closure from thinking goog.getMsg
	// should be used to initialise the values
	var PARAMS = {
	    TYPE_OF_MSG: 'firebase-messaging-msg-type',
	    DATA: 'firebase-messaging-msg-data'
	};
	// This value isn't using the TYPE_OF_MSG short hand as closure
	// expects the variable to be defined via goog.getMsg
	var msgType = {
	    PUSH_MSG_RECEIVED: 'push-msg-received',
	    NOTIFICATION_CLICKED: 'notification-clicked'
	};
	var createNewMsg = function (msgType, msgData) {
	    var message = (_a = {},
	        _a[PARAMS.TYPE_OF_MSG] = msgType,
	        _a[PARAMS.DATA] = msgData,
	        _a);
	    return message;
	    var _a;
	};
	exports.default = {
	    PARAMS: PARAMS,
	    TYPES_OF_MSG: msgType,
	    createNewMsg: createNewMsg
	};
	
	//# sourceMappingURL=worker-page-message.js.map


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @file Provides a Blob-like wrapper for various binary types (including the
	 * native Blob type). This makes it possible to upload types like ArrayBuffers,
	 * making uploads possible in environments without the native Blob type.
	 */
	var fs = __webpack_require__(505);
	var string = __webpack_require__(74);
	var string_1 = __webpack_require__(74);
	var type = __webpack_require__(33);
	/**
	 * @param opt_elideCopy If true, doesn't copy mutable input data
	 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
	 *     modified after this blob's construction.
	 */
	var FbsBlob = /** @class */ (function () {
	    function FbsBlob(data, opt_elideCopy) {
	        var size = 0;
	        var blobType = '';
	        if (type.isNativeBlob(data)) {
	            this.data_ = data;
	            size = data.size;
	            blobType = data.type;
	        }
	        else if (data instanceof ArrayBuffer) {
	            if (opt_elideCopy) {
	                this.data_ = new Uint8Array(data);
	            }
	            else {
	                this.data_ = new Uint8Array(data.byteLength);
	                this.data_.set(new Uint8Array(data));
	            }
	            size = this.data_.length;
	        }
	        else if (data instanceof Uint8Array) {
	            if (opt_elideCopy) {
	                this.data_ = data;
	            }
	            else {
	                this.data_ = new Uint8Array(data.length);
	                this.data_.set(data);
	            }
	            size = data.length;
	        }
	        this.size_ = size;
	        this.type_ = blobType;
	    }
	    FbsBlob.prototype.size = function () {
	        return this.size_;
	    };
	    FbsBlob.prototype.type = function () {
	        return this.type_;
	    };
	    FbsBlob.prototype.slice = function (startByte, endByte) {
	        if (type.isNativeBlob(this.data_)) {
	            var realBlob = this.data_;
	            var sliced = fs.sliceBlob(realBlob, startByte, endByte);
	            if (sliced === null) {
	                return null;
	            }
	            return new FbsBlob(sliced);
	        }
	        else {
	            var slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
	            return new FbsBlob(slice, true);
	        }
	    };
	    FbsBlob.getBlob = function () {
	        var var_args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            var_args[_i] = arguments[_i];
	        }
	        if (type.isNativeBlobDefined()) {
	            var blobby = var_args.map(function (val) {
	                if (val instanceof FbsBlob) {
	                    return val.data_;
	                }
	                else {
	                    return val;
	                }
	            });
	            return new FbsBlob(fs.getBlob.apply(null, blobby));
	        }
	        else {
	            var uint8Arrays = var_args.map(function (val) {
	                if (type.isString(val)) {
	                    return string.dataFromString(string_1.StringFormat.RAW, val).data;
	                }
	                else {
	                    // Blobs don't exist, so this has to be a Uint8Array.
	                    return val.data_;
	                }
	            });
	            var finalLength_1 = 0;
	            uint8Arrays.forEach(function (array) {
	                finalLength_1 += array.byteLength;
	            });
	            var merged_1 = new Uint8Array(finalLength_1);
	            var index_1 = 0;
	            uint8Arrays.forEach(function (array) {
	                for (var i = 0; i < array.length; i++) {
	                    merged_1[index_1++] = array[i];
	                }
	            });
	            return new FbsBlob(merged_1, true);
	        }
	    };
	    FbsBlob.prototype.uploadData = function () {
	        return this.data_;
	    };
	    return FbsBlob;
	}());
	exports.FbsBlob = FbsBlob;
	
	//# sourceMappingURL=blob.js.map


/***/ },
/* 202 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @fileoverview Contains helper methods for manipulating paths.
	 */
	/**
	 * @return Null if the path is already at the root.
	 */
	function parent(path) {
	    if (path.length == 0) {
	        return null;
	    }
	    var index = path.lastIndexOf('/');
	    if (index === -1) {
	        return '';
	    }
	    var newPath = path.slice(0, index);
	    return newPath;
	}
	exports.parent = parent;
	function child(path, childPath) {
	    var canonicalChildPath = childPath
	        .split('/')
	        .filter(function (component) {
	        return component.length > 0;
	    })
	        .join('/');
	    if (path.length === 0) {
	        return canonicalChildPath;
	    }
	    else {
	        return path + '/' + canonicalChildPath;
	    }
	}
	exports.child = child;
	/**
	 * Returns the last component of a path.
	 * '/foo/bar' -> 'bar'
	 * '/foo/bar/baz/' -> 'baz/'
	 * '/a' -> 'a'
	 */
	function lastComponent(path) {
	    var index = path.lastIndexOf('/', path.length - 2);
	    if (index === -1) {
	        return path;
	    }
	    else {
	        return path.slice(index + 1);
	    }
	}
	exports.lastComponent = lastComponent;
	
	//# sourceMappingURL=path.js.map


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var array = __webpack_require__(132);
	var blob_1 = __webpack_require__(201);
	var errorsExports = __webpack_require__(41);
	var MetadataUtils = __webpack_require__(133);
	var object = __webpack_require__(58);
	var requestinfo_1 = __webpack_require__(509);
	var type = __webpack_require__(33);
	var UrlUtils = __webpack_require__(134);
	/**
	 * Throws the UNKNOWN FirebaseStorageError if cndn is false.
	 */
	function handlerCheck(cndn) {
	    if (!cndn) {
	        throw errorsExports.unknown();
	    }
	}
	exports.handlerCheck = handlerCheck;
	function metadataHandler(authWrapper, mappings) {
	    function handler(xhr, text) {
	        var metadata = MetadataUtils.fromResourceString(authWrapper, text, mappings);
	        handlerCheck(metadata !== null);
	        return metadata;
	    }
	    return handler;
	}
	exports.metadataHandler = metadataHandler;
	function sharedErrorHandler(location) {
	    function errorHandler(xhr, err) {
	        var newErr;
	        if (xhr.getStatus() === 401) {
	            newErr = errorsExports.unauthenticated();
	        }
	        else {
	            if (xhr.getStatus() === 402) {
	                newErr = errorsExports.quotaExceeded(location.bucket);
	            }
	            else {
	                if (xhr.getStatus() === 403) {
	                    newErr = errorsExports.unauthorized(location.path);
	                }
	                else {
	                    newErr = err;
	                }
	            }
	        }
	        newErr.setServerResponseProp(err.serverResponseProp());
	        return newErr;
	    }
	    return errorHandler;
	}
	exports.sharedErrorHandler = sharedErrorHandler;
	function objectErrorHandler(location) {
	    var shared = sharedErrorHandler(location);
	    function errorHandler(xhr, err) {
	        var newErr = shared(xhr, err);
	        if (xhr.getStatus() === 404) {
	            newErr = errorsExports.objectNotFound(location.path);
	        }
	        newErr.setServerResponseProp(err.serverResponseProp());
	        return newErr;
	    }
	    return errorHandler;
	}
	exports.objectErrorHandler = objectErrorHandler;
	function getMetadata(authWrapper, location, mappings) {
	    var urlPart = location.fullServerUrl();
	    var url = UrlUtils.makeNormalUrl(urlPart);
	    var method = 'GET';
	    var timeout = authWrapper.maxOperationRetryTime();
	    var requestInfo = new requestinfo_1.RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
	    requestInfo.errorHandler = objectErrorHandler(location);
	    return requestInfo;
	}
	exports.getMetadata = getMetadata;
	function updateMetadata(authWrapper, location, metadata, mappings) {
	    var urlPart = location.fullServerUrl();
	    var url = UrlUtils.makeNormalUrl(urlPart);
	    var method = 'PATCH';
	    var body = MetadataUtils.toResourceString(metadata, mappings);
	    var headers = { 'Content-Type': 'application/json; charset=utf-8' };
	    var timeout = authWrapper.maxOperationRetryTime();
	    var requestInfo = new requestinfo_1.RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
	    requestInfo.headers = headers;
	    requestInfo.body = body;
	    requestInfo.errorHandler = objectErrorHandler(location);
	    return requestInfo;
	}
	exports.updateMetadata = updateMetadata;
	function deleteObject(authWrapper, location) {
	    var urlPart = location.fullServerUrl();
	    var url = UrlUtils.makeNormalUrl(urlPart);
	    var method = 'DELETE';
	    var timeout = authWrapper.maxOperationRetryTime();
	    function handler(xhr, text) { }
	    var requestInfo = new requestinfo_1.RequestInfo(url, method, handler, timeout);
	    requestInfo.successCodes = [200, 204];
	    requestInfo.errorHandler = objectErrorHandler(location);
	    return requestInfo;
	}
	exports.deleteObject = deleteObject;
	function determineContentType_(metadata, blob) {
	    return ((metadata && metadata['contentType']) ||
	        (blob && blob.type()) ||
	        'application/octet-stream');
	}
	exports.determineContentType_ = determineContentType_;
	function metadataForUpload_(location, blob, opt_metadata) {
	    var metadata = object.clone(opt_metadata);
	    metadata['fullPath'] = location.path;
	    metadata['size'] = blob.size();
	    if (!metadata['contentType']) {
	        metadata['contentType'] = determineContentType_(null, blob);
	    }
	    return metadata;
	}
	exports.metadataForUpload_ = metadataForUpload_;
	function multipartUpload(authWrapper, location, mappings, blob, opt_metadata) {
	    var urlPart = location.bucketOnlyServerUrl();
	    var headers = {
	        'X-Goog-Upload-Protocol': 'multipart'
	    };
	    function genBoundary() {
	        var str = '';
	        for (var i = 0; i < 2; i++) {
	            str =
	                str +
	                    Math.random()
	                        .toString()
	                        .slice(2);
	        }
	        return str;
	    }
	    var boundary = genBoundary();
	    headers['Content-Type'] = 'multipart/related; boundary=' + boundary;
	    var metadata = metadataForUpload_(location, blob, opt_metadata);
	    var metadataString = MetadataUtils.toResourceString(metadata, mappings);
	    var preBlobPart = '--' +
	        boundary +
	        '\r\n' +
	        'Content-Type: application/json; charset=utf-8\r\n\r\n' +
	        metadataString +
	        '\r\n--' +
	        boundary +
	        '\r\n' +
	        'Content-Type: ' +
	        metadata['contentType'] +
	        '\r\n\r\n';
	    var postBlobPart = '\r\n--' + boundary + '--';
	    var body = blob_1.FbsBlob.getBlob(preBlobPart, blob, postBlobPart);
	    if (body === null) {
	        throw errorsExports.cannotSliceBlob();
	    }
	    var urlParams = { name: metadata['fullPath'] };
	    var url = UrlUtils.makeUploadUrl(urlPart);
	    var method = 'POST';
	    var timeout = authWrapper.maxUploadRetryTime();
	    var requestInfo = new requestinfo_1.RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
	    requestInfo.urlParams = urlParams;
	    requestInfo.headers = headers;
	    requestInfo.body = body.uploadData();
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	exports.multipartUpload = multipartUpload;
	/**
	 * @param current The number of bytes that have been uploaded so far.
	 * @param total The total number of bytes in the upload.
	 * @param opt_finalized True if the server has finished the upload.
	 * @param opt_metadata The upload metadata, should
	 *     only be passed if opt_finalized is true.
	 * @struct
	 */
	var ResumableUploadStatus = /** @class */ (function () {
	    function ResumableUploadStatus(current, total, finalized, metadata) {
	        this.current = current;
	        this.total = total;
	        this.finalized = !!finalized;
	        this.metadata = metadata || null;
	    }
	    return ResumableUploadStatus;
	}());
	exports.ResumableUploadStatus = ResumableUploadStatus;
	function checkResumeHeader_(xhr, opt_allowed) {
	    var status;
	    try {
	        status = xhr.getResponseHeader('X-Goog-Upload-Status');
	    }
	    catch (e) {
	        handlerCheck(false);
	    }
	    var allowed = opt_allowed || ['active'];
	    handlerCheck(array.contains(allowed, status));
	    return status;
	}
	exports.checkResumeHeader_ = checkResumeHeader_;
	function createResumableUpload(authWrapper, location, mappings, blob, opt_metadata) {
	    var urlPart = location.bucketOnlyServerUrl();
	    var metadata = metadataForUpload_(location, blob, opt_metadata);
	    var urlParams = { name: metadata['fullPath'] };
	    var url = UrlUtils.makeUploadUrl(urlPart);
	    var method = 'POST';
	    var headers = {
	        'X-Goog-Upload-Protocol': 'resumable',
	        'X-Goog-Upload-Command': 'start',
	        'X-Goog-Upload-Header-Content-Length': blob.size(),
	        'X-Goog-Upload-Header-Content-Type': metadata['contentType'],
	        'Content-Type': 'application/json; charset=utf-8'
	    };
	    var body = MetadataUtils.toResourceString(metadata, mappings);
	    var timeout = authWrapper.maxUploadRetryTime();
	    function handler(xhr, text) {
	        checkResumeHeader_(xhr);
	        var url;
	        try {
	            url = xhr.getResponseHeader('X-Goog-Upload-URL');
	        }
	        catch (e) {
	            handlerCheck(false);
	        }
	        handlerCheck(type.isString(url));
	        return url;
	    }
	    var requestInfo = new requestinfo_1.RequestInfo(url, method, handler, timeout);
	    requestInfo.urlParams = urlParams;
	    requestInfo.headers = headers;
	    requestInfo.body = body;
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	exports.createResumableUpload = createResumableUpload;
	/**
	 * @param url From a call to fbs.requests.createResumableUpload.
	 */
	function getResumableUploadStatus(authWrapper, location, url, blob) {
	    var headers = { 'X-Goog-Upload-Command': 'query' };
	    function handler(xhr, text) {
	        var status = checkResumeHeader_(xhr, ['active', 'final']);
	        var sizeString;
	        try {
	            sizeString = xhr.getResponseHeader('X-Goog-Upload-Size-Received');
	        }
	        catch (e) {
	            handlerCheck(false);
	        }
	        var size = parseInt(sizeString, 10);
	        handlerCheck(!isNaN(size));
	        return new ResumableUploadStatus(size, blob.size(), status === 'final');
	    }
	    var method = 'POST';
	    var timeout = authWrapper.maxUploadRetryTime();
	    var requestInfo = new requestinfo_1.RequestInfo(url, method, handler, timeout);
	    requestInfo.headers = headers;
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	exports.getResumableUploadStatus = getResumableUploadStatus;
	/**
	 * Any uploads via the resumable upload API must transfer a number of bytes
	 * that is a multiple of this number.
	 */
	exports.resumableUploadChunkSize = 256 * 1024;
	/**
	 * @param url From a call to fbs.requests.createResumableUpload.
	 * @param chunkSize Number of bytes to upload.
	 * @param opt_status The previous status.
	 *     If not passed or null, we start from the beginning.
	 * @throws fbs.Error If the upload is already complete, the passed in status
	 *     has a final size inconsistent with the blob, or the blob cannot be sliced
	 *     for upload.
	 */
	function continueResumableUpload(location, authWrapper, url, blob, chunkSize, mappings, opt_status, opt_progressCallback) {
	    // TODO(andysoto): standardize on internal asserts
	    // assert(!(opt_status && opt_status.finalized));
	    var status = new ResumableUploadStatus(0, 0);
	    if (opt_status) {
	        status.current = opt_status.current;
	        status.total = opt_status.total;
	    }
	    else {
	        status.current = 0;
	        status.total = blob.size();
	    }
	    if (blob.size() !== status.total) {
	        throw errorsExports.serverFileWrongSize();
	    }
	    var bytesLeft = status.total - status.current;
	    var bytesToUpload = bytesLeft;
	    if (chunkSize > 0) {
	        bytesToUpload = Math.min(bytesToUpload, chunkSize);
	    }
	    var startByte = status.current;
	    var endByte = startByte + bytesToUpload;
	    var uploadCommand = bytesToUpload === bytesLeft ? 'upload, finalize' : 'upload';
	    var headers = {
	        'X-Goog-Upload-Command': uploadCommand,
	        'X-Goog-Upload-Offset': status.current
	    };
	    var body = blob.slice(startByte, endByte);
	    if (body === null) {
	        throw errorsExports.cannotSliceBlob();
	    }
	    function handler(xhr, text) {
	        // TODO(andysoto): Verify the MD5 of each uploaded range:
	        // the 'x-range-md5' header comes back with status code 308 responses.
	        // We'll only be able to bail out though, because you can't re-upload a
	        // range that you previously uploaded.
	        var uploadStatus = checkResumeHeader_(xhr, ['active', 'final']);
	        var newCurrent = status.current + bytesToUpload;
	        var size = blob.size();
	        var metadata;
	        if (uploadStatus === 'final') {
	            metadata = metadataHandler(authWrapper, mappings)(xhr, text);
	        }
	        else {
	            metadata = null;
	        }
	        return new ResumableUploadStatus(newCurrent, size, uploadStatus === 'final', metadata);
	    }
	    var method = 'POST';
	    var timeout = authWrapper.maxUploadRetryTime();
	    var requestInfo = new requestinfo_1.RequestInfo(url, method, handler, timeout);
	    requestInfo.headers = headers;
	    requestInfo.body = body.uploadData();
	    requestInfo.progressCallback = opt_progressCallback || null;
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	exports.continueResumableUpload = continueResumableUpload;
	
	//# sourceMappingURL=requests.js.map


/***/ },
/* 204 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @enum{number}
	 */
	var ErrorCode;
	(function (ErrorCode) {
	    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
	    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
	    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
	})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
	
	//# sourceMappingURL=xhrio.js.map


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @fileoverview Defines the Firebase Storage Reference class.
	 */
	var args = __webpack_require__(131);
	var blob_1 = __webpack_require__(201);
	var errorsExports = __webpack_require__(41);
	var location_1 = __webpack_require__(100);
	var metadata = __webpack_require__(133);
	var object = __webpack_require__(58);
	var path = __webpack_require__(202);
	var requests = __webpack_require__(203);
	var fbsString = __webpack_require__(74);
	var string_1 = __webpack_require__(74);
	var type = __webpack_require__(33);
	var task_1 = __webpack_require__(514);
	/**
	 * Provides methods to interact with a bucket in the Firebase Storage service.
	 * @param location An fbs.location, or the URL at
	 *     which to base this object, in one of the following forms:
	 *         gs://<bucket>/<object-path>
	 *         http[s]://firebasestorage.googleapis.com/
	 *                     <api-version>/b/<bucket>/o/<object-path>
	 *     Any query or fragment strings will be ignored in the http[s]
	 *     format. If no value is passed, the storage object will use a URL based on
	 *     the project ID of the base firebase.App instance.
	 */
	var Reference = /** @class */ (function () {
	    function Reference(authWrapper, location) {
	        this.authWrapper = authWrapper;
	        if (location instanceof location_1.Location) {
	            this.location = location;
	        }
	        else {
	            this.location = location_1.Location.makeFromUrl(location);
	        }
	    }
	    /**
	     * @return The URL for the bucket and path this object references,
	     *     in the form gs://<bucket>/<object-path>
	     * @override
	     */
	    Reference.prototype.toString = function () {
	        args.validate('toString', [], arguments);
	        return 'gs://' + this.location.bucket + '/' + this.location.path;
	    };
	    Reference.prototype.newRef = function (authWrapper, location) {
	        return new Reference(authWrapper, location);
	    };
	    Reference.prototype.mappings = function () {
	        return metadata.getMappings();
	    };
	    /**
	     * @return A reference to the object obtained by
	     *     appending childPath, removing any duplicate, beginning, or trailing
	     *     slashes.
	     */
	    Reference.prototype.child = function (childPath) {
	        args.validate('child', [args.stringSpec()], arguments);
	        var newPath = path.child(this.location.path, childPath);
	        var location = new location_1.Location(this.location.bucket, newPath);
	        return this.newRef(this.authWrapper, location);
	    };
	    Object.defineProperty(Reference.prototype, "parent", {
	        /**
	         * @return A reference to the parent of the
	         *     current object, or null if the current object is the root.
	         */
	        get: function () {
	            var newPath = path.parent(this.location.path);
	            if (newPath === null) {
	                return null;
	            }
	            var location = new location_1.Location(this.location.bucket, newPath);
	            return this.newRef(this.authWrapper, location);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "root", {
	        /**
	         * @return An reference to the root of this
	         *     object's bucket.
	         */
	        get: function () {
	            var location = new location_1.Location(this.location.bucket, '');
	            return this.newRef(this.authWrapper, location);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "bucket", {
	        get: function () {
	            return this.location.bucket;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "fullPath", {
	        get: function () {
	            return this.location.path;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "name", {
	        get: function () {
	            return path.lastComponent(this.location.path);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "storage", {
	        get: function () {
	            return this.authWrapper.service();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Uploads a blob to this object's location.
	     * @param data The blob to upload.
	     * @return An UploadTask that lets you control and
	     *     observe the upload.
	     */
	    Reference.prototype.put = function (data, metadata) {
	        if (metadata === void 0) { metadata = null; }
	        args.validate('put', [args.uploadDataSpec(), args.metadataSpec(true)], arguments);
	        this.throwIfRoot_('put');
	        return new task_1.UploadTask(this, this.authWrapper, this.location, this.mappings(), new blob_1.FbsBlob(data), metadata);
	    };
	    /**
	     * Uploads a string to this object's location.
	     * @param string The string to upload.
	     * @param opt_format The format of the string to upload.
	     * @return An UploadTask that lets you control and
	     *     observe the upload.
	     */
	    Reference.prototype.putString = function (string, format, opt_metadata) {
	        if (format === void 0) { format = string_1.StringFormat.RAW; }
	        args.validate('putString', [
	            args.stringSpec(),
	            args.stringSpec(fbsString.formatValidator, true),
	            args.metadataSpec(true)
	        ], arguments);
	        this.throwIfRoot_('putString');
	        var data = fbsString.dataFromString(format, string);
	        var metadata = object.clone(opt_metadata);
	        if (!type.isDef(metadata['contentType']) && type.isDef(data.contentType)) {
	            metadata['contentType'] = data.contentType;
	        }
	        return new task_1.UploadTask(this, this.authWrapper, this.location, this.mappings(), new blob_1.FbsBlob(data.data, true), metadata);
	    };
	    /**
	     * Deletes the object at this location.
	     * @return A promise that resolves if the deletion succeeds.
	     */
	    Reference.prototype.delete = function () {
	        args.validate('delete', [], arguments);
	        this.throwIfRoot_('delete');
	        var self = this;
	        return this.authWrapper.getAuthToken().then(function (authToken) {
	            var requestInfo = requests.deleteObject(self.authWrapper, self.location);
	            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
	        });
	    };
	    /**
	     *     A promise that resolves with the metadata for this object. If this
	     *     object doesn't exist or metadata cannot be retreived, the promise is
	     *     rejected.
	     */
	    Reference.prototype.getMetadata = function () {
	        args.validate('getMetadata', [], arguments);
	        this.throwIfRoot_('getMetadata');
	        var self = this;
	        return this.authWrapper.getAuthToken().then(function (authToken) {
	            var requestInfo = requests.getMetadata(self.authWrapper, self.location, self.mappings());
	            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
	        });
	    };
	    /**
	     * Updates the metadata for this object.
	     * @param metadata The new metadata for the object.
	     *     Only values that have been explicitly set will be changed. Explicitly
	     *     setting a value to null will remove the metadata.
	     * @return A promise that resolves
	     *     with the new metadata for this object.
	     *     @see firebaseStorage.Reference.prototype.getMetadata
	     */
	    Reference.prototype.updateMetadata = function (metadata) {
	        args.validate('updateMetadata', [args.metadataSpec()], arguments);
	        this.throwIfRoot_('updateMetadata');
	        var self = this;
	        return this.authWrapper.getAuthToken().then(function (authToken) {
	            var requestInfo = requests.updateMetadata(self.authWrapper, self.location, metadata, self.mappings());
	            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
	        });
	    };
	    /**
	     * @return A promise that resolves with the download
	     *     URL for this object.
	     */
	    Reference.prototype.getDownloadURL = function () {
	        args.validate('getDownloadURL', [], arguments);
	        this.throwIfRoot_('getDownloadURL');
	        return this.getMetadata().then(function (metadata) {
	            var url = metadata['downloadURLs'][0];
	            if (type.isDef(url)) {
	                return url;
	            }
	            else {
	                throw errorsExports.noDownloadURL();
	            }
	        });
	    };
	    Reference.prototype.throwIfRoot_ = function (name) {
	        if (this.location.path === '') {
	            throw errorsExports.invalidRootOperation(name);
	        }
	    };
	    return Reference;
	}());
	exports.Reference = Reference;
	
	//# sourceMappingURL=reference.js.map


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var constants_1 = __webpack_require__(135);
	/**
	 * Throws an error if the provided assertion is falsy
	 * @param {*} assertion The assertion to be tested for falsiness
	 * @param {!string} message The message to display if the check fails
	 */
	exports.assert = function (assertion, message) {
	    if (!assertion) {
	        throw exports.assertionError(message);
	    }
	};
	/**
	 * Returns an Error object suitable for throwing.
	 * @param {string} message
	 * @return {!Error}
	 */
	exports.assertionError = function (message) {
	    return new Error('Firebase Database (' +
	        constants_1.CONSTANTS.SDK_VERSION +
	        ') INTERNAL ASSERT FAILED: ' +
	        message);
	};
	
	//# sourceMappingURL=assert.js.map


/***/ },
/* 207 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var stringToByteArray = function (str) {
	    var output = [], p = 0;
	    for (var i = 0; i < str.length; i++) {
	        var c = str.charCodeAt(i);
	        while (c > 255) {
	            output[p++] = c & 255;
	            c >>= 8;
	        }
	        output[p++] = c;
	    }
	    return output;
	};
	/**
	 * Turns an array of numbers into the string given by the concatenation of the
	 * characters to which the numbers correspond.
	 * @param {Array<number>} bytes Array of numbers representing characters.
	 * @return {string} Stringification of the array.
	 */
	var byteArrayToString = function (bytes) {
	    var CHUNK_SIZE = 8192;
	    // Special-case the simple case for speed's sake.
	    if (bytes.length < CHUNK_SIZE) {
	        return String.fromCharCode.apply(null, bytes);
	    }
	    // The remaining logic splits conversion by chunks since
	    // Function#apply() has a maximum parameter count.
	    // See discussion: http://goo.gl/LrWmZ9
	    var str = '';
	    for (var i = 0; i < bytes.length; i += CHUNK_SIZE) {
	        var chunk = bytes.slice(i, i + CHUNK_SIZE);
	        str += String.fromCharCode.apply(null, chunk);
	    }
	    return str;
	};
	// Static lookup maps, lazily populated by init_()
	exports.base64 = {
	    /**
	     * Maps bytes to characters.
	     * @type {Object}
	     * @private
	     */
	    byteToCharMap_: null,
	    /**
	     * Maps characters to bytes.
	     * @type {Object}
	     * @private
	     */
	    charToByteMap_: null,
	    /**
	     * Maps bytes to websafe characters.
	     * @type {Object}
	     * @private
	     */
	    byteToCharMapWebSafe_: null,
	    /**
	     * Maps websafe characters to bytes.
	     * @type {Object}
	     * @private
	     */
	    charToByteMapWebSafe_: null,
	    /**
	     * Our default alphabet, shared between
	     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
	     * @type {string}
	     */
	    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
	    /**
	     * Our default alphabet. Value 64 (=) is special; it means "nothing."
	     * @type {string}
	     */
	    get ENCODED_VALS() {
	        return this.ENCODED_VALS_BASE + '+/=';
	    },
	    /**
	     * Our websafe alphabet.
	     * @type {string}
	     */
	    get ENCODED_VALS_WEBSAFE() {
	        return this.ENCODED_VALS_BASE + '-_.';
	    },
	    /**
	     * Whether this browser supports the atob and btoa functions. This extension
	     * started at Mozilla but is now implemented by many browsers. We use the
	     * ASSUME_* variables to avoid pulling in the full useragent detection library
	     * but still allowing the standard per-browser compilations.
	     *
	     * @type {boolean}
	     */
	    HAS_NATIVE_SUPPORT: typeof atob === 'function',
	    /**
	     * Base64-encode an array of bytes.
	     *
	     * @param {Array<number>|Uint8Array} input An array of bytes (numbers with
	     *     value in [0, 255]) to encode.
	     * @param {boolean=} opt_webSafe Boolean indicating we should use the
	     *     alternative alphabet.
	     * @return {string} The base64 encoded string.
	     */
	    encodeByteArray: function (input, opt_webSafe) {
	        if (!Array.isArray(input)) {
	            throw Error('encodeByteArray takes an array as a parameter');
	        }
	        this.init_();
	        var byteToCharMap = opt_webSafe
	            ? this.byteToCharMapWebSafe_
	            : this.byteToCharMap_;
	        var output = [];
	        for (var i = 0; i < input.length; i += 3) {
	            var byte1 = input[i];
	            var haveByte2 = i + 1 < input.length;
	            var byte2 = haveByte2 ? input[i + 1] : 0;
	            var haveByte3 = i + 2 < input.length;
	            var byte3 = haveByte3 ? input[i + 2] : 0;
	            var outByte1 = byte1 >> 2;
	            var outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
	            var outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
	            var outByte4 = byte3 & 0x3f;
	            if (!haveByte3) {
	                outByte4 = 64;
	                if (!haveByte2) {
	                    outByte3 = 64;
	                }
	            }
	            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
	        }
	        return output.join('');
	    },
	    /**
	     * Base64-encode a string.
	     *
	     * @param {string} input A string to encode.
	     * @param {boolean=} opt_webSafe If true, we should use the
	     *     alternative alphabet.
	     * @return {string} The base64 encoded string.
	     */
	    encodeString: function (input, opt_webSafe) {
	        // Shortcut for Mozilla browsers that implement
	        // a native base64 encoder in the form of "btoa/atob"
	        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
	            return btoa(input);
	        }
	        return this.encodeByteArray(stringToByteArray(input), opt_webSafe);
	    },
	    /**
	     * Base64-decode a string.
	     *
	     * @param {string} input to decode.
	     * @param {boolean=} opt_webSafe True if we should use the
	     *     alternative alphabet.
	     * @return {string} string representing the decoded value.
	     */
	    decodeString: function (input, opt_webSafe) {
	        // Shortcut for Mozilla browsers that implement
	        // a native base64 encoder in the form of "btoa/atob"
	        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
	            return atob(input);
	        }
	        return byteArrayToString(this.decodeStringToByteArray(input, opt_webSafe));
	    },
	    /**
	     * Base64-decode a string.
	     *
	     * In base-64 decoding, groups of four characters are converted into three
	     * bytes.  If the encoder did not apply padding, the input length may not
	     * be a multiple of 4.
	     *
	     * In this case, the last group will have fewer than 4 characters, and
	     * padding will be inferred.  If the group has one or two characters, it decodes
	     * to one byte.  If the group has three characters, it decodes to two bytes.
	     *
	     * @param {string} input Input to decode.
	     * @param {boolean=} opt_webSafe True if we should use the web-safe alphabet.
	     * @return {!Array<number>} bytes representing the decoded value.
	     */
	    decodeStringToByteArray: function (input, opt_webSafe) {
	        this.init_();
	        var charToByteMap = opt_webSafe
	            ? this.charToByteMapWebSafe_
	            : this.charToByteMap_;
	        var output = [];
	        for (var i = 0; i < input.length;) {
	            var byte1 = charToByteMap[input.charAt(i++)];
	            var haveByte2 = i < input.length;
	            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
	            ++i;
	            var haveByte3 = i < input.length;
	            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
	            ++i;
	            var haveByte4 = i < input.length;
	            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
	            ++i;
	            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
	                throw Error();
	            }
	            var outByte1 = (byte1 << 2) | (byte2 >> 4);
	            output.push(outByte1);
	            if (byte3 != 64) {
	                var outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
	                output.push(outByte2);
	                if (byte4 != 64) {
	                    var outByte3 = ((byte3 << 6) & 0xc0) | byte4;
	                    output.push(outByte3);
	                }
	            }
	        }
	        return output;
	    },
	    /**
	     * Lazy static initialization function. Called before
	     * accessing any of the static map variables.
	     * @private
	     */
	    init_: function () {
	        if (!this.byteToCharMap_) {
	            this.byteToCharMap_ = {};
	            this.charToByteMap_ = {};
	            this.byteToCharMapWebSafe_ = {};
	            this.charToByteMapWebSafe_ = {};
	            // We want quick mappings back and forth, so we precompute two maps.
	            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
	                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
	                this.charToByteMap_[this.byteToCharMap_[i]] = i;
	                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
	                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
	                // Be forgiving when decoding and correctly decode both encodings.
	                if (i >= this.ENCODED_VALS_BASE.length) {
	                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
	                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
	                }
	            }
	        }
	    }
	};
	/**
	 * URL-safe base64 encoding
	 * @param {!string} str
	 * @return {!string}
	 */
	exports.base64Encode = function (str) {
	    var utf8Bytes = stringToByteArray(str);
	    return exports.base64.encodeByteArray(utf8Bytes, true);
	};
	/**
	 * URL-safe base64 decoding
	 *
	 * NOTE: DO NOT use the global atob() function - it does NOT support the
	 * base64Url variant encoding.
	 *
	 * @param {string} str To be decoded
	 * @return {?string} Decoded result, if possible
	 */
	exports.base64Decode = function (str) {
	    try {
	        return exports.base64.decodeString(str, true);
	    }
	    catch (e) {
	        console.error('base64Decode failed: ', e);
	    }
	    return null;
	};
	
	//# sourceMappingURL=crypt.js.map


/***/ },
/* 208 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Evaluates a JSON string into a javascript object.
	 *
	 * @param {string} str A string containing JSON.
	 * @return {*} The javascript object representing the specified JSON.
	 */
	function jsonEval(str) {
	    return JSON.parse(str);
	}
	exports.jsonEval = jsonEval;
	/**
	 * Returns JSON representing a javascript object.
	 * @param {*} data Javascript object to be stringified.
	 * @return {string} The JSON contents of the object.
	 */
	function stringify(data) {
	    return JSON.stringify(data);
	}
	exports.stringify = stringify;
	
	//# sourceMappingURL=json.js.map


/***/ },
/* 209 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// See http://www.devthought.com/2012/01/18/an-object-is-not-a-hash/
	exports.contains = function (obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	};
	exports.safeGet = function (obj, key) {
	    if (Object.prototype.hasOwnProperty.call(obj, key))
	        return obj[key];
	    // else return undefined.
	};
	/**
	 * Enumerates the keys/values in an object, excluding keys defined on the prototype.
	 *
	 * @param {?Object.<K,V>} obj Object to enumerate.
	 * @param {!function(K, V)} fn Function to call for each key and value.
	 * @template K,V
	 */
	exports.forEach = function (obj, fn) {
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            fn(key, obj[key]);
	        }
	    }
	};
	/**
	 * Copies all the (own) properties from one object to another.
	 * @param {!Object} objTo
	 * @param {!Object} objFrom
	 * @return {!Object} objTo
	 */
	exports.extend = function (objTo, objFrom) {
	    exports.forEach(objFrom, function (key, value) {
	        objTo[key] = value;
	    });
	    return objTo;
	};
	/**
	 * Returns a clone of the specified object.
	 * @param {!Object} obj
	 * @return {!Object} cloned obj.
	 */
	exports.clone = function (obj) {
	    return exports.extend({}, obj);
	};
	/**
	 * Returns true if obj has typeof "object" and is not null.  Unlike goog.isObject(), does not return true
	 * for functions.
	 *
	 * @param obj {*} A potential object.
	 * @returns {boolean} True if it's an object.
	 */
	exports.isNonNullObject = function (obj) {
	    return typeof obj === 'object' && obj !== null;
	};
	exports.isEmpty = function (obj) {
	    for (var key in obj) {
	        return false;
	    }
	    return true;
	};
	exports.getCount = function (obj) {
	    var rv = 0;
	    for (var key in obj) {
	        rv++;
	    }
	    return rv;
	};
	exports.map = function (obj, f, opt_obj) {
	    var res = {};
	    for (var key in obj) {
	        res[key] = f.call(opt_obj, obj[key], key, obj);
	    }
	    return res;
	};
	exports.findKey = function (obj, fn, opt_this) {
	    for (var key in obj) {
	        if (fn.call(opt_this, obj[key], key, obj)) {
	            return key;
	        }
	    }
	    return undefined;
	};
	exports.findValue = function (obj, fn, opt_this) {
	    var key = exports.findKey(obj, fn, opt_this);
	    return key && obj[key];
	};
	exports.getAnyKey = function (obj) {
	    for (var key in obj) {
	        return key;
	    }
	};
	exports.getValues = function (obj) {
	    var res = [];
	    var i = 0;
	    for (var key in obj) {
	        res[i++] = obj[key];
	    }
	    return res;
	};
	/**
	 * Tests whether every key/value pair in an object pass the test implemented
	 * by the provided function
	 *
	 * @param {?Object.<K,V>} obj Object to test.
	 * @param {!function(K, V)} fn Function to call for each key and value.
	 * @template K,V
	 */
	exports.every = function (obj, fn) {
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            if (!fn(key, obj[key])) {
	                return false;
	            }
	        }
	    }
	    return true;
	};
	
	//# sourceMappingURL=obj.js.map


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	*  filename: ej2-compression.umd.min.js
	*  version : 19.4.52
	*  Copyright Syncfusion Inc. 2001 - 2020. All rights reserved.
	*  Use of this code is subject to the terms of our license.
	*  A copy of the current license can be obtained at any time by e-mailing
	*  licensing@syncfusion.com. Any infringement will be prosecuted under
	*  applicable laws. 
	*/
	!function(t,e){ true?e(exports,__webpack_require__(211)):"function"==typeof define&&define.amd?define(["exports","@syncfusion/ej2-file-utils"],e):e(t.ej={},t.ej2FileUtils)}(this,function(t,e){"use strict";var i=new Int16Array(286),r=new Uint8Array(286),n=new Int16Array(30),s=new Uint8Array(30),h=function(){function t(e){this.pendingBuffer=new Uint8Array(65536),this.pendingBufLength=0,this.pendingBufCache=0,this.pendingBufBitsInCache=0,this.bufferPosition=0,this.extraBits=0,this.currentHash=0,this.matchStart=0,this.matchLength=0,this.matchPrevAvail=!1,this.blockStart=0,this.stringStart=0,this.lookAhead=0,this.totalBytesIn=0,this.inputOffset=0,this.inputEnd=0,this.windowSize=32768,this.windowMask=this.windowSize-1,this.hashSize=32768,this.hashMask=this.hashSize-1,this.hashShift=Math.floor(17/3),this.maxDist=this.windowSize-262,this.checkSum=1,this.noWrap=!1,t.isHuffmanTreeInitiated||(t.initHuffmanTree(),t.isHuffmanTreeInitiated=!0),this.treeLiteral=new o(this,286,257,15),this.treeDistances=new o(this,30,1,15),this.treeCodeLengths=new o(this,19,4,7),this.arrDistances=new Uint16Array(16384),this.arrLiterals=new Uint8Array(16384),this.stream=[],this.dataWindow=new Uint8Array(2*this.windowSize),this.hashHead=new Int16Array(this.hashSize),this.hashPrevious=new Int16Array(this.windowSize),this.blockStart=this.stringStart=1,this.noWrap=e,e||this.writeZLibHeader()}return Object.defineProperty(t.prototype,"compressedData",{get:function(){return this.stream},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"getCompressedString",{get:function(){var t="";if(void 0!==this.stream)for(var e=0;e<this.stream.length;e++)t+=String.fromCharCode.apply(null,this.stream[e]);return t},enumerable:!0,configurable:!0}),t.prototype.write=function(t,i,r){if(void 0===t||null===t)throw new Error("ArgumentException: data cannot null or undefined");var n=i+r;if(0>i||i>n||n>t.length)throw new Error("ArgumentOutOfRangeException: Offset or length is incorrect");if("string"==typeof t){var s=new e.Encoding(!1);s.type="Utf8",n=i+(t=new Uint8Array(s.getBytes(t,0,t.length))).length}for(this.inputBuffer=t,this.inputOffset=i,this.inputEnd=n,this.noWrap||(this.checkSum=a.checksumUpdate(this.checkSum,this.inputBuffer,this.inputOffset,n));this.inputEnd!==this.inputOffset||0!==this.pendingBufLength;)this.pendingBufferFlush(),this.compressData(!1)},t.prototype.writeZLibHeader=function(){var t=30720;t|=64,t+=31-t%31,this.pendingBufferWriteShortBytes(t)},t.prototype.pendingBufferWriteShortBytes=function(t){this.pendingBuffer[this.pendingBufLength++]=t>>8,this.pendingBuffer[this.pendingBufLength++]=t},t.prototype.compressData=function(t){var e;do{this.fillWindow();var i=t&&this.inputEnd===this.inputOffset;e=this.compressSlow(i,t)}while(0===this.pendingBufLength&&e);return e},t.prototype.compressSlow=function(t,e){if(this.lookAhead<262&&!t)return!1;for(;this.lookAhead>=262||t;){if(0===this.lookAhead)return this.lookAheadCompleted(e);this.stringStart>=2*this.windowSize-262&&this.slideWindow();var i=this.matchStart,r=this.matchLength;if(this.lookAhead>=3&&this.discardMatch(),r>=3&&this.matchLength<=r?r=this.matchPreviousBest(i,r):this.matchPreviousAvailable(),this.bufferPosition>=16384)return this.huffmanIsFull(e)}return!0},t.prototype.discardMatch=function(){var t=this.insertString();0!==t&&this.stringStart-t<=this.maxDist&&this.findLongestMatch(t)&&this.matchLength<=5&&3===this.matchLength&&this.stringStart-this.matchStart>4096&&(this.matchLength=2)},t.prototype.matchPreviousAvailable=function(){this.matchPrevAvail&&this.huffmanTallyLit(255&this.dataWindow[this.stringStart-1]),this.matchPrevAvail=!0,this.stringStart++,this.lookAhead--},t.prototype.matchPreviousBest=function(t,e){this.huffmanTallyDist(this.stringStart-1-t,e),e-=2;do{this.stringStart++,this.lookAhead--,this.lookAhead>=3&&this.insertString()}while(--e>0);return this.stringStart++,this.lookAhead--,this.matchPrevAvail=!1,this.matchLength=2,e},t.prototype.lookAheadCompleted=function(t){return this.matchPrevAvail&&this.huffmanTallyLit(255&this.dataWindow[this.stringStart-1]),this.matchPrevAvail=!1,this.huffmanFlushBlock(this.dataWindow,this.blockStart,this.stringStart-this.blockStart,t),this.blockStart=this.stringStart,!1},t.prototype.huffmanIsFull=function(t){var e=this.stringStart-this.blockStart;this.matchPrevAvail&&e--;var i=t&&0===this.lookAhead&&!this.matchPrevAvail;return this.huffmanFlushBlock(this.dataWindow,this.blockStart,e,i),this.blockStart+=e,!i},t.prototype.fillWindow=function(){for(this.stringStart>=this.windowSize+this.maxDist&&this.slideWindow();this.lookAhead<262&&this.inputOffset<this.inputEnd;){var t=2*this.windowSize-this.lookAhead-this.stringStart;t>this.inputEnd-this.inputOffset&&(t=this.inputEnd-this.inputOffset),this.dataWindow.set(this.inputBuffer.subarray(this.inputOffset,this.inputOffset+t),this.stringStart+this.lookAhead),this.inputOffset+=t,this.totalBytesIn+=t,this.lookAhead+=t}this.lookAhead>=3&&this.updateHash()},t.prototype.slideWindow=function(){this.dataWindow.set(this.dataWindow.subarray(this.windowSize,this.windowSize+this.windowSize),0),this.matchStart-=this.windowSize,this.stringStart-=this.windowSize,this.blockStart-=this.windowSize;for(var t=0;t<this.hashSize;++t){var e=65535&this.hashHead[t];this.hashHead[t]=e>=this.windowSize?e-this.windowSize:0}for(t=0;t<this.windowSize;t++){e=65535&this.hashPrevious[t];this.hashPrevious[t]=e>=this.windowSize?e-this.windowSize:0}},t.prototype.insertString=function(){var t,e=(this.currentHash<<this.hashShift^this.dataWindow[this.stringStart+2])&this.hashMask;return this.hashPrevious[this.stringStart&this.windowMask]=t=this.hashHead[e],this.hashHead[e]=this.stringStart,this.currentHash=e,65535&t},t.prototype.findLongestMatch=function(t){var e,i=4096,r=258,n=this.stringStart,s=this.stringStart+this.matchLength,h=Math.max(this.matchLength,2),o=Math.max(this.stringStart-this.maxDist,0),a=this.stringStart+258-1,f=this.dataWindow[s-1],u=this.dataWindow[s],d=this.dataWindow;h>=32&&(i>>=2),r>this.lookAhead&&(r=this.lookAhead);do{if(d[t+h]===u&&d[t+h-1]===f&&d[t]===d[n]&&d[t+1]===d[n+1]){for(e=t+2,n+=2;d[++n]===d[++e]&&d[++n]===d[++e]&&d[++n]===d[++e]&&d[++n]===d[++e]&&d[++n]===d[++e]&&d[++n]===d[++e]&&d[++n]===d[++e]&&d[++n]===d[++e]&&n<a;);if(n>s){if(this.matchStart=t,s=n,(h=n-this.stringStart)>=r)break;f=d[s-1],u=d[s]}n=this.stringStart}}while((t=65535&this.hashPrevious[t&this.windowMask])>o&&0!=--i);return this.matchLength=Math.min(h,this.lookAhead),this.matchLength>=3},t.prototype.updateHash=function(){this.currentHash=this.dataWindow[this.stringStart]<<this.hashShift^this.dataWindow[this.stringStart+1]},t.prototype.huffmanTallyLit=function(t){return this.arrDistances[this.bufferPosition]=0,this.arrLiterals[this.bufferPosition++]=t,this.treeLiteral.codeFrequencies[t]++,this.bufferPosition>=16384},t.prototype.huffmanTallyDist=function(t,e){this.arrDistances[this.bufferPosition]=t,this.arrLiterals[this.bufferPosition++]=e-3;var i=this.huffmanLengthCode(e-3);this.treeLiteral.codeFrequencies[i]++,i>=265&&i<285&&(this.extraBits+=Math.floor((i-261)/4));var r=this.huffmanDistanceCode(t-1);return this.treeDistances.codeFrequencies[r]++,r>=4&&(this.extraBits+=Math.floor(r/2-1)),this.bufferPosition>=16384},t.prototype.huffmanFlushBlock=function(t,e,h,a){this.treeLiteral.codeFrequencies[256]++,this.treeLiteral.buildTree(),this.treeDistances.buildTree(),this.treeLiteral.calculateBLFreq(this.treeCodeLengths),this.treeDistances.calculateBLFreq(this.treeCodeLengths),this.treeCodeLengths.buildTree();for(var f=4,u=18;u>f;u--)this.treeCodeLengths.codeLengths[o.huffCodeLengthOrders[u]]>0&&(f=u+1);var d=14+3*f+this.treeCodeLengths.getEncodedLength()+this.treeLiteral.getEncodedLength()+this.treeDistances.getEncodedLength()+this.extraBits,c=this.extraBits;for(u=0;u<286;u++)c+=this.treeLiteral.codeFrequencies[u]*r[u];for(u=0;u<30;u++)c+=this.treeDistances.codeFrequencies[u]*s[u];d>=c&&(d=c),e>=0&&h+4<d>>3?this.huffmanFlushStoredBlock(t,e,h,a):d==c?(this.pendingBufferWriteBits(2+(a?1:0),3),this.treeLiteral.setStaticCodes(i,r),this.treeDistances.setStaticCodes(n,s),this.huffmanCompressBlock(),this.huffmanReset()):(this.pendingBufferWriteBits(4+(a?1:0),3),this.huffmanSendAllTrees(f),this.huffmanCompressBlock(),this.huffmanReset())},t.prototype.huffmanFlushStoredBlock=function(t,e,i,r){this.pendingBufferWriteBits(0+(r?1:0),3),this.pendingBufferAlignToByte(),this.pendingBufferWriteShort(i),this.pendingBufferWriteShort(~i),this.pendingBufferWriteByteBlock(t,e,i),this.huffmanReset()},t.prototype.huffmanLengthCode=function(t){if(255===t)return 285;for(var e=257;t>=8;)e+=4,t>>=1;return e+t},t.prototype.huffmanDistanceCode=function(t){for(var e=0;t>=4;)e+=2,t>>=1;return e+t},t.prototype.huffmanSendAllTrees=function(t){this.treeCodeLengths.buildCodes(),this.treeLiteral.buildCodes(),this.treeDistances.buildCodes(),this.pendingBufferWriteBits(this.treeLiteral.treeLength-257,5),this.pendingBufferWriteBits(this.treeDistances.treeLength-1,5),this.pendingBufferWriteBits(t-4,4);for(var e=0;e<t;e++)this.pendingBufferWriteBits(this.treeCodeLengths.codeLengths[o.huffCodeLengthOrders[e]],3);this.treeLiteral.writeTree(this.treeCodeLengths),this.treeDistances.writeTree(this.treeCodeLengths)},t.prototype.huffmanReset=function(){this.bufferPosition=0,this.extraBits=0,this.treeLiteral.reset(),this.treeDistances.reset(),this.treeCodeLengths.reset()},t.prototype.huffmanCompressBlock=function(){for(var t=0;t<this.bufferPosition;t++){var e=255&this.arrLiterals[t],i=this.arrDistances[t];if(0!=i--){var r=this.huffmanLengthCode(e);this.treeLiteral.writeCodeToStream(r);var n=Math.floor((r-261)/4);n>0&&n<=5&&this.pendingBufferWriteBits(e&(1<<n)-1,n);var s=this.huffmanDistanceCode(i);this.treeDistances.writeCodeToStream(s),(n=Math.floor(s/2-1))>0&&this.pendingBufferWriteBits(i&(1<<n)-1,n)}else this.treeLiteral.writeCodeToStream(e)}this.treeLiteral.writeCodeToStream(256)},t.prototype.pendingBufferWriteBits=function(t,e){var i=new Uint32Array(1);i[0]=this.pendingBufCache|t<<this.pendingBufBitsInCache,this.pendingBufCache=i[0],this.pendingBufBitsInCache+=e,this.pendingBufferFlushBits()},t.prototype.pendingBufferFlush=function(t){if(this.pendingBufferFlushBits(),this.pendingBufLength>0){var e=new Uint8Array(this.pendingBufLength);e.set(this.pendingBuffer.subarray(0,this.pendingBufLength),0),this.stream.push(e)}this.pendingBufLength=0},t.prototype.pendingBufferFlushBits=function(){for(var t=0;this.pendingBufBitsInCache>=8&&this.pendingBufLength<65536;)this.pendingBuffer[this.pendingBufLength++]=this.pendingBufCache,this.pendingBufCache>>=8,this.pendingBufBitsInCache-=8,t++;return t},t.prototype.pendingBufferWriteByteBlock=function(t,e,i){var r=t.subarray(e,e+i);this.pendingBuffer.set(r,this.pendingBufLength),this.pendingBufLength+=i},t.prototype.pendingBufferWriteShort=function(t){this.pendingBuffer[this.pendingBufLength++]=t,this.pendingBuffer[this.pendingBufLength++]=t>>8},t.prototype.pendingBufferAlignToByte=function(){this.pendingBufBitsInCache>0&&(this.pendingBuffer[this.pendingBufLength++]=this.pendingBufCache),this.pendingBufCache=0,this.pendingBufBitsInCache=0},t.initHuffmanTree=function(){for(var t=0;t<144;)i[t]=o.bitReverse(48+t<<8),r[t++]=8;for(;t<256;)i[t]=o.bitReverse(256+t<<7),r[t++]=9;for(;t<280;)i[t]=o.bitReverse(-256+t<<9),r[t++]=7;for(;t<286;)i[t]=o.bitReverse(-88+t<<8),r[t++]=8;for(t=0;t<30;t++)n[t]=o.bitReverse(t<<11),s[t]=5},t.prototype.close=function(){do{this.pendingBufferFlush(!0),this.compressData(!0)||(this.pendingBufferFlush(!0),this.pendingBufferAlignToByte(),this.noWrap||(this.pendingBufferWriteShortBytes(this.checkSum>>16),this.pendingBufferWriteShortBytes(65535&this.checkSum)),this.pendingBufferFlush(!0))}while(this.inputEnd!==this.inputOffset||0!==this.pendingBufLength)},t.prototype.destroy=function(){this.stream=[],this.stream=void 0,this.pendingBuffer=void 0,this.treeLiteral=void 0,this.treeDistances=void 0,this.treeCodeLengths=void 0,this.arrLiterals=void 0,this.arrDistances=void 0,this.hashHead=void 0,this.hashPrevious=void 0,this.dataWindow=void 0,this.inputBuffer=void 0,this.pendingBufLength=void 0,this.pendingBufCache=void 0,this.pendingBufBitsInCache=void 0,this.bufferPosition=void 0,this.extraBits=void 0,this.currentHash=void 0,this.matchStart=void 0,this.matchLength=void 0,this.matchPrevAvail=void 0,this.blockStart=void 0,this.stringStart=void 0,this.lookAhead=void 0,this.totalBytesIn=void 0,this.inputOffset=void 0,this.inputEnd=void 0,this.windowSize=void 0,this.windowMask=void 0,this.hashSize=void 0,this.hashMask=void 0,this.hashShift=void 0,this.maxDist=void 0,this.checkSum=void 0,this.noWrap=void 0},t.isHuffmanTreeInitiated=!1,t}(),o=function(){function t(t,e,i,r){this.writer=t,this.codeMinCount=i,this.maxLength=r,this.codeFrequency=new Uint16Array(e),this.lengthCount=new Int32Array(r)}return Object.defineProperty(t.prototype,"treeLength",{get:function(){return this.codeCount},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"codeLengths",{get:function(){return this.codeLength},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"codeFrequencies",{get:function(){return this.codeFrequency},enumerable:!0,configurable:!0}),t.prototype.setStaticCodes=function(t,e){var i=new Int16Array(t.length);i.set(t,0),this.codes=i;var r=new Uint8Array(e.length);r.set(e,0),this.codeLength=r},t.prototype.reset=function(){for(var t=0;t<this.codeFrequency.length;t++)this.codeFrequency[t]=0;this.codes=void 0,this.codeLength=void 0},t.prototype.writeCodeToStream=function(t){this.writer.pendingBufferWriteBits(65535&this.codes[t],this.codeLength[t])},t.prototype.buildCodes=function(){var e=new Int32Array(this.maxLength);this.codes=new Int16Array(this.codeCount);for(var i=0,r=0;r<this.maxLength;r++)e[r]=i,i+=this.lengthCount[r]<<15-r;for(var n=0;n<this.codeCount;n++){var s=this.codeLength[n];s>0&&(this.codes[n]=t.bitReverse(e[s-1]),e[s-1]+=1<<16-s)}},t.bitReverse=function(e){return t.reverseBits[15&e]<<12|t.reverseBits[e>>4&15]<<8|t.reverseBits[e>>8&15]<<4|t.reverseBits[e>>12]},t.prototype.getEncodedLength=function(){for(var t=0,e=0;e<this.codeFrequency.length;e++)t+=this.codeFrequency[e]*this.codeLength[e];return t},t.prototype.calculateBLFreq=function(t){for(var e,i,r,n=-1,s=0;s<this.codeCount;){r=1;var h=this.codeLength[s];for(0===h?(e=138,i=3):(e=6,i=3,n!==h&&(t.codeFrequency[h]++,r=0)),n=h,s++;s<this.codeCount&&n===this.codeLength[s]&&(s++,!(++r>=e)););r<i?t.codeFrequency[n]+=r:0!==n?t.codeFrequency[16]++:r<=10?t.codeFrequency[17]++:t.codeFrequency[18]++}},t.prototype.writeTree=function(t){for(var e,i,r,n=-1,s=0;s<this.codeCount;){r=1;var h=this.codeLength[s];for(0===h?(e=138,i=3):(e=6,i=3,n!==h&&(t.writeCodeToStream(h),r=0)),n=h,s++;s<this.codeCount&&n===this.codeLength[s]&&(s++,!(++r>=e)););if(r<i)for(;r-- >0;)t.writeCodeToStream(n);else 0!==n?(t.writeCodeToStream(16),this.writer.pendingBufferWriteBits(r-3,2)):r<=10?(t.writeCodeToStream(17),this.writer.pendingBufferWriteBits(r-3,3)):(t.writeCodeToStream(18),this.writer.pendingBufferWriteBits(r-11,7))}},t.prototype.buildTree=function(){for(var t=this.codeFrequency.length,e=new Int32Array(t),i=0,r=0,n=0;n<t;n++){var s=this.codeFrequency[n];if(0!==s){for(var h=i++,o=0;h>0&&this.codeFrequency[e[o=Math.floor((h-1)/2)]]>s;)e[h]=e[o],h=o;e[h]=n,r=n}}for(;i<2;)e[i++]=r<2?++r:0;this.codeCount=Math.max(r+1,this.codeMinCount);for(var a=i,f=new Int32Array(4*i-2),u=new Int32Array(2*i-1),d=0;d<i;d++){var c=e[d],l=2*d;f[l]=c,f[l+1]=-1,u[d]=this.codeFrequency[c]<<8,e[d]=d}this.constructHuffmanTree(e,i,u,a,f),this.buildLength(f)},t.prototype.constructHuffmanTree=function(t,e,i,r,n){do{for(var s=t[0],h=t[--e],o=i[h],a=0,f=1;f<e;)f+1<e&&i[t[f]]>i[t[f+1]]&&f++,t[a]=t[f],f=2*(a=f)+1;for(;(f=a)>0&&i[t[a=Math.floor((f-1)/2)]]>o;)t[f]=t[a];t[f]=h;var u=t[0];n[2*(h=r++)]=s,n[2*h+1]=u;var d=Math.min(255&i[s],255&i[u]);for(i[h]=o=i[s]+i[u]-d+1,a=0,f=1;f<e;)f+1<e&&i[t[f]]>i[t[f+1]]&&f++,t[a]=t[f],f=2*(a=f)+1;for(;(f=a)>0&&i[t[a=Math.floor((f-1)/2)]]>o;)t[f]=t[a];t[f]=h}while(e>1)},t.prototype.buildLength=function(t){this.codeLength=new Uint8Array(this.codeFrequency.length);for(var e=Math.floor(t.length/2),i=Math.floor((e+1)/2),r=0,n=0;n<this.maxLength;n++)this.lengthCount[n]=0;if(0!==(r=this.calculateOptimalCodeLength(t,r,e))){var s=this.maxLength-1;do{for(;0===this.lengthCount[--s];);do{this.lengthCount[s]--,this.lengthCount[++s]++,r-=1<<this.maxLength-1-s}while(r>0&&s<this.maxLength-1)}while(r>0);this.recreateTree(t,r,i)}},t.prototype.recreateTree=function(t,e,i){this.lengthCount[this.maxLength-1]+=e,this.lengthCount[this.maxLength-2]-=e;for(var r=2*i,n=this.maxLength;0!==n;n--)for(var s=this.lengthCount[n-1];s>0;){var h=2*t[r++];-1===t[h+1]&&(this.codeLength[t[h]]=n,s--)}},t.prototype.calculateOptimalCodeLength=function(t,e,i){var r=new Int32Array(i);r[i-1]=0;for(var n=i-1;n>=0;n--){var s=2*n+1;if(-1!==t[s]){(h=r[n]+1)>this.maxLength&&(h=this.maxLength,e++),r[t[s-1]]=r[t[s]]=h}else{var h=r[n];this.lengthCount[h-1]++,this.codeLength[t[s-1]]=r[n]}}return e},t.reverseBits=[0,8,4,12,2,10,6,14,1,9,5,13,3,11,7,15],t.huffCodeLengthOrders=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],t}(),a=function(){function t(){}return t.checksumUpdate=function(e,i,r,n){var s=new Uint32Array(1);s[0]=e;for(var h=s[0],o=s[0]=65535&h,a=s[0]=h>>t.checkSumBitOffset;n>0;){var f=Math.min(n,t.checksumIterationCount);for(n-=f;--f>=0;)a+=o+=s[0]=255&i[r++];o%=t.checksumBase,a%=t.checksumBase}return h=a<<t.checkSumBitOffset|o},t.checkSumBitOffset=16,t.checksumBase=65521,t.checksumIterationCount=3800,t}(),f=[],u=function(){function t(){0===f.length&&t.initCrc32Table(),this.files=[],this.level="Normal",e.Save.isMicrosoftBrowser=!!navigator.msSaveBlob}return Object.defineProperty(t.prototype,"compressionLevel",{get:function(){return this.level},set:function(t){this.level=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"length",{get:function(){return void 0===this.files?0:this.files.length},enumerable:!0,configurable:!0}),t.prototype.addItem=function(t){if(null===t||void 0===t)throw new Error("ArgumentException: item cannot be null or undefined");for(var e=0;e<this.files.length;e++){var i=this.files[e];if(i instanceof d&&i.name===t.name)throw new Error("item with same name already exist")}this.files.push(t)},t.prototype.addDirectory=function(t){if(null===t||void 0===t)throw new Error("ArgumentException: string cannot be null or undefined");if(0===t.length)throw new Error("ArgumentException: string cannot be empty");if("/"!==t.slice(-1)&&(t+="/"),-1!==this.files.indexOf(t))throw new Error("item with same name already exist");this.files.push(t)},t.prototype.getItem=function(t){if(t>=0&&t<this.files.length)return this.files[t]},t.prototype.contains=function(t){return-1!==this.files.indexOf(t)},t.prototype.save=function(t){if(null===t||void 0===t||0===t.length)throw new Error("ArgumentException: fileName cannot be null or undefined");if(0===this.files.length)throw new Error("InvalidOperation");var e=this;return new Promise(function(i,r){e.saveInternal(t,!1).then(function(){i(e)})})},t.prototype.saveAsBlob=function(){var t=this;return new Promise(function(e,i){t.saveInternal("",!0).then(function(t){e(t)})})},t.prototype.saveInternal=function(t,e){var i=this,r=this;return new Promise(function(n,s){for(var h=[],o=0,a=0;a<r.files.length;a++){i.getCompressedData(i.files[a]).then(function(i){if(o=r.constructZippedObject(h,i,o,i.isDirectory),h.length===r.files.length){var s=r.writeZippedContent(t,h,o,e);n(s)}})}})},t.prototype.destroy=function(){if(void 0!==this.files&&this.files.length>0){for(var t=0;t<this.files.length;t++){var e=this.files[t];e instanceof d&&e.destroy(),e=void 0}this.files=[]}this.files=void 0,this.level=void 0},t.prototype.getCompressedData=function(t){var e=this;return new Promise(function(i,r){if(t instanceof d){var n=new FileReader;n.onload=function(){var r=new Uint8Array(n.result),s={fileName:t.name,crc32Value:0,compressedData:[],compressedSize:void 0,uncompressedDataSize:r.length,compressionType:void 0,isDirectory:!1};if("Normal"===e.level){e.compressData(r,s,f);for(var h=0,o=0;o<s.compressedData.length;o++)h+=s.compressedData[o].length;s.compressedSize=h,s.compressionType="\b\0"}else s.compressedSize=r.length,s.crc32Value=e.calculateCrc32Value(0,r,f),s.compressionType="\0\0",s.compressedData.push(r);i(s)},n.readAsArrayBuffer(t.data)}else{i({fileName:t,crc32Value:0,compressedData:"",compressedSize:0,uncompressedDataSize:0,compressionType:"\0\0",isDirectory:!0})}})},t.prototype.compressData=function(t,e,i){var r=new h(!0),n=0,s=0;do{if(n>=t.length){r.close();break}s=Math.min(t.length,n+16384);var o=t.subarray(n,s);e.crc32Value=this.calculateCrc32Value(e.crc32Value,o,i),r.write(o,0,s-n),n=s}while(n<=t.length);e.compressedData=r.compressedData,r.destroy()},t.prototype.constructZippedObject=function(t,e,i,r){var n=0,s=new Date;r&&(n|=16),n|=0;var h=this.writeHeader(e,s),o="PK"+h+e.fileName,a=this.writeCentralDirectory(e,h,i,n);return t.push({localHeader:o,centralDir:a,compressedData:e}),i+o.length+e.compressedSize},t.prototype.writeHeader=function(t,e){var i="";return i+="\n\0\0\0",i+=t.compressionType,i+=this.getBytes(this.getModifiedTime(e),2),i+=this.getBytes(this.getModifiedDate(e),2),i+=this.getBytes(t.crc32Value,4),i+=this.getBytes(t.compressedSize,4),i+=this.getBytes(t.uncompressedDataSize,4),i+=this.getBytes(t.fileName.length,2),i+=this.getBytes(0,2)},t.prototype.writeZippedContent=function(t,i,r,n){for(var s=0,h=[],o=0;o<i.length;o++){var a=i[o];for(s+=a.centralDir.length,h.push(this.getArrayBuffer(a.localHeader));a.compressedData.compressedData.length;)h.push(a.compressedData.compressedData.shift().buffer)}for(o=0;o<i.length;o++)h.push(this.getArrayBuffer(i[o].centralDir));h.push(this.getArrayBuffer(this.writeFooter(i,s,r)));var f=new Blob(h,{type:"application/zip"});return n||e.Save.save(t,f),f},t.prototype.writeCentralDirectory=function(t,e,i,r){return"PK"+this.getBytes(20,2)+e+this.getBytes(0,2)+"\0\0\0\0"+this.getBytes(r,4)+this.getBytes(i,4)+t.fileName},t.prototype.writeFooter=function(t,e,i){return"PK\0\0\0\0"+this.getBytes(t.length,2)+this.getBytes(t.length,2)+this.getBytes(e,4)+this.getBytes(i,4)+this.getBytes(0,2)},t.prototype.getArrayBuffer=function(t){for(var e=new Uint8Array(t.length),i=0;i<t.length;++i)e[i]=255&t.charCodeAt(i);return e.buffer},t.prototype.getBytes=function(t,e){for(var i="",r=0;r<e;r++)i+=String.fromCharCode(255&t),t>>>=8;return i},t.prototype.getModifiedTime=function(t){var e=t.getHours();return e<<=6,e|=t.getMinutes(),e<<=5,e|=t.getSeconds()/2},t.prototype.getModifiedDate=function(t){var e=t.getFullYear()-1980;return e<<=4,e|=t.getMonth()+1,e<<=5,e|=t.getDate()},t.prototype.calculateCrc32Value=function(t,e,i){t^=-1;for(var r=0;r<e.length;r++)t=t>>>8^i[255&(t^e[r])];return-1^t},t.initCrc32Table=function(){for(var t,e=0;e<256;e++){t=e;for(var i=0;i<8;i++)t=1&t?3988292384^t>>>1:t>>>1;f[e]=t}},t}(),d=function(){function t(t,e){if(null===t||void 0===t)throw new Error("ArgumentException: data cannot be null or undefined");if(null===e||void 0===e)throw new Error("ArgumentException: string cannot be null or undefined");if(0===e.length)throw new Error("string cannot be empty");this.data=t,this.name=e}return Object.defineProperty(t.prototype,"name",{get:function(){return this.fileName},set:function(t){this.fileName=t},enumerable:!0,configurable:!0}),t.prototype.destroy=function(){this.fileName=void 0,this.data=void 0},t}();t.ZipArchive=u,t.ZipArchiveItem=d,t.CompressedStreamWriter=h,t.CompressorHuffmanTree=o,t.ChecksumCalculator=a,Object.defineProperty(t,"__esModule",{value:!0})});
	//# sourceMappingURL=ej2-compression.umd.min.js.map


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	*  filename: ej2-file-utils.umd.min.js
	*  version : 19.4.52
	*  Copyright Syncfusion Inc. 2001 - 2020. All rights reserved.
	*  Use of this code is subject to the terms of our license.
	*  A copy of the current license can be obtained at any time by e-mailing
	*  licensing@syncfusion.com. Any infringement will be prosecuted under
	*  applicable laws. 
	*/
	!function(t,e){ true?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e(t.ej={})}(this,function(t){"use strict";function e(t,e){if(null===t||void 0===t)throw new Error("ArgumentException: "+e+" cannot be null or undefined")}var n=function(){function t(){}return t.save=function(t,e){if(null===t||void 0===t||""===t)throw new Error("ArgumentException: fileName cannot be undefined, null or empty");var n=t.substring(t.lastIndexOf(".")+1,t.length),i=this.getMimeType(n);if(""!==i&&(e=new Blob([e],{type:i})),this.isMicrosoftBrowser)navigator.msSaveBlob(e,t);else{var r=document.createElementNS("http://www.w3.org/1999/xhtml","a");this.saveInternal(t,n,e,r,"download"in r)}},t.saveInternal=function(t,e,n,i,r){if(r){i.download=t;var o=window.URL.createObjectURL(n);i.href=o;var s=document.createEvent("MouseEvent");s.initEvent("click",!0,!0),i.dispatchEvent(s),setTimeout(function(){window.URL.revokeObjectURL(o),o=void 0})}else if("docx"!==e&&"xlsx"!==e){var a=window.URL.createObjectURL(n);window.open(a,"_blank")||(window.location.href=a)}else{var c=new FileReader;c.onloadend=function(){window.open(c.result,"_blank")||(window.location.href=c.result)},c.readAsDataURL(n)}},t.getMimeType=function(t){var e="";switch(t){case"html":e="text/html";break;case"pdf":e="application/pdf";break;case"docx":e="application/vnd.openxmlformats-officedocument.wordprocessingml.document";break;case"xlsx":e="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";break;case"txt":e="text/plain"}return e},t}(),i=function(){function t(){this.contentPos=0,this.bufferText="",this.bufferBlob=new Blob([""],{type:"text/plain"}),this.currentState="Initial",this.namespaceStack=[],this.namespaceStack.push(new r),this.namespaceStack[0].set("xmlns","http://www.w3.org/2000/xmlns/","Special"),this.namespaceStack.push(new r),this.namespaceStack[1].set("xml","http://www.w3.org/XML/1998/namespace","Special"),this.namespaceStack.push(new r),this.namespaceStack[2].set("","","Implied"),this.elementStack=[],this.elementStack.push(new o),this.elementStack[0].set("","","",this.namespaceStack.length-1),this.attributeStack=[],n.isMicrosoftBrowser=!!navigator.msSaveBlob}return Object.defineProperty(t.prototype,"buffer",{get:function(){return this.flush(),this.bufferBlob},enumerable:!0,configurable:!0}),t.prototype.writeProcessingInstruction=function(t,e){if(void 0===t||null===t||0===t.length)throw new Error("ArgumentException: name should not be undefined, null or empty");if(this.checkName(t),void 0!==e&&null!==e||(e=""),3===t.length&&"xml"===t&&"Initial"!==this.currentState)throw new Error("InvalidArgumentException: Cannot write XML declaration.WriteStartDocument method has already written it");if("Initial"!==this.currentState||void 0===this.bufferBlob)throw new Error("InvalidOperationException: Wrong Token");this.writeStartDocument(),this.writeProcessingInstructionInternal(t,e)},t.prototype.writeStartDocument=function(t){if("Initial"!==this.currentState||void 0===this.bufferBlob)throw new Error("InvalidOperationException: Wrong Token");this.currentState="StartDocument",this.rawText('<?xml version="1.0" encoding="utf-8'),null!==t&&void 0!==t&&(this.rawText('" standalone="'),this.rawText(t?"yes":"no")),this.rawText('"?>')},t.prototype.writeEndDocument=function(){for(;this.elementStack.length-1>0;)this.writeEndElement();this.currentState="EndDocument",this.flush()},t.prototype.writeStartElement=function(t,e,n){if(void 0===this.bufferBlob)throw new Error("InvalidOperationException: Wrong Token");if(void 0===e||null===e||0===e.length)throw new Error("ArgumentException: localName cannot be undefined, null or empty");if(this.checkName(e),"Initial"===this.currentState&&this.writeStartDocument(),"StartElement"===this.currentState&&this.startElementContent(),this.currentState="StartElement",void 0===t||null===t)void 0!==n&&null!==n&&(t=this.lookupPrefix(n)),void 0!==t&&null!==t||(t="");else if(t.length>0&&(void 0!==n&&null!==n||(n=this.lookupNamespace(t)),void 0===n||null===n||void 0!==n&&0===n.length))throw new Error("ArgumentException: Cannot use a prefix with an empty namespace");void 0!==n&&null!==n||(n=this.lookupNamespace(t)),this.writeStartElementInternal(t,e,n)},t.prototype.writeEndElement=function(){"StartElement"===this.currentState?(this.startElementContent(),this.currentState="ElementContent"):"ElementContent"===this.currentState&&(this.currentState="ElementContent"),this.currentState="EndElement";var t=this.elementStack.length-1;this.writeEndElementInternal(this.elementStack[t].prefix,this.elementStack[t].localName),this.namespaceStack.splice(this.elementStack[t].previousTop+1),this.elementStack.splice(t),this.bufferText.length>10240&&this.flush()},t.prototype.writeElementString=function(t,e,n,i){this.writeStartElement(t,e,n),void 0!==i&&null!==i&&0!==i.length&&this.writeString(i),this.writeEndElement()},t.prototype.writeAttributeString=function(t,e,n,i){this.writeStartAttribute(t,e,n,i),this.writeStringInternal(i,!0),this.writeEndAttribute()},t.prototype.writeString=function(t){this.writeInternal(t,!1)},t.prototype.writeRaw=function(t){this.writeInternal(t,!0)},t.prototype.writeInternal=function(t,e){if(void 0!==t&&null!==t){if("StartElement"!==this.currentState&&"ElementContent"!==this.currentState)throw new Error("InvalidOperationException: Wrong Token");"StartElement"===this.currentState&&this.startElementContent(),this.currentState="ElementContent",e?this.rawText(t):this.writeStringInternal(t,!1)}},t.prototype.save=function(t){for(;this.elementStack.length-1>0;)this.writeEndElement();""!==this.bufferText&&this.flush(),n.save(t,this.buffer)},t.prototype.destroy=function(){this.bufferBlob=void 0;for(var t=0;t<this.namespaceStack.length;t++)this.namespaceStack[t].destroy();this.namespaceStack=[];for(t=0;t<this.elementStack.length;t++)this.elementStack[t].destroy();this.elementStack=[],this.bufferText="",this.contentPos=0},t.prototype.flush=function(){void 0!==this.bufferBlob&&(this.bufferBlob=new Blob([this.bufferBlob,this.bufferText],{type:"text/plain"}),this.bufferText="")},t.prototype.writeProcessingInstructionInternal=function(t,e){this.bufferText+="<?",this.rawText(t),e.length>0&&(this.bufferText+=" ",e=e.replace(/\?\>/g,"? >"),this.bufferText+=e),this.bufferText+="?",this.bufferText+=">"},t.prototype.writeStartAttribute=function(t,e,n,i){if(void 0===e||null===e||0===e.length){if("xmlns"!==t)throw new Error("ArgumentException: localName cannot be undefined, null or empty");e="xmlns",t=""}if("StartElement"!==this.currentState)throw new Error("InvalidOperationException: Wrong Token");this.checkName(e),this.writeStartAttributePrefixAndNameSpace(t,e,n,i)},t.prototype.writeStartAttributePrefixAndNameSpace=function(t,e,n,i){void 0!==t&&null!==t||(void 0!==n&&null!==n&&("xmlns"===e&&"http://www.w3.org/2000/xmlns/"===n||(t=this.lookupPrefix(n))),void 0!==t&&null!==t||(t="")),void 0!==n&&null!==n||(void 0!==t&&null!==t&&t.length>0&&(n=this.lookupNamespace(t)),void 0!==n&&null!==n||(n="")),this.writeStartAttributeSpecialAttribute(t,e,n,i)},t.prototype.writeStartAttributeSpecialAttribute=function(t,e,n,i){if(0===t.length){if("x"===e[0]&&"xmlns"===e)return this.skipPushAndWrite(t,e,n),void this.pushNamespaceExplicit("",i);n.length>0&&(t=this.lookupPrefix(n))}else{if("x"===t[0]){if("xmlns"===t)return this.skipPushAndWrite(t,e,n),void this.pushNamespaceExplicit(e,i);if("xml"===t&&("space"===e||"lang"===e))return void this.skipPushAndWrite(t,e,n)}0===n.length&&(t="")}void 0!==t&&null!==t&&0!==t.length&&this.pushNamespaceImplicit(t,n),this.skipPushAndWrite(t,e,n)},t.prototype.writeEndAttribute=function(){this.currentState="StartElement",this.bufferText+='"'},t.prototype.writeStartElementInternal=function(t,e,n){this.bufferText+="<",t.length>0&&(this.rawText(t),this.bufferText+=":"),this.rawText(e);var i=this.elementStack.length;this.elementStack.push(new o),this.elementStack[i].set(t,e,n,this.namespaceStack.length-1),this.pushNamespaceImplicit(t,n);for(var r=0;r<this.attributeStack.length;r++)this.attributeStack[r].destroy();this.attributeStack=[]},t.prototype.writeEndElementInternal=function(t,e){this.contentPos!==this.bufferText.length+1?(this.bufferText+="</",void 0!==t&&null!==t&&0!==t.length&&(this.rawText(t),this.bufferText+=":"),this.rawText(e),this.bufferText+=">"):(this.bufferText=this.bufferText.substring(0,this.bufferText.length-1),this.bufferText+=" />")},t.prototype.writeStartAttributeInternal=function(t,e,n){this.bufferText+=" ",void 0!==t&&null!==t&&t.length>0&&(this.rawText(t),this.bufferText+=":"),this.rawText(e),this.bufferText+="=",this.bufferText+='"'},t.prototype.writeNamespaceDeclaration=function(t,e){this.writeStartNamespaceDeclaration(t),this.writeStringInternal(e,!0),this.bufferText+='"'},t.prototype.writeStartNamespaceDeclaration=function(t){void 0===t||null===t||0===t.length?this.rawText(' xmlns="'):(this.rawText(" xmlns:"),this.rawText(t),this.bufferText+="=",this.bufferText+='"')},t.prototype.writeStringInternal=function(t,e){null!==t&&void 0!==t||(t=""),t=(t=(t=t.replace(/\&/g,"&amp;")).replace(/\</g,"&lt;")).replace(/\>/g,"&gt;"),e&&(t=t.replace(/\"/g,"&quot;")),this.bufferText+=t,e||(this.contentPos=0)},t.prototype.startElementContent=function(){for(var t=this.elementStack[this.elementStack.length-1].previousTop,e=this.namespaceStack.length-1;e>t;e--)"NeedToWrite"===this.namespaceStack[e].kind&&this.writeNamespaceDeclaration(this.namespaceStack[e].prefix,this.namespaceStack[e].namespaceUri);this.bufferText+=">",this.contentPos=this.bufferText.length+1},t.prototype.rawText=function(t){this.bufferText+=t},t.prototype.addNamespace=function(t,e,n){var i=this.namespaceStack.length;this.namespaceStack.push(new r),this.namespaceStack[i].set(t,e,n)},t.prototype.lookupPrefix=function(t){for(var e=this.namespaceStack.length-1;e>=0;e--)if(this.namespaceStack[e].namespaceUri===t)return this.namespaceStack[e].prefix},t.prototype.lookupNamespace=function(t){for(var e=this.namespaceStack.length-1;e>=0;e--)if(this.namespaceStack[e].prefix===t)return this.namespaceStack[e].namespaceUri},t.prototype.lookupNamespaceIndex=function(t){for(var e=this.namespaceStack.length-1;e>=0;e--)if(this.namespaceStack[e].prefix===t)return e;return-1},t.prototype.pushNamespaceImplicit=function(t,e){var n,i=this.lookupNamespaceIndex(t);if(-1!==i){if(i>this.elementStack[this.elementStack.length-1].previousTop){if(this.namespaceStack[i].namespaceUri!==e)throw new Error("XmlException namespace Uri needs to be the same as the one that is already declared");return}if("Special"===this.namespaceStack[i].kind){if("xml"!==t)throw new Error('InvalidArgumentException: Prefix "xmlns" is reserved for use by XML.');if(e!==this.namespaceStack[i].namespaceUri)throw new Error("InvalidArgumentException: Xml String");n="Implied"}else n=this.namespaceStack[i].namespaceUri===e?"Implied":"NeedToWrite"}else{if("http://www.w3.org/XML/1998/namespace"===e&&"xml"!==t||"http://www.w3.org/2000/xmlns/"===e&&"xmlns"!==t)throw new Error("InvalidArgumentException");n="NeedToWrite"}this.addNamespace(t,e,n)},t.prototype.pushNamespaceExplicit=function(t,e){var n=this.lookupNamespaceIndex(t);-1!==n&&n>this.elementStack[this.elementStack.length-1].previousTop?this.namespaceStack[n].kind="Written":this.addNamespace(t,e,"Written")},t.prototype.addAttribute=function(t,e,n){var i=this.attributeStack.length;this.attributeStack.push(new s),this.attributeStack[i].set(t,e,n);for(var r=0;r<i;r++)if(this.attributeStack[r].isDuplicate(t,e,n))throw new Error("XmlException: duplicate attribute name")},t.prototype.skipPushAndWrite=function(t,e,n){this.addAttribute(t,e,n),this.writeStartAttributeInternal(t,e,n)},t.prototype.checkName=function(t){if(/[ !@#$%^&*()+\=\[\]{};':"\\|,<>\/?]/.test(t))throw new Error("InvalidArgumentException: invalid name character")},t}(),r=function(){function t(){}return t.prototype.set=function(t,e,n){this.prefix=t,this.namespaceUri=e,this.kind=n},t.prototype.destroy=function(){this.prefix=void 0,this.namespaceUri=void 0,this.kind=void 0},t}(),o=function(){function t(){}return t.prototype.set=function(t,e,n,i){this.previousTop=i,this.prefix=t,this.namespaceUri=n,this.localName=e},t.prototype.destroy=function(){this.previousTop=void 0,this.prefix=void 0,this.localName=void 0,this.namespaceUri=void 0},t}(),s=function(){function t(){}return t.prototype.set=function(t,e,n){this.prefix=t,this.namespaceUri=n,this.localName=e},t.prototype.isDuplicate=function(t,e,n){return this.localName===e&&(this.prefix===t||this.namespaceUri===n)},t.prototype.destroy=function(){this.prefix=void 0,this.namespaceUri=void 0,this.localName=void 0},t}(),a=function(){function t(t){this.emitBOM=!0,this.encodingType="Ansi",this.initBOM(t)}return Object.defineProperty(t.prototype,"includeBom",{get:function(){return this.emitBOM},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"type",{get:function(){return this.encodingType},set:function(t){this.encodingType=t},enumerable:!0,configurable:!0}),t.prototype.initBOM=function(t){this.emitBOM=void 0===t||null===t||t},t.prototype.getByteCount=function(t){if(e(t,"string"),""===t){return this.utf8Len(t.charCodeAt(0))}return null!==this.type&&void 0!==this.type||(this.type="Ansi"),this.getByteCountInternal(t,0,t.length)},t.prototype.utf8Len=function(t){return t<=127?1:t<=2047?2:t<=65535?3:t<=2097151?4:0},t.prototype.isHighSurrogate=function(t){return t>=55296&&t<=56319},t.prototype.toCodepoint=function(t,e){return((t=(1023&t)<<10)|1023&e)+65536},t.prototype.getByteCountInternal=function(t,e,n){var i=0;if("Utf8"===this.encodingType||"Unicode"===this.encodingType){for(var r="Utf8"===this.encodingType,o=0;o<n;o++){var s=t.charCodeAt(r?e:e++);if(this.isHighSurrogate(s))if(r){var a=s,c=t.charCodeAt(++e);i+=this.utf8Len(this.toCodepoint(a,c))}else i+=4,++o;else i+=r?this.utf8Len(s):2;r&&e++}return i}return i=n},t.prototype.getBytes=function(t,n,i){if(e(t,"string"),e(n,"charIndex"),e(i,"charCount"),n<0||i<0)throw new RangeError("Argument Out Of Range Exception: charIndex or charCount is less than zero");if(t.length-n<i)throw new RangeError("Argument Out Of Range Exception: charIndex and charCount do not denote a valid range in string");if(""===t)return new ArrayBuffer(0);null!==this.type&&void 0!==this.type||(this.type="Ansi");var r=this.getByteCountInternal(t,n,i);switch(this.type){case"Utf8":return this.getBytesOfUtf8Encoding(r,t,n,i);case"Unicode":return this.getBytesOfUnicodeEncoding(r,t,n,i);default:return this.getBytesOfAnsiEncoding(r,t,n,i)}},t.prototype.getString=function(t,n,i){if(e(t,"bytes"),e(n,"index"),e(i,"count"),n<0||i<0)throw new RangeError("Argument Out Of Range Exception: index or count is less than zero");if(t.byteLength-n<i)throw new RangeError("Argument Out Of Range Exception: index and count do not denote a valid range in bytes");if(0===t.byteLength||0===i)return"";null!==this.type&&void 0!==this.type||(this.type="Ansi");var r="",o=new Uint8Array(t);switch(this.type){case"Utf8":return this.getStringOfUtf8Encoding(o,n,i);case"Unicode":var s=new Uint16Array(t);return r=this.getStringofUnicodeEncoding(s,n,i);default:for(var a=n,c=0;c<i;c++){var h=o[a];r+=String.fromCharCode(h),a++}return r}},t.prototype.getBytesOfAnsiEncoding=function(t,e,n,i){for(var r=new ArrayBuffer(t),o=new Uint8Array(r),s=0,a=0;a<i;a++){var c=e.charCodeAt(n++);o[s]=c<2048?c:63,s++}return r},t.prototype.getBytesOfUtf8Encoding=function(t,e,n,i){for(var r=new ArrayBuffer(t),o=new Uint8Array(r),s=n,a=0,c=0;c<i;c++){var h=e.charCodeAt(s);h<=127?o[a]=h:h<2048?(o[a]=192|h>>6,o[++a]=128|63&h):h<55296||h>=57344?(o[a]=224|h>>12,o[++a]=128|h>>6&63,o[++a]=128|63&h):(o[a]=239,o[++a]=191,o[++a]=189),++a,++s}return r},t.prototype.getBytesOfUnicodeEncoding=function(t,e,n,i){for(var r=new ArrayBuffer(t),o=new Uint16Array(r),s=0;s<i;s++){var a=e.charCodeAt(s);o[s]=a}return r},t.prototype.getStringOfUtf8Encoding=function(t,e,n){for(var i=0,r=e,o="";i<n;i++){for(var s=t[r++];r>t.length;)return o;s>127&&(s>191&&s<224&&r<n?s=(31&s)<<6|63&t[r]:s>223&&s<240&&r<t.byteLength?s=(15&s)<<12|(63&t[r])<<6|63&t[++r]:s>239&&s<248&&r<t.byteLength&&(s=(7&s)<<18|(63&t[r])<<12|(63&t[++r])<<6|63&t[++r]),++r),o+=String.fromCharCode(s)}return o},t.prototype.getStringofUnicodeEncoding=function(t,e,n){if(n>t.length)throw new RangeError("ArgumentOutOfRange_Count");for(var i=new Uint16Array(n),r=0;r<n&&r<t.length;r++)i[r]=t[e++];return String.fromCharCode.apply(null,i)},t.prototype.destroy=function(){this.emitBOM=void 0,this.encodingType=void 0},t}(),c=function(){function t(t){this.bufferBlob=new Blob([""]),this.bufferText="",this.init(t),n.isMicrosoftBrowser=!!navigator.msSaveBlob}return Object.defineProperty(t.prototype,"buffer",{get:function(){return this.flush(),this.bufferBlob},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"encoding",{get:function(){return this.enc},enumerable:!0,configurable:!0}),t.prototype.init=function(t){null===t||void 0===t?(this.enc=new a(!1),this.enc.type="Utf8"):(this.enc=t,this.setBomByte())},t.prototype.setBomByte=function(){if(this.encoding.includeBom)switch(this.encoding.type){case"Unicode":var t=new ArrayBuffer(2),e=new Uint8Array(t);e[0]=255,e[1]=254,this.bufferBlob=new Blob([t]);break;case"Utf8":var n=new ArrayBuffer(3),i=new Uint8Array(n);i[0]=239,i[1]=187,i[2]=191,this.bufferBlob=new Blob([n]);break;default:this.bufferBlob=new Blob([""])}},t.prototype.save=function(t){""!==this.bufferText&&this.flush(),n.save(t,this.buffer)},t.prototype.write=function(t){if(void 0===this.encoding)throw new Error("Object Disposed Exception: current writer is disposed");e(t,"string"),this.bufferText+=t,this.bufferText.length>=10240&&this.flush()},t.prototype.flush=function(){if(void 0!==this.bufferText&&null!==this.bufferText&&0!==this.bufferText.length){var t=this.encoding.getBytes(this.bufferText,0,this.bufferText.length);this.bufferText="",this.bufferBlob=new Blob([this.bufferBlob,t])}},t.prototype.writeLine=function(t){if(void 0===this.encoding)throw new Error("Object Disposed Exception: current writer is disposed");e(t,"string"),this.bufferText=this.bufferText+t+"\r\n",this.bufferText.length>=10240&&this.flush()},t.prototype.destroy=function(){this.bufferBlob=void 0,this.bufferText=void 0,this.enc instanceof a&&this.enc.destroy(),this.enc=void 0},t}();t.XmlWriter=i,t.Namespace=r,t.XmlElement=o,t.XmlAttribute=s,t.StreamWriter=c,t.Encoding=a,t.validateNullOrUndefined=e,t.Save=n,Object.defineProperty(t,"__esModule",{value:!0})});
	//# sourceMappingURL=ej2-file-utils.umd.min.js.map


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _ahmed = __webpack_require__(821);
	
	var _ahmed2 = _interopRequireDefault(_ahmed);
	
	var _Ahmed = __webpack_require__(820);
	
	var _Ahmed2 = _interopRequireDefault(_Ahmed);
	
	var _firebase = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Testimonial = function (_Component) {
	  _inherits(Testimonial, _Component);
	
	  function Testimonial(props) {
	    _classCallCheck(this, Testimonial);
	
	    var _this = _possibleConstructorReturn(this, (Testimonial.__proto__ || Object.getPrototypeOf(Testimonial)).call(this, props));
	
	    _this.state = {
	      testimonialData: []
	    };
	    return _this;
	  }
	
	  _createClass(Testimonial, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderList();
	    }
	  }, {
	    key: 'renderList',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var dataList, dataListCategory;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                dataList = [];
	                dataListCategory = [];
	                _context.next = 4;
	                return _firebase.database.ref("testimonials").once('value', function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    if (ChildSnapshot.val().status == 'Active') {
	                      dataList.push({
	                        key: ChildSnapshot.key,
	                        testiAuthor: ChildSnapshot.val().author,
	                        testiImage: ChildSnapshot.val().imageUrl,
	                        testiVideo: ChildSnapshot.val().videoUrl
	                      });
	                    }
	                  });
	                });
	
	              case 4:
	                this.setState({
	                  testimonialData: dataList
	
	                });
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function renderList() {
	        return _ref.apply(this, arguments);
	      }
	
	      return renderList;
	    }()
	  }, {
	    key: 'testimonialPopup',
	    value: function testimonialPopup(fileName) {
	
	      (0, _jquery2.default)('#upFileAboutVideoAdd').val(fileName);
	      this.setState({
	        videoTestimonial: fileName
	      });
	      (0, _jquery2.default)("body").addClass("modal-open");
	      (0, _jquery2.default)("#testimonialPopup").addClass("show");
	      (0, _jquery2.default)(".modal").show();
	      (0, _jquery2.default)('.modal-backdrop').add();
	      (0, _jquery2.default)("#testimonialPopup video").show();
	      (0, _jquery2.default)('body').append('<div class="modal-backdrop fade show"></div>');
	    }
	  }, {
	    key: 'closePopup',
	    value: function closePopup() {
	      this.setState({
	        videoTestimonial: ""
	      });
	      (0, _jquery2.default)('#upFileAboutVideoAdd').val("");
	      (0, _jquery2.default)("body").removeClass("modal-open");
	      (0, _jquery2.default)(".modal").removeClass("show");
	      (0, _jquery2.default)(".modal").hide();
	      (0, _jquery2.default)('.modal-backdrop').remove();
	      (0, _jquery2.default)("#testimonialPopup video").hide();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'testimonial-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'testimonial-panel' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'home-head' },
	                  ' Testimonial',
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Our learners send us bunch of smiles with their experiences and we love them!'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'testimonial-body' },
	                  this.state.testimonialData.map(function (data, i) {
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'testimonial-box' },
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'testimonial-box-a', onClick: function onClick() {
	                            return _this2.testimonialPopup(data.testiVideo);
	                          } },
	                        _react2.default.createElement('img', { alt: '', className: 'testimonial-img', src: data.testiImage }),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'testimonial-box-text' },
	                          data.testiAuthor
	                        )
	                      )
	                    );
	                  })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'modal fade testPopup bd-example-modal-lg', id: 'testimonialPopup', tabindex: '-1', role: 'dialog', 'aria-labelledby': 'exampleModalLabel', 'aria-hidden': 'true' },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-dialog modal-lg', role: 'document' },
	            _react2.default.createElement(
	              'div',
	              { className: 'modal-content' },
	              _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-label': 'Close', onClick: function onClick() {
	                    return _this2.closePopup();
	                  } },
	                _react2.default.createElement(
	                  'span',
	                  { 'aria-hidden': 'true' },
	                  '\xD7'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'modal-body text-center' },
	                _react2.default.createElement('video', { src: this.state.videoTestimonial, autoplay: 'autoplay', controls: 'controls', id: 'upFileAboutVideoAdd', controlslist: 'nodownload' })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Testimonial;
	}(_react.Component);
	
	exports.default = Testimonial;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(608)
	var ieee754 = __webpack_require__(656)
	var isArray = __webpack_require__(658)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(78));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("css", function(config, parserConfig) {
	  var inline = parserConfig.inline
	  if (!parserConfig.propertyKeywords) parserConfig = CodeMirror.resolveMode("text/css");
	
	  var indentUnit = config.indentUnit,
	      tokenHooks = parserConfig.tokenHooks,
	      documentTypes = parserConfig.documentTypes || {},
	      mediaTypes = parserConfig.mediaTypes || {},
	      mediaFeatures = parserConfig.mediaFeatures || {},
	      mediaValueKeywords = parserConfig.mediaValueKeywords || {},
	      propertyKeywords = parserConfig.propertyKeywords || {},
	      nonStandardPropertyKeywords = parserConfig.nonStandardPropertyKeywords || {},
	      fontProperties = parserConfig.fontProperties || {},
	      counterDescriptors = parserConfig.counterDescriptors || {},
	      colorKeywords = parserConfig.colorKeywords || {},
	      valueKeywords = parserConfig.valueKeywords || {},
	      allowNested = parserConfig.allowNested,
	      lineComment = parserConfig.lineComment,
	      supportsAtComponent = parserConfig.supportsAtComponent === true,
	      highlightNonStandardPropertyKeywords = config.highlightNonStandardPropertyKeywords !== false;
	
	  var type, override;
	  function ret(style, tp) { type = tp; return style; }
	
	  // Tokenizers
	
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	    if (tokenHooks[ch]) {
	      var result = tokenHooks[ch](stream, state);
	      if (result !== false) return result;
	    }
	    if (ch == "@") {
	      stream.eatWhile(/[\w\\\-]/);
	      return ret("def", stream.current());
	    } else if (ch == "=" || (ch == "~" || ch == "|") && stream.eat("=")) {
	      return ret(null, "compare");
	    } else if (ch == "\"" || ch == "'") {
	      state.tokenize = tokenString(ch);
	      return state.tokenize(stream, state);
	    } else if (ch == "#") {
	      stream.eatWhile(/[\w\\\-]/);
	      return ret("atom", "hash");
	    } else if (ch == "!") {
	      stream.match(/^\s*\w*/);
	      return ret("keyword", "important");
	    } else if (/\d/.test(ch) || ch == "." && stream.eat(/\d/)) {
	      stream.eatWhile(/[\w.%]/);
	      return ret("number", "unit");
	    } else if (ch === "-") {
	      if (/[\d.]/.test(stream.peek())) {
	        stream.eatWhile(/[\w.%]/);
	        return ret("number", "unit");
	      } else if (stream.match(/^-[\w\\\-]*/)) {
	        stream.eatWhile(/[\w\\\-]/);
	        if (stream.match(/^\s*:/, false))
	          return ret("variable-2", "variable-definition");
	        return ret("variable-2", "variable");
	      } else if (stream.match(/^\w+-/)) {
	        return ret("meta", "meta");
	      }
	    } else if (/[,+>*\/]/.test(ch)) {
	      return ret(null, "select-op");
	    } else if (ch == "." && stream.match(/^-?[_a-z][_a-z0-9-]*/i)) {
	      return ret("qualifier", "qualifier");
	    } else if (/[:;{}\[\]\(\)]/.test(ch)) {
	      return ret(null, ch);
	    } else if (stream.match(/^[\w-.]+(?=\()/)) {
	      if (/^(url(-prefix)?|domain|regexp)$/i.test(stream.current())) {
	        state.tokenize = tokenParenthesized;
	      }
	      return ret("variable callee", "variable");
	    } else if (/[\w\\\-]/.test(ch)) {
	      stream.eatWhile(/[\w\\\-]/);
	      return ret("property", "word");
	    } else {
	      return ret(null, null);
	    }
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var escaped = false, ch;
	      while ((ch = stream.next()) != null) {
	        if (ch == quote && !escaped) {
	          if (quote == ")") stream.backUp(1);
	          break;
	        }
	        escaped = !escaped && ch == "\\";
	      }
	      if (ch == quote || !escaped && quote != ")") state.tokenize = null;
	      return ret("string", "string");
	    };
	  }
	
	  function tokenParenthesized(stream, state) {
	    stream.next(); // Must be '('
	    if (!stream.match(/^\s*[\"\')]/, false))
	      state.tokenize = tokenString(")");
	    else
	      state.tokenize = null;
	    return ret(null, "(");
	  }
	
	  // Context management
	
	  function Context(type, indent, prev) {
	    this.type = type;
	    this.indent = indent;
	    this.prev = prev;
	  }
	
	  function pushContext(state, stream, type, indent) {
	    state.context = new Context(type, stream.indentation() + (indent === false ? 0 : indentUnit), state.context);
	    return type;
	  }
	
	  function popContext(state) {
	    if (state.context.prev)
	      state.context = state.context.prev;
	    return state.context.type;
	  }
	
	  function pass(type, stream, state) {
	    return states[state.context.type](type, stream, state);
	  }
	  function popAndPass(type, stream, state, n) {
	    for (var i = n || 1; i > 0; i--)
	      state.context = state.context.prev;
	    return pass(type, stream, state);
	  }
	
	  // Parser
	
	  function wordAsValue(stream) {
	    var word = stream.current().toLowerCase();
	    if (valueKeywords.hasOwnProperty(word))
	      override = "atom";
	    else if (colorKeywords.hasOwnProperty(word))
	      override = "keyword";
	    else
	      override = "variable";
	  }
	
	  var states = {};
	
	  states.top = function(type, stream, state) {
	    if (type == "{") {
	      return pushContext(state, stream, "block");
	    } else if (type == "}" && state.context.prev) {
	      return popContext(state);
	    } else if (supportsAtComponent && /@component/i.test(type)) {
	      return pushContext(state, stream, "atComponentBlock");
	    } else if (/^@(-moz-)?document$/i.test(type)) {
	      return pushContext(state, stream, "documentTypes");
	    } else if (/^@(media|supports|(-moz-)?document|import)$/i.test(type)) {
	      return pushContext(state, stream, "atBlock");
	    } else if (/^@(font-face|counter-style)/i.test(type)) {
	      state.stateArg = type;
	      return "restricted_atBlock_before";
	    } else if (/^@(-(moz|ms|o|webkit)-)?keyframes$/i.test(type)) {
	      return "keyframes";
	    } else if (type && type.charAt(0) == "@") {
	      return pushContext(state, stream, "at");
	    } else if (type == "hash") {
	      override = "builtin";
	    } else if (type == "word") {
	      override = "tag";
	    } else if (type == "variable-definition") {
	      return "maybeprop";
	    } else if (type == "interpolation") {
	      return pushContext(state, stream, "interpolation");
	    } else if (type == ":") {
	      return "pseudo";
	    } else if (allowNested && type == "(") {
	      return pushContext(state, stream, "parens");
	    }
	    return state.context.type;
	  };
	
	  states.block = function(type, stream, state) {
	    if (type == "word") {
	      var word = stream.current().toLowerCase();
	      if (propertyKeywords.hasOwnProperty(word)) {
	        override = "property";
	        return "maybeprop";
	      } else if (nonStandardPropertyKeywords.hasOwnProperty(word)) {
	        override = highlightNonStandardPropertyKeywords ? "string-2" : "property";
	        return "maybeprop";
	      } else if (allowNested) {
	        override = stream.match(/^\s*:(?:\s|$)/, false) ? "property" : "tag";
	        return "block";
	      } else {
	        override += " error";
	        return "maybeprop";
	      }
	    } else if (type == "meta") {
	      return "block";
	    } else if (!allowNested && (type == "hash" || type == "qualifier")) {
	      override = "error";
	      return "block";
	    } else {
	      return states.top(type, stream, state);
	    }
	  };
	
	  states.maybeprop = function(type, stream, state) {
	    if (type == ":") return pushContext(state, stream, "prop");
	    return pass(type, stream, state);
	  };
	
	  states.prop = function(type, stream, state) {
	    if (type == ";") return popContext(state);
	    if (type == "{" && allowNested) return pushContext(state, stream, "propBlock");
	    if (type == "}" || type == "{") return popAndPass(type, stream, state);
	    if (type == "(") return pushContext(state, stream, "parens");
	
	    if (type == "hash" && !/^#([0-9a-fA-f]{3,4}|[0-9a-fA-f]{6}|[0-9a-fA-f]{8})$/.test(stream.current())) {
	      override += " error";
	    } else if (type == "word") {
	      wordAsValue(stream);
	    } else if (type == "interpolation") {
	      return pushContext(state, stream, "interpolation");
	    }
	    return "prop";
	  };
	
	  states.propBlock = function(type, _stream, state) {
	    if (type == "}") return popContext(state);
	    if (type == "word") { override = "property"; return "maybeprop"; }
	    return state.context.type;
	  };
	
	  states.parens = function(type, stream, state) {
	    if (type == "{" || type == "}") return popAndPass(type, stream, state);
	    if (type == ")") return popContext(state);
	    if (type == "(") return pushContext(state, stream, "parens");
	    if (type == "interpolation") return pushContext(state, stream, "interpolation");
	    if (type == "word") wordAsValue(stream);
	    return "parens";
	  };
	
	  states.pseudo = function(type, stream, state) {
	    if (type == "meta") return "pseudo";
	
	    if (type == "word") {
	      override = "variable-3";
	      return state.context.type;
	    }
	    return pass(type, stream, state);
	  };
	
	  states.documentTypes = function(type, stream, state) {
	    if (type == "word" && documentTypes.hasOwnProperty(stream.current())) {
	      override = "tag";
	      return state.context.type;
	    } else {
	      return states.atBlock(type, stream, state);
	    }
	  };
	
	  states.atBlock = function(type, stream, state) {
	    if (type == "(") return pushContext(state, stream, "atBlock_parens");
	    if (type == "}" || type == ";") return popAndPass(type, stream, state);
	    if (type == "{") return popContext(state) && pushContext(state, stream, allowNested ? "block" : "top");
	
	    if (type == "interpolation") return pushContext(state, stream, "interpolation");
	
	    if (type == "word") {
	      var word = stream.current().toLowerCase();
	      if (word == "only" || word == "not" || word == "and" || word == "or")
	        override = "keyword";
	      else if (mediaTypes.hasOwnProperty(word))
	        override = "attribute";
	      else if (mediaFeatures.hasOwnProperty(word))
	        override = "property";
	      else if (mediaValueKeywords.hasOwnProperty(word))
	        override = "keyword";
	      else if (propertyKeywords.hasOwnProperty(word))
	        override = "property";
	      else if (nonStandardPropertyKeywords.hasOwnProperty(word))
	        override = highlightNonStandardPropertyKeywords ? "string-2" : "property";
	      else if (valueKeywords.hasOwnProperty(word))
	        override = "atom";
	      else if (colorKeywords.hasOwnProperty(word))
	        override = "keyword";
	      else
	        override = "error";
	    }
	    return state.context.type;
	  };
	
	  states.atComponentBlock = function(type, stream, state) {
	    if (type == "}")
	      return popAndPass(type, stream, state);
	    if (type == "{")
	      return popContext(state) && pushContext(state, stream, allowNested ? "block" : "top", false);
	    if (type == "word")
	      override = "error";
	    return state.context.type;
	  };
	
	  states.atBlock_parens = function(type, stream, state) {
	    if (type == ")") return popContext(state);
	    if (type == "{" || type == "}") return popAndPass(type, stream, state, 2);
	    return states.atBlock(type, stream, state);
	  };
	
	  states.restricted_atBlock_before = function(type, stream, state) {
	    if (type == "{")
	      return pushContext(state, stream, "restricted_atBlock");
	    if (type == "word" && state.stateArg == "@counter-style") {
	      override = "variable";
	      return "restricted_atBlock_before";
	    }
	    return pass(type, stream, state);
	  };
	
	  states.restricted_atBlock = function(type, stream, state) {
	    if (type == "}") {
	      state.stateArg = null;
	      return popContext(state);
	    }
	    if (type == "word") {
	      if ((state.stateArg == "@font-face" && !fontProperties.hasOwnProperty(stream.current().toLowerCase())) ||
	          (state.stateArg == "@counter-style" && !counterDescriptors.hasOwnProperty(stream.current().toLowerCase())))
	        override = "error";
	      else
	        override = "property";
	      return "maybeprop";
	    }
	    return "restricted_atBlock";
	  };
	
	  states.keyframes = function(type, stream, state) {
	    if (type == "word") { override = "variable"; return "keyframes"; }
	    if (type == "{") return pushContext(state, stream, "top");
	    return pass(type, stream, state);
	  };
	
	  states.at = function(type, stream, state) {
	    if (type == ";") return popContext(state);
	    if (type == "{" || type == "}") return popAndPass(type, stream, state);
	    if (type == "word") override = "tag";
	    else if (type == "hash") override = "builtin";
	    return "at";
	  };
	
	  states.interpolation = function(type, stream, state) {
	    if (type == "}") return popContext(state);
	    if (type == "{" || type == ";") return popAndPass(type, stream, state);
	    if (type == "word") override = "variable";
	    else if (type != "variable" && type != "(" && type != ")") override = "error";
	    return "interpolation";
	  };
	
	  return {
	    startState: function(base) {
	      return {tokenize: null,
	              state: inline ? "block" : "top",
	              stateArg: null,
	              context: new Context(inline ? "block" : "top", base || 0, null)};
	    },
	
	    token: function(stream, state) {
	      if (!state.tokenize && stream.eatSpace()) return null;
	      var style = (state.tokenize || tokenBase)(stream, state);
	      if (style && typeof style == "object") {
	        type = style[1];
	        style = style[0];
	      }
	      override = style;
	      if (type != "comment")
	        state.state = states[state.state](type, stream, state);
	      return override;
	    },
	
	    indent: function(state, textAfter) {
	      var cx = state.context, ch = textAfter && textAfter.charAt(0);
	      var indent = cx.indent;
	      if (cx.type == "prop" && (ch == "}" || ch == ")")) cx = cx.prev;
	      if (cx.prev) {
	        if (ch == "}" && (cx.type == "block" || cx.type == "top" ||
	                          cx.type == "interpolation" || cx.type == "restricted_atBlock")) {
	          // Resume indentation from parent context.
	          cx = cx.prev;
	          indent = cx.indent;
	        } else if (ch == ")" && (cx.type == "parens" || cx.type == "atBlock_parens") ||
	            ch == "{" && (cx.type == "at" || cx.type == "atBlock")) {
	          // Dedent relative to current context.
	          indent = Math.max(0, cx.indent - indentUnit);
	        }
	      }
	      return indent;
	    },
	
	    electricChars: "}",
	    blockCommentStart: "/*",
	    blockCommentEnd: "*/",
	    blockCommentContinue: " * ",
	    lineComment: lineComment,
	    fold: "brace"
	  };
	});
	
	  function keySet(array) {
	    var keys = {};
	    for (var i = 0; i < array.length; ++i) {
	      keys[array[i].toLowerCase()] = true;
	    }
	    return keys;
	  }
	
	  var documentTypes_ = [
	    "domain", "regexp", "url", "url-prefix"
	  ], documentTypes = keySet(documentTypes_);
	
	  var mediaTypes_ = [
	    "all", "aural", "braille", "handheld", "print", "projection", "screen",
	    "tty", "tv", "embossed"
	  ], mediaTypes = keySet(mediaTypes_);
	
	  var mediaFeatures_ = [
	    "width", "min-width", "max-width", "height", "min-height", "max-height",
	    "device-width", "min-device-width", "max-device-width", "device-height",
	    "min-device-height", "max-device-height", "aspect-ratio",
	    "min-aspect-ratio", "max-aspect-ratio", "device-aspect-ratio",
	    "min-device-aspect-ratio", "max-device-aspect-ratio", "color", "min-color",
	    "max-color", "color-index", "min-color-index", "max-color-index",
	    "monochrome", "min-monochrome", "max-monochrome", "resolution",
	    "min-resolution", "max-resolution", "scan", "grid", "orientation",
	    "device-pixel-ratio", "min-device-pixel-ratio", "max-device-pixel-ratio",
	    "pointer", "any-pointer", "hover", "any-hover", "prefers-color-scheme",
	    "dynamic-range", "video-dynamic-range"
	  ], mediaFeatures = keySet(mediaFeatures_);
	
	  var mediaValueKeywords_ = [
	    "landscape", "portrait", "none", "coarse", "fine", "on-demand", "hover",
	    "interlace", "progressive",
	    "dark", "light",
	    "standard", "high"
	  ], mediaValueKeywords = keySet(mediaValueKeywords_);
	
	  var propertyKeywords_ = [
	    "align-content", "align-items", "align-self", "alignment-adjust",
	    "alignment-baseline", "all", "anchor-point", "animation", "animation-delay",
	    "animation-direction", "animation-duration", "animation-fill-mode",
	    "animation-iteration-count", "animation-name", "animation-play-state",
	    "animation-timing-function", "appearance", "azimuth", "backdrop-filter",
	    "backface-visibility", "background", "background-attachment",
	    "background-blend-mode", "background-clip", "background-color",
	    "background-image", "background-origin", "background-position",
	    "background-position-x", "background-position-y", "background-repeat",
	    "background-size", "baseline-shift", "binding", "bleed", "block-size",
	    "bookmark-label", "bookmark-level", "bookmark-state", "bookmark-target",
	    "border", "border-bottom", "border-bottom-color", "border-bottom-left-radius",
	    "border-bottom-right-radius", "border-bottom-style", "border-bottom-width",
	    "border-collapse", "border-color", "border-image", "border-image-outset",
	    "border-image-repeat", "border-image-slice", "border-image-source",
	    "border-image-width", "border-left", "border-left-color", "border-left-style",
	    "border-left-width", "border-radius", "border-right", "border-right-color",
	    "border-right-style", "border-right-width", "border-spacing", "border-style",
	    "border-top", "border-top-color", "border-top-left-radius",
	    "border-top-right-radius", "border-top-style", "border-top-width",
	    "border-width", "bottom", "box-decoration-break", "box-shadow", "box-sizing",
	    "break-after", "break-before", "break-inside", "caption-side", "caret-color",
	    "clear", "clip", "color", "color-profile", "column-count", "column-fill",
	    "column-gap", "column-rule", "column-rule-color", "column-rule-style",
	    "column-rule-width", "column-span", "column-width", "columns", "contain",
	    "content", "counter-increment", "counter-reset", "crop", "cue", "cue-after",
	    "cue-before", "cursor", "direction", "display", "dominant-baseline",
	    "drop-initial-after-adjust", "drop-initial-after-align",
	    "drop-initial-before-adjust", "drop-initial-before-align", "drop-initial-size",
	    "drop-initial-value", "elevation", "empty-cells", "fit", "fit-content", "fit-position",
	    "flex", "flex-basis", "flex-direction", "flex-flow", "flex-grow",
	    "flex-shrink", "flex-wrap", "float", "float-offset", "flow-from", "flow-into",
	    "font", "font-family", "font-feature-settings", "font-kerning",
	    "font-language-override", "font-optical-sizing", "font-size",
	    "font-size-adjust", "font-stretch", "font-style", "font-synthesis",
	    "font-variant", "font-variant-alternates", "font-variant-caps",
	    "font-variant-east-asian", "font-variant-ligatures", "font-variant-numeric",
	    "font-variant-position", "font-variation-settings", "font-weight", "gap",
	    "grid", "grid-area", "grid-auto-columns", "grid-auto-flow", "grid-auto-rows",
	    "grid-column", "grid-column-end", "grid-column-gap", "grid-column-start",
	    "grid-gap", "grid-row", "grid-row-end", "grid-row-gap", "grid-row-start",
	    "grid-template", "grid-template-areas", "grid-template-columns",
	    "grid-template-rows", "hanging-punctuation", "height", "hyphens", "icon",
	    "image-orientation", "image-rendering", "image-resolution", "inline-box-align",
	    "inset", "inset-block", "inset-block-end", "inset-block-start", "inset-inline",
	    "inset-inline-end", "inset-inline-start", "isolation", "justify-content",
	    "justify-items", "justify-self", "left", "letter-spacing", "line-break",
	    "line-height", "line-height-step", "line-stacking", "line-stacking-ruby",
	    "line-stacking-shift", "line-stacking-strategy", "list-style",
	    "list-style-image", "list-style-position", "list-style-type", "margin",
	    "margin-bottom", "margin-left", "margin-right", "margin-top", "marks",
	    "marquee-direction", "marquee-loop", "marquee-play-count", "marquee-speed",
	    "marquee-style", "mask-clip", "mask-composite", "mask-image", "mask-mode",
	    "mask-origin", "mask-position", "mask-repeat", "mask-size","mask-type",
	    "max-block-size", "max-height", "max-inline-size",
	    "max-width", "min-block-size", "min-height", "min-inline-size", "min-width",
	    "mix-blend-mode", "move-to", "nav-down", "nav-index", "nav-left", "nav-right",
	    "nav-up", "object-fit", "object-position", "offset", "offset-anchor",
	    "offset-distance", "offset-path", "offset-position", "offset-rotate",
	    "opacity", "order", "orphans", "outline", "outline-color", "outline-offset",
	    "outline-style", "outline-width", "overflow", "overflow-style",
	    "overflow-wrap", "overflow-x", "overflow-y", "padding", "padding-bottom",
	    "padding-left", "padding-right", "padding-top", "page", "page-break-after",
	    "page-break-before", "page-break-inside", "page-policy", "pause",
	    "pause-after", "pause-before", "perspective", "perspective-origin", "pitch",
	    "pitch-range", "place-content", "place-items", "place-self", "play-during",
	    "position", "presentation-level", "punctuation-trim", "quotes",
	    "region-break-after", "region-break-before", "region-break-inside",
	    "region-fragment", "rendering-intent", "resize", "rest", "rest-after",
	    "rest-before", "richness", "right", "rotate", "rotation", "rotation-point",
	    "row-gap", "ruby-align", "ruby-overhang", "ruby-position", "ruby-span",
	    "scale", "scroll-behavior", "scroll-margin", "scroll-margin-block",
	    "scroll-margin-block-end", "scroll-margin-block-start", "scroll-margin-bottom",
	    "scroll-margin-inline", "scroll-margin-inline-end",
	    "scroll-margin-inline-start", "scroll-margin-left", "scroll-margin-right",
	    "scroll-margin-top", "scroll-padding", "scroll-padding-block",
	    "scroll-padding-block-end", "scroll-padding-block-start",
	    "scroll-padding-bottom", "scroll-padding-inline", "scroll-padding-inline-end",
	    "scroll-padding-inline-start", "scroll-padding-left", "scroll-padding-right",
	    "scroll-padding-top", "scroll-snap-align", "scroll-snap-type",
	    "shape-image-threshold", "shape-inside", "shape-margin", "shape-outside",
	    "size", "speak", "speak-as", "speak-header", "speak-numeral",
	    "speak-punctuation", "speech-rate", "stress", "string-set", "tab-size",
	    "table-layout", "target", "target-name", "target-new", "target-position",
	    "text-align", "text-align-last", "text-combine-upright", "text-decoration",
	    "text-decoration-color", "text-decoration-line", "text-decoration-skip",
	    "text-decoration-skip-ink", "text-decoration-style", "text-emphasis",
	    "text-emphasis-color", "text-emphasis-position", "text-emphasis-style",
	    "text-height", "text-indent", "text-justify", "text-orientation",
	    "text-outline", "text-overflow", "text-rendering", "text-shadow",
	    "text-size-adjust", "text-space-collapse", "text-transform",
	    "text-underline-position", "text-wrap", "top", "touch-action", "transform", "transform-origin",
	    "transform-style", "transition", "transition-delay", "transition-duration",
	    "transition-property", "transition-timing-function", "translate",
	    "unicode-bidi", "user-select", "vertical-align", "visibility", "voice-balance",
	    "voice-duration", "voice-family", "voice-pitch", "voice-range", "voice-rate",
	    "voice-stress", "voice-volume", "volume", "white-space", "widows", "width",
	    "will-change", "word-break", "word-spacing", "word-wrap", "writing-mode", "z-index",
	    // SVG-specific
	    "clip-path", "clip-rule", "mask", "enable-background", "filter", "flood-color",
	    "flood-opacity", "lighting-color", "stop-color", "stop-opacity", "pointer-events",
	    "color-interpolation", "color-interpolation-filters",
	    "color-rendering", "fill", "fill-opacity", "fill-rule", "image-rendering",
	    "marker", "marker-end", "marker-mid", "marker-start", "paint-order", "shape-rendering", "stroke",
	    "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin",
	    "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-rendering",
	    "baseline-shift", "dominant-baseline", "glyph-orientation-horizontal",
	    "glyph-orientation-vertical", "text-anchor", "writing-mode",
	  ], propertyKeywords = keySet(propertyKeywords_);
	
	  var nonStandardPropertyKeywords_ = [
	    "accent-color", "aspect-ratio", "border-block", "border-block-color", "border-block-end",
	    "border-block-end-color", "border-block-end-style", "border-block-end-width",
	    "border-block-start", "border-block-start-color", "border-block-start-style",
	    "border-block-start-width", "border-block-style", "border-block-width",
	    "border-inline", "border-inline-color", "border-inline-end",
	    "border-inline-end-color", "border-inline-end-style",
	    "border-inline-end-width", "border-inline-start", "border-inline-start-color",
	    "border-inline-start-style", "border-inline-start-width",
	    "border-inline-style", "border-inline-width", "content-visibility", "margin-block",
	    "margin-block-end", "margin-block-start", "margin-inline", "margin-inline-end",
	    "margin-inline-start", "overflow-anchor", "overscroll-behavior", "padding-block", "padding-block-end",
	    "padding-block-start", "padding-inline", "padding-inline-end",
	    "padding-inline-start", "scroll-snap-stop", "scrollbar-3d-light-color",
	    "scrollbar-arrow-color", "scrollbar-base-color", "scrollbar-dark-shadow-color",
	    "scrollbar-face-color", "scrollbar-highlight-color", "scrollbar-shadow-color",
	    "scrollbar-track-color", "searchfield-cancel-button", "searchfield-decoration",
	    "searchfield-results-button", "searchfield-results-decoration", "shape-inside", "zoom"
	  ], nonStandardPropertyKeywords = keySet(nonStandardPropertyKeywords_);
	
	  var fontProperties_ = [
	    "font-display", "font-family", "src", "unicode-range", "font-variant",
	     "font-feature-settings", "font-stretch", "font-weight", "font-style"
	  ], fontProperties = keySet(fontProperties_);
	
	  var counterDescriptors_ = [
	    "additive-symbols", "fallback", "negative", "pad", "prefix", "range",
	    "speak-as", "suffix", "symbols", "system"
	  ], counterDescriptors = keySet(counterDescriptors_);
	
	  var colorKeywords_ = [
	    "aliceblue", "antiquewhite", "aqua", "aquamarine", "azure", "beige",
	    "bisque", "black", "blanchedalmond", "blue", "blueviolet", "brown",
	    "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue",
	    "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod",
	    "darkgray", "darkgreen", "darkgrey", "darkkhaki", "darkmagenta", "darkolivegreen",
	    "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen",
	    "darkslateblue", "darkslategray", "darkslategrey", "darkturquoise", "darkviolet",
	    "deeppink", "deepskyblue", "dimgray", "dimgrey", "dodgerblue", "firebrick",
	    "floralwhite", "forestgreen", "fuchsia", "gainsboro", "ghostwhite",
	    "gold", "goldenrod", "gray", "grey", "green", "greenyellow", "honeydew",
	    "hotpink", "indianred", "indigo", "ivory", "khaki", "lavender",
	    "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral",
	    "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightgrey", "lightpink",
	    "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray", "lightslategrey",
	    "lightsteelblue", "lightyellow", "lime", "limegreen", "linen", "magenta",
	    "maroon", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple",
	    "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise",
	    "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin",
	    "navajowhite", "navy", "oldlace", "olive", "olivedrab", "orange", "orangered",
	    "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred",
	    "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue",
	    "purple", "rebeccapurple", "red", "rosybrown", "royalblue", "saddlebrown",
	    "salmon", "sandybrown", "seagreen", "seashell", "sienna", "silver", "skyblue",
	    "slateblue", "slategray", "slategrey", "snow", "springgreen", "steelblue", "tan",
	    "teal", "thistle", "tomato", "turquoise", "violet", "wheat", "white",
	    "whitesmoke", "yellow", "yellowgreen"
	  ], colorKeywords = keySet(colorKeywords_);
	
	  var valueKeywords_ = [
	    "above", "absolute", "activeborder", "additive", "activecaption", "afar",
	    "after-white-space", "ahead", "alias", "all", "all-scroll", "alphabetic", "alternate",
	    "always", "amharic", "amharic-abegede", "antialiased", "appworkspace",
	    "arabic-indic", "armenian", "asterisks", "attr", "auto", "auto-flow", "avoid", "avoid-column", "avoid-page",
	    "avoid-region", "axis-pan", "background", "backwards", "baseline", "below", "bidi-override", "binary",
	    "bengali", "blink", "block", "block-axis", "blur", "bold", "bolder", "border", "border-box",
	    "both", "bottom", "break", "break-all", "break-word", "brightness", "bullets", "button", "button-bevel",
	    "buttonface", "buttonhighlight", "buttonshadow", "buttontext", "calc", "cambodian",
	    "capitalize", "caps-lock-indicator", "caption", "captiontext", "caret",
	    "cell", "center", "checkbox", "circle", "cjk-decimal", "cjk-earthly-branch",
	    "cjk-heavenly-stem", "cjk-ideographic", "clear", "clip", "close-quote",
	    "col-resize", "collapse", "color", "color-burn", "color-dodge", "column", "column-reverse",
	    "compact", "condensed", "conic-gradient", "contain", "content", "contents",
	    "content-box", "context-menu", "continuous", "contrast", "copy", "counter", "counters", "cover", "crop",
	    "cross", "crosshair", "cubic-bezier", "currentcolor", "cursive", "cyclic", "darken", "dashed", "decimal",
	    "decimal-leading-zero", "default", "default-button", "dense", "destination-atop",
	    "destination-in", "destination-out", "destination-over", "devanagari", "difference",
	    "disc", "discard", "disclosure-closed", "disclosure-open", "document",
	    "dot-dash", "dot-dot-dash",
	    "dotted", "double", "down", "drop-shadow", "e-resize", "ease", "ease-in", "ease-in-out", "ease-out",
	    "element", "ellipse", "ellipsis", "embed", "end", "ethiopic", "ethiopic-abegede",
	    "ethiopic-abegede-am-et", "ethiopic-abegede-gez", "ethiopic-abegede-ti-er",
	    "ethiopic-abegede-ti-et", "ethiopic-halehame-aa-er",
	    "ethiopic-halehame-aa-et", "ethiopic-halehame-am-et",
	    "ethiopic-halehame-gez", "ethiopic-halehame-om-et",
	    "ethiopic-halehame-sid-et", "ethiopic-halehame-so-et",
	    "ethiopic-halehame-ti-er", "ethiopic-halehame-ti-et", "ethiopic-halehame-tig",
	    "ethiopic-numeric", "ew-resize", "exclusion", "expanded", "extends", "extra-condensed",
	    "extra-expanded", "fantasy", "fast", "fill", "fill-box", "fixed", "flat", "flex", "flex-end", "flex-start", "footnotes",
	    "forwards", "from", "geometricPrecision", "georgian", "grayscale", "graytext", "grid", "groove",
	    "gujarati", "gurmukhi", "hand", "hangul", "hangul-consonant", "hard-light", "hebrew",
	    "help", "hidden", "hide", "higher", "highlight", "highlighttext",
	    "hiragana", "hiragana-iroha", "horizontal", "hsl", "hsla", "hue", "hue-rotate", "icon", "ignore",
	    "inactiveborder", "inactivecaption", "inactivecaptiontext", "infinite",
	    "infobackground", "infotext", "inherit", "initial", "inline", "inline-axis",
	    "inline-block", "inline-flex", "inline-grid", "inline-table", "inset", "inside", "intrinsic", "invert",
	    "italic", "japanese-formal", "japanese-informal", "justify", "kannada",
	    "katakana", "katakana-iroha", "keep-all", "khmer",
	    "korean-hangul-formal", "korean-hanja-formal", "korean-hanja-informal",
	    "landscape", "lao", "large", "larger", "left", "level", "lighter", "lighten",
	    "line-through", "linear", "linear-gradient", "lines", "list-item", "listbox", "listitem",
	    "local", "logical", "loud", "lower", "lower-alpha", "lower-armenian",
	    "lower-greek", "lower-hexadecimal", "lower-latin", "lower-norwegian",
	    "lower-roman", "lowercase", "ltr", "luminosity", "malayalam", "manipulation", "match", "matrix", "matrix3d",
	    "media-controls-background", "media-current-time-display",
	    "media-fullscreen-button", "media-mute-button", "media-play-button",
	    "media-return-to-realtime-button", "media-rewind-button",
	    "media-seek-back-button", "media-seek-forward-button", "media-slider",
	    "media-sliderthumb", "media-time-remaining-display", "media-volume-slider",
	    "media-volume-slider-container", "media-volume-sliderthumb", "medium",
	    "menu", "menulist", "menulist-button", "menulist-text",
	    "menulist-textfield", "menutext", "message-box", "middle", "min-intrinsic",
	    "mix", "mongolian", "monospace", "move", "multiple", "multiple_mask_images", "multiply", "myanmar", "n-resize",
	    "narrower", "ne-resize", "nesw-resize", "no-close-quote", "no-drop",
	    "no-open-quote", "no-repeat", "none", "normal", "not-allowed", "nowrap",
	    "ns-resize", "numbers", "numeric", "nw-resize", "nwse-resize", "oblique", "octal", "opacity", "open-quote",
	    "optimizeLegibility", "optimizeSpeed", "oriya", "oromo", "outset",
	    "outside", "outside-shape", "overlay", "overline", "padding", "padding-box",
	    "painted", "page", "paused", "persian", "perspective", "pinch-zoom", "plus-darker", "plus-lighter",
	    "pointer", "polygon", "portrait", "pre", "pre-line", "pre-wrap", "preserve-3d",
	    "progress", "push-button", "radial-gradient", "radio", "read-only",
	    "read-write", "read-write-plaintext-only", "rectangle", "region",
	    "relative", "repeat", "repeating-linear-gradient", "repeating-radial-gradient",
	    "repeating-conic-gradient", "repeat-x", "repeat-y", "reset", "reverse",
	    "rgb", "rgba", "ridge", "right", "rotate", "rotate3d", "rotateX", "rotateY",
	    "rotateZ", "round", "row", "row-resize", "row-reverse", "rtl", "run-in", "running",
	    "s-resize", "sans-serif", "saturate", "saturation", "scale", "scale3d", "scaleX", "scaleY", "scaleZ", "screen",
	    "scroll", "scrollbar", "scroll-position", "se-resize", "searchfield",
	    "searchfield-cancel-button", "searchfield-decoration",
	    "searchfield-results-button", "searchfield-results-decoration", "self-start", "self-end",
	    "semi-condensed", "semi-expanded", "separate", "sepia", "serif", "show", "sidama",
	    "simp-chinese-formal", "simp-chinese-informal", "single",
	    "skew", "skewX", "skewY", "skip-white-space", "slide", "slider-horizontal",
	    "slider-vertical", "sliderthumb-horizontal", "sliderthumb-vertical", "slow",
	    "small", "small-caps", "small-caption", "smaller", "soft-light", "solid", "somali",
	    "source-atop", "source-in", "source-out", "source-over", "space", "space-around", "space-between", "space-evenly", "spell-out", "square",
	    "square-button", "start", "static", "status-bar", "stretch", "stroke", "stroke-box", "sub",
	    "subpixel-antialiased", "svg_masks", "super", "sw-resize", "symbolic", "symbols", "system-ui", "table",
	    "table-caption", "table-cell", "table-column", "table-column-group",
	    "table-footer-group", "table-header-group", "table-row", "table-row-group",
	    "tamil",
	    "telugu", "text", "text-bottom", "text-top", "textarea", "textfield", "thai",
	    "thick", "thin", "threeddarkshadow", "threedface", "threedhighlight",
	    "threedlightshadow", "threedshadow", "tibetan", "tigre", "tigrinya-er",
	    "tigrinya-er-abegede", "tigrinya-et", "tigrinya-et-abegede", "to", "top",
	    "trad-chinese-formal", "trad-chinese-informal", "transform",
	    "translate", "translate3d", "translateX", "translateY", "translateZ",
	    "transparent", "ultra-condensed", "ultra-expanded", "underline", "unidirectional-pan", "unset", "up",
	    "upper-alpha", "upper-armenian", "upper-greek", "upper-hexadecimal",
	    "upper-latin", "upper-norwegian", "upper-roman", "uppercase", "urdu", "url",
	    "var", "vertical", "vertical-text", "view-box", "visible", "visibleFill", "visiblePainted",
	    "visibleStroke", "visual", "w-resize", "wait", "wave", "wider",
	    "window", "windowframe", "windowtext", "words", "wrap", "wrap-reverse", "x-large", "x-small", "xor",
	    "xx-large", "xx-small"
	  ], valueKeywords = keySet(valueKeywords_);
	
	  var allWords = documentTypes_.concat(mediaTypes_).concat(mediaFeatures_).concat(mediaValueKeywords_)
	    .concat(propertyKeywords_).concat(nonStandardPropertyKeywords_).concat(colorKeywords_)
	    .concat(valueKeywords_);
	  CodeMirror.registerHelper("hintWords", "css", allWords);
	
	  function tokenCComment(stream, state) {
	    var maybeEnd = false, ch;
	    while ((ch = stream.next()) != null) {
	      if (maybeEnd && ch == "/") {
	        state.tokenize = null;
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return ["comment", "comment"];
	  }
	
	  CodeMirror.defineMIME("text/css", {
	    documentTypes: documentTypes,
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    mediaValueKeywords: mediaValueKeywords,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    fontProperties: fontProperties,
	    counterDescriptors: counterDescriptors,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    tokenHooks: {
	      "/": function(stream, state) {
	        if (!stream.eat("*")) return false;
	        state.tokenize = tokenCComment;
	        return tokenCComment(stream, state);
	      }
	    },
	    name: "css"
	  });
	
	  CodeMirror.defineMIME("text/x-scss", {
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    mediaValueKeywords: mediaValueKeywords,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    fontProperties: fontProperties,
	    allowNested: true,
	    lineComment: "//",
	    tokenHooks: {
	      "/": function(stream, state) {
	        if (stream.eat("/")) {
	          stream.skipToEnd();
	          return ["comment", "comment"];
	        } else if (stream.eat("*")) {
	          state.tokenize = tokenCComment;
	          return tokenCComment(stream, state);
	        } else {
	          return ["operator", "operator"];
	        }
	      },
	      ":": function(stream) {
	        if (stream.match(/^\s*\{/, false))
	          return [null, null]
	        return false;
	      },
	      "$": function(stream) {
	        stream.match(/^[\w-]+/);
	        if (stream.match(/^\s*:/, false))
	          return ["variable-2", "variable-definition"];
	        return ["variable-2", "variable"];
	      },
	      "#": function(stream) {
	        if (!stream.eat("{")) return false;
	        return [null, "interpolation"];
	      }
	    },
	    name: "css",
	    helperType: "scss"
	  });
	
	  CodeMirror.defineMIME("text/x-less", {
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    mediaValueKeywords: mediaValueKeywords,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    fontProperties: fontProperties,
	    allowNested: true,
	    lineComment: "//",
	    tokenHooks: {
	      "/": function(stream, state) {
	        if (stream.eat("/")) {
	          stream.skipToEnd();
	          return ["comment", "comment"];
	        } else if (stream.eat("*")) {
	          state.tokenize = tokenCComment;
	          return tokenCComment(stream, state);
	        } else {
	          return ["operator", "operator"];
	        }
	      },
	      "@": function(stream) {
	        if (stream.eat("{")) return [null, "interpolation"];
	        if (stream.match(/^(charset|document|font-face|import|(-(moz|ms|o|webkit)-)?keyframes|media|namespace|page|supports)\b/i, false)) return false;
	        stream.eatWhile(/[\w\\\-]/);
	        if (stream.match(/^\s*:/, false))
	          return ["variable-2", "variable-definition"];
	        return ["variable-2", "variable"];
	      },
	      "&": function() {
	        return ["atom", "atom"];
	      }
	    },
	    name: "css",
	    helperType: "less"
	  });
	
	  CodeMirror.defineMIME("text/x-gss", {
	    documentTypes: documentTypes,
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    fontProperties: fontProperties,
	    counterDescriptors: counterDescriptors,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    supportsAtComponent: true,
	    tokenHooks: {
	      "/": function(stream, state) {
	        if (!stream.eat("*")) return false;
	        state.tokenize = tokenCComment;
	        return tokenCComment(stream, state);
	      }
	    },
	    name: "css",
	    helperType: "gss"
	  });
	
	});


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(78));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("javascript", function(config, parserConfig) {
	  var indentUnit = config.indentUnit;
	  var statementIndent = parserConfig.statementIndent;
	  var jsonldMode = parserConfig.jsonld;
	  var jsonMode = parserConfig.json || jsonldMode;
	  var trackScope = parserConfig.trackScope !== false
	  var isTS = parserConfig.typescript;
	  var wordRE = parserConfig.wordCharacters || /[\w$\xa1-\uffff]/;
	
	  // Tokenizer
	
	  var keywords = function(){
	    function kw(type) {return {type: type, style: "keyword"};}
	    var A = kw("keyword a"), B = kw("keyword b"), C = kw("keyword c"), D = kw("keyword d");
	    var operator = kw("operator"), atom = {type: "atom", style: "atom"};
	
	    return {
	      "if": kw("if"), "while": A, "with": A, "else": B, "do": B, "try": B, "finally": B,
	      "return": D, "break": D, "continue": D, "new": kw("new"), "delete": C, "void": C, "throw": C,
	      "debugger": kw("debugger"), "var": kw("var"), "const": kw("var"), "let": kw("var"),
	      "function": kw("function"), "catch": kw("catch"),
	      "for": kw("for"), "switch": kw("switch"), "case": kw("case"), "default": kw("default"),
	      "in": operator, "typeof": operator, "instanceof": operator,
	      "true": atom, "false": atom, "null": atom, "undefined": atom, "NaN": atom, "Infinity": atom,
	      "this": kw("this"), "class": kw("class"), "super": kw("atom"),
	      "yield": C, "export": kw("export"), "import": kw("import"), "extends": C,
	      "await": C
	    };
	  }();
	
	  var isOperatorChar = /[+\-*&%=<>!?|~^@]/;
	  var isJsonldKeyword = /^@(context|id|value|language|type|container|list|set|reverse|index|base|vocab|graph)"/;
	
	  function readRegexp(stream) {
	    var escaped = false, next, inSet = false;
	    while ((next = stream.next()) != null) {
	      if (!escaped) {
	        if (next == "/" && !inSet) return;
	        if (next == "[") inSet = true;
	        else if (inSet && next == "]") inSet = false;
	      }
	      escaped = !escaped && next == "\\";
	    }
	  }
	
	  // Used as scratch variables to communicate multiple values without
	  // consing up tons of objects.
	  var type, content;
	  function ret(tp, style, cont) {
	    type = tp; content = cont;
	    return style;
	  }
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	    if (ch == '"' || ch == "'") {
	      state.tokenize = tokenString(ch);
	      return state.tokenize(stream, state);
	    } else if (ch == "." && stream.match(/^\d[\d_]*(?:[eE][+\-]?[\d_]+)?/)) {
	      return ret("number", "number");
	    } else if (ch == "." && stream.match("..")) {
	      return ret("spread", "meta");
	    } else if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
	      return ret(ch);
	    } else if (ch == "=" && stream.eat(">")) {
	      return ret("=>", "operator");
	    } else if (ch == "0" && stream.match(/^(?:x[\dA-Fa-f_]+|o[0-7_]+|b[01_]+)n?/)) {
	      return ret("number", "number");
	    } else if (/\d/.test(ch)) {
	      stream.match(/^[\d_]*(?:n|(?:\.[\d_]*)?(?:[eE][+\-]?[\d_]+)?)?/);
	      return ret("number", "number");
	    } else if (ch == "/") {
	      if (stream.eat("*")) {
	        state.tokenize = tokenComment;
	        return tokenComment(stream, state);
	      } else if (stream.eat("/")) {
	        stream.skipToEnd();
	        return ret("comment", "comment");
	      } else if (expressionAllowed(stream, state, 1)) {
	        readRegexp(stream);
	        stream.match(/^\b(([gimyus])(?![gimyus]*\2))+\b/);
	        return ret("regexp", "string-2");
	      } else {
	        stream.eat("=");
	        return ret("operator", "operator", stream.current());
	      }
	    } else if (ch == "`") {
	      state.tokenize = tokenQuasi;
	      return tokenQuasi(stream, state);
	    } else if (ch == "#" && stream.peek() == "!") {
	      stream.skipToEnd();
	      return ret("meta", "meta");
	    } else if (ch == "#" && stream.eatWhile(wordRE)) {
	      return ret("variable", "property")
	    } else if (ch == "<" && stream.match("!--") ||
	               (ch == "-" && stream.match("->") && !/\S/.test(stream.string.slice(0, stream.start)))) {
	      stream.skipToEnd()
	      return ret("comment", "comment")
	    } else if (isOperatorChar.test(ch)) {
	      if (ch != ">" || !state.lexical || state.lexical.type != ">") {
	        if (stream.eat("=")) {
	          if (ch == "!" || ch == "=") stream.eat("=")
	        } else if (/[<>*+\-|&?]/.test(ch)) {
	          stream.eat(ch)
	          if (ch == ">") stream.eat(ch)
	        }
	      }
	      if (ch == "?" && stream.eat(".")) return ret(".")
	      return ret("operator", "operator", stream.current());
	    } else if (wordRE.test(ch)) {
	      stream.eatWhile(wordRE);
	      var word = stream.current()
	      if (state.lastType != ".") {
	        if (keywords.propertyIsEnumerable(word)) {
	          var kw = keywords[word]
	          return ret(kw.type, kw.style, word)
	        }
	        if (word == "async" && stream.match(/^(\s|\/\*([^*]|\*(?!\/))*?\*\/)*[\[\(\w]/, false))
	          return ret("async", "keyword", word)
	      }
	      return ret("variable", "variable", word)
	    }
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var escaped = false, next;
	      if (jsonldMode && stream.peek() == "@" && stream.match(isJsonldKeyword)){
	        state.tokenize = tokenBase;
	        return ret("jsonld-keyword", "meta");
	      }
	      while ((next = stream.next()) != null) {
	        if (next == quote && !escaped) break;
	        escaped = !escaped && next == "\\";
	      }
	      if (!escaped) state.tokenize = tokenBase;
	      return ret("string", "string");
	    };
	  }
	
	  function tokenComment(stream, state) {
	    var maybeEnd = false, ch;
	    while (ch = stream.next()) {
	      if (ch == "/" && maybeEnd) {
	        state.tokenize = tokenBase;
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return ret("comment", "comment");
	  }
	
	  function tokenQuasi(stream, state) {
	    var escaped = false, next;
	    while ((next = stream.next()) != null) {
	      if (!escaped && (next == "`" || next == "$" && stream.eat("{"))) {
	        state.tokenize = tokenBase;
	        break;
	      }
	      escaped = !escaped && next == "\\";
	    }
	    return ret("quasi", "string-2", stream.current());
	  }
	
	  var brackets = "([{}])";
	  // This is a crude lookahead trick to try and notice that we're
	  // parsing the argument patterns for a fat-arrow function before we
	  // actually hit the arrow token. It only works if the arrow is on
	  // the same line as the arguments and there's no strange noise
	  // (comments) in between. Fallback is to only notice when we hit the
	  // arrow, and not declare the arguments as locals for the arrow
	  // body.
	  function findFatArrow(stream, state) {
	    if (state.fatArrowAt) state.fatArrowAt = null;
	    var arrow = stream.string.indexOf("=>", stream.start);
	    if (arrow < 0) return;
	
	    if (isTS) { // Try to skip TypeScript return type declarations after the arguments
	      var m = /:\s*(?:\w+(?:<[^>]*>|\[\])?|\{[^}]*\})\s*$/.exec(stream.string.slice(stream.start, arrow))
	      if (m) arrow = m.index
	    }
	
	    var depth = 0, sawSomething = false;
	    for (var pos = arrow - 1; pos >= 0; --pos) {
	      var ch = stream.string.charAt(pos);
	      var bracket = brackets.indexOf(ch);
	      if (bracket >= 0 && bracket < 3) {
	        if (!depth) { ++pos; break; }
	        if (--depth == 0) { if (ch == "(") sawSomething = true; break; }
	      } else if (bracket >= 3 && bracket < 6) {
	        ++depth;
	      } else if (wordRE.test(ch)) {
	        sawSomething = true;
	      } else if (/["'\/`]/.test(ch)) {
	        for (;; --pos) {
	          if (pos == 0) return
	          var next = stream.string.charAt(pos - 1)
	          if (next == ch && stream.string.charAt(pos - 2) != "\\") { pos--; break }
	        }
	      } else if (sawSomething && !depth) {
	        ++pos;
	        break;
	      }
	    }
	    if (sawSomething && !depth) state.fatArrowAt = pos;
	  }
	
	  // Parser
	
	  var atomicTypes = {"atom": true, "number": true, "variable": true, "string": true,
	                     "regexp": true, "this": true, "import": true, "jsonld-keyword": true};
	
	  function JSLexical(indented, column, type, align, prev, info) {
	    this.indented = indented;
	    this.column = column;
	    this.type = type;
	    this.prev = prev;
	    this.info = info;
	    if (align != null) this.align = align;
	  }
	
	  function inScope(state, varname) {
	    if (!trackScope) return false
	    for (var v = state.localVars; v; v = v.next)
	      if (v.name == varname) return true;
	    for (var cx = state.context; cx; cx = cx.prev) {
	      for (var v = cx.vars; v; v = v.next)
	        if (v.name == varname) return true;
	    }
	  }
	
	  function parseJS(state, style, type, content, stream) {
	    var cc = state.cc;
	    // Communicate our context to the combinators.
	    // (Less wasteful than consing up a hundred closures on every call.)
	    cx.state = state; cx.stream = stream; cx.marked = null, cx.cc = cc; cx.style = style;
	
	    if (!state.lexical.hasOwnProperty("align"))
	      state.lexical.align = true;
	
	    while(true) {
	      var combinator = cc.length ? cc.pop() : jsonMode ? expression : statement;
	      if (combinator(type, content)) {
	        while(cc.length && cc[cc.length - 1].lex)
	          cc.pop()();
	        if (cx.marked) return cx.marked;
	        if (type == "variable" && inScope(state, content)) return "variable-2";
	        return style;
	      }
	    }
	  }
	
	  // Combinator utils
	
	  var cx = {state: null, column: null, marked: null, cc: null};
	  function pass() {
	    for (var i = arguments.length - 1; i >= 0; i--) cx.cc.push(arguments[i]);
	  }
	  function cont() {
	    pass.apply(null, arguments);
	    return true;
	  }
	  function inList(name, list) {
	    for (var v = list; v; v = v.next) if (v.name == name) return true
	    return false;
	  }
	  function register(varname) {
	    var state = cx.state;
	    cx.marked = "def";
	    if (!trackScope) return
	    if (state.context) {
	      if (state.lexical.info == "var" && state.context && state.context.block) {
	        // FIXME function decls are also not block scoped
	        var newContext = registerVarScoped(varname, state.context)
	        if (newContext != null) {
	          state.context = newContext
	          return
	        }
	      } else if (!inList(varname, state.localVars)) {
	        state.localVars = new Var(varname, state.localVars)
	        return
	      }
	    }
	    // Fall through means this is global
	    if (parserConfig.globalVars && !inList(varname, state.globalVars))
	      state.globalVars = new Var(varname, state.globalVars)
	  }
	  function registerVarScoped(varname, context) {
	    if (!context) {
	      return null
	    } else if (context.block) {
	      var inner = registerVarScoped(varname, context.prev)
	      if (!inner) return null
	      if (inner == context.prev) return context
	      return new Context(inner, context.vars, true)
	    } else if (inList(varname, context.vars)) {
	      return context
	    } else {
	      return new Context(context.prev, new Var(varname, context.vars), false)
	    }
	  }
	
	  function isModifier(name) {
	    return name == "public" || name == "private" || name == "protected" || name == "abstract" || name == "readonly"
	  }
	
	  // Combinators
	
	  function Context(prev, vars, block) { this.prev = prev; this.vars = vars; this.block = block }
	  function Var(name, next) { this.name = name; this.next = next }
	
	  var defaultVars = new Var("this", new Var("arguments", null))
	  function pushcontext() {
	    cx.state.context = new Context(cx.state.context, cx.state.localVars, false)
	    cx.state.localVars = defaultVars
	  }
	  function pushblockcontext() {
	    cx.state.context = new Context(cx.state.context, cx.state.localVars, true)
	    cx.state.localVars = null
	  }
	  pushcontext.lex = pushblockcontext.lex = true
	  function popcontext() {
	    cx.state.localVars = cx.state.context.vars
	    cx.state.context = cx.state.context.prev
	  }
	  popcontext.lex = true
	  function pushlex(type, info) {
	    var result = function() {
	      var state = cx.state, indent = state.indented;
	      if (state.lexical.type == "stat") indent = state.lexical.indented;
	      else for (var outer = state.lexical; outer && outer.type == ")" && outer.align; outer = outer.prev)
	        indent = outer.indented;
	      state.lexical = new JSLexical(indent, cx.stream.column(), type, null, state.lexical, info);
	    };
	    result.lex = true;
	    return result;
	  }
	  function poplex() {
	    var state = cx.state;
	    if (state.lexical.prev) {
	      if (state.lexical.type == ")")
	        state.indented = state.lexical.indented;
	      state.lexical = state.lexical.prev;
	    }
	  }
	  poplex.lex = true;
	
	  function expect(wanted) {
	    function exp(type) {
	      if (type == wanted) return cont();
	      else if (wanted == ";" || type == "}" || type == ")" || type == "]") return pass();
	      else return cont(exp);
	    };
	    return exp;
	  }
	
	  function statement(type, value) {
	    if (type == "var") return cont(pushlex("vardef", value), vardef, expect(";"), poplex);
	    if (type == "keyword a") return cont(pushlex("form"), parenExpr, statement, poplex);
	    if (type == "keyword b") return cont(pushlex("form"), statement, poplex);
	    if (type == "keyword d") return cx.stream.match(/^\s*$/, false) ? cont() : cont(pushlex("stat"), maybeexpression, expect(";"), poplex);
	    if (type == "debugger") return cont(expect(";"));
	    if (type == "{") return cont(pushlex("}"), pushblockcontext, block, poplex, popcontext);
	    if (type == ";") return cont();
	    if (type == "if") {
	      if (cx.state.lexical.info == "else" && cx.state.cc[cx.state.cc.length - 1] == poplex)
	        cx.state.cc.pop()();
	      return cont(pushlex("form"), parenExpr, statement, poplex, maybeelse);
	    }
	    if (type == "function") return cont(functiondef);
	    if (type == "for") return cont(pushlex("form"), pushblockcontext, forspec, statement, popcontext, poplex);
	    if (type == "class" || (isTS && value == "interface")) {
	      cx.marked = "keyword"
	      return cont(pushlex("form", type == "class" ? type : value), className, poplex)
	    }
	    if (type == "variable") {
	      if (isTS && value == "declare") {
	        cx.marked = "keyword"
	        return cont(statement)
	      } else if (isTS && (value == "module" || value == "enum" || value == "type") && cx.stream.match(/^\s*\w/, false)) {
	        cx.marked = "keyword"
	        if (value == "enum") return cont(enumdef);
	        else if (value == "type") return cont(typename, expect("operator"), typeexpr, expect(";"));
	        else return cont(pushlex("form"), pattern, expect("{"), pushlex("}"), block, poplex, poplex)
	      } else if (isTS && value == "namespace") {
	        cx.marked = "keyword"
	        return cont(pushlex("form"), expression, statement, poplex)
	      } else if (isTS && value == "abstract") {
	        cx.marked = "keyword"
	        return cont(statement)
	      } else {
	        return cont(pushlex("stat"), maybelabel);
	      }
	    }
	    if (type == "switch") return cont(pushlex("form"), parenExpr, expect("{"), pushlex("}", "switch"), pushblockcontext,
	                                      block, poplex, poplex, popcontext);
	    if (type == "case") return cont(expression, expect(":"));
	    if (type == "default") return cont(expect(":"));
	    if (type == "catch") return cont(pushlex("form"), pushcontext, maybeCatchBinding, statement, poplex, popcontext);
	    if (type == "export") return cont(pushlex("stat"), afterExport, poplex);
	    if (type == "import") return cont(pushlex("stat"), afterImport, poplex);
	    if (type == "async") return cont(statement)
	    if (value == "@") return cont(expression, statement)
	    return pass(pushlex("stat"), expression, expect(";"), poplex);
	  }
	  function maybeCatchBinding(type) {
	    if (type == "(") return cont(funarg, expect(")"))
	  }
	  function expression(type, value) {
	    return expressionInner(type, value, false);
	  }
	  function expressionNoComma(type, value) {
	    return expressionInner(type, value, true);
	  }
	  function parenExpr(type) {
	    if (type != "(") return pass()
	    return cont(pushlex(")"), maybeexpression, expect(")"), poplex)
	  }
	  function expressionInner(type, value, noComma) {
	    if (cx.state.fatArrowAt == cx.stream.start) {
	      var body = noComma ? arrowBodyNoComma : arrowBody;
	      if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, expect("=>"), body, popcontext);
	      else if (type == "variable") return pass(pushcontext, pattern, expect("=>"), body, popcontext);
	    }
	
	    var maybeop = noComma ? maybeoperatorNoComma : maybeoperatorComma;
	    if (atomicTypes.hasOwnProperty(type)) return cont(maybeop);
	    if (type == "function") return cont(functiondef, maybeop);
	    if (type == "class" || (isTS && value == "interface")) { cx.marked = "keyword"; return cont(pushlex("form"), classExpression, poplex); }
	    if (type == "keyword c" || type == "async") return cont(noComma ? expressionNoComma : expression);
	    if (type == "(") return cont(pushlex(")"), maybeexpression, expect(")"), poplex, maybeop);
	    if (type == "operator" || type == "spread") return cont(noComma ? expressionNoComma : expression);
	    if (type == "[") return cont(pushlex("]"), arrayLiteral, poplex, maybeop);
	    if (type == "{") return contCommasep(objprop, "}", null, maybeop);
	    if (type == "quasi") return pass(quasi, maybeop);
	    if (type == "new") return cont(maybeTarget(noComma));
	    return cont();
	  }
	  function maybeexpression(type) {
	    if (type.match(/[;\}\)\],]/)) return pass();
	    return pass(expression);
	  }
	
	  function maybeoperatorComma(type, value) {
	    if (type == ",") return cont(maybeexpression);
	    return maybeoperatorNoComma(type, value, false);
	  }
	  function maybeoperatorNoComma(type, value, noComma) {
	    var me = noComma == false ? maybeoperatorComma : maybeoperatorNoComma;
	    var expr = noComma == false ? expression : expressionNoComma;
	    if (type == "=>") return cont(pushcontext, noComma ? arrowBodyNoComma : arrowBody, popcontext);
	    if (type == "operator") {
	      if (/\+\+|--/.test(value) || isTS && value == "!") return cont(me);
	      if (isTS && value == "<" && cx.stream.match(/^([^<>]|<[^<>]*>)*>\s*\(/, false))
	        return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, me);
	      if (value == "?") return cont(expression, expect(":"), expr);
	      return cont(expr);
	    }
	    if (type == "quasi") { return pass(quasi, me); }
	    if (type == ";") return;
	    if (type == "(") return contCommasep(expressionNoComma, ")", "call", me);
	    if (type == ".") return cont(property, me);
	    if (type == "[") return cont(pushlex("]"), maybeexpression, expect("]"), poplex, me);
	    if (isTS && value == "as") { cx.marked = "keyword"; return cont(typeexpr, me) }
	    if (type == "regexp") {
	      cx.state.lastType = cx.marked = "operator"
	      cx.stream.backUp(cx.stream.pos - cx.stream.start - 1)
	      return cont(expr)
	    }
	  }
	  function quasi(type, value) {
	    if (type != "quasi") return pass();
	    if (value.slice(value.length - 2) != "${") return cont(quasi);
	    return cont(maybeexpression, continueQuasi);
	  }
	  function continueQuasi(type) {
	    if (type == "}") {
	      cx.marked = "string-2";
	      cx.state.tokenize = tokenQuasi;
	      return cont(quasi);
	    }
	  }
	  function arrowBody(type) {
	    findFatArrow(cx.stream, cx.state);
	    return pass(type == "{" ? statement : expression);
	  }
	  function arrowBodyNoComma(type) {
	    findFatArrow(cx.stream, cx.state);
	    return pass(type == "{" ? statement : expressionNoComma);
	  }
	  function maybeTarget(noComma) {
	    return function(type) {
	      if (type == ".") return cont(noComma ? targetNoComma : target);
	      else if (type == "variable" && isTS) return cont(maybeTypeArgs, noComma ? maybeoperatorNoComma : maybeoperatorComma)
	      else return pass(noComma ? expressionNoComma : expression);
	    };
	  }
	  function target(_, value) {
	    if (value == "target") { cx.marked = "keyword"; return cont(maybeoperatorComma); }
	  }
	  function targetNoComma(_, value) {
	    if (value == "target") { cx.marked = "keyword"; return cont(maybeoperatorNoComma); }
	  }
	  function maybelabel(type) {
	    if (type == ":") return cont(poplex, statement);
	    return pass(maybeoperatorComma, expect(";"), poplex);
	  }
	  function property(type) {
	    if (type == "variable") {cx.marked = "property"; return cont();}
	  }
	  function objprop(type, value) {
	    if (type == "async") {
	      cx.marked = "property";
	      return cont(objprop);
	    } else if (type == "variable" || cx.style == "keyword") {
	      cx.marked = "property";
	      if (value == "get" || value == "set") return cont(getterSetter);
	      var m // Work around fat-arrow-detection complication for detecting typescript typed arrow params
	      if (isTS && cx.state.fatArrowAt == cx.stream.start && (m = cx.stream.match(/^\s*:\s*/, false)))
	        cx.state.fatArrowAt = cx.stream.pos + m[0].length
	      return cont(afterprop);
	    } else if (type == "number" || type == "string") {
	      cx.marked = jsonldMode ? "property" : (cx.style + " property");
	      return cont(afterprop);
	    } else if (type == "jsonld-keyword") {
	      return cont(afterprop);
	    } else if (isTS && isModifier(value)) {
	      cx.marked = "keyword"
	      return cont(objprop)
	    } else if (type == "[") {
	      return cont(expression, maybetype, expect("]"), afterprop);
	    } else if (type == "spread") {
	      return cont(expressionNoComma, afterprop);
	    } else if (value == "*") {
	      cx.marked = "keyword";
	      return cont(objprop);
	    } else if (type == ":") {
	      return pass(afterprop)
	    }
	  }
	  function getterSetter(type) {
	    if (type != "variable") return pass(afterprop);
	    cx.marked = "property";
	    return cont(functiondef);
	  }
	  function afterprop(type) {
	    if (type == ":") return cont(expressionNoComma);
	    if (type == "(") return pass(functiondef);
	  }
	  function commasep(what, end, sep) {
	    function proceed(type, value) {
	      if (sep ? sep.indexOf(type) > -1 : type == ",") {
	        var lex = cx.state.lexical;
	        if (lex.info == "call") lex.pos = (lex.pos || 0) + 1;
	        return cont(function(type, value) {
	          if (type == end || value == end) return pass()
	          return pass(what)
	        }, proceed);
	      }
	      if (type == end || value == end) return cont();
	      if (sep && sep.indexOf(";") > -1) return pass(what)
	      return cont(expect(end));
	    }
	    return function(type, value) {
	      if (type == end || value == end) return cont();
	      return pass(what, proceed);
	    };
	  }
	  function contCommasep(what, end, info) {
	    for (var i = 3; i < arguments.length; i++)
	      cx.cc.push(arguments[i]);
	    return cont(pushlex(end, info), commasep(what, end), poplex);
	  }
	  function block(type) {
	    if (type == "}") return cont();
	    return pass(statement, block);
	  }
	  function maybetype(type, value) {
	    if (isTS) {
	      if (type == ":") return cont(typeexpr);
	      if (value == "?") return cont(maybetype);
	    }
	  }
	  function maybetypeOrIn(type, value) {
	    if (isTS && (type == ":" || value == "in")) return cont(typeexpr)
	  }
	  function mayberettype(type) {
	    if (isTS && type == ":") {
	      if (cx.stream.match(/^\s*\w+\s+is\b/, false)) return cont(expression, isKW, typeexpr)
	      else return cont(typeexpr)
	    }
	  }
	  function isKW(_, value) {
	    if (value == "is") {
	      cx.marked = "keyword"
	      return cont()
	    }
	  }
	  function typeexpr(type, value) {
	    if (value == "keyof" || value == "typeof" || value == "infer" || value == "readonly") {
	      cx.marked = "keyword"
	      return cont(value == "typeof" ? expressionNoComma : typeexpr)
	    }
	    if (type == "variable" || value == "void") {
	      cx.marked = "type"
	      return cont(afterType)
	    }
	    if (value == "|" || value == "&") return cont(typeexpr)
	    if (type == "string" || type == "number" || type == "atom") return cont(afterType);
	    if (type == "[") return cont(pushlex("]"), commasep(typeexpr, "]", ","), poplex, afterType)
	    if (type == "{") return cont(pushlex("}"), typeprops, poplex, afterType)
	    if (type == "(") return cont(commasep(typearg, ")"), maybeReturnType, afterType)
	    if (type == "<") return cont(commasep(typeexpr, ">"), typeexpr)
	    if (type == "quasi") { return pass(quasiType, afterType); }
	  }
	  function maybeReturnType(type) {
	    if (type == "=>") return cont(typeexpr)
	  }
	  function typeprops(type) {
	    if (type.match(/[\}\)\]]/)) return cont()
	    if (type == "," || type == ";") return cont(typeprops)
	    return pass(typeprop, typeprops)
	  }
	  function typeprop(type, value) {
	    if (type == "variable" || cx.style == "keyword") {
	      cx.marked = "property"
	      return cont(typeprop)
	    } else if (value == "?" || type == "number" || type == "string") {
	      return cont(typeprop)
	    } else if (type == ":") {
	      return cont(typeexpr)
	    } else if (type == "[") {
	      return cont(expect("variable"), maybetypeOrIn, expect("]"), typeprop)
	    } else if (type == "(") {
	      return pass(functiondecl, typeprop)
	    } else if (!type.match(/[;\}\)\],]/)) {
	      return cont()
	    }
	  }
	  function quasiType(type, value) {
	    if (type != "quasi") return pass();
	    if (value.slice(value.length - 2) != "${") return cont(quasiType);
	    return cont(typeexpr, continueQuasiType);
	  }
	  function continueQuasiType(type) {
	    if (type == "}") {
	      cx.marked = "string-2";
	      cx.state.tokenize = tokenQuasi;
	      return cont(quasiType);
	    }
	  }
	  function typearg(type, value) {
	    if (type == "variable" && cx.stream.match(/^\s*[?:]/, false) || value == "?") return cont(typearg)
	    if (type == ":") return cont(typeexpr)
	    if (type == "spread") return cont(typearg)
	    return pass(typeexpr)
	  }
	  function afterType(type, value) {
	    if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType)
	    if (value == "|" || type == "." || value == "&") return cont(typeexpr)
	    if (type == "[") return cont(typeexpr, expect("]"), afterType)
	    if (value == "extends" || value == "implements") { cx.marked = "keyword"; return cont(typeexpr) }
	    if (value == "?") return cont(typeexpr, expect(":"), typeexpr)
	  }
	  function maybeTypeArgs(_, value) {
	    if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType)
	  }
	  function typeparam() {
	    return pass(typeexpr, maybeTypeDefault)
	  }
	  function maybeTypeDefault(_, value) {
	    if (value == "=") return cont(typeexpr)
	  }
	  function vardef(_, value) {
	    if (value == "enum") {cx.marked = "keyword"; return cont(enumdef)}
	    return pass(pattern, maybetype, maybeAssign, vardefCont);
	  }
	  function pattern(type, value) {
	    if (isTS && isModifier(value)) { cx.marked = "keyword"; return cont(pattern) }
	    if (type == "variable") { register(value); return cont(); }
	    if (type == "spread") return cont(pattern);
	    if (type == "[") return contCommasep(eltpattern, "]");
	    if (type == "{") return contCommasep(proppattern, "}");
	  }
	  function proppattern(type, value) {
	    if (type == "variable" && !cx.stream.match(/^\s*:/, false)) {
	      register(value);
	      return cont(maybeAssign);
	    }
	    if (type == "variable") cx.marked = "property";
	    if (type == "spread") return cont(pattern);
	    if (type == "}") return pass();
	    if (type == "[") return cont(expression, expect(']'), expect(':'), proppattern);
	    return cont(expect(":"), pattern, maybeAssign);
	  }
	  function eltpattern() {
	    return pass(pattern, maybeAssign)
	  }
	  function maybeAssign(_type, value) {
	    if (value == "=") return cont(expressionNoComma);
	  }
	  function vardefCont(type) {
	    if (type == ",") return cont(vardef);
	  }
	  function maybeelse(type, value) {
	    if (type == "keyword b" && value == "else") return cont(pushlex("form", "else"), statement, poplex);
	  }
	  function forspec(type, value) {
	    if (value == "await") return cont(forspec);
	    if (type == "(") return cont(pushlex(")"), forspec1, poplex);
	  }
	  function forspec1(type) {
	    if (type == "var") return cont(vardef, forspec2);
	    if (type == "variable") return cont(forspec2);
	    return pass(forspec2)
	  }
	  function forspec2(type, value) {
	    if (type == ")") return cont()
	    if (type == ";") return cont(forspec2)
	    if (value == "in" || value == "of") { cx.marked = "keyword"; return cont(expression, forspec2) }
	    return pass(expression, forspec2)
	  }
	  function functiondef(type, value) {
	    if (value == "*") {cx.marked = "keyword"; return cont(functiondef);}
	    if (type == "variable") {register(value); return cont(functiondef);}
	    if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, mayberettype, statement, popcontext);
	    if (isTS && value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, functiondef)
	  }
	  function functiondecl(type, value) {
	    if (value == "*") {cx.marked = "keyword"; return cont(functiondecl);}
	    if (type == "variable") {register(value); return cont(functiondecl);}
	    if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, mayberettype, popcontext);
	    if (isTS && value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, functiondecl)
	  }
	  function typename(type, value) {
	    if (type == "keyword" || type == "variable") {
	      cx.marked = "type"
	      return cont(typename)
	    } else if (value == "<") {
	      return cont(pushlex(">"), commasep(typeparam, ">"), poplex)
	    }
	  }
	  function funarg(type, value) {
	    if (value == "@") cont(expression, funarg)
	    if (type == "spread") return cont(funarg);
	    if (isTS && isModifier(value)) { cx.marked = "keyword"; return cont(funarg); }
	    if (isTS && type == "this") return cont(maybetype, maybeAssign)
	    return pass(pattern, maybetype, maybeAssign);
	  }
	  function classExpression(type, value) {
	    // Class expressions may have an optional name.
	    if (type == "variable") return className(type, value);
	    return classNameAfter(type, value);
	  }
	  function className(type, value) {
	    if (type == "variable") {register(value); return cont(classNameAfter);}
	  }
	  function classNameAfter(type, value) {
	    if (value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, classNameAfter)
	    if (value == "extends" || value == "implements" || (isTS && type == ",")) {
	      if (value == "implements") cx.marked = "keyword";
	      return cont(isTS ? typeexpr : expression, classNameAfter);
	    }
	    if (type == "{") return cont(pushlex("}"), classBody, poplex);
	  }
	  function classBody(type, value) {
	    if (type == "async" ||
	        (type == "variable" &&
	         (value == "static" || value == "get" || value == "set" || (isTS && isModifier(value))) &&
	         cx.stream.match(/^\s+[\w$\xa1-\uffff]/, false))) {
	      cx.marked = "keyword";
	      return cont(classBody);
	    }
	    if (type == "variable" || cx.style == "keyword") {
	      cx.marked = "property";
	      return cont(classfield, classBody);
	    }
	    if (type == "number" || type == "string") return cont(classfield, classBody);
	    if (type == "[")
	      return cont(expression, maybetype, expect("]"), classfield, classBody)
	    if (value == "*") {
	      cx.marked = "keyword";
	      return cont(classBody);
	    }
	    if (isTS && type == "(") return pass(functiondecl, classBody)
	    if (type == ";" || type == ",") return cont(classBody);
	    if (type == "}") return cont();
	    if (value == "@") return cont(expression, classBody)
	  }
	  function classfield(type, value) {
	    if (value == "!") return cont(classfield)
	    if (value == "?") return cont(classfield)
	    if (type == ":") return cont(typeexpr, maybeAssign)
	    if (value == "=") return cont(expressionNoComma)
	    var context = cx.state.lexical.prev, isInterface = context && context.info == "interface"
	    return pass(isInterface ? functiondecl : functiondef)
	  }
	  function afterExport(type, value) {
	    if (value == "*") { cx.marked = "keyword"; return cont(maybeFrom, expect(";")); }
	    if (value == "default") { cx.marked = "keyword"; return cont(expression, expect(";")); }
	    if (type == "{") return cont(commasep(exportField, "}"), maybeFrom, expect(";"));
	    return pass(statement);
	  }
	  function exportField(type, value) {
	    if (value == "as") { cx.marked = "keyword"; return cont(expect("variable")); }
	    if (type == "variable") return pass(expressionNoComma, exportField);
	  }
	  function afterImport(type) {
	    if (type == "string") return cont();
	    if (type == "(") return pass(expression);
	    if (type == ".") return pass(maybeoperatorComma);
	    return pass(importSpec, maybeMoreImports, maybeFrom);
	  }
	  function importSpec(type, value) {
	    if (type == "{") return contCommasep(importSpec, "}");
	    if (type == "variable") register(value);
	    if (value == "*") cx.marked = "keyword";
	    return cont(maybeAs);
	  }
	  function maybeMoreImports(type) {
	    if (type == ",") return cont(importSpec, maybeMoreImports)
	  }
	  function maybeAs(_type, value) {
	    if (value == "as") { cx.marked = "keyword"; return cont(importSpec); }
	  }
	  function maybeFrom(_type, value) {
	    if (value == "from") { cx.marked = "keyword"; return cont(expression); }
	  }
	  function arrayLiteral(type) {
	    if (type == "]") return cont();
	    return pass(commasep(expressionNoComma, "]"));
	  }
	  function enumdef() {
	    return pass(pushlex("form"), pattern, expect("{"), pushlex("}"), commasep(enummember, "}"), poplex, poplex)
	  }
	  function enummember() {
	    return pass(pattern, maybeAssign);
	  }
	
	  function isContinuedStatement(state, textAfter) {
	    return state.lastType == "operator" || state.lastType == "," ||
	      isOperatorChar.test(textAfter.charAt(0)) ||
	      /[,.]/.test(textAfter.charAt(0));
	  }
	
	  function expressionAllowed(stream, state, backUp) {
	    return state.tokenize == tokenBase &&
	      /^(?:operator|sof|keyword [bcd]|case|new|export|default|spread|[\[{}\(,;:]|=>)$/.test(state.lastType) ||
	      (state.lastType == "quasi" && /\{\s*$/.test(stream.string.slice(0, stream.pos - (backUp || 0))))
	  }
	
	  // Interface
	
	  return {
	    startState: function(basecolumn) {
	      var state = {
	        tokenize: tokenBase,
	        lastType: "sof",
	        cc: [],
	        lexical: new JSLexical((basecolumn || 0) - indentUnit, 0, "block", false),
	        localVars: parserConfig.localVars,
	        context: parserConfig.localVars && new Context(null, null, false),
	        indented: basecolumn || 0
	      };
	      if (parserConfig.globalVars && typeof parserConfig.globalVars == "object")
	        state.globalVars = parserConfig.globalVars;
	      return state;
	    },
	
	    token: function(stream, state) {
	      if (stream.sol()) {
	        if (!state.lexical.hasOwnProperty("align"))
	          state.lexical.align = false;
	        state.indented = stream.indentation();
	        findFatArrow(stream, state);
	      }
	      if (state.tokenize != tokenComment && stream.eatSpace()) return null;
	      var style = state.tokenize(stream, state);
	      if (type == "comment") return style;
	      state.lastType = type == "operator" && (content == "++" || content == "--") ? "incdec" : type;
	      return parseJS(state, style, type, content, stream);
	    },
	
	    indent: function(state, textAfter) {
	      if (state.tokenize == tokenComment || state.tokenize == tokenQuasi) return CodeMirror.Pass;
	      if (state.tokenize != tokenBase) return 0;
	      var firstChar = textAfter && textAfter.charAt(0), lexical = state.lexical, top
	      // Kludge to prevent 'maybelse' from blocking lexical scope pops
	      if (!/^\s*else\b/.test(textAfter)) for (var i = state.cc.length - 1; i >= 0; --i) {
	        var c = state.cc[i];
	        if (c == poplex) lexical = lexical.prev;
	        else if (c != maybeelse && c != popcontext) break;
	      }
	      while ((lexical.type == "stat" || lexical.type == "form") &&
	             (firstChar == "}" || ((top = state.cc[state.cc.length - 1]) &&
	                                   (top == maybeoperatorComma || top == maybeoperatorNoComma) &&
	                                   !/^[,\.=+\-*:?[\(]/.test(textAfter))))
	        lexical = lexical.prev;
	      if (statementIndent && lexical.type == ")" && lexical.prev.type == "stat")
	        lexical = lexical.prev;
	      var type = lexical.type, closing = firstChar == type;
	
	      if (type == "vardef") return lexical.indented + (state.lastType == "operator" || state.lastType == "," ? lexical.info.length + 1 : 0);
	      else if (type == "form" && firstChar == "{") return lexical.indented;
	      else if (type == "form") return lexical.indented + indentUnit;
	      else if (type == "stat")
	        return lexical.indented + (isContinuedStatement(state, textAfter) ? statementIndent || indentUnit : 0);
	      else if (lexical.info == "switch" && !closing && parserConfig.doubleIndentSwitch != false)
	        return lexical.indented + (/^(?:case|default)\b/.test(textAfter) ? indentUnit : 2 * indentUnit);
	      else if (lexical.align) return lexical.column + (closing ? 0 : 1);
	      else return lexical.indented + (closing ? 0 : indentUnit);
	    },
	
	    electricInput: /^\s*(?:case .*?:|default:|\{|\})$/,
	    blockCommentStart: jsonMode ? null : "/*",
	    blockCommentEnd: jsonMode ? null : "*/",
	    blockCommentContinue: jsonMode ? null : " * ",
	    lineComment: jsonMode ? null : "//",
	    fold: "brace",
	    closeBrackets: "()[]{}''\"\"``",
	
	    helperType: jsonMode ? "json" : "javascript",
	    jsonldMode: jsonldMode,
	    jsonMode: jsonMode,
	
	    expressionAllowed: expressionAllowed,
	
	    skipExpression: function(state) {
	      parseJS(state, "atom", "atom", "true", new CodeMirror.StringStream("", 2, null))
	    }
	  };
	});
	
	CodeMirror.registerHelper("wordChars", "javascript", /[\w$]/);
	
	CodeMirror.defineMIME("text/javascript", "javascript");
	CodeMirror.defineMIME("text/ecmascript", "javascript");
	CodeMirror.defineMIME("application/javascript", "javascript");
	CodeMirror.defineMIME("application/x-javascript", "javascript");
	CodeMirror.defineMIME("application/ecmascript", "javascript");
	CodeMirror.defineMIME("application/json", { name: "javascript", json: true });
	CodeMirror.defineMIME("application/x-json", { name: "javascript", json: true });
	CodeMirror.defineMIME("application/manifest+json", { name: "javascript", json: true })
	CodeMirror.defineMIME("application/ld+json", { name: "javascript", jsonld: true });
	CodeMirror.defineMIME("text/typescript", { name: "javascript", typescript: true });
	CodeMirror.defineMIME("application/typescript", { name: "javascript", typescript: true });
	
	});


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.cloneNode = exports.hasChildren = exports.isDocument = exports.isDirective = exports.isComment = exports.isText = exports.isCDATA = exports.isTag = exports.Element = exports.Document = exports.NodeWithChildren = exports.ProcessingInstruction = exports.Comment = exports.Text = exports.DataNode = exports.Node = void 0;
	var domelementtype_1 = __webpack_require__(612);
	var nodeTypes = new Map([
	    [domelementtype_1.ElementType.Tag, 1],
	    [domelementtype_1.ElementType.Script, 1],
	    [domelementtype_1.ElementType.Style, 1],
	    [domelementtype_1.ElementType.Directive, 1],
	    [domelementtype_1.ElementType.Text, 3],
	    [domelementtype_1.ElementType.CDATA, 4],
	    [domelementtype_1.ElementType.Comment, 8],
	    [domelementtype_1.ElementType.Root, 9],
	]);
	/**
	 * This object will be used as the prototype for Nodes when creating a
	 * DOM-Level-1-compliant structure.
	 */
	var Node = /** @class */ (function () {
	    /**
	     *
	     * @param type The type of the node.
	     */
	    function Node(type) {
	        this.type = type;
	        /** Parent of the node */
	        this.parent = null;
	        /** Previous sibling */
	        this.prev = null;
	        /** Next sibling */
	        this.next = null;
	        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */
	        this.startIndex = null;
	        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */
	        this.endIndex = null;
	    }
	    Object.defineProperty(Node.prototype, "nodeType", {
	        // Read-only aliases
	        /**
	         * [DOM spec](https://dom.spec.whatwg.org/#dom-node-nodetype)-compatible
	         * node {@link type}.
	         */
	        get: function () {
	            var _a;
	            return (_a = nodeTypes.get(this.type)) !== null && _a !== void 0 ? _a : 1;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Node.prototype, "parentNode", {
	        // Read-write aliases for properties
	        /**
	         * Same as {@link parent}.
	         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
	         */
	        get: function () {
	            return this.parent;
	        },
	        set: function (parent) {
	            this.parent = parent;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Node.prototype, "previousSibling", {
	        /**
	         * Same as {@link prev}.
	         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
	         */
	        get: function () {
	            return this.prev;
	        },
	        set: function (prev) {
	            this.prev = prev;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Node.prototype, "nextSibling", {
	        /**
	         * Same as {@link next}.
	         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
	         */
	        get: function () {
	            return this.next;
	        },
	        set: function (next) {
	            this.next = next;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Clone this node, and optionally its children.
	     *
	     * @param recursive Clone child nodes as well.
	     * @returns A clone of the node.
	     */
	    Node.prototype.cloneNode = function (recursive) {
	        if (recursive === void 0) { recursive = false; }
	        return cloneNode(this, recursive);
	    };
	    return Node;
	}());
	exports.Node = Node;
	/**
	 * A node that contains some data.
	 */
	var DataNode = /** @class */ (function (_super) {
	    __extends(DataNode, _super);
	    /**
	     * @param type The type of the node
	     * @param data The content of the data node
	     */
	    function DataNode(type, data) {
	        var _this = _super.call(this, type) || this;
	        _this.data = data;
	        return _this;
	    }
	    Object.defineProperty(DataNode.prototype, "nodeValue", {
	        /**
	         * Same as {@link data}.
	         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
	         */
	        get: function () {
	            return this.data;
	        },
	        set: function (data) {
	            this.data = data;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return DataNode;
	}(Node));
	exports.DataNode = DataNode;
	/**
	 * Text within the document.
	 */
	var Text = /** @class */ (function (_super) {
	    __extends(Text, _super);
	    function Text(data) {
	        return _super.call(this, domelementtype_1.ElementType.Text, data) || this;
	    }
	    return Text;
	}(DataNode));
	exports.Text = Text;
	/**
	 * Comments within the document.
	 */
	var Comment = /** @class */ (function (_super) {
	    __extends(Comment, _super);
	    function Comment(data) {
	        return _super.call(this, domelementtype_1.ElementType.Comment, data) || this;
	    }
	    return Comment;
	}(DataNode));
	exports.Comment = Comment;
	/**
	 * Processing instructions, including doc types.
	 */
	var ProcessingInstruction = /** @class */ (function (_super) {
	    __extends(ProcessingInstruction, _super);
	    function ProcessingInstruction(name, data) {
	        var _this = _super.call(this, domelementtype_1.ElementType.Directive, data) || this;
	        _this.name = name;
	        return _this;
	    }
	    return ProcessingInstruction;
	}(DataNode));
	exports.ProcessingInstruction = ProcessingInstruction;
	/**
	 * A `Node` that can have children.
	 */
	var NodeWithChildren = /** @class */ (function (_super) {
	    __extends(NodeWithChildren, _super);
	    /**
	     * @param type Type of the node.
	     * @param children Children of the node. Only certain node types can have children.
	     */
	    function NodeWithChildren(type, children) {
	        var _this = _super.call(this, type) || this;
	        _this.children = children;
	        return _this;
	    }
	    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
	        // Aliases
	        /** First child of the node. */
	        get: function () {
	            var _a;
	            return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
	        /** Last child of the node. */
	        get: function () {
	            return this.children.length > 0
	                ? this.children[this.children.length - 1]
	                : null;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
	        /**
	         * Same as {@link children}.
	         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
	         */
	        get: function () {
	            return this.children;
	        },
	        set: function (children) {
	            this.children = children;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return NodeWithChildren;
	}(Node));
	exports.NodeWithChildren = NodeWithChildren;
	/**
	 * The root node of the document.
	 */
	var Document = /** @class */ (function (_super) {
	    __extends(Document, _super);
	    function Document(children) {
	        return _super.call(this, domelementtype_1.ElementType.Root, children) || this;
	    }
	    return Document;
	}(NodeWithChildren));
	exports.Document = Document;
	/**
	 * An element within the DOM.
	 */
	var Element = /** @class */ (function (_super) {
	    __extends(Element, _super);
	    /**
	     * @param name Name of the tag, eg. `div`, `span`.
	     * @param attribs Object mapping attribute names to attribute values.
	     * @param children Children of the node.
	     */
	    function Element(name, attribs, children, type) {
	        if (children === void 0) { children = []; }
	        if (type === void 0) { type = name === "script"
	            ? domelementtype_1.ElementType.Script
	            : name === "style"
	                ? domelementtype_1.ElementType.Style
	                : domelementtype_1.ElementType.Tag; }
	        var _this = _super.call(this, type, children) || this;
	        _this.name = name;
	        _this.attribs = attribs;
	        return _this;
	    }
	    Object.defineProperty(Element.prototype, "tagName", {
	        // DOM Level 1 aliases
	        /**
	         * Same as {@link name}.
	         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
	         */
	        get: function () {
	            return this.name;
	        },
	        set: function (name) {
	            this.name = name;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Element.prototype, "attributes", {
	        get: function () {
	            var _this = this;
	            return Object.keys(this.attribs).map(function (name) {
	                var _a, _b;
	                return ({
	                    name: name,
	                    value: _this.attribs[name],
	                    namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
	                    prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name],
	                });
	            });
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return Element;
	}(NodeWithChildren));
	exports.Element = Element;
	/**
	 * @param node Node to check.
	 * @returns `true` if the node is a `Element`, `false` otherwise.
	 */
	function isTag(node) {
	    return (0, domelementtype_1.isTag)(node);
	}
	exports.isTag = isTag;
	/**
	 * @param node Node to check.
	 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
	 */
	function isCDATA(node) {
	    return node.type === domelementtype_1.ElementType.CDATA;
	}
	exports.isCDATA = isCDATA;
	/**
	 * @param node Node to check.
	 * @returns `true` if the node has the type `Text`, `false` otherwise.
	 */
	function isText(node) {
	    return node.type === domelementtype_1.ElementType.Text;
	}
	exports.isText = isText;
	/**
	 * @param node Node to check.
	 * @returns `true` if the node has the type `Comment`, `false` otherwise.
	 */
	function isComment(node) {
	    return node.type === domelementtype_1.ElementType.Comment;
	}
	exports.isComment = isComment;
	/**
	 * @param node Node to check.
	 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
	 */
	function isDirective(node) {
	    return node.type === domelementtype_1.ElementType.Directive;
	}
	exports.isDirective = isDirective;
	/**
	 * @param node Node to check.
	 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
	 */
	function isDocument(node) {
	    return node.type === domelementtype_1.ElementType.Root;
	}
	exports.isDocument = isDocument;
	/**
	 * @param node Node to check.
	 * @returns `true` if the node is a `NodeWithChildren` (has children), `false` otherwise.
	 */
	function hasChildren(node) {
	    return Object.prototype.hasOwnProperty.call(node, "children");
	}
	exports.hasChildren = hasChildren;
	/**
	 * Clone a node, and optionally its children.
	 *
	 * @param recursive Clone child nodes as well.
	 * @returns A clone of the node.
	 */
	function cloneNode(node, recursive) {
	    if (recursive === void 0) { recursive = false; }
	    var result;
	    if (isText(node)) {
	        result = new Text(node.data);
	    }
	    else if (isComment(node)) {
	        result = new Comment(node.data);
	    }
	    else if (isTag(node)) {
	        var children = recursive ? cloneChildren(node.children) : [];
	        var clone_1 = new Element(node.name, __assign({}, node.attribs), children);
	        children.forEach(function (child) { return (child.parent = clone_1); });
	        if (node.namespace != null) {
	            clone_1.namespace = node.namespace;
	        }
	        if (node["x-attribsNamespace"]) {
	            clone_1["x-attribsNamespace"] = __assign({}, node["x-attribsNamespace"]);
	        }
	        if (node["x-attribsPrefix"]) {
	            clone_1["x-attribsPrefix"] = __assign({}, node["x-attribsPrefix"]);
	        }
	        result = clone_1;
	    }
	    else if (isCDATA(node)) {
	        var children = recursive ? cloneChildren(node.children) : [];
	        var clone_2 = new NodeWithChildren(domelementtype_1.ElementType.CDATA, children);
	        children.forEach(function (child) { return (child.parent = clone_2); });
	        result = clone_2;
	    }
	    else if (isDocument(node)) {
	        var children = recursive ? cloneChildren(node.children) : [];
	        var clone_3 = new Document(children);
	        children.forEach(function (child) { return (child.parent = clone_3); });
	        if (node["x-mode"]) {
	            clone_3["x-mode"] = node["x-mode"];
	        }
	        result = clone_3;
	    }
	    else if (isDirective(node)) {
	        var instruction = new ProcessingInstruction(node.name, node.data);
	        if (node["x-name"] != null) {
	            instruction["x-name"] = node["x-name"];
	            instruction["x-publicId"] = node["x-publicId"];
	            instruction["x-systemId"] = node["x-systemId"];
	        }
	        result = instruction;
	    }
	    else {
	        throw new Error("Not implemented yet: ".concat(node.type));
	    }
	    result.startIndex = node.startIndex;
	    result.endIndex = node.endIndex;
	    if (node.sourceCodeLocation != null) {
	        result.sourceCodeLocation = node.sourceCodeLocation;
	    }
	    return result;
	}
	exports.cloneNode = cloneNode;
	function cloneChildren(childs) {
	    var children = childs.map(function (child) { return cloneNode(child, true); });
	    for (var i = 1; i < children.length; i++) {
	        children[i].prev = children[i - 1];
	        children[i - 1].next = children[i];
	    }
	    return children;
	}


/***/ },
/* 217 */
/***/ function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ },
/* 218 */
137,
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(37);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 220 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 221 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	__webpack_require__(496);
	module.exports = __webpack_require__(35).default;


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(649);
	} else {
	  module.exports = require('./cjs/history.js');
	}


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	var constants = __webpack_require__(651);
	var domhandler = __webpack_require__(216);
	
	var CASE_SENSITIVE_TAG_NAMES = constants.CASE_SENSITIVE_TAG_NAMES;
	
	var Comment = domhandler.Comment;
	var Element = domhandler.Element;
	var ProcessingInstruction = domhandler.ProcessingInstruction;
	var Text = domhandler.Text;
	
	var caseSensitiveTagNamesMap = {};
	var tagName;
	
	for (var i = 0, len = CASE_SENSITIVE_TAG_NAMES.length; i < len; i++) {
	  tagName = CASE_SENSITIVE_TAG_NAMES[i];
	  caseSensitiveTagNamesMap[tagName.toLowerCase()] = tagName;
	}
	
	/**
	 * Gets case-sensitive tag name.
	 *
	 * @param  {string}           tagName - Tag name in lowercase.
	 * @return {string|undefined}         - Case-sensitive tag name.
	 */
	function getCaseSensitiveTagName(tagName) {
	  return caseSensitiveTagNamesMap[tagName];
	}
	
	/**
	 * Formats DOM attributes to a hash map.
	 *
	 * @param  {NamedNodeMap} attributes - List of attributes.
	 * @return {object}                  - Map of attribute name to value.
	 */
	function formatAttributes(attributes) {
	  var result = {};
	  var attribute;
	  // `NamedNodeMap` is array-like
	  for (var i = 0, len = attributes.length; i < len; i++) {
	    attribute = attributes[i];
	    result[attribute.name] = attribute.value;
	  }
	  return result;
	}
	
	/**
	 * Corrects the tag name if it is case-sensitive (SVG).
	 * Otherwise, returns the lowercase tag name (HTML).
	 *
	 * @param  {string} tagName - Lowercase tag name.
	 * @return {string}         - Formatted tag name.
	 */
	function formatTagName(tagName) {
	  tagName = tagName.toLowerCase();
	  var caseSensitiveTagName = getCaseSensitiveTagName(tagName);
	  if (caseSensitiveTagName) {
	    return caseSensitiveTagName;
	  }
	  return tagName;
	}
	
	/**
	 * Transforms DOM nodes to `domhandler` nodes.
	 *
	 * @param  {NodeList}     nodes         - DOM nodes.
	 * @param  {Element|null} [parent=null] - Parent node.
	 * @param  {string}       [directive]   - Directive.
	 * @return {Array<Comment|Element|ProcessingInstruction|Text>}
	 */
	function formatDOM(nodes, parent, directive) {
	  parent = parent || null;
	  var result = [];
	
	  for (var index = 0, len = nodes.length; index < len; index++) {
	    var node = nodes[index];
	    var current;
	
	    // set the node data given the type
	    switch (node.nodeType) {
	      case 1:
	        // script, style, or tag
	        current = new Element(
	          formatTagName(node.nodeName),
	          formatAttributes(node.attributes)
	        );
	        current.children = formatDOM(node.childNodes, current);
	        break;
	
	      case 3:
	        current = new Text(node.nodeValue);
	        break;
	
	      case 8:
	        current = new Comment(node.nodeValue);
	        break;
	
	      default:
	        continue;
	    }
	
	    // set previous node next
	    var prev = result[index - 1] || null;
	    if (prev) {
	      prev.next = current;
	    }
	
	    // set properties for current node
	    current.parent = parent;
	    current.prev = prev;
	    current.next = null;
	
	    result.push(current);
	  }
	
	  if (directive) {
	    current = new ProcessingInstruction(
	      directive.substring(0, directive.indexOf(' ')).toLowerCase(),
	      directive
	    );
	    current.next = result[0] || null;
	    current.parent = parent;
	    result.unshift(current);
	
	    if (result[1]) {
	      result[1].prev = result[0];
	    }
	  }
	
	  return result;
	}
	
	/**
	 * Detects if browser is Internet Explorer.
	 *
	 * @return {boolean} - Whether IE is detected.
	 */
	function isIE() {
	  return /(MSIE |Trident\/|Edge\/)/.test(navigator.userAgent);
	}
	
	module.exports = {
	  formatAttributes: formatAttributes,
	  formatDOM: formatDOM,
	  isIE: isIE
	};


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	var reactProperty = __webpack_require__(768);
	var utilities = __webpack_require__(226);
	
	/**
	 * Converts HTML/SVG DOM attributes to React props.
	 *
	 * @param  {object} [attributes={}] - HTML/SVG DOM attributes.
	 * @return {object}                 - React props.
	 */
	module.exports = function attributesToProps(attributes) {
	  attributes = attributes || {};
	
	  var valueOnlyInputs = {
	    reset: true,
	    submit: true
	  };
	
	  var attributeName;
	  var attributeNameLowerCased;
	  var attributeValue;
	  var propName;
	  var propertyInfo;
	  var props = {};
	  var inputIsValueOnly = attributes.type && valueOnlyInputs[attributes.type];
	
	  for (attributeName in attributes) {
	    attributeValue = attributes[attributeName];
	
	    // ARIA (aria-*) or custom data (data-*) attribute
	    if (reactProperty.isCustomAttribute(attributeName)) {
	      props[attributeName] = attributeValue;
	      continue;
	    }
	
	    // convert HTML/SVG attribute to React prop
	    attributeNameLowerCased = attributeName.toLowerCase();
	    propName = getPropName(attributeNameLowerCased);
	
	    if (propName) {
	      propertyInfo = reactProperty.getPropertyInfo(propName);
	
	      // convert attribute to uncontrolled component prop (e.g., `value` to `defaultValue`)
	      // https://reactjs.org/docs/uncontrolled-components.html
	      if (
	        (propName === 'checked' || propName === 'value') &&
	        !inputIsValueOnly
	      ) {
	        propName = getPropName('default' + attributeNameLowerCased);
	      }
	
	      props[propName] = attributeValue;
	
	      switch (propertyInfo && propertyInfo.type) {
	        case reactProperty.BOOLEAN:
	          props[propName] = true;
	          break;
	        case reactProperty.OVERLOADED_BOOLEAN:
	          if (attributeValue === '') {
	            props[propName] = true;
	          }
	          break;
	      }
	      continue;
	    }
	
	    // preserve custom attribute if React >=16
	    if (utilities.PRESERVE_CUSTOM_ATTRIBUTES) {
	      props[attributeName] = attributeValue;
	    }
	  }
	
	  // transform inline style to object
	  utilities.setStyleProp(attributes.style, props);
	
	  return props;
	};
	
	/**
	 * Gets prop name from lowercased attribute name.
	 *
	 * @param {string} attributeName - Lowercased attribute name.
	 * @return {string}
	 */
	function getPropName(attributeName) {
	  return reactProperty.possibleStandardNames[attributeName];
	}


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(3);
	var styleToJS = __webpack_require__(816).default;
	
	/**
	 * Swap key with value in an object.
	 *
	 * @param  {Object}   obj        - The object.
	 * @param  {Function} [override] - The override method.
	 * @return {Object}              - The inverted object.
	 */
	function invertObject(obj, override) {
	  if (!obj || typeof obj !== 'object') {
	    throw new TypeError('First argument must be an object');
	  }
	
	  var key;
	  var value;
	  var isOverridePresent = typeof override === 'function';
	  var overrides = {};
	  var result = {};
	
	  for (key in obj) {
	    value = obj[key];
	
	    if (isOverridePresent) {
	      overrides = override(key, value);
	      if (overrides && overrides.length === 2) {
	        result[overrides[0]] = overrides[1];
	        continue;
	      }
	    }
	
	    if (typeof value === 'string') {
	      result[value] = key;
	    }
	  }
	
	  return result;
	}
	
	/**
	 * Check if a given tag is a custom component.
	 *
	 * @see {@link https://github.com/facebook/react/blob/v16.6.3/packages/react-dom/src/shared/isCustomComponent.js}
	 *
	 * @param {string} tagName - The name of the html tag.
	 * @param {Object} props   - The props being passed to the element.
	 * @return {boolean}
	 */
	function isCustomComponent(tagName, props) {
	  if (tagName.indexOf('-') === -1) {
	    return props && typeof props.is === 'string';
	  }
	
	  switch (tagName) {
	    // These are reserved SVG and MathML elements.
	    // We don't mind this whitelist too much because we expect it to never grow.
	    // The alternative is to track the namespace in a few places which is convoluted.
	    // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
	    case 'annotation-xml':
	    case 'color-profile':
	    case 'font-face':
	    case 'font-face-src':
	    case 'font-face-uri':
	    case 'font-face-format':
	    case 'font-face-name':
	    case 'missing-glyph':
	      return false;
	    default:
	      return true;
	  }
	}
	
	var styleToJSOptions = { reactCompat: true };
	
	/**
	 * Sets style prop.
	 *
	 * @param {null|undefined|string} style
	 * @param {object} props
	 */
	function setStyleProp(style, props) {
	  if (style === null || style === undefined) {
	    return;
	  }
	  try {
	    props.style = styleToJS(style, styleToJSOptions);
	  } catch (err) {
	    props.style = {};
	  }
	}
	
	/**
	 * @constant {boolean}
	 * @see {@link https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html}
	 */
	var PRESERVE_CUSTOM_ATTRIBUTES = React.version.split('.')[0] >= 16;
	
	// Taken from
	// https://github.com/facebook/react/blob/cae635054e17a6f107a39d328649137b83f25972/packages/react-dom/src/client/validateDOMNesting.js#L213
	var elementsWithNoTextChildren = new Set([
	  'tr',
	  'tbody',
	  'thead',
	  'tfoot',
	  'colgroup',
	  'table',
	  'head',
	  'html',
	  'frameset'
	]);
	
	/**
	 * Checks if the given node can contain text nodes
	 *
	 * @param {DomElement} node
	 * @returns {boolean}
	 */
	function canTextBeChildOfNode(node) {
	  return !elementsWithNoTextChildren.has(node.name);
	}
	
	module.exports = {
	  PRESERVE_CUSTOM_ATTRIBUTES: PRESERVE_CUSTOM_ATTRIBUTES,
	  invertObject: invertObject,
	  isCustomComponent: isCustomComponent,
	  setStyleProp: setStyleProp,
	  canTextBeChildOfNode: canTextBeChildOfNode,
	  elementsWithNoTextChildren: elementsWithNoTextChildren
	};


/***/ },
/* 227 */
/***/ function(module, exports) {

	module.exports = {
		"Aacute": "Á",
		"aacute": "á",
		"Abreve": "Ă",
		"abreve": "ă",
		"ac": "∾",
		"acd": "∿",
		"acE": "∾̳",
		"Acirc": "Â",
		"acirc": "â",
		"acute": "´",
		"Acy": "А",
		"acy": "а",
		"AElig": "Æ",
		"aelig": "æ",
		"af": "⁡",
		"Afr": "𝔄",
		"afr": "𝔞",
		"Agrave": "À",
		"agrave": "à",
		"alefsym": "ℵ",
		"aleph": "ℵ",
		"Alpha": "Α",
		"alpha": "α",
		"Amacr": "Ā",
		"amacr": "ā",
		"amalg": "⨿",
		"amp": "&",
		"AMP": "&",
		"andand": "⩕",
		"And": "⩓",
		"and": "∧",
		"andd": "⩜",
		"andslope": "⩘",
		"andv": "⩚",
		"ang": "∠",
		"ange": "⦤",
		"angle": "∠",
		"angmsdaa": "⦨",
		"angmsdab": "⦩",
		"angmsdac": "⦪",
		"angmsdad": "⦫",
		"angmsdae": "⦬",
		"angmsdaf": "⦭",
		"angmsdag": "⦮",
		"angmsdah": "⦯",
		"angmsd": "∡",
		"angrt": "∟",
		"angrtvb": "⊾",
		"angrtvbd": "⦝",
		"angsph": "∢",
		"angst": "Å",
		"angzarr": "⍼",
		"Aogon": "Ą",
		"aogon": "ą",
		"Aopf": "𝔸",
		"aopf": "𝕒",
		"apacir": "⩯",
		"ap": "≈",
		"apE": "⩰",
		"ape": "≊",
		"apid": "≋",
		"apos": "'",
		"ApplyFunction": "⁡",
		"approx": "≈",
		"approxeq": "≊",
		"Aring": "Å",
		"aring": "å",
		"Ascr": "𝒜",
		"ascr": "𝒶",
		"Assign": "≔",
		"ast": "*",
		"asymp": "≈",
		"asympeq": "≍",
		"Atilde": "Ã",
		"atilde": "ã",
		"Auml": "Ä",
		"auml": "ä",
		"awconint": "∳",
		"awint": "⨑",
		"backcong": "≌",
		"backepsilon": "϶",
		"backprime": "‵",
		"backsim": "∽",
		"backsimeq": "⋍",
		"Backslash": "∖",
		"Barv": "⫧",
		"barvee": "⊽",
		"barwed": "⌅",
		"Barwed": "⌆",
		"barwedge": "⌅",
		"bbrk": "⎵",
		"bbrktbrk": "⎶",
		"bcong": "≌",
		"Bcy": "Б",
		"bcy": "б",
		"bdquo": "„",
		"becaus": "∵",
		"because": "∵",
		"Because": "∵",
		"bemptyv": "⦰",
		"bepsi": "϶",
		"bernou": "ℬ",
		"Bernoullis": "ℬ",
		"Beta": "Β",
		"beta": "β",
		"beth": "ℶ",
		"between": "≬",
		"Bfr": "𝔅",
		"bfr": "𝔟",
		"bigcap": "⋂",
		"bigcirc": "◯",
		"bigcup": "⋃",
		"bigodot": "⨀",
		"bigoplus": "⨁",
		"bigotimes": "⨂",
		"bigsqcup": "⨆",
		"bigstar": "★",
		"bigtriangledown": "▽",
		"bigtriangleup": "△",
		"biguplus": "⨄",
		"bigvee": "⋁",
		"bigwedge": "⋀",
		"bkarow": "⤍",
		"blacklozenge": "⧫",
		"blacksquare": "▪",
		"blacktriangle": "▴",
		"blacktriangledown": "▾",
		"blacktriangleleft": "◂",
		"blacktriangleright": "▸",
		"blank": "␣",
		"blk12": "▒",
		"blk14": "░",
		"blk34": "▓",
		"block": "█",
		"bne": "=⃥",
		"bnequiv": "≡⃥",
		"bNot": "⫭",
		"bnot": "⌐",
		"Bopf": "𝔹",
		"bopf": "𝕓",
		"bot": "⊥",
		"bottom": "⊥",
		"bowtie": "⋈",
		"boxbox": "⧉",
		"boxdl": "┐",
		"boxdL": "╕",
		"boxDl": "╖",
		"boxDL": "╗",
		"boxdr": "┌",
		"boxdR": "╒",
		"boxDr": "╓",
		"boxDR": "╔",
		"boxh": "─",
		"boxH": "═",
		"boxhd": "┬",
		"boxHd": "╤",
		"boxhD": "╥",
		"boxHD": "╦",
		"boxhu": "┴",
		"boxHu": "╧",
		"boxhU": "╨",
		"boxHU": "╩",
		"boxminus": "⊟",
		"boxplus": "⊞",
		"boxtimes": "⊠",
		"boxul": "┘",
		"boxuL": "╛",
		"boxUl": "╜",
		"boxUL": "╝",
		"boxur": "└",
		"boxuR": "╘",
		"boxUr": "╙",
		"boxUR": "╚",
		"boxv": "│",
		"boxV": "║",
		"boxvh": "┼",
		"boxvH": "╪",
		"boxVh": "╫",
		"boxVH": "╬",
		"boxvl": "┤",
		"boxvL": "╡",
		"boxVl": "╢",
		"boxVL": "╣",
		"boxvr": "├",
		"boxvR": "╞",
		"boxVr": "╟",
		"boxVR": "╠",
		"bprime": "‵",
		"breve": "˘",
		"Breve": "˘",
		"brvbar": "¦",
		"bscr": "𝒷",
		"Bscr": "ℬ",
		"bsemi": "⁏",
		"bsim": "∽",
		"bsime": "⋍",
		"bsolb": "⧅",
		"bsol": "\\",
		"bsolhsub": "⟈",
		"bull": "•",
		"bullet": "•",
		"bump": "≎",
		"bumpE": "⪮",
		"bumpe": "≏",
		"Bumpeq": "≎",
		"bumpeq": "≏",
		"Cacute": "Ć",
		"cacute": "ć",
		"capand": "⩄",
		"capbrcup": "⩉",
		"capcap": "⩋",
		"cap": "∩",
		"Cap": "⋒",
		"capcup": "⩇",
		"capdot": "⩀",
		"CapitalDifferentialD": "ⅅ",
		"caps": "∩︀",
		"caret": "⁁",
		"caron": "ˇ",
		"Cayleys": "ℭ",
		"ccaps": "⩍",
		"Ccaron": "Č",
		"ccaron": "č",
		"Ccedil": "Ç",
		"ccedil": "ç",
		"Ccirc": "Ĉ",
		"ccirc": "ĉ",
		"Cconint": "∰",
		"ccups": "⩌",
		"ccupssm": "⩐",
		"Cdot": "Ċ",
		"cdot": "ċ",
		"cedil": "¸",
		"Cedilla": "¸",
		"cemptyv": "⦲",
		"cent": "¢",
		"centerdot": "·",
		"CenterDot": "·",
		"cfr": "𝔠",
		"Cfr": "ℭ",
		"CHcy": "Ч",
		"chcy": "ч",
		"check": "✓",
		"checkmark": "✓",
		"Chi": "Χ",
		"chi": "χ",
		"circ": "ˆ",
		"circeq": "≗",
		"circlearrowleft": "↺",
		"circlearrowright": "↻",
		"circledast": "⊛",
		"circledcirc": "⊚",
		"circleddash": "⊝",
		"CircleDot": "⊙",
		"circledR": "®",
		"circledS": "Ⓢ",
		"CircleMinus": "⊖",
		"CirclePlus": "⊕",
		"CircleTimes": "⊗",
		"cir": "○",
		"cirE": "⧃",
		"cire": "≗",
		"cirfnint": "⨐",
		"cirmid": "⫯",
		"cirscir": "⧂",
		"ClockwiseContourIntegral": "∲",
		"CloseCurlyDoubleQuote": "”",
		"CloseCurlyQuote": "’",
		"clubs": "♣",
		"clubsuit": "♣",
		"colon": ":",
		"Colon": "∷",
		"Colone": "⩴",
		"colone": "≔",
		"coloneq": "≔",
		"comma": ",",
		"commat": "@",
		"comp": "∁",
		"compfn": "∘",
		"complement": "∁",
		"complexes": "ℂ",
		"cong": "≅",
		"congdot": "⩭",
		"Congruent": "≡",
		"conint": "∮",
		"Conint": "∯",
		"ContourIntegral": "∮",
		"copf": "𝕔",
		"Copf": "ℂ",
		"coprod": "∐",
		"Coproduct": "∐",
		"copy": "©",
		"COPY": "©",
		"copysr": "℗",
		"CounterClockwiseContourIntegral": "∳",
		"crarr": "↵",
		"cross": "✗",
		"Cross": "⨯",
		"Cscr": "𝒞",
		"cscr": "𝒸",
		"csub": "⫏",
		"csube": "⫑",
		"csup": "⫐",
		"csupe": "⫒",
		"ctdot": "⋯",
		"cudarrl": "⤸",
		"cudarrr": "⤵",
		"cuepr": "⋞",
		"cuesc": "⋟",
		"cularr": "↶",
		"cularrp": "⤽",
		"cupbrcap": "⩈",
		"cupcap": "⩆",
		"CupCap": "≍",
		"cup": "∪",
		"Cup": "⋓",
		"cupcup": "⩊",
		"cupdot": "⊍",
		"cupor": "⩅",
		"cups": "∪︀",
		"curarr": "↷",
		"curarrm": "⤼",
		"curlyeqprec": "⋞",
		"curlyeqsucc": "⋟",
		"curlyvee": "⋎",
		"curlywedge": "⋏",
		"curren": "¤",
		"curvearrowleft": "↶",
		"curvearrowright": "↷",
		"cuvee": "⋎",
		"cuwed": "⋏",
		"cwconint": "∲",
		"cwint": "∱",
		"cylcty": "⌭",
		"dagger": "†",
		"Dagger": "‡",
		"daleth": "ℸ",
		"darr": "↓",
		"Darr": "↡",
		"dArr": "⇓",
		"dash": "‐",
		"Dashv": "⫤",
		"dashv": "⊣",
		"dbkarow": "⤏",
		"dblac": "˝",
		"Dcaron": "Ď",
		"dcaron": "ď",
		"Dcy": "Д",
		"dcy": "д",
		"ddagger": "‡",
		"ddarr": "⇊",
		"DD": "ⅅ",
		"dd": "ⅆ",
		"DDotrahd": "⤑",
		"ddotseq": "⩷",
		"deg": "°",
		"Del": "∇",
		"Delta": "Δ",
		"delta": "δ",
		"demptyv": "⦱",
		"dfisht": "⥿",
		"Dfr": "𝔇",
		"dfr": "𝔡",
		"dHar": "⥥",
		"dharl": "⇃",
		"dharr": "⇂",
		"DiacriticalAcute": "´",
		"DiacriticalDot": "˙",
		"DiacriticalDoubleAcute": "˝",
		"DiacriticalGrave": "`",
		"DiacriticalTilde": "˜",
		"diam": "⋄",
		"diamond": "⋄",
		"Diamond": "⋄",
		"diamondsuit": "♦",
		"diams": "♦",
		"die": "¨",
		"DifferentialD": "ⅆ",
		"digamma": "ϝ",
		"disin": "⋲",
		"div": "÷",
		"divide": "÷",
		"divideontimes": "⋇",
		"divonx": "⋇",
		"DJcy": "Ђ",
		"djcy": "ђ",
		"dlcorn": "⌞",
		"dlcrop": "⌍",
		"dollar": "$",
		"Dopf": "𝔻",
		"dopf": "𝕕",
		"Dot": "¨",
		"dot": "˙",
		"DotDot": "⃜",
		"doteq": "≐",
		"doteqdot": "≑",
		"DotEqual": "≐",
		"dotminus": "∸",
		"dotplus": "∔",
		"dotsquare": "⊡",
		"doublebarwedge": "⌆",
		"DoubleContourIntegral": "∯",
		"DoubleDot": "¨",
		"DoubleDownArrow": "⇓",
		"DoubleLeftArrow": "⇐",
		"DoubleLeftRightArrow": "⇔",
		"DoubleLeftTee": "⫤",
		"DoubleLongLeftArrow": "⟸",
		"DoubleLongLeftRightArrow": "⟺",
		"DoubleLongRightArrow": "⟹",
		"DoubleRightArrow": "⇒",
		"DoubleRightTee": "⊨",
		"DoubleUpArrow": "⇑",
		"DoubleUpDownArrow": "⇕",
		"DoubleVerticalBar": "∥",
		"DownArrowBar": "⤓",
		"downarrow": "↓",
		"DownArrow": "↓",
		"Downarrow": "⇓",
		"DownArrowUpArrow": "⇵",
		"DownBreve": "̑",
		"downdownarrows": "⇊",
		"downharpoonleft": "⇃",
		"downharpoonright": "⇂",
		"DownLeftRightVector": "⥐",
		"DownLeftTeeVector": "⥞",
		"DownLeftVectorBar": "⥖",
		"DownLeftVector": "↽",
		"DownRightTeeVector": "⥟",
		"DownRightVectorBar": "⥗",
		"DownRightVector": "⇁",
		"DownTeeArrow": "↧",
		"DownTee": "⊤",
		"drbkarow": "⤐",
		"drcorn": "⌟",
		"drcrop": "⌌",
		"Dscr": "𝒟",
		"dscr": "𝒹",
		"DScy": "Ѕ",
		"dscy": "ѕ",
		"dsol": "⧶",
		"Dstrok": "Đ",
		"dstrok": "đ",
		"dtdot": "⋱",
		"dtri": "▿",
		"dtrif": "▾",
		"duarr": "⇵",
		"duhar": "⥯",
		"dwangle": "⦦",
		"DZcy": "Џ",
		"dzcy": "џ",
		"dzigrarr": "⟿",
		"Eacute": "É",
		"eacute": "é",
		"easter": "⩮",
		"Ecaron": "Ě",
		"ecaron": "ě",
		"Ecirc": "Ê",
		"ecirc": "ê",
		"ecir": "≖",
		"ecolon": "≕",
		"Ecy": "Э",
		"ecy": "э",
		"eDDot": "⩷",
		"Edot": "Ė",
		"edot": "ė",
		"eDot": "≑",
		"ee": "ⅇ",
		"efDot": "≒",
		"Efr": "𝔈",
		"efr": "𝔢",
		"eg": "⪚",
		"Egrave": "È",
		"egrave": "è",
		"egs": "⪖",
		"egsdot": "⪘",
		"el": "⪙",
		"Element": "∈",
		"elinters": "⏧",
		"ell": "ℓ",
		"els": "⪕",
		"elsdot": "⪗",
		"Emacr": "Ē",
		"emacr": "ē",
		"empty": "∅",
		"emptyset": "∅",
		"EmptySmallSquare": "◻",
		"emptyv": "∅",
		"EmptyVerySmallSquare": "▫",
		"emsp13": " ",
		"emsp14": " ",
		"emsp": " ",
		"ENG": "Ŋ",
		"eng": "ŋ",
		"ensp": " ",
		"Eogon": "Ę",
		"eogon": "ę",
		"Eopf": "𝔼",
		"eopf": "𝕖",
		"epar": "⋕",
		"eparsl": "⧣",
		"eplus": "⩱",
		"epsi": "ε",
		"Epsilon": "Ε",
		"epsilon": "ε",
		"epsiv": "ϵ",
		"eqcirc": "≖",
		"eqcolon": "≕",
		"eqsim": "≂",
		"eqslantgtr": "⪖",
		"eqslantless": "⪕",
		"Equal": "⩵",
		"equals": "=",
		"EqualTilde": "≂",
		"equest": "≟",
		"Equilibrium": "⇌",
		"equiv": "≡",
		"equivDD": "⩸",
		"eqvparsl": "⧥",
		"erarr": "⥱",
		"erDot": "≓",
		"escr": "ℯ",
		"Escr": "ℰ",
		"esdot": "≐",
		"Esim": "⩳",
		"esim": "≂",
		"Eta": "Η",
		"eta": "η",
		"ETH": "Ð",
		"eth": "ð",
		"Euml": "Ë",
		"euml": "ë",
		"euro": "€",
		"excl": "!",
		"exist": "∃",
		"Exists": "∃",
		"expectation": "ℰ",
		"exponentiale": "ⅇ",
		"ExponentialE": "ⅇ",
		"fallingdotseq": "≒",
		"Fcy": "Ф",
		"fcy": "ф",
		"female": "♀",
		"ffilig": "ﬃ",
		"fflig": "ﬀ",
		"ffllig": "ﬄ",
		"Ffr": "𝔉",
		"ffr": "𝔣",
		"filig": "ﬁ",
		"FilledSmallSquare": "◼",
		"FilledVerySmallSquare": "▪",
		"fjlig": "fj",
		"flat": "♭",
		"fllig": "ﬂ",
		"fltns": "▱",
		"fnof": "ƒ",
		"Fopf": "𝔽",
		"fopf": "𝕗",
		"forall": "∀",
		"ForAll": "∀",
		"fork": "⋔",
		"forkv": "⫙",
		"Fouriertrf": "ℱ",
		"fpartint": "⨍",
		"frac12": "½",
		"frac13": "⅓",
		"frac14": "¼",
		"frac15": "⅕",
		"frac16": "⅙",
		"frac18": "⅛",
		"frac23": "⅔",
		"frac25": "⅖",
		"frac34": "¾",
		"frac35": "⅗",
		"frac38": "⅜",
		"frac45": "⅘",
		"frac56": "⅚",
		"frac58": "⅝",
		"frac78": "⅞",
		"frasl": "⁄",
		"frown": "⌢",
		"fscr": "𝒻",
		"Fscr": "ℱ",
		"gacute": "ǵ",
		"Gamma": "Γ",
		"gamma": "γ",
		"Gammad": "Ϝ",
		"gammad": "ϝ",
		"gap": "⪆",
		"Gbreve": "Ğ",
		"gbreve": "ğ",
		"Gcedil": "Ģ",
		"Gcirc": "Ĝ",
		"gcirc": "ĝ",
		"Gcy": "Г",
		"gcy": "г",
		"Gdot": "Ġ",
		"gdot": "ġ",
		"ge": "≥",
		"gE": "≧",
		"gEl": "⪌",
		"gel": "⋛",
		"geq": "≥",
		"geqq": "≧",
		"geqslant": "⩾",
		"gescc": "⪩",
		"ges": "⩾",
		"gesdot": "⪀",
		"gesdoto": "⪂",
		"gesdotol": "⪄",
		"gesl": "⋛︀",
		"gesles": "⪔",
		"Gfr": "𝔊",
		"gfr": "𝔤",
		"gg": "≫",
		"Gg": "⋙",
		"ggg": "⋙",
		"gimel": "ℷ",
		"GJcy": "Ѓ",
		"gjcy": "ѓ",
		"gla": "⪥",
		"gl": "≷",
		"glE": "⪒",
		"glj": "⪤",
		"gnap": "⪊",
		"gnapprox": "⪊",
		"gne": "⪈",
		"gnE": "≩",
		"gneq": "⪈",
		"gneqq": "≩",
		"gnsim": "⋧",
		"Gopf": "𝔾",
		"gopf": "𝕘",
		"grave": "`",
		"GreaterEqual": "≥",
		"GreaterEqualLess": "⋛",
		"GreaterFullEqual": "≧",
		"GreaterGreater": "⪢",
		"GreaterLess": "≷",
		"GreaterSlantEqual": "⩾",
		"GreaterTilde": "≳",
		"Gscr": "𝒢",
		"gscr": "ℊ",
		"gsim": "≳",
		"gsime": "⪎",
		"gsiml": "⪐",
		"gtcc": "⪧",
		"gtcir": "⩺",
		"gt": ">",
		"GT": ">",
		"Gt": "≫",
		"gtdot": "⋗",
		"gtlPar": "⦕",
		"gtquest": "⩼",
		"gtrapprox": "⪆",
		"gtrarr": "⥸",
		"gtrdot": "⋗",
		"gtreqless": "⋛",
		"gtreqqless": "⪌",
		"gtrless": "≷",
		"gtrsim": "≳",
		"gvertneqq": "≩︀",
		"gvnE": "≩︀",
		"Hacek": "ˇ",
		"hairsp": " ",
		"half": "½",
		"hamilt": "ℋ",
		"HARDcy": "Ъ",
		"hardcy": "ъ",
		"harrcir": "⥈",
		"harr": "↔",
		"hArr": "⇔",
		"harrw": "↭",
		"Hat": "^",
		"hbar": "ℏ",
		"Hcirc": "Ĥ",
		"hcirc": "ĥ",
		"hearts": "♥",
		"heartsuit": "♥",
		"hellip": "…",
		"hercon": "⊹",
		"hfr": "𝔥",
		"Hfr": "ℌ",
		"HilbertSpace": "ℋ",
		"hksearow": "⤥",
		"hkswarow": "⤦",
		"hoarr": "⇿",
		"homtht": "∻",
		"hookleftarrow": "↩",
		"hookrightarrow": "↪",
		"hopf": "𝕙",
		"Hopf": "ℍ",
		"horbar": "―",
		"HorizontalLine": "─",
		"hscr": "𝒽",
		"Hscr": "ℋ",
		"hslash": "ℏ",
		"Hstrok": "Ħ",
		"hstrok": "ħ",
		"HumpDownHump": "≎",
		"HumpEqual": "≏",
		"hybull": "⁃",
		"hyphen": "‐",
		"Iacute": "Í",
		"iacute": "í",
		"ic": "⁣",
		"Icirc": "Î",
		"icirc": "î",
		"Icy": "И",
		"icy": "и",
		"Idot": "İ",
		"IEcy": "Е",
		"iecy": "е",
		"iexcl": "¡",
		"iff": "⇔",
		"ifr": "𝔦",
		"Ifr": "ℑ",
		"Igrave": "Ì",
		"igrave": "ì",
		"ii": "ⅈ",
		"iiiint": "⨌",
		"iiint": "∭",
		"iinfin": "⧜",
		"iiota": "℩",
		"IJlig": "Ĳ",
		"ijlig": "ĳ",
		"Imacr": "Ī",
		"imacr": "ī",
		"image": "ℑ",
		"ImaginaryI": "ⅈ",
		"imagline": "ℐ",
		"imagpart": "ℑ",
		"imath": "ı",
		"Im": "ℑ",
		"imof": "⊷",
		"imped": "Ƶ",
		"Implies": "⇒",
		"incare": "℅",
		"in": "∈",
		"infin": "∞",
		"infintie": "⧝",
		"inodot": "ı",
		"intcal": "⊺",
		"int": "∫",
		"Int": "∬",
		"integers": "ℤ",
		"Integral": "∫",
		"intercal": "⊺",
		"Intersection": "⋂",
		"intlarhk": "⨗",
		"intprod": "⨼",
		"InvisibleComma": "⁣",
		"InvisibleTimes": "⁢",
		"IOcy": "Ё",
		"iocy": "ё",
		"Iogon": "Į",
		"iogon": "į",
		"Iopf": "𝕀",
		"iopf": "𝕚",
		"Iota": "Ι",
		"iota": "ι",
		"iprod": "⨼",
		"iquest": "¿",
		"iscr": "𝒾",
		"Iscr": "ℐ",
		"isin": "∈",
		"isindot": "⋵",
		"isinE": "⋹",
		"isins": "⋴",
		"isinsv": "⋳",
		"isinv": "∈",
		"it": "⁢",
		"Itilde": "Ĩ",
		"itilde": "ĩ",
		"Iukcy": "І",
		"iukcy": "і",
		"Iuml": "Ï",
		"iuml": "ï",
		"Jcirc": "Ĵ",
		"jcirc": "ĵ",
		"Jcy": "Й",
		"jcy": "й",
		"Jfr": "𝔍",
		"jfr": "𝔧",
		"jmath": "ȷ",
		"Jopf": "𝕁",
		"jopf": "𝕛",
		"Jscr": "𝒥",
		"jscr": "𝒿",
		"Jsercy": "Ј",
		"jsercy": "ј",
		"Jukcy": "Є",
		"jukcy": "є",
		"Kappa": "Κ",
		"kappa": "κ",
		"kappav": "ϰ",
		"Kcedil": "Ķ",
		"kcedil": "ķ",
		"Kcy": "К",
		"kcy": "к",
		"Kfr": "𝔎",
		"kfr": "𝔨",
		"kgreen": "ĸ",
		"KHcy": "Х",
		"khcy": "х",
		"KJcy": "Ќ",
		"kjcy": "ќ",
		"Kopf": "𝕂",
		"kopf": "𝕜",
		"Kscr": "𝒦",
		"kscr": "𝓀",
		"lAarr": "⇚",
		"Lacute": "Ĺ",
		"lacute": "ĺ",
		"laemptyv": "⦴",
		"lagran": "ℒ",
		"Lambda": "Λ",
		"lambda": "λ",
		"lang": "⟨",
		"Lang": "⟪",
		"langd": "⦑",
		"langle": "⟨",
		"lap": "⪅",
		"Laplacetrf": "ℒ",
		"laquo": "«",
		"larrb": "⇤",
		"larrbfs": "⤟",
		"larr": "←",
		"Larr": "↞",
		"lArr": "⇐",
		"larrfs": "⤝",
		"larrhk": "↩",
		"larrlp": "↫",
		"larrpl": "⤹",
		"larrsim": "⥳",
		"larrtl": "↢",
		"latail": "⤙",
		"lAtail": "⤛",
		"lat": "⪫",
		"late": "⪭",
		"lates": "⪭︀",
		"lbarr": "⤌",
		"lBarr": "⤎",
		"lbbrk": "❲",
		"lbrace": "{",
		"lbrack": "[",
		"lbrke": "⦋",
		"lbrksld": "⦏",
		"lbrkslu": "⦍",
		"Lcaron": "Ľ",
		"lcaron": "ľ",
		"Lcedil": "Ļ",
		"lcedil": "ļ",
		"lceil": "⌈",
		"lcub": "{",
		"Lcy": "Л",
		"lcy": "л",
		"ldca": "⤶",
		"ldquo": "“",
		"ldquor": "„",
		"ldrdhar": "⥧",
		"ldrushar": "⥋",
		"ldsh": "↲",
		"le": "≤",
		"lE": "≦",
		"LeftAngleBracket": "⟨",
		"LeftArrowBar": "⇤",
		"leftarrow": "←",
		"LeftArrow": "←",
		"Leftarrow": "⇐",
		"LeftArrowRightArrow": "⇆",
		"leftarrowtail": "↢",
		"LeftCeiling": "⌈",
		"LeftDoubleBracket": "⟦",
		"LeftDownTeeVector": "⥡",
		"LeftDownVectorBar": "⥙",
		"LeftDownVector": "⇃",
		"LeftFloor": "⌊",
		"leftharpoondown": "↽",
		"leftharpoonup": "↼",
		"leftleftarrows": "⇇",
		"leftrightarrow": "↔",
		"LeftRightArrow": "↔",
		"Leftrightarrow": "⇔",
		"leftrightarrows": "⇆",
		"leftrightharpoons": "⇋",
		"leftrightsquigarrow": "↭",
		"LeftRightVector": "⥎",
		"LeftTeeArrow": "↤",
		"LeftTee": "⊣",
		"LeftTeeVector": "⥚",
		"leftthreetimes": "⋋",
		"LeftTriangleBar": "⧏",
		"LeftTriangle": "⊲",
		"LeftTriangleEqual": "⊴",
		"LeftUpDownVector": "⥑",
		"LeftUpTeeVector": "⥠",
		"LeftUpVectorBar": "⥘",
		"LeftUpVector": "↿",
		"LeftVectorBar": "⥒",
		"LeftVector": "↼",
		"lEg": "⪋",
		"leg": "⋚",
		"leq": "≤",
		"leqq": "≦",
		"leqslant": "⩽",
		"lescc": "⪨",
		"les": "⩽",
		"lesdot": "⩿",
		"lesdoto": "⪁",
		"lesdotor": "⪃",
		"lesg": "⋚︀",
		"lesges": "⪓",
		"lessapprox": "⪅",
		"lessdot": "⋖",
		"lesseqgtr": "⋚",
		"lesseqqgtr": "⪋",
		"LessEqualGreater": "⋚",
		"LessFullEqual": "≦",
		"LessGreater": "≶",
		"lessgtr": "≶",
		"LessLess": "⪡",
		"lesssim": "≲",
		"LessSlantEqual": "⩽",
		"LessTilde": "≲",
		"lfisht": "⥼",
		"lfloor": "⌊",
		"Lfr": "𝔏",
		"lfr": "𝔩",
		"lg": "≶",
		"lgE": "⪑",
		"lHar": "⥢",
		"lhard": "↽",
		"lharu": "↼",
		"lharul": "⥪",
		"lhblk": "▄",
		"LJcy": "Љ",
		"ljcy": "љ",
		"llarr": "⇇",
		"ll": "≪",
		"Ll": "⋘",
		"llcorner": "⌞",
		"Lleftarrow": "⇚",
		"llhard": "⥫",
		"lltri": "◺",
		"Lmidot": "Ŀ",
		"lmidot": "ŀ",
		"lmoustache": "⎰",
		"lmoust": "⎰",
		"lnap": "⪉",
		"lnapprox": "⪉",
		"lne": "⪇",
		"lnE": "≨",
		"lneq": "⪇",
		"lneqq": "≨",
		"lnsim": "⋦",
		"loang": "⟬",
		"loarr": "⇽",
		"lobrk": "⟦",
		"longleftarrow": "⟵",
		"LongLeftArrow": "⟵",
		"Longleftarrow": "⟸",
		"longleftrightarrow": "⟷",
		"LongLeftRightArrow": "⟷",
		"Longleftrightarrow": "⟺",
		"longmapsto": "⟼",
		"longrightarrow": "⟶",
		"LongRightArrow": "⟶",
		"Longrightarrow": "⟹",
		"looparrowleft": "↫",
		"looparrowright": "↬",
		"lopar": "⦅",
		"Lopf": "𝕃",
		"lopf": "𝕝",
		"loplus": "⨭",
		"lotimes": "⨴",
		"lowast": "∗",
		"lowbar": "_",
		"LowerLeftArrow": "↙",
		"LowerRightArrow": "↘",
		"loz": "◊",
		"lozenge": "◊",
		"lozf": "⧫",
		"lpar": "(",
		"lparlt": "⦓",
		"lrarr": "⇆",
		"lrcorner": "⌟",
		"lrhar": "⇋",
		"lrhard": "⥭",
		"lrm": "‎",
		"lrtri": "⊿",
		"lsaquo": "‹",
		"lscr": "𝓁",
		"Lscr": "ℒ",
		"lsh": "↰",
		"Lsh": "↰",
		"lsim": "≲",
		"lsime": "⪍",
		"lsimg": "⪏",
		"lsqb": "[",
		"lsquo": "‘",
		"lsquor": "‚",
		"Lstrok": "Ł",
		"lstrok": "ł",
		"ltcc": "⪦",
		"ltcir": "⩹",
		"lt": "<",
		"LT": "<",
		"Lt": "≪",
		"ltdot": "⋖",
		"lthree": "⋋",
		"ltimes": "⋉",
		"ltlarr": "⥶",
		"ltquest": "⩻",
		"ltri": "◃",
		"ltrie": "⊴",
		"ltrif": "◂",
		"ltrPar": "⦖",
		"lurdshar": "⥊",
		"luruhar": "⥦",
		"lvertneqq": "≨︀",
		"lvnE": "≨︀",
		"macr": "¯",
		"male": "♂",
		"malt": "✠",
		"maltese": "✠",
		"Map": "⤅",
		"map": "↦",
		"mapsto": "↦",
		"mapstodown": "↧",
		"mapstoleft": "↤",
		"mapstoup": "↥",
		"marker": "▮",
		"mcomma": "⨩",
		"Mcy": "М",
		"mcy": "м",
		"mdash": "—",
		"mDDot": "∺",
		"measuredangle": "∡",
		"MediumSpace": " ",
		"Mellintrf": "ℳ",
		"Mfr": "𝔐",
		"mfr": "𝔪",
		"mho": "℧",
		"micro": "µ",
		"midast": "*",
		"midcir": "⫰",
		"mid": "∣",
		"middot": "·",
		"minusb": "⊟",
		"minus": "−",
		"minusd": "∸",
		"minusdu": "⨪",
		"MinusPlus": "∓",
		"mlcp": "⫛",
		"mldr": "…",
		"mnplus": "∓",
		"models": "⊧",
		"Mopf": "𝕄",
		"mopf": "𝕞",
		"mp": "∓",
		"mscr": "𝓂",
		"Mscr": "ℳ",
		"mstpos": "∾",
		"Mu": "Μ",
		"mu": "μ",
		"multimap": "⊸",
		"mumap": "⊸",
		"nabla": "∇",
		"Nacute": "Ń",
		"nacute": "ń",
		"nang": "∠⃒",
		"nap": "≉",
		"napE": "⩰̸",
		"napid": "≋̸",
		"napos": "ŉ",
		"napprox": "≉",
		"natural": "♮",
		"naturals": "ℕ",
		"natur": "♮",
		"nbsp": " ",
		"nbump": "≎̸",
		"nbumpe": "≏̸",
		"ncap": "⩃",
		"Ncaron": "Ň",
		"ncaron": "ň",
		"Ncedil": "Ņ",
		"ncedil": "ņ",
		"ncong": "≇",
		"ncongdot": "⩭̸",
		"ncup": "⩂",
		"Ncy": "Н",
		"ncy": "н",
		"ndash": "–",
		"nearhk": "⤤",
		"nearr": "↗",
		"neArr": "⇗",
		"nearrow": "↗",
		"ne": "≠",
		"nedot": "≐̸",
		"NegativeMediumSpace": "​",
		"NegativeThickSpace": "​",
		"NegativeThinSpace": "​",
		"NegativeVeryThinSpace": "​",
		"nequiv": "≢",
		"nesear": "⤨",
		"nesim": "≂̸",
		"NestedGreaterGreater": "≫",
		"NestedLessLess": "≪",
		"NewLine": "\n",
		"nexist": "∄",
		"nexists": "∄",
		"Nfr": "𝔑",
		"nfr": "𝔫",
		"ngE": "≧̸",
		"nge": "≱",
		"ngeq": "≱",
		"ngeqq": "≧̸",
		"ngeqslant": "⩾̸",
		"nges": "⩾̸",
		"nGg": "⋙̸",
		"ngsim": "≵",
		"nGt": "≫⃒",
		"ngt": "≯",
		"ngtr": "≯",
		"nGtv": "≫̸",
		"nharr": "↮",
		"nhArr": "⇎",
		"nhpar": "⫲",
		"ni": "∋",
		"nis": "⋼",
		"nisd": "⋺",
		"niv": "∋",
		"NJcy": "Њ",
		"njcy": "њ",
		"nlarr": "↚",
		"nlArr": "⇍",
		"nldr": "‥",
		"nlE": "≦̸",
		"nle": "≰",
		"nleftarrow": "↚",
		"nLeftarrow": "⇍",
		"nleftrightarrow": "↮",
		"nLeftrightarrow": "⇎",
		"nleq": "≰",
		"nleqq": "≦̸",
		"nleqslant": "⩽̸",
		"nles": "⩽̸",
		"nless": "≮",
		"nLl": "⋘̸",
		"nlsim": "≴",
		"nLt": "≪⃒",
		"nlt": "≮",
		"nltri": "⋪",
		"nltrie": "⋬",
		"nLtv": "≪̸",
		"nmid": "∤",
		"NoBreak": "⁠",
		"NonBreakingSpace": " ",
		"nopf": "𝕟",
		"Nopf": "ℕ",
		"Not": "⫬",
		"not": "¬",
		"NotCongruent": "≢",
		"NotCupCap": "≭",
		"NotDoubleVerticalBar": "∦",
		"NotElement": "∉",
		"NotEqual": "≠",
		"NotEqualTilde": "≂̸",
		"NotExists": "∄",
		"NotGreater": "≯",
		"NotGreaterEqual": "≱",
		"NotGreaterFullEqual": "≧̸",
		"NotGreaterGreater": "≫̸",
		"NotGreaterLess": "≹",
		"NotGreaterSlantEqual": "⩾̸",
		"NotGreaterTilde": "≵",
		"NotHumpDownHump": "≎̸",
		"NotHumpEqual": "≏̸",
		"notin": "∉",
		"notindot": "⋵̸",
		"notinE": "⋹̸",
		"notinva": "∉",
		"notinvb": "⋷",
		"notinvc": "⋶",
		"NotLeftTriangleBar": "⧏̸",
		"NotLeftTriangle": "⋪",
		"NotLeftTriangleEqual": "⋬",
		"NotLess": "≮",
		"NotLessEqual": "≰",
		"NotLessGreater": "≸",
		"NotLessLess": "≪̸",
		"NotLessSlantEqual": "⩽̸",
		"NotLessTilde": "≴",
		"NotNestedGreaterGreater": "⪢̸",
		"NotNestedLessLess": "⪡̸",
		"notni": "∌",
		"notniva": "∌",
		"notnivb": "⋾",
		"notnivc": "⋽",
		"NotPrecedes": "⊀",
		"NotPrecedesEqual": "⪯̸",
		"NotPrecedesSlantEqual": "⋠",
		"NotReverseElement": "∌",
		"NotRightTriangleBar": "⧐̸",
		"NotRightTriangle": "⋫",
		"NotRightTriangleEqual": "⋭",
		"NotSquareSubset": "⊏̸",
		"NotSquareSubsetEqual": "⋢",
		"NotSquareSuperset": "⊐̸",
		"NotSquareSupersetEqual": "⋣",
		"NotSubset": "⊂⃒",
		"NotSubsetEqual": "⊈",
		"NotSucceeds": "⊁",
		"NotSucceedsEqual": "⪰̸",
		"NotSucceedsSlantEqual": "⋡",
		"NotSucceedsTilde": "≿̸",
		"NotSuperset": "⊃⃒",
		"NotSupersetEqual": "⊉",
		"NotTilde": "≁",
		"NotTildeEqual": "≄",
		"NotTildeFullEqual": "≇",
		"NotTildeTilde": "≉",
		"NotVerticalBar": "∤",
		"nparallel": "∦",
		"npar": "∦",
		"nparsl": "⫽⃥",
		"npart": "∂̸",
		"npolint": "⨔",
		"npr": "⊀",
		"nprcue": "⋠",
		"nprec": "⊀",
		"npreceq": "⪯̸",
		"npre": "⪯̸",
		"nrarrc": "⤳̸",
		"nrarr": "↛",
		"nrArr": "⇏",
		"nrarrw": "↝̸",
		"nrightarrow": "↛",
		"nRightarrow": "⇏",
		"nrtri": "⋫",
		"nrtrie": "⋭",
		"nsc": "⊁",
		"nsccue": "⋡",
		"nsce": "⪰̸",
		"Nscr": "𝒩",
		"nscr": "𝓃",
		"nshortmid": "∤",
		"nshortparallel": "∦",
		"nsim": "≁",
		"nsime": "≄",
		"nsimeq": "≄",
		"nsmid": "∤",
		"nspar": "∦",
		"nsqsube": "⋢",
		"nsqsupe": "⋣",
		"nsub": "⊄",
		"nsubE": "⫅̸",
		"nsube": "⊈",
		"nsubset": "⊂⃒",
		"nsubseteq": "⊈",
		"nsubseteqq": "⫅̸",
		"nsucc": "⊁",
		"nsucceq": "⪰̸",
		"nsup": "⊅",
		"nsupE": "⫆̸",
		"nsupe": "⊉",
		"nsupset": "⊃⃒",
		"nsupseteq": "⊉",
		"nsupseteqq": "⫆̸",
		"ntgl": "≹",
		"Ntilde": "Ñ",
		"ntilde": "ñ",
		"ntlg": "≸",
		"ntriangleleft": "⋪",
		"ntrianglelefteq": "⋬",
		"ntriangleright": "⋫",
		"ntrianglerighteq": "⋭",
		"Nu": "Ν",
		"nu": "ν",
		"num": "#",
		"numero": "№",
		"numsp": " ",
		"nvap": "≍⃒",
		"nvdash": "⊬",
		"nvDash": "⊭",
		"nVdash": "⊮",
		"nVDash": "⊯",
		"nvge": "≥⃒",
		"nvgt": ">⃒",
		"nvHarr": "⤄",
		"nvinfin": "⧞",
		"nvlArr": "⤂",
		"nvle": "≤⃒",
		"nvlt": "<⃒",
		"nvltrie": "⊴⃒",
		"nvrArr": "⤃",
		"nvrtrie": "⊵⃒",
		"nvsim": "∼⃒",
		"nwarhk": "⤣",
		"nwarr": "↖",
		"nwArr": "⇖",
		"nwarrow": "↖",
		"nwnear": "⤧",
		"Oacute": "Ó",
		"oacute": "ó",
		"oast": "⊛",
		"Ocirc": "Ô",
		"ocirc": "ô",
		"ocir": "⊚",
		"Ocy": "О",
		"ocy": "о",
		"odash": "⊝",
		"Odblac": "Ő",
		"odblac": "ő",
		"odiv": "⨸",
		"odot": "⊙",
		"odsold": "⦼",
		"OElig": "Œ",
		"oelig": "œ",
		"ofcir": "⦿",
		"Ofr": "𝔒",
		"ofr": "𝔬",
		"ogon": "˛",
		"Ograve": "Ò",
		"ograve": "ò",
		"ogt": "⧁",
		"ohbar": "⦵",
		"ohm": "Ω",
		"oint": "∮",
		"olarr": "↺",
		"olcir": "⦾",
		"olcross": "⦻",
		"oline": "‾",
		"olt": "⧀",
		"Omacr": "Ō",
		"omacr": "ō",
		"Omega": "Ω",
		"omega": "ω",
		"Omicron": "Ο",
		"omicron": "ο",
		"omid": "⦶",
		"ominus": "⊖",
		"Oopf": "𝕆",
		"oopf": "𝕠",
		"opar": "⦷",
		"OpenCurlyDoubleQuote": "“",
		"OpenCurlyQuote": "‘",
		"operp": "⦹",
		"oplus": "⊕",
		"orarr": "↻",
		"Or": "⩔",
		"or": "∨",
		"ord": "⩝",
		"order": "ℴ",
		"orderof": "ℴ",
		"ordf": "ª",
		"ordm": "º",
		"origof": "⊶",
		"oror": "⩖",
		"orslope": "⩗",
		"orv": "⩛",
		"oS": "Ⓢ",
		"Oscr": "𝒪",
		"oscr": "ℴ",
		"Oslash": "Ø",
		"oslash": "ø",
		"osol": "⊘",
		"Otilde": "Õ",
		"otilde": "õ",
		"otimesas": "⨶",
		"Otimes": "⨷",
		"otimes": "⊗",
		"Ouml": "Ö",
		"ouml": "ö",
		"ovbar": "⌽",
		"OverBar": "‾",
		"OverBrace": "⏞",
		"OverBracket": "⎴",
		"OverParenthesis": "⏜",
		"para": "¶",
		"parallel": "∥",
		"par": "∥",
		"parsim": "⫳",
		"parsl": "⫽",
		"part": "∂",
		"PartialD": "∂",
		"Pcy": "П",
		"pcy": "п",
		"percnt": "%",
		"period": ".",
		"permil": "‰",
		"perp": "⊥",
		"pertenk": "‱",
		"Pfr": "𝔓",
		"pfr": "𝔭",
		"Phi": "Φ",
		"phi": "φ",
		"phiv": "ϕ",
		"phmmat": "ℳ",
		"phone": "☎",
		"Pi": "Π",
		"pi": "π",
		"pitchfork": "⋔",
		"piv": "ϖ",
		"planck": "ℏ",
		"planckh": "ℎ",
		"plankv": "ℏ",
		"plusacir": "⨣",
		"plusb": "⊞",
		"pluscir": "⨢",
		"plus": "+",
		"plusdo": "∔",
		"plusdu": "⨥",
		"pluse": "⩲",
		"PlusMinus": "±",
		"plusmn": "±",
		"plussim": "⨦",
		"plustwo": "⨧",
		"pm": "±",
		"Poincareplane": "ℌ",
		"pointint": "⨕",
		"popf": "𝕡",
		"Popf": "ℙ",
		"pound": "£",
		"prap": "⪷",
		"Pr": "⪻",
		"pr": "≺",
		"prcue": "≼",
		"precapprox": "⪷",
		"prec": "≺",
		"preccurlyeq": "≼",
		"Precedes": "≺",
		"PrecedesEqual": "⪯",
		"PrecedesSlantEqual": "≼",
		"PrecedesTilde": "≾",
		"preceq": "⪯",
		"precnapprox": "⪹",
		"precneqq": "⪵",
		"precnsim": "⋨",
		"pre": "⪯",
		"prE": "⪳",
		"precsim": "≾",
		"prime": "′",
		"Prime": "″",
		"primes": "ℙ",
		"prnap": "⪹",
		"prnE": "⪵",
		"prnsim": "⋨",
		"prod": "∏",
		"Product": "∏",
		"profalar": "⌮",
		"profline": "⌒",
		"profsurf": "⌓",
		"prop": "∝",
		"Proportional": "∝",
		"Proportion": "∷",
		"propto": "∝",
		"prsim": "≾",
		"prurel": "⊰",
		"Pscr": "𝒫",
		"pscr": "𝓅",
		"Psi": "Ψ",
		"psi": "ψ",
		"puncsp": " ",
		"Qfr": "𝔔",
		"qfr": "𝔮",
		"qint": "⨌",
		"qopf": "𝕢",
		"Qopf": "ℚ",
		"qprime": "⁗",
		"Qscr": "𝒬",
		"qscr": "𝓆",
		"quaternions": "ℍ",
		"quatint": "⨖",
		"quest": "?",
		"questeq": "≟",
		"quot": "\"",
		"QUOT": "\"",
		"rAarr": "⇛",
		"race": "∽̱",
		"Racute": "Ŕ",
		"racute": "ŕ",
		"radic": "√",
		"raemptyv": "⦳",
		"rang": "⟩",
		"Rang": "⟫",
		"rangd": "⦒",
		"range": "⦥",
		"rangle": "⟩",
		"raquo": "»",
		"rarrap": "⥵",
		"rarrb": "⇥",
		"rarrbfs": "⤠",
		"rarrc": "⤳",
		"rarr": "→",
		"Rarr": "↠",
		"rArr": "⇒",
		"rarrfs": "⤞",
		"rarrhk": "↪",
		"rarrlp": "↬",
		"rarrpl": "⥅",
		"rarrsim": "⥴",
		"Rarrtl": "⤖",
		"rarrtl": "↣",
		"rarrw": "↝",
		"ratail": "⤚",
		"rAtail": "⤜",
		"ratio": "∶",
		"rationals": "ℚ",
		"rbarr": "⤍",
		"rBarr": "⤏",
		"RBarr": "⤐",
		"rbbrk": "❳",
		"rbrace": "}",
		"rbrack": "]",
		"rbrke": "⦌",
		"rbrksld": "⦎",
		"rbrkslu": "⦐",
		"Rcaron": "Ř",
		"rcaron": "ř",
		"Rcedil": "Ŗ",
		"rcedil": "ŗ",
		"rceil": "⌉",
		"rcub": "}",
		"Rcy": "Р",
		"rcy": "р",
		"rdca": "⤷",
		"rdldhar": "⥩",
		"rdquo": "”",
		"rdquor": "”",
		"rdsh": "↳",
		"real": "ℜ",
		"realine": "ℛ",
		"realpart": "ℜ",
		"reals": "ℝ",
		"Re": "ℜ",
		"rect": "▭",
		"reg": "®",
		"REG": "®",
		"ReverseElement": "∋",
		"ReverseEquilibrium": "⇋",
		"ReverseUpEquilibrium": "⥯",
		"rfisht": "⥽",
		"rfloor": "⌋",
		"rfr": "𝔯",
		"Rfr": "ℜ",
		"rHar": "⥤",
		"rhard": "⇁",
		"rharu": "⇀",
		"rharul": "⥬",
		"Rho": "Ρ",
		"rho": "ρ",
		"rhov": "ϱ",
		"RightAngleBracket": "⟩",
		"RightArrowBar": "⇥",
		"rightarrow": "→",
		"RightArrow": "→",
		"Rightarrow": "⇒",
		"RightArrowLeftArrow": "⇄",
		"rightarrowtail": "↣",
		"RightCeiling": "⌉",
		"RightDoubleBracket": "⟧",
		"RightDownTeeVector": "⥝",
		"RightDownVectorBar": "⥕",
		"RightDownVector": "⇂",
		"RightFloor": "⌋",
		"rightharpoondown": "⇁",
		"rightharpoonup": "⇀",
		"rightleftarrows": "⇄",
		"rightleftharpoons": "⇌",
		"rightrightarrows": "⇉",
		"rightsquigarrow": "↝",
		"RightTeeArrow": "↦",
		"RightTee": "⊢",
		"RightTeeVector": "⥛",
		"rightthreetimes": "⋌",
		"RightTriangleBar": "⧐",
		"RightTriangle": "⊳",
		"RightTriangleEqual": "⊵",
		"RightUpDownVector": "⥏",
		"RightUpTeeVector": "⥜",
		"RightUpVectorBar": "⥔",
		"RightUpVector": "↾",
		"RightVectorBar": "⥓",
		"RightVector": "⇀",
		"ring": "˚",
		"risingdotseq": "≓",
		"rlarr": "⇄",
		"rlhar": "⇌",
		"rlm": "‏",
		"rmoustache": "⎱",
		"rmoust": "⎱",
		"rnmid": "⫮",
		"roang": "⟭",
		"roarr": "⇾",
		"robrk": "⟧",
		"ropar": "⦆",
		"ropf": "𝕣",
		"Ropf": "ℝ",
		"roplus": "⨮",
		"rotimes": "⨵",
		"RoundImplies": "⥰",
		"rpar": ")",
		"rpargt": "⦔",
		"rppolint": "⨒",
		"rrarr": "⇉",
		"Rrightarrow": "⇛",
		"rsaquo": "›",
		"rscr": "𝓇",
		"Rscr": "ℛ",
		"rsh": "↱",
		"Rsh": "↱",
		"rsqb": "]",
		"rsquo": "’",
		"rsquor": "’",
		"rthree": "⋌",
		"rtimes": "⋊",
		"rtri": "▹",
		"rtrie": "⊵",
		"rtrif": "▸",
		"rtriltri": "⧎",
		"RuleDelayed": "⧴",
		"ruluhar": "⥨",
		"rx": "℞",
		"Sacute": "Ś",
		"sacute": "ś",
		"sbquo": "‚",
		"scap": "⪸",
		"Scaron": "Š",
		"scaron": "š",
		"Sc": "⪼",
		"sc": "≻",
		"sccue": "≽",
		"sce": "⪰",
		"scE": "⪴",
		"Scedil": "Ş",
		"scedil": "ş",
		"Scirc": "Ŝ",
		"scirc": "ŝ",
		"scnap": "⪺",
		"scnE": "⪶",
		"scnsim": "⋩",
		"scpolint": "⨓",
		"scsim": "≿",
		"Scy": "С",
		"scy": "с",
		"sdotb": "⊡",
		"sdot": "⋅",
		"sdote": "⩦",
		"searhk": "⤥",
		"searr": "↘",
		"seArr": "⇘",
		"searrow": "↘",
		"sect": "§",
		"semi": ";",
		"seswar": "⤩",
		"setminus": "∖",
		"setmn": "∖",
		"sext": "✶",
		"Sfr": "𝔖",
		"sfr": "𝔰",
		"sfrown": "⌢",
		"sharp": "♯",
		"SHCHcy": "Щ",
		"shchcy": "щ",
		"SHcy": "Ш",
		"shcy": "ш",
		"ShortDownArrow": "↓",
		"ShortLeftArrow": "←",
		"shortmid": "∣",
		"shortparallel": "∥",
		"ShortRightArrow": "→",
		"ShortUpArrow": "↑",
		"shy": "­",
		"Sigma": "Σ",
		"sigma": "σ",
		"sigmaf": "ς",
		"sigmav": "ς",
		"sim": "∼",
		"simdot": "⩪",
		"sime": "≃",
		"simeq": "≃",
		"simg": "⪞",
		"simgE": "⪠",
		"siml": "⪝",
		"simlE": "⪟",
		"simne": "≆",
		"simplus": "⨤",
		"simrarr": "⥲",
		"slarr": "←",
		"SmallCircle": "∘",
		"smallsetminus": "∖",
		"smashp": "⨳",
		"smeparsl": "⧤",
		"smid": "∣",
		"smile": "⌣",
		"smt": "⪪",
		"smte": "⪬",
		"smtes": "⪬︀",
		"SOFTcy": "Ь",
		"softcy": "ь",
		"solbar": "⌿",
		"solb": "⧄",
		"sol": "/",
		"Sopf": "𝕊",
		"sopf": "𝕤",
		"spades": "♠",
		"spadesuit": "♠",
		"spar": "∥",
		"sqcap": "⊓",
		"sqcaps": "⊓︀",
		"sqcup": "⊔",
		"sqcups": "⊔︀",
		"Sqrt": "√",
		"sqsub": "⊏",
		"sqsube": "⊑",
		"sqsubset": "⊏",
		"sqsubseteq": "⊑",
		"sqsup": "⊐",
		"sqsupe": "⊒",
		"sqsupset": "⊐",
		"sqsupseteq": "⊒",
		"square": "□",
		"Square": "□",
		"SquareIntersection": "⊓",
		"SquareSubset": "⊏",
		"SquareSubsetEqual": "⊑",
		"SquareSuperset": "⊐",
		"SquareSupersetEqual": "⊒",
		"SquareUnion": "⊔",
		"squarf": "▪",
		"squ": "□",
		"squf": "▪",
		"srarr": "→",
		"Sscr": "𝒮",
		"sscr": "𝓈",
		"ssetmn": "∖",
		"ssmile": "⌣",
		"sstarf": "⋆",
		"Star": "⋆",
		"star": "☆",
		"starf": "★",
		"straightepsilon": "ϵ",
		"straightphi": "ϕ",
		"strns": "¯",
		"sub": "⊂",
		"Sub": "⋐",
		"subdot": "⪽",
		"subE": "⫅",
		"sube": "⊆",
		"subedot": "⫃",
		"submult": "⫁",
		"subnE": "⫋",
		"subne": "⊊",
		"subplus": "⪿",
		"subrarr": "⥹",
		"subset": "⊂",
		"Subset": "⋐",
		"subseteq": "⊆",
		"subseteqq": "⫅",
		"SubsetEqual": "⊆",
		"subsetneq": "⊊",
		"subsetneqq": "⫋",
		"subsim": "⫇",
		"subsub": "⫕",
		"subsup": "⫓",
		"succapprox": "⪸",
		"succ": "≻",
		"succcurlyeq": "≽",
		"Succeeds": "≻",
		"SucceedsEqual": "⪰",
		"SucceedsSlantEqual": "≽",
		"SucceedsTilde": "≿",
		"succeq": "⪰",
		"succnapprox": "⪺",
		"succneqq": "⪶",
		"succnsim": "⋩",
		"succsim": "≿",
		"SuchThat": "∋",
		"sum": "∑",
		"Sum": "∑",
		"sung": "♪",
		"sup1": "¹",
		"sup2": "²",
		"sup3": "³",
		"sup": "⊃",
		"Sup": "⋑",
		"supdot": "⪾",
		"supdsub": "⫘",
		"supE": "⫆",
		"supe": "⊇",
		"supedot": "⫄",
		"Superset": "⊃",
		"SupersetEqual": "⊇",
		"suphsol": "⟉",
		"suphsub": "⫗",
		"suplarr": "⥻",
		"supmult": "⫂",
		"supnE": "⫌",
		"supne": "⊋",
		"supplus": "⫀",
		"supset": "⊃",
		"Supset": "⋑",
		"supseteq": "⊇",
		"supseteqq": "⫆",
		"supsetneq": "⊋",
		"supsetneqq": "⫌",
		"supsim": "⫈",
		"supsub": "⫔",
		"supsup": "⫖",
		"swarhk": "⤦",
		"swarr": "↙",
		"swArr": "⇙",
		"swarrow": "↙",
		"swnwar": "⤪",
		"szlig": "ß",
		"Tab": "\t",
		"target": "⌖",
		"Tau": "Τ",
		"tau": "τ",
		"tbrk": "⎴",
		"Tcaron": "Ť",
		"tcaron": "ť",
		"Tcedil": "Ţ",
		"tcedil": "ţ",
		"Tcy": "Т",
		"tcy": "т",
		"tdot": "⃛",
		"telrec": "⌕",
		"Tfr": "𝔗",
		"tfr": "𝔱",
		"there4": "∴",
		"therefore": "∴",
		"Therefore": "∴",
		"Theta": "Θ",
		"theta": "θ",
		"thetasym": "ϑ",
		"thetav": "ϑ",
		"thickapprox": "≈",
		"thicksim": "∼",
		"ThickSpace": "  ",
		"ThinSpace": " ",
		"thinsp": " ",
		"thkap": "≈",
		"thksim": "∼",
		"THORN": "Þ",
		"thorn": "þ",
		"tilde": "˜",
		"Tilde": "∼",
		"TildeEqual": "≃",
		"TildeFullEqual": "≅",
		"TildeTilde": "≈",
		"timesbar": "⨱",
		"timesb": "⊠",
		"times": "×",
		"timesd": "⨰",
		"tint": "∭",
		"toea": "⤨",
		"topbot": "⌶",
		"topcir": "⫱",
		"top": "⊤",
		"Topf": "𝕋",
		"topf": "𝕥",
		"topfork": "⫚",
		"tosa": "⤩",
		"tprime": "‴",
		"trade": "™",
		"TRADE": "™",
		"triangle": "▵",
		"triangledown": "▿",
		"triangleleft": "◃",
		"trianglelefteq": "⊴",
		"triangleq": "≜",
		"triangleright": "▹",
		"trianglerighteq": "⊵",
		"tridot": "◬",
		"trie": "≜",
		"triminus": "⨺",
		"TripleDot": "⃛",
		"triplus": "⨹",
		"trisb": "⧍",
		"tritime": "⨻",
		"trpezium": "⏢",
		"Tscr": "𝒯",
		"tscr": "𝓉",
		"TScy": "Ц",
		"tscy": "ц",
		"TSHcy": "Ћ",
		"tshcy": "ћ",
		"Tstrok": "Ŧ",
		"tstrok": "ŧ",
		"twixt": "≬",
		"twoheadleftarrow": "↞",
		"twoheadrightarrow": "↠",
		"Uacute": "Ú",
		"uacute": "ú",
		"uarr": "↑",
		"Uarr": "↟",
		"uArr": "⇑",
		"Uarrocir": "⥉",
		"Ubrcy": "Ў",
		"ubrcy": "ў",
		"Ubreve": "Ŭ",
		"ubreve": "ŭ",
		"Ucirc": "Û",
		"ucirc": "û",
		"Ucy": "У",
		"ucy": "у",
		"udarr": "⇅",
		"Udblac": "Ű",
		"udblac": "ű",
		"udhar": "⥮",
		"ufisht": "⥾",
		"Ufr": "𝔘",
		"ufr": "𝔲",
		"Ugrave": "Ù",
		"ugrave": "ù",
		"uHar": "⥣",
		"uharl": "↿",
		"uharr": "↾",
		"uhblk": "▀",
		"ulcorn": "⌜",
		"ulcorner": "⌜",
		"ulcrop": "⌏",
		"ultri": "◸",
		"Umacr": "Ū",
		"umacr": "ū",
		"uml": "¨",
		"UnderBar": "_",
		"UnderBrace": "⏟",
		"UnderBracket": "⎵",
		"UnderParenthesis": "⏝",
		"Union": "⋃",
		"UnionPlus": "⊎",
		"Uogon": "Ų",
		"uogon": "ų",
		"Uopf": "𝕌",
		"uopf": "𝕦",
		"UpArrowBar": "⤒",
		"uparrow": "↑",
		"UpArrow": "↑",
		"Uparrow": "⇑",
		"UpArrowDownArrow": "⇅",
		"updownarrow": "↕",
		"UpDownArrow": "↕",
		"Updownarrow": "⇕",
		"UpEquilibrium": "⥮",
		"upharpoonleft": "↿",
		"upharpoonright": "↾",
		"uplus": "⊎",
		"UpperLeftArrow": "↖",
		"UpperRightArrow": "↗",
		"upsi": "υ",
		"Upsi": "ϒ",
		"upsih": "ϒ",
		"Upsilon": "Υ",
		"upsilon": "υ",
		"UpTeeArrow": "↥",
		"UpTee": "⊥",
		"upuparrows": "⇈",
		"urcorn": "⌝",
		"urcorner": "⌝",
		"urcrop": "⌎",
		"Uring": "Ů",
		"uring": "ů",
		"urtri": "◹",
		"Uscr": "𝒰",
		"uscr": "𝓊",
		"utdot": "⋰",
		"Utilde": "Ũ",
		"utilde": "ũ",
		"utri": "▵",
		"utrif": "▴",
		"uuarr": "⇈",
		"Uuml": "Ü",
		"uuml": "ü",
		"uwangle": "⦧",
		"vangrt": "⦜",
		"varepsilon": "ϵ",
		"varkappa": "ϰ",
		"varnothing": "∅",
		"varphi": "ϕ",
		"varpi": "ϖ",
		"varpropto": "∝",
		"varr": "↕",
		"vArr": "⇕",
		"varrho": "ϱ",
		"varsigma": "ς",
		"varsubsetneq": "⊊︀",
		"varsubsetneqq": "⫋︀",
		"varsupsetneq": "⊋︀",
		"varsupsetneqq": "⫌︀",
		"vartheta": "ϑ",
		"vartriangleleft": "⊲",
		"vartriangleright": "⊳",
		"vBar": "⫨",
		"Vbar": "⫫",
		"vBarv": "⫩",
		"Vcy": "В",
		"vcy": "в",
		"vdash": "⊢",
		"vDash": "⊨",
		"Vdash": "⊩",
		"VDash": "⊫",
		"Vdashl": "⫦",
		"veebar": "⊻",
		"vee": "∨",
		"Vee": "⋁",
		"veeeq": "≚",
		"vellip": "⋮",
		"verbar": "|",
		"Verbar": "‖",
		"vert": "|",
		"Vert": "‖",
		"VerticalBar": "∣",
		"VerticalLine": "|",
		"VerticalSeparator": "❘",
		"VerticalTilde": "≀",
		"VeryThinSpace": " ",
		"Vfr": "𝔙",
		"vfr": "𝔳",
		"vltri": "⊲",
		"vnsub": "⊂⃒",
		"vnsup": "⊃⃒",
		"Vopf": "𝕍",
		"vopf": "𝕧",
		"vprop": "∝",
		"vrtri": "⊳",
		"Vscr": "𝒱",
		"vscr": "𝓋",
		"vsubnE": "⫋︀",
		"vsubne": "⊊︀",
		"vsupnE": "⫌︀",
		"vsupne": "⊋︀",
		"Vvdash": "⊪",
		"vzigzag": "⦚",
		"Wcirc": "Ŵ",
		"wcirc": "ŵ",
		"wedbar": "⩟",
		"wedge": "∧",
		"Wedge": "⋀",
		"wedgeq": "≙",
		"weierp": "℘",
		"Wfr": "𝔚",
		"wfr": "𝔴",
		"Wopf": "𝕎",
		"wopf": "𝕨",
		"wp": "℘",
		"wr": "≀",
		"wreath": "≀",
		"Wscr": "𝒲",
		"wscr": "𝓌",
		"xcap": "⋂",
		"xcirc": "◯",
		"xcup": "⋃",
		"xdtri": "▽",
		"Xfr": "𝔛",
		"xfr": "𝔵",
		"xharr": "⟷",
		"xhArr": "⟺",
		"Xi": "Ξ",
		"xi": "ξ",
		"xlarr": "⟵",
		"xlArr": "⟸",
		"xmap": "⟼",
		"xnis": "⋻",
		"xodot": "⨀",
		"Xopf": "𝕏",
		"xopf": "𝕩",
		"xoplus": "⨁",
		"xotime": "⨂",
		"xrarr": "⟶",
		"xrArr": "⟹",
		"Xscr": "𝒳",
		"xscr": "𝓍",
		"xsqcup": "⨆",
		"xuplus": "⨄",
		"xutri": "△",
		"xvee": "⋁",
		"xwedge": "⋀",
		"Yacute": "Ý",
		"yacute": "ý",
		"YAcy": "Я",
		"yacy": "я",
		"Ycirc": "Ŷ",
		"ycirc": "ŷ",
		"Ycy": "Ы",
		"ycy": "ы",
		"yen": "¥",
		"Yfr": "𝔜",
		"yfr": "𝔶",
		"YIcy": "Ї",
		"yicy": "ї",
		"Yopf": "𝕐",
		"yopf": "𝕪",
		"Yscr": "𝒴",
		"yscr": "𝓎",
		"YUcy": "Ю",
		"yucy": "ю",
		"yuml": "ÿ",
		"Yuml": "Ÿ",
		"Zacute": "Ź",
		"zacute": "ź",
		"Zcaron": "Ž",
		"zcaron": "ž",
		"Zcy": "З",
		"zcy": "з",
		"Zdot": "Ż",
		"zdot": "ż",
		"zeetrf": "ℨ",
		"ZeroWidthSpace": "​",
		"Zeta": "Ζ",
		"zeta": "ζ",
		"zfr": "𝔷",
		"Zfr": "ℨ",
		"ZHcy": "Ж",
		"zhcy": "ж",
		"zigrarr": "⇝",
		"zopf": "𝕫",
		"Zopf": "ℤ",
		"Zscr": "𝒵",
		"zscr": "𝓏",
		"zwj": "‍",
		"zwnj": "‌"
	};

/***/ },
/* 228 */
/***/ function(module, exports) {

	module.exports = {
		"amp": "&",
		"apos": "'",
		"gt": ">",
		"lt": "<",
		"quot": "\""
	};

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	            '_'
	        ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split(
	            '_'
	        ),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	            '_'
	        ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	            '_'
	        ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort: 'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	            '_'
	        ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                '_'
	            ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	            '_'
	        ),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	            '_'
	        ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                    ? 'тан'
	                    : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	            '_'
	        ),
	        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	            '_'
	        ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split(
	            '_'
	        ),
	        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	            '_'
	        ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	            '_'
	        ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        weekdays: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysShort: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	            ' '
	        ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	            '_'
	        ),
	        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	            '_'
	        ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split(
	            '_'
	        );
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone: 'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                '_'
	            ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                '_'
	            ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split(
	            '_'
	        ),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone: 'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split(
	            '_'
	        ),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex: /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex: /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(
	        ' '
	    );
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	            '_'
	        ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                '_'
	            ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function (
	                    $0,
	                    $1,
	                    $2
	                ) {
	                    return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                });
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	            ? forms(key)[1]
	            : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                '_'
	            ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	            '_'
	        ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	            '_'
	        ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            w: 'en uke',
	            ww: '%d uker',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone: 'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                '_'
	            ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	            '_'
	        ),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                '_'
	            ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	        },
	        weekdays: {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                '_'
	            ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split(
	            '_'
	        ),
	        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	            '_'
	        ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	            '_'
	        ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	            '_'
	        ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'дан',
	            dd: translator.translate,
	            M: 'месец',
	            MM: translator.translate,
	            y: 'годину',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                        ? ':a'
	                        : b === 2
	                        ? ':a'
	                        : b === 3
	                        ? ':e'
	                        : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	            '_'
	        ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	            '_'
	        ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'waQ'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'nem'
	                : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'wen'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'ben'
	                : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	            ? format[key][0]
	            : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative: 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                    '_'
	                ),
	                accusative: 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                    '_'
	                ),
	                genitive: 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                    '_'
	                ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	            ? 'genitive'
	            : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	            '_'
	        ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort: 'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	            '_'
	        ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(673);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 365 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(688);


/***/ },
/* 367 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(53);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(62);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactInstrumentation = __webpack_require__(34);
	
	var quoteAttributeValueForBrowser = __webpack_require__(736);
	var warning = __webpack_require__(15);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 370 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var LinkedValueUtils = __webpack_require__(147);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactUpdates = __webpack_require__(39);
	
	var warning = __webpack_require__(15);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 372 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 373 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var invariant = __webpack_require__(11);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(696);
	
	var containsNode = __webpack_require__(628);
	var focusNode = __webpack_require__(220);
	var getActiveElement = __webpack_require__(221);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var DOMLazyTree = __webpack_require__(61);
	var DOMProperty = __webpack_require__(62);
	var React = __webpack_require__(65);
	var ReactBrowserEventEmitter = __webpack_require__(107);
	var ReactCurrentOwner = __webpack_require__(44);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactDOMContainerInfo = __webpack_require__(690);
	var ReactDOMFeatureFlags = __webpack_require__(692);
	var ReactFeatureFlags = __webpack_require__(373);
	var ReactInstanceMap = __webpack_require__(81);
	var ReactInstrumentation = __webpack_require__(34);
	var ReactMarkupChecksum = __webpack_require__(706);
	var ReactReconciler = __webpack_require__(63);
	var ReactUpdateQueue = __webpack_require__(150);
	var ReactUpdates = __webpack_require__(39);
	
	var emptyObject = __webpack_require__(138);
	var instantiateReactComponent = __webpack_require__(384);
	var invariant = __webpack_require__(11);
	var setInnerHTML = __webpack_require__(111);
	var shouldUpdateReactComponent = __webpack_require__(156);
	var warning = __webpack_require__(15);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var React = __webpack_require__(65);
	
	var invariant = __webpack_require__(11);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 378 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 380 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(377);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(27);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(18);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14),
	    _assign = __webpack_require__(16);
	
	var ReactCompositeComponent = __webpack_require__(687);
	var ReactEmptyComponent = __webpack_require__(372);
	var ReactHostComponent = __webpack_require__(374);
	
	var getNextDebugID = __webpack_require__(805);
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(15);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 385 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(27);
	var escapeTextContentForBrowser = __webpack_require__(110);
	var setInnerHTML = __webpack_require__(111);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var ReactCurrentOwner = __webpack_require__(44);
	var REACT_ELEMENT_TYPE = __webpack_require__(702);
	
	var getIteratorFn = __webpack_require__(733);
	var invariant = __webpack_require__(11);
	var KeyEscapeUtils = __webpack_require__(146);
	var warning = __webpack_require__(15);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = convertNodeToElement;
	
	var _elementTypes = __webpack_require__(747);
	
	var _elementTypes2 = _interopRequireDefault(_elementTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Converts a htmlparser2 node to a React element
	 *
	 * @param {Object} node The htmlparser2 node to convert
	 * @param {Number} index The index of the current node
	 * @param {Function} transform Transform function to apply to children of the node
	 * @returns {React.Element}
	 */
	function convertNodeToElement(node, index, transform) {
	  return _elementTypes2.default[node.type](node, index, transform);
	}

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.htmlparser2 = exports.convertNodeToElement = exports.processNodes = undefined;
	
	var _processNodes = __webpack_require__(158);
	
	Object.defineProperty(exports, 'processNodes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_processNodes).default;
	  }
	});
	
	var _convertNodeToElement = __webpack_require__(388);
	
	Object.defineProperty(exports, 'convertNodeToElement', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_convertNodeToElement).default;
	  }
	});
	
	var _htmlparser = __webpack_require__(64);
	
	Object.defineProperty(exports, 'htmlparser2', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_htmlparser).default;
	  }
	});
	
	var _HtmlParser = __webpack_require__(739);
	
	var _HtmlParser2 = _interopRequireDefault(_HtmlParser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _HtmlParser2.default;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = generatePropsFromAttributes;
	
	var _htmlAttributesToReact = __webpack_require__(748);
	
	var _htmlAttributesToReact2 = _interopRequireDefault(_htmlAttributesToReact);
	
	var _inlineStyleToObject = __webpack_require__(749);
	
	var _inlineStyleToObject2 = _interopRequireDefault(_inlineStyleToObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Generates props for a React element from an object of HTML attributes
	 *
	 * @param {Object} attributes The HTML attributes
	 * @param {String} key The key to give the react element
	 */
	function generatePropsFromAttributes(attributes, key) {
	
	  // generate props
	  var props = _extends({}, (0, _htmlAttributesToReact2.default)(attributes), { key: key });
	
	  // if there is an inline/string style prop then convert it to a React style object
	  // otherwise, it is invalid and omitted
	  if (typeof props.style === 'string' || props.style instanceof String) {
	    props.style = (0, _inlineStyleToObject2.default)(props.style);
	  } else {
	    delete props.style;
	  }
	
	  return props;
	}

/***/ },
/* 391 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValidTagOrAttributeName;
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/;
	
	var nameCache = {};
	
	function isValidTagOrAttributeName(tagName) {
	  if (!nameCache.hasOwnProperty(tagName)) {
	    nameCache[tagName] = VALID_TAG_REGEX.test(tagName);
	  }
	  return nameCache[tagName];
	}

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.decodeHTML = exports.decodeHTMLStrict = exports.decodeXML = void 0;
	var entities_json_1 = __importDefault(__webpack_require__(227));
	var legacy_json_1 = __importDefault(__webpack_require__(661));
	var xml_json_1 = __importDefault(__webpack_require__(228));
	var decode_codepoint_1 = __importDefault(__webpack_require__(753));
	var strictEntityRe = /&(?:[a-zA-Z0-9]+|#[xX][\da-fA-F]+|#\d+);/g;
	exports.decodeXML = getStrictDecoder(xml_json_1.default);
	exports.decodeHTMLStrict = getStrictDecoder(entities_json_1.default);
	function getStrictDecoder(map) {
	    var replace = getReplacer(map);
	    return function (str) { return String(str).replace(strictEntityRe, replace); };
	}
	var sorter = function (a, b) { return (a < b ? 1 : -1); };
	exports.decodeHTML = (function () {
	    var legacy = Object.keys(legacy_json_1.default).sort(sorter);
	    var keys = Object.keys(entities_json_1.default).sort(sorter);
	    for (var i = 0, j = 0; i < keys.length; i++) {
	        if (legacy[j] === keys[i]) {
	            keys[i] += ";?";
	            j++;
	        }
	        else {
	            keys[i] += ";";
	        }
	    }
	    var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g");
	    var replace = getReplacer(entities_json_1.default);
	    function replacer(str) {
	        if (str.substr(-1) !== ";")
	            str += ";";
	        return replace(str);
	    }
	    // TODO consider creating a merged map
	    return function (str) { return String(str).replace(re, replacer); };
	})();
	function getReplacer(map) {
	    return function replace(str) {
	        if (str.charAt(1) === "#") {
	            var secondChar = str.charAt(2);
	            if (secondChar === "X" || secondChar === "x") {
	                return decode_codepoint_1.default(parseInt(str.substr(3), 16));
	            }
	            return decode_codepoint_1.default(parseInt(str.substr(2), 10));
	        }
	        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
	        return map[str.slice(1, -1)] || str;
	    };
	}


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.escapeUTF8 = exports.escape = exports.encodeNonAsciiHTML = exports.encodeHTML = exports.encodeXML = void 0;
	var xml_json_1 = __importDefault(__webpack_require__(228));
	var inverseXML = getInverseObj(xml_json_1.default);
	var xmlReplacer = getInverseReplacer(inverseXML);
	/**
	 * Encodes all non-ASCII characters, as well as characters not valid in XML
	 * documents using XML entities.
	 *
	 * If a character has no equivalent entity, a
	 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
	 */
	exports.encodeXML = getASCIIEncoder(inverseXML);
	var entities_json_1 = __importDefault(__webpack_require__(227));
	var inverseHTML = getInverseObj(entities_json_1.default);
	var htmlReplacer = getInverseReplacer(inverseHTML);
	/**
	 * Encodes all entities and non-ASCII characters in the input.
	 *
	 * This includes characters that are valid ASCII characters in HTML documents.
	 * For example `#` will be encoded as `&num;`. To get a more compact output,
	 * consider using the `encodeNonAsciiHTML` function.
	 *
	 * If a character has no equivalent entity, a
	 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
	 */
	exports.encodeHTML = getInverse(inverseHTML, htmlReplacer);
	/**
	 * Encodes all non-ASCII characters, as well as characters not valid in HTML
	 * documents using HTML entities.
	 *
	 * If a character has no equivalent entity, a
	 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
	 */
	exports.encodeNonAsciiHTML = getASCIIEncoder(inverseHTML);
	function getInverseObj(obj) {
	    return Object.keys(obj)
	        .sort()
	        .reduce(function (inverse, name) {
	        inverse[obj[name]] = "&" + name + ";";
	        return inverse;
	    }, {});
	}
	function getInverseReplacer(inverse) {
	    var single = [];
	    var multiple = [];
	    for (var _i = 0, _a = Object.keys(inverse); _i < _a.length; _i++) {
	        var k = _a[_i];
	        if (k.length === 1) {
	            // Add value to single array
	            single.push("\\" + k);
	        }
	        else {
	            // Add value to multiple array
	            multiple.push(k);
	        }
	    }
	    // Add ranges to single characters.
	    single.sort();
	    for (var start = 0; start < single.length - 1; start++) {
	        // Find the end of a run of characters
	        var end = start;
	        while (end < single.length - 1 &&
	            single[end].charCodeAt(1) + 1 === single[end + 1].charCodeAt(1)) {
	            end += 1;
	        }
	        var count = 1 + end - start;
	        // We want to replace at least three characters
	        if (count < 3)
	            continue;
	        single.splice(start, count, single[start] + "-" + single[end]);
	    }
	    multiple.unshift("[" + single.join("") + "]");
	    return new RegExp(multiple.join("|"), "g");
	}
	// /[^\0-\x7F]/gu
	var reNonASCII = /(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g;
	var getCodePoint = 
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	String.prototype.codePointAt != null
	    ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	        function (str) { return str.codePointAt(0); }
	    : // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	        function (c) {
	            return (c.charCodeAt(0) - 0xd800) * 0x400 +
	                c.charCodeAt(1) -
	                0xdc00 +
	                0x10000;
	        };
	function singleCharReplacer(c) {
	    return "&#x" + (c.length > 1 ? getCodePoint(c) : c.charCodeAt(0))
	        .toString(16)
	        .toUpperCase() + ";";
	}
	function getInverse(inverse, re) {
	    return function (data) {
	        return data
	            .replace(re, function (name) { return inverse[name]; })
	            .replace(reNonASCII, singleCharReplacer);
	    };
	}
	var reEscapeChars = new RegExp(xmlReplacer.source + "|" + reNonASCII.source, "g");
	/**
	 * Encodes all non-ASCII characters, as well as characters not valid in XML
	 * documents using numeric hexadecimal reference (eg. `&#xfc;`).
	 *
	 * Have a look at `escapeUTF8` if you want a more concise output at the expense
	 * of reduced transportability.
	 *
	 * @param data String to escape.
	 */
	function escape(data) {
	    return data.replace(reEscapeChars, singleCharReplacer);
	}
	exports.escape = escape;
	/**
	 * Encodes all characters not valid in XML documents using numeric hexadecimal
	 * reference (eg. `&#xfc;`).
	 *
	 * Note that the output will be character-set dependent.
	 *
	 * @param data String to escape.
	 */
	function escapeUTF8(data) {
	    return data.replace(xmlReplacer, singleCharReplacer);
	}
	exports.escapeUTF8 = escapeUTF8;
	function getASCIIEncoder(obj) {
	    return function (data) {
	        return data.replace(reEscapeChars, function (c) { return obj[c] || singleCharReplacer(c); });
	    };
	}


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(83);
	
	var re_whitespace = /\s+/g;
	var NodePrototype = __webpack_require__(395);
	var ElementPrototype = __webpack_require__(755);
	
	function DomHandler(callback, options, elementCB){
		if(typeof callback === "object"){
			elementCB = options;
			options = callback;
			callback = null;
		} else if(typeof options === "function"){
			elementCB = options;
			options = defaultOpts;
		}
		this._callback = callback;
		this._options = options || defaultOpts;
		this._elementCB = elementCB;
		this.dom = [];
		this._done = false;
		this._tagStack = [];
		this._parser = this._parser || null;
	}
	
	//default options
	var defaultOpts = {
		normalizeWhitespace: false, //Replace all whitespace with single spaces
		withStartIndices: false, //Add startIndex properties to nodes
		withEndIndices: false, //Add endIndex properties to nodes
	};
	
	DomHandler.prototype.onparserinit = function(parser){
		this._parser = parser;
	};
	
	//Resets the handler back to starting state
	DomHandler.prototype.onreset = function(){
		DomHandler.call(this, this._callback, this._options, this._elementCB);
	};
	
	//Signals the handler that parsing is done
	DomHandler.prototype.onend = function(){
		if(this._done) return;
		this._done = true;
		this._parser = null;
		this._handleCallback(null);
	};
	
	DomHandler.prototype._handleCallback =
	DomHandler.prototype.onerror = function(error){
		if(typeof this._callback === "function"){
			this._callback(error, this.dom);
		} else {
			if(error) throw error;
		}
	};
	
	DomHandler.prototype.onclosetag = function(){
		//if(this._tagStack.pop().name !== name) this._handleCallback(Error("Tagname didn't match!"));
		
		var elem = this._tagStack.pop();
	
		if(this._options.withEndIndices && elem){
			elem.endIndex = this._parser.endIndex;
		}
	
		if(this._elementCB) this._elementCB(elem);
	};
	
	DomHandler.prototype._createDomElement = function(properties){
		if (!this._options.withDomLvl1) return properties;
	
		var element;
		if (properties.type === "tag") {
			element = Object.create(ElementPrototype);
		} else {
			element = Object.create(NodePrototype);
		}
	
		for (var key in properties) {
			if (properties.hasOwnProperty(key)) {
				element[key] = properties[key];
			}
		}
	
		return element;
	};
	
	DomHandler.prototype._addDomElement = function(element){
		var parent = this._tagStack[this._tagStack.length - 1];
		var siblings = parent ? parent.children : this.dom;
		var previousSibling = siblings[siblings.length - 1];
	
		element.next = null;
	
		if(this._options.withStartIndices){
			element.startIndex = this._parser.startIndex;
		}
		if(this._options.withEndIndices){
			element.endIndex = this._parser.endIndex;
		}
	
		if(previousSibling){
			element.prev = previousSibling;
			previousSibling.next = element;
		} else {
			element.prev = null;
		}
	
		siblings.push(element);
		element.parent = parent || null;
	};
	
	DomHandler.prototype.onopentag = function(name, attribs){
		var properties = {
			type: name === "script" ? ElementType.Script : name === "style" ? ElementType.Style : ElementType.Tag,
			name: name,
			attribs: attribs,
			children: []
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
	
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.ontext = function(data){
		//the ignoreWhitespace is officially dropped, but for now,
		//it's an alias for normalizeWhitespace
		var normalize = this._options.normalizeWhitespace || this._options.ignoreWhitespace;
	
		var lastTag;
	
		if(!this._tagStack.length && this.dom.length && (lastTag = this.dom[this.dom.length-1]).type === ElementType.Text){
			if(normalize){
				lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
			} else {
				lastTag.data += data;
			}
		} else {
			if(
				this._tagStack.length &&
				(lastTag = this._tagStack[this._tagStack.length - 1]) &&
				(lastTag = lastTag.children[lastTag.children.length - 1]) &&
				lastTag.type === ElementType.Text
			){
				if(normalize){
					lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
				} else {
					lastTag.data += data;
				}
			} else {
				if(normalize){
					data = data.replace(re_whitespace, " ");
				}
	
				var element = this._createDomElement({
					data: data,
					type: ElementType.Text
				});
	
				this._addDomElement(element);
			}
		}
	};
	
	DomHandler.prototype.oncomment = function(data){
		var lastTag = this._tagStack[this._tagStack.length - 1];
	
		if(lastTag && lastTag.type === ElementType.Comment){
			lastTag.data += data;
			return;
		}
	
		var properties = {
			data: data,
			type: ElementType.Comment
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.oncdatastart = function(){
		var properties = {
			children: [{
				data: "",
				type: ElementType.Text
			}],
			type: ElementType.CDATA
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.oncommentend = DomHandler.prototype.oncdataend = function(){
		this._tagStack.pop();
	};
	
	DomHandler.prototype.onprocessinginstruction = function(name, data){
		var element = this._createDomElement({
			name: name,
			data: data,
			type: ElementType.Directive
		});
	
		this._addDomElement(element);
	};
	
	module.exports = DomHandler;


/***/ },
/* 395 */
/***/ function(module, exports) {

	// This object will be used as the prototype for Nodes when creating a
	// DOM-Level-1-compliant structure.
	var NodePrototype = module.exports = {
		get firstChild() {
			var children = this.children;
			return children && children[0] || null;
		},
		get lastChild() {
			var children = this.children;
			return children && children[children.length - 1] || null;
		},
		get nodeType() {
			return nodeTypes[this.type] || nodeTypes.element;
		}
	};
	
	var domLvl1 = {
		tagName: "name",
		childNodes: "children",
		parentNode: "parent",
		previousSibling: "prev",
		nextSibling: "next",
		nodeValue: "data"
	};
	
	var nodeTypes = {
		element: 1,
		text: 3,
		cdata: 4,
		comment: 8
	};
	
	Object.keys(domLvl1).forEach(function(key) {
		var shorthand = domLvl1[key];
		Object.defineProperty(NodePrototype, key, {
			get: function() {
				return this[shorthand] || null;
			},
			set: function(val) {
				this[shorthand] = val;
				return val;
			}
		});
	});


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	var DomUtils = module.exports;
	
	[
		__webpack_require__(760),
		__webpack_require__(761),
		__webpack_require__(758),
		__webpack_require__(759),
		__webpack_require__(757),
		__webpack_require__(756)
	].forEach(function(ext){
		Object.keys(ext).forEach(function(key){
			DomUtils[key] = ext[key].bind(DomUtils);
		});
	});


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	var Tokenizer = __webpack_require__(398);
	
	/*
		Options:
	
		xmlMode: Disables the special behavior for script/style tags (false by default)
		lowerCaseAttributeNames: call .toLowerCase for each attribute name (true if xmlMode is `false`)
		lowerCaseTags: call .toLowerCase for each tag name (true if xmlMode is `false`)
	*/
	
	/*
		Callbacks:
	
		oncdataend,
		oncdatastart,
		onclosetag,
		oncomment,
		oncommentend,
		onerror,
		onopentag,
		onprocessinginstruction,
		onreset,
		ontext
	*/
	
	var formTags = {
	    input: true,
	    option: true,
	    optgroup: true,
	    select: true,
	    button: true,
	    datalist: true,
	    textarea: true
	};
	
	var openImpliesClose = {
	    tr: { tr: true, th: true, td: true },
	    th: { th: true },
	    td: { thead: true, th: true, td: true },
	    body: { head: true, link: true, script: true },
	    li: { li: true },
	    p: { p: true },
	    h1: { p: true },
	    h2: { p: true },
	    h3: { p: true },
	    h4: { p: true },
	    h5: { p: true },
	    h6: { p: true },
	    select: formTags,
	    input: formTags,
	    output: formTags,
	    button: formTags,
	    datalist: formTags,
	    textarea: formTags,
	    option: { option: true },
	    optgroup: { optgroup: true }
	};
	
	var voidElements = {
	    __proto__: null,
	    area: true,
	    base: true,
	    basefont: true,
	    br: true,
	    col: true,
	    command: true,
	    embed: true,
	    frame: true,
	    hr: true,
	    img: true,
	    input: true,
	    isindex: true,
	    keygen: true,
	    link: true,
	    meta: true,
	    param: true,
	    source: true,
	    track: true,
	    wbr: true
	};
	
	var foreignContextElements = {
	    __proto__: null,
	    math: true,
	    svg: true
	};
	var htmlIntegrationElements = {
	    __proto__: null,
	    mi: true,
	    mo: true,
	    mn: true,
	    ms: true,
	    mtext: true,
	    "annotation-xml": true,
	    foreignObject: true,
	    desc: true,
	    title: true
	};
	
	var re_nameEnd = /\s|\//;
	
	function Parser(cbs, options) {
	    this._options = options || {};
	    this._cbs = cbs || {};
	
	    this._tagname = "";
	    this._attribname = "";
	    this._attribvalue = "";
	    this._attribs = null;
	    this._stack = [];
	    this._foreignContext = [];
	
	    this.startIndex = 0;
	    this.endIndex = null;
	
	    this._lowerCaseTagNames =
	        "lowerCaseTags" in this._options
	            ? !!this._options.lowerCaseTags
	            : !this._options.xmlMode;
	    this._lowerCaseAttributeNames =
	        "lowerCaseAttributeNames" in this._options
	            ? !!this._options.lowerCaseAttributeNames
	            : !this._options.xmlMode;
	
	    if (this._options.Tokenizer) {
	        Tokenizer = this._options.Tokenizer;
	    }
	    this._tokenizer = new Tokenizer(this._options, this);
	
	    if (this._cbs.onparserinit) this._cbs.onparserinit(this);
	}
	
	__webpack_require__(105)(Parser, __webpack_require__(617).EventEmitter);
	
	Parser.prototype._updatePosition = function(initialOffset) {
	    if (this.endIndex === null) {
	        if (this._tokenizer._sectionStart <= initialOffset) {
	            this.startIndex = 0;
	        } else {
	            this.startIndex = this._tokenizer._sectionStart - initialOffset;
	        }
	    } else this.startIndex = this.endIndex + 1;
	    this.endIndex = this._tokenizer.getAbsoluteIndex();
	};
	
	//Tokenizer event handlers
	Parser.prototype.ontext = function(data) {
	    this._updatePosition(1);
	    this.endIndex--;
	
	    if (this._cbs.ontext) this._cbs.ontext(data);
	};
	
	Parser.prototype.onopentagname = function(name) {
	    if (this._lowerCaseTagNames) {
	        name = name.toLowerCase();
	    }
	
	    this._tagname = name;
	
	    if (!this._options.xmlMode && name in openImpliesClose) {
	        for (
	            var el;
	            (el = this._stack[this._stack.length - 1]) in
	            openImpliesClose[name];
	            this.onclosetag(el)
	        );
	    }
	
	    if (this._options.xmlMode || !(name in voidElements)) {
	        this._stack.push(name);
	        if (name in foreignContextElements) this._foreignContext.push(true);
	        else if (name in htmlIntegrationElements)
	            this._foreignContext.push(false);
	    }
	
	    if (this._cbs.onopentagname) this._cbs.onopentagname(name);
	    if (this._cbs.onopentag) this._attribs = {};
	};
	
	Parser.prototype.onopentagend = function() {
	    this._updatePosition(1);
	
	    if (this._attribs) {
	        if (this._cbs.onopentag)
	            this._cbs.onopentag(this._tagname, this._attribs);
	        this._attribs = null;
	    }
	
	    if (
	        !this._options.xmlMode &&
	        this._cbs.onclosetag &&
	        this._tagname in voidElements
	    ) {
	        this._cbs.onclosetag(this._tagname);
	    }
	
	    this._tagname = "";
	};
	
	Parser.prototype.onclosetag = function(name) {
	    this._updatePosition(1);
	
	    if (this._lowerCaseTagNames) {
	        name = name.toLowerCase();
	    }
	    
	    if (name in foreignContextElements || name in htmlIntegrationElements) {
	        this._foreignContext.pop();
	    }
	
	    if (
	        this._stack.length &&
	        (!(name in voidElements) || this._options.xmlMode)
	    ) {
	        var pos = this._stack.lastIndexOf(name);
	        if (pos !== -1) {
	            if (this._cbs.onclosetag) {
	                pos = this._stack.length - pos;
	                while (pos--) this._cbs.onclosetag(this._stack.pop());
	            } else this._stack.length = pos;
	        } else if (name === "p" && !this._options.xmlMode) {
	            this.onopentagname(name);
	            this._closeCurrentTag();
	        }
	    } else if (!this._options.xmlMode && (name === "br" || name === "p")) {
	        this.onopentagname(name);
	        this._closeCurrentTag();
	    }
	};
	
	Parser.prototype.onselfclosingtag = function() {
	    if (
	        this._options.xmlMode ||
	        this._options.recognizeSelfClosing ||
	        this._foreignContext[this._foreignContext.length - 1]
	    ) {
	        this._closeCurrentTag();
	    } else {
	        this.onopentagend();
	    }
	};
	
	Parser.prototype._closeCurrentTag = function() {
	    var name = this._tagname;
	
	    this.onopentagend();
	
	    //self-closing tags will be on the top of the stack
	    //(cheaper check than in onclosetag)
	    if (this._stack[this._stack.length - 1] === name) {
	        if (this._cbs.onclosetag) {
	            this._cbs.onclosetag(name);
	        }
	        this._stack.pop();
	        
	    }
	};
	
	Parser.prototype.onattribname = function(name) {
	    if (this._lowerCaseAttributeNames) {
	        name = name.toLowerCase();
	    }
	    this._attribname = name;
	};
	
	Parser.prototype.onattribdata = function(value) {
	    this._attribvalue += value;
	};
	
	Parser.prototype.onattribend = function() {
	    if (this._cbs.onattribute)
	        this._cbs.onattribute(this._attribname, this._attribvalue);
	    if (
	        this._attribs &&
	        !Object.prototype.hasOwnProperty.call(this._attribs, this._attribname)
	    ) {
	        this._attribs[this._attribname] = this._attribvalue;
	    }
	    this._attribname = "";
	    this._attribvalue = "";
	};
	
	Parser.prototype._getInstructionName = function(value) {
	    var idx = value.search(re_nameEnd),
	        name = idx < 0 ? value : value.substr(0, idx);
	
	    if (this._lowerCaseTagNames) {
	        name = name.toLowerCase();
	    }
	
	    return name;
	};
	
	Parser.prototype.ondeclaration = function(value) {
	    if (this._cbs.onprocessinginstruction) {
	        var name = this._getInstructionName(value);
	        this._cbs.onprocessinginstruction("!" + name, "!" + value);
	    }
	};
	
	Parser.prototype.onprocessinginstruction = function(value) {
	    if (this._cbs.onprocessinginstruction) {
	        var name = this._getInstructionName(value);
	        this._cbs.onprocessinginstruction("?" + name, "?" + value);
	    }
	};
	
	Parser.prototype.oncomment = function(value) {
	    this._updatePosition(4);
	
	    if (this._cbs.oncomment) this._cbs.oncomment(value);
	    if (this._cbs.oncommentend) this._cbs.oncommentend();
	};
	
	Parser.prototype.oncdata = function(value) {
	    this._updatePosition(1);
	
	    if (this._options.xmlMode || this._options.recognizeCDATA) {
	        if (this._cbs.oncdatastart) this._cbs.oncdatastart();
	        if (this._cbs.ontext) this._cbs.ontext(value);
	        if (this._cbs.oncdataend) this._cbs.oncdataend();
	    } else {
	        this.oncomment("[CDATA[" + value + "]]");
	    }
	};
	
	Parser.prototype.onerror = function(err) {
	    if (this._cbs.onerror) this._cbs.onerror(err);
	};
	
	Parser.prototype.onend = function() {
	    if (this._cbs.onclosetag) {
	        for (
	            var i = this._stack.length;
	            i > 0;
	            this._cbs.onclosetag(this._stack[--i])
	        );
	    }
	    if (this._cbs.onend) this._cbs.onend();
	};
	
	//Resets the parser to a blank state, ready to parse a new HTML document
	Parser.prototype.reset = function() {
	    if (this._cbs.onreset) this._cbs.onreset();
	    this._tokenizer.reset();
	
	    this._tagname = "";
	    this._attribname = "";
	    this._attribs = null;
	    this._stack = [];
	
	    if (this._cbs.onparserinit) this._cbs.onparserinit(this);
	};
	
	//Parses a complete HTML document and pushes it to the handler
	Parser.prototype.parseComplete = function(data) {
	    this.reset();
	    this.end(data);
	};
	
	Parser.prototype.write = function(chunk) {
	    this._tokenizer.write(chunk);
	};
	
	Parser.prototype.end = function(chunk) {
	    this._tokenizer.end(chunk);
	};
	
	Parser.prototype.pause = function() {
	    this._tokenizer.pause();
	};
	
	Parser.prototype.resume = function() {
	    this._tokenizer.resume();
	};
	
	//alias for backwards compat
	Parser.prototype.parseChunk = Parser.prototype.write;
	Parser.prototype.done = Parser.prototype.end;
	
	module.exports = Parser;


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = Tokenizer;
	
	var decodeCodePoint = __webpack_require__(762);
	var entityMap = __webpack_require__(663);
	var legacyMap = __webpack_require__(664);
	var xmlMap = __webpack_require__(665);
	
	var i = 0;
	
	var TEXT = i++;
	var BEFORE_TAG_NAME = i++; //after <
	var IN_TAG_NAME = i++;
	var IN_SELF_CLOSING_TAG = i++;
	var BEFORE_CLOSING_TAG_NAME = i++;
	var IN_CLOSING_TAG_NAME = i++;
	var AFTER_CLOSING_TAG_NAME = i++;
	
	//attributes
	var BEFORE_ATTRIBUTE_NAME = i++;
	var IN_ATTRIBUTE_NAME = i++;
	var AFTER_ATTRIBUTE_NAME = i++;
	var BEFORE_ATTRIBUTE_VALUE = i++;
	var IN_ATTRIBUTE_VALUE_DQ = i++; // "
	var IN_ATTRIBUTE_VALUE_SQ = i++; // '
	var IN_ATTRIBUTE_VALUE_NQ = i++;
	
	//declarations
	var BEFORE_DECLARATION = i++; // !
	var IN_DECLARATION = i++;
	
	//processing instructions
	var IN_PROCESSING_INSTRUCTION = i++; // ?
	
	//comments
	var BEFORE_COMMENT = i++;
	var IN_COMMENT = i++;
	var AFTER_COMMENT_1 = i++;
	var AFTER_COMMENT_2 = i++;
	
	//cdata
	var BEFORE_CDATA_1 = i++; // [
	var BEFORE_CDATA_2 = i++; // C
	var BEFORE_CDATA_3 = i++; // D
	var BEFORE_CDATA_4 = i++; // A
	var BEFORE_CDATA_5 = i++; // T
	var BEFORE_CDATA_6 = i++; // A
	var IN_CDATA = i++; // [
	var AFTER_CDATA_1 = i++; // ]
	var AFTER_CDATA_2 = i++; // ]
	
	//special tags
	var BEFORE_SPECIAL = i++; //S
	var BEFORE_SPECIAL_END = i++; //S
	
	var BEFORE_SCRIPT_1 = i++; //C
	var BEFORE_SCRIPT_2 = i++; //R
	var BEFORE_SCRIPT_3 = i++; //I
	var BEFORE_SCRIPT_4 = i++; //P
	var BEFORE_SCRIPT_5 = i++; //T
	var AFTER_SCRIPT_1 = i++; //C
	var AFTER_SCRIPT_2 = i++; //R
	var AFTER_SCRIPT_3 = i++; //I
	var AFTER_SCRIPT_4 = i++; //P
	var AFTER_SCRIPT_5 = i++; //T
	
	var BEFORE_STYLE_1 = i++; //T
	var BEFORE_STYLE_2 = i++; //Y
	var BEFORE_STYLE_3 = i++; //L
	var BEFORE_STYLE_4 = i++; //E
	var AFTER_STYLE_1 = i++; //T
	var AFTER_STYLE_2 = i++; //Y
	var AFTER_STYLE_3 = i++; //L
	var AFTER_STYLE_4 = i++; //E
	
	var BEFORE_ENTITY = i++; //&
	var BEFORE_NUMERIC_ENTITY = i++; //#
	var IN_NAMED_ENTITY = i++;
	var IN_NUMERIC_ENTITY = i++;
	var IN_HEX_ENTITY = i++; //X
	
	var j = 0;
	
	var SPECIAL_NONE = j++;
	var SPECIAL_SCRIPT = j++;
	var SPECIAL_STYLE = j++;
	
	function whitespace(c) {
	    return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
	}
	
	function ifElseState(upper, SUCCESS, FAILURE) {
	    var lower = upper.toLowerCase();
	
	    if (upper === lower) {
	        return function(c) {
	            if (c === lower) {
	                this._state = SUCCESS;
	            } else {
	                this._state = FAILURE;
	                this._index--;
	            }
	        };
	    } else {
	        return function(c) {
	            if (c === lower || c === upper) {
	                this._state = SUCCESS;
	            } else {
	                this._state = FAILURE;
	                this._index--;
	            }
	        };
	    }
	}
	
	function consumeSpecialNameChar(upper, NEXT_STATE) {
	    var lower = upper.toLowerCase();
	
	    return function(c) {
	        if (c === lower || c === upper) {
	            this._state = NEXT_STATE;
	        } else {
	            this._state = IN_TAG_NAME;
	            this._index--; //consume the token again
	        }
	    };
	}
	
	function Tokenizer(options, cbs) {
	    this._state = TEXT;
	    this._buffer = "";
	    this._sectionStart = 0;
	    this._index = 0;
	    this._bufferOffset = 0; //chars removed from _buffer
	    this._baseState = TEXT;
	    this._special = SPECIAL_NONE;
	    this._cbs = cbs;
	    this._running = true;
	    this._ended = false;
	    this._xmlMode = !!(options && options.xmlMode);
	    this._decodeEntities = !!(options && options.decodeEntities);
	}
	
	Tokenizer.prototype._stateText = function(c) {
	    if (c === "<") {
	        if (this._index > this._sectionStart) {
	            this._cbs.ontext(this._getSection());
	        }
	        this._state = BEFORE_TAG_NAME;
	        this._sectionStart = this._index;
	    } else if (
	        this._decodeEntities &&
	        this._special === SPECIAL_NONE &&
	        c === "&"
	    ) {
	        if (this._index > this._sectionStart) {
	            this._cbs.ontext(this._getSection());
	        }
	        this._baseState = TEXT;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateBeforeTagName = function(c) {
	    if (c === "/") {
	        this._state = BEFORE_CLOSING_TAG_NAME;
	    } else if (c === "<") {
	        this._cbs.ontext(this._getSection());
	        this._sectionStart = this._index;
	    } else if (c === ">" || this._special !== SPECIAL_NONE || whitespace(c)) {
	        this._state = TEXT;
	    } else if (c === "!") {
	        this._state = BEFORE_DECLARATION;
	        this._sectionStart = this._index + 1;
	    } else if (c === "?") {
	        this._state = IN_PROCESSING_INSTRUCTION;
	        this._sectionStart = this._index + 1;
	    } else {
	        this._state =
	            !this._xmlMode && (c === "s" || c === "S")
	                ? BEFORE_SPECIAL
	                : IN_TAG_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInTagName = function(c) {
	    if (c === "/" || c === ">" || whitespace(c)) {
	        this._emitToken("onopentagname");
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateBeforeCloseingTagName = function(c) {
	    if (whitespace(c));
	    else if (c === ">") {
	        this._state = TEXT;
	    } else if (this._special !== SPECIAL_NONE) {
	        if (c === "s" || c === "S") {
	            this._state = BEFORE_SPECIAL_END;
	        } else {
	            this._state = TEXT;
	            this._index--;
	        }
	    } else {
	        this._state = IN_CLOSING_TAG_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInCloseingTagName = function(c) {
	    if (c === ">" || whitespace(c)) {
	        this._emitToken("onclosetag");
	        this._state = AFTER_CLOSING_TAG_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateAfterCloseingTagName = function(c) {
	    //skip everything until ">"
	    if (c === ">") {
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    }
	};
	
	Tokenizer.prototype._stateBeforeAttributeName = function(c) {
	    if (c === ">") {
	        this._cbs.onopentagend();
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (c === "/") {
	        this._state = IN_SELF_CLOSING_TAG;
	    } else if (!whitespace(c)) {
	        this._state = IN_ATTRIBUTE_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInSelfClosingTag = function(c) {
	    if (c === ">") {
	        this._cbs.onselfclosingtag();
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (!whitespace(c)) {
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateInAttributeName = function(c) {
	    if (c === "=" || c === "/" || c === ">" || whitespace(c)) {
	        this._cbs.onattribname(this._getSection());
	        this._sectionStart = -1;
	        this._state = AFTER_ATTRIBUTE_NAME;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateAfterAttributeName = function(c) {
	    if (c === "=") {
	        this._state = BEFORE_ATTRIBUTE_VALUE;
	    } else if (c === "/" || c === ">") {
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    } else if (!whitespace(c)) {
	        this._cbs.onattribend();
	        this._state = IN_ATTRIBUTE_NAME;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateBeforeAttributeValue = function(c) {
	    if (c === '"') {
	        this._state = IN_ATTRIBUTE_VALUE_DQ;
	        this._sectionStart = this._index + 1;
	    } else if (c === "'") {
	        this._state = IN_ATTRIBUTE_VALUE_SQ;
	        this._sectionStart = this._index + 1;
	    } else if (!whitespace(c)) {
	        this._state = IN_ATTRIBUTE_VALUE_NQ;
	        this._sectionStart = this._index;
	        this._index--; //reconsume token
	    }
	};
	
	Tokenizer.prototype._stateInAttributeValueDoubleQuotes = function(c) {
	    if (c === '"') {
	        this._emitToken("onattribdata");
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	    } else if (this._decodeEntities && c === "&") {
	        this._emitToken("onattribdata");
	        this._baseState = this._state;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInAttributeValueSingleQuotes = function(c) {
	    if (c === "'") {
	        this._emitToken("onattribdata");
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	    } else if (this._decodeEntities && c === "&") {
	        this._emitToken("onattribdata");
	        this._baseState = this._state;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateInAttributeValueNoQuotes = function(c) {
	    if (whitespace(c) || c === ">") {
	        this._emitToken("onattribdata");
	        this._cbs.onattribend();
	        this._state = BEFORE_ATTRIBUTE_NAME;
	        this._index--;
	    } else if (this._decodeEntities && c === "&") {
	        this._emitToken("onattribdata");
	        this._baseState = this._state;
	        this._state = BEFORE_ENTITY;
	        this._sectionStart = this._index;
	    }
	};
	
	Tokenizer.prototype._stateBeforeDeclaration = function(c) {
	    this._state =
	        c === "["
	            ? BEFORE_CDATA_1
	            : c === "-"
	                ? BEFORE_COMMENT
	                : IN_DECLARATION;
	};
	
	Tokenizer.prototype._stateInDeclaration = function(c) {
	    if (c === ">") {
	        this._cbs.ondeclaration(this._getSection());
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    }
	};
	
	Tokenizer.prototype._stateInProcessingInstruction = function(c) {
	    if (c === ">") {
	        this._cbs.onprocessinginstruction(this._getSection());
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    }
	};
	
	Tokenizer.prototype._stateBeforeComment = function(c) {
	    if (c === "-") {
	        this._state = IN_COMMENT;
	        this._sectionStart = this._index + 1;
	    } else {
	        this._state = IN_DECLARATION;
	    }
	};
	
	Tokenizer.prototype._stateInComment = function(c) {
	    if (c === "-") this._state = AFTER_COMMENT_1;
	};
	
	Tokenizer.prototype._stateAfterComment1 = function(c) {
	    if (c === "-") {
	        this._state = AFTER_COMMENT_2;
	    } else {
	        this._state = IN_COMMENT;
	    }
	};
	
	Tokenizer.prototype._stateAfterComment2 = function(c) {
	    if (c === ">") {
	        //remove 2 trailing chars
	        this._cbs.oncomment(
	            this._buffer.substring(this._sectionStart, this._index - 2)
	        );
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (c !== "-") {
	        this._state = IN_COMMENT;
	    }
	    // else: stay in AFTER_COMMENT_2 (`--->`)
	};
	
	Tokenizer.prototype._stateBeforeCdata1 = ifElseState(
	    "C",
	    BEFORE_CDATA_2,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata2 = ifElseState(
	    "D",
	    BEFORE_CDATA_3,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata3 = ifElseState(
	    "A",
	    BEFORE_CDATA_4,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata4 = ifElseState(
	    "T",
	    BEFORE_CDATA_5,
	    IN_DECLARATION
	);
	Tokenizer.prototype._stateBeforeCdata5 = ifElseState(
	    "A",
	    BEFORE_CDATA_6,
	    IN_DECLARATION
	);
	
	Tokenizer.prototype._stateBeforeCdata6 = function(c) {
	    if (c === "[") {
	        this._state = IN_CDATA;
	        this._sectionStart = this._index + 1;
	    } else {
	        this._state = IN_DECLARATION;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateInCdata = function(c) {
	    if (c === "]") this._state = AFTER_CDATA_1;
	};
	
	Tokenizer.prototype._stateAfterCdata1 = function(c) {
	    if (c === "]") this._state = AFTER_CDATA_2;
	    else this._state = IN_CDATA;
	};
	
	Tokenizer.prototype._stateAfterCdata2 = function(c) {
	    if (c === ">") {
	        //remove 2 trailing chars
	        this._cbs.oncdata(
	            this._buffer.substring(this._sectionStart, this._index - 2)
	        );
	        this._state = TEXT;
	        this._sectionStart = this._index + 1;
	    } else if (c !== "]") {
	        this._state = IN_CDATA;
	    }
	    //else: stay in AFTER_CDATA_2 (`]]]>`)
	};
	
	Tokenizer.prototype._stateBeforeSpecial = function(c) {
	    if (c === "c" || c === "C") {
	        this._state = BEFORE_SCRIPT_1;
	    } else if (c === "t" || c === "T") {
	        this._state = BEFORE_STYLE_1;
	    } else {
	        this._state = IN_TAG_NAME;
	        this._index--; //consume the token again
	    }
	};
	
	Tokenizer.prototype._stateBeforeSpecialEnd = function(c) {
	    if (this._special === SPECIAL_SCRIPT && (c === "c" || c === "C")) {
	        this._state = AFTER_SCRIPT_1;
	    } else if (this._special === SPECIAL_STYLE && (c === "t" || c === "T")) {
	        this._state = AFTER_STYLE_1;
	    } else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeScript1 = consumeSpecialNameChar(
	    "R",
	    BEFORE_SCRIPT_2
	);
	Tokenizer.prototype._stateBeforeScript2 = consumeSpecialNameChar(
	    "I",
	    BEFORE_SCRIPT_3
	);
	Tokenizer.prototype._stateBeforeScript3 = consumeSpecialNameChar(
	    "P",
	    BEFORE_SCRIPT_4
	);
	Tokenizer.prototype._stateBeforeScript4 = consumeSpecialNameChar(
	    "T",
	    BEFORE_SCRIPT_5
	);
	
	Tokenizer.prototype._stateBeforeScript5 = function(c) {
	    if (c === "/" || c === ">" || whitespace(c)) {
	        this._special = SPECIAL_SCRIPT;
	    }
	    this._state = IN_TAG_NAME;
	    this._index--; //consume the token again
	};
	
	Tokenizer.prototype._stateAfterScript1 = ifElseState("R", AFTER_SCRIPT_2, TEXT);
	Tokenizer.prototype._stateAfterScript2 = ifElseState("I", AFTER_SCRIPT_3, TEXT);
	Tokenizer.prototype._stateAfterScript3 = ifElseState("P", AFTER_SCRIPT_4, TEXT);
	Tokenizer.prototype._stateAfterScript4 = ifElseState("T", AFTER_SCRIPT_5, TEXT);
	
	Tokenizer.prototype._stateAfterScript5 = function(c) {
	    if (c === ">" || whitespace(c)) {
	        this._special = SPECIAL_NONE;
	        this._state = IN_CLOSING_TAG_NAME;
	        this._sectionStart = this._index - 6;
	        this._index--; //reconsume the token
	    } else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeStyle1 = consumeSpecialNameChar(
	    "Y",
	    BEFORE_STYLE_2
	);
	Tokenizer.prototype._stateBeforeStyle2 = consumeSpecialNameChar(
	    "L",
	    BEFORE_STYLE_3
	);
	Tokenizer.prototype._stateBeforeStyle3 = consumeSpecialNameChar(
	    "E",
	    BEFORE_STYLE_4
	);
	
	Tokenizer.prototype._stateBeforeStyle4 = function(c) {
	    if (c === "/" || c === ">" || whitespace(c)) {
	        this._special = SPECIAL_STYLE;
	    }
	    this._state = IN_TAG_NAME;
	    this._index--; //consume the token again
	};
	
	Tokenizer.prototype._stateAfterStyle1 = ifElseState("Y", AFTER_STYLE_2, TEXT);
	Tokenizer.prototype._stateAfterStyle2 = ifElseState("L", AFTER_STYLE_3, TEXT);
	Tokenizer.prototype._stateAfterStyle3 = ifElseState("E", AFTER_STYLE_4, TEXT);
	
	Tokenizer.prototype._stateAfterStyle4 = function(c) {
	    if (c === ">" || whitespace(c)) {
	        this._special = SPECIAL_NONE;
	        this._state = IN_CLOSING_TAG_NAME;
	        this._sectionStart = this._index - 5;
	        this._index--; //reconsume the token
	    } else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeEntity = ifElseState(
	    "#",
	    BEFORE_NUMERIC_ENTITY,
	    IN_NAMED_ENTITY
	);
	Tokenizer.prototype._stateBeforeNumericEntity = ifElseState(
	    "X",
	    IN_HEX_ENTITY,
	    IN_NUMERIC_ENTITY
	);
	
	//for entities terminated with a semicolon
	Tokenizer.prototype._parseNamedEntityStrict = function() {
	    //offset = 1
	    if (this._sectionStart + 1 < this._index) {
	        var entity = this._buffer.substring(
	                this._sectionStart + 1,
	                this._index
	            ),
	            map = this._xmlMode ? xmlMap : entityMap;
	
	        if (map.hasOwnProperty(entity)) {
	            this._emitPartial(map[entity]);
	            this._sectionStart = this._index + 1;
	        }
	    }
	};
	
	//parses legacy entities (without trailing semicolon)
	Tokenizer.prototype._parseLegacyEntity = function() {
	    var start = this._sectionStart + 1,
	        limit = this._index - start;
	
	    if (limit > 6) limit = 6; //the max length of legacy entities is 6
	
	    while (limit >= 2) {
	        //the min length of legacy entities is 2
	        var entity = this._buffer.substr(start, limit);
	
	        if (legacyMap.hasOwnProperty(entity)) {
	            this._emitPartial(legacyMap[entity]);
	            this._sectionStart += limit + 1;
	            return;
	        } else {
	            limit--;
	        }
	    }
	};
	
	Tokenizer.prototype._stateInNamedEntity = function(c) {
	    if (c === ";") {
	        this._parseNamedEntityStrict();
	        if (this._sectionStart + 1 < this._index && !this._xmlMode) {
	            this._parseLegacyEntity();
	        }
	        this._state = this._baseState;
	    } else if (
	        (c < "a" || c > "z") &&
	        (c < "A" || c > "Z") &&
	        (c < "0" || c > "9")
	    ) {
	        if (this._xmlMode);
	        else if (this._sectionStart + 1 === this._index);
	        else if (this._baseState !== TEXT) {
	            if (c !== "=") {
	                this._parseNamedEntityStrict();
	            }
	        } else {
	            this._parseLegacyEntity();
	        }
	
	        this._state = this._baseState;
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._decodeNumericEntity = function(offset, base) {
	    var sectionStart = this._sectionStart + offset;
	
	    if (sectionStart !== this._index) {
	        //parse entity
	        var entity = this._buffer.substring(sectionStart, this._index);
	        var parsed = parseInt(entity, base);
	
	        this._emitPartial(decodeCodePoint(parsed));
	        this._sectionStart = this._index;
	    } else {
	        this._sectionStart--;
	    }
	
	    this._state = this._baseState;
	};
	
	Tokenizer.prototype._stateInNumericEntity = function(c) {
	    if (c === ";") {
	        this._decodeNumericEntity(2, 10);
	        this._sectionStart++;
	    } else if (c < "0" || c > "9") {
	        if (!this._xmlMode) {
	            this._decodeNumericEntity(2, 10);
	        } else {
	            this._state = this._baseState;
	        }
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._stateInHexEntity = function(c) {
	    if (c === ";") {
	        this._decodeNumericEntity(3, 16);
	        this._sectionStart++;
	    } else if (
	        (c < "a" || c > "f") &&
	        (c < "A" || c > "F") &&
	        (c < "0" || c > "9")
	    ) {
	        if (!this._xmlMode) {
	            this._decodeNumericEntity(3, 16);
	        } else {
	            this._state = this._baseState;
	        }
	        this._index--;
	    }
	};
	
	Tokenizer.prototype._cleanup = function() {
	    if (this._sectionStart < 0) {
	        this._buffer = "";
	        this._bufferOffset += this._index;
	        this._index = 0;
	    } else if (this._running) {
	        if (this._state === TEXT) {
	            if (this._sectionStart !== this._index) {
	                this._cbs.ontext(this._buffer.substr(this._sectionStart));
	            }
	            this._buffer = "";
	            this._bufferOffset += this._index;
	            this._index = 0;
	        } else if (this._sectionStart === this._index) {
	            //the section just started
	            this._buffer = "";
	            this._bufferOffset += this._index;
	            this._index = 0;
	        } else {
	            //remove everything unnecessary
	            this._buffer = this._buffer.substr(this._sectionStart);
	            this._index -= this._sectionStart;
	            this._bufferOffset += this._sectionStart;
	        }
	
	        this._sectionStart = 0;
	    }
	};
	
	//TODO make events conditional
	Tokenizer.prototype.write = function(chunk) {
	    if (this._ended) this._cbs.onerror(Error(".write() after done!"));
	
	    this._buffer += chunk;
	    this._parse();
	};
	
	Tokenizer.prototype._parse = function() {
	    while (this._index < this._buffer.length && this._running) {
	        var c = this._buffer.charAt(this._index);
	        if (this._state === TEXT) {
	            this._stateText(c);
	        } else if (this._state === BEFORE_TAG_NAME) {
	            this._stateBeforeTagName(c);
	        } else if (this._state === IN_TAG_NAME) {
	            this._stateInTagName(c);
	        } else if (this._state === BEFORE_CLOSING_TAG_NAME) {
	            this._stateBeforeCloseingTagName(c);
	        } else if (this._state === IN_CLOSING_TAG_NAME) {
	            this._stateInCloseingTagName(c);
	        } else if (this._state === AFTER_CLOSING_TAG_NAME) {
	            this._stateAfterCloseingTagName(c);
	        } else if (this._state === IN_SELF_CLOSING_TAG) {
	            this._stateInSelfClosingTag(c);
	        } else if (this._state === BEFORE_ATTRIBUTE_NAME) {
	
	        /*
			*	attributes
			*/
	            this._stateBeforeAttributeName(c);
	        } else if (this._state === IN_ATTRIBUTE_NAME) {
	            this._stateInAttributeName(c);
	        } else if (this._state === AFTER_ATTRIBUTE_NAME) {
	            this._stateAfterAttributeName(c);
	        } else if (this._state === BEFORE_ATTRIBUTE_VALUE) {
	            this._stateBeforeAttributeValue(c);
	        } else if (this._state === IN_ATTRIBUTE_VALUE_DQ) {
	            this._stateInAttributeValueDoubleQuotes(c);
	        } else if (this._state === IN_ATTRIBUTE_VALUE_SQ) {
	            this._stateInAttributeValueSingleQuotes(c);
	        } else if (this._state === IN_ATTRIBUTE_VALUE_NQ) {
	            this._stateInAttributeValueNoQuotes(c);
	        } else if (this._state === BEFORE_DECLARATION) {
	
	        /*
			*	declarations
			*/
	            this._stateBeforeDeclaration(c);
	        } else if (this._state === IN_DECLARATION) {
	            this._stateInDeclaration(c);
	        } else if (this._state === IN_PROCESSING_INSTRUCTION) {
	
	        /*
			*	processing instructions
			*/
	            this._stateInProcessingInstruction(c);
	        } else if (this._state === BEFORE_COMMENT) {
	
	        /*
			*	comments
			*/
	            this._stateBeforeComment(c);
	        } else if (this._state === IN_COMMENT) {
	            this._stateInComment(c);
	        } else if (this._state === AFTER_COMMENT_1) {
	            this._stateAfterComment1(c);
	        } else if (this._state === AFTER_COMMENT_2) {
	            this._stateAfterComment2(c);
	        } else if (this._state === BEFORE_CDATA_1) {
	
	        /*
			*	cdata
			*/
	            this._stateBeforeCdata1(c);
	        } else if (this._state === BEFORE_CDATA_2) {
	            this._stateBeforeCdata2(c);
	        } else if (this._state === BEFORE_CDATA_3) {
	            this._stateBeforeCdata3(c);
	        } else if (this._state === BEFORE_CDATA_4) {
	            this._stateBeforeCdata4(c);
	        } else if (this._state === BEFORE_CDATA_5) {
	            this._stateBeforeCdata5(c);
	        } else if (this._state === BEFORE_CDATA_6) {
	            this._stateBeforeCdata6(c);
	        } else if (this._state === IN_CDATA) {
	            this._stateInCdata(c);
	        } else if (this._state === AFTER_CDATA_1) {
	            this._stateAfterCdata1(c);
	        } else if (this._state === AFTER_CDATA_2) {
	            this._stateAfterCdata2(c);
	        } else if (this._state === BEFORE_SPECIAL) {
	
	        /*
			* special tags
			*/
	            this._stateBeforeSpecial(c);
	        } else if (this._state === BEFORE_SPECIAL_END) {
	            this._stateBeforeSpecialEnd(c);
	        } else if (this._state === BEFORE_SCRIPT_1) {
	
	        /*
			* script
			*/
	            this._stateBeforeScript1(c);
	        } else if (this._state === BEFORE_SCRIPT_2) {
	            this._stateBeforeScript2(c);
	        } else if (this._state === BEFORE_SCRIPT_3) {
	            this._stateBeforeScript3(c);
	        } else if (this._state === BEFORE_SCRIPT_4) {
	            this._stateBeforeScript4(c);
	        } else if (this._state === BEFORE_SCRIPT_5) {
	            this._stateBeforeScript5(c);
	        } else if (this._state === AFTER_SCRIPT_1) {
	            this._stateAfterScript1(c);
	        } else if (this._state === AFTER_SCRIPT_2) {
	            this._stateAfterScript2(c);
	        } else if (this._state === AFTER_SCRIPT_3) {
	            this._stateAfterScript3(c);
	        } else if (this._state === AFTER_SCRIPT_4) {
	            this._stateAfterScript4(c);
	        } else if (this._state === AFTER_SCRIPT_5) {
	            this._stateAfterScript5(c);
	        } else if (this._state === BEFORE_STYLE_1) {
	
	        /*
			* style
			*/
	            this._stateBeforeStyle1(c);
	        } else if (this._state === BEFORE_STYLE_2) {
	            this._stateBeforeStyle2(c);
	        } else if (this._state === BEFORE_STYLE_3) {
	            this._stateBeforeStyle3(c);
	        } else if (this._state === BEFORE_STYLE_4) {
	            this._stateBeforeStyle4(c);
	        } else if (this._state === AFTER_STYLE_1) {
	            this._stateAfterStyle1(c);
	        } else if (this._state === AFTER_STYLE_2) {
	            this._stateAfterStyle2(c);
	        } else if (this._state === AFTER_STYLE_3) {
	            this._stateAfterStyle3(c);
	        } else if (this._state === AFTER_STYLE_4) {
	            this._stateAfterStyle4(c);
	        } else if (this._state === BEFORE_ENTITY) {
	
	        /*
			* entities
			*/
	            this._stateBeforeEntity(c);
	        } else if (this._state === BEFORE_NUMERIC_ENTITY) {
	            this._stateBeforeNumericEntity(c);
	        } else if (this._state === IN_NAMED_ENTITY) {
	            this._stateInNamedEntity(c);
	        } else if (this._state === IN_NUMERIC_ENTITY) {
	            this._stateInNumericEntity(c);
	        } else if (this._state === IN_HEX_ENTITY) {
	            this._stateInHexEntity(c);
	        } else {
	            this._cbs.onerror(Error("unknown _state"), this._state);
	        }
	
	        this._index++;
	    }
	
	    this._cleanup();
	};
	
	Tokenizer.prototype.pause = function() {
	    this._running = false;
	};
	Tokenizer.prototype.resume = function() {
	    this._running = true;
	
	    if (this._index < this._buffer.length) {
	        this._parse();
	    }
	    if (this._ended) {
	        this._finish();
	    }
	};
	
	Tokenizer.prototype.end = function(chunk) {
	    if (this._ended) this._cbs.onerror(Error(".end() after done!"));
	    if (chunk) this.write(chunk);
	
	    this._ended = true;
	
	    if (this._running) this._finish();
	};
	
	Tokenizer.prototype._finish = function() {
	    //if there is remaining data, emit it in a reasonable way
	    if (this._sectionStart < this._index) {
	        this._handleTrailingData();
	    }
	
	    this._cbs.onend();
	};
	
	Tokenizer.prototype._handleTrailingData = function() {
	    var data = this._buffer.substr(this._sectionStart);
	
	    if (
	        this._state === IN_CDATA ||
	        this._state === AFTER_CDATA_1 ||
	        this._state === AFTER_CDATA_2
	    ) {
	        this._cbs.oncdata(data);
	    } else if (
	        this._state === IN_COMMENT ||
	        this._state === AFTER_COMMENT_1 ||
	        this._state === AFTER_COMMENT_2
	    ) {
	        this._cbs.oncomment(data);
	    } else if (this._state === IN_NAMED_ENTITY && !this._xmlMode) {
	        this._parseLegacyEntity();
	        if (this._sectionStart < this._index) {
	            this._state = this._baseState;
	            this._handleTrailingData();
	        }
	    } else if (this._state === IN_NUMERIC_ENTITY && !this._xmlMode) {
	        this._decodeNumericEntity(2, 10);
	        if (this._sectionStart < this._index) {
	            this._state = this._baseState;
	            this._handleTrailingData();
	        }
	    } else if (this._state === IN_HEX_ENTITY && !this._xmlMode) {
	        this._decodeNumericEntity(3, 16);
	        if (this._sectionStart < this._index) {
	            this._state = this._baseState;
	            this._handleTrailingData();
	        }
	    } else if (
	        this._state !== IN_TAG_NAME &&
	        this._state !== BEFORE_ATTRIBUTE_NAME &&
	        this._state !== BEFORE_ATTRIBUTE_VALUE &&
	        this._state !== AFTER_ATTRIBUTE_NAME &&
	        this._state !== IN_ATTRIBUTE_NAME &&
	        this._state !== IN_ATTRIBUTE_VALUE_SQ &&
	        this._state !== IN_ATTRIBUTE_VALUE_DQ &&
	        this._state !== IN_ATTRIBUTE_VALUE_NQ &&
	        this._state !== IN_CLOSING_TAG_NAME
	    ) {
	        this._cbs.ontext(data);
	    }
	    //else, ignore remaining data
	    //TODO add a way to remove current tag
	};
	
	Tokenizer.prototype.reset = function() {
	    Tokenizer.call(
	        this,
	        { xmlMode: this._xmlMode, decodeEntities: this._decodeEntities },
	        this._cbs
	    );
	};
	
	Tokenizer.prototype.getAbsoluteIndex = function() {
	    return this._bufferOffset + this._index;
	};
	
	Tokenizer.prototype._getSection = function() {
	    return this._buffer.substring(this._sectionStart, this._index);
	};
	
	Tokenizer.prototype._emitToken = function(name) {
	    this._cbs[name](this._getSection());
	    this._sectionStart = -1;
	};
	
	Tokenizer.prototype._emitPartial = function(value) {
	    if (this._baseState !== TEXT) {
	        this._cbs.onattribdata(value); //TODO implement the new event
	    } else {
	        this._cbs.ontext(value);
	    }
	};


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = Stream;
	
	var Parser = __webpack_require__(397);
	var WritableStream = __webpack_require__(854).Writable;
	var StringDecoder = __webpack_require__(815).StringDecoder;
	var Buffer = __webpack_require__(213).Buffer;
	
	function Stream(cbs, options) {
	    var parser = (this._parser = new Parser(cbs, options));
	    var decoder = (this._decoder = new StringDecoder());
	
	    WritableStream.call(this, { decodeStrings: false });
	
	    this.once("finish", function() {
	        parser.end(decoder.end());
	    });
	}
	
	__webpack_require__(105)(Stream, WritableStream);
	
	Stream.prototype._write = function(chunk, encoding, cb) {
	    if (chunk instanceof Buffer) chunk = this._decoder.write(chunk);
	    this._parser.write(chunk);
	    cb();
	};


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(538);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(791);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getPanelsCount = getPanelsCount;
	exports.getTabsCount = getTabsCount;
	
	var _childrenDeepMap = __webpack_require__(160);
	
	var _elementTypes = __webpack_require__(112);
	
	function getTabsCount(children) {
	  var tabCount = 0;
	  (0, _childrenDeepMap.deepForEach)(children, function (child) {
	    if ((0, _elementTypes.isTab)(child)) tabCount++;
	  });
	  return tabCount;
	}
	
	function getPanelsCount(children) {
	  var panelCount = 0;
	  (0, _childrenDeepMap.deepForEach)(children, function (child) {
	    if ((0, _elementTypes.isTabPanel)(child)) panelCount++;
	  });
	  return panelCount;
	}

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.childrenPropType = childrenPropType;
	exports.onSelectPropType = onSelectPropType;
	exports.selectedIndexPropType = selectedIndexPropType;
	
	var _childrenDeepMap = __webpack_require__(160);
	
	var _elementTypes = __webpack_require__(112);
	
	function childrenPropType(props, propName, componentName) {
	  var error;
	  var tabsCount = 0;
	  var panelsCount = 0;
	  var tabListFound = false;
	  var listTabs = [];
	  var children = props[propName];
	  (0, _childrenDeepMap.deepForEach)(children, function (child) {
	    if ((0, _elementTypes.isTabList)(child)) {
	      if (child.props && child.props.children && typeof child.props.children === 'object') {
	        (0, _childrenDeepMap.deepForEach)(child.props.children, function (listChild) {
	          return listTabs.push(listChild);
	        });
	      }
	
	      if (tabListFound) {
	        error = new Error("Found multiple 'TabList' components inside 'Tabs'. Only one is allowed.");
	      }
	
	      tabListFound = true;
	    }
	
	    if ((0, _elementTypes.isTab)(child)) {
	      if (!tabListFound || listTabs.indexOf(child) === -1) {
	        error = new Error("Found a 'Tab' component outside of the 'TabList' component. 'Tab' components " + "have to be inside the 'TabList' component.");
	      }
	
	      tabsCount++;
	    } else if ((0, _elementTypes.isTabPanel)(child)) {
	      panelsCount++;
	    }
	  });
	
	  if (!error && tabsCount !== panelsCount) {
	    error = new Error("There should be an equal number of 'Tab' and 'TabPanel' in `" + componentName + "`. " + ("Received " + tabsCount + " 'Tab' and " + panelsCount + " 'TabPanel'."));
	  }
	
	  return error;
	}
	
	function onSelectPropType(props, propName, componentName, location, propFullName) {
	  var prop = props[propName];
	  var name = propFullName || propName;
	  var error = null;
	
	  if (prop && typeof prop !== 'function') {
	    error = new Error("Invalid " + location + " `" + name + "` of type `" + typeof prop + "` supplied " + ("to `" + componentName + "`, expected `function`."));
	  } else if (props.selectedIndex != null && prop == null) {
	    error = new Error("The " + location + " `" + name + "` is marked as required in `" + componentName + "`, but " + "its value is `undefined` or `null`.\n" + "`onSelect` is required when `selectedIndex` is also set. Not doing so will " + "make the tabs not do anything, as `selectedIndex` indicates that you want to " + "handle the selected tab yourself.\n" + "If you only want to set the inital tab replace `selectedIndex` with `defaultIndex`.");
	  }
	
	  return error;
	}
	
	function selectedIndexPropType(props, propName, componentName, location, propFullName) {
	  var prop = props[propName];
	  var name = propFullName || propName;
	  var error = null;
	
	  if (prop != null && typeof prop !== 'number') {
	    error = new Error("Invalid " + location + " `" + name + "` of type `" + typeof prop + "` supplied to " + ("`" + componentName + "`, expected `number`."));
	  } else if (props.defaultIndex != null && prop != null) {
	    return new Error("The " + location + " `" + name + "` cannot be used together with `defaultIndex` " + ("in `" + componentName + "`.\n") + ("Either remove `" + name + "` to let `" + componentName + "` handle the selected ") + "tab internally or remove `defaultIndex` to handle it yourself.");
	  }
	
	  return error;
	}

/***/ },
/* 404 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = uuid;
	exports.reset = reset;
	// Get a universally unique identifier
	var count = 0;
	
	function uuid() {
	  return "react-tabs-" + count++;
	}
	
	function reset() {
	  count = 0;
	}

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(85),
	    _assign = __webpack_require__(16);
	
	var ReactNoopUpdateQueue = __webpack_require__(408);
	
	var canDefineProperty = __webpack_require__(409);
	var emptyObject = __webpack_require__(138);
	var invariant = __webpack_require__(11);
	var lowPriorityWarning = __webpack_require__(806);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(85);
	
	var ReactCurrentOwner = __webpack_require__(44);
	
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(15);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 407 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(15);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 410 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAPNQTFRFAAAAn5+csrKwu7u6vr69zMzMwMC/vLy7s7Oynp6an5+Yra2sx8fGyMjHtLSyp6ennZ2bwcHBxMPDr6+tsLCvt7e0tra1vbu5t7e3vLq4rq+utrOxxMTExMG/j4+Ptba0uri3ycnJycjIr6+vpaWkubm5urq5wMDAwcHBw8PCxMTDw8PDxMPCxMPDvLy7v76+sLCwp6WiycnIurq6vLy7rq6uxsbFx8fGr6+vs7Oyu7u6vr28vr69yMjH2dnZs7KxwL++z8zL29vbkJCYxcjKzc3Nzs3M2tLM78+/3t7g2NjY1NTU0tLS09PS1dXU2trZ5N3XdEOZwgAAAFF0Uk5TAHzO7/b/9u/OcB+//v6/H5L9/YfPztzbz8+Sh/39EMDA/v58cc/P7+/59vn278/PcXH+wMAf/f0Qh4fA3NzAh/39hx/A/v7AEHHP7/b2789xYsQUZQAAAM9JREFUeJyF0+duAjEQBOANMPTeCYTQewkkBNIooUMIvP/TcOh0TXde5qc/WVrZs0RqHmx2B+B0uT1kitfnh5pAMGTUcASGRGN6jcOUhKZJswIpRdNWCmRkfbRWIHvTUE7ET3mJn0UKFCQuirlEVBYrUKEqxzWqc9ygJsct4hS4x21OO/xoXepx3KcXjgfsow6lN38V85vEo3eRjie3D/8Q8adcF8HwX0rZvq30R6uqxf2pvuizuREXv8Y1Wa7WGm62O/Oa7Q/HP+D0f75oZ1ddpRonM+mucwAAAABJRU5ErkJggg=="

/***/ },
/* 411 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAApgAAAKYB3X3/OAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAKNSURBVEiJvZZNaxNBGMd/M7ttIT1Ukr54qI1FqAcRIUkpOdX9AhI9CtoIbS89tJ6EUhSlCN7aa3sw+gGk+AVCQSjaxIt4CUpJKNiXKHpoIclmHw/pLnGzaaGG/mEPO/Ps73mZZ2ZWiQjt9P3ew0GzrscVknCUiitIAAjktEheUDnbcLavvXt70I6hAh1Yllnqiy4KLAFdbSNoqKZgeeRP8SXZrH2mg9Kd9A3RvAHiZ4D9yiuHqZH3ma/Ng7r5pZiamhZN/hxwgLho8sXU1HTzoJfBburRzTqSA7rPAW9W1UAlhjdefwE3A8sy60oyHYADdNeVZLAs03NQ6osuIsT8lkYkTCjZvlqhZBwjEm6dEGKlvugigPp298Gg6ehdfN1iRMJcXn6COTRAeXWdo82tfxi9k0n652ew9w/ZW3pF/ecvv5uarZ1hbdb1uB8O0DM2ijk0AFrTPz9D72SyBY7WmEMD9IyNBiXYZdb1uPH4+q37KHW7xf3uD+y9A0ITMdCa0EQMe++A7qtXPDiOQ3l1neMPnwJLqJCCebJDA+WWxQX2L8yefKk8uL90zXKUipvu9m8nz8nCbAMMIHImvJEBCX2qRQekBXKnGXgLqhSINB6lWhY+SAI5rUXyZ8LdBV1Zo7yyBo4T2F2t0UveFFRgBqFkvKVbmmvuLfz8DFKtcrzVGqegcto2nG2g5p+sFHaw9w8D4UebW5RX18FxsPcPqRR2gmKs2YazrUSEUir9VOC538KIhOkZGw2Mzs2yUtgJ2sUoeDaykXnROE0tyyxein4MOo/OJcXn6O/iBNms3WjTbNY2RKWBagfwVUNU2r3dvH3QOL9lDqj8B7wCMufeBXABV+bFX/rN6sRvy18zCD6H8NWwzgAAAABJRU5ErkJggg=="

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/home3.42de1bd4.webp";

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/insights.835eb1e5.jpeg";

/***/ },
/* 414 */
114,
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(416);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  setPrototypeOf(subClass, superClass);
	}
	
	module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 416 */
/***/ function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _setPrototypeOf(o, p);
	}
	
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var util_1 = __webpack_require__(2);
	var util_2 = __webpack_require__(2);
	var contains = function (obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	};
	var DEFAULT_ENTRY_NAME = '[DEFAULT]';
	// An array to capture listeners before the true auth functions
	// exist
	var tokenListeners = [];
	/**
	 * Global context object for a collection of services using
	 * a shared authentication state.
	 */
	var FirebaseAppImpl = /** @class */ (function () {
	    function FirebaseAppImpl(options, name, firebase_) {
	        this.firebase_ = firebase_;
	        this.isDeleted_ = false;
	        this.services_ = {};
	        this.name_ = name;
	        this.options_ = util_2.deepCopy(options);
	        this.INTERNAL = {
	            getUid: function () { return null; },
	            getToken: function () { return Promise.resolve(null); },
	            addAuthTokenListener: function (callback) {
	                tokenListeners.push(callback);
	                // Make sure callback is called, asynchronously, in the absence of the auth module
	                setTimeout(function () { return callback(null); }, 0);
	            },
	            removeAuthTokenListener: function (callback) {
	                tokenListeners = tokenListeners.filter(function (listener) { return listener !== callback; });
	            }
	        };
	    }
	    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
	        get: function () {
	            this.checkDestroyed_();
	            return this.name_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
	        get: function () {
	            this.checkDestroyed_();
	            return this.options_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    FirebaseAppImpl.prototype.delete = function () {
	        var _this = this;
	        return new Promise(function (resolve) {
	            _this.checkDestroyed_();
	            resolve();
	        })
	            .then(function () {
	            _this.firebase_.INTERNAL.removeApp(_this.name_);
	            var services = [];
	            Object.keys(_this.services_).forEach(function (serviceKey) {
	                Object.keys(_this.services_[serviceKey]).forEach(function (instanceKey) {
	                    services.push(_this.services_[serviceKey][instanceKey]);
	                });
	            });
	            return Promise.all(services.map(function (service) {
	                return service.INTERNAL.delete();
	            }));
	        })
	            .then(function () {
	            _this.isDeleted_ = true;
	            _this.services_ = {};
	        });
	    };
	    /**
	     * Return a service instance associated with this app (creating it
	     * on demand), identified by the passed instanceIdentifier.
	     *
	     * NOTE: Currently storage is the only one that is leveraging this
	     * functionality. They invoke it by calling:
	     *
	     * ```javascript
	     * firebase.app().storage('STORAGE BUCKET ID')
	     * ```
	     *
	     * The service name is passed to this already
	     * @internal
	     */
	    FirebaseAppImpl.prototype._getService = function (name, instanceIdentifier) {
	        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
	        this.checkDestroyed_();
	        if (!this.services_[name]) {
	            this.services_[name] = {};
	        }
	        if (!this.services_[name][instanceIdentifier]) {
	            /**
	             * If a custom instance has been defined (i.e. not '[DEFAULT]')
	             * then we will pass that instance on, otherwise we pass `null`
	             */
	            var instanceSpecifier = instanceIdentifier !== DEFAULT_ENTRY_NAME
	                ? instanceIdentifier
	                : undefined;
	            var service = this.firebase_.INTERNAL.factories[name](this, this.extendApp.bind(this), instanceSpecifier);
	            this.services_[name][instanceIdentifier] = service;
	        }
	        return this.services_[name][instanceIdentifier];
	    };
	    /**
	     * Callback function used to extend an App instance at the time
	     * of service instance creation.
	     */
	    FirebaseAppImpl.prototype.extendApp = function (props) {
	        var _this = this;
	        // Copy the object onto the FirebaseAppImpl prototype
	        util_2.deepExtend(this, props);
	        /**
	         * If the app has overwritten the addAuthTokenListener stub, forward
	         * the active token listeners on to the true fxn.
	         *
	         * TODO: This function is required due to our current module
	         * structure. Once we are able to rely strictly upon a single module
	         * implementation, this code should be refactored and Auth should
	         * provide these stubs and the upgrade logic
	         */
	        if (props.INTERNAL && props.INTERNAL.addAuthTokenListener) {
	            tokenListeners.forEach(function (listener) {
	                _this.INTERNAL.addAuthTokenListener(listener);
	            });
	            tokenListeners = [];
	        }
	    };
	    /**
	     * This function will throw an Error if the App has already been deleted -
	     * use before performing API actions on the App.
	     */
	    FirebaseAppImpl.prototype.checkDestroyed_ = function () {
	        if (this.isDeleted_) {
	            error('app-deleted', { name: this.name_ });
	        }
	    };
	    return FirebaseAppImpl;
	}());
	// Prevent dead-code elimination of these methods w/o invalid property
	// copying.
	(FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
	    FirebaseAppImpl.prototype.delete ||
	    console.log('dc');
	/**
	 * Return a firebase namespace object.
	 *
	 * In production, this will be called exactly once and the result
	 * assigned to the 'firebase' global.  It may be called multiple times
	 * in unit tests.
	 */
	function createFirebaseNamespace() {
	    var apps_ = {};
	    var factories = {};
	    var appHooks = {};
	    // A namespace is a plain JavaScript Object.
	    var namespace = {
	        // Hack to prevent Babel from modifying the object returned
	        // as the firebase namespace.
	        __esModule: true,
	        initializeApp: initializeApp,
	        app: app,
	        apps: null,
	        Promise: Promise,
	        SDK_VERSION: '4.8.0',
	        INTERNAL: {
	            registerService: registerService,
	            createFirebaseNamespace: createFirebaseNamespace,
	            extendNamespace: extendNamespace,
	            createSubscribe: util_1.createSubscribe,
	            ErrorFactory: util_2.ErrorFactory,
	            removeApp: removeApp,
	            factories: factories,
	            useAsService: useAsService,
	            Promise: Promise,
	            deepExtend: util_2.deepExtend
	        }
	    };
	    // Inject a circular default export to allow Babel users who were previously
	    // using:
	    //
	    //   import firebase from 'firebase';
	    //   which becomes: var firebase = require('firebase').default;
	    //
	    // instead of
	    //
	    //   import * as firebase from 'firebase';
	    //   which becomes: var firebase = require('firebase');
	    util_2.patchProperty(namespace, 'default', namespace);
	    // firebase.apps is a read-only getter.
	    Object.defineProperty(namespace, 'apps', {
	        get: getApps
	    });
	    /**
	     * Called by App.delete() - but before any services associated with the App
	     * are deleted.
	     */
	    function removeApp(name) {
	        var app = apps_[name];
	        callAppHooks(app, 'delete');
	        delete apps_[name];
	    }
	    /**
	     * Get the App object for a given name (or DEFAULT).
	     */
	    function app(name) {
	        name = name || DEFAULT_ENTRY_NAME;
	        if (!contains(apps_, name)) {
	            error('no-app', { name: name });
	        }
	        return apps_[name];
	    }
	    util_2.patchProperty(app, 'App', FirebaseAppImpl);
	    /**
	     * Create a new App instance (name must be unique).
	     */
	    function initializeApp(options, name) {
	        if (name === undefined) {
	            name = DEFAULT_ENTRY_NAME;
	        }
	        else {
	            if (typeof name !== 'string' || name === '') {
	                error('bad-app-name', { name: name + '' });
	            }
	        }
	        if (contains(apps_, name)) {
	            error('duplicate-app', { name: name });
	        }
	        var app = new FirebaseAppImpl(options, name, namespace);
	        apps_[name] = app;
	        callAppHooks(app, 'create');
	        return app;
	    }
	    /*
	     * Return an array of all the non-deleted FirebaseApps.
	     */
	    function getApps() {
	        // Make a copy so caller cannot mutate the apps list.
	        return Object.keys(apps_).map(function (name) { return apps_[name]; });
	    }
	    /*
	     * Register a Firebase Service.
	     *
	     * firebase.INTERNAL.registerService()
	     *
	     * TODO: Implement serviceProperties.
	     */
	    function registerService(name, createService, serviceProperties, appHook, allowMultipleInstances) {
	        // Cannot re-register a service that already exists
	        if (factories[name]) {
	            error('duplicate-service', { name: name });
	        }
	        // Capture the service factory for later service instantiation
	        factories[name] = createService;
	        // Capture the appHook, if passed
	        if (appHook) {
	            appHooks[name] = appHook;
	            // Run the **new** app hook on all existing apps
	            getApps().forEach(function (app) {
	                appHook('create', app);
	            });
	        }
	        // The Service namespace is an accessor function ...
	        var serviceNamespace = function (appArg) {
	            if (appArg === void 0) { appArg = app(); }
	            if (typeof appArg[name] !== 'function') {
	                // Invalid argument.
	                // This happens in the following case: firebase.storage('gs:/')
	                error('invalid-app-argument', { name: name });
	            }
	            // Forward service instance lookup to the FirebaseApp.
	            return appArg[name]();
	        };
	        // ... and a container for service-level properties.
	        if (serviceProperties !== undefined) {
	            util_2.deepExtend(serviceNamespace, serviceProperties);
	        }
	        // Monkey-patch the serviceNamespace onto the firebase namespace
	        namespace[name] = serviceNamespace;
	        // Patch the FirebaseAppImpl prototype
	        FirebaseAppImpl.prototype[name] = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var serviceFxn = this._getService.bind(this, name);
	            return serviceFxn.apply(this, allowMultipleInstances ? args : []);
	        };
	        return serviceNamespace;
	    }
	    /**
	     * Patch the top-level firebase namespace with additional properties.
	     *
	     * firebase.INTERNAL.extendNamespace()
	     */
	    function extendNamespace(props) {
	        util_2.deepExtend(namespace, props);
	    }
	    function callAppHooks(app, eventName) {
	        Object.keys(factories).forEach(function (serviceName) {
	            // Ignore virtual services
	            var factoryName = useAsService(app, serviceName);
	            if (factoryName === null) {
	                return;
	            }
	            if (appHooks[factoryName]) {
	                appHooks[factoryName](eventName, app);
	            }
	        });
	    }
	    // Map the requested service to a registered service name
	    // (used to map auth to serverAuth service when needed).
	    function useAsService(app, name) {
	        if (name === 'serverAuth') {
	            return null;
	        }
	        var useService = name;
	        var options = app.options;
	        return useService;
	    }
	    return namespace;
	}
	exports.createFirebaseNamespace = createFirebaseNamespace;
	function error(code, args) {
	    throw appErrors.create(code, args);
	}
	// TypeScript does not support non-string indexes!
	// let errors: {[code: AppError: string} = {
	var errors = {
	    'no-app': "No Firebase App '{$name}' has been created - " +
	        'call Firebase App.initializeApp()',
	    'bad-app-name': "Illegal App name: '{$name}",
	    'duplicate-app': "Firebase App named '{$name}' already exists",
	    'app-deleted': "Firebase App named '{$name}' already deleted",
	    'duplicate-service': "Firebase service named '{$name}' already registered",
	    'sa-not-supported': 'Initializing the Firebase SDK with a service ' +
	        'account is only allowed in a Node.js environment. On client ' +
	        'devices, you should instead initialize the SDK with an api key and ' +
	        'auth domain',
	    'invalid-app-argument': 'firebase.{$name}() takes either no argument or a ' +
	        'Firebase App instance.'
	};
	var appErrors = new util_2.ErrorFactory('app', 'Firebase', errors);
	
	
	//# sourceMappingURL=firebaseApp.js.map


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function() {
	  var firebase = __webpack_require__(35).default;
	  var h,aa=aa||{},k=this;function m(a){return"string"==typeof a}function ba(a){return"boolean"==typeof a}function ca(){}
	function da(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
	else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ea(a){return null===a}function fa(a){return"array"==da(a)}function ha(a){var b=da(a);return"array"==b||"object"==b&&"number"==typeof a.length}function p(a){return"function"==da(a)}function q(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}var ia="closure_uid_"+(1E9*Math.random()>>>0),ja=0;function ka(a,b,c){return a.call.apply(a.bind,arguments)}
	function la(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function r(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?r=ka:r=la;return r.apply(null,arguments)}
	function ma(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var b=c.slice();b.push.apply(b,arguments);return a.apply(this,b)}}var na=Date.now||function(){return+new Date};function t(a,b){function c(){}c.prototype=b.prototype;a.ib=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.Rc=function(a,c,f){for(var d=Array(arguments.length-2),e=2;e<arguments.length;e++)d[e-2]=arguments[e];return b.prototype[c].apply(a,d)}};function u(a){if(Error.captureStackTrace)Error.captureStackTrace(this,u);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))}t(u,Error);u.prototype.name="CustomError";function oa(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")}var pa=String.prototype.trim?function(a){return a.trim()}:function(a){return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g,"")};
	function qa(a){if(!ra.test(a))return a;-1!=a.indexOf("&")&&(a=a.replace(sa,"&amp;"));-1!=a.indexOf("<")&&(a=a.replace(ta,"&lt;"));-1!=a.indexOf(">")&&(a=a.replace(ua,"&gt;"));-1!=a.indexOf('"')&&(a=a.replace(va,"&quot;"));-1!=a.indexOf("'")&&(a=a.replace(wa,"&#39;"));-1!=a.indexOf("\x00")&&(a=a.replace(xa,"&#0;"));return a}var sa=/&/g,ta=/</g,ua=/>/g,va=/"/g,wa=/'/g,xa=/\x00/g,ra=/[\x00&<>"']/;function v(a,b){return-1!=a.indexOf(b)}function ya(a,b){return a<b?-1:a>b?1:0};function za(a,b){b.unshift(a);u.call(this,oa.apply(null,b));b.shift()}t(za,u);za.prototype.name="AssertionError";function Aa(a,b){throw new za("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));};var Ba=Array.prototype.indexOf?function(a,b,c){return Array.prototype.indexOf.call(a,b,c)}:function(a,b,c){c=null==c?0:0>c?Math.max(0,a.length+c):c;if(m(a))return m(b)&&1==b.length?a.indexOf(b,c):-1;for(;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},w=Array.prototype.forEach?function(a,b,c){Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=m(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};
	function Ca(a,b){var c=a.length,d=m(a)?a.split(""):a;for(--c;0<=c;--c)c in d&&b.call(void 0,d[c],c,a)}var Da=Array.prototype.map?function(a,b,c){return Array.prototype.map.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=Array(d),f=m(a)?a.split(""):a,g=0;g<d;g++)g in f&&(e[g]=b.call(c,f[g],g,a));return e},Ea=Array.prototype.some?function(a,b,c){return Array.prototype.some.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=m(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return!0;return!1};
	function Fa(a){a:{var b=Ga;for(var c=a.length,d=m(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:m(a)?a.charAt(b):a[b]}function Ha(a,b){return 0<=Ba(a,b)}function Ia(a,b){b=Ba(a,b);var c;(c=0<=b)&&Array.prototype.splice.call(a,b,1);return c}function Ja(a,b){var c=0;Ca(a,function(d,e){b.call(void 0,d,e,a)&&1==Array.prototype.splice.call(a,e,1).length&&c++})}function Ka(a){return Array.prototype.concat.apply([],arguments)}
	function La(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};var Ma;a:{var Na=k.navigator;if(Na){var Oa=Na.userAgent;if(Oa){Ma=Oa;break a}}Ma=""}function x(a){return v(Ma,a)};function Pa(a,b){for(var c in a)b.call(void 0,a[c],c,a)}function Qa(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b}function Ra(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b}function Sa(a){for(var b in a)return!1;return!0}function Ta(a,b){for(var c in a)if(!(c in b)||a[c]!==b[c])return!1;for(c in b)if(!(c in a))return!1;return!0}function Ua(a){var b={},c;for(c in a)b[c]=a[c];return b}var Va="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
	function Wa(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<Va.length;f++)c=Va[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};function Xa(a){Xa[" "](a);return a}Xa[" "]=ca;function Ya(a,b){var c=Za;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var $a=x("Opera"),y=x("Trident")||x("MSIE"),ab=x("Edge"),bb=ab||y,cb=x("Gecko")&&!(v(Ma.toLowerCase(),"webkit")&&!x("Edge"))&&!(x("Trident")||x("MSIE"))&&!x("Edge"),db=v(Ma.toLowerCase(),"webkit")&&!x("Edge");function eb(){var a=k.document;return a?a.documentMode:void 0}var fb;
	a:{var gb="",hb=function(){var a=Ma;if(cb)return/rv\:([^\);]+)(\)|;)/.exec(a);if(ab)return/Edge\/([\d\.]+)/.exec(a);if(y)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(db)return/WebKit\/(\S+)/.exec(a);if($a)return/(?:Version)[ \/]?(\S+)/.exec(a)}();hb&&(gb=hb?hb[1]:"");if(y){var ib=eb();if(null!=ib&&ib>parseFloat(gb)){fb=String(ib);break a}}fb=gb}var Za={};
	function jb(a){return Ya(a,function(){for(var b=0,c=pa(String(fb)).split("."),d=pa(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var g=c[f]||"",l=d[f]||"";do{g=/(\d*)(\D*)(.*)/.exec(g)||["","","",""];l=/(\d*)(\D*)(.*)/.exec(l)||["","","",""];if(0==g[0].length&&0==l[0].length)break;b=ya(0==g[1].length?0:parseInt(g[1],10),0==l[1].length?0:parseInt(l[1],10))||ya(0==g[2].length,0==l[2].length)||ya(g[2],l[2]);g=g[3];l=l[3]}while(0==b)}return 0<=b})}var kb;var lb=k.document;
	kb=lb&&y?eb()||("CSS1Compat"==lb.compatMode?parseInt(fb,10):5):void 0;function mb(a){a.prototype.then=a.prototype.then;a.prototype.$goog_Thenable=!0}function nb(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}};function ob(a,b,c){this.f=c;this.c=a;this.g=b;this.b=0;this.a=null}ob.prototype.get=function(){if(0<this.b){this.b--;var a=this.a;this.a=a.next;a.next=null}else a=this.c();return a};function pb(a,b){a.g(b);a.b<a.f&&(a.b++,b.next=a.a,a.a=b)};var rb=new ob(function(){return new qb},function(a){a.reset()},100);function sb(){var a=tb,b=null;a.a&&(b=a.a,a.a=a.a.next,a.a||(a.b=null),b.next=null);return b}function qb(){this.next=this.b=this.a=null}qb.prototype.set=function(a,b){this.a=a;this.b=b;this.next=null};qb.prototype.reset=function(){this.next=this.b=this.a=null};function ub(a){k.setTimeout(function(){throw a;},0)}var wb;
	function xb(){var a=k.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!x("Presto")&&(a=function(){var a=document.createElement("IFRAME");a.style.display="none";a.src="";document.documentElement.appendChild(a);var b=a.contentWindow;a=b.document;a.open();a.write("");a.close();var c="callImmediate"+Math.random(),d="file:"==b.location.protocol?"*":b.location.protocol+"//"+b.location.host;a=r(function(a){if(("*"==d||a.origin==d)&&a.data==
	c)this.port1.onmessage()},this);b.addEventListener("message",a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,d)}}});if("undefined"!==typeof a&&!x("Trident")&&!x("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var a=c.pb;c.pb=null;a()}};return function(a){d.next={pb:a};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?function(a){var b=document.createElement("SCRIPT");
	b.onreadystatechange=function(){b.onreadystatechange=null;b.parentNode.removeChild(b);b=null;a();a=null};document.documentElement.appendChild(b)}:function(a){k.setTimeout(a,0)}};function yb(a,b){zb||Ab();Bb||(zb(),Bb=!0);var c=tb,d=rb.get();d.set(a,b);c.b?c.b.next=d:c.a=d;c.b=d}var zb;function Ab(){if(-1!=String(k.Promise).indexOf("[native code]")){var a=k.Promise.resolve(void 0);zb=function(){a.then(Cb)}}else zb=function(){var a=Cb;!p(k.setImmediate)||k.Window&&k.Window.prototype&&!x("Edge")&&k.Window.prototype.setImmediate==k.setImmediate?(wb||(wb=xb()),wb(a)):k.setImmediate(a)}}var Bb=!1,tb=new function(){this.b=this.a=null};
	function Cb(){for(var a;a=sb();){try{a.a.call(a.b)}catch(b){ub(b)}pb(rb,a)}Bb=!1};function z(a,b){this.a=Db;this.i=void 0;this.f=this.b=this.c=null;this.g=this.h=!1;if(a!=ca)try{var c=this;a.call(b,function(a){Eb(c,Fb,a)},function(a){if(!(a instanceof Gb))try{if(a instanceof Error)throw a;throw Error("Promise rejected.");}catch(e){}Eb(c,Hb,a)})}catch(d){Eb(this,Hb,d)}}var Db=0,Fb=2,Hb=3;function Ib(){this.next=this.f=this.b=this.g=this.a=null;this.c=!1}Ib.prototype.reset=function(){this.f=this.b=this.g=this.a=null;this.c=!1};
	var Jb=new ob(function(){return new Ib},function(a){a.reset()},100);function Kb(a,b,c){var d=Jb.get();d.g=a;d.b=b;d.f=c;return d}function A(a){if(a instanceof z)return a;var b=new z(ca);Eb(b,Fb,a);return b}function B(a){return new z(function(b,c){c(a)})}function Lb(a,b,c){Mb(a,b,c,null)||yb(ma(b,a))}function Nb(a){return new z(function(b,c){var d=a.length,e=[];if(d)for(var f=function(a,c){d--;e[a]=c;0==d&&b(e)},g=function(a){c(a)},l=0,n;l<a.length;l++)n=a[l],Lb(n,ma(f,l),g);else b(e)})}
	function Ob(a){return new z(function(b){var c=a.length,d=[];if(c)for(var e=function(a,e,f){c--;d[a]=e?{Ub:!0,value:f}:{Ub:!1,reason:f};0==c&&b(d)},f=0,g;f<a.length;f++)g=a[f],Lb(g,ma(e,f,!0),ma(e,f,!1));else b(d)})}z.prototype.then=function(a,b,c){return Pb(this,p(a)?a:null,p(b)?b:null,c)};mb(z);function Qb(a,b){b=Kb(b,b,void 0);b.c=!0;Rb(a,b);return a}h=z.prototype;h.s=function(a,b){return Pb(this,null,a,b)};h.cancel=function(a){this.a==Db&&yb(function(){var b=new Gb(a);Sb(this,b)},this)};
	function Sb(a,b){if(a.a==Db)if(a.c){var c=a.c;if(c.b){for(var d=0,e=null,f=null,g=c.b;g&&(g.c||(d++,g.a==a&&(e=g),!(e&&1<d)));g=g.next)e||(f=g);e&&(c.a==Db&&1==d?Sb(c,b):(f?(d=f,d.next==c.f&&(c.f=d),d.next=d.next.next):Tb(c),Ub(c,e,Hb,b)))}a.c=null}else Eb(a,Hb,b)}function Rb(a,b){a.b||a.a!=Fb&&a.a!=Hb||Vb(a);a.f?a.f.next=b:a.b=b;a.f=b}
	function Pb(a,b,c,d){var e=Kb(null,null,null);e.a=new z(function(a,g){e.g=b?function(c){try{var e=b.call(d,c);a(e)}catch(D){g(D)}}:a;e.b=c?function(b){try{var e=c.call(d,b);void 0===e&&b instanceof Gb?g(b):a(e)}catch(D){g(D)}}:g});e.a.c=a;Rb(a,e);return e.a}h.Ac=function(a){this.a=Db;Eb(this,Fb,a)};h.Bc=function(a){this.a=Db;Eb(this,Hb,a)};
	function Eb(a,b,c){a.a==Db&&(a===c&&(b=Hb,c=new TypeError("Promise cannot resolve to itself")),a.a=1,Mb(c,a.Ac,a.Bc,a)||(a.i=c,a.a=b,a.c=null,Vb(a),b!=Hb||c instanceof Gb||Wb(a,c)))}function Mb(a,b,c,d){if(a instanceof z)return Rb(a,Kb(b||ca,c||null,d)),!0;if(nb(a))return a.then(b,c,d),!0;if(q(a))try{var e=a.then;if(p(e))return Xb(a,e,b,c,d),!0}catch(f){return c.call(d,f),!0}return!1}
	function Xb(a,b,c,d,e){function f(a){l||(l=!0,d.call(e,a))}function g(a){l||(l=!0,c.call(e,a))}var l=!1;try{b.call(a,g,f)}catch(n){f(n)}}function Vb(a){a.h||(a.h=!0,yb(a.Qb,a))}function Tb(a){var b=null;a.b&&(b=a.b,a.b=b.next,b.next=null);a.b||(a.f=null);return b}h.Qb=function(){for(var a;a=Tb(this);)Ub(this,a,this.a,this.i);this.h=!1};
	function Ub(a,b,c,d){if(c==Hb&&b.b&&!b.c)for(;a&&a.g;a=a.c)a.g=!1;if(b.a)b.a.c=null,Yb(b,c,d);else try{b.c?b.g.call(b.f):Yb(b,c,d)}catch(e){Zb.call(null,e)}pb(Jb,b)}function Yb(a,b,c){b==Fb?a.g.call(a.f,c):a.b&&a.b.call(a.f,c)}function Wb(a,b){a.g=!0;yb(function(){a.g&&Zb.call(null,b)})}var Zb=ub;function Gb(a){u.call(this,a)}t(Gb,u);Gb.prototype.name="cancel";var $b=!y||9<=Number(kb);function ac(){this.a="";this.b=bc}ac.prototype.la=!0;ac.prototype.ja=function(){return this.a};ac.prototype.toString=function(){return"Const{"+this.a+"}"};function cc(a){if(a instanceof ac&&a.constructor===ac&&a.b===bc)return a.a;Aa("expected object of type Const, got '"+a+"'");return"type_error:Const"}var bc={};function dc(a){var b=new ac;b.a=a;return b}dc("");function ec(){this.a="";this.b=fc}ec.prototype.la=!0;ec.prototype.ja=function(){return this.a};ec.prototype.toString=function(){return"TrustedResourceUrl{"+this.a+"}"};function gc(a){if(a instanceof ec&&a.constructor===ec&&a.b===fc)return a.a;Aa("expected object of type TrustedResourceUrl, got '"+a+"' of type "+da(a));return"type_error:TrustedResourceUrl"}function hc(a,b){a=ic(a,b);b=new ec;b.a=a;return b}
	function ic(a,b){var c=cc(a);if(!jc.test(c))throw Error("Invalid TrustedResourceUrl format: "+c);return c.replace(kc,function(a,e){if(!Object.prototype.hasOwnProperty.call(b,e))throw Error('Found marker, "'+e+'", in format string, "'+c+'", but no valid label mapping found in args: '+JSON.stringify(b));a=b[e];return a instanceof ac?cc(a):encodeURIComponent(String(a))})}var kc=/%{(\w+)}/g,jc=/^(?:https:)?\/\/[0-9a-z.:[\]-]+\/|^\/[^\/\\]|^about:blank(#|$)/i,fc={};function lc(){this.a="";this.b=mc}lc.prototype.la=!0;lc.prototype.ja=function(){return this.a};lc.prototype.toString=function(){return"SafeUrl{"+this.a+"}"};function nc(a){if(a instanceof lc&&a.constructor===lc&&a.b===mc)return a.a;Aa("expected object of type SafeUrl, got '"+a+"' of type "+da(a));return"type_error:SafeUrl"}var oc=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
	function pc(a){if(a instanceof lc)return a;a=a.la?a.ja():String(a);oc.test(a)||(a="about:invalid#zClosurez");return qc(a)}var mc={};function qc(a){var b=new lc;b.a=a;return b}qc("about:blank");function rc(){this.a="";this.b=sc}rc.prototype.la=!0;rc.prototype.ja=function(){return this.a};rc.prototype.toString=function(){return"SafeHtml{"+this.a+"}"};function uc(a){if(a instanceof rc&&a.constructor===rc&&a.b===sc)return a.a;Aa("expected object of type SafeHtml, got '"+a+"' of type "+da(a));return"type_error:SafeHtml"}var sc={};function vc(a){var b=new rc;b.a=a;return b}vc("<!DOCTYPE html>");vc("");vc("<br>");function wc(a){var b=document;return m(a)?b.getElementById(a):a}function xc(a,b){Pa(b,function(b,d){b&&b.la&&(b=b.ja());"style"==d?a.style.cssText=b:"class"==d?a.className=b:"for"==d?a.htmlFor=b:yc.hasOwnProperty(d)?a.setAttribute(yc[d],b):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,b):a[d]=b})}
	var yc={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};
	function zc(a,b,c){var d=arguments,e=document,f=String(d[0]),g=d[1];if(!$b&&g&&(g.name||g.type)){f=["<",f];g.name&&f.push(' name="',qa(g.name),'"');if(g.type){f.push(' type="',qa(g.type),'"');var l={};Wa(l,g);delete l.type;g=l}f.push(">");f=f.join("")}f=e.createElement(f);g&&(m(g)?f.className=g:fa(g)?f.className=g.join(" "):xc(f,g));2<d.length&&Ac(e,f,d);return f}
	function Ac(a,b,c){function d(c){c&&b.appendChild(m(c)?a.createTextNode(c):c)}for(var e=2;e<c.length;e++){var f=c[e];!ha(f)||q(f)&&0<f.nodeType?d(f):w(Bc(f)?La(f):f,d)}}function Bc(a){if(a&&"number"==typeof a.length){if(q(a))return"function"==typeof a.item||"string"==typeof a.item;if(p(a))return"function"==typeof a.item}return!1};function Cc(a){var b=[];Dc(new Ec,a,b);return b.join("")}function Ec(){}
	function Dc(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(fa(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),Dc(a,d[f],c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");e="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(f=b[d],"function"!=typeof f&&(c.push(e),Fc(d,c),c.push(":"),Dc(a,f,c),e=","));c.push("}");return}}switch(typeof b){case "string":Fc(b,c);break;case "number":c.push(isFinite(b)&&
	!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}}var Gc={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},Hc=/\uffff/.test("\uffff")?/[\\\"\x00-\x1f\x7f-\uffff]/g:/[\\\"\x00-\x1f\x7f-\xff]/g;
	function Fc(a,b){b.push('"',a.replace(Hc,function(a){var b=Gc[a];b||(b="\\u"+(a.charCodeAt(0)|65536).toString(16).substr(1),Gc[a]=b);return b}),'"')};function Ic(){0!=Jc&&(Kc[this[ia]||(this[ia]=++ja)]=this);this.oa=this.oa;this.Fa=this.Fa}var Jc=0,Kc={};Ic.prototype.oa=!1;function Lc(a){a.oa||(a.oa=!0,a.ta(),0!=Jc&&(a=a[ia]||(a[ia]=++ja),delete Kc[a]))}Ic.prototype.ta=function(){if(this.Fa)for(;this.Fa.length;)this.Fa.shift()()};var Mc=Object.freeze||function(a){return a};var Nc=!y||9<=Number(kb),Oc=y&&!jb("9"),Pc=function(){if(!k.addEventListener||!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0}});k.addEventListener("test",ca,b);k.removeEventListener("test",ca,b);return a}();function C(a,b){this.type=a;this.b=this.target=b;this.Bb=!0}C.prototype.c=function(){this.Bb=!1};function Qc(a,b){C.call(this,a?a.type:"");this.relatedTarget=this.b=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=0;this.key="";this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.pointerId=0;this.pointerType="";this.a=null;if(a){var c=this.type=a.type,d=a.changedTouches?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.b=b;if(b=a.relatedTarget){if(cb){a:{try{Xa(b.nodeName);var e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==c?b=
	a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;null===d?(this.clientX=void 0!==a.clientX?a.clientX:a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0):(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0);this.button=a.button;this.key=a.key||"";this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=
	a.metaKey;this.pointerId=a.pointerId||0;this.pointerType=m(a.pointerType)?a.pointerType:Rc[a.pointerType]||"";this.a=a;a.defaultPrevented&&this.c()}}t(Qc,C);var Rc=Mc({2:"touch",3:"pen",4:"mouse"});Qc.prototype.c=function(){Qc.ib.c.call(this);var a=this.a;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,Oc)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};Qc.prototype.g=function(){return this.a};var Sc="closure_listenable_"+(1E6*Math.random()|0),Tc=0;function Uc(a,b,c,d,e){this.listener=a;this.a=null;this.src=b;this.type=c;this.capture=!!d;this.La=e;this.key=++Tc;this.ma=this.Ha=!1}function Vc(a){a.ma=!0;a.listener=null;a.a=null;a.src=null;a.La=null};function Wc(a){this.src=a;this.a={};this.b=0}function Xc(a,b,c,d,e,f){var g=b.toString();b=a.a[g];b||(b=a.a[g]=[],a.b++);var l=Yc(b,c,e,f);-1<l?(a=b[l],d||(a.Ha=!1)):(a=new Uc(c,a.src,g,!!e,f),a.Ha=d,b.push(a));return a}function Zc(a,b){var c=b.type;c in a.a&&Ia(a.a[c],b)&&(Vc(b),0==a.a[c].length&&(delete a.a[c],a.b--))}function Yc(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.ma&&f.listener==b&&f.capture==!!c&&f.La==d)return e}return-1};var $c="closure_lm_"+(1E6*Math.random()|0),ad={},bd=0;function cd(a,b,c,d,e){if(d&&d.once)dd(a,b,c,d,e);else if(fa(b))for(var f=0;f<b.length;f++)cd(a,b[f],c,d,e);else c=ed(c),a&&a[Sc]?fd(a,b,c,q(d)?!!d.capture:!!d,e):gd(a,b,c,!1,d,e)}
	function gd(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var g=q(e)?!!e.capture:!!e,l=hd(a);l||(a[$c]=l=new Wc(a));c=Xc(l,b,c,d,g,f);if(!c.a){d=id();c.a=d;d.src=a;d.listener=c;if(a.addEventListener)Pc||(e=g),void 0===e&&(e=!1),a.addEventListener(b.toString(),d,e);else if(a.attachEvent)a.attachEvent(jd(b.toString()),d);else throw Error("addEventListener and attachEvent are unavailable.");bd++}}
	function id(){var a=kd,b=Nc?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}function dd(a,b,c,d,e){if(fa(b))for(var f=0;f<b.length;f++)dd(a,b[f],c,d,e);else c=ed(c),a&&a[Sc]?ld(a,b,c,q(d)?!!d.capture:!!d,e):gd(a,b,c,!0,d,e)}
	function E(a,b,c,d,e){if(fa(b))for(var f=0;f<b.length;f++)E(a,b[f],c,d,e);else(d=q(d)?!!d.capture:!!d,c=ed(c),a&&a[Sc])?(a=a.u,b=String(b).toString(),b in a.a&&(f=a.a[b],c=Yc(f,c,d,e),-1<c&&(Vc(f[c]),Array.prototype.splice.call(f,c,1),0==f.length&&(delete a.a[b],a.b--)))):a&&(a=hd(a))&&(b=a.a[b.toString()],a=-1,b&&(a=Yc(b,c,d,e)),(c=-1<a?b[a]:null)&&md(c))}
	function md(a){if("number"!=typeof a&&a&&!a.ma){var b=a.src;if(b&&b[Sc])Zc(b.u,a);else{var c=a.type,d=a.a;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent&&b.detachEvent(jd(c),d);bd--;(c=hd(b))?(Zc(c,a),0==c.b&&(c.src=null,b[$c]=null)):Vc(a)}}}function jd(a){return a in ad?ad[a]:ad[a]="on"+a}function nd(a,b,c,d){var e=!0;if(a=hd(a))if(b=a.a[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.ma&&(f=od(f,d),e=e&&!1!==f)}return e}
	function od(a,b){var c=a.listener,d=a.La||a.src;a.Ha&&md(a);return c.call(d,b)}
	function kd(a,b){if(a.ma)return!0;if(!Nc){if(!b)a:{b=["window","event"];for(var c=k,d=0;d<b.length;d++)if(c=c[b[d]],null==c){b=null;break a}b=c}d=b;b=new Qc(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(g){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.b;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-1;0<=e;e--){b.b=d[e];var f=nd(d[e],a,!0,b);c=c&&f}for(e=0;e<d.length;e++)b.b=d[e],f=nd(d[e],a,!1,b),c=c&&f}return c}return od(a,
	new Qc(b,this))}function hd(a){a=a[$c];return a instanceof Wc?a:null}var pd="__closure_events_fn_"+(1E9*Math.random()>>>0);function ed(a){if(p(a))return a;a[pd]||(a[pd]=function(b){return a.handleEvent(b)});return a[pd]};function F(){Ic.call(this);this.u=new Wc(this);this.Ib=this;this.Ra=null}t(F,Ic);F.prototype[Sc]=!0;F.prototype.removeEventListener=function(a,b,c,d){E(this,a,b,c,d)};
	function G(a,b){var c,d=a.Ra;if(d)for(c=[];d;d=d.Ra)c.push(d);a=a.Ib;d=b.type||b;if(m(b))b=new C(b,a);else if(b instanceof C)b.target=b.target||a;else{var e=b;b=new C(d,a);Wa(b,e)}e=!0;if(c)for(var f=c.length-1;0<=f;f--){var g=b.b=c[f];e=qd(g,d,!0,b)&&e}g=b.b=a;e=qd(g,d,!0,b)&&e;e=qd(g,d,!1,b)&&e;if(c)for(f=0;f<c.length;f++)g=b.b=c[f],e=qd(g,d,!1,b)&&e}
	F.prototype.ta=function(){F.ib.ta.call(this);if(this.u){var a=this.u,b=0,c;for(c in a.a){for(var d=a.a[c],e=0;e<d.length;e++)++b,Vc(d[e]);delete a.a[c];a.b--}}this.Ra=null};function fd(a,b,c,d,e){Xc(a.u,String(b),c,!1,d,e)}function ld(a,b,c,d,e){Xc(a.u,String(b),c,!0,d,e)}function qd(a,b,c,d){b=a.u.a[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var g=b[f];if(g&&!g.ma&&g.capture==c){var l=g.listener,n=g.La||g.src;g.Ha&&Zc(a.u,g);e=!1!==l.call(n,d)&&e}}return e&&0!=d.Bb};function rd(a,b,c){if(p(a))c&&(a=r(a,c));else if(a&&"function"==typeof a.handleEvent)a=r(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:k.setTimeout(a,b||0)}function sd(a){var b=null;return(new z(function(c,d){b=rd(function(){c(void 0)},a);-1==b&&d(Error("Failed to schedule timer."))})).s(function(a){k.clearTimeout(b);throw a;})};function td(a,b,c,d,e){this.reset(a,b,c,d,e)}td.prototype.a=null;var ud=0;td.prototype.reset=function(a,b,c,d,e){"number"==typeof e||ud++;d||na();this.b=b;delete this.a};function vd(a){this.f=a;this.b=this.c=this.a=null}function wd(a,b){this.name=a;this.value=b}wd.prototype.toString=function(){return this.name};var xd=new wd("SEVERE",1E3),yd=new wd("CONFIG",700),zd=new wd("FINE",500);function Ad(a){if(a.c)return a.c;if(a.a)return Ad(a.a);Aa("Root logger has no level set.");return null}
	vd.prototype.log=function(a,b,c){if(a.value>=Ad(this).value)for(p(b)&&(b=b()),a=new td(a,String(b),this.f),c&&(a.a=c),c="log:"+a.b,(a=k.console)&&a.timeStamp&&a.timeStamp(c),(a=k.msWriteProfilerMark)&&a(c),c=this;c;)c=c.a};var Bd={},Cd=null;function Dd(a){Cd||(Cd=new vd(""),Bd[""]=Cd,Cd.c=yd);var b;if(!(b=Bd[a])){b=new vd(a);var c=a.lastIndexOf("."),d=a.substr(c+1);c=Dd(a.substr(0,c));c.b||(c.b={});c.b[d]=b;b.a=c;Bd[a]=b}return b};function Ed(a,b){this.b={};this.a=[];this.c=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else if(a){a instanceof Ed?(c=a.S(),d=a.P()):(c=Ra(a),d=Qa(a));for(var e=0;e<c.length;e++)this.set(c[e],d[e])}}h=Ed.prototype;h.P=function(){Fd(this);for(var a=[],b=0;b<this.a.length;b++)a.push(this.b[this.a[b]]);return a};h.S=function(){Fd(this);return this.a.concat()};
	h.clear=function(){this.b={};this.c=this.a.length=0};function Fd(a){if(a.c!=a.a.length){for(var b=0,c=0;b<a.a.length;){var d=a.a[b];Gd(a.b,d)&&(a.a[c++]=d);b++}a.a.length=c}if(a.c!=a.a.length){var e={};for(c=b=0;b<a.a.length;)d=a.a[b],Gd(e,d)||(a.a[c++]=d,e[d]=1),b++;a.a.length=c}}h.get=function(a,b){return Gd(this.b,a)?this.b[a]:b};h.set=function(a,b){Gd(this.b,a)||(this.c++,this.a.push(a));this.b[a]=b};
	h.forEach=function(a,b){for(var c=this.S(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};function Gd(a,b){return Object.prototype.hasOwnProperty.call(a,b)};function H(a,b){a&&a.log(zd,b,void 0)};function Hd(a){return Da(a,function(a){a=a.toString(16);return 1<a.length?a:"0"+a}).join("")};var Id=null,Jd=null;function Kd(a){var b="";Ld(a,function(a){b+=String.fromCharCode(a)});return b}function Ld(a,b){function c(b){for(;d<a.length;){var c=a.charAt(d++),e=Jd[c];if(null!=e)return e;if(!/^[\s\xa0]*$/.test(c))throw Error("Unknown base64 encoding at char: "+c);}return b}Md();for(var d=0;;){var e=c(-1),f=c(0),g=c(64),l=c(64);if(64===l&&-1===e)break;b(e<<2|f>>4);64!=g&&(b(f<<4&240|g>>2),64!=l&&b(g<<6&192|l))}}
	function Md(){if(!Id){Id={};Jd={};for(var a=0;65>a;a++)Id[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a),Jd[Id[a]]=a,62<=a&&(Jd["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a)]=a)}};/*
	 Portions of this code are from MochiKit, received by
	 The Closure Authors under the MIT license. All other code is Copyright
	 2005-2009 The Closure Authors. All Rights Reserved.
	*/
	function Nd(a,b){this.g=[];this.v=a;this.o=b||null;this.f=this.a=!1;this.c=void 0;this.u=this.w=this.i=!1;this.h=0;this.b=null;this.l=0}Nd.prototype.cancel=function(a){if(this.a)this.c instanceof Nd&&this.c.cancel();else{if(this.b){var b=this.b;delete this.b;a?b.cancel(a):(b.l--,0>=b.l&&b.cancel())}this.v?this.v.call(this.o,this):this.u=!0;this.a||(a=new Od,Pd(this),Qd(this,!1,a))}};Nd.prototype.m=function(a,b){this.i=!1;Qd(this,a,b)};function Qd(a,b,c){a.a=!0;a.c=c;a.f=!b;Rd(a)}
	function Pd(a){if(a.a){if(!a.u)throw new Sd;a.u=!1}}Nd.prototype.A=function(a){Pd(this);Qd(this,!0,a)};function Td(a,b){Ud(a,null,b,void 0)}function Ud(a,b,c,d){a.g.push([b,c,d]);a.a&&Rd(a)}Nd.prototype.then=function(a,b,c){var d,e,f=new z(function(a,b){d=a;e=b});Ud(this,d,function(a){a instanceof Od?f.cancel():e(a)});return f.then(a,b,c)};mb(Nd);function Vd(a){return Ea(a.g,function(a){return p(a[1])})}
	function Rd(a){if(a.h&&a.a&&Vd(a)){var b=a.h,c=Wd[b];c&&(k.clearTimeout(c.a),delete Wd[b]);a.h=0}a.b&&(a.b.l--,delete a.b);b=a.c;for(var d=c=!1;a.g.length&&!a.i;){var e=a.g.shift(),f=e[0],g=e[1];e=e[2];if(f=a.f?g:f)try{var l=f.call(e||a.o,b);void 0!==l&&(a.f=a.f&&(l==b||l instanceof Error),a.c=b=l);if(nb(b)||"function"===typeof k.Promise&&b instanceof k.Promise)d=!0,a.i=!0}catch(n){b=n,a.f=!0,Vd(a)||(c=!0)}}a.c=b;d&&(l=r(a.m,a,!0),d=r(a.m,a,!1),b instanceof Nd?(Ud(b,l,d),b.w=!0):b.then(l,d));c&&(b=
	new Xd(b),Wd[b.a]=b,a.h=b.a)}function Sd(){u.call(this)}t(Sd,u);Sd.prototype.message="Deferred has already fired";Sd.prototype.name="AlreadyCalledError";function Od(){u.call(this)}t(Od,u);Od.prototype.message="Deferred was canceled";Od.prototype.name="CanceledError";function Xd(a){this.a=k.setTimeout(r(this.c,this),0);this.b=a}Xd.prototype.c=function(){delete Wd[this.a];throw this.b;};var Wd={};function Yd(){this.b=-1};function Zd(a,b){this.b=-1;this.b=$d;this.f=k.Uint8Array?new Uint8Array(this.b):Array(this.b);this.g=this.c=0;this.a=[];this.i=a;this.h=b;this.l=k.Int32Array?new Int32Array(64):Array(64);ae||(k.Int32Array?ae=new Int32Array(be):ae=be);this.reset()}var ae;t(Zd,Yd);for(var $d=64,ce=$d-1,de=[],ee=0;ee<ce;ee++)de[ee]=0;var fe=Ka(128,de);Zd.prototype.reset=function(){this.g=this.c=0;this.a=k.Int32Array?new Int32Array(this.h):La(this.h)};
	function ge(a){for(var b=a.f,c=a.l,d=0,e=0;e<b.length;)c[d++]=b[e]<<24|b[e+1]<<16|b[e+2]<<8|b[e+3],e=4*d;for(b=16;64>b;b++){e=c[b-15]|0;d=c[b-2]|0;var f=(c[b-16]|0)+((e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3)|0,g=(c[b-7]|0)+((d>>>17|d<<15)^(d>>>19|d<<13)^d>>>10)|0;c[b]=f+g|0}d=a.a[0]|0;e=a.a[1]|0;var l=a.a[2]|0,n=a.a[3]|0,D=a.a[4]|0,vb=a.a[5]|0,tc=a.a[6]|0;f=a.a[7]|0;for(b=0;64>b;b++){var Bj=((d>>>2|d<<30)^(d>>>13|d<<19)^(d>>>22|d<<10))+(d&e^d&l^e&l)|0;g=D&vb^~D&tc;f=f+((D>>>6|D<<26)^(D>>>11|D<<21)^(D>>>
	25|D<<7))|0;g=g+(ae[b]|0)|0;g=f+(g+(c[b]|0)|0)|0;f=tc;tc=vb;vb=D;D=n+g|0;n=l;l=e;e=d;d=g+Bj|0}a.a[0]=a.a[0]+d|0;a.a[1]=a.a[1]+e|0;a.a[2]=a.a[2]+l|0;a.a[3]=a.a[3]+n|0;a.a[4]=a.a[4]+D|0;a.a[5]=a.a[5]+vb|0;a.a[6]=a.a[6]+tc|0;a.a[7]=a.a[7]+f|0}
	function he(a,b,c){void 0===c&&(c=b.length);var d=0,e=a.c;if(m(b))for(;d<c;)a.f[e++]=b.charCodeAt(d++),e==a.b&&(ge(a),e=0);else if(ha(b))for(;d<c;){var f=b[d++];if(!("number"==typeof f&&0<=f&&255>=f&&f==(f|0)))throw Error("message must be a byte array");a.f[e++]=f;e==a.b&&(ge(a),e=0)}else throw Error("message must be string or array");a.c=e;a.g+=c}
	var be=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,
	4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];function ie(){Zd.call(this,8,je)}t(ie,Zd);var je=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];function ke(a){if(a.P&&"function"==typeof a.P)return a.P();if(m(a))return a.split("");if(ha(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}return Qa(a)}function le(a){if(a.S&&"function"==typeof a.S)return a.S();if(!a.P||"function"!=typeof a.P){if(ha(a)||m(a)){var b=[];a=a.length;for(var c=0;c<a;c++)b.push(c);return b}return Ra(a)}}
	function me(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(ha(a)||m(a))w(a,b,void 0);else for(var c=le(a),d=ke(a),e=d.length,f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a)};var ne=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function oe(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1)}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"")}}};function pe(a,b){this.b=this.l=this.c="";this.i=null;this.h=this.g="";this.f=!1;if(a instanceof pe){this.f=void 0!==b?b:a.f;qe(this,a.c);this.l=a.l;this.b=a.b;re(this,a.i);this.g=a.g;b=a.a;var c=new se;c.c=b.c;b.a&&(c.a=new Ed(b.a),c.b=b.b);te(this,c);this.h=a.h}else a&&(c=String(a).match(ne))?(this.f=!!b,qe(this,c[1]||"",!0),this.l=ue(c[2]||""),this.b=ue(c[3]||"",!0),re(this,c[4]),this.g=ue(c[5]||"",!0),te(this,c[6]||"",!0),this.h=ue(c[7]||"")):(this.f=!!b,this.a=new se(null,0,this.f))}
	pe.prototype.toString=function(){var a=[],b=this.c;b&&a.push(ve(b,we,!0),":");var c=this.b;if(c||"file"==b)a.push("//"),(b=this.l)&&a.push(ve(b,we,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.i,null!=c&&a.push(":",String(c));if(c=this.g)this.b&&"/"!=c.charAt(0)&&a.push("/"),a.push(ve(c,"/"==c.charAt(0)?xe:ye,!0));(c=this.a.toString())&&a.push("?",c);(c=this.h)&&a.push("#",ve(c,ze));return a.join("")};
	function qe(a,b,c){a.c=c?ue(b,!0):b;a.c&&(a.c=a.c.replace(/:$/,""))}function re(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.i=b}else a.i=null}function te(a,b,c){b instanceof se?(a.a=b,Ae(a.a,a.f)):(c||(b=ve(b,Be)),a.a=new se(b,0,a.f))}function I(a,b,c){a.a.set(b,c)}function Ce(a,b){return a.a.get(b)}function De(a){return a instanceof pe?new pe(a):new pe(a,void 0)}function Ee(a,b){var c=new pe(null,void 0);qe(c,"https");a&&(c.b=a);b&&(c.g=b);return c}
	function ue(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}function ve(a,b,c){return m(a)?(a=encodeURI(a).replace(b,Fe),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function Fe(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)}var we=/[#\/\?@]/g,ye=/[\#\?:]/g,xe=/[\#\?]/g,Be=/[\#\?@]/g,ze=/#/g;function se(a,b,c){this.b=this.a=null;this.c=a||null;this.f=!!c}
	function Ge(a){a.a||(a.a=new Ed,a.b=0,a.c&&oe(a.c,function(b,c){He(a,decodeURIComponent(b.replace(/\+/g," ")),c)}))}function Ie(a){var b=le(a);if("undefined"==typeof b)throw Error("Keys are undefined");var c=new se(null,0,void 0);a=ke(a);for(var d=0;d<b.length;d++){var e=b[d],f=a[d];fa(f)?Je(c,e,f):He(c,e,f)}return c}function He(a,b,c){Ge(a);a.c=null;b=Ke(a,b);var d=a.a.get(b);d||a.a.set(b,d=[]);d.push(c);a.b+=1}
	function Le(a,b){Ge(a);b=Ke(a,b);Gd(a.a.b,b)&&(a.c=null,a.b-=a.a.get(b).length,a=a.a,Gd(a.b,b)&&(delete a.b[b],a.c--,a.a.length>2*a.c&&Fd(a)))}h=se.prototype;h.clear=function(){this.a=this.c=null;this.b=0};function Me(a,b){Ge(a);b=Ke(a,b);return Gd(a.a.b,b)}h.forEach=function(a,b){Ge(this);this.a.forEach(function(c,d){w(c,function(c){a.call(b,c,d,this)},this)},this)};h.S=function(){Ge(this);for(var a=this.a.P(),b=this.a.S(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};
	h.P=function(a){Ge(this);var b=[];if(m(a))Me(this,a)&&(b=Ka(b,this.a.get(Ke(this,a))));else{a=this.a.P();for(var c=0;c<a.length;c++)b=Ka(b,a[c])}return b};h.set=function(a,b){Ge(this);this.c=null;a=Ke(this,a);Me(this,a)&&(this.b-=this.a.get(a).length);this.a.set(a,[b]);this.b+=1;return this};h.get=function(a,b){a=a?this.P(a):[];return 0<a.length?String(a[0]):b};function Je(a,b,c){Le(a,b);0<c.length&&(a.c=null,a.a.set(Ke(a,b),La(c)),a.b+=c.length)}
	h.toString=function(){if(this.c)return this.c;if(!this.a)return"";for(var a=[],b=this.a.S(),c=0;c<b.length;c++){var d=b[c],e=encodeURIComponent(String(d));d=this.P(d);for(var f=0;f<d.length;f++){var g=e;""!==d[f]&&(g+="="+encodeURIComponent(String(d[f])));a.push(g)}}return this.c=a.join("&")};function Ke(a,b){b=String(b);a.f&&(b=b.toLowerCase());return b}function Ae(a,b){b&&!a.f&&(Ge(a),a.c=null,a.a.forEach(function(a,b){var c=b.toLowerCase();b!=c&&(Le(this,b),Je(this,c,a))},a));a.f=b};function Ne(){}Ne.prototype.c=null;function Oe(a){return a.c||(a.c=a.b())};var Pe;function Qe(){}t(Qe,Ne);Qe.prototype.a=function(){var a=Re(this);return a?new ActiveXObject(a):new XMLHttpRequest};Qe.prototype.b=function(){var a={};Re(this)&&(a[0]=!0,a[1]=!0);return a};
	function Re(a){if(!a.f&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.f=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.f}Pe=new Qe;function Se(a){F.call(this);this.headers=new Ed;this.w=a||null;this.b=!1;this.v=this.a=null;this.g=this.I=this.i="";this.c=this.G=this.h=this.A=!1;this.f=0;this.m=null;this.l=Te;this.o=this.N=!1}t(Se,F);var Te="",Ue=Se.prototype,Ve=Dd("goog.net.XhrIo");Ue.J=Ve;var We=/^https?$/i,Xe=["POST","PUT"];
	function Ye(a,b,c,d,e){if(a.a)throw Error("[goog.net.XhrIo] Object is active with another request="+a.i+"; newUri="+b);c=c?c.toUpperCase():"GET";a.i=b;a.g="";a.I=c;a.A=!1;a.b=!0;a.a=a.w?a.w.a():Pe.a();a.v=a.w?Oe(a.w):Oe(Pe);a.a.onreadystatechange=r(a.Ab,a);try{H(a.J,Ze(a,"Opening Xhr")),a.G=!0,a.a.open(c,String(b),!0),a.G=!1}catch(g){H(a.J,Ze(a,"Error opening Xhr: "+g.message));$e(a,g);return}b=d||"";var f=new Ed(a.headers);e&&me(e,function(a,b){f.set(b,a)});e=Fa(f.S());d=k.FormData&&b instanceof
	k.FormData;!Ha(Xe,c)||e||d||f.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");f.forEach(function(a,b){this.a.setRequestHeader(b,a)},a);a.l&&(a.a.responseType=a.l);"withCredentials"in a.a&&a.a.withCredentials!==a.N&&(a.a.withCredentials=a.N);try{af(a),0<a.f&&(a.o=bf(a.a),H(a.J,Ze(a,"Will abort after "+a.f+"ms if incomplete, xhr2 "+a.o)),a.o?(a.a.timeout=a.f,a.a.ontimeout=r(a.Ea,a)):a.m=rd(a.Ea,a.f,a)),H(a.J,Ze(a,"Sending request")),a.h=!0,a.a.send(b),a.h=!1}catch(g){H(a.J,Ze(a,
	"Send error: "+g.message)),$e(a,g)}}function bf(a){return y&&jb(9)&&"number"==typeof a.timeout&&void 0!==a.ontimeout}function Ga(a){return"content-type"==a.toLowerCase()}h=Se.prototype;h.Ea=function(){"undefined"!=typeof aa&&this.a&&(this.g="Timed out after "+this.f+"ms, aborting",H(this.J,Ze(this,this.g)),G(this,"timeout"),this.abort(8))};function $e(a,b){a.b=!1;a.a&&(a.c=!0,a.a.abort(),a.c=!1);a.g=b;cf(a);df(a)}function cf(a){a.A||(a.A=!0,G(a,"complete"),G(a,"error"))}
	h.abort=function(){this.a&&this.b&&(H(this.J,Ze(this,"Aborting")),this.b=!1,this.c=!0,this.a.abort(),this.c=!1,G(this,"complete"),G(this,"abort"),df(this))};h.ta=function(){this.a&&(this.b&&(this.b=!1,this.c=!0,this.a.abort(),this.c=!1),df(this,!0));Se.ib.ta.call(this)};h.Ab=function(){this.oa||(this.G||this.h||this.c?ef(this):this.jc())};h.jc=function(){ef(this)};
	function ef(a){if(a.b&&"undefined"!=typeof aa)if(a.v[1]&&4==ff(a)&&2==gf(a))H(a.J,Ze(a,"Local request error detected and ignored"));else if(a.h&&4==ff(a))rd(a.Ab,0,a);else if(G(a,"readystatechange"),4==ff(a)){H(a.J,Ze(a,"Request complete"));a.b=!1;try{var b=gf(a);a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var c=!0;break a;default:c=!1}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.i).match(ne)[1]||null;if(!f&&k.self&&k.self.location){var g=k.self.location.protocol;
	f=g.substr(0,g.length-1)}e=!We.test(f?f.toLowerCase():"")}d=e}if(d)G(a,"complete"),G(a,"success");else{try{var l=2<ff(a)?a.a.statusText:""}catch(n){H(a.J,"Can not get status: "+n.message),l=""}a.g=l+" ["+gf(a)+"]";cf(a)}}finally{df(a)}}}function df(a,b){if(a.a){af(a);var c=a.a,d=a.v[0]?ca:null;a.a=null;a.v=null;b||G(a,"ready");try{c.onreadystatechange=d}catch(e){(a=a.J)&&a.log(xd,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}}
	function af(a){a.a&&a.o&&(a.a.ontimeout=null);"number"==typeof a.m&&(k.clearTimeout(a.m),a.m=null)}function ff(a){return a.a?a.a.readyState:0}function gf(a){try{return 2<ff(a)?a.a.status:-1}catch(b){return-1}}function hf(a){try{return a.a?a.a.responseText:""}catch(b){return H(a.J,"Can not get responseText: "+b.message),""}}
	h.getResponse=function(){try{if(!this.a)return null;if("response"in this.a)return this.a.response;switch(this.l){case Te:case "text":return this.a.responseText;case "arraybuffer":if("mozResponseArrayBuffer"in this.a)return this.a.mozResponseArrayBuffer}var a=this.J;a&&a.log(xd,"Response type "+this.l+" is not supported on this browser",void 0);return null}catch(b){return H(this.J,"Can not get response: "+b.message),null}};function Ze(a,b){return b+" ["+a.I+" "+a.i+" "+gf(a)+"]"};var jf=/^[+a-zA-Z0-9_.!#$%&'*\/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/;function kf(a){var b={},c=b.document||document,d=gc(a),e=document.createElement("SCRIPT"),f={Cb:e,Ea:void 0},g=new Nd(lf,f),l=null,n=null!=b.timeout?b.timeout:5E3;0<n&&(l=window.setTimeout(function(){mf(e,!0);var a=new nf(of,"Timeout reached for loading script "+d);Pd(g);Qd(g,!1,a)},n),f.Ea=l);e.onload=e.onreadystatechange=function(){e.readyState&&"loaded"!=e.readyState&&"complete"!=e.readyState||(mf(e,b.Sc||!1,l),g.A(null))};e.onerror=function(){mf(e,!0,l);var a=new nf(pf,"Error while loading script "+
	d);Pd(g);Qd(g,!1,a)};f=b.attributes||{};Wa(f,{type:"text/javascript",charset:"UTF-8"});xc(e,f);e.src=gc(a);qf(c).appendChild(e);return g}function qf(a){var b;return(b=(a||document).getElementsByTagName("HEAD"))&&0!=b.length?b[0]:a.documentElement}function lf(){if(this&&this.Cb){var a=this.Cb;a&&"SCRIPT"==a.tagName&&mf(a,!0,this.Ea)}}
	function mf(a,b,c){null!=c&&k.clearTimeout(c);a.onload=ca;a.onerror=ca;a.onreadystatechange=ca;b&&window.setTimeout(function(){a&&a.parentNode&&a.parentNode.removeChild(a)},0)}var pf=0,of=1;function nf(a,b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);u.call(this,c);this.code=a}t(nf,u);function rf(){}t(rf,Ne);rf.prototype.a=function(){var a=new XMLHttpRequest;if("withCredentials"in a)return a;if("undefined"!=typeof XDomainRequest)return new sf;throw Error("Unsupported browser");};rf.prototype.b=function(){return{}};
	function sf(){this.a=new XDomainRequest;this.readyState=0;this.onreadystatechange=null;this.responseText="";this.status=-1;this.statusText=this.responseXML=null;this.a.onload=r(this.Wb,this);this.a.onerror=r(this.xb,this);this.a.onprogress=r(this.Xb,this);this.a.ontimeout=r(this.Yb,this)}h=sf.prototype;h.open=function(a,b,c){if(null!=c&&!c)throw Error("Only async requests are supported.");this.a.open(a,b)};
	h.send=function(a){if(a)if("string"==typeof a)this.a.send(a);else throw Error("Only string data is supported");else this.a.send()};h.abort=function(){this.a.abort()};h.setRequestHeader=function(){};h.getResponseHeader=function(a){return"content-type"==a.toLowerCase()?this.a.contentType:""};h.Wb=function(){this.status=200;this.responseText=this.a.responseText;tf(this,4)};h.xb=function(){this.status=500;this.responseText="";tf(this,4)};h.Yb=function(){this.xb()};
	h.Xb=function(){this.status=200;tf(this,1)};function tf(a,b){a.readyState=b;if(a.onreadystatechange)a.onreadystatechange()}h.getAllResponseHeaders=function(){return"content-type: "+this.a.contentType};function uf(){var a=J();return y&&!!kb&&11==kb||/Edge\/\d+/.test(a)}function vf(){return k.window&&k.window.location.href||""}function wf(a,b){b=b||k.window;var c="about:blank";a&&(c=nc(pc(a)));b.location.href=c}function xf(a,b){var c=[],d;for(d in a)d in b?typeof a[d]!=typeof b[d]?c.push(d):fa(a[d])?Ta(a[d],b[d])||c.push(d):"object"==typeof a[d]&&null!=a[d]&&null!=b[d]?0<xf(a[d],b[d]).length&&c.push(d):a[d]!==b[d]&&c.push(d):c.push(d);for(d in b)d in a||c.push(d);return c}
	function yf(){var a=J();a=zf(a)!=Af?null:(a=a.match(/\sChrome\/(\d+)/i))&&2==a.length?parseInt(a[1],10):null;return a&&30>a?!1:!y||!kb||9<kb}function Bf(a){a=(a||J()).toLowerCase();return a.match(/android/)||a.match(/webos/)||a.match(/iphone|ipad|ipod/)||a.match(/blackberry/)||a.match(/windows phone/)||a.match(/iemobile/)?!0:!1}function Cf(a){a=a||k.window;try{a.close()}catch(b){}}
	function Df(a,b,c){var d=Math.floor(1E9*Math.random()).toString();b=b||500;c=c||600;var e=(window.screen.availHeight-c)/2,f=(window.screen.availWidth-b)/2;b={width:b,height:c,top:0<e?e:0,left:0<f?f:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1};c=J().toLowerCase();d&&(b.target=d,v(c,"crios/")&&(b.target="_blank"));zf(J())==Ef&&(a=a||"http://localhost",b.scrollbars=!0);c=a||"";(d=b)||(d={});a=window;b=c instanceof lc?c:pc("undefined"!=typeof c.href?c.href:String(c));c=d.target||c.target;e=[];
	for(g in d)switch(g){case "width":case "height":case "top":case "left":e.push(g+"="+d[g]);break;case "target":case "noreferrer":break;default:e.push(g+"="+(d[g]?1:0))}var g=e.join(",");(x("iPhone")&&!x("iPod")&&!x("iPad")||x("iPad")||x("iPod"))&&a.navigator&&a.navigator.standalone&&c&&"_self"!=c?(g=a.document.createElement("A"),b instanceof lc||b instanceof lc||(b=b.la?b.ja():String(b),oc.test(b)||(b="about:invalid#zClosurez"),b=qc(b)),g.href=nc(b),g.setAttribute("target",c),d.noreferrer&&g.setAttribute("rel",
	"noreferrer"),d=document.createEvent("MouseEvent"),d.initMouseEvent("click",!0,!0,a,1),g.dispatchEvent(d),g={}):d.noreferrer?(g=a.open("",c,g),a=nc(b),g&&(bb&&v(a,";")&&(a="'"+a.replace(/'/g,"%27")+"'"),g.opener=null,dc("b/12014412, meta tag with sanitized URL"),a='<META HTTP-EQUIV="refresh" content="0; url='+qa(a)+'">',a=vc(a),g.document.write(uc(a)),g.document.close())):g=a.open(nc(b),c,g);if(g)try{g.focus()}catch(l){}return g}
	function Ff(a){return new z(function(b){function c(){sd(2E3).then(function(){if(!a||a.closed)b();else return c()})}return c()})}var Gf=/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;function Hf(){var a=null;return(new z(function(b){"complete"==k.document.readyState?b():(a=function(){b()},dd(window,"load",a))})).s(function(b){E(window,"load",a);throw b;})}
	function If(){return Jf(void 0)?Hf().then(function(){return new z(function(a,b){var c=k.document,d=setTimeout(function(){b(Error("Cordova framework is not ready."))},1E3);c.addEventListener("deviceready",function(){clearTimeout(d);a()},!1)})}):B(Error("Cordova must run in an Android or iOS file scheme."))}function Jf(a){a=a||J();return!("file:"!==Kf()||!a.toLowerCase().match(/iphone|ipad|ipod|android/))}function Lf(){var a=k.window;try{return!(!a||a==a.top)}catch(b){return!1}}
	function K(){return firebase.INTERNAL.hasOwnProperty("reactNative")?"ReactNative":firebase.INTERNAL.hasOwnProperty("node")?"Node":"Browser"}function Mf(){var a=K();return"ReactNative"===a||"Node"===a}var Ef="Firefox",Af="Chrome";
	function zf(a){var b=a.toLowerCase();if(v(b,"opera/")||v(b,"opr/")||v(b,"opios/"))return"Opera";if(v(b,"iemobile"))return"IEMobile";if(v(b,"msie")||v(b,"trident/"))return"IE";if(v(b,"edge/"))return"Edge";if(v(b,"firefox/"))return Ef;if(v(b,"silk/"))return"Silk";if(v(b,"blackberry"))return"Blackberry";if(v(b,"webos"))return"Webos";if(!v(b,"safari/")||v(b,"chrome/")||v(b,"crios/")||v(b,"android"))if(!v(b,"chrome/")&&!v(b,"crios/")||v(b,"edge/")){if(v(b,"android"))return"Android";if((a=a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/))&&
	2==a.length)return a[1]}else return Af;else return"Safari";return"Other"}var Nf={Gc:"FirebaseCore-web",Ic:"FirebaseUI-web"};function Of(a,b){b=b||[];var c=[],d={},e;for(e in Nf)d[Nf[e]]=!0;for(e=0;e<b.length;e++)"undefined"!==typeof d[b[e]]&&(delete d[b[e]],c.push(b[e]));c.sort();b=c;b.length||(b=["FirebaseCore-web"]);c=K();d="";"Browser"===c?d=zf(J()):d=c;return d+"/JsCore/"+a+"/"+b.join(",")}function J(){return k.navigator&&k.navigator.userAgent||""}
	function L(a,b){a=a.split(".");b=b||k;for(var c=0;c<a.length&&"object"==typeof b&&null!=b;c++)b=b[a[c]];c!=a.length&&(b=void 0);return b}function Pf(){try{var a=k.localStorage,b=Qf();if(a)return a.setItem(b,"1"),a.removeItem(b),uf()?!!k.indexedDB:!0}catch(c){}return!1}function Rf(){return(Sf()||"chrome-extension:"===Kf()||Jf())&&!Mf()&&Pf()}function Sf(){return"http:"===Kf()||"https:"===Kf()}function Kf(){return k.location&&k.location.protocol||null}
	function Tf(a){a=a||J();return Bf(a)||zf(a)==Ef?!1:!0}function Uf(a){return"undefined"===typeof a?null:Cc(a)}function Vf(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&null!==a[c]&&void 0!==a[c]&&(b[c]=a[c]);return b}function Wf(a){if(null!==a)return JSON.parse(a)}function Qf(a){return a?a:""+Math.floor(1E9*Math.random()).toString()}function Xf(a){a=a||J();return"Safari"==zf(a)||a.toLowerCase().match(/iphone|ipad|ipod/)?!1:!0}
	function Yf(){var a=k.___jsl;if(a&&a.H)for(var b in a.H)if(a.H[b].r=a.H[b].r||[],a.H[b].L=a.H[b].L||[],a.H[b].r=a.H[b].L.concat(),a.CP)for(var c=0;c<a.CP.length;c++)a.CP[c]=null}function Zf(){var a=k.navigator;return a&&"boolean"===typeof a.onLine&&(Sf()||"chrome-extension:"===Kf()||"undefined"!==typeof a.connection)?a.onLine:!0}function $f(a,b,c,d){if(a>b)throw Error("Short delay should be less than long delay!");this.c=a;this.b=b;a=c||J();d=d||K();this.a=Bf(a)||"ReactNative"===d}
	$f.prototype.get=function(){return this.a?this.b:this.c};function ag(){var a=k.document;return a&&"undefined"!==typeof a.visibilityState?"visible"==a.visibilityState:!0}function bg(){var a=k.document,b=null;return ag()||!a?A():(new z(function(c){b=function(){ag()&&(a.removeEventListener("visibilitychange",b,!1),c())};a.addEventListener("visibilitychange",b,!1)})).s(function(c){a.removeEventListener("visibilitychange",b,!1);throw c;})}
	function cg(a){try{var b=new Date(parseInt(a,10));if(!isNaN(b.getTime())&&!/[^0-9]/.test(a))return b.toUTCString()}catch(c){}return null};var dg={};var eg;try{var fg={};Object.defineProperty(fg,"abcd",{configurable:!0,enumerable:!0,value:1});Object.defineProperty(fg,"abcd",{configurable:!0,enumerable:!0,value:2});eg=2==fg.abcd}catch(a){eg=!1}function M(a,b,c){eg?Object.defineProperty(a,b,{configurable:!0,enumerable:!0,value:c}):a[b]=c}function gg(a,b){if(b)for(var c in b)b.hasOwnProperty(c)&&M(a,c,b[c])}function hg(a){var b={};gg(b,a);return b}function ig(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&(b[c]=a[c]);return b}
	function jg(a,b){if(!b||!b.length)return!0;if(!a)return!1;for(var c=0;c<b.length;c++){var d=a[b[c]];if(void 0===d||null===d||""===d)return!1}return!0}function kg(a){var b=a;if("object"==typeof a&&null!=a){b="length"in a?[]:{};for(var c in a)M(b,c,kg(a[c]))}return b};function lg(a){var b={},c=a[mg],d=a[ng];a=a[og];if(!c||!a)throw Error("Invalid provider user info!");b[pg]=d||null;b[qg]=c;M(this,rg,a);M(this,sg,kg(b))}var mg="email",ng="newEmail",og="requestType",qg="email",pg="fromEmail",sg="data",rg="operation";function N(a,b){this.code=tg+a;this.message=b||ug[a]||""}t(N,Error);N.prototype.B=function(){return{code:this.code,message:this.message}};N.prototype.toJSON=function(){return this.B()};function vg(a){var b=a&&a.code;return b?new N(b.substring(tg.length),a.message):null}
	var tg="auth/",ug={"argument-error":"","app-not-authorized":"This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.","app-not-installed":"The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.","captcha-check-failed":"The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
	"code-expired":"The SMS code has expired. Please re-send the verification code to try again.","cordova-not-ready":"Cordova framework is not ready.","cors-unsupported":"This browser is not supported.","credential-already-in-use":"This credential is already associated with a different user account.","custom-token-mismatch":"The custom token corresponds to a different audience.","requires-recent-login":"This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
	"dynamic-link-not-activated":"Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.","email-already-in-use":"The email address is already in use by another account.","expired-action-code":"The action code has expired. ","cancelled-popup-request":"This operation has been cancelled due to another conflicting popup being opened.","internal-error":"An internal error has occurred.","invalid-app-credential":"The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
	"invalid-app-id":"The mobile app identifier is not registed for the current project.","invalid-user-token":"The user's credential is no longer valid. The user must sign in again.","invalid-auth-event":"An internal error has occurred.","invalid-verification-code":"The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.","invalid-continue-uri":"The continue URL provided in the request is invalid.",
	"invalid-cordova-configuration":"The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.","invalid-custom-token":"The custom token format is incorrect. Please check the documentation.","invalid-email":"The email address is badly formatted.","invalid-api-key":"Your API key is invalid, please check you have copied it correctly.","invalid-cert-hash":"The SHA-1 certificate hash provided is invalid.",
	"invalid-credential":"The supplied auth credential is malformed or has expired.","invalid-persistence-type":"The specified persistence type is invalid. It can only be local, session or none.","invalid-message-payload":"The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-oauth-provider":"EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
	"invalid-oauth-client-id":"The OAuth client ID provided is either invalid or does not match the specified API key.","unauthorized-domain":"This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.","invalid-action-code":"The action code is invalid. This can happen if the code is malformed, expired, or has already been used.","wrong-password":"The password is invalid or the user does not have a password.","invalid-phone-number":"The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
	"invalid-recipient-email":"The email corresponding to this action failed to send as the provided recipient email address is invalid.","invalid-sender":"The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-verification-id":"The verification ID used to create the phone auth credential is invalid.","missing-android-pkg-name":"An Android Package Name must be provided if the Android App is required to be installed.",
	"auth-domain-config-required":"Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.","missing-app-credential":"The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.","missing-verification-code":"The phone auth credential was created with an empty SMS verification code.","missing-continue-uri":"A continue URL must be provided in the request.","missing-iframe-start":"An internal error has occurred.",
	"missing-ios-bundle-id":"An iOS Bundle ID must be provided if an App Store ID is provided.","missing-phone-number":"To send verification codes, provide a phone number for the recipient.","missing-verification-id":"The phone auth credential was created with an empty verification ID.","app-deleted":"This instance of FirebaseApp has been deleted.","account-exists-with-different-credential":"An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
	"network-request-failed":"A network error (such as timeout, interrupted connection or unreachable host) has occurred.","no-auth-event":"An internal error has occurred.","no-such-provider":"User was not linked to an account with the given provider.","operation-not-allowed":"The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.","operation-not-supported-in-this-environment":'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
	"popup-blocked":"Unable to establish a connection with the popup. It may have been blocked by the browser.","popup-closed-by-user":"The popup has been closed by the user before finalizing the operation.","provider-already-linked":"User can only be linked to one identity for the given provider.","quota-exceeded":"The project's quota for this operation has been exceeded.","redirect-cancelled-by-user":"The redirect operation has been cancelled by the user before finalizing.","redirect-operation-pending":"A redirect sign-in operation is already pending.",
	timeout:"The operation has timed out.","user-token-expired":"The user's credential is no longer valid. The user must sign in again.","too-many-requests":"We have blocked all requests from this device due to unusual activity. Try again later.","unauthorized-continue-uri":"The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.","unsupported-persistence-type":"The current environment does not support the specified persistence type.","user-cancelled":"User did not grant your application the permissions it requested.",
	"user-not-found":"There is no user record corresponding to this identifier. The user may have been deleted.","user-disabled":"The user account has been disabled by an administrator.","user-mismatch":"The supplied credentials do not correspond to the previously signed in user.","user-signed-out":"","weak-password":"The password must be 6 characters long or more.","web-storage-unsupported":"This browser is not supported or 3rd party cookies and data may be disabled."};function wg(a){var b=a[xg];if("undefined"===typeof b)throw new N("missing-continue-uri");if("string"!==typeof b||"string"===typeof b&&!b.length)throw new N("invalid-continue-uri");this.h=b;this.c=this.a=null;this.g=!1;var c=a[yg];if(c&&"object"===typeof c){b=c[zg];var d=c[Ag];c=c[Bg];if("string"===typeof b&&b.length){this.a=b;if("undefined"!==typeof d&&"boolean"!==typeof d)throw new N("argument-error",Ag+" property must be a boolean when specified.");this.g=!!d;if("undefined"!==typeof c&&("string"!==
	typeof c||"string"===typeof c&&!c.length))throw new N("argument-error",Bg+" property must be a non empty string when specified.");this.c=c||null}else{if("undefined"!==typeof b)throw new N("argument-error",zg+" property must be a non empty string when specified.");if("undefined"!==typeof d||"undefined"!==typeof c)throw new N("missing-android-pkg-name");}}else if("undefined"!==typeof c)throw new N("argument-error",yg+" property must be a non null object when specified.");this.b=null;if((b=a[Cg])&&"object"===
	typeof b)if(b=b[Dg],"string"===typeof b&&b.length)this.b=b;else{if("undefined"!==typeof b)throw new N("argument-error",Dg+" property must be a non empty string when specified.");}else if("undefined"!==typeof b)throw new N("argument-error",Cg+" property must be a non null object when specified.");a=a[Eg];if("undefined"!==typeof a&&"boolean"!==typeof a)throw new N("argument-error",Eg+" property must be a boolean when specified.");if((this.f=!!a)&&!this.b&&!this.a)throw new N("argument-error",Eg+" property can't be true when no mobile application is provided.");
	}var yg="android",Eg="handleCodeInApp",Cg="iOS",xg="url",Ag="installApp",Bg="minimumVersion",zg="packageName",Dg="bundleId";function Fg(a){var b={};b.continueUrl=a.h;b.canHandleCodeInApp=a.f;if(b.androidPackageName=a.a)b.androidMinimumVersion=a.c,b.androidInstallApp=a.g;b.iOSBundleId=a.b;for(var c in b)null===b[c]&&delete b[c];return b};function Gg(a){this.b=a.sub;na();this.a=a.provider_id||a.firebase&&a.firebase.sign_in_provider||null}function Hg(a){a=a.split(".");if(3!=a.length)return null;a=a[1];for(var b=(4-a.length%4)%4,c=0;c<b;c++)a+=".";try{var d=JSON.parse(Kd(a));if(d.sub&&d.iss&&d.aud&&d.exp)return new Gg(d)}catch(e){}return null};var Ig="oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "),Jg=["client_id","response_type","scope","redirect_uri","state"],Kg={Hc:{Ma:"locale",za:500,ya:600,Na:"facebook.com",$a:Jg},Jc:{Ma:null,za:500,ya:620,Na:"github.com",$a:Jg},Kc:{Ma:"hl",za:515,ya:680,Na:"google.com",$a:Jg},Qc:{Ma:"lang",za:485,ya:705,Na:"twitter.com",$a:Ig}};function Lg(a){for(var b in Kg)if(Kg[b].Na==a)return Kg[b];return null};function Mg(a){var b={};b["facebook.com"]=Ng;b["google.com"]=Og;b["github.com"]=Pg;b["twitter.com"]=Qg;var c=a&&a[Rg];try{if(c)return b[c]?new b[c](a):new Sg(a);if("undefined"!==typeof a[Tg])return new Ug(a)}catch(d){}return null}var Tg="idToken",Rg="providerId";
	function Ug(a){var b=a[Rg];if(!b&&a[Tg]){var c=Hg(a[Tg]);c&&c.a&&(b=c.a)}if(!b)throw Error("Invalid additional user info!");if("anonymous"==b||"custom"==b)b=null;c=!1;"undefined"!==typeof a.isNewUser?c=!!a.isNewUser:"identitytoolkit#SignupNewUserResponse"===a.kind&&(c=!0);M(this,"providerId",b);M(this,"isNewUser",c)}function Sg(a){Ug.call(this,a);a=Wf(a.rawUserInfo||"{}");M(this,"profile",kg(a||{}))}t(Sg,Ug);
	function Ng(a){Sg.call(this,a);if("facebook.com"!=this.providerId)throw Error("Invalid provider ID!");}t(Ng,Sg);function Pg(a){Sg.call(this,a);if("github.com"!=this.providerId)throw Error("Invalid provider ID!");M(this,"username",this.profile&&this.profile.login||null)}t(Pg,Sg);function Og(a){Sg.call(this,a);if("google.com"!=this.providerId)throw Error("Invalid provider ID!");}t(Og,Sg);
	function Qg(a){Sg.call(this,a);if("twitter.com"!=this.providerId)throw Error("Invalid provider ID!");M(this,"username",a.screenName||null)}t(Qg,Sg);function Vg(a,b){return a.then(function(a){if(a[O]){var c=Hg(a[O]);if(!c||b!=c.b)throw new N("user-mismatch");return a}throw new N("user-mismatch");}).s(function(a){throw a&&a.code&&a.code==tg+"user-not-found"?new N("user-mismatch"):a;})}
	function Wg(a,b){if(b.idToken||b.accessToken)b.idToken&&M(this,"idToken",b.idToken),b.accessToken&&M(this,"accessToken",b.accessToken);else if(b.oauthToken&&b.oauthTokenSecret)M(this,"accessToken",b.oauthToken),M(this,"secret",b.oauthTokenSecret);else throw new N("internal-error","failed to construct a credential");M(this,"providerId",a)}Wg.prototype.wa=function(a){return Xg(a,Yg(this))};Wg.prototype.b=function(a,b){var c=Yg(this);c.idToken=b;return Zg(a,c)};
	Wg.prototype.c=function(a,b){var c=Yg(this);return Vg($g(a,c),b)};function Yg(a){var b={};a.idToken&&(b.id_token=a.idToken);a.accessToken&&(b.access_token=a.accessToken);a.secret&&(b.oauth_token_secret=a.secret);b.providerId=a.providerId;return{postBody:Ie(b).toString(),requestUri:"http://localhost"}}
	Wg.prototype.B=function(){var a={providerId:this.providerId};this.idToken&&(a.oauthIdToken=this.idToken);this.accessToken&&(a.oauthAccessToken=this.accessToken);this.secret&&(a.oauthTokenSecret=this.secret);return a};function ah(a,b){this.rc=b||[];gg(this,{providerId:a,isOAuthProvider:!0});this.rb={};this.Wa=(Lg(a)||{}).Ma||null;this.Ua=null}ah.prototype.Ba=function(a){this.rb=Ua(a);return this};function P(a){ah.call(this,a,Jg);this.a=[]}t(P,ah);
	P.prototype.sa=function(a){Ha(this.a,a)||this.a.push(a);return this};P.prototype.wb=function(){return La(this.a)};P.prototype.credential=function(a,b){if(!a&&!b)throw new N("argument-error","credential failed: must provide the ID token and/or the access token.");return new Wg(this.providerId,{idToken:a||null,accessToken:b||null})};function bh(){P.call(this,"facebook.com")}t(bh,P);M(bh,"PROVIDER_ID","facebook.com");
	function ch(a){if(!a)throw new N("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;q(a)&&(b=a.accessToken);return(new bh).credential(null,b)}function dh(){P.call(this,"github.com")}t(dh,P);M(dh,"PROVIDER_ID","github.com");function eh(a){if(!a)throw new N("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;q(a)&&(b=a.accessToken);return(new dh).credential(null,b)}
	function fh(){P.call(this,"google.com");this.sa("profile")}t(fh,P);M(fh,"PROVIDER_ID","google.com");function gh(a,b){var c=a;q(a)&&(c=a.idToken,b=a.accessToken);return(new fh).credential(c,b)}function hh(){ah.call(this,"twitter.com",Ig)}t(hh,ah);M(hh,"PROVIDER_ID","twitter.com");
	function ih(a,b){var c=a;q(c)||(c={oauthToken:a,oauthTokenSecret:b});if(!c.oauthToken||!c.oauthTokenSecret)throw new N("argument-error","credential failed: expected 2 arguments (the OAuth access token and secret).");return new Wg("twitter.com",c)}function jh(a,b){this.a=a;this.f=b;M(this,"providerId","password")}jh.prototype.wa=function(a){return Q(a,kh,{email:this.a,password:this.f})};jh.prototype.b=function(a,b){return Q(a,lh,{idToken:b,email:this.a,password:this.f})};
	jh.prototype.c=function(a,b){return Vg(this.wa(a),b)};jh.prototype.B=function(){return{email:this.a,password:this.f}};function mh(){gg(this,{providerId:"password",isOAuthProvider:!1})}gg(mh,{PROVIDER_ID:"password"});function nh(a){if(!(a.Pa&&a.Oa||a.Da&&a.Y))throw new N("internal-error");this.a=a;M(this,"providerId","phone")}nh.prototype.wa=function(a){return a.Qa(oh(this))};nh.prototype.b=function(a,b){var c=oh(this);c.idToken=b;return Q(a,ph,c)};
	nh.prototype.c=function(a,b){var c=oh(this);c.operation="REAUTH";a=Q(a,qh,c);return Vg(a,b)};nh.prototype.B=function(){var a={providerId:"phone"};this.a.Pa&&(a.verificationId=this.a.Pa);this.a.Oa&&(a.verificationCode=this.a.Oa);this.a.Da&&(a.temporaryProof=this.a.Da);this.a.Y&&(a.phoneNumber=this.a.Y);return a};function oh(a){return a.a.Da&&a.a.Y?{temporaryProof:a.a.Da,phoneNumber:a.a.Y}:{sessionInfo:a.a.Pa,code:a.a.Oa}}
	function rh(a){try{this.a=a||firebase.auth()}catch(b){throw new N("argument-error","Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.PhoneAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");}gg(this,{providerId:"phone",isOAuthProvider:!1})}
	rh.prototype.Qa=function(a,b){var c=this.a.c;return A(b.verify()).then(function(d){if(!m(d))throw new N("argument-error","An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");switch(b.type){case "recaptcha":return sh(c,{phoneNumber:a,recaptchaToken:d}).then(function(a){"function"===typeof b.reset&&b.reset();return a},function(a){"function"===typeof b.reset&&b.reset();throw a;});default:throw new N("argument-error",
	'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');}})};function th(a,b){if(!a)throw new N("missing-verification-id");if(!b)throw new N("missing-verification-code");return new nh({Pa:a,Oa:b})}gg(rh,{PROVIDER_ID:"phone"});
	function uh(a){if(a.temporaryProof&&a.phoneNumber)return new nh({Da:a.temporaryProof,Y:a.phoneNumber});var b=a&&a.providerId;if(!b||"password"===b)return null;var c=a&&a.oauthAccessToken,d=a&&a.oauthTokenSecret;a=a&&a.oauthIdToken;try{switch(b){case "google.com":return gh(a,c);case "facebook.com":return ch(c);case "github.com":return eh(c);case "twitter.com":return ih(c,d);default:return(new P(b)).credential(a,c)}}catch(e){return null}}
	function vh(a){if(!a.isOAuthProvider)throw new N("invalid-oauth-provider");};function wh(a,b,c,d,e){this.b=a;this.c=b||null;this.f=c||null;this.g=d||null;this.a=e||null;if(this.f||this.a){if(this.f&&this.a)throw new N("invalid-auth-event");if(this.f&&!this.g)throw new N("invalid-auth-event");}else throw new N("invalid-auth-event");}wh.prototype.B=function(){return{type:this.b,eventId:this.c,urlResponse:this.f,sessionId:this.g,error:this.a&&this.a.B()}};function xh(a){a=a||{};return a.type?new wh(a.type,a.eventId,a.urlResponse,a.sessionId,a.error&&vg(a.error)):null};function yh(a){var b="unauthorized-domain",c=void 0,d=De(a);a=d.b;d=d.c;"chrome-extension"==d?c=oa("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):"http"==d||"https"==d?c=oa("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):b="operation-not-supported-in-this-environment";
	N.call(this,b,c)}t(yh,N);function zh(a,b,c){N.call(this,a,c);a=b||{};a.sb&&M(this,"email",a.sb);a.Y&&M(this,"phoneNumber",a.Y);a.credential&&M(this,"credential",a.credential)}t(zh,N);zh.prototype.B=function(){var a={code:this.code,message:this.message};this.email&&(a.email=this.email);this.phoneNumber&&(a.phoneNumber=this.phoneNumber);var b=this.credential&&this.credential.B();b&&Wa(a,b);return a};zh.prototype.toJSON=function(){return this.B()};
	function Ah(a){if(a.code){var b=a.code||"";0==b.indexOf(tg)&&(b=b.substring(tg.length));var c={credential:uh(a)};if(a.email)c.sb=a.email;else if(a.phoneNumber)c.Y=a.phoneNumber;else return new N(b,a.message||void 0);return new zh(b,c,a.message)}return null};function Bh(a){this.f=a}t(Bh,Ne);Bh.prototype.a=function(){return new this.f};Bh.prototype.b=function(){return{}};
	function Ch(a,b,c){var d="Node"==K();d=k.XMLHttpRequest||d&&firebase.INTERNAL.node&&firebase.INTERNAL.node.XMLHttpRequest;if(!d)throw new N("internal-error","The XMLHttpRequest compatibility library was not found.");this.b=a;a=b||{};this.i=a.secureTokenEndpoint||"https://securetoken.googleapis.com/v1/token";this.l=a.secureTokenTimeout||Dh;this.c=Ua(a.secureTokenHeaders||Eh);this.g=a.firebaseEndpoint||"https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.h=a.firebaseTimeout||Fh;this.a=
	Ua(a.firebaseHeaders||Gh);c&&(this.a["X-Client-Version"]=c,this.c["X-Client-Version"]=c);this.f=new rf;this.o=new Bh(d)}var Hh,O="idToken",Dh=new $f(3E4,6E4),Eh={"Content-Type":"application/x-www-form-urlencoded"},Fh=new $f(3E4,6E4),Gh={"Content-Type":"application/json"};function Ih(a,b){b?a.a["X-Firebase-Locale"]=b:delete a.a["X-Firebase-Locale"]}function Jh(a,b){b?(a.a["X-Client-Version"]=b,a.c["X-Client-Version"]=b):(delete a.a["X-Client-Version"],delete a.c["X-Client-Version"])}
	function Kh(a,b,c,d,e,f,g){Zf()?(yf()?a=r(a.m,a):(Hh||(Hh=new z(function(a,b){Lh(a,b)})),a=r(a.u,a)),a(b,c,d,e,f,g)):c&&c(null)}
	Ch.prototype.m=function(a,b,c,d,e,f){var g="Node"==K(),l=Mf()?g?new Se(this.o):new Se:new Se(this.f);if(f){l.f=Math.max(0,f);var n=setTimeout(function(){G(l,"timeout")},f)}fd(l,"complete",function(){n&&clearTimeout(n);var a=null;try{a=JSON.parse(hf(this))||null}catch(vb){a=null}b&&b(a)});ld(l,"ready",function(){n&&clearTimeout(n);Lc(this)});ld(l,"timeout",function(){n&&clearTimeout(n);Lc(this);b&&b(null)});Ye(l,a,c,d,e)};
	var Mh=dc("https://apis.google.com/js/client.js?onload=%{onload}"),Nh="__fcb"+Math.floor(1E6*Math.random()).toString();function Lh(a,b){if(((window.gapi||{}).client||{}).request)a();else{k[Nh]=function(){((window.gapi||{}).client||{}).request?a():b(Error("CORS_UNSUPPORTED"))};var c=hc(Mh,{onload:Nh});Td(kf(c),function(){b(Error("CORS_UNSUPPORTED"))})}}
	Ch.prototype.u=function(a,b,c,d,e){var f=this;Hh.then(function(){window.gapi.client.setApiKey(f.b);var g=window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({path:a,method:c,body:d,headers:e,authType:"none",callback:function(a){window.gapi.auth.setToken(g);b&&b(a)}})}).s(function(a){b&&b({error:{message:a&&a.message||"CORS_UNSUPPORTED"}})})};
	function Oh(a,b){return new z(function(c,d){"refresh_token"==b.grant_type&&b.refresh_token||"authorization_code"==b.grant_type&&b.code?Kh(a,a.i+"?key="+encodeURIComponent(a.b),function(a){a?a.error?d(Ph(a)):a.access_token&&a.refresh_token?c(a):d(new N("internal-error")):d(new N("network-request-failed"))},"POST",Ie(b).toString(),a.c,a.l.get()):d(new N("internal-error"))})}
	function Qh(a,b,c,d,e,f){var g=De(a.g+b);I(g,"key",a.b);f&&I(g,"cb",na().toString());var l="GET"==c;if(l)for(var n in d)d.hasOwnProperty(n)&&I(g,n,d[n]);return new z(function(b,f){Kh(a,g.toString(),function(a){a?a.error?f(Ph(a,e||{})):b(a):f(new N("network-request-failed"))},c,l?void 0:Cc(Vf(d)),a.a,a.h.get())})}function Rh(a){if(!jf.test(a.email))throw new N("invalid-email");}function Sh(a){"email"in a&&Rh(a)}
	function Th(a,b){return Q(a,Uh,{identifier:b,continueUri:Sf()?vf():"http://localhost"}).then(function(a){return a.allProviders||[]})}function Vh(a){return Q(a,Wh,{}).then(function(a){return a.authorizedDomains||[]})}function Xh(a){if(!a[O])throw new N("internal-error");}
	function Yh(a){if(a.phoneNumber||a.temporaryProof){if(!a.phoneNumber||!a.temporaryProof)throw new N("internal-error");}else{if(!a.sessionInfo)throw new N("missing-verification-id");if(!a.code)throw new N("missing-verification-code");}}Ch.prototype.gb=function(){return Q(this,Zh,{})};Ch.prototype.kb=function(a,b){return Q(this,$h,{idToken:a,email:b})};Ch.prototype.lb=function(a,b){return Q(this,lh,{idToken:a,password:b})};var ai={displayName:"DISPLAY_NAME",photoUrl:"PHOTO_URL"};h=Ch.prototype;
	h.mb=function(a,b){var c={idToken:a},d=[];Pa(ai,function(a,f){var e=b[f];null===e?d.push(a):f in b&&(c[f]=e)});d.length&&(c.deleteAttribute=d);return Q(this,$h,c)};h.cb=function(a,b){a={requestType:"PASSWORD_RESET",email:a};Wa(a,b);return Q(this,bi,a)};h.bb=function(a,b){a={requestType:"VERIFY_EMAIL",idToken:a};Wa(a,b);return Q(this,ci,a)};function sh(a,b){return Q(a,di,b)}h.Qa=function(a){return Q(this,ei,a)};function fi(a,b,c){return Q(a,gi,{idToken:b,deleteProvider:c})}
	function hi(a){if(!a.requestUri||!a.sessionId&&!a.postBody)throw new N("internal-error");}function ii(a){var b=null;a.needConfirmation?(a.code="account-exists-with-different-credential",b=Ah(a)):"FEDERATED_USER_ID_ALREADY_LINKED"==a.errorMessage?(a.code="credential-already-in-use",b=Ah(a)):"EMAIL_EXISTS"==a.errorMessage?(a.code="email-already-in-use",b=Ah(a)):a.errorMessage&&(b=ji(a.errorMessage));if(b)throw b;if(!a[O])throw new N("internal-error");}
	function Xg(a,b){b.returnIdpCredential=!0;return Q(a,ki,b)}function Zg(a,b){b.returnIdpCredential=!0;return Q(a,li,b)}function $g(a,b){b.returnIdpCredential=!0;b.autoCreate=!1;return Q(a,mi,b)}function ni(a){if(!a.oobCode)throw new N("invalid-action-code");}h.Ta=function(a,b){return Q(this,oi,{oobCode:a,newPassword:b})};h.Ia=function(a){return Q(this,pi,{oobCode:a})};h.Sa=function(a){return Q(this,qi,{oobCode:a})};
	var qi={endpoint:"setAccountInfo",D:ni,ga:"email"},pi={endpoint:"resetPassword",D:ni,O:function(a){if(!a.email||!a.requestType)throw new N("internal-error");}},ri={endpoint:"signupNewUser",D:function(a){Rh(a);if(!a.password)throw new N("weak-password");},O:Xh,T:!0},Uh={endpoint:"createAuthUri"},si={endpoint:"deleteAccount",ea:["idToken"]},gi={endpoint:"setAccountInfo",ea:["idToken","deleteProvider"],D:function(a){if(!fa(a.deleteProvider))throw new N("internal-error");}},ti={endpoint:"getAccountInfo"},
	ci={endpoint:"getOobConfirmationCode",ea:["idToken","requestType"],D:function(a){if("VERIFY_EMAIL"!=a.requestType)throw new N("internal-error");},ga:"email"},bi={endpoint:"getOobConfirmationCode",ea:["requestType"],D:function(a){if("PASSWORD_RESET"!=a.requestType)throw new N("internal-error");Rh(a)},ga:"email"},Wh={nb:!0,endpoint:"getProjectConfig",zb:"GET"},ui={nb:!0,endpoint:"getRecaptchaParam",zb:"GET",O:function(a){if(!a.recaptchaSiteKey)throw new N("internal-error");}},oi={endpoint:"resetPassword",
	D:ni,ga:"email"},di={endpoint:"sendVerificationCode",ea:["phoneNumber","recaptchaToken"],ga:"sessionInfo"},$h={endpoint:"setAccountInfo",ea:["idToken"],D:Sh,T:!0},lh={endpoint:"setAccountInfo",ea:["idToken"],D:function(a){Sh(a);if(!a.password)throw new N("weak-password");},O:Xh,T:!0},Zh={endpoint:"signupNewUser",O:Xh,T:!0},ki={endpoint:"verifyAssertion",D:hi,O:ii,T:!0},mi={endpoint:"verifyAssertion",D:hi,O:function(a){if(a.errorMessage&&"USER_NOT_FOUND"==a.errorMessage)throw new N("user-not-found");
	if(a.errorMessage)throw ji(a.errorMessage);if(!a[O])throw new N("internal-error");},T:!0},li={endpoint:"verifyAssertion",D:function(a){hi(a);if(!a.idToken)throw new N("internal-error");},O:ii,T:!0},vi={endpoint:"verifyCustomToken",D:function(a){if(!a.token)throw new N("invalid-custom-token");},O:Xh,T:!0},kh={endpoint:"verifyPassword",D:function(a){Rh(a);if(!a.password)throw new N("wrong-password");},O:Xh,T:!0},ei={endpoint:"verifyPhoneNumber",D:Yh,O:Xh},ph={endpoint:"verifyPhoneNumber",D:function(a){if(!a.idToken)throw new N("internal-error");
	Yh(a)},O:function(a){if(a.temporaryProof)throw a.code="credential-already-in-use",Ah(a);Xh(a)}},qh={Pb:{USER_NOT_FOUND:"user-not-found"},endpoint:"verifyPhoneNumber",D:Yh,O:Xh};
	function Q(a,b,c){if(!jg(c,b.ea))return B(new N("internal-error"));var d=b.zb||"POST",e;return A(c).then(b.D).then(function(){b.T&&(c.returnSecureToken=!0);return Qh(a,b.endpoint,d,c,b.Pb,b.nb||!1)}).then(function(a){return e=a}).then(b.O).then(function(){if(!b.ga)return e;if(!(b.ga in e))throw new N("internal-error");return e[b.ga]})}function ji(a){return Ph({error:{errors:[{message:a}],code:400,message:a}})}
	function Ph(a,b){var c=(a.error&&a.error.errors&&a.error.errors[0]||{}).reason||"";var d={keyInvalid:"invalid-api-key",ipRefererBlocked:"app-not-authorized"};if(c=d[c]?new N(d[c]):null)return c;c=a.error&&a.error.message||"";d={INVALID_CUSTOM_TOKEN:"invalid-custom-token",CREDENTIAL_MISMATCH:"custom-token-mismatch",MISSING_CUSTOM_TOKEN:"internal-error",INVALID_IDENTIFIER:"invalid-email",MISSING_CONTINUE_URI:"internal-error",INVALID_EMAIL:"invalid-email",INVALID_PASSWORD:"wrong-password",USER_DISABLED:"user-disabled",
	MISSING_PASSWORD:"internal-error",EMAIL_EXISTS:"email-already-in-use",PASSWORD_LOGIN_DISABLED:"operation-not-allowed",INVALID_IDP_RESPONSE:"invalid-credential",FEDERATED_USER_ID_ALREADY_LINKED:"credential-already-in-use",INVALID_MESSAGE_PAYLOAD:"invalid-message-payload",INVALID_RECIPIENT_EMAIL:"invalid-recipient-email",INVALID_SENDER:"invalid-sender",EMAIL_NOT_FOUND:"user-not-found",EXPIRED_OOB_CODE:"expired-action-code",INVALID_OOB_CODE:"invalid-action-code",MISSING_OOB_CODE:"internal-error",CREDENTIAL_TOO_OLD_LOGIN_AGAIN:"requires-recent-login",
	INVALID_ID_TOKEN:"invalid-user-token",TOKEN_EXPIRED:"user-token-expired",USER_NOT_FOUND:"user-token-expired",CORS_UNSUPPORTED:"cors-unsupported",DYNAMIC_LINK_NOT_ACTIVATED:"dynamic-link-not-activated",INVALID_APP_ID:"invalid-app-id",TOO_MANY_ATTEMPTS_TRY_LATER:"too-many-requests",WEAK_PASSWORD:"weak-password",OPERATION_NOT_ALLOWED:"operation-not-allowed",USER_CANCELLED:"user-cancelled",CAPTCHA_CHECK_FAILED:"captcha-check-failed",INVALID_APP_CREDENTIAL:"invalid-app-credential",INVALID_CODE:"invalid-verification-code",
	INVALID_PHONE_NUMBER:"invalid-phone-number",INVALID_SESSION_INFO:"invalid-verification-id",INVALID_TEMPORARY_PROOF:"invalid-credential",MISSING_APP_CREDENTIAL:"missing-app-credential",MISSING_CODE:"missing-verification-code",MISSING_PHONE_NUMBER:"missing-phone-number",MISSING_SESSION_INFO:"missing-verification-id",QUOTA_EXCEEDED:"quota-exceeded",SESSION_EXPIRED:"code-expired",INVALID_CONTINUE_URI:"invalid-continue-uri",MISSING_ANDROID_PACKAGE_NAME:"missing-android-pkg-name",MISSING_IOS_BUNDLE_ID:"missing-ios-bundle-id",
	UNAUTHORIZED_DOMAIN:"unauthorized-continue-uri",INVALID_OAUTH_CLIENT_ID:"invalid-oauth-client-id",INVALID_CERT_HASH:"invalid-cert-hash"};Wa(d,b||{});b=(b=c.match(/^[^\s]+\s*:\s*(.*)$/))&&1<b.length?b[1]:void 0;for(var e in d)if(0===c.indexOf(e))return new N(d[e],b);!b&&a&&(b=Uf(a));return new N("internal-error",b)};var wi={Mc:{Va:"https://www.googleapis.com/identitytoolkit/v3/relyingparty/",ab:"https://securetoken.googleapis.com/v1/token",id:"p"},Oc:{Va:"https://staging-www.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",ab:"https://staging-securetoken.sandbox.googleapis.com/v1/token",id:"s"},Pc:{Va:"https://www-googleapis-test.sandbox.google.com/identitytoolkit/v3/relyingparty/",ab:"https://test-securetoken.sandbox.googleapis.com/v1/token",id:"t"}};
	function xi(a){for(var b in wi)if(wi[b].id===a)return a=wi[b],{firebaseEndpoint:a.Va,secureTokenEndpoint:a.ab};return null}var yi;yi=xi("__EID__")?"__EID__":void 0;function zi(a){this.b=a;this.a=null;this.Ya=Ai(this)}
	function Ai(a){return Bi().then(function(){return new z(function(b,c){L("gapi.iframes.getContext")().open({where:document.body,url:a.b,messageHandlersFilter:L("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"),attributes:{style:{position:"absolute",top:"-100px",width:"1px",height:"1px"}},dontclear:!0},function(d){function e(){clearTimeout(f);b()}a.a=d;a.a.restyle({setHideOnLeave:!1});var f=setTimeout(function(){c(Error("Network Error"))},Ci.get());d.ping(e).then(e,function(){c(Error("Network Error"))})})})})}
	function Di(a,b){return a.Ya.then(function(){return new z(function(c){a.a.send(b.type,b,c,L("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})})}function Ei(a,b){a.Ya.then(function(){a.a.register("authEvent",b,L("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})}var Fi=dc("https://apis.google.com/js/api.js?onload=%{onload}"),Gi=new $f(3E4,6E4),Ci=new $f(5E3,15E3),Hi=null;
	function Bi(){return Hi?Hi:Hi=(new z(function(a,b){if(Zf()){var c=function(){Yf();L("gapi.load")("gapi.iframes",{callback:a,ontimeout:function(){Yf();b(Error("Network Error"))},timeout:Gi.get()})};if(L("gapi.iframes.Iframe"))a();else if(L("gapi.load"))c();else{var d="__iframefcb"+Math.floor(1E6*Math.random()).toString();k[d]=function(){L("gapi.load")?c():b(Error("Network Error"))};d=hc(Fi,{onload:d});A(kf(d)).s(function(){b(Error("Network Error"))})}}else b(Error("Network Error"))})).s(function(a){Hi=
	null;throw a;})};function Ii(a,b,c){this.i=a;this.g=b;this.h=c;this.f=null;this.a=Ee(this.i,"/__/auth/iframe");I(this.a,"apiKey",this.g);I(this.a,"appName",this.h);this.b=null;this.c=[]}Ii.prototype.toString=function(){this.f?I(this.a,"v",this.f):Le(this.a.a,"v");this.b?I(this.a,"eid",this.b):Le(this.a.a,"eid");this.c.length?I(this.a,"fw",this.c.join(",")):Le(this.a.a,"fw");return this.a.toString()};function Ji(a,b,c,d,e){this.m=a;this.u=b;this.c=c;this.l=d;this.i=this.g=this.h=null;this.a=e;this.f=null}
	Ji.prototype.toString=function(){var a=Ee(this.m,"/__/auth/handler");I(a,"apiKey",this.u);I(a,"appName",this.c);I(a,"authType",this.l);if(this.a.isOAuthProvider){var b=this.a;try{var c=firebase.app(this.c).auth().$()}catch(l){c=null}b.Ua=c;I(a,"providerId",this.a.providerId);b=this.a;c=Vf(b.rb);for(var d in c)c[d]=c[d].toString();d=b.rc;c=Ua(c);for(var e=0;e<d.length;e++){var f=d[e];f in c&&delete c[f]}b.Wa&&b.Ua&&!c[b.Wa]&&(c[b.Wa]=b.Ua);Sa(c)||I(a,"customParameters",Uf(c))}"function"===typeof this.a.wb&&
	(b=this.a.wb(),b.length&&I(a,"scopes",b.join(",")));this.h?I(a,"redirectUrl",this.h):Le(a.a,"redirectUrl");this.g?I(a,"eventId",this.g):Le(a.a,"eventId");this.i?I(a,"v",this.i):Le(a.a,"v");if(this.b)for(var g in this.b)this.b.hasOwnProperty(g)&&!Ce(a,g)&&I(a,g,this.b[g]);this.f?I(a,"eid",this.f):Le(a.a,"eid");g=Ki(this.c);g.length&&I(a,"fw",g.join(","));return a.toString()};function Ki(a){try{return firebase.app(a).auth().Ka()}catch(b){return[]}}
	function Li(a,b,c,d,e){this.u=a;this.f=b;this.b=c;this.c=d||null;this.h=e||null;this.m=this.o=this.v=null;this.g=[];this.l=this.a=null}
	function Mi(a){var b=vf();return Vh(a).then(function(a){a:{var c=De(b),e=c.c;c=c.b;for(var f=0;f<a.length;f++){var g=a[f];var l=c;var n=e;0==g.indexOf("chrome-extension://")?l=De(g).b==l&&"chrome-extension"==n:"http"!=n&&"https"!=n?l=!1:Gf.test(g)?l=l==g:(g=g.split(".").join("\\."),l=(new RegExp("^(.+\\."+g+"|"+g+")$","i")).test(l));if(l){a=!0;break a}}a=!1}if(!a)throw new yh(vf());})}
	function Ni(a){if(a.l)return a.l;a.l=Hf().then(function(){if(!a.o){var b=a.c,c=a.h,d=Ki(a.b),e=new Ii(a.u,a.f,a.b);e.f=b;e.b=c;e.c=La(d||[]);a.o=e.toString()}a.i=new zi(a.o);Oi(a)});return a.l}h=Li.prototype;h.Ca=function(a,b,c){var d=new N("popup-closed-by-user"),e=new N("web-storage-unsupported"),f=this,g=!1;return this.ba().then(function(){Pi(f).then(function(c){c||(a&&Cf(a),b(e),g=!0)})}).s(function(){}).then(function(){if(!g)return Ff(a)}).then(function(){if(!g)return sd(c).then(function(){b(d)})})};
	h.Db=function(){var a=J();return!Tf(a)&&!Xf(a)};h.yb=function(){return!1};
	h.vb=function(a,b,c,d,e,f,g){if(!a)return B(new N("popup-blocked"));if(g&&!Tf())return this.ba().s(function(b){Cf(a);e(b)}),d(),A();this.a||(this.a=Mi(Qi(this)));var l=this;return this.a.then(function(){var b=l.ba().s(function(b){Cf(a);e(b);throw b;});d();return b}).then(function(){vh(c);if(!g){var d=Ri(l.u,l.f,l.b,b,c,null,f,l.c,void 0,l.h);wf(d,a)}}).s(function(a){"auth/network-request-failed"==a.code&&(l.a=null);throw a;})};
	function Qi(a){a.m||(a.v=a.c?Of(a.c,Ki(a.b)):null,a.m=new Ch(a.f,xi(a.h),a.v));return a.m}h.Aa=function(a,b,c){this.a||(this.a=Mi(Qi(this)));var d=this;return this.a.then(function(){vh(b);var e=Ri(d.u,d.f,d.b,a,b,vf(),c,d.c,void 0,d.h);wf(e)}).s(function(a){"auth/network-request-failed"==a.code&&(d.a=null);throw a;})};h.ba=function(){var a=this;return Ni(this).then(function(){return a.i.Ya}).s(function(){a.a=null;throw new N("network-request-failed");})};h.Hb=function(){return!0};
	function Ri(a,b,c,d,e,f,g,l,n,D){a=new Ji(a,b,c,d,e);a.h=f;a.g=g;a.i=l;a.b=Ua(n||null);a.f=D;return a.toString()}function Oi(a){if(!a.i)throw Error("IfcHandler must be initialized!");Ei(a.i,function(b){var c={};if(b&&b.authEvent){var d=!1;b=xh(b.authEvent);for(c=0;c<a.g.length;c++)d=a.g[c](b)||d;c={};c.status=d?"ACK":"ERROR";return A(c)}c.status="ERROR";return A(c)})}
	function Pi(a){var b={type:"webStorageSupport"};return Ni(a).then(function(){return Di(a.i,b)}).then(function(a){if(a&&a.length&&"undefined"!==typeof a[0].webStorageSupport)return a[0].webStorageSupport;throw Error();})}h.ua=function(a){this.g.push(a)};h.Ja=function(a){Ja(this.g,function(b){return b==a})};function Si(a){this.a=a||firebase.INTERNAL.reactNative&&firebase.INTERNAL.reactNative.AsyncStorage;if(!this.a)throw new N("internal-error","The React Native compatibility library was not found.");}h=Si.prototype;h.get=function(a){return A(this.a.getItem(a)).then(function(a){return a&&Wf(a)})};h.set=function(a,b){return A(this.a.setItem(a,Uf(b)))};h.X=function(a){return A(this.a.removeItem(a))};h.ia=function(){};h.da=function(){};function Ti(){this.a={}}h=Ti.prototype;h.get=function(a){return A(this.a[a])};h.set=function(a,b){this.a[a]=b;return A()};h.X=function(a){delete this.a[a];return A()};h.ia=function(){};h.da=function(){};function Ui(a,b,c,d,e,f){try{var g=!!k.indexedDB}catch(l){g=!1}if(!g)throw new N("web-storage-unsupported");this.u=a;this.h=b;this.g=c;this.l=d;this.m=e;this.f={};this.c=[];this.a=0;this.o=f||k.indexedDB}var Vi;function Wi(a){return new z(function(b,c){var d=a.o.open(a.u,a.m);d.onerror=function(a){c(Error(a.target.errorCode))};d.onupgradeneeded=function(b){b=b.target.result;try{b.createObjectStore(a.h,{keyPath:a.g})}catch(f){c(f)}};d.onsuccess=function(a){b(a.target.result)}})}
	function Xi(a){a.i||(a.i=Wi(a));return a.i}function Yi(a,b){return b.objectStore(a.h)}function Zi(a,b,c){return b.transaction([a.h],c?"readwrite":"readonly")}function $i(a){return new z(function(b,c){a.onsuccess=function(a){a&&a.target?b(a.target.result):b()};a.onerror=function(a){c(Error(a.target.errorCode))}})}h=Ui.prototype;
	h.set=function(a,b){var c=!1,d,e=this;return Qb(Xi(this).then(function(b){d=b;b=Yi(e,Zi(e,d,!0));return $i(b.get(a))}).then(function(f){var g=Yi(e,Zi(e,d,!0));if(f)return f.value=b,$i(g.put(f));e.a++;c=!0;f={};f[e.g]=a;f[e.l]=b;return $i(g.add(f))}).then(function(){e.f[a]=b}),function(){c&&e.a--})};h.get=function(a){var b=this;return Xi(this).then(function(c){return $i(Yi(b,Zi(b,c,!1)).get(a))}).then(function(a){return a&&a.value})};
	h.X=function(a){var b=!1,c=this;return Qb(Xi(this).then(function(d){b=!0;c.a++;return $i(Yi(c,Zi(c,d,!0))["delete"](a))}).then(function(){delete c.f[a]}),function(){b&&c.a--})};
	h.zc=function(){var a=this;return Xi(this).then(function(b){var c=Yi(a,Zi(a,b,!1));return c.getAll?$i(c.getAll()):new z(function(a,b){var d=[],e=c.openCursor();e.onsuccess=function(b){(b=b.target.result)?(d.push(b.value),b["continue"]()):a(d)};e.onerror=function(a){b(Error(a.target.errorCode))}})}).then(function(b){var c={},d=[];if(0==a.a){for(d=0;d<b.length;d++)c[b[d][a.g]]=b[d][a.l];d=xf(a.f,c);a.f=c}return d})};h.ia=function(a){0==this.c.length&&aj(this);this.c.push(a)};
	h.da=function(a){Ja(this.c,function(b){return b==a});0==this.c.length&&this.b&&this.b.cancel("STOP_EVENT")};function aj(a){function b(){a.b=sd(800).then(r(a.zc,a)).then(function(b){0<b.length&&w(a.c,function(a){a(b)})}).then(b).s(function(a){"STOP_EVENT"!=a.message&&b()});return a.b}a.b&&a.b.cancel("STOP_EVENT");b()};function bj(){if(!cj()){if("Node"==K())throw new N("internal-error","The LocalStorage compatibility library was not found.");throw new N("web-storage-unsupported");}this.a=dj()||firebase.INTERNAL.node.localStorage}function dj(){try{var a=k.localStorage,b=Qf();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
	function cj(){var a="Node"==K();a=dj()||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.localStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}h=bj.prototype;h.get=function(a){var b=this;return A().then(function(){var c=b.a.getItem(a);return Wf(c)})};h.set=function(a,b){var c=this;return A().then(function(){var d=Uf(b);null===d?c.X(a):c.a.setItem(a,d)})};h.X=function(a){var b=this;return A().then(function(){b.a.removeItem(a)})};
	h.ia=function(a){k.window&&cd(k.window,"storage",a)};h.da=function(a){k.window&&E(k.window,"storage",a)};function ej(){}h=ej.prototype;h.get=function(){return A(null)};h.set=function(){return A()};h.X=function(){return A()};h.ia=function(){};h.da=function(){};function fj(){if(!gj()){if("Node"==K())throw new N("internal-error","The SessionStorage compatibility library was not found.");throw new N("web-storage-unsupported");}this.a=hj()||firebase.INTERNAL.node.sessionStorage}function hj(){try{var a=k.sessionStorage,b=Qf();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
	function gj(){var a="Node"==K();a=hj()||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.sessionStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}h=fj.prototype;h.get=function(a){var b=this;return A().then(function(){var c=b.a.getItem(a);return Wf(c)})};h.set=function(a,b){var c=this;return A().then(function(){var d=Uf(b);null===d?c.X(a):c.a.setItem(a,d)})};h.X=function(a){var b=this;return A().then(function(){b.a.removeItem(a)})};h.ia=function(){};
	h.da=function(){};function ij(){var a={};a.Browser=jj;a.Node=kj;a.ReactNative=lj;this.a=a[K()]}var mj,jj={C:bj,jb:fj},kj={C:bj,jb:fj},lj={C:Si,jb:ej};var nj={Lc:"local",NONE:"none",Nc:"session"};function oj(a){var b=new N("invalid-persistence-type"),c=new N("unsupported-persistence-type");a:{for(d in nj)if(nj[d]==a){var d=!0;break a}d=!1}if(!d||"string"!==typeof a)throw b;switch(K()){case "ReactNative":if("session"===a)throw c;break;case "Node":if("none"!==a)throw c;break;default:if(!Pf()&&"none"!==a)throw c;}}
	function pj(a,b,c,d,e){this.i=a;this.g=b;this.A=c;this.u=d;this.v=e;this.a={};mj||(mj=new ij);a=mj;try{if(uf()){Vi||(Vi=new Ui("firebaseLocalStorageDb","firebaseLocalStorage","fbase_key","value",1));var f=Vi}else f=new a.a.C;this.l=f}catch(g){this.l=new Ti,this.u=!0}try{this.o=new a.a.jb}catch(g){this.o=new Ti}this.w=new Ti;this.h=r(this.m,this);this.b={}}var qj;function rj(){qj||(qj=new pj("firebase",":",!Xf(J())&&Lf()?!0:!1,Tf(),Pf()));return qj}
	function sj(a,b){switch(b){case "session":return a.o;case "none":return a.w;default:return a.l}}function tj(a,b,c){return a.i+a.g+b.name+(c?a.g+c:"")}pj.prototype.get=function(a,b){return sj(this,a.C).get(tj(this,a,b))};function uj(a,b,c){c=tj(a,b,c);"local"==b.C&&(a.b[c]=null);return sj(a,b.C).X(c)}pj.prototype.set=function(a,b,c){var d=tj(this,a,c),e=this,f=sj(this,a.C);return f.set(d,b).then(function(){return f.get(d)}).then(function(b){"local"==a.C&&(e.b[d]=b)})};
	function vj(a,b,c,d){b=tj(a,b,c);a.v&&(a.b[b]=k.localStorage.getItem(b));Sa(a.a)&&(sj(a,"local").ia(a.h),a.u||uf()||!a.v||wj(a));a.a[b]||(a.a[b]=[]);a.a[b].push(d)}function xj(a,b,c){b=tj(a,yj("local"),b);a.a[b]&&(Ja(a.a[b],function(a){return a==c}),0==a.a[b].length&&delete a.a[b]);Sa(a.a)&&zj(a)}
	function wj(a){Aj(a);a.f=setInterval(function(){for(var b in a.a){var c=k.localStorage.getItem(b),d=a.b[b];c!=d&&(a.b[b]=c,c=new Qc({type:"storage",key:b,target:window,oldValue:d,newValue:c,a:!0}),a.m(c))}},1E3)}function Aj(a){a.f&&(clearInterval(a.f),a.f=null)}function zj(a){sj(a,"local").da(a.h);Aj(a)}
	pj.prototype.m=function(a){if(a&&a.g){var b=a.a.key;if(null==b)for(var c in this.a){var d=this.b[c];"undefined"===typeof d&&(d=null);var e=k.localStorage.getItem(c);e!==d&&(this.b[c]=e,this.c(c))}else if(0==b.indexOf(this.i+this.g)&&this.a[b]){"undefined"!==typeof a.a.a?sj(this,"local").da(this.h):Aj(this);if(this.A)if(c=k.localStorage.getItem(b),d=a.a.newValue,d!==c)null!==d?k.localStorage.setItem(b,d):k.localStorage.removeItem(b);else if(this.b[b]===d&&"undefined"===typeof a.a.a)return;var f=this;
	c=function(){if("undefined"!==typeof a.a.a||f.b[b]!==k.localStorage.getItem(b))f.b[b]=k.localStorage.getItem(b),f.c(b)};y&&kb&&10==kb&&k.localStorage.getItem(b)!==a.a.newValue&&a.a.newValue!==a.a.oldValue?setTimeout(c,10):c()}}else w(a,r(this.c,this))};pj.prototype.c=function(a){this.a[a]&&w(this.a[a],function(a){a()})};function Cj(a){this.a=a;this.b=rj()}var Dj={name:"authEvent",C:"local"};function Ej(a){return a.b.get(Dj,a.a).then(function(a){return xh(a)})};function Fj(){this.a=rj()};function Gj(a,b,c,d,e,f,g){this.u=a;this.i=b;this.l=c;this.m=d||null;this.o=g||null;this.h=b+":"+c;this.A=new Fj;this.g=new Cj(this.h);this.f=null;this.b=[];this.v=e||500;this.w=f||2E3;this.a=this.c=null}function Hj(a){return new N("invalid-cordova-configuration",a)}h=Gj.prototype;
	h.ba=function(){return this.xa?this.xa:this.xa=If().then(function(){if("function"!==typeof L("universalLinks.subscribe",k))throw Hj("cordova-universal-links-plugin is not installed");if("undefined"===typeof L("BuildInfo.packageName",k))throw Hj("cordova-plugin-buildinfo is not installed");if("function"!==typeof L("cordova.plugins.browsertab.openUrl",k))throw Hj("cordova-plugin-browsertab is not installed");if("function"!==typeof L("cordova.InAppBrowser.open",k))throw Hj("cordova-plugin-inappbrowser is not installed");
	},function(){throw new N("cordova-not-ready");})};function Ij(){for(var a=20,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}function Jj(a){var b=new ie;he(b,a);a=[];var c=8*b.g;56>b.c?he(b,fe,56-b.c):he(b,fe,b.b-(b.c-56));for(var d=63;56<=d;d--)b.f[d]=c&255,c/=256;ge(b);for(d=c=0;d<b.i;d++)for(var e=24;0<=e;e-=8)a[c++]=b.a[d]>>e&255;return Hd(a)}
	h.Ca=function(a,b){b(new N("operation-not-supported-in-this-environment"));return A()};h.vb=function(){return B(new N("operation-not-supported-in-this-environment"))};h.Hb=function(){return!1};h.Db=function(){return!0};h.yb=function(){return!0};
	h.Aa=function(a,b,c){if(this.c)return B(new N("redirect-operation-pending"));var d=this,e=k.document,f=null,g=null,l=null,n=null;return this.c=Qb(A().then(function(){vh(b);return Kj(d)}).then(function(){return Lj(d,a,b,c)}).then(function(){return(new z(function(a,b){g=function(){var b=L("cordova.plugins.browsertab.close",k);a();"function"===typeof b&&b();d.a&&"function"===typeof d.a.close&&(d.a.close(),d.a=null);return!1};d.ua(g);l=function(){f||(f=sd(d.w).then(function(){b(new N("redirect-cancelled-by-user"))}))};
	n=function(){ag()&&l()};e.addEventListener("resume",l,!1);J().toLowerCase().match(/android/)||e.addEventListener("visibilitychange",n,!1)})).s(function(a){return Mj(d).then(function(){throw a;})})}),function(){l&&e.removeEventListener("resume",l,!1);n&&e.removeEventListener("visibilitychange",n,!1);f&&f.cancel();g&&d.Ja(g);d.c=null})};
	function Lj(a,b,c,d){var e=Ij(),f=new wh(b,d,null,e,new N("no-auth-event")),g=L("BuildInfo.packageName",k);if("string"!==typeof g)throw new N("invalid-cordova-configuration");var l=L("BuildInfo.displayName",k),n={};if(J().toLowerCase().match(/iphone|ipad|ipod/))n.ibi=g;else if(J().toLowerCase().match(/android/))n.apn=g;else return B(new N("operation-not-supported-in-this-environment"));l&&(n.appDisplayName=l);e=Jj(e);n.sessionId=e;var D=Ri(a.u,a.i,a.l,b,c,null,d,a.m,n,a.o);return a.ba().then(function(){var b=
	a.h;return a.A.a.set(Dj,f.B(),b)}).then(function(){var b=L("cordova.plugins.browsertab.isAvailable",k);if("function"!==typeof b)throw new N("invalid-cordova-configuration");var c=null;b(function(b){if(b){c=L("cordova.plugins.browsertab.openUrl",k);if("function"!==typeof c)throw new N("invalid-cordova-configuration");c(D)}else{c=L("cordova.InAppBrowser.open",k);if("function"!==typeof c)throw new N("invalid-cordova-configuration");b=J();b=!(!b.match(/(iPad|iPhone|iPod).*OS 7_\d/i)&&!b.match(/(iPad|iPhone|iPod).*OS 8_\d/i));
	a.a=c(D,b?"_blank":"_system","location=yes")}})})}function Nj(a,b){for(var c=0;c<a.b.length;c++)try{a.b[c](b)}catch(d){}}function Kj(a){a.f||(a.f=a.ba().then(function(){return new z(function(b){function c(d){b(d);a.Ja(c);return!1}a.ua(c);Oj(a)})}));return a.f}function Mj(a){var b=null;return Ej(a.g).then(function(c){b=c;c=a.g;return uj(c.b,Dj,c.a)}).then(function(){return b})}
	function Oj(a){function b(b){e=!0;f&&f.cancel();Mj(a).then(function(c){var e=d;if(c&&b&&b.url){e=null;var f=b.url;var g=De(f),l=Ce(g,"link"),n=Ce(De(l),"link");g=Ce(g,"deep_link_id");f=Ce(De(g),"link")||g||n||l||f;-1!=f.indexOf("/__/auth/callback")&&(e=De(f),e=Wf(Ce(e,"firebaseError")||null),e=(e="object"===typeof e?vg(e):null)?new wh(c.b,c.c,null,null,e):new wh(c.b,c.c,f,c.g));e=e||d}Nj(a,e)})}var c=L("universalLinks.subscribe",k);if("function"!==typeof c)throw new N("invalid-cordova-configuration");
	var d=new wh("unknown",null,null,null,new N("no-auth-event")),e=!1,f=sd(a.v).then(function(){return Mj(a).then(function(){e||Nj(a,d)})}),g=k.handleOpenURL;k.handleOpenURL=function(a){0==a.toLowerCase().indexOf(L("BuildInfo.packageName",k).toLowerCase()+"://")&&b({url:a});if("function"===typeof g)try{g(a)}catch(n){console.error(n)}};c(null,b)}
	h.ua=function(a){this.b.push(a);Kj(this).s(function(b){"auth/invalid-cordova-configuration"===b.code&&(b=new wh("unknown",null,null,null,new N("no-auth-event")),a(b))})};h.Ja=function(a){Ja(this.b,function(b){return b==a})};function Pj(a){this.a=a;this.b=rj()}var Qj={name:"pendingRedirect",C:"session"};function Rj(a){return a.b.set(Qj,"pending",a.a)}function Sj(a){return uj(a.b,Qj,a.a)}function Tj(a){return a.b.get(Qj,a.a).then(function(a){return"pending"==a})};function Uj(a,b,c){this.v=a;this.l=b;this.u=c;this.h=[];this.f=!1;this.i=r(this.m,this);this.c=new Vj;this.o=new Wj;this.g=new Pj(this.l+":"+this.u);this.b={};this.b.unknown=this.c;this.b.signInViaRedirect=this.c;this.b.linkViaRedirect=this.c;this.b.reauthViaRedirect=this.c;this.b.signInViaPopup=this.o;this.b.linkViaPopup=this.o;this.b.reauthViaPopup=this.o;this.a=Xj(this.v,this.l,this.u,yi)}
	function Xj(a,b,c,d){var e=firebase.SDK_VERSION||null;return Jf()?new Gj(a,b,c,e,void 0,void 0,d):new Li(a,b,c,e,d)}Uj.prototype.reset=function(){this.f=!1;this.a.Ja(this.i);this.a=Xj(this.v,this.l,this.u)};function Yj(a){a.f||(a.f=!0,a.a.ua(a.i));var b=a.a;return a.a.ba().s(function(c){a.a==b&&a.reset();throw c;})}function Zj(a){a.a.Db()&&Yj(a).s(function(b){var c=new wh("unknown",null,null,null,new N("operation-not-supported-in-this-environment"));ak(b)&&a.m(c)});a.a.yb()||bk(a.c)}
	Uj.prototype.subscribe=function(a){Ha(this.h,a)||this.h.push(a);if(!this.f){var b=this;Tj(this.g).then(function(a){a?Sj(b.g).then(function(){Yj(b).s(function(a){var c=new wh("unknown",null,null,null,new N("operation-not-supported-in-this-environment"));ak(a)&&b.m(c)})}):Zj(b)}).s(function(){Zj(b)})}};Uj.prototype.unsubscribe=function(a){Ja(this.h,function(b){return b==a})};
	Uj.prototype.m=function(a){if(!a)throw new N("invalid-auth-event");for(var b=!1,c=0;c<this.h.length;c++){var d=this.h[c];if(d.ob(a.b,a.c)){(b=this.b[a.b])&&b.h(a,d);b=!0;break}}bk(this.c);return b};var ck=new $f(2E3,1E4),dk=new $f(3E4,6E4);Uj.prototype.aa=function(){return this.c.aa()};function ek(a,b,c,d,e,f){return a.a.vb(b,c,d,function(){a.f||(a.f=!0,a.a.ua(a.i))},function(){a.reset()},e,f)}function ak(a){return a&&"auth/cordova-not-ready"==a.code?!0:!1}
	Uj.prototype.Aa=function(a,b,c){var d=this,e;return Rj(this.g).then(function(){return d.a.Aa(a,b,c).s(function(a){if(ak(a))throw new N("operation-not-supported-in-this-environment");e=a;return Sj(d.g).then(function(){throw e;})}).then(function(){return d.a.Hb()?new z(function(){}):Sj(d.g).then(function(){return d.aa()}).then(function(){}).s(function(){})})})};Uj.prototype.Ca=function(a,b,c,d){return this.a.Ca(c,function(c){a.fa(b,null,c,d)},ck.get())};var fk={};
	function gk(a,b,c){var d=b+":"+c;fk[d]||(fk[d]=new Uj(a,b,c));return fk[d]}function Vj(){this.b=null;this.f=[];this.c=[];this.a=null;this.g=!1}Vj.prototype.reset=function(){this.b=null;this.a&&(this.a.cancel(),this.a=null)};
	Vj.prototype.h=function(a,b){if(!a)return B(new N("invalid-auth-event"));this.reset();this.g=!0;var c=a.b,d=a.c,e=a.a&&"auth/web-storage-unsupported"==a.a.code,f=a.a&&"auth/operation-not-supported-in-this-environment"==a.a.code;"unknown"!=c||e||f?a.a?(hk(this,!0,null,a.a),a=A()):a=b.va(c,d)?ik(this,a,b):B(new N("invalid-auth-event")):(hk(this,!1,null,null),a=A());return a};function bk(a){a.g||(a.g=!0,hk(a,!1,null,null))}
	function ik(a,b,c){c=c.va(b.b,b.c);var d=b.f,e=b.g,f=!!b.b.match(/Redirect$/);return c(d,e).then(function(b){hk(a,f,b,null)}).s(function(b){hk(a,f,null,b)})}function jk(a,b){a.b=function(){return B(b)};if(a.c.length)for(var c=0;c<a.c.length;c++)a.c[c](b)}function kk(a,b){a.b=function(){return A(b)};if(a.f.length)for(var c=0;c<a.f.length;c++)a.f[c](b)}function hk(a,b,c,d){b?d?jk(a,d):kk(a,c):kk(a,{user:null});a.f=[];a.c=[]}
	Vj.prototype.aa=function(){var a=this;return new z(function(b,c){a.b?a.b().then(b,c):(a.f.push(b),a.c.push(c),lk(a))})};function lk(a){var b=new N("timeout");a.a&&a.a.cancel();a.a=sd(dk.get()).then(function(){a.b||hk(a,!0,null,b)})}function Wj(){}Wj.prototype.h=function(a,b){if(!a)return B(new N("invalid-auth-event"));var c=a.b,d=a.c;a.a?(b.fa(a.b,null,a.a,a.c),a=A()):a=b.va(c,d)?mk(a,b):B(new N("invalid-auth-event"));return a};
	function mk(a,b){var c=a.c,d=a.b;return b.va(d,c)(a.f,a.g).then(function(a){b.fa(d,a,null,c)}).s(function(a){b.fa(d,null,a,c)})};function nk(a,b){this.a=b;M(this,"verificationId",a)}nk.prototype.confirm=function(a){a=th(this.verificationId,a);return this.a(a)};function ok(a,b,c,d){return(new rh(a)).Qa(b,c).then(function(a){return new nk(a,d)})};function pk(a,b,c,d,e,f){this.h=a;this.i=b;this.g=c;this.c=d;this.f=e;this.l=!!f;this.b=null;this.a=this.c;if(this.f<this.c)throw Error("Proactive refresh lower bound greater than upper bound!");}pk.prototype.start=function(){this.a=this.c;qk(this,!0)};function rk(a,b){if(b)return a.a=a.c,a.g();b=a.a;a.a*=2;a.a>a.f&&(a.a=a.f);return b}
	function qk(a,b){sk(a);a.b=sd(rk(a,b)).then(function(){return a.l?A():bg()}).then(function(){return a.h()}).then(function(){qk(a,!0)}).s(function(b){a.i(b)&&qk(a,!1)})}function sk(a){a.b&&(a.b.cancel(),a.b=null)};function tk(a){this.f=a;this.b=this.a=null;this.c=0}tk.prototype.B=function(){return{apiKey:this.f.b,refreshToken:this.a,accessToken:this.b,expirationTime:this.c}};function uk(a,b){var c=b[O],d=b.refreshToken;b=vk(b.expiresIn);a.b=c;a.c=b;a.a=d}function vk(a){return na()+1E3*parseInt(a,10)}
	function wk(a,b){return Oh(a.f,b).then(function(b){a.b=b.access_token;a.c=vk(b.expires_in);a.a=b.refresh_token;return{accessToken:a.b,expirationTime:a.c,refreshToken:a.a}}).s(function(b){"auth/user-token-expired"==b.code&&(a.a=null);throw b;})}tk.prototype.getToken=function(a){a=!!a;return this.b&&!this.a?B(new N("user-token-expired")):a||!this.b||na()>this.c-3E4?this.a?wk(this,{grant_type:"refresh_token",refresh_token:this.a}):A(null):A({accessToken:this.b,expirationTime:this.c,refreshToken:this.a})};function xk(a,b){this.a=a||null;this.b=b||null;gg(this,{lastSignInTime:cg(b||null),creationTime:cg(a||null)})}function yk(a){return new xk(a.a,a.b)}xk.prototype.B=function(){return{lastLoginAt:this.b,createdAt:this.a}};function zk(a,b,c,d,e,f){gg(this,{uid:a,displayName:d||null,photoURL:e||null,email:c||null,phoneNumber:f||null,providerId:b})}function Ak(a,b){C.call(this,a);for(var c in b)this[c]=b[c]}t(Ak,C);
	function Bk(a,b,c){this.A=[];this.G=a.apiKey;this.o=a.appName;this.w=a.authDomain||null;a=firebase.SDK_VERSION?Of(firebase.SDK_VERSION):null;this.c=new Ch(this.G,xi(yi),a);this.h=new tk(this.c);Ck(this,b[O]);uk(this.h,b);M(this,"refreshToken",this.h.a);Dk(this,c||{});F.call(this);this.I=!1;this.w&&Rf()&&(this.a=gk(this.w,this.G,this.o));this.N=[];this.i=null;this.l=Ek(this);this.U=r(this.Ga,this);var d=this;this.ha=null;this.ra=function(a){d.na(a.h)};this.W=null;this.R=[];this.qa=function(a){Fk(d,
	a.f)};this.V=null}t(Bk,F);Bk.prototype.na=function(a){this.ha=a;Ih(this.c,a)};Bk.prototype.$=function(){return this.ha};function Gk(a,b){a.W&&E(a.W,"languageCodeChanged",a.ra);(a.W=b)&&cd(b,"languageCodeChanged",a.ra)}function Fk(a,b){a.R=b;Jh(a.c,firebase.SDK_VERSION?Of(firebase.SDK_VERSION,a.R):null)}Bk.prototype.Ka=function(){return La(this.R)};function Hk(a,b){a.V&&E(a.V,"frameworkChanged",a.qa);(a.V=b)&&cd(b,"frameworkChanged",a.qa)}Bk.prototype.Ga=function(){this.l.b&&(sk(this.l),this.l.start())};
	function Ik(a){try{return firebase.app(a.o).auth()}catch(b){throw new N("internal-error","No firebase.auth.Auth instance is available for the Firebase App '"+a.o+"'!");}}function Ek(a){return new pk(function(){return a.F(!0)},function(a){return a&&"auth/network-request-failed"==a.code?!0:!1},function(){var b=a.h.c-na()-3E5;return 0<b?b:0},3E4,96E4,!1)}function Jk(a){a.m||a.l.b||(a.l.start(),E(a,"tokenChanged",a.U),cd(a,"tokenChanged",a.U))}function Kk(a){E(a,"tokenChanged",a.U);sk(a.l)}
	function Ck(a,b){a.pa=b;M(a,"_lat",b)}function Lk(a,b){Ja(a.N,function(a){return a==b})}function Mk(a){for(var b=[],c=0;c<a.N.length;c++)b.push(a.N[c](a));return Ob(b).then(function(){return a})}function Nk(a){a.a&&!a.I&&(a.I=!0,a.a.subscribe(a))}
	function Dk(a,b){gg(a,{uid:b.uid,displayName:b.displayName||null,photoURL:b.photoURL||null,email:b.email||null,emailVerified:b.emailVerified||!1,phoneNumber:b.phoneNumber||null,isAnonymous:b.isAnonymous||!1,metadata:new xk(b.createdAt,b.lastLoginAt),providerData:[]})}M(Bk.prototype,"providerId","firebase");function Ok(){}function Pk(a){return A().then(function(){if(a.m)throw new N("app-deleted");})}function Qk(a){return Da(a.providerData,function(a){return a.providerId})}
	function Rk(a,b){b&&(Sk(a,b.providerId),a.providerData.push(b))}function Sk(a,b){Ja(a.providerData,function(a){return a.providerId==b})}function Tk(a,b,c){("uid"!=b||c)&&a.hasOwnProperty(b)&&M(a,b,c)}
	function Uk(a,b){a!=b&&(gg(a,{uid:b.uid,displayName:b.displayName,photoURL:b.photoURL,email:b.email,emailVerified:b.emailVerified,phoneNumber:b.phoneNumber,isAnonymous:b.isAnonymous,providerData:[]}),b.metadata?M(a,"metadata",yk(b.metadata)):M(a,"metadata",new xk),w(b.providerData,function(b){Rk(a,b)}),a.h=b.h,M(a,"refreshToken",a.h.a))}h=Bk.prototype;h.reload=function(){var a=this;return R(this,Pk(this).then(function(){return Vk(a).then(function(){return Mk(a)}).then(Ok)}))};
	function Vk(a){return a.F().then(function(b){var c=a.isAnonymous;return Wk(a,b).then(function(){c||Tk(a,"isAnonymous",!1);return b})})}h.F=function(a){var b=this;return R(this,Pk(this).then(function(){return b.h.getToken(a)}).then(function(a){if(!a)throw new N("internal-error");a.accessToken!=b.pa&&(Ck(b,a.accessToken),G(b,new Ak("tokenChanged")));Tk(b,"refreshToken",a.refreshToken);return a.accessToken}))};
	h.getToken=function(a){dg["firebase.User.prototype.getToken is deprecated. Please use firebase.User.prototype.getIdToken instead."]||(dg["firebase.User.prototype.getToken is deprecated. Please use firebase.User.prototype.getIdToken instead."]=!0,"undefined"!==typeof console&&"function"===typeof console.warn&&console.warn("firebase.User.prototype.getToken is deprecated. Please use firebase.User.prototype.getIdToken instead."));return this.F(a)};
	function Xk(a,b){b[O]&&a.pa!=b[O]&&(uk(a.h,b),G(a,new Ak("tokenChanged")),Ck(a,b[O]),Tk(a,"refreshToken",a.h.a))}function Wk(a,b){return Q(a.c,ti,{idToken:b}).then(r(a.kc,a))}
	h.kc=function(a){a=a.users;if(!a||!a.length)throw new N("internal-error");a=a[0];Dk(this,{uid:a.localId,displayName:a.displayName,photoURL:a.photoUrl,email:a.email,emailVerified:!!a.emailVerified,phoneNumber:a.phoneNumber,lastLoginAt:a.lastLoginAt,createdAt:a.createdAt});for(var b=Yk(a),c=0;c<b.length;c++)Rk(this,b[c]);Tk(this,"isAnonymous",!(this.email&&a.passwordHash)&&!(this.providerData&&this.providerData.length))};
	function Yk(a){return(a=a.providerUserInfo)&&a.length?Da(a,function(a){return new zk(a.rawId,a.providerId,a.email,a.displayName,a.photoUrl,a.phoneNumber)}):[]}h.Za=function(a){var b=this,c=null;return R(this,a.c(this.c,this.uid).then(function(a){Xk(b,a);c=Zk(b,a,"reauthenticate");b.i=null;return b.reload()}).then(function(){return c}),!0)};h.mc=function(a){return this.Za(a).then(function(){})};
	function $k(a,b){return Vk(a).then(function(){if(Ha(Qk(a),b))return Mk(a).then(function(){throw new N("provider-already-linked");})})}h.Xa=function(a){var b=this,c=null;return R(this,$k(this,a.providerId).then(function(){return b.F()}).then(function(c){return a.b(b.c,c)}).then(function(a){c=Zk(b,a,"link");return al(b,a)}).then(function(){return c}))};h.cc=function(a){return this.Xa(a).then(function(a){return a.user})};
	h.dc=function(a,b){var c=this;return R(this,$k(this,"phone").then(function(){return ok(Ik(c),a,b,r(c.Xa,c))}))};h.nc=function(a,b){var c=this;return R(this,A().then(function(){return ok(Ik(c),a,b,r(c.Za,c))}),!0)};function Zk(a,b,c){var d=uh(b);b=Mg(b);return hg({user:a,credential:d,additionalUserInfo:b,operationType:c})}function al(a,b){Xk(a,b);return a.reload().then(function(){return a})}
	h.kb=function(a){var b=this;return R(this,this.F().then(function(c){return b.c.kb(c,a)}).then(function(a){Xk(b,a);return b.reload()}))};h.Dc=function(a){var b=this;return R(this,this.F().then(function(c){return a.b(b.c,c)}).then(function(a){Xk(b,a);return b.reload()}))};h.lb=function(a){var b=this;return R(this,this.F().then(function(c){return b.c.lb(c,a)}).then(function(a){Xk(b,a);return b.reload()}))};
	h.mb=function(a){if(void 0===a.displayName&&void 0===a.photoURL)return Pk(this);var b=this;return R(this,this.F().then(function(c){return b.c.mb(c,{displayName:a.displayName,photoUrl:a.photoURL})}).then(function(a){Xk(b,a);Tk(b,"displayName",a.displayName||null);Tk(b,"photoURL",a.photoUrl||null);w(b.providerData,function(a){"password"===a.providerId&&(M(a,"displayName",b.displayName),M(a,"photoURL",b.photoURL))});return Mk(b)}).then(Ok))};
	h.Cc=function(a){var b=this;return R(this,Vk(this).then(function(c){return Ha(Qk(b),a)?fi(b.c,c,[a]).then(function(a){var c={};w(a.providerUserInfo||[],function(a){c[a.providerId]=!0});w(Qk(b),function(a){c[a]||Sk(b,a)});c[rh.PROVIDER_ID]||M(b,"phoneNumber",null);return Mk(b)}):Mk(b).then(function(){throw new N("no-such-provider");})}))};
	h.delete=function(){var a=this;return R(this,this.F().then(function(b){return Q(a.c,si,{idToken:b})}).then(function(){G(a,new Ak("userDeleted"))})).then(function(){for(var b=0;b<a.A.length;b++)a.A[b].cancel("app-deleted");Gk(a,null);Hk(a,null);a.A=[];a.m=!0;Kk(a);M(a,"refreshToken",null);a.a&&a.a.unsubscribe(a)})};
	h.ob=function(a,b){return"linkViaPopup"==a&&(this.g||null)==b&&this.f||"reauthViaPopup"==a&&(this.g||null)==b&&this.f||"linkViaRedirect"==a&&(this.Z||null)==b||"reauthViaRedirect"==a&&(this.Z||null)==b?!0:!1};h.fa=function(a,b,c,d){"linkViaPopup"!=a&&"reauthViaPopup"!=a||d!=(this.g||null)||(c&&this.v?this.v(c):b&&!c&&this.f&&this.f(b),this.b&&(this.b.cancel(),this.b=null),delete this.f,delete this.v)};
	h.va=function(a,b){return"linkViaPopup"==a&&b==(this.g||null)?r(this.tb,this):"reauthViaPopup"==a&&b==(this.g||null)?r(this.ub,this):"linkViaRedirect"==a&&(this.Z||null)==b?r(this.tb,this):"reauthViaRedirect"==a&&(this.Z||null)==b?r(this.ub,this):null};h.ec=function(a){var b=this;return bl(this,"linkViaPopup",a,function(){return $k(b,a.providerId).then(function(){return Mk(b)})},!1)};h.oc=function(a){return bl(this,"reauthViaPopup",a,function(){return A()},!0)};
	function bl(a,b,c,d,e){if(!Rf())return B(new N("operation-not-supported-in-this-environment"));if(a.i&&!e)return B(a.i);var f=Lg(c.providerId),g=Qf(a.uid+":::"),l=null;(!Tf()||Lf())&&a.w&&c.isOAuthProvider&&(l=Ri(a.w,a.G,a.o,b,c,null,g,firebase.SDK_VERSION||null));var n=Df(l,f&&f.za,f&&f.ya);d=d().then(function(){cl(a);if(!e)return a.F().then(function(){})}).then(function(){return ek(a.a,n,b,c,g,!!l)}).then(function(){return new z(function(c,d){a.fa(b,null,new N("cancelled-popup-request"),a.g||null);
	a.f=c;a.v=d;a.g=g;a.b=a.a.Ca(a,b,n,g)})}).then(function(a){n&&Cf(n);return a?hg(a):null}).s(function(a){n&&Cf(n);throw a;});return R(a,d,e)}h.fc=function(a){var b=this;return dl(this,"linkViaRedirect",a,function(){return $k(b,a.providerId)},!1)};h.pc=function(a){return dl(this,"reauthViaRedirect",a,function(){return A()},!0)};
	function dl(a,b,c,d,e){if(!Rf())return B(new N("operation-not-supported-in-this-environment"));if(a.i&&!e)return B(a.i);var f=null,g=Qf(a.uid+":::");d=d().then(function(){cl(a);if(!e)return a.F().then(function(){})}).then(function(){a.Z=g;return Mk(a)}).then(function(b){a.ca&&(b=a.ca,b=b.b.set(el,a.B(),b.a));return b}).then(function(){return a.a.Aa(b,c,g)}).s(function(b){f=b;if(a.ca)return fl(a.ca);throw f;}).then(function(){if(f)throw f;});return R(a,d,e)}
	function cl(a){if(!a.a||!a.I){if(a.a&&!a.I)throw new N("internal-error");throw new N("auth-domain-config-required");}}h.tb=function(a,b){var c=this;this.b&&(this.b.cancel(),this.b=null);var d=null,e=this.F().then(function(d){return Zg(c.c,{requestUri:a,sessionId:b,idToken:d})}).then(function(a){d=Zk(c,a,"link");return al(c,a)}).then(function(){return d});return R(this,e)};
	h.ub=function(a,b){var c=this;this.b&&(this.b.cancel(),this.b=null);var d=null,e=A().then(function(){return Vg($g(c.c,{requestUri:a,sessionId:b}),c.uid)}).then(function(a){d=Zk(c,a,"reauthenticate");Xk(c,a);c.i=null;return c.reload()}).then(function(){return d});return R(this,e,!0)};h.bb=function(a){var b=this,c=null;return R(this,this.F().then(function(b){c=b;return"undefined"===typeof a||Sa(a)?{}:Fg(new wg(a))}).then(function(a){return b.c.bb(c,a)}).then(function(a){if(b.email!=a)return b.reload()}).then(function(){}))};
	function R(a,b,c){var d=gl(a,b,c);a.A.push(d);Qb(d,function(){Ia(a.A,d)});return d}function gl(a,b,c){return a.i&&!c?(b.cancel(),B(a.i)):b.s(function(b){!b||"auth/user-disabled"!=b.code&&"auth/user-token-expired"!=b.code||(a.i||G(a,new Ak("userInvalidated")),a.i=b);throw b;})}h.toJSON=function(){return this.B()};
	h.B=function(){var a={uid:this.uid,displayName:this.displayName,photoURL:this.photoURL,email:this.email,emailVerified:this.emailVerified,phoneNumber:this.phoneNumber,isAnonymous:this.isAnonymous,providerData:[],apiKey:this.G,appName:this.o,authDomain:this.w,stsTokenManager:this.h.B(),redirectEventId:this.Z||null};this.metadata&&Wa(a,this.metadata.B());w(this.providerData,function(b){a.providerData.push(ig(b))});return a};
	function hl(a){if(!a.apiKey)return null;var b={apiKey:a.apiKey,authDomain:a.authDomain,appName:a.appName},c={};if(a.stsTokenManager&&a.stsTokenManager.accessToken&&a.stsTokenManager.expirationTime)c[O]=a.stsTokenManager.accessToken,c.refreshToken=a.stsTokenManager.refreshToken||null,c.expiresIn=(a.stsTokenManager.expirationTime-na())/1E3;else return null;var d=new Bk(b,c,a);a.providerData&&w(a.providerData,function(a){a&&Rk(d,hg(a))});a.redirectEventId&&(d.Z=a.redirectEventId);return d}
	function il(a,b,c,d){var e=new Bk(a,b);c&&(e.ca=c);d&&Fk(e,d);return e.reload().then(function(){return e})};function jl(a){this.a=a;this.b=rj()}var el={name:"redirectUser",C:"session"};function fl(a){return uj(a.b,el,a.a)}function kl(a,b){return a.b.get(el,a.a).then(function(a){a&&b&&(a.authDomain=b);return hl(a||{})})};function ll(a,b){this.a=a;this.b=b||rj();this.c=null;this.f=ml(this);vj(this.b,yj("local"),this.a,r(this.g,this))}ll.prototype.g=function(){var a=this,b=yj("local");nl(this,function(){return A().then(function(){return a.c&&"local"!=a.c.C?a.b.get(b,a.a):null}).then(function(c){if(c)return ol(a,"local").then(function(){a.c=b})})})};function ol(a,b){var c=[],d;for(d in nj)nj[d]!==b&&c.push(uj(a.b,yj(nj[d]),a.a));c.push(uj(a.b,pl,a.a));return Nb(c)}
	function ml(a){var b=yj("local"),c=yj("session"),d=yj("none");return a.b.get(c,a.a).then(function(e){return e?c:a.b.get(d,a.a).then(function(c){return c?d:a.b.get(b,a.a).then(function(c){return c?b:a.b.get(pl,a.a).then(function(a){return a?yj(a):b})})})}).then(function(b){a.c=b;return ol(a,b.C)}).s(function(){a.c||(a.c=b)})}var pl={name:"persistence",C:"session"};function yj(a){return{name:"authUser",C:a}}
	ll.prototype.eb=function(a){var b=null,c=this;oj(a);return nl(this,function(){return a!=c.c.C?c.b.get(c.c,c.a).then(function(d){b=d;return ol(c,a)}).then(function(){c.c=yj(a);if(b)return c.b.set(c.c,b,c.a)}):A()})};function ql(a){return nl(a,function(){return a.b.set(pl,a.c.C,a.a)})}function rl(a,b){return nl(a,function(){return a.b.set(a.c,b.B(),a.a)})}function sl(a){return nl(a,function(){return uj(a.b,a.c,a.a)})}
	function tl(a,b){return nl(a,function(){return a.b.get(a.c,a.a).then(function(a){a&&b&&(a.authDomain=b);return hl(a||{})})})}function nl(a,b){a.f=a.f.then(b,b);return a.f};function ul(a){this.l=!1;M(this,"app",a);if(S(this).options&&S(this).options.apiKey)a=firebase.SDK_VERSION?Of(firebase.SDK_VERSION):null,this.c=new Ch(S(this).options&&S(this).options.apiKey,xi(yi),a);else throw new N("invalid-api-key");this.N=[];this.m=[];this.I=[];this.Kb=firebase.INTERNAL.createSubscribe(r(this.ac,this));this.R=void 0;this.Lb=firebase.INTERNAL.createSubscribe(r(this.bc,this));vl(this,null);this.h=new ll(S(this).options.apiKey+":"+S(this).name);this.G=new jl(S(this).options.apiKey+
	":"+S(this).name);this.U=T(this,wl(this));this.i=T(this,xl(this));this.W=!1;this.ha=r(this.yc,this);this.Ga=r(this.ka,this);this.pa=r(this.Tb,this);this.qa=r(this.Zb,this);this.ra=r(this.$b,this);yl(this);this.INTERNAL={};this.INTERNAL["delete"]=r(this.delete,this);this.INTERNAL.logFramework=r(this.gc,this);this.o=0;F.call(this);zl(this);this.A=[]}t(ul,F);function Al(a){C.call(this,"languageCodeChanged");this.h=a}t(Al,C);function Bl(a){C.call(this,"frameworkChanged");this.f=a}t(Bl,C);h=ul.prototype;
	h.eb=function(a){a=this.h.eb(a);return T(this,a)};h.na=function(a){this.V===a||this.l||(this.V=a,Ih(this.c,this.V),G(this,new Al(this.$())))};h.$=function(){return this.V};h.Ec=function(){var a=k.navigator;this.na(a?a.languages&&a.languages[0]||a.language||a.userLanguage||null:null)};h.gc=function(a){this.A.push(a);Jh(this.c,firebase.SDK_VERSION?Of(firebase.SDK_VERSION,this.A):null);G(this,new Bl(this.A))};h.Ka=function(){return La(this.A)};
	function zl(a){Object.defineProperty(a,"lc",{get:function(){return this.$()},set:function(a){this.na(a)},enumerable:!1});a.V=null}h.toJSON=function(){return{apiKey:S(this).options.apiKey,authDomain:S(this).options.authDomain,appName:S(this).name,currentUser:U(this)&&U(this).B()}};function Cl(a){return a.Jb||B(new N("auth-domain-config-required"))}
	function yl(a){var b=S(a).options.authDomain,c=S(a).options.apiKey;b&&Rf()&&(a.Jb=a.U.then(function(){if(!a.l){a.a=gk(b,c,S(a).name);a.a.subscribe(a);U(a)&&Nk(U(a));if(a.w){Nk(a.w);var d=a.w;d.na(a.$());Gk(d,a);d=a.w;Fk(d,a.A);Hk(d,a);a.w=null}return a.a}}))}h.ob=function(a,b){switch(a){case "unknown":case "signInViaRedirect":return!0;case "signInViaPopup":return this.g==b&&!!this.f;default:return!1}};
	h.fa=function(a,b,c,d){"signInViaPopup"==a&&this.g==d&&(c&&this.v?this.v(c):b&&!c&&this.f&&this.f(b),this.b&&(this.b.cancel(),this.b=null),delete this.f,delete this.v)};h.va=function(a,b){return"signInViaRedirect"==a||"signInViaPopup"==a&&this.g==b&&this.f?r(this.Sb,this):null};
	h.Sb=function(a,b){var c=this;a={requestUri:a,sessionId:b};this.b&&(this.b.cancel(),this.b=null);var d=null,e=null,f=Xg(c.c,a).then(function(a){d=uh(a);e=Mg(a);return a});a=c.U.then(function(){return f}).then(function(a){return Dl(c,a)}).then(function(){return hg({user:U(c),credential:d,additionalUserInfo:e,operationType:"signIn"})});return T(this,a)};
	h.wc=function(a){if(!Rf())return B(new N("operation-not-supported-in-this-environment"));var b=this,c=Lg(a.providerId),d=Qf(),e=null;(!Tf()||Lf())&&S(this).options.authDomain&&a.isOAuthProvider&&(e=Ri(S(this).options.authDomain,S(this).options.apiKey,S(this).name,"signInViaPopup",a,null,d,firebase.SDK_VERSION||null));var f=Df(e,c&&c.za,c&&c.ya);c=Cl(this).then(function(b){return ek(b,f,"signInViaPopup",a,d,!!e)}).then(function(){return new z(function(a,c){b.fa("signInViaPopup",null,new N("cancelled-popup-request"),
	b.g);b.f=a;b.v=c;b.g=d;b.b=b.a.Ca(b,"signInViaPopup",f,d)})}).then(function(a){f&&Cf(f);return a?hg(a):null}).s(function(a){f&&Cf(f);throw a;});return T(this,c)};h.xc=function(a){if(!Rf())return B(new N("operation-not-supported-in-this-environment"));var b=this,c=Cl(this).then(function(){return ql(b.h)}).then(function(){return b.a.Aa("signInViaRedirect",a)});return T(this,c)};
	h.aa=function(){if(!Rf())return B(new N("operation-not-supported-in-this-environment"));var a=this,b=Cl(this).then(function(){return a.a.aa()}).then(function(a){return a?hg(a):null});return T(this,b)};function Dl(a,b){var c={};c.apiKey=S(a).options.apiKey;c.authDomain=S(a).options.authDomain;c.appName=S(a).name;return a.U.then(function(){return il(c,b,a.G,a.Ka())}).then(function(b){if(U(a)&&b.uid==U(a).uid)return Uk(U(a),b),a.ka(b);vl(a,b);Nk(b);return a.ka(b)}).then(function(){El(a)})}
	function vl(a,b){U(a)&&(Lk(U(a),a.Ga),E(U(a),"tokenChanged",a.pa),E(U(a),"userDeleted",a.qa),E(U(a),"userInvalidated",a.ra),Kk(U(a)));b&&(b.N.push(a.Ga),cd(b,"tokenChanged",a.pa),cd(b,"userDeleted",a.qa),cd(b,"userInvalidated",a.ra),0<a.o&&Jk(b));M(a,"currentUser",b);b&&(b.na(a.$()),Gk(b,a),Fk(b,a.A),Hk(b,a))}h.hb=function(){var a=this,b=this.i.then(function(){if(!U(a))return A();vl(a,null);return sl(a.h).then(function(){El(a)})});return T(this,b)};
	function Fl(a){var b=kl(a.G,S(a).options.authDomain).then(function(b){if(a.w=b)b.ca=a.G;return fl(a.G)});return T(a,b)}function wl(a){var b=S(a).options.authDomain,c=Fl(a).then(function(){return tl(a.h,b)}).then(function(b){return b?(b.ca=a.G,a.w&&(a.w.Z||null)==(b.Z||null)?b:b.reload().then(function(){return rl(a.h,b).then(function(){return b})}).s(function(c){return"auth/network-request-failed"==c.code?b:sl(a.h)})):null}).then(function(b){vl(a,b||null)});return T(a,c)}
	function xl(a){return a.U.then(function(){return a.aa()}).s(function(){}).then(function(){if(!a.l)return a.ha()}).s(function(){}).then(function(){if(!a.l){a.W=!0;var b=a.h;vj(b.b,yj("local"),b.a,a.ha)}})}
	h.yc=function(){var a=this;return tl(this.h,S(this).options.authDomain).then(function(b){if(!a.l){var c;if(c=U(a)&&b){c=U(a).uid;var d=b.uid;c=void 0===c||null===c||""===c||void 0===d||null===d||""===d?!1:c==d}if(c)return Uk(U(a),b),U(a).F();if(U(a)||b)vl(a,b),b&&(Nk(b),b.ca=a.G),a.a&&a.a.subscribe(a),El(a)}})};h.ka=function(a){return rl(this.h,a)};h.Tb=function(){El(this);this.ka(U(this))};h.Zb=function(){this.hb()};h.$b=function(){this.hb()};
	function Gl(a,b){var c=null,d=null;return T(a,b.then(function(b){c=uh(b);d=Mg(b);return Dl(a,b)}).then(function(){return hg({user:U(a),credential:c,additionalUserInfo:d,operationType:"signIn"})}))}h.ac=function(a){var b=this;this.addAuthTokenListener(function(){a.next(U(b))})};h.bc=function(a){var b=this;Hl(this,function(){a.next(U(b))})};h.ic=function(a,b,c){var d=this;this.W&&firebase.Promise.resolve().then(function(){p(a)?a(U(d)):p(a.next)&&a.next(U(d))});return this.Kb(a,b,c)};
	h.hc=function(a,b,c){var d=this;this.W&&firebase.Promise.resolve().then(function(){d.R=d.getUid();p(a)?a(U(d)):p(a.next)&&a.next(U(d))});return this.Lb(a,b,c)};h.Vb=function(a){var b=this,c=this.i.then(function(){return U(b)?U(b).F(a).then(function(a){return{accessToken:a}}):null});return T(this,c)};h.tc=function(a){return this.Eb(a).then(function(a){return a.user})};
	h.Eb=function(a){var b=this;return this.i.then(function(){return Gl(b,Q(b.c,vi,{token:a}))}).then(function(a){var c=a.user;Tk(c,"isAnonymous",!1);b.ka(c);return a})};h.Fb=function(a,b){var c=this;return this.i.then(function(){return Gl(c,Q(c.c,kh,{email:a,password:b}))})};h.uc=function(a,b){return this.Fb(a,b).then(function(a){return a.user})};h.Ob=function(a,b){return this.qb(a,b).then(function(a){return a.user})};
	h.qb=function(a,b){var c=this;return this.i.then(function(){return Gl(c,Q(c.c,ri,{email:a,password:b}))})};h.sc=function(a){return this.fb(a).then(function(a){return a.user})};h.fb=function(a){var b=this;return this.i.then(function(){return Gl(b,a.wa(b.c))})};h.gb=function(){return this.Gb().then(function(a){return a.user})};
	h.Gb=function(){var a=this;return this.i.then(function(){var b=U(a);if(b&&b.isAnonymous){var c=hg({providerId:null,isNewUser:!1});return hg({user:b,credential:null,additionalUserInfo:c,operationType:"signIn"})}return Gl(a,a.c.gb()).then(function(b){var c=b.user;Tk(c,"isAnonymous",!0);a.ka(c);return b})})};function S(a){return a.app}function U(a){return a.currentUser}h.getUid=function(){return U(this)&&U(this).uid||null};function Il(a){return U(a)&&U(a)._lat||null}
	function El(a){if(a.W){for(var b=0;b<a.m.length;b++)if(a.m[b])a.m[b](Il(a));if(a.R!==a.getUid()&&a.I.length)for(a.R=a.getUid(),b=0;b<a.I.length;b++)if(a.I[b])a.I[b](Il(a))}}h.Mb=function(a){this.addAuthTokenListener(a);this.o++;0<this.o&&U(this)&&Jk(U(this))};h.qc=function(a){var b=this;w(this.m,function(c){c==a&&b.o--});0>this.o&&(this.o=0);0==this.o&&U(this)&&Kk(U(this));this.removeAuthTokenListener(a)};
	h.addAuthTokenListener=function(a){var b=this;this.m.push(a);T(this,this.i.then(function(){b.l||Ha(b.m,a)&&a(Il(b))}))};h.removeAuthTokenListener=function(a){Ja(this.m,function(b){return b==a})};function Hl(a,b){a.I.push(b);T(a,a.i.then(function(){!a.l&&Ha(a.I,b)&&a.R!==a.getUid()&&(a.R=a.getUid(),b(Il(a)))}))}h.delete=function(){this.l=!0;for(var a=0;a<this.N.length;a++)this.N[a].cancel("app-deleted");this.N=[];this.h&&(a=this.h,xj(a.b,a.a,this.ha));this.a&&this.a.unsubscribe(this);return firebase.Promise.resolve()};
	function T(a,b){a.N.push(b);Qb(b,function(){Ia(a.N,b)});return b}h.Rb=function(a){return T(this,Th(this.c,a))};h.Fc=function(a){return this.Ia(a).then(function(a){return a.data.email})};h.Ta=function(a,b){return T(this,this.c.Ta(a,b).then(function(){}))};h.Ia=function(a){return T(this,this.c.Ia(a).then(function(a){return new lg(a)}))};h.Sa=function(a){return T(this,this.c.Sa(a).then(function(){}))};
	h.cb=function(a,b){var c=this;return T(this,A().then(function(){return"undefined"===typeof b||Sa(b)?{}:Fg(new wg(b))}).then(function(b){return c.c.cb(a,b)}).then(function(){}))};h.vc=function(a,b){return T(this,ok(this,a,b,r(this.fb,this)))};function Jl(a,b,c,d){a:{c=Array.prototype.slice.call(c);var e=0;for(var f=!1,g=0;g<b.length;g++)if(b[g].optional)f=!0;else{if(f)throw new N("internal-error","Argument validator encountered a required argument after an optional argument.");e++}f=b.length;if(c.length<e||f<c.length)d="Expected "+(e==f?1==e?"1 argument":e+" arguments":e+"-"+f+" arguments")+" but got "+c.length+".";else{for(e=0;e<c.length;e++)if(f=b[e].optional&&void 0===c[e],!b[e].M(c[e])&&!f){b=b[e];if(0>e||e>=Kl.length)throw new N("internal-error",
	"Argument validator received an unsupported number of arguments.");c=Kl[e];d=(d?"":c+" argument ")+(b.name?'"'+b.name+'" ':"")+"must be "+b.K+".";break a}d=null}}if(d)throw new N("argument-error",a+" failed: "+d);}var Kl="First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" ");function V(a,b){return{name:a||"",K:"a valid string",optional:!!b,M:m}}function Ll(){return{name:"opt_forceRefresh",K:"a boolean",optional:!0,M:ba}}
	function W(a,b){return{name:a||"",K:"a valid object",optional:!!b,M:q}}function Ml(a,b){return{name:a||"",K:"a function",optional:!!b,M:p}}function Nl(a,b){return{name:a||"",K:"null",optional:!!b,M:ea}}function Ol(){return{name:"",K:"an HTML element",optional:!1,M:function(a){return!!(a&&a instanceof Element)}}}function Pl(){return{name:"auth",K:"an instance of Firebase Auth",optional:!0,M:function(a){return!!(a&&a instanceof ul)}}}
	function Ql(){return{name:"app",K:"an instance of Firebase App",optional:!0,M:function(a){return!!(a&&a instanceof firebase.app.App)}}}function Rl(a){return{name:a?a+"Credential":"credential",K:a?"a valid "+a+" credential":"a valid credential",optional:!1,M:function(b){if(!b)return!1;var c=!a||b.providerId===a;return!(!b.wa||!c)}}}
	function Sl(){return{name:"authProvider",K:"a valid Auth provider",optional:!1,M:function(a){return!!(a&&a.providerId&&a.hasOwnProperty&&a.hasOwnProperty("isOAuthProvider"))}}}function Tl(){return{name:"applicationVerifier",K:"an implementation of firebase.auth.ApplicationVerifier",optional:!1,M:function(a){return!!(a&&m(a.type)&&p(a.verify))}}}function X(a,b,c,d){return{name:c||"",K:a.K+" or "+b.K,optional:!!d,M:function(c){return a.M(c)||b.M(c)}}};function Ul(a,b,c,d,e,f){M(this,"type","recaptcha");this.b=this.c=null;this.m=!1;this.l=b;this.a=c||{theme:"light",type:"image"};this.g=[];if(this.a[Vl])throw new N("argument-error","sitekey should not be provided for reCAPTCHA as one is automatically provisioned for the current project.");this.h="invisible"===this.a[Wl];if(!wc(b)||!this.h&&wc(b).hasChildNodes())throw new N("argument-error","reCAPTCHA container is either not found or already contains inner elements!");this.u=new Ch(a,f||null,e||null);
	this.o=d||function(){return null};var g=this;this.i=[];var l=this.a[Xl];this.a[Xl]=function(a){Yl(g,a);if("function"===typeof l)l(a);else if("string"===typeof l){var b=L(l,k);"function"===typeof b&&b(a)}};var n=this.a[Zl];this.a[Zl]=function(){Yl(g,null);if("function"===typeof n)n();else if("string"===typeof n){var a=L(n,k);"function"===typeof a&&a()}}}var Xl="callback",Zl="expired-callback",Vl="sitekey",Wl="size";function Yl(a,b){for(var c=0;c<a.i.length;c++)try{a.i[c](b)}catch(d){}}
	function $l(a,b){Ja(a.i,function(a){return a==b})}function am(a,b){a.g.push(b);Qb(b,function(){Ia(a.g,b)});return b}h=Ul.prototype;
	h.xa=function(){var a=this;return this.c?this.c:this.c=am(this,A().then(function(){if(Sf())return Hf();throw new N("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment.");}).then(function(){return bm(cm(),a.o())}).then(function(){return Q(a.u,ui,{})}).then(function(b){a.a[Vl]=b.recaptchaSiteKey}).s(function(b){a.c=null;throw b;}))};
	h.render=function(){dm(this);var a=this;return am(this,this.xa().then(function(){if(null===a.b){var b=a.l;if(!a.h){var c=wc(b);b=zc("DIV");c.appendChild(b)}a.b=grecaptcha.render(b,a.a)}return a.b}))};h.verify=function(){dm(this);var a=this;return am(this,this.render().then(function(b){return new z(function(c){var d=grecaptcha.getResponse(b);if(d)c(d);else{var e=function(b){b&&($l(a,e),c(b))};a.i.push(e);a.h&&grecaptcha.execute(a.b)}})}))};h.reset=function(){dm(this);null!==this.b&&grecaptcha.reset(this.b)};
	function dm(a){if(a.m)throw new N("internal-error","RecaptchaVerifier instance has been destroyed.");}h.clear=function(){dm(this);this.m=!0;cm().b--;for(var a=0;a<this.g.length;a++)this.g[a].cancel("RecaptchaVerifier instance has been destroyed.");if(!this.h){a=wc(this.l);for(var b;b=a.firstChild;)a.removeChild(b)}};var em=dc("https://www.google.com/recaptcha/api.js?onload=%{onload}&render=explicit&hl=%{hl}");
	function fm(){this.b=k.grecaptcha?Infinity:0;this.c=null;this.a="__rcb"+Math.floor(1E6*Math.random()).toString()}
	function bm(a,b){return new z(function(c,d){if(Zf())if(!k.grecaptcha||b!==a.c&&!a.b){k[a.a]=function(){if(k.grecaptcha){a.c=b;var e=k.grecaptcha.render;k.grecaptcha.render=function(b,c){b=e(b,c);a.b++;return b};c()}else d(new N("internal-error"));delete k[a.a]};var e=hc(em,{onload:a.a,hl:b||""});A(kf(e)).s(function(){d(new N("internal-error","Unable to load external reCAPTCHA dependencies!"))})}else c();else d(new N("network-request-failed"))})}var gm=null;
	function cm(){gm||(gm=new fm);return gm}function hm(a,b,c){try{this.f=c||firebase.app()}catch(f){throw new N("argument-error","No firebase.app.App instance is currently initialized.");}if(this.f.options&&this.f.options.apiKey)c=this.f.options.apiKey;else throw new N("invalid-api-key");var d=this,e=null;try{e=this.f.auth().Ka()}catch(f){}e=firebase.SDK_VERSION?Of(firebase.SDK_VERSION,e):null;Ul.call(this,c,a,b,function(){try{var a=d.f.auth().$()}catch(g){a=null}return a},e,xi(yi))}t(hm,Ul);function Y(a,b){for(var c in b){var d=b[c].name;a[d]=im(d,a[c],b[c].j)}}function Z(a,b,c,d){a[b]=im(b,c,d)}function im(a,b,c){function d(){var a=Array.prototype.slice.call(arguments);Jl(e,c,a);return b.apply(this,a)}if(!c)return b;var e=jm(a),f;for(f in b)d[f]=b[f];for(f in b.prototype)d.prototype[f]=b.prototype[f];return d}function jm(a){a=a.split(".");return a[a.length-1]};Y(ul.prototype,{Sa:{name:"applyActionCode",j:[V("code")]},Ia:{name:"checkActionCode",j:[V("code")]},Ta:{name:"confirmPasswordReset",j:[V("code"),V("newPassword")]},Ob:{name:"createUserWithEmailAndPassword",j:[V("email"),V("password")]},qb:{name:"createUserAndRetrieveDataWithEmailAndPassword",j:[V("email"),V("password")]},Rb:{name:"fetchProvidersForEmail",j:[V("email")]},aa:{name:"getRedirectResult",j:[]},hc:{name:"onAuthStateChanged",j:[X(W(),Ml(),"nextOrObserver"),Ml("opt_error",!0),Ml("opt_completed",
	!0)]},ic:{name:"onIdTokenChanged",j:[X(W(),Ml(),"nextOrObserver"),Ml("opt_error",!0),Ml("opt_completed",!0)]},cb:{name:"sendPasswordResetEmail",j:[V("email"),X(W("opt_actionCodeSettings",!0),Nl(null,!0),"opt_actionCodeSettings",!0)]},eb:{name:"setPersistence",j:[V("persistence")]},fb:{name:"signInAndRetrieveDataWithCredential",j:[Rl()]},gb:{name:"signInAnonymously",j:[]},Gb:{name:"signInAnonymouslyAndRetrieveData",j:[]},sc:{name:"signInWithCredential",j:[Rl()]},tc:{name:"signInWithCustomToken",j:[V("token")]},
	Eb:{name:"signInAndRetrieveDataWithCustomToken",j:[V("token")]},uc:{name:"signInWithEmailAndPassword",j:[V("email"),V("password")]},Fb:{name:"signInAndRetrieveDataWithEmailAndPassword",j:[V("email"),V("password")]},vc:{name:"signInWithPhoneNumber",j:[V("phoneNumber"),Tl()]},wc:{name:"signInWithPopup",j:[Sl()]},xc:{name:"signInWithRedirect",j:[Sl()]},hb:{name:"signOut",j:[]},toJSON:{name:"toJSON",j:[V(null,!0)]},Ec:{name:"useDeviceLanguage",j:[]},Fc:{name:"verifyPasswordResetCode",j:[V("code")]}});
	(function(a,b){for(var c in b){var d=b[c].name;if(d!==c){var e=b[c].Nb;Object.defineProperty(a,d,{get:function(){return this[c]},set:function(a){Jl(d,[e],[a],!0);this[c]=a},enumerable:!0})}}})(ul.prototype,{lc:{name:"languageCode",Nb:X(V(),Nl(),"languageCode")}});ul.Persistence=nj;ul.Persistence.LOCAL="local";ul.Persistence.SESSION="session";ul.Persistence.NONE="none";
	Y(Bk.prototype,{"delete":{name:"delete",j:[]},F:{name:"getIdToken",j:[Ll()]},getToken:{name:"getToken",j:[Ll()]},Xa:{name:"linkAndRetrieveDataWithCredential",j:[Rl()]},cc:{name:"linkWithCredential",j:[Rl()]},dc:{name:"linkWithPhoneNumber",j:[V("phoneNumber"),Tl()]},ec:{name:"linkWithPopup",j:[Sl()]},fc:{name:"linkWithRedirect",j:[Sl()]},Za:{name:"reauthenticateAndRetrieveDataWithCredential",j:[Rl()]},mc:{name:"reauthenticateWithCredential",j:[Rl()]},nc:{name:"reauthenticateWithPhoneNumber",j:[V("phoneNumber"),
	Tl()]},oc:{name:"reauthenticateWithPopup",j:[Sl()]},pc:{name:"reauthenticateWithRedirect",j:[Sl()]},reload:{name:"reload",j:[]},bb:{name:"sendEmailVerification",j:[X(W("opt_actionCodeSettings",!0),Nl(null,!0),"opt_actionCodeSettings",!0)]},toJSON:{name:"toJSON",j:[V(null,!0)]},Cc:{name:"unlink",j:[V("provider")]},kb:{name:"updateEmail",j:[V("email")]},lb:{name:"updatePassword",j:[V("password")]},Dc:{name:"updatePhoneNumber",j:[Rl("phone")]},mb:{name:"updateProfile",j:[W("profile")]}});
	Y(z.prototype,{s:{name:"catch"},then:{name:"then"}});Y(nk.prototype,{confirm:{name:"confirm",j:[V("verificationCode")]}});Z(mh,"credential",function(a,b){return new jh(a,b)},[V("email"),V("password")]);Y(bh.prototype,{sa:{name:"addScope",j:[V("scope")]},Ba:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(bh,"credential",ch,[X(V(),W(),"token")]);Y(dh.prototype,{sa:{name:"addScope",j:[V("scope")]},Ba:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});
	Z(dh,"credential",eh,[X(V(),W(),"token")]);Y(fh.prototype,{sa:{name:"addScope",j:[V("scope")]},Ba:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(fh,"credential",gh,[X(V(),X(W(),Nl()),"idToken"),X(V(),Nl(),"accessToken",!0)]);Y(hh.prototype,{Ba:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(hh,"credential",ih,[X(V(),W(),"token"),V("secret",!0)]);
	Y(P.prototype,{sa:{name:"addScope",j:[V("scope")]},credential:{name:"credential",j:[X(V(),Nl(),"idToken",!0),X(V(),Nl(),"accessToken",!0)]},Ba:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(rh,"credential",th,[V("verificationId"),V("verificationCode")]);Y(rh.prototype,{Qa:{name:"verifyPhoneNumber",j:[V("phoneNumber"),Tl()]}});Y(N.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(zh.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});
	Y(yh.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(hm.prototype,{clear:{name:"clear",j:[]},render:{name:"render",j:[]},verify:{name:"verify",j:[]}});
	(function(){if("undefined"!==typeof firebase&&firebase.INTERNAL&&firebase.INTERNAL.registerService){var a={Auth:ul,Error:N};Z(a,"EmailAuthProvider",mh,[]);Z(a,"FacebookAuthProvider",bh,[]);Z(a,"GithubAuthProvider",dh,[]);Z(a,"GoogleAuthProvider",fh,[]);Z(a,"TwitterAuthProvider",hh,[]);Z(a,"OAuthProvider",P,[V("providerId")]);Z(a,"PhoneAuthProvider",rh,[Pl()]);Z(a,"RecaptchaVerifier",hm,[X(V(),Ol(),"recaptchaContainer"),W("recaptchaParameters",!0),Ql()]);firebase.INTERNAL.registerService("auth",function(a,
	c){a=new ul(a);c({INTERNAL:{getUid:r(a.getUid,a),getToken:r(a.Vb,a),addAuthTokenListener:r(a.Mb,a),removeAuthTokenListener:r(a.qc,a)}});return a},a,function(a,c){if("create"===a)try{c.auth()}catch(d){}});firebase.INTERNAL.extendNamespace({User:Bk})}else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");})();
	}).call(typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var app_1 = __webpack_require__(35);
	var Database_1 = __webpack_require__(164);
	exports.Database = Database_1.Database;
	var Query_1 = __webpack_require__(165);
	exports.Query = Query_1.Query;
	var Reference_1 = __webpack_require__(116);
	exports.Reference = Reference_1.Reference;
	var util_1 = __webpack_require__(13);
	exports.enableLogging = util_1.enableLogging;
	var RepoManager_1 = __webpack_require__(117);
	var INTERNAL = __webpack_require__(421);
	var TEST_ACCESS = __webpack_require__(422);
	var util_2 = __webpack_require__(2);
	var ServerValue = Database_1.Database.ServerValue;
	exports.ServerValue = ServerValue;
	function registerDatabase(instance) {
	    // Register the Database Service with the 'firebase' namespace.
	    var namespace = instance.INTERNAL.registerService('database', function (app, unused, url) { return RepoManager_1.RepoManager.getInstance().databaseFromApp(app, url); }, 
	    // firebase.database namespace properties
	    {
	        Reference: Reference_1.Reference,
	        Query: Query_1.Query,
	        Database: Database_1.Database,
	        enableLogging: util_1.enableLogging,
	        INTERNAL: INTERNAL,
	        ServerValue: ServerValue,
	        TEST_ACCESS: TEST_ACCESS
	    }, null, true);
	    if (util_2.isNodeSdk()) {
	        module.exports = namespace;
	    }
	}
	exports.registerDatabase = registerDatabase;
	registerDatabase(app_1.default);
	var DataSnapshot_1 = __webpack_require__(115);
	exports.DataSnapshot = DataSnapshot_1.DataSnapshot;
	var onDisconnect_1 = __webpack_require__(166);
	exports.OnDisconnect = onDisconnect_1.OnDisconnect;
	
	//# sourceMappingURL=index.js.map


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var TransactionResult = /** @class */ (function () {
	    /**
	     * A type for the resolve value of Firebase.transaction.
	     * @constructor
	     * @dict
	     * @param {boolean} committed
	     * @param {DataSnapshot} snapshot
	     */
	    function TransactionResult(committed, snapshot) {
	        this.committed = committed;
	        this.snapshot = snapshot;
	    }
	    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
	    // for end-users
	    TransactionResult.prototype.toJSON = function () {
	        util_1.validateArgCount('TransactionResult.toJSON', 0, 1, arguments.length);
	        return { committed: this.committed, snapshot: this.snapshot.toJSON() };
	    };
	    return TransactionResult;
	}());
	exports.TransactionResult = TransactionResult;
	
	//# sourceMappingURL=TransactionResult.js.map


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var WebSocketConnection_1 = __webpack_require__(188);
	var BrowserPollConnection_1 = __webpack_require__(186);
	/**
	 * INTERNAL methods for internal-use only (tests, etc.).
	 *
	 * Customers shouldn't use these or else should be aware that they could break at any time.
	 *
	 * @const
	 */
	exports.forceLongPolling = function () {
	    WebSocketConnection_1.WebSocketConnection.forceDisallow();
	    BrowserPollConnection_1.BrowserPollConnection.forceAllow();
	};
	exports.forceWebSockets = function () {
	    BrowserPollConnection_1.BrowserPollConnection.forceDisallow();
	};
	/* Used by App Manager */
	exports.isWebSocketsAvailable = function () {
	    return WebSocketConnection_1.WebSocketConnection['isAvailable']();
	};
	exports.setSecurityDebugCallback = function (ref, callback) {
	    ref.repo.persistentConnection_.securityDebugCallback_ = callback;
	};
	exports.stats = function (ref, showDelta) {
	    ref.repo.stats(showDelta);
	};
	exports.statsIncrementCounter = function (ref, metric) {
	    ref.repo.statsIncrementCounter(metric);
	};
	exports.dataUpdateCount = function (ref) {
	    return ref.repo.dataUpdateCount;
	};
	exports.interceptServerData = function (ref, callback) {
	    return ref.repo.interceptServerData_(callback);
	};
	
	//# sourceMappingURL=internal.js.map


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var RepoInfo_1 = __webpack_require__(168);
	var PersistentConnection_1 = __webpack_require__(167);
	var RepoManager_1 = __webpack_require__(117);
	var Connection_1 = __webpack_require__(187);
	exports.DataConnection = PersistentConnection_1.PersistentConnection;
	/**
	 * @param {!string} pathString
	 * @param {function(*)} onComplete
	 */
	PersistentConnection_1.PersistentConnection.prototype.simpleListen = function (pathString, onComplete) {
	    this.sendRequest('q', { p: pathString }, onComplete);
	};
	/**
	 * @param {*} data
	 * @param {function(*)} onEcho
	 */
	PersistentConnection_1.PersistentConnection.prototype.echo = function (data, onEcho) {
	    this.sendRequest('echo', { d: data }, onEcho);
	};
	// RealTimeConnection properties that we use in tests.
	exports.RealTimeConnection = Connection_1.Connection;
	/**
	 * @param {function(): string} newHash
	 * @return {function()}
	 */
	exports.hijackHash = function (newHash) {
	    var oldPut = PersistentConnection_1.PersistentConnection.prototype.put;
	    PersistentConnection_1.PersistentConnection.prototype.put = function (pathString, data, opt_onComplete, opt_hash) {
	        if (opt_hash !== undefined) {
	            opt_hash = newHash();
	        }
	        oldPut.call(this, pathString, data, opt_onComplete, opt_hash);
	    };
	    return function () {
	        PersistentConnection_1.PersistentConnection.prototype.put = oldPut;
	    };
	};
	/**
	 * @type {function(new:RepoInfo, !string, boolean, !string, boolean): undefined}
	 */
	exports.ConnectionTarget = RepoInfo_1.RepoInfo;
	/**
	 * @param {!Query} query
	 * @return {!string}
	 */
	exports.queryIdentifier = function (query) {
	    return query.queryIdentifier();
	};
	/**
	 * @param {!Query} firebaseRef
	 * @return {!Object}
	 */
	exports.listens = function (firebaseRef) {
	    return firebaseRef.repo.persistentConnection_.listens_;
	};
	/**
	 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
	 *
	 * @param {boolean} forceRestClient
	 */
	exports.forceRestClient = function (forceRestClient) {
	    RepoManager_1.RepoManager.getInstance().forceRestClient(forceRestClient);
	};
	
	//# sourceMappingURL=test_access.js.map


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(13);
	/**
	 * Abstraction around FirebaseApp's token fetching capabilities.
	 */
	var AuthTokenProvider = /** @class */ (function () {
	    /**
	     * @param {!FirebaseApp} app_
	     */
	    function AuthTokenProvider(app_) {
	        this.app_ = app_;
	    }
	    /**
	     * @param {boolean} forceRefresh
	     * @return {!Promise<FirebaseAuthTokenData>}
	     */
	    AuthTokenProvider.prototype.getToken = function (forceRefresh) {
	        return this.app_['INTERNAL']['getToken'](forceRefresh).then(null, 
	        // .catch
	        function (error) {
	            // TODO: Need to figure out all the cases this is raised and whether
	            // this makes sense.
	            if (error && error.code === 'auth/token-not-initialized') {
	                util_1.log('Got auth/token-not-initialized error.  Treating as null token.');
	                return null;
	            }
	            else {
	                return Promise.reject(error);
	            }
	        });
	    };
	    AuthTokenProvider.prototype.addTokenChangeListener = function (listener) {
	        // TODO: We might want to wrap the listener and call it with no args to
	        // avoid a leaky abstraction, but that makes removing the listener harder.
	        this.app_['INTERNAL']['addAuthTokenListener'](listener);
	    };
	    AuthTokenProvider.prototype.removeTokenChangeListener = function (listener) {
	        this.app_['INTERNAL']['removeAuthTokenListener'](listener);
	    };
	    AuthTokenProvider.prototype.notifyForInvalidToken = function () {
	        var errorMessage = 'Provided authentication credentials for the app named "' +
	            this.app_.name +
	            '" are invalid. This usually indicates your app was not ' +
	            'initialized correctly. ';
	        if ('credential' in this.app_.options) {
	            errorMessage +=
	                'Make sure the "credential" property provided to initializeApp() ' +
	                    'is authorized to access the specified "databaseURL" and is from the correct ' +
	                    'project.';
	        }
	        else if ('serviceAccount' in this.app_.options) {
	            errorMessage +=
	                'Make sure the "serviceAccount" property provided to initializeApp() ' +
	                    'is authorized to access the specified "databaseURL" and is from the correct ' +
	                    'project.';
	        }
	        else {
	            errorMessage +=
	                'Make sure the "apiKey" and "databaseURL" properties provided to ' +
	                    'initializeApp() match the values provided for your app at ' +
	                    'https://console.firebase.google.com/.';
	        }
	        util_1.warn(errorMessage);
	    };
	    return AuthTokenProvider;
	}());
	exports.AuthTokenProvider = AuthTokenProvider;
	
	//# sourceMappingURL=AuthTokenProvider.js.map


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ImmutableTree_1 = __webpack_require__(119);
	var Path_1 = __webpack_require__(17);
	var util_1 = __webpack_require__(2);
	var Node_1 = __webpack_require__(30);
	var PriorityIndex_1 = __webpack_require__(26);
	var util_2 = __webpack_require__(2);
	/**
	 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
	 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
	 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
	 * to reflect the write added.
	 *
	 * @constructor
	 * @param {!ImmutableTree.<!Node>} writeTree
	 */
	var CompoundWrite = /** @class */ (function () {
	    function CompoundWrite(writeTree_) {
	        this.writeTree_ = writeTree_;
	    }
	    /**
	     * @param {!Path} path
	     * @param {!Node} node
	     * @return {!CompoundWrite}
	     */
	    CompoundWrite.prototype.addWrite = function (path, node) {
	        if (path.isEmpty()) {
	            return new CompoundWrite(new ImmutableTree_1.ImmutableTree(node));
	        }
	        else {
	            var rootmost = this.writeTree_.findRootMostValueAndPath(path);
	            if (rootmost != null) {
	                var rootMostPath = rootmost.path;
	                var value = rootmost.value;
	                var relativePath = Path_1.Path.relativePath(rootMostPath, path);
	                value = value.updateChild(relativePath, node);
	                return new CompoundWrite(this.writeTree_.set(rootMostPath, value));
	            }
	            else {
	                var subtree = new ImmutableTree_1.ImmutableTree(node);
	                var newWriteTree = this.writeTree_.setTree(path, subtree);
	                return new CompoundWrite(newWriteTree);
	            }
	        }
	    };
	    /**
	     * @param {!Path} path
	     * @param {!Object.<string, !Node>} updates
	     * @return {!CompoundWrite}
	     */
	    CompoundWrite.prototype.addWrites = function (path, updates) {
	        var newWrite = this;
	        util_1.forEach(updates, function (childKey, node) {
	            newWrite = newWrite.addWrite(path.child(childKey), node);
	        });
	        return newWrite;
	    };
	    /**
	     * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
	     * location, which must be removed by calling this method with that path.
	     *
	     * @param {!Path} path The path at which a write and all deeper writes should be removed
	     * @return {!CompoundWrite} The new CompoundWrite with the removed path
	     */
	    CompoundWrite.prototype.removeWrite = function (path) {
	        if (path.isEmpty()) {
	            return CompoundWrite.Empty;
	        }
	        else {
	            var newWriteTree = this.writeTree_.setTree(path, ImmutableTree_1.ImmutableTree.Empty);
	            return new CompoundWrite(newWriteTree);
	        }
	    };
	    /**
	     * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
	     * considered "complete".
	     *
	     * @param {!Path} path The path to check for
	     * @return {boolean} Whether there is a complete write at that path
	     */
	    CompoundWrite.prototype.hasCompleteWrite = function (path) {
	        return this.getCompleteNode(path) != null;
	    };
	    /**
	     * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
	     * writes from deeper paths, but will return child nodes from a more shallow path.
	     *
	     * @param {!Path} path The path to get a complete write
	     * @return {?Node} The node if complete at that path, or null otherwise.
	     */
	    CompoundWrite.prototype.getCompleteNode = function (path) {
	        var rootmost = this.writeTree_.findRootMostValueAndPath(path);
	        if (rootmost != null) {
	            return this.writeTree_
	                .get(rootmost.path)
	                .getChild(Path_1.Path.relativePath(rootmost.path, path));
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * Returns all children that are guaranteed to be a complete overwrite.
	     *
	     * @return {!Array.<NamedNode>} A list of all complete children.
	     */
	    CompoundWrite.prototype.getCompleteChildren = function () {
	        var children = [];
	        var node = this.writeTree_.value;
	        if (node != null) {
	            // If it's a leaf node, it has no children; so nothing to do.
	            if (!node.isLeafNode()) {
	                node.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (childName, childNode) {
	                    children.push(new Node_1.NamedNode(childName, childNode));
	                });
	            }
	        }
	        else {
	            this.writeTree_.children.inorderTraversal(function (childName, childTree) {
	                if (childTree.value != null) {
	                    children.push(new Node_1.NamedNode(childName, childTree.value));
	                }
	            });
	        }
	        return children;
	    };
	    /**
	     * @param {!Path} path
	     * @return {!CompoundWrite}
	     */
	    CompoundWrite.prototype.childCompoundWrite = function (path) {
	        if (path.isEmpty()) {
	            return this;
	        }
	        else {
	            var shadowingNode = this.getCompleteNode(path);
	            if (shadowingNode != null) {
	                return new CompoundWrite(new ImmutableTree_1.ImmutableTree(shadowingNode));
	            }
	            else {
	                return new CompoundWrite(this.writeTree_.subtree(path));
	            }
	        }
	    };
	    /**
	     * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
	     * @return {boolean} Whether this CompoundWrite is empty
	     */
	    CompoundWrite.prototype.isEmpty = function () {
	        return this.writeTree_.isEmpty();
	    };
	    /**
	     * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
	     * node
	     * @param {!Node} node The node to apply this CompoundWrite to
	     * @return {!Node} The node with all writes applied
	     */
	    CompoundWrite.prototype.apply = function (node) {
	        return CompoundWrite.applySubtreeWrite_(Path_1.Path.Empty, this.writeTree_, node);
	    };
	    /**
	     * @type {!CompoundWrite}
	     */
	    CompoundWrite.Empty = new CompoundWrite(new ImmutableTree_1.ImmutableTree(null));
	    /**
	     * @param {!Path} relativePath
	     * @param {!ImmutableTree.<!Node>} writeTree
	     * @param {!Node} node
	     * @return {!Node}
	     * @private
	     */
	    CompoundWrite.applySubtreeWrite_ = function (relativePath, writeTree, node) {
	        if (writeTree.value != null) {
	            // Since there a write is always a leaf, we're done here
	            return node.updateChild(relativePath, writeTree.value);
	        }
	        else {
	            var priorityWrite_1 = null;
	            writeTree.children.inorderTraversal(function (childKey, childTree) {
	                if (childKey === '.priority') {
	                    // Apply priorities at the end so we don't update priorities for either empty nodes or forget
	                    // to apply priorities to empty nodes that are later filled
	                    util_2.assert(childTree.value !== null, 'Priority writes must always be leaf nodes');
	                    priorityWrite_1 = childTree.value;
	                }
	                else {
	                    node = CompoundWrite.applySubtreeWrite_(relativePath.child(childKey), childTree, node);
	                }
	            });
	            // If there was a priority write, we only apply it if the node is not empty
	            if (!node.getChild(relativePath).isEmpty() && priorityWrite_1 !== null) {
	                node = node.updateChild(relativePath.child('.priority'), priorityWrite_1);
	            }
	            return node;
	        }
	    };
	    return CompoundWrite;
	}());
	exports.CompoundWrite = CompoundWrite;
	
	//# sourceMappingURL=CompoundWrite.js.map


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var util_2 = __webpack_require__(13);
	var util_3 = __webpack_require__(2);
	var util_4 = __webpack_require__(2);
	var util_5 = __webpack_require__(2);
	var ServerActions_1 = __webpack_require__(169);
	/**
	 * An implementation of ServerActions that communicates with the server via REST requests.
	 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
	 * persistent connection (using WebSockets or long-polling)
	 */
	var ReadonlyRestClient = /** @class */ (function (_super) {
	    __extends(ReadonlyRestClient, _super);
	    /**
	     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
	     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
	     * @param {AuthTokenProvider} authTokenProvider_
	     * @implements {ServerActions}
	     */
	    function ReadonlyRestClient(repoInfo_, onDataUpdate_, authTokenProvider_) {
	        var _this = _super.call(this) || this;
	        _this.repoInfo_ = repoInfo_;
	        _this.onDataUpdate_ = onDataUpdate_;
	        _this.authTokenProvider_ = authTokenProvider_;
	        /** @private {function(...[*])} */
	        _this.log_ = util_2.logWrapper('p:rest:');
	        /**
	         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
	         * that's been removed. :-/
	         *
	         * @private {!Object.<string, !Object>}
	         */
	        _this.listens_ = {};
	        return _this;
	    }
	    ReadonlyRestClient.prototype.reportStats = function (stats) {
	        throw new Error('Method not implemented.');
	    };
	    /**
	     * @param {!Query} query
	     * @param {?number=} tag
	     * @return {string}
	     * @private
	     */
	    ReadonlyRestClient.getListenId_ = function (query, tag) {
	        if (tag !== undefined) {
	            return 'tag$' + tag;
	        }
	        else {
	            util_1.assert(query.getQueryParams().isDefault(), "should have a tag if it's not a default query.");
	            return query.path.toString();
	        }
	    };
	    /** @inheritDoc */
	    ReadonlyRestClient.prototype.listen = function (query, currentHashFn, tag, onComplete) {
	        var _this = this;
	        var pathString = query.path.toString();
	        this.log_('Listen called for ' + pathString + ' ' + query.queryIdentifier());
	        // Mark this listener so we can tell if it's removed.
	        var listenId = ReadonlyRestClient.getListenId_(query, tag);
	        var thisListen = {};
	        this.listens_[listenId] = thisListen;
	        var queryStringParamaters = query
	            .getQueryParams()
	            .toRestQueryStringParameters();
	        this.restRequest_(pathString + '.json', queryStringParamaters, function (error, result) {
	            var data = result;
	            if (error === 404) {
	                data = null;
	                error = null;
	            }
	            if (error === null) {
	                _this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
	            }
	            if (util_4.safeGet(_this.listens_, listenId) === thisListen) {
	                var status_1;
	                if (!error) {
	                    status_1 = 'ok';
	                }
	                else if (error == 401) {
	                    status_1 = 'permission_denied';
	                }
	                else {
	                    status_1 = 'rest_error:' + error;
	                }
	                onComplete(status_1, null);
	            }
	        });
	    };
	    /** @inheritDoc */
	    ReadonlyRestClient.prototype.unlisten = function (query, tag) {
	        var listenId = ReadonlyRestClient.getListenId_(query, tag);
	        delete this.listens_[listenId];
	    };
	    /** @inheritDoc */
	    ReadonlyRestClient.prototype.refreshAuthToken = function (token) {
	        // no-op since we just always call getToken.
	    };
	    /**
	     * Performs a REST request to the given path, with the provided query string parameters,
	     * and any auth credentials we have.
	     *
	     * @param {!string} pathString
	     * @param {!Object.<string, *>} queryStringParameters
	     * @param {?function(?number, *=)} callback
	     * @private
	     */
	    ReadonlyRestClient.prototype.restRequest_ = function (pathString, queryStringParameters, callback) {
	        var _this = this;
	        if (queryStringParameters === void 0) { queryStringParameters = {}; }
	        queryStringParameters['format'] = 'export';
	        this.authTokenProvider_
	            .getToken(/*forceRefresh=*/ false)
	            .then(function (authTokenData) {
	            var authToken = authTokenData && authTokenData.accessToken;
	            if (authToken) {
	                queryStringParameters['auth'] = authToken;
	            }
	            var url = (_this.repoInfo_.secure ? 'https://' : 'http://') +
	                _this.repoInfo_.host +
	                pathString +
	                '?' +
	                util_5.querystring(queryStringParameters);
	            _this.log_('Sending REST request for ' + url);
	            var xhr = new XMLHttpRequest();
	            xhr.onreadystatechange = function () {
	                if (callback && xhr.readyState === 4) {
	                    _this.log_('REST Response for ' + url + ' received. status:', xhr.status, 'response:', xhr.responseText);
	                    var res = null;
	                    if (xhr.status >= 200 && xhr.status < 300) {
	                        try {
	                            res = util_3.jsonEval(xhr.responseText);
	                        }
	                        catch (e) {
	                            util_2.warn('Failed to parse JSON response for ' +
	                                url +
	                                ': ' +
	                                xhr.responseText);
	                        }
	                        callback(null, res);
	                    }
	                    else {
	                        // 401 and 404 are expected.
	                        if (xhr.status !== 401 && xhr.status !== 404) {
	                            util_2.warn('Got unsuccessful REST response for ' +
	                                url +
	                                ' Status: ' +
	                                xhr.status);
	                        }
	                        callback(xhr.status);
	                    }
	                    callback = null;
	                }
	            };
	            xhr.open('GET', url, /*asynchronous=*/ true);
	            xhr.send();
	        });
	    };
	    return ReadonlyRestClient;
	}(ServerActions_1.ServerActions));
	exports.ReadonlyRestClient = ReadonlyRestClient;
	
	//# sourceMappingURL=ReadonlyRestClient.js.map


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var Reference_1 = __webpack_require__(116);
	var DataSnapshot_1 = __webpack_require__(115);
	var Path_1 = __webpack_require__(17);
	var Tree_1 = __webpack_require__(439);
	var PriorityIndex_1 = __webpack_require__(26);
	var util_2 = __webpack_require__(13);
	var ServerValues_1 = __webpack_require__(182);
	var validation_1 = __webpack_require__(48);
	var util_3 = __webpack_require__(2);
	var nodeFromJSON_1 = __webpack_require__(68);
	var ChildrenNode_1 = __webpack_require__(28);
	var Repo_1 = __webpack_require__(86);
	// TODO: This is pretty messy.  Ideally, a lot of this would move into FirebaseData, or a transaction-specific
	// component used by FirebaseData, but it has ties to user callbacks (transaction update and onComplete) as well
	// as the realtime connection (to send transactions to the server).  So that all needs to be decoupled first.
	// For now it's part of Repo, but in its own file.
	/**
	 * @enum {number}
	 */
	var TransactionStatus;
	(function (TransactionStatus) {
	    // We've run the transaction and updated transactionResultData_ with the result, but it isn't currently sent to the
	    // server. A transaction will go from RUN -> SENT -> RUN if it comes back from the server as rejected due to
	    // mismatched hash.
	    TransactionStatus[TransactionStatus["RUN"] = 0] = "RUN";
	    // We've run the transaction and sent it to the server and it's currently outstanding (hasn't come back as accepted
	    // or rejected yet).
	    TransactionStatus[TransactionStatus["SENT"] = 1] = "SENT";
	    // Temporary state used to mark completed transactions (whether successful or aborted).  The transaction will be
	    // removed when we get a chance to prune completed ones.
	    TransactionStatus[TransactionStatus["COMPLETED"] = 2] = "COMPLETED";
	    // Used when an already-sent transaction needs to be aborted (e.g. due to a conflicting set() call that was made).
	    // If it comes back as unsuccessful, we'll abort it.
	    TransactionStatus[TransactionStatus["SENT_NEEDS_ABORT"] = 3] = "SENT_NEEDS_ABORT";
	    // Temporary state used to mark transactions that need to be aborted.
	    TransactionStatus[TransactionStatus["NEEDS_ABORT"] = 4] = "NEEDS_ABORT";
	})(TransactionStatus = exports.TransactionStatus || (exports.TransactionStatus = {}));
	/**
	 * If a transaction does not succeed after 25 retries, we abort it.  Among other things this ensure that if there's
	 * ever a bug causing a mismatch between client / server hashes for some data, we won't retry indefinitely.
	 * @type {number}
	 * @const
	 * @private
	 */
	Repo_1.Repo.MAX_TRANSACTION_RETRIES_ = 25;
	/**
	 * Setup the transaction data structures
	 * @private
	 */
	Repo_1.Repo.prototype.transactions_init_ = function () {
	    /**
	     * Stores queues of outstanding transactions for Firebase locations.
	     *
	     * @type {!Tree.<Array.<!Transaction>>}
	     * @private
	     */
	    this.transactionQueueTree_ = new Tree_1.Tree();
	};
	/**
	 * Creates a new transaction, adds it to the transactions we're tracking, and sends it to the server if possible.
	 *
	 * @param {!Path} path Path at which to do transaction.
	 * @param {function(*):*} transactionUpdate Update callback.
	 * @param {?function(?Error, boolean, ?DataSnapshot)} onComplete Completion callback.
	 * @param {boolean} applyLocally Whether or not to make intermediate results visible
	 */
	Repo_1.Repo.prototype.startTransaction = function (path, transactionUpdate, onComplete, applyLocally) {
	    this.log_('transaction on ' + path);
	    // Add a watch to make sure we get server updates.
	    var valueCallback = function () { };
	    var watchRef = new Reference_1.Reference(this, path);
	    watchRef.on('value', valueCallback);
	    var unwatcher = function () {
	        watchRef.off('value', valueCallback);
	    };
	    // Initialize transaction.
	    var transaction = {
	        path: path,
	        update: transactionUpdate,
	        onComplete: onComplete,
	        // One of TransactionStatus enums.
	        status: null,
	        // Used when combining transactions at different locations to figure out which one goes first.
	        order: util_2.LUIDGenerator(),
	        // Whether to raise local events for this transaction.
	        applyLocally: applyLocally,
	        // Count of how many times we've retried the transaction.
	        retryCount: 0,
	        // Function to call to clean up our .on() listener.
	        unwatcher: unwatcher,
	        // Stores why a transaction was aborted.
	        abortReason: null,
	        currentWriteId: null,
	        currentInputSnapshot: null,
	        currentOutputSnapshotRaw: null,
	        currentOutputSnapshotResolved: null
	    };
	    // Run transaction initially.
	    var currentState = this.getLatestState_(path);
	    transaction.currentInputSnapshot = currentState;
	    var newVal = transaction.update(currentState.val());
	    if (newVal === undefined) {
	        // Abort transaction.
	        transaction.unwatcher();
	        transaction.currentOutputSnapshotRaw = null;
	        transaction.currentOutputSnapshotResolved = null;
	        if (transaction.onComplete) {
	            // We just set the input snapshot, so this cast should be safe
	            var snapshot = new DataSnapshot_1.DataSnapshot(transaction.currentInputSnapshot, new Reference_1.Reference(this, transaction.path), PriorityIndex_1.PRIORITY_INDEX);
	            transaction.onComplete(null, false, snapshot);
	        }
	    }
	    else {
	        validation_1.validateFirebaseData('transaction failed: Data returned ', newVal, transaction.path);
	        // Mark as run and add to our queue.
	        transaction.status = TransactionStatus.RUN;
	        var queueNode = this.transactionQueueTree_.subTree(path);
	        var nodeQueue = queueNode.getValue() || [];
	        nodeQueue.push(transaction);
	        queueNode.setValue(nodeQueue);
	        // Update visibleData and raise events
	        // Note: We intentionally raise events after updating all of our transaction state, since the user could
	        // start new transactions from the event callbacks.
	        var priorityForNode = void 0;
	        if (typeof newVal === 'object' &&
	            newVal !== null &&
	            util_3.contains(newVal, '.priority')) {
	            priorityForNode = util_3.safeGet(newVal, '.priority');
	            util_1.assert(validation_1.isValidPriority(priorityForNode), 'Invalid priority returned by transaction. ' +
	                'Priority must be a valid string, finite number, server value, or null.');
	        }
	        else {
	            var currentNode = this.serverSyncTree_.calcCompleteEventCache(path) ||
	                ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	            priorityForNode = currentNode.getPriority().val();
	        }
	        priorityForNode /** @type {null|number|string} */ = priorityForNode;
	        var serverValues = this.generateServerValues();
	        var newNodeUnresolved = nodeFromJSON_1.nodeFromJSON(newVal, priorityForNode);
	        var newNode = ServerValues_1.resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
	        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
	        transaction.currentOutputSnapshotResolved = newNode;
	        transaction.currentWriteId = this.getNextWriteId_();
	        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, transaction.currentWriteId, transaction.applyLocally);
	        this.eventQueue_.raiseEventsForChangedPath(path, events);
	        this.sendReadyTransactions_();
	    }
	};
	/**
	 * @param {!Path} path
	 * @param {Array.<number>=} excludeSets A specific set to exclude
	 * @return {Node}
	 * @private
	 */
	Repo_1.Repo.prototype.getLatestState_ = function (path, excludeSets) {
	    return (this.serverSyncTree_.calcCompleteEventCache(path, excludeSets) ||
	        ChildrenNode_1.ChildrenNode.EMPTY_NODE);
	};
	/**
	 * Sends any already-run transactions that aren't waiting for outstanding transactions to
	 * complete.
	 *
	 * Externally it's called with no arguments, but it calls itself recursively with a particular
	 * transactionQueueTree node to recurse through the tree.
	 *
	 * @param {Tree.<Array.<Transaction>>=} node  transactionQueueTree node to start at.
	 * @private
	 */
	Repo_1.Repo.prototype.sendReadyTransactions_ = function (node) {
	    var _this = this;
	    if (node === void 0) { node = this.transactionQueueTree_; }
	    // Before recursing, make sure any completed transactions are removed.
	    if (!node) {
	        this.pruneCompletedTransactionsBelowNode_(node);
	    }
	    if (node.getValue() !== null) {
	        var queue = this.buildTransactionQueue_(node);
	        util_1.assert(queue.length > 0, 'Sending zero length transaction queue');
	        var allRun = queue.every(function (transaction) { return transaction.status === TransactionStatus.RUN; });
	        // If they're all run (and not sent), we can send them.  Else, we must wait.
	        if (allRun) {
	            this.sendTransactionQueue_(node.path(), queue);
	        }
	    }
	    else if (node.hasChildren()) {
	        node.forEachChild(function (childNode) {
	            _this.sendReadyTransactions_(childNode);
	        });
	    }
	};
	/**
	 * Given a list of run transactions, send them to the server and then handle the result (success or failure).
	 *
	 * @param {!Path} path The location of the queue.
	 * @param {!Array.<Transaction>} queue Queue of transactions under the specified location.
	 * @private
	 */
	Repo_1.Repo.prototype.sendTransactionQueue_ = function (path, queue) {
	    var _this = this;
	    // Mark transactions as sent and increment retry count!
	    var setsToIgnore = queue.map(function (txn) {
	        return txn.currentWriteId;
	    });
	    var latestState = this.getLatestState_(path, setsToIgnore);
	    var snapToSend = latestState;
	    var latestHash = latestState.hash();
	    for (var i = 0; i < queue.length; i++) {
	        var txn = queue[i];
	        util_1.assert(txn.status === TransactionStatus.RUN, 'tryToSendTransactionQueue_: items in queue should all be run.');
	        txn.status = TransactionStatus.SENT;
	        txn.retryCount++;
	        var relativePath = Path_1.Path.relativePath(path, txn.path);
	        // If we've gotten to this point, the output snapshot must be defined.
	        snapToSend = snapToSend.updateChild(relativePath /**@type {!Node} */, txn.currentOutputSnapshotRaw);
	    }
	    var dataToSend = snapToSend.val(true);
	    var pathToSend = path;
	    // Send the put.
	    this.server_.put(pathToSend.toString(), dataToSend, function (status) {
	        _this.log_('transaction put response', {
	            path: pathToSend.toString(),
	            status: status
	        });
	        var events = [];
	        if (status === 'ok') {
	            // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
	            // the callback could trigger more transactions or sets.
	            var callbacks = [];
	            for (var i = 0; i < queue.length; i++) {
	                queue[i].status = TransactionStatus.COMPLETED;
	                events = events.concat(_this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId));
	                if (queue[i].onComplete) {
	                    // We never unset the output snapshot, and given that this transaction is complete, it should be set
	                    var node = queue[i].currentOutputSnapshotResolved;
	                    var ref = new Reference_1.Reference(_this, queue[i].path);
	                    var snapshot = new DataSnapshot_1.DataSnapshot(node, ref, PriorityIndex_1.PRIORITY_INDEX);
	                    callbacks.push(queue[i].onComplete.bind(null, null, true, snapshot));
	                }
	                queue[i].unwatcher();
	            }
	            // Now remove the completed transactions.
	            _this.pruneCompletedTransactionsBelowNode_(_this.transactionQueueTree_.subTree(path));
	            // There may be pending transactions that we can now send.
	            _this.sendReadyTransactions_();
	            _this.eventQueue_.raiseEventsForChangedPath(path, events);
	            // Finally, trigger onComplete callbacks.
	            for (var i = 0; i < callbacks.length; i++) {
	                util_2.exceptionGuard(callbacks[i]);
	            }
	        }
	        else {
	            // transactions are no longer sent.  Update their status appropriately.
	            if (status === 'datastale') {
	                for (var i = 0; i < queue.length; i++) {
	                    if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT)
	                        queue[i].status = TransactionStatus.NEEDS_ABORT;
	                    else
	                        queue[i].status = TransactionStatus.RUN;
	                }
	            }
	            else {
	                util_2.warn('transaction at ' + pathToSend.toString() + ' failed: ' + status);
	                for (var i = 0; i < queue.length; i++) {
	                    queue[i].status = TransactionStatus.NEEDS_ABORT;
	                    queue[i].abortReason = status;
	                }
	            }
	            _this.rerunTransactions_(path);
	        }
	    }, latestHash);
	};
	/**
	 * Finds all transactions dependent on the data at changedPath and reruns them.
	 *
	 * Should be called any time cached data changes.
	 *
	 * Return the highest path that was affected by rerunning transactions.  This is the path at which events need to
	 * be raised for.
	 *
	 * @param {!Path} changedPath The path in mergedData that changed.
	 * @return {!Path} The rootmost path that was affected by rerunning transactions.
	 * @private
	 */
	Repo_1.Repo.prototype.rerunTransactions_ = function (changedPath) {
	    var rootMostTransactionNode = this.getAncestorTransactionNode_(changedPath);
	    var path = rootMostTransactionNode.path();
	    var queue = this.buildTransactionQueue_(rootMostTransactionNode);
	    this.rerunTransactionQueue_(queue, path);
	    return path;
	};
	/**
	 * Does all the work of rerunning transactions (as well as cleans up aborted transactions and whatnot).
	 *
	 * @param {Array.<Transaction>} queue The queue of transactions to run.
	 * @param {!Path} path The path the queue is for.
	 * @private
	 */
	Repo_1.Repo.prototype.rerunTransactionQueue_ = function (queue, path) {
	    if (queue.length === 0) {
	        return; // Nothing to do!
	    }
	    // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
	    // the callback could trigger more transactions or sets.
	    var callbacks = [];
	    var events = [];
	    // Ignore all of the sets we're going to re-run.
	    var txnsToRerun = queue.filter(function (q) {
	        return q.status === TransactionStatus.RUN;
	    });
	    var setsToIgnore = txnsToRerun.map(function (q) {
	        return q.currentWriteId;
	    });
	    for (var i = 0; i < queue.length; i++) {
	        var transaction = queue[i];
	        var relativePath = Path_1.Path.relativePath(path, transaction.path);
	        var abortTransaction = false, abortReason = void 0;
	        util_1.assert(relativePath !== null, 'rerunTransactionsUnderNode_: relativePath should not be null.');
	        if (transaction.status === TransactionStatus.NEEDS_ABORT) {
	            abortTransaction = true;
	            abortReason = transaction.abortReason;
	            events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
	        }
	        else if (transaction.status === TransactionStatus.RUN) {
	            if (transaction.retryCount >= Repo_1.Repo.MAX_TRANSACTION_RETRIES_) {
	                abortTransaction = true;
	                abortReason = 'maxretry';
	                events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
	            }
	            else {
	                // This code reruns a transaction
	                var currentNode = this.getLatestState_(transaction.path, setsToIgnore);
	                transaction.currentInputSnapshot = currentNode;
	                var newData = queue[i].update(currentNode.val());
	                if (newData !== undefined) {
	                    validation_1.validateFirebaseData('transaction failed: Data returned ', newData, transaction.path);
	                    var newDataNode = nodeFromJSON_1.nodeFromJSON(newData);
	                    var hasExplicitPriority = typeof newData === 'object' &&
	                        newData != null &&
	                        util_3.contains(newData, '.priority');
	                    if (!hasExplicitPriority) {
	                        // Keep the old priority if there wasn't a priority explicitly specified.
	                        newDataNode = newDataNode.updatePriority(currentNode.getPriority());
	                    }
	                    var oldWriteId = transaction.currentWriteId;
	                    var serverValues = this.generateServerValues();
	                    var newNodeResolved = ServerValues_1.resolveDeferredValueSnapshot(newDataNode, serverValues);
	                    transaction.currentOutputSnapshotRaw = newDataNode;
	                    transaction.currentOutputSnapshotResolved = newNodeResolved;
	                    transaction.currentWriteId = this.getNextWriteId_();
	                    // Mutates setsToIgnore in place
	                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
	                    events = events.concat(this.serverSyncTree_.applyUserOverwrite(transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
	                    events = events.concat(this.serverSyncTree_.ackUserWrite(oldWriteId, true));
	                }
	                else {
	                    abortTransaction = true;
	                    abortReason = 'nodata';
	                    events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
	                }
	            }
	        }
	        this.eventQueue_.raiseEventsForChangedPath(path, events);
	        events = [];
	        if (abortTransaction) {
	            // Abort.
	            queue[i].status = TransactionStatus.COMPLETED;
	            // Removing a listener can trigger pruning which can muck with mergedData/visibleData (as it prunes data).
	            // So defer the unwatcher until we're done.
	            (function (unwatcher) {
	                setTimeout(unwatcher, Math.floor(0));
	            })(queue[i].unwatcher);
	            if (queue[i].onComplete) {
	                if (abortReason === 'nodata') {
	                    var ref = new Reference_1.Reference(this, queue[i].path);
	                    // We set this field immediately, so it's safe to cast to an actual snapshot
	                    var lastInput /** @type {!Node} */ = queue[i].currentInputSnapshot;
	                    var snapshot = new DataSnapshot_1.DataSnapshot(lastInput, ref, PriorityIndex_1.PRIORITY_INDEX);
	                    callbacks.push(queue[i].onComplete.bind(null, null, false, snapshot));
	                }
	                else {
	                    callbacks.push(queue[i].onComplete.bind(null, new Error(abortReason), false, null));
	                }
	            }
	        }
	    }
	    // Clean up completed transactions.
	    this.pruneCompletedTransactionsBelowNode_(this.transactionQueueTree_);
	    // Now fire callbacks, now that we're in a good, known state.
	    for (var i = 0; i < callbacks.length; i++) {
	        util_2.exceptionGuard(callbacks[i]);
	    }
	    // Try to send the transaction result to the server.
	    this.sendReadyTransactions_();
	};
	/**
	 * Returns the rootmost ancestor node of the specified path that has a pending transaction on it, or just returns
	 * the node for the given path if there are no pending transactions on any ancestor.
	 *
	 * @param {!Path} path The location to start at.
	 * @return {!Tree.<Array.<!Transaction>>} The rootmost node with a transaction.
	 * @private
	 */
	Repo_1.Repo.prototype.getAncestorTransactionNode_ = function (path) {
	    var front;
	    // Start at the root and walk deeper into the tree towards path until we find a node with pending transactions.
	    var transactionNode = this.transactionQueueTree_;
	    while ((front = path.getFront()) !== null &&
	        transactionNode.getValue() === null) {
	        transactionNode = transactionNode.subTree(front);
	        path = path.popFront();
	    }
	    return transactionNode;
	};
	/**
	 * Builds the queue of all transactions at or below the specified transactionNode.
	 *
	 * @param {!Tree.<Array.<Transaction>>} transactionNode
	 * @return {Array.<Transaction>} The generated queue.
	 * @private
	 */
	Repo_1.Repo.prototype.buildTransactionQueue_ = function (transactionNode) {
	    // Walk any child transaction queues and aggregate them into a single queue.
	    var transactionQueue = [];
	    this.aggregateTransactionQueuesForNode_(transactionNode, transactionQueue);
	    // Sort them by the order the transactions were created.
	    transactionQueue.sort(function (a, b) {
	        return a.order - b.order;
	    });
	    return transactionQueue;
	};
	/**
	 * @param {!Tree.<Array.<Transaction>>} node
	 * @param {Array.<Transaction>} queue
	 * @private
	 */
	Repo_1.Repo.prototype.aggregateTransactionQueuesForNode_ = function (node, queue) {
	    var _this = this;
	    var nodeQueue = node.getValue();
	    if (nodeQueue !== null) {
	        for (var i = 0; i < nodeQueue.length; i++) {
	            queue.push(nodeQueue[i]);
	        }
	    }
	    node.forEachChild(function (child) {
	        _this.aggregateTransactionQueuesForNode_(child, queue);
	    });
	};
	/**
	 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
	 *
	 * @param {!Tree.<Array.<!Transaction>>} node
	 * @private
	 */
	Repo_1.Repo.prototype.pruneCompletedTransactionsBelowNode_ = function (node) {
	    var _this = this;
	    var queue = node.getValue();
	    if (queue) {
	        var to = 0;
	        for (var from = 0; from < queue.length; from++) {
	            if (queue[from].status !== TransactionStatus.COMPLETED) {
	                queue[to] = queue[from];
	                to++;
	            }
	        }
	        queue.length = to;
	        node.setValue(queue.length > 0 ? queue : null);
	    }
	    node.forEachChild(function (childNode) {
	        _this.pruneCompletedTransactionsBelowNode_(childNode);
	    });
	};
	/**
	 * Aborts all transactions on ancestors or descendants of the specified path.  Called when doing a set() or update()
	 * since we consider them incompatible with transactions.
	 *
	 * @param {!Path} path Path for which we want to abort related transactions.
	 * @return {!Path}
	 * @private
	 */
	Repo_1.Repo.prototype.abortTransactions_ = function (path) {
	    var _this = this;
	    var affectedPath = this.getAncestorTransactionNode_(path).path();
	    var transactionNode = this.transactionQueueTree_.subTree(path);
	    transactionNode.forEachAncestor(function (node) {
	        _this.abortTransactionsOnNode_(node);
	    });
	    this.abortTransactionsOnNode_(transactionNode);
	    transactionNode.forEachDescendant(function (node) {
	        _this.abortTransactionsOnNode_(node);
	    });
	    return affectedPath;
	};
	/**
	 * Abort transactions stored in this transaction queue node.
	 *
	 * @param {!Tree.<Array.<Transaction>>} node Node to abort transactions for.
	 * @private
	 */
	Repo_1.Repo.prototype.abortTransactionsOnNode_ = function (node) {
	    var queue = node.getValue();
	    if (queue !== null) {
	        // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
	        // the callback could trigger more transactions or sets.
	        var callbacks = [];
	        // Go through queue.  Any already-sent transactions must be marked for abort, while the unsent ones
	        // can be immediately aborted and removed.
	        var events = [];
	        var lastSent = -1;
	        for (var i = 0; i < queue.length; i++) {
	            if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT) {
	                // Already marked.  No action needed.
	            }
	            else if (queue[i].status === TransactionStatus.SENT) {
	                util_1.assert(lastSent === i - 1, 'All SENT items should be at beginning of queue.');
	                lastSent = i;
	                // Mark transaction for abort when it comes back.
	                queue[i].status = TransactionStatus.SENT_NEEDS_ABORT;
	                queue[i].abortReason = 'set';
	            }
	            else {
	                util_1.assert(queue[i].status === TransactionStatus.RUN, 'Unexpected transaction status in abort');
	                // We can abort it immediately.
	                queue[i].unwatcher();
	                events = events.concat(this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId, true));
	                if (queue[i].onComplete) {
	                    var snapshot = null;
	                    callbacks.push(queue[i].onComplete.bind(null, new Error('set'), false, snapshot));
	                }
	            }
	        }
	        if (lastSent === -1) {
	            // We're not waiting for any sent transactions.  We can clear the queue.
	            node.setValue(null);
	        }
	        else {
	            // Remove the transactions we aborted.
	            queue.length = lastSent + 1;
	        }
	        // Now fire the callbacks.
	        this.eventQueue_.raiseEventsForChangedPath(node.path(), events);
	        for (var i = 0; i < callbacks.length; i++) {
	            util_2.exceptionGuard(callbacks[i]);
	        }
	    }
	};
	
	//# sourceMappingURL=Repo_transaction.js.map


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ChildrenNode_1 = __webpack_require__(28);
	/**
	 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
	 *
	 * @constructor
	 */
	var SnapshotHolder = /** @class */ (function () {
	    function SnapshotHolder() {
	        this.rootNode_ = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	    }
	    SnapshotHolder.prototype.getNode = function (path) {
	        return this.rootNode_.getChild(path);
	    };
	    SnapshotHolder.prototype.updateSnapshot = function (path, newSnapshotNode) {
	        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
	    };
	    return SnapshotHolder;
	}());
	exports.SnapshotHolder = SnapshotHolder;
	
	//# sourceMappingURL=SnapshotHolder.js.map


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var util_2 = __webpack_require__(13);
	var AckUserWrite_1 = __webpack_require__(430);
	var ChildrenNode_1 = __webpack_require__(28);
	var util_3 = __webpack_require__(2);
	var ImmutableTree_1 = __webpack_require__(119);
	var ListenComplete_1 = __webpack_require__(431);
	var Merge_1 = __webpack_require__(432);
	var Operation_1 = __webpack_require__(47);
	var Overwrite_1 = __webpack_require__(172);
	var Path_1 = __webpack_require__(17);
	var SyncPoint_1 = __webpack_require__(171);
	var WriteTree_1 = __webpack_require__(429);
	/**
	 * SyncTree is the central class for managing event callback registration, data caching, views
	 * (query processing), and event generation.  There are typically two SyncTree instances for
	 * each Repo, one for the normal Firebase data, and one for the .info data.
	 *
	 * It has a number of responsibilities, including:
	 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
	 *  - Applying and caching data changes for user set(), transaction(), and update() calls
	 *    (applyUserOverwrite(), applyUserMerge()).
	 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
	 *    applyServerMerge()).
	 *  - Generating user-facing events for server and user changes (all of the apply* methods
	 *    return the set of events that need to be raised as a result).
	 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
	 *    to the correct set of paths and queries to satisfy the current set of user event
	 *    callbacks (listens are started/stopped using the provided listenProvider).
	 *
	 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
	 * events are returned to the caller rather than raised synchronously.
	 *
	 * @constructor
	 */
	var SyncTree = /** @class */ (function () {
	    /**
	     * @param {!ListenProvider} listenProvider_ Used by SyncTree to start / stop listening
	     *   to server data.
	     */
	    function SyncTree(listenProvider_) {
	        this.listenProvider_ = listenProvider_;
	        /**
	         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
	         * @type {!ImmutableTree.<!SyncPoint>}
	         * @private
	         */
	        this.syncPointTree_ = ImmutableTree_1.ImmutableTree.Empty;
	        /**
	         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
	         * @type {!WriteTree}
	         * @private
	         */
	        this.pendingWriteTree_ = new WriteTree_1.WriteTree();
	        this.tagToQueryMap_ = {};
	        this.queryToTagMap_ = {};
	    }
	    /**
	     * Apply the data changes for a user-generated set() or transaction() call.
	     *
	     * @param {!Path} path
	     * @param {!Node} newData
	     * @param {number} writeId
	     * @param {boolean=} visible
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.applyUserOverwrite = function (path, newData, writeId, visible) {
	        // Record pending write.
	        this.pendingWriteTree_.addOverwrite(path, newData, writeId, visible);
	        if (!visible) {
	            return [];
	        }
	        else {
	            return this.applyOperationToSyncPoints_(new Overwrite_1.Overwrite(Operation_1.OperationSource.User, path, newData));
	        }
	    };
	    /**
	     * Apply the data from a user-generated update() call
	     *
	     * @param {!Path} path
	     * @param {!Object.<string, !Node>} changedChildren
	     * @param {!number} writeId
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.applyUserMerge = function (path, changedChildren, writeId) {
	        // Record pending merge.
	        this.pendingWriteTree_.addMerge(path, changedChildren, writeId);
	        var changeTree = ImmutableTree_1.ImmutableTree.fromObject(changedChildren);
	        return this.applyOperationToSyncPoints_(new Merge_1.Merge(Operation_1.OperationSource.User, path, changeTree));
	    };
	    /**
	     * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
	     *
	     * @param {!number} writeId
	     * @param {boolean=} revert True if the given write failed and needs to be reverted
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.ackUserWrite = function (writeId, revert) {
	        if (revert === void 0) { revert = false; }
	        var write = this.pendingWriteTree_.getWrite(writeId);
	        var needToReevaluate = this.pendingWriteTree_.removeWrite(writeId);
	        if (!needToReevaluate) {
	            return [];
	        }
	        else {
	            var affectedTree_1 = ImmutableTree_1.ImmutableTree.Empty;
	            if (write.snap != null) {
	                // overwrite
	                affectedTree_1 = affectedTree_1.set(Path_1.Path.Empty, true);
	            }
	            else {
	                util_3.forEach(write.children, function (pathString, node) {
	                    affectedTree_1 = affectedTree_1.set(new Path_1.Path(pathString), node);
	                });
	            }
	            return this.applyOperationToSyncPoints_(new AckUserWrite_1.AckUserWrite(write.path, affectedTree_1, revert));
	        }
	    };
	    /**
	     * Apply new server data for the specified path..
	     *
	     * @param {!Path} path
	     * @param {!Node} newData
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.applyServerOverwrite = function (path, newData) {
	        return this.applyOperationToSyncPoints_(new Overwrite_1.Overwrite(Operation_1.OperationSource.Server, path, newData));
	    };
	    /**
	     * Apply new server data to be merged in at the specified path.
	     *
	     * @param {!Path} path
	     * @param {!Object.<string, !Node>} changedChildren
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.applyServerMerge = function (path, changedChildren) {
	        var changeTree = ImmutableTree_1.ImmutableTree.fromObject(changedChildren);
	        return this.applyOperationToSyncPoints_(new Merge_1.Merge(Operation_1.OperationSource.Server, path, changeTree));
	    };
	    /**
	     * Apply a listen complete for a query
	     *
	     * @param {!Path} path
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.applyListenComplete = function (path) {
	        return this.applyOperationToSyncPoints_(new ListenComplete_1.ListenComplete(Operation_1.OperationSource.Server, path));
	    };
	    /**
	     * Apply new server data for the specified tagged query.
	     *
	     * @param {!Path} path
	     * @param {!Node} snap
	     * @param {!number} tag
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.applyTaggedQueryOverwrite = function (path, snap, tag) {
	        var queryKey = this.queryKeyForTag_(tag);
	        if (queryKey != null) {
	            var r = SyncTree.parseQueryKey_(queryKey);
	            var queryPath = r.path, queryId = r.queryId;
	            var relativePath = Path_1.Path.relativePath(queryPath, path);
	            var op = new Overwrite_1.Overwrite(Operation_1.OperationSource.forServerTaggedQuery(queryId), relativePath, snap);
	            return this.applyTaggedOperation_(queryPath, op);
	        }
	        else {
	            // Query must have been removed already
	            return [];
	        }
	    };
	    /**
	     * Apply server data to be merged in for the specified tagged query.
	     *
	     * @param {!Path} path
	     * @param {!Object.<string, !Node>} changedChildren
	     * @param {!number} tag
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.applyTaggedQueryMerge = function (path, changedChildren, tag) {
	        var queryKey = this.queryKeyForTag_(tag);
	        if (queryKey) {
	            var r = SyncTree.parseQueryKey_(queryKey);
	            var queryPath = r.path, queryId = r.queryId;
	            var relativePath = Path_1.Path.relativePath(queryPath, path);
	            var changeTree = ImmutableTree_1.ImmutableTree.fromObject(changedChildren);
	            var op = new Merge_1.Merge(Operation_1.OperationSource.forServerTaggedQuery(queryId), relativePath, changeTree);
	            return this.applyTaggedOperation_(queryPath, op);
	        }
	        else {
	            // We've already removed the query. No big deal, ignore the update
	            return [];
	        }
	    };
	    /**
	     * Apply a listen complete for a tagged query
	     *
	     * @param {!Path} path
	     * @param {!number} tag
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.applyTaggedListenComplete = function (path, tag) {
	        var queryKey = this.queryKeyForTag_(tag);
	        if (queryKey) {
	            var r = SyncTree.parseQueryKey_(queryKey);
	            var queryPath = r.path, queryId = r.queryId;
	            var relativePath = Path_1.Path.relativePath(queryPath, path);
	            var op = new ListenComplete_1.ListenComplete(Operation_1.OperationSource.forServerTaggedQuery(queryId), relativePath);
	            return this.applyTaggedOperation_(queryPath, op);
	        }
	        else {
	            // We've already removed the query. No big deal, ignore the update
	            return [];
	        }
	    };
	    /**
	     * Add an event callback for the specified query.
	     *
	     * @param {!Query} query
	     * @param {!EventRegistration} eventRegistration
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncTree.prototype.addEventRegistration = function (query, eventRegistration) {
	        var path = query.path;
	        var serverCache = null;
	        var foundAncestorDefaultView = false;
	        // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
	        // Consider optimizing this once there's a better understanding of what actual behavior will be.
	        this.syncPointTree_.foreachOnPath(path, function (pathToSyncPoint, sp) {
	            var relativePath = Path_1.Path.relativePath(pathToSyncPoint, path);
	            serverCache = serverCache || sp.getCompleteServerCache(relativePath);
	            foundAncestorDefaultView =
	                foundAncestorDefaultView || sp.hasCompleteView();
	        });
	        var syncPoint = this.syncPointTree_.get(path);
	        if (!syncPoint) {
	            syncPoint = new SyncPoint_1.SyncPoint();
	            this.syncPointTree_ = this.syncPointTree_.set(path, syncPoint);
	        }
	        else {
	            foundAncestorDefaultView =
	                foundAncestorDefaultView || syncPoint.hasCompleteView();
	            serverCache = serverCache || syncPoint.getCompleteServerCache(Path_1.Path.Empty);
	        }
	        var serverCacheComplete;
	        if (serverCache != null) {
	            serverCacheComplete = true;
	        }
	        else {
	            serverCacheComplete = false;
	            serverCache = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	            var subtree = this.syncPointTree_.subtree(path);
	            subtree.foreachChild(function (childName, childSyncPoint) {
	                var completeCache = childSyncPoint.getCompleteServerCache(Path_1.Path.Empty);
	                if (completeCache) {
	                    serverCache = serverCache.updateImmediateChild(childName, completeCache);
	                }
	            });
	        }
	        var viewAlreadyExists = syncPoint.viewExistsForQuery(query);
	        if (!viewAlreadyExists && !query.getQueryParams().loadsAllData()) {
	            // We need to track a tag for this query
	            var queryKey = SyncTree.makeQueryKey_(query);
	            util_1.assert(!(queryKey in this.queryToTagMap_), 'View does not exist, but we have a tag');
	            var tag = SyncTree.getNextQueryTag_();
	            this.queryToTagMap_[queryKey] = tag;
	            // Coerce to string to avoid sparse arrays.
	            this.tagToQueryMap_['_' + tag] = queryKey;
	        }
	        var writesCache = this.pendingWriteTree_.childWrites(path);
	        var events = syncPoint.addEventRegistration(query, eventRegistration, writesCache, serverCache, serverCacheComplete);
	        if (!viewAlreadyExists && !foundAncestorDefaultView) {
	            var view /** @type !View */ = syncPoint.viewForQuery(query);
	            events = events.concat(this.setupListener_(query, view));
	        }
	        return events;
	    };
	    /**
	     * Remove event callback(s).
	     *
	     * If query is the default query, we'll check all queries for the specified eventRegistration.
	     * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
	     *
	     * @param {!Query} query
	     * @param {?EventRegistration} eventRegistration If null, all callbacks are removed.
	     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
	     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
	     */
	    SyncTree.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
	        var _this = this;
	        // Find the syncPoint first. Then deal with whether or not it has matching listeners
	        var path = query.path;
	        var maybeSyncPoint = this.syncPointTree_.get(path);
	        var cancelEvents = [];
	        // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
	        // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
	        // not loadsAllData().
	        if (maybeSyncPoint &&
	            (query.queryIdentifier() === 'default' ||
	                maybeSyncPoint.viewExistsForQuery(query))) {
	            /**
	             * @type {{removed: !Array.<!Query>, events: !Array.<!Event>}}
	             */
	            var removedAndEvents = maybeSyncPoint.removeEventRegistration(query, eventRegistration, cancelError);
	            if (maybeSyncPoint.isEmpty()) {
	                this.syncPointTree_ = this.syncPointTree_.remove(path);
	            }
	            var removed = removedAndEvents.removed;
	            cancelEvents = removedAndEvents.events;
	            // We may have just removed one of many listeners and can short-circuit this whole process
	            // We may also not have removed a default listener, in which case all of the descendant listeners should already be
	            // properly set up.
	            //
	            // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
	            // queryId === 'default'
	            var removingDefault = -1 !==
	                removed.findIndex(function (query) {
	                    return query.getQueryParams().loadsAllData();
	                });
	            var covered = this.syncPointTree_.findOnPath(path, function (relativePath, parentSyncPoint) {
	                return parentSyncPoint.hasCompleteView();
	            });
	            if (removingDefault && !covered) {
	                var subtree = this.syncPointTree_.subtree(path);
	                // There are potentially child listeners. Determine what if any listens we need to send before executing the
	                // removal
	                if (!subtree.isEmpty()) {
	                    // We need to fold over our subtree and collect the listeners to send
	                    var newViews = this.collectDistinctViewsForSubTree_(subtree);
	                    // Ok, we've collected all the listens we need. Set them up.
	                    for (var i = 0; i < newViews.length; ++i) {
	                        var view = newViews[i], newQuery = view.getQuery();
	                        var listener = this.createListenerForView_(view);
	                        this.listenProvider_.startListening(SyncTree.queryForListening_(newQuery), this.tagForQuery_(newQuery), listener.hashFn, listener.onComplete);
	                    }
	                }
	                else {
	                    // There's nothing below us, so nothing we need to start listening on
	                }
	            }
	            // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
	            // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
	            // Also, note that if we have a cancelError, it's already been removed at the provider level.
	            if (!covered && removed.length > 0 && !cancelError) {
	                // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
	                // default. Otherwise, we need to iterate through and cancel each individual query
	                if (removingDefault) {
	                    // We don't tag default listeners
	                    var defaultTag = null;
	                    this.listenProvider_.stopListening(SyncTree.queryForListening_(query), defaultTag);
	                }
	                else {
	                    removed.forEach(function (queryToRemove) {
	                        var tagToRemove = _this.queryToTagMap_[SyncTree.makeQueryKey_(queryToRemove)];
	                        _this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToRemove), tagToRemove);
	                    });
	                }
	            }
	            // Now, clear all of the tags we're tracking for the removed listens
	            this.removeTags_(removed);
	        }
	        else {
	            // No-op, this listener must've been already removed
	        }
	        return cancelEvents;
	    };
	    /**
	     * Returns a complete cache, if we have one, of the data at a particular path. The location must have a listener above
	     * it, but as this is only used by transaction code, that should always be the case anyways.
	     *
	     * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
	     * @param {!Path} path The path to the data we want
	     * @param {Array.<number>=} writeIdsToExclude A specific set to be excluded
	     * @return {?Node}
	     */
	    SyncTree.prototype.calcCompleteEventCache = function (path, writeIdsToExclude) {
	        var includeHiddenSets = true;
	        var writeTree = this.pendingWriteTree_;
	        var serverCache = this.syncPointTree_.findOnPath(path, function (pathSoFar, syncPoint) {
	            var relativePath = Path_1.Path.relativePath(pathSoFar, path);
	            var serverCache = syncPoint.getCompleteServerCache(relativePath);
	            if (serverCache) {
	                return serverCache;
	            }
	        });
	        return writeTree.calcCompleteEventCache(path, serverCache, writeIdsToExclude, includeHiddenSets);
	    };
	    /**
	     * This collapses multiple unfiltered views into a single view, since we only need a single
	     * listener for them.
	     *
	     * @param {!ImmutableTree.<!SyncPoint>} subtree
	     * @return {!Array.<!View>}
	     * @private
	     */
	    SyncTree.prototype.collectDistinctViewsForSubTree_ = function (subtree) {
	        return subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
	            if (maybeChildSyncPoint && maybeChildSyncPoint.hasCompleteView()) {
	                var completeView = maybeChildSyncPoint.getCompleteView();
	                return [completeView];
	            }
	            else {
	                // No complete view here, flatten any deeper listens into an array
	                var views_1 = [];
	                if (maybeChildSyncPoint) {
	                    views_1 = maybeChildSyncPoint.getQueryViews();
	                }
	                util_3.forEach(childMap, function (key, childViews) {
	                    views_1 = views_1.concat(childViews);
	                });
	                return views_1;
	            }
	        });
	    };
	    /**
	     * @param {!Array.<!Query>} queries
	     * @private
	     */
	    SyncTree.prototype.removeTags_ = function (queries) {
	        for (var j = 0; j < queries.length; ++j) {
	            var removedQuery = queries[j];
	            if (!removedQuery.getQueryParams().loadsAllData()) {
	                // We should have a tag for this
	                var removedQueryKey = SyncTree.makeQueryKey_(removedQuery);
	                var removedQueryTag = this.queryToTagMap_[removedQueryKey];
	                delete this.queryToTagMap_[removedQueryKey];
	                delete this.tagToQueryMap_['_' + removedQueryTag];
	            }
	        }
	    };
	    /**
	     * Normalizes a query to a query we send the server for listening
	     * @param {!Query} query
	     * @return {!Query} The normalized query
	     * @private
	     */
	    SyncTree.queryForListening_ = function (query) {
	        if (query.getQueryParams().loadsAllData() &&
	            !query.getQueryParams().isDefault()) {
	            // We treat queries that load all data as default queries
	            // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
	            // from Query
	            return /** @type {!Query} */ query.getRef();
	        }
	        else {
	            return query;
	        }
	    };
	    /**
	     * For a given new listen, manage the de-duplication of outstanding subscriptions.
	     *
	     * @param {!Query} query
	     * @param {!View} view
	     * @return {!Array.<!Event>} This method can return events to support synchronous data sources
	     * @private
	     */
	    SyncTree.prototype.setupListener_ = function (query, view) {
	        var path = query.path;
	        var tag = this.tagForQuery_(query);
	        var listener = this.createListenerForView_(view);
	        var events = this.listenProvider_.startListening(SyncTree.queryForListening_(query), tag, listener.hashFn, listener.onComplete);
	        var subtree = this.syncPointTree_.subtree(path);
	        // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
	        // may need to shadow other listens as well.
	        if (tag) {
	            util_1.assert(!subtree.value.hasCompleteView(), "If we're adding a query, it shouldn't be shadowed");
	        }
	        else {
	            // Shadow everything at or below this location, this is a default listener.
	            var queriesToStop = subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
	                if (!relativePath.isEmpty() &&
	                    maybeChildSyncPoint &&
	                    maybeChildSyncPoint.hasCompleteView()) {
	                    return [maybeChildSyncPoint.getCompleteView().getQuery()];
	                }
	                else {
	                    // No default listener here, flatten any deeper queries into an array
	                    var queries_1 = [];
	                    if (maybeChildSyncPoint) {
	                        queries_1 = queries_1.concat(maybeChildSyncPoint.getQueryViews().map(function (view) { return view.getQuery(); }));
	                    }
	                    util_3.forEach(childMap, function (key, childQueries) {
	                        queries_1 = queries_1.concat(childQueries);
	                    });
	                    return queries_1;
	                }
	            });
	            for (var i = 0; i < queriesToStop.length; ++i) {
	                var queryToStop = queriesToStop[i];
	                this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToStop), this.tagForQuery_(queryToStop));
	            }
	        }
	        return events;
	    };
	    /**
	     *
	     * @param {!View} view
	     * @return {{hashFn: function(), onComplete: function(!string, *)}}
	     * @private
	     */
	    SyncTree.prototype.createListenerForView_ = function (view) {
	        var _this = this;
	        var query = view.getQuery();
	        var tag = this.tagForQuery_(query);
	        return {
	            hashFn: function () {
	                var cache = view.getServerCache() || ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	                return cache.hash();
	            },
	            onComplete: function (status) {
	                if (status === 'ok') {
	                    if (tag) {
	                        return _this.applyTaggedListenComplete(query.path, tag);
	                    }
	                    else {
	                        return _this.applyListenComplete(query.path);
	                    }
	                }
	                else {
	                    // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
	                    // Note that this may need to be scoped to just this listener if we change permissions on filtered children
	                    var error = util_2.errorForServerCode(status, query);
	                    return _this.removeEventRegistration(query, 
	                    /*eventRegistration*/ null, error);
	                }
	            }
	        };
	    };
	    /**
	     * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
	     * @private
	     * @param {!Query} query
	     * @return {string}
	     */
	    SyncTree.makeQueryKey_ = function (query) {
	        return query.path.toString() + '$' + query.queryIdentifier();
	    };
	    /**
	     * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
	     * @private
	     * @param {!string} queryKey
	     * @return {{queryId: !string, path: !Path}}
	     */
	    SyncTree.parseQueryKey_ = function (queryKey) {
	        var splitIndex = queryKey.indexOf('$');
	        util_1.assert(splitIndex !== -1 && splitIndex < queryKey.length - 1, 'Bad queryKey.');
	        return {
	            queryId: queryKey.substr(splitIndex + 1),
	            path: new Path_1.Path(queryKey.substr(0, splitIndex))
	        };
	    };
	    /**
	     * Return the query associated with the given tag, if we have one
	     * @param {!number} tag
	     * @return {?string}
	     * @private
	     */
	    SyncTree.prototype.queryKeyForTag_ = function (tag) {
	        return this.tagToQueryMap_['_' + tag];
	    };
	    /**
	     * Return the tag associated with the given query.
	     * @param {!Query} query
	     * @return {?number}
	     * @private
	     */
	    SyncTree.prototype.tagForQuery_ = function (query) {
	        var queryKey = SyncTree.makeQueryKey_(query);
	        return util_3.safeGet(this.queryToTagMap_, queryKey);
	    };
	    /**
	     * Static accessor for query tags.
	     * @return {number}
	     * @private
	     */
	    SyncTree.getNextQueryTag_ = function () {
	        return SyncTree.nextQueryTag_++;
	    };
	    /**
	     * A helper method to apply tagged operations
	     *
	     * @param {!Path} queryPath
	     * @param {!Operation} operation
	     * @return {!Array.<!Event>}
	     * @private
	     */
	    SyncTree.prototype.applyTaggedOperation_ = function (queryPath, operation) {
	        var syncPoint = this.syncPointTree_.get(queryPath);
	        util_1.assert(syncPoint, "Missing sync point for query tag that we're tracking");
	        var writesCache = this.pendingWriteTree_.childWrites(queryPath);
	        return syncPoint.applyOperation(operation, writesCache, 
	        /*serverCache=*/ null);
	    };
	    /**
	     * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
	     *
	     * NOTES:
	     * - Descendant SyncPoints will be visited first (since we raise events depth-first).
	  
	     * - We call applyOperation() on each SyncPoint passing three things:
	     *   1. A version of the Operation that has been made relative to the SyncPoint location.
	     *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
	     *   3. A snapshot Node with cached server data, if we have it.
	  
	     * - We concatenate all of the events returned by each SyncPoint and return the result.
	     *
	     * @param {!Operation} operation
	     * @return {!Array.<!Event>}
	     * @private
	     */
	    SyncTree.prototype.applyOperationToSyncPoints_ = function (operation) {
	        return this.applyOperationHelper_(operation, this.syncPointTree_, 
	        /*serverCache=*/ null, this.pendingWriteTree_.childWrites(Path_1.Path.Empty));
	    };
	    /**
	     * Recursive helper for applyOperationToSyncPoints_
	     *
	     * @private
	     * @param {!Operation} operation
	     * @param {ImmutableTree.<!SyncPoint>} syncPointTree
	     * @param {?Node} serverCache
	     * @param {!WriteTreeRef} writesCache
	     * @return {!Array.<!Event>}
	     */
	    SyncTree.prototype.applyOperationHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
	        if (operation.path.isEmpty()) {
	            return this.applyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
	        }
	        else {
	            var syncPoint = syncPointTree.get(Path_1.Path.Empty);
	            // If we don't have cached server data, see if we can get it from this SyncPoint.
	            if (serverCache == null && syncPoint != null) {
	                serverCache = syncPoint.getCompleteServerCache(Path_1.Path.Empty);
	            }
	            var events = [];
	            var childName = operation.path.getFront();
	            var childOperation = operation.operationForChild(childName);
	            var childTree = syncPointTree.children.get(childName);
	            if (childTree && childOperation) {
	                var childServerCache = serverCache
	                    ? serverCache.getImmediateChild(childName)
	                    : null;
	                var childWritesCache = writesCache.child(childName);
	                events = events.concat(this.applyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
	            }
	            if (syncPoint) {
	                events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
	            }
	            return events;
	        }
	    };
	    /**
	     * Recursive helper for applyOperationToSyncPoints_
	     *
	     * @private
	     * @param {!Operation} operation
	     * @param {ImmutableTree.<!SyncPoint>} syncPointTree
	     * @param {?Node} serverCache
	     * @param {!WriteTreeRef} writesCache
	     * @return {!Array.<!Event>}
	     */
	    SyncTree.prototype.applyOperationDescendantsHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
	        var _this = this;
	        var syncPoint = syncPointTree.get(Path_1.Path.Empty);
	        // If we don't have cached server data, see if we can get it from this SyncPoint.
	        if (serverCache == null && syncPoint != null) {
	            serverCache = syncPoint.getCompleteServerCache(Path_1.Path.Empty);
	        }
	        var events = [];
	        syncPointTree.children.inorderTraversal(function (childName, childTree) {
	            var childServerCache = serverCache
	                ? serverCache.getImmediateChild(childName)
	                : null;
	            var childWritesCache = writesCache.child(childName);
	            var childOperation = operation.operationForChild(childName);
	            if (childOperation) {
	                events = events.concat(_this.applyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
	            }
	        });
	        if (syncPoint) {
	            events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
	        }
	        return events;
	    };
	    /**
	     * Static tracker for next query tag.
	     * @type {number}
	     * @private
	     */
	    SyncTree.nextQueryTag_ = 1;
	    return SyncTree;
	}());
	exports.SyncTree = SyncTree;
	
	//# sourceMappingURL=SyncTree.js.map


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var util_2 = __webpack_require__(2);
	var Path_1 = __webpack_require__(17);
	var CompoundWrite_1 = __webpack_require__(424);
	var PriorityIndex_1 = __webpack_require__(26);
	var ChildrenNode_1 = __webpack_require__(28);
	/**
	 * WriteTree tracks all pending user-initiated writes and has methods to calculate the result of merging them
	 * with underlying server data (to create "event cache" data).  Pending writes are added with addOverwrite()
	 * and addMerge(), and removed with removeWrite().
	 *
	 * @constructor
	 */
	var WriteTree = /** @class */ (function () {
	    function WriteTree() {
	        /**
	         * A tree tracking the result of applying all visible writes.  This does not include transactions with
	         * applyLocally=false or writes that are completely shadowed by other writes.
	         *
	         * @type {!CompoundWrite}
	         * @private
	         */
	        this.visibleWrites_ = CompoundWrite_1.CompoundWrite.Empty;
	        /**
	         * A list of all pending writes, regardless of visibility and shadowed-ness.  Used to calculate arbitrary
	         * sets of the changed data, such as hidden writes (from transactions) or changes with certain writes excluded (also
	         * used by transactions).
	         *
	         * @type {!Array.<!WriteRecord>}
	         * @private
	         */
	        this.allWrites_ = [];
	        this.lastWriteId_ = -1;
	    }
	    /**
	     * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
	     *
	     * @param {!Path} path
	     * @return {!WriteTreeRef}
	     */
	    WriteTree.prototype.childWrites = function (path) {
	        return new WriteTreeRef(path, this);
	    };
	    /**
	     * Record a new overwrite from user code.
	     *
	     * @param {!Path} path
	     * @param {!Node} snap
	     * @param {!number} writeId
	     * @param {boolean=} visible This is set to false by some transactions. It should be excluded from event caches
	     */
	    WriteTree.prototype.addOverwrite = function (path, snap, writeId, visible) {
	        util_2.assert(writeId > this.lastWriteId_, 'Stacking an older write on top of newer ones');
	        if (visible === undefined) {
	            visible = true;
	        }
	        this.allWrites_.push({
	            path: path,
	            snap: snap,
	            writeId: writeId,
	            visible: visible
	        });
	        if (visible) {
	            this.visibleWrites_ = this.visibleWrites_.addWrite(path, snap);
	        }
	        this.lastWriteId_ = writeId;
	    };
	    /**
	     * Record a new merge from user code.
	     *
	     * @param {!Path} path
	     * @param {!Object.<string, !Node>} changedChildren
	     * @param {!number} writeId
	     */
	    WriteTree.prototype.addMerge = function (path, changedChildren, writeId) {
	        util_2.assert(writeId > this.lastWriteId_, 'Stacking an older merge on top of newer ones');
	        this.allWrites_.push({
	            path: path,
	            children: changedChildren,
	            writeId: writeId,
	            visible: true
	        });
	        this.visibleWrites_ = this.visibleWrites_.addWrites(path, changedChildren);
	        this.lastWriteId_ = writeId;
	    };
	    /**
	     * @param {!number} writeId
	     * @return {?WriteRecord}
	     */
	    WriteTree.prototype.getWrite = function (writeId) {
	        for (var i = 0; i < this.allWrites_.length; i++) {
	            var record = this.allWrites_[i];
	            if (record.writeId === writeId) {
	                return record;
	            }
	        }
	        return null;
	    };
	    /**
	     * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
	     * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
	     *
	     * @param {!number} writeId
	     * @return {boolean} true if the write may have been visible (meaning we'll need to reevaluate / raise
	     * events as a result).
	     */
	    WriteTree.prototype.removeWrite = function (writeId) {
	        // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
	        // out of order.
	        //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
	        //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
	        var _this = this;
	        var idx = this.allWrites_.findIndex(function (s) {
	            return s.writeId === writeId;
	        });
	        util_2.assert(idx >= 0, 'removeWrite called with nonexistent writeId.');
	        var writeToRemove = this.allWrites_[idx];
	        this.allWrites_.splice(idx, 1);
	        var removedWriteWasVisible = writeToRemove.visible;
	        var removedWriteOverlapsWithOtherWrites = false;
	        var i = this.allWrites_.length - 1;
	        while (removedWriteWasVisible && i >= 0) {
	            var currentWrite = this.allWrites_[i];
	            if (currentWrite.visible) {
	                if (i >= idx &&
	                    this.recordContainsPath_(currentWrite, writeToRemove.path)) {
	                    // The removed write was completely shadowed by a subsequent write.
	                    removedWriteWasVisible = false;
	                }
	                else if (writeToRemove.path.contains(currentWrite.path)) {
	                    // Either we're covering some writes or they're covering part of us (depending on which came first).
	                    removedWriteOverlapsWithOtherWrites = true;
	                }
	            }
	            i--;
	        }
	        if (!removedWriteWasVisible) {
	            return false;
	        }
	        else if (removedWriteOverlapsWithOtherWrites) {
	            // There's some shadowing going on. Just rebuild the visible writes from scratch.
	            this.resetTree_();
	            return true;
	        }
	        else {
	            // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
	            if (writeToRemove.snap) {
	                this.visibleWrites_ = this.visibleWrites_.removeWrite(writeToRemove.path);
	            }
	            else {
	                var children = writeToRemove.children;
	                util_1.forEach(children, function (childName) {
	                    _this.visibleWrites_ = _this.visibleWrites_.removeWrite(writeToRemove.path.child(childName));
	                });
	            }
	            return true;
	        }
	    };
	    /**
	     * Return a complete snapshot for the given path if there's visible write data at that path, else null.
	     * No server data is considered.
	     *
	     * @param {!Path} path
	     * @return {?Node}
	     */
	    WriteTree.prototype.getCompleteWriteData = function (path) {
	        return this.visibleWrites_.getCompleteNode(path);
	    };
	    /**
	     * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
	     * writes), attempt to calculate a complete snapshot for the given path
	     *
	     * @param {!Path} treePath
	     * @param {?Node} completeServerCache
	     * @param {Array.<number>=} writeIdsToExclude An optional set to be excluded
	     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
	     * @return {?Node}
	     */
	    WriteTree.prototype.calcCompleteEventCache = function (treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
	        if (!writeIdsToExclude && !includeHiddenWrites) {
	            var shadowingNode = this.visibleWrites_.getCompleteNode(treePath);
	            if (shadowingNode != null) {
	                return shadowingNode;
	            }
	            else {
	                var subMerge = this.visibleWrites_.childCompoundWrite(treePath);
	                if (subMerge.isEmpty()) {
	                    return completeServerCache;
	                }
	                else if (completeServerCache == null &&
	                    !subMerge.hasCompleteWrite(Path_1.Path.Empty)) {
	                    // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
	                    return null;
	                }
	                else {
	                    var layeredCache = completeServerCache || ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	                    return subMerge.apply(layeredCache);
	                }
	            }
	        }
	        else {
	            var merge = this.visibleWrites_.childCompoundWrite(treePath);
	            if (!includeHiddenWrites && merge.isEmpty()) {
	                return completeServerCache;
	            }
	            else {
	                // If the server cache is null, and we don't have a complete cache, we need to return null
	                if (!includeHiddenWrites &&
	                    completeServerCache == null &&
	                    !merge.hasCompleteWrite(Path_1.Path.Empty)) {
	                    return null;
	                }
	                else {
	                    var filter = function (write) {
	                        return ((write.visible || includeHiddenWrites) &&
	                            (!writeIdsToExclude ||
	                                !~writeIdsToExclude.indexOf(write.writeId)) &&
	                            (write.path.contains(treePath) || treePath.contains(write.path)));
	                    };
	                    var mergeAtPath = WriteTree.layerTree_(this.allWrites_, filter, treePath);
	                    var layeredCache = completeServerCache || ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	                    return mergeAtPath.apply(layeredCache);
	                }
	            }
	        }
	    };
	    /**
	     * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
	     * Used when creating new views, to pre-fill their complete event children snapshot.
	     *
	     * @param {!Path} treePath
	     * @param {?ChildrenNode} completeServerChildren
	     * @return {!ChildrenNode}
	     */
	    WriteTree.prototype.calcCompleteEventChildren = function (treePath, completeServerChildren) {
	        var completeChildren = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	        var topLevelSet = this.visibleWrites_.getCompleteNode(treePath);
	        if (topLevelSet) {
	            if (!topLevelSet.isLeafNode()) {
	                // we're shadowing everything. Return the children.
	                topLevelSet.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (childName, childSnap) {
	                    completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
	                });
	            }
	            return completeChildren;
	        }
	        else if (completeServerChildren) {
	            // Layer any children we have on top of this
	            // We know we don't have a top-level set, so just enumerate existing children
	            var merge_1 = this.visibleWrites_.childCompoundWrite(treePath);
	            completeServerChildren.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (childName, childNode) {
	                var node = merge_1
	                    .childCompoundWrite(new Path_1.Path(childName))
	                    .apply(childNode);
	                completeChildren = completeChildren.updateImmediateChild(childName, node);
	            });
	            // Add any complete children we have from the set
	            merge_1.getCompleteChildren().forEach(function (namedNode) {
	                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
	            });
	            return completeChildren;
	        }
	        else {
	            // We don't have anything to layer on top of. Layer on any children we have
	            // Note that we can return an empty snap if we have a defined delete
	            var merge = this.visibleWrites_.childCompoundWrite(treePath);
	            merge.getCompleteChildren().forEach(function (namedNode) {
	                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
	            });
	            return completeChildren;
	        }
	    };
	    /**
	     * Given that the underlying server data has updated, determine what, if anything, needs to be
	     * applied to the event cache.
	     *
	     * Possibilities:
	     *
	     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
	     *
	     * 2. Some write is completely shadowing. No events to be raised
	     *
	     * 3. Is partially shadowed. Events
	     *
	     * Either existingEventSnap or existingServerSnap must exist
	     *
	     * @param {!Path} treePath
	     * @param {!Path} childPath
	     * @param {?Node} existingEventSnap
	     * @param {?Node} existingServerSnap
	     * @return {?Node}
	     */
	    WriteTree.prototype.calcEventCacheAfterServerOverwrite = function (treePath, childPath, existingEventSnap, existingServerSnap) {
	        util_2.assert(existingEventSnap || existingServerSnap, 'Either existingEventSnap or existingServerSnap must exist');
	        var path = treePath.child(childPath);
	        if (this.visibleWrites_.hasCompleteWrite(path)) {
	            // At this point we can probably guarantee that we're in case 2, meaning no events
	            // May need to check visibility while doing the findRootMostValueAndPath call
	            return null;
	        }
	        else {
	            // No complete shadowing. We're either partially shadowing or not shadowing at all.
	            var childMerge = this.visibleWrites_.childCompoundWrite(path);
	            if (childMerge.isEmpty()) {
	                // We're not shadowing at all. Case 1
	                return existingServerSnap.getChild(childPath);
	            }
	            else {
	                // This could be more efficient if the serverNode + updates doesn't change the eventSnap
	                // However this is tricky to find out, since user updates don't necessary change the server
	                // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
	                // adds nodes, but doesn't change any existing writes. It is therefore not enough to
	                // only check if the updates change the serverNode.
	                // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
	                return childMerge.apply(existingServerSnap.getChild(childPath));
	            }
	        }
	    };
	    /**
	     * Returns a complete child for a given server snap after applying all user writes or null if there is no
	     * complete child for this ChildKey.
	     *
	     * @param {!Path} treePath
	     * @param {!string} childKey
	     * @param {!CacheNode} existingServerSnap
	     * @return {?Node}
	     */
	    WriteTree.prototype.calcCompleteChild = function (treePath, childKey, existingServerSnap) {
	        var path = treePath.child(childKey);
	        var shadowingNode = this.visibleWrites_.getCompleteNode(path);
	        if (shadowingNode != null) {
	            return shadowingNode;
	        }
	        else {
	            if (existingServerSnap.isCompleteForChild(childKey)) {
	                var childMerge = this.visibleWrites_.childCompoundWrite(path);
	                return childMerge.apply(existingServerSnap.getNode().getImmediateChild(childKey));
	            }
	            else {
	                return null;
	            }
	        }
	    };
	    /**
	     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
	     * a higher path, this will return the child of that write relative to the write and this path.
	     * Returns null if there is no write at this path.
	     *
	     * @param {!Path} path
	     * @return {?Node}
	     */
	    WriteTree.prototype.shadowingWrite = function (path) {
	        return this.visibleWrites_.getCompleteNode(path);
	    };
	    /**
	     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
	     * the window, but may now be in the window.
	     *
	     * @param {!Path} treePath
	     * @param {?Node} completeServerData
	     * @param {!NamedNode} startPost
	     * @param {!number} count
	     * @param {boolean} reverse
	     * @param {!Index} index
	     * @return {!Array.<!NamedNode>}
	     */
	    WriteTree.prototype.calcIndexedSlice = function (treePath, completeServerData, startPost, count, reverse, index) {
	        var toIterate;
	        var merge = this.visibleWrites_.childCompoundWrite(treePath);
	        var shadowingNode = merge.getCompleteNode(Path_1.Path.Empty);
	        if (shadowingNode != null) {
	            toIterate = shadowingNode;
	        }
	        else if (completeServerData != null) {
	            toIterate = merge.apply(completeServerData);
	        }
	        else {
	            // no children to iterate on
	            return [];
	        }
	        toIterate = toIterate.withIndex(index);
	        if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
	            var nodes = [];
	            var cmp = index.getCompare();
	            var iter = reverse
	                ? toIterate.getReverseIteratorFrom(startPost, index)
	                : toIterate.getIteratorFrom(startPost, index);
	            var next = iter.getNext();
	            while (next && nodes.length < count) {
	                if (cmp(next, startPost) !== 0) {
	                    nodes.push(next);
	                }
	                next = iter.getNext();
	            }
	            return nodes;
	        }
	        else {
	            return [];
	        }
	    };
	    /**
	     * @param {!WriteRecord} writeRecord
	     * @param {!Path} path
	     * @return {boolean}
	     * @private
	     */
	    WriteTree.prototype.recordContainsPath_ = function (writeRecord, path) {
	        if (writeRecord.snap) {
	            return writeRecord.path.contains(path);
	        }
	        else {
	            // findKey can return undefined, so use !! to coerce to boolean
	            return !!util_1.findKey(writeRecord.children, function (childSnap, childName) {
	                return writeRecord.path.child(childName).contains(path);
	            });
	        }
	    };
	    /**
	     * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
	     * @private
	     */
	    WriteTree.prototype.resetTree_ = function () {
	        this.visibleWrites_ = WriteTree.layerTree_(this.allWrites_, WriteTree.DefaultFilter_, Path_1.Path.Empty);
	        if (this.allWrites_.length > 0) {
	            this.lastWriteId_ = this.allWrites_[this.allWrites_.length - 1].writeId;
	        }
	        else {
	            this.lastWriteId_ = -1;
	        }
	    };
	    /**
	     * The default filter used when constructing the tree. Keep everything that's visible.
	     *
	     * @param {!WriteRecord} write
	     * @return {boolean}
	     * @private
	     */
	    WriteTree.DefaultFilter_ = function (write) {
	        return write.visible;
	    };
	    /**
	     * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
	     * event data at that path.
	     *
	     * @param {!Array.<!WriteRecord>} writes
	     * @param {!function(!WriteRecord):boolean} filter
	     * @param {!Path} treeRoot
	     * @return {!CompoundWrite}
	     * @private
	     */
	    WriteTree.layerTree_ = function (writes, filter, treeRoot) {
	        var compoundWrite = CompoundWrite_1.CompoundWrite.Empty;
	        for (var i = 0; i < writes.length; ++i) {
	            var write = writes[i];
	            // Theory, a later set will either:
	            // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
	            // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
	            if (filter(write)) {
	                var writePath = write.path;
	                var relativePath = void 0;
	                if (write.snap) {
	                    if (treeRoot.contains(writePath)) {
	                        relativePath = Path_1.Path.relativePath(treeRoot, writePath);
	                        compoundWrite = compoundWrite.addWrite(relativePath, write.snap);
	                    }
	                    else if (writePath.contains(treeRoot)) {
	                        relativePath = Path_1.Path.relativePath(writePath, treeRoot);
	                        compoundWrite = compoundWrite.addWrite(Path_1.Path.Empty, write.snap.getChild(relativePath));
	                    }
	                    else {
	                        // There is no overlap between root path and write path, ignore write
	                    }
	                }
	                else if (write.children) {
	                    if (treeRoot.contains(writePath)) {
	                        relativePath = Path_1.Path.relativePath(treeRoot, writePath);
	                        compoundWrite = compoundWrite.addWrites(relativePath, write.children);
	                    }
	                    else if (writePath.contains(treeRoot)) {
	                        relativePath = Path_1.Path.relativePath(writePath, treeRoot);
	                        if (relativePath.isEmpty()) {
	                            compoundWrite = compoundWrite.addWrites(Path_1.Path.Empty, write.children);
	                        }
	                        else {
	                            var child = util_1.safeGet(write.children, relativePath.getFront());
	                            if (child) {
	                                // There exists a child in this node that matches the root path
	                                var deepNode = child.getChild(relativePath.popFront());
	                                compoundWrite = compoundWrite.addWrite(Path_1.Path.Empty, deepNode);
	                            }
	                        }
	                    }
	                    else {
	                        // There is no overlap between root path and write path, ignore write
	                    }
	                }
	                else {
	                    throw util_2.assertionError('WriteRecord should have .snap or .children');
	                }
	            }
	        }
	        return compoundWrite;
	    };
	    return WriteTree;
	}());
	exports.WriteTree = WriteTree;
	/**
	 * A WriteTreeRef wraps a WriteTree and a path, for convenient access to a particular subtree.  All of the methods
	 * just proxy to the underlying WriteTree.
	 *
	 * @constructor
	 */
	var WriteTreeRef = /** @class */ (function () {
	    /**
	     * @param {!Path} path
	     * @param {!WriteTree} writeTree
	     */
	    function WriteTreeRef(path, writeTree) {
	        this.treePath_ = path;
	        this.writeTree_ = writeTree;
	    }
	    /**
	     * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
	     * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
	     * can lead to a more expensive calculation.
	     *
	     * @param {?Node} completeServerCache
	     * @param {Array.<number>=} writeIdsToExclude Optional writes to exclude.
	     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
	     * @return {?Node}
	     */
	    WriteTreeRef.prototype.calcCompleteEventCache = function (completeServerCache, writeIdsToExclude, includeHiddenWrites) {
	        return this.writeTree_.calcCompleteEventCache(this.treePath_, completeServerCache, writeIdsToExclude, includeHiddenWrites);
	    };
	    /**
	     * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
	     * mix of the given server data and write data.
	     *
	     * @param {?ChildrenNode} completeServerChildren
	     * @return {!ChildrenNode}
	     */
	    WriteTreeRef.prototype.calcCompleteEventChildren = function (completeServerChildren) {
	        return this.writeTree_.calcCompleteEventChildren(this.treePath_, completeServerChildren);
	    };
	    /**
	     * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
	     * if anything, needs to be applied to the event cache.
	     *
	     * Possibilities:
	     *
	     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
	     *
	     * 2. Some write is completely shadowing. No events to be raised
	     *
	     * 3. Is partially shadowed. Events should be raised
	     *
	     * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
	     *
	     * @param {!Path} path
	     * @param {?Node} existingEventSnap
	     * @param {?Node} existingServerSnap
	     * @return {?Node}
	     */
	    WriteTreeRef.prototype.calcEventCacheAfterServerOverwrite = function (path, existingEventSnap, existingServerSnap) {
	        return this.writeTree_.calcEventCacheAfterServerOverwrite(this.treePath_, path, existingEventSnap, existingServerSnap);
	    };
	    /**
	     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
	     * a higher path, this will return the child of that write relative to the write and this path.
	     * Returns null if there is no write at this path.
	     *
	     * @param {!Path} path
	     * @return {?Node}
	     */
	    WriteTreeRef.prototype.shadowingWrite = function (path) {
	        return this.writeTree_.shadowingWrite(this.treePath_.child(path));
	    };
	    /**
	     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
	     * the window, but may now be in the window
	     *
	     * @param {?Node} completeServerData
	     * @param {!NamedNode} startPost
	     * @param {!number} count
	     * @param {boolean} reverse
	     * @param {!Index} index
	     * @return {!Array.<!NamedNode>}
	     */
	    WriteTreeRef.prototype.calcIndexedSlice = function (completeServerData, startPost, count, reverse, index) {
	        return this.writeTree_.calcIndexedSlice(this.treePath_, completeServerData, startPost, count, reverse, index);
	    };
	    /**
	     * Returns a complete child for a given server snap after applying all user writes or null if there is no
	     * complete child for this ChildKey.
	     *
	     * @param {!string} childKey
	     * @param {!CacheNode} existingServerCache
	     * @return {?Node}
	     */
	    WriteTreeRef.prototype.calcCompleteChild = function (childKey, existingServerCache) {
	        return this.writeTree_.calcCompleteChild(this.treePath_, childKey, existingServerCache);
	    };
	    /**
	     * Return a WriteTreeRef for a child.
	     *
	     * @param {string} childName
	     * @return {!WriteTreeRef}
	     */
	    WriteTreeRef.prototype.child = function (childName) {
	        return new WriteTreeRef(this.treePath_.child(childName), this.writeTree_);
	    };
	    return WriteTreeRef;
	}());
	exports.WriteTreeRef = WriteTreeRef;
	
	//# sourceMappingURL=WriteTree.js.map


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var Path_1 = __webpack_require__(17);
	var Operation_1 = __webpack_require__(47);
	var AckUserWrite = /** @class */ (function () {
	    /**
	     *
	     * @param {!Path} path
	     * @param {!ImmutableTree<!boolean>} affectedTree A tree containing true for each affected path. Affected paths can't overlap.
	     * @param {!boolean} revert
	     */
	    function AckUserWrite(
	        /**@inheritDoc */ path, 
	        /**@inheritDoc */ affectedTree, 
	        /**@inheritDoc */ revert) {
	        this.path = path;
	        this.affectedTree = affectedTree;
	        this.revert = revert;
	        /** @inheritDoc */
	        this.type = Operation_1.OperationType.ACK_USER_WRITE;
	        /** @inheritDoc */
	        this.source = Operation_1.OperationSource.User;
	    }
	    /**
	     * @inheritDoc
	     */
	    AckUserWrite.prototype.operationForChild = function (childName) {
	        if (!this.path.isEmpty()) {
	            util_1.assert(this.path.getFront() === childName, 'operationForChild called for unrelated child.');
	            return new AckUserWrite(this.path.popFront(), this.affectedTree, this.revert);
	        }
	        else if (this.affectedTree.value != null) {
	            util_1.assert(this.affectedTree.children.isEmpty(), 'affectedTree should not have overlapping affected paths.');
	            // All child locations are affected as well; just return same operation.
	            return this;
	        }
	        else {
	            var childTree = this.affectedTree.subtree(new Path_1.Path(childName));
	            return new AckUserWrite(Path_1.Path.Empty, childTree, this.revert);
	        }
	    };
	    return AckUserWrite;
	}());
	exports.AckUserWrite = AckUserWrite;
	
	//# sourceMappingURL=AckUserWrite.js.map


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Path_1 = __webpack_require__(17);
	var Operation_1 = __webpack_require__(47);
	/**
	 * @param {!OperationSource} source
	 * @param {!Path} path
	 * @constructor
	 * @implements {Operation}
	 */
	var ListenComplete = /** @class */ (function () {
	    function ListenComplete(source, path) {
	        this.source = source;
	        this.path = path;
	        /** @inheritDoc */
	        this.type = Operation_1.OperationType.LISTEN_COMPLETE;
	    }
	    ListenComplete.prototype.operationForChild = function (childName) {
	        if (this.path.isEmpty()) {
	            return new ListenComplete(this.source, Path_1.Path.Empty);
	        }
	        else {
	            return new ListenComplete(this.source, this.path.popFront());
	        }
	    };
	    return ListenComplete;
	}());
	exports.ListenComplete = ListenComplete;
	
	//# sourceMappingURL=ListenComplete.js.map


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Operation_1 = __webpack_require__(47);
	var Overwrite_1 = __webpack_require__(172);
	var Path_1 = __webpack_require__(17);
	var util_1 = __webpack_require__(2);
	/**
	 * @param {!OperationSource} source
	 * @param {!Path} path
	 * @param {!ImmutableTree.<!Node>} children
	 * @constructor
	 * @implements {Operation}
	 */
	var Merge = /** @class */ (function () {
	    function Merge(
	        /**@inheritDoc */ source, 
	        /**@inheritDoc */ path, 
	        /**@inheritDoc */ children) {
	        this.source = source;
	        this.path = path;
	        this.children = children;
	        /** @inheritDoc */
	        this.type = Operation_1.OperationType.MERGE;
	    }
	    /**
	     * @inheritDoc
	     */
	    Merge.prototype.operationForChild = function (childName) {
	        if (this.path.isEmpty()) {
	            var childTree = this.children.subtree(new Path_1.Path(childName));
	            if (childTree.isEmpty()) {
	                // This child is unaffected
	                return null;
	            }
	            else if (childTree.value) {
	                // We have a snapshot for the child in question.  This becomes an overwrite of the child.
	                return new Overwrite_1.Overwrite(this.source, Path_1.Path.Empty, childTree.value);
	            }
	            else {
	                // This is a merge at a deeper level
	                return new Merge(this.source, Path_1.Path.Empty, childTree);
	            }
	        }
	        else {
	            util_1.assert(this.path.getFront() === childName, "Can't get a merge for a child not on the path of the operation");
	            return new Merge(this.source, this.path.popFront(), this.children);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Merge.prototype.toString = function () {
	        return ('Operation(' +
	            this.path +
	            ': ' +
	            this.source.toString() +
	            ' merge: ' +
	            this.children.toString() +
	            ')');
	    };
	    return Merge;
	}());
	exports.Merge = Merge;
	
	//# sourceMappingURL=Merge.js.map


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var util_2 = __webpack_require__(2);
	/**
	 * Tracks a collection of stats.
	 *
	 * @constructor
	 */
	var StatsCollection = /** @class */ (function () {
	    function StatsCollection() {
	        this.counters_ = {};
	    }
	    StatsCollection.prototype.incrementCounter = function (name, amount) {
	        if (amount === void 0) { amount = 1; }
	        if (!util_2.contains(this.counters_, name))
	            this.counters_[name] = 0;
	        this.counters_[name] += amount;
	    };
	    StatsCollection.prototype.get = function () {
	        return util_1.deepCopy(this.counters_);
	    };
	    return StatsCollection;
	}());
	exports.StatsCollection = StatsCollection;
	
	//# sourceMappingURL=StatsCollection.js.map


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var util_2 = __webpack_require__(13);
	var StatsListener_1 = __webpack_require__(179);
	// Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
	// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
	// seconds to try to ensure the Firebase connection is established / settled.
	var FIRST_STATS_MIN_TIME = 10 * 1000;
	var FIRST_STATS_MAX_TIME = 30 * 1000;
	// We'll continue to report stats on average every 5 minutes.
	var REPORT_STATS_INTERVAL = 5 * 60 * 1000;
	/**
	 * @constructor
	 */
	var StatsReporter = /** @class */ (function () {
	    /**
	     * @param collection
	     * @param server_
	     */
	    function StatsReporter(collection, server_) {
	        this.server_ = server_;
	        this.statsToReport_ = {};
	        this.statsListener_ = new StatsListener_1.StatsListener(collection);
	        var timeout = FIRST_STATS_MIN_TIME +
	            (FIRST_STATS_MAX_TIME - FIRST_STATS_MIN_TIME) * Math.random();
	        util_2.setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
	    }
	    StatsReporter.prototype.includeStat = function (stat) {
	        this.statsToReport_[stat] = true;
	    };
	    StatsReporter.prototype.reportStats_ = function () {
	        var _this = this;
	        var stats = this.statsListener_.get();
	        var reportedStats = {};
	        var haveStatsToReport = false;
	        util_1.forEach(stats, function (stat, value) {
	            if (value > 0 && util_1.contains(_this.statsToReport_, stat)) {
	                reportedStats[stat] = value;
	                haveStatsToReport = true;
	            }
	        });
	        if (haveStatsToReport) {
	            this.server_.reportStats(reportedStats);
	        }
	        // queue our next run.
	        util_2.setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * REPORT_STATS_INTERVAL));
	    };
	    return StatsReporter;
	}());
	exports.StatsReporter = StatsReporter;
	
	//# sourceMappingURL=StatsReporter.js.map


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	/**
	 * Wraps a DOM Storage object and:
	 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
	 * - prefixes names with "firebase:" to avoid collisions with app data.
	 *
	 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
	 * and one for localStorage.
	 *
	 * @constructor
	 */
	var DOMStorageWrapper = /** @class */ (function () {
	    /**
	     * @param {Storage} domStorage_ The underlying storage object (e.g. localStorage or sessionStorage)
	     */
	    function DOMStorageWrapper(domStorage_) {
	        this.domStorage_ = domStorage_;
	        // Use a prefix to avoid collisions with other stuff saved by the app.
	        this.prefix_ = 'firebase:';
	    }
	    /**
	     * @param {string} key The key to save the value under
	     * @param {?Object} value The value being stored, or null to remove the key.
	     */
	    DOMStorageWrapper.prototype.set = function (key, value) {
	        if (value == null) {
	            this.domStorage_.removeItem(this.prefixedName_(key));
	        }
	        else {
	            this.domStorage_.setItem(this.prefixedName_(key), util_1.stringify(value));
	        }
	    };
	    /**
	     * @param {string} key
	     * @return {*} The value that was stored under this key, or null
	     */
	    DOMStorageWrapper.prototype.get = function (key) {
	        var storedVal = this.domStorage_.getItem(this.prefixedName_(key));
	        if (storedVal == null) {
	            return null;
	        }
	        else {
	            return util_1.jsonEval(storedVal);
	        }
	    };
	    /**
	     * @param {string} key
	     */
	    DOMStorageWrapper.prototype.remove = function (key) {
	        this.domStorage_.removeItem(this.prefixedName_(key));
	    };
	    /**
	     * @param {string} name
	     * @return {string}
	     */
	    DOMStorageWrapper.prototype.prefixedName_ = function (name) {
	        return this.prefix_ + name;
	    };
	    DOMStorageWrapper.prototype.toString = function () {
	        return this.domStorage_.toString();
	    };
	    return DOMStorageWrapper;
	}());
	exports.DOMStorageWrapper = DOMStorageWrapper;
	
	//# sourceMappingURL=DOMStorageWrapper.js.map


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	/**
	 * An in-memory storage implementation that matches the API of DOMStorageWrapper
	 * (TODO: create interface for both to implement).
	 *
	 * @constructor
	 */
	var MemoryStorage = /** @class */ (function () {
	    function MemoryStorage() {
	        this.cache_ = {};
	        this.isInMemoryStorage = true;
	    }
	    MemoryStorage.prototype.set = function (key, value) {
	        if (value == null) {
	            delete this.cache_[key];
	        }
	        else {
	            this.cache_[key] = value;
	        }
	    };
	    MemoryStorage.prototype.get = function (key) {
	        if (util_1.contains(this.cache_, key)) {
	            return this.cache_[key];
	        }
	        return null;
	    };
	    MemoryStorage.prototype.remove = function (key) {
	        delete this.cache_[key];
	    };
	    return MemoryStorage;
	}());
	exports.MemoryStorage = MemoryStorage;
	
	//# sourceMappingURL=MemoryStorage.js.map


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	/**
	 * Fancy ID generator that creates 20-character string identifiers with the
	 * following properties:
	 *
	 * 1. They're based on timestamp so that they sort *after* any existing ids.
	 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
	 *    collide with other clients' IDs.
	 * 3. They sort *lexicographically* (so the timestamp is converted to characters
	 *    that will sort properly).
	 * 4. They're monotonically increasing. Even if you generate more than one in
	 *    the same timestamp, the latter ones will sort after the former ones. We do
	 *    this by using the previous random bits but "incrementing" them by 1 (only
	 *    in the case of a timestamp collision).
	 */
	exports.nextPushId = (function () {
	    // Modeled after base64 web-safe chars, but ordered by ASCII.
	    var PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
	    // Timestamp of last push, used to prevent local collisions if you push twice
	    // in one ms.
	    var lastPushTime = 0;
	    // We generate 72-bits of randomness which get turned into 12 characters and
	    // appended to the timestamp to prevent collisions with other clients. We
	    // store the last characters we generated because in the event of a collision,
	    // we'll use those same characters except "incremented" by one.
	    var lastRandChars = [];
	    return function (now) {
	        var duplicateTime = now === lastPushTime;
	        lastPushTime = now;
	        var i;
	        var timeStampChars = new Array(8);
	        for (i = 7; i >= 0; i--) {
	            timeStampChars[i] = PUSH_CHARS.charAt(now % 64);
	            // NOTE: Can't use << here because javascript will convert to int and lose
	            // the upper bits.
	            now = Math.floor(now / 64);
	        }
	        util_1.assert(now === 0, 'Cannot push at time == 0');
	        var id = timeStampChars.join('');
	        if (!duplicateTime) {
	            for (i = 0; i < 12; i++) {
	                lastRandChars[i] = Math.floor(Math.random() * 64);
	            }
	        }
	        else {
	            // If the timestamp hasn't changed since last push, use the same random
	            // number, except incremented by 1.
	            for (i = 11; i >= 0 && lastRandChars[i] === 63; i--) {
	                lastRandChars[i] = 0;
	            }
	            lastRandChars[i]++;
	        }
	        for (i = 0; i < 12; i++) {
	            id += PUSH_CHARS.charAt(lastRandChars[i]);
	        }
	        util_1.assert(id.length === 20, 'nextPushId: Length should be 20.');
	        return id;
	    };
	})();
	
	//# sourceMappingURL=NextPushId.js.map


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var EventEmitter_1 = __webpack_require__(181);
	var util_2 = __webpack_require__(2);
	/**
	 * Monitors online state (as reported by window.online/offline events).
	 *
	 * The expectation is that this could have many false positives (thinks we are online
	 * when we're not), but no false negatives.  So we can safely use it to determine when
	 * we definitely cannot reach the internet.
	 *
	 * @extends {EventEmitter}
	 */
	var OnlineMonitor = /** @class */ (function (_super) {
	    __extends(OnlineMonitor, _super);
	    function OnlineMonitor() {
	        var _this = _super.call(this, ['online']) || this;
	        _this.online_ = true;
	        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
	        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
	        // It would seem that the 'online' event does not always fire consistently. So we disable it
	        // for Cordova.
	        if (typeof window !== 'undefined' &&
	            typeof window.addEventListener !== 'undefined' &&
	            !util_2.isMobileCordova()) {
	            window.addEventListener('online', function () {
	                if (!_this.online_) {
	                    _this.online_ = true;
	                    _this.trigger('online', true);
	                }
	            }, false);
	            window.addEventListener('offline', function () {
	                if (_this.online_) {
	                    _this.online_ = false;
	                    _this.trigger('online', false);
	                }
	            }, false);
	        }
	        return _this;
	    }
	    OnlineMonitor.getInstance = function () {
	        return new OnlineMonitor();
	    };
	    /**
	     * @param {!string} eventType
	     * @return {Array.<boolean>}
	     */
	    OnlineMonitor.prototype.getInitialEvent = function (eventType) {
	        util_1.assert(eventType === 'online', 'Unknown event type: ' + eventType);
	        return [this.online_];
	    };
	    /**
	     * @return {boolean}
	     */
	    OnlineMonitor.prototype.currentlyOnline = function () {
	        return this.online_;
	    };
	    return OnlineMonitor;
	}(EventEmitter_1.EventEmitter));
	exports.OnlineMonitor = OnlineMonitor;
	
	//# sourceMappingURL=OnlineMonitor.js.map


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var Path_1 = __webpack_require__(17);
	var util_2 = __webpack_require__(2);
	/**
	 * Node in a Tree.
	 */
	var TreeNode = /** @class */ (function () {
	    function TreeNode() {
	        // TODO: Consider making accessors that create children and value lazily or
	        // separate Internal / Leaf 'types'.
	        this.children = {};
	        this.childCount = 0;
	        this.value = null;
	    }
	    return TreeNode;
	}());
	exports.TreeNode = TreeNode;
	/**
	 * A light-weight tree, traversable by path.  Nodes can have both values and children.
	 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
	 * children.
	 */
	var Tree = /** @class */ (function () {
	    /**
	     * @template T
	     * @param {string=} name_ Optional name of the node.
	     * @param {Tree=} parent_ Optional parent node.
	     * @param {TreeNode=} node_ Optional node to wrap.
	     */
	    function Tree(name_, parent_, node_) {
	        if (name_ === void 0) { name_ = ''; }
	        if (parent_ === void 0) { parent_ = null; }
	        if (node_ === void 0) { node_ = new TreeNode(); }
	        this.name_ = name_;
	        this.parent_ = parent_;
	        this.node_ = node_;
	    }
	    /**
	     * Returns a sub-Tree for the given path.
	     *
	     * @param {!(string|Path)} pathObj Path to look up.
	     * @return {!Tree.<T>} Tree for path.
	     */
	    Tree.prototype.subTree = function (pathObj) {
	        // TODO: Require pathObj to be Path?
	        var path = pathObj instanceof Path_1.Path ? pathObj : new Path_1.Path(pathObj);
	        var child = this, next;
	        while ((next = path.getFront()) !== null) {
	            var childNode = util_2.safeGet(child.node_.children, next) || new TreeNode();
	            child = new Tree(next, child, childNode);
	            path = path.popFront();
	        }
	        return child;
	    };
	    /**
	     * Returns the data associated with this tree node.
	     *
	     * @return {?T} The data or null if no data exists.
	     */
	    Tree.prototype.getValue = function () {
	        return this.node_.value;
	    };
	    /**
	     * Sets data to this tree node.
	     *
	     * @param {!T} value Value to set.
	     */
	    Tree.prototype.setValue = function (value) {
	        util_1.assert(typeof value !== 'undefined', 'Cannot set value to undefined');
	        this.node_.value = value;
	        this.updateParents_();
	    };
	    /**
	     * Clears the contents of the tree node (its value and all children).
	     */
	    Tree.prototype.clear = function () {
	        this.node_.value = null;
	        this.node_.children = {};
	        this.node_.childCount = 0;
	        this.updateParents_();
	    };
	    /**
	     * @return {boolean} Whether the tree has any children.
	     */
	    Tree.prototype.hasChildren = function () {
	        return this.node_.childCount > 0;
	    };
	    /**
	     * @return {boolean} Whether the tree is empty (no value or children).
	     */
	    Tree.prototype.isEmpty = function () {
	        return this.getValue() === null && !this.hasChildren();
	    };
	    /**
	     * Calls action for each child of this tree node.
	     *
	     * @param {function(!Tree.<T>)} action Action to be called for each child.
	     */
	    Tree.prototype.forEachChild = function (action) {
	        var _this = this;
	        util_2.forEach(this.node_.children, function (child, childTree) {
	            action(new Tree(child, _this, childTree));
	        });
	    };
	    /**
	     * Does a depth-first traversal of this node's descendants, calling action for each one.
	     *
	     * @param {function(!Tree.<T>)} action Action to be called for each child.
	     * @param {boolean=} includeSelf Whether to call action on this node as well. Defaults to
	     *   false.
	     * @param {boolean=} childrenFirst Whether to call action on children before calling it on
	     *   parent.
	     */
	    Tree.prototype.forEachDescendant = function (action, includeSelf, childrenFirst) {
	        if (includeSelf && !childrenFirst)
	            action(this);
	        this.forEachChild(function (child) {
	            child.forEachDescendant(action, /*includeSelf=*/ true, childrenFirst);
	        });
	        if (includeSelf && childrenFirst)
	            action(this);
	    };
	    /**
	     * Calls action on each ancestor node.
	     *
	     * @param {function(!Tree.<T>)} action Action to be called on each parent; return
	     *   true to abort.
	     * @param {boolean=} includeSelf Whether to call action on this node as well.
	     * @return {boolean} true if the action callback returned true.
	     */
	    Tree.prototype.forEachAncestor = function (action, includeSelf) {
	        var node = includeSelf ? this : this.parent();
	        while (node !== null) {
	            if (action(node)) {
	                return true;
	            }
	            node = node.parent();
	        }
	        return false;
	    };
	    /**
	     * Does a depth-first traversal of this node's descendants.  When a descendant with a value
	     * is found, action is called on it and traversal does not continue inside the node.
	     * Action is *not* called on this node.
	     *
	     * @param {function(!Tree.<T>)} action Action to be called for each child.
	     */
	    Tree.prototype.forEachImmediateDescendantWithValue = function (action) {
	        this.forEachChild(function (child) {
	            if (child.getValue() !== null)
	                action(child);
	            else
	                child.forEachImmediateDescendantWithValue(action);
	        });
	    };
	    /**
	     * @return {!Path} The path of this tree node, as a Path.
	     */
	    Tree.prototype.path = function () {
	        return new Path_1.Path(this.parent_ === null
	            ? this.name_
	            : this.parent_.path() + '/' + this.name_);
	    };
	    /**
	     * @return {string} The name of the tree node.
	     */
	    Tree.prototype.name = function () {
	        return this.name_;
	    };
	    /**
	     * @return {?Tree} The parent tree node, or null if this is the root of the tree.
	     */
	    Tree.prototype.parent = function () {
	        return this.parent_;
	    };
	    /**
	     * Adds or removes this child from its parent based on whether it's empty or not.
	     *
	     * @private
	     */
	    Tree.prototype.updateParents_ = function () {
	        if (this.parent_ !== null)
	            this.parent_.updateChild_(this.name_, this);
	    };
	    /**
	     * Adds or removes the passed child to this tree node, depending on whether it's empty.
	     *
	     * @param {string} childName The name of the child to update.
	     * @param {!Tree.<T>} child The child to update.
	     * @private
	     */
	    Tree.prototype.updateChild_ = function (childName, child) {
	        var childEmpty = child.isEmpty();
	        var childExists = util_2.contains(this.node_.children, childName);
	        if (childEmpty && childExists) {
	            delete this.node_.children[childName];
	            this.node_.childCount--;
	            this.updateParents_();
	        }
	        else if (!childEmpty && !childExists) {
	            this.node_.children[childName] = child.node_;
	            this.node_.childCount++;
	            this.updateParents_();
	        }
	    };
	    return Tree;
	}());
	exports.Tree = Tree;
	
	//# sourceMappingURL=Tree.js.map


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventEmitter_1 = __webpack_require__(181);
	var util_1 = __webpack_require__(2);
	/**
	 * @extends {EventEmitter}
	 */
	var VisibilityMonitor = /** @class */ (function (_super) {
	    __extends(VisibilityMonitor, _super);
	    function VisibilityMonitor() {
	        var _this = _super.call(this, ['visible']) || this;
	        var hidden;
	        var visibilityChange;
	        if (typeof document !== 'undefined' &&
	            typeof document.addEventListener !== 'undefined') {
	            if (typeof document['hidden'] !== 'undefined') {
	                // Opera 12.10 and Firefox 18 and later support
	                visibilityChange = 'visibilitychange';
	                hidden = 'hidden';
	            }
	            else if (typeof document['mozHidden'] !== 'undefined') {
	                visibilityChange = 'mozvisibilitychange';
	                hidden = 'mozHidden';
	            }
	            else if (typeof document['msHidden'] !== 'undefined') {
	                visibilityChange = 'msvisibilitychange';
	                hidden = 'msHidden';
	            }
	            else if (typeof document['webkitHidden'] !== 'undefined') {
	                visibilityChange = 'webkitvisibilitychange';
	                hidden = 'webkitHidden';
	            }
	        }
	        // Initially, we always assume we are visible. This ensures that in browsers
	        // without page visibility support or in cases where we are never visible
	        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
	        // reconnects
	        _this.visible_ = true;
	        if (visibilityChange) {
	            document.addEventListener(visibilityChange, function () {
	                var visible = !document[hidden];
	                if (visible !== _this.visible_) {
	                    _this.visible_ = visible;
	                    _this.trigger('visible', visible);
	                }
	            }, false);
	        }
	        return _this;
	    }
	    VisibilityMonitor.getInstance = function () {
	        return new VisibilityMonitor();
	    };
	    /**
	     * @param {!string} eventType
	     * @return {Array.<boolean>}
	     */
	    VisibilityMonitor.prototype.getInitialEvent = function (eventType) {
	        util_1.assert(eventType === 'visible', 'Unknown event type: ' + eventType);
	        return [this.visible_];
	    };
	    return VisibilityMonitor;
	}(EventEmitter_1.EventEmitter));
	exports.VisibilityMonitor = VisibilityMonitor;
	
	//# sourceMappingURL=VisibilityMonitor.js.map


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var Change_1 = __webpack_require__(54);
	var util_2 = __webpack_require__(2);
	/**
	 * @constructor
	 */
	var ChildChangeAccumulator = /** @class */ (function () {
	    function ChildChangeAccumulator() {
	        this.changeMap_ = {};
	    }
	    /**
	     * @param {!Change} change
	     */
	    ChildChangeAccumulator.prototype.trackChildChange = function (change) {
	        var type = change.type;
	        var childKey /** @type {!string} */ = change.childName;
	        util_2.assert(type == Change_1.Change.CHILD_ADDED ||
	            type == Change_1.Change.CHILD_CHANGED ||
	            type == Change_1.Change.CHILD_REMOVED, 'Only child changes supported for tracking');
	        util_2.assert(childKey !== '.priority', 'Only non-priority child changes can be tracked.');
	        var oldChange = util_1.safeGet(this.changeMap_, childKey);
	        if (oldChange) {
	            var oldType = oldChange.type;
	            if (type == Change_1.Change.CHILD_ADDED && oldType == Change_1.Change.CHILD_REMOVED) {
	                this.changeMap_[childKey] = Change_1.Change.childChangedChange(childKey, change.snapshotNode, oldChange.snapshotNode);
	            }
	            else if (type == Change_1.Change.CHILD_REMOVED &&
	                oldType == Change_1.Change.CHILD_ADDED) {
	                delete this.changeMap_[childKey];
	            }
	            else if (type == Change_1.Change.CHILD_REMOVED &&
	                oldType == Change_1.Change.CHILD_CHANGED) {
	                this.changeMap_[childKey] = Change_1.Change.childRemovedChange(childKey, oldChange.oldSnap);
	            }
	            else if (type == Change_1.Change.CHILD_CHANGED &&
	                oldType == Change_1.Change.CHILD_ADDED) {
	                this.changeMap_[childKey] = Change_1.Change.childAddedChange(childKey, change.snapshotNode);
	            }
	            else if (type == Change_1.Change.CHILD_CHANGED &&
	                oldType == Change_1.Change.CHILD_CHANGED) {
	                this.changeMap_[childKey] = Change_1.Change.childChangedChange(childKey, change.snapshotNode, oldChange.oldSnap);
	            }
	            else {
	                throw util_2.assertionError('Illegal combination of changes: ' +
	                    change +
	                    ' occurred after ' +
	                    oldChange);
	            }
	        }
	        else {
	            this.changeMap_[childKey] = change;
	        }
	    };
	    /**
	     * @return {!Array.<!Change>}
	     */
	    ChildChangeAccumulator.prototype.getChanges = function () {
	        return util_1.getValues(this.changeMap_);
	    };
	    return ChildChangeAccumulator;
	}());
	exports.ChildChangeAccumulator = ChildChangeAccumulator;
	
	//# sourceMappingURL=ChildChangeAccumulator.js.map


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var CacheNode_1 = __webpack_require__(91);
	/**
	 * An implementation of CompleteChildSource that never returns any additional children
	 *
	 * @private
	 * @constructor
	 * @implements CompleteChildSource
	 */
	var NoCompleteChildSource_ = /** @class */ (function () {
	    function NoCompleteChildSource_() {
	    }
	    /**
	     * @inheritDoc
	     */
	    NoCompleteChildSource_.prototype.getCompleteChild = function (childKey) {
	        return null;
	    };
	    /**
	     * @inheritDoc
	     */
	    NoCompleteChildSource_.prototype.getChildAfterChild = function (index, child, reverse) {
	        return null;
	    };
	    return NoCompleteChildSource_;
	}());
	exports.NoCompleteChildSource_ = NoCompleteChildSource_;
	/**
	 * Singleton instance.
	 * @const
	 * @type {!CompleteChildSource}
	 */
	exports.NO_COMPLETE_CHILD_SOURCE = new NoCompleteChildSource_();
	/**
	 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
	 * old event caches available to calculate complete children.
	 *
	 *
	 * @implements CompleteChildSource
	 */
	var WriteTreeCompleteChildSource = /** @class */ (function () {
	    /**
	     * @param {!WriteTreeRef} writes_
	     * @param {!ViewCache} viewCache_
	     * @param {?Node} optCompleteServerCache_
	     */
	    function WriteTreeCompleteChildSource(writes_, viewCache_, optCompleteServerCache_) {
	        if (optCompleteServerCache_ === void 0) { optCompleteServerCache_ = null; }
	        this.writes_ = writes_;
	        this.viewCache_ = viewCache_;
	        this.optCompleteServerCache_ = optCompleteServerCache_;
	    }
	    /**
	     * @inheritDoc
	     */
	    WriteTreeCompleteChildSource.prototype.getCompleteChild = function (childKey) {
	        var node = this.viewCache_.getEventCache();
	        if (node.isCompleteForChild(childKey)) {
	            return node.getNode().getImmediateChild(childKey);
	        }
	        else {
	            var serverNode = this.optCompleteServerCache_ != null
	                ? new CacheNode_1.CacheNode(this.optCompleteServerCache_, true, false)
	                : this.viewCache_.getServerCache();
	            return this.writes_.calcCompleteChild(childKey, serverNode);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    WriteTreeCompleteChildSource.prototype.getChildAfterChild = function (index, child, reverse) {
	        var completeServerData = this.optCompleteServerCache_ != null
	            ? this.optCompleteServerCache_
	            : this.viewCache_.getCompleteServerSnap();
	        var nodes = this.writes_.calcIndexedSlice(completeServerData, child, 1, reverse, index);
	        if (nodes.length === 0) {
	            return null;
	        }
	        else {
	            return nodes[0];
	        }
	    };
	    return WriteTreeCompleteChildSource;
	}());
	exports.WriteTreeCompleteChildSource = WriteTreeCompleteChildSource;
	
	//# sourceMappingURL=CompleteChildSource.js.map


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	/**
	 * Encapsulates the data needed to raise an event
	 * @implements {Event}
	 */
	var DataEvent = /** @class */ (function () {
	    /**
	     * @param {!string} eventType One of: value, child_added, child_changed, child_moved, child_removed
	     * @param {!EventRegistration} eventRegistration The function to call to with the event data. User provided
	     * @param {!DataSnapshot} snapshot The data backing the event
	     * @param {?string=} prevName Optional, the name of the previous child for child_* events.
	     */
	    function DataEvent(eventType, eventRegistration, snapshot, prevName) {
	        this.eventType = eventType;
	        this.eventRegistration = eventRegistration;
	        this.snapshot = snapshot;
	        this.prevName = prevName;
	    }
	    /**
	     * @inheritDoc
	     */
	    DataEvent.prototype.getPath = function () {
	        var ref = this.snapshot.getRef();
	        if (this.eventType === 'value') {
	            return ref.path;
	        }
	        else {
	            return ref.getParent().path;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    DataEvent.prototype.getEventType = function () {
	        return this.eventType;
	    };
	    /**
	     * @inheritDoc
	     */
	    DataEvent.prototype.getEventRunner = function () {
	        return this.eventRegistration.getEventRunner(this);
	    };
	    /**
	     * @inheritDoc
	     */
	    DataEvent.prototype.toString = function () {
	        return (this.getPath().toString() +
	            ':' +
	            this.eventType +
	            ':' +
	            util_1.stringify(this.snapshot.exportVal()));
	    };
	    return DataEvent;
	}());
	exports.DataEvent = DataEvent;
	var CancelEvent = /** @class */ (function () {
	    /**
	     * @param {EventRegistration} eventRegistration
	     * @param {Error} error
	     * @param {!Path} path
	     */
	    function CancelEvent(eventRegistration, error, path) {
	        this.eventRegistration = eventRegistration;
	        this.error = error;
	        this.path = path;
	    }
	    /**
	     * @inheritDoc
	     */
	    CancelEvent.prototype.getPath = function () {
	        return this.path;
	    };
	    /**
	     * @inheritDoc
	     */
	    CancelEvent.prototype.getEventType = function () {
	        return 'cancel';
	    };
	    /**
	     * @inheritDoc
	     */
	    CancelEvent.prototype.getEventRunner = function () {
	        return this.eventRegistration.getEventRunner(this);
	    };
	    /**
	     * @inheritDoc
	     */
	    CancelEvent.prototype.toString = function () {
	        return this.path.toString() + ':cancel';
	    };
	    return CancelEvent;
	}());
	exports.CancelEvent = CancelEvent;
	
	//# sourceMappingURL=Event.js.map


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Node_1 = __webpack_require__(30);
	var Change_1 = __webpack_require__(54);
	var util_1 = __webpack_require__(2);
	/**
	 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
	 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
	 * for details.
	 *
	 * @constructor
	 */
	var EventGenerator = /** @class */ (function () {
	    /**
	     *
	     * @param {!Query} query_
	     */
	    function EventGenerator(query_) {
	        this.query_ = query_;
	        /**
	         * @private
	         * @type {!Index}
	         */
	        this.index_ = this.query_.getQueryParams().getIndex();
	    }
	    /**
	     * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
	     * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
	     *
	     * Notes:
	     *  - child_moved events will be synthesized at this time for any child_changed events that affect
	     *    our index.
	     *  - prevName will be calculated based on the index ordering.
	     *
	     * @param {!Array.<!Change>} changes
	     * @param {!Node} eventCache
	     * @param {!Array.<!EventRegistration>} eventRegistrations
	     * @return {!Array.<!Event>}
	     */
	    EventGenerator.prototype.generateEventsForChanges = function (changes, eventCache, eventRegistrations) {
	        var _this = this;
	        var events = [];
	        var moves = [];
	        changes.forEach(function (change) {
	            if (change.type === Change_1.Change.CHILD_CHANGED &&
	                _this.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) {
	                moves.push(Change_1.Change.childMovedChange(change.childName, change.snapshotNode));
	            }
	        });
	        this.generateEventsForType_(events, Change_1.Change.CHILD_REMOVED, changes, eventRegistrations, eventCache);
	        this.generateEventsForType_(events, Change_1.Change.CHILD_ADDED, changes, eventRegistrations, eventCache);
	        this.generateEventsForType_(events, Change_1.Change.CHILD_MOVED, moves, eventRegistrations, eventCache);
	        this.generateEventsForType_(events, Change_1.Change.CHILD_CHANGED, changes, eventRegistrations, eventCache);
	        this.generateEventsForType_(events, Change_1.Change.VALUE, changes, eventRegistrations, eventCache);
	        return events;
	    };
	    /**
	     * Given changes of a single change type, generate the corresponding events.
	     *
	     * @param {!Array.<!Event>} events
	     * @param {!string} eventType
	     * @param {!Array.<!Change>} changes
	     * @param {!Array.<!EventRegistration>} registrations
	     * @param {!Node} eventCache
	     * @private
	     */
	    EventGenerator.prototype.generateEventsForType_ = function (events, eventType, changes, registrations, eventCache) {
	        var _this = this;
	        var filteredChanges = changes.filter(function (change) { return change.type === eventType; });
	        filteredChanges.sort(this.compareChanges_.bind(this));
	        filteredChanges.forEach(function (change) {
	            var materializedChange = _this.materializeSingleChange_(change, eventCache);
	            registrations.forEach(function (registration) {
	                if (registration.respondsTo(change.type)) {
	                    events.push(registration.createEvent(materializedChange, _this.query_));
	                }
	            });
	        });
	    };
	    /**
	     * @param {!Change} change
	     * @param {!Node} eventCache
	     * @return {!Change}
	     * @private
	     */
	    EventGenerator.prototype.materializeSingleChange_ = function (change, eventCache) {
	        if (change.type === 'value' || change.type === 'child_removed') {
	            return change;
	        }
	        else {
	            change.prevName = eventCache.getPredecessorChildName(
	            /** @type {!string} */
	            change.childName, change.snapshotNode, this.index_);
	            return change;
	        }
	    };
	    /**
	     * @param {!Change} a
	     * @param {!Change} b
	     * @return {number}
	     * @private
	     */
	    EventGenerator.prototype.compareChanges_ = function (a, b) {
	        if (a.childName == null || b.childName == null) {
	            throw util_1.assertionError('Should only compare child_ events.');
	        }
	        var aWrapped = new Node_1.NamedNode(a.childName, a.snapshotNode);
	        var bWrapped = new Node_1.NamedNode(b.childName, b.snapshotNode);
	        return this.index_.compare(aWrapped, bWrapped);
	    };
	    return EventGenerator;
	}());
	exports.EventGenerator = EventGenerator;
	
	//# sourceMappingURL=EventGenerator.js.map


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(13);
	/**
	 * The event queue serves a few purposes:
	 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
	 *    events being queued.
	 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
	 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
	 *    left off, ensuring that the events are still raised synchronously and in order.
	 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
	 *    events are raised synchronously.
	 *
	 * NOTE: This can all go away if/when we move to async events.
	 *
	 * @constructor
	 */
	var EventQueue = /** @class */ (function () {
	    function EventQueue() {
	        /**
	         * @private
	         * @type {!Array.<EventList>}
	         */
	        this.eventLists_ = [];
	        /**
	         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
	         * @private
	         * @type {!number}
	         */
	        this.recursionDepth_ = 0;
	    }
	    /**
	     * @param {!Array.<Event>} eventDataList The new events to queue.
	     */
	    EventQueue.prototype.queueEvents = function (eventDataList) {
	        // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
	        var currList = null;
	        for (var i = 0; i < eventDataList.length; i++) {
	            var eventData = eventDataList[i];
	            var eventPath = eventData.getPath();
	            if (currList !== null && !eventPath.equals(currList.getPath())) {
	                this.eventLists_.push(currList);
	                currList = null;
	            }
	            if (currList === null) {
	                currList = new EventList(eventPath);
	            }
	            currList.add(eventData);
	        }
	        if (currList) {
	            this.eventLists_.push(currList);
	        }
	    };
	    /**
	     * Queues the specified events and synchronously raises all events (including previously queued ones)
	     * for the specified path.
	     *
	     * It is assumed that the new events are all for the specified path.
	     *
	     * @param {!Path} path The path to raise events for.
	     * @param {!Array.<Event>} eventDataList The new events to raise.
	     */
	    EventQueue.prototype.raiseEventsAtPath = function (path, eventDataList) {
	        this.queueEvents(eventDataList);
	        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
	            return eventPath.equals(path);
	        });
	    };
	    /**
	     * Queues the specified events and synchronously raises all events (including previously queued ones) for
	     * locations related to the specified change path (i.e. all ancestors and descendants).
	     *
	     * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
	     *
	     * @param {!Path} changedPath The path to raise events for.
	     * @param {!Array.<!Event>} eventDataList The events to raise
	     */
	    EventQueue.prototype.raiseEventsForChangedPath = function (changedPath, eventDataList) {
	        this.queueEvents(eventDataList);
	        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
	            return eventPath.contains(changedPath) || changedPath.contains(eventPath);
	        });
	    };
	    /**
	     * @param {!function(!Path):boolean} predicate
	     * @private
	     */
	    EventQueue.prototype.raiseQueuedEventsMatchingPredicate_ = function (predicate) {
	        this.recursionDepth_++;
	        var sentAll = true;
	        for (var i = 0; i < this.eventLists_.length; i++) {
	            var eventList = this.eventLists_[i];
	            if (eventList) {
	                var eventPath = eventList.getPath();
	                if (predicate(eventPath)) {
	                    this.eventLists_[i].raise();
	                    this.eventLists_[i] = null;
	                }
	                else {
	                    sentAll = false;
	                }
	            }
	        }
	        if (sentAll) {
	            this.eventLists_ = [];
	        }
	        this.recursionDepth_--;
	    };
	    return EventQueue;
	}());
	exports.EventQueue = EventQueue;
	/**
	 * @param {!Path} path
	 * @constructor
	 */
	var EventList = /** @class */ (function () {
	    function EventList(path_) {
	        this.path_ = path_;
	        /**
	         * @type {!Array.<Event>}
	         * @private
	         */
	        this.events_ = [];
	    }
	    /**
	     * @param {!Event} eventData
	     */
	    EventList.prototype.add = function (eventData) {
	        this.events_.push(eventData);
	    };
	    /**
	     * Iterates through the list and raises each event
	     */
	    EventList.prototype.raise = function () {
	        for (var i = 0; i < this.events_.length; i++) {
	            var eventData = this.events_[i];
	            if (eventData !== null) {
	                this.events_[i] = null;
	                var eventFn = eventData.getEventRunner();
	                if (util_1.logger) {
	                    util_1.log('event: ' + eventData.toString());
	                }
	                util_1.exceptionGuard(eventFn);
	            }
	        }
	    };
	    /**
	     * @return {!Path}
	     */
	    EventList.prototype.getPath = function () {
	        return this.path_;
	    };
	    return EventList;
	}());
	exports.EventList = EventList;
	
	//# sourceMappingURL=EventQueue.js.map


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var DataSnapshot_1 = __webpack_require__(115);
	var Event_1 = __webpack_require__(443);
	var util_1 = __webpack_require__(2);
	var util_2 = __webpack_require__(2);
	/**
	 * Represents registration for 'value' events.
	 */
	var ValueEventRegistration = /** @class */ (function () {
	    /**
	     * @param {?function(!DataSnapshot)} callback_
	     * @param {?function(Error)} cancelCallback_
	     * @param {?Object} context_
	     */
	    function ValueEventRegistration(callback_, cancelCallback_, context_) {
	        this.callback_ = callback_;
	        this.cancelCallback_ = cancelCallback_;
	        this.context_ = context_;
	    }
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.respondsTo = function (eventType) {
	        return eventType === 'value';
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.createEvent = function (change, query) {
	        var index = query.getQueryParams().getIndex();
	        return new Event_1.DataEvent('value', this, new DataSnapshot_1.DataSnapshot(change.snapshotNode, query.getRef(), index));
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.getEventRunner = function (eventData) {
	        var ctx = this.context_;
	        if (eventData.getEventType() === 'cancel') {
	            util_2.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
	            var cancelCB_1 = this.cancelCallback_;
	            return function () {
	                // We know that error exists, we checked above that this is a cancel event
	                cancelCB_1.call(ctx, eventData.error);
	            };
	        }
	        else {
	            var cb_1 = this.callback_;
	            return function () {
	                cb_1.call(ctx, eventData.snapshot);
	            };
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.createCancelEvent = function (error, path) {
	        if (this.cancelCallback_) {
	            return new Event_1.CancelEvent(this, error, path);
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.matches = function (other) {
	        if (!(other instanceof ValueEventRegistration)) {
	            return false;
	        }
	        else if (!other.callback_ || !this.callback_) {
	            // If no callback specified, we consider it to match any callback.
	            return true;
	        }
	        else {
	            return (other.callback_ === this.callback_ && other.context_ === this.context_);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.hasAnyCallback = function () {
	        return this.callback_ !== null;
	    };
	    return ValueEventRegistration;
	}());
	exports.ValueEventRegistration = ValueEventRegistration;
	/**
	 * Represents the registration of 1 or more child_xxx events.
	 *
	 * Currently, it is always exactly 1 child_xxx event, but the idea is we might let you
	 * register a group of callbacks together in the future.
	 *
	 * @constructor
	 * @implements {EventRegistration}
	 */
	var ChildEventRegistration = /** @class */ (function () {
	    /**
	     * @param {?Object.<string, function(!DataSnapshot, ?string=)>} callbacks_
	     * @param {?function(Error)} cancelCallback_
	     * @param {Object=} context_
	     */
	    function ChildEventRegistration(callbacks_, cancelCallback_, context_) {
	        this.callbacks_ = callbacks_;
	        this.cancelCallback_ = cancelCallback_;
	        this.context_ = context_;
	    }
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.respondsTo = function (eventType) {
	        var eventToCheck = eventType === 'children_added' ? 'child_added' : eventType;
	        eventToCheck =
	            eventToCheck === 'children_removed' ? 'child_removed' : eventToCheck;
	        return util_1.contains(this.callbacks_, eventToCheck);
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.createCancelEvent = function (error, path) {
	        if (this.cancelCallback_) {
	            return new Event_1.CancelEvent(this, error, path);
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.createEvent = function (change, query) {
	        util_2.assert(change.childName != null, 'Child events should have a childName.');
	        var ref = query.getRef().child(/** @type {!string} */ (change.childName));
	        var index = query.getQueryParams().getIndex();
	        return new Event_1.DataEvent(change.type, this, new DataSnapshot_1.DataSnapshot(change.snapshotNode, ref, index), change.prevName);
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.getEventRunner = function (eventData) {
	        var ctx = this.context_;
	        if (eventData.getEventType() === 'cancel') {
	            util_2.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
	            var cancelCB_2 = this.cancelCallback_;
	            return function () {
	                // We know that error exists, we checked above that this is a cancel event
	                cancelCB_2.call(ctx, eventData.error);
	            };
	        }
	        else {
	            var cb_2 = this.callbacks_[eventData.eventType];
	            return function () {
	                cb_2.call(ctx, eventData.snapshot, eventData.prevName);
	            };
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.matches = function (other) {
	        if (other instanceof ChildEventRegistration) {
	            if (!this.callbacks_ || !other.callbacks_) {
	                return true;
	            }
	            else if (this.context_ === other.context_) {
	                var otherCount = util_1.getCount(other.callbacks_);
	                var thisCount = util_1.getCount(this.callbacks_);
	                if (otherCount === thisCount) {
	                    // If count is 1, do an exact match on eventType, if either is defined but null, it's a match.
	                    //  If event types don't match, not a match
	                    // If count is not 1, exact match across all
	                    if (otherCount === 1) {
	                        var otherKey /** @type {!string} */ = util_1.getAnyKey(other.callbacks_);
	                        var thisKey /** @type {!string} */ = util_1.getAnyKey(this.callbacks_);
	                        return (thisKey === otherKey &&
	                            (!other.callbacks_[otherKey] ||
	                                !this.callbacks_[thisKey] ||
	                                other.callbacks_[otherKey] === this.callbacks_[thisKey]));
	                    }
	                    else {
	                        // Exact match on each key.
	                        return util_1.every(this.callbacks_, function (eventType, cb) { return other.callbacks_[eventType] === cb; });
	                    }
	                }
	            }
	        }
	        return false;
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.hasAnyCallback = function () {
	        return this.callbacks_ !== null;
	    };
	    return ChildEventRegistration;
	}());
	exports.ChildEventRegistration = ChildEventRegistration;
	
	//# sourceMappingURL=EventRegistration.js.map


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var util_2 = __webpack_require__(13);
	var KeyIndex_1 = __webpack_require__(67);
	var PriorityIndex_1 = __webpack_require__(26);
	var ValueIndex_1 = __webpack_require__(177);
	var PathIndex_1 = __webpack_require__(176);
	var IndexedFilter_1 = __webpack_require__(120);
	var LimitedFilter_1 = __webpack_require__(450);
	var RangedFilter_1 = __webpack_require__(185);
	var util_3 = __webpack_require__(2);
	/**
	 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
	 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
	 * user-facing API level, so it is not done here.
	 * @constructor
	 */
	var QueryParams = /** @class */ (function () {
	    function QueryParams() {
	        this.limitSet_ = false;
	        this.startSet_ = false;
	        this.startNameSet_ = false;
	        this.endSet_ = false;
	        this.endNameSet_ = false;
	        this.limit_ = 0;
	        this.viewFrom_ = '';
	        this.indexStartValue_ = null;
	        this.indexStartName_ = '';
	        this.indexEndValue_ = null;
	        this.indexEndName_ = '';
	        this.index_ = PriorityIndex_1.PRIORITY_INDEX;
	    }
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.hasStart = function () {
	        return this.startSet_;
	    };
	    /**
	     * @return {boolean} True if it would return from left.
	     */
	    QueryParams.prototype.isViewFromLeft = function () {
	        if (this.viewFrom_ === '') {
	            // limit(), rather than limitToFirst or limitToLast was called.
	            // This means that only one of startSet_ and endSet_ is true. Use them
	            // to calculate which side of the view to anchor to. If neither is set,
	            // anchor to the end.
	            return this.startSet_;
	        }
	        else {
	            return (this.viewFrom_ === QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT);
	        }
	    };
	    /**
	     * Only valid to call if hasStart() returns true
	     * @return {*}
	     */
	    QueryParams.prototype.getIndexStartValue = function () {
	        util_1.assert(this.startSet_, 'Only valid if start has been set');
	        return this.indexStartValue_;
	    };
	    /**
	     * Only valid to call if hasStart() returns true.
	     * Returns the starting key name for the range defined by these query parameters
	     * @return {!string}
	     */
	    QueryParams.prototype.getIndexStartName = function () {
	        util_1.assert(this.startSet_, 'Only valid if start has been set');
	        if (this.startNameSet_) {
	            return this.indexStartName_;
	        }
	        else {
	            return util_2.MIN_NAME;
	        }
	    };
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.hasEnd = function () {
	        return this.endSet_;
	    };
	    /**
	     * Only valid to call if hasEnd() returns true.
	     * @return {*}
	     */
	    QueryParams.prototype.getIndexEndValue = function () {
	        util_1.assert(this.endSet_, 'Only valid if end has been set');
	        return this.indexEndValue_;
	    };
	    /**
	     * Only valid to call if hasEnd() returns true.
	     * Returns the end key name for the range defined by these query parameters
	     * @return {!string}
	     */
	    QueryParams.prototype.getIndexEndName = function () {
	        util_1.assert(this.endSet_, 'Only valid if end has been set');
	        if (this.endNameSet_) {
	            return this.indexEndName_;
	        }
	        else {
	            return util_2.MAX_NAME;
	        }
	    };
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.hasLimit = function () {
	        return this.limitSet_;
	    };
	    /**
	     * @return {boolean} True if a limit has been set and it has been explicitly anchored
	     */
	    QueryParams.prototype.hasAnchoredLimit = function () {
	        return this.limitSet_ && this.viewFrom_ !== '';
	    };
	    /**
	     * Only valid to call if hasLimit() returns true
	     * @return {!number}
	     */
	    QueryParams.prototype.getLimit = function () {
	        util_1.assert(this.limitSet_, 'Only valid if limit has been set');
	        return this.limit_;
	    };
	    /**
	     * @return {!Index}
	     */
	    QueryParams.prototype.getIndex = function () {
	        return this.index_;
	    };
	    /**
	     * @return {!QueryParams}
	     * @private
	     */
	    QueryParams.prototype.copy_ = function () {
	        var copy = new QueryParams();
	        copy.limitSet_ = this.limitSet_;
	        copy.limit_ = this.limit_;
	        copy.startSet_ = this.startSet_;
	        copy.indexStartValue_ = this.indexStartValue_;
	        copy.startNameSet_ = this.startNameSet_;
	        copy.indexStartName_ = this.indexStartName_;
	        copy.endSet_ = this.endSet_;
	        copy.indexEndValue_ = this.indexEndValue_;
	        copy.endNameSet_ = this.endNameSet_;
	        copy.indexEndName_ = this.indexEndName_;
	        copy.index_ = this.index_;
	        copy.viewFrom_ = this.viewFrom_;
	        return copy;
	    };
	    /**
	     * @param {!number} newLimit
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.limit = function (newLimit) {
	        var newParams = this.copy_();
	        newParams.limitSet_ = true;
	        newParams.limit_ = newLimit;
	        newParams.viewFrom_ = '';
	        return newParams;
	    };
	    /**
	     * @param {!number} newLimit
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.limitToFirst = function (newLimit) {
	        var newParams = this.copy_();
	        newParams.limitSet_ = true;
	        newParams.limit_ = newLimit;
	        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT;
	        return newParams;
	    };
	    /**
	     * @param {!number} newLimit
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.limitToLast = function (newLimit) {
	        var newParams = this.copy_();
	        newParams.limitSet_ = true;
	        newParams.limit_ = newLimit;
	        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_RIGHT;
	        return newParams;
	    };
	    /**
	     * @param {*} indexValue
	     * @param {?string=} key
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.startAt = function (indexValue, key) {
	        var newParams = this.copy_();
	        newParams.startSet_ = true;
	        if (!(indexValue !== undefined)) {
	            indexValue = null;
	        }
	        newParams.indexStartValue_ = indexValue;
	        if (key != null) {
	            newParams.startNameSet_ = true;
	            newParams.indexStartName_ = key;
	        }
	        else {
	            newParams.startNameSet_ = false;
	            newParams.indexStartName_ = '';
	        }
	        return newParams;
	    };
	    /**
	     * @param {*} indexValue
	     * @param {?string=} key
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.endAt = function (indexValue, key) {
	        var newParams = this.copy_();
	        newParams.endSet_ = true;
	        if (!(indexValue !== undefined)) {
	            indexValue = null;
	        }
	        newParams.indexEndValue_ = indexValue;
	        if (key !== undefined) {
	            newParams.endNameSet_ = true;
	            newParams.indexEndName_ = key;
	        }
	        else {
	            newParams.endNameSet_ = false;
	            newParams.indexEndName_ = '';
	        }
	        return newParams;
	    };
	    /**
	     * @param {!Index} index
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.orderBy = function (index) {
	        var newParams = this.copy_();
	        newParams.index_ = index;
	        return newParams;
	    };
	    /**
	     * @return {!Object}
	     */
	    QueryParams.prototype.getQueryObject = function () {
	        var WIRE_PROTOCOL_CONSTANTS = QueryParams.WIRE_PROTOCOL_CONSTANTS_;
	        var obj = {};
	        if (this.startSet_) {
	            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE] = this.indexStartValue_;
	            if (this.startNameSet_) {
	                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME] = this.indexStartName_;
	            }
	        }
	        if (this.endSet_) {
	            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE] = this.indexEndValue_;
	            if (this.endNameSet_) {
	                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME] = this.indexEndName_;
	            }
	        }
	        if (this.limitSet_) {
	            obj[WIRE_PROTOCOL_CONSTANTS.LIMIT] = this.limit_;
	            var viewFrom = this.viewFrom_;
	            if (viewFrom === '') {
	                if (this.isViewFromLeft()) {
	                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT;
	                }
	                else {
	                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT;
	                }
	            }
	            obj[WIRE_PROTOCOL_CONSTANTS.VIEW_FROM] = viewFrom;
	        }
	        // For now, priority index is the default, so we only specify if it's some other index
	        if (this.index_ !== PriorityIndex_1.PRIORITY_INDEX) {
	            obj[WIRE_PROTOCOL_CONSTANTS.INDEX] = this.index_.toString();
	        }
	        return obj;
	    };
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.loadsAllData = function () {
	        return !(this.startSet_ || this.endSet_ || this.limitSet_);
	    };
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.isDefault = function () {
	        return this.loadsAllData() && this.index_ == PriorityIndex_1.PRIORITY_INDEX;
	    };
	    /**
	     * @return {!NodeFilter}
	     */
	    QueryParams.prototype.getNodeFilter = function () {
	        if (this.loadsAllData()) {
	            return new IndexedFilter_1.IndexedFilter(this.getIndex());
	        }
	        else if (this.hasLimit()) {
	            return new LimitedFilter_1.LimitedFilter(this);
	        }
	        else {
	            return new RangedFilter_1.RangedFilter(this);
	        }
	    };
	    /**
	     * Returns a set of REST query string parameters representing this query.
	     *
	     * @return {!Object.<string,*>} query string parameters
	     */
	    QueryParams.prototype.toRestQueryStringParameters = function () {
	        var REST_CONSTANTS = QueryParams.REST_QUERY_CONSTANTS_;
	        var qs = {};
	        if (this.isDefault()) {
	            return qs;
	        }
	        var orderBy;
	        if (this.index_ === PriorityIndex_1.PRIORITY_INDEX) {
	            orderBy = REST_CONSTANTS.PRIORITY_INDEX;
	        }
	        else if (this.index_ === ValueIndex_1.VALUE_INDEX) {
	            orderBy = REST_CONSTANTS.VALUE_INDEX;
	        }
	        else if (this.index_ === KeyIndex_1.KEY_INDEX) {
	            orderBy = REST_CONSTANTS.KEY_INDEX;
	        }
	        else {
	            util_1.assert(this.index_ instanceof PathIndex_1.PathIndex, 'Unrecognized index type!');
	            orderBy = this.index_.toString();
	        }
	        qs[REST_CONSTANTS.ORDER_BY] = util_3.stringify(orderBy);
	        if (this.startSet_) {
	            qs[REST_CONSTANTS.START_AT] = util_3.stringify(this.indexStartValue_);
	            if (this.startNameSet_) {
	                qs[REST_CONSTANTS.START_AT] += ',' + util_3.stringify(this.indexStartName_);
	            }
	        }
	        if (this.endSet_) {
	            qs[REST_CONSTANTS.END_AT] = util_3.stringify(this.indexEndValue_);
	            if (this.endNameSet_) {
	                qs[REST_CONSTANTS.END_AT] += ',' + util_3.stringify(this.indexEndName_);
	            }
	        }
	        if (this.limitSet_) {
	            if (this.isViewFromLeft()) {
	                qs[REST_CONSTANTS.LIMIT_TO_FIRST] = this.limit_;
	            }
	            else {
	                qs[REST_CONSTANTS.LIMIT_TO_LAST] = this.limit_;
	            }
	        }
	        return qs;
	    };
	    /**
	     * Wire Protocol Constants
	     * @const
	     * @enum {string}
	     * @private
	     */
	    QueryParams.WIRE_PROTOCOL_CONSTANTS_ = {
	        INDEX_START_VALUE: 'sp',
	        INDEX_START_NAME: 'sn',
	        INDEX_END_VALUE: 'ep',
	        INDEX_END_NAME: 'en',
	        LIMIT: 'l',
	        VIEW_FROM: 'vf',
	        VIEW_FROM_LEFT: 'l',
	        VIEW_FROM_RIGHT: 'r',
	        INDEX: 'i'
	    };
	    /**
	     * REST Query Constants
	     * @const
	     * @enum {string}
	     * @private
	     */
	    QueryParams.REST_QUERY_CONSTANTS_ = {
	        ORDER_BY: 'orderBy',
	        PRIORITY_INDEX: '$priority',
	        VALUE_INDEX: '$value',
	        KEY_INDEX: '$key',
	        START_AT: 'startAt',
	        END_AT: 'endAt',
	        LIMIT_TO_FIRST: 'limitToFirst',
	        LIMIT_TO_LAST: 'limitToLast'
	    };
	    /**
	     * Default, empty query parameters
	     * @type {!QueryParams}
	     * @const
	     */
	    QueryParams.DEFAULT = new QueryParams();
	    return QueryParams;
	}());
	exports.QueryParams = QueryParams;
	
	//# sourceMappingURL=QueryParams.js.map


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var IndexedFilter_1 = __webpack_require__(120);
	var ViewProcessor_1 = __webpack_require__(449);
	var ChildrenNode_1 = __webpack_require__(28);
	var CacheNode_1 = __webpack_require__(91);
	var ViewCache_1 = __webpack_require__(184);
	var EventGenerator_1 = __webpack_require__(444);
	var util_1 = __webpack_require__(2);
	var Operation_1 = __webpack_require__(47);
	var Change_1 = __webpack_require__(54);
	var PriorityIndex_1 = __webpack_require__(26);
	/**
	 * A view represents a specific location and query that has 1 or more event registrations.
	 *
	 * It does several things:
	 *  - Maintains the list of event registrations for this location/query.
	 *  - Maintains a cache of the data visible for this location/query.
	 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
	 *    registrations returns the set of events to be raised.
	 * @constructor
	 */
	var View = /** @class */ (function () {
	    /**
	     *
	     * @param {!Query} query_
	     * @param {!ViewCache} initialViewCache
	     */
	    function View(query_, initialViewCache) {
	        this.query_ = query_;
	        this.eventRegistrations_ = [];
	        var params = this.query_.getQueryParams();
	        var indexFilter = new IndexedFilter_1.IndexedFilter(params.getIndex());
	        var filter = params.getNodeFilter();
	        /**
	         * @type {ViewProcessor}
	         * @private
	         */
	        this.processor_ = new ViewProcessor_1.ViewProcessor(filter);
	        var initialServerCache = initialViewCache.getServerCache();
	        var initialEventCache = initialViewCache.getEventCache();
	        // Don't filter server node with other filter than index, wait for tagged listen
	        var serverSnap = indexFilter.updateFullNode(ChildrenNode_1.ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
	        var eventSnap = filter.updateFullNode(ChildrenNode_1.ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
	        var newServerCache = new CacheNode_1.CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
	        var newEventCache = new CacheNode_1.CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
	        /**
	         * @type {!ViewCache}
	         * @private
	         */
	        this.viewCache_ = new ViewCache_1.ViewCache(newEventCache, newServerCache);
	        /**
	         * @type {!EventGenerator}
	         * @private
	         */
	        this.eventGenerator_ = new EventGenerator_1.EventGenerator(this.query_);
	    }
	    /**
	     * @return {!Query}
	     */
	    View.prototype.getQuery = function () {
	        return this.query_;
	    };
	    /**
	     * @return {?Node}
	     */
	    View.prototype.getServerCache = function () {
	        return this.viewCache_.getServerCache().getNode();
	    };
	    /**
	     * @param {!Path} path
	     * @return {?Node}
	     */
	    View.prototype.getCompleteServerCache = function (path) {
	        var cache = this.viewCache_.getCompleteServerSnap();
	        if (cache) {
	            // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
	            // we need to see if it contains the child we're interested in.
	            if (this.query_.getQueryParams().loadsAllData() ||
	                (!path.isEmpty() && !cache.getImmediateChild(path.getFront()).isEmpty())) {
	                return cache.getChild(path);
	            }
	        }
	        return null;
	    };
	    /**
	     * @return {boolean}
	     */
	    View.prototype.isEmpty = function () {
	        return this.eventRegistrations_.length === 0;
	    };
	    /**
	     * @param {!EventRegistration} eventRegistration
	     */
	    View.prototype.addEventRegistration = function (eventRegistration) {
	        this.eventRegistrations_.push(eventRegistration);
	    };
	    /**
	     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
	     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
	     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
	     */
	    View.prototype.removeEventRegistration = function (eventRegistration, cancelError) {
	        var cancelEvents = [];
	        if (cancelError) {
	            util_1.assert(eventRegistration == null, 'A cancel should cancel all event registrations.');
	            var path_1 = this.query_.path;
	            this.eventRegistrations_.forEach(function (registration) {
	                cancelError /** @type {!Error} */ = cancelError;
	                var maybeEvent = registration.createCancelEvent(cancelError, path_1);
	                if (maybeEvent) {
	                    cancelEvents.push(maybeEvent);
	                }
	            });
	        }
	        if (eventRegistration) {
	            var remaining = [];
	            for (var i = 0; i < this.eventRegistrations_.length; ++i) {
	                var existing = this.eventRegistrations_[i];
	                if (!existing.matches(eventRegistration)) {
	                    remaining.push(existing);
	                }
	                else if (eventRegistration.hasAnyCallback()) {
	                    // We're removing just this one
	                    remaining = remaining.concat(this.eventRegistrations_.slice(i + 1));
	                    break;
	                }
	            }
	            this.eventRegistrations_ = remaining;
	        }
	        else {
	            this.eventRegistrations_ = [];
	        }
	        return cancelEvents;
	    };
	    /**
	     * Applies the given Operation, updates our cache, and returns the appropriate events.
	     *
	     * @param {!Operation} operation
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeServerCache
	     * @return {!Array.<!Event>}
	     */
	    View.prototype.applyOperation = function (operation, writesCache, completeServerCache) {
	        if (operation.type === Operation_1.OperationType.MERGE &&
	            operation.source.queryId !== null) {
	            util_1.assert(this.viewCache_.getCompleteServerSnap(), 'We should always have a full cache before handling merges');
	            util_1.assert(this.viewCache_.getCompleteEventSnap(), 'Missing event cache, even though we have a server cache');
	        }
	        var oldViewCache = this.viewCache_;
	        var result = this.processor_.applyOperation(oldViewCache, operation, writesCache, completeServerCache);
	        this.processor_.assertIndexed(result.viewCache);
	        util_1.assert(result.viewCache.getServerCache().isFullyInitialized() ||
	            !oldViewCache.getServerCache().isFullyInitialized(), 'Once a server snap is complete, it should never go back');
	        this.viewCache_ = result.viewCache;
	        return this.generateEventsForChanges_(result.changes, result.viewCache.getEventCache().getNode(), null);
	    };
	    /**
	     * @param {!EventRegistration} registration
	     * @return {!Array.<!Event>}
	     */
	    View.prototype.getInitialEvents = function (registration) {
	        var eventSnap = this.viewCache_.getEventCache();
	        var initialChanges = [];
	        if (!eventSnap.getNode().isLeafNode()) {
	            var eventNode = eventSnap.getNode();
	            eventNode.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (key, childNode) {
	                initialChanges.push(Change_1.Change.childAddedChange(key, childNode));
	            });
	        }
	        if (eventSnap.isFullyInitialized()) {
	            initialChanges.push(Change_1.Change.valueChange(eventSnap.getNode()));
	        }
	        return this.generateEventsForChanges_(initialChanges, eventSnap.getNode(), registration);
	    };
	    /**
	     * @private
	     * @param {!Array.<!Change>} changes
	     * @param {!Node} eventCache
	     * @param {EventRegistration=} eventRegistration
	     * @return {!Array.<!Event>}
	     */
	    View.prototype.generateEventsForChanges_ = function (changes, eventCache, eventRegistration) {
	        var registrations = eventRegistration
	            ? [eventRegistration]
	            : this.eventRegistrations_;
	        return this.eventGenerator_.generateEventsForChanges(changes, eventCache, registrations);
	    };
	    return View;
	}());
	exports.View = View;
	
	//# sourceMappingURL=View.js.map


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Operation_1 = __webpack_require__(47);
	var util_1 = __webpack_require__(2);
	var ChildChangeAccumulator_1 = __webpack_require__(441);
	var Change_1 = __webpack_require__(54);
	var ChildrenNode_1 = __webpack_require__(28);
	var KeyIndex_1 = __webpack_require__(67);
	var ImmutableTree_1 = __webpack_require__(119);
	var Path_1 = __webpack_require__(17);
	var CompleteChildSource_1 = __webpack_require__(442);
	/**
	 * @constructor
	 * @struct
	 */
	var ProcessorResult = /** @class */ (function () {
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Array.<!Change>} changes
	     */
	    function ProcessorResult(viewCache, changes) {
	        this.viewCache = viewCache;
	        this.changes = changes;
	    }
	    return ProcessorResult;
	}());
	exports.ProcessorResult = ProcessorResult;
	/**
	 * @constructor
	 */
	var ViewProcessor = /** @class */ (function () {
	    /**
	     * @param {!NodeFilter} filter_
	     */
	    function ViewProcessor(filter_) {
	        this.filter_ = filter_;
	    }
	    /**
	     * @param {!ViewCache} viewCache
	     */
	    ViewProcessor.prototype.assertIndexed = function (viewCache) {
	        util_1.assert(viewCache
	            .getEventCache()
	            .getNode()
	            .isIndexed(this.filter_.getIndex()), 'Event snap not indexed');
	        util_1.assert(viewCache
	            .getServerCache()
	            .getNode()
	            .isIndexed(this.filter_.getIndex()), 'Server snap not indexed');
	    };
	    /**
	     * @param {!ViewCache} oldViewCache
	     * @param {!Operation} operation
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeCache
	     * @return {!ProcessorResult}
	     */
	    ViewProcessor.prototype.applyOperation = function (oldViewCache, operation, writesCache, completeCache) {
	        var accumulator = new ChildChangeAccumulator_1.ChildChangeAccumulator();
	        var newViewCache, filterServerNode;
	        if (operation.type === Operation_1.OperationType.OVERWRITE) {
	            var overwrite = operation;
	            if (overwrite.source.fromUser) {
	                newViewCache = this.applyUserOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
	            }
	            else {
	                util_1.assert(overwrite.source.fromServer, 'Unknown source.');
	                // We filter the node if it's a tagged update or the node has been previously filtered  and the
	                // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
	                // again
	                filterServerNode =
	                    overwrite.source.tagged ||
	                        (oldViewCache.getServerCache().isFiltered() &&
	                            !overwrite.path.isEmpty());
	                newViewCache = this.applyServerOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
	            }
	        }
	        else if (operation.type === Operation_1.OperationType.MERGE) {
	            var merge = operation;
	            if (merge.source.fromUser) {
	                newViewCache = this.applyUserMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
	            }
	            else {
	                util_1.assert(merge.source.fromServer, 'Unknown source.');
	                // We filter the node if it's a tagged update or the node has been previously filtered
	                filterServerNode =
	                    merge.source.tagged || oldViewCache.getServerCache().isFiltered();
	                newViewCache = this.applyServerMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
	            }
	        }
	        else if (operation.type === Operation_1.OperationType.ACK_USER_WRITE) {
	            var ackUserWrite = operation;
	            if (!ackUserWrite.revert) {
	                newViewCache = this.ackUserWrite_(oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
	            }
	            else {
	                newViewCache = this.revertUserWrite_(oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
	            }
	        }
	        else if (operation.type === Operation_1.OperationType.LISTEN_COMPLETE) {
	            newViewCache = this.listenComplete_(oldViewCache, operation.path, writesCache, accumulator);
	        }
	        else {
	            throw util_1.assertionError('Unknown operation type: ' + operation.type);
	        }
	        var changes = accumulator.getChanges();
	        ViewProcessor.maybeAddValueEvent_(oldViewCache, newViewCache, changes);
	        return new ProcessorResult(newViewCache, changes);
	    };
	    /**
	     * @param {!ViewCache} oldViewCache
	     * @param {!ViewCache} newViewCache
	     * @param {!Array.<!Change>} accumulator
	     * @private
	     */
	    ViewProcessor.maybeAddValueEvent_ = function (oldViewCache, newViewCache, accumulator) {
	        var eventSnap = newViewCache.getEventCache();
	        if (eventSnap.isFullyInitialized()) {
	            var isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
	            var oldCompleteSnap = oldViewCache.getCompleteEventSnap();
	            if (accumulator.length > 0 ||
	                !oldViewCache.getEventCache().isFullyInitialized() ||
	                (isLeafOrEmpty &&
	                    !eventSnap
	                        .getNode()
	                        .equals(/** @type {!Node} */ (oldCompleteSnap))) ||
	                !eventSnap
	                    .getNode()
	                    .getPriority()
	                    .equals(oldCompleteSnap.getPriority())) {
	                accumulator.push(Change_1.Change.valueChange(
	                /** @type {!Node} */ newViewCache.getCompleteEventSnap()));
	            }
	        }
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} changePath
	     * @param {!WriteTreeRef} writesCache
	     * @param {!CompleteChildSource} source
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.generateEventCacheAfterServerEvent_ = function (viewCache, changePath, writesCache, source, accumulator) {
	        var oldEventSnap = viewCache.getEventCache();
	        if (writesCache.shadowingWrite(changePath) != null) {
	            // we have a shadowing write, ignore changes
	            return viewCache;
	        }
	        else {
	            var newEventCache = void 0, serverNode = void 0;
	            if (changePath.isEmpty()) {
	                // TODO: figure out how this plays with "sliding ack windows"
	                util_1.assert(viewCache.getServerCache().isFullyInitialized(), 'If change path is empty, we must have complete server data');
	                if (viewCache.getServerCache().isFiltered()) {
	                    // We need to special case this, because we need to only apply writes to complete children, or
	                    // we might end up raising events for incomplete children. If the server data is filtered deep
	                    // writes cannot be guaranteed to be complete
	                    var serverCache = viewCache.getCompleteServerSnap();
	                    var completeChildren = serverCache instanceof ChildrenNode_1.ChildrenNode
	                        ? serverCache
	                        : ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	                    var completeEventChildren = writesCache.calcCompleteEventChildren(completeChildren);
	                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeEventChildren, accumulator);
	                }
	                else {
	                    var completeNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
	                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeNode, accumulator);
	                }
	            }
	            else {
	                var childKey = changePath.getFront();
	                if (childKey == '.priority') {
	                    util_1.assert(changePath.getLength() == 1, "Can't have a priority with additional path components");
	                    var oldEventNode = oldEventSnap.getNode();
	                    serverNode = viewCache.getServerCache().getNode();
	                    // we might have overwrites for this priority
	                    var updatedPriority = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventNode, serverNode);
	                    if (updatedPriority != null) {
	                        newEventCache = this.filter_.updatePriority(oldEventNode, updatedPriority);
	                    }
	                    else {
	                        // priority didn't change, keep old node
	                        newEventCache = oldEventSnap.getNode();
	                    }
	                }
	                else {
	                    var childChangePath = changePath.popFront();
	                    // update child
	                    var newEventChild = void 0;
	                    if (oldEventSnap.isCompleteForChild(childKey)) {
	                        serverNode = viewCache.getServerCache().getNode();
	                        var eventChildUpdate = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventSnap.getNode(), serverNode);
	                        if (eventChildUpdate != null) {
	                            newEventChild = oldEventSnap
	                                .getNode()
	                                .getImmediateChild(childKey)
	                                .updateChild(childChangePath, eventChildUpdate);
	                        }
	                        else {
	                            // Nothing changed, just keep the old child
	                            newEventChild = oldEventSnap
	                                .getNode()
	                                .getImmediateChild(childKey);
	                        }
	                    }
	                    else {
	                        newEventChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
	                    }
	                    if (newEventChild != null) {
	                        newEventCache = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
	                    }
	                    else {
	                        // no complete child available or no change
	                        newEventCache = oldEventSnap.getNode();
	                    }
	                }
	            }
	            return viewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized() || changePath.isEmpty(), this.filter_.filtersNodes());
	        }
	    };
	    /**
	     * @param {!ViewCache} oldViewCache
	     * @param {!Path} changePath
	     * @param {!Node} changedSnap
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeCache
	     * @param {boolean} filterServerNode
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.applyServerOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
	        var oldServerSnap = oldViewCache.getServerCache();
	        var newServerCache;
	        var serverFilter = filterServerNode
	            ? this.filter_
	            : this.filter_.getIndexedFilter();
	        if (changePath.isEmpty()) {
	            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
	        }
	        else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
	            // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
	            var newServerNode = oldServerSnap
	                .getNode()
	                .updateChild(changePath, changedSnap);
	            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
	        }
	        else {
	            var childKey = changePath.getFront();
	            if (!oldServerSnap.isCompleteForPath(changePath) &&
	                changePath.getLength() > 1) {
	                // We don't update incomplete nodes with updates intended for other listeners
	                return oldViewCache;
	            }
	            var childChangePath = changePath.popFront();
	            var childNode = oldServerSnap.getNode().getImmediateChild(childKey);
	            var newChildNode = childNode.updateChild(childChangePath, changedSnap);
	            if (childKey == '.priority') {
	                newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
	            }
	            else {
	                newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, CompleteChildSource_1.NO_COMPLETE_CHILD_SOURCE, null);
	            }
	        }
	        var newViewCache = oldViewCache.updateServerSnap(newServerCache, oldServerSnap.isFullyInitialized() || changePath.isEmpty(), serverFilter.filtersNodes());
	        var source = new CompleteChildSource_1.WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
	        return this.generateEventCacheAfterServerEvent_(newViewCache, changePath, writesCache, source, accumulator);
	    };
	    /**
	     * @param {!ViewCache} oldViewCache
	     * @param {!Path} changePath
	     * @param {!Node} changedSnap
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.applyUserOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
	        var oldEventSnap = oldViewCache.getEventCache();
	        var newViewCache, newEventCache;
	        var source = new CompleteChildSource_1.WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
	        if (changePath.isEmpty()) {
	            newEventCache = this.filter_.updateFullNode(oldViewCache.getEventCache().getNode(), changedSnap, accumulator);
	            newViewCache = oldViewCache.updateEventSnap(newEventCache, true, this.filter_.filtersNodes());
	        }
	        else {
	            var childKey = changePath.getFront();
	            if (childKey === '.priority') {
	                newEventCache = this.filter_.updatePriority(oldViewCache.getEventCache().getNode(), changedSnap);
	                newViewCache = oldViewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
	            }
	            else {
	                var childChangePath = changePath.popFront();
	                var oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
	                var newChild = void 0;
	                if (childChangePath.isEmpty()) {
	                    // Child overwrite, we can replace the child
	                    newChild = changedSnap;
	                }
	                else {
	                    var childNode = source.getCompleteChild(childKey);
	                    if (childNode != null) {
	                        if (childChangePath.getBack() === '.priority' &&
	                            childNode.getChild(childChangePath.parent()).isEmpty()) {
	                            // This is a priority update on an empty node. If this node exists on the server, the
	                            // server will send down the priority in the update, so ignore for now
	                            newChild = childNode;
	                        }
	                        else {
	                            newChild = childNode.updateChild(childChangePath, changedSnap);
	                        }
	                    }
	                    else {
	                        // There is no complete child node available
	                        newChild = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	                    }
	                }
	                if (!oldChild.equals(newChild)) {
	                    var newEventSnap = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
	                    newViewCache = oldViewCache.updateEventSnap(newEventSnap, oldEventSnap.isFullyInitialized(), this.filter_.filtersNodes());
	                }
	                else {
	                    newViewCache = oldViewCache;
	                }
	            }
	        }
	        return newViewCache;
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {string} childKey
	     * @return {boolean}
	     * @private
	     */
	    ViewProcessor.cacheHasChild_ = function (viewCache, childKey) {
	        return viewCache.getEventCache().isCompleteForChild(childKey);
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} path
	     * @param {ImmutableTree.<!Node>} changedChildren
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} serverCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.applyUserMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
	        var _this = this;
	        // HACK: In the case of a limit query, there may be some changes that bump things out of the
	        // window leaving room for new items.  It's important we process these changes first, so we
	        // iterate the changes twice, first processing any that affect items currently in view.
	        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
	        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
	        // not the other.
	        var curViewCache = viewCache;
	        changedChildren.foreach(function (relativePath, childNode) {
	            var writePath = path.child(relativePath);
	            if (ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
	                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
	            }
	        });
	        changedChildren.foreach(function (relativePath, childNode) {
	            var writePath = path.child(relativePath);
	            if (!ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
	                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
	            }
	        });
	        return curViewCache;
	    };
	    /**
	     * @param {!Node} node
	     * @param {ImmutableTree.<!Node>} merge
	     * @return {!Node}
	     * @private
	     */
	    ViewProcessor.prototype.applyMerge_ = function (node, merge) {
	        merge.foreach(function (relativePath, childNode) {
	            node = node.updateChild(relativePath, childNode);
	        });
	        return node;
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} path
	     * @param {!ImmutableTree.<!Node>} changedChildren
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} serverCache
	     * @param {boolean} filterServerNode
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.applyServerMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
	        var _this = this;
	        // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
	        // wait for the complete data update coming soon.
	        if (viewCache
	            .getServerCache()
	            .getNode()
	            .isEmpty() &&
	            !viewCache.getServerCache().isFullyInitialized()) {
	            return viewCache;
	        }
	        // HACK: In the case of a limit query, there may be some changes that bump things out of the
	        // window leaving room for new items.  It's important we process these changes first, so we
	        // iterate the changes twice, first processing any that affect items currently in view.
	        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
	        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
	        // not the other.
	        var curViewCache = viewCache;
	        var viewMergeTree;
	        if (path.isEmpty()) {
	            viewMergeTree = changedChildren;
	        }
	        else {
	            viewMergeTree = ImmutableTree_1.ImmutableTree.Empty.setTree(path, changedChildren);
	        }
	        var serverNode = viewCache.getServerCache().getNode();
	        viewMergeTree.children.inorderTraversal(function (childKey, childTree) {
	            if (serverNode.hasChild(childKey)) {
	                var serverChild = viewCache
	                    .getServerCache()
	                    .getNode()
	                    .getImmediateChild(childKey);
	                var newChild = _this.applyMerge_(serverChild, childTree);
	                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path_1.Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
	            }
	        });
	        viewMergeTree.children.inorderTraversal(function (childKey, childMergeTree) {
	            var isUnknownDeepMerge = !viewCache.getServerCache().isCompleteForChild(childKey) &&
	                childMergeTree.value == null;
	            if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
	                var serverChild = viewCache
	                    .getServerCache()
	                    .getNode()
	                    .getImmediateChild(childKey);
	                var newChild = _this.applyMerge_(serverChild, childMergeTree);
	                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path_1.Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
	            }
	        });
	        return curViewCache;
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} ackPath
	     * @param {!ImmutableTree<!boolean>} affectedTree
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.ackUserWrite_ = function (viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
	        if (writesCache.shadowingWrite(ackPath) != null) {
	            return viewCache;
	        }
	        // Only filter server node if it is currently filtered
	        var filterServerNode = viewCache.getServerCache().isFiltered();
	        // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
	        // now that it won't be shadowed.
	        var serverCache = viewCache.getServerCache();
	        if (affectedTree.value != null) {
	            // This is an overwrite.
	            if ((ackPath.isEmpty() && serverCache.isFullyInitialized()) ||
	                serverCache.isCompleteForPath(ackPath)) {
	                return this.applyServerOverwrite_(viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
	            }
	            else if (ackPath.isEmpty()) {
	                // This is a goofy edge case where we are acking data at this location but don't have full data.  We
	                // should just re-apply whatever we have in our cache as a merge.
	                var changedChildren_1 = ImmutableTree_1.ImmutableTree.Empty;
	                serverCache.getNode().forEachChild(KeyIndex_1.KEY_INDEX, function (name, node) {
	                    changedChildren_1 = changedChildren_1.set(new Path_1.Path(name), node);
	                });
	                return this.applyServerMerge_(viewCache, ackPath, changedChildren_1, writesCache, completeCache, filterServerNode, accumulator);
	            }
	            else {
	                return viewCache;
	            }
	        }
	        else {
	            // This is a merge.
	            var changedChildren_2 = ImmutableTree_1.ImmutableTree.Empty;
	            affectedTree.foreach(function (mergePath, value) {
	                var serverCachePath = ackPath.child(mergePath);
	                if (serverCache.isCompleteForPath(serverCachePath)) {
	                    changedChildren_2 = changedChildren_2.set(mergePath, serverCache.getNode().getChild(serverCachePath));
	                }
	            });
	            return this.applyServerMerge_(viewCache, ackPath, changedChildren_2, writesCache, completeCache, filterServerNode, accumulator);
	        }
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} path
	     * @param {!WriteTreeRef} writesCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.listenComplete_ = function (viewCache, path, writesCache, accumulator) {
	        var oldServerNode = viewCache.getServerCache();
	        var newViewCache = viewCache.updateServerSnap(oldServerNode.getNode(), oldServerNode.isFullyInitialized() || path.isEmpty(), oldServerNode.isFiltered());
	        return this.generateEventCacheAfterServerEvent_(newViewCache, path, writesCache, CompleteChildSource_1.NO_COMPLETE_CHILD_SOURCE, accumulator);
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} path
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeServerCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.revertUserWrite_ = function (viewCache, path, writesCache, completeServerCache, accumulator) {
	        var complete;
	        if (writesCache.shadowingWrite(path) != null) {
	            return viewCache;
	        }
	        else {
	            var source = new CompleteChildSource_1.WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
	            var oldEventCache = viewCache.getEventCache().getNode();
	            var newEventCache = void 0;
	            if (path.isEmpty() || path.getFront() === '.priority') {
	                var newNode = void 0;
	                if (viewCache.getServerCache().isFullyInitialized()) {
	                    newNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
	                }
	                else {
	                    var serverChildren = viewCache.getServerCache().getNode();
	                    util_1.assert(serverChildren instanceof ChildrenNode_1.ChildrenNode, 'serverChildren would be complete if leaf node');
	                    newNode = writesCache.calcCompleteEventChildren(serverChildren);
	                }
	                newNode = newNode;
	                newEventCache = this.filter_.updateFullNode(oldEventCache, newNode, accumulator);
	            }
	            else {
	                var childKey = path.getFront();
	                var newChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
	                if (newChild == null &&
	                    viewCache.getServerCache().isCompleteForChild(childKey)) {
	                    newChild = oldEventCache.getImmediateChild(childKey);
	                }
	                if (newChild != null) {
	                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, newChild, path.popFront(), source, accumulator);
	                }
	                else if (viewCache
	                    .getEventCache()
	                    .getNode()
	                    .hasChild(childKey)) {
	                    // No complete child available, delete the existing one, if any
	                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, ChildrenNode_1.ChildrenNode.EMPTY_NODE, path.popFront(), source, accumulator);
	                }
	                else {
	                    newEventCache = oldEventCache;
	                }
	                if (newEventCache.isEmpty() &&
	                    viewCache.getServerCache().isFullyInitialized()) {
	                    // We might have reverted all child writes. Maybe the old event was a leaf node
	                    complete = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
	                    if (complete.isLeafNode()) {
	                        newEventCache = this.filter_.updateFullNode(newEventCache, complete, accumulator);
	                    }
	                }
	            }
	            complete =
	                viewCache.getServerCache().isFullyInitialized() ||
	                    writesCache.shadowingWrite(Path_1.Path.Empty) != null;
	            return viewCache.updateEventSnap(newEventCache, complete, this.filter_.filtersNodes());
	        }
	    };
	    return ViewProcessor;
	}());
	exports.ViewProcessor = ViewProcessor;
	
	//# sourceMappingURL=ViewProcessor.js.map


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var RangedFilter_1 = __webpack_require__(185);
	var ChildrenNode_1 = __webpack_require__(28);
	var Node_1 = __webpack_require__(30);
	var util_1 = __webpack_require__(2);
	var Change_1 = __webpack_require__(54);
	/**
	 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
	 *
	 * @constructor
	 * @implements {NodeFilter}
	 */
	var LimitedFilter = /** @class */ (function () {
	    /**
	     * @param {!QueryParams} params
	     */
	    function LimitedFilter(params) {
	        this.rangedFilter_ = new RangedFilter_1.RangedFilter(params);
	        this.index_ = params.getIndex();
	        this.limit_ = params.getLimit();
	        this.reverse_ = !params.isViewFromLeft();
	    }
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
	        if (!this.rangedFilter_.matches(new Node_1.NamedNode(key, newChild))) {
	            newChild = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
	        }
	        if (snap.getImmediateChild(key).equals(newChild)) {
	            // No change
	            return snap;
	        }
	        else if (snap.numChildren() < this.limit_) {
	            return this.rangedFilter_
	                .getIndexedFilter()
	                .updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
	        }
	        else {
	            return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
	        var filtered;
	        if (newSnap.isLeafNode() || newSnap.isEmpty()) {
	            // Make sure we have a children node with the correct index, not a leaf node;
	            filtered = ChildrenNode_1.ChildrenNode.EMPTY_NODE.withIndex(this.index_);
	        }
	        else {
	            if (this.limit_ * 2 < newSnap.numChildren() &&
	                newSnap.isIndexed(this.index_)) {
	                // Easier to build up a snapshot, since what we're given has more than twice the elements we want
	                filtered = ChildrenNode_1.ChildrenNode.EMPTY_NODE.withIndex(this.index_);
	                // anchor to the startPost, endPost, or last element as appropriate
	                var iterator = void 0;
	                if (this.reverse_) {
	                    iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
	                }
	                else {
	                    iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
	                }
	                var count = 0;
	                while (iterator.hasNext() && count < this.limit_) {
	                    var next = iterator.getNext();
	                    var inRange = void 0;
	                    if (this.reverse_) {
	                        inRange =
	                            this.index_.compare(this.rangedFilter_.getStartPost(), next) <= 0;
	                    }
	                    else {
	                        inRange =
	                            this.index_.compare(next, this.rangedFilter_.getEndPost()) <= 0;
	                    }
	                    if (inRange) {
	                        filtered = filtered.updateImmediateChild(next.name, next.node);
	                        count++;
	                    }
	                    else {
	                        // if we have reached the end post, we cannot keep adding elemments
	                        break;
	                    }
	                }
	            }
	            else {
	                // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
	                filtered = newSnap.withIndex(this.index_);
	                // Don't support priorities on queries
	                filtered = filtered.updatePriority(ChildrenNode_1.ChildrenNode.EMPTY_NODE);
	                var startPost = void 0;
	                var endPost = void 0;
	                var cmp = void 0;
	                var iterator = void 0;
	                if (this.reverse_) {
	                    iterator = filtered.getReverseIterator(this.index_);
	                    startPost = this.rangedFilter_.getEndPost();
	                    endPost = this.rangedFilter_.getStartPost();
	                    var indexCompare_1 = this.index_.getCompare();
	                    cmp = function (a, b) { return indexCompare_1(b, a); };
	                }
	                else {
	                    iterator = filtered.getIterator(this.index_);
	                    startPost = this.rangedFilter_.getStartPost();
	                    endPost = this.rangedFilter_.getEndPost();
	                    cmp = this.index_.getCompare();
	                }
	                var count = 0;
	                var foundStartPost = false;
	                while (iterator.hasNext()) {
	                    var next = iterator.getNext();
	                    if (!foundStartPost && cmp(startPost, next) <= 0) {
	                        // start adding
	                        foundStartPost = true;
	                    }
	                    var inRange = foundStartPost && count < this.limit_ && cmp(next, endPost) <= 0;
	                    if (inRange) {
	                        count++;
	                    }
	                    else {
	                        filtered = filtered.updateImmediateChild(next.name, ChildrenNode_1.ChildrenNode.EMPTY_NODE);
	                    }
	                }
	            }
	        }
	        return this.rangedFilter_
	            .getIndexedFilter()
	            .updateFullNode(oldSnap, filtered, optChangeAccumulator);
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
	        // Don't support priorities on queries
	        return oldSnap;
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.filtersNodes = function () {
	        return true;
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.getIndexedFilter = function () {
	        return this.rangedFilter_.getIndexedFilter();
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.getIndex = function () {
	        return this.index_;
	    };
	    /**
	     * @param {!Node} snap
	     * @param {string} childKey
	     * @param {!Node} childSnap
	     * @param {!CompleteChildSource} source
	     * @param {?ChildChangeAccumulator} changeAccumulator
	     * @return {!Node}
	     * @private
	     */
	    LimitedFilter.prototype.fullLimitUpdateChild_ = function (snap, childKey, childSnap, source, changeAccumulator) {
	        // TODO: rename all cache stuff etc to general snap terminology
	        var cmp;
	        if (this.reverse_) {
	            var indexCmp_1 = this.index_.getCompare();
	            cmp = function (a, b) { return indexCmp_1(b, a); };
	        }
	        else {
	            cmp = this.index_.getCompare();
	        }
	        var oldEventCache = snap;
	        util_1.assert(oldEventCache.numChildren() == this.limit_, '');
	        var newChildNamedNode = new Node_1.NamedNode(childKey, childSnap);
	        var windowBoundary = this.reverse_
	            ? oldEventCache.getFirstChild(this.index_)
	            : oldEventCache.getLastChild(this.index_);
	        var inRange = this.rangedFilter_.matches(newChildNamedNode);
	        if (oldEventCache.hasChild(childKey)) {
	            var oldChildSnap = oldEventCache.getImmediateChild(childKey);
	            var nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
	            while (nextChild != null &&
	                (nextChild.name == childKey || oldEventCache.hasChild(nextChild.name))) {
	                // There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
	                // been applied to the limited filter yet. Ignore this next child which will be updated later in
	                // the limited filter...
	                nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
	            }
	            var compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
	            var remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
	            if (remainsInWindow) {
	                if (changeAccumulator != null) {
	                    changeAccumulator.trackChildChange(Change_1.Change.childChangedChange(childKey, childSnap, oldChildSnap));
	                }
	                return oldEventCache.updateImmediateChild(childKey, childSnap);
	            }
	            else {
	                if (changeAccumulator != null) {
	                    changeAccumulator.trackChildChange(Change_1.Change.childRemovedChange(childKey, oldChildSnap));
	                }
	                var newEventCache = oldEventCache.updateImmediateChild(childKey, ChildrenNode_1.ChildrenNode.EMPTY_NODE);
	                var nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
	                if (nextChildInRange) {
	                    if (changeAccumulator != null) {
	                        changeAccumulator.trackChildChange(Change_1.Change.childAddedChange(nextChild.name, nextChild.node));
	                    }
	                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
	                }
	                else {
	                    return newEventCache;
	                }
	            }
	        }
	        else if (childSnap.isEmpty()) {
	            // we're deleting a node, but it was not in the window, so ignore it
	            return snap;
	        }
	        else if (inRange) {
	            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
	                if (changeAccumulator != null) {
	                    changeAccumulator.trackChildChange(Change_1.Change.childRemovedChange(windowBoundary.name, windowBoundary.node));
	                    changeAccumulator.trackChildChange(Change_1.Change.childAddedChange(childKey, childSnap));
	                }
	                return oldEventCache
	                    .updateImmediateChild(childKey, childSnap)
	                    .updateImmediateChild(windowBoundary.name, ChildrenNode_1.ChildrenNode.EMPTY_NODE);
	            }
	            else {
	                return snap;
	            }
	        }
	        else {
	            return snap;
	        }
	    };
	    return LimitedFilter;
	}());
	exports.LimitedFilter = LimitedFilter;
	
	//# sourceMappingURL=LimitedFilter.js.map


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var BrowserPollConnection_1 = __webpack_require__(186);
	var WebSocketConnection_1 = __webpack_require__(188);
	var util_1 = __webpack_require__(13);
	/**
	 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
	 * lifecycle.
	 *
	 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
	 * they are available.
	 * @constructor
	 */
	var TransportManager = /** @class */ (function () {
	    /**
	     * @param {!RepoInfo} repoInfo Metadata around the namespace we're connecting to
	     */
	    function TransportManager(repoInfo) {
	        this.initTransports_(repoInfo);
	    }
	    Object.defineProperty(TransportManager, "ALL_TRANSPORTS", {
	        /**
	         * @const
	         * @type {!Array.<function(new:Transport, string, RepoInfo, string=)>}
	         */
	        get: function () {
	            return [BrowserPollConnection_1.BrowserPollConnection, WebSocketConnection_1.WebSocketConnection];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {!RepoInfo} repoInfo
	     * @private
	     */
	    TransportManager.prototype.initTransports_ = function (repoInfo) {
	        var isWebSocketsAvailable = WebSocketConnection_1.WebSocketConnection && WebSocketConnection_1.WebSocketConnection['isAvailable']();
	        var isSkipPollConnection = isWebSocketsAvailable && !WebSocketConnection_1.WebSocketConnection.previouslyFailed();
	        if (repoInfo.webSocketOnly) {
	            if (!isWebSocketsAvailable)
	                util_1.warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
	            isSkipPollConnection = true;
	        }
	        if (isSkipPollConnection) {
	            this.transports_ = [WebSocketConnection_1.WebSocketConnection];
	        }
	        else {
	            var transports_1 = (this.transports_ = []);
	            util_1.each(TransportManager.ALL_TRANSPORTS, function (i, transport) {
	                if (transport && transport['isAvailable']()) {
	                    transports_1.push(transport);
	                }
	            });
	        }
	    };
	    /**
	     * @return {function(new:Transport, !string, !RepoInfo, string=, string=)} The constructor for the
	     * initial transport to use
	     */
	    TransportManager.prototype.initialTransport = function () {
	        if (this.transports_.length > 0) {
	            return this.transports_[0];
	        }
	        else {
	            throw new Error('No transports available');
	        }
	    };
	    /**
	     * @return {?function(new:Transport, function(),function(), string=)} The constructor for the next
	     * transport, or null
	     */
	    TransportManager.prototype.upgradeTransport = function () {
	        if (this.transports_.length > 1) {
	            return this.transports_[1];
	        }
	        else {
	            return null;
	        }
	    };
	    return TransportManager;
	}());
	exports.TransportManager = TransportManager;
	
	//# sourceMappingURL=TransportManager.js.map


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(13);
	/**
	 * This class ensures the packets from the server arrive in order
	 * This class takes data from the server and ensures it gets passed into the callbacks in order.
	 * @constructor
	 */
	var PacketReceiver = /** @class */ (function () {
	    /**
	     * @param onMessage_
	     */
	    function PacketReceiver(onMessage_) {
	        this.onMessage_ = onMessage_;
	        this.pendingResponses = [];
	        this.currentResponseNum = 0;
	        this.closeAfterResponse = -1;
	        this.onClose = null;
	    }
	    PacketReceiver.prototype.closeAfter = function (responseNum, callback) {
	        this.closeAfterResponse = responseNum;
	        this.onClose = callback;
	        if (this.closeAfterResponse < this.currentResponseNum) {
	            this.onClose();
	            this.onClose = null;
	        }
	    };
	    /**
	     * Each message from the server comes with a response number, and an array of data. The responseNumber
	     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
	     * browsers will respond in the same order as the requests we sent
	     * @param {number} requestNum
	     * @param {Array} data
	     */
	    PacketReceiver.prototype.handleResponse = function (requestNum, data) {
	        var _this = this;
	        this.pendingResponses[requestNum] = data;
	        var _loop_1 = function () {
	            var toProcess = this_1.pendingResponses[this_1.currentResponseNum];
	            delete this_1.pendingResponses[this_1.currentResponseNum];
	            var _loop_2 = function (i) {
	                if (toProcess[i]) {
	                    util_1.exceptionGuard(function () {
	                        _this.onMessage_(toProcess[i]);
	                    });
	                }
	            };
	            for (var i = 0; i < toProcess.length; ++i) {
	                _loop_2(i);
	            }
	            if (this_1.currentResponseNum === this_1.closeAfterResponse) {
	                if (this_1.onClose) {
	                    this_1.onClose();
	                    this_1.onClose = null;
	                }
	                return "break";
	            }
	            this_1.currentResponseNum++;
	        };
	        var this_1 = this;
	        while (this.pendingResponses[this.currentResponseNum]) {
	            var state_1 = _loop_1();
	            if (state_1 === "break")
	                break;
	        }
	    };
	    return PacketReceiver;
	}());
	exports.PacketReceiver = PacketReceiver;
	
	//# sourceMappingURL=PacketReceiver.js.map


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var app_1 = __webpack_require__(35);
	__webpack_require__(479);
	var config_1 = __webpack_require__(478);
	function registerFirestore(instance) {
	    config_1.configureForFirebase(instance);
	}
	exports.registerFirestore = registerFirestore;
	registerFirestore(app_1.default);
	
	//# sourceMappingURL=index.js.map


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var user_1 = __webpack_require__(458);
	var assert_1 = __webpack_require__(10);
	var error_1 = __webpack_require__(19);
	var OAuthToken = /** @class */ (function () {
	    function OAuthToken(value, user) {
	        this.user = user;
	        this.type = 'OAuth';
	        this.authHeaders = { Authorization: "Bearer " + value };
	    }
	    return OAuthToken;
	}());
	exports.OAuthToken = OAuthToken;
	/** A CredentialsProvider that always yields an empty token. */
	var EmptyCredentialsProvider = /** @class */ (function () {
	    function EmptyCredentialsProvider() {
	        /**
	         * Stores the User listener registered with setUserChangeListener()
	         * This isn't actually necessary since the UID never changes, but we use this
	         * to verify the listen contract is adhered to in tests.
	         */
	        this.userListener = null;
	    }
	    EmptyCredentialsProvider.prototype.getToken = function (forceRefresh) {
	        return Promise.resolve(null);
	    };
	    EmptyCredentialsProvider.prototype.setUserChangeListener = function (listener) {
	        assert_1.assert(!this.userListener, 'Can only call setUserChangeListener() once.');
	        this.userListener = listener;
	        // Fire with initial user.
	        listener(user_1.User.UNAUTHENTICATED);
	    };
	    EmptyCredentialsProvider.prototype.removeUserChangeListener = function () {
	        assert_1.assert(this.userListener !== null, 'removeUserChangeListener() when no listener registered');
	        this.userListener = null;
	    };
	    return EmptyCredentialsProvider;
	}());
	exports.EmptyCredentialsProvider = EmptyCredentialsProvider;
	var FirebaseCredentialsProvider = /** @class */ (function () {
	    function FirebaseCredentialsProvider(app) {
	        var _this = this;
	        this.app = app;
	        /**
	         * The auth token listener registered with FirebaseApp, retained here so we
	         * can unregister it.
	         */
	        this.tokenListener = null;
	        /**
	         * Counter used to detect if the user changed while a getToken request was
	         * outstanding.
	         */
	        this.userCounter = 0;
	        /** The User listener registered with setUserChangeListener(). */
	        this.userListener = null;
	        // We listen for token changes but all we really care about is knowing when
	        // the uid may have changed.
	        this.tokenListener = function () {
	            var newUser = _this.getUser();
	            if (!_this.currentUser || !newUser.equals(_this.currentUser)) {
	                _this.currentUser = newUser;
	                _this.userCounter++;
	                if (_this.userListener) {
	                    _this.userListener(_this.currentUser);
	                }
	            }
	        };
	        this.userCounter = 0;
	        // Will fire at least once where we set this.currentUser
	        this.app.INTERNAL.addAuthTokenListener(this.tokenListener);
	    }
	    FirebaseCredentialsProvider.prototype.getToken = function (forceRefresh) {
	        var _this = this;
	        assert_1.assert(this.tokenListener != null, 'getToken cannot be called after listener removed.');
	        // Take note of the current value of the userCounter so that this method can
	        // fail (with an ABORTED error) if there is a user change while the request
	        // is outstanding.
	        var initialUserCounter = this.userCounter;
	        return this.app.INTERNAL.getToken(forceRefresh).then(function (tokenData) {
	            // Cancel the request since the user changed while the request was
	            // outstanding so the response is likely for a previous user (which
	            // user, we can't be sure).
	            if (_this.userCounter !== initialUserCounter) {
	                throw new error_1.FirestoreError(error_1.Code.ABORTED, 'getToken aborted due to uid change.');
	            }
	            else {
	                if (tokenData) {
	                    assert_1.assert(typeof tokenData.accessToken === 'string', 'Invalid tokenData returned from getToken():' + tokenData);
	                    return new OAuthToken(tokenData.accessToken, _this.currentUser);
	                }
	                else {
	                    return null;
	                }
	            }
	        });
	    };
	    FirebaseCredentialsProvider.prototype.setUserChangeListener = function (listener) {
	        assert_1.assert(!this.userListener, 'Can only call setUserChangeListener() once.');
	        this.userListener = listener;
	        // Fire the initial event, but only if we received the initial user
	        if (this.currentUser) {
	            listener(this.currentUser);
	        }
	    };
	    FirebaseCredentialsProvider.prototype.removeUserChangeListener = function () {
	        assert_1.assert(this.tokenListener != null, 'removeUserChangeListener() called twice');
	        assert_1.assert(this.userListener !== null, 'removeUserChangeListener() called when no listener registered');
	        this.app.INTERNAL.removeAuthTokenListener(this.tokenListener);
	        this.tokenListener = null;
	        this.userListener = null;
	    };
	    FirebaseCredentialsProvider.prototype.getUser = function () {
	        // TODO(mikelehen): Remove this check once we're shipping with firebase.js.
	        if (typeof this.app.INTERNAL.getUid !== 'function') {
	            assert_1.fail('This version of the Firestore SDK requires at least version' +
	                ' 3.7.0 of firebase.js.');
	        }
	        var currentUid = this.app.INTERNAL.getUid();
	        assert_1.assert(currentUid === null || typeof currentUid === 'string', 'Received invalid UID: ' + currentUid);
	        return new user_1.User(currentUid);
	    };
	    return FirebaseCredentialsProvider;
	}());
	exports.FirebaseCredentialsProvider = FirebaseCredentialsProvider;
	/*
	 * FirstPartyToken provides a fresh token each time its value
	 * is requested, because if the token is too old, requests will be rejected.
	 * TODO(b/33147818) this implementation violates the current assumption that
	 * tokens are immutable.  We need to either revisit this assumption or come
	 * up with some way for FPA to use the listen/unlisten interface.
	 */
	var FirstPartyToken = /** @class */ (function () {
	    function FirstPartyToken(gapi, sessionIndex) {
	        this.gapi = gapi;
	        this.sessionIndex = sessionIndex;
	        this.type = 'FirstParty';
	        this.user = user_1.User.FIRST_PARTY;
	        assert_1.assert(this.gapi &&
	            this.gapi['auth'] &&
	            this.gapi['auth']['getAuthHeaderValueForFirstParty'], 'unexpected gapi interface');
	    }
	    Object.defineProperty(FirstPartyToken.prototype, "authHeaders", {
	        get: function () {
	            return {
	                Authorization: this.gapi['auth']['getAuthHeaderValueForFirstParty']([]),
	                'X-Goog-AuthUser': this.sessionIndex
	            };
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return FirstPartyToken;
	}());
	exports.FirstPartyToken = FirstPartyToken;
	/*
	 * Provides user credentials required for the Firestore JavaScript SDK
	 * to authenticate the user, using technique that is only available
	 * to applications hosted by Google.
	 */
	var FirstPartyCredentialsProvider = /** @class */ (function () {
	    function FirstPartyCredentialsProvider(gapi, sessionIndex) {
	        this.gapi = gapi;
	        this.sessionIndex = sessionIndex;
	        assert_1.assert(this.gapi &&
	            this.gapi['auth'] &&
	            this.gapi['auth']['getAuthHeaderValueForFirstParty'], 'unexpected gapi interface');
	    }
	    FirstPartyCredentialsProvider.prototype.getToken = function (forceRefresh) {
	        return Promise.resolve(new FirstPartyToken(this.gapi, this.sessionIndex));
	    };
	    // TODO(33108925): can someone switch users w/o a page refresh?
	    // TODO(33110621): need to understand token/session lifecycle
	    FirstPartyCredentialsProvider.prototype.setUserChangeListener = function (listener) {
	        // Fire with initial uid.
	        listener(user_1.User.FIRST_PARTY);
	    };
	    FirstPartyCredentialsProvider.prototype.removeUserChangeListener = function () { };
	    return FirstPartyCredentialsProvider;
	}());
	exports.FirstPartyCredentialsProvider = FirstPartyCredentialsProvider;
	/**
	 * Builds a CredentialsProvider depending on the type of
	 * the credentials passed in.
	 */
	function makeCredentialsProvider(credentials) {
	    if (!credentials) {
	        return new EmptyCredentialsProvider();
	    }
	    switch (credentials.type) {
	        case 'gapi':
	            return new FirstPartyCredentialsProvider(credentials.client, credentials.sessionIndex || '0');
	        case 'provider':
	            return credentials.client;
	        default:
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'makeCredentialsProvider failed due to invalid credential type');
	    }
	}
	exports.makeCredentialsProvider = makeCredentialsProvider;
	
	//# sourceMappingURL=credentials.js.map


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var field_path_1 = __webpack_require__(122);
	var database_info_1 = __webpack_require__(190);
	var firestore_client_1 = __webpack_require__(460);
	var query_1 = __webpack_require__(124);
	var view_snapshot_1 = __webpack_require__(93);
	var document_1 = __webpack_require__(32);
	var document_key_1 = __webpack_require__(22);
	var field_value_1 = __webpack_require__(57);
	var mutation_1 = __webpack_require__(96);
	var path_1 = __webpack_require__(49);
	var platform_1 = __webpack_require__(40);
	var api_1 = __webpack_require__(128);
	var assert_1 = __webpack_require__(10);
	var async_observer_1 = __webpack_require__(488);
	var async_queue_1 = __webpack_require__(489);
	var error_1 = __webpack_require__(19);
	var input_validation_1 = __webpack_require__(72);
	var log = __webpack_require__(24);
	var log_1 = __webpack_require__(24);
	var misc_1 = __webpack_require__(25);
	var objUtils = __webpack_require__(36);
	var credentials_1 = __webpack_require__(454);
	var observer_1 = __webpack_require__(456);
	var user_data_converter_1 = __webpack_require__(457);
	// The objects that are a part of this API are exposed to third-parties as
	// compiled javascript so we want to flag our private members with a leading
	// underscore to discourage their use.
	// tslint:disable:strip-private-property-underscore
	var DEFAULT_HOST = 'firestore.googleapis.com';
	var DEFAULT_SSL = true;
	/**
	 * A concrete type describing all the values that can be applied via a
	 * user-supplied firestore.Settings object. This is a separate type so that
	 * defaults can be supplied and the value can be checked for equality.
	 */
	var FirestoreSettings = /** @class */ (function () {
	    function FirestoreSettings(settings) {
	        if (settings.host === undefined) {
	            if (settings.ssl !== undefined) {
	                throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
	            }
	            this.host = DEFAULT_HOST;
	            this.ssl = DEFAULT_SSL;
	        }
	        else {
	            input_validation_1.validateNamedType('settings', 'string', 'host', settings.host);
	            this.host = settings.host;
	            input_validation_1.validateNamedOptionalType('settings', 'boolean', 'ssl', settings.ssl);
	            this.ssl = objUtils.defaulted(settings.ssl, DEFAULT_SSL);
	        }
	        input_validation_1.validateOptionNames('settings', settings, ['host', 'ssl', 'credentials']);
	        input_validation_1.validateNamedOptionalType('settings', 'object', 'credentials', settings.credentials);
	        this.credentials = settings.credentials;
	    }
	    FirestoreSettings.prototype.equals = function (other) {
	        return (this.host === other.host &&
	            this.ssl === other.ssl &&
	            this.credentials === other.credentials);
	    };
	    return FirestoreSettings;
	}());
	var FirestoreConfig = /** @class */ (function () {
	    function FirestoreConfig() {
	    }
	    return FirestoreConfig;
	}());
	/**
	 * The root reference to the database.
	 */
	var Firestore = /** @class */ (function () {
	    function Firestore(databaseIdOrApp) {
	        var _this = this;
	        this._queue = new async_queue_1.AsyncQueue();
	        this.INTERNAL = {
	            delete: function () {
	                if (_this._firestoreClient) {
	                    return _this._firestoreClient.shutdown();
	                }
	                else {
	                    return Promise.resolve();
	                }
	            },
	            // Exposed via INTERNAL for use in tests.
	            disableNetwork: function () { return _this._firestoreClient.disableNetwork(); },
	            enableNetwork: function () { return _this._firestoreClient.enableNetwork(); },
	            drainAsyncQueue: function (executeDelayedTasks) {
	                return _this._queue.drain(executeDelayedTasks);
	            }
	        };
	        var config = new FirestoreConfig();
	        if (typeof databaseIdOrApp.options === 'object') {
	            // This is very likely a Firebase app object
	            // TODO(b/34177605): Can we somehow use instanceof?
	            var app = databaseIdOrApp;
	            config.firebaseApp = app;
	            config.databaseId = Firestore.databaseIdFromApp(app);
	            config.persistenceKey = config.firebaseApp.name;
	            config.credentials = new credentials_1.FirebaseCredentialsProvider(app);
	        }
	        else {
	            var external_1 = databaseIdOrApp;
	            if (!external_1.projectId) {
	                throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Must provide projectId');
	            }
	            config.databaseId = new database_info_1.DatabaseId(external_1.projectId, external_1.database);
	            // Use a default persistenceKey that lines up with FirebaseApp.
	            config.persistenceKey = '[DEFAULT]';
	            config.credentials = new credentials_1.EmptyCredentialsProvider();
	        }
	        config.settings = new FirestoreSettings({});
	        this._config = config;
	        this._databaseId = config.databaseId;
	    }
	    Firestore.prototype.settings = function (settingsLiteral) {
	        input_validation_1.validateExactNumberOfArgs('Firestore.settings', arguments, 1);
	        input_validation_1.validateArgType('Firestore.settings', 'object', 1, settingsLiteral);
	        if (objUtils.contains(settingsLiteral, 'persistence')) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, '"persistence" is now specified with a separate call to ' +
	                'firestore.enablePersistence().');
	        }
	        var newSettings = new FirestoreSettings(settingsLiteral);
	        if (this._firestoreClient && !this._config.settings.equals(newSettings)) {
	            throw new error_1.FirestoreError(error_1.Code.FAILED_PRECONDITION, 'Firestore has already been started and its settings can no longer ' +
	                'be changed. You can only call settings() before calling any other ' +
	                'methods on a Firestore object.');
	        }
	        this._config.settings = newSettings;
	        if (newSettings.credentials !== undefined) {
	            this._config.credentials = credentials_1.makeCredentialsProvider(newSettings.credentials);
	        }
	    };
	    Firestore.prototype.enablePersistence = function () {
	        if (this._firestoreClient) {
	            throw new error_1.FirestoreError(error_1.Code.FAILED_PRECONDITION, 'Firestore has already been started and persistence can no longer ' +
	                'be enabled. You can only call enablePersistence() before calling ' +
	                'any other methods on a Firestore object.');
	        }
	        return this.configureClient(/* persistence= */ true);
	    };
	    Firestore.prototype.ensureClientConfigured = function () {
	        if (!this._firestoreClient) {
	            this.configureClient(/* persistence= */ false);
	        }
	        return this._firestoreClient;
	    };
	    Firestore.prototype.configureClient = function (persistence) {
	        var _this = this;
	        assert_1.assert(!!this._config.settings.host, 'FirestoreSettings.host cannot be falsey');
	        assert_1.assert(!this._firestoreClient, 'configureClient() called multiple times');
	        var databaseInfo = new database_info_1.DatabaseInfo(this._config.databaseId, this._config.persistenceKey, this._config.settings.host, this._config.settings.ssl);
	        var preConverter = function (value) {
	            if (value instanceof DocumentReference) {
	                var thisDb = _this._config.databaseId;
	                var otherDb = value.firestore._config.databaseId;
	                if (!otherDb.equals(thisDb)) {
	                    throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Document reference is for database ' +
	                        (otherDb.projectId + "/" + otherDb.database + " but should be ") +
	                        ("for database " + thisDb.projectId + "/" + thisDb.database));
	                }
	                return new user_data_converter_1.DocumentKeyReference(_this._config.databaseId, value._key);
	            }
	            else {
	                return value;
	            }
	        };
	        this._dataConverter = new user_data_converter_1.UserDataConverter(preConverter);
	        this._firestoreClient = new firestore_client_1.FirestoreClient(platform_1.PlatformSupport.getPlatform(), databaseInfo, this._config.credentials, this._queue);
	        return this._firestoreClient.start(persistence);
	    };
	    Firestore.databaseIdFromApp = function (app) {
	        var options = app.options;
	        if (!objUtils.contains(options, 'projectId')) {
	            // TODO(b/62673263): We can safely remove the special handling of
	            // 'firestoreId' once alpha testers have upgraded.
	            if (objUtils.contains(options, 'firestoreId')) {
	                throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, '"firestoreId" is now specified as "projectId" in ' +
	                    'firebase.initializeApp.');
	            }
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
	        }
	        if (objUtils.contains(options, 'firestoreOptions')) {
	            // TODO(b/62673263): We can safely remove the special handling of
	            // 'firestoreOptions' once alpha testers have upgraded.
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, '"firestoreOptions" values are now specified with ' +
	                'Firestore.settings()');
	        }
	        var projectId = options['projectId'];
	        if (!projectId || typeof projectId !== 'string') {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'projectId must be a string in FirebaseApp.options');
	        }
	        return new database_info_1.DatabaseId(projectId);
	    };
	    Object.defineProperty(Firestore.prototype, "app", {
	        get: function () {
	            if (!this._config.firebaseApp) {
	                throw new error_1.FirestoreError(error_1.Code.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is " +
	                    'not available');
	            }
	            return this._config.firebaseApp;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Firestore.prototype.collection = function (pathString) {
	        input_validation_1.validateExactNumberOfArgs('Firestore.collection', arguments, 1);
	        input_validation_1.validateArgType('Firestore.collection', 'string', 1, pathString);
	        if (!pathString) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Must provide a non-empty collection path to collection()');
	        }
	        this.ensureClientConfigured();
	        return new CollectionReference(path_1.ResourcePath.fromString(pathString), this);
	    };
	    Firestore.prototype.doc = function (pathString) {
	        input_validation_1.validateExactNumberOfArgs('Firestore.doc', arguments, 1);
	        input_validation_1.validateArgType('Firestore.doc', 'string', 1, pathString);
	        if (!pathString) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Must provide a non-empty document path to doc()');
	        }
	        this.ensureClientConfigured();
	        return DocumentReference.forPath(path_1.ResourcePath.fromString(pathString), this);
	    };
	    Firestore.prototype.runTransaction = function (updateFunction) {
	        var _this = this;
	        input_validation_1.validateExactNumberOfArgs('Firestore.runTransaction', arguments, 1);
	        input_validation_1.validateArgType('Firestore.runTransaction', 'function', 1, updateFunction);
	        return this.ensureClientConfigured().transaction(function (transaction) {
	            return updateFunction(new Transaction(_this, transaction));
	        });
	    };
	    Firestore.prototype.batch = function () {
	        this.ensureClientConfigured();
	        return new WriteBatch(this);
	    };
	    Object.defineProperty(Firestore, "logLevel", {
	        get: function () {
	            switch (log.getLogLevel()) {
	                case log_1.LogLevel.DEBUG:
	                    return 'debug';
	                case log_1.LogLevel.ERROR:
	                    return 'error';
	                case log_1.LogLevel.SILENT:
	                    return 'silent';
	                default:
	                    return assert_1.fail('Unknown log level: ' + log.getLogLevel());
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Firestore.setLogLevel = function (level) {
	        input_validation_1.validateExactNumberOfArgs('Firestore.setLogLevel', arguments, 1);
	        input_validation_1.validateArgType('Firestore.setLogLevel', 'string', 1, level);
	        switch (level) {
	            case 'debug':
	                log.setLogLevel(log.LogLevel.DEBUG);
	                break;
	            case 'error':
	                log.setLogLevel(log.LogLevel.ERROR);
	                break;
	            case 'silent':
	                log.setLogLevel(log.LogLevel.SILENT);
	                break;
	            default:
	                throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Invalid log level: ' + level);
	        }
	    };
	    return Firestore;
	}());
	exports.Firestore = Firestore;
	/**
	 * A reference to a transaction.
	 */
	var Transaction = /** @class */ (function () {
	    function Transaction(_firestore, _transaction) {
	        this._firestore = _firestore;
	        this._transaction = _transaction;
	    }
	    Transaction.prototype.get = function (documentRef) {
	        var _this = this;
	        input_validation_1.validateExactNumberOfArgs('Transaction.get', arguments, 1);
	        var ref = validateReference('Transaction.get', documentRef, this._firestore);
	        return this._transaction
	            .lookup([ref._key])
	            .then(function (docs) {
	            if (!docs || docs.length !== 1) {
	                return assert_1.fail('Mismatch in docs returned from document lookup.');
	            }
	            var doc = docs[0];
	            if (doc instanceof document_1.NoDocument) {
	                return new DocumentSnapshot(_this._firestore, ref._key, null, false);
	            }
	            return new DocumentSnapshot(_this._firestore, ref._key, doc, false);
	        });
	    };
	    Transaction.prototype.set = function (documentRef, value, options) {
	        input_validation_1.validateBetweenNumberOfArgs('Transaction.set', arguments, 2, 3);
	        var ref = validateReference('Transaction.set', documentRef, this._firestore);
	        options = validateSetOptions('Transaction.set', options);
	        var parsed = options.merge
	            ? this._firestore._dataConverter.parseMergeData('Transaction.set', value)
	            : this._firestore._dataConverter.parseSetData('Transaction.set', value);
	        this._transaction.set(ref._key, parsed);
	        return this;
	    };
	    Transaction.prototype.update = function (documentRef, fieldOrUpdateData, value) {
	        var moreFieldsAndValues = [];
	        for (var _i = 3; _i < arguments.length; _i++) {
	            moreFieldsAndValues[_i - 3] = arguments[_i];
	        }
	        var ref;
	        var parsed;
	        if (typeof fieldOrUpdateData === 'string' ||
	            fieldOrUpdateData instanceof field_path_1.FieldPath) {
	            input_validation_1.validateAtLeastNumberOfArgs('Transaction.update', arguments, 3);
	            ref = validateReference('Transaction.update', documentRef, this._firestore);
	            parsed = this._firestore._dataConverter.parseUpdateVarargs('Transaction.update', fieldOrUpdateData, value, moreFieldsAndValues);
	        }
	        else {
	            input_validation_1.validateExactNumberOfArgs('Transaction.update', arguments, 2);
	            ref = validateReference('Transaction.update', documentRef, this._firestore);
	            parsed = this._firestore._dataConverter.parseUpdateData('Transaction.update', fieldOrUpdateData);
	        }
	        this._transaction.update(ref._key, parsed);
	        return this;
	    };
	    Transaction.prototype.delete = function (documentRef) {
	        input_validation_1.validateExactNumberOfArgs('Transaction.delete', arguments, 1);
	        var ref = validateReference('Transaction.delete', documentRef, this._firestore);
	        this._transaction.delete(ref._key);
	        return this;
	    };
	    return Transaction;
	}());
	exports.Transaction = Transaction;
	var WriteBatch = /** @class */ (function () {
	    function WriteBatch(_firestore) {
	        this._firestore = _firestore;
	        this._mutations = [];
	        this._committed = false;
	    }
	    WriteBatch.prototype.set = function (documentRef, value, options) {
	        input_validation_1.validateBetweenNumberOfArgs('WriteBatch.set', arguments, 2, 3);
	        this.verifyNotCommitted();
	        var ref = validateReference('WriteBatch.set', documentRef, this._firestore);
	        options = validateSetOptions('WriteBatch.set', options);
	        var parsed = options.merge
	            ? this._firestore._dataConverter.parseMergeData('WriteBatch.set', value)
	            : this._firestore._dataConverter.parseSetData('WriteBatch.set', value);
	        this._mutations = this._mutations.concat(parsed.toMutations(ref._key, mutation_1.Precondition.NONE));
	        return this;
	    };
	    WriteBatch.prototype.update = function (documentRef, fieldOrUpdateData, value) {
	        var moreFieldsAndValues = [];
	        for (var _i = 3; _i < arguments.length; _i++) {
	            moreFieldsAndValues[_i - 3] = arguments[_i];
	        }
	        this.verifyNotCommitted();
	        var ref;
	        var parsed;
	        if (typeof fieldOrUpdateData === 'string' ||
	            fieldOrUpdateData instanceof field_path_1.FieldPath) {
	            input_validation_1.validateAtLeastNumberOfArgs('WriteBatch.update', arguments, 3);
	            ref = validateReference('WriteBatch.update', documentRef, this._firestore);
	            parsed = this._firestore._dataConverter.parseUpdateVarargs('WriteBatch.update', fieldOrUpdateData, value, moreFieldsAndValues);
	        }
	        else {
	            input_validation_1.validateExactNumberOfArgs('WriteBatch.update', arguments, 2);
	            ref = validateReference('WriteBatch.update', documentRef, this._firestore);
	            parsed = this._firestore._dataConverter.parseUpdateData('WriteBatch.update', fieldOrUpdateData);
	        }
	        this._mutations = this._mutations.concat(parsed.toMutations(ref._key, mutation_1.Precondition.exists(true)));
	        return this;
	    };
	    WriteBatch.prototype.delete = function (documentRef) {
	        input_validation_1.validateExactNumberOfArgs('WriteBatch.delete', arguments, 1);
	        this.verifyNotCommitted();
	        var ref = validateReference('WriteBatch.delete', documentRef, this._firestore);
	        this._mutations = this._mutations.concat(new mutation_1.DeleteMutation(ref._key, mutation_1.Precondition.NONE));
	        return this;
	    };
	    WriteBatch.prototype.commit = function () {
	        this.verifyNotCommitted();
	        this._committed = true;
	        if (this._mutations.length > 0) {
	            return this._firestore.ensureClientConfigured().write(this._mutations);
	        }
	        else {
	            return Promise.resolve();
	        }
	    };
	    WriteBatch.prototype.verifyNotCommitted = function () {
	        if (this._committed) {
	            throw new error_1.FirestoreError(error_1.Code.FAILED_PRECONDITION, 'A write batch can no longer be used after commit() ' +
	                'has been called.');
	        }
	    };
	    return WriteBatch;
	}());
	exports.WriteBatch = WriteBatch;
	/**
	 * A reference to a particular document in a collection in the database.
	 */
	var DocumentReference = /** @class */ (function () {
	    function DocumentReference(_key, firestore) {
	        this._key = _key;
	        this.firestore = firestore;
	        this._firestoreClient = this.firestore.ensureClientConfigured();
	    }
	    DocumentReference.forPath = function (path, firestore) {
	        if (path.length % 2 !== 0) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Invalid document reference. Document ' +
	                'references must have an even number of segments, but ' +
	                (path.canonicalString() + " has " + path.length));
	        }
	        return new DocumentReference(new document_key_1.DocumentKey(path), firestore);
	    };
	    Object.defineProperty(DocumentReference.prototype, "id", {
	        get: function () {
	            return this._key.path.lastSegment();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DocumentReference.prototype, "parent", {
	        get: function () {
	            return new CollectionReference(this._key.path.popLast(), this.firestore);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DocumentReference.prototype, "path", {
	        get: function () {
	            return this._key.path.canonicalString();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DocumentReference.prototype.collection = function (pathString) {
	        input_validation_1.validateExactNumberOfArgs('DocumentReference.collection', arguments, 1);
	        input_validation_1.validateArgType('DocumentReference.collection', 'string', 1, pathString);
	        if (!pathString) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Must provide a non-empty collection name to collection()');
	        }
	        var path = path_1.ResourcePath.fromString(pathString);
	        return new CollectionReference(this._key.path.child(path), this.firestore);
	    };
	    DocumentReference.prototype.isEqual = function (other) {
	        if (!(other instanceof DocumentReference)) {
	            throw input_validation_1.invalidClassError('isEqual', 'DocumentReference', 1, other);
	        }
	        return this.firestore === other.firestore && this._key.equals(other._key);
	    };
	    DocumentReference.prototype.set = function (value, options) {
	        input_validation_1.validateBetweenNumberOfArgs('DocumentReference.set', arguments, 1, 2);
	        options = validateSetOptions('DocumentReference.set', options);
	        var parsed = options.merge
	            ? this.firestore._dataConverter.parseMergeData('DocumentReference.set', value)
	            : this.firestore._dataConverter.parseSetData('DocumentReference.set', value);
	        return this._firestoreClient.write(parsed.toMutations(this._key, mutation_1.Precondition.NONE));
	    };
	    DocumentReference.prototype.update = function (fieldOrUpdateData, value) {
	        var moreFieldsAndValues = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            moreFieldsAndValues[_i - 2] = arguments[_i];
	        }
	        var parsed;
	        if (typeof fieldOrUpdateData === 'string' ||
	            fieldOrUpdateData instanceof field_path_1.FieldPath) {
	            input_validation_1.validateAtLeastNumberOfArgs('DocumentReference.update', arguments, 2);
	            parsed = this.firestore._dataConverter.parseUpdateVarargs('DocumentReference.update', fieldOrUpdateData, value, moreFieldsAndValues);
	        }
	        else {
	            input_validation_1.validateExactNumberOfArgs('DocumentReference.update', arguments, 1);
	            parsed = this.firestore._dataConverter.parseUpdateData('DocumentReference.update', fieldOrUpdateData);
	        }
	        return this._firestoreClient.write(parsed.toMutations(this._key, mutation_1.Precondition.exists(true)));
	    };
	    DocumentReference.prototype.delete = function () {
	        input_validation_1.validateExactNumberOfArgs('DocumentReference.delete', arguments, 0);
	        return this._firestoreClient.write([
	            new mutation_1.DeleteMutation(this._key, mutation_1.Precondition.NONE)
	        ]);
	    };
	    DocumentReference.prototype.onSnapshot = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        input_validation_1.validateBetweenNumberOfArgs('DocumentReference.onSnapshot', arguments, 1, 4);
	        var options = {
	            includeMetadataChanges: false
	        };
	        var observer;
	        var currArg = 0;
	        if (typeof args[currArg] === 'object' &&
	            !observer_1.isPartialObserver(args[currArg])) {
	            options = args[currArg];
	            input_validation_1.validateOptionNames('DocumentReference.onSnapshot', options, [
	                'includeMetadataChanges'
	            ]);
	            input_validation_1.validateNamedOptionalType('DocumentReference.onSnapshot', 'boolean', 'includeMetadataChanges', options.includeMetadataChanges);
	            currArg++;
	        }
	        var internalOptions = {
	            includeDocumentMetadataChanges: options.includeMetadataChanges,
	            includeQueryMetadataChanges: options.includeMetadataChanges
	        };
	        if (observer_1.isPartialObserver(args[currArg])) {
	            observer = args[currArg];
	        }
	        else {
	            input_validation_1.validateArgType('DocumentReference.onSnapshot', 'function', currArg, args[currArg]);
	            input_validation_1.validateOptionalArgType('DocumentReference.onSnapshot', 'function', currArg + 1, args[currArg + 1]);
	            input_validation_1.validateOptionalArgType('DocumentReference.onSnapshot', 'function', currArg + 2, args[currArg + 2]);
	            observer = {
	                next: args[currArg],
	                error: args[currArg + 1],
	                complete: args[currArg + 2]
	            };
	        }
	        return this.onSnapshotInternal(internalOptions, observer);
	    };
	    DocumentReference.prototype.onSnapshotInternal = function (options, observer) {
	        var _this = this;
	        var errHandler = function (err) {
	            console.error('Uncaught Error in onSnapshot:', err);
	        };
	        if (observer.error) {
	            errHandler = observer.error.bind(observer);
	        }
	        var asyncObserver = new async_observer_1.AsyncObserver({
	            next: function (snapshot) {
	                if (observer.next) {
	                    assert_1.assert(snapshot.docs.size <= 1, 'Too many documents returned on a document query');
	                    var doc = snapshot.docs.get(_this._key);
	                    observer.next(new DocumentSnapshot(_this.firestore, _this._key, doc, snapshot.fromCache));
	                }
	            },
	            error: errHandler
	        });
	        var internalListener = this._firestoreClient.listen(query_1.Query.atPath(this._key.path), asyncObserver, options);
	        return function () {
	            asyncObserver.mute();
	            _this._firestoreClient.unlisten(internalListener);
	        };
	    };
	    DocumentReference.prototype.get = function () {
	        var _this = this;
	        input_validation_1.validateExactNumberOfArgs('DocumentReference.get', arguments, 0);
	        return new Promise(function (resolve, reject) {
	            var unlisten = _this.onSnapshotInternal({
	                includeQueryMetadataChanges: true,
	                includeDocumentMetadataChanges: true,
	                waitForSyncWhenOnline: true
	            }, {
	                next: function (snap) {
	                    // Remove query first before passing event to user to avoid
	                    // user actions affecting the now stale query.
	                    unlisten();
	                    if (!snap.exists && snap.metadata.fromCache) {
	                        // TODO(dimond): If we're online and the document doesn't
	                        // exist then we resolve with a doc.exists set to false. If
	                        // we're offline however, we reject the Promise in this
	                        // case. Two options: 1) Cache the negative response from
	                        // the server so we can deliver that even when you're
	                        // offline 2) Actually reject the Promise in the online case
	                        // if the document doesn't exist.
	                        reject(new error_1.FirestoreError(error_1.Code.ABORTED, 'Failed to get document because the client is ' + 'offline.'));
	                    }
	                    else {
	                        resolve(snap);
	                    }
	                },
	                error: reject
	            });
	        });
	    };
	    return DocumentReference;
	}());
	exports.DocumentReference = DocumentReference;
	var DocumentSnapshot = /** @class */ (function () {
	    function DocumentSnapshot(_firestore, _key, _document, _fromCache) {
	        this._firestore = _firestore;
	        this._key = _key;
	        this._document = _document;
	        this._fromCache = _fromCache;
	    }
	    DocumentSnapshot.prototype.data = function () {
	        input_validation_1.validateExactNumberOfArgs('DocumentSnapshot.data', arguments, 0);
	        if (!this._document) {
	            throw new error_1.FirestoreError(error_1.Code.NOT_FOUND, "This document doesn't exist. Check doc.exists to make sure " +
	                'the document exists before calling doc.data().');
	        }
	        return this.convertObject(this._document.data);
	    };
	    DocumentSnapshot.prototype.get = function (fieldPath) {
	        input_validation_1.validateExactNumberOfArgs('DocumentSnapshot.get', arguments, 1);
	        if (!this._document) {
	            throw new error_1.FirestoreError(error_1.Code.NOT_FOUND, "This document doesn't exist. Check doc.exists to make sure " +
	                'the document exists before calling doc.get().');
	        }
	        var value = this._document.data.field(user_data_converter_1.fieldPathFromArgument('DocumentSnapshot.get', fieldPath));
	        return value === undefined ? undefined : this.convertValue(value);
	    };
	    Object.defineProperty(DocumentSnapshot.prototype, "id", {
	        get: function () {
	            return this._key.path.lastSegment();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DocumentSnapshot.prototype, "ref", {
	        get: function () {
	            return new DocumentReference(this._key, this._firestore);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DocumentSnapshot.prototype, "exists", {
	        get: function () {
	            return this._document !== null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DocumentSnapshot.prototype, "metadata", {
	        get: function () {
	            return {
	                hasPendingWrites: this._document !== null && this._document.hasLocalMutations,
	                fromCache: this._fromCache
	            };
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DocumentSnapshot.prototype.convertObject = function (data) {
	        var _this = this;
	        var result = {};
	        data.forEach(function (key, value) {
	            result[key] = _this.convertValue(value);
	        });
	        return result;
	    };
	    DocumentSnapshot.prototype.convertValue = function (value) {
	        if (value instanceof field_value_1.ObjectValue) {
	            return this.convertObject(value);
	        }
	        else if (value instanceof field_value_1.ArrayValue) {
	            return this.convertArray(value);
	        }
	        else if (value instanceof field_value_1.RefValue) {
	            var key = value.value();
	            var database = this._firestore.ensureClientConfigured().databaseId();
	            if (!value.databaseId.equals(database)) {
	                // TODO(b/64130202): Somehow support foreign references.
	                log.error("Document " + this._key.path + " contains a document " +
	                    "reference within a different database (" +
	                    (value.databaseId.projectId + "/" + value.databaseId.database + ") which is not ") +
	                    "supported. It will be treated as a reference in the current " +
	                    ("database (" + database.projectId + "/" + database.database + ") ") +
	                    "instead.");
	            }
	            return new DocumentReference(key, this._firestore);
	        }
	        else {
	            return value.value();
	        }
	    };
	    DocumentSnapshot.prototype.convertArray = function (data) {
	        var _this = this;
	        return data.internalValue.map(function (value) {
	            return _this.convertValue(value);
	        });
	    };
	    return DocumentSnapshot;
	}());
	exports.DocumentSnapshot = DocumentSnapshot;
	var Query = /** @class */ (function () {
	    function Query(_query, firestore) {
	        this._query = _query;
	        this.firestore = firestore;
	    }
	    Query.prototype.where = function (field, opStr, value) {
	        input_validation_1.validateExactNumberOfArgs('Query.where', arguments, 3);
	        input_validation_1.validateArgType('Query.where', 'string', 2, opStr);
	        input_validation_1.validateDefined('Query.where', 3, value);
	        var fieldValue;
	        var fieldPath = user_data_converter_1.fieldPathFromArgument('Query.where', field);
	        if (fieldPath.isKeyField()) {
	            if (typeof value === 'string') {
	                if (value.indexOf('/') !== -1) {
	                    // TODO(dimond): Allow slashes once ancestor queries are supported
	                    throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Function Query.where() requires its third parameter to be a ' +
	                        'valid document ID if the first parameter is ' +
	                        'FieldPath.documentId(), but it contains a slash.');
	                }
	                if (value === '') {
	                    throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Function Query.where() requires its third parameter to be a ' +
	                        'valid document ID if the first parameter is ' +
	                        'FieldPath.documentId(), but it was an empty string.');
	                }
	                var path = this._query.path.child(new path_1.ResourcePath([value]));
	                assert_1.assert(path.length % 2 === 0, 'Path should be a document key');
	                fieldValue = new field_value_1.RefValue(this.firestore._databaseId, new document_key_1.DocumentKey(path));
	            }
	            else if (value instanceof DocumentReference) {
	                var ref = value;
	                fieldValue = new field_value_1.RefValue(this.firestore._databaseId, ref._key);
	            }
	            else {
	                throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function Query.where() requires its third parameter to be a " +
	                    "string or a DocumentReference if the first parameter is " +
	                    "FieldPath.documentId(), but it was: " +
	                    (input_validation_1.valueDescription(value) + "."));
	            }
	        }
	        else {
	            fieldValue = this.firestore._dataConverter.parseQueryValue('Query.where', value);
	        }
	        var filter = query_1.fieldFilter(fieldPath, query_1.RelationOp.fromString(opStr), fieldValue);
	        this.validateNewFilter(filter);
	        return new Query(this._query.addFilter(filter), this.firestore);
	    };
	    Query.prototype.orderBy = function (field, directionStr) {
	        input_validation_1.validateBetweenNumberOfArgs('Query.orderBy', arguments, 1, 2);
	        input_validation_1.validateOptionalArgType('Query.orderBy', 'string', 2, directionStr);
	        var direction;
	        if (directionStr === undefined || directionStr === 'asc') {
	            direction = query_1.Direction.ASCENDING;
	        }
	        else if (directionStr === 'desc') {
	            direction = query_1.Direction.DESCENDING;
	        }
	        else {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function Query.orderBy() has unknown direction '" + directionStr + "', " +
	                "expected 'asc' or 'desc'.");
	        }
	        if (this._query.startAt !== null) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Invalid query. You must not call Query.startAt() or ' +
	                'Query.startAfter() before calling Query.orderBy().');
	        }
	        if (this._query.endAt !== null) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Invalid query. You must not call Query.endAt() or ' +
	                'Query.endBefore() before calling Query.orderBy().');
	        }
	        var fieldPath = user_data_converter_1.fieldPathFromArgument('Query.orderBy', field);
	        var orderBy = new query_1.OrderBy(fieldPath, direction);
	        this.validateNewOrderBy(orderBy);
	        return new Query(this._query.addOrderBy(orderBy), this.firestore);
	    };
	    Query.prototype.limit = function (n) {
	        input_validation_1.validateExactNumberOfArgs('Query.limit', arguments, 1);
	        input_validation_1.validateArgType('Query.limit', 'number', 1, n);
	        if (n <= 0) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Invalid Query. Query limit (" + n + ") is invalid. Limit must be " +
	                'positive.');
	        }
	        return new Query(this._query.withLimit(n), this.firestore);
	    };
	    Query.prototype.startAt = function (docOrField) {
	        var fields = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            fields[_i - 1] = arguments[_i];
	        }
	        input_validation_1.validateAtLeastNumberOfArgs('Query.startAt', arguments, 1);
	        var bound = this.boundFromDocOrFields('Query.startAt', docOrField, fields, 
	        /*before=*/ true);
	        return new Query(this._query.withStartAt(bound), this.firestore);
	    };
	    Query.prototype.startAfter = function (docOrField) {
	        var fields = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            fields[_i - 1] = arguments[_i];
	        }
	        input_validation_1.validateAtLeastNumberOfArgs('Query.startAfter', arguments, 1);
	        var bound = this.boundFromDocOrFields('Query.startAfter', docOrField, fields, 
	        /*before=*/ false);
	        return new Query(this._query.withStartAt(bound), this.firestore);
	    };
	    Query.prototype.endBefore = function (docOrField) {
	        var fields = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            fields[_i - 1] = arguments[_i];
	        }
	        input_validation_1.validateAtLeastNumberOfArgs('Query.endBefore', arguments, 1);
	        var bound = this.boundFromDocOrFields('Query.endBefore', docOrField, fields, 
	        /*before=*/ true);
	        return new Query(this._query.withEndAt(bound), this.firestore);
	    };
	    Query.prototype.endAt = function (docOrField) {
	        var fields = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            fields[_i - 1] = arguments[_i];
	        }
	        input_validation_1.validateAtLeastNumberOfArgs('Query.endAt', arguments, 1);
	        var bound = this.boundFromDocOrFields('Query.endAt', docOrField, fields, 
	        /*before=*/ false);
	        return new Query(this._query.withEndAt(bound), this.firestore);
	    };
	    Query.prototype.isEqual = function (other) {
	        if (!(other instanceof Query)) {
	            throw input_validation_1.invalidClassError('isEqual', 'Query', 1, other);
	        }
	        return (this.firestore === other.firestore && this._query.equals(other._query));
	    };
	    /** Helper function to create a bound from a document or fields */
	    Query.prototype.boundFromDocOrFields = function (methodName, docOrField, fields, before) {
	        input_validation_1.validateDefined(methodName, 1, docOrField);
	        if (docOrField instanceof DocumentSnapshot) {
	            if (fields.length > 0) {
	                throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Too many arguments provided to " + methodName + "().");
	            }
	            var snap = docOrField;
	            if (!snap.exists) {
	                throw new error_1.FirestoreError(error_1.Code.NOT_FOUND, "Can't use a DocumentSnapshot that doesn't exist for " +
	                    (methodName + "()."));
	            }
	            return this.boundFromDocument(methodName, snap._document, before);
	        }
	        else {
	            var allFields = [docOrField].concat(fields);
	            return this.boundFromFields(methodName, allFields, before);
	        }
	    };
	    /**
	     * Create a Bound from a query and a document.
	     *
	     * Note that the Bound will always include the key of the document
	     * and so only the provided document will compare equal to the returned
	     * position.
	     *
	     * Will throw if the document does not contain all fields of the order by
	     * of the query.
	     */
	    Query.prototype.boundFromDocument = function (methodName, doc, before) {
	        var components = [];
	        // Because people expect to continue/end a query at the exact document
	        // provided, we need to use the implicit sort order rather than the explicit
	        // sort order, because it's guaranteed to contain the document key. That way
	        // the position becomes unambiguous and the query continues/ends exactly at
	        // the provided document. Without the key (by using the explicit sort
	        // orders), multiple documents could match the position, yielding duplicate
	        // results.
	        for (var _i = 0, _a = this._query.orderBy; _i < _a.length; _i++) {
	            var orderBy = _a[_i];
	            if (orderBy.field.isKeyField()) {
	                components.push(new field_value_1.RefValue(this.firestore._databaseId, doc.key));
	            }
	            else {
	                var value = doc.field(orderBy.field);
	                if (value !== undefined) {
	                    components.push(value);
	                }
	                else {
	                    var field = orderBy.field.canonicalString();
	                    throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Invalid query. You are trying to start or end a query using a " +
	                        ("document for which the field '" + field + "' (used as the ") +
	                        "orderBy) does not exist.");
	                }
	            }
	        }
	        return new query_1.Bound(components, before);
	    };
	    /**
	     * Converts a list of field values to a Bound for the given query.
	     */
	    Query.prototype.boundFromFields = function (methodName, values, before) {
	        // Use explicit order by's because it has to match the query the user made
	        var orderBy = this._query.explicitOrderBy;
	        if (values.length > orderBy.length) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Too many arguments provided to " + methodName + "(). " +
	                "The number of arguments must be less than or equal to the " +
	                "number of Query.orderBy() clauses");
	        }
	        var components = [];
	        for (var i = 0; i < values.length; i++) {
	            var rawValue = values[i];
	            var orderByComponent = orderBy[i];
	            if (orderByComponent.field.isKeyField()) {
	                if (typeof rawValue !== 'string') {
	                    throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Invalid query. Expected a string for document ID in " +
	                        (methodName + "(), but got a " + typeof rawValue));
	                }
	                if (rawValue.indexOf('/') !== -1) {
	                    throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Invalid query. Document ID '" + rawValue + "' contains a slash in " +
	                        (methodName + "()"));
	                }
	                var key = new document_key_1.DocumentKey(this._query.path.child(rawValue));
	                components.push(new field_value_1.RefValue(this.firestore._databaseId, key));
	            }
	            else {
	                var wrapped = this.firestore._dataConverter.parseQueryValue(methodName, rawValue);
	                components.push(wrapped);
	            }
	        }
	        return new query_1.Bound(components, before);
	    };
	    Query.prototype.onSnapshot = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        input_validation_1.validateBetweenNumberOfArgs('Query.onSnapshot', arguments, 1, 4);
	        var options = {};
	        var observer;
	        var currArg = 0;
	        if (typeof args[currArg] === 'object' &&
	            !observer_1.isPartialObserver(args[currArg])) {
	            options = args[currArg];
	            input_validation_1.validateOptionNames('Query.onSnapshot', options, [
	                'includeQueryMetadataChanges',
	                'includeDocumentMetadataChanges'
	            ]);
	            input_validation_1.validateNamedOptionalType('Query.onSnapshot', 'boolean', 'includeDocumentMetadataChanges', options.includeDocumentMetadataChanges);
	            input_validation_1.validateNamedOptionalType('Query.onSnapshot', 'boolean', 'includeQueryMetadataChanges', options.includeQueryMetadataChanges);
	            currArg++;
	        }
	        if (observer_1.isPartialObserver(args[currArg])) {
	            observer = args[currArg];
	        }
	        else {
	            input_validation_1.validateArgType('Query.onSnapshot', 'function', currArg, args[currArg]);
	            input_validation_1.validateOptionalArgType('Query.onSnapshot', 'function', currArg + 1, args[currArg + 1]);
	            input_validation_1.validateOptionalArgType('Query.onSnapshot', 'function', currArg + 2, args[currArg + 2]);
	            observer = {
	                next: args[currArg],
	                error: args[currArg + 1],
	                complete: args[currArg + 2]
	            };
	        }
	        return this.onSnapshotInternal(options, observer);
	    };
	    Query.prototype.onSnapshotInternal = function (options, observer) {
	        var _this = this;
	        var errHandler = function (err) {
	            console.error('Uncaught Error in onSnapshot:', err);
	        };
	        if (observer.error) {
	            errHandler = observer.error.bind(observer);
	        }
	        var asyncObserver = new async_observer_1.AsyncObserver({
	            next: function (result) {
	                if (observer.next) {
	                    observer.next(new QuerySnapshot(_this.firestore, _this._query, result));
	                }
	            },
	            error: errHandler
	        });
	        var firestoreClient = this.firestore.ensureClientConfigured();
	        var internalListener = firestoreClient.listen(this._query, asyncObserver, options);
	        return function () {
	            asyncObserver.mute();
	            firestoreClient.unlisten(internalListener);
	        };
	    };
	    Query.prototype.get = function () {
	        var _this = this;
	        input_validation_1.validateExactNumberOfArgs('Query.get', arguments, 0);
	        return new Promise(function (resolve, reject) {
	            var unlisten = _this.onSnapshotInternal({
	                includeDocumentMetadataChanges: false,
	                includeQueryMetadataChanges: true,
	                waitForSyncWhenOnline: true
	            }, {
	                next: function (result) {
	                    // Remove query first before passing event to user to avoid
	                    // user actions affecting the now stale query.
	                    unlisten();
	                    resolve(result);
	                },
	                error: reject
	            });
	        });
	    };
	    Query.prototype.validateNewFilter = function (filter) {
	        if (filter instanceof query_1.RelationFilter && filter.isInequality()) {
	            var existingField = this._query.getInequalityFilterField();
	            if (existingField !== null && !existingField.equals(filter.field)) {
	                throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Invalid query. All where filters with an inequality' +
	                    ' (<, <=, >, or >=) must be on the same field. But you have' +
	                    (" inequality filters on '" + existingField.toString() + "'") +
	                    (" and '" + filter.field.toString() + "'"));
	            }
	            var firstOrderByField = this._query.getFirstOrderByField();
	            if (firstOrderByField !== null) {
	                this.validateOrderByAndInequalityMatch(filter.field, firstOrderByField);
	            }
	        }
	    };
	    Query.prototype.validateNewOrderBy = function (orderBy) {
	        if (this._query.getFirstOrderByField() === null) {
	            // This is the first order by. It must match any inequality.
	            var inequalityField = this._query.getInequalityFilterField();
	            if (inequalityField !== null) {
	                this.validateOrderByAndInequalityMatch(inequalityField, orderBy.field);
	            }
	        }
	    };
	    Query.prototype.validateOrderByAndInequalityMatch = function (inequality, orderBy) {
	        if (!orderBy.equals(inequality)) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Invalid query. You have a where filter with an inequality " +
	                ("(<, <=, >, or >=) on field '" + inequality.toString() + "' ") +
	                ("and so you must also use '" + inequality.toString() + "' ") +
	                "as your first Query.orderBy(), but your first Query.orderBy() " +
	                ("is on field '" + orderBy.toString() + "' instead."));
	        }
	    };
	    return Query;
	}());
	exports.Query = Query;
	var QuerySnapshot = /** @class */ (function () {
	    function QuerySnapshot(_firestore, _originalQuery, _snapshot) {
	        this._firestore = _firestore;
	        this._originalQuery = _originalQuery;
	        this._snapshot = _snapshot;
	        this._cachedChanges = null;
	        this.metadata = {
	            fromCache: _snapshot.fromCache,
	            hasPendingWrites: _snapshot.hasPendingWrites
	        };
	    }
	    Object.defineProperty(QuerySnapshot.prototype, "docs", {
	        get: function () {
	            var result = [];
	            this.forEach(function (doc) { return result.push(doc); });
	            return result;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(QuerySnapshot.prototype, "empty", {
	        get: function () {
	            return this._snapshot.docs.isEmpty();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(QuerySnapshot.prototype, "size", {
	        get: function () {
	            return this._snapshot.docs.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    QuerySnapshot.prototype.forEach = function (callback, thisArg) {
	        var _this = this;
	        input_validation_1.validateBetweenNumberOfArgs('QuerySnapshot.forEach', arguments, 1, 2);
	        input_validation_1.validateArgType('QuerySnapshot.forEach', 'function', 1, callback);
	        this._snapshot.docs.forEach(function (doc) {
	            callback.call(thisArg, _this.convertToDocumentImpl(doc));
	        });
	    };
	    Object.defineProperty(QuerySnapshot.prototype, "query", {
	        get: function () {
	            return new Query(this._originalQuery, this._firestore);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(QuerySnapshot.prototype, "docChanges", {
	        get: function () {
	            if (!this._cachedChanges) {
	                this._cachedChanges = changesFromSnapshot(this._firestore, this._snapshot);
	            }
	            return this._cachedChanges;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    QuerySnapshot.prototype.convertToDocumentImpl = function (doc) {
	        return new DocumentSnapshot(this._firestore, doc.key, doc, this.metadata.fromCache);
	    };
	    return QuerySnapshot;
	}());
	exports.QuerySnapshot = QuerySnapshot;
	var CollectionReference = /** @class */ (function (_super) {
	    __extends(CollectionReference, _super);
	    function CollectionReference(path, firestore) {
	        var _this = _super.call(this, query_1.Query.atPath(path), firestore) || this;
	        if (path.length % 2 !== 1) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Invalid collection reference. Collection ' +
	                'references must have an odd number of segments, but ' +
	                (path.canonicalString() + " has " + path.length));
	        }
	        return _this;
	    }
	    Object.defineProperty(CollectionReference.prototype, "id", {
	        get: function () {
	            return this._query.path.lastSegment();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CollectionReference.prototype, "parent", {
	        get: function () {
	            var parentPath = this._query.path.popLast();
	            if (parentPath.isEmpty()) {
	                return null;
	            }
	            else {
	                return new DocumentReference(new document_key_1.DocumentKey(parentPath), this.firestore);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CollectionReference.prototype, "path", {
	        get: function () {
	            return this._query.path.canonicalString();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CollectionReference.prototype.doc = function (pathString) {
	        input_validation_1.validateBetweenNumberOfArgs('CollectionReference.doc', arguments, 0, 1);
	        // We allow omission of 'pathString' but explicitly prohibit passing in both
	        // 'undefined' and 'null'.
	        if (arguments.length === 0) {
	            pathString = misc_1.AutoId.newId();
	        }
	        input_validation_1.validateArgType('CollectionReference.doc', 'string', 1, pathString);
	        if (pathString === '') {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Document path must be a non-empty string');
	        }
	        var path = path_1.ResourcePath.fromString(pathString);
	        return DocumentReference.forPath(this._query.path.child(path), this.firestore);
	    };
	    CollectionReference.prototype.add = function (value) {
	        input_validation_1.validateExactNumberOfArgs('CollectionReference.add', arguments, 1);
	        input_validation_1.validateArgType('CollectionReference.add', 'object', 1, value);
	        var docRef = this.doc();
	        return docRef.set(value).then(function () { return docRef; });
	    };
	    return CollectionReference;
	}(Query));
	exports.CollectionReference = CollectionReference;
	function validateSetOptions(methodName, options) {
	    if (options === undefined) {
	        return {
	            merge: false
	        };
	    }
	    input_validation_1.validateOptionNames(methodName, options, ['merge']);
	    input_validation_1.validateNamedOptionalType(methodName, 'boolean', 'merge', options.merge);
	    return options;
	}
	function validateReference(methodName, documentRef, firestore) {
	    if (!(documentRef instanceof DocumentReference)) {
	        throw input_validation_1.invalidClassError(methodName, 'DocumentReference', 1, documentRef);
	    }
	    else if (documentRef.firestore !== firestore) {
	        throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, 'Provided document reference is from a different Firestore instance.');
	    }
	    else {
	        return documentRef;
	    }
	}
	/**
	 * Calculates the array of firestore.DocumentChange's for a given ViewSnapshot.
	 *
	 * Exported for testing.
	 */
	function changesFromSnapshot(firestore, snapshot) {
	    if (snapshot.oldDocs.isEmpty()) {
	        // Special case the first snapshot because index calculation is easy and
	        // fast
	        var lastDoc_1;
	        var index_1 = 0;
	        return snapshot.docChanges.map(function (change) {
	            var doc = new DocumentSnapshot(firestore, change.doc.key, change.doc, snapshot.fromCache);
	            assert_1.assert(change.type === view_snapshot_1.ChangeType.Added, 'Invalid event type for first snapshot');
	            assert_1.assert(!lastDoc_1 || snapshot.query.docComparator(lastDoc_1, change.doc) < 0, 'Got added events in wrong order');
	            lastDoc_1 = change.doc;
	            return {
	                type: 'added',
	                doc: doc,
	                oldIndex: -1,
	                newIndex: index_1++
	            };
	        });
	    }
	    else {
	        // A DocumentSet that is updated incrementally as changes are applied to use
	        // to lookup the index of a document.
	        var indexTracker_1 = snapshot.oldDocs;
	        return snapshot.docChanges.map(function (change) {
	            var doc = new DocumentSnapshot(firestore, change.doc.key, change.doc, snapshot.fromCache);
	            var oldIndex = -1;
	            var newIndex = -1;
	            if (change.type !== view_snapshot_1.ChangeType.Added) {
	                oldIndex = indexTracker_1.indexOf(change.doc.key);
	                assert_1.assert(oldIndex >= 0, 'Index for document not found');
	                indexTracker_1 = indexTracker_1.delete(change.doc.key);
	            }
	            if (change.type !== view_snapshot_1.ChangeType.Removed) {
	                indexTracker_1 = indexTracker_1.add(change.doc);
	                newIndex = indexTracker_1.indexOf(change.doc.key);
	            }
	            return { type: resultChangeType(change.type), doc: doc, oldIndex: oldIndex, newIndex: newIndex };
	        });
	    }
	}
	exports.changesFromSnapshot = changesFromSnapshot;
	function resultChangeType(type) {
	    switch (type) {
	        case view_snapshot_1.ChangeType.Added:
	            return 'added';
	        case view_snapshot_1.ChangeType.Modified:
	        case view_snapshot_1.ChangeType.Metadata:
	            return 'modified';
	        case view_snapshot_1.ChangeType.Removed:
	            return 'removed';
	        default:
	            return assert_1.fail('Unknown change type: ' + type);
	    }
	}
	// Export the classes with a private constructor (it will fail if invoked
	// at runtime). Note that this still allows instanceof checks.
	// We're treating the variables as class names, so disable checking for lower
	// case variable names.
	// tslint:disable:variable-name
	exports.PublicFirestore = api_1.makeConstructorPrivate(Firestore, 'Use firebase.firestore() instead.');
	exports.PublicTransaction = api_1.makeConstructorPrivate(Transaction, 'Use firebase.firestore().runTransaction() instead.');
	exports.PublicWriteBatch = api_1.makeConstructorPrivate(WriteBatch, 'Use firebase.firestore().batch() instead.');
	exports.PublicDocumentReference = api_1.makeConstructorPrivate(DocumentReference, 'Use firebase.firestore().doc() instead.');
	exports.PublicDocumentSnapshot = api_1.makeConstructorPrivate(DocumentSnapshot);
	exports.PublicQuery = api_1.makeConstructorPrivate(Query);
	exports.PublicQuerySnapshot = api_1.makeConstructorPrivate(QuerySnapshot);
	exports.PublicCollectionReference = api_1.makeConstructorPrivate(CollectionReference, 'Use firebase.firestore().collection() instead.');
	// tslint:enable:variable-name
	
	//# sourceMappingURL=database.js.map


/***/ },
/* 456 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	function isPartialObserver(obj) {
	    return implementsAnyMethods(obj, ['next', 'error', 'complete']);
	}
	exports.isPartialObserver = isPartialObserver;
	/**
	 * Returns true if obj is an object and contains at least one of the specified
	 * methods.
	 */
	function implementsAnyMethods(obj, methods) {
	    if (typeof obj !== 'object' || obj === null) {
	        return false;
	    }
	    var object = obj;
	    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
	        var method = methods_1[_i];
	        if (method in object && typeof object[method] === 'function') {
	            return true;
	        }
	    }
	    return false;
	}
	
	//# sourceMappingURL=observer.js.map


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var timestamp_1 = __webpack_require__(55);
	var field_value_1 = __webpack_require__(57);
	var field_value_2 = __webpack_require__(57);
	var mutation_1 = __webpack_require__(96);
	var path_1 = __webpack_require__(49);
	var assert_1 = __webpack_require__(10);
	var error_1 = __webpack_require__(19);
	var input_validation_1 = __webpack_require__(72);
	var misc_1 = __webpack_require__(25);
	var objUtils = __webpack_require__(36);
	var sorted_map_1 = __webpack_require__(50);
	var typeUtils = __webpack_require__(73);
	var blob_1 = __webpack_require__(121);
	var field_path_1 = __webpack_require__(122);
	var field_value_3 = __webpack_require__(189);
	var geo_point_1 = __webpack_require__(123);
	var RESERVED_FIELD_REGEX = /^__.*__$/;
	/** The result of parsing document data (e.g. for a setData call). */
	var ParsedSetData = /** @class */ (function () {
	    function ParsedSetData(data, fieldMask, fieldTransforms) {
	        this.data = data;
	        this.fieldMask = fieldMask;
	        this.fieldTransforms = fieldTransforms;
	    }
	    ParsedSetData.prototype.toMutations = function (key, precondition) {
	        var mutations = [];
	        if (this.fieldMask !== null) {
	            mutations.push(new mutation_1.PatchMutation(key, this.data, this.fieldMask, precondition));
	        }
	        else {
	            mutations.push(new mutation_1.SetMutation(key, this.data, precondition));
	        }
	        if (this.fieldTransforms.length > 0) {
	            mutations.push(new mutation_1.TransformMutation(key, this.fieldTransforms));
	        }
	        return mutations;
	    };
	    return ParsedSetData;
	}());
	exports.ParsedSetData = ParsedSetData;
	/** The result of parsing "update" data (i.e. for an updateData call). */
	var ParsedUpdateData = /** @class */ (function () {
	    function ParsedUpdateData(data, fieldMask, fieldTransforms) {
	        this.data = data;
	        this.fieldMask = fieldMask;
	        this.fieldTransforms = fieldTransforms;
	    }
	    ParsedUpdateData.prototype.toMutations = function (key, precondition) {
	        var mutations = [
	            new mutation_1.PatchMutation(key, this.data, this.fieldMask, precondition)
	        ];
	        if (this.fieldTransforms.length > 0) {
	            mutations.push(new mutation_1.TransformMutation(key, this.fieldTransforms));
	        }
	        return mutations;
	    };
	    return ParsedUpdateData;
	}());
	exports.ParsedUpdateData = ParsedUpdateData;
	/*
	 * Represents what type of API method provided the data being parsed; useful
	 * for determining which error conditions apply during parsing and providing
	 * better error messages.
	 */
	var UserDataSource;
	(function (UserDataSource) {
	    UserDataSource[UserDataSource["Set"] = 0] = "Set";
	    UserDataSource[UserDataSource["Update"] = 1] = "Update";
	    UserDataSource[UserDataSource["MergeSet"] = 2] = "MergeSet";
	    UserDataSource[UserDataSource["QueryValue"] = 3] = "QueryValue"; // from a where clause or cursor bound
	})(UserDataSource || (UserDataSource = {}));
	function isWrite(dataSource) {
	    switch (dataSource) {
	        case UserDataSource.Set: // fall through
	        case UserDataSource.MergeSet: // fall through
	        case UserDataSource.Update:
	            return true;
	        case UserDataSource.QueryValue:
	            return false;
	        default:
	            throw assert_1.fail("Unexpected case for UserDataSource: " + dataSource);
	    }
	}
	/** A "context" object passed around while parsing user data. */
	var ParseContext = /** @class */ (function () {
	    /**
	     * Initializes a ParseContext with the given source and path.
	     *
	     * @param dataSource Indicates what kind of API method this data came from.
	     * @param methodName The name of the method the user called to create this
	     *     ParseContext.
	     * @param path A path within the object being parsed. This could be an empty
	     *     path (in which case the context represents the root of the data being
	     *     parsed), or a nonempty path (indicating the context represents a nested
	     *     location within the data).
	     * @param arrayElement Whether or not this context corresponds to an element
	     *     of an array.
	     * @param fieldTransforms A mutable list of field transforms encountered while
	     *     parsing the data.
	     * @param fieldMask A mutable list of field paths encountered while parsing
	     *     the data.
	     *
	     * TODO(b/34871131): We don't support array paths right now, so path can be
	     * null to indicate the context represents any location within an array (in
	     * which case certain features will not work and errors will be somewhat
	     * compromised).
	     */
	    function ParseContext(dataSource, methodName, path, arrayElement, fieldTransforms, fieldMask) {
	        this.dataSource = dataSource;
	        this.methodName = methodName;
	        this.path = path;
	        this.arrayElement = arrayElement;
	        // Minor hack: If fieldTransforms is undefined, we assume this is an
	        // external call and we need to validate the entire path.
	        if (fieldTransforms === undefined) {
	            this.validatePath();
	        }
	        this.arrayElement = arrayElement !== undefined ? arrayElement : false;
	        this.fieldTransforms = fieldTransforms || [];
	        this.fieldMask = fieldMask || [];
	    }
	    ParseContext.prototype.childContextForField = function (field) {
	        var childPath = this.path == null ? null : this.path.child(field);
	        var context = new ParseContext(this.dataSource, this.methodName, childPath, 
	        /*arrayElement=*/ false, this.fieldTransforms, this.fieldMask);
	        context.validatePathSegment(field);
	        return context;
	    };
	    ParseContext.prototype.childContextForFieldPath = function (field) {
	        var childPath = this.path == null ? null : this.path.child(field);
	        var context = new ParseContext(this.dataSource, this.methodName, childPath, 
	        /*arrayElement=*/ false, this.fieldTransforms, this.fieldMask);
	        context.validatePath();
	        return context;
	    };
	    ParseContext.prototype.childContextForArray = function (index) {
	        // TODO(b/34871131): We don't support array paths right now; so make path
	        // null.
	        return new ParseContext(this.dataSource, this.methodName, 
	        /*path=*/ null, 
	        /*arrayElement=*/ true, this.fieldTransforms, this.fieldMask);
	    };
	    ParseContext.prototype.createError = function (reason) {
	        var fieldDescription = this.path === null || this.path.isEmpty()
	            ? ''
	            : " (found in field " + this.path.toString() + ")";
	        return new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function " + this.methodName + "() called with invalid data. " +
	            reason +
	            fieldDescription);
	    };
	    ParseContext.prototype.validatePath = function () {
	        // TODO(b/34871131): Remove null check once we have proper paths for fields
	        // within arrays.
	        if (this.path === null) {
	            return;
	        }
	        for (var i = 0; i < this.path.length; i++) {
	            this.validatePathSegment(this.path.get(i));
	        }
	    };
	    ParseContext.prototype.validatePathSegment = function (segment) {
	        if (isWrite(this.dataSource) && RESERVED_FIELD_REGEX.test(segment)) {
	            throw this.createError('Document fields cannot begin and end with __');
	        }
	    };
	    ParseContext.prototype.isWrite = function () {
	        return (this.dataSource === UserDataSource.Set ||
	            this.dataSource === UserDataSource.Update);
	    };
	    return ParseContext;
	}());
	/**
	 * A placeholder object for DocumentReferences in this file, in order to
	 * avoid a circular dependency. See the comments for `DataPreConverter` for
	 * the full context.
	 */
	var DocumentKeyReference = /** @class */ (function () {
	    function DocumentKeyReference(databaseId, key) {
	        this.databaseId = databaseId;
	        this.key = key;
	    }
	    return DocumentKeyReference;
	}());
	exports.DocumentKeyReference = DocumentKeyReference;
	/**
	 * Helper for parsing raw user input (provided via the API) into internal model
	 * classes.
	 */
	var UserDataConverter = /** @class */ (function () {
	    function UserDataConverter(preConverter) {
	        this.preConverter = preConverter;
	    }
	    /** Parse document data from a non-merge set() call.*/
	    UserDataConverter.prototype.parseSetData = function (methodName, input) {
	        var context = new ParseContext(UserDataSource.Set, methodName, path_1.FieldPath.EMPTY_PATH);
	        validatePlainObject('Data must be an object, but it was:', context, input);
	        var updateData = this.parseData(input, context);
	        return new ParsedSetData(updateData, 
	        /* fieldMask= */ null, context.fieldTransforms);
	    };
	    /** Parse document data from a set() call with '{merge:true}'. */
	    UserDataConverter.prototype.parseMergeData = function (methodName, input) {
	        var context = new ParseContext(UserDataSource.MergeSet, methodName, path_1.FieldPath.EMPTY_PATH);
	        validatePlainObject('Data must be an object, but it was:', context, input);
	        var updateData = this.parseData(input, context);
	        var fieldMask = new mutation_1.FieldMask(context.fieldMask);
	        return new ParsedSetData(updateData, fieldMask, context.fieldTransforms);
	    };
	    /** Parse update data from an update() call. */
	    UserDataConverter.prototype.parseUpdateData = function (methodName, input) {
	        var _this = this;
	        var context = new ParseContext(UserDataSource.Update, methodName, path_1.FieldPath.EMPTY_PATH);
	        validatePlainObject('Data must be an object, but it was:', context, input);
	        var fieldMaskPaths = [];
	        var updateData = field_value_1.ObjectValue.EMPTY;
	        objUtils.forEach(input, function (key, value) {
	            var path = fieldPathFromDotSeparatedString(methodName, key);
	            var childContext = context.childContextForFieldPath(path);
	            value = _this.runPreConverter(value, childContext);
	            if (value instanceof field_value_3.DeleteFieldValueImpl) {
	                // Add it to the field mask, but don't add anything to updateData.
	                fieldMaskPaths.push(path);
	            }
	            else {
	                var parsedValue = _this.parseData(value, childContext);
	                if (parsedValue != null) {
	                    fieldMaskPaths.push(path);
	                    updateData = updateData.set(path, parsedValue);
	                }
	            }
	        });
	        var mask = new mutation_1.FieldMask(fieldMaskPaths);
	        return new ParsedUpdateData(updateData, mask, context.fieldTransforms);
	    };
	    /** Parse update data from a list of field/value arguments. */
	    UserDataConverter.prototype.parseUpdateVarargs = function (methodName, field, value, moreFieldsAndValues) {
	        var context = new ParseContext(UserDataSource.Update, methodName, path_1.FieldPath.EMPTY_PATH);
	        var keys = [fieldPathFromArgument(methodName, field)];
	        var values = [value];
	        if (moreFieldsAndValues.length % 2 !== 0) {
	            throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function " + methodName + "() needs to be called with an even number " +
	                'of arguments that alternate between field names and values.');
	        }
	        for (var i = 0; i < moreFieldsAndValues.length; i += 2) {
	            keys.push(fieldPathFromArgument(methodName, moreFieldsAndValues[i]));
	            values.push(moreFieldsAndValues[i + 1]);
	        }
	        var fieldMaskPaths = [];
	        var updateData = field_value_1.ObjectValue.EMPTY;
	        for (var i = 0; i < keys.length; ++i) {
	            var path = keys[i];
	            var childContext = context.childContextForFieldPath(path);
	            var value_1 = this.runPreConverter(values[i], childContext);
	            if (value_1 instanceof field_value_3.DeleteFieldValueImpl) {
	                // Add it to the field mask, but don't add anything to updateData.
	                fieldMaskPaths.push(path);
	            }
	            else {
	                var parsedValue = this.parseData(value_1, childContext);
	                if (parsedValue != null) {
	                    fieldMaskPaths.push(path);
	                    updateData = updateData.set(path, parsedValue);
	                }
	            }
	        }
	        var mask = new mutation_1.FieldMask(fieldMaskPaths);
	        return new ParsedUpdateData(updateData, mask, context.fieldTransforms);
	    };
	    /**
	     * Parse a "query value" (e.g. value in a where filter or a value in a cursor
	     * bound).
	     */
	    UserDataConverter.prototype.parseQueryValue = function (methodName, input) {
	        var context = new ParseContext(UserDataSource.QueryValue, methodName, path_1.FieldPath.EMPTY_PATH);
	        var parsed = this.parseData(input, context);
	        assert_1.assert(parsed != null, 'Parsed data should not be null.');
	        assert_1.assert(context.fieldTransforms.length === 0, 'Field transforms should have been disallowed.');
	        return parsed;
	    };
	    /** Sends data through this.preConverter, handling any thrown errors. */
	    UserDataConverter.prototype.runPreConverter = function (input, context) {
	        try {
	            return this.preConverter(input);
	        }
	        catch (e) {
	            var message = errorMessage(e);
	            throw context.createError(message);
	        }
	    };
	    /**
	     * Internal helper for parsing user data.
	     *
	     * @param input Data to be parsed.
	     * @param context A context object representing the current path being parsed,
	     * the source of the data being parsed, etc.
	     * @return The parsed value, or null if the value was a FieldValue sentinel
	     * that should not be included in the resulting parsed data.
	     */
	    UserDataConverter.prototype.parseData = function (input, context) {
	        input = this.runPreConverter(input, context);
	        if (input instanceof Array) {
	            // TODO(b/34871131): Include the path containing the array in the error
	            // message.
	            if (context.arrayElement) {
	                throw context.createError('Nested arrays are not supported');
	            }
	            // If context.path is null we are already inside an array and we don't
	            // support field mask paths more granular than the top-level array.
	            if (context.path) {
	                context.fieldMask.push(context.path);
	            }
	            return this.parseArray(input, context);
	        }
	        else if (looksLikeJsonObject(input)) {
	            validatePlainObject('Unsupported field value:', context, input);
	            return this.parseObject(input, context);
	        }
	        else {
	            // If context.path is null, we are inside an array and we should have
	            // already added the root of the array to the field mask.
	            if (context.path) {
	                context.fieldMask.push(context.path);
	            }
	            return this.parseScalarValue(input, context);
	        }
	    };
	    UserDataConverter.prototype.parseArray = function (array, context) {
	        var result = [];
	        var entryIndex = 0;
	        for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
	            var entry = array_1[_i];
	            var parsedEntry = this.parseData(entry, context.childContextForArray(entryIndex));
	            if (parsedEntry == null) {
	                // Just include nulls in the array for fields being replaced with a
	                // sentinel.
	                parsedEntry = field_value_2.NullValue.INSTANCE;
	            }
	            result.push(parsedEntry);
	            entryIndex++;
	        }
	        return new field_value_2.ArrayValue(result);
	    };
	    UserDataConverter.prototype.parseObject = function (obj, context) {
	        var _this = this;
	        var result = new sorted_map_1.SortedMap(misc_1.primitiveComparator);
	        objUtils.forEach(obj, function (key, val) {
	            var parsedValue = _this.parseData(val, context.childContextForField(key));
	            if (parsedValue != null) {
	                result = result.insert(key, parsedValue);
	            }
	        });
	        return new field_value_1.ObjectValue(result);
	    };
	    /**
	     * Helper to parse a scalar value (i.e. not an Object or Array)
	     *
	     * @return The parsed value, or null if the value was a FieldValue sentinel
	     * that should not be included in the resulting parsed data.
	     */
	    UserDataConverter.prototype.parseScalarValue = function (value, context) {
	        if (value === null) {
	            return field_value_2.NullValue.INSTANCE;
	        }
	        else if (typeof value === 'number') {
	            if (typeUtils.isSafeInteger(value)) {
	                return new field_value_2.IntegerValue(value);
	            }
	            else {
	                return new field_value_2.DoubleValue(value);
	            }
	        }
	        else if (typeof value === 'boolean') {
	            return field_value_2.BooleanValue.of(value);
	        }
	        else if (typeof value === 'string') {
	            return new field_value_2.StringValue(value);
	        }
	        else if (value instanceof Date) {
	            return new field_value_2.TimestampValue(timestamp_1.Timestamp.fromDate(value));
	        }
	        else if (value instanceof geo_point_1.GeoPoint) {
	            return new field_value_2.GeoPointValue(value);
	        }
	        else if (value instanceof blob_1.Blob) {
	            return new field_value_2.BlobValue(value);
	        }
	        else if (value instanceof DocumentKeyReference) {
	            return new field_value_2.RefValue(value.databaseId, value.key);
	        }
	        else if (value instanceof field_value_3.FieldValueImpl) {
	            if (value instanceof field_value_3.DeleteFieldValueImpl) {
	                if (context.dataSource == UserDataSource.MergeSet) {
	                    return null;
	                }
	                else if (context.dataSource === UserDataSource.Update) {
	                    assert_1.assert(context.path == null || context.path.length > 0, 'FieldValue.delete() at the top level should have already' +
	                        ' been handled.');
	                    throw context.createError('FieldValue.delete() can only appear at the top level ' +
	                        'of your update data');
	                }
	                else {
	                    // We shouldn't encounter delete sentinels for queries or non-merge set() calls.
	                    throw context.createError('FieldValue.delete() can only be used with update() and set() with {merge:true}');
	                }
	            }
	            else if (value instanceof field_value_3.ServerTimestampFieldValueImpl) {
	                if (!isWrite(context.dataSource)) {
	                    throw context.createError('FieldValue.serverTimestamp() can only be used with set()' +
	                        ' and update()');
	                }
	                if (context.path === null) {
	                    throw context.createError('FieldValue.serverTimestamp() is not currently' +
	                        ' supported inside arrays');
	                }
	                context.fieldTransforms.push(new mutation_1.FieldTransform(context.path, mutation_1.ServerTimestampTransform.instance));
	                // Return null so this value is omitted from the parsed result.
	                return null;
	            }
	            else {
	                return assert_1.fail('Unknown FieldValue type: ' + value);
	            }
	        }
	        else {
	            throw context.createError("Unsupported field value: " + input_validation_1.valueDescription(value));
	        }
	    };
	    return UserDataConverter;
	}());
	exports.UserDataConverter = UserDataConverter;
	/**
	 * Checks whether an object looks like a JSON object that should be converted
	 * into a struct. Normal class/prototype instances are considered to look like
	 * JSON objects since they should be converted to a struct value. Arrays, Dates,
	 * GeoPoints, etc. are not considered to look like JSON objects since they map
	 * to specific FieldValue types other than ObjectValue.
	 */
	function looksLikeJsonObject(input) {
	    return (typeof input === 'object' &&
	        input !== null &&
	        !(input instanceof Array) &&
	        !(input instanceof Date) &&
	        !(input instanceof geo_point_1.GeoPoint) &&
	        !(input instanceof blob_1.Blob) &&
	        !(input instanceof DocumentKeyReference) &&
	        !(input instanceof field_value_3.FieldValueImpl));
	}
	function validatePlainObject(message, context, input) {
	    if (!looksLikeJsonObject(input) || !input_validation_1.isPlainObject(input)) {
	        var description = input_validation_1.valueDescription(input);
	        if (description === 'an object') {
	            // Massage the error if it was an object.
	            throw context.createError(message + ' a custom object');
	        }
	        else {
	            throw context.createError(message + ' ' + description);
	        }
	    }
	}
	/**
	 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
	 */
	function fieldPathFromArgument(methodName, path) {
	    if (path instanceof field_path_1.FieldPath) {
	        return path._internalPath;
	    }
	    else if (typeof path === 'string') {
	        return fieldPathFromDotSeparatedString(methodName, path);
	    }
	    else {
	        var message = 'Field path arguments must be of type string or FieldPath.';
	        throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function " + methodName + "() called with invalid data. " + message);
	    }
	}
	exports.fieldPathFromArgument = fieldPathFromArgument;
	/**
	 * Wraps fromDotSeparatedString with an error message about the method that
	 * was thrown.
	 * @param methodName The publicly visible method name
	 * @param path The dot-separated string form of a field path which will be split
	 * on dots.
	 */
	function fieldPathFromDotSeparatedString(methodName, path) {
	    try {
	        return field_path_1.fromDotSeparatedString(path)._internalPath;
	    }
	    catch (e) {
	        var message = errorMessage(e);
	        throw new error_1.FirestoreError(error_1.Code.INVALID_ARGUMENT, "Function " + methodName + "() called with invalid data. " + message);
	    }
	}
	/**
	 * Extracts the message from a caught exception, which should be an Error object
	 * though JS doesn't guarantee that.
	 */
	function errorMessage(error) {
	    return error instanceof Error ? error.message : error.toString();
	}
	
	//# sourceMappingURL=user_data_converter.js.map


/***/ },
/* 458 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Simple wrapper around a nullable UID. Mostly exists to make code more
	 * readable.
	 */
	var User = /** @class */ (function () {
	    function User(uid) {
	        this.uid = uid;
	    }
	    User.prototype.isUnauthenticated = function () {
	        return this.uid == null;
	    };
	    /**
	     * Returns a key representing this user, suitable for inclusion in a
	     * dictionary.
	     */
	    User.prototype.toKey = function () {
	        if (this.isUnauthenticated()) {
	            return 'anonymous-user';
	        }
	        else {
	            return 'uid:' + this.uid;
	        }
	    };
	    User.prototype.equals = function (otherUser) {
	        return otherUser.uid === this.uid;
	    };
	    /** A user with a null UID. */
	    User.UNAUTHENTICATED = new User(null);
	    // TODO(mikelehen): Look into getting a proper uid-equivalent for
	    // non-FirebaseAuth providers.
	    User.GOOGLE_CREDENTIALS = new User('google-credentials-uid');
	    User.FIRST_PARTY = new User('first-party-uid');
	    return User;
	}());
	exports.User = User;
	
	//# sourceMappingURL=user.js.map


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(192);
	var view_snapshot_1 = __webpack_require__(93);
	var document_set_1 = __webpack_require__(194);
	var assert_1 = __webpack_require__(10);
	var obj_map_1 = __webpack_require__(129);
	/**
	 * Holds the listeners and the last received ViewSnapshot for a query being
	 * tracked by EventManager.
	 */
	var QueryListenersInfo = /** @class */ (function () {
	    function QueryListenersInfo() {
	        this.listeners = [];
	    }
	    return QueryListenersInfo;
	}());
	/**
	 * EventManager is responsible for mapping queries to query event emitters.
	 * It handles "fan-out". -- Identical queries will re-use the same watch on the
	 * backend.
	 */
	var EventManager = /** @class */ (function () {
	    function EventManager(syncEngine) {
	        this.syncEngine = syncEngine;
	        this.queries = new obj_map_1.ObjectMap(function (q) {
	            return q.canonicalId();
	        });
	        this.onlineState = types_1.OnlineState.Unknown;
	        this.syncEngine.subscribe(this.onChange.bind(this), this.onError.bind(this));
	    }
	    EventManager.prototype.listen = function (listener) {
	        var query = listener.query;
	        var firstListen = false;
	        var queryInfo = this.queries.get(query);
	        if (!queryInfo) {
	            firstListen = true;
	            queryInfo = new QueryListenersInfo();
	            this.queries.set(query, queryInfo);
	        }
	        queryInfo.listeners.push(listener);
	        listener.onOnlineStateChanged(this.onlineState);
	        if (queryInfo.viewSnap)
	            listener.onViewSnapshot(queryInfo.viewSnap);
	        if (firstListen) {
	            return this.syncEngine.listen(query).then(function (targetId) {
	                queryInfo.targetId = targetId;
	                return targetId;
	            });
	        }
	        else {
	            return Promise.resolve(queryInfo.targetId);
	        }
	    };
	    EventManager.prototype.unlisten = function (listener) {
	        var query = listener.query;
	        var lastListen = false;
	        var queryInfo = this.queries.get(query);
	        if (queryInfo) {
	            var i = queryInfo.listeners.indexOf(listener);
	            if (i >= 0) {
	                queryInfo.listeners.splice(i, 1);
	                lastListen = queryInfo.listeners.length === 0;
	            }
	        }
	        if (lastListen) {
	            this.queries.delete(query);
	            return this.syncEngine.unlisten(query);
	        }
	        else {
	            return Promise.resolve();
	        }
	    };
	    EventManager.prototype.onChange = function (viewSnaps) {
	        for (var _i = 0, viewSnaps_1 = viewSnaps; _i < viewSnaps_1.length; _i++) {
	            var viewSnap = viewSnaps_1[_i];
	            var query = viewSnap.query;
	            var queryInfo = this.queries.get(query);
	            if (queryInfo) {
	                for (var _a = 0, _b = queryInfo.listeners; _a < _b.length; _a++) {
	                    var listener = _b[_a];
	                    listener.onViewSnapshot(viewSnap);
	                }
	                queryInfo.viewSnap = viewSnap;
	            }
	        }
	    };
	    EventManager.prototype.onError = function (query, error) {
	        var queryInfo = this.queries.get(query);
	        if (queryInfo) {
	            for (var _i = 0, _a = queryInfo.listeners; _i < _a.length; _i++) {
	                var listener = _a[_i];
	                listener.onError(error);
	            }
	        }
	        // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
	        // after an error.
	        this.queries.delete(query);
	    };
	    EventManager.prototype.onOnlineStateChanged = function (onlineState) {
	        this.onlineState = onlineState;
	        this.queries.forEach(function (_, queryInfo) {
	            for (var _i = 0, _a = queryInfo.listeners; _i < _a.length; _i++) {
	                var listener = _a[_i];
	                listener.onOnlineStateChanged(onlineState);
	            }
	        });
	    };
	    return EventManager;
	}());
	exports.EventManager = EventManager;
	/**
	 * QueryListener takes a series of internal view snapshots and determines
	 * when to raise the event.
	 *
	 * It uses an Observer to dispatch events.
	 */
	var QueryListener = /** @class */ (function () {
	    function QueryListener(query, queryObserver, options) {
	        this.query = query;
	        this.queryObserver = queryObserver;
	        /**
	         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
	         * observer. This flag is set to true once we've actually raised an event.
	         */
	        this.raisedInitialEvent = false;
	        this.onlineState = types_1.OnlineState.Unknown;
	        this.options = options || {};
	    }
	    QueryListener.prototype.onViewSnapshot = function (snap) {
	        assert_1.assert(snap.docChanges.length > 0 || snap.syncStateChanged, 'We got a new snapshot with no changes?');
	        if (!this.options.includeDocumentMetadataChanges) {
	            // Remove the metadata only changes.
	            var docChanges = [];
	            for (var _i = 0, _a = snap.docChanges; _i < _a.length; _i++) {
	                var docChange = _a[_i];
	                if (docChange.type !== view_snapshot_1.ChangeType.Metadata) {
	                    docChanges.push(docChange);
	                }
	            }
	            snap = {
	                query: snap.query,
	                docs: snap.docs,
	                oldDocs: snap.oldDocs,
	                docChanges: docChanges,
	                fromCache: snap.fromCache,
	                hasPendingWrites: snap.hasPendingWrites,
	                syncStateChanged: snap.syncStateChanged
	            };
	        }
	        if (!this.raisedInitialEvent) {
	            if (this.shouldRaiseInitialEvent(snap, this.onlineState)) {
	                this.raiseInitialEvent(snap);
	            }
	        }
	        else if (this.shouldRaiseEvent(snap)) {
	            this.queryObserver.next(snap);
	        }
	        this.snap = snap;
	    };
	    QueryListener.prototype.onError = function (error) {
	        this.queryObserver.error(error);
	    };
	    QueryListener.prototype.onOnlineStateChanged = function (onlineState) {
	        this.onlineState = onlineState;
	        if (this.snap &&
	            !this.raisedInitialEvent &&
	            this.shouldRaiseInitialEvent(this.snap, onlineState)) {
	            this.raiseInitialEvent(this.snap);
	        }
	    };
	    QueryListener.prototype.shouldRaiseInitialEvent = function (snap, onlineState) {
	        assert_1.assert(!this.raisedInitialEvent, 'Determining whether to raise first event but already had first event');
	        // Always raise the first event when we're synced
	        if (!snap.fromCache) {
	            return true;
	        }
	        // NOTE: We consider OnlineState.Unknown as online (it should become Failed
	        // or Online if we wait long enough).
	        var maybeOnline = onlineState !== types_1.OnlineState.Failed;
	        // Don't raise the event if we're online, aren't synced yet (checked
	        // above) and are waiting for a sync.
	        if (this.options.waitForSyncWhenOnline && maybeOnline) {
	            assert_1.assert(snap.fromCache, 'Waiting for sync, but snapshot is not from cache');
	            return false;
	        }
	        // Raise data from cache if we have any documents or we are offline
	        return !snap.docs.isEmpty() || onlineState === types_1.OnlineState.Failed;
	    };
	    QueryListener.prototype.shouldRaiseEvent = function (snap) {
	        // We don't need to handle includeDocumentMetadataChanges here because
	        // the Metadata only changes have already been stripped out if needed.
	        // At this point the only changes we will see are the ones we should
	        // propagate.
	        if (snap.docChanges.length > 0) {
	            return true;
	        }
	        var hasPendingWritesChanged = this.snap && this.snap.hasPendingWrites !== snap.hasPendingWrites;
	        if (snap.syncStateChanged || hasPendingWritesChanged) {
	            return this.options.includeQueryMetadataChanges === true;
	        }
	        // Generally we should have hit one of the cases above, but it's possible
	        // to get here if there were only metadata docChanges and they got
	        // stripped out.
	        return false;
	    };
	    QueryListener.prototype.raiseInitialEvent = function (snap) {
	        assert_1.assert(!this.raisedInitialEvent, 'Trying to raise initial events for second time');
	        snap = {
	            query: snap.query,
	            docs: snap.docs,
	            oldDocs: document_set_1.DocumentSet.emptySet(snap.docs),
	            docChanges: QueryListener.getInitialViewChanges(snap),
	            fromCache: snap.fromCache,
	            hasPendingWrites: snap.hasPendingWrites,
	            syncStateChanged: true
	        };
	        this.raisedInitialEvent = true;
	        this.queryObserver.next(snap);
	    };
	    /** Returns changes as if all documents in the snap were added. */
	    QueryListener.getInitialViewChanges = function (snap) {
	        var result = [];
	        snap.docs.forEach(function (doc) {
	            result.push({ type: view_snapshot_1.ChangeType.Added, doc: doc });
	        });
	        return result;
	    };
	    return QueryListener;
	}());
	exports.QueryListener = QueryListener;
	
	//# sourceMappingURL=event_manager.js.map


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var event_manager_1 = __webpack_require__(459);
	var sync_engine_1 = __webpack_require__(461);
	var eager_garbage_collector_1 = __webpack_require__(193);
	var indexeddb_persistence_1 = __webpack_require__(465);
	var local_store_1 = __webpack_require__(470);
	var memory_persistence_1 = __webpack_require__(473);
	var no_op_garbage_collector_1 = __webpack_require__(476);
	var datastore_1 = __webpack_require__(483);
	var remote_store_1 = __webpack_require__(486);
	var serializer_1 = __webpack_require__(195);
	var error_1 = __webpack_require__(19);
	var log_1 = __webpack_require__(24);
	var promise_1 = __webpack_require__(130);
	var LOG_TAG = 'FirestoreClient';
	/**
	 * FirestoreClient is a top-level class that constructs and owns all of the
	 * pieces of the client SDK architecture. It is responsible for creating the
	 * async queue that is shared by all of the other components in the system.
	 */
	var FirestoreClient = /** @class */ (function () {
	    function FirestoreClient(platform, databaseInfo, credentials, 
	        /**
	         * Asynchronous queue responsible for all of our internal processing. When
	         * we get incoming work from the user (via public API) or the network
	         * (incoming GRPC messages), we should always schedule onto this queue.
	         * This ensures all of our work is properly serialized (e.g. we don't
	         * start processing a new operation while the previous one is waiting for
	         * an async I/O to complete).
	         */
	        asyncQueue) {
	        this.platform = platform;
	        this.databaseInfo = databaseInfo;
	        this.credentials = credentials;
	        this.asyncQueue = asyncQueue;
	    }
	    /**
	     * Starts up the FirestoreClient, returning only whether or not enabling
	     * persistence succeeded.
	     *
	     * The intent here is to "do the right thing" as far as users are concerned.
	     * Namely, in cases where offline persistence is requested and possible,
	     * enable it, but otherwise fall back to persistence disabled. For the most
	     * part we expect this to succeed one way or the other so we don't expect our
	     * users to actually wait on the firestore.enablePersistence Promise since
	     * they generally won't care.
	     *
	     * Of course some users actually do care about whether or not persistence
	     * was successfully enabled, so the Promise returned from this method
	     * indicates this outcome.
	     *
	     * This presents a problem though: even before enablePersistence resolves or
	     * rejects, users may have made calls to e.g. firestore.collection() which
	     * means that the FirestoreClient in there will be available and will be
	     * enqueuing actions on the async queue.
	     *
	     * Meanwhile any failure of an operation on the async queue causes it to
	     * panic and reject any further work, on the premise that unhandled errors
	     * are fatal.
	     *
	     * Consequently the fallback is handled internally here in start, and if the
	     * fallback succeeds we signal success to the async queue even though the
	     * start() itself signals failure.
	     *
	     * @param usePersistence Whether or not to attempt to enable persistence.
	     * @returns A deferred result indicating the user-visible result of enabling
	     *     offline persistence. This method will reject this if IndexedDB fails to
	     *     start for any reason. If usePersistence is false this is
	     *     unconditionally resolved.
	     */
	    FirestoreClient.prototype.start = function (usePersistence) {
	        var _this = this;
	        // We defer our initialization until we get the current user from
	        // setUserChangeListener(). We block the async queue until we got the
	        // initial user and the initialization is completed. This will prevent
	        // any scheduled work from happening before initialization is completed.
	        //
	        // If initializationDone resolved then the FirestoreClient is in a usable
	        // state.
	        var initializationDone = new promise_1.Deferred();
	        // If usePersistence is true, certain classes of errors while starting are
	        // recoverable but only by falling back to persistence disabled.
	        //
	        // If there's an error in the first case but not in recovery we cannot
	        // reject the promise blocking the async queue because this will cause the
	        // async queue to panic.
	        var persistenceResult = new promise_1.Deferred();
	        var initialized = false;
	        this.credentials.setUserChangeListener(function (user) {
	            if (!initialized) {
	                initialized = true;
	                _this.initializePersistence(usePersistence, persistenceResult)
	                    .then(function () { return _this.initializeRest(user); })
	                    .then(initializationDone.resolve, initializationDone.reject);
	            }
	            else {
	                _this.asyncQueue.schedule(function () {
	                    return _this.handleUserChange(user);
	                });
	            }
	        });
	        // Block the async queue until initialization is done
	        this.asyncQueue.schedule(function () {
	            return initializationDone.promise;
	        });
	        // Return only the result of enabling persistence. Note that this does not
	        // need to await the completion of initializationDone because the result of
	        // this method should not reflect any other kind of failure to start.
	        return persistenceResult.promise;
	    };
	    /** Enables the network connection and requeues all pending operations. */
	    FirestoreClient.prototype.enableNetwork = function () {
	        var _this = this;
	        return this.asyncQueue.schedule(function () {
	            return _this.remoteStore.enableNetwork();
	        });
	    };
	    /**
	     * Initializes persistent storage, attempting to use IndexedDB if
	     * usePersistence is true or memory-only if false.
	     *
	     * If IndexedDB fails because it's already open in another tab or because the
	     * platform can't possibly support our implementation then this method rejects
	     * the persistenceResult and falls back on memory-only persistence.
	     *
	     * @param usePersistence indicates whether or not to use offline persistence
	     * @param persistenceResult A deferred result indicating the user-visible
	     *     result of enabling offline persistence. This method will reject this if
	     *     IndexedDB fails to start for any reason. If usePersistence is false
	     *     this is unconditionally resolved.
	     * @returns a Promise indicating whether or not initialization should
	     *     continue, i.e. that one of the persistence implementations actually
	     *     succeeded.
	     */
	    FirestoreClient.prototype.initializePersistence = function (usePersistence, persistenceResult) {
	        var _this = this;
	        if (usePersistence) {
	            return this.startIndexedDbPersistence()
	                .then(persistenceResult.resolve)
	                .catch(function (error) {
	                // Regardless of whether or not the retry succeeds, from an user
	                // perspective, offline persistence has failed.
	                persistenceResult.reject(error);
	                // An unknown failure on the first stage shuts everything down.
	                if (!_this.canFallback(error)) {
	                    return Promise.reject(error);
	                }
	                console.warn('Error enabling offline storage. Falling back to' +
	                    ' storage disabled: ' +
	                    error);
	                return _this.startMemoryPersistence();
	            });
	        }
	        else {
	            // When usePersistence == false, enabling offline persistence is defined
	            // to unconditionally succeed. This allows start() to have the same
	            // signature for both cases, despite the fact that the returned promise
	            // is only used in the enablePersistence call.
	            persistenceResult.resolve();
	            return this.startMemoryPersistence();
	        }
	    };
	    FirestoreClient.prototype.canFallback = function (error) {
	        return (error.code === error_1.Code.FAILED_PRECONDITION ||
	            error.code === error_1.Code.UNIMPLEMENTED);
	    };
	    /**
	     * Starts IndexedDB-based persistence.
	     *
	     * @returns A promise indicating success or failure.
	     */
	    FirestoreClient.prototype.startIndexedDbPersistence = function () {
	        // TODO(http://b/33384523): For now we just disable garbage collection
	        // when persistence is enabled.
	        this.garbageCollector = new no_op_garbage_collector_1.NoOpGarbageCollector();
	        var storagePrefix = indexeddb_persistence_1.IndexedDbPersistence.buildStoragePrefix(this.databaseInfo);
	        // Opt to use proto3 JSON in case the platform doesn't support Uint8Array.
	        var serializer = new serializer_1.JsonProtoSerializer(this.databaseInfo.databaseId, {
	            useProto3Json: true
	        });
	        this.persistence = new indexeddb_persistence_1.IndexedDbPersistence(storagePrefix, serializer);
	        return this.persistence.start();
	    };
	    /**
	     * Starts Memory-backed persistence. In practice this cannot fail.
	     *
	     * @returns A promise that will successfully resolve.
	     */
	    FirestoreClient.prototype.startMemoryPersistence = function () {
	        this.garbageCollector = new eager_garbage_collector_1.EagerGarbageCollector();
	        this.persistence = new memory_persistence_1.MemoryPersistence();
	        return this.persistence.start();
	    };
	    /**
	     * Initializes the rest of the FirestoreClient, assuming the initial user
	     * has been obtained from the credential provider and some persistence
	     * implementation is available in this.persistence.
	     */
	    FirestoreClient.prototype.initializeRest = function (user) {
	        var _this = this;
	        return this.platform
	            .loadConnection(this.databaseInfo)
	            .then(function (connection) {
	            _this.localStore = new local_store_1.LocalStore(_this.persistence, user, _this.garbageCollector);
	            var serializer = _this.platform.newSerializer(_this.databaseInfo.databaseId);
	            var datastore = new datastore_1.Datastore(_this.databaseInfo, _this.asyncQueue, connection, _this.credentials, serializer);
	            var onlineStateChangedHandler = function (onlineState) {
	                _this.eventMgr.onOnlineStateChanged(onlineState);
	            };
	            _this.remoteStore = new remote_store_1.RemoteStore(_this.databaseInfo, _this.asyncQueue, _this.localStore, datastore, onlineStateChangedHandler);
	            _this.syncEngine = new sync_engine_1.SyncEngine(_this.localStore, _this.remoteStore, user);
	            // Setup wiring between sync engine and remote store
	            _this.remoteStore.syncEngine = _this.syncEngine;
	            _this.eventMgr = new event_manager_1.EventManager(_this.syncEngine);
	            // NOTE: RemoteStore depends on LocalStore (for persisting stream
	            // tokens, refilling mutation queue, etc.) so must be started after
	            // LocalStore.
	            return _this.localStore.start();
	        })
	            .then(function () {
	            return _this.remoteStore.start();
	        });
	    };
	    FirestoreClient.prototype.handleUserChange = function (user) {
	        this.asyncQueue.verifyOperationInProgress();
	        log_1.debug(LOG_TAG, 'User Changed: ' + user.uid);
	        return this.syncEngine.handleUserChange(user);
	    };
	    /** Disables the network connection. Pending operations will not complete. */
	    FirestoreClient.prototype.disableNetwork = function () {
	        var _this = this;
	        return this.asyncQueue.schedule(function () {
	            return _this.remoteStore.disableNetwork();
	        });
	    };
	    FirestoreClient.prototype.shutdown = function () {
	        var _this = this;
	        return this.asyncQueue
	            .schedule(function () {
	            _this.credentials.removeUserChangeListener();
	            return _this.remoteStore.shutdown();
	        })
	            .then(function () {
	            // PORTING NOTE: LocalStore does not need an explicit shutdown on web.
	            return _this.persistence.shutdown();
	        });
	    };
	    FirestoreClient.prototype.listen = function (query, observer, options) {
	        var _this = this;
	        var listener = new event_manager_1.QueryListener(query, observer, options);
	        this.asyncQueue.schedule(function () {
	            return _this.eventMgr.listen(listener);
	        });
	        return listener;
	    };
	    FirestoreClient.prototype.unlisten = function (listener) {
	        var _this = this;
	        this.asyncQueue.schedule(function () {
	            return _this.eventMgr.unlisten(listener);
	        });
	    };
	    FirestoreClient.prototype.write = function (mutations) {
	        var _this = this;
	        var deferred = new promise_1.Deferred();
	        this.asyncQueue.schedule(function () { return _this.syncEngine.write(mutations, deferred); });
	        return deferred.promise;
	    };
	    FirestoreClient.prototype.databaseId = function () {
	        return this.databaseInfo.databaseId;
	    };
	    FirestoreClient.prototype.transaction = function (updateFunction) {
	        var _this = this;
	        // We have to wait for the async queue to be sure syncEngine is initialized.
	        return this.asyncQueue
	            .schedule(function () {
	            return Promise.resolve();
	        })
	            .then(function () {
	            return _this.syncEngine.runTransaction(updateFunction);
	        });
	    };
	    return FirestoreClient;
	}());
	exports.FirestoreClient = FirestoreClient;
	
	//# sourceMappingURL=firestore_client.js.map


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var eager_garbage_collector_1 = __webpack_require__(193);
	var local_view_changes_1 = __webpack_require__(471);
	var query_data_1 = __webpack_require__(69);
	var reference_set_1 = __webpack_require__(94);
	var document_1 = __webpack_require__(32);
	var document_key_1 = __webpack_require__(22);
	var remote_event_1 = __webpack_require__(71);
	var assert_1 = __webpack_require__(10);
	var log = __webpack_require__(24);
	var misc_1 = __webpack_require__(25);
	var objUtils = __webpack_require__(36);
	var obj_map_1 = __webpack_require__(129);
	var sorted_map_1 = __webpack_require__(50);
	var types_1 = __webpack_require__(73);
	var query_1 = __webpack_require__(124);
	var snapshot_version_1 = __webpack_require__(31);
	var target_id_generator_1 = __webpack_require__(191);
	var view_1 = __webpack_require__(463);
	var LOG_TAG = 'SyncEngine';
	/**
	 * QueryView contains all of the data that SyncEngine needs to keep track of for
	 * a particular query.
	 */
	var QueryView = /** @class */ (function () {
	    function QueryView(
	        /**
	         * The query itself.
	         */
	        query, 
	        /**
	         * The target number created by the client that is used in the watch
	         * stream to identify this query.
	         */
	        targetId, 
	        /**
	         * An identifier from the datastore backend that indicates the last state
	         * of the results that was received. This can be used to indicate where
	         * to continue receiving new doc changes for the query.
	         */
	        resumeToken, 
	        /**
	         * The view is responsible for computing the final merged truth of what
	         * docs are in the query. It gets notified of local and remote changes,
	         * and applies the query filters and limits to determine the most correct
	         * possible results.
	         */
	        view) {
	        this.query = query;
	        this.targetId = targetId;
	        this.resumeToken = resumeToken;
	        this.view = view;
	    }
	    return QueryView;
	}());
	/**
	 * SyncEngine is the central controller in the client SDK architecture. It is
	 * the glue code between the EventManager, LocalStore, and RemoteStore. Some of
	 * SyncEngine's responsibilities include:
	 * 1. Coordinating client requests and remote events between the EventManager
	 *    and the local and remote data stores.
	 * 2. Managing a View object for each query, providing the unified view between
	 *    the local and remote data stores.
	 * 3. Notifying the RemoteStore when the LocalStore has new mutations in its
	 *    queue that need sending to the backend.
	 *
	 * The SyncEngine’s methods should only ever be called by methods running in the
	 * global async queue.
	 */
	var SyncEngine = /** @class */ (function () {
	    function SyncEngine(localStore, remoteStore, currentUser) {
	        this.localStore = localStore;
	        this.remoteStore = remoteStore;
	        this.currentUser = currentUser;
	        this.viewHandler = null;
	        this.errorHandler = null;
	        this.queryViewsByQuery = new obj_map_1.ObjectMap(function (q) {
	            return q.canonicalId();
	        });
	        this.queryViewsByTarget = {};
	        this.limboTargetsByKey = new sorted_map_1.SortedMap(document_key_1.DocumentKey.comparator);
	        this.limboKeysByTarget = {};
	        this.limboDocumentRefs = new reference_set_1.ReferenceSet();
	        this.limboCollector = new eager_garbage_collector_1.EagerGarbageCollector();
	        /** Stores user completion handlers, indexed by User and BatchId. */
	        this.mutationUserCallbacks = {};
	        this.targetIdGenerator = target_id_generator_1.TargetIdGenerator.forSyncEngine();
	    }
	    /** Subscribes view and error handler. Can be called only once. */
	    SyncEngine.prototype.subscribe = function (viewHandler, errorHandler) {
	        assert_1.assert(viewHandler !== null && errorHandler !== null, 'View and error handlers cannot be null');
	        assert_1.assert(this.viewHandler === null && this.errorHandler === null, 'SyncEngine already has a subscriber.');
	        this.viewHandler = viewHandler;
	        this.errorHandler = errorHandler;
	        this.limboCollector.addGarbageSource(this.limboDocumentRefs);
	    };
	    /**
	     * Initiates the new listen, resolves promise when listen enqueued to the
	     * server. All the subsequent view snapshots or errors are sent to the
	     * subscribed handlers. Returns the targetId of the query.
	     */
	    SyncEngine.prototype.listen = function (query) {
	        var _this = this;
	        this.assertSubscribed('listen()');
	        assert_1.assert(!this.queryViewsByQuery.has(query), 'We already listen to the query: ' + query);
	        return this.localStore.allocateQuery(query).then(function (queryData) {
	            return _this.localStore
	                .executeQuery(query)
	                .then(function (docs) {
	                return _this.localStore
	                    .remoteDocumentKeys(queryData.targetId)
	                    .then(function (remoteKeys) {
	                    var view = new view_1.View(query, remoteKeys);
	                    var viewDocChanges = view.computeDocChanges(docs);
	                    var viewChange = view.applyChanges(viewDocChanges);
	                    assert_1.assert(viewChange.limboChanges.length === 0, 'View returned limbo docs before target ack from the server.');
	                    assert_1.assert(!!viewChange.snapshot, 'applyChanges for new view should always return a snapshot');
	                    var data = new QueryView(query, queryData.targetId, queryData.resumeToken, view);
	                    _this.queryViewsByQuery.set(query, data);
	                    _this.queryViewsByTarget[queryData.targetId] = data;
	                    _this.viewHandler([viewChange.snapshot]);
	                    _this.remoteStore.listen(queryData);
	                });
	            })
	                .then(function () {
	                return queryData.targetId;
	            });
	        });
	    };
	    /** Stops listening to the query. */
	    SyncEngine.prototype.unlisten = function (query) {
	        var _this = this;
	        this.assertSubscribed('unlisten()');
	        var queryView = this.queryViewsByQuery.get(query);
	        assert_1.assert(!!queryView, 'Trying to unlisten on query not found:' + query);
	        return this.localStore.releaseQuery(query).then(function () {
	            _this.remoteStore.unlisten(queryView.targetId);
	            return _this.removeAndCleanupQuery(queryView).then(function () {
	                return _this.localStore.collectGarbage();
	            });
	        });
	    };
	    /**
	     * Initiates the write of local mutation batch which involves adding the
	     * writes to the mutation queue, notifying the remote store about new
	     * mutations and raising events for any changes this write caused.
	     *
	     * The promise returned by this call is resolved when the above steps
	     * have completed, *not* when the write was acked by the backend. The
	     * userCallback is resolved once the write was acked/rejected by the
	     * backend (or failed locally for any other reason).
	     */
	    SyncEngine.prototype.write = function (batch, userCallback) {
	        var _this = this;
	        this.assertSubscribed('write()');
	        return this.localStore
	            .localWrite(batch)
	            .then(function (result) {
	            _this.addMutationCallback(result.batchId, userCallback);
	            return _this.emitNewSnapsAndNotifyLocalStore(result.changes);
	        })
	            .then(function () {
	            return _this.remoteStore.fillWritePipeline();
	        });
	    };
	    // TODO(klimt): Wrap the given error in a standard Firestore error object.
	    SyncEngine.prototype.wrapUpdateFunctionError = function (error) {
	        return error;
	    };
	    /**
	     * Takes an updateFunction in which a set of reads and writes can be performed
	     * atomically. In the updateFunction, the client can read and write values
	     * using the supplied transaction object. After the updateFunction, all
	     * changes will be committed. If some other client has changed any of the data
	     * referenced, then the updateFunction will be called again. If the
	     * updateFunction still fails after the given number of retries, then the
	     * transaction will be rejection.
	     *
	     * The transaction object passed to the updateFunction contains methods for
	     * accessing documents and collections. Unlike other datastore access, data
	     * accessed with the transaction will not reflect local changes that have not
	     * been committed. For this reason, it is required that all reads are
	     * performed before any writes. Transactions must be performed while online.
	     *
	     * The promise returned is resolved when the transaction is fully committed.
	     */
	    SyncEngine.prototype.runTransaction = function (updateFunction, retries) {
	        var _this = this;
	        if (retries === void 0) { retries = 5; }
	        assert_1.assert(retries >= 0, 'Got negative number of retries for transaction.');
	        var transaction = this.remoteStore.createTransaction();
	        var wrappedUpdateFunction = function () {
	            try {
	                var userPromise = updateFunction(transaction);
	                if (types_1.isNullOrUndefined(userPromise) ||
	                    !userPromise.catch ||
	                    !userPromise.then) {
	                    return Promise.reject(Error('Transaction callback must return a Promise'));
	                }
	                return userPromise.catch(function (e) {
	                    return Promise.reject(_this.wrapUpdateFunctionError(e));
	                });
	            }
	            catch (e) {
	                return Promise.reject(_this.wrapUpdateFunctionError(e));
	            }
	        };
	        return wrappedUpdateFunction().then(function (result) {
	            return transaction
	                .commit()
	                .then(function () {
	                return result;
	            })
	                .catch(function (error) {
	                if (retries === 0) {
	                    return Promise.reject(error);
	                }
	                // TODO(klimt): Put in a retry delay?
	                return _this.runTransaction(updateFunction, retries - 1);
	            });
	        });
	    };
	    SyncEngine.prototype.applyRemoteEvent = function (remoteEvent) {
	        var _this = this;
	        this.assertSubscribed('applyRemoteEvent()');
	        // Make sure limbo documents are deleted if there were no results
	        objUtils.forEachNumber(remoteEvent.targetChanges, function (targetId, targetChange) {
	            var limboKey = _this.limboKeysByTarget[targetId];
	            if (limboKey &&
	                targetChange.currentStatusUpdate ===
	                    remote_event_1.CurrentStatusUpdate.MarkCurrent &&
	                !remoteEvent.documentUpdates.get(limboKey)) {
	                // When listening to a query the server responds with a snapshot
	                // containing documents matching the query and a current marker
	                // telling us we're now in sync. It's possible for these to arrive
	                // as separate remote events or as a single remote event.
	                // For a document query, there will be no documents sent in the
	                // response if the document doesn't exist.
	                //
	                // If the snapshot arrives separately from the current marker,
	                // we handle it normally and updateTrackedLimbos will resolve the
	                // limbo status of the document, removing it from limboDocumentRefs.
	                // This works because clients only initiate limbo resolution when
	                // a target is current and because all current targets are
	                // always at a consistent snapshot.
	                //
	                // However, if the document doesn't exist and the current marker
	                // arrives, the document is not present in the snapshot and our
	                // normal view handling would consider the document to remain in
	                // limbo indefinitely because there are no updates to the document.
	                // To avoid this, we specially handle this just this case here:
	                // synthesizing a delete.
	                //
	                // TODO(dimond): Ideally we would have an explicit lookup query
	                // instead resulting in an explicit delete message and we could
	                // remove this special logic.
	                remoteEvent.addDocumentUpdate(new document_1.NoDocument(limboKey, remoteEvent.snapshotVersion));
	            }
	        });
	        return this.localStore.applyRemoteEvent(remoteEvent).then(function (changes) {
	            return _this.emitNewSnapsAndNotifyLocalStore(changes, remoteEvent);
	        });
	    };
	    SyncEngine.prototype.rejectListen = function (targetId, err) {
	        var _this = this;
	        this.assertSubscribed('rejectListens()');
	        var limboKey = this.limboKeysByTarget[targetId];
	        if (limboKey) {
	            // Since this query failed, we won't want to manually unlisten to it.
	            // So go ahead and remove it from bookkeeping.
	            this.limboTargetsByKey = this.limboTargetsByKey.remove(limboKey);
	            delete this.limboKeysByTarget[targetId];
	            // TODO(klimt): We really only should do the following on permission
	            // denied errors, but we don't have the cause code here.
	            // It's a limbo doc. Create a synthetic event saying it was deleted.
	            // This is kind of a hack. Ideally, we would have a method in the local
	            // store to purge a document. However, it would be tricky to keep all of
	            // the local store's invariants with another method.
	            var docMap = new sorted_map_1.SortedMap(document_key_1.DocumentKey.comparator);
	            docMap = docMap.insert(limboKey, new document_1.NoDocument(limboKey, snapshot_version_1.SnapshotVersion.forDeletedDoc()));
	            var event_1 = new remote_event_1.RemoteEvent(snapshot_version_1.SnapshotVersion.MIN, {}, docMap);
	            return this.applyRemoteEvent(event_1);
	        }
	        else {
	            var queryView_1 = this.queryViewsByTarget[targetId];
	            assert_1.assert(!!queryView_1, 'Unknown targetId: ' + targetId);
	            return this.localStore.releaseQuery(queryView_1.query).then(function () {
	                return _this.removeAndCleanupQuery(queryView_1).then(function () {
	                    _this.errorHandler(queryView_1.query, err);
	                });
	            });
	        }
	    };
	    SyncEngine.prototype.applySuccessfulWrite = function (mutationBatchResult) {
	        var _this = this;
	        this.assertSubscribed('applySuccessfulWrite()');
	        // The local store may or may not be able to apply the write result and
	        // raise events immediately (depending on whether the watcher is caught
	        // up), so we raise user callbacks first so that they consistently happen
	        // before listen events.
	        this.processUserCallback(mutationBatchResult.batch.batchId, 
	        /*error=*/ null);
	        return this.localStore
	            .acknowledgeBatch(mutationBatchResult)
	            .then(function (changes) {
	            return _this.emitNewSnapsAndNotifyLocalStore(changes);
	        });
	    };
	    SyncEngine.prototype.rejectFailedWrite = function (batchId, error) {
	        var _this = this;
	        this.assertSubscribed('rejectFailedWrite()');
	        // The local store may or may not be able to apply the write result and
	        // raise events immediately (depending on whether the watcher is caught up),
	        // so we raise user callbacks first so that they consistently happen before
	        // listen events.
	        this.processUserCallback(batchId, error);
	        return this.localStore.rejectBatch(batchId).then(function (changes) {
	            return _this.emitNewSnapsAndNotifyLocalStore(changes);
	        });
	    };
	    SyncEngine.prototype.addMutationCallback = function (batchId, callback) {
	        var newCallbacks = this.mutationUserCallbacks[this.currentUser.toKey()];
	        if (!newCallbacks) {
	            newCallbacks = new sorted_map_1.SortedMap(misc_1.primitiveComparator);
	        }
	        newCallbacks = newCallbacks.insert(batchId, callback);
	        this.mutationUserCallbacks[this.currentUser.toKey()] = newCallbacks;
	    };
	    /**
	     * Resolves or rejects the user callback for the given batch and then discards
	     * it.
	     */
	    SyncEngine.prototype.processUserCallback = function (batchId, error) {
	        var newCallbacks = this.mutationUserCallbacks[this.currentUser.toKey()];
	        // NOTE: Mutations restored from persistence won't have callbacks, so it's
	        // okay for there to be no callback for this ID.
	        if (newCallbacks) {
	            var callback = newCallbacks.get(batchId);
	            if (callback) {
	                assert_1.assert(batchId === newCallbacks.minKey(), 'Mutation callbacks processed out-of-order?');
	                if (error) {
	                    callback.reject(error);
	                }
	                else {
	                    callback.resolve();
	                }
	                newCallbacks = newCallbacks.remove(batchId);
	            }
	            this.mutationUserCallbacks[this.currentUser.toKey()] = newCallbacks;
	        }
	    };
	    SyncEngine.prototype.removeAndCleanupQuery = function (queryView) {
	        this.queryViewsByQuery.delete(queryView.query);
	        delete this.queryViewsByTarget[queryView.targetId];
	        this.limboDocumentRefs.removeReferencesForId(queryView.targetId);
	        return this.gcLimboDocuments();
	    };
	    SyncEngine.prototype.updateTrackedLimbos = function (targetId, limboChanges) {
	        for (var _i = 0, limboChanges_1 = limboChanges; _i < limboChanges_1.length; _i++) {
	            var limboChange = limboChanges_1[_i];
	            if (limboChange instanceof view_1.AddedLimboDocument) {
	                this.limboDocumentRefs.addReference(limboChange.key, targetId);
	                this.trackLimboChange(limboChange);
	            }
	            else if (limboChange instanceof view_1.RemovedLimboDocument) {
	                log.debug(LOG_TAG, 'Document no longer in limbo: ' + limboChange.key);
	                this.limboDocumentRefs.removeReference(limboChange.key, targetId);
	            }
	            else {
	                assert_1.fail('Unknown limbo change: ' + JSON.stringify(limboChange));
	            }
	        }
	        return this.gcLimboDocuments();
	    };
	    SyncEngine.prototype.trackLimboChange = function (limboChange) {
	        var key = limboChange.key;
	        if (!this.limboTargetsByKey.get(key)) {
	            log.debug(LOG_TAG, 'New document in limbo: ' + key);
	            var limboTargetId = this.targetIdGenerator.next();
	            var query = query_1.Query.atPath(key.path);
	            this.limboKeysByTarget[limboTargetId] = key;
	            this.remoteStore.listen(new query_data_1.QueryData(query, limboTargetId, query_data_1.QueryPurpose.Listen));
	            this.limboTargetsByKey = this.limboTargetsByKey.insert(key, limboTargetId);
	        }
	    };
	    SyncEngine.prototype.gcLimboDocuments = function () {
	        var _this = this;
	        // HACK: We can use a null transaction here, because we know that the
	        // reference set is entirely within memory and doesn't need a store engine.
	        return this.limboCollector
	            .collectGarbage(null)
	            .next(function (keys) {
	            keys.forEach(function (key) {
	                var limboTargetId = _this.limboTargetsByKey.get(key);
	                if (limboTargetId === null) {
	                    // This target already got removed, because the query failed.
	                    return;
	                }
	                _this.remoteStore.unlisten(limboTargetId);
	                _this.limboTargetsByKey = _this.limboTargetsByKey.remove(key);
	                delete _this.limboKeysByTarget[limboTargetId];
	            });
	        })
	            .toPromise();
	    };
	    // Visible for testing
	    SyncEngine.prototype.currentLimboDocs = function () {
	        return this.limboTargetsByKey;
	    };
	    SyncEngine.prototype.emitNewSnapsAndNotifyLocalStore = function (changes, remoteEvent) {
	        var _this = this;
	        var newSnaps = [];
	        var docChangesInAllViews = [];
	        var queriesProcessed = [];
	        this.queryViewsByQuery.forEach(function (_, queryView) {
	            queriesProcessed.push(Promise.resolve()
	                .then(function () {
	                var viewDocChanges = queryView.view.computeDocChanges(changes);
	                if (!viewDocChanges.needsRefill) {
	                    return viewDocChanges;
	                }
	                // The query has a limit and some docs were removed, so we need
	                // to re-run the query against the local store to make sure we
	                // didn't lose any good docs that had been past the limit.
	                return _this.localStore.executeQuery(queryView.query).then(function (docs) {
	                    return queryView.view.computeDocChanges(docs, viewDocChanges);
	                });
	            })
	                .then(function (viewDocChanges) {
	                var targetChange = remoteEvent && remoteEvent.targetChanges[queryView.targetId];
	                var viewChange = queryView.view.applyChanges(viewDocChanges, targetChange);
	                return _this.updateTrackedLimbos(queryView.targetId, viewChange.limboChanges).then(function () {
	                    if (viewChange.snapshot) {
	                        newSnaps.push(viewChange.snapshot);
	                        var docChanges = local_view_changes_1.LocalViewChanges.fromSnapshot(viewChange.snapshot);
	                        docChangesInAllViews.push(docChanges);
	                    }
	                });
	            }));
	        });
	        return Promise.all(queriesProcessed)
	            .then(function () {
	            _this.viewHandler(newSnaps);
	            return _this.localStore.notifyLocalViewChanges(docChangesInAllViews);
	        })
	            .then(function () {
	            return _this.localStore.collectGarbage();
	        });
	    };
	    SyncEngine.prototype.assertSubscribed = function (fnName) {
	        assert_1.assert(this.viewHandler !== null && this.errorHandler !== null, 'Trying to call ' + fnName + ' before calling subscribe().');
	    };
	    SyncEngine.prototype.handleUserChange = function (user) {
	        var _this = this;
	        this.currentUser = user;
	        return this.localStore
	            .handleUserChange(user)
	            .then(function (changes) {
	            return _this.emitNewSnapsAndNotifyLocalStore(changes);
	        })
	            .then(function () {
	            return _this.remoteStore.handleUserChange(user);
	        });
	    };
	    return SyncEngine;
	}());
	exports.SyncEngine = SyncEngine;
	
	//# sourceMappingURL=sync_engine.js.map


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var snapshot_version_1 = __webpack_require__(31);
	var collections_1 = __webpack_require__(20);
	var document_1 = __webpack_require__(32);
	var mutation_1 = __webpack_require__(96);
	var error_1 = __webpack_require__(19);
	/**
	 * Internal transaction object responsible for accumulating the mutations to
	 * perform and the base versions for any documents read.
	 */
	var Transaction = /** @class */ (function () {
	    function Transaction(datastore) {
	        this.datastore = datastore;
	        // The version of each document that was read during this transaction.
	        this.readVersions = collections_1.documentVersionMap();
	        this.mutations = [];
	        this.committed = false;
	    }
	    Transaction.prototype.recordVersion = function (doc) {
	        var docVersion = doc.version;
	        if (doc instanceof document_1.NoDocument) {
	            // For deleted docs, we must use baseVersion 0 when we overwrite them.
	            docVersion = snapshot_version_1.SnapshotVersion.forDeletedDoc();
	        }
	        var existingVersion = this.readVersions.get(doc.key);
	        if (existingVersion !== null) {
	            if (!docVersion.equals(existingVersion)) {
	                // This transaction will fail no matter what.
	                throw new error_1.FirestoreError(error_1.Code.ABORTED, 'Document version changed between two reads.');
	            }
	        }
	        else {
	            this.readVersions = this.readVersions.insert(doc.key, docVersion);
	        }
	    };
	    Transaction.prototype.lookup = function (keys) {
	        var _this = this;
	        if (this.committed) {
	            return Promise.reject('Transaction has already completed.');
	        }
	        if (this.mutations.length > 0) {
	            return Promise.reject('Transactions lookups are invalid after writes.');
	        }
	        return this.datastore.lookup(keys).then(function (docs) {
	            docs.forEach(function (doc) { return _this.recordVersion(doc); });
	            return docs;
	        });
	    };
	    Transaction.prototype.write = function (mutations) {
	        if (this.committed) {
	            throw new error_1.FirestoreError(error_1.Code.FAILED_PRECONDITION, 'Transaction has already completed.');
	        }
	        this.mutations = this.mutations.concat(mutations);
	    };
	    /**
	     * Returns the version of this document when it was read in this transaction,
	     * as a precondition, or no precondition if it was not read.
	     */
	    Transaction.prototype.precondition = function (key) {
	        var version = this.readVersions.get(key);
	        if (version) {
	            return mutation_1.Precondition.updateTime(version);
	        }
	        else {
	            return mutation_1.Precondition.NONE;
	        }
	    };
	    /**
	     * Returns the precondition for a document if the operation is an update.
	     */
	    Transaction.prototype.preconditionForUpdate = function (key) {
	        var version = this.readVersions.get(key);
	        if (version && version.equals(snapshot_version_1.SnapshotVersion.forDeletedDoc())) {
	            // The document doesn't exist, so fail the transaction.
	            throw new error_1.FirestoreError(error_1.Code.FAILED_PRECONDITION, "Can't update a document that doesn't exist.");
	        }
	        else if (version) {
	            // Document exists, base precondition on document update time.
	            return mutation_1.Precondition.updateTime(version);
	        }
	        else {
	            // Document was not read, so we just use the preconditions for a blind
	            // update.
	            return mutation_1.Precondition.exists(true);
	        }
	    };
	    Transaction.prototype.set = function (key, data) {
	        this.write(data.toMutations(key, this.precondition(key)));
	    };
	    Transaction.prototype.update = function (key, data) {
	        this.write(data.toMutations(key, this.preconditionForUpdate(key)));
	    };
	    Transaction.prototype.delete = function (key) {
	        this.write([new mutation_1.DeleteMutation(key, this.precondition(key))]);
	        // Since the delete will be applied before all following writes, we need to
	        // ensure that the precondition for the next write will be exists: false.
	        this.readVersions = this.readVersions.insert(key, snapshot_version_1.SnapshotVersion.forDeletedDoc());
	    };
	    Transaction.prototype.commit = function () {
	        var _this = this;
	        var unwritten = this.readVersions;
	        // For each mutation, note that the doc was written.
	        this.mutations.forEach(function (mutation) {
	            unwritten = unwritten.remove(mutation.key);
	        });
	        if (!unwritten.isEmpty()) {
	            return Promise.reject(Error('Every document read in a transaction must also be written.'));
	        }
	        return this.datastore.commit(this.mutations).then(function () {
	            _this.committed = true;
	        });
	    };
	    return Transaction;
	}());
	exports.Transaction = Transaction;
	
	//# sourceMappingURL=transaction.js.map


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var collections_1 = __webpack_require__(20);
	var document_1 = __webpack_require__(32);
	var document_set_1 = __webpack_require__(194);
	var remote_event_1 = __webpack_require__(71);
	var assert_1 = __webpack_require__(10);
	var view_snapshot_1 = __webpack_require__(93);
	var AddedLimboDocument = /** @class */ (function () {
	    function AddedLimboDocument(key) {
	        this.key = key;
	    }
	    return AddedLimboDocument;
	}());
	exports.AddedLimboDocument = AddedLimboDocument;
	var RemovedLimboDocument = /** @class */ (function () {
	    function RemovedLimboDocument(key) {
	        this.key = key;
	    }
	    return RemovedLimboDocument;
	}());
	exports.RemovedLimboDocument = RemovedLimboDocument;
	/**
	 * View is responsible for computing the final merged truth of what docs are in
	 * a query. It gets notified of local and remote changes to docs, and applies
	 * the query filters and limits to determine the most correct possible results.
	 */
	var View = /** @class */ (function () {
	    function View(query, 
	        /** Documents included in the remote target */
	        syncedDocuments) {
	        this.query = query;
	        this.syncedDocuments = syncedDocuments;
	        this.syncState = null;
	        /**
	         * A flag whether the view is current with the backend. A view is considered
	         * current after it has seen the current flag from the backend and did not
	         * lose consistency within the watch stream (e.g. because of an existence
	         * filter mismatch).
	         */
	        this.current = false;
	        /** Documents in the view but not in the remote target */
	        this.limboDocuments = collections_1.documentKeySet();
	        /** Document Keys that have local changes */
	        this.mutatedKeys = collections_1.documentKeySet();
	        this.documentSet = new document_set_1.DocumentSet(query.docComparator.bind(query));
	    }
	    /**
	     * Iterates over a set of doc changes, applies the query limit, and computes
	     * what the new results should be, what the changes were, and whether we may
	     * need to go back to the local cache for more results. Does not make any
	     * changes to the view.
	     * @param docChanges The doc changes to apply to this view.
	     * @param previousChanges If this is being called with a refill, then start
	     *        with this set of docs and changes instead of the current view.
	     * @return a new set of docs, changes, and refill flag.
	     */
	    View.prototype.computeDocChanges = function (docChanges, previousChanges) {
	        var _this = this;
	        var changeSet = previousChanges
	            ? previousChanges.changeSet
	            : new view_snapshot_1.DocumentChangeSet();
	        var oldDocumentSet = previousChanges
	            ? previousChanges.documentSet
	            : this.documentSet;
	        var newMutatedKeys = previousChanges
	            ? previousChanges.mutatedKeys
	            : this.mutatedKeys;
	        var newDocumentSet = oldDocumentSet;
	        var needsRefill = false;
	        // Track the last doc in a (full) limit. This is necessary, because some
	        // update (a delete, or an update moving a doc past the old limit) might
	        // mean there is some other document in the local cache that either should
	        // come (1) between the old last limit doc and the new last document, in the
	        // case of updates, or (2) after the new last document, in the case of
	        // deletes. So we keep this doc at the old limit to compare the updates to.
	        //
	        // Note that this should never get used in a refill (when previousChanges is
	        // set), because there will only be adds -- no deletes or updates.
	        var lastDocInLimit = this.query.hasLimit() && oldDocumentSet.size === this.query.limit
	            ? oldDocumentSet.last()
	            : null;
	        docChanges.inorderTraversal(function (key, newMaybeDoc) {
	            var oldDoc = oldDocumentSet.get(key);
	            var newDoc = newMaybeDoc instanceof document_1.Document ? newMaybeDoc : null;
	            if (newDoc) {
	                assert_1.assert(key.equals(newDoc.key), 'Mismatching keys found in document changes: ' +
	                    key +
	                    ' != ' +
	                    newDoc.key);
	                newDoc = _this.query.matches(newDoc) ? newDoc : null;
	            }
	            if (newDoc) {
	                newDocumentSet = newDocumentSet.add(newDoc);
	                if (newDoc.hasLocalMutations) {
	                    newMutatedKeys = newMutatedKeys.add(key);
	                }
	                else {
	                    newMutatedKeys = newMutatedKeys.delete(key);
	                }
	            }
	            else {
	                newDocumentSet = newDocumentSet.delete(key);
	                newMutatedKeys = newMutatedKeys.delete(key);
	            }
	            // Calculate change
	            if (oldDoc && newDoc) {
	                var docsEqual = oldDoc.data.equals(newDoc.data);
	                if (!docsEqual ||
	                    oldDoc.hasLocalMutations !== newDoc.hasLocalMutations) {
	                    // only report a change if document actually changed
	                    if (docsEqual) {
	                        changeSet.track({ type: view_snapshot_1.ChangeType.Metadata, doc: newDoc });
	                    }
	                    else {
	                        changeSet.track({ type: view_snapshot_1.ChangeType.Modified, doc: newDoc });
	                    }
	                    if (lastDocInLimit &&
	                        _this.query.docComparator(newDoc, lastDocInLimit) > 0) {
	                        // This doc moved from inside the limit to after the limit.
	                        // That means there may be some doc in the local cache that's
	                        // actually less than this one.
	                        needsRefill = true;
	                    }
	                }
	            }
	            else if (!oldDoc && newDoc) {
	                changeSet.track({ type: view_snapshot_1.ChangeType.Added, doc: newDoc });
	            }
	            else if (oldDoc && !newDoc) {
	                changeSet.track({ type: view_snapshot_1.ChangeType.Removed, doc: oldDoc });
	                if (lastDocInLimit) {
	                    // A doc was removed from a full limit query. We'll need to
	                    // requery from the local cache to see if we know about some other
	                    // doc that should be in the results.
	                    needsRefill = true;
	                }
	            }
	        });
	        if (this.query.hasLimit()) {
	            // TODO(klimt): Make DocumentSet size be constant time.
	            while (newDocumentSet.size > this.query.limit) {
	                var oldDoc = newDocumentSet.last();
	                newDocumentSet = newDocumentSet.delete(oldDoc.key);
	                changeSet.track({ type: view_snapshot_1.ChangeType.Removed, doc: oldDoc });
	            }
	        }
	        assert_1.assert(!needsRefill || !previousChanges, 'View was refilled using docs that themselves needed refilling.');
	        return {
	            documentSet: newDocumentSet,
	            changeSet: changeSet,
	            needsRefill: needsRefill,
	            mutatedKeys: newMutatedKeys
	        };
	    };
	    /**
	     * Updates the view with the given ViewDocumentChanges and updates limbo docs
	     * and sync state from the given (optional) target change.
	     * @param docChanges The set of changes to make to the view's docs.
	     * @param targetChange A target change to apply for computing limbo docs and
	     *        sync state.
	     * @return A new ViewChange with the given docs, changes, and sync state.
	     */
	    View.prototype.applyChanges = function (docChanges, targetChange) {
	        var _this = this;
	        assert_1.assert(!docChanges.needsRefill, 'Cannot apply changes that need a refill');
	        var oldDocs = this.documentSet;
	        this.documentSet = docChanges.documentSet;
	        this.mutatedKeys = docChanges.mutatedKeys;
	        // Sort changes based on type and query comparator
	        var changes = docChanges.changeSet.getChanges();
	        changes.sort(function (c1, c2) {
	            return (compareChangeType(c1.type, c2.type) ||
	                _this.query.docComparator(c1.doc, c2.doc));
	        });
	        var limboChanges = this.applyTargetChange(targetChange);
	        var synced = this.limboDocuments.size === 0 && this.current;
	        var newSyncState = synced ? view_snapshot_1.SyncState.Synced : view_snapshot_1.SyncState.Local;
	        var syncStateChanged = newSyncState !== this.syncState;
	        this.syncState = newSyncState;
	        if (changes.length === 0 && !syncStateChanged) {
	            // no changes
	            return { limboChanges: limboChanges };
	        }
	        else {
	            return {
	                snapshot: {
	                    query: this.query,
	                    docs: docChanges.documentSet,
	                    oldDocs: oldDocs,
	                    docChanges: changes,
	                    fromCache: newSyncState === view_snapshot_1.SyncState.Local,
	                    syncStateChanged: syncStateChanged,
	                    hasPendingWrites: !docChanges.mutatedKeys.isEmpty()
	                },
	                limboChanges: limboChanges
	            };
	        }
	    };
	    /**
	     * Returns whether the doc for the given key should be in limbo.
	     */
	    View.prototype.shouldBeInLimbo = function (key) {
	        // If the remote end says it's part of this query, it's not in limbo.
	        if (this.syncedDocuments.has(key)) {
	            return false;
	        }
	        // The local store doesn't think it's a result, so it shouldn't be in limbo.
	        if (!this.documentSet.has(key)) {
	            return false;
	        }
	        // If there are local changes to the doc, they might explain why the server
	        // doesn't know that it's part of the query. So don't put it in limbo.
	        // TODO(klimt): Ideally, we would only consider changes that might actually
	        // affect this specific query.
	        if (this.documentSet.get(key).hasLocalMutations) {
	            return false;
	        }
	        // Everything else is in limbo.
	        return true;
	    };
	    /**
	     * Updates syncedDocuments, current, and limbo docs based on the given change.
	     * Returns the list of changes to which docs are in limbo.
	     */
	    View.prototype.applyTargetChange = function (targetChange) {
	        var _this = this;
	        if (targetChange) {
	            var targetMapping = targetChange.mapping;
	            if (targetMapping instanceof remote_event_1.ResetMapping) {
	                this.syncedDocuments = targetMapping.documents;
	            }
	            else if (targetMapping instanceof remote_event_1.UpdateMapping) {
	                this.syncedDocuments = targetMapping.applyToKeySet(this.syncedDocuments);
	            }
	            switch (targetChange.currentStatusUpdate) {
	                case remote_event_1.CurrentStatusUpdate.MarkCurrent:
	                    this.current = true;
	                    break;
	                case remote_event_1.CurrentStatusUpdate.MarkNotCurrent:
	                    this.current = false;
	                    break;
	                case remote_event_1.CurrentStatusUpdate.None:
	                    break;
	                default:
	                    assert_1.fail('Unknown current status update: ' + targetChange.currentStatusUpdate);
	            }
	        }
	        // Recompute the set of limbo docs.
	        // TODO(klimt): Do this incrementally so that it's not quadratic when
	        // updating many documents.
	        var oldLimboDocuments = this.limboDocuments;
	        this.limboDocuments = collections_1.documentKeySet();
	        if (this.current) {
	            this.documentSet.forEach(function (doc) {
	                if (_this.shouldBeInLimbo(doc.key)) {
	                    _this.limboDocuments = _this.limboDocuments.add(doc.key);
	                }
	            });
	        }
	        // Diff the new limbo docs with the old limbo docs.
	        var changes = [];
	        oldLimboDocuments.forEach(function (key) {
	            if (!_this.limboDocuments.has(key)) {
	                changes.push(new RemovedLimboDocument(key));
	            }
	        });
	        this.limboDocuments.forEach(function (key) {
	            if (!oldLimboDocuments.has(key)) {
	                changes.push(new AddedLimboDocument(key));
	            }
	        });
	        return changes;
	    };
	    return View;
	}());
	exports.View = View;
	function compareChangeType(c1, c2) {
	    var order = function (change) {
	        switch (change) {
	            case view_snapshot_1.ChangeType.Added:
	                return 1;
	            case view_snapshot_1.ChangeType.Modified:
	                return 2;
	            case view_snapshot_1.ChangeType.Metadata:
	                // A metadata change is converted to a modified change at the public
	                // api layer.  Since we sort by document key and then change type,
	                // metadata and modified changes must be sorted equivalently.
	                return 2;
	            case view_snapshot_1.ChangeType.Removed:
	                return 0;
	            default:
	                return assert_1.fail('Unknown ChangeType: ' + change);
	        }
	    };
	    return order(c1) - order(c2);
	}
	
	//# sourceMappingURL=view.js.map


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var mutation_batch_1 = __webpack_require__(70);
	var assert_1 = __webpack_require__(10);
	var misc_1 = __webpack_require__(25);
	var sorted_set_1 = __webpack_require__(97);
	var EncodedResourcePath = __webpack_require__(126);
	var indexeddb_schema_1 = __webpack_require__(56);
	var persistence_promise_1 = __webpack_require__(29);
	var simple_db_1 = __webpack_require__(95);
	/** A mutation queue for a specific user, backed by IndexedDB. */
	var IndexedDbMutationQueue = /** @class */ (function () {
	    function IndexedDbMutationQueue(
	        /**
	         * The normalized userId (e.g. null UID => "" userId) used to store /
	         * retrieve mutations.
	         */
	        userId, serializer) {
	        this.userId = userId;
	        this.serializer = serializer;
	        this.garbageCollector = null;
	    }
	    /**
	     * Creates a new mutation queue for the given user.
	     * @param user The user for which to create a mutation queue.
	     * @param serializer The serializer to use when persisting to IndexedDb.
	     */
	    IndexedDbMutationQueue.forUser = function (user, serializer) {
	        // TODO(mcg): Figure out what constraints there are on userIDs
	        // In particular, are there any reserved characters? are empty ids allowed?
	        // For the moment store these together in the same mutations table assuming
	        // that empty userIDs aren't allowed.
	        assert_1.assert(user.uid !== '', 'UserID must not be an empty string.');
	        var userId = user.isUnauthenticated() ? '' : user.uid;
	        return new IndexedDbMutationQueue(userId, serializer);
	    };
	    IndexedDbMutationQueue.prototype.start = function (transaction) {
	        var _this = this;
	        return IndexedDbMutationQueue.loadNextBatchIdFromDb(transaction)
	            .next(function (nextBatchId) {
	            _this.nextBatchId = nextBatchId;
	            return mutationQueuesStore(transaction).get(_this.userId);
	        })
	            .next(function (metadata) {
	            if (!metadata) {
	                metadata = new indexeddb_schema_1.DbMutationQueue(_this.userId, mutation_batch_1.BATCHID_UNKNOWN, 
	                /*lastStreamToken=*/ '');
	            }
	            _this.metadata = metadata;
	            // On restart, nextBatchId may end up lower than
	            // lastAcknowledgedBatchId since it's computed from the queue
	            // contents, and there may be no mutations in the queue. In this
	            // case, we need to reset lastAcknowledgedBatchId (which is safe
	            // since the queue must be empty).
	            if (_this.metadata.lastAcknowledgedBatchId >= _this.nextBatchId) {
	                return _this.checkEmpty(transaction).next(function (empty) {
	                    assert_1.assert(empty, 'Reset nextBatchID is only possible when the queue is empty');
	                    _this.metadata.lastAcknowledgedBatchId = mutation_batch_1.BATCHID_UNKNOWN;
	                    return mutationQueuesStore(transaction).put(_this.metadata);
	                });
	            }
	            else {
	                return persistence_promise_1.PersistencePromise.resolve();
	            }
	        });
	    };
	    /**
	     * Returns one larger than the largest batch ID that has been stored. If there
	     * are no mutations returns 0. Note that batch IDs are global.
	     */
	    IndexedDbMutationQueue.loadNextBatchIdFromDb = function (txn) {
	        var maxBatchId = mutation_batch_1.BATCHID_UNKNOWN;
	        return mutationsStore(txn)
	            .iterate({ reverse: true }, function (key, batch, control) {
	            var userId = key[0], batchId = key[1];
	            if (batchId > maxBatchId) {
	                maxBatchId = batch.batchId;
	            }
	            if (userId === '') {
	                // We can't compute a predecessor for the empty string, since it
	                // is lexographically first. That also means that no other
	                // userIds can come before this one, so we can just exit early.
	                control.done();
	            }
	            else {
	                var nextUser = misc_1.immediatePredecessor(userId);
	                control.skip([nextUser]);
	            }
	        })
	            .next(function () { return maxBatchId + 1; });
	    };
	    IndexedDbMutationQueue.prototype.checkEmpty = function (transaction) {
	        var empty = true;
	        var range = IDBKeyRange.bound(this.keyForBatchId(Number.NEGATIVE_INFINITY), this.keyForBatchId(Number.POSITIVE_INFINITY));
	        return mutationsStore(transaction)
	            .iterate({ range: range }, function (key, value, control) {
	            empty = false;
	            control.done();
	        })
	            .next(function () { return empty; });
	    };
	    IndexedDbMutationQueue.prototype.getNextBatchId = function (transaction) {
	        return persistence_promise_1.PersistencePromise.resolve(this.nextBatchId);
	    };
	    IndexedDbMutationQueue.prototype.getHighestAcknowledgedBatchId = function (transaction) {
	        return persistence_promise_1.PersistencePromise.resolve(this.metadata.lastAcknowledgedBatchId);
	    };
	    IndexedDbMutationQueue.prototype.acknowledgeBatch = function (transaction, batch, streamToken) {
	        var batchId = batch.batchId;
	        assert_1.assert(batchId > this.metadata.lastAcknowledgedBatchId, 'Mutation batchIDs must be acknowledged in order');
	        this.metadata.lastAcknowledgedBatchId = batchId;
	        this.metadata.lastStreamToken = validateStreamToken(streamToken);
	        return mutationQueuesStore(transaction).put(this.metadata);
	    };
	    IndexedDbMutationQueue.prototype.getLastStreamToken = function (transaction) {
	        return persistence_promise_1.PersistencePromise.resolve(this.metadata.lastStreamToken);
	    };
	    IndexedDbMutationQueue.prototype.setLastStreamToken = function (transaction, streamToken) {
	        this.metadata.lastStreamToken = validateStreamToken(streamToken);
	        return mutationQueuesStore(transaction).put(this.metadata);
	    };
	    IndexedDbMutationQueue.prototype.addMutationBatch = function (transaction, localWriteTime, mutations) {
	        var _this = this;
	        var batchId = this.nextBatchId;
	        this.nextBatchId++;
	        var batch = new mutation_batch_1.MutationBatch(batchId, localWriteTime, mutations);
	        var dbBatch = this.serializer.toDbMutationBatch(this.userId, batch);
	        return mutationsStore(transaction)
	            .put(dbBatch)
	            .next(function () {
	            var promises = [];
	            for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
	                var mutation = mutations_1[_i];
	                var encodedPath = EncodedResourcePath.encode(mutation.key.path);
	                var indexKey = indexeddb_schema_1.DbDocumentMutation.key(_this.userId, mutation.key.path, batchId);
	                documentMutationsStore(transaction).put(indexKey, indexeddb_schema_1.DbDocumentMutation.PLACEHOLDER);
	            }
	            return persistence_promise_1.PersistencePromise.waitFor(promises);
	        })
	            .next(function () {
	            return batch;
	        });
	    };
	    IndexedDbMutationQueue.prototype.lookupMutationBatch = function (transaction, batchId) {
	        var _this = this;
	        return mutationsStore(transaction)
	            .get(this.keyForBatchId(batchId))
	            .next(function (dbBatch) {
	            return dbBatch ? _this.serializer.fromDbMutationBatch(dbBatch) : null;
	        });
	    };
	    IndexedDbMutationQueue.prototype.getNextMutationBatchAfterBatchId = function (transaction, batchId) {
	        var _this = this;
	        var range = IDBKeyRange.lowerBound(this.keyForBatchId(batchId + 1));
	        var foundBatch = null;
	        return mutationsStore(transaction)
	            .iterate({ range: range }, function (key, dbBatch, control) {
	            if (dbBatch.userId === _this.userId) {
	                assert_1.assert(dbBatch.batchId > batchId, 'Should have found mutation after ' + batchId);
	                foundBatch = _this.serializer.fromDbMutationBatch(dbBatch);
	            }
	            control.done();
	        })
	            .next(function () { return foundBatch; });
	    };
	    IndexedDbMutationQueue.prototype.getAllMutationBatches = function (transaction) {
	        var _this = this;
	        var range = IDBKeyRange.bound(this.keyForBatchId(mutation_batch_1.BATCHID_UNKNOWN), this.keyForBatchId(Number.POSITIVE_INFINITY));
	        return mutationsStore(transaction)
	            .loadAll(range)
	            .next(function (dbBatches) {
	            return dbBatches.map(function (dbBatch) { return _this.serializer.fromDbMutationBatch(dbBatch); });
	        });
	    };
	    IndexedDbMutationQueue.prototype.getAllMutationBatchesThroughBatchId = function (transaction, batchId) {
	        var _this = this;
	        var range = IDBKeyRange.bound(this.keyForBatchId(mutation_batch_1.BATCHID_UNKNOWN), this.keyForBatchId(batchId));
	        return mutationsStore(transaction)
	            .loadAll(range)
	            .next(function (dbBatches) {
	            return dbBatches.map(function (dbBatch) { return _this.serializer.fromDbMutationBatch(dbBatch); });
	        });
	    };
	    IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKey = function (transaction, documentKey) {
	        var _this = this;
	        // Scan the document-mutation index starting with a prefix starting with
	        // the given documentKey.
	        var indexPrefix = indexeddb_schema_1.DbDocumentMutation.prefixForPath(this.userId, documentKey.path);
	        var indexStart = IDBKeyRange.lowerBound(indexPrefix);
	        var results = [];
	        return documentMutationsStore(transaction)
	            .iterate({ range: indexStart }, function (indexKey, _, control) {
	            var userID = indexKey[0], encodedPath = indexKey[1], batchID = indexKey[2];
	            // Only consider rows matching exactly the specific key of
	            // interest. Note that because we order by path first, and we
	            // order terminators before path separators, we'll encounter all
	            // the index rows for documentKey contiguously. In particular, all
	            // the rows for documentKey will occur before any rows for
	            // documents nested in a subcollection beneath documentKey so we
	            // can stop as soon as we hit any such row.
	            var path = EncodedResourcePath.decode(encodedPath);
	            if (userID !== _this.userId || !documentKey.path.equals(path)) {
	                control.done();
	                return;
	            }
	            var mutationKey = _this.keyForBatchId(batchID);
	            // Look up the mutation batch in the store.
	            // PORTING NOTE: because iteration is callback driven in the web,
	            // we just look up the key instead of keeping an open iterator
	            // like iOS.
	            return mutationsStore(transaction)
	                .get(mutationKey)
	                .next(function (dbBatch) {
	                if (dbBatch === null) {
	                    assert_1.fail('Dangling document-mutation reference found: ' +
	                        indexKey +
	                        ' which points to ' +
	                        mutationKey);
	                }
	                results.push(_this.serializer.fromDbMutationBatch(dbBatch));
	            });
	        })
	            .next(function () { return results; });
	    };
	    IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingQuery = function (transaction, query) {
	        var _this = this;
	        assert_1.assert(!query.isDocumentQuery(), "Document queries shouldn't go down this path");
	        var queryPath = query.path;
	        var immediateChildrenLength = queryPath.length + 1;
	        // TODO(mcg): Actually implement a single-collection query
	        //
	        // This is actually executing an ancestor query, traversing the whole
	        // subtree below the collection which can be horrifically inefficient for
	        // some structures. The right way to solve this is to implement the full
	        // value index, but that's not in the cards in the near future so this is
	        // the best we can do for the moment.
	        //
	        // Since we don't yet index the actual properties in the mutations, our
	        // current approach is to just return all mutation batches that affect
	        // documents in the collection being queried.
	        var indexPrefix = indexeddb_schema_1.DbDocumentMutation.prefixForPath(this.userId, queryPath);
	        var encodedQueryPath = indexPrefix[1];
	        var indexStart = IDBKeyRange.lowerBound(indexPrefix);
	        // Collect up unique batchIDs encountered during a scan of the index. Use a
	        // SortedSet to accumulate batch IDs so they can be traversed in order in a
	        // scan of the main table.
	        var uniqueBatchIDs = new sorted_set_1.SortedSet(misc_1.primitiveComparator);
	        return documentMutationsStore(transaction)
	            .iterate({ range: indexStart }, function (indexKey, _, control) {
	            var userID = indexKey[0], encodedPath = indexKey[1], batchID = indexKey[2];
	            var path = EncodedResourcePath.decode(encodedPath);
	            if (userID !== _this.userId || !queryPath.isPrefixOf(path)) {
	                control.done();
	                return;
	            }
	            // Rows with document keys more than one segment longer than the
	            // query path can't be matches. For example, a query on 'rooms'
	            // can't match the document /rooms/abc/messages/xyx.
	            // TODO(mcg): we'll need a different scanner when we implement
	            // ancestor queries.
	            if (path.length !== immediateChildrenLength) {
	                return;
	            }
	            uniqueBatchIDs = uniqueBatchIDs.add(batchID);
	        })
	            .next(function () {
	            var results = [];
	            var promises = [];
	            // TODO(rockwood): Implement this using iterate.
	            uniqueBatchIDs.forEach(function (batchID) {
	                var mutationKey = _this.keyForBatchId(batchID);
	                promises.push(mutationsStore(transaction)
	                    .get(mutationKey)
	                    .next(function (mutation) {
	                    if (mutation === null) {
	                        assert_1.fail('Dangling document-mutation reference found, ' +
	                            'which points to ' +
	                            mutationKey);
	                    }
	                    results.push(_this.serializer.fromDbMutationBatch(mutation));
	                }));
	            });
	            return persistence_promise_1.PersistencePromise.waitFor(promises).next(function () { return results; });
	        });
	    };
	    IndexedDbMutationQueue.prototype.removeMutationBatches = function (transaction, batches) {
	        var txn = mutationsStore(transaction);
	        var indexTxn = documentMutationsStore(transaction);
	        var promises = [];
	        var _loop_1 = function (batch) {
	            var range = IDBKeyRange.only(this_1.keyForBatchId(batch.batchId));
	            var numDeleted = 0;
	            var removePromise = txn.iterate({ range: range }, function (key, value, control) {
	                numDeleted++;
	                return control.delete();
	            });
	            promises.push(removePromise.next(function () {
	                assert_1.assert(numDeleted === 1, 'Dangling document-mutation reference found: Missing batch ' +
	                    batch.batchId);
	            }));
	            for (var _i = 0, _a = batch.mutations; _i < _a.length; _i++) {
	                var mutation = _a[_i];
	                var indexKey = indexeddb_schema_1.DbDocumentMutation.key(this_1.userId, mutation.key.path, batch.batchId);
	                promises.push(indexTxn.delete(indexKey));
	                if (this_1.garbageCollector !== null) {
	                    this_1.garbageCollector.addPotentialGarbageKey(mutation.key);
	                }
	            }
	        };
	        var this_1 = this;
	        for (var _i = 0, batches_1 = batches; _i < batches_1.length; _i++) {
	            var batch = batches_1[_i];
	            _loop_1(batch);
	        }
	        return persistence_promise_1.PersistencePromise.waitFor(promises);
	    };
	    IndexedDbMutationQueue.prototype.performConsistencyCheck = function (txn) {
	        var _this = this;
	        return this.checkEmpty(txn).next(function (empty) {
	            if (!empty) {
	                return persistence_promise_1.PersistencePromise.resolve();
	            }
	            // Verify that there are no entries in the documentMutations index if
	            // the queue is empty.
	            var startRange = IDBKeyRange.lowerBound(indexeddb_schema_1.DbDocumentMutation.prefixForUser(_this.userId));
	            var danglingMutationReferences = [];
	            return documentMutationsStore(txn)
	                .iterate({ range: startRange }, function (key, _, control) {
	                var userID = key[0];
	                if (userID !== _this.userId) {
	                    control.done();
	                    return;
	                }
	                else {
	                    var path = EncodedResourcePath.decode(key[1]);
	                    danglingMutationReferences.push(path);
	                }
	            })
	                .next(function () {
	                assert_1.assert(danglingMutationReferences.length === 0, 'Document leak -- detected dangling mutation references when queue is empty. Dangling keys: ' +
	                    danglingMutationReferences.map(function (p) { return p.canonicalString(); }));
	            });
	        });
	    };
	    IndexedDbMutationQueue.prototype.setGarbageCollector = function (gc) {
	        this.garbageCollector = gc;
	    };
	    IndexedDbMutationQueue.prototype.containsKey = function (txn, key) {
	        var _this = this;
	        var indexKey = indexeddb_schema_1.DbDocumentMutation.prefixForPath(this.userId, key.path);
	        var encodedPath = indexKey[1];
	        var startRange = IDBKeyRange.lowerBound(indexKey);
	        var containsKey = false;
	        return documentMutationsStore(txn)
	            .iterate({ range: startRange, keysOnly: true }, function (key, _, control) {
	            var userID = key[0], keyPath = key[1], batchID = key[2];
	            if (userID === _this.userId && keyPath === encodedPath) {
	                containsKey = true;
	            }
	            control.done();
	        })
	            .next(function () { return containsKey; });
	    };
	    /**
	     * Creates a [userId, batchId] key for use with the DbMutationQueue object
	     * store.
	     */
	    IndexedDbMutationQueue.prototype.keyForBatchId = function (batchId) {
	        return [this.userId, batchId];
	    };
	    return IndexedDbMutationQueue;
	}());
	exports.IndexedDbMutationQueue = IndexedDbMutationQueue;
	function validateStreamToken(token) {
	    assert_1.assert(typeof token === 'string', 'Persisting non-string stream token not supported.');
	    return token;
	}
	/**
	 * Helper to get a typed SimpleDbStore for the mutations object store.
	 */
	function mutationsStore(txn) {
	    return getStore(txn, indexeddb_schema_1.DbMutationBatch.store);
	}
	/**
	 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
	 */
	function documentMutationsStore(txn) {
	    return getStore(txn, indexeddb_schema_1.DbDocumentMutation.store);
	}
	/**
	 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
	 */
	function mutationQueuesStore(txn) {
	    return getStore(txn, indexeddb_schema_1.DbMutationQueue.store);
	}
	/**
	 * Helper to get a typed SimpleDbStore from a transaction.
	 */
	function getStore(txn, store) {
	    if (txn instanceof simple_db_1.SimpleDbTransaction) {
	        return txn.store(store);
	    }
	    else {
	        return assert_1.fail('Invalid transaction object provided!');
	    }
	}
	
	//# sourceMappingURL=indexeddb_mutation_queue.js.map


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(10);
	var error_1 = __webpack_require__(19);
	var log = __webpack_require__(24);
	var misc_1 = __webpack_require__(25);
	var indexeddb_mutation_queue_1 = __webpack_require__(464);
	var indexeddb_query_cache_1 = __webpack_require__(466);
	var indexeddb_remote_document_cache_1 = __webpack_require__(467);
	var indexeddb_schema_1 = __webpack_require__(56);
	var indexeddb_schema_2 = __webpack_require__(56);
	var local_serializer_1 = __webpack_require__(469);
	var persistence_promise_1 = __webpack_require__(29);
	var simple_db_1 = __webpack_require__(95);
	var LOG_TAG = 'IndexedDbPersistence';
	/** If the owner lease is older than 5 seconds, try to take ownership. */
	var OWNER_LEASE_MAX_AGE_MS = 5000;
	/** Refresh the owner lease every 4 seconds while owner. */
	var OWNER_LEASE_REFRESH_INTERVAL_MS = 4000;
	/** LocalStorage location to indicate a zombied ownerId (see class comment). */
	var ZOMBIE_OWNER_LOCALSTORAGE_SUFFIX = 'zombiedOwnerId';
	/** Error when the owner lease cannot be acquired or is lost. */
	var EXISTING_OWNER_ERROR_MSG = 'There is another tab open with offline' +
	    ' persistence enabled. Only one such tab is allowed at a time. The' +
	    ' other tab must be closed or persistence must be disabled.';
	var UNSUPPORTED_PLATFORM_ERROR_MSG = 'This platform is either missing' +
	    ' IndexedDB or is known to have an incomplete implementation. Offline' +
	    ' persistence has been disabled.';
	/**
	 * An IndexedDB-backed instance of Persistence. Data is stored persistently
	 * across sessions.
	 *
	 * Currently the Firestore SDK only supports a single consumer of the database,
	 * but browsers obviously support multiple tabs. IndexedDbPersistence ensures a
	 * single consumer of the database via an "owner lease" stored in the database.
	 *
	 * On startup, IndexedDbPersistence assigns itself a random "ownerId" and writes
	 * it to a special "owner" object in the database (if no entry exists already or
	 * the current entry is expired). This owner lease is then verified inside every
	 * transaction to ensure the lease has not been lost.
	 *
	 * If a tab opts not to acquire the owner lease (because there's an existing
	 * non-expired owner) or loses the owner lease, IndexedDbPersistence enters a
	 * failed state and all subsequent operations will automatically fail.
	 *
	 * The current owner regularly refreshes the owner lease with new timestamps to
	 * prevent newly-opened tabs from taking over ownership.
	 *
	 * Additionally there is an optimization so that when a tab is closed, the owner
	 * lease is released immediately (this is especially important to make sure that
	 * a refreshed tab is able to immediately re-acquire the owner lease).
	 * Unfortunately, IndexedDB cannot be reliably used in window.unload since it is
	 * an asynchronous API. So in addition to attempting to give up the lease,
	 * the owner writes its ownerId to a "zombiedOwnerId" entry in LocalStorage
	 * which acts as an indicator that another tab should go ahead and take the
	 * owner lease immediately regardless of the current lease timestamp.
	 */
	var IndexedDbPersistence = /** @class */ (function () {
	    function IndexedDbPersistence(prefix, serializer) {
	        this.ownerId = this.generateOwnerId();
	        this.dbName = prefix + IndexedDbPersistence.MAIN_DATABASE;
	        this.serializer = new local_serializer_1.LocalSerializer(serializer);
	        this.localStoragePrefix = prefix;
	    }
	    IndexedDbPersistence.prototype.start = function () {
	        var _this = this;
	        if (!IndexedDbPersistence.isAvailable()) {
	            this.persistenceError = new error_1.FirestoreError(error_1.Code.UNIMPLEMENTED, UNSUPPORTED_PLATFORM_ERROR_MSG);
	            return Promise.reject(this.persistenceError);
	        }
	        assert_1.assert(!this.started, 'IndexedDbPersistence double-started!');
	        this.started = true;
	        return simple_db_1.SimpleDb.openOrCreate(this.dbName, indexeddb_schema_2.SCHEMA_VERSION, indexeddb_schema_2.createOrUpgradeDb)
	            .then(function (db) {
	            _this.simpleDb = db;
	        })
	            .then(function () { return _this.tryAcquireOwnerLease(); })
	            .then(function () {
	            _this.scheduleOwnerLeaseRefreshes();
	            _this.attachWindowUnloadHook();
	        });
	    };
	    IndexedDbPersistence.prototype.shutdown = function () {
	        var _this = this;
	        assert_1.assert(this.started, 'IndexedDbPersistence shutdown without start!');
	        this.started = false;
	        this.detachWindowUnloadHook();
	        this.stopOwnerLeaseRefreshes();
	        return this.releaseOwnerLease().then(function () {
	            _this.simpleDb.close();
	        });
	    };
	    IndexedDbPersistence.prototype.getMutationQueue = function (user) {
	        return indexeddb_mutation_queue_1.IndexedDbMutationQueue.forUser(user, this.serializer);
	    };
	    IndexedDbPersistence.prototype.getQueryCache = function () {
	        return new indexeddb_query_cache_1.IndexedDbQueryCache(this.serializer);
	    };
	    IndexedDbPersistence.prototype.getRemoteDocumentCache = function () {
	        return new indexeddb_remote_document_cache_1.IndexedDbRemoteDocumentCache(this.serializer);
	    };
	    IndexedDbPersistence.prototype.runTransaction = function (action, operation) {
	        var _this = this;
	        if (this.persistenceError) {
	            return Promise.reject(this.persistenceError);
	        }
	        log.debug(LOG_TAG, 'Starting transaction:', action);
	        // Do all transactions as readwrite against all object stores, since we
	        // are the only reader/writer.
	        return this.simpleDb.runTransaction('readwrite', indexeddb_schema_1.ALL_STORES, function (txn) {
	            // Verify that we still have the owner lease as part of every transaction.
	            return _this.ensureOwnerLease(txn).next(function () { return operation(txn); });
	        });
	    };
	    IndexedDbPersistence.isAvailable = function () {
	        return simple_db_1.SimpleDb.isAvailable();
	    };
	    /**
	     * Generates a string used as a prefix when storing data in IndexedDB and
	     * LocalStorage.
	     */
	    IndexedDbPersistence.buildStoragePrefix = function (databaseInfo) {
	        // Use two different prefix formats:
	        //
	        //   * firestore / persistenceKey / projectID . databaseID / ...
	        //   * firestore / persistenceKey / projectID / ...
	        //
	        // projectIDs are DNS-compatible names and cannot contain dots
	        // so there's no danger of collisions.
	        var database = databaseInfo.databaseId.projectId;
	        if (!databaseInfo.databaseId.isDefaultDatabase) {
	            database += '.' + databaseInfo.databaseId.database;
	        }
	        return 'firestore/' + databaseInfo.persistenceKey + '/' + database + '/';
	    };
	    /**
	     * Acquires the owner lease if there's no valid owner. Else returns a rejected
	     * promise.
	     */
	    IndexedDbPersistence.prototype.tryAcquireOwnerLease = function () {
	        var _this = this;
	        // NOTE: Don't use this.runTransaction, since it requires us to already
	        // have the lease.
	        return this.simpleDb.runTransaction('readwrite', [indexeddb_schema_1.DbOwner.store], function (txn) {
	            var store = txn.store(indexeddb_schema_1.DbOwner.store);
	            return store.get('owner').next(function (dbOwner) {
	                if (!_this.validOwner(dbOwner)) {
	                    var newDbOwner = new indexeddb_schema_1.DbOwner(_this.ownerId, Date.now());
	                    log.debug(LOG_TAG, 'No valid owner. Acquiring owner lease. Current owner:', dbOwner, 'New owner:', newDbOwner);
	                    return store.put('owner', newDbOwner);
	                }
	                else {
	                    log.debug(LOG_TAG, 'Valid owner already. Failing. Current owner:', dbOwner);
	                    _this.persistenceError = new error_1.FirestoreError(error_1.Code.FAILED_PRECONDITION, EXISTING_OWNER_ERROR_MSG);
	                    return persistence_promise_1.PersistencePromise.reject(_this.persistenceError);
	                }
	            });
	        });
	    };
	    /** Checks the owner lease and deletes it if we are the current owner. */
	    IndexedDbPersistence.prototype.releaseOwnerLease = function () {
	        var _this = this;
	        // NOTE: Don't use this.runTransaction, since it requires us to already
	        // have the lease.
	        return this.simpleDb.runTransaction('readwrite', [indexeddb_schema_1.DbOwner.store], function (txn) {
	            var store = txn.store(indexeddb_schema_1.DbOwner.store);
	            return store.get('owner').next(function (dbOwner) {
	                if (dbOwner !== null && dbOwner.ownerId === _this.ownerId) {
	                    log.debug(LOG_TAG, 'Releasing owner lease.');
	                    return store.delete('owner');
	                }
	                else {
	                    return persistence_promise_1.PersistencePromise.resolve();
	                }
	            });
	        });
	    };
	    /**
	     * Checks the owner lease and returns a rejected promise if we are not the
	     * current owner. This should be included in every transaction to guard
	     * against losing the owner lease.
	     */
	    IndexedDbPersistence.prototype.ensureOwnerLease = function (txn) {
	        var _this = this;
	        var store = txn.store(indexeddb_schema_1.DbOwner.store);
	        return store.get('owner').next(function (dbOwner) {
	            if (dbOwner === null || dbOwner.ownerId !== _this.ownerId) {
	                _this.persistenceError = new error_1.FirestoreError(error_1.Code.FAILED_PRECONDITION, EXISTING_OWNER_ERROR_MSG);
	                return persistence_promise_1.PersistencePromise.reject(_this.persistenceError);
	            }
	            else {
	                return persistence_promise_1.PersistencePromise.resolve();
	            }
	        });
	    };
	    /**
	     * Returns true if the provided owner exists, has a recent timestamp, and
	     * isn't zombied.
	     *
	     * NOTE: To determine if the owner is zombied, this method reads from
	     * LocalStorage which could be mildly expensive.
	     */
	    IndexedDbPersistence.prototype.validOwner = function (dbOwner) {
	        var now = Date.now();
	        var minAcceptable = now - OWNER_LEASE_MAX_AGE_MS;
	        var maxAcceptable = now;
	        if (dbOwner === null) {
	            return false; // no owner.
	        }
	        else if (dbOwner.leaseTimestampMs < minAcceptable) {
	            return false; // owner lease has expired.
	        }
	        else if (dbOwner.leaseTimestampMs > maxAcceptable) {
	            log.error('Persistence owner-lease is in the future. Discarding.', dbOwner);
	            return false;
	        }
	        else if (dbOwner.ownerId === this.getZombiedOwnerId()) {
	            return false; // owner's tab closed.
	        }
	        else {
	            return true;
	        }
	    };
	    /**
	     * Schedules a recurring timer to update the owner lease timestamp to prevent
	     * other tabs from taking the lease.
	     */
	    IndexedDbPersistence.prototype.scheduleOwnerLeaseRefreshes = function () {
	        var _this = this;
	        // NOTE: This doesn't need to be scheduled on the async queue and doing so
	        // would increase the chances of us not refreshing on time if the queue is
	        // backed up for some reason.
	        this.ownerLeaseRefreshHandle = setInterval(function () {
	            var txResult = _this.runTransaction('Refresh owner timestamp', function (txn) {
	                // NOTE: We don't need to validate the current owner contents, since
	                // runTransaction does that automatically.
	                var store = txn.store(indexeddb_schema_1.DbOwner.store);
	                return store.put('owner', new indexeddb_schema_1.DbOwner(_this.ownerId, Date.now()));
	            });
	            txResult.catch(function (reason) {
	                // Probably means we lost the lease. Report the error and stop trying to
	                // refresh the lease.
	                log.error(reason);
	                _this.stopOwnerLeaseRefreshes();
	            });
	        }, OWNER_LEASE_REFRESH_INTERVAL_MS);
	    };
	    IndexedDbPersistence.prototype.stopOwnerLeaseRefreshes = function () {
	        if (this.ownerLeaseRefreshHandle) {
	            clearInterval(this.ownerLeaseRefreshHandle);
	            this.ownerLeaseRefreshHandle = null;
	        }
	    };
	    /**
	     * Attaches a window.unload handler that will synchronously write our
	     * ownerId to a "zombie owner id" location in localstorage. This can be used
	     * by tabs trying to acquire the lease to determine that the lease should be
	     * acquired immediately even if the timestamp is recent. This is particularly
	     * important for the refresh case (so the tab correctly re-acquires the owner
	     * lease). LocalStorage is used for this rather than IndexedDb because it is
	     * a synchronous API and so can be used reliably from an unload handler.
	     */
	    IndexedDbPersistence.prototype.attachWindowUnloadHook = function () {
	        var _this = this;
	        this.windowUnloadHandler = function () {
	            // Record that we're zombied.
	            _this.setZombiedOwnerId(_this.ownerId);
	            // Attempt graceful shutdown (including releasing our owner lease), but
	            // there's no guarantee it will complete.
	            _this.shutdown();
	        };
	        window.addEventListener('unload', this.windowUnloadHandler);
	    };
	    IndexedDbPersistence.prototype.detachWindowUnloadHook = function () {
	        if (this.windowUnloadHandler) {
	            window.removeEventListener('unload', this.windowUnloadHandler);
	            this.windowUnloadHandler = null;
	        }
	    };
	    /**
	     * Returns any recorded "zombied owner" (i.e. a previous owner that became
	     * zombied due to their tab closing) from LocalStorage, or null if no such
	     * record exists.
	     */
	    IndexedDbPersistence.prototype.getZombiedOwnerId = function () {
	        try {
	            var zombiedOwnerId = window.localStorage.getItem(this.zombiedOwnerLocalStorageKey());
	            log.debug(LOG_TAG, 'Zombied ownerID from LocalStorage:', zombiedOwnerId);
	            return zombiedOwnerId;
	        }
	        catch (e) {
	            // Gracefully handle if LocalStorage isn't available / working.
	            log.error(LOG_TAG, 'Failed to get zombie owner id.', e);
	            return null;
	        }
	    };
	    /**
	     * Records a zombied owner (an owner that had its tab closed) in LocalStorage
	     * or, if passed null, deletes any recorded zombied owner.
	     */
	    IndexedDbPersistence.prototype.setZombiedOwnerId = function (zombieOwnerId) {
	        try {
	            if (zombieOwnerId === null) {
	                window.localStorage.removeItem(this.zombiedOwnerLocalStorageKey());
	            }
	            else {
	                window.localStorage.setItem(this.zombiedOwnerLocalStorageKey(), zombieOwnerId);
	            }
	        }
	        catch (e) {
	            // Gracefully handle if LocalStorage isn't available / working.
	            log.error(LOG_TAG, 'Failed to set zombie owner id.', e);
	        }
	    };
	    IndexedDbPersistence.prototype.zombiedOwnerLocalStorageKey = function () {
	        return this.localStoragePrefix + ZOMBIE_OWNER_LOCALSTORAGE_SUFFIX;
	    };
	    IndexedDbPersistence.prototype.generateOwnerId = function () {
	        // For convenience, just use an AutoId.
	        return misc_1.AutoId.newId();
	    };
	    /**
	     * The name of the main (and currently only) IndexedDB database. this name is
	     * appended to the prefix provided to the IndexedDbPersistence constructor.
	     */
	    IndexedDbPersistence.MAIN_DATABASE = 'main';
	    return IndexedDbPersistence;
	}());
	exports.IndexedDbPersistence = IndexedDbPersistence;
	
	//# sourceMappingURL=indexeddb_persistence.js.map


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var snapshot_version_1 = __webpack_require__(31);
	var timestamp_1 = __webpack_require__(55);
	var collections_1 = __webpack_require__(20);
	var document_key_1 = __webpack_require__(22);
	var assert_1 = __webpack_require__(10);
	var misc_1 = __webpack_require__(25);
	var EncodedResourcePath = __webpack_require__(126);
	var indexeddb_schema_1 = __webpack_require__(56);
	var persistence_promise_1 = __webpack_require__(29);
	var simple_db_1 = __webpack_require__(95);
	var IndexedDbQueryCache = /** @class */ (function () {
	    function IndexedDbQueryCache(serializer) {
	        this.serializer = serializer;
	        /**
	         * The last received snapshot version. We store this seperately from the
	         * metadata to avoid the extra conversion to/from DbTimestamp.
	         */
	        this.lastRemoteSnapshotVersion = snapshot_version_1.SnapshotVersion.MIN;
	        /**
	         * A cached copy of the metadata for the query cache.
	         */
	        this.metadata = new indexeddb_schema_1.DbTargetGlobal(
	        /*highestTargetId=*/ 0, 
	        /*lastListenSequenceNumber=*/ 0, snapshot_version_1.SnapshotVersion.MIN.toTimestamp());
	        /** The garbage collector to notify about potential garbage keys. */
	        this.garbageCollector = null;
	    }
	    IndexedDbQueryCache.prototype.start = function (transaction) {
	        var _this = this;
	        return globalTargetStore(transaction)
	            .get(indexeddb_schema_1.DbTargetGlobal.key)
	            .next(function (metadata) {
	            if (metadata !== null) {
	                _this.metadata = metadata;
	                var lastSavedVersion = metadata.lastRemoteSnapshotVersion;
	                _this.lastRemoteSnapshotVersion = snapshot_version_1.SnapshotVersion.fromTimestamp(new timestamp_1.Timestamp(lastSavedVersion.seconds, lastSavedVersion.nanos));
	            }
	            return persistence_promise_1.PersistencePromise.resolve();
	        });
	    };
	    IndexedDbQueryCache.prototype.getHighestTargetId = function () {
	        return this.metadata.highestTargetId;
	    };
	    IndexedDbQueryCache.prototype.getLastRemoteSnapshotVersion = function () {
	        return this.lastRemoteSnapshotVersion;
	    };
	    IndexedDbQueryCache.prototype.setLastRemoteSnapshotVersion = function (transaction, snapshotVersion) {
	        this.lastRemoteSnapshotVersion = snapshotVersion;
	        this.metadata.lastRemoteSnapshotVersion = snapshotVersion.toTimestamp();
	        return globalTargetStore(transaction).put(indexeddb_schema_1.DbTargetGlobal.key, this.metadata);
	    };
	    IndexedDbQueryCache.prototype.addQueryData = function (transaction, queryData) {
	        var _this = this;
	        var targetId = queryData.targetId;
	        var addedQueryPromise = targetsStore(transaction).put(this.serializer.toDbTarget(queryData));
	        if (targetId > this.metadata.highestTargetId) {
	            this.metadata.highestTargetId = targetId;
	            return addedQueryPromise.next(function () {
	                return globalTargetStore(transaction).put(indexeddb_schema_1.DbTargetGlobal.key, _this.metadata);
	            });
	        }
	        else {
	            return addedQueryPromise;
	        }
	    };
	    IndexedDbQueryCache.prototype.removeQueryData = function (transaction, queryData) {
	        return this.removeMatchingKeysForTargetId(transaction, queryData.targetId).next(function () {
	            targetsStore(transaction).delete(queryData.targetId);
	        });
	    };
	    IndexedDbQueryCache.prototype.getQueryData = function (transaction, query) {
	        var _this = this;
	        // Iterating by the canonicalId may yield more than one result because
	        // canonicalId values are not required to be unique per target. This query
	        // depends on the queryTargets index to be efficent.
	        var canonicalId = query.canonicalId();
	        var range = IDBKeyRange.bound([canonicalId, Number.NEGATIVE_INFINITY], [canonicalId, Number.POSITIVE_INFINITY]);
	        var result = null;
	        return targetsStore(transaction)
	            .iterate({ range: range, index: indexeddb_schema_1.DbTarget.queryTargetsIndexName }, function (key, value, control) {
	            var found = _this.serializer.fromDbTarget(value);
	            // After finding a potential match, check that the query is
	            // actually equal to the requested query.
	            if (query.equals(found.query)) {
	                result = found;
	                control.done();
	            }
	        })
	            .next(function () { return result; });
	    };
	    IndexedDbQueryCache.prototype.addMatchingKeys = function (txn, keys, targetId) {
	        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
	        // Indexeddb.
	        var promises = [];
	        var store = documentTargetStore(txn);
	        keys.forEach(function (key) {
	            var path = EncodedResourcePath.encode(key.path);
	            promises.push(store.put(new indexeddb_schema_1.DbTargetDocument(targetId, path)));
	        });
	        return persistence_promise_1.PersistencePromise.waitFor(promises);
	    };
	    IndexedDbQueryCache.prototype.removeMatchingKeys = function (txn, keys, targetId) {
	        var _this = this;
	        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
	        // IndexedDb.
	        var promises = [];
	        var store = documentTargetStore(txn);
	        keys.forEach(function (key) {
	            var path = EncodedResourcePath.encode(key.path);
	            promises.push(store.delete([targetId, path]));
	            if (_this.garbageCollector !== null) {
	                _this.garbageCollector.addPotentialGarbageKey(key);
	            }
	        });
	        return persistence_promise_1.PersistencePromise.waitFor(promises);
	    };
	    IndexedDbQueryCache.prototype.removeMatchingKeysForTargetId = function (txn, targetId) {
	        var store = documentTargetStore(txn);
	        var range = IDBKeyRange.bound([targetId], [targetId + 1], 
	        /*lowerOpen=*/ false, 
	        /*upperOpen=*/ true);
	        return this.notifyGCForRemovedKeys(txn, range).next(function () {
	            return store.delete(range);
	        });
	    };
	    IndexedDbQueryCache.prototype.notifyGCForRemovedKeys = function (txn, range) {
	        var _this = this;
	        var store = documentTargetStore(txn);
	        if (this.garbageCollector !== null && this.garbageCollector.isEager) {
	            // In order to generate garbage events properly, we need to read these
	            // keys before deleting.
	            return store.iterate({ range: range, keysOnly: true }, function (key, _, control) {
	                var path = EncodedResourcePath.decode(key[1]);
	                var docKey = new document_key_1.DocumentKey(path);
	                // Paranoid assertion in case the the collector is set to null
	                // during the iteration.
	                assert_1.assert(_this.garbageCollector !== null, 'GarbageCollector for query cache set to null during key removal.');
	                _this.garbageCollector.addPotentialGarbageKey(docKey);
	            });
	        }
	        else {
	            return persistence_promise_1.PersistencePromise.resolve();
	        }
	    };
	    IndexedDbQueryCache.prototype.getMatchingKeysForTargetId = function (txn, targetId) {
	        var promises = [];
	        var range = IDBKeyRange.bound([targetId], [targetId + 1], 
	        /*lowerOpen=*/ false, 
	        /*upperOpen=*/ true);
	        var store = documentTargetStore(txn);
	        var result = collections_1.documentKeySet();
	        return store
	            .iterate({ range: range, keysOnly: true }, function (key, _, control) {
	            var path = EncodedResourcePath.decode(key[1]);
	            var docKey = new document_key_1.DocumentKey(path);
	            result = result.add(docKey);
	        })
	            .next(function () { return result; });
	    };
	    IndexedDbQueryCache.prototype.setGarbageCollector = function (gc) {
	        this.garbageCollector = gc;
	    };
	    IndexedDbQueryCache.prototype.containsKey = function (txn, key) {
	        assert_1.assert(txn !== null, 'Persistence Transaction cannot be null for query cache containsKey');
	        var path = EncodedResourcePath.encode(key.path);
	        var range = IDBKeyRange.bound([path], [misc_1.immediateSuccessor(path)], 
	        /*lowerOpen=*/ false, 
	        /*upperOpen=*/ true);
	        var count = 0;
	        return documentTargetStore(txn)
	            .iterate({
	            index: indexeddb_schema_1.DbTargetDocument.documentTargetsIndex,
	            keysOnly: true,
	            range: range
	        }, function (key, _, control) {
	            count++;
	            control.done();
	        })
	            .next(function () { return count > 0; });
	    };
	    return IndexedDbQueryCache;
	}());
	exports.IndexedDbQueryCache = IndexedDbQueryCache;
	/**
	 * Helper to get a typed SimpleDbStore for the queries object store.
	 */
	function targetsStore(txn) {
	    return getStore(txn, indexeddb_schema_1.DbTarget.store);
	}
	/**
	 * Helper to get a typed SimpleDbStore for the target globals object store.
	 */
	function globalTargetStore(txn) {
	    return getStore(txn, indexeddb_schema_1.DbTargetGlobal.store);
	}
	/**
	 * Helper to get a typed SimpleDbStore for the document target object store.
	 */
	function documentTargetStore(txn) {
	    return getStore(txn, indexeddb_schema_1.DbTargetDocument.store);
	}
	/**
	 * Helper to get a typed SimpleDbStore from a transaction.
	 */
	function getStore(txn, store) {
	    if (txn instanceof simple_db_1.SimpleDbTransaction) {
	        return txn.store(store);
	    }
	    else {
	        return assert_1.fail('Invalid transaction object provided!');
	    }
	}
	
	//# sourceMappingURL=indexeddb_query_cache.js.map


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var collections_1 = __webpack_require__(20);
	var document_1 = __webpack_require__(32);
	var assert_1 = __webpack_require__(10);
	var indexeddb_schema_1 = __webpack_require__(56);
	var simple_db_1 = __webpack_require__(95);
	var IndexedDbRemoteDocumentCache = /** @class */ (function () {
	    function IndexedDbRemoteDocumentCache(serializer) {
	        this.serializer = serializer;
	    }
	    IndexedDbRemoteDocumentCache.prototype.addEntry = function (transaction, maybeDocument) {
	        return remoteDocumentsStore(transaction).put(dbKey(maybeDocument.key), this.serializer.toDbRemoteDocument(maybeDocument));
	    };
	    IndexedDbRemoteDocumentCache.prototype.removeEntry = function (transaction, documentKey) {
	        return remoteDocumentsStore(transaction).delete(dbKey(documentKey));
	    };
	    IndexedDbRemoteDocumentCache.prototype.getEntry = function (transaction, documentKey) {
	        var _this = this;
	        return remoteDocumentsStore(transaction)
	            .get(dbKey(documentKey))
	            .next(function (dbRemoteDoc) {
	            return dbRemoteDoc
	                ? _this.serializer.fromDbRemoteDocument(dbRemoteDoc)
	                : null;
	        });
	    };
	    IndexedDbRemoteDocumentCache.prototype.getDocumentsMatchingQuery = function (transaction, query) {
	        var _this = this;
	        var results = collections_1.documentMap();
	        // Documents are ordered by key, so we can use a prefix scan to narrow down
	        // the documents we need to match the query against.
	        var startKey = query.path.toArray();
	        var range = IDBKeyRange.lowerBound(startKey);
	        return remoteDocumentsStore(transaction)
	            .iterate({ range: range }, function (key, dbRemoteDoc, control) {
	            var maybeDoc = _this.serializer.fromDbRemoteDocument(dbRemoteDoc);
	            if (!query.path.isPrefixOf(maybeDoc.key.path)) {
	                control.done();
	            }
	            else if (maybeDoc instanceof document_1.Document && query.matches(maybeDoc)) {
	                results = results.insert(maybeDoc.key, maybeDoc);
	            }
	        })
	            .next(function () { return results; });
	    };
	    return IndexedDbRemoteDocumentCache;
	}());
	exports.IndexedDbRemoteDocumentCache = IndexedDbRemoteDocumentCache;
	/**
	 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
	 */
	function remoteDocumentsStore(txn) {
	    if (txn instanceof simple_db_1.SimpleDbTransaction) {
	        return txn.store(indexeddb_schema_1.DbRemoteDocument.store);
	    }
	    else {
	        return assert_1.fail('Invalid transaction object provided!');
	    }
	}
	function dbKey(docKey) {
	    return docKey.path.toArray();
	}
	
	//# sourceMappingURL=indexeddb_remote_document_cache.js.map


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var snapshot_version_1 = __webpack_require__(31);
	var collections_1 = __webpack_require__(20);
	var document_1 = __webpack_require__(32);
	var document_key_1 = __webpack_require__(22);
	var assert_1 = __webpack_require__(10);
	var persistence_promise_1 = __webpack_require__(29);
	/**
	 * A readonly view of the local state of all documents we're tracking (i.e. we
	 * have a cached version in remoteDocumentCache or local mutations for the
	 * document). The view is computed by applying the mutations in the
	 * MutationQueue to the RemoteDocumentCache.
	 */
	var LocalDocumentsView = /** @class */ (function () {
	    function LocalDocumentsView(remoteDocumentCache, mutationQueue) {
	        this.remoteDocumentCache = remoteDocumentCache;
	        this.mutationQueue = mutationQueue;
	    }
	    /**
	     * Get the local view of the document identified by `key`.
	     *
	     * @return Local view of the document or null if we don't have any cached
	     * state for it.
	     */
	    LocalDocumentsView.prototype.getDocument = function (transaction, key) {
	        var _this = this;
	        return this.remoteDocumentCache
	            .getEntry(transaction, key)
	            .next(function (remoteDoc) {
	            return _this.computeLocalDocument(transaction, key, remoteDoc);
	        });
	    };
	    /**
	     * Gets the local view of the documents identified by `keys`.
	     *
	     * If we don't have cached state for a document in `keys`, a NoDocument will
	     * be stored for that key in the resulting set.
	     */
	    LocalDocumentsView.prototype.getDocuments = function (transaction, keys) {
	        var _this = this;
	        var promises = [];
	        var results = collections_1.maybeDocumentMap();
	        keys.forEach(function (key) {
	            promises.push(_this.getDocument(transaction, key).next(function (maybeDoc) {
	                // TODO(http://b/32275378): Don't conflate missing / deleted.
	                if (!maybeDoc) {
	                    maybeDoc = new document_1.NoDocument(key, snapshot_version_1.SnapshotVersion.forDeletedDoc());
	                }
	                results = results.insert(key, maybeDoc);
	            }));
	        });
	        return persistence_promise_1.PersistencePromise.waitFor(promises).next(function () { return results; });
	    };
	    /** Performs a query against the local view of all documents. */
	    LocalDocumentsView.prototype.getDocumentsMatchingQuery = function (transaction, query) {
	        if (document_key_1.DocumentKey.isDocumentKey(query.path)) {
	            return this.getDocumentsMatchingDocumentQuery(transaction, query.path);
	        }
	        else {
	            return this.getDocumentsMatchingCollectionQuery(transaction, query);
	        }
	    };
	    LocalDocumentsView.prototype.getDocumentsMatchingDocumentQuery = function (transaction, docPath) {
	        // Just do a simple document lookup.
	        return this.getDocument(transaction, new document_key_1.DocumentKey(docPath)).next(function (maybeDoc) {
	            var result = collections_1.documentMap();
	            if (maybeDoc instanceof document_1.Document) {
	                result = result.insert(maybeDoc.key, maybeDoc);
	            }
	            return result;
	        });
	    };
	    LocalDocumentsView.prototype.getDocumentsMatchingCollectionQuery = function (transaction, query) {
	        var _this = this;
	        // Query the remote documents and overlay mutations.
	        // TODO(mikelehen): There may be significant overlap between the mutations
	        // affecting these remote documents and the
	        // getAllMutationBatchesAffectingQuery() mutations. Consider optimizing.
	        var results;
	        return this.remoteDocumentCache
	            .getDocumentsMatchingQuery(transaction, query)
	            .next(function (queryResults) {
	            return _this.computeLocalDocuments(transaction, queryResults);
	        })
	            .next(function (promisedResults) {
	            results = promisedResults;
	            // Now use the mutation queue to discover any other documents that may
	            // match the query after applying mutations.
	            return _this.mutationQueue.getAllMutationBatchesAffectingQuery(transaction, query);
	        })
	            .next(function (matchingMutationBatches) {
	            var matchingKeys = collections_1.documentKeySet();
	            for (var _i = 0, matchingMutationBatches_1 = matchingMutationBatches; _i < matchingMutationBatches_1.length; _i++) {
	                var batch = matchingMutationBatches_1[_i];
	                for (var _a = 0, _b = batch.mutations; _a < _b.length; _a++) {
	                    var mutation = _b[_a];
	                    // TODO(mikelehen): PERF: Check if this mutation actually
	                    // affects the query to reduce work.
	                    if (!results.get(mutation.key)) {
	                        matchingKeys = matchingKeys.add(mutation.key);
	                    }
	                }
	            }
	            // Now add in the results for the matchingKeys.
	            var promises = [];
	            matchingKeys.forEach(function (key) {
	                promises.push(_this.getDocument(transaction, key).next(function (doc) {
	                    if (doc instanceof document_1.Document) {
	                        results = results.insert(doc.key, doc);
	                    }
	                }));
	            });
	            return persistence_promise_1.PersistencePromise.waitFor(promises);
	        })
	            .next(function () {
	            // Finally, filter out any documents that don't actually match
	            // the query.
	            results.forEach(function (key, doc) {
	                if (!query.matches(doc)) {
	                    results = results.remove(key);
	                }
	            });
	            return results;
	        });
	    };
	    /**
	     * Takes a remote document and applies local mutations to generate the local
	     * view of the document.
	     * @param transaction The transaction in which to perform any persistence
	     *     operations.
	     * @param documentKey The key of the document (necessary when remoteDocument
	     *     is null).
	     * @param document The base remote document to apply mutations to or null.
	     */
	    LocalDocumentsView.prototype.computeLocalDocument = function (transaction, documentKey, document) {
	        return this.mutationQueue
	            .getAllMutationBatchesAffectingDocumentKey(transaction, documentKey)
	            .next(function (batches) {
	            for (var _i = 0, batches_1 = batches; _i < batches_1.length; _i++) {
	                var batch = batches_1[_i];
	                document = batch.applyToLocalView(documentKey, document);
	            }
	            return document;
	        });
	    };
	    /**
	     * Takes a set of remote documents and applies local mutations to generate the
	     * local view of the documents.
	     * @param transaction The transaction in which to perform any persistence
	     *     operations.
	     * @param documents The base remote documents to apply mutations to.
	     * @return The local view of the documents.
	     */
	    LocalDocumentsView.prototype.computeLocalDocuments = function (transaction, documents) {
	        var _this = this;
	        var promises = [];
	        documents.forEach(function (key, doc) {
	            promises.push(_this.computeLocalDocument(transaction, key, doc).next(function (mutatedDoc) {
	                if (mutatedDoc instanceof document_1.Document) {
	                    documents = documents.insert(mutatedDoc.key, mutatedDoc);
	                }
	                else if (mutatedDoc instanceof document_1.NoDocument) {
	                    documents = documents.remove(mutatedDoc.key);
	                }
	                else {
	                    assert_1.fail('Unknown MaybeDocument: ' + mutatedDoc);
	                }
	            }));
	        });
	        return persistence_promise_1.PersistencePromise.waitFor(promises).next(function () { return documents; });
	    };
	    return LocalDocumentsView;
	}());
	exports.LocalDocumentsView = LocalDocumentsView;
	
	//# sourceMappingURL=local_documents_view.js.map


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var snapshot_version_1 = __webpack_require__(31);
	var timestamp_1 = __webpack_require__(55);
	var document_1 = __webpack_require__(32);
	var document_key_1 = __webpack_require__(22);
	var mutation_batch_1 = __webpack_require__(70);
	var assert_1 = __webpack_require__(10);
	var indexeddb_schema_1 = __webpack_require__(56);
	var query_data_1 = __webpack_require__(69);
	/** Serializer for values stored in the LocalStore. */
	var LocalSerializer = /** @class */ (function () {
	    function LocalSerializer(remoteSerializer) {
	        this.remoteSerializer = remoteSerializer;
	    }
	    /** Decodes a remote document from storage locally to a Document. */
	    LocalSerializer.prototype.fromDbRemoteDocument = function (remoteDoc) {
	        if (remoteDoc.document) {
	            return this.remoteSerializer.fromDocument(remoteDoc.document);
	        }
	        else if (remoteDoc.noDocument) {
	            var key = document_key_1.DocumentKey.fromSegments(remoteDoc.noDocument.path);
	            var readTime = remoteDoc.noDocument.readTime;
	            var timestamp = new timestamp_1.Timestamp(readTime.seconds, readTime.nanos);
	            return new document_1.NoDocument(key, snapshot_version_1.SnapshotVersion.fromTimestamp(timestamp));
	        }
	        else {
	            return assert_1.fail('Unexpected DbRemoteDocument');
	        }
	    };
	    /** Encodes a document for storage locally. */
	    LocalSerializer.prototype.toDbRemoteDocument = function (maybeDoc) {
	        if (maybeDoc instanceof document_1.Document) {
	            var doc = this.remoteSerializer.toDocument(maybeDoc);
	            return new indexeddb_schema_1.DbRemoteDocument(null, doc);
	        }
	        else {
	            var path = maybeDoc.key.path.toArray();
	            var timestamp = maybeDoc.version.toTimestamp();
	            var readTime = new indexeddb_schema_1.DbTimestamp(timestamp.seconds, timestamp.nanos);
	            return new indexeddb_schema_1.DbRemoteDocument(new indexeddb_schema_1.DbNoDocument(path, readTime), null);
	        }
	    };
	    /** Encodes a batch of mutations into a DbMutationBatch for local storage. */
	    LocalSerializer.prototype.toDbMutationBatch = function (userId, batch) {
	        var _this = this;
	        var serializedMutations = batch.mutations.map(function (m) {
	            return _this.remoteSerializer.toMutation(m);
	        });
	        return new indexeddb_schema_1.DbMutationBatch(userId, batch.batchId, batch.localWriteTime.toEpochMilliseconds(), serializedMutations);
	    };
	    /** Decodes a DbMutationBatch into a MutationBatch */
	    LocalSerializer.prototype.fromDbMutationBatch = function (dbBatch) {
	        var _this = this;
	        var mutations = dbBatch.mutations.map(function (m) {
	            return _this.remoteSerializer.fromMutation(m);
	        });
	        var timestamp = timestamp_1.Timestamp.fromEpochMilliseconds(dbBatch.localWriteTimeMs);
	        return new mutation_batch_1.MutationBatch(dbBatch.batchId, timestamp, mutations);
	    };
	    /** Decodes a DbTarget into QueryData */
	    LocalSerializer.prototype.fromDbTarget = function (dbTarget) {
	        var readTime = new timestamp_1.Timestamp(dbTarget.readTime.seconds, dbTarget.readTime.nanos);
	        var version = snapshot_version_1.SnapshotVersion.fromTimestamp(readTime);
	        var query;
	        if (isDocumentQuery(dbTarget.query)) {
	            query = this.remoteSerializer.fromDocumentsTarget(dbTarget.query);
	        }
	        else {
	            query = this.remoteSerializer.fromQueryTarget(dbTarget.query);
	        }
	        return new query_data_1.QueryData(query, dbTarget.targetId, query_data_1.QueryPurpose.Listen, version, dbTarget.resumeToken);
	    };
	    /** Encodes QueryData into a DbTarget for storage locally. */
	    LocalSerializer.prototype.toDbTarget = function (queryData) {
	        assert_1.assert(query_data_1.QueryPurpose.Listen === queryData.purpose, 'Only queries with purpose ' +
	            query_data_1.QueryPurpose.Listen +
	            ' may be stored, got ' +
	            queryData.purpose);
	        var timestamp = queryData.snapshotVersion.toTimestamp();
	        var dbTimestamp = new indexeddb_schema_1.DbTimestamp(timestamp.seconds, timestamp.nanos);
	        var queryProto;
	        if (queryData.query.isDocumentQuery()) {
	            queryProto = this.remoteSerializer.toDocumentsTarget(queryData.query);
	        }
	        else {
	            queryProto = this.remoteSerializer.toQueryTarget(queryData.query);
	        }
	        assert_1.assert(typeof queryData.resumeToken === 'string', 'Persisting non-string resume token not supported.');
	        var resumeToken = queryData.resumeToken;
	        // lastListenSequenceNumber is always 0 until we do real GC.
	        return new indexeddb_schema_1.DbTarget(queryData.targetId, queryData.query.canonicalId(), dbTimestamp, resumeToken, 0, queryProto);
	    };
	    return LocalSerializer;
	}());
	exports.LocalSerializer = LocalSerializer;
	/**
	 * A helper function for figuring out what kind of query has been stored.
	 */
	function isDocumentQuery(dbQuery) {
	    return dbQuery.documents !== undefined;
	}
	
	//# sourceMappingURL=local_serializer.js.map


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var snapshot_version_1 = __webpack_require__(31);
	var target_id_generator_1 = __webpack_require__(191);
	var timestamp_1 = __webpack_require__(55);
	var collections_1 = __webpack_require__(20);
	var mutation_batch_1 = __webpack_require__(70);
	var remote_event_1 = __webpack_require__(71);
	var assert_1 = __webpack_require__(10);
	var log = __webpack_require__(24);
	var objUtils = __webpack_require__(36);
	var local_documents_view_1 = __webpack_require__(468);
	var persistence_promise_1 = __webpack_require__(29);
	var query_data_1 = __webpack_require__(69);
	var reference_set_1 = __webpack_require__(94);
	var remote_document_change_buffer_1 = __webpack_require__(477);
	var LOG_TAG = 'LocalStore';
	/**
	 * Local storage in the Firestore client. Coordinates persistence components
	 * like the mutation queue and remote document cache to present a
	 * latency-compensated view of stored data.
	 *
	 * The LocalStore is responsible for accepting mutations from the Sync Engine.
	 * Writes from the client are put into a queue as provisional Mutations until
	 * they are processed by the RemoteStore and confirmed as having been written
	 * to the server.
	 *
	 * The local store provides the local version of documents that have been
	 * modified locally. It maintains the constraint:
	 *
	 *   LocalDocument = RemoteDocument + Active(LocalMutations)
	 *
	 * (Active mutations are those that are enqueued and have not been previously
	 * acknowledged or rejected).
	 *
	 * The RemoteDocument ("ground truth") state is provided via the
	 * applyChangeBatch method. It will be some version of a server-provided
	 * document OR will be a server-provided document PLUS acknowledged mutations:
	 *
	 *   RemoteDocument' = RemoteDocument + Acknowledged(LocalMutations)
	 *
	 * Note that this "dirty" version of a RemoteDocument will not be identical to a
	 * server base version, since it has LocalMutations added to it pending getting
	 * an authoritative copy from the server.
	 *
	 * Since LocalMutations can be rejected by the server, we have to be able to
	 * revert a LocalMutation that has already been applied to the LocalDocument
	 * (typically done by replaying all remaining LocalMutations to the
	 * RemoteDocument to re-apply).
	 *
	 * The LocalStore is responsible for the garbage collection of the documents it
	 * contains. For now, it every doc referenced by a view, the mutation queue, or
	 * the RemoteStore.
	 *
	 * It also maintains the persistence of mapping queries to resume tokens and
	 * target ids. It needs to know this data about queries to properly know what
	 * docs it would be allowed to garbage collect.
	 *
	 * The LocalStore must be able to efficiently execute queries against its local
	 * cache of the documents, to provide the initial set of results before any
	 * remote changes have been received.
	 *
	 * Note: In TypeScript, most methods return Promises since the implementation
	 * may rely on fetching data from IndexedDB which is async.
	 * These Promises will only be rejected on an I/O error or other internal
	 * (unexpected) failure (e.g. failed assert) and always represent an
	 * unrecoverable error (should be caught / reported by the async_queue).
	 */
	var LocalStore = /** @class */ (function () {
	    function LocalStore(
	        /** Manages our in-memory or durable persistence. */
	        persistence, initialUser, 
	        /**
	         * The garbage collector collects documents that should no longer be
	         * cached (e.g. if they are no longer retained by the above reference sets
	         * and the garbage collector is performing eager collection).
	         */
	        garbageCollector) {
	        this.persistence = persistence;
	        this.garbageCollector = garbageCollector;
	        /**
	         * The set of document references maintained by any local views.
	         */
	        this.localViewReferences = new reference_set_1.ReferenceSet();
	        /** Maps a targetID to data about its query. */
	        this.targetIds = {};
	        /** Used to generate targetIDs for queries tracked locally. */
	        this.targetIdGenerator = target_id_generator_1.TargetIdGenerator.forLocalStore();
	        /**
	         * A heldBatchResult is a mutation batch result (from a write acknowledgement)
	         * that arrived before the watch stream got notified of a snapshot that
	         * includes the write. So we "hold" it until the watch stream catches up. It
	         * ensures that the local write remains visible (latency compensation) and
	         * doesn't temporarily appear reverted because the watch stream is slower than
	         * the write stream and so wasn't reflecting it.
	         *
	         * NOTE: Eventually we want to move this functionality into the remote store.
	         */
	        this.heldBatchResults = [];
	        this.mutationQueue = persistence.getMutationQueue(initialUser);
	        this.remoteDocuments = persistence.getRemoteDocumentCache();
	        this.queryCache = persistence.getQueryCache();
	        this.localDocuments = new local_documents_view_1.LocalDocumentsView(this.remoteDocuments, this.mutationQueue);
	        this.garbageCollector.addGarbageSource(this.localViewReferences);
	        this.garbageCollector.addGarbageSource(this.queryCache);
	        this.garbageCollector.addGarbageSource(this.mutationQueue);
	    }
	    /** Performs any initial startup actions required by the local store. */
	    LocalStore.prototype.start = function () {
	        var _this = this;
	        return this.persistence.runTransaction('Start LocalStore', function (txn) {
	            return _this.startMutationQueue(txn).next(function () { return _this.startQueryCache(txn); });
	        });
	    };
	    /**
	     * Tells the LocalStore that the currently authenticated user has changed.
	     *
	     * In response the local store switches the mutation queue to the new user and
	     * returns any resulting document changes.
	     */
	    LocalStore.prototype.handleUserChange = function (user) {
	        var _this = this;
	        return this.persistence.runTransaction('Handle user change', function (txn) {
	            // Swap out the mutation queue, grabbing the pending mutation batches
	            // before and after.
	            var oldBatches;
	            return _this.mutationQueue
	                .getAllMutationBatches(txn)
	                .next(function (promisedOldBatches) {
	                oldBatches = promisedOldBatches;
	                _this.garbageCollector.removeGarbageSource(_this.mutationQueue);
	                _this.mutationQueue = _this.persistence.getMutationQueue(user);
	                _this.garbageCollector.addGarbageSource(_this.mutationQueue);
	                return _this.startMutationQueue(txn);
	            })
	                .next(function () {
	                // Recreate our LocalDocumentsView using the new
	                // MutationQueue.
	                _this.localDocuments = new local_documents_view_1.LocalDocumentsView(_this.remoteDocuments, _this.mutationQueue);
	                return _this.mutationQueue.getAllMutationBatches(txn);
	            })
	                .next(function (newBatches) {
	                // Union the old/new changed keys.
	                var changedKeys = collections_1.documentKeySet();
	                for (var _i = 0, _a = [oldBatches, newBatches]; _i < _a.length; _i++) {
	                    var batches = _a[_i];
	                    for (var _b = 0, batches_1 = batches; _b < batches_1.length; _b++) {
	                        var batch = batches_1[_b];
	                        for (var _c = 0, _d = batch.mutations; _c < _d.length; _c++) {
	                            var mutation = _d[_c];
	                            changedKeys = changedKeys.add(mutation.key);
	                        }
	                    }
	                }
	                // Return the set of all (potentially) changed documents as the
	                // result of the user change.
	                return _this.localDocuments.getDocuments(txn, changedKeys);
	            });
	        });
	    };
	    LocalStore.prototype.startQueryCache = function (txn) {
	        var _this = this;
	        return this.queryCache.start(txn).next(function () {
	            var targetId = _this.queryCache.getHighestTargetId();
	            _this.targetIdGenerator = target_id_generator_1.TargetIdGenerator.forLocalStore(targetId);
	        });
	    };
	    LocalStore.prototype.startMutationQueue = function (txn) {
	        var _this = this;
	        return this.mutationQueue
	            .start(txn)
	            .next(function () {
	            // If we have any leftover mutation batch results from a prior run,
	            // just drop them.
	            // TODO(http://b/33446471): We probably need to repopulate
	            // heldBatchResults or similar instead, but that is not
	            // straightforward since we're not persisting the write ack versions.
	            _this.heldBatchResults = [];
	            return _this.mutationQueue.getHighestAcknowledgedBatchId(txn);
	        })
	            .next(function (highestAck) {
	            // TODO(mikelehen): This is the only usage of
	            // getAllMutationBatchesThroughBatchId(). Consider removing it in
	            // favor of a getAcknowledgedBatches() method.
	            if (highestAck !== mutation_batch_1.BATCHID_UNKNOWN) {
	                return _this.mutationQueue.getAllMutationBatchesThroughBatchId(txn, highestAck);
	            }
	            else {
	                return persistence_promise_1.PersistencePromise.resolve([]);
	            }
	        })
	            .next(function (ackedBatches) {
	            if (ackedBatches.length > 0) {
	                return _this.mutationQueue.removeMutationBatches(txn, ackedBatches);
	            }
	            else {
	                return persistence_promise_1.PersistencePromise.resolve();
	            }
	        });
	    };
	    /* Accept locally generated Mutations and commit them to storage. */
	    LocalStore.prototype.localWrite = function (mutations) {
	        var _this = this;
	        return this.persistence.runTransaction('Locally write mutations', function (txn) {
	            var batch;
	            var localWriteTime = timestamp_1.Timestamp.now();
	            return _this.mutationQueue
	                .addMutationBatch(txn, localWriteTime, mutations)
	                .next(function (promisedBatch) {
	                batch = promisedBatch;
	                // TODO(koss): This is doing an N^2 update by replaying ALL the
	                // mutations on each document (instead of just the ones added) in
	                // this batch.
	                var keys = batch.keys();
	                return _this.localDocuments.getDocuments(txn, keys);
	            })
	                .next(function (changedDocuments) {
	                return { batchId: batch.batchId, changes: changedDocuments };
	            });
	        });
	    };
	    /**
	     * Acknowledge the given batch.
	     *
	     * On the happy path when a batch is acknowledged, the local store will
	     *
	     *  + remove the batch from the mutation queue;
	     *  + apply the changes to the remote document cache;
	     *  + recalculate the latency compensated view implied by those changes (there
	     *    may be mutations in the queue that affect the documents but haven't been
	     *    acknowledged yet); and
	     *  + give the changed documents back the sync engine
	     *
	     * @returns The resulting (modified) documents.
	     */
	    LocalStore.prototype.acknowledgeBatch = function (batchResult) {
	        var _this = this;
	        return this.persistence.runTransaction('Acknowledge batch', function (txn) {
	            var affected;
	            return _this.mutationQueue
	                .acknowledgeBatch(txn, batchResult.batch, batchResult.streamToken)
	                .next(function () {
	                if (_this.shouldHoldBatchResult(batchResult.commitVersion)) {
	                    _this.heldBatchResults.push(batchResult);
	                    affected = collections_1.documentKeySet();
	                    return persistence_promise_1.PersistencePromise.resolve();
	                }
	                else {
	                    var documentBuffer_1 = new remote_document_change_buffer_1.RemoteDocumentChangeBuffer(_this.remoteDocuments);
	                    return _this.releaseBatchResults(txn, [batchResult], documentBuffer_1).next(function (promisedAffectedKeys) {
	                        affected = promisedAffectedKeys;
	                        return documentBuffer_1.apply(txn);
	                    });
	                }
	            })
	                .next(function () {
	                return _this.mutationQueue.performConsistencyCheck(txn);
	            })
	                .next(function () {
	                return _this.localDocuments.getDocuments(txn, affected);
	            });
	        });
	    };
	    /**
	     * Remove mutations from the MutationQueue for the specified batch;
	     * LocalDocuments will be recalculated.
	     *
	     * @returns The resulting modified documents.
	     */
	    LocalStore.prototype.rejectBatch = function (batchId) {
	        var _this = this;
	        return this.persistence.runTransaction('Reject batch', function (txn) {
	            var toReject;
	            var affectedKeys;
	            return _this.mutationQueue
	                .lookupMutationBatch(txn, batchId)
	                .next(function (promisedToReject) {
	                assert_1.assert(promisedToReject != null, 'Attempt to reject nonexistent batch!');
	                toReject = promisedToReject;
	                return _this.mutationQueue
	                    .getHighestAcknowledgedBatchId(txn)
	                    .next(function (lastAcked) {
	                    assert_1.assert(batchId > lastAcked, "Acknowledged batches can't be rejected.");
	                    return toReject;
	                });
	            })
	                .next(function () {
	                return _this.removeMutationBatch(txn, toReject);
	            })
	                .next(function (promisedAffectedKeys) {
	                affectedKeys = promisedAffectedKeys;
	                return _this.mutationQueue.performConsistencyCheck(txn);
	            })
	                .next(function () {
	                return _this.localDocuments.getDocuments(txn, affectedKeys);
	            });
	        });
	    };
	    /** Returns the last recorded stream token for the current user. */
	    LocalStore.prototype.getLastStreamToken = function () {
	        var _this = this;
	        return this.persistence.runTransaction('Get last stream token', function (txn) {
	            return _this.mutationQueue.getLastStreamToken(txn);
	        });
	    };
	    /**
	     * Sets the stream token for the current user without acknowledging any
	     * mutation batch. This is usually only useful after a stream handshake or in
	     * response to an error that requires clearing the stream token.
	     */
	    LocalStore.prototype.setLastStreamToken = function (streamToken) {
	        var _this = this;
	        return this.persistence.runTransaction('Set last stream token', function (txn) {
	            return _this.mutationQueue.setLastStreamToken(txn, streamToken);
	        });
	    };
	    /**
	     * Returns the last consistent snapshot processed (used by the RemoteStore to
	     * determine whether to buffer incoming snapshots from the backend).
	     */
	    LocalStore.prototype.getLastRemoteSnapshotVersion = function () {
	        return this.queryCache.getLastRemoteSnapshotVersion();
	    };
	    /**
	     * Update the "ground-state" (remote) documents. We assume that the remote
	     * event reflects any write batches that have been acknowledged or rejected
	     * (i.e. we do not re-apply local mutations to updates from this event).
	     *
	     * LocalDocuments are re-calculated if there are remaining mutations in the
	     * queue.
	     */
	    LocalStore.prototype.applyRemoteEvent = function (remoteEvent) {
	        var _this = this;
	        var documentBuffer = new remote_document_change_buffer_1.RemoteDocumentChangeBuffer(this.remoteDocuments);
	        return this.persistence.runTransaction('Apply remote event', function (txn) {
	            var promises = [];
	            objUtils.forEachNumber(remoteEvent.targetChanges, function (targetId, change) {
	                // Do not ref/unref unassigned targetIds - it may lead to leaks.
	                var queryData = _this.targetIds[targetId];
	                if (!queryData)
	                    return;
	                var mapping = change.mapping;
	                if (mapping) {
	                    // First make sure that all references are deleted
	                    if (mapping instanceof remote_event_1.ResetMapping) {
	                        promises.push(_this.queryCache
	                            .removeMatchingKeysForTargetId(txn, targetId)
	                            .next(function () {
	                            return _this.queryCache.addMatchingKeys(txn, mapping.documents, targetId);
	                        }));
	                    }
	                    else if (mapping instanceof remote_event_1.UpdateMapping) {
	                        promises.push(_this.queryCache
	                            .removeMatchingKeys(txn, mapping.removedDocuments, targetId)
	                            .next(function () {
	                            return _this.queryCache.addMatchingKeys(txn, mapping.addedDocuments, targetId);
	                        }));
	                    }
	                    else {
	                        return assert_1.fail('Unknown mapping type: ' + JSON.stringify(mapping));
	                    }
	                }
	                // Update the resume token if the change includes one. Don't clear
	                // any preexisting value.
	                var resumeToken = change.resumeToken;
	                if (resumeToken.length > 0) {
	                    queryData = queryData.update({
	                        resumeToken: resumeToken,
	                        snapshotVersion: change.snapshotVersion
	                    });
	                    _this.targetIds[targetId] = queryData;
	                    promises.push(_this.queryCache.addQueryData(txn, queryData));
	                }
	            });
	            var changedDocKeys = collections_1.documentKeySet();
	            remoteEvent.documentUpdates.forEach(function (key, doc) {
	                changedDocKeys = changedDocKeys.add(key);
	                promises.push(documentBuffer.getEntry(txn, key).next(function (existingDoc) {
	                    // Make sure we don't apply an old document version to the remote
	                    // cache, though we make an exception for SnapshotVersion.MIN which
	                    // can happen for manufactured events (e.g. in the case of a limbo
	                    // document resolution failing).
	                    if (existingDoc == null ||
	                        doc.version.equals(snapshot_version_1.SnapshotVersion.MIN) ||
	                        doc.version.compareTo(existingDoc.version) >= 0) {
	                        documentBuffer.addEntry(doc);
	                    }
	                    else {
	                        log.debug(LOG_TAG, 'Ignoring outdated watch update for ', key, '. Current version:', existingDoc.version, ' Watch version:', doc.version);
	                    }
	                    // The document might be garbage because it was unreferenced by
	                    // everything. Make sure to mark it as garbage if it is...
	                    _this.garbageCollector.addPotentialGarbageKey(key);
	                }));
	            });
	            // HACK: The only reason we allow a null snapshot version is so that we
	            // can synthesize remote events when we get permission denied errors while
	            // trying to resolve the state of a locally cached document that is in
	            // limbo.
	            var lastRemoteVersion = _this.queryCache.getLastRemoteSnapshotVersion();
	            var remoteVersion = remoteEvent.snapshotVersion;
	            if (!remoteVersion.equals(snapshot_version_1.SnapshotVersion.MIN)) {
	                assert_1.assert(remoteVersion.compareTo(lastRemoteVersion) >= 0, 'Watch stream reverted to previous snapshot?? ' +
	                    remoteVersion +
	                    ' < ' +
	                    lastRemoteVersion);
	                promises.push(_this.queryCache.setLastRemoteSnapshotVersion(txn, remoteVersion));
	            }
	            var releasedWriteKeys;
	            return persistence_promise_1.PersistencePromise.waitFor(promises)
	                .next(function () { return _this.releaseHeldBatchResults(txn, documentBuffer); })
	                .next(function (promisedReleasedWriteKeys) {
	                releasedWriteKeys = promisedReleasedWriteKeys;
	                return documentBuffer.apply(txn);
	            })
	                .next(function () {
	                return _this.localDocuments.getDocuments(txn, changedDocKeys.unionWith(releasedWriteKeys));
	            });
	        });
	    };
	    /**
	     * Notify local store of the changed views to locally pin documents.
	     */
	    LocalStore.prototype.notifyLocalViewChanges = function (viewChanges) {
	        var _this = this;
	        return this.persistence.runTransaction('Notify local view changes', function (txn) {
	            var promises = [];
	            var _loop_1 = function (view) {
	                promises.push(_this.queryCache
	                    .getQueryData(txn, view.query)
	                    .next(function (queryData) {
	                    assert_1.assert(queryData !== null, 'Local view changes contain unallocated query.');
	                    var targetId = queryData.targetId;
	                    _this.localViewReferences.addReferences(view.addedKeys, targetId);
	                    _this.localViewReferences.removeReferences(view.removedKeys, targetId);
	                }));
	            };
	            for (var _i = 0, viewChanges_1 = viewChanges; _i < viewChanges_1.length; _i++) {
	                var view = viewChanges_1[_i];
	                _loop_1(view);
	            }
	            return persistence_promise_1.PersistencePromise.waitFor(promises);
	        });
	    };
	    /**
	     * Gets the mutation batch after the passed in batchId in the mutation queue
	     * or null if empty.
	     * @param afterBatchId If provided, the batch to search after.
	     * @returns The next mutation or null if there wasn't one.
	     */
	    LocalStore.prototype.nextMutationBatch = function (afterBatchId) {
	        var _this = this;
	        return this.persistence.runTransaction('Get next mutation batch', function (txn) {
	            if (afterBatchId === undefined) {
	                afterBatchId = mutation_batch_1.BATCHID_UNKNOWN;
	            }
	            return _this.mutationQueue.getNextMutationBatchAfterBatchId(txn, afterBatchId);
	        });
	    };
	    /**
	     * Read the current value of a Document with a given key or null if not
	     * found - used for testing.
	     */
	    LocalStore.prototype.readDocument = function (key) {
	        var _this = this;
	        return this.persistence.runTransaction('read document', function (txn) {
	            return _this.localDocuments.getDocument(txn, key);
	        });
	    };
	    /**
	     * Assigns the given query an internal ID so that its results can be pinned so
	     * they don't get GC'd. A query must be allocated in the local store before
	     * the store can be used to manage its view.
	     */
	    LocalStore.prototype.allocateQuery = function (query) {
	        var _this = this;
	        return this.persistence.runTransaction('Allocate query', function (txn) {
	            var queryData;
	            return _this.queryCache
	                .getQueryData(txn, query)
	                .next(function (cached) {
	                if (cached) {
	                    // This query has been listened to previously, so reuse the
	                    // previous targetID.
	                    // TODO(mcg): freshen last accessed date?
	                    queryData = cached;
	                    return persistence_promise_1.PersistencePromise.resolve();
	                }
	                else {
	                    var targetId = _this.targetIdGenerator.next();
	                    queryData = new query_data_1.QueryData(query, targetId, query_data_1.QueryPurpose.Listen);
	                    return _this.queryCache.addQueryData(txn, queryData);
	                }
	            })
	                .next(function () {
	                assert_1.assert(!_this.targetIds[queryData.targetId], 'Tried to allocate an already allocated query: ' + query);
	                _this.targetIds[queryData.targetId] = queryData;
	                return queryData;
	            });
	        });
	    };
	    /** Unpin all the documents associated with the given query. */
	    LocalStore.prototype.releaseQuery = function (query) {
	        var _this = this;
	        return this.persistence.runTransaction('Release query', function (txn) {
	            return _this.queryCache
	                .getQueryData(txn, query)
	                .next(function (queryData) {
	                assert_1.assert(queryData != null, 'Tried to release nonexistent query: ' + query);
	                _this.localViewReferences.removeReferencesForId(queryData.targetId);
	                delete _this.targetIds[queryData.targetId];
	                if (_this.garbageCollector.isEager) {
	                    return _this.queryCache.removeQueryData(txn, queryData);
	                }
	                else {
	                    return persistence_promise_1.PersistencePromise.resolve();
	                }
	            })
	                .next(function () {
	                // If this was the last watch target, then we won't get any more
	                // watch snapshots, so we should release any held batch results.
	                if (objUtils.isEmpty(_this.targetIds)) {
	                    var documentBuffer_2 = new remote_document_change_buffer_1.RemoteDocumentChangeBuffer(_this.remoteDocuments);
	                    return _this.releaseHeldBatchResults(txn, documentBuffer_2).next(function () {
	                        documentBuffer_2.apply(txn);
	                    });
	                }
	                else {
	                    return persistence_promise_1.PersistencePromise.resolve();
	                }
	            });
	        });
	    };
	    /**
	     * Runs the specified query against all the documents in the local store and
	     * returns the results.
	     */
	    LocalStore.prototype.executeQuery = function (query) {
	        var _this = this;
	        return this.persistence.runTransaction('Execute query', function (txn) {
	            return _this.localDocuments.getDocumentsMatchingQuery(txn, query);
	        });
	    };
	    /**
	     * Returns the keys of the documents that are associated with the given
	     * target id in the remote table.
	     */
	    LocalStore.prototype.remoteDocumentKeys = function (targetId) {
	        var _this = this;
	        return this.persistence.runTransaction('Remote document keys', function (txn) {
	            return _this.queryCache.getMatchingKeysForTargetId(txn, targetId);
	        });
	    };
	    /**
	     * Collect garbage if necessary.
	     * Should be called periodically by Sync Engine to recover resources. The
	     * implementation must guarantee that GC won't happen in other places than
	     * this method call.
	     */
	    LocalStore.prototype.collectGarbage = function () {
	        var _this = this;
	        // Call collectGarbage regardless of whether isGCEnabled so the referenceSet
	        // doesn't continue to accumulate the garbage keys.
	        return this.persistence.runTransaction('Garbage collection', function (txn) {
	            return _this.garbageCollector.collectGarbage(txn).next(function (garbage) {
	                var promises = [];
	                garbage.forEach(function (key) {
	                    promises.push(_this.remoteDocuments.removeEntry(txn, key));
	                });
	                return persistence_promise_1.PersistencePromise.waitFor(promises);
	            });
	        });
	    };
	    LocalStore.prototype.releaseHeldBatchResults = function (txn, documentBuffer) {
	        var toRelease = [];
	        for (var _i = 0, _a = this.heldBatchResults; _i < _a.length; _i++) {
	            var batchResult = _a[_i];
	            if (!this.isRemoteUpToVersion(batchResult.commitVersion)) {
	                break;
	            }
	            toRelease.push(batchResult);
	        }
	        if (toRelease.length === 0) {
	            return persistence_promise_1.PersistencePromise.resolve(collections_1.documentKeySet());
	        }
	        else {
	            this.heldBatchResults.splice(0, toRelease.length);
	            return this.releaseBatchResults(txn, toRelease, documentBuffer);
	        }
	    };
	    LocalStore.prototype.isRemoteUpToVersion = function (version) {
	        // If there are no watch targets, then we won't get remote snapshots, and
	        // we are always "up-to-date."
	        var lastRemoteVersion = this.queryCache.getLastRemoteSnapshotVersion();
	        return (version.compareTo(lastRemoteVersion) <= 0 ||
	            objUtils.isEmpty(this.targetIds));
	    };
	    LocalStore.prototype.shouldHoldBatchResult = function (version) {
	        // Check if watcher isn't up to date or prior results are already held.
	        return (!this.isRemoteUpToVersion(version) || this.heldBatchResults.length > 0);
	    };
	    LocalStore.prototype.releaseBatchResults = function (txn, batchResults, documentBuffer) {
	        var _this = this;
	        var promiseChain = persistence_promise_1.PersistencePromise.resolve();
	        var _loop_2 = function (batchResult) {
	            promiseChain = promiseChain.next(function () {
	                return _this.applyWriteToRemoteDocuments(txn, batchResult, documentBuffer);
	            });
	        };
	        for (var _i = 0, batchResults_1 = batchResults; _i < batchResults_1.length; _i++) {
	            var batchResult = batchResults_1[_i];
	            _loop_2(batchResult);
	        }
	        return promiseChain.next(function () {
	            return _this.removeMutationBatches(txn, batchResults.map(function (result) { return result.batch; }));
	        });
	    };
	    LocalStore.prototype.removeMutationBatch = function (txn, batch) {
	        return this.removeMutationBatches(txn, [batch]);
	    };
	    /** Removes all the mutation batches named in the given array. */
	    LocalStore.prototype.removeMutationBatches = function (txn, batches) {
	        var affectedDocs = collections_1.documentKeySet();
	        for (var _i = 0, batches_2 = batches; _i < batches_2.length; _i++) {
	            var batch = batches_2[_i];
	            for (var _a = 0, _b = batch.mutations; _a < _b.length; _a++) {
	                var mutation = _b[_a];
	                var key = mutation.key;
	                affectedDocs = affectedDocs.add(key);
	            }
	        }
	        return this.mutationQueue
	            .removeMutationBatches(txn, batches)
	            .next(function () { return affectedDocs; });
	    };
	    LocalStore.prototype.applyWriteToRemoteDocuments = function (txn, batchResult, documentBuffer) {
	        var batch = batchResult.batch;
	        var docKeys = batch.keys();
	        var promiseChain = persistence_promise_1.PersistencePromise.resolve();
	        docKeys.forEach(function (docKey) {
	            promiseChain = promiseChain
	                .next(function () {
	                return documentBuffer.getEntry(txn, docKey);
	            })
	                .next(function (remoteDoc) {
	                var doc = remoteDoc;
	                var ackVersion = batchResult.docVersions.get(docKey);
	                assert_1.assert(ackVersion !== null, 'ackVersions should contain every doc in the write.');
	                if (!doc || doc.version.compareTo(ackVersion) < 0) {
	                    doc = batch.applyToRemoteDocument(docKey, doc, batchResult);
	                    if (!doc) {
	                        assert_1.assert(!remoteDoc, 'Mutation batch ' +
	                            batch +
	                            ' applied to document ' +
	                            remoteDoc +
	                            ' resulted in null');
	                    }
	                    else {
	                        documentBuffer.addEntry(doc);
	                    }
	                }
	            });
	        });
	        return promiseChain;
	    };
	    return LocalStore;
	}());
	exports.LocalStore = LocalStore;
	
	//# sourceMappingURL=local_store.js.map


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var view_snapshot_1 = __webpack_require__(93);
	var collections_1 = __webpack_require__(20);
	/**
	 * A set of changes to what documents are currently in view and out of view for
	 * a given query. These changes are sent to the LocalStore by the View (via
	 * the SyncEngine) and are used to pin / unpin documents as appropriate.
	 */
	var LocalViewChanges = /** @class */ (function () {
	    function LocalViewChanges(query, addedKeys, removedKeys) {
	        this.query = query;
	        this.addedKeys = addedKeys;
	        this.removedKeys = removedKeys;
	    }
	    LocalViewChanges.fromSnapshot = function (viewSnapshot) {
	        var addedKeys = collections_1.documentKeySet();
	        var removedKeys = collections_1.documentKeySet();
	        for (var _i = 0, _a = viewSnapshot.docChanges; _i < _a.length; _i++) {
	            var docChange = _a[_i];
	            switch (docChange.type) {
	                case view_snapshot_1.ChangeType.Added:
	                    addedKeys = addedKeys.add(docChange.doc.key);
	                    break;
	                case view_snapshot_1.ChangeType.Removed:
	                    removedKeys = removedKeys.add(docChange.doc.key);
	                    break;
	                default:
	            }
	        }
	        return new LocalViewChanges(viewSnapshot.query, addedKeys, removedKeys);
	    };
	    return LocalViewChanges;
	}());
	exports.LocalViewChanges = LocalViewChanges;
	
	//# sourceMappingURL=local_view_changes.js.map


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var document_key_1 = __webpack_require__(22);
	var mutation_batch_1 = __webpack_require__(70);
	var platform_1 = __webpack_require__(40);
	var assert_1 = __webpack_require__(10);
	var misc_1 = __webpack_require__(25);
	var sorted_set_1 = __webpack_require__(97);
	var persistence_promise_1 = __webpack_require__(29);
	var reference_set_1 = __webpack_require__(94);
	var MemoryMutationQueue = /** @class */ (function () {
	    function MemoryMutationQueue() {
	        /**
	         * The set of all mutations that have been sent but not yet been applied to
	         * the backend.
	         */
	        this.mutationQueue = [];
	        /** Next value to use when assigning sequential IDs to each mutation batch. */
	        this.nextBatchId = 1;
	        /** The highest acknowledged mutation in the queue. */
	        this.highestAcknowledgedBatchId = mutation_batch_1.BATCHID_UNKNOWN;
	        /** The last received stream token from the server, used to acknowledge which
	         * responses the client has processed. Stream tokens are opaque checkpoint
	         * markers whose only real value is their inclusion in the next request.
	         */
	        this.lastStreamToken = platform_1.emptyByteString();
	        /** The garbage collector to notify about potential garbage keys. */
	        this.garbageCollector = null;
	        /** An ordered mapping between documents and the mutations batch IDs. */
	        this.batchesByDocumentKey = new sorted_set_1.SortedSet(reference_set_1.DocReference.compareByKey);
	    }
	    MemoryMutationQueue.prototype.start = function (transaction) {
	        // NOTE: The queue may be shutdown / started multiple times, since we
	        // maintain the queue for the duration of the app session in case a user
	        // logs out / back in. To behave like the LevelDB-backed MutationQueue (and
	        // accommodate tests that expect as much), we reset nextBatchId and
	        // highestAcknowledgedBatchId if the queue is empty.
	        if (this.mutationQueue.length === 0) {
	            this.nextBatchId = 1;
	            this.highestAcknowledgedBatchId = mutation_batch_1.BATCHID_UNKNOWN;
	        }
	        assert_1.assert(this.highestAcknowledgedBatchId < this.nextBatchId, 'highestAcknowledgedBatchId must be less than the nextBatchId');
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryMutationQueue.prototype.checkEmpty = function (transaction) {
	        return persistence_promise_1.PersistencePromise.resolve(this.mutationQueue.length === 0);
	    };
	    MemoryMutationQueue.prototype.getNextBatchId = function (transaction) {
	        return persistence_promise_1.PersistencePromise.resolve(this.nextBatchId);
	    };
	    MemoryMutationQueue.prototype.getHighestAcknowledgedBatchId = function (transaction) {
	        return persistence_promise_1.PersistencePromise.resolve(this.highestAcknowledgedBatchId);
	    };
	    MemoryMutationQueue.prototype.acknowledgeBatch = function (transaction, batch, streamToken) {
	        var batchId = batch.batchId;
	        assert_1.assert(batchId > this.highestAcknowledgedBatchId, 'Mutation batchIDs must be acknowledged in order');
	        var batchIndex = this.indexOfExistingBatchId(batchId, 'acknowledged');
	        // Verify that the batch in the queue is the one to be acknowledged.
	        var check = this.mutationQueue[batchIndex];
	        assert_1.assert(batchId === check.batchId, 'Queue ordering failure: expected batch ' +
	            batchId +
	            ', got batch ' +
	            check.batchId);
	        assert_1.assert(!check.isTombstone(), "Can't acknowledge a previously removed batch");
	        this.highestAcknowledgedBatchId = batchId;
	        this.lastStreamToken = streamToken;
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryMutationQueue.prototype.getLastStreamToken = function (transaction) {
	        return persistence_promise_1.PersistencePromise.resolve(this.lastStreamToken);
	    };
	    MemoryMutationQueue.prototype.setLastStreamToken = function (transaction, streamToken) {
	        this.lastStreamToken = streamToken;
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryMutationQueue.prototype.addMutationBatch = function (transaction, localWriteTime, mutations) {
	        assert_1.assert(mutations.length !== 0, 'Mutation batches should not be empty');
	        var batchId = this.nextBatchId;
	        this.nextBatchId++;
	        if (this.mutationQueue.length > 0) {
	            var prior = this.mutationQueue[this.mutationQueue.length - 1];
	            assert_1.assert(prior.batchId < batchId, 'Mutation batchIDs must be monotonically increasing order');
	        }
	        var batch = new mutation_batch_1.MutationBatch(batchId, localWriteTime, mutations);
	        this.mutationQueue.push(batch);
	        // Track references by document key.
	        for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
	            var mutation = mutations_1[_i];
	            this.batchesByDocumentKey = this.batchesByDocumentKey.add(new reference_set_1.DocReference(mutation.key, batchId));
	        }
	        return persistence_promise_1.PersistencePromise.resolve(batch);
	    };
	    MemoryMutationQueue.prototype.lookupMutationBatch = function (transaction, batchId) {
	        return persistence_promise_1.PersistencePromise.resolve(this.findMutationBatch(batchId));
	    };
	    MemoryMutationQueue.prototype.getNextMutationBatchAfterBatchId = function (transaction, batchId) {
	        var size = this.mutationQueue.length;
	        // All batches with batchId <= this.highestAcknowledgedBatchId have been
	        // acknowledged so the first unacknowledged batch after batchID will have a
	        // batchID larger than both of these values.
	        batchId = Math.max(batchId + 1, this.highestAcknowledgedBatchId);
	        // The requested batchId may still be out of range so normalize it to the
	        // start of the queue.
	        var rawIndex = this.indexOfBatchId(batchId);
	        var index = rawIndex < 0 ? 0 : rawIndex;
	        // Finally return the first non-tombstone batch.
	        for (; index < size; index++) {
	            var batch = this.mutationQueue[index];
	            if (!batch.isTombstone()) {
	                return persistence_promise_1.PersistencePromise.resolve(batch);
	            }
	        }
	        return persistence_promise_1.PersistencePromise.resolve(null);
	    };
	    MemoryMutationQueue.prototype.getAllMutationBatches = function (transaction) {
	        return persistence_promise_1.PersistencePromise.resolve(this.getAllLiveMutationBatchesBeforeIndex(this.mutationQueue.length));
	    };
	    MemoryMutationQueue.prototype.getAllMutationBatchesThroughBatchId = function (transaction, batchId) {
	        var count = this.mutationQueue.length;
	        var endIndex = this.indexOfBatchId(batchId);
	        if (endIndex < 0) {
	            endIndex = 0;
	        }
	        else if (endIndex >= count) {
	            endIndex = count;
	        }
	        else {
	            // The endIndex is in the queue so increment to pull everything in the
	            // queue including it.
	            endIndex++;
	        }
	        return persistence_promise_1.PersistencePromise.resolve(this.getAllLiveMutationBatchesBeforeIndex(endIndex));
	    };
	    MemoryMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKey = function (transaction, documentKey) {
	        var _this = this;
	        var start = new reference_set_1.DocReference(documentKey, 0);
	        var end = new reference_set_1.DocReference(documentKey, Number.POSITIVE_INFINITY);
	        var result = [];
	        this.batchesByDocumentKey.forEachInRange([start, end], function (ref) {
	            assert_1.assert(documentKey.equals(ref.key), "Should only iterate over a single key's batches");
	            var batch = _this.findMutationBatch(ref.targetOrBatchId);
	            assert_1.assert(batch !== null, 'Batches in the index must exist in the main table');
	            result.push(batch);
	        });
	        return persistence_promise_1.PersistencePromise.resolve(result);
	    };
	    MemoryMutationQueue.prototype.getAllMutationBatchesAffectingQuery = function (transaction, query) {
	        var _this = this;
	        // Use the query path as a prefix for testing if a document matches the
	        // query.
	        var prefix = query.path;
	        var immediateChildrenPathLength = prefix.length + 1;
	        // Construct a document reference for actually scanning the index. Unlike
	        // the prefix the document key in this reference must have an even number of
	        // segments. The empty segment can be used a suffix of the query path
	        // because it precedes all other segments in an ordered traversal.
	        var startPath = prefix;
	        if (!document_key_1.DocumentKey.isDocumentKey(startPath)) {
	            startPath = startPath.child('');
	        }
	        var start = new reference_set_1.DocReference(new document_key_1.DocumentKey(startPath), 0);
	        // Find unique batchIDs referenced by all documents potentially matching the
	        // query.
	        var uniqueBatchIDs = new sorted_set_1.SortedSet(misc_1.primitiveComparator);
	        this.batchesByDocumentKey.forEachWhile(function (ref) {
	            var rowKeyPath = ref.key.path;
	            if (!prefix.isPrefixOf(rowKeyPath)) {
	                return false;
	            }
	            else {
	                // Rows with document keys more than one segment longer than the query
	                // path can't be matches. For example, a query on 'rooms' can't match
	                // the document /rooms/abc/messages/xyx.
	                // TODO(mcg): we'll need a different scanner when we implement
	                // ancestor queries.
	                if (rowKeyPath.length === immediateChildrenPathLength) {
	                    uniqueBatchIDs = uniqueBatchIDs.add(ref.targetOrBatchId);
	                }
	                return true;
	            }
	        }, start);
	        // Construct an array of matching batches, sorted by batchID to ensure that
	        // multiple mutations affecting the same document key are applied in order.
	        var result = [];
	        uniqueBatchIDs.forEach(function (batchId) {
	            var batch = _this.findMutationBatch(batchId);
	            if (batch !== null) {
	                result.push(batch);
	            }
	        });
	        return persistence_promise_1.PersistencePromise.resolve(result);
	    };
	    MemoryMutationQueue.prototype.removeMutationBatches = function (transaction, batches) {
	        var batchCount = batches.length;
	        assert_1.assert(batchCount > 0, 'Should not remove mutations when none exist.');
	        var firstBatchId = batches[0].batchId;
	        var queueCount = this.mutationQueue.length;
	        // Find the position of the first batch for removal. This need not be the
	        // first entry in the queue.
	        var startIndex = this.indexOfExistingBatchId(firstBatchId, 'removed');
	        assert_1.assert(this.mutationQueue[startIndex].batchId === firstBatchId, 'Removed batches must exist in the queue');
	        // Check that removed batches are contiguous (while excluding tombstones).
	        var batchIndex = 1;
	        var queueIndex = startIndex + 1;
	        while (batchIndex < batchCount && queueIndex < queueCount) {
	            var batch = this.mutationQueue[queueIndex];
	            if (batch.isTombstone()) {
	                queueIndex++;
	                continue;
	            }
	            assert_1.assert(batch.batchId === batches[batchIndex].batchId, 'Removed batches must be contiguous in the queue');
	            batchIndex++;
	            queueIndex++;
	        }
	        // Only actually remove batches if removing at the front of the queue.
	        // Previously rejected batches may have left tombstones in the queue, so
	        // expand the removal range to include any tombstones.
	        if (startIndex === 0) {
	            for (; queueIndex < queueCount; queueIndex++) {
	                var batch = this.mutationQueue[queueIndex];
	                if (!batch.isTombstone()) {
	                    break;
	                }
	            }
	            var length_1 = queueIndex - startIndex;
	            this.mutationQueue.splice(startIndex, length_1);
	        }
	        else {
	            // Mark the tombstones
	            for (var i = startIndex; i < queueIndex; i++) {
	                this.mutationQueue[i] = this.mutationQueue[i].toTombstone();
	            }
	        }
	        var references = this.batchesByDocumentKey;
	        for (var _i = 0, batches_1 = batches; _i < batches_1.length; _i++) {
	            var batch = batches_1[_i];
	            var batchId = batch.batchId;
	            for (var _a = 0, _b = batch.mutations; _a < _b.length; _a++) {
	                var mutation = _b[_a];
	                var key = mutation.key;
	                if (this.garbageCollector !== null) {
	                    this.garbageCollector.addPotentialGarbageKey(key);
	                }
	                var ref = new reference_set_1.DocReference(key, batchId);
	                references = references.delete(ref);
	            }
	        }
	        this.batchesByDocumentKey = references;
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryMutationQueue.prototype.setGarbageCollector = function (garbageCollector) {
	        this.garbageCollector = garbageCollector;
	    };
	    MemoryMutationQueue.prototype.containsKey = function (txn, key) {
	        var ref = new reference_set_1.DocReference(key, 0);
	        var firstRef = this.batchesByDocumentKey.firstAfterOrEqual(ref);
	        return persistence_promise_1.PersistencePromise.resolve(key.equals(firstRef && firstRef.key));
	    };
	    MemoryMutationQueue.prototype.performConsistencyCheck = function (txn) {
	        if (this.mutationQueue.length === 0) {
	            assert_1.assert(this.batchesByDocumentKey.isEmpty(), 'Document leak -- detected dangling mutation references when queue is empty.');
	        }
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    /**
	     * A private helper that collects all the mutations batches in the queue up to
	     * but not including the given endIndex. All tombstones in the queue are
	     * excluded.
	     */
	    MemoryMutationQueue.prototype.getAllLiveMutationBatchesBeforeIndex = function (endIndex) {
	        var result = [];
	        for (var i = 0; i < endIndex; i++) {
	            var batch = this.mutationQueue[i];
	            if (!batch.isTombstone()) {
	                result.push(batch);
	            }
	        }
	        return result;
	    };
	    /**
	     * Finds the index of the given batchId in the mutation queue and asserts that
	     * the resulting index is within the bounds of the queue.
	     *
	     * @param batchId The batchId to search for
	     * @param action A description of what the caller is doing, phrased in passive
	     * form (e.g. "acknowledged" in a routine that acknowledges batches).
	     */
	    MemoryMutationQueue.prototype.indexOfExistingBatchId = function (batchId, action) {
	        var index = this.indexOfBatchId(batchId);
	        assert_1.assert(index >= 0 && index < this.mutationQueue.length, 'Batches must exist to be ' + action);
	        return index;
	    };
	    /**
	     * Finds the index of the given batchId in the mutation queue. This operation
	     * is O(1).
	     *
	     * @return The computed index of the batch with the given batchId, based on
	     * the state of the queue. Note this index can be negative if the requested
	     * batchId has already been remvoed from the queue or past the end of the
	     * queue if the batchId is larger than the last added batch.
	     */
	    MemoryMutationQueue.prototype.indexOfBatchId = function (batchId) {
	        if (this.mutationQueue.length === 0) {
	            // As an index this is past the end of the queue
	            return 0;
	        }
	        // Examine the front of the queue to figure out the difference between the
	        // batchId and indexes in the array. Note that since the queue is ordered
	        // by batchId, if the first batch has a larger batchId then the requested
	        // batchId doesn't exist in the queue.
	        var firstBatchId = this.mutationQueue[0].batchId;
	        return batchId - firstBatchId;
	    };
	    /**
	     * A version of lookupMutationBatch that doesn't return a promise, this makes
	     * other functions that uses this code easier to read and more efficent.
	     */
	    MemoryMutationQueue.prototype.findMutationBatch = function (batchId) {
	        var index = this.indexOfBatchId(batchId);
	        if (index < 0 || index >= this.mutationQueue.length) {
	            return null;
	        }
	        var batch = this.mutationQueue[index];
	        assert_1.assert(batch.batchId === batchId, 'If found batch must match');
	        return batch.isTombstone() ? null : batch;
	    };
	    return MemoryMutationQueue;
	}());
	exports.MemoryMutationQueue = MemoryMutationQueue;
	
	//# sourceMappingURL=memory_mutation_queue.js.map


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(10);
	var log_1 = __webpack_require__(24);
	var memory_mutation_queue_1 = __webpack_require__(472);
	var memory_query_cache_1 = __webpack_require__(474);
	var memory_remote_document_cache_1 = __webpack_require__(475);
	var LOG_TAG = 'MemoryPersistence';
	/**
	 * A memory-backed instance of Persistence. Data is stored only in RAM and
	 * not persisted across sessions.
	 */
	var MemoryPersistence = /** @class */ (function () {
	    function MemoryPersistence() {
	        /**
	         * Note that these are retained here to make it easier to write tests
	         * affecting both the in-memory and IndexedDB-backed persistence layers. Tests
	         * can create a new LocalStore wrapping this Persistence instance and this
	         * will make the in-memory persistence layer behave as if it were actually
	         * persisting values.
	         */
	        this.mutationQueues = {};
	        this.remoteDocumentCache = new memory_remote_document_cache_1.MemoryRemoteDocumentCache();
	        this.queryCache = new memory_query_cache_1.MemoryQueryCache();
	        this.started = false;
	    }
	    MemoryPersistence.prototype.start = function () {
	        assert_1.assert(!this.started, 'MemoryPersistence double-started!');
	        this.started = true;
	        // No durable state to read on startup.
	        return Promise.resolve();
	    };
	    MemoryPersistence.prototype.shutdown = function () {
	        // No durable state to ensure is closed on shutdown.
	        assert_1.assert(this.started, 'MemoryPersistence shutdown without start!');
	        this.started = false;
	        return Promise.resolve();
	    };
	    MemoryPersistence.prototype.getMutationQueue = function (user) {
	        var queue = this.mutationQueues[user.toKey()];
	        if (!queue) {
	            queue = new memory_mutation_queue_1.MemoryMutationQueue();
	            this.mutationQueues[user.toKey()] = queue;
	        }
	        return queue;
	    };
	    MemoryPersistence.prototype.getQueryCache = function () {
	        return this.queryCache;
	    };
	    MemoryPersistence.prototype.getRemoteDocumentCache = function () {
	        return this.remoteDocumentCache;
	    };
	    MemoryPersistence.prototype.runTransaction = function (action, operation) {
	        log_1.debug(LOG_TAG, 'Starting transaction:', action);
	        return operation(new MemoryPersistenceTransaction()).toPromise();
	    };
	    return MemoryPersistence;
	}());
	exports.MemoryPersistence = MemoryPersistence;
	/** Dummy class since memory persistence doesn't actually use transactions. */
	var MemoryPersistenceTransaction = /** @class */ (function () {
	    function MemoryPersistenceTransaction() {
	    }
	    return MemoryPersistenceTransaction;
	}());
	
	//# sourceMappingURL=memory_persistence.js.map


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var snapshot_version_1 = __webpack_require__(31);
	var obj_map_1 = __webpack_require__(129);
	var persistence_promise_1 = __webpack_require__(29);
	var reference_set_1 = __webpack_require__(94);
	var MemoryQueryCache = /** @class */ (function () {
	    function MemoryQueryCache() {
	        /**
	         * Maps a query to the data about that query
	         */
	        this.queries = new obj_map_1.ObjectMap(function (q) { return q.canonicalId(); });
	        /** The last received snapshot version. */
	        this.lastRemoteSnapshotVersion = snapshot_version_1.SnapshotVersion.MIN;
	        /** The highest numbered target ID encountered. */
	        this.highestTargetId = 0;
	        /**
	         * A ordered bidirectional mapping between documents and the remote target
	         * IDs.
	         */
	        this.references = new reference_set_1.ReferenceSet();
	    }
	    MemoryQueryCache.prototype.start = function (transaction) {
	        // Nothing to do.
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryQueryCache.prototype.getLastRemoteSnapshotVersion = function () {
	        return this.lastRemoteSnapshotVersion;
	    };
	    MemoryQueryCache.prototype.getHighestTargetId = function () {
	        return this.highestTargetId;
	    };
	    MemoryQueryCache.prototype.setLastRemoteSnapshotVersion = function (transaction, snapshotVersion) {
	        this.lastRemoteSnapshotVersion = snapshotVersion;
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryQueryCache.prototype.addQueryData = function (transaction, queryData) {
	        this.queries.set(queryData.query, queryData);
	        var targetId = queryData.targetId;
	        if (targetId > this.highestTargetId) {
	            this.highestTargetId = targetId;
	        }
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryQueryCache.prototype.removeQueryData = function (transaction, queryData) {
	        this.queries.delete(queryData.query);
	        this.references.removeReferencesForId(queryData.targetId);
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryQueryCache.prototype.getQueryData = function (transaction, query) {
	        var queryData = this.queries.get(query) || null;
	        return persistence_promise_1.PersistencePromise.resolve(queryData);
	    };
	    MemoryQueryCache.prototype.addMatchingKeys = function (txn, keys, targetId) {
	        this.references.addReferences(keys, targetId);
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryQueryCache.prototype.removeMatchingKeys = function (txn, keys, targetId) {
	        this.references.removeReferences(keys, targetId);
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryQueryCache.prototype.removeMatchingKeysForTargetId = function (txn, targetId) {
	        this.references.removeReferencesForId(targetId);
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryQueryCache.prototype.getMatchingKeysForTargetId = function (txn, targetId) {
	        var matchingKeys = this.references.referencesForId(targetId);
	        return persistence_promise_1.PersistencePromise.resolve(matchingKeys);
	    };
	    MemoryQueryCache.prototype.setGarbageCollector = function (gc) {
	        this.references.setGarbageCollector(gc);
	    };
	    MemoryQueryCache.prototype.containsKey = function (txn, key) {
	        return this.references.containsKey(txn, key);
	    };
	    return MemoryQueryCache;
	}());
	exports.MemoryQueryCache = MemoryQueryCache;
	
	//# sourceMappingURL=memory_query_cache.js.map


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var collections_1 = __webpack_require__(20);
	var document_1 = __webpack_require__(32);
	var document_key_1 = __webpack_require__(22);
	var persistence_promise_1 = __webpack_require__(29);
	var MemoryRemoteDocumentCache = /** @class */ (function () {
	    function MemoryRemoteDocumentCache() {
	        this.docs = collections_1.maybeDocumentMap();
	    }
	    MemoryRemoteDocumentCache.prototype.addEntry = function (transaction, maybeDocument) {
	        this.docs = this.docs.insert(maybeDocument.key, maybeDocument);
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryRemoteDocumentCache.prototype.removeEntry = function (transaction, documentKey) {
	        this.docs = this.docs.remove(documentKey);
	        return persistence_promise_1.PersistencePromise.resolve();
	    };
	    MemoryRemoteDocumentCache.prototype.getEntry = function (transaction, documentKey) {
	        return persistence_promise_1.PersistencePromise.resolve(this.docs.get(documentKey));
	    };
	    MemoryRemoteDocumentCache.prototype.getDocumentsMatchingQuery = function (transaction, query) {
	        var results = collections_1.documentMap();
	        // Documents are ordered by key, so we can use a prefix scan to narrow down
	        // the documents we need to match the query against.
	        var prefix = new document_key_1.DocumentKey(query.path.child(''));
	        var iterator = this.docs.getIteratorFrom(prefix);
	        while (iterator.hasNext()) {
	            var _a = iterator.getNext(), key = _a.key, maybeDoc = _a.value;
	            if (!query.path.isPrefixOf(key.path)) {
	                break;
	            }
	            if (maybeDoc instanceof document_1.Document && query.matches(maybeDoc)) {
	                results = results.insert(maybeDoc.key, maybeDoc);
	            }
	        }
	        return persistence_promise_1.PersistencePromise.resolve(results);
	    };
	    return MemoryRemoteDocumentCache;
	}());
	exports.MemoryRemoteDocumentCache = MemoryRemoteDocumentCache;
	
	//# sourceMappingURL=memory_remote_document_cache.js.map


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var collections_1 = __webpack_require__(20);
	var persistence_promise_1 = __webpack_require__(29);
	/**
	 * A garbage collector implementation that does absolutely nothing. It ignores
	 * all addGarbageSource and addPotentialGarbageKey messages and and never
	 * produces any garbage.
	 */
	var NoOpGarbageCollector = /** @class */ (function () {
	    function NoOpGarbageCollector() {
	        this.isEager = false;
	    }
	    NoOpGarbageCollector.prototype.addGarbageSource = function (garbageSource) {
	        // Not tracking garbage so don't track sources.
	    };
	    NoOpGarbageCollector.prototype.removeGarbageSource = function (garbageSource) {
	        // Not tracking garbage so don't track sources.
	    };
	    NoOpGarbageCollector.prototype.addPotentialGarbageKey = function (key) {
	        // Not tracking garbage so ignore.
	    };
	    NoOpGarbageCollector.prototype.collectGarbage = function (txn) {
	        return persistence_promise_1.PersistencePromise.resolve(collections_1.documentKeySet());
	    };
	    return NoOpGarbageCollector;
	}());
	exports.NoOpGarbageCollector = NoOpGarbageCollector;
	
	//# sourceMappingURL=no_op_garbage_collector.js.map


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var collections_1 = __webpack_require__(20);
	var assert_1 = __webpack_require__(10);
	var persistence_promise_1 = __webpack_require__(29);
	/**
	 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
	 * It can be used to batch up a set of changes to be written to the cache, but
	 * additionally supports reading entries back with the `getEntry()` method,
	 * falling back to the underlying RemoteDocumentCache if no entry is
	 * buffered.
	 *
	 * NOTE: This class was introduced in iOS to work around a limitation in
	 * LevelDB. Given IndexedDb has full transaction support with
	 * read-your-own-writes capability, this class is not technically needed, but
	 * has been preserved as a convenience and to aid portability.
	 */
	var RemoteDocumentChangeBuffer = /** @class */ (function () {
	    function RemoteDocumentChangeBuffer(remoteDocumentCache) {
	        this.remoteDocumentCache = remoteDocumentCache;
	        this.changes = collections_1.maybeDocumentMap();
	    }
	    /** Buffers a `RemoteDocumentCache.addEntry()` call. */
	    RemoteDocumentChangeBuffer.prototype.addEntry = function (maybeDocument) {
	        var changes = this.assertChanges();
	        this.changes = changes.insert(maybeDocument.key, maybeDocument);
	    };
	    // NOTE: removeEntry() is not presently necessary and so is omitted.
	    /**
	     * Looks up an entry in the cache. The buffered changes will first be checked,
	     * and if no buffered change applies, this will forward to
	     * `RemoteDocumentCache.getEntry()`.
	     *
	     * @param transaction The transaction in which to perform any persistence
	     *     operations.
	     * @param documentKey The key of the entry to look up.
	     * @return The cached Document or NoDocument entry, or null if we have nothing
	     * cached.
	     */
	    RemoteDocumentChangeBuffer.prototype.getEntry = function (transaction, documentKey) {
	        var changes = this.assertChanges();
	        var bufferedEntry = changes.get(documentKey);
	        if (bufferedEntry) {
	            return persistence_promise_1.PersistencePromise.resolve(bufferedEntry);
	        }
	        else {
	            return this.remoteDocumentCache.getEntry(transaction, documentKey);
	        }
	    };
	    /**
	     * Applies buffered changes to the underlying RemoteDocumentCache, using
	     * the provided transaction.
	     */
	    RemoteDocumentChangeBuffer.prototype.apply = function (transaction) {
	        var _this = this;
	        var changes = this.assertChanges();
	        var promises = [];
	        changes.forEach(function (key, maybeDoc) {
	            promises.push(_this.remoteDocumentCache.addEntry(transaction, maybeDoc));
	        });
	        // We should not be used to buffer any more changes.
	        this.changes = null;
	        return persistence_promise_1.PersistencePromise.waitFor(promises);
	    };
	    /** Helper to assert this.changes is not null and return it. */
	    RemoteDocumentChangeBuffer.prototype.assertChanges = function () {
	        assert_1.assert(this.changes !== null, 'Changes have already been applied.');
	        return this.changes;
	    };
	    return RemoteDocumentChangeBuffer;
	}());
	exports.RemoteDocumentChangeBuffer = RemoteDocumentChangeBuffer;
	
	//# sourceMappingURL=remote_document_change_buffer.js.map


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var blob_1 = __webpack_require__(121);
	var database_1 = __webpack_require__(455);
	var field_path_1 = __webpack_require__(122);
	var field_value_1 = __webpack_require__(189);
	var geo_point_1 = __webpack_require__(123);
	var obj_1 = __webpack_require__(36);
	var firestoreNamespace = {
	    Firestore: database_1.PublicFirestore,
	    GeoPoint: geo_point_1.GeoPoint,
	    Blob: blob_1.PublicBlob,
	    Transaction: database_1.PublicTransaction,
	    WriteBatch: database_1.PublicWriteBatch,
	    DocumentReference: database_1.PublicDocumentReference,
	    DocumentSnapshot: database_1.PublicDocumentSnapshot,
	    Query: database_1.PublicQuery,
	    QuerySnapshot: database_1.PublicQuerySnapshot,
	    CollectionReference: database_1.PublicCollectionReference,
	    FieldPath: field_path_1.FieldPath,
	    FieldValue: field_value_1.PublicFieldValue,
	    setLogLevel: database_1.Firestore.setLogLevel
	};
	/**
	 * Configures Firestore as part of the Firebase SDK by calling registerService.
	 */
	function configureForFirebase(firebase) {
	    firebase.INTERNAL.registerService('firestore', function (app) { return new database_1.Firestore(app); }, obj_1.shallowCopy(firestoreNamespace));
	}
	exports.configureForFirebase = configureForFirebase;
	/**
	 * Exports the Firestore namespace into the provided `exportObject` object under
	 * the key 'firestore'. This is used for wrapped binary that exposes Firestore
	 * as a goog module.
	 */
	function configureForStandalone(exportObject) {
	    var copiedNamespace = obj_1.shallowCopy(firestoreNamespace);
	    // Unlike the use with Firebase, the standalone allows the use of the
	    // constructor, so export it's internal class
	    copiedNamespace['Firestore'] = database_1.Firestore;
	    exportObject['firestore'] = copiedNamespace;
	}
	exports.configureForStandalone = configureForStandalone;
	
	//# sourceMappingURL=config.js.map


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var platform_1 = __webpack_require__(40);
	var browser_platform_1 = __webpack_require__(480);
	/**
	 * This code needs to run before Firestore is used. This can be achieved in
	 * several ways:
	 *   1) Through the JSCompiler compiling this code and then (automatically)
	 *      executing it before exporting the Firestore symbols.
	 *   2) Through importing this module first in a Firestore main module
	 */
	platform_1.PlatformSupport.setPlatform(new browser_platform_1.BrowserPlatform());
	
	//# sourceMappingURL=browser_init.js.map


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var serializer_1 = __webpack_require__(195);
	var webchannel_connection_1 = __webpack_require__(481);
	var BrowserPlatform = /** @class */ (function () {
	    function BrowserPlatform() {
	        this.emptyByteString = '';
	        this.base64Available = typeof atob !== 'undefined';
	    }
	    BrowserPlatform.prototype.loadConnection = function (databaseInfo) {
	        return Promise.resolve(new webchannel_connection_1.WebChannelConnection(databaseInfo));
	    };
	    BrowserPlatform.prototype.newSerializer = function (databaseId) {
	        return new serializer_1.JsonProtoSerializer(databaseId, { useProto3Json: true });
	    };
	    BrowserPlatform.prototype.formatJSON = function (value) {
	        return JSON.stringify(value);
	    };
	    BrowserPlatform.prototype.atob = function (encoded) {
	        return atob(encoded);
	    };
	    BrowserPlatform.prototype.btoa = function (raw) {
	        return btoa(raw);
	    };
	    return BrowserPlatform;
	}());
	exports.BrowserPlatform = BrowserPlatform;
	
	//# sourceMappingURL=browser_platform.js.map


/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var webchannel_wrapper_1 = __webpack_require__(527);
	var version_1 = __webpack_require__(125);
	var rpc_error_1 = __webpack_require__(127);
	var stream_bridge_1 = __webpack_require__(487);
	var assert_1 = __webpack_require__(10);
	var error_1 = __webpack_require__(19);
	var log = __webpack_require__(24);
	var LOG_TAG = 'Connection';
	var RPC_STREAM_SERVICE = 'google.firestore.v1beta1.Firestore';
	var RPC_URL_VERSION = 'v1beta1';
	/** Maps RPC names to the corresponding REST endpoint name. */
	var RPC_NAME_REST_MAPPING = {
	    BatchGetDocuments: 'batchGet',
	    Commit: 'commit'
	};
	// TODO(b/38203344): The SDK_VERSION is set independently from Firebase because
	// we are doing out-of-band releases. Once we release as part of Firebase, we
	// should use the Firebase version instead.
	var X_GOOG_API_CLIENT_VALUE = 'gl-js/ fire/' + version_1.SDK_VERSION;
	var XHR_TIMEOUT_SECS = 15;
	var WebChannelConnection = /** @class */ (function () {
	    function WebChannelConnection(info) {
	        this.databaseId = info.databaseId;
	        this.pool = new webchannel_wrapper_1.XhrIoPool();
	        var proto = info.ssl ? 'https' : 'http';
	        this.baseUrl = proto + '://' + info.host;
	    }
	    /**
	     * Modifies the headers for a request, adding any authorization token if
	     * present and any additional headers for the request.
	     */
	    WebChannelConnection.prototype.modifyHeadersForRequest = function (headers, token) {
	        if (token) {
	            for (var header in token.authHeaders) {
	                if (token.authHeaders.hasOwnProperty(header)) {
	                    headers[header] = token.authHeaders[header];
	                }
	            }
	        }
	        headers['X-Goog-Api-Client'] = X_GOOG_API_CLIENT_VALUE;
	        // This header is used to improve routing and project isolation by the
	        // backend.
	        headers['google-cloud-resource-prefix'] =
	            "projects/" + this.databaseId.projectId + "/" +
	                ("databases/" + this.databaseId.database);
	    };
	    WebChannelConnection.prototype.invokeRPC = function (rpcName, request, token) {
	        var _this = this;
	        var url = this.makeUrl(rpcName);
	        return new Promise(function (resolve, reject) {
	            _this.pool.getObject(function (xhr) {
	                xhr.listenOnce(webchannel_wrapper_1.EventType.COMPLETE, function () {
	                    try {
	                        switch (xhr.getLastErrorCode()) {
	                            case webchannel_wrapper_1.ErrorCode.NO_ERROR:
	                                var json = xhr.getResponseJson();
	                                log.debug(LOG_TAG, 'XHR received:', JSON.stringify(json));
	                                resolve(json);
	                                break;
	                            case webchannel_wrapper_1.ErrorCode.TIMEOUT:
	                                log.debug(LOG_TAG, 'RPC "' + rpcName + '" timed out');
	                                reject(new error_1.FirestoreError(error_1.Code.DEADLINE_EXCEEDED, 'Request time out'));
	                                break;
	                            case webchannel_wrapper_1.ErrorCode.HTTP_ERROR:
	                                var status_1 = xhr.getStatus();
	                                log.debug(LOG_TAG, 'RPC "' + rpcName + '" failed with status:', status_1, 'response text:', xhr.getResponseText());
	                                if (status_1 > 0) {
	                                    reject(new error_1.FirestoreError(rpc_error_1.mapCodeFromHttpStatus(status_1), 'Server responded with status ' + xhr.getStatusText()));
	                                }
	                                else {
	                                    // If we received an HTTP_ERROR but there's no status code,
	                                    // it's most probably a connection issue
	                                    log.debug(LOG_TAG, 'RPC "' + rpcName + '" failed');
	                                    reject(new error_1.FirestoreError(error_1.Code.UNAVAILABLE, 'Connection failed.'));
	                                }
	                                break;
	                            default:
	                                assert_1.fail('RPC "' +
	                                    rpcName +
	                                    '" failed with unanticipated ' +
	                                    'webchannel error ' +
	                                    xhr.getLastErrorCode() +
	                                    ': ' +
	                                    xhr.getLastError() +
	                                    ', giving up.');
	                        }
	                    }
	                    finally {
	                        log.debug(LOG_TAG, 'RPC "' + rpcName + '" completed.');
	                        _this.pool.releaseObject(xhr);
	                    }
	                });
	                var requestString = JSON.stringify(request);
	                log.debug(LOG_TAG, 'XHR sending: ', url + ' ' + requestString);
	                // Content-Type: text/plain will avoid preflight requests which might
	                // mess with CORS and redirects by proxies. If we add custom headers
	                // we will need to change this code to potentially use the
	                // $httpOverwrite parameter supported by ESF to avoid
	                // triggering preflight requests.
	                var headers = { 'Content-Type': 'text/plain' };
	                _this.modifyHeadersForRequest(headers, token);
	                xhr.send(url, 'POST', requestString, headers, XHR_TIMEOUT_SECS);
	            });
	        });
	    };
	    WebChannelConnection.prototype.invokeStreamingRPC = function (rpcName, request, token) {
	        // The REST API automatically aggregates all of the streamed results, so we
	        // can just use the normal invoke() method.
	        return this.invokeRPC(rpcName, request, token);
	    };
	    WebChannelConnection.prototype.openStream = function (rpcName, token) {
	        var urlParts = [
	            this.baseUrl,
	            '/',
	            RPC_STREAM_SERVICE,
	            '/',
	            rpcName,
	            '/channel'
	        ];
	        var webchannelTransport = webchannel_wrapper_1.createWebChannelTransport();
	        var request = {
	            // Background channel test avoids the initial two test calls and decreases
	            // initial cold start time.
	            // TODO(dimond): wenboz@ mentioned this might affect use with proxies and
	            // we should monitor closely for any reports.
	            backgroundChannelTest: true,
	            // Required for backend stickiness, routing behavior is based on this
	            // parameter.
	            httpSessionIdParam: 'gsessionid',
	            initMessageHeaders: {},
	            // Send our custom headers as a '$httpHeaders=' url param to avoid CORS
	            // preflight round-trip. This is formally defined here:
	            // https://github.com/google/closure-library/blob/b0e1815b13fb92a46d7c9b3c30de5d6a396a3245/closure/goog/net/rpc/httpcors.js#L40
	            httpHeadersOverwriteParam: '$httpHeaders',
	            sendRawJson: true,
	            supportsCrossDomainXhr: true
	        };
	        this.modifyHeadersForRequest(request.initMessageHeaders, token);
	        var url = urlParts.join('');
	        log.debug(LOG_TAG, 'Creating WebChannel: ' + url + ' ' + request);
	        // tslint:disable-next-line:no-any Because listen isn't defined on it.
	        var channel = webchannelTransport.createWebChannel(url, request);
	        // WebChannel supports sending the first message with the handshake - saving
	        // a network round trip. However, it will have to call send in the same
	        // JS event loop as open. In order to enforce this, we delay actually
	        // opening the WebChannel until send is called. Whether we have called
	        // open is tracked with this variable.
	        var opened = false;
	        // A flag to determine whether the stream was closed (by us or through an
	        // error/close event) to avoid delivering multiple close events or sending
	        // on a closed stream
	        var closed = false;
	        // tslint:disable-next-line:no-any
	        var streamBridge = new stream_bridge_1.StreamBridge({
	            sendFn: function (msg) {
	                if (!closed) {
	                    if (!opened) {
	                        log.debug(LOG_TAG, 'Opening WebChannel transport.');
	                        channel.open();
	                        opened = true;
	                    }
	                    log.debug(LOG_TAG, 'WebChannel sending:', msg);
	                    channel.send(msg);
	                }
	                else {
	                    log.debug(LOG_TAG, 'Not sending because WebChannel is closed:', msg);
	                }
	            },
	            closeFn: function () { return channel.close(); }
	        });
	        // Closure events are guarded and exceptions are swallowed, so catch any
	        // exception and rethrow using a setTimeout so they become visible again.
	        // Note that eventually this function could go away if we are confident
	        // enough the code is exception free.
	        var unguardedEventListen = function (type, fn) {
	            // TODO(dimond): closure typing seems broken because WebChannel does
	            // not implement goog.events.Listenable
	            channel.listen(type, function (param) {
	                try {
	                    fn(param);
	                }
	                catch (e) {
	                    setTimeout(function () {
	                        throw e;
	                    }, 0);
	                }
	            });
	        };
	        unguardedEventListen(webchannel_wrapper_1.WebChannel.EventType.OPEN, function () {
	            if (!closed) {
	                log.debug(LOG_TAG, 'WebChannel transport opened.');
	            }
	        });
	        unguardedEventListen(webchannel_wrapper_1.WebChannel.EventType.CLOSE, function () {
	            if (!closed) {
	                closed = true;
	                log.debug(LOG_TAG, 'WebChannel transport closed');
	                streamBridge.callOnClose();
	            }
	        });
	        unguardedEventListen(webchannel_wrapper_1.WebChannel.EventType.ERROR, function (err) {
	            if (!closed) {
	                closed = true;
	                log.debug(LOG_TAG, 'WebChannel transport errored:', err);
	                streamBridge.callOnClose(new error_1.FirestoreError(error_1.Code.UNAVAILABLE, 'The operation could not be completed'));
	            }
	        });
	        unguardedEventListen(webchannel_wrapper_1.WebChannel.EventType.MESSAGE, function (msg) {
	            if (!closed) {
	                // WebChannel delivers message events as array. If batching
	                // is not enabled (it's off by default) each message will be
	                // delivered alone, resulting in a single element array.
	                var msgData = msg.data[0];
	                assert_1.assert(!!msgData, 'Got a webchannel message without data.');
	                // TODO(b/35143891): There is a bug in One Platform that caused errors
	                // (and only errors) to be wrapped in an extra array. To be forward
	                // compatible with the bug we need to check either condition. The latter
	                // can be removed once the fix has been rolled out.
	                var error = msgData.error || (msgData[0] && msgData[0].error);
	                if (error) {
	                    log.debug(LOG_TAG, 'WebChannel received error:', error);
	                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
	                    var status_2 = error.status;
	                    var code = rpc_error_1.mapCodeFromRpcStatus(status_2);
	                    var message = error.message;
	                    if (code === undefined) {
	                        code = error_1.Code.INTERNAL;
	                        message =
	                            'Unknown error status: ' +
	                                status_2 +
	                                ' with message ' +
	                                error.message;
	                    }
	                    // Mark closed so no further events are propagated
	                    closed = true;
	                    streamBridge.callOnClose(new error_1.FirestoreError(code, message));
	                    channel.close();
	                }
	                else {
	                    log.debug(LOG_TAG, 'WebChannel received:', msgData);
	                    streamBridge.callOnMessage(msgData);
	                }
	            }
	        });
	        setTimeout(function () {
	            // Technically we could/should wait for the WebChannel opened event,
	            // but because we want to send the first message with the WebChannel
	            // handshake we pretend the channel opened here (asynchronously), and
	            // then delay the actual open until the first message is sent.
	            streamBridge.callOnOpen();
	        }, 0);
	        return streamBridge;
	    };
	    // visible for testing
	    WebChannelConnection.prototype.makeUrl = function (rpcName) {
	        var urlRpcName = RPC_NAME_REST_MAPPING[rpcName];
	        assert_1.assert(urlRpcName !== undefined, 'Unknown REST mapping for: ' + rpcName);
	        var url = [this.baseUrl, '/', RPC_URL_VERSION];
	        url.push('/projects/');
	        url.push(this.databaseId.projectId);
	        url.push('/databases/');
	        url.push(this.databaseId.database);
	        url.push('/documents');
	        url.push(':');
	        url.push(urlRpcName);
	        return url.join('');
	    };
	    return WebChannelConnection;
	}());
	exports.WebChannelConnection = WebChannelConnection;
	
	//# sourceMappingURL=webchannel_connection.js.map


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var log = __webpack_require__(24);
	var promise_1 = __webpack_require__(130);
	var LOG_TAG = 'ExponentialBackoff';
	/**
	 * A helper for running delayed tasks following an exponential backoff curve
	 * between attempts.
	 *
	 * Each delay is made up of a "base" delay which follows the exponential
	 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
	 * base delay. This prevents clients from accidentally synchronizing their
	 * delays causing spikes of load to the backend.
	 */
	var ExponentialBackoff = /** @class */ (function () {
	    function ExponentialBackoff(
	        /**
	         * The initial delay (used as the base delay on the first retry attempt).
	         * Note that jitter will still be applied, so the actual delay could be as
	         * little as 0.5*initialDelayMs.
	         */
	        initialDelayMs, 
	        /**
	         * The multiplier to use to determine the extended base delay after each
	         * attempt.
	         */
	        backoffFactor, 
	        /**
	         * The maximum base delay after which no further backoff is performed.
	         * Note that jitter will still be applied, so the actual delay could be as
	         * much as 1.5*maxDelayMs.
	         */
	        maxDelayMs) {
	        this.initialDelayMs = initialDelayMs;
	        this.backoffFactor = backoffFactor;
	        this.maxDelayMs = maxDelayMs;
	        this.reset();
	    }
	    /**
	     * Resets the backoff delay.
	     *
	     * The very next backoffAndWait() will have no delay. If it is called again
	     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
	     * subsequent ones will increase according to the backoffFactor.
	     */
	    ExponentialBackoff.prototype.reset = function () {
	        this.currentBaseMs = 0;
	    };
	    /**
	     * Resets the backoff delay to the maximum delay (e.g. for use after a
	     * RESOURCE_EXHAUSTED error).
	     */
	    ExponentialBackoff.prototype.resetToMax = function () {
	        this.currentBaseMs = this.maxDelayMs;
	    };
	    /**
	     * Returns a promise that resolves after currentDelayMs, and increases the
	     * delay for any subsequent attempts.
	     */
	    ExponentialBackoff.prototype.backoffAndWait = function () {
	        var def = new promise_1.Deferred();
	        // First schedule using the current base (which may be 0 and should be
	        // honored as such).
	        var delayWithJitterMs = this.currentBaseMs + this.jitterDelayMs();
	        if (this.currentBaseMs > 0) {
	            log.debug(LOG_TAG, "Backing off for " + delayWithJitterMs + " ms " +
	                ("(base delay: " + this.currentBaseMs + " ms)"));
	        }
	        setTimeout(function () {
	            def.resolve();
	        }, delayWithJitterMs);
	        // Apply backoff factor to determine next delay and ensure it is within
	        // bounds.
	        this.currentBaseMs *= this.backoffFactor;
	        if (this.currentBaseMs < this.initialDelayMs) {
	            this.currentBaseMs = this.initialDelayMs;
	        }
	        if (this.currentBaseMs > this.maxDelayMs) {
	            this.currentBaseMs = this.maxDelayMs;
	        }
	        return def.promise;
	    };
	    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */
	    ExponentialBackoff.prototype.jitterDelayMs = function () {
	        return (Math.random() - 0.5) * this.currentBaseMs;
	    };
	    return ExponentialBackoff;
	}());
	exports.ExponentialBackoff = ExponentialBackoff;
	
	//# sourceMappingURL=backoff.js.map


/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var collections_1 = __webpack_require__(20);
	var assert_1 = __webpack_require__(10);
	var persistent_stream_1 = __webpack_require__(485);
	/**
	 * Datastore is a wrapper around the external Google Cloud Datastore grpc API,
	 * which provides an interface that is more convenient for the rest of the
	 * client SDK architecture to consume.
	 */
	var Datastore = /** @class */ (function () {
	    function Datastore(databaseInfo, queue, connection, credentials, serializer, initialBackoffDelay) {
	        this.databaseInfo = databaseInfo;
	        this.queue = queue;
	        this.connection = connection;
	        this.credentials = credentials;
	        this.serializer = serializer;
	        this.initialBackoffDelay = initialBackoffDelay;
	    }
	    Datastore.prototype.newPersistentWriteStream = function () {
	        return new persistent_stream_1.PersistentWriteStream(this.databaseInfo, this.queue, this.connection, this.credentials, this.serializer, this.initialBackoffDelay);
	    };
	    Datastore.prototype.newPersistentWatchStream = function () {
	        return new persistent_stream_1.PersistentListenStream(this.databaseInfo, this.queue, this.connection, this.credentials, this.serializer, this.initialBackoffDelay);
	    };
	    Datastore.prototype.commit = function (mutations) {
	        var _this = this;
	        var params = {
	            database: this.serializer.encodedDatabaseId,
	            writes: mutations.map(function (m) { return _this.serializer.toMutation(m); })
	        };
	        return this.invokeRPC('Commit', params).then(function (response) {
	            return _this.serializer.fromWriteResults(response.writeResults);
	        });
	    };
	    Datastore.prototype.lookup = function (keys) {
	        var _this = this;
	        var params = {
	            database: this.serializer.encodedDatabaseId,
	            documents: keys.map(function (k) { return _this.serializer.toName(k); })
	        };
	        return this.invokeStreamingRPC('BatchGetDocuments', params).then(function (response) {
	            var docs = collections_1.maybeDocumentMap();
	            response.forEach(function (proto) {
	                var doc = _this.serializer.fromMaybeDocument(proto);
	                docs = docs.insert(doc.key, doc);
	            });
	            var result = [];
	            keys.forEach(function (key) {
	                var doc = docs.get(key);
	                assert_1.assert(!!doc, 'Missing entity in write response for ' + key);
	                result.push(doc);
	            });
	            return result;
	        });
	    };
	    /** Gets an auth token and invokes the provided RPC. */
	    Datastore.prototype.invokeRPC = function (rpcName, request) {
	        var _this = this;
	        // TODO(mikelehen): Retry (with backoff) on token failures?
	        return this.credentials.getToken(/*forceRefresh=*/ false).then(function (token) {
	            return _this.connection.invokeRPC(rpcName, request, token);
	        });
	    };
	    /** Gets an auth token and invokes the provided RPC with streamed results. */
	    Datastore.prototype.invokeStreamingRPC = function (rpcName, request) {
	        var _this = this;
	        // TODO(mikelehen): Retry (with backoff) on token failures?
	        return this.credentials.getToken(/*forceRefresh=*/ false).then(function (token) {
	            return _this.connection.invokeStreamingRPC(rpcName, request, token);
	        });
	    };
	    return Datastore;
	}());
	exports.Datastore = Datastore;
	
	//# sourceMappingURL=datastore.js.map


/***/ },
/* 484 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ExistenceFilter = /** @class */ (function () {
	    // TODO(b/33078163): just use simplest form of existence filter for now
	    function ExistenceFilter(count) {
	        this.count = count;
	    }
	    ExistenceFilter.prototype.equals = function (other) {
	        return other && other.count === this.count;
	    };
	    return ExistenceFilter;
	}());
	exports.ExistenceFilter = ExistenceFilter;
	
	//# sourceMappingURL=existence_filter.js.map


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(10);
	var error_1 = __webpack_require__(19);
	var log = __webpack_require__(24);
	var backoff_1 = __webpack_require__(482);
	var types_1 = __webpack_require__(73);
	var LOG_TAG = 'PersistentStream';
	var PersistentStreamState;
	(function (PersistentStreamState) {
	    /**
	     * The streaming RPC is not running and there's no error condition.
	     * Calling `start` will start the stream immediately without backoff.
	     * While in this state isStarted will return false.
	     */
	    PersistentStreamState[PersistentStreamState["Initial"] = 0] = "Initial";
	    /**
	     * The stream is starting, and is waiting for an auth token to attach to
	     * the initial request. While in this state, isStarted will return
	     * true but isOpen will return false.
	     */
	    PersistentStreamState[PersistentStreamState["Auth"] = 1] = "Auth";
	    /**
	     * The streaming RPC is up and running. Requests and responses can flow
	     * freely. Both isStarted and isOpen will return true.
	     */
	    PersistentStreamState[PersistentStreamState["Open"] = 2] = "Open";
	    /**
	     * The stream encountered an error. The next start attempt will back off.
	     * While in this state isStarted() will return false.
	     *
	     */
	    PersistentStreamState[PersistentStreamState["Error"] = 3] = "Error";
	    /**
	     * An in-between state after an error where the stream is waiting before
	     * re-starting. After
	     * waiting is complete, the stream will try to open. While in this
	     * state isStarted() will return YES but isOpen will return false.
	     */
	    PersistentStreamState[PersistentStreamState["Backoff"] = 4] = "Backoff";
	    /**
	     * The stream has been explicitly stopped; no further events will be emitted.
	     */
	    PersistentStreamState[PersistentStreamState["Stopped"] = 5] = "Stopped";
	})(PersistentStreamState || (PersistentStreamState = {}));
	/**
	 * Initial backoff time in milliseconds after an error.
	 * Set to 1s according to https://cloud.google.com/apis/design/errors.
	 */
	var BACKOFF_INITIAL_DELAY_MS = 1000;
	/** Maximum backoff time in milliseconds */
	var BACKOFF_MAX_DELAY_MS = 60 * 1000;
	var BACKOFF_FACTOR = 1.5;
	/** The time a stream stays open after it is marked idle. */
	var IDLE_TIMEOUT_MS = 60 * 1000;
	/**
	 * A PersistentStream is an abstract base class that represents a streaming RPC
	 * to the Firestore backend. It's built on top of the connections own support
	 * for streaming RPCs, and adds several critical features for our clients:
	 *
	 *   - Exponential backoff on failure
	 *   - Authentication via CredentialsProvider
	 *   - Dispatching all callbacks into the shared worker queue
	 *
	 * Subclasses of PersistentStream implement serialization of models to and
	 * from the JSON representation of the protocol buffers for a specific
	 * streaming RPC.
	 *
	 * ## Starting and Stopping
	 *
	 * Streaming RPCs are stateful and need to be `start`ed before messages can
	 * be sent and received. The PersistentStream will call the onOpen function
	 * of the listener once the stream is ready to accept requests.
	 *
	 * Should a `start` fail, PersistentStream will call the registered
	 * onClose with a FirestoreError indicating what went wrong.
	 *
	 * A PersistentStream can be started and stopped repeatedly.
	 *
	 * Generic types:
	 *  SendType: The type of the outgoing message of the underlying
	 *    connection stream
	 *  ReceiveType: The type of the incoming message of the underlying
	 *    connection stream
	 *  ListenerType: The type of the listener that will be used for callbacks
	 */
	var PersistentStream = /** @class */ (function () {
	    function PersistentStream(queue, connection, credentialsProvider, 
	        // Used for faster retries in testing
	        initialBackoffDelay) {
	        this.queue = queue;
	        this.connection = connection;
	        this.credentialsProvider = credentialsProvider;
	        this.idle = false;
	        this.stream = null;
	        this.listener = null;
	        this.backoff = new backoff_1.ExponentialBackoff(initialBackoffDelay ? initialBackoffDelay : BACKOFF_INITIAL_DELAY_MS, BACKOFF_FACTOR, BACKOFF_MAX_DELAY_MS);
	        this.state = PersistentStreamState.Initial;
	    }
	    /**
	     * Returns true if `start` has been called and no error has occurred. True
	     * indicates the stream is open or in the process of opening (which
	     * encompasses respecting backoff, getting auth tokens, and starting the
	     * actual RPC). Use `isOpen` to determine if the stream is open and ready for
	     * outbound requests.
	     */
	    PersistentStream.prototype.isStarted = function () {
	        return (this.state === PersistentStreamState.Backoff ||
	            this.state === PersistentStreamState.Auth ||
	            this.state === PersistentStreamState.Open);
	    };
	    /**
	     * Returns true if the underlying RPC is open (the openHandler has been
	     * called) and the stream is ready for outbound requests.
	     */
	    PersistentStream.prototype.isOpen = function () {
	        return this.state === PersistentStreamState.Open;
	    };
	    /**
	     * Starts the RPC. Only allowed if isStarted returns false. The stream is
	     * not immediately ready for use: onOpen will be invoked when the RPC is ready
	     * for outbound requests, at which point isOpen will return true.
	     *
	     *  When start returns, isStarted will return true.
	     */
	    PersistentStream.prototype.start = function (listener) {
	        if (this.state === PersistentStreamState.Error) {
	            this.performBackoff(listener);
	            return;
	        }
	        assert_1.assert(this.state === PersistentStreamState.Initial, 'Already started');
	        this.listener = listener;
	        this.auth();
	    };
	    /**
	     * Stops the RPC. This call is idempotent and allowed regardless of the
	     * current isStarted state.
	     *
	     * When stop returns, isStarted and isOpen will both return false.
	     */
	    PersistentStream.prototype.stop = function () {
	        if (this.isStarted()) {
	            this.close(PersistentStreamState.Stopped);
	        }
	    };
	    /**
	     * After an error the stream will usually back off on the next attempt to
	     * start it. If the error warrants an immediate restart of the stream, the
	     * sender can use this to indicate that the receiver should not back off.
	     *
	     * Each error will call the onClose function. That function can decide to
	     * inhibit backoff if required.
	     */
	    PersistentStream.prototype.inhibitBackoff = function () {
	        assert_1.assert(!this.isStarted(), 'Can only inhibit backoff in a stopped state');
	        this.state = PersistentStreamState.Initial;
	        this.backoff.reset();
	    };
	    /**
	     * Initializes the idle timer. If no write takes place within one minute, the
	     * WebChannel stream will be closed.
	     */
	    PersistentStream.prototype.markIdle = function () {
	        var _this = this;
	        this.idle = true;
	        this.queue
	            .schedule(function () {
	            return _this.handleIdleCloseTimer();
	        }, IDLE_TIMEOUT_MS)
	            .catch(function (err) {
	            // When the AsyncQueue gets drained during testing, pending Promises
	            // (including these idle checks) will get rejected. We special-case
	            // these cancelled idle checks to make sure that these specific Promise
	            // rejections are not considered unhandled.
	            assert_1.assert(err.code === error_1.Code.CANCELLED, "Received unexpected error in idle timeout closure. Expected CANCELLED, but was: " + err);
	        });
	    };
	    /** Sends a message to the underlying stream. */
	    PersistentStream.prototype.sendRequest = function (msg) {
	        this.cancelIdleCheck();
	        this.stream.send(msg);
	    };
	    /** Called by the idle timer when the stream should close due to inactivity. */
	    PersistentStream.prototype.handleIdleCloseTimer = function () {
	        if (this.isOpen() && this.idle) {
	            // When timing out an idle stream there's no reason to force the stream into backoff when
	            // it restarts so set the stream state to Initial instead of Error.
	            return this.close(PersistentStreamState.Initial);
	        }
	        return Promise.resolve();
	    };
	    /** Marks the stream as active again. */
	    PersistentStream.prototype.cancelIdleCheck = function () {
	        this.idle = false;
	    };
	    /**
	     * Closes the stream and cleans up as necessary:
	     *
	     * * closes the underlying GRPC stream;
	     * * calls the onClose handler with the given 'error';
	     * * sets internal stream state to 'finalState';
	     * * adjusts the backoff timer based on the error
	     *
	     * A new stream can be opened by calling `start` unless `finalState` is set to
	     * `PersistentStreamState.Stopped`.
	     *
	     * @param finalState the intended state of the stream after closing.
	     * @param error the error the connection was closed with.
	     */
	    PersistentStream.prototype.close = function (finalState, error) {
	        assert_1.assert(finalState == PersistentStreamState.Error || types_1.isNullOrUndefined(error), "Can't provide an error when not in an error state.");
	        this.cancelIdleCheck();
	        if (finalState != PersistentStreamState.Error) {
	            // If this is an intentional close ensure we don't delay our next connection attempt.
	            this.backoff.reset();
	        }
	        else if (error && error.code === error_1.Code.RESOURCE_EXHAUSTED) {
	            log.debug(LOG_TAG, 'Using maximum backoff delay to prevent overloading the backend.');
	            this.backoff.resetToMax();
	        }
	        // Clean up the underlying stream because we are no longer interested in events.
	        if (this.stream !== null) {
	            this.tearDown();
	            this.stream.close();
	            this.stream = null;
	        }
	        // This state must be assigned before calling onClose() to allow the callback to
	        // inhibit backoff or otherwise manipulate the state in its non-started state.
	        this.state = finalState;
	        var listener = this.listener;
	        // Clear the listener to avoid bleeding of events from the underlying streams.
	        this.listener = null;
	        // If the caller explicitly requested a stream stop, don't notify them of a closing stream (it
	        // could trigger undesirable recovery logic, etc.).
	        if (finalState != PersistentStreamState.Stopped) {
	            return listener.onClose(error);
	        }
	        else {
	            return Promise.resolve();
	        }
	    };
	    /**
	     * Can be overridden to perform additional cleanup before the stream is closed.
	     * Calling super.tearDown() is not required.
	     */
	    PersistentStream.prototype.tearDown = function () { };
	    PersistentStream.prototype.auth = function () {
	        var _this = this;
	        assert_1.assert(this.state === PersistentStreamState.Initial, 'Must be in initial state to auth');
	        this.state = PersistentStreamState.Auth;
	        this.credentialsProvider.getToken(/*forceRefresh=*/ false).then(function (token) {
	            // Normally we'd have to schedule the callback on the AsyncQueue.
	            // However, the following calls are safe to be called outside the
	            // AsyncQueue since they don't chain asynchronous calls
	            _this.startStream(token);
	        }, function (error) {
	            _this.queue.schedule(function () {
	                if (_this.state !== PersistentStreamState.Stopped) {
	                    // Stream can be stopped while waiting for authorization.
	                    var rpcError = new error_1.FirestoreError(error_1.Code.UNKNOWN, 'Fetching auth token failed: ' + error.message);
	                    return _this.handleStreamClose(rpcError);
	                }
	                else {
	                    return Promise.resolve();
	                }
	            });
	        });
	    };
	    PersistentStream.prototype.startStream = function (token) {
	        var _this = this;
	        if (this.state === PersistentStreamState.Stopped) {
	            // Stream can be stopped while waiting for authorization.
	            return;
	        }
	        assert_1.assert(this.state === PersistentStreamState.Auth, 'Trying to start stream in a non-auth state');
	        // Helper function to dispatch to AsyncQueue and make sure that any
	        // close will seem instantaneous and events are prevented from being
	        // raised after the close call
	        var dispatchIfStillActive = function (stream, fn) {
	            _this.queue.schedule(function () {
	                // Only raise events if the stream instance has not changed
	                if (_this.stream === stream) {
	                    return fn();
	                }
	                else {
	                    return Promise.resolve();
	                }
	            });
	        };
	        // Only start stream if listener has not changed
	        if (this.listener !== null) {
	            var currentStream_1 = this.startRpc(token);
	            this.stream = currentStream_1;
	            this.stream.onOpen(function () {
	                dispatchIfStillActive(currentStream_1, function () {
	                    assert_1.assert(_this.state === PersistentStreamState.Auth, 'Expected stream to be in state auth, but was ' + _this.state);
	                    _this.state = PersistentStreamState.Open;
	                    return _this.listener.onOpen();
	                });
	            });
	            this.stream.onClose(function (error) {
	                dispatchIfStillActive(currentStream_1, function () {
	                    return _this.handleStreamClose(error);
	                });
	            });
	            this.stream.onMessage(function (msg) {
	                dispatchIfStillActive(currentStream_1, function () {
	                    return _this.onMessage(msg);
	                });
	            });
	        }
	    };
	    PersistentStream.prototype.performBackoff = function (listener) {
	        var _this = this;
	        assert_1.assert(this.state === PersistentStreamState.Error, 'Should only perform backoff in an error case');
	        this.state = PersistentStreamState.Backoff;
	        this.backoff.backoffAndWait().then(function () {
	            // Backoff does not run on the AsyncQueue, so we need to reschedule to
	            // make sure the queue blocks
	            _this.queue.schedule(function () {
	                if (_this.state === PersistentStreamState.Stopped) {
	                    // Stream can be stopped while waiting for backoff to complete.
	                    return Promise.resolve();
	                }
	                _this.state = PersistentStreamState.Initial;
	                _this.start(listener);
	                assert_1.assert(_this.isStarted(), 'PersistentStream should have started');
	                return Promise.resolve();
	            });
	        });
	    };
	    PersistentStream.prototype.handleStreamClose = function (error) {
	        assert_1.assert(this.isStarted(), "Can't handle server close on non-started stream");
	        log.debug(LOG_TAG, "close with error: " + error);
	        this.stream = null;
	        // In theory the stream could close cleanly, however, in our current model
	        // we never expect this to happen because if we stop a stream ourselves,
	        // this callback will never be called. To prevent cases where we retry
	        // without a backoff accidentally, we set the stream to error in all cases.
	        return this.close(PersistentStreamState.Error, error);
	    };
	    return PersistentStream;
	}());
	exports.PersistentStream = PersistentStream;
	/**
	 * A PersistentStream that implements the Listen RPC.
	 *
	 * Once the Listen stream has called the openHandler, any number of listen and
	 * unlisten calls calls can be sent to control what changes will be sent from
	 * the server for ListenResponses.
	 */
	var PersistentListenStream = /** @class */ (function (_super) {
	    __extends(PersistentListenStream, _super);
	    function PersistentListenStream(databaseInfo, queue, connection, credentials, serializer, initialBackoffDelay) {
	        var _this = _super.call(this, queue, connection, credentials, initialBackoffDelay) || this;
	        _this.databaseInfo = databaseInfo;
	        _this.serializer = serializer;
	        return _this;
	    }
	    PersistentListenStream.prototype.startRpc = function (token) {
	        return this.connection.openStream('Listen', token);
	    };
	    PersistentListenStream.prototype.onMessage = function (watchChangeProto) {
	        // A successful response means the stream is healthy
	        this.backoff.reset();
	        var watchChange = this.serializer.fromWatchChange(watchChangeProto);
	        var snapshot = this.serializer.versionFromListenResponse(watchChangeProto);
	        return this.listener.onWatchChange(watchChange, snapshot);
	    };
	    /**
	     * Registers interest in the results of the given query. If the query
	     * includes a resumeToken it will be included in the request. Results that
	     * affect the query will be streamed back as WatchChange messages that
	     * reference the targetId.
	     */
	    PersistentListenStream.prototype.watch = function (queryData) {
	        var request = {};
	        request.database = this.serializer.encodedDatabaseId;
	        request.addTarget = this.serializer.toTarget(queryData);
	        var labels = this.serializer.toListenRequestLabels(queryData);
	        if (labels) {
	            request.labels = labels;
	        }
	        this.sendRequest(request);
	    };
	    /**
	     * Unregisters interest in the results of the query associated with the
	     * given targetId.
	     */
	    PersistentListenStream.prototype.unwatch = function (targetId) {
	        var request = {};
	        request.database = this.serializer.encodedDatabaseId;
	        request.removeTarget = targetId;
	        this.sendRequest(request);
	    };
	    return PersistentListenStream;
	}(PersistentStream));
	exports.PersistentListenStream = PersistentListenStream;
	/**
	 * A Stream that implements the Write RPC.
	 *
	 * The Write RPC requires the caller to maintain special streamToken
	 * state in between calls, to help the server understand which responses the
	 * client has processed by the time the next request is made. Every response
	 * will contain a streamToken; this value must be passed to the next
	 * request.
	 *
	 * After calling start() on this stream, the next request must be a handshake,
	 * containing whatever streamToken is on hand. Once a response to this
	 * request is received, all pending mutations may be submitted. When
	 * submitting multiple batches of mutations at the same time, it's
	 * okay to use the same streamToken for the calls to writeMutations.
	 *
	 * TODO(b/33271235): Use proto types
	 */
	var PersistentWriteStream = /** @class */ (function (_super) {
	    __extends(PersistentWriteStream, _super);
	    function PersistentWriteStream(databaseInfo, queue, connection, credentials, serializer, initialBackoffDelay) {
	        var _this = _super.call(this, queue, connection, credentials, initialBackoffDelay) || this;
	        _this.databaseInfo = databaseInfo;
	        _this.serializer = serializer;
	        _this.handshakeComplete_ = false;
	        return _this;
	    }
	    Object.defineProperty(PersistentWriteStream.prototype, "handshakeComplete", {
	        /**
	         * Tracks whether or not a handshake has been successfully exchanged and
	         * the stream is ready to accept mutations.
	         */
	        get: function () {
	            return this.handshakeComplete_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    // Override of PersistentStream.start
	    PersistentWriteStream.prototype.start = function (listener) {
	        this.handshakeComplete_ = false;
	        _super.prototype.start.call(this, listener);
	    };
	    PersistentWriteStream.prototype.tearDown = function () {
	        if (this.handshakeComplete_) {
	            this.writeMutations([]);
	        }
	    };
	    PersistentWriteStream.prototype.startRpc = function (token) {
	        return this.connection.openStream('Write', token);
	    };
	    PersistentWriteStream.prototype.onMessage = function (responseProto) {
	        // Always capture the last stream token.
	        assert_1.assert(!!responseProto.streamToken, 'Got a write response without a stream token');
	        this.lastStreamToken = responseProto.streamToken;
	        if (!this.handshakeComplete_) {
	            // The first response is always the handshake response
	            assert_1.assert(!responseProto.writeResults || responseProto.writeResults.length === 0, 'Got mutation results for handshake');
	            this.handshakeComplete_ = true;
	            return this.listener.onHandshakeComplete();
	        }
	        else {
	            // A successful first write response means the stream is healthy,
	            // Note, that we could consider a successful handshake healthy, however,
	            // the write itself might be causing an error we want to back off from.
	            this.backoff.reset();
	            var results = this.serializer.fromWriteResults(responseProto.writeResults);
	            var commitVersion = this.serializer.fromVersion(responseProto.commitTime);
	            return this.listener.onMutationResult(commitVersion, results);
	        }
	    };
	    /**
	     * Sends an initial streamToken to the server, performing the handshake
	     * required to make the StreamingWrite RPC work. Subsequent
	     * calls should wait until onHandshakeComplete was called.
	     */
	    PersistentWriteStream.prototype.writeHandshake = function () {
	        assert_1.assert(this.isOpen(), 'Writing handshake requires an opened stream');
	        assert_1.assert(!this.handshakeComplete_, 'Handshake already completed');
	        // TODO(dimond): Support stream resumption. We intentionally do not set the
	        // stream token on the handshake, ignoring any stream token we might have.
	        var request = {};
	        request.database = this.serializer.encodedDatabaseId;
	        this.sendRequest(request);
	    };
	    /** Sends a group of mutations to the Firestore backend to apply. */
	    PersistentWriteStream.prototype.writeMutations = function (mutations) {
	        var _this = this;
	        assert_1.assert(this.isOpen(), 'Writing mutations requires an opened stream');
	        assert_1.assert(this.handshakeComplete_, 'Handshake must be complete before writing mutations');
	        assert_1.assert(this.lastStreamToken.length > 0, 'Trying to write mutation without a token');
	        var request = {
	            // Protos are typed with string, but we support UInt8Array on Node
	            // tslint:disable-next-line:no-any
	            streamToken: this.lastStreamToken,
	            writes: mutations.map(function (mutation) { return _this.serializer.toMutation(mutation); })
	        };
	        this.sendRequest(request);
	    };
	    return PersistentWriteStream;
	}(PersistentStream));
	exports.PersistentWriteStream = PersistentWriteStream;
	
	//# sourceMappingURL=persistent_stream.js.map


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var snapshot_version_1 = __webpack_require__(31);
	var transaction_1 = __webpack_require__(462);
	var types_1 = __webpack_require__(192);
	var query_data_1 = __webpack_require__(69);
	var document_1 = __webpack_require__(32);
	var document_key_1 = __webpack_require__(22);
	var mutation_batch_1 = __webpack_require__(70);
	var platform_1 = __webpack_require__(40);
	var assert_1 = __webpack_require__(10);
	var error_1 = __webpack_require__(19);
	var log = __webpack_require__(24);
	var objUtils = __webpack_require__(36);
	var remote_event_1 = __webpack_require__(71);
	var rpc_error_1 = __webpack_require__(127);
	var watch_change_1 = __webpack_require__(196);
	var LOG_TAG = 'RemoteStore';
	// TODO(b/35853402): Negotiate this with the stream.
	var MAX_PENDING_WRITES = 10;
	// The RemoteStore notifies an onlineStateHandler with OnlineState.Failed if we
	// fail to connect to the backend. This subsequently triggers get() requests to
	// fail or use cached data, etc. Unfortunately, our connections have
	// historically been subject to various transient failures. So we wait for
	// multiple failures before notifying the onlineStateHandler.
	var ONLINE_ATTEMPTS_BEFORE_FAILURE = 2;
	/**
	 * RemoteStore - An interface to remotely stored data, basically providing a
	 * wrapper around the Datastore that is more reliable for the rest of the
	 * system.
	 *
	 * RemoteStore is responsible for maintaining the connection to the server.
	 * - maintaining a list of active listens.
	 * - reconnecting when the connection is dropped.
	 * - resuming all the active listens on reconnect.
	 *
	 * RemoteStore handles all incoming events from the Datastore.
	 * - listening to the watch stream and repackaging the events as RemoteEvents
	 * - notifying SyncEngine of any changes to the active listens.
	 *
	 * RemoteStore takes writes from other components and handles them reliably.
	 * - pulling pending mutations from LocalStore and sending them to Datastore.
	 * - retrying mutations that failed because of network problems.
	 * - acking mutations to the SyncEngine once they are accepted or rejected.
	 */
	var RemoteStore = /** @class */ (function () {
	    function RemoteStore(databaseInfo, asyncQueue, 
	        /**
	         * The local store, used to fill the write pipeline with outbound
	         * mutations and resolve existence filter mismatches.
	         */
	        localStore, 
	        /** The client-side proxy for interacting with the backend. */
	        datastore, onlineStateHandler) {
	        this.databaseInfo = databaseInfo;
	        this.asyncQueue = asyncQueue;
	        this.localStore = localStore;
	        this.datastore = datastore;
	        this.onlineStateHandler = onlineStateHandler;
	        this.pendingWrites = [];
	        this.lastBatchSeen = mutation_batch_1.BATCHID_UNKNOWN;
	        /**
	         * A mapping of watched targets that the client cares about tracking and the
	         * user has explicitly called a 'listen' for this target.
	         *
	         * These targets may or may not have been sent to or acknowledged by the
	         * server. On re-establishing the listen stream, these targets should be sent
	         * to the server. The targets removed with unlistens are removed eagerly
	         * without waiting for confirmation from the listen stream.
	         */
	        this.listenTargets = {};
	        /**
	         * A mapping of targetId to pending acks needed.
	         *
	         * If a targetId is present in this map, then we're waiting for watch to
	         * acknowledge a removal or addition of the target. If a target is not in this
	         * mapping, and it's in the listenTargets map, then we consider the target to
	         * be active.
	         *
	         * We increment the count here every time we issue a request over the stream
	         * to watch or unwatch. We then decrement the count every time we get a target
	         * added or target removed message from the server. Once the count is equal to
	         * 0 we know that the client and server are in the same state (once this state
	         * is reached the targetId is removed from the map to free the memory).
	         */
	        this.pendingTargetResponses = {};
	        this.accumulatedWatchChanges = [];
	        this.watchStream = null;
	        this.writeStream = null;
	        /**
	         * The online state of the watch stream. The state is set to healthy if and
	         * only if there are messages received by the backend.
	         */
	        this.watchStreamOnlineState = types_1.OnlineState.Unknown;
	        /** A count of consecutive failures to open the stream. */
	        this.watchStreamFailures = 0;
	        /** Whether the client should fire offline warning. */
	        this.shouldWarnOffline = true;
	    }
	    /**
	     * Starts up the remote store, creating streams, restoring state from
	     * LocalStore, etc.
	     */
	    RemoteStore.prototype.start = function () {
	        return this.enableNetwork();
	    };
	    RemoteStore.prototype.setOnlineStateToHealthy = function () {
	        this.shouldWarnOffline = false;
	        this.updateAndBroadcastOnlineState(types_1.OnlineState.Healthy);
	    };
	    RemoteStore.prototype.setOnlineStateToUnknown = function () {
	        // The state is set to unknown when a healthy stream is closed (e.g. due to
	        // a token timeout) or when we have no active listens and therefore there's
	        // no need to start the stream. Assuming there is (possibly in the future)
	        // an active listen, then we will eventually move to state Online or Failed,
	        // but we always want to make at least ONLINE_ATTEMPTS_BEFORE_FAILURE
	        // attempts before failing, so we reset the count here.
	        this.watchStreamFailures = 0;
	        this.updateAndBroadcastOnlineState(types_1.OnlineState.Unknown);
	    };
	    RemoteStore.prototype.updateOnlineStateAfterFailure = function () {
	        // The first failure after we are successfully connected moves us to the
	        // 'Unknown' state. We then may make multiple attempts (based on
	        // ONLINE_ATTEMPTS_BEFORE_FAILURE) before we actually report failure.
	        if (this.watchStreamOnlineState === types_1.OnlineState.Healthy) {
	            this.setOnlineStateToUnknown();
	        }
	        else {
	            this.watchStreamFailures++;
	            if (this.watchStreamFailures >= ONLINE_ATTEMPTS_BEFORE_FAILURE) {
	                if (this.shouldWarnOffline) {
	                    log.debug(LOG_TAG, 'Could not reach Firestore backend.');
	                    this.shouldWarnOffline = false;
	                }
	                this.updateAndBroadcastOnlineState(types_1.OnlineState.Failed);
	            }
	        }
	    };
	    RemoteStore.prototype.updateAndBroadcastOnlineState = function (onlineState) {
	        var didChange = this.watchStreamOnlineState !== onlineState;
	        this.watchStreamOnlineState = onlineState;
	        if (didChange) {
	            this.onlineStateHandler(onlineState);
	        }
	    };
	    RemoteStore.prototype.isNetworkEnabled = function () {
	        assert_1.assert((this.watchStream == null) == (this.writeStream == null), 'WatchStream and WriteStream should both be null or non-null');
	        return this.watchStream != null;
	    };
	    /** Re-enables the network. Only to be called as the counterpart to disableNetwork(). */
	    RemoteStore.prototype.enableNetwork = function () {
	        var _this = this;
	        assert_1.assert(this.watchStream == null, 'enableNetwork() called with non-null watchStream.');
	        assert_1.assert(this.writeStream == null, 'enableNetwork() called with non-null writeStream.');
	        // Create new streams (but note they're not started yet).
	        this.watchStream = this.datastore.newPersistentWatchStream();
	        this.writeStream = this.datastore.newPersistentWriteStream();
	        // Load any saved stream token from persistent storage
	        return this.localStore.getLastStreamToken().then(function (token) {
	            _this.writeStream.lastStreamToken = token;
	            if (_this.shouldStartWatchStream()) {
	                _this.startWatchStream();
	            }
	            _this.updateAndBroadcastOnlineState(types_1.OnlineState.Unknown);
	            return _this.fillWritePipeline(); // This may start the writeStream.
	        });
	    };
	    /** Temporarily disables the network. The network can be re-enabled using enableNetwork(). */
	    RemoteStore.prototype.disableNetwork = function () {
	        this.updateAndBroadcastOnlineState(types_1.OnlineState.Failed);
	        // NOTE: We're guaranteed not to get any further events from these streams (not even a close
	        // event).
	        this.watchStream.stop();
	        this.writeStream.stop();
	        this.cleanUpWatchStreamState();
	        this.cleanUpWriteStreamState();
	        this.writeStream = null;
	        this.watchStream = null;
	        return Promise.resolve();
	    };
	    RemoteStore.prototype.shutdown = function () {
	        log.debug(LOG_TAG, 'RemoteStore shutting down.');
	        this.disableNetwork();
	        return Promise.resolve(undefined);
	    };
	    /** Starts new listen for the given query. Uses resume token if provided */
	    RemoteStore.prototype.listen = function (queryData) {
	        assert_1.assert(!objUtils.contains(this.listenTargets, queryData.targetId), 'listen called with duplicate targetId!');
	        // Mark this as something the client is currently listening for.
	        this.listenTargets[queryData.targetId] = queryData;
	        if (this.shouldStartWatchStream()) {
	            // The listen will be sent in onWatchStreamOpen
	            this.startWatchStream();
	        }
	        else if (this.isNetworkEnabled() && this.watchStream.isOpen()) {
	            this.sendWatchRequest(queryData);
	        }
	    };
	    /** Removes the listen from server */
	    RemoteStore.prototype.unlisten = function (targetId) {
	        assert_1.assert(objUtils.contains(this.listenTargets, targetId), 'unlisten called without assigned target ID!');
	        var queryData = this.listenTargets[targetId];
	        delete this.listenTargets[targetId];
	        if (this.isNetworkEnabled() && this.watchStream.isOpen()) {
	            this.sendUnwatchRequest(targetId);
	            if (objUtils.isEmpty(this.listenTargets)) {
	                this.watchStream.markIdle();
	            }
	        }
	    };
	    /**
	     * We need to increment the the expected number of pending responses we're due
	     * from watch so we wait for the ack to process any messages from this target.
	     */
	    RemoteStore.prototype.sendWatchRequest = function (queryData) {
	        this.recordPendingTargetRequest(queryData.targetId);
	        this.watchStream.watch(queryData);
	    };
	    /**
	     * We need to increment the expected number of pending responses we're due
	     * from watch so we wait for the removal on the server before we process any
	     * messages from this target.
	     */
	    RemoteStore.prototype.sendUnwatchRequest = function (targetId) {
	        this.recordPendingTargetRequest(targetId);
	        this.watchStream.unwatch(targetId);
	    };
	    /**
	     * Increment the mapping of how many acks are needed from watch before we can
	     * consider the server to be 'in-sync' with the client's active targets.
	     */
	    RemoteStore.prototype.recordPendingTargetRequest = function (targetId) {
	        // For each request we get we need to record we need a response for it.
	        this.pendingTargetResponses[targetId] =
	            (this.pendingTargetResponses[targetId] || 0) + 1;
	    };
	    RemoteStore.prototype.startWatchStream = function () {
	        assert_1.assert(this.shouldStartWatchStream(), 'startWriteStream() called when shouldStartWatchStream() is false.');
	        this.watchStream.start({
	            onOpen: this.onWatchStreamOpen.bind(this),
	            onClose: this.onWatchStreamClose.bind(this),
	            onWatchChange: this.onWatchStreamChange.bind(this)
	        });
	    };
	    /**
	     * Returns whether the watch stream should be started because there are
	     * active targets trying to be listened too
	     */
	    RemoteStore.prototype.shouldStartWatchStream = function () {
	        return (this.isNetworkEnabled() &&
	            !this.watchStream.isStarted() &&
	            !objUtils.isEmpty(this.listenTargets));
	    };
	    RemoteStore.prototype.cleanUpWatchStreamState = function () {
	        // If the connection is closed then we'll never get a snapshot version for
	        // the accumulated changes and so we'll never be able to complete the batch.
	        // When we start up again the server is going to resend these changes
	        // anyway, so just toss the accumulated state.
	        this.accumulatedWatchChanges = [];
	        this.pendingTargetResponses = {};
	    };
	    RemoteStore.prototype.onWatchStreamOpen = function () {
	        var _this = this;
	        // TODO(b/35852690): close the stream again (with some timeout?) if no watch
	        // targets are active
	        objUtils.forEachNumber(this.listenTargets, function (targetId, queryData) {
	            _this.sendWatchRequest(queryData);
	        });
	        return Promise.resolve();
	    };
	    RemoteStore.prototype.onWatchStreamClose = function (error) {
	        assert_1.assert(this.isNetworkEnabled(), 'onWatchStreamClose() should only be called when the network is enabled');
	        this.cleanUpWatchStreamState();
	        // If there was an error, retry the connection.
	        if (this.shouldStartWatchStream()) {
	            this.updateOnlineStateAfterFailure();
	            this.startWatchStream();
	        }
	        else {
	            // No need to restart watch stream because there are no active targets.
	            // The online state is set to unknown because there is no active attempt
	            // at establishing a connection
	            this.setOnlineStateToUnknown();
	        }
	        return Promise.resolve();
	    };
	    RemoteStore.prototype.onWatchStreamChange = function (watchChange, snapshotVersion) {
	        // Mark the connection as healthy because we got a message from the server
	        this.setOnlineStateToHealthy();
	        if (watchChange instanceof watch_change_1.WatchTargetChange &&
	            watchChange.state === watch_change_1.WatchTargetChangeState.Removed &&
	            watchChange.cause) {
	            // There was an error on a target, don't wait for a consistent snapshot
	            // to raise events
	            return this.handleTargetError(watchChange);
	        }
	        // Accumulate watch changes but don't process them if there's no
	        // snapshotVersion or it's older than a previous snapshot we've processed
	        // (can happen after we resume a target using a resume token).
	        this.accumulatedWatchChanges.push(watchChange);
	        if (!snapshotVersion.equals(snapshot_version_1.SnapshotVersion.MIN) &&
	            snapshotVersion.compareTo(this.localStore.getLastRemoteSnapshotVersion()) >= 0) {
	            var changes = this.accumulatedWatchChanges;
	            this.accumulatedWatchChanges = [];
	            return this.handleWatchChangeBatch(snapshotVersion, changes);
	        }
	        else {
	            return Promise.resolve();
	        }
	    };
	    /**
	     * Takes a batch of changes from the Datastore, repackages them as a
	     * RemoteEvent, and passes that on to the listener, which is typically the
	     * SyncEngine.
	     */
	    RemoteStore.prototype.handleWatchChangeBatch = function (snapshotVersion, changes) {
	        var _this = this;
	        var aggregator = new watch_change_1.WatchChangeAggregator(snapshotVersion, this.listenTargets, this.pendingTargetResponses);
	        aggregator.addChanges(changes);
	        var remoteEvent = aggregator.createRemoteEvent();
	        // Get the new response counts from the aggregator
	        this.pendingTargetResponses = aggregator.pendingTargetResponses;
	        var promises = [];
	        // Handle existence filters and existence filter mismatches.
	        objUtils.forEachNumber(aggregator.existenceFilters, function (targetId, filter) {
	            var queryData = _this.listenTargets[targetId];
	            if (!queryData) {
	                // A watched target might have been removed already.
	                return;
	            }
	            var query = queryData.query;
	            if (query.isDocumentQuery()) {
	                if (filter.count === 0) {
	                    // The existence filter told us the document does not exist.
	                    // We need to deduce that this document does not exist and apply
	                    // a deleted document to our updates. Without applying a deleted
	                    // document there might be another query that will raise this
	                    // document as part of a snapshot until it is resolved,
	                    // essentially exposing inconsistency between queries.
	                    var key = new document_key_1.DocumentKey(query.path);
	                    var deletedDoc = new document_1.NoDocument(key, snapshotVersion);
	                    remoteEvent.addDocumentUpdate(deletedDoc);
	                }
	                else {
	                    assert_1.assert(filter.count === 1, 'Single document existence filter with count: ' + filter.count);
	                }
	            }
	            else {
	                // Not a document query.
	                var promise = _this.localStore
	                    .remoteDocumentKeys(targetId)
	                    .then(function (trackedRemote) {
	                    if (remoteEvent.targetChanges[targetId]) {
	                        var mapping = remoteEvent.targetChanges[targetId].mapping;
	                        if (mapping !== null) {
	                            if (mapping instanceof remote_event_1.UpdateMapping) {
	                                trackedRemote = mapping.applyToKeySet(trackedRemote);
	                            }
	                            else {
	                                assert_1.assert(mapping instanceof remote_event_1.ResetMapping, 'Expected either reset or update mapping but got something else: ' +
	                                    mapping);
	                                trackedRemote = mapping.documents;
	                            }
	                        }
	                    }
	                    if (trackedRemote.size !== filter.count) {
	                        // Existence filter mismatch, resetting mapping.
	                        // Make sure the mismatch is exposed in the remote event.
	                        remoteEvent.handleExistenceFilterMismatch(targetId);
	                        // Clear the resume token for the query, since we're in a
	                        // known mismatch state.
	                        var newQueryData = new query_data_1.QueryData(query, targetId, queryData.purpose);
	                        _this.listenTargets[targetId] = newQueryData;
	                        // Cause a hard reset by unwatching and rewatching
	                        // immediately, but deliberately don't send a resume token
	                        // so that we get a full update.
	                        // Make sure we expect that this acks are going to happen.
	                        _this.sendUnwatchRequest(targetId);
	                        // Mark the query we send as being on behalf of an existence
	                        // filter mismatch, but don't actually retain that in
	                        // listenTargets. This ensures that we flag the first
	                        // re-listen this way without impacting future listens of
	                        // this target (that might happen e.g. on reconnect).
	                        var requestQueryData = new query_data_1.QueryData(query, targetId, query_data_1.QueryPurpose.ExistenceFilterMismatch);
	                        _this.sendWatchRequest(requestQueryData);
	                    }
	                });
	                promises.push(promise);
	            }
	        });
	        return Promise.all(promises).then(function () {
	            // Update in-memory resume tokens. LocalStore will update the
	            // persistent view of these when applying the completed RemoteEvent.
	            objUtils.forEachNumber(remoteEvent.targetChanges, function (targetId, change) {
	                if (change.resumeToken.length > 0) {
	                    var queryData = _this.listenTargets[targetId];
	                    // A watched target might have been removed already.
	                    if (queryData) {
	                        _this.listenTargets[targetId] = queryData.update({
	                            resumeToken: change.resumeToken,
	                            snapshotVersion: change.snapshotVersion
	                        });
	                    }
	                }
	            });
	            // Finally handle remote event
	            return _this.syncEngine.applyRemoteEvent(remoteEvent);
	        });
	    };
	    /** Handles an error on a target */
	    RemoteStore.prototype.handleTargetError = function (watchChange) {
	        var _this = this;
	        assert_1.assert(!!watchChange.cause, 'Handling target error without a cause');
	        var error = watchChange.cause;
	        var promiseChain = Promise.resolve();
	        watchChange.targetIds.forEach(function (targetId) {
	            promiseChain = promiseChain.then(function () {
	                if (objUtils.contains(_this.listenTargets, targetId)) {
	                    delete _this.listenTargets[targetId];
	                    return _this.syncEngine.rejectListen(targetId, error);
	                }
	                else {
	                    // A watched target might have been removed already.
	                    return Promise.resolve();
	                }
	            });
	        });
	        return promiseChain;
	    };
	    RemoteStore.prototype.cleanUpWriteStreamState = function () {
	        this.lastBatchSeen = mutation_batch_1.BATCHID_UNKNOWN;
	        this.pendingWrites = [];
	    };
	    /**
	     * Notifies that there are new mutations to process in the queue. This is
	     * typically called by SyncEngine after it has sent mutations to LocalStore.
	     */
	    RemoteStore.prototype.fillWritePipeline = function () {
	        var _this = this;
	        if (!this.canWriteMutations()) {
	            return Promise.resolve();
	        }
	        else {
	            return this.localStore
	                .nextMutationBatch(this.lastBatchSeen)
	                .then(function (batch) {
	                if (batch === null) {
	                    if (_this.pendingWrites.length == 0) {
	                        _this.writeStream.markIdle();
	                    }
	                    return Promise.resolve();
	                }
	                else {
	                    _this.commit(batch);
	                    return _this.fillWritePipeline();
	                }
	            });
	        }
	    };
	    /**
	     * Returns true if the backend can accept additional write requests.
	     *
	     * When sending mutations to the write stream (e.g. in fillWritePipeline),
	     * call this method first to check if more mutations can be sent.
	     *
	     * Currently the only thing that can prevent the backend from accepting
	     * write requests is if there are too many requests already outstanding. As
	     * writes complete the backend will be able to accept more.
	     */
	    RemoteStore.prototype.canWriteMutations = function () {
	        return (this.isNetworkEnabled() && this.pendingWrites.length < MAX_PENDING_WRITES);
	    };
	    // For testing
	    RemoteStore.prototype.outstandingWrites = function () {
	        return this.pendingWrites.length;
	    };
	    /**
	     * Given mutations to commit, actually commits them to the Datastore. Note
	     * that this does *not* return a Promise specifically because the AsyncQueue
	     * should not block operations for this.
	     */
	    RemoteStore.prototype.commit = function (batch) {
	        assert_1.assert(this.canWriteMutations(), "commit called when batches can't be written");
	        this.lastBatchSeen = batch.batchId;
	        this.pendingWrites.push(batch);
	        if (this.shouldStartWriteStream()) {
	            this.startWriteStream();
	        }
	        else if (this.isNetworkEnabled() && this.writeStream.handshakeComplete) {
	            this.writeStream.writeMutations(batch.mutations);
	        }
	    };
	    RemoteStore.prototype.shouldStartWriteStream = function () {
	        return (this.isNetworkEnabled() &&
	            !this.writeStream.isStarted() &&
	            this.pendingWrites.length > 0);
	    };
	    RemoteStore.prototype.startWriteStream = function () {
	        assert_1.assert(this.shouldStartWriteStream(), 'startWriteStream() called when shouldStartWriteStream() is false.');
	        this.writeStream.start({
	            onOpen: this.onWriteStreamOpen.bind(this),
	            onClose: this.onWriteStreamClose.bind(this),
	            onHandshakeComplete: this.onWriteHandshakeComplete.bind(this),
	            onMutationResult: this.onMutationResult.bind(this)
	        });
	    };
	    RemoteStore.prototype.onWriteStreamOpen = function () {
	        this.writeStream.writeHandshake();
	        return Promise.resolve();
	    };
	    RemoteStore.prototype.onWriteHandshakeComplete = function () {
	        var _this = this;
	        // Record the stream token.
	        return this.localStore
	            .setLastStreamToken(this.writeStream.lastStreamToken)
	            .then(function () {
	            // Drain any pending writes.
	            //
	            // Note that at this point pendingWrites contains mutations that
	            // have already been accepted by fillWritePipeline/commitBatch. If
	            // the pipeline is full, canWriteMutations will be false, despite
	            // the fact that we actually need to send mutations over.
	            //
	            // This also means that this method indirectly respects the limits
	            // imposed by canWriteMutations since writes can't be added to the
	            // pendingWrites array when canWriteMutations is false. If the
	            // limits imposed by canWriteMutations actually protect us from
	            // DOSing ourselves then those limits won't be exceeded here and
	            // we'll continue to make progress.
	            for (var _i = 0, _a = _this.pendingWrites; _i < _a.length; _i++) {
	                var batch = _a[_i];
	                _this.writeStream.writeMutations(batch.mutations);
	            }
	        });
	    };
	    RemoteStore.prototype.onMutationResult = function (commitVersion, results) {
	        var _this = this;
	        // This is a response to a write containing mutations and should be
	        // correlated to the first pending write.
	        assert_1.assert(this.pendingWrites.length > 0, 'Got result for empty pending writes');
	        var batch = this.pendingWrites.shift();
	        var success = mutation_batch_1.MutationBatchResult.from(batch, commitVersion, results, this.writeStream.lastStreamToken);
	        return this.syncEngine.applySuccessfulWrite(success).then(function () {
	            // It's possible that with the completion of this mutation another
	            // slot has freed up.
	            return _this.fillWritePipeline();
	        });
	    };
	    RemoteStore.prototype.onWriteStreamClose = function (error) {
	        var _this = this;
	        assert_1.assert(this.isNetworkEnabled(), 'onWriteStreamClose() should only be called when the network is enabled');
	        // If the write stream closed due to an error, invoke the error callbacks if
	        // there are pending writes.
	        if (error && this.pendingWrites.length > 0) {
	            assert_1.assert(!!error, 'We have pending writes, but the write stream closed without an error');
	            // A promise that is resolved after we processed the error
	            var errorHandling = void 0;
	            if (this.writeStream.handshakeComplete) {
	                // This error affects the actual write.
	                errorHandling = this.handleWriteError(error);
	            }
	            else {
	                // If there was an error before the handshake has finished, it's
	                // possible that the server is unable to process the stream token
	                // we're sending. (Perhaps it's too old?)
	                errorHandling = this.handleHandshakeError(error);
	            }
	            return errorHandling.then(function () {
	                // The write stream might have been started by refilling the write
	                // pipeline for failed writes
	                if (_this.shouldStartWriteStream()) {
	                    _this.startWriteStream();
	                }
	            });
	        }
	        else {
	            // No pending writes, nothing to do
	            return Promise.resolve();
	        }
	    };
	    RemoteStore.prototype.handleHandshakeError = function (error) {
	        // Reset the token if it's a permanent error or the error code is
	        // ABORTED, signaling the write stream is no longer valid.
	        if (rpc_error_1.isPermanentError(error.code) || error.code === error_1.Code.ABORTED) {
	            log.debug(LOG_TAG, 'RemoteStore error before completed handshake; resetting stream token: ', this.writeStream.lastStreamToken);
	            this.writeStream.lastStreamToken = platform_1.emptyByteString();
	            return this.localStore.setLastStreamToken(platform_1.emptyByteString());
	        }
	        else {
	            // Some other error, don't reset stream token. Our stream logic will
	            // just retry with exponential backoff.
	            return Promise.resolve();
	        }
	    };
	    RemoteStore.prototype.handleWriteError = function (error) {
	        var _this = this;
	        if (rpc_error_1.isPermanentError(error.code)) {
	            // This was a permanent error, the request itself was the problem
	            // so it's not going to succeed if we resend it.
	            var batch = this.pendingWrites.shift();
	            // In this case it's also unlikely that the server itself is melting
	            // down -- this was just a bad request so inhibit backoff on the next
	            // restart.
	            this.writeStream.inhibitBackoff();
	            return this.syncEngine
	                .rejectFailedWrite(batch.batchId, error)
	                .then(function () {
	                // It's possible that with the completion of this mutation
	                // another slot has freed up.
	                return _this.fillWritePipeline();
	            });
	        }
	        else {
	            // Transient error, just let the retry logic kick in.
	            return Promise.resolve();
	        }
	    };
	    RemoteStore.prototype.createTransaction = function () {
	        return new transaction_1.Transaction(this.datastore);
	    };
	    RemoteStore.prototype.handleUserChange = function (user) {
	        log.debug(LOG_TAG, 'RemoteStore changing users: uid=', user.uid);
	        // Tear down and re-create our network streams. This will ensure we get a fresh auth token
	        // for the new user and re-fill the write pipeline with new mutations from the LocalStore
	        // (since mutations are per-user).
	        this.disableNetwork();
	        return this.enableNetwork();
	    };
	    return RemoteStore;
	}());
	exports.RemoteStore = RemoteStore;
	
	//# sourceMappingURL=remote_store.js.map


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(10);
	/**
	 * Provides a simple helper class that implements the Stream interface to
	 * bridge to other implementations that are streams but do not implement the
	 * interface. The stream callbacks are invoked with the callOn... methods.
	 */
	var StreamBridge = /** @class */ (function () {
	    function StreamBridge(args) {
	        this.wrappedOnOpen = null;
	        this.wrappedOnClose = null;
	        this.wrappedOnMessage = null;
	        this.sendFn = args.sendFn;
	        this.closeFn = args.closeFn;
	    }
	    StreamBridge.prototype.onOpen = function (callback) {
	        assert_1.assert(!this.wrappedOnOpen, 'Called onOpen on stream twice!');
	        this.wrappedOnOpen = callback;
	    };
	    StreamBridge.prototype.onClose = function (callback) {
	        assert_1.assert(!this.wrappedOnClose, 'Called onClose on stream twice!');
	        this.wrappedOnClose = callback;
	    };
	    StreamBridge.prototype.onMessage = function (callback) {
	        assert_1.assert(!this.wrappedOnMessage, 'Called onMessage on stream twice!');
	        this.wrappedOnMessage = callback;
	    };
	    StreamBridge.prototype.close = function () {
	        this.closeFn();
	    };
	    StreamBridge.prototype.send = function (msg) {
	        this.sendFn(msg);
	    };
	    StreamBridge.prototype.callOnOpen = function () {
	        assert_1.assert(this.wrappedOnOpen !== null, 'Cannot call onOpen because no callback ' + 'was set');
	        this.wrappedOnOpen();
	    };
	    StreamBridge.prototype.callOnClose = function (err) {
	        assert_1.assert(this.wrappedOnClose !== null, 'Cannot call onClose because no ' + 'callback was set');
	        this.wrappedOnClose(err);
	    };
	    StreamBridge.prototype.callOnMessage = function (msg) {
	        assert_1.assert(this.wrappedOnMessage !== null, 'Cannot call onMessage because no ' + 'callback was set');
	        this.wrappedOnMessage(msg);
	    };
	    return StreamBridge;
	}());
	exports.StreamBridge = StreamBridge;
	
	//# sourceMappingURL=stream_bridge.js.map


/***/ },
/* 488 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * A wrapper implementation of Observer<T> that will dispatch events
	 * asynchronously. To allow immediate silencing, a mute call is added which
	 * causes events scheduled to no longer be raised.
	 */
	var AsyncObserver = /** @class */ (function () {
	    function AsyncObserver(observer) {
	        this.observer = observer;
	        /**
	         * When set to true, will not raise future events. Necessary to deal with
	         * async detachment of listener.
	         */
	        this.muted = false;
	    }
	    AsyncObserver.prototype.next = function (value) {
	        this.scheduleEvent(this.observer.next, value);
	    };
	    AsyncObserver.prototype.error = function (error) {
	        this.scheduleEvent(this.observer.error, error);
	    };
	    AsyncObserver.prototype.mute = function () {
	        this.muted = true;
	    };
	    AsyncObserver.prototype.scheduleEvent = function (eventHandler, event) {
	        var _this = this;
	        if (!this.muted) {
	            setTimeout(function () {
	                if (!_this.muted) {
	                    eventHandler(event);
	                }
	            }, 0);
	        }
	    };
	    return AsyncObserver;
	}());
	exports.AsyncObserver = AsyncObserver;
	
	//# sourceMappingURL=async_observer.js.map


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(10);
	var log = __webpack_require__(24);
	var promise_1 = __webpack_require__(130);
	var error_1 = __webpack_require__(19);
	var AsyncQueue = /** @class */ (function () {
	    function AsyncQueue() {
	        // The last promise in the queue.
	        this.tail = Promise.resolve();
	        // A list with timeout handles and their respective deferred promises.
	        // Contains an entry for each operation that is queued to run in the future
	        // (i.e. it has a delay that has not yet elapsed). Prior to cleanup, this list
	        // may also contain entries that have already been run (in which case `handle` is
	        // null).
	        this.delayedOperations = [];
	        // The number of operations that are queued to be run in the future (i.e. they
	        // have a delay that has not yet elapsed). Unlike `delayedOperations`, this
	        // is guaranteed to only contain operations that have not yet been run.
	        //
	        // Visible for testing.
	        this.delayedOperationsCount = 0;
	        // Flag set while there's an outstanding AsyncQueue operation, used for
	        // assertion sanity-checks.
	        this.operationInProgress = false;
	    }
	    /**
	     * Adds a new operation to the queue. Returns a promise that will be resolved
	     * when the promise returned by the new operation is (with its value).
	     *
	     * Can optionally specify a delay (in milliseconds) to wait before queuing the
	     * operation.
	     */
	    AsyncQueue.prototype.schedule = function (op, delay) {
	        var _this = this;
	        if (this.failure) {
	            assert_1.fail('AsyncQueue is already failed: ' +
	                (this.failure.stack || this.failure.message));
	        }
	        if ((delay || 0) > 0) {
	            this.delayedOperationsCount++;
	            var delayedOp_1 = {
	                handle: null,
	                op: op,
	                deferred: new promise_1.Deferred()
	            };
	            delayedOp_1.handle = setTimeout(function () {
	                _this.scheduleInternal(function () {
	                    return delayedOp_1.op().then(function (result) {
	                        delayedOp_1.deferred.resolve(result);
	                    });
	                });
	                delayedOp_1.handle = null;
	                _this.delayedOperationsCount--;
	                if (_this.delayedOperationsCount === 0) {
	                    _this.delayedOperations = [];
	                }
	            }, delay);
	            this.delayedOperations.push(delayedOp_1);
	            return delayedOp_1.deferred.promise;
	        }
	        else {
	            return this.scheduleInternal(op);
	        }
	    };
	    AsyncQueue.prototype.scheduleInternal = function (op) {
	        var _this = this;
	        this.tail = this.tail.then(function () {
	            _this.operationInProgress = true;
	            return op()
	                .catch(function (error) {
	                _this.failure = error;
	                _this.operationInProgress = false;
	                var message = error.stack || error.message || '';
	                log.error('INTERNAL UNHANDLED ERROR: ', message);
	                // Escape the promise chain and throw the error globally so that
	                // e.g. any global crash reporting library detects and reports it.
	                // (but not for simulated errors in our tests since this breaks mocha)
	                if (message.indexOf('Firestore Test Simulated Error') < 0) {
	                    setTimeout(function () {
	                        throw error;
	                    }, 0);
	                }
	                // Re-throw the error so that this.tail becomes a rejected Promise and
	                // all further attempts to chain (via .then) will just short-circuit
	                // and return the rejected Promise.
	                throw error;
	            })
	                .then(function () {
	                _this.operationInProgress = false;
	            });
	        });
	        return this.tail;
	    };
	    /**
	     * Verifies there's an operation currently in-progress on the AsyncQueue.
	     * Unfortunately we can't verify that the running code is in the promise chain
	     * of that operation, so this isn't a foolproof check, but it should be enough
	     * to catch some bugs.
	     */
	    AsyncQueue.prototype.verifyOperationInProgress = function () {
	        assert_1.assert(this.operationInProgress, 'verifyOpInProgress() called when no op in progress on this queue.');
	    };
	    /**
	     * Waits until all currently scheduled tasks are finished executing. Tasks
	     * scheduled with a delay can be rejected or queued for immediate execution.
	     */
	    AsyncQueue.prototype.drain = function (executeDelayedTasks) {
	        var _this = this;
	        this.delayedOperations.forEach(function (entry) {
	            if (entry.handle) {
	                clearTimeout(entry.handle);
	                if (executeDelayedTasks) {
	                    _this.scheduleInternal(entry.op).then(entry.deferred.resolve, entry.deferred.reject);
	                }
	                else {
	                    entry.deferred.reject(new error_1.FirestoreError(error_1.Code.CANCELLED, 'Operation cancelled by shutdown'));
	                }
	            }
	        });
	        this.delayedOperations = [];
	        this.delayedOperationsCount = 0;
	        return this.schedule(function () { return Promise.resolve(); });
	    };
	    return AsyncQueue;
	}());
	exports.AsyncQueue = AsyncQueue;
	
	//# sourceMappingURL=async_queue.js.map


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	var window_controller_1 = __webpack_require__(492);
	var sw_controller_1 = __webpack_require__(491);
	var app_1 = __webpack_require__(35);
	function registerMessaging(instance) {
	    var messagingName = 'messaging';
	    var factoryMethod = function (app) {
	        if (self && 'ServiceWorkerGlobalScope' in self) {
	            return new sw_controller_1.default(app);
	        }
	        // Assume we are in the window context.
	        return new window_controller_1.default(app);
	    };
	    var namespaceExports = {
	        // no-inline
	        Messaging: window_controller_1.default
	    };
	    instance.INTERNAL.registerService(messagingName, factoryMethod, namespaceExports);
	}
	exports.registerMessaging = registerMessaging;
	registerMessaging(app_1.default);
	
	//# sourceMappingURL=index.js.map


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	'use strict';
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var controller_interface_1 = __webpack_require__(197);
	var errors_1 = __webpack_require__(98);
	var worker_page_message_1 = __webpack_require__(200);
	var fcm_details_1 = __webpack_require__(198);
	var FCM_MSG = 'FCM_MSG';
	var SWController = /** @class */ (function (_super) {
	    __extends(SWController, _super);
	    function SWController(app) {
	        var _this = _super.call(this, app) || this;
	        self.addEventListener('push', function (e) { return _this.onPush_(e); }, false);
	        self.addEventListener('pushsubscriptionchange', function (e) { return _this.onSubChange_(e); }, false);
	        self.addEventListener('notificationclick', function (e) { return _this.onNotificationClick_(e); }, false);
	        /**
	         * @private
	         * @type {function(Object)|null}
	         */
	        _this.bgMessageHandler_ = null;
	        return _this;
	    }
	    /**
	     * A handler for push events that shows notifications based on the content of
	     * the payload.
	     *
	     * The payload must be a JSON-encoded Object with a `notification` key. The
	     * value of the `notification` property will be used as the NotificationOptions
	     * object passed to showNotification. Additionally, the `title` property of the
	     * notification object will be used as the title.
	     *
	     * If there is no notification data in the payload then no notification will be
	     * shown.
	     * @private
	     */
	    SWController.prototype.onPush_ = function (event) {
	        var _this = this;
	        var msgPayload;
	        try {
	            msgPayload = event.data.json();
	        }
	        catch (err) {
	            // Not JSON so not an FCM message
	            return;
	        }
	        var handleMsgPromise = this.hasVisibleClients_().then(function (hasVisibleClients) {
	            if (hasVisibleClients) {
	                // Do not need to show a notification.
	                if (msgPayload.notification || _this.bgMessageHandler_) {
	                    // Send to page
	                    return _this.sendMessageToWindowClients_(msgPayload);
	                }
	                return;
	            }
	            var notificationDetails = _this.getNotificationData_(msgPayload);
	            if (notificationDetails) {
	                var notificationTitle = notificationDetails.title || '';
	                return self.registration.showNotification(notificationTitle, notificationDetails);
	            }
	            else if (_this.bgMessageHandler_) {
	                return _this.bgMessageHandler_(msgPayload);
	            }
	        });
	        event.waitUntil(handleMsgPromise);
	    };
	    /**
	     * @private
	     */
	    SWController.prototype.onSubChange_ = function (event) {
	        var _this = this;
	        var promiseChain = this.getToken().then(function (token) {
	            if (!token) {
	                // We can't resubscribe if we don't have an FCM token for this scope.
	                throw _this.errorFactory_.create(errors_1.default.codes.NO_FCM_TOKEN_FOR_RESUBSCRIBE);
	            }
	            var tokenDetails = null;
	            var tokenManager = _this.getTokenManager();
	            return tokenManager
	                .getTokenDetailsFromToken(token)
	                .then(function (details) {
	                tokenDetails = details;
	                if (!tokenDetails) {
	                    throw _this.errorFactory_.create(errors_1.default.codes.INVALID_SAVED_TOKEN);
	                }
	                // Attempt to get a new subscription
	                return self.registration.pushManager.subscribe(fcm_details_1.default.SUBSCRIPTION_OPTIONS);
	            })
	                .then(function (newSubscription) {
	                // Send new subscription to FCM.
	                return tokenManager.subscribeToFCM(tokenDetails.fcmSenderId, newSubscription, tokenDetails.fcmPushSet);
	            })
	                .catch(function (err) {
	                // The best thing we can do is log this to the terminal so
	                // developers might notice the error.
	                return tokenManager.deleteToken(tokenDetails.fcmToken).then(function () {
	                    throw _this.errorFactory_.create(errors_1.default.codes.UNABLE_TO_RESUBSCRIBE, {
	                        message: err
	                    });
	                });
	            });
	        });
	        event.waitUntil(promiseChain);
	    };
	    /**
	     * @private
	     */
	    SWController.prototype.onNotificationClick_ = function (event) {
	        var _this = this;
	        if (!(event.notification &&
	            event.notification.data &&
	            event.notification.data[FCM_MSG])) {
	            // Not an FCM notification, do nothing.
	            return;
	        }
	        // Prevent other listeners from receiving the event
	        event.stopImmediatePropagation();
	        event.notification.close();
	        var msgPayload = event.notification.data[FCM_MSG];
	        var clickAction = msgPayload['notification']['click_action'];
	        if (!clickAction) {
	            // Nothing to do.
	            return;
	        }
	        var promiseChain = this.getWindowClient_(clickAction)
	            .then(function (windowClient) {
	            if (!windowClient) {
	                // Unable to find window client so need to open one.
	                return self.clients.openWindow(clickAction);
	            }
	            return windowClient;
	        })
	            .then(function (windowClient) {
	            if (!windowClient) {
	                // Window Client will not be returned if it's for a third party origin.
	                return;
	            }
	            // Delete notification data from payload before sending to the page.
	            var notificationData = msgPayload['notification'];
	            delete msgPayload['notification'];
	            var internalMsg = worker_page_message_1.default.createNewMsg(worker_page_message_1.default.TYPES_OF_MSG.NOTIFICATION_CLICKED, msgPayload);
	            // Attempt to send a message to the client to handle the data
	            // Is affected by: https://github.com/slightlyoff/ServiceWorker/issues/728
	            return _this.attemptToMessageClient_(windowClient, internalMsg);
	        });
	        event.waitUntil(promiseChain);
	    };
	    /**
	     * @private
	     * @param {Object} msgPayload
	     * @return {NotificationOptions|undefined}
	     */
	    SWController.prototype.getNotificationData_ = function (msgPayload) {
	        if (!msgPayload) {
	            return;
	        }
	        if (typeof msgPayload.notification !== 'object') {
	            return;
	        }
	        var notificationInformation = Object.assign({}, msgPayload.notification);
	        // Put the message payload under FCM_MSG name so we can identify the
	        // notification as being an FCM notification vs a notification from
	        // somewhere else (i.e. normal web push or developer generated
	        // notification).
	        notificationInformation['data'] = (_a = {},
	            _a[FCM_MSG] = msgPayload,
	            _a);
	        return notificationInformation;
	        var _a;
	    };
	    /**
	     * Calling setBackgroundMessageHandler will opt in to some specific
	     * behaviours.
	     * 1.) If a notification doesn't need to be shown due to a window already
	     * being visible, then push messages will be sent to the page.
	     * 2.) If a notification needs to be shown, and the message contains no
	     * notification data this method will be called
	     * and the promise it returns will be passed to event.waitUntil.
	     * If you do not set this callback then all push messages will let and the
	     * developer can handle them in a their own 'push' event callback
	     * @export
	     * @param {function(Object)} callback The callback to be called when a push
	     * message is received and a notification must be shown. The callback will
	     * be given the data from the push message.
	     */
	    SWController.prototype.setBackgroundMessageHandler = function (callback) {
	        if (callback && typeof callback !== 'function') {
	            throw this.errorFactory_.create(errors_1.default.codes.BG_HANDLER_FUNCTION_EXPECTED);
	        }
	        this.bgMessageHandler_ = callback;
	    };
	    /**
	     * @private
	     * @param {string} url The URL to look for when focusing a client.
	     * @return {Object} Returns an existing window client or a newly opened
	     * WindowClient.
	     */
	    SWController.prototype.getWindowClient_ = function (url) {
	        // Use URL to normalize the URL when comparing to windowClients.
	        // This at least handles whether to include trailing slashes or not
	        var parsedURL = new URL(url).href;
	        return self.clients
	            .matchAll({
	            type: 'window',
	            includeUncontrolled: true
	        })
	            .then(function (clientList) {
	            var suitableClient = null;
	            for (var i = 0; i < clientList.length; i++) {
	                var parsedClientUrl = new URL(clientList[i].url).href;
	                if (parsedClientUrl === parsedURL) {
	                    suitableClient = clientList[i];
	                    break;
	                }
	            }
	            if (suitableClient) {
	                suitableClient.focus();
	                return suitableClient;
	            }
	        });
	    };
	    /**
	     * This message will attempt to send the message to a window client.
	     * @private
	     * @param {Object} client The WindowClient to send the message to.
	     * @param {Object} message The message to send to the client.
	     * @returns {Promise} Returns a promise that resolves after sending the
	     * message. This does not guarantee that the message was successfully
	     * received.
	     */
	    SWController.prototype.attemptToMessageClient_ = function (client, message) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            if (!client) {
	                return reject(_this.errorFactory_.create(errors_1.default.codes.NO_WINDOW_CLIENT_TO_MSG));
	            }
	            client.postMessage(message);
	            resolve();
	        });
	    };
	    /**
	     * @private
	     * @returns {Promise<boolean>} If there is currently a visible WindowClient,
	     * this method will resolve to true, otherwise false.
	     */
	    SWController.prototype.hasVisibleClients_ = function () {
	        return self.clients
	            .matchAll({
	            type: 'window',
	            includeUncontrolled: true
	        })
	            .then(function (clientList) {
	            return clientList.some(function (client) { return client.visibilityState === 'visible'; });
	        });
	    };
	    /**
	     * @private
	     * @param {Object} msgPayload The data from the push event that should be sent
	     * to all available pages.
	     * @returns {Promise} Returns a promise that resolves once the message
	     * has been sent to all WindowClients.
	     */
	    SWController.prototype.sendMessageToWindowClients_ = function (msgPayload) {
	        var _this = this;
	        return self.clients
	            .matchAll({
	            type: 'window',
	            includeUncontrolled: true
	        })
	            .then(function (clientList) {
	            var internalMsg = worker_page_message_1.default.createNewMsg(worker_page_message_1.default.TYPES_OF_MSG.PUSH_MSG_RECEIVED, msgPayload);
	            return Promise.all(clientList.map(function (client) {
	                return _this.attemptToMessageClient_(client, internalMsg);
	            }));
	        });
	    };
	    /**
	     * This will register the default service worker and return the registration.
	     * @private
	     * @return {Promise<!ServiceWorkerRegistration>} The service worker
	     * registration to be used for the push service.
	     */
	    SWController.prototype.getSWRegistration_ = function () {
	        return Promise.resolve(self.registration);
	    };
	    return SWController;
	}(controller_interface_1.default));
	exports.default = SWController;
	
	//# sourceMappingURL=sw-controller.js.map


/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	'use strict';
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var controller_interface_1 = __webpack_require__(197);
	var errors_1 = __webpack_require__(98);
	var worker_page_message_1 = __webpack_require__(200);
	var default_sw_1 = __webpack_require__(494);
	var notification_permission_1 = __webpack_require__(199);
	var util_1 = __webpack_require__(2);
	var WindowController = /** @class */ (function (_super) {
	    __extends(WindowController, _super);
	    /**
	     * A service that provides a MessagingService instance.
	     * @param {!firebase.app.App} app
	     */
	    function WindowController(app) {
	        var _this = _super.call(this, app) || this;
	        /**
	         * @private
	         * @type {ServiceWorkerRegistration}
	         */
	        _this.registrationToUse_;
	        /**
	         * @private
	         * @type {Promise}
	         */
	        _this.manifestCheckPromise_;
	        /**
	         * @private
	         * @type {firebase.Observer}
	         */
	        _this.messageObserver_ = null;
	        /**
	         * @private {!firebase.Subscribe} The subscribe function to the onMessage
	         * observer.
	         */
	        _this.onMessage_ = util_1.createSubscribe(function (observer) {
	            _this.messageObserver_ = observer;
	        });
	        /**
	         * @private
	         * @type {firebase.Observer}
	         */
	        _this.tokenRefreshObserver_ = null;
	        _this.onTokenRefresh_ = util_1.createSubscribe(function (observer) {
	            _this.tokenRefreshObserver_ = observer;
	        });
	        _this.setupSWMessageListener_();
	        return _this;
	    }
	    /**
	     * This method returns an FCM token if it can be generated.
	     * The return promise will reject if the browser doesn't support
	     * FCM, if permission is denied for notifications or it's not
	     * possible to generate a token.
	     * @export
	     * @return {Promise<string> | Promise<null>} Returns a promise the
	     * resolves to an FCM token or null if permission isn't granted.
	     */
	    WindowController.prototype.getToken = function () {
	        var _this = this;
	        // Check that the required API's are available
	        if (!this.isSupported_()) {
	            return Promise.reject(this.errorFactory_.create(errors_1.default.codes.UNSUPPORTED_BROWSER));
	        }
	        return this.manifestCheck_().then(function () {
	            return _super.prototype.getToken.call(_this);
	        });
	    };
	    /**
	     * The method checks that a manifest is defined and has the correct GCM
	     * sender ID.
	     * @private
	     * @return {Promise} Returns a promise that resolves if the manifest matches
	     * our required sender ID
	     */
	    WindowController.prototype.manifestCheck_ = function () {
	        var _this = this;
	        if (this.manifestCheckPromise_) {
	            return this.manifestCheckPromise_;
	        }
	        var manifestTag = document.querySelector('link[rel="manifest"]');
	        if (!manifestTag) {
	            this.manifestCheckPromise_ = Promise.resolve();
	        }
	        else {
	            this.manifestCheckPromise_ = fetch(manifestTag.href)
	                .then(function (response) {
	                return response.json();
	            })
	                .catch(function () {
	                // If the download or parsing fails allow check.
	                // We only want to error if we KNOW that the gcm_sender_id is incorrect.
	                return Promise.resolve();
	            })
	                .then(function (manifestContent) {
	                if (!manifestContent) {
	                    return;
	                }
	                if (!manifestContent['gcm_sender_id']) {
	                    return;
	                }
	                if (manifestContent['gcm_sender_id'] !== '103953800507') {
	                    throw _this.errorFactory_.create(errors_1.default.codes.INCORRECT_GCM_SENDER_ID);
	                }
	            });
	        }
	        return this.manifestCheckPromise_;
	    };
	    /**
	     * Request permission if it is not currently granted
	     * @export
	     * @returns {Promise} Resolves if the permission was granted, otherwise
	     * rejects
	     */
	    WindowController.prototype.requestPermission = function () {
	        var _this = this;
	        if (Notification.permission === notification_permission_1.default.granted) {
	            return Promise.resolve();
	        }
	        return new Promise(function (resolve, reject) {
	            var managePermissionResult = function (result) {
	                if (result === notification_permission_1.default.granted) {
	                    return resolve();
	                }
	                else if (result === notification_permission_1.default.denied) {
	                    return reject(_this.errorFactory_.create(errors_1.default.codes.PERMISSION_BLOCKED));
	                }
	                else {
	                    return reject(_this.errorFactory_.create(errors_1.default.codes.PERMISSION_DEFAULT));
	                }
	            };
	            // The Notification.requestPermission API was changed to
	            // return a promise so now have to handle both in case
	            // browsers stop support callbacks for promised version
	            var permissionPromise = Notification.requestPermission(function (result) {
	                if (permissionPromise) {
	                    // Let the promise manage this
	                    return;
	                }
	                managePermissionResult(result);
	            });
	            if (permissionPromise) {
	                // Prefer the promise version as it's the future API.
	                permissionPromise.then(managePermissionResult);
	            }
	        });
	    };
	    /**
	     * This method allows a developer to override the default service worker and
	     * instead use a custom service worker.
	     * @export
	     * @param {!ServiceWorkerRegistration} registration The service worker
	     * registration that should be used to receive the push messages.
	     */
	    WindowController.prototype.useServiceWorker = function (registration) {
	        if (!(registration instanceof ServiceWorkerRegistration)) {
	            throw this.errorFactory_.create(errors_1.default.codes.SW_REGISTRATION_EXPECTED);
	        }
	        if (typeof this.registrationToUse_ !== 'undefined') {
	            throw this.errorFactory_.create(errors_1.default.codes.USE_SW_BEFORE_GET_TOKEN);
	        }
	        this.registrationToUse_ = registration;
	    };
	    /**
	     * @export
	     * @param {!firebase.Observer|function(*)} nextOrObserver An observer object
	     * or a function triggered on message.
	     * @param {function(!Error)=} optError Optional A function triggered on
	     * message error.
	     * @param {function()=} optCompleted Optional function triggered when the
	     * observer is removed.
	     * @return {!function()} The unsubscribe function for the observer.
	     */
	    WindowController.prototype.onMessage = function (nextOrObserver, optError, optCompleted) {
	        return this.onMessage_(nextOrObserver, optError, optCompleted);
	    };
	    /**
	     * @export
	     * @param {!firebase.Observer|function()} nextOrObserver An observer object
	     * or a function triggered on token refresh.
	     * @param {function(!Error)=} optError Optional A function
	     * triggered on token refresh error.
	     * @param {function()=} optCompleted Optional function triggered when the
	     * observer is removed.
	     * @return {!function()} The unsubscribe function for the observer.
	     */
	    WindowController.prototype.onTokenRefresh = function (nextOrObserver, optError, optCompleted) {
	        return this.onTokenRefresh_(nextOrObserver, optError, optCompleted);
	    };
	    /**
	     * Given a registration, wait for the service worker it relates to
	     * become activer
	     * @private
	     * @param  {ServiceWorkerRegistration} registration Registration to wait
	     * for service worker to become active
	     * @return {Promise<!ServiceWorkerRegistration>} Wait for service worker
	     * registration to become active
	     */
	    WindowController.prototype.waitForRegistrationToActivate_ = function (registration) {
	        var _this = this;
	        var serviceWorker = registration.installing || registration.waiting || registration.active;
	        return new Promise(function (resolve, reject) {
	            if (!serviceWorker) {
	                // This is a rare scenario but has occured in firefox
	                reject(_this.errorFactory_.create(errors_1.default.codes.NO_SW_IN_REG));
	                return;
	            }
	            // Because the Promise function is called on next tick there is a
	            // small chance that the worker became active or redundant already.
	            if (serviceWorker.state === 'activated') {
	                resolve(registration);
	                return;
	            }
	            if (serviceWorker.state === 'redundant') {
	                reject(_this.errorFactory_.create(errors_1.default.codes.SW_REG_REDUNDANT));
	                return;
	            }
	            var stateChangeListener = function () {
	                if (serviceWorker.state === 'activated') {
	                    resolve(registration);
	                }
	                else if (serviceWorker.state === 'redundant') {
	                    reject(_this.errorFactory_.create(errors_1.default.codes.SW_REG_REDUNDANT));
	                }
	                else {
	                    // Return early and wait to next state change
	                    return;
	                }
	                serviceWorker.removeEventListener('statechange', stateChangeListener);
	            };
	            serviceWorker.addEventListener('statechange', stateChangeListener);
	        });
	    };
	    /**
	     * This will regiater the default service worker and return the registration
	     * @private
	     * @return {Promise<!ServiceWorkerRegistration>} The service worker
	     * registration to be used for the push service.
	     */
	    WindowController.prototype.getSWRegistration_ = function () {
	        var _this = this;
	        if (this.registrationToUse_) {
	            return this.waitForRegistrationToActivate_(this.registrationToUse_);
	        }
	        // Make the registration null so we know useServiceWorker will not
	        // use a new service worker as registrationToUse_ is no longer undefined
	        this.registrationToUse_ = null;
	        return navigator.serviceWorker
	            .register(default_sw_1.default.path, {
	            scope: default_sw_1.default.scope
	        })
	            .catch(function (err) {
	            throw _this.errorFactory_.create(errors_1.default.codes.FAILED_DEFAULT_REGISTRATION, {
	                browserErrorMessage: err.message
	            });
	        })
	            .then(function (registration) {
	            return _this.waitForRegistrationToActivate_(registration).then(function () {
	                _this.registrationToUse_ = registration;
	                // We update after activation due to an issue with Firefox v49 where
	                // a race condition occassionally causes the service work to not
	                // install
	                registration.update();
	                return registration;
	            });
	        });
	    };
	    /**
	     * This method will set up a message listener to handle
	     * events from the service worker that should trigger
	     * events in the page.
	     *
	     * @private
	     */
	    WindowController.prototype.setupSWMessageListener_ = function () {
	        var _this = this;
	        if (!('serviceWorker' in navigator)) {
	            return;
	        }
	        navigator.serviceWorker.addEventListener('message', function (event) {
	            if (!event.data || !event.data[worker_page_message_1.default.PARAMS.TYPE_OF_MSG]) {
	                // Not a message from FCM
	                return;
	            }
	            var workerPageMessage = event.data;
	            switch (workerPageMessage[worker_page_message_1.default.PARAMS.TYPE_OF_MSG]) {
	                case worker_page_message_1.default.TYPES_OF_MSG.PUSH_MSG_RECEIVED:
	                case worker_page_message_1.default.TYPES_OF_MSG.NOTIFICATION_CLICKED:
	                    var pushMessage = workerPageMessage[worker_page_message_1.default.PARAMS.DATA];
	                    _this.messageObserver_.next(pushMessage);
	                    break;
	                default:
	                    // Noop.
	                    break;
	            }
	        }, false);
	    };
	    /**
	     * Checks to see if the required API's are valid or not.
	     * @private
	     * @return {boolean} Returns true if the desired APIs are available.
	     */
	    WindowController.prototype.isSupported_ = function () {
	        return ('serviceWorker' in navigator &&
	            'PushManager' in window &&
	            'Notification' in window &&
	            'fetch' in window &&
	            ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
	            PushSubscription.prototype.hasOwnProperty('getKey'));
	    };
	    return WindowController;
	}(controller_interface_1.default));
	exports.default = WindowController;
	
	//# sourceMappingURL=window-controller.js.map


/***/ },
/* 493 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function toBase64(arrayBuffer) {
	    var uint8Version = new Uint8Array(arrayBuffer);
	    return window.btoa(String.fromCharCode.apply(null, uint8Version));
	}
	exports.default = function (arrayBuffer) {
	    var base64String = toBase64(arrayBuffer);
	    return base64String
	        .replace(/=/g, '')
	        .replace(/\+/g, '-')
	        .replace(/\//g, '_');
	};
	
	//# sourceMappingURL=array-buffer-to-base64.js.map


/***/ },
/* 494 */
/***/ function(module, exports) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    path: '/firebase-messaging-sw.js',
	    scope: '/firebase-cloud-messaging-push-scope'
	};
	
	//# sourceMappingURL=default-sw.js.map


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(2);
	var errors_1 = __webpack_require__(98);
	var array_buffer_to_base64_1 = __webpack_require__(493);
	var fcm_details_1 = __webpack_require__(198);
	var FCM_TOKEN_OBJ_STORE = 'fcm_token_object_Store';
	var FCM_TOKEN_DETAILS_DB_VERSION = 1;
	var TokenManager = /** @class */ (function () {
	    function TokenManager() {
	        this.errorFactory_ = new util_1.ErrorFactory('messaging', 'Messaging', errors_1.default.map);
	        this.openDbPromise_ = null;
	    }
	    /**
	     * Get the indexedDB as a promsie.
	     * @private
	     * @return {Promise<IDBDatabase>} The IndexedDB database
	     */
	    TokenManager.prototype.openDatabase_ = function () {
	        if (this.openDbPromise_) {
	            return this.openDbPromise_;
	        }
	        this.openDbPromise_ = new Promise(function (resolve, reject) {
	            var request = indexedDB.open(TokenManager.DB_NAME, FCM_TOKEN_DETAILS_DB_VERSION);
	            request.onerror = function (event) {
	                reject(event.target.error);
	            };
	            request.onsuccess = function (event) {
	                resolve(event.target.result);
	            };
	            request.onupgradeneeded = function (event) {
	                var db = event.target.result;
	                var objectStore = db.createObjectStore(FCM_TOKEN_OBJ_STORE, {
	                    keyPath: 'swScope'
	                });
	                // Make sure the sender ID can be searched
	                objectStore.createIndex('fcmSenderId', 'fcmSenderId', {
	                    unique: false
	                });
	                objectStore.createIndex('fcmToken', 'fcmToken', {
	                    unique: true
	                });
	            };
	        });
	        return this.openDbPromise_;
	    };
	    /**
	     * Close the currently open database.
	     * @return {Promise<?>} Returns the result of the promise chain.
	     */
	    TokenManager.prototype.closeDatabase = function () {
	        var _this = this;
	        if (this.openDbPromise_) {
	            return this.openDbPromise_.then(function (db) {
	                db.close();
	                _this.openDbPromise_ = null;
	            });
	        }
	        return Promise.resolve();
	    };
	    /**
	     * Given a token, this method will look up the details in indexedDB.
	     * @public
	     * @param {string} fcmToken
	     * @return {Promise<Object>} The details associated with that token.
	     */
	    TokenManager.prototype.getTokenDetailsFromToken = function (fcmToken) {
	        return this.openDatabase_().then(function (db) {
	            return new Promise(function (resolve, reject) {
	                var transaction = db.transaction([FCM_TOKEN_OBJ_STORE]);
	                var objectStore = transaction.objectStore(FCM_TOKEN_OBJ_STORE);
	                var index = objectStore.index('fcmToken');
	                var request = index.get(fcmToken);
	                request.onerror = function (event) {
	                    reject(event.target.error);
	                };
	                request.onsuccess = function (event) {
	                    resolve(event.target.result);
	                };
	            });
	        });
	    };
	    TokenManager.prototype.getTokenDetailsFromSWScope_ = function (swScope) {
	        return this.openDatabase_().then(function (db) {
	            return new Promise(function (resolve, reject) {
	                var transaction = db.transaction([FCM_TOKEN_OBJ_STORE]);
	                var objectStore = transaction.objectStore(FCM_TOKEN_OBJ_STORE);
	                var scopeRequest = objectStore.get(swScope);
	                scopeRequest.onerror = function (event) {
	                    reject(event.target.error);
	                };
	                scopeRequest.onsuccess = function (event) {
	                    resolve(event.target.result);
	                };
	            });
	        });
	    };
	    TokenManager.prototype.getAllTokenDetailsForSenderId_ = function (senderId) {
	        return this.openDatabase_().then(function (db) {
	            return new Promise(function (resolve, reject) {
	                var transaction = db.transaction([FCM_TOKEN_OBJ_STORE]);
	                var objectStore = transaction.objectStore(FCM_TOKEN_OBJ_STORE);
	                var senderIdTokens = [];
	                var cursorRequest = objectStore.openCursor();
	                cursorRequest.onerror = function (event) {
	                    reject(event.target.error);
	                };
	                cursorRequest.onsuccess = function (event) {
	                    var cursor = event.target.result;
	                    if (cursor) {
	                        if (cursor.value['fcmSenderId'] === senderId) {
	                            senderIdTokens.push(cursor.value);
	                        }
	                        cursor.continue();
	                    }
	                    else {
	                        resolve(senderIdTokens);
	                    }
	                };
	            });
	        });
	    };
	    /**
	     * Given a PushSubscription and messagingSenderId, get an FCM token.
	     * @public
	     * @param  {string} senderId The 'messagingSenderId' to tie the token to.
	     * @param  {PushSubscription} subscription The PushSusbcription to "federate".
	     * @param  {string=} pushSet If defined this will swap the subscription for
	     * matching FCM token.
	     * @return {Promise<!Object>} Returns the FCM token to be used in place
	     * of the PushSubscription.
	     */
	    TokenManager.prototype.subscribeToFCM = function (senderId, subscription, pushSet) {
	        var _this = this;
	        var p256dh = array_buffer_to_base64_1.default(subscription['getKey']('p256dh'));
	        var auth = array_buffer_to_base64_1.default(subscription['getKey']('auth'));
	        var fcmSubscribeBody = "authorized_entity=" + senderId + "&" +
	            ("endpoint=" + subscription.endpoint + "&") +
	            ("encryption_key=" + p256dh + "&") +
	            ("encryption_auth=" + auth);
	        if (pushSet) {
	            fcmSubscribeBody += "&pushSet=" + pushSet;
	        }
	        var headers = new Headers();
	        headers.append('Content-Type', 'application/x-www-form-urlencoded');
	        var subscribeOptions = {
	            method: 'POST',
	            headers: headers,
	            body: fcmSubscribeBody
	        };
	        return fetch(fcm_details_1.default.ENDPOINT + '/fcm/connect/subscribe', subscribeOptions)
	            .then(function (response) { return response.json(); })
	            .then(function (response) {
	            var fcmTokenResponse = response;
	            if (fcmTokenResponse['error']) {
	                var message = fcmTokenResponse['error']['message'];
	                throw _this.errorFactory_.create(errors_1.default.codes.TOKEN_SUBSCRIBE_FAILED, {
	                    message: message
	                });
	            }
	            if (!fcmTokenResponse['token']) {
	                throw _this.errorFactory_.create(errors_1.default.codes.TOKEN_SUBSCRIBE_NO_TOKEN);
	            }
	            if (!fcmTokenResponse['pushSet']) {
	                throw _this.errorFactory_.create(errors_1.default.codes.TOKEN_SUBSCRIBE_NO_PUSH_SET);
	            }
	            return {
	                token: fcmTokenResponse['token'],
	                pushSet: fcmTokenResponse['pushSet']
	            };
	        });
	    };
	    /**
	     * Checks the that fields in the PushSubscription are equivalent to the
	     * details stores in the masterTokenDetails.
	     * @private
	     * @param  {PushSubscription} subscription The push subscription we expect
	     * the master token to match.
	     * @param  {Object}  masterTokenDetails The saved details we wish to compare
	     * with the PushSubscription
	     * @return {boolean} true if the subscription and token details are
	     * equivalent.
	     */
	    TokenManager.prototype.isSameSubscription_ = function (subscription, masterTokenDetails) {
	        // getKey() isn't defined in the PushSubscription externs file, hence
	        // subscription['getKey']('<key name>').
	        return (subscription.endpoint === masterTokenDetails['endpoint'] &&
	            array_buffer_to_base64_1.default(subscription['getKey']('auth')) ===
	                masterTokenDetails['auth'] &&
	            array_buffer_to_base64_1.default(subscription['getKey']('p256dh')) ===
	                masterTokenDetails['p256dh']);
	    };
	    /**
	     * Save the details for the fcm token for re-use at a later date.
	     * @private
	     * @param  {string} senderId The 'messagingSenderId' used for this project
	     * @param  {ServiceWorkerRegistration} swRegistration The service worker
	     * used to subscribe the user for web push
	     * @param  {PushSubscription} subscription The push subscription passed to
	     * FCM for the current token.
	     * @param  {string} fcmToken The FCM token currently used on this
	     * device.
	     * @param  {string} fcmPushSet The FCM push tied to the fcm token.
	     * @return {Promise<void>}
	     */
	    TokenManager.prototype.saveTokenDetails_ = function (senderId, swRegistration, subscription, fcmToken, fcmPushSet) {
	        var details = {
	            swScope: swRegistration.scope,
	            endpoint: subscription.endpoint,
	            auth: array_buffer_to_base64_1.default(subscription['getKey']('auth')),
	            p256dh: array_buffer_to_base64_1.default(subscription['getKey']('p256dh')),
	            fcmToken: fcmToken,
	            fcmPushSet: fcmPushSet,
	            fcmSenderId: senderId
	        };
	        return this.openDatabase_().then(function (db) {
	            return new Promise(function (resolve, reject) {
	                var transaction = db.transaction([FCM_TOKEN_OBJ_STORE], 'readwrite');
	                var objectStore = transaction.objectStore(FCM_TOKEN_OBJ_STORE);
	                var request = objectStore.put(details);
	                request.onerror = function (event) {
	                    reject(event.target.error);
	                };
	                request.onsuccess = function (event) {
	                    resolve();
	                };
	            });
	        });
	    };
	    /**
	     * Returns the saved FCM Token if one is available and still valid,
	     * otherwise `null` is returned.
	     * @param {string} senderId This should be the sender ID associated with the
	     * FCM Token being retrieved.
	     * @param {ServiceWorkerRegistration} swRegistration Registration to be used
	     * to subscribe the user to push.
	     * @return {Promise<string> | Promise} Returns the saved FCM Token if
	     * avilable and valid.
	     * @export
	     */
	    TokenManager.prototype.getSavedToken = function (senderId, swRegistration) {
	        var _this = this;
	        if (!(swRegistration instanceof ServiceWorkerRegistration)) {
	            return Promise.reject(this.errorFactory_.create(errors_1.default.codes.SW_REGISTRATION_EXPECTED));
	        }
	        if (typeof senderId !== 'string' || senderId.length === 0) {
	            return Promise.reject(this.errorFactory_.create(errors_1.default.codes.BAD_SENDER_ID));
	        }
	        return this.getAllTokenDetailsForSenderId_(senderId)
	            .then(function (allTokenDetails) {
	            if (allTokenDetails.length === 0) {
	                return;
	            }
	            var index = allTokenDetails.findIndex(function (tokenDetails) {
	                return (swRegistration.scope === tokenDetails['swScope'] &&
	                    senderId === tokenDetails['fcmSenderId']);
	            });
	            if (index === -1) {
	                return;
	            }
	            return allTokenDetails[index];
	        })
	            .then(function (tokenDetails) {
	            if (!tokenDetails) {
	                return;
	            }
	            return swRegistration.pushManager
	                .getSubscription()
	                .catch(function (err) {
	                throw _this.errorFactory_.create(errors_1.default.codes.GET_SUBSCRIPTION_FAILED);
	            })
	                .then(function (subscription) {
	                if (subscription &&
	                    _this.isSameSubscription_(subscription, tokenDetails)) {
	                    return tokenDetails['fcmToken'];
	                }
	            });
	        });
	    };
	    /**
	     * Creates a new FCM token.
	     */
	    TokenManager.prototype.createToken = function (senderId, swRegistration) {
	        var _this = this;
	        if (typeof senderId !== 'string' || senderId.length === 0) {
	            return Promise.reject(this.errorFactory_.create(errors_1.default.codes.BAD_SENDER_ID));
	        }
	        if (!(swRegistration instanceof ServiceWorkerRegistration)) {
	            return Promise.reject(this.errorFactory_.create(errors_1.default.codes.SW_REGISTRATION_EXPECTED));
	        }
	        // Check for existing subscription first
	        var subscription;
	        var fcmTokenDetails;
	        return swRegistration.pushManager
	            .getSubscription()
	            .then(function (subscription) {
	            if (subscription) {
	                return subscription;
	            }
	            return swRegistration.pushManager.subscribe(fcm_details_1.default.SUBSCRIPTION_OPTIONS);
	        })
	            .then(function (sub) {
	            subscription = sub;
	            return _this.subscribeToFCM(senderId, subscription);
	        })
	            .then(function (tokenDetails) {
	            fcmTokenDetails = tokenDetails;
	            return _this.saveTokenDetails_(senderId, swRegistration, subscription, fcmTokenDetails['token'], fcmTokenDetails['pushSet']);
	        })
	            .then(function () { return fcmTokenDetails['token']; });
	    };
	    /**
	     * This method deletes details of the current FCM token.
	     * It's returning a promise in case we need to move to an async
	     * method for deleting at a later date.
	     * @param {string} token Token to be deleted
	     * @return {Promise<Object>} Resolves once the FCM token details have been
	     * deleted and returns the deleted details.
	     */
	    TokenManager.prototype.deleteToken = function (token) {
	        var _this = this;
	        if (typeof token !== 'string' || token.length === 0) {
	            return Promise.reject(this.errorFactory_.create(errors_1.default.codes.INVALID_DELETE_TOKEN));
	        }
	        return this.getTokenDetailsFromToken(token).then(function (details) {
	            if (!details) {
	                throw _this.errorFactory_.create(errors_1.default.codes.DELETE_TOKEN_NOT_FOUND);
	            }
	            return _this.openDatabase_().then(function (db) {
	                return new Promise(function (resolve, reject) {
	                    var transaction = db.transaction([FCM_TOKEN_OBJ_STORE], 'readwrite');
	                    var objectStore = transaction.objectStore(FCM_TOKEN_OBJ_STORE);
	                    var request = objectStore.delete(details['swScope']);
	                    request.onerror = function (event) {
	                        reject(event.target.error);
	                    };
	                    request.onsuccess = function (event) {
	                        if (event.target.result === 0) {
	                            reject(_this.errorFactory_.create(errors_1.default.codes.FAILED_TO_DELETE_TOKEN));
	                            return;
	                        }
	                        resolve(details);
	                    };
	                });
	            });
	        });
	    };
	    return TokenManager;
	}());
	exports.default = TokenManager;
	
	//# sourceMappingURL=token-manager.js.map


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	__webpack_require__(497);
	__webpack_require__(498);
	__webpack_require__(499);
	
	//# sourceMappingURL=index.js.map


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __global = (function () {
	    if (typeof global !== 'undefined') {
	        return global;
	    }
	    if (typeof window !== 'undefined') {
	        return window;
	    }
	    if (typeof self !== 'undefined') {
	        return self;
	    }
	    throw new Error('unable to locate global object');
	})();
	// Polyfill Promise
	if (typeof Promise === 'undefined') {
	    // HACK: TS throws an error if I attempt to use 'dot-notation'
	    __global['Promise'] = Promise = __webpack_require__(670);
	}
	
	//# sourceMappingURL=promise.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 498 */
/***/ function(module, exports) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * This is the Array.prototype.find polyfill from MDN
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
	 * https://tc39.github.io/ecma262/#sec-array.prototype.find
	 */
	if (!Array.prototype.find) {
	    Object.defineProperty(Array.prototype, 'find', {
	        value: function (predicate) {
	            // 1. Let O be ? ToObject(this value).
	            if (this == null) {
	                throw new TypeError('"this" is null or not defined');
	            }
	            var o = Object(this);
	            // 2. Let len be ? ToLength(? Get(O, "length")).
	            var len = o.length >>> 0;
	            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
	            if (typeof predicate !== 'function') {
	                throw new TypeError('predicate must be a function');
	            }
	            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
	            var thisArg = arguments[1];
	            // 5. Let k be 0.
	            var k = 0;
	            // 6. Repeat, while k < len
	            while (k < len) {
	                // a. Let Pk be ! ToString(k).
	                // b. Let kValue be ? Get(O, Pk).
	                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
	                // d. If testResult is true, return kValue.
	                var kValue = o[k];
	                if (predicate.call(thisArg, kValue, k, o)) {
	                    return kValue;
	                }
	                // e. Increase k by 1.
	                k++;
	            }
	            // 7. Return undefined.
	            return undefined;
	        }
	    });
	}
	
	//# sourceMappingURL=find.js.map


/***/ },
/* 499 */
/***/ function(module, exports) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * This is the Array.prototype.findIndex polyfill from MDN
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
	 * https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
	 */
	if (!Array.prototype.findIndex) {
	    Object.defineProperty(Array.prototype, 'findIndex', {
	        value: function (predicate) {
	            // 1. Let O be ? ToObject(this value).
	            if (this == null) {
	                throw new TypeError('"this" is null or not defined');
	            }
	            var o = Object(this);
	            // 2. Let len be ? ToLength(? Get(O, "length")).
	            var len = o.length >>> 0;
	            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
	            if (typeof predicate !== 'function') {
	                throw new TypeError('predicate must be a function');
	            }
	            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
	            var thisArg = arguments[1];
	            // 5. Let k be 0.
	            var k = 0;
	            // 6. Repeat, while k < len
	            while (k < len) {
	                // a. Let Pk be ! ToString(k).
	                // b. Let kValue be ? Get(O, Pk).
	                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
	                // d. If testResult is true, return k.
	                var kValue = o[k];
	                if (predicate.call(thisArg, kValue, k, o)) {
	                    return k;
	                }
	                // e. Increase k by 1.
	                k++;
	            }
	            // 7. Return -1.
	            return -1;
	        }
	    });
	}
	
	//# sourceMappingURL=findIndex.js.map


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var app_1 = __webpack_require__(35);
	var string_1 = __webpack_require__(74);
	var taskenums_1 = __webpack_require__(75);
	var taskenums_2 = __webpack_require__(75);
	var xhriopool_1 = __webpack_require__(512);
	var reference_1 = __webpack_require__(205);
	var service_1 = __webpack_require__(513);
	/**
	 * Type constant for Firebase Storage.
	 */
	var STORAGE_TYPE = 'storage';
	function factory(app, unused, opt_url) {
	    return new service_1.Service(app, new xhriopool_1.XhrIoPool(), opt_url);
	}
	function registerStorage(instance) {
	    var namespaceExports = {
	        // no-inline
	        TaskState: taskenums_2.TaskState,
	        TaskEvent: taskenums_1.TaskEvent,
	        StringFormat: string_1.StringFormat,
	        Storage: service_1.Service,
	        Reference: reference_1.Reference
	    };
	    instance.INTERNAL.registerService(STORAGE_TYPE, factory, namespaceExports, undefined, 
	    // Allow multiple storage instances per app.
	    true);
	}
	exports.registerStorage = registerStorage;
	registerStorage(app_1.default);
	
	//# sourceMappingURL=index.js.map


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @fileoverview Method for invoking a callback asynchronously.
	 */
	var promiseimpl = __webpack_require__(51);
	/**
	 * Returns a function that invokes f with its arguments asynchronously as a
	 * microtask, i.e. as soon as possible after the current script returns back
	 * into browser code.
	 */
	function async(f) {
	    return function () {
	        var argsToForward = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            argsToForward[_i] = arguments[_i];
	        }
	        promiseimpl.resolve(true).then(function () {
	            f.apply(null, argsToForward);
	        });
	    };
	}
	exports.async = async;
	
	//# sourceMappingURL=async.js.map


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var constants = __webpack_require__(99);
	var errorsExports = __webpack_require__(41);
	var failrequest_1 = __webpack_require__(504);
	var location_1 = __webpack_require__(100);
	var promiseimpl = __webpack_require__(51);
	var requestmap_1 = __webpack_require__(510);
	var type = __webpack_require__(33);
	/**
	 * @param app If null, getAuthToken always resolves with null.
	 * @param service The storage service associated with this auth wrapper.
	 *     Untyped to avoid circular type dependencies.
	 * @struct
	 */
	var AuthWrapper = /** @class */ (function () {
	    function AuthWrapper(app, maker, requestMaker, service, pool) {
	        this.bucket_ = null;
	        this.deleted_ = false;
	        this.app_ = app;
	        if (this.app_ !== null) {
	            var options = this.app_.options;
	            if (type.isDef(options)) {
	                this.bucket_ = AuthWrapper.extractBucket_(options);
	            }
	        }
	        this.storageRefMaker_ = maker;
	        this.requestMaker_ = requestMaker;
	        this.pool_ = pool;
	        this.service_ = service;
	        this.maxOperationRetryTime_ = constants.defaultMaxOperationRetryTime;
	        this.maxUploadRetryTime_ = constants.defaultMaxUploadRetryTime;
	        this.requestMap_ = new requestmap_1.RequestMap();
	    }
	    AuthWrapper.extractBucket_ = function (config) {
	        var bucketString = config[constants.configOption] || null;
	        if (bucketString == null) {
	            return null;
	        }
	        var loc = location_1.Location.makeFromBucketSpec(bucketString);
	        return loc.bucket;
	    };
	    AuthWrapper.prototype.getAuthToken = function () {
	        // TODO(andysoto): remove ifDef checks after firebase-app implements stubs
	        // (b/28673818).
	        if (this.app_ !== null &&
	            type.isDef(this.app_.INTERNAL) &&
	            type.isDef(this.app_.INTERNAL.getToken)) {
	            return this.app_.INTERNAL.getToken().then(function (response) {
	                if (response !== null) {
	                    return response.accessToken;
	                }
	                else {
	                    return null;
	                }
	            }, function (_error) {
	                return null;
	            });
	        }
	        else {
	            return promiseimpl.resolve(null);
	        }
	    };
	    AuthWrapper.prototype.bucket = function () {
	        if (this.deleted_) {
	            throw errorsExports.appDeleted();
	        }
	        else {
	            return this.bucket_;
	        }
	    };
	    /**
	     * The service associated with this auth wrapper. Untyped to avoid circular
	     * type dependencies.
	     */
	    AuthWrapper.prototype.service = function () {
	        return this.service_;
	    };
	    /**
	     * Returns a new firebaseStorage.Reference object referencing this AuthWrapper
	     * at the given Location.
	     * @param loc The Location.
	     * @return Actually a firebaseStorage.Reference, typing not allowed
	     *     because of circular dependency problems.
	     */
	    AuthWrapper.prototype.makeStorageReference = function (loc) {
	        return this.storageRefMaker_(this, loc);
	    };
	    AuthWrapper.prototype.makeRequest = function (requestInfo, authToken) {
	        if (!this.deleted_) {
	            var request = this.requestMaker_(requestInfo, authToken, this.pool_);
	            this.requestMap_.addRequest(request);
	            return request;
	        }
	        else {
	            return new failrequest_1.FailRequest(errorsExports.appDeleted());
	        }
	    };
	    /**
	     * Stop running requests and prevent more from being created.
	     */
	    AuthWrapper.prototype.deleteApp = function () {
	        this.deleted_ = true;
	        this.app_ = null;
	        this.requestMap_.clear();
	    };
	    AuthWrapper.prototype.maxUploadRetryTime = function () {
	        return this.maxUploadRetryTime_;
	    };
	    AuthWrapper.prototype.setMaxUploadRetryTime = function (time) {
	        this.maxUploadRetryTime_ = time;
	    };
	    AuthWrapper.prototype.maxOperationRetryTime = function () {
	        return this.maxOperationRetryTime_;
	    };
	    AuthWrapper.prototype.setMaxOperationRetryTime = function (time) {
	        this.maxOperationRetryTime_ = time;
	    };
	    return AuthWrapper;
	}());
	exports.AuthWrapper = AuthWrapper;
	
	//# sourceMappingURL=authwrapper.js.map


/***/ },
/* 503 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @param f May be invoked
	 *     before the function returns.
	 * @param callback Get all the arguments passed to the function
	 *     passed to f, including the initial boolean.
	 */
	function start(f, callback, timeout) {
	    // TODO(andysoto): make this code cleaner (probably refactor into an actual
	    // type instead of a bunch of functions with state shared in the closure)
	    var waitSeconds = 1;
	    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
	    var timeoutId = null;
	    var hitTimeout = false;
	    var cancelState = 0;
	    function canceled() {
	        return cancelState === 2;
	    }
	    var triggeredCallback = false;
	    function triggerCallback() {
	        if (!triggeredCallback) {
	            triggeredCallback = true;
	            callback.apply(null, arguments);
	        }
	    }
	    function callWithDelay(millis) {
	        timeoutId = setTimeout(function () {
	            timeoutId = null;
	            f(handler, canceled());
	        }, millis);
	    }
	    function handler(success) {
	        var var_args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            var_args[_i - 1] = arguments[_i];
	        }
	        if (triggeredCallback) {
	            return;
	        }
	        if (success) {
	            triggerCallback.apply(null, arguments);
	            return;
	        }
	        var mustStop = canceled() || hitTimeout;
	        if (mustStop) {
	            triggerCallback.apply(null, arguments);
	            return;
	        }
	        if (waitSeconds < 64) {
	            /* TODO(andysoto): don't back off so quickly if we know we're offline. */
	            waitSeconds *= 2;
	        }
	        var waitMillis;
	        if (cancelState === 1) {
	            cancelState = 2;
	            waitMillis = 0;
	        }
	        else {
	            waitMillis = (waitSeconds + Math.random()) * 1000;
	        }
	        callWithDelay(waitMillis);
	    }
	    var stopped = false;
	    function stop(wasTimeout) {
	        if (stopped) {
	            return;
	        }
	        stopped = true;
	        if (triggeredCallback) {
	            return;
	        }
	        if (timeoutId !== null) {
	            if (!wasTimeout) {
	                cancelState = 2;
	            }
	            clearTimeout(timeoutId);
	            callWithDelay(0);
	        }
	        else {
	            if (!wasTimeout) {
	                cancelState = 1;
	            }
	        }
	    }
	    callWithDelay(0);
	    setTimeout(function () {
	        hitTimeout = true;
	        stop(true);
	    }, timeout);
	    return stop;
	}
	exports.start = start;
	/**
	 * Stops the retry loop from repeating.
	 * If the function is currently "in between" retries, it is invoked immediately
	 * with the second parameter as "true". Otherwise, it will be invoked once more
	 * after the current invocation finishes iff the current invocation would have
	 * triggered another retry.
	 */
	function stop(id) {
	    id(false);
	}
	exports.stop = stop;
	
	//# sourceMappingURL=backoff.js.map


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var promiseimpl = __webpack_require__(51);
	/**
	 * A request whose promise always fails.
	 * @struct
	 * @template T
	 */
	var FailRequest = /** @class */ (function () {
	    function FailRequest(error) {
	        this.promise_ = promiseimpl.reject(error);
	    }
	    /** @inheritDoc */
	    FailRequest.prototype.getPromise = function () {
	        return this.promise_;
	    };
	    /** @inheritDoc */
	    FailRequest.prototype.cancel = function (appDelete) {
	        if (appDelete === void 0) { appDelete = false; }
	    };
	    return FailRequest;
	}());
	exports.FailRequest = FailRequest;
	
	//# sourceMappingURL=failrequest.js.map


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var type = __webpack_require__(33);
	function getBlobBuilder() {
	    if (typeof BlobBuilder !== 'undefined') {
	        return BlobBuilder;
	    }
	    else if (typeof WebKitBlobBuilder !== 'undefined') {
	        return WebKitBlobBuilder;
	    }
	    else {
	        return undefined;
	    }
	}
	/**
	 * Concatenates one or more values together and converts them to a Blob.
	 *
	 * @param var_args The values that will make up the resulting blob.
	 * @return The blob.
	 */
	function getBlob() {
	    var var_args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        var_args[_i] = arguments[_i];
	    }
	    var BlobBuilder = getBlobBuilder();
	    if (BlobBuilder !== undefined) {
	        var bb = new BlobBuilder();
	        for (var i = 0; i < var_args.length; i++) {
	            bb.append(var_args[i]);
	        }
	        return bb.getBlob();
	    }
	    else {
	        if (type.isNativeBlobDefined()) {
	            return new Blob(var_args);
	        }
	        else {
	            throw Error("This browser doesn't seem to support creating Blobs");
	        }
	    }
	}
	exports.getBlob = getBlob;
	/**
	 * Slices the blob. The returned blob contains data from the start byte
	 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
	 *
	 * @param blob The blob to be sliced.
	 * @param start Index of the starting byte.
	 * @param end Index of the ending byte.
	 * @return The blob slice or null if not supported.
	 */
	function sliceBlob(blob, start, end) {
	    if (blob.webkitSlice) {
	        return blob.webkitSlice(start, end);
	    }
	    else if (blob.mozSlice) {
	        return blob.mozSlice(start, end);
	    }
	    else if (blob.slice) {
	        return blob.slice(start, end);
	    }
	    return null;
	}
	exports.sliceBlob = sliceBlob;
	
	//# sourceMappingURL=fs.js.map


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var type = __webpack_require__(33);
	/**
	 * Returns the Object resulting from parsing the given JSON, or null if the
	 * given string does not represent a JSON object.
	 */
	function jsonObjectOrNull(s) {
	    var obj;
	    try {
	        obj = JSON.parse(s);
	    }
	    catch (e) {
	        return null;
	    }
	    if (type.isNonArrayObject(obj)) {
	        return obj;
	    }
	    else {
	        return null;
	    }
	}
	exports.jsonObjectOrNull = jsonObjectOrNull;
	
	//# sourceMappingURL=json.js.map


/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var type = __webpack_require__(33);
	/**
	 * @struct
	 */
	var Observer = /** @class */ (function () {
	    function Observer(nextOrObserver, opt_error, opt_complete) {
	        var asFunctions = type.isFunction(nextOrObserver) ||
	            type.isDef(opt_error) ||
	            type.isDef(opt_complete);
	        if (asFunctions) {
	            this.next = nextOrObserver;
	            this.error = opt_error || null;
	            this.complete = opt_complete || null;
	        }
	        else {
	            var observer = nextOrObserver;
	            this.next = observer.next || null;
	            this.error = observer.error || null;
	            this.complete = observer.complete || null;
	        }
	    }
	    return Observer;
	}());
	exports.Observer = Observer;
	
	//# sourceMappingURL=observer.js.map


/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @fileoverview Defines methods used to actually send HTTP requests from
	 * abstract representations.
	 */
	var app_1 = __webpack_require__(35);
	var array = __webpack_require__(132);
	var backoff = __webpack_require__(503);
	var errorsExports = __webpack_require__(41);
	var object = __webpack_require__(58);
	var promiseimpl = __webpack_require__(51);
	var type = __webpack_require__(33);
	var UrlUtils = __webpack_require__(134);
	var XhrIoExports = __webpack_require__(204);
	/**
	 * @struct
	 * @template T
	 */
	var NetworkRequest = /** @class */ (function () {
	    function NetworkRequest(url, method, headers, body, successCodes, additionalRetryCodes, callback, errorCallback, timeout, progressCallback, pool) {
	        this.pendingXhr_ = null;
	        this.backoffId_ = null;
	        this.resolve_ = null;
	        this.reject_ = null;
	        this.canceled_ = false;
	        this.appDelete_ = false;
	        this.url_ = url;
	        this.method_ = method;
	        this.headers_ = headers;
	        this.body_ = body;
	        this.successCodes_ = successCodes.slice();
	        this.additionalRetryCodes_ = additionalRetryCodes.slice();
	        this.callback_ = callback;
	        this.errorCallback_ = errorCallback;
	        this.progressCallback_ = progressCallback;
	        this.timeout_ = timeout;
	        this.pool_ = pool;
	        var self = this;
	        this.promise_ = promiseimpl.make(function (resolve, reject) {
	            self.resolve_ = resolve;
	            self.reject_ = reject;
	            self.start_();
	        });
	    }
	    /**
	     * Actually starts the retry loop.
	     */
	    NetworkRequest.prototype.start_ = function () {
	        var self = this;
	        function doTheRequest(backoffCallback, canceled) {
	            if (canceled) {
	                backoffCallback(false, new RequestEndStatus(false, null, true));
	                return;
	            }
	            var xhr = self.pool_.createXhrIo();
	            self.pendingXhr_ = xhr;
	            function progressListener(progressEvent) {
	                var loaded = progressEvent.loaded;
	                var total = progressEvent.lengthComputable ? progressEvent.total : -1;
	                if (self.progressCallback_ !== null) {
	                    self.progressCallback_(loaded, total);
	                }
	            }
	            if (self.progressCallback_ !== null) {
	                xhr.addUploadProgressListener(progressListener);
	            }
	            xhr
	                .send(self.url_, self.method_, self.body_, self.headers_)
	                .then(function (xhr) {
	                if (self.progressCallback_ !== null) {
	                    xhr.removeUploadProgressListener(progressListener);
	                }
	                self.pendingXhr_ = null;
	                xhr = xhr;
	                var hitServer = xhr.getErrorCode() === XhrIoExports.ErrorCode.NO_ERROR;
	                var status = xhr.getStatus();
	                if (!hitServer || self.isRetryStatusCode_(status)) {
	                    var wasCanceled = xhr.getErrorCode() === XhrIoExports.ErrorCode.ABORT;
	                    backoffCallback(false, new RequestEndStatus(false, null, wasCanceled));
	                    return;
	                }
	                var successCode = array.contains(self.successCodes_, status);
	                backoffCallback(true, new RequestEndStatus(successCode, xhr));
	            });
	        }
	        /**
	         * @param requestWentThrough True if the request eventually went
	         *     through, false if it hit the retry limit or was canceled.
	         */
	        function backoffDone(requestWentThrough, status) {
	            var resolve = self.resolve_;
	            var reject = self.reject_;
	            var xhr = status.xhr;
	            if (status.wasSuccessCode) {
	                try {
	                    var result = self.callback_(xhr, xhr.getResponseText());
	                    if (type.isJustDef(result)) {
	                        resolve(result);
	                    }
	                    else {
	                        resolve();
	                    }
	                }
	                catch (e) {
	                    reject(e);
	                }
	            }
	            else {
	                if (xhr !== null) {
	                    var err = errorsExports.unknown();
	                    err.setServerResponseProp(xhr.getResponseText());
	                    if (self.errorCallback_) {
	                        reject(self.errorCallback_(xhr, err));
	                    }
	                    else {
	                        reject(err);
	                    }
	                }
	                else {
	                    if (status.canceled) {
	                        var err = self.appDelete_
	                            ? errorsExports.appDeleted()
	                            : errorsExports.canceled();
	                        reject(err);
	                    }
	                    else {
	                        var err = errorsExports.retryLimitExceeded();
	                        reject(err);
	                    }
	                }
	            }
	        }
	        if (this.canceled_) {
	            backoffDone(false, new RequestEndStatus(false, null, true));
	        }
	        else {
	            this.backoffId_ = backoff.start(doTheRequest, backoffDone, this.timeout_);
	        }
	    };
	    /** @inheritDoc */
	    NetworkRequest.prototype.getPromise = function () {
	        return this.promise_;
	    };
	    /** @inheritDoc */
	    NetworkRequest.prototype.cancel = function (appDelete) {
	        this.canceled_ = true;
	        this.appDelete_ = appDelete || false;
	        if (this.backoffId_ !== null) {
	            backoff.stop(this.backoffId_);
	        }
	        if (this.pendingXhr_ !== null) {
	            this.pendingXhr_.abort();
	        }
	    };
	    NetworkRequest.prototype.isRetryStatusCode_ = function (status) {
	        // The codes for which to retry came from this page:
	        // https://cloud.google.com/storage/docs/exponential-backoff
	        var isFiveHundredCode = status >= 500 && status < 600;
	        var extraRetryCodes = [
	            // Request Timeout: web server didn't receive full request in time.
	            408,
	            // Too Many Requests: you're getting rate-limited, basically.
	            429
	        ];
	        var isExtraRetryCode = array.contains(extraRetryCodes, status);
	        var isRequestSpecificRetryCode = array.contains(this.additionalRetryCodes_, status);
	        return isFiveHundredCode || isExtraRetryCode || isRequestSpecificRetryCode;
	    };
	    return NetworkRequest;
	}());
	/**
	 * A collection of information about the result of a network request.
	 * @param opt_canceled Defaults to false.
	 * @struct
	 */
	var RequestEndStatus = /** @class */ (function () {
	    function RequestEndStatus(wasSuccessCode, xhr, opt_canceled) {
	        this.wasSuccessCode = wasSuccessCode;
	        this.xhr = xhr;
	        this.canceled = !!opt_canceled;
	    }
	    return RequestEndStatus;
	}());
	exports.RequestEndStatus = RequestEndStatus;
	function addAuthHeader_(headers, authToken) {
	    if (authToken !== null && authToken.length > 0) {
	        headers['Authorization'] = 'Firebase ' + authToken;
	    }
	}
	exports.addAuthHeader_ = addAuthHeader_;
	function addVersionHeader_(headers) {
	    var number = typeof app_1.default !== 'undefined' ? app_1.default.SDK_VERSION : 'AppManager';
	    headers['X-Firebase-Storage-Version'] = 'webjs/' + number;
	}
	exports.addVersionHeader_ = addVersionHeader_;
	/**
	 * @template T
	 */
	function makeRequest(requestInfo, authToken, pool) {
	    var queryPart = UrlUtils.makeQueryString(requestInfo.urlParams);
	    var url = requestInfo.url + queryPart;
	    var headers = object.clone(requestInfo.headers);
	    addAuthHeader_(headers, authToken);
	    addVersionHeader_(headers);
	    return new NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, pool);
	}
	exports.makeRequest = makeRequest;
	
	//# sourceMappingURL=request.js.map


/***/ },
/* 509 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var RequestInfo = /** @class */ (function () {
	    function RequestInfo(url, method, 
	        /**
	         * Returns the value with which to resolve the request's promise. Only called
	         * if the request is successful. Throw from this function to reject the
	         * returned Request's promise with the thrown error.
	         * Note: The XhrIo passed to this function may be reused after this callback
	         * returns. Do not keep a reference to it in any way.
	         */
	        handler, timeout) {
	        this.url = url;
	        this.method = method;
	        this.handler = handler;
	        this.timeout = timeout;
	        this.urlParams = {};
	        this.headers = {};
	        this.body = null;
	        this.errorHandler = null;
	        /**
	         * Called with the current number of bytes uploaded and total size (-1 if not
	         * computable) of the request body (i.e. used to report upload progress).
	         */
	        this.progressCallback = null;
	        this.successCodes = [200];
	        this.additionalRetryCodes = [];
	    }
	    return RequestInfo;
	}());
	exports.RequestInfo = RequestInfo;
	
	//# sourceMappingURL=requestinfo.js.map


/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var object = __webpack_require__(58);
	var constants = __webpack_require__(99);
	/**
	 * @struct
	 */
	var RequestMap = /** @class */ (function () {
	    function RequestMap() {
	        this.map_ = {};
	        this.id_ = constants.minSafeInteger;
	    }
	    /**
	     * Registers the given request with this map.
	     * The request is unregistered when it completes.
	     * @param r The request to register.
	     */
	    RequestMap.prototype.addRequest = function (r) {
	        var id = this.id_;
	        this.id_++;
	        this.map_[id] = r;
	        var self = this;
	        function unmap() {
	            delete self.map_[id];
	        }
	        r.getPromise().then(unmap, unmap);
	    };
	    /**
	     * Cancels all registered requests.
	     */
	    RequestMap.prototype.clear = function () {
	        object.forEach(this.map_, function (key, val) {
	            if (val) {
	                val.cancel(true);
	            }
	        });
	        this.map_ = {};
	    };
	    return RequestMap;
	}());
	exports.RequestMap = RequestMap;
	
	//# sourceMappingURL=requestmap.js.map


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var errorsExports = __webpack_require__(41);
	var object = __webpack_require__(58);
	var promiseimpl = __webpack_require__(51);
	var type = __webpack_require__(33);
	var XhrIoExports = __webpack_require__(204);
	/**
	 * We use this instead of goog.net.XhrIo because goog.net.XhrIo is hyuuuuge and
	 * doesn't work in React Native on Android.
	 */
	var NetworkXhrIo = /** @class */ (function () {
	    function NetworkXhrIo() {
	        var _this = this;
	        this.sent_ = false;
	        this.xhr_ = new XMLHttpRequest();
	        this.errorCode_ = XhrIoExports.ErrorCode.NO_ERROR;
	        this.sendPromise_ = promiseimpl.make(function (resolve, reject) {
	            _this.xhr_.addEventListener('abort', function (event) {
	                _this.errorCode_ = XhrIoExports.ErrorCode.ABORT;
	                resolve(_this);
	            });
	            _this.xhr_.addEventListener('error', function (event) {
	                _this.errorCode_ = XhrIoExports.ErrorCode.NETWORK_ERROR;
	                resolve(_this);
	            });
	            _this.xhr_.addEventListener('load', function (event) {
	                resolve(_this);
	            });
	        });
	    }
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.send = function (url, method, opt_body, opt_headers) {
	        var _this = this;
	        if (this.sent_) {
	            throw errorsExports.internalError('cannot .send() more than once');
	        }
	        this.sent_ = true;
	        this.xhr_.open(method, url, true);
	        if (type.isDef(opt_headers)) {
	            var headers = opt_headers;
	            object.forEach(headers, function (key, val) {
	                _this.xhr_.setRequestHeader(key, val.toString());
	            });
	        }
	        if (type.isDef(opt_body)) {
	            this.xhr_.send(opt_body);
	        }
	        else {
	            this.xhr_.send();
	        }
	        return this.sendPromise_;
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.getErrorCode = function () {
	        if (!this.sent_) {
	            throw errorsExports.internalError('cannot .getErrorCode() before sending');
	        }
	        return this.errorCode_;
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.getStatus = function () {
	        if (!this.sent_) {
	            throw errorsExports.internalError('cannot .getStatus() before sending');
	        }
	        try {
	            return this.xhr_.status;
	        }
	        catch (e) {
	            return -1;
	        }
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.getResponseText = function () {
	        if (!this.sent_) {
	            throw errorsExports.internalError('cannot .getResponseText() before sending');
	        }
	        return this.xhr_.responseText;
	    };
	    /**
	     * Aborts the request.
	     * @override
	     */
	    NetworkXhrIo.prototype.abort = function () {
	        this.xhr_.abort();
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.getResponseHeader = function (header) {
	        return this.xhr_.getResponseHeader(header);
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.addUploadProgressListener = function (listener) {
	        if (type.isDef(this.xhr_.upload)) {
	            this.xhr_.upload.addEventListener('progress', listener);
	        }
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.removeUploadProgressListener = function (listener) {
	        if (type.isDef(this.xhr_.upload)) {
	            this.xhr_.upload.removeEventListener('progress', listener);
	        }
	    };
	    return NetworkXhrIo;
	}());
	exports.NetworkXhrIo = NetworkXhrIo;
	
	//# sourceMappingURL=xhrio_network.js.map


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var xhrio_network_1 = __webpack_require__(511);
	/**
	 * Factory-like class for creating XhrIo instances.
	 */
	var XhrIoPool = /** @class */ (function () {
	    function XhrIoPool() {
	    }
	    XhrIoPool.prototype.createXhrIo = function () {
	        return new xhrio_network_1.NetworkXhrIo();
	    };
	    return XhrIoPool;
	}());
	exports.XhrIoPool = XhrIoPool;
	
	//# sourceMappingURL=xhriopool.js.map


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var args = __webpack_require__(131);
	var authwrapper_1 = __webpack_require__(502);
	var location_1 = __webpack_require__(100);
	var fbsPromiseImpl = __webpack_require__(51);
	var RequestExports = __webpack_require__(508);
	var reference_1 = __webpack_require__(205);
	/**
	 * A service that provides firebaseStorage.Reference instances.
	 * @param opt_url gs:// url to a custom Storage Bucket
	 *
	 * @struct
	 */
	var Service = /** @class */ (function () {
	    function Service(app, pool, url) {
	        this.bucket_ = null;
	        function maker(authWrapper, loc) {
	            return new reference_1.Reference(authWrapper, loc);
	        }
	        this.authWrapper_ = new authwrapper_1.AuthWrapper(app, maker, RequestExports.makeRequest, this, pool);
	        this.app_ = app;
	        if (url != null) {
	            this.bucket_ = location_1.Location.makeFromBucketSpec(url);
	        }
	        else {
	            var authWrapperBucket = this.authWrapper_.bucket();
	            if (authWrapperBucket != null) {
	                this.bucket_ = new location_1.Location(authWrapperBucket, '');
	            }
	        }
	        this.internals_ = new ServiceInternals(this);
	    }
	    /**
	     * Returns a firebaseStorage.Reference for the given path in the default
	     * bucket.
	     */
	    Service.prototype.ref = function (path) {
	        function validator(path) {
	            if (/^[A-Za-z]+:\/\//.test(path)) {
	                throw 'Expected child path but got a URL, use refFromURL instead.';
	            }
	        }
	        args.validate('ref', [args.stringSpec(validator, true)], arguments);
	        if (this.bucket_ == null) {
	            throw new Error('No Storage Bucket defined in Firebase Options.');
	        }
	        var ref = new reference_1.Reference(this.authWrapper_, this.bucket_);
	        if (path != null) {
	            return ref.child(path);
	        }
	        else {
	            return ref;
	        }
	    };
	    /**
	     * Returns a firebaseStorage.Reference object for the given absolute URL,
	     * which must be a gs:// or http[s]:// URL.
	     */
	    Service.prototype.refFromURL = function (url) {
	        function validator(p) {
	            if (!/^[A-Za-z]+:\/\//.test(p)) {
	                throw 'Expected full URL but got a child path, use ref instead.';
	            }
	            try {
	                location_1.Location.makeFromUrl(p);
	            }
	            catch (e) {
	                throw 'Expected valid full URL but got an invalid one.';
	            }
	        }
	        args.validate('refFromURL', [args.stringSpec(validator, false)], arguments);
	        return new reference_1.Reference(this.authWrapper_, url);
	    };
	    Object.defineProperty(Service.prototype, "maxUploadRetryTime", {
	        get: function () {
	            return this.authWrapper_.maxUploadRetryTime();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Service.prototype.setMaxUploadRetryTime = function (time) {
	        args.validate('setMaxUploadRetryTime', [args.nonNegativeNumberSpec()], arguments);
	        this.authWrapper_.setMaxUploadRetryTime(time);
	    };
	    Object.defineProperty(Service.prototype, "maxOperationRetryTime", {
	        get: function () {
	            return this.authWrapper_.maxOperationRetryTime();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Service.prototype.setMaxOperationRetryTime = function (time) {
	        args.validate('setMaxOperationRetryTime', [args.nonNegativeNumberSpec()], arguments);
	        this.authWrapper_.setMaxOperationRetryTime(time);
	    };
	    Object.defineProperty(Service.prototype, "app", {
	        get: function () {
	            return this.app_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Service.prototype, "INTERNAL", {
	        get: function () {
	            return this.internals_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Service;
	}());
	exports.Service = Service;
	/**
	 * @struct
	 */
	var ServiceInternals = /** @class */ (function () {
	    function ServiceInternals(service) {
	        this.service_ = service;
	    }
	    /**
	     * Called when the associated app is deleted.
	     * @see {!fbs.AuthWrapper.prototype.deleteApp}
	     */
	    ServiceInternals.prototype.delete = function () {
	        this.service_.authWrapper_.deleteApp();
	        return fbsPromiseImpl.resolve(undefined);
	    };
	    return ServiceInternals;
	}());
	exports.ServiceInternals = ServiceInternals;
	
	//# sourceMappingURL=service.js.map


/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @fileoverview Defines types for interacting with blob transfer tasks.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var taskenums_1 = __webpack_require__(75);
	var observer_1 = __webpack_require__(507);
	var taskenums_2 = __webpack_require__(75);
	var tasksnapshot_1 = __webpack_require__(515);
	var fbsArgs = __webpack_require__(131);
	var fbsArray = __webpack_require__(132);
	var async_1 = __webpack_require__(501);
	var errors = __webpack_require__(41);
	var fbsPromiseimpl = __webpack_require__(51);
	var fbsRequests = __webpack_require__(203);
	var fbsTaskEnums = __webpack_require__(75);
	var typeUtils = __webpack_require__(33);
	/**
	 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
	 * upload and manage callbacks for various events.
	 */
	var UploadTask = /** @class */ (function () {
	    /**
	     * @param ref The firebaseStorage.Reference object this task came
	     *     from, untyped to avoid cyclic dependencies.
	     * @param blob The blob to upload.
	     */
	    function UploadTask(ref, authWrapper, location, mappings, blob, metadata) {
	        if (metadata === void 0) { metadata = null; }
	        var _this = this;
	        this.transferred_ = 0;
	        this.needToFetchStatus_ = false;
	        this.needToFetchMetadata_ = false;
	        this.observers_ = [];
	        this.error_ = null;
	        this.uploadUrl_ = null;
	        this.request_ = null;
	        this.chunkMultiplier_ = 1;
	        this.resolve_ = null;
	        this.reject_ = null;
	        this.ref_ = ref;
	        this.authWrapper_ = authWrapper;
	        this.location_ = location;
	        this.blob_ = blob;
	        this.metadata_ = metadata;
	        this.mappings_ = mappings;
	        this.resumable_ = this.shouldDoResumable_(this.blob_);
	        this.state_ = taskenums_1.InternalTaskState.RUNNING;
	        this.errorHandler_ = function (error) {
	            _this.request_ = null;
	            _this.chunkMultiplier_ = 1;
	            if (error.codeEquals(errors.Code.CANCELED)) {
	                _this.needToFetchStatus_ = true;
	                _this.completeTransitions_();
	            }
	            else {
	                _this.error_ = error;
	                _this.transition_(taskenums_1.InternalTaskState.ERROR);
	            }
	        };
	        this.metadataErrorHandler_ = function (error) {
	            _this.request_ = null;
	            if (error.codeEquals(errors.Code.CANCELED)) {
	                _this.completeTransitions_();
	            }
	            else {
	                _this.error_ = error;
	                _this.transition_(taskenums_1.InternalTaskState.ERROR);
	            }
	        };
	        this.promise_ = fbsPromiseimpl.make(function (resolve, reject) {
	            _this.resolve_ = resolve;
	            _this.reject_ = reject;
	            _this.start_();
	        });
	        // Prevent uncaught rejections on the internal promise from bubbling out
	        // to the top level with a dummy handler.
	        this.promise_.then(null, function () { });
	    }
	    UploadTask.prototype.makeProgressCallback_ = function () {
	        var _this = this;
	        var sizeBefore = this.transferred_;
	        return function (loaded, total) {
	            _this.updateProgress_(sizeBefore + loaded);
	        };
	    };
	    UploadTask.prototype.shouldDoResumable_ = function (blob) {
	        return blob.size() > 256 * 1024;
	    };
	    UploadTask.prototype.start_ = function () {
	        if (this.state_ !== taskenums_1.InternalTaskState.RUNNING) {
	            // This can happen if someone pauses us in a resume callback, for example.
	            return;
	        }
	        if (this.request_ !== null) {
	            return;
	        }
	        if (this.resumable_) {
	            if (this.uploadUrl_ === null) {
	                this.createResumable_();
	            }
	            else {
	                if (this.needToFetchStatus_) {
	                    this.fetchStatus_();
	                }
	                else {
	                    if (this.needToFetchMetadata_) {
	                        // Happens if we miss the metadata on upload completion.
	                        this.fetchMetadata_();
	                    }
	                    else {
	                        this.continueUpload_();
	                    }
	                }
	            }
	        }
	        else {
	            this.oneShotUpload_();
	        }
	    };
	    UploadTask.prototype.resolveToken_ = function (callback) {
	        var _this = this;
	        this.authWrapper_.getAuthToken().then(function (authToken) {
	            switch (_this.state_) {
	                case taskenums_1.InternalTaskState.RUNNING:
	                    callback(authToken);
	                    break;
	                case taskenums_1.InternalTaskState.CANCELING:
	                    _this.transition_(taskenums_1.InternalTaskState.CANCELED);
	                    break;
	                case taskenums_1.InternalTaskState.PAUSING:
	                    _this.transition_(taskenums_1.InternalTaskState.PAUSED);
	                    break;
	                default:
	            }
	        });
	    };
	    // TODO(andysoto): assert false
	    UploadTask.prototype.createResumable_ = function () {
	        var _this = this;
	        this.resolveToken_(function (authToken) {
	            var requestInfo = fbsRequests.createResumableUpload(_this.authWrapper_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
	            var createRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
	            _this.request_ = createRequest;
	            createRequest.getPromise().then(function (url) {
	                _this.request_ = null;
	                _this.uploadUrl_ = url;
	                _this.needToFetchStatus_ = false;
	                _this.completeTransitions_();
	            }, _this.errorHandler_);
	        });
	    };
	    UploadTask.prototype.fetchStatus_ = function () {
	        var _this = this;
	        // TODO(andysoto): assert(this.uploadUrl_ !== null);
	        var url = this.uploadUrl_;
	        this.resolveToken_(function (authToken) {
	            var requestInfo = fbsRequests.getResumableUploadStatus(_this.authWrapper_, _this.location_, url, _this.blob_);
	            var statusRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
	            _this.request_ = statusRequest;
	            statusRequest.getPromise().then(function (status) {
	                status = status;
	                _this.request_ = null;
	                _this.updateProgress_(status.current);
	                _this.needToFetchStatus_ = false;
	                if (status.finalized) {
	                    _this.needToFetchMetadata_ = true;
	                }
	                _this.completeTransitions_();
	            }, _this.errorHandler_);
	        });
	    };
	    UploadTask.prototype.continueUpload_ = function () {
	        var _this = this;
	        var chunkSize = fbsRequests.resumableUploadChunkSize * this.chunkMultiplier_;
	        var status = new fbsRequests.ResumableUploadStatus(this.transferred_, this.blob_.size());
	        // TODO(andysoto): assert(this.uploadUrl_ !== null);
	        var url = this.uploadUrl_;
	        this.resolveToken_(function (authToken) {
	            var requestInfo;
	            try {
	                requestInfo = fbsRequests.continueResumableUpload(_this.location_, _this.authWrapper_, url, _this.blob_, chunkSize, _this.mappings_, status, _this.makeProgressCallback_());
	            }
	            catch (e) {
	                _this.error_ = e;
	                _this.transition_(taskenums_1.InternalTaskState.ERROR);
	                return;
	            }
	            var uploadRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
	            _this.request_ = uploadRequest;
	            uploadRequest
	                .getPromise()
	                .then(function (newStatus) {
	                _this.increaseMultiplier_();
	                _this.request_ = null;
	                _this.updateProgress_(newStatus.current);
	                if (newStatus.finalized) {
	                    _this.metadata_ = newStatus.metadata;
	                    _this.transition_(taskenums_1.InternalTaskState.SUCCESS);
	                }
	                else {
	                    _this.completeTransitions_();
	                }
	            }, _this.errorHandler_);
	        });
	    };
	    UploadTask.prototype.increaseMultiplier_ = function () {
	        var currentSize = fbsRequests.resumableUploadChunkSize * this.chunkMultiplier_;
	        // Max chunk size is 32M.
	        if (currentSize < 32 * 1024 * 1024) {
	            this.chunkMultiplier_ *= 2;
	        }
	    };
	    UploadTask.prototype.fetchMetadata_ = function () {
	        var _this = this;
	        this.resolveToken_(function (authToken) {
	            var requestInfo = fbsRequests.getMetadata(_this.authWrapper_, _this.location_, _this.mappings_);
	            var metadataRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
	            _this.request_ = metadataRequest;
	            metadataRequest.getPromise().then(function (metadata) {
	                _this.request_ = null;
	                _this.metadata_ = metadata;
	                _this.transition_(taskenums_1.InternalTaskState.SUCCESS);
	            }, _this.metadataErrorHandler_);
	        });
	    };
	    UploadTask.prototype.oneShotUpload_ = function () {
	        var _this = this;
	        this.resolveToken_(function (authToken) {
	            var requestInfo = fbsRequests.multipartUpload(_this.authWrapper_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
	            var multipartRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
	            _this.request_ = multipartRequest;
	            multipartRequest.getPromise().then(function (metadata) {
	                _this.request_ = null;
	                _this.metadata_ = metadata;
	                _this.updateProgress_(_this.blob_.size());
	                _this.transition_(taskenums_1.InternalTaskState.SUCCESS);
	            }, _this.errorHandler_);
	        });
	    };
	    UploadTask.prototype.updateProgress_ = function (transferred) {
	        var old = this.transferred_;
	        this.transferred_ = transferred;
	        // A progress update can make the "transferred" value smaller (e.g. a
	        // partial upload not completed by server, after which the "transferred"
	        // value may reset to the value at the beginning of the request).
	        if (this.transferred_ !== old) {
	            this.notifyObservers_();
	        }
	    };
	    UploadTask.prototype.transition_ = function (state) {
	        if (this.state_ === state) {
	            return;
	        }
	        switch (state) {
	            case taskenums_1.InternalTaskState.CANCELING:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.RUNNING ||
	                //        this.state_ === InternalTaskState.PAUSING);
	                this.state_ = state;
	                if (this.request_ !== null) {
	                    this.request_.cancel();
	                }
	                break;
	            case taskenums_1.InternalTaskState.PAUSING:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.RUNNING);
	                this.state_ = state;
	                if (this.request_ !== null) {
	                    this.request_.cancel();
	                }
	                break;
	            case taskenums_1.InternalTaskState.RUNNING:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.PAUSED ||
	                //        this.state_ === InternalTaskState.PAUSING);
	                var wasPaused = this.state_ === taskenums_1.InternalTaskState.PAUSED;
	                this.state_ = state;
	                if (wasPaused) {
	                    this.notifyObservers_();
	                    this.start_();
	                }
	                break;
	            case taskenums_1.InternalTaskState.PAUSED:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.PAUSING);
	                this.state_ = state;
	                this.notifyObservers_();
	                break;
	            case taskenums_1.InternalTaskState.CANCELED:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.PAUSED ||
	                //        this.state_ === InternalTaskState.CANCELING);
	                this.error_ = errors.canceled();
	                this.state_ = state;
	                this.notifyObservers_();
	                break;
	            case taskenums_1.InternalTaskState.ERROR:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.RUNNING ||
	                //        this.state_ === InternalTaskState.PAUSING ||
	                //        this.state_ === InternalTaskState.CANCELING);
	                this.state_ = state;
	                this.notifyObservers_();
	                break;
	            case taskenums_1.InternalTaskState.SUCCESS:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.RUNNING ||
	                //        this.state_ === InternalTaskState.PAUSING ||
	                //        this.state_ === InternalTaskState.CANCELING);
	                this.state_ = state;
	                this.notifyObservers_();
	                break;
	        }
	    };
	    UploadTask.prototype.completeTransitions_ = function () {
	        switch (this.state_) {
	            case taskenums_1.InternalTaskState.PAUSING:
	                this.transition_(taskenums_1.InternalTaskState.PAUSED);
	                break;
	            case taskenums_1.InternalTaskState.CANCELING:
	                this.transition_(taskenums_1.InternalTaskState.CANCELED);
	                break;
	            case taskenums_1.InternalTaskState.RUNNING:
	                this.start_();
	                break;
	            default:
	                // TODO(andysoto): assert(false);
	                break;
	        }
	    };
	    Object.defineProperty(UploadTask.prototype, "snapshot", {
	        get: function () {
	            var externalState = fbsTaskEnums.taskStateFromInternalTaskState(this.state_);
	            return new tasksnapshot_1.UploadTaskSnapshot(this.transferred_, this.blob_.size(), externalState, this.metadata_, this, this.ref_);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Adds a callback for an event.
	     * @param type The type of event to listen for.
	     */
	    UploadTask.prototype.on = function (type, nextOrObserver, error, completed) {
	        if (nextOrObserver === void 0) { nextOrObserver = undefined; }
	        if (error === void 0) { error = undefined; }
	        if (completed === void 0) { completed = undefined; }
	        function typeValidator(_p) {
	            if (type !== taskenums_2.TaskEvent.STATE_CHANGED) {
	                throw "Expected one of the event types: [" + taskenums_2.TaskEvent.STATE_CHANGED + "].";
	            }
	        }
	        var nextOrObserverMessage = 'Expected a function or an Object with one of ' +
	            '`next`, `error`, `complete` properties.';
	        var nextValidator = fbsArgs.nullFunctionSpec(true).validator;
	        var observerValidator = fbsArgs.looseObjectSpec(null, true).validator;
	        function nextOrObserverValidator(p) {
	            try {
	                nextValidator(p);
	                return;
	            }
	            catch (e) { }
	            try {
	                observerValidator(p);
	                var anyDefined = typeUtils.isJustDef(p['next']) ||
	                    typeUtils.isJustDef(p['error']) ||
	                    typeUtils.isJustDef(p['complete']);
	                if (!anyDefined) {
	                    throw '';
	                }
	                return;
	            }
	            catch (e) {
	                throw nextOrObserverMessage;
	            }
	        }
	        var specs = [
	            fbsArgs.stringSpec(typeValidator),
	            fbsArgs.looseObjectSpec(nextOrObserverValidator, true),
	            fbsArgs.nullFunctionSpec(true),
	            fbsArgs.nullFunctionSpec(true)
	        ];
	        fbsArgs.validate('on', specs, arguments);
	        var self = this;
	        function makeBinder(specs) {
	            function binder(nextOrObserver, error, opt_complete) {
	                if (specs !== null) {
	                    fbsArgs.validate('on', specs, arguments);
	                }
	                var observer = new observer_1.Observer(nextOrObserver, error, completed);
	                self.addObserver_(observer);
	                return function () {
	                    self.removeObserver_(observer);
	                };
	            }
	            return binder;
	        }
	        function binderNextOrObserverValidator(p) {
	            if (p === null) {
	                throw nextOrObserverMessage;
	            }
	            nextOrObserverValidator(p);
	        }
	        var binderSpecs = [
	            fbsArgs.looseObjectSpec(binderNextOrObserverValidator),
	            fbsArgs.nullFunctionSpec(true),
	            fbsArgs.nullFunctionSpec(true)
	        ];
	        var typeOnly = !(typeUtils.isJustDef(nextOrObserver) ||
	            typeUtils.isJustDef(error) ||
	            typeUtils.isJustDef(completed));
	        if (typeOnly) {
	            return makeBinder(binderSpecs);
	        }
	        else {
	            return makeBinder(null)(nextOrObserver, error, completed);
	        }
	    };
	    /**
	     * This object behaves like a Promise, and resolves with its snapshot data
	     * when the upload completes.
	     * @param onFulfilled The fulfillment callback. Promise chaining works as normal.
	     * @param onRejected The rejection callback.
	     */
	    UploadTask.prototype.then = function (onFulfilled, onRejected) {
	        // These casts are needed so that TypeScript can infer the types of the
	        // resulting Promise.
	        return this.promise_.then(onFulfilled, onRejected);
	    };
	    /**
	     * Equivalent to calling `then(null, onRejected)`.
	     */
	    UploadTask.prototype.catch = function (onRejected) {
	        return this.then(null, onRejected);
	    };
	    /**
	     * Adds the given observer.
	     */
	    UploadTask.prototype.addObserver_ = function (observer) {
	        this.observers_.push(observer);
	        this.notifyObserver_(observer);
	    };
	    /**
	     * Removes the given observer.
	     */
	    UploadTask.prototype.removeObserver_ = function (observer) {
	        fbsArray.remove(this.observers_, observer);
	    };
	    UploadTask.prototype.notifyObservers_ = function () {
	        var _this = this;
	        this.finishPromise_();
	        var observers = fbsArray.clone(this.observers_);
	        observers.forEach(function (observer) {
	            _this.notifyObserver_(observer);
	        });
	    };
	    UploadTask.prototype.finishPromise_ = function () {
	        if (this.resolve_ !== null) {
	            var triggered = true;
	            switch (fbsTaskEnums.taskStateFromInternalTaskState(this.state_)) {
	                case taskenums_2.TaskState.SUCCESS:
	                    async_1.async(this.resolve_.bind(null, this.snapshot))();
	                    break;
	                case taskenums_2.TaskState.CANCELED:
	                case taskenums_2.TaskState.ERROR:
	                    var toCall = this.reject_;
	                    async_1.async(toCall.bind(null, this.error_))();
	                    break;
	                default:
	                    triggered = false;
	                    break;
	            }
	            if (triggered) {
	                this.resolve_ = null;
	                this.reject_ = null;
	            }
	        }
	    };
	    UploadTask.prototype.notifyObserver_ = function (observer) {
	        var externalState = fbsTaskEnums.taskStateFromInternalTaskState(this.state_);
	        switch (externalState) {
	            case taskenums_2.TaskState.RUNNING:
	            case taskenums_2.TaskState.PAUSED:
	                if (observer.next !== null) {
	                    async_1.async(observer.next.bind(observer, this.snapshot))();
	                }
	                break;
	            case taskenums_2.TaskState.SUCCESS:
	                if (observer.complete !== null) {
	                    async_1.async(observer.complete.bind(observer))();
	                }
	                break;
	            case taskenums_2.TaskState.CANCELED:
	            case taskenums_2.TaskState.ERROR:
	                if (observer.error !== null) {
	                    async_1.async(observer.error.bind(observer, this.error_))();
	                }
	                break;
	            default:
	                // TODO(andysoto): assert(false);
	                if (observer.error !== null) {
	                    async_1.async(observer.error.bind(observer, this.error_))();
	                }
	        }
	    };
	    /**
	     * Resumes a paused task. Has no effect on a currently running or failed task.
	     * @return True if the operation took effect, false if ignored.
	     */
	    UploadTask.prototype.resume = function () {
	        fbsArgs.validate('resume', [], arguments);
	        var valid = this.state_ === taskenums_1.InternalTaskState.PAUSED ||
	            this.state_ === taskenums_1.InternalTaskState.PAUSING;
	        if (valid) {
	            this.transition_(taskenums_1.InternalTaskState.RUNNING);
	        }
	        return valid;
	    };
	    /**
	     * Pauses a currently running task. Has no effect on a paused or failed task.
	     * @return True if the operation took effect, false if ignored.
	     */
	    UploadTask.prototype.pause = function () {
	        fbsArgs.validate('pause', [], arguments);
	        var valid = this.state_ === taskenums_1.InternalTaskState.RUNNING;
	        if (valid) {
	            this.transition_(taskenums_1.InternalTaskState.PAUSING);
	        }
	        return valid;
	    };
	    /**
	     * Cancels a currently running or paused task. Has no effect on a complete or
	     * failed task.
	     * @return True if the operation took effect, false if ignored.
	     */
	    UploadTask.prototype.cancel = function () {
	        fbsArgs.validate('cancel', [], arguments);
	        var valid = this.state_ === taskenums_1.InternalTaskState.RUNNING ||
	            this.state_ === taskenums_1.InternalTaskState.PAUSING;
	        if (valid) {
	            this.transition_(taskenums_1.InternalTaskState.CANCELING);
	        }
	        return valid;
	    };
	    return UploadTask;
	}());
	exports.UploadTask = UploadTask;
	
	//# sourceMappingURL=task.js.map


/***/ },
/* 515 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var UploadTaskSnapshot = /** @class */ (function () {
	    function UploadTaskSnapshot(bytesTransferred, totalBytes, state, metadata, task, ref) {
	        this.bytesTransferred = bytesTransferred;
	        this.totalBytes = totalBytes;
	        this.state = state;
	        this.metadata = metadata;
	        this.task = task;
	        this.ref = ref;
	    }
	    Object.defineProperty(UploadTaskSnapshot.prototype, "downloadURL", {
	        get: function () {
	            if (this.metadata !== null) {
	                var urls = this.metadata['downloadURLs'];
	                if (urls != null && urls[0] != null) {
	                    return urls[0];
	                }
	                else {
	                    return null;
	                }
	            }
	            else {
	                return null;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return UploadTaskSnapshot;
	}());
	exports.UploadTaskSnapshot = UploadTaskSnapshot;
	
	//# sourceMappingURL=tasksnapshot.js.map


/***/ },
/* 516 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Do a deep-copy of basic JavaScript Objects or Arrays.
	 */
	function deepCopy(value) {
	    return deepExtend(undefined, value);
	}
	exports.deepCopy = deepCopy;
	/**
	 * Copy properties from source to target (recursively allows extension
	 * of Objects and Arrays).  Scalar values in the target are over-written.
	 * If target is undefined, an object of the appropriate type will be created
	 * (and returned).
	 *
	 * We recursively copy all child properties of plain Objects in the source- so
	 * that namespace- like dictionaries are merged.
	 *
	 * Note that the target can be a function, in which case the properties in
	 * the source Object are copied onto it as static properties of the Function.
	 */
	function deepExtend(target, source) {
	    if (!(source instanceof Object)) {
	        return source;
	    }
	    switch (source.constructor) {
	        case Date:
	            // Treat Dates like scalars; if the target date object had any child
	            // properties - they will be lost!
	            var dateValue = source;
	            return new Date(dateValue.getTime());
	        case Object:
	            if (target === undefined) {
	                target = {};
	            }
	            break;
	        case Array:
	            // Always copy the array source and overwrite the target.
	            target = [];
	            break;
	        default:
	            // Not a plain Object - treat it as a scalar.
	            return source;
	    }
	    for (var prop in source) {
	        if (!source.hasOwnProperty(prop)) {
	            continue;
	        }
	        target[prop] = deepExtend(target[prop], source[prop]);
	    }
	    return target;
	}
	exports.deepExtend = deepExtend;
	// TODO: Really needed (for JSCompiler type checking)?
	function patchProperty(obj, prop, value) {
	    obj[prop] = value;
	}
	exports.patchProperty = patchProperty;
	
	//# sourceMappingURL=deepCopy.js.map


/***/ },
/* 517 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Deferred = /** @class */ (function () {
	    function Deferred() {
	        var _this = this;
	        this.promise = new Promise(function (resolve, reject) {
	            _this.resolve = resolve;
	            _this.reject = reject;
	        });
	    }
	    /**
	     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
	     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
	     * and returns a node-style callback which will resolve or reject the Deferred's promise.
	     * @param {((?function(?(Error)): (?|undefined))| (?function(?(Error),?=): (?|undefined)))=} callback
	     * @return {!function(?(Error), ?=)}
	     */
	    Deferred.prototype.wrapCallback = function (callback) {
	        var _this = this;
	        return function (error, value) {
	            if (error) {
	                _this.reject(error);
	            }
	            else {
	                _this.resolve(value);
	            }
	            if (typeof callback === 'function') {
	                // Attaching noop handler just in case developer wasn't expecting
	                // promises
	                _this.promise.catch(function () { });
	                // Some of our callbacks don't expect a value and our own tests
	                // assert that the parameter length is 1
	                if (callback.length === 1) {
	                    callback(error);
	                }
	                else {
	                    callback(error, value);
	                }
	            }
	        };
	    };
	    return Deferred;
	}());
	exports.Deferred = Deferred;
	
	//# sourceMappingURL=deferred.js.map


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var constants_1 = __webpack_require__(135);
	/**
	 * Returns navigator.userAgent string or '' if it's not defined.
	 * @return {string} user agent string
	 */
	exports.getUA = function () {
	    if (typeof navigator !== 'undefined' &&
	        typeof navigator['userAgent'] === 'string') {
	        return navigator['userAgent'];
	    }
	    else {
	        return '';
	    }
	};
	/**
	 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
	 *
	 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap in the Ripple emulator) nor
	 * Cordova `onDeviceReady`, which would normally wait for a callback.
	 *
	 * @return {boolean} isMobileCordova
	 */
	exports.isMobileCordova = function () {
	    return (typeof window !== 'undefined' &&
	        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
	        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(exports.getUA()));
	};
	/**
	 * Detect React Native.
	 *
	 * @return {boolean} True if ReactNative environment is detected.
	 */
	exports.isReactNative = function () {
	    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
	};
	/**
	 * Detect Node.js.
	 *
	 * @return {boolean} True if Node.js environment is detected.
	 */
	exports.isNodeSdk = function () {
	    return constants_1.CONSTANTS.NODE_CLIENT === true || constants_1.CONSTANTS.NODE_ADMIN === true;
	};
	
	//# sourceMappingURL=environment.js.map


/***/ },
/* 519 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ERROR_NAME = 'FirebaseError';
	var captureStackTrace = Error
	    .captureStackTrace;
	// Export for faking in tests
	function patchCapture(captureFake) {
	    var result = captureStackTrace;
	    captureStackTrace = captureFake;
	    return result;
	}
	exports.patchCapture = patchCapture;
	var FirebaseError = /** @class */ (function () {
	    function FirebaseError(code, message) {
	        this.code = code;
	        this.message = message;
	        var stack;
	        // We want the stack value, if implemented by Error
	        if (captureStackTrace) {
	            // Patches this.stack, omitted calls above ErrorFactory#create
	            captureStackTrace(this, ErrorFactory.prototype.create);
	        }
	        else {
	            var err_1 = Error.apply(this, arguments);
	            this.name = ERROR_NAME;
	            // Make non-enumerable getter for the property.
	            Object.defineProperty(this, 'stack', {
	                get: function () {
	                    return err_1.stack;
	                }
	            });
	        }
	    }
	    return FirebaseError;
	}());
	exports.FirebaseError = FirebaseError;
	// Back-door inheritance
	FirebaseError.prototype = Object.create(Error.prototype);
	FirebaseError.prototype.constructor = FirebaseError;
	FirebaseError.prototype.name = ERROR_NAME;
	var ErrorFactory = /** @class */ (function () {
	    function ErrorFactory(service, serviceName, errors) {
	        this.service = service;
	        this.serviceName = serviceName;
	        this.errors = errors;
	        // Matches {$name}, by default.
	        this.pattern = /\{\$([^}]+)}/g;
	        // empty
	    }
	    ErrorFactory.prototype.create = function (code, data) {
	        if (data === undefined) {
	            data = {};
	        }
	        var template = this.errors[code];
	        var fullCode = this.service + '/' + code;
	        var message;
	        if (template === undefined) {
	            message = 'Error';
	        }
	        else {
	            message = template.replace(this.pattern, function (match, key) {
	                var value = data[key];
	                return value !== undefined ? value.toString() : '<' + key + '?>';
	            });
	        }
	        // Service: Error message (service/code).
	        message = this.serviceName + ': ' + message + ' (' + fullCode + ').';
	        var err = new FirebaseError(fullCode, message);
	        // Populate the Error object with message parts for programmatic
	        // accesses (e.g., e.file).
	        for (var prop in data) {
	            if (!data.hasOwnProperty(prop) || prop.slice(-1) === '_') {
	                continue;
	            }
	            err[prop] = data[prop];
	        }
	        return err;
	    };
	    return ErrorFactory;
	}());
	exports.ErrorFactory = ErrorFactory;
	
	//# sourceMappingURL=errors.js.map


/***/ },
/* 520 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// Copyright 2011 The Closure Library Authors. All Rights Reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	//      http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS-IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	/**
	 * @fileoverview Abstract cryptographic hash interface.
	 *
	 * See Sha1 and Md5 for sample implementations.
	 *
	 */
	/**
	 * Create a cryptographic hash instance.
	 *
	 * @constructor
	 * @struct
	 */
	var Hash = /** @class */ (function () {
	    function Hash() {
	        /**
	         * The block size for the hasher.
	         * @type {number}
	         */
	        this.blockSize = -1;
	    }
	    return Hash;
	}());
	exports.Hash = Hash;
	
	//# sourceMappingURL=hash.js.map


/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var crypt_1 = __webpack_require__(207);
	var json_1 = __webpack_require__(208);
	/**
	 * Decodes a Firebase auth. token into constituent parts.
	 *
	 * Notes:
	 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 *
	 * @param {?string} token
	 * @return {{header: *, claims: *, data: *, signature: string}}
	 */
	exports.decode = function (token) {
	    var header = {}, claims = {}, data = {}, signature = '';
	    try {
	        var parts = token.split('.');
	        header = json_1.jsonEval(crypt_1.base64Decode(parts[0]) || '');
	        claims = json_1.jsonEval(crypt_1.base64Decode(parts[1]) || '');
	        signature = parts[2];
	        data = claims['d'] || {};
	        delete claims['d'];
	    }
	    catch (e) { }
	    return {
	        header: header,
	        claims: claims,
	        data: data,
	        signature: signature
	    };
	};
	/**
	 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
	 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
	 *
	 * Notes:
	 * - May return a false negative if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 *
	 * @param {?string} token
	 * @return {boolean}
	 */
	exports.isValidTimestamp = function (token) {
	    var claims = exports.decode(token).claims, now = Math.floor(new Date().getTime() / 1000), validSince, validUntil;
	    if (typeof claims === 'object') {
	        if (claims.hasOwnProperty('nbf')) {
	            validSince = claims['nbf'];
	        }
	        else if (claims.hasOwnProperty('iat')) {
	            validSince = claims['iat'];
	        }
	        if (claims.hasOwnProperty('exp')) {
	            validUntil = claims['exp'];
	        }
	        else {
	            // token will expire after 24h by default
	            validUntil = validSince + 86400;
	        }
	    }
	    return (now && validSince && validUntil && now >= validSince && now <= validUntil);
	};
	/**
	 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
	 *
	 * Notes:
	 * - May return null if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 *
	 * @param {?string} token
	 * @return {?number}
	 */
	exports.issuedAtTime = function (token) {
	    var claims = exports.decode(token).claims;
	    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
	        return claims['iat'];
	    }
	    return null;
	};
	/**
	 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time and non-empty
	 * signature.
	 *
	 * Notes:
	 * - May return a false negative if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 *
	 * @param {?string} token
	 * @return {boolean}
	 */
	exports.isValidFormat = function (token) {
	    var decoded = exports.decode(token), claims = decoded.claims;
	    return (!!decoded.signature &&
	        !!claims &&
	        typeof claims === 'object' &&
	        claims.hasOwnProperty('iat'));
	};
	/**
	 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
	 *
	 * Notes:
	 * - May return a false negative if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 *
	 * @param {?string} token
	 * @return {boolean}
	 */
	exports.isAdmin = function (token) {
	    var claims = exports.decode(token).claims;
	    return typeof claims === 'object' && claims['admin'] === true;
	};
	
	//# sourceMappingURL=jwt.js.map


/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var obj_1 = __webpack_require__(209);
	/**
	 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a params
	 * object (e.g. {arg: 'val', arg2: 'val2'})
	 * Note: You must prepend it with ? when adding it to a URL.
	 *
	 * @param {!Object} querystringParams
	 * @return {string}
	 */
	exports.querystring = function (querystringParams) {
	    var params = [];
	    obj_1.forEach(querystringParams, function (key, value) {
	        if (Array.isArray(value)) {
	            value.forEach(function (arrayVal) {
	                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
	            });
	        }
	        else {
	            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
	        }
	    });
	    return params.length ? '&' + params.join('&') : '';
	};
	/**
	 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object (e.g. {arg: 'val', arg2: 'val2'})
	 *
	 * @param {string} querystring
	 * @return {!Object}
	 */
	exports.querystringDecode = function (querystring) {
	    var obj = {};
	    var tokens = querystring.replace(/^\?/, '').split('&');
	    tokens.forEach(function (token) {
	        if (token) {
	            var key = token.split('=');
	            obj[key[0]] = key[1];
	        }
	    });
	    return obj;
	};
	
	//# sourceMappingURL=query.js.map


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var hash_1 = __webpack_require__(520);
	/**
	 * @fileoverview SHA-1 cryptographic hash.
	 * Variable names follow the notation in FIPS PUB 180-3:
	 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
	 *
	 * Usage:
	 *   var sha1 = new sha1();
	 *   sha1.update(bytes);
	 *   var hash = sha1.digest();
	 *
	 * Performance:
	 *   Chrome 23:   ~400 Mbit/s
	 *   Firefox 16:  ~250 Mbit/s
	 *
	 */
	/**
	 * SHA-1 cryptographic hash constructor.
	 *
	 * The properties declared here are discussed in the above algorithm document.
	 * @constructor
	 * @extends {Hash}
	 * @final
	 * @struct
	 */
	var Sha1 = /** @class */ (function (_super) {
	    __extends(Sha1, _super);
	    function Sha1() {
	        var _this = _super.call(this) || this;
	        /**
	         * Holds the previous values of accumulated variables a-e in the compress_
	         * function.
	         * @type {!Array<number>}
	         * @private
	         */
	        _this.chain_ = [];
	        /**
	         * A buffer holding the partially computed hash result.
	         * @type {!Array<number>}
	         * @private
	         */
	        _this.buf_ = [];
	        /**
	         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
	         * as the message schedule in the docs.
	         * @type {!Array<number>}
	         * @private
	         */
	        _this.W_ = [];
	        /**
	         * Contains data needed to pad messages less than 64 bytes.
	         * @type {!Array<number>}
	         * @private
	         */
	        _this.pad_ = [];
	        /**
	         * @private {number}
	         */
	        _this.inbuf_ = 0;
	        /**
	         * @private {number}
	         */
	        _this.total_ = 0;
	        _this.blockSize = 512 / 8;
	        _this.pad_[0] = 128;
	        for (var i = 1; i < _this.blockSize; ++i) {
	            _this.pad_[i] = 0;
	        }
	        _this.reset();
	        return _this;
	    }
	    Sha1.prototype.reset = function () {
	        this.chain_[0] = 0x67452301;
	        this.chain_[1] = 0xefcdab89;
	        this.chain_[2] = 0x98badcfe;
	        this.chain_[3] = 0x10325476;
	        this.chain_[4] = 0xc3d2e1f0;
	        this.inbuf_ = 0;
	        this.total_ = 0;
	    };
	    /**
	     * Internal compress helper function.
	     * @param {!Array<number>|!Uint8Array|string} buf Block to compress.
	     * @param {number=} opt_offset Offset of the block in the buffer.
	     * @private
	     */
	    Sha1.prototype.compress_ = function (buf, opt_offset) {
	        if (!opt_offset) {
	            opt_offset = 0;
	        }
	        var W = this.W_;
	        // get 16 big endian words
	        if (typeof buf === 'string') {
	            for (var i = 0; i < 16; i++) {
	                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
	                // have a bug that turns the post-increment ++ operator into pre-increment
	                // during JIT compilation.  We have code that depends heavily on SHA-1 for
	                // correctness and which is affected by this bug, so I've removed all uses
	                // of post-increment ++ in which the result value is used.  We can revert
	                // this change once the Safari bug
	                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
	                // most clients have been updated.
	                W[i] =
	                    (buf.charCodeAt(opt_offset) << 24) |
	                        (buf.charCodeAt(opt_offset + 1) << 16) |
	                        (buf.charCodeAt(opt_offset + 2) << 8) |
	                        buf.charCodeAt(opt_offset + 3);
	                opt_offset += 4;
	            }
	        }
	        else {
	            for (var i = 0; i < 16; i++) {
	                W[i] =
	                    (buf[opt_offset] << 24) |
	                        (buf[opt_offset + 1] << 16) |
	                        (buf[opt_offset + 2] << 8) |
	                        buf[opt_offset + 3];
	                opt_offset += 4;
	            }
	        }
	        // expand to 80 words
	        for (var i = 16; i < 80; i++) {
	            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
	        }
	        var a = this.chain_[0];
	        var b = this.chain_[1];
	        var c = this.chain_[2];
	        var d = this.chain_[3];
	        var e = this.chain_[4];
	        var f, k;
	        // TODO(user): Try to unroll this loop to speed up the computation.
	        for (var i = 0; i < 80; i++) {
	            if (i < 40) {
	                if (i < 20) {
	                    f = d ^ (b & (c ^ d));
	                    k = 0x5a827999;
	                }
	                else {
	                    f = b ^ c ^ d;
	                    k = 0x6ed9eba1;
	                }
	            }
	            else {
	                if (i < 60) {
	                    f = (b & c) | (d & (b | c));
	                    k = 0x8f1bbcdc;
	                }
	                else {
	                    f = b ^ c ^ d;
	                    k = 0xca62c1d6;
	                }
	            }
	            var t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
	            e = d;
	            d = c;
	            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
	            b = a;
	            a = t;
	        }
	        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
	        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
	        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
	        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
	        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
	    };
	    Sha1.prototype.update = function (bytes, opt_length) {
	        // TODO(johnlenz): tighten the function signature and remove this check
	        if (bytes == null) {
	            return;
	        }
	        if (opt_length === undefined) {
	            opt_length = bytes.length;
	        }
	        var lengthMinusBlock = opt_length - this.blockSize;
	        var n = 0;
	        // Using local instead of member variables gives ~5% speedup on Firefox 16.
	        var buf = this.buf_;
	        var inbuf = this.inbuf_;
	        // The outer while loop should execute at most twice.
	        while (n < opt_length) {
	            // When we have no data in the block to top up, we can directly process the
	            // input buffer (assuming it contains sufficient data). This gives ~25%
	            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
	            // the data is provided in large chunks (or in multiples of 64 bytes).
	            if (inbuf == 0) {
	                while (n <= lengthMinusBlock) {
	                    this.compress_(bytes, n);
	                    n += this.blockSize;
	                }
	            }
	            if (typeof bytes === 'string') {
	                while (n < opt_length) {
	                    buf[inbuf] = bytes.charCodeAt(n);
	                    ++inbuf;
	                    ++n;
	                    if (inbuf == this.blockSize) {
	                        this.compress_(buf);
	                        inbuf = 0;
	                        // Jump to the outer loop so we use the full-block optimization.
	                        break;
	                    }
	                }
	            }
	            else {
	                while (n < opt_length) {
	                    buf[inbuf] = bytes[n];
	                    ++inbuf;
	                    ++n;
	                    if (inbuf == this.blockSize) {
	                        this.compress_(buf);
	                        inbuf = 0;
	                        // Jump to the outer loop so we use the full-block optimization.
	                        break;
	                    }
	                }
	            }
	        }
	        this.inbuf_ = inbuf;
	        this.total_ += opt_length;
	    };
	    /** @override */
	    Sha1.prototype.digest = function () {
	        var digest = [];
	        var totalBits = this.total_ * 8;
	        // Add pad 0x80 0x00*.
	        if (this.inbuf_ < 56) {
	            this.update(this.pad_, 56 - this.inbuf_);
	        }
	        else {
	            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
	        }
	        // Add # bits.
	        for (var i = this.blockSize - 1; i >= 56; i--) {
	            this.buf_[i] = totalBits & 255;
	            totalBits /= 256; // Don't use bit-shifting here!
	        }
	        this.compress_(this.buf_);
	        var n = 0;
	        for (var i = 0; i < 5; i++) {
	            for (var j = 24; j >= 0; j -= 8) {
	                digest[n] = (this.chain_[i] >> j) & 255;
	                ++n;
	            }
	        }
	        return digest;
	    };
	    return Sha1;
	}(hash_1.Hash));
	exports.Sha1 = Sha1;
	
	//# sourceMappingURL=sha1.js.map


/***/ },
/* 524 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Helper to make a Subscribe function (just like Promise helps make a
	 * Thenable).
	 *
	 * @param executor Function which can make calls to a single Observer
	 *     as a proxy.
	 * @param onNoObservers Callback when count of Observers goes to zero.
	 */
	function createSubscribe(executor, onNoObservers) {
	    var proxy = new ObserverProxy(executor, onNoObservers);
	    return proxy.subscribe.bind(proxy);
	}
	exports.createSubscribe = createSubscribe;
	/**
	 * Implement fan-out for any number of Observers attached via a subscribe
	 * function.
	 */
	var ObserverProxy = /** @class */ (function () {
	    /**
	     * @param executor Function which can make calls to a single Observer
	     *     as a proxy.
	     * @param onNoObservers Callback when count of Observers goes to zero.
	     */
	    function ObserverProxy(executor, onNoObservers) {
	        var _this = this;
	        this.observers = [];
	        this.unsubscribes = [];
	        this.observerCount = 0;
	        // Micro-task scheduling by calling task.then().
	        this.task = Promise.resolve();
	        this.finalized = false;
	        this.onNoObservers = onNoObservers;
	        // Call the executor asynchronously so subscribers that are called
	        // synchronously after the creation of the subscribe function
	        // can still receive the very first value generated in the executor.
	        this.task
	            .then(function () {
	            executor(_this);
	        })
	            .catch(function (e) {
	            _this.error(e);
	        });
	    }
	    ObserverProxy.prototype.next = function (value) {
	        this.forEachObserver(function (observer) {
	            observer.next(value);
	        });
	    };
	    ObserverProxy.prototype.error = function (error) {
	        this.forEachObserver(function (observer) {
	            observer.error(error);
	        });
	        this.close(error);
	    };
	    ObserverProxy.prototype.complete = function () {
	        this.forEachObserver(function (observer) {
	            observer.complete();
	        });
	        this.close();
	    };
	    /**
	     * Subscribe function that can be used to add an Observer to the fan-out list.
	     *
	     * - We require that no event is sent to a subscriber sychronously to their
	     *   call to subscribe().
	     */
	    ObserverProxy.prototype.subscribe = function (nextOrObserver, error, complete) {
	        var _this = this;
	        var observer;
	        if (nextOrObserver === undefined &&
	            error === undefined &&
	            complete === undefined) {
	            throw new Error('Missing Observer.');
	        }
	        // Assemble an Observer object when passed as callback functions.
	        if (implementsAnyMethods(nextOrObserver, ['next', 'error', 'complete'])) {
	            observer = nextOrObserver;
	        }
	        else {
	            observer = {
	                next: nextOrObserver,
	                error: error,
	                complete: complete
	            };
	        }
	        if (observer.next === undefined) {
	            observer.next = noop;
	        }
	        if (observer.error === undefined) {
	            observer.error = noop;
	        }
	        if (observer.complete === undefined) {
	            observer.complete = noop;
	        }
	        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
	        // Attempt to subscribe to a terminated Observable - we
	        // just respond to the Observer with the final error or complete
	        // event.
	        if (this.finalized) {
	            this.task.then(function () {
	                try {
	                    if (_this.finalError) {
	                        observer.error(_this.finalError);
	                    }
	                    else {
	                        observer.complete();
	                    }
	                }
	                catch (e) {
	                    // nothing
	                }
	                return;
	            });
	        }
	        this.observers.push(observer);
	        return unsub;
	    };
	    // Unsubscribe is synchronous - we guarantee that no events are sent to
	    // any unsubscribed Observer.
	    ObserverProxy.prototype.unsubscribeOne = function (i) {
	        if (this.observers === undefined || this.observers[i] === undefined) {
	            return;
	        }
	        delete this.observers[i];
	        this.observerCount -= 1;
	        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
	            this.onNoObservers(this);
	        }
	    };
	    ObserverProxy.prototype.forEachObserver = function (fn) {
	        if (this.finalized) {
	            // Already closed by previous event....just eat the additional values.
	            return;
	        }
	        // Since sendOne calls asynchronously - there is no chance that
	        // this.observers will become undefined.
	        for (var i = 0; i < this.observers.length; i++) {
	            this.sendOne(i, fn);
	        }
	    };
	    // Call the Observer via one of it's callback function. We are careful to
	    // confirm that the observe has not been unsubscribed since this asynchronous
	    // function had been queued.
	    ObserverProxy.prototype.sendOne = function (i, fn) {
	        var _this = this;
	        // Execute the callback asynchronously
	        this.task.then(function () {
	            if (_this.observers !== undefined && _this.observers[i] !== undefined) {
	                try {
	                    fn(_this.observers[i]);
	                }
	                catch (e) {
	                    // Ignore exceptions raised in Observers or missing methods of an
	                    // Observer.
	                    // Log error to console. b/31404806
	                    if (typeof console !== 'undefined' && console.error) {
	                        console.error(e);
	                    }
	                }
	            }
	        });
	    };
	    ObserverProxy.prototype.close = function (err) {
	        var _this = this;
	        if (this.finalized) {
	            return;
	        }
	        this.finalized = true;
	        if (err !== undefined) {
	            this.finalError = err;
	        }
	        // Proxy is no longer needed - garbage collect references
	        this.task.then(function () {
	            _this.observers = undefined;
	            _this.onNoObservers = undefined;
	        });
	    };
	    return ObserverProxy;
	}());
	/** Turn synchronous function into one called asynchronously. */
	function async(fn, onError) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        Promise.resolve(true)
	            .then(function () {
	            fn.apply(void 0, args);
	        })
	            .catch(function (error) {
	            if (onError) {
	                onError(error);
	            }
	        });
	    };
	}
	exports.async = async;
	/**
	 * Return true if the object passed in implements any of the named methods.
	 */
	function implementsAnyMethods(obj, methods) {
	    if (typeof obj !== 'object' || obj === null) {
	        return false;
	    }
	    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
	        var method = methods_1[_i];
	        if (method in obj && typeof obj[method] === 'function') {
	            return true;
	        }
	    }
	    return false;
	}
	function noop() {
	    // do nothing
	}
	
	//# sourceMappingURL=subscribe.js.map


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var assert_1 = __webpack_require__(206);
	// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
	// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
	// so it's been modified.
	// Note that not all Unicode characters appear as single characters in JavaScript strings.
	// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
	// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
	// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
	// pair).
	// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
	/**
	 * @param {string} str
	 * @return {Array}
	 */
	exports.stringToByteArray = function (str) {
	    var out = [], p = 0;
	    for (var i = 0; i < str.length; i++) {
	        var c = str.charCodeAt(i);
	        // Is this the lead surrogate in a surrogate pair?
	        if (c >= 0xd800 && c <= 0xdbff) {
	            var high = c - 0xd800; // the high 10 bits.
	            i++;
	            assert_1.assert(i < str.length, 'Surrogate pair missing trail surrogate.');
	            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
	            c = 0x10000 + (high << 10) + low;
	        }
	        if (c < 128) {
	            out[p++] = c;
	        }
	        else if (c < 2048) {
	            out[p++] = (c >> 6) | 192;
	            out[p++] = (c & 63) | 128;
	        }
	        else if (c < 65536) {
	            out[p++] = (c >> 12) | 224;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	        else {
	            out[p++] = (c >> 18) | 240;
	            out[p++] = ((c >> 12) & 63) | 128;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	    }
	    return out;
	};
	/**
	 * Calculate length without actually converting; useful for doing cheaper validation.
	 * @param {string} str
	 * @return {number}
	 */
	exports.stringLength = function (str) {
	    var p = 0;
	    for (var i = 0; i < str.length; i++) {
	        var c = str.charCodeAt(i);
	        if (c < 128) {
	            p++;
	        }
	        else if (c < 2048) {
	            p += 2;
	        }
	        else if (c >= 0xd800 && c <= 0xdbff) {
	            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
	            p += 4;
	            i++; // skip trail surrogate.
	        }
	        else {
	            p += 3;
	        }
	    }
	    return p;
	};
	
	//# sourceMappingURL=utf8.js.map


/***/ },
/* 526 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Check to make sure the appropriate number of arguments are provided for a public function.
	 * Throws an error if it fails.
	 *
	 * @param {!string} fnName The function name
	 * @param {!number} minCount The minimum number of arguments to allow for the function call
	 * @param {!number} maxCount The maximum number of argument to allow for the function call
	 * @param {!number} argCount The actual number of arguments provided.
	 */
	exports.validateArgCount = function (fnName, minCount, maxCount, argCount) {
	    var argError;
	    if (argCount < minCount) {
	        argError = 'at least ' + minCount;
	    }
	    else if (argCount > maxCount) {
	        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
	    }
	    if (argError) {
	        var error = fnName +
	            ' failed: Was called with ' +
	            argCount +
	            (argCount === 1 ? ' argument.' : ' arguments.') +
	            ' Expects ' +
	            argError +
	            '.';
	        throw new Error(error);
	    }
	};
	/**
	 * Generates a string to prefix an error message about failed argument validation
	 *
	 * @param {!string} fnName The function name
	 * @param {!number} argumentNumber The index of the argument
	 * @param {boolean} optional Whether or not the argument is optional
	 * @return {!string} The prefix to add to the error thrown for validation.
	 */
	function errorPrefix(fnName, argumentNumber, optional) {
	    var argName = '';
	    switch (argumentNumber) {
	        case 1:
	            argName = optional ? 'first' : 'First';
	            break;
	        case 2:
	            argName = optional ? 'second' : 'Second';
	            break;
	        case 3:
	            argName = optional ? 'third' : 'Third';
	            break;
	        case 4:
	            argName = optional ? 'fourth' : 'Fourth';
	            break;
	        default:
	            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
	    }
	    var error = fnName + ' failed: ';
	    error += argName + ' argument ';
	    return error;
	}
	exports.errorPrefix = errorPrefix;
	/**
	 * @param {!string} fnName
	 * @param {!number} argumentNumber
	 * @param {!string} namespace
	 * @param {boolean} optional
	 */
	function validateNamespace(fnName, argumentNumber, namespace, optional) {
	    if (optional && !namespace)
	        return;
	    if (typeof namespace !== 'string') {
	        //TODO: I should do more validation here. We only allow certain chars in namespaces.
	        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid firebase namespace.');
	    }
	}
	exports.validateNamespace = validateNamespace;
	function validateCallback(fnName, argumentNumber, callback, optional) {
	    if (optional && !callback)
	        return;
	    if (typeof callback !== 'function')
	        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid function.');
	}
	exports.validateCallback = validateCallback;
	function validateContextObject(fnName, argumentNumber, context, optional) {
	    if (optional && !context)
	        return;
	    if (typeof context !== 'object' || context === null)
	        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid context object.');
	}
	exports.validateContextObject = validateContextObject;
	
	//# sourceMappingURL=validation.js.map


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function() {var g,goog=goog||{},k=this;function l(a){return"string"==typeof a}function aa(){}
	function ba(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
	else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function n(a){return"array"==ba(a)}function ca(a){var b=ba(a);return"array"==b||"object"==b&&"number"==typeof a.length}function da(a){return"function"==ba(a)}function p(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}var q="closure_uid_"+(1E9*Math.random()>>>0),ea=0;function fa(a,b,c){return a.call.apply(a.bind,arguments)}
	function ha(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function r(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?r=fa:r=ha;return r.apply(null,arguments)}
	function ia(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var b=c.slice();b.push.apply(b,arguments);return a.apply(this,b)}}var t=Date.now||function(){return+new Date};function u(a,b){function c(){}c.prototype=b.prototype;a.L=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.Ab=function(a,c,f){for(var d=Array(arguments.length-2),e=2;e<arguments.length;e++)d[e-2]=arguments[e];return b.prototype[c].apply(a,d)}};function ja(a){if(Error.captureStackTrace)Error.captureStackTrace(this,ja);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))}u(ja,Error);ja.prototype.name="CustomError";function ka(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")}var la=String.prototype.trim?function(a){return a.trim()}:function(a){return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g,"")};function ma(a,b){return a<b?-1:a>b?1:0};function na(a,b){b.unshift(a);ja.call(this,ka.apply(null,b));b.shift()}u(na,ja);na.prototype.name="AssertionError";function oa(a,b){throw new na("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));};function w(){0!=qa&&(ra[this[q]||(this[q]=++ea)]=this);this.i=this.i;this.w=this.w}var qa=0,ra={};w.prototype.i=!1;w.prototype.Z=function(){if(!this.i&&(this.i=!0,this.A(),0!=qa)){var a=this[q]||(this[q]=++ea);delete ra[a]}};w.prototype.A=function(){if(this.w)for(;this.w.length;)this.w.shift()()};var sa=Array.prototype.indexOf?function(a,b){return Array.prototype.indexOf.call(a,b,void 0)}:function(a,b){if(l(a))return l(b)&&1==b.length?a.indexOf(b,0):-1;for(var c=0;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},ta=Array.prototype.forEach?function(a,b,c){Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=l(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};
	function ua(a){a:{var b=va;for(var c=a.length,d=l(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:l(a)?a.charAt(b):a[b]}function wa(a){if(!n(a))for(var b=a.length-1;0<=b;b--)delete a[b];a.length=0}function xa(a){return Array.prototype.concat.apply([],arguments)}function ya(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};var x;a:{var za=k.navigator;if(za){var Aa=za.userAgent;if(Aa){x=Aa;break a}}x=""}function y(a){return-1!=x.indexOf(a)};function Ba(a,b,c){for(var d in a)b.call(c,a[d],d,a)}function Ca(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b}function Da(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b}function Ea(a){var b={},c;for(c in a)b[c]=a[c];return b}var Fa="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
	function Ga(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<Fa.length;f++)c=Fa[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};function Ha(a){Ha[" "](a);return a}Ha[" "]=aa;function Ia(a,b){var c=Ja;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var Ka=y("Opera"),z=y("Trident")||y("MSIE"),La=y("Edge"),Ma=y("Gecko")&&!(-1!=x.toLowerCase().indexOf("webkit")&&!y("Edge"))&&!(y("Trident")||y("MSIE"))&&!y("Edge"),Na=-1!=x.toLowerCase().indexOf("webkit")&&!y("Edge");function Oa(){var a=k.document;return a?a.documentMode:void 0}var Pa;
	a:{var Qa="",Ra=function(){var a=x;if(Ma)return/rv:([^\);]+)(\)|;)/.exec(a);if(La)return/Edge\/([\d\.]+)/.exec(a);if(z)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(Na)return/WebKit\/(\S+)/.exec(a);if(Ka)return/(?:Version)[ \/]?(\S+)/.exec(a)}();Ra&&(Qa=Ra?Ra[1]:"");if(z){var Sa=Oa();if(null!=Sa&&Sa>parseFloat(Qa)){Pa=String(Sa);break a}}Pa=Qa}var Ja={};
	function Ta(a){return Ia(a,function(){for(var b=0,c=la(String(Pa)).split("."),d=la(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var h=c[f]||"",m=d[f]||"";do{h=/(\d*)(\D*)(.*)/.exec(h)||["","","",""];m=/(\d*)(\D*)(.*)/.exec(m)||["","","",""];if(0==h[0].length&&0==m[0].length)break;b=ma(0==h[1].length?0:parseInt(h[1],10),0==m[1].length?0:parseInt(m[1],10))||ma(0==h[2].length,0==m[2].length)||ma(h[2],m[2]);h=h[3];m=m[3]}while(0==b)}return 0<=b})}var Ua;var Va=k.document;
	Ua=Va&&z?Oa()||("CSS1Compat"==Va.compatMode?parseInt(Pa,10):5):void 0;var Wa=Object.freeze||function(a){return a};var Xa=!z||9<=Number(Ua),Ya=z&&!Ta("9"),Za=function(){if(!k.addEventListener||!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0}});k.addEventListener("test",aa,b);k.removeEventListener("test",aa,b);return a}();function A(a,b){this.type=a;this.a=this.target=b;this.Pa=!0}A.prototype.b=function(){this.Pa=!1};function $a(a,b){A.call(this,a?a.type:"");this.relatedTarget=this.a=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=0;this.key="";this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.pointerId=0;this.pointerType="";this.c=null;if(a){var c=this.type=a.type,d=a.changedTouches?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.a=b;if(b=a.relatedTarget){if(Ma){a:{try{Ha(b.nodeName);var e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==c?b=
	a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;null===d?(this.clientX=void 0!==a.clientX?a.clientX:a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0):(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0);this.button=a.button;this.key=a.key||"";this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=
	a.metaKey;this.pointerId=a.pointerId||0;this.pointerType=l(a.pointerType)?a.pointerType:ab[a.pointerType]||"";this.c=a;a.defaultPrevented&&this.b()}}u($a,A);var ab=Wa({2:"touch",3:"pen",4:"mouse"});$a.prototype.b=function(){$a.L.b.call(this);var a=this.c;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,Ya)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};var bb="closure_listenable_"+(1E6*Math.random()|0);function cb(a){return!(!a||!a[bb])}var db=0;function eb(a,b,c,d,e){this.listener=a;this.a=null;this.src=b;this.type=c;this.capture=!!d;this.ga=e;this.key=++db;this.Y=this.ca=!1}function fb(a){a.Y=!0;a.listener=null;a.a=null;a.src=null;a.ga=null};function gb(a){this.src=a;this.a={};this.b=0}gb.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.a[f];a||(a=this.a[f]=[],this.b++);var h=hb(a,b,d,e);-1<h?(b=a[h],c||(b.ca=!1)):(b=new eb(b,this.src,f,!!d,e),b.ca=c,a.push(b));return b};function ib(a,b){var c=b.type;if(c in a.a){var d=a.a[c],e=sa(d,b),f;(f=0<=e)&&Array.prototype.splice.call(d,e,1);f&&(fb(b),0==a.a[c].length&&(delete a.a[c],a.b--))}}function jb(a,b,c,d,e){a=a.a[b.toString()];b=-1;a&&(b=hb(a,c,d,e));return-1<b?a[b]:null}
	function hb(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.Y&&f.listener==b&&f.capture==!!c&&f.ga==d)return e}return-1};var kb="closure_lm_"+(1E6*Math.random()|0),lb={},mb=0;function nb(a,b,c,d,e){if(d&&d.once)return ob(a,b,c,d,e);if(n(b)){for(var f=0;f<b.length;f++)nb(a,b[f],c,d,e);return null}c=pb(c);return cb(a)?a.aa(b,c,p(d)?!!d.capture:!!d,e):qb(a,b,c,!1,d,e)}
	function qb(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var h=p(e)?!!e.capture:!!e,m=rb(a);m||(a[kb]=m=new gb(a));c=m.add(b,c,d,h,f);if(c.a)return c;d=sb();c.a=d;d.src=a;d.listener=c;if(a.addEventListener)Za||(e=h),void 0===e&&(e=!1),a.addEventListener(b.toString(),d,e);else if(a.attachEvent)a.attachEvent(tb(b.toString()),d);else if(a.addListener&&a.removeListener)a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");mb++;return c}
	function sb(){var a=ub,b=Xa?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}function ob(a,b,c,d,e){if(n(b)){for(var f=0;f<b.length;f++)ob(a,b[f],c,d,e);return null}c=pb(c);return cb(a)?a.Ha(b,c,p(d)?!!d.capture:!!d,e):qb(a,b,c,!0,d,e)}function vb(a,b,c,d,e){if(n(b))for(var f=0;f<b.length;f++)vb(a,b[f],c,d,e);else d=p(d)?!!d.capture:!!d,c=pb(c),cb(a)?a.va(b,c,d,e):a&&(a=rb(a))&&(b=jb(a,b,c,d,e))&&wb(b)}
	function wb(a){if("number"!=typeof a&&a&&!a.Y){var b=a.src;if(cb(b))ib(b.c,a);else{var c=a.type,d=a.a;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent?b.detachEvent(tb(c),d):b.addListener&&b.removeListener&&b.removeListener(d);mb--;(c=rb(b))?(ib(c,a),0==c.b&&(c.src=null,b[kb]=null)):fb(a)}}}function tb(a){return a in lb?lb[a]:lb[a]="on"+a}
	function xb(a,b,c,d){var e=!0;if(a=rb(a))if(b=a.a[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.Y&&(f=yb(f,d),e=e&&!1!==f)}return e}function yb(a,b){var c=a.listener,d=a.ga||a.src;a.ca&&wb(a);return c.call(d,b)}
	function ub(a,b){if(a.Y)return!0;if(!Xa){if(!b)a:{b=["window","event"];for(var c=k,d=0;d<b.length;d++)if(c=c[b[d]],null==c){b=null;break a}b=c}d=b;b=new $a(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(h){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.a;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-1;0<=e;e--){b.a=d[e];var f=xb(d[e],a,!0,b);c=c&&f}for(e=0;e<d.length;e++)b.a=d[e],f=xb(d[e],a,!1,b),c=c&&f}return c}return yb(a,
	new $a(b,this))}function rb(a){a=a[kb];return a instanceof gb?a:null}var zb="__closure_events_fn_"+(1E9*Math.random()>>>0);function pb(a){if(da(a))return a;a[zb]||(a[zb]=function(b){return a.handleEvent(b)});return a[zb]};function B(){w.call(this);this.c=new gb(this);this.P=this;this.J=null}u(B,w);B.prototype[bb]=!0;g=B.prototype;g.addEventListener=function(a,b,c,d){nb(this,a,b,c,d)};g.removeEventListener=function(a,b,c,d){vb(this,a,b,c,d)};
	g.dispatchEvent=function(a){var b,c=this.J;if(c)for(b=[];c;c=c.J)b.push(c);c=this.P;var d=a.type||a;if(l(a))a=new A(a,c);else if(a instanceof A)a.target=a.target||c;else{var e=a;a=new A(d,c);Ga(a,e)}e=!0;if(b)for(var f=b.length-1;0<=f;f--){var h=a.a=b[f];e=Ab(h,d,!0,a)&&e}h=a.a=c;e=Ab(h,d,!0,a)&&e;e=Ab(h,d,!1,a)&&e;if(b)for(f=0;f<b.length;f++)h=a.a=b[f],e=Ab(h,d,!1,a)&&e;return e};
	g.A=function(){B.L.A.call(this);if(this.c){var a=this.c,b=0,c;for(c in a.a){for(var d=a.a[c],e=0;e<d.length;e++)++b,fb(d[e]);delete a.a[c];a.b--}}this.J=null};g.aa=function(a,b,c,d){return this.c.add(String(a),b,!1,c,d)};g.Ha=function(a,b,c,d){return this.c.add(String(a),b,!0,c,d)};g.va=function(a,b,c,d){var e=this.c;a=String(a).toString();if(a in e.a){var f=e.a[a];b=hb(f,b,c,d);-1<b&&(fb(f[b]),Array.prototype.splice.call(f,b,1),0==f.length&&(delete e.a[a],e.b--))}};
	function Ab(a,b,c,d){b=a.c.a[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var h=b[f];if(h&&!h.Y&&h.capture==c){var m=h.listener,v=h.ga||h.src;h.ca&&ib(a.c,h);e=!1!==m.call(v,d)&&e}}return e&&0!=d.Pa};function Bb(a){return/^\s*$/.test(a)?!1:/^[\],:{}\s\u2028\u2029]*$/.test(a.replace(/\\["\\\/bfnrtu]/g,"@").replace(/(?:"[^"\\\n\r\u2028\u2029\x00-\x08\x0a-\x1f]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)[\s\u2028\u2029]*(?=:|,|]|}|$)/g,"]").replace(/(?:^|:|,)(?:[\s\u2028\u2029]*\[)+/g,""))}function Cb(a){a=String(a);if(Bb(a))try{return eval("("+a+")")}catch(b){}throw Error("Invalid JSON string: "+a);}function Db(a){var b=[];Eb(new Fb,a,b);return b.join("")}function Fb(){}
	function Eb(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(n(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),Eb(a,d[f],c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");e="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(f=b[d],"function"!=typeof f&&(c.push(e),Gb(d,c),c.push(":"),Eb(a,f,c),e=","));c.push("}");return}}switch(typeof b){case "string":Gb(b,c);break;case "number":c.push(isFinite(b)&&
	!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}}var Hb={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},Ib=/\uffff/.test("\uffff")?/[\\"\x00-\x1f\x7f-\uffff]/g:/[\\"\x00-\x1f\x7f-\xff]/g;
	function Gb(a,b){b.push('"',a.replace(Ib,function(a){var b=Hb[a];b||(b="\\u"+(a.charCodeAt(0)|65536).toString(16).substr(1),Hb[a]=b);return b}),'"')};function Jb(a,b){this.c=a;this.f=b;this.b=0;this.a=null}Jb.prototype.get=function(){if(0<this.b){this.b--;var a=this.a;this.a=a.next;a.next=null}else a=this.c();return a};function Kb(){this.b=this.a=null}var Nb=new Jb(function(){return new Lb},function(a){a.reset()});Kb.prototype.add=function(a,b){var c=Nb.get();c.set(a,b);this.b?this.b.next=c:this.a=c;this.b=c};function Ob(){var a=Pb,b=null;a.a&&(b=a.a,a.a=a.a.next,a.a||(a.b=null),b.next=null);return b}function Lb(){this.next=this.b=this.a=null}Lb.prototype.set=function(a,b){this.a=a;this.b=b;this.next=null};Lb.prototype.reset=function(){this.next=this.b=this.a=null};function Qb(a){k.setTimeout(function(){throw a;},0)}var Rb;
	function Sb(){var a=k.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!y("Presto")&&(a=function(){var a=document.createElement("IFRAME");a.style.display="none";a.src="";document.documentElement.appendChild(a);var b=a.contentWindow;a=b.document;a.open();a.write("");a.close();var c="callImmediate"+Math.random(),d="file:"==b.location.protocol?"*":b.location.protocol+"//"+b.location.host;a=r(function(a){if(("*"==d||a.origin==d)&&a.data==
	c)this.port1.onmessage()},this);b.addEventListener("message",a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,d)}}});if("undefined"!==typeof a&&!y("Trident")&&!y("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var a=c.za;c.za=null;a()}};return function(a){d.next={za:a};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?function(a){var b=document.createElement("SCRIPT");
	b.onreadystatechange=function(){b.onreadystatechange=null;b.parentNode.removeChild(b);b=null;a();a=null};document.documentElement.appendChild(b)}:function(a){k.setTimeout(a,0)}};var Tb;function Ub(){if(-1!=String(k.Promise).indexOf("[native code]")){var a=k.Promise.resolve(void 0);Tb=function(){a.then(Vb)}}else Tb=function(){var a=Vb;!da(k.setImmediate)||k.Window&&k.Window.prototype&&!y("Edge")&&k.Window.prototype.setImmediate==k.setImmediate?(Rb||(Rb=Sb()),Rb(a)):k.setImmediate(a)}}var Wb=!1,Pb=new Kb;function Vb(){for(var a;a=Ob();){try{a.a.call(a.b)}catch(c){Qb(c)}var b=Nb;b.f(a);100>b.b&&(b.b++,a.next=b.a,b.a=a)}Wb=!1};function Xb(a,b){B.call(this);this.b=a||1;this.a=b||k;this.f=r(this.ib,this);this.g=t()}u(Xb,B);g=Xb.prototype;g.$=!1;g.K=null;g.ib=function(){if(this.$){var a=t()-this.g;0<a&&a<.8*this.b?this.K=this.a.setTimeout(this.f,this.b-a):(this.K&&(this.a.clearTimeout(this.K),this.K=null),this.dispatchEvent("tick"),this.$&&(this.K=this.a.setTimeout(this.f,this.b),this.g=t()))}};g.start=function(){this.$=!0;this.K||(this.K=this.a.setTimeout(this.f,this.b),this.g=t())};
	function Yb(a){a.$=!1;a.K&&(a.a.clearTimeout(a.K),a.K=null)}g.A=function(){Xb.L.A.call(this);Yb(this);delete this.a};function Zb(a,b,c){if(da(a))c&&(a=r(a,c));else if(a&&"function"==typeof a.handleEvent)a=r(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:k.setTimeout(a,b||0)};function $b(a,b,c){w.call(this);this.f=null!=c?r(a,c):a;this.c=b;this.b=r(this.bb,this);this.a=[]}u($b,w);g=$b.prototype;g.ha=!1;g.X=null;g.Xa=function(a){this.a=arguments;this.X?this.ha=!0:ac(this)};g.A=function(){$b.L.A.call(this);this.X&&(k.clearTimeout(this.X),this.X=null,this.ha=!1,this.a=[])};g.bb=function(){this.X=null;this.ha&&(this.ha=!1,ac(this))};function ac(a){a.X=Zb(a.b,a.c);a.f.apply(null,a.a)};function C(a){w.call(this);this.b=a;this.a={}}u(C,w);var bc=[];C.prototype.aa=function(a,b,c,d){n(b)||(b&&(bc[0]=b.toString()),b=bc);for(var e=0;e<b.length;e++){var f=nb(a,b[e],c||this.handleEvent,d||!1,this.b||this);if(!f)break;this.a[f.key]=f}return this};
	C.prototype.va=function(a,b,c,d,e){if(n(b))for(var f=0;f<b.length;f++)this.va(a,b[f],c,d,e);else c=c||this.handleEvent,d=p(d)?!!d.capture:!!d,e=e||this.b||this,c=pb(c),d=!!d,b=cb(a)?jb(a.c,String(b),c,d,e):a?(a=rb(a))?jb(a,b,c,d,e):null:null,b&&(wb(b),delete this.a[b.key])};function cc(a){Ba(a.a,function(a,c){this.a.hasOwnProperty(c)&&wb(a)},a);a.a={}}C.prototype.A=function(){C.L.A.call(this);cc(this)};C.prototype.handleEvent=function(){throw Error("EventHandler.handleEvent not implemented");};function dc(a,b,c){this.reset(a,b,c,void 0,void 0)}dc.prototype.a=null;var ec=0;dc.prototype.reset=function(a,b,c,d,e){"number"==typeof e||ec++;d||t();delete this.a};function fc(a){this.f=a;this.b=this.c=this.a=null}function D(a,b){this.name=a;this.value=b}D.prototype.toString=function(){return this.name};var gc=new D("SEVERE",1E3),hc=new D("WARNING",900),ic=new D("INFO",800),jc=new D("CONFIG",700),kc=new D("FINE",500);function lc(a){if(a.c)return a.c;if(a.a)return lc(a.a);oa("Root logger has no level set.");return null}fc.prototype.log=function(a,b,c){if(a.value>=lc(this).value)for(da(b)&&(b=b()),a=new dc(a,String(b),this.f),c&&(a.a=c),c=this;c;)c=c.a};
	var mc={},nc=null;function oc(a){nc||(nc=new fc(""),mc[""]=nc,nc.c=jc);var b;if(!(b=mc[a])){b=new fc(a);var c=a.lastIndexOf("."),d=a.substr(c+1);c=oc(a.substr(0,c));c.b||(c.b={});c.b[d]=b;b.a=c;mc[a]=b}return b};function E(a,b){a&&a.log(hc,b,void 0)}function pc(a,b){a&&a.log(ic,b,void 0)}function F(a,b){a&&a.log(kc,b,void 0)};function qc(){this.a=oc("goog.labs.net.webChannel.WebChannelDebug");this.b=!0}qc.prototype.Ea=function(){this.b=!1};function rc(a,b,c,d,e,f){H(a,function(){if(a.b)if(f){var h="";for(var m=f.split("&"),v=0;v<m.length;v++){var G=m[v].split("=");if(1<G.length){var Z=G[0];G=G[1];var Mb=Z.split("_");h=2<=Mb.length&&"type"==Mb[1]?h+(Z+"="+G+"&"):h+(Z+"=redacted&")}}}else h=null;else h=f;return"XMLHTTP REQ ("+d+") [attempt "+e+"]: "+b+"\n"+c+"\n"+h})}
	function sc(a,b,c,d,e,f,h){H(a,function(){return"XMLHTTP RESP ("+d+") [ attempt "+e+"]: "+b+"\n"+c+"\n"+f+" "+h})}function tc(a,b,c,d){H(a,function(){return"XMLHTTP TEXT ("+b+"): "+uc(a,c)+(d?" "+d:"")})}function vc(a,b){H(a,function(){return"TIMEOUT: "+b})}function I(a,b){F(a.a,b)}function wc(a,b,c){(a=a.a)&&a.log(gc,c||"Exception",b)}function H(a,b){pc(a.a,b)}function xc(a,b){(a=a.a)&&a.log(gc,b,void 0)}
	function uc(a,b){if(!a.b)return b;if(!b)return null;try{var c=JSON.parse(b);if(c)for(var d=0;d<c.length;d++)if(n(c[d])){var e=c[d];if(!(2>e.length)){var f=e[1];if(n(f)&&!(1>f.length)){var h=f[0];if("noop"!=h&&"stop"!=h&&"close"!=h)for(var m=1;m<f.length;m++)f[m]=""}}}return Db(c)}catch(v){return I(a,"Exception parsing expected JS array - probably was not JS"),b}};var yc=new B;function zc(a){A.call(this,"serverreachability",a)}u(zc,A);function Ac(a){yc.dispatchEvent(new zc(yc,a))}function Bc(a){A.call(this,"statevent",a)}u(Bc,A);function J(a){yc.dispatchEvent(new Bc(yc,a))}function Cc(a){A.call(this,"timingevent",a)}u(Cc,A);function Dc(a,b,c){yc.dispatchEvent(new Cc(yc,a,b,c))}function Ec(a,b){if(!da(a))throw Error("Fn must not be null and must be a function");return k.setTimeout(function(){a()},b)};var Fc={NO_ERROR:0,jb:1,qb:2,pb:3,mb:4,ob:5,rb:6,Ra:7,TIMEOUT:8,ub:9};var Gc={lb:"complete",yb:"success",Sa:"error",Ra:"abort",wb:"ready",xb:"readystatechange",TIMEOUT:"timeout",sb:"incrementaldata",vb:"progress",nb:"downloadprogress",zb:"uploadprogress"};function Hc(){}Hc.prototype.a=null;function Ic(a){var b;(b=a.a)||(b={},Jc(a)&&(b[0]=!0,b[1]=!0),b=a.a=b);return b};var Kc;function Lc(){}u(Lc,Hc);function Mc(a){return(a=Jc(a))?new ActiveXObject(a):new XMLHttpRequest}function Jc(a){if(!a.b&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.b=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.b}Kc=new Lc;function K(a,b,c,d){this.i=a;this.b=b;this.f=c;this.T=d||1;this.N=new C(this);this.S=Nc;a=this.H=new Xb;a.b=Oc;a.K&&a.$?(Yb(a),a.start()):a.K&&Yb(a);this.j=null;this.c=!1;this.m=this.g=this.h=this.J=this.D=this.U=this.w=null;this.s=[];this.a=null;this.F=0;this.l=this.o=null;this.C=-1;this.B=!1;this.P=0;this.I=null;this.M=!1}var Nc=45E3,Oc=250;
	function Pc(a,b){switch(a){case 0:return"Non-200 return code ("+b+")";case 1:return"XMLHTTP failure (no data)";case 2:return"HttpConnection timeout";default:return"Unknown error"}}var Qc={},Rc={};g=K.prototype;g.setTimeout=function(a){this.S=a};function Sc(a,b,c){a.J=1;a.h=Tc(L(b));a.m=c;a.M=!0;Uc(a,null)}function Vc(a,b,c,d){a.J=1;a.h=Tc(L(b));a.m=null;a.M=c;Uc(a,d)}
	function Uc(a,b){a.D=t();Wc(a);a.g=L(a.h);Xc(a.g,"t",a.T);a.F=0;a.a=a.i.da(a.i.ia()?b:null);0<a.P&&(a.I=new $b(r(a.Qa,a,a.a),a.P));a.N.aa(a.a,"readystatechange",a.fb);b=a.j?Ea(a.j):{};a.m?(a.o||(a.o="POST"),b["Content-Type"]="application/x-www-form-urlencoded",a.a.fa(a.g,a.o,a.m,b)):(a.o="GET",a.a.fa(a.g,a.o,null,b));Ac(1);rc(a.b,a.o,a.g,a.f,a.T,a.m)}g.fb=function(a){a=a.target;var b=this.I;b&&3==M(a)?(I(this.b,"Throttling readystatechange."),b.Xa()):this.Qa(a)};
	g.Qa=function(a){try{a==this.a?Yc(this):E(this.b.a,"Called back with an unexpected xmlhttp")}catch(c){if(I(this.b,"Failed call to OnXmlHttpReadyStateChanged_"),this.a&&this.a.V()){var b=this;wc(this.b,c,function(){return"ResponseText: "+b.a.V()})}else wc(this.b,c,"No response text")}finally{}};
	function Yc(a){var b=M(a.a),c=a.a.Fa(),d=a.a.W();if(!(3>b||3==b&&!Ka&&!a.a.V())){a.B||4!=b||7==c||(8==c||0>=d?Ac(3):Ac(2));Zc(a);var e=a.a.W();a.C=e;(c=a.a.V())||I(a.b,function(){return"No response text for uri "+a.g+" status "+e});a.c=200==e;sc(a.b,a.o,a.g,a.f,a.T,b,e);a.c?(a.M?($c(a,b,c),Ka&&a.c&&3==b&&ad(a)):(tc(a.b,a.f,c,null),bd(a,c)),4==b&&cd(a),a.c&&!a.B&&(4==b?a.i.ua(a):(a.c=!1,Wc(a)))):(400==e&&0<c.indexOf("Unknown SID")?(a.l=3,J(12),E(a.b.a,"XMLHTTP Unknown SID ("+a.f+")")):(a.l=0,J(13),
	E(a.b.a,"XMLHTTP Bad status "+e+" ("+a.f+")")),cd(a),dd(a))}}function $c(a,b,c){for(var d=!0;!a.B&&a.F<c.length;){var e=ed(a,c);if(e==Rc){4==b&&(a.l=4,J(14),d=!1);tc(a.b,a.f,null,"[Incomplete Response]");break}else if(e==Qc){a.l=4;J(15);tc(a.b,a.f,c,"[Invalid Chunk]");d=!1;break}else tc(a.b,a.f,e,null),bd(a,e)}4==b&&0==c.length&&(a.l=1,J(16),d=!1);a.c=a.c&&d;d||(tc(a.b,a.f,c,"[Invalid Chunked Response]"),cd(a),dd(a))}
	g.eb=function(){var a=M(this.a),b=this.a.V();this.F<b.length&&(Zc(this),$c(this,a,b),this.c&&4!=a&&Wc(this))};function ad(a){a.N.aa(a.H,"tick",a.eb);a.H.start()}function ed(a,b){var c=a.F,d=b.indexOf("\n",c);if(-1==d)return Rc;c=Number(b.substring(c,d));if(isNaN(c))return Qc;d+=1;if(d+c>b.length)return Rc;b=b.substr(d,c);a.F=d+c;return b}g.cancel=function(){this.B=!0;cd(this)};function Wc(a){a.U=t()+a.S;fd(a,a.S)}
	function fd(a,b){if(null!=a.w)throw Error("WatchDog timer not null");a.w=Ec(r(a.cb,a),b)}function Zc(a){a.w&&(k.clearTimeout(a.w),a.w=null)}g.cb=function(){this.w=null;var a=t();0<=a-this.U?(this.c&&xc(this.b,"Received watchdog timeout even though request loaded successfully"),vc(this.b,this.g),2!=this.J&&(Ac(3),J(17)),cd(this),this.l=2,dd(this)):(E(this.b.a,"WatchDog timer called too early"),fd(this,this.U-a))};function dd(a){a.i.Ja()||a.B||a.i.ua(a)}
	function cd(a){Zc(a);var b=a.I;b&&"function"==typeof b.Z&&b.Z();a.I=null;Yb(a.H);cc(a.N);a.a&&(b=a.a,a.a=null,b.abort(),b.Z())}function bd(a,b){try{a.i.Ma(a,b),Ac(4)}catch(c){wc(a.b,c,"Error in httprequest callback")}};function gd(a){if(a.v&&"function"==typeof a.v)return a.v();if(l(a))return a.split("");if(ca(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}return Ca(a)}
	function hd(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(ca(a)||l(a))ta(a,b,void 0);else{if(a.O&&"function"==typeof a.O)var c=a.O();else if(a.v&&"function"==typeof a.v)c=void 0;else if(ca(a)||l(a)){c=[];for(var d=a.length,e=0;e<d;e++)c.push(e)}else c=Da(a);d=gd(a);e=d.length;for(var f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a)}};function N(a,b){this.b={};this.a=[];this.c=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else if(a){a instanceof N?(c=a.O(),d=a.v()):(c=Da(a),d=Ca(a));for(var e=0;e<c.length;e++)this.set(c[e],d[e])}}g=N.prototype;g.u=function(){return this.c};g.v=function(){id(this);for(var a=[],b=0;b<this.a.length;b++)a.push(this.b[this.a[b]]);return a};g.O=function(){id(this);return this.a.concat()};
	function jd(a){a.b={};a.a.length=0;a.c=0}function kd(a,b){return O(a.b,b)?(delete a.b[b],a.c--,a.a.length>2*a.c&&id(a),!0):!1}function id(a){if(a.c!=a.a.length){for(var b=0,c=0;b<a.a.length;){var d=a.a[b];O(a.b,d)&&(a.a[c++]=d);b++}a.a.length=c}if(a.c!=a.a.length){var e={};for(c=b=0;b<a.a.length;)d=a.a[b],O(e,d)||(a.a[c++]=d,e[d]=1),b++;a.a.length=c}}g.get=function(a,b){return O(this.b,a)?this.b[a]:b};g.set=function(a,b){O(this.b,a)||(this.c++,this.a.push(a));this.b[a]=b};
	g.forEach=function(a,b){for(var c=this.O(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};function O(a,b){return Object.prototype.hasOwnProperty.call(a,b)};var ld=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function md(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1)}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"")}}};function P(a,b){this.b=this.j=this.f="";this.i=null;this.g=this.a="";this.h=!1;var c;a instanceof P?(this.h=void 0!==b?b:a.h,nd(this,a.f),this.j=a.j,od(this,a.b),pd(this,a.i),this.a=a.a,qd(this,rd(a.c)),this.g=a.g):a&&(c=String(a).match(ld))?(this.h=!!b,nd(this,c[1]||"",!0),this.j=sd(c[2]||""),od(this,c[3]||"",!0),pd(this,c[4]),this.a=sd(c[5]||"",!0),qd(this,c[6]||"",!0),this.g=sd(c[7]||"")):(this.h=!!b,this.c=new td(null,this.h))}
	P.prototype.toString=function(){var a=[],b=this.f;b&&a.push(ud(b,vd,!0),":");var c=this.b;if(c||"file"==b)a.push("//"),(b=this.j)&&a.push(ud(b,vd,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.i,null!=c&&a.push(":",String(c));if(c=this.a)this.b&&"/"!=c.charAt(0)&&a.push("/"),a.push(ud(c,"/"==c.charAt(0)?wd:xd,!0));(c=this.c.toString())&&a.push("?",c);(c=this.g)&&a.push("#",ud(c,yd));return a.join("")};
	P.prototype.resolve=function(a){var b=L(this),c=!!a.f;c?nd(b,a.f):c=!!a.j;c?b.j=a.j:c=!!a.b;c?od(b,a.b):c=null!=a.i;var d=a.a;if(c)pd(b,a.i);else if(c=!!a.a){if("/"!=d.charAt(0))if(this.b&&!this.a)d="/"+d;else{var e=b.a.lastIndexOf("/");-1!=e&&(d=b.a.substr(0,e+1)+d)}e=d;if(".."==e||"."==e)d="";else if(-1!=e.indexOf("./")||-1!=e.indexOf("/.")){d=0==e.lastIndexOf("/",0);e=e.split("/");for(var f=[],h=0;h<e.length;){var m=e[h++];"."==m?d&&h==e.length&&f.push(""):".."==m?((1<f.length||1==f.length&&""!=
	f[0])&&f.pop(),d&&h==e.length&&f.push("")):(f.push(m),d=!0)}d=f.join("/")}else d=e}c?b.a=d:c=""!==a.c.toString();c?qd(b,rd(a.c)):c=!!a.g;c&&(b.g=a.g);return b};function L(a){return new P(a)}function nd(a,b,c){a.f=c?sd(b,!0):b;a.f&&(a.f=a.f.replace(/:$/,""))}function od(a,b,c){a.b=c?sd(b,!0):b}function pd(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.i=b}else a.i=null}function qd(a,b,c){b instanceof td?(a.c=b,zd(a.c,a.h)):(c||(b=ud(b,Ad)),a.c=new td(b,a.h))}
	function Q(a,b,c){a.c.set(b,c)}function Xc(a,b,c){n(c)||(c=[String(c)]);Bd(a.c,b,c)}function Tc(a){Q(a,"zx",Math.floor(2147483648*Math.random()).toString(36)+Math.abs(Math.floor(2147483648*Math.random())^t()).toString(36));return a}function Cd(a){return a instanceof P?L(a):new P(a,void 0)}function Dd(a,b,c,d){var e=new P(null,void 0);a&&nd(e,a);b&&od(e,b);c&&pd(e,c);d&&(e.a=d);return e}function sd(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}
	function ud(a,b,c){return l(a)?(a=encodeURI(a).replace(b,Ed),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function Ed(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)}var vd=/[#\/\?@]/g,xd=/[#\?:]/g,wd=/[#\?]/g,Ad=/[#\?@]/g,yd=/#/g;function td(a,b){this.b=this.a=null;this.c=a||null;this.f=!!b}function R(a){a.a||(a.a=new N,a.b=0,a.c&&md(a.c,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))}g=td.prototype;g.u=function(){R(this);return this.b};
	g.add=function(a,b){R(this);this.c=null;a=Fd(this,a);var c=this.a.get(a);c||this.a.set(a,c=[]);c.push(b);this.b+=1;return this};function Gd(a,b){R(a);b=Fd(a,b);O(a.a.b,b)&&(a.c=null,a.b-=a.a.get(b).length,kd(a.a,b))}function Hd(a,b){R(a);b=Fd(a,b);return O(a.a.b,b)}g.forEach=function(a,b){R(this);this.a.forEach(function(c,d){ta(c,function(c){a.call(b,c,d,this)},this)},this)};
	g.O=function(){R(this);for(var a=this.a.v(),b=this.a.O(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};g.v=function(a){R(this);var b=[];if(l(a))Hd(this,a)&&(b=xa(b,this.a.get(Fd(this,a))));else{a=this.a.v();for(var c=0;c<a.length;c++)b=xa(b,a[c])}return b};g.set=function(a,b){R(this);this.c=null;a=Fd(this,a);Hd(this,a)&&(this.b-=this.a.get(a).length);this.a.set(a,[b]);this.b+=1;return this};g.get=function(a,b){a=a?this.v(a):[];return 0<a.length?String(a[0]):b};
	function Bd(a,b,c){Gd(a,b);0<c.length&&(a.c=null,a.a.set(Fd(a,b),ya(c)),a.b+=c.length)}g.toString=function(){if(this.c)return this.c;if(!this.a)return"";for(var a=[],b=this.a.O(),c=0;c<b.length;c++){var d=b[c],e=encodeURIComponent(String(d));d=this.v(d);for(var f=0;f<d.length;f++){var h=e;""!==d[f]&&(h+="="+encodeURIComponent(String(d[f])));a.push(h)}}return this.c=a.join("&")};function rd(a){var b=new td;b.c=a.c;a.a&&(b.a=new N(a.a),b.b=a.b);return b}
	function Fd(a,b){b=String(b);a.f&&(b=b.toLowerCase());return b}function zd(a,b){b&&!a.f&&(R(a),a.c=null,a.a.forEach(function(a,b){var c=b.toLowerCase();b!=c&&(Gd(this,b),Bd(this,c,a))},a));a.f=b};function Id(){this.a=t()}var Jd=null;Id.prototype.set=function(a){this.a=a};Id.prototype.reset=function(){this.set(t())};Id.prototype.get=function(){return this.a};function Kd(){Jd||(Jd=new Id)}function Ld(){Jd||(Jd=new Id)}u(Ld,Kd);function Md(){}var Nd={OPEN:"a",kb:"b",Sa:"c",tb:"d"};function Od(){A.call(this,"d")}u(Od,A);function Pd(){A.call(this,"c")}u(Pd,A);function Qd(a,b){this.a=a;this.b=b;this.c=this.i=null;this.h=!1;this.l=null;this.f=-1;this.m=this.g=null}g=Qd.prototype;g.R=null;
	function Rd(a){I(a.b,"TestConnection: starting stage 2");var b=a.a.H.a;if(null!=b)I(a.b,function(){return true?"Buffered":"Unbuffered"}),J(4),b?(J(10),Sd(a.a,a,!1)):(J(11),Sd(a.a,a,!0));else{a.c=new K(a,a.b,void 0,void 0);a.c.j=a.i;var c=Td(a.a,a.g,a.l);J(4);Xc(c,"TYPE","xmlhttp");var d=a.a.j,e=a.a.J;d&&e&&Q(c,d,e);Vc(a.c,c,!1,a.g)}}g.da=function(a){return this.a.da(a)};g.abort=function(){this.c&&(this.c.cancel(),this.c=null);this.f=-1};
	g.Ja=function(){return!1};
	g.Ma=function(a,b){this.f=a.C;if(0==this.R){I(this.b,"TestConnection: Got data for stage 1");if(!this.a.D&&(a=a.a)){var c=a.a?a.a.getResponseHeader("X-Client-Wire-Protocol"):null;this.m=c?c:null;this.a.j&&((a=a.a?a.a.getResponseHeader("X-HTTP-Session-Id"):null)?this.a.J=a:E(this.b.a,"Missing X_HTTP_SESSION_ID in the handshake response"))}if(b){try{var d=this.a.ma.a.parse(b)}catch(e){wc(this.b,e);Ud(this.a,this);return}this.g=d[0]}else I(this.b,"TestConnection: Null responseText"),Ud(this.a,this)}else if(1==
	this.R)if(this.h)J(6);else if("11111"==b){if(J(5),this.h=!0,!z||10<=Number(Ua))this.f=200,this.c.cancel(),I(this.b,"Test connection succeeded; using streaming connection"),J(11),Sd(this.a,this,!0)}else J(7),this.h=!1};
	g.ua=function(){this.f=this.c.C;this.c.c?0==this.R?(this.R=1,I(this.b,"TestConnection: request complete for initial check"),Rd(this)):1==this.R&&(I(this.b,"TestConnection: request complete for stage 2"),this.h?(I(this.b,"Test connection succeeded; using streaming connection"),J(11),Sd(this.a,this,!0)):(I(this.b,"Test connection failed; not using streaming"),J(10),Sd(this.a,this,!1))):(I(this.b,"TestConnection: request failed, in state "+this.R),0==this.R?J(8):1==this.R&&J(9),Ud(this.a,this))};
	g.ia=function(){return this.a.ia()};g.ra=function(){return this.a.ra()};function Vd(){this.a=this.b=null};function S(){this.a=new N}function Wd(a){var b=typeof a;return"object"==b&&a||"function"==b?"o"+(a[q]||(a[q]=++ea)):b.charAt(0)+a}S.prototype.u=function(){return this.a.u()};S.prototype.add=function(a){this.a.set(Wd(a),a)};S.prototype.contains=function(a){a=Wd(a);return O(this.a.b,a)};S.prototype.v=function(){return this.a.v()};function Xd(a,b){this.a=a;this.b=b};function Yd(a){this.g=a||Zd;this.f=k.pa&&k.pa.Ka&&k.pa.Ka()&&k.pa.Ka().Bb?this.g:1;this.a=null;1<this.f&&(this.a=new S);this.b=null;this.c=[]}var Zd=10;function $d(a,b){a.a||-1==b.indexOf("spdy")&&-1==b.indexOf("quic")&&-1==b.indexOf("h2")||(a.f=a.g,a.a=new S,a.b&&(ae(a,a.b),a.b=null))}function be(a){return a.b?!0:a.a?a.a.u()>=a.f:!1}function ce(a,b){return a.b?a.b==b:a.a?a.a.contains(b):!1}function ae(a,b){a.a?a.a.add(b):a.b=b}
	function de(a,b){a.b&&a.b==b?a.b=null:a.a&&a.a.contains(b)&&kd(a.a.a,Wd(b))}Yd.prototype.cancel=function(){this.c=ee(this);this.b?(this.b.cancel(),this.b=null):this.a&&0!=this.a.a.c&&(ta(this.a.v(),function(a){a.cancel()}),jd(this.a.a))};function ee(a){if(null!=a.b)return a.c.concat(a.b.s);if(null!=a.a&&0!=a.a.a.c){var b=a.c;ta(a.a.v(),function(a){b=b.concat(a.s)});return b}return ya(a.c)}function fe(a,b){a.c=a.c.concat(b)};function ge(){}ge.prototype.stringify=function(a){return k.JSON.stringify(a,void 0)};ge.prototype.parse=function(a){return k.JSON.parse(a,void 0)};function he(){this.a=new ge}function ie(a,b,c){var d=c||"";try{hd(a,function(a,c){var e=a;p(a)&&(e=Db(a));b.push(d+c+"="+encodeURIComponent(e))})}catch(e){throw b.push(d+"type="+encodeURIComponent("_badmap")),e;}};function je(a,b){var c=new qc;I(c,"TestLoadImage: loading "+a);var d=new Image;d.onload=ia(ke,c,d,"TestLoadImage: loaded",!0,b);d.onerror=ia(ke,c,d,"TestLoadImage: error",!1,b);d.onabort=ia(ke,c,d,"TestLoadImage: abort",!1,b);d.ontimeout=ia(ke,c,d,"TestLoadImage: timeout",!1,b);k.setTimeout(function(){if(d.ontimeout)d.ontimeout()},1E4);d.src=a}function ke(a,b,c,d,e){try{I(a,c),b.onload=null,b.onerror=null,b.onabort=null,b.ontimeout=null,e(d)}catch(f){wc(a,f)}};function T(a){B.call(this);this.headers=new N;this.F=a||null;this.f=!1;this.D=this.a=null;this.M=this.s="";this.j=0;this.g="";this.h=this.I=this.o=this.H=!1;this.l=0;this.B=null;this.N=le;this.C=this.m=!1}u(T,B);var le="";T.prototype.b=oc("goog.net.XhrIo");var me=/^https?$/i,ne=["POST","PUT"];g=T.prototype;
	g.fa=function(a,b,c,d){if(this.a)throw Error("[goog.net.XhrIo] Object is active with another request="+this.s+"; newUri="+a);b=b?b.toUpperCase():"GET";this.s=a;this.g="";this.j=0;this.M=b;this.H=!1;this.f=!0;this.a=this.F?Mc(this.F):Mc(Kc);this.D=this.F?Ic(this.F):Ic(Kc);this.a.onreadystatechange=r(this.La,this);try{F(this.b,U(this,"Opening Xhr")),this.I=!0,this.a.open(b,String(a),!0),this.I=!1}catch(f){F(this.b,U(this,"Error opening Xhr: "+f.message));oe(this,f);return}a=c||"";var e=new N(this.headers);
	d&&hd(d,function(a,b){e.set(b,a)});d=ua(e.O());c=k.FormData&&a instanceof k.FormData;!(0<=sa(ne,b))||d||c||e.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");e.forEach(function(a,b){this.a.setRequestHeader(b,a)},this);this.N&&(this.a.responseType=this.N);"withCredentials"in this.a&&this.a.withCredentials!==this.m&&(this.a.withCredentials=this.m);try{pe(this),0<this.l&&(this.C=qe(this.a),F(this.b,U(this,"Will abort after "+this.l+"ms if incomplete, xhr2 "+this.C)),this.C?(this.a.timeout=
	this.l,this.a.ontimeout=r(this.Ia,this)):this.B=Zb(this.Ia,this.l,this)),F(this.b,U(this,"Sending request")),this.o=!0,this.a.send(a),this.o=!1}catch(f){F(this.b,U(this,"Send error: "+f.message)),oe(this,f)}};function qe(a){return z&&Ta(9)&&"number"==typeof a.timeout&&void 0!==a.ontimeout}function va(a){return"content-type"==a.toLowerCase()}
	g.Ia=function(){"undefined"!=typeof goog&&this.a&&(this.g="Timed out after "+this.l+"ms, aborting",this.j=8,F(this.b,U(this,this.g)),this.dispatchEvent("timeout"),this.abort(8))};function oe(a,b){a.f=!1;a.a&&(a.h=!0,a.a.abort(),a.h=!1);a.g=b;a.j=5;re(a);se(a)}function re(a){a.H||(a.H=!0,a.dispatchEvent("complete"),a.dispatchEvent("error"))}
	g.abort=function(a){this.a&&this.f&&(F(this.b,U(this,"Aborting")),this.f=!1,this.h=!0,this.a.abort(),this.h=!1,this.j=a||7,this.dispatchEvent("complete"),this.dispatchEvent("abort"),se(this))};g.A=function(){this.a&&(this.f&&(this.f=!1,this.h=!0,this.a.abort(),this.h=!1),se(this,!0));T.L.A.call(this)};g.La=function(){this.i||(this.I||this.o||this.h?te(this):this.ab())};g.ab=function(){te(this)};
	function te(a){if(a.f&&"undefined"!=typeof goog)if(a.D[1]&&4==M(a)&&2==a.W())F(a.b,U(a,"Local request error detected and ignored"));else if(a.o&&4==M(a))Zb(a.La,0,a);else if(a.dispatchEvent("readystatechange"),4==M(a)){F(a.b,U(a,"Request complete"));a.f=!1;try{var b=a.W();a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var c=!0;break a;default:c=!1}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.s).match(ld)[1]||null;if(!f&&k.self&&k.self.location){var h=k.self.location.protocol;
	f=h.substr(0,h.length-1)}e=!me.test(f?f.toLowerCase():"")}d=e}d?(a.dispatchEvent("complete"),a.dispatchEvent("success")):(a.j=6,a.g=a.Ga()+" ["+a.W()+"]",re(a))}finally{se(a)}}}function se(a,b){if(a.a){pe(a);var c=a.a,d=a.D[0]?aa:null;a.a=null;a.D=null;b||a.dispatchEvent("ready");try{c.onreadystatechange=d}catch(e){(a=a.b)&&a.log(gc,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}}function pe(a){a.a&&a.C&&(a.a.ontimeout=null);a.B&&(k.clearTimeout(a.B),a.B=null)}
	function M(a){return a.a?a.a.readyState:0}g.W=function(){try{return 2<M(this)?this.a.status:-1}catch(a){return-1}};g.Ga=function(){try{return 2<M(this)?this.a.statusText:""}catch(a){return F(this.b,"Can not get status: "+a.message),""}};g.V=function(){try{return this.a?this.a.responseText:""}catch(a){return F(this.b,"Can not get responseText: "+a.message),""}};
	g.Ya=function(a){if(this.a){var b=this.a.responseText;a&&0==b.indexOf(a)&&(b=b.substring(a.length));a:{a=b;if(k.JSON)try{var c=k.JSON.parse(a);break a}catch(d){}c=Cb(a)}return c}};g.Fa=function(){return this.j};g.Za=function(){return l(this.g)?this.g:String(this.g)};function U(a,b){return b+" ["+a.M+" "+a.s+" "+a.W()+"]"};function ue(a){var b="";Ba(a,function(a,d){b+=d;b+=":";b+=a;b+="\r\n"});return b}function ve(a,b,c){a:{for(d in c){var d=!1;break a}d=!0}if(d)return a;c=ue(c);if(l(a)){b=encodeURIComponent(String(b));c=null!=c?"="+encodeURIComponent(String(c)):"";if(b+=c){c=a.indexOf("#");0>c&&(c=a.length);d=a.indexOf("?");if(0>d||d>c){d=c;var e=""}else e=a.substring(d+1,c);a=[a.substr(0,d),e,a.substr(c)];c=a[1];a[1]=b?c?c+"&"+b:b:c;a=a[0]+(a[1]?"?"+a[1]:"")+a[2]}return a}Q(a,b,c);return a};function we(a){this.ya=0;this.g=[];this.a=new qc;this.H=new Vd;this.ja=this.wa=this.F=this.ka=this.b=this.J=this.j=this.U=this.h=this.M=this.i=null;this.Ua=this.P=0;this.la=this.B=this.o=this.m=this.l=this.f=null;this.s=this.xa=this.N=-1;this.T=this.w=this.C=0;this.S=a&&a.supportsCrossDomainXhr||!1;this.I="";this.c=new Yd(a&&a.concurrentRequestLimit);this.ma=new he;this.D=a&&void 0!==a.backgroundChannelTest?a.backgroundChannelTest:!0;this.Ta=a&&a.fastHandshake||!1;a&&a.Ea&&this.a.Ea()}g=we.prototype;
	g.oa=8;g.G=1;function xe(a){I(a.a,"disconnect()");ye(a);if(3==a.G){var b=a.P++,c=L(a.F);Q(c,"SID",a.I);Q(c,"RID",b);Q(c,"TYPE","terminate");ze(a,c);b=new K(a,a.a,b,void 0);b.J=2;b.h=Tc(L(c));c=!1;k.navigator&&k.navigator.sendBeacon&&(c=k.navigator.sendBeacon(b.h.toString(),""));!c&&k.Image&&((new Image).src=b.h,c=!0);c||(b.a=b.i.da(null),b.a.fa(b.h));b.D=t();Wc(b)}Ae(a)}
	function ye(a){a.B&&(a.B.abort(),a.B=null);a.b&&(a.b.cancel(),a.b=null);a.m&&(k.clearTimeout(a.m),a.m=null);Be(a);a.c.cancel();a.l&&(k.clearTimeout(a.l),a.l=null)}function Ce(a,b){1E3==a.g.length&&xc(a.a,function(){return"Already have 1000 queued maps upon queueing "+Db(b)});a.g.push(new Xd(a.Ua++,b));3==a.G&&De(a)}g.Ja=function(){return 0==this.G};function De(a){be(a.c)||a.l||(a.l=Ec(r(a.Oa,a),0),a.C=0)}
	function Ee(a,b){var c=a.c;if((c.b?1:c.a?c.a.u():0)>=a.c.f-(a.l?1:0))return xc(a.a,"Unexpected retry request is scheduled."),!1;if(a.l)return I(a.a,"Use the retry request that is already scheduled."),a.g=b.s.concat(a.g),!0;if(1==a.G||2==a.G||2<=a.C)return!1;I(a.a,"Going to retry POST");a.l=Ec(r(a.Oa,a,b),Fe(a,a.C));a.C++;return!0}
	g.Oa=function(a){this.l=null;I(this.a,"startForwardChannel_");if(1==this.G)if(a)xc(this.a,"Not supposed to retry the open");else{I(this.a,"open_()");this.P=Math.floor(1E5*Math.random());a=this.P++;var b=new K(this,this.a,a,void 0),c=this.i;this.M&&(c?(c=Ea(c),Ga(c,this.M)):c=this.M);null===this.h&&(b.j=c);var d=Ge(this,b),e=L(this.F);Q(e,"RID",a);Q(e,"CVER",21);this.D&&this.j&&Q(e,"X-HTTP-Session-Id",this.j);ze(this,e);this.h&&c&&ve(e,this.h,c);ae(this.c,b);this.Ta?(Q(e,"$req",d),Sc(b,e,null)):Sc(b,
	e,d);this.G=2}else 3==this.G&&(a?He(this,a):0==this.g.length?I(this.a,"startForwardChannel_ returned: nothing to send"):be(this.c)?xc(this.a,"startForwardChannel_ returned: connection already in progress"):(He(this),I(this.a,"startForwardChannel_ finished, sent request")))};
	function He(a,b){var c;b?c=b.f:c=a.P++;var d=L(a.F);Q(d,"SID",a.I);Q(d,"RID",c);Q(d,"AID",a.N);ze(a,d);a.h&&a.i&&ve(d,a.h,a.i);c=new K(a,a.a,c,a.C+1);null===a.h&&(c.j=a.i);b&&(a.g=b.s.concat(a.g));b=Ge(a,c);c.setTimeout(Math.round(1E4)+Math.round(1E4*Math.random()));ae(a.c,c);Sc(c,d,b)}function ze(a,b){a.f&&hd({},function(a,d){Q(b,d,a)})}
	function Ge(a,b){var c=Math.min(a.g.length,1E3),d=a.f?r(a.f.Va,a.f,a):null;a:for(var e=a.g,f=-1;;){var h=["count="+c];-1==f?0<c?(f=e[0].a,h.push("ofs="+f)):f=0:h.push("ofs="+f);for(var m=!0,v=0;v<c;v++){var G=e[v].a,Z=e[v].b;G-=f;if(0>G)f=Math.max(0,e[v].a-100),m=!1;else try{ie(Z,h,"req"+G+"_")}catch(Mb){d&&d(Z)}}if(m){d=h.join("&");break a}}a=a.g.splice(0,c);b.s=a;return d}function Ie(a){if(!a.b&&!a.m){a.T=1;var b=a.Na;Tb||Ub();Wb||(Tb(),Wb=!0);Pb.add(b,a);a.w=0}}
	function Je(a){if(a.b||a.m)return xc(a.a,"Request already in progress"),!1;if(3<=a.w)return!1;I(a.a,"Going to retry GET");a.T++;a.m=Ec(r(a.Na,a),Fe(a,a.w));a.w++;return!0}
	g.Na=function(){this.m=null;I(this.a,"Creating new HttpRequest");this.b=new K(this,this.a,"rpc",this.T);null===this.h&&(this.b.j=this.i);this.b.P=0;var a=L(this.wa);Q(a,"RID","rpc");Q(a,"SID",this.I);Q(a,"CI",this.la?"0":"1");Q(a,"AID",this.N);ze(this,a);Q(a,"TYPE","xmlhttp");this.h&&this.i&&ve(a,this.h,this.i);Vc(this.b,a,!0,this.ja);I(this.a,"New Request created")};
	function Sd(a,b,c){I(a.a,"Test Connection Finished");var d=b.m;d&&$d(a.c,d);a.la=c;a.s=b.f;I(a.a,"connectChannel_()");a.F=Ke(a,a.ka);De(a)}function Ud(a,b){I(a.a,"Test Connection Failed");a.s=b.f;V(a,2)}
	g.Ma=function(a,b){if(0!=this.G&&(this.b==a||ce(this.c,a)))if(this.s=a.C,ce(this.c,a)&&3==this.G){try{var c=this.ma.a.parse(b)}catch(f){c=null}if(n(c)&&3==c.length)if(b=c,0==b[0])a:if(I(this.a,"Server claims our backchannel is missing."),this.m)I(this.a,"But we are currently starting the request.");else{if(this.b)if(this.b.D+3E3<a.D)Be(this),this.b.cancel(),this.b=null;else break a;else E(this.a.a,"We do not have a BackChannel established");Je(this);J(18)}else this.xa=b[1],a=this.xa-this.N,0<a&&(b=
	b[2],I(this.a,b+" bytes (in "+a+" arrays) are outstanding on the BackChannel"),37500>b&&this.la&&0==this.w&&!this.o&&(this.o=Ec(r(this.$a,this),6E3)));else I(this.a,"Bad POST response data returned"),V(this,11)}else if(this.b==a&&Be(this),!/^[\s\xa0]*$/.test(b))for(b=c=this.ma.a.parse(b),c=0;c<b.length;c++){var d=b[c];this.N=d[0];d=d[1];if(2==this.G)if("c"==d[0]){this.I=d[1];this.ja=d[2];var e=d[3];null!=e&&(this.oa=e,H(this.a,"VER="+this.oa));d=d[4];null!=d&&(this.ya=d,H(this.a,"SVER="+this.ya));
	this.D&&(d=a.a)&&((e=d.a?d.a.getResponseHeader("X-Client-Wire-Protocol"):null)&&$d(this.c,e),this.j&&((d=d.a?d.a.getResponseHeader("X-HTTP-Session-Id"):null)?(this.J=d,Q(this.F,this.j,d)):E(this.a.a,"Missing X_HTTP_SESSION_ID in the handshake response")));this.G=3;this.f&&this.f.Da();this.wa=Td(this,this.ja,this.ka);Ie(this)}else"stop"!=d[0]&&"close"!=d[0]||V(this,7);else 3==this.G&&("stop"==d[0]||"close"==d[0]?"stop"==d[0]?V(this,7):xe(this):"noop"!=d[0]&&this.f&&this.f.Ca(d),this.w=0)}};
	g.$a=function(){null!=this.o&&(this.o=null,this.b.cancel(),this.b=null,Je(this),J(19))};function Be(a){null!=a.o&&(k.clearTimeout(a.o),a.o=null)}
	g.ua=function(a){I(this.a,"Request complete");var b=null;if(this.b==a){Be(this);this.b=null;var c=2}else if(ce(this.c,a))b=a.s,de(this.c,a),c=1;else return;this.s=a.C;if(0!=this.G)if(a.c)1==c?(Dc(a.m?a.m.length:0,t()-a.D,this.C),De(this)):Ie(this);else{var d=a.l;if(3==d||0==d&&0<this.s)I(this.a,"Not retrying due to error type");else{var e=this;I(this.a,function(){return"Maybe retrying, last error: "+Pc(d,e.s)});if(1==c&&Ee(this,a)||2==c&&Je(this))return;I(this.a,"Exceeded max number of retries")}b&&
	0<b.length&&fe(this.c,b);I(this.a,"Error: HTTP request failed");switch(d){case 1:V(this,5);break;case 4:V(this,10);break;case 3:V(this,6);break;default:V(this,2)}}};function Fe(a,b){var c=5E3+Math.floor(1E4*Math.random());a.ra()||(I(a.a,"Inactive channel"),c*=2);return c*b}
	function V(a,b){H(a.a,"Error code "+b);if(2==b){var c=null;a.f&&(c=null);var d=r(a.hb,a);c||(c=new P("//www.google.com/images/cleardot.gif"),k.location&&"http"==k.location.protocol||nd(c,"https"),Tc(c));je(c.toString(),d)}else J(2);I(a.a,"HttpChannel: error - "+b);a.G=0;a.f&&a.f.Ba(b);Ae(a);ye(a)}g.hb=function(a){a?(H(this.a,"Successfully pinged google.com"),J(2)):(H(this.a,"Failed to ping google.com"),J(1))};
	function Ae(a){a.G=0;a.s=-1;if(a.f){var b=ee(a.c);if(0!=b.length||0!=a.g.length)I(a.a,function(){return"Number of undelivered maps, pending: "+b.length+", outgoing: "+a.g.length}),a.c.c.length=0,ya(a.g),a.g.length=0;a.f.Aa()}}function Ke(a,b){b=Le(a,null,b);I(a.a,"GetForwardChannelUri: "+b);return b}function Td(a,b,c){b=Le(a,a.ia()?b:null,c);I(a.a,"GetBackChannelUri: "+b);return b}
	function Le(a,b,c){var d=Cd(c);if(""!=d.b)b&&od(d,b+"."+d.b),pd(d,d.i);else{var e=k.location,f;b?f=b+"."+e.hostname:f=e.hostname;d=Dd(e.protocol,f,e.port,c)}a.U&&Ba(a.U,function(a,b){Q(d,b,a)});b=a.j;c=a.J;b&&c&&Q(d,b,c);Q(d,"VER",a.oa);ze(a,d);return d}g.da=function(a){if(a&&!this.S)throw Error("Can't create secondary domain capable XhrIo object.");a=new T;a.m=this.S;return a};g.ra=function(){return!!this.f&&!0};g.ia=function(){return this.S};new Ld;function Me(){}g=Me.prototype;g.Da=function(){};
	g.Ca=function(){};g.Ba=function(){};g.Aa=function(){};g.Va=function(){};function Ne(a){for(var b=arguments[0],c=1;c<arguments.length;c++){var d=arguments[c];if(0==d.lastIndexOf("/",0))b=d;else{var e;(e=""==b)||(e=b.length-1,e=0<=e&&b.indexOf("/",e)==e);e?b+=d:b+="/"+d}}return b};function Oe(){if(z&&!(10<=Number(Ua)))throw Error("Environmental error: no available transport.");}Oe.prototype.a=function(a,b){return new W(a,b)};
	function W(a,b){B.call(this);this.a=new we(b);this.b=a;this.s=b&&b.testUrl?b.testUrl:Ne(this.b,"test");this.f=oc("goog.labs.net.webChannel.WebChannelBaseTransport");this.g=b&&b.messageUrlParams||null;a=b&&b.messageHeaders||null;b&&b.clientProtocolHeaderRequired&&(a?a["X-Client-Protocol"]="webchannel":a={"X-Client-Protocol":"webchannel"});this.a.i=a;a=b&&b.initMessageHeaders||null;b&&b.messageContentType&&(a?a["X-WebChannel-Content-Type"]=b.messageContentType:a={"X-WebChannel-Content-Type":b.messageContentType});
	this.a.M=a;(a=b&&b.httpHeadersOverwriteParam)&&!/^[\s\xa0]*$/.test(a)&&(this.a.h=a);this.o=b&&b.supportsCrossDomainXhr||!1;this.m=b&&b.sendRawJson||!1;(b=b&&b.httpSessionIdParam)&&!/^[\s\xa0]*$/.test(b)&&(this.a.j=b,a=this.g,null!==a&&b in a&&(a=this.g,b in a&&delete a[b],E(this.f,"Ignore httpSessionIdParam also specified with messageUrlParams: "+b)));this.h=new Pe(this)}u(W,B);
	W.prototype.j=function(){this.a.f=this.h;this.o&&(this.a.S=!0);var a=this.a,b=this.s,c=this.b,d=this.g||void 0;I(a.a,"connect()");J(0);a.ka=c;a.U=d||{};a.D&&(I(a.a,"connect() bypassed channel-test."),a.H.b=[],a.H.a=!1);I(a.a,"connectTest_()");a.B=new Qd(a,a.a);null===a.h&&(a.B.i=a.i);c=b;a.h&&a.i&&(c=ve(b,a.h,a.i));a=a.B;a.l=c;b=Ke(a.a,a.l);J(3);c=a.a.H.b;null!=c?(a.g=c[0],a.R=1,Rd(a)):(Xc(b,"MODE","init"),!a.a.D&&a.a.j&&Xc(b,"X-HTTP-Session-Id",a.a.j),a.c=new K(a,a.b,void 0,void 0),a.c.j=a.i,Vc(a.c,
	b,!1,null),a.R=0)};W.prototype.close=function(){xe(this.a)};W.prototype.l=function(a){if(l(a)){var b={};b.__data__=a;Ce(this.a,b)}else this.m?(b={},b.__data__=Db(a),Ce(this.a,b)):Ce(this.a,a)};W.prototype.A=function(){this.a.f=null;delete this.h;xe(this.a);delete this.a;W.L.A.call(this)};function Qe(a){Od.call(this);var b=a.__sm__;if(b){a:{for(var c in b){a=c;break a}a=void 0}(this.c=a)?(a=this.c,this.data=null!==b&&a in b?b[a]:void 0):this.data=b}else this.data=a}u(Qe,Od);
	function Re(){Pd.call(this);this.status=1}u(Re,Pd);function Pe(a){this.a=a}u(Pe,Me);Pe.prototype.Da=function(){pc(this.a.f,"WebChannel opened on "+this.a.b);this.a.dispatchEvent("a")};Pe.prototype.Ca=function(a){this.a.dispatchEvent(new Qe(a))};Pe.prototype.Ba=function(a){pc(this.a.f,"WebChannel aborted on "+this.a.b+" due to channel error: "+a);this.a.dispatchEvent(new Re(a))};Pe.prototype.Aa=function(){pc(this.a.f,"WebChannel closed on "+this.a.b);this.a.dispatchEvent("b")};var Se=ia(function(a,b){function c(){}c.prototype=a.prototype;var d=new c;a.apply(d,Array.prototype.slice.call(arguments,1));return d},Oe);function Te(){this.b=[];this.a=[]}function Ue(a){0==a.b.length&&(a.b=a.a,a.b.reverse(),a.a=[]);return a.b.pop()}Te.prototype.u=function(){return this.b.length+this.a.length};Te.prototype.contains=function(a){return 0<=sa(this.b,a)||0<=sa(this.a,a)};Te.prototype.v=function(){for(var a=[],b=this.b.length-1;0<=b;--b)a.push(this.b[b]);var c=this.a.length;for(b=0;b<c;++b)a.push(this.a[b]);return a};function Ve(a,b){w.call(this);this.h=a||0;this.c=b||10;if(this.h>this.c)throw Error(We);this.a=new Te;this.b=new S;this.g=null;this.ba()}u(Ve,w);var We="[goog.structs.Pool] Min can not be greater than max";g=Ve.prototype;g.ea=function(){var a=t();if(!(null!=this.g&&0>a-this.g)){for(var b;0<this.a.u()&&(b=Ue(this.a),!this.ta(b));)this.ba();!b&&this.u()<this.c&&(b=this.qa());b&&(this.g=a,this.b.add(b));return b}};g.gb=function(a){return kd(this.b.a,Wd(a))?(this.na(a),!0):!1};
	g.na=function(a){kd(this.b.a,Wd(a));this.ta(a)&&this.u()<this.c?this.a.a.push(a):Xe(a)};g.ba=function(){for(var a=this.a;this.u()<this.h;){var b=this.qa();a.a.push(b)}for(;this.u()>this.c&&0<this.a.u();)Xe(Ue(a))};g.qa=function(){return{}};function Xe(a){if("function"==typeof a.Z)a.Z();else for(var b in a)a[b]=null}g.ta=function(a){return"function"==typeof a.Wa?a.Wa():!0};g.contains=function(a){return this.a.contains(a)||this.b.contains(a)};g.u=function(){return this.a.u()+this.b.u()};
	g.A=function(){Ve.L.A.call(this);if(0<this.b.u())throw Error("[goog.structs.Pool] Objects not released");delete this.b;for(var a=this.a;0!=a.b.length||0!=a.a.length;)Xe(Ue(a));delete this.a};function Ye(a,b){this.a=a;this.b=b};function Ze(a){this.a=[];if(a)a:{if(a instanceof Ze){var b=a.O();a=a.v();if(0>=this.u()){for(var c=this.a,d=0;d<b.length;d++)c.push(new Ye(b[d],a[d]));break a}}else b=Da(a),a=Ca(a);for(d=0;d<b.length;d++)$e(this,b[d],a[d])}}function $e(a,b,c){var d=a.a;d.push(new Ye(b,c));b=d.length-1;a=a.a;for(c=a[b];0<b;)if(d=b-1>>1,a[d].a>c.a)a[b]=a[d],b=d;else break;a[b]=c}Ze.prototype.v=function(){for(var a=this.a,b=[],c=a.length,d=0;d<c;d++)b.push(a[d].b);return b};
	Ze.prototype.O=function(){for(var a=this.a,b=[],c=a.length,d=0;d<c;d++)b.push(a[d].a);return b};Ze.prototype.u=function(){return this.a.length};function af(){Ze.call(this)}u(af,Ze);function X(a,b){this.f=new af;Ve.call(this,a,b)}u(X,Ve);g=X.prototype;g.ea=function(a,b){if(!a)return X.L.ea.call(this);$e(this.f,void 0!==b?b:100,a);this.sa()};g.sa=function(){for(var a=this.f;0<a.u();){var b=this.ea();if(b){var c=a,d=c.a,e=d.length;var f=d[0];if(0>=e)f=void 0;else{if(1==e)wa(d);else{d[0]=d.pop();d=0;c=c.a;e=c.length;for(var h=c[d];d<e>>1;){var m=2*d+1,v=2*d+2;m=v<e&&c[v].a<c[m].a?v:m;if(c[m].a>h.a)break;c[d]=c[m];d=m}c[d]=h}f=f.b}f.apply(this,[b])}else break}};
	g.na=function(a){X.L.na.call(this,a);this.sa()};g.ba=function(){X.L.ba.call(this);this.sa()};g.A=function(){X.L.A.call(this);k.clearTimeout(void 0);wa(this.f.a);this.f=null};function Y(a,b,c,d){this.l=a;this.j=!!d;X.call(this,b,c)}u(Y,X);Y.prototype.qa=function(){var a=new T,b=this.l;b&&b.forEach(function(b,d){a.headers.set(d,b)});this.j&&(a.m=!0);return a};Y.prototype.ta=function(a){return!a.i&&!a.a};Oe.prototype.createWebChannel=Oe.prototype.a;W.prototype.send=W.prototype.l;W.prototype.open=W.prototype.j;W.prototype.close=W.prototype.close;Fc.NO_ERROR=0;Fc.TIMEOUT=8;Fc.HTTP_ERROR=6;Gc.COMPLETE="complete";Md.EventType=Nd;Nd.OPEN="a";Nd.CLOSE="b";Nd.ERROR="c";Nd.MESSAGE="d";B.prototype.listen=B.prototype.aa;Y.prototype.getObject=Y.prototype.ea;Y.prototype.releaseObject=Y.prototype.gb;T.prototype.listenOnce=T.prototype.Ha;T.prototype.getLastError=T.prototype.Za;T.prototype.getLastErrorCode=T.prototype.Fa;
	T.prototype.getStatus=T.prototype.W;T.prototype.getStatusText=T.prototype.Ga;T.prototype.getResponseJson=T.prototype.Ya;T.prototype.getResponseText=T.prototype.V;T.prototype.getResponseText=T.prototype.V;T.prototype.send=T.prototype.fa;module.exports={createWebChannelTransport:Se,ErrorCode:Fc,EventType:Gc,WebChannel:Md,XhrIoPool:Y};}).call(typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {})
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	*  filename: ej2-calendars.umd.min.js
	*  version : 19.4.56
	*  Copyright Syncfusion Inc. 2001 - 2020. All rights reserved.
	*  Use of this code is subject to the terms of our license.
	*  A copy of the current license can be obtained at any time by e-mailing
	*  licensing@syncfusion.com. Any infringement will be prosecuted under
	*  applicable laws. 
	*/
	!function(e,t){ true?t(exports,__webpack_require__(23),__webpack_require__(46),__webpack_require__(59),__webpack_require__(42),__webpack_require__(101)):"function"==typeof define&&define.amd?define(["exports","@syncfusion/ej2-base","@syncfusion/ej2-popups","@syncfusion/ej2-inputs","@syncfusion/ej2-buttons","@syncfusion/ej2-lists"],t):t(e.ej={},e.ej2Base,e.ej2Popups,e.ej2Inputs,e.ej2Buttons,e.ej2Lists)}(this,function(e,t,i,s,a,n){"use strict";var r=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),l=function(e,t,i,s){var a,n=arguments.length,r=n<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(e,t,i,s);else for(var l=e.length-1;l>=0;l--)(a=e[l])&&(r=(n<3?a(r):n>3?a(t,i,r):a(t,i))||r);return n>3&&r&&Object.defineProperty(t,i,r),r},o="e-other-month",h="e-other-year",u="e-calendar",d="e-year",p="e-month",c="e-disabled",m="e-overlay",v="e-week-number",f="e-selected",y="e-focused-date",g="e-month-hide",b="e-zoomin",D="e-calendar-day-header-lg",E=function(e){function i(t,i){var s=e.call(this,t,i)||this;return s.effect="",s.isPopupClicked=!1,s.isDateSelected=!0,s.isTodayClicked=!1,s.preventChange=!1,s.isAngular=!1,s}return r(i,e),i.prototype.render=function(){this.rangeValidation(this.min,this.max),this.calendarEleCopy=this.element.cloneNode(!0),"Islamic"===this.calendarMode&&(+this.min.setSeconds(0)==+new Date(1900,0,1,0,0,0)&&(this.min=new Date(1944,2,18)),+this.max==+new Date(2099,11,31)&&(this.max=new Date(2069,10,16))),this.globalize=new t.Internationalization(this.locale),(t.isNullOrUndefined(this.firstDayOfWeek)||this.firstDayOfWeek>6||this.firstDayOfWeek<0)&&this.setProperties({firstDayOfWeek:this.globalize.getFirstDayOfWeek()},!0),this.todayDisabled=!1,this.todayDate=new Date((new Date).setHours(0,0,0,0)),"calendar"===this.getModuleName()?(this.element.classList.add(u),this.enableRtl&&this.element.classList.add("e-rtl"),t.Browser.isDevice&&this.element.classList.add("e-device"),t.attributes(this.element,{"data-role":"calendar"}),this.tabIndex=this.element.hasAttribute("tabindex")?this.element.getAttribute("tabindex"):"0",this.element.setAttribute("tabindex",this.tabIndex)):(this.calendarElement=this.createElement("div"),this.calendarElement.classList.add(u),this.enableRtl&&this.calendarElement.classList.add("e-rtl"),t.Browser.isDevice&&this.calendarElement.classList.add("e-device"),t.attributes(this.calendarElement,{role:"calendar"})),this.createHeader(),this.createContent(),this.wireEvents()},i.prototype.rangeValidation=function(e,i){t.isNullOrUndefined(e)&&this.setProperties({min:new Date(1900,0,1)},!0),t.isNullOrUndefined(i)&&this.setProperties({max:new Date(2099,11,31)},!0)},i.prototype.getDefaultKeyConfig=function(){return this.defaultKeyConfigs={controlUp:"ctrl+38",controlDown:"ctrl+40",moveDown:"downarrow",moveUp:"uparrow",moveLeft:"leftarrow",moveRight:"rightarrow",select:"enter",home:"home",end:"end",pageUp:"pageup",pageDown:"pagedown",shiftPageUp:"shift+pageup",shiftPageDown:"shift+pagedown",controlHome:"ctrl+home",controlEnd:"ctrl+end",altUpArrow:"alt+uparrow",spacebar:"space",altRightArrow:"alt+rightarrow",altLeftArrow:"alt+leftarrow"},this.defaultKeyConfigs},i.prototype.validateDate=function(e){this.setProperties({min:this.checkDateValue(new Date(this.checkValue(this.min)))},!0),this.setProperties({max:this.checkDateValue(new Date(this.checkValue(this.max)))},!0),this.currentDate=this.currentDate?this.currentDate:new Date((new Date).setHours(0,0,0,0)),!t.isNullOrUndefined(e)&&this.min<=this.max&&e>=this.min&&e<=this.max&&(this.currentDate=new Date(this.checkValue(e)))},i.prototype.setOverlayIndex=function(e,i,s,a){if(a&&!t.isNullOrUndefined(i)&&!t.isNullOrUndefined(s)&&!t.isNullOrUndefined(e)){var n=parseInt(i.style.zIndex,10)?parseInt(i.style.zIndex,10):1e3;s.style.zIndex=(n-1).toString(),e.style.zIndex=n.toString()}},i.prototype.minMaxUpdate=function(e){+this.min<=+this.max?t.removeClass([this.element],m):(this.setProperties({min:this.min},!0),t.addClass([this.element],m)),this.min=t.isNullOrUndefined(this.min)||!+this.min?this.min=new Date(1900,0,1):this.min,this.max=t.isNullOrUndefined(this.max)||!+this.max?this.max=new Date(2099,11,31):this.max,+this.min<=+this.max&&e&&+e<=+this.max&&+e>=+this.min?this.currentDate=new Date(this.checkValue(e)):+this.min<=+this.max&&!e&&+this.currentDate>+this.max?this.currentDate=new Date(this.checkValue(this.max)):+this.currentDate<+this.min&&(this.currentDate=new Date(this.checkValue(this.min)))},i.prototype.createHeader=function(){this.headerElement=this.createElement("div",{className:"e-header"});var e=this.createElement("div",{className:"e-icon-container"});this.previousIcon=this.createElement("button",{className:"e-prev",attrs:{type:"button"}}),t.rippleEffect(this.previousIcon,{duration:400,selector:".e-prev",isCenterRipple:!0}),t.attributes(this.previousIcon,{"aria-disabled":"false","aria-label":"previous month"}),this.nextIcon=this.createElement("button",{className:"e-next",attrs:{type:"button"}}),t.rippleEffect(this.nextIcon,{selector:".e-next",duration:400,isCenterRipple:!0}),t.attributes(this.nextIcon,{"aria-disabled":"false","aria-label":"next month"}),this.headerTitleElement=this.createElement("div",{className:"e-day e-title"}),t.attributes(this.headerTitleElement,{"aria-atomic":"true","aria-live":"assertive","aria-label":"title"}),this.headerElement.appendChild(this.headerTitleElement),this.previousIcon.appendChild(this.createElement("span",{className:"e-date-icon-prev e-icons"})),this.nextIcon.appendChild(this.createElement("span",{className:"e-date-icon-next  e-icons"})),e.appendChild(this.previousIcon),e.appendChild(this.nextIcon),this.headerElement.appendChild(e),"calendar"===this.getModuleName()?this.element.appendChild(this.headerElement):this.calendarElement.appendChild(this.headerElement),this.adjustLongHeaderSize()},i.prototype.createContent=function(){this.contentElement=this.createElement("div",{className:"e-content"}),this.table=this.createElement("table",{attrs:{tabIndex:"0",role:"grid","aria-activedescendant":""}}),"calendar"===this.getModuleName()?this.element.appendChild(this.contentElement):this.calendarElement.appendChild(this.contentElement),this.contentElement.appendChild(this.table),this.createContentHeader(),this.createContentBody(),this.showTodayButton&&this.createContentFooter()},i.prototype.getCultureValues=function(){var e,i=[],s="days.stand-alone."+this.dayHeaderFormat.toLowerCase();e="en"===this.locale||"en-US"===this.locale?t.getValue(s,t.getDefaultDateObject()):this.getCultureObjects(t.cldrData,""+this.locale);for(var a=0,n=Object.keys(e);a<n.length;a++){var r=n[a];i.push(t.getValue(r,e))}return i},i.prototype.toCapitalize=function(e){return!t.isNullOrUndefined(e)&&e.length?e[0].toUpperCase()+e.slice(1):e},i.prototype.createContentHeader=function(){"calendar"===this.getModuleName()?t.isNullOrUndefined(this.element.querySelectorAll(".e-content .e-week-header")[0])||t.detach(this.element.querySelectorAll(".e-content .e-week-header")[0]):t.isNullOrUndefined(this.calendarElement.querySelectorAll(".e-content .e-week-header")[0])||t.detach(this.calendarElement.querySelectorAll(".e-content .e-week-header")[0]);var e="";(this.firstDayOfWeek>6||this.firstDayOfWeek<0)&&this.setProperties({firstDayOfWeek:0},!0),this.tableHeadElement=this.createElement("thead",{className:"e-week-header"}),this.weekNumber&&(e+='<th class="e-week-number"></th>',"calendar"===this.getModuleName()?t.addClass([this.element],""+v):t.addClass([this.calendarElement],""+v));for(var i=this.shiftArray(this.getCultureValues().length>0&&this.getCultureValues(),this.firstDayOfWeek),s=0;s<=6;s++)e+='<th  class="">'+this.toCapitalize(i[s])+"</th>";e="<tr>"+e+"</tr>",this.tableHeadElement.innerHTML=e,this.table.appendChild(this.tableHeadElement)},i.prototype.createContentBody=function(){switch("calendar"===this.getModuleName()?t.isNullOrUndefined(this.element.querySelectorAll(".e-content tbody")[0])||t.detach(this.element.querySelectorAll(".e-content tbody")[0]):t.isNullOrUndefined(this.calendarElement.querySelectorAll(".e-content tbody")[0])||t.detach(this.calendarElement.querySelectorAll(".e-content tbody")[0]),this.start){case"Year":this.renderYears();break;case"Decade":this.renderDecades();break;default:this.renderMonths()}},i.prototype.updateFooter=function(){this.todayElement.textContent=this.l10.getConstant("today"),this.todayElement.setAttribute("aria-label",this.l10.getConstant("today"))},i.prototype.createContentFooter=function(){if(this.showTodayButton){var e=new Date(+this.min),i=new Date(+this.max);this.globalize=new t.Internationalization(this.locale),this.l10=new t.L10n(this.getModuleName(),{today:"Today"},this.locale),this.todayElement=this.createElement("button",{attrs:{role:"button"}}),t.rippleEffect(this.todayElement),this.updateFooter(),t.addClass([this.todayElement],["e-btn","e-today","e-flat","e-primary","e-css"]),+new Date(e.setHours(0,0,0,0))<=+this.todayDate&&+this.todayDate<=+new Date(i.setHours(0,0,0,0))&&!this.todayDisabled||t.addClass([this.todayElement],c),this.footer=this.createElement("div",{className:"e-footer-container"}),this.footer.appendChild(this.todayElement),"calendar"===this.getModuleName()&&this.element.appendChild(this.footer),"datepicker"===this.getModuleName()&&this.calendarElement.appendChild(this.footer),"datetimepicker"===this.getModuleName()&&this.calendarElement.appendChild(this.footer),this.todayElement.classList.contains(c)||t.EventHandler.add(this.todayElement,"click",this.todayButtonClick,this)}},i.prototype.wireEvents=function(e,i,s,a){t.EventHandler.add(this.headerTitleElement,"click",this.navigateTitle,this),this.defaultKeyConfigs=t.extend(this.defaultKeyConfigs,this.keyConfigs),"calendar"===this.getModuleName()?this.keyboardModule=new t.KeyboardEvents(this.element,{eventName:"keydown",keyAction:this.keyActionHandle.bind(this),keyConfigs:this.defaultKeyConfigs}):this.keyboardModule=new t.KeyboardEvents(this.calendarElement,{eventName:"keydown",keyAction:this.keyActionHandle.bind(this),keyConfigs:this.defaultKeyConfigs})},i.prototype.dateWireEvents=function(e,i,s,a){this.defaultKeyConfigs=this.getDefaultKeyConfig(),this.defaultKeyConfigs=t.extend(this.defaultKeyConfigs,s),this.serverModuleName=a},i.prototype.todayButtonClick=function(e,t,i){this.showTodayButton&&(this.currentView()===this.depth?this.effect="":this.effect="e-zoomin",this.getViewNumber(this.start)>=this.getViewNumber(this.depth)?this.navigateTo(this.depth,new Date(this.checkValue(t)),i):this.navigateTo("Month",new Date(this.checkValue(t)),i))},i.prototype.resetCalendar=function(){this.calendarElement&&t.detach(this.calendarElement),this.tableBodyElement&&t.detach(this.tableBodyElement),this.table&&t.detach(this.table),this.tableHeadElement&&t.detach(this.tableHeadElement),this.nextIcon&&t.detach(this.nextIcon),this.previousIcon&&t.detach(this.previousIcon),this.footer&&t.detach(this.footer),this.todayElement=null,this.renderDayCellArgs=null,this.calendarElement=this.tableBodyElement=this.footer=this.tableHeadElement=this.nextIcon=this.previousIcon=this.table=null},i.prototype.keyActionHandle=function(e,i,s){var a,n=this.tableBodyElement.querySelector("tr td.e-focused-date");a=s?t.isNullOrUndefined(n)||+i!==parseInt(n.getAttribute("id").split("_")[0],10)?this.tableBodyElement.querySelector("tr td.e-selected"):n:this.tableBodyElement.querySelector("tr td.e-selected");var r=this.getViewNumber(this.currentView()),l=this.getViewNumber(this.depth),o=r===l&&this.getViewNumber(this.start)>=l;switch(this.effect="",e.action){case"moveLeft":this.keyboardNavigate(-1,r,e,this.max,this.min),e.preventDefault();break;case"moveRight":this.keyboardNavigate(1,r,e,this.max,this.min),e.preventDefault();break;case"moveUp":0===r?this.keyboardNavigate(-7,r,e,this.max,this.min):this.keyboardNavigate(-4,r,e,this.max,this.min),e.preventDefault();break;case"moveDown":0===r?this.keyboardNavigate(7,r,e,this.max,this.min):this.keyboardNavigate(4,r,e,this.max,this.min),e.preventDefault();break;case"select":if(e.target===this.todayElement)this.todayButtonClick(e,i);else{var h=t.isNullOrUndefined(n)?a:n;if(!t.isNullOrUndefined(h)&&!h.classList.contains(c))if(o){var u=new Date(parseInt(""+h.id,0));this.selectDate(e,u,h)}else this.contentClick(null,--r,h,i)}break;case"controlUp":this.title(),e.preventDefault();break;case"controlDown":t.isNullOrUndefined(n)&&(t.isNullOrUndefined(a)||o)||this.contentClick(null,--r,n||a,i),e.preventDefault();break;case"home":this.currentDate=this.firstDay(this.currentDate),t.detach(this.tableBodyElement),0===r?this.renderMonths(e):1===r?this.renderYears(e):this.renderDecades(e),e.preventDefault();break;case"end":this.currentDate=this.lastDay(this.currentDate,r),t.detach(this.tableBodyElement),0===r?this.renderMonths(e):1===r?this.renderYears(e):this.renderDecades(e),e.preventDefault();break;case"pageUp":this.addMonths(this.currentDate,-1),this.navigateTo("Month",this.currentDate),e.preventDefault();break;case"pageDown":this.addMonths(this.currentDate,1),this.navigateTo("Month",this.currentDate),e.preventDefault();break;case"shiftPageUp":this.addYears(this.currentDate,-1),this.navigateTo("Month",this.currentDate),e.preventDefault();break;case"shiftPageDown":this.addYears(this.currentDate,1),this.navigateTo("Month",this.currentDate),e.preventDefault();break;case"controlHome":this.navigateTo("Month",new Date(this.currentDate.getFullYear(),0,1)),e.preventDefault();break;case"controlEnd":this.navigateTo("Month",new Date(this.currentDate.getFullYear(),11,31)),e.preventDefault()}"calendar"===this.getModuleName()&&this.table.focus()},i.prototype.keyboardNavigate=function(e,i,s,a,n){var r=new Date(this.checkValue(this.currentDate));switch(i){case 2:this.addYears(this.currentDate,e),this.isMonthYearRange(this.currentDate)?(t.detach(this.tableBodyElement),this.renderDecades(s)):this.currentDate=r;break;case 1:this.addMonths(this.currentDate,e),this.calendarMode,this.isMonthYearRange(this.currentDate)?(t.detach(this.tableBodyElement),this.renderYears(s)):this.currentDate=r;break;case 0:this.addDay(this.currentDate,e,s,a,n),this.isMinMaxRange(this.currentDate)?(t.detach(this.tableBodyElement),this.renderMonths(s)):this.currentDate=r}},i.prototype.preRender=function(e){var t=this;this.navigatePreviousHandler=this.navigatePrevious.bind(this),this.navigateNextHandler=this.navigateNext.bind(this),this.defaultKeyConfigs=this.getDefaultKeyConfig(),this.navigateHandler=function(e){t.triggerNavigate(e)}},i.prototype.minMaxDate=function(e){var t=new Date(new Date(+e).setHours(0,0,0,0)),i=new Date(new Date(+this.min).setHours(0,0,0,0)),s=new Date(new Date(+this.max).setHours(0,0,0,0));return+t!=+i&&+t!=+s||(+e<+this.min&&(e=new Date(+this.min)),+e>+this.max&&(e=new Date(+this.max))),e},i.prototype.renderMonths=function(e,t,i){var s,a=this.weekNumber?8:7;s="Gregorian"===this.calendarMode?this.renderDays(this.currentDate,t,null,null,i):this.islamicModule.islamicRenderDays(this.currentDate,t),this.createContentHeader(),"Gregorian"===this.calendarMode?this.renderTemplate(s,a,p,e,t):this.islamicModule.islamicRenderTemplate(s,a,p,e,t)},i.prototype.renderDays=function(e,i,s,a,n){var r,l=[],h=n?new Date(+e):this.getDate(new Date,this.timezone),u=new Date(this.checkValue(e)),d=u.getMonth();this.titleUpdate(e,"days");var p=u;for(u=new Date(p.getFullYear(),p.getMonth(),0,p.getHours(),p.getMinutes(),p.getSeconds(),p.getMilliseconds());u.getDay()!==this.firstDayOfWeek;)this.setStartDate(u,-864e5);for(var y=0;y<42;++y){var g=this.createElement("td",{className:"e-cell"}),b=this.createElement("span");if(y%7==0&&this.weekNumber){var D="FirstDay"===this.weekRule?6:"FirstFourDayWeek"===this.weekRule?3:0,E=new Date(u.getFullYear(),u.getMonth(),u.getDate()+D);b.textContent=""+this.getWeek(E),g.appendChild(b),t.addClass([g],""+v),l.push(g)}r=new Date(+u),u=this.minMaxDate(u);var C={type:"dateTime",skeleton:"full"},k=this.globalize.parseDate(this.globalize.formatDate(u,C),C),V=this.dayCell(u),w=this.globalize.formatDate(u,{type:"date",skeleton:"full"}),M=this.createElement("span");M.textContent=this.globalize.formatDate(u,{format:"d",type:"date",skeleton:"yMd"});var O=this.min>u||this.max<u;O?(t.addClass([V],c),t.addClass([V],m)):M.setAttribute("title",""+w),d!==u.getMonth()&&t.addClass([V],o),0!==u.getDay()&&6!==u.getDay()||t.addClass([V],"e-weekend"),V.appendChild(M),this.renderDayCellArgs={date:u,isDisabled:!1,element:V,isOutOfRange:O};var N=this.renderDayCellArgs;if(this.renderDayCellEvent(N),N.isDisabled){var I=new Date(this.checkValue(i)),T=new Date(this.checkValue(N.date));if(s){if(!t.isNullOrUndefined(a)&&a.length>0)for(var x=0;x<a.length;x++){+new Date(this.globalize.formatDate(N.date,{type:"date",skeleton:"yMd"}))===+new Date(this.globalize.formatDate(a[x],{type:"date",skeleton:"yMd"}))&&(a.splice(x,1),x=-1)}}else I&&+I==+T&&this.setProperties({value:null},!0)}this.renderDayCellArgs.isDisabled&&!V.classList.contains(f)&&(t.addClass([V],c),t.addClass([V],m),+this.renderDayCellArgs.date==+this.todayDate&&(this.todayDisabled=!0));var P=V.classList.contains(o),A=V.classList.contains(c);if(A||t.EventHandler.add(V,"click",this.clickHandler,this),!s||t.isNullOrUndefined(a)||A)!A&&this.getDateVal(u,i)&&t.addClass([V],f);else{for(var S=0;S<a.length;S++){var U={format:null,type:"date",skeleton:"short",calendar:"Gregorian"===this.calendarMode?"gregorian":"islamic"};this.globalize.formatDate(u,U)===this.globalize.formatDate(a[S],U)&&this.getDateVal(u,a[S])||this.getDateVal(u,i)?t.addClass([V],f):this.updateFocus(P,A,u,V,e)}a.length<=0&&this.updateFocus(P,A,u,V,e)}this.updateFocus(P,A,u,V,e),k.getFullYear()===h.getFullYear()&&k.getMonth()===h.getMonth()&&k.getDate()===h.getDate()&&t.addClass([V],"e-today"),l.push(this.renderDayCellArgs.element),u=new Date(+r),this.addDay(u,1,null,this.max,this.min)}return l},i.prototype.updateFocus=function(e,i,s,a,n){n.getDate()!==s.getDate()||e||i?(n>=this.max&&parseInt(a.id,0)===+this.max&&!e&&!i&&t.addClass([a],y),n<=this.min&&parseInt(a.id,0)===+this.min&&!e&&!i&&t.addClass([a],y)):t.addClass([a],y)},i.prototype.renderYears=function(e,i){this.removeTableHeadElement();var s=[],a=t.isNullOrUndefined(i),n=new Date(this.checkValue(this.currentDate)),r=n.getMonth(),l=n.getFullYear(),o=n,h=o.getFullYear(),u=new Date(this.checkValue(this.min)).getFullYear(),p=new Date(this.checkValue(this.min)).getMonth(),m=new Date(this.checkValue(this.max)).getFullYear(),v=new Date(this.checkValue(this.max)).getMonth();o.setMonth(0),this.titleUpdate(this.currentDate,"months"),o.setDate(1);for(var g=0;g<12;++g){var b=this.dayCell(o),D=this.createElement("span"),E=i&&i.getMonth()===o.getMonth(),C=i&&i.getFullYear()===l&&E;D.textContent=this.toCapitalize(this.globalize.formatDate(o,{format:null,type:"dateTime",skeleton:"MMM"})),this.min&&(h<u||g<p&&h===u)||this.max&&(h>m||g>v&&h>=m)?t.addClass([b],c):!a&&C?t.addClass([b],f):o.getMonth()===r&&this.currentDate.getMonth()===r&&t.addClass([b],y),o.setDate(1),o.setMonth(o.getMonth()+1),b.classList.contains(c)||t.EventHandler.add(b,"click",this.clickHandler,this),b.appendChild(D),s.push(b)}this.renderTemplate(s,4,d,e,i)},i.prototype.renderDecades=function(e,i){this.removeTableHeadElement();var s=[],a=new Date(this.checkValue(this.currentDate));a.setMonth(0),a.setDate(1);var n=a.getFullYear(),r=new Date(a.setFullYear(n-n%10)),l=new Date(a.setFullYear(n-n%10+9)),o=r.getFullYear(),u=l.getFullYear(),d=this.globalize.formatDate(r,{format:null,type:"dateTime",skeleton:"y"}),p=this.globalize.formatDate(l,{format:null,type:"dateTime",skeleton:"y"});this.headerTitleElement.textContent=d+" - "+p;for(var m=new Date(n-n%10-1,0,1).getFullYear(),v=0;v<12;++v){var g=m+v;a.setFullYear(g);var b=this.dayCell(a);t.attributes(b,{role:"gridcell"});var D=this.createElement("span");D.textContent=this.globalize.formatDate(a,{format:null,type:"dateTime",skeleton:"y"}),g<o||g>u?(t.addClass([b],h),t.isNullOrUndefined(i)||a.getFullYear()!==i.getFullYear()||t.addClass([b],f),(g<new Date(this.checkValue(this.min)).getFullYear()||g>new Date(this.checkValue(this.max)).getFullYear())&&t.addClass([b],c)):g<new Date(this.checkValue(this.min)).getFullYear()||g>new Date(this.checkValue(this.max)).getFullYear()?t.addClass([b],c):t.isNullOrUndefined(i)||a.getFullYear()!==i.getFullYear()?a.getFullYear()!==this.currentDate.getFullYear()||b.classList.contains(c)||t.addClass([b],y):t.addClass([b],f),b.classList.contains(c)||t.EventHandler.add(b,"click",this.clickHandler,this),b.appendChild(D),s.push(b)}this.renderTemplate(s,4,"e-decade",e,i)},i.prototype.dayCell=function(e){var i={skeleton:"full",type:"dateTime",calendar:"Gregorian"===this.calendarMode?"gregorian":"islamic"},s=this.globalize.parseDate(this.globalize.formatDate(e,i),i).valueOf(),a={className:"e-cell",attrs:{id:""+t.getUniqueID(""+s),"aria-selected":"false",role:"gridcell"}};return this.createElement("td",a)},i.prototype.firstDay=function(e){var t="Decade"!==this.currentView()?this.tableBodyElement.querySelectorAll("td:not(."+o):this.tableBodyElement.querySelectorAll("td:not(."+h);if(t.length)for(var i=0;i<t.length;i++)if(!t[i].classList.contains(c)){e=new Date(parseInt(t[i].id,0));break}return e},i.prototype.lastDay=function(e,t){var i=new Date(e.getFullYear(),e.getMonth()+1,0);if(2!==t){var s=Math.abs(i.getTimezoneOffset()-this.firstDay(e).getTimezoneOffset());return s&&i.setHours(this.firstDay(e).getHours()+s/60),this.findLastDay(i)}return this.findLastDay(this.firstDay(i))},i.prototype.checkDateValue=function(e){return!t.isNullOrUndefined(e)&&e instanceof Date&&!isNaN(+e)?e:null},i.prototype.findLastDay=function(e){var t="Decade"===this.currentView()?this.tableBodyElement.querySelectorAll("td:not(."+h):this.tableBodyElement.querySelectorAll("td:not(."+o);if(t.length)for(var i=t.length-1;i>=0;i--)if(!t[i].classList.contains(c)){e=new Date(parseInt(t[i].id,0));break}return e},i.prototype.removeTableHeadElement=function(){"calendar"===this.getModuleName()?t.isNullOrUndefined(this.element.querySelectorAll(".e-content table thead")[0])||t.detach(this.tableHeadElement):t.isNullOrUndefined(this.calendarElement.querySelectorAll(".e-content table thead")[0])||t.detach(this.tableHeadElement)},i.prototype.renderTemplate=function(e,i,s,a,n){var r,l=this.getViewNumber(this.currentView());this.tableBodyElement=this.createElement("tbody"),this.table.appendChild(this.tableBodyElement),t.removeClass([this.contentElement,this.headerElement],[p,"e-decade",d]),t.addClass([this.contentElement,this.headerElement],[s]);for(var h=i,u=0,c=0;c<e.length/i;++c){for(r=this.createElement("tr",{attrs:{role:"row"}}),u=0+u;u<h;u++)e[u].classList.contains("e-week-number")||t.isNullOrUndefined(e[u].children[0])||(t.addClass([e[u].children[0]],["e-day"]),t.rippleEffect(e[u].children[0],{duration:600,isCenterRipple:!0})),r.appendChild(e[u]),this.weekNumber&&7===u&&e[7].classList.contains(o)&&t.addClass([r],g),!this.weekNumber&&6===u&&e[6].classList.contains(o)&&t.addClass([r],g),this.weekNumber?41===u&&e[41].classList.contains(o)&&t.addClass([r],g):35===u&&e[35].classList.contains(o)&&t.addClass([r],g);h+=i,u+=0,this.tableBodyElement.appendChild(r)}this.table.querySelector("tbody").className=this.effect,"Gregorian"===this.calendarMode?this.iconHandler():this.islamicModule.islamicIconHandler(),(l!==this.getViewNumber(this.currentView())||0===l&&l!==this.getViewNumber(this.currentView()))&&this.navigateHandler(a),this.setAriaActiveDescendant()},i.prototype.clickHandler=function(e,t){this.clickEventEmitter(e);var i=e.currentTarget,s=this.getViewNumber(this.currentView());i.classList.contains(o)?this.contentClick(e,0,null,t):s===this.getViewNumber(this.depth)&&this.getViewNumber(this.start)>=this.getViewNumber(this.depth)?this.contentClick(e,1,null,t):2===s?this.contentClick(e,1,null,t):i.classList.contains(o)||0!==s?this.contentClick(e,0,i,t):this.selectDate(e,this.getIdValue(e,null),null),"calendar"===this.getModuleName()&&this.table.focus()},i.prototype.clickEventEmitter=function(e){e.preventDefault()},i.prototype.contentClick=function(e,i,s,a){var n=this.getViewNumber(this.currentView()),r=this.getIdValue(e,s);switch(i){case 0:n===this.getViewNumber(this.depth)&&this.getViewNumber(this.start)>=this.getViewNumber(this.depth)?(t.detach(this.tableBodyElement),this.currentDate=r,this.effect=b,this.renderMonths(e)):("Gregorian"===this.calendarMode?(this.currentDate.setMonth(r.getMonth()),r.getMonth()>0&&this.currentDate.getMonth()!==r.getMonth()&&this.currentDate.setDate(0),this.currentDate.setFullYear(r.getFullYear())):this.currentDate=r,this.effect=b,t.detach(this.tableBodyElement),this.renderMonths(e));break;case 1:if(n===this.getViewNumber(this.depth)&&this.getViewNumber(this.start)>=this.getViewNumber(this.depth))this.selectDate(e,r,null);else{if("Gregorian"===this.calendarMode)this.currentDate.setFullYear(r.getFullYear());else{var l=this.islamicModule.getIslamicDate(r);this.currentDate=this.islamicModule.toGregorian(l.year,l.month,1)}this.effect=b,t.detach(this.tableBodyElement),this.renderYears(e)}}},i.prototype.switchView=function(e,i,s,a){switch(e){case 0:t.detach(this.tableBodyElement),this.renderMonths(i,null,a),s&&!t.isNullOrUndefined(this.tableBodyElement.querySelectorAll("."+y)[0])&&this.tableBodyElement.querySelectorAll("."+y)[0].classList.remove(y);break;case 1:t.detach(this.tableBodyElement),this.renderYears(i);break;case 2:t.detach(this.tableBodyElement),this.renderDecades(i)}},i.prototype.getModuleName=function(){return"calendar"},i.prototype.requiredModules=function(){var e=[];return this&&e.push({args:[this],member:"islamic"}),e},i.prototype.getPersistData=function(){return this.addOnPersist(["value"])},i.prototype.onPropertyChanged=function(e,i,s,a){this.effect="";for(var n=0,r=Object.keys(e);n<r.length;n++){var l=r[n];switch(l){case"enableRtl":e.enableRtl?"calendar"===this.getModuleName()?this.element.classList.add("e-rtl"):this.calendarElement.classList.add("e-rtl"):"calendar"===this.getModuleName()?this.element.classList.remove("e-rtl"):this.calendarElement.classList.remove("e-rtl");break;case"dayHeaderFormat":this.getCultureValues(),"datepicker"!==this.getModuleName()?this.createContentHeader():this.calendarElement&&this.createContentHeader(),this.adjustLongHeaderSize();break;case"min":case"max":this.rangeValidation(this.min,this.max),"min"===l?this.setProperties({min:this.checkDateValue(new Date(this.checkValue(e.min)))},!0):this.setProperties({max:this.checkDateValue(new Date(this.checkValue(e.max)))},!0),this.setProperties({start:this.currentView()},!0),this.tableBodyElement&&t.detach(this.tableBodyElement),this.minMaxUpdate(),s&&this.validateValues(s,a),"datepicker"!==this.getModuleName()?this.createContentBody():this.calendarElement&&this.createContentBody(),(this.todayDate<this.min||this.max<this.todayDate)&&this.footer&&this.todayElement?(t.detach(this.todayElement),t.detach(this.footer),this.todayElement=this.footer=null,this.createContentFooter()):this.footer&&this.todayElement&&this.todayElement.classList.contains("e-disabled")&&(t.removeClass([this.todayElement],c),t.detach(this.todayElement),t.detach(this.footer),this.todayElement=this.footer=null,this.createContentFooter());break;case"start":case"depth":case"weekNumber":case"firstDayOfWeek":case"weekRule":this.checkView(),"datepicker"!==this.getModuleName()?(this.createContentHeader(),this.createContentBody()):this.calendarElement&&(this.createContentHeader(),this.createContentBody());break;case"locale":this.globalize=new t.Internationalization(this.locale),"datepicker"!==this.getModuleName()?(this.createContentHeader(),this.createContentBody()):this.calendarElement&&(this.createContentHeader(),this.createContentBody()),this.l10.setLocale(this.locale),this.updateFooter();break;case"showTodayButton":e.showTodayButton?this.createContentFooter():t.isNullOrUndefined(this.todayElement)||t.isNullOrUndefined(this.footer)||(t.detach(this.todayElement),t.detach(this.footer),this.todayElement=this.footer=void 0),this.setProperties({showTodayButton:e.showTodayButton},!0)}}},i.prototype.validateValues=function(e,i){if(e&&!t.isNullOrUndefined(i)&&i.length>0){for(var s=this.copyValues(i),a=0;a<s.length;a++){var n=s[a],r="Gregorian"===this.calendarMode?"gregorian":"islamic",l=void 0;l="Gregorian"===this.calendarMode?this.globalize.formatDate(n,{type:"date",skeleton:"yMd"}):this.globalize.formatDate(n,{type:"dateTime",skeleton:"full",calendar:"islamic"});var o={type:"date",skeleton:"yMd",calendar:r},h=this.globalize.formatDate(this.min,o),u={type:"date",skeleton:"yMd",calendar:r},d=this.globalize.formatDate(this.max,u);(+new Date(l)<+new Date(h)||+new Date(l)>+new Date(d))&&(s.splice(a,1),a=-1)}this.setProperties({values:s},!0)}},i.prototype.setValueUpdate=function(){t.isNullOrUndefined(this.tableBodyElement)||(t.detach(this.tableBodyElement),this.setProperties({start:this.currentView()},!0),this.createContentBody())},i.prototype.copyValues=function(e){var i=[];if(!t.isNullOrUndefined(e)&&e.length>0)for(var s=0;s<e.length;s++)i.push(new Date(+e[s]));return i},i.prototype.titleUpdate=function(e,i){var s,a,n=new t.Internationalization(this.locale),r="Gregorian"===this.calendarMode?"gregorian":"islamic";switch("Gregorian"===this.calendarMode?(s=n.formatDate(e,{type:"dateTime",skeleton:"yMMMM",calendar:r}),a=n.formatDate(e,{format:null,type:"dateTime",skeleton:"y",calendar:r})):(s=n.formatDate(e,{type:"dateTime",format:"MMMM y",calendar:r}),a=n.formatDate(e,{type:"dateTime",format:"y",calendar:r})),i){case"days":this.headerTitleElement.textContent=this.toCapitalize(s);break;case"months":this.headerTitleElement.textContent=a}},i.prototype.setActiveDescendant=function(){var e,i,s=this.tableBodyElement.querySelector("tr td.e-focused-date"),a=this.tableBodyElement.querySelector("tr td.e-selected"),n="Gregorian"===this.calendarMode?"gregorian":"islamic",r=this.currentView();return i="Month"===r?this.globalize.formatDate(this.currentDate,{type:"date",skeleton:"full",calendar:n}):"Year"===r?"islamic"!==n?this.globalize.formatDate(this.currentDate,{type:"date",skeleton:"yMMMM",calendar:n}):this.globalize.formatDate(this.currentDate,{type:"date",skeleton:"GyMMM",calendar:n}):this.globalize.formatDate(this.currentDate,{format:null,type:"date",skeleton:"y",calendar:n}),(a||s)&&(t.isNullOrUndefined(a)||a.setAttribute("aria-selected","true"),(s||a).setAttribute("aria-label",i),e=(s||a).getAttribute("id")),e},i.prototype.iconHandler=function(){switch(new Date(this.checkValue(this.currentDate)).setDate(1),this.currentView()){case"Month":this.previousIconHandler(this.compareMonth(new Date(this.checkValue(this.currentDate)),this.min)<1),this.nextIconHandler(this.compareMonth(new Date(this.checkValue(this.currentDate)),this.max)>-1);break;case"Year":this.previousIconHandler(this.compareYear(new Date(this.checkValue(this.currentDate)),this.min)<1),this.nextIconHandler(this.compareYear(new Date(this.checkValue(this.currentDate)),this.max)>-1);break;case"Decade":this.previousIconHandler(this.compareDecade(new Date(this.checkValue(this.currentDate)),this.min)<1),this.nextIconHandler(this.compareDecade(new Date(this.checkValue(this.currentDate)),this.max)>-1)}},i.prototype.destroy=function(){"calendar"===this.getModuleName()&&this.element?t.removeClass([this.element],[u]):this.calendarElement&&this.element&&t.removeClass([this.element],[u]),"calendar"===this.getModuleName()&&this.element&&(t.EventHandler.remove(this.headerTitleElement,"click",this.navigateTitle),this.todayElement&&t.EventHandler.remove(this.todayElement,"click",this.todayButtonClick),this.previousIconHandler(!0),this.nextIconHandler(!0),this.keyboardModule.destroy(),this.element.removeAttribute("data-role"),t.isNullOrUndefined(this.calendarEleCopy.getAttribute("tabindex"))?this.element.removeAttribute("tabindex"):this.element.setAttribute("tabindex",this.tabIndex)),this.element&&(this.element.innerHTML=""),e.prototype.destroy.call(this)},i.prototype.title=function(e){var t=this.getViewNumber(this.currentView());this.effect=b,this.switchView(++t,e)},i.prototype.getViewNumber=function(e){return"Month"===e?0:"Year"===e?1:2},i.prototype.navigateTitle=function(e){e.preventDefault(),this.title(e),"calendar"===this.getModuleName()&&this.table.focus()},i.prototype.previous=function(){this.effect="";var e=this.getViewNumber(this.currentView());switch(this.currentView()){case"Month":this.addMonths(this.currentDate,-1),this.switchView(e);break;case"Year":this.addYears(this.currentDate,-1),this.switchView(e);break;case"Decade":this.addYears(this.currentDate,-10),this.switchView(e)}},i.prototype.navigatePrevious=function(e){e.preventDefault(),"Gregorian"===this.calendarMode?this.previous():this.islamicModule.islamicPrevious(),this.triggerNavigate(e),"calendar"===this.getModuleName()&&this.table.focus()},i.prototype.next=function(){this.effect="";var e=this.getViewNumber(this.currentView());switch(this.currentView()){case"Month":this.addMonths(this.currentDate,1),this.switchView(e);break;case"Year":this.addYears(this.currentDate,1),this.switchView(e);break;case"Decade":this.addYears(this.currentDate,10),this.switchView(e)}},i.prototype.navigateNext=function(e){e.preventDefault(),"Gregorian"===this.calendarMode?this.next():this.islamicModule.islamicNext(),this.triggerNavigate(e),"calendar"===this.getModuleName()&&this.table.focus()},i.prototype.navigateTo=function(e,t,i){+t>=+this.min&&+t<=+this.max&&(this.currentDate=t),+t<=+this.min&&(this.currentDate=new Date(this.checkValue(this.min))),+t>=+this.max&&(this.currentDate=new Date(this.checkValue(this.max))),this.getViewNumber(this.depth)>=this.getViewNumber(e)&&(this.getViewNumber(this.depth)<=this.getViewNumber(this.start)||this.getViewNumber(this.depth)===this.getViewNumber(e))&&(e=this.depth),this.switchView(this.getViewNumber(e),null,null,i)},i.prototype.currentView=function(){return this.contentElement.classList.contains(d)?"Year":this.contentElement.classList.contains("e-decade")?"Decade":"Month"},i.prototype.getDateVal=function(e,i){return!t.isNullOrUndefined(i)&&e.getDate()===i.getDate()&&e.getMonth()===i.getMonth()&&e.getFullYear()===i.getFullYear()},i.prototype.getCultureObjects=function(e,i){var s=".dates.calendars.gregorian.days.format."+this.dayHeaderFormat.toLowerCase(),a=".dates.calendars.islamic.days.format."+this.dayHeaderFormat.toLowerCase();return"Gregorian"===this.calendarMode?t.getValue("main."+this.locale+s,e):t.getValue("main."+this.locale+a,e)},i.prototype.getWeek=function(e){var t=new Date(this.checkValue(e)).valueOf(),i=new Date(e.getFullYear(),0,1).valueOf();return Math.ceil((t-i+864e5)/864e5/7)},i.prototype.setStartDate=function(e,t){var i=e.getTimezoneOffset(),s=new Date(e.getTime()+t),a=s.getTimezoneOffset()-i;e.setTime(s.getTime()+6e4*a)},i.prototype.addMonths=function(e,t){if("Gregorian"===this.calendarMode){var i=e.getDate();e.setDate(1),e.setMonth(e.getMonth()+t),e.setDate(Math.min(i,this.getMaxDays(e)))}else{var s=this.islamicModule.getIslamicDate(e);this.currentDate=this.islamicModule.toGregorian(s.year,s.month+t,1)}},i.prototype.addYears=function(e,t){if("Gregorian"===this.calendarMode){var i=e.getDate();e.setDate(1),e.setFullYear(e.getFullYear()+t),e.setDate(Math.min(i,this.getMaxDays(e)))}else{var s=this.islamicModule.getIslamicDate(e);this.currentDate=this.islamicModule.toGregorian(s.year+t,s.month,1)}},i.prototype.getIdValue=function(e,t){var i;i=e?e.currentTarget:t;var s={type:"dateTime",skeleton:"full",calendar:"Gregorian"===this.calendarMode?"gregorian":"islamic"},a=this.globalize.formatDate(new Date(parseInt(""+i.getAttribute("id"),0)),s),n=this.globalize.parseDate(a,s),r=n.valueOf()-n.valueOf()%1e3;return new Date(r)},i.prototype.adjustLongHeaderSize=function(){t.removeClass([this.element],D),"Wide"===this.dayHeaderFormat&&t.addClass(["calendar"===this.getModuleName()?this.element:this.calendarElement],D)},i.prototype.selectDate=function(e,i,s,a,n){var r=s||e.currentTarget;if(this.isDateSelected=!1,"Decade"===this.currentView())this.setDateDecade(this.currentDate,i.getFullYear());else if("Year"===this.currentView())this.setDateYear(this.currentDate,i);else{if(a&&!this.checkPresentDate(i,n)){var l=this.copyValues(n);!t.isNullOrUndefined(n)&&l.length>0?(l.push(new Date(this.checkValue(i))),this.setProperties({values:l},!0),this.setProperties({value:n[n.length-1]},!0)):this.setProperties({values:[new Date(this.checkValue(i))]},!0)}else this.setProperties({value:new Date(this.checkValue(i))},!0);this.currentDate=new Date(this.checkValue(i))}var o=t.closest(r,"."+u);if(t.isNullOrUndefined(o)&&(o=this.tableBodyElement),a||t.isNullOrUndefined(o.querySelector("."+f))||t.removeClass([o.querySelector("."+f)],f),a||t.isNullOrUndefined(o.querySelector("."+y))||t.removeClass([o.querySelector("."+y)],y),a){l=this.copyValues(n);for(var h=Array.prototype.slice.call(this.tableBodyElement.querySelectorAll("td")),d=0;d<h.length;d++){var p=o.querySelectorAll("td."+y)[0],c=o.querySelectorAll("td."+f)[0];h[d]===p&&t.removeClass([h[d]],y),h[d]!==c||this.checkPresentDate(new Date(parseInt(c.getAttribute("id").split("_")[0],10)),n)||t.removeClass([h[d]],f)}if(r.classList.contains(f)){t.removeClass([r],f);for(var m=0;m<l.length;m++){var v={format:null,type:"date",skeleton:"short",calendar:"Gregorian"===this.calendarMode?"gregorian":"islamic"};if(this.globalize.formatDate(i,v)===this.globalize.formatDate(l[m],v)){d=l.indexOf(l[m]);l.splice(d,1),t.addClass([r],y)}}this.setProperties({values:l},!0)}else t.addClass([r],f)}else t.addClass([r],f);this.isDateSelected=!0},i.prototype.checkPresentDate=function(e,i){var s=!1;if(!t.isNullOrUndefined(i))for(var a=0;a<i.length;a++){var n="Gregorian"===this.calendarMode?"gregorian":"islamic";this.globalize.formatDate(e,{format:null,type:"date",skeleton:"short",calendar:n})===this.globalize.formatDate(i[a],{format:null,type:"date",skeleton:"short",calendar:n})&&(s=!0)}return s},i.prototype.setAriaActiveDescendant=function(){t.attributes(this.table,{"aria-activedescendant":""+this.setActiveDescendant()})},i.prototype.previousIconHandler=function(e){e?(t.EventHandler.remove(this.previousIcon,"click",this.navigatePreviousHandler),t.addClass([this.previousIcon],""+c),t.addClass([this.previousIcon],""+m),this.previousIcon.setAttribute("aria-disabled","true")):(t.EventHandler.add(this.previousIcon,"click",this.navigatePreviousHandler),t.removeClass([this.previousIcon],""+c),t.removeClass([this.previousIcon],""+m),this.previousIcon.setAttribute("aria-disabled","false"))},i.prototype.renderDayCellEvent=function(e){t.extend(this.renderDayCellArgs,{name:"renderDayCell"}),this.trigger("renderDayCell",e)},i.prototype.navigatedEvent=function(e){t.extend(this.navigatedArgs,{name:"navigated",event:e}),this.trigger("navigated",this.navigatedArgs)},i.prototype.triggerNavigate=function(e){this.navigatedArgs={view:this.currentView(),date:this.currentDate},this.navigatedEvent(e)},i.prototype.nextIconHandler=function(e){e?(t.EventHandler.remove(this.nextIcon,"click",this.navigateNextHandler),t.addClass([this.nextIcon],c),t.addClass([this.nextIcon],m),this.nextIcon.setAttribute("aria-disabled","true")):(t.EventHandler.add(this.nextIcon,"click",this.navigateNextHandler),t.removeClass([this.nextIcon],c),t.removeClass([this.nextIcon],m),this.nextIcon.setAttribute("aria-disabled","false"))},i.prototype.compare=function(e,t,i){var s,a,n=t.getFullYear();return s=n,a=0,i&&(s=(n-=n%i)-n%i+i-1),e.getFullYear()>s?a=1:e.getFullYear()<n&&(a=-1),a},i.prototype.isMinMaxRange=function(e){return+e>=+this.min&&+e<=+this.max},i.prototype.isMonthYearRange=function(e){if("Gregorian"===this.calendarMode)return e.getMonth()>=this.min.getMonth()&&e.getFullYear()>=this.min.getFullYear()&&e.getMonth()<=this.max.getMonth()&&e.getFullYear()<=this.max.getFullYear();var t=this.islamicModule.getIslamicDate(e);return t.month>=this.islamicModule.getIslamicDate(new Date(1944,1,18)).month&&t.year>=this.islamicModule.getIslamicDate(new Date(1944,1,18)).year&&t.month<=this.islamicModule.getIslamicDate(new Date(2069,1,16)).month&&t.year<=this.islamicModule.getIslamicDate(new Date(2069,1,16)).year},i.prototype.compareYear=function(e,t){return this.compare(e,t,0)},i.prototype.compareDecade=function(e,t){return this.compare(e,t,10)},i.prototype.shiftArray=function(e,t){return e.slice(t).concat(e.slice(0,t))},i.prototype.addDay=function(e,i,s,a,n){var r=i,l=new Date(+e);if(!t.isNullOrUndefined(this.tableBodyElement)&&!t.isNullOrUndefined(s)){for(;this.findNextTD(new Date(+e),r,a,n);)r+=i;var o=new Date(l.setDate(l.getDate()+r));r=+o>+a||+o<+n?r===i?i-i:i:r}e.setDate(e.getDate()+r)},i.prototype.findNextTD=function(e,i,s,a){var n=new Date(e.setDate(e.getDate()+i)),r=[],l=!1;if((!t.isNullOrUndefined(n)&&n.getMonth())===(!t.isNullOrUndefined(this.currentDate)&&this.currentDate.getMonth())){r=("Gregorian"===this.calendarMode?this.renderDays(n):this.islamicModule.islamicRenderDays(this.currentDate,n)).filter(function(e){return e.classList.contains(c)})}else r=this.tableBodyElement.querySelectorAll("td."+c);if(+n<=+s&&+n>=+a&&r.length)for(var o=0;o<r.length&&!(l=+n==+new Date(parseInt(r[o].id,0)));o++);return l},i.prototype.getMaxDays=function(e){var t,i=new Date(this.checkValue(e));t=28;for(var s=i.getMonth();i.getMonth()===s;)++t,i.setDate(t);return t-1},i.prototype.setDateDecade=function(e,t){e.setFullYear(t),this.setProperties({value:new Date(this.checkValue(e))},!0)},i.prototype.setDateYear=function(e,t){e.setFullYear(t.getFullYear(),t.getMonth(),e.getDate()),t.getMonth()!==e.getMonth()&&(e.setDate(0),this.currentDate=new Date(this.checkValue(t))),this.setProperties({value:new Date(this.checkValue(e))},!0)},i.prototype.compareMonth=function(e,t){return e.getFullYear()>t.getFullYear()?1:e.getFullYear()<t.getFullYear()?-1:e.getMonth()===t.getMonth()?0:e.getMonth()>t.getMonth()?1:-1},i.prototype.checkValue=function(e){return e instanceof Date?e.toUTCString():""+e},i.prototype.checkView=function(){"Decade"!==this.start&&"Year"!==this.start&&this.setProperties({start:"Month"},!0),"Decade"!==this.depth&&"Year"!==this.depth&&this.setProperties({depth:"Month"},!0),this.getViewNumber(this.depth)>this.getViewNumber(this.start)&&this.setProperties({depth:"Month"},!0)},i.prototype.getDate=function(e,t){return t&&(e=new Date(e.toLocaleString("en-US",{timeZone:t}))),e},l([t.Property(new Date(1900,0,1))],i.prototype,"min",void 0),l([t.Property(!0)],i.prototype,"enabled",void 0),l([t.Property(null)],i.prototype,"cssClass",void 0),l([t.Property(new Date(2099,11,31))],i.prototype,"max",void 0),l([t.Property(null)],i.prototype,"firstDayOfWeek",void 0),l([t.Property("Gregorian")],i.prototype,"calendarMode",void 0),l([t.Property("Month")],i.prototype,"start",void 0),l([t.Property("Month")],i.prototype,"depth",void 0),l([t.Property(!1)],i.prototype,"weekNumber",void 0),l([t.Property("FirstDay")],i.prototype,"weekRule",void 0),l([t.Property(!0)],i.prototype,"showTodayButton",void 0),l([t.Property("Short")],i.prototype,"dayHeaderFormat",void 0),l([t.Property(!1)],i.prototype,"enablePersistence",void 0),l([t.Property(null)],i.prototype,"keyConfigs",void 0),l([t.Property(null)],i.prototype,"serverTimezoneOffset",void 0),l([t.Event()],i.prototype,"created",void 0),l([t.Event()],i.prototype,"destroyed",void 0),l([t.Event()],i.prototype,"navigated",void 0),l([t.Event()],i.prototype,"renderDayCell",void 0),i=l([t.NotifyPropertyChanges],i)}(t.Component),C=function(e){function i(t,i){return e.call(this,t,i)||this}return r(i,e),i.prototype.render=function(){if("Islamic"===this.calendarMode&&void 0===this.islamicModule&&t.throwError("Requires the injectable Islamic modules to render Calendar in Islamic mode"),this.isMultiSelection&&"object"==typeof this.values&&!t.isNullOrUndefined(this.values)&&this.values.length>0){for(var i=[],s=[],a=0;a<this.values.length;a++)-1===i.indexOf(+this.values[a])&&(i.push(+this.values[a]),s.push(this.values[a]));this.setProperties({values:s},!0);for(var n=0;n<this.values.length;n++)if(!this.checkDateValue(this.values[n]))if("string"==typeof this.values[n]&&this.checkDateValue(new Date(this.checkValue(this.values[n])))){var r=new Date(this.checkValue(this.values[n]));this.values.splice(n,1),this.values.splice(n,0,r)}else this.values.splice(n,1);this.setProperties({value:this.values[this.values.length-1]},!0),this.previousValues=this.values.length}if(this.validateDate(),this.minMaxUpdate(),"calendar"===this.getModuleName()&&(this.setEnable(this.enabled),this.setClass(this.cssClass)),e.prototype.render.call(this),"calendar"===this.getModuleName()){var l=t.closest(this.element,"form");l&&t.EventHandler.add(l,"reset",this.formResetHandler.bind(this)),this.setTimeZone(this.serverTimezoneOffset)}this.renderComplete()},i.prototype.setEnable=function(e){e?t.removeClass([this.element],c):t.addClass([this.element],c)},i.prototype.setClass=function(e,i){t.isNullOrUndefined(i)||(i=i.replace(/\s+/g," ").trim()),t.isNullOrUndefined(e)||(e=e.replace(/\s+/g," ").trim()),t.isNullOrUndefined(i)||""===i||t.removeClass([this.element],i.split(" ")),t.isNullOrUndefined(e)||t.addClass([this.element],e.split(" "))},i.prototype.isDayLightSaving=function(){var e=new Date(this.value.getFullYear(),6,1).getTimezoneOffset(),t=new Date(this.value.getFullYear(),0,1).getTimezoneOffset();return this.value.getTimezoneOffset()<Math.max(t,e)},i.prototype.setTimeZone=function(e){if(!t.isNullOrUndefined(this.serverTimezoneOffset)&&this.value){var i=e+(new Date).getTimezoneOffset()/60;i=this.isDayLightSaving()?i--:i,this.value=new Date(this.value.getTime()+60*i*60*1e3)}},i.prototype.formResetHandler=function(){this.setProperties({value:null},!0)},i.prototype.validateDate=function(){"string"==typeof this.value&&this.setProperties({value:this.checkDateValue(new Date(this.checkValue(this.value)))},!0),e.prototype.validateDate.call(this,this.value),!t.isNullOrUndefined(this.value)&&this.min<=this.max&&this.value>=this.min&&this.value<=this.max&&(this.currentDate=new Date(this.checkValue(this.value))),isNaN(+this.value)&&this.setProperties({value:null},!0)},i.prototype.minMaxUpdate=function(){"calendar"===this.getModuleName()&&(!t.isNullOrUndefined(this.value)&&this.value<=this.min&&this.min<=this.max?(this.setProperties({value:this.min},!0),this.changedArgs={value:this.value}):!t.isNullOrUndefined(this.value)&&this.value>=this.max&&this.min<=this.max&&(this.setProperties({value:this.max},!0),this.changedArgs={value:this.value})),"calendar"===this.getModuleName()||t.isNullOrUndefined(this.value)?e.prototype.minMaxUpdate.call(this,this.value):!t.isNullOrUndefined(this.value)&&this.value<this.min&&this.min<=this.max?e.prototype.minMaxUpdate.call(this,this.min):!t.isNullOrUndefined(this.value)&&this.value>this.max&&this.min<=this.max&&e.prototype.minMaxUpdate.call(this,this.max)},i.prototype.generateTodayVal=function(i){var s=new Date;return t.isNullOrUndefined(this.timezone)||(s=e.prototype.getDate.call(this,s,this.timezone)),i&&t.isNullOrUndefined(this.timezone)?(s.setHours(i.getHours()),s.setMinutes(i.getMinutes()),s.setSeconds(i.getSeconds()),s.setMilliseconds(i.getMilliseconds())):s=new Date(s.getFullYear(),s.getMonth(),s.getDate(),0,0,0,0),s},i.prototype.todayButtonClick=function(t){if(this.showTodayButton){var i=this.generateTodayVal(this.value);if(this.setProperties({value:i},!0),this.isTodayClicked=!0,this.todayButtonEvent=t,this.isMultiSelection){var s=this.copyValues(this.values);e.prototype.checkPresentDate.call(this,i,this.values)||(s.push(i),this.setProperties({values:s}))}e.prototype.todayButtonClick.call(this,t,new Date(+this.value))}},i.prototype.keyActionHandle=function(t){e.prototype.keyActionHandle.call(this,t,this.value,this.isMultiSelection)},i.prototype.preRender=function(){var t=this;this.changeHandler=function(e){t.triggerChange(e)},this.checkView(),e.prototype.preRender.call(this,this.value)},i.prototype.createContent=function(){this.previousDate=this.value,this.previousDateTime=this.value,e.prototype.createContent.call(this)},i.prototype.minMaxDate=function(t){return e.prototype.minMaxDate.call(this,t)},i.prototype.renderMonths=function(t,i,s){e.prototype.renderMonths.call(this,t,this.value,s)},i.prototype.renderDays=function(t,i,s,a,n){var r=e.prototype.renderDays.call(this,t,this.value,this.isMultiSelection,this.values,n);return this.isMultiSelection&&e.prototype.validateValues.call(this,this.isMultiSelection,this.values),r},i.prototype.renderYears=function(t){"Gregorian"===this.calendarMode?e.prototype.renderYears.call(this,t,this.value):this.islamicModule.islamicRenderYears(t,this.value)},i.prototype.renderDecades=function(t){"Gregorian"===this.calendarMode?e.prototype.renderDecades.call(this,t,this.value):this.islamicModule.islamicRenderDecade(t,this.value)},i.prototype.renderTemplate=function(t,i,s,a){"Gregorian"===this.calendarMode?e.prototype.renderTemplate.call(this,t,i,s,a,this.value):this.islamicModule.islamicRenderTemplate(t,i,s,a,this.value),this.changedArgs={value:this.value,values:this.values},this.changeHandler()},i.prototype.clickHandler=function(i){var s=i.currentTarget;if(this.isPopupClicked=!0,s.classList.contains(o))if(this.isMultiSelection){var a=this.copyValues(this.values);a.push(this.getIdValue(i,null)),this.setProperties({values:a},!0),this.setProperties({value:this.values[this.values.length-1]},!0)}else this.setProperties({value:this.getIdValue(i,null)},!0);var n=this.currentView();e.prototype.clickHandler.call(this,i,this.value),this.isMultiSelection&&this.currentDate!==this.value&&!t.isNullOrUndefined(this.tableBodyElement.querySelectorAll("."+y)[0])&&"Year"===n&&this.tableBodyElement.querySelectorAll("."+y)[0].classList.remove(y)},i.prototype.switchView=function(t,i,s,a){e.prototype.switchView.call(this,t,i,this.isMultiSelection,a)},i.prototype.getModuleName=function(){return e.prototype.getModuleName.call(this),"calendar"},i.prototype.getPersistData=function(){e.prototype.getPersistData.call(this);return this.addOnPersist(["value","values"])},i.prototype.onPropertyChanged=function(t,i){this.effect="",this.rangeValidation(this.min,this.max);for(var s=0,a=Object.keys(t);s<a.length;s++){switch(a[s]){case"value":this.isDateSelected&&("string"==typeof t.value?this.setProperties({value:new Date(this.checkValue(t.value))},!0):t.value=new Date(this.checkValue(t.value)),isNaN(+this.value)&&this.setProperties({value:i.value},!0),this.update());break;case"values":if(this.isDateSelected){if("string"==typeof t.values||"number"==typeof t.values)this.setProperties({values:null},!0);else{for(var n=this.copyValues(this.values),r=0;r<n.length;r++){var l=n[r];this.checkDateValue(l)&&!e.prototype.checkPresentDate.call(this,l,n)&&n.push(l)}this.setProperties({values:n},!0),this.values.length>0&&this.setProperties({value:t.values[t.values.length-1]},!0)}this.validateValues(this.isMultiSelection,this.values),this.update()}break;case"isMultiSelection":this.isDateSelected&&(this.setProperties({isMultiSelection:t.isMultiSelection},!0),this.update());break;case"enabled":this.setEnable(this.enabled);break;case"cssClass":"calendar"===this.getModuleName()&&this.setClass(t.cssClass,i.cssClass);break;default:e.prototype.onPropertyChanged.call(this,t,i,this.isMultiSelection,this.values)}}this.preventChange=this.isAngular&&this.preventChange?!this.preventChange:this.preventChange},i.prototype.destroy=function(){if(e.prototype.destroy.call(this),"calendar"===this.getModuleName()){var i=t.closest(this.element,"form");i&&t.EventHandler.remove(i,"reset",this.formResetHandler.bind(this))}},i.prototype.navigateTo=function(t,i,s){this.minMaxUpdate(),e.prototype.navigateTo.call(this,t,i,s)},i.prototype.currentView=function(){return e.prototype.currentView.call(this)},i.prototype.addDate=function(i){if("string"!=typeof i&&"number"!=typeof i){var s=this.copyValues(this.values);if("object"==typeof i&&i.length>0)for(var a=i,n=0;n<a.length;n++)this.checkDateValue(a[n])&&!e.prototype.checkPresentDate.call(this,a[n],s)&&(!t.isNullOrUndefined(s)&&s.length>0?s.push(a[n]):s=[new Date(+a[n])]);else this.checkDateValue(i)&&!e.prototype.checkPresentDate.call(this,i,s)&&(!t.isNullOrUndefined(s)&&s.length>0?s.push(i):s=[new Date(+i)]);this.setProperties({values:s},!0),this.isMultiSelection&&this.setProperties({value:this.values[this.values.length-1]},!0),this.validateValues(this.isMultiSelection,s),this.update(),this.changedArgs={value:this.value,values:this.values},this.changeHandler()}},i.prototype.removeDate=function(e){if("string"!=typeof e&&"number"!=typeof e&&!t.isNullOrUndefined(this.values)&&this.values.length>0){var i=this.copyValues(this.values);if("object"==typeof e&&e.length>0)for(var s=e,a=0;a<s.length;a++)for(var n=0;n<i.length;n++)+i[n]==+s[a]&&i.splice(n,1);else for(n=0;n<i.length;n++)+i[n]==+e&&i.splice(n,1);this.setProperties({values:i},!1),this.update(),this.isMultiSelection&&this.setProperties({value:this.values[this.values.length-1]},!0),this.changedArgs={value:this.value,values:this.values},this.changeHandler()}},i.prototype.setTodayDate=function(t){var i=new Date(+t);this.setProperties({value:i},!0),e.prototype.todayButtonClick.call(this,null,i,!0)},i.prototype.update=function(){this.validateDate(),this.minMaxUpdate(),e.prototype.setValueUpdate.call(this)},i.prototype.selectDate=function(i,s,a){e.prototype.selectDate.call(this,i,s,a,this.isMultiSelection,this.values),this.isMultiSelection&&!t.isNullOrUndefined(this.values)&&this.values.length>0&&this.setProperties({value:this.values[this.values.length-1]},!0),this.changedArgs={value:this.value,values:this.values},this.changeHandler(i)},i.prototype.changeEvent=function(e){((this.value&&this.value.valueOf())!==(this.previousDate&&+this.previousDate.valueOf())||this.isMultiSelection)&&(this.isAngular&&this.preventChange?this.preventChange=!1:this.trigger("change",this.changedArgs),this.previousDate=new Date(+this.value))},i.prototype.triggerChange=function(e){!t.isNullOrUndefined(this.todayButtonEvent)&&this.isTodayClicked&&(e=this.todayButtonEvent,this.isTodayClicked=!1),this.changedArgs.event=e||null,this.changedArgs.isInteracted=!t.isNullOrUndefined(e),t.isNullOrUndefined(this.value)||this.setProperties({value:this.value},!0),this.isMultiSelection||+this.value===Number.NaN||+this.value==+this.previousDate&&(null!=this.previousDate||isNaN(+this.value))?t.isNullOrUndefined(this.values)||this.previousValues===this.values.length||(this.changeEvent(e),this.previousValues=this.values.length):this.changeEvent(e)},l([t.Property(null)],i.prototype,"value",void 0),l([t.Property(null)],i.prototype,"values",void 0),l([t.Property(!1)],i.prototype,"isMultiSelection",void 0),l([t.Event()],i.prototype,"change",void 0),i=l([t.NotifyPropertyChanges],i)}(E),k="e-other-month",V="e-disabled",w="e-selected",M="e-focused-date",O="e-month-hide",N=function(){function e(e){this.calendarInstance=e}return e.prototype.getModuleName=function(){return"islamic"},e.prototype.islamicTitleUpdate=function(e,i){var s=new t.Internationalization(this.calendarInstance.locale);switch(i){case"days":this.calendarInstance.headerTitleElement.textContent=s.formatDate(e,{type:"dateTime",format:"MMMMyyyy",calendar:"islamic"});break;case"months":this.calendarInstance.headerTitleElement.textContent=s.formatDate(e,{type:"dateTime",format:"yyyy",calendar:"islamic"})}},e.prototype.islamicRenderDays=function(e,i,s,a){var n,r=[],l=new Date(this.islamicInValue(e));this.islamicTitleUpdate(e,"days");var o=this.getIslamicDate(l),h=this.toGregorian(o.year,o.month,1),u=o.month;for(l=h;l.getDay()!==this.calendarInstance.firstDayOfWeek;)this.calendarInstance.setStartDate(l,-864e5);for(var d=0;d<42;++d){var p=this.calendarInstance.createElement("td",{className:"e-cell"}),c=this.calendarInstance.createElement("span");d%7==0&&this.calendarInstance.weekNumber&&(c.textContent=""+this.calendarInstance.getWeek(l),p.appendChild(c),t.addClass([p],"e-week-number"),r.push(p)),n=new Date(+l),l=this.calendarInstance.minMaxDate(l);var m={type:"dateTime",skeleton:"full",calendar:"islamic"},v=this.calendarInstance.globalize.parseDate(this.calendarInstance.globalize.formatDate(l,m),m),f=this.islamicDayCell(l),y=this.calendarInstance.globalize.formatDate(l,{type:"date",skeleton:"full",calendar:"islamic"}),g=this.calendarInstance.createElement("span");g.textContent=this.calendarInstance.globalize.formatDate(l,{type:"date",skeleton:"d",calendar:"islamic"});var b=this.calendarInstance.min>l||this.calendarInstance.max<l;b?(t.addClass([f],V),t.addClass([f],"e-overlay")):g.setAttribute("title",""+y);u!==this.getIslamicDate(l).month&&t.addClass([f],k),0!==l.getDay()&&6!==l.getDay()||t.addClass([f],"e-weekend"),f.appendChild(g),this.calendarInstance.renderDayCellArgs={date:l,isDisabled:!1,element:f,isOutOfRange:b};var D=this.calendarInstance.renderDayCellArgs;if(this.calendarInstance.renderDayCellEvent(D),D.isDisabled)if(this.calendarInstance.isMultiSelection){if(!t.isNullOrUndefined(this.calendarInstance.values)&&this.calendarInstance.values.length>0)for(var E=0;E<a.length;E++){+new Date(this.calendarInstance.globalize.formatDate(D.date,{type:"date",skeleton:"yMd",calendar:"islamic"}))===+new Date(this.calendarInstance.globalize.formatDate(this.calendarInstance.values[E],{type:"date",skeleton:"yMd",calendar:"islamic"}))&&(this.calendarInstance.values.splice(E,1),E=-1)}}else i&&+i==+D.date&&this.calendarInstance.setProperties({value:null},!0);this.calendarInstance.renderDayCellArgs.isDisabled&&!f.classList.contains(w)&&(t.addClass([f],V),t.addClass([f],"e-overlay"),+this.calendarInstance.renderDayCellArgs.date==+this.calendarInstance.todayDate&&(this.calendarInstance.todayDisabled=!0));var C=f.classList.contains(k),M=f.classList.contains(V);if(M||t.EventHandler.add(f,"click",this.calendarInstance.clickHandler,this.calendarInstance),!this.calendarInstance.isMultiSelection||t.isNullOrUndefined(this.calendarInstance.values)||C||M)C||M||!this.calendarInstance.getDateVal(l,i)?this.calendarInstance.updateFocus(C,M,l,f,e):t.addClass([f],w);else{for(var O=0;O<this.calendarInstance.values.length;O++){this.calendarInstance.globalize.formatDate(l,{type:"date",skeleton:"short",calendar:"islamic"})===this.calendarInstance.globalize.formatDate(this.calendarInstance.values[O],{type:"date",skeleton:"short",calendar:"islamic"})&&this.calendarInstance.getDateVal(l,this.calendarInstance.values[O])?t.addClass([f],w):this.calendarInstance.updateFocus(C,M,l,f,e)}this.calendarInstance.values.length<=0&&this.calendarInstance.updateFocus(C,M,l,f,e)}v.getDate()===(new Date).getDate()&&v.getMonth()===(new Date).getMonth()&&v.getFullYear()===(new Date).getFullYear()&&t.addClass([f],"e-today"),l=new Date(+n),r.push(this.calendarInstance.renderDayCellArgs.element),this.calendarInstance.addDay(l,1,null,this.calendarInstance.max,this.calendarInstance.min)}return r},e.prototype.islamicIconHandler=function(){new Date(this.islamicInValue(this.calendarInstance.currentDate)).setDate(1);var e=new Date(this.islamicInValue(this.calendarInstance.currentDate));switch(this.calendarInstance.currentView()){case"Month":var t=this.islamicCompareMonth(e,this.calendarInstance.min)<1,i=this.islamicCompareMonth(e,this.calendarInstance.max)>-1;this.calendarInstance.previousIconHandler(t),this.calendarInstance.nextIconHandler(i);break;case"Year":var s=this.hijriCompareYear(e,this.calendarInstance.min)<1,a=this.hijriCompareYear(e,this.calendarInstance.max)>-1;this.calendarInstance.previousIconHandler(s),this.calendarInstance.nextIconHandler(a);break;case"Decade":var n=this.hijriCompareDecade(e,this.calendarInstance.min)<1,r=this.hijriCompareDecade(e,this.calendarInstance.max)>-1;this.calendarInstance.previousIconHandler(n),this.calendarInstance.nextIconHandler(r)}},e.prototype.islamicNext=function(){this.calendarInstance.effect="";var e=this.calendarInstance.getViewNumber(this.calendarInstance.currentView()),t=this.getIslamicDate(this.calendarInstance.currentDate);switch(this.calendarInstance.currentView()){case"Year":this.calendarInstance.currentDate=this.toGregorian(t.year+1,t.month,1),this.calendarInstance.switchView(e);break;case"Month":this.calendarInstance.currentDate=this.toGregorian(t.year,t.month+1,1),this.calendarInstance.switchView(e);break;case"Decade":this.calendarInstance.currentDate=this.toGregorian(t.year+10,t.month,1),this.calendarInstance.switchView(e)}},e.prototype.islamicPrevious=function(){var e=this.calendarInstance.getViewNumber(this.calendarInstance.currentView());this.calendarInstance.effect="";var t=this.getIslamicDate(this.calendarInstance.currentDate);switch(this.calendarInstance.currentView()){case"Month":this.calendarInstance.currentDate=this.toGregorian(t.year,t.month-1,1),this.calendarInstance.switchView(e);break;case"Year":this.calendarInstance.currentDate=this.toGregorian(t.year-1,t.month,1),this.calendarInstance.switchView(e);break;case"Decade":this.calendarInstance.currentDate=this.toGregorian(t.year-10,t.month-1,1),this.calendarInstance.switchView(e)}},e.prototype.islamicRenderYears=function(e,i){this.calendarInstance.removeTableHeadElement();var s=[],a=t.isNullOrUndefined(i),n=new Date(this.islamicInValue(this.calendarInstance.currentDate)),r=this.getIslamicDate(n);n=t.HijriParser.toGregorian(r.year,1,1);var l=r.month,o=r.year,h=r.year,u=this.getIslamicDate(this.calendarInstance.min).year,d=this.getIslamicDate(this.calendarInstance.min).month,p=this.getIslamicDate(this.calendarInstance.max).year,c=this.getIslamicDate(this.calendarInstance.max).month;this.islamicTitleUpdate(this.calendarInstance.currentDate,"months");for(var m=1;m<=12;++m){var v=this.getIslamicDate(n);n=t.HijriParser.toGregorian(v.year,m,1);var f=this.islamicDayCell(n),y=this.calendarInstance.createElement("span"),g=i&&this.getIslamicDate(i).month===this.getIslamicDate(n).month,b=i&&this.getIslamicDate(i).year===o&&g;y.textContent=this.calendarInstance.globalize.formatDate(n,{type:"dateTime",format:"MMM",calendar:"islamic"}),this.calendarInstance.min&&(h<u||m<d&&h===u)||this.calendarInstance.max&&(h>p||m>c&&h>=p)?t.addClass([f],V):!a&&b?t.addClass([f],w):this.getIslamicDate(n).month===l&&this.getIslamicDate(this.calendarInstance.currentDate).month===l&&t.addClass([f],M),f.classList.contains(V)||t.EventHandler.add(f,"click",this.calendarInstance.clickHandler,this.calendarInstance),f.appendChild(y),s.push(f)}this.islamicRenderTemplate(s,4,"e-year",e,i)},e.prototype.islamicRenderDecade=function(e,i){this.calendarInstance.removeTableHeadElement();var s=[],a=new Date(this.islamicInValue(this.calendarInstance.currentDate)),n=this.getIslamicDate(a),r=(a=t.HijriParser.toGregorian(n.year,1,1)).getFullYear(),l=new Date(this.islamicInValue(r-r%10)),o=new Date(this.islamicInValue(r-r%10+9)),h=l.getFullYear(),u=o.getFullYear(),d=this.calendarInstance.globalize.formatDate(l,{type:"dateTime",format:"y",calendar:"islamic"}),p=this.calendarInstance.globalize.formatDate(o,{type:"dateTime",format:"y",calendar:"islamic"});this.calendarInstance.headerTitleElement.textContent=d+" - "+p;for(var c=new Date(r-r%10-2,0,1).getFullYear(),m=1;m<=12;++m){var v=c+m;a.setFullYear(v),a.setDate(1),a.setMonth(0);var f=this.getIslamicDate(a);a=t.HijriParser.toGregorian(f.year,1,1);var y=this.islamicDayCell(a);t.attributes(y,{role:"gridcell"});var g=this.calendarInstance.createElement("span");g.textContent=this.calendarInstance.globalize.formatDate(a,{type:"dateTime",format:"y",calendar:"islamic"}),v<h||v>u?t.addClass([y],k):v<new Date(this.islamicInValue(this.calendarInstance.min)).getFullYear()||v>new Date(this.islamicInValue(this.calendarInstance.max)).getFullYear()?t.addClass([y],V):t.isNullOrUndefined(i)||this.getIslamicDate(a).year!==this.getIslamicDate(i).year?a.getFullYear()!==this.calendarInstance.currentDate.getFullYear()||y.classList.contains(V)||t.addClass([y],M):t.addClass([y],w),y.classList.contains(V)||t.EventHandler.add(y,"click",this.calendarInstance.clickHandler,this.calendarInstance),y.appendChild(g),s.push(y)}this.islamicRenderTemplate(s,4,"e-decade",e,i)},e.prototype.islamicDayCell=function(e){var i={skeleton:"full",type:"dateTime",calendar:"islamic"},s=this.calendarInstance.globalize.formatDate(e,i),a=this.calendarInstance.globalize.parseDate(s,i).valueOf(),n={className:"e-cell",attrs:{id:""+t.getUniqueID(""+a),"aria-selected":"false",role:"gridcell"}};return this.calendarInstance.createElement("td",n)},e.prototype.islamicRenderTemplate=function(e,i,s,a,n){var r,l=this.calendarInstance.getViewNumber(this.calendarInstance.currentView());this.calendarInstance.tableBodyElement=this.calendarInstance.createElement("tbody"),this.calendarInstance.table.appendChild(this.calendarInstance.tableBodyElement),t.removeClass([this.calendarInstance.contentElement,this.calendarInstance.headerElement],["e-month","e-decade","e-year"]),t.addClass([this.calendarInstance.contentElement,this.calendarInstance.headerElement],[s]);for(var o=i,h=0,u=0;u<e.length/i;++u){for(r=this.calendarInstance.createElement("tr",{attrs:{role:"row"}}),h=0+h;h<o;h++)e[h].classList.contains("e-week-number")||t.isNullOrUndefined(e[h].children[0])||(t.addClass([e[h].children[0]],["e-day"]),t.rippleEffect(e[h].children[0],{duration:600,isCenterRipple:!0})),r.appendChild(e[h]),this.calendarInstance.weekNumber&&7===h&&e[7].classList.contains(k)&&t.addClass([r],O),!this.calendarInstance.weekNumber&&6===h&&e[6].classList.contains(k)&&t.addClass([r],O),this.calendarInstance.weekNumber?41===h&&e[41].classList.contains(k)&&t.addClass([r],O):35===h&&e[35].classList.contains(k)&&t.addClass([r],O);o+=i,h+=0,this.calendarInstance.tableBodyElement.appendChild(r)}this.calendarInstance.table.querySelector("tbody").className=this.calendarInstance.effect,this.islamicIconHandler(),(l!==this.calendarInstance.getViewNumber(this.calendarInstance.currentView())||0===l&&l!==this.calendarInstance.getViewNumber(this.calendarInstance.currentView()))&&this.calendarInstance.navigateHandler(a),this.calendarInstance.setAriaActiveDescendant(),this.calendarInstance.changedArgs={value:this.calendarInstance.value,values:this.calendarInstance.values},this.calendarInstance.changeHandler()},e.prototype.islamicCompareMonth=function(e,t){var i=this.getIslamicDate(e),s=this.getIslamicDate(t);return i.year>s.year?1:i.year<s.year?-1:i.month===s.month?0:i.month>s.month?1:-1},e.prototype.islamicCompare=function(e,t,i){var s,a,n=this.getIslamicDate(e),r=this.getIslamicDate(t).year;return s=r,a=0,i&&(s=(r-=r%i)-r%i+i-1),n.year>s?a=1:"Decade"===this.calendarInstance.currentView()&&n.year<r&&!(e.getFullYear()>=2060&&e.getFullYear()<=2069)?a=-1:n.year<r&&"Year"===this.calendarInstance.currentView()&&(a=-1),a},e.prototype.getIslamicDate=function(e){return t.HijriParser.getHijriDate(e)},e.prototype.toGregorian=function(e,i,s){return t.HijriParser.toGregorian(e,i,s)},e.prototype.hijriCompareYear=function(e,t){return this.islamicCompare(e,t,0)},e.prototype.hijriCompareDecade=function(e,t){return this.islamicCompare(e,t,10)},e.prototype.destroy=function(){this.calendarInstance=null},e.prototype.islamicInValue=function(e){return e instanceof Date?e.toUTCString():""+e},e}(),I=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),T=function(e,t,i,s){var a,n=arguments.length,r=n<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(e,t,i,s);else for(var l=e.length-1;l>=0;l--)(a=e[l])&&(r=(n<3?a(r):n>3?a(t,i,r):a(t,i))||r);return n>3&&r&&Object.defineProperty(t,i,r),r},x="e-datepicker",P="e-popup-wrapper",A="e-input-focus",S="e-active",U="e-date-overflow",H="e-selected",W="e-non-edit",L=["title","class","style"],F=function(e){function a(t,i){var s=e.call(this,t,i)||this;return s.previousElementValue="",s.isDateIconClicked=!1,s.isAltKeyPressed=!1,s.isInteracted=!0,s.invalidValueString=null,s.checkPreviousValue=null,s.maskedDateValue="",s.isAngular=!1,s.preventChange=!1,s.isIconClicked=!1,s.isDynamicValueChanged=!1,s.moduleName=s.getModuleName(),s.datepickerOptions=t,s}return I(a,e),a.prototype.render=function(){this.initialize(),this.bindEvents(),this.renderComplete(),this.setTimeZone(this.serverTimezoneOffset)},a.prototype.setTimeZone=function(e){if(!t.isNullOrUndefined(this.serverTimezoneOffset)&&this.value){var i=e+(new Date).getTimezoneOffset()/60;i=this.isDayLightSaving()?i--:i,this.value=new Date(this.value.getTime()+60*i*60*1e3),this.updateInput()}},a.prototype.isDayLightSaving=function(){var e=new Date(this.value.getFullYear(),0,1).getTimezoneOffset(),t=new Date(this.value.getFullYear(),6,1).getTimezoneOffset();return this.value.getTimezoneOffset()<Math.max(e,t)},a.prototype.setAllowEdit=function(){this.allowEdit?this.readonly||this.inputElement.removeAttribute("readonly"):t.attributes(this.inputElement,{readonly:""}),this.updateIconState()},a.prototype.updateIconState=function(){this.allowEdit||!this.inputWrapper||this.readonly?this.inputWrapper&&t.removeClass([this.inputWrapper.container],[W]):""===this.inputElement.value?t.removeClass([this.inputWrapper.container],[W]):t.addClass([this.inputWrapper.container],[W])},a.prototype.initialize=function(){this.checkInvalidValue(this.value),this.enableMask&&this.notify("createMask",{module:"MaskedDateTime"}),this.createInput(),this.updateHtmlAttributeToWrapper(),this.setAllowEdit(),this.updateInput(),!this.enableMask||this.value||!this.maskedDateValue||"Always"!=this.floatLabelType&&this.floatLabelType&&this.placeholder||this.updateInputValue(this.maskedDateValue),this.previousElementValue=this.inputElement.value,this.previousDate=t.isNullOrUndefined(this.value)?null:new Date(+this.value),this.inputElement.setAttribute("value",this.inputElement.value),this.inputValueCopy=this.value},a.prototype.createInput=function(){var e={"aria-live":"assertive","aria-atomic":"true","aria-haspopup":"true","aria-activedescendant":"null","aria-owns":this.element.id+"_options","aria-expanded":"false",role:"combobox",autocomplete:"off",autocorrect:"off",autocapitalize:"off",spellcheck:"false","aria-invalid":"false"};if("datepicker"===this.getModuleName()){var i={placeholder:this.placeholder};this.globalize=new t.Internationalization(this.locale),this.l10n=new t.L10n("datepicker",i,this.locale),this.setProperties({placeholder:this.placeholder||this.l10n.getConstant("placeholder")},!0)}var a=this.cssClass;t.isNullOrUndefined(this.cssClass)||""===this.cssClass||(a=this.cssClass.replace(/\s+/g," ").trim());var n=!this.enableMask;this.inputWrapper=s.Input.createInput({element:this.inputElement,floatLabelType:this.floatLabelType,bindClearAction:n,properties:{readonly:this.readonly,placeholder:this.placeholder,cssClass:a,enabled:this.enabled,enableRtl:this.enableRtl,showClearButton:this.showClearButton},buttons:["e-input-group-icon e-date-icon e-icons"]},this.createElement),this.setWidth(this.width),""!==this.inputElement.name?this.inputElement.setAttribute("name",""+this.inputElement.getAttribute("name")):this.inputElement.setAttribute("name",""+this.element.id),t.attributes(this.inputElement,e),this.enabled?(this.inputElement.setAttribute("aria-disabled","false"),this.inputElement.setAttribute("tabindex",this.tabIndex)):(this.inputElement.setAttribute("aria-disabled","true"),this.inputElement.tabIndex=-1),s.Input.addAttributes({"aria-label":"select"},this.inputWrapper.buttons[0]),t.addClass([this.inputWrapper.container],"e-date-wrapper")},a.prototype.updateInput=function(i){void 0===i&&(i=!1);var s;if(!this.value||this.isCalendar()||i||this.disabledDates(),isNaN(+new Date(this.checkValue(this.value)))&&this.setProperties({value:null},!0),this.strictMode&&(e.prototype.validateDate.call(this),this.minMaxUpdates(),e.prototype.minMaxUpdate.call(this)),!t.isNullOrUndefined(this.value)){var a=this.value,n=void 0,r=t.isNullOrUndefined(this.formatString)?this.dateTimeFormat:this.formatString;if("datetimepicker"===this.getModuleName()?n="Gregorian"===this.calendarMode?this.globalize.formatDate(this.value,{format:r,type:"dateTime",skeleton:"yMd"}):this.globalize.formatDate(this.value,{format:r,type:"dateTime",skeleton:"yMd",calendar:"islamic"}):(s="Gregorian"===this.calendarMode?{format:this.formatString,type:"dateTime",skeleton:"yMd"}:{format:this.formatString,type:"dateTime",skeleton:"yMd",calendar:"islamic"},n=this.globalize.formatDate(this.value,s)),+a<=+this.max&&+a>=+this.min)this.updateInputValue(n);else{var l=+a>=+this.max||!+this.value||!+this.value||+a<=+this.min;!this.strictMode&&l&&this.updateInputValue(n)}}t.isNullOrUndefined(this.value)&&this.strictMode&&(this.enableMask?(this.updateInputValue(this.maskedDateValue),this.notify("createMask",{module:"MaskedDateTime"})):this.updateInputValue("")),!this.strictMode&&t.isNullOrUndefined(this.value)&&this.invalidValueString&&this.updateInputValue(this.invalidValueString),this.changedArgs={value:this.value},this.errorClass(),this.updateIconState()},a.prototype.minMaxUpdates=function(){!t.isNullOrUndefined(this.value)&&this.value<this.min&&this.min<=this.max&&this.strictMode?(this.setProperties({value:this.min},!0),this.changedArgs={value:this.value}):!t.isNullOrUndefined(this.value)&&this.value>this.max&&this.min<=this.max&&this.strictMode&&(this.setProperties({value:this.max},!0),this.changedArgs={value:this.value})},a.prototype.checkStringValue=function(e){var i=null,s=null,a=null;if("datetimepicker"===this.getModuleName()){var n=new t.Internationalization(this.locale);"Gregorian"===this.calendarMode?(s={format:this.dateTimeFormat,type:"dateTime",skeleton:"yMd"},a={format:n.getDatePattern({skeleton:"yMd"}),type:"dateTime"}):(s={format:this.dateTimeFormat,type:"dateTime",skeleton:"yMd",calendar:"islamic"},a={format:n.getDatePattern({skeleton:"yMd"}),type:"dateTime",calendar:"islamic"})}else s="Gregorian"===this.calendarMode?{format:this.formatString,type:"dateTime",skeleton:"yMd"}:{format:this.formatString,type:"dateTime",skeleton:"yMd",calendar:"islamic"};return i=this.checkDateValue(this.globalize.parseDate(e,s)),t.isNullOrUndefined(i)&&"datetimepicker"===this.getModuleName()&&(i=this.checkDateValue(this.globalize.parseDate(e,a))),i},a.prototype.checkInvalidValue=function(e){if(!(e instanceof Date||t.isNullOrUndefined(e))){var i=null,s=e;"number"==typeof e&&(s=e.toString());if("datetimepicker"===this.getModuleName()){var a=new t.Internationalization(this.locale);"Gregorian"===this.calendarMode?({format:this.dateTimeFormat,type:"dateTime",skeleton:"yMd"},{format:a.getDatePattern({skeleton:"yMd"}),type:"dateTime"}):({format:this.dateTimeFormat,type:"dateTime",skeleton:"yMd",calendar:"islamic"},{format:a.getDatePattern({skeleton:"yMd"}),type:"dateTime",calendar:"islamic"})}else"Gregorian"===this.calendarMode?{format:this.formatString,type:"dateTime",skeleton:"yMd"}:{format:this.formatString,type:"dateTime",skeleton:"yMd",calendar:"islamic"};var n=!1;if("string"!=typeof s)s=null,n=!0;else if("string"==typeof s&&(s=s.trim()),!(i=this.checkStringValue(s))){var r=null;r=/^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/,!/^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/.test(s)&&!r.test(s)||/^[a-zA-Z0-9- ]*$/.test(s)||isNaN(+new Date(this.checkValue(s)))?n=!0:i=new Date(s)}n?(this.strictMode||(this.invalidValueString=s),this.setProperties({value:null},!0)):this.setProperties({value:i},!0)}},a.prototype.bindInputEvent=function(){t.isNullOrUndefined(this.formatString)&&!this.enableMask||(this.enableMask||-1===this.formatString.indexOf("y")?t.EventHandler.add(this.inputElement,"input",this.inputHandler,this):t.EventHandler.remove(this.inputElement,"input",this.inputHandler))},a.prototype.bindEvents=function(){t.EventHandler.add(this.inputWrapper.buttons[0],"mousedown touchstart",this.dateIconHandler,this),t.EventHandler.add(this.inputElement,"mouseup",this.mouseUpHandler,this),t.EventHandler.add(this.inputElement,"focus",this.inputFocusHandler,this),t.EventHandler.add(this.inputElement,"blur",this.inputBlurHandler,this),this.enableMask&&t.EventHandler.add(this.inputElement,"keydown",this.keydownHandler,this),this.bindInputEvent(),t.EventHandler.add(this.inputElement,"change",this.inputChangeHandler,this),this.showClearButton&&this.inputWrapper.clearButton&&t.EventHandler.add(this.inputWrapper.clearButton,"mousedown touchstart",this.resetHandler,this),this.formElement&&t.EventHandler.add(this.formElement,"reset",this.resetFormHandler,this),this.defaultKeyConfigs=t.extend(this.defaultKeyConfigs,this.keyConfigs),this.keyboardModules=new t.KeyboardEvents(this.inputElement,{eventName:"keydown",keyAction:this.inputKeyActionHandle.bind(this),keyConfigs:this.defaultKeyConfigs})},a.prototype.keydownHandler=function(e){switch(e.code){case"ArrowLeft":case"ArrowRight":case"ArrowUp":case"ArrowDown":case"Home":case"End":case"Delete":!this.enableMask||this.popupObj||this.readonly||("Delete"!==e.code&&e.preventDefault(),this.notify("keyDownHandler",{module:"MaskedDateTime",e:e}))}},a.prototype.unBindEvents=function(){t.EventHandler.remove(this.inputWrapper.buttons[0],"mousedown touchstart",this.dateIconHandler),t.EventHandler.remove(this.inputElement,"mouseup",this.mouseUpHandler),t.EventHandler.remove(this.inputElement,"focus",this.inputFocusHandler),t.EventHandler.remove(this.inputElement,"blur",this.inputBlurHandler),t.EventHandler.remove(this.inputElement,"change",this.inputChangeHandler),this.enableMask&&t.EventHandler.remove(this.inputElement,"keydown",this.keydownHandler),this.showClearButton&&this.inputWrapper.clearButton&&t.EventHandler.remove(this.inputWrapper.clearButton,"mousedown touchstart",this.resetHandler),this.formElement&&t.EventHandler.remove(this.formElement,"reset",this.resetFormHandler)},a.prototype.resetFormHandler=function(){if(this.enabled&&!this.inputElement.disabled){var e=this.inputElement.getAttribute("value");"EJS-DATEPICKER"!==this.element.tagName&&"EJS-DATETIMEPICKER"!==this.element.tagName||(e="",this.inputValueCopy=null,this.inputElement.setAttribute("value","")),this.setProperties({value:this.inputValueCopy},!0),this.restoreValue(),this.inputElement&&(this.updateInputValue(e),this.errorClass())}},a.prototype.restoreValue=function(){this.currentDate=this.value?this.value:new Date,this.previousDate=this.value,this.previousElementValue=t.isNullOrUndefined(this.inputValueCopy)?"":this.globalize.formatDate(this.inputValueCopy,{format:this.formatString,type:"dateTime",skeleton:"yMd"})},a.prototype.inputChangeHandler=function(e){this.enabled&&e.stopPropagation()},a.prototype.bindClearEvent=function(){this.showClearButton&&this.inputWrapper.clearButton&&t.EventHandler.add(this.inputWrapper.clearButton,"mousedown touchstart",this.resetHandler,this)},a.prototype.resetHandler=function(e){this.enabled&&(e.preventDefault(),this.clear(e))},a.prototype.mouseUpHandler=function(e){this.enableMask&&(e.preventDefault(),this.notify("setMaskSelection",{module:"MaskedDateTime"}))},a.prototype.clear=function(e){this.setProperties({value:null},!0),this.enableMask||this.updateInputValue("");var t={event:e};this.trigger("cleared",t),this.invalidValueString="",this.updateInput(),this.popupUpdate(),this.changeEvent(e),this.enableMask&&this.notify("clearHandler",{module:"MaskedDateTime"})},a.prototype.preventEventBubbling=function(e){e.preventDefault(),this.interopAdaptor.invokeMethodAsync("OnDateIconClick")},a.prototype.updateInputValue=function(e){s.Input.setValue(e,this.inputElement,this.floatLabelType,this.showClearButton)},a.prototype.dateIconHandler=function(e){this.enabled&&(this.isIconClicked=!0,t.Browser.isDevice&&(this.inputElement.setAttribute("readonly",""),this.inputElement.blur()),e.preventDefault(),this.readonly||(this.isCalendar()?this.hide(e):(this.isDateIconClicked=!0,this.show(null,e),"datetimepicker"===this.getModuleName()&&this.inputElement.focus(),this.inputElement.focus(),t.addClass([this.inputWrapper.container],[A]),t.addClass(this.inputWrapper.buttons,S))),this.isIconClicked=!1)},a.prototype.updateHtmlAttributeToWrapper=function(){if(!t.isNullOrUndefined(this.htmlAttributes))for(var e=0,i=Object.keys(this.htmlAttributes);e<i.length;e++){var s=i[e];if(!t.isNullOrUndefined(this.htmlAttributes[s])&&L.indexOf(s)>-1)if("class"===s){var a=this.htmlAttributes[s].replace(/\s+/g," ").trim();""!==a&&t.addClass([this.inputWrapper.container],a.split(" "))}else if("style"===s){var n=this.inputWrapper.container.getAttribute(s);t.isNullOrUndefined(n)?n=this.htmlAttributes[s]:";"===n.charAt(n.length-1)?n+=this.htmlAttributes[s]:n=n+";"+this.htmlAttributes[s],this.inputWrapper.container.setAttribute(s,n)}else this.inputWrapper.container.setAttribute(s,this.htmlAttributes[s])}},a.prototype.updateHtmlAttributeToElement=function(){if(!t.isNullOrUndefined(this.htmlAttributes))for(var e=0,i=Object.keys(this.htmlAttributes);e<i.length;e++){var s=i[e];L.indexOf(s)<0&&this.inputElement.setAttribute(s,this.htmlAttributes[s])}},a.prototype.updateCssClass=function(e,i){t.isNullOrUndefined(i)||(i=i.replace(/\s+/g," ").trim()),t.isNullOrUndefined(e)||(e=e.replace(/\s+/g," ").trim()),s.Input.setCssClass(e,[this.inputWrapper.container],i),this.popupWrapper&&s.Input.setCssClass(e,[this.popupWrapper],i)},a.prototype.calendarKeyActionHandle=function(e){switch(e.action){case"escape":this.isCalendar()?this.hide(e):this.inputWrapper.container.children[this.index].blur();break;case"enter":this.isCalendar()?+this.value==+this.currentDate||this.isCalendar()||this.inputWrapper.container.children[this.index].focus():this.show(null,e),"datetimepicker"===this.getModuleName()&&this.inputElement.focus();break;case"tab":this.hide(e)}},a.prototype.inputFocusHandler=function(){if(this.enabled){this.enableMask&&!this.inputElement.value&&this.placeholder&&(!this.maskedDateValue||this.value||"Auto"!=this.floatLabelType&&"Never"!=this.floatLabelType&&!this.placeholder||(this.updateInputValue(this.maskedDateValue),this.inputElement.selectionStart=0,this.inputElement.selectionEnd=this.inputElement.value.length));var e={model:this};this.isDateIconClicked=!1,this.trigger("focus",e),this.updateIconState(),this.openOnFocus&&!this.isIconClicked&&this.show()}},a.prototype.inputHandler=function(){this.isPopupClicked=!1,this.enableMask&&this.notify("inputHandler",{module:"MaskedDateTime"})},a.prototype.inputBlurHandler=function(e){if(this.enabled){if(this.strictModeUpdate(),""===this.inputElement.value&&t.isNullOrUndefined(this.value)&&(this.invalidValueString=null,this.updateInputValue("")),this.updateInput(),this.popupUpdate(),this.changeTrigger(e),this.enableMask&&this.maskedDateValue&&this.placeholder&&"Always"!==this.floatLabelType&&(this.inputElement.value!=this.maskedDateValue||this.value||"Auto"!=this.floatLabelType&&"Never"!=this.floatLabelType&&!this.placeholder||this.updateInputValue("")),this.errorClass(),this.isCalendar()&&document.activeElement===this.inputElement&&this.hide(e),"datepicker"===this.getModuleName()){var i={model:this};this.trigger("blur",i)}this.isCalendar()&&(this.defaultKeyConfigs=t.extend(this.defaultKeyConfigs,this.keyConfigs),this.calendarKeyboardModules=new t.KeyboardEvents(this.calendarElement.children[1].firstElementChild,{eventName:"keydown",keyAction:this.calendarKeyActionHandle.bind(this),keyConfigs:this.defaultKeyConfigs})),this.isPopupClicked=!1}},a.prototype.documentHandler=function(i){!t.isNullOrUndefined(this.popupObj)&&(this.inputWrapper.container.contains(i.target)||this.popupObj.element&&this.popupObj.element.contains(i.target))&&"touchstart"!==i.type&&i.preventDefault();var s=i.target;t.closest(s,".e-datepicker.e-popup-wrapper")||t.closest(s,".e-input-group")===this.inputWrapper.container||s.classList.contains("e-day")?t.closest(s,".e-datepicker.e-popup-wrapper")&&(s.classList.contains("e-day")&&!t.isNullOrUndefined(i.target.parentElement)&&i.target.parentElement.classList.contains("e-selected")&&t.closest(s,".e-content")&&t.closest(s,".e-content").classList.contains("e-"+this.depth.toLowerCase())?this.hide(i):t.closest(s,".e-footer-container")&&s.classList.contains("e-today")&&s.classList.contains("e-btn")&&+new Date(+this.value)==+e.prototype.generateTodayVal.call(this,this.value)&&this.hide(i)):(this.hide(i),this.focusOut())},a.prototype.inputKeyActionHandle=function(e){var t=this.currentView();switch(e.action){case"altUpArrow":this.isAltKeyPressed=!1,this.hide(e),this.inputElement.focus();break;case"altDownArrow":this.isAltKeyPressed=!0,this.strictModeUpdate(),this.updateInput(),this.changeTrigger(e),"datepicker"===this.getModuleName()&&this.show(null,e);break;case"escape":this.hide(e);break;case"enter":this.strictModeUpdate(),this.updateInput(),this.popupUpdate(),this.changeTrigger(e),this.errorClass(),this.isCalendar()||document.activeElement!==this.inputElement||this.hide(e),this.isCalendar()&&(e.preventDefault(),e.stopPropagation());break;case"tab":case"shiftTab":var i=this.inputElement.selectionStart,s=this.inputElement.selectionEnd;if(this.enableMask&&!this.popupObj&&!this.readonly){var a=this.inputElement.value.length;(0==i&&s==a||s!==a&&"tab"==e.action||0!==i&&"shiftTab"==e.action)&&e.preventDefault(),this.notify("keyDownHandler",{module:"MaskedDateTime",e:e}),i=this.inputElement.selectionStart,s=this.inputElement.selectionEnd}this.strictModeUpdate(),this.updateInput(),this.popupUpdate(),this.changeTrigger(e),this.errorClass(),this.enableMask&&(this.inputElement.selectionStart=i,this.inputElement.selectionEnd=s),this.hide(e);break;default:this.defaultAction(e),"select"===e.action&&t===this.depth&&this.hide(e)}},a.prototype.defaultAction=function(i){this.previousDate=!t.isNullOrUndefined(this.value)&&new Date(+this.value)||null,this.isCalendar()&&(e.prototype.keyActionHandle.call(this,i),this.isCalendar()&&t.attributes(this.inputElement,{"aria-activedescendant":""+this.setActiveDescendant()}))},a.prototype.popupUpdate=function(){if((t.isNullOrUndefined(this.value)&&!t.isNullOrUndefined(this.previousDate)||+this.value!=+this.previousDate)&&(this.popupObj&&this.popupObj.element.querySelectorAll("."+H).length>0&&t.removeClass(this.popupObj.element.querySelectorAll("."+H),[H]),!t.isNullOrUndefined(this.value)&&+this.value>=+this.min&&+this.value<=+this.max)){var i=new Date(this.checkValue(this.value));e.prototype.navigateTo.call(this,"Month",i)}},a.prototype.strictModeUpdate=function(){var e,i;if(e="datetimepicker"===this.getModuleName()?t.isNullOrUndefined(this.formatString)?this.dateTimeFormat:this.formatString:t.isNullOrUndefined(this.formatString)?this.formatString:this.formatString.replace("dd","d"),!t.isNullOrUndefined(e)){e.split("M").length-1<3&&(e=e.replace("MM","M"))}var s;s="datetimepicker"===this.getModuleName()?"Gregorian"===this.calendarMode?{format:t.isNullOrUndefined(this.formatString)?this.dateTimeFormat:this.formatString,type:"dateTime",skeleton:"yMd"}:{format:t.isNullOrUndefined(this.formatString)?this.dateTimeFormat:this.formatString,type:"dateTime",skeleton:"yMd",calendar:"islamic"}:i="Gregorian"===this.calendarMode?{format:e,type:"dateTime",skeleton:"yMd"}:{format:e,type:"dateTime",skeleton:"yMd",calendar:"islamic"};var a;"string"==typeof this.inputElement.value&&(this.inputElement.value=this.inputElement.value.trim()),"datetimepicker"===this.getModuleName()?this.checkDateValue(this.globalize.parseDate(this.inputElement.value,s))?a=this.globalize.parseDate(this.inputElement.value,s):(i="Gregorian"===this.calendarMode?{type:"dateTime",skeleton:"yMd"}:{type:"dateTime",skeleton:"yMd",calendar:"islamic"},a=this.globalize.parseDate(this.inputElement.value,i)):(a=this.globalize.parseDate(this.inputElement.value,s),a=!t.isNullOrUndefined(a)&&isNaN(+a)?null:a,!t.isNullOrUndefined(this.formatString)&&""!==this.inputElement.value&&this.strictMode&&(this.isPopupClicked||!this.isPopupClicked&&this.inputElement.value===this.previousElementValue)&&-1===this.formatString.indexOf("y")&&a.setFullYear(this.value.getFullYear())),"datepicker"===this.getModuleName()&&this.value&&!isNaN(+this.value)&&a&&a.setHours(this.value.getHours(),this.value.getMinutes(),this.value.getSeconds(),this.value.getMilliseconds()),this.strictMode&&a?(this.updateInputValue(this.globalize.formatDate(a,s)),this.inputElement.value!==this.previousElementValue&&this.setProperties({value:a},!0)):this.strictMode||this.inputElement.value!==this.previousElementValue&&this.setProperties({value:a},!0),this.strictMode&&!a&&""===this.inputElement.value&&this.setProperties({value:null},!0),isNaN(+this.value)&&this.setProperties({value:null},!0),t.isNullOrUndefined(this.value)&&(this.currentDate=new Date((new Date).setHours(0,0,0,0)))},a.prototype.createCalendar=function(){var e=this;this.popupWrapper=this.createElement("div",{className:x+" "+P}),t.isNullOrUndefined(this.cssClass)||(this.popupWrapper.className+=" "+this.cssClass),t.Browser.isDevice&&(this.modelHeader(),this.modal=this.createElement("div"),this.modal.className=x+" e-date-modal",document.body.className+=" "+U,this.modal.style.display="block",document.body.appendChild(this.modal)),this.calendarElement.querySelector("table tbody").className="",this.popupObj=new i.Popup(this.popupWrapper,{content:this.calendarElement,relateTo:t.Browser.isDevice?document.body:this.inputWrapper.container,position:t.Browser.isDevice?{X:"center",Y:"center"}:{X:"left",Y:"bottom"},offsetY:4,targetType:"container",enableRtl:this.enableRtl,zIndex:this.zIndex,collision:t.Browser.isDevice?{X:"fit",Y:"fit"}:{X:"flip",Y:"flip"},open:function(){"datetimepicker"!==e.getModuleName()&&document.activeElement!==e.inputElement&&(e.defaultKeyConfigs=t.extend(e.defaultKeyConfigs,e.keyConfigs),e.calendarElement.children[1].firstElementChild.focus(),e.calendarKeyboardModules=new t.KeyboardEvents(e.calendarElement.children[1].firstElementChild,{eventName:"keydown",keyAction:e.calendarKeyActionHandle.bind(e),keyConfigs:e.defaultKeyConfigs}),e.calendarKeyboardModules=new t.KeyboardEvents(e.inputWrapper.container.children[e.index],{eventName:"keydown",keyAction:e.calendarKeyActionHandle.bind(e),keyConfigs:e.defaultKeyConfigs}))},close:function(){e.isDateIconClicked&&e.inputWrapper.container.children[e.index].focus(),e.value&&e.disabledDates(),e.popupObj&&e.popupObj.destroy(),e.resetCalendar(),t.detach(e.popupWrapper),e.popupObj=e.popupWrapper=null,e.preventArgs=null,e.calendarKeyboardModules=null,e.setAriaAttributes()},targetExitViewport:function(){t.Browser.isDevice||e.hide()}}),this.popupObj.element.className+=" "+this.cssClass,this.setAriaAttributes()},a.prototype.setAriaDisabled=function(){this.enabled?(this.inputElement.setAttribute("aria-disabled","false"),this.inputElement.setAttribute("tabindex",this.tabIndex)):(this.inputElement.setAttribute("aria-disabled","true"),this.inputElement.tabIndex=-1)},a.prototype.modelHeader=function(){var e,t=this.createElement("div",{className:"e-model-header"}),i=this.createElement("h1",{className:"e-model-year"}),s=this.createElement("div"),a=this.createElement("span",{className:"e-model-day"}),n=this.createElement("span",{className:"e-model-month"});e="Gregorian"===this.calendarMode?{format:"y",skeleton:"dateTime"}:{format:"y",skeleton:"dateTime",calendar:"islamic"},i.textContent=""+this.globalize.formatDate(this.value||new Date,e),e="Gregorian"===this.calendarMode?{format:"E",skeleton:"dateTime"}:{format:"E",skeleton:"dateTime",calendar:"islamic"},a.textContent=this.globalize.formatDate(this.value||new Date,e)+", ",e="Gregorian"===this.calendarMode?{format:"MMM d",skeleton:"dateTime"}:{format:"MMM d",skeleton:"dateTime",calendar:"islamic"},n.textContent=""+this.globalize.formatDate(this.value||new Date,e),t.appendChild(i),s.appendChild(a),s.appendChild(n),t.appendChild(s),this.calendarElement.insertBefore(t,this.calendarElement.firstElementChild)},a.prototype.changeTrigger=function(e){this.inputElement.value!==this.previousElementValue&&(this.previousDate&&this.previousDate.valueOf())!==(this.value&&this.value.valueOf())&&(this.isDynamicValueChanged&&this.isCalendar()&&this.popupUpdate(),this.changedArgs.value=this.value,this.changedArgs.event=e||null,this.changedArgs.element=this.element,this.changedArgs.isInteracted=!t.isNullOrUndefined(e),this.isAngular&&this.preventChange?this.preventChange=!1:this.trigger("change",this.changedArgs),this.previousElementValue=this.inputElement.value,this.previousDate=isNaN(+new Date(this.checkValue(this.value)))?null:new Date(this.checkValue(this.value)),this.isInteracted=!0)},a.prototype.navigatedEvent=function(){this.trigger("navigated",this.navigatedArgs)},a.prototype.changeEvent=function(e){(this.previousDate&&this.previousDate.valueOf())!==(this.value&&this.value.valueOf())&&(this.selectCalendar(e),this.changedArgs.event=e||null,this.changedArgs.element=this.element,this.changedArgs.isInteracted=this.isInteracted,this.isDynamicValueChanged||this.trigger("change",this.changedArgs),this.previousDate=this.value&&new Date(+this.value),this.isDynamicValueChanged||this.hide(e),this.previousElementValue=this.inputElement.value,this.errorClass())},a.prototype.requiredModules=function(){var e=[];return this&&e.push({args:[this],member:"islamic"}),this.enableMask&&e.push({args:[this],member:"MaskedDateTime"}),e},a.prototype.selectCalendar=function(e){var i,s,a;s="datetimepicker"===this.getModuleName()&&t.isNullOrUndefined(this.formatString)?this.dateTimeFormat:this.formatString,this.value&&("datetimepicker"===this.getModuleName()?(a="Gregorian"===this.calendarMode?{format:s,type:"dateTime",skeleton:"yMd"}:{format:s,type:"dateTime",skeleton:"yMd",calendar:"islamic"},i=this.globalize.formatDate(this.changedArgs.value,a)):(a="Gregorian"===this.calendarMode?{format:this.formatString,type:"dateTime",skeleton:"yMd"}:{format:this.formatString,type:"dateTime",skeleton:"yMd",calendar:"islamic"},i=this.globalize.formatDate(this.changedArgs.value,a)),this.enableMask&&this.notify("createMask",{module:"MaskedDateTime"})),t.isNullOrUndefined(i)||(this.updateInputValue(i),this.enableMask&&this.notify("setMaskSelection",{module:"MaskedDateTime"}))},a.prototype.isCalendar=function(){return!(!this.popupWrapper||!this.popupWrapper.classList.contains(""+P))},a.prototype.setWidth=function(e){this.inputWrapper.container.style.width="number"==typeof e?t.formatUnit(this.width):"string"==typeof e?e.match(/px|%|em/)?this.width:t.formatUnit(this.width):"100%"},a.prototype.show=function(i,s){var a=this;if(!(this.enabled&&this.readonly||!this.enabled||this.popupObj)){var n=!0,r=void 0;t.isNullOrUndefined(this.value)||+this.value>=+this.min&&+this.value<=+this.max?r=this.value||null:(r=new Date(this.checkValue(this.value)),this.setProperties({value:null},!0)),this.isCalendar()||(e.prototype.render.call(this),this.setProperties({value:r||null},!0),this.previousDate=r,this.createCalendar()),t.Browser.isDevice&&(this.mobilePopupWrapper=this.createElement("div",{className:"e-datepick-mob-popup-wrap"}),document.body.appendChild(this.mobilePopupWrapper)),this.preventArgs={preventDefault:function(){n=!1},popup:this.popupObj,event:s||null,cancel:!1,appendTo:t.Browser.isDevice?this.mobilePopupWrapper:document.body};var l=this.preventArgs;this.trigger("open",l,function(i){if(a.preventArgs=i,n&&!a.preventArgs.cancel){t.addClass(a.inputWrapper.buttons,S),a.preventArgs.appendTo.appendChild(a.popupWrapper),a.popupObj.refreshPosition(a.inputElement);var s={name:"FadeIn",duration:t.Browser.isDevice?0:300};1e3===a.zIndex?a.popupObj.show(new t.Animation(s),a.element):a.popupObj.show(new t.Animation(s),null),e.prototype.setOverlayIndex.call(a,a.mobilePopupWrapper,a.popupObj.element,a.modal,t.Browser.isDevice),a.setAriaAttributes()}else a.popupObj.destroy(),a.popupWrapper=a.popupObj=null;t.isNullOrUndefined(a.inputElement)||""!==a.inputElement.value||!t.isNullOrUndefined(a.tableBodyElement)&&a.tableBodyElement.querySelectorAll("td.e-selected").length>0&&(t.addClass([a.tableBodyElement.querySelector("td.e-selected")],"e-focused-date"),t.removeClass(a.tableBodyElement.querySelectorAll("td.e-selected"),H)),t.EventHandler.add(document,"mousedown touchstart",a.documentHandler,a)})}},a.prototype.hide=function(e){var i=this;if(t.isNullOrUndefined(this.popupWrapper))t.Browser.isDevice&&this.allowEdit&&!this.readonly&&this.inputElement.removeAttribute("readonly"),this.setAllowEdit();else{var s=!0;this.preventArgs={preventDefault:function(){s=!1},popup:this.popupObj,event:e||null,cancel:!1},t.removeClass(this.inputWrapper.buttons,S),t.removeClass([document.body],U);var a=this.preventArgs;this.isCalendar()?this.trigger("close",a,function(e){i.closeEventCallback(s,e)}):this.closeEventCallback(s,a)}},a.prototype.closeEventCallback=function(e,i){this.preventArgs=i,this.isCalendar()&&e&&!this.preventArgs.cancel&&(this.popupObj.hide(),this.isAltKeyPressed=!1,this.keyboardModule.destroy(),t.removeClass(this.inputWrapper.buttons,S)),this.setAriaAttributes(),t.Browser.isDevice&&this.modal&&(this.modal.style.display="none",this.modal.outerHTML="",this.modal=null),t.Browser.isDevice&&(t.isNullOrUndefined(this.mobilePopupWrapper)||(this.mobilePopupWrapper.remove(),this.mobilePopupWrapper=null)),t.EventHandler.remove(document,"mousedown touchstart",this.documentHandler),t.Browser.isDevice&&this.allowEdit&&!this.readonly&&this.inputElement.removeAttribute("readonly"),this.setAllowEdit()},a.prototype.focusIn=function(e){document.activeElement!==this.inputElement&&this.enabled&&(this.inputElement.focus(),t.addClass([this.inputWrapper.container],[A]))},a.prototype.focusOut=function(){document.activeElement===this.inputElement&&(t.removeClass([this.inputWrapper.container],[A]),this.inputElement.blur())},a.prototype.currentView=function(){var t;return this.calendarElement&&(t=e.prototype.currentView.call(this)),t},a.prototype.navigateTo=function(t,i){this.calendarElement&&e.prototype.navigateTo.call(this,t,i)},a.prototype.destroy=function(){this.unBindEvents(),e.prototype.destroy.call(this),this.keyboardModules.destroy(),this.popupObj&&this.popupObj.element.classList.contains("e-popup")&&e.prototype.destroy.call(this);var i={"aria-live":"assertive","aria-atomic":"true","aria-disabled":"true","aria-haspopup":"true","aria-activedescendant":"null","aria-owns":this.element.id+"_options","aria-expanded":"false",role:"combobox",autocomplete:"off",autocorrect:"off",autocapitalize:"off",spellcheck:"false"};this.inputElement&&(s.Input.removeAttributes(i,this.inputElement),t.isNullOrUndefined(this.inputElementCopy.getAttribute("tabindex"))?this.inputElement.removeAttribute("tabindex"):this.inputElement.setAttribute("tabindex",this.tabIndex),t.EventHandler.remove(this.inputElement,"blur",this.inputBlurHandler),t.EventHandler.remove(this.inputElement,"focus",this.inputFocusHandler),this.ensureInputAttribute()),this.isCalendar()&&(this.popupWrapper&&t.detach(this.popupWrapper),this.popupObj=this.popupWrapper=null,this.keyboardModule.destroy()),null===this.ngTag&&(this.inputElement&&(this.inputWrapper.container.insertAdjacentElement("afterend",this.inputElement),t.removeClass([this.inputElement],["e-input"])),t.removeClass([this.element],[x]),t.detach(this.inputWrapper.container)),this.formElement&&t.EventHandler.remove(this.formElement,"reset",this.resetFormHandler)},a.prototype.ensureInputAttribute=function(){for(var e=[],i=0;i<this.inputElement.attributes.length;i++)e[i]=this.inputElement.attributes[i].name;for(i=0;i<e.length;i++)t.isNullOrUndefined(this.inputElementCopy.getAttribute(e[i]))?("value"===e[i].toLowerCase()&&(this.inputElement.value=""),this.inputElement.removeAttribute(e[i])):("value"===e[i].toLowerCase()&&(this.inputElement.value=this.inputElementCopy.getAttribute(e[i])),this.inputElement.setAttribute(e[i],this.inputElementCopy.getAttribute(e[i])))},a.prototype.preRender=function(){this.inputElementCopy=this.element.cloneNode(!0),t.removeClass([this.inputElementCopy],[x,"e-control","e-lib"]),this.inputElement=this.element,this.formElement=t.closest(this.inputElement,"form"),this.index=this.showClearButton?2:1,this.ngTag=null,"EJS-DATEPICKER"!==this.element.tagName&&"EJS-DATETIMEPICKER"!==this.element.tagName||(this.ngTag=this.element.tagName,this.inputElement=this.createElement("input"),this.element.appendChild(this.inputElement)),this.element.getAttribute("id")?null!==this.ngTag&&(this.inputElement.id=this.element.getAttribute("id")+"_input"):"datetimepicker"===this.getModuleName()?(this.element.id=t.getUniqueID("ej2-datetimepicker"),null!==this.ngTag&&t.attributes(this.inputElement,{id:this.element.id+"_input"})):(this.element.id=t.getUniqueID("ej2-datepicker"),null!==this.ngTag&&t.attributes(this.inputElement,{id:this.element.id+"_input"})),null!==this.ngTag&&this.validationAttribute(this.element,this.inputElement),this.updateHtmlAttributeToElement(),this.defaultKeyConfigs=this.getDefaultKeyConfig(),this.checkHtmlAttributes(!1),this.tabIndex=this.element.hasAttribute("tabindex")?this.element.getAttribute("tabindex"):"0",this.element.removeAttribute("tabindex"),e.prototype.preRender.call(this)},a.prototype.getDefaultKeyConfig=function(){return this.defaultKeyConfigs={altUpArrow:"alt+uparrow",altDownArrow:"alt+downarrow",escape:"escape",enter:"enter",controlUp:"ctrl+38",controlDown:"ctrl+40",moveDown:"downarrow",moveUp:"uparrow",moveLeft:"leftarrow",moveRight:"rightarrow",select:"enter",home:"home",end:"end",pageUp:"pageup",pageDown:"pagedown",shiftPageUp:"shift+pageup",shiftPageDown:"shift+pagedown",controlHome:"ctrl+home",controlEnd:"ctrl+end",shiftTab:"shift+tab",tab:"tab"},this.defaultKeyConfigs},a.prototype.validationAttribute=function(e,i){var s=e.getAttribute("name")?e.getAttribute("name"):e.getAttribute("id");i.setAttribute("name",s),e.removeAttribute("name");for(var a=["required","aria-required","form"],n=0;n<a.length;n++)if(!t.isNullOrUndefined(e.getAttribute(a[n]))){var r=e.getAttribute(a[n]);i.setAttribute(a[n],r),e.removeAttribute(a[n])}},a.prototype.checkFormat=function(){var e=new t.Internationalization(this.locale);if(this.format)if("string"==typeof this.format)this.formatString=this.format;else if(""===this.format.skeleton||t.isNullOrUndefined(this.format.skeleton))"datetimepicker"===this.getModuleName()?this.formatString=this.dateTimeFormat:this.formatString=null;else{var i=this.format.skeleton;"datetimepicker"===this.getModuleName()?this.formatString=e.getDatePattern({skeleton:i,type:"dateTime"}):this.formatString=e.getDatePattern({skeleton:i,type:"date"})}else this.formatString=null},a.prototype.checkHtmlAttributes=function(e){this.globalize=new t.Internationalization(this.locale),this.checkFormat(),this.checkView();var i,s=e?t.isNullOrUndefined(this.htmlAttributes)?[]:Object.keys(this.htmlAttributes):["value","min","max","disabled","readonly","style","name","placeholder","type"];i="datetimepicker"===this.getModuleName()?"Gregorian"===this.calendarMode?{format:t.isNullOrUndefined(this.formatString)?this.dateTimeFormat:this.formatString,type:"dateTime",skeleton:"yMd"}:{format:t.isNullOrUndefined(this.formatString)?this.dateTimeFormat:this.formatString,type:"dateTime",skeleton:"yMd",calendar:"islamic"}:"Gregorian"===this.calendarMode?{format:this.formatString,type:"dateTime",skeleton:"yMd"}:{format:this.formatString,type:"dateTime",skeleton:"yMd",calendar:"islamic"};for(var a=0,n=s;a<n.length;a++){var r=n[a];if(!t.isNullOrUndefined(this.inputElement.getAttribute(r)))switch(r){case"disabled":if(t.isNullOrUndefined(this.datepickerOptions)||void 0===this.datepickerOptions.enabled||e){var l="disabled"!==this.inputElement.getAttribute(r)&&""!==this.inputElement.getAttribute(r)&&"true"!==this.inputElement.getAttribute(r);this.setProperties({enabled:l},!e)}break;case"readonly":if(t.isNullOrUndefined(this.datepickerOptions)||void 0===this.datepickerOptions.readonly||e){var o="readonly"===this.inputElement.getAttribute(r)||""===this.inputElement.getAttribute(r)||"true"===this.inputElement.getAttribute(r);this.setProperties({readonly:o},!e)}break;case"placeholder":(t.isNullOrUndefined(this.datepickerOptions)||void 0===this.datepickerOptions.placeholder||e)&&this.setProperties({placeholder:this.inputElement.getAttribute(r)},!e);break;case"style":this.inputElement.setAttribute("style",""+this.inputElement.getAttribute(r));break;case"name":this.inputElement.setAttribute("name",""+this.inputElement.getAttribute(r));break;case"value":if(t.isNullOrUndefined(this.datepickerOptions)||void 0===this.datepickerOptions.value||e){var h=this.inputElement.getAttribute(r);this.setProperties(t.setValue(r,this.globalize.parseDate(h,i),{}),!e)}break;case"min":if(+this.min==+new Date(1900,0,1)||e){var u=this.inputElement.getAttribute(r);this.setProperties(t.setValue(r,this.globalize.parseDate(u),{}),!e)}break;case"max":if(+this.max==+new Date(2099,11,31)||e){var d=this.inputElement.getAttribute(r);this.setProperties(t.setValue(r,this.globalize.parseDate(d),{}),!e)}break;case"type":"text"!==this.inputElement.getAttribute(r)&&this.inputElement.setAttribute("type","text")}}},a.prototype.getModuleName=function(){return"datepicker"},a.prototype.disabledDates=function(){var i,s=this.checkDateValue(this.value)?new Date(+this.value):new Date(this.checkValue(this.value)),a=this.previousDate;this.minMaxUpdates(),e.prototype.render.call(this),this.previousDate=a;var n='*[id^="/id"]'.replace("/id",""+(s&&+s));this.strictMode||("string"==typeof this.value||"object"==typeof this.value&&+this.value!=+s)&&this.setProperties({value:s},!0),t.isNullOrUndefined(this.calendarElement.querySelectorAll(n)[0])||this.calendarElement.querySelectorAll(n)[0].classList.contains("e-disabled")&&(this.strictMode||(this.currentDate=new Date((new Date).setHours(0,0,0,0))));var r;"datetimepicker"===this.getModuleName()?r="Gregorian"===this.calendarMode?this.globalize.formatDate(s,{format:t.isNullOrUndefined(this.formatString)?this.dateTimeFormat:this.formatString,type:"dateTime",skeleton:"yMd"}):this.globalize.formatDate(s,{format:t.isNullOrUndefined(this.formatString)?this.dateTimeFormat:this.formatString,type:"dateTime",skeleton:"yMd",calendar:"islamic"}):(i="Gregorian"===this.calendarMode?{format:this.formatString,type:"dateTime",skeleton:"yMd"}:{format:this.formatString,type:"dateTime",skeleton:"yMd",calendar:"islamic"},r=this.globalize.formatDate(s,i)),this.popupObj||(this.updateInputValue(r),this.enableMask&&(this.updateInputValue(this.maskedDateValue),this.notify("createMask",{module:"MaskedDateTime"})))},a.prototype.setAriaAttributes=function(){this.isCalendar()?(s.Input.addAttributes({"aria-expanded":"true"},this.inputElement),t.attributes(this.inputElement,{"aria-activedescendant":""+this.setActiveDescendant()})):(s.Input.addAttributes({"aria-expanded":"false"},this.inputElement),t.attributes(this.inputElement,{"aria-activedescendant":"null"}))},a.prototype.errorClass=function(){var e='*[id^="/id"]'.replace("/id",""+ +this.value),i=this.calendarElement&&this.calendarElement.querySelectorAll(e)[0]&&this.calendarElement.querySelectorAll(e)[0].classList.contains("e-disabled");!t.isNullOrUndefined(this.value)&&!(+new Date(+this.value).setMilliseconds(0)>=+this.min&&+new Date(+this.value).setMilliseconds(0)<=+this.max)||!this.strictMode&&""!==this.inputElement.value&&this.inputElement.value!==this.maskedDateValue&&t.isNullOrUndefined(this.value)||i?(t.addClass([this.inputWrapper.container],"e-error"),t.attributes(this.inputElement,{"aria-invalid":"true"})):(t.removeClass([this.inputWrapper.container],"e-error"),t.attributes(this.inputElement,{"aria-invalid":"false"}))},a.prototype.onPropertyChanged=function(i,a){for(var n=0,r=Object.keys(i);n<r.length;n++){switch(r[n]){case"value":this.isDynamicValueChanged=!0,this.isInteracted=!1,this.invalidValueString=null,this.checkInvalidValue(i.value),i.value=this.value,this.previousElementValue=this.inputElement.value,t.isNullOrUndefined(this.value)&&(this.updateInputValue(""),this.currentDate=new Date((new Date).setHours(0,0,0,0))),this.updateInput(!0),+this.previousDate!=+this.value&&this.changeTrigger(null),this.isInteracted=!0,this.preventChange=this.isAngular&&this.preventChange?!this.preventChange:this.preventChange,this.enableMask&&this.notify("createMask",{module:"MaskedDateTime"});break;case"format":this.checkFormat(),this.bindInputEvent(),this.updateInput(),this.enableMask&&(this.notify("createMask",{module:"MaskedDateTime"}),this.value||this.updateInputValue(this.maskedDateValue));break;case"allowEdit":this.setAllowEdit();break;case"placeholder":s.Input.setPlaceholder(this.placeholder,this.inputElement);break;case"readonly":s.Input.setReadonly(this.readonly,this.inputElement);break;case"enabled":s.Input.setEnabled(this.enabled,this.inputElement),this.setAriaDisabled();break;case"htmlAttributes":this.updateHtmlAttributeToElement(),this.updateHtmlAttributeToWrapper(),this.checkHtmlAttributes(!0);break;case"locale":this.globalize=new t.Internationalization(this.locale),this.l10n.setLocale(this.locale),this.setProperties({placeholder:this.l10n.getConstant("placeholder")},!0),s.Input.setPlaceholder(this.placeholder,this.inputElement),this.updateInput(),this.enableMask&&this.notify("createMask",{module:"MaskedDateTime"});break;case"enableRtl":s.Input.setEnableRtl(this.enableRtl,[this.inputWrapper.container]);break;case"start":case"depth":this.checkView(),this.calendarElement&&e.prototype.onPropertyChanged.call(this,i,a);break;case"zIndex":this.setProperties({zIndex:i.zIndex},!0);break;case"cssClass":this.updateCssClass(i.cssClass,a.cssClass);break;case"showClearButton":s.Input.setClearButton(this.showClearButton,this.inputElement,this.inputWrapper),this.bindClearEvent(),this.index=this.showClearButton?2:1;break;case"strictMode":this.invalidValueString=null,this.updateInput();break;case"width":this.setWidth(i.width);break;case"floatLabelType":this.floatLabelType=i.floatLabelType,s.Input.removeFloating(this.inputWrapper),s.Input.addFloating(this.inputElement,this.floatLabelType,this.placeholder);break;case"enableMask":this.enableMask?(this.notify("createMask",{module:"MaskedDateTime"}),this.updateInputValue(this.maskedDateValue),this.bindInputEvent()):this.inputElement.value===this.maskedDateValue&&this.updateInputValue("");break;default:this.calendarElement&&this.isCalendar()&&e.prototype.onPropertyChanged.call(this,i,a)}this.isDynamicValueChanged||this.hide(null),this.isDynamicValueChanged=!1}},T([t.Property(null)],a.prototype,"width",void 0),T([t.Property(null)],a.prototype,"value",void 0),T([t.Property(null)],a.prototype,"cssClass",void 0),T([t.Property(!1)],a.prototype,"strictMode",void 0),T([t.Property(null)],a.prototype,"format",void 0),T([t.Property(!0)],a.prototype,"enabled",void 0),T([t.Property({})],a.prototype,"htmlAttributes",void 0),T([t.Property(null)],a.prototype,"values",void 0),T([t.Property(!1)],a.prototype,"isMultiSelection",void 0),T([t.Property(!0)],a.prototype,"showClearButton",void 0),T([t.Property(!0)],a.prototype,"allowEdit",void 0),T([t.Property(null)],a.prototype,"keyConfigs",void 0),T([t.Property(!1)],a.prototype,"enablePersistence",void 0),T([t.Property(1e3)],a.prototype,"zIndex",void 0),T([t.Property(!1)],a.prototype,"readonly",void 0),T([t.Property(null)],a.prototype,"placeholder",void 0),T([t.Property("Never")],a.prototype,"floatLabelType",void 0),T([t.Property(null)],a.prototype,"serverTimezoneOffset",void 0),T([t.Property(!1)],a.prototype,"openOnFocus",void 0),T([t.Property(!1)],a.prototype,"enableMask",void 0),T([t.Property({day:"day",month:"month",year:"year",hour:"hour",minute:"minute",second:"second",dayOfTheWeek:"day of the week"})],a.prototype,"maskPlaceholder",void 0),T([t.Event()],a.prototype,"open",void 0),T([t.Event()],a.prototype,"cleared",void 0),T([t.Event()],a.prototype,"close",void 0),T([t.Event()],a.prototype,"blur",void 0),T([t.Event()],a.prototype,"focus",void 0),T([t.Event()],a.prototype,"created",void 0),T([t.Event()],a.prototype,"destroyed",void 0),a=T([t.NotifyPropertyChanges],a)}(C),B=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),j=function(e,t,i,s){var a,n=arguments.length,r=n<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(e,t,i,s);else for(var l=e.length-1;l>=0;l--)(a=e[l])&&(r=(n<3?a(r):n>3?a(t,i,r):a(t,i))||r);return n>3&&r&&Object.defineProperty(t,i,r),r},Y="e-left-calendar",R="e-right-calendar",z="e-daterangepicker",q="e-active",K="e-start-date",_="e-end-date",G="e-input-focus",Z="e-range-hover",X="e-other-month",J="e-start-label",$="e-end-label",Q="e-disabled",ee="e-selected",te="e-calendar",ie="e-header",se="e-title",ae="e-icon-container",ne="e-date-range-container",re="e-presets",le="e-focused-date",oe="e-content",he="e-day-span",ue="e-week-number",de="e-date-disabled",pe="e-icon-disabled",ce="e-overlay",me="e-list-item",ve="e-hover",fe="e-range-overflow",ye="e-non-edit",ge="e-daterange-hidden",be=["title","class","style"],De=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return B(i,e),j([t.Property()],i.prototype,"label",void 0),j([t.Property()],i.prototype,"start",void 0),j([t.Property()],i.prototype,"end",void 0),i}(t.ChildProperty),Ee=function(e){function r(t,i){var s=e.call(this,t,i)||this;return s.isCustomRange=!1,s.isCustomWindow=!1,s.presetsItem=[],s.liCollections=[],s.previousEleValue="",s.isKeyPopup=!1,s.dateDisabled=!1,s.isRangeIconClicked=!1,s.isMaxDaysClicked=!1,s.disabledDays=[],s.preventBlur=!1,s.preventFocus=!1,s.invalidValueString=null,s.isAngular=!1,s.preventChange=!1,s.dateRangeOptions=t,s}return B(r,e),r.prototype.render=function(){this.initialize(),this.setProperties({startDate:this.startValue},!0),this.setProperties({endDate:this.endValue},!0),this.setModelValue(),this.setDataAttribute(!1),this.element.hasAttribute("data-val")&&this.element.setAttribute("data-val","false"),this.renderComplete()},r.prototype.preRender=function(){if(this.keyInputConfigs={altDownArrow:"alt+downarrow",escape:"escape",enter:"enter",tab:"tab",altRightArrow:"alt+rightarrow",altLeftArrow:"alt+leftarrow",moveUp:"uparrow",moveDown:"downarrow",spacebar:"space"},this.defaultConstant={placeholder:this.placeholder,startLabel:"Start Date",endLabel:"End Date",customRange:"Custom Range",applyText:"Apply",cancelText:"Cancel",selectedDays:"Selected Days",days:"days"},this.isMobile=window.matchMedia("(max-width:550px)").matches,this.inputElement=this.element,this.angularTag=null,"EJS-DATERANGEPICKER"===this.element.tagName&&(this.angularTag=this.element.tagName,this.inputElement=this.createElement("input"),this.element.appendChild(this.inputElement)),this.cloneElement=this.element.cloneNode(!0),t.removeClass([this.cloneElement],[z,"e-control","e-lib"]),this.updateHtmlAttributeToElement(),this.element.getAttribute("id")?null!==this.angularTag&&(this.inputElement.id=this.element.getAttribute("id")+"_input"):(this.element.id=t.getUniqueID("ej2-datetimepicker"),null!==this.angularTag&&t.attributes(this.inputElement,{id:this.element.id+"_input"})),this.checkInvalidRange(this.value),!this.invalidValueString&&"string"==typeof this.value){var i=this.value.split(" "+this.separator+" ");this.value=[new Date(i[0]),new Date(i[1])]}this.initProperty(),this.tabIndex=this.element.hasAttribute("tabindex")?this.element.getAttribute("tabindex"):"0",this.element.removeAttribute("tabindex"),e.prototype.preRender.call(this),this.navNextFunction=this.navNextMonth.bind(this),this.navPrevFunction=this.navPrevMonth.bind(this),this.deviceNavNextFunction=this.deviceNavNext.bind(this),this.deviceNavPrevFunction=this.deviceNavPrevious.bind(this),this.initStartDate=this.checkDateValue(this.startValue),this.initEndDate=this.checkDateValue(this.endValue),this.formElement=t.closest(this.element,"form")},r.prototype.updateValue=function(){this.value&&this.value.length>0?(this.value[0]instanceof Date&&!isNaN(+this.value[0])?(this.setProperties({startDate:this.value[0]},!0),this.startValue=this.value[0]):"string"==typeof this.value[0]?0==+this.value[0]||isNaN(+new Date(this.checkValue(this.value[0])))?(this.startValue=null,this.setValue()):(this.setProperties({startDate:new Date(this.checkValue(this.value[0]))},!0),this.startValue=new Date(this.checkValue(this.value[0]))):(this.startValue=null,this.setValue()),this.value[1]instanceof Date&&!isNaN(+this.value[1])?(this.setProperties({endDate:this.value[1]},!0),this.endValue=this.value[1]):"string"==typeof this.value[1]?0==+this.value[0]||isNaN(+new Date(this.checkValue(this.value[0])))?(this.setProperties({endDate:null},!0),this.endValue=null,this.setValue()):(this.setProperties({endDate:new Date(this.checkValue(this.value[1]))},!0),this.endValue=new Date(this.checkValue(this.value[1])),this.setValue()):(this.setProperties({endDate:null},!0),this.endValue=null,this.setValue())):this.value&&this.value.start?(this.value.start instanceof Date&&!isNaN(+this.value.start)?(this.setProperties({startDate:this.value.start},!0),this.startValue=this.value.start):"string"==typeof this.value.start?(this.setProperties({startDate:new Date(this.checkValue(this.value.start))},!0),this.startValue=new Date(this.checkValue(this.value.start))):(this.startValue=null,this.setValue()),this.value.end instanceof Date&&!isNaN(+this.value.end)?(this.setProperties({endDate:this.value.end},!0),this.endValue=this.value.end):"string"==typeof this.value.end?(this.setProperties({endDate:new Date(this.checkValue(this.value.end))},!0),this.endValue=new Date(this.checkValue(this.value.end)),this.setValue()):(this.setProperties({endDate:null},!0),this.endValue=null,this.setValue())):t.isNullOrUndefined(this.value)&&(this.endValue=this.checkDateValue(new Date(this.checkValue(this.endDate))),this.startValue=this.checkDateValue(new Date(this.checkValue(this.startDate))),this.setValue())},r.prototype.initProperty=function(){this.globalize=new t.Internationalization(this.locale),this.checkFormat(),this.checkView(),(t.isNullOrUndefined(this.firstDayOfWeek)||this.firstDayOfWeek>6||this.firstDayOfWeek<0)&&this.setProperties({firstDayOfWeek:this.globalize.getFirstDayOfWeek()},!0),this.updateValue()},r.prototype.checkFormat=function(){if(this.format)if("string"==typeof this.format)this.formatString=this.format;else if(""===this.format.skeleton||t.isNullOrUndefined(this.format.skeleton))this.formatString=null;else{var e=this.format.skeleton;this.formatString=this.globalize.getDatePattern({skeleton:e,type:"date"})}else this.formatString=null},r.prototype.initialize=function(){null!==this.angularTag&&this.validationAttribute(this.element,this.inputElement),this.checkHtmlAttributes(!1),t.merge(this.defaultKeyConfigs,{shiftTab:"shift+tab"});var e=this.checkDateValue(new Date(this.checkValue(this.startValue)));this.setProperties({startDate:e},!0),this.setProperties({endValue:this.checkDateValue(new Date(this.checkValue(this.endValue)))},!0),this.setValue(),this.setProperties({min:this.checkDateValue(new Date(this.checkValue(this.min)))},!0),this.setProperties({max:this.checkDateValue(new Date(this.checkValue(this.max)))},!0),this.l10n=new t.L10n("daterangepicker",this.defaultConstant,this.locale),this.l10n.setLocale(this.locale),this.setProperties({placeholder:this.placeholder||this.l10n.getConstant("placeholder")},!0),this.processPresets(),this.createInput(),this.updateHtmlAttributeToWrapper(),this.setRangeAllowEdit(),this.bindEvents()},r.prototype.setDataAttribute=function(e){var t={};if(e)t=this.htmlAttributes;else for(var i=0;i<this.element.attributes.length;i++)t[this.element.attributes[i].name]=this.element.getAttribute(this.element.attributes[i].name);for(var s=0,a=Object.keys(t);s<a.length;s++){var n=a[s];0===n.indexOf("data")&&(this.firstHiddenChild.setAttribute(n,t[n]),this.secondHiddenChild.setAttribute(n,t[n]))}},r.prototype.setRangeAllowEdit=function(){this.allowEdit?this.readonly||this.inputElement.removeAttribute("readonly"):t.attributes(this.inputElement,{readonly:""}),this.updateClearIconState()},r.prototype.updateClearIconState=function(){this.allowEdit||!this.inputWrapper||this.readonly?this.inputWrapper&&t.removeClass([this.inputWrapper.container],[ye]):""===this.inputElement.value?t.removeClass([this.inputWrapper.container],[ye]):t.addClass([this.inputWrapper.container],[ye])},r.prototype.validationAttribute=function(e,i){var s=e.getAttribute("name")?e.getAttribute("name"):e.getAttribute("id");i.setAttribute("name",s),e.removeAttribute("name");for(var a=["required","aria-required","form"],n=0;n<a.length;n++)if(!t.isNullOrUndefined(e.getAttribute(a[n]))){var r=e.getAttribute(a[n]);i.setAttribute(a[n],r),e.removeAttribute(a[n])}},r.prototype.updateHtmlAttributeToWrapper=function(){if(!t.isNullOrUndefined(this.htmlAttributes))for(var e=0,i=Object.keys(this.htmlAttributes);e<i.length;e++){var s=i[e];if(be.indexOf(s)>-1)if("class"===s){var a=this.htmlAttributes[s].replace(/\s+/g," ").trim();""!==a&&t.addClass([this.inputWrapper.container],a.split(" "))}else if("style"===s){var n=this.inputWrapper.container.getAttribute(s);n=t.isNullOrUndefined(n)?this.htmlAttributes[s]:n+this.htmlAttributes[s],this.inputWrapper.container.setAttribute(s,n)}else this.inputWrapper.container.setAttribute(s,this.htmlAttributes[s])}},r.prototype.updateHtmlAttributeToElement=function(){if(!t.isNullOrUndefined(this.htmlAttributes))for(var e=0,i=Object.keys(this.htmlAttributes);e<i.length;e++){var s=i[e];be.indexOf(s)<0&&this.inputElement.setAttribute(s,this.htmlAttributes[s])}},r.prototype.updateCssClass=function(e,i){t.isNullOrUndefined(i)||(i=i.replace(/\s+/g," ").trim()),t.isNullOrUndefined(e)||(e=e.replace(/\s+/g," ").trim()),s.Input.setCssClass(e,[this.inputWrapper.container],i),this.popupWrapper&&s.Input.setCssClass(e,[this.popupWrapper],i)},r.prototype.processPresets=function(){this.presetsItem=[];var e=0;if(!t.isUndefined(this.presets[0].start&&this.presets[0].end&&this.presets[0].label)){for(var i=0,s=this.presets;i<s.length;i++){var a=s[i],n=a.label.replace(/\s+/g,"")+"_"+ ++e;"string"==typeof a.end?this.presetsItem.push({id:n,text:a.label,end:new Date(this.checkValue(a.end)),start:new Date(this.checkValue(a.start))}):this.presetsItem.push({id:n,text:a.label,start:a.start,end:a.end})}var r=t.isNullOrUndefined(this.startValue)?null:new Date(+this.startValue),l=t.isNullOrUndefined(this.endValue)?null:new Date(+this.endValue);this.presetsItem.push({id:"custom_range",text:this.l10n.getConstant("customRange"),start:r,end:l}),t.isNullOrUndefined(this.startValue)||t.isNullOrUndefined(this.endValue)||(this.isCustomRange=!0,this.activeIndex=this.presetsItem.length-1)}},r.prototype.bindEvents=function(){t.EventHandler.add(this.inputWrapper.buttons[0],"mousedown",this.rangeIconHandler,this),t.EventHandler.add(this.inputElement,"focus",this.inputFocusHandler,this),t.EventHandler.add(this.inputElement,"blur",this.inputBlurHandler,this),t.EventHandler.add(this.inputElement,"change",this.inputChangeHandler,this),this.showClearButton&&this.inputWrapper.clearButton&&t.EventHandler.add(this.inputWrapper.clearButton,"mousedown",this.resetHandler,this),this.isMobile||(this.keyInputConfigs=t.extend(this.keyInputConfigs,this.keyConfigs),this.inputKeyboardModule=new t.KeyboardEvents(this.inputElement,{eventName:"keydown",keyAction:this.inputHandler.bind(this),keyConfigs:this.keyInputConfigs})),this.formElement&&t.EventHandler.add(this.formElement,"reset",this.formResetHandler,this),this.enabled?this.inputElement.setAttribute("tabindex",this.tabIndex):this.inputElement.tabIndex=-1},r.prototype.unBindEvents=function(){t.EventHandler.remove(this.inputWrapper.buttons[0],"mousedown",this.rangeIconHandler),t.EventHandler.remove(this.inputElement,"blur",this.inputBlurHandler),t.EventHandler.remove(this.inputElement,"focus",this.inputFocusHandler),t.EventHandler.remove(this.inputElement,"change",this.inputChangeHandler),this.showClearButton&&this.inputWrapper.clearButton&&t.EventHandler.remove(this.inputWrapper.clearButton,"mousedown touchstart",this.resetHandler),this.isMobile||t.isNullOrUndefined(this.inputKeyboardModule)||this.inputKeyboardModule.destroy(),this.formElement&&t.EventHandler.remove(this.formElement,"reset",this.formResetHandler),this.inputElement.tabIndex=-1},r.prototype.updateHiddenInput=function(){if(this.firstHiddenChild&&this.secondHiddenChild){var e={type:"datetime",skeleton:"yMd"};"string"==typeof this.startDate&&(this.startDate=this.globalize.parseDate(this.startDate,e)),"string"==typeof this.endDate&&(this.endDate=this.globalize.parseDate(this.endDate,e)),this.firstHiddenChild.value=this.startDate&&this.globalize.formatDate(this.startDate,e)||this.inputElement.value,this.secondHiddenChild.value=this.endDate&&this.globalize.formatDate(this.endDate,e)||this.inputElement.value,this.dispatchEvent(this.firstHiddenChild,"focusout"),this.dispatchEvent(this.firstHiddenChild,"change")}},r.prototype.inputChangeHandler=function(e){this.enabled&&(e.stopPropagation(),this.updateHiddenInput())},r.prototype.bindClearEvent=function(){this.showClearButton&&this.inputWrapper.clearButton&&t.EventHandler.add(this.inputWrapper.clearButton,"mousedown",this.resetHandler,this)},r.prototype.resetHandler=function(e){if(this.enabled){this.valueType=this.value,e.preventDefault(),this.clear();var t={event:e};this.setProperties({endDate:this.checkDateValue(this.endValue)},!0),this.setProperties({startDate:this.checkDateValue(this.startValue)},!0),this.trigger("cleared",t),this.changeTrigger(e),this.clearRange(),this.hide(e)}},r.prototype.restoreValue=function(){this.previousEleValue=this.inputElement.value,this.previousStartValue=this.startValue,this.previousEndValue=this.endValue,this.valueType=null,this.initStartDate=this.checkDateValue(this.startValue),this.initEndDate=this.checkDateValue(this.endValue),this.setValue(),this.setModelValue()},r.prototype.formResetHandler=function(e){if(this.enabled&&this.formElement&&e.target===this.formElement&&!this.inputElement.disabled){var i=this.inputElement.getAttribute("value");t.isNullOrUndefined(this.startCopy)?(this.setProperties({value:null,startDate:null,endDate:null},!0),this.startValue=this.endValue=null):(t.isNullOrUndefined(this.value)||t.isNullOrUndefined(this.value.start)?(this.setProperties({value:[this.startCopy,this.endCopy]},!0),this.startValue=this.value[0],this.endValue=this.value[1]):(this.setProperties({value:{start:this.startCopy,end:this.endCopy}},!0),this.startValue=this.value.start,this.endValue=this.value.end),this.setProperties({startDate:this.startValue,endDate:this.endValue},!0)),"EJS-DATERANGEPICKER"===this.element.tagName&&(this.setProperties({value:null,startDate:null,endDate:null},!0),i="",this.startValue=this.endValue=null,this.inputElement.setAttribute("value","")),this.restoreValue(),this.inputElement&&(s.Input.setValue(i,this.inputElement,this.floatLabelType,this.showClearButton),this.errorClass())}},r.prototype.clear=function(){null!==this.startValue&&(this.startValue=null),null!==this.endValue&&(this.endValue=null),this.value&&this.value.start&&this.setProperties({value:{start:null,end:null}},!0),null!==this.value&&this.value.length>0&&this.setProperties({value:null},!0),s.Input.setValue("",this.inputElement,this.floatLabelType,this.showClearButton),t.isNullOrUndefined(this.applyButton)||(this.applyButton.disabled=this.applyButton.element.disabled=!0),this.removeSelection()},r.prototype.rangeIconHandler=function(e){this.enabled&&(this.isMobile&&this.inputElement.setAttribute("readonly",""),e.preventDefault(),this.targetElement=null,this.isPopupOpen()&&document.body.contains(this.popupObj.element)?this.applyFunction(e):(this.isRangeIconClicked=!0,this.inputWrapper.container.children[0].focus(),this.show(null,e),this.isMobile||t.isNullOrUndefined(this.leftCalendar)||(this.isRangeIconClicked=!1,this.calendarFocus(),this.isRangeIconClicked=!0),t.addClass([this.inputWrapper.container],[G])))},r.prototype.checkHtmlAttributes=function(e){this.globalize=new t.Internationalization(this.locale);for(var i=e?t.isNullOrUndefined(this.htmlAttributes)?[]:Object.keys(this.htmlAttributes):["startDate","endDate","minDays","maxDays","min","max","disabled","readonly","style","name","placeholder","type","value"],s={format:this.formatString,type:"date",skeleton:"yMd"},a=0,n=i;a<n.length;a++){var r=n[a];if(!t.isNullOrUndefined(this.inputElement.getAttribute(r)))switch(r){case"disabled":if(t.isNullOrUndefined(this.dateRangeOptions)||void 0===this.dateRangeOptions.enabled||e){var l="disabled"===this.inputElement.getAttribute(r)||""===this.inputElement.getAttribute(r)||"true"===this.inputElement.getAttribute(r);this.setProperties({enabled:!l},!e)}break;case"readonly":if(t.isNullOrUndefined(this.dateRangeOptions)||void 0===this.dateRangeOptions.readonly||e){var o="readonly"===this.inputElement.getAttribute(r)||"true"===this.inputElement.getAttribute(r)||""===this.inputElement.getAttribute(r);this.setProperties({readonly:o},!e)}break;case"placeholder":(t.isNullOrUndefined(this.dateRangeOptions)||void 0===this.dateRangeOptions.placeholder||e)&&this.setProperties({placeholder:this.inputElement.getAttribute(r)},!e);break;case"value":if(t.isNullOrUndefined(this.dateRangeOptions)||void 0===this.dateRangeOptions.value||e){var h=this.inputElement.getAttribute(r);this.setProperties(t.setValue(r,h,{}),!e)}break;case"style":this.inputElement.setAttribute("style",""+this.inputElement.getAttribute(r));break;case"min":if(t.isNullOrUndefined(this.min)||+this.min==+new Date(1900,0,1)||e){var u=this.globalize.parseDate(this.inputElement.getAttribute(r),s);this.setProperties(t.setValue(r,u,{}),!e)}break;case"name":this.inputElement.setAttribute("name",""+this.inputElement.getAttribute(r));break;case"max":if(t.isNullOrUndefined(this.max)||+this.max==+new Date(2099,11,31)||e){u=this.globalize.parseDate(this.inputElement.getAttribute(r),s);this.setProperties(t.setValue(r,u,{}),!e)}break;case"startDate":if(t.isNullOrUndefined(this.startDate)){u=this.globalize.parseDate(this.inputElement.getAttribute(r),s);this.startValue=u,this.setValue()}break;case"endDate":if(t.isNullOrUndefined(this.endDate)){u=this.globalize.parseDate(this.inputElement.getAttribute(r),s);this.endValue=u,this.setValue()}break;case"minDays":t.isNullOrUndefined(this.minDays)&&this.setProperties(t.setValue(r,parseInt(this.inputElement.getAttribute(r),10),{}),!0);break;case"maxDays":t.isNullOrUndefined(this.maxDays)&&this.setProperties(t.setValue(r,parseInt(this.inputElement.getAttribute(r),10),{}),!0);break;case"type":"text"!==this.inputElement.getAttribute(r)&&this.inputElement.setAttribute("type","text")}}},r.prototype.createPopup=function(){for(var e=0;e<this.presetsItem.length;e++)e!==this.presetsItem.length-1&&"custom_range"===this.presetsItem[e].id&&this.presetsItem.splice(e,1);this.activeIndex=this.presetsItem.length-1,this.isCustomRange=!0;for(e=0;e<=this.presetsItem.length-2;e++){var i=this.presetsItem[e].start,s=this.presetsItem[e].end;this.startValue&&this.endValue&&+new Date(i.setHours(0,0,0,0))==+new Date(this.startValue.setHours(0,0,0,0))&&+new Date(s.setHours(0,0,0,0))==+new Date(this.endValue.setHours(0,0,0,0))&&(this.activeIndex=e,this.isCustomRange=!1)}this.popupWrapper=t.createElement("div",{id:this.element.id+"_popup",className:z+" e-popup"}),this.adjustLongHeaderWidth();var a=!this.isCustomRange||this.isMobile;!t.isUndefined(this.presets[0].start&&this.presets[0].end&&this.presets[0].label)&&a?(this.isCustomWindow=!1,this.createPresets(),this.listRippleEffect(),this.renderPopup()):(this.isCustomWindow=!0,this.renderControl())},r.prototype.renderControl=function(){this.createControl(),this.bindCalendarEvents(),this.updateRange(this.isMobile?[this.calendarElement]:[this.leftCalendar,this.rightCalendar]),t.isNullOrUndefined(this.endValue)||t.isNullOrUndefined(this.startValue)||this.disabledDateRender(),this.updateHeader()},r.prototype.clearCalendarEvents=function(){t.EventHandler.clearEvents(this.leftCalPrevIcon),t.EventHandler.clearEvents(this.leftCalNextIcon),t.EventHandler.clearEvents(this.rightCalPrevIcon),t.EventHandler.clearEvents(this.rightCalNextIcon)},r.prototype.updateNavIcons=function(){e.prototype.iconHandler.call(this)},r.prototype.calendarIconEvent=function(){this.clearCalendarEvents(),this.leftCalPrevIcon&&!this.leftCalPrevIcon.classList.contains(Q)&&t.EventHandler.add(this.leftCalPrevIcon,"mousedown",this.navPrevFunction),this.leftCalNextIcon&&!this.leftCalNextIcon.classList.contains(Q)&&t.EventHandler.add(this.leftCalNextIcon,"mousedown",this.navNextFunction),this.rightCalPrevIcon&&!this.rightCalPrevIcon.classList.contains(Q)&&t.EventHandler.add(this.rightCalPrevIcon,"mousedown",this.navPrevFunction),this.rightCalNextIcon&&!this.rightCalNextIcon.classList.contains(Q)&&t.EventHandler.add(this.rightCalNextIcon,"mousedown",this.navNextFunction)},r.prototype.bindCalendarEvents=function(){this.isMobile?(this.deviceCalendarEvent(),t.EventHandler.add(this.startButton.element,"click",this.deviceHeaderClick,this),t.EventHandler.add(this.endButton.element,"click",this.deviceHeaderClick,this)):(this.updateNavIcons(),this.calendarIconEvent(),this.calendarIconRipple(),this.headerTitleElement=this.popupObj.element.querySelector("."+R+" ."+ie+" ."+se),this.headerTitleElement=this.popupObj.element.querySelector("."+Y+" ."+ie+" ."+se),this.defaultKeyConfigs=t.extend(this.defaultKeyConfigs,this.keyConfigs),this.leftKeyboardModule=new t.KeyboardEvents(this.leftCalendar,{eventName:"keydown",keyAction:this.keyInputHandler.bind(this),keyConfigs:this.defaultKeyConfigs}),this.rightKeyboardModule=new t.KeyboardEvents(this.rightCalendar,{eventName:"keydown",keyAction:this.keyInputHandler.bind(this),keyConfigs:this.defaultKeyConfigs})),this.start===this.depth&&this.bindCalendarCellEvents(),this.removeFocusedDate()},r.prototype.calendarIconRipple=function(){t.rippleEffect(this.leftCalPrevIcon,{selector:".e-prev",duration:400,isCenterRipple:!0}),t.rippleEffect(this.leftCalNextIcon,{selector:".e-next",duration:400,isCenterRipple:!0}),t.rippleEffect(this.rightCalPrevIcon,{selector:".e-prev",duration:400,isCenterRipple:!0}),t.rippleEffect(this.rightCalNextIcon,{selector:".e-next",duration:400,isCenterRipple:!0})},r.prototype.deviceCalendarEvent=function(){t.EventHandler.clearEvents(this.nextIcon),t.EventHandler.clearEvents(this.previousIcon),t.rippleEffect(this.nextIcon,{selector:".e-prev",duration:400,isCenterRipple:!0}),t.rippleEffect(this.previousIcon,{selector:".e-next",duration:400,isCenterRipple:!0}),this.nextIcon&&!this.nextIcon.classList.contains(Q)&&t.EventHandler.add(this.nextIcon,"mousedown",this.deviceNavNextFunction),this.previousIcon&&!this.previousIcon.classList.contains(Q)&&t.EventHandler.add(this.previousIcon,"mousedown",this.deviceNavPrevFunction)},r.prototype.deviceNavNext=function(e){var i=t.closest(e.target,"."+te);this.updateDeviceCalendar(i),this.navigateNext(e),this.deviceNavigation()},r.prototype.deviceNavPrevious=function(e){var i=t.closest(e.target,"."+te);this.updateDeviceCalendar(i),this.navigatePrevious(e),this.deviceNavigation()},r.prototype.updateDeviceCalendar=function(e){e&&(this.previousIcon=e.querySelector(".e-prev"),this.nextIcon=e.querySelector(".e-next"),this.calendarElement=e,this.deviceCalendar=e,this.contentElement=e.querySelector("."+oe),this.tableBodyElement=t.select(".e-content tbody",e),this.table=e.querySelector("."+oe).getElementsByTagName("table")[0],this.headerTitleElement=e.querySelector(".e-header ."+se),this.headerElement=e.querySelector("."+ie))},r.prototype.deviceHeaderClick=function(e){if(e.currentTarget.classList.contains("e-start-btn")&&!t.isNullOrUndefined(this.startValue)){this.endButton.element.classList.remove(q),this.startButton.element.classList.add(q);var i=this.popupObj.element.querySelector("."+te);this.updateDeviceCalendar(i),t.isNullOrUndefined(this.calendarElement.querySelector("."+K+":not(.e-other-month)"))&&(this.currentDate=new Date(+this.startValue),t.remove(this.tableBodyElement),this.createContentBody(),this.deviceNavigation()),this.removeClassDisabled()}else if(!t.isNullOrUndefined(this.startValue)&&!t.isNullOrUndefined(this.endValue)){this.startButton.element.classList.remove(q),this.endButton.element.classList.add(q);i=this.popupObj.element.querySelector("."+te);this.updateDeviceCalendar(i),t.isNullOrUndefined(this.calendarElement.querySelector("."+_+":not(.e-other-month)"))&&(this.currentDate=new Date(+this.endValue),t.remove(this.tableBodyElement),this.createContentBody(),this.deviceNavigation()),this.updateMinMaxDays(this.popupObj.element.querySelector("."+te)),this.selectableDates()}},r.prototype.inputFocusHandler=function(){if(this.enabled){this.preventBlur=!1;var e={model:this};this.preventFocus||this.trigger("focus",e),this.updateClearIconState(),this.updateHiddenInput(),this.openOnFocus&&!this.preventFocus?(this.preventFocus=!0,this.show()):this.preventFocus=!0}},r.prototype.inputBlurHandler=function(e){if(this.enabled){if(!this.preventBlur){var i=this.inputElement.value;if(t.isNullOrUndefined(this.presetsItem)||this.presetsItem.length>0&&this.previousEleValue!==this.inputElement.value&&(this.activeIndex=this.presetsItem.length-1,this.isCustomRange=!0),!t.isNullOrUndefined(i)&&""!==i.trim()){var a=i.split(" "+this.separator+" ");if(a.length>1){this.invalidValueString=null;var n={format:this.formatString,type:"date",skeleton:"yMd"},r=this.globalize.parseDate(a[0].trim(),n),l=this.globalize.parseDate(a[1].trim(),n);if(!(t.isNullOrUndefined(r)||isNaN(+r)||t.isNullOrUndefined(l)||isNaN(+l))){var o=this.startValue;this.startValue=r;var h=this.endValue;if(this.endValue=l,this.setValue(),this.refreshControl(),i!==this.previousEleValue&&this.changeTrigger(e),!this.preventBlur&&document.activeElement!==this.inputElement){this.preventFocus=!1;var u={model:this};this.trigger("blur",u)}return this.updateHiddenInput(),void(this.isMobile&&this.isPopupOpen()&&(this.startValue=o,this.endValue=h))}this.strictMode||(this.startValue=null,this.endValue=null,this.setValue())}else this.strictMode||(this.startValue=null,this.endValue=null,this.setValue())}if(this.strictMode?(t.isNullOrUndefined(i)||""!==i.trim()||(this.startValue=null,this.endValue=null),s.Input.setValue("",this.inputElement,this.floatLabelType,this.showClearButton),this.updateInput()):(t.isNullOrUndefined(this.popupObj)&&(this.currentDate=null),this.previousStartValue=this.previousEndValue=null,this.startValue=null,this.endValue=null,this.setValue()),this.errorClass(),this.changeTrigger(e),!this.preventBlur&&document.activeElement!==this.inputElement){this.preventFocus=!1;u={model:this};this.trigger("blur",u)}}this.updateHiddenInput()}},r.prototype.clearRange=function(){this.previousStartValue=this.previousEndValue=null,this.currentDate=null},r.prototype.errorClass=function(){var e=this.inputElement.value.trim();(t.isNullOrUndefined(this.endValue)&&t.isNullOrUndefined(this.startValue)&&""!==e||!t.isNullOrUndefined(this.startValue)&&+this.startValue<+this.min||!t.isNullOrUndefined(this.startValue)&&!t.isNullOrUndefined(this.endValue)&&+this.startValue>+this.endValue||!t.isNullOrUndefined(this.endValue)&&+this.endValue>+this.max||this.startValue&&this.isDateDisabled(this.startValue)||this.endValue&&this.isDateDisabled(this.endValue))&&""!==e?(t.addClass([this.inputWrapper.container],"e-error"),t.attributes(this.inputElement,{"aria-invalid":"true"})):this.inputWrapper&&(t.removeClass([this.inputWrapper.container],"e-error"),t.attributes(this.inputElement,{"aria-invalid":"false"}))},r.prototype.keyCalendarUpdate=function(e,t){return this.removeFocusedDate(),e?(this.leftCalCurrentDate=new Date(+this.currentDate),t=this.leftCalendar):(this.rightCalCurrentDate=new Date(+this.currentDate),t=this.rightCalendar),this.updateCalendarElement(t),this.table.focus(),t},r.prototype.navInCalendar=function(e,i,s,a,n){var r,l,o=this.getViewNumber(this.currentView()),h=this.min;switch(l=t.isNullOrUndefined(this.maxDays)||!this.isMaxDaysClicked||t.isNullOrUndefined(this.startValue)?this.max:new Date(new Date(+this.startValue).setDate(this.startValue.getDate()+(this.maxDays-1))),e.action){case"moveRight":r=new Date(+this.currentDate),this.addDay(r,1,e,l,h),i&&+r==+a&&(n=this.keyCalendarUpdate(!1,n)),this.keyboardNavigate(1,o,e,l,h),this.keyNavigation(n,e);break;case"moveLeft":r=new Date(+this.currentDate),this.addDay(r,-1,e,l,h),i||+r==+s&&(n=this.keyCalendarUpdate(!0,n)),this.keyboardNavigate(-1,o,e,l,h),this.keyNavigation(n,e);break;case"moveUp":0===o?(r=new Date(+this.currentDate),this.addDay(r,-7,e,l,h),+r<=+s&&!i&&(n=this.keyCalendarUpdate(!0,n)),this.keyboardNavigate(-7,o,e,l,h)):this.keyboardNavigate(-4,o,e,this.max,this.min),this.keyNavigation(n,e);break;case"moveDown":0===o?(r=new Date(+this.currentDate),this.addDay(r,7,e,l,h),i&&+r>=+a&&(n=this.keyCalendarUpdate(!1,n)),this.keyboardNavigate(7,o,e,l,h)):this.keyboardNavigate(4,o,e,this.max,this.min),this.keyNavigation(n,e);break;case"home":this.currentDate=this.firstDay(this.currentDate),t.remove(this.tableBodyElement),0===o?this.renderMonths(e):1===o?this.renderYears(e):this.renderDecades(e),this.keyNavigation(n,e);break;case"end":this.currentDate=this.lastDay(this.currentDate,o),t.remove(this.tableBodyElement),0===o?this.renderMonths(e):1===o?this.renderYears(e):this.renderDecades(e),this.keyNavigation(n,e)}},r.prototype.keyInputHandler=function(i,s){var a,n=this.getViewNumber(this.currentView()),r=new Date(this.rightCalCurrentDate.getFullYear(),this.rightCalCurrentDate.getMonth(),1),l=new Date(this.leftCalCurrentDate.getFullYear(),this.leftCalCurrentDate.getMonth()+1,0),o=t.closest(i.target,"."+R),h=(o=t.isNullOrUndefined(o)?this.leftCalendar:o).classList.contains(Y);this.updateCalendarElement(o);var u=this.tableBodyElement.querySelector("tr td.e-selected"),d=o.querySelector("tr td."+le),p=o.querySelector("tr td."+K),c=o.querySelector("tr td."+_),m=this.getViewNumber(this.depth),v=n===m&&this.getViewNumber(this.start)>=m,f=t.closest(i.target,"."+Y),y=t.closest(i.target,"."+R),g=t.closest(i.target,"."+re);switch(t.isNullOrUndefined(d)?t.isNullOrUndefined(c)||this.dateDisabled?t.isNullOrUndefined(p)||this.dateDisabled?this.dateDisabled||this.currentDate.setDate(1):this.currentDate=new Date(+this.startValue):this.currentDate=new Date(+this.endValue):this.currentDate=this.currentDate,this.effect="",i.action){case"altUpArrow":this.isPopupOpen()&&(this.hide(i),this.preventFocus=!0,this.inputElement.focus(),t.addClass([this.inputWrapper.container],[G]));break;case"select":if(v){var b=t.isNullOrUndefined(d)?p:d;t.isNullOrUndefined(b)||b.classList.contains(Q)||this.selectRange(null,b)}else(t.isNullOrUndefined(u)||v)&&t.isNullOrUndefined(d)||(t.isNullOrUndefined(this.value)||(s=this.calendarElement.classList.contains(Y)?this.startDate:this.endDate),this.controlDown=i,this.contentClick(null,--n,d||u,s));i.preventDefault();break;case"controlHome":var D=new Date(this.currentDate.getFullYear(),0,1);!h&&+D<+l&&(o=this.keyCalendarUpdate(!0,o)),e.prototype.navigateTo.call(this,"Month",new Date(this.currentDate.getFullYear(),0,1)),this.keyNavigation(o,i);break;case"altRightArrow":t.isNullOrUndefined(f)?t.isNullOrUndefined(y)?t.isNullOrUndefined(g)||this.cancelButton.element.focus():t.isNullOrUndefined(this.presetElement)?this.cancelButton.element.focus():(this.presetElement.focus(),this.removeFocusedDate()):this.rightCalendar.children[1].firstElementChild.focus(),i.preventDefault();break;case"altLeftArrow":t.isNullOrUndefined(f)?t.isNullOrUndefined(y)||this.leftCalendar.children[1].firstElementChild.focus():!0!==this.applyButton.element.disabled?this.applyButton.element.focus():this.cancelButton.element.focus(),i.preventDefault();break;case"controlUp":this.calendarElement.classList.contains(Y),this.calendarNavigation(i,this.calendarElement),i.preventDefault();break;case"controlDown":t.isNullOrUndefined(u)&&t.isNullOrUndefined(d)||v||(t.isNullOrUndefined(this.value)||(s=this.calendarElement.classList.contains(Y)?this.startDate:this.endDate),this.controlDown=i,this.contentClick(null,--n,u||d,s)),i.preventDefault();break;case"controlEnd":D=new Date(this.currentDate.getFullYear(),11,31);h&&+D>+r&&(o=this.keyCalendarUpdate(!1,o)),e.prototype.navigateTo.call(this,"Month",new Date(this.currentDate.getFullYear(),11,31)),this.keyNavigation(o,i);break;case"pageUp":a=new Date(+this.currentDate),this.addMonths(a,-1),!h&&+a<=+l&&(o=this.keyCalendarUpdate(!0,o)),this.addMonths(this.currentDate,-1),e.prototype.navigateTo.call(this,"Month",this.currentDate),this.keyNavigation(o,i);break;case"pageDown":a=new Date(+this.currentDate),this.addMonths(a,1),h&&+a>=+r&&(o=this.keyCalendarUpdate(!1,o)),this.addMonths(this.currentDate,1),e.prototype.navigateTo.call(this,"Month",this.currentDate),this.keyNavigation(o,i);break;case"shiftPageUp":a=new Date(+this.currentDate),this.addYears(a,-1),!h&&+a<=+l&&(o=this.keyCalendarUpdate(!0,o)),this.addYears(this.currentDate,-1),e.prototype.navigateTo.call(this,"Month",this.currentDate),this.keyNavigation(o,i);break;case"shiftPageDown":a=new Date(+this.currentDate),this.addYears(a,1),h&&+a>=+r&&(o=this.keyCalendarUpdate(!1,o)),this.addYears(this.currentDate,1),e.prototype.navigateTo.call(this,"Month",this.currentDate),this.keyNavigation(o,i);break;case"shiftTab":t.isNullOrUndefined(this.presetElement)||(this.presetElement.setAttribute("tabindex","0"),this.presetElement.focus(),this.removeFocusedDate()),i.preventDefault();break;case"spacebar":this.applyButton&&!this.applyButton.disabled&&this.applyFunction(i);break;default:this.navInCalendar(i,h,l,r,o),this.checkMinMaxDays()}this.presetHeight()},r.prototype.keyNavigation=function(e,t){this.bindCalendarCellEvents(e),e.classList.contains(Y)?this.leftCalCurrentDate=new Date(+this.currentDate):this.rightCalCurrentDate=new Date(+this.currentDate),this.updateNavIcons(),this.calendarIconEvent(),this.updateRange([e]),this.dateDisabled=this.isDateDisabled(this.currentDate),t.preventDefault()},r.prototype.inputHandler=function(e){switch(e.action){case"altDownArrow":this.isPopupOpen()||(""===this.inputElement.value&&(this.clear(),this.changeTrigger(e),this.clearRange()),this.show(null,e),this.isRangeIconClicked=!1,this.isMobile||t.isNullOrUndefined(this.leftCalendar)||this.calendarFocus(),this.isKeyPopup=!0);break;case"escape":this.isPopupOpen()&&this.hide(e);break;case"enter":document.activeElement===this.inputElement&&(this.inputBlurHandler(e),this.hide(e));break;case"tab":document.activeElement===this.inputElement&&this.isPopupOpen()&&(this.hide(e),e.preventDefault())}},r.prototype.bindCalendarCellEvents=function(e){for(var i=0,s=e?e.querySelectorAll("."+te+" td"):this.popupObj.element.querySelectorAll("."+te+" td");i<s.length;i++){var a=s[i];t.EventHandler.clearEvents(a);a.classList.contains(Q)||a.classList.contains(de)||a.classList.contains(ue)||(this.isMobile||t.EventHandler.add(a,"mouseover",this.hoverSelection,this),t.EventHandler.add(a,"mousedown",this.selectRange,this))}},r.prototype.removeFocusedDate=function(){for(var e=!t.isNullOrUndefined(this.startValue)||!t.isNullOrUndefined(this.endValue),i=0,s=this.popupObj.element.querySelectorAll("."+te+" ."+le);i<s.length;i++){var a=s[i],n=new Date,r=this.getIdValue(null,a);("Month"===this.depth&&"Month"===this.currentView()&&(!a.classList.contains("e-today")||a.classList.contains("e-today")&&e)||"Year"===this.depth&&"Year"===this.currentView()&&(!this.isSameMonth(n,r)&&!this.isSameYear(n,r)||e)||"Decade"===this.depth&&"Decade"===this.currentView()&&(!this.isSameYear(n,r)||e))&&(a.classList.remove(le),a.classList.contains(K)||a.classList.contains(_)||a.removeAttribute("aria-label"))}},r.prototype.hoverSelection=function(e,i){var s=i||e.currentTarget,a=this.getIdValue(null,s);if(!t.isNullOrUndefined(this.startValue)&&+this.startValue>=+this.min&&+this.startValue<=+this.max&&(!this.isDateDisabled(this.endValue)&&!this.isDateDisabled(this.startValue)&&t.isNullOrUndefined(this.endValue)&&t.isNullOrUndefined(this.startValue)||!t.isNullOrUndefined(this.startValue)&&t.isNullOrUndefined(this.endValue)))for(var n=0,r=this.popupObj.element.querySelectorAll("."+te+" td");n<r.length;n++){var l=r[n],o=!l.classList.contains(Q)||l.classList.contains(de);if(!l.classList.contains(ue)&&o){var h=this.getIdValue(null,l),u=new Date(+this.startValue);new Date(+h).setHours(0,0,0,0)>=u.setHours(0,0,0,0)&&+h<=+a?t.addClass([l],Z):t.removeClass([l],[Z])}}},r.prototype.isSameStartEnd=function(e,t){var i=!1;return"Month"===this.depth?e.setHours(0,0,0,0)===t.setHours(0,0,0,0)&&(i=!0):"Year"===this.depth?e.getFullYear()===t.getFullYear()&&e.getMonth()===t.getMonth()&&(i=!0):"Decade"===this.depth&&e.getFullYear()===t.getFullYear()&&(i=!0),i},r.prototype.updateRange=function(e){if(!t.isNullOrUndefined(this.startValue))for(var i=0,s=e;i<s.length;i++)for(var a=0,n=s[i].querySelectorAll("."+te+" td");a<n.length;a++){var r=n[a];if(!r.classList.contains(ue)&&!r.classList.contains(Q)){var l=this.getIdValue(null,r),o=this.getIdValue(null,r);if(t.isNullOrUndefined(this.endValue)?t.removeClass([r],[Z]):this.currentView()===this.depth&&+o.setHours(0,0,0,0)>=+new Date(+this.startValue).setHours(0,0,0,0)&&+o.setHours(0,0,0,0)<=+new Date(+this.endValue).setHours(0,0,0,0)&&!this.isSameStartEnd(new Date(+this.startValue),new Date(+this.endValue))&&+new Date(+this.startValue).setHours(0,0,0,0)>=+this.min&&+new Date(+this.endValue).setHours(0,0,0,0)<=+this.max&&!this.isDateDisabled(this.startValue)&&!this.isDateDisabled(this.endValue)&&t.addClass([r],Z),r.classList.contains(ee)&&r.classList.contains(_)&&+o!=+this.endValue&&(t.removeClass([r],[ee]),t.removeClass([r],[_])),r.classList.contains(Z)&&+o>+this.endValue&&t.removeClass([r],[Z]),!r.classList.contains(X)){var h=new Date(+this.startValue),u=new Date(+l);this.currentView()===this.depth&&+u.setHours(0,0,0,0)==+h.setHours(0,0,0,0)&&+u.setHours(0,0,0,0)>=+h.setHours(0,0,0,0)&&+this.startValue>=+this.min&&!this.inputWrapper.container.classList.contains("e-error")&&!this.isDateDisabled(this.startValue)&&!this.isDateDisabled(this.endValue)&&(t.addClass([r],[K,ee]),this.addSelectedAttributes(r,this.startValue,!0));var d=new Date(+this.endValue);"Year"===this.currentView()?u=new Date(u.getFullYear(),u.getMonth()+1,0):"Decade"===this.currentView()&&(u=new Date(u.getFullYear(),11,31)),this.currentView()===this.depth&&!t.isNullOrUndefined(this.endValue)&&+u.setHours(0,0,0,0)==+d.setHours(0,0,0,0)&&+u.setHours(0,0,0,0)<=+d.setHours(0,0,0,0)&&+this.startValue>=+this.min&&!this.inputWrapper.container.classList.contains("e-error")&&!this.isDateDisabled(this.startValue)&&!this.isDateDisabled(this.endValue)&&(t.addClass([r],[_,ee]),this.addSelectedAttributes(r,this.startValue,!1)),+l!=+this.startValue||t.isNullOrUndefined(this.endValue)||+l!=+this.endValue||this.addSelectedAttributes(r,this.endValue,!1,!0)}}}},r.prototype.checkMinMaxDays=function(){(!t.isNullOrUndefined(this.minDays)&&this.minDays>0||!t.isNullOrUndefined(this.maxDays)&&this.maxDays>0)&&(this.isMobile?this.updateMinMaxDays(this.popupObj.element.querySelector("."+te)):(this.updateMinMaxDays(this.popupObj.element.querySelector("."+Y)),this.updateMinMaxDays(this.popupObj.element.querySelector("."+R))))},r.prototype.rangeArgs=function(e){var i,s,a=t.isNullOrUndefined(this.startValue)?null:this.globalize.formatDate(this.startValue,{format:this.formatString,type:"date",skeleton:"yMd"}),n=t.isNullOrUndefined(this.endValue)?null:this.globalize.formatDate(this.endValue,{format:this.formatString,type:"date",skeleton:"yMd"});t.isNullOrUndefined(this.endValue)||t.isNullOrUndefined(this.startValue)?(i="",s=0):(i=a+" "+this.separator+" "+n,s=Math.round(Math.abs((this.removeTimeValueFromDate(this.startValue).getTime()-this.removeTimeValueFromDate(this.endValue).getTime())/864e5))+1);return{value:this.value,startDate:this.startValue,endDate:this.endValue,daySpan:s,event:e||null,element:this.element,isInteracted:!t.isNullOrUndefined(e),text:i}},r.prototype.otherMonthSelect=function(e,i,s){var a=+this.getIdValue(null,e),n='*[id^="/id"]:not(.e-other-month)'.replace("/id",""+a),r=this.popupObj&&this.popupObj.element.querySelector(n);t.isNullOrUndefined(r)||(i?(t.addClass([r],[K,ee]),this.addSelectedAttributes(r,this.startValue,!0)):(t.addClass([r],[_,ee]),this.addSelectedAttributes(r,this.endValue,!0)),s&&this.addSelectedAttributes(e,this.endValue,!1,!0))},r.prototype.selectRange=function(e,i){var s,a;e&&e.preventDefault();var n=t.isNullOrUndefined(e)?this.getIdValue(null,i):this.getIdValue(e,null),r=n.getFullYear(),l=n.getMonth(),o=new Date(r,l,1),h=new Date(r,l+1,0),u=new Date(r,0,1),d=new Date(r,11,31);t.isNullOrUndefined(this.endValue)||t.isNullOrUndefined(this.startValue)?this.isMobile&&this.startButton.element.classList.contains(q)&&this.removeSelection():(!this.isMobile||this.isMobile&&!this.endButton.element.classList.contains(q))&&this.removeSelection();var p=i||e.currentTarget;if(t.isNullOrUndefined(this.startValue))t.isNullOrUndefined(this.previousStartValue)||(n.setHours(this.previousStartValue.getHours()),n.setMinutes(this.previousStartValue.getMinutes()),n.setSeconds(this.previousStartValue.getSeconds())),this.startValue="Month"===this.depth?new Date(this.checkValue(n)):"Year"===this.depth?o:u,this.endValue=null,this.setValue(),t.addClass([p],K),this.addSelectedAttributes(p,this.startValue,!0),p.classList.contains(X)&&this.otherMonthSelect(p,!0),this.checkMinMaxDays(),this.applyButton.disabled=!0,this.applyButton.element.disabled=!0,this.isMobile&&(this.endButton.element.classList.add(q),this.startButton.element.classList.remove(q),this.endButton.element.removeAttribute("disabled"),this.selectableDates()),this.trigger("select",this.rangeArgs(e));else if(+n==+this.startValue||+n>+this.startValue){if(+n==+this.startValue&&!t.isNullOrUndefined(this.minDays)&&this.minDays>1)return;this.endValue=null,this.setValue(),(this.isMobile||i)&&this.hoverSelection(e,i),t.isNullOrUndefined(this.previousEndValue)||(n.setHours(this.previousEndValue.getHours()),n.setMinutes(this.previousEndValue.getMinutes()),n.setSeconds(this.previousEndValue.getSeconds())),this.endValue="Month"===this.depth?new Date(this.checkValue(n)):"Year"===this.depth?h:d,this.setValue();var c=this.popupObj.element.querySelectorAll("."+_);if(this.isMobile){this.startButton.element.classList.remove(q),this.endButton.element.classList.add(q);for(var m=0,v=c;m<v.length;m++){var f=v[m];f.removeAttribute("aria-label"),f.classList.contains(K)?(this.addSelectedAttributes(f,this.startValue,!0),t.removeClass([f],[_])):(f.setAttribute("aria-selected","false"),t.removeClass([f],[_,ee]))}}t.addClass([p],_),+this.endValue==+this.startValue?this.addSelectedAttributes(p,this.endValue,!1,!0):this.addSelectedAttributes(p,this.endValue,!1),p.classList.contains(X)&&(+this.endValue==+this.startValue?this.otherMonthSelect(p,!1,!0):this.otherMonthSelect(p,!1));for(var y=0,g=c=this.popupObj.element.querySelectorAll("."+_);y<g.length;y++){var b=g[y];b.classList.contains(K)&&t.removeClass([b],[Z])}this.applyButton.disabled=!1,this.applyButton.element.disabled=!1,this.isMobile||this.removeClassDisabled(),this.disabledDateRender(),this.trigger("select",this.rangeArgs(e))}else+n<+this.startValue&&(this.removeClassDisabled(),this.startValue="Month"===this.depth?new Date(this.checkValue(n)):"Year"===this.depth?o:u,this.setValue(),this.removeSelectedAttributes(),t.removeClass(this.popupObj.element.querySelectorAll("."+K),[K,ee]),t.addClass([p],K),this.addSelectedAttributes(p,this.startValue,!0),p.classList.contains(X)&&this.otherMonthSelect(p,!0),this.checkMinMaxDays());e&&(s=t.closest(e.target,"."+Y)),t.isNullOrUndefined(s)?(e&&(a=e&&t.closest(e.target,"."+R)),t.isNullOrUndefined(a)||this.rightCalendar.children[1].firstElementChild.focus()):this.leftCalendar.children[1].firstElementChild.focus(),t.addClass([p],ee),this.updateHeader(),this.removeFocusedDate()},r.prototype.selectableDates=function(){if(!t.isNullOrUndefined(this.startValue)){var e=this.calendarElement.querySelectorAll("."+te+" td"),i=!1;if(this.currentView()===this.depth){for(var s=0,a=e;s<a.length;s++){if(!(l=a[s]).classList.contains(K)&&!l.classList.contains(ue)&&!l.classList.contains(Q)){if(+this.getIdValue(null,l)<+this.startValue){t.addClass([l],[de,Q,ce]),t.EventHandler.clearEvents(l);continue}break}if(l.classList.contains(K)&&!l.classList.contains(X)){i=!0;break}}i&&(this.previousIcon.classList.contains(Q)||t.addClass([this.previousIcon],[pe,Q,ce]))}else{for(var n=0,r=e;n<r.length;n++){var l=r[n],o=this.startValue.getMonth(),h=this.startValue.getFullYear(),u=this.getIdValue(null,l);if(this.startButton.element.classList.contains(q)||!("Year"===this.currentView()&&u.getMonth()<o&&u.getFullYear()<=h||"Decade"===this.currentView()&&u.getMonth()<=o&&u.getFullYear()<h))break;t.addClass([l],[Q])}e[0].classList.contains(Q)?this.previousIconHandler(!0):e[e.length-1].classList.contains(Q)&&this.nextIconHandler(!0)}}},r.prototype.updateMinMaxDays=function(e){if(!t.isNullOrUndefined(this.startValue)&&t.isNullOrUndefined(this.endValue)||this.isMobile&&this.endButton.element.classList.contains(q)){if(!t.isNullOrUndefined(this.minDays)&&this.minDays>0||!t.isNullOrUndefined(this.maxDays)&&this.maxDays>0){var i=this.removeTimeValueFromDate(this.startValue),s=new Date(new Date(+i).setDate(i.getDate()+(this.minDays-1))),a=new Date(new Date(+i).setDate(i.getDate()+(this.maxDays-1)));s=!t.isNullOrUndefined(this.minDays)&&this.minDays>0?s:null,a=!t.isNullOrUndefined(this.maxDays)&&this.maxDays>0?a:null,"Year"===this.currentView()?(s=t.isNullOrUndefined(s)?null:new Date(s.getFullYear(),s.getMonth(),0),a=t.isNullOrUndefined(a)?null:new Date(a.getFullYear(),a.getMonth(),1)):"Decade"===this.currentView()&&(s=t.isNullOrUndefined(s)?null:new Date(s.getFullYear()-1,11,1),a=t.isNullOrUndefined(a)?null:new Date(a.getFullYear(),0,1));for(var n=void 0,r=0,l=e.querySelectorAll("."+te+" td");r<l.length;r++){var o=l[r];if(!o.classList.contains(K)&&!o.classList.contains(ue)){var h=this.getIdValue(null,o);if(h=this.removeTimeValueFromDate(h),!t.isNullOrUndefined(s)&&+h==+s&&o.classList.contains(Q)&&s.setDate(s.getDate()+1),!o.classList.contains(Q)){if(+h<=+i)continue;!t.isNullOrUndefined(s)&&+h<+s&&(t.addClass([o],[de,Q,ce]),t.EventHandler.clearEvents(o)),!t.isNullOrUndefined(a)&&+h>+a&&(t.addClass([o],[de,Q,ce]),this.isMaxDaysClicked=!0,t.EventHandler.clearEvents(o),t.isNullOrUndefined(n)&&!o.classList.contains(X)&&(n=o))}}}if(!t.isNullOrUndefined(n))if(this.isMobile)this.nextIcon.classList.contains(Q)||t.addClass([this.nextIcon],[pe,Q,ce]);else{var u=t.closest(n,"."+R);(u=t.isNullOrUndefined(u)?this.leftCalendar:u).classList.contains(Y)?(this.rightCalNextIcon.classList.contains(Q)||t.addClass([this.rightCalNextIcon],[pe,Q,ce]),this.leftCalNextIcon.classList.contains(Q)||t.addClass([this.leftCalNextIcon],[pe,Q,ce]),this.rightCalPrevIcon.classList.contains(Q)||t.addClass([this.rightCalPrevIcon],[pe,Q,ce])):this.rightCalNextIcon.classList.contains(Q)||t.addClass([this.rightCalNextIcon],[pe,Q,ce])}}}else this.isMaxDaysClicked=!1},r.prototype.removeTimeValueFromDate=function(e){return new Date(e.getFullYear(),e.getMonth(),e.getDate())},r.prototype.removeClassDisabled=function(){for(var e=0,i=this.popupObj.element.querySelectorAll("."+te+" td."+de);e<i.length;e++){var s=i[e];s.classList.contains(de)&&(t.removeClass([s],[de,Q,ce]),t.EventHandler.add(s,"click",this.selectRange,this),this.isMobile||t.EventHandler.add(s,"mouseover",this.hoverSelection,this))}this.isMobile?(this.nextIcon.classList.contains(pe)&&t.removeClass([this.nextIcon],[pe,Q,ce]),this.previousIcon.classList.contains(pe)&&t.removeClass([this.previousIcon],[pe,Q,ce])):(this.rightCalNextIcon.classList.contains(pe)&&t.removeClass([this.rightCalNextIcon],[pe,Q,ce]),this.rightCalPrevIcon.classList.contains(pe)&&t.removeClass([this.rightCalPrevIcon],[pe,Q,ce]),this.leftCalNextIcon.classList.contains(pe)&&t.removeClass([this.leftCalNextIcon],[pe,Q,ce]))},r.prototype.updateHeader=function(){var e={type:"date",skeleton:"yMMMd"};if(t.isNullOrUndefined(this.endValue)||t.isNullOrUndefined(this.startValue))this.popupObj.element.querySelector("."+he).textContent=this.l10n.getConstant("selectedDays");else{var i=Math.round(Math.abs((this.removeTimeValueFromDate(this.startValue).getTime()-this.removeTimeValueFromDate(this.endValue).getTime())/864e5))+1;t.isNullOrUndefined(this.disabledDayCnt)||(i-=this.disabledDayCnt,this.disabledDayCnt=null),this.popupObj.element.querySelector("."+he).textContent=i.toString()+" "+this.l10n.getConstant("days")}this.isMobile?(t.isNullOrUndefined(this.startValue)?this.startButton.element.textContent=this.l10n.getConstant("startLabel"):this.startButton.element.textContent=this.globalize.formatDate(this.startValue,e),t.isNullOrUndefined(this.endValue)||t.isNullOrUndefined(this.startValue)?this.endButton.element.textContent=this.l10n.getConstant("endLabel"):this.endButton.element.textContent=this.globalize.formatDate(this.endValue,e)):(t.isNullOrUndefined(this.endValue)||t.isNullOrUndefined(this.startValue)?this.popupObj.element.querySelector("."+$).textContent=this.l10n.getConstant("endLabel"):this.popupObj.element.querySelector("."+$).textContent=this.globalize.formatDate(this.endValue,e),t.isNullOrUndefined(this.startValue)?this.popupObj.element.querySelector("."+J).textContent=this.l10n.getConstant("startLabel"):this.popupObj.element.querySelector("."+J).textContent=this.globalize.formatDate(this.startValue,e)),(this.isDateDisabled(this.startValue)||this.isDateDisabled(this.endValue)||!t.isNullOrUndefined(this.startValue)&&+this.startValue<+this.min||!t.isNullOrUndefined(this.endValue)&&+this.endValue>+this.max||!t.isNullOrUndefined(this.startValue)&&!t.isNullOrUndefined(this.endValue)&&+this.startValue>+this.endValue)&&(this.isMobile?(this.startButton.element.textContent=this.l10n.getConstant("startLabel"),this.endButton.element.textContent=this.l10n.getConstant("endLabel"),this.popupObj.element.querySelector("."+he).textContent=this.l10n.getConstant("selectedDays")):(this.popupObj.element.querySelector("."+he).textContent=this.l10n.getConstant("selectedDays"),this.popupObj.element.querySelector("."+J).textContent=this.l10n.getConstant("startLabel"),this.popupObj.element.querySelector("."+$).textContent=this.l10n.getConstant("endLabel"))),this.popupObj.element.querySelector("#custom_range")&&(this.popupObj.element.querySelector("#custom_range").textContent=""!==this.l10n.getConstant("customRange")?this.l10n.getConstant("customRange"):"Custom Range")},r.prototype.removeSelection=function(){this.startValue=null,this.endValue=null,this.setValue(),this.removeSelectedAttributes(),this.popupObj&&(this.popupObj.element.querySelectorAll("."+ee).length>0&&t.removeClass(this.popupObj.element.querySelectorAll("."+ee),[K,_,ee]),this.popupObj.element.querySelectorAll("."+le).length>0&&t.removeClass(this.popupObj.element.querySelectorAll("."+le),le),this.popupObj.element.querySelectorAll("."+Z).length>0&&t.removeClass(this.popupObj.element.querySelectorAll("."+Z),[Z]))},r.prototype.addSelectedAttributes=function(e,i,s,a){if(e){var n=this.globalize.formatDate(i,{type:"date",skeleton:"full"});!t.isNullOrUndefined(a)&&a?e.setAttribute("aria-label","The current start and end date is "+n):e.setAttribute("aria-label","The current "+(s?"start":"end")+" date is "+n),e.setAttribute("aria-selected","true")}},r.prototype.removeSelectedAttributes=function(){if(this.popupObj){for(var e=0,t=this.popupObj.element.querySelectorAll("."+K);e<t.length;e++){(a=t[e]).setAttribute("aria-selected","false"),a.removeAttribute("aria-label")}for(var i=0,s=this.popupObj.element.querySelectorAll("."+_);i<s.length;i++){var a;(a=s[i]).setAttribute("aria-selected","false"),a.removeAttribute("aria-label")}}},r.prototype.updateCalendarElement=function(e){e.classList.contains(Y)?(this.calendarElement=this.leftCalendar,this.currentDate=this.leftCalCurrentDate,this.previousIcon=this.leftCalPrevIcon,this.nextIcon=this.leftCalNextIcon):(this.calendarElement=this.rightCalendar,this.currentDate=this.rightCalCurrentDate,this.previousIcon=this.rightCalPrevIcon,this.nextIcon=this.rightCalNextIcon),this.contentElement=e.querySelector("."+oe),this.tableBodyElement=t.select(".e-content tbody",e),this.table=e.querySelector("."+oe).getElementsByTagName("table")[0],this.headerTitleElement=e.querySelector(".e-header ."+se),this.headerElement=e.querySelector("."+ie)},r.prototype.navPrevMonth=function(e){e.preventDefault();var i=t.closest(e.target,"."+Y);i=t.isNullOrUndefined(i)?t.closest(e.target,"."+R):i,this.updateCalendarElement(i),this.navigatePrevious(e),!t.isNullOrUndefined(this.startValue)&&t.isNullOrUndefined(this.endValue)&&this.updateMinMaxDays(i),this.updateControl(i)},r.prototype.deviceNavigation=function(e){this.deviceCalendarEvent(),this.updateRange([this.popupObj.element.querySelector("."+te)]),this.endButton.element.classList.contains(q)&&this.updateMinMaxDays(this.popupObj.element.querySelector("."+te)),this.endButton.element.classList.contains(q)&&this.selectableDates(),this.currentView()===this.depth&&this.bindCalendarCellEvents(),this.removeFocusedDate()},r.prototype.updateControl=function(e){e.classList.contains(R)?this.rightCalCurrentDate=new Date(+this.currentDate):this.leftCalCurrentDate=new Date(+this.currentDate),this.calendarIconEvent(),("Month"===this.depth&&this.leftCalendar.querySelector(".e-content").classList.contains("e-month")&&this.rightCalendar.querySelector(".e-content").classList.contains("e-month")||"Year"===this.depth&&this.leftCalendar.querySelector(".e-content").classList.contains("e-year")&&this.rightCalendar.querySelector(".e-content").classList.contains("e-year")||"Decade"===this.depth&&this.leftCalendar.querySelector(".e-content").classList.contains("e-decade")&&this.rightCalendar.querySelector(".e-content").classList.contains("e-decade")||this.isMobile)&&this.bindCalendarCellEvents(),this.removeFocusedDate(),this.updateRange([e])},r.prototype.navNextMonth=function(e){e.preventDefault();var i=t.closest(e.target,"."+Y);i=t.isNullOrUndefined(i)?t.closest(e.target,"."+R):i,this.updateCalendarElement(i),this.navigateNext(e),!t.isNullOrUndefined(this.startValue)&&t.isNullOrUndefined(this.endValue)&&this.updateMinMaxDays(i),this.updateControl(i)},r.prototype.isPopupOpen=function(){return!(t.isNullOrUndefined(this.popupObj)||!this.popupObj.element.classList.contains("e-popup"))},r.prototype.createRangeHeader=function(){var e=this.createElement("div",{className:"e-start-end"});if(this.isMobile){var i=this.createElement("button",{className:"e-end-btn"}),s=this.createElement("button",{className:"e-start-btn"});this.startButton=new a.Button({content:this.l10n.getConstant("startLabel")},s),this.endButton=new a.Button({content:this.l10n.getConstant("endLabel")},i),e.appendChild(s),e.appendChild(i)}else{var n=this.createElement("a",{className:J}),r=this.createElement("a",{className:$}),l=this.createElement("span",{className:"e-change-icon e-icons"});t.attributes(n,{"aria-atomic":"true","aria-live":"assertive","aria-label":"Start Date",role:"button"}),t.attributes(r,{"aria-atomic":"true","aria-live":"assertive","aria-label":"End Date",role:"button"}),e.appendChild(n),e.appendChild(l),e.appendChild(r),n.textContent=this.l10n.getConstant("startLabel"),r.textContent=this.l10n.getConstant("endLabel")}return e},r.prototype.disableInput=function(){this.strictMode?t.isNullOrUndefined(this.previousStartValue)||t.isNullOrUndefined(this.previousEndValue)||(this.startValue=this.previousStartValue,this.endValue=this.previousEndValue,this.setValue(),this.updateInput()):(this.updateInput(),this.clearRange(),this.setProperties({startDate:null},!0),this.setProperties({endDate:null},!0),this.startValue=null,this.endValue=null,this.setValue(),this.errorClass()),this.setProperties({enabled:!1},!0),s.Input.setEnabled(this.enabled,this.inputElement),this.bindEvents()},r.prototype.validateMinMax=function(){this.min=t.isNullOrUndefined(this.min)||!+this.min?this.min=new Date(1900,0,1):this.min,this.max=t.isNullOrUndefined(this.max)||!+this.max?this.max=new Date(2099,11,31):this.max,this.min<=this.max?(t.isNullOrUndefined(this.minDays)||t.isNullOrUndefined(this.maxDays)||this.maxDays>0&&this.minDays>0&&this.minDays>this.maxDays&&(this.maxDays=null),!t.isNullOrUndefined(this.minDays)&&this.minDays<0&&(this.minDays=null),!t.isNullOrUndefined(this.maxDays)&&this.maxDays<0&&(this.maxDays=null)):this.disableInput()},r.prototype.validateRangeStrict=function(){t.isNullOrUndefined(this.startValue)||(+this.startValue<=+this.min?(this.startValue=this.min,this.setValue()):+this.startValue>=+this.min&&+this.startValue>=+this.max&&(this.startValue=this.max)),t.isNullOrUndefined(this.endValue)||(+this.endValue>+this.max?(this.endValue=this.max,this.setValue()):+this.endValue<+this.min&&(this.endValue=this.min,this.setValue())),this.validateMinMaxDays()},r.prototype.validateRange=function(){this.validateMinMaxDays()},r.prototype.validateMinMaxDays=function(){if(!t.isNullOrUndefined(this.startValue)&&!t.isNullOrUndefined(this.endValue)){var e=Math.round(Math.abs((this.removeTimeValueFromDate(this.startValue).getTime()-this.removeTimeValueFromDate(this.endValue).getTime())/864e5))+1;if(!t.isNullOrUndefined(this.minDays)&&this.minDays>0&&!(e>=this.minDays))if(this.strictMode){var i=new Date(+this.startValue);i.setDate(i.getDate()+(this.minDays-1)),+i>+this.max?(this.endValue=this.max,this.setValue()):(this.endValue=i,this.setValue())}else this.startValue=null,this.endValue=null,this.setValue();t.isNullOrUndefined(this.maxDays)||!(this.maxDays>0)||e<=this.maxDays||(this.strictMode?(this.endValue=new Date(+this.startValue),this.endValue.setDate(this.endValue.getDate()+(this.maxDays-1)),this.setValue()):(this.startValue=null,this.endValue=null,this.setValue()))}},r.prototype.renderCalendar=function(){this.calendarElement=this.createElement("div"),this.calendarElement.classList.add(te),this.enableRtl&&this.calendarElement.classList.add("e-rtl"),t.attributes(this.calendarElement,{role:"calendar"}),e.prototype.createHeader.call(this),e.prototype.createContent.call(this)},r.prototype.isSameMonth=function(e,t){return e.getMonth()===t.getMonth()&&e.getFullYear()===t.getFullYear()},r.prototype.isSameYear=function(e,t){return e.getFullYear()===t.getFullYear()},r.prototype.isSameDecade=function(e,t){var i=e.getFullYear(),s=t.getFullYear();return i-i%10==s-s%10},r.prototype.startMonthCurrentDate=function(){this.isSameMonth(this.min,this.max)||+this.currentDate>+this.max||this.isSameMonth(this.currentDate,this.max)?(this.currentDate=new Date(+this.max),this.currentDate.setDate(1),this.currentDate.setMonth(this.currentDate.getMonth()-1)):this.currentDate<this.min&&(this.currentDate=new Date(this.checkValue(this.min)))},r.prototype.selectNextMonth=function(){if(t.isNullOrUndefined(this.endValue)||t.isNullOrUndefined(this.startValue)||this.isSameMonth(this.endValue,this.currentDate)||this.isDateDisabled(this.endValue)||this.isDateDisabled(this.startValue))return this.currentDate.setDate(1),void this.currentDate.setMonth(this.currentDate.getMonth()+1);if(this.currentDate=new Date(+this.endValue),!t.isNullOrUndefined(this.startValue)&&+this.startValue<+this.min||!t.isNullOrUndefined(this.endValue)&&+this.endValue>+this.max||!t.isNullOrUndefined(this.startValue)&&!t.isNullOrUndefined(this.endValue)&&+this.startValue>+this.endValue){this.currentDate=new Date((new Date).setHours(0,0,0,0)),this.currentDate.setDate(1);var e=this.currentDate.getMonth()+1;this.currentDate.setMonth(e)}},r.prototype.selectNextYear=function(){if(t.isNullOrUndefined(this.endValue)||t.isNullOrUndefined(this.startValue)||this.isSameYear(this.endValue,this.currentDate)||this.isDateDisabled(this.endValue)||this.isDateDisabled(this.startValue)){this.currentDate.setMonth(0);var e=this.currentDate.getFullYear()+1;this.currentDate.setFullYear(e)}else this.currentDate=new Date(+this.endValue),(!t.isNullOrUndefined(this.endValue)&&+this.endValue>+this.max||!t.isNullOrUndefined(this.startValue)&&!t.isNullOrUndefined(this.endValue)&&+this.startValue>+this.endValue||!t.isNullOrUndefined(this.startValue)&&+this.startValue<+this.min)&&(this.currentDate=new Date((new Date).setHours(0,0,0,0)),this.currentDate.setMonth(0),this.currentDate.setFullYear(this.currentDate.getFullYear()+1))},r.prototype.selectNextDecade=function(){if(t.isNullOrUndefined(this.endValue)||t.isNullOrUndefined(this.startValue)||this.isSameDecade(this.endValue,this.currentDate)||this.isDateDisabled(this.endValue)||this.isDateDisabled(this.startValue)){var e=this.currentDate.getFullYear()+10;this.currentDate.setFullYear(e)}else this.currentDate=new Date(+this.endValue),(!t.isNullOrUndefined(this.startValue)&&!t.isNullOrUndefined(this.endValue)&&+this.startValue>+this.endValue||!t.isNullOrUndefined(this.endValue)&&+this.endValue>+this.max||!t.isNullOrUndefined(this.startValue)&&+this.startValue<+this.min)&&(this.currentDate=new Date((new Date).setHours(0,0,0,0)),this.currentDate.setFullYear(this.currentDate.getFullYear()+10))},r.prototype.selectStartMonth=function(){t.isNullOrUndefined(this.startValue)?(this.currentDate=new Date((new Date).setHours(0,0,0,0)),this.startMonthCurrentDate()):!t.isNullOrUndefined(this.max)&&this.isSameMonth(this.startValue,this.max)?(this.currentDate=new Date(+this.max),this.currentDate.setDate(1),this.currentDate.setMonth(this.currentDate.getMonth()-1)):this.startValue>=this.min&&this.startValue<=this.max&&!this.isDateDisabled(this.startValue)?this.currentDate=new Date(+this.startValue):this.currentDate=new Date((new Date).setHours(0,0,0,0)),(!t.isNullOrUndefined(this.endValue)&&+this.endValue>+this.max||!t.isNullOrUndefined(this.startValue)&&+this.startValue<+this.min||!t.isNullOrUndefined(this.startValue)&&!t.isNullOrUndefined(this.endValue)&&+this.startValue>+this.endValue)&&(this.currentDate=new Date((new Date).setHours(0,0,0,0))),this.startMonthCurrentDate()},r.prototype.createCalendar=function(){var i=this.createElement("div",{className:"e-calendar-container"});if(this.isMobile){t.isNullOrUndefined(this.startValue)||(this.currentDate=new Date(+this.startValue)),e.prototype.validateDate.call(this),e.prototype.minMaxUpdate.call(this),e.prototype.render.call(this);var s=this.calendarElement.querySelector("."+te+" .e-prev"),a=this.calendarElement.querySelector("."+te+" .e-next");t.remove(this.calendarElement.querySelector("."+te+" ."+ae)),this.calendarElement.querySelector("."+te+" ."+ie).appendChild(a),this.calendarElement.querySelector("."+te+" ."+ie).appendChild(s),t.prepend([s],this.calendarElement.querySelector("."+te+" ."+ie)),this.deviceCalendar=this.calendarElement,i.appendChild(this.calendarElement),this.headerTitleElement=this.calendarElement.querySelector(".e-calendar .e-header ."+se)}else{this.selectStartMonth(),this.renderCalendar(),this.leftCalCurrentDate=new Date(+this.currentDate),this.calendarElement.classList.add(Y),this.leftCalPrevIcon=this.calendarElement.querySelector("."+Y+" .e-prev"),this.leftCalNextIcon=this.calendarElement.querySelector("."+Y+" .e-next"),this.leftTitle=this.calendarElement.querySelector("."+Y+" ."+se),t.remove(this.calendarElement.querySelector("."+Y+" ."+ae)),this.calendarElement.querySelector("."+Y+" ."+ie).appendChild(this.leftCalNextIcon),this.calendarElement.querySelector("."+Y+" ."+ie).appendChild(this.leftCalPrevIcon),t.prepend([this.leftCalPrevIcon],this.calendarElement.querySelector("."+Y+" ."+ie)),this.leftCalendar=this.calendarElement;var n=this.createElement("div",{className:"e-left-container"}),r=this.createElement("div",{className:"e-right-container"});n.appendChild(this.leftCalendar),i.appendChild(n),this.isMobile||t.EventHandler.add(this.leftTitle,"click",this.leftNavTitle,this),"Month"===this.start&&this.selectNextMonth(),"Year"===this.start&&this.selectNextYear(),"Decade"===this.start&&this.selectNextDecade(),this.renderCalendar(),this.rightCalCurrentDate=new Date(+this.currentDate),t.addClass([this.calendarElement],R),this.rightCalendar=this.calendarElement,t.removeClass([this.leftCalendar&&this.leftCalendar.querySelector(".e-content tbody")],"e-zoomin"),t.removeClass([this.rightCalendar&&this.rightCalendar.querySelector(".e-content tbody")],"e-zoomin"),this.rightCalPrevIcon=this.calendarElement.querySelector("."+R+" .e-prev"),this.rightCalNextIcon=this.calendarElement.querySelector("."+R+" .e-next"),this.rightTitle=this.calendarElement.querySelector("."+R+" ."+se),t.remove(this.calendarElement.querySelector("."+R+" ."+ae)),this.calendarElement.querySelector("table").setAttribute("tabindex","-1"),this.calendarElement.querySelector("."+R+" ."+ie).appendChild(this.rightCalNextIcon),this.calendarElement.querySelector("."+R+" ."+ie).appendChild(this.rightCalPrevIcon),t.prepend([this.rightCalPrevIcon],this.calendarElement.querySelector("."+R+" ."+ie)),r.appendChild(this.rightCalendar),i.appendChild(r),this.isMobile||t.EventHandler.add(this.rightTitle,"click",this.rightNavTitle,this)}return i},r.prototype.leftNavTitle=function(e){this.isPopupOpen()&&(this.calendarElement=this.leftCalendar,this.calendarNavigation(e,this.calendarElement))},r.prototype.calendarNavigation=function(t,i){this.table=i.querySelector("table"),this.headerTitleElement=i.querySelector(".e-title"),this.tableBodyElement=i.querySelector("tbody"),this.tableHeadElement=i.querySelector("thead"),this.contentElement=i.querySelector(".e-content"),this.updateCalendarElement(i),e.prototype.navigateTitle.call(this,t),this.updateNavIcons()},r.prototype.rightNavTitle=function(e){this.isPopupOpen()&&(this.calendarElement=this.rightCalendar,this.calendarNavigation(e,this.calendarElement))},r.prototype.clickEventEmitter=function(e){this.isMobile||(t.closest(e.target,".e-calendar.e-left-calendar")?(this.calendarElement=this.leftCalendar,this.updateCalendarElement(this.leftCalendar)):(this.calendarElement=this.rightCalendar,this.updateCalendarElement(this.rightCalendar)))},r.prototype.currentView=function(){return e.prototype.currentView.call(this)},r.prototype.getCalendarView=function(e){return"Year"===e?"Year":"Decade"===e?"Decade":"Month"},r.prototype.navigatedEvent=function(i){if(this.trigger("navigated",this.navigatedArgs),!t.isNullOrUndefined(this.popupObj)){var s=this.getCalendarView(this.currentView());this.isMobile?s===this.depth?(this.bindCalendarCellEvents(),this.deviceNavigation(),this.removeFocusedDate(),this.checkMinMaxDays()):this.selectableDates():this.isMobile||s!==this.depth?(this.updateNavIcons(),this.calendarIconEvent()):((this.calendarElement.classList.contains("e-left-calendar")?this.leftCalendar:this.rightCalendar)!==this.leftCalendar||(!i||i.currentTarget.children[0].classList.contains("e-icons"))&&t.isNullOrUndefined(this.controlDown)?(i&&!i.currentTarget.children[0].classList.contains("e-icons")||!t.isNullOrUndefined(this.controlDown))&&(this.rightCalCurrentDate=new Date(+this.currentDate),this.effect="",this.currentDate=this.rightCalCurrentDate,this.updateCalendarElement(this.rightCalendar),this.updateControl(this.rightCalendar),this.updateCalendarElement(this.leftCalendar),this.startValue&&t.isNullOrUndefined(this.endValue)?"Month"===s&&this.startValue.getMonth()<this.rightCalCurrentDate.getMonth()&&this.startValue.getFullYear()<=this.rightCalCurrentDate.getFullYear()?e.prototype.navigateTo.call(this,s,new Date(+this.startValue)):"Year"===s&&this.startValue.getFullYear()<this.rightCalCurrentDate.getFullYear()?e.prototype.navigateTo.call(this,s,new Date(+this.startValue)):e.prototype.navigateTo.call(this,s,this.leftCalCurrentDate):e.prototype.navigateTo.call(this,s,this.leftCalCurrentDate),this.updateControl(this.leftCalendar),this.updateNavIcons(),this.calendarIconEvent(),this.calendarIconRipple(),this.controlDown=null):(this.leftCalCurrentDate=new Date(+this.currentDate),this.effect="",this.currentDate=this.leftCalCurrentDate,this.updateCalendarElement(this.leftCalendar),this.updateControl(this.leftCalendar),this.updateCalendarElement(this.rightCalendar),e.prototype.navigateTo.call(this,s,this.rightCalCurrentDate),this.updateControl(this.rightCalendar),this.updateNavIcons(),this.calendarIconEvent(),this.calendarIconRipple(),this.controlDown=null),this.checkMinMaxDays())}},r.prototype.createControl=function(){var e=this.createElement("div",{className:ne}),i=this.createElement("div",{className:"e-range-header"}),s=this.createRangeHeader();i.appendChild(s);var n=this.createElement("div",{className:he});t.attributes(n,{"aria-label":"Selected Days"}),n.textContent=this.l10n.getConstant("selectedDays"),i.appendChild(n);var r=this.createElement("div",{className:"e-separator"}),l=this.createCalendar();e.appendChild(i),e.appendChild(r),e.appendChild(l);var o=this.createElement("div",{className:"e-footer"}),h=this.createElement("button",{className:"e-cancel e-flat e-css"}),u=this.createElement("button");t.addClass([u],["e-apply","e-flat","e-primary","e-css"]),o.appendChild(u),o.appendChild(h);var d=!t.isNullOrUndefined(this.startValue)&&!t.isNullOrUndefined(this.endValue);if(this.cancelButton=new a.Button({content:this.l10n.getConstant("cancelText")},h),this.applyButton=new a.Button({content:this.l10n.getConstant("applyText"),disabled:!d},u),t.EventHandler.add(u,"click",this.applyFunction,this),t.EventHandler.add(h,"click",this.cancelFunction,this),this.popupWrapper.appendChild(e),!this.isMobile&&!t.isUndefined(this.presets[0].start&&this.presets[0].end&&this.presets[0].label)){this.createPresets(),this.listRippleEffect(),t.addClass([e],"e-range-border"),t.addClass([this.popupWrapper],"e-preset-wrapper");this.popupWrapper.querySelector("."+re).style.height=this.popupWrapper.querySelector("."+ne).getBoundingClientRect().height+"px"}this.popupWrapper.appendChild(o),this.isMobile&&this.deviceHeaderUpdate(),this.renderPopup()},r.prototype.cancelFunction=function(e){document.activeElement!==this.inputElement&&(this.preventFocus=!0,this.inputElement.focus(),t.addClass([this.inputWrapper.container],[G])),e.preventDefault(),this.isKeyPopup&&(this.inputElement.focus(),this.isKeyPopup=!1),this.startValue=null,this.endValue=null,this.removeSelection(),this.hide(e)},r.prototype.deviceHeaderUpdate=function(){t.isNullOrUndefined(this.startValue)&&t.isNullOrUndefined(this.endValue)?(this.endButton.element.setAttribute("disabled",""),this.startButton.element.classList.add(q)):t.isNullOrUndefined(this.startValue)||this.startButton.element.classList.add(q)},r.prototype.applyFunction=function(e){var i=!1;"touchstart"!==e.type&&e.preventDefault(),this.closeEventArgs&&this.closeEventArgs.cancel&&(this.startValue=this.popupWrapper.querySelector(".e-start-date")&&this.getIdValue(null,this.popupWrapper.querySelector(".e-start-date")),this.endValue=this.popupWrapper.querySelector(".e-end-date")&&this.getIdValue(null,this.popupWrapper.querySelector(".e-end-date")),this.setValue()),document.activeElement!==this.inputElement&&(this.preventFocus=!0,this.inputElement.focus(),t.addClass([this.inputWrapper.container],[G])),"touchstart"!==e.type&&this.closeEventArgs&&!this.closeEventArgs.cancel&&e.preventDefault(),t.isNullOrUndefined(this.startValue)||t.isNullOrUndefined(this.endValue)?this.hide(e||null):(this.previousStartValue=new Date(+this.startValue),this.previousEndValue=new Date(+this.endValue),this.previousEleValue=this.inputElement.value,s.Input.setValue(this.rangeArgs(e).text,this.inputElement,this.floatLabelType,this.showClearButton),+this.initStartDate==+this.startValue&&+this.initEndDate==+this.endValue||(i=!0),this.changeTrigger(e),this.hide(e||null),this.errorClass(),i=!0),t.closest(e.target,".e-input-group")||i||this.focusOut(),this.isMobile||(this.isKeyPopup=!1,this.isRangeIconClicked&&(this.inputWrapper.container.children[1].focus(),this.keyInputConfigs=t.extend(this.keyInputConfigs,this.keyConfigs),this.popupKeyboardModule=new t.KeyboardEvents(this.inputWrapper.container.children[1],{eventName:"keydown",keyConfigs:this.keyInputConfigs,keyAction:this.popupKeyActionHandle.bind(this)})))},r.prototype.onMouseClick=function(e,i){if("touchstart"!==e.type){var s=i||e.target,a=t.closest(s,"."+me),n=a&&a.classList.contains(q);a&&a.classList.contains(me)&&this.setListSelection(a,e),this.preventFocus=!0,this.inputElement.focus(),this.isMobile||(this.preventFocus=!0,a&&a.classList.contains(me)&&"custom_range"===a.getAttribute("id")?this.leftCalendar.children[1].firstElementChild.focus():n||"keydown"!==e.type||this.inputElement.focus())}},r.prototype.onMouseOver=function(e){var i=t.closest(e.target,"."+me);i&&i.classList.contains(me)&&!i.classList.contains(ve)&&t.addClass([i],ve)},r.prototype.onMouseLeave=function(e){var i=t.closest(e.target,"."+ve);t.isNullOrUndefined(i)||t.removeClass([i],ve)},r.prototype.setListSelection=function(e,i){if(e&&(!e.classList.contains(q)||this.isMobile&&e.classList.contains(q))){if(this.isMobile&&e.classList.contains(q)){this.activeIndex=Array.prototype.slice.call(this.liCollections).indexOf(e);if("custom_range"===this.presetsItem[this.activeIndex].id)return void this.renderCustomPopup();return}this.removeListSelection(),this.activeIndex=Array.prototype.slice.call(this.liCollections).indexOf(e),t.addClass([e],q),e.setAttribute("aria-selected","true");var s=this.presetsItem[this.activeIndex];"custom_range"===s.id?this.renderCustomPopup():this.applyPresetRange(s,i)}},r.prototype.removeListSelection=function(){var e=this.presetElement.querySelector("."+q);t.isNullOrUndefined(e)||(t.removeClass([e],q),e.removeAttribute("aria-selected"))},r.prototype.setValue=function(){this.modelValue=[this.startValue,this.endValue]},r.prototype.applyPresetRange=function(e,t){this.hide(null),this.presetsItem[this.presetsItem.length-1].start=null,this.presetsItem[this.presetsItem.length-1].end=null,this.startValue=e.start,this.endValue=e.end,this.setValue(),this.refreshControl(),this.trigger("select",this.rangeArgs(t)),this.changeTrigger(t),this.previousEleValue=this.inputElement.value,this.isCustomRange=!1,this.leftCalendar=this.rightCalendar=null,this.isKeyPopup&&(this.isRangeIconClicked=!1,this.inputElement.focus())},r.prototype.showPopup=function(e,t){this.presetHeight(),1e3===this.zIndex?this.popupObj.show(null,this.element):this.popupObj.show(null,null),this.isMobile&&this.popupObj.refreshPosition()},r.prototype.renderCustomPopup=function(){this.isCustomWindow=!0,this.popupObj.hide(),this.popupWrapper=this.createElement("div",{id:this.element.id+"_popup",className:z+" e-popup"}),this.renderControl(),this.openEventArgs.appendTo.appendChild(this.popupWrapper),this.showPopup(),this.isCustomRange=!0,this.isMobile||this.calendarFocus()},r.prototype.listRippleEffect=function(){for(var e=0,i=this.liCollections;e<i.length;e++){var s=i[e];t.rippleEffect(s)}},r.prototype.createPresets=function(){if(!t.isUndefined(this.presets[0].start&&this.presets[0].end&&this.presets[0].label)){this.presetElement=this.createElement("div",{className:re,attrs:{tabindex:"0"}});var e=n.ListBase.createList(this.createElement,this.presetsItem,null,!0);t.attributes(e,{role:"listbox","aria-hidden":"false",id:this.element.id+"_options"}),this.presetElement.appendChild(e),this.popupWrapper.appendChild(this.presetElement);var i=this.presetElement.querySelector("#custom_range");t.isNullOrUndefined(i)||(i.textContent=""!==this.l10n.getConstant("customRange")?this.l10n.getConstant("customRange"):"Custom Range"),this.liCollections=this.presetElement.querySelectorAll("."+me),this.wireListEvents(),this.isMobile&&(this.presetElement.style.width=this.inputWrapper.container.getBoundingClientRect().width+"px"),!t.isNullOrUndefined(this.activeIndex)&&this.activeIndex>-1&&t.addClass([this.liCollections[this.activeIndex]],q)}},r.prototype.wireListEvents=function(){t.EventHandler.add(this.presetElement,"click",this.onMouseClick,this),this.isMobile||(t.EventHandler.add(this.presetElement,"mouseover",this.onMouseOver,this),t.EventHandler.add(this.presetElement,"mouseout",this.onMouseLeave,this))},r.prototype.unWireListEvents=function(){t.isNullOrUndefined(this.presetElement)||(t.EventHandler.remove(this.presetElement,"click touchstart",this.onMouseClick),this.isMobile||(t.EventHandler.remove(this.presetElement,"mouseover",this.onMouseOver),t.EventHandler.remove(this.presetElement,"mouseout",this.onMouseLeave)))},r.prototype.renderPopup=function(){var e=this;this.popupWrapper.classList.add("e-control");var s=this.popupWrapper.getBoundingClientRect().width;t.isNullOrUndefined(this.cssClass)||""===this.cssClass.trim()||(this.popupWrapper.className+=" "+this.cssClass),this.isMobile&&this.isCustomWindow&&(this.modal=this.createElement("div"),document.body.appendChild(this.modal)),this.popupObj=new i.Popup(this.popupWrapper,{relateTo:this.isMobile&&this.isCustomWindow?document.body:t.isNullOrUndefined(this.targetElement)?this.inputWrapper.container:this.targetElement,position:this.isMobile?t.isUndefined(this.presets[0].start&&this.presets[0].end&&this.presets[0].label)||this.isCustomWindow?{X:"center",Y:"center"}:{X:"left",Y:"bottom"}:this.enableRtl?{X:"left",Y:"bottom"}:{X:"right",Y:"bottom"},offsetX:this.isMobile||this.enableRtl?0:-s,offsetY:4,collision:this.isMobile?t.isUndefined(this.presets[0].start&&this.presets[0].end&&this.presets[0].label)||this.isCustomWindow?{X:"fit",Y:"fit"}:{X:"fit"}:{X:"fit",Y:"flip"},targetType:this.isMobile&&this.isCustomWindow?"container":"relative",enableRtl:this.enableRtl,zIndex:this.zIndex,open:function(){t.attributes(e.inputElement,{"aria-expanded":"true"}),t.addClass([e.inputWrapper.buttons[0]],q),e.isMobile||(e.cancelButton&&(e.btnKeyboardModule=new t.KeyboardEvents(e.cancelButton.element,{eventName:"keydown",keyAction:e.popupKeyActionHandle.bind(e),keyConfigs:{tab:"tab",altRightArrow:"alt+rightarrow",altLeftArrow:"alt+leftarrow"}}),e.btnKeyboardModule=new t.KeyboardEvents(e.applyButton.element,{eventName:"keydown",keyAction:e.popupKeyActionHandle.bind(e),keyConfigs:{altRightArrow:"alt+rightarrow",altLeftArrow:"alt+leftarrow"}})),t.isNullOrUndefined(e.leftCalendar)||e.isRangeIconClicked||e.calendarFocus(),t.isNullOrUndefined(e.presetElement)||(e.keyInputConfigs=t.extend(e.keyInputConfigs,e.keyConfigs),e.presetKeyboardModule=new t.KeyboardEvents(e.presetElement,{eventName:"keydown",keyAction:e.presetKeyActionHandler.bind(e),keyConfigs:e.keyInputConfigs}),e.presetKeyboardModule=new t.KeyboardEvents(e.presetElement,{eventName:"keydown",keyAction:e.popupKeyActionHandle.bind(e),keyConfigs:{altRightArrow:"alt+rightarrow",altLeftArrow:"alt+leftarrow"}}),t.isNullOrUndefined(e.leftCalendar)?(e.preventBlur=!0,e.presetElement.focus()):e.presetElement.setAttribute("tabindex","-1")),e.popupKeyBoardHandler()),e.isMobile&&!t.Browser.isDevice&&t.EventHandler.add(document,"keydown",e.popupCloseHandler,e)},close:function(){t.attributes(e.inputElement,{"aria-expanded":"false"}),t.removeClass([e.inputWrapper.buttons[0]],q),e.isRangeIconClicked&&e.inputWrapper.container.children[1].focus(),t.isUndefined(e.presets[0].start&&e.presets[0].end&&e.presets[0].label)||e.unWireListEvents(),t.isNullOrUndefined(e.popupObj)||(t.isNullOrUndefined(e.popupObj.element.parentElement)||t.detach(e.popupObj.element),e.popupObj.destroy(),e.popupObj=null),e.isMobile&&!t.Browser.isDevice&&t.EventHandler.remove(document,"keydown",e.popupCloseHandler)},targetExitViewport:function(){t.Browser.isDevice||e.hide()}}),this.isMobile&&(this.popupObj.element.classList.add("e-device"),this.isMobile||this.popupObj.element.classList.add("e-bigger")),this.isMobile&&this.isCustomWindow&&(t.addClass([this.modal],["e-device",z,"e-range-modal"]),document.body.className+=" "+fe,this.modal.style.display="block"),t.EventHandler.add(document,"mousedown touchstart",this.documentHandler,this)},r.prototype.popupCloseHandler=function(e){switch(e.keyCode){case 27:this.hide(e)}},r.prototype.calendarFocus=function(){var e=this.popupObj&&this.popupObj.element.querySelector("."+K);if(e){var i=t.closest(e,"."+R);i=t.isNullOrUndefined(i)?this.leftCalendar:i,this.isRangeIconClicked?this.inputWrapper.container.focus():(this.preventBlur=!0,i.children[1].firstElementChild.focus()),t.addClass([e],le)}else this.isRangeIconClicked?this.inputWrapper.container.focus():(this.preventBlur=!0,this.leftCalendar.children[1].firstElementChild.focus())},r.prototype.presetHeight=function(){var e=this.popupObj&&this.popupObj.element.querySelector("."+re),i=this.popupObj&&this.popupObj.element.querySelector("."+ne);t.isNullOrUndefined(e)||t.isNullOrUndefined(i)||(e.style.height=i.getBoundingClientRect().height+"px")},r.prototype.presetKeyActionHandler=function(e){switch(e.action){case"moveDown":this.listMoveDown(e),this.setScrollPosition(),e.preventDefault();break;case"moveUp":this.listMoveUp(e),this.setScrollPosition(),e.preventDefault();break;case"enter":var i=this.getHoverLI(),s=this.getActiveLI();if(!t.isNullOrUndefined(this.leftCalendar)&&!t.isNullOrUndefined(s)&&(t.isNullOrUndefined(i)||!t.isNullOrUndefined(s)&&s===i)){this.activeIndex=Array.prototype.slice.call(this.liCollections).indexOf(s);if("custom_range"===this.presetsItem[this.activeIndex].id)return this.calendarFocus(),s.classList.remove(ve),void e.preventDefault()}t.isNullOrUndefined(i)&&t.isNullOrUndefined(s)||this.onMouseClick(e,i||s),e.preventDefault();break;case"tab":if(this.leftCalendar){var a=this.getHoverLI();t.isNullOrUndefined(a)||a.classList.remove(ve)}else this.hide(e),e.preventDefault()}},r.prototype.listMoveDown=function(e){var i=this.getHoverLI(),s=this.getActiveLI();if(t.isNullOrUndefined(i))if(t.isNullOrUndefined(s))t.addClass([this.liCollections[0]],ve);else{a=s.nextElementSibling;!t.isNullOrUndefined(a)&&a.classList.contains(me)&&t.addClass([a],ve)}else{var a=i.nextElementSibling;!t.isNullOrUndefined(a)&&a.classList.contains(me)&&(t.removeClass([i],ve),t.addClass([a],ve))}},r.prototype.listMoveUp=function(e){var i=this.getHoverLI(),s=this.getActiveLI();if(t.isNullOrUndefined(i)){if(!t.isNullOrUndefined(s)){a=s.previousElementSibling;!t.isNullOrUndefined(a)&&a.classList.contains(me)&&t.addClass([a],ve)}}else{var a=i.previousElementSibling;!t.isNullOrUndefined(a)&&a.classList.contains(me)&&(t.removeClass([i],ve),t.addClass([a],ve))}},r.prototype.getHoverLI=function(){return this.presetElement.querySelector("."+ve)},r.prototype.getActiveLI=function(){return this.presetElement.querySelector("."+q)},r.prototype.popupKeyBoardHandler=function(){this.popupKeyboardModule=new t.KeyboardEvents(this.popupWrapper,{eventName:"keydown",keyAction:this.popupKeyActionHandle.bind(this),keyConfigs:{escape:"escape"}}),this.keyInputConfigs=t.extend(this.keyInputConfigs,this.keyConfigs),this.popupKeyboardModule=new t.KeyboardEvents(this.inputWrapper.container.children[1],{eventName:"keydown",keyAction:this.popupKeyActionHandle.bind(this),keyConfigs:this.keyInputConfigs})},r.prototype.setScrollPosition=function(){var e=this.presetElement.getBoundingClientRect().height,i=this.presetElement.querySelector("."+ve),s=this.presetElement.querySelector("."+q),a=t.isNullOrUndefined(i)?s:i;if(!t.isNullOrUndefined(a)){var n=a.nextElementSibling,r=n?n.offsetTop:a.offsetTop,l=a.getBoundingClientRect().height;r+a.offsetTop>e?this.presetElement.scrollTop=n?r-(e/2+l/2):r:this.presetElement.scrollTop=0}},r.prototype.popupKeyActionHandle=function(e){var i=t.closest(e.target,"."+re);switch(e.action){case"escape":this.isPopupOpen()?(this.isKeyPopup&&(this.inputElement.focus(),this.isKeyPopup=!1),this.hide(e)):this.inputWrapper.container.children[1].blur();break;case"enter":this.isPopupOpen()?this.inputWrapper.container.children[1].focus():this.show(null,e);break;case"tab":this.hide(e);break;case"altRightArrow":t.isNullOrUndefined(i)?document.activeElement===this.cancelButton.element&&!0!==this.applyButton.element.disabled?this.applyButton.element.focus():this.leftCalendar.children[1].firstElementChild.focus():this.cancelButton.element.focus(),e.preventDefault();break;case"altLeftArrow":t.isNullOrUndefined(i)?document.activeElement===this.applyButton.element&&!0!==this.applyButton.element.disabled?this.cancelButton.element.focus():t.isNullOrUndefined(this.presetElement)||document.activeElement!==this.cancelButton.element?this.rightCalendar.children[1].firstElementChild.focus():this.presetElement.focus():this.rightCalendar.children[1].firstElementChild.focus(),e.preventDefault()}},r.prototype.documentHandler=function(e){if(!t.isNullOrUndefined(this.popupObj)){var i=e.target;this.inputWrapper.container.contains(i)&&(t.isNullOrUndefined(this.popupObj)||t.closest(i,'[id="'+this.popupWrapper.id+'"]'))||"touchstart"!==e.type&&("mousedown"===e.type||this.closeEventArgs&&!this.closeEventArgs.cancel)&&e.preventDefault(),!t.isNullOrUndefined(this.targetElement)&&(t.isNullOrUndefined(this.targetElement)||i===this.targetElement)||t.closest(i,'[id="'+this.popupWrapper.id+'"]')||t.closest(i,".e-input-group")===this.inputWrapper.container||t.closest(i,".e-daterangepicker.e-popup")&&!i.classList.contains("e-day")||(this.preventBlur=!1,this.isPopupOpen()&&document.body.contains(this.popupObj.element)&&(this.applyFunction(e),this.isMobile||(this.isRangeIconClicked=!1)))}},r.prototype.createInput=function(){var e=this.cssClass;t.isNullOrUndefined(this.cssClass)||""===this.cssClass||(e=this.cssClass.replace(/\s+/g," ").trim()),this.inputWrapper=s.Input.createInput({floatLabelType:this.floatLabelType,element:this.inputElement,properties:{readonly:this.readonly,placeholder:this.placeholder,cssClass:e,enabled:this.enabled,enableRtl:this.enableRtl,showClearButton:this.showClearButton},buttons:["e-input-group-icon e-range-icon e-icons"]},this.createElement),t.attributes(this.inputElement,{"aria-readonly":this.readonly?"true":"false",tabindex:"0","aria-haspopup":"true","aria-activedescendant":"null","aria-owns":this.element.id+"_popup","aria-expanded":"false",role:"combobox",autocomplete:"off","aria-disabled":this.enabled?"false":"true",autocorrect:"off",autocapitalize:"off",spellcheck:"false"}),s.Input.addAttributes({"aria-label":"select"},this.inputWrapper.buttons[0]),t.isNullOrUndefined(this.placeholder)||""===this.placeholder.trim()||s.Input.addAttributes({"aria-placeholder":this.placeholder},this.inputElement),this.setEleWidth(this.width),t.addClass([this.inputWrapper.container],"e-date-range-wrapper"),t.isNullOrUndefined(this.inputElement.getAttribute("name"))&&t.attributes(this.inputElement,{name:this.element.id}),"hidden"===this.inputElement.type&&(this.inputWrapper.container.style.display="none"),this.refreshControl(),this.previousEleValue=this.inputElement.value,this.inputElement.setAttribute("value",this.inputElement.value),this.startCopy=this.startDate,this.endCopy=this.endDate},r.prototype.setEleWidth=function(e){this.inputWrapper.container.style.width="string"==typeof e?this.width:"number"==typeof e?t.formatUnit(this.width):"100%"},r.prototype.adjustLongHeaderWidth=function(){"Wide"===this.dayHeaderFormat&&t.addClass([this.popupWrapper],"e-daterange-day-header-lg")},r.prototype.refreshControl=function(){this.validateMinMax(),this.strictMode&&this.validateRangeStrict();var e=this.disabledDates();this.strictMode&&e&&(this.startValue=this.previousStartValue,this.setProperties({startDate:this.startValue},!0),this.endValue=this.previousEndValue,this.setProperties({endDate:this.endValue},!0),this.setValue()),this.updateInput(),this.strictMode||this.validateRange(),!this.strictMode&&e&&this.clearRange(),t.isNullOrUndefined(this.endValue)||t.isNullOrUndefined(this.startValue)||e||this.disabledDateRender(),this.errorClass(),this.previousStartValue=t.isNullOrUndefined(this.startValue)||isNaN(+this.startValue)?null:new Date(+this.startValue),this.previousEndValue=t.isNullOrUndefined(this.endValue)||isNaN(+this.endValue)?null:new Date(+this.endValue)},r.prototype.updateInput=function(){if(!t.isNullOrUndefined(this.endValue)&&!t.isNullOrUndefined(this.startValue)){var e={format:this.formatString,type:"date",skeleton:"yMd"},i=this.globalize.formatDate(this.startValue,e),a=this.globalize.formatDate(this.endValue,e);s.Input.setValue(i+" "+this.separator+" "+a,this.inputElement,this.floatLabelType,this.showClearButton),this.previousStartValue=new Date(+this.startValue),this.previousEndValue=new Date(+this.endValue)}!this.strictMode&&t.isNullOrUndefined(this.value)&&this.invalidValueString&&s.Input.setValue(this.invalidValueString,this.inputElement,this.floatLabelType,this.showClearButton)},r.prototype.checkInvalidRange=function(e){if(!t.isNullOrUndefined(e)){var i=!1,s=void 0,a=void 0,n=null,r=null,l=null,o=!1,h=!1,u=!1;if("string"==typeof e){var d=e.split(" "+this.separator+" ");2===d.length?(n=d[0],r=d[1]):(i=!0,l=e)}else e.length>0?(s=e[0],a=e[1]):(s=e.start,a=e.end),s instanceof Date||"object"==typeof s?s instanceof Date?o=!0:t.isNullOrUndefined(s)||(u=!0):n=this.getstringvalue(s),a instanceof Date||"object"==typeof a?a instanceof Date?h=!0:t.isNullOrUndefined(a)||(u=!0):r=this.getstringvalue(a);(t.isNullOrUndefined(n)&&!o&&!t.isNullOrUndefined(r)||!t.isNullOrUndefined(n)&&!h&&t.isNullOrUndefined(r))&&(i=!0),u&&(n=r=l=null,i=!0),n&&(i=i||this.checkInvalidValue(n)),r&&(i=i||this.checkInvalidValue(r)),i&&(o&&!u&&(n=s.toLocaleDateString()),h&&!u&&(r=a.toLocaleDateString()),t.isNullOrUndefined(n)||t.isNullOrUndefined(r)?t.isNullOrUndefined(n)?t.isNullOrUndefined(r)||(l=r):l=n:l=n+" "+this.separator+" "+r,this.invalidValueString=l,this.setProperties({value:null},!0),this.setProperties({startValue:null},!0),this.setProperties({endValue:null},!0),this.startDate=null,this.endDate=null)}},r.prototype.getstringvalue=function(e){var i=null;return t.isNullOrUndefined(e)||"number"!=typeof e?t.isNullOrUndefined(e)||"string"!=typeof e||(i=""+e):i=e.toString(),i},r.prototype.checkInvalidValue=function(e){var i=e,s=!1,a=null;if(a={format:this.formatString,type:"date",skeleton:"yMd"},"string"!=typeof i)s=!0;else{var n=new t.Internationalization(this.locale);if(!this.checkDateValue(n.parseDate(i,a))){var r=null;r=/^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/,(!/^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/.test(i)&&!r.test(i)||/^[a-zA-Z0-9- ]*$/.test(i)||isNaN(+new Date(this.checkValue(i))))&&(s=!0)}}return s},r.prototype.isDateDisabled=function(e){if(t.isNullOrUndefined(e))return!1;var i=new Date(+e);if(+i<+this.min||+i>+this.max)return!0;this.virtualRenderCellArgs={date:i,isDisabled:!1};var s=this.virtualRenderCellArgs;return this.virtualRenderCellEvent(s),!!s.isDisabled},r.prototype.disabledDateRender=function(){this.disabledDays=[],this.disabledDayCnt=null;for(var e=new Date(+this.startValue),t=0;+e<=+this.endValue&&+this.endValue<=+this.max;){this.virtualRenderCellArgs={date:e,isDisabled:!1};var i=this.virtualRenderCellArgs;this.virtualRenderCellEvent(i),i.isDisabled&&(this.disabledDays.push(new Date(+i.date)),+e>+this.startValue&&+e<+this.endValue&&t++),this.addDay(e,1,null,this.max,this.min)}this.disabledDayCnt=t},r.prototype.virtualRenderCellEvent=function(e){t.extend(this.virtualRenderCellArgs,{name:"renderDayCell"}),this.trigger("renderDayCell",e)},r.prototype.disabledDates=function(){var e=!1,i=!1;return t.isNullOrUndefined(this.endValue)||t.isNullOrUndefined(this.startValue)||(e=this.isDateDisabled(this.startValue),i=this.isDateDisabled(this.endValue),this.isPopupOpen()||(this.currentDate=null),this.setValue()),e||i},r.prototype.setModelValue=function(){this.value||null!==this.startDate||null!==this.endDate?null===this.value||null===this.value.start?null===this.value?this.setProperties({value:[this.startDate,this.endDate]},!0):null===this.value.start&&this.setProperties({value:{start:this.startDate,end:this.endDate}},!0):this.value&&this.value.length>0||this.valueType&&this.valueType.length>0?(+this.startDate==+this.value[0]&&+this.endDate==+this.value[1]||this.setProperties({value:[this.startDate,this.endDate]},!0),this.value&&null==this.value[0]&&null==this.value[1]&&this.setProperties({value:null},!0)):this.value&&this.value.start&&this.setProperties({value:{start:this.startDate,end:this.endDate}},!0):this.setProperties({value:null},!0),this.createHiddenInput()},r.prototype.dispatchEvent=function(e,t){var i=document.createEvent("HTMLEvents");i.initEvent(t,!1,!0),e.dispatchEvent(i),this.firstHiddenChild.dispatchEvent(i)},r.prototype.changeTrigger=function(e){+this.initStartDate==+this.startValue&&+this.initEndDate==+this.endValue||(this.setProperties({endDate:this.checkDateValue(this.endValue)},!0),this.setProperties({startDate:this.checkDateValue(this.startValue)},!0),this.setModelValue(),this.isAngular&&this.preventChange?this.preventChange=!1:this.trigger("change",this.rangeArgs(e))),this.previousEleValue=this.inputElement.value,this.initStartDate=this.checkDateValue(this.startValue),this.initEndDate=this.checkDateValue(this.endValue)},r.prototype.navigateTo=function(t,i){if(this.isPopupOpen()){if("month"===t.toLowerCase())t="Month";else if("year"===t.toLowerCase())t="Year";else{if("decade"!==t.toLowerCase())return;t="Decade"}this.getViewNumber(t)<this.getViewNumber(this.depth)&&(t=this.depth),this.isMobile?e.prototype.navigateTo.call(this,t,i):(i<this.min?i=new Date(+this.min):i>=this.max&&(i=new Date(+this.max)),"Month"===t&&this.isSameMonth(i,this.max)?i=new Date(this.max.getFullYear(),this.max.getMonth()-1,this.min.getDate()):"Year"===t&&this.isSameYear(i,this.max)?i=new Date(this.max.getFullYear()-1,this.max.getMonth(),this.max.getDate()):"Decade"===t&&this.isSameDecade(i,this.max)&&(i=new Date(this.max.getFullYear()-10,this.max.getMonth(),this.max.getDate())),this.leftCalCurrentDate=i,this.navigate(this.leftCalendar,this.leftCalCurrentDate,t),i="Month"===t?new Date(this.currentDate.setMonth(this.currentDate.getMonth()+1)):"Year"===t?new Date(this.currentDate.setFullYear(this.currentDate.getFullYear()+1)):new Date(this.currentDate.setFullYear(this.currentDate.getFullYear()+10)),this.rightCalCurrentDate=i,this.navigate(this.rightCalendar,this.rightCalCurrentDate,t),this.leftKeyboardModule=this.rightKeyboardModule=null,this.updateNavIcons()),this.currentView()===this.depth&&this.bindCalendarCellEvents(),this.removeFocusedDate(),this.updateRange(this.isMobile?[this.calendarElement]:[this.leftCalendar,this.rightCalendar])}},r.prototype.navigate=function(t,i,s){this.calendarElement=t,this.table=t.querySelector("table"),this.tableBodyElement=t.querySelector("tbody"),this.headerTitleElement=t.querySelector(".e-title"),this.tableHeadElement=t.querySelector("thead"),this.contentElement=t.querySelector(".e-content"),this.previousIcon=t.querySelector(".e-prev"),this.nextIcon=t.querySelector(".e-next"),this.effect="e-zoomin",e.prototype.navigateTo.call(this,s,i)},r.prototype.focusIn=function(){document.activeElement!==this.inputElement&&this.enabled&&(t.addClass([this.inputWrapper.container],[G]),this.inputElement.focus())},r.prototype.focusOut=function(){var e=this.preventBlur;document.activeElement===this.inputElement&&(t.removeClass([this.inputWrapper.container],[G]),this.preventBlur=!1,this.inputElement.blur(),this.preventBlur=e)},r.prototype.destroy=function(){this.unBindEvents(),this.hide(null);var i={"aria-readonly":this.readonly?"true":"false",tabindex:"0","aria-haspopup":"true","aria-activedescendant":"null","aria-owns":this.element.id+"_popup","aria-expanded":"false",role:"combobox",autocomplete:"off","aria-disabled":this.enabled?"false":"true",autocorrect:"off",autocapitalize:"off","aria-invalid":"false",spellcheck:"false"};this.inputElement&&(t.removeClass([this.inputElement],[z]),t.EventHandler.remove(this.inputElement,"blur",this.inputBlurHandler),s.Input.removeAttributes(i,this.inputElement),t.isNullOrUndefined(this.cloneElement.getAttribute("tabindex"))?this.inputElement.removeAttribute("tabindex"):this.inputElement.setAttribute("tabindex",this.tabIndex),this.ensureInputAttribute(),this.inputElement.classList.remove("e-input"),t.isNullOrUndefined(this.inputWrapper)||(t.EventHandler.remove(this.inputWrapper.buttons[0],"mousedown",this.rangeIconHandler),null===this.angularTag&&this.inputWrapper.container.parentElement.appendChild(this.inputElement),t.detach(this.inputWrapper.container))),t.isNullOrUndefined(this.inputKeyboardModule)||this.isMobile||this.inputKeyboardModule.destroy(),this.popupObj&&(this.isMobile||this.clearCalendarEvents()),e.prototype.destroy.call(this),this.inputWrapper=this.popupWrapper=this.popupObj=this.cloneElement=this.presetElement=null,this.formElement&&t.EventHandler.remove(this.formElement,"reset",this.formResetHandler),t.isNullOrUndefined(this.firstHiddenChild)||t.isNullOrUndefined(this.secondHiddenChild)||(t.detach(this.firstHiddenChild),t.detach(this.secondHiddenChild),this.firstHiddenChild=this.secondHiddenChild=null,this.inputElement.setAttribute("name",this.element.getAttribute("data-name")),this.inputElement.removeAttribute("data-name"))},r.prototype.ensureInputAttribute=function(){for(var e=[],i=0;i<this.inputElement.attributes.length;i++)e[i]=this.inputElement.attributes[i].name;for(i=0;i<e.length;i++)t.isNullOrUndefined(this.cloneElement.getAttribute(e[i]))?("value"===e[i].toLowerCase()&&(this.inputElement.value=""),this.inputElement.removeAttribute(e[i])):("value"===e[i].toLowerCase()&&(this.inputElement.value=this.cloneElement.getAttribute(e[i])),this.inputElement.setAttribute(e[i],this.cloneElement.getAttribute(e[i])))},r.prototype.getModuleName=function(){return"daterangepicker"},r.prototype.getPersistData=function(){return this.addOnPersist(["startDate","endDate","value"])},r.prototype.getSelectedRange=function(){var e;return t.isNullOrUndefined(this.startValue)||t.isNullOrUndefined(this.endValue)?e=0:(e=Math.round(Math.abs((this.removeTimeValueFromDate(this.startValue).getTime()-this.removeTimeValueFromDate(this.endValue).getTime())/864e5))+1,this.disabledDateRender(),t.isNullOrUndefined(this.disabledDayCnt)||(e-=this.disabledDayCnt,this.disabledDayCnt=null)),{startDate:this.startValue,endDate:this.endValue,daySpan:e}},r.prototype.show=function(i,s){var a=this;if(this.isMobile&&this.popupObj&&this.popupObj.refreshPosition(),!(this.enabled&&this.readonly||!this.enabled||this.popupObj||this.isPopupOpen())){i&&(this.targetElement=i),this.createPopup(),(this.isMobile||t.Browser.isDevice)&&(this.mobileRangePopupWrap=this.createElement("div",{className:"e-daterangepick-mob-popup-wrap"}),document.body.appendChild(this.mobileRangePopupWrap)),this.openEventArgs={popup:this.popupObj||null,cancel:!1,date:this.inputElement.value,model:this,event:s||null,appendTo:this.isMobile||t.Browser.isDevice?this.mobileRangePopupWrap:document.body};var n=this.openEventArgs;this.trigger("open",n,function(n){if(a.openEventArgs=n,!a.openEventArgs.cancel){a.openEventArgs.appendTo.appendChild(a.popupWrapper),a.showPopup(i,s);var r=!a.isCustomRange||a.isMobile&&a.isCustomRange;!t.isUndefined(a.presets[0].start&&a.presets[0].end&&a.presets[0].label)&&r&&a.setScrollPosition(),a.checkMinMaxDays(),a.isMobile&&!t.isNullOrUndefined(a.startDate)&&t.isNullOrUndefined(a.endDate)&&(a.endButton.element.classList.add(q),a.startButton.element.classList.remove(q),a.endButton.element.removeAttribute("disabled"),a.selectableDates()),e.prototype.setOverlayIndex.call(a,a.mobileRangePopupWrap,a.popupObj.element,a.modal,a.isMobile||t.Browser.isDevice)}})}},r.prototype.hide=function(e){var i=this;if(this.popupObj){if(t.isNullOrUndefined(this.previousEndValue)&&t.isNullOrUndefined(this.previousStartValue)?this.clearRange():(t.isNullOrUndefined(this.previousStartValue)?(this.startValue=null,this.setValue()):(this.startValue=new Date(this.checkValue(this.previousStartValue)),this.setValue(),this.currentDate=new Date(this.checkValue(this.startValue))),t.isNullOrUndefined(this.previousEndValue)?(this.endValue=null,this.setValue()):(this.endValue=new Date(this.checkValue(this.previousEndValue)),this.setValue())),this.isPopupOpen()){this.closeEventArgs={cancel:!1,popup:this.popupObj,date:this.inputElement.value,model:this,event:e||null};var s=this.closeEventArgs;this.trigger("close",s,function(e){i.closeEventArgs=e,i.closeEventArgs.cancel?t.removeClass([i.inputWrapper.buttons[0]],q):(i.isMobile&&(t.isNullOrUndefined(i.startButton)||t.isNullOrUndefined(i.endButton)||(t.EventHandler.remove(i.startButton.element,"click touchstart",i.deviceHeaderClick),t.EventHandler.remove(i.endButton.element,"click touchstart",i.deviceHeaderClick))),i.popupObj&&(i.popupObj.hide(),i.preventBlur&&(i.inputElement.focus(),t.addClass([i.inputWrapper.container],[G]))),i.isMobile||(t.isNullOrUndefined(i.leftKeyboardModule)||t.isNullOrUndefined(i.rightKeyboardModule)||(i.leftKeyboardModule.destroy(),i.rightKeyboardModule.destroy()),t.isNullOrUndefined(i.presetElement)||i.presetKeyboardModule.destroy(),t.isNullOrUndefined(i.cancelButton)||i.btnKeyboardModule.destroy()),i.targetElement=null,t.removeClass([document.body],fe),t.EventHandler.remove(document,"mousedown touchstart",i.documentHandler),i.isMobile&&i.modal&&(i.modal.style.display="none",i.modal.outerHTML="",i.modal=null),(i.isMobile||t.Browser.isDevice)&&(t.isNullOrUndefined(i.mobileRangePopupWrap)||(i.mobileRangePopupWrap.remove(),i.mobileRangePopupWrap=null)),i.isKeyPopup=i.dateDisabled=!1),i.updateClearIconState(),i.updateHiddenInput(),i.isMobile&&i.allowEdit&&!i.readonly&&i.inputElement.removeAttribute("readonly")})}}else this.updateClearIconState(),this.updateHiddenInput(),this.isMobile&&this.allowEdit&&!this.readonly&&this.inputElement.removeAttribute("readonly")},r.prototype.setLocale=function(){this.globalize=new t.Internationalization(this.locale),this.l10n.setLocale(this.locale),this.setProperties({placeholder:this.l10n.getConstant("placeholder")},!0),s.Input.setPlaceholder(this.placeholder,this.inputElement),this.updateInput(),this.updateHiddenInput(),this.changeTrigger()},r.prototype.refreshChange=function(){this.checkView(),this.refreshControl(),this.changeTrigger()},r.prototype.setDate=function(){s.Input.setValue("",this.inputElement,this.floatLabelType,this.showClearButton),this.refreshChange()},r.prototype.enableInput=function(){+this.min<=+this.max&&(this.setProperties({enabled:!0},!0),s.Input.setEnabled(this.enabled,this.inputElement),this.element.hasAttribute("disabled")&&this.bindEvents())},r.prototype.clearModelvalue=function(e,t){this.setProperties({startDate:null},!0),this.setProperties({endDate:null},!0),t.value&&t.value.length>0?this.setProperties({value:null},!0):t.value&&t.value.start?this.setProperties({value:{start:null,end:null}},!0):t.value&&!t.value.start&&this.setProperties({value:{start:null,end:null}},!0),this.updateValue(),this.setDate()},r.prototype.createHiddenInput=function(){t.isNullOrUndefined(this.firstHiddenChild)&&t.isNullOrUndefined(this.secondHiddenChild)&&(this.firstHiddenChild=this.createElement("input"),this.secondHiddenChild=this.createElement("input")),t.isNullOrUndefined(this.inputElement.getAttribute("name"))||(this.inputElement.setAttribute("data-name",this.inputElement.getAttribute("name")),this.inputElement.removeAttribute("name")),t.attributes(this.firstHiddenChild,{type:"text",name:this.inputElement.getAttribute("data-name"),class:ge}),t.attributes(this.secondHiddenChild,{type:"text",name:this.inputElement.getAttribute("data-name"),class:ge});var e={type:"datetime",skeleton:"yMd"};this.firstHiddenChild.value=this.startDate&&this.globalize.formatDate(this.startDate,e),this.secondHiddenChild.value=this.endDate&&this.globalize.formatDate(this.endDate,e),this.inputElement.parentElement.appendChild(this.firstHiddenChild),this.inputElement.parentElement.appendChild(this.secondHiddenChild)},r.prototype.setMinMaxDays=function(){this.isPopupOpen()&&(this.removeClassDisabled(),this.checkMinMaxDays(),this.isMobile&&this.selectableDates(),!this.strictMode&&t.isNullOrUndefined(this.startValue)&&t.isNullOrUndefined(this.endValue)?this.removeSelection():this.updateRange(this.isMobile?[this.calendarElement]:[this.leftCalendar,this.rightCalendar]),this.updateHeader())},r.prototype.onPropertyChanged=function(e,i){for(var a={format:this.formatString,type:"date",skeleton:"yMd"},n=0,r=Object.keys(e);n<r.length;n++){var l=r[n];switch(["maxDays","minDays","value"].indexOf(l)<0&&this.hide(null),l){case"width":this.setEleWidth(this.width);break;case"separator":this.previousEleValue=this.inputElement.value,this.setProperties({separator:e.separator},!0),this.updateInput(),this.changeTrigger();break;case"placeholder":s.Input.setPlaceholder(e.placeholder,this.inputElement),this.setProperties({placeholder:e.placeholder},!0);break;case"readonly":s.Input.setReadonly(this.readonly,this.inputElement),this.inputElement.setAttribute("aria-readonly",""+this.readonly),this.setRangeAllowEdit();break;case"cssClass":this.updateCssClass(e.cssClass,i.cssClass);break;case"enabled":this.setProperties({enabled:e.enabled},!0),s.Input.setEnabled(this.enabled,this.inputElement),this.enabled?this.inputElement.setAttribute("tabindex",this.tabIndex):this.inputElement.tabIndex=-1;break;case"allowEdit":this.setRangeAllowEdit();break;case"enableRtl":this.setProperties({enableRtl:e.enableRtl},!0),s.Input.setEnableRtl(this.enableRtl,[this.inputWrapper.container]);break;case"zIndex":this.setProperties({zIndex:e.zIndex},!0);break;case"format":this.setProperties({format:e.format},!0),this.checkFormat(),this.updateInput(),this.changeTrigger();break;case"locale":this.globalize=new t.Internationalization(this.locale),this.l10n.setLocale(this.locale),this.setProperties({placeholder:this.l10n.getConstant("placeholder")},!0),s.Input.setPlaceholder(this.placeholder,this.inputElement),this.setLocale();break;case"htmlAttributes":this.updateHtmlAttributeToElement(),this.updateHtmlAttributeToWrapper(),this.setDataAttribute(!0),this.checkHtmlAttributes(!0);break;case"showClearButton":s.Input.setClearButton(this.showClearButton,this.inputElement,this.inputWrapper),this.bindClearEvent();break;case"startDate":"string"==typeof e.startDate&&(e.startDate=this.globalize.parseDate(e.startDate,a)),+this.initStartDate!=+e.startDate&&(this.startValue=this.checkDateValue(new Date(this.checkValue(e.startDate))),this.setDate(),this.setValue());break;case"endDate":"string"==typeof e.endDate&&(e.endDate=this.globalize.parseDate(e.endDate,a)),+this.initEndDate!=+e.endDate&&(this.endValue=this.checkDateValue(new Date(this.checkValue(e.endDate))),this.setDate(),this.setValue());break;case"value":if(this.invalidValueString=null,this.checkInvalidRange(e.value),"string"==typeof e.value)if(this.invalidValueString)this.clearModelvalue(e,i);else{var o=e.value.split(" "+this.separator+" ");this.value=[new Date(o[0]),new Date(o[1])],this.updateValue(),this.setDate()}else!t.isNullOrUndefined(e.value)&&e.value.length>0||!t.isNullOrUndefined(e.value)&&e.value.start?(this.valueType=e.value,null===e.value[0]||null===e.value.start?1===e.value.length||e.value.start?this.clearModelvalue(e,i):null!==e.value[1]&&null!==e.value.start||this.clearModelvalue(e,i):+this.initStartDate==+e.value[0]&&+this.initEndDate==+e.value[1]&&+this.initStartDate==+(e.value.start||+this.initEndDate!=+e.value.start)||(1===e.value.length?this.modelValue=e.value:e.value.start&&(this.modelValue=e.value),this.updateValue(),this.setDate())):(t.isNullOrUndefined(this.value)||null==e.value.start)&&(this.valueType=e.value,this.startValue=null,this.endValue=null,this.clearModelvalue(e,i));if(this.isPopupOpen()){if(t.isNullOrUndefined(this.startValue)&&t.isNullOrUndefined(this.endValue))return this.removeSelection(),void(this.isMobile&&this.deviceHeaderUpdate());this.isMobile?(this.navigate(this.deviceCalendar,this.startValue,this.currentView()),this.deviceHeaderUpdate()):(this.navigate(this.leftCalendar,this.startValue,this.currentView()),this.updateControl(this.leftCalendar),this.navigate(this.rightCalendar,this.endValue,this.currentView()),this.updateControl(this.rightCalendar)),this.updateRange(this.isMobile?[this.calendarElement]:[this.leftCalendar,this.rightCalendar]),this.updateHeader(),this.applyButton.disabled=this.applyButton.element.disabled=!1}this.preventChange=this.isAngular&&this.preventChange?!this.preventChange:this.preventChange;break;case"minDays":this.setProperties({minDays:e.minDays},!0),this.refreshChange(),this.setMinMaxDays();break;case"maxDays":this.setProperties({maxDays:e.maxDays},!0),this.refreshChange(),this.setMinMaxDays();break;case"min":this.setProperties({min:this.checkDateValue(new Date(this.checkValue(e.min)))},!0),this.previousEleValue=this.inputElement.value,this.enableInput(),this.refreshChange();break;case"max":this.setProperties({max:this.checkDateValue(new Date(this.checkValue(e.max)))},!0),this.enableInput(),this.refreshChange();break;case"strictMode":this.invalidValueString=null,this.setProperties({strictMode:e.strictMode},!0),this.refreshChange();break;case"presets":this.setProperties({presets:e.presets},!0),this.processPresets();break;case"floatLabelType":this.floatLabelType=e.floatLabelType,s.Input.removeFloating(this.inputWrapper),s.Input.addFloating(this.inputElement,this.floatLabelType,this.placeholder);break;case"start":this.setProperties({start:e.start},!0),this.refreshChange();break;case"depth":this.setProperties({depth:e.depth},!0),this.refreshChange()}}},j([t.Property(null)],r.prototype,"value",void 0),j([t.Property(!1)],r.prototype,"enablePersistence",void 0),j([t.Property(new Date(1900,0,1))],r.prototype,"min",void 0),j([t.Property(new Date(2099,11,31))],r.prototype,"max",void 0),j([t.Property(null)],r.prototype,"locale",void 0),j([t.Property(null)],r.prototype,"firstDayOfWeek",void 0),j([t.Property(!1)],r.prototype,"weekNumber",void 0),j([t.Property("Gregorian")],r.prototype,"calendarMode",void 0),j([t.Property(!1)],r.prototype,"openOnFocus",void 0),j([t.Event()],r.prototype,"created",void 0),j([t.Event()],r.prototype,"destroyed",void 0),j([t.Event()],r.prototype,"change",void 0),j([t.Event()],r.prototype,"cleared",void 0),j([t.Event()],r.prototype,"navigated",void 0),j([t.Event()],r.prototype,"renderDayCell",void 0),j([t.Property(null)],r.prototype,"startDate",void 0),j([t.Property(null)],r.prototype,"endDate",void 0),j([t.Collection([{}],De)],r.prototype,"presets",void 0),j([t.Property("")],r.prototype,"width",void 0),j([t.Property(1e3)],r.prototype,"zIndex",void 0),j([t.Property(!0)],r.prototype,"showClearButton",void 0),j([t.Property(!0)],r.prototype,"showTodayButton",void 0),j([t.Property("Month")],r.prototype,"start",void 0),j([t.Property("Month")],r.prototype,"depth",void 0),j([t.Property("")],r.prototype,"cssClass",void 0),j([t.Property("-")],r.prototype,"separator",void 0),j([t.Property(null)],r.prototype,"minDays",void 0),j([t.Property(null)],r.prototype,"maxDays",void 0),j([t.Property(!1)],r.prototype,"strictMode",void 0),j([t.Property(null)],r.prototype,"keyConfigs",void 0),j([t.Property(null)],r.prototype,"format",void 0),j([t.Property(!0)],r.prototype,"enabled",void 0),j([t.Property(!1)],r.prototype,"readonly",void 0),j([t.Property(!0)],r.prototype,"allowEdit",void 0),j([t.Property("Never")],r.prototype,"floatLabelType",void 0),j([t.Property(null)],r.prototype,"placeholder",void 0),j([t.Property({})],r.prototype,"htmlAttributes",void 0),j([t.Event()],r.prototype,"open",void 0),j([t.Event()],r.prototype,"close",void 0),j([t.Event()],r.prototype,"select",void 0),j([t.Event()],r.prototype,"focus",void 0),j([t.Event()],r.prototype,"blur",void 0),r=j([t.NotifyPropertyChanges],r)}(E),Ce=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),ke=function(e,t,i,s){var a,n=arguments.length,r=n<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(e,t,i,s);else for(var l=e.length-1;l>=0;l--)(a=e[l])&&(r=(n<3?a(r):n>3?a(t,i,r):a(t,i))||r);return n>3&&r&&Object.defineProperty(t,i,r),r},Ve=(new Date).getDate(),we=(new Date).getMonth(),Me=(new Date).getFullYear(),Oe="e-timepicker",Ne="e-active",Ie="e-navigation",Te="e-disabled",xe="e-input-focus",Pe="e-list-item",Ae="e-non-edit",Se=["title","class","style"];!function(t){(e.TimePickerBase||(e.TimePickerBase={})).createListItems=function(e,t,i,s,a,r){this.calendarMode;var l,o=6e4*r,h=[],u=[];l=+t.setMilliseconds(0);for(var d=+i.setMilliseconds(0);d>=l;)u.push(l),h.push(s.formatDate(new Date(l),{format:a,type:"time"})),l+=o;return{collection:u,list:n.ListBase.createList(e,h,null,!0)}}}();var Ue=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return Ce(i,e),ke([t.Property("day")],i.prototype,"day",void 0),ke([t.Property("month")],i.prototype,"month",void 0),ke([t.Property("year")],i.prototype,"year",void 0),ke([t.Property("day of the week")],i.prototype,"dayOfTheWeek",void 0),ke([t.Property("hour")],i.prototype,"hour",void 0),ke([t.Property("minute")],i.prototype,"minute",void 0),ke([t.Property("second")],i.prototype,"second",void 0),i}(t.ChildProperty),He=function(e){function a(t,i){var s=e.call(this,t,i)||this;return s.liCollections=[],s.timeCollections=[],s.disableItemCollection=[],s.invalidValueString=null,s.isAngular=!1,s.preventChange=!1,s.maskedDateValue="",s.moduleName=s.getModuleName(),s.timeOptions=t,s}return Ce(a,e),a.prototype.preRender=function(){this.keyConfigure={enter:"enter",escape:"escape",end:"end",tab:"tab",home:"home",down:"downarrow",up:"uparrow",left:"leftarrow",right:"rightarrow",open:"alt+downarrow",close:"alt+uparrow"},this.cloneElement=this.element.cloneNode(!0),t.removeClass([this.cloneElement],[Oe,"e-control","e-lib"]),this.inputElement=this.element,this.angularTag=null,this.formElement=t.closest(this.element,"form"),"EJS-TIMEPICKER"===this.element.tagName&&(this.angularTag=this.element.tagName,this.inputElement=this.createElement("input"),this.element.appendChild(this.inputElement)),this.tabIndex=this.element.hasAttribute("tabindex")?this.element.getAttribute("tabindex"):"0",this.element.removeAttribute("tabindex"),this.openPopupEventArgs={appendTo:document.body}},a.prototype.render=function(){this.initialize(),this.createInputElement(),this.updateHtmlAttributeToWrapper(),this.setTimeAllowEdit(),this.setEnable(),this.validateInterval(),this.bindEvents(),this.validateDisable(),this.setValue(this.getFormattedValue(this.value)),!this.enableMask||this.value||!this.maskedDateValue||"Always"!=this.floatLabelType&&this.floatLabelType&&this.placeholder||(this.updateInputValue(this.maskedDateValue),this.checkErrorState(this.maskedDateValue)),this.anchor=this.inputElement,this.inputElement.setAttribute("value",this.inputElement.value),this.inputEleValue=this.getDateObject(this.inputElement.value),this.renderComplete()},a.prototype.setTimeAllowEdit=function(){this.allowEdit?this.readonly||this.inputElement.removeAttribute("readonly"):t.attributes(this.inputElement,{readonly:""}),this.clearIconState()},a.prototype.clearIconState=function(){this.allowEdit||!this.inputWrapper||this.readonly?this.inputWrapper&&t.removeClass([this.inputWrapper.container],[Ae]):""===this.inputElement.value?t.removeClass([this.inputWrapper.container],[Ae]):t.addClass([this.inputWrapper.container],[Ae])},a.prototype.validateDisable=function(){this.setMinMax(this.initMin,this.initMax),this.popupCreation(),this.popupObj.destroy(),this.popupWrapper=this.popupObj=null,isNaN(+this.value)||null===this.value||this.valueIsDisable(this.value)||(this.strictMode&&this.resetState(),this.initValue=null,this.initMax=this.getDateObject(this.initMax),this.initMin=this.getDateObject(this.initMin),this.timeCollections=this.liCollections=[],this.setMinMax(this.initMin,this.initMax))},a.prototype.validationAttribute=function(e,i){var s=e.getAttribute("name")?e.getAttribute("name"):e.getAttribute("id");i.setAttribute("name",s),e.removeAttribute("name");for(var a=["required","aria-required","form"],n=0;n<a.length;n++)if(!t.isNullOrUndefined(e.getAttribute(a[n]))){var r=e.getAttribute(a[n]);i.setAttribute(a[n],r),e.removeAttribute(a[n])}},a.prototype.initialize=function(){this.globalize=new t.Internationalization(this.locale),this.defaultCulture=new t.Internationalization("en"),this.checkTimeFormat(),this.checkInvalidValue(this.value),this.setProperties({value:this.checkDateValue(new Date(this.checkInValue(this.value)))},!0),this.setProperties({min:this.checkDateValue(new Date(this.checkInValue(this.min)))},!0),this.setProperties({max:this.checkDateValue(new Date(this.checkInValue(this.max)))},!0),this.setProperties({scrollTo:this.checkDateValue(new Date(this.checkInValue(this.scrollTo)))},!0),null!==this.angularTag&&this.validationAttribute(this.element,this.inputElement),this.updateHtmlAttributeToElement(),this.checkAttributes(!1);var e={placeholder:this.placeholder};this.l10n=new t.L10n("timepicker",e,this.locale),this.setProperties({placeholder:this.placeholder||this.l10n.getConstant("placeholder")},!0),this.initValue=this.checkDateValue(this.value),this.initMin=this.checkDateValue(this.min),this.initMax=this.checkDateValue(this.max),this.isNavigate=this.isPreventBlur=this.isTextSelected=!1,this.activeIndex=this.valueWithMinutes=this.prevDate=null,t.isNullOrUndefined(this.element.getAttribute("id"))?(this.element.id=t.getUniqueID("ej2_timepicker"),null!==this.angularTag&&t.attributes(this.inputElement,{id:this.element.id+"_input"})):null!==this.angularTag&&(this.inputElement.id=this.element.getAttribute("id")+"_input"),t.isNullOrUndefined(this.inputElement.getAttribute("name"))&&t.attributes(this.inputElement,{name:this.element.id}),this.enableMask&&this.notify("createMask",{module:"MaskedDateTime"})},a.prototype.checkTimeFormat=function(){if(this.format)if("string"==typeof this.format)this.formatString=this.format;else if(t.isNullOrUndefined(this.format.skeleton)||""===this.format.skeleton)this.formatString=this.globalize.getDatePattern({type:"time",skeleton:"short"});else{var e=this.format.skeleton;this.formatString=this.globalize.getDatePattern({type:"time",skeleton:e})}else this.formatString=null},a.prototype.checkDateValue=function(e){return!t.isNullOrUndefined(e)&&e instanceof Date&&!isNaN(+e)?e:null},a.prototype.createInputElement=function(){var e=this.cssClass,i=!this.enableMask;t.isNullOrUndefined(this.cssClass)||""===this.cssClass||(e=this.cssClass.replace(/\s+/g," ").trim()),this.inputWrapper=s.Input.createInput({element:this.inputElement,bindClearAction:i,floatLabelType:this.floatLabelType,properties:{readonly:this.readonly,placeholder:this.placeholder,cssClass:e,enabled:this.enabled,enableRtl:this.enableRtl,showClearButton:this.showClearButton},buttons:[" e-input-group-icon e-time-icon e-icons"]},this.createElement),this.inputWrapper.container.style.width=this.setWidth(this.width),t.attributes(this.inputElement,{"aria-haspopup":"true","aria-autocomplete":"list",tabindex:"0","aria-activedescendant":"null","aria-owns":this.element.id+"_options","aria-expanded":"false",role:"combobox",autocomplete:"off",autocorrect:"off",autocapitalize:"off",spellcheck:"false","aria-disabled":"false","aria-invalid":"false"}),this.isNullOrEmpty(this.inputStyle)||s.Input.addAttributes({style:this.inputStyle},this.inputElement),t.addClass([this.inputWrapper.container],"e-time-wrapper")},a.prototype.getCldrDateTimeFormat=function(){var e=new t.Internationalization(this.locale).getDatePattern({skeleton:"yMd"});return this.isNullOrEmpty(this.formatString)?e+" "+this.cldrFormat("time"):this.formatString},a.prototype.checkInvalidValue=function(e){var i=!1;if("object"!=typeof e&&!t.isNullOrUndefined(e)){var s=e;"string"==typeof s&&(s=s.trim());var a=null,n=null;if("number"==typeof e?s=e.toString():"string"==typeof e&&(/^[a-zA-Z0-9- ]*$/.test(e)||(a=this.setCurrentDate(this.getDateObject(e)),t.isNullOrUndefined(a)&&(a=this.checkDateValue(this.globalize.parseDate(s,{format:this.getCldrDateTimeFormat(),type:"datetime"})),t.isNullOrUndefined(a)&&(a=this.checkDateValue(this.globalize.parseDate(s,{format:this.formatString,type:"dateTime",skeleton:"yMd"})))))),n=this.globalize.parseDate(s,{format:this.getCldrDateTimeFormat(),type:"datetime"}),a=!t.isNullOrUndefined(n)&&n instanceof Date&&!isNaN(+n)?n:null,t.isNullOrUndefined(a)&&s.replace(/\s/g,"").length){var r=null;r=/^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/,!/^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/.test(s)&&!r.test(s)||/^[a-zA-Z0-9- ]*$/.test(e)||isNaN(+new Date(""+s))?i=!0:a=new Date(""+s)}i?(this.strictMode||(this.invalidValueString=s),this.setProperties({value:null},!0),this.initValue=null):(this.setProperties({value:a},!0),this.initValue=this.value)}},a.prototype.requiredModules=function(){var e=[];return this.enableMask&&e.push({args:[this],member:"MaskedDateTime"}),e},a.prototype.cldrFormat=function(e){return"en"===this.locale||"en-US"===this.locale?t.getValue("timeFormats.short",t.getDefaultDateObject()):this.getCultureTimeObject(t.cldrData,""+this.locale)},a.prototype.destroy=function(){this.hide(),this.unBindEvents();var i={"aria-haspopup":"true","aria-autocomplete":"list",tabindex:"0","aria-activedescendant":"null","aria-owns":this.element.id+"_options","aria-expanded":"false",role:"combobox",autocomplete:"off",autocorrect:"off",autocapitalize:"off",spellcheck:"false","aria-disabled":"true","aria-invalid":"false"};this.inputElement&&(s.Input.removeAttributes(i,this.inputElement),null===this.angularTag&&this.inputWrapper.container.parentElement.appendChild(this.inputElement),t.isNullOrUndefined(this.cloneElement.getAttribute("tabindex"))?this.inputElement.removeAttribute("tabindex"):this.inputElement.setAttribute("tabindex",this.tabIndex),this.ensureInputAttribute(),this.enableElement([this.inputElement]),this.inputElement.classList.remove("e-input"),t.isNullOrUndefined(this.cloneElement.getAttribute("disabled"))&&s.Input.setEnabled(!0,this.inputElement,this.floatLabelType)),this.inputWrapper.container&&t.detach(this.inputWrapper.container),this.inputWrapper=this.popupWrapper=this.cloneElement=void 0,this.liCollections=this.timeCollections=this.disableItemCollection=[],t.isNullOrUndefined(this.rippleFn)||this.rippleFn(),e.prototype.destroy.call(this),this.formElement&&t.EventHandler.remove(this.formElement,"reset",this.formResetHandler)},a.prototype.ensureInputAttribute=function(){for(var e=[],i=0;i<this.inputElement.attributes.length;i++)e[i]=this.inputElement.attributes[i].name;for(i=0;i<e.length;i++)t.isNullOrUndefined(this.cloneElement.getAttribute(e[i]))?(this.inputElement.removeAttribute(e[i]),"value"===e[i].toLowerCase()&&(this.inputElement.value="")):(this.inputElement.setAttribute(e[i],this.cloneElement.getAttribute(e[i])),"value"===e[i].toLowerCase()&&(this.inputElement.value=this.cloneElement.getAttribute(e[i])))},a.prototype.popupCreation=function(){this.popupWrapper=this.createElement("div",{className:Oe+" e-popup",attrs:{id:this.element.id+"_popup",style:"visibility:hidden"}}),t.isNullOrUndefined(this.cssClass)||(this.popupWrapper.className+=" "+this.cssClass),!t.isNullOrUndefined(this.step)&&this.step>0&&(this.generateList(),t.append([this.listWrapper],this.popupWrapper)),this.openPopupEventArgs.appendTo.appendChild(this.popupWrapper),this.addSelection(),this.renderPopup(),t.detach(this.popupWrapper)},a.prototype.getPopupHeight=function(){var e=parseInt("240px",10),t=this.popupWrapper.getBoundingClientRect().height;return t>e?e:t},a.prototype.generateList=function(){this.createListItems(),this.wireListEvents();var e={duration:300,selector:"."+Pe};this.rippleFn=t.rippleEffect(this.listWrapper,e),this.liCollections=this.listWrapper.querySelectorAll("."+Pe)},a.prototype.renderPopup=function(){var e=this;this.containerStyle=this.inputWrapper.container.getBoundingClientRect(),this.popupObj=new i.Popup(this.popupWrapper,{width:this.setPopupWidth(this.width),zIndex:this.zIndex,targetType:"relative",position:t.Browser.isDevice?{X:"center",Y:"center"}:{X:"left",Y:"bottom"},collision:t.Browser.isDevice?{X:"fit",Y:"fit"}:{X:"flip",Y:"flip"},enableRtl:this.enableRtl,relateTo:t.Browser.isDevice?document.body:this.inputWrapper.container,offsetY:4,open:function(){e.popupWrapper.style.visibility="visible",t.addClass([e.inputWrapper.buttons[0]],Ne)},close:function(){t.removeClass([e.inputWrapper.buttons[0]],Ne),e.unWireListEvents(),e.inputElement.setAttribute("aria-activedescendant","null"),t.remove(e.popupObj.element),e.popupObj.destroy(),e.popupWrapper.innerHTML="",e.listWrapper=e.popupWrapper=e.listTag=void 0},targetExitViewport:function(){t.Browser.isDevice||e.hide()}}),t.Browser.isDevice||(this.popupObj.collision={X:"none",Y:"flip"}),this.popupObj.element.style.maxHeight="240px"},a.prototype.getFormattedValue=function(e){return t.isNullOrUndefined(this.checkDateValue(e))?null:this.globalize.formatDate(e,{skeleton:"medium",type:"time"})},a.prototype.getDateObject=function(e){if(!this.isNullOrEmpty(e)){var t=this.createDateObj(e),i=!this.isNullOrEmpty(this.initValue);if(this.checkDateValue(t)){var s=i?this.initValue.getDate():Ve,a=i?this.initValue.getMonth():we,n=i?this.initValue.getFullYear():Me;return new Date(n,a,s,t.getHours(),t.getMinutes(),t.getSeconds())}}return null},a.prototype.updateHtmlAttributeToWrapper=function(){if(!t.isNullOrUndefined(this.htmlAttributes))for(var e=0,i=Object.keys(this.htmlAttributes);e<i.length;e++){var s=i[e];if(Se.indexOf(s)>-1)if("class"===s){var a=this.htmlAttributes[s].replace(/\s+/g," ").trim();""!==a&&t.addClass([this.inputWrapper.container],a.split(" "))}else if("style"===s){var n=this.inputWrapper.container.getAttribute(s);n=t.isNullOrUndefined(n)?this.htmlAttributes[s]:n+this.htmlAttributes[s],this.inputWrapper.container.setAttribute(s,n)}else this.inputWrapper.container.setAttribute(s,this.htmlAttributes[s])}},a.prototype.updateHtmlAttributeToElement=function(){if(!t.isNullOrUndefined(this.htmlAttributes))for(var e=0,i=Object.keys(this.htmlAttributes);e<i.length;e++){var s=i[e];Se.indexOf(s)<0&&this.inputElement.setAttribute(s,this.htmlAttributes[s])}},a.prototype.updateCssClass=function(e,i){t.isNullOrUndefined(i)||(i=i.replace(/\s+/g," ").trim()),t.isNullOrUndefined(e)||(e=e.replace(/\s+/g," ").trim()),s.Input.setCssClass(e,[this.inputWrapper.container],i),this.popupWrapper&&s.Input.setCssClass(e,[this.popupWrapper],i)},a.prototype.removeErrorClass=function(){t.removeClass([this.inputWrapper.container],"e-error"),t.attributes(this.inputElement,{"aria-invalid":"false"})},a.prototype.checkErrorState=function(e){var i=this.getDateObject(e);this.validateState(i)&&!this.invalidValueString||this.enableMask&&this.inputElement.value===this.maskedDateValue?this.removeErrorClass():(t.addClass([this.inputWrapper.container],"e-error"),t.attributes(this.inputElement,{"aria-invalid":"true"}))},a.prototype.validateInterval=function(){!t.isNullOrUndefined(this.step)&&this.step>0?this.enableElement([this.inputWrapper.buttons[0]]):this.disableTimeIcon()},a.prototype.disableTimeIcon=function(){this.disableElement([this.inputWrapper.buttons[0]]),this.hide()},a.prototype.disableElement=function(e){t.addClass(e,Te)},a.prototype.enableElement=function(e){t.removeClass(e,Te)},a.prototype.selectInputText=function(){this.inputElement.setSelectionRange(0,this.inputElement.value.length)},a.prototype.setCursorToEnd=function(){this.inputElement.setSelectionRange(this.inputElement.value.length,this.inputElement.value.length)},a.prototype.getMeridianText=function(){var e;if("en"===this.locale||"en-US"===this.locale)e=t.getValue("dayPeriods.format.wide",t.getDefaultDateObject());else{e=t.getValue("main."+this.locale+".dates.calendars.gregorian.dayPeriods.format.abbreviated",t.cldrData)}return e},a.prototype.getCursorSelection=function(){var e=this.inputElement,t=0,i=0;return isNaN(e.selectionStart)||(t=e.selectionStart,i=e.selectionEnd),{start:Math.abs(t),end:Math.abs(i)}},a.prototype.getActiveElement=function(){return t.isNullOrUndefined(this.popupWrapper)?null:this.popupWrapper.querySelectorAll("."+Ne)},a.prototype.isNullOrEmpty=function(e){return!!(t.isNullOrUndefined(e)||"string"==typeof e&&""===e.trim())},a.prototype.setWidth=function(e){return e="number"==typeof e?t.formatUnit(e):"string"==typeof e?e.match(/px|%|em/)?e:t.formatUnit(e):"100%"},a.prototype.setPopupWidth=function(e){if((e=this.setWidth(e)).indexOf("%")>-1){e=(this.containerStyle.width*parseFloat(e)/100).toString()+"px"}return e},a.prototype.setScrollPosition=function(){var e=this.selectedElement;t.isNullOrUndefined(e)?this.popupWrapper&&this.checkDateValue(this.scrollTo)&&this.setScrollTo():this.findScrollTop(e)},a.prototype.findScrollTop=function(e){var t=this.getPopupHeight(),i=e.nextElementSibling,s=i?i.offsetTop:e.offsetTop,a=e.getBoundingClientRect().height;s+e.offsetTop>t?this.popupWrapper.scrollTop=i?s-(t/2+a/2):s:this.popupWrapper.scrollTop=0},a.prototype.setScrollTo=function(){var e;if(t.isNullOrUndefined(this.popupWrapper))this.popupWrapper.scrollTop=0;else{var i=this.popupWrapper.querySelectorAll("."+Pe);if(i.length){var s=this.timeCollections[0],a=this.getDateObject(this.checkDateValue(this.scrollTo)).getTime();e=i[Math.round((a-s)/(6e4*this.step))]}}t.isNullOrUndefined(e)?this.popupWrapper.scrollTop=0:this.findScrollTop(e)},a.prototype.getText=function(){return t.isNullOrUndefined(this.checkDateValue(this.value))?"":this.getValue(this.value)},a.prototype.getValue=function(e){return t.isNullOrUndefined(this.checkDateValue(e))?null:this.globalize.formatDate(e,{format:this.cldrTimeFormat(),type:"time"})},a.prototype.cldrDateFormat=function(){return"en"===this.locale||"en-US"===this.locale?t.getValue("dateFormats.short",t.getDefaultDateObject()):this.getCultureDateObject(t.cldrData,""+this.locale)},a.prototype.cldrTimeFormat=function(){return this.isNullOrEmpty(this.formatString)?"en"===this.locale||"en-US"===this.locale?t.getValue("timeFormats.short",t.getDefaultDateObject()):this.getCultureTimeObject(t.cldrData,""+this.locale):this.formatString},a.prototype.dateToNumeric=function(){return"en"===this.locale||"en-US"===this.locale?t.getValue("timeFormats.medium",t.getDefaultDateObject()):t.getValue("main."+this.locale+".dates.calendars.gregorian.timeFormats.medium",t.cldrData)},a.prototype.getExactDateTime=function(e){return t.isNullOrUndefined(this.checkDateValue(e))?null:this.globalize.formatDate(e,{format:this.dateToNumeric(),type:"time"})},a.prototype.setValue=function(e){var t=this.checkValue(e);this.strictMode||this.validateState(t)?this.isNullOrEmpty(t)?(this.initValue=null,this.validateMinMax(this.value,this.min,this.max)):this.initValue=this.compareFormatChange(t):(null===this.checkDateValue(this.valueWithMinutes)&&(this.initValue=this.valueWithMinutes=null),this.validateMinMax(this.value,this.min,this.max)),this.updateInput(!0,this.initValue)},a.prototype.compareFormatChange=function(e){return t.isNullOrUndefined(e)?null:e!==this.getText()?this.getDateObject(e):this.getDateObject(this.value)},a.prototype.updatePlaceHolder=function(){s.Input.setPlaceholder(this.l10n.getConstant("placeholder"),this.inputElement)},a.prototype.updateInputValue=function(e){s.Input.setValue(e,this.inputElement,this.floatLabelType,this.showClearButton)},a.prototype.preventEventBubbling=function(e){e.preventDefault(),this.interopAdaptor.invokeMethodAsync("OnTimeIconClick")},a.prototype.popupHandler=function(e){this.enabled&&(t.Browser.isDevice&&this.inputElement.setAttribute("readonly",""),e.preventDefault(),this.isPopupOpen()?this.closePopup(0,e):(this.inputElement.focus(),this.show(e)))},a.prototype.mouseDownHandler=function(){this.enabled&&(this.readonly||(this.inputElement.setSelectionRange(0,0),t.EventHandler.add(this.inputElement,"mouseup",this.mouseUpHandler,this)))},a.prototype.mouseUpHandler=function(e){if(!this.readonly){if(e.preventDefault(),this.enableMask)return e.preventDefault(),void this.notify("setMaskSelection",{module:"MaskedDateTime"});t.EventHandler.remove(this.inputElement,"mouseup",this.mouseUpHandler);var i=this.getCursorSelection();0===i.start&&i.end===this.inputElement.value.length||(this.inputElement.value.length>0&&(this.cursorDetails=this.focusSelection()),this.inputElement.setSelectionRange(this.cursorDetails.start,this.cursorDetails.end))}},a.prototype.focusSelection=function(){var e=new RegExp("^[a-zA-Z0-9]+$"),t=this.inputElement.value.split("");t.push(" ");var i=this.getCursorSelection(),s=0,a=0,n=!1;if(this.isTextSelected)s=i.start,a=i.end,this.isTextSelected=!1;else for(var r=0;r<t.length;r++)if(e.test(t[r])||(a=r,n=!0),n){if(i.start>=s&&i.end<=a){a=a,this.isTextSelected=!0;break}s=r+1,n=!1}return{start:s,end:a}},a.prototype.inputHandler=function(e){if(!this.readonly&&this.enabled)switch("right"!==e.action&&"left"!==e.action&&"tab"!==e.action&&e.preventDefault(),e.action){case"home":case"end":case"up":case"down":!this.enableMask||this.readonly||this.isPopupOpen()||(e.preventDefault(),this.notify("keyDownHandler",{module:"MaskedDateTime",e:e})),this.enableMask&&!this.isPopupOpen()||this.keyHandler(e);break;case"enter":this.isNavigate?(this.selectedElement=this.liCollections[this.activeIndex],this.valueWithMinutes=new Date(this.timeCollections[this.activeIndex]),this.updateValue(this.valueWithMinutes,e)):this.updateValue(this.inputElement.value,e),this.hide(),this.isNavigate=!1,this.isPopupOpen()&&e.stopPropagation();break;case"open":this.show(e);break;case"escape":this.updateInputValue(this.objToString(this.value)),this.enableMask&&(this.value||this.updateInputValue(this.maskedDateValue),this.createMask()),this.previousState(this.value),this.hide();break;case"close":this.hide();break;case"right":case"left":case"tab":case"shiftTab":this.isPopupOpen()||!this.enableMask||this.readonly||((0==this.inputElement.selectionStart&&this.inputElement.selectionEnd==this.inputElement.value.length||this.inputElement.selectionEnd!==this.inputElement.value.length&&"tab"==e.action||0!==this.inputElement.selectionStart&&"shiftTab"==e.action||"left"==e.action||"right"==e.action)&&e.preventDefault(),this.notify("keyDownHandler",{module:"MaskedDateTime",e:e}));break;default:this.isNavigate=!1}},a.prototype.onMouseClick=function(e){var i=e.target,s=this.selectedElement=t.closest(i,"."+Pe);this.setSelection(s,e),s&&s.classList.contains(Pe)&&this.hide()},a.prototype.closePopup=function(e,i){var s=this;if(this.isPopupOpen()&&this.popupWrapper){var a={popup:this.popupObj,event:i||null,cancel:!1,name:"open"};t.removeClass([document.body],"e-time-overflow"),this.trigger("close",a,function(i){if(!i.cancel){var a={name:"FadeOut",duration:50,delay:e||0};s.popupObj.hide(new t.Animation(a)),t.removeClass([s.inputWrapper.container],["e-icon-anim"]),t.attributes(s.inputElement,{"aria-expanded":"false"}),t.EventHandler.remove(document,"mousedown touchstart",s.documentClickHandler)}t.Browser.isDevice&&s.modal&&(s.modal.style.display="none",s.modal.outerHTML="",s.modal=null),t.Browser.isDevice&&(t.isNullOrUndefined(s.mobileTimePopupWrap)||(s.mobileTimePopupWrap.remove(),s.mobileTimePopupWrap=null)),t.Browser.isDevice&&s.allowEdit&&!s.readonly&&s.inputElement.removeAttribute("readonly")})}else t.Browser.isDevice&&this.allowEdit&&!this.readonly&&this.inputElement.removeAttribute("readonly")},a.prototype.disposeServerPopup=function(){this.popupWrapper&&(this.popupWrapper.style.visibility="hidden",this.popupWrapper.style.top="-9999px",this.popupWrapper.style.left="-9999px",this.popupWrapper.style.width="0px",this.popupWrapper.style.height="0px")},a.prototype.checkValueChange=function(e,i){if(this.strictMode||this.validateState(this.valueWithMinutes))if(i){var s=this.getDateObject(new Date(this.timeCollections[this.activeIndex]));+this.prevDate!=+s&&this.valueProcess(e,s)}else(this.prevValue!==this.inputElement.value||t.isNullOrUndefined(this.checkDateValue(this.value)))&&this.valueProcess(e,this.compareFormatChange(this.inputElement.value));else null===this.checkDateValue(this.valueWithMinutes)&&(this.initValue=this.valueWithMinutes=null),this.setProperties({value:this.compareFormatChange(this.inputElement.value)},!0),this.initValue=this.valueWithMinutes=this.compareFormatChange(this.inputElement.value),this.prevValue=this.inputElement.value,+this.prevDate!=+this.value&&this.changeEvent(e)},a.prototype.onMouseOver=function(e){var i=t.closest(e.target,"."+Pe);this.setHover(i,"e-hover")},a.prototype.setHover=function(e,i){this.enabled&&this.isValidLI(e)&&!e.classList.contains(i)&&(this.removeHover(i),t.addClass([e],i),i===Ie&&e.setAttribute("aria-selected","true"))},a.prototype.setSelection=function(e,i){this.isValidLI(e)&&(this.checkValue(e.getAttribute("data-value")),this.enableMask&&this.notify("setMaskSelection",{module:"MaskedDateTime"}),this.selectedElement=e,this.activeIndex=Array.prototype.slice.call(this.liCollections).indexOf(e),this.valueWithMinutes=new Date(this.timeCollections[this.activeIndex]),t.addClass([this.selectedElement],Ne),this.selectedElement.setAttribute("aria-selected","true"),this.checkValueChange(i,!0))},a.prototype.onMouseLeave=function(){this.removeHover("e-hover")},a.prototype.scrollHandler=function(){"timepicker"===this.getModuleName()&&t.Browser.isDevice||this.hide()},a.prototype.setMinMax=function(e,i){t.isNullOrUndefined(this.checkDateValue(e))&&(this.initMin=this.getDateObject("12:00:00 AM")),t.isNullOrUndefined(this.checkDateValue(i))&&(this.initMax=this.getDateObject("11:59:59 PM"))},a.prototype.validateMinMax=function(e,i,s){var a=e instanceof Date?e:this.getDateObject(e);return t.isNullOrUndefined(this.checkDateValue(a))?+this.createDateObj(this.getFormattedValue(this.initMin))>+this.createDateObj(this.getFormattedValue(this.initMax))&&this.disableTimeIcon():e=this.strictOperation(this.initMin,this.initMax,e,a),this.strictMode&&(e=this.valueIsDisable(e)?e:null),this.checkErrorState(e),e},a.prototype.valueIsDisable=function(e){if(this.disableItemCollection.length>0){if(this.disableItemCollection.length===this.timeCollections.length)return!1;for(var t=e instanceof Date?this.objToString(e):e,i=0;i<this.disableItemCollection.length;i++)if(t===this.disableItemCollection[i])return!1}return!0},a.prototype.validateState=function(e){if(!this.strictMode){if(!this.valueIsDisable(e))return!1;var i=this.setCurrentDate(this.getDateObject(e)),s=this.setCurrentDate(this.getDateObject(this.initMax)),a=this.setCurrentDate(this.getDateObject(this.initMin));if(t.isNullOrUndefined(this.checkDateValue(i))){if(+s<+a||""!==this.inputElement.value)return!1}else if(+i>+s||+i<+a)return!1}return!0},a.prototype.strictOperation=function(e,t,i,s){var a=this.createDateObj(this.getFormattedValue(t)),n=this.createDateObj(this.getFormattedValue(e)),r=this.createDateObj(this.getFormattedValue(s));if(this.strictMode){if(+n>+a)return this.disableTimeIcon(),this.initValue=this.getDateObject(a),this.updateInputValue(this.getValue(this.initValue)),this.enableMask&&this.createMask(),this.inputElement.value;if(+n>=+r)return this.getDateObject(n);if(+r>=+a||+n==+a)return this.getDateObject(a)}else if(+n>+a&&(this.disableTimeIcon(),!isNaN(+this.createDateObj(i))))return i;return i},a.prototype.bindEvents=function(){t.EventHandler.add(this.inputWrapper.buttons[0],"mousedown",this.popupHandler,this),t.EventHandler.add(this.inputElement,"blur",this.inputBlurHandler,this),t.EventHandler.add(this.inputElement,"focus",this.inputFocusHandler,this),t.EventHandler.add(this.inputElement,"change",this.inputChangeHandler,this),t.EventHandler.add(this.inputElement,"input",this.inputEventHandler,this),this.enableMask&&t.EventHandler.add(this.inputElement,"keydown",this.keydownHandler,this),this.showClearButton&&this.inputWrapper.clearButton&&t.EventHandler.add(this.inputWrapper.clearButton,"mousedown",this.clearHandler,this),this.formElement&&t.EventHandler.add(this.formElement,"reset",this.formResetHandler,this),t.Browser.isDevice||(this.keyConfigure=t.extend(this.keyConfigure,this.keyConfigs),this.inputEvent=new t.KeyboardEvents(this.inputWrapper.container,{keyAction:this.inputHandler.bind(this),keyConfigs:this.keyConfigure,eventName:"keydown"}),this.showClearButton&&this.inputElement&&t.EventHandler.add(this.inputElement,"mousedown",this.mouseDownHandler,this))},a.prototype.keydownHandler=function(e){switch(e.code){case"Delete":!this.enableMask||this.popupObj||this.readonly||this.notify("keyDownHandler",{module:"MaskedDateTime",e:e})}},a.prototype.formResetHandler=function(){if(this.enabled&&!this.inputElement.disabled){var e=this.inputElement.getAttribute("value"),t=this.checkDateValue(this.inputEleValue);"EJS-TIMEPICKER"===this.element.tagName&&(t=null,e="",this.inputElement.setAttribute("value","")),this.setProperties({value:t},!0),this.prevDate=this.value,this.valueWithMinutes=this.value,this.initValue=this.value,this.inputElement&&(this.updateInputValue(e),this.enableMask&&(e||this.updateInputValue(this.maskedDateValue),this.createMask()),this.checkErrorState(e),this.prevValue=this.inputElement.value)}},a.prototype.inputChangeHandler=function(e){this.enabled&&e.stopPropagation()},a.prototype.inputEventHandler=function(){this.enableMask&&this.notify("inputHandler",{module:"MaskedDateTime"})},a.prototype.unBindEvents=function(){this.inputWrapper&&t.EventHandler.remove(this.inputWrapper.buttons[0],"mousedown touchstart",this.popupHandler),t.EventHandler.remove(this.inputElement,"blur",this.inputBlurHandler),t.EventHandler.remove(this.inputElement,"focus",this.inputFocusHandler),t.EventHandler.remove(this.inputElement,"change",this.inputChangeHandler),t.EventHandler.remove(this.inputElement,"input",this.inputEventHandler),this.inputEvent&&this.inputEvent.destroy(),t.EventHandler.remove(this.inputElement,"mousedown touchstart",this.mouseDownHandler),this.showClearButton&&!t.isNullOrUndefined(this.inputWrapper.clearButton)&&t.EventHandler.remove(this.inputWrapper.clearButton,"mousedown touchstart",this.clearHandler),this.formElement&&t.EventHandler.remove(this.formElement,"reset",this.formResetHandler)},a.prototype.bindClearEvent=function(){this.showClearButton&&this.inputWrapper.clearButton&&t.EventHandler.add(this.inputWrapper.clearButton,"mousedown",this.clearHandler,this)},a.prototype.raiseClearedEvent=function(e){var t={event:e};this.trigger("cleared",t)},a.prototype.clearHandler=function(e){this.enabled&&(e.preventDefault(),t.isNullOrUndefined(this.value)?(this.resetState(),this.raiseClearedEvent(e)):this.clear(e),this.popupWrapper&&(this.popupWrapper.scrollTop=0),this.enableMask&&this.notify("clearHandler",{module:"MaskedDateTime"}))},a.prototype.clear=function(e){this.setProperties({value:null},!0),this.initValue=null,this.resetState(),this.raiseClearedEvent(e),this.changeEvent(e)},a.prototype.setZIndex=function(){this.popupObj&&(this.popupObj.zIndex=this.zIndex,this.popupObj.dataBind())},a.prototype.checkAttributes=function(e){for(var i,s=0,a=e?t.isNullOrUndefined(this.htmlAttributes)?[]:Object.keys(this.htmlAttributes):["step","disabled","readonly","style","name","value","min","max","placeholder"];s<a.length;s++){var n=a[s];if(!t.isNullOrUndefined(this.inputElement.getAttribute(n)))switch(n){case"disabled":if(t.isNullOrUndefined(this.timeOptions)||void 0===this.timeOptions.enabled||e){var r="disabled"!==this.inputElement.getAttribute(n)&&""!==this.inputElement.getAttribute(n)&&"true"!==this.inputElement.getAttribute(n);this.setProperties({enabled:r},!e)}break;case"style":this.inputStyle=this.inputElement.getAttribute(n);break;case"readonly":if(t.isNullOrUndefined(this.timeOptions)||void 0===this.timeOptions.readonly||e){var l="readonly"===this.inputElement.getAttribute(n)||""===this.inputElement.getAttribute(n)||"true"===this.inputElement.getAttribute(n);this.setProperties({readonly:l},!e)}break;case"name":this.inputElement.setAttribute("name",this.inputElement.getAttribute(n));break;case"step":this.step=parseInt(this.inputElement.getAttribute(n),10);break;case"placeholder":(t.isNullOrUndefined(this.timeOptions)||void 0===this.timeOptions.placeholder||e)&&this.setProperties({placeholder:this.inputElement.getAttribute(n)},!e);break;case"min":(t.isNullOrUndefined(this.timeOptions)||void 0===this.timeOptions.min||e)&&(i=new Date(this.inputElement.getAttribute(n)),t.isNullOrUndefined(this.checkDateValue(i))||this.setProperties({min:i},!e));break;case"max":(t.isNullOrUndefined(this.timeOptions)||void 0===this.timeOptions.max||e)&&(i=new Date(this.inputElement.getAttribute(n)),t.isNullOrUndefined(this.checkDateValue(i))||this.setProperties({max:i},!e));break;case"value":(t.isNullOrUndefined(this.timeOptions)||void 0===this.timeOptions.value||e)&&(i=new Date(this.inputElement.getAttribute(n)),t.isNullOrUndefined(this.checkDateValue(i))||(this.initValue=i,this.updateInput(!1,this.initValue),this.setProperties({value:i},!e)))}}},a.prototype.setCurrentDate=function(e){return t.isNullOrUndefined(this.checkDateValue(e))?null:new Date(Me,we,Ve,e.getHours(),e.getMinutes(),e.getSeconds())},a.prototype.getTextFormat=function(){var e=0;if("a"===this.cldrTimeFormat().split(" ")[0]||0===this.cldrTimeFormat().indexOf("a"))e=1;else if(this.cldrTimeFormat().indexOf("a")<0)for(var t=this.cldrTimeFormat().split(" "),i=0;i<t.length;i++)if(t[i].toLowerCase().indexOf("h")>=0){e=i;break}return e},a.prototype.updateValue=function(e,i){var s;if(this.isNullOrEmpty(e))this.resetState();else if(s=this.checkValue(e),this.strictMode){var a=null===s&&e.trim().length>0?this.previousState(this.prevDate):this.inputElement.value;this.updateInputValue(a),this.enableMask&&(a||this.updateInputValue(this.maskedDateValue),t.isNullOrUndefined(s)&&e!=this.maskedDateValue&&this.createMask(),t.isNullOrUndefined(s)&&e==this.maskedDateValue&&this.updateInputValue(this.maskedDateValue))}this.checkValueChange(i,"string"!=typeof e)},a.prototype.previousState=function(e){for(var t=this.getDateObject(e),i=0;i<this.timeCollections.length;i++)if(+t===this.timeCollections[i]){this.activeIndex=i,this.selectedElement=this.liCollections[i],this.valueWithMinutes=new Date(this.timeCollections[i]);break}return this.prevValue},a.prototype.resetState=function(){this.removeSelection(),s.Input.setValue("",this.inputElement,this.floatLabelType,!1),this.valueWithMinutes=this.activeIndex=null,this.strictMode||this.checkErrorState(null)},a.prototype.objToString=function(e){return t.isNullOrUndefined(this.checkDateValue(e))?null:this.globalize.formatDate(e,{format:this.cldrTimeFormat(),type:"time"})},a.prototype.checkValue=function(e){if(!this.isNullOrEmpty(e)){var t=e instanceof Date?e:this.getDateObject(e);return this.validateValue(t,e)}return this.resetState(),this.valueWithMinutes=null},a.prototype.validateValue=function(e,i){var s,a=this.validateMinMax(i,this.min,this.max),n=this.createDateObj(a);if(this.getFormattedValue(n)!==this.getFormattedValue(this.value)?(this.valueWithMinutes=t.isNullOrUndefined(n)?null:n,s=this.objToString(this.valueWithMinutes)):(this.strictMode&&(e=n),this.valueWithMinutes=this.checkDateValue(e),s=this.objToString(this.valueWithMinutes)),!this.strictMode&&t.isNullOrUndefined(s)){var r=a.trim().length>0?a:"";this.updateInputValue(r),this.enableMask&&(r||this.updateInputValue(this.maskedDateValue))}else this.updateInputValue(s),this.enableMask&&(""==s&&this.updateInputValue(this.maskedDateValue),t.isNullOrUndefined(s)&&i!=this.maskedDateValue&&this.createMask(),t.isNullOrUndefined(s)&&i==this.maskedDateValue&&this.updateInputValue(this.maskedDateValue));return s},a.prototype.createMask=function(){this.notify("createMask",{module:"MaskedDateTime"})},a.prototype.findNextElement=function(e){var i=this.inputElement.value,s=t.isNullOrUndefined(this.valueWithMinutes)?this.createDateObj(i):this.getDateObject(this.valueWithMinutes),a=null,n=this.liCollections.length,r=this.timeCollections;if(t.isNullOrUndefined(this.checkDateValue(s))&&t.isNullOrUndefined(this.activeIndex))this.selectNextItem(e);else{if("home"===e.action){var l=this.validLiElement(0);a=+this.createDateObj(new Date(this.timeCollections[l])),this.activeIndex=l}else if("end"===e.action){l=this.validLiElement(r.length-1,!0);a=+this.createDateObj(new Date(this.timeCollections[l])),this.activeIndex=l}else if("down"===e.action)for(var o=0;o<n;o++){if(+s<this.timeCollections[o]){l=this.validLiElement(o);a=+this.createDateObj(new Date(this.timeCollections[l])),this.activeIndex=l;break}if(o===n-1){l=this.validLiElement(0);a=+this.createDateObj(new Date(this.timeCollections[l])),this.activeIndex=l;break}}else for(o=n-1;o>=0;o--){if(+s>this.timeCollections[o]){l=this.validLiElement(o,!0);a=+this.createDateObj(new Date(this.timeCollections[l])),this.activeIndex=l;break}if(0===o){l=this.validLiElement(n-1);a=+this.createDateObj(new Date(this.timeCollections[l])),this.activeIndex=l;break}}this.selectedElement=this.liCollections[this.activeIndex],this.elementValue(t.isNullOrUndefined(a)?null:new Date(a))}},a.prototype.selectNextItem=function(e){var t=this.validLiElement(0,"down"!==e.action);this.activeIndex=t,this.selectedElement=this.liCollections[t],this.elementValue(new Date(this.timeCollections[t]))},a.prototype.elementValue=function(e){t.isNullOrUndefined(this.checkDateValue(e))||this.checkValue(e)},a.prototype.validLiElement=function(e,i){var s=null,a=t.isNullOrUndefined(this.popupWrapper)?this.liCollections:this.popupWrapper.querySelectorAll("."+Pe),n=!0;if(a.length)if(i)for(var r=e;r>=0;r--){if(!a[r].classList.contains(Te)){s=r;break}0===r&&n&&(e=r=a.length,n=!1)}else for(r=e;r<=a.length-1;r++){if(!a[r].classList.contains(Te)){s=r;break}r===a.length-1&&n&&(e=r=-1,n=!1)}return s},a.prototype.keyHandler=function(e){if(!(t.isNullOrUndefined(this.step)||this.step<=0||this.inputWrapper.buttons[0].classList.contains(Te))){var i=this.timeCollections.length;if(t.isNullOrUndefined(this.getActiveElement())||0===this.getActiveElement().length)if(this.liCollections.length>0)if(t.isNullOrUndefined(this.value)&&t.isNullOrUndefined(this.activeIndex)){var s=this.validLiElement(0,"down"!==e.action);this.activeIndex=s,this.selectedElement=this.liCollections[s],this.elementValue(new Date(this.timeCollections[s]))}else this.findNextElement(e);else this.findNextElement(e);else{var a=void 0;if(e.keyCode>=37&&e.keyCode<=40){s=40===e.keyCode||39===e.keyCode?++this.activeIndex:--this.activeIndex;this.activeIndex=s=this.activeIndex===i?0:this.activeIndex,this.activeIndex=s=this.activeIndex<0?i-1:this.activeIndex,this.activeIndex=s=this.validLiElement(this.activeIndex,40!==e.keyCode&&39!==e.keyCode),a=t.isNullOrUndefined(this.timeCollections[s])?this.timeCollections[0]:this.timeCollections[s]}else if("home"===e.action){s=this.validLiElement(0);this.activeIndex=s,a=this.timeCollections[s]}else if("end"===e.action){s=this.validLiElement(i-1,!0);this.activeIndex=s,a=this.timeCollections[s]}this.selectedElement=this.liCollections[this.activeIndex],this.elementValue(new Date(a))}this.isNavigate=!0,this.setHover(this.selectedElement,Ie),this.setActiveDescendant(),this.selectInputText(),!this.isPopupOpen()||null===this.selectedElement||e&&"click"===e.type||this.setScrollPosition()}},a.prototype.getCultureTimeObject=function(e,i){return t.getValue("main."+i+".dates.calendars.gregorian.timeFormats.short",e)},a.prototype.getCultureDateObject=function(e,i){return t.getValue("main."+i+".dates.calendars.gregorian.dateFormats.short",e)},a.prototype.wireListEvents=function(){t.EventHandler.add(this.listWrapper,"click",this.onMouseClick,this),t.Browser.isDevice||(t.EventHandler.add(this.listWrapper,"mouseover",this.onMouseOver,this),t.EventHandler.add(this.listWrapper,"mouseout",this.onMouseLeave,this))},a.prototype.unWireListEvents=function(){this.listWrapper&&(t.EventHandler.remove(this.listWrapper,"click",this.onMouseClick),t.Browser.isDevice||(t.EventHandler.remove(this.listWrapper,"mouseover",this.onMouseOver),t.EventHandler.remove(this.listWrapper,"mouseout",this.onMouseLeave)))},a.prototype.valueProcess=function(e,i){var s=t.isNullOrUndefined(this.checkDateValue(i))?null:i;+this.prevDate!=+s&&(this.initValue=s,this.changeEvent(e))},a.prototype.changeEvent=function(e){this.addSelection(),this.updateInput(!0,this.initValue);var i={event:e||null,value:this.value,text:this.inputElement.value,isInteracted:!t.isNullOrUndefined(e),element:this.element};i.value=this.valueWithMinutes||this.getDateObject(this.inputElement.value),this.prevDate=this.valueWithMinutes||this.getDateObject(this.inputElement.value),this.isAngular&&this.preventChange?this.preventChange=!1:this.trigger("change",i),this.invalidValueString=null,this.checkErrorState(this.value)},a.prototype.updateInput=function(e,i){e&&(this.prevValue=this.getValue(i)),this.prevDate=this.valueWithMinutes=i,"number"==typeof i&&(this.value&&+new Date(+this.value).setMilliseconds(0))===+i||(this.setProperties({value:i},!0),this.enableMask&&this.createMask()),!this.strictMode&&t.isNullOrUndefined(this.value)&&this.invalidValueString&&(this.checkErrorState(this.invalidValueString),this.updateInputValue(this.invalidValueString)),this.clearIconState()},a.prototype.setActiveDescendant=function(){t.isNullOrUndefined(this.selectedElement)?t.attributes(this.inputElement,{"aria-activedescendant":"null"}):t.attributes(this.inputElement,{"aria-activedescendant":this.selectedElement.getAttribute("id")})},a.prototype.removeSelection=function(){if(this.removeHover("e-hover"),!t.isNullOrUndefined(this.popupWrapper)){var e=this.popupWrapper.querySelectorAll("."+Ne);e.length&&(t.removeClass(e,Ne),e[0].removeAttribute("aria-selected"))}},a.prototype.removeHover=function(e){var i=this.getHoverItem(e);i&&i.length&&(t.removeClass(i,e),e===Ie&&i[0].removeAttribute("aria-selected"))},a.prototype.getHoverItem=function(e){var i;return t.isNullOrUndefined(this.popupWrapper)||(i=this.popupWrapper.querySelectorAll("."+e)),i},a.prototype.setActiveClass=function(){if(!t.isNullOrUndefined(this.popupWrapper)){var e=this.popupWrapper.querySelectorAll("."+Pe);if(e.length)for(var i=0;i<e.length;i++)if(this.timeCollections[i]===+this.getDateObject(this.valueWithMinutes)){e[i].setAttribute("aria-selected","true"),this.selectedElement=e[i],this.activeIndex=i;break}}},a.prototype.addSelection=function(){this.selectedElement=null,this.removeSelection(),this.setActiveClass(),t.isNullOrUndefined(this.selectedElement)||(t.addClass([this.selectedElement],Ne),this.selectedElement.setAttribute("aria-selected","true"))},a.prototype.isValidLI=function(e){return e&&e.classList.contains(Pe)&&!e.classList.contains(Te)},a.prototype.createDateObj=function(e){var i=this.globalize.formatDate(new Date,{format:null,skeleton:"short",type:"date"}),s=null;return"string"==typeof e?e.toUpperCase().indexOf("AM")>-1||e.toUpperCase().indexOf("PM")>-1?(i=this.defaultCulture.formatDate(new Date,{format:null,skeleton:"short",type:"date"}),s=isNaN(+new Date(i+" "+e))?null:new Date(new Date(i+" "+e).setMilliseconds(0)),t.isNullOrUndefined(s)&&(s=this.timeParse(i,e))):s=this.timeParse(i,e):e instanceof Date&&(s=e),s},a.prototype.timeParse=function(e,i){var s;return s=this.globalize.parseDate(e+" "+i,{format:this.cldrDateFormat()+" "+this.cldrTimeFormat(),type:"datetime"}),s=t.isNullOrUndefined(s)?this.globalize.parseDate(e+" "+i,{format:this.cldrDateFormat()+" "+this.dateToNumeric(),type:"datetime"}):s,s=t.isNullOrUndefined(s)?s:new Date(s.setMilliseconds(0))},a.prototype.createListItems=function(){var e=this;this.listWrapper=this.createElement("div",{className:"e-content",attrs:{tabindex:"0"}});var i,s=6e4*this.step,a=[];this.timeCollections=[],this.disableItemCollection=[],i=+this.getDateObject(this.initMin).setMilliseconds(0);for(var r=+this.getDateObject(this.initMax).setMilliseconds(0);r>=i;)this.timeCollections.push(i),a.push(this.globalize.formatDate(new Date(i),{format:this.cldrTimeFormat(),type:"time"})),i+=s;var l={itemCreated:function(t){var i={element:t.item,text:t.text,value:e.getDateObject(t.text),isDisabled:!1};e.trigger("itemRender",i,function(t){t.isDisabled&&t.element.classList.add(Te),t.element.classList.contains(Te)&&e.disableItemCollection.push(t.element.getAttribute("data-value"))})}};this.listTag=n.ListBase.createList(this.createElement,a,l,!0),t.attributes(this.listTag,{role:"listbox","aria-hidden":"false",id:this.element.id+"_options"}),t.append([this.listTag],this.listWrapper)},a.prototype.documentClickHandler=function(e){var i=e.target;!t.isNullOrUndefined(this.popupObj)&&(this.inputWrapper.container.contains(i)||this.popupObj.element&&this.popupObj.element.contains(i))&&"touchstart"!==e.type&&e.preventDefault(),t.closest(i,'[id="'+this.popupObj.element.id+'"]')||i===this.inputElement||i===(this.inputWrapper&&this.inputWrapper.buttons[0])||i===(this.inputWrapper&&this.inputWrapper.clearButton)||i===(this.inputWrapper&&this.inputWrapper.container)?i!==this.inputElement&&(t.Browser.isDevice||(this.isPreventBlur=(t.Browser.isIE||"edge"===t.Browser.info.name)&&document.activeElement===this.inputElement&&i===this.popupWrapper)):this.isPopupOpen()&&(this.hide(),this.focusOut())},a.prototype.setEnableRtl=function(){s.Input.setEnableRtl(this.enableRtl,[this.inputWrapper.container]),this.popupObj&&(this.popupObj.enableRtl=this.enableRtl,this.popupObj.dataBind())},a.prototype.setEnable=function(){s.Input.setEnabled(this.enabled,this.inputElement,this.floatLabelType),this.enabled?(t.removeClass([this.inputWrapper.container],Te),t.attributes(this.inputElement,{"aria-disabled":"false"}),this.inputElement.setAttribute("tabindex",this.tabIndex)):(this.hide(),t.addClass([this.inputWrapper.container],Te),t.attributes(this.inputElement,{"aria-disabled":"true"}),this.inputElement.tabIndex=-1)},a.prototype.getProperty=function(e,t){"min"===t?(this.initMin=this.checkDateValue(new Date(this.checkInValue(e.min))),this.setProperties({min:this.initMin},!0)):(this.initMax=this.checkDateValue(new Date(this.checkInValue(e.max))),this.setProperties({max:this.initMax},!0)),""===this.inputElement.value?this.validateMinMax(this.value,this.min,this.max):this.checkValue(this.inputElement.value),this.checkValueChange(null,!1)},a.prototype.inputBlurHandler=function(e){if(this.enabled)if(this.isPreventBlur&&this.isPopupOpen())this.inputElement.focus();else{this.closePopup(0,e),this.enableMask&&this.maskedDateValue&&this.placeholder&&"Always"!==this.floatLabelType&&(this.inputElement.value!=this.maskedDateValue||this.value||"Auto"!=this.floatLabelType&&"Never"!=this.floatLabelType&&!this.placeholder||this.updateInputValue("")),t.removeClass([this.inputWrapper.container],[xe]);var i={model:this};this.trigger("blur",i),this.getText()!==this.inputElement.value?this.updateValue(this.inputElement.value,e):0===this.inputElement.value.trim().length&&this.resetState(),this.cursorDetails=null,this.isNavigate=!1,""===this.inputElement.value&&(this.invalidValueString=null)}},a.prototype.focusOut=function(){if(document.activeElement===this.inputElement){this.inputElement.blur(),t.removeClass([this.inputWrapper.container],[xe]);var e={model:this};this.trigger("blur",e)}},a.prototype.isPopupOpen=function(){return!(!this.popupWrapper||!this.popupWrapper.classList.contains(""+Oe))},a.prototype.inputFocusHandler=function(){if(this.enabled){var e={model:this};this.readonly||t.Browser.isDevice||this.enableMask||this.selectInputText(),this.enableMask&&!this.inputElement.value&&this.placeholder&&(!this.maskedDateValue||this.value||"Auto"!=this.floatLabelType&&"Never"!=this.floatLabelType&&!this.placeholder||(this.updateInputValue(this.maskedDateValue),this.inputElement.selectionStart=0,this.inputElement.selectionEnd=this.inputElement.value.length)),this.trigger("focus",e),this.clearIconState(),this.openOnFocus&&this.show()}},a.prototype.focusIn=function(){document.activeElement!==this.inputElement&&this.enabled&&this.inputElement.focus()},a.prototype.hide=function(){this.closePopup(100,null),this.clearIconState()},a.prototype.show=function(e){var i=this;if(!(this.enabled&&this.readonly||!this.enabled||this.popupWrapper)){this.popupCreation(),t.Browser.isDevice&&this.listWrapper&&(this.modal=this.createElement("div"),this.modal.className=Oe+" e-time-modal",document.body.className+=" e-time-overflow",document.body.appendChild(this.modal)),t.Browser.isDevice&&(this.mobileTimePopupWrap=this.createElement("div",{className:"e-timepicker-mob-popup-wrap"}),document.body.appendChild(this.mobileTimePopupWrap)),this.openPopupEventArgs={popup:this.popupObj||null,cancel:!1,event:e||null,name:"open",appendTo:t.Browser.isDevice?this.mobileTimePopupWrap:document.body};var s=this.openPopupEventArgs;this.trigger("open",s,function(e){if(i.openPopupEventArgs=e,i.openPopupEventArgs.cancel||i.inputWrapper.buttons[0].classList.contains(Te))i.popupObj.destroy(),i.popupWrapper=i.listTag=void 0,i.liCollections=i.timeCollections=i.disableItemCollection=[],i.popupObj=null;else{i.openPopupEventArgs.appendTo.appendChild(i.popupWrapper),i.popupAlignment(i.openPopupEventArgs),i.setScrollPosition(),t.Browser.isDevice||i.inputElement.focus();var s={name:"FadeIn",duration:50};i.popupObj.refreshPosition(i.anchor),1e3===i.zIndex?i.popupObj.show(new t.Animation(s),i.element):i.popupObj.show(new t.Animation(s),null),i.setActiveDescendant(),t.attributes(i.inputElement,{"aria-expanded":"true"}),t.addClass([i.inputWrapper.container],xe),t.EventHandler.add(document,"mousedown touchstart",i.documentClickHandler,i),i.setOverlayIndex(i.mobileTimePopupWrap,i.popupObj.element,i.modal,t.Browser.isDevice)}})}},a.prototype.setOverlayIndex=function(e,i,s,a){if(a&&!t.isNullOrUndefined(i)&&!t.isNullOrUndefined(s)&&!t.isNullOrUndefined(e)){var n=parseInt(i.style.zIndex,10)?parseInt(i.style.zIndex,10):1e3;s.style.zIndex=(n-1).toString(),e.style.zIndex=n.toString()}},a.prototype.formatValues=function(e){var i;return"number"==typeof e?i=t.formatUnit(e):"string"==typeof e&&(i=e.match(/px|%|em/)?e:isNaN(parseInt(e,10))?e:t.formatUnit(e)),i},a.prototype.popupAlignment=function(e){if(e.popup.position.X=this.formatValues(e.popup.position.X),e.popup.position.Y=this.formatValues(e.popup.position.Y),isNaN(parseFloat(e.popup.position.X))&&isNaN(parseFloat(e.popup.position.Y))||(this.popupObj.relateTo=this.anchor=document.body,this.popupObj.targetType="container"),isNaN(parseFloat(e.popup.position.X))||(this.popupObj.offsetX=parseFloat(e.popup.position.X)),isNaN(parseFloat(e.popup.position.Y))||(this.popupObj.offsetY=parseFloat(e.popup.position.Y)),t.Browser.isDevice)"center"===e.popup.position.X&&"center"===e.popup.position.Y&&(this.popupObj.relateTo=this.anchor=document.body,this.popupObj.offsetY=0,this.popupObj.targetType="container",this.popupObj.collision={X:"fit",Y:"fit"});else{switch(e.popup.position.X){case"left":break;case"right":e.popup.offsetX=this.containerStyle.width;break;case"center":e.popup.offsetX=-this.containerStyle.width/2}switch(e.popup.position.Y){case"top":case"bottom":break;case"center":e.popup.offsetY=-this.containerStyle.height/2}"center"===e.popup.position.X&&"center"===e.popup.position.Y&&(this.popupObj.relateTo=this.inputWrapper.container,this.anchor=this.inputElement,this.popupObj.targetType="relative")}},a.prototype.getPersistData=function(){return this.addOnPersist(["value"])},a.prototype.getModuleName=function(){return"timepicker"},a.prototype.onPropertyChanged=function(e,i){for(var a=0,n=Object.keys(e);a<n.length;a++){var r=n[a];switch(r){case"placeholder":s.Input.setPlaceholder(e.placeholder,this.inputElement),this.inputElement.setAttribute("aria-placeholder",e.placeholder);break;case"readonly":s.Input.setReadonly(this.readonly,this.inputElement,this.floatLabelType),this.readonly&&this.hide(),this.setTimeAllowEdit();break;case"enabled":this.setProperties({enabled:e.enabled},!0),this.setEnable();break;case"allowEdit":this.setTimeAllowEdit();break;case"enableRtl":this.setProperties({enableRtl:e.enableRtl},!0),this.setEnableRtl();break;case"cssClass":this.updateCssClass(e.cssClass,i.cssClass);break;case"zIndex":this.setProperties({zIndex:e.zIndex},!0),this.setZIndex();break;case"htmlAttributes":this.updateHtmlAttributeToElement(),this.updateHtmlAttributeToWrapper(),this.checkAttributes(!0);break;case"min":case"max":this.getProperty(e,r);break;case"showClearButton":s.Input.setClearButton(this.showClearButton,this.inputElement,this.inputWrapper),this.bindClearEvent();break;case"locale":this.setProperties({locale:e.locale},!0),this.globalize=new t.Internationalization(this.locale),this.l10n.setLocale(this.locale),this.updatePlaceHolder(),this.setValue(this.value),this.enableMask&&this.notify("createMask",{module:"MaskedDateTime"});break;case"width":t.setStyleAttribute(this.inputWrapper.container,{width:this.setWidth(e.width)}),this.containerStyle=this.inputWrapper.container.getBoundingClientRect();break;case"format":this.setProperties({format:e.format},!0),this.checkTimeFormat(),this.setValue(this.value),this.enableMask&&(this.createMask(),this.value||this.updateInputValue(this.maskedDateValue));break;case"value":this.invalidValueString=null,this.checkInvalidValue(e.value),e.value=this.value,this.invalidValueString?(this.updateInputValue(this.invalidValueString),this.checkErrorState(this.invalidValueString)):("string"==typeof e.value?(this.setProperties({value:this.checkDateValue(new Date(e.value))},!0),e.value=this.value):(e.value&&+new Date(+e.value).setMilliseconds(0))!==+this.value&&(e.value=this.checkDateValue(new Date(""+e.value))),this.initValue=e.value,e.value=this.compareFormatChange(this.checkValue(e.value))),this.checkValueChange(null,!1),this.isPopupOpen()&&this.setScrollPosition(),this.isAngular&&this.preventChange&&(this.preventChange=!1),this.enableMask&&this.notify("createMask",{module:"MaskedDateTime"});break;case"floatLabelType":this.floatLabelType=e.floatLabelType,s.Input.removeFloating(this.inputWrapper),s.Input.addFloating(this.inputElement,this.floatLabelType,this.placeholder);break;case"strictMode":this.invalidValueString=null,e.strictMode&&this.checkErrorState(null),this.setProperties({strictMode:e.strictMode},!0),this.checkValue(this.inputElement.value),this.checkValueChange(null,!1);break;case"scrollTo":this.checkDateValue(new Date(this.checkInValue(e.scrollTo)))?(this.popupWrapper&&this.setScrollTo(),this.setProperties({scrollTo:this.checkDateValue(new Date(this.checkInValue(e.scrollTo)))},!0)):this.setProperties({scrollTo:null},!0);break;case"enableMask":this.enableMask?(this.notify("createMask",{module:"MaskedDateTime"}),this.updateInputValue(this.maskedDateValue)):this.inputElement.value===this.maskedDateValue&&this.updateInputValue("")}}},a.prototype.checkInValue=function(e){return e instanceof Date?e.toUTCString():""+e},ke([t.Property(null)],a.prototype,"width",void 0),ke([t.Property(null)],a.prototype,"cssClass",void 0),ke([t.Property(!1)],a.prototype,"strictMode",void 0),ke([t.Property(null)],a.prototype,"keyConfigs",void 0),ke([t.Property(null)],a.prototype,"format",void 0),ke([t.Property(!0)],a.prototype,"enabled",void 0),ke([t.Property(!1)],a.prototype,"readonly",void 0),ke([t.Property({})],a.prototype,"htmlAttributes",void 0),ke([t.Property("Never")],a.prototype,"floatLabelType",void 0),ke([t.Property(null)],a.prototype,"placeholder",void 0),ke([t.Property(1e3)],a.prototype,"zIndex",void 0),ke([t.Property(!1)],a.prototype,"enablePersistence",void 0),ke([t.Property(!0)],a.prototype,"showClearButton",void 0),ke([t.Property(30)],a.prototype,"step",void 0),ke([t.Property(null)],a.prototype,"scrollTo",void 0),ke([t.Property(null)],a.prototype,"value",void 0),ke([t.Property(null)],a.prototype,"min",void 0),ke([t.Property(null)],a.prototype,"max",void 0),ke([t.Property(!0)],a.prototype,"allowEdit",void 0),ke([t.Property(!1)],a.prototype,"openOnFocus",void 0),ke([t.Property(!1)],a.prototype,"enableMask",void 0),ke([t.Property({day:"day",month:"month",year:"year",hour:"hour",minute:"minute",second:"second",dayOfTheWeek:"day of the week"})],a.prototype,"maskPlaceholder",void 0),ke([t.Event()],a.prototype,"change",void 0),ke([t.Event()],a.prototype,"created",void 0),ke([t.Event()],a.prototype,"destroyed",void 0),ke([t.Event()],a.prototype,"open",void 0),ke([t.Event()],a.prototype,"itemRender",void 0),ke([t.Event()],a.prototype,"close",void 0),ke([t.Event()],a.prototype,"cleared",void 0),ke([t.Event()],a.prototype,"blur",void 0),ke([t.Event()],a.prototype,"focus",void 0),a=ke([t.NotifyPropertyChanges],a)}(t.Component),We=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),Le=function(e,t,i,s){var a,n=arguments.length,r=n<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(e,t,i,s);else for(var l=e.length-1;l>=0;l--)(a=e[l])&&(r=(n<3?a(r):n>3?a(t,i,r):a(t,i))||r);return n>3&&r&&Object.defineProperty(t,i,r),r},Fe=(new Date).getDate(),Be=(new Date).getMonth(),je=(new Date).getFullYear(),Ye=(new Date).getHours(),Re=(new Date).getMinutes(),ze=(new Date).getSeconds(),qe=(new Date).getMilliseconds(),Ke="e-datetimepicker",_e="e-datetimepopup-wrapper",Ge="e-input-focus",Ze="e-disabled",Xe="e-active",Je="e-list-item",$e=function(a){function n(e,t){var i=a.call(this,e,t)||this;return i.valueWithMinutes=null,i.scrollInvoked=!1,i.moduleName=i.getModuleName(),i.dateTimeOptions=e,i}return We(n,a),n.prototype.focusHandler=function(){this.enabled&&t.addClass([this.inputWrapper.container],Ge)},n.prototype.focusIn=function(){a.prototype.focusIn.call(this)},n.prototype.focusOut=function(){document.activeElement===this.inputElement&&(this.inputElement.blur(),t.removeClass([this.inputWrapper.container],[Ge]))},n.prototype.blurHandler=function(e){if(this.enabled)if(this.isTimePopupOpen()&&this.isPreventBlur)this.inputElement.focus();else{t.removeClass([this.inputWrapper.container],Ge);var i={model:this};this.isTimePopupOpen()&&this.hide(e),this.trigger("blur",i)}},n.prototype.destroy=function(){this.popupObject&&this.popupObject.element.classList.contains("e-popup")&&(this.popupObject.destroy(),t.detach(this.dateTimeWrapper),this.dateTimeWrapper=void 0,this.liCollections=this.timeCollections=[],t.isNullOrUndefined(this.rippleFn)||this.rippleFn());var e={"aria-live":"assertive","aria-atomic":"true","aria-invalid":"false","aria-haspopup":"true","aria-activedescendant":"null",autocorrect:"off",autocapitalize:"off",spellcheck:"false","aria-owns":this.element.id+"_options","aria-expanded":"false",role:"combobox",autocomplete:"off"};this.inputElement&&(s.Input.removeAttributes(e,this.inputElement),this.inputElement.removeAttribute("aria-placeholder")),this.isCalendar()&&(this.popupWrapper&&t.detach(this.popupWrapper),this.popupObject=this.popupWrapper=null,this.keyboardHandler.destroy()),this.unBindInputEvents(),a.prototype.destroy.call(this)},n.prototype.render=function(){this.timekeyConfigure={enter:"enter",escape:"escape",end:"end",tab:"tab",home:"home",down:"downarrow",up:"uparrow",left:"leftarrow",right:"rightarrow",open:"alt+downarrow",close:"alt+uparrow"},this.valueWithMinutes=null,this.previousDateTime=null,this.isPreventBlur=!1,this.cloneElement=this.element.cloneNode(!0),this.dateTimeFormat=this.cldrDateTimeFormat(),this.initValue=this.value,a.prototype.updateHtmlAttributeToElement.call(this),this.checkAttributes(!1);var e={placeholder:this.placeholder};this.l10n=new t.L10n("datetimepicker",e,this.locale),this.setProperties({placeholder:this.placeholder||this.l10n.getConstant("placeholder")},!0),a.prototype.render.call(this),this.createInputElement(),a.prototype.updateHtmlAttributeToWrapper.call(this),this.bindInputEvents(),this.enableMask&&this.notify("createMask",{module:"MaskedDateTime"}),this.setValue(),!this.enableMask||this.value||!this.maskedDateValue||"Always"!=this.floatLabelType&&this.floatLabelType&&this.placeholder||s.Input.setValue(this.maskedDateValue,this.inputElement,this.floatLabelType,this.showClearButton),this.setProperties({scrollTo:this.checkDateValue(new Date(this.checkValue(this.scrollTo)))},!0),this.previousDateTime=this.value&&new Date(+this.value),"EJS-DATETIMEPICKER"===this.element.tagName&&(this.tabIndex=this.element.hasAttribute("tabindex")?this.element.getAttribute("tabindex"):"0",this.element.removeAttribute("tabindex"),this.enabled||(this.inputElement.tabIndex=-1)),this.renderComplete()},n.prototype.setValue=function(){if(this.initValue=this.validateMinMaxRange(this.value),!this.strictMode&&this.isDateObject(this.initValue)){var e=this.validateMinMaxRange(this.initValue);s.Input.setValue(this.getFormattedValue(e),this.inputElement,this.floatLabelType,this.showClearButton),this.setProperties({value:e},!0)}else t.isNullOrUndefined(this.value)&&(this.initValue=null,this.setProperties({value:null},!0));this.valueWithMinutes=this.value,a.prototype.updateInput.call(this)},n.prototype.validateMinMaxRange=function(e){var t=e;return this.isDateObject(e)?t=this.validateValue(e):+this.min>+this.max&&this.disablePopupButton(!0),this.checkValidState(t),t},n.prototype.checkValidState=function(e){this.isValidState=!0,this.strictMode||(+e>+this.max||+e<+this.min)&&(this.isValidState=!1),this.checkErrorState()},n.prototype.checkErrorState=function(){this.isValidState?t.removeClass([this.inputWrapper.container],"e-error"):t.addClass([this.inputWrapper.container],"e-error"),t.attributes(this.inputElement,{"aria-invalid":this.isValidState?"false":"true"})},n.prototype.validateValue=function(e){var t=e;return this.strictMode?+this.min>+this.max?(this.disablePopupButton(!0),t=this.max):+e<+this.min?t=this.min:+e>+this.max&&(t=this.max):+this.min>+this.max&&(this.disablePopupButton(!0),t=e),t},n.prototype.disablePopupButton=function(e){e?(t.addClass([this.inputWrapper.buttons[0],this.timeIcon],Ze),this.hide()):t.removeClass([this.inputWrapper.buttons[0],this.timeIcon],Ze)},n.prototype.getFormattedValue=function(e){var i;return t.isNullOrUndefined(e)?null:(i="Gregorian"===this.calendarMode?{format:this.cldrDateTimeFormat(),type:"dateTime",skeleton:"yMd"}:{format:this.cldrDateTimeFormat(),type:"dateTime",skeleton:"yMd",calendar:"islamic"},this.globalize.formatDate(e,i))},n.prototype.isDateObject=function(e){return!t.isNullOrUndefined(e)&&!isNaN(+e)},n.prototype.createInputElement=function(){t.removeClass([this.inputElement],"e-datepicker"),t.removeClass([this.inputWrapper.container],"e-date-wrapper"),t.addClass([this.inputWrapper.container],"e-datetime-wrapper"),t.addClass([this.inputElement],Ke),this.renderTimeIcon()},n.prototype.renderTimeIcon=function(){this.timeIcon=s.Input.appendSpan("e-input-group-icon e-time-icon e-icons",this.inputWrapper.container)},n.prototype.bindInputEvents=function(){t.EventHandler.add(this.timeIcon,"mousedown",this.timeHandler,this),t.EventHandler.add(this.inputWrapper.buttons[0],"mousedown",this.dateHandler,this),t.EventHandler.add(this.inputElement,"blur",this.blurHandler,this),t.EventHandler.add(this.inputElement,"focus",this.focusHandler,this),this.defaultKeyConfigs=t.extend(this.defaultKeyConfigs,this.keyConfigs),this.keyboardHandler=new t.KeyboardEvents(this.inputElement,{eventName:"keydown",keyAction:this.inputKeyAction.bind(this),keyConfigs:this.defaultKeyConfigs})},n.prototype.unBindInputEvents=function(){t.EventHandler.remove(this.timeIcon,"mousedown touchstart",this.timeHandler),t.EventHandler.remove(this.inputWrapper.buttons[0],"mousedown touchstart",this.dateHandler),this.inputElement&&(t.EventHandler.remove(this.inputElement,"blur",this.blurHandler),t.EventHandler.remove(this.inputElement,"focus",this.focusHandler)),this.keyboardHandler&&this.keyboardHandler.destroy()},n.prototype.cldrTimeFormat=function(){return this.isNullOrEmpty(this.timeFormat)?"en"===this.locale||"en-US"===this.locale?t.getValue("timeFormats.short",t.getDefaultDateObject()):this.getCultureTimeObject(t.cldrData,""+this.locale):this.timeFormat},n.prototype.cldrDateTimeFormat=function(){var e=new t.Internationalization(this.locale).getDatePattern({skeleton:"yMd"});return this.isNullOrEmpty(this.formatString)?e+" "+this.getCldrFormat("time"):this.formatString},n.prototype.getCldrFormat=function(e){return"en"===this.locale||"en-US"===this.locale?t.getValue("timeFormats.short",t.getDefaultDateObject()):this.getCultureTimeObject(t.cldrData,""+this.locale)},n.prototype.isNullOrEmpty=function(e){return!!(t.isNullOrUndefined(e)||"string"==typeof e&&""===e.trim())},n.prototype.getCultureTimeObject=function(e,i){return"Gregorian"===this.calendarMode?t.getValue("main."+this.locale+".dates.calendars.gregorian.timeFormats.short",e):t.getValue("main."+this.locale+".dates.calendars.islamic.timeFormats.short",e)},n.prototype.timeHandler=function(e){this.enabled&&(this.isIconClicked=!0,t.Browser.isDevice&&this.inputElement.setAttribute("readonly",""),e.currentTarget===this.timeIcon&&e.preventDefault(),this.enabled&&!this.readonly&&(this.isDatePopupOpen()&&a.prototype.hide.call(this,e),this.isTimePopupOpen()?this.closePopup(e):(this.inputElement.focus(),this.popupCreation("time",e),t.addClass([this.inputWrapper.container],[Ge]))),this.isIconClicked=!1)},n.prototype.dateHandler=function(e){this.enabled&&(e.currentTarget===this.inputWrapper.buttons[0]&&e.preventDefault(),this.enabled&&!this.readonly&&(this.isTimePopupOpen()&&this.closePopup(e),t.isNullOrUndefined(this.popupWrapper)||this.popupCreation("date",e)))},n.prototype.show=function(e,t){this.enabled&&this.readonly||!this.enabled||("time"!==e||this.dateTimeWrapper?this.popupObj||(this.isTimePopupOpen()&&this.hide(t),a.prototype.show.call(this),this.popupCreation("date",t)):(this.isDatePopupOpen()&&this.hide(t),this.popupCreation("time",t)))},n.prototype.toggle=function(e){this.isDatePopupOpen()?(a.prototype.hide.call(this,e),this.show("time",null)):this.isTimePopupOpen()?(this.hide(e),a.prototype.show.call(this,null,e),this.popupCreation("date",null)):this.show(null,e)},n.prototype.listCreation=function(){var i;i="Gregorian"===this.calendarMode?this.globalize.parseDate(this.inputElement.value,{format:this.cldrDateTimeFormat(),type:"datetime"}):this.globalize.parseDate(this.inputElement.value,{format:this.cldrDateTimeFormat(),type:"datetime",calendar:"islamic"});var s=t.isNullOrUndefined(this.value)?""!==this.inputElement.value?i:new Date:this.value;this.valueWithMinutes=s,this.listWrapper=t.createElement("div",{className:"e-content",attrs:{tabindex:"0"}});var a=this.startTime(s),n=this.endTime(s),r=e.TimePickerBase.createListItems(this.createElement,a,n,this.globalize,this.cldrTimeFormat(),this.step);this.timeCollections=r.collection,this.listTag=r.list,t.attributes(this.listTag,{role:"listbox","aria-hidden":"false",id:this.element.id+"_options"}),t.append([r.list],this.listWrapper),this.wireTimeListEvents();var l={duration:300,selector:"."+Je};this.rippleFn=t.rippleEffect(this.listWrapper,l),this.liCollections=this.listWrapper.querySelectorAll("."+Je)},n.prototype.popupCreation=function(e,i){t.Browser.isDevice&&this.element.setAttribute("readonly","readonly"),"date"===e?!this.readonly&&this.popupWrapper&&(t.addClass([this.popupWrapper],_e),t.attributes(this.popupWrapper,{id:this.element.id+"_datepopup"})):this.readonly||(this.dateTimeWrapper=t.createElement("div",{className:Ke+" e-popup",attrs:{id:this.element.id+"_timepopup",style:"visibility:hidden ; display:block"}}),t.isNullOrUndefined(this.cssClass)||(this.dateTimeWrapper.className+=" "+this.cssClass),!t.isNullOrUndefined(this.step)&&this.step>0&&(this.listCreation(),t.append([this.listWrapper],this.dateTimeWrapper)),document.body.appendChild(this.dateTimeWrapper),this.addTimeSelection(),this.renderPopup(),this.setTimeScrollPosition(),this.openPopup(i),this.popupObject.refreshPosition(this.inputElement))},n.prototype.openPopup=function(e){var i=this;this.preventArgs={cancel:!1,popup:this.popupObject,event:e||null};var s=this.preventArgs;this.trigger("open",s,function(e){if(i.preventArgs=e,!i.preventArgs.cancel&&!i.readonly){var s={name:"FadeIn",duration:100};1e3===i.zIndex?i.popupObject.show(new t.Animation(s),i.element):i.popupObject.show(new t.Animation(s),null),t.addClass([i.inputWrapper.container],["e-icon-anim"]),t.attributes(i.inputElement,{"aria-expanded":"true"}),t.EventHandler.add(document,"mousedown touchstart",i.documentClickHandler,i)}})},n.prototype.documentClickHandler=function(e){var i=e.target;!t.isNullOrUndefined(this.popupObject)&&(this.inputWrapper.container.contains(i)||this.popupObject.element&&this.popupObject.element.contains(i))&&"touchstart"!==e.type&&e.preventDefault(),t.closest(i,'[id="'+(this.popupObject&&this.popupObject.element.id+'"]'))||i===this.inputElement||i===this.timeIcon||i===this.inputWrapper.container?i!==this.inputElement&&(t.Browser.isDevice||(this.isPreventBlur=document.activeElement===this.inputElement&&(t.Browser.isIE||"edge"===t.Browser.info.name)&&i===this.popupObject.element)):this.isTimePopupOpen()&&(this.hide(e),this.focusOut())},n.prototype.isTimePopupOpen=function(){return!(!this.dateTimeWrapper||!this.dateTimeWrapper.classList.contains(""+Ke))},n.prototype.isDatePopupOpen=function(){return!(!this.popupWrapper||!this.popupWrapper.classList.contains(""+_e))},n.prototype.renderPopup=function(){var e=this;this.containerStyle=this.inputWrapper.container.getBoundingClientRect(),t.Browser.isDevice&&(this.timeModal=t.createElement("div"),this.timeModal.className=Ke+" e-time-modal",document.body.className+=" e-time-overflow",this.timeModal.style.display="block",document.body.appendChild(this.timeModal));this.popupObject=new i.Popup(this.dateTimeWrapper,{width:this.setPopupWidth(),zIndex:this.zIndex,targetType:"container",collision:t.Browser.isDevice?{X:"fit",Y:"fit"}:{X:"flip",Y:"flip"},relateTo:t.Browser.isDevice?document.body:this.inputWrapper.container,position:t.Browser.isDevice?{X:"center",Y:"center"}:{X:"left",Y:"bottom"},enableRtl:this.enableRtl,offsetY:4,open:function(){e.dateTimeWrapper.style.visibility="visible",t.addClass([e.timeIcon],Xe),t.Browser.isDevice||(e.timekeyConfigure=t.extend(e.timekeyConfigure,e.keyConfigs),e.inputEvent=new t.KeyboardEvents(e.inputWrapper.container,{keyAction:e.timeKeyActionHandle.bind(e),keyConfigs:e.timekeyConfigure,eventName:"keydown"}))},close:function(){t.removeClass([e.timeIcon],Xe),e.unWireTimeListEvents(),e.inputElement.setAttribute("aria-activedescendant","null"),t.remove(e.popupObject.element),e.popupObject.destroy(),e.dateTimeWrapper.innerHTML="",e.listWrapper=e.dateTimeWrapper=void 0,e.inputEvent&&e.inputEvent.destroy()},targetExitViewport:function(){t.Browser.isDevice||e.hide()}}),this.popupObject.element.style.maxHeight="250px"},n.prototype.setDimension=function(e){return e="number"==typeof e?t.formatUnit(e):"string"==typeof e?e:"100%"},n.prototype.setPopupWidth=function(){var e=this.setDimension(this.width);if(e.indexOf("%")>-1){e=(this.containerStyle.width*parseFloat(e)/100).toString()+"px"}return e},n.prototype.wireTimeListEvents=function(){t.EventHandler.add(this.listWrapper,"click",this.onMouseClick,this),t.Browser.isDevice||(t.EventHandler.add(this.listWrapper,"mouseover",this.onMouseOver,this),t.EventHandler.add(this.listWrapper,"mouseout",this.onMouseLeave,this))},n.prototype.unWireTimeListEvents=function(){this.listWrapper&&(t.EventHandler.remove(this.listWrapper,"click",this.onMouseClick),t.EventHandler.remove(document,"mousedown touchstart",this.documentClickHandler),t.Browser.isDevice||(t.EventHandler.add(this.listWrapper,"mouseover",this.onMouseOver,this),t.EventHandler.add(this.listWrapper,"mouseout",this.onMouseLeave,this)))},n.prototype.onMouseOver=function(e){var i=t.closest(e.target,"."+Je);this.setTimeHover(i,"e-hover")},n.prototype.onMouseLeave=function(){this.removeTimeHover("e-hover")},n.prototype.setTimeHover=function(e,i){this.enabled&&this.isValidLI(e)&&!e.classList.contains(i)&&(this.removeTimeHover(i),t.addClass([e],i))},n.prototype.getPopupHeight=function(){var e=parseInt("250px",10),t=this.dateTimeWrapper.getBoundingClientRect().height;return t>e?e:t},n.prototype.changeEvent=function(e){(this.value&&this.value.valueOf())!==(this.previousDateTime&&+this.previousDateTime.valueOf())&&(a.prototype.changeEvent.call(this,e),this.valueWithMinutes=this.value,this.setInputValue("date"),this.previousDateTime=this.value&&new Date(+this.value))},n.prototype.updateValue=function(e){this.setInputValue("time"),+this.previousDateTime!=+this.value&&(this.changedArgs={value:this.value,event:e||null,isInteracted:!t.isNullOrUndefined(e),element:this.element},this.addTimeSelection(),this.trigger("change",this.changedArgs),this.previousDateTime=this.previousDate=this.value)},n.prototype.setTimeScrollPosition=function(){var e=this.selectedElement;t.isNullOrUndefined(e)?this.dateTimeWrapper&&this.checkDateValue(this.scrollTo)&&this.setScrollTo():this.findScrollTop(e)},n.prototype.findScrollTop=function(e){var t=this.getPopupHeight(),i=e.nextElementSibling,s=i?i.offsetTop:e.offsetTop,a=e.getBoundingClientRect().height;s+e.offsetTop>t?this.dateTimeWrapper.scrollTop=i?s-(t/2+a/2):s:this.dateTimeWrapper.scrollTop=0},n.prototype.setScrollTo=function(){var e,i=this.dateTimeWrapper.querySelectorAll("."+Je);if(i.length>=0){this.scrollInvoked=!0;var s=this.timeCollections[0],a=this.getDateObject(this.checkDateValue(this.scrollTo)).getTime();e=i[Math.round((a-s)/(6e4*this.step))]}else this.dateTimeWrapper.scrollTop=0;t.isNullOrUndefined(e)?this.dateTimeWrapper.scrollTop=0:this.findScrollTop(e)},n.prototype.setInputValue=function(e){if("date"===e)this.inputElement.value=this.previousElementValue=this.getFormattedValue(this.getFullDateTime()),this.setProperties({value:this.getFullDateTime()},!0);else{var t=this.getFormattedValue(new Date(this.timeCollections[this.activeIndex]));s.Input.setValue(t,this.inputElement,this.floatLabelType,this.showClearButton),this.previousElementValue=this.inputElement.value,this.setProperties({value:new Date(this.timeCollections[this.activeIndex])},!0),this.enableMask&&this.createMask()}this.updateIconState()},n.prototype.getFullDateTime=function(){var e=null;return e=this.isDateObject(this.valueWithMinutes)?this.combineDateTime(this.valueWithMinutes):this.previousDate,this.validateMinMaxRange(e)},n.prototype.createMask=function(){this.notify("createMask",{module:"MaskedDateTime"})},n.prototype.combineDateTime=function(e){if(this.isDateObject(e)){var t=this.previousDate.getDate(),i=this.previousDate.getMonth(),s=this.previousDate.getFullYear(),a=e.getHours(),n=e.getMinutes(),r=e.getSeconds();return new Date(s,i,t,a,n,r)}return this.previousDate},n.prototype.onMouseClick=function(e){var i=e.target,s=this.selectedElement=t.closest(i,"."+Je);s&&s.classList.contains(Je)&&(this.timeValue=s.getAttribute("data-value"),this.hide(e)),this.setSelection(s,e)},n.prototype.setSelection=function(e,i){if(this.isValidLI(e)&&!e.classList.contains(Xe)){this.selectedElement=e;var s=Array.prototype.slice.call(this.liCollections).indexOf(e);this.activeIndex=s,this.valueWithMinutes=new Date(this.timeCollections[this.activeIndex]),t.addClass([this.selectedElement],Xe),this.selectedElement.setAttribute("aria-selected","true"),this.updateValue(i)}},n.prototype.setTimeActiveClass=function(){var e=t.isNullOrUndefined(this.dateTimeWrapper)?this.listWrapper:this.dateTimeWrapper;if(!t.isNullOrUndefined(e)){var i=e.querySelectorAll("."+Je);if(i.length)for(var s=0;s<i.length;s++)if(this.timeCollections[s]===+this.valueWithMinutes){i[s].setAttribute("aria-selected","true"),this.selectedElement=i[s],this.activeIndex=s,this.setTimeActiveDescendant();break}}},n.prototype.setTimeActiveDescendant=function(){t.isNullOrUndefined(this.selectedElement)?t.attributes(this.inputElement,{"aria-activedescendant":"null"}):t.attributes(this.inputElement,{"aria-activedescendant":this.selectedElement.getAttribute("id")})},n.prototype.addTimeSelection=function(){this.selectedElement=null,this.removeTimeSelection(),this.setTimeActiveClass(),t.isNullOrUndefined(this.selectedElement)||(t.addClass([this.selectedElement],Xe),this.selectedElement.setAttribute("aria-selected","true"))},n.prototype.removeTimeSelection=function(){if(this.removeTimeHover("e-hover"),!t.isNullOrUndefined(this.dateTimeWrapper)){var e=this.dateTimeWrapper.querySelectorAll("."+Xe);e.length&&(t.removeClass(e,Xe),e[0].removeAttribute("aria-selected"))}},n.prototype.removeTimeHover=function(e){var i=this.getTimeHoverItem(e);i&&i.length&&t.removeClass(i,e)},n.prototype.getTimeHoverItem=function(e){var i,s=t.isNullOrUndefined(this.dateTimeWrapper)?this.listWrapper:this.dateTimeWrapper;return t.isNullOrUndefined(s)||(i=s.querySelectorAll("."+e)),i},n.prototype.isValidLI=function(e){return e&&e.classList.contains(Je)&&!e.classList.contains(Ze)},n.prototype.calculateStartEnd=function(e,t,i){var s=e.getDate(),a=e.getMonth(),n=e.getFullYear(),r=e.getHours(),l=e.getMinutes(),o=e.getSeconds(),h=e.getMilliseconds();return t?"starttime"===i?new Date(n,a,s,0,0,0):new Date(n,a,s,23,59,59):new Date(n,a,s,r,l,o,h)},n.prototype.startTime=function(e){var t,i,s=this.min,a=null===e?new Date:e;return+a.getDate()==+s.getDate()&&+a.getMonth()==+s.getMonth()&&+a.getFullYear()==+s.getFullYear()||+new Date(a.getFullYear(),a.getMonth(),a.getDate())<=+new Date(s.getFullYear(),s.getMonth(),s.getDate())?(i=!1,t=this.min):+a<+this.max&&+a>+this.min?(i=!0,t=a):+a>=+this.max&&(i=!0,t=this.max),this.calculateStartEnd(t,i,"starttime")},n.prototype.endTime=function(e){var t,i,s=this.max,a=null===e?new Date:e;return+a.getDate()==+s.getDate()&&+a.getMonth()==+s.getMonth()&&+a.getFullYear()==+s.getFullYear()||+new Date(a.getUTCFullYear(),a.getMonth(),a.getDate())>=+new Date(s.getFullYear(),s.getMonth(),s.getDate())?(i=!1,t=this.max):+a<+this.max&&+a>+this.min?(i=!0,t=a):+a<=+this.min&&(i=!0,t=this.min),this.calculateStartEnd(t,i,"endtime")},n.prototype.hide=function(e){var i=this;if(this.popupObj||this.dateTimeWrapper){this.preventArgs={cancel:!1,popup:this.popupObj||this.popupObject,event:e||null};var s=this.preventArgs;t.isNullOrUndefined(this.popupObj)?this.trigger("close",s,function(t){i.dateTimeCloseEventCallback(e,t)}):this.dateTimeCloseEventCallback(e,s)}else t.Browser.isDevice&&this.allowEdit&&!this.readonly&&this.inputElement.removeAttribute("readonly"),this.setAllowEdit()},n.prototype.dateTimeCloseEventCallback=function(e,i){this.preventArgs=i,this.preventArgs.cancel||(this.isDatePopupOpen()?a.prototype.hide.call(this,e):this.isTimePopupOpen()&&(this.closePopup(e),t.removeClass([document.body],"e-time-overflow"),t.Browser.isDevice&&this.timeModal&&(this.timeModal.style.display="none",this.timeModal.outerHTML="",this.timeModal=null),this.setTimeActiveDescendant())),t.Browser.isDevice&&this.allowEdit&&!this.readonly&&this.inputElement.removeAttribute("readonly"),this.setAllowEdit()},n.prototype.closePopup=function(e){if(this.isTimePopupOpen()&&this.popupObject){var i={name:"FadeOut",duration:100,delay:0};this.popupObject.hide(new t.Animation(i)),this.inputWrapper.container.classList.remove("e-icon-anim"),t.attributes(this.inputElement,{"aria-expanded":"false"}),t.EventHandler.remove(document,"mousedown touchstart",this.documentClickHandler)}},n.prototype.preRender=function(){this.checkFormat(),this.dateTimeFormat=this.cldrDateTimeFormat(),a.prototype.preRender.call(this),t.removeClass([this.inputElementCopy],[Ke])},n.prototype.getProperty=function(e,t){"min"===t?this.setProperties({min:this.validateValue(e.min)},!0):this.setProperties({max:this.validateValue(e.max)},!0)},n.prototype.checkAttributes=function(e){for(var i,s=0,a=e?t.isNullOrUndefined(this.htmlAttributes)?[]:Object.keys(this.htmlAttributes):["style","name","step","disabled","readonly","value","min","max","placeholder","type"];s<a.length;s++){var n=a[s];if(!t.isNullOrUndefined(this.inputElement.getAttribute(n)))switch(n){case"name":this.inputElement.setAttribute("name",this.inputElement.getAttribute(n));break;case"step":this.step=parseInt(this.inputElement.getAttribute(n),10);break;case"readonly":if(t.isNullOrUndefined(this.dateTimeOptions)||void 0===this.dateTimeOptions.readonly||e){var r="disabled"===this.inputElement.getAttribute(n)||""===this.inputElement.getAttribute(n)||"true"===this.inputElement.getAttribute(n);this.setProperties({readonly:r},!e)}break;case"placeholder":(t.isNullOrUndefined(this.dateTimeOptions)||void 0===this.dateTimeOptions.placeholder||e)&&this.setProperties({placeholder:this.inputElement.getAttribute(n)},!e);break;case"min":(t.isNullOrUndefined(this.dateTimeOptions)||void 0===this.dateTimeOptions.min||e)&&(i=new Date(this.inputElement.getAttribute(n)),this.isNullOrEmpty(i)||isNaN(+i)||this.setProperties({min:i},!e));break;case"disabled":if(t.isNullOrUndefined(this.dateTimeOptions)||void 0===this.dateTimeOptions.enabled||e){var l="disabled"!==this.inputElement.getAttribute(n)&&"true"!==this.inputElement.getAttribute(n)&&""!==this.inputElement.getAttribute(n);this.setProperties({enabled:l},!e)}break;case"value":(t.isNullOrUndefined(this.dateTimeOptions)||void 0===this.dateTimeOptions.value||e)&&(i=new Date(this.inputElement.getAttribute(n)),this.isNullOrEmpty(i)||isNaN(+i)||this.setProperties({value:i},!e));break;case"max":(t.isNullOrUndefined(this.dateTimeOptions)||void 0===this.dateTimeOptions.max||e)&&(i=new Date(this.inputElement.getAttribute(n)),this.isNullOrEmpty(i)||isNaN(+i)||this.setProperties({max:i},!e))}}},n.prototype.requiredModules=function(){var e=[];return this&&e.push({args:[this],member:"islamic"}),this.enableMask&&e.push(this.maskedDateModule()),e},n.prototype.maskedDateModule=function(){return{args:[this],member:"MaskedDateTime"}},n.prototype.getTimeActiveElement=function(){return t.isNullOrUndefined(this.dateTimeWrapper)?null:this.dateTimeWrapper.querySelectorAll("."+Xe)},n.prototype.createDateObj=function(e){return e instanceof Date?e:null},n.prototype.getDateObject=function(e){if(!this.isNullOrEmpty(e)){var i=this.createDateObj(e),s=this.valueWithMinutes,a=!t.isNullOrUndefined(s);if(this.checkDateValue(i)){var n=a?s.getDate():Fe,r=a?s.getMonth():Be,l=a?s.getFullYear():je,o=a?s.getHours():Ye,h=a?s.getMinutes():Re,u=a?s.getSeconds():ze,d=a?s.getMilliseconds():qe;return this.scrollInvoked?(this.scrollInvoked=!1,new Date(l,r,n,i.getHours(),i.getMinutes(),i.getSeconds(),i.getMilliseconds())):new Date(l,r,n,o,h,u,d)}}return null},n.prototype.findNextTimeElement=function(e){var i=this.inputElement.value,s=t.isNullOrUndefined(this.valueWithMinutes)?this.createDateObj(i):this.getDateObject(this.valueWithMinutes),a=null,n=this.liCollections.length;if(!t.isNullOrUndefined(this.activeIndex)||!t.isNullOrUndefined(this.checkDateValue(s))){if("home"===e.action)a=+this.createDateObj(new Date(this.timeCollections[0])),this.activeIndex=0;else if("end"===e.action)a=+this.createDateObj(new Date(this.timeCollections[this.timeCollections.length-1])),this.activeIndex=this.timeCollections.length-1;else if("down"===e.action){for(var r=0;r<n;r++)if(+s<this.timeCollections[r]){a=+this.createDateObj(new Date(this.timeCollections[r])),this.activeIndex=r;break}}else for(r=n-1;r>=0;r--)if(+s>this.timeCollections[r]){a=+this.createDateObj(new Date(this.timeCollections[r])),this.activeIndex=r;break}this.selectedElement=this.liCollections[this.activeIndex],this.timeElementValue(t.isNullOrUndefined(a)?null:new Date(a))}},n.prototype.setTimeValue=function(e,i){var a,n,r=this.validateMinMaxRange(i),l=this.createDateObj(r);return this.getFormattedValue(l)!==(t.isNullOrUndefined(this.value)?null:this.getFormattedValue(this.value))?(this.valueWithMinutes=t.isNullOrUndefined(l)?null:l,n=new Date(+this.valueWithMinutes)):(this.strictMode&&(e=l),this.valueWithMinutes=this.checkDateValue(e),n=new Date(+this.valueWithMinutes)),a="Gregorian"===this.calendarMode?this.globalize.formatDate(n,{format:t.isNullOrUndefined(this.formatString)?this.cldrDateTimeFormat():this.formatString,type:"dateTime",skeleton:"yMd"}):this.globalize.formatDate(n,{format:t.isNullOrUndefined(this.formatString)?this.cldrDateTimeFormat():this.formatString,type:"dateTime",skeleton:"yMd",calendar:"islamic"}),!this.strictMode&&t.isNullOrUndefined(n),s.Input.setValue(a,this.inputElement,this.floatLabelType,this.showClearButton),n},n.prototype.timeElementValue=function(e){if(!t.isNullOrUndefined(this.checkDateValue(e))&&!this.isNullOrEmpty(e)){var i=e instanceof Date?e:this.getDateObject(e);return this.setTimeValue(i,e)}return null},n.prototype.timeKeyHandler=function(e){if(!(t.isNullOrUndefined(this.step)||this.step<=0)){var i=this.timeCollections.length;if(t.isNullOrUndefined(this.getTimeActiveElement())||0===this.getTimeActiveElement().length)this.liCollections.length>0&&(t.isNullOrUndefined(this.value)&&t.isNullOrUndefined(this.activeIndex)?(this.activeIndex=0,this.selectedElement=this.liCollections[0],this.timeElementValue(new Date(this.timeCollections[0]))):this.findNextTimeElement(e));else{var s=void 0;if(e.keyCode>=37&&e.keyCode<=40){var a=40===e.keyCode||39===e.keyCode?++this.activeIndex:--this.activeIndex;this.activeIndex=a=this.activeIndex===i?0:this.activeIndex,this.activeIndex=a=this.activeIndex<0?i-1:this.activeIndex,s=t.isNullOrUndefined(this.timeCollections[a])?this.timeCollections[0]:this.timeCollections[a]}else"home"===e.action?(this.activeIndex=0,s=this.timeCollections[0]):"end"===e.action&&(this.activeIndex=i-1,s=this.timeCollections[i-1]);this.selectedElement=this.liCollections[this.activeIndex],this.timeElementValue(new Date(s))}this.isNavigate=!0,this.setTimeHover(this.selectedElement,"e-navigation"),this.setTimeActiveDescendant(),!this.isTimePopupOpen()||null===this.selectedElement||e&&"click"===e.type||this.setTimeScrollPosition()}},n.prototype.timeKeyActionHandle=function(e){if(this.enabled)switch("right"!==e.action&&"left"!==e.action&&"tab"!==e.action&&e.preventDefault(),e.action){case"up":case"down":case"home":case"end":this.timeKeyHandler(e);break;case"enter":this.isNavigate?(this.selectedElement=this.liCollections[this.activeIndex],this.valueWithMinutes=new Date(this.timeCollections[this.activeIndex]),this.setInputValue("time"),+this.previousDateTime!=+this.value&&(this.changedArgs.value=this.value,this.addTimeSelection(),this.previousDateTime=this.value)):this.updateValue(e),this.hide(e),t.addClass([this.inputWrapper.container],Ge),this.isNavigate=!1,e.stopPropagation();break;case"escape":this.hide(e);break;default:this.isNavigate=!1}},n.prototype.inputKeyAction=function(e){switch(e.action){case"altDownArrow":this.strictModeUpdate(),this.updateInput(),this.toggle(e)}},n.prototype.onPropertyChanged=function(e,i){for(var n=0,r=Object.keys(e);n<r.length;n++){var l=r[n];switch(l){case"value":this.isDynamicValueChanged=!0,this.invalidValueString=null,this.checkInvalidValue(e.value),e.value=this.value,e.value=this.validateValue(e.value),s.Input.setValue(this.getFormattedValue(e.value),this.inputElement,this.floatLabelType,this.showClearButton),this.valueWithMinutes=e.value,this.setProperties({value:e.value},!0),this.popupObj&&this.popupUpdate(),this.previousDateTime=new Date(this.inputElement.value),this.updateInput(),this.changeTrigger(null),this.preventChange=this.isAngular&&this.preventChange?!this.preventChange:this.preventChange,this.enableMask&&this.value&&this.notify("createMask",{module:"MaskedDateTime"});break;case"min":case"max":this.getProperty(e,l),this.updateInput();break;case"enableRtl":s.Input.setEnableRtl(this.enableRtl,[this.inputWrapper.container]);break;case"cssClass":t.isNullOrUndefined(i.cssClass)||(i.cssClass=i.cssClass.replace(/\s+/g," ").trim()),t.isNullOrUndefined(e.cssClass)||(e.cssClass=e.cssClass.replace(/\s+/g," ").trim()),s.Input.setCssClass(e.cssClass,[this.inputWrapper.container],i.cssClass),this.dateTimeWrapper&&s.Input.setCssClass(e.cssClass,[this.dateTimeWrapper],i.cssClass);break;case"locale":this.globalize=new t.Internationalization(this.locale),this.l10n.setLocale(this.locale),this.setProperties({placeholder:this.l10n.getConstant("placeholder")},!0),s.Input.setPlaceholder(this.l10n.getConstant("placeholder"),this.inputElement),this.dateTimeFormat=this.cldrDateTimeFormat(),a.prototype.updateInput.call(this);break;case"htmlAttributes":this.updateHtmlAttributeToElement(),this.updateHtmlAttributeToWrapper(),this.checkAttributes(!0);break;case"format":this.setProperties({format:e.format},!0),this.checkFormat(),this.dateTimeFormat=this.formatString,this.setValue(),this.enableMask&&(this.notify("createMask",{module:"MaskedDateTime"}),this.value||s.Input.setValue(this.maskedDateValue,this.inputElement,this.floatLabelType,this.showClearButton));break;case"placeholder":s.Input.setPlaceholder(e.placeholder,this.inputElement),this.inputElement.setAttribute("aria-placeholder",e.placeholder);break;case"enabled":s.Input.setEnabled(this.enabled,this.inputElement),this.enabled||(this.inputElement.tabIndex=-1);break;case"strictMode":this.invalidValueString=null,this.updateInput();break;case"width":this.setWidth(e.width);break;case"readonly":s.Input.setReadonly(this.readonly,this.inputElement);break;case"floatLabelType":this.floatLabelType=e.floatLabelType,s.Input.removeFloating(this.inputWrapper),s.Input.addFloating(this.inputElement,this.floatLabelType,this.placeholder);break;case"scrollTo":this.checkDateValue(new Date(this.checkValue(e.scrollTo)))?(this.dateTimeWrapper&&this.setScrollTo(),this.setProperties({scrollTo:this.checkDateValue(new Date(this.checkValue(e.scrollTo)))},!0)):this.setProperties({scrollTo:null},!0);break;case"enableMask":this.enableMask?(this.notify("createMask",{module:"MaskedDateTime"}),s.Input.setValue(this.maskedDateValue,this.inputElement,this.floatLabelType,this.showClearButton)):this.inputElement.value===this.maskedDateValue&&(this.maskedDateValue="",s.Input.setValue(this.maskedDateValue,this.inputElement,this.floatLabelType,this.showClearButton));break;default:a.prototype.onPropertyChanged.call(this,e,i)}this.isDynamicValueChanged||this.hide(null),this.isDynamicValueChanged=!1}},n.prototype.getModuleName=function(){return"datetimepicker"},n.prototype.restoreValue=function(){this.previousDateTime=this.previousDate,this.currentDate=this.value?this.value:new Date,this.valueWithMinutes=this.value,this.previousDate=this.value,this.previousElementValue=this.previousElementValue=t.isNullOrUndefined(this.inputValueCopy)?"":this.getFormattedValue(this.inputValueCopy)},Le([t.Property(null)],n.prototype,"timeFormat",void 0),Le([t.Property(30)],n.prototype,"step",void 0),Le([t.Property(null)],n.prototype,"scrollTo",void 0),Le([t.Property(1e3)],n.prototype,"zIndex",void 0),Le([t.Property(null)],n.prototype,"value",void 0),Le([t.Property(null)],n.prototype,"keyConfigs",void 0),Le([t.Property({})],n.prototype,"htmlAttributes",void 0),Le([t.Property(!1)],n.prototype,"enablePersistence",void 0),Le([t.Property(!0)],n.prototype,"allowEdit",void 0),Le([t.Property(!1)],n.prototype,"isMultiSelection",void 0),Le([t.Property(null)],n.prototype,"values",void 0),Le([t.Property(!0)],n.prototype,"showClearButton",void 0),Le([t.Property(null)],n.prototype,"placeholder",void 0),Le([t.Property(!1)],n.prototype,"strictMode",void 0),Le([t.Property(null)],n.prototype,"serverTimezoneOffset",void 0),Le([t.Property(new Date(1900,0,1))],n.prototype,"min",void 0),Le([t.Property(new Date(2099,11,31))],n.prototype,"max",void 0),Le([t.Property(null)],n.prototype,"firstDayOfWeek",void 0),Le([t.Property("Gregorian")],n.prototype,"calendarMode",void 0),Le([t.Property("Month")],n.prototype,"start",void 0),Le([t.Property("Month")],n.prototype,"depth",void 0),Le([t.Property(!1)],n.prototype,"weekNumber",void 0),Le([t.Property(!0)],n.prototype,"showTodayButton",void 0),Le([t.Property("Short")],n.prototype,"dayHeaderFormat",void 0),Le([t.Property(!1)],n.prototype,"openOnFocus",void 0),Le([t.Property(!1)],n.prototype,"enableMask",void 0),Le([t.Property({day:"day",month:"month",year:"year",hour:"hour",minute:"minute",second:"second",dayOfTheWeek:"day of the week"})],n.prototype,"maskPlaceholder",void 0),Le([t.Event()],n.prototype,"open",void 0),Le([t.Event()],n.prototype,"close",void 0),Le([t.Event()],n.prototype,"cleared",void 0),Le([t.Event()],n.prototype,"blur",void 0),Le([t.Event()],n.prototype,"focus",void 0),Le([t.Event()],n.prototype,"created",void 0),Le([t.Event()],n.prototype,"destroyed",void 0),n=Le([t.NotifyPropertyChanges],n)}(F),Qe="shiftTab",et=function(){function e(e){this.mask="",this.defaultConstant={day:"day",month:"month",year:"year",hour:"hour",minute:"minute",second:"second",dayOfTheWeek:"day of the week"},this.hiddenMask="",this.validCharacters="dMyhmHfasz",this.isDayPart=!1,this.isMonthPart=!1,this.isYearPart=!1,this.isHourPart=!1,this.isMinutePart=!1,this.isSecondsPart=!1,this.isMilliSecondsPart=!1,this.monthCharacter="",this.periodCharacter="",this.isHiddenMask=!1,this.isComplete=!1,this.isNavigate=!1,this.formatRegex=/EEEEE|EEEE|EEE|EE|E|dddd|ddd|dd|d|MMMM|MMM|MM|M|yyyy|yy|y|HH|H|hh|h|mm|m|fff|ff|f|aa|a|ss|s|zzzz|zzz|zz|z|'[^']*'|'[^']*'/g,this.isDeletion=!1,this.isShortYear=!1,this.isDeleteKey=!1,this.isDateZero=!1,this.isMonthZero=!1,this.isYearZero=!1,this.dayTypeCount=0,this.monthTypeCount=0,this.hourTypeCount=0,this.minuteTypeCount=0,this.secondTypeCount=0,this.parent=e,this.dateformat=this.getCulturedFormat(),this.maskDateValue=null!=this.parent.value?new Date(+this.parent.value):new Date,this.maskDateValue.setMonth(0),this.maskDateValue.setHours(0),this.maskDateValue.setMinutes(0),this.maskDateValue.setSeconds(0),this.previousDate=new Date(this.maskDateValue.getFullYear(),this.maskDateValue.getMonth(),this.maskDateValue.getDate(),this.maskDateValue.getHours(),this.maskDateValue.getMinutes(),this.maskDateValue.getSeconds()),this.removeEventListener(),this.addEventListener()}return e.prototype.getModuleName=function(){return"MaskedDateTime"},e.prototype.addEventListener=function(){this.parent.isDestroyed||(this.parent.on("createMask",this.createMask,this),this.parent.on("setMaskSelection",this.validCharacterCheck,this),this.parent.on("inputHandler",this.maskInputHandler,this),this.parent.on("keyDownHandler",this.maskKeydownHandler,this),this.parent.on("clearHandler",this.clearHandler,this))},e.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off("createMask",this.createMask),this.parent.off("setMaskSelection",this.validCharacterCheck),this.parent.off("inputHandler",this.maskInputHandler),this.parent.off("keyDownHandler",this.maskKeydownHandler),this.parent.off("clearHandler",this.clearHandler))},e.prototype.createMask=function(e){this.isDayPart=this.isMonthPart=this.isYearPart=this.isHourPart=this.isMinutePart=this.isSecondsPart=!1,this.dateformat=this.getCulturedFormat(),this.parent.maskPlaceholder.day&&(this.defaultConstant.day=this.parent.maskPlaceholder.day),this.parent.maskPlaceholder.month&&(this.defaultConstant.month=this.parent.maskPlaceholder.month),this.parent.maskPlaceholder.year&&(this.defaultConstant.year=this.parent.maskPlaceholder.year),this.parent.maskPlaceholder.hour&&(this.defaultConstant.hour=this.parent.maskPlaceholder.hour),this.parent.maskPlaceholder.minute&&(this.defaultConstant.minute=this.parent.maskPlaceholder.minute),this.parent.maskPlaceholder.second&&(this.defaultConstant.second=this.parent.maskPlaceholder.second),this.parent.maskPlaceholder.dayOfTheWeek&&(this.defaultConstant.dayOfTheWeek=this.parent.maskPlaceholder.dayOfTheWeek.toString()),this.getCUltureMaskFormat();var t=this.dateformat.replace(this.formatRegex,this.formatCheck());this.isHiddenMask=!0,this.hiddenMask=this.dateformat.replace(this.formatRegex,this.formatCheck()),this.isHiddenMask=!1,this.previousHiddenMask=this.hiddenMask,this.mask=this.previousValue=t,this.parent.maskedDateValue=this.mask,this.parent.value&&this.setDynamicValue()},e.prototype.getCUltureMaskFormat=function(){this.l10n=new t.L10n(this.parent.moduleName,this.defaultConstant,this.parent.locale),this.objectString=Object.keys(this.defaultConstant);for(var e=0;e<this.objectString.length;e++)this.defaultConstant[this.objectString[e].toString()]=this.l10n.getConstant(this.objectString[e].toString())},e.prototype.validCharacterCheck=function(){for(var e=this.parent.inputElement.selectionStart,t=e,i=e-1;t<this.hiddenMask.length||i>=0;t++,i--){if(t<this.hiddenMask.length&&-1!==this.validCharacters.indexOf(this.hiddenMask[t]))return void this.setSelection(this.hiddenMask[t]);if(i>=0&&-1!==this.validCharacters.indexOf(this.hiddenMask[i]))return void this.setSelection(this.hiddenMask[i])}},e.prototype.setDynamicValue=function(){this.maskDateValue=this.parent.value,this.isDayPart=this.isMonthPart=this.isYearPart=this.isHourPart=this.isMinutePart=this.isSecondsPart=!0,this.updateValue()},e.prototype.setSelection=function(e){for(var t=-1,i=0,s=0;s<this.hiddenMask.length;s++)this.hiddenMask[s]===e&&(i=s+1,-1===t&&(t=s));t<0&&(t=0),this.parent.inputElement.setSelectionRange(t,i)},e.prototype.maskKeydownHandler=function(e){if("Delete"!==e.e.key){if(!(e.e.altKey||e.e.ctrlKey||"ArrowLeft"!==e.e.key&&"ArrowRight"!==e.e.key&&e.e.key!==Qe&&"Tab"!==e.e.key&&e.e.action!==Qe&&"End"!==e.e.key&&"Home"!==e.e.key)){var t=this.parent.inputElement.selectionStart,i=this.parent.inputElement.selectionEnd,s=this.parent.inputElement.value.length;if(0==t&&i==s&&("Tab"===e.e.key||e.e.action===Qe)){var a=e.e.action===Qe?i:0;this.parent.inputElement.selectionStart=this.parent.inputElement.selectionEnd=a}if("End"===e.e.key||"Home"===e.e.key){var n="End"===e.e.key?s:0;this.parent.inputElement.selectionStart=this.parent.inputElement.selectionEnd=n}this.navigateSelection("ArrowLeft"===e.e.key||e.e.action===Qe||"End"===e.e.key)}if(!(e.e.altKey||e.e.ctrlKey||"ArrowUp"!==e.e.key&&"ArrowDown"!==e.e.key)){t=this.parent.inputElement.selectionStart;this.dateAlteration("ArrowDown"===e.e.key);var r=this.dateformat.replace(this.formatRegex,this.formatCheck());this.isHiddenMask=!0,this.hiddenMask=this.dateformat.replace(this.formatRegex,this.formatCheck()),this.isHiddenMask=!1,this.previousHiddenMask=this.hiddenMask,this.previousValue=r,this.parent.inputElement.value=r,this.parent.inputElement.selectionStart=t,this.validCharacterCheck()}}else this.isDeleteKey=!0},e.prototype.differenceCheck=function(){var e=this.parent.inputElement.selectionStart,t=this.parent.inputElement.value,i=this.previousValue.substring(0,e+this.previousValue.length-t.length),s=t.substring(0,e),a=new Date(+this.maskDateValue),n=new Date(a.getFullYear(),a.getMonth()+1,0).getDate();if(0===i.indexOf(s)&&(0===s.length||this.previousHiddenMask[s.length-1]!==this.previousHiddenMask[s.length])){for(var r=s.length;r<i.length;r++)""!==this.previousHiddenMask[r]&&this.validCharacters.indexOf(this.previousHiddenMask[r])>=0&&(this.isDeletion=this.handleDeletion(this.previousHiddenMask[r],!1));if(this.isDeletion)return}switch(this.previousHiddenMask[e-1]){case"d":var l=(this.isDayPart&&a.getDate().toString().length<2?10*a.getDate():0)+parseInt(s[e-1],10);if(this.isDateZero="0"==s[e-1],isNaN(l))return;for(r=0;l>n;r++)l=parseInt(l.toString().slice(1),10);if(l>=1){if(a.setDate(l),this.isNavigate=2===l.toString().length,this.previousDate=new Date(a.getFullYear(),a.getMonth(),a.getDate()),a.getMonth()!==this.maskDateValue.getMonth())return;this.isDayPart=!0,this.dayTypeCount=this.dayTypeCount+1}else this.isDayPart=!1,this.dayTypeCount=this.isDateZero?this.dayTypeCount+1:this.dayTypeCount;break;case"M":var o=void 0;if(o=a.getMonth().toString().length<2?(this.isMonthPart?10*(a.getMonth()+1):0)+parseInt(s[e-1],10):parseInt(s[e-1],10),this.isMonthZero="0"==s[e-1],isNaN(o)){var h=this.getCulturedValue("months[stand-alone].wide"),u=Object.keys(h);for(this.monthCharacter+=s[e-1].toLowerCase();this.monthCharacter.length>0;){r=1;for(var d=0,p=u;d<p.length;d++){p[d];if(0===h[r].toLowerCase().indexOf(this.monthCharacter))return a.setMonth(r-1),this.isMonthPart=!0,void(this.maskDateValue=a);r++}this.monthCharacter=this.monthCharacter.substring(1,this.monthCharacter.length)}}else{for(;o>12;)o=parseInt(o.toString().slice(1),10);if(o>=1){if(a.setMonth(o-1),this.isNavigate=2===o.toString().length,a.getMonth()!==o-1&&(a.setDate(1),a.setMonth(o-1)),this.isDayPart){var c=new Date(this.previousDate.getFullYear(),this.previousDate.getMonth()+1,0).getDate(),m=new Date(a.getFullYear(),a.getMonth()+1,0).getDate();this.previousDate.getDate()==c&&m<=c&&a.setDate(m)}this.previousDate=new Date(a.getFullYear(),a.getMonth(),a.getDate()),this.isMonthPart=!0,this.monthTypeCount=this.monthTypeCount+1}else a.setMonth(0),this.isMonthPart=!1,this.monthTypeCount=this.isMonthZero?this.monthTypeCount+1:this.monthTypeCount}break;case"y":var v=(this.isYearPart&&a.getFullYear().toString().length<4&&!this.isShortYear?10*a.getFullYear():0)+parseInt(s[e-1],10);if(this.isShortYear=!1,this.isYearZero="0"==s[e-1],isNaN(v))return;for(;v>9999;)v=parseInt(v.toString().slice(1),10);v<1?this.isYearPart=!1:(a.setFullYear(v),4===v.toString().length&&(this.isNavigate=!0),this.previousDate=new Date(a.getFullYear(),a.getMonth(),a.getDate()),this.isYearPart=!0);break;case"h":if(this.hour=(this.isHourPart&&(a.getHours()%12||12).toString().length<2?10*(a.getHours()%12||12):0)+parseInt(s[e-1],10),isNaN(this.hour))return;for(;this.hour>12;)this.hour=parseInt(this.hour.toString().slice(1),10);a.setHours(12*Math.floor(a.getHours()/12)+this.hour%12),this.isNavigate=2===this.hour.toString().length,this.isHourPart=!0,this.hourTypeCount=this.hourTypeCount+1;break;case"H":if(this.hour=(this.isHourPart&&a.getHours().toString().length<2?10*a.getHours():0)+parseInt(s[e-1],10),isNaN(this.hour))return;for(r=0;this.hour>23;r++)this.hour=parseInt(this.hour.toString().slice(1),10);a.setHours(this.hour),this.isNavigate=2===this.hour.toString().length,this.isHourPart=!0,this.hourTypeCount=this.hourTypeCount+1;break;case"m":var f=(this.isMinutePart&&a.getMinutes().toString().length<2?10*a.getMinutes():0)+parseInt(s[e-1],10);if(isNaN(f))return;for(r=0;f>59;r++)f=parseInt(f.toString().slice(1),10);a.setMinutes(f),this.isNavigate=2===f.toString().length,this.isMinutePart=!0,this.minuteTypeCount=this.minuteTypeCount+1;break;case"s":var y=(this.isSecondsPart&&a.getSeconds().toString().length<2?10*a.getSeconds():0)+parseInt(s[e-1],10);if(isNaN(y))return;for(r=0;y>59;r++)y=parseInt(y.toString().slice(1),10);a.setSeconds(y),this.isNavigate=2===y.toString().length,this.isSecondsPart=!0,this.secondTypeCount=this.secondTypeCount+1;break;case"a":this.periodCharacter+=s[e-1].toLowerCase();var g=this.getCulturedValue("dayPeriods.format.wide"),b=Object.keys(g);for(r=0;this.periodCharacter.length>0;r++)(0===g[b[0]].toLowerCase().indexOf(this.periodCharacter)&&a.getHours()>=12||0===g[b[1]].toLowerCase().indexOf(this.periodCharacter)&&a.getHours()<12)&&(a.setHours((a.getHours()+12)%24),this.maskDateValue=a),this.periodCharacter=this.periodCharacter.substring(1,this.periodCharacter.length)}this.maskDateValue=a},e.prototype.formatCheck=function(){var e=this;return function(t){var i,s,a,n=e.getCulturedValue("days[stand-alone].abbreviated"),r=Object.keys(n),l=e.getCulturedValue("days[stand-alone].wide"),o=Object.keys(l),h=e.getCulturedValue("days[stand-alone].narrow"),u=Object.keys(h),d=e.getCulturedValue("months[stand-alone].abbreviated"),p=e.getCulturedValue("months[stand-alone].wide"),c=e.getCulturedValue("dayPeriods.format.wide"),m=Object.keys(c);switch(t){case"ddd":case"dddd":case"d":i=e.isDayPart?e.maskDateValue.getDate().toString():e.defaultConstant.day.toString(),i=e.zeroCheck(e.isDateZero,e.isDayPart,i);break;case"dd":i=e.isDayPart?e.roundOff(e.maskDateValue.getDate(),2):e.defaultConstant.day.toString(),i=e.zeroCheck(e.isDateZero,e.isDayPart,i),2==e.dayTypeCount&&(e.isNavigate=!0,e.dayTypeCount=0);break;case"E":case"EE":case"EEE":i=e.isDayPart&&e.isMonthPart&&e.isYearPart?n[r[e.maskDateValue.getDay()]].toString():e.defaultConstant.dayOfTheWeek.toString();break;case"EEEE":i=e.isDayPart&&e.isMonthPart&&e.isYearPart?l[o[e.maskDateValue.getDay()]].toString():e.defaultConstant.dayOfTheWeek.toString();break;case"EEEEE":i=e.isDayPart&&e.isMonthPart&&e.isYearPart?h[u[e.maskDateValue.getDay()]].toString():e.defaultConstant.dayOfTheWeek.toString();break;case"M":i=e.isMonthPart?(e.maskDateValue.getMonth()+1).toString():e.defaultConstant.month.toString(),i=e.zeroCheck(e.isMonthZero,e.isMonthPart,i);break;case"MM":i=e.isMonthPart?e.roundOff(e.maskDateValue.getMonth()+1,2):e.defaultConstant.month.toString(),i=e.zeroCheck(e.isMonthZero,e.isMonthPart,i),2==e.monthTypeCount&&(e.isNavigate=!0,e.monthTypeCount=0);break;case"MMM":i=e.isMonthPart?d[e.maskDateValue.getMonth()+1]:e.defaultConstant.month.toString();break;case"MMMM":i=e.isMonthPart?p[e.maskDateValue.getMonth()+1]:e.defaultConstant.month.toString();break;case"yy":i=e.isYearPart?e.roundOff(e.maskDateValue.getFullYear()%100,2):e.defaultConstant.year.toString(),i=e.zeroCheck(e.isYearZero,e.isYearPart,i),e.isYearPart&&(e.isNavigate=e.isShortYear=2===(e.maskDateValue.getFullYear()%100).toString().length);break;case"y":case"yyyy":i=e.isYearPart?e.roundOff(e.maskDateValue.getFullYear(),4):e.defaultConstant.year.toString(),i=e.zeroCheck(e.isYearZero,e.isYearPart,i);break;case"h":i=e.isHourPart?(e.maskDateValue.getHours()%12||12).toString():e.defaultConstant.hour.toString();break;case"hh":i=e.isHourPart?e.roundOff(e.maskDateValue.getHours()%12||12,2):e.defaultConstant.hour.toString(),2==e.hourTypeCount&&(e.isNavigate=!0,e.hourTypeCount=0);break;case"H":i=e.isHourPart?e.maskDateValue.getHours().toString():e.defaultConstant.hour.toString();break;case"HH":i=e.isHourPart?e.roundOff(e.maskDateValue.getHours(),2):e.defaultConstant.hour.toString(),2==e.hourTypeCount&&(e.isNavigate=!0,e.hourTypeCount=0);break;case"m":i=e.isMinutePart?e.maskDateValue.getMinutes().toString():e.defaultConstant.minute.toString();break;case"mm":i=e.isMinutePart?e.roundOff(e.maskDateValue.getMinutes(),2):e.defaultConstant.minute.toString(),2==e.minuteTypeCount&&(e.isNavigate=!0,e.minuteTypeCount=0);break;case"s":i=e.isSecondsPart?e.maskDateValue.getSeconds().toString():e.defaultConstant.second.toString();break;case"ss":i=e.isSecondsPart?e.roundOff(e.maskDateValue.getSeconds(),2):e.defaultConstant.second.toString(),2==e.secondTypeCount&&(e.isNavigate=!0,e.secondTypeCount=0);break;case"f":i=Math.floor(e.maskDateValue.getMilliseconds()/100).toString();break;case"ff":s=e.maskDateValue.getMilliseconds(),e.maskDateValue.getMilliseconds()>99&&(s=Math.floor(e.maskDateValue.getMilliseconds()/10)),i=e.roundOff(s,2);break;case"fff":i=e.roundOff(e.maskDateValue.getMilliseconds(),3);break;case"a":case"aa":i=e.maskDateValue.getHours()<12?c[m[0]]:c[m[1]];break;case"z":case"zz":case"zzz":case"zzzz":a={format:t,type:"dateTime",skeleton:"yMd",calendar:e.parent.calendarMode},i=e.parent.globalize.formatDate(e.maskDateValue,a)}if(i=void 0!==i?i:t.slice(1,t.length-1),e.isHiddenMask){for(var v="",f=0;f<i.length;f++)v+=t[0];return v}return i}},e.prototype.maskInputHandler=function(){var e,t=this.parent.inputElement.selectionStart;this.previousHiddenMask[t-1];if(this.differenceCheck(),e=this.dateformat.replace(this.formatRegex,this.formatCheck()),this.isHiddenMask=!0,this.hiddenMask=this.dateformat.replace(this.formatRegex,this.formatCheck()),this.isDateZero=this.isMonthZero=this.isYearZero=!1,this.isHiddenMask=!1,this.previousHiddenMask=this.hiddenMask,this.previousValue=e,this.parent.inputElement.value=e,this.parent.inputElement.selectionStart=t,this.validCharacterCheck(),(this.isNavigate||this.isDeletion)&&!this.isDeleteKey){var i=!this.isNavigate;this.isNavigate=this.isDeletion=!1,this.navigateSelection(i)}this.isDeleteKey=!1},e.prototype.navigateSelection=function(e){for(var t=this.parent.inputElement.selectionStart,i=this.parent.inputElement.selectionEnd,s=e?t-1:i+1;s<this.hiddenMask.length&&s>=0;){if(this.validCharacters.indexOf(this.hiddenMask[s])>=0){this.setSelection(this.hiddenMask[s]);break}s+=e?-1:1}},e.prototype.roundOff=function(e,t){for(var i=e.toString(),s=t-i.length,a="",n=0;n<s;n++)a+="0";return a+i},e.prototype.zeroCheck=function(e,t,i){var s=i;return e&&!t&&(s="0"),s},e.prototype.handleDeletion=function(e,t){switch(e){case"d":this.isDayPart=t;break;case"M":this.isMonthPart=t,t||(this.maskDateValue.setMonth(0),this.monthCharacter="");break;case"y":this.isYearPart=t;break;case"H":case"h":this.isHourPart=t,t||(this.periodCharacter="");break;case"m":this.isMinutePart=t;break;case"s":this.isSecondsPart=t;break;default:return!1}return!0},e.prototype.dateAlteration=function(e){var t=this.parent.inputElement.selectionStart,i="";if(-1!==this.validCharacters.indexOf(this.hiddenMask[t])){i=this.hiddenMask[t];var s=new Date(this.maskDateValue.getFullYear(),this.maskDateValue.getMonth(),this.maskDateValue.getDate(),this.maskDateValue.getHours(),this.maskDateValue.getMinutes(),this.maskDateValue.getSeconds());this.previousDate=new Date(this.maskDateValue.getFullYear(),this.maskDateValue.getMonth(),this.maskDateValue.getDate(),this.maskDateValue.getHours(),this.maskDateValue.getMinutes(),this.maskDateValue.getSeconds());var a=e?-1:1;switch(i){case"d":s.setDate(s.getDate()+a);break;case"M":var n=s.getMonth()+a;if(s.setDate(1),s.setMonth(n),this.isDayPart){var r=new Date(this.previousDate.getFullYear(),this.previousDate.getMonth()+1,0).getDate(),l=new Date(s.getFullYear(),s.getMonth()+1,0).getDate();this.previousDate.getDate()==r&&l<=r?s.setDate(l):s.setDate(this.previousDate.getDate())}else s.setDate(this.previousDate.getDate());this.previousDate=new Date(s.getFullYear(),s.getMonth(),s.getDate());break;case"y":s.setFullYear(s.getFullYear()+a);break;case"H":case"h":s.setHours(s.getHours()+a);break;case"m":s.setMinutes(s.getMinutes()+a);break;case"s":s.setSeconds(s.getSeconds()+a);break;case"a":s.setHours((s.getHours()+12)%24)}this.maskDateValue=s.getFullYear()>0?s:this.maskDateValue,-1!==this.validCharacters.indexOf(this.hiddenMask[t])&&this.handleDeletion(this.hiddenMask[t],!0)}},e.prototype.getCulturedValue=function(e){var i=this.parent.locale;return"en"===i||"en-US"===i?t.getValue(e,t.getDefaultDateObject()):t.getValue("main."+i+".dates.calendars.gregorian."+e,t.cldrData)},e.prototype.getCulturedFormat=function(){var e=this.getCulturedValue("dateTimeFormats[availableFormats].yMd").toString();return"datepicker"==this.parent.moduleName&&(e=this.getCulturedValue("dateTimeFormats[availableFormats].yMd").toString(),this.parent.format&&this.parent.formatString&&(e=this.parent.formatString)),"datetimepicker"==this.parent.moduleName&&(e=this.getCulturedValue("dateTimeFormats[availableFormats].yMd").toString(),this.parent.dateTimeFormat&&(e=this.parent.dateTimeFormat)),"timepicker"==this.parent.moduleName&&(e=this.parent.cldrTimeFormat()),e},e.prototype.clearHandler=function(){this.isDayPart=this.isMonthPart=this.isYearPart=this.isHourPart=this.isMinutePart=this.isSecondsPart=!1,this.updateValue()},e.prototype.updateValue=function(){this.monthCharacter=this.periodCharacter="";var e=this.dateformat.replace(this.formatRegex,this.formatCheck());this.isHiddenMask=!0,this.hiddenMask=this.dateformat.replace(this.formatRegex,this.formatCheck()),this.isHiddenMask=!1,this.previousHiddenMask=this.hiddenMask,this.previousValue=e,this.parent.updateInputValue(e)},e.prototype.destroy=function(){this.removeEventListener()},e}();e.CalendarBase=E,e.Calendar=C,e.Islamic=N,e.DatePicker=F,e.Presets=De,e.DateRangePicker=Ee,e.TimeMaskPlaceholder=Ue,e.TimePicker=He,e.DateTimePicker=$e,e.MaskedDateTime=et,Object.defineProperty(e,"__esModule",{value:!0})});
	//# sourceMappingURL=ej2-calendars.umd.min.js.map


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	*  filename: ej2-dropdowns.umd.min.js
	*  version : 19.4.56
	*  Copyright Syncfusion Inc. 2001 - 2020. All rights reserved.
	*  Use of this code is subject to the terms of our license.
	*  A copy of the current license can be obtained at any time by e-mailing
	*  licensing@syncfusion.com. Any infringement will be prosecuted under
	*  applicable laws. 
	*/
	!function(e,t){ true?t(exports,__webpack_require__(23),__webpack_require__(76),__webpack_require__(101),__webpack_require__(46),__webpack_require__(59),__webpack_require__(42),__webpack_require__(102)):"function"==typeof define&&define.amd?define(["exports","@syncfusion/ej2-base","@syncfusion/ej2-data","@syncfusion/ej2-lists","@syncfusion/ej2-popups","@syncfusion/ej2-inputs","@syncfusion/ej2-buttons","@syncfusion/ej2-navigations"],t):t(e.ej={},e.ej2Base,e.ej2Data,e.ej2Lists,e.ej2Popups,e.ej2Inputs,e.ej2Buttons,e.ej2Navigations)}(this,function(e,t,i,s,l,n,o,r){"use strict";function a(e,t,i,s,l){E+=String.fromCharCode(e),setTimeout(function(){E=""},1e3);var n;if(E=s?E.toLowerCase():E,O===l&&S===E){for(var o=0;o<x.length;o++)if(x[o].classList.contains(w)){n=o;break}return n+=1,x[n]?x[n]:x[0]}var r=t,a=E.length,h=void 0;o=i=i?i+1:0;x=[];do{o===r.length&&(o=-1),h=r[n=-1===o?0:o],(s?h.innerText.toLowerCase():h.innerText).substr(0,a)===E&&x.push(r[n]),o++}while(o!==i);return S=E,O=l,x[0]}function h(e,t,i,s){var l=t;s=void 0===s||null===s||s;var n={item:null,index:null};if(e&&e.length){for(var o=e.length,r=s?e.toLocaleLowerCase():e,a=0,h=l;a<h.length;a++){var p=h[a],u=(s?p.textContent.toLocaleLowerCase():p.textContent).replace(/^\s+|\s+$/g,"");if("Equal"===i&&u===r||"StartsWith"===i&&u.substr(0,o)===r||"EndsWith"===i&&u.substr(u.length-r.length)===r||"Contains"===i&&new RegExp(r,"g").test(u))return n.item=p,n.index=a,{item:p,index:a}}return n}return n}function p(e){O===e&&(O="",S="",E="",x=[])}function u(e,t,i,s){if(""!==t){var l=i?"gim":"gm";t=/^[a-zA-Z0-9- ]*$/.test(t)?t:t.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,"\\$&");var n="StartsWith"===s?"^("+t+")":"EndsWith"===s?"("+t+")$":"("+t+")";c(e,new RegExp(n,l))}}function c(e,t){for(var i=0;e.childNodes&&i<e.childNodes.length;i++){if(3===e.childNodes[i].nodeType&&""!==e.childNodes[i].textContent.trim()){var s=e.childNodes[i].nodeValue.trim().replace(t,'<span class="e-highlight">$1</span>');e.childNodes[i].nodeValue="",e.innerHTML=e.innerHTML.trim()+s;break}c(e.childNodes[i],t)}}function d(e){for(var t=e.querySelectorAll(".e-highlight"),i=t.length-1;i>=0;i--){var s=t[i].parentNode,l=document.createTextNode(t[i].textContent);s.replaceChild(l,t[i])}}function m(e,i,s,l,n,o,r){var a=t.createElement("span",{className:de}),h=t.createElement("label",{className:me});t.isNullOrUndefined(s.id)||""===s.id||(h.id="label_"+s.id.replace(/ /g,"_"),t.attributes(s,{"aria-labelledby":h.id})),t.isNullOrUndefined(l.placeholder)||""===l.placeholder||(h.innerText=b(l.placeholder),l.removeAttribute("placeholder")),h.innerText=b(r),i.appendChild(a),i.appendChild(h),e.classList.add("e-float-input"),f(n,h),"Always"===o&&(h.classList.contains(ve)&&t.removeClass([h],ve),t.addClass([h],fe))}function f(e,i){e&&e.length>0?(t.addClass([i],fe),t.removeClass([i],ve)):(t.removeClass([i],fe),t.addClass([i],ve))}function v(e,i,s,l,n,o,r){var a,h=i.querySelector("."+me),p=i.querySelector("."+de);t.isNullOrUndefined(h)?y(n,l,a=null!==r?r:""):(a=h.innerText,t.detach(s.querySelector("."+me)),y(n,l,a),t.isNullOrUndefined(p)||t.detach(s.querySelector("."+de))),e.classList.remove("e-float-input")}function y(e,t,i){e&&e.length?t.placeholder="":t.placeholder=i}function g(e,i){e.classList.add("e-input-focus");var s=i.querySelector("."+me);t.isNullOrUndefined(s)||(t.addClass([s],fe),s.classList.contains(ve)&&t.removeClass([s],ve))}function C(e,i,s,l,n){e.classList.remove("e-input-focus");var o=i.querySelector("."+me);s&&s.length<=0&&"Auto"===l&&!t.isNullOrUndefined(o)&&(o.classList.contains(fe)&&t.removeClass([o],fe),t.addClass([o],ve))}function b(e){var i="";if(!t.isNullOrUndefined(e)&&""!==e){var s=document.createElement("span");s.innerHTML='<input  placeholder="'+e+'"/>';i=s.children[0].placeholder}return i}var E="",S="",x=[],w="e-active",O="",k=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),A=function(e,t,i,s){var l,n=arguments.length,o=n<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)o=Reflect.decorate(e,t,i,s);else for(var r=e.length-1;r>=0;r--)(l=e[r])&&(o=(n<3?l(o):n>3?l(t,i,o):l(t,i))||o);return n>3&&o&&Object.defineProperty(t,i,o),o},D=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return k(i,e),A([t.Property()],i.prototype,"text",void 0),A([t.Property()],i.prototype,"value",void 0),A([t.Property()],i.prototype,"iconCss",void 0),A([t.Property()],i.prototype,"groupBy",void 0),A([t.Property()],i.prototype,"htmlAttributes",void 0),i}(t.ChildProperty),I={root:"e-dropdownbase",rtl:"e-rtl",content:"e-content",selected:"e-active",hover:"e-hover",noData:"e-nodata",fixedHead:"e-fixed-head",focus:"e-item-focus",li:"e-list-item",group:"e-list-group-item",disabled:"e-disabled",grouping:"e-dd-group"},L=function(e){function l(t,i){var s=e.call(this,t,i)||this;return s.preventChange=!1,s.isAngular=!1,s.isPreventChange=!1,s.isDynamicDataChange=!1,s}return k(l,e),l.prototype.getPropObject=function(e,t,i){var s=new Object,l=new Object,n=function(e){return e};s[n(e)]=t[n(e)],l[n(e)]=i[n(e)];var o=new Object;return o.newProperty=s,o.oldProperty=l,o},l.prototype.getValueByText=function(e,i,s){var l=null;return t.isNullOrUndefined(this.listData)||(l=i?this.checkValueCase(e,!0,s):this.checkValueCase(e,!1,s)),l},l.prototype.checkValueCase=function(e,i,s,l){var n=this,o=null;l&&(o=e);var r=this.listData,a=this.fields,h=this.typeOfData(r).typeof;if("string"===h||"number"===h||"boolean"===h)for(var p=0,u=r;p<u.length;p++){var c=u[p];t.isNullOrUndefined(c)||(s?o=this.checkingAccent(String(c),e,i):i?this.checkIgnoreCase(String(c),e)&&(o=this.getItemValue(String(c),e,i)):this.checkNonIgnoreCase(String(c),e)&&(o=this.getItemValue(String(c),e,i,l)))}else if(i)r.filter(function(i){var s=t.getValue(a.value,i);!t.isNullOrUndefined(s)&&n.checkIgnoreCase(t.getValue(a.text,i).toString(),e)&&(o=t.getValue(a.value,i))});else if(l){var d=null;d=o,r.filter(function(e){var i=t.getValue(a.value,e);t.isNullOrUndefined(i)||t.isNullOrUndefined(o)||i.toString()!==d.toString()||(o=t.getValue(a.text,e))})}else r.filter(function(i){n.checkNonIgnoreCase(t.getValue(a.text,i),e)&&(o=t.getValue(a.value,i))});return o},l.prototype.checkingAccent=function(e,t,s){var l=i.DataUtil.ignoreDiacritics(String(e)),n=i.DataUtil.ignoreDiacritics(t.toString()),o=null;return s?this.checkIgnoreCase(l,n)&&(o=this.getItemValue(String(e),t,s)):this.checkNonIgnoreCase(String(e),t)&&(o=this.getItemValue(String(e),t,s)),o},l.prototype.checkIgnoreCase=function(e,t){return String(e).toLowerCase()===t.toString().toLowerCase()},l.prototype.checkNonIgnoreCase=function(e,t){return String(e)===t.toString()},l.prototype.getItemValue=function(e,t,i,s){var l=this.listData,n=this.typeOfData(l).typeof;return s?e.toString():i?"string"===n?String(e):this.getFormattedValue(String(e)):"string"===n?t:this.getFormattedValue(t)},l.prototype.templateCompiler=function(e){var i=!1;if(e)try{i=!!t.selectAll(e,document).length}catch(e){i=!1}return i},l.prototype.l10nUpdate=function(e){var i="listbox"===this.getModuleName()?this.ulElement:this.list;if("No records found"!==this.noRecordsTemplate||"Request failed"!==this.actionFailureTemplate){var s=e?this.actionFailureTemplate:this.noRecordsTemplate,l=e?this.actionFailureTemplateId:this.noRecordsTemplateId;i.innerHTML="";var n=(this.templateCompiler(s)?t.compile(t.select(s,document).innerHTML.trim()):t.compile(s))({},this,e?"actionFailureTemplate":"noRecordsTemplate",l,this.isStringTemplate,null,i);if(n&&n.length>0)for(var o=0;o<n.length;o++)i.appendChild(n[o]);this.renderReactTemplates()}else{var r=new t.L10n(this.getLocaleName(),{},this.locale);""!==r.getConstant("actionFailureTemplate")?this.l10n=r:this.l10n=new t.L10n("listbox"===this.getModuleName()?"listbox":"dropdowns",{noRecordsTemplate:"No records found",actionFailureTemplate:"Request failed"},this.locale);var a=e?this.l10n.getConstant("actionFailureTemplate"):this.l10n.getConstant("noRecordsTemplate");if("listbox"===this.getModuleName()){var h=this.createElement("li");h.textContent=a,i.appendChild(h),h.classList.add("e-list-nrt")}else i.innerHTML=a}},l.prototype.getLocaleName=function(){return"drop-down-base"},l.prototype.getTextByValue=function(e){return this.checkValueCase(e,!1,!1,!0)},l.prototype.getFormattedValue=function(e){if(this.listData&&this.listData.length){var i=this.typeOfData(this.listData);if("number"==typeof t.getValue(this.fields.value?this.fields.value:"value",i.item)||"number"===i.typeof)return parseFloat(e);if("boolean"==typeof t.getValue(this.fields.value?this.fields.value:"value",i.item)||"boolean"===i.typeof)return"true"===e||""+e=="true"}return e},l.prototype.setEnableRtl=function(){this.list&&this.enableRtlElements.push(this.list),this.enableRtl?t.addClass(this.enableRtlElements,I.rtl):t.removeClass(this.enableRtlElements,I.rtl)},l.prototype.initialize=function(){if(this.bindEvent=!0,this.actionFailureTemplateId=this.element.id+"ActionFailureTemplate","UL"===this.element.tagName){var e=s.ListBase.createJsonFromElement(this.element);this.setProperties({fields:{text:"text",value:"text"}},!0),this.resetList(e,this.fields)}else if("SELECT"===this.element.tagName){(this.dataSource instanceof Array?this.dataSource.length>0:!t.isNullOrUndefined(this.dataSource))?this.isDynamicDataChange&&this.setListData(this.dataSource,this.fields,this.query):this.renderItemsBySelect()}else this.setListData(this.dataSource,this.fields,this.query)},l.prototype.getPersistData=function(){return this.addOnPersist([])},l.prototype.setEnabled=function(){this.element.setAttribute("aria-disabled",this.enabled?"false":"true")},l.prototype.updateDataAttribute=function(e){for(var i=["class","style","id","type"],s={},l=0;l<this.element.attributes.length;l++)-1!==i.indexOf(this.element.attributes[l].name)||"dropdownlist"===this.getModuleName()&&"readonly"===this.element.attributes[l].name||(s[this.element.attributes[l].name]=this.element.getAttribute(this.element.attributes[l].name));t.extend(s,e,s),this.setProperties({htmlAttributes:s},!0)},l.prototype.renderItemsBySelect=function(){var e=this.element,t={value:"value",text:"text"},i=[],s=e.querySelectorAll("select>optgroup"),l=e.querySelectorAll("select>option");if(this.getJSONfromOption(i,l,t),s.length){for(var n=0;n<s.length;n++){var o=s[n],r={};r[t.text]=o.label,r.isHeader=!0;var a=o.querySelectorAll("option");i.push(r),this.getJSONfromOption(i,a,t)}e.querySelectorAll("select>option")}this.updateFields(t.text,t.value,this.fields.groupBy,this.fields.htmlAttributes,this.fields.iconCss),this.resetList(i,t)},l.prototype.updateFields=function(e,i,s,l,n){var o={fields:{text:e,value:i,groupBy:t.isNullOrUndefined(s)?this.fields&&this.fields.groupBy:s,htmlAttributes:t.isNullOrUndefined(l)?this.fields&&this.fields.htmlAttributes:l,iconCss:t.isNullOrUndefined(n)?this.fields&&this.fields.iconCss:n}};this.setProperties(o,!0)},l.prototype.getJSONfromOption=function(e,i,s){for(var l=0,n=i;l<n.length;l++){var o=n[l],r={};r[s.text]=o.innerText,r[s.value]=t.isNullOrUndefined(o.getAttribute(s.value))?o.innerText:o.getAttribute(s.value),e.push(r)}},l.prototype.preRender=function(){this.scrollTimer=-1,this.enableRtlElements=[],this.isRequested=!1,this.isDataFetched=!1,this.itemTemplateId=this.element.id+"ItemTemplate",this.valueTemplateId=this.element.id+"ValueTemplate",this.groupTemplateId=this.element.id+"GroupTemplate",this.headerTemplateId=this.element.id+"HeaderTemplate",this.footerTemplateId=this.element.id+"FooterTemplate",this.noRecordsTemplateId=this.element.id+"NoRecordsTemplate"},l.prototype.setListData=function(e,t,s){var l=this;t=t||this.fields;var n;this.isActive=!0;var o={cancel:!1,data:e,query:s};this.isPreventChange=!(!this.isAngular||!this.preventChange)||this.isPreventChange,this.trigger("actionBegin",o,function(s){if(!s.cancel)if(l.showSpinner(),e instanceof i.DataManager){if(l.isRequested=!0,l.isDataFetched)return void l.emptyDataRequest(t);s.data.executeQuery(l.getQuery(s.query)).then(function(e){l.isPreventChange=!(!l.isAngular||!l.preventChange)||l.isPreventChange,l.trigger("actionComplete",e,function(e){if(!e.cancel){var i=e.result;0===i.length&&(l.isDataFetched=!0),n=l.renderItems(i,t),l.onActionComplete(n,i,e),l.groupTemplate&&l.renderGroupTemplate(n),l.isRequested=!1,l.bindChildItems(i,n,t,e)}})}).catch(function(e){l.isRequested=!1,l.onActionFailure(e),l.hideSpinner()})}else{var o=new i.DataManager(s.data),r={cancel:!1,result:l.getQuery(s.query).executeLocal(o)};l.isPreventChange=!(!l.isAngular||!l.preventChange)||l.isPreventChange,l.trigger("actionComplete",r,function(e){e.cancel||(n=l.renderItems(e.result,t),l.onActionComplete(n,e.result),l.groupTemplate&&l.renderGroupTemplate(n),l.bindChildItems(e.result,n,t),setTimeout(function(){"multiselect"===l.getModuleName()&&null!=l.itemTemplate&&n.childElementCount>0&&(n.children[0].childElementCount>0||l.fields.groupBy&&n.children[1]&&n.children[1].childElementCount>0)&&l.updateDataList()}))})}})},l.prototype.bindChildItems=function(e,i,s,l){var n=this;e.length>=100&&"autocomplete"===this.getModuleName()?setTimeout(function(){var o=n.remainingItems(n.sortedData,s);t.append(o,i),n.liCollections=n.list.querySelectorAll("."+I.li),n.updateListValues(),n.raiseDataBound(e,l)},0):this.raiseDataBound(e,l)},l.prototype.updateListValues=function(){},l.prototype.findListElement=function(e,t,i,s){var l=null;if(e)for(var n=[].slice.call(e.querySelectorAll(t)),o=0;o<n.length;o++)if(n[o].getAttribute(i)===s+""){l=n[o];break}return l},l.prototype.raiseDataBound=function(e,t){this.hideSpinner();var i={items:e,e:t};this.trigger("dataBound",i)},l.prototype.remainingItems=function(e,t){var l=new i.DataManager(e).executeLocal((new i.Query).skip(100));if(this.itemTemplate){var n=this.templateListItem(l,t);return[].slice.call(n.childNodes)}var o=this.typeOfData(l).typeof;return"string"===o||"number"===o||"boolean"===o?s.ListBase.createListItemFromArray(this.createElement,l,!0,this.listOption(l,t),this):s.ListBase.createListItemFromJson(this.createElement,l,this.listOption(l,t),1,!0,this)},l.prototype.emptyDataRequest=function(e){var t=[];this.onActionComplete(this.renderItems(t,e),t),this.isRequested=!1,this.hideSpinner()},l.prototype.showSpinner=function(){},l.prototype.hideSpinner=function(){},l.prototype.onActionFailure=function(e){this.liCollections=[],this.trigger("actionFailure",e),this.l10nUpdate(!0),t.addClass([this.list],I.noData)},l.prototype.onActionComplete=function(e,i,s){if(this.listData=i,this.isReact&&this.clearTemplate(["itemTemplate","groupTemplate","actionFailureTemplate","noRecordsTemplate"]),this.fixedHeaderElement=t.isNullOrUndefined(this.fixedHeaderElement)?this.fixedHeaderElement:null,"multiselect"===this.getModuleName()&&this.properties.allowCustomValue&&this.fields.groupBy)for(var l=0;l<e.childElementCount;l++)e.children[l].classList.contains("e-list-group-item")&&(t.isNullOrUndefined(e.children[l].innerHTML)||""==e.children[l].innerHTML)&&t.addClass([e.children[l]],"e-hide-group-header");t.isNullOrUndefined(this.list)||(this.list.innerHTML="",this.list.appendChild(e),this.liCollections=this.list.querySelectorAll("."+I.li),this.ulElement=this.list.querySelector("ul"),this.postRender(this.list,i,this.bindEvent))},l.prototype.postRender=function(e,i,s){var l=e.querySelector("."+I.li),n=e.querySelector("."+I.selected);l&&!n&&l.classList.add(I.focus),i.length<=0?(this.l10nUpdate(),t.addClass([e],I.noData)):e.classList.remove(I.noData)},l.prototype.getQuery=function(e){return e||(this.query?this.query:new i.Query)},l.prototype.renderGroupTemplate=function(e){if(null!==this.fields.groupBy&&this.dataSource||this.element.querySelector("."+I.group)){var i=this.dataSource,l={groupTemplateID:this.groupTemplateId,isStringTemplate:this.isStringTemplate},n=e.querySelectorAll("."+I.group);if(this.templateCompiler(this.groupTemplate)){var o=t.select(this.groupTemplate,document).innerHTML.trim(),r=s.ListBase.renderGroupTemplate(o,i,this.fields.properties,n,l,this);if(this.isGroupChecking)for(var a=0;a<r.length;a++)this.notify("addItem",{module:"CheckBoxSelection",item:r[a]})}else{r=s.ListBase.renderGroupTemplate(this.groupTemplate,i,this.fields.properties,n,l,this);if(this.isGroupChecking)for(a=0;a<r.length;a++)this.notify("addItem",{module:"CheckBoxSelection",item:r[a]})}this.renderReactTemplates()}},l.prototype.createListItems=function(e,l){e&&l.groupBy||this.element.querySelector("optgroup")?(l.groupBy&&("None"!==this.sortOrder&&(e=this.getSortedDataSource(e)),e=s.ListBase.groupDataSource(e,l.properties,this.sortOrder)),t.addClass([this.list],I.grouping)):e=this.getSortedDataSource(e);var n=this.listOption(e,l),o=e.length>100?new i.DataManager(e).executeLocal((new i.Query).take(100)):e;return this.sortedData=e,s.ListBase.createList(this.createElement,"autocomplete"===this.getModuleName()?o:e,n,!0,this)},l.prototype.listOption=function(e,i){var s=!t.isNullOrUndefined(i.iconCss),l=t.isNullOrUndefined(i.properties)?i:i.properties,n=null!==i.text||null!==i.value?{fields:l,showIcon:s,ariaAttributes:{groupItemRole:"presentation"}}:{fields:{value:"text"}};return t.extend({},n,i,!0)},l.prototype.setFloatingHeader=function(e){t.isNullOrUndefined(this.fixedHeaderElement)&&(this.fixedHeaderElement=this.createElement("div",{className:I.fixedHead}),this.list.querySelector("li").classList.contains(I.group)||(this.fixedHeaderElement.style.display="none"),t.prepend([this.fixedHeaderElement],this.list),this.setFixedHeader()),t.isNullOrUndefined(this.fixedHeaderElement)||"0"!==this.fixedHeaderElement.style.zIndex||this.setFixedHeader(),this.scrollStop(e)},l.prototype.scrollStop=function(e){for(var i=t.isNullOrUndefined(e)?this.list:e.target,s=parseInt(getComputedStyle(this.getValidLi(),null).getPropertyValue("height"),10),l=Math.round(i.scrollTop/s),n=this.list.querySelectorAll("li:not(.e-hide-listitem)"),o=l;o>-1;o--){if(!t.isNullOrUndefined(n[o])&&n[o].classList.contains(I.group)){var r=n[o];this.fixedHeaderElement.innerHTML=r.innerHTML,this.fixedHeaderElement.style.top=i.scrollTop+"px",this.fixedHeaderElement.style.display="block";break}this.fixedHeaderElement.style.display="none",this.fixedHeaderElement.style.top="none"}},l.prototype.getValidLi=function(){return this.liCollections[0]},l.prototype.renderItems=function(e,t){var l;if(this.itemTemplate&&e){var n=e;n&&t.groupBy?("None"!==this.sortOrder&&(n=this.getSortedDataSource(n)),n=s.ListBase.groupDataSource(n,t.properties,this.sortOrder)):n=this.getSortedDataSource(n),this.sortedData=n;var o=n.length>100?new i.DataManager(n).executeLocal((new i.Query).take(100)):n;l=this.templateListItem("autocomplete"===this.getModuleName()?o:n,t)}else l=this.createListItems(e,t);return l},l.prototype.templateListItem=function(e,i){var l=this.listOption(e,i);l.templateID=this.itemTemplateId,l.isStringTemplate=this.isStringTemplate;if(this.templateCompiler(this.itemTemplate)){var n=t.select(this.itemTemplate,document).innerHTML.trim();return s.ListBase.renderContentTemplate(this.createElement,n,e,i.properties,l,this)}return s.ListBase.renderContentTemplate(this.createElement,this.itemTemplate,e,i.properties,l,this)},l.prototype.typeOfData=function(e){for(var i={typeof:null,item:null},s=0;!t.isNullOrUndefined(e)&&s<e.length;s++)if(!t.isNullOrUndefined(e[s])){if(!("string"==typeof e[s]||"number"==typeof e[s]||"boolean"==typeof e[s]?t.isNullOrUndefined(e[s]):t.isNullOrUndefined(t.getValue(this.fields.value?this.fields.value:"value",e[s]))))return i={typeof:typeof e[s],item:e[s]}}return i},l.prototype.setFixedHeader=function(){this.list.parentElement.style.display="block";var e=0;if(this.list&&this.list.parentElement&&(e=parseInt(document.defaultView.getComputedStyle(this.list.parentElement,null).getPropertyValue("border-width"),10),isNaN(e))){e=parseInt(document.defaultView.getComputedStyle(this.list.parentElement,null).getPropertyValue("border-top-width"),10)+parseInt(document.defaultView.getComputedStyle(this.list.parentElement,null).getPropertyValue("border-bottom-width"),10)+parseInt(document.defaultView.getComputedStyle(this.list.parentElement,null).getPropertyValue("border-left-width"),10)+parseInt(document.defaultView.getComputedStyle(this.list.parentElement,null).getPropertyValue("border-right-width"),10)}var i=this.getValidLi().offsetWidth-e;this.fixedHeaderElement.style.width=i.toString()+"px",t.setStyleAttribute(this.fixedHeaderElement,{zIndex:10});var s=this.ulElement.querySelector("."+I.group+":not(.e-hide-listitem)");this.fixedHeaderElement.innerHTML=s.innerHTML},l.prototype.getSortedDataSource=function(e){if(e&&"None"!==this.sortOrder){var t=this.fields.text?this.fields.text:"text";"string"!==this.typeOfData(e).typeof&&"number"!==this.typeOfData(e).typeof&&"boolean"!==this.typeOfData(e).typeof||(t=""),e=s.ListBase.getDataSource(e,s.ListBase.addSorting(this.sortOrder,t))}return e},l.prototype.getIndexByValue=function(e){for(var i,s=this.getItems(),l=0;l<s.length;l++)if(!t.isNullOrUndefined(e)&&s[l].getAttribute("data-value")===e.toString()){i=l;break}return i},l.prototype.dispatchEvent=function(e,t){var i=document.createEvent("HTMLEvents");i.initEvent(t,!1,!0),e.dispatchEvent(i)},l.prototype.setFields=function(){this.fields.value&&!this.fields.text?this.updateFields(this.fields.value,this.fields.value):!this.fields.value&&this.fields.text?this.updateFields(this.fields.text,this.fields.text):this.fields.value||this.fields.text||this.updateFields("text","text")},l.prototype.resetList=function(e,i,s){if(this.list){if("SELECT"===this.element.tagName&&this.element.options.length>0||"UL"===this.element.tagName&&this.element.childNodes.length>0){!(e instanceof Array?e.length>0:!t.isNullOrUndefined(e))&&this.selectData&&this.selectData.length>0&&(e=this.selectData)}this.setListData(e,i,s)}},l.prototype.updateSelectElementData=function(e){e&&t.isNullOrUndefined(this.selectData)&&this.listData&&this.listData.length>0&&(this.selectData=this.listData)},l.prototype.updateSelection=function(){},l.prototype.renderList=function(){this.render()},l.prototype.updateDataSource=function(e){this.resetList(this.dataSource)},l.prototype.setUpdateInitial=function(e,t){this.isDataFetched=!1;for(var i={},s=0;e.length>s;s++)t[e[s]]&&"fields"===e[s]?(this.setFields(),i[e[s]]=t[e[s]]):t[e[s]]&&(i[e[s]]=t[e[s]]);Object.keys(i).length>0&&(-1===Object.keys(i).indexOf("dataSource")&&(i.dataSource=this.dataSource),this.updateDataSource(i))},l.prototype.onPropertyChanged=function(e,i){"dropdownbase"===this.getModuleName()&&this.setUpdateInitial(["fields","query","dataSource"],e),this.setUpdateInitial(["sortOrder","itemTemplate"],e);for(var s=0,l=Object.keys(e);s<l.length;s++){switch(l[s]){case"query":case"sortOrder":case"dataSource":case"itemTemplate":break;case"enableRtl":this.setEnableRtl();break;case"enabled":this.setEnabled();break;case"groupTemplate":if(this.renderGroupTemplate(this.list),this.ulElement&&this.fixedHeaderElement){var n=this.ulElement.querySelector("."+I.group);this.fixedHeaderElement.innerHTML=n.innerHTML}break;case"locale":this.list&&!t.isNullOrUndefined(this.liCollections)&&0===this.liCollections.length&&this.l10nUpdate();break;case"zIndex":this.setProperties({zIndex:e.zIndex},!0),this.setZIndex()}}},l.prototype.render=function(e){this.list=this.createElement("div",{className:I.content,attrs:{tabindex:"0"}}),this.list.classList.add(I.root),this.setFields();var i={duration:300,selector:"."+I.li};this.rippleFun=t.rippleEffect(this.list,i);var s=this.element.querySelector("select>optgroup");if(!this.fields.groupBy&&t.isNullOrUndefined(s)||this.isGroupChecking||t.EventHandler.add(this.list,"scroll",this.setFloatingHeader,this),"dropdownbase"===this.getModuleName()){this.element.getAttribute("tabindex")&&this.list.setAttribute("tabindex",this.element.getAttribute("tabindex")),t.removeClass([this.element],I.root),this.element.style.display="none";var l=this.createElement("div");this.element.parentElement.insertBefore(l,this.element),l.appendChild(this.element),l.appendChild(this.list)}this.setEnableRtl(),this.setEnabled(),e||this.initialize()},l.prototype.getModuleName=function(){return"dropdownbase"},l.prototype.getItems=function(){return this.ulElement.querySelectorAll("."+I.li)},l.prototype.addItem=function(e,i){if((!this.list||this.list.textContent===this.noRecordsTemplate&&"listbox"!==this.getModuleName())&&this.renderList(),"None"!==this.sortOrder&&t.isNullOrUndefined(i)){var l=[].slice.call(this.listData);l.push(e),l=this.getSortedDataSource(l),i=this.fields.groupBy?(l=s.ListBase.groupDataSource(l,this.fields.properties,this.sortOrder)).indexOf(e):l.indexOf(e)}var n=this.getItems().length,o=this.list.querySelector("."+I.selected);e=e instanceof Array?e:[e];var r;r=t.isNullOrUndefined(i)||i<0||i>n-1?n:i;var a=this.fields;e&&a.groupBy&&(e=s.ListBase.groupDataSource(e,a.properties));for(var h=[],p=0;p<e.length;p++){var u=e[p],c=u.isHeader,d=this.createElement("li",{className:c?I.group:I.li,id:"option-add-"+p}),m=u instanceof Object?t.getValue(a.text,u):u;if(c&&(d.innerText=m),this.itemTemplate&&!c){var f=(this.templateCompiler(this.itemTemplate)?t.compile(t.select(this.itemTemplate,document).innerHTML.trim()):t.compile(this.itemTemplate))(u,this,"itemTemplate",this.itemTemplateId,this.isStringTemplate,null,d);f&&t.append(f,d)}else c||d.appendChild(document.createTextNode(m));d.setAttribute("data-value",u instanceof Object?t.getValue(a.value,u):u),d.setAttribute("role","option"),this.notify("addItem",{module:"CheckBoxSelection",item:d}),h.push(d),this.listData.push(u),"None"===this.sortOrder&&t.isNullOrUndefined(i)&&0===r&&(r=null),this.updateActionCompleteData(d,u,r),this.trigger("beforeItemRender",{element:d,item:u})}if(0===n&&t.isNullOrUndefined(this.list.querySelector("ul")))this.list.innerHTML="",this.list.classList.remove(I.noData),this.list.appendChild(this.ulElement),this.liCollections=h,t.append(h,this.ulElement),this.updateAddItemList(this.list,n);else{"listbox"===this.getModuleName()&&0===n&&(this.ulElement.innerHTML="");var v=[];for(p=0;p<e.length;p++){for(var y=this.ulElement.querySelectorAll(".e-list-group-item"),g=0;g<y.length;g++)v[g]=y[g].innerText;if(v.indexOf(h[p].innerText)>-1&&a.groupBy){for(g=0;g<y.length;g++)if(v[g]===h[p].innerText){"None"===this.sortOrder?this.ulElement.insertBefore(h[p+1],y[g+1]):this.ulElement.insertBefore(h[p+1],this.ulElement.childNodes[i]),p+=1;break}}else this.liCollections[r]?this.liCollections[r].parentNode.insertBefore(h[p],this.liCollections[r]):this.ulElement.appendChild(h[p]);var C=[].slice.call(this.liCollections);C.splice(r,0,h[p]),this.liCollections=C,r+=1,"multiselect"===this.getModuleName()&&this.updateDataList()}}(o||0===i)&&this.updateSelection()},l.prototype.validationAttribute=function(e,t){var i=e.getAttribute("name")?e.getAttribute("name"):e.getAttribute("id");t.setAttribute("name",i),e.removeAttribute("name");for(var s=["required","aria-required","form"],l=0;l<s.length;l++)if(e.getAttribute(s[l])){var n=e.getAttribute(s[l]);t.setAttribute(s[l],n),e.removeAttribute(s[l])}},l.prototype.setZIndex=function(){},l.prototype.updateActionCompleteData=function(e,t,i){},l.prototype.updateAddItemList=function(e,t){},l.prototype.updateDataList=function(){},l.prototype.getDataByValue=function(e){if(!t.isNullOrUndefined(this.listData)){var i=this.typeOfData(this.listData).typeof;if("string"===i||"number"===i||"boolean"===i)for(var s=0,l=this.listData;s<l.length;s++){var n=l[s];if(!t.isNullOrUndefined(n)&&n===e)return n}else for(var o=0,r=this.listData;o<r.length;o++){n=r[o];if(!t.isNullOrUndefined(n)&&t.getValue(this.fields.value?this.fields.value:"value",n)===e)return n}}return null},l.prototype.destroy=function(){document.body.contains(this.list)&&(t.EventHandler.remove(this.list,"scroll",this.setFloatingHeader),t.isNullOrUndefined(this.rippleFun)||this.rippleFun(),t.detach(this.list)),e.prototype.destroy.call(this)},A([t.Complex({text:null,value:null,iconCss:null,groupBy:null},D)],l.prototype,"fields",void 0),A([t.Property(!1)],l.prototype,"enablePersistence",void 0),A([t.Property(null)],l.prototype,"itemTemplate",void 0),A([t.Property(null)],l.prototype,"groupTemplate",void 0),A([t.Property("No records found")],l.prototype,"noRecordsTemplate",void 0),A([t.Property("Request failed")],l.prototype,"actionFailureTemplate",void 0),A([t.Property("None")],l.prototype,"sortOrder",void 0),A([t.Property(!0)],l.prototype,"enabled",void 0),A([t.Property([])],l.prototype,"dataSource",void 0),A([t.Property(null)],l.prototype,"query",void 0),A([t.Property("StartsWith")],l.prototype,"filterType",void 0),A([t.Property(!0)],l.prototype,"ignoreCase",void 0),A([t.Property(1e3)],l.prototype,"zIndex",void 0),A([t.Property(!1)],l.prototype,"ignoreAccent",void 0),A([t.Property()],l.prototype,"locale",void 0),A([t.Event()],l.prototype,"actionBegin",void 0),A([t.Event()],l.prototype,"actionComplete",void 0),A([t.Event()],l.prototype,"actionFailure",void 0),A([t.Event()],l.prototype,"select",void 0),A([t.Event()],l.prototype,"dataBound",void 0),A([t.Event()],l.prototype,"created",void 0),A([t.Event()],l.prototype,"destroyed",void 0),l=A([t.NotifyPropertyChanges],l)}(t.Component),B=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),T=function(e,t,i,s){var l,n=arguments.length,o=n<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)o=Reflect.decorate(e,t,i,s);else for(var r=e.length-1;r>=0;r--)(l=e[r])&&(o=(n<3?l(o):n>3?l(t,i,o):l(t,i))||o);return n>3&&o&&Object.defineProperty(t,i,o),o},N={root:"e-dropdownlist",hover:I.hover,selected:I.selected,rtl:I.rtl,li:I.li,disable:I.disabled,base:I.root,focus:I.focus,input:"e-input-group",inputFocus:"e-input-focus",icon:"e-input-group-icon e-ddl-icon",iconAnimation:"e-icon-anim",value:"e-input-value",device:"e-ddl-device",backIcon:"e-input-group-icon e-back-icon e-icons",filterBarClearIcon:"e-input-group-icon e-clear-icon e-icons",filterInput:"e-input-filter",filterParent:"e-filter-parent",mobileFilter:"e-ddl-device-filter",footer:"e-ddl-footer",header:"e-ddl-header",clearIcon:"e-clear-icon",clearIconHide:"e-clear-icon-hide",popupFullScreen:"e-popup-full-page",disableIcon:"e-ddl-disable-icon",hiddenElement:"e-ddl-hidden"},P={container:null,buttons:[]},W=function(e){function s(t,i){var s=e.call(this,t,i)||this;return s.isListSearched=!1,s.preventChange=!1,s.isAngular=!1,s}return B(s,e),s.prototype.preRender=function(){this.valueTempElement=null,this.element.style.opacity="0",this.initializeData(),e.prototype.preRender.call(this),this.activeIndex=this.index,this.queryString=""},s.prototype.initializeData=function(){this.isPopupOpen=!1,this.isDocumentClick=!1,this.isInteracted=!1,this.isFilterFocus=!1,this.beforePopupOpen=!1,this.initial=!0,this.initRemoteRender=!1,this.isNotSearchList=!1,this.isTyped=!1,this.isSelected=!1,this.preventFocus=!1,this.preventAutoFill=!1,this.isValidKey=!1,this.typedString="",this.isEscapeKey=!1,this.isPreventBlur=!1,this.isTabKey=!1,this.actionCompleteData={isUpdated:!1},this.actionData={isUpdated:!1},this.prevSelectPoints={},this.isSelectCustom=!1,this.isDropDownClick=!1,this.preventAltUp=!1,this.isCustomFilter=!1,this.isSecondClick=!1,this.previousValue=null,this.keyConfigure={tab:"tab",enter:"13",escape:"27",end:"35",home:"36",down:"40",up:"38",pageUp:"33",pageDown:"34",open:"alt+40",close:"shift+tab",hide:"alt+38",space:"32"}},s.prototype.setZIndex=function(){this.popupObj&&this.popupObj.setProperties({zIndex:this.zIndex})},s.prototype.renderList=function(t){e.prototype.render.call(this,t),this.unWireListEvents(),this.wireListEvents()},s.prototype.floatLabelChange=function(){if("dropdownlist"===this.getModuleName()&&"Auto"===this.floatLabelType){var e=this.inputWrapper.container.querySelector(".e-float-text");""!==this.inputElement.value||this.isInteracted?t.classList(e,["e-label-top"],["e-label-bottom"]):t.classList(e,["e-label-bottom"],["e-label-top"])}},s.prototype.resetHandler=function(e){e.preventDefault(),this.clearAll(e)},s.prototype.resetFocusElement=function(){if(this.removeHover(),this.removeSelection(),this.removeFocus(),this.list.scrollTop=0,"autocomplete"!==this.getModuleName()&&!t.isNullOrUndefined(this.ulElement)){var e=this.ulElement.querySelector("."+N.li);e&&e.classList.add(N.focus)}},s.prototype.clearAll=function(e,s){!t.isNullOrUndefined(s)&&(t.isNullOrUndefined(s)||!t.isNullOrUndefined(s.dataSource)&&(s.dataSource instanceof i.DataManager||0!==s.dataSource.length))||(this.isActive=!0,this.resetSelection(s));var l=this.getItemData();this.previousValue!==l.value&&this.onChangeEvent(e)},s.prototype.resetSelection=function(e){this.list&&(t.isNullOrUndefined(e)||!t.isNullOrUndefined(e.dataSource)&&(e.dataSource instanceof i.DataManager||0!==e.dataSource.length)?(!this.allowFiltering||"autocomplete"===this.getModuleName()||t.isNullOrUndefined(this.actionCompleteData.ulElement)||t.isNullOrUndefined(this.actionCompleteData.list)||this.onActionComplete(this.actionCompleteData.ulElement.cloneNode(!0),this.actionCompleteData.list),this.resetFocusElement()):(this.selectedLI=null,this.actionCompleteData.isUpdated=!1,this.actionCompleteData.ulElement=null,this.actionCompleteData.list=null,this.resetList(e.dataSource))),this.hiddenElement.innerHTML="",this.inputElement.value="",this.value=null,this.itemData=null,this.text=null,this.index=null,this.activeIndex=null,this.item=null,this.queryString="",this.valueTempElement&&(t.detach(this.valueTempElement),this.inputElement.style.display="block",this.valueTempElement=null),this.setSelection(null,null),this.isSelectCustom=!1,this.updateIconState(),this.cloneElements()},s.prototype.setHTMLAttributes=function(){if(Object.keys(this.htmlAttributes).length)for(var e=0,i=Object.keys(this.htmlAttributes);e<i.length;e++){var s=i[e];if("class"===s){var l=this.htmlAttributes[s].replace(/\s+/g," ").trim();""!==l&&t.addClass([this.inputWrapper.container],l.split(" "))}else if("disabled"===s&&"disabled"===this.htmlAttributes[s])this.enabled=!1,this.setEnable();else if("readonly"!==s||t.isNullOrUndefined(this.htmlAttributes[s]))if("style"===s)this.inputWrapper.container.setAttribute("style",this.htmlAttributes[s]);else{var o=["title","id","placeholder","aria-placeholder","role","autocorrect","autocomplete","autocapitalize","spellcheck","minlength","maxlength"];"autocomplete"!==this.getModuleName()&&"combobox"!==this.getModuleName()||o.push("tabindex"),["name","required"].indexOf(s)>-1||0===s.indexOf("data")?this.hiddenElement.setAttribute(s,this.htmlAttributes[s]):o.indexOf(s)>-1?"placeholder"===s?n.Input.setPlaceholder(this.htmlAttributes[s],this.inputElement):this.inputElement.setAttribute(s,this.htmlAttributes[s]):this.inputWrapper.container.setAttribute(s,this.htmlAttributes[s])}else this.readonly=!0,this.dataBind()}"autocomplete"!==this.getModuleName()&&"combobox"!==this.getModuleName()||this.inputWrapper.container.removeAttribute("tabindex")},s.prototype.getAriaAttributes=function(){return{"aria-disabled":"false","aria-owns":this.element.id+"_options",role:"listbox","aria-haspopup":"true","aria-expanded":"false","aria-activedescendant":"null","aria-live":"polite","aria-labelledby":this.hiddenElement.id}},s.prototype.setEnableRtl=function(){n.Input.setEnableRtl(this.enableRtl,[this.inputElement.parentElement]),this.popupObj&&(this.popupObj.enableRtl=this.enableRtl,this.popupObj.dataBind())},s.prototype.setEnable=function(){n.Input.setEnabled(this.enabled,this.inputElement),this.enabled?(t.removeClass([this.inputWrapper.container],N.disable),this.inputElement.setAttribute("aria-disabled","false"),this.targetElement().setAttribute("tabindex",this.tabIndex)):(this.hidePopup(),t.addClass([this.inputWrapper.container],N.disable),this.inputElement.setAttribute("aria-disabled","true"),this.targetElement().tabIndex=-1)},s.prototype.getPersistData=function(){return this.addOnPersist(["value"])},s.prototype.getLocaleName=function(){return"drop-down-list"},s.prototype.preventTabIndex=function(e){"dropdownlist"===this.getModuleName()&&(e.tabIndex=-1)},s.prototype.targetElement=function(){return this.inputWrapper.container},s.prototype.getNgDirective=function(){return"EJS-DROPDOWNLIST"},s.prototype.getElementByText=function(e){return this.getElementByValue(this.getValueByText(e))},s.prototype.getElementByValue=function(e){for(var t,i=0,s=this.getItems();i<s.length;i++){var l=s[i];if(this.getFormattedValue(l.getAttribute("data-value"))===e){t=l;break}}return t},s.prototype.initValue=function(){this.renderList(),this.dataSource instanceof i.DataManager?this.initRemoteRender=!0:this.updateValues()},s.prototype.updateValues=function(){if(t.isNullOrUndefined(this.value))if(this.text&&t.isNullOrUndefined(this.value)){var e=this.getElementByText(this.text);if(t.isNullOrUndefined(e))return void this.setProperties({text:null});this.setSelection(e,null)}else this.setSelection(this.liCollections[this.activeIndex],null);else this.setSelection(this.getElementByValue(this.value),null);this.setHiddenValue(),n.Input.setValue(this.text,this.inputElement,this.floatLabelType,this.showClearButton)},s.prototype.onBlurHandler=function(e){if(this.enabled){var i=e.relatedTarget,s=e.target,l=this.isPreventBlur;this.isPreventBlur=!1,!l||this.isDocumentClick||!this.isPopupOpen||t.isNullOrUndefined(s)&&(this.isFilterLayout()||!t.isNullOrUndefined(i))?this.isDocumentClick||!t.isNullOrUndefined(this.popupObj)&&document.body.contains(this.popupObj.element)&&this.popupObj.element.classList.contains(N.mobileFilter)?this.beforePopupOpen||(this.isDocumentClick=!1):(("dropdownlist"===this.getModuleName()&&!this.isFilterFocus&&i!==this.inputElement&&(document.activeElement!==i||document.activeElement===i&&s.classList.contains(N.inputFocus))||t.isNullOrUndefined(i)&&"dropdownlist"===this.getModuleName()&&this.allowFiltering&&s!==this.inputWrapper.container||"dropdownlist"!==this.getModuleName()&&!this.inputWrapper.container.contains(i)||this.isTabKey)&&(this.isDocumentClick=!!this.isPopupOpen,this.focusOutAction(e),this.isTabKey=!1),!this.isRequested||this.isPopupOpen||this.isPreventBlur||(this.isActive=!1,this.beforePopupOpen=!1)):"dropdownlist"===this.getModuleName()&&this.allowFiltering&&this.isPopupOpen?this.filterInput.focus():this.targetElement().focus()}},s.prototype.focusOutAction=function(e){this.isInteracted=!1,this.focusOut(e),this.onFocusOut()},s.prototype.onFocusOut=function(){this.enabled&&(this.isSelected&&(this.isSelectCustom=!1,this.onChangeEvent(null)),this.floatLabelChange(),this.dispatchEvent(this.hiddenElement,"change"),"dropdownlist"===this.getModuleName()&&"INPUT"!==this.element.tagName&&this.dispatchEvent(this.inputElement,"blur"),this.inputWrapper.clearButton&&t.addClass([this.inputWrapper.clearButton],N.clearIconHide),this.trigger("blur"))},s.prototype.onFocus=function(e){if(!this.isInteracted){this.isInteracted=!0;var t={isInteracted:!!e,event:e};this.trigger("focus",t)}this.updateIconState()},s.prototype.resetValueHandler=function(e){var i=t.closest(this.inputElement,"form");if(i&&e.target===i){var s=this.element.tagName===this.getNgDirective()?null:this.inputElement.getAttribute("value");this.text=s}},s.prototype.wireEvent=function(){t.EventHandler.add(this.inputWrapper.container,"mousedown",this.dropDownClick,this),t.EventHandler.add(this.inputWrapper.container,"focus",this.focusIn,this),t.EventHandler.add(this.inputWrapper.container,"keypress",this.onSearch,this),this.bindCommonEvent()},s.prototype.bindCommonEvent=function(){t.EventHandler.add(this.targetElement(),"blur",this.onBlurHandler,this);var e=t.closest(this.inputElement,"form");e&&t.EventHandler.add(e,"reset",this.resetValueHandler,this),t.Browser.isDevice?this.keyboardModule=new t.KeyboardEvents(this.targetElement(),{keyAction:this.mobileKeyActionHandler.bind(this),keyConfigs:this.keyConfigure,eventName:"keydown"}):this.keyboardModule=new t.KeyboardEvents(this.targetElement(),{keyAction:this.keyActionHandler.bind(this),keyConfigs:this.keyConfigure,eventName:"keydown"}),this.bindClearEvent()},s.prototype.bindClearEvent=function(){this.showClearButton&&t.EventHandler.add(this.inputWrapper.clearButton,"mousedown",this.resetHandler,this)},s.prototype.unBindCommonEvent=function(){this.targetElement()&&t.EventHandler.remove(this.targetElement(),"blur",this.onBlurHandler);var e=this.inputElement&&t.closest(this.inputElement,"form");e&&t.EventHandler.remove(e,"reset",this.resetValueHandler),t.Browser.isDevice||this.keyboardModule.destroy(),this.showClearButton&&t.EventHandler.remove(this.inputWrapper.clearButton,"mousedown",this.resetHandler)},s.prototype.updateIconState=function(){this.showClearButton&&(""===this.inputElement.value||this.readonly?t.addClass([this.inputWrapper.clearButton],N.clearIconHide):t.removeClass([this.inputWrapper.clearButton],N.clearIconHide))},s.prototype.wireListEvents=function(){t.EventHandler.add(this.list,"click",this.onMouseClick,this),t.EventHandler.add(this.list,"mouseover",this.onMouseOver,this),t.EventHandler.add(this.list,"mouseout",this.onMouseLeave,this)},s.prototype.onSearch=function(e){32!==e.charCode&&13!==e.charCode&&(void 0===this.list&&this.renderList(),this.searchKeyEvent=e,this.onServerIncrementalSearch(e))},s.prototype.onServerIncrementalSearch=function(e){this.isRequested||t.isNullOrUndefined(this.list)||t.isNullOrUndefined(this.list.querySelector("li"))||!this.enabled||this.readonly||this.incrementalSearch(e)},s.prototype.onMouseClick=function(e){var i=e.target,s=t.closest(i,"."+I.li);if(this.isValidLI(s))if(this.setSelection(s,e),t.Browser.isDevice&&this.isFilterLayout())history.back();else{this.closePopup(100)}},s.prototype.onMouseOver=function(e){var i=t.closest(e.target,"."+I.li);this.setHover(i)},s.prototype.setHover=function(e){this.enabled&&this.isValidLI(e)&&!e.classList.contains(I.hover)&&(this.removeHover(),t.addClass([e],I.hover))},s.prototype.onMouseLeave=function(){this.removeHover()},s.prototype.removeHover=function(){if(this.list){var e=this.list.querySelectorAll("."+I.hover);e&&e.length&&t.removeClass(e,I.hover)}},s.prototype.isValidLI=function(e){return e&&e.hasAttribute("role")&&"option"===e.getAttribute("role")},s.prototype.incrementalSearch=function(e){if(this.liCollections.length>0){var i=a(e.charCode,this.liCollections,this.activeIndex,!0,this.element.id);t.isNullOrUndefined(i)||(this.setSelection(i,e),this.setScrollPosition())}},s.prototype.hideSpinner=function(){t.isNullOrUndefined(this.spinnerElement)||(l.hideSpinner(this.spinnerElement),t.removeClass([this.spinnerElement],N.disableIcon),this.spinnerElement.innerHTML="",this.spinnerElement=null)},s.prototype.showSpinner=function(){t.isNullOrUndefined(this.spinnerElement)&&(this.spinnerElement=t.Browser.isDevice&&!t.isNullOrUndefined(this.filterInputObj)&&this.filterInputObj.buttons[1]||!t.isNullOrUndefined(this.filterInputObj)&&this.filterInputObj.buttons[0]||this.inputWrapper.buttons[0],t.addClass([this.spinnerElement],N.disableIcon),l.createSpinner({target:this.spinnerElement,width:t.Browser.isDevice?"16px":"14px"},this.createElement),l.showSpinner(this.spinnerElement))},s.prototype.keyActionHandler=function(e){if(this.enabled){var i="pageUp"===e.action||"pageDown"===e.action,s="dropdownlist"!==this.getModuleName()&&("home"===e.action||"end"===e.action);this.isEscapeKey="escape"===e.action,this.isTabKey=!this.isPopupOpen&&"tab"===e.action;"down"===e.action||"up"===e.action||"home"===e.action||e.action;var l="down"===e.action||"up"===e.action||"pageUp"===e.action||"pageDown"===e.action||"home"===e.action||"end"===e.action;if((!(this.isEditTextBox()||i||s)||this.isPopupOpen)&&!this.readonly){var n="tab"===e.action||"close"===e.action;if(void 0!==this.list||this.isRequested||n||"escape"===e.action||(this.searchKeyEvent=e,this.renderList()),t.isNullOrUndefined(this.list)||!t.isNullOrUndefined(this.liCollections)&&l&&0===this.liCollections.length||this.isRequested)return;switch((n&&"autocomplete"!==this.getModuleName()&&this.isPopupOpen||"escape"===e.action)&&e.preventDefault(),this.isSelected="escape"!==e.action&&this.isSelected,this.isTyped=!l&&"escape"!==e.action&&this.isTyped,e.action){case"down":case"up":this.updateUpDownAction(e);break;case"pageUp":this.pageUpSelection(this.activeIndex-this.getPageCount(),e),e.preventDefault();break;case"pageDown":this.pageDownSelection(this.activeIndex+this.getPageCount(),e),e.preventDefault();break;case"home":case"end":this.updateHomeEndAction(e);break;case"space":"dropdownlist"===this.getModuleName()&&(this.beforePopupOpen||this.showPopup());break;case"open":this.showPopup();break;case"hide":this.preventAltUp=this.isPopupOpen,this.hidePopup(e),this.focusDropDown(e);break;case"enter":this.selectCurrentItem(e);break;case"tab":this.selectCurrentValueOnTab(e);break;case"escape":case"close":this.isPopupOpen&&(this.hidePopup(e),this.focusDropDown(e))}}}},s.prototype.updateUpDownAction=function(e){var i=this.list.querySelector("."+N.focus);if(this.isSelectFocusItem(i))this.setSelection(i,e);else if(!t.isNullOrUndefined(this.liCollections)){var s="down"===e.action?this.activeIndex+1:this.activeIndex-1,l=0;"autocomplete"===this.getModuleName()&&(l="down"===e.action&&t.isNullOrUndefined(this.activeIndex)?0:this.liCollections.length-1,s=s<0?this.liCollections.length-1:s===this.liCollections.length?0:s);var n=t.isNullOrUndefined(this.activeIndex)?this.liCollections[l]:this.liCollections[s];t.isNullOrUndefined(n)||this.setSelection(n,e)}e.preventDefault()},s.prototype.updateHomeEndAction=function(e){if("dropdownlist"===this.getModuleName()){var t=0;if(t="home"===e.action?0:this.getItems().length-1,e.preventDefault(),this.activeIndex===t)return;this.setSelection(this.liCollections[t],e)}},s.prototype.selectCurrentValueOnTab=function(e){"autocomplete"===this.getModuleName()?this.selectCurrentItem(e):this.isPopupOpen&&(this.hidePopup(e),this.focusDropDown(e))},s.prototype.mobileKeyActionHandler=function(e){if(this.enabled&&(!this.isEditTextBox()||this.isPopupOpen)&&!this.readonly){if(void 0!==this.list||this.isRequested||(this.searchKeyEvent=e,this.renderList()),t.isNullOrUndefined(this.list)||!t.isNullOrUndefined(this.liCollections)&&0===this.liCollections.length||this.isRequested)return;"enter"===e.action&&this.selectCurrentItem(e)}},s.prototype.selectCurrentItem=function(e){if(this.isPopupOpen){var t=this.list.querySelector("."+N.focus);t&&(this.setSelection(t,e),this.isTyped=!1),this.isSelected&&(this.isSelectCustom=!1,this.onChangeEvent(e)),this.hidePopup(),this.focusDropDown(e)}else this.showPopup()},s.prototype.isSelectFocusItem=function(e){return!t.isNullOrUndefined(e)},s.prototype.getPageCount=function(){var e=this.list.classList.contains(I.noData)?null:getComputedStyle(this.getItems()[0],null).getPropertyValue("height");return Math.round(this.list.getBoundingClientRect().height/parseInt(e,10))},s.prototype.pageUpSelection=function(e,t){var i=e>=0?this.liCollections[e+1]:this.liCollections[0];this.setSelection(i,t)},s.prototype.pageDownSelection=function(e,t){var i=this.getItems(),s=e<=i.length?this.liCollections[e-1]:this.liCollections[i.length-1];this.setSelection(s,t)},s.prototype.unWireEvent=function(){t.EventHandler.remove(this.inputWrapper.container,"mousedown",this.dropDownClick),t.EventHandler.remove(this.inputWrapper.container,"keypress",this.onSearch),t.EventHandler.remove(this.inputWrapper.container,"focus",this.focusIn),this.unBindCommonEvent()},s.prototype.unWireListEvents=function(){t.EventHandler.remove(this.list,"click",this.onMouseClick),t.EventHandler.remove(this.list,"mouseover",this.onMouseOver),t.EventHandler.remove(this.list,"mouseout",this.onMouseLeave)},s.prototype.checkSelector=function(e){return'[id="'+e.replace(/(:|\.|\[|\]|,|=|@|\\|\/|#)/g,"\\$1")+'"]'},s.prototype.onDocumentClick=function(e){var i=e.target;if(!t.isNullOrUndefined(this.popupObj)&&t.closest(i,this.checkSelector(this.popupObj.element.id))||this.inputWrapper.container.contains(e.target))i===this.inputElement||this.allowFiltering&&i===this.filterInput||"combobox"===this.getModuleName()&&!this.allowFiltering&&t.Browser.isDevice&&i===this.inputWrapper.buttons[0]||(this.isPreventBlur=(t.Browser.isIE||"edge"===t.Browser.info.name)&&(document.activeElement===this.targetElement()||document.activeElement===this.filterInput),e.preventDefault());else if(this.inputWrapper.container.classList.contains(N.inputFocus)||this.isPopupOpen){this.isDocumentClick=!0;var s=this.isRequested;this.isInteracted=!1,this.hidePopup(e),s||(this.onFocusOut(),this.inputWrapper.container.classList.remove(N.inputFocus))}},s.prototype.activeStateChange=function(){this.isDocumentClick&&(this.hidePopup(),this.onFocusOut(),this.inputWrapper.container.classList.remove(N.inputFocus))},s.prototype.focusDropDown=function(e){!this.initial&&this.isFilterLayout()&&this.focusIn(e)},s.prototype.dropDownClick=function(e){if(3!==e.which&&2!==e.button&&!this.targetElement().classList.contains(N.disable)&&this.inputWrapper.clearButton!==e.target){var t=e.target;if(t===this.inputElement||this.allowFiltering&&t===this.filterInput||"combobox"===this.getModuleName()||e.preventDefault(),this.readonly)this.focusIn(e);else{this.isPopupOpen?(this.hidePopup(),this.isFilterLayout()&&this.focusDropDown(e)):(this.focusIn(e),this.floatLabelChange(),this.queryString=""===this.inputElement.value.trim()?null:this.inputElement.value,this.isDropDownClick=!0,this.showPopup());var i=this,s=this.element.tagName===this.getNgDirective()&&this.itemTemplate?500:100;this.isSecondClick||setTimeout(function(){i.cloneElements(),i.isSecondClick=!0},s)}}},s.prototype.cloneElements=function(){if(this.list){var e=this.list.querySelector("ul");e&&(e=e.cloneNode?e.cloneNode(!0):e,this.actionCompleteData.ulElement=e)}},s.prototype.updateSelectedItem=function(e,i,s,l){var n=this;this.removeSelection(),e.classList.add(I.selected),this.removeHover();var o=this.getFormattedValue(e.getAttribute("data-value")),r=this.getDataByValue(o);if(this.initial||s||t.isNullOrUndefined(i))this.selectEventCallback(e,i,s,r,o),l&&this.setSelectOptions(e,i);else{var a=this.detachChanges(r);this.isSelected=!0;var h={e:i,item:e,itemData:a,isInteracted:!!i,cancel:!1};this.trigger("select",h,function(t){t.cancel?e.classList.remove(I.selected):(n.selectEventCallback(e,i,s,r,o),l&&n.setSelectOptions(e,i))})}},s.prototype.selectEventCallback=function(e,i,s,l,n){this.previousItemData=t.isNullOrUndefined(this.itemData)?null:this.itemData,this.item=e,this.itemData=l;var o=this.list.querySelector("."+I.focus);o&&t.removeClass([o],I.focus),e.setAttribute("aria-selected","true"),this.activeIndex=this.getIndexByValue(n)},s.prototype.activeItem=function(e){this.isValidLI(e)&&!e.classList.contains(I.selected)&&(this.removeSelection(),e.classList.add(I.selected),this.removeHover(),e.setAttribute("aria-selected","true"))},s.prototype.setValue=function(e){var i=this.getItemData();null===i.value?n.Input.setValue(null,this.inputElement,this.floatLabelType,this.showClearButton):n.Input.setValue(i.text,this.inputElement,this.floatLabelType,this.showClearButton),this.valueTemplate&&null!==this.itemData?this.setValueTemplate():t.isNullOrUndefined(this.valueTempElement)||this.inputElement.previousSibling!==this.valueTempElement||(t.detach(this.valueTempElement),this.inputElement.style.display="block");var s=N.clearIcon,l=this.isFiltering()&&this.filterInput&&"combobox"===this.getModuleName()&&this.filterInput.parentElement.querySelector("."+s);return this.isFiltering()&&l&&l.style.removeProperty("visibility"),this.previousValue===i.value?(this.isSelected=!1,!0):(this.isSelected=!this.initial,this.isSelectCustom=!1,"dropdownlist"===this.getModuleName()&&this.updateIconState(),!1)},s.prototype.setSelection=function(e,t){this.isValidLI(e)&&(!e.classList.contains(I.selected)||this.isPopupOpen&&this.isSelected&&e.classList.contains(I.selected))?this.updateSelectedItem(e,t,!1,!0):this.setSelectOptions(e,t)},s.prototype.setSelectOptions=function(e,i){this.list&&this.removeHover(),this.previousSelectedLI=t.isNullOrUndefined(this.selectedLI)?null:this.selectedLI,this.selectedLI=e,this.setValue(i)||(this.isPopupOpen&&(t.attributes(this.targetElement(),{"aria-activedescendant":this.selectedLI?this.selectedLI.id:null}),this.isFilterLayout()&&this.filterInput&&t.attributes(this.filterInput,{"aria-activedescendant":this.selectedLI?this.selectedLI.id:null})),(!this.isPopupOpen&&!t.isNullOrUndefined(e)||this.isPopupOpen&&!t.isNullOrUndefined(i)&&("keydown"!==i.type||"keydown"===i.type&&"enter"===i.action))&&(this.isSelectCustom=!1,this.onChangeEvent(i)),!this.isPopupOpen||t.isNullOrUndefined(this.selectedLI)||null===this.itemData||i&&"click"===i.type||this.setScrollPosition(i),"mozilla"!==t.Browser.info.name&&(t.attributes(this.inputElement,{"aria-label":this.inputElement.value}),t.attributes(this.targetElement(),{"aria-describedby":this.inputElement.id}),this.targetElement().removeAttribute("aria-live")))},s.prototype.dropdownCompiler=function(e){var t=!1;if(e)try{t=!!document.querySelectorAll(e).length}catch(e){t=!1}return t},s.prototype.setValueTemplate=function(){this.isReact&&this.clearTemplate(["valueTemplate"]),this.valueTempElement||(this.valueTempElement=this.createElement("span",{className:N.value}),this.inputElement.parentElement.insertBefore(this.valueTempElement,this.inputElement),this.inputElement.style.display="none"),this.valueTempElement.innerHTML="";var e=(this.dropdownCompiler(this.valueTemplate)?t.compile(document.querySelector(this.valueTemplate).innerHTML.trim()):t.compile(this.valueTemplate))(this.itemData,this,"valueTemplate",this.valueTemplateId,this.isStringTemplate,null,this.valueTempElement);if(e&&e.length>0)for(var i=0;i<e.length;i++)this.valueTempElement.appendChild(e[i]);this.renderReactTemplates()},s.prototype.removeSelection=function(){if(this.list){var e=this.list.querySelectorAll("."+I.selected);e.length&&(t.removeClass(e,I.selected),e[0].removeAttribute("aria-selected"))}},s.prototype.getItemData=function(){var e=this.fields,i=null;i=this.itemData;var s,l;t.isNullOrUndefined(i)||(s=t.getValue(e.value,i),l=t.getValue(e.text,i));return{value:t.isNullOrUndefined(i)||t.isUndefined(s)?i:s,text:t.isNullOrUndefined(i)||t.isUndefined(s)?i:l}},s.prototype.onChangeEvent=function(e){var t=this.getItemData(),i=this.isSelectCustom?null:this.activeIndex;this.setProperties({index:i,text:t.text,value:t.value},!0),this.detachChangeEvent(e)},s.prototype.detachChanges=function(e){return"string"==typeof e||"boolean"==typeof e||"number"==typeof e?Object.defineProperties({},{value:{value:e,enumerable:!0},text:{value:e,enumerable:!0}}):e},s.prototype.detachChangeEvent=function(e){if(this.isSelected=!1,this.previousValue=this.value,this.activeIndex=this.index,this.typedString=t.isNullOrUndefined(this.text)?"":this.text,!this.initial){var i=this.detachChanges(this.itemData),s=void 0;s="string"==typeof this.previousItemData||"boolean"==typeof this.previousItemData||"number"==typeof this.previousItemData?Object.defineProperties({},{value:{value:this.previousItemData,enumerable:!0},text:{value:this.previousItemData,enumerable:!0}}):this.previousItemData,this.setHiddenValue();var l={e:e,item:this.item,itemData:i,previousItem:this.previousSelectedLI,previousItemData:s,isInteracted:!!e,value:this.value,element:this.element,event:e};this.isAngular&&this.preventChange?this.preventChange=!1:this.trigger("change",l)}!t.isNullOrUndefined(this.value)&&""!==this.value||"Always"===this.floatLabelType||t.removeClass([this.inputWrapper.container],"e-valid-input")},s.prototype.setHiddenValue=function(){if(t.isNullOrUndefined(this.value))this.hiddenElement.innerHTML="";else if(this.hiddenElement.querySelector("option")){(e=this.hiddenElement.querySelector("option")).textContent=this.text,e.setAttribute("value",this.value.toString())}else{this.hiddenElement.innerHTML="<option selected>"+this.text+"</option>";var e;(e=this.hiddenElement.querySelector("option")).setAttribute("value",this.value.toString())}},s.prototype.onFilterUp=function(e){if(e.ctrlKey&&86===e.keyCode||!this.isValidKey&&40!==e.keyCode&&38!==e.keyCode)this.isValidKey=!1;else switch(this.isValidKey=!1,e.keyCode){case 38:case 40:"autocomplete"!==this.getModuleName()||this.isPopupOpen||this.preventAltUp||this.isRequested?this.preventAutoFill=!1:(this.preventAutoFill=!0,this.searchLists(e)),this.preventAltUp=!1,e.preventDefault();break;case 46:case 8:this.typedString=this.filterInput.value,!this.isPopupOpen&&""!==this.typedString||this.isPopupOpen&&this.queryString.length>0?(this.preventAutoFill=!0,this.searchLists(e)):""===this.typedString&&""===this.queryString&&"autocomplete"!==this.getModuleName()?(this.preventAutoFill=!0,this.searchLists(e)):""===this.typedString&&(this.list&&this.resetFocusElement(),this.activeIndex=null,"dropdownlist"!==this.getModuleName()&&(this.preventAutoFill=!0,this.searchLists(e),"autocomplete"===this.getModuleName()&&this.hidePopup())),e.preventDefault();break;default:this.typedString=this.filterInput.value,this.preventAutoFill=!1,this.searchLists(e)}},s.prototype.onFilterDown=function(e){switch(e.keyCode){case 13:break;case 40:case 38:this.queryString=this.filterInput.value,e.preventDefault();break;case 9:this.isPopupOpen&&"autocomplete"!==this.getModuleName()&&e.preventDefault();break;default:this.prevSelectPoints=this.getSelectionPoints(),this.queryString=this.filterInput.value}},s.prototype.removeFillSelection=function(){if(this.isInteracted){var e=this.getSelectionPoints();this.inputElement.setSelectionRange(e.end,e.end)}},s.prototype.getQuery=function(e){var t;if(!this.isCustomFilter&&this.allowFiltering&&this.filterInput){t=e?e.clone():this.query?this.query.clone():new i.Query;var s=""===this.typedString?"contains":this.filterType,l=this.typeOfData(this.dataSource).typeof;if((this.dataSource instanceof i.DataManager||"string"!==l)&&"number"!==l){var n=this.fields.text?this.fields.text:"";t.where(n,s,this.typedString,this.ignoreCase,this.ignoreAccent)}else t.where("",s,this.typedString,this.ignoreCase,this.ignoreAccent)}else t=e?e.clone():this.query?this.query.clone():new i.Query;return t},s.prototype.getSelectionPoints=function(){var e=this.inputElement;return{start:Math.abs(e.selectionStart),end:Math.abs(e.selectionEnd)}},s.prototype.searchLists=function(e){var t=this;if(this.isTyped=!0,this.activeIndex=null,this.isListSearched=!0,this.filterInput.parentElement.querySelector("."+N.clearIcon)){this.filterInput.parentElement.querySelector("."+N.clearIcon).style.visibility=""===this.filterInput.value?"hidden":"visible"}if(this.isDataFetched=!1,this.isFiltering()){var i={preventDefaultAction:!1,text:this.filterInput.value,updateData:function(e,s,l){i.cancel||(t.isCustomFilter=!0,t.filteringAction(e,s,l))},baseEventArgs:e,cancel:!1};this.trigger("filtering",i,function(e){e.cancel||t.isCustomFilter||e.preventDefaultAction||t.filteringAction(t.dataSource,null,t.fields)})}},s.prototype.filter=function(e,t,i){this.isCustomFilter=!0,this.filteringAction(e,t,i)},s.prototype.filteringAction=function(e,i,s){t.isNullOrUndefined(this.filterInput)||(this.beforePopupOpen=!(!this.isPopupOpen&&"combobox"===this.getModuleName()&&""===this.filterInput.value),""!==this.filterInput.value.trim()||this.itemTemplate?(this.isNotSearchList=!1,i=""===this.filterInput.value.trim()?null:i,this.resetList(e,s,i)):(this.actionCompleteData.isUpdated=!1,this.isTyped=!1,t.isNullOrUndefined(this.actionCompleteData.ulElement)||t.isNullOrUndefined(this.actionCompleteData.list)||this.onActionComplete(this.actionCompleteData.ulElement,this.actionCompleteData.list),this.isTyped=!0,t.isNullOrUndefined(this.itemData)||"dropdownlist"!==this.getModuleName()||(this.focusIndexItem(),this.setScrollPosition()),this.isNotSearchList=!0),this.renderReactTemplates())},s.prototype.setSearchBox=function(e){if(this.isFiltering()){var i=e.querySelector("."+N.filterParent)?e.querySelector("."+N.filterParent):this.createElement("span",{className:N.filterParent});this.filterInput=this.createElement("input",{attrs:{type:"text"},className:N.filterInput}),this.element.parentNode.insertBefore(this.filterInput,this.element);var s=!1;return t.Browser.isDevice&&(s=!0),this.filterInputObj=n.Input.createInput({element:this.filterInput,buttons:s?[N.backIcon,N.filterBarClearIcon]:[N.filterBarClearIcon],properties:{placeholder:this.filterBarPlaceholder}},this.createElement),t.isNullOrUndefined(this.cssClass)||(-1!==this.cssClass.split(" ").indexOf("e-outline")?t.addClass([this.filterInputObj.container],"e-outline"):-1!==this.cssClass.split(" ").indexOf("e-filled")&&t.addClass([this.filterInputObj.container],"e-filled")),t.append([this.filterInputObj.container],i),t.prepend([i],e),t.attributes(this.filterInput,{"aria-disabled":"false","aria-owns":this.element.id+"_options",role:"listbox","aria-activedescendant":this.selectedLI?this.selectedLI.id:null,autocomplete:"off",autocorrect:"off",autocapitalize:"off",spellcheck:"false"}),this.clearIconElement=this.filterInput.parentElement.querySelector("."+N.clearIcon),!t.Browser.isDevice&&this.clearIconElement&&(t.EventHandler.add(this.clearIconElement,"click",this.clearText,this),this.clearIconElement.style.visibility="hidden"),t.Browser.isDevice?this.searchKeyModule=new t.KeyboardEvents(this.filterInput,{keyAction:this.mobileKeyActionHandler.bind(this),keyConfigs:this.keyConfigure,eventName:"keydown"}):this.searchKeyModule=new t.KeyboardEvents(this.filterInput,{keyAction:this.keyActionHandler.bind(this),keyConfigs:this.keyConfigure,eventName:"keydown"}),t.EventHandler.add(this.filterInput,"input",this.onInput,this),t.EventHandler.add(this.filterInput,"keyup",this.onFilterUp,this),t.EventHandler.add(this.filterInput,"keydown",this.onFilterDown,this),t.EventHandler.add(this.filterInput,"blur",this.onBlurHandler,this),t.EventHandler.add(this.filterInput,"paste",this.pasteHandler,this),this.filterInputObj}return P},s.prototype.onInput=function(e){this.isValidKey=!0,t.Browser.isDevice&&"mozilla"===t.Browser.info.name&&(this.typedString=this.filterInput.value,this.preventAutoFill=!0,this.searchLists(e))},s.prototype.pasteHandler=function(e){var t=this;setTimeout(function(){t.typedString=t.filterInput.value,t.searchLists(e)})},s.prototype.onActionFailure=function(t){e.prototype.onActionFailure.call(this,t),this.beforePopupOpen&&this.renderPopup()},s.prototype.onActionComplete=function(s,l,n,o){var r=this;if(this.isNotSearchList)this.isNotSearchList=!1;else if(this.isActive){var a=this.selectedLI?this.selectedLI.cloneNode(!0):null;if(e.prototype.onActionComplete.call(this,s,l,n),this.updateSelectElementData(this.allowFiltering),this.isRequested&&!t.isNullOrUndefined(this.searchKeyEvent)&&"keydown"===this.searchKeyEvent.type&&(this.isRequested=!1,this.keyActionHandler(this.searchKeyEvent),this.searchKeyEvent=null),this.isRequested&&!t.isNullOrUndefined(this.searchKeyEvent)&&(this.incrementalSearch(this.searchKeyEvent),this.searchKeyEvent=null),this.list.scrollTop=0,t.isNullOrUndefined(s)||t.attributes(s,{id:this.element.id+"_options",role:"listbox","aria-hidden":"false"}),this.initRemoteRender&&(this.initial=!0,this.activeIndex=this.index,this.updateValues(),this.initRemoteRender=!1,this.initial=!1,this.value&&this.dataSource instanceof i.DataManager)){var h=t.isNullOrUndefined(this.fields.value)?this.fields.text:this.fields.value;l.some(function(e){return e[h]===r.value})||this.dataSource.executeQuery(this.getQuery(this.query).where(new i.Predicate(h,"equal",this.value))).then(function(e){e.result.length>0&&(r.addItem(e.result,l.length),r.updateValues())})}"autocomplete"!==this.getModuleName()&&this.isFiltering()&&!this.isTyped&&((!this.actionCompleteData.isUpdated||!this.isCustomFilter&&!this.isFilterFocus||t.isNullOrUndefined(this.itemData)&&this.allowFiltering&&(this.dataSource instanceof i.DataManager||!t.isNullOrUndefined(this.dataSource)&&!t.isNullOrUndefined(this.dataSource.length)&&0!==this.dataSource.length))&&(this.itemTemplate&&"EJS-COMBOBOX"===this.element.tagName&&this.allowFiltering?setTimeout(function(){r.updateActionCompleteDataValues(s,l)},0):this.updateActionCompleteDataValues(s,l)),this.addNewItem(l,a),t.isNullOrUndefined(this.itemData)||this.focusIndexItem()),this.beforePopupOpen&&this.renderPopup()}},s.prototype.updateActionCompleteDataValues=function(e,i){this.actionCompleteData={ulElement:e.cloneNode(!0),list:i,isUpdated:!0},t.isNullOrUndefined(this.actionData.ulElement)&&t.isNullOrUndefined(this.actionData.list)&&(this.actionData=this.actionCompleteData)},s.prototype.addNewItem=function(e,i){var s=this;if(!t.isNullOrUndefined(this.itemData)&&!t.isNullOrUndefined(i)){var l=this.getItemData().value;e.some(function(e){return("string"==typeof e||"number"==typeof e)&&e===l||t.getValue(s.fields.value,e)===l})||this.addItem(this.itemData)}},s.prototype.updateActionCompleteData=function(e,t,i){var s=this;"autocomplete"!==this.getModuleName()&&this.actionCompleteData.ulElement&&(this.itemTemplate&&"EJS-COMBOBOX"===this.element.tagName&&this.allowFiltering?setTimeout(function(){s.actionCompleteDataUpdate(e,t,i)},0):this.actionCompleteDataUpdate(e,t,i))},s.prototype.actionCompleteDataUpdate=function(e,t,i){null!=i?this.actionCompleteData.ulElement.insertBefore(e.cloneNode(!0),this.actionCompleteData.ulElement.childNodes[i]):this.actionCompleteData.ulElement.appendChild(e.cloneNode(!0)),this.isFiltering()&&this.actionCompleteData.list.indexOf(t)<0&&this.actionCompleteData.list.push(t)},s.prototype.focusIndexItem=function(){var e=this.getItemData().value;this.activeIndex=this.getIndexByValue(e);var t=this.findListElement(this.list,"li","data-value",e);this.selectedLI=t,this.activeItem(t),this.removeFocus()},s.prototype.updateSelection=function(){var e=this.list.querySelector("."+I.selected);e?(this.setProperties({index:this.getIndexByValue(e.getAttribute("data-value"))}),this.activeIndex=this.index):(this.removeFocus(),this.list.querySelector("."+I.li).classList.add(N.focus))},s.prototype.removeFocus=function(){var e=this.list.querySelectorAll("."+N.focus);e&&e.length&&t.removeClass(e,N.focus)},s.prototype.renderPopup=function(){var e=this;if(this.popupObj&&document.body.contains(this.popupObj.element))this.refreshPopup();else{this.trigger("beforeOpen",{cancel:!1},function(i){if(i.cancel)e.beforePopupOpen=!1;else{var s=e.createElement("div",{id:e.element.id+"_popup",className:"e-ddl e-popup "+(null!=e.cssClass?e.cssClass:"")}),l=e.setSearchBox(s);if(e.listHeight=t.formatUnit(e.popupHeight),e.headerTemplate&&e.setHeaderTemplate(s),t.append([e.list],s),e.footerTemplate&&e.setFooterTemplate(s),document.body.appendChild(s),s.style.visibility="hidden","auto"!==e.popupHeight){if(e.searchBoxHeight=0,t.isNullOrUndefined(l.container)||(e.searchBoxHeight=l.container.parentElement.getBoundingClientRect().height,e.listHeight=(parseInt(e.listHeight,10)-e.searchBoxHeight).toString()+"px"),e.headerTemplate){e.header=e.header?e.header:s.querySelector(".e-ddl-header");var n=Math.round(e.header.getBoundingClientRect().height);e.listHeight=(parseInt(e.listHeight,10)-(n+e.searchBoxHeight)).toString()+"px"}if(e.footerTemplate){e.footer=e.footer?e.footer:s.querySelector(".e-ddl-footer");n=Math.round(e.footer.getBoundingClientRect().height);e.listHeight=(parseInt(e.listHeight,10)-(n+e.searchBoxHeight)).toString()+"px"}e.list.style.maxHeight=(parseInt(e.listHeight,10)-2).toString()+"px",s.style.maxHeight=t.formatUnit(e.popupHeight)}else s.style.height="auto";var o=0,r=void 0;if(!t.isNullOrUndefined(e.selectedLI)&&!t.isNullOrUndefined(e.activeIndex)&&e.activeIndex>=0?e.setScrollPosition():e.list.scrollTop=0,t.Browser.isDevice&&!e.allowFiltering&&("dropdownlist"===e.getModuleName()||e.isDropDownClick&&"combobox"===e.getModuleName())){o=e.getOffsetValue(s);var a=e.isEmptyList()?e.list:e.liCollections[0];r=-(parseInt(getComputedStyle(a).textIndent,10)-parseInt(getComputedStyle(e.inputElement).paddingLeft,10)+parseInt(getComputedStyle(e.inputElement.parentElement).borderLeftWidth,10))}e.getFocusElement(),e.createPopup(s,o,r),e.checkCollision(s),t.Browser.isDevice&&(e.popupObj.element.classList.add(N.device),("dropdownlist"===e.getModuleName()||"combobox"===e.getModuleName()&&!e.allowFiltering&&e.isDropDownClick)&&(e.popupObj.collision={X:"fit",Y:"fit"}),e.isFilterLayout()&&(e.popupObj.element.classList.add(N.mobileFilter),e.popupObj.position={X:0,Y:0},e.popupObj.dataBind(),t.attributes(e.popupObj.element,{style:"left:0px;right:0px;top:0px;bottom:0px;"}),t.addClass([document.body,e.popupObj.element],N.popupFullScreen),e.setSearchBoxPosition(),e.backIconElement=l.container.querySelector(".e-back-icon"),e.clearIconElement=l.container.querySelector("."+N.clearIcon),t.EventHandler.add(e.backIconElement,"click",e.clickOnBackIcon,e),t.EventHandler.add(e.clearIconElement,"click",e.clearText,e))),s.style.visibility="visible",t.addClass([s],"e-popup-close");for(var h=0,p=e.popupObj.getScrollableParent(e.inputWrapper.container);h<p.length;h++){var u=p[h];t.EventHandler.add(u,"scroll",e.scrollHandler,e)}t.Browser.isDevice&&e.isFilterLayout()&&t.EventHandler.add(e.list,"scroll",e.listScroll,e),t.isNullOrUndefined(e.list)||(e.unWireListEvents(),e.wireListEvents()),t.attributes(e.targetElement(),{"aria-expanded":"true"});var c=e.isFiltering()?e.filterInput.parentElement:e.inputWrapper.container;t.addClass([c],[N.inputFocus]);e.beforePopupOpen=!0;var d={popup:e.popupObj,cancel:!1,animation:{name:"FadeIn",duration:100}};e.trigger("open",d,function(i){i.cancel?(e.beforePopupOpen=!1,e.destroyPopup()):(t.addClass([e.inputWrapper.container],[N.iconAnimation]),e.renderReactTemplates(),e.popupObj.show(new t.Animation(i.animation),1e3===e.zIndex?e.element:null))})}})}},s.prototype.checkCollision=function(e){if(!t.Browser.isDevice||t.Browser.isDevice&&"dropdownlist"!==this.getModuleName()&&!this.isDropDownClick){l.isCollide(e).length>0&&(e.style.marginTop=-parseInt(getComputedStyle(e).marginTop,10)+"px"),this.popupObj.resolveCollision()}},s.prototype.getOffsetValue=function(e){var t=getComputedStyle(e),i=parseInt(t.borderTopWidth,10),s=parseInt(t.borderBottomWidth,10);return this.setPopupPosition(i+s)},s.prototype.createPopup=function(e,i,s){var n=this;this.popupObj=new l.Popup(e,{width:this.setWidth(),targetType:"relative",relateTo:this.inputWrapper.container,collision:{X:"flip",Y:"flip"},offsetY:i,enableRtl:this.enableRtl,offsetX:s,position:{X:"left",Y:"bottom"},zIndex:this.zIndex,close:function(){n.isDocumentClick||n.focusDropDown(),n.isReact&&n.clearTemplate(["headerTemplate","footerTemplate"]);n.getModuleName();n.isNotSearchList=!1,n.isDocumentClick=!1,n.destroyPopup(),n.isFiltering()&&n.actionCompleteData.list&&n.actionCompleteData.list[0]&&(n.isActive=!0,n.onActionComplete(n.actionCompleteData.ulElement,n.actionCompleteData.list,null,!0))},open:function(){t.EventHandler.add(document,"mousedown",n.onDocumentClick,n),n.isPopupOpen=!0;var e=n.actionCompleteData&&n.actionCompleteData.ulElement&&n.actionCompleteData.ulElement.querySelector("li"),i=n.list.querySelector("ul li");n.isFiltering()&&n.itemTemplate&&n.element.tagName===n.getNgDirective()&&e&&i&&e.textContent!==i.textContent&&"EJS-COMBOBOX"!==n.element.tagName&&n.cloneElements(),n.isFilterLayout()&&(t.removeClass([n.inputWrapper.container],[N.inputFocus]),n.isFilterFocus=!0,n.filterInput.focus(),n.inputWrapper.clearButton&&t.addClass([n.inputWrapper.clearButton],N.clearIconHide)),n.activeStateChange()},targetExitViewport:function(){t.Browser.isDevice||n.hidePopup()}})},s.prototype.isEmptyList=function(){return!t.isNullOrUndefined(this.liCollections)&&0===this.liCollections.length},s.prototype.getFocusElement=function(){},s.prototype.isFilterLayout=function(){return"dropdownlist"===this.getModuleName()&&this.allowFiltering},s.prototype.scrollHandler=function(){t.Browser.isDevice&&("dropdownlist"===this.getModuleName()&&!this.isFilterLayout()||"combobox"===this.getModuleName()&&!this.allowFiltering&&this.isDropDownClick)&&this.hidePopup()},s.prototype.setSearchBoxPosition=function(){var e=this.filterInput.parentElement.getBoundingClientRect().height;this.popupObj.element.style.maxHeight="100%",this.popupObj.element.style.width="100%",this.list.style.maxHeight=window.innerHeight-e+"px",this.list.style.height=window.innerHeight-e+"px";var i=this.filterInput.parentElement.querySelector("."+N.clearIcon);t.detach(this.filterInput),i.parentElement.insertBefore(this.filterInput,i)},s.prototype.setPopupPosition=function(e){var i,s=e,l=this.list.querySelector("."+N.focus)||this.selectedLI,n=this.isEmptyList()?this.list:this.liCollections[0],o=this.isEmptyList()?this.list:this.liCollections[this.getItems().length-1],r=n.getBoundingClientRect().height,a=this.list.offsetHeight/2,h=t.isNullOrUndefined(l)?n.offsetTop:l.offsetTop;if(o.offsetTop-a<h&&!t.isNullOrUndefined(this.liCollections)&&this.liCollections.length>0&&!t.isNullOrUndefined(l)){var p=this.list.offsetHeight/r,u=parseInt(getComputedStyle(this.list).paddingBottom,10);i=(p-(this.liCollections.length-this.activeIndex))*r-s+u,this.list.scrollTop=l.offsetTop}else h>a?(i=a-r/2,this.list.scrollTop=h-a+r/2):i=h;return-(i=i+r+s-(r-this.inputWrapper.container.offsetHeight)/2)},s.prototype.setWidth=function(){var e=t.formatUnit(this.popupWidth);if(e.indexOf("%")>-1){e=(this.inputWrapper.container.offsetWidth*parseFloat(e)/100).toString()+"px"}if(t.Browser.isDevice&&!this.allowFiltering&&("dropdownlist"===this.getModuleName()||this.isDropDownClick&&"combobox"===this.getModuleName())){var i=this.isEmptyList()?this.list:this.liCollections[0];e=parseInt(e,10)+2*(parseInt(getComputedStyle(i).textIndent,10)-parseInt(getComputedStyle(this.inputElement).paddingLeft,10)+parseInt(getComputedStyle(this.inputElement.parentElement).borderLeftWidth,10))+"px"}return e},s.prototype.scrollBottom=function(e){if(!t.isNullOrUndefined(this.selectedLI)){var i=this.list.offsetHeight,s=this.selectedLI.offsetTop+this.selectedLI.offsetHeight-this.list.scrollTop,l=this.list.scrollTop+s-i;l=e?l+2*parseInt(getComputedStyle(this.list).paddingTop,10):l;var n=this.selectedLI.offsetTop+this.selectedLI.offsetHeight-this.list.scrollTop;n=this.fields.groupBy&&!t.isNullOrUndefined(this.fixedHeaderElement)?n-this.fixedHeaderElement.offsetHeight:n,0===this.activeIndex?this.list.scrollTop=0:(s>i||!(n>0&&this.list.offsetHeight>n))&&(this.list.scrollTop=l)}},s.prototype.scrollTop=function(){if(!t.isNullOrUndefined(this.selectedLI)){var e=this.selectedLI.offsetTop-this.list.scrollTop;e=this.fields.groupBy&&!t.isNullOrUndefined(this.fixedHeaderElement)?e-this.fixedHeaderElement.offsetHeight:e;var i=this.selectedLI.offsetTop+this.selectedLI.offsetHeight-this.list.scrollTop;0===this.activeIndex?this.list.scrollTop=0:e<0?this.list.scrollTop=this.list.scrollTop+e:i>0&&this.list.offsetHeight>i||(this.list.scrollTop=this.selectedLI.offsetTop-(this.fields.groupBy&&!t.isNullOrUndefined(this.fixedHeaderElement)?this.fixedHeaderElement.offsetHeight:0))}},s.prototype.isEditTextBox=function(){return!1},s.prototype.isFiltering=function(){return this.allowFiltering},s.prototype.isPopupButton=function(){return!0},s.prototype.setScrollPosition=function(e){if(t.isNullOrUndefined(e))this.scrollBottom(!0);else switch(e.action){case"pageDown":case"down":case"end":this.scrollBottom();break;default:this.scrollTop()}},s.prototype.clearText=function(){this.filterInput.value=this.typedString="",this.searchLists(null)},s.prototype.listScroll=function(){this.filterInput.blur()},s.prototype.setEleWidth=function(e){t.isNullOrUndefined(e)||("number"==typeof e?this.inputWrapper.container.style.width=t.formatUnit(e):"string"==typeof e&&(this.inputWrapper.container.style.width=e.match(/px|%|em/)?e:t.formatUnit(e)))},s.prototype.closePopup=function(e){var i=this;if(this.isTyped=!1,this.popupObj&&document.body.contains(this.popupObj.element)&&this.beforePopupOpen){t.EventHandler.remove(document,"mousedown",this.onDocumentClick),this.isActive=!1,this.filterInputObj=null,this.isDropDownClick=!1,this.preventAutoFill=!1;for(var s=0,l=this.popupObj.getScrollableParent(this.inputWrapper.container);s<l.length;s++){var n=l[s];t.EventHandler.remove(n,"scroll",this.scrollHandler)}t.Browser.isDevice&&this.isFilterLayout()&&(t.removeClass([document.body,this.popupObj.element],N.popupFullScreen),t.EventHandler.remove(this.list,"scroll",this.listScroll)),this.isFilterLayout()&&(t.Browser.isDevice||(this.searchKeyModule.destroy(),this.clearIconElement&&t.EventHandler.remove(this.clearIconElement,"click",this.clearText)),this.backIconElement&&(t.EventHandler.remove(this.backIconElement,"click",this.clickOnBackIcon),t.EventHandler.remove(this.clearIconElement,"click",this.clearText)),t.EventHandler.remove(this.filterInput,"input",this.onInput),t.EventHandler.remove(this.filterInput,"keyup",this.onFilterUp),t.EventHandler.remove(this.filterInput,"keydown",this.onFilterDown),t.EventHandler.remove(this.filterInput,"blur",this.onBlurHandler),t.EventHandler.remove(this.filterInput,"paste",this.pasteHandler),this.filterInput=null),t.attributes(this.targetElement(),{"aria-expanded":"false","aria-activedescendant":null}),this.inputWrapper.container.classList.remove(N.iconAnimation),this.isFiltering()&&(this.actionCompleteData.isUpdated=!1),this.beforePopupOpen=!1;var o={name:"FadeOut",duration:100,delay:e||0},r={popup:this.popupObj,cancel:!1,animation:o};this.trigger("close",r,function(e){if(!t.isNullOrUndefined(i.popupObj)&&!t.isNullOrUndefined(i.popupObj.element.querySelector(".e-fixed-head"))){var s=i.popupObj.element.querySelector(".e-fixed-head");s.parentNode.removeChild(s),i.fixedHeaderElement=null}e.cancel||("autocomplete"===i.getModuleName()&&i.rippleFun(),i.isPopupOpen?i.popupObj.hide(new t.Animation(e.animation)):i.destroyPopup())})}},s.prototype.destroyPopup=function(){this.isPopupOpen=!1,this.isFilterFocus=!1,this.popupObj.destroy(),t.detach(this.popupObj.element)},s.prototype.clickOnBackIcon=function(){this.hidePopup(),this.focusIn()},s.prototype.render=function(){"INPUT"===this.element.tagName?(this.inputElement=this.element,t.isNullOrUndefined(this.inputElement.getAttribute("role"))&&this.inputElement.setAttribute("role","textbox"),t.isNullOrUndefined(this.inputElement.getAttribute("type"))&&this.inputElement.setAttribute("type","text")):(this.inputElement=this.createElement("input",{attrs:{role:"textbox",type:"text"}}),this.element.tagName!==this.getNgDirective()&&(this.element.style.display="none"),this.element.parentElement.insertBefore(this.inputElement,this.element),this.preventTabIndex(this.inputElement));var e=this.cssClass;t.isNullOrUndefined(this.cssClass)||""===this.cssClass||(e=this.cssClass.replace(/\s+/g," ").trim()),this.inputWrapper=n.Input.createInput({element:this.inputElement,buttons:this.isPopupButton()?[N.icon]:null,floatLabelType:this.floatLabelType,properties:{readonly:"dropdownlist"===this.getModuleName()||this.readonly,placeholder:this.placeholder,cssClass:e,enabled:this.enabled,enableRtl:this.enableRtl,showClearButton:this.showClearButton}},this.createElement),this.element.tagName===this.getNgDirective()?this.element.appendChild(this.inputWrapper.container):this.inputElement.parentElement.insertBefore(this.element,this.inputElement),this.hiddenElement=this.createElement("select",{attrs:{"aria-hidden":"true",tabindex:"-1",class:N.hiddenElement}}),t.prepend([this.hiddenElement],this.inputWrapper.container),this.validationAttribute(this.element,this.hiddenElement),this.setReadOnly(),this.setFields(),this.inputWrapper.container.style.width=t.formatUnit(this.width),this.inputWrapper.container.classList.add("e-ddl"),this.wireEvent(),this.tabIndex=this.element.hasAttribute("tabindex")?this.element.getAttribute("tabindex"):"0",this.element.removeAttribute("tabindex");var i=this.element.getAttribute("id")?this.element.getAttribute("id"):t.getUniqueID("ej2_dropdownlist");if(this.element.id=i,this.hiddenElement.id=i+"_hidden",this.targetElement().setAttribute("tabindex",this.tabIndex),t.attributes(this.targetElement(),this.getAriaAttributes()),this.updateDataAttribute(this.htmlAttributes),this.setHTMLAttributes(),null!==this.value||null!==this.activeIndex||null!==this.text)this.initValue();else if("SELECT"===this.element.tagName&&this.element.options[0]){var s=this.element;this.value=s.options[s.selectedIndex].value,this.text=t.isNullOrUndefined(this.value)?null:s.options[s.selectedIndex].textContent,this.initValue()}this.preventTabIndex(this.element),this.enabled||(this.targetElement().tabIndex=-1),this.initial=!1,this.element.style.opacity="",this.inputElement.onselect=function(e){e.stopImmediatePropagation()},this.inputElement.onchange=function(e){e.stopImmediatePropagation()},this.element.hasAttribute("autofocus")&&this.focusIn(),t.isNullOrUndefined(this.text)||this.inputElement.setAttribute("value",this.text),this.element.hasAttribute("data-val")&&this.element.setAttribute("data-val","false"),this.renderComplete()},s.prototype.setFooterTemplate=function(e){this.footer?this.footer.innerHTML="":(this.footer=this.createElement("div"),t.addClass([this.footer],N.footer));var i=(this.dropdownCompiler(this.footerTemplate)?t.compile(t.select(this.footerTemplate,document).innerHTML.trim()):t.compile(this.footerTemplate))({},this,"footerTemplate",this.footerTemplateId,this.isStringTemplate,null,this.footer);if(i&&i.length>0)for(var s=0;s<i.length;s++)this.footer.appendChild(i[s]);t.append([this.footer],e)},s.prototype.setHeaderTemplate=function(e){this.header?this.header.innerHTML="":(this.header=this.createElement("div"),t.addClass([this.header],N.header));var i=(this.dropdownCompiler(this.headerTemplate)?t.compile(t.select(this.headerTemplate,document).innerHTML.trim()):t.compile(this.headerTemplate))({},this,"headerTemplate",this.headerTemplateId,this.isStringTemplate,null,this.header);if(i&&i.length)for(var s=0;s<i.length;s++)this.header.appendChild(i[s]);var l=e.querySelector("div.e-content");e.insertBefore(this.header,l)},s.prototype.setOldText=function(e){this.text=e},s.prototype.setOldValue=function(e){this.value=e},s.prototype.refreshPopup=function(){t.isNullOrUndefined(this.popupObj)||!document.body.contains(this.popupObj.element)||(!this.allowFiltering||t.Browser.isDevice&&this.isFilterLayout())&&"autocomplete"!==this.getModuleName()||(t.removeClass([this.popupObj.element],"e-popup-close"),this.popupObj.refreshPosition(this.inputWrapper.container),this.popupObj.resolveCollision())},s.prototype.checkData=function(e){!e.dataSource||t.isNullOrUndefined(Object.keys(e.dataSource))||!this.itemTemplate||!this.allowFiltering||this.isListSearched&&e.dataSource instanceof i.DataManager||(this.list=null,this.actionCompleteData={ulElement:null,list:null,isUpdated:!1}),this.isListSearched=!1;var s=-1!==Object.keys(e).indexOf("value")&&t.isNullOrUndefined(e.value),l=-1!==Object.keys(e).indexOf("text")&&t.isNullOrUndefined(e.text);"autocomplete"!==this.getModuleName()&&this.allowFiltering&&(s||l)&&(this.itemData=null),this.allowFiltering&&e.dataSource&&!t.isNullOrUndefined(Object.keys(e.dataSource))?(this.actionCompleteData={ulElement:null,list:null,isUpdated:!1},this.actionData=this.actionCompleteData):this.allowFiltering&&e.query&&!t.isNullOrUndefined(Object.keys(e.query))&&(this.actionCompleteData="combobox"===this.getModuleName()?{ulElement:null,list:null,isUpdated:!1}:this.actionCompleteData,this.actionData=this.actionCompleteData)},s.prototype.updateDataSource=function(e){""===this.inputElement.value&&(t.isNullOrUndefined(e)||!t.isNullOrUndefined(e.dataSource)&&(e.dataSource instanceof i.DataManager||0!==e.dataSource.length))||this.clearAll(null,e),this.fields.groupBy&&e.fields&&!this.isGroupChecking&&(t.EventHandler.remove(this.list,"scroll",this.setFloatingHeader),t.EventHandler.add(this.list,"scroll",this.setFloatingHeader,this)),(t.isNullOrUndefined(e)||!t.isNullOrUndefined(e.dataSource)&&(e.dataSource instanceof i.DataManager||0!==e.dataSource.length)||e.dataSource!==[])&&(this.typedString="",this.resetList(this.dataSource)),this.isCustomFilter||this.isFilterFocus||document.activeElement===this.filterInput||this.checkCustomValue()},s.prototype.checkCustomValue=function(){this.itemData=this.getDataByValue(this.value);var e=this.getItemData();this.setProperties({text:e.text,value:e.value})},s.prototype.updateInputFields=function(){"dropdownlist"===this.getModuleName()&&n.Input.setValue(this.text,this.inputElement,this.floatLabelType,this.showClearButton)},s.prototype.onPropertyChanged=function(s,l){var o=this;"dropdownlist"===this.getModuleName()&&(this.checkData(s),this.setUpdateInitial(["fields","query","dataSource"],s));for(var r=function(r){switch(r){case"query":case"dataSource":break;case"htmlAttributes":a.setHTMLAttributes();break;case"width":a.setEleWidth(s.width);break;case"placeholder":n.Input.setPlaceholder(s.placeholder,a.inputElement);break;case"filterBarPlaceholder":a.filterInput&&n.Input.setPlaceholder(s.filterBarPlaceholder,a.filterInput);break;case"readonly":"dropdownlist"!==a.getModuleName()&&n.Input.setReadonly(s.readonly,a.inputElement),a.setReadOnly();break;case"cssClass":a.setCssClass(s.cssClass,l.cssClass);break;case"enableRtl":a.setEnableRtl();break;case"enabled":a.setEnable();break;case"text":if(null===s.text){a.clearAll();break}if(a.list||(a.dataSource instanceof i.DataManager&&(a.initRemoteRender=!0),a.renderList()),!a.initRemoteRender){var h=a.getElementByText(s.text);if(!a.checkValidLi(h))if(a.liCollections&&100===a.liCollections.length&&"autocomplete"===a.getModuleName()&&a.listData.length>100)a.setSelectionData(s.text,l.text,"text");else if(s.text&&a.dataSource instanceof i.DataManager){var p=a.getItems().length,u=t.isNullOrUndefined(a.fields.text)?a.fields.value:a.fields.text;a.typedString="",a.dataSource.executeQuery(a.getQuery(a.query).where(new i.Predicate(u,"equal",s.text))).then(function(e){e.result.length>0?(o.addItem(e.result,p),o.updateValues()):o.setOldText(l.text)})}else a.setOldText(l.text);a.updateInputFields()}break;case"value":if(null===s.value){a.clearAll();break}if(a.notify("beforeValueChange",{newProp:s}),a.list||(a.dataSource instanceof i.DataManager&&(a.initRemoteRender=!0),a.renderList()),!a.initRemoteRender){var c=a.getElementByValue(s.value);if(!a.checkValidLi(c))if(a.liCollections&&100===a.liCollections.length&&"autocomplete"===a.getModuleName()&&a.listData.length>100)a.setSelectionData(s.value,l.value,"value");else if(s.value&&a.dataSource instanceof i.DataManager){var d=a.getItems().length;u=t.isNullOrUndefined(a.fields.value)?a.fields.text:a.fields.value;a.typedString="",a.dataSource.executeQuery(a.getQuery(a.query).where(new i.Predicate(u,"equal",s.value))).then(function(e){e.result.length>0?(o.addItem(e.result,d),o.updateValues()):o.setOldValue(l.value)})}else a.setOldValue(l.value);a.updateInputFields(),a.preventChange=a.isAngular&&a.preventChange?!a.preventChange:a.preventChange}break;case"index":if(null===s.index){a.clearAll();break}if(a.list||(a.dataSource instanceof i.DataManager&&(a.initRemoteRender=!0),a.renderList()),!a.initRemoteRender&&a.liCollections){var m=a.liCollections[s.index];a.checkValidLi(m)||(a.liCollections&&100===a.liCollections.length&&"autocomplete"===a.getModuleName()&&a.listData.length>100?a.setSelectionData(s.index,l.index,"index"):a.index=l.index),a.updateInputFields()}break;case"footerTemplate":a.popupObj&&a.setFooterTemplate(a.popupObj.element);break;case"headerTemplate":a.popupObj&&a.setHeaderTemplate(a.popupObj.element);break;case"valueTemplate":t.isNullOrUndefined(a.itemData)||null==a.valueTemplate||a.setValueTemplate();break;case"allowFiltering":a.allowFiltering&&(a.actionCompleteData={ulElement:a.ulElement,list:a.listData,isUpdated:!0},a.actionData=a.actionCompleteData,a.updateSelectElementData(a.allowFiltering));break;case"floatLabelType":n.Input.removeFloating(a.inputWrapper),n.Input.addFloating(a.inputElement,s.floatLabelType,a.placeholder,a.createElement);break;case"showClearButton":n.Input.setClearButton(s.showClearButton,a.inputElement,a.inputWrapper,null,a.createElement),a.bindClearEvent();break;default:var f=a.getPropObject(r,s,l);e.prototype.onPropertyChanged.call(a,f.newProperty,f.oldProperty)}},a=this,h=0,p=Object.keys(s);h<p.length;h++){r(p[h])}},s.prototype.checkValidLi=function(e){return!!this.isValidLI(e)&&(this.setSelection(e,null),!0)},s.prototype.setSelectionData=function(e,t,i){var s,l=this;this.updateListValues=function(){"text"===i?(s=l.getElementByText(e),l.checkValidLi(s)||l.setOldText(t)):"value"===i?(s=l.getElementByValue(e),l.checkValidLi(s)||l.setOldValue(t)):"index"===i&&(s=l.liCollections[e],l.checkValidLi(s)||(l.index=t))}},s.prototype.setReadOnly=function(){this.readonly?t.addClass([this.inputWrapper.container],["e-readonly"]):t.removeClass([this.inputWrapper.container],["e-readonly"])},s.prototype.setCssClass=function(e,i){t.isNullOrUndefined(i)||(i=i.replace(/\s+/g," ").trim()),t.isNullOrUndefined(e)||(e=e.replace(/\s+/g," ").trim()),n.Input.setCssClass(e,[this.inputWrapper.container],i),this.popupObj&&n.Input.setCssClass(e,[this.popupObj.element],i)},s.prototype.getModuleName=function(){return"dropdownlist"},s.prototype.showPopup=function(){this.enabled&&(this.isFiltering()&&this.dataSource instanceof i.DataManager&&this.actionData.list!=this.actionCompleteData.list&&this.actionData.list&&this.actionData.ulElement&&(this.actionCompleteData=this.actionData,this.onActionComplete(this.actionCompleteData.ulElement,this.actionCompleteData.list,null,!0)),this.beforePopupOpen?this.refreshPopup():(this.beforePopupOpen=!0,this.isFiltering()&&!this.isActive&&this.actionCompleteData.list&&this.actionCompleteData.list[0]?(this.isActive=!0,this.onActionComplete(this.actionCompleteData.ulElement,this.actionCompleteData.list,null,!0)):(t.isNullOrUndefined(this.list)||!t.isUndefined(this.list)&&(this.list.classList.contains(I.noData)||this.list.querySelectorAll("."+I.li).length<=0))&&this.renderList(),this.invokeRenderPopup()))},s.prototype.invokeRenderPopup=function(){if(t.Browser.isDevice&&this.isFilterLayout()){var e=this;window.onpopstate=function(){e.hidePopup()},history.pushState({},"")}t.isNullOrUndefined(this.list.children[0])&&!this.list.classList.contains(I.noData)||this.renderPopup(),t.attributes(this.targetElement(),{"aria-activedescendant":this.selectedLI?this.selectedLI.id:null})},s.prototype.renderHightSearch=function(){},s.prototype.hidePopup=function(e){if(this.isEscapeKey&&"dropdownlist"===this.getModuleName())if(n.Input.setValue(this.text,this.inputElement,this.floatLabelType,this.showClearButton),this.isEscapeKey=!1,t.isNullOrUndefined(this.index))this.resetSelection();else{var i=this.findListElement(this.ulElement,"li","data-value",this.value);this.selectedLI=this.liCollections[this.index]||i,this.selectedLI&&(this.updateSelectedItem(this.selectedLI,null,!0),this.valueTemplate&&null!==this.itemData&&this.setValueTemplate())}this.closePopup();var s=this.getItemData(),l=!t.isNullOrUndefined(this.selectedLI);this.inputElement&&""===this.inputElement.value.trim()&&!this.isInteracted&&(this.isSelectCustom||l&&this.inputElement.value!==s.text)&&(this.isSelectCustom=!1,this.clearAll(e))},s.prototype.focusIn=function(e){if(this.enabled&&!this.targetElement().classList.contains(N.disable)){var i=!1;this.preventFocus&&t.Browser.isDevice&&(this.inputWrapper.container.tabIndex=1,this.inputWrapper.container.focus(),this.preventFocus=!1,i=!0),i||this.targetElement().focus(),t.addClass([this.inputWrapper.container],[N.inputFocus]),this.onFocus(e)}},s.prototype.focusOut=function(e){this.enabled&&(this.isTyped=!0,this.hidePopup(e),this.targetElement()&&this.targetElement().blur(),t.removeClass([this.inputWrapper.container],[N.inputFocus]))},s.prototype.destroy=function(){if(this.isActive=!1,p(this.element.id),this.isReact&&this.clearTemplate(),this.hidePopup(),this.unWireEvent(),this.list&&this.unWireListEvents(),!this.element||this.element.classList.contains("e-"+this.getModuleName())){if(this.inputElement){for(var i=["readonly","aria-disabled","aria-placeholder","placeholder","aria-owns","aria-labelledby","aria-haspopup","aria-expanded","aria-activedescendant","autocomplete","aria-readonly","autocorrect","autocapitalize","spellcheck","aria-autocomplete","aria-live","aria-describedby","aria-label"],s=0;s<i.length;s++)this.inputElement.removeAttribute(i[s]);this.inputElement.setAttribute("tabindex",this.tabIndex),this.inputElement.classList.remove("e-input"),n.Input.setValue("",this.inputElement,this.floatLabelType,this.showClearButton)}this.element.style.display="block",this.inputWrapper.container.parentElement.tagName===this.getNgDirective()?t.detach(this.inputWrapper.container):(this.inputWrapper.container.parentElement.insertBefore(this.element,this.inputWrapper.container),t.detach(this.inputWrapper.container)),e.prototype.destroy.call(this)}},s.prototype.getItems=function(){return this.list||(this.dataSource instanceof i.DataManager&&(this.initRemoteRender=!0),this.renderList()),this.ulElement?e.prototype.getItems.call(this):[]},s.prototype.getDataByValue=function(t){return e.prototype.getDataByValue.call(this,t)},s.prototype.clear=function(){this.value=null},T([t.Property(null)],s.prototype,"cssClass",void 0),T([t.Property("100%")],s.prototype,"width",void 0),T([t.Property("300px")],s.prototype,"popupHeight",void 0),T([t.Property("100%")],s.prototype,"popupWidth",void 0),T([t.Property(null)],s.prototype,"placeholder",void 0),T([t.Property(null)],s.prototype,"filterBarPlaceholder",void 0),T([t.Property({})],s.prototype,"htmlAttributes",void 0),T([t.Property(null)],s.prototype,"query",void 0),T([t.Property(null)],s.prototype,"valueTemplate",void 0),T([t.Property(null)],s.prototype,"headerTemplate",void 0),T([t.Property(null)],s.prototype,"footerTemplate",void 0),T([t.Property(!1)],s.prototype,"allowFiltering",void 0),T([t.Property(!1)],s.prototype,"readonly",void 0),T([t.Property(null)],s.prototype,"text",void 0),T([t.Property(null)],s.prototype,"value",void 0),T([t.Property(null)],s.prototype,"index",void 0),T([t.Property("Never")],s.prototype,"floatLabelType",void 0),T([t.Property(!1)],s.prototype,"showClearButton",void 0),T([t.Event()],s.prototype,"filtering",void 0),T([t.Event()],s.prototype,"change",void 0),T([t.Event()],s.prototype,"beforeOpen",void 0),T([t.Event()],s.prototype,"open",void 0),T([t.Event()],s.prototype,"close",void 0),T([t.Event()],s.prototype,"blur",void 0),T([t.Event()],s.prototype,"focus",void 0),s=T([t.NotifyPropertyChanges],s)}(L),F=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),H=function(e,t,i,s){var l,n=arguments.length,o=n<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)o=Reflect.decorate(e,t,i,s);else for(var r=e.length-1;r>=0;r--)(l=e[r])&&(o=(n<3?l(o):n>3?l(t,i,o):l(t,i))||o);return n>3&&o&&Object.defineProperty(t,i,o),o},V="e-input-group-icon e-ddt-icon e-icons",U="e-show-chip",M="e-show-clear",j="e-show-dd-icon",q="e-chip-input",R="e-input-focus",K="e-chips-close",z="e-icon-hide",_="e-ddt-icon-hide",G="e-selectall-parent",Q="e-hide-selectall",J="e-check",X="e-checkbox-wrapper",$="e-no-data",Y="e-overflow",Z="e-show-text",ee="e-total-count",te="e-wrap-count",ie=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return F(i,e),H([t.Property("child")],i.prototype,"child",void 0),H([t.Property([])],i.prototype,"dataSource",void 0),H([t.Property("expanded")],i.prototype,"expanded",void 0),H([t.Property("hasChildren")],i.prototype,"hasChildren",void 0),H([t.Property("htmlAttributes")],i.prototype,"htmlAttributes",void 0),H([t.Property("iconCss")],i.prototype,"iconCss",void 0),H([t.Property("imageUrl")],i.prototype,"imageUrl",void 0),H([t.Property("parentValue")],i.prototype,"parentValue",void 0),H([t.Property(null)],i.prototype,"query",void 0),H([t.Property("selected")],i.prototype,"selected",void 0),H([t.Property(null)],i.prototype,"tableName",void 0),H([t.Property("text")],i.prototype,"text",void 0),H([t.Property("tooltip")],i.prototype,"tooltip",void 0),H([t.Property("value")],i.prototype,"value",void 0),i}(t.ChildProperty),se=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return F(i,e),H([t.Property(!1)],i.prototype,"autoCheck",void 0),H([t.Property("Auto")],i.prototype,"expandOn",void 0),H([t.Property(!1)],i.prototype,"loadOnDemand",void 0),i}(t.ChildProperty),le=function(e){function s(t,i){var s=e.call(this,t,i)||this;return s.filterTimer=null,s.isFilteredData=!1,s.isFilterRestore=!1,s.selectedData=[],s.filterDelayTime=300,s.isClicked=!1,s}return F(s,e),s.prototype.getPersistData=function(){return this.addOnPersist(["value"])},s.prototype.getLocaleName=function(){return"drop-down-tree"},s.prototype.preRender=function(){this.inputFocus=!1,this.isPopupOpen=!1,this.isFirstRender=!0,this.isInitialized=!1,this.currentText=null,this.currentValue=null,this.oldValue=null,this.removeValue=!1,this.selectedText=[],this.treeItems=[],this.dataValue=null,this.isNodeSelected=!1,this.isDynamicChange=!1,this.clearIconWidth=0,this.headerTemplateId=this.element.id+"HeaderTemplate",this.footerTemplateId=this.element.id+"FooterTemplate",this.actionFailureTemplateId=this.element.id+"ActionFailureTemplate",this.noRecordsTemplateId=this.element.id+"NoRecordsTemplate",this.customTemplateId=this.element.id+"CustomTemplate",this.keyConfigs={escape:"escape",altUp:"alt+uparrow",altDown:"alt+downarrow",tab:"tab",shiftTab:"shift+tab",end:"end",enter:"enter",home:"home",moveDown:"downarrow",moveLeft:"leftarrow",moveRight:"rightarrow",moveUp:"uparrow",ctrlDown:"ctrl+downarrow",ctrlUp:"ctrl+uparrow",ctrlEnter:"ctrl+enter",ctrlHome:"ctrl+home",ctrlEnd:"ctrl+end",shiftDown:"shift+downarrow",shiftUp:"shift+uparrow",shiftEnter:"shift+enter",shiftHome:"shift+home",shiftEnd:"shift+end",csDown:"ctrl+shift+downarrow",csUp:"ctrl+shift+uparrow",csEnter:"ctrl+shift+enter",csHome:"ctrl+shift+home",csEnd:"ctrl+shift+end",space:"space",ctrlA:"ctrl+A"}},s.prototype.render=function(){var e=t.select("#"+this.element.id+"_tree",document);if(e){var s=t.select("#"+this.element.id+"_popup",document);t.detach(s||e.parentElement)}this.ensureAutoCheck(),"INPUT"===this.element.tagName?(this.inputEle=this.element,t.isNullOrUndefined(this.inputEle.getAttribute("role"))&&this.inputEle.setAttribute("role","textbox"),t.isNullOrUndefined(this.inputEle.getAttribute("type"))&&this.inputEle.setAttribute("type","text")):(this.inputEle=this.createElement("input",{attrs:{role:"textbox",type:"text"}}),this.element.parentElement.insertBefore(this.inputEle,this.element)),this.inputObj=n.Input.createInput({element:this.inputEle,floatLabelType:this.floatLabelType,buttons:this.showDropDownIcon?[V]:null,properties:{readonly:!0,placeholder:this.placeholder,enabled:this.enabled,cssClass:this.cssClass,enableRtl:this.enableRtl}},this.createElement),this.inputWrapper=this.inputObj.container,this.inputWrapper.classList.contains("e-input-group")||this.inputWrapper.classList.add("e-input-group"),this.showDropDownIcon&&this.inputWrapper.classList.add(j),this.element.tagName===this.getDirective()&&this.element.appendChild(this.inputWrapper),this.createHiddenElement(),this.createClearIcon(),this.inputWrapper.classList.add("e-ddt"),this.setElementWidth(this.width),this.updateDataAttribute(),this.setHTMLAttributes(),this.setAttributes(),this.popupDiv=this.createElement("div",{className:"e-popup-content",attrs:{tabindex:"0"}}),this.popupDiv.classList.add("e-dropdown"),this.tree=this.createElement("div",{id:this.element.id+"_tree"}),this.popupDiv.appendChild(this.tree),document.body.appendChild(this.popupDiv),this.wireTreeEvents(),t.addClass([this.popupDiv],_),this.renderTree(),this.isRemoteData=this.fields.dataSource instanceof i.DataManager,(this.allowMultiSelection||this.showCheckBox)&&("Delimiter"!==this.mode&&this.createChip(),this.wrapText||"Custom"===this.mode||(this.overFlowWrapper=this.createElement("span",{className:Y+" "+z}),this.inputWrapper.insertBefore(this.overFlowWrapper,this.hiddenElement),"Box"!==this.mode&&t.addClass([this.overFlowWrapper],Z))),this.isRemoteData||(this.setTreeValue(),this.setTreeText(),this.updateHiddenValue(),this.setSelectedValue(),this.wrapText||this.updateView()),this.wireEvents();var l=t.select(".e-list-parent",this.treeObj.element);l&&l.getAttribute("aria-multiselectable")&&l.removeAttribute("aria-multiselectable"),this.oldValue=this.value,this.isInitialized=!0,this.hasTemplate=this.itemTemplate||this.headerTemplate||this.footerTemplate||this.actionFailureTemplate||this.noRecordsTemplate||this.customTemplate,this.renderComplete()},s.prototype.ensureAutoCheck=function(){this.allowFiltering&&this.treeSettings.autoCheck&&this.setProperties({treeSettings:{autoCheck:!1}},!0)},s.prototype.hideCheckAll=function(e){var i=t.isNullOrUndefined(this.popupEle)?null:this.popupEle.querySelector("."+G);t.isNullOrUndefined(i)||(e&&!i.classList.contains(Q)?t.addClass([i],Q):!e&&i.classList.contains(Q)&&t.removeClass([i],Q))},s.prototype.renderFilter=function(){this.filterContainer=this.createElement("div",{id:this.element.id+"_filter_wrap",className:"e-filter-wrap"});var e=this.createElement("input",{id:this.element.id+"_filter",attrs:{autocomplete:"off","aria-label":this.filterBarPlaceholder}});this.filterContainer.appendChild(e),t.prepend([this.filterContainer],this.popupEle),this.filterObj=new n.TextBox({value:"",showClearButton:!0,placeholder:this.filterBarPlaceholder,input:this.filterChangeHandler.bind(this)}),this.filterObj.appendTo("#"+this.element.id+"_filter")},s.prototype.filterChangeHandler=function(e){var i=this;t.isNullOrUndefined(e.value)||(window.clearTimeout(this.filterTimer),this.filterTimer=window.setTimeout(function(){i.filterHandler(e.value,e.event)},this.filterDelayTime))},s.prototype.filterHandler=function(e,t){var s=this;this.isFilteredData||(this.treeData=this.treeObj.getTreeData());var l=this.cloneFields(this.fields),n={cancel:!1,preventDefaultAction:!1,event:t,text:e,fields:l};this.trigger("filtering",n,function(t){if(!t.cancel){var l=!1,n=void 0;if(s.isFilteredData=!0,""===e?(s.isFilteredData=!1,s.isFilterRestore=!0,n=s.cloneFields(s.fields)):t.preventDefaultAction?n=t.fields:1===s.treeDataType?n=s.selfReferencefilter(e,t.fields):s.fields.dataSource instanceof i.DataManager?l=!0:n=s.nestedFilter(e,t.fields),s.hideCheckAll(s.isFilteredData),l)return;s.treeObj.fields=s.getTreeFields(n),s.treeObj.dataBind()}})},s.prototype.nestedFilter=function(e,i){for(var s=[],l=0;l<this.treeData.length;l++){var n=this.nestedChildFilter(e,this.treeData[l]);t.isNullOrUndefined(n)||s.push(n)}return i.dataSource=s,i},s.prototype.nestedChildFilter=function(e,i){var s=i[this.fields.child];if(t.isNullOrUndefined(s))return this.isMatchedNode(e,i)?i:null;for(var l=[],n=0;n<s.length;n++){var o=this.nestedChildFilter(e,s[n]);t.isNullOrUndefined(o)||l.push(o)}return 0!==l.length?(i[this.fields.child]=l,i):(i[this.fields.child]=null,this.isMatchedNode(e,i)?i:null)},s.prototype.selfReferencefilter=function(e,i){for(var s=[],l=[],n=0;n<this.treeData.length;n++)this.isMatchedNode(e,this.treeData[n])&&s.push(this.treeData[n]);for(n=0;n<s.length;n++)if(-1===l.indexOf(s[n])){l.push(s[n]);for(var o=s[n][this.fields.parentValue];!t.isNullOrUndefined(o);){for(var r=null,a=0;a<this.treeData.length;a++){var h=this.treeData[a][this.fields.value];if(!t.isNullOrUndefined(h)&&h===o){r=this.treeData[a];break}}if(t.isNullOrUndefined(r)||-1!==l.indexOf(r))break;l.push(r),o=r[this.fields.parentValue]}}return i.dataSource=l,i},s.prototype.isMatchedNode=function(e,t){var s=t[this.fields.text];return this.ignoreCase&&(s=s.toLowerCase(),e=e.toLowerCase()),this.ignoreAccent&&(s=i.DataUtil.ignoreDiacritics(s),e=i.DataUtil.ignoreDiacritics(e)),"StartsWith"===this.filterType?s.slice(0,e.length)===e:"EndsWith"===this.filterType?s.slice(-e.length)===e:-1!==s.indexOf(e)},s.prototype.wireEvents=function(){t.EventHandler.add(this.inputWrapper,"mouseup",this.dropDownClick,this),t.EventHandler.add(this.inputWrapper,"focus",this.focusIn,this),t.EventHandler.add(this.inputWrapper,"blur",this.focusOut,this),t.EventHandler.add(this.inputWrapper,"mousemove",this.mouseIn,this),t.EventHandler.add(this.inputWrapper,"mouseout",this.onMouseLeave,this),t.EventHandler.add(this.overAllClear,"mousedown",this.clearAll,this),t.EventHandler.add(window,"resize",this.windowResize,this);var e=t.closest(this.inputWrapper,"form");e&&t.EventHandler.add(e,"reset",this.resetValueHandler,this),this.keyboardModule=new t.KeyboardEvents(this.inputWrapper,{keyAction:this.keyActionHandler.bind(this),keyConfigs:this.keyConfigs,eventName:"keydown"})},s.prototype.wireTreeEvents=function(){this.keyboardModule=new t.KeyboardEvents(this.tree,{keyAction:this.treeAction.bind(this),keyConfigs:this.keyConfigs,eventName:"keydown"})},s.prototype.wireCheckAllWrapperEvents=function(){this.keyboardModule=new t.KeyboardEvents(this.checkAllParent,{keyAction:this.checkAllAction.bind(this),keyConfigs:this.keyConfigs,eventName:"keydown"})},s.prototype.unWireEvents=function(){t.EventHandler.remove(this.inputWrapper,"mouseup",this.dropDownClick),t.EventHandler.remove(this.inputWrapper,"focus",this.focusIn),t.EventHandler.remove(this.inputWrapper,"blur",this.focusOut),t.EventHandler.remove(this.inputWrapper,"mousemove",this.mouseIn),t.EventHandler.remove(this.inputWrapper,"mouseout",this.onMouseLeave),t.EventHandler.remove(this.overAllClear,"mousedown",this.clearAll),t.EventHandler.remove(window,"resize",this.windowResize);var e=t.closest(this.inputWrapper,"form");e&&t.EventHandler.remove(e,"reset",this.resetValueHandler)},s.prototype.dropDownClick=function(e){this.enabled&&!this.readonly&&(this.isClearButtonClick?this.isClearButtonClick=!1:(this.isPopupOpen?this.hidePopup():(this.focusIn(e),this.renderPopup()),this.showOverAllClear()))},s.prototype.mouseIn=function(){!this.enabled&&this.readonly||this.showOverAllClear()},s.prototype.onMouseLeave=function(){this.inputFocus||(t.addClass([this.overAllClear],z),t.removeClass([this.inputWrapper],M))},s.prototype.getDirective=function(){return"EJS-DROPDOWNTREE"},s.prototype.focusOut=function(e){if(this.enabled&&!this.readonly&&this.inputFocus&&(!t.Browser.isIE&&"edge"!==t.Browser.info.name||e.target!==this.inputWrapper)){var i=e.relatedTarget;i===this.inputEle||!t.isNullOrUndefined(i)||e.target===this.inputWrapper&&this.isPopupOpen||this.onFocusOut(e)}},s.prototype.onFocusOut=function(e){if(this.inputFocus=!1,this.isPopupOpen&&this.hidePopup(),this.isClearButtonClick&&(this.isClearButtonClick=!1),this.showClearButton&&(this.clearIconWidth=t.select(".e-clear-icon",this.inputWrapper).offsetWidth,t.addClass([this.overAllClear],z),t.removeClass([this.inputWrapper],M)),t.removeClass([this.inputWrapper],[R]),this.allowMultiSelection||this.showCheckBox){var i=!!this.value&&!!this.value.length;"Delimiter"!==this.mode&&"Custom"!==this.mode&&this.chipWrapper&&"Default"===this.mode&&(t.addClass([this.chipWrapper],z),t.removeClass([this.inputWrapper],U),t.removeClass([this.inputEle],q)),!this.wrapText&&i&&this.updateView()}this.changeOnBlur&&this.triggerChangeEvent(e),this.removeValue=!1,this.oldValue=this.value,this.trigger("blur")},s.prototype.updateView=function(){!this.showCheckBox&&!this.allowMultiSelection||"Custom"===this.mode||this.inputFocus||("Box"!==this.mode?t.addClass([this.inputWrapper,this.overFlowWrapper],Z):t.addClass([this.inputWrapper],U),this.value&&0!==this.value.length&&(this.inputWrapper.contains(this.chipWrapper)&&t.addClass([this.chipWrapper],z),t.addClass([this.inputEle],q),this.updateOverFlowView(),this.ensurePlaceHolder()))},s.prototype.triggerChangeEvent=function(e){if((!this.ddtCompareValues(this.oldValue,this.value)||this.isChipDelete)&&!this.removeValue){var t={e:e,oldValue:this.oldValue,value:this.value,isInteracted:!!e,element:this.element};this.trigger("change",t),this.oldValue=this.value}},s.prototype.ddtCompareValues=function(e,t){if(null===e||null===t){return null===e?t===e:0===e.length&&t===e}if(e.length!==t.length)return!1;for(var i=0;i<e.length;i++)if(e[i]!==t[i])return!1;return!0},s.prototype.focusIn=function(e){if(this.enabled&&!this.readonly&&!this.inputFocus){this.showOverAllClear(),this.inputFocus=!0,t.addClass([this.inputWrapper],[R]),(this.allowMultiSelection||this.showCheckBox)&&("Delimiter"!==this.mode&&this.inputFocus&&(this.chipWrapper&&this.value&&0!==this.value.length&&(t.removeClass([this.chipWrapper],z),t.addClass([this.inputEle],q)),t.addClass([this.inputWrapper],U),this.popupObj&&this.popupObj.refreshPosition()),this.wrapText||"Custom"===this.mode||(this.inputWrapper.contains(this.overFlowWrapper)&&t.addClass([this.overFlowWrapper],z),"Delimiter"===this.mode?(t.removeClass([this.inputWrapper],U),t.removeClass([this.inputEle],q)):t.addClass([this.inputWrapper],U),t.removeClass([this.inputWrapper],Z),this.ensurePlaceHolder()));var i={isInteracted:!!e,event:e};this.trigger("focus",i)}},s.prototype.treeAction=function(e){var t=this,i={cancel:!1,event:e};this.trigger("keyPress",i,function(i){if(i.cancel)e.stopImmediatePropagation();else switch(e.action){case"escape":case"altUp":t.inputWrapper.focus(),e.preventDefault(),t.isPopupOpen&&t.hidePopup();break;case"tab":case"shiftTab":t.isPopupOpen&&t.hidePopup();break;case"enter":case"ctrlEnter":case"shiftEnter":case"csEnter":t.showCheckBox||(t.isValueChange=!0,t.keyEventArgs=e);break;case"space":t.isValueChange=!0,t.keyEventArgs=e;break;case"ctrlA":t.allowMultiSelection&&t.selectAll(!0)}})},s.prototype.keyActionHandler=function(e){var t=this,i={cancel:!1,event:e};this.trigger("keyPress",i,function(i){if(!i.cancel)switch(e.action){case"escape":case"altUp":t.isPopupOpen&&t.hidePopup();break;case"shiftTab":case"tab":t.isPopupOpen&&t.hidePopup(),t.inputFocus&&t.onFocusOut();break;case"altDown":t.isPopupOpen||(t.showPopup(),e.preventDefault());break;case"moveDown":t.showSelectAll&&t.showCheckBox&&t.checkAllParent.focus()}})},s.prototype.checkAllAction=function(e){var t=this,i={cancel:!1,event:e};this.trigger("keyPress",i,function(i){if(!i.cancel)switch(e.action){case"space":t.clickHandler(e);break;case"moveDown":t.treeObj.element.focus()}})},s.prototype.windowResize=function(){this.popupObj&&(this.popupObj.setProperties({width:this.setWidth()}),this.popupObj.refreshPosition())},s.prototype.resetValueHandler=function(e){var i=t.closest(this.inputWrapper,"form");i&&e.target===i&&(this.isDynamicChange=!0,this.setProperties({value:null},!0),this.resetValue(!0),this.isDynamicChange=!1)},s.prototype.getAriaAttributes=function(){return{"aria-disabled":this.enabled?"false":"true","aria-owns":this.element.id+"_options",role:"listbox","aria-haspopup":"true","aria-expanded":"false","aria-activedescendant":"null","aria-labelledby":this.hiddenElement.id}},s.prototype.updateOverFlowView=function(){if(this.overFlowWrapper.classList.remove(ee),t.removeClass([this.overFlowWrapper],z),this.value&&this.value.length){var e="",i=void 0,s=void 0,l=void 0,n=1,o=void 0,r=void 0,a=0;this.overFlowWrapper.innerHTML="";this.l10n=new t.L10n(this.getLocaleName(),{overflowCountTemplate:"+${count} more..",totalCountTemplate:"${count} selected"},this.locale);var h=this.l10n.getConstant("overflowCountTemplate"),p=this.l10n.getConstant("totalCountTemplate"),u=this.createElement("span",{className:"e-remain"});this.overFlowWrapper.appendChild(u),u.innerText=h.replace("${count}",this.value.length.toString());var c=u.offsetWidth;if(t.remove(u),this.showDropDownIcon&&(a=t.select(".e-ddt-icon",this.inputWrapper).offsetWidth),!t.isNullOrUndefined(this.value))if("Box"!==this.mode)for(var d=0;!t.isNullOrUndefined(this.value[d]);d++){if(e+=0===d?"":this.delimiterChar+" ",s=this.getOverflowVal(d),e+=s,s=this.overFlowWrapper.innerHTML,this.overFlowWrapper.innerHTML=e,o=this.overFlowWrapper.offsetWidth,i=this.inputWrapper.offsetWidth,o+a+this.clearIconWidth>i){for(void 0!==l&&""!==l&&(s=l,d=n+1),this.overFlowWrapper.innerHTML=s,r=this.value.length-d,o=this.overFlowWrapper.offsetWidth;o+c+a+this.clearIconWidth>=i&&0!==o&&""!==this.overFlowWrapper.innerHTML;){var m=this.overFlowWrapper.innerHTML.split(this.delimiterChar);m.pop(),this.overFlowWrapper.innerHTML=m.join(this.delimiterChar),r++,o=this.overFlowWrapper.offsetWidth}break}o+c+a+this.clearIconWidth<=i?(l=e,n=d):0===d&&(l="",n=-1)}else{t.addClass([this.chipWrapper],z);for(var f=this.chipWrapper.cloneNode(!0),v=t.selectAll(".e-chips",f),y=0;y<v.length;y++){if(s=this.overFlowWrapper.innerHTML,this.overFlowWrapper.appendChild(v[y]),e=this.overFlowWrapper.innerHTML,o=this.overFlowWrapper.offsetWidth,i=this.inputWrapper.offsetWidth,o+a+this.clearIconWidth>i){for(void 0!==l&&""!==l&&(s=l,y=n+1),this.overFlowWrapper.innerHTML=s,r=this.value.length-y,o=this.overFlowWrapper.offsetWidth;o+c+a+this.clearIconWidth>=i&&0!==o&&""!==this.overFlowWrapper.innerHTML;)this.overFlowWrapper.removeChild(this.overFlowWrapper.lastChild),r++,o=this.overFlowWrapper.offsetWidth;break}o+c+a+this.clearIconWidth<=i?(l=e,n=y):0===y&&(l="",n=-1)}}r>0&&this.overFlowWrapper.appendChild(this.updateRemainTemplate(u,r,h,p)),"Box"!==this.mode||this.overFlowWrapper.classList.contains(ee)||t.addClass([u],te)}else this.overFlowWrapper.innerHTML="",t.addClass([this.overFlowWrapper],z);this.updateDelimMode()},s.prototype.updateRemainTemplate=function(e,i,s,l){return this.overFlowWrapper.firstChild&&3===this.overFlowWrapper.firstChild.nodeType&&""===this.overFlowWrapper.firstChild.nodeValue&&this.overFlowWrapper.removeChild(this.overFlowWrapper.firstChild),e.innerHTML="",e.innerText=!this.overFlowWrapper.firstChild||3!==this.overFlowWrapper.firstChild.nodeType&&"Box"!==this.mode?l.replace("${count}",i.toString()):s.replace("${count}",i.toString()),!this.overFlowWrapper.firstChild||3!==this.overFlowWrapper.firstChild.nodeType&&"Box"!==this.mode?(t.addClass([this.overFlowWrapper],ee),t.removeClass([this.overFlowWrapper],te)):t.removeClass([this.overFlowWrapper],ee),e},s.prototype.getOverflowVal=function(e){var i=this.getSelectedData(this.value[e]);return t.getValue(this.treeSettings.loadOnDemand?this.fields.text:"text",i)},s.prototype.updateDelimMode=function(){"Box"!==this.mode?t.select(".e-remain",this.overFlowWrapper)&&!this.overFlowWrapper.classList.contains(ee)?(t.addClass([this.overFlowWrapper],te),t.addClass([this.overFlowWrapper],Z)):(this.overFlowWrapper.classList.remove(te),t.removeClass([this.overFlowWrapper],te)):t.select(".e-remain",this.overFlowWrapper)&&this.overFlowWrapper.classList.remove(te)},s.prototype.createHiddenElement=function(){this.allowMultiSelection||this.showCheckBox?this.hiddenElement=this.createElement("select",{attrs:{"aria-hidden":"true",class:"e-ddt-hidden",tabindex:"-1",multiple:""}}):this.hiddenElement=this.createElement("select",{attrs:{"aria-hidden":"true",tabindex:"-1",class:"e-ddt-hidden"}}),t.prepend([this.hiddenElement],this.inputWrapper),this.validationAttribute()},s.prototype.createClearIcon=function(){this.overAllClear=this.createElement("span",{className:"e-clear-icon e-icons"}),t.addClass([this.overAllClear],z),t.removeClass([this.inputWrapper],M),this.showClearButton&&this.inputWrapper.insertBefore(this.overAllClear,this.inputObj.buttons[0])},s.prototype.validationAttribute=function(){var e=this.inputEle.getAttribute("name")?this.inputEle.getAttribute("name"):this.inputEle.getAttribute("id");this.hiddenElement.setAttribute("name",e),this.inputEle.removeAttribute("name");for(var t=["required","aria-required","form"],i=0;i<t.length;i++){var s=this.inputEle.getAttribute(t[i]);s&&(this.hiddenElement.setAttribute(t[i],s),this.inputEle.removeAttribute(t[i]))}},s.prototype.createChip=function(){if(!this.inputWrapper.contains(this.chipWrapper)){this.chipWrapper=this.createElement("span",{className:"e-chips-wrapper"}),this.chipCollection=this.createElement("span",{className:"e-chips-collection"}),this.chipWrapper.appendChild(this.chipCollection),this.inputWrapper.insertBefore(this.chipWrapper,this.hiddenElement),t.addClass([this.inputWrapper],U);this.getValidMode()&&null!==this.value&&this.value&&0!==this.value.length?t.addClass([this.inputEle],q):(null===this.value||this.value&&0===this.value.length)&&t.addClass([this.chipWrapper],z)}},s.prototype.getValidMode=function(){return!(!this.allowMultiSelection&&!this.showCheckBox)&&("Box"===this.mode||!("Default"!==this.mode||!this.inputFocus))},s.prototype.createSelectAllWrapper=function(){this.checkAllParent=this.createElement("div",{className:G,attrs:{tabindex:"0"}}),this.selectAllSpan=this.createElement("span",{className:"e-all-text"}),this.selectAllSpan.textContent="";var e=t.closest(this.element,".e-bigger"),i=t.isNullOrUndefined(e)?"":"e-small";this.checkBoxElement=o.createCheckBox(this.createElement,!0,{cssClass:i}),this.checkBoxElement.setAttribute("role","checkbox"),this.checkAllParent.appendChild(this.checkBoxElement),this.checkAllParent.appendChild(this.selectAllSpan),this.setLocale(),t.EventHandler.add(this.checkAllParent,"mouseup",this.clickHandler,this),this.wireCheckAllWrapperEvents()},s.prototype.clickHandler=function(e){var i;if(i=e.currentTarget&&e.currentTarget.classList.contains(G)?e.currentTarget.firstElementChild.lastElementChild:e.target,this.checkWrapper=t.closest(i,"."+X),!t.isNullOrUndefined(this.checkWrapper)){this.isClicked=!0;var s=t.select(".e-frame",this.checkWrapper);this.changeState(this.checkWrapper,s.classList.contains(J)?"uncheck":"check",e),this.isClicked=!1}e.preventDefault()},s.prototype.changeState=function(e,i,s){var l,n=e.getElementsByClassName("e-frame")[0];"check"!==i||n.classList.contains(J)?"uncheck"===i&&n.classList.contains(J)&&(n.classList.remove(J),l="false",this.isReverseUpdate||(this.treeObj.uncheckAll(),this.changeOnBlur||this.triggerChangeEvent(s)),this.setLocale(!1)):(n.classList.add(J),l="true",this.isReverseUpdate||(this.treeObj.checkAll(),this.changeOnBlur||this.triggerChangeEvent(s)),this.setLocale(!0)),this.setMultiSelect(),this.ensurePlaceHolder(),l="check"===i?"true":"false",t.isNullOrUndefined(l)||e.setAttribute("aria-checked",l)},s.prototype.setLocale=function(e){if(this.selectAllSpan)if("Select All"!==this.selectAllText||"Unselect All"!==this.unSelectAllText){var i=e?this.unSelectAllText:this.selectAllText;this.selectAllSpan.textContent="";for(var s=0,l=t.compile(i)({},this,e?"unSelectAllText":"selectAllText",null,!this.isStringTemplate);s<l.length;s++){var n=l[s];this.selectAllSpan.textContent=n.textContent}}else this.selectAllSpan.textContent=e?this.unSelectAllText:this.selectAllText},s.prototype.setAttributes=function(){this.inputEle.setAttribute("tabindex","-1");var e=this.element.getAttribute("id");this.hiddenElement.id=e+"_hidden",this.inputWrapper.setAttribute("tabindex","0"),t.attributes(this.inputWrapper,this.getAriaAttributes())},s.prototype.setHTMLAttributes=function(){if(Object.keys(this.htmlAttributes).length)for(var e=0,i=Object.keys(this.htmlAttributes);e<i.length;e++){var s=i[e];if("class"===s)this.inputWrapper.classList.add(this.htmlAttributes[s]);else if("disabled"===s&&"disabled"===this.htmlAttributes[s])this.setProperties({enabled:!1},!0),this.setEnable();else if("readonly"!==s||t.isNullOrUndefined(this.htmlAttributes[s]))if("style"===s)this.inputWrapper.setAttribute("style",this.htmlAttributes[s]);else{0===s.indexOf("data")||["name","required"].indexOf(s)>-1?this.hiddenElement.setAttribute(s,this.htmlAttributes[s]):["title","id","placeholder","aria-placeholder","role","autocorrect","autocomplete","autocapitalize","spellcheck","minlength","maxlength"].indexOf(s)>-1?"placeholder"===s?n.Input.setPlaceholder(this.htmlAttributes[s],this.inputEle):this.inputEle.setAttribute(s,this.htmlAttributes[s]):this.inputWrapper.setAttribute(s,this.htmlAttributes[s])}else this.setProperties({readonly:!0},!0),this.dataBind()}},s.prototype.updateDataAttribute=function(){for(var e=this.htmlAttributes,i=["class","style","id","type"],s={},l=0;l<this.element.attributes.length;l++)-1===i.indexOf(this.element.attributes[l].name)&&"readonly"!==this.element.attributes[l].name&&(s[this.element.attributes[l].name]=this.element.getAttribute(this.element.attributes[l].name));t.extend(s,e,s),this.setProperties({htmlAttributes:s},!0)},s.prototype.showOverAllClear=function(){if(this.enabled&&!this.readonly&&this.overAllClear){!!this.value&&!!this.value.length&&this.showClearButton?(t.removeClass([this.overAllClear],z),t.addClass([this.inputWrapper],M)):(t.addClass([this.overAllClear],z),t.removeClass([this.inputWrapper],M))}},s.prototype.setTreeValue=function(){if(null!==this.value&&0!==this.value.length){var e=void 0;if(this.showCheckBox||this.allowMultiSelection){for(var i=0;i<this.value.length;i++)e=this.treeObj.getTreeData(this.value[i])[0],t.isNullOrUndefined(e)&&this.value.splice(this.value.indexOf(this.value[i]),1);0!==this.value.length&&this.setValidValue()}else e=this.treeObj.getTreeData(this.value[0])[0],t.isNullOrUndefined(e)?this.setProperties({value:this.currentValue},!0):(this.setProperties({text:e[this.fields.text]},!0),this.setValidValue())}},s.prototype.setTreeText=function(){if((null===this.value||this.isInitialized)&&null!==this.text){var e=void 0,i=[];if(this.showCheckBox||this.allowMultiSelection){for(var s=this.text.split(this.delimiterChar),l=0;l<s.length;l++)e=this.getItems(s[l]),t.isNullOrUndefined(e)||i.push(e[this.fields.value].toString());0!==i.length?(this.oldValue=this.value,this.setProperties({value:i},!0),this.setValidValue()):this.setProperties({text:this.currentText},!0)}else e=this.getItems(this.text),t.isNullOrUndefined(e)?this.setProperties({text:this.currentText},!0):(this.oldValue=this.value,this.setProperties({value:[e[this.fields.value].toString()]},!0),this.setValidValue())}},s.prototype.setSelectedValue=function(){null==this.value&&(this.isInitialized||(this.oldValue=this.value,this.treeObj.selectedNodes.length>0&&!this.showCheckBox?(this.setProperties({value:this.treeObj.selectedNodes},!0),this.allowMultiSelection&&this.updateMode()):this.showCheckBox&&this.treeObj.checkedNodes&&this.treeObj.checkedNodes.length>0&&(this.setProperties({value:this.treeObj.checkedNodes},!0),t.setValue("selectedNodes",[],this.treeObj),this.treeObj.dataBind(),this.updateMode()),this.updateSelectedValues(),this.currentText=this.text,this.currentValue=this.value))},s.prototype.setValidValue=function(){var e=this;if(this.showCheckBox||this.allowMultiSelection){if(this.showCheckBox){(this.value.filter(function(t){return-1===e.treeObj.checkedNodes.indexOf(t)}).length>0||this.treeSettings.autoCheck)&&(this.treeObj.checkedNodes=this.value.slice(),this.treeObj.dataBind(),this.setMultiSelect())}else this.treeObj.selectedNodes=this.value.slice(),this.selectedText=[],this.updateSelectedValues();this.treeObj.dataBind()}else{n.Input.setValue(this.text,this.inputEle,this.floatLabelType);var i=this.value[0].toString();this.treeObj.selectedNodes[0]!==i&&t.setValue("selectedNodes",[i],this.treeObj)}this.currentText=this.text,this.currentValue=this.value,this.isInitialized&&this.triggerChangeEvent()},s.prototype.getItems=function(e){var i;if(1===this.treeDataType)for(var s=0;s<this.treeItems.length;s++){var l=t.getValue(this.fields.text,this.treeItems[s]);if(!t.isNullOrUndefined(this.treeItems[s])&&!t.isNullOrUndefined(l)&&l===e){i=this.treeItems[s];break}}else i=this.getNestedItems(this.treeItems,this.fields,e);return i},s.prototype.getNestedItems=function(e,s,l){for(var n,o=0,r=e.length;o<r;o++){var a=t.getValue(this.fields.text,e[o]);if(e[o]&&a&&a.toString()===l)return e[o];if("string"!=typeof s.child||t.isNullOrUndefined(t.getValue(s.child,e[o]))){if(this.fields.dataSource instanceof i.DataManager&&!t.isNullOrUndefined(t.getValue("child",e[o]))){if(void 0!==(n=this.getNestedItems(t.getValue("child",e[o]),this.getChildType(s),l)))break}}else{var h=t.getValue(s.child,e[o]);if(void 0!==(n=this.getNestedItems(h,this.getChildType(s),l)))break}}return n},s.prototype.getChildType=function(e){return"string"==typeof e.child||t.isNullOrUndefined(e.child)?e:e.child},s.prototype.renderTree=function(){this.treeObj=new r.TreeView({fields:this.getTreeFields(this.fields),enableRtl:this.enableRtl,nodeSelected:this.onNodeSelected.bind(this),nodeChecked:this.onNodeChecked.bind(this),nodeChecking:this.beforeCheck.bind(this),actionFailure:this.onActionFailure.bind(this),nodeClicked:this.onNodeClicked.bind(this),dataBound:this.OnDataBound.bind(this),allowMultiSelection:this.allowMultiSelection,showCheckBox:this.showCheckBox,autoCheck:this.treeSettings.autoCheck,sortOrder:this.sortOrder,expandOn:this.treeSettings.expandOn,loadOnDemand:this.treeSettings.loadOnDemand,nodeSelecting:this.onBeforeSelect.bind(this),nodeTemplate:this.itemTemplate}),this.treeObj.appendTo("#"+this.tree.id)},s.prototype.renderPopup=function(){var e=this;this.isFilteredData&&(this.filterObj.value="",this.treeObj.fields=this.getTreeFields(this.fields),this.isFilterRestore=!0,this.isFilteredData=!1,this.hideCheckAll(!1));var i=!1;this.trigger("beforeOpen",{cancel:!1},function(s){if(s.cancel?i=!0:(t.addClass([e.inputWrapper],["e-icon-anim"]),e.isFirstRender?(e.popupEle=e.createElement("div",{id:e.element.id+"_popup",className:"e-ddt e-popup "+(null!=e.cssClass?e.cssClass:"")}),document.body.appendChild(e.popupEle),e.createPopup(e.popupEle)):e.popupEle=e.popupObj.element),e.isFirstRender&&!i&&(t.prepend([e.popupDiv],e.popupEle),t.removeClass([e.popupDiv],_),e.allowFiltering&&e.renderFilter(),e.showCheckBox&&e.showSelectAll&&!e.popupDiv.classList.contains($)&&(e.createSelectAllWrapper(),e.popupEle.insertBefore(e.checkAllParent,e.popupDiv)),e.headerTemplate&&e.setHeaderTemplate(),e.footerTemplate&&e.setFooterTemplate(),e.isFirstRender=!1,e.hasTemplate&&e.portals&&(e.portals=e.portals.concat(e.treeObj.portals),e.renderReactTemplates())),!i){if(t.attributes(e.inputWrapper,{"aria-expanded":"true"}),e.popupObj.show(null,1e3===e.zIndex?e.inputEle:null),t.removeClass([e.popupEle],_),e.updatePopupHeight(),e.popupObj.refreshPosition(),e.showCheckBox&&e.showSelectAll||e.popupDiv.classList.contains($)||!(e.treeItems.length>0)||e.treeObj.element.focus(),e.checkSelectAll&&e.checkBoxElement){var l=t.closest(e.checkBoxElement,"."+X);e.changeState(l,"check"),e.checkSelectAll=!1}e.allowFiltering&&(t.removeClass([e.inputWrapper],[R]),e.filterObj.element.focus());var n={popup:e.popupObj};e.trigger("open",n)}})},s.prototype.updatePopupHeight=function(){if(!this.isFirstRender){var e=this.getHeight();if(this.popupEle.style.maxHeight=e,this.allowFiltering){var i=Math.round(this.filterContainer.getBoundingClientRect().height);e=t.formatUnit(parseInt(e,10)-i+"px")}if(this.headerTemplate){i=Math.round(this.header.getBoundingClientRect().height);e=t.formatUnit(parseInt(e,10)-i+"px")}if(this.showCheckBox&&this.showSelectAll){i=Math.round(this.checkAllParent.getBoundingClientRect().height);e=t.formatUnit(parseInt(e,10)-i+"px")}if(this.footerTemplate){i=Math.round(this.footer.getBoundingClientRect().height);e=t.formatUnit(parseInt(e,10)-i+"px")}var s=parseInt(window.getComputedStyle(this.popupEle).borderTopWidth,10);s+=parseInt(window.getComputedStyle(this.popupEle).borderBottomWidth,10),e=t.formatUnit(parseInt(e,10)-s+"px"),this.popupDiv.style.maxHeight=e}},s.prototype.createPopup=function(e){var i=this;this.isFirstRender&&(this.popupObj=new l.Popup(e,{width:this.setWidth(),targetType:"relative",collision:{X:"flip",Y:"flip"},relateTo:this.inputWrapper,zIndex:this.zIndex,enableRtl:this.enableRtl,position:{X:"left",Y:"bottom"},close:function(){i.isPopupOpen=!1},open:function(){t.EventHandler.add(document,"mousedown",i.onDocumentClick,i),i.isPopupOpen=!0},targetExitViewport:function(){t.Browser.isDevice||i.hidePopup()}}))},s.prototype.setElementWidth=function(e){var i=this.inputWrapper;t.isNullOrUndefined(e)||("number"==typeof e?i.style.width=t.formatUnit(e):"string"==typeof e&&(i.style.width=e.match(/px|%|em/)?e:t.formatUnit(e)))},s.prototype.setWidth=function(){var e=t.formatUnit(this.popupWidth);return e.indexOf("%")>-1?e=(this.inputWrapper.offsetWidth*parseFloat(e)/100).toString()+"px":"string"==typeof this.popupWidth&&(e=this.popupWidth.match(/px|em/)?this.popupWidth:e),e},s.prototype.getHeight=function(){var e=t.formatUnit(this.popupHeight);return e.indexOf("%")>-1?e=(document.documentElement.clientHeight*parseFloat(e)/100).toString()+"px":"string"==typeof this.popupHeight&&(e=this.popupHeight.match(/px|em/)?this.popupHeight:e),e},s.prototype.onDocumentClick=function(e){var i=e.target,s=t.closest(i,".e-list-parent"),l=t.closest(i,".e-filter-wrap"),n=t.closest(i,".e-ddt-header"),o=t.closest(i,".e-ddt-footer"),r=!!i.classList.contains("e-dropdown")||(t.matches(i,".e-ddt .e-popup")||t.matches(i,".e-ddt .e-treeview"));this.isPopupOpen&&(this.inputWrapper.contains(i)||s||l||r||n||o)||(this.allowMultiSelection||this.showCheckBox)&&(this.isPopupOpen&&i.classList.contains(K)||this.isPopupOpen&&(i.classList.contains(G)||i.classList.contains("e-all-text")||i.classList.contains("e-frame")))?(this.isDocumentClick=!1,e.preventDefault()):!this.inputWrapper.contains(i)&&this.inputFocus&&this.focusOut(e)},s.prototype.onActionFailure=function(e){this.trigger("actionFailure",e),this.l10nUpdate(!0),t.addClass([this.popupDiv],$)},s.prototype.OnDataBound=function(e){this.treeItems=e.data,this.treeItems.length<=0?(this.l10nUpdate(),t.addClass([this.popupDiv],$),this.hideCheckAll(!0)):this.popupDiv.classList.contains($)&&this.treeItems.length>=1&&(t.removeClass([this.popupDiv],$),this.hideCheckAll(!1)),this.treeDataType=this.getTreeDataType(this.treeItems,this.fields),this.isFirstRender&&this.isRemoteData&&(this.setTreeValue(),this.setTreeText(),this.updateHiddenValue(),this.setSelectedValue(),this.wrapText||this.updateView(),this.treeObj.element.focus());var i={data:e.data};this.trigger("dataBound",i),this.isFilteredData&&this.treeObj.expandAll(),this.isFilterRestore&&(this.restoreFilterSelection(),this.isFilterRestore=!1)},s.prototype.restoreFilterSelection=function(){this.showCheckBox?this.treeObj.checkedNodes=this.value?this.value:[]:this.treeObj.selectedNodes=this.value?this.value:[]},s.prototype.setCssClass=function(e,i){var s=this.popupObj?[this.inputWrapper,this.popupObj.element]:[this.inputWrapper];t.isNullOrUndefined(i)||""===i||t.removeClass(s,i.split(" ")),t.isNullOrUndefined(e)||""===e||t.addClass(s,e.split(" "))},s.prototype.setEnableRTL=function(e){e?this.inputWrapper.classList.add("e-rtl"):this.inputWrapper.classList.remove("e-rtl"),this.popupObj&&(this.popupObj.enableRtl=e,this.popupObj.dataBind()),this.treeObj&&(this.treeObj.enableRtl=e,this.treeObj.dataBind())},s.prototype.setEnable=function(){n.Input.setEnabled(this.enabled,this.inputEle),this.enabled?(t.removeClass([this.inputWrapper],"e-disabled"),this.inputEle.setAttribute("aria-disabled","false"),this.inputWrapper.setAttribute("aria-disabled","false")):(this.isPopupOpen&&this.hidePopup(),t.addClass([this.inputWrapper],"e-disabled"),this.inputWrapper&&this.inputWrapper.classList.contains(R)&&t.removeClass([this.inputWrapper],[R]),this.inputEle.setAttribute("aria-disabled","true"),this.inputWrapper.setAttribute("aria-disabled","true"))},s.prototype.cloneFields=function(e){return{dataSource:e.dataSource,value:e.value,text:e.text,parentValue:e.parentValue,child:this.cloneChildField(e.child),hasChildren:e.hasChildren,expanded:e.expanded,iconCss:e.iconCss,imageUrl:e.imageUrl,htmlAttributes:e.htmlAttributes,query:e.query,selected:e.selected,tableName:e.tableName,tooltip:e.tooltip}},s.prototype.cloneChildField=function(e){if("string"==typeof e)return e;return{dataSource:e.dataSource,value:e.value,text:e.text,parentValue:e.parentValue,child:e.child?this.cloneChildField(e.child):null,hasChildren:e.hasChildren,expanded:e.expanded,iconCss:e.iconCss,imageUrl:e.imageUrl,htmlAttributes:e.htmlAttributes,query:e.query,selected:e.selected,tableName:e.tableName,tooltip:e.tooltip}},s.prototype.getTreeFields=function(e){return{dataSource:e.dataSource,id:e.value,text:e.text,parentID:e.parentValue,child:this.getTreeChildren(e.child),hasChildren:e.hasChildren,expanded:e.expanded,iconCss:e.iconCss,imageUrl:e.imageUrl,isChecked:e.selected,htmlAttributes:e.htmlAttributes,query:e.query,selected:e.selected,tableName:e.tableName,tooltip:e.tooltip}},s.prototype.getTreeChildren=function(e){if("string"==typeof e)return e;if(!t.isNullOrUndefined(e)){var i=e=this.getActualProperties(e);return e.value&&(i.id=e.value),e.parentValue&&(i.parentID=e.parentValue),e.child&&(i.child=this.getTreeChildren(e.child)),e.selected&&this.showCheckBox&&(i.isChecked=e.selected),i}return null},s.prototype.getTreeDataType=function(e,s){if(this.fields.dataSource instanceof i.DataManager){for(var l=0;l<e.length;l++)if("string"==typeof s.child&&t.isNullOrUndefined(t.getValue(s.child,e[l])))return 1;return 2}l=0;for(var n=e.length;l<n;l++){if("string"==typeof s.child&&!t.isNullOrUndefined(t.getValue(s.child,e[l])))return 2;if(!t.isNullOrUndefined(t.getValue(s.parentValue,e[l]))||!t.isNullOrUndefined(t.getValue(s.hasChildren,e[l])))return 1}return 1},s.prototype.setFields=function(){this.resetValue(),this.hasTemplate&&this.updateTemplate(),this.treeObj.fields=this.getTreeFields(this.fields),this.treeObj.dataBind()},s.prototype.getEventArgs=function(e){var t,i=e.data,s=e.nodeData;this.showCheckBox&&("check"===e.action?t="select":"uncheck"===e.action&&(t="un-select"));return{action:this.showCheckBox?t:e.action,isInteracted:!!this.isClicked||e.isInteracted,item:e.node,itemData:this.showCheckBox?i[0]:s}},s.prototype.onBeforeSelect=function(e){e.isInteracted&&(this.oldValue=this.value?this.value.slice():this.value,null===this.value&&this.setProperties({value:[]},!0))},s.prototype.updateHiddenValue=function(){this.allowMultiSelection||this.showCheckBox||(this.value&&this.value.length?this.hiddenElement.innerHTML='<option selected value ="'+this.value[0]+'">'+this.text+"</option>":this.hiddenElement.innerHTML="")},s.prototype.onNodeSelected=function(e){if(!this.showCheckBox){var i;if(e.isInteracted){var s=t.getValue("id",e.nodeData).toString();this.allowMultiSelection?this.allowMultiSelection&&this.setMultiSelect():(this.hiddenElement.innerHTML="",this.setProperties({value:[s]},!0),i=this.itemTemplate?t.getValue("text",this.treeObj.getNode(s)):t.getValue("text",e.nodeData).toString(),n.Input.setValue(i,this.inputEle,this.floatLabelType),this.setProperties({text:i},!0),this.currentText=this.text,this.currentValue=this.value,t.attributes(this.inputWrapper,{"aria-describedby":this.element.id}),t.attributes(this.inputWrapper,{"aria-activedescendant":s.toString()}),this.updateHiddenValue(),this.showOverAllClear(),this.hidePopup(),this.isNodeSelected=!0)}var l=this.getEventArgs(e);this.trigger("select",l),this.isValueChange&&!this.changeOnBlur&&(this.triggerChangeEvent(this.keyEventArgs),this.isValueChange=!1)}},s.prototype.onNodeClicked=function(e){!this.changeOnBlur&&this.isNodeSelected&&(this.triggerChangeEvent(e.event),this.isNodeSelected=!1);var t=e.event.target;if((t.classList.contains("e-fullrow")||t.classList.contains("e-list-text"))&&this.showCheckBox){this.isClicked=!0;"true"===this.treeObj.getNode(e.node).isChecked?this.treeObj.uncheckAll([e.node]):this.treeObj.checkAll([e.node]),this.isClicked=!1,this.setMultiSelect(),this.ensurePlaceHolder()}this.changeOnBlur||!this.allowMultiSelection&&!this.showCheckBox||this.triggerChangeEvent(e.event)},s.prototype.onNodeChecked=function(e){var i=this.getEventArgs(e);if(this.trigger("select",i),this.isFilteredData&&"uncheck"===e.action){var s=t.getValue("id",e.data[0]).toString();this.removeSelectedData(s,!0)}if(!this.isChipDelete&&e.isInteracted&&(this.setMultiSelect(),this.ensurePlaceHolder()),this.showSelectAll&&this.checkBoxElement){var l=this.treeObj.element.querySelectorAll("li"),n=this.treeObj.element.querySelectorAll("li .e-checkbox-wrapper[aria-checked=true]"),o=t.closest(this.checkBoxElement,"."+X);o&&"uncheck"===e.action?(this.isReverseUpdate=!0,this.changeState(o,"uncheck"),this.isReverseUpdate=!1):o&&"check"===e.action&&n.length===l.length&&(this.isReverseUpdate=!0,this.changeState(o,"check"),this.isReverseUpdate=!1)}},s.prototype.beforeCheck=function(e){e.isInteracted&&(this.oldValue=this.value?this.value.slice():this.value)},s.prototype.updateClearButton=function(e){if(e?this.inputWrapper.contains(this.overAllClear)?(t.removeClass([this.overAllClear],z),t.addClass([this.inputWrapper],M)):this.inputEle.parentElement.insertBefore(this.overAllClear,this.inputEle.nextSibling):(t.addClass([this.overAllClear],z),t.removeClass([this.inputWrapper],M)),(this.allowMultiSelection||this.showCheckBox)&&this.chipWrapper)for(var i=t.selectAll("."+K,this.chipWrapper),s=0;s<i.length;s++)e?t.removeClass([i[s]],z):t.addClass([i[s]],z)},s.prototype.updateDropDownIconState=function(e){var i=t.select(".e-ddt-icon",this.inputWrapper);e?(i?t.removeClass([i],z):n.Input.appendSpan(V,this.inputWrapper,this.createElement),t.addClass([this.inputWrapper],j)):(t.addClass([i],z),t.removeClass([this.inputWrapper],j))},s.prototype.updateMode=function(){if("Custom"!==this.mode)if("Delimiter"!==this.mode){this.inputWrapper.contains(this.chipWrapper)||this.createChip();var e=this.getValidMode();this.chipWrapper.classList.contains(z)&&e?(t.removeClass([this.chipWrapper],z),t.addClass([this.inputWrapper],U)):e||(t.addClass([this.chipWrapper],z),t.removeClass([this.inputWrapper],U));var i=null!==this.value&&0!==this.value.length;e&&i?t.addClass([this.inputEle],q):t.removeClass([this.inputEle],q)}else this.inputEle.classList.contains(q)&&(t.removeClass([this.inputEle],q),this.chipWrapper&&(t.addClass([this.chipWrapper],z),t.removeClass([this.inputWrapper],U)))},s.prototype.ensurePlaceHolder=function(){this.value&&0===this.value.length&&(t.removeClass([this.inputEle],q),this.chipWrapper&&t.addClass([this.chipWrapper],z))},s.prototype.ensureClearIconPosition=function(e){"Never"!==e&&this.inputWrapper.insertBefore(this.overAllClear,this.inputObj.buttons[0])},s.prototype.setMultiSelectValue=function(e){if(this.isFilteredData){for(var i=t.isNullOrUndefined(this.value)?[]:this.value,s=0;s<e.length;s++)(t.isNullOrUndefined(this.value)||-1===this.value.indexOf(e[s]))&&i.push(e[s]);this.setProperties({value:i},!0)}else this.setProperties({value:e},!0),e&&0!==e.length&&!this.showCheckBox&&(this.treeObj.selectedNodes=this.value.slice(),this.treeObj.dataBind())},s.prototype.setMultiSelect=function(){if(this.showCheckBox&&!this.isDynamicChange)this.setMultiSelectValue(this.treeObj.checkedNodes.slice());else{var e=this.allowMultiSelection?this.showCheckBox?this.treeObj.checkedNodes:this.treeObj.selectedNodes:this.value?this.showCheckBox?this.value:[this.value[0]]:null;this.setMultiSelectValue(e),this.showCheckBox&&null!==this.value&&(this.treeObj.checkedNodes=this.value,this.treeObj.dataBind())}this.selectedText=[];var i=!!this.allowMultiSelection||!!this.showCheckBox;this.inputWrapper.contains(this.chipWrapper)&&!i&&(t.removeClass([this.inputEle],q),t.detach(this.chipWrapper));this.getValidMode()&&null!==this.value&&(t.addClass([this.inputEle],q),this.chipWrapper&&t.removeClass([this.chipWrapper],z));var s=!!this.value&&!!this.value.length;this.chipWrapper&&"Box"===this.mode&&!s&&(t.addClass([this.chipWrapper],z),t.removeClass([this.inputEle],q)),this.updateSelectedValues()},s.prototype.getSelectedData=function(e){var i=null;if(this.isFilteredData)for(var s=0;s<this.selectedData.length;s++)if(t.getValue(this.treeSettings.loadOnDemand?this.fields.value:"id",this.selectedData[s]).toString()===e){i=this.selectedData[s];break}return t.isNullOrUndefined(i)&&(i=this.treeSettings.loadOnDemand?this.getNodeData(e):this.treeObj.getNode(e),t.isNullOrUndefined(i)||this.selectedData.push(i)),i},s.prototype.getNodeData=function(e){if(!t.isNullOrUndefined(e)){if(1!==this.treeDataType)return this.getChildNodeData(this.treeItems,this.fields,e);for(var i=0,s=this.treeItems.length;i<s;i++){var l=t.getValue(this.fields.value,this.treeItems[i]);if(!t.isNullOrUndefined(this.treeItems[i])&&!t.isNullOrUndefined(l)&&l.toString()===e)return this.treeItems[i]}}},s.prototype.getChildNodeData=function(e,s,l){var n;if(t.isNullOrUndefined(e))return n;for(var o=0,r=e.length;o<r;o++){var a=t.getValue(s.value,e[o]);if(e[o]&&a&&a.toString()===l)return e[o];if("string"!=typeof s.child||t.isNullOrUndefined(t.getValue(s.child,e[o]))){if(this.fields.dataSource instanceof i.DataManager&&!t.isNullOrUndefined(t.getValue("child",e[o]))){if(void 0!==(n=this.getChildNodeData(t.getValue("child",e[o]),this.getChildMapperFields(s),l)))break}}else{var h=t.getValue(s.child,e[o]);if(void 0!==(n=this.getChildNodeData(h,this.getChildMapperFields(s),l)))break}}return n},s.prototype.getChildMapperFields=function(e){return"string"==typeof e.child||t.isNullOrUndefined(e.child)?e:e.child},s.prototype.removeSelectedData=function(e,i){var s=t.isNullOrUndefined(this.value)?[]:this.value.slice();s.splice(s.indexOf(e),1),this.setProperties({value:s},i);for(var l=0;l<this.selectedData.length;l++)if(t.getValue(this.treeSettings.loadOnDemand?this.fields.value:"id",this.selectedData[l]).toString()===e){this.selectedData.splice(l,1);break}},s.prototype.updateSelectedValues=function(){this.dataValue="";var e,i,s,l="";this.hiddenElement.innerHTML="";var o="";if(this.isChipDelete&&!this.treeSettings.autoCheck||!this.inputWrapper.contains(this.chipWrapper)||(this.chipCollection.innerHTML=""),this.isFilteredData||(this.selectedData=[]),!t.isNullOrUndefined(this.value)){for(var r=0,a=this.value.length;r<a;r++)s=this.getSelectedData(this.value[r]),i=t.getValue(this.treeSettings.loadOnDemand?this.fields.text:"text",s),this.selectedText.push(i),e=this.selectedText[this.selectedText.length-1],this.selectedText.length>1?(this.dataValue+=this.delimiterChar+" "+e,l+=","+e):(this.dataValue+=e,l+=e),"Custom"===this.mode||"Delimiter"===this.mode||this.isChipDelete&&!this.treeSettings.autoCheck||!this.allowMultiSelection&&!this.showCheckBox||this.setChipValues(e,this.value[r]),o+='<option selected value ="'+this.value[r]+'">'+this.selectedText[this.selectedText.length-1]+"</option>";this.selectedText.length>=1&&this.setProperties({text:l},!0),this.hiddenElement.innerHTML=o,"Custom"===this.mode&&(this.allowMultiSelection||this.showCheckBox)&&this.setTagValues()}var h=this.getValidMode();"Custom"===this.mode||"Box"===this.mode||!this.allowMultiSelection&&!this.showCheckBox||h||this.chipWrapper&&(t.addClass([this.chipWrapper],z),t.removeClass([this.inputWrapper],U)),n.Input.setValue(this.dataValue,this.inputEle,this.floatLabelType),""===l?this.setProperties({text:null},!0):this.setProperties({text:l},!0),this.showClearButton&&this.inputFocus&&this.showOverAllClear(),(this.allowMultiSelection||this.showCheckBox)&&this.popupObj&&this.popupObj.refreshPosition(),this.currentText=this.text,this.currentValue=this.value},s.prototype.setChipValues=function(e,i){this.inputWrapper.contains(this.chipWrapper)||this.createChip();var s=this.createElement("span",{className:"e-chips",attrs:{"data-value":i}}),l=this.createElement("span",{className:"e-chipcontent"}),n=this.createElement("span",{className:K+" e-icons"});l.innerHTML=e,s.appendChild(l),this.chipCollection.appendChild(s),this.showClearButton&&(s.appendChild(n),t.EventHandler.add(n,"mousedown",this.removeChip,this))},s.prototype.setTagValues=function(){if(null!==this.value&&null!=this.text){this.inputWrapper.contains(this.chipWrapper)||this.createChip(),this.inputWrapper.classList.contains(U)||t.addClass([this.inputWrapper],U);var e=this.createElement("span",{className:"e-chips"});this.inputEle.classList.contains(q)||t.addClass([this.inputEle],q),this.chipWrapper.classList.contains(z)&&t.removeClass([this.chipWrapper],z);var i=this.createElement("span",{className:"e-chipcontent"}),s=this.customTemplate,l=this.customTemplateId,n=this.templateComplier(s)({value:this.value,text:this.text},this,"customTemplate",l,this.isStringTemplate,void 0,i);n&&(n=Array.prototype.slice.call(n),t.append(n,i)),e.appendChild(i),this.chipCollection.appendChild(e)}},s.prototype.setSelectAllWrapper=function(e){this.isFirstRender||(e&&!this.popupEle.contains(this.checkAllParent)&&this.showCheckBox?(this.createSelectAllWrapper(),this.popupEle.insertBefore(this.checkAllParent,this.popupDiv)):this.popupEle.contains(this.checkAllParent)&&(t.detach(this.checkAllParent),this.checkAllParent=null))},s.prototype.setHeaderTemplate=function(){this.header?this.header.innerHTML="":(this.header=this.createElement("div"),t.addClass([this.header],"e-ddt-header"));var e=this.templateComplier(this.headerTemplate)({},this,"headerTemplate",this.headerTemplateId,this.isStringTemplate,void 0,this.header);e&&(e=Array.prototype.slice.call(e),t.append(e,this.header)),this.popupEle.insertBefore(this.header,this.checkAllParent?this.checkAllParent:this.popupDiv)},s.prototype.templateComplier=function(e){if(e)try{if(document.querySelectorAll(e).length)return t.compile(document.querySelector(e).innerHTML.trim())}catch(i){return t.compile(e)}return t.compile(e)},s.prototype.setFooterTemplate=function(){this.footer?this.footer.innerHTML="":(this.footer=this.createElement("div"),t.addClass([this.footer],"e-ddt-footer"));var e=this.templateComplier(this.footerTemplate)({},this,"footerTemplate",this.footerTemplateId,this.isStringTemplate,void 0,this.footer);e&&(e=Array.prototype.slice.call(e),t.append(e,this.footer)),t.append([this.footer],this.popupEle)},s.prototype.clearAll=function(e){this.enabled&&!this.readonly&&(this.resetValue(),this.showOverAllClear(),(this.allowMultiSelection||this.showCheckBox)&&(this.popupObj&&this.popupObj.refreshPosition(),this.wrapText||this.updateOverflowWrapper(!0)),e&&(this.isClearButtonClick=!0),this.changeOnBlur||this.triggerChangeEvent(e))},s.prototype.removeChip=function(e){if(this.enabled&&!this.readonly){var i=e.target.parentElement,s=i.getAttribute("data-value");this.chipCollection&&i&&t.remove(i),this.isChipDelete=!0,this.isClearButtonClick=!0,this.removeSelectedData(s,!0),this.selectedText=[],this.allowMultiSelection&&(this.treeObj.selectedNodes=this.value.slice(),this.updateSelectedValues()),this.showCheckBox&&(this.treeObj.uncheckAll([s]),this.clearCheckAll(),this.setMultiSelect()),this.triggerChangeEvent(e),this.isChipDelete=!1,this.ensurePlaceHolder()}},s.prototype.resetValue=function(e){this.value==[]&&null==this.text||(n.Input.setValue(null,this.inputEle,this.floatLabelType),e||(this.oldValue=this.value,this.setProperties({value:[]},!0)),this.dataValue=null,this.setProperties({text:null},!0),this.selectedData=[],t.setValue("selectedNodes",[],this.treeObj),this.hiddenElement.innerHTML="",this.showCheckBox&&(this.treeObj.checkedNodes=[],this.treeObj.dataBind(),this.setMultiSelect(),this.clearCheckAll()),null!==this.oldValue||e?e&&this.triggerChangeEvent():this.removeValue=!0,(this.allowMultiSelection||this.showCheckBox)&&this.chipWrapper&&(this.chipCollection.innerHTML="",this.wrapText||this.updateOverflowWrapper(!0),this.ensurePlaceHolder()))},s.prototype.clearCheckAll=function(){this.showSelectAll&&this.value&&0===this.value.length&&this.setLocale(!1)},s.prototype.selectAllItems=function(e){if(this.showCheckBox)e?this.treeObj.checkAll():this.treeObj.uncheckAll(),this.checkSelectAll=!0;else if(this.allowMultiSelection)if(e){for(var i=t.selectAll("li",this.treeObj.element),s=void 0,l=[],n=0;n<i.length;n++)s=i[n].getAttribute("data-uid").toString(),l.push(s);this.treeObj.selectedNodes=l}else this.treeObj.selectedNodes=[];this.updateMode(),this.setMultiSelect(),this.wrapText||(e?this.updateView():this.updateOverflowWrapper(!0))},s.prototype.updateTreeSettings=function(e){var t=Object.keys(e.treeSettings)[0];if("autoCheck"===t)this.ensureAutoCheck(),this.treeObj.autoCheck=this.treeSettings.autoCheck;else if("loadOnDemand"===t)this.treeObj.loadOnDemand=this.treeSettings.loadOnDemand;else if("expandOn"===t)return this.treeObj.expandOn=this.treeSettings.expandOn,void this.treeObj.dataBind();this.treeObj.dataBind(),this.setMultiSelect(),this.updateValue(this.value)},s.prototype.updateCheckBoxState=function(e){this.hasTemplate&&this.updateTemplate(),this.wrapText||this.updateOverflowWrapper(!1),this.treeObj.showCheckBox=e,this.treeObj.dataBind(),this.isDynamicChange=!0,this.setSelectAllWrapper(this.showSelectAll),this.showSelectAll&&this.setLocale(),this.showCheckBox&&this.updateMode(),this.setMultiSelect(),this.isDynamicChange=!1},s.prototype.updateTemplate=function(){this.popupObj&&(this.clearTemplate(),this.portals=[],this.popupObj.destroy(),this.isPopupOpen?(this.hidePopup(),this.isFirstRender=!0,this.renderPopup()):this.isFirstRender=!0)},s.prototype.l10nUpdate=function(e){if(this.noRecord?this.noRecord.innerHTML="":(this.noRecord=this.createElement("div"),t.addClass([this.noRecord],"e-ddt-nodata"),t.prepend([this.noRecord],this.popupDiv)),"No Records Found"!==this.noRecordsTemplate||"The Request Failed"!==this.actionFailureTemplate){var i=e?this.actionFailureTemplate:this.noRecordsTemplate,s=e?this.actionFailureTemplateId:this.noRecordsTemplateId,l=e?"actionFailureTemplate":"noRecordsTemplate",n=this.templateComplier(i)({},this,l,s,this.isStringTemplate,void 0,this.noRecord);n&&(n=Array.prototype.slice.call(n),t.append(n,this.noRecord))}else{this.l10n=new t.L10n(this.getLocaleName(),{noRecordsTemplate:"No Records Found",actionFailureTemplate:"The Request Failed"},this.locale),this.noRecord.innerHTML=e?this.l10n.getConstant("actionFailureTemplate"):this.l10n.getConstant("noRecordsTemplate")}},s.prototype.updateRecordTemplate=function(e){this.treeItems&&this.treeItems.length<=0&&(this.l10nUpdate(e),this.hasTemplate&&this.updateTemplate())},s.prototype.updateOverflowWrapper=function(e){e?this.inputWrapper.contains(this.overFlowWrapper)&&e&&(this.overFlowWrapper.innerHTML=""):this.inputWrapper.contains(this.overFlowWrapper)||(this.overFlowWrapper=this.createElement("span",{className:Y+" "+z}),this.inputWrapper.insertBefore(this.overFlowWrapper,this.hiddenElement))},s.prototype.updateMultiSelection=function(e){this.wrapText||this.updateOverflowWrapper(!1),this.treeObj.allowMultiSelection=e,this.treeObj.dataBind(),this.updateOption(),this.allowMultiSelection&&this.updateMode(),this.setMultiSelect()},s.prototype.updateAllowFiltering=function(e){this.isFirstRender||(e?this.renderFilter():this.destroyFilter()),this.ensureAutoCheck()},s.prototype.updateFilterPlaceHolder=function(){this.filterObj&&(this.filterObj.placeholder=this.filterBarPlaceholder,this.filterObj.element.setAttribute("aria-label",this.filterBarPlaceholder))},s.prototype.updateValue=function(e){this.isDynamicChange=!0,t.isNullOrUndefined(e)||0===e.length?this.resetValue(!0):(this.setTreeValue(),!this.allowMultiSelection&&!this.showCheckBox||this.wrapText||(this.updateOverflowWrapper(!1),this.updateView())),this.updateHiddenValue(),this.isDynamicChange=!1},s.prototype.updateText=function(e){t.isNullOrUndefined(e)?this.resetValue():(this.setTreeText(),!this.allowMultiSelection&&!this.showCheckBox||this.wrapText||(this.updateOverflowWrapper(!1),this.updateView())),this.updateHiddenValue()},s.prototype.updateModelMode=function(){if(!!this.allowMultiSelection||!!this.showCheckBox){if(!this.wrapText){var e=t.select("."+Y,this.inputWrapper);e&&(e.innerHTML="")}this.updateMode(),this.setMultiSelect(),!this.wrapText&&this.value&&0!==this.value.length&&(this.updateOverFlowView(),t.addClass([this.inputEle],q),"Box"===this.mode?t.removeClass([this.overFlowWrapper,this.inputWrapper],Z):t.addClass([this.overFlowWrapper,this.inputWrapper],Z))}},s.prototype.updateOption=function(){this.hiddenElement.hasAttribute("multiple")||!this.allowMultiSelection&&!this.showCheckBox?!this.hiddenElement.hasAttribute("multiple")||this.allowMultiSelection||this.showCheckBox||this.hiddenElement.removeAttribute("multiple"):this.hiddenElement.setAttribute("multiple","")},s.prototype.onPropertyChanged=function(e,i){for(var s=0,l=Object.keys(e);s<l.length;s++){switch(l[s]){case"width":this.setElementWidth(e.width),this.popupObj&&(this.popupObj.element.style.width=this.setWidth());break;case"placeholder":n.Input.setPlaceholder(e.placeholder,this.inputEle);break;case"cssClass":this.setCssClass(e.cssClass,i.cssClass);break;case"enableRtl":this.setEnableRTL(this.enableRtl);break;case"fields":this.setFields();break;case"readonly":n.Input.setReadonly(e.readonly,this.inputEle);break;case"enabled":this.setEnable();break;case"floatLabelType":n.Input.removeFloating(this.inputObj),n.Input.addFloating(this.inputEle,e.floatLabelType,this.placeholder,this.createElement),this.ensureClearIconPosition(e.floatLabelType);break;case"showClearButton":this.updateClearButton(e.showClearButton);break;case"allowFiltering":this.updateAllowFiltering(e.allowFiltering);break;case"filterBarPlaceholder":this.updateFilterPlaceHolder();break;case"value":this.oldValue=i.value,this.updateValue(e.value);break;case"text":this.updateText(e.text);break;case"allowMultiSelection":this.updateMultiSelection(e.allowMultiSelection);break;case"mode":if(!this.showCheckBox&&!this.allowMultiSelection)return;"Custom"===this.mode?(this.overFlowWrapper&&t.detach(this.overFlowWrapper),this.chipWrapper&&t.detach(this.chipWrapper),this.setTagValues()):("Custom"===i.mode&&this.updateOverflowWrapper(this.wrapText),this.updateModelMode());break;case"delimiterChar":if("Box"===this.mode)return;(this.showCheckBox||this.allowMultiSelection)&&this.setMultiSelect();break;case"selectAllText":this.showCheckBox&&this.showSelectAll&&this.setLocale();break;case"unSelectAllText":this.showCheckBox&&this.showSelectAll&&this.setLocale(!1);break;case"showSelectAll":this.showCheckBox&&(this.setSelectAllWrapper(e.showSelectAll),this.updatePopupHeight());break;case"showCheckBox":this.updateCheckBoxState(e.showCheckBox),this.wrapText||this.updateOverflowWrapper(!0),this.updatePopupHeight(),this.updateOption();break;case"treeSettings":this.updateTreeSettings(e);break;case"customTemplate":if("Custom"!==this.mode)return;this.chipCollection.innerHTML="",this.setTagValues();break;case"sortOrder":this.hasTemplate&&this.updateTemplate(),this.treeObj.sortOrder=e.sortOrder,this.treeObj.dataBind(),this.updateValue(this.value);break;case"showDropDownIcon":this.updateDropDownIconState(e.showDropDownIcon);break;case"popupWidth":this.popupObj&&(this.popupObj.element.style.width=this.setWidth());break;case"popupHeight":this.popupObj&&this.updatePopupHeight();break;case"zIndex":this.popupObj&&(this.popupObj.zIndex=e.zIndex,this.popupObj.dataBind());break;case"headerTemplate":case"footerTemplate":this.updateTemplate();break;case"itemTemplate":this.updateTemplate(),this.treeObj.nodeTemplate=e.itemTemplate,this.treeObj.dataBind();break;case"noRecordsTemplate":this.updateRecordTemplate();break;case"actionFailureTemplate":this.updateRecordTemplate(!0);break;case"htmlAttributes":this.setHTMLAttributes();break;case"wrapText":this.updateOverflowWrapper(this.wrapText),!this.allowMultiSelection&&!this.showCheckBox||this.wrapText?(t.addClass([this.overFlowWrapper],z),this.chipWrapper&&"Box"===this.mode?t.removeClass([this.chipWrapper],z):(t.removeClass([this.inputWrapper],U),t.removeClass([this.inputEle],q)),this.ensurePlaceHolder()):this.updateView()}}},s.prototype.clear=function(){this.clearAll(),this.inputFocus?this.onFocusOut():(this.changeOnBlur&&this.triggerChangeEvent(),this.removeValue=!1)},s.prototype.destroy=function(){this.clearTemplate(),this.unWireEvents(),this.setCssClass(null,this.cssClass),this.setProperties({value:[]},!0),this.setProperties({text:null},!0),this.treeObj.destroy(),this.destroyFilter(),this.popupObj&&(this.popupObj.destroy(),t.detach(this.popupObj.element)),this.element.tagName!==this.getDirective()&&this.inputWrapper.parentElement.insertBefore(this.element,this.inputWrapper),n.Input.setValue(null,this.inputEle,this.floatLabelType),t.detach(this.inputWrapper),t.detach(this.popupDiv),this.element.classList.remove("e-input"),(this.showCheckBox||this.allowMultiSelection)&&this.element.classList.remove(q),e.prototype.destroy.call(this)},s.prototype.destroyFilter=function(){this.filterObj&&(this.filterObj.destroy(),t.detach(this.filterObj.element),t.detach(this.filterContainer),this.filterObj=null)},s.prototype.ensureVisible=function(e){this.treeObj.ensureVisible(e)},s.prototype.getData=function(e){return this.treeObj.getTreeData(e)},s.prototype.hidePopup=function(){var e={popup:this.popupObj};this.inputWrapper.classList.remove("e-icon-anim"),this.popupEle&&t.addClass([this.popupEle],_),t.attributes(this.inputWrapper,{"aria-expanded":"false"}),this.popupObj&&this.isPopupOpen&&(this.popupObj.hide(),this.inputFocus&&(this.inputWrapper.focus(),this.allowFiltering&&t.addClass([this.inputWrapper],[R])),this.trigger("close",e))},s.prototype.selectAll=function(e){this.selectAllItems(e)},s.prototype.showPopup=function(){!this.enabled||this.readonly||this.isPopupOpen||(this.renderPopup(),this.focusIn())},s.prototype.getModuleName=function(){return"dropdowntree"},H([t.Property("The Request Failed")],s.prototype,"actionFailureTemplate",void 0),H([t.Property(!1)],s.prototype,"allowFiltering",void 0),H([t.Property(!1)],s.prototype,"allowMultiSelection",void 0),H([t.Property(!0)],s.prototype,"changeOnBlur",void 0),H([t.Property("")],s.prototype,"cssClass",void 0),H([t.Property("${value.length} item(s) selected")],s.prototype,"customTemplate",void 0),H([t.Property(",")],s.prototype,"delimiterChar",void 0),H([t.Property(!0)],s.prototype,"enabled",void 0),H([t.Complex({},ie)],s.prototype,"fields",void 0),H([t.Property(null)],s.prototype,"filterBarPlaceholder",void 0),H([t.Property("StartsWith")],s.prototype,"filterType",void 0),H([t.Property("Never")],s.prototype,"floatLabelType",void 0),H([t.Property(null)],s.prototype,"footerTemplate",void 0),H([t.Property(!1)],s.prototype,"ignoreAccent",void 0),H([t.Property(!0)],s.prototype,"ignoreCase",void 0),H([t.Property(null)],s.prototype,"headerTemplate",void 0),H([t.Property({})],s.prototype,"htmlAttributes",void 0),H([t.Property(null)],s.prototype,"itemTemplate",void 0),H([t.Property("Default")],s.prototype,"mode",void 0),H([t.Property("No Records Found")],s.prototype,"noRecordsTemplate",void 0),H([t.Property(null)],s.prototype,"placeholder",void 0),H([t.Property("300px")],s.prototype,"popupHeight",void 0),H([t.Property("100%")],s.prototype,"popupWidth",void 0),H([t.Property(!1)],s.prototype,"readonly",void 0),H([t.Property(!1)],s.prototype,"showSelectAll",void 0),H([t.Property("Select All")],s.prototype,"selectAllText",void 0),H([t.Property(!1)],s.prototype,"showCheckBox",void 0),H([t.Property(!0)],s.prototype,"showClearButton",void 0),H([t.Property(!0)],s.prototype,"showDropDownIcon",void 0),H([t.Property("None")],s.prototype,"sortOrder",void 0),H([t.Property(null)],s.prototype,"text",void 0),H([t.Complex({},se)],s.prototype,"treeSettings",void 0),H([t.Property("Unselect All")],s.prototype,"unSelectAllText",void 0),H([t.Property(null)],s.prototype,"value",void 0),H([t.Property("100%")],s.prototype,"width",void 0),H([t.Property(1e3)],s.prototype,"zIndex",void 0),H([t.Property(!1)],s.prototype,"wrapText",void 0),H([t.Event()],s.prototype,"actionFailure",void 0),H([t.Event()],s.prototype,"beforeOpen",void 0),H([t.Event()],s.prototype,"change",void 0),H([t.Event()],s.prototype,"close",void 0),H([t.Event()],s.prototype,"blur",void 0),H([t.Event()],s.prototype,"created",void 0),H([t.Event()],s.prototype,"dataBound",void 0),H([t.Event()],s.prototype,"destroyed",void 0),H([t.Event()],s.prototype,"filtering",void 0),H([t.Event()],s.prototype,"focus",void 0),H([t.Event()],s.prototype,"keyPress",void 0),H([t.Event()],s.prototype,"open",void 0),H([t.Event()],s.prototype,"select",void 0),s=H([t.NotifyPropertyChanges],s)}(t.Component),ne=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),oe=function(e,t,i,s){var l,n=arguments.length,o=n<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)o=Reflect.decorate(e,t,i,s);else for(var r=e.length-1;r>=0;r--)(l=e[r])&&(o=(n<3?l(o):n>3?l(t,i,o):l(t,i))||o);return n>3&&o&&Object.defineProperty(t,i,o),o},re="e-atc-spinner-icon";N.root="e-combobox";var ae={container:null,buttons:[]},he=function(e){function i(t,i){return e.call(this,t,i)||this}return ne(i,e),i.prototype.preRender=function(){e.prototype.preRender.call(this)},i.prototype.getLocaleName=function(){return"combo-box"},i.prototype.wireEvent=function(){"combobox"===this.getModuleName()&&(t.EventHandler.add(this.inputWrapper.buttons[0],"mousedown",this.preventBlur,this),t.EventHandler.add(this.inputWrapper.container,"blur",this.onBlurHandler,this)),t.isNullOrUndefined(this.inputWrapper.buttons[0])||t.EventHandler.add(this.inputWrapper.buttons[0],"mousedown",this.dropDownClick,this),t.EventHandler.add(this.inputElement,"focus",this.targetFocus,this),this.readonly||(t.EventHandler.add(this.inputElement,"input",this.onInput,this),t.EventHandler.add(this.inputElement,"keyup",this.onFilterUp,this),t.EventHandler.add(this.inputElement,"keydown",this.onFilterDown,this),t.EventHandler.add(this.inputElement,"paste",this.pasteHandler,this)),this.bindCommonEvent()},i.prototype.preventBlur=function(e){(this.allowFiltering||document.activeElement===this.inputElement||document.activeElement.classList.contains(N.input)||!t.Browser.isDevice)&&t.Browser.isDevice||e.preventDefault()},i.prototype.onBlurHandler=function(i){var s=this.inputElement&&""===this.inputElement.value?null:this.inputElement&&this.inputElement.value;t.isNullOrUndefined(this.listData)||t.isNullOrUndefined(s)||s===this.text||this.customValue(i),e.prototype.onBlurHandler.call(this,i)},i.prototype.targetElement=function(){return this.inputElement},i.prototype.setOldText=function(e){n.Input.setValue(this.text,this.inputElement,this.floatLabelType,this.showClearButton),this.customValue(),this.removeSelection()},i.prototype.setOldValue=function(e){this.allowCustom?this.valueMuteChange(this.value):this.valueMuteChange(null),this.removeSelection(),this.setHiddenValue()},i.prototype.valueMuteChange=function(e){var i=t.isNullOrUndefined(e)?null:e.toString();n.Input.setValue(i,this.inputElement,this.floatLabelType,this.showClearButton),this.setProperties({value:e,text:e,index:null},!0),this.activeIndex=this.index;var s=this.fields,l={};l[s.text]=t.isNullOrUndefined(e)?null:e.toString(),l[s.value]=t.isNullOrUndefined(e)?null:e.toString(),this.itemData=l,this.item=null,this.previousValue!==this.value&&this.detachChangeEvent(null)},i.prototype.updateValues=function(){if(t.isNullOrUndefined(this.value))if(this.text&&t.isNullOrUndefined(this.value)){(e=this.getElementByText(this.text))?this.setSelection(e,null):(n.Input.setValue(this.text,this.inputElement,this.floatLabelType,this.showClearButton),this.customValue())}else this.setSelection(this.liCollections[this.activeIndex],null);else{var e;(e=this.getElementByValue(this.value))?this.setSelection(e,null):this.allowCustom?this.valueMuteChange(this.value):this.valueMuteChange(null)}this.setHiddenValue(),n.Input.setValue(this.text,this.inputElement,this.floatLabelType,this.showClearButton)},i.prototype.updateIconState=function(){this.showClearButton&&(this.inputElement&&""!==this.inputElement.value&&!this.readonly?t.removeClass([this.inputWrapper.clearButton],N.clearIconHide):t.addClass([this.inputWrapper.clearButton],N.clearIconHide))},i.prototype.getAriaAttributes=function(){return{"aria-owns":this.element.id+"_options",role:"combobox","aria-autocomplete":"both","aria-labelledby":this.hiddenElement.id,"aria-hasPopup":"true","aria-expanded":"false","aria-readonly":this.readonly.toString(),autocomplete:"off",autocorrect:"off",autocapitalize:"off",spellcheck:"false"}},i.prototype.searchLists=function(t){this.isTyped=!0,this.isFiltering()?(e.prototype.searchLists.call(this,t),this.ulElement&&""===this.filterInput.value.trim()&&this.setHoverList(this.ulElement.querySelector("."+N.li))):(this.ulElement&&""===this.inputElement.value&&this.preventAutoFill&&this.setHoverList(this.ulElement.querySelector("."+N.li)),this.incrementalSearch(t))},i.prototype.getNgDirective=function(){return"EJS-COMBOBOX"},i.prototype.setSearchBox=function(){return this.filterInput=this.inputElement,this.isFiltering()?this.inputWrapper:ae},i.prototype.onActionComplete=function(t,i,s,l){var n=this;e.prototype.onActionComplete.call(this,t,i,s),this.isSelectCustom&&this.removeSelection(),!this.preventAutoFill&&"combobox"===this.getModuleName()&&this.isTyped&&setTimeout(function(){n.inlineSearch()})},i.prototype.getFocusElement=function(){var e=this.isSelectCustom?{text:""}:this.getItemData(),i=this.list.querySelector("."+N.selected);if(e.text===this.inputElement.value&&!t.isNullOrUndefined(i))return i;if((t.Browser.isDevice&&!this.isDropDownClick||!t.Browser.isDevice)&&!t.isNullOrUndefined(this.liCollections)&&this.liCollections.length>0){var s=h(this.inputElement.value,this.liCollections,this.filterType,!0).item;if(t.isNullOrUndefined(s))this.isSelectCustom&&""!==this.inputElement.value.trim()&&(this.removeFocus(),this.list.scrollTop=0);else{var l=this.getIndexByValue(s.getAttribute("data-value"))-1,n=parseInt(getComputedStyle(this.liCollections[0],null).getPropertyValue("height"),10);if(!isNaN(n)&&"autocomplete"!==this.getModuleName()){this.removeFocus();var o=this.fields.groupBy?this.liCollections[0].offsetHeight:0;this.list.scrollTop=l*n+o,t.addClass([s],N.focus)}}return s}return null},i.prototype.setValue=function(t){return t&&"keydown"===t.type&&"enter"===t.action&&this.removeFillSelection(),this.autofill&&"combobox"===this.getModuleName()&&t&&"keydown"===t.type&&"enter"!==t.action?(this.preventAutoFill=!1,this.inlineSearch(t),!1):e.prototype.setValue.call(this,t)},i.prototype.checkCustomValue=function(){this.itemData=this.getDataByValue(this.value);var e=this.getItemData();this.allowCustom&&t.isNullOrUndefined(e.value)&&t.isNullOrUndefined(e.text)||this.setProperties({value:e.value,text:e.text},!this.allowCustom)},i.prototype.showSpinner=function(){t.isNullOrUndefined(this.spinnerElement)&&(this.spinnerElement="autocomplete"===this.getModuleName()?this.inputWrapper.buttons[0]||this.inputWrapper.clearButton||n.Input.appendSpan("e-input-group-icon "+re,this.inputWrapper.container,this.createElement):this.inputWrapper.buttons[0]||this.inputWrapper.clearButton,t.addClass([this.spinnerElement],N.disableIcon),l.createSpinner({target:this.spinnerElement,width:t.Browser.isDevice?"16px":"14px"},this.createElement),l.showSpinner(this.spinnerElement))},i.prototype.hideSpinner=function(){t.isNullOrUndefined(this.spinnerElement)||(l.hideSpinner(this.spinnerElement),t.removeClass([this.spinnerElement],N.disableIcon),this.spinnerElement.classList.contains(re)?t.detach(this.spinnerElement):this.spinnerElement.innerHTML="",this.spinnerElement=null)},i.prototype.setAutoFill=function(e,t){if(t||this.setHoverList(e),this.autofill&&!this.preventAutoFill){var i=this.getTextByValue(e.getAttribute("data-value")).toString(),s=this.getFormattedValue(e.getAttribute("data-value"));"combobox"===this.getModuleName()&&(this.isSelected||this.previousValue===s?this.updateSelectedItem(e,null,!0):(this.updateSelectedItem(e,null),this.isSelected=!0,this.previousValue=this.getFormattedValue(e.getAttribute("data-value")))),this.isAndroidAutoFill(i)||this.setAutoFillSelection(i)}},i.prototype.isAndroidAutoFill=function(e){if(t.Browser.isAndroid){var i=this.getSelectionPoints(),s=this.prevSelectPoints.end,l=i.end,n=this.prevSelectPoints.start,o=i.start;return 0!==s&&(s===e.length&&n===e.length||n>o&&s>l||s===l&&n===o)}return!1},i.prototype.clearAll=function(i,s){(t.isNullOrUndefined(s)||!t.isNullOrUndefined(s)&&t.isNullOrUndefined(s.dataSource))&&e.prototype.clearAll.call(this,i),this.isFiltering()&&!t.isNullOrUndefined(i)&&i.target===this.inputWrapper.clearButton&&this.searchLists(i)},i.prototype.isSelectFocusItem=function(e){return!t.isNullOrUndefined(e)},i.prototype.inlineSearch=function(e){var i=e&&("down"===e.action||"up"===e.action||"home"===e.action||"end"===e.action||"pageUp"===e.action||"pageDown"===e.action),s=i?this.liCollections[this.activeIndex]:this.getFocusElement();if(t.isNullOrUndefined(s))if(""===this.inputElement.value){this.activeIndex=null,this.list.scrollTop=0;var l=this.list.querySelector("."+N.li);this.setHoverList(l)}else this.activeIndex=null,this.removeSelection(),this.liCollections&&this.liCollections.length>0&&!this.isCustomFilter&&this.removeFocus();else{if(!i){var n=this.getFormattedValue(s.getAttribute("data-value"));this.activeIndex=this.getIndexByValue(n),this.activeIndex=t.isNullOrUndefined(this.activeIndex)?null:this.activeIndex}this.preventAutoFill=""!==this.inputElement.value&&this.preventAutoFill,this.setAutoFill(s,i)}},i.prototype.incrementalSearch=function(e){this.showPopup(),t.isNullOrUndefined(this.listData)||(this.inlineSearch(e),e.preventDefault())},i.prototype.setAutoFillSelection=function(e){var t=this.getSelectionPoints(),i=this.inputElement.value.substr(0,t.start);if(i&&i.toLowerCase()===e.substr(0,t.start).toLowerCase()){var s=i+e.substr(i.length,e.length);n.Input.setValue(s,this.inputElement,this.floatLabelType,this.showClearButton),this.inputElement.setSelectionRange(t.start,this.inputElement.value.length)}else n.Input.setValue(e,this.inputElement,this.floatLabelType,this.showClearButton),this.inputElement.setSelectionRange(0,this.inputElement.value.length)},i.prototype.getValueByText=function(t){return e.prototype.getValueByText.call(this,t,!0,this.ignoreAccent)},i.prototype.unWireEvent=function(){"combobox"===this.getModuleName()&&(t.EventHandler.remove(this.inputWrapper.buttons[0],"mousedown",this.preventBlur),t.EventHandler.remove(this.inputWrapper.container,"blur",this.onBlurHandler)),t.isNullOrUndefined(this.inputWrapper.buttons[0])||t.EventHandler.remove(this.inputWrapper.buttons[0],"mousedown",this.dropDownClick),this.inputElement&&(t.EventHandler.remove(this.inputElement,"focus",this.targetFocus),this.readonly||(t.EventHandler.remove(this.inputElement,"input",this.onInput),t.EventHandler.remove(this.inputElement,"keyup",this.onFilterUp),t.EventHandler.remove(this.inputElement,"keydown",this.onFilterDown),t.EventHandler.remove(this.inputElement,"paste",this.pasteHandler))),this.unBindCommonEvent()},i.prototype.setSelection=function(i,s){e.prototype.setSelection.call(this,i,s),t.isNullOrUndefined(i)||this.autofill||this.isDropDownClick||this.removeFocus()},i.prototype.selectCurrentItem=function(e){var i;this.isPopupOpen&&((i=this.isSelected?this.list.querySelector("."+N.selected):this.list.querySelector("."+N.focus))&&(this.setSelection(i,e),this.isTyped=!1),this.isSelected&&(this.isSelectCustom=!1,this.onChangeEvent(e))),"enter"===e.action&&""===this.inputElement.value.trim()?this.clearAll(e):this.isTyped&&!this.isSelected&&t.isNullOrUndefined(i)&&this.customValue(e),this.hidePopup()},i.prototype.setHoverList=function(e){this.removeSelection(),this.isValidLI(e)&&!e.classList.contains(N.selected)&&(this.removeFocus(),e.classList.add(N.focus))},i.prototype.targetFocus=function(e){t.Browser.isDevice&&!this.allowFiltering&&(this.preventFocus=!1),this.onFocus(e)},i.prototype.dropDownClick=function(i){i.preventDefault(),t.Browser.isDevice&&!this.isFiltering()&&(this.preventFocus=!0),e.prototype.dropDownClick.call(this,i)},i.prototype.customValue=function(e){var i=this,s=this.getValueByText(this.inputElement.value);if(this.allowCustom||""===this.inputElement.value)if(""!==this.inputElement.value.trim()){var l=this.value;if(t.isNullOrUndefined(s)){var o=""===this.inputElement.value?null:this.inputElement.value,r={text:o,item:{}};this.initial?this.updateCustomValueCallback(o,r,l):this.trigger("customValueSpecifier",r,function(t){i.updateCustomValueCallback(o,t,l,e)})}else this.isSelectCustom=!1,this.setProperties({value:s}),l!==this.value&&this.onChangeEvent(e)}else this.allowCustom&&(this.isSelectCustom=!0);else{var a=this.previousValue,h=this.value;this.setProperties({value:s}),t.isNullOrUndefined(this.value)&&n.Input.setValue("",this.inputElement,this.floatLabelType,this.showClearButton),this.autofill&&a===this.value&&h!==this.value&&this.onChangeEvent(null)}},i.prototype.updateCustomValueCallback=function(e,i,s,l){var n=this.fields,o=i.item,r={};o&&t.getValue(n.text,o)&&t.getValue(n.value,o)?r=o:(t.setValue(n.text,e,r),t.setValue(n.value,e,r)),this.itemData=r;var a={text:t.getValue(n.text,this.itemData),value:t.getValue(n.value,this.itemData),index:null};this.setProperties(a,!0),this.setSelection(null,null),this.isSelectCustom=!0,s!==this.value&&this.onChangeEvent(l)},i.prototype.onPropertyChanged=function(i,s){"combobox"===this.getModuleName()&&(this.checkData(i),this.setUpdateInitial(["fields","query","dataSource"],i));for(var l=0,o=Object.keys(i);l<o.length;l++){var r=o[l];switch(r){case"readonly":n.Input.setReadonly(this.readonly,this.inputElement),this.readonly?(t.EventHandler.remove(this.inputElement,"input",this.onInput),t.EventHandler.remove(this.inputElement,"keyup",this.onFilterUp),t.EventHandler.remove(this.inputElement,"keydown",this.onFilterDown)):(t.EventHandler.add(this.inputElement,"input",this.onInput,this),t.EventHandler.add(this.inputElement,"keyup",this.onFilterUp,this),t.EventHandler.add(this.inputElement,"keydown",this.onFilterDown,this)),this.setReadOnly();break;case"allowFiltering":this.setSearchBox(),this.isFiltering()&&"combobox"===this.getModuleName()&&t.isNullOrUndefined(this.list)&&e.prototype.renderList.call(this);break;case"allowCustom":break;default:var a=this.getPropObject(r,i,s);e.prototype.onPropertyChanged.call(this,a.newProperty,a.oldProperty),this.isFiltering()&&"dataSource"===r&&t.isNullOrUndefined(this.list)&&this.itemTemplate&&"combobox"===this.getModuleName()&&e.prototype.renderList.call(this)}}},i.prototype.render=function(){e.prototype.render.call(this),this.setSearchBox(),this.isFiltering()&&"combobox"===this.getModuleName()&&t.isNullOrUndefined(this.list)&&e.prototype.renderList.call(this),this.renderComplete()},i.prototype.getModuleName=function(){return"combobox"},i.prototype.addItem=function(t,i){e.prototype.addItem.call(this,t,i)},i.prototype.filter=function(t,i,s){e.prototype.filter.call(this,t,i,s)},i.prototype.showPopup=function(){e.prototype.showPopup.call(this)},i.prototype.hidePopup=function(i){var s=this.inputElement&&""===this.inputElement.value?null:this.inputElement&&this.inputElement.value;if(!t.isNullOrUndefined(this.listData)){var l=this.isEscapeKey;this.isEscapeKey&&(n.Input.setValue(this.typedString,this.inputElement,this.floatLabelType,this.showClearButton),this.isEscapeKey=!1),this.autofill&&this.removeFillSelection();var o=this.isSelectCustom?{text:""}:this.getItemData(),r=this.list.querySelector("."+N.selected);if(this.inputElement&&o.text===this.inputElement.value&&!t.isNullOrUndefined(r))return this.isSelected&&(this.onChangeEvent(i),this.isSelectCustom=!1),void e.prototype.hidePopup.call(this,i);if("combobox"===this.getModuleName()&&""!==this.inputElement.value.trim()){var a=h(this.inputElement.value,this.liCollections,"Equal",!0);this.selectedLI=a.item,t.isNullOrUndefined(a.index)&&(a.index=h(this.inputElement.value,this.liCollections,"StartsWith",!0).index),this.activeIndex=a.index,t.isNullOrUndefined(this.selectedLI)?l&&(this.isSelectCustom=!0,this.removeSelection()):this.updateSelectedItem(this.selectedLI,null,!0)}this.isEscapeKey||!this.isTyped||this.isInteracted||this.customValue(i)}t.isNullOrUndefined(this.listData)&&this.allowCustom&&!t.isNullOrUndefined(s)&&s!==this.value&&this.customValue(),e.prototype.hidePopup.call(this,i)},i.prototype.focusIn=function(){this.enabled&&(t.Browser.isDevice&&!this.isFiltering()&&(this.preventFocus=!0),e.prototype.focusIn.call(this))},i.prototype.clear=function(){this.value=null},i.prototype.focusOut=function(t){e.prototype.focusOut.call(this,t)},i.prototype.getItems=function(){return e.prototype.getItems.call(this)},i.prototype.getDataByValue=function(t){return e.prototype.getDataByValue.call(this,t)},i.prototype.renderHightSearch=function(){},oe([t.Property(!1)],i.prototype,"autofill",void 0),oe([t.Property(!0)],i.prototype,"allowCustom",void 0),oe([t.Property({})],i.prototype,"htmlAttributes",void 0),oe([t.Property(!1)],i.prototype,"allowFiltering",void 0),oe([t.Property(null)],i.prototype,"query",void 0),oe([t.Property(null)],i.prototype,"index",void 0),oe([t.Property(!0)],i.prototype,"showClearButton",void 0),oe([t.Property(!1)],i.prototype,"enableRtl",void 0),oe([t.Event()],i.prototype,"customValueSpecifier",void 0),oe([t.Event()],i.prototype,"filtering",void 0),oe([t.Property(null)],i.prototype,"valueTemplate",void 0),oe([t.Property("Never")],i.prototype,"floatLabelType",void 0),oe([t.Property(null)],i.prototype,"filterBarPlaceholder",void 0),oe([t.Property(null)],i.prototype,"cssClass",void 0),oe([t.Property(null)],i.prototype,"headerTemplate",void 0),oe([t.Property(null)],i.prototype,"footerTemplate",void 0),oe([t.Property(null)],i.prototype,"placeholder",void 0),oe([t.Property("100%")],i.prototype,"width",void 0),oe([t.Property("300px")],i.prototype,"popupHeight",void 0),oe([t.Property("100%")],i.prototype,"popupWidth",void 0),oe([t.Property(!1)],i.prototype,"readonly",void 0),oe([t.Property(null)],i.prototype,"text",void 0),oe([t.Property(null)],i.prototype,"value",void 0),i=oe([t.NotifyPropertyChanges],i)}(W),pe=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),ue=function(e,t,i,s){var l,n=arguments.length,o=n<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)o=Reflect.decorate(e,t,i,s);else for(var r=e.length-1;r>=0;r--)(l=e[r])&&(o=(n<3?l(o):n>3?l(t,i,o):l(t,i))||o);return n>3&&o&&Object.defineProperty(t,i,o),o};N.root="e-autocomplete",N.icon="e-input-group-icon e-ddl-icon e-search-icon";var ce=function(e){function s(t,i){var s=e.call(this,t,i)||this;return s.isFiltered=!1,s.searchList=!1,s}return pe(s,e),s.prototype.preRender=function(){e.prototype.preRender.call(this)},s.prototype.getLocaleName=function(){return"auto-complete"},s.prototype.getNgDirective=function(){return"EJS-AUTOCOMPLETE"},s.prototype.getQuery=function(e){var s=e?e.clone():this.query?this.query.clone():new i.Query,l=""!==this.queryString||t.isNullOrUndefined(this.value)?this.filterType:"equal",n=""!==this.queryString||t.isNullOrUndefined(this.value)?this.queryString:this.value;if(this.isFiltered)return s;if(null!==this.queryString&&""!==this.queryString){var o=this.typeOfData(this.dataSource).typeof;if((this.dataSource instanceof i.DataManager||"string"!==o)&&"number"!==o){var r=t.isNullOrUndefined(this.fields.value)?"":this.fields.value;s.where(r,l,n,this.ignoreCase,this.ignoreAccent)}else s.where("",l,n,this.ignoreCase,this.ignoreAccent)}if(!t.isNullOrUndefined(this.suggestionCount)){if(20!==this.suggestionCount)for(var a=0;a<s.queries.length;a++)"onTake"===s.queries[a].fn&&s.queries.splice(a,1);s.take(this.suggestionCount)}return s},s.prototype.searchLists=function(i){var s=this;if(this.isTyped=!0,this.isDataFetched=this.isSelectCustom=!1,t.isNullOrUndefined(this.list)&&e.prototype.renderList.call(this,!0),this.queryString=this.filterInput.value,"mousedown"!==i.type&&(40===i.keyCode||38===i.keyCode))return this.queryString=""===this.queryString?null:this.queryString,this.beforePopupOpen=!0,void this.resetList(this.dataSource,this.fields);this.isSelected=!1,this.activeIndex=null;var l={preventDefaultAction:!1,text:this.filterInput.value,updateData:function(e,t,i){l.cancel||(s.isFiltered=!0,s.filterAction(e,t,i))},cancel:!1};this.trigger("filtering",l,function(e){e.cancel||s.isFiltered||e.preventDefaultAction||(s.searchList=!0,s.filterAction(s.dataSource,null,s.fields))})},s.prototype.filter=function(e,t,i){this.isFiltered=!0,this.filterAction(e,t,i)},s.prototype.filterAction=function(e,t,i){this.beforePopupOpen=!0,""!==this.queryString&&this.queryString.length>=this.minLength?this.resetList(e,i,t):(this.hidePopup(),this.beforePopupOpen=!1),this.renderReactTemplates()},s.prototype.clearAll=function(i,s){(t.isNullOrUndefined(s)||!t.isNullOrUndefined(s)&&t.isNullOrUndefined(s.dataSource))&&e.prototype.clearAll.call(this,i),this.beforePopupOpen&&this.hidePopup()},s.prototype.onActionComplete=function(i,s,l,n){this.fixedHeaderElement=null,e.prototype.onActionComplete.call(this,i,s,l);var o=this.list.querySelector("."+N.li);t.isNullOrUndefined(o)||t.removeClass([o],N.focus),this.postBackAction()},s.prototype.postBackAction=function(){if(this.autofill&&!t.isNullOrUndefined(this.liCollections[0])&&this.searchList){var i=[this.liCollections[0]],s=h(this.inputElement.value,i,"StartsWith",this.ignoreCase);this.searchList=!1,t.isNullOrUndefined(s.item)||e.prototype.setAutoFill.call(this,this.liCollections[0],!0)}},s.prototype.setSelection=function(i,s){if(this.isValidLI(i))if(!t.isNullOrUndefined(s)&&"keydown"===s.type&&"enter"!==s.action&&"tab"!==s.action&&this.isValidLI(i)){var l=this.getFormattedValue(i.getAttribute("data-value"));this.activeIndex=this.getIndexByValue(l),this.setHoverList(i),this.selectedLI=i,this.setScrollPosition(s),this.autofill&&this.isPopupOpen&&(this.preventAutoFill=!1,e.prototype.setAutoFill.call(this,i)),t.attributes(this.inputElement,{"aria-activedescendant":this.selectedLI?this.selectedLI.id:null})}else e.prototype.setSelection.call(this,i,s)},s.prototype.listOption=function(i,s){var l=this,n=e.prototype.listOption.call(this,i,s);if(t.isNullOrUndefined(n.itemCreated))n.itemCreated=function(e){l.highlight&&(l.element.tagName===l.getNgDirective()&&l.itemTemplate?setTimeout(function(){u(e.item,l.queryString,l.ignoreCase,l.filterType)},0):u(e.item,l.queryString,l.ignoreCase,l.filterType))};else{var o=n.itemCreated;n.itemCreated=function(e){l.highlight&&u(e.item,l.queryString,l.ignoreCase,l.filterType),o.apply(l,[e])}}return n},s.prototype.isFiltering=function(){return!0},s.prototype.renderPopup=function(){this.list.scrollTop=0,e.prototype.renderPopup.call(this)},s.prototype.isEditTextBox=function(){return""!==this.inputElement.value.trim()},s.prototype.isPopupButton=function(){return this.showPopupButton},s.prototype.isSelectFocusItem=function(e){return!1},s.prototype.showPopup=function(){this.enabled&&(this.beforePopupOpen?this.refreshPopup():(this.beforePopupOpen=!0,this.preventAutoFill=!0,t.isNullOrUndefined(this.list)?this.renderList():this.resetList(this.dataSource,this.fields)))},s.prototype.hidePopup=function(){e.prototype.hidePopup.call(this),this.activeIndex=-1},s.prototype.onPropertyChanged=function(i,s){"autocomplete"===this.getModuleName()&&this.setUpdateInitial(["fields","query","dataSource"],i);for(var l=0,o=Object.keys(i);l<o.length;l++){var r=o[l];switch(r){case"showPopupButton":if(this.showPopupButton){var a=n.Input.appendSpan(N.icon,this.inputWrapper.container,this.createElement);this.inputWrapper.buttons[0]=a,this.inputWrapper&&this.inputWrapper.buttons&&this.inputWrapper.buttons[0]&&t.EventHandler.add(this.inputWrapper.buttons[0],"click",this.dropDownClick,this)}else t.detach(this.inputWrapper.buttons[0]),this.inputWrapper.buttons[0]=null;break;default:var h=this.getPropObject(r,i,s);e.prototype.onPropertyChanged.call(this,h.newProperty,h.oldProperty)}}},s.prototype.renderHightSearch=function(){if(this.highlight)for(var e=0;e<this.liCollections.length;e++){this.ulElement.querySelector(".e-active")||(d(this.liCollections[e]),u(this.liCollections[e],this.queryString,this.ignoreCase,this.filterType))}},s.prototype.getModuleName=function(){return"autocomplete"},s.prototype.render=function(){e.prototype.render.call(this)},ue([t.Complex({value:null,iconCss:null,groupBy:null},D)],s.prototype,"fields",void 0),ue([t.Property(!0)],s.prototype,"ignoreCase",void 0),ue([t.Property(!1)],s.prototype,"showPopupButton",void 0),ue([t.Property(!1)],s.prototype,"highlight",void 0),ue([t.Property(20)],s.prototype,"suggestionCount",void 0),ue([t.Property({})],s.prototype,"htmlAttributes",void 0),ue([t.Property(null)],s.prototype,"query",void 0),ue([t.Property(1)],s.prototype,"minLength",void 0),ue([t.Property("Contains")],s.prototype,"filterType",void 0),ue([t.Event()],s.prototype,"filtering",void 0),ue([t.Property(null)],s.prototype,"index",void 0),ue([t.Property("Never")],s.prototype,"floatLabelType",void 0),ue([t.Property(null)],s.prototype,"valueTemplate",void 0),ue([t.Property(null)],s.prototype,"filterBarPlaceholder",void 0),ue([t.Property(!1)],s.prototype,"allowFiltering",void 0),ue([t.Property(null)],s.prototype,"text",void 0),s=ue([t.NotifyPropertyChanges],s)}(he),de="e-float-line",me="e-float-text",fe="e-label-top",ve="e-label-bottom",ye=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),ge=function(e,t,i,s){var l,n=arguments.length,o=n<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)o=Reflect.decorate(e,t,i,s);else for(var r=e.length-1;r>=0;r--)(l=e[r])&&(o=(n<3?l(o):n>3?l(t,i,o):l(t,i))||o);return n>3&&o&&Object.defineProperty(t,i,o),o},Ce="e-input-focus",be="e-hide-listitem",Ee="e-chips",Se="e-chips-close",xe="e-chip-selected",we="e-zero-size",Oe="e-chips-close e-close-hooker",ke="e-close-icon-hide",Ae="e-ddl-disable-icon",De="e-ms-spinner-icon",Ie="e-input-group-icon e-ddl-icon",Le="e-delim-total",Be="e-search-custom-width",Te="e-input-filter",Ne=function(e){function s(t,i){var s=e.call(this,t,i)||this;return s.clearIconWidth=0,s.isValidKey=!1,s.selectAllEventData=[],s.selectAllEventEle=[],s.scrollFocusStatus=!1,s.keyDownStatus=!1,s}return ye(s,e),s.prototype.enableRTL=function(e){e?this.overAllWrapper.classList.add("e-rtl"):this.overAllWrapper.classList.remove("e-rtl"),this.popupObj&&(this.popupObj.enableRtl=e,this.popupObj.dataBind())},s.prototype.requiredModules=function(){var e=[];if("CheckBox"===this.mode){if(this.isGroupChecking=this.enableGroupCheckBox,this.enableGroupCheckBox){var t=this.isProtectedOnChange;this.isProtectedOnChange=!0,this.enableSelectionOrder=!1,this.isProtectedOnChange=t}this.allowCustomValue=!1,this.hideSelectedItem=!1,this.closePopupOnSelect=!1,e.push({member:"CheckBoxSelection",args:[this]})}return e},s.prototype.updateHTMLAttribute=function(){if(Object.keys(this.htmlAttributes).length)for(var e=0,i=Object.keys(this.htmlAttributes);e<i.length;e++){var s=i[e];switch(s){case"class":var l=this.htmlAttributes[s].replace(/\s+/g," ").trim();""!==l&&(t.addClass([this.overAllWrapper],l.split(" ")),t.addClass([this.popupWrapper],l.split(" ")));break;case"disabled":this.enable(!1);break;case"placeholder":this.placeholder||(this.inputElement.setAttribute(s,this.htmlAttributes[s]),this.setProperties({placeholder:this.inputElement.placeholder},!0),this.refreshPlaceHolder());break;default:["id"].indexOf(s)>-1?this.element.setAttribute(s,this.htmlAttributes[s]):0===s.indexOf("data")||["name","required","aria-required","form"].indexOf(s)>-1?this.hiddenElement.setAttribute(s,this.htmlAttributes[s]):["title","role","style","class"].indexOf(s)>-1?this.overAllWrapper.setAttribute(s,this.htmlAttributes[s]):this.inputElement.setAttribute(s,this.htmlAttributes[s])}}},s.prototype.updateReadonly=function(e){e||"CheckBox"===this.mode?this.inputElement.setAttribute("readonly","true"):this.inputElement.removeAttribute("readonly")},s.prototype.updateClearButton=function(e){e?(this.overAllClear.parentNode?this.overAllClear.style.display="":this.componentWrapper.appendChild(this.overAllClear),this.componentWrapper.classList.remove(ke)):(this.overAllClear.style.display="none",this.componentWrapper.classList.add(ke))},s.prototype.updateCssClass=function(){if(!t.isNullOrUndefined(this.cssClass)&&""!==this.cssClass){var e=this.cssClass;""!==(e=this.cssClass.replace(/\s+/g," ").trim())&&(t.addClass([this.overAllWrapper],e.split(" ")),t.addClass([this.popupWrapper],e.split(" ")))}},s.prototype.updateOldPropCssClass=function(e){t.isNullOrUndefined(e)||""===e||""!==(e=e.replace(/\s+/g," ").trim())&&(t.removeClass([this.overAllWrapper],e.split(" ")),t.removeClass([this.popupWrapper],e.split(" ")))},s.prototype.onPopupShown=function(){var e=this;if(t.Browser.isDevice&&"CheckBox"===this.mode&&this.allowFiltering){var i=this;window.onpopstate=function(){i.hidePopup(),i.inputElement.focus()},history.pushState({},"")}var s={popup:this.popupObj,cancel:!1,animation:{name:"FadeIn",duration:100}};this.trigger("open",s,function(i){i.cancel||(e.focusAtFirstListItem(),document.body.appendChild(e.popupObj.element),"CheckBox"===e.mode&&e.enableGroupCheckBox&&!t.isNullOrUndefined(e.fields.groupBy)&&e.updateListItems(e.list.querySelectorAll("li.e-list-item"),e.mainList.querySelectorAll("li.e-list-item")),("CheckBox"===e.mode||e.showDropDownIcon)&&t.addClass([e.overAllWrapper],["e-icon-anim"]),e.refreshPopup(),e.renderReactTemplates(),e.popupObj.show(i.animation,1e3===e.zIndex?e.element:null),t.attributes(e.inputElement,{"aria-expanded":"true"}),e.isFirstClick&&e.loadTemplate())})},s.prototype.updateListItems=function(e,t){for(var i=0;i<e.length;i++)this.findGroupStart(e[i]),this.findGroupStart(t[i]);this.deselectHeader()},s.prototype.loadTemplate=function(){this.refreshListItems(null),"CheckBox"===this.mode&&this.removeFocus(),this.notify("reOrder",{module:"CheckBoxSelection",enable:"CheckBox"===this.mode,e:this})},s.prototype.setScrollPosition=function(){if((!this.hideSelectedItem&&"CheckBox"!==this.mode||"CheckBox"===this.mode&&!this.enableSelectionOrder)&&!t.isNullOrUndefined(this.value)&&this.value.length>0){var e=this.findListElement(this.hideSelectedItem?this.ulElement:this.list,"li","data-value",this.value[this.value.length-1]);t.isNullOrUndefined(e)||this.scrollBottom(e)}},s.prototype.focusAtFirstListItem=function(){if(this.ulElement&&this.ulElement.querySelector("li."+I.li)){var e=void 0;if("CheckBox"===this.mode)return void this.removeFocus();null!==(e=this.ulElement.querySelector("li."+I.li+":not(."+be+")"))&&(this.removeFocus(),this.addListFocus(e))}},s.prototype.focusAtLastListItem=function(e){var t;e?t=h(e,this.liCollections,"StartsWith",this.ignoreCase):this.value&&this.value.length?h(this.value[this.value.length-1],this.liCollections,"StartsWith",this.ignoreCase):t=null,t&&null!==t.item&&(this.addListFocus(t.item),this.scrollBottom(t.item,t.index))},s.prototype.getAriaAttributes=function(){return{"aria-disabled":"false","aria-owns":this.element.id+"_options",role:"listbox","aria-multiselectable":"true","aria-activedescendant":"null","aria-haspopup":"true","aria-expanded":"false"}},s.prototype.updateListARIA=function(){t.isNullOrUndefined(this.ulElement)||t.attributes(this.ulElement,{id:this.element.id+"_options",role:"listbox","aria-hidden":"false"});var e=!!this.inputElement.disabled;t.attributes(this.inputElement,this.getAriaAttributes()),e&&t.attributes(this.inputElement,{"aria-disabled":"true"}),this.ensureAriaDisabled(e?"true":"false")},s.prototype.ensureAriaDisabled=function(e){if(this.htmlAttributes&&this.htmlAttributes["aria-disabled"]){var i=this.htmlAttributes;t.extend(i,{"aria-disabled":e},i),this.setProperties({htmlAttributes:i},!0)}},s.prototype.removelastSelection=function(e){var i=this.chipCollectionWrapper.querySelectorAll("span."+Ee),s=i[i.length-1].getAttribute("data-value");t.isNullOrUndefined(this.value)||(this.tempValues=this.value.slice());var l=this.getFormattedValue(s);this.allowCustomValue&&("false"!==s&&!1===l||!t.isNullOrUndefined(l)&&"NaN"===l.toString())&&(l=s),this.removeValue(l,e),this.removeChipSelection(),this.updateDelimeter(this.delimiterChar,e),this.makeTextBoxEmpty(),this.mainList&&this.listData&&this.refreshSelection(),this.checkPlaceholderSize()},s.prototype.onActionFailure=function(t){e.prototype.onActionFailure.call(this,t),this.renderPopup(),this.onPopupShown()},s.prototype.targetElement=function(){return this.targetInputElement=this.inputElement,"CheckBox"===this.mode&&this.allowFiltering&&this.notify("targetElement",{module:"CheckBoxSelection",enable:"CheckBox"===this.mode}),this.targetInputElement.value},s.prototype.getForQuery=function(e){for(var s,l=t.isNullOrUndefined(this.fields.value)?this.fields.text:this.fields.value,n=0;n<e.length;n++)s=0===n?new i.Predicate(l,"equal",e[n]):s.or(l,"equal",e[n]);return this.getQuery(this.query).where(s)},s.prototype.onActionComplete=function(s,l,n,o){e.prototype.onActionComplete.call(this,s,l,n),this.updateSelectElementData(this.allowFiltering);if(!t.isNullOrUndefined(this.value)&&!this.allowCustomValue)for(var r=0;r<this.value.length;r++){this.findListElement(this.allowFiltering&&!t.isNullOrUndefined(this.mainList)?this.mainList:s,"li","data-value",this.value[r])||(this.value.splice(r,1),r-=1)}this.updateActionList(s,l,n),this.dataSource instanceof i.DataManager&&"CheckBox"===this.mode&&this.allowFiltering&&this.removeFocus()},s.prototype.updateActionList=function(e,s,l,n){"CheckBox"===this.mode&&this.showSelectAll&&this.notify("selectAll",{module:"CheckBoxSelection",enable:"CheckBox"===this.mode}),this.mainList||this.mainData?(t.isNullOrUndefined(this.mainData)||0===this.mainData.length)&&(this.mainData=s):(this.mainList=e.cloneNode?e.cloneNode(!0):e,this.mainData=s,this.mainListCollection=this.liCollections),(this.remoteCustomValue||s.length<=0)&&this.allowCustomValue&&this.inputFocus&&this.allowFiltering&&this.inputElement.value&&""!==this.inputElement.value?this.checkForCustomValue(this.tempQuery,this.fields):(this.value&&this.value.length&&("CheckBox"!==this.mode&&""!==this.inputElement.value.trim()||"CheckBox"===this.mode||(8===this.keyCode||46===this.keyCode)&&this.allowFiltering&&this.allowCustomValue&&this.dataSource instanceof i.DataManager&&""===this.inputElement.value)&&this.refreshSelection(),this.updateListARIA(),this.unwireListEvents(),this.wireListEvents(),t.isNullOrUndefined(this.setInitialValue)||this.setInitialValue(),t.isNullOrUndefined(this.selectAllAction)||this.selectAllAction(),this.setDynValue&&(t.isNullOrUndefined(this.text)||!t.isNullOrUndefined(this.value)&&0!==this.value.length||this.initialTextUpdate(),this.initialValueUpdate(),this.initialUpdate(),this.refreshPlaceHolder(),"CheckBox"!==this.mode&&this.changeOnBlur&&this.updateValueState(null,this.value,null)),this.renderPopup(),this.beforePopupOpen&&(this.beforePopupOpen=!1,this.onPopupShown()))},s.prototype.refreshSelection=function(){var e,i,s=this.hideSelectedItem?be:I.selected;if(!t.isNullOrUndefined(this.value))for(var l=0;!t.isNullOrUndefined(this.value[l]);l++)if(e=this.value[l],i=this.findListElement(this.list,"li","data-value",e)){if(t.addClass([i],s),this.hideSelectedItem&&i.previousSibling&&i.previousElementSibling.classList.contains(I.group)&&(!i.nextElementSibling||i.nextElementSibling.classList.contains(I.group))&&t.addClass([i.previousElementSibling],s),this.hideSelectedItem&&this.fields.groupBy&&!i.previousElementSibling.classList.contains(be)&&this.hideGroupItem(e),this.hideSelectedItem&&i.classList.contains(I.focus)){t.removeClass([i],I.focus);var n=i.parentElement.querySelectorAll("."+I.li+":not(."+be+")");n.length>0?t.addClass([n[0]],I.focus):this.list&&this.list.querySelectorAll("."+I.li).length>0||(this.l10nUpdate(),t.addClass([this.list],I.noData))}if(i.setAttribute("aria-selected","true"),"CheckBox"===this.mode&&i.classList.contains("e-active")){var o=i.firstElementChild.getAttribute("aria-checked");if(t.isNullOrUndefined(o)||"false"===o){var r={module:"CheckBoxSelection",enable:"CheckBox"===this.mode,li:i,e:null};this.notify("updatelist",r)}}}this.checkSelectAll(),this.checkMaxSelection()},s.prototype.hideGroupItem=function(e){var i,s,l=this.hideSelectedItem?be:I.selected;s=i=this.findListElement(this.ulElement,"li","data-value",e);var n=0,o=0,r=!0,a=!0;do{i&&i.previousElementSibling&&!i.previousElementSibling.classList.contains(be)&&i.previousElementSibling.classList.contains(I.li)&&(r=!1),!r||!i||i.previousElementSibling&&i.previousElementSibling.classList.contains(I.group)?n=10:i=i.previousElementSibling,s&&s.nextElementSibling&&!s.nextElementSibling.classList.contains(be)&&s.nextElementSibling.classList.contains(I.li)&&(a=!1),!a||!s||s.nextElementSibling&&s.nextElementSibling.classList.contains(I.group)?o=10:s=s.nextElementSibling}while(n<10||o<10);r&&a&&!i.previousElementSibling.classList.contains(be)?t.addClass([i.previousElementSibling],l):r&&a&&i.previousElementSibling.classList.contains(be)&&t.removeClass([i.previousElementSibling],l)},s.prototype.getValidLi=function(){var e=this.ulElement.querySelector("li."+I.li+":not(."+be+")");return t.isNullOrUndefined(e)?this.liCollections[0]:e},s.prototype.checkSelectAll=function(){var e=this.list.querySelectorAll("li.e-list-group-item.e-active").length,i=this.list.querySelectorAll("li.e-list-item"),s=this.list.querySelectorAll("li."+I.li).length,l=this.list.querySelectorAll("li."+I.selected).length;if(this.enableGroupCheckBox&&!t.isNullOrUndefined(this.fields.groupBy)&&(l-=e),s!==l&&l!==this.maximumSelectionLength||"CheckBox"!==this.mode||!this.showSelectAll?s!==l&&"CheckBox"===this.mode&&this.showSelectAll&&this.notify("checkSelectAll",{module:"CheckBoxSelection",enable:"CheckBox"===this.mode,value:"uncheck"}):this.notify("checkSelectAll",{module:"CheckBoxSelection",enable:"CheckBox"===this.mode,value:"check"}),this.enableGroupCheckBox&&this.fields.groupBy&&!this.enableSelectionOrder){for(var n=0;n<i.length;n++)this.findGroupStart(i[n]);this.deselectHeader()}},s.prototype.openClick=function(e){this.openOnClick||"CheckBox"===this.mode?this.openOnClick||"CheckBox"!==this.mode||this.isPopupOpen()||this.showPopup():""!==this.targetElement()?this.showPopup():this.hidePopup()},s.prototype.keyUp=function(e){if("CheckBox"===this.mode&&!this.openOnClick){var i=String.fromCharCode(e.keyCode).match(/\w/);t.isNullOrUndefined(i)||(this.isValidKey=!0)}this.isValidKey=this.isPopupOpen()&&8===e.keyCode||this.isValidKey,this.isValidKey=(!e.ctrlKey||86!==e.keyCode)&&this.isValidKey,this.isValidKey&&(this.isValidKey=!1,this.expandTextbox(),this.showOverAllClear(),e.keyCode,this.search(e))},s.prototype.filter=function(e,t,i){this.isFiltered=!0,this.remoteFilterAction=!0,this.dataUpdater(e,t,i)},s.prototype.getQuery=function(e){var s=e?e.clone():this.query?this.query.clone():new i.Query;if(this.filterAction){if(null!==this.targetElement()){var l=this.typeOfData(this.dataSource).typeof;if((this.dataSource instanceof i.DataManager||"string"!==l)&&"number"!==l){var n=this.fields;s.where(t.isNullOrUndefined(n.text)?"":n.text,this.filterType,this.targetElement(),this.ignoreCase,this.ignoreAccent)}else s.where("",this.filterType,this.targetElement(),this.ignoreCase,this.ignoreAccent)}return s}return e||(this.query?this.query:new i.Query)},s.prototype.dataUpdater=function(e,t,s){if(this.isDataFetched=!1,""===this.targetElement().trim()){var l=this.mainList.cloneNode?this.mainList.cloneNode(!0):this.mainList;this.backCommand&&(this.remoteCustomValue=!1,this.allowCustomValue&&0==l.querySelectorAll("li").length&&this.mainData.length>0&&(this.mainData=[]),this.onActionComplete(l,this.mainData),this.value&&this.value.length&&this.refreshSelection(),8!==this.keyCode&&this.focusAtFirstListItem(),this.notify("reOrder",{module:"CheckBoxSelection",enable:"CheckBox"===this.mode,e:this}))}else this.resetList(e,s,t),this.allowCustomValue&&(e instanceof i.DataManager?(this.remoteCustomValue=!0,this.tempQuery=t):this.checkForCustomValue(t,s));this.refreshPopup(),"CheckBox"===this.mode&&this.removeFocus()},s.prototype.checkForCustomValue=function(e,i){var s=!this.getValueByText(this.inputElement.value,this.ignoreCase);if(this.allowCustomValue&&s){var l=this.inputElement.value,n=i||this.fields,o=!t.isNullOrUndefined(this.mainData)&&this.mainData.length>0?this.mainData[0]:this.mainData;if("string"!=typeof o&&"number"!=typeof o&&"boolean"!=typeof o){var r={};t.setValue(n.text,l,r),"number"==typeof t.getValue(this.fields.value?this.fields.value:"value",o)?t.setValue(n.value,Math.random(),r):t.setValue(n.value,l,r);(a=JSON.parse(JSON.stringify(this.listData))).splice(0,0,r),this.resetList(a,n,e)}else{var a;(a=[this.inputElement.value])[0]="number"!=typeof o||isNaN(parseFloat(a[0]))?a[0]:parseFloat(a[0]),a[0]="boolean"==typeof o?"true"===a[0]||"false"!==a[0]&&a[0]:a[0],this.resetList(a,n)}}this.value&&this.value.length&&this.refreshSelection()},s.prototype.getNgDirective=function(){return"EJS-MULTISELECT"},s.prototype.wrapperClick=function(e){if(this.setDynValue=!1,this.enabled)if(e.target!==this.overAllClear){if(this.inputFocus||this.inputElement.focus(),!this.readonly){if(e.target&&-1!==e.target.classList.toString().indexOf(Se))return void(this.isPopupOpen()&&this.refreshPopup());!this.isPopupOpen()&&(this.openOnClick||this.showDropDownIcon&&e.target&&e.target.className===Ie)?this.showPopup():(this.hidePopup(),"CheckBox"===this.mode&&(this.showOverAllClear(),this.inputFocus=!0,this.overAllWrapper.classList.contains(Ce)||this.overAllWrapper.classList.add(Ce)))}this.targetElement()&&""!==this.targetElement()||e.preventDefault()}else e.preventDefault()},s.prototype.enable=function(e){e?(this.overAllWrapper.classList.remove("e-disabled"),this.inputElement.removeAttribute("disabled"),t.attributes(this.inputElement,{"aria-disabled":"false"}),this.ensureAriaDisabled("false")):(this.overAllWrapper.classList.add("e-disabled"),this.inputElement.setAttribute("disabled","true"),t.attributes(this.inputElement,{"aria-disabled":"true"}),this.ensureAriaDisabled("true")),this.enabled!==e&&(this.enabled=e),this.hidePopup()},s.prototype.onBlurHandler=function(e,i){var s;if(t.isNullOrUndefined(e)||(s=e.relatedTarget),this.popupObj&&document.body.contains(this.popupObj.element)&&this.popupObj.element.contains(s))"CheckBox"!==this.mode?this.inputElement.focus():"Auto"===this.floatLabelType&&(this.overAllWrapper.classList.contains("e-outline")||this.overAllWrapper.classList.contains("e-filled"))&&t.addClass([this.overAllWrapper],"e-valid-input");else{if("Auto"===this.floatLabelType&&this.overAllWrapper.classList.contains("e-outline")&&"CheckBox"===this.mode&&(t.isNullOrUndefined(this.value)||0===this.value.length)&&t.removeClass([this.overAllWrapper],"e-valid-input"),"CheckBox"===this.mode&&t.Browser.isIE&&!t.isNullOrUndefined(e)&&!i)return this.inputFocus=!1,void this.overAllWrapper.classList.remove(Ce);if(this.scrollFocusStatus)return t.isNullOrUndefined(e)||e.preventDefault(),this.inputElement.focus(),void(this.scrollFocusStatus=!1);if(this.inputFocus=!1,this.overAllWrapper.classList.remove(Ce),this.addTagOnBlur){var l=this.getValueByText(this.inputElement.value,this.ignoreCase,this.ignoreAccent),n=this.findListElement(this.list,"li","data-value",l),o=this.hideSelectedItem?be:I.selected;!(!n||n.classList.contains(o))&&(this.updateListSelection(n,e),"Delimiter"===this.mode&&this.updateDelimeter(this.delimiterChar))}this.refreshListItems(null),"Box"!==this.mode&&"CheckBox"!==this.mode&&this.updateDelimView(),this.changeOnBlur&&(this.updateValueState(e,this.value,this.tempValues),this.dispatchEvent(this.hiddenElement,"change")),this.overAllClear.style.display="none",this.isPopupOpen()&&this.hidePopup(),this.makeTextBoxEmpty(),this.trigger("blur"),this.focused=!0,t.Browser.isDevice&&"Delimiter"!==this.mode&&"CheckBox"!==this.mode&&this.removeChipFocus(),this.removeChipSelection(),this.refreshInputHight(),C(this.overAllWrapper,this.componentWrapper,this.value,this.floatLabelType,this.placeholder),this.refreshPlaceHolder(),(this.allowFiltering||!0===this.enableSelectionOrder&&"CheckBox"===this.mode)&&!t.isNullOrUndefined(this.mainList)&&(this.ulElement=this.mainList),this.checkPlaceholderSize()}},s.prototype.checkPlaceholderSize=function(){if(this.showDropDownIcon){var e=this.dropIcon.offsetWidth+parseInt(window.getComputedStyle(this.dropIcon).marginRight,10);this.setPlaceholderSize(e)}else t.isNullOrUndefined(this.dropIcon)||this.setPlaceholderSize(this.showDropDownIcon?this.dropIcon.offsetWidth:0)},s.prototype.setPlaceholderSize=function(e){t.isNullOrUndefined(this.value)||0===this.value.length?0!==this.dropIcon.offsetWidth?this.searchWrapper.style.width="calc(100% - "+(e+10)+"px":t.addClass([this.searchWrapper],Be):t.isNullOrUndefined(this.value)||(this.searchWrapper.removeAttribute("style"),t.removeClass([this.searchWrapper],Be))},s.prototype.refreshInputHight=function(){this.value&&this.value.length||!t.isNullOrUndefined(this.text)&&""!==this.text?this.searchWrapper.classList.add(we):this.searchWrapper.classList.remove(we)},s.prototype.validateValues=function(e,t){return JSON.stringify(e.slice().sort())!==JSON.stringify(t.slice().sort())},s.prototype.updateValueState=function(e,t,i){var s=t||[],l=i||[];if(this.initStatus&&this.validateValues(s,l)){var n={e:e,oldValue:i,value:t,isInteracted:!!e,element:this.element,event:e};this.isAngular&&this.preventChange?this.preventChange=!1:this.trigger("change",n),this.updateTempValue(),this.changeOnBlur||this.dispatchEvent(this.hiddenElement,"change")}},s.prototype.updateTempValue=function(){this.value?this.tempValues=this.value.slice():this.tempValues=this.value},s.prototype.getPagingCount=function(){var e=this.list.classList.contains(I.noData)?null:getComputedStyle(this.getItems()[0],null).getPropertyValue("height");return Math.round(this.list.offsetHeight/parseInt(e,10))},s.prototype.pageUpSelection=function(e){var t=this.list.querySelectorAll("li."+I.li+":not(."+be+"):not(.e-reorder-hide)"),i=e>=0?t[e+1]:t[0];this.addListFocus(i),this.scrollBottom(i,this.getIndexByValue(i.getAttribute("data-value")))},s.prototype.pageDownSelection=function(e){this.getItems();var t=this.list.querySelectorAll("li."+I.li+":not(."+be+"):not(.e-reorder-hide)"),i=e<=t.length?t[e-1]:t[t.length-1];this.addListFocus(i),this.scrollBottom(i,this.getIndexByValue(i.getAttribute("data-value")))},s.prototype.getItems=function(){return this.list||e.prototype.render.call(this),this.ulElement&&this.ulElement.querySelectorAll("."+I.li).length>0?this.ulElement.querySelectorAll("."+I.li+":not(."+be+")"):[]},s.prototype.focusInHandler=function(e){if(this.enabled){if(this.showOverAllClear(),this.inputFocus=!0,this.value&&this.value.length&&("Delimiter"!==this.mode&&"CheckBox"!==this.mode?this.chipCollectionWrapper.style.display="":this.showDelimWrapper(),"CheckBox"!==this.mode&&(this.viewWrapper.style.display="none")),"CheckBox"!==this.mode&&this.searchWrapper.classList.remove(we),this.checkPlaceholderSize(),this.focused){var t={isInteracted:!!e,event:e};this.trigger("focus",t),this.focused=!1}return this.overAllWrapper.classList.contains(Ce)||this.overAllWrapper.classList.add(Ce),g(this.overAllWrapper,this.componentWrapper),this.isPopupOpen()&&this.refreshPopup(),!0}return!1},s.prototype.showDelimWrapper=function(){"CheckBox"===this.mode?this.viewWrapper.style.display="":this.delimiterWrapper.style.display="",this.componentWrapper.classList.add("e-delimiter")},s.prototype.hideDelimWrapper=function(){this.delimiterWrapper.style.display="none",this.componentWrapper.classList.remove("e-delimiter")},s.prototype.expandTextbox=function(){var e=5;this.placeholder&&(e=e>this.inputElement.placeholder.length?e:this.inputElement.placeholder.length),this.inputElement.value.length>e?this.inputElement.size=this.inputElement.value.length:this.inputElement.size=e},s.prototype.isPopupOpen=function(){return null!==this.popupWrapper&&null!==this.popupWrapper.parentElement},s.prototype.refreshPopup=function(){this.popupObj&&this.mobFilter&&(this.popupObj.setProperties({width:this.calcPopupWidth()}),this.popupObj.refreshPosition(this.overAllWrapper),this.popupObj.resolveCollision())},s.prototype.checkTextLength=function(){return this.targetElement().length<1},s.prototype.popupKeyActions=function(e){switch(e.keyCode){case 38:this.hidePopup(),"CheckBox"===this.mode&&this.inputElement.focus(),e.preventDefault();break;case 40:this.isPopupOpen()||(this.showPopup(),e.preventDefault())}},s.prototype.updateAriaAttribute=function(){var e=this.list.querySelector("."+I.focus);if(!t.isNullOrUndefined(e))if(this.inputElement.setAttribute("aria-activedescendant",e.id),this.allowFiltering){var i=this.popupWrapper.querySelector("."+Te);i&&i.setAttribute("aria-activedescendant",e.id)}else"CheckBox"==this.mode&&this.overAllWrapper.setAttribute("aria-activedescendant",e.id)},s.prototype.homeNavigation=function(e){this.removeFocus();var t=this.ulElement.querySelectorAll("li."+I.li+":not(."+be+"):not(.e-reorder-hide)");if(t.length>0){var i=t[e?0:t.length-1];i.classList.add(I.focus),this.scrollBottom(i)}},s.prototype.onKeyDown=function(e){if(!this.readonly&&(this.enabled||"CheckBox"===this.mode)&&(this.keyCode=e.keyCode,this.keyDownStatus=!0,!(e.keyCode>111&&e.keyCode<124)))if(e.altKey)this.popupKeyActions(e);else{if(this.isPopupOpen()){var t=this.list.querySelector("."+I.focus);switch(e.keyCode){case 36:case 35:this.homeNavigation(36===e.keyCode);break;case 33:return e.preventDefault(),void(t&&(this.getIndexByValue(t.getAttribute("data-value")),this.pageUpSelection(void 0-this.getPagingCount()),this.updateAriaAttribute()));case 34:return e.preventDefault(),void(t&&(this.getIndexByValue(t.getAttribute("data-value")),this.pageDownSelection(void 0+this.getPagingCount()),this.updateAriaAttribute()));case 38:this.arrowUp(e);break;case 40:this.arrowDown(e);break;case 27:return e.preventDefault(),this.hidePopup(),void("CheckBox"===this.mode&&this.inputElement.focus());case 13:return e.preventDefault(),"CheckBox"!==this.mode&&this.selectByKey(e),void this.checkPlaceholderSize();case 32:return void this.spaceKeySelection(e);case 9:e.preventDefault(),this.hidePopup(),this.inputElement.focus(),this.overAllWrapper.classList.add(Ce)}}else switch(e.keyCode){case 13:case 9:case 16:case 17:case 20:return;case 40:this.openOnClick&&this.showPopup();break;case 27:return e.preventDefault(),void this.escapeAction()}this.checkTextLength()&&this.keyNavigation(e),"CheckBox"===this.mode&&this.enableSelectionOrder&&this.checkBackCommand(e),this.expandTextbox(),"CheckBox"===this.mode&&this.showSelectAll||this.refreshPopup()}},s.prototype.arrowDown=function(e){e.preventDefault(),this.moveByList(1),this.keyAction=!0,(document.activeElement.classList.contains(Te)||"CheckBox"===this.mode&&!this.allowFiltering&&document.activeElement!==this.list)&&t.EventHandler.add(this.list,"keydown",this.onKeyDown,this),this.updateAriaAttribute()},s.prototype.arrowUp=function(e){e.preventDefault(),this.keyAction=!0;var i=this.list.querySelectorAll("li."+I.li+":not(."+be+"):not(.e-reorder-hide)");this.enableGroupCheckBox&&"CheckBox"===this.mode&&!t.isNullOrUndefined(this.fields.groupBy)&&(i=this.list.querySelectorAll("li."+I.li+",li."+I.group+":not(."+be+"):not(.e-reorder-hide)"));var s=this.list.querySelector("li."+I.focus);Array.prototype.slice.call(i).indexOf(s)<=0&&"CheckBox"===this.mode&&this.allowFiltering&&(this.keyAction=!1,this.notify("inputFocus",{module:"CheckBoxSelection",enable:"CheckBox"===this.mode,value:"focus"})),this.moveByList(-1),this.updateAriaAttribute()},s.prototype.spaceKeySelection=function(e){"CheckBox"===this.mode&&(document.activeElement.classList.contains(Te)||(e.preventDefault(),this.keyAction=!0,this.list.focus()),this.selectByKey(e)),this.checkPlaceholderSize()},s.prototype.checkBackCommand=function(e){8===e.keyCode&&""===this.targetElement()?this.backCommand=!1:this.backCommand=!0},s.prototype.keyNavigation=function(e){if("Delimiter"!==this.mode&&"CheckBox"!==this.mode&&this.value&&this.value.length)switch(e.keyCode){case 37:e.preventDefault(),this.moveBy(-1,e);break;case 39:e.preventDefault(),this.moveBy(1,e);break;case 8:this.removelastSelection(e);break;case 46:this.removeSelectedChip(e)}else if(8===e.keyCode&&"Delimiter"===this.mode&&this.value&&this.value.length){e.preventDefault();var t=this.value[this.value.length-1];this.removeValue(t,e),this.updateDelimeter(this.delimiterChar,e),this.focusAtLastListItem(t)}},s.prototype.selectByKey=function(e){this.removeChipSelection(),this.selectListByKey(e),this.hideSelectedItem&&this.focusAtFirstListItem()},s.prototype.escapeAction=function(){var e=this.tempValues?this.tempValues.slice():[];this.value&&this.validateValues(this.value,e)&&("CheckBox"!==this.mode&&(this.value=e,this.initialValueUpdate()),"Delimiter"!==this.mode&&"CheckBox"!==this.mode?this.chipCollectionWrapper.style.display="":this.showDelimWrapper(),this.refreshPlaceHolder(),this.value.length?this.showOverAllClear():this.hideOverAllClear()),this.makeTextBoxEmpty()},s.prototype.scrollBottom=function(e,i){var s=this.list.offsetHeight,l=e.offsetTop+e.offsetHeight-this.list.scrollTop,n=this.list.scrollTop+l-s,o=e.offsetTop+e.offsetHeight-this.list.scrollTop;o=this.fields.groupBy&&!t.isNullOrUndefined(this.fixedHeaderElement)?o-this.fixedHeaderElement.offsetHeight:o,0===i?this.list.scrollTop=0:l>s?this.list.scrollTop=n:o>0&&this.list.offsetHeight>o||(this.list.scrollTop=n)},s.prototype.scrollTop=function(e,i){var s=e.offsetTop-this.list.scrollTop;s=this.fields.groupBy&&!t.isUndefined(this.fixedHeaderElement)?s-this.fixedHeaderElement.offsetHeight:s;var l=e.offsetTop+e.offsetHeight-this.list.scrollTop;0===i?this.list.scrollTop=0:s<0?this.list.scrollTop=this.list.scrollTop+s:l>0&&this.list.offsetHeight>l||(this.list.scrollTop=e.offsetTop-(this.fields.groupBy&&!t.isUndefined(this.fixedHeaderElement)?this.fixedHeaderElement.offsetHeight:0))},s.prototype.selectListByKey=function(e){var i,s=this.list.querySelector("li."+I.focus),l=this.value&&this.value.length?this.value.length:0;null!==s&&(s.classList.contains("e-active")&&(l-=1),this.isValidLI(s)&&l<this.maximumSelectionLength?(this.updateListSelection(s,e),this.addListFocus(s),"CheckBox"===this.mode?(this.updateDelimView(),this.updateDelimeter(this.delimiterChar,e),this.refreshInputHight(),this.checkPlaceholderSize(),this.enableGroupCheckBox&&!t.isNullOrUndefined(this.fields.groupBy)&&(i=s.firstElementChild.lastElementChild,this.findGroupStart(i),this.deselectHeader())):this.updateDelimeter(this.delimiterChar,e),this.makeTextBoxEmpty(),"CheckBox"!==this.mode&&this.refreshListItems(s.textContent),this.changeOnBlur||this.updateValueState(e,this.value,this.tempValues),this.refreshPopup()):!this.isValidLI(s)&&l<this.maximumSelectionLength&&((i=s.firstElementChild.lastElementChild).classList.contains("e-check")?this.selectAllItem(!1,e,s):this.selectAllItem(!0,e,s)),this.refreshSelection(),this.closePopupOnSelect&&this.hidePopup()),this.refreshPlaceHolder()},s.prototype.refreshListItems=function(e){if((this.allowFiltering||"CheckBox"===this.mode&&!0===this.enableSelectionOrder||this.allowCustomValue)&&this.mainList&&this.listData){var t=this.mainList.cloneNode?this.mainList.cloneNode(!0):this.mainList;this.onActionComplete(t,this.mainData),this.focusAtLastListItem(e),this.value&&this.value.length&&this.refreshSelection()}},s.prototype.removeSelectedChip=function(e){var i,s=this.chipCollectionWrapper.querySelector("span."+xe);null!==s&&(t.isNullOrUndefined(this.value)||(this.tempValues=this.value.slice()),null!==(i=s.nextElementSibling)&&(this.removeChipSelection(),this.addChipSelection(i,e)),this.removeValue(s.getAttribute("data-value"),e),this.makeTextBoxEmpty()),this.closePopupOnSelect&&this.hidePopup(),this.checkPlaceholderSize()},s.prototype.moveByTop=function(e){var t,i=this.list.querySelectorAll("li."+I.li);i.length>1&&(this.removeFocus(),t=e?0:i.length-1,this.addListFocus(i[t]),this.scrollBottom(i[t],t)),this.updateAriaAttribute()},s.prototype.moveByList=function(e){if(this.list){var i=this.list.querySelectorAll("li."+I.li+":not(."+be+"):not(.e-reorder-hide)");"CheckBox"===this.mode&&this.enableGroupCheckBox&&!t.isNullOrUndefined(this.fields.groupBy)&&(i=this.list.querySelectorAll("li."+I.li+",li."+I.group+":not(."+be+"):not(.e-reorder-hide)"));var s=this.list.querySelector("li."+I.focus),l=-1;if(i.length){for(var n=0;n<i.length;n++)if(i[n]===s){l=n;break}e>0?l<i.length-1&&(this.removeFocus(),this.addListFocus(i[++l]),this.updateCheck(i[l]),this.scrollBottom(i[l],l)):l>0&&(this.removeFocus(),this.addListFocus(i[--l]),this.updateCheck(i[l]),this.scrollTop(i[l],l))}}},s.prototype.updateCheck=function(e){if("CheckBox"===this.mode&&this.enableGroupCheckBox&&!t.isNullOrUndefined(this.fields.groupBy)){e.firstElementChild.lastElementChild.classList.contains("e-check")?e.classList.add("e-active"):e.classList.remove("e-active")}},s.prototype.moveBy=function(e,t){var i,s=this.chipCollectionWrapper.querySelectorAll("span."+Ee),l=this.chipCollectionWrapper.querySelector("span."+xe);null===l?e<0&&this.addChipSelection(s[s.length-1],t):e<0?null!==(i=l.previousElementSibling)&&(this.removeChipSelection(),this.addChipSelection(i,t)):(i=l.nextElementSibling,this.removeChipSelection(),null!==i&&this.addChipSelection(i,t))},s.prototype.chipClick=function(e){if(this.enabled){var i=t.closest(e.target,"."+Ee);this.removeChipSelection(),this.addChipSelection(i,e)}},s.prototype.removeChipSelection=function(){this.chipCollectionWrapper&&this.removeChipFocus()},s.prototype.addChipSelection=function(e,i){t.addClass([e],xe),this.trigger("chipSelection",i)},s.prototype.onChipRemove=function(e){if(3!==e.which&&2!==e.button&&this.enabled&&!this.readonly){var i=e.target.parentElement.getAttribute("data-value"),s=this.getFormattedValue(i);if(this.allowCustomValue&&("false"!==i&&!1===s||!t.isNullOrUndefined(s)&&"NaN"===s.toString())&&(s=i),this.isPopupOpen()&&"CheckBox"!==this.mode&&this.hidePopup(),this.inputFocus||this.inputElement.focus(),this.removeValue(s,e),t.isNullOrUndefined(this.findListElement(this.list,"li","data-value",s))&&this.mainList&&this.listData){var l=this.mainList.cloneNode?this.mainList.cloneNode(!0):this.mainList;this.onActionComplete(l,this.mainData)}this.updateDelimeter(this.delimiterChar,e),this.placeholder&&"Never"===this.floatLabelType?(this.makeTextBoxEmpty(),this.checkPlaceholderSize()):this.inputElement.value="",e.preventDefault()}},s.prototype.makeTextBoxEmpty=function(){this.inputElement.value="",this.refreshPlaceHolder()},s.prototype.refreshPlaceHolder=function(){this.placeholder&&"Never"===this.floatLabelType?this.value&&this.value.length||!t.isNullOrUndefined(this.text)&&""!==this.text?this.inputElement.placeholder="":this.inputElement.placeholder=b(this.placeholder):this.setFloatLabelType(),this.expandTextbox()},s.prototype.removeAllItems=function(e,i,s,l,n){var o=this.value.indexOf(e),r=this.value.slice(0);r.splice(o,1),this.setProperties({value:[].concat([],r)},!0),l.setAttribute("aria-selected","false");var a=this.hideSelectedItem?be:I.selected;t.removeClass([l],a),this.notify("activeList",{module:"CheckBoxSelection",enable:"CheckBox"===this.mode,li:l,e:this,index:o}),this.invokeCheckboxSelection(l,i,s),this.updateMainList(!0,e,n),this.updateChipStatus()},s.prototype.invokeCheckboxSelection=function(e,i,s){this.notify("updatelist",{module:"CheckBoxSelection",enable:"CheckBox"===this.mode,li:e,e:i}),t.attributes(this.inputElement,{"aria-activedescendant":e.id}),this.value&&this.value.length!==this.mainData.length&&"CheckBox"===this.mode&&this.showSelectAll&&!this.isSelectAll&&!s&&this.notify("checkSelectAll",{module:"CheckBoxSelection",enable:"CheckBox"===this.mode,value:"uncheck"})},s.prototype.removeValue=function(i,s,l,n){var o=this,r=this.value.indexOf(this.getFormattedValue(i));-1===r&&this.allowCustomValue&&!t.isNullOrUndefined(i)&&(r=this.value.indexOf(i.toString()));var a=s&&s.target;n=!!(n||a&&a.classList.contains("e-close-hooker"))||null;var h=this.hideSelectedItem?be:I.selected;if(-1!==r){var p=this.findListElement(this.list,"li","data-value",i),u=this.getDataByValue(i),c={e:s,item:p,itemData:u,isInteracted:!!s,cancel:!1};this.trigger("removing",c,function(a){if(a.cancel)o.removeIndex++;else{var c=o.value.slice(0);if(c.splice(r,1),o.setProperties({value:[].concat([],c)},!0),null!==p){var d=o.findListElement(o.mainList,"li","data-value",i);p.setAttribute("aria-selected","false"),t.removeClass([p],h),d&&(d.setAttribute("aria-selected","false"),t.removeClass([p,d],h)),o.notify("activeList",{module:"CheckBoxSelection",enable:"CheckBox"===o.mode,li:p,e:o,index:r}),o.invokeCheckboxSelection(p,s,n)}o.hideSelectedItem&&o.fields.groupBy&&o.hideGroupItem(i),o.hideSelectedItem&&o.fixedHeaderElement&&o.fields.groupBy&&"CheckBox"!==o.mode&&o.isPopupOpen()&&e.prototype.scrollStop.call(o),o.updateMainList(!0,i),o.removeChip(i),o.updateChipStatus();if((o.value&&o.value.length?o.value.length:0)<o.maximumSelectionLength){var m=o.list.querySelectorAll("li."+I.li+":not(.e-active)");t.removeClass(m,"e-disable")}o.trigger("removed",a);var f=s&&s.currentTarget,v=!(!f||!f.classList.contains("e-selectall-parent"))||null;if(o.changeOnBlur||n||!s||!l||v||o.updateValueState(s,o.value,o.tempValues),l&&(o.selectAllEventData.push(u),o.selectAllEventEle.push(p)),1===l){o.changeOnBlur||o.updateValueState(s,o.value,o.tempValues);var y={event:s,items:o.selectAllEventEle,itemData:o.selectAllEventData,isInteracted:!!s,isChecked:!1};o.trigger("selectedAll",y),o.selectAllEventData=[],o.selectAllEventEle=[]}!n||1!==l&&null!==l||o.clearAllCallback(s,n)}})}},s.prototype.updateMainList=function(e,i,s){if(this.allowFiltering||"CheckBox"===this.mode){var l=s||this.findListElement(this.mainList,"li","data-value",i);l&&(e?(l.setAttribute("aria-selected","false"),t.removeClass([l],this.hideSelectedItem?be:I.selected),"CheckBox"===this.mode&&(l.firstElementChild.setAttribute("aria-checked","false"),t.removeClass([l.firstElementChild.lastElementChild],"e-check"))):(l.setAttribute("aria-selected","true"),t.addClass([l],this.hideSelectedItem?be:I.selected),"CheckBox"===this.mode&&(l.firstElementChild.setAttribute("aria-checked","true"),t.addClass([l.firstElementChild.lastElementChild],"e-check"))))}},s.prototype.removeChip=function(e){if(this.chipCollectionWrapper){var i=this.findListElement(this.chipCollectionWrapper,"span","data-value",e);i&&t.remove(i)}},s.prototype.setWidth=function(e){t.isNullOrUndefined(e)||("number"==typeof e?this.overAllWrapper.style.width=t.formatUnit(e):"string"==typeof e&&(this.overAllWrapper.style.width=e.match(/px|%|em/)?e:t.formatUnit(e)))},s.prototype.updateChipStatus=function(){this.value&&this.value.length?(t.isNullOrUndefined(this.chipCollectionWrapper)||(this.chipCollectionWrapper.style.display=""),"Delimiter"!==this.mode&&"CheckBox"!==this.mode||this.showDelimWrapper(),this.showOverAllClear()):(t.isNullOrUndefined(this.chipCollectionWrapper)||(this.chipCollectionWrapper.style.display="none"),t.isNullOrUndefined(this.delimiterWrapper)||(this.delimiterWrapper.style.display="none"),this.hideOverAllClear())},s.prototype.addValue=function(e,t,i){this.value||(this.value=[]),this.value.indexOf(e)<0&&this.setProperties({value:[].concat([],this.value,[e])},!0);var s=this.findListElement(this.list,"li","data-value",e);this.removeFocus(),s&&(this.addListFocus(s),this.addListSelection(s)),"Delimiter"!==this.mode&&"CheckBox"!==this.mode&&this.addChip(t,e,i),this.hideSelectedItem&&this.fields.groupBy&&this.hideGroupItem(e),this.updateChipStatus(),this.checkMaxSelection()},s.prototype.checkMaxSelection=function(){if((this.value&&this.value.length?this.value.length:0)===this.maximumSelectionLength){var e=this.list.querySelectorAll("li."+I.li+":not(.e-active)");t.addClass(e,"e-disable")}},s.prototype.dispatchSelect=function(t,i,s,l,n){var o=this,r=this.listData;if(this.initStatus&&!l){var a=this.getDataByValue(t),h={e:i,item:s,itemData:a,isInteracted:!!i,cancel:!1};this.trigger("select",h,function(l){if(!l.cancel){if(n&&(o.selectAllEventData.push(a),o.selectAllEventEle.push(s)),1===n){var h={event:i,items:o.selectAllEventEle,itemData:o.selectAllEventData,isInteracted:!!i,isChecked:!0};o.trigger("selectedAll",h),o.selectAllEventData=[]}o.allowCustomValue&&o.isServerRendered&&o.listData!==r&&(o.listData=r),o.updateListSelectEventCallback(t,s,i),o.hideSelectedItem&&o.fixedHeaderElement&&o.fields.groupBy&&"CheckBox"!==o.mode&&e.prototype.scrollStop.call(o)}})}},s.prototype.addChip=function(e,t,i){this.chipCollectionWrapper&&this.getChip(e,t,i)},s.prototype.removeChipFocus=function(){var e=this.chipCollectionWrapper.querySelectorAll("span."+Ee),i=this.chipCollectionWrapper.querySelectorAll("span."+Se.split(" ")[0]);if(t.removeClass(e,xe),t.Browser.isDevice)for(var s=0;s<i.length;s++)i[s].style.display="none"},s.prototype.onMobileChipInteraction=function(e){var i=t.closest(e.target,"."+Ee),s=i.querySelector("span."+Se.split(" ")[0]);this.enabled&&!this.readonly&&(i.classList.contains(xe)||(this.removeChipFocus(),s.style.display="",i.classList.add(xe)),this.refreshPopup(),e.preventDefault())},s.prototype.multiCompiler=function(e){var i=!1;if(e)try{i=!!t.selectAll(e,document).length}catch(e){i=!1}return i},s.prototype.getChip=function(e,i,s){var l=this,n={text:i,value:i},o=this.createElement("span",{className:Ee,attrs:{"data-value":i,title:e}}),r=this.createElement("span",{className:"e-chipcontent"}),a=this.createElement("span",{className:Se});if(this.mainData&&(n=this.getDataByValue(i)),this.valueTemplate&&!t.isNullOrUndefined(n)){var h=(this.multiCompiler(this.valueTemplate)?t.compile(t.select(this.valueTemplate,document).innerHTML.trim()):t.compile(this.valueTemplate))(n,this,"valueTemplate",this.valueTemplateId,this.isStringTemplate,null,r);if(h&&h.length>0)for(var p=0;p<h.length;p++)r.appendChild(h[p]);this.renderReactTemplates()}else this.enableHtmlSanitizer?r.innerText=e:r.innerHTML=e;o.appendChild(r);var u={isInteracted:!!s,itemData:n,e:s,setClass:function(e){t.addClass([o],e)},cancel:!1};this.isPreventChange=this.isAngular&&this.preventChange,this.trigger("tagging",u,function(e){e.cancel||(t.Browser.isDevice?(o.classList.add("e-mob-chip"),t.append([a],o),a.style.display="none",t.EventHandler.add(o,"click",l.onMobileChipInteraction,l)):(t.EventHandler.add(o,"mousedown",l.chipClick,l),l.showClearButton&&o.appendChild(a)),t.EventHandler.add(a,"mousedown",l.onChipRemove,l),l.chipCollectionWrapper.appendChild(o),!l.changeOnBlur&&s&&l.updateValueState(s,l.value,l.tempValues))})},s.prototype.calcPopupWidth=function(){var e=t.formatUnit(this.popupWidth);if(e.indexOf("%")>-1){e=(this.componentWrapper.offsetWidth*parseFloat(e)/100).toString()+"px"}return e},s.prototype.mouseIn=function(){this.enabled&&!this.readonly&&this.showOverAllClear()},s.prototype.mouseOut=function(){this.inputFocus||(this.overAllClear.style.display="none")},s.prototype.listOption=function(e,i){var s=!t.isNullOrUndefined(i.iconCss),l=t.isNullOrUndefined(i.properties)?i:i.properties;return this.listCurrentOptions=null!==i.text||null!==i.value?{fields:l,showIcon:s,ariaAttributes:{groupItemRole:"presentation"}}:{fields:{value:"text"}},t.extend(this.listCurrentOptions,this.listCurrentOptions,i,!0),"CheckBox"===this.mode&&this.notify("listoption",{module:"CheckBoxSelection",enable:"CheckBox"===this.mode,dataSource:e,fieldProperty:l}),this.listCurrentOptions},s.prototype.renderPopup=function(){var i=this;if(this.list||e.prototype.render.call(this),!this.popupObj){document.body.appendChild(this.popupWrapper);var s=this.popupWrapper.querySelector(".e-filter-parent");"CheckBox"===this.mode&&!this.allowFiltering&&s&&this.filterParent&&(s.remove(),this.filterParent=null);var n=parseInt(this.popupHeight,10);if(this.popupWrapper.style.visibility="hidden",this.headerTemplate&&(this.setHeaderTemplate(),n-=this.header.offsetHeight),t.append([this.list],this.popupWrapper),this.footerTemplate&&(this.setFooterTemplate(),n-=this.footer.offsetHeight),"CheckBox"===this.mode&&this.showSelectAll?(this.notify("selectAll",{module:"CheckBoxSelection",enable:"CheckBox"===this.mode}),n-=this.selectAllHeight):"CheckBox"!==this.mode||this.showSelectAll||this.headerTemplate||this.footerTemplate?"CheckBox"!==this.mode||this.showSelectAll||(this.notify("selectAll",{module:"CheckBoxSelection",enable:"CheckBox"===this.mode}),n=parseInt(this.popupHeight,10),this.headerTemplate&&this.header&&(n-=this.header.offsetHeight),this.footerTemplate&&this.footer&&(n-=this.footer.offsetHeight)):(this.notify("selectAll",{module:"CheckBoxSelection",enable:"CheckBox"===this.mode}),n=parseInt(this.popupHeight,10)),"CheckBox"===this.mode){var o={module:"CheckBoxSelection",enable:"CheckBox"===this.mode,popupElement:this.popupWrapper};this.allowFiltering&&(this.notify("searchBox",o),n-=this.searchBoxHeight),t.addClass([this.popupWrapper],"e-checkbox")}"auto"!==this.popupHeight?(this.list.style.maxHeight=t.formatUnit(n),this.popupWrapper.style.maxHeight=t.formatUnit(this.popupHeight)):this.list.style.maxHeight=t.formatUnit(this.popupHeight),this.popupObj=new l.Popup(this.popupWrapper,{width:this.calcPopupWidth(),targetType:"relative",position:{X:"left",Y:"bottom"},relateTo:this.overAllWrapper,collision:{X:"flip",Y:"flip"},offsetY:1,enableRtl:this.enableRtl,zIndex:this.zIndex,close:function(){if(i.popupObj.element.parentElement){i.popupObj.unwireScrollEvents();var e=i.popupWrapper.querySelector("."+Te);"CheckBox"===i.mode&&e&&document.activeElement===e&&e.blur(),t.detach(i.popupObj.element)}},open:function(){if(i.popupObj.resolveCollision(),!i.isFirstClick){var e=i.list.querySelector("ul");e&&("CheckBox"!==i.mode&&(i.allowFiltering||i.allowCustomValue)&&""!==i.targetElement().trim()||(i.mainList=e.cloneNode?e.cloneNode(!0):e)),i.isFirstClick=!0}i.popupObj.wireScrollEvents(),"CheckBox"!==i.mode&&(i.allowFiltering||i.allowCustomValue)&&""!==i.targetElement().trim()||i.loadTemplate(),i.setScrollPosition(),i.allowFiltering&&i.notify("inputFocus",{module:"CheckBoxSelection",enable:"CheckBox"===i.mode,value:"focus"})},targetExitViewport:function(){t.Browser.isDevice||i.hidePopup()}}),"CheckBox"===this.mode&&t.Browser.isDevice&&this.allowFiltering&&this.notify("deviceSearchBox",{module:"CheckBoxSelection",enable:"CheckBox"===this.mode}),this.popupObj.close(),this.popupWrapper.style.visibility=""}},s.prototype.setHeaderTemplate=function(){this.header&&this.header.remove(),this.header=this.createElement("div"),t.addClass([this.header],"e-ddl-header");var e=(this.multiCompiler(this.headerTemplate)?t.compile(t.select(this.headerTemplate,document).innerHTML.trim()):t.compile(this.headerTemplate))({},this,"headerTemplate",this.headerTemplateId,this.isStringTemplate,null,this.header);if(e&&e.length>0)for(var i=0;i<e.length;i++)this.header.appendChild(e[i]);"CheckBox"===this.mode&&this.showSelectAll?t.prepend([this.header],this.popupWrapper):t.append([this.header],this.popupWrapper),t.EventHandler.add(this.header,"mousedown",this.onListMouseDown,this)},s.prototype.setFooterTemplate=function(){this.footer&&this.footer.remove(),this.footer=this.createElement("div"),t.addClass([this.footer],"e-ddl-footer");var e=(this.multiCompiler(this.footerTemplate)?t.compile(t.select(this.footerTemplate,document).innerHTML.trim()):t.compile(this.footerTemplate))({},this,"footerTemplate",this.footerTemplateId,this.isStringTemplate,null,this.footer);if(e&&e.length>0)for(var i=0;i<e.length;i++)this.footer.appendChild(e[i]);t.append([this.footer],this.popupWrapper),t.EventHandler.add(this.footer,"mousedown",this.onListMouseDown,this)},s.prototype.clearAll=function(e){if(this.enabled&&!this.readonly){var t=void 0;if(this.value&&this.value.length>0){var i=this.list&&this.list.querySelectorAll("li.e-list-item");if(i&&i.length>0)this.selectAllItems(!1,e);else for(this.removeIndex=0,t=this.value[this.removeIndex];this.removeIndex<this.value.length;t=this.value[this.removeIndex])this.removeValue(t,e,null,!0)}else this.clearAllCallback(e)}},s.prototype.clearAllCallback=function(e,i){var s=this.value?this.value.slice():[];if(this.mainList&&this.listData&&(this.allowFiltering&&"CheckBox"!==this.mode||this.allowCustomValue)){var l=this.mainList.cloneNode?this.mainList.cloneNode(!0):this.mainList;this.onActionComplete(l,this.mainData)}this.focusAtFirstListItem(),this.updateDelimeter(this.delimiterChar,e),"Box"===this.mode||this.inputFocus&&"CheckBox"!==this.mode||this.updateDelimView(),""!==this.inputElement.value&&(this.makeTextBoxEmpty(),this.search(null)),this.checkPlaceholderSize(),this.isPopupOpen()&&this.refreshPopup(),this.inputFocus||(this.changeOnBlur&&this.updateValueState(e,this.value,s),"CheckBox"!==this.mode&&this.inputElement.focus()),"CheckBox"===this.mode&&(this.refreshPlaceHolder(),this.refreshInputHight(),this.changeOnBlur&&i&&(t.isNullOrUndefined(this.value)||0===this.value.length)&&this.updateValueState(e,this.value,this.tempValues)),this.changeOnBlur||!i||!t.isNullOrUndefined(this.value)&&0!==this.value.length||this.updateValueState(e,this.value,this.tempValues),"CheckBox"===this.mode&&this.enableGroupCheckBox&&!t.isNullOrUndefined(this.fields.groupBy)&&this.updateListItems(this.list.querySelectorAll("li.e-list-item"),this.mainList.querySelectorAll("li.e-list-item")),e.preventDefault()},s.prototype.windowResize=function(){this.refreshPopup(),this.inputFocus&&"CheckBox"!==this.mode||!this.viewWrapper||!this.viewWrapper.parentElement||this.updateDelimView()},s.prototype.resetValueHandler=function(e){var i=t.closest(this.inputElement,"form");if(i&&e.target===i){var s=this.element.tagName===this.getNgDirective()?null:this.element.getAttribute("data-initial-value");this.text=s}},s.prototype.wireEvent=function(){t.EventHandler.add(this.componentWrapper,"mousedown",this.wrapperClick,this),t.EventHandler.add(window,"resize",this.windowResize,this),t.EventHandler.add(this.inputElement,"focus",this.focusInHandler,this),t.EventHandler.add(this.inputElement,"keydown",this.onKeyDown,this),t.EventHandler.add(this.inputElement,"keyup",this.keyUp,this),"CheckBox"!==this.mode&&t.EventHandler.add(this.inputElement,"input",this.onInput,this),t.EventHandler.add(this.inputElement,"blur",this.onBlurHandler,this),t.EventHandler.add(this.componentWrapper,"mouseover",this.mouseIn,this);var e=t.closest(this.inputElement,"form");e&&t.EventHandler.add(e,"reset",this.resetValueHandler,this),t.EventHandler.add(this.componentWrapper,"mouseout",this.mouseOut,this),t.EventHandler.add(this.overAllClear,"mouseup",this.clearAll,this),t.EventHandler.add(this.inputElement,"paste",this.pasteHandler,this)},s.prototype.onInput=function(e){this.keyDownStatus?this.isValidKey=!0:this.isValidKey=!1,this.keyDownStatus=!1,t.Browser.isDevice&&"mozilla"===t.Browser.info.name&&this.search(e)},s.prototype.pasteHandler=function(e){var t=this;setTimeout(function(){t.expandTextbox(),t.search(e)})},s.prototype.search=function(e){var s=this;if(t.isNullOrUndefined(e)||(this.keyCode=e.keyCode),!this.isPopupOpen()&&this.openOnClick&&this.showPopup(),this.openClick(e),!this.checkTextLength()||this.allowFiltering||t.isNullOrUndefined(e)||8===e.keyCode){var l=this.targetElement();if(this.allowFiltering){var n={preventDefaultAction:!1,text:this.targetElement(),updateData:function(e,t,i){n.cancel||(s.isFiltered=!0,s.remoteFilterAction=!0,s.dataUpdater(e,t,i))},event:e,cancel:!1};this.trigger("filtering",n,function(e){e.cancel||s.isFiltered||e.preventDefaultAction||(s.filterAction=!0,s.dataUpdater(s.dataSource,null,s.fields))})}else if(this.allowCustomValue){var o=new i.Query;o=""!==l?o.where(this.fields.text,"startswith",l,this.ignoreCase,this.ignoreAccent):o,this.dataUpdater(this.mainData,o,this.fields)}else{var r=this.list.querySelectorAll("li."+I.li+":not(.e-hide-listitem)"),a=h(this.targetElement(),r,"StartsWith",this.ignoreCase);a&&null!==a.item?(this.addListFocus(a.item),this.list.scrollTop=a.item.offsetHeight*a.index):""!==this.targetElement()?this.removeFocus():this.focusAtFirstListItem()}}else this.focusAtFirstListItem()},s.prototype.preRender=function(){null===this.allowFiltering&&(this.allowFiltering="CheckBox"===this.mode),this.initializeData(),this.updateDataAttribute(this.htmlAttributes),e.prototype.preRender.call(this)},s.prototype.getLocaleName=function(){return"multi-select"},s.prototype.initializeData=function(){this.mainListCollection=[],this.beforePopupOpen=!1,this.filterAction=!1,this.remoteFilterAction=!1,this.isFirstClick=!1,this.mobFilter=!0,this.isFiltered=!1,this.focused=!0,this.initial=!0,this.backCommand=!0},s.prototype.updateData=function(e,i){var s,l="",n="Delimiter"===this.mode||"CheckBox"===this.mode,o=[],r=this.listData;if(this.listData=this.mainData,this.hiddenElement.innerHTML="",!t.isNullOrUndefined(this.value))for(var a=0;!t.isNullOrUndefined(this.value[a]);a++){var h=this.findListElement(t.isNullOrUndefined(this.mainList)?this.ulElement:this.mainList,"li","data-value",this.value[a]);t.isNullOrUndefined(h)&&!this.allowCustomValue?(this.value.splice(a,1),a-=1):(l+=(s=this.listData?this.getTextByValue(this.value[a]):this.value[a])+e+" ",o.push(s)),this.hiddenElement.innerHTML+='<option selected value ="'+this.value[a]+'">'+a+"</option>"}this.setProperties({text:o.toString()},!0),n&&(this.updateWrapperText(this.delimiterWrapper,l),this.delimiterWrapper.setAttribute("id",t.getUniqueID("delim_val")),this.inputElement.setAttribute("aria-describedby",this.delimiterWrapper.id),this.inputElement.setAttribute("aria-labelledby",this.delimiterWrapper.id));var p=i&&i.target,u=!(!p||!p.classList.contains("e-close-hooker"))||null;(!this.changeOnBlur&&i&&!u||this.isSelectAll)&&(this.isSelectAll=!1,this.updateValueState(i,this.value,this.tempValues)),this.listData=r,this.addValidInputClass()},s.prototype.initialTextUpdate=function(){if(t.isNullOrUndefined(this.text))this.setProperties({value:null},!0);else{for(var e=this.text.split(this.delimiterChar),i=[],s=0;e.length>s;s++){var l=this.getValueByText(e[s]);t.isNullOrUndefined(l)?this.allowCustomValue&&i.push(e[s]):i.push(l)}i&&i.length&&this.setProperties({value:i},!0)}},s.prototype.renderList=function(t){!t&&this.allowCustomValue&&this.list&&(this.list.textContent===this.noRecordsTemplate||this.list.querySelector(".e-ul")&&0===this.list.querySelector(".e-ul").childElementCount)&&(t=!0),e.prototype.render.call(this,t),this.unwireListEvents(),this.wireListEvents()},s.prototype.initialValueUpdate=function(){if(this.list){var e=void 0,i=void 0,s=void 0;if(this.chipCollectionWrapper&&(this.chipCollectionWrapper.innerHTML=""),this.removeListSelection(),!t.isNullOrUndefined(this.value))for(var l=0;!t.isNullOrUndefined(this.value[l]);l++)if(s=this.value[l],i=this.findListElement(this.hideSelectedItem?this.ulElement:this.list,"li","data-value",s),e=this.getTextByValue(s),i&&"true"!==i.getAttribute("aria-selected")||i&&"true"===i.getAttribute("aria-selected")&&this.hideSelectedItem&&("Box"===this.mode||"Default"===this.mode))this.addChip(e,s),this.addListSelection(i);else if(s&&this.allowCustomValue){var n=this.listData.length,o={};t.setValue(this.fields.text,s,o),t.setValue(this.fields.value,s,o);var r=this.popupWrapper.querySelector("."+I.noData);this.addItem(o,n),i=i||this.findListElement(this.hideSelectedItem?this.ulElement:this.list,"li","data-value",s),this.popupWrapper.contains(r)&&(this.list.setAttribute("style",r.getAttribute("style")),this.popupWrapper.replaceChild(this.list,r),this.wireListEvents()),this.addChip(e,s),this.addListSelection(i)}"CheckBox"===this.mode?(this.updateDelimView(),this.changeOnBlur&&this.updateValueState(null,this.value,this.tempValues),this.updateDelimeter(this.delimiterChar),this.refreshInputHight()):this.updateDelimeter(this.delimiterChar),"CheckBox"!==this.mode||!this.showSelectAll||!t.isNullOrUndefined(this.value)&&this.value.length||this.notify("checkSelectAll",{module:"CheckBoxSelection",enable:"CheckBox"===this.mode,value:"uncheck"}),"Box"===this.mode||"Default"===this.mode&&this.inputFocus?this.chipCollectionWrapper.style.display="":"Delimiter"!==this.mode&&"CheckBox"!==this.mode||this.showDelimWrapper()}},s.prototype.updateActionCompleteData=function(e,i){this.value&&this.value.indexOf(e.getAttribute("data-value"))>-1&&(this.mainList=this.ulElement,this.hideSelectedItem&&t.addClass([e],be))},s.prototype.updateAddItemList=function(e,i){this.popupObj&&this.popupObj.element&&this.popupObj.element.querySelector("."+I.noData)&&e?(this.list=e,this.mainList=this.ulElement=e.querySelector("ul"),t.remove(this.popupWrapper.querySelector(".e-content")),this.popupObj=null,this.renderPopup()):this.allowCustomValue&&(this.list=e,this.mainList=this.ulElement=e.querySelector("ul"))},s.prototype.updateDataList=function(){if(this.mainList&&this.ulElement){var e=this.mainList.childElementCount<this.ulElement.childElementCount,t=this.ulElement.childElementCount>0&&this.ulElement.children[0].childElementCount>0&&this.mainList.children[0].childElementCount<this.ulElement.children[0].childElementCount,i=this.itemTemplate&&this.ulElement.childElementCount>0&&(this.ulElement.children[0].childElementCount>0||this.fields.groupBy&&this.ulElement.children[1]&&this.ulElement.children[1].childElementCount>0);(e||t||i)&&(this.mainList=this.ulElement)}},s.prototype.isValidLI=function(e){return e&&!e.classList.contains(I.disabled)&&!e.classList.contains(I.group)&&e.classList.contains(I.li)},s.prototype.updateListSelection=function(e,i,s){var l=e.getAttribute("data-value"),n=this.getFormattedValue(l);this.allowCustomValue&&("false"!==l&&!1===n||!t.isNullOrUndefined(n)&&"NaN"===n.toString())&&(n=l),this.removeHover(),this.value&&-1!==this.value.indexOf(n)?this.removeValue(n,i,s):this.dispatchSelect(n,i,e,"true"===e.getAttribute("aria-selected"),s)},s.prototype.updateListSelectEventCallback=function(e,i,s){var l=this,n=this.getTextByValue(e);if(!this.allowCustomValue&&!this.allowFiltering||this.findListElement(this.mainList,"li","data-value",e))this.remoteCustomValue=!1,this.addValue(e,n,s);else{var o=i.cloneNode(!0),r=this.fields.value?this.fields.value:"value";this.allowCustomValue&&this.mainData.length&&"number"==typeof t.getValue(r,this.mainData[0])&&(e=isNaN(parseFloat(e.toString()))?e:parseFloat(e.toString()));var a=this.getDataByValue(e),h={newData:a,cancel:!1};this.trigger("customValueSelection",h,function(i){i.cancel||(t.append([o],l.mainList),l.mainData.push(a),l.remoteCustomValue=!1,l.addValue(e,n,s))})}},s.prototype.removeListSelection=function(){var e=this.hideSelectedItem?be:I.selected,i=this.list.querySelectorAll("."+e),s=i.length;if(i&&i.length)for(t.removeClass(i,e);s>0;)i[s-1].setAttribute("aria-selected","false"),s--;if(!t.isNullOrUndefined(this.mainList)){var l=this.mainList.querySelectorAll("."+e),n=l.length;if(l&&l.length)for(t.removeClass(l,e);n>0;)l[n-1].setAttribute("aria-selected","false"),"CheckBox"===this.mode&&(i&&i.length>n-1&&(i[n-1].firstElementChild.setAttribute("aria-checked","false"),t.removeClass([i[n-1].firstElementChild.lastElementChild],"e-check")),l[n-1].firstElementChild.setAttribute("aria-checked","false"),t.removeClass([l[n-1].firstElementChild.lastElementChild],"e-check")),n--}},s.prototype.removeHover=function(){var e=this.list.querySelectorAll("."+I.hover);e&&e.length&&t.removeClass(e,I.hover)},s.prototype.removeFocus=function(){if(this.list&&this.mainList){var e=this.list.querySelectorAll("."+I.focus),i=this.mainList.querySelectorAll("."+I.focus);e&&e.length&&(t.removeClass(e,I.focus),t.removeClass(i,I.focus))}},s.prototype.addListHover=function(e){this.enabled&&this.isValidLI(e)?(this.removeHover(),t.addClass([e],I.hover)):null!==e&&e.classList.contains("e-list-group-item")&&this.enableGroupCheckBox&&"CheckBox"===this.mode&&!t.isNullOrUndefined(this.fields.groupBy)&&(this.removeHover(),t.addClass([e],I.hover))},s.prototype.addListFocus=function(e){this.enabled&&this.isValidLI(e)?(this.removeFocus(),t.addClass([e],I.focus)):this.enableGroupCheckBox&&"CheckBox"===this.mode&&!t.isNullOrUndefined(this.fields.groupBy)&&t.addClass([e],I.focus)},s.prototype.addListSelection=function(e,i){var s=this.hideSelectedItem?be:I.selected;if(this.isValidLI(e)&&!e.classList.contains(I.hover)){if(t.addClass([e],s),this.updateMainList(!1,e.getAttribute("data-value"),i),e.setAttribute("aria-selected","true"),"CheckBox"===this.mode){var l=e.firstElementChild.getAttribute("aria-checked");("false"===l||t.isNullOrUndefined(l))&&this.notify("updatelist",{module:"CheckBoxSelection",enable:"CheckBox"===this.mode,li:e,e:this})}this.notify("activeList",{module:"CheckBoxSelection",enable:"CheckBox"===this.mode,li:e,e:this}),this.chipCollectionWrapper&&this.removeChipSelection(),t.attributes(this.inputElement,{"aria-activedescendant":e.id})}},s.prototype.updateDelimeter=function(e,t){this.updateData(e,t)},s.prototype.onMouseClick=function(e){var i=this;this.keyCode=null,this.scrollFocusStatus=!1;var s=e.target,l=t.closest(s,"."+I.li);if(t.closest(s,"."+I.group)&&this.enableGroupCheckBox&&"CheckBox"===this.mode&&this.fields.groupBy)(s=s.classList.contains("e-list-group-item")?s.firstElementChild.lastElementChild:e.target).classList.contains("e-check")?(this.selectAllItem(!1,e),s.classList.remove("e-check"),s.classList.remove("e-stop"),t.closest(s,".e-list-group-item").classList.remove("e-active"),s.setAttribute("aria-selected","false")):(this.selectAllItem(!0,e),s.classList.remove("e-stop"),s.classList.add("e-check"),t.closest(s,".e-list-group-item").classList.add("e-active"),s.setAttribute("aria-selected","true")),this.refreshSelection(),this.checkSelectAll();else{if(this.isValidLI(l)){var n=this.value&&this.value.length?this.value.length:0;l.classList.contains("e-active")&&(n-=1),n<this.maximumSelectionLength&&(this.updateListSelection(l,e),this.checkPlaceholderSize(),this.addListFocus(l),(this.allowCustomValue||this.allowFiltering)&&this.mainList&&this.listData?"CheckBox"!==this.mode&&(this.focusAtLastListItem(l.getAttribute("data-value")),this.refreshSelection()):this.makeTextBoxEmpty()),"CheckBox"===this.mode?(this.updateDelimView(),this.value&&this.value.length>50?setTimeout(function(){i.updateDelimeter(i.delimiterChar,e)},0):this.updateDelimeter(this.delimiterChar,e),this.refreshInputHight()):this.updateDelimeter(this.delimiterChar,e),this.checkSelectAll(),this.refreshPopup(),this.hideSelectedItem&&this.focusAtFirstListItem(),this.closePopupOnSelect?this.hidePopup():e.preventDefault(),this.makeTextBoxEmpty(),this.findGroupStart(s),"CheckBox"!==this.mode&&this.refreshListItems(t.isNullOrUndefined(l)?null:l.textContent)}else e.preventDefault();this.refreshPlaceHolder(),this.deselectHeader()}},s.prototype.findGroupStart=function(e){if(this.enableGroupCheckBox&&"CheckBox"===this.mode&&!t.isNullOrUndefined(this.fields.groupBy)){var i=void 0;if(this.itemTemplate&&!e.getElementsByClassName("e-frame").length)for(;!e.getElementsByClassName("e-frame").length;)e=e.parentElement;for(e.classList.contains("e-frame")&&(e=e.parentElement.parentElement),i=this.findGroupAttrtibutes(e,0,0,0,0),i=this.findGroupAttrtibutes(e,i[0],i[1],i[2],1);!e.classList.contains("e-list-group-item")&&(e.classList.contains("e-list-icon")&&(e=e.parentElement),null!=(e=e.previousElementSibling)););this.updateCheckBox(e,i[0],i[1],i[2])}},s.prototype.findGroupAttrtibutes=function(e,t,i,s,l){for(;!e.classList.contains("e-list-group-item")&&(e.classList.contains("e-list-icon")&&(e=e.parentElement),e.getElementsByClassName("e-frame")[0].classList.contains("e-check")&&e.classList.contains("e-list-item")?t++:e.classList.contains("e-list-item")&&i++,s++,null!=(e=l?e.nextElementSibling:e.previousElementSibling)););return[t,i,s]},s.prototype.updateCheckBox=function(e,i,s,l){if(null!==e){var n=e.getElementsByClassName("e-frame")[0];l===i?(n.classList.remove("e-stop"),n.classList.add("e-check"),t.closest(n,".e-list-group-item").classList.add("e-active"),e.setAttribute("aria-selected","true")):l===s?(n.classList.remove("e-check"),n.classList.remove("e-stop"),t.closest(n,".e-list-group-item").classList.remove("e-active"),e.setAttribute("aria-selected","false")):this.maximumSelectionLength===i-1?(n.classList.remove("e-stop"),e.setAttribute("aria-selected","true"),t.closest(n,".e-list-group-item").classList.add("e-active"),n.classList.add("e-check")):(n.classList.remove("e-check"),n.classList.add("e-stop"),t.closest(n,".e-list-group-item").classList.add("e-active"),e.setAttribute("aria-selected","false"))}},s.prototype.deselectHeader=function(){var e=this.value&&this.value.length?this.value.length:0,i=this.list.querySelectorAll("li.e-list-group-item:not(.e-active)");e<this.maximumSelectionLength&&t.removeClass(i,"e-disable"),e===this.maximumSelectionLength&&t.addClass(i,"e-disable")},s.prototype.onMouseOver=function(e){var i=t.closest(e.target,"."+I.li);null===i&&"CheckBox"===this.mode&&!t.isNullOrUndefined(this.fields.groupBy)&&this.enableGroupCheckBox&&(i=t.closest(e.target,"."+I.group)),this.addListHover(i)},s.prototype.onMouseLeave=function(){this.removeHover()},s.prototype.onListMouseDown=function(e){e.preventDefault(),this.scrollFocusStatus=!0},s.prototype.onDocumentClick=function(e){if("CheckBox"!==this.mode){var i=e.target;!t.isNullOrUndefined(this.popupObj)&&t.closest(i,'[id="'+this.popupObj.element.id+'"]')||this.overAllWrapper.contains(e.target)?this.scrollFocusStatus=(t.Browser.isIE||"edge"===t.Browser.info.name)&&document.activeElement===this.inputElement:this.scrollFocusStatus=!1}},s.prototype.wireListEvents=function(){t.isNullOrUndefined(this.list)||(t.EventHandler.add(document,"mousedown",this.onDocumentClick,this),t.EventHandler.add(this.list,"mousedown",this.onListMouseDown,this),t.EventHandler.add(this.list,"mouseup",this.onMouseClick,this),t.EventHandler.add(this.list,"mouseover",this.onMouseOver,this),t.EventHandler.add(this.list,"mouseout",this.onMouseLeave,this))},s.prototype.unwireListEvents=function(){t.EventHandler.remove(document,"mousedown",this.onDocumentClick),this.list&&(t.EventHandler.remove(this.list,"mousedown",this.onListMouseDown),t.EventHandler.remove(this.list,"mouseup",this.onMouseClick),t.EventHandler.remove(this.list,"mouseover",this.onMouseOver),t.EventHandler.remove(this.list,"mouseout",this.onMouseLeave))},s.prototype.hideOverAllClear=function(){this.value&&this.value.length&&""!==this.inputElement.value||(this.overAllClear.style.display="none")},s.prototype.showOverAllClear=function(){(this.value&&this.value.length||""!==this.inputElement.value)&&this.showClearButton&&!0!==this.readonly?this.overAllClear.style.display="":this.overAllClear.style.display="none"},s.prototype.focusIn=function(){document.activeElement!==this.inputElement&&this.enabled&&this.inputElement.focus()},s.prototype.focusOut=function(){document.activeElement===this.inputElement&&this.enabled&&this.inputElement.blur()},s.prototype.showSpinner=function(){if(t.isNullOrUndefined(this.spinnerElement)){var e=this.filterParent&&this.filterParent.querySelector(".e-clear-icon.e-icons");"none"!==this.overAllClear.style.display||e?this.spinnerElement=e||this.overAllClear:(this.spinnerElement=this.createElement("span",{className:Oe+" "+De}),this.componentWrapper.appendChild(this.spinnerElement)),l.createSpinner({target:this.spinnerElement,width:t.Browser.isDevice?"16px":"14px"},this.createElement),t.addClass([this.spinnerElement],Ae),l.showSpinner(this.spinnerElement)}},s.prototype.hideSpinner=function(){t.isNullOrUndefined(this.spinnerElement)||(l.hideSpinner(this.spinnerElement),t.removeClass([this.spinnerElement],Ae),this.spinnerElement.classList.contains(De)?t.detach(this.spinnerElement):this.spinnerElement.innerHTML="",this.spinnerElement=null)},s.prototype.updateWrapperText=function(e,i){this.valueTemplate||!this.enableHtmlSanitizer?e.innerHTML=i:e.innerText=t.SanitizeHtmlHelper.sanitize(i)},s.prototype.updateDelimView=function(){if(this.delimiterWrapper&&this.hideDelimWrapper(),this.chipCollectionWrapper&&(this.chipCollectionWrapper.style.display="none"),this.viewWrapper.style.display="",this.viewWrapper.style.width="",this.viewWrapper.classList.remove(Le),this.value&&this.value.length){var e="",i=void 0,s=void 0,l=1,n=void 0,o=void 0,r=0,a=void 0;this.updateWrapperText(this.viewWrapper,e);var h={noRecordsTemplate:"No records found",actionFailureTemplate:"Request failed",overflowCountTemplate:"+${count} more..",totalCountTemplate:"${count} selected"},p=new t.L10n(this.getLocaleName(),h,this.locale);""===p.getConstant("actionFailureTemplate")&&(p=new t.L10n("dropdowns",h,this.locale)),""===p.getConstant("noRecordsTemplate")&&(p=new t.L10n("dropdowns",h,this.locale));var u=p.getConstant("overflowCountTemplate"),c=p.getConstant("totalCountTemplate"),d=this.createElement("span",{className:"e-remain"}),m=u.replace("${count}",this.value.length.toString());d.innerText=m,this.viewWrapper.appendChild(d),this.renderReactTemplates();var f=d.offsetWidth;if(t.remove(d),this.showDropDownIcon&&(r=this.dropIcon.offsetWidth+parseInt(window.getComputedStyle(this.dropIcon).marginRight,10)),this.checkClearIconWidth(),!t.isNullOrUndefined(this.value))for(var v=0;!t.isNullOrUndefined(this.value[v]);v++){if(e+=0===v?"":this.delimiterChar+" ",i=this.getOverflowVal(v),e+=i,i=this.viewWrapper.innerHTML,this.updateWrapperText(this.viewWrapper,e),n=this.viewWrapper.offsetWidth+parseInt(window.getComputedStyle(this.viewWrapper).paddingRight,10),a=this.componentWrapper.offsetWidth-parseInt(window.getComputedStyle(this.componentWrapper).paddingLeft,10)-parseInt(window.getComputedStyle(this.componentWrapper).paddingRight,10),n+r+this.clearIconWidth>a){for(void 0!==s&&""!==s&&(i=s,v=l+1),this.updateWrapperText(this.viewWrapper,i),o=this.value.length-v,n=this.viewWrapper.offsetWidth+parseInt(window.getComputedStyle(this.viewWrapper).paddingRight,10);n+f+r+this.clearIconWidth>a&&0!==n&&""!==this.viewWrapper.innerHTML;){this.viewWrapper.innerHTML=[].join(this.delimiterChar),o=this.value.length,n=this.viewWrapper.offsetWidth+parseInt(window.getComputedStyle(this.viewWrapper).paddingRight,10)}break}n+f+r+this.clearIconWidth<=a?(s=e,l=v):0===v&&(s="",l=-1)}if(o>0){var y=a-r-this.clearIconWidth;this.viewWrapper.appendChild(this.updateRemainTemplate(d,this.viewWrapper,o,u,c,y)),this.updateRemainWidth(this.viewWrapper,y),this.updateRemainingText(d,r,o,u,c)}}else this.viewWrapper.innerHTML="",this.viewWrapper.style.display="none"},s.prototype.checkClearIconWidth=function(){this.showClearButton&&(this.clearIconWidth=this.overAllClear.offsetWidth)},s.prototype.updateRemainWidth=function(e,t){e.classList.contains(Le)&&t<e.offsetWidth+parseInt(window.getComputedStyle(e).paddingLeft,10)+parseInt(window.getComputedStyle(e).paddingLeft,10)&&(e.style.width=t+"px")},s.prototype.updateRemainTemplate=function(e,t,i,s,l,n){t.firstChild&&3===t.firstChild.nodeType&&""===t.firstChild.nodeValue&&t.removeChild(t.firstChild),e.innerHTML="";var o=s.replace("${count}",i.toString()),r=l.replace("${count}",i.toString());return e.innerText=t.firstChild&&3===t.firstChild.nodeType?o:r,t.firstChild&&3===t.firstChild.nodeType?t.classList.remove(Le):(t.classList.add(Le),this.updateRemainWidth(t,n)),e},s.prototype.updateRemainingText=function(e,t,i,s,l){var n=this.componentWrapper.offsetWidth-parseInt(window.getComputedStyle(this.componentWrapper).paddingLeft,10)-parseInt(window.getComputedStyle(this.componentWrapper).paddingRight,10),o=this.viewWrapper.offsetWidth+parseInt(window.getComputedStyle(this.viewWrapper).paddingRight,10);if(o+t>=n&&0!==o&&this.viewWrapper.firstChild&&3===this.viewWrapper.firstChild.nodeType){for(;o+t>n&&0!==o&&this.viewWrapper.firstChild&&3===this.viewWrapper.firstChild.nodeType;){var r=this.viewWrapper.firstChild.nodeValue.split(this.delimiterChar);r.pop(),this.viewWrapper.firstChild.nodeValue=r.join(this.delimiterChar),""===this.viewWrapper.firstChild.nodeValue&&this.viewWrapper.removeChild(this.viewWrapper.firstChild),i++,o=this.viewWrapper.offsetWidth}var a=n-t;this.updateRemainTemplate(e,this.viewWrapper,i,s,l,a)}},s.prototype.getOverflowVal=function(e){var t;if(this.mainData&&this.mainData.length)if("CheckBox"===this.mode){var i=this.listData;this.listData=this.mainData,t=this.getTextByValue(this.value[e]),this.listData=i}else t=this.getTextByValue(this.value[e]);else t=this.value[e];return t},s.prototype.unWireEvent=function(){t.EventHandler.remove(this.componentWrapper,"mousedown",this.wrapperClick),t.EventHandler.remove(window,"resize",this.windowResize),t.EventHandler.remove(this.inputElement,"focus",this.focusInHandler),t.EventHandler.remove(this.inputElement,"keydown",this.onKeyDown),"CheckBox"!==this.mode&&t.EventHandler.remove(this.inputElement,"input",this.onInput),t.EventHandler.remove(this.inputElement,"keyup",this.keyUp);var e=t.closest(this.inputElement,"form");e&&t.EventHandler.remove(e,"reset",this.resetValueHandler),t.EventHandler.remove(this.inputElement,"blur",this.onBlurHandler),t.EventHandler.remove(this.componentWrapper,"mouseover",this.mouseIn),t.EventHandler.remove(this.componentWrapper,"mouseout",this.mouseOut),t.EventHandler.remove(this.overAllClear,"mousedown",this.clearAll),t.EventHandler.remove(this.inputElement,"paste",this.pasteHandler)},s.prototype.selectAllItem=function(e,i,s){var l;if(l=this.list.querySelectorAll(e?'li.e-list-item:not([aria-selected="true"]):not(.e-reorder-hide)':'li.e-list-item[aria-selected="true"]:not(.e-reorder-hide)'),this.value&&this.value.length&&i&&i.target&&t.closest(i.target,".e-close-hooker")&&this.allowFiltering&&(l=this.mainList.querySelectorAll(e?'li.e-list-item:not([aria-selected="true"]):not(.e-reorder-hide)':'li.e-list-item[aria-selected="true"]:not(.e-reorder-hide)')),this.enableGroupCheckBox&&"CheckBox"===this.mode&&!t.isNullOrUndefined(this.fields.groupBy)){var n=i?this.groupTemplate?t.closest(i.target,".e-list-group-item"):i.target:null;if(n=i&&32===i.keyCode?s:n,(n=n&&n.classList.contains("e-frame")?n.parentElement.parentElement:n)&&n.classList.contains("e-list-group-item")){var o=n.nextElementSibling;if(t.isNullOrUndefined(o))return;for(;o.classList.contains("e-list-item");){if(e){if(!o.firstElementChild.lastElementChild.classList.contains("e-check")){var r=this.value&&this.value.length?this.value.length:0;o.classList.contains("e-active")&&(r-=1),r<this.maximumSelectionLength&&this.updateListSelection(o,i)}}else o.firstElementChild.lastElementChild.classList.contains("e-check")&&this.updateListSelection(o,i);if(null==(o=o.nextElementSibling))break}if(n.classList.contains("e-list-group-item")){var a=this.list.getElementsByClassName("e-item-focus")[0];a&&a.classList.remove("e-item-focus"),e?n.classList.add("e-active"):n.classList.remove("e-active"),n.classList.add("e-item-focus")}this.textboxValueUpdate(),this.checkPlaceholderSize(),!this.changeOnBlur&&i&&this.updateValueState(i,this.value,this.tempValues)}else this.updateValue(i,l,e)}else this.updateValue(i,l,e)},s.prototype.updateValue=function(e,i,s){var l=this,n=i.length,o={event:e,items:s?i:[],itemData:s?this.listData:[],isInteracted:!!e,isChecked:s,preventSelectEvent:!1};if(this.trigger("beforeSelectAll",o),i&&i.length){var r=0,a=0;if(a=this.enableGroupCheckBox?s?this.maximumSelectionLength-(this.value?this.value.length:0):i.length:s?this.maximumSelectionLength-(this.value?this.value.length:0):this.maximumSelectionLength,o.preventSelectEvent){for(var h=0;h<i.length&&h<a;h++){this.removeHover();var p=i[h].getAttribute("data-value"),u=this.getFormattedValue(p),c=this.mainList?this.mainList.querySelectorAll(s?'li.e-list-item:not([aria-selected="true"]):not(.e-reorder-hide)':'li.e-list-item[aria-selected="true"]:not(.e-reorder-hide)')[h]:null;s?(this.value=this.value?this.value:[],this.value.indexOf(u)<0&&this.setProperties({value:[].concat([],this.value,[u])},!0),this.removeFocus(),this.addListSelection(i[h],c),this.updateChipStatus(),this.checkMaxSelection()):this.removeAllItems(u,e,!1,i[h],c),this.enableGroupCheckBox&&this.findGroupStart(i[h])}if(!s){if((this.value&&this.value.length?this.value.length:0)<this.maximumSelectionLength){var d=this.list.querySelectorAll("li."+I.li+":not(.e-active)");t.removeClass(d,"e-disable")}}var m={event:e,items:s?i:[],itemData:s?this.listData:[],isInteracted:!!e,isChecked:s};this.trigger("selectedAll",m)}else{for(;r<n&&r<=50&&r<a;)this.updateListSelection(i[r],e,n-r),this.enableGroupCheckBox&&this.findGroupStart(i[r]),r++;n>50&&setTimeout(function(){for(;r<n&&r<a;)l.updateListSelection(i[r],e,n-r),l.enableGroupCheckBox&&l.findGroupStart(i[r]),r++;l.updatedataValueItems(e),l.changeOnBlur||(l.updateValueState(e,l.value,l.tempValues),l.isSelectAll=l.isSelectAll?!l.isSelectAll:l.isSelectAll),l.updateHiddenElement()},0)}}this.updatedataValueItems(e),this.checkPlaceholderSize(),n<=50&&!o.preventSelectEvent&&(this.changeOnBlur||(this.updateValueState(e,this.value,this.tempValues),this.isSelectAll=this.isSelectAll?!this.isSelectAll:this.isSelectAll),this.updateHiddenElement())},s.prototype.updateHiddenElement=function(){var e=this,i="",s="",l="",n=[];"CheckBox"===this.mode&&(this.value.map(function(t,o){i+='<option selected value ="'+t+'">'+o+"</option>",l=e.listData?e.getTextByValue(t):t,s+=l+e.delimiterChar+" ",n.push(l)}),this.hiddenElement.innerHTML=i,this.updateWrapperText(this.delimiterWrapper,s),this.delimiterWrapper.setAttribute("id",t.getUniqueID("delim_val")),this.inputElement.setAttribute("aria-describedby",this.delimiterWrapper.id),this.inputElement.setAttribute("aria-labelledby",this.delimiterWrapper.id),this.setProperties({text:n.toString()},!0),this.refreshInputHight(),this.refreshPlaceHolder())},s.prototype.updatedataValueItems=function(e){this.deselectHeader(),this.textboxValueUpdate(e)},s.prototype.textboxValueUpdate=function(e){var i=e&&e.target&&(t.closest(e.target,".e-selectall-parent")||t.closest(e.target,".e-close-hooker"));"Box"===this.mode||this.isPopupOpen()||"CheckBox"===this.mode&&(this.isSelectAll||i)?this.searchWrapper.classList.remove(we):this.updateDelimView(),"CheckBox"===this.mode?(this.updateDelimView(),i||this.isSelectAll||this.updateDelimeter(this.delimiterChar,e),this.refreshInputHight()):this.updateDelimeter(this.delimiterChar,e),this.refreshPlaceHolder()},s.prototype.setZIndex=function(){this.popupObj&&this.popupObj.setProperties({zIndex:this.zIndex})},s.prototype.updateDataSource=function(e){t.isNullOrUndefined(this.list)?this.renderPopup():this.resetList(this.dataSource),this.value&&this.value.length&&(this.setProperties({value:this.value}),this.refreshSelection())},s.prototype.onLoadSelect=function(){this.setDynValue=!0,this.renderPopup()},s.prototype.selectAllItems=function(i,s){var l=this;if(t.isNullOrUndefined(this.list))this.selectAllAction=function(){if("CheckBox"===l.mode&&l.showSelectAll){var e={module:"CheckBoxSelection",enable:"CheckBox"===l.mode,value:i?"check":"uncheck"};l.notify("checkSelectAll",e)}l.selectAllItem(i,s),l.selectAllAction=null},e.prototype.render.call(this);else{if(this.selectAllAction=null,"CheckBox"===this.mode&&this.showSelectAll){var n={value:i?"check":"uncheck",enable:"CheckBox"===this.mode,module:"CheckBoxSelection"};this.notify("checkSelectAll",n)}this.selectAllItem(i,s)}},s.prototype.getPersistData=function(){return this.addOnPersist(["value"])},s.prototype.onPropertyChanged=function(i,s){(i.dataSource&&!t.isNullOrUndefined(Object.keys(i.dataSource))||i.query&&!t.isNullOrUndefined(Object.keys(i.query)))&&(this.mainList=null,this.mainData=null,this.isFirstClick=!1,this.isDynamicDataChange=!0),"multiselect"===this.getModuleName()&&(this.filterAction=!1,this.setUpdateInitial(["fields","query","dataSource"],i));for(var l=0,n=Object.keys(i);l<n.length;l++){var o=n[l];switch(o){case"query":case"dataSource":"CheckBox"===this.mode&&this.showSelectAll&&(t.isNullOrUndefined(this.popupObj)||(this.popupObj.destroy(),this.popupObj=null),this.renderPopup());break;case"htmlAttributes":this.updateHTMLAttribute();break;case"showClearButton":this.updateClearButton(i.showClearButton);break;case"text":this.updateVal(this.value,this.value,"text");break;case"value":this.updateVal(this.value,s.value,"value"),this.addValidInputClass(),!this.closePopupOnSelect&&this.isPopupOpen()&&this.refreshPopup(),this.preventChange=this.isAngular&&this.preventChange?!this.preventChange:this.preventChange;break;case"width":this.setWidth(i.width),this.popupObj.setProperties({width:this.calcPopupWidth()});break;case"placeholder":this.refreshPlaceHolder();break;case"filterBarPlaceholder":this.allowFiltering&&this.notify("filterBarPlaceholder",{filterBarPlaceholder:i.filterBarPlaceholder});break;case"delimiterChar":"Box"!==this.mode&&this.updateDelimView(),this.updateData(i.delimiterChar);break;case"cssClass":this.updateOldPropCssClass(s.cssClass),this.updateCssClass();break;case"enableRtl":this.enableRTL(i.enableRtl),e.prototype.onPropertyChanged.call(this,i,s);break;case"readonly":this.updateReadonly(i.readonly),this.hidePopup();break;case"enabled":this.hidePopup(),this.enable(i.enabled);break;case"showSelectAll":this.popupObj&&(this.popupObj.destroy(),this.popupObj=null),this.renderPopup();break;case"showDropDownIcon":this.dropDownIcon();break;case"floatLabelType":this.setFloatLabelType(),this.addValidInputClass();break;case"enableSelectionOrder":break;case"selectAllText":this.notify("selectAllText",!1);break;case"popupHeight":if(this.popupObj){var r=parseInt(this.popupHeight,10);"auto"!==this.popupHeight?(this.list.style.maxHeight=t.formatUnit(r),this.popupWrapper.style.maxHeight=t.formatUnit(this.popupHeight)):this.list.style.maxHeight=t.formatUnit(this.popupHeight)}break;case"headerTemplate":case"footerTemplate":this.reInitializePoup();break;case"allowFiltering":"CheckBox"===this.mode&&this.popupObj&&this.reInitializePoup(),this.updateSelectElementData(this.allowFiltering);break;default:var a=this.getPropObject(o,i,s);e.prototype.onPropertyChanged.call(this,a.newProperty,a.oldProperty)}}},s.prototype.reInitializePoup=function(){this.popupObj&&(this.popupObj.destroy(),this.popupObj=null),this.renderPopup()},s.prototype.presentItemValue=function(e){for(var i=[],s=0;s<this.value.length;s++){this.findListElement(this.allowFiltering&&!t.isNullOrUndefined(this.mainList)?this.mainList:e,"li","data-value",this.value[s])||i.push(this.value[s])}return i},s.prototype.addNonPresentItems=function(e,t,i,s){var l=this;this.dataSource.executeQuery(this.getForQuery(e)).then(function(e){l.addItem(e.result,i.length),l.updateActionList(t,i,s)})},s.prototype.updateVal=function(e,s,l){if(this.list)if(!(this.dataSource instanceof i.DataManager)||this.listData&&this.mainList&&this.mainData){var n=[];if(t.isNullOrUndefined(this.value)||this.allowCustomValue||(n=this.presentItemValue(this.ulElement)),"value"==l&&n.length>0&&this.dataSource instanceof i.DataManager&&!t.isNullOrUndefined(this.value)&&null!=this.listData)this.mainData=null,this.setDynValue=!0,this.addNonPresentItems(n,this.ulElement,this.listData);else{if("text"===l&&(this.initialTextUpdate(),e=this.value),(t.isNullOrUndefined(this.value)||0===this.value.length)&&(this.tempValues=s),this.allowCustomValue&&("Default"===this.mode||"Box"===this.mode)&&this.isReact&&this.inputFocus&&this.isPopupOpen()&&this.mainData!==this.listData){var o=this.mainList.cloneNode?this.mainList.cloneNode(!0):this.mainList;this.onActionComplete(o,this.mainData)}this.initialValueUpdate(),"Box"===this.mode||this.inputFocus||this.updateDelimView(),this.inputFocus||this.refreshInputHight(),this.refreshPlaceHolder(),"CheckBox"!==this.mode&&this.changeOnBlur&&this.updateValueState(null,e,s),this.checkPlaceholderSize()}}else this.onLoadSelect();else this.onLoadSelect();this.changeOnBlur||this.updateValueState(null,e,s)},s.prototype.addItem=function(t,i){e.prototype.addItem.call(this,t,i)},s.prototype.hidePopup=function(){var e=this;if(this.isPopupOpen()){var i={name:"FadeOut",duration:100,delay:100},s={popup:this.popupObj,cancel:!1,animation:i};this.trigger("close",s,function(i){i.cancel||(e.fields.groupBy&&"CheckBox"!==e.mode&&e.fixedHeaderElement&&(t.remove(e.fixedHeaderElement),e.fixedHeaderElement=null),e.beforePopupOpen=!1,e.overAllWrapper.classList.remove("e-icon-anim"),e.popupObj.hide(new t.Animation(i.animation)),t.attributes(e.inputElement,{"aria-expanded":"false"}),e.allowFiltering&&e.notify("inputFocus",{module:"CheckBoxSelection",enable:"CheckBox"===e.mode,value:"clear"}),e.popupObj.hide(),t.removeClass([document.body,e.popupObj.element],"e-popup-full-page"),t.EventHandler.remove(e.list,"keydown",e.onKeyDown))})}},s.prototype.showPopup=function(){var i=this;if(this.enabled){this.trigger("beforeOpen",{cancel:!1},function(s){if(!s.cancel){if(!i.ulElement)return i.beforePopupOpen=!0,e.prototype.render.call(i),void("CheckBox"===i.mode&&t.Browser.isDevice&&i.allowFiltering&&i.notify("popupFullScreen",{module:"CheckBoxSelection",enable:"CheckBox"===i.mode}));"CheckBox"===i.mode&&t.Browser.isDevice&&i.allowFiltering&&i.notify("popupFullScreen",{module:"CheckBoxSelection",enable:"CheckBox"===i.mode});var l=i.ulElement.querySelectorAll("li.e-list-item").length,n=i.ulElement.querySelectorAll("li."+I.li+"."+be).length;if(l>0&&l===n&&n===i.mainData.length)return void(i.beforePopupOpen=!1);i.onPopupShown()}})}},s.prototype.selectAll=function(e){this.isSelectAll=!0,this.selectAllItems(e)},s.prototype.getModuleName=function(){return"multiselect"},s.prototype.clear=function(){var e=this;this.selectAll(!1),this.value&&this.value.length?setTimeout(function(){e.setProperties({value:null},!0)},0):this.setProperties({value:null},!0)},s.prototype.render=function(){this.setDynValue=this.initStatus=!1,this.isSelectAll=!1,this.searchWrapper=this.createElement("span",{className:"e-searcher "+("Box"===this.mode?"e-multiselect-box":"")}),this.viewWrapper=this.createElement("span",{className:"e-delim-view e-delim-values",styles:"display:none;"}),this.overAllClear=this.createElement("span",{className:Oe,styles:"display:none;"}),this.componentWrapper=this.createElement("div",{className:"e-multi-select-wrapper"}),this.overAllWrapper=this.createElement("div",{className:"e-multiselect e-input-group e-control-wrapper"}),"CheckBox"===this.mode&&t.addClass([this.overAllWrapper],"e-checkbox"),t.Browser.isDevice&&this.componentWrapper.classList.add("e-mob-wrapper"),this.setWidth(this.width),this.overAllWrapper.appendChild(this.componentWrapper),this.popupWrapper=this.createElement("div",{id:this.element.id+"_popup",className:"e-ddl e-popup e-multi-select-list-wrapper"}),"Delimiter"===this.mode||"CheckBox"===this.mode?(this.delimiterWrapper=this.createElement("span",{className:"e-delim-values",styles:"display:none"}),this.componentWrapper.appendChild(this.delimiterWrapper)):(this.chipCollectionWrapper=this.createElement("span",{className:"e-chips-collection",styles:"display:none"}),"Default"===this.mode?this.chipCollectionWrapper.setAttribute("id",t.getUniqueID("chip_default")):"Box"===this.mode&&this.chipCollectionWrapper.setAttribute("id",t.getUniqueID("chip_box")),this.componentWrapper.appendChild(this.chipCollectionWrapper)),"Box"!==this.mode&&this.componentWrapper.appendChild(this.viewWrapper),this.componentWrapper.appendChild(this.searchWrapper),this.showClearButton&&!t.Browser.isDevice?this.componentWrapper.appendChild(this.overAllClear):this.componentWrapper.classList.add(ke),this.dropDownIcon(),this.inputElement=this.createElement("input",{className:"e-dropdownbase",attrs:{spellcheck:"false",type:"text",autocomplete:"off",tabindex:"0"}}),"Default"!==this.mode&&"Box"!==this.mode||(this.inputElement.setAttribute("aria-describedby",this.chipCollectionWrapper.id),this.inputElement.setAttribute("aria-labelledby",this.chipCollectionWrapper.id)),this.element.tagName!==this.getNgDirective()&&(this.element.style.display="none"),this.element.tagName===this.getNgDirective()?(this.element.appendChild(this.overAllWrapper),this.searchWrapper.appendChild(this.inputElement)):(this.element.parentElement.insertBefore(this.overAllWrapper,this.element),this.searchWrapper.appendChild(this.inputElement),this.searchWrapper.appendChild(this.element),this.element.removeAttribute("tabindex")),"Never"!==this.floatLabelType?m(this.overAllWrapper,this.searchWrapper,this.element,this.inputElement,this.value,this.floatLabelType,this.placeholder):"Never"===this.floatLabelType&&this.refreshPlaceHolder(),this.addValidInputClass(),this.element.style.opacity="";var e=this.element.getAttribute("id")?this.element.getAttribute("id"):t.getUniqueID("ej2_dropdownlist");this.element.id=e,this.hiddenElement=this.createElement("select",{attrs:{"aria-hidden":"true",class:"e-multi-hidden",tabindex:"-1",multiple:""}}),this.componentWrapper.appendChild(this.hiddenElement),this.validationAttribute(this.element,this.hiddenElement),"CheckBox"!==this.mode&&this.hideOverAllClear(),this.wireEvent(),this.enable(this.enabled),this.enableRTL(this.enableRtl),this.checkInitialValue(),this.element.hasAttribute("data-val")&&this.element.setAttribute("data-val","false"),this.renderComplete()},s.prototype.checkInitialValue=function(){var s=this,l=this.dataSource instanceof Array?this.dataSource.length>0:!t.isNullOrUndefined(this.dataSource);if((!this.value||!this.value.length)&&t.isNullOrUndefined(this.text)&&!l&&"SELECT"===this.element.tagName&&this.element.options.length>0){for(var n=this.element.options,o=[],r="",a=0,h=n.length;a<h;a++){var p=n[a];t.isNullOrUndefined(p.getAttribute("selected"))||(p.getAttribute("value")?o.push(p.getAttribute("value")):r+=p.text+this.delimiterChar)}o.length>0?this.setProperties({value:o},!0):""!==r&&this.setProperties({text:r},!0),(o.length>0||""!==r)&&(this.refreshInputHight(),this.refreshPlaceHolder())}(this.value&&this.value.length||!t.isNullOrUndefined(this.text))&&(this.list||e.prototype.render.call(this)),t.isNullOrUndefined(this.text)||!t.isNullOrUndefined(this.value)&&0!==this.value.length||this.initialTextUpdate(),this.value&&this.value.length?(this.dataSource instanceof i.DataManager?this.setInitialValue=function(){s.initStatus=!1,s.initialValueUpdate(),s.initialUpdate(),s.setInitialValue=null,s.initStatus=!0}:(this.initialValueUpdate(),this.initialUpdate()),this.updateTempValue()):this.initialUpdate(),this.initStatus=!0,this.checkAutoFocus(),t.isNullOrUndefined(this.text)||this.element.setAttribute("data-initial-value",this.text)},s.prototype.checkAutoFocus=function(){this.element.hasAttribute("autofocus")&&this.inputElement.focus()},s.prototype.setFloatLabelType=function(){v(this.overAllWrapper,this.componentWrapper,this.searchWrapper,this.inputElement,this.value,this.floatLabelType,this.placeholder),"Never"!==this.floatLabelType&&m(this.overAllWrapper,this.searchWrapper,this.element,this.inputElement,this.value,this.floatLabelType,this.placeholder)},s.prototype.addValidInputClass=function(){!t.isNullOrUndefined(this.value)&&this.value.length||"Always"===this.floatLabelType?t.addClass([this.overAllWrapper],"e-valid-input"):t.removeClass([this.overAllWrapper],"e-valid-input")},s.prototype.dropDownIcon=function(){this.showDropDownIcon?(this.dropIcon=this.createElement("span",{className:Ie}),this.componentWrapper.appendChild(this.dropIcon),t.addClass([this.componentWrapper],["e-down-icon"])):t.isNullOrUndefined(this.dropIcon)||(this.dropIcon.parentElement.removeChild(this.dropIcon),t.removeClass([this.componentWrapper],["e-down-icon"]))},s.prototype.initialUpdate=function(){"Box"===this.mode||this.setDynValue&&"Default"===this.mode&&this.inputFocus||this.updateDelimView(),this.updateCssClass(),this.updateHTMLAttribute(),this.updateReadonly(this.readonly),this.refreshInputHight(),this.checkPlaceholderSize()},s.prototype.destroy=function(){this.isReact&&this.clearTemplate(),this.popupObj&&this.popupObj.hide(),this.notify("destroy",{}),this.unwireListEvents(),this.unWireEvent(),this.list=null,this.popupObj=null,this.mainList=null,this.mainData=null,this.filterParent=null,this.ulElement=null,this.mainListCollection=null,e.prototype.destroy.call(this);for(var i=["readonly","aria-disabled","aria-placeholder","placeholder"],s=i.length;s>0;)this.inputElement.removeAttribute(i[s-1]),s--;this.element.removeAttribute("data-initial-value"),this.element.style.display="block",this.overAllWrapper.parentElement&&(this.overAllWrapper.parentElement.tagName===this.getNgDirective()?t.remove(this.overAllWrapper):(this.overAllWrapper.parentElement.insertBefore(this.element,this.overAllWrapper),t.remove(this.overAllWrapper)))},ge([t.Complex({text:null,value:null,iconCss:null,groupBy:null},D)],s.prototype,"fields",void 0),ge([t.Property(!1)],s.prototype,"enablePersistence",void 0),ge([t.Property(null)],s.prototype,"groupTemplate",void 0),ge([t.Property("No records found")],s.prototype,"noRecordsTemplate",void 0),ge([t.Property("Request failed")],s.prototype,"actionFailureTemplate",void 0),ge([t.Property("None")],s.prototype,"sortOrder",void 0),ge([t.Property(!0)],s.prototype,"enabled",void 0),ge([t.Property(!1)],s.prototype,"enableHtmlSanitizer",void 0),ge([t.Property([])],s.prototype,"dataSource",void 0),ge([t.Property(null)],s.prototype,"query",void 0),ge([t.Property("StartsWith")],s.prototype,"filterType",void 0),ge([t.Property(1e3)],s.prototype,"zIndex",void 0),ge([t.Property(!1)],s.prototype,"ignoreAccent",void 0),ge([t.Property()],s.prototype,"locale",void 0),ge([t.Property(!1)],s.prototype,"enableGroupCheckBox",void 0),ge([t.Property(null)],s.prototype,"cssClass",void 0),ge([t.Property("100%")],s.prototype,"width",void 0),ge([t.Property("300px")],s.prototype,"popupHeight",void 0),ge([t.Property("100%")],s.prototype,"popupWidth",void 0),ge([t.Property(null)],s.prototype,"placeholder",void 0),ge([t.Property(null)],s.prototype,"filterBarPlaceholder",void 0),ge([t.Property({})],s.prototype,"htmlAttributes",void 0),ge([t.Property(null)],s.prototype,"valueTemplate",void 0),ge([t.Property(null)],s.prototype,"headerTemplate",void 0),ge([t.Property(null)],s.prototype,"footerTemplate",void 0),ge([t.Property(null)],s.prototype,"itemTemplate",void 0),ge([t.Property(null)],s.prototype,"allowFiltering",void 0),ge([t.Property(!0)],s.prototype,"changeOnBlur",void 0),ge([t.Property(!1)],s.prototype,"allowCustomValue",void 0),ge([t.Property(!0)],s.prototype,"showClearButton",void 0),ge([t.Property(1e3)],s.prototype,"maximumSelectionLength",void 0),ge([t.Property(!1)],s.prototype,"readonly",void 0),ge([t.Property(null)],s.prototype,"text",void 0),ge([t.Property(null)],s.prototype,"value",void 0),ge([t.Property(!0)],s.prototype,"hideSelectedItem",void 0),ge([t.Property(!0)],s.prototype,"closePopupOnSelect",void 0),ge([t.Property("Default")],s.prototype,"mode",void 0),ge([t.Property(",")],s.prototype,"delimiterChar",void 0),ge([t.Property(!0)],s.prototype,"ignoreCase",void 0),ge([t.Property(!1)],s.prototype,"showDropDownIcon",void 0),ge([t.Property("Never")],s.prototype,"floatLabelType",void 0),ge([t.Property(!1)],s.prototype,"showSelectAll",void 0),ge([t.Property("Select All")],s.prototype,"selectAllText",void 0),ge([t.Property("Unselect All")],s.prototype,"unSelectAllText",void 0),ge([t.Property(!0)],s.prototype,"enableSelectionOrder",void 0),ge([t.Property(!0)],s.prototype,"openOnClick",void 0),ge([t.Property(!1)],s.prototype,"addTagOnBlur",void 0),ge([t.Event()],s.prototype,"change",void 0),ge([t.Event()],s.prototype,"removing",void 0),ge([t.Event()],s.prototype,"removed",void 0),ge([t.Event()],s.prototype,"beforeSelectAll",void 0),ge([t.Event()],s.prototype,"selectedAll",void 0),ge([t.Event()],s.prototype,"beforeOpen",void 0),ge([t.Event()],s.prototype,"open",void 0),ge([t.Event()],s.prototype,"close",void 0),ge([t.Event()],s.prototype,"blur",void 0),ge([t.Event()],s.prototype,"focus",void 0),ge([t.Event()],s.prototype,"chipSelection",void 0),ge([t.Event()],s.prototype,"filtering",void 0),ge([t.Event()],s.prototype,"tagging",void 0),ge([t.Event()],s.prototype,"customValueSelection",void 0),s=ge([t.NotifyPropertyChanges],s)}(L),Pe="e-check",We="e-checkbox-wrapper",Fe="e-input-group-icon e-clear-icon e-icons",He="e-clear-icon",Ve="e-popup-full-page",Ue=function(){function e(e){this.activeLi=[],this.activeEle=[],this.parent=e,this.removeEventListener(),this.addEventListener()}return e.prototype.getModuleName=function(){return"CheckBoxSelection"},e.prototype.addEventListener=function(){this.parent.isDestroyed||(this.parent.on("updatelist",this.listSelection,this),this.parent.on("listoption",this.listOption,this),this.parent.on("selectAll",this.setSelectAll,this),this.parent.on("checkSelectAll",this.checkSelectAll,this),this.parent.on("searchBox",this.setSearchBox,this),this.parent.on("blur",this.onBlurHandler,this),this.parent.on("targetElement",this.targetElement,this),this.parent.on("deviceSearchBox",this.setDeviceSearchBox,this),this.parent.on("inputFocus",this.getFocus,this),this.parent.on("reOrder",this.setReorder,this),this.parent.on("activeList",this.getActiveList,this),this.parent.on("selectAllText",this.setLocale,this),this.parent.on("filterBarPlaceholder",this.setPlaceholder,this),t.EventHandler.add(document,"mousedown",this.onDocumentClick,this),this.parent.on("addItem",this.checboxCreate,this),this.parent.on("popupFullScreen",this.setPopupFullScreen,this))},e.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off("updatelist",this.listSelection),this.parent.off("listoption",this.listOption),this.parent.off("selectAll",this.setSelectAll),this.parent.off("checkSelectAll",this.checkSelectAll),this.parent.off("searchBox",this.setSearchBox),this.parent.off("blur",this.onBlurHandler),this.parent.off("targetElement",this.targetElement),this.parent.off("deviceSearchBox",this.setDeviceSearchBox),this.parent.off("inputFocus",this.getFocus),this.parent.off("reOrder",this.setReorder),this.parent.off("activeList",this.getActiveList),this.parent.off("selectAllText",this.setLocale),this.parent.off("filterBarPlaceholder",this.setPlaceholder),this.parent.off("addItem",this.checboxCreate),this.parent.off("popupFullScreen",this.setPopupFullScreen))},e.prototype.listOption=function(e){var i=this;if(t.isNullOrUndefined(this.parent.listCurrentOptions.itemCreated))this.parent.listCurrentOptions.itemCreated=function(e){i.checboxCreate(e)};else{var s=this.parent.listCurrentOptions.itemCreated;this.parent.listCurrentOptions.itemCreated=function(e){i.checboxCreate(e),s.apply(i,[e])}}},e.prototype.setPlaceholder=function(e){n.Input.setPlaceholder(e.filterBarPlaceholder,this.filterInput)},e.prototype.checboxCreate=function(e){var i;if(i=t.isNullOrUndefined(e.item)?e:e.item,this.parent.enableGroupCheckBox||"e-list-group-item "!==i.className&&"e-list-group-item"!==i.className){var s=o.createCheckBox(this.parent.createElement,!0),l=t.select("div.e-icons",i);return i.insertBefore(s,i.childNodes[t.isNullOrUndefined(l)?0:1]),t.select(".e-frame",s),this.parent.enableGroupCheckBox&&this.parent.popupWrapper.classList.add("e-multiselect-group"),i}return i},e.prototype.setSelectAll=function(){this.parent.showSelectAll?(t.isNullOrUndefined(this.checkAllParent)&&(this.checkAllParent=this.parent.createElement("div",{className:"e-selectall-parent"}),this.selectAllSpan=this.parent.createElement("span",{className:"e-all-text"}),this.selectAllSpan.textContent="",this.checkAllParent.appendChild(this.selectAllSpan),this.setLocale(),this.checboxCreate(this.checkAllParent),this.parent.headerTemplate&&(t.isNullOrUndefined(this.parent.filterParent)?t.append([this.checkAllParent],this.parent.popupWrapper):t.append([this.checkAllParent],this.parent.filterParent)),this.parent.headerTemplate||(t.isNullOrUndefined(this.parent.filterParent)?t.prepend([this.checkAllParent],this.parent.popupWrapper):this.parent.filterParent.parentNode.insertBefore(this.checkAllParent,this.parent.filterParent.nextSibling)),t.EventHandler.add(this.checkAllParent,"mousedown",this.clickHandler,this)),this.parent.list.classList.contains("e-nodata")||this.parent.listData&&this.parent.listData.length<=1&&!this.parent.isDynamicDataChange||this.parent.isDynamicDataChange&&this.parent.listData&&this.parent.listData.length<=1?this.checkAllParent.style.display="none":this.checkAllParent.style.display="block",this.parent.selectAllHeight=this.checkAllParent.getBoundingClientRect().height):t.isNullOrUndefined(this.checkAllParent)||(this.checkAllParent.parentElement.removeChild(this.checkAllParent),this.checkAllParent=null)},e.prototype.destroy=function(){this.removeEventListener(),t.EventHandler.remove(document,"mousedown",this.onDocumentClick)},e.prototype.listSelection=function(e){var i;if(t.isNullOrUndefined(e.e)){var s=e.li.querySelector(".e-checkbox-wrapper");i=s?s.childNodes[1]:e.li.lastElementChild.childNodes[1]}else{e.li.querySelector(".e-checkbox-wrapper .e-frame");i=t.isNullOrUndefined(e.e.target)?e.li.querySelector(".e-checkbox-wrapper").childNodes[1]:e.e.target.classList.contains("e-frame")&&(!this.parent.showSelectAll||this.checkAllParent&&!this.checkAllParent.contains(e.e.target))?e.e.target:e.li.querySelector(".e-checkbox-wrapper").childNodes[1]}if((this.parent.itemTemplate||this.parent.enableGroupCheckBox)&&(i=e.li.firstElementChild.childNodes[1]),t.isNullOrUndefined(i)||(this.checkWrapper=t.closest(i,"."+We)),!t.isNullOrUndefined(this.checkWrapper)){var l=t.select(".e-frame",this.checkWrapper);this.validateCheckNode(this.checkWrapper,l.classList.contains(Pe),e.li,e.e,!1)}},e.prototype.validateCheckNode=function(e,t,i,s,l){this.changeState(e,t?"uncheck":"check",s,!0,l)},e.prototype.clickHandler=function(e){var i;i=e.currentTarget.classList.contains(this.checkAllParent.className)?e.currentTarget.firstElementChild.lastElementChild:e.currentTarget,this.checkWrapper=t.closest(i,"."+We);if(!t.isNullOrUndefined(this.checkWrapper)){var s=t.select(".e-frame",this.checkWrapper);this.validateCheckNode(this.checkWrapper,s.classList.contains(Pe),null,e,!0)}e.preventDefault()},e.prototype.changeState=function(e,i,s,l,n){var o,r=e.getElementsByClassName("e-frame")[0];"check"!==i||r.classList.contains(Pe)?"uncheck"===i&&(r.classList.contains(Pe)||r.classList.contains("e-stop"))?(t.removeClass([r],[Pe,"e-stop"]),o="false",n&&(this.parent.selectAllItems(!1,s),this.setLocale())):"indeterminate"!==i||r.classList.contains("e-stop")||(t.removeClass([r],[Pe]),r.classList.add("e-stop"),o="false",n&&(this.parent.selectAllItems(!1,s),this.setLocale())):(r.classList.remove("e-stop"),r.classList.add(Pe),o="true",n&&(this.parent.selectAllItems(!0,s),this.setLocale(!0))),o="check"===i?"true":"uncheck"===i?"false":o,t.isNullOrUndefined(o)||e.setAttribute("aria-checked",o)},e.prototype.setSearchBox=function(e){if(t.isNullOrUndefined(this.parent.filterParent)){this.parent.filterParent=this.parent.createElement("span",{className:"e-filter-parent"}),this.filterInput=this.parent.createElement("input",{attrs:{type:"text"},className:"e-input-filter"}),this.parent.element.parentNode.insertBefore(this.filterInput,this.parent.element);var i=!1;return t.Browser.isDevice&&(i=!0,this.parent.mobFilter=!1),this.filterInputObj=n.Input.createInput({element:this.filterInput,buttons:i?["e-input-group-icon e-back-icon e-icons",Fe]:[Fe],properties:{placeholder:this.parent.filterBarPlaceholder}},this.parent.createElement),t.isNullOrUndefined(this.parent.cssClass)||(-1!==this.parent.cssClass.split(" ").indexOf("e-outline")?t.addClass([this.filterInputObj.container],"e-outline"):-1!==this.parent.cssClass.split(" ").indexOf("e-filled")&&t.addClass([this.filterInputObj.container],"e-filled")),t.append([this.filterInputObj.container],this.parent.filterParent),t.prepend([this.parent.filterParent],e.popupElement),t.attributes(this.filterInput,{"aria-disabled":"false","aria-owns":this.parent.element.id+"_options",role:"listbox","aria-activedescendant":null,autocomplete:"off",autocorrect:"off",autocapitalize:"off",spellcheck:"false"}),this.clearIconElement=this.filterInput.parentElement.querySelector("."+He),!t.Browser.isDevice&&this.clearIconElement&&(t.EventHandler.add(this.clearIconElement,"mousedown",this.clearText,this),this.clearIconElement.style.visibility="hidden"),t.EventHandler.add(this.filterInput,"input",this.parent.onInput,this.parent),t.EventHandler.add(this.filterInput,"keyup",this.parent.keyUp,this.parent),t.EventHandler.add(this.filterInput,"keydown",this.parent.onKeyDown,this.parent),t.EventHandler.add(this.filterInput,"blur",this.onBlurHandler,this),t.EventHandler.add(this.filterInput,"paste",this.parent.pasteHandler,this.parent),this.parent.searchBoxHeight=this.filterInputObj.container.parentElement.getBoundingClientRect().height,this.filterInputObj}},e.prototype.clickOnBackIcon=function(e){this.parent.hidePopup(),t.removeClass([document.body,this.parent.popupObj.element],Ve),this.parent.inputElement.focus()},e.prototype.clearText=function(e){this.parent.targetInputElement.value="",this.parent.allowFiltering&&""===this.parent.targetInputElement.value&&this.parent.search(null),this.parent.refreshPopup(),this.parent.refreshListItems(null),this.clearIconElement.style.visibility="hidden",this.filterInput.focus(),this.setReorder(e),e.preventDefault()},e.prototype.setDeviceSearchBox=function(){this.parent.popupObj.element.classList.add("e-ddl-device"),this.parent.popupObj.element.classList.add("e-ddl-device-filter"),this.parent.popupObj.position={X:0,Y:0},this.parent.popupObj.dataBind(),this.setSearchBoxPosition(),this.backIconElement=this.filterInputObj.container.querySelector(".e-back-icon"),this.clearIconElement=this.filterInputObj.container.querySelector("."+He),this.clearIconElement.style.visibility="hidden",t.EventHandler.add(this.backIconElement,"click",this.clickOnBackIcon,this),t.EventHandler.add(this.clearIconElement,"click",this.clearText,this)},e.prototype.setSearchBoxPosition=function(){var e=this.filterInput.parentElement.getBoundingClientRect().height,i=0;this.checkAllParent&&(i=this.checkAllParent.getBoundingClientRect().height),this.parent.popupObj.element.style.maxHeight="100%",this.parent.popupObj.element.style.width="100%",this.parent.list.style.maxHeight=window.innerHeight-e-i+"px",this.parent.list.style.height=window.innerHeight-e-i+"px";var s=this.filterInput.parentElement.querySelector("."+He);t.detach(this.filterInput),s.parentElement.insertBefore(this.filterInput,s)},e.prototype.setPopupFullScreen=function(){t.attributes(this.parent.popupObj.element,{style:"left:0px;right:0px;top:0px;bottom:0px;"}),t.addClass([document.body,this.parent.popupObj.element],Ve),this.parent.popupObj.element.style.maxHeight="100%",this.parent.popupObj.element.style.width="100%"},e.prototype.targetElement=function(){return t.isNullOrUndefined(this.clearIconElement)||(this.parent.targetInputElement=this.filterInput,this.clearIconElement.style.visibility=""===this.parent.targetInputElement.value?"hidden":"visible"),this.parent.targetInputElement.value},e.prototype.onBlurHandler=function(e){if(!this.parent.element.classList.contains("e-listbox")){var i=void 0;if(this.parent.keyAction)return;if(t.Browser.isIE&&(i=!t.isNullOrUndefined(e)&&e.target),t.Browser.isIE||(i=!t.isNullOrUndefined(e)&&e.relatedTarget),this.parent.popupObj&&document.body.contains(this.parent.popupObj.element)&&this.parent.popupObj.element.contains(i)&&!t.Browser.isIE&&this.filterInput)return void this.filterInput.focus();if(this.parent.scrollFocusStatus&&this.filterInput)return e.preventDefault(),this.filterInput.focus(),void(this.parent.scrollFocusStatus=!1);this.parent.popupObj&&document.body.contains(this.parent.popupObj.element)&&!this.parent.popupObj.element.classList.contains("e-popup-close")&&(this.parent.inputFocus=!1,this.parent.updateValueState(e,this.parent.value,this.parent.tempValues),this.parent.dispatchEvent(this.parent.hiddenElement,"change")),this.parent.popupObj&&document.body.contains(this.parent.popupObj.element)&&!this.parent.popupObj.element.classList.contains("e-popup-close")&&(this.parent.inputFocus=!1,this.parent.overAllWrapper.classList.remove("e-input-focus"),this.parent.trigger("blur"),this.parent.focused=!0),this.parent.popupObj&&document.body.contains(this.parent.popupObj.element)&&!this.parent.popupObj.element.classList.contains("e-popup-close")&&!t.Browser.isDevice&&this.parent.hidePopup()}},e.prototype.onDocumentClick=function(e){if("listbox"!==this.parent.getLocaleName()){var i=e.target;!t.isNullOrUndefined(this.parent.popupObj)&&t.closest(i,'[id="'+this.parent.popupObj.element.id+'"]')&&(this.filterInput&&""!==this.filterInput.value||e.preventDefault()),!t.isNullOrUndefined(this.parent.popupObj)&&t.closest(i,'[id="'+this.parent.popupObj.element.id+'"]')||this.parent.overAllWrapper.contains(e.target)?this.parent.scrollFocusStatus=(t.Browser.isIE||"edge"===t.Browser.info.name)&&document.activeElement===this.filterInput:(this.parent.overAllWrapper.classList.contains(I.focus)||this.parent.isPopupOpen())&&(this.parent.inputFocus=!1,this.parent.scrollFocusStatus=!1,this.parent.hidePopup(),this.parent.onBlurHandler(e,!0),this.parent.focused=!0),this.parent.overAllWrapper.contains(e.target)||!this.parent.overAllWrapper.classList.contains("e-input-focus")||this.parent.isPopupOpen()||(t.Browser.isIE?this.parent.onBlurHandler():this.parent.onBlurHandler(e)),this.filterInput===i&&this.filterInput.focus()}},e.prototype.getFocus=function(e){this.parent.overAllWrapper.classList.remove("e-input-focus"),this.parent.keyAction&&"clear"!==e.value&&"focus"!==e.value?this.parent.keyAction=!1:("focus"===e.value&&(this.filterInput.focus(),this.parent.removeFocus(),t.EventHandler.remove(this.parent.list,"keydown",this.parent.onKeyDown)),"clear"===e.value&&(this.filterInput.value="",this.clearIconElement.style.visibility="hidden"))},e.prototype.checkSelectAll=function(e){"check"===e.value&&"true"!==this.checkAllParent.getAttribute("aria-checked")&&(this.changeState(this.checkAllParent,e.value,null,null,!1),this.setLocale(!0)),"uncheck"===e.value&&(this.changeState(this.checkAllParent,e.value,null,null,!1),this.setLocale()),"indeterminate"===e.value&&(this.changeState(this.checkAllParent,e.value,null,null,!1),this.setLocale())},e.prototype.setLocale=function(e){if("Select All"!==this.parent.selectAllText||"Unselect All"!==this.parent.unSelectAllText){var i=e?this.parent.unSelectAllText:this.parent.selectAllText;this.selectAllSpan.textContent="";for(var s=t.compile(i),l=e?"unSelectAllText":"selectAllText",n=0,o=s({},this.parent,l,null,!this.parent.isStringTemplate);n<o.length;n++){var r=o[n];this.selectAllSpan.textContent=r.textContent}}else{var a=new t.L10n(this.parent.getLocaleName(),{},this.parent.locale);""===a.getConstant("selectAllText")&&(a=new t.L10n("dropdowns",{selectAllText:"Select All",unSelectAllText:"Unselect All"},this.parent.locale)),this.selectAllSpan.textContent=e?a.getConstant("unSelectAllText"):a.getConstant("selectAllText")}},e.prototype.getActiveList=function(e){e.li.classList.contains("e-active")?this.activeLi.push(e.li.cloneNode(!0)):this.activeLi.splice(e.index,1)},e.prototype.setReorder=function(e){if(this.parent.enableSelectionOrder&&!t.isNullOrUndefined(this.parent.value)){var i=this.parent.ulElement.querySelectorAll("li.e-active").length,s=void 0,l=this.parent.createElement("ul",{className:"e-list-parent e-ul e-reorder"});i>0&&(t.append(this.parent.ulElement.querySelectorAll("li.e-active"),l),s=this.parent.ulElement.querySelectorAll("li.e-active"),t.addClass(s,"e-reorder-hide"),t.prepend([l],this.parent.list)),this.parent.focusAtFirstListItem()}},e}(),Me=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),je=function(e,t,i,s){var l,n=arguments.length,o=n<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)o=Reflect.decorate(e,t,i,s);else for(var r=e.length-1;r>=0;r--)(l=e[r])&&(o=(n<3?l(o):n>3?l(t,i,o):l(t,i))||o);return n>3&&o&&Object.defineProperty(t,i,o),o},qe=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return Me(i,e),je([t.Property("Multiple")],i.prototype,"mode",void 0),je([t.Property(!1)],i.prototype,"showCheckbox",void 0),je([t.Property(!1)],i.prototype,"showSelectAll",void 0),je([t.Property("Left")],i.prototype,"checkboxPosition",void 0),i}(t.ChildProperty),Re=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return Me(i,e),je([t.Property([])],i.prototype,"items",void 0),je([t.Property("Right")],i.prototype,"position",void 0),i}(t.ChildProperty),Ke=function(e){function r(t,i){var s=e.call(this,t,i)||this;return s.isValidKey=!1,s.isDataSourceUpdate=!1,s.keyDownStatus=!1,s}Me(r,e),a=r,r.prototype.addItem=function(t,i){e.prototype.addItem.call(this,t,i)},r.prototype.render=function(){this.inputString="",this.initLoad=!0,this.isCustomFiltering=!1,this.initialSelectedOptions=this.value,e.prototype.render.call(this),this.renderComplete()},r.prototype.initWrapper=function(){var e=this.createElement("select",{className:"e-hidden-select",attrs:{multiple:""}});this.list.classList.add("e-listbox-wrapper"),this.itemTemplate&&this.list.classList.add("e-list-template"),this.list.classList.add("e-wrapper"),this.list.classList.add("e-lib"),"EJS-LISTBOX"===this.element.tagName?(this.element.setAttribute("tabindex","0"),this.initLoad&&this.element.appendChild(this.list)):(this.initLoad&&this.element.parentElement.insertBefore(this.list,this.element),this.list.insertBefore(this.element,this.list.firstChild),this.element.style.display="none"),this.list.insertBefore(e,this.list.firstChild),this.list.getElementsByClassName("e-list-item")[0]&&this.list.getElementsByClassName("e-list-item")[0].classList.remove(I.focus),this.itemTemplate&&this.renderReactTemplates(),t.removeClass([this.list],[I.content,I.root]),this.validationAttribute(this.element,e),this.list.setAttribute("role","listbox"),t.attributes(this.list,{role:"listbox","aria-multiselectable":"Multiple"===this.selectionSettings.mode?"true":"false"}),this.updateSelectionSettings()},r.prototype.updateSelectionSettings=function(){if(this.selectionSettings.showCheckbox&&this.selectionSettings.showSelectAll&&this.liCollections.length){var e=new t.L10n(this.getModuleName(),{selectAllText:"Select All",unSelectAllText:"Unselect All"},this.locale);this.showSelectAll=!0,this.selectAllText=e.getConstant("selectAllText"),this.unSelectAllText=e.getConstant("unSelectAllText"),this.popupWrapper=this.list,this.checkBoxSelectionModule.checkAllParent=null,this.notify("selectAll",{})}},r.prototype.initDraggable=function(){var e=this;this.ulElement&&(this.ulElement.id=this.element.id+"_parent"),this.allowDragAndDrop&&new s.Sortable(this.ulElement,{scope:this.scope,itemClass:"e-list-item",dragStart:this.triggerDragStart.bind(this),drag:this.triggerDrag.bind(this),beforeDrop:this.beforeDragEnd.bind(this),drop:this.dragEnd.bind(this),placeHolder:function(){return e.createElement("span",{className:"e-placeholder"})},helper:function(t){var i=e.list.cloneNode(),s=t.sender.cloneNode(!0);i.appendChild(s);var n=e.getItems()[0];return i.style.width=n.offsetWidth+"px",i.style.height=n.offsetHeight+"px",(e.value&&e.value.length)>1&&e.isSelected(s)&&s.appendChild(e.createElement("span",{className:"e-list-badge",innerHTML:e.value.length+""})),i.style.zIndex=l.getZindexPartial(e.element)+"",i}})},r.prototype.updateActionCompleteData=function(e,t){this.jsonData.push(t)},r.prototype.initToolbar=function(){var e=this.toolbarSettings.position,i=this.element.getAttribute("data-value");if(this.toolbarSettings.items.length){var s=this.createElement("div",{className:"e-listbox-tool",attrs:{role:"toolbar"}}),l=this.createElement("div",{className:"e-listboxtool-wrapper e-lib e-"+e.toLowerCase()});this.list.parentElement.insertBefore(l,this.list),l.appendChild("Right"===e?this.list:s),l.appendChild("Right"===e?s:this.list),this.createButtons(s),this.element.id||(this.element.id=t.getUniqueID("e-"+this.getModuleName())),this.scope?document.querySelector(this.scope).setAttribute("data-value",this.element.id):this.updateToolBarState()}var n=this.element.getAttribute("data-value");i&&n&&i!==n?(this.tBListBox=t.getComponent(document.getElementById(i),this.getModuleName()),this.tBListBox.updateToolBarState()):n&&(this.tBListBox=t.getComponent(document.getElementById(n),this.getModuleName()),this.tBListBox.updateToolBarState())},r.prototype.createButtons=function(e){var i,s,l=this,n=new t.L10n(this.getModuleName(),{moveUp:"Move Up",moveDown:"Move Down",moveTo:"Move To",moveFrom:"Move From",moveAllTo:"Move All To",moveAllFrom:"Move All From"},this.locale);this.toolbarSettings.items.forEach(function(t){s=n.getConstant(t),i=l.createElement("button",{attrs:{type:"button","data-value":t,title:s,"aria-label":s}}),e.appendChild(i),new o.Button({iconCss:"e-icons e-"+t.toLowerCase()},i).createElement=l.createElement})},r.prototype.validationAttribute=function(t,i){e.prototype.validationAttribute.call(this,t,i),i.required=t.required,t.required=!1},r.prototype.setHeight=function(){(this.toolbarSettings.items.length?this.list.parentElement:this.list).style.height=t.formatUnit(this.height),this.allowFiltering&&this.height.toString().indexOf("%")<0?t.addClass([this.list],"e-filter-list"):t.removeClass([this.list],"e-filter-list")},r.prototype.setCssClass=function(){var e=this.toolbarSettings.items.length?this.list.parentElement:this.list;this.cssClass&&t.addClass([e],this.cssClass.split(" ")),this.enableRtl&&t.addClass([this.list],"e-rtl")},r.prototype.setEnable=function(){var e=this.toolbarSettings.items.length?this.list.parentElement:this.list;this.enabled?t.removeClass([e],s.cssClass.disabled):t.addClass([e],s.cssClass.disabled)},r.prototype.showSpinner=function(){this.spinner||(this.spinner=this.createElement("div",{className:"e-listbox-wrapper"})),this.spinner.style.height=t.formatUnit(this.height),this.element.parentElement.insertBefore(this.spinner,this.element.nextSibling),l.createSpinner({target:this.spinner},this.createElement),l.showSpinner(this.spinner)},r.prototype.hideSpinner=function(){this.spinner.querySelector(".e-spinner-pane")&&l.hideSpinner(this.spinner),this.spinner.parentElement&&t.detach(this.spinner)},r.prototype.onInput=function(){this.isDataSourceUpdate=!1,this.keyDownStatus?this.isValidKey=!0:this.isValidKey=!1,this.keyDownStatus=!1,this.refreshClearIcon()},r.prototype.clearText=function(){this.filterInput.value="",this.refreshClearIcon();var e=document.createEvent("KeyboardEvent");this.isValidKey=!0,this.KeyUp(e)},r.prototype.refreshClearIcon=function(){if(this.filterInput.parentElement.querySelector("."+ze.clearIcon)){this.filterInput.parentElement.querySelector("."+ze.clearIcon).style.visibility=""===this.filterInput.value?"hidden":"visible"}},r.prototype.onActionComplete=function(i,s,l){var n;if(this.allowFiltering&&this.list.getElementsByClassName("e-filter-parent")[0]&&(n=this.list.getElementsByClassName("e-filter-parent")[0].cloneNode(!0)),0===s.length){var o=i.childNodes[0];o&&i.removeChild(o)}if(e.prototype.onActionComplete.call(this,i,s,l),this.allowFiltering&&!t.isNullOrUndefined(n)&&(this.list.insertBefore(n,this.list.firstElementChild),this.filterParent=this.list.getElementsByClassName("e-filter-parent")[0],this.filterWireEvents(n)),this.initWrapper(),this.setSelection(),this.initDraggable(),this.mainList=this.ulElement,this.initLoad)this.jsonData=[],t.extend(this.jsonData,s,[]),this.initToolbarAndStyles(),this.wireEvents(),this.showCheckbox&&this.setCheckboxPosition(),this.allowFiltering&&this.setFiltering();else if(this.isDataSourceUpdate&&(this.jsonData=[],t.extend(this.jsonData,s,[]),this.isDataSourceUpdate=!1),this.allowFiltering){var r=this.list.getElementsByClassName("e-input-filter")[0],a=this.filterInput.value.length;r.selectionStart=a,r.selectionEnd=a,r.focus()}if(this.toolbarSettings.items.length&&this.scope&&this.scope.indexOf("#")>-1&&!t.isNullOrUndefined(l)){var h=this.scope.replace("#","");t.getComponent(document.getElementById(h),this.getModuleName()).initToolbar()}this.initLoad=!1},r.prototype.initToolbarAndStyles=function(){this.initToolbar(),this.setCssClass(),this.setEnable(),this.setHeight()},r.prototype.triggerDragStart=function(e){var i,s=this;e=t.extend(this.getDragArgs(e),{dragSelected:!0}),t.Browser.isIos&&(this.list.style.overflow="hidden"),this.trigger("dragStart",e,function(e){s.allowDragAll=e.dragSelected,s.allowDragAll||(i=s.ulElement.getElementsByClassName("e-list-badge")[0])&&t.detach(i)})},r.prototype.triggerDrag=function(e){var t,i,s,l=e.event;if(e.target&&(e.target.classList.contains("e-listbox-wrapper")||e.target.classList.contains("e-list-item")||e.target.classList.contains("e-filter-parent")||e.target.classList.contains("e-input-group"))&&(s=e.target.classList.contains("e-list-item")||e.target.classList.contains("e-filter-parent")||e.target.classList.contains("e-input-group")?e.target.closest(".e-listbox-wrapper"):e.target,(i=(t=this.allowFiltering?s.querySelector(".e-list-parent"):s).getBoundingClientRect()).y+t.offsetHeight-(l.pageY+36)<1?t.scrollTop=t.scrollTop+10:l.pageY-36-i.y<1&&(t.scrollTop=t.scrollTop-10)),null!==e.target){this.trigger("drag",this.getDragArgs(e));var n=this.getComponent(e.target);if(n&&0===n.listData.length){var o=n.ulElement.childNodes[0];o&&n.ulElement.removeChild(o)}}},r.prototype.beforeDragEnd=function(e){var t=this.getFormattedValue(e.droppedElement.getAttribute("data-value"));this.value.indexOf(t)>-1?e.items=this.getDataByValues(this.value):e.items=this.getDataByValues([t]),this.trigger("beforeDrop",e)},r.prototype.dragEnd=function(e){var i,s,l,n,o,r,a=this,h=this.getFormattedValue(e.droppedElement.getAttribute("data-value")),p=this.getComponent(e.droppedElement),u=this.getDragArgs({target:e.droppedElement},!0),c={previousData:this.dataSource},d={previousData:p.dataSource},m=t.extend({},u,{target:e.target,source:{previousData:this.dataSource},previousIndex:e.previousIndex,currentIndex:e.currentIndex});if(p!==this){var f=t.extend(c,{currentData:this.listData});m=t.extend(m,{source:f,destination:d})}if(t.Browser.isIos&&(this.list.style.overflow=""),p===this){var v=this.ulElement;i=[].slice.call(this.listData),s=[].slice.call(this.liCollections),l=[].slice.call(this.jsonData),r=[].slice.call(this.sortedData);var y=e.currentIndex,g=e.currentIndex=this.getCurIdx(this,e.currentIndex),C=i.indexOf(this.getDataByValue(h)),b=l.indexOf(this.getDataByValue(h)),E=r.indexOf(this.getDataByValue(h));i.splice(g,0,i.splice(C,1)[0]),r.splice(y,0,r.splice(E,1)[0]),l.splice(g,0,l.splice(b,1)[0]),s.splice(g,0,s.splice(C,1)[0]),this.allowDragAll&&(o=this.value&&Array.prototype.indexOf.call(this.value,h)>-1?this.value:[h]).forEach(function(e){if(e!==h){var t=i.indexOf(a.getDataByValue(e)),n=l.indexOf(a.getDataByValue(e)),o=r.indexOf(a.getDataByValue(e));t>g&&g++,l.splice(g,0,l.splice(n,1)[0]),i.splice(g,0,i.splice(t,1)[0]),r.splice(y,0,r.splice(o,1)[0]),s.splice(g,0,s.splice(t,1)[0]),v.insertBefore(a.getItems()[a.getIndexByValue(e)],v.getElementsByClassName("e-placeholder")[0])}}),this.listData=i,this.jsonData=l,this.sortedData=r,this.liCollections=s}else{var S,x=[].slice.call(this.liCollections),w=e.currentIndex=this.getCurIdx(p,e.currentIndex),O=p.ulElement;i=[].slice.call(p.listData),s=[].slice.call(p.liCollections),l=[].slice.call(p.jsonData),r=[].slice.call(p.sortedData),o=this.value&&Array.prototype.indexOf.call(this.value,h)>-1&&this.allowDragAll?this.value:[h];var k=[].slice.call(this.listData),A=[].slice.call(this.sortedData);if(o.forEach(function(t,o){n=a.getDataByValue(t);var p=a.listData.indexOf(n),u=a.jsonData.indexOf(n),c=a.sortedData.indexOf(n);k.splice(p,1),a.jsonData.splice(u,1),A.splice(c,1),a.listData=k,a.sortedData=A;var d=t===h?e.currentIndex:w;if(i.splice(d,0,n),l.splice(d,0,n),r.splice(d,0,n),s.splice(d,0,x.splice(p,1)[0]),t)S=a.getItems()[a.getIndexByValue(t)];else for(var m=a.getItems(),f=0;f<m.length;f++)if(null===m[f].getAttribute("data-value")&&m[f].classList.contains("e-list-item")){S=m[f];break}S||(S=e.helper),a.removeSelected(a,t===h?[e.droppedElement]:[S]),O.insertBefore(S,O.getElementsByClassName("e-placeholder")[0]),w++}),this.fields.groupBy){var D=this.renderItems(this.listData,this.fields);this.updateListItems(D,this.ulElement),this.setSelection()}if("None"!==p.sortOrder||this.selectionSettings.showCheckbox!==p.selectionSettings.showCheckbox||p.fields.groupBy||p.itemTemplate||this.itemTemplate){var I=t.getComponent(O,"sortable");D=p.renderItems(i,p.fields);p.updateListItems(D,O),this.setSelection(),I.placeHolderElement&&O.appendChild(I.placeHolderElement),O.appendChild(e.helper),p.setSelection()}this.liCollections=x,p.liCollections=s,p.jsonData=t.extend([],[],l,!1),p.listData=t.extend([],[],i,!1),p.sortedData=t.extend([],[],r,!1),0===this.listData.length&&this.l10nUpdate()}if(this===p){f=t.extend(c,{currentData:i});m=t.extend(m,{source:f})}else{var L=t.extend(d,{currentData:i});m=t.extend(m,{destination:L})}this.trigger("drop",m)},r.prototype.updateListItems=function(e,t){for(t.innerHTML="";0<e.childNodes.length;)t.appendChild(e.childNodes[0])},r.prototype.removeSelected=function(e,i){e.selectionSettings.showCheckbox?i.forEach(function(e){e.getElementsByClassName("e-frame")[0].classList.remove("e-check")}):t.removeClass(i,s.cssClass.selected)},r.prototype.getCurIdx=function(e,t){return e.fields.groupBy&&(t-=[].slice.call(e.ulElement.children).slice(0,t).filter(function(e){return e.classList.contains(s.cssClass.group)}).length),t},r.prototype.getComponent=function(e){var i,s="EJS-LISTBOX"===this.element.tagName?t.closest(e,".e-listbox"):t.closest(e,".e-listbox-wrapper")&&t.closest(e,".e-listbox-wrapper").querySelector(".e-listbox");return s&&(i=t.getComponent(s,this.getModuleName())),i},r.prototype.listOption=function(i,s){return this.listCurrentOptions=e.prototype.listOption.call(this,i,s),this.listCurrentOptions=t.extend({},this.listCurrentOptions,{itemCreated:this.triggerBeforeItemRender.bind(this)},!0),this.notify("listoption",{module:"CheckBoxSelection"}),this.listCurrentOptions},r.prototype.triggerBeforeItemRender=function(e){e.item.setAttribute("tabindex","-1"),this.trigger("beforeItemRender",{element:e.item,item:e.curData})},r.prototype.requiredModules=function(){var e=[];return this.selectionSettings.showCheckbox&&e.push({member:"CheckBoxSelection",args:[this]}),e},r.prototype.enableItems=function(e,i,l){var n=this;void 0===i&&(i=!0);var o;e.forEach(function(e){var r=e;(o=n.findListElement(n.list,"li","data-value",l?r:n.getValueByText(r)))&&(i?(t.removeClass([o],s.cssClass.disabled),o.removeAttribute("aria-disabled")):(t.addClass([o],s.cssClass.disabled),o.setAttribute("aria-disabled","true")))})},r.prototype.selectItems=function(e,t,i){void 0===t&&(t=!0),this.setSelection(e,t,!i),this.updateSelectedOptions()},r.prototype.selectAll=function(e){void 0===e&&(e=!0),this.selectAllItems(e)},r.prototype.addItems=function(t,i){e.prototype.addItem.call(this,t,i)},r.prototype.removeItems=function(e,t){this.removeItem(e,t)},r.prototype.removeItem=function(e,i){var s=[],l=this.list.querySelectorAll("."+I.li);if(e){e=e instanceof Array?e:[e];var n=this.fields,o=void 0,r=[],a=void 0;t.extend(r,[],this.listData);for(var h=[],p=[],u=0;u<e.length;u++){o=e[u]instanceof Object?t.getValue(n.value,e[u]):e[u].toString();for(var c=0,d=r.length;c<d;c++)if((r[c]instanceof Object?t.getValue(n.value,r[c]):r[c].toString())===o){var m=(a=this.getIndexByValue(o))===c?a:c;s.push(l[m]),h.push(m),p.push(m)}}for(var f=h.length-1;f>=0;f--)this.listData.splice(h[f],1);for(f=h.length-1;f>=0;f--)this.jsonData.splice(h[f],1);for(f=p.length-1;f>=0;f--)this.updateLiCollection(p[f])}else i=i||0,s.push(l[i]),this.listData.splice(i,1),this.jsonData.splice(i,1),this.updateLiCollection(i);for(c=0;c<s.length;c++)this.ulElement.removeChild(s[c]);0===this.listData.length&&this.l10nUpdate()},r.prototype.getDataByValues=function(e){for(var t=[],i=0;i<e.length;i++)t.push(this.getDataByValue(e[i]));return t},r.prototype.moveUp=function(e){var t=e?this.getElemByValue(e):this.getSelectedItems();this.moveUpDown(!0,!1,t)},r.prototype.moveDown=function(e){var t=e?this.getElemByValue(e):this.getSelectedItems();this.moveUpDown(!1,!1,t)},r.prototype.moveTo=function(e,i,s){var l=e?this.getElemByValue(e):this.getSelectedItems(),n=s?t.getComponent(s,a):this.getScopedListBox();this.moveData(this,n,!1,l,i)},r.prototype.moveAllTo=function(e,i){if(this.listData.length>0){var s=e?t.getComponent(e,a):this.getScopedListBox();this.moveAllData(this,s,!1,i)}},r.prototype.getDataList=function(){return this.jsonData},r.prototype.getSortedList=function(){var e,t;if(e=t=this.sortedData,this.fields.groupBy){e=[];for(var i=0;i<t.length;i++)t[i].isHeader||e.push(t[i])}return e},r.prototype.getElemByValue=function(e){for(var t=[],i=0;i<e.length;i++)t.push(this.ulElement.querySelector('[data-value ="'+e[i]+'"]'));return t},r.prototype.updateLiCollection=function(e){var t=[].slice.call(this.liCollections);t.splice(e,1),this.liCollections=t},r.prototype.selectAllItems=function(e,t){var i=this;if([].slice.call(this.getItems()).forEach(function(t){if(!t.classList.contains(s.cssClass.disabled))if(i.selectionSettings.showCheckbox){var l=t.getElementsByClassName("e-check")[0];(!l&&e||l&&!e)&&(i.notify("updatelist",{li:t,module:"listbox"}),i.maximumSelectionLength>=i.list.querySelectorAll(".e-list-item span.e-check").length&&i.checkMaxSelection())}else e?t.classList.add(s.cssClass.selected):t.classList.remove(s.cssClass.selected)}),this.updateSelectedOptions(),this.allowFiltering&&this.selectionSettings.showCheckbox){var l=this.list.getElementsByTagName("li"),n=0;if(e){var o=function(){var e=r.getFormattedValue(l[n].getAttribute("data-value"));r.value.some(function(t){return t===e})||r.value.push(r.getFormattedValue(l[n].getAttribute("data-value")))},r=this;for(n=0;n<l.length;n++)o()}else{var a=function(){var e=h.getFormattedValue(l[n].getAttribute("data-value"));h.value=h.value.filter(function(t){return t!==e})},h=this;for(n=0;n<l.length;n++)a()}document.querySelectorAll("ul").length<2&&this.updateMainList()}this.triggerChange(this.getSelectedItems(),t)},r.prototype.updateMainList=function(){var e=this.mainList.querySelectorAll(".e-list-item"),t=this.ulElement.querySelectorAll(".e-list-item"),i=e.length,s=t.length;if(this.selectionSettings.showCheckbox||document.querySelectorAll("ul").length>1||i!==s)for(var l=0,n=0,o=0;l<i;){if(this.value)for(;n<this.value.length;n++)e[l].getAttribute("data-value")===this.value[n]&&o++;!o&&this.selectionSettings.showCheckbox&&e[l].getElementsByClassName("e-frame")[0].classList.remove("e-check"),document.querySelectorAll("ul").length>1&&o&&i!==s?(this.mainList.removeChild(this.mainList.getElementsByTagName("li")[l]),l=0):l++,o=0,n=0}},r.prototype.wireEvents=function(){var e=t.closest(this.element,"form"),i="EJS-LISTBOX"===this.element.tagName?this.element:this.list;t.EventHandler.add(this.list,"click",this.clickHandler,this),t.EventHandler.add(i,"keydown",this.keyDownHandler,this),t.EventHandler.add(i,"focusout",this.focusOutHandler,this),this.wireToolbarEvent(),this.selectionSettings.showCheckbox&&t.EventHandler.remove(document,"mousedown",this.checkBoxSelectionModule.onDocumentClick),(this.fields.groupBy||this.element.querySelector("select>optgroup"))&&t.EventHandler.remove(this.list,"scroll",this.setFloatingHeader),e&&t.EventHandler.add(e,"reset",this.formResetHandler,this)},r.prototype.wireToolbarEvent=function(){this.toolbarSettings.items.length&&t.EventHandler.add(this.getToolElem(),"click",this.toolbarClickHandler,this)},r.prototype.unwireEvents=function(){var e=t.closest(this.element,"form"),i="EJS-LISTBOX"===this.element.tagName?this.element:this.list;t.EventHandler.remove(this.list,"click",this.clickHandler),t.EventHandler.remove(i,"keydown",this.keyDownHandler),t.EventHandler.remove(i,"focusout",this.focusOutHandler),this.allowFiltering&&this.clearFilterIconElem&&t.EventHandler.remove(this.clearFilterIconElem,"click",this.clearText),this.toolbarSettings.items.length&&t.EventHandler.remove(this.getToolElem(),"click",this.toolbarClickHandler),e&&t.EventHandler.remove(e,"reset",this.formResetHandler)},r.prototype.clickHandler=function(e){this.selectHandler(e)},r.prototype.checkSelectAll=function(){for(var e=0,t=this.list.querySelectorAll("li."+I.li),i=0;i<t.length;i++)t[i].classList.contains("e-disabled")||e++;var s=this.getSelectedItems().length;this.showSelectAll&&e&&this.notify("checkSelectAll",{module:"CheckBoxSelection",value:e===s?"check":0===s?"uncheck":"indeterminate"})},r.prototype.getQuery=function(e){var t=e?e.clone():this.query?this.query.clone():new i.Query;if(this.allowFiltering){var s=""===this.inputString?"contains":this.filterType,l=this.typeOfData(this.dataSource).typeof;if((this.dataSource instanceof i.DataManager||"string"!==l)&&"number"!==l){var n=this.fields.text?this.fields.text:"";t.where(n,s,this.inputString,this.ignoreCase,this.ignoreAccent)}else t.where("",s,this.inputString,this.ignoreCase,this.ignoreAccent)}else t=e||(this.query?this.query:new i.Query);return t},r.prototype.setFiltering=function(){var e;if(this.initLoad||t.isNullOrUndefined(this.filterParent))return this.filterParent=this.createElement("span",{className:ze.filterParent}),this.filterInput=this.createElement("input",{attrs:{type:"text"},className:ze.filterInput}),this.element.parentNode.insertBefore(this.filterInput,this.element),e=n.Input.createInput({element:this.filterInput,buttons:[ze.filterBarClearIcon],properties:{placeholder:this.filterBarPlaceholder}},this.createElement),t.append([e.container],this.filterParent),t.prepend([this.filterParent],this.list),t.attributes(this.filterInput,{"aria-disabled":"false","aria-owns":this.element.id+"_options",role:"listbox","aria-activedescendant":null,autocomplete:"off",autocorrect:"off",autocapitalize:"off",spellcheck:"false"}),this.height.toString().indexOf("%")<0&&t.addClass([this.list],"e-filter-list"),this.inputString=this.filterInput.value,this.filterWireEvents(),e},r.prototype.filterWireEvents=function(e){e&&(this.filterInput=e.querySelector(".e-input-filter")),this.clearFilterIconElem=this.filterInput.parentElement.querySelector("."+ze.clearIcon),this.clearFilterIconElem&&(t.EventHandler.add(this.clearFilterIconElem,"click",this.clearText,this),e||(this.clearFilterIconElem.style.visibility="hidden")),t.EventHandler.add(this.filterInput,"input",this.onInput,this),t.EventHandler.add(this.filterInput,"keyup",this.KeyUp,this),t.EventHandler.add(this.filterInput,"keydown",this.onKeyDown,this)},r.prototype.selectHandler=function(e,i){var l,n=!0,o=t.closest(e.target,".e-list-item"),r=[o];if(o&&o.parentElement){if(l=[].slice.call(o.parentElement.children).indexOf(o),this.selectionSettings.showCheckbox?n=!o.getElementsByClassName("e-frame")[0].classList.contains("e-check"):(e.ctrlKey||t.Browser.isDevice)&&this.isSelected(o)?(o.classList.remove(s.cssClass.selected),o.removeAttribute("aria-selected"),n=!1):"Multiple"===this.selectionSettings.mode&&(e.ctrlKey||t.Browser.isDevice)||(this.getSelectedItems().forEach(function(e){e.removeAttribute("aria-selected")}),t.removeClass(this.getSelectedItems(),s.cssClass.selected)),e.shiftKey&&!this.selectionSettings.showCheckbox&&"Single"!==this.selectionSettings.mode?r=[].slice.call(o.parentElement.children).slice(Math.min(l,this.prevSelIdx),Math.max(l,this.prevSelIdx)+1).filter(function(e){return e.classList.contains("e-list-item")}):this.prevSelIdx=[].slice.call(o.parentElement.children).indexOf(o),n&&(this.selectionSettings.showCheckbox||t.addClass(r,s.cssClass.selected),r.forEach(function(e){e.setAttribute("aria-selected","true")}),this.list.setAttribute("aria-activedescendant",o.id)),i||!(this.maximumSelectionLength>(this.value&&this.value.length))&&n||!(this.maximumSelectionLength>=(this.value&&this.value.length))&&n||this.maximumSelectionLength<(this.value&&this.value.length)||this.notify("updatelist",{li:o,e:e,module:"listbox"}),this.allowFiltering&&!i){var a=this.getFormattedValue(o.getAttribute("data-value"));if(n){var h=[];t.extend(h,this.value),h.push(a),this.value=h}else this.value=this.value.filter(function(e){return e!==a});document.querySelectorAll("ul").length<2&&this.updateMainList()}this.updateSelectedOptions(),this.triggerChange(this.getSelectedItems(),e),this.checkMaxSelection()}},r.prototype.triggerChange=function(e,t){this.trigger("change",{elements:e,items:this.getDataByElements(e),value:this.value,event:t})},r.prototype.getDataByElems=function(e){for(var t=[],i=0,s=e.length;i<s;i++)t.push(this.getDataByValue(this.getFormattedValue(e[i].getAttribute("data-value"))));return t},r.prototype.getDataByElements=function(e){var i,s=[],l=0;if(!t.isNullOrUndefined(this.listData)){var n=this.typeOfData(this.listData).typeof;if("string"===n||"number"===n||"boolean"===n)for(var o=0,r=this.listData;o<r.length;o++){for(var a=r[o],h=l,p=e.length;h<p;h++)if(i=this.getFormattedValue(e[h].getAttribute("data-value")),!t.isNullOrUndefined(a)&&a===i){l=h,s.push(a);break}if(e.length===s.length)break}else for(var u=0,c=this.listData;u<c.length;u++){for(a=c[u],h=l,p=e.length;h<p;h++)if(i=this.getFormattedValue(e[h].getAttribute("data-value")),!t.isNullOrUndefined(a)&&t.getValue(this.fields.value?this.fields.value:"value",a)===i){l=h,s.push(a);break}if(e.length===s.length)break}return s}return null},r.prototype.checkMaxSelection=function(){var e=this.list.querySelectorAll(".e-list-item span.e-check").length;if(this.selectionSettings.showCheckbox)for(var t=0,i=this.list.getElementsByClassName("e-list-item");t<i.length;t++)i[t].querySelector(".e-frame.e-check")||(e===this.maximumSelectionLength?i[t].classList.add("e-disable"):i[t].classList.contains("e-disable")&&i[t].classList.remove("e-disable"))},r.prototype.toolbarClickHandler=function(e){var i=t.closest(e.target,"button");if(i){if(this.toolbarAction=i.getAttribute("data-value"),i.disabled)return;switch(this.toolbarAction){case"moveUp":this.moveUpDown(!0);break;case"moveDown":this.moveUpDown();break;case"moveTo":this.moveItemTo();break;case"moveFrom":this.moveItemFrom();break;case"moveAllTo":this.moveAllItemTo();break;case"moveAllFrom":this.moveAllItemFrom();break;default:this.trigger("actionBegin",{cancel:!1,items:this.getDataByElems(this.getSelectedItems()),eventName:this.toolbarAction})}}},r.prototype.moveUpDown=function(e,t,i){var l=this,n=this.getSelectedItems();if(i&&(n=i),!(e&&this.isSelected(this.ulElement.firstElementChild)||!e&&this.isSelected(this.ulElement.lastElementChild))||i){var o=this.getDataByElems(n),r={cancel:!1,items:o,eventName:this.toolbarAction};this.trigger("actionBegin",r),r.cancel||((e?n:n.reverse()).forEach(function(t){var i=Array.prototype.indexOf.call(l.ulElement.querySelectorAll(".e-list-item"),t),n=Array.prototype.indexOf.call(l.ulElement.children,t);s.moveTo(l.ulElement,l.ulElement,[n],e?n-1:n+2),l.changeData(n,e?n-1:n+1,e?i-1:i+1,t)}),this.trigger("actionComplete",{items:o,eventName:this.toolbarAction}),n[0].focus(),!t&&this.toolbarSettings.items.length&&this.getToolElem().querySelector("[data-value="+(e?"moveUp":"moveDown")+"]").focus(),this.updateToolBarState())}},r.prototype.moveItemTo=function(){this.moveData(this,this.getScopedListBox())},r.prototype.moveItemFrom=function(){this.moveData(this.getScopedListBox(),this)},r.prototype.moveData=function(e,i,l,n,o){var r=[],a=[],h=[],p=[],u=[].slice.call(e.listData),c=[].slice.call(i.listData),d=[].slice.call(e.sortedData),m=[].slice.call(i.sortedData),f=[].slice.call(e.liCollections),v=[],y=[].slice.call(i.liCollections),g=[],C=[],b=e.getSelectedItems();n&&(b=n);var E="None"!==i.sortOrder||i.selectionSettings.showCheckbox!==e.selectionSettings.showCheckbox||i.fields.groupBy||i.itemTemplate||e.itemTemplate;if(e.value=[],b.length){this.removeSelected(e,b),b.forEach(function(t){r.push(Array.prototype.indexOf.call(e.ulElement.children,t)),v.push(Array.prototype.indexOf.call(e.ulElement.querySelectorAll(".e-list-item"),t)),a.push(Array.prototype.indexOf.call(e.listData,e.getDataByElems([t])[0])),p.push(Array.prototype.indexOf.call(e.sortedData,e.getDataByElems([t])[0])),h.push(Array.prototype.indexOf.call(e.jsonData,e.getDataByElems([t])[0]))}),"None"!==this.sortOrder?p.forEach(function(t){g.push(e.sortedData[t])}):h.forEach(function(t){g.push(e.jsonData[t])});var S={cancel:!1,items:g,eventName:this.toolbarAction};if(e.trigger("actionBegin",S),S.cancel)return;var x=[];if(v.sort(function(e,t){return e-t}).reverse().forEach(function(e){x.push(f.splice(e,1)[0])}),e.liCollections=f,o){var w=y.splice(0,o);i.liCollections=w.concat(x.reverse()).concat(y)}else i.liCollections=y.concat(x.reverse());if(0===i.listData.length){var O=i.ulElement.childNodes[0];O&&i.ulElement.removeChild(O)}if(a.sort(function(e,t){return t-e}).forEach(function(e){u.splice(e,1)[0]}),p.sort(function(e,t){return t-e}).forEach(function(e){d.splice(e,1)[0]}),h.slice().reverse().forEach(function(t){C.push(e.jsonData.splice(t,1)[0])}),E)if(e.fields.groupBy){var k=e.renderItems(u,e.fields);e.updateListItems(k,e.ulElement)}else b.forEach(function(e){t.detach(e)});else s.moveTo(e.ulElement,i.ulElement,r,o),e.trigger("actionComplete",{items:g,eventName:this.toolbarAction});i.mainList.childElementCount!==i.jsonData.length&&(i.mainList=i.ulElement),e.updateMainList();var A=[].slice.call(i.jsonData);m=[].slice.call(i.sortedData),this.selectNextList(b,v,a,e),l&&this.list.focus(),e.listData=u,e.sortedData=d,o=o||c.length;for(var D=g.length-1;D>=0;D--)c.splice(o,0,g[D]),A.splice(o,0,g[D]),m.splice(o,0,g[D]);if(i.listData=c,i.jsonData=A,i.sortedData=m,E){k=i.renderItems(c,i.fields);i.updateListItems(k,i.ulElement),i.setSelection(),e.trigger("actionComplete",{items:g,eventName:this.toolbarAction})}e.updateSelectedOptions(),0===e.listData.length&&e.l10nUpdate()}1===e.value.length&&e.getSelectedItems().length&&(e.value[0]=e.getFormattedValue(e.getSelectedItems()[0].getAttribute("data-value")))},r.prototype.selectNextList=function(e,t,i,l){var n,o,r=l.ulElement.querySelectorAll(".e-list-item").length,a=-1;1===e.length&&r&&!l.selectionSettings.showCheckbox&&(o=r<=t[0]?r-1:t[0],n=l.ulElement.querySelectorAll(".e-list-item")[o],(a=l.getValidIndex(n,o,r===i[0]?38:40))>-1&&l.ulElement.querySelectorAll(".e-list-item")[a].classList.add(s.cssClass.selected))},r.prototype.moveAllItemTo=function(){this.moveAllData(this,this.getScopedListBox())},r.prototype.moveAllItemFrom=function(){this.moveAllData(this.getScopedListBox(),this)},r.prototype.moveAllData=function(e,t,i,l){var n=[].slice.call(t.listData),o=[].slice.call(t.jsonData),r="None"!==t.sortOrder||t.selectionSettings.showCheckbox!==e.selectionSettings.showCheckbox||t.fields.groupBy||t.itemTemplate||e.itemTemplate;this.removeSelected(e,e.getSelectedItems());var a=[].slice.call(e.jsonData),h={cancel:!1,items:a,eventName:this.toolbarAction};if(e.trigger("actionBegin",h),!h.cancel){if(0===t.listData.length){(p=t.ulElement.childNodes[0])&&t.ulElement.removeChild(p)}if(r){var p;(p=e.ulElement.childNodes[0])&&e.ulElement.removeChild(p)}s.moveTo(e.ulElement,t.ulElement,Array.apply(null,{length:e.ulElement.childElementCount}).map(Number.call,Number),l),this.trigger("actionComplete",{items:a,eventName:this.toolbarAction}),i&&this.list.focus(),l=l||n.length;for(var u=0;u<e.listData.length;u++)n.splice(l+u,0,e.listData[u]);for(u=0;u<e.jsonData.length;u++)o.splice(l+u,0,e.jsonData[u]);var c=[].slice.call(e.liCollections),d=[].slice.call(t.liCollections);if(e.liCollections=[],l){var m=d.splice(0,l);t.liCollections=m.concat(c).concat(d)}else t.liCollections=d.concat(c);if(e.value=[],n=n.filter(function(e){return!0!==e.isHeader}),t.listData=n,t.jsonData=o,e.listData=e.sortedData=e.jsonData=[],r){var f=t.renderItems(n,t.fields);t.updateListItems(f,t.ulElement),this.trigger("actionComplete",{items:a,eventName:this.toolbarAction})}else t.sortedData=n;e.updateSelectedOptions(),0===e.listData.length&&e.l10nUpdate()}},r.prototype.changeData=function(e,t,i,s){var l=[].slice.call(this.listData),n=[].slice.call(this.jsonData),o=[].slice.call(this.sortedData),r=Array.prototype.indexOf.call(this.jsonData,this.getDataByElems([s])[0]),a=Array.prototype.indexOf.call(this.sortedData,this.getDataByElems([s])[0]),h=[].slice.call(this.liCollections);l.splice(t,0,l.splice(e,1)[0]),n.splice(i,0,n.splice(r,1)[0]),o.splice(t,0,o.splice(a,1)[0]),h.splice(t,0,h.splice(e,1)[0]),this.listData=l,this.jsonData=n,this.liCollections=h,this.sortedData=o},r.prototype.getSelectedItems=function(){var e=[];return this.selectionSettings.showCheckbox?[].slice.call(this.ulElement.getElementsByClassName("e-check")).forEach(function(i){e.push(t.closest(i,".e-list-item"))}):e=[].slice.call(this.ulElement.getElementsByClassName(s.cssClass.selected)),e},r.prototype.getScopedListBox=function(){var e,i=this;return this.scope&&[].slice.call(document.querySelectorAll(this.scope)).forEach(function(s){t.getComponent(s,i.getModuleName())&&(e=t.getComponent(s,i.getModuleName()))}),e},r.prototype.getGrabbedItems=function(){return Array.prototype.slice.call(this.element.querySelectorAll(".e-grabbed"))},r.prototype.getDragArgs=function(e,t){var i=this.getGrabbedItems();return i.length?t&&i.push(e.target):i=[e.target],{elements:i,items:this.getDataByElems(i)}},r.prototype.onKeyDown=function(e){this.keyDownHandler(e),e.stopPropagation()},r.prototype.keyDownHandler=function(e){if([32,35,36,37,38,39,40,65].indexOf(e.keyCode)>-1&&!this.allowFiltering){if(e.target&&e.target.className.indexOf("e-edit-template")>-1)return;if(e.preventDefault(),32===e.keyCode&&this.ulElement.children.length)this.selectHandler({target:this.ulElement.getElementsByClassName("e-focused")[0],ctrlKey:e.ctrlKey,shiftKey:e.shiftKey});else if(65===e.keyCode&&e.ctrlKey)this.selectAll();else if((38===e.keyCode||40===e.keyCode)&&e.ctrlKey&&e.shiftKey)this.moveUpDown(38===e.keyCode,!0);else if(!this.toolbarSettings.items.length&&!this.tBListBox||39!==e.keyCode&&37!==e.keyCode||!e.ctrlKey)37!==e.keyCode&&39!==e.keyCode&&this.upDownKeyHandler(e);else{var t=this.tBListBox||this.getScopedListBox();39===e.keyCode?e.shiftKey?this.moveAllData(this,t,!0):this.moveData(this,t,!0):e.shiftKey?this.moveAllData(t,this,!0):this.moveData(t,this,!0)}}else this.allowFiltering&&(40!==e.keyCode&&38!==e.keyCode||this.upDownKeyHandler(e))},r.prototype.upDownKeyHandler=function(e){var i=this.ulElement,l=40===e.keyCode||36===e.keyCode?0:i.childElementCount-1,n=i.getElementsByClassName("e-focused")[0]||i.getElementsByClassName(s.cssClass.selected)[0];if(n){if(35!==e.keyCode&&36!==e.keyCode&&(l=Array.prototype.indexOf.call(i.children,n),40===e.keyCode?l++:l--,l<0||l>i.childElementCount-1))return;t.removeClass([n],"e-focused")}var o=i.children[l];if(o){if(-1===(l=this.getValidIndex(o,l,e.keyCode)))return void t.addClass([n],"e-focused");i.children[l].focus(),i.children[l].classList.add("e-focused"),e.ctrlKey||this.selectHandler({target:i.children[l],ctrlKey:e.ctrlKey,shiftKey:e.shiftKey},!0)}},r.prototype.KeyUp=function(e){var s=this,l=String.fromCharCode(e.keyCode).match(/\w/);if(t.isNullOrUndefined(l)||(this.isValidKey=!0),this.isValidKey=8===e.keyCode||46===e.keyCode||this.isValidKey,this.isValidKey&&(this.isValidKey=!1,e.keyCode,this.allowFiltering)){var n={preventDefaultAction:!1,text:this.targetElement(),updateData:function(e,t,i){n.cancel||(s.isFiltered=!0,s.remoteFilterAction=!0,s.dataUpdater(e,t,i))},event:e,cancel:!1};this.trigger("filtering",n,function(e){s.isDataFetched=!1,e.cancel||""!==s.filterInput.value&&s.isFiltered||(e.cancel||s.isCustomFiltering||e.preventDefaultAction||(s.inputString=s.filterInput.value,s.filteringAction(s.jsonData,new i.Query,s.fields)),s.isFiltered||s.isCustomFiltering||e.preventDefaultAction||s.dataUpdater(s.jsonData,new i.Query,s.fields))})}},r.prototype.filter=function(e,t,i){this.isCustomFiltering=!0,this.filteringAction(e,t,i)},r.prototype.filteringAction=function(e,t,i){this.resetList(e,i,t)},r.prototype.targetElement=function(){return this.targetInputElement=this.list.getElementsByClassName("e-input-filter")[0],this.targetInputElement.value},r.prototype.dataUpdater=function(e,t,i){this.isDataFetched=!1;if(""===this.targetElement().trim()){var s=this.mainList.cloneNode?this.mainList.cloneNode(!0):this.mainList;this.remoteCustomValue=!1,this.onActionComplete(s,this.jsonData),this.notify("reOrder",{module:"CheckBoxSelection",enable:this.selectionSettings.showCheckbox,e:this})}else this.resetList(e,i,t)},r.prototype.focusOutHandler=function(){var e=this.list.getElementsByClassName("e-focused")[0];e&&e.classList.remove("e-focused"),this.allowFiltering&&this.refreshClearIcon()},r.prototype.getValidIndex=function(e,t,i){var l=this.ulElement;return(e.classList.contains("e-disabled")||e.classList.contains(s.cssClass.group))&&(40===i||36===i?t++:t--),t<0||t===l.childElementCount?-1:(((e=l.querySelectorAll(".e-list-item")[t]).classList.contains("e-disabled")||e.classList.contains(s.cssClass.group))&&(t=this.getValidIndex(e,t,i)),t)},r.prototype.updateSelectedOptions=function(){var e=this,i=[],s=[];if(t.extend(s,this.value),this.getSelectedItems().forEach(function(t){t.classList.contains("e-grabbed")||i.push(e.getFormattedValue(t.getAttribute("data-value")))}),this.mainList.childElementCount===this.ulElement.childElementCount)if(this.allowFiltering&&this.selectionSettings.showCheckbox){for(var l=0;l<i.length;l++)s.indexOf(i[l])>-1||s.push(i[l]);this.setProperties({value:s},!0)}else this.setProperties({value:i},!0);this.updateSelectTag(),this.updateToolBarState(),this.tBListBox&&this.tBListBox.updateToolBarState()},r.prototype.clearSelection=function(e){var t=this;if(void 0===e&&(e=this.value),this.selectionSettings.showCheckbox){var i;this.getSelectedItems().forEach(function(s){i=t.getFormattedValue(s.getAttribute("data-value")),e.indexOf(i)<0&&(s.getElementsByClassName("e-check")[0].classList.remove("e-check"),s.getElementsByClassName("e-checkbox-wrapper")[0].removeAttribute("aria-checked"),s.removeAttribute("aria-selected"))})}},r.prototype.setSelection=function(e,t,i){var l=this;void 0===e&&(e=this.value),void 0===t&&(t=!0),void 0===i&&(i=!1);var n,o;e&&e.forEach(function(e){var r;r=i?l.getValueByText(e):e,(n=l.list.querySelector('[data-value="'+r+'"]'))&&(o=l.selectionSettings.showCheckbox?n.getElementsByClassName("e-frame")[0].classList.contains("e-check"):n.classList.contains("e-selected"),(!t&&o||t&&!o&&n)&&(l.selectionSettings.showCheckbox?l.notify("updatelist",{li:n,module:"listbox"}):t?(n.classList.add(s.cssClass.selected),n.setAttribute("aria-selected","true")):(n.classList.remove(s.cssClass.selected),n.removeAttribute("aria-selected"))))}),this.updateSelectTag()},r.prototype.updateSelectTag=function(){var e=this.getSelectTag(),t="";if(e.innerHTML="",this.value){for(var i=0,s=this.value.length;i<s;i++)t+='<option selected value="'+this.value[i]+'"></option>';e.innerHTML+=t}this.checkSelectAll()},r.prototype.checkDisabledState=function(e){return 0===e.ulElement.querySelectorAll("."+s.cssClass.li).length},r.prototype.updateToolBarState=function(){var e=this;if(this.toolbarSettings.items.length){var t=this.getScopedListBox(),i=this.list.parentElement.getElementsByClassName("e-listbox-tool")[0];this.toolbarSettings.items.forEach(function(s){var l=i.querySelector('[data-value="'+s+'"]');switch(s){case"moveAllTo":l.disabled=e.checkDisabledState(e);break;case"moveAllFrom":l.disabled=e.checkDisabledState(t);break;case"moveFrom":l.disabled=!t.value||!t.value.length;break;case"moveUp":l.disabled=!(e.value&&e.value.length&&!e.isSelected(e.ulElement.children[0]));break;case"moveDown":l.disabled=!(e.value&&e.value.length&&!e.isSelected(e.ulElement.children[e.ulElement.childElementCount-1]));break;default:l.disabled=!e.value||!e.value.length}})}},r.prototype.setCheckboxPosition=function(){var e=this.list;this.initLoad||"Left"!==this.selectionSettings.checkboxPosition||e.classList.remove("e-right"),"Right"===this.selectionSettings.checkboxPosition&&e.classList.add("e-right")},r.prototype.showCheckbox=function(e){var i=0,s=this.list.lastElementChild.querySelectorAll("li"),l=this.list.lastElementChild.getElementsByClassName("e-list-item").length;if(e){if(this.ulElement=this.renderItems(this.listData,this.fields),this.mainList=this.ulElement,this.list.removeChild(this.list.getElementsByTagName("ul")[0]),this.list.appendChild(this.ulElement),this.selectionSettings.showSelectAll&&!this.list.getElementsByClassName("e-selectall-parent")[0]){var n=new t.L10n(this.getModuleName(),{selectAllText:"Select All",unSelectAllText:"Unselect All"},this.locale);this.showSelectAll=!0,this.selectAllText=n.getConstant("selectAllText"),this.unSelectAllText=n.getConstant("unSelectAllText"),this.popupWrapper=this.list,this.checkBoxSelectionModule.checkAllParent=null,this.notify("selectAll",{}),this.checkSelectAll()}}else{for(this.list.getElementsByClassName("e-selectall-parent")[0]&&this.list.removeChild(this.list.getElementsByClassName("e-selectall-parent")[0]);i<l;i++)s[i].classList.contains("e-list-item")&&s[i].removeChild(s[i].getElementsByClassName("e-checkbox-wrapper")[0]),s[i].hasAttribute("aria-selected")&&s[i].removeAttribute("aria-selected");this.mainList=this.ulElement}this.value=[]},r.prototype.isSelected=function(e){return!t.isNullOrUndefined(e)&&(e.classList.contains(s.cssClass.selected)||null!==e.querySelector(".e-check"))},r.prototype.getSelectTag=function(){return this.list.getElementsByClassName("e-hidden-select")[0]},r.prototype.getToolElem=function(){return this.list.parentElement.getElementsByClassName("e-listbox-tool")[0]},r.prototype.formResetHandler=function(){this.value=this.initialSelectedOptions},r.prototype.getModuleName=function(){return"listbox"},r.prototype.getPersistData=function(){return this.addOnPersist(["value"])},r.prototype.getLocaleName=function(){return"listbox"},r.prototype.destroy=function(){this.unwireEvents(),"EJS-LISTBOX"===this.element.tagName?this.element.innerHTML="":(this.element.style.display="inline-block",this.toolbarSettings.items.length&&(this.list.parentElement.parentElement.insertBefore(this.list,this.list.parentElement),t.detach(this.list.nextElementSibling)),this.list.parentElement.insertBefore(this.element,this.list)),e.prototype.destroy.call(this),this.itemTemplate&&this.clearTemplate()},r.prototype.onPropertyChanged=function(i,l){var o=this.toolbarSettings.items.length?this.list.parentElement:this.list;e.prototype.onPropertyChanged.call(this,i,l),this.setUpdateInitial(["fields","query","dataSource"],i);for(var r=0,a=Object.keys(i);r<a.length;r++){switch(a[r]){case"cssClass":l.cssClass&&t.removeClass([o],l.cssClass.split(" ")),i.cssClass&&t.addClass([o],i.cssClass.split(" "));break;case"enableRtl":i.enableRtl?this.list.classList.add("e-rtl"):this.list.classList.remove("e-rtl");break;case"value":t.removeClass(this.list.querySelectorAll("."+s.cssClass.selected),s.cssClass.selected),this.clearSelection(this.value),this.setSelection();break;case"height":this.setHeight();break;case"enabled":this.setEnable();break;case"allowDragAndDrop":i.allowDragAndDrop?this.initDraggable():t.getComponent(this.ulElement,"sortable").destroy();break;case"allowFiltering":this.allowFiltering?this.setFiltering():(this.list.removeChild(this.list.getElementsByClassName("e-filter-parent")[0]),this.filterParent=null,t.removeClass([this.list],"e-filter-list"));break;case"filterBarPlaceholder":this.allowFiltering&&this.filterInput&&n.Input.setPlaceholder(i.filterBarPlaceholder,this.filterInput);break;case"scope":this.allowDragAndDrop&&(t.getComponent(this.ulElement,"sortable").scope=i.scope),this.toolbarSettings.items.length&&(l.scope&&(t.getComponent(document.querySelector(l.scope),this.getModuleName()).tBListBox=null),i.scope&&(t.getComponent(document.querySelector(i.scope),this.getModuleName()).tBListBox=this));break;case"toolbarSettings":var h=void 0,p=i.toolbarSettings.position,u=this.getToolElem();p&&(t.removeClass([o],["e-right","e-left"]),o.classList.add("e-"+p.toLowerCase()),"Left"===p?o.insertBefore(u,this.list):o.appendChild(u)),i.toolbarSettings.items&&(l.toolbarSettings&&l.toolbarSettings.items.length&&((h=this.list.parentElement).parentElement.insertBefore(this.list,h),t.detach(h)),this.initToolbarAndStyles(),this.wireToolbarEvent());break;case"selectionSettings":var c=i.selectionSettings.showSelectAll,d=i.selectionSettings.showCheckbox;if(!t.isNullOrUndefined(c)){if(this.showSelectAll=c,this.showSelectAll){var m=new t.L10n(this.getModuleName(),{selectAllText:"Select All",unSelectAllText:"Unselect All"},this.locale);this.checkBoxSelectionModule.checkAllParent=null,this.showSelectAll=!0,this.selectAllText=m.getConstant("selectAllText"),this.unSelectAllText=m.getConstant("selectAllText"),this.popupWrapper=this.list}this.notify("selectAll",{}),this.checkSelectAll()}t.isNullOrUndefined(d)||this.showCheckbox(d),this.selectionSettings.showCheckbox&&this.setCheckboxPosition();break;case"dataSource":this.isDataSourceUpdate=!0,this.jsonData=[].slice.call(this.dataSource)}}};var a;return je([t.Property("")],r.prototype,"cssClass",void 0),je([t.Property([])],r.prototype,"value",void 0),je([t.Property("")],r.prototype,"height",void 0),je([t.Property(!1)],r.prototype,"allowDragAndDrop",void 0),je([t.Property(1e3)],r.prototype,"maximumSelectionLength",void 0),je([t.Property(!1)],r.prototype,"allowFiltering",void 0),je([t.Property("")],r.prototype,"scope",void 0),je([t.Property(!0)],r.prototype,"ignoreCase",void 0),je([t.Property(null)],r.prototype,"filterBarPlaceholder",void 0),je([t.Event()],r.prototype,"beforeItemRender",void 0),je([t.Event()],r.prototype,"filtering",void 0),je([t.Event()],r.prototype,"select",void 0),je([t.Event()],r.prototype,"change",void 0),je([t.Event()],r.prototype,"beforeDrop",void 0),je([t.Event()],r.prototype,"dragStart",void 0),je([t.Event()],r.prototype,"drag",void 0),je([t.Event()],r.prototype,"drop",void 0),je([t.Event()],r.prototype,"dataBound",void 0),je([t.Property(null)],r.prototype,"groupTemplate",void 0),je([t.Property("Request failed")],r.prototype,"actionFailureTemplate",void 0),je([t.Property(1e3)],r.prototype,"zIndex",void 0),je([t.Property(!1)],r.prototype,"ignoreAccent",void 0),je([t.Complex({},Re)],r.prototype,"toolbarSettings",void 0),je([t.Complex({},qe)],r.prototype,"selectionSettings",void 0),r=a=je([t.NotifyPropertyChanges],r)}(L),ze={backIcon:"e-input-group-icon e-back-icon e-icons",filterBarClearIcon:"e-input-group-icon e-clear-icon e-icons",filterInput:"e-input-filter",filterParent:"e-filter-parent",clearIcon:"e-clear-icon"};e.incrementalSearch=a,e.Search=h,e.resetIncrementalSearchValues=p,e.highlightSearch=u,e.revertHighlightSearch=d,e.FieldSettings=D,e.dropDownBaseClasses=I,e.DropDownBase=L,e.dropDownListClasses=N,e.DropDownList=W,e.Fields=ie,e.TreeSettings=se,e.DropDownTree=le,e.ComboBox=he,e.AutoComplete=ce,e.MultiSelect=Ne,e.CheckBoxSelection=Ue,e.createFloatLabel=m,e.updateFloatLabelState=f,e.removeFloating=v,e.setPlaceHolder=y,e.floatLabelFocus=g,e.floatLabelBlur=C,e.encodePlaceholder=b,e.SelectionSettings=qe,e.ToolbarSettings=Re,e.ListBox=Ke,Object.defineProperty(e,"__esModule",{value:!0})});
	//# sourceMappingURL=ej2-dropdowns.umd.min.js.map


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	*  filename: ej2-excel-export.umd.min.js
	*  version : 19.4.52
	*  Copyright Syncfusion Inc. 2001 - 2020. All rights reserved.
	*  Use of this code is subject to the terms of our license.
	*  A copy of the current license can be obtained at any time by e-mailing
	*  licensing@syncfusion.com. Any infringement will be prosecuted under
	*  applicable laws. 
	*/
	!function(e,t){ true?t(exports,__webpack_require__(210),__webpack_require__(23)):"function"==typeof define&&define.amd?define(["exports","@syncfusion/ej2-compression","@syncfusion/ej2-base"],t):t(e.ej={},e.ej2Compression,e.ej2Base)}(this,function(e,t,r){"use strict";var o=function(){return function(){this.numFmtId=0,this.backColor="none",this.fontName="Calibri",this.fontSize=10.5,this.fontColor="#000000",this.italic=!1,this.bold=!1,this.underline=!1,this.strikeThrough=!1,this.wrapText=!1,this.hAlign="general",this.vAlign="bottom",this.indent=0,this.rotation=0,this.numberFormat="GENERAL",this.type="datetime",this.borders=new m,this.isGlobalStyle=!1}}(),i=function(){return function(){this.sz=10.5,this.name="Calibri",this.u=!1,this.b=!1,this.i=!1,this.color="FF000000",this.strike=!1}}(),n=function(){return function(){}}(),s=function(){return function(){}}(),l=function(){return function(){}}(),a=function(){return function(){this.name="Normal",this.xfId=0}}(),d=function(){return function(e,t){this.numFmtId=e,this.formatCode=t}}(),h=function(){return function(e,t){this.lineStyle=e,this.color=t}}(),m=function(){return function(){this.left=new h("none","#FFFFFF"),this.right=new h("none","#FFFFFF"),this.top=new h("none","#FFFFFF"),this.bottom=new h("none","#FFFFFF"),this.all=new h("none","#FFFFFF")}}(),p=function(){var e=function(t,r){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])})(t,r)};return function(t,r){function o(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(o.prototype=r.prototype,new o)}}(),u=function(){return function(){}}(),c=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.add=function(e){for(var r=!1,o=0,i=0,n=t;i<n.length;i++){n[i].index===e.index&&(t[o]=e,r=!0),o++}r||t.push(e)},t}return p(t,e),t}(Array),f=function(){return function(){}}(),v=function(){var e=function(t,r){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])})(t,r)};return function(t,r){function o(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(o.prototype=r.prototype,new o)}}(),g=function(){return function(){}}(),y=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.add=function(e){t.push(e)},t}return v(t,e),t}(Array),x=function(){var e=function(t,r){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])})(t,r)};return function(t,r){function o(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(o.prototype=r.prototype,new o)}}(),w=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return x(t,e),t}(Array),b=function(){var e=function(t,r){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])})(t,r)};return function(t,r){function o(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(o.prototype=r.prototype,new o)}}(),F=function(){return function(){this.isSummaryRowBelow=!0,this.showGridLines=!0,this.enableRtl=!1}}(),S=function(){return function(){}}(),C=function(){return function(){}}(),k=function(){return function(){}}(),I=function(){return function(){}}(),T=function(e){function t(){var r=null!==e&&e.apply(this,arguments)||this;return r.add=function(e){for(var o=!1,i=0,n=0,s=r;n<s.length;n++){var l=s[n];if(t.isIntersecting(l,e)){var a=new I;a.x=Math.min(l.x,e.x),a.y=Math.min(l.Y,e.y),a.width=Math.max(l.Width+l.X,e.width+e.x),a.height=Math.max(l.Height+l.Y,e.height+e.y),a.ref=r[i].ref.split(":")[0]+":"+e.ref.split(":")[1],r[i]=a,e=a,o=!0}i++}return o||r.push(e),e},r}return b(t,e),t.isIntersecting=function(e,t){return e.x<=t.x+t.width&&t.x<=e.x+e.width&&e.y<=t.y+t.height&&t.y<=e.y+e.height},t}(Array),R=function(){return function(){}}(),P=function(){function e(e){this.intl=new r.Internationalization}return e.prototype.getFormatFunction=function(e,t){return e.type?(t&&(e.isServerRendered=!0),this.intl.getDateFormat(e)):this.intl.getNumberFormat(e)},e.prototype.toView=function(e,t){var o=e;return r.isNullOrUndefined(t)||r.isNullOrUndefined(e)||(o=t(e)),o},e.prototype.displayText=function(e,t,r){return this.toView(e,this.getFormatFunction(t,r))},e}(),N=function(){function e(e,t){if(this.csvStr="",this.separator=null===t||void 0===t?",":t,this.formatter=new P,this.isMicrosoftBrowser=!!navigator.msSaveBlob,null!==e.isServerRendered&&void 0!==e.isServerRendered&&(this.isServerRendered=e.isServerRendered),null!==e.styles&&void 0!==e.styles){this.globalStyles=new Map;for(var r=0;r<e.styles.length;r++)void 0!==e.styles[r].name&&void 0!==e.styles[r].numberFormat&&this.globalStyles.set(e.styles[r].name,e.styles[r].numberFormat)}null!==e.worksheets&&void 0!==e.worksheets&&this.parseWorksheet(e.worksheets[0])}return e.prototype.parseWorksheet=function(e){null!==e.rows&&void 0!==e.rows&&this.parseRows(e.rows)},e.prototype.parseRows=function(e){for(var t=1,r=0,o=e;r<o.length;r++){var i=o[r];if(null===i.index||void 0===i.index)throw Error("Row index is missing.");for(;t<i.index;)this.csvStr+="\n",t++;this.parseRow(i)}},e.prototype.parseRow=function(e){if(null!==e.cells&&void 0!==e.cells)for(var t=1,r=0,o=e.cells;r<o.length;r++){var i=o[r];if(null===i.index||void 0===i.index)throw Error("Cell index is missing.");for(;t<i.index;)this.csvStr+=this.separator,t++;this.parseCell(i)}},e.prototype.parseCell=function(e){var t=this.csvStr;if(void 0!==e.value)if(e.value instanceof Date)if(void 0!==e.style&&void 0!==e.style.numberFormat)try{t+=this.parseCellValue(this.formatter.displayText(e.value,{type:"dateTime",skeleton:e.style.numberFormat},this.isServerRendered))}catch(r){t+=this.parseCellValue(this.formatter.displayText(e.value,{type:"dateTime",format:e.style.numberFormat},this.isServerRendered))}else if(void 0!==e.style&&void 0!==e.style.name&&this.globalStyles.has(e.style.name))try{t+=this.parseCellValue(this.formatter.displayText(e.value,{type:"dateTime",skeleton:this.globalStyles.get(e.style.name)},this.isServerRendered))}catch(r){t+=this.parseCellValue(this.formatter.displayText(e.value,{type:"dateTime",format:this.globalStyles.get(e.style.name)},this.isServerRendered))}else t+=e.value;else"boolean"==typeof e.value?t+=e.value?"TRUE":"FALSE":"number"==typeof e.value?void 0!==e.style&&void 0!==e.style.numberFormat?t+=this.parseCellValue(this.formatter.displayText(e.value,{format:e.style.numberFormat},this.isServerRendered)):void 0!==e.style&&void 0!==e.style.name&&this.globalStyles.has(e.style.name)?t+=this.parseCellValue(this.formatter.displayText(e.value,{format:this.globalStyles.get(e.style.name)},this.isServerRendered)):t+=e.value:t+=this.parseCellValue(e.value);this.csvStr=t},e.prototype.parseCellValue=function(e){for(var t="",r=e.length,o=0;o<r;o++)'"'===e[o]?t+=e[o].replace('"','""'):t+=e[o];return-1!==(e=t).indexOf(this.separator)||-1!==e.indexOf("\n")?e='"'+e+'"':e},e.prototype.save=function(e){if(this.buffer=new Blob(["\ufeff"+this.csvStr],{type:"text/csv;charset=UTF-8"}),this.isMicrosoftBrowser)navigator.msSaveBlob(this.buffer,e);else{var t=window.URL.createObjectURL(this.buffer),r=document.createElementNS("http://www.w3.org/1999/xhtml","a");r.download=e,r.href=t;var o=document.createEvent("MouseEvent");o.initEvent("click",!0,!0),r.dispatchEvent(o),setTimeout(function(){window.URL.revokeObjectURL(t)})}},e.prototype.saveAsBlob=function(){return new Blob(["\ufeff"+this.csvStr],{type:"text/csv;charset=UTF-8"})},e}(),A=function(){function e(){this.parts=[]}return e.prototype.append=function(e){this.parts.push(e),this.blob=void 0},e.prototype.getBlob=function(){return new Blob(this.parts,{type:"text/plain"})},e}(),O=function(){return function(){}}(),B=function(){function e(e,n,s,l,d){if(this.sharedStringCount=0,this.unitsProportions=[1.28,.32,96,96/25.4,96/2.54,1,96/72,96/72/12700],this.hyperlinkStyle={fontColor:"#0000FF",underline:!0},this.culture=void 0!==s?s:"en-US",this.currency=void 0!==l?l:"USD",this.intl=new r.Internationalization(this.culture),this.mSaveType=n,"xlsx"===n){if(this.mArchive=new t.ZipArchive,this.sharedString=[],this.mFonts=[],this.mBorders=[],this.mStyles=[],this.printTitles=new Map,this.cellStyles=new Map,this.mNumFmt=new Map,this.mFills=new Map,this.mStyles.push(new o),this.mFonts.push(new i),this.cellStyles.set("Normal",new a),this.mCellXfs=[],this.mCellStyleXfs=[],this.drawingCount=0,this.imageCount=0,null!==e.styles&&void 0!==e.styles){this.globalStyles=new Map;for(var h=0;h<e.styles.length;h++)if(void 0!==e.styles[h].name){if(this.cellStyles.has(e.styles[h].name))throw Error("Style name "+e.styles[h].name+" is already existed");var m=new o;m.isGlobalStyle=!0,this.parserCellStyle(e.styles[h],m,"none");var p=new a;p.name=m.name,p.xfId=m.index-1,this.cellStyles.set(p.name,p);var u={};void 0!==e.styles[h].numberFormat&&(u.format=e.styles[h].numberFormat),void 0!==e.styles[h].type?u.type=e.styles[h].type:u.type="datetime",void 0!==u.format&&this.globalStyles.set(e.styles[h].name,u)}}if(null===e.worksheets||void 0===e.worksheets)throw Error("Worksheet is expected.");this.parserWorksheets(e.worksheets),null!==e.builtInProperties&&void 0!==e.builtInProperties&&(this.builtInProperties=new D,this.parserBuiltInProperties(e.builtInProperties,this.builtInProperties))}else this.csvHelper=new N(e,d)}return e.prototype.parserBuiltInProperties=function(e,t){null!==e.author&&void 0!==e.author&&(t.author=e.author),null!==e.comments&&void 0!==e.comments&&(t.comments=e.comments),null!==e.category&&void 0!==e.category&&(t.category=e.category),null!==e.company&&void 0!==e.company&&(t.company=e.company),null!==e.manager&&void 0!==e.manager&&(t.manager=e.manager),null!==e.subject&&void 0!==e.subject&&(t.subject=e.subject),null!==e.title&&void 0!==e.title&&(t.title=e.title),null!==e.createdDate&&void 0!==e.createdDate&&(t.createdDate=e.createdDate),null!==e.modifiedDate&&void 0!==e.modifiedDate&&(t.modifiedDate=e.modifiedDate),null!==e.tags&&void 0!==e.tags&&(t.tags=e.tags),null!==e.status&&void 0!==e.status&&(t.status=e.status)},e.prototype.parserWorksheets=function(e){this.worksheets=new w;for(var t=e.length,r=0;r<t;r++){var o=e[r],i=new F;this.mergeCells=new T,this.mergedCellsStyle=new Map,this.mHyperLinks=[],null!==o.name&&void 0!==o.name?i.name=o.name:i.name="Sheet"+(r+1).toString(),null!==o.enableRtl&&void 0!==o.enableRtl&&(i.enableRtl=o.enableRtl),i.index=r+1,null!==o.columns&&void 0!==o.columns&&this.parserColumns(o.columns,i),null!==o.rows&&void 0!==o.rows&&this.parserRows(o.rows,i),null!==o.showGridLines&&void 0!==o.showGridLines&&(i.showGridLines=o.showGridLines),null!==o.freeze&&void 0!==o.freeze&&this.parserFreezePanes(o.freeze,i),null!==o.printTitle&&void 0!==o.printTitle&&this.parserPrintTitle(o.printTitle,i),void 0!==o.pageSetup&&void 0!==o.pageSetup.isSummaryRowBelow&&(i.isSummaryRowBelow=o.pageSetup.isSummaryRowBelow),void 0!==o.images&&this.parserImages(o.images,i),null!==o.autoFilters&&void 0!==o.autoFilters&&this.parseFilters(o.autoFilters,i),i.index=r+1,i.mergeCells=this.mergeCells,i.hyperLinks=this.mHyperLinks,this.worksheets.push(i)}},e.prototype.mergeOptions=function(e,t){var r={};return this.applyProperties(e,r),this.applyProperties(t,r),r},e.prototype.applyProperties=function(e,t){for(var r=Object.keys(e),o=0;o<r.length;o++)"name"!==r[o]&&(t[r[o]]=e[r[o]])},e.prototype.getCellName=function(e,t){return this.getColumnName(t)+e.toString()},e.prototype.getColumnName=function(e){e--;var t="";do{var r=e%26;e=e/26-1,t=String.fromCharCode(65+r)+t}while(e>=0);return t},e.prototype.parserPrintTitle=function(e,t){var r,o="";if(null!==e.fromRow&&void 0!==e.fromRow){r="$"+e.fromRow+":$"+(null!==e.toRow&&void 0!==e.toRow?e.toRow:e.fromRow)}var i;if(null!==e.fromColumn&&void 0!==e.fromColumn){var n=e.fromColumn,s=void 0;s=null!==e.toColumn&&void 0!==e.toColumn?e.toColumn:e.fromColumn,i="$"+this.getColumnName(n)+":$"+this.getColumnName(s)}void 0!==r&&(o+=t.name+"!"+r),void 0!==i&&void 0!==r?o+=","+t.name+"!"+i:void 0!==i&&(o+=t.name+"!"+i),""!==o&&this.printTitles.set(t.index-1,o)},e.prototype.parserFreezePanes=function(e,t){t.freezePanes=new k,null!==e.row&&void 0!==e.row?t.freezePanes.row=e.row:t.freezePanes.row=0,null!==e.column&&void 0!==e.column?t.freezePanes.column=e.column:t.freezePanes.column=0,t.freezePanes.leftCell=this.getCellName(t.freezePanes.row+1,t.freezePanes.column+1)},e.prototype.parserColumns=function(e,t){var r=e.length;t.columns=[];for(var o=0;o<r;o++){var i=new f;if(null===e[o].index||void 0===e[o].index)throw Error("Column index is missing.");i.index=e[o].index,null!==e[o].width&&void 0!==e[o].width&&(i.width=e[o].width),t.columns.push(i)}},e.prototype.parserRows=function(e,t){var r=e.length;t.rows=new y;for(var o=0,i=0;i<r;i++){var n=this.parserRow(e[i],o);o=n.index,t.rows.add(n)}this.insertMergedCellsStyle(t)},e.prototype.insertMergedCellsStyle=function(e){var t=this;this.mergeCells.length>0&&this.mergedCellsStyle.forEach(function(o,i){var n=e.rows.filter(function(e){return e.index===o.y})[0];if(r.isNullOrUndefined(n)){var s=e.rows.filter(function(e){return e.index<=o.y}),l=new g;l.index=o.y,l.cells=new c,l.cells.add(t.createCell(o,i));h=0;s.length>0&&(h=e.rows.indexOf(s[s.length-1])+1),e.rows.splice(h,0,l)}else{var a=n.cells.filter(function(e){return e.index===o.x})[0];if(r.isNullOrUndefined(a)){var d=n.cells.filter(function(e){return e.index<=o.x}),h=0;d.length>0&&(h=n.cells.indexOf(d[d.length-1])+1),n.cells.splice(h,0,t.createCell(o,i))}else a.styleIndex=o.styleIndex}})},e.prototype.createCell=function(e,t){var r=new u;return r.refName=t,r.index=e.x,r.cellStyle=new o,r.styleIndex=e.styleIndex,r},e.prototype.parserRow=function(e,t){var r=new g;if(null!==e.height&&void 0!==e.height&&(r.height=e.height),null===e.index||void 0===e.index)throw Error("Row index is missing.");return r.index=e.index,null!==e.grouping&&void 0!==e.grouping&&this.parseGrouping(e.grouping,r),this.parseCells(e.cells,r),r},e.prototype.parseGrouping=function(e,t){t.grouping=new C,void 0!==e.outlineLevel&&(t.grouping.outlineLevel=e.outlineLevel),void 0!==e.isCollapsed&&(t.grouping.isCollapsed=e.isCollapsed),void 0!==e.isHidden&&(t.grouping.isHidden=e.isHidden)},e.prototype.parseCells=function(e,t){t.cells=new c;for(var r=void 0!==e?e.length:0,i=1,n=1,s=0;s<r;s++){var l=e[s],a=new u;if(null===l.index||void 0===l.index)throw Error("Cell index is missing.");if(a.index=l.index,a.index<i?i=a.index:a.index>n&&(n=a.index),a.refName=this.getCellName(t.index,a.index),null!==l.rowSpan&&void 0!==l.rowSpan?a.rowSpan=l.rowSpan-1:a.rowSpan=0,null!==l.colSpan&&void 0!==l.colSpan?a.colSpan=l.colSpan-1:a.colSpan=0,null!==l.hyperlink&&void 0!==l.hyperlink){var d=new S;void 0!==l.hyperlink.target&&(d.target=l.hyperlink.target,void 0!==l.hyperlink.displayText?a.value=l.hyperlink.displayText:a.value=l.hyperlink.target,a.type=this.getCellValueType(a.value),d.ref=a.refName,d.rId=this.mHyperLinks.length+1,this.mHyperLinks.push(d),a.cellStyle=new o,this.parserCellStyle(void 0!==l.style?this.mergeOptions(l.style,this.hyperlinkStyle):this.hyperlinkStyle,a.cellStyle,"string"),a.styleIndex=a.cellStyle.index)}null!==l.formula&&void 0!==l.formula&&(a.formula=l.formula,a.type="formula"),null!==l.value&&void 0!==l.value&&(void 0!==a.formula?a.value=0:(a.value=l.value,a.type=this.getCellValueType(a.value))),null!==l.style&&void 0!==l.style&&void 0===a.styleIndex?(a.cellStyle=new o,a.value instanceof Date?this.parserCellStyle(l.style,a.cellStyle,a.type,14):this.parserCellStyle(l.style,a.cellStyle,a.type),a.styleIndex=a.cellStyle.index):a.value instanceof Date&&(a.cellStyle=new o,this.parserCellStyle({},a.cellStyle,a.type,14),a.styleIndex=a.cellStyle.index),this.parseCellType(a),this.mergeCells=this.processMergeCells(a,t.index,this.mergeCells),t.cells.add(a)}t.spans=i+":"+n},e.prototype.GetColors=function(){var e;return(e=new Map).set("WHITE","FFFFFFFF"),e.set("SILVER","FFC0C0C0"),e.set("GRAY","FF808080"),e.set("BLACK","FF000000"),e.set("RED","FFFF0000"),e.set("MAROON","FF800000"),e.set("YELLOW","FFFFFF00"),e.set("OLIVE","FF808000"),e.set("LIME","FF00FF00"),e.set("GREEN","FF008000"),e.set("AQUA","FF00FFFF"),e.set("TEAL","FF008080"),e.set("BLUE","FF0000FF"),e.set("NAVY","FF000080"),e.set("FUCHSIA","FFFF00FF"),e.set("PURPLE","FF800080"),e},e.prototype.processColor=function(e){return 0===e.indexOf("#")?e.replace("#","FF"):(e=e.toUpperCase(),this.rgbColors=this.GetColors(),e=this.rgbColors.has(e)?this.rgbColors.get(e):"FF000000")},e.prototype.processCellValue=function(e,t){var r=e;if(-1!==e.indexOf("<font")||-1!==e.indexOf("<a")||-1!==e.indexOf("<b>")||-1!==e.indexOf("<i>")||-1!==e.indexOf("<u>")){var o="",i=e.indexOf("<",0),n=e.indexOf(">",i+1);if(i>=0&&n>=0){for(0!==i&&(o+='<r><t xml:space="preserve">'+this.processString(e.substring(0,i))+"</t></r>");i>=0&&n>=0;)if((n=e.indexOf(">",i+1))>=0){var s=e.substring(i+1,n);(i=e.indexOf("<",n+1))<0&&(i=r.length);var l=r.substring(n+1,i);if(0!==l.length){var a=s.split(" ");if(a.length>0&&(o+="<r><rPr>"),a.length>1)for(var d=0,h=a;d<h.length;d++){var m=h[d];switch(m.trim().substring(0,5)){case"size=":o+='<sz val="'+m.substring(6,m.length-1)+'"/>';break;case"face=":o+='<rFont val="'+m.substring(6,m.length-1)+'"/>';break;case"color":o+='<color rgb="'+this.processColor(m.substring(7,m.length-1))+'"/>';break;case"href=":var p=new S;p.target=m.substring(6,m.length-1).trim(),p.ref=t.refName,p.rId=this.mHyperLinks.length+1,this.mHyperLinks.push(p),o+='<color rgb="FF0000FF"/><u/><b/>'}}else if(1===a.length){switch(a[0].trim()){case"b":o+="<b/>";break;case"i":o+="<i/>";break;case"u":o+="<u/>"}}o+='</rPr><t xml:space="preserve">'+this.processString(l)+"</t></r>"}}return""===o?r:o}return r}return r},e.prototype.applyGlobalStyle=function(e,t){this.cellStyles.has(e.name)&&(t.index=this.mStyles.filter(function(t){return t.name===e.name})[0].index,t.name=e.name)},e.prototype.parserCellStyle=function(e,t,r,o){if(null!==e.name&&void 0!==e.name){if(!t.isGlobalStyle)return void this.applyGlobalStyle(e,t);t.name=e.name}null!==e.backColor&&void 0!==e.backColor&&(t.backColor=e.backColor),t.borders=new m,null!==e.borders&&void 0!==e.borders&&this.parserBorder(e.borders,t.borders.all),null!==e.leftBorder&&void 0!==e.leftBorder&&this.parserBorder(e.leftBorder,t.borders.left),null!==e.rightBorder&&void 0!==e.rightBorder&&this.parserBorder(e.rightBorder,t.borders.right),null!==e.topBorder&&void 0!==e.topBorder&&this.parserBorder(e.topBorder,t.borders.top),null!==e.bottomBorder&&void 0!==e.bottomBorder&&this.parserBorder(e.bottomBorder,t.borders.bottom),null!==e.fontName&&void 0!==e.fontName&&(t.fontName=e.fontName),null!==e.fontSize&&void 0!==e.fontSize&&(t.fontSize=e.fontSize),null!==e.fontColor&&void 0!==e.fontColor&&(t.fontColor=e.fontColor),null!==e.italic&&void 0!==e.italic&&(t.italic=e.italic),null!==e.bold&&void 0!==e.bold&&(t.bold=e.bold),null!==e.hAlign&&void 0!==e.hAlign&&(t.hAlign=e.hAlign.toLowerCase()),null!==e.indent&&void 0!==e.indent&&(t.indent=e.indent,"left"!==t.hAlign&&"right"!==t.hAlign&&(t.hAlign="left")),null!==e.rotation&&void 0!==e.rotation&&(t.rotation=e.rotation),null!==e.vAlign&&void 0!==e.vAlign&&(t.vAlign=e.vAlign.toLowerCase()),null!==e.underline&&void 0!==e.underline&&(t.underline=e.underline),null!==e.strikeThrough&&void 0!==e.strikeThrough&&(t.strikeThrough=e.strikeThrough),null!==e.wrapText&&void 0!==e.wrapText&&(t.wrapText=e.wrapText),null!==e.numberFormat&&void 0!==e.numberFormat?null!==e.type&&void 0!==e.type?t.numberFormat=this.getNumberFormat(e.numberFormat,e.type):t.numberFormat=this.getNumberFormat(e.numberFormat,r):void 0!==o?(t.numFmtId=14,t.numberFormat="GENERAL"):t.numberFormat="GENERAL",t.index=this.processCellStyle(t)},e.prototype.switchNumberFormat=function(e,t){var r=this.getNumberFormat(e,t);if(r!==e){var o=this.mNumFmt.get(e);if(void 0!==o&&(o.formatCode=r,this.mNumFmt.has(r))){for(var i=0,n=this.mCellStyleXfs;i<n.length;i++){var s=n[i];s.numFmtId===o.numFmtId&&(s.numFmtId=this.mNumFmt.get(r).numFmtId)}for(var l=0,a=this.mCellXfs;l<a.length;l++){var d=a[l];d.numFmtId===o.numFmtId&&(d.numFmtId=this.mNumFmt.get(r).numFmtId)}}}},e.prototype.getNumberFormat=function(e,t){var r;switch(t){case"number":try{r=this.intl.getNumberPattern({format:e,currency:this.currency,useGrouping:!0},!0)}catch(t){r=e}break;case"datetime":try{r=this.intl.getDatePattern({skeleton:e,type:"dateTime"},!0)}catch(t){try{r=this.intl.getDatePattern({format:e,type:"dateTime"},!0)}catch(t){r=e}}break;case"date":try{r=this.intl.getDatePattern({skeleton:e,type:"date"},!0)}catch(t){try{r=this.intl.getDatePattern({format:e,type:"date"},!0)}catch(t){r=e}}break;case"time":try{r=this.intl.getDatePattern({skeleton:e,type:"time"},!0)}catch(t){try{r=this.intl.getDatePattern({format:e,type:"time"},!0)}catch(t){r=e}}break;default:r=e}return r},e.prototype.parserBorder=function(e,t){null!==e.color&&void 0!==e.color?t.color=e.color:t.color="#000000",null!==e.lineStyle&&void 0!==e.lineStyle?t.lineStyle=e.lineStyle:t.lineStyle="thin"},e.prototype.processCellStyle=function(e){if(e.isGlobalStyle)return this.processNumFormatId(e),this.mStyles.push(e),this.mStyles.length;var t=this.compareStyle(e);return t.result?t.index:(this.processNumFormatId(e),this.mStyles.push(e),this.mStyles.length)},e.prototype.processNumFormatId=function(e){if("GENERAL"!==e.numberFormat&&!this.mNumFmt.has(e.numberFormat)){var t=this.mNumFmt.size+164;this.mNumFmt.set(e.numberFormat,new d(t,e.numberFormat))}},e.prototype.isNewFont=function(e){for(var t=!1,r=0,o=0,i=this.mFonts;o<i.length;o++){var n=i[o];r++;var s=void 0;if(void 0!==e.fontColor&&(s="FF"+e.fontColor.replace("#","")),t=n.color===s&&n.b===e.bold&&n.i===e.italic&&n.u===e.underline&&n.strike===e.strikeThrough&&n.name===e.fontName&&n.sz===e.fontSize)break}return r-=1,{index:r,result:t}},e.prototype.isNewBorder=function(e){var t=new o;return this.isAllBorder(e.borders)?t.borders.all.color===e.borders.all.color&&t.borders.all.lineStyle===e.borders.all.lineStyle:t.borders.left.color===e.borders.left.color&&t.borders.left.lineStyle===e.borders.left.lineStyle&&t.borders.right.color===e.borders.right.color&&t.borders.right.lineStyle===e.borders.right.lineStyle&&t.borders.top.color===e.borders.top.color&&t.borders.top.lineStyle===e.borders.top.lineStyle&&t.borders.bottom.color===e.borders.bottom.color&&t.borders.bottom.lineStyle===e.borders.bottom.lineStyle},e.prototype.isAllBorder=function(e){var t=new o;return t.borders.all.color!==e.all.color&&t.borders.all.lineStyle!==e.all.lineStyle},e.prototype.compareStyle=function(e){for(var t=!0,r=0,o=0,i=this.mStyles;o<i.length;o++){var n=i[o];if(t=!n.isGlobalStyle&&(n.backColor===e.backColor&&n.bold===e.bold&&n.numFmtId===e.numFmtId&&n.numberFormat===e.numberFormat&&n.type===e.type&&n.fontColor===e.fontColor&&n.fontName===e.fontName&&n.fontSize===e.fontSize&&n.hAlign===e.hAlign&&n.italic===e.italic&&n.underline===e.underline&&n.strikeThrough===e.strikeThrough&&n.vAlign===e.vAlign&&n.indent===e.indent&&n.rotation===e.rotation&&n.wrapText===e.wrapText&&n.borders.all.color===e.borders.all.color&&n.borders.all.lineStyle===e.borders.all.lineStyle&&n.borders.left.color===e.borders.left.color&&n.borders.left.lineStyle===e.borders.left.lineStyle&&n.borders.right.color===e.borders.right.color&&n.borders.right.lineStyle===e.borders.right.lineStyle&&n.borders.top.color===e.borders.top.color&&n.borders.top.lineStyle===e.borders.top.lineStyle&&n.borders.bottom.color===e.borders.bottom.color&&n.borders.bottom.lineStyle===e.borders.bottom.lineStyle)){r=n.index;break}}return{index:r,result:t}},e.prototype.contains=function(e,t){var r=e.indexOf(t);return r>-1&&r<e.length},e.prototype.getCellValueType=function(e){return e instanceof Date?"datetime":"boolean"==typeof e?"boolean":"number"==typeof e?"number":"string"},e.prototype.parseCellType=function(e){var t,r=e.type,o=e.value;switch(r){case"datetime":if(o=this.toOADate(o),void 0!==e.cellStyle&&void 0!==e.cellStyle.name&&this.globalStyles.has(e.cellStyle.name)){var i=this.globalStyles.get(e.cellStyle.name);this.switchNumberFormat(i.format,i.type)}t="n";break;case"boolean":o=o?1:0,t="b";break;case"number":t="n",void 0!==e.cellStyle&&void 0!==e.cellStyle.name&&this.globalStyles.has(e.cellStyle.name)&&this.switchNumberFormat(this.globalStyles.get(e.cellStyle.name).format,"number");break;case"string":this.sharedStringCount++,t="s";var n=this.processCellValue(o,e);this.contains(this.sharedString,n)||this.sharedString.push(n),o=this.sharedString.indexOf(n)}e.saveType=t,e.value=o},e.prototype.parserImages=function(e,t){var r=e.length;t.images=[];for(var o=0;o<r;o++){var i=this.parserImage(e[o]);t.images.push(i)}},e.prototype.parseFilters=function(e,t){if(t.autoFilters=new O,null===e.row||void 0===e.row)throw new Error("Argument Null Exception: row null or empty");if(t.autoFilters.row=e.row,null===e.lastRow||void 0===e.lastRow)throw new Error("Argument Null Exception: lastRow cannot be null or empty");if(t.autoFilters.lastRow=e.lastRow,null===e.column||void 0===e.column)throw new Error("Argument Null Exception: column cannot be null or empty");if(t.autoFilters.column=e.column,null===e.lastColumn||void 0===e.row)throw new Error("Argument Null Exception: lastColumn cannot be null or empty");t.autoFilters.lastColumn=e.lastColumn},e.prototype.parserImage=function(e){var t=new R;return null!==e.image&&void 0!==e.image&&(t.image=e.image),null!==e.row&&void 0!==e.row&&(t.row=e.row),null!==e.column&&void 0!==e.column&&(t.column=e.column),null!==e.lastRow&&void 0!==e.lastRow&&(t.lastRow=e.lastRow),null!==e.lastColumn&&void 0!==e.lastColumn&&(t.lastColumn=e.lastColumn),null!==e.width&&void 0!==e.width&&(t.width=e.width),null!==e.height&&void 0!==e.height&&(t.height=e.height),null!==e.horizontalFlip&&void 0!==e.horizontalFlip&&(t.horizontalFlip=e.horizontalFlip),null!==e.verticalFlip&&void 0!==e.verticalFlip&&(t.verticalFlip=e.verticalFlip),null!==e.rotation&&void 0!==e.rotation&&(t.rotation=e.rotation),t},e.prototype.saveAsBlob=function(e){var t=this;switch(e){case"text/csv":return new Promise(function(e,r){var o={};o.blobData=t.csvHelper.saveAsBlob(),e(o)});default:return new Promise(function(e,r){t.saveInternal(),t.mArchive.saveAsBlob().then(function(t){var r={};r.blobData=new Blob([t],{type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}),e(r)})})}},e.prototype.save=function(e,t){var r=this;if(null===e||void 0===e||""===e)throw new Error("Argument Null Exception: fileName cannot be null or empty");var o=e.match(".xlsx$"),i=e.match(".csv$");if(null!==o&&o[0]==="."+this.mSaveType)this.saveInternal(),this.mArchive.save(e).then(function(){r.mArchive.destroy()});else{if(null===i||i[0]!=="."+this.mSaveType)throw Error("Save type and file extension is different.");this.csvHelper.save(e)}},e.prototype.saveInternal=function(){this.saveWorkbook(),this.saveWorksheets(),this.saveSharedString(),this.saveStyles(),this.saveApp(this.builtInProperties),this.saveCore(this.builtInProperties),this.saveContentType(),this.saveTopLevelRelation(),this.saveWorkbookRelation()},e.prototype.saveWorkbook=function(){for(var e='<?xml version="1.0" encoding="utf-8"?><workbook xmlns:r = "http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns= "http://schemas.openxmlformats.org/spreadsheetml/2006/main"><workbookPr codeName="ThisWorkbook" defaultThemeVersion= "153222"/><bookViews><workbookView activeTab="0"/></bookViews>',t="<sheets>",r=this.worksheets.length,o=0;o<r;o++){var i=this.worksheets[o].name;t+='<sheet name="'+(i=(i=(i=(i=i.replace("&","&amp;")).replace("<","&lt;")).replace(">","&gt;")).replace('"',"&quot;"))+'" sheetId="'+(o+1).toString()+'" r:id ="rId'+(o+1).toString()+'" />'}if(t+="</sheets>",e+=t,this.printTitles.size>0){var n="<definedNames>";this.printTitles.forEach(function(e,t){n+='<definedName name="_xlnm.Print_Titles" localSheetId="'+t+'">'+e+"</definedName>"}),e+=n+="</definedNames>"}this.addToArchive(e+"</workbook>","xl/workbook.xml")},e.prototype.saveWorksheets=function(){for(var e=this.worksheets.length,t=0;t<e;t++)this.saveWorksheet(this.worksheets[t],t)},e.prototype.saveWorksheet=function(e,t){var o=new A,i='<?xml version="1.0" encoding="utf-8" standalone="yes"?><worksheet xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:x14="http://schemas.microsoft.com/office/spreadsheetml/2009/9/main" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">';if(e.isSummaryRowBelow?i+="<sheetPr />":i+='<sheetPr><outlinePr summaryBelow="0" ></outlinePr></sheetPr>',i+=this.saveSheetView(e),void 0!==e.columns){for(var n="<cols>",s=0,l=e.columns;s<l.length;s++){var a=l[s];void 0!==a.width?n+='<col min="'+a.index+'" max="'+a.index+'" width="'+this.pixelsToColumnWidth(a.width)+'" customWidth="1" />':n+='<col min="'+a.index+'" max="'+a.index+'" width="8.43" customWidth="1" />'}i+=n+"</cols>"}if(i+="<sheetData>",o.append(i),i="",void 0!==e.rows)for(var d=0,h=e.rows;d<h.length;d++){var m=h[d],p='<row r="'+m.index+'" ';r.isNullOrUndefined(m.spans)||(p+='spans="'+m.spans+'" '),void 0!==m.height&&(p+='ht="'+this.pixelsToRowHeight(m.height)+'" customHeight="1" '),void 0!==m.grouping&&(m.grouping.isHidden&&(p+='hidden="1" '),void 0!==m.grouping.outlineLevel&&(p+='outlineLevel="'+m.grouping.outlineLevel+'" '),m.grouping.isCollapsed&&(p+='collapsed="1" ')),p+=">";for(var u=0,c=m.cells;u<c.length;u++){var f=c[u];void 0===f||void 0===f.value&&void 0===f.cellStyle||(p+='<c r="'+f.refName+'" ',void 0!==f.saveType&&(p+='t="'+f.saveType+'" '),void 0!==f.styleIndex&&(p+='s="'+f.styleIndex+'" '),p+=" >",void 0!==f.formula&&(p+="<f>"+f.formula+"</f>"),void 0!==f.value?p+="<v>"+f.value+"</v></c>":p+="</c>")}p+="</row>",o.append(p)}if(i+="</sheetData>",null!==e.autoFilters&&void 0!==e.autoFilters&&(i+='<autoFilter ref="'+this.getCellName(e.autoFilters.row,e.autoFilters.column)+":"+this.getCellName(e.autoFilters.lastRow,e.autoFilters.lastColumn)+'"/>'),e.mergeCells.length>0){i+='<mergeCells count="'+e.mergeCells.length+'">';for(var v=0,g=e.mergeCells;v<g.length;v++){i+='<mergeCell ref="'+g[v].ref+'" />'}i+="</mergeCells>"}if(e.hyperLinks.length>0){i+="<hyperlinks>";for(var y=0,x=e.hyperLinks;y<x.length;y++){var w=x[y];i+='<hyperlink ref="'+w.ref+'" r:id="rId'+w.rId+'" />'}i+="</hyperlinks>"}i+='<pageMargins left="0.75" right="0.75" top="1" bottom="1" header="0.5" footer="0.5" /><headerFooter scaleWithDoc="1" alignWithMargins="0" differentFirst="0" differentOddEven="0" />',void 0!=e.images&&e.images.length>0&&(this.drawingCount++,this.saveDrawings(e,e.index),i+='<drawing r:id="rId'+(e.hyperLinks.length+1)+'"/>'),this.addToArchive(this.saveSheetRelations(e),"xl/worksheets/_rels/sheet"+e.index+".xml.rels"),o.append(i+"</worksheet>"),this.addToArchive(o.getBlob(),"xl/worksheets/sheet"+(t+1)+".xml")},e.prototype.saveDrawings=function(e,t){var r=new A,o='<xdr:wsDr xmlns:xdr="http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing" xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main">';if(void 0!==e.images){for(var i=0,n=0,s=e.images;n<s.length;n++){var l=s[n];void 0!==l.height&&void 0!==l.width?(this.updatelastRowOffset(e,l),this.updatelastColumnOffSet(e,l)):void 0!==l.lastRow&&void 0!==l.lastColumn&&(l.lastRowOffset=0,l.lastColOffset=0),i++,o+='<xdr:twoCellAnchor editAs="oneCell">',o+="<xdr:from><xdr:col>",o+=l.column-1,o+="</xdr:col><xdr:colOff>",o+=0,o+="</xdr:colOff><xdr:row>",o+=l.row-1,o+="</xdr:row><xdr:rowOff>",o+=0,o+="</xdr:rowOff></xdr:from>",o+="<xdr:to><xdr:col>",o+=l.lastColumn,o+="</xdr:col><xdr:colOff>",o+=l.lastColOffset,o+="</xdr:colOff><xdr:row>",o+=l.lastRow,o+="</xdr:row><xdr:rowOff>",o+=l.lastRowOffset,o+="</xdr:rowOff></xdr:to>",o+="<xdr:pic>",o+="<xdr:nvPicPr>",o+='<xdr:cNvPr id="'+i+'" name="Picture '+i+'"> </xdr:cNvPr>',o+='<xdr:cNvPicPr><a:picLocks noChangeAspect="1"/></xdr:cNvPicPr> </xdr:nvPicPr>',o+="<xdr:blipFill>",o+='<a:blip xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" r:embed="rId'+i+'" cstate="print">',o+="</a:blip><a:stretch><a:fillRect /></a:stretch></xdr:blipFill>",o+="<xdr:spPr>",o+="<a:xfrm",void 0!=l.rotation&&l.rotation<=3600&&l.rotation>=-3600&&(o+=' rot="'+6e4*l.rotation+'"'),void 0!=l.verticalFlip&&0!=l.verticalFlip&&(o+=' flipV="1"'),void 0!=l.horizontalFlip&&0!=l.horizontalFlip&&(o+=' flipH="1"'),o+="/>",o+='<a:prstGeom prst="rect"><a:avLst /></a:prstGeom></xdr:spPr>',o+="</xdr:pic><xdr:clientData /></xdr:twoCellAnchor>";var a=this.convertBase64toImage(l.image);this.imageCount+=1,this.addToArchive(a,"xl/media/image"+this.imageCount+".png")}r.append(o),r.append("</xdr:wsDr>"),this.saveDrawingRelations(e),this.addToArchive(r.getBlob(),"xl/drawings/drawing"+this.drawingCount+".xml")}},e.prototype.updatelastRowOffset=function(e,t){for(var r=t.height,o=t.row,i=0;r>=0;){var n=0,s=(n=void 0!==e.rows&&void 0!==e.rows[o-1]?this.convertToPixels(void 0===e.rows[o-1].height?15:e.rows[o-1].height):this.convertToPixels(15))-i*n/256;if(s>r){t.lastRow=o,t.lastRowOffset=i+256*r/n;var l=0;l=void 0!==e.rows&&void 0!==e.rows[o-1]?this.convertToPixels(void 0===e.rows[o-1].height?15:e.rows[o-1].height):this.convertToPixels(15),t.lastRowOffset=l*t.lastRowOffset/256,t.lastRowOffset=Math.round(t.lastRowOffset/this.unitsProportions[7]);break}r-=s,o++,i=0}},e.prototype.updatelastColumnOffSet=function(e,t){for(var r=t.width,o=t.column,i=0;r>=0;){var n=0,s=(n=void 0!==e.columns&&void 0!==e.columns[o-1]?this.ColumnWidthToPixels(void 0===e.columns[o-1].width?8.43:e.columns[o-1].width):this.ColumnWidthToPixels(8.43))-i*n/1024;if(s>r){t.lastColumn=o,t.lastColOffset=i+1024*r/n;var l=0;l=void 0!==e.columns&&void 0!==e.columns[o-1]?this.ColumnWidthToPixels(void 0===e.columns[o-1].width?8.43:e.columns[o].width):this.ColumnWidthToPixels(8.43),t.lastColOffset=l*t.lastColOffset/1024,t.lastColOffset=Math.round(t.lastColOffset/this.unitsProportions[7]);break}r-=s,o++,i=0}},e.prototype.convertToPixels=function(e){return e*this.unitsProportions[6]},e.prototype.convertBase64toImage=function(e){for(var t=window.atob(e),r=new ArrayBuffer(t.length),o=new Uint8Array(r),i=0;i<t.length;i++)o[i]=t.charCodeAt(i);return new Blob([o],{type:"image/png"})},e.prototype.saveDrawingRelations=function(e){for(var t='<?xml version="1.0" encoding="utf-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">',r=e.images.length,o=this.imageCount-e.images.length,i=1;i<=r;i++)t+='<Relationship Id="rId'+i+'" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/image" Target="../media/image'+ ++o+'.png" />';this.addToArchive(t+"</Relationships>","xl/drawings/_rels/drawing"+this.drawingCount+".xml.rels")},e.prototype.pixelsToColumnWidth=function(e){var t=e>12?this.trunc((e-5)/7*100+.5)/100:e/12;return t>1?(7*t+5)/7*256/256:12*t/7*256/256},e.prototype.ColumnWidthToPixels=function(e){var t=e>1?(7*e+5)/7*256/256:12*e/7*256/256;return this.trunc((256*t+this.trunc(128/7))/256*7)},e.prototype.trunc=function(e){var t=e-e%1;return 0===t&&(e<0||0===e&&1/e!=1/0)?-0:t},e.prototype.pixelsToRowHeight=function(e){return e*this.unitsProportions[5]/this.unitsProportions[6]},e.prototype.saveSheetRelations=function(e){for(var t='<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">',r=0,o=e.hyperLinks;r<o.length;r++){var i=o[r];t+='<Relationship Id="rId'+i.rId+'" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink" Target="'+this.processString(i.target)+'" TargetMode="External" />'}return void 0!=e.images&&e.images.length>0&&(t+='<Relationship Id="rId'+(e.hyperLinks.length+1)+'" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing" Target="../drawings/drawing'+this.drawingCount+'.xml" />'),t+="</Relationships>"},e.prototype.saveSheetView=function(e){var t='<sheetViews><sheetView workbookViewId="0" ';return!0===e.enableRtl&&(t+='rightToLeft="1"'),!1===e.showGridLines?t+='showGridLines="0" >':t+=">",void 0!==e.freezePanes&&(t+='<pane state="frozen" topLeftCell="'+e.freezePanes.leftCell+'" ',0!==e.freezePanes.row&&(t+='ySplit="'+e.freezePanes.row+'" '),0!==e.freezePanes.column&&(t+='xSplit="'+e.freezePanes.column+'" '),t+="/>"),t+="</sheetView></sheetViews > "},e.prototype.saveSharedString=function(){var e=this.sharedString.length;if(e>0){for(var t='<?xml version="1.0" encoding="utf-8"?><sst uniqueCount="'+e+'" count="'+this.sharedStringCount+'" xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">',r="",o=0;o<e;o++)0!==this.sharedString[o].indexOf("<r>")?(r+="<si><t>",r+=this.processString(this.sharedString[o]),r+="</t></si>"):(r+="<si>",r+=this.sharedString[o],r+="</si>");r+="</sst>",this.addToArchive(t+r,"xl/sharedStrings.xml")}},e.prototype.processString=function(e){return-1!==e.indexOf("&")&&(e=e.replace(/&/g,"&amp;")),-1!==e.indexOf("<")&&(e=e.replace(/</g,"&lt;")),-1!==e.indexOf(">")&&(e=e.replace(/>/g,"&gt;")),e},e.prototype.saveStyles=function(){this.updateCellXfsStyleXfs();var e='<?xml version="1.0" encoding="utf-8"?><styleSheet xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" mc:Ignorable="x14ac" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac" xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">';e+=this.saveNumberFormats(),e+=this.saveFonts(),e+=this.saveFills(),e+=this.saveBorders(),e+=this.saveCellStyleXfs(),e+=this.saveCellXfs(),e+=this.saveCellStyles(),this.addToArchive(e+"</styleSheet>","xl/styles.xml")},e.prototype.updateCellXfsStyleXfs=function(){for(var e=0,t=this.mStyles;e<t.length;e++){var r=t[e],o=void 0;r.isGlobalStyle?(o=new l).xfId=r.index-1:(o=new n).xfId=0;var a=this.isNewFont(r);if(a.result)o.fontId=a.index;else{var h=new i;h.b=r.bold,h.i=r.italic,h.name=r.fontName,h.sz=r.fontSize,h.u=r.underline,h.strike=r.strikeThrough,h.color="FF"+r.fontColor.replace("#",""),this.mFonts.push(h),o.fontId=this.mFonts.length-1}if("none"!==r.backColor){var m="FF"+r.backColor.replace("#","");if(this.mFills.has(m)){var p=this.mFills.get(m);o.fillId=p}else{p=this.mFills.size+2;this.mFills.set(m,p),o.fillId=p}}else o.fillId=0;if(this.isNewBorder(r)?o.borderId=0:(this.mBorders.push(r.borders),o.borderId=this.mBorders.length),"GENERAL"!==r.numberFormat)if(this.mNumFmt.has(r.numberFormat)){var u=this.mNumFmt.get(r.numberFormat);o.numFmtId=u.numFmtId}else{var c=this.mNumFmt.size+164;this.mNumFmt.set(r.numberFormat,new d(c,r.numberFormat)),o.numFmtId=c}else"GENERAL"===r.numberFormat&&14===r.numFmtId?o.numFmtId=14:o.numFmtId=0;r.isGlobalStyle||(o.applyAlignment=1),o.alignment=new s,o.alignment.indent=r.indent,o.alignment.horizontal=r.hAlign,o.alignment.vertical=r.vAlign,o.alignment.wrapText=r.wrapText?1:0,o.alignment.rotation=r.rotation,r.isGlobalStyle?(this.mCellStyleXfs.push(o),this.mCellXfs.push(o)):this.mCellXfs.push(o)}},e.prototype.saveNumberFormats=function(){if(this.mNumFmt.size>=1){var e='<numFmts count="'+this.mNumFmt.size+'">';return this.mNumFmt.forEach(function(t,r){e+='<numFmt numFmtId="'+t.numFmtId+'" formatCode="'+t.formatCode.replace(/"/g,"&quot;")+'" />'}),e+="</numFmts>"}return""},e.prototype.saveFonts=function(){var e='<fonts count="'+this.mFonts.length+'">';if(this.mFonts.length>=1)for(var t=0,r=this.mFonts;t<r.length;t++){var o=r[t];e+="<font>",o.b&&(e+="<b />"),o.i&&(e+="<i />"),o.u&&(e+="<u />"),o.strike&&(e+="<strike />"),e+='<sz val="'+o.sz+'" />',e+='<color rgb="'+o.color+'" />',e+='<name val="'+o.name+'" /></font>'}return e+"</fonts>"},e.prototype.saveFills=function(){var e='<fills count="'+(this.mFills.size+2)+'"><fill><patternFill patternType="none"></patternFill></fill><fill><patternFill patternType="gray125"></patternFill></fill>';return this.mFills.size>=1&&this.mFills.forEach(function(t,r){e+='<fill><patternFill patternType="solid"><fgColor rgb="'+r+'" /><bgColor rgb="FFFFFFFF" /></patternFill></fill>'}),e+"</fills>"},e.prototype.saveBorders=function(){var e='<borders count="'+(this.mBorders.length+1)+'"><border><left /><right /><top /><bottom /><diagonal /></border>';if(this.mBorders.length>=1)for(var t=0,r=this.mBorders;t<r.length;t++){var o=r[t];if(this.isAllBorder(o)){var i=o.all.color.replace("#",""),n=o.all.lineStyle;e+='<border><left style="'+n+'"><color rgb="FF'+i+'" /></left><right style="'+n+'"><color rgb="FF'+i+'" /></right><top style="'+n+'"><color rgb="FF'+i+'" /></top><bottom style="'+n+'"><color rgb="FF'+i+'" /></bottom></border>'}else e+='<border><left style="'+o.left.lineStyle+'"><color rgb="FF'+o.left.color.replace("#","")+'" /></left><right style="'+o.right.lineStyle+'"><color rgb="FF'+o.right.color.replace("#","")+'" /></right><top style="'+o.top.lineStyle+'"><color rgb="FF'+o.top.color.replace("#","")+'" /></top><bottom style="'+o.bottom.lineStyle+'"><color rgb="FF'+o.bottom.color.replace("#","")+'" /></bottom></border>'}return e+"</borders>"},e.prototype.saveCellStyles=function(){var e=this,t='<cellStyles  count="'+this.cellStyles.size+'">';return this.cellStyles.forEach(function(r,o){t+='<cellStyle name="'+o+'" xfId="'+e.cellStyles.get(o).xfId+'"',"Normal"===o&&(t+=' builtinId="0"'),t+=" />"}),t+="</cellStyles>"},e.prototype.saveCellStyleXfs=function(){var e='<cellStyleXfs count="'+(this.mCellStyleXfs.length+1)+'"><xf numFmtId="0" fontId="0" fillId="0" borderId="0" />';if(this.mCellStyleXfs.length>=1)for(var t=0,r=this.mCellStyleXfs;t<r.length;t++){var o=r[t];e+='<xf numFmtId="'+o.numFmtId+'" fontId="'+o.fontId+'" fillId="'+o.fillId+'" borderId="'+o.borderId+'" ',void 0!==o.alignment?e+=">"+this.saveAlignment(o)+"</xf>":e+=" />"}return e+"</cellStyleXfs>"},e.prototype.saveCellXfs=function(){var e='<cellXfs count="'+(this.mCellXfs.length+1)+'"><xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0" />';if(this.mCellXfs.length>=1)for(var t=0,r=this.mCellXfs;t<r.length;t++){var o=r[t];e+='<xf numFmtId="'+o.numFmtId+'" fontId="'+o.fontId+'" fillId="'+o.fillId+'" borderId="'+o.borderId+'" xfId="'+o.xfId+'" ',1===o.applyAlignment&&(e+='applyAlignment="1"'),e+=">"+this.saveAlignment(o)+"</xf>"}return e+"</cellXfs>"},e.prototype.saveAlignment=function(e){var t="<alignment ";return void 0!==e.alignment.horizontal&&(t+='horizontal="'+e.alignment.horizontal+'" '),void 0!==e.alignment.indent&&0!==e.alignment.indent?t+='indent="'+e.alignment.indent+'" ':void 0!==e.alignment.rotation&&0!==e.alignment.rotation&&(t+='textRotation="'+e.alignment.rotation+'" '),void 0!==e.alignment.vertical&&(t+='vertical="'+e.alignment.vertical+'" '),t+='wrapText="'+e.alignment.wrapText+'" />'},e.prototype.saveApp=function(e){var t='<?xml version="1.0" encoding="utf-8" standalone="yes"?><Properties xmlns="http://schemas.openxmlformats.org/officeDocument/2006/extended-properties"><Application>Essential XlsIO</Application>';void 0!==e&&(void 0!==e.manager&&(t+="<Manager>"+e.manager+"</Manager>"),void 0!==e.company&&(t+="<Company>"+e.company+"</Company>")),this.addToArchive(t+"</Properties>","docProps/app.xml")},e.prototype.saveCore=function(e){var t=new Date,r='<?xml version="1.0" encoding="utf-8" standalone="yes"?><cp:coreProperties xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:dcterms="http://purl.org/dc/terms/" xmlns:dcmitype="http://purl.org/dc/dcmitype/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:cp="http://schemas.openxmlformats.org/package/2006/metadata/core-properties">';void 0!==this.builtInProperties?(void 0!==e.author&&(r+="<dc:creator>"+e.author+"</dc:creator>"),void 0!==e.subject&&(r+="<dc:subject>"+e.subject+"</dc:subject>"),void 0!==e.category&&(r+="<cp:category>"+e.category+"</cp:category>"),void 0!==e.comments&&(r+="<dc:description>"+e.comments+"</dc:description>"),void 0!==e.title&&(r+="<dc:title>"+e.title+"</dc:title>"),void 0!==e.tags&&(r+="<cp:keywords>"+e.tags+"</cp:keywords>"),void 0!==e.status&&(r+="<cp:contentStatus>"+e.status+"</cp:contentStatus>"),void 0!==e.createdDate?r+='<dcterms:created xsi:type="dcterms:W3CDTF">'+e.createdDate.toISOString()+"</dcterms:created>":r+='<dcterms:created xsi:type="dcterms:W3CDTF">'+t.toISOString()+"</dcterms:created>",void 0!==e.modifiedDate?r+='<dcterms:modified xsi:type="dcterms:W3CDTF">'+e.modifiedDate.toISOString()+"</dcterms:modified>":r+='<dcterms:modified xsi:type="dcterms:W3CDTF">'+t.toISOString()+"</dcterms:modified>"):(r+='<dcterms:created xsi:type="dcterms:W3CDTF">'+t.toISOString()+"</dcterms:created>",r+='<dcterms:modified xsi:type="dcterms:W3CDTF">'+t.toISOString()+"</dcterms:modified>"),r+="</cp:coreProperties>",this.addToArchive(r,"docProps/core.xml")},e.prototype.saveTopLevelRelation=function(){this.addToArchive('<?xml version="1.0" encoding="utf-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml" /><Relationship Id="rId2" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties" Target="docProps/app.xml" /><Relationship Id="rId3" Type="http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties" Target="docProps/core.xml" /></Relationships>',"_rels/.rels")},e.prototype.saveWorkbookRelation=function(){for(var e='<?xml version="1.0" encoding="utf-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">',t=this.worksheets.length,r=0,o=0;o<t;o++,r++)e+='<Relationship Id="rId'+(o+1).toString()+'" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet'+(o+1).toString()+'.xml" />';e+='<Relationship Id="rId'+(++r).toString()+'" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml" />',this.sharedStringCount>0&&(e+='<Relationship Id="rId'+(++r).toString()+'" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings" Target="sharedStrings.xml" />'),this.addToArchive(e+"</Relationships>","xl/_rels/workbook.xml.rels")},e.prototype.saveContentType=function(){for(var e='<?xml version="1.0" encoding="utf-8" standalone="yes"?><Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types"><Default Extension="xml" ContentType="application/xml" /><Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml" /><Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml" /><Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml" /><Override PartName="/docProps/app.xml" ContentType="application/vnd.openxmlformats-officedocument.extended-properties+xml" /><Override PartName="/docProps/core.xml" ContentType="application/vnd.openxmlformats-package.core-properties+xml" />',t="",r=this.worksheets.length,o=0;o<r;o++)t+='<Override PartName="/xl/worksheets/sheet'+(o+1).toString()+'.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml" />',void 0!=this.worksheets[o].images&&this.worksheets[o].images.length>0&&(t+='<Override PartName="/xl/drawings/drawing'+(o+1).toString()+'.xml" ContentType="application/vnd.openxmlformats-officedocument.drawing+xml" />');this.imageCount>0&&(t+='<Default Extension="png" ContentType="image/png" />'),this.sharedStringCount>0&&(e+='<Override PartName="/xl/sharedStrings.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml" />'),this.addToArchive(e+t+"</Types>","[Content_Types].xml")},e.prototype.addToArchive=function(e,r){if("string"==typeof e){var o=new Blob([e],{type:"text/plain"}),i=new t.ZipArchiveItem(o,r);this.mArchive.addItem(i)}else{i=new t.ZipArchiveItem(e,r);this.mArchive.addItem(i)}},e.prototype.processMergeCells=function(e,t,r){if(0!==e.rowSpan||0!==e.colSpan){var o=new I;o.x=e.index,o.width=e.colSpan,o.y=t,o.height=e.rowSpan;var i=this.getCellName(o.y,o.x),n=this.getCellName(t+o.height,e.index+o.width);o.ref=i+":"+n;r.add(o);var s={x:o.x,y:o.y},l={x:e.index+o.width,y:t+o.height};this.updatedMergedCellStyles(s,l,e)}return r},e.prototype.updatedMergedCellStyles=function(e,t,r){for(var o=e.x;o<=t.x;o++)for(var i=e.y;i<=t.y;i++)this.mergedCellsStyle.set(this.getCellName(i,o),{x:o,y:i,styleIndex:r.styleIndex})},e.prototype.dateToTicks=function(e,t,r){if(e>=1&&e<=9999&&t>=1&&t<=12){var o=e-1;return 864e9*(365*o+(o/4|0)-(o/100|0)+(o/400|0)+(this.isLeapYear(e)?[0,31,60,91,121,152,182,213,244,274,305,335,366]:[0,31,59,90,120,151,181,212,243,273,304,334,365])[t-1]+r-1)}throw new Error("Not a valid date")},e.prototype.timeToTicks=function(e,t,r){if(e>=0&&e<24&&t>=0&&t<60&&r>=0&&r<60){return 1e4*(3600*e+60*t+r)*1e3}throw new Error("Not valid time")},e.prototype.isLeapYear=function(e){return e%4==0&&(e%100!=0||e%400==0)},e.prototype.toOADate=function(e){var t=0;if(0===(t=this.dateToTicks(e.getFullYear(),e.getMonth()+1,e.getDate())+this.timeToTicks(e.getHours(),e.getMinutes(),e.getSeconds())))return 0;if(t<31241376e9)throw new Error("Arg_OleAutDateInvalid");return(t-599264352e9)/1e4/864e5},e}(),D=function(){return function(){}}();e.CellStyle=o,e.Font=i,e.CellXfs=n,e.Alignment=s,e.CellStyleXfs=l,e.CellStyles=a,e.NumFmt=d,e.Border=h,e.Borders=m,e.Cell=u,e.Cells=c,e.Column=f,e.Row=g,e.Rows=y,e.Workbook=B,e.BuiltInProperties=D,e.Worksheet=F,e.HyperLink=S,e.Grouping=C,e.FreezePane=k,e.MergeCell=I,e.MergeCells=T,e.Worksheets=w,e.CsvHelper=N,e.ValueFormatter=P,e.BlobHelper=A,Object.defineProperty(e,"__esModule",{value:!0})});
	//# sourceMappingURL=ej2-excel-export.umd.min.js.map


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	*  filename: ej2-filemanager.umd.min.js
	*  version : 19.4.56
	*  Copyright Syncfusion Inc. 2001 - 2020. All rights reserved.
	*  Use of this code is subject to the terms of our license.
	*  A copy of the current license can be obtained at any time by e-mailing
	*  licensing@syncfusion.com. Any infringement will be prosecuted under
	*  applicable laws. 
	*/
	!function(e,t){ true?t(exports,__webpack_require__(23),__webpack_require__(533),__webpack_require__(46),__webpack_require__(76),__webpack_require__(59),__webpack_require__(42),__webpack_require__(101),__webpack_require__(136),__webpack_require__(102),__webpack_require__(532)):"function"==typeof define&&define.amd?define(["exports","@syncfusion/ej2-base","@syncfusion/ej2-layouts","@syncfusion/ej2-popups","@syncfusion/ej2-data","@syncfusion/ej2-inputs","@syncfusion/ej2-buttons","@syncfusion/ej2-lists","@syncfusion/ej2-splitbuttons","@syncfusion/ej2-navigations","@syncfusion/ej2-grids"],t):t(e.ej={},e.ej2Base,e.ej2Layouts,e.ej2Popups,e.ej2Data,e.ej2Inputs,e.ej2Buttons,e.ej2Lists,e.ej2Splitbuttons,e.ej2Navigations,e.ej2Grids)}(this,function(e,t,i,n,s,a,r,o,l,h,d){"use strict";function p(e,i,n){var s=t.getValue("name",i),a=e.getAttribute("data-id"),r=t.isNullOrUndefined(a)?s:a;n.setProperties({path:c(e,r,n.hasId)},!0),n.pathId=function(e){for(var t=u(e,e.getAttribute("data-uid"),!0),i=[],n=t.length-1;n>=0;n--)i.push(t[n]);return i}(e),n.pathNames=function(e,t){for(var i=u(e,t,!1),n=[],s=i.length-1;s>=0;s--)n.push(i[s]);return n}(e,s)}function c(e,t,i){for(var n=u(e,t,!1,i),s=i?"":"/",a=n.length-(i?1:2);a>=0;a--)s+=n[a]+"/";return s}function u(e,i,n,s){for(var a=[i],r=e.parentNode;!t.isNullOrUndefined(r);){if(t.matches(r,"."+Zt)){var o=n?r.getAttribute("data-uid"):s?r.getAttribute("data-id"):t.select("."+ei,r).textContent;a.push(o)}if((r=r.parentNode).classList.contains(Ci))break}return a}function f(e){e.isCut&&(b(e),e.selectedNodes=[],e.actionRecords=[],e.enablePaste=!1,e.notify(Fn,{}))}function g(e,i){if(i.isSearchCut=!1,i.actionRecords=[],i.activeElements=[],i.notify(Vn,{}),0===i.activeElements.length)return!1;b(i);var n=i.activeElements;"navigationpane"!==i.activeModule?i.targetPath=i.path:i.targetPath=H(i.path);var s=0;if(n&&(y(i,n[0]),"cut"===e))for(;s<n.length;)m(n[s]),s++;for(s=0,i.selectedNodes=[],i.enablePaste=!0,i.notify(An,{});s<i.activeRecords.length;)i.actionRecords.push(i.activeRecords[s]),i.selectedNodes.push(t.getValue("name",i.activeRecords[s])),s++;if((""!==i.breadcrumbbarModule.searchObj.element.value||i.isFiltered)&&"navigationpane"!==i.activeModule){i.selectedNodes=[],i.isSearchCut=!0;for(var a=0;a<i.selectedItems.length;)i.selectedNodes.push(i.selectedItems[a]),a++}return!0}function m(e){e.classList.add(si)}function b(e,t){for(var i=t?e.element.querySelectorAll("."+ri):e.element.querySelectorAll("."+si),n=0;n<i.length;)i[n].classList.remove(t?ri:si),n++}function y(e,i){i&&(i.classList.contains(pi)?e.activeModule="detailsview":t.closest(i,"."+wi)?e.activeModule="largeiconsview":e.activeModule="navigationpane")}function v(e,t,i){var n;if(0!==t.length||e.isFiltered||e.notify(Kn,{args:e}),n="startsWith"===e.searchSettings.filterType?t+"*":"endsWith"===e.searchSettings.filterType?"*"+t:"*"+t+"*",e.searchWord=n,e.itemData=[S(e)],t.length>0){var s=e.searchSettings.ignoreCase,a=e.showHiddenItems;Re(e,i?Nn:In,e.path,n,a,!s)}else e.isFiltered?me(e,Nn):e.isSortByClicked?(e.notify(Nn,{files:e.largeiconsviewModule.items}),e.isSortByClicked=!1):fe(e,i?Nn:In,e.path)}function O(e,t){e.setProperties({view:t},!0),(""!==e.breadcrumbbarModule.searchObj.element.value||e.isFiltered)&&(e.layoutSelectedItems=e.selectedItems);var i="";e.breadcrumbbarModule.searchObj.element.value&&(i=e.breadcrumbbarModule.searchObj.element.value),e.isLayoutChange=!0,v(e,i,!0)}function I(e,i){var n="";i&&(n=t.closest(i,"."+Ht+"."+zt+" ."+Pi)?"detailsview":t.closest(i,"."+Xt)?"largeiconsview":i.classList.contains("e-fullrow")||i.classList.contains("e-icon-expandable")?"navigationpane":t.closest(i,".e-address-list-item")?"breadcrumbbar":""),e.targetModule=n}function w(e){e.itemData=[S(e)],oe(e.itemData[0])?fe(e,pn,e.path):ae(e,e.itemData[0],ts)}function D(e){fe(e,Dn,e.path)}function S(e){return t.getValue(e.pathId[e.pathId.length-1],e.feParent)}function C(e){g("copy",e)&&(e.fileAction="copy")}function j(e){g("cut",e)&&(e.isCut=!0,e.fileAction="move")}function x(e){if(!t.getValue("isFile",e))return yi;var i=t.getValue("type",e);-1!==(i=i.toLowerCase()).indexOf(".")&&(i=i.split(".").join(""));return-1!==["bmp","dib","jpg","jpeg","jpe","jfif","gif","tif","tiff","png","ico"].indexOf(i)?vi:-1!==["mp3","wav","aac","ogg","wma","aif","fla","m4a"].indexOf(i)?Oi:-1!==["webm","mkv","flv","vob","ogv","ogg","avi","wmv","mp4","3gp"].indexOf(i)?Ii:-1!==["css","exe","html","js","msi","pdf","pptx","ppt","rar","zip","txt","docx","doc","xlsx","xls","xml","rtf","php"].indexOf(i)?"e-fe-"+i:"e-fe-unknown e-fe-"+i}function N(e,i){var n,s=e.ajaxSettings.getImageUrl?e.ajaxSettings.getImageUrl:e.ajaxSettings.url,a=encodeURIComponent(t.getValue("name",i)),r=t.getValue("filterPath",i);if(e.hasId){var o=t.getValue("id",i);n=s+"?path="+e.path+"&id="+o}else n=t.isNullOrUndefined(r)?s+"?path="+e.path+a:s+"?path="+r.replace(/\\/g,"/")+a;var l={fileDetails:[i],imageUrl:n=n+"&time="+(new Date).getTime().toString()};return e.trigger("beforeImageLoad",l),l.imageUrl}function P(e,i,n){var s=t.getValue(e.hasId?"id":"name",i)+"/",a=t.getValue(e.hasId?"filterId":"filterPath",i);return t.isNullOrUndefined(a)?n+s:a.replace(/\\/g,"/")+s}function E(e,i){var n=t.getValue("name",i),s=t.getValue("filterPath",i);return""===e.breadcrumbbarModule.searchObj.element.value&&!e.isFiltered||t.isNullOrUndefined(s)||(n=(s=s.replace(/\\/g,"/")).replace(e.path,"")+n),n}function R(e,i){if(0===i.length)return i;var n;n="None"!==e.sortOrder?(new s.Query).sortBy(e.sortBy,e.sortOrder.toLowerCase(),!0).group("isFile"):(new s.Query).group("isFile");var a=new s.DataManager(i).executeLocal(n);return t.getValue("records",a)}function M(e,i,n){var a=t.getValue(e.pathId[e.pathId.length-1],e.feFiles),r=(new s.Query).where(i,"equal",n);return new s.DataManager(a).executeLocal(r)[0]}function k(e,i,n){var s,a=t.select("#"+e.element.id+Et,e.element),r=t.select("#"+e.element.id+_t,a).offsetHeight;if(s=a.offsetHeight-r,"Details"===e.view&&(s-=t.select("."+Si,a).offsetHeight),t.isNullOrUndefined(i.querySelector("."+ci))){var o=t.createElement("div",{className:ci}),l=t.createElement("div",{className:Di}),h=t.createElement("div",{className:ui}),d=t.createElement("div",{className:fi});"Details"===e.view?i.querySelector("."+Ni).appendChild(o):i.appendChild(o),o.appendChild(l),o.appendChild(h),o.appendChild(d)}i.querySelector("."+ci)&&(t.isNullOrUndefined(n.error)?e.isFiltered?(i.querySelector("."+ui).innerHTML=T(e,"Filter-Empty"),i.querySelector("."+fi).innerHTML=T(e,"Filter-Key")):""!==e.breadcrumbbarModule.searchObj.element.value?(i.querySelector("."+ui).innerHTML=T(e,"Search-Empty"),i.querySelector("."+fi).innerHTML=T(e,"Search-Key")):(i.querySelector("."+ui).innerHTML=T(e,"Folder-Empty"),i.querySelector("."+fi).innerHTML=T(e,"File-Upload")):(i.querySelector("."+ui).innerHTML=T(e,"Access-Denied"),i.querySelector("."+fi).innerHTML=T(e,"Access-Details")));var p=t.select("."+ci,i);s=(s-p.offsetHeight)/2,p.style.marginTop=s+"px"}function L(e){return new s.DataManager(e).executeLocal((new s.Query).where(tn,"equal",!1,!1))}function T(e,t){var i=e.localeObj.getConstant(t);return""===i?t:i}function A(e,i){var n=e.cssClass;return n=t.isNullOrUndefined(n)||""===n?i:n+" "+i}function F(e,t){e.isSortByClicked=!0,-1!==t.item.id.indexOf("ascending")||-1!==t.item.id.indexOf("descending")||-1!==t.item.id.indexOf("none")?e.sortOrder=U(t.item.id):e.sortBy=U(t.item.id),e.itemData=[S(e)],"Details"===e.view&&(e.isMobile?O(e,"Details"):e.notify(Wn,{module:"detailsview"})),"LargeIcons"===e.view&&O(e,"LargeIcons"),e.notify(Pn,{})}function U(e){var t=e.substring(e.lastIndexOf("_")+1),i=t;switch(t){case"date":i="_fm_modified";break;case"ascending":i="Ascending";break;case"descending":i="Descending";break;case"none":i="None"}return i}function V(e,t){e.notify(xn,{selectedNode:e.pathId[e.pathId.length-1]}),e.originalPath=P(e,t,e.path),fe(e,e.path!==e.originalPath?sn:an,e.path)}function _(e){if(e.isDragDrop=!1,0!==e.selectedNodes.length&&e.enablePaste){var t=""===e.folderPath?e.path:e.folderPath;B(e,e.actionRecords,t,e.path)||("move"===e.fileAction&&e.targetPath!==t||"copy"===e.fileAction?(e.notify(_n,{}),ye(e,e.targetPath,e.selectedNodes,t,e.fileAction,[],e.actionRecords)):(e.enablePaste=!1,e.notify(Fn,{}),b(e)))}}function B(e,i,n,s){for(var a=!1,r=0;r<i.length;r++)if(t.getValue("isFile",i[r])){var o=e.dragNodes[r],l=0;o&&(l=o.lastIndexOf("/"));var h="";if(l>0&&(h=s+o.substring(0,l+1)),h===n){Le(e,"Error",{files:null,error:{code:"402",message:T(e,"Same-Folder-Error"),fileExists:null}}),a=!0;break}}else{var d=P(e,i[r],s);if(0===n.indexOf(d)){Le(e,"Error",{files:null,error:{code:"402",message:T(e,"Sub-Folder-Error"),fileExists:null}}),a=!0;break}}return a}function H(e){for(var t=e.split("/"),i=t[0]+"/",n=1;n<t.length-2;n++)i+=t[n]+"/";return i}function z(e,i){var n=t.getValue(e.hasId?"id":"name",i.cwd)+"/",s=t.getValue(e.hasId?"filterId":"filterPath",i.cwd);return t.isNullOrUndefined(s)?e.path+n:""===s?e.hasId?n:"/":s.replace(/\\/g,"/")+n}function q(e,t,i){"move"===t&&(e.isDragDrop?e.notify(Jn,i):(e.enablePaste=!1,e.notify(Fn,{}),e.notify(Hn,i))),0===e.duplicateItems.length&&(e.pasteNodes=[]);for(var n=0;n<i.files.length;n++)e.pasteNodes.push(i.files[n][e.hasId?"id":"name"]),e.isDragDrop&&e.droppedObjects.push(i.files[n]);e.duplicateItems=[],e.duplicateRecords=[],e.isDragDrop&&!e.isPasteError?e.isDropEnd=!0:e.isDropEnd=!1,!e.isDragDrop||e.path===e.dragPath||e.path===e.dropPath||e.isSearchDrag?(e.isPathDrag=!1,fe(e,Bn,e.path)):W(e),e.trigger("success",{action:t,result:i})}function W(e){var i=t.getValue("_fm_id",e.dropData);if(e.expandedId=i,e.itemData=[e.dropData],e.isPathDrag)e.notify(ln,e.itemData);else{if(e.navigationpaneModule){p(t.select('[data-uid="'+i+'"]',e.navigationpaneModule.treeObj.element),e.dropData,e)}fe(e,Xn,e.dropPath)}}function K(e){if(e.isSearchDrag=!1,""!==e.breadcrumbbarModule.searchObj.element.value&&(e.isSearchDrag=!0),"navigationpane"!==e.activeModule){e.dragNodes=[];for(var t=0;t<e.selectedItems.length;)e.dragNodes.push(e.selectedItems[t]),t++;0===e.selectedItems.length&&e.dragData&&1===e.dragData.length&&e.dragNodes.push(Z(e,e.dragData[0]))}var i=e.createElement("div",{className:"e-fe-icon "+x(e.dragData[0])}),n=e.createElement("div",{className:"e-fe-name",innerHTML:e.dragData[0].name}),s=e.createElement("div",{className:"e-fe-content"});s.appendChild(i),s.appendChild(n);var a=e.createElement("div",{className:gi});if(a.appendChild(s),e.dragNodes.length>1){var r=e.createElement("span",{className:"e-fe-count",innerHTML:e.dragNodes.length.toString(10)});a.appendChild(r)}e.virtualDragElement=a,e.element.appendChild(e.virtualDragElement)}function G(e,i){var n=i;n.cancel=!1,null!=e.treeExpandTimer&&(window.clearTimeout(e.treeExpandTimer),e.treeExpandTimer=null),J(e),e.element.classList.remove("e-fe-drop","e-no-drop"),b(e),e.uploadObj.dropArea=t.select("#"+e.element.id+Vt,e.element);var s=t.select("."+gi,e.element);s&&t.detach(s),I(e,i.target),e.notify(Qn,i),b(e,"hover"),n.fileDetails=e.dragData,e.trigger("fileDragStop",n,function(i){!i.cancel&&!t.isNullOrUndefined(e.targetModule)&&""!==e.targetModule&&e.dragCount>2&&function(e){e.isDragDrop=!0,0!==e.dragData.length&&(e.dragPath=e.dragPath.replace(/\\/g,"/"),e.dropPath=e.dropPath.replace(/\\/g,"/"),B(e,e.dragData,e.dropPath,e.dragPath)||e.dragPath===e.dropPath||(e.itemData=[e.dropData],ye(e,e.dragPath,e.dragNodes,e.dropPath,"move",[],e.dragData),e.notify(_n,{})))}(e),e.dragCount=0})}function Y(e,i,n){var s=i;if(s.cancel=!1,s.fileDetails=e.dragData,e.dragCount=0,e.droppedObjects=[],(!e.allowDragAndDrop||"navigationpane"===e.activeModule&&t.closest(i.element,"li").getAttribute("data-uid")===e.pathId[0])&&(s.cancel=!0),"navigationpane"===e.activeModule&&-1!==e.pathId.indexOf(t.closest(i.element,"li").getAttribute("data-uid"))?e.isPathDrag=!0:e.isPathDrag=!1,b(e),s.cancel)n.intDestroy(i.event),Q(e);else if(!s.cancel){for(var a=0;a<e.activeElements.length;)m(e.activeElements[a]),a++;e.trigger("fileDragStart",s,function(t){t.cancel?(n.intDestroy(i.event),Q(e)):e.uploadObj.dropArea=null})}}function Q(e){b(e);var i=t.select("."+gi,e.element);i&&t.detach(i)}function J(e){X(e,mi),X(e,bi)}function X(e,t){for(var i=e.element.querySelectorAll("."+t),n=0;n<i.length;n++)i[n].classList.remove(t)}function $(e,i){var n=i;n.fileDetails=e.dragData;var s=!1;I(e,i.target),J(e),null!=e.treeExpandTimer&&(window.clearTimeout(e.treeExpandTimer),e.treeExpandTimer=null),b(e,"hover");var a=null;"navigationpane"===e.targetModule?((a=t.closest(i.target,"li")).classList.add(ri,mi),s=!0,e.treeExpandTimer=window.setTimeout(function(){e.notify($n,i)},800)):"detailsview"===e.targetModule?((a=t.closest(i.target,"tr"))&&a.querySelector("."+yi)&&!a.classList.contains(si)?a.classList.add(mi):!a||a.querySelector("."+yi)||a.classList.contains(si)||a.classList.add(bi),s=!0):"largeiconsview"===e.targetModule?((a=t.closest(i.target,"li"))&&a.querySelector("."+yi)&&!a.classList.contains(si)&&a.classList.add(ri,mi),s=!0):"breadcrumbbar"===e.targetModule&&(s=!0),e.element.classList.remove("e-fe-drop","e-no-drop"),e.element.classList.add(s?"e-fe-drop":"e-no-drop"),e.dragCount=e.dragCount+1,e.trigger("fileDragging",n)}function Z(e,i){return e.hasId?t.getValue("id",i):E(e,i)}function ee(e,i){e.itemData=[i],e.currentItemText=t.getValue("name",i),e.isFile=t.getValue("isFile",i),e.filterPath=t.getValue("filterPath",i)}function te(e){le(e.itemData[0])?Le(e,"Rename"):ae(e,e.itemData[0],is)}function ie(e){for(var t=e.itemData,i=0;i<t.length;i++)if(!pe(t[i]))return void ae(e,t[i],as);e.selectedItems.length>0&&ke(e,e.path,e.selectedItems)}function ne(e,t,i){for(var n=0;n<t.length;n++)if(!le(t[n]))return void ae(e,t[n],is);e.itemData=t,ve(e,i,e.path,"delete")}function se(e,t,i){for(var n=0;n<t.length;n++)if(!pe(t[n]))return void ae(e,t[n],as);e.itemData=t,i.length>0&&ke(e,e.path,i)}function ae(e,i,n){var s=t.getValue("message",t.getValue("permission",i));""===s&&(s=T(e,"Access-Message").replace("{0}",t.getValue("name",i)).replace("{1}",n));Le(e,"Error",{error:{code:"401",fileExists:null,message:s}})}function re(e){return oe(e)?"e-fe-locked":"e-fe-locked e-fe-hidden"}function oe(e){var i=t.getValue("permission",e);return!(i&&!t.getValue("read",i))}function le(e){var i=t.getValue("permission",e);return!i||t.getValue("read",i)&&t.getValue("write",i)}function he(e){var i=t.getValue("permission",e);return!i||t.getValue("read",i)&&t.getValue("writeContents",i)}function de(e){var i=t.getValue("permission",e);return!i||t.getValue("read",i)&&t.getValue("upload",i)}function pe(e){var i=t.getValue("permission",e);return!i||t.getValue("read",i)&&t.getValue("download",i)}function ce(e){var t=e.itemData[0];he(t)?Le(e,"NewFolder"):ae(e,t,ns)}function ue(e){var t=e.itemData[0];if(de(t)){var i="#"+e.element.id+Bt;document.querySelector(i).click()}else ae(e,t,ss)}function fe(e,i,n){for(var s=e.itemData,a=0;a<s.length;a++)t.isNullOrUndefined(t.getValue("hasChild",s[a]))&&t.setValue("hasChild",!1,s[a]);Ie(e,{action:"read",path:n,showHiddenItems:e.showHiddenItems,data:s},De,i)}function ge(e,t){Ie(e,{action:"create",path:e.path,name:t,data:e.itemData},Ce,t)}function me(e,i){var n={action:"filter",path:e.path,showHiddenItems:e.showHiddenItems,data:[S(e)]},s=e.filterData?t.extend(void 0,n,e.filterData):n;Ie(e,s,Se,i,t.getValue("action",s))}function be(e,t,i){var n,s;if(""!==e.breadcrumbbarModule.searchObj.element.value||e.isFiltered){var a=e.filterPath;e.hasId?(n=e.currentItemText,s=i):(n=(a=a.replace(/\\/g,"/")).replace(t,"")+e.currentItemText,s=a.replace(t,"")+i)}else n=e.currentItemText,s=i;Ie(e,{action:"rename",path:t,name:n,newName:s,data:e.itemData},je,t)}function ye(e,t,i,n,s,a,r){var o={action:s,path:t,targetData:e.itemData[0],targetPath:n,names:i,renameFiles:a,data:r};e.destinationPath=n,Ie(e,o,xe,t,s,n)}function ve(e,t,i,n){Ie(e,{action:n,path:i,names:t,data:e.itemData},Ne,i)}function Oe(e,t,i,n){Ie(e,{action:n,path:i,names:t,data:e.itemData},Pe,i,n)}function Ie(e,i,n,s,a,r){var o={url:e.ajaxSettings.url,type:"POST",mode:!0,dataType:"json",contentType:"application/json",data:JSON.stringify(i),onSuccess:null,onFailure:null,beforeSend:null},l={action:t.getValue("action",i),ajaxSettings:o,cancel:!1};e.trigger("beforeSend",l,function(o){if(!o.cancel){e.notify(mn,{});new t.Ajax({url:t.getValue("url",o.ajaxSettings),type:t.getValue("type",o.ajaxSettings),mode:t.getValue("mode",o.ajaxSettings),dataType:t.getValue("dataType",o.ajaxSettings),contentType:t.getValue("contentType",o.ajaxSettings),data:t.getValue("data",o.ajaxSettings),beforeSend:t.getValue("beforeSend",o.ajaxSettings),onSuccess:function(l){if(t.isNullOrUndefined(l)){var h={error:{fileExists:null,message:T(e,"Server-Error")+" "+e.ajaxSettings.url,code:"406"},files:null};we(e,o,n,h,s,a,r)}else{"string"==typeof l&&(l=JSON.parse(l)),e.notify(yn,{action:"success"});var d=e.expandedId?e.expandedId:e.pathId[e.pathId.length-1];if(!t.isNullOrUndefined(l.cwd)&&"read"===t.getValue("action",i)&&(l.cwd.name=1===e.pathId.length?e.rootAliasName||l.cwd.name:l.cwd.name,t.setValue("_fm_id",d,l.cwd),t.setValue(d,l.cwd,e.feParent),!t.isNullOrUndefined(l.files)||"401"===l.error.code)){if(("finalize-end"===s||"initial-end"===s)&&0===e.pathNames.length){var p=t.getValue(e.pathId[0],e.feParent);e.pathNames[0]=t.getValue("name",p),e.hasId=!t.isNullOrUndefined(t.getValue("id",p))}"finalize-end"===s&&function(e){for(var i=e.hasId?"id":"name",n=e.hasId?"":"/",s=e.hasId?0:1;s<e.pathId.length;s++){var a=t.getValue(e.pathId[s],e.feParent);n+=t.getValue(i,a)+"/"}e.setProperties({path:n},!0)}(e)}if(!t.isNullOrUndefined(l.files)){!function(e){for(var i=0;i<e.length;i++)t.setValue("_fm_created",new Date(t.getValue("dateCreated",e[i])),e[i]),t.setValue("_fm_modified",new Date(t.getValue("dateModified",e[i])),e[i])}(l.files);for(var c=0,u=l.files.length;c<u;c++){var f=l.files[c];t.setValue("_fm_iconClass",x(f),f)}"read"===t.getValue("action",i)&&(!function(e,i){for(var n=L(e.files),s=0,a=n.length;s<a;s++)t.setValue("_fm_id",i+"_"+s,n[s])}(l,d),t.setValue(d,l.files,e.feFiles))}if(!t.isNullOrUndefined(l.details)&&!t.isNullOrUndefined(e.rootAliasName)){var g=e.rootAliasName||t.getValue("name",l.details),m=t.getValue("location",l.details).replace(new RegExp("/","g"),"\\");("/"===t.getValue("path",i)||e.hasId&&1===t.getValue("path",i).match(/[/]/g).length)&&0===t.getValue("names",i).length?(t.setValue("name",g,l.details),m=g):m=m.replace(m.substring(0,m.indexOf("\\")),g),t.setValue("location",m,l.details)}n(e,l,s,a,r),t.isNullOrUndefined(l.files)||"path-changed"!==s&&"finalize-end"!==s&&"open-end"!==s||e.notify(Gn,l),"function"==typeof t.getValue("onSuccess",o.ajaxSettings)&&t.getValue("onSuccess",o.ajaxSettings)()}},onFailure:function(){var t={files:null,error:{code:"404",message:T(e,"Network-Error")+" "+e.ajaxSettings.url,fileExists:null}};we(e,o,n,t,s,a,r)}}).send()}})}function we(e,i,n,s,a,r,o){e.notify(yn,{action:"failure"}),n(e,s,a,r,o),"function"==typeof t.getValue("onFailure",i.ajaxSettings)&&t.getValue("onFailure",i.ajaxSettings)()}function De(e,i,n){if(t.isNullOrUndefined(i.files))"401"===i.error.code&&(i.files=[],e.notify(n,i),e.notify(Sn,{})),Ee(e,i,"read");else{e.notify(n,i),e.notify(Sn,{});var s={action:"read",result:i};e.trigger("success",s)}if(e.isDragDrop&&e.isDropEnd){if(0!==e.droppedObjects.length){s={fileDetails:e.droppedObjects};e.trigger("fileDropped",s)}e.isDropEnd=e.isDragDrop=!1}}function Se(e,i,n,s){if(t.isNullOrUndefined(i.files))Ee(e,i,s);else{e.notify(n,i);var a={action:s,result:i};e.trigger("success",a)}}function Ce(e,i,n){if(t.isNullOrUndefined(i.files))if("400"===i.error.code){if(e.dialogObj&&e.dialogObj.visible){var s=t.select("#newname",e.dialogObj.element),a=T(e,"Validation-NewFolder-Exists").replace("{0}",'"'+s.value+'"');s.parentElement.nextElementSibling.innerHTML=a}else{Le(e,"Error",{files:null,error:{code:"400",message:T(e,"Validation-NewFolder-Exists").replace("{0}",'"'+n+'"'),fileExists:null}})}r={action:"create",error:i.error};e.trigger("failure",r)}else e.dialogObj&&e.dialogObj.visible&&e.dialogObj.hide(),Ee(e,i,"create");else{e.dialogObj&&e.dialogObj.visible&&e.dialogObj.hide(),e.createdItem=i.files[0],e.breadcrumbbarModule.searchObj.value="";var r={action:"create",result:i};e.trigger("success",r),e.itemData=[S(e)],fe(e,rn,e.path)}}function je(e,i,n){if(t.isNullOrUndefined(i.files))if("400"===i.error.code&&e.dialogObj&&e.dialogObj.visible){var s=t.select("#rename",e.dialogObj.element),a=T(e,"Validation-Rename-Exists").replace("{0}",'"'+e.currentItemText+'"');a=a.replace("{1}",'"'+s.value+'"'),s.parentElement.nextElementSibling.innerHTML=a;r={action:"rename",error:i.error};e.trigger("failure",r)}else t.isNullOrUndefined(e.dialogObj)||e.dialogObj.hide(),Ee(e,i,"rename");else{t.isNullOrUndefined(e.dialogObj)||e.dialogObj.hide();var r={action:"rename",result:i};e.trigger("success",r),e.renamedItem=i.files[0],"navigationpane"===e.activeModule?(e.pathId.pop(),e.itemData=[t.getValue(e.pathId[e.pathId.length-1],e.feParent)],fe(e,Ln,H(e.path))):(e.itemData=[S(e)],""!==e.breadcrumbbarModule.searchObj.value?Re(e,Tn,e.path,e.searchWord,e.showHiddenItems,!e.searchSettings.ignoreCase):e.isFiltered?me(e,Tn):fe(e,Tn,e.path))}}function xe(e,i,n,s){i.error&&i.error.fileExists?(e.fileLength=0,t.isNullOrUndefined(i.files)||(e.isPasteError=!0,q(e,s,i)),Te(e,"DuplicateItems",i.error.fileExists),"404"===i.error.code&&Le(e,"Error",i)):i.error||t.isNullOrUndefined(i.files)?i.error&&!t.isNullOrUndefined(i.files)?(e.isPasteError=!0,q(e,s,i),Le(e,"Error",i)):Ee(e,i,s):(e.isPasteError=!1,q(e,s,i))}function Ne(e,i,n){if(t.isNullOrUndefined(i.files))Ee(e,i,"delete");else if(e.setProperties({path:n},!0),e.itemData=[S(e)],fe(e,dn,e.path),i.error)Ee(e,i,"delete");else{var s={action:"delete",result:i};e.trigger("success",s)}}function Pe(e,i,n,s){if(t.isNullOrUndefined(i.details))Ee(e,i,"details");else{Le(e,s,null,i.details);var a={action:"details",result:i};e.trigger("success",a)}}function Ee(e,t,i){Le(e,"Error",t);var n={action:i,error:t.error};e.trigger("failure",n)}function Re(e,t,i,n,s,a){Ie(e,{action:"search",path:i,searchString:n,showHiddenItems:s,caseSensitive:a,data:e.itemData},Me,t)}function Me(e,i,n){if(t.isNullOrUndefined(i.files))Ee(e,i,"search");else{e.notify(n,i);var s={action:"search",result:i};e.trigger("success",s)}}function ke(e,i,n){var s=e.ajaxSettings.downloadUrl?e.ajaxSettings.downloadUrl:e.ajaxSettings.url,a={data:{action:"download",path:i,names:n,data:e.itemData},cancel:!1};e.trigger("beforeDownload",a,function(i){if(!i.cancel){var n=t.createElement("form",{id:e.element.id+"_downloadForm",attrs:{action:s,method:"post",name:"downloadForm",download:""}}),a=t.createElement("input",{id:e.element.id+"_hiddenForm",attrs:{name:"downloadInput",value:JSON.stringify(i.data),type:"hidden"}});n.appendChild(a),e.element.appendChild(n),document.forms.namedItem("downloadForm").submit(),e.element.removeChild(n)}})}function Le(e,i,s,a,r){var o=function(e,i,n,s,a){var r,o,l,h,d,p,c={header:"",content:"",buttons:[],dialogName:""};switch(c.open=function(){Ue(e,e.dialogObj,c.dialogName)},c.close=function(){Ve(e,e.dialogObj,c.dialogName)},i=s&&!0===s.multipleFiles?"MultipleFileDetails":i){case"NewFolder":c.dialogName="Create Folder",c.header=T(e,"Header-NewFolder"),c.content='<input type="text" value="New folder" id="newname"><div class="e-fe-error"></div>',c.buttons=[{buttonModel:{isPrimary:!0,content:T(e,"Button-Create")},click:function(t){"keydown"!==t.type&&Ke(e)}}],c.open=function(e){var i=t.select("#newname",e.dialogObj.element);i.parentElement.classList.contains("e-control-wrapper")||He(i,T(e,"Content-NewFolder"));i.parentElement.nextElementSibling.innerHTML="",i.oninput=function(){Ye(e,i)},i.onkeyup=function(t){var i=Xe(t);13===i&&Ke(e)},function(e){var i=t.select("#newname",e.dialogObj.element);i.focus(),i.value="";var n=i.value.length;i.setSelectionRange(0,n)}(e),Ue(e,e.dialogObj,"Create Folder")}.bind(this,e);break;case"Delete":c.dialogName="Delete",e.selectedItems.length>1?(c.content=("<div>"+T(e,"Content-Multiple-Delete")+"</div>").replace("{0}",e.selectedItems.length.toString()),c.header=T(e,"Header-Multiple-Delete")):(c.content="<div>"+T(e,e.isFile?"Content-Delete":"Content-Folder-Delete")+"</div>",c.header=T(e,e.isFile?"Header-Delete":"Header-Folder-Delete")),c.buttons=[{buttonModel:{isPrimary:!0,content:T(e,"Button-Yes")},click:function(t){!function(e){e.dialogObj.hide(),e.notify(hn,{})}(e)}},{buttonModel:{content:T(e,"Button-No")},click:function(){e.dialogObj.hide()}}];break;case"Rename":c.dialogName="Rename",c.header=T(e,"Header-Rename"),c.content='<input type="text" class="e-input" id="rename"><div class="e-fe-error"></div>',c.buttons=[{buttonModel:{isPrimary:!0,content:T(e,"Button-Save")},click:function(t){"keydown"!==t.type&&Ge(e)}}],c.open=function(e){var i=t.select("#rename",e.dialogObj.element);i.parentElement.classList.contains("e-control-wrapper")||He(i,T(e,"Content-Rename"));i.parentElement.nextElementSibling.innerHTML="",i.oninput=function(){Ye(e,i)},i.onkeyup=function(t){var i=Xe(t);13===i&&Ge(e)},function(e,t){t.focus();var i="";if(e.isFile&&!e.showFileExtension){var n=e.currentItemText.lastIndexOf(".");i=-1===n?e.currentItemText:e.currentItemText.substring(0,n)}else i=e.currentItemText;t.value=i,e.isFile&&e.showFileExtension&&-1!==t.value.indexOf(".")?t.setSelectionRange(0,t.value.lastIndexOf(".")):t.setSelectionRange(0,t.value.length)}(e,i),Ue(e,e.dialogObj,"Rename")}.bind(this,e);break;case"details":c.dialogName="File Details",l=new t.Internationalization(e.locale),o=l.formatDate(new Date(s.modified),{format:"MMMM dd, yyyy HH:mm:ss"}),r="",t.isNullOrUndefined(s.permission)||(r="<tr><td>"+T(e,"Permission")+'</td><td class="'+en+'" >'+function(e){for(var i="",n=Object.keys(e),s=0;s<n.length;s++)"message"!==n[s]&&(i+=(0===s?"":", ")+n[s]+": "+t.getValue(n[s],e));return i}(s.permission)+"</td></tr>"),c.header=s.name,c.content="<table><tr><td>"+T(e,"Type")+'</td><td class="'+en+'" title="'+(s.isFile?"File":"Folder")+'">'+(s.isFile?"File":"Folder")+"</td></tr><tr><td>"+T(e,"Size")+'</td><td><span class="'+en+'" title ="'+s.size+'">'+s.size+"</span></td></tr><tr><td>"+T(e,"Location")+'</td><td class="'+en+'" title="'+s.location+'">'+s.location+"</td></tr><tr><td>"+T(e,"Modified")+'</td><td class="'+en+'" >'+o+"</td></tr>"+r+"</table>",c.buttons=[{buttonModel:{isPrimary:!0,content:T(e,"Button-Ok")},click:function(t){e.dialogObj.hide()}}];break;case"MultipleFileDetails":c.dialogName="File Details",h=s.name.split(",").map(function(e){var t=e.indexOf(".")+1;return 0===t?"Folder":e.substr(t).replace(" ","")}),d=h.every(function(e,t,i){return e===i[0]})?"Folder"===h[0]?"Folder":h[0].toLocaleUpperCase()+" Type":"Multiple Types",p=s.location,c.header=s.name,c.content="<table><tr><td>"+T(e,"Type")+':</td><td class="'+en+'">'+d+"</td></tr><tr><td>"+T(e,"Size")+":</td><td>"+s.size+'<span class="'+en+'" title ="'+s.size+'"></span></td></tr><tr><td>'+T(e,"Location")+':</td><td class="'+en+'" title="'+p+'">'+p+"</td></tr></table>",c.buttons=[{buttonModel:{isPrimary:!0,content:T(e,"Button-Ok")},click:function(t){"keydown"!==t.type&&e.dialogObj.hide()}}];break;case"Error":e.notify(On,{}),c.dialogName="Error","401"===n.error.code?c.header='<span class="e-fe-icon e-fe-access-error"></span><div class="e-fe-access-header">'+T(e,"Access-Denied")+"</div>":c.header=T(e,"Error"),c.content='<div class="'+Qi+'">'+n.error.message+"</div>",c.buttons=[{buttonModel:{isPrimary:!0,content:T(e,"Button-Ok")},click:function(t){e.dialogObj.hide()}}]}return c}(e,i,s,a);t.isNullOrUndefined(e.dialogObj)?(e.dialogObj=new n.Dialog({beforeOpen:ze.bind(this,e,o.dialogName),beforeClose:function(t){Fe(e,e.dialogObj,t,o.dialogName)},header:o.header,content:o.content,buttons:o.buttons,animationSettings:{effect:"None"},showCloseIcon:!0,closeOnEscape:!0,visible:!0,allowDragging:!0,isModal:!0,target:e.popupTarget?e.popupTarget:"#"+e.element.id,cssClass:A(e,e.isMobile?Gt:Wt),width:"350px",open:o.open,close:o.close,enableRtl:e.enableRtl,enableHtmlSanitizer:e.enableHtmlSanitizer,locale:e.locale}),e.dialogObj.isStringTemplate=!0,e.dialogObj.appendTo("#"+e.element.id+Lt)):function(e,t){e.dialogObj.header=t.header,e.dialogObj.content=t.content,e.dialogObj.buttons=t.buttons,e.dialogObj.enableRtl=e.enableRtl,e.dialogObj.open=t.open,e.dialogObj.close=t.close,e.dialogObj.beforeOpen=ze.bind(this,e,t.dialogName),e.dialogObj.beforeClose=function(i){Fe(e,e.dialogObj,i,t.dialogName)},e.dialogObj.dataBind(),e.dialogObj.show()}(e,o)}function Te(e,i,s,a){var o=function(e,i,n,s){var a,o,l,h={header:"",content:"",buttons:[],dialogName:""};switch(h.open=function(){Ue(e,e.extDialogObj,h.dialogName)},h.close=function(){Ve(e,e.extDialogObj,h.dialogName)},i){case"Extension":h.header=T(e,"Header-Rename-Confirmation"),h.content="<div>"+T(e,"Content-Rename-Confirmation")+"</div>",h.buttons=[{buttonModel:{isPrimary:!0,content:T(e,"Button-Yes")},click:function(){e.extDialogObj.hide(),be(e,s,e.renameText)}},{buttonModel:{content:T(e,"Button-No")},click:function(){e.extDialogObj.hide(),e.dialogObj.hide()}}],h.dialogName="Extension Change";break;case"DuplicateItems":h.dialogName="Duplicate Items",e.replaceItems=n,o=e.replaceItems[e.fileLength],l=o.lastIndexOf("/"),o=-1===l?o:o.substring(l),h.header=T(e,"Header-Duplicate"),a="<div>"+T(e,"Content-Duplicate")+"</div>",h.content=a.replace("{0}",o),h.close=function(){if(!e.isDropEnd&&0===e.duplicateItems.length){var t={fileDetails:e.droppedObjects};e.trigger("fileDropped",t),e.isDropEnd=e.isDragDrop=!1}Ve(e,e.extDialogObj,h.dialogName)},h.buttons=[{buttonModel:{isPrimary:!0,content:T(e,"Button-Yes")},click:function(){if(e.duplicateItems.push(e.replaceItems[e.fileLength]),e.duplicateRecords.push(function(e,i){for(var n=null,s=e.isDragDrop?e.dragData:e.actionRecords,a=0;a<s.length;a++)if(t.getValue("name",s[a])===i){n=s[a];break}return n}(e,e.replaceItems[e.fileLength])),e.fileLength++,n[e.fileLength]){var i=e.replaceItems[e.fileLength],s=i.lastIndexOf("/");i=-1===s?i:i.substring(s),e.extDialogObj.content=a.replace("{0}",i),e.extDialogObj.show()}else{e.extDialogObj.hide();var r=e.isDragDrop?e.dragPath:e.targetPath,o=e.isDragDrop?e.dropPath:""===e.folderPath?e.path:e.folderPath,l=e.isDragDrop?"move":e.fileAction;ye(e,r,e.duplicateItems,o,l,e.duplicateItems,e.duplicateRecords)}}},{buttonModel:{content:T(e,"Button-No")},click:function(){if(e.fileLength++,n[e.fileLength]){var t=e.replaceItems[e.fileLength],i=t.lastIndexOf("/");t=-1===i?t:t.substring(i),e.extDialogObj.content=a.replace("{0}",t),e.extDialogObj.show()}else if(e.extDialogObj.hide(),0!==e.duplicateItems.length){var s=e.isDragDrop?"move":e.fileAction,r=e.isDragDrop?e.dragPath:e.targetPath,o=e.isDragDrop?e.dropPath:""===e.folderPath?e.path:e.folderPath;ye(e,r,e.duplicateItems,o,s,e.duplicateItems,e.duplicateRecords)}}}];break;case"UploadRetry":h.dialogName="Retry Upload",h.header=T(e,"Header-Retry"),h.content=e.retryFiles[0].name+'<div class="e-fe-retrycontent">'+T(e,"Content-Retry")+"</div>",h.open=function(e,i){e.isRetryOpened=!0;var n=t.getValue("element",i),s=t.select(".e-dlg-content",n),a=e.createElement("div",{className:"e-dlg-checkbox"}),o=e.createElement("input",{id:e.element.id+"_applyall"});a.appendChild(o),s.appendChild(a);new r.CheckBox({label:T(e,"ApplyAll-Label"),change:function(t){e.isApplySame=t.checked}}).appendTo("#"+e.element.id+"_applyall"),Ue(e,e.extDialogObj,"Retry Upload")}.bind(this,e),h.close=function(){e.isRetryOpened=!1,Be(e),Ve(e,e.extDialogObj,h.dialogName)},h.buttons=[{buttonModel:{isPrimary:!0,content:T(e,"Button-Keep-Both")},click:function(){_e(e,!0)}},{buttonModel:{isPrimary:!0,content:T(e,"Button-Replace")},click:function(){_e(e,!1)}},{buttonModel:{isPrimary:!0,content:T(e,"Button-Skip")},click:function(){var t=0;e.isApplySame?(t=e.retryFiles.length,e.retryFiles=[],Be(e)):(t=1,e.retryFiles.splice(0,1),0!==e.retryFiles.length?Te(e,"UploadRetry"):Be(e)),e.notify(bn,{count:t})}}]}return h}(e,i,s,a);e.isApplySame=!1,t.isNullOrUndefined(e.extDialogObj)?(e.extDialogObj=new n.Dialog({beforeOpen:qe.bind(this,e,o.dialogName),beforeClose:function(t){Fe(e,e.extDialogObj,t,o.dialogName)},content:o.content,header:o.header,closeOnEscape:!0,allowDragging:!0,animationSettings:{effect:"None"},target:e.popupTarget?e.popupTarget:"#"+e.element.id,cssClass:A(e,e.isMobile?Gt:Wt),enableRtl:e.enableRtl,showCloseIcon:!0,isModal:!0,width:350,buttons:o.buttons,open:o.open,close:o.close,enableHtmlSanitizer:e.enableHtmlSanitizer,locale:e.locale}),e.extDialogObj.isStringTemplate=!0,e.extDialogObj.appendTo("#"+e.element.id+At)):(e.extDialogObj.header=o.header,e.extDialogObj.close=o.close,e.extDialogObj.open=o.open,e.extDialogObj.close=o.close,e.extDialogObj.content=o.content,e.extDialogObj.buttons=o.buttons,e.extDialogObj.enableRtl=e.enableRtl,e.extDialogObj.locale=e.locale,e.extDialogObj.beforeOpen=qe.bind(this,e,o.dialogName),e.extDialogObj.beforeClose=function(t){Fe(e,e.extDialogObj,t,o.dialogName)},e.extDialogObj.dataBind(),e.extDialogObj.show())}function Ae(e,t,i,n){var s={cancel:i.cancel,popupName:n,popupModule:t};e.trigger("beforePopupOpen",s,function(e){i.cancel=e.cancel})}function Fe(e,t,i,n){var s={cancel:i.cancel,popupModule:t,popupName:n};e.trigger("beforePopupClose",s,function(t){i.cancel=t.cancel,i.cancel||!i.isInteracted||"Rename"!==n&&"Create Folder"!==n||e.trigger(On,{})})}function Ue(e,t,i){var n={popupModule:t,element:t.element,popupName:i};e.trigger("popupOpen",n)}function Ve(e,t,i){var n={popupModule:t,element:t.element,popupName:i};e.trigger("popupClose",n)}function _e(e,t){e.isApplySame?(t?function(e){for(;0!==e.retryFiles.length;)e.retryArgs.push({action:"keepboth",file:e.retryFiles[0]}),e.uploadObj.retry(e.retryFiles[0]),e.retryFiles.splice(0,1)}(e):function(e){for(;0!==e.retryFiles.length;)e.retryArgs.push({action:"replace",file:e.retryFiles[0]}),e.uploadObj.retry(e.retryFiles[0]),e.retryFiles.splice(0,1)}(e),Be(e)):(e.retryArgs.push({action:t?"keepboth":"replace",file:e.retryFiles[0]}),e.uploadObj.retry(e.retryFiles[0]),e.retryFiles.splice(0,1),0!==e.retryFiles.length?Te(e,"UploadRetry"):Be(e))}function Be(e){var i=!0;e.isRetryOpened?e.isRetryOpened=!1:i=!1;var n=t.select(".e-dlg-checkbox",e.extDialogObj.element);n&&t.remove(n),i?e.extDialogObj.hide():e.retryFiles=[]}function He(e,t){a.Input.createInput({element:e,properties:{placeholder:t}})}function ze(e,i,n){We(t.selectAll(".e-btn",e.dialogObj.element)),Ae(e,e.dialogObj,n,i)}function qe(e,i,n){We(t.selectAll(".e-btn",e.extDialogObj.element)),Ae(e,e.extDialogObj,n,i)}function We(e){for(var t=function(t){e[t].onkeydown=function(e){13===e.keyCode&&e.preventDefault()},e[t].onkeyup=function(i){13===i.keyCode&&e[t].click()}},i=0;i<e.length;i++)t(i)}function Ke(e){var i=t.select("#newname",e.dialogObj.element);Qe(e,i),""===i.parentElement.nextElementSibling.innerHTML&&ge(e,i.value)}function Ge(e){var i=t.select("#rename",e.dialogObj.element);if(Qe(e,i),""===i.parentElement.nextElementSibling.innerHTML){var n=i.value,s=e.currentItemText.lastIndexOf(".");if(e.isFile&&!e.showFileExtension){n+=-1===s?"":e.currentItemText.substr(s)}if(e.renameText=n,e.currentItemText!==n){var a="navigationpane"===e.activeModule?H(e.path):e.path;if(e.renamedId=t.getValue("id",e.itemData[0]),e.isFile){var r=-1===s?"":e.currentItemText.substr(s),o=n.lastIndexOf("."),l=-1===o?"":n.substr(o);e.showFileExtension&&r!==l?Te(e,"Extension",null,a):be(e,a,n)}else be(e,a,n)}else e.dialogObj.hide()}}function Ye(e,t){/[/\\|*?"<>:]/.test(t.value)?Je(e,t):""===t.value?t.parentElement.nextElementSibling.innerHTML=T(e,"Validation-Empty"):t.parentElement.nextElementSibling.innerHTML=""}function Qe(e,t){Ye(e,t);var i=t.value.length-1;""===t.value||t.value.lastIndexOf(".")!==i&&t.value.lastIndexOf(" ")!==i||!e.showFileExtension&&-1!==e.currentItemText.lastIndexOf(".")||Je(e,t)}function Je(e,t){var i=T(e,"Validation-Invalid").replace("{0}",'"'+t.value+'"');e.enableHtmlSanitizer?t.parentElement.nextElementSibling.textContent=i:t.parentElement.nextElementSibling.innerHTML=i}function Xe(e){return e.keyCode?e.keyCode:e.which?e.which:e.charCode}function $e(e,i,s){var a=t.createElement("div",{className:"e-image-wrap"}),r=t.createElement("img",{className:"e-image",attrs:{src:s,alt:i}});a.appendChild(r),t.isNullOrUndefined(e.viewerObj)?(e.viewerObj=new n.Dialog({header:i,content:a,animationSettings:{effect:"None"},showCloseIcon:!0,closeOnEscape:!0,visible:!0,isModal:!0,width:"350px",height:"350px",target:e.popupTarget?e.popupTarget:"#"+e.element.id,cssClass:A(e,e.isMobile?Gt:Wt),locale:e.locale,enableResize:!0,allowDragging:!0,enableHtmlSanitizer:e.enableHtmlSanitizer,position:{X:"center",Y:"center"},enableRtl:e.enableRtl,open:function(e){setTimeout(function(){e.viewerObj&&e.viewerObj.element.focus()}),Ze(e),Ue(e,e.viewerObj,"Image Preview")}.bind(this,e),close:function(){Ve(e,e.viewerObj,"Image Preview")},beforeOpen:function(t){Ae(e,e.viewerObj,t,"Image Preview")},beforeClose:function(t){Fe(e,e.viewerObj,t,"Image Preview")},resizing:Ze.bind(this,e),resizeStop:Ze.bind(this,e)}),e.viewerObj.isStringTemplate=!0,e.viewerObj.appendTo("#"+e.element.id+Tt)):(e.viewerObj.refresh(),e.viewerObj.header=i,e.viewerObj.content=a,e.viewerObj.enableRtl=e.enableRtl,e.viewerObj.dataBind(),e.viewerObj.show())}function Ze(e){var i=t.select(".e-dlg-content",e.viewerObj.element),n=t.select(".e-image-wrap",e.viewerObj.element),s=window.getComputedStyle(i,null),a=s?2*parseFloat(s.paddingRight):36,r=s?2*parseFloat(s.paddingBottom):20;n.style.width=i.offsetWidth-a+"px",n.style.height=i.offsetHeight-r+"px"}var et=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function n(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),tt=function(e,t,i,n){var s,a=arguments.length,r=a<3?t:null===n?n=Object.getOwnPropertyDescriptor(t,i):n;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(e,t,i,n);else for(var o=e.length-1;o>=0;o--)(s=e[o])&&(r=(a<3?s(r):a>3?s(t,i,r):s(t,i))||r);return a>3&&r&&Object.defineProperty(t,i,r),r},it=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return et(i,e),tt([t.Property(null)],i.prototype,"downloadUrl",void 0),tt([t.Property(null)],i.prototype,"getImageUrl",void 0),tt([t.Property(null)],i.prototype,"uploadUrl",void 0),tt([t.Property(null)],i.prototype,"url",void 0),i}(t.ChildProperty),nt=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function n(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),st=function(e,t,i,n){var s,a=arguments.length,r=a<3?t:null===n?n=Object.getOwnPropertyDescriptor(t,i):n;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(e,t,i,n);else for(var o=e.length-1;o>=0;o--)(s=e[o])&&(r=(a<3?s(r):a>3?s(t,i,r):s(t,i))||r);return a>3&&r&&Object.defineProperty(t,i,r),r},at=["NewFolder","Upload","Cut","Copy","Paste","Delete","Download","Rename","SortBy","Refresh","Selection","View","Details"],rt=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return nt(i,e),st([t.Property(at)],i.prototype,"items",void 0),st([t.Property(!0)],i.prototype,"visible",void 0),i}(t.ChildProperty),ot=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function n(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),lt=function(e,t,i,n){var s,a=arguments.length,r=a<3?t:null===n?n=Object.getOwnPropertyDescriptor(t,i):n;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(e,t,i,n);else for(var o=e.length-1;o>=0;o--)(s=e[o])&&(r=(a<3?s(r):a>3?s(t,i,r):s(t,i))||r);return a>3&&r&&Object.defineProperty(t,i,r),r},ht=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return ot(i,e),lt([t.Property(!0)],i.prototype,"allowSearchOnTyping",void 0),lt([t.Property("contains")],i.prototype,"filterType",void 0),lt([t.Property(!0)],i.prototype,"ignoreCase",void 0),lt([t.Property(null)],i.prototype,"placeholder",void 0),i}(t.ChildProperty),dt=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function n(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),pt=function(e,t,i,n){var s,a=arguments.length,r=a<3?t:null===n?n=Object.getOwnPropertyDescriptor(t,i):n;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(e,t,i,n);else for(var o=e.length-1;o>=0;o--)(s=e[o])&&(r=(a<3?s(r):a>3?s(t,i,r):s(t,i))||r);return a>3&&r&&Object.defineProperty(t,i,r),r},ct=[{field:"name",headerText:"Name",minWidth:120,template:'<span class="e-fe-text">${name}</span>',customAttributes:{class:"e-fe-grid-name"}},{field:"_fm_modified",headerText:"DateModified",type:"dateTime",format:"MMMM dd, yyyy HH:mm",minWidth:120,width:"190"},{field:"size",headerText:"Size",minWidth:90,width:"110",template:'<span class="e-fe-size">${size}</span>'}],ut=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return dt(i,e),pt([t.Property(!0)],i.prototype,"columnResizing",void 0),pt([t.Property(ct)],i.prototype,"columns",void 0),i}(t.ChildProperty),ft=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function n(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),gt=function(e,t,i,n){var s,a=arguments.length,r=a<3?t:null===n?n=Object.getOwnPropertyDescriptor(t,i):n;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(e,t,i,n);else for(var o=e.length-1;o>=0;o--)(s=e[o])&&(r=(a<3?s(r):a>3?s(t,i,r):s(t,i))||r);return a>3&&r&&Object.defineProperty(t,i,r),r},mt=["Open","|","Cut","Copy","|","Delete","Download","Rename","|","Details"],bt=["Open","|","Cut","Copy","Paste","|","Delete","Rename","Download","|","Details"],yt=["SortBy","View","Refresh","|","Paste","|","NewFolder","Upload","|","Details","|","SelectAll"],vt=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return ft(i,e),gt([t.Property(mt)],i.prototype,"file",void 0),gt([t.Property(bt)],i.prototype,"folder",void 0),gt([t.Property(yt)],i.prototype,"layout",void 0),gt([t.Property(!0)],i.prototype,"visible",void 0),i}(t.ChildProperty),Ot=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function n(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),It=function(e,t,i,n){var s,a=arguments.length,r=a<3?t:null===n?n=Object.getOwnPropertyDescriptor(t,i):n;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(e,t,i,n);else for(var o=e.length-1;o>=0;o--)(s=e[o])&&(r=(a<3?s(r):a>3?s(t,i,r):s(t,i))||r);return a>3&&r&&Object.defineProperty(t,i,r),r},wt=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return Ot(i,e),It([t.Property("650px")],i.prototype,"maxWidth",void 0),It([t.Property("240px")],i.prototype,"minWidth",void 0),It([t.Property(!0)],i.prototype,"visible",void 0),It([t.Property("None")],i.prototype,"sortOrder",void 0),i}(t.ChildProperty),Dt=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function n(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),St=function(e,t,i,n){var s,a=arguments.length,r=a<3?t:null===n?n=Object.getOwnPropertyDescriptor(t,i):n;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(e,t,i,n);else for(var o=e.length-1;o>=0;o--)(s=e[o])&&(r=(a<3?s(r):a>3?s(t,i,r):s(t,i))||r);return a>3&&r&&Object.defineProperty(t,i,r),r},Ct=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return Dt(i,e),St([t.Property("")],i.prototype,"allowedExtensions",void 0),St([t.Property(!0)],i.prototype,"autoUpload",void 0),St([t.Property(!1)],i.prototype,"autoClose",void 0),St([t.Property(0)],i.prototype,"minFileSize",void 0),St([t.Property(3e7)],i.prototype,"maxFileSize",void 0),i}(t.ChildProperty),jt=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function n(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),xt=function(e,t,i,n){var s,a=arguments.length,r=a<3?t:null===n?n=Object.getOwnPropertyDescriptor(t,i):n;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(e,t,i,n);else for(var o=e.length-1;o>=0;o--)(s=e[o])&&(r=(a<3?s(r):a>3?s(t,i,r):s(t,i))||r);return a>3&&r&&Object.defineProperty(t,i,r),r},Nt=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return jt(i,e),xt([t.Property("")],i.prototype,"field",void 0),xt([t.Property("")],i.prototype,"headerText",void 0),xt([t.Property("")],i.prototype,"width",void 0),xt([t.Property("")],i.prototype,"minWidth",void 0),xt([t.Property("")],i.prototype,"maxWidth",void 0),xt([t.Property("Left")],i.prototype,"textAlign",void 0),xt([t.Property(null)],i.prototype,"headerTextAlign",void 0),xt([t.Property(null)],i.prototype,"type",void 0),xt([t.Property(null)],i.prototype,"format",void 0),xt([t.Property(null)],i.prototype,"template",void 0),xt([t.Property(null)],i.prototype,"headerTemplate",void 0),xt([t.Property(!0)],i.prototype,"allowSorting",void 0),xt([t.Property(!0)],i.prototype,"allowResizing",void 0),xt([t.Property(null)],i.prototype,"customAttributes",void 0),xt([t.Property("")],i.prototype,"hideAtMedia",void 0),xt([t.Property(null)],i.prototype,"customFormat",void 0),i}(t.ChildProperty),Pt="_toolbar",Et="_layout",Rt="_tree",Mt="_grid",kt="_largeicons",Lt="_dialog",Tt="_img_dialog",At="_extn_dialog",Ft="_upload_dialog",Ut="_contextmenu",Vt="_content",_t="_breadcrumbbar",Bt="_upload",Ht="e-filemanager",zt="e-control",qt="e-fe-cb-select",Wt="e-fe-popup",Kt="e-fe-mobile",Gt="e-fe-popup e-fe-mobile",Yt="e-fe-m-select",Qt="e-fe-m-filter",Jt="e-layout-content",Xt="e-large-icons",$t="e-toolbar-item",Zt="e-list-item",ei="e-list-text",ti="e-list-parent",ii="e-icons e-fe-tick",ni="e-icons e-fe-dot",si="e-blur",ai="e-active",ri="e-hover",oi="e-focus",li="e-focused",hi="e-check",di="e-checkbox-wrapper",pi="e-row",ci="e-empty",ui="e-empty-content",fi="e-empty-inner-content",gi="e-fe-clone",mi="e-fe-drop-folder",bi="e-fe-drop-file",yi="e-fe-folder",vi="e-fe-image",Oi="e-fe-music",Ii="e-fe-video",wi="e-large-icon",Di="e-empty-icon e-fe-folder",Si="e-gridheader",Ci="e-treeview",ji="e-menu-item",xi="e-menu-icon",Ni="e-content",Pi="e-gridcontent",Ei="e-list-parent",Ri="e-icons e-fe-open",Mi="e-icons e-fe-upload",ki="e-icons e-fe-cut",Li="e-icons e-fe-copy",Ti="e-icons e-fe-paste",Ai="e-icons e-fe-delete",Fi="e-icons e-fe-rename",Ui="e-icons e-fe-newfolder",Vi="e-icons e-fe-details",_i="e-icons e-fe-sort",Bi="e-icons e-fe-refresh",Hi="e-icons e-fe-select",zi="e-icons e-fe-download",qi="e-icons e-fe-grid",Wi="e-icons e-fe-large",Ki="e-icons e-fe-breadcrumb",Gi="e-icons e-fe-clear",Yi="e-icons",Qi="e-fe-errorcontent",Ji="e-display-none",Xi="e-fullrow",$i="e-split-bar",Zi="e-headercheck",en="e-fe-value",tn="isFile",nn="model-changed",sn="initial-end",an="finalize-end",rn="create-end",on="filter-end",ln="path-drag",hn="delete-init",dn="delete-end",pn="refresh-end",cn="resize-end",un="splitter-resize",fn="path-changed",gn="destroy",mn="before-request",bn="skip-upload",yn="after-request",vn="layout-refresh",On="actionFailure",In="search",wn="open-init",Dn="open-end",Sn="selection-changed",Cn="select-all-init",jn="clear-all-init",xn="clear-path-init",Nn="layout-change",Pn="sort-by-change",En="node-expand",Rn="details-init",Mn="menu-item-data",kn="rename-init",Ln="rename-end-parent",Tn="rename-end",An="show-paste",Fn="hide-paste",Un="selected-data",Vn="cut-copy-init",_n="paste-init",Bn="paste-end",Hn="cut-end",zn="hide-layout",qn="update-tree-selection",Wn="sort-column",Kn="path-column",Gn="search-change",Yn="download-init",Qn="drop-init",Jn="drag-end",Xn="drop-path",$n="dragging",Zn="update-selection-data",es="method-call",ts="read",is="write",ns="writeContents",ss="upload",as="download",rs=function(){function e(e){this.isInteraction=!0,this.uploadOperation=!1,this.count=0,this.isRendered=!0,this.tapCount=0,this.isPasteOperation=!1,this.isInteracted=!0,this.parent=e,this.element=t.select("#"+this.parent.element.id+kt,this.parent.element),t.addClass([this.element],Xt),this.addEventListener(),this.keyConfigs={end:"end",home:"home",tab:"tab",moveDown:"downarrow",moveLeft:"leftarrow",moveRight:"rightarrow",moveUp:"uparrow",ctrlEnd:"ctrl+end",ctrlHome:"ctrl+home",ctrlDown:"ctrl+downarrow",ctrlLeft:"ctrl+leftarrow",ctrlRight:"ctrl+rightarrow",ctrlUp:"ctrl+uparrow",shiftEnd:"shift+end",shiftHome:"shift+home",shiftDown:"shift+downarrow",shiftLeft:"shift+leftarrow",shiftRight:"shift+rightarrow",shiftUp:"shift+uparrow",csEnd:"ctrl+shift+end",csHome:"ctrl+shift+home",csDown:"ctrl+shift+downarrow",csLeft:"ctrl+shift+leftarrow",csRight:"ctrl+shift+rightarrow",csUp:"ctrl+shift+uparrow",space:"space",ctrlSpace:"ctrl+space",shiftSpace:"shift+space",csSpace:"ctrl+shift+space",ctrlA:"ctrl+a",enter:"enter",altEnter:"alt+enter",esc:"escape",del:"delete",ctrlX:"ctrl+x",ctrlC:"ctrl+c",ctrlV:"ctrl+v",f2:"f2",shiftdel:"shift+delete",back:"backspace",ctrlD:"ctrl+d"}}return e.prototype.render=function(e){if(this.parent.visitedItem=null,this.startItem=null,n.showSpinner(this.parent.element),"LargeIcons"===this.parent.view){this.resetMultiSelect(),this.element.setAttribute("tabindex","0"),this.listObj&&(this.unWireEvents(),this.removeEventListener()),this.parent.notify(zn,{});var i=t.select("#"+this.parent.element.id+kt,this.parent.element),s=t.select("ul",i);if(s&&t.remove(s),this.listObj={ariaAttributes:{itemRole:"option",listRole:"listbox",itemText:"",groupItemRole:"group",wrapperRole:""},showIcon:!0,fields:{text:"name",iconCss:"_fm_icon",imageUrl:"_fm_imageUrl",htmlAttributes:"_fm_htmlAttr"},sortOrder:this.parent.sortOrder,itemCreated:this.onItemCreated.bind(this),enableHtmlSanitizer:this.parent.enableHtmlSanitizer},this.items=[],this.items=this.renderList(e),this.items=R(this.parent,this.items),this.listElements=o.ListBase.createListFromJson(t.createElement,this.items,this.listObj),this.itemList=Array.prototype.slice.call(t.selectAll("."+Zt,this.listElements)),this.element.appendChild(this.listElements),this.preventImgDrag(),this.createDragObj(),i.classList.remove(Ji),0===this.itemList.length){var a=this.element.querySelector("."+ti);this.element.removeChild(a),k(this.parent,this.element,e)}else 0!==this.itemList.length&&this.element.querySelector("."+ci)&&this.element.removeChild(this.element.querySelector("."+ci));!0===this.isPasteOperation&&(this.selectItems(this.parent.pasteNodes),this.isPasteOperation=!1),!0===this.uploadOperation&&(this.selectItems(this.parent.uploadItem),this.parent.setProperties({selectedItems:[]},!0),this.count++,this.count===this.parent.uploadItem.length&&(this.uploadOperation=!1,this.parent.uploadItem=[]));var r=this.element.querySelectorAll("."+ai);0!==r.length&&(this.parent.activeModule="largeiconsview");for(var l=0;l<r.length;l++)r[l].setAttribute("aria-selected","true");this.adjustHeight(),this.element.style.maxHeight="100%",this.getItemCount(),this.addEventListener(),this.wireEvents(),this.isRendered=!0,n.hideSpinner(this.parent.element),this.parent.selectedItems.length&&this.checkItem()}},e.prototype.preventImgDrag=function(){for(var e=0;e<this.itemList.length;)this.itemList[e].querySelector("img")&&(this.itemList[e].ondragstart=function(){return!1}),e++},e.prototype.createDragObj=function(){var e=this;!this.parent.isMobile&&this.listObj&&(this.parent.allowDragAndDrop?(this.dragObj&&this.dragObj.destroy(),this.dragObj=new t.Draggable(this.listElements,{enableTailMode:!0,distance:5,enableAutoScroll:!0,dragTarget:"."+wi,helper:this.dragHelper.bind(this),cursorAt:this.parent.dragCursorPosition,dragArea:this.parent.element,dragStop:G.bind(this,this.parent),drag:$.bind(this,this.parent),clone:!0,dragStart:function(t){Y(e.parent,t,e.dragObj)}})):this.dragObj&&!this.parent.allowDragAndDrop&&this.dragObj.destroy())},e.prototype.dragHelper=function(e){var i=e.sender.target,n=t.closest(i,".e-list-item");if(!n)return null;n&&!n.classList.contains("e-active")&&this.setFocus(n);var s=this.element.querySelectorAll("."+ai);this.parent.activeElements=[],this.parent.dragData=[];for(var a=0;a<s.length;a++)this.parent.dragData.push(this.getItemObject(s[a])),this.parent.activeElements.push(s[a]);return y(this.parent,n),this.parent.dragPath=this.parent.path,K(this.parent),this.parent.virtualDragElement},e.prototype.onDropInit=function(e){if(this.parent.targetModule===this.getModuleName()){var i=t.closest(e.target,".e-list-item"),n=t.getValue(this.parent.pathId[this.parent.pathId.length-1],this.parent.feParent);if(i){var s=this.getItemObject(i);this.parent.dropPath=s.isFile?this.parent.path:P(this.parent,s,this.parent.path),this.parent.dropData=s.isFile?n:s}else this.parent.dropPath=this.parent.path,this.parent.dropData=n}},e.prototype.getModuleName=function(){return"largeiconsview"},e.prototype.adjustHeight=function(){var e=t.select("#"+this.parent.element.id+Vt,this.parent.element),i=t.select("#"+this.parent.element.id+_t,this.parent.element);this.element.style.height=e.offsetHeight-i.offsetHeight+"px"},e.prototype.onItemCreated=function(e){if(e.item.removeAttribute("aria-level"),!this.parent.showFileExtension&&t.getValue("isFile",e.curData)){var i=e.item.querySelector("."+ei),n=t.getValue("name",e.curData),s=t.getValue("type",e.curData);i.innerHTML=n.substr(0,n.length-s.length)}this.renderCheckbox(e);var a={element:e.item,fileDetails:e.curData,module:"LargeIconsView"};this.parent.trigger("fileLoad",a)},e.prototype.renderCheckbox=function(e){if(this.parent.allowMultiSelection){var i=r.createCheckBox(t.createElement,!1,{checked:!1,cssClass:"e-small"});i.setAttribute("role","checkbox"),i.setAttribute("aria-checked","false"),e.item.firstElementChild.insertBefore(i,e.item.firstElementChild.childNodes[0])}},e.prototype.onLayoutChange=function(e){if("LargeIcons"===this.parent.view){if(this.destroy(),this.render(e),"layout-change"===t.getValue("name",e)&&"move"===this.parent.fileAction&&this.parent.isCut&&this.parent.selectedNodes&&0!==this.parent.selectedNodes.length)for(var i=this.getIndexes(this.parent.selectedNodes),n=0;n<i.length;)m(this.itemList[i[n]]),n++;0!==this.element.querySelectorAll("."+ai).length&&this.element.focus(),this.checkItem(),this.parent.isLayoutChange=!1}else this.element.setAttribute("tabindex","-1")},e.prototype.checkItem=function(){var e=this.element.querySelectorAll("."+ai);if(e)for(var t=0;t<e.length;)this.checkState(e[t],!0),t++},e.prototype.renderList=function(e){for(var i=0,n=JSON.parse(JSON.stringify(e.files));i<n.length;){var s=x(n[i]),a=t.getValue("name",n[i]),r=Z(this.parent,n[i]),o=this.parent.selectedItems&&-1!==this.parent.selectedItems.indexOf(r)?wi+" e-active":wi;if(le(n[i])||(o+=" "+re(n[i])),s===vi&&this.parent.showThumbnail&&oe(n[i])){var l=N(this.parent,n[i]);t.setValue("_fm_imageUrl",l,n[i]),t.setValue("_fm_imageAttr",{alt:a},n[i])}else t.setValue("_fm_icon",s,n[i]);t.setValue("_fm_htmlAttr",{class:o,title:a},n[i]),i++}return n},e.prototype.onFinalizeEnd=function(e){this.render(e)},e.prototype.onCreateEnd=function(e){"LargeIcons"===this.parent.view&&(this.onLayoutChange(e),this.clearSelect(),this.selectItems([t.getValue(this.parent.hasId?"id":"name",this.parent.createdItem)]),this.parent.createdItem=null,this.parent.largeiconsviewModule.element.focus())},e.prototype.onSelectedData=function(){"largeiconsview"===this.parent.activeModule&&this.updateSelectedData()},e.prototype.onDeleteInit=function(){"largeiconsview"===this.parent.activeModule&&ve(this.parent,this.parent.selectedItems,this.parent.path,"delete")},e.prototype.onDeleteEnd=function(e){"LargeIcons"===this.parent.view&&(this.onLayoutChange(e),this.parent.setProperties({selectedItems:[]},!0),this.clearSelect())},e.prototype.onRefreshEnd=function(e){"LargeIcons"===this.parent.view&&this.onLayoutChange(e)},e.prototype.onRenameInit=function(){"largeiconsview"===this.parent.activeModule&&1===this.parent.selectedItems.length&&this.updateRenameData()},e.prototype.onPathChanged=function(e){this.parent.isCut=!1,""===this.parent.breadcrumbbarModule.searchObj.element.value&&(this.parent.searchedItems=[]),"LargeIcons"===this.parent.view&&(b(this.parent),this.parent.setProperties({selectedItems:[]},!0),this.onLayoutChange(e),this.parent.renamedItem&&(this.clearSelect(),this.addSelection(this.parent.renamedItem),this.parent.renamedItem=null))},e.prototype.onOpenInit=function(e){"largeiconsview"===this.parent.activeModule&&this.doOpenAction(e.target)},e.prototype.onHideLayout=function(){"LargeIcons"!==this.parent.view&&this.element&&this.element.classList.add(Ji)},e.prototype.onSelectAllInit=function(){if("LargeIcons"===this.parent.view){this.startItem=this.getFirstItem();var e=this.getLastItem();this.doSelection(e,{ctrlKey:!0,shiftKey:!0}),this.isInteraction=!0,this.isInteracted=!0}},e.prototype.onClearAllInit=function(){"LargeIcons"===this.parent.view&&(this.clearSelection(),this.isInteraction=!0,this.isInteracted=!0)},e.prototype.onBeforeRequest=function(){this.isRendered=!1},e.prototype.onAfterRequest=function(){this.isRendered=!0},e.prototype.onSearch=function(e){"LargeIcons"===this.parent.view&&(this.parent.setProperties({selectedItems:[]},!0),this.parent.notify(Sn,{}),this.parent.searchedItems=e.files,this.onLayoutChange(e))},e.prototype.onLayoutRefresh=function(){"LargeIcons"===this.parent.view&&this.adjustHeight()},e.prototype.onUpdateSelectionData=function(){"LargeIcons"===this.parent.view&&this.updateSelectedData()},e.prototype.onPathColumn=function(){"LargeIcons"!==this.parent.view||t.isNullOrUndefined(this.listObj)||""!==this.parent.breadcrumbbarModule.searchObj.element.value||this.parent.isFiltered||"filterPath"!==this.parent.sortBy||(this.parent.sortBy="name",this.parent.notify(Pn,{}))},e.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(Kn,this.onPathColumn),this.parent.off(an,this.onFinalizeEnd),this.parent.off(rn,this.onCreateEnd),this.parent.off(Un,this.onSelectedData),this.parent.off(hn,this.onDeleteInit),this.parent.off(dn,this.onDeleteEnd),this.parent.off(pn,this.onRefreshEnd),this.parent.off(fn,this.onPathChanged),this.parent.off(Nn,this.onLayoutChange),this.parent.off(In,this.onSearch),this.parent.off(wn,this.onOpenInit),this.parent.off(Dn,this.onPathChanged),this.parent.off(nn,this.onPropertyChanged),this.parent.off(es,this.onMethodCall),this.parent.off(On,this.onActionFailure),this.parent.off(kn,this.onRenameInit),this.parent.off(Tn,this.onPathChanged),this.parent.off(zn,this.onHideLayout),this.parent.off(Cn,this.onSelectAllInit),this.parent.off(jn,this.onClearAllInit),this.parent.off(Mn,this.onMenuItemData),this.parent.off(mn,this.onBeforeRequest),this.parent.off(yn,this.onAfterRequest),this.parent.off(un,this.splitterResizeHandler),this.parent.off(cn,this.resizeHandler),this.parent.off(_n,this.onpasteInit),this.parent.off(Bn,this.onpasteEnd),this.parent.off(Vn,this.oncutCopyInit),this.parent.off(Qn,this.onDropInit),this.parent.off(Rn,this.onDetailsInit),this.parent.off(vn,this.onLayoutRefresh),this.parent.off(Xn,this.onDropPath),this.parent.off(Zn,this.onUpdateSelectionData),this.parent.off(on,this.onPathChanged))},e.prototype.addEventListener=function(){this.parent.on(Kn,this.onPathColumn,this),this.parent.on(an,this.onFinalizeEnd,this),this.parent.on(rn,this.onCreateEnd,this),this.parent.on(pn,this.onRefreshEnd,this),this.parent.on(Un,this.onSelectedData,this),this.parent.on(fn,this.onPathChanged,this),this.parent.on(hn,this.onDeleteInit,this),this.parent.on(_n,this.onpasteInit,this),this.parent.on(dn,this.onDeleteEnd,this),this.parent.on(Nn,this.onLayoutChange,this),this.parent.on(In,this.onSearch,this),this.parent.on(wn,this.onOpenInit,this),this.parent.on(kn,this.onRenameInit,this),this.parent.on(Tn,this.onPathChanged,this),this.parent.on(Dn,this.onPathChanged,this),this.parent.on(nn,this.onPropertyChanged,this),this.parent.on(es,this.onMethodCall,this),this.parent.on(On,this.onActionFailure,this),this.parent.on(zn,this.onHideLayout,this),this.parent.on(Cn,this.onSelectAllInit,this),this.parent.on(jn,this.onClearAllInit,this),this.parent.on(Mn,this.onMenuItemData,this),this.parent.on(mn,this.onBeforeRequest,this),this.parent.on(yn,this.onAfterRequest,this),this.parent.on(Qn,this.onDropInit,this),this.parent.on(Rn,this.onDetailsInit,this),this.parent.on(un,this.splitterResizeHandler,this),this.parent.on(cn,this.resizeHandler,this),this.parent.on(Bn,this.onpasteEnd,this),this.parent.on(Vn,this.oncutCopyInit,this),this.parent.on(vn,this.onLayoutRefresh,this),this.parent.on(Xn,this.onDropPath,this),this.parent.on(Zn,this.onUpdateSelectionData,this),this.parent.on(on,this.onPathChanged,this)},e.prototype.onActionFailure=function(){this.isInteraction=!0,this.isInteracted=!0},e.prototype.onMenuItemData=function(e){if(this.parent.activeModule===this.getModuleName()){var i=t.closest(e.target,"li");this.parent.itemData=[this.getItemObject(i)]}},e.prototype.onDetailsInit=function(){this.parent.activeModule===this.getModuleName()&&(0!==this.parent.selectedItems.length?this.updateSelectedData():this.parent.itemData=[t.getValue(this.parent.pathId[this.parent.pathId.length-1],this.parent.feParent)])},e.prototype.onpasteInit=function(){this.parent.activeModule===this.getModuleName()&&(this.parent.itemData=""===this.parent.folderPath?[S(this.parent)]:[this.getItemObject(t.select(".e-active",this.element))])},e.prototype.oncutCopyInit=function(){if(this.parent.activeModule===this.getModuleName()){var e=this.element.querySelectorAll("."+ai);this.parent.activeRecords=[],this.parent.activeElements=[];for(var t=0;t<e.length;t++)this.parent.activeElements.push(e[t]),this.parent.activeRecords.push(this.getItemObject(e[t]))}},e.prototype.onpasteEnd=function(e){"LargeIcons"===this.parent.view&&(this.isPasteOperation=!0,this.parent.path!==this.parent.destinationPath&&this.parent.path!==z(this.parent,e)||this.onPathChanged(e))},e.prototype.onDropPath=function(e){"LargeIcons"===this.parent.view&&(this.isPasteOperation=!0,this.onPathChanged(e))},e.prototype.onPropertyChanged=function(e){var i;if(e.module===this.getModuleName()||"common"===e.module)for(var n=0,s=Object.keys(e.newProp);n<s.length;n++){switch(s[n]){case"allowDragAndDrop":this.createDragObj();break;case"height":this.adjustHeight();break;case"selectedItems":this.isInteraction=!1,this.isInteracted=!1,i=t.isNullOrUndefined(this.parent.selectedItems)?[]:this.parent.selectedItems.slice(0),i=this.parent.allowMultiSelection?i:i.slice(i.length-1),this.parent.setProperties({selectedItems:[]},!0),this.onClearAllInit(),i.length&&this.selectItems(i),this.parent.setProperties({selectedItems:this.parent.selectedItems},!0),this.isInteraction=!0,this.isInteracted=!0;break;case"showThumbnail":w(this.parent);break;case"showFileExtension":case"showHiddenItems":fe(this.parent,fn,this.parent.path);break;case"allowMultiSelection":if("LargeIcons"!==this.parent.view)break;w(this.parent);break;case"view":O(this.parent,"LargeIcons")}}},e.prototype.destroy=function(){this.parent.isDestroyed||(this.removeEventListener(),this.listObj&&this.unWireEvents())},e.prototype.wireEvents=function(){this.wireClickEvent(!0),this.keyboardModule=new t.KeyboardEvents(this.element,{keyAction:this.keyActionHandler.bind(this),keyConfigs:this.keyConfigs,eventName:"keyup"}),this.keyboardDownModule=new t.KeyboardEvents(this.element,{keyAction:this.keydownActionHandler.bind(this),keyConfigs:this.keyConfigs,eventName:"keydown"}),t.EventHandler.add(this.element,"mouseover",this.onMouseOver,this)},e.prototype.unWireEvents=function(){this.wireClickEvent(!1),t.EventHandler.remove(this.element,"mouseover",this.onMouseOver),this.keyboardModule.destroy(),this.keyboardDownModule.destroy()},e.prototype.onMouseOver=function(e){var i=t.closest(e.target,".e-list-item");b(this.parent,"hover"),null!==i&&i.classList.add(ri)},e.prototype.wireClickEvent=function(e){if(e){var i=this;this.clickObj=new t.Touch(this.element,{tap:function(e){e.originalEvent.preventDefault(),i.parent.isDevice?(i.tapCount=e.tapCount,i.tapEvent=e,setTimeout(function(){i.tapCount>0&&i.doTapAction(i.tapEvent),i.tapCount=0},350)):2===e.tapCount&&3!==e.originalEvent.which?i.dblClickHandler(e):i.clickHandler(e)},tapHold:function(e){i.parent.isDevice&&(i.multiSelect=!!i.parent.allowMultiSelection,i.parent.allowMultiSelection&&t.addClass([i.parent.element],Yt),i.clickHandler(e))}})}else this.clickObj&&this.clickObj.destroy()},e.prototype.doTapAction=function(e){var i=e.originalEvent.target,n=t.closest(i,"."+Zt);this.multiSelect||i.classList.contains(ti)||t.isNullOrUndefined(n)?this.clickHandler(e):(this.parent.isFile=!1,this.updateType(n),this.parent.isFile?2===e.tapCount?(this.clickHandler(e),this.dblClickHandler(e)):this.clickHandler(e):this.dblClickHandler(e))},e.prototype.clickHandler=function(e){var t=e.originalEvent.target;b(this.parent,"hover"),this.doSelection(t,e.originalEvent),this.parent.activeModule="largeiconsview"},e.prototype.doSelection=function(e,i){var n=t.closest(e,"."+Zt),s=e.classList;this.parent.isFile=!1;var a="select";if(3!==i.which||t.isNullOrUndefined(n)||!n.classList.contains(ai)){if(t.isNullOrUndefined(n))this.clearSelection();else{this.parent.allowMultiSelection&&n.classList.contains(ai)&&(i.ctrlKey||e.classList.contains(hi))&&(a="unselect");if(!0!==this.triggerSelection(a,n).cancel){if(this.parent.allowMultiSelection&&(this.multiSelect||!i||i.ctrlKey)||s.contains("e-frame")||(this.updateType(n),this.clearSelect()),this.parent.allowMultiSelection&&i.shiftKey){i&&i.ctrlKey||this.clearSelect(),this.startItem||(this.startItem=n);var r=this.itemList.indexOf(this.startItem),o=this.itemList.indexOf(n);if(r>o)for(var l=r;l>=o;l--)this.addActive(this.itemList[l]);else for(l=r;l<=o;l++)this.addActive(this.itemList[l]);this.addFocus(this.itemList[o])}else this.startItem=n,this.parent.allowMultiSelection&&n.classList.contains(ai)?this.removeActive(n):this.addActive(n),this.addFocus(n);0===this.parent.selectedItems.length&&this.resetMultiSelect(),this.parent.notify(Sn,{}),this.triggerSelect(a,n)}}t.isNullOrUndefined(n)||this.updateType(n)}else this.updateType(n)},e.prototype.dblClickHandler=function(e){this.parent.activeModule="largeiconsview";var t=e.originalEvent.target;this.doOpenAction(t)},e.prototype.clearSelection=function(){this.clearSelect(),this.resetMultiSelect(),this.parent.notify(Sn,{})},e.prototype.resetMultiSelect=function(){this.multiSelect=!1,t.removeClass([this.parent.element],Yt)},e.prototype.doOpenAction=function(e){var i=this;if(!t.isNullOrUndefined(e)){var n=t.closest(e,"."+Zt);if(this.parent.isFile=!1,!t.isNullOrUndefined(n)){this.updateType(n);var s=this.getItemObject(n);if(!oe(s))return void ae(this.parent,s,ts);var a={cancel:!1,fileDetails:s,module:"LargeIconsView"};this.parent.trigger("fileOpen",a,function(e){if(!e.cancel){var n=t.getValue("name",s);if(i.parent.isFile){if(x(s)===vi){var a=N(i.parent,s);$e(i.parent,n,a)}}else{if(""!==i.parent.breadcrumbbarModule.searchObj.element.value||i.parent.isFiltered)V(i.parent,s);else{var r=t.getValue("id",s),o=i.parent.path+(t.isNullOrUndefined(r)?n:r)+"/";i.parent.setProperties({path:o},!0),i.parent.pathNames.push(n),i.parent.pathId.push(t.getValue("_fm_id",s)),i.parent.itemData=[s],D(i.parent)}i.parent.isFiltered=!1,i.parent.setProperties({selectedItems:[]},!0)}}})}}},e.prototype.updateType=function(e){var i=t.select("."+yi,e);this.parent.isFile=!!t.isNullOrUndefined(i)},e.prototype.keydownActionHandler=function(e){if(this.isRendered)switch(e.action){case"end":case"home":case"moveDown":case"moveLeft":case"moveRight":case"moveUp":case"ctrlEnd":case"shiftEnd":case"csEnd":case"ctrlHome":case"shiftHome":case"csHome":case"ctrlDown":case"shiftDown":case"csDown":case"ctrlLeft":case"shiftLeft":case"csLeft":case"ctrlRight":case"shiftRight":case"csRight":case"space":case"ctrlSpace":case"shiftSpace":case"csSpace":case"ctrlA":case"enter":case"altEnter":case"esc":case"del":case"shiftdel":case"ctrlC":case"ctrlV":case"ctrlX":case"f2":case"ctrlD":e.preventDefault()}},e.prototype.keyActionHandler=function(e){if(this.isRendered){var i=this.getFocusedItem(),n=this.getFirstItem(),s=this.getLastItem();switch(e.action){case"end":this.navigateItem(s);break;case"home":this.navigateItem(n);break;case"tab":t.isNullOrUndefined(i)?t.isNullOrUndefined(n)||this.addFocus(n):this.addFocus(i);break;case"moveDown":this.navigateDown(i,!0);break;case"moveLeft":this.navigateRight(i,!1);break;case"moveRight":this.navigateRight(i,!0);break;case"moveUp":this.navigateDown(i,!1);break;case"ctrlEnd":case"shiftEnd":case"csEnd":this.csEndKey(s,e);break;case"ctrlHome":case"shiftHome":case"csHome":this.csHomeKey(n,e);break;case"ctrlDown":case"shiftDown":case"csDown":this.csDownKey(i,e);break;case"ctrlLeft":case"shiftLeft":case"csLeft":this.csLeftKey(i,e);break;case"ctrlRight":case"shiftRight":case"csRight":this.csRightKey(i,e);break;case"ctrlUp":case"shiftUp":case"csUp":this.csUpKey(i,e);break;case"space":this.spaceKey(i);break;case"ctrlSpace":case"shiftSpace":case"csSpace":t.isNullOrUndefined(i)||this.doSelection(i,e);break;case"ctrlA":this.ctrlAKey(n,s);break;case"enter":this.doOpenAction(this.parent.visitedItem?this.parent.visitedItem:this.getVisitedItem());break;case"altEnter":this.parent.notify(Rn,{}),Oe(this.parent,this.parent.selectedItems,this.parent.path,"details");break;case"esc":f(this.parent);break;case"del":case"shiftdel":this.performDelete();break;case"ctrlC":C(this.parent);break;case"ctrlV":this.parent.folderPath="",_(this.parent);break;case"ctrlX":j(this.parent);break;case"f2":this.performRename();break;case"ctrlD":this.doDownload()}}},e.prototype.doDownload=function(){this.updateSelectedData(),ie(this.parent)},e.prototype.performDelete=function(){if(this.parent.selectedItems&&this.parent.selectedItems.length>0){this.updateSelectedData();for(var e=this.parent.itemData,t=0;t<e.length;t++)if(!le(e[t]))return void ae(this.parent,e[t],is);Le(this.parent,"Delete")}},e.prototype.performRename=function(){1===this.parent.selectedItems.length&&(this.updateRenameData(),te(this.parent))},e.prototype.updateRenameData=function(){var e=t.select("."+Zt+"."+ai,this.element),i=this.getItemObject(e);ee(this.parent,i)},e.prototype.getVisitedItem=function(){var e=this.parent.selectedItems[this.parent.selectedItems.length-1],t=this.getIndexes([e],this.parent.hasId);return this.itemList[t[0]]},e.prototype.getFocusedItem=function(){return t.select("."+Zt+"."+oi,this.element)},e.prototype.getActiveItem=function(){return t.select("."+Zt+"."+ai,this.element)},e.prototype.getFirstItem=function(){return this.itemList[0]},e.prototype.getLastItem=function(){return this.itemList[this.itemList.length-1]},e.prototype.navigateItem=function(e){this.setFocus(e)},e.prototype.navigateDown=function(e,t){var i=this.getNextItem(e,t,this.perRow);this.setFocus(i)},e.prototype.navigateRight=function(e,t){var i=this.getNextItem(e,t);this.setFocus(i)},e.prototype.getNextItem=function(e,i,n){if(t.isNullOrUndefined(e))return this.getFocusedItem()||this.getActiveItem()||this.getFirstItem();var s,a=this.itemList.indexOf(e);do{if(a=i?n?a+n:a+1:n?a-n:a-1,s=this.itemList[a],t.isNullOrUndefined(s))return e}while(!t.isVisible(s));return s},e.prototype.setFocus=function(e){if(!t.isNullOrUndefined(e)){!0!==this.triggerSelection("select",e).cancel&&(this.startItem=e,this.clearSelect(),this.addActive(e),this.addFocus(e),this.parent.notify(Sn,{}),this.triggerSelect("select",e))}},e.prototype.spaceKey=function(e){if(!t.isNullOrUndefined(e)&&!e.classList.contains(ai)){!0!==this.triggerSelection("select",e).cancel&&(this.addActive(e),this.parent.notify(Sn,{}),this.triggerSelect("select",e))}},e.prototype.ctrlAKey=function(e,i){if(this.parent.allowMultiSelection&&!t.isNullOrUndefined(e)){this.startItem=e;var n=this.element.querySelector("."+ti),s=n.scrollTop,a=this.getFocusedItem();this.doSelection(i,{ctrlKey:!0,shiftKey:!0}),n.scrollTop=s,t.isNullOrUndefined(a)||this.addFocus(a)}},e.prototype.csEndKey=function(e,i){this.parent.allowMultiSelection?t.isNullOrUndefined(e)||("ctrlEnd"===i.action?this.addFocus(e):this.doSelection(e,i)):this.navigateItem(e)},e.prototype.csHomeKey=function(e,i){this.parent.allowMultiSelection?t.isNullOrUndefined(e)||("ctrlHome"===i.action?this.addFocus(e):this.doSelection(e,i)):this.navigateItem(e)},e.prototype.csDownKey=function(e,i){if(this.parent.allowMultiSelection){var n=this.getNextItem(e,!0,this.perRow);t.isNullOrUndefined(n)||("ctrlDown"===i.action?this.addFocus(n):this.doSelection(n,i))}else this.navigateDown(e,!0)},e.prototype.csLeftKey=function(e,i){if(this.parent.allowMultiSelection){var n=this.getNextItem(e,!1);t.isNullOrUndefined(n)||("ctrlLeft"===i.action?this.addFocus(n):this.doSelection(n,i))}else this.navigateRight(e,!1)},e.prototype.csRightKey=function(e,i){if(this.parent.allowMultiSelection){var n=this.getNextItem(e,!0);t.isNullOrUndefined(n)||("ctrlRight"===i.action?this.addFocus(n):this.doSelection(n,i))}else this.navigateRight(e,!0)},e.prototype.csUpKey=function(e,i){if(this.parent.allowMultiSelection){var n=this.getNextItem(e,!1,this.perRow);t.isNullOrUndefined(n)||("ctrlUp"===i.action?this.addFocus(n):this.doSelection(n,i))}else this.navigateDown(e,!1)},e.prototype.addActive=function(e){t.isNullOrUndefined(e)||(e.classList.contains(ai)||(this.parent.selectedItems.push(this.getDataName(e)),this.parent.setProperties({selectedItems:this.parent.selectedItems},!0),t.addClass([e],[ai]),e.setAttribute("aria-selected","true"),this.checkState(e,!0)),this.parent.visitedItem=e)},e.prototype.removeActive=function(e){if(!t.isNullOrUndefined(e)){t.removeClass([e],[ai]),this.parent.allowMultiSelection?e.setAttribute("aria-selected","false"):e.removeAttribute("aria-selected"),this.checkState(e,!1);var i=this.parent.selectedItems.indexOf(this.getDataName(e));i>-1&&(this.parent.selectedItems.splice(i,1),this.parent.setProperties({selectedItems:this.parent.selectedItems},!0)),this.parent.visitedItem=null}},e.prototype.getDataName=function(e){var t=this.getItemObject(e);return Z(this.parent,t)},e.prototype.addFocus=function(e){this.element.setAttribute("tabindex","-1");var i=this.getFocusedItem();i&&(i.removeAttribute("tabindex"),t.removeClass([i],[oi])),t.addClass([e],[oi]),e.setAttribute("tabindex","0"),e.focus()},e.prototype.checkState=function(e,i){if(this.parent.allowMultiSelection){var n=t.select(".e-frame",e);t.isNullOrUndefined(n)||(i?n.classList.contains(hi)||(t.addClass([n],hi),t.closest(n,"."+di).setAttribute("aria-checked","true")):n.classList.contains(hi)&&(t.removeClass([n],hi),t.closest(n,"."+di).setAttribute("aria-checked","false")))}},e.prototype.clearSelect=function(){var e=Array.prototype.slice.call(t.selectAll("."+ai,this.listElements));if(0!==e.length){if(!0!==this.triggerSelection("unselect",e[0]).cancel)for(var i=0,n=e.length;i<n;i++)this.removeActive(e[i]);this.triggerSelect("unselect",e[0])}},e.prototype.resizeHandler=function(){this.getItemCount(),t.isNullOrUndefined(this.listObj)||this.adjustHeight()},e.prototype.splitterResizeHandler=function(){this.getItemCount()},e.prototype.getItemCount=function(){var e=1;if(this.itemList)for(var t=0,i=this.itemList.length-1;t<i&&this.itemList[t].getBoundingClientRect().top===this.itemList[t+1].getBoundingClientRect().top;t++)e++;this.perRow=e},e.prototype.triggerSelection=function(e,t){var i={action:e,fileDetails:this.getItemObject(t),isInteracted:this.isInteraction,cancel:!1,target:t};return this.parent.trigger("fileSelection",i),this.isInteraction=!0,i},e.prototype.triggerSelect=function(e,t){var i=this.getItemObject(t);this.parent.visitedData=i;var n={action:e,fileDetails:i,isInteracted:this.isInteracted};this.parent.trigger("fileSelect",n),this.isInteracted=!0},e.prototype.selectItems=function(e){for(var t=this.getIndexes(e,this.parent.hasId),i=0,n=t.length;i<n;i++){this.doSelection(this.itemList[t[i]],{ctrlKey:!0,shiftKey:!1})}},e.prototype.getIndexes=function(e,i){for(var n=[],s=i?"id":"name",a=0,r=this.items.length;a<r;a++)-1!==e.indexOf(t.getValue(s,this.items[a]))&&n.push(a);return n},e.prototype.getItemObject=function(e){var t=this.itemList.indexOf(e);return this.items[t]},e.prototype.addSelection=function(e){var i=[];if(this.parent.hasId)i=new s.DataManager(this.items).executeLocal((new s.Query).where("id","equal",this.parent.renamedId,!1));else{var n=new s.DataManager(this.items).executeLocal((new s.Query).where("name","equal",t.getValue("name",e),!1));n.length>0&&(i=new s.DataManager(n).executeLocal((new s.Query).where("filterPath","equal",this.parent.filterPath,!1)))}if(i.length>0){var a=this.items.indexOf(i[0]);this.doSelection(this.itemList[a],{ctrlKey:!0,shiftKey:!1})}},e.prototype.updateSelectedData=function(){for(var e=[],i=t.selectAll("."+Zt+"."+ai,this.element),n=0;n<i.length;n++)e[n]=this.getItemObject(i[n]);this.parent.itemData=e},e.prototype.onMethodCall=function(e){if("LargeIcons"===this.parent.view){switch(t.getValue("action",e)){case"deleteFiles":this.deleteFiles(t.getValue("ids",e));break;case"downloadFiles":this.downloadFiles(t.getValue("ids",e));break;case"openFile":this.openFile(t.getValue("id",e));break;case"renameFile":this.isInteraction=!1,this.isInteracted=!1,this.renameFile(t.getValue("id",e),t.getValue("newName",e));break;case"createFolder":this.isInteraction=!1,this.isInteracted=!1;break;case"clearSelection":this.isInteraction=!1,this.isInteracted=!1,this.onClearAllInit();break;case"selectAll":this.isInteraction=!1,this.isInteracted=!1,this.onSelectAllInit()}}},e.prototype.getItemsIndex=function(e){var i=[],n=!(""===this.parent.breadcrumbbarModule.searchObj.element.value&&!this.parent.isFiltered),s=this.parent.hasId?"id":"name";if(this.parent.hasId||!n)for(var a=0,r=this.items.length;a<r;a++)-1!==e.indexOf(t.getValue(s,this.items[a]))&&i.push(a);else for(a=0,r=this.items.length;a<r;a++){var o=t.getValue("filterPath",this.items[a])+t.getValue("name",this.items[a]);-1!==e.indexOf(o)&&i.push(a)}return i},e.prototype.deleteFiles=function(e){if(this.parent.activeModule="largeiconsview",t.isNullOrUndefined(e))this.performDelete();else{var i=this.getItemsIndex(e);if(0!==i.length){for(var n=[],s=[],a=0;a<i.length;a++)n[a]=this.items[i[a]],s[a]=Z(this.parent,n[a]);ne(this.parent,n,s)}}},e.prototype.downloadFiles=function(e){if(t.isNullOrUndefined(e))this.doDownload();else{var i=this.getItemsIndex(e);if(0!==i.length){for(var n=[],s=[],a=0;a<i.length;a++)n[a]=this.items[i[a]],s[a]=Z(this.parent,n[a]);se(this.parent,n,s)}}},e.prototype.openFile=function(e){if(!t.isNullOrUndefined(e)){var i=this.getItemsIndex([e]);i.length>0&&this.doOpenAction(this.itemList[i[0]])}},e.prototype.renameFile=function(e,i){if(this.parent.activeModule="largeiconsview",t.isNullOrUndefined(e))this.performRename();else{var n=this.getItemsIndex([e]);n.length>0&&(ee(this.parent,this.items[n[0]]),t.isNullOrUndefined(i)?te(this.parent):le(this.parent.itemData[0])?be(this.parent,this.parent.path,i):ae(this.parent,this.parent.itemData[0],is))}},e}(),os=function(){function e(e){this.addressPath="",this.addressBarLink="",this.searchTimer=null,this.searchWrapWidth=null,this.parent=e,this.keyConfigs={enter:"enter"},this.render()}return e.prototype.onPropertyChanged=function(e){if(e.module===this.getModuleName()||"common"===e.module)for(var i=0,n=Object.keys(e.newProp);i<n.length;i++){var s=n[i],a=e.newProp.searchSettings;switch(s){case"searchSettings":t.isNullOrUndefined(a.allowSearchOnTyping)||this.searchEventBind(a.allowSearchOnTyping),!this.parent.breadcrumbbarModule.searchObj.value||""===this.parent.breadcrumbbarModule.searchObj.value||!t.isNullOrUndefined(a.allowSearchOnTyping)&&t.isNullOrUndefined(a.filterType)&&t.isNullOrUndefined(a.ignoreCase)||v(this.parent,this.parent.breadcrumbbarModule.searchObj.value,!1)}}},e.prototype.render=function(){this.addEventListener()},e.prototype.onPathChange=function(){var e=this.parent.pathNames,i=this.parent.path.split("/"),n=this.parent.createElement("ul",{className:"e-addressbar-ul"}),s=null,a=e.length;if(e.length>0){for(var r="",o=0;o<a;o++){var l=null;s=this.parent.createElement("li",{className:"e-address-list-item"});for(var h=0;h<=o;h++)r=r+i[h]+"/";if(s.setAttribute("data-utext",r),0!==o){var d=t.createElement("span",{className:Yi});s.appendChild(d)}a-o!=1?(l=t.createElement("a",{className:ei}),s.setAttribute("tabindex","0")):l=t.createElement("span",{className:ei}),r="",l.innerText=e[o],s.appendChild(l),n.appendChild(s)}var p=this.parent.breadCrumbBarNavigation.querySelector(".e-addressbar-ul");t.isNullOrUndefined(p)||(t.isNullOrUndefined(this.subMenuObj)||this.subMenuObj.destroy(),t.remove(p));var c=this.parent.breadCrumbBarNavigation.querySelector(".e-search-wrap");c?this.parent.breadCrumbBarNavigation.appendChild(n):this.parent.breadCrumbBarNavigation.insertBefore(n,c),this.updateBreadCrumbBar(n)}},e.prototype.updateBreadCrumbBar=function(e){for(var i=e.querySelectorAll("li"),n=this.parent.breadCrumbBarNavigation.querySelector(".e-addressbar-ul"),s=window.getComputedStyle(n,null),r=parseFloat(s.getPropertyValue("padding-right")),o=parseFloat(s.getPropertyValue("padding-left")),h=n.offsetWidth-r-o,d=this.parent.createElement("ul",{className:"e-addressbar-ul"}),p=0,c=[],u=0;u<i.length;u++){var f=i[u].clientWidth;c.push(f),p+=f}t.isNullOrUndefined(n)||t.remove(n);var g=this.parent.createElement("div");g.setAttribute("class","e-search-wrap");var m=this.parent.element.id+"_search",b=t.createElement("input",{id:m,attrs:{autocomplete:"off","aria-label":T(this.parent,"Search")}});g.appendChild(b);var y=this.parent.breadCrumbBarNavigation.querySelector(".e-search-wrap .e-input");if(t.isNullOrUndefined(y)){this.parent.breadCrumbBarNavigation.appendChild(g);var v=t.createElement("span",{className:"e-icons e-fe-search"});t.EventHandler.add(v,"click",this.onShowInput,this),b.parentElement.insertBefore(v,b),this.searchObj=new a.TextBox({value:"",showClearButton:!0,placeholder:T(this.parent,"Search"),focus:this.onFocus.bind(this),blur:this.onBlur.bind(this)}),this.searchObj.appendTo("#"+this.parent.element.id+"_search"),this.searchEventBind(this.parent.searchSettings.allowSearchOnTyping);var O=this.searchObj.element.nextElementSibling;t.EventHandler.add(O,"mousedown",this.searchChangeHandler.bind(this),this),t.EventHandler.add(this.searchObj.element,"keyup",this.onKeyUp.bind(this),this)}var I=this.parent.breadCrumbBarNavigation.querySelector(".e-search-wrap");if(h-=this.searchWrapWidth?this.searchWrapWidth:I.offsetWidth,p>h){for(u=i.length;u--;){var w=h-c[u];if(!(w>40)){for(var D=[],S=0;S<=u;S++){var C=i[S];D.push({text:C.innerText,utext:C.getAttribute("data-utext")})}var j=this.parent.createElement("li",{className:"e-breadcrumb-menu"}),x=this.parent.createElement("button",{className:"e-breadcrumb-submenu"});j.appendChild(x),d.insertBefore(j,d.querySelector("li")),this.subMenuObj=new l.DropDownButton({items:D,cssClass:"e-caret-hide e-submenu",iconCss:Ki,iconPosition:"Top",enableHtmlSanitizer:this.parent.enableHtmlSanitizer,beforeItemRender:this.addSubMenuAttributes.bind(this),select:this.subMenuSelectOperations.bind(this)}),this.subMenuObj.isStringTemplate=!0,this.subMenuObj.appendTo(x);break}d.insertBefore(i[u],d.querySelector("li")),h=w}this.parent.breadCrumbBarNavigation.insertBefore(d,I)}else this.parent.breadCrumbBarNavigation.insertBefore(e,I)},e.prototype.onFocus=function(){t.closest(this.searchObj.element,".e-search-wrap").classList.add("e-focus")},e.prototype.onKeyUp=function(){this.parent.notify(Kn,{args:this.parent})},e.prototype.onBlur=function(){t.closest(this.searchObj.element,".e-search-wrap").classList.remove("e-focus")},e.prototype.subMenuSelectOperations=function(e){var t={target:e.element};this.addressPathClickHandler(t)},e.prototype.addSubMenuAttributes=function(e){e.element.setAttribute("data-utext",t.getValue("utext",e.item));var i=this.parent.createElement("a",{className:"e-list-text"});e.element.appendChild(i)},e.prototype.searchEventBind=function(e){e?(this.searchObj.input=this.searchChangeHandler.bind(this),this.searchObj.change=null):(this.searchObj.change=this.searchChangeHandler.bind(this),this.searchObj.input=null)},e.prototype.searchChangeHandler=function(e){var i=this;t.isNullOrUndefined(e.value)||(this.parent.isFiltered=!1,this.parent.searchSettings.allowSearchOnTyping?(window.clearTimeout(this.searchTimer),this.searchTimer=window.setTimeout(function(){v(i.parent,e.value,!1)},300)):v(this.parent,e.value,!1))},e.prototype.addressPathClickHandler=function(e){var i=e.target;if("LI"===i.nodeName||"A"===i.nodeName){var n="LI"===i.nodeName?i.children[0]:i;if(!t.isNullOrUndefined(n)){this.parent.isFiltered=!1;var s=this.updatePath(n);this.parent.itemData=[t.getValue(this.parent.pathId[this.parent.pathId.length-1],this.parent.feParent)],this.triggerFileOpen(this.parent.itemData[0]),fe(this.parent,fn,s);var a=this.parent.pathId[this.parent.pathId.length-1];this.parent.notify(qn,{module:"treeview",selectedNode:a})}}},e.prototype.triggerFileOpen=function(e){var t={cancel:!1,fileDetails:e,module:"BreadCrumbBar"};delete t.cancel,this.parent.trigger("fileOpen",t)},e.prototype.onShowInput=function(){if(this.parent.isMobile)if(this.parent.element.classList.contains(Qt))t.removeClass([this.parent.element],Qt),this.searchWrapWidth=null;else{var e=this.parent.breadCrumbBarNavigation.querySelector(".e-search-wrap");this.searchWrapWidth=e.offsetWidth,t.addClass([this.parent.element],Qt),this.searchObj.element.focus()}},e.prototype.updatePath=function(e){var i=t.closest(e,"li").getAttribute("data-utext");this.addressBarLink=i;var n=this.addressBarLink.split("/"),s=this.parent.pathId,a=this.parent.pathNames;this.parent.pathId=[],this.parent.pathNames=[];for(var r="",o=0,l=n.length-1;o<l;o++)this.parent.pathId.push(s[o]),this.parent.pathNames.push(a[o]),r+=n[o]+"/";return this.parent.setProperties({path:r},!0),r},e.prototype.onUpdatePath=function(){this.onPathChange(),this.removeSearchValue()},e.prototype.onCreateEnd=function(){this.onPathChange()},e.prototype.onRenameEnd=function(){this.onPathChange()},e.prototype.onDeleteEnd=function(){this.onUpdatePath()},e.prototype.removeSearchValue=function(){this.parent.isFiltered=!1,!this.searchObj||""===this.searchObj.value&&""===this.searchObj.element.value||(this.searchObj.value="",this.searchObj.element.value="",this.searchObj.dataBind())},e.prototype.onResize=function(){this.onPathChange()},e.prototype.onPasteEnd=function(){this.onPathChange()},e.prototype.addEventListener=function(){this.keyboardModule=new t.KeyboardEvents(this.parent.breadCrumbBarNavigation,{keyAction:this.keyActionHandler.bind(this),keyConfigs:this.keyConfigs,eventName:"keydown"}),this.parent.on(nn,this.onPropertyChanged,this),t.EventHandler.add(this.parent.breadCrumbBarNavigation,"click",this.addressPathClickHandler,this),this.parent.on(gn,this.destroy,this),this.parent.on(fn,this.onUpdatePath,this),this.parent.on(an,this.onUpdatePath,this),this.parent.on(pn,this.onUpdatePath,this),this.parent.on(Dn,this.onUpdatePath,this),this.parent.on(rn,this.onCreateEnd,this),this.parent.on(Tn,this.onRenameEnd,this),this.parent.on(dn,this.onDeleteEnd,this),this.parent.on(un,this.onResize,this),this.parent.on(Bn,this.onPasteEnd,this),this.parent.on(cn,this.onResize,this),this.parent.on(Gn,this.onSearchTextChange,this),this.parent.on(Qn,this.onDropInit,this),this.parent.on(vn,this.onResize,this),this.parent.on(Xn,this.onPathChange,this)},e.prototype.keyActionHandler=function(e){switch(e.action){case"enter":this.addressPathClickHandler(e)}},e.prototype.removeEventListener=function(){this.keyboardModule.destroy(),this.parent.off(fn,this.onUpdatePath),this.parent.off(an,this.onUpdatePath),this.parent.off(pn,this.onUpdatePath),this.parent.off(Dn,this.onUpdatePath),this.parent.off(Bn,this.onPasteEnd),this.parent.off(rn,this.onCreateEnd),this.parent.off(Tn,this.onRenameEnd),this.parent.off(dn,this.onDeleteEnd),this.parent.off(un,this.onResize),this.parent.off(cn,this.onResize),this.parent.off(Gn,this.onSearchTextChange),this.parent.off(Qn,this.onDropInit),this.parent.off(vn,this.onResize),this.parent.off(Xn,this.onPathChange)},e.prototype.onDropInit=function(e){if(this.parent.targetModule===this.getModuleName()){var i=e.target.closest("li");this.parent.dropPath=this.updatePath(i.children[0]),this.parent.dropData=t.getValue(this.parent.pathId[this.parent.pathId.length-1],this.parent.feParent),this.triggerFileOpen(this.parent.dropData);var n=this.parent.pathId[this.parent.pathId.length-1];this.parent.notify(qn,{module:"treeview",selectedNode:n})}},e.prototype.getModuleName=function(){return"breadcrumbbar"},e.prototype.destroy=function(){this.parent.isDestroyed||(this.removeEventListener(),t.isNullOrUndefined(this.subMenuObj)||this.subMenuObj.destroy(),t.isNullOrUndefined(this.searchObj)||this.searchObj.destroy())},e.prototype.onSearchTextChange=function(e){this.searchObj.element.placeholder=null!=this.parent.searchSettings.placeholder?this.parent.searchSettings.placeholder:T(this.parent,"Search")+" "+e.cwd.name},e}(),ls=function(){function e(e){this.currentItems=[],this.currentElement=null,this.disabledItems=[],this.parent=e,this.render()}return e.prototype.render=function(){this.keyConfigs={downarrow:"downarrow",uparrow:"uparrown"},this.contextMenu=new h.ContextMenu({enableRtl:this.parent.enableRtl,locale:this.parent.locale,target:"#"+this.parent.element.id,enableHtmlSanitizer:this.parent.enableHtmlSanitizer,beforeItemRender:this.onBeforeItemRender.bind(this),select:this.onSelect.bind(this),beforeOpen:this.onBeforeOpen.bind(this),beforeClose:this.onBeforeClose.bind(this),cssClass:A(this.parent,Wt)}),this.contextMenu.isStringTemplate=!0,this.contextMenu.appendTo("#"+this.parent.element.id+Ut),this.addEventListener()},e.prototype.onBeforeItemRender=function(e){if(e.item.id===this.getMenuId("largeiconsview")){var i=t.createElement("span");(n=e.element).insertBefore(i,"LargeIcons"===this.parent.view?n.childNodes[1]:n.childNodes[0]),i.setAttribute("class",Wi+" "+xi)}if(e.item.id===this.getMenuId("detailsview")){var n;i=t.createElement("span");(n=e.element).insertBefore(i,"Details"===this.parent.view?n.childNodes[1]:n.childNodes[0]),i.setAttribute("class",qi+" "+xi)}},e.prototype.onBeforeClose=function(){this.menuTarget=null},e.prototype.onBeforeOpen=function(e){var i=this;this.disabledItems=[];var n,s,a=!1,r=!1,o=e.event.target;this.menuTarget=this.targetNodeElement=o,this.currentElement=e.element,o.classList.contains("e-spinner-pane")&&(o=this.parent.navigationpaneModule.activeNode.getElementsByClassName(Xi)[0],this.menuTarget=this.targetNodeElement=o),this.targetElement="Details"===this.parent.view?t.closest(o,"tr.e-row"):o;var l=this.getTargetView(o);if(this.updateActiveModule(),o.classList.contains(Ci)||t.closest(o,"th")||t.closest(o,"#"+this.parent.element.id+_t)||t.closest(o,"#"+this.parent.element.id+Pt))e.cancel=!0;else if("LargeIcons"!==this.parent.view&&this.targetElement&&this.targetElement.classList.contains("e-emptyrow"))this.setLayoutItem(o);else if(t.closest(o,"."+ci))this.setLayoutItem(o);else if(!o.classList.contains(ji)&&!o.classList.contains(xi)&&!o.classList.contains("e-caret")){if("LargeIcons"!==this.parent.view||t.isNullOrUndefined(t.closest(o,"li"))||t.closest(o,"#"+this.parent.element.id+Rt))t.isNullOrUndefined(t.closest(o,"tr.e-row"))?t.closest(o,"#"+this.parent.element.id+Rt)&&(n=t.closest(o,"li").getAttribute("data-uid"),r=!0):(n=this.targetElement.getAttribute("data-uid"),s=this.parent.detailsviewModule.gridObj.getRowObjectFromUID(n).data,t.isNullOrUndefined(this.targetElement.getAttribute("aria-selected"))&&this.parent.detailsviewModule.gridObj.selectRows([parseInt(this.targetElement.getAttribute("aria-rowindex"),10)]),a=!0);else{t.closest(o,"li").classList.contains("e-active")||this.parent.largeiconsviewModule.doSelection(o,{ctrlKey:!0,shiftKey:!0}),s=this.parent.visitedData,a=!0}a?!0===t.getValue("isFile",s)?this.setFileItem():this.setFolderItem(!1):r?(this.setFolderItem(!0),n===this.parent.pathId[0]&&this.disabledItems.push("Delete","Rename","Cut","Copy")):"TreeView"===l||"GridView"===l||"LargeIcon"===l?this.setLayoutItem(o):e.cancel=!0}var h=t.select("#"+this.getMenuId("Paste"),this.contextMenu.element);if(e.cancel||this.parent.enablePaste||!h||h.classList.contains("e-disabled")||this.disabledItems.push("Paste"),e.cancel)this.menuTarget=this.currentElement=null;else{this.contextMenu.dataBind();var d=!1;(o.classList.contains(ji)||o.classList.contains(xi)||o.classList.contains("e-caret"))&&(d=!0),this.menuItemData=d?this.menuItemData:this.getMenuItemData();var p={fileDetails:[this.menuItemData],element:e.element,target:o,items:d?e.items:this.contextMenu.items,menuModule:this.contextMenu,cancel:!1,menuType:this.menuType,isSubMenu:d};this.currentItems=p.items,this.parent.trigger("menuOpen",p,function(t){d||(i.contextMenu.dataBind(),i.contextMenu.items=t.items,i.contextMenu.dataBind()),i.enableItems(i.disabledItems,!1,!0),e.cancel=t.cancel,t.cancel&&(i.menuTarget=i.targetNodeElement=i.currentElement=null)})}},e.prototype.updateActiveModule=function(){this.parent.activeModule=t.closest(this.menuTarget,"#"+this.parent.element.id+Rt)?"navigationpane":t.closest(this.menuTarget,"#"+this.parent.element.id+Mt)?"detailsview":t.closest(this.menuTarget,"#"+this.parent.element.id+kt)?"largeiconsview":this.parent.activeModule},e.prototype.getTargetView=function(e){return e.classList.contains(Ci)?"TreeView":e.classList.contains(Ni)?"GridView":e.classList.contains(Ei)?"LargeIcon":e.classList.contains(Xt)?"LargeIcon":""},e.prototype.getItemIndex=function(e){for(var t=this.getMenuId(e),i=0;i<this.currentItems.length;i++)if(this.currentItems[i].id===t||this.currentItems[i].id===e)return i;return-1},e.prototype.disableItem=function(e){0!==e.length&&(this.disabledItems=this.disabledItems.concat(e))},e.prototype.enableItems=function(e,t,i){for(var n=0;n<e.length;n++)1===this.checkValidItem(e[n])?this.contextMenu.enableItems([this.getMenuId(e[n])],t,i):2===this.checkValidItem(e[n])&&this.contextMenu.enableItems([e[n]],t,i)},e.prototype.setFolderItem=function(e){this.menuType="folder",this.contextMenu.items=this.getItemData(this.parent.contextMenuSettings.folder.map(function(e){return e.trim()})),this.contextMenu.dataBind(),e?this.disabledItems.push("Open"):1!==this.parent.selectedItems.length&&this.disabledItems.push("Rename","Paste")},e.prototype.setFileItem=function(){this.menuType="file",this.contextMenu.items=this.getItemData(this.parent.contextMenuSettings.file.map(function(e){return e.trim()})),this.contextMenu.dataBind(),1!==this.parent.selectedItems.length&&this.disabledItems.push("Rename")},e.prototype.setLayoutItem=function(e){this.menuType="layout",this.contextMenu.items=this.getItemData(this.parent.contextMenuSettings.layout.map(function(e){return e.trim()})),this.contextMenu.dataBind(),(!this.parent.allowMultiSelection||"LargeIcons"===this.parent.view&&0!==t.closest(e,"#"+this.parent.element.id+kt).getElementsByClassName(ci).length||"Details"===this.parent.view&&0!==t.closest(e,"#"+this.parent.element.id+Mt).getElementsByClassName(ci).length)&&this.disabledItems.push("SelectAll"),0===this.parent.selectedNodes.length&&this.disabledItems.push("Paste"),this.contextMenu.dataBind()},e.prototype.checkValidItem=function(e){return t.isNullOrUndefined(t.select("#"+this.getMenuId(e),this.currentElement))?t.isNullOrUndefined(t.select("#"+e,this.currentElement))?-1:2:1},e.prototype.getMenuItemData=function(){if("layout"===this.menuType)return S(this.parent);var e={target:this.menuTarget};return this.parent.notify(Mn,e),this.parent.itemData[0]},e.prototype.onSelect=function(e){var i=this;if(!t.isNullOrUndefined(e.item)&&e.item.id){var n,s=e.item.id.substr((this.parent.element.id+"_cm_").length);"refresh"===s||"newfolder"===s||"upload"===s?(n=[S(this.parent)],this.parent.itemData=n):(this.parent.notify(Un,{}),n="navigationpane"===this.parent.activeModule&&"open"===s?[this.menuItemData]:this.parent.itemData);var a={cancel:!1,element:e.element,fileDetails:n,item:e.item};this.parent.trigger("menuClick",a,function(a){var r;if(!a.cancel)switch(s){case"cut":j(i.parent);break;case"copy":C(i.parent);break;case"paste":"folder"===i.menuType&&("largeiconsview"===i.parent.activeModule||"detailsview"===i.parent.activeModule)?i.parent.folderPath=P(i.parent,i.menuItemData,i.parent.path):i.parent.folderPath="",_(i.parent);break;case"delete":for(var o=0;o<n.length;o++)if(!le(n[o]))return void ae(i.parent,n[o],is);Le(i.parent,"Delete");break;case"download":for(var l=0;l<n.length;l++)if(!pe(n[l]))return void ae(i.parent,n[l],as);"navigationpane"===i.parent.activeModule?i.parent.notify(Yn,{}):i.parent.selectedItems.length>0&&ke(i.parent,i.parent.path,i.parent.selectedItems);break;case"rename":le(n[0])?(i.parent.notify(kn,{}),Le(i.parent,"Rename")):ae(i.parent,n[0],is);break;case"selectall":i.parent.notify(Cn,{});break;case"refresh":w(i.parent);break;case"open":i.parent.visitedItem?i.parent.notify(wn,{target:i.parent.visitedItem}):"navigationpane"===i.parent.activeModule&&i.parent.navigationpaneModule.openFileOnContextMenuClick(t.closest(i.targetNodeElement,"li"));break;case"details":i.parent.notify(Rn,{}),r=i.parent.selectedItems,"navigationpane"===i.parent.activeModule&&(r=[]),Oe(i.parent,r,i.parent.path,"details");break;case"newfolder":ce(i.parent);break;case"upload":ue(i.parent);break;case"name":case"size":case"date":case"ascending":case"descending":case"none":F(i.parent,e);break;case"largeiconsview":O(i.parent,"LargeIcons");break;case"detailsview":O(i.parent,"Details")}})}},e.prototype.onPropertyChanged=function(e){if(e.module===this.getModuleName()||"common"===e.module)for(var t=0,i=Object.keys(e.newProp);t<i.length;t++){switch(i[t]){case"cssClass":this.contextMenu.cssClass=A(this.parent,Wt)}}},e.prototype.addEventListener=function(){this.parent.on(gn,this.destroy,this),this.parent.on(nn,this.onPropertyChanged,this),this.keyboardModule=new t.KeyboardEvents(this.contextMenu.element,{keyAction:this.keyActionHandler.bind(this),keyConfigs:this.keyConfigs,eventName:"keydown"})},e.prototype.removeEventListener=function(){this.parent.off(gn,this.destroy),this.parent.off(nn,this.onPropertyChanged),this.keyboardModule.destroy()},e.prototype.keyActionHandler=function(e){switch(e.action){case"uparrow":case"downarrow":e.preventDefault()}},e.prototype.getModuleName=function(){return"contextmenu"},e.prototype.destroy=function(){this.parent.isDestroyed||(this.removeEventListener(),this.contextMenu.destroy())},e.prototype.getItemData=function(e){for(var t=[],i=0;i<e.length;i++){var n=void 0,s=this.getMenuId(e[i]),a=T(this.parent,e[i]);switch(e[i]){case"|":n={separator:!0};break;case"Open":n={id:s,text:a,iconCss:Ri};break;case"Upload":n={id:s,text:a,iconCss:Mi};break;case"Cut":n={id:s,text:a,iconCss:ki};break;case"Copy":n={id:s,text:a,iconCss:Li};break;case"Paste":n={id:s,text:a,iconCss:Ti};break;case"Delete":n={id:s,text:a,iconCss:Ai};break;case"Rename":n={id:s,text:a,iconCss:Fi};break;case"NewFolder":n={id:s,text:a,iconCss:Ui};break;case"Details":n={id:s,text:a,iconCss:Vi};break;case"SortBy":n={id:s,text:a,iconCss:_i,items:[{id:this.getMenuId("Name"),text:T(this.parent,"Name"),iconCss:"name"===this.parent.sortBy?ni:null},{id:this.getMenuId("Size"),text:T(this.parent,"Size"),iconCss:"size"===this.parent.sortBy?ni:null},{id:this.getMenuId("Date"),text:T(this.parent,"DateModified"),iconCss:"_fm_modified"===this.parent.sortBy?ni:null},{separator:!0},{id:this.getMenuId("Ascending"),text:T(this.parent,"Ascending"),iconCss:"Ascending"===this.parent.sortOrder?ii:null},{id:this.getMenuId("Descending"),text:T(this.parent,"Descending"),iconCss:"Descending"===this.parent.sortOrder?ii:null},{id:this.getMenuId("None"),text:T(this.parent,"None"),iconCss:"None"===this.parent.sortOrder?ii:null}]};break;case"View":n={id:s,text:a,iconCss:"Details"===this.parent.view?qi:Wi,items:[{id:this.getMenuId("largeiconsview"),text:T(this.parent,"View-LargeIcons"),iconCss:"Details"===this.parent.view?null:ii},{id:this.getMenuId("detailsview"),text:T(this.parent,"View-Details"),iconCss:"Details"===this.parent.view?ii:null}]};break;case"Refresh":n={id:s,text:a,iconCss:Bi};break;case"SelectAll":n={id:s,text:a,iconCss:Hi};break;case"Download":n={id:s,text:a,iconCss:zi};break;default:n={id:s,text:a}}t.push(n)}return t},e.prototype.getMenuId=function(e){return this.parent.element.id+"_cm_"+e.toLowerCase()},e}(),hs={NewFolder:"New folder",Upload:"Upload",Delete:"Delete",Rename:"Rename",Download:"Download",Cut:"Cut",Copy:"Copy",Paste:"Paste",SortBy:"Sort by",Refresh:"Refresh","Item-Selection":"item selected","Items-Selection":"items selected",View:"View",Details:"Details",SelectAll:"Select all",Open:"Open","Tooltip-NewFolder":"New folder","Tooltip-Upload":"Upload","Tooltip-Delete":"Delete","Tooltip-Rename":"Rename","Tooltip-Download":"Download","Tooltip-Cut":"Cut","Tooltip-Copy":"Copy","Tooltip-Paste":"Paste","Tooltip-SortBy":"Sort by","Tooltip-Refresh":"Refresh","Tooltip-Selection":"Clear selection","Tooltip-View":"View","Tooltip-Details":"Details","Tooltip-SelectAll":"Select all",Name:"Name",Size:"Size",DateModified:"Modified",DateCreated:"Date created",Path:"Path",Modified:"Modified",Created:"Created",Location:"Location",Type:"Type",Permission:"Permission",Ascending:"Ascending",Descending:"Descending",None:"None","View-LargeIcons":"Large icons","View-Details":"Details",Search:"Search","Button-Ok":"OK","Button-Cancel":"Cancel","Button-Yes":"Yes","Button-No":"No","Button-Create":"Create","Button-Save":"Save","Header-NewFolder":"Folder","Content-NewFolder":"Enter your folder name","Header-Rename":"Rename","Content-Rename":"Enter your new name","Header-Rename-Confirmation":"Rename Confirmation","Content-Rename-Confirmation":"If you change a file name extension, the file might become unstable. Are you sure you want to change it?","Header-Delete":"Delete File","Content-Delete":"Are you sure you want to delete this file?","Header-Folder-Delete":"Delete Folder","Content-Folder-Delete":"Are you sure you want to delete this folder?","Header-Multiple-Delete":"Delete Multiple Items","Content-Multiple-Delete":"Are you sure you want to delete these {0} items?","Header-Duplicate":"File/Folder exists","Content-Duplicate":"{0} already exists. Do you want to rename and paste?","Header-Upload":"Upload Files",Error:"Error","Validation-Empty":"The file or folder name cannot be empty.","Validation-Invalid":'The file or folder name {0} contains invalid characters. Please use a different name. Valid file or folder names cannot end with a dot or space, and cannot contain any of the following characters: \\/:*?"<>|',"Validation-NewFolder-Exists":"A file or folder with the name {0} already exists.","Validation-Rename-Exists":"Cannot rename {0} to {1}: destination already exists.","Folder-Empty":"This folder is empty","File-Upload":"Drag files here to upload","Search-Empty":"No results found","Search-Key":"Try with different keywords","Filter-Empty":"No results found","Filter-Key":"Try with different filter","Sub-Folder-Error":"The destination folder is the subfolder of the source folder.","Same-Folder-Error":"The destination folder is the same as the source folder.","Access-Denied":"Access Denied","Access-Details":'You don"t have permission to access this folder.',"Header-Retry":"File Already Exists","Content-Retry":"A file with this name already exists in this folder. What would you like to do?","Button-Keep-Both":"Keep both","Button-Replace":"Replace","Button-Skip":"Skip","ApplyAll-Label":"Do this for all current items",KB:"KB","Access-Message":"{0} is not accessible. You need permission to perform the {1} action.","Network-Error":"NetworkError: Failed to send on XMLHTTPRequest: Failed to load","Server-Error":"ServerError: Invalid response from"},ds=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function n(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(n.prototype=i.prototype,new n)}}(),ps=function(e,t,i,n){var s,a=arguments.length,r=a<3?t:null===n?n=Object.getOwnPropertyDescriptor(t,i):n;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)r=Reflect.decorate(e,t,i,n);else for(var o=e.length-1;o>=0;o--)(s=e[o])&&(r=(a<3?s(r):a>3?s(t,i,r):s(t,i))||r);return a>3&&r&&Object.defineProperty(t,i,r),r},cs=function(e){function s(t,i){var n=e.call(this,t,i)||this;return n.filterData=null,n.selectedNodes=[],n.duplicateItems=[],n.duplicateRecords=[],n.previousPath=[],n.nextPath=[],n.isLayoutChange=!1,n.layoutSelectedItems=[],n.renamedId=null,n.uploadItem=[],n.deleteRecords=[],n.isFile=!1,n.sortBy="name",n.isCut=!1,n.isSearchCut=!1,n.isSearchDrag=!1,n.isPasteError=!1,n.folderPath="",n.isSameAction=!1,n.isFiltered=!1,n.isSortByClicked=!1,n.enablePaste=!1,n.persistData=!1,n.retryArgs=[],n.isOpened=!1,n.isRetryOpened=!1,n.isPathDrag=!1,n.searchedItems=[],n.retryFiles=[],n.isApplySame=!1,n.dragData=[],n.dragNodes=[],n.dragPath="",n.dropPath="",n.isDragDrop=!1,n.treeExpandTimer=null,n.dragCursorPosition={left:44,top:18},n.isDropEnd=!1,n.dragCount=0,n.droppedObjects=[],n.uploadingCount=0,n.uploadedCount=0,r.Inject(os,rs,ls),n}ds(s,e),r=s,s.prototype.getModuleName=function(){return"filemanager"},s.prototype.preRender=function(){(t.isNullOrUndefined(this.element.id)||""===this.element.id)&&this.element.setAttribute("id",t.getUniqueID("filemanager")),this.ensurePath(),this.feParent=[],this.feFiles=[],t.setStyleAttribute(this.element,{width:t.formatUnit(this.width),height:t.formatUnit(this.height)}),this.isDevice=t.Browser.isDevice,this.isMobile=this.checkMobile(),this.isMobile&&this.setProperties({navigationPaneSettings:{visible:!1}},!0);var e=t.closest(this.element,".e-bigger");this.isBigger=!!e,this.activeModule="LargeIcons"===this.view?"largeiconsview":"detailsview",n.createSpinner({target:this.element},t.createElement),this.addWrapper(),this.keyConfigs={altN:"alt+n",f5:"f5",ctrlShift1:"ctrl+shift+1",ctrlShift2:"ctrl+shift+2",ctrlU:"ctrl+u"},this.localeObj=new t.L10n(this.getModuleName(),hs,this.locale)},s.prototype.getPersistData=function(){return this.addOnPersist(["view","path","selectedItems"])},s.prototype.requiredModules=function(){var e=[];return e.push({member:"breadcrumbbar",args:[this]}),e.push({member:"largeiconsview",args:[this]}),this.toolbarSettings.visible&&e.push({member:"toolbar",args:[this]}),this.navigationPaneSettings.visible&&e.push({member:"navigationpane",args:[this]}),this.view&&e.push({member:"detailsview",args:[this]}),this.contextMenuSettings.visible&&!this.isDevice&&e.push({member:"contextmenu",args:[this]}),e},s.prototype.render=function(){this.initialize();var e=t.isNullOrUndefined(this.selectedItems)?[]:this.allowMultiSelection?this.selectedItems:this.selectedItems.slice(this.selectedItems.length-1);if(this.setProperties({selectedItems:e},!0),this.fileView=this.view,this.setRtl(this.enableRtl),this.addEventListeners(),fe(this,this.path!==this.originalPath?sn:an,this.path),this.adjustHeight(),t.isNullOrUndefined(this.navigationpaneModule)){this.splitterObj.collapse(this.enableRtl?1:0);t.select("."+$i,this.element).classList.add(Ji)}this.wireEvents(),this.renderComplete()},s.prototype.ensurePath=function(){var e=this.path;t.isNullOrUndefined(e)&&(e="/"),e.lastIndexOf("/")!==e.length-1&&(e+="/"),this.originalPath=e;var i=e.split("/");this.setProperties({path:i[0]+"/"},!0),this.pathNames=[],this.pathId=["fe_tree"],this.itemData=[]},s.prototype.initialize=function(){this.isMobile&&t.addClass([this.element],Kt),this.allowMultiSelection&&t.addClass([this.element],qt),this.addCssClass(null,this.cssClass),this.renderFileUpload()},s.prototype.addWrapper=function(){var e=this.createElement("div",{id:this.element.id+Pt});this.element.appendChild(e);var t=this.createElement("div",{id:this.element.id+Et,className:"e-layout"});this.element.appendChild(t);var n=this.createElement("div",{id:this.element.id+"_navigation",className:"e-navigation"}),s=this.createElement("div",{id:this.element.id+Rt});n.appendChild(s);var a=this.createElement("div",{id:this.element.id+Vt,className:Jt});this.breadCrumbBarNavigation=this.createElement("div",{id:this.element.id+_t,className:"e-address"}),a.appendChild(this.breadCrumbBarNavigation);var r=this.createElement("div",{id:this.element.id+Mt});a.appendChild(r);var o=this.createElement("div",{id:this.element.id+kt,className:Xt,attrs:{role:"group"}});a.appendChild(o);var l=this.createElement("span",{className:"e-fe-overlay"});a.appendChild(l);var h;this.enableRtl?(t.appendChild(a),t.appendChild(n),h=[{size:"75%",min:"270px"},{size:"25%",min:this.navigationPaneSettings.minWidth.toString(),max:this.navigationPaneSettings.maxWidth.toString()}]):(t.appendChild(n),t.appendChild(a),h=[{size:"25%",min:this.navigationPaneSettings.minWidth.toString(),max:this.navigationPaneSettings.maxWidth.toString()},{size:"75%",min:"270px"}]),this.splitterObj=new i.Splitter({paneSettings:h,width:"100%",enableRtl:!1,enableHtmlSanitizer:this.enableHtmlSanitizer,resizing:this.splitterResize.bind(this)}),this.splitterObj.isStringTemplate=!0,this.splitterObj.appendTo(t);var d=this.createElement("div",{id:this.element.id+Lt});this.element.appendChild(d);var p=this.createElement("ul",{id:this.element.id+Ut});this.element.appendChild(p);var c=this.createElement("div",{id:this.element.id+Tt});this.element.appendChild(c);var u=this.createElement("div",{id:this.element.id+At});this.element.appendChild(u);var f=this.createElement("div",{id:this.element.id+Ft});this.element.appendChild(f)},s.prototype.adjustHeight=function(){var e=t.select("#"+this.element.id+Pt,this.element),i=e?e.offsetHeight:0;this.splitterObj&&(this.splitterObj.height=(this.element.clientHeight-i).toString(),this.splitterObj.dataBind())},s.prototype.splitterResize=function(){this.notify(un,{})},s.prototype.splitterAdjust=function(){var e=t.select("."+$i,this.element);this.navigationPaneSettings.visible?(this.splitterObj.expand(this.enableRtl?1:0),e.classList.remove(Ji)):(this.splitterObj.collapse(this.enableRtl?1:0),e.classList.add(Ji))},s.prototype.addCssClass=function(e,i){t.isNullOrUndefined(e)||""===e||t.removeClass([this.element],e.split(" ")),t.isNullOrUndefined(i)||""===i||t.addClass([this.element],i.split(" "))},s.prototype.showSpinner=function(){n.showSpinner(this.element)},s.prototype.hideSpinner=function(){n.hideSpinner(this.element)},s.prototype.onContextMenu=function(e){e.preventDefault()},s.prototype.checkMobile=function(){return/iphone|ipod|android|blackberry|opera|mini|windows\sce|palm|smartphone|iemobile/i.test(t.Browser.userAgent.toLowerCase())&&/mobile/i.test(t.Browser.userAgent.toLowerCase())},s.prototype.renderFileUpload=function(){var e=this.element.id+Bt,t=this.createElement("input",{id:e,attrs:{name:"uploadFiles",type:"file"}});this.element.appendChild(t),this.uploadDialogObj=new n.Dialog({header:T(this,"Header-Upload"),content:t,animationSettings:{effect:"None"},showCloseIcon:!0,closeOnEscape:!0,visible:!1,isModal:!0,width:"350px",target:this.popupTarget?this.popupTarget:"#"+this.element.id,cssClass:A(this,this.isMobile?Gt:Wt),locale:this.locale,allowDragging:!0,position:{X:"center",Y:"center"},enableRtl:this.enableRtl,enableHtmlSanitizer:this.enableHtmlSanitizer,open:this.onOpen.bind(this),close:this.onClose.bind(this),beforeOpen:this.onBeforeOpen.bind(this),beforeClose:this.onBeforeClose.bind(this)}),this.uploadDialogObj.appendTo("#"+this.element.id+Ft),this.renderUploadBox()},s.prototype.renderUploadBox=function(){var e=this.ajaxSettings.uploadUrl?this.ajaxSettings.uploadUrl:this.ajaxSettings.url;this.uploadObj=new a.Uploader({dropArea:t.select("#"+this.element.id+Vt,this.element),asyncSettings:{saveUrl:e,removeUrl:e},locale:this.locale,enableRtl:this.enableRtl,uploading:this.onUploading.bind(this),removing:this.onRemoving.bind(this),canceling:this.onCancel.bind(this),clearing:this.onClearing.bind(this),selected:this.onSelected.bind(this),success:this.onUploadSuccess.bind(this),failure:this.onUploadFailure.bind(this),autoUpload:this.uploadSettings.autoUpload,minFileSize:this.uploadSettings.minFileSize,maxFileSize:this.uploadSettings.maxFileSize,allowedExtensions:this.uploadSettings.allowedExtensions,fileListRendering:this.onFileListRender.bind(this)}),this.uploadObj.appendTo("#"+this.element.id+Bt)},s.prototype.onFileListRender=function(e){this.trigger("uploadListCreate",e)},s.prototype.updateUploader=function(){this.uploadObj.autoUpload=this.uploadSettings.autoUpload,this.uploadObj.minFileSize=this.uploadSettings.minFileSize,this.uploadObj.maxFileSize=this.uploadSettings.maxFileSize,this.uploadObj.allowedExtensions=this.uploadSettings.allowedExtensions,this.uploadObj.dataBind()},s.prototype.onBeforeOpen=function(e){var t={cancel:e.cancel,popupName:"Upload",popupModule:this.uploadDialogObj};this.trigger("beforePopupOpen",t,function(t){e.cancel=t.cancel})},s.prototype.onBeforeClose=function(e){var t={cancel:e.cancel,popupName:"Upload",popupModule:this.uploadDialogObj};this.trigger("beforePopupClose",t,function(t){e.cancel=t.cancel})},s.prototype.onOpen=function(){this.isOpened=!0,this.uploadDialogObj.element.focus();var e={popupModule:this.uploadDialogObj,popupName:"Upload",element:this.uploadDialogObj.element};this.trigger("popupOpen",e)},s.prototype.onClose=function(){this.isOpened=!1,this.uploadObj.clearAll();var e={popupModule:this.uploadDialogObj,popupName:"Upload",element:this.uploadDialogObj.element};this.trigger("popupClose",e)},s.prototype.onUploading=function(e){var i="save";if(0!==this.retryArgs.length)for(var n=0;n<this.retryArgs.length;n++)e.fileData.name===this.retryArgs[n].file.name&&(i=this.retryArgs[n].action,this.retryArgs.splice(n,1),n=this.retryArgs.length);var s=JSON.stringify(t.getValue(this.pathId[this.pathId.length-1],this.feParent));e.customFormData=[{path:this.path},{action:i},{data:s}];var a={url:this.ajaxSettings.uploadUrl?this.ajaxSettings.uploadUrl:this.ajaxSettings.url,type:"POST",mode:!0,dataType:null,contentType:null,data:JSON.stringify(e.customFormData),onSuccess:null,onFailure:null,beforeSend:null};this.uploadEventArgs={action:"Upload",ajaxSettings:a,cancel:!1},this.trigger("beforeSend",this.uploadEventArgs,function(i){e.customFormData=JSON.parse(t.getValue("data",i.ajaxSettings)),e.cancel=i.cancel;var n={cancel:!1,httpRequest:e.currentRequest};"function"==typeof t.getValue("beforeSend",i.ajaxSettings)&&(t.getValue("beforeSend",i.ajaxSettings)(n),t.getValue("cancel",n)&&(e.cancel=t.getValue("cancel",n)))})},s.prototype.onRemoving=function(){this.onFileUploadSuccess({count:1}),1===this.uploadObj.getFilesData().length&&this.uploadDialogObj.hide()},s.prototype.onCancel=function(e){var i=JSON.stringify(t.getValue(this.pathId[this.pathId.length-1],this.feParent));e.customFormData=[{path:this.path},{action:"remove"},{data:i}]},s.prototype.onClearing=function(){this.isOpened&&this.uploadDialogObj.hide()},s.prototype.onSelected=function(e){if(0!==e.filesData.length){this.uploadingCount=e.filesData.length,this.uploadedCount=0;var t=S(this);if(!de(t))return e.cancel=!0,void ae(this,t,ss);this.uploadDialogObj.show()}},s.prototype.onFileUploadSuccess=function(e){this.uploadedCount=this.uploadedCount+e.count,this.uploadSettings.autoClose&&this.uploadingCount===this.uploadedCount&&this.uploadDialogObj.hide()},s.prototype.onUploadSuccess=function(e){var i={action:"Upload",result:e};this.trigger("success",i),this.itemData=[t.getValue(this.pathId[this.pathId.length-1],this.feParent)],fe(this,fn,this.path),this.onFileUploadSuccess({count:1}),"function"==typeof t.getValue("onSuccess",this.uploadEventArgs.ajaxSettings)&&t.getValue("onSuccess",this.uploadEventArgs.ajaxSettings)()},s.prototype.onUploadFailure=function(e){var i=t.getValue("response",e),n=t.getValue("statusText",i);""!==n&&t.setValue("statusText",n,e);var s={action:"Upload",error:e};this.trigger("failure",s),400===t.getValue("statusCode",i)&&(this.retryFiles.push(t.getValue("file",e)),this.isRetryOpened||Te(this,"UploadRetry")),"function"==typeof t.getValue("onFailure",this.uploadEventArgs.ajaxSettings)&&t.getValue("onFailure",this.uploadEventArgs.ajaxSettings)()},s.prototype.onInitialEnd=function(){!function(e,i){for(var n=i.split("/"),s=e.originalPath.split("/"),a=t.getValue(e.pathId[0],e.feParent),r=t.isNullOrUndefined(t.getValue("id",a))?"name":"id",o=n.length-1,l=s.length-1;o<l;o++){var h=""===s[o+1]?an:sn,d=""===s[o]?"/":e.path+s[o]+"/",p=M(e,r,s[o]),c=t.getValue("_fm_id",p);e.setProperties({path:d},!0),e.pathId.push(c),e.itemData=[p],e.pathNames.push(t.getValue("name",p)),fe(e,h,e.path);break}}(this,this.path)},s.prototype.addEventListeners=function(){this.on(mn,this.showSpinner,this),this.on(yn,this.hideSpinner,this),this.on(sn,this.onInitialEnd,this),this.on(Rn,this.onDetailsInit,this),this.on(bn,this.onFileUploadSuccess,this),t.EventHandler.add(this.element,"contextmenu",this.onContextMenu,this)},s.prototype.removeEventListeners=function(){this.isDestroyed||(this.off(mn,this.showSpinner),this.off(yn,this.hideSpinner),this.off(sn,this.onInitialEnd),this.off(Rn,this.onDetailsInit),this.off(bn,this.onFileUploadSuccess),t.EventHandler.remove(this.element,"contextmenu",this.onContextMenu))},s.prototype.onDetailsInit=function(){t.isNullOrUndefined(this.activeModule)&&(this.itemData=[t.getValue(this.pathId[this.pathId.length-1],this.feParent)])},s.prototype.resizeHandler=function(){this.adjustHeight(),this.notify(cn,{})},s.prototype.keyActionHandler=function(e){switch(e.action){case"altN":e.preventDefault(),this.itemData=[S(this)],he(this.itemData[0])?Le(this,"NewFolder"):ae(this,this.itemData[0],ns);break;case"f5":e.preventDefault(),w(this);break;case"ctrlShift1":e.preventDefault(),this.fileView="Details",this.setProperties({view:"Details"},!0),n.showSpinner(this.element),O(this,"Details");break;case"ctrlShift2":e.preventDefault(),this.fileView="LargeIcons",this.setProperties({view:"LargeIcons"},!0),n.showSpinner(this.element),O(this,"LargeIcons");break;case"ctrlU":e.preventDefault(),t.select("#"+this.element.id+Bt,this.element).click()}},s.prototype.wireEvents=function(){t.EventHandler.add(window,"resize",this.resizeHandler,this),this.keyboardModule=new t.KeyboardEvents(this.element,{keyAction:this.keyActionHandler.bind(this),keyConfigs:this.keyConfigs,eventName:"keydown"})},s.prototype.unWireEvents=function(){t.EventHandler.remove(window,"resize",this.resizeHandler),this.keyboardModule.destroy()},s.prototype.setPath=function(){this.setProperties({selectedItems:[]},!0),this.ensurePath(),this.notify(xn,{selectedNode:this.pathId[0]}),fe(this,this.path!==this.originalPath?sn:an,this.path)},s.prototype.onPropertyChanged=function(e,i){for(var n,s=0,a=Object.keys(e);s<a.length;s++){switch(a[s]){case"ajaxSettings":this.ajaxSettingSetModel(e);break;case"allowDragAndDrop":this.allowDragAndDrop=e.allowDragAndDrop,this.notify(nn,{module:"common",newProp:e,oldProp:i});break;case"allowMultiSelection":this.allowMultiSelection?t.addClass([this.element],qt):(this.selectedItems.length>1&&this.setProperties({selectedItems:this.selectedItems.slice(this.selectedItems.length-1)},!0),t.removeClass([this.element],qt)),this.notify(nn,{module:"common",newProp:e,oldProp:i});break;case"cssClass":this.addCssClass(i.cssClass,e.cssClass),this.notify(nn,{module:"common",newProp:e,oldProp:i});break;case"detailsViewSettings":this.notify(nn,{module:"detailsview",newProp:e,oldProp:i});break;case"enableRtl":this.enableRtl=e.enableRtl,this.refresh();break;case"rootAliasName":this.rootAliasName=e.rootAliasName,this.refresh();break;case"height":n=t.isNullOrUndefined(e.height)?e.height:t.formatUnit(e.height),t.setStyleAttribute(this.element,{height:n}),this.adjustHeight(),this.notify(nn,{module:"common",newProp:e,oldProp:i});break;case"locale":t.isNullOrUndefined(e.enableRtl)||this.setProperties({enableRtl:e.enableRtl},!0),this.localeSetModelOption(e);break;case"navigationPaneSettings":this.splitterAdjust(),this.notify(nn,{module:"navigationpane",newProp:e,oldProp:i});break;case"path":this.setPath();break;case"searchSettings":t.isNullOrUndefined(e.searchSettings.allowSearchOnTyping)||this.setProperties({searchSettings:{allowSearchOnTyping:e.searchSettings.allowSearchOnTyping}},!0),t.isNullOrUndefined(e.searchSettings.ignoreCase)&&this.setProperties({searchSettings:{ignoreCase:e.searchSettings.ignoreCase}},!0),t.isNullOrUndefined(e.searchSettings.filterType)&&this.setProperties({searchSettings:{filterType:e.searchSettings.filterType}},!0),this.notify(nn,{module:"breadcrumbbar",newProp:e,oldProp:i});break;case"selectedItems":"Details"===this.view?this.notify(nn,{module:"detailsview",newProp:e,oldProp:i}):"LargeIcons"===this.view&&this.notify(nn,{module:"largeiconsview",newProp:e,oldProp:i});break;case"showFileExtension":case"showHiddenItems":this.notify(nn,{module:"common",newProp:e,oldProp:i});break;case"showThumbnail":this.notify(nn,{module:"largeiconsview",newProp:e,oldProp:i});break;case"toolbarSettings":this.adjustHeight(),this.notify(nn,{module:"toolbar",newProp:e,oldProp:i});break;case"uploadSettings":this.updateUploader();break;case"view":"Details"===e.view?this.notify(nn,{module:"detailsview",newProp:e,oldProp:i}):"LargeIcons"===e.view&&this.notify(nn,{module:"largeiconsview",newProp:e,oldProp:i});break;case"width":t.setStyleAttribute(this.element,{width:t.isNullOrUndefined(e.width)?e.width:t.formatUnit(e.width)}),this.notify(nn,{module:"common",newProp:e,oldProp:i});break;case"sortOrder":w(this),this.notify(Pn,{});break;case"popupTarget":this.uploadDialogObj&&(this.uploadDialogObj.target=e.popupTarget),this.dialogObj&&(this.dialogObj.target=e.popupTarget),this.extDialogObj&&(this.extDialogObj.target=e.popupTarget),this.viewerObj&&(this.viewerObj.target=e.popupTarget)}}},s.prototype.ajaxSettingSetModel=function(i){t.isNullOrUndefined(i.ajaxSettings.url)||this.setProperties({ajaxSettings:{url:i.ajaxSettings.url}},!0),t.isNullOrUndefined(i.ajaxSettings.uploadUrl)||this.setProperties({ajaxSettings:{uploadUrl:i.ajaxSettings.uploadUrl}},!0),t.isNullOrUndefined(i.ajaxSettings.downloadUrl)||this.setProperties({ajaxSettings:{downloadUrl:i.ajaxSettings.downloadUrl}},!0),t.isNullOrUndefined(i.ajaxSettings.getImageUrl)||this.setProperties({ajaxSettings:{getImageUrl:i.ajaxSettings.getImageUrl}},!0),this.setProperties({path:"/"},!0),this.setProperties({selectedItems:[]},!0),e.prototype.refresh.call(this)},s.prototype.localeSetModelOption=function(t){this.uploadObj.locale=t.locale,e.prototype.refresh.call(this)},s.prototype.destroy=function(){this.isDestroyed||(this.refreshing||this.notify(gn,{}),this.uploadObj.destroy(),this.uploadObj=null,this.uploadDialogObj.destroy(),this.uploadDialogObj=null,this.splitterObj.destroy(),this.splitterObj=null,this.dialogObj&&(this.dialogObj.destroy(),this.dialogObj=null),this.viewerObj&&(this.viewerObj.destroy(),this.viewerObj=null),this.extDialogObj&&(this.extDialogObj.destroy(),this.extDialogObj=null),this.element.removeAttribute("style"),this.element.removeAttribute("tabindex"),this.removeEventListeners(),this.unWireEvents(),this.addCssClass(this.cssClass,null),t.removeClass([this.element],["e-rtl",Kt,qt]),this.element.innerHTML="",e.prototype.destroy.call(this))},s.prototype.createFolder=function(e){this.notify(es,{action:"createFolder"});var t=[S(this)];if(this.itemData=t,e)if(/[/\\|*?"<>:]/.test(e)){Le(this,"Error",{files:null,error:{code:"402",message:T(this,"Validation-Invalid").replace("{0}",'"'+e+'"'),fileExists:null}})}else he(t[0])?ge(this,e):ae(this,t[0],ns);else ce(this)},s.prototype.deleteFiles=function(e){this.notify(es,{action:"deleteFiles",ids:e})},s.prototype.disableToolbarItems=function(e){t.isNullOrUndefined(e)||this.toolbarModule.enableItems(e,!1)},s.prototype.downloadFiles=function(e){this.notify(es,{action:"downloadFiles",ids:e})},s.prototype.enableToolbarItems=function(e){t.isNullOrUndefined(e)||this.toolbarModule.enableItems(e,!0)},s.prototype.disableMenuItems=function(e){t.isNullOrUndefined(e)||t.isNullOrUndefined(this.contextmenuModule.contextMenu)||this.contextmenuModule.disableItem(e)},s.prototype.getMenuItemIndex=function(e){return this.contextmenuModule?this.contextmenuModule.getItemIndex(e):-1},s.prototype.getToolbarItemIndex=function(e){return this.toolbarModule?this.toolbarModule.getItemIndex(e):-1},s.prototype.filterFiles=function(e){this.filterData=e||null,this.setProperties({selectedItems:[]},!0),this.notify(Sn,{}),this.isFiltered=!0,""!==this.breadcrumbbarModule.searchObj.element.value&&(this.breadcrumbbarModule.searchObj.element.value=""),me(this,on)},s.prototype.getSelectedFiles=function(){return this.notify(Zn,{}),this.itemData},s.prototype.openFile=function(e){this.notify(es,{action:"openFile",id:e})},s.prototype.refreshFiles=function(){w(this)},s.prototype.refreshLayout=function(){this.adjustHeight(),this.notify(vn,{})},s.prototype.selectAll=function(){this.notify(es,{action:"selectAll"})},s.prototype.clearSelection=function(){this.notify(es,{action:"clearSelection"})},s.prototype.renameFile=function(e,t){this.notify(es,{action:"renameFile",id:e,newName:t})},s.prototype.uploadFiles=function(){var e=[S(this)];this.itemData=e,ue(this)},s.prototype.setRtl=function(e){e?this.addCssClass(null,"e-rtl"):this.addCssClass("e-rtl",null),this.uploadObj&&(this.uploadDialogObj.enableRtl=e,this.uploadObj.enableRtl=e)};var r;return ps([t.Complex({},it)],s.prototype,"ajaxSettings",void 0),ps([t.Property(!1)],s.prototype,"allowDragAndDrop",void 0),ps([t.Property(!0)],s.prototype,"allowMultiSelection",void 0),ps([t.Complex({},vt)],s.prototype,"contextMenuSettings",void 0),ps([t.Property("")],s.prototype,"cssClass",void 0),ps([t.Complex({},ut)],s.prototype,"detailsViewSettings",void 0),ps([t.Property(!0)],s.prototype,"enableHtmlSanitizer",void 0),ps([t.Property(!1)],s.prototype,"enablePersistence",void 0),ps([t.Property("400px")],s.prototype,"height",void 0),ps([t.Property("LargeIcons")],s.prototype,"view",void 0),ps([t.Complex({},wt)],s.prototype,"navigationPaneSettings",void 0),ps([t.Property("/")],s.prototype,"path",void 0),ps([t.Property(null)],s.prototype,"popupTarget",void 0),ps([t.Complex({},ht)],s.prototype,"searchSettings",void 0),ps([t.Property()],s.prototype,"selectedItems",void 0),ps([t.Property(!0)],s.prototype,"showFileExtension",void 0),ps([t.Property(null)],s.prototype,"rootAliasName",void 0),ps([t.Property(!1)],s.prototype,"showHiddenItems",void 0),ps([t.Property(!0)],s.prototype,"showThumbnail",void 0),ps([t.Property("Ascending")],s.prototype,"sortOrder",void 0),ps([t.Complex({},rt)],s.prototype,"toolbarSettings",void 0),ps([t.Complex({},Ct)],s.prototype,"uploadSettings",void 0),ps([t.Property("100%")],s.prototype,"width",void 0),ps([t.Event()],s.prototype,"fileLoad",void 0),ps([t.Event()],s.prototype,"fileOpen",void 0),ps([t.Event()],s.prototype,"beforeDownload",void 0),ps([t.Event()],s.prototype,"beforeImageLoad",void 0),ps([t.Event()],s.prototype,"beforePopupClose",void 0),ps([t.Event()],s.prototype,"beforePopupOpen",void 0),ps([t.Event()],s.prototype,"beforeSend",void 0),ps([t.Event()],s.prototype,"created",void 0),ps([t.Event()],s.prototype,"destroyed",void 0),ps([t.Event()],s.prototype,"fileDragStart",void 0),ps([t.Event()],s.prototype,"fileDragging",void 0),ps([t.Event()],s.prototype,"fileDragStop",void 0),ps([t.Event()],s.prototype,"fileDropped",void 0),ps([t.Event()],s.prototype,"fileSelection",void 0),ps([t.Event()],s.prototype,"fileSelect",void 0),ps([t.Event()],s.prototype,"menuClick",void 0),ps([t.Event()],s.prototype,"menuOpen",void 0),ps([t.Event()],s.prototype,"failure",void 0),ps([t.Event()],s.prototype,"popupClose",void 0),ps([t.Event()],s.prototype,"popupOpen",void 0),ps([t.Event()],s.prototype,"success",void 0),ps([t.Event()],s.prototype,"toolbarClick",void 0),ps([t.Event()],s.prototype,"toolbarCreate",void 0),ps([t.Event()],s.prototype,"uploadListCreate",void 0),s=r=ps([t.NotifyPropertyChanges],s)}(t.Component),us=function(){function e(e){this.default=["Delete","Rename","Download","Cut","Copy","Paste"],this.single=["Delete","Rename","Download","Cut","Copy"],this.multiple=["Delete","Download","Cut","Copy","Refresh"],this.selection=["NewFolder","Upload","SortBy","Refresh"],this.parent=e,this.render(),this.addEventListener()}return e.prototype.render=function(){var e=this;this.items=this.toolbarItemData(this.getItems(this.parent.toolbarSettings.items.map(function(e){return e.trim()})));var t={items:this.items};this.parent.trigger("toolbarCreate",t,function(t){e.items=t.items,e.toolbarObj=new h.Toolbar({items:e.items,created:e.toolbarCreateHandler.bind(e),overflowMode:"Popup",clicked:e.onClicked.bind(e),enableHtmlSanitizer:e.parent.enableHtmlSanitizer,enableRtl:e.parent.enableRtl}),e.toolbarObj.isStringTemplate=!0,e.toolbarObj.appendTo("#"+e.parent.element.id+Pt)})},e.prototype.getItemIndex=function(e){for(var t=this.getId(e),i=0;i<this.items.length;i++)if(this.items[i].id===t)return i;return-1},e.prototype.getItems=function(e){var t=e.slice();return this.parent.isDevice&&this.parent.allowMultiSelection&&t.push("SelectAll"),t},e.prototype.onClicked=function(e){var i=this;if(!t.isNullOrUndefined(e.item)&&e.item.id){var n,s=e.item.id.substr((this.parent.element.id+"_tb_").length);"refresh"===s||"newfolder"===s||"upload"===s?(n=[S(this.parent)],this.parent.itemData=n):(this.parent.notify(Un,{}),n=this.parent.itemData);var a={cancel:!1,fileDetails:n,item:e.item};this.parent.trigger("toolbarClick",a,function(a){var r,o;if(!a.cancel)switch(s){case"sortby":(o=t.closest(e.originalEvent.target,"."+$t))&&o.classList.contains("e-toolbar-popup")&&(e.cancel=!0);break;case"newfolder":ce(i.parent);break;case"cut":j(i.parent);break;case"copy":C(i.parent);break;case"delete":for(var l=0;l<n.length;l++)if(!le(n[l]))return void ae(i.parent,n[l],is);Le(i.parent,"Delete");break;case"details":i.parent.notify(Rn,{}),r=i.parent.selectedItems,"navigationpane"===i.parent.activeModule&&(r=[]),Oe(i.parent,r,i.parent.path,"details");break;case"paste":i.parent.folderPath="",_(i.parent);break;case"refresh":w(i.parent);break;case"download":ie(i.parent);break;case"rename":le(n[0])?(i.parent.notify(kn,{}),Le(i.parent,"Rename")):ae(i.parent,n[0],is);break;case"upload":ue(i.parent);break;case"selectall":i.parent.notify(Cn,{});break;case"selection":i.parent.notify(jn,{})}})}},e.prototype.toolbarCreateHandler=function(){if(!t.isNullOrUndefined(t.select("#"+this.getId("SortBy"),this.parent.element))){var e=[{id:this.getPupupId("name"),text:T(this.parent,"Name"),iconCss:ni},{id:this.getPupupId("size"),text:T(this.parent,"Size")},{id:this.getPupupId("date"),text:T(this.parent,"DateModified")},{separator:!0},{id:this.getPupupId("ascending"),text:T(this.parent,"Ascending"),iconCss:"Ascending"===this.parent.sortOrder?ii:""},{id:this.getPupupId("descending"),text:T(this.parent,"Descending"),iconCss:"Descending"===this.parent.sortOrder?ii:""},{id:this.getPupupId("none"),text:T(this.parent,"None"),iconCss:"None"===this.parent.sortOrder?ii:""}];this.buttonObj=new l.DropDownButton({items:e,cssClass:A(this.parent,Wt),select:F.bind(this,this.parent),enableHtmlSanitizer:this.parent.enableHtmlSanitizer,enableRtl:this.parent.enableRtl,iconCss:_i}),this.buttonObj.isStringTemplate=!0,this.buttonObj.appendTo("#"+this.getId("SortBy"))}if(!t.isNullOrUndefined(t.select("#"+this.getId("View"),this.parent.element))){var i=[{id:this.getPupupId("large"),text:'<span class="e-icons e-fe-large e-menu-icon"></span>'+T(this.parent,"View-LargeIcons"),iconCss:"Details"===this.parent.view?"":ii},{id:this.getPupupId("details"),text:'<span class="e-icons e-fe-grid e-menu-icon"></span>'+T(this.parent,"View-Details"),iconCss:"Details"===this.parent.view?ii:""}];this.layoutBtnObj=new l.DropDownButton({iconCss:"Details"===this.parent.view?qi:Wi,cssClass:A(this.parent,"e-caret-hide "+Wt),items:i,select:this.layoutChange.bind(this),enableRtl:this.parent.enableRtl,enableHtmlSanitizer:this.parent.enableHtmlSanitizer,content:'<span class="e-tbar-btn-text">'+T(this.parent,"View")+"</span>"}),this.layoutBtnObj.isStringTemplate=!0,this.layoutBtnObj.appendTo("#"+this.getId("View"))}this.hideItems(this.default,!0),this.hideStatus();for(var n=t.selectAll(".e-btn",this.toolbarObj.element),s=function(e){n[e].onkeydown=function(e){13!==e.keyCode||e.target.classList.contains("e-fe-popup")||e.preventDefault()},n[e].onkeyup=function(t){13!==t.keyCode||t.target.classList.contains("e-fe-popup")||n[e].click()}},a=0;a<n.length;a++)s(a);this.parent.refreshLayout()},e.prototype.updateSortByButton=function(){if(this.buttonObj)for(var e=this.buttonObj.items,t=0;t<e.length;t++)e[t].id===this.getPupupId("name")?e[t].iconCss="name"===this.parent.sortBy?ni:"":e[t].id===this.getPupupId("size")?e[t].iconCss="size"===this.parent.sortBy?ni:"":e[t].id===this.getPupupId("date")?e[t].iconCss="_fm_modified"===this.parent.sortBy?ni:"":e[t].id===this.getPupupId("ascending")?e[t].iconCss="Ascending"===this.parent.sortOrder?ii:"":e[t].id===this.getPupupId("descending")?e[t].iconCss="Descending"===this.parent.sortOrder?ii:"":e[t].id===this.getPupupId("none")&&(e[t].iconCss="None"===this.parent.sortOrder?ii:"")},e.prototype.getPupupId=function(e){return this.parent.element.id+"_ddl_"+e.toLowerCase()},e.prototype.layoutChange=function(e){"Details"===this.parent.view?e.item.id===this.getPupupId("large")&&O(this.parent,"LargeIcons"):e.item.id===this.getPupupId("details")&&O(this.parent,"Details")},e.prototype.toolbarItemData=function(e){var t=[],i="Both";this.parent.isMobile&&(i="Overflow");for(var n=0;n<e.length;n++){var s=void 0,a=this.getId(e[n]),r=T(this.parent,e[n]),o=T(this.parent,"Tooltip-"+e[n]),l='<span class="e-tbar-btn-text e-tbar-ddb-text">'+r+"</span>";switch(e[n]){case"|":s={type:"Separator"};break;case"Upload":s={id:a,text:r,tooltipText:o,prefixIcon:Mi,showTextOn:i};break;case"SortBy":s={id:a,tooltipText:o,template:'<button id="'+a+'" class="e-tbar-btn e-tbtn-txt" tabindex="-1">'+l+"</button>"};break;case"Refresh":s={id:a,text:r,tooltipText:o,prefixIcon:Bi,showTextOn:i};break;case"Selection":s={id:a,text:r,tooltipText:o,suffixIcon:Gi,overflow:"Show",align:"Right"};break;case"View":s={id:a,tooltipText:o,prefixIcon:"Details"===this.parent.view?qi:Wi,overflow:"Show",align:"Right",text:r,showTextOn:"Overflow",template:'<button id="'+a+'" class="e-tbar-btn e-tbtn-txt" tabindex="-1" aria-label='+T(this.parent,"View")+"></button>"};break;case"Details":s={id:a,tooltipText:o,prefixIcon:Vi,overflow:"Show",align:"Right",text:r,showTextOn:"Overflow"};break;case"NewFolder":s={id:a,text:r,tooltipText:o,prefixIcon:Ui,showTextOn:i};break;case"Cut":s={id:a,text:r,tooltipText:o,prefixIcon:ki,showTextOn:i};break;case"Copy":s={id:a,text:r,tooltipText:o,prefixIcon:Li,showTextOn:i};break;case"Paste":s={id:a,text:r,tooltipText:o,prefixIcon:Ti,showTextOn:i};break;case"Delete":s={id:a,text:r,tooltipText:o,prefixIcon:Ai,showTextOn:i};break;case"Rename":s={id:a,text:r,tooltipText:o,prefixIcon:Fi,showTextOn:i};break;case"Download":s={id:a,text:r,tooltipText:o,prefixIcon:zi,showTextOn:i};break;case"SelectAll":s={id:a,text:r,tooltipText:o,prefixIcon:Hi,showTextOn:i};break;default:s={id:a,text:r,tooltipText:o}}t.push(s)}return t},e.prototype.getId=function(e){return this.parent.element.id+"_tb_"+e.toLowerCase()},e.prototype.addEventListener=function(){this.parent.on(nn,this.onPropertyChanged,this),this.parent.on(Sn,this.onSelectionChanged,this),this.parent.on(Nn,this.onLayoutChange,this),this.parent.on(An,this.showPaste,this),this.parent.on(Fn,this.hidePaste,this),this.parent.on(gn,this.destroy,this),this.parent.on(Pn,this.updateSortByButton,this)},e.prototype.reRenderToolbar=function(e){var t=this;if(void 0!==e.newProp.toolbarSettings.items){this.items=this.toolbarItemData(this.getItems(e.newProp.toolbarSettings.items.map(function(e){return e.trim()})));var i={items:this.items};this.parent.trigger("toolbarCreate",i,function(e){t.buttonObj&&t.buttonObj.destroy(),t.layoutBtnObj&&t.layoutBtnObj.destroy(),t.items=e.items,t.toolbarObj.items=t.items,t.toolbarObj.dataBind(),t.toolbarCreateHandler()})}},e.prototype.onSelectionChanged=function(){this.hideStatus(),this.hideItems(this.single,!0),this.hideItems(this.selection,!1),1===this.parent.selectedItems.length?(this.hideItems(this.single,!1),this.hideItems(this.selection,!0)):this.parent.selectedItems.length>1&&(this.hideItems(this.multiple,!1),this.hideItems(this.selection,!0));var e=t.select("#"+this.getId("Selection"),this.toolbarObj.element);if(this.parent.selectedItems.length>0&&e){var i=void 0;i=1===this.parent.selectedItems.length?this.parent.selectedItems.length+" "+T(this.parent,"Item-Selection"):this.parent.selectedItems.length+" "+T(this.parent,"Items-Selection"),t.select(".e-tbar-btn-text",e).textContent=i,this.toolbarObj.hideItem(e.parentElement,!1)}},e.prototype.hideItems=function(e,i){for(var n=0;n<e.length;n++){var s=t.select("#"+this.getId(e[n]),this.parent.element);s&&this.toolbarObj.hideItem(s.parentElement,i)}},e.prototype.hideStatus=function(){var e=t.select("#"+this.getId("Selection"),this.toolbarObj.element);e&&this.toolbarObj.hideItem(e.parentElement,!0)},e.prototype.showPaste=function(){this.hideItems(["Paste"],!1)},e.prototype.hidePaste=function(){this.hideItems(["Paste"],!0)},e.prototype.onLayoutChange=function(){if(this.layoutBtnObj){this.layoutBtnObj.iconCss="Details"===this.parent.view?qi:Wi;for(var e=this.layoutBtnObj.items,t=0;t<e.length;t++)e[t].id===this.getPupupId("large")?e[t].iconCss="LargeIcons"===this.parent.view?ii:"":e[t].id===this.getPupupId("details")&&(e[t].iconCss="Details"===this.parent.view?ii:"")}},e.prototype.removeEventListener=function(){this.parent.off(nn,this.onPropertyChanged),this.parent.off(Sn,this.onSelectionChanged),this.parent.off(Nn,this.onLayoutChange),this.parent.off(An,this.showPaste),this.parent.off(Fn,this.hidePaste),this.parent.off(gn,this.destroy),this.parent.off(Pn,this.updateSortByButton)},e.prototype.getModuleName=function(){return"toolbar"},e.prototype.onPropertyChanged=function(e){if(e.module===this.getModuleName()||"common"===e.module)for(var t=0,i=Object.keys(e.newProp);t<i.length;t++){switch(i[t]){case"cssClass":this.buttonObj&&(this.buttonObj.cssClass=A(this.parent,Wt)),this.layoutBtnObj&&(this.layoutBtnObj.cssClass=A(this.parent,"e-caret-hide "+Wt));break;case"height":case"width":this.toolbarObj.refreshOverflow();break;case"toolbarSettings":this.reRenderToolbar(e)}}},e.prototype.destroy=function(){this.parent.isDestroyed||(this.removeEventListener(),this.buttonObj&&this.buttonObj.destroy(),this.layoutBtnObj&&this.layoutBtnObj.destroy(),this.toolbarObj.destroy(),this.parent.refreshLayout())},e.prototype.enableItems=function(e,i){for(var n=0;n<e.length;n++){var s=t.select("#"+this.getId(e[n]),this.parent.element);s&&this.toolbarObj.enableItems(s.parentElement,i)}},e}(),fs=function(){function e(e){this.removeNodes=[],this.moveNames=[],this.expandTree=!1,this.isDrag=!1,this.isPathDragged=!1,this.isRenameParent=!1,this.isRightClick=!1,this.renameParent=null,this.previousSelected=null,this.isNodeClickCalled=!1,this.restrictSelecting=!1,this.parent=e,this.addEventListener(),this.keyConfigs={altEnter:"alt+enter",esc:"escape",del:"delete",ctrlX:"ctrl+x",ctrlC:"ctrl+c",ctrlV:"ctrl+v",ctrlShiftN:"ctrl+shift+n",shiftF10:"shift+F10",f2:"f2"}}return e.prototype.onInit=function(){if(t.isNullOrUndefined(this.treeObj)){var e=t.getValue(this.parent.pathId[0],this.parent.feParent);t.setValue("_fm_icon","e-fe-folder",e);var i={},n=t.getValue("id",e);t.isNullOrUndefined(n)||t.setValue("data-id",n,i),le(e)||t.setValue("class",re(e),i),t.isNullOrUndefined(i)||t.setValue("_fm_htmlAttr",i,e),this.treeObj=new h.TreeView({fields:{dataSource:[e],id:"_fm_id",parentID:"_fm_pId",expanded:"_fm_expanded",selected:"_fm_selected",text:"name",hasChildren:"hasChild",iconCss:"_fm_icon",htmlAttributes:"_fm_htmlAttr",tooltip:"name"},enableHtmlSanitizer:this.parent.enableHtmlSanitizer,sortOrder:this.parent.navigationPaneSettings.sortOrder,nodeSelecting:this.onNodeSelecting.bind(this),nodeSelected:this.onNodeSelected.bind(this),nodeExpanding:this.onNodeExpand.bind(this),nodeClicked:this.onNodeClicked.bind(this),allowEditing:!0,nodeEditing:this.onNodeEditing.bind(this),drawNode:this.onDrowNode.bind(this),enableRtl:this.parent.enableRtl,dataBound:this.addDragDrop.bind(this)}),this.treeObj.isStringTemplate=!0,this.treeObj.appendTo("#"+this.parent.element.id+Rt),this.wireEvents()}},e.prototype.addDragDrop=function(){var e=this;!this.parent.isMobile&&this.treeObj&&(this.parent.allowDragAndDrop?(this.dragObj&&this.dragObj.destroy(),this.dragObj=new t.Draggable(this.treeObj.element,{cursorAt:this.parent.dragCursorPosition,dragTarget:"."+Xi,distance:5,dragArea:this.parent.element,drag:$.bind(this,this.parent),dragStart:function(t){Y(e.parent,t,e.dragObj)},dragStop:G.bind(this,this.parent),enableTailMode:!0,enableAutoScroll:!0,helper:this.dragHelper.bind(this)})):!this.parent.allowDragAndDrop&&this.dragObj&&this.dragObj.destroy())},e.prototype.dragHelper=function(e){var i=e.sender.target;if(!i.classList.contains(Xi))return null;var n=t.closest(i,"li");return this.parent.dragPath="",this.parent.dragData=[],this.parent.activeElements=[],this.parent.activeElements=[n],this.parent.dragNodes=[],y(this.parent,n),this.parent.dragData=this.getTreeData(n),this.parent.dragPath=this.getDragPath(n,this.parent.dragData[0].name),this.parent.dragNodes.push(this.parent.dragData[0].name),K(this.parent),this.parent.virtualDragElement},e.prototype.getDragPath=function(e,t){return H(this.getDropPath(e,t))},e.prototype.getDropPath=function(e,t){var i=e.getAttribute("data-id");return c(e,this.parent.hasId?i:t,this.parent.hasId)},e.prototype.onDrowNode=function(e){var t={element:e.node,fileDetails:e.nodeData,module:"NavigationPane"};this.parent.trigger("fileLoad",t)},e.prototype.addChild=function(e,i,n){var s=L(e);if(s.length>0){for(var a=0,r=s;a<s.length;){r[a]._fm_icon="e-fe-folder";var o={},l=t.getValue("id",r[a]);t.isNullOrUndefined(l)||t.setValue("data-id",l,o),le(r[a])||t.setValue("class",re(r[a]),o),t.isNullOrUndefined(o)||t.setValue("_fm_htmlAttr",o,r[a]),a++}this.treeObj.addNodes(s,i,null,n)}},e.prototype.onNodeSelecting=function(e){if(!e.isInteracted&&!this.isRightClick&&!this.isPathDragged&&!this.isRenameParent||this.restrictSelecting)return this.restrictSelecting=!1,void(this.isNodeClickCalled=!1);if(!this.renameParent){this.parent.activeModule="navigationpane";var i={cancel:!1,fileDetails:this.getTreeData(t.getValue("id",e.nodeData))[0],module:"NavigationPane"};this.parent.trigger("fileOpen",i),e.cancel=i.cancel,e.cancel&&(this.restrictSelecting=!!this.isNodeClickCalled&&this.previousSelected[0]!=e.node.getAttribute("data-uid"),this.treeObj.selectedNodes=this.isNodeClickCalled?this.previousSelected:this.treeObj.selectedNodes,this.previousSelected=this.treeObj.selectedNodes,t.isNullOrUndefined(this.parent)||t.isNullOrUndefined(this.parent.contextmenuModule)||this.parent.contextmenuModule.contextMenu.enableItems(["Open"],!0))}},e.prototype.openFileOnContextMenuClick=function(e){var t=this.treeObj.getTreeData(e);this.parent.selectedItems=[],this.parent.itemData=t,this.activeNode=e,this.parent.activeModule="navigationpane",p(e,this.parent.itemData[0],this.parent),fe(this.parent,this.isPathDragged?Bn:fn,this.parent.path),this.parent.visitedItem=e,this.isPathDragged=this.isRenameParent=this.isRightClick=!1,this.treeObj.selectedNodes=[e.getAttribute("data-uid")]},e.prototype.onNodeSelected=function(e){if(this.parent.breadcrumbbarModule&&this.parent.breadcrumbbarModule.searchObj&&!this.renameParent&&(this.parent.breadcrumbbarModule.searchObj.element.value="",this.parent.isFiltered=!1),this.parent.searchedItems=[],e.isInteracted||this.isRightClick||this.isPathDragged||this.isRenameParent){this.activeNode=e.node,this.parent.activeModule="navigationpane";var i=this.getTreeData(t.getValue("id",e.nodeData));this.parent.selectedItems=[],this.parent.itemData=i;var n=this.parent.path;p(e.node,this.parent.itemData[0],this.parent),n!==this.parent.path&&(this.expandNodeTarget=null,e.node.querySelector("."+Yi)&&null===e.node.querySelector("."+Zt)&&(this.expandNodeTarget="add"),fe(this.parent,this.isPathDragged?Bn:fn,this.parent.path),this.parent.visitedItem=e.node),this.isPathDragged=this.isRenameParent=this.isRightClick=!1}},e.prototype.onPathDrag=function(e){this.isPathDragged=!0,this.selectResultNode(e[0])},e.prototype.onNodeExpand=function(e){if((e.isInteracted||this.isDrag)&&null===e.node.querySelector("."+Zt)){var i=t.getValue("text",e.nodeData),n=e.node.getAttribute("data-id"),s=!t.isNullOrUndefined(n),a=t.isNullOrUndefined(n)?i:n,r=c(e.node,a,s);this.expandNodeTarget=e.node.getAttribute("data-uid"),this.parent.expandedId=this.expandNodeTarget,this.parent.itemData=this.getTreeData(t.getValue("id",e.nodeData)),fe(this.parent,En,r)}},e.prototype.onNodeExpanded=function(e){this.addChild(e.files,this.expandNodeTarget,!1),this.parent.expandedId=null},e.prototype.onNodeClicked=function(e){if(this.parent.activeModule="navigationpane",this.previousSelected=this.treeObj.selectedNodes,this.activeNode=e.node,3===e.event.which&&e.node.getAttribute("data-uid")!==this.treeObj.selectedNodes[0])this.isRightClick=!0,this.isNodeClickCalled=!0,this.treeObj.selectedNodes=[e.node.getAttribute("data-uid")];else if(e.node.getAttribute("data-uid")===this.treeObj.selectedNodes[0]&&0!==this.parent.selectedItems.length){this.parent.setProperties({selectedItems:[]},!0);var t="LargeIcons"===this.parent.view?"largeiconsview":"detailsview";this.parent.notify(nn,{module:t,newProp:{selectedItems:[]}})}},e.prototype.onNodeEditing=function(e){t.isNullOrUndefined(e.innerHtml)||(e.cancel=!0)},e.prototype.onPathChanged=function(e){this.parent.isCut=!1;var i=t.getValue(this.parent.pathId[this.parent.pathId.length-1],this.parent.feFiles);if("add"===this.expandNodeTarget){var n=t.select('[data-uid="'+this.treeObj.selectedNodes[0]+'"]',this.treeObj.element),s=t.select("."+ti,n);t.isNullOrUndefined(s)&&this.addChild(e.files,this.treeObj.selectedNodes[0],!this.expandTree),this.expandNodeTarget=""}this.expandTree=!1,t.isNullOrUndefined(i)&&t.setValue(this.parent.pathId[this.parent.pathId.length-1],e.files,this.parent.feFiles)},e.prototype.updateTree=function(e){if(this.treeObj){var t=this.treeObj.selectedNodes[0];this.updateTreeNode(e,t)}},e.prototype.updateTreeNode=function(e,t){var i=-1!==this.treeObj.expandedNodes.indexOf(t);this.removeChildNodes(t),this.addChild(e.files,t,!i)},e.prototype.removeChildNodes=function(e){var i=t.select('[data-uid="'+e+'"]',this.treeObj.element),n=t.select("."+ti,i),s=n?Array.prototype.slice.call(n.children):null;s&&this.treeObj.removeNodes(s)},e.prototype.onOpenEnd=function(e){var t=this.parent.pathId[this.parent.pathId.length-1];this.treeObj.expandAll(this.treeObj.selectedNodes),this.treeObj.selectedNodes=[t],this.expandNodeTarget="add",this.onPathChanged(e)},e.prototype.onOpenInit=function(e){"navigationpane"===this.parent.activeModule&&e.target.querySelector("."+Yi)&&this.treeObj.expandAll(this.treeObj.selectedNodes)},e.prototype.onInitialEnd=function(e){this.onInit(),this.addChild(e.files,t.getValue("_fm_id",e.cwd),!1)},e.prototype.onFinalizeEnd=function(e){this.onInit();var i=t.getValue("_fm_id",e.cwd);this.removeChildNodes(i),this.addChild(e.files,i,!1),this.treeObj.selectedNodes=[this.parent.pathId[this.parent.pathId.length-1]]},e.prototype.onCreateEnd=function(e){this.updateTree(e)},e.prototype.onSelectedData=function(){"navigationpane"===this.parent.activeModule&&this.updateItemData()},e.prototype.onDeleteInit=function(){if("navigationpane"===this.parent.activeModule){this.updateActionData();var e=t.getValue("name",this.parent.itemData[0]);ve(this.parent,[e],this.parent.path,"delete")}},e.prototype.onDeleteEnd=function(e){if("navigationpane"===this.parent.activeModule){var i=this.treeObj.selectedNodes[0],n=t.select('[data-uid="'+i+'"]',this.treeObj.element),s=t.closest(n,"."+ti).parentElement;this.treeObj.selectedNodes=[s.getAttribute("data-uid")],this.treeObj.dataBind()}this.updateTree(e)},e.prototype.onRefreshEnd=function(e){this.updateTree(e)},e.prototype.onRenameInit=function(){"navigationpane"===this.parent.activeModule&&this.updateRenameData()},e.prototype.onRenameEndParent=function(e){var i=this.renameParent?this.renameParent:this.parent.pathId[this.parent.pathId.length-1];if(this.expandTree=-1!==this.treeObj.expandedNodes.indexOf(this.treeObj.selectedNodes[0]),this.updateTreeNode(e,i),this.parent.expandedId=null,this.renameParent)this.renameParent=null;else{var n=[];if(this.parent.hasId)n=new s.DataManager(this.treeObj.getTreeData()).executeLocal((new s.Query).where("id","equal",this.parent.renamedId,!1));else{var a=new s.DataManager(this.treeObj.getTreeData()).executeLocal((new s.Query).where(this.treeObj.fields.text,"equal",this.parent.renameText,!1));a.length>0&&(n=new s.DataManager(a).executeLocal((new s.Query).where("_fm_pId","equal",i,!1)))}if(n.length>0){this.isRenameParent=!0;var r=t.getValue(this.treeObj.fields.id,n[0]);this.treeObj.selectedNodes=[r],this.treeObj.dataBind()}}},e.prototype.onRenameEnd=function(e){if(""!==this.parent.breadcrumbbarModule.searchObj.element.value||this.parent.isFiltered){var i=this.treeObj.getTreeData(),n=[];if(this.parent.hasId)n=new s.DataManager(i).executeLocal((new s.Query).where("id","equal",this.parent.renamedId,!1));else{var a=new s.DataManager(i).executeLocal((new s.Query).where(this.treeObj.fields.text,"equal",this.parent.currentItemText,!1));a.length>0&&(n=new s.DataManager(a).executeLocal((new s.Query).where("filterPath","equal",this.parent.filterPath,!1)))}n.length>0&&(this.renameParent=t.getValue(this.treeObj.fields.parentID,n[0]),this.parent.expandedId=this.renameParent,this.parent.itemData=this.getTreeData(this.renameParent),fe(this.parent,Ln,this.parent.filterPath.replace(/\\/g,"/")))}else this.updateTree(e)},e.prototype.onPropertyChanged=function(e){if(e.module===this.getModuleName()||"common"===e.module)for(var t=0,i=Object.keys(e.newProp);t<i.length;t++){switch(i[t]){case"allowDragAndDrop":this.addDragDrop();break;case"navigationPaneSettings":fe(this.parent,an,"/"),e.oldProp.navigationPaneSettings.sortOrder!==e.newProp.navigationPaneSettings.sortOrder&&(this.treeObj.sortOrder=e.newProp.navigationPaneSettings.sortOrder)}}},e.prototype.onDownLoadInit=function(){this.doDownload()},e.prototype.onSelectionChanged=function(e){this.treeObj.selectedNodes=[e.selectedNode]},e.prototype.onClearPathInit=function(e){this.removeChildNodes(e.selectedNode)},e.prototype.onDragEnd=function(e){var t=[];t=this.parent.isPasteError||this.parent.isSearchDrag?this.getMoveNames(e.files,this.parent.isSearchDrag,this.parent.dragPath):this.moveNames,this.treeObj.removeNodes(t)},e.prototype.getMoveNames=function(e,i,n){for(var a=[],r=0;r<e.length;r++)if(!e[r].isFile&&!this.parent.hasId){var o=e[r].previousName;if(i){var l=(n+=e[r].previousName).lastIndexOf("/");o=n.substring(l+1),n=n.substring(0,l+1)}for(var h=new s.DataManager(this.treeObj.getTreeData()).executeLocal((new s.Query).where(this.treeObj.fields.text,"equal",o,!1)),d=0;d<h.length;d++){var p=t.getValue("filterPath",h[d]);if((p=p.replace(/\\/g,"/"))===n){a.push(t.getValue(this.treeObj.fields.id,h[d]));break}}}return a},e.prototype.onCutEnd=function(e){var t=[];this.parent.isPasteError||this.parent.isSearchCut?this.moveNames=this.getMoveNames(e.files,this.parent.isSearchCut,this.parent.targetPath):t=this.moveNames,this.treeObj.removeNodes(t)},e.prototype.selectResultNode=function(e){if(this.parent.hasId)this.treeObj.selectedNodes=[t.getValue("_fm_id",e)],this.treeObj.dataBind();else{var i=t.getValue("filterPath",e),n=t.getValue("name",e),a=new s.DataManager(this.treeObj.getTreeData()).executeLocal((new s.Query).where(this.treeObj.fields.text,"equal",n,!1));if(a.length>0){var r=new s.DataManager(a).executeLocal((new s.Query).where("filterPath","equal",i,!1));if(r.length>0){var o=t.getValue(this.treeObj.fields.id,r[0]);this.treeObj.selectedNodes=[o],this.treeObj.dataBind()}}}},e.prototype.onDropPath=function(e){this.onpasteEnd(e),this.selectResultNode(this.parent.dropData),this.parent.isDropEnd=!this.parent.isPasteError},e.prototype.onpasteEnd=function(e){var i=[];if(this.parent.hasId)i=new s.DataManager(this.treeObj.getTreeData()).executeLocal((new s.Query).where("id","equal",t.getValue("id",e.cwd),!1));else{var n=new s.DataManager(this.treeObj.getTreeData()).executeLocal((new s.Query).where(this.treeObj.fields.text,"equal",t.getValue("name",e.cwd),!1));n.length>0&&(i=new s.DataManager(n).executeLocal((new s.Query).where("filterPath","equal",t.getValue("filterPath",e.cwd),!1)))}if(i.length>0){var a=t.getValue(this.treeObj.fields.id,i[0]),r=-1===this.treeObj.expandedNodes.indexOf(a);this.removeChildNodes(a),this.addChild(e.files,a,r)}this.parent.expandedId=null,this.onPathChanged(e),this.parent.isDragDrop&&this.checkDropPath(e)},e.prototype.checkDropPath=function(e){if(this.parent.hasId)return this.parent.isDropEnd=!this.parent.isPasteError,void W(this.parent);-1===this.parent.dropPath.indexOf(z(this.parent,e))?(this.parent.isDropEnd=!1,W(this.parent)):this.parent.isDropEnd=!this.parent.isPasteError},e.prototype.onpasteInit=function(){this.parent.activeModule===this.getModuleName()&&this.updateItemData(),this.moveNames=[];for(var e=this.parent.isDragDrop?this.parent.dragData:this.parent.actionRecords,i=0;i<e.length;i++)!1===t.getValue("isFile",e[i])&&this.moveNames.push(t.getValue("_fm_id",e[i]))},e.prototype.oncutCopyInit=function(){this.parent.activeModule===this.getModuleName()&&(this.parent.activeRecords=this.getTreeData(this.treeObj.selectedNodes[0]),this.parent.activeElements=[this.activeNode])},e.prototype.addEventListener=function(){this.parent.on(nn,this.onPropertyChanged,this),this.parent.on(Yn,this.onDownLoadInit,this),this.parent.on(sn,this.onInitialEnd,this),this.parent.on(an,this.onFinalizeEnd,this),this.parent.on(fn,this.onPathChanged,this),this.parent.on(Bn,this.onpasteEnd,this),this.parent.on(Hn,this.onCutEnd,this),this.parent.on(_n,this.onpasteInit,this),this.parent.on(En,this.onNodeExpanded,this),this.parent.on(rn,this.onCreateEnd,this),this.parent.on(Un,this.onSelectedData,this),this.parent.on(hn,this.onDeleteInit,this),this.parent.on(dn,this.onDeleteEnd,this),this.parent.on(pn,this.onRefreshEnd,this),this.parent.on(qn,this.onSelectionChanged,this),this.parent.on(wn,this.onOpenInit,this),this.parent.on(Dn,this.onOpenEnd,this),this.parent.on(gn,this.destroy,this),this.parent.on(kn,this.onRenameInit,this),this.parent.on(Tn,this.onRenameEnd,this),this.parent.on(Ln,this.onRenameEndParent,this),this.parent.on(xn,this.onClearPathInit,this),this.parent.on(Vn,this.oncutCopyInit,this),this.parent.on(Qn,this.onDropInit,this),this.parent.on(Mn,this.onMenuItemData,this),this.parent.on(Jn,this.onDragEnd,this),this.parent.on($n,this.onDragging,this),this.parent.on(Xn,this.onDropPath,this),this.parent.on(Rn,this.onDetailsInit,this),this.parent.on(ln,this.onPathDrag,this)},e.prototype.removeEventListener=function(){this.parent.off(sn,this.onInitialEnd),this.parent.off(Yn,this.onDownLoadInit),this.parent.off(an,this.onFinalizeEnd),this.parent.off(Un,this.onSelectedData),this.parent.off(nn,this.onPropertyChanged),this.parent.off(fn,this.onPathChanged),this.parent.off(Bn,this.onpasteEnd),this.parent.off(Hn,this.onCutEnd),this.parent.off(_n,this.onpasteInit),this.parent.off(qn,this.onSelectionChanged),this.parent.off(En,this.onNodeExpanded),this.parent.off(rn,this.onCreateEnd),this.parent.off(pn,this.onRefreshEnd),this.parent.off(wn,this.onOpenInit),this.parent.off(Dn,this.onOpenEnd),this.parent.off(gn,this.destroy),this.parent.off(kn,this.onRenameInit),this.parent.off(Tn,this.onRenameEnd),this.parent.off(Ln,this.onRenameEndParent),this.parent.off(xn,this.onClearPathInit),this.parent.off(hn,this.onDeleteInit),this.parent.off(dn,this.onDeleteEnd),this.parent.off(Vn,this.oncutCopyInit),this.parent.off(Qn,this.onDropInit),this.parent.off(Jn,this.onDragEnd),this.parent.off($n,this.onDragging),this.parent.off(Xn,this.onDropPath),this.parent.off(Rn,this.onDetailsInit),this.parent.off(Mn,this.onMenuItemData),this.parent.off(ln,this.onPathDrag)},e.prototype.onDetailsInit=function(){if(this.parent.activeModule===this.getModuleName()){var e=this.getTreeData(this.treeObj.selectedNodes[0]);this.parent.itemData=e}},e.prototype.onMenuItemData=function(e){if(this.parent.activeModule===this.getModuleName()){var i=t.closest(e.target,"li");this.parent.itemData=this.getTreeData(i.getAttribute("data-uid"))}},e.prototype.onDragging=function(e){var i=t.closest(e.target,"li");if(i.classList.contains("e-node-collapsed")){this.isDrag=!0;var n=parseInt(i.getAttribute("aria-level"),10);this.treeObj.expandAll([i.getAttribute("data-uid")],n+1),this.isDrag=!1}},e.prototype.onDropInit=function(e){if(this.parent.targetModule===this.getModuleName()){var i=t.closest(e.target,"li");this.parent.dropData=this.getTreeData(i)[0],this.parent.dropPath=this.getDropPath(i,t.getValue("name",this.parent.dropData))}},e.prototype.getModuleName=function(){return"navigationpane"},e.prototype.destroy=function(){this.parent.isDestroyed||(this.removeEventListener(),this.treeObj&&(this.unWireEvents(),this.treeObj.destroy()))},e.prototype.wireEvents=function(){this.keyboardModule=new t.KeyboardEvents(this.treeObj.element,{keyAction:this.keyDown.bind(this),keyConfigs:this.keyConfigs,eventName:"keydown"})},e.prototype.unWireEvents=function(){this.keyboardModule.destroy()},e.prototype.keyDown=function(e){switch(e.action){case"altEnter":this.parent.notify(Rn,{}),Oe(this.parent,[],this.parent.path,"details");break;case"esc":f(this.parent);break;case"del":this.parent.pathId[0]!==this.activeNode.getAttribute("data-uid")&&(this.updateItemData(),le(this.parent.itemData[0])?(this.removeNodes=[],Le(this.parent,"Delete")):ae(this.parent,this.parent.itemData[0],is));break;case"ctrlC":C(this.parent);break;case"ctrlV":this.parent.folderPath="",_(this.parent);break;case"ctrlX":j(this.parent);break;case"shiftF10":if(this.updateItemData(),!pe(this.parent.itemData[0]))return void ae(this.parent,this.parent.itemData[0],as);0!==this.parent.selectedItems.length&&this.doDownload();break;case"f2":if(0===this.parent.selectedItems.length){var t=this.getTreeData(this.treeObj.selectedNodes[0])[0];le(t)?(this.updateRenameData(),Le(this.parent,"Rename")):ae(this.parent,t,is)}}},e.prototype.getTreeData=function(e){for(var i=this.treeObj.getTreeData(e),n=0;n<i.length;n++)t.isNullOrUndefined(t.getValue("hasChild",i[n]))&&t.setValue("hasChild",!1,i[n]);return i},e.prototype.updateRenameData=function(){this.updateItemData(),this.parent.currentItemText=t.getValue("name",this.parent.itemData[0])},e.prototype.updateItemData=function(){var e=this.getTreeData(this.treeObj.selectedNodes[0])[0];this.parent.itemData=[e],this.parent.isFile=!1},e.prototype.updateActionData=function(){this.updateItemData();var e=H(this.parent.path);this.parent.setProperties({path:e},!0),this.parent.pathId.pop(),this.parent.pathNames.pop()},e.prototype.doDownload=function(){var e=H(this.parent.path),i=this.treeObj.selectedNodes[0]===this.parent.pathId[0]?"":t.getValue("name",this.parent.itemData[0]);ke(this.parent,e,[i])},e}(),gs=function(){function e(e){this.isInteracted=!0,this.interaction=!0,this.isPasteOperation=!1,this.isColumnRefresh=!1,this.dragObj=null,this.startIndex=null,this.firstItemIndex=null,this.isSelectionUpdate=!1,this.currentSelectedItem=[],this.count=0,this.isRendered=!0,this.isLoaded=!1,this.isNameWidth=!1,this.pasteOperation=!1,this.uploadOperation=!1,d.Grid.Inject(d.Resize,d.ContextMenu,d.Sort,d.VirtualScroll),this.parent=e,this.element=t.select("#"+this.parent.element.id+Mt,this.parent.element),this.addEventListener(),this.keyConfigs={altEnter:"alt+enter",esc:"escape",tab:"tab",moveDown:"downarrow",ctrlEnd:"ctrl+end",ctrlHome:"ctrl+home",ctrlDown:"ctrl+downarrow",ctrlLeft:"ctrl+leftarrow",ctrlRight:"ctrl+rightarrow",shiftEnd:"shift+end",shiftHome:"shift+home",shiftDown:"shift+downarrow",shiftUp:"shift+uparrow",ctrlUp:"ctrl+uparrow",csEnd:"ctrl+shift+end",csHome:"ctrl+shift+home",csDown:"ctrl+shift+downarrow",csUp:"ctrl+shift+uparrow",space:"space",ctrlSpace:"ctrl+space",shiftSpace:"shift+space",csSpace:"ctrl+shift+space",end:"end",home:"home",moveUp:"uparrow",del:"delete",ctrlX:"ctrl+x",ctrlC:"ctrl+c",ctrlV:"ctrl+v",ctrlShiftN:"ctrl+shift+n",shiftdel:"shift+delete",ctrlD:"ctrl+d",f2:"f2",ctrlA:"ctrl+a",enter:"enter"}}return e.prototype.render=function(e){if(n.showSpinner(this.parent.element),"Details"===this.parent.view){t.removeClass([this.parent.element],Yt);var i=R(this.parent,e.files);this.checkNameWidth();var s=this.getColumns(),a=void 0;this.parent.isMobile?a=[]:"None"!==this.parent.sortOrder&&(a=[{direction:this.parent.sortOrder,field:this.parent.sortBy}]),this.gridObj=new d.Grid({dataSource:i,allowSorting:!0,rowSelecting:this.onSelection.bind(this,"select"),rowDeselecting:this.onSelection.bind(this,"unselect"),rowSelected:this.onSelected.bind(this),rowDeselected:this.onDeSelection.bind(this),allowResizing:this.parent.detailsViewSettings.columnResizing,selectionSettings:{type:this.parent.allowMultiSelection?"Multiple":"Single",checkboxMode:"ResetOnRowClick"},enableRtl:this.parent.enableRtl,pageSettings:{pageSize:20},sortSettings:{allowUnsort:!1,columns:a},columns:s,recordDoubleClick:this.DblClickEvents.bind(this),beforeDataBound:this.onBeforeDataBound.bind(this),dataBound:this.onDataBound.bind(this),rowDataBound:this.onRowDataBound.bind(this),actionBegin:this.onActionBegin.bind(this),headerCellInfo:this.onHeaderCellInfo.bind(this),width:"100%",beforeCopy:function(e){e.cancel=!0},load:function(e){this.focusModule.destroy()},locale:this.parent.locale}),this.gridObj.isStringTemplate=!0,this.gridObj.appendTo("#"+this.parent.element.id+Mt),this.wireEvents(),this.adjustHeight(),this.emptyArgs=e}},e.prototype.checkNameWidth=function(){var e=this.parent.detailsViewSettings.columns;this.isNameWidth=!1;for(var i=0;i<e.length;i++)if("name"===e[i].field)return void(this.isNameWidth=!t.isNullOrUndefined(e[i].width))},e.prototype.adjustWidth=function(e,t){if(!this.isNameWidth||"name"!==t)for(var i=0;i<e.length;i++)if(e[i].field===t){var n=void 0;n=""!==this.parent.breadcrumbbarModule.searchObj.element.value||this.parent.isFiltered?this.element.clientWidth<=680?"name"===t?"120px":"180px":"auto":this.element.clientWidth<=500?"120px":"auto",e[i].width=n}},e.prototype.getColumns=function(){var e;if(this.parent.isMobile)e=[{field:"name",headerText:T(this.parent,"Name"),width:"auto",minWidth:120,headerTextAlign:"Left",template:'<div class="e-fe-text">${name}</div><div class="e-fe-date">${_fm_modified}</div><span class="e-fe-size">${size}</span>'}];else{e=JSON.parse(JSON.stringify(this.parent.detailsViewSettings.columns)),this.adjustWidth(e,"name");for(var t=0,i=e.length;t<i;t++)e[t].headerText=T(this.parent,e[t].headerText)}var n=this.parent.isMobile||this.parent.isBigger?"54":"46",s={field:"type",width:n,minWidth:n,template:'<span class="e-fe-icon ${_fm_iconClass}"></span>',allowResizing:!1,allowSorting:!0,customAttributes:{class:"e-fe-grid-icon"},headerTemplate:'<span class="e-fe-icon e-fe-folder"></span>'};if(e.unshift(s),this.parent.allowMultiSelection){var a=this.parent.isBigger?"36":"26",r={type:"checkbox",width:a,minWidth:a,customAttributes:{class:"e-fe-checkbox"},allowResizing:!1,allowSorting:!1};this.parent.isMobile?e.push(r):e.unshift(r)}for(t=0,i=e.length;t<i;t++)e[t].disableHtmlEncode=!this.parent.enableHtmlSanitizer;return e},e.prototype.adjustHeight=function(){if(this.gridObj){var e=t.select("#"+this.parent.element.id+Vt,this.parent.element),i=t.select("#"+this.parent.element.id+_t,this.parent.element),n=t.select("."+Si,this.parent.element),s=e.offsetHeight-i.offsetHeight-n.offsetHeight;this.gridObj.height=s,this.gridObj.dataBind()}},e.prototype.renderCheckBox=function(){this.gridObj.columns=this.getColumns(),this.isColumnRefresh=!0,this.gridObj.refreshColumns()},e.prototype.onRowDataBound=function(e){var i=t.select(".e-fe-grid-name",e.row);if(!i)for(var n=this.parent.detailsViewSettings.columns,s=0;s<n.length;s++)if("name"===n[s].field){i=e.row.children[this.parent.allowMultiSelection?s+2:s+1];break}if(i&&i.setAttribute("title",t.getValue("name",e.data)),this.parent.isLayoutChange&&this.parent.isCut&&"move"===this.parent.fileAction&&this.parent.selectedNodes&&0!==this.parent.selectedNodes.length&&-1!==this.parent.selectedNodes.indexOf(t.getValue("name",e.data))&&m(e.row),!this.parent.showFileExtension&&t.getValue("isFile",e.data)){var a=e.row.querySelector(".e-fe-text");if(a){var r=t.getValue("name",e.data),o=t.getValue("type",e.data);a.innerHTML=r.substr(0,r.length-o.length)}}if(void 0!==t.getValue("size",e.data)&&e.row.querySelector(".e-fe-size")){var l=e.row.querySelector(".e-fe-size"),h=void 0;if(t.getValue("isFile",e.data)){var d=t.getValue("size",e.data);h=(c=new t.Internationalization(this.parent.locale)).formatNumber(d/1024,{format:"n"})+" "+T(this.parent,"KB")}else h="";l.innerHTML=h}if(this.parent.isMobile&&void 0!==t.getValue("_fm_modified",e.data)&&e.row.querySelector(".e-fe-date")){var p=e.row.querySelector(".e-fe-date"),c=new t.Internationalization(this.parent.locale),u=(n=this.parent.detailsViewSettings.columns,void 0);for(s=0;s<n.length;s++)if("dateModified"===n[s].field){u=n[s].format;break}var f=c.formatDate(new Date(t.getValue("_fm_modified",e.data)),u);p.innerHTML=f}var g=e.row.querySelector("."+di);g&&g.classList.add("e-small"),le(e.data)||(e.row.className+=" "+re(e.data));var b={element:e.row,fileDetails:e.data,module:"DetailsView"};this.parent.trigger("fileLoad",b)},e.prototype.onActionBegin=function(e){if("sorting"===e.requestType){if(this.parent.setProperties({sortOrder:e.direction},!0),this.parent.setProperties({sortBy:e.columnName},!0),0!==this.parent.selectedItems.length){this.sortItem=!0;var i=this.gridObj.getSelectedRowIndexes(),n=i.length;for(this.sortSelectedNodes=[];n>0;){var s=this.gridObj.getRowsObject()[i[n-1]].data;this.sortSelectedNodes.push(t.getValue(this.parent.hasId?"id":"name",s)),n--}}this.parent.notify(Pn,{})}},e.prototype.onHeaderCellInfo=function(e){var t=e.node.querySelector("."+di);t&&t.classList.add("e-small")},e.prototype.onBeforeDataBound=function(e){n.showSpinner(this.parent.element);var t=R(this.parent,this.gridObj.dataSource);e.result=t},e.prototype.onDataBound=function(){if(this.createDragObj(),0!==this.parent.selectedItems.length&&this.selectRecords(this.parent.selectedItems),!0===this.isPasteOperation&&(this.isColumnRefresh?this.isColumnRefresh=!1:(this.selectRecords(this.parent.pasteNodes),this.isPasteOperation=!1)),this.parent.createdItem&&(this.selectRecords([t.getValue(this.parent.hasId?"id":"name",this.parent.createdItem)]),this.parent.createdItem=null),this.parent.layoutSelectedItems.length&&this.selectRecords(this.parent.layoutSelectedItems),this.parent.renamedItem&&(this.addSelection(this.parent.renamedItem),this.parent.renamedItem=null),!0===this.sortItem&&(this.selectRecords(this.sortSelectedNodes),this.sortItem=!1),this.isSelectionUpdate&&(this.isColumnRefresh?this.isColumnRefresh=!1:(this.selectRecords(this.currentSelectedItem),this.isSelectionUpdate=!1)),!0===this.uploadOperation&&(this.count++,this.selectRecords(this.parent.uploadItem),this.count===this.parent.uploadItem.length&&(this.uploadOperation=!1,this.parent.uploadItem=[])),this.gridObj.currentViewData.length*this.gridObj.getRowHeight()<this.gridObj.height){(e=this.gridObj.getHeaderContent()).style.paddingRight="",e.style.paddingLeft="";t.select(".e-headercontent",e).style.borderRightWidth="0";(i=this.gridObj.getContent().querySelector(".e-content")).style.overflowY="",i.classList.add("e-scrollShow")}else{var e=this.gridObj.getHeaderContent();this.parent.enableRtl?e.style.paddingLeft="16px":e.style.paddingRight="16px";var i;(i=this.gridObj.getContent().querySelector(".e-content")).classList.remove("e-scrollShow")}this.isRendered=!0,this.parent.isLayoutChange=!1,n.hideSpinner(this.parent.element),this.checkEmptyDiv(this.emptyArgs),this.isInteracted=!!this.isLoaded||this.isInteracted,this.isLoaded=!1},e.prototype.selectRecords=function(e){for(var i=this.gridObj.getCurrentViewRecords(),n=[],s=0,a=i.length;s<a;s++){var r=this.parent.hasId?t.getValue("id",i[s]):E(this.parent,i[s]);-1!==e.indexOf(r)&&n.push(s)}0!==n.length&&(this.gridObj.selectRows(n),this.addFocus(this.gridObj.selectedRowIndex))},e.prototype.addSelection=function(e){var i=this.gridObj.getCurrentViewRecords(),n=[];if(this.parent.hasId)n=new s.DataManager(i).executeLocal((new s.Query).where("id","equal",this.parent.renamedId,!1));else{var a=new s.DataManager(i).executeLocal((new s.Query).where("name","equal",t.getValue("name",e),!1));a.length>0&&(n=new s.DataManager(a).executeLocal((new s.Query).where("filterPath","equal",this.parent.filterPath,!1)))}if(n.length>0){var r=i.indexOf(n[0]);this.gridObj.selectRows([r])}},e.prototype.onSortColumn=function(){"None"!==this.parent.sortOrder?this.gridObj.sortModule.sortColumn(this.parent.sortBy,this.parent.sortOrder):this.gridObj.dataSource=R(this.parent,this.gridObj.dataSource)},e.prototype.onPropertyChanged=function(e){if(e.module===this.getModuleName()||"common"===e.module)for(var i=0,n=Object.keys(e.newProp);i<n.length;i++){switch(n[i]){case"allowDragAndDrop":this.createDragObj();break;case"height":this.adjustHeight();break;case"detailsViewSettings":if(!t.isNullOrUndefined(this.gridObj)){this.checkNameWidth();var s=this.getColumns();this.gridObj.columns=s,this.gridObj.allowResizing=this.parent.detailsViewSettings.columnResizing,this.gridObj.dataBind(),this.gridObj.refreshColumns()}break;case"selectedItems":if(this.interaction=!1,0!==this.parent.selectedItems.length){if(!this.parent.allowMultiSelection){var a=this.parent.selectedItems.slice(this.parent.selectedItems.length-1);this.parent.setProperties({selectedItems:a},!0)}this.selectRecords(this.parent.selectedItems),this.parent.setProperties({selectedItems:this.parent.selectedItems},!0)}else t.isNullOrUndefined(this.gridObj)||this.gridObj.clearSelection();break;case"showFileExtension":case"showHiddenItems":fe(this.parent,fn,this.parent.path);break;case"allowMultiSelection":t.isNullOrUndefined(this.gridObj)||(this.currentSelectedItem=this.parent.selectedItems,this.gridObj.selectionSettings.type=e.newProp.allowMultiSelection?"Multiple":"Single",this.isSelectionUpdate=!0,this.renderCheckBox());break;case"view":O(this.parent,"Details");break;case"width":this.onDetailsResize()}}},e.prototype.onPathChanged=function(e){this.parent.isCut=!1,""===this.parent.breadcrumbbarModule.searchObj.element.value.trim()&&this.gridObj&&(this.parent.searchedItems=[],this.parent.isFiltered?this.updatePathColumn():this.removePathColumn(!1)),b(this.parent),"Details"===this.parent.view&&(this.isInteracted=!1,n.showSpinner(this.parent.element),this.parent.setProperties({selectedItems:[]},!0),this.gridObj.dataSource=R(this.parent,e.files)),this.emptyArgs=e},e.prototype.updatePathColumn=function(){var e=this.gridObj.columns.length,t=JSON.parse(JSON.stringify(this.gridObj.columns));if(t[e-1].field&&"filterPath"!==t[e-1].field&&!this.parent.isMobile){var i={field:"filterPath",headerText:T(this.parent,"Path"),minWidth:180,width:"auto"};this.gridObj.columns.push(i),this.adjustWidth(this.gridObj.columns,"filterPath"),this.adjustWidth(this.gridObj.columns,"name"),this.isColumnRefresh=!0,this.gridObj.refreshColumns()}},e.prototype.checkEmptyDiv=function(e){var i=R(this.parent,e.files);if(0!==i.length||t.isNullOrUndefined(this.element.querySelector("."+Ni))){if(0!==i.length&&this.element.querySelector("."+ci))if(this.element.querySelector("."+Ni).querySelector("."+ci)){var n=this.element.querySelector("."+Ni).querySelector("."+ci);this.element.querySelector("."+Ni).removeChild(n)}else this.element.removeChild(this.element.querySelector("."+ci))}else k(this.parent,this.element,e)},e.prototype.onOpenInit=function(){if("detailsview"===this.parent.activeModule){var e=this.gridObj.getSelectedRecords()[0];this.openContent(e)}},e.prototype.DblClickEvents=function(e){this.gridObj.selectRows([e.rowIndex]);var t;e.rowData&&(t=JSON.parse(JSON.stringify(e.rowData)),this.openContent(t))},e.prototype.openContent=function(e){var i=this;if(oe(e)){var n={cancel:!1,fileDetails:e,module:"DetailsView"};this.parent.trigger("fileOpen",n,function(n){if(!n.cancel){var s=t.getValue("name",e);if(t.getValue("isFile",e)){if(x(e)===vi){var a=N(i.parent,e);$e(i.parent,s,a)}}else{if(""!==i.parent.breadcrumbbarModule.searchObj.element.value||i.parent.isFiltered)V(i.parent,e);else{var r=t.getValue("id",e),o=i.parent.path+(t.isNullOrUndefined(r)?s:r)+"/";i.parent.setProperties({path:o},!0),i.parent.pathNames.push(s),i.parent.pathId.push(t.getValue("_fm_id",e)),i.parent.itemData=[e],D(i.parent)}i.parent.isFiltered=!1}i.element.focus()}})}else ae(this.parent,e,ts)},e.prototype.onLayoutChange=function(e){"Details"===this.parent.view&&(this.gridObj?this.isLoaded=!0:this.render(e),this.parent.isFiltered&&(this.updatePathColumn(),this.parent.setProperties({selectedItems:[]},!0)),this.gridObj.dataSource=R(this.parent,e.files),this.parent.notify(zn,{}),this.gridObj.element.classList.remove(Ji),this.isInteracted=!1,this.gridObj.clearSelection(),""!==this.parent.breadcrumbbarModule.searchObj.element.value.trim()&&this.onSearchFiles(e),this.adjustHeight(),this.gridObj.sortSettings.columns.length>0&&this.gridObj.sortSettings.columns[0].field!==this.parent.sortBy&&"None"!==this.parent.sortOrder&&this.gridObj.sortColumn(this.parent.sortBy,this.parent.sortOrder))},e.prototype.onSearchFiles=function(e){"Details"===this.parent.view&&(this.parent.setProperties({selectedItems:[]},!0),this.parent.notify(Sn,{}),this.parent.isLayoutChange||(this.parent.layoutSelectedItems=[]),this.updatePathColumn(),this.parent.searchedItems=e.files,this.onPathChanged(e))},e.prototype.removePathColumn=function(e){var t=this.gridObj.columns.length,i=JSON.parse(JSON.stringify(this.gridObj.columns));i[t-1].field&&"filterPath"===i[t-1].field&&("filterPath"===this.gridObj.sortSettings.columns[0].field&&("None"!==this.parent.sortOrder?this.gridObj.sortColumn("name",this.parent.sortOrder):this.gridObj.dataSource=R(this.parent,this.gridObj.dataSource),this.parent.notify(Pn,{})),this.gridObj.columns.pop(),e||(this.isColumnRefresh=!0,this.gridObj.refreshColumns()))},e.prototype.onFinalizeEnd=function(e){"Details"===this.parent.view&&(this.gridObj?this.onPathChanged(e):this.render(e))},e.prototype.onCreateEnd=function(e){"Details"===this.parent.view&&this.onPathChanged(e)},e.prototype.onRenameInit=function(){"detailsview"===this.parent.activeModule&&1===this.parent.selectedItems.length&&this.updateRenameData()},e.prototype.onSelectedData=function(){"detailsview"===this.parent.activeModule&&(this.parent.itemData=this.gridObj.getSelectedRecords())},e.prototype.onDeleteInit=function(){"detailsview"===this.parent.activeModule&&ve(this.parent,this.parent.selectedItems,this.parent.path,"delete")},e.prototype.onDeleteEnd=function(e){"Details"===this.parent.view&&(this.onPathChanged(e),this.parent.setProperties({selectedItems:[]},!0))},e.prototype.onRefreshEnd=function(e){"Details"===this.parent.view&&(this.isInteracted=!1,this.removePathColumn(!1),this.gridObj.dataSource=R(this.parent,e.files),this.emptyArgs=e)},e.prototype.onHideLayout=function(){"Details"!==this.parent.view&&this.gridObj&&this.gridObj.element.classList.add(Ji)},e.prototype.onSelectAllInit=function(){"Details"===this.parent.view&&(this.isInteracted=!1,this.parent.allowMultiSelection?this.gridObj.selectionModule.selectRowsByRange(0,this.gridObj.getRows().length):this.gridObj.selectRow(this.gridObj.getRows().length-1),this.isInteracted=!0,this.interaction=!0)},e.prototype.onClearAllInit=function(){"Details"===this.parent.view&&(this.removeSelection(),this.interaction=!0)},e.prototype.onSelectionChanged=function(){t.removeClass([this.element],Zi),this.parent.selectedItems.length>0&&t.addClass([this.element],Zi)},e.prototype.onLayoutRefresh=function(){"Details"===this.parent.view&&this.adjustHeight()},e.prototype.onBeforeRequest=function(){this.isRendered=!1},e.prototype.onAfterRequest=function(){this.isRendered=!0},e.prototype.onUpdateSelectionData=function(){"Details"===this.parent.view&&(this.parent.itemData=this.gridObj.getSelectedRecords())},e.prototype.addEventListener=function(){this.parent.on(an,this.onFinalizeEnd,this),this.parent.on(gn,this.destroy,this),this.parent.on(Nn,this.onLayoutChange,this),this.parent.on(fn,this.onPathChanged,this),this.parent.on(rn,this.onCreateEnd,this),this.parent.on(Qn,this.onDropInit,this),this.parent.on(Rn,this.onDetailsInit,this),this.parent.on(pn,this.onRefreshEnd,this),this.parent.on(In,this.onSearchFiles,this),this.parent.on(es,this.onMethodCall,this),this.parent.on(On,this.onActionFailure,this),this.parent.on(nn,this.onPropertyChanged,this),this.parent.on(hn,this.onDeleteInit,this),this.parent.on(dn,this.onDeleteEnd,this),this.parent.on(Un,this.onSelectedData,this),this.parent.on(kn,this.onRenameInit,this),this.parent.on(Tn,this.onPathChanged,this),this.parent.on(wn,this.onOpenInit,this),this.parent.on(Wn,this.onSortColumn,this),this.parent.on(Dn,this.onPathChanged,this),this.parent.on(on,this.onPathChanged,this),this.parent.on(_n,this.onPasteInit,this),this.parent.on(zn,this.onHideLayout,this),this.parent.on(Cn,this.onSelectAllInit,this),this.parent.on(jn,this.onClearAllInit,this),this.parent.on(Kn,this.onPathColumn,this),this.parent.on(Sn,this.onSelectionChanged,this),this.parent.on(mn,this.onBeforeRequest,this),this.parent.on(yn,this.onAfterRequest,this),this.parent.on(Bn,this.onpasteEnd,this),this.parent.on(Vn,this.oncutCopyInit,this),this.parent.on(Mn,this.onMenuItemData,this),this.parent.on(cn,this.onDetailsResizeHandler,this),this.parent.on(un,this.onDetailsResize,this),this.parent.on(vn,this.onLayoutRefresh,this),this.parent.on(Xn,this.onDropPath,this),this.parent.on(Zn,this.onUpdateSelectionData,this)},e.prototype.removeEventListener=function(){this.parent.off(an,this.onFinalizeEnd),this.parent.off(gn,this.destroy),this.parent.off(Nn,this.onLayoutChange),this.parent.off(fn,this.onPathChanged),this.parent.off(_n,this.onPasteInit),this.parent.off(rn,this.onCreateEnd),this.parent.off(pn,this.onRefreshEnd),this.parent.off(In,this.onSearchFiles),this.parent.off(es,this.onMethodCall),this.parent.off(On,this.onActionFailure),this.parent.off(nn,this.onPropertyChanged),this.parent.off(kn,this.onRenameInit),this.parent.off(Tn,this.onPathChanged),this.parent.off(on,this.onPathChanged),this.parent.off(wn,this.onOpenInit),this.parent.off(Wn,this.onSortColumn),this.parent.off(Dn,this.onPathChanged),this.parent.off(zn,this.onHideLayout),this.parent.off(Cn,this.onSelectAllInit),this.parent.off(jn,this.onClearAllInit),this.parent.off(hn,this.onDeleteInit),this.parent.off(dn,this.onDeleteEnd),this.parent.off(Kn,this.onPathColumn),this.parent.off(Sn,this.onSelectionChanged),this.parent.off(mn,this.onBeforeRequest),this.parent.off(yn,this.onAfterRequest),this.parent.off(Bn,this.onpasteEnd),this.parent.off(Vn,this.oncutCopyInit),this.parent.off(Qn,this.onDropInit),this.parent.off(Un,this.onSelectedData),this.parent.off(Rn,this.onDetailsInit),this.parent.off(Mn,this.onMenuItemData),this.parent.off(cn,this.onDetailsResizeHandler),this.parent.off(un,this.onDetailsResize),this.parent.off(vn,this.onLayoutRefresh),this.parent.off(Xn,this.onDropPath),this.parent.off(Zn,this.onUpdateSelectionData)},e.prototype.onActionFailure=function(){this.interaction=!0},e.prototype.onMenuItemData=function(e){this.parent.activeModule===this.getModuleName()&&(this.parent.itemData=[this.gridObj.getRowInfo(e.target).rowData])},e.prototype.onPasteInit=function(){this.parent.activeModule===this.getModuleName()&&(this.parent.itemData=""!==this.parent.folderPath?this.gridObj.getSelectedRecords():[S(this.parent)])},e.prototype.onDetailsInit=function(){this.parent.activeModule===this.getModuleName()&&(0!==this.parent.selectedItems.length?this.parent.itemData=this.gridObj.getSelectedRecords():this.parent.itemData=[t.getValue(this.parent.pathId[this.parent.pathId.length-1],this.parent.feParent)])},e.prototype.dragHelper=function(e){var t=e.sender.target.closest("tr.e-row");if(!t)return null;var i=t.getElementsByClassName("e-fe-text")[0].innerText;t&&!t.querySelector(".e-active")&&this.selectRecords([i]),y(this.parent,t),this.parent.activeElements=[],this.parent.dragData=[],this.parent.dragData=this.gridObj.getSelectedRecords();var n;return 0===this.parent.dragData.length&&t&&(n=this.gridObj.getRowInfo(t)),n&&this.parent.dragData.push(n.rowData),this.parent.dragPath=this.parent.path,this.parent.activeElements=this.gridObj.getSelectedRows(),K(this.parent),this.parent.virtualDragElement},e.prototype.onDetailsResize=function(){if("Details"===this.parent.view&&!this.parent.isMobile&&!t.isNullOrUndefined(this.gridObj))for(var e=this.gridObj.getHeaderContent().querySelector(".e-headercontent").firstChild.childNodes[0],i=this.gridObj.getContent().querySelector(".e-content .e-table").children[0],n=this.gridObj.getColumns(),s=0;s<n.length;s++)(!this.isNameWidth&&"name"===n[s].field||"filterPath"===n[s].field)&&(""!==this.parent.breadcrumbbarModule.searchObj.element.value||this.parent.isFiltered?this.element.clientWidth<=680?"name"===n[s].field?(e.children[s].setAttribute("style","width: 120px"),i.children[s].setAttribute("style","width: 120px")):(e.children[s].setAttribute("style","width: 180px"),i.children[s].setAttribute("style","width: 180px")):this.element.clientWidth>680&&(e.children[s].setAttribute("style","width: auto"),i.children[s].setAttribute("style","width: auto")):this.element.clientWidth<=500?(e.children[s].setAttribute("style","width: 120px"),i.children[s].setAttribute("style","width: 120px")):this.element.clientWidth>500&&(e.children[s].setAttribute("style","width: auto"),i.children[s].setAttribute("style","width: auto")))},e.prototype.onDetailsResizeHandler=function(){this.onDetailsResize(),"Details"!==this.parent.view||this.parent.isMobile||t.isNullOrUndefined(this.gridObj)||this.adjustHeight()},e.prototype.createDragObj=function(){var e=this;!this.parent.isMobile&&this.gridObj&&(this.parent.allowDragAndDrop?(this.dragObj&&this.dragObj.destroy(),this.dragObj=new t.Draggable(this.gridObj.element,{cursorAt:this.parent.dragCursorPosition,distance:5,enableTailMode:!0,dragArea:this.parent.element,dragTarget:"."+pi,drag:$.bind(this,this.parent),dragStart:function(t){Y(e.parent,t,e.dragObj)},dragStop:G.bind(this,this.parent),enableAutoScroll:!0,helper:this.dragHelper.bind(this)})):!this.parent.allowDragAndDrop&&this.dragObj&&this.dragObj.destroy())},e.prototype.onDropInit=function(e){if(this.parent.targetModule===this.getModuleName()){var i=t.getValue(this.parent.pathId[this.parent.pathId.length-1],this.parent.feParent);if(e.target.closest("tr")){var n=null;n=this.gridObj.getRowInfo(e.target).rowData,this.parent.dropPath=n.isFile?this.parent.path:P(this.parent,n,this.parent.path),this.parent.dropData=n.isFile?i:n}else this.parent.dropPath=this.parent.path,this.parent.dropData=i}},e.prototype.oncutCopyInit=function(){this.parent.activeModule===this.getModuleName()&&(this.parent.activeRecords=this.gridObj.getSelectedRecords(),this.parent.activeElements=this.gridObj.getSelectedRows())},e.prototype.onpasteEnd=function(e){"Details"===this.parent.view&&(this.isPasteOperation=!0,this.parent.path!==this.parent.destinationPath&&this.parent.path!==z(this.parent,e)||this.onPathChanged(e))},e.prototype.onDropPath=function(e){"Details"===this.parent.view&&(this.isPasteOperation=!0,this.onPathChanged(e))},e.prototype.getModuleName=function(){return"detailsview"},e.prototype.destroy=function(){this.parent.isDestroyed||(this.removeEventListener(),this.gridObj&&(this.unWireEvents(),this.gridObj.destroy()))},e.prototype.updateType=function(e){var i=t.select("."+yi,e);this.parent.isFile=!!t.isNullOrUndefined(i)},e.prototype.onSelection=function(e,t){var i={action:e,fileDetails:t.data,isInteracted:this.interaction,cancel:!1,target:t.target};this.parent.trigger("fileSelection",i),t.cancel=i.cancel},e.prototype.onSelected=function(e){this.parent.activeModule="detailsview",this.parent.isLayoutChange&&!this.parent.isFiltered||this.selectedRecords(),this.parent.notify(Sn,{}),1===this.gridObj.getSelectedRowIndexes().length&&(this.firstItemIndex=this.gridObj.selectedRowIndex),this.gridObj.element.setAttribute("tabindex","-1"),this.triggerSelect("select",e);var i=this.gridObj.getRowByIndex(this.gridObj.selectedRowIndex);if(this.updateType(i),!t.isNullOrUndefined(i)&&!t.isNullOrUndefined(i.querySelector(".e-checkselect"))){if(1!==this.gridObj.getSelectedRowIndexes().length){var n=this.gridObj.getSelectedRowIndexes()[this.gridObj.getSelectedRowIndexes().length-2];this.gridObj.getRowByIndex(n).querySelector(".e-checkselect").setAttribute("tabindex","-1")}i.querySelector(".e-rowcell.e-fe-checkbox").removeAttribute("tabindex")}t.isNullOrUndefined(this.gridObj)||t.isNullOrUndefined(this.gridObj.element.querySelector(".e-checkselectall"))||this.gridObj.element.querySelector(".e-checkselectall").setAttribute("tabindex","-1");var s=this.gridObj.getSelectedRowIndexes();if(!this.parent.allowMultiSelection)for(var a=0;a<s.length;a++)s[a]===this.gridObj.selectedRowIndex?this.gridObj.getRowByIndex(s[a]).setAttribute("tabindex","0"):this.gridObj.getRowByIndex(s[a]).removeAttribute("tabindex");var r=s.length;if(r>0){var o=this.gridObj.getRowsObject()[s[r-1]].data;this.parent.currentItemText=t.getValue("name",o)}var l=t.getValue("rowIndexes",e),h=t.getValue("enableSelectMultiTouch",this.gridObj.selectionModule);if(this.parent.isDevice&&t.isNullOrUndefined(l)&&e.target&&!h&&!e.target.closest(".e-headercell")&&(this.parent.isFile=t.getValue("isFile",e.data),this.parent.isFile||this.openContent(e.data)),this.parent.visitedItem=e.row,this.parent.allowMultiSelection&&!t.isNullOrUndefined(i)&&!t.isNullOrUndefined(i.querySelector(".e-checkselect"))){i.querySelector(".e-checkselect").focus()}this.addFocus(this.gridObj.selectedRowIndex),this.parent.isLayoutChange||(this.isInteracted=!0)},e.prototype.onPathColumn=function(){"Details"!==this.parent.view||t.isNullOrUndefined(this.gridObj)||""!==this.parent.breadcrumbbarModule.searchObj.element.value||this.parent.isFiltered||this.removePathColumn(!1)},e.prototype.selectedRecords=function(){this.parent.setProperties({selectedItems:[]},!0);for(var e=this.gridSelectNodes(),t=0;t<e.length;){var i=e[t],n=Z(this.parent,i);this.parent.selectedItems.push(n),t++}this.parent.setProperties({selectedItems:this.parent.selectedItems},!0)},e.prototype.onDeSelection=function(e){if(!this.parent.allowMultiSelection&&t.isNullOrUndefined(e.data))this.gridObj.getRowByIndex(e.rowIndex).removeAttribute("tabindex");else if(this.gridObj.getSelectedRowIndexes().length>1){var i=this.gridObj.getSelectedRowIndexes()[this.gridObj.getSelectedRowIndexes().length-2];this.gridObj.getRowByIndex(i).querySelector(".e-checkselect").removeAttribute("tabindex")}-1===this.gridObj.selectedRowIndex&&this.gridObj.element.setAttribute("tabindex","0"),this.isInteracted?(this.selectedRecords(),0===this.parent.selectedItems.length&&(t.setValue("enableSelectMultiTouch",!1,this.gridObj.selectionModule),t.removeClass([this.parent.element],Yt)),this.parent.notify(Sn,{}),this.triggerSelect("unselect",e),this.parent.visitedItem=null):this.isInteracted=!0},e.prototype.triggerSelect=function(e,t){var i={action:e,fileDetails:t.data,isInteracted:this.interaction};this.parent.trigger("fileSelect",i),this.interaction=!0},e.prototype.wireEvents=function(){this.wireClickEvent(!0),this.keyboardModule=new t.KeyboardEvents(this.gridObj.element,{keyAction:this.keyupHandler.bind(this),keyConfigs:this.keyConfigs,eventName:"keyup"}),this.keyboardDownModule=new t.KeyboardEvents(this.element,{keyAction:this.keydownHandler.bind(this),keyConfigs:this.keyConfigs,eventName:"keydown"}),t.EventHandler.add(this.gridObj.element,"blur",this.removeFocus,this)},e.prototype.unWireEvents=function(){this.wireClickEvent(!1),this.keyboardModule.destroy(),this.keyboardDownModule.destroy(),t.EventHandler.remove(this.gridObj.element,"blur",this.removeFocus)},e.prototype.wireClickEvent=function(e){if(e){var i=this,n=this.gridObj.getContent();this.clickObj=new t.Touch(n,{tap:function(e){1===e.tapCount&&e.originalEvent.target.classList.contains("e-content")&&i.onClearAllInit()},tapHold:function(e){if(i.parent.isDevice){e.originalEvent.preventDefault(),i.parent.allowMultiSelection&&(t.setValue("enableSelectMultiTouch",i.parent.allowMultiSelection,i.gridObj.selectionModule),t.addClass([i.parent.element],Yt));var n=e.originalEvent.target;if(n){var s=t.closest(n,"."+pi),a=i.gridObj.getRows().indexOf(s);i.gridObj.selectRow(a)}}}})}else this.clickObj&&this.clickObj.destroy()},e.prototype.removeSelection=function(){t.removeClass([this.parent.element],Yt),this.gridObj.clearSelection(),this.parent.setProperties({selectedItems:[]},!0),this.parent.notify(Sn,{}),-1===this.gridObj.selectedRowIndex&&(this.startIndex=null),this.isInteracted=!0},e.prototype.removeFocus=function(){this.addFocus(null)},e.prototype.getFocusedItemIndex=function(){return t.isNullOrUndefined(this.getFocusedItem())?null:parseInt(this.getFocusedItem().getAttribute("aria-rowindex"),10)},e.prototype.keydownHandler=function(e){if(this.isRendered)switch(e.action){case"end":case"home":case"space":case"ctrlSpace":case"shiftSpace":case"csSpace":case"ctrlA":case"enter":case"altEnter":case"ctrlEnd":case"shiftEnd":case"csEnd":case"ctrlHome":case"shiftHome":case"csHome":case"ctrlDown":case"shiftDown":case"csDown":case"ctrlLeft":case"shiftLeft":case"csLeft":case"esc":case"del":case"shiftdel":case"ctrlC":case"ctrlV":case"ctrlX":case"f2":case"moveDown":case"moveUp":e.preventDefault()}},e.prototype.keyupHandler=function(e){if(this.isRendered){e.preventDefault();var i,n,s,a=e.action,r=R(this.parent,this.gridObj.dataSource),o=r.length,l=(this.getFocusedItem(),this.getFocusedItemIndex()),h=this.gridObj.selectedRowIndex,d=this.gridObj.getSelectedRowIndexes();switch(a){case"altEnter":Oe(this.parent,this.parent.selectedItems,this.parent.path,"details");break;case"esc":f(this.parent);break;case"del":case"shiftdel":this.performDelete();break;case"enter":if(-1===this.gridObj.selectedRowIndex)break;if(i=this.gridObj.getRowsObject()[this.gridObj.selectedRowIndex].data){var p=JSON.parse(JSON.stringify(i));this.openContent(p)}break;case"ctrlC":C(this.parent);break;case"ctrlV":this.parent.folderPath="",_(this.parent);break;case"ctrlX":j(this.parent);break;case"ctrlD":this.doDownload();break;case"f2":this.performRename();break;case"ctrlA":if(!t.isNullOrUndefined(r[0])&&this.parent.allowMultiSelection){var c=this.gridObj.getContent().querySelector(".e-content"),u=c.scrollTop,g=this.gridObj.selectedRowIndex;this.gridObj.selectionModule.selectRowsByRange(0,r.length-1),c.scrollTop=u,-1!==g&&this.addFocus(g)}break;case"ctrlHome":case"tab":if(!t.isNullOrUndefined(r[0]))if(this.parent.allowMultiSelection||"ctrlHome"!==e.action){if(-1!==this.gridObj.selectedRowIndex&&"tab"===e.action)return;this.addFocus(0)}else this.gridObj.selectRow(0);break;case"ctrlEnd":t.isNullOrUndefined(r[0])||(this.parent.allowMultiSelection?this.addFocus(o-1):this.gridObj.selectRow(o-1));break;case"shiftHome":case"shiftEnd":case"csHome":case"csEnd":this.parent.allowMultiSelection?t.isNullOrUndefined(r[0])||(t.isNullOrUndefined(h)||-1===h?"csHome"===e.action||"shiftHome"===e.action?this.gridObj.selectRow(0):this.gridObj.selectionModule.selectRowsByRange(0,r.length-1):this.checkRowsKey(r,h,null,e)):this.gridObj.selectRow("shiftHome"===e.action||"csHome"===e.action?0:r.length-1);break;case"space":case"csSpace":case"shiftSpace":case"ctrlSpace":this.spaceSelection(d,l,h,e);break;case"csUp":case"csDown":case"shiftUp":case"shiftDown":this.shiftMoveMethod(r,h,l,d,e);break;case"ctrlUp":case"ctrlDown":this.parent.allowMultiSelection?this.ctrlMoveFunction(r,e,h):this.moveFunction(r,e,h);break;case"home":n=[t.getValue(this.parent.hasId?"id":"name",r[0])],this.parent.setProperties({selectedItems:n},!0),this.selectRecords(n);break;case"moveUp":case"moveDown":this.moveFunction(r,e,h);break;case"end":s=[t.getValue(this.parent.hasId?"id":"name",r[o-1])],this.parent.setProperties({selectedItems:s},!0),this.selectRecords(s)}}},e.prototype.gridSelectNodes=function(){return this.gridObj.getSelectedRecords()},e.prototype.doDownload=function(){if(0!==this.parent.selectedItems.length){this.parent.itemData=this.gridObj.getSelectedRecords();for(var e=this.parent.itemData,t=0;t<e.length;t++)if(!pe(e[t]))return void ae(this.parent,e[t],as);ke(this.parent,this.parent.path,this.parent.selectedItems)}},e.prototype.performDelete=function(){if(this.parent.selectedItems&&this.parent.selectedItems.length>0){this.parent.itemData=this.gridObj.getSelectedRecords();for(var e=this.parent.itemData,t=0;t<e.length;t++)if(!le(e[t]))return void ae(this.parent,e[t],is);Le(this.parent,"Delete")}},e.prototype.performRename=function(){1===this.parent.selectedItems.length&&(this.updateRenameData(),te(this.parent))},e.prototype.updateRenameData=function(){var e=this.gridSelectNodes()[0];ee(this.parent,e)},e.prototype.shiftMoveMethod=function(e,t,i,n,s){this.parent.allowMultiSelection?-1!==t||"csUp"!==s.action&&"csDown"!==s.action?-1===t||i===t||("csUp"===s.action||"csDown"===s.action)&&this.isSelected(n,i)?this.shiftSelectedItem(t,n,e,s):this.shiftSelectFocusItem(t,i,n,s):this.ctrlMoveFunction(e,s,t):this.moveFunction(e,s,t)},e.prototype.moveFunction=function(e,i,n){!t.isNullOrUndefined(this.getFocusedItem())&&this.parent.allowMultiSelection?"moveDown"===i.action?this.gridObj.selectRow(this.getFocusedItemIndex()+1):this.gridObj.selectRow(this.getFocusedItemIndex()-1):t.isNullOrUndefined(n)||-1===n?t.isNullOrUndefined(e[0])||this.gridObj.selectRow(0):"moveDown"===i.action||"ctrlDown"===i.action||"shiftDown"===i.action||"csDown"===i.action?this.gridObj.selectRow(n+(n!==e.length-1?1:0)):this.gridObj.selectRow(n-(0!==n?1:0))},e.prototype.spaceSelection=function(e,i,n,s){if(this.isSelected(e,i)||-1===n||"shiftSpace"!==s.action&&"csSpace"!==s.action)if(t.isNullOrUndefined(this.getFocusedItem())||i===n)if(-1!==n&&"ctrlSpace"===s.action&&this.parent.allowMultiSelection){var a=n;e.pop(),this.gridObj.selectRows(e),this.addFocus(a)}else"shiftSpace"===s.action&&this.gridObj.selectRow(n);else e.push(this.getFocusedItemIndex()),this.gridObj.selectRows(e);else i<n?this.gridObj.selectionModule.selectRowsByRange(i,n):this.gridObj.selectionModule.selectRowsByRange(n,i)},e.prototype.ctrlMoveFunction=function(e,i,n){var s;if(t.isNullOrUndefined(this.getFocusedItem()))t.isNullOrUndefined(n)||-1===n?t.isNullOrUndefined(e[0])||(s=0):s="ctrlDown"===i.action||"csDown"===i.action?n+(n<e.length?1:0):n-(n<1?0:1);else{var a=this.getFocusedItemIndex();s="ctrlDown"===i.action||"csDown"===i.action?a+(a<e.length-1?1:0):a-(a<1?0:1)}this.addFocus(s)},e.prototype.checkRowsKey=function(e,i,n,s){"Uncheck"===this.gridObj.checkAllRows||"Intermediate"===this.gridObj.checkAllRows?"csHome"!==s.action&&"csEnd"!==s.action?(t.isNullOrUndefined(this.startIndex)&&this.firstItemIndex!==i&&(this.firstItemIndex=i),"shiftEnd"===s.action?this.gridObj.selectionModule.selectRowsByRange(this.firstItemIndex,e.length-1):this.gridObj.selectionModule.selectRowsByRange(0,this.firstItemIndex),this.startIndex=i):"csEnd"===s.action?this.gridObj.selectRows(this.InnerItems(t.isNullOrUndefined(i)?0:i,t.isNullOrUndefined(n)?e.length-1:n,s)):t.isNullOrUndefined(i)?this.gridObj.selectRow(0):this.gridObj.selectRows(this.InnerItems(t.isNullOrUndefined(n)?0:n,i,s)):this.gridObj.selectionModule.selectRow("shiftHome"===s.action||"csHome"===s.action?0:e.length-1)},e.prototype.InnerItems=function(e,t,i){var n=this.gridObj.getSelectedRowIndexes();if("csEnd"===i.action)for(var s=e+1;s<=t;s++)n.push(s);else for(s=t-1;e<=s;s--)n.push(s);return n},e.prototype.shiftSelectFocusItem=function(e,i,n,s){var a=i+("shiftDown"===s.action||"csDown"===s.action?1:-1),r=t.isNullOrUndefined(this.startIndex)?e:n[0];r===a?this.gridObj.selectRow(r):r<a?"shiftDown"===s.action||"csDown"===s.action?this.gridObj.selectionModule.selectRowsByRange(r,a):this.gridObj.selectionModule.selectRowsByRange(a,r):"shiftDown"===s.action||"csDown"===s.action?this.gridObj.selectionModule.selectRowsByRange(a,r):this.gridObj.selectionModule.selectRowsByRange(r,a),this.startIndex=this.gridObj.selectedRowIndex},e.prototype.addFocus=function(e){var i=this.getFocusedItem(),n=this.gridObj.getRowByIndex(e);i&&(i.removeAttribute("tabindex"),t.removeClass([i],[oi,li])),t.isNullOrUndefined(n)||(this.gridObj.element.setAttribute("tabindex","-1"),n.setAttribute("tabindex","0"),n.focus(),t.addClass([n],[oi,li]))},e.prototype.getFocusedItem=function(){return t.select("."+li,this.element)},e.prototype.isSelected=function(e,t){for(var i=!1,n=0;n<=e.length-1;n++)if(e[n]===t){i=!0;break}return i},e.prototype.shiftSelectedItem=function(e,i,n,s){-1===e?this.gridObj.selectRow(0):t.isNullOrUndefined(this.startIndex)&&s.shiftKey?(this.startIndex=this.gridObj.selectedRowIndex,this.gridObj.selectRows([e,"shiftDown"===s.action||"csDown"===s.action?e+(e!==n.length-1?1:0):e-(0!==e?1:0)])):"shiftDown"===s.action||"shiftUp"===s.action?("shiftDown"===s.action&&-1===i.indexOf(e+1)?e!==n.length-1&&i.push(e+1):"shiftUp"===s.action&&-1===i.indexOf(e-1)?0!==e&&i.push(e-1):i.pop(),this.gridObj.selectRows(i)):"csDown"===s.action?this.isSelected(i,this.getFocusedItemIndex()+1)?this.addFocus(this.getFocusedItemIndex()+1):(i.push(this.getFocusedItemIndex()+1),this.gridObj.selectRows(i)):this.isSelected(i,this.getFocusedItemIndex()-1)?this.addFocus(this.getFocusedItemIndex()-1):(i.push(this.getFocusedItemIndex()-1),this.gridObj.selectRows(i))},e.prototype.onMethodCall=function(e){if("Details"===this.parent.view){switch(t.getValue("action",e)){case"deleteFiles":this.deleteFiles(t.getValue("ids",e));break;case"downloadFiles":this.downloadFiles(t.getValue("ids",e));break;case"openFile":this.openFile(t.getValue("id",e));break;case"createFolder":this.interaction=!1;break;case"renameFile":this.interaction=!1,this.renameFile(t.getValue("id",e),t.getValue("newName",e));break;case"selectAll":this.interaction=!1,this.onSelectAllInit();break;case"clearSelection":this.interaction=!1,this.onClearAllInit()}}},e.prototype.getRecords=function(e){var i=this.gridObj.getCurrentViewRecords(),n=[],s=!(""===this.parent.breadcrumbbarModule.searchObj.element.value&&!this.parent.isFiltered),a=this.parent.hasId?"id":"name";if(this.parent.hasId||!s)for(var r=0,o=i.length;r<o;r++)-1!==e.indexOf(t.getValue(a,i[r]))&&n.push(i[r]);else for(r=0,o=i.length;r<o;r++){var l=t.getValue("filterPath",i[r])+t.getValue("name",i[r]);-1!==e.indexOf(l)&&n.push(i[r])}return n},e.prototype.deleteFiles=function(e){if(this.parent.activeModule="detailsview",t.isNullOrUndefined(e))this.performDelete();else{var i=this.getRecords(e);if(0!==i.length){for(var n=[],s=[],a=0;a<i.length;a++)n[a]=i[a],s[a]=Z(this.parent,n[a]);ne(this.parent,n,s)}}},e.prototype.downloadFiles=function(e){if(t.isNullOrUndefined(e))this.doDownload();else{var i=this.getRecords(e);if(0!==i.length){for(var n=[],s=[],a=0;a<i.length;a++)n[a]=i[a],s[a]=Z(this.parent,n[a]);se(this.parent,n,s)}}},e.prototype.openFile=function(e){if(!t.isNullOrUndefined(e)){var i=this.getRecords([e]);i.length>0&&this.openContent(i[0])}},e.prototype.renameFile=function(e,i){if(this.parent.activeModule="detailsview",t.isNullOrUndefined(e))this.performRename();else{var n=this.getRecords([e]);n.length>0&&(ee(this.parent,n[0]),t.isNullOrUndefined(i)?te(this.parent):le(this.parent.itemData[0])?be(this.parent,this.parent.path,i):ae(this.parent,this.parent.itemData[0],is))}},e}();e.AjaxSettings=it,e.toolbarItems=at,e.ToolbarSettings=rt,e.SearchSettings=ht,e.columnArray=ct,e.DetailsViewSettings=ut,e.fileItems=mt,e.folderItems=bt,e.layoutItems=yt,e.ContextMenuSettings=vt,e.NavigationPaneSettings=wt,e.UploadSettings=Ct,e.Column=Nt,e.TOOLBAR_ID=Pt,e.LAYOUT_ID=Et,e.NAVIGATION_ID="_navigation",e.TREE_ID=Rt,e.GRID_ID=Mt,e.LARGEICON_ID=kt,e.DIALOG_ID=Lt,e.ALT_DIALOG_ID="_alt_dialog",e.IMG_DIALOG_ID=Tt,e.EXTN_DIALOG_ID=At,e.UPLOAD_DIALOG_ID=Ft,e.RETRY_DIALOG_ID="_retry_dialog",e.CONTEXT_MENU_ID=Ut,e.SORTBY_ID="_sortby",e.VIEW_ID="_view",e.SPLITTER_ID="_splitter",e.CONTENT_ID=Vt,e.BREADCRUMBBAR_ID=_t,e.UPLOAD_ID=Bt,e.RETRY_ID="_retry",e.SEARCH_ID="_search",e.ROOT=Ht,e.CONTROL=zt,e.CHECK_SELECT=qt,e.ROOT_POPUP=Wt,e.MOBILE=Kt,e.MOB_POPUP=Gt,e.MULTI_SELECT=Yt,e.FILTER=Qt,e.LAYOUT="e-layout",e.NAVIGATION="e-navigation",e.LAYOUT_CONTENT=Jt,e.LARGE_ICONS=Xt,e.TB_ITEM=$t,e.LIST_ITEM=Zt,e.LIST_TEXT=ei,e.LIST_PARENT=ti,e.TB_OPTION_TICK=ii,e.TB_OPTION_DOT=ni,e.BLUR=si,e.ACTIVE=ai,e.HOVER=ri,e.FOCUS=oi,e.FOCUSED=li,e.CHECK=hi,e.FRAME="e-frame",e.CB_WRAP=di,e.ROW=pi,e.ROWCELL="e-rowcell",e.EMPTY=ci,e.EMPTY_CONTENT=ui,e.EMPTY_INNER_CONTENT=fi,e.CLONE=gi,e.DROP_FOLDER=mi,e.DROP_FILE=bi,e.FOLDER=yi,e.ICON_IMAGE=vi,e.ICON_MUSIC=Oi,e.ICON_VIDEO=Ii,e.LARGE_ICON=wi,e.LARGE_EMPTY_FOLDER=Di,e.LARGE_EMPTY_FOLDER_TWO="e-empty-icon.e-fe-folder",e.LARGE_ICON_FOLDER="e-fe-folder",e.SELECTED_ITEMS="e-items",e.TEXT_CONTENT="e-text-content",e.GRID_HEADER=Si,e.TEMPLATE_CELL="e-templatecell",e.TREE_VIEW=Ci,e.MENU_ITEM=ji,e.MENU_ICON=xi,e.SUBMENU_ICON="e-caret",e.GRID_VIEW=Ni,e.GRID_CONTENT=Pi,e.ICON_VIEW=Ei,e.ICON_OPEN=Ri,e.ICON_UPLOAD=Mi,e.ICON_CUT=ki,e.ICON_COPY=Li,e.ICON_PASTE=Ti,e.ICON_DELETE=Ai,e.ICON_RENAME=Fi,e.ICON_NEWFOLDER=Ui,e.ICON_DETAILS=Vi,e.ICON_SHORTBY=_i,e.ICON_REFRESH=Bi,e.ICON_SELECTALL=Hi,e.ICON_DOWNLOAD=zi,e.ICON_OPTIONS="e-icons e-fe-options",e.ICON_GRID=qi,e.ICON_LARGE=Wi,e.ICON_BREADCRUMB=Ki,e.ICON_CLEAR=Gi,e.ICON_DROP_IN="e-icons e-fe-drop-in",e.ICON_DROP_OUT="e-icons e-fe-drop-out",e.ICON_NO_DROP="e-icons e-fe-no-drop",e.ICONS=Yi,e.DETAILS_LABEL="e-detailslabel",e.ERROR_CONTENT=Qi,e.STATUS="e-status",e.BREADCRUMBS="e-address",e.RTL="e-rtl",e.DISPLAY_NONE=Ji,e.COLLAPSED="e-node-collapsed",e.FULLROW=Xi,e.ICON_COLLAPSIBLE="e-icon-collapsible",e.SPLIT_BAR=$i,e.HEADER_CHECK=Zi,e.OVERLAY="e-fe-overlay",e.VALUE=en,e.isFile=tn,e.modelChanged=nn,e.initialEnd=sn,e.finalizeEnd=an,e.createEnd=rn,e.filterEnd=on,e.beforeDelete="before-delete",e.pathDrag=ln,e.deleteInit=hn,e.deleteEnd=dn,e.refreshEnd=pn,e.resizeEnd=cn,e.splitterResize=un,e.pathChanged=fn,e.destroy=gn,e.beforeRequest=mn,e.upload="upload",e.skipUpload=bn,e.afterRequest=yn,e.download="download",e.layoutRefresh=vn,e.actionFailure=On,e.search=In,e.openInit=wn,e.openEnd=Dn,e.selectionChanged=Sn,e.selectAllInit=Cn,e.clearAllInit=jn,e.clearPathInit=xn,e.layoutChange=Nn,e.sortByChange=Pn,e.nodeExpand=En,e.detailsInit=Rn,e.menuItemData=Mn,e.renameInit=kn,e.renameEndParent=Ln,e.renameEnd=Tn,e.showPaste=An,e.hidePaste=Fn,e.selectedData=Un,e.cutCopyInit=Vn,e.pasteInit=_n,e.pasteEnd=Bn,e.cutEnd=Hn,e.hideLayout=zn,e.updateTreeSelection=qn,e.treeSelect="select-node",e.sortColumn=Wn,e.pathColumn=Kn,e.searchTextChange=Gn,e.beforeDownload="before-download",e.downloadInit=Yn,e.dropInit=Qn,e.dragEnd=Jn,e.dropPath=Xn,e.dragHelper="drag-helper",e.dragging=$n,e.updateSelectionData=Zn,e.methodCall=es,e.permissionRead=ts,e.permissionEdit=is,e.permissionEditContents=ns,e.permissionCopy="copy",e.permissionUpload=ss,e.permissionDownload=as,e.FileManager=cs,e.Toolbar=us,e.BreadCrumbBar=os,e.NavigationPane=fs,e.DetailsView=gs,e.LargeIconsView=rs,e.createDialog=Le,e.createExtDialog=Te,e.createImageDialog=$e,e.ContextMenu=ls,Object.defineProperty(e,"__esModule",{value:!0})});
	//# sourceMappingURL=ej2-filemanager.umd.min.js.map


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	*  filename: ej2-grids.umd.min.js
	*  version : 19.4.56
	*  Copyright Syncfusion Inc. 2001 - 2020. All rights reserved.
	*  Use of this code is subject to the terms of our license.
	*  A copy of the current license can be obtained at any time by e-mailing
	*  licensing@syncfusion.com. Any infringement will be prosecuted under
	*  applicable laws. 
	*/
	!function(e,t){ true?t(exports,__webpack_require__(23),__webpack_require__(76),__webpack_require__(46),__webpack_require__(42),__webpack_require__(59),__webpack_require__(529),__webpack_require__(528),__webpack_require__(102),__webpack_require__(530),__webpack_require__(534)):"function"==typeof define&&define.amd?define(["exports","@syncfusion/ej2-base","@syncfusion/ej2-data","@syncfusion/ej2-popups","@syncfusion/ej2-buttons","@syncfusion/ej2-inputs","@syncfusion/ej2-dropdowns","@syncfusion/ej2-calendars","@syncfusion/ej2-navigations","@syncfusion/ej2-excel-export","@syncfusion/ej2-pdf-export"],t):t(e.ej={},e.ej2Base,e.ej2Data,e.ej2Popups,e.ej2Buttons,e.ej2Inputs,e.ej2Dropdowns,e.ej2Calendars,e.ej2Navigations,e.ej2ExcelExport,e.ej2PdfExport)}(this,function(e,t,i,r,n,o,s,l,a,h,d){"use strict";function p(e,t,i,r){r&&e?e.removeAttribute(t):e&&e.setAttribute(t,i)}function c(){return["aggregates","allowGrouping","allowFiltering","allowMultiSorting","allowReordering","allowSorting","allowTextWrap","childGrid","columns","currentViewData","dataSource","detailTemplate","enableAltRow","enableColumnVirtualization","filterSettings","gridLines","groupSettings","height","locale","pageSettings","printMode","query","queryString","enableRtl","rowHeight","rowTemplate","sortSettings","textWrapSettings","allowPaging","hierarchyPrintMode","searchSettings","queryCellInfo","beforeDataBound"]}function u(e,t){return e.prototype&&t in e.prototype}function g(e,r,n){return t.isNullOrUndefined(e)||""===e?"":i.DataUtil.getObject(e,r)}function f(e,t){requestAnimationFrame(function(){try{t(null,e())}catch(e){t(e)}})}function m(e){return!t.isNullOrUndefined(e)&&!t.isNullOrUndefined(e.columns)&&e.columns.length>0}function y(e,t){for(var i=e.columns,r=t.columns,n=0;n<i.length;n++)if(r.length-1>=n)if(r[n].columns)for(var o=0;o<r[n].columns.length;o++)i[n].columns[o].type=r[n].columns[o].type;else i[n].type=r[n].type}function v(e){for(var t=[],i=e.vRows,r=0;r<i.length;r++)i[r].isDataRow?t.push(i[r]):i[r].isDataRow||(t.push(i[r]),!i[r].isExpand&&i[r].isCaptionRow&&(r+=C(i[r],e)));e.vcRows=t}function C(e,i){$l=0;var r="gSummary",n=i.groupSettings.columns.length,o=e[r],s=0,l="aggregatesCount";if(o===e.data.count)return i.groupSettings.columns.length&&!t.isNullOrUndefined(e[l])&&e[l]?1!==i.groupSettings.columns.length?$l+=0!==e.indent&&o<2?e[r]*(n-e.indent+(n-e.indent)*e[l]):e[r]*(n-e.indent+(n-e.indent-1)*e[l])+e[l]:1===i.groupSettings.columns.length&&($l+=e[r]*(n-e.indent)+e[l]):i.groupSettings.columns.length&&(1!==i.groupSettings.columns.length?$l+=e[r]*(i.groupSettings.columns.length-e.indent):$l+=e[r]),$l;for(var a=0,h=e.data.items.length;a<h;a++){var d=e.data.items[a];$l+=d.items.length+(n===i.columns.length||t.isNullOrUndefined(d.items.records)?0:d.items.records.length),s+=t.isNullOrUndefined(d.items.records)||t.isNullOrUndefined(e[l])?d.items.length:d.items.records.length,d.items.GroupGuid&&0!==d.items.childLevels&&w(d)}return $l+=e.data.items.length,t.isNullOrUndefined(e[l])||e[l]&&$l&&0!==s&&($l+=($l-s)*e[l]+e[l]),$l}function w(e){for(var t=0,i=e.items.length;t<i;t++){var r=e.items[t];$l+=r.count,0!==r.items.childLevels&&w(r)}}function b(e,i){for(var r=[],n=0,o=e.length;n<o;n++){var s=i(e[n],n);t.isNullOrUndefined(s)||r.push(s)}return r}function S(e){for(var i=[],r=0;r<e.length;r++)i.push(t.extend({},z(e[r]),{},!0));return i}function R(e){if(e)try{return document.querySelectorAll(e).length?t.compile(document.querySelector(e).innerHTML.trim()):t.compile(e)}catch(i){return t.compile(e)}}function x(e,i){var r={},n=["style","class"];t.extend(r,i,{}),"style"in r&&(t.setStyleAttribute(e,r[n[0]]),delete r[n[0]]),"class"in r&&(t.addClass([e],r[n[1]]),delete r[n[1]]),t.attributes(e,r)}function F(e,i,r,n){for(var o=t.extend(e,i,r),s=Object.keys(o),l=0;l<s.length;l++)n&&-1!==n.indexOf(s[l])&&delete o[s[l]];return o}function E(e,i){void 0===i&&(i=0);for(var r=0,n=e.length;r<n;r++)e[r].columns?(e[r].index=t.isNullOrUndefined(e[r].index)?i:e[r].index,i++,i=E(e[r].columns,i)):(e[r].index=t.isNullOrUndefined(e[r].index)?i:e[r].index,i++);return i}function I(e,i,r){for(var n=0,o=e.length;n<o;n++){var s=void 0;"string"==typeof e[n]?s=new St({field:e[n]},r):e[n]instanceof St&&!e[n].columns?s=e[n]:e[n].columns?(e[n].columns=I(e[n].columns,null,r),s=new St(e[n],r)):s=new St(e[n],r),s.type&&"checkbox"===s.type.toLowerCase()&&(s.allowReordering=!1),s.headerText=t.isNullOrUndefined(s.headerText)?s.foreignKeyValue||s.field||"":s.headerText,s.foreignKeyField=s.foreignKeyField||s.field,s.valueAccessor=("string"==typeof s.valueAccessor?t.getValue(s.valueAccessor,window):s.valueAccessor)||g,s.width=i&&t.isNullOrUndefined(s.width)?200:s.width,t.isNullOrUndefined(s.visible)&&(s.visible=!0),e[n]=s}return e}function T(e,i,r){var n=e.querySelector("span"),o=e.parentElement.getBoundingClientRect(),s=i.target.getBoundingClientRect();n.className=r,e.style.display="";var l=(t.isNullOrUndefined(i.clientY)?i.changedTouches[0].clientY:i.clientY)>e.offsetHeight+10;e.style.top=s.top-o.top+(l?-(e.offsetHeight+10):e.offsetHeight+10)+"px",e.style.left=function(e,t,i,r){var n=e.offsetWidth/2,o=B(t).x;return o-i.left<n?i.left-r:i.right-o<n?i.right-r-2*n:o-r-n}(e,i,s,o.left)+"px",l?(e.querySelector(".e-downtail").style.display="",e.querySelector(".e-uptail").style.display="none"):(e.querySelector(".e-downtail").style.display="none",e.querySelector(".e-uptail").style.display="")}function z(e){return e instanceof t.ChildProperty?t.getValue("properties",e):e}function D(e,t,i){for(var r=e;r&&(i?r.id!==t:!r.classList.contains(t));)r=r.parentElement;return r}function M(e,t){for(var i=-1,r=0,n=t.length;r<n;r++)if(t[r].isEqualNode(e)){i=r;break}return i}function O(e,t){for(var i=0,r=t.length;i<r;i++)if(t[i]===e)return i;return-1}function k(e){for(var t=[],i=0,r=e.length;i<r;i++)e[i].hasOwnProperty("properties")?t.push(e[i].properties):t.push(e[i]);return t}function A(e,i){for(var r=[].slice.call(e.querySelectorAll(i)),n=0;n<r.length;n++)t.remove(r[n])}function B(e){var i={};return i.x=t.isNullOrUndefined(e.clientX)?e.changedTouches[0].clientX:e.clientX,i.y=t.isNullOrUndefined(e.clientY)?e.changedTouches[0].clientY:e.clientY,i}function N(e){return e+ea++}function P(e,t){for(var i=0,r=t.length;i<r;i++)r===t.length?e.appendChild(t[i]):e.appendChild(t[0]);return e}function L(e,t,i){for(var r=e,n=[];r;)(i?r.id===t:r.classList.contains(t))&&n.push(r),r=r.parentElement;return n}function q(e,r,n,o){if("Custom"===e){var s=n.customAggregate;return"string"==typeof s&&(s=t.getValue(s,window)),s?s.call(o,r,n):""}return n.field in r||r instanceof Array?i.DataUtil.aggregates[e.toLowerCase()](r,n.field):null}function H(){if(null!==ta)return ta;var e=document.createElement("div"),t=0;return e.style.cssText="width:100px;height: 100px;overflow: scroll;position: absolute;top: -9999px;",document.body.appendChild(e),t=e.offsetWidth-e.clientWidth|0,document.body.removeChild(e),ta=t}function U(e){if(void 0!==qo)return qo;var i=t.createElement("table",{className:ts,styles:"visibility: hidden"});i.innerHTML='<tr><td class="e-rowcell">A<td></tr>',e.appendChild(i);var r=i.querySelector("td").getBoundingClientRect();return e.removeChild(i),qo=Math.ceil(r.height)}function j(e){return e.split(".").length>1}function V(e){return void 0===e&&(e=""),e.replace(/\./g,"___")}function G(e){return void 0===e&&(e=""),e.replace(/___/g,".")}function _(e,t,i){var r=D(i,is),n=!r||r&&!r.classList.contains("e-insertedrow");return"beginEdit"===t&&n?!(e.isIdentity||e.isPrimaryKey||!e.allowEditing):("add"!==t||!e.isIdentity)&&!(n&&!e.allowEditing&&!e.isIdentity&&!e.isPrimaryKey)}function W(e){var i=t.select("#"+e.element.id+"EditConfirm",e.element);return"Batch"===e.editSettings.mode&&t.selectAll(".e-updatedtd",e.element).length&&e.editSettings.showConfirmDialog&&(!i||i.classList.contains("e-popup-close"))}function K(e,t){e=e instanceof Array?e:[e];for(var i=0;i<e.length;i++)t?e[i].classList.add("e-wrap"):e[i].classList.remove("e-wrap")}function Q(e,t){var i,r=e.getService("valueFormatter");switch("date"!==t.type&&"datetime"!==t.type||(i={type:t.type,skeleton:t.format},"string"==typeof t.format&&"yMd"!==t.format&&(i.format=t.format)),t.type){case"date":case"datetime":t.setFormatter(r.getFormatFunction(i)),t.setParser(r.getParserFunction(i));break;case"number":t.setFormatter(r.getFormatFunction({format:t.format})),t.setParser(r.getParserFunction({format:t.format}))}}function X(e,i){for(var r=[],n=2;n<arguments.length;n++)r[n-2]=arguments[n];for(var o=0,s=e.length;o<s;o++)i?(t.classList(e[o],r.slice(),[]),e[o].setAttribute("aria-selected","true")):(t.classList(e[o],[],r.slice()),e[o].removeAttribute("aria-selected"))}function Y(e){for(var t={},i=[],r=0;r<e.length;r++)e[r]in t||(i.push(e[r].toString()),t[e[r]]=1);return i}function J(e,t){var i=t.element.style.display;t.element.style.display="block";var n=t.width,o=r.calculateRelativeBasedPosition(e,t.element);t.element.style.display=i,t.element.style.top=o.top+e.getBoundingClientRect().height-5+"px";var s=o.left-n+e.clientWidth;t.element.style.left=s<1?n+s-16+"px":s+-4+"px"}function Z(e,t){e.popup.element.style.zIndex=(t.zIndex+1).toString()}function $(e){var i=e.querySelector(".e-frame"),r=i.previousSibling;i.classList.contains("e-check")?(r.checked=!1,t.classList(i,["e-uncheck"],["e-check"])):(r.checked=!0,t.classList(i,["e-check"],["e-uncheck"]))}function ee(e,t){e.checked=t}function te(e,i,r){var n=t.createElement("div",{className:r});return n.appendChild(i),n.setAttribute("uid",e),n}function ie(e,i){t.removeClass([e],["e-check","e-stop","e-uncheck"]),i?e.classList.add("e-check"):e.classList.add("e-uncheck")}function re(e,i,r){for(var n=0;n<i.length;n++)t.setValue(i[n].field,ne(i[n],r),e.foreignKeyData);var o=e.cells;for(n=0;n<o.length;n++)o[n].isForeignKey&&t.setValue("foreignKeyData",t.getValue(o[n].column.field,e.foreignKeyData),o[n])}function ne(e,r,n,o){var s=e.foreignKeyField,l=t.isNullOrUndefined(n)?g(e.field,r):n;l=t.isNullOrUndefined(l)?"":l;var a=new i.Query,h=o||(e.dataSource instanceof i.DataManager&&e.dataSource.dataSource.json.length?e.dataSource.dataSource.json:e.columnData);return l.getDay?a.where(se({field:s,operator:"equal",value:l,matchCase:!1})):a.where(s,"==",l,!1),new i.DataManager(h).executeLocal(a)}function oe(e,t){var i;return t.some(function(t){return i=t,t.foreignKeyValue===e})&&i}function se(e,r){var n,o,s,l=t.extend({},z(e)),a=t.extend({},z(e));if(t.isNullOrUndefined(e.value))return n=new i.Predicate(l.field,l.operator,l.value,!1);var h=new Date(e.value);if("equal"===e.operator||"notequal"===e.operator){"datetime"===r?(o=new Date(h.setSeconds(h.getSeconds()-1)),s=new Date(h.setSeconds(h.getSeconds()+2)),e.value=new Date(h.setSeconds(s.getSeconds()-1))):(o=new Date(h.setHours(0)-1),s=new Date(h.setHours(24))),l.value=o,a.value=s,"equal"===e.operator?(l.operator="greaterthan",a.operator="lessthan"):"notequal"===e.operator&&(l.operator="lessthanorequal",a.operator="greaterthanorequal");var d=new i.Predicate(l.field,l.operator,l.value,!1),p=new i.Predicate(a.field,a.operator,a.value,!1);n="equal"===e.operator?d.and(p):d.or(p)}else{"date"!==r||"lessthanorequal"!==e.operator&&"greaterthan"!==e.operator||(l.value=new Date(h.setHours(24)-1)),"string"==typeof l.value&&(l.value=new Date(l.value));n=new i.Predicate(l.field,l.operator,l.value,!1)}return e.setProperties?e.setProperties({ejpredicate:n},!0):e.ejpredicate=n,n}function le(e,t,i){t=t&&i&&i.isRowDragable()?t+1:t;for(var r=e.cloneNode(!0),n=0;n<t;n++)r.removeChild(r.children[0]);n=t;for(var o=e.childElementCount;n<o;n++)e.removeChild(e.children[e.childElementCount-1]);return r}function ae(e){return e.enableVirtualization&&e.groupSettings.columns.length>0&&e.isVirtualAdaptive}function he(e,i){if(void 0===e&&(e=""),e){for(var r=i,n=e.split("."),o=0;o<n.length&&!t.isNullOrUndefined(r);o++)r=r[n[o]];return r}}function de(e,i){var r=new t.Internationalization;return"date"===i?"object"==typeof e?r.getDatePattern({type:e.type?e.type:"date",format:e.format},!1):r.getDatePattern({type:"dateTime",skeleton:e},!1):"object"==typeof e?r.getDatePattern({type:e.type?e.type:"dateTime",format:e.format},!1):r.getDatePattern({type:"dateTime",skeleton:e},!1)}function pe(e,t){for(var i={},r=0,n=e.getRowsObject();r<n.length;r++){var o=n[r];if(o.isExpand&&!o.isDetailRow){var s=e.allowPaging&&"AllPages"===e.printMode?o.index+e.pageSettings.currentPage*e.pageSettings.pageSize-e.pageSettings.pageSize:o.index;i[s]={},i[s].isExpand=!0,i[s].gridModel=ce(o.childGrid,t),i[s].gridModel.query=e.childGrid.query}}return i}function ce(e,t){void 0===t&&(t="Expanded");var i={};if(!e)return i;for(var r=e.isFrozenGrid()&&!e.getFrozenColumns(),n=0,o=Zl.printGridProp;n<o.length;n++){var s=o[n];i[s]="columns"===s?k(r?e.getColumns():e[s]):"allowPaging"===s?"CurrentPage"===e.printMode:z(e[s])}return i.enableHover=!1,e.childGrid&&"None"!==t&&(i.expandedRows=pe(e,t)),i}function ue(e,i,r,n){var o=e||{},s=arguments.length;n&&(s-=1);for(var l=1;l<s;l++)if(arguments[l])for(var a=arguments[l],h=Object.keys(Object.getPrototypeOf(a)).length?Object.keys(a).concat(function(e){var t=[];for(;Object.getPrototypeOf(e)&&Object.keys(Object.getPrototypeOf(e)).length;)t=t.concat(Object.keys(Object.getPrototypeOf(e))),e=Object.getPrototypeOf(e);return t}(a)):Object.keys(a),d=0;d<h.length;d++){var p=o[h[d]],c=a[h[d]],u=void 0;n&&(t.isObject(c)||Array.isArray(c))?t.isObject(c)?(u=p||{},o[h[d]]=t.extend({},u,c,n)):(u=p||[],o[h[d]]=t.extend([],u,c,n)):o[h[d]]=c}return o}function ge(e){for(var t=0,i=0;i<e.length;i++){var r=fe(e[i],0);t<r&&(t=r)}return t+1}function fe(e,t){var i=t,r=[];if(e.columns){t++;for(var n=0;n<e.columns.length;n++)r[n]=fe(e.columns[n],t);for(var o=0;o<r.length;o++)i<r[o]&&(i=r[o]);t=i}return t}function me(e,t){for(var i=0;i<t.length;i++)t[i].uid=t[i].isForeignKey?oe(t[i].field,e.getForeignKeyColumns()).uid:e.enableColumnVirtualization?Qe(e,t[i].field).uid:e.getColumnByField(t[i].field).uid}function ye(e){var t=document.defaultView.getComputedStyle(e,null).getPropertyValue("transform").replace(/,/g,"");return{width:parseFloat(t.split(" ")[4]),height:parseFloat(t.split(" ")[5])}}function ve(e,t){e.classList.contains("e-bigger")&&t.classList.add("e-bigger")}function Ce(e,i){if(e&&i){var r=t.closest(e,"."+is).getBoundingClientRect().height,n=t.closest(i,"."+is).getBoundingClientRect().height;r>n?i.style.height=r+"px":e.style.height=n+"px"}}function we(e,t){var i=t.getContent().firstElementChild.offsetHeight;return e&&e.getBoundingClientRect().top>i}function be(e,t){return e&&e.getBoundingClientRect().top<t}function Se(e,t){var i=t.getRowHeight(),r=t.getContent().firstElementChild.scrollTop/i;return e<r+t.getContent().firstElementChild.offsetHeight/i&&e>r}function Re(e,t){var i,r=e.getPrimaryKeyFieldNames()[0];return e.getCurrentViewRecords().filter(function(e,n){e[r]===t[r]&&(i=n)}),i}function xe(e,t){var r=Fe(t),n=new i.Deferred;return r.dataSource=n.resolve,r.action=e,{state:r,deffered:n}}function Fe(e){var t=new i.UrlAdaptor,r=new i.DataManager({url:"",adaptor:new i.UrlAdaptor}),n=t.processQuery(r,e);return JSON.parse(n.data)}function Ee(e){for(var i=e.getVisibleColumns(),r=0,n=0,o=0;o<i.length;o++)t.isUndefined(i[o].width)?n++:-1!==i[o].width.toString().indexOf("%")&&r++;return("auto"===e.width||"string"==typeof e.width&&-1!==e.width.indexOf("%"))&&!e.groupSettings.showGroupedColumn&&e.groupSettings.columns.length&&r&&!n}function Ie(e,t,i,r){for(var n=r||0,o=0;o<t.length;o++)if(t[o].isDataRow){t[o].index=n,t[o].isAltRow=!!e.enableAltRow&&n%2!=0,i[o].setAttribute(us,n.toString()),t[o].isAltRow?i[o].classList.add("e-altrow"):i[o].classList.remove("e-altrow");for(var s=0;s<i[o].cells.length;s++)i[o].cells[s].setAttribute("index",n.toString());n++}t.length||e.renderModule.emptyRow(!0)}function Te(e,t,i,r){var n=e.dataToBeUpdated[i].concat(t[i]).reduce(function(e,t){return e[t[r]]=void 0===e[t[r]]?t:Object.assign(e[t[r]],t),e},{});e.dataToBeUpdated[i]=Object.keys(n).map(function(e){return n[e]})}function ze(e){if(e.isFrozenGrid()){e.contentModule.rowElements=[].slice.call(e.element.querySelectorAll(".e-movableheader .e-row, .e-movablecontent .e-row"));var t=e.getFrozenMode()===hs?".e-frozen-left-header .e-row, .e-frozen-left-content .e-row":".e-frozenheader .e-row, .e-frozencontent .e-row";e.contentModule.freezeRowElements=[].slice.call(e.element.querySelectorAll(t)),e.getFrozenMode()===hs&&(e.contentModule.frozenRightRowElements=[].slice.call(e.element.querySelectorAll(".e-frozen-right-header .e-row, .e-frozen-right-content .e-row")))}else e.contentModule.rowElements=[].slice.call(e.element.querySelectorAll(".e-row:not(.e-addedrow)"))}function De(e,t,i){var r=e.getFrozenLeftCount(),n=e.getMovableColumnsCount(),o=e.getFrozenRightColumnsCount(),s=e.getFrozenMode(),l=e.isRowDragable()?1:0,a="Right"===s?r+n:r+n+l,h="Right"===s?r:r+l,d="Right"===s?t.length-o-l:o?t.length-o:t.length;return i===ps?t=t.slice(0,r?r+l:t.length):i===ds?t=t.slice(a,t.length):"movable"===i&&(t=t.slice(h,d)),t}function Me(e,t,i,r,n){(i[0].length||r)&&(n?t(ps,i[0],n[0]):t(ps,i[0])),e.isFrozenGrid()&&(i[1].length||r)&&(n?t("movable",i[1],n[1]):t("movable",i[1])),e.getFrozenMode()!==hs&&"Right"!==e.getFrozenMode()||!i[2].length&&!r||(n?t(ds,i[2],n[2]):t(ds,i[2]))}function Oe(e){return["Right"!==e.getFrozenMode()?e.getRowsObject():[],e.getMovableRowsObject(),e.getFrozenRightRowsObject()]}function ke(e){return["Right"!==e.getFrozenMode()?e.getAllDataRows(!0):[],e.getAllMovableDataRows(!0),e.getAllFrozenRightDataRows(!0)]}function Ae(e,t,i){for(var r=e.children.length,n=0,o=0;o<r;o++,n++)o>=t&&o<i||(e.removeChild(e.children[n]),n--)}function Be(e,t,i){return"movable"===t.getFreezeTableName()?[].slice.call(e.getMovableDataRows()[i].getElementsByClassName(_o)):t.getFreezeTableName()===ds?[].slice.call(e.getFrozenRightDataRows()[i].getElementsByClassName(_o)):[].slice.call(e.getDataRows()[i].getElementsByClassName(_o))}function Ne(e,t,i,r){var n=e.getFrozenLeftCount(),o=e.getMovableColumnsCount();return r="movable"===t.getFreezeTableName()?r-n:t.getFreezeTableName()===ds?r-(n+o):r,Be(e,t,i)[r]}function Pe(e,t,i,r,n,o,s){s?i[V(e.field)]=e.validationRules:e.getFreezeTableName()===ps||!t&&e.getFreezeTableName()===ds||1===o?i[V(e.field)]=e.validationRules:"movable"!==e.getFreezeTableName()&&e.getFreezeTableName()?e.getFreezeTableName()===ds&&(n[V(e.field)]=e.validationRules):r[V(e.field)]=e.validationRules}function Le(e){var t;return e.isFrozenGrid()&&(t=e.frozenRows&&"Top"===e.editSettings.newRowPosition?e.getMovableHeaderTbody():e.getMovableContentTbody()),t}function qe(e){var t;return e.getFrozenMode()===hs&&(t=e.frozenRows&&"Top"===e.editSettings.newRowPosition?e.getFrozenRightHeaderTbody():e.getFrozenRightContentTbody()),t}function He(e,t,i,r,n,o,s){e&&r&&s(e,r),t&&n&&s(t,n),i&&o&&s(i,o)}function Ue(e,i,r){var n,o=new t.Internationalization;if("number"===i)try{n=o.getNumberPattern({format:e,currency:this.currency,useGrouping:!0},!0)}catch(t){n=e}else if("date"===i||"time"===i||"datetime"===i)try{if(n=o.getDatePattern({skeleton:e,type:i},r),t.isNullOrUndefined(n))throw"error"}catch(t){try{n=o.getDatePattern({format:e,type:i},r)}catch(t){n=e}}else n=e;if("number"!==i){var s={G:"",H:"h",c:"d","'":'"'," a":" AM/PM",yy:"yy",y:"yyyy",EEEE:"dddd",E:"ddd"};n=n.replace(/G|H|c|'| a|yy|y|EEEE|E/g,function(e){return s[e]})}return n}function je(e){if(e.enableAdaptiveUI)for(var t=document.getElementsByClassName("e-responsive-dialog"),i=0;i<t.length;i++)t[i].classList.add("e-bigger")}function Ve(e,t){for(var i,r=e.split(".").length,n=e.split("."),o=t,s=0;s<r;s++)o=i=o[n[s]];return i}function Ge(e,i,r,n,o,s){for(var l=Object.keys(e),a=0;a<l.length;a++){var h=e[l[a]].querySelectorAll("td.e-rowcell")[i];if(e[l[a]].querySelectorAll("td.e-rowcell").length&&h)if(t.setStyleAttribute(e[l[a]].querySelectorAll("td.e-rowcell")[i],{display:r}),e[l[a]].querySelectorAll("td.e-rowcell")[i].classList.contains("e-hide")&&t.removeClass([e[l[a]].querySelectorAll("td.e-rowcell")[i]],["e-hide"]),s&&o.isRowDragable()){var d=o.getFrozenColumns()?i:i+1;n[l[a]].cells[d].visible=""===r}else n[l[a]].cells[i].visible=""===r}}function _e(e,t,i,r){for(var n=0,o=t;n<o.length;n++){var s=o[n];i?e.on(s.event,s.handler,r):e.off(s.event,s.handler)}}function We(e,t,i,r){var n=V(t.field);return r=Object.assign(r,{id:e.element.id+n,name:n,"e-mappinguid":t.uid}),e.createElement("input",{className:i,attrs:r})}function Ke(e,t){for(var i,r=0,n=e.columnModel;r<n.length;r++){var o=n[r];if(o.uid===t){i=o;break}}return i}function Qe(e,t){var i;e.columnModel||e.getColumns();for(var r=0,n=e.columnModel;r<n.length;r++){var o=n[r];if(o.field===t){i=o;break}}return i}function Xe(e,t,i,r){r.eventHandlers[e]={};for(var n=0;n<t.length;n++)r.eventHandlers[e][t[n]]=i[t[n]]}function Ye(e,t,i){for(var r=0;r<t.length&&!e.isDestroyed;r++)e.removeEventListener(t[r],i.eventHandlers[e.element.id][t[r]])}function Je(e,t){e.destroyTemplate(t),e.isReact&&e.renderTemplates()}function Ze(e){return parseInt(e.getAttribute(us),10)}function $e(e,i,r){for(var n=[],o=0;o<e.length;o++){var s=r.parent.getColumnByField(e[o]),l="null"===i[o]?null:i[o],a={field:e[o],predicate:"or",uid:s.uid,operator:"equal",type:s.type,matchCase:r.allowCaseSensitive,ignoreAccent:r.parent.filterSettings.ignoreAccent};""===l||t.isNullOrUndefined(l)?n=n.concat(ia.generateNullValuePredicates(a)):n.push(F({},{value:l},a))}return ia.getPredicate(n)}function et(e){for(var t=[],i=0,r=Object.keys(e);i<r.length;i++){var n=r[i];t.push(e[n])}return t}function tt(e,t){for(var i=[],r=[],n=e;n>=0&&(!t[n].isCaptionRow||-1!==i.indexOf(t[n].data.field)||!(t[n].indent<t[e].indent||n===e)||(i.push(t[n].data.field),r.push(t[n].data.key),0!==t[n].indent));n--);return{fields:i,keys:r}}function it(e,t){for(var i=0;i<e.length;i++)for(var r=0;r<e[i].columns.length;r++)t(e[i].columns[r],e[i])}function rt(e,t,i){var r="Dialog"!==t,n=de(e.column.format,e.column.type),o=he(e.column.field,e.rowData);return o=o?new Date(o):null,{floatLabelType:r?"Never":"Always",value:o,format:n,placeholder:r?"":e.column.headerText,enableRtl:i,enabled:_(e.column,e.requestType,e.element)}}function nt(e,t,i,r,n,o,s,l){r.clearSelection(),e.startIndex=0;var a=new Fs(o,null,r),h=n.generateRows(t,e);e.renderMovableContent?(s.vgenerator.movableCache[1]=h,h=r.getMovableRowsObject()):e.renderFrozenRightContent||e.renderMovableContent?e.renderFrozenRightContent&&(s.vgenerator.frozenRightCache[1]=h,h=r.getFrozenRightRowsObject()):(s.vgenerator.cache[1]=h,h=r.getRowsObject());var d=e.renderMovableContent||e.renderFrozenRightContent?e.renderMovableContent?r.getHeaderContent().querySelector("."+Jo).querySelector(gs):r.getHeaderContent().querySelector(".e-frozen-right-header").querySelector(gs):r.getHeaderContent().querySelector("."+$o).querySelector(gs);d.innerHTML="";for(var p=0;p<r.frozenRows;p++)if(d.appendChild(a.render(h[p],r.getColumns())),i.indexOf(p)>-1){h[p].isSelected=!0;for(var c=0;c<h[p].cells.length;c++)h[p].cells[c].isSelected=!0}e.renderMovableContent?l.mvblRows=s.vgenerator.movableCache[1]:e.renderMovableContent||e.renderFrozenRightContent?e.renderFrozenRightContent&&(l.frRows=s.vgenerator.frozenRightCache[1]):l.frzRows=s.vgenerator.cache[1],e.renderMovableContent=!e.renderMovableContent&&!e.renderFrozenRightContent,e.renderFrozenRightContent=r.getFrozenMode()===hs&&!e.renderMovableContent&&!e.renderFrozenRightContent,(e.renderMovableContent||e.renderFrozenRightContent)&&(nt(e,t,i,r,n,o,s,l),e.renderMovableContent||e.renderFrozenRightContent||(e.isFrozenRowsRender=!1))}function ot(e,i,r){for(var n=[],o=0;o<e.length;o++)n.push(t.extend({},e[o])),n[o].cells=De(r,n[o].cells,i);return n}function st(e,t,i){var r,n=[];e===ps?r=t.vgenerator.cache:"movable"===e?r=t.vgenerator.movableCache:e===ds&&(r="Right"===i.getFrozenMode()?t.vgenerator.cache:t.vgenerator.frozenRightCache);for(var o=Object.keys(r),s=0;s<o.length;s++)n=n.concat(ot(r[o[s]],e,i));return n}function lt(e,t){for(var i=Object.keys(t.vgenerator.cache),r=Object.keys(t.vgenerator.movableCache),n=Object.keys(t.vgenerator.frozenRightCache),o=0;o<i.length;o++)at(e,t.vgenerator.cache[i[o]]);for(o=0;o<r.length;o++)at(e,t.vgenerator.movableCache[r[o]]);for(o=0;o<n.length;o++)at(e,t.vgenerator.frozenRightCache[n[o]])}function at(e,t){for(var i=t.filter(function(t){return e.clearAll||e.uid===t.uid}),r=0;r<i.length;r++){i[r].isSelected=e.set;for(var n=i[r].cells,o=0;o<n.length;o++)n[o].isSelected=e.set}}function ht(e,t,i,r,n){e.appendContent(i,r,n),t.refreshFrozenScrollbar()}function dt(e,i,r,n,o){var s=[];s=e.vgenerator.generateRows(i,r).map(function(e){return t.extend({},e)});var l=n.generateRows(i,r,s);return o.frozenRows&&"delete"===r.requestType&&1===o.pageSettings.currentPage&&(l=l.slice(o.frozenRows)),l}function pt(e,t,i,r,n){var o=e.virtualInfo.blockIndexes,s=e.virtualInfo.columnIndexes,l=e.virtualInfo.page;e.virtualInfo.blockIndexes=[1,2],e.virtualInfo.page=1,e.renderMovableContent||(e.virtualInfo.columnIndexes=[]);var a=i.getCurrentViewRecords().length;n=i.renderModule.data.dataManager.dataSource.json.slice(0,a);var h=function(e,t,i,r){var n;n=i.renderMovableContent?"movable":i.renderFrozenRightContent?"frozen-right":"frozen-left";for(var o=0,s=e.length;o<s;o++)e[o].cells=De(t,e[o].cells,n);return e}(t.vgenerator.generateRows(n,e),i,e);return e.virtualInfo.blockIndexes=o,e.virtualInfo.columnIndexes=s,e.virtualInfo.page=l,h.splice(0,i.frozenRows)}function ct(e){var t=!1;return e&&(t="virtualscroll"===e.requestType&&"X"===e.currentInfo.sentinelInfo.axis),t}function ut(e,t){var i=ct(e)?t.getMovableVirtualHeader():t.getHeaderContent();return i?[].slice.call(i.querySelectorAll(".e-headercell:not(.e-stackedheadercell)")):[]}function gt(e,t){return ct(e)?t.getMovableVirtualHeader().querySelector("."+ts):t.getFrozenVirtualHeader().querySelector("."+ts)}function ft(e,t){return e=t.columns.slice(0,t.getFrozenColumns()).concat(e)}function mt(e,i,r){return ct(i)||(t.isNullOrUndefined(e)||(e.id="content-"+e.id),r.colgroup=e),r.colgroup}function yt(e,t){e.virtualRenderer.vgenerator.cache[1]?e.virtualRenderer.vgenerator.cache[1][t]=e.frzRows[t]:e.virtualRenderer.vgenerator.cache[1]=e.frzRows,e.virtualRenderer.vgenerator.movableCache[1]?e.virtualRenderer.vgenerator.movableCache[1][t]=e.mvblRows[t]:e.virtualRenderer.vgenerator.movableCache[1]=e.mvblRows}function vt(e,t,r,n){var o=e.dataSource instanceof i.DataManager&&!e.dataSource.dataSource.offline,s={container:t.content,pageHeight:2*t.getBlockHeight(),debounceEvent:o,axes:e.enableColumnVirtualization?["X","Y"]:["Y"],scrollbar:r,movableContainer:n};t.observer=new qa(t.virtualEle.wrapper,s,t.virtualEle.movableWrapper)}var Ct=function(){function e(e){this.intl=new t.Internationalization,t.isNullOrUndefined(e)||(this.intl.culture=e)}return e.prototype.getFormatFunction=function(e){return e.type?this.intl.getDateFormat(e):this.intl.getNumberFormat(e)},e.prototype.getParserFunction=function(e){return e.type?this.intl.getDateParser(e):this.intl.getNumberParser(e)},e.prototype.fromView=function(e,i,r){return"date"!==r&&"datetime"!==r&&"number"!==r||t.isNullOrUndefined(i)?e:i(e)},e.prototype.toView=function(e,i){var r=e;return t.isNullOrUndefined(i)||t.isNullOrUndefined(e)||(r=i(e)),r},e.prototype.setCulture=function(e){t.isNullOrUndefined(e)||t.setCulture(e)},e}(),wt=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),bt=function(e,t,i,r){var n,o=arguments.length,s=o<3?t:null===r?r=Object.getOwnPropertyDescriptor(t,i):r;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,i,r);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(o<3?n(s):o>3?n(t,i,s):n(t,i))||s);return o>3&&s&&Object.defineProperty(t,i,s),s},St=function(){function e(e,r){var n=this;this.disableHtmlEncode=!0,this.allowSorting=!0,this.allowResizing=!0,this.allowFiltering=!0,this.allowGrouping=!0,this.allowReordering=!0,this.showColumnMenu=!0,this.enableGroupByFormat=!1,this.allowEditing=!0,this.filter={},this.showInColumnChooser=!0,this.edit={},this.allowSearching=!0,this.autoFit=!1,this.sortDirection="Descending",this.getEditTemplate=function(){return n.editTemplateFn},this.getFilterTemplate=function(){return n.filterTemplateFn},t.merge(this,e),this.parent=r,"none"===this.type?this.type=null:this.type&&(this.type="string"==typeof this.type?this.type.toLowerCase():void 0),this.editType&&(this.editType=this.editType.toLowerCase()),t.isNullOrUndefined(this.uid)&&(this.uid=N("grid-column"));var o=new Ct;if(e.format&&(e.format.skeleton||e.format.format&&"string"==typeof e.format.format)&&(this.setFormatter(o.getFormatFunction(t.extend({},e.format))),this.setParser(o.getParserFunction(e.format))),this.toJSON=function(){for(var e={},t=["filter","dataSource","headerText","template","headerTemplate","edit","editTemplate","filterTemplate","commandsTemplate","parent"],i=Object.keys(n),r=0;r<i.length;r++)if("columns"===i[r]){e[i[r]]=[];for(var o=0;o<n[i[r]].length;o++)e[i[r]].push(n[i[r]][o].toJSON())}else t.indexOf(i[r])<0&&(e[i[r]]=n[i[r]]);return e},this.field||(this.allowFiltering=!1,this.allowGrouping=!1,this.allowSorting=!1,this.columns&&(this.allowResizing=this.columns.some(function(e){return e.allowResizing}))),this.commands&&!this.textAlign&&(this.textAlign="Right"),(this.template||this.commandsTemplate)&&(this.templateFn=R(this.template||this.commandsTemplate)),this.headerTemplate&&(this.headerTemplateFn=R(this.headerTemplate)),!t.isNullOrUndefined(this.filter)&&this.filter.itemTemplate&&(this.fltrTemplateFn=R(this.filter.itemTemplate)),this.editTemplate&&(this.editTemplateFn=R(this.editTemplate)),this.filterTemplate&&(this.filterTemplateFn=R(this.filterTemplate)),this.isForeignColumn()&&(t.isNullOrUndefined(this.editType)||"dropdownedit"===this.editType||"defaultedit"===this.editType)&&(this.editType="dropdownedit",this.edit.params&&this.edit.params.dataSource&&(this.edit.params.ddEditedData=!0),this.edit.params=t.extend({dataSource:this.dataSource,query:new i.Query,fields:{value:this.foreignKeyField||this.field,text:this.foreignKeyValue}},this.edit.params)),this.sortComparer){var s=this.sortComparer;this.sortComparer=function(e,t,i,r){if("string"==typeof s&&(s=he(s,window)),"Descending"===n.sortDirection){var o=e;e=t,t=o;var l=i;i=r,r=l}return s(e,t,i,r)}}!this.sortComparer&&this.isForeignColumn()&&(this.sortComparer=function(e,t){return e=he(n.foreignKeyValue,ne(n,{},e)[0]),t=he(n.foreignKeyValue,ne(n,{},t)[0]),"Descending"===n.sortDirection?i.DataUtil.fnDescending(e,t):i.DataUtil.fnAscending(e,t)})}return e.prototype.getSortDirection=function(){return this.sortDirection},e.prototype.setSortDirection=function(e){this.sortDirection=e},e.prototype.getFreezeTableName=function(){return this.freezeTable},e.prototype.setProperties=function(e){for(var t=Object.keys(e),i=0;i<t.length;i++)this[t[i]]=e[t[i]],this.parent&&this.parent.isReact&&("template"===t[i]?this.parent.refreshReactColumnTemplateByUid(this.uid):"headerTemplate"===t[i]&&(this.headerTemplateFn=R(e[t[i]]),this.parent.refreshReactHeaderTemplateByUid(this.uid)))},e.prototype.isForeignColumn=function(){return!(!this.dataSource||!this.foreignKeyValue)},e.prototype.getFormatter=function(){return this.formatFn},e.prototype.setFormatter=function(e){this.formatFn=e},e.prototype.getParser=function(){return this.parserFn},e.prototype.setParser=function(e){this.parserFn=e},e.prototype.getColumnTemplate=function(){return this.templateFn},e.prototype.getHeaderTemplate=function(){return this.headerTemplateFn},e.prototype.getFilterItemTemplate=function(){return this.fltrTemplateFn},e.prototype.getDomSetter=function(){return this.disableHtmlEncode?"textContent":"innerHTML"},e}(),Rt=function(){function e(){}return bt([t.Property()],e.prototype,"title",void 0),bt([t.Property()],e.prototype,"type",void 0),bt([t.Property()],e.prototype,"buttonOption",void 0),e}(),xt=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return wt(i,e),bt([t.Property(null)],i.prototype,"columns",void 0),i}(St),Ft=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return wt(t,e),t}(xt),Et="rowDataBound",It="queryCellInfo",Tt="headerCellInfo",zt="actionBegin",Dt="actionComplete",Mt="actionFailure",Ot="dataBound",kt="rowSelecting",At="rowSelected",Bt="rowDeselecting",Nt="rowDeselected",Pt="cellSelecting",Lt="cellSelected",qt="cellDeselecting",Ht="cellDeselected",Ut="columnSelecting",jt="columnSelected",Vt="columnDeselecting",Gt="columnDeselected",_t="columnDragStart",Wt="columnDrag",Kt="columnDrop",Qt="rowDragStartHelper",Xt="rowDragStart",Yt="rowDrag",Jt="rowDrop",Zt="beforePrint",$t="printComplete",ei="detailDataBound",ti="batchAdd",ii="batchCancel",ri="batchDelete",ni="beforeBatchAdd",oi="beforeBatchDelete",si="beforeBatchSave",li="recordDoubleClick",ai="beforeDataBound",hi="beforeOpenColumnChooser",di="beforeOpenAdaptiveDialog",pi="resizeStop",ci="checkBoxChange",ui="beforeAutoFill",gi="filterchoicerequest",fi="filterafteropen",mi="filterbeforeopen",yi="filtersearchbegin",vi="exportGroupCaption",Ci="lazyLoadGroupExpand",wi="lazyLoadGroupCollapse",bi="initial-load",Si="initial-end",Ri="data-ready",xi="content-ready",Fi="ui-update",Ei="on-empty",Ii="inbound-model-changed",Ti="model-changed",zi="colgroup-refresh",Di="header-refreshed",Mi="paging-complete",Oi="sorting-complete",ki="filtering-complete",Ai="searching-complete",Bi="reorder-complete",Ni="rowdraganddrop-complete",Pi="grouping-complete",Li="ungrouping-complete",qi="group-aggregates",Hi="refresh-footer-rendered",Ui="refresh-aggregate-cell",ji="refresh-aggregates",Vi="beforecellfocused",Gi="cellfocused",_i="key-pressed",Wi="click",Ki="destroy",Qi="column-visible-changed",Xi="scroll",Yi="column-width-changed",Ji="column-position-changed",Zi="rows-added",$i="rows-removed",er="column-drag-stop",tr="header-drop",ir="datasource-modified",rr="refresh-complete",nr="refresh-virtual-block",or="dblclick",sr="toolbar-refresh",lr="bulk-save",ar="auto-col",hr="tooltip-destroy",dr="update-data",pr="save-complete",cr="delete-complete",ur="prevent-batch",gr="dialog-destroy",fr="crud-Action",mr="add-delete-Action",yr="destroy-form",vr="double-tap",Cr="beforeExcelExport",wr="excelExportComplete",br="excelQueryCellInfo",Sr="excelHeaderQueryCellInfo",Rr="exportDetailDataBound",xr="beforePdfExport",Fr="pdfExportComplete",Er="pdfQueryCellInfo",Ir="pdfHeaderQueryCellInfo",Tr="contextMenuClick",zr="freezerender",Dr="contextMenuOpen",Mr="columnMenuClick",Or="columnMenuOpen",kr="filterOpen",Ar="filterDialogCreated",Br="filter-menu-close",Nr="initForeignKeyColumn",Pr="getForeignKeyData",Lr="generateQuery",qr="showEmptyGrid",Hr="foreignKeyData",Ur="columnDataStateChange",jr="dataStateChange",Vr="dataSourceChanged",Gr="rtl-updated",_r="beforeFragAppend",Wr="frozenHeight",Kr="textWrapRefresh",Qr="recordAdded",Xr="cancel-Begin",Yr="editNextValCell",Jr="hierarchyprint",Zr="expandchildgrid",$r="printGrid-Init",en="export-RowDataBound",tn="export-DataBound",rn="row-position-changed",nn="columnChooserOpened",on="batchedit-form",sn="before-batch-cancel",ln="batcheditform-rendered",an="partial-refresh",hn="beforeCustomFilterOpen",dn="select-virtual-Row",pn="columns-prepared",cn="cbox-filter-begin",un="cbox-filter-complete",gn="filter-Prevent",fn="before-filter-cmenu-open",mn="validation-custom-placement",yn="filter-cbox-value",vn="restore-Focus",Cn="detail-state-change",wn="detail-indentcell-info",bn="virtaul-cell-focus",Sn="virtual-scroll-edit-action-begin",Rn="virtual-scroll-edit-success",xn="virtual-scroll-edit-cancel",Fn="virtual-scroll-edit",En="refresh-virtual-cache",In="edit-reset",Tn="virtual-scroll-add-action-begin",zn="get-virtual-data",Dn="refresh-infinite-mode-blocks",Mn="reset-infinite-blocks",On="infinite-scroll-handler",kn="infinite-page-query",An="infinite-show-hide",Bn="append-infinite-content",Nn="remove-infinite-rows",Pn="set-infinite-cache",Ln="infinite-edit-handler",qn="initial-collapse",Hn="close-filter-dialog",Un="columnChooserCancelBtnClick",jn="get-filterbar-operator",Vn="reset-columns",Gn="pdfAggregateQueryCellInfo",_n="excelAggregateQueryCellInfo",Wn="group-cache",Kn="lazy-load-scroll-handler",Qn="group-collapse",Xn="beforeCheckboxRenderer",Yn="refreshResizeHandlers",Jn="refresh-frozen-columns",Zn="set-reorder-destination-element",$n="refresh-virtual-frozen-height",eo="set-freeze-selection",to="before-refresh-on-data-change",io="immutable-batch-cancel",ro="refresh-virtual-frozenrows",no="check-scroll-reset",oo="refresh-frozen-height",so="set-height-to-frozen-element",lo="prevent-frozen-scroll-refresh",ao="next-cell-index",ho="refresh-infinite-current-view-data",po="infinite-crud-cancel",co="filter-dialog-close",uo="refresh-cutsom-filter-ok-button",go="refresh-cutsom-filter-clear-button",fo="render-responsive-cmenu",mo="filter-cmenu-select",yo="custom-filter-close",vo="set-fullscreen-dialog",Co="refresh-Expand-and-Collapse",wo="row-mode-change",bo="enter-key-handler",So="refresh-virtual-max-page",Ro="set-virtual-page-query",xo="select-row-on-context-open",Fo="pager-refresh",Eo="close-edit",Io="reset-virtual-focus",To="refresh-virtual-editform-cells",zo="scroll-to-edit",Do="before-checkbox-renderer-query",Mo="create-virtual-validation-form",Oo="validate-virtual-form",ko="destroy-child-grid",Ao="sticky-scroll-complete",Bo="infinite-group-collapse",No="refresh-infinite-persist-selection",Po="refresh-infinite-editrowindex",Lo="after-filter-column-menu-close";!function(e){e[e.Data=0]="Data",e[e.Header=1]="Header",e[e.Summary=2]="Summary",e[e.GroupSummary=3]="GroupSummary",e[e.CaptionSummary=4]="CaptionSummary",e[e.Filter=5]="Filter",e[e.Indent=6]="Indent",e[e.GroupCaption=7]="GroupCaption",e[e.GroupCaptionEmpty=8]="GroupCaptionEmpty",e[e.Expand=9]="Expand",e[e.HeaderIndent=10]="HeaderIndent",e[e.StackedHeader=11]="StackedHeader",e[e.DetailHeader=12]="DetailHeader",e[e.DetailExpand=13]="DetailExpand",e[e.CommandColumn=14]="CommandColumn",e[e.DetailFooterIntent=15]="DetailFooterIntent",e[e.RowDragIcon=16]="RowDragIcon",e[e.RowDragHIcon=17]="RowDragHIcon"}(e.CellType||(e.CellType={})),function(e){e[e.Header=0]="Header",e[e.Content=1]="Content",e[e.Summary=2]="Summary"}(e.RenderType||(e.RenderType={})),function(e){e[e.Add=0]="Add",e[e.Edit=1]="Edit",e[e.Update=2]="Update",e[e.Delete=3]="Delete",e[e.Cancel=4]="Cancel",e[e.Print=5]="Print",e[e.Search=6]="Search",e[e.ColumnChooser=7]="ColumnChooser",e[e.PdfExport=8]="PdfExport",e[e.ExcelExport=9]="ExcelExport",e[e.CsvExport=10]="CsvExport",e[e.WordExport=11]="WordExport"}(e.ToolbarItem||(e.ToolbarItem={})),function(e){e[e.isEdit=0]="isEdit",e[e.isAdd=1]="isAdd",e[e.isSort=2]="isSort",e[e.isFilter=3]="isFilter"}(e.ResponsiveDialogAction||(e.ResponsiveDialogAction={})),function(e){e[e.isInitial=0]="isInitial",e[e.isSearch=1]="isSearch"}(e.ResponsiveToolbarAction||(e.ResponsiveToolbarAction={}));var qo,Ho,Uo=function(){function e(e,t){this.dataState={isPending:!1,resolver:null,group:[]},this.foreignKeyDataState={isPending:!1,resolver:null},this.parent=e,this.serviceLocator=t,this.initDataManager(),this.parent.isDestroyed||"foreignKey"===this.getModuleName()||(this.parent.on(Zi,this.addRows,this),this.parent.on(rn,this.reorderRows,this),this.parent.on($i,this.removeRows,this),this.parent.on(ir,this.initDataManager,this),this.parent.on(Ki,this.destroy,this),this.parent.on(dr,this.crudActions,this),this.parent.on(mr,this.getData,this),this.parent.on(ar,this.refreshFilteredCols,this),this.parent.on(pn,this.refreshFilteredCols,this))}return e.prototype.reorderRows=function(e){this.dataManager.dataSource.json.splice(e.toIndex,0,this.dataManager.dataSource.json.splice(e.fromIndex,1)[0])},e.prototype.getModuleName=function(){return"data"},e.prototype.initDataManager=function(){var e=this.parent;this.dataManager=e.dataSource instanceof i.DataManager?e.dataSource:t.isNullOrUndefined(e.dataSource)?new i.DataManager:new i.DataManager(e.dataSource),!e.isAngular||e.query instanceof i.Query?(this.isQueryInvokedFromData=!0,e.query=e.query instanceof i.Query?e.query:new i.Query):e.setProperties({query:new i.Query},!0)},e.prototype.generateQuery=function(e){var t=this.parent.getQuery().clone();if("ExcludeHidden"===this.parent.columnQueryMode)t.select(this.parent.getColumns().filter(function(e){return!(!0!==e.isPrimaryKey&&!1===e.visible||void 0===e.field)}).map(function(e){return e.field}));else if("Schema"===this.parent.columnQueryMode){for(var i=[],r=this.parent.columns,n=0;n<r.length;n++)i.push(r[n].field);t.select(i)}return this.filterQuery(t),this.searchQuery(t),this.aggregateQuery(t),this.sortQuery(t),ae(this.parent)?this.virtualGroupPageQuery(t):this.pageQuery(t,e),this.groupQuery(t),t},e.prototype.aggregateQuery=function(e){for(var t=this.parent.aggregates,i=0;i<t.length;i++)for(var r=t[i],n=0;n<r.columns.length;n++)for(var o=r.columns[n],s=o.type instanceof Array?o.type:[o.type],l=0;l<s.length;l++)e.aggregate(s[l].toLowerCase(),o.field);return e},e.prototype.virtualGroupPageQuery=function(e){if(e.queries.length)for(var t=0;t<e.queries.length;t++)"onPage"===e.queries[t].fn&&e.queries.splice(t,1);return e},e.prototype.pageQuery=function(e,i){var r=this.parent,n={query:e,skipPage:!1};if(r.notify(Ro,n),n.skipPage)return e;if((r.allowPaging||r.enableVirtualization||r.enableInfiniteScrolling)&&!0!==i){if(r.pageSettings.currentPage=Math.max(1,r.pageSettings.currentPage),r.pageSettings.pageCount<=0&&(r.pageSettings.pageCount=8),r.pageSettings.pageSize<=0&&(r.pageSettings.pageSize=12),e.queries.length)for(var o=0;o<e.queries.length;o++)"onPage"===e.queries[o].fn&&e.queries.splice(o,1);!t.isNullOrUndefined(r.infiniteScrollModule)&&r.enableInfiniteScrolling?this.parent.notify(kn,e):e.page(r.pageSettings.currentPage,r.allowPaging&&r.pagerModule&&r.pagerModule.pagerObj.isAllPage&&!this.dataManager.dataSource.offline?null:r.pageSettings.pageSize)}return e},e.prototype.groupQuery=function(e){var t=this.parent;if(t.allowGrouping&&t.groupSettings.columns.length){this.parent.groupSettings.enableLazyLoading&&e.lazyLoad.push({key:"isLazyLoad",value:this.parent.groupSettings.enableLazyLoading});for(var i=t.groupSettings.columns,r=0,n=i.length;r<n;r++){var o=this.getColumnByField(i[r]);o||this.parent.log("initial_action",{moduleName:"group",columnName:i[r]});var s=o.enableGroupByFormat,l=o.format;s?e.group(i[r],this.formatGroupColumn.bind(this),l):e.group(i[r],null)}}return e},e.prototype.sortQuery=function(e){var t=this.parent;if((t.allowSorting||t.allowGrouping)&&t.sortSettings.columns.length){for(var i=t.sortSettings.columns,r=[],n=i.length-1;n>-1;n--){if(!(l=this.getColumnByField(i[n].field)))return this.parent.log("initial_action",{moduleName:"sort",columnName:i[n].field}),e;l.setSortDirection(i[n].direction);var o=i[n].direction;l.sortComparer&&(this.parent.log("grid_sort_comparer"),o=this.isRemote()?i[n].direction:l.sortComparer.bind(l)),-1===t.groupSettings.columns.indexOf(i[n].field)?l.isForeignColumn()||l.sortComparer?e.sortByForeignKey(l.field,o,void 0,i[n].direction.toLowerCase()):e.sortBy(l.field,o):r.push({direction:o,field:l.field})}n=0;for(var s=r.length;n<s;n++)if("string"==typeof r[n].direction)e.sortBy(r[n].field,r[n].direction);else{var l=this.getColumnByField(r[n].field);e.sortByForeignKey(r[n].field,r[n].direction,void 0,l.getSortDirection().toLowerCase())}}return e},e.prototype.searchQuery=function(e,t,r){var n=this.parent.searchSettings,o=n.fields.length?n.fields:this.getSearchColumnFieldNames(),s=[],l=!1;if(this.parent.searchSettings.key.length){l=this.parent.getForeignKeyColumns().some(function(e){return o.indexOf(e.field)>-1});var a=r?t.dataSource.adaptor:this.dataManager.adaptor;if(l||a.getModuleName&&"ODataV4Adaptor"===a.getModuleName()){o=r?[t.foreignKeyValue]:o;for(var h=0;h<o.length;h++){var d=r?t:this.getColumnByField(o[h]);d.isForeignColumn()&&!r?s=this.fGeneratePredicate(d,s):s.push(new i.Predicate(o[h],n.operator,n.key,n.ignoreCase,n.ignoreAccent))}var p=i.Predicate.or(s);p.key=n.key,e.where(p)}else e.search(n.key,o,n.operator,n.ignoreCase,n.ignoreAccent)}return e},e.prototype.filterQuery=function(e,r,n){var o,s=this.parent,l=[],a=[],h=this.parent.getForeignKeyColumns();if(s.allowFiltering&&s.filterSettings.columns.length){for(var d=r||s.filterSettings.columns,p={},c=0,u=s.getColumns();c<u.length;c++){p[(v=u[c]).field]=v.filter.type?v.filter.type:s.filterSettings.type}for(var g=[],f=[],m=0,y=d;m<y.length;m++){var v=y[m],C=s.getColumnByField(v.field);t.isNullOrUndefined(v.type)&&C&&("date"===C.type||"datetime"===C.type)&&(v.type=s.getColumnByField(v.field).type),v.isForeignKey?g.push(v):f.push(v)}if(f.length){for(var w=0,b=f.length;w<b;w++)f[w].uid=f[w].uid||this.parent.grabColumnByFieldFromAllCols(f[w].field).uid;for(var S=ia.getPredicate(f),R=0,x=Object.keys(S);R<x.length;R++){var F=x[R];l.push(S[F])}}if(g.length)for(var E=0,I=g;E<I.length;E++){(v=I[E]).uid=v.uid||this.parent.grabColumnByFieldFromAllCols(v.field).uid;var T=this.parent.grabColumnByUidFromAllCols(v.uid);if(T||this.parent.log("initial_action",{moduleName:"filter",columnName:v.field}),T.isForeignColumn()&&oe(v.field,h)&&!n)a.push(v),T.columnData.length||(o=!0),l=this.fGeneratePredicate(T,l);else{S=ia.getPredicate(d);for(var z=0,D=Object.keys(S);z<D.length;z++){F=D[z];l.push(S[F])}}}l.length&&!o?e.where(i.Predicate.and(l)):this.parent.notify(qr,{})}return e},e.prototype.fGeneratePredicate=function(e,t){var i={};return e&&(this.parent.notify(Lr,{predicate:i,column:e}),i.predicate.predicates.length&&t.push(i.predicate)),t},e.prototype.getData=function(e,i){var r=this;void 0===e&&(e={requestType:""});var n=this.getKey(e.foreignKeyData&&Object.keys(e.foreignKeyData).length?e.foreignKeyData:this.parent.getPrimaryKeyFieldNames());if(this.parent.log("datasource_syntax_mismatch",{dataState:this.parent}),this.parent.dataSource&&"result"in this.parent.dataSource){return this.eventPromise(e,i,n).promise}var o=void 0;switch(e.requestType){case"delete":i=i||this.generateQuery();if(1===Object.keys(e.data).length)o=this.dataManager.remove(n,e.data[0],i.fromTable,i);else{var s={addedRecords:[],deletedRecords:[],changedRecords:[]};s.deletedRecords=e.data,o=this.dataManager.saveChanges(s,n,i.fromTable,i.requiresCount())}break;case"save":i=i||this.generateQuery(),e.index=t.isNullOrUndefined(e.index)?0:e.index,o=this.dataManager.insert(e.data,i.fromTable,i,e.index)}return e.promise=o,!o||Array.isArray(o)||o.hasOwnProperty("deletedRecords")?this.insert(i,e):o.then(function(){return r.insert(i,e)})},e.prototype.insert=function(e,t){return"save"===t.requestType&&this.parent.notify(Qr,t),this.executeQuery(e)},e.prototype.executeQuery=function(e){var t=this;if(this.dataManager.ready){var r=new i.Deferred;return this.dataManager.ready.then(function(){t.dataManager.executeQuery(e).then(function(e){r.resolve(e)})}).catch(function(e){r.reject(e)}),r.promise}return this.dataManager.executeQuery(e)},e.prototype.formatGroupColumn=function(e,i){var r=this.serviceLocator,n=this.getColumnByField(i),o=e;n.type||(n.type=o.getDay?o.getHours()>0||o.getMinutes()>0||o.getSeconds()>0||o.getMilliseconds()>0?"datetime":"date":typeof e),t.isNullOrUndefined(n.getFormatter())&&Q(r,n);return Ct.prototype.toView(e,n.getFormatter())},e.prototype.crudActions=function(e){var t=this.generateQuery(),i=null,r=this.getKey(e.foreignKeyData&&Object.keys(e.foreignKeyData).length?e.foreignKeyData:this.parent.getPrimaryKeyFieldNames());switch(this.parent.dataSource&&"result"in this.parent.dataSource&&this.eventPromise(e,t,r),e.requestType){case"save":i=this.dataManager.update(r,e.data,t.fromTable,t,e.previousData)}e.promise=i||e.promise,this.parent.notify(fr,e)},e.prototype.saveChanges=function(e,t,r,n){if(void 0===n&&(n=this.generateQuery()),n.requiresCount(),"result"in this.parent.dataSource){var o=new i.Deferred,s={requestType:"batchsave",changes:e,key:t,query:n,endEdit:o.resolve};return this.setState({isPending:!0,resolver:o.resolve}),this.parent.trigger(Vr,s),o.promise}return this.dataManager.saveChanges(e,t,n.fromTable,n,r)},e.prototype.getKey=function(e){if(e&&e.length)return e[0]},e.prototype.isRemote=function(){return!0!==this.dataManager.dataSource.offline&&void 0!==this.dataManager.dataSource.url&&""!==this.dataManager.dataSource.url},e.prototype.addRows=function(e){for(var t=e.records.length;t>0;t--)this.dataManager.dataSource.json.splice(e.toIndex,0,e.records[t-1])},e.prototype.removeRows=function(e){var t=this.dataManager.dataSource.json;this.dataManager.dataSource.json=t.filter(function(t){return-1===e.records.indexOf(t)})},e.prototype.getColumnByField=function(e){var t;return this.parent.columnModel.some(function(i){return t=i,i.field===e})&&t},e.prototype.destroy=function(){this.parent.isDestroyed||(this.parent.off(Zi,this.addRows),this.parent.off($i,this.removeRows),this.parent.off(ir,this.initDataManager),this.parent.off(Ki,this.destroy),this.parent.off(dr,this.crudActions),this.parent.off(mr,this.getData),this.parent.off(ar,this.refreshFilteredCols),this.parent.off(pn,this.refreshFilteredCols))},e.prototype.getState=function(){return this.dataState},e.prototype.setState=function(e){return this.dataState=e},e.prototype.getForeignKeyDataState=function(){return this.foreignKeyDataState},e.prototype.setForeignKeyDataState=function(e){this.foreignKeyDataState=e},e.prototype.getStateEventArgument=function(e){var r=new i.UrlAdaptor,n=new i.DataManager({url:"",adaptor:new i.UrlAdaptor}),o=r.processQuery(n,e),s=JSON.parse(o.data);return t.extend(s,o.pvtData)},e.prototype.eventPromise=function(e,t,r){var n=this,o=e,s=this.getStateEventArgument(t),l=new i.Deferred,a=new i.Deferred;if(void 0!==e.requestType&&!1!==this.dataState.isDataChanged)if(s.action=e,"save"===e.requestType||"delete"===e.requestType){var h=e;h.key=r;h.promise=a.promise,h.state=s,this.setState({isPending:!0,resolver:a.resolve}),o.endEdit=a.resolve,o.cancelEdit=a.reject,this.parent.trigger(Vr,h),a.promise.then(function(){n.setState({isPending:!0,resolver:l.resolve,group:s.group,aggregates:s.aggregates}),"save"===h.requestType&&n.parent.notify(Qr,h),n.parent.trigger(jr,s)}).catch(function(){})}else this.setState({isPending:!0,resolver:l.resolve,group:s.group,aggregates:s.aggregates}),this.parent.trigger(jr,s);else this.setState({}),l.resolve(this.parent.dataSource);return l},e.prototype.getSearchColumnFieldNames=function(){for(var e=[],i=0,r=this.parent.getColumns();i<r.length;i++){var n=r[i];n.allowSearching&&!t.isNullOrUndefined(n.field)&&e.push(n.field)}return e},e.prototype.refreshFilteredCols=function(){this.parent.allowFiltering&&this.parent.filterSettings.columns.length&&me(this.parent,this.parent.filterSettings.columns)},e}(),jo=function(){function e(e,i){t.merge(this,e),this.parent=i}return e.prototype.clone=function(){var i=new e({});return t.merge(i,this),i.cells=this.cells.map(function(e){return e.clone()}),i},e.prototype.setRowValue=function(e){if(this.parent){var t=this.data[this.parent.getPrimaryKeyFieldNames()[0]];this.parent.setRowData(t,e)}},e.prototype.setCellValue=function(e,t){if(this.parent){if(!(this.data[e].toString()===t.toString())){var i=this.parent.getPrimaryKeyFieldNames()[0],r=this.data[i];this.parent.setCellValue(r,e,t),this.makechanges(i,this.data)}}},e.prototype.makechanges=function(e,t){if(this.parent){this.parent.getDataModule().dataManager.update(e,t)}},e}(),Vo=function(){function e(e){this.isSpanned=!1,this.isRowSpanned=!1,t.merge(this,e)}return e.prototype.clone=function(){var i=new e({});return t.merge(i,this),i},e}(),Go=function(){function i(e,t){this.serviceLocator=e,this.parent=t}return i.prototype.render=function(i,r,n,o){var s,l=this.serviceLocator.getService("cellRendererFactory").getCellRenderer(r.cells[n].cellType||e.CellType.Data),a=r.cells[n].cellSpan?r.cells[n].cellSpan:i.colSpan+n<=r.cells.length?i.colSpan:r.cells.length-n,h=i.rowSpan,d=0;if(r.index>0){var p=this.parent.groupSettings.columns.length>0&&!this.parent.getRowsObject()[r.index-1].isDataRow?this.parent.getRowsObject()[r.index].cells:this.parent.getRowsObject()[r.index-1].cells,c=r.cells[n];s=p.filter(function(e){return e.column.uid===c.column.uid})[0]}for(var u=s&&s.colSpanRange>1&&s.rowSpanRange>1?s.colSpanRange:a,g=n+1;g<n+u&&g<r.cells.length;g++)!1===r.cells[g].visible?d++:r.cells[g].isSpanned=!0;if(d>0){for(g=n+a;g<n+a+d&&g<r.cells.length;g++)r.cells[g].isSpanned=!0;n+a+d>=r.cells.length&&(a-=n+a+d-r.cells.length)}return r.cells[n].cellSpan&&(r.data[i.column.field]=r.cells[n].spanText,o=l.render(r.cells[n],r.data,{index:t.isNullOrUndefined(r.index)?"":r.index.toString()})),a>1&&t.attributes(o,{colSpan:a.toString(),"aria-colSpan":a.toString()}),h>1&&(t.attributes(o,{rowspan:h.toString(),"aria-rowspan":h.toString()}),r.cells[n].isRowSpanned=!0,r.cells[n].rowSpanRange=Number(h),a>1&&(r.cells[n].colSpanRange=Number(a))),r.index>0&&s.rowSpanRange>1&&(r.cells[n].isSpanned=!0,r.cells[n].rowSpanRange=Number(s.rowSpanRange-1),r.cells[n].colSpanRange=s.rowSpanRange>0?s.colSpanRange:1),!this.parent.enableColumnVirtualization||r.cells[n].cellSpan||this.containsKey(i.column.field,i.data[i.column.field])||this.backupMergeCells(i.column.field,i.data[i.column.field],i.colSpan),o},i.prototype.backupMergeCells=function(e,t,i){this.setMergeCells(this.generteKey(e,t),i)},i.prototype.generteKey=function(e,t){return e+"__"+t.toString()},i.prototype.splitKey=function(e){return e.split("__")},i.prototype.containsKey=function(e,t){return this.getMergeCells().hasOwnProperty(this.generteKey(e,t))},i.prototype.getMergeCells=function(){return this.parent.mergeCells},i.prototype.setMergeCells=function(e,t){this.parent.mergeCells[e]=t},i.prototype.updateVirtualCells=function(e){for(var t=this.getMergeCells(),i=0,r=Object.keys(t);i<r.length;i++){var n=r[i],o=t[n],s=this.splitKey(n),l=this.getIndexFromAllColumns(s[0]),a=this.parent.getColumnIndexesInView(),h=o-(a[0]-l);if(l<a[0]&&h>1)for(var d=0,p=e;d<p.length;d++){var c=p[d];if(c.data[s[0]].toString()===s[1].toString()){c.cells[0].cellSpan=h,c.cells[0].spanText=s[1];break}}}return e},i.prototype.getIndexFromAllColumns=function(e){return b(this.parent.getVisibleColumns(),function(t,i){if(t.field===e)return i})[0]},i}(),_o="e-rowcell",Wo="e-gridheader",Ko="e-gridcontent",Qo="e-gridfooter",Xo="e-headercontent",Yo="e-movablecontent",Jo="e-movableheader",Zo="e-frozencontent",$o="e-frozenheader",es="e-content",ts="e-table",is="e-row",rs="e-gridchkbox",ns="e-editedrow",os="e-addedrow",ss="changedRecords",ls="addedRecords",as="deletedRecords",hs="Left-Right",ds="frozen-right",ps="frozen-left",cs="aria-colindex",us="aria-rowindex",gs="tbody",fs="colgroup",ms="open",ys="change",vs="focus",Cs="created",ws="beforeOpen",bs="downArrow",Ss="upArrow",Rs="enter",xs="shiftEnter",Fs=function(){function i(e,t,i){this.isSpan=!1,this.cellType=t,this.serviceLocator=e,this.parent=i,this.element=this.parent.createElement("tr",{attrs:{role:"row"}})}return i.prototype.render=function(e,t,i,r,n){return this.refreshRow(e,t,i,r,n)},i.prototype.refresh=function(e,t,i,r,n){i&&(e.data=ue({},e.changes),this.refreshMergeCells(e));var o=this.parent.element.querySelector("[data-uid="+e.uid+"]"),s=this.refreshRow(e,t,r,n,null,i),l=[].slice.call(s.cells);o.innerHTML="";for(var a=0,h=l;a<h.length;a++){var d=h[a];o.appendChild(d)}},i.prototype.refreshRow=function(i,r,n,o,s,l){var a=t.isNullOrUndefined(s)?this.element.cloneNode():s,h={data:i.data},d={data:i.data},p=this.parent.getColumns().filter(function(e){return"checkbox"===e.type&&e.field})[0],c=!1;p&&(c=he(p.field,h.data));var u=this.parent.getSelectedRowIndexes();i.isDataRow&&(i.isSelected=u.indexOf(i.index)>-1||c),i.isDataRow&&this.parent.isCheckBoxSelection&&"Check"===this.parent.checkAllRows&&this.parent.enableVirtualization&&(i.isSelected=!0,-1===u.indexOf(i.index)&&u.push(i.index)),this.buildAttributeFromRow(a,i),t.attributes(a,t.extend({},n,{})),x(a,i.attributes);for(var g=this.serviceLocator.getService("cellRendererFactory"),f=function(r,n){var o=i.cells[r];o.isSelected=i.isSelected,o.isColumnSelected=o.column.isSelected;var s=g.getCellRenderer(i.cells[r].cellType||e.CellType.Data),h={index:t.isNullOrUndefined(i.index)?"":i.index.toString()};i.isExpand&&i.cells[r].cellType===e.CellType.DetailExpand&&(h.class=m.parent.isPrinting?"e-detailrowcollapse":"e-detailrowexpand");var p=s.render(i.cells[r],i.data,h,i.isExpand,l);if(i.cells[r].cellType!==e.CellType.Filter){if(i.cells[r].cellType===e.CellType.Data||i.cells[r].cellType===e.CellType.CommandColumn){m.parent.trigger(It,t.extend(d,{cell:p,column:o.column,colSpan:1,rowSpan:1,foreignKeyData:i.cells[r].foreignKeyData,requestType:m.parent.requestTypeAction}));var c=!1;if(i.index>0&&m.isSpan){var u=(m.parent.groupSettings.columns.length>0&&!m.parent.getRowsObject()[i.index-1].isDataRow?m.parent.getRowsObject()[i.index].cells:m.parent.getRowsObject()[i.index-1].cells).filter(function(e){return e.column.uid===i.cells[r].column.uid})[0];c=u.isRowSpanned?u.isRowSpanned:u.rowSpanRange>1}if(d.colSpan>1||i.cells[r].cellSpan>1||d.rowSpan>1||c){m.isSpan=!0;p=new Go(m.serviceLocator,m.parent).render(d,i,r,p)}}i.cells[r].isSpanned||a.appendChild(p)}},m=this,y=0,v=i.cells.length;y<v;y++)f(y);var C={row:a,rowHeight:this.parent.rowHeight};if(i.isDataRow&&(this.parent.trigger(Et,t.extend(h,C)),this.parent.childGrid||this.parent.isRowDragable()||this.parent.detailTemplate)){var w=a.querySelectorAll(".e-rowcell:not(.e-hide)")[0];w&&w.classList.add("e-detailrowvisible")}this.parent.enableVirtualization&&(h.rowHeight=this.parent.rowHeight),h.rowHeight?a.style.height=h.rowHeight+"px":this.parent.rowHeight&&(a.querySelector(".e-headercell")||a.querySelector(".e-groupcaption"))&&(a.style.height=this.parent.rowHeight+"px"),i.cssClass&&a.classList.add(i.cssClass),i.lazyLoadCssClass&&a.classList.add(i.lazyLoadCssClass);if(!(this.parent.enableColumnVirtualization&&0!==this.parent.frozenColumns)&&this.parent.aggregates.length&&this.parent.element.scrollHeight>this.parent.height)for(y=0;y<this.parent.aggregates.length;y++){if(this.parent.aggregates[y].properties.columns[0].footerTemplate){var b=[].slice.call(a.getElementsByClassName("e-summarycell"));if(b.length){var S=b[b.length-1];t.addClass([S],["e-lastsummarycell"]);var R=b[0];t.addClass([R],["e-firstsummarycell"])}}}return a},i.prototype.refreshMergeCells=function(e){for(var t=0,i=e.cells;t<i.length;t++){i[t].isSpanned=!1}return e},i.prototype.buildAttributeFromRow=function(e,i){var r={},n=us,o="data-uid",s="aria-selected",l=[];i.isDataRow&&l.push(is),i.isAltRow&&l.push("e-altrow"),t.isNullOrUndefined(i.index)||(r[n]=i.index),i.rowSpan&&(r.rowSpan=i.rowSpan),i.uid&&(r[o]=i.uid),i.isSelected&&(r[s]=!0),!1===i.visible&&l.push("e-hide"),r.class=l,x(e,r)},i}(),Es=function(){function i(e){this.parent=e}return i.prototype.generateRows=function(e,t){var i=[],r=this.parent.enableVirtualization&&t?t.startIndex:0;r=this.parent.enableInfiniteScrolling&&t?this.getInfiniteIndex(t):r;for(var n=0,o=Object.keys(e).length;n<o;n++,r++)i[n]=this.generateRow(e[n],r);return i},i.prototype.ensureColumns=function(){var t=[];if(this.parent.detailTemplate||this.parent.childGrid){var i={};this.parent.notify(wn,i),t.push(this.generateCell(i,null,e.CellType.DetailExpand))}return this.parent.isRowDragable()&&t.push(this.generateCell({},null,e.CellType.RowDragIcon)),t},i.prototype.generateRow=function(e,t,i,r,n,o,s){var l={};l.foreignKeyData={},l.uid=N("grid-row"),l.data=e,l.index=t,l.indent=r,l.tIndex=o,l.isDataRow=!0,l.parentGid=n,l.parentUid=s,this.parent.isPrinting&&("All"===this.parent.hierarchyPrintMode?l.isExpand=!0:"Expanded"===this.parent.hierarchyPrintMode&&this.parent.expandedRows&&this.parent.expandedRows[t]&&(l.isExpand=this.parent.expandedRows[t].isExpand)),l.cssClass=i,l.isAltRow=!!this.parent.enableAltRow&&t%2!=0,l.isAltRow=!!this.parent.enableAltRow&&t%2!=0,l.isSelected=this.parent.getSelectedRowIndexes().indexOf(t)>-1,this.refreshForeignKeyRow(l);var a=this.ensureColumns(),h=new jo(l,this.parent);return h.cells="Right"===this.parent.getFrozenMode()?this.generateCells(l).concat(a):a.concat(this.generateCells(l)),h},i.prototype.refreshForeignKeyRow=function(e){for(var i=this.parent.getForeignKeyColumns(),r=0;r<i.length;r++)t.setValue(i[r].field,ne(i[r],e.data),e.foreignKeyData)},i.prototype.generateCells=function(i){for(var r=this.parent.getColumns(),n=[],o=0;o<r.length;o++)n.push(this.generateCell(r[o],i.uid,t.isNullOrUndefined(r[o].commands)?void 0:e.CellType.CommandColumn,null,o,i.foreignKeyData));return n},i.prototype.generateCell=function(i,r,n,o,s,l){var a={visible:i.visible,isDataCell:!t.isNullOrUndefined(i.field||i.template),isTemplate:!t.isNullOrUndefined(i.template),rowID:r,column:i,cellType:t.isNullOrUndefined(n)?e.CellType.Data:n,colSpan:o,commands:i.commands,isForeignKey:i.isForeignColumn&&i.isForeignColumn(),foreignKeyData:i.isForeignColumn&&i.isForeignColumn()&&t.getValue(i.field,l)};return(a.isDataCell||"checkbox"===a.column.type||a.commands)&&(a.index=s),new Vo(a)},i.prototype.refreshRows=function(e){for(var t=0;t<e.length;t++)this.refreshForeignKeyRow(e[t]),e[t].cells=this.generateCells(e[t]);return e},i.prototype.getInfiniteIndex=function(e){return"infiniteScroll"===e.requestType||"delete"===e.requestType||"add"===e.action?e.startIndex:0},i}(),Is=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Ts=function(){function i(e){this.parent=e}return i.prototype.getData=function(){for(var e=this,t=[],i=this.parent.aggregates.slice(),r=0;r<i.length;r++){var n=i[r].columns.filter(function(t){return!(t.footerTemplate||t.groupFooterTemplate||t.groupCaptionTemplate)||e.columnSelector(t)});n.length&&t.push({columns:n})}return t},i.prototype.columnSelector=function(e){return void 0!==e.footerTemplate},i.prototype.getColumns=function(e,i){var r=[];if(this.parent.allowGrouping)for(var n=0;n<this.parent.groupSettings.columns.length;n++)r.push(new St({}));return!this.parent.detailTemplate&&t.isNullOrUndefined(this.parent.childGrid)||r.push(new St({})),this.parent.isRowDragable()&&!e&&r.push(new St({})),r.push.apply(r,this.parent.getColumns()),i=i&&!e?i+this.parent.getIndentCount():i,t.isNullOrUndefined(e)?r:r.slice(e,i)},i.prototype.generateRows=function(e,t,i,r,n){if(0===e.length&&(void 0===t||!t.count))return[];for(var o=this.buildSummaryData(e,t),s=[],l=this.getData(),a=0;a<l.length;a++)s.push(this.getGeneratedRow(l[a],o[a],t?t.level:void 0,i,r,t?t.parentUid:void 0,n));return s},i.prototype.getGeneratedRow=function(i,r,n,o,s,l,a){var h=[],d=this.getIndentByLevel(),p=!t.isNullOrUndefined(this.parent.childGrid),c=o?0:this.parent.getIndentCount();this.parent.isRowDragable()&&!o&&(d=["e-indentcelltop"]);for(var u=a||this.getColumns(o,s),g=0;g<u.length;g++)h.push(this.getGeneratedCell(u[g],i,g>=c?this.getCellType():g<this.parent.groupSettings.columns.length?e.CellType.Indent:e.CellType.DetailFooterIntent,d[g],p));var f=new jo({data:r,attributes:{class:"e-summaryrow"}});return f.cells=h,f.uid=N("grid-row"),f.parentUid=l,f.isAggregateRow=!0,f.visible=h.some(function(e){return e.isDataCell&&e.visible}),f},i.prototype.getGeneratedCell=function(e,i,r,n,o){var s=i.columns.filter(function(t){return t.columnName===e.field})[0],l={style:{textAlign:e.textAlign},"e-mappinguid":e.uid,index:e.index};n&&(l.class=n),t.isNullOrUndefined(n)&&o&&(l.class="e-detailindentcelltop");var a={visible:e.visible,isDataCell:!t.isNullOrUndefined(s),isTemplate:s&&!t.isNullOrUndefined(s.footerTemplate||s.groupFooterTemplate||s.groupCaptionTemplate),column:s||{},attributes:l,cellType:r};return a.column.headerText=e.headerText,new Vo(a)},i.prototype.buildSummaryData=function(e,t){for(var i=[],r=this.getData(),n={},o=0;o<r.length;o++){n={};for(var s=r[o].columns,l=0;l<s.length;l++)n=this.setTemplate(s[l],t&&t.aggregates?t:e,n);i.push(n)}return i},i.prototype.getIndentByLevel=function(){return this.parent.groupSettings.columns.map(function(){return"e-indentcelltop"})},i.prototype.setTemplate=function(e,i,r){var n=e.type,o={},s=e.getFormatter()||function(e){return e},l=i;n instanceof Array||(n=[e.type]);for(var a=0;a<n.length;a++){var h=e.field+" - "+n[a].toLowerCase(),d=e.columnName,p="Custom"!==n[a]&&l.aggregates&&h in l.aggregates?l.aggregates[h]:q(n[a],l.aggregates?l:i,e,this.parent);r[d]=r[d]||{},r[d][h]=p,r[d][n[a]]=t.isNullOrUndefined(p)?" ":s(p),l.field&&(r[d].field=l.field,r[d].key=l.key)}return o.format=e.getFormatter(),e.setTemplate(o),r},i.prototype.getCellType=function(){return e.CellType.Summary},i}(),zs=function(t){function i(){return null!==t&&t.apply(this,arguments)||this}return Is(i,t),i.prototype.columnSelector=function(e){return void 0!==e.groupFooterTemplate},i.prototype.getIndentByLevel=function(e){return void 0===e&&(e=this.parent.groupSettings.columns.length),this.parent.groupSettings.columns.map(function(t,i){return i<=e-1?"":"e-indentcelltop"})},i.prototype.getCellType=function(){return e.CellType.GroupSummary},i}(Ts),Ds=function(t){function i(){return null!==t&&t.apply(this,arguments)||this}return Is(i,t),i.prototype.columnSelector=function(e){return void 0!==e.groupCaptionTemplate},i.prototype.getData=function(){return[t.prototype.getData.call(this).reduce(function(e,t){return e.columns=e.columns.concat(t.columns),e},{columns:[]})]},i.prototype.isEmpty=function(){return 0===(this.getData()[0].columns||[]).length},i.prototype.getCellType=function(){return e.CellType.CaptionSummary},i}(Ts),Ms=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Os=function(i){function r(e){var t=i.call(this,e)||this;return t.rows=[],t.index=0,t.infiniteChildCount=0,t.renderInfiniteAgg=!0,t.parent=e,t.summaryModelGen=new zs(e),t.captionModelGen=new Ds(e),t}return Ms(r,i),r.prototype.generateRows=function(e,t){if(0===this.parent.groupSettings.columns.length)return i.prototype.generateRows.call(this,e,t);this.isInfiniteScroll="infiniteScroll"===t.requestType,this.rows=[],this.index=this.parent.enableVirtualization||this.isInfiniteScroll?t.startIndex:0;for(var r=0,n=e.length;r<n;r++)this.infiniteChildCount=0,this.renderInfiniteAgg=!0,this.getGroupedRecords(0,e[r],e.level,r,void 0,this.rows.length);return this.index=0,this.parent.isCollapseStateEnabled()&&this.ensureRowVisibility(),this.rows},r.prototype.getGroupedRecords=function(e,i,r,n,o,s,l){var a,h=r;if(t.isNullOrUndefined(i.items))if(t.isNullOrUndefined(i.GroupGuid))this.rows=this.rows.concat(this.generateDataRows(i,e,n,this.rows.length,l));else for(var d=0,p=i.length;d<p;d++)this.getGroupedRecords(e,i[d],i.level,n,e,this.rows.length,l);else{var c=void 0,u=this.generateCaptionRow(i,e,n,o,s,l);if(this.isInfiniteScroll&&(c=this.getPreCaption(e,u.data.key)),c?u.uid=c.uid:this.rows=this.rows.concat(u),i.items&&i.items.length&&this.getGroupedRecords(e+1,i.items,i.items.level,n,e+1,this.rows.length,u.uid),this.parent.aggregates.length&&this.isRenderAggregate(u)){var g=this.rows.length;(a=this.rows).push.apply(a,this.summaryModelGen.generateRows(i,{level:h,parentUid:u.uid}));for(var f=g-1;f>=0;f--)if(this.rows[f].isCaptionRow)this.rows[f].aggregatesCount=this.rows.length-g;else if(!this.rows[f].isCaptionRow&&!this.rows[f].isDataRow)break}c&&this.setInfiniteRowVisibility(c)}},r.prototype.isRenderAggregate=function(e){return this.parent.enableInfiniteScrolling?!!this.renderInfiniteAgg&&(this.getPreCaption(e.indent,e.data.key),this.renderInfiniteAgg=e.data.count===this.infiniteChildCount,this.renderInfiniteAgg):!this.parent.enableInfiniteScrolling},r.prototype.getPreCaption=function(e,t){var i,r=this.parent.getRowsObject().concat(this.rows);this.infiniteChildCount=0;for(var n=r.length;n--&&(r[n].isCaptionRow&&r[n].indent===e&&r[n].data.key===t&&(i=r[n]),!(r[n].indent===e||r[n].indent<e));)r[n].indent===e+1&&this.infiniteChildCount++;return i},r.prototype.getCaptionRowCells=function(i,r,n){var o=[],s=[],l=this.parent.getColumnByField(i),a=this.parent.getColumnIndexesInView();this.parent.enableColumnVirtualization&&(l=this.parent.columns.filter(function(e){return e.field===i})[0]);var h=this.parent.groupSettings.columns.length,d=this.parent;if(!this.parent.enableColumnVirtualization||-1!==a.indexOf(r)){for(var p=0;p<r;p++)o.push(this.generateIndentCell());o.push(this.generateCell({},null,e.CellType.Expand))}if(r=this.parent.enableColumnVirtualization?1:this.parent.getVisibleColumns().length+h+(d.detailTemplate||d.childGrid?1:0)-r+(this.parent.getVisibleColumns().length?-1:0),this.parent.aggregates.length&&!this.captionModelGen.isEmpty()){var c=this.captionModelGen.generateRows(n)[0];t.extend(n,c.data);var u=0;c.cells.some(function(e,t){return u=t,e.visible&&e.isDataCell}),s=c.cells.slice(u).filter(function(e){return e.visible}),c.visible&&s[0].column.field===this.parent.getVisibleColumns()[0].field&&(s=s.slice(1)),1===this.parent.getVisibleColumns().length&&(s=[]),r-=s.length}for(var g=this.parent.enableColumnVirtualization?this.parent.getColumns():[l],f=!0,m=0;m<g.length;m++){var y=f&&-1!==a.indexOf(r);y&&(f=!1);var v=!this.parent.enableColumnVirtualization||y?e.CellType.GroupCaption:e.CellType.GroupCaptionEmpty;r=this.parent.enableColumnVirtualization&&v===e.CellType.GroupCaption?r+h:r,d.isRowDragable()&&r++,o.push(this.generateCell(l,null,v,r))}return o.push.apply(o,s),o},r.prototype.generateCaptionRow=function(e,i,r,n,o,s){var l={},a=this.parent.getColumnByField(e.field);l.data=t.extend({},e),a&&(l.data.field=e.field),l.isDataRow=!1,l.isExpand=!this.parent.groupSettings.enableLazyLoading&&!this.parent.isCollapseStateEnabled(),l.parentGid=r,l.childGid=n,l.tIndex=o,l.isCaptionRow=!0,l.parentUid=s,l.gSummary=t.isNullOrUndefined(e.items.records)?e.items.length:e.items.records.length,l.uid=N("grid-row");var h=new jo(l);return h.indent=i,this.getForeignKeyData(h),h.cells=this.getCaptionRowCells(e.field,i,h.data),h},r.prototype.getForeignKeyData=function(e){var i=e.data,r=this.parent.getColumnByField(i.field);if(r&&r.isForeignColumn&&r.isForeignColumn()){var n=t.isNullOrUndefined(i.key)?"":r.valueAccessor(r.foreignKeyValue,ne(r,{},i.key)[0],r);t.setValue("foreignKey",n,e.data)}},r.prototype.generateDataRows=function(e,t,i,r,n){for(var o=[],s=this.parent.getColumnIndexesInView(),l=0,a=e.length;l<a;l++,r++){o[l]=this.generateRow(e[l],this.index,l?void 0:"e-firstchildrow",t,i,r,n);for(var h=0;h<t;h++)this.parent.enableColumnVirtualization&&-1===s.indexOf(t)||o[l].cells.unshift(this.generateIndentCell());this.index++}return o},r.prototype.generateIndentCell=function(){return this.generateCell({},null,e.CellType.Indent)},r.prototype.refreshRows=function(e){for(var t=this.parent.getColumnIndexesInView(),i=0;i<e.length;i++)if(e[i].isDataRow){e[i].cells=this.generateCells(e[i]);for(var r=0;r<e[i].indent;r++)this.parent.enableColumnVirtualization&&-1===t.indexOf(e[i].indent)||e[i].cells.unshift(this.generateIndentCell())}else{var n=this.generateCaptionRow(e[i].data,e[i].indent);e[i].cells=n.cells}return e},r.prototype.setInfiniteRowVisibility=function(e){if(!e.isExpand||!1===e.visible)for(var t=0,i=this.rows;t<i.length;t++){var r=i[t];r.parentUid===e.uid&&(r.visible=!1,r.isCaptionRow&&this.setInfiniteRowVisibility(r))}},r.prototype.ensureRowVisibility=function(){for(var e=0;e<this.rows.length;e++){var t=this.rows[e];if(t.isCaptionRow)for(var i=e+1;i<this.rows.length;i++){var r=this.rows[i];t.uid===r.parentUid&&(this.rows[i].visible=t.isExpand)}}},r}(Es),ks=function(){function e(e,i){var r=this;this.rows=[],this.freezeRows=[],this.movableRows=[],this.freezeRowElements=[],this.currentInfo={},this.prevCurrentView=[],this.isLoaded=!0,this.viewColIndexes=[],this.drop=function(e){r.parent.notify(Kt,{target:e.target,droppedElement:e.droppedElement}),t.remove(e.droppedElement)},this.infiniteCache={},this.isRemove=!1,this.visibleRows=[],this.visibleFrozenRows=[],this.rightFreezeRows=[],this.isAddRows=!1,this.isInfiniteFreeze=!1,this.useGroupCache=!1,this.rafCallback=function(e){var t=e;return function(){if(r.parent.isFrozenGrid()&&r.parent.enableVirtualization){var i=e.tableName;if(r.isLoaded=r.parent.getFrozenMode()===hs?"frozen-right"===i:"movable"===i,r.parent.enableColumnVirtualization&&"virtualscroll"===e.requestType&&r.isLoaded){var n=[].slice.call(r.parent.getMovableVirtualHeader().getElementsByClassName(is)),o=[].slice.call(r.parent.getFrozenVirtualHeader().getElementsByClassName(is));r.isLoaded=n.length===o.length}}if(r.ariaService.setBusy(r.getPanel().querySelector("."+es),!1),!r.parent.isDestroyed){var s=r.rows.slice(0);if(r.parent.enableInfiniteScrolling){s=r.parent.getRowsObject();var l=t.prevPage;if(r.parent.infiniteScrollSettings.enableCache&&l){var a=r.parent.infiniteScrollSettings.maxBlocks;s=[];for(var h=parseInt(r.rowElements[0].getAttribute("aria-rowindex"),10)+1,d=0,p=Math.ceil(h/r.parent.pageSettings.pageSize);d<a;d++,p++)r.infiniteCache[p]&&(s=s.concat(r.infiniteCache[p]))}}if(r.parent.isFrozenGrid()&&(s=e.isFrozen?r.freezeRows:e.renderFrozenRightContent?r.parent.getFrozenRightRowsObject():r.movableRows),r.parent.notify(xi,{rows:s,args:t}),r.isLoaded&&(r.parent.isManualRefresh=!1,r.parent.trigger(Ot,{},function(){r.parent.allowTextWrap&&r.parent.notify(zr,{case:"textwrap"})})),t){var c=(t.requestType||"").toLowerCase()+"-complete";r.parent.notify(c,t),"batchsave"===e.requestType&&(e.cancel=!1,r.parent.trigger(Dt,e))}r.isLoaded&&r.parent.hideSpinner()}}},this.parent=e,this.serviceLocator=i,this.ariaService=this.serviceLocator.getService("ariaService"),this.parent.enableDeepCompare=this.parent.getDataModule().isRemote(),this.generator=this.getModelGenerator(),this.parent.isDestroyed||(this.parent.enableColumnVirtualization||this.parent.enableVirtualization||this.parent.groupSettings.enableLazyLoading||this.parent.on(Qi,this.setVisible,this),this.parent.on(zi,this.colGroupRefresh,this),this.parent.on(Fi,this.enableAfterRender,this),this.parent.on(Dn,this.refreshContentRows,this),this.parent.on(Vi,this.beforeCellFocused,this),this.parent.on(Ki,this.droppableDestroy,this))}return e.prototype.beforeCellFocused=function(e){!e.byKey||"upArrow"!==e.keyArgs.action&&"downArrow"!==e.keyArgs.action?this.pressedKey=void 0:this.pressedKey=e.keyArgs.action},e.prototype.renderPanel=function(){var e=this.parent,t=this.parent.element.querySelector("."+Ko);if(t)return this.ariaService.setOptions(this.parent.element.querySelector("."+es),{busy:!1}),void this.setPanel(t);t=this.parent.createElement("div",{className:Ko});var i=this.parent.createElement("div",{className:es});this.ariaService.setOptions(i,{busy:!1}),t.appendChild(i),this.setPanel(t),e.element.appendChild(t)},e.prototype.renderTable=function(){var e=this.getPanel(),i=e.querySelector(".e-virtualtable"),r=e.querySelector(".e-virtualtrack");!this.parent.enableVirtualization||t.isNullOrUndefined(i)||t.isNullOrUndefined(r)||(t.remove(i),t.remove(r)),e.appendChild(this.createContentTable("_content_table")),this.setTable(e.querySelector("."+ts)),this.ariaService.setOptions(this.getTable(),{multiselectable:"Multiple"===this.parent.selectionSettings.type}),this.initializeContentDrop(),this.parent.frozenRows&&this.parent.getHeaderContent().classList.add("e-frozenhdrcont")},e.prototype.createContentTable=function(e){var i=this.getPanel().firstElementChild;this.getTable()&&t.remove(this.getTable());var r=i.querySelector("."+ts)?i.querySelector("."+ts):this.parent.createElement("table",{className:ts,attrs:{cellspacing:"0.25px",role:"grid",id:this.parent.element.id+e}});return this.setColGroup(this.parent.getHeaderTable().querySelector(fs).cloneNode(!0)),r.appendChild(this.getColGroup()),r.appendChild(this.parent.createElement(gs)),i.appendChild(r),i},e.prototype.refreshContentRows=function(e){var i=this;void 0===e&&(e={});var r=this.parent;if(0!==r.currentViewData.length){var n=this.currentMovableRows||r.currentViewData,o=this.parent.contentModule,s=r.isReact&&!t.isNullOrUndefined(r.rowTemplate),l=s?r.createElement(gs):document.createDocumentFragment();this.initialPageRecords||(this.initialPageRecords=t.extend([],n));var a,h,d,p=s?r.createElement(gs):document.createDocumentFragment(),c=r.getColumns(),u=r.getFrozenColumns(),g=this.parent.isFrozenGrid(),m=new Fs(this.serviceLocator,null,this.parent),y=this.parent.enableInfiniteScrolling&&"infiniteScroll"===e.requestType;r.notify(ko,{}),this.rowElements=[],this.rows=[];var v,C,w=this.getPanel().querySelector("."+Zo),b=this.getPanel().querySelector("."+Yo),S=this.getPanel().querySelector("."+es);ae(r)&&["sorting","filtering","searching","grouping","ungrouping","reorder"].some(function(t){return e.requestType===t})&&this.emptyVcRows();var R;this.parent.enableVirtualization&&this.parent.isFrozenGrid()?(this.parent.enableColumnVirtualization&&"virtualscroll"===e.requestType&&"X"===e.virtualInfo.sentinelInfo.axis&&(R=this.parent.contentModule.generateRows(n,e),e.renderMovableContent=!0),R=this.parent.contentModule.generateRows(n,e)):(R=this.checkCache(R,e),this.isAddRows||this.useGroupCache||(R=this.generator.generateRows(n,e))),this.setGroupCache(R,e),this.parent.notify(Pn,{isInfiniteScroll:y,modelData:R,args:e});var x=R[0].cells[0].index;g&&(C=o.setTbody(R,e),v=o.getTbody(C));var F=this.parent.getFrozenMode()===hs&&C===ds;if("infiniteScroll"!==e.requestType&&this.parent.registeredTemplate&&this.parent.registeredTemplate.template&&!e.isFrozen&&!F){for(var E=[],I=0;I<this.parent.registeredTemplate.template.length;I++)for(var T=0;T<this.parent.registeredTemplate.template[I].rootNodes.length;T++)t.isNullOrUndefined(this.parent.registeredTemplate.template[I].rootNodes[T].parentNode)&&E.push(this.parent.registeredTemplate.template[I]);this.parent.destroyTemplate(["template"],E)}if((this.parent.isReact||this.parent.isVue)&&"infiniteScroll"!==e.requestType&&!e.isFrozen){var z=[this.parent.isVue?"template":"columnTemplate","rowTemplate","detailTemplate","captionTemplate","commandsTemplate","groupFooterTemplate","groupCaptionTemplate"];Je(this.parent,z)}if(this.parent.enableColumnVirtualization){new Go(this.serviceLocator,this.parent).updateVirtualCells(R)}g||(this.tbody=this.getTable().querySelector(gs));var D=0,M=!0;if(ae(r)&&r.vcRows.length){var O=t.isNullOrUndefined(e.virtualInfo.offsets)?t.isNullOrUndefined(e.scrollTop)?0:e.scrollTop.top:e.virtualInfo.offsets.top;if(0!==O){for(var k=r.vGroupOffsets,A=r.pageSettings.pageSize/2,B=Object.keys(k).map(function(e){return k[e]}),N=0;N<B.length;N++)if(O<B[N]){if(t.isNullOrUndefined(e.virtualInfo)||"up"!==e.virtualInfo.direction){D=N*A,(this.parent.contentModule.isEndBlock(N)||this.parent.contentModule.isEndBlock(N+1))&&(e.virtualInfo.blockIndexes=[N,N+1]);break}D=N>0?(N-1)*A:N*A;break}Math.round(O+this.contentPanel.firstElementChild.offsetHeight)>=this.contentPanel.firstElementChild.scrollHeight&&!e.rowObject&&(M=!1)}}var L=r.frozenRows&&!r.isFrozenGrid()&&this.parent.enableVirtualization&&"reorder"===e.requestType;if(r.frozenRows&&"virtualscroll"===e.requestType&&"X"===e.virtualInfo.sentinelInfo.axis||L){var q=e.virtualInfo.blockIndexes,H=e.virtualInfo.page;e.virtualInfo.blockIndexes=[1,2],L&&(e.virtualInfo.page=1);var U=L?this.initialPageRecords:n,j=this.vgenerator.generateRows(U,e);j.splice(this.parent.frozenRows);for(I=0;I<this.parent.frozenRows;I++)j[I].cells.splice(0,this.parent.getFrozenColumns()),a=m.render(j[I],c),p.appendChild(a);e.virtualInfo.blockIndexes=q,e.virtualInfo.page=H,L&&1===e.virtualInfo.page&&R.splice(0,this.parent.frozenRows)}this.virtualFrozenHdrRefresh(p,R,m,e,n,c);I=D;for(var V=R.length;I<V;I++)if(this.rows.push(R[I]),!this.parent.groupSettings.enableLazyLoading||this.useGroupCache||!this.parent.groupSettings.columns.length||(this.setRowsInLazyGroup(R[I],I),!t.isNullOrUndefined(R[I].indent))){if(this.setInfiniteVisibleRows(e,R[I],C),ae(r)&&e.virtualInfo&&e.virtualInfo.blockIndexes&&this.rowElements.length>=e.virtualInfo.blockIndexes.length*this.parent.contentModule.getBlockSize()&&M){this.parent.currentViewData.records=this.rows.map(function(e){return e.data});break}if(r.rowTemplate){var G=r.element.id+"rowTemplate",_=void 0;if(r.isReact){var W=r.frozenRows&&I<r.frozenRows,K=t.extend({index:I},n[I]);r.getRowTemplate()(K,r,"rowTemplate",G,null,null,W?p:l),r.renderTemplates()}else _=r.getRowTemplate()(t.extend({index:I},n[I]),r,"rowTemplate",G);if(r.isReact||"TBODY"!==_[0].tagName)r.frozenRows&&I<r.frozenRows?a=r.isReact?p.lastElementChild:P(p,_):(r.isReact||(a=P(l,_)),d=r.isReact?l.lastElementChild:a.lastElementChild);else{for(T=0;T<_.length;T++){var Q="tr"===_[T].nodeName.toLowerCase();(Q||_[T].querySelectorAll&&_[T].querySelectorAll("tr").length)&&(a=Q?_[T]:_[T].querySelector("tr"))}r.frozenRows&&I<r.frozenRows?p.appendChild(a):l.appendChild(a)}var X={data:R[I].data,row:d||a};this.parent.trigger(Et,X)}else{a=m.render(R[I],c);var Y=this.ensureFrozenHeaderRender(e);r.frozenRows&&I<r.frozenRows&&!y&&"virtualscroll"!==e.requestType&&Y&&this.ensureVirtualFrozenHeaderRender(e)?p.appendChild(a):l.appendChild(a),R[I].isExpand&&r.notify(Zr,a.cells[r.groupSettings.columns.length])}R[I].isDataRow&&this.rowElements.push(a),this.ariaService.setOptions(this.getTable(),{colcount:r.getColumns().length.toString()})}if(g&&o.splitRows(C),r.frozenRows&&"virtualscroll"!==e.requestType&&!y&&this.ensureVirtualFrozenHeaderRender(e)||"virtualscroll"===e.requestType&&e.virtualInfo.sentinelInfo&&"X"===e.virtualInfo.sentinelInfo.axis)if(h=g?o.getFrozenHeader(C):r.getHeaderTable().querySelector(gs),s){var J=h.parentElement;t.remove(h),J.appendChild(p)}else h.innerHTML="",h.appendChild(p);!r.enableVirtualization&&r.frozenRows&&0===x&&S.offsetHeight===Number(r.height)&&(S.style.height=S.offsetHeight-h.offsetHeight+"px"),e.rows=this.rows.slice(0),g&&o.setIsFrozen(e,C),this.index=x,f(function(){i.parent.notify(_r,e);var n=i.parent.enableVirtualization&&i.parent.isFrozenGrid();if(i.parent.enableVirtualization||y||(i.parent.isFrozenGrid()?(t.remove(o.getTbody(C)),v=i.parent.createElement(gs)):(i.tbody.innerHTML="",t.remove(i.tbody),i.tbody=i.parent.createElement(gs))),!g||n||i.parent.enableInfiniteScrolling)if(r.rowTemplate&&t.updateBlazorTemplate(r.element.id+"rowTemplate","RowTemplate",r),n){if(e.renderFrozenRightContent){var s=r.getContent().querySelector(".e-frozen-right-content").querySelector(gs);i.appendContent(s,l,e)}else e.renderMovableContent?(i.appendContent(b.querySelector(gs),l,e),e.renderMovableContent=!1):i.appendContent(w.querySelector(gs),l,e);i.parent.getFrozenColumns()||o.renderNextFrozentPart(e,C)}else!t.isNullOrUndefined(i.parent.infiniteScrollModule)&&i.parent.enableInfiniteScrolling?(i.isAddRows=!1,i.parent.notify(Nn,{args:e}),i.parent.notify(Bn,{tbody:v||i.tbody,frag:l,args:e,rows:i.rows,rowElements:i.rowElements,visibleRows:i.visibleRows,tableName:C}),!u&&g&&((r.getFrozenMode()===hs||C!==ps&&C!==ds)&&(r.getFrozenMode()!==hs||C!==ps&&"movable"!==C)||i.refreshContentRows(t.extend({},e)))):(i.useGroupCache=!1,i.appendContent(i.tbody,l,e));else i.appendContent(v,l,e,C);u&&o.renderNextFrozentPart(e,C),l=null},this.rafCallback(t.extend({},e)))}},e.prototype.emptyVcRows=function(){this.parent.vcRows=[],this.parent.vRows=[]},e.prototype.appendContent=function(e,i,r,n){this.parent.isReact&&!t.isNullOrUndefined(this.parent.rowTemplate)?this.getTable().appendChild(i):(e.appendChild(i),this.getTable().appendChild(e))},e.prototype.setRowsInLazyGroup=function(e,t){this.parent.groupSettings.enableLazyLoading&&!this.useGroupCache&&this.parent.groupSettings.columns.length&&this.parent.contentModule.maintainRows(e,t)},e.prototype.setGroupCache=function(e,t){!this.useGroupCache&&this.parent.groupSettings.enableLazyLoading&&this.parent.notify(Wn,{args:t,data:e})},e.prototype.ensureFrozenHeaderRender=function(e){return!(this.parent.enableVirtualization&&("reorder"===e.requestType||"refresh"===e.requestType)||this.parent.infiniteScrollSettings.enableCache&&this.parent.frozenRows&&"delete"===this.parent.infiniteScrollModule.requestType&&1!==this.parent.pageSettings.currentPage)},e.prototype.ensureVirtualFrozenHeaderRender=function(e){return!(this.parent.enableVirtualization&&"delete"===e.requestType)},e.prototype.checkCache=function(e,i){if(this.parent.infiniteScrollSettings.enableCache&&"infiniteScroll"===i.requestType){var r=i.isFrozen?1:0,n=this.parent.isFrozenGrid();if(this.isAddRows=!t.isNullOrUndefined(this.infiniteCache[this.parent.pageSettings.currentPage]),n&&!t.isNullOrUndefined(this.infiniteCache[this.parent.pageSettings.currentPage])&&(this.isAddRows=0!==this.infiniteCache[this.parent.pageSettings.currentPage][r].length),this.isAddRows){var o=n?this.infiniteCache[this.parent.pageSettings.currentPage][r]:this.infiniteCache[this.parent.pageSettings.currentPage];e=1===this.parent.pageSettings.currentPage?o.slice(this.parent.frozenRows):o}return e}return this.parent.groupSettings.enableLazyLoading&&this.parent.groupSettings.columns.length&&("paging"===i.requestType||"columnstate"===i.requestType||"reorder"===i.requestType)&&this.parent.contentModule.getGroupCache()[this.parent.pageSettings.currentPage]?(this.useGroupCache=!0,this.parent.contentModule.initialGroupRows("reorder"===i.requestType)):null},e.prototype.setInfiniteVisibleRows=function(e,t,i){var r=this.parent.isFrozenGrid();this.parent.enableInfiniteScrolling&&!this.parent.infiniteScrollSettings.enableCache&&(r?i===ps||"Right"===this.parent.getFrozenMode()&&i===ds?this.visibleFrozenRows.push(t):"movable"===i?this.visibleRows.push(t):this.rightFreezeRows.push(t):this.parent.infiniteScrollSettings.enableCache||this.visibleRows.push(t))},e.prototype.getCurrentBlockInfiniteRecords=function(e){var t=[];if(this.parent.infiniteScrollSettings.enableCache){if(!Object.keys(this.infiniteCache).length)return[];var i=this.parent.isFrozenGrid(),r=this.parent.getRows(),n=parseInt(r[this.parent.frozenRows].getAttribute(us),10),o=Math.ceil((n+1)/this.parent.pageSettings.pageSize);n=parseInt(r[r.length-1].getAttribute(us),10);var s=Math.ceil(n/this.parent.pageSettings.pageSize);if(i){for(var l=e?0:1,a=o;a<=s;a++)t=t.length?t.concat(this.infiniteCache[a][l]):this.infiniteCache[a][l];this.parent.frozenRows&&this.parent.pageSettings.currentPage>1&&(t=this.infiniteCache[1][l].slice(0,this.parent.frozenRows).concat(t))}else{for(a=o;a<=s;a++)t=t.length?t.concat(this.infiniteCache[a]):this.infiniteCache[a];this.parent.frozenRows&&this.parent.pageSettings.currentPage>1&&(t=this.infiniteCache[1].slice(0,this.parent.frozenRows).concat(t))}}return t},e.prototype.getReorderedVFRows=function(e){return this.parent.contentModule.getReorderedFrozenRows(e)},e.prototype.getReorderedRows=function(e){return this.parent.contentModule.getReorderedFrozenRows(e)},e.prototype.virtualFrozenHdrRefresh=function(e,t,i,r,n,o){if(this.parent.frozenRows&&this.parent.enableVirtualization&&("reorder"===r.requestType||"refresh"===r.requestType)){var s=void 0,l=[];this.parent.isFrozenGrid()?(this.currentMovableRows=n,l=this.getReorderedVFRows(r)):l=this.getReorderedRows(r);for(var a=0;a<l.length;a++)s=i.render(l[a],o),e.appendChild(s);1===r.virtualInfo.page&&t.splice(0,this.parent.frozenRows),r.renderMovableContent&&(this.parent.currentViewData=this.currentMovableRows,this.currentMovableRows=null)}},e.prototype.getInfiniteRows=function(){var e=[],t=this.parent.isFrozenGrid();if(this.parent.enableInfiniteScrolling)if(this.parent.infiniteScrollSettings.enableCache)for(var i=Object.keys(this.infiniteCache),r=0;r<i.length;r++)e=t?e.concat(this.infiniteCache[i[r]][0]):e.concat(this.infiniteCache[i[r]]);else e=t?this.visibleFrozenRows:this.visibleRows;return e},e.prototype.getInfiniteMovableRows=function(){var e=this.getCurrentBlockInfiniteRecords();return this.parent.enableInfiniteScrolling?e.length?e:this.visibleRows:[]},e.prototype.getPanel=function(){return this.contentPanel},e.prototype.setPanel=function(e){this.contentPanel=e},e.prototype.getTable=function(){return this.contentTable},e.prototype.setTable=function(e){this.contentTable=e},e.prototype.getRows=function(){var e=this.getInfiniteRows();return e.length?e:this.parent.getFrozenColumns()?this.freezeRows:this.rows},e.prototype.getMovableRows=function(){var e=this.getInfiniteMovableRows();return e.length?e:this.movableRows},e.prototype.getRowElements=function(){return this.parent.getFrozenColumns()?this.freezeRowElements:this.rowElements},e.prototype.getMovableRowElements=function(){return this.rowElements},e.prototype.setRowElements=function(e){this.rowElements=e},e.prototype.getColGroup=function(){return this.colgroup},e.prototype.setColGroup=function(e){return t.isNullOrUndefined(e)||(e.id="content-"+e.id),this.colgroup=e},e.prototype.setVisible=function(e){var i=this.parent,r=this.parent.isFrozenGrid(),n=i.getFrozenColumns(),o=[];if(r){var s=this.freezeRows,l=this.movableRows,a=s.length,h=void 0,d=[];i.getFrozenMode()===hs&&(d=i.getFrozenRightRowsObject());for(var p=0,c=void 0;p<a;p++){h=l[p].cells.length;var u=d.length?d[p].cells.length:0;c=s[p].clone();for(var g=0;g<h;g++)c.cells.push(l[p].cells[g]);for(var f=0;f<u;f++)c.cells.push(d[p].cells[f]);o.push(c)}}else o=this.getRows();var m;o.some(function(e){return e.isDataRow&&(m=e),e.isDataRow});var y=!0;!i.groupSettings.columns.length&&m&&(y=!1);for(var v=i.getDataRows(),C=this.infiniteRowVisibility(),w=C||this.rows.filter(function(e){return!e.isDetailRow}),b=0,S=e.length;b<S;b++){var R=e[b],x=this.parent.getNormalizedColumnIndex(R.uid),F=this.parent.getColumnIndexByUid(R.uid),E=!0===R.visible?"":"none";if(-1!==x&&m&&x<m.cells.length)if(r)if("movable"!==R.getFreezeTableName())if(R.getFreezeTableName()===ds){F=x-=this.parent.getFrozenLeftColumnsCount()+this.parent.getMovableColumnsCount();var I=this.parent.getContent().querySelector(".e-frozen-right-content").querySelector(fs);t.setStyleAttribute(I.childNodes[x],{display:E}),w=i.getFrozenRightRowsObject(),v=i.getFrozenRightDataRows()}else{t.setStyleAttribute(this.getColGroup().childNodes[x],{display:E});var T=this.infiniteRowVisibility(!0);w=T||this.freezeRows,v=i.getDataRows()}else{var z=i.getContent().querySelector("."+Yo).querySelector(fs);F=x=x-n-this.parent.getFrozenLeftColumnsCount(),t.setStyleAttribute(z.childNodes[x],{display:E}),v=i.getMovableDataRows();var D=this.infiniteRowVisibility();w=D||this.movableRows}else t.setStyleAttribute(this.getColGroup().childNodes[x],{display:E});y||(this.setDisplayNone(v,F,E,w),w[0].cells[F].isTemplate&&(y=!0)),!this.parent.invokedFromMedia&&R.hideAtMedia&&this.parent.updateMediaColumns(R),this.parent.invokedFromMedia=!1}y?this.refreshContentRows({requestType:"refresh"}):this.parent.getFrozenColumns()?(this.parent.notify(an,{rows:this.freezeRows,args:{isFrozen:!0,rows:this.freezeRows}}),this.parent.notify(an,{rows:this.movableRows,args:{isFrozen:!1,rows:this.movableRows}})):this.parent.notify(an,{rows:w,args:{}})},e.prototype.setDisplayNone=function(e,t,i,r){Ge(e,t,i,r,this.parent,this.parent.isRowDragable()),this.parent.notify(An,{visible:i,index:t,isFreeze:this.isInfiniteFreeze})},e.prototype.infiniteRowVisibility=function(e){var t;return this.parent.enableInfiniteScrolling&&(this.isInfiniteFreeze=e,t=this.parent.infiniteScrollSettings.enableCache?e?this.getCurrentBlockInfiniteRecords(!0):this.getCurrentBlockInfiniteRecords():e?this.visibleFrozenRows:this.visibleRows),t},e.prototype.colGroupRefresh=function(){if(this.getColGroup()){var e=void 0;e=this.parent.enableColumnVirtualization&&this.parent.getFrozenColumns()&&this.parent.contentModule.isXaxis()?this.parent.getMovableVirtualHeader().querySelector(fs).cloneNode(!0):this.getHeaderColGroup(),this.getTable().replaceChild(e,this.getColGroup()),this.setColGroup(e)}},e.prototype.getHeaderColGroup=function(){return this.parent.element.querySelector("."+Wo).querySelector(fs).cloneNode(!0)},e.prototype.initializeContentDrop=function(){var e=this.parent;this.droppable=new t.Droppable(e.element,{accept:".e-dragclone",drop:this.drop})},e.prototype.droppableDestroy=function(){this.droppable&&!this.droppable.isDestroyed&&this.droppable.destroy()},e.prototype.canSkip=function(e,i,r){return t.isNullOrUndefined(i)||t.isNullOrUndefined(e.visible)||i.cells[r].visible===e.visible},e.prototype.getModelGenerator=function(){return this.generator=this.parent.allowGrouping?new Os(this.parent):new Es(this.parent)},e.prototype.renderEmpty=function(e){this.getTable().appendChild(e),this.parent.frozenRows&&(this.parent.getHeaderContent().querySelector(gs).innerHTML="")},e.prototype.setSelection=function(e,t,i){this.parent.notify(eo,{uid:e,set:t,clearAll:i});var r=this.parent.isFrozenGrid();if(!r||!this.parent.enableVirtualization){if(r)for(var n=this.getMovableRows().filter(function(t){return i||e===t.uid}),o=0;o<n.length;o++)n[o].isSelected=t;for(var s=this.getRows().filter(function(t){return i||e===t.uid}),l=0;l<s.length;l++){s[l].isSelected=t;for(var a=s[l].cells,h=0;h<a.length;h++)a[h].isSelected=t}}},e.prototype.getRowByIndex=function(e){return e=this.getInfiniteRowIndex(e),this.parent.getDataRows()[e]},e.prototype.getInfiniteRowIndex=function(e){if(this.parent.infiniteScrollSettings.enableCache){var t=this.parent.frozenRows,i=t>e?0:t,r=parseInt(this.parent.getRows()[i].getAttribute(us),10);e=t>e?e:e-r+t}return e},e.prototype.getVirtualRowIndex=function(e){return e},e.prototype.getMovableRowByIndex=function(e){return e=this.getInfiniteRowIndex(e),this.parent.getMovableDataRows()[e]},e.prototype.enableAfterRender=function(e){"group"===e.module&&e.enable&&(this.generator=this.getModelGenerator())},e.prototype.setRowObjects=function(e){this.rows=e},e.prototype.immutableModeRendering=function(e){var i=this;void 0===e&&(e={});var r=this.parent;r.hideSpinner();var n=r.getPrimaryKeyFieldNames()[0],o={},s={},l=[],a={},h=r.getRowsObject().slice(),d=this.getBatchEditedRecords(n,h),p={},c=0!==Object.keys(d).length;if(r.getContent().querySelector(".e-emptyrow")||"reorder"===e.requestType||this.parent.groupSettings.columns.length)this.refreshContentRows(e);else{if(0===r.currentViewData.length)return;var u={},g=r.createElement(gs),f=r.currentViewData,m=[].slice.call(this.getTable().querySelector(gs).children);if(this.prevCurrentView.length){var y=this.prevCurrentView.length,v=f.length;if(y===v)for(var C=0;C<v;C++)"Batch"===this.parent.editSettings.mode&&m[C].classList.contains("e-insertedrow")?(m.splice(C,1),--C):(s[f[C][n]]=o[this.prevCurrentView[C][n]]=C,p[C]=f[C][n],u[h[C].uid]=m[C],a[C]=this.prevCurrentView[C][n]);else{for(C=0;C<v;C++)s[f[C][n]]=C,p[C]=f[C][n];for(C=0;C<y;C++)"Batch"===this.parent.editSettings.mode&&m[C].classList.contains("e-insertedrow")?(m.splice(C,1),--C):(u[h[C].uid]=m[C],o[this.prevCurrentView[C][n]]=C,a[C]=this.prevCurrentView[C][n])}}for(C=0;C<f.length;C++){var w=o[f[C][n]];if(t.isNullOrUndefined(w)){var b=new Fs(this.serviceLocator,null,r),S=this.generator.generateRows([f[C]]);l.push(S[0]);x=b.render(S[0],r.getColumns());g.appendChild(x),this.refreshImmutableContent(C,x,l[C])}else{var R=!1;this.parent.enableDeepCompare&&(R=this.objectEqualityChecker(this.prevCurrentView[w],f[C]));var x=u[h[w].uid];if(l.push(h[w]),this.rowElements[w]&&this.rowElements[w].getAttribute("data-uid")===l[C].uid&&(c&&t.isNullOrUndefined(d[p[C]])||!c&&(R||this.prevCurrentView[w]===f[C]))){w!==C&&this.refreshImmutableContent(C,x,l[C]),g.appendChild(x);continue}(c&&!t.isNullOrUndefined(d[p[C]])||!this.parent.enableDeepCompare&&f[C]!==this.prevCurrentView[w]||this.parent.enableDeepCompare&&!R)&&h[w].setRowValue(f[C]),g.appendChild(x),this.refreshImmutableContent(C,x,l[C])}}if(this.rows=l,this.rowElements=[].slice.call(g.children),t.remove(this.getTable().querySelector(gs)),this.getTable().appendChild(g),this.parent.trigger(Ot,{},function(){i.parent.allowTextWrap&&i.parent.notify(zr,{case:"textwrap"})}),e){var F=(e.requestType||"").toLowerCase()+"-complete";this.parent.notify(F,e)}}},e.prototype.objectEqualityChecker=function(e,t){for(var i=Object.keys(e),r=!0,n=0;n<i.length;n++)if(e[i[n]]!==t[i[n]]){if(!(e[i[n]]instanceof Date&&t[i[n]]instanceof Date)||e[i[n]].getTime()!==t[i[n]].getTime()){r=!1;break}}return r},e.prototype.getBatchEditedRecords=function(e,t){var i={},r=this.parent.getBatchChanges(),n=[],o=[];Object.keys(r).length&&(n=r.changedRecords,o=r.addedRecords);var s={cancel:!1};this.parent.notify(io,{rows:t,args:s}),o.length&&("Bottom"===this.parent.editSettings.newRowPosition?t.splice(t.length-1,o.length):s.cancel||t.splice(0,o.length));for(var l=0;l<n.length;l++)i[n[l][e]]=l;return i},e.prototype.refreshImmutableContent=function(e,t,i){i.isAltRow=!!this.parent.enableAltRow&&e%2!=0,i.isAltRow?t.classList.add("e-altrow"):t.classList.remove("e-altrow"),i.index=e,i.edit=void 0,i.isDirty=!1,t.setAttribute(us,e.toString()),this.updateCellIndex(t,e)},e.prototype.updateCellIndex=function(e,t){for(var i=0;i<e.cells.length;i++)e.cells[i].setAttribute("index",t.toString())},e}(),As=function(){function i(e,i){var r=this;this.frzIdx=0,this.notfrzIdx=0,this.isFirstCol=!1,this.isReplaceDragEle=!0,this.helper=function(e){var i=r.parent,n=r.draggable.currentStateTarget,o=D(n,"e-headercell");if(!i.allowReordering&&!i.allowGrouping||!t.isNullOrUndefined(o)&&o.getElementsByClassName("e-checkselectall").length>0)return!1;var s=r.parent.createElement("div",{className:"e-cloneproperties e-dragclone e-headerclone"}),l=n.classList.contains("e-headercell")?n:o;if(!l||!i.allowReordering&&l.classList.contains("e-stackedheadercell"))return!1;var a,h=l.offsetHeight,d=l.querySelector(".e-headercelldiv")||l.querySelector(".e-stackedheadercelldiv");if(d){if(a=l.querySelector(".e-stackedheadercelldiv")?i.getStackedHeaderColumnByHeaderText(d.innerText.trim(),i.columns):i.getColumnByUid(d.getAttribute("e-mappinguid")),r.column=a,r.column.lockColumn)return!1;s.setAttribute("e-mappinguid",r.column.uid)}if(a&&!t.isNullOrUndefined(a.headerTemplate))if(t.isNullOrUndefined(a.headerTemplate))s.innerHTML=a.headerTemplate;else{var p=i.getColumnIndexByField(a.field);P(s,a.getHeaderTemplate()(t.extend({index:p},a),i,"headerTemplate"))}else s.innerHTML=d?a.headerText:l.firstElementChild.innerHTML;return s.style.width=l.offsetWidth+"px",s.style.height=l.offsetHeight+"px",s.style.lineHeight=(h-6).toString()+"px",i.element.appendChild(s),s},this.dragStart=function(e){var t=r.parent;t.element.querySelector(".e-gridpopup").style.display="none",t.notify(_t,{target:r.draggable.currentStateTarget,column:r.column,event:e.event})},this.drag=function(e){var i=r.parent,n=e.target;if(n){var o=t.closest(n,".e-grid"),s=r.parent.element.querySelector(".e-cloneproperties");if(!(o&&o.getAttribute("id")===i.element.getAttribute("id")||(t.classList(s,["e-notallowedcur"],["e-defaultcur"]),i.allowReordering&&(i.element.querySelector(".e-reorderuparrow").style.display="none",i.element.querySelector(".e-reorderdownarrow").style.display="none"),i.groupSettings.allowReordering)))return;i.notify(Wt,{target:e.target,column:r.column,event:e.event})}},this.dragStop=function(e){var i,n=r.parent;n.element.querySelector(".e-gridpopup").style.display="none",(!D(e.target,"e-headercell")&&!D(e.target,"e-groupdroparea")||!n.allowReordering&&D(e.target,"e-headercell")||!e.helper.getAttribute("e-mappinguid")&&D(e.target,"e-groupdroparea"))&&(t.remove(e.helper),i=!0),n.notify(er,{target:e.target,event:e.event,column:r.column,cancel:i})},this.drop=function(e){var i=r.parent,n=e.droppedElement.getAttribute("e-mappinguid"),o=t.closest(e.target,".e-grid");t.remove(e.droppedElement),o&&o.getAttribute("id")!==i.element.getAttribute("id")||!i.allowReordering&&!i.allowGrouping||i.notify(tr,{target:e.target,uid:n,droppedElement:e.droppedElement})},this.parent=e,this.serviceLocator=i,this.ariaService=this.serviceLocator.getService("ariaService"),this.widthService=this.serviceLocator.getService("widthService"),this.parent.isDestroyed||(this.parent.enableColumnVirtualization||this.parent.getFrozenLeftColumnsCount()||this.parent.getFrozenRightColumnsCount()||this.parent.on(Qi,this.setVisible,this),this.parent.on(Ji,this.colPosRefresh,this),this.parent.on(Si,this.renderCustomToolbar,this),"Vertical"===this.parent.rowRenderingMode&&this.parent.on(Fi,this.updateCustomResponsiveToolbar,this))}return i.prototype.renderPanel=function(){var e=this.parent.element.querySelector("."+Wo),t=null!=e;e=t?e:this.parent.createElement("div",{className:"e-gridheader"});var i=t?e.querySelector("."+Xo):this.parent.createElement("div",{className:Xo});this.toggleStackClass(e),e.appendChild(i),this.setPanel(e),t||this.parent.element.appendChild(e)},i.prototype.renderTable=function(){var e=this.getPanel();e.appendChild(this.createHeaderTable()),this.setTable(e.querySelector("."+ts)),this.parent.getFrozenColumns()||this.parent.getFrozenRightColumnsCount()||this.parent.getFrozenLeftColumnsCount()||(this.initializeHeaderDrag(),this.initializeHeaderDrop()),this.parent.notify(Di,{rows:this.rows,args:{isFrozen:this.parent.isFrozenGrid()}})},i.prototype.getPanel=function(){return this.headerPanel},i.prototype.setPanel=function(e){this.headerPanel=e},i.prototype.getTable=function(){return this.headerTable},i.prototype.setTable=function(e){this.headerTable=e},i.prototype.getColGroup=function(){return this.colgroup},i.prototype.setColGroup=function(e){return this.colgroup=e},i.prototype.getRows=function(){return this.getTable().tHead.rows},i.prototype.createHeaderTable=function(){var e=this.createTable(),t=this.getPanel().querySelector("."+Xo);return t.appendChild(e),t},i.prototype.createHeader=function(e,i){void 0===e&&(e=null);var r=this.parent,n=r.isFrozenGrid();this.getTable()&&!n&&t.remove(this.getTable());var o=this.parent.createElement("table",{className:ts,attrs:{cellspacing:"0.25px",role:"grid"}}),s=i||(r.getFrozenLeftCount()?"frozen-left":"frozen-right"),l=this.createHeaderContent(s),a=l.thead,h=this.parent.createElement(gs,{className:this.parent.frozenRows?"":"e-hide"});this.caption=this.parent.createElement("caption",{innerHTML:this.parent.element.id+"_header_table",className:"e-hide"});for(var d,p=this.parent.createElement(fs),c=this.parent.createElement("tr"),u=this.rows=l.rows,g=0,f=u.length;g<f;g++)for(var m=0,y=u[g].cells.length;m<y;m++)d=this.parent.createElement("td"),c.appendChild(d);return(r.allowFiltering||r.allowSorting||r.allowGrouping)&&o.classList.add("e-sortfilter"),this.updateColGroup(p),h.appendChild(c),o.appendChild(this.setColGroup(p)),o.appendChild(a),o.appendChild(h),o.appendChild(this.caption),this.ariaService.setOptions(o,{colcount:r.getColumns().length.toString()}),o},i.prototype.createTable=function(e){return void 0===e&&(e=null),this.createHeader(e)},i.prototype.createHeaderContent=function(t){var i=this.parent,r=1,n=i.getFrozenMode(),o=i.getColumns(),s=this.parent.createElement("thead"),l=this.parent.createElement("tr",{className:"e-columnheader"}),a=new Fs(this.serviceLocator,e.CellType.Header,i);a.element=l;var h,d=[];this.colDepth=ge(i.columns);for(var p=0,c=this.colDepth;p<c;p++)d[p]=this.generateRow(p),d[p].cells=[];"Right"!==n&&(d=this.ensureColumns(d)),d=this.getHeaderCells(d,t),"Right"===n&&(r=0,d=this.ensureColumns(d));var u=this.parent.getFrozenColumns();if(this.parent.isRowDragable()&&this.parent.isFrozenGrid()&&d[0].cells[r]){var g=d[0].cells[r].column.getFreezeTableName();"movable"===g||n===hs&&g===ds?"Right"===n?d[0].cells.pop():d[0].cells.shift():u||g!==ps?"Right"===n&&g===ds&&(d[0].cells[d[0].cells.length-1].column.freeze="Right"):d[0].cells[0].column.freeze=g===ps?"Left":"Right"}for(p=0,c=this.colDepth;p<c;p++)h=a.render(d[p],o),this.parent.rowHeight&&h.querySelector(".e-headercell")&&(h.style.height=this.parent.rowHeight+"px"),s.appendChild(h);return{thead:s,rows:d}},i.prototype.updateColGroup=function(e){var i,r=this.parent.getColumns(),n=this.parent.getColumnIndexesInView();if(this.parent.enableColumnVirtualization&&this.parent.getFrozenColumns()&&this.parent.contentModule.isXaxis()&&(r=t.extend([],this.parent.getColumns())).splice(0,this.parent.getFrozenColumns()),e.id=this.parent.element.id+fs,this.parent.allowGrouping)for(var o=0,s=this.parent.groupSettings.columns.length;o<s;o++)this.parent.enableColumnVirtualization&&-1===n.indexOf(o)||(i=this.parent.createElement("col",{className:"e-group-intent"}),e.appendChild(i));(this.parent.detailTemplate||this.parent.childGrid)&&(i=this.parent.createElement("col",{className:"e-detail-intent"}),e.appendChild(i)),this.parent.isRowDragable()&&"Right"!==this.parent.getFrozenMode()&&(i=this.parent.createElement("col",{className:"e-drag-intent"}),e.appendChild(i));for(o=0,s=r.length;o<s;o++)i=this.parent.createElement("col"),!1===r[o].visible&&t.setStyleAttribute(i,{display:"none"}),e.appendChild(i);return this.parent.isRowDragable()&&"Right"===this.parent.getFrozenMode()&&(i=this.parent.createElement("col",{className:"e-drag-intent"}),e.appendChild(i)),e},i.prototype.ensureColumns=function(t){for(var i=this.parent,r=this.parent.getColumnIndexesInView(),n=0,o=t.length;n<o;n++){if(i.allowGrouping)for(var s=0,l=i.groupSettings.columns.length;s<l;s++)this.parent.enableColumnVirtualization&&-1===r.indexOf(s)||t[n].cells.push(this.generateCell({},e.CellType.HeaderIndent));if(i.detailTemplate||i.childGrid){var a={};this.parent.notify(wn,a),t[n].cells.push(this.generateCell(a,e.CellType.DetailHeader))}i.isRowDragable()&&t[n].cells.push(this.generateCell({},e.CellType.RowDragHIcon))}return t},i.prototype.getHeaderCells=function(e,t){var i=this.parent.getHeaderTable()&&this.parent.getHeaderTable().querySelector("thead"),r=this.parent.enableColumnVirtualization?this.parent.getColumns(this.parent.enablePersistence):this.parent.columns;if(this.frzIdx=0,this.notfrzIdx=0,this.parent.lockcolPositionCount)for(var n=0;n<r.length;n++)this.lockColsRendered=!1,e=this.appendCells(r[n],e,0,0===n,!1,n===r.length-1,i,t,!1);n=0;for(var o=r.length;n<o;n++)this.notfrzIdx=0,this.lockColsRendered=!0,e=this.appendCells(r[n],e,0,0===n,!1,n===o-1,i,t,!1);return e},i.prototype.appendCells=function(t,i,r,n,o,s,l,a,h){var d,p=s?h?"e-laststackcell":"e-lastcell":"",c=this.parent.isFrozenGrid(),u=!this.parent.lockcolPositionCount||t.lockColumn&&!this.lockColsRendered||!t.lockColumn&&this.lockColsRendered,g=!this.parent.lockcolPositionCount||t.lockColumn&&!this.lockColsRendered||!t.lockColumn&&this.lockColsRendered,f=this.parent.getContent().querySelector(".e-movablescrollbar");if(c&&f&&this.parent.enableColumnVirtualization&&(d=f.scrollLeft),t.columns){this.isFirstCol=!1;var m=this.getCellCnt(t,0);if(m){var y=this.getStackedLockColsCount(t,0),v=0===this.parent.lockcolPositionCount||!this.lockColsRendered&&0!==y||this.lockColsRendered&&m-y!=0,C=c&&this.ensureStackedFrozen(t.columns,a,!1);(!c&&v||C)&&i[r].cells.push(new Vo({cellType:e.CellType.StackedHeader,column:t,colSpan:this.getColSpan(m,y,t.columns,a,c),className:n?"":o?"e-firstcell":""}))}if(this.parent.lockcolPositionCount&&!this.lockColsRendered)for(var w=0;w<t.columns.length;w++)i=this.appendCells(t.columns[w],i,r+1,n,0===w,w===t.columns.length-1&&s,l,a,!1);if(this.lockColsRendered){w=0;for(var b=t.columns.length;w<b;w++){n=n&&0===w;var S=this.isFirstCol=t.columns[w].visible&&!n,R=w===b-1&&s;i=this.appendCells(t.columns[w],i,r+1,n,S&&!R,R,l,a,!0)}}}else d&&d>0&&this.parent.contentModule.isXaxis()&&0!==this.parent.inViewIndexes[0]&&"movable"===t.getFreezeTableName()?i[r].cells.push(this.generateCell(t,e.CellType.Header,this.colDepth-r,(n?"":o?"e-firstcell":"")+p,r,this.parent.getColumnIndexByUid(t.uid))):(!c&&u||c&&t.getFreezeTableName()===a&&g)&&i[r].cells.push(this.generateCell(t,e.CellType.Header,this.colDepth-r,(n?"":o?"e-firstcell":"")+p,r,this.parent.getColumnIndexByUid(t.uid))),this.parent.lockcolPositionCount?this.frzIdx+this.notfrzIdx<this.parent.frozenColumns&&(t.lockColumn&&!this.lockColsRendered||!t.lockColumn&&this.lockColsRendered)?this.frzIdx++:this.notfrzIdx++:this.frzIdx++;return i},i.prototype.ensureStackedFrozen=function(e,t,i){for(var r=e.length,n=0;n<r;n++)if(e[n].columns)i=this.ensureStackedFrozen(e[n].columns,t,i);else if(e[n].getFreezeTableName()===t){i=!0;break}return i},i.prototype.getStackedLockColsCount=function(e,t){if(e.columns)for(var i=0;i<e.columns.length;i++)t=this.getStackedLockColsCount(e.columns[i],t);else e.lockColumn&&t++;return t},i.prototype.getColSpan=function(e,t,i,r,n){return n?e=this.getFrozenColSpan(i,r,0):this.parent.lockcolPositionCount&&(e=this.lockColsRendered?e-t:t),e},i.prototype.getFrozenColSpan=function(e,t,i){for(var r=e.length,n=0;n<r;n++)e[n].columns?i=this.getFrozenColSpan(e[n].columns,t,i):e[n].getFreezeTableName()===t&&e[n].visible&&i++;return i},i.prototype.generateRow=function(e){return new jo({})},i.prototype.generateCell=function(e,i,r,n,o,s){var l={visible:e.visible,isDataCell:!1,isTemplate:!t.isNullOrUndefined(e.headerTemplate),rowID:"",column:e,cellType:i,rowSpan:r,className:n,index:o,colIndex:s};return(!l.rowSpan||l.rowSpan<2)&&delete l.rowSpan,new Vo(l)},i.prototype.setVisible=function(e){for(var i,r,n=this.parent,o=n.getFrozenColumns(),s=0,l=e.length;s<l;s++){var a=e[s];if(r=n.getNormalizedColumnIndex(a.uid),i=a.visible?"":"none",o){var h=this.parent.isRowDragable()?o+1:o;if(r<h)t.setStyleAttribute(this.getColGroup().children[r],{display:i});else{var d=n.getHeaderContent().querySelector("."+Jo).querySelector(fs);t.setStyleAttribute(d.children[r-h],{display:i})}}else t.setStyleAttribute(this.getColGroup().children[r],{display:i})}this.refreshUI()},i.prototype.colPosRefresh=function(){this.refreshUI()},i.prototype.refreshUI=function(){var e=this.parent.isFrozenGrid(),i=this.parent.enableColumnVirtualization&&e,r=this.getPanel();this.toggleStackClass(r);var n=this.freezeReorder?this.headerPanel.querySelector("."+Jo).querySelector("."+ts):this.getTable(),o=this.parent.isFrozenGrid()?this.parent.getFrozenLeftCount()?"frozen-left":"frozen-right":void 0;if(i&&(n=this.parent.contentModule.getVirtualFreezeHeader(),o=this.parent.contentModule.isXaxis()?"movable":o),n){t.remove(n),n.removeChild(n.firstChild),n.removeChild(n.childNodes[0]);var s=this.parent.createElement(fs),l=this.createHeaderContent(o);this.rows=l.rows,n.insertBefore(l.thead,n.firstChild),this.updateColGroup(s),n.insertBefore(this.setColGroup(s),n.firstChild),i||this.setTable(n),this.appendContent(n),this.parent.notify(zi,{}),this.widthService.setWidthToColumns(),this.parent.updateDefaultCursor(),(!e||this.parent.enableColumnVirtualization&&e)&&this.initializeHeaderDrag();for(var a=[].slice.call(r.querySelectorAll("tr.e-columnheader")),h=0,d=a;h<d.length;h++){var p=d[h],c=[].slice.call(p.getElementsByClassName("e-grouptopleftcell"));c.length&&c[c.length-1].classList.add("e-lastgrouptopleftcell")}e||this.parent.notify(Di,{rows:this.rows,args:{isFrozen:e}}),this.parent.enableColumnVirtualization&&D(n,Jo)&&this.parent.notify(Di,{rows:this.rows,args:{isFrozen:!1,isXaxis:!0}}),this.parent.allowTextWrap&&"Header"===this.parent.textWrapSettings.wrapMode&&K(a,!0)}},i.prototype.toggleStackClass=function(e){this.parent.columns.some(function(e){return!t.isNullOrUndefined(e.columns)})?e.classList.add("e-stackedheader"):e.classList.remove("e-stackedheader")},i.prototype.appendContent=function(e){this.getPanel().querySelector("."+Xo).appendChild(e)},i.prototype.getCellCnt=function(e,t){if(e.columns)for(var i=0,r=e.columns.length;i<r;i++)t=this.getCellCnt(e.columns[i],t);else e.visible&&t++;return t},i.prototype.initializeHeaderDrag=function(){var e=this.parent;(this.parent.allowReordering||this.parent.allowGrouping&&this.parent.groupSettings.showDropArea)&&(this.draggable=new t.Draggable(e.getHeaderContent(),{dragTarget:".e-headercell",distance:5,helper:this.helper,dragStart:this.dragStart,drag:this.drag,dragStop:this.dragStop,abort:".e-rhandler",isReplaceDragEle:this.isReplaceDragEle}))},i.prototype.initializeHeaderDrop=function(){var e=this.parent;new t.Droppable(e.getHeaderContent(),{accept:".e-dragclone",drop:this.drop})},i.prototype.renderCustomToolbar=function(){var e=this,t=this.parent;if("Vertical"===t.rowRenderingMode&&!t.toolbar&&(t.allowSorting||t.allowFiltering&&"FilterBar"!==t.filterSettings.type)){for(var i=t.createElement("div",{className:"e-res-toolbar e-toolbar"}),r=t.createElement("div",{className:"e-toolbar-items"}),o=t.createElement("div",{className:"e-toolbar-left"}),s=this.parent.allowFiltering&&this.parent.allowSorting?2:1,l=0;l<s;l++){var a=t.createElement("div",{className:"e-toolbar-item e-gridresponsiveicons e-icons e-tbtn-align"}),h=1===s?this.parent.allowSorting?"sort":"filter":1===l?"sort":"filter",d=t.createElement("button",{className:"e-tbar-btn e-control e-btn e-lib e-icon-btn"}),p=t.createElement("span",{className:"e-btn-icon e-res"+h+"-icon e-icons"});d.appendChild(p);new n.Button({}).appendTo(d),d.onclick=function(t){t.target.classList.contains("e-ressort-btn")||t.target.classList.contains("e-ressort-icon")?e.parent.showResponsiveCustomSort():e.parent.showResponsiveCustomFilter()},a.appendChild(d),o.appendChild(a)}r.appendChild(o),i.appendChild(r),t.element.insertBefore(i,this.parent.element.querySelector("."+Wo))}else t.enableAdaptiveUI&&!t.toolbar&&t.getContent().classList.add("e-responsive-header")},i.prototype.updateCustomResponsiveToolbar=function(e){var i=this.parent.element.querySelector(".e-responsive-toolbar");"toolbar"===e.module&&(i?t.remove(i):this.renderCustomToolbar())},i}(),Bs=function(){function i(e,t){this.localizer=t.getService("localization"),this.formatter=t.getService("valueFormatter"),this.parent=e,this.element=this.parent.createElement("TD",{className:_o,attrs:{role:"gridcell",tabindex:"-1"}}),this.rowChkBox=this.parent.createElement("input",{className:"e-checkselect",attrs:{type:"checkbox","aria-label":"checkbox"}})}return i.prototype.getGui=function(){return""},i.prototype.format=function(e,i,r){return t.isNullOrUndefined(e.format)||("number"===e.type&&isNaN(parseInt(i,10))&&(i=null),i=this.formatter.toView(i,e.getFormatter())),t.isNullOrUndefined(i)?"":i.toString()},i.prototype.evaluate=function(e,i,r,n,o,s){var l,a;if(i.column.template){var h=this.parent.isReact&&"string"!=typeof i.column.template,d=["index"],p=ue({},r,(l={},l[Hr]=o,l.column=i.column,l)),c=this.parent.element.id+i.column.uid,u="isStringTemplate";if(h){var g={index:n[d[0]]};i.column.getColumnTemplate()(t.extend(g,p),this.parent,"columnTemplate",c,this.parent[u],null,e),this.parent.renderTemplates()}else a=i.column.getColumnTemplate()(t.extend({index:n[d[0]]},p),this.parent,"template",c,this.parent[u]);return h||P(e,a),this.parent.notify("template-result",{template:a}),a=null,e.setAttribute("aria-label",e.innerText+" is template cell column header "+i.column.headerText),!1}return!0},i.prototype.invokeFormatter=function(e,i,r){if(!t.isNullOrUndefined(e.formatter))if(u(e.formatter,"getValue")){i=(new(0,e.formatter)).getValue(e,r)}else i="function"==typeof e.formatter?e.formatter(e,r):e.formatter.getValue(e,r);return i},i.prototype.render=function(e,t,i,r,n){return this.refreshCell(e,t,i,n)},i.prototype.refreshTD=function(e,i,r,n){var o="Batch"===this.parent.editSettings.mode&&e.classList.contains("e-editedbatchcell");if(this.parent.isReact){e.innerHTML="";var s=e.cellIndex,l=e.parentElement;t.remove(e);var a=this.refreshCell(i,r,n,o);this.cloneAttributes(a,e),l.cells.length!==s-1?l.insertBefore(a,l.cells[s]):l.appendChild(a)}else{var h=this.refreshCell(i,r,n,o);e.innerHTML="",e.setAttribute("aria-label",h.getAttribute("aria-label"));for(var d=0,p=[].slice.call(h.childNodes);d<p.length;d++){var c=p[d];e.appendChild(c)}}},i.prototype.cloneAttributes=function(e,t){for(var i,r=t.attributes,n=r.length;n--;)i=r[n],e.setAttribute(i.name,i.value)},i.prototype.refreshCell=function(e,i,r,o){var s,l,a=this.element.cloneNode(),h=e.column;e.isForeignKey&&(l=e.foreignKeyData[0]||(s={},s[h.foreignKeyValue]=h.format?null:"",s));var d=this.getGui(),p=e.isForeignKey?this.getValue(h.foreignKeyValue,l,h):this.getValue(h.field,i,h);if("date"!==h.type&&"datetime"!==h.type||t.isNullOrUndefined(p)||(p=new Date(p)),p=this.format(h,p,i),d=p.toString(),"boolean"===h.type&&!h.displayAsCheckBox){var c="true"!==p&&"false"!==p?null:"true"===p?"True":"False";d=c?this.localizer.getConstant(c):d}var u=this.invokeFormatter(h,p,i);if(d=t.isNullOrUndefined(h.formatter)?d:t.isNullOrUndefined(u)?"":u.toString(),a.setAttribute("aria-label",d+" column header "+e.column.headerText),this.evaluate(a,e,i,r,l,o)&&"checkbox"!==h.type)this.appendHtml(a,d,h.getDomSetter?h.getDomSetter():"innerHTML");else if("checkbox"===h.type){a.classList.add(rs),a.setAttribute("aria-label","checkbox"),p=!!this.parent.selectionSettings.persistSelection&&"true"===p;var g=n.createCheckBox(this.parent.createElement,!1,{checked:p,label:" "});this.rowChkBox.id="checkbox-"+e.rowID,g.insertBefore(this.rowChkBox.cloneNode(),g.firstChild),a.appendChild(g)}if("Check"===this.parent.checkAllRows&&this.parent.enableVirtualization&&(e.isSelected=!0),this.setAttributes(a,e,r),"boolean"===h.type&&h.displayAsCheckBox){var f=isNaN(parseInt(p.toString(),10))?"true"===p:parseInt(p.toString(),10)>0;g=n.createCheckBox(this.parent.createElement,!1,{checked:f,label:" "});a.innerHTML="",g.classList.add("e-checkbox-disabled"),a.appendChild(g),a.setAttribute("aria-label",f+" column header "+e.column.headerText)}return a},i.prototype.appendHtml=function(e,t,i){return void 0===i&&(i="innerHTML"),e[i]=t,e},i.prototype.setAttributes=function(e,t,i){var r=t.column;this.buildAttributeFromCell(e,t,"checkbox"===r.type),x(e,i),x(e,t.attributes),r.customAttributes&&x(e,r.customAttributes),"Vertical"===this.parent.rowRenderingMode&&x(e,{"data-cell":r.headerText}),r.textAlign&&(e.style.textAlign=r.textAlign),"Clip"===r.clipMode||!r.clipMode&&"Clip"===this.parent.clipMode?e.classList.add("e-gridclip"):("EllipsisWithTooltip"===r.clipMode||!r.clipMode&&"EllipsisWithTooltip"===this.parent.clipMode)&&"checkbox"!==r.type&&e.classList.add("e-ellipsistooltip")},i.prototype.buildAttributeFromCell=function(i,r,n){var o={},s=cs,l=[];r.colSpan&&(o.colSpan=r.colSpan),r.rowSpan&&(o.rowSpan=r.rowSpan),r.isTemplate&&l.push("e-templatecell"),r.isSelected&&(l.push.apply(l,["e-selectionbackground","e-active"]),n&&i.querySelector(".e-frame").classList.add("e-check")),r.isColumnSelected&&l.push.apply(l,["e-columnselection"]),r.cellType===e.CellType.Header?o[s]=r.colIndex:t.isNullOrUndefined(r.index)||(o[s]=r.index),r.visible||l.push("e-hide"),o.class=l,x(i,o)},i.prototype.getValue=function(e,t,i){return i.valueAccessor(e,t,i)},i}(),Ns=function(){function e(){}return e.prototype.setOptions=function(e,t){for(var i=Object.keys(t),r=0;r<i.length;r++)p(e,Ps[i[r]],t[i[r]])},e.prototype.setExpand=function(e,t){p(e,Ps.expand,t)},e.prototype.setSort=function(e,t){p(e,Ps.sort,t,"boolean"==typeof t)},e.prototype.setBusy=function(e,t){p(e,Ps.busy,t),p(e,Ps.invalid,null,!0)},e.prototype.setGrabbed=function(e,t,i){p(e,Ps.grabbed,t,i)},e.prototype.setDropTarget=function(e,t){p(e,Ps.dropeffect,"copy",!t)},e}(),Ps={expand:"aria-expanded",role:"role",selected:"aria-selected",multiselectable:"aria-multiselectable",sort:"aria-sort",busy:"aria-busy",invalid:"aria-invalid",grabbed:"aria-grabbed",dropeffect:"aria-dropeffect",haspopup:"aria-haspopup",level:"aria-level",colcount:"aria-colcount",rowcount:"aria-rowcount"},Ls=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),qs=function(e){function i(){var t=null!==e&&e.apply(this,arguments)||this;return t.element=t.parent.createElement("TH",{className:"e-headercell",attrs:{role:"columnheader",tabindex:"-1"}}),t.ariaService=new Ns,t.hTxtEle=t.parent.createElement("span",{className:"e-headertext"}),t.sortEle=t.parent.createElement("div",{className:"e-sortfilterdiv e-icons"}),t.gui=t.parent.createElement("div"),t.chkAllBox=t.parent.createElement("input",{className:"e-checkselectall",attrs:{type:"checkbox","aria-label":"checkbox"}}),t}return Ls(i,e),i.prototype.getGui=function(){return this.gui.cloneNode()},i.prototype.render=function(e,t,i){var r=this.element.cloneNode(),n=this.parent.createElement("div",{className:"e-filtermenudiv e-icons e-icon-filter"});return this.prepareHeader(e,r,n)},i.prototype.refresh=function(e,t){this.clean(t);var i=this.parent.createElement("div",{className:"e-filtermenudiv e-icons e-icon-filter"});return this.prepareHeader(e,t,i)},i.prototype.clean=function(e){e.innerHTML=""},i.prototype.prepareHeader=function(e,i,r){var o,s=e.column,l={},a=this.getGui();if(t.attributes(a,{"e-mappinguid":s.uid,class:"e-headercelldiv"}),t.isNullOrUndefined(s.headerValueAccessor)||(o=this.getValue(s.headerText,s)),"checkbox"!==s.type){var h=s.headerText;t.isNullOrUndefined(o)||(h=o);var d=this.hTxtEle.cloneNode();d[s.getDomSetter()]=h,a.appendChild(d)}else{s.editType="booleanedit";var p=n.createCheckBox(this.parent.createElement,!1,{checked:!1,label:" "});this.chkAllBox.id="checkbox-"+s.uid,p.insertBefore(this.chkAllBox.cloneNode(),p.firstChild),a.appendChild(p),a.classList.add("e-headerchkcelldiv")}if(this.buildAttributeFromCell(i,e),this.appendHtml(i,a),i.appendChild(this.sortEle.cloneNode()),this.parent.allowFiltering&&"FilterBar"!==this.parent.filterSettings.type&&s.allowFiltering&&!t.isNullOrUndefined(s.field)&&(!this.parent.showColumnMenu||!s.showColumnMenu)){t.attributes(r,{"e-mappinguid":"e-flmenu-"+s.uid}),i.classList.add("e-fltr-icon");var c=[];if(this.parent.filterSettings.columns.length&&this.parent.filterSettings.columns.length!==c.length)for(var u=this.parent.getForeignKeyColumns(),g=0;g<this.parent.columns.length;g++)for(var f=0;f<this.parent.filterSettings.columns.length;f++)if(this.parent.filterSettings.columns[f].field===s.field||u.length&&s.foreignKeyValue===this.parent.filterSettings.columns[f].field){r.classList.add("e-filtered"),c.push(s.field);break}i.appendChild(r.cloneNode())}e.className&&i.classList.add(e.className),s.customAttributes&&x(i,s.customAttributes),s.allowSorting&&(l.sort="none"),s.allowGrouping&&(l.grabbed=!1),i=this.extendPrepareHeader(s,i);var m,y=this.parent,v=y.getColumnIndexByField(s.field);if(!t.isNullOrUndefined(s.headerTemplate)){var C=y.element.id+s.uid+"headerTemplate",w="isStringTemplate",b=s;if(this.parent.isReact&&"string"!=typeof s.headerTemplate){var S={index:v};i.firstElementChild.innerHTML="",s.getHeaderTemplate()(t.extend(S,b),y,"headerTemplate",C,this.parent[w],null,i.firstElementChild),this.parent.renderTemplates()}else m=s.getHeaderTemplate()(t.extend({index:v},b),y,"headerTemplate",C,this.parent[w]),i.firstElementChild.innerHTML="",P(i.firstElementChild,m)}if(this.ariaService.setOptions(i,l),!t.isNullOrUndefined(s.headerTextAlign)||!t.isNullOrUndefined(s.textAlign)){var R=s.headerTextAlign||s.textAlign;a.style.textAlign=R,"Right"===R||"Left"===R?i.classList.add("Right"===R?"e-rightalign":"e-leftalign"):"Center"===R&&i.classList.add("e-centeralign")}return"Clip"===s.clipMode||!s.clipMode&&"Clip"===this.parent.clipMode?i.classList.add("e-gridclip"):("EllipsisWithTooltip"===s.clipMode||!s.clipMode&&"EllipsisWithTooltip"===this.parent.clipMode)&&"checkbox"!==s.type&&i.classList.add("e-ellipsistooltip"),i.setAttribute("aria-rowspan",(t.isNullOrUndefined(e.rowSpan)?1:e.rowSpan).toString()),i.setAttribute("aria-colspan","1"),this.parent.trigger(Tt,{cell:e,node:i}),i},i.prototype.getValue=function(e,t){return t.headerValueAccessor(e,t)},i.prototype.extendPrepareHeader=function(e,i){if(this.parent.showColumnMenu&&e.showColumnMenu&&!t.isNullOrUndefined(e.field)){var r=this.parent.createElement("div",{className:"e-icons e-columnmenu"}),n=[];if(this.parent.filterSettings.columns.length&&this.parent.filterSettings.columns.length!==n.length)for(var o=0;o<this.parent.columns.length;o++)for(var s=0;s<this.parent.filterSettings.columns.length;s++)if(this.parent.filterSettings.columns[s].field===e.field){r.classList.add("e-filtered"),n.push(e.field);break}i.classList.add("e-fltr-icon"),i.appendChild(r)}if(this.parent.allowResizing){var l=this.parent.createElement("div");l.className=e.allowResizing?"e-rhandler e-rcursor":"e-rsuppress",i.appendChild(l)}return i},i.prototype.appendHtml=function(e,t){return e.appendChild(t),e},i}(Bs),Hs=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Us=function(e){function i(){var t=null!==e&&e.apply(this,arguments)||this;return t.element=t.parent.createElement("TH",{className:"e-headercell e-stackedheadercell",attrs:{role:"columnheader",tabindex:"-1"}}),t}return Hs(i,e),i.prototype.render=function(e,i,r){var n=this.element.cloneNode(),o=this.parent.createElement("div",{className:"e-stackedheadercelldiv",attrs:{"e-mappinguid":e.column.uid}}),s=e.column;if(n.appendChild(o),t.isNullOrUndefined(s.headerTemplate)?this.appendHtml(o,s.headerText,s.getDomSetter()):P(o,s.getHeaderTemplate()(s,this.parent,"headerTemplate")),e.column.toolTip&&n.setAttribute("title",e.column.toolTip),"Clip"===s.clipMode||!s.clipMode&&"Clip"===this.parent.clipMode?n.classList.add("e-gridclip"):("EllipsisWithTooltip"===s.clipMode||!s.clipMode&&"EllipsisWithTooltip"===this.parent.clipMode)&&n.classList.add("e-ellipsistooltip"),t.isNullOrUndefined(e.column.textAlign)||(o.style.textAlign=e.column.textAlign),e.column.customAttributes&&x(n,e.column.customAttributes),n.setAttribute("colspan",e.colSpan.toString()),n.setAttribute("aria-colspan",e.colSpan.toString()),n.setAttribute("aria-rowspan","1"),this.parent.allowResizing){var l=this.parent.createElement("div");l.className=e.column.allowResizing?"e-rhandler e-rcursor":"e-rsuppress",n.appendChild(l)}return e.className&&n.classList.add(e.className),this.parent.trigger(Tt,{cell:e,node:n}),n},i}(Bs),js=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Vs=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.element=t.parent.createElement("TD",{className:"e-indentcell"}),t}return js(t,e),t.prototype.render=function(e,t){var i=this.element.cloneNode();return x(i,e.attributes),i},t}(Bs),Gs=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),_s=function(e){function i(){var t=null!==e&&e.apply(this,arguments)||this;return t.element=t.parent.createElement("TD",{className:"e-groupcaption",attrs:{id:t.parent.element.id+"captioncell",role:"gridcell",tabindex:"-1"}}),t}return Gs(i,e),i.prototype.render=function(e,i){var r,n,o=this.element.cloneNode(),s=this.parent;i.headerText=e.column.headerText,e.isForeignKey&&(n=this.format(e.column,e.column.valueAccessor("foreignKey",i,e.column)));var l=e.isForeignKey?n:e.column.enableGroupByFormat?i.key:this.format(e.column,e.column.valueAccessor("key",i,e.column));if(t.isNullOrUndefined(s.groupSettings.captionTemplate))s.groupSettings.enableLazyLoading?o.innerHTML=e.column.headerText+": "+l:o.innerHTML=e.column.headerText+": "+l+" - "+i.count+" "+(i.count<2?this.localizer.getConstant("Item"):this.localizer.getConstant("Items"));else{var a=this.parent.isReact&&"string"!=typeof s.groupSettings.captionTemplate;if(a){var h=s.element.id+"captionTemplate";R(s.groupSettings.captionTemplate)(i,this.parent,"captionTemplate",h,null,null,o),this.parent.renderTemplates()}else r=this.parent.isVue?R(s.groupSettings.captionTemplate)(i,this.parent):R(s.groupSettings.captionTemplate)(i);a||P(o,r)}return o.setAttribute("colspan",e.colSpan.toString()),o.setAttribute("aria-label",o.innerHTML+" is groupcaption cell"),o.setAttribute("title",o.innerHTML),o},i}(Bs),Ws=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.element=t.parent.createElement("TD",{className:"e-groupcaption"}),t}return Gs(t,e),t.prototype.render=function(e,t){var i=this.element.cloneNode();return i.innerHTML="&nbsp;",i.setAttribute("colspan",e.colSpan.toString()),i},t}(Bs),Ks=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Qs=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Ks(t,e),t.prototype.render=function(e,t,i,r){var n=this.element.cloneNode();return n.className=r?"e-recordplusexpand":"e-recordpluscollapse",n.setAttribute("ej-mappingname",t.field),n.setAttribute("ej-mappingvalue",t.key),n.setAttribute("aria-expanded",r?"true":"false"),n.setAttribute("tabindex","-1"),n.appendChild(this.parent.createElement("div",{className:r?"e-icons e-gdiagonaldown e-icon-gdownarrow":"e-icons e-gnextforward e-icon-grightarrow"})),n},t}(Vs),Xs=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Ys=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.element=t.parent.createElement("TH",{className:"e-grouptopleftcell"}),t}return Xs(t,e),t.prototype.render=function(e,t){var i=this.element.cloneNode();return i.appendChild(this.parent.createElement("div",{className:"e-headercelldiv e-emptycell",innerHTML:""})),i},t}(Bs),Js=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Zs=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.element=t.parent.createElement("TH",{className:"e-detailheadercell"}),t}return Js(t,e),t.prototype.render=function(e,t){var i=this.element.cloneNode();return i.appendChild(this.parent.createElement("div",{className:"e-emptycell"})),i},t}(Bs),$s=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),el=function(e){function i(){var t=null!==e&&e.apply(this,arguments)||this;return t.element=t.parent.createElement("TD",{className:"e-detailrowcollapse",attrs:{"aria-expanded":"false",role:"gridcell",tabindex:"-1"}}),t}return $s(i,e),i.prototype.render=function(e,i,r){var n=this.element.cloneNode();return r&&!t.isNullOrUndefined(r.class)?(n.className="",n.className=r.class,n.appendChild(this.parent.createElement("div",{className:"e-icons e-dtdiagonaldown e-icon-gdownarrow"}))):n.appendChild(this.parent.createElement("div",{className:"e-icons e-dtdiagonalright e-icon-grightarrow"})),n},i}(Bs),tl=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),il=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.element=t.parent.createElement("TD",{className:"e-rowdragdrop e-rowdragdropcell",attrs:{role:"gridcell",tabindex:"-1"}}),t}return tl(t,e),t.prototype.render=function(e,t){var i=this.element.cloneNode();return i.appendChild(this.parent.createElement("div",{className:"e-icons e-rowcelldrag e-dtdiagonalright e-icon-rowdragicon"})),e.isSelected&&(i.classList.add("e-selectionbackground"),i.classList.add("e-active")),i},t}(Bs),rl=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),nl=function(e){function i(){var t=null!==e&&e.apply(this,arguments)||this;return t.element=t.parent.createElement("TH",{className:"e-rowdragheader"}),t}return rl(i,e),i.prototype.render=function(e,i){var r=this.element.cloneNode();return r.appendChild(t.createElement("div",{className:"e-emptycell"})),r},i}(Bs),ol=function(){function r(e,t){this.emptyGrid=!1,this.counter=0,this.parent=e,this.locator=t,this.data=new Uo(e,t),this.l10n=t.getService("localization"),this.ariaService=this.locator.getService("ariaService"),this.renderer=this.locator.getService("rendererFactory"),this.addEventListener()}return r.prototype.render=function(){var t=this.parent;this.headerRenderer=this.renderer.getRenderer(e.RenderType.Header),this.contentRenderer=this.renderer.getRenderer(e.RenderType.Content),this.headerRenderer.renderPanel(),this.contentRenderer.renderPanel(),t.getColumns().length&&(this.isLayoutRendered=!0,this.headerRenderer.renderTable(),this.contentRenderer.renderTable(),this.emptyRow(!1)),this.parent.scrollModule.setWidth(),this.parent.scrollModule.setHeight(),"auto"!==this.parent.height&&this.parent.scrollModule.setPadding(),this.refreshDataManager()},r.prototype.refresh=function(e){var t=this;void 0===e&&(e={requestType:"refresh"});var i=this.parent;i.notify(e.requestType+"-begin",e),i.trigger(zt,e,function(e){if(void 0===e&&(e={requestType:"refresh"}),e.cancel)i.notify(Xr,e);else{if("delete"===e.requestType&&i.allowPaging){var r=e.data.length,n=i.pageSettings.totalRecordsCount-r;i.getCurrentViewRecords().length-r||!n||(i.pageSettings.currentPage-1)*i.pageSettings.pageSize!==n||(i.prevPageMoving=!0,i.setProperties({pageSettings:{totalRecordsCount:n,currentPage:Math.ceil(n/i.pageSettings.pageSize)}},!0),i.pagerModule.pagerObj.totalRecordsCount=n)}"reorder"===e.requestType&&t.parent.dataSource&&"result"in t.parent.dataSource?t.contentRenderer.refreshContentRows(e):("paging"===e.requestType||"columnstate"===e.requestType||"reorder"===e.requestType)&&t.parent.groupSettings.enableLazyLoading&&t.parent.groupSettings.columns.length&&t.parent.contentModule.getGroupCache()[t.parent.pageSettings.currentPage]?t.contentRenderer.refreshContentRows(e):t.refreshDataManager(e)}})},r.prototype.resetTemplates=function(){var e=this.parent,i=e.getColumns();if(e.detailTemplate){var r=e.element.id+"detailTemplate";t.blazorTemplates[r]=[],t.resetBlazorTemplate(r,"DetailTemplate")}e.groupSettings.captionTemplate&&t.resetBlazorTemplate(e.element.id+"captionTemplate","CaptionTemplate"),e.rowTemplate&&t.resetBlazorTemplate(e.element.id+"rowTemplate","RowTemplate"),e.toolbarTemplate&&t.resetBlazorTemplate(e.element.id+"toolbarTemplate","ToolbarTemplate"),e.pageSettings.template&&t.resetBlazorTemplate(e.element.id+"_template","pageSettings");for(var n=0;n<i.length;n++)i[n].template&&(t.blazorTemplates[e.element.id+i[n].uid]=[],t.resetBlazorTemplate(e.element.id+i[n].uid,"Template")),i[n].headerTemplate&&t.resetBlazorTemplate(e.element.id+i[n].uid+"headerTemplate","HeaderTemplate"),i[n].filterTemplate&&t.resetBlazorTemplate(e.element.id+i[n].uid+"filterTemplate","FilterTemplate");for(var o=0;o<e.aggregates.length;o++)for(var s=0;s<e.aggregates[o].columns.length;s++){if(e.aggregates[o].columns[s].footerTemplate){var l=e.element.id+e.aggregates[o].columns[s].guid+"footerTemplate";t.resetBlazorTemplate(l,"FooterTemplate")}if(e.aggregates[o].columns[s].groupFooterTemplate){l=e.element.id+e.aggregates[o].columns[s].guid+"groupFooterTemplate";t.resetBlazorTemplate(l,"GroupFooterTemplate")}if(e.aggregates[o].columns[s].groupCaptionTemplate){l=e.element.id+e.aggregates[o].columns[s].guid+"groupCaptionTemplate";t.resetBlazorTemplate(l,"GroupCaptionTemplate")}}},r.prototype.refreshComplete=function(e){this.parent.trigger(Dt,e)},r.prototype.refreshDataManager=function(e){var t=this;void 0===e&&(e={}),"virtualscroll"===e.requestType||e.isCaptionCollapse||this.parent.showSpinner(),this.parent.notify(Mn,e),this.emptyGrid=!1;var r,n=this.isNeedForeignAction();if(this.ariaService.setBusy(this.parent.getContent().querySelector("."+es),!0),n){var o=new i.Deferred;r=this.getFData(o,e)}if(r=r?r.then(function(r){var n=t.data.generateQuery().requiresCount();if(t.emptyGrid){var o=new i.Deferred;return o.resolve({result:[],count:0}),o.promise}return t.data.getData(e,n)}):this.data.getData(e,this.data.generateQuery().requiresCount()),this.parent.getForeignKeyColumns().length&&(!n||this.parent.searchSettings.key.length)){var s=new i.Deferred;r=r.then(function(i){return t.parent.notify(Pr,{dataManager:r,result:i,promise:s,action:e}),s.promise})}this.parent.groupSettings.disablePageWiseAggregates&&this.parent.groupSettings.columns.length&&(r=r.then(function(e){return t.validateGroupRecords(e)})),r.then(function(i){return t.dataManagerSuccess(i,e)}).catch(function(i){return t.dataManagerFailure(i,e)})},r.prototype.getFData=function(e,t){return this.parent.notify(Pr,{isComplex:!0,promise:e,action:t}),e.promise},r.prototype.isNeedForeignAction=function(){var e=this.parent;return!!(e.allowFiltering&&e.filterSettings.columns.length||e.searchSettings.key.length)&&this.foreignKey(this.parent.getForeignKeyColumns())},r.prototype.foreignKey=function(e){var t=this;return e.some(function(e){return!(!t.parent.filterSettings.columns.some(function(t){return e.uid===t.uid})&&!t.parent.searchSettings.key.length)})},r.prototype.sendBulkRequest=function(e){var t=this;e.requestType="batchsave";var i=this.data.saveChanges(e.changes,this.parent.getPrimaryKeyFieldNames()[0],e.original),r=this.data.generateQuery().requiresCount();this.data.dataManager.dataSource.offline?this.refreshDataManager({requestType:"batchsave"}):i.then(function(i){t.data.getData(e,r).then(function(i){return t.dmSuccess(i,e)}).catch(function(i){return t.dmFailure(i,e)})}).catch(function(i){return t.dmFailure(i,e)})},r.prototype.dmSuccess=function(e,t){this.dataManagerSuccess(e,t)},r.prototype.dmFailure=function(e,t){this.dataManagerFailure(e,t)},r.prototype.renderEmptyRow=function(){this.emptyRow(!0)},r.prototype.emptyRow=function(e){var i=this.parent,r=this.contentRenderer.getTable().querySelector(gs);t.isNullOrUndefined(r)||t.remove(r),r=this.parent.createElement(gs);var n=0;(i.detailTemplate||i.childGrid)&&++n;var o=this.parent.createElement("tr",{className:"e-emptyrow"});o.appendChild(this.parent.createElement("td",{innerHTML:this.l10n.getConstant("EmptyRecord"),attrs:{colspan:(i.getVisibleColumns().length+n+i.groupSettings.columns.length).toString()}})),r.appendChild(o),this.contentRenderer.renderEmpty(r),e&&(this.parent.trigger(Ot,{}),this.parent.notify(Ei,{rows:[new jo({isDataRow:!0,cells:[new Vo({isDataCell:!0,visible:!0})]})]}))},r.prototype.dynamicColumnChange=function(){this.parent.getCurrentViewRecords().length&&this.updateColumnType(this.parent.getCurrentViewRecords()[0])},r.prototype.updateColumnType=function(e){for(var i,r=this.parent.getColumns(),n=e&&e.items?e.items[0]:e,o=this.locator.getService("valueFormatter"),s=0,l=r.length;s<l;s++){i=he(r[s].field||"",n),t.isNullOrUndefined(r[s].customFormat)||(r[s].format=r[s].customFormat),t.isNullOrUndefined(r[s].validationRules)||t.isNullOrUndefined(r[s].validationRules.equalTo)||(r[s].validationRules.equalTo[0]=this.parent.element.id+r[s].validationRules.equalTo[0]),r[s].isForeignColumn()&&r[s].columnData&&(i=he(r[s].foreignKeyValue||"",r[s].columnData[0])),t.isNullOrUndefined(i)?r[s].type=r[s].type||null:(this.isColTypeDef=!0,r[s].type||(r[s].type=i.getDay?i.getHours()>0||i.getMinutes()>0||i.getSeconds()>0||i.getMilliseconds()>0?"datetime":"date":typeof i));var a=new Ct;r[s].format&&(r[s].format.skeleton||r[s].format.format&&"string"==typeof r[s].format.format)&&(r[s].setFormatter(a.getFormatFunction(t.extend({},r[s].format))),r[s].setParser(a.getParserFunction(r[s].format))),"string"==typeof r[s].format?Q(this.locator,r[s]):r[s].format||"number"!==r[s].type||r[s].setParser(o.getParserFunction({format:"n2"}))}},r.prototype.dataManagerSuccess=function(i,r){var n=this,o=this.parent;this.contentRenderer=this.renderer.getRenderer(e.RenderType.Content),this.headerRenderer=this.renderer.getRenderer(e.RenderType.Header),i.actionArgs=r;var s=this.parent.enableInfiniteScrolling&&!this.parent.infiniteScrollSettings.enableCache&&("delete"===r.requestType||"save"===r.requestType&&"add"===this.parent.infiniteScrollModule.requestType);o.trigger(ai,i,function(e){if(!e.cancel){e.result=t.isNullOrUndefined(e.result)?[]:e.result;var l=Object.keys(e.result).length;if(!n.parent.isDestroyed)if(o.getColumns().length||l||o.columns.length&&o.columns[0]instanceof St)if(!n.isInfiniteEnd(r)||l){if(n.parent.isEdit=!1,n.parent.notify(In,{}),n.parent.notify(hr,{}),n.contentRenderer.prevCurrentView=n.parent.currentViewData.slice(),o.currentViewData=e.result,o.notify(ho,{args:r,data:e.result}),!l&&e.count&&o.allowPaging&&r&&"delete"!==r.requestType)return!n.parent.groupSettings.enableLazyLoading||"grouping"!==r.requestType&&"ungrouping"!==r.requestType||n.parent.notify(Pi,r),o.prevPageMoving=!0,o.pageSettings.totalRecordsCount=e.count,"paging"!==r.requestType&&(o.pageSettings.currentPage=Math.ceil(e.count/o.pageSettings.pageSize)),void o.dataBind();if((o.getColumns().length||!l)&&n.isLayoutRendered||ae(o)||n.updatesOnInitialRender(e),!n.isColTypeDef&&o.getCurrentViewRecords()&&(n.data.dataManager.dataSource.offline&&o.dataSource&&o.dataSource.length?n.updateColumnType(o.dataSource[0]):n.updateColumnType(o.getCurrentViewRecords()[0])),n.parent.isInitialLoad||!n.parent.groupSettings.disablePageWiseAggregates||n.parent.groupSettings.columns.length||(e.result=n.parent.dataSource instanceof Array?n.parent.dataSource:n.parent.currentViewData),!n.parent.isReact&&!n.parent.isVue||t.isNullOrUndefined(r)||"infiniteScroll"===r.requestType||r.isFrozen||Je(n.parent,["footerTemplate"]),n.parent.notify(Ri,t.extend({count:e.count,result:e.result,aggregates:e.aggregates},r)),(o.groupSettings.columns.length||r&&"ungrouping"===r.requestType)&&r&&"filtering"!==r.requestType&&n.headerRenderer.refreshUI(),l){if(ae(o)){r.scrollTop={top:n.contentRenderer.content.scrollTop}}s?n.parent.notify(Ln,{e:r,result:i.result,count:i.count,agg:i.aggregates}):n.parent.enableImmutableMode?n.contentRenderer.immutableModeRendering(r):n.contentRenderer.refreshContentRows(r)}else{if(r&&r.isCaptionCollapse)return;if(!o.getColumns().length)return o.element.innerHTML="",void alert(n.l10n.getConstant("EmptyDataSourceError"));if(n.contentRenderer.setRowElements([]),n.contentRenderer.setRowObjects([]),n.ariaService.setBusy(n.parent.getContent().querySelector("."+es),!1),n.renderEmptyRow(),r){var a=(r.requestType||"").toLowerCase()+"-complete";n.parent.notify(a,r),"batchsave"===r.requestType&&(r.cancel=!1,r.rows=[],r.isFrozen=0!==n.parent.getFrozenColumns()&&!r.isFrozen,n.parent.trigger(Dt,r))}n.parent.hideSpinner()}n.parent.notify(sr,{}),n.setRowCount(n.parent.getCurrentViewRecords().length),n.parent.getDataModule().isQueryInvokedFromData=!1}else n.parent.notify(Ln,{e:r,result:i.result,count:i.count,agg:i.aggregates});else o.hideSpinner()}})},r.prototype.dataManagerFailure=function(e,t){this.ariaService.setOptions(this.parent.getContent().querySelector("."+es),{busy:!1,invalid:!0}),this.setRowCount(1),this.parent.trigger(Mt,{error:e}),this.parent.hideSpinner(),"save"!==t.requestType&&"delete"!==t.requestType&&"bulk-save"!==t.name&&(this.parent.currentViewData=[],this.renderEmptyRow(),this.parent.log("actionfailure",{error:e}))},r.prototype.setRowCount=function(e){this.ariaService.setOptions(this.parent.getHeaderTable(),{rowcount:e?e.toString():"1"})},r.prototype.isInfiniteEnd=function(e){return this.parent.enableInfiniteScrolling&&!this.parent.infiniteScrollSettings.enableCache&&"delete"===e.requestType},r.prototype.updatesOnInitialRender=function(e){this.isLayoutRendered=!0,this.parent.columns.length<1&&this.buildColumns(e.result[0]),I(this.parent.columns,null,this.parent),this.headerRenderer.renderTable(),this.contentRenderer.renderTable(),this.parent.isAutoGen=!0,this.parent.notify(ar,{})},r.prototype.iterateComplexColumns=function(e,t,i){for(var r=Object.keys(e),n=0;n<r.length;n++){("object"!=typeof e[r[n]]||!e[r[n]]||e[r[n]]instanceof Date?[]:Object.keys(e[r[n]])).length?this.iterateComplexColumns(e[r[n]],t+(r[n]+"."),i):(i[this.counter]=t+r[n],this.counter++)}},r.prototype.buildColumns=function(e){var i=[],r={};this.iterateComplexColumns(e,"",r);for(var n=Object.keys(r).filter(function(e){return"BlazId"!==r[e]}).map(function(e){return r[e]}),o=0,s=n.length;o<s;o++)i[o]={field:n[o]},this.parent.enableColumnVirtualization&&(i[o].width=t.isNullOrUndefined(i[o].width)?200:i[o].width);this.parent.setProperties({columns:i},!0)},r.prototype.instantiateRenderer=function(){this.renderer.addRenderer(e.RenderType.Header,new As(this.parent,this.locator)),this.renderer.addRenderer(e.RenderType.Content,new ks(this.parent,this.locator));var t=this.locator.getService("cellRendererFactory");t.addCellRenderer(e.CellType.Header,new qs(this.parent,this.locator)),t.addCellRenderer(e.CellType.Data,new Bs(this.parent,this.locator)),t.addCellRenderer(e.CellType.StackedHeader,new Us(this.parent,this.locator)),t.addCellRenderer(e.CellType.Indent,new Vs(this.parent,this.locator)),t.addCellRenderer(e.CellType.GroupCaption,new _s(this.parent,this.locator)),t.addCellRenderer(e.CellType.GroupCaptionEmpty,new Ws(this.parent,this.locator)),t.addCellRenderer(e.CellType.Expand,new Qs(this.parent,this.locator)),t.addCellRenderer(e.CellType.HeaderIndent,new Ys(this.parent,this.locator)),t.addCellRenderer(e.CellType.StackedHeader,new Us(this.parent,this.locator)),t.addCellRenderer(e.CellType.DetailHeader,new Zs(this.parent,this.locator)),t.addCellRenderer(e.CellType.RowDragHIcon,new nl(this.parent,this.locator)),t.addCellRenderer(e.CellType.DetailExpand,new el(this.parent,this.locator)),t.addCellRenderer(e.CellType.DetailFooterIntent,new Vs(this.parent,this.locator)),t.addCellRenderer(e.CellType.RowDragIcon,new il(this.parent,this.locator))},r.prototype.addEventListener=function(){var e=this;this.parent.isDestroyed||(this.parent.on(bi,this.instantiateRenderer,this),this.parent.on("refreshdataSource",this.dataManagerSuccess,this),this.parent.on(Ti,this.refresh,this),this.parent.on(rr,this.refreshComplete,this),this.parent.on(lr,this.sendBulkRequest,this),this.parent.on(qr,function(){e.emptyGrid=!0},this),this.parent.on(ar,this.dynamicColumnChange,this))},r.prototype.validateGroupRecords=function(e){var t=this,r=e.result.length-1;if(r<0)return Promise.resolve(e);var n=e.result[0],o=e.result[r],s=[],l=function(e){for(var r=[n,o],l=0;l<r.length;l++)s.push(new i.Predicate("field","==",r[l].field).and(t.getPredicate("key","equal",r[l].key)));e.where(i.Predicate.or(s))},a=new i.Query;l(a);var h=new i.DataManager(e.result).executeLocal(a),d=this.data.generateQuery(!0),p=[];if(this.data.isRemote()){for(var c=[n,o],u=0;u<c.length;u++)p.push(this.getPredicate(c[u].field,"equal",c[u].key));d.where(i.Predicate.or(p))}else l(d);var g=new i.Deferred;return this.data.getData({},d).then(function(i){t.updateGroupInfo(h,i.result),g.resolve(e)}).catch(function(e){return g.reject(e)}),g.promise},r.prototype.getPredicate=function(e,t,r){return r instanceof Date?se({field:e,operator:t,value:r}):new i.Predicate(e,t,r)},r.prototype.updateGroupInfo=function(e,r){for(var n=new i.DataManager(r),o=e,s=0;s<o.length;s++){var l=n.executeLocal((new i.Query).where(new i.Predicate("field","==",o[s].field).and(this.getPredicate("key","equal",o[s].key))))[0];o[s].count=l.count;var a=o[s].items,h=l.items;a.GroupGuid&&(o[s].items=this.updateGroupInfo(o[s].items,l.items));for(var d=this.parent.aggregates,p=0;p<d.length;p++)for(var c=d[p],u=0;u<c.columns.length;u++)for(var g=c.columns[u].type instanceof Array?c.columns[u].type:[c.columns[u].type],f=0;f<g.length;f++){var m=c.columns[u].field+" - "+g[f].toLowerCase(),y=a.level?h.records:l.items,v=this.parent;if("Custom"===g[f]){var C=a.level?h:l,w=c.columns[u].customAggregate;"string"==typeof w&&(w=t.getValue(w,window)),o[s].aggregates[m]=w?w.call(v,C,c.columns[u]):""}else o[s].aggregates[m]=i.DataUtil.aggregates[g[f].toLowerCase()](y,c.columns[u].field)}}return e},r}(),sl=function(){function i(){this.cellRenderMap={}}return i.prototype.addCellRenderer=function(i,r){i="string"==typeof i?i:t.getEnumValue(e.CellType,i),t.isNullOrUndefined(this.cellRenderMap[i])&&(this.cellRenderMap[i]=r)},i.prototype.getCellRenderer=function(i){if(i="string"==typeof i?i:t.getEnumValue(e.CellType,i),t.isNullOrUndefined(this.cellRenderMap[i]))throw"The cellRenderer "+i+" is not found";return this.cellRenderMap[i]},i}(),ll=function(){function i(e,t){this.sortedCols=[],this.sortPredicate=[],this.isCustomDialog=!1,this.parent=e,this.serviceLocator=t,this.addEventListener()}return i.prototype.addEventListener=function(){this.evtHandlers=[{event:co,handler:this.closeCustomDialog},{event:uo,handler:this.refreshCustomFilterOkBtn},{event:fo,handler:this.renderResponsiveContextMenu},{event:mo,handler:this.renderCustomFilterDiv},{event:yo,handler:this.customExFilterClose},{event:go,handler:this.refreshCustomFilterClearBtn}],_e(this.parent,this.evtHandlers,!0,this),this.onActionCompleteFn=this.editComplate.bind(this),this.parent.addEventListener(Dt,this.onActionCompleteFn)},i.prototype.customExFilterClose=function(){this.isCustomDlgRender=!1},i.prototype.renderCustomFilterDiv=function(){var e=this.customResponsiveDlg.element.querySelector(".e-dlg-header-content"),t=e.querySelector(".e-dlg-custom-header"),i=e.querySelector(".e-dlg-closeicon-btn");this.isCustomDlgRender=!0,this.parent.filterModule.filterModule.closeDialog(),this.saveBtn.element.style.display="",this.refreshCustomFilterOkBtn({disabled:!1}),this.backBtn.element.style.display="none",i.style.display="",t.innerHTML=this.parent.localeObj.getConstant("CustomFilter");var r=this.customResponsiveDlg.element.querySelector(".e-dlg-content");this.customExcelFilterParent=this.parent.createElement("div",{className:"e-xl-customfilterdiv e-default-filter"}),r.appendChild(this.customExcelFilterParent)},i.prototype.renderResponsiveContextMenu=function(i){if(this.action===e.ResponsiveDialogAction.isFilter){var r=this.customResponsiveDlg.element.querySelector(".e-dlg-content"),o=this.customResponsiveDlg.element.querySelector(".e-dlg-header-content"),s=o.querySelector(".e-dlg-closeicon-btn"),l=o.querySelector(".e-dlg-custom-header");if(i.isOpen){r.firstChild.style.display="none",r.appendChild(i.target),s.style.display="none",this.saveBtn.element.style.display="none",this.filterClearBtn.element.style.display="none",l.innerHTML=i.header;var a=this.parent.createElement("button"),h=this.parent.createElement("span",{className:"e-btn-icon e-resfilterback e-icons"});a.appendChild(h),this.backBtn=new n.Button({cssClass:"e-res-back-btn"}),this.backBtn.appendTo(a),l.parentElement.insertBefore(a,l)}else this.backBtn&&!this.isCustomDlgRender&&(r.firstChild.style.display="",t.remove(this.backBtn.element),s.style.display="",this.saveBtn.element.style.display="",this.isFiltered&&(this.filterClearBtn.element.style.display=""),l.innerHTML=this.getHeaderTitle({action:e.ResponsiveDialogAction.isFilter},i.col))}},i.prototype.refreshCustomFilterClearBtn=function(e){this.filterClearBtn&&(this.isFiltered=e.isFiltered,this.filterClearBtn.element.style.display=e.isFiltered?"":"none")},i.prototype.refreshCustomFilterOkBtn=function(e){this.saveBtn&&(this.saveBtn.disabled=e.disabled)},i.prototype.renderResponsiveContent=function(i){var r=this,o=this.parent;if(i)return this.filterParent=this.parent.createElement("div",{className:"e-mainfilterdiv e-default-filter",id:i.uid+"-main-filter"}),this.filterParent;var s=o.getColumns();this.customColumnDiv=o.createElement("div",{className:"columndiv",styles:"width: 100%"});var l=o.createElement("div",{className:"e-ressortbutton-parent"}),a=[],h=this.action===e.ResponsiveDialogAction.isSort,d=this.action===e.ResponsiveDialogAction.isFilter;if(d)for(var p=0;p<o.filterSettings.columns.length;p++)a.push(o.filterSettings.columns[p].field);for(p=0;p<s.length;p++)if(!(!s[p].visible||!s[p].allowSorting&&h||!s[p].allowFiltering&&d)){var c=o.createElement("div",{className:"e-responsivecoldiv"});c.setAttribute("data-e-mappingname",s[p].field),c.setAttribute("data-e-mappinguid",s[p].uid);var u=o.createElement("span",{innerHTML:s[p].headerText,className:"e-res-header-text"});if(c.appendChild(u),this.customColumnDiv.appendChild(c),h){var g=this.getSortedFieldsAndDirections("field").indexOf(s[p].field),f=o.createElement("button",{id:o.element.id+s[p].field+"sortbutton"}),m=l.cloneNode();m.appendChild(f),c.appendChild(m);new n.Button({cssClass:"e-ressortbutton"}).appendTo(f),f.innerHTML=g>-1?this.parent.sortSettings.columns[g].direction:"None",f.onclick=function(e){r.sortButtonClickHandler(e.target)}}if(d&&a.indexOf(s[p].field)>-1){var y=o.createElement("div",{className:"e-icons e-res-icon e-filtersetdiv"}),v=o.createElement("span",{className:"e-icons e-res-icon e-filterset"});v.setAttribute("colType",s[p].type),y.appendChild(v),c.appendChild(y)}}return t.EventHandler.add(this.customColumnDiv,"click",this.customFilterColumnClickHandler,this),this.customColumnDiv},i.prototype.getSortedFieldsAndDirections=function(e){for(var t=[],i=0;i<this.parent.sortSettings.columns.length;i++)t.push(this.parent.sortSettings.columns[i][e]);return t},i.prototype.sortButtonClickHandler=function(e){if(e){var t=D(e,"e-responsivecoldiv").getAttribute("data-e-mappingname");this.parent.allowMultiSorting||(this.sortPredicate=[],this.sortedCols=[],this.isSortApplied=!1,this.resetSortButtons(e));var i=e.textContent,r="None"===i?"Ascending":"Ascending"===i?"Descending":"None";e.innerHTML=r,this.setSortedCols(t,r)}},i.prototype.resetSortButtons=function(e){for(var t=[].slice.call(this.customColumnDiv.getElementsByClassName("e-ressortbutton")),i=0;i<t.length;i++)t[i]!==e&&(t[i].innerHTML="None")},i.prototype.setSortedCols=function(e,t){var i=this.getCurrentSortedFields().indexOf(e);this.parent.allowMultiSorting&&i>-1&&(this.sortedCols.splice(i,1),this.sortPredicate.splice(i,1)),this.isSortApplied=!0,"None"!==t&&(this.sortedCols.push(e),this.sortPredicate.push({field:e,direction:t}))},i.prototype.getCurrentSortedFields=function(){for(var e=[],t=0;t<this.sortedCols.length;t++)e.push(this.sortedCols[t]);return e},i.prototype.customFilterColumnClickHandler=function(t){if(this.action===e.ResponsiveDialogAction.isFilter){var i=this.parent,r=t.target;if("FilterBar"!==i.filterSettings.type)if(r.classList.contains("e-responsivecoldiv")||r.parentElement.classList.contains("e-responsivecoldiv")){if((s=r.getAttribute("data-e-mappingname"))||(s=r.parentElement.getAttribute("data-e-mappingname")),s){var n=i.getColumnByField(s);this.isRowResponsive=!0,this.showResponsiveDialog(n)}}else if(r.classList.contains("e-filterset")||r.parentElement.classList.contains("e-filtersetdiv")){var o=D(r,"e-responsivecoldiv");if(o){var s=o.getAttribute("data-e-mappingname");("Menu"===(n=i.getColumnByField(s)).filter.type||!n.filter.type&&"Menu"===i.filterSettings.type)&&(this.isDialogClose=!0),this.parent.filterModule.filterModule.clearCustomFilter(n),this.removeCustomDlgFilterEle(r)}}}},i.prototype.showResponsiveDialog=function(t){if(this.isCustomDialog&&this.action===e.ResponsiveDialogAction.isFilter&&!this.isRowResponsive)this.renderCustomFilterDialog();else{if(this.filteredCol=t,this.renderResponsiveDialog(t),this.parent.enableAdaptiveUI&&t&&(this.parent.filterModule.setFilterModel(t),this.parent.filterModule.filterModule.openDialog(this.parent.filterModule.createOptions(t,void 0))),this.action===e.ResponsiveDialogAction.isSort){var i={cancel:!1,dialogObj:this.customResponsiveDlg,requestType:"beforeOpenAptiveSortDialog"};if(this.parent.trigger(di,i),i.cancel)return}this.customResponsiveDlg.show(!0),this.customResponsiveDlg.element.style.maxHeight="100%",this.setTopToChildDialog(this.customResponsiveDlg.element)}},i.prototype.setTopToChildDialog=function(e){var t=e.querySelector(".e-dialog");if(t){var i=e.querySelector(".e-dlg-header-content").getBoundingClientRect().height;t.style.top=i+"px"}},i.prototype.renderCustomFilterDialog=function(t){var i=this.parent;if(this.action!==e.ResponsiveDialogAction.isFilter||"FilterBar"!==i.filterSettings.type){var r=this.parent.createElement("div",{id:i.element.id+"customfilter",className:"e-customfilterdiv e-responsive-dialog"});this.parent.element.appendChild(r),this.customFilterDlg=this.getDialogOptions(t,!0);var n={cancel:!1,dialogObj:this.customFilterDlg,requestType:"beforeOpenAptiveFilterDialog"};this.parent.trigger(di,n),n.cancel||(this.customFilterDlg.appendTo(r),this.customFilterDlg.show(!0),this.customFilterDlg.element.style.maxHeight="100%")}},i.prototype.getDialogOptions=function(t,i,n){var o=new r.Dialog({isModal:!0,showCloseIcon:!0,closeOnEscape:!1,locale:this.parent.locale,target:this.parent.adaptiveDlgTarget?this.parent.adaptiveDlgTarget:document.body,visible:!1,enableRtl:this.parent.enableRtl,content:this.renderResponsiveContent(t),open:this.dialogOpen.bind(this),created:this.dialogCreated.bind(this),close:this.beforeDialogClose.bind(this),width:"100%",height:"100%",animationSettings:{effect:"None"}});return o.isStringTemplate=!0,i?(o.header=this.renderResponsiveHeader(t,void 0,!0),o.cssClass="e-customfilter"):(o.header=this.renderResponsiveHeader(t),o.cssClass="Vertical"===this.parent.rowRenderingMode&&this.action===e.ResponsiveDialogAction.isFilter?"e-res"+n+" e-row-responsive-filter":"e-res"+n),o},i.prototype.renderResponsiveDialog=function(t){var i=this.parent;if(this.action!==e.ResponsiveDialogAction.isFilter||"FilterBar"!==i.filterSettings.type){var r=this.action===e.ResponsiveDialogAction.isFilter?"filter":"sort",n=this.parent.createElement("div",{id:i.element.id+"responsive"+r,className:"e-res"+r+"div e-responsive-dialog"});this.parent.element.appendChild(n),this.customResponsiveDlg=this.getDialogOptions(t,!1,r),this.customResponsiveDlg.appendTo(n)}},i.prototype.dialogCreated=function(){je(this.parent)},i.prototype.dialogOpen=function(){if(this.action===e.ResponsiveDialogAction.isSort&&this.parent.allowMultiSorting)for(var t=0;t<this.parent.sortSettings.columns.length;t++){this.sortedCols.push(this.parent.sortSettings.columns[t].field);var i=this.parent.sortSettings.columns[t].field,r=this.parent.sortSettings.columns[t].direction;this.sortPredicate.push({field:i,direction:r})}},i.prototype.beforeDialogClose=function(t){this.isDialogClose=t.element&&!t.element.querySelector(".e-xl-customfilterdiv")&&t.element.classList.contains("e-resfilterdiv"),this.action===e.ResponsiveDialogAction.isFilter?t.element.classList.contains("e-resfilterdiv")?this.parent.filterModule.filterModule.closeResponsiveDialog(this.isCustomDlgRender):t.element.classList.contains("e-customfilterdiv")&&this.closeCustomFilter():this.action===e.ResponsiveDialogAction.isSort&&this.closeCustomDialog(),this.parent.off(bo,this.keyHandler)},i.prototype.sortColumn=function(){if(this.isSortApplied){this.sortPredicate.length&&this.parent.setProperties({sortSettings:{columns:[]}},!0);for(var e=0;e<this.sortPredicate.length;e++)this.parent.sortColumn(this.sortPredicate[e].field,this.sortPredicate[e].direction,this.parent.allowMultiSorting);this.sortPredicate.length||this.parent.clearSorting(),this.closeCustomDialog()}else this.closeCustomDialog()},i.prototype.getHeaderTitle=function(t,i){var r,n=this.parent;return this.action===e.ResponsiveDialogAction.isEdit?r=n.localeObj.getConstant("EditFormTitle")+t.primaryKeyValue[0]:this.action===e.ResponsiveDialogAction.isAdd?r=n.localeObj.getConstant("AddFormTitle"):this.action===e.ResponsiveDialogAction.isFilter?r=i?i.headerText||i.field:n.localeObj.getConstant("FilterButton"):this.action===e.ResponsiveDialogAction.isSort&&(r=n.localeObj.getConstant("Sort")),r},i.prototype.getDialogName=function(t){var i;return t===e.ResponsiveDialogAction.isAdd||t===e.ResponsiveDialogAction.isEdit?i="dialogEdit_wrapper_title":t===e.ResponsiveDialogAction.isFilter&&(i="responsive_filter_dialog_wrapper"),i},i.prototype.getButtonText=function(t){var i;return t===e.ResponsiveDialogAction.isAdd||t===e.ResponsiveDialogAction.isEdit?i="Save":t!==e.ResponsiveDialogAction.isFilter&&this.action!==e.ResponsiveDialogAction.isSort||(i="OKButton"),i},i.prototype.renderResponsiveHeader=function(t,i,r){var o=this,s=this.parent;s.on(bo,this.keyHandler,this);var l=s.element.id+this.getDialogName(this.action),a=s.createElement("div",{className:"e-res-custom-element"}),h=s.createElement("div",{className:"e-dlg-custom-header",id:l});h.innerHTML=this.getHeaderTitle(i,t),a.appendChild(h);var d=s.createElement("button");r||(this.saveBtn=new n.Button({cssClass:"e-primary e-flat e-res-apply-btn"}),d.innerHTML=s.localeObj.getConstant(this.getButtonText(this.action)),this.saveBtn.appendTo(d),d.onclick=function(e){o.dialogHdrBtnClickHandler()});var p=this.action===e.ResponsiveDialogAction.isSort,c=this.action===e.ResponsiveDialogAction.isFilter;if(c||p){var u=p?"sort":"filter",g=s.createElement("button");if(this.filterClearBtn=new n.Button({cssClass:"e-primary e-flat e-res-"+u+"-clear-btn"}),c){var f=s.createElement("span",{className:"e-btn-icon e-icon-filter-clear e-icons"});g.appendChild(f)}else g.innerHTML=s.localeObj.getConstant("Clear");a.appendChild(g),this.filterClearBtn.appendTo(g),g.onclick=function(e){D(e.target,"e-customfilter")?(o.parent.filterModule.clearFiltering(),o.removeCustomDlgFilterEle()):c?o.filterClear():(o.resetSortButtons(),o.sortedCols=[],o.sortPredicate=[],o.isSortApplied=!0)},a.appendChild(g)}return r||a.appendChild(d),a},i.prototype.filterClear=function(){this.parent.filterModule.filterModule.clearCustomFilter(this.filteredCol),this.parent.filterModule.filterModule.closeResponsiveDialog()},i.prototype.dialogHdrBtnClickHandler=function(){this.action===e.ResponsiveDialogAction.isEdit||this.action===e.ResponsiveDialogAction.isAdd?this.parent.endEdit():this.action===e.ResponsiveDialogAction.isFilter?this.parent.filterModule.filterModule.applyCustomFilter({col:this.filteredCol,isCustomFilter:this.isCustomDlgRender}):this.action===e.ResponsiveDialogAction.isSort&&this.sortColumn()},i.prototype.closeCustomDialog=function(){if(this.isCustomDlgRender){var e=this.customResponsiveDlg.element.querySelector(".e-mainfilterdiv");t.remove(e)}else this.isRowResponsive=!1,this.isCustomDlgRender=!1,this.destroyCustomFilterDialog()},i.prototype.destroyCustomFilterDialog=function(){if(this.customResponsiveDlg){var i=document.getElementById(this.customResponsiveDlg.element.id);this.customResponsiveDlg&&!this.customResponsiveDlg.isDestroyed&&i&&(this.customResponsiveDlg.destroy(),t.remove(i)),this.closeCustomFilter(),this.action===e.ResponsiveDialogAction.isSort&&(this.sortPredicate=[],this.sortedCols=[],this.isSortApplied=!1)}},i.prototype.closeCustomFilter=function(){if(!this.isDialogClose&&this.customFilterDlg){var e=document.getElementById(this.customFilterDlg.element.id);this.customFilterDlg&&!this.customFilterDlg.isDestroyed&&e&&(this.customFilterDlg.destroy(),t.remove(e))}this.isCustomDialog=!1,this.isDialogClose=!1},i.prototype.removeCustomDlgFilterEle=function(e){if(e)e.parentElement.classList.contains("e-filtersetdiv")?t.remove(e.parentElement):t.remove(e);else for(var i=this.customColumnDiv.children,r=0;r<i.length;r++)(e=i[r].querySelector(".e-filtersetdiv"))&&(t.remove(e),r--)},i.prototype.keyHandler=function(t){13===t.keyCode&&(this.action===e.ResponsiveDialogAction.isFilter&&t.target.classList.contains("e-searchinput")||this.action===e.ResponsiveDialogAction.isEdit||this.action===e.ResponsiveDialogAction.isAdd)&&this.dialogHdrBtnClickHandler()},i.prototype.editComplate=function(e){"save"!==e.requestType&&"cancel"!==e.requestType||this.parent.off(bo,this.keyHandler)},i.prototype.removeEventListener=function(){this.customColumnDiv&&t.EventHandler.remove(this.customColumnDiv,"click",this.customFilterColumnClickHandler),_e(this.parent,this.evtHandlers,!0,this),this.parent.removeEventListener(Dt,this.onActionCompleteFn)},i}(),al=function(){function e(){this.services={}}return e.prototype.register=function(e,i){t.isNullOrUndefined(this.services[e])&&(this.services[e]=i)},e.prototype.getService=function(e){if(t.isNullOrUndefined(this.services[e]))throw"The service "+e+" is not registered";return this.services[e]},e.prototype.registerAdaptiveService=function(e,t,i){t?(e.responsiveDialogRenderer=new ll(e.parent,e.serviceLocator),e.responsiveDialogRenderer.action=i):e.responsiveDialogRenderer&&(e.responsiveDialogRenderer.removeEventListener(),e.responsiveDialogRenderer=void 0)},e}(),hl=function(){function i(){this.rendererMap={}}return i.prototype.addRenderer=function(i,r){var n=t.getEnumValue(e.RenderType,i);t.isNullOrUndefined(this.rendererMap[n])&&(this.rendererMap[n]=r)},i.prototype.getRenderer=function(i){var r=t.getEnumValue(e.RenderType,i);if(t.isNullOrUndefined(this.rendererMap[r]))throw"The renderer "+r+" is not found";return this.rendererMap[r]},i}(),dl=function(){function e(e){this.parent=e}return e.prototype.setWidthToColumns=function(){var e=0,t=this.parent.getColumnIndexesInView(),i=!0,r=0;if(this.parent.allowGrouping)for(var n=this.parent.groupSettings.columns.length;e<n;e++)this.parent.enableColumnVirtualization&&-1===t.indexOf(e)?i=!1:this.setColumnWidth(new St({width:"30px"}),e);(this.parent.detailTemplate||this.parent.childGrid)&&(this.setColumnWidth(new St({width:"30px"}),e),e++),this.parent.isRowDragable()&&"Right"!==this.parent.getFrozenMode()&&(this.setColumnWidth(new St({width:"30px"}),e),e++);for(var o=this.parent.getColumns(),s=0;s<o.length;s++)this.setColumnWidth(o[s],i&&this.parent.enableColumnVirtualization?void 0:s+e);this.parent.isRowDragable()&&"Right"===this.parent.getFrozenMode()&&this.setColumnWidth(new St({width:"30px"}),o.length),r=this.getTableWidth(this.parent.getColumns()),"auto"!==this.parent.width&&-1===this.parent.width.toString().indexOf("%")&&this.setMinwidthBycalculation(r)},e.prototype.setMinwidthBycalculation=function(e){var i=0,r=this.parent.getColumns().filter(function(e){return t.isNullOrUndefined(e.width)||"auto"===e.width});if(r.length){i=t.isNullOrUndefined(this.parent.width)||"auto"===this.parent.width||"string"!=typeof this.parent.width||-1!==this.parent.width.indexOf("%")?this.parent.element.getBoundingClientRect().width-e:("string"==typeof this.parent.width?parseInt(this.parent.width,10):this.parent.width)-e;for(var n=0,o=0,s=r;o<s.length;o++){var l=s[o];n+=t.isNullOrUndefined(l.minWidth)?0:"string"==typeof l.minWidth?parseInt(l.minWidth,10):l.minWidth}for(var a=0;a<r.length;a++){0===e&&this.parent.allowResizing&&this.isWidthUndefined()&&a!==r.length-1&&this.setUndefinedColumnWidth(r);var h=this.parent.getColumnIndexByField(r[a].field)+this.parent.getIndentCount();0!==e&&i<n?this.setWidth(r[a].minWidth,h):0!==e&&i>n&&this.setWidth("",h,!0)}}},e.prototype.setUndefinedColumnWidth=function(e){for(var t=0;t<e.length;t++)t!==e.length-1&&(e[t].width=200,this.setWidth(200,this.parent.getColumnIndexByField(e[t].field)))},e.prototype.setColumnWidth=function(e,i,r){if(!(this.parent.getColumns().length<1)){var n=t.isNullOrUndefined(i)?this.parent.getNormalizedColumnIndex(e.uid):i,o=this.getWidth(e),s=this.getTableWidth(this.parent.getColumns());null!==o&&(this.setWidth(o,n),"auto"!==this.parent.width&&-1===this.parent.width.toString().indexOf("%")&&this.setMinwidthBycalculation(s),(this.parent.allowResizing&&"resize"===r||this.parent.getFrozenColumns()&&this.parent.allowResizing)&&this.setWidthToTable(),this.parent.notify(Yi,{index:n,width:o,column:e,module:r}))}},e.prototype.setWidth=function(e,i,r){if(this.parent.groupSettings.columns.length>i&&Ee(this.parent)){e=(30/this.parent.element.offsetWidth*100).toFixed(1)+"%"}var n,o=this.parent.getHeaderTable(),s=this.parent.getContentTable(),l=t.formatUnit(e),a=this.parent.getFrozenColumns(),h=this.parent.isRowDragable();a=a&&h?a+1:a;var d=this.parent.getHeaderContent().querySelector("."+Jo),p=this.parent.getContent().querySelector("."+Yo),c=this.parent.getFrozenLeftColumnsCount(),u=this.parent.getFrozenRightColumnsCount(),g=this.parent.getMovableColumnsCount(),f=0!==c||0!==u;if(a&&i>=a){if(!d||!d.querySelector(fs))return;n=d.querySelector(fs).children[i-a]}else if(this.parent.enableColumnVirtualization&&a&&this.parent.contentModule.isXaxis()&&d.scrollLeft>0){n=(C=d.querySelector(fs)).children[C.children.length-1-i]}else if(f){var m=void 0;if(c&&!u)m=(i=h?i-1:i)<c?o:d;else if(!c&&u)m=i>=g?o:d;else if(c&&u){i=h?i-1:i;var y=this.parent.getFrozenRightHeader();m=i<c?o:i<c+g?d:y}if(!(n=this.getColumnLevelFrozenColgroup(i,c,g,m)))return}else n=o.querySelector(fs).children[i];n&&!r?n.style.width=l:n&&r&&(n.style.width="");var v;if(a&&i>=a)v=this.parent.getContent().querySelector("."+Yo).querySelector(fs).children[i-a];else if(this.parent.enableColumnVirtualization&&a&&this.parent.contentModule.isXaxis()&&p.scrollLeft>0){var C;v=(C=this.parent.getContent().querySelector("."+Yo).querySelector(fs)).children[C.children.length-1-i]}else if(f){m=void 0;if(c&&!u&&(m=i<c?s:p),!c&&u&&(m=i>=g?s:p),c&&u){var w=this.parent.getContent().querySelector(".e-frozen-right-content");m=i<c?s:i<c+g?p:w}v=this.getColumnLevelFrozenColgroup(i,c,g,m)}else v=s.querySelector(fs).children[i];if(v&&!r?v.style.width=l:v&&r&&(v.style.width=""),!this.parent.enableColumnVirtualization){for(var b=this.parent.element.querySelectorAll(".e-table.e-inline-edit"),S=[],R=0;R<b.length;R++)if(D(b[R],"e-grid").id===this.parent.element.id)for(var x=0;x<b[R].querySelector("colgroup").children.length;x++)S.push(b[R].querySelector("colgroup").children[x]);b.length&&S.length&&(S[i].style.width=l)}this.parent.isFrozenGrid()&&this.refreshFrozenScrollbar()},e.prototype.getColumnLevelFrozenColgroup=function(e,t,i,r){if(!r||!r.querySelector(fs))return null;var n=this.parent.getColumns(),o=this.parent.isRowDragable(),s=this.parent.getFrozenMode(),l=[].slice.call(r.querySelector(fs).children);return"Right"===s&&o&&e===i+this.parent.getFrozenRightColumnsCount()?l[l.length-1]:o&&-1===e?l[0]:"Left"===n[e].freeze?l[o?e+1:e]:"Right"===n[e].freeze?l[e-(t+i)]:l[e-t]},e.prototype.refreshFrozenScrollbar=function(){var e={cancel:!1};if(this.parent.notify(lo,e),!e.cancel){var t=H(),i=this.parent.element.querySelector(".e-frozenscrollbar"),r=this.parent.element.querySelector(".e-movablescrollbar"),n=this.parent.getContent().querySelector("."+Zo),o=this.parent.getContent().querySelector("."+Yo),s=n.firstElementChild.getBoundingClientRect().width,l=o.firstElementChild.getBoundingClientRect().width;if("Right"===this.parent.getFrozenMode()&&(s+=t),i.style.width=s+"px",this.parent.getFrozenMode()===hs){var a=this.parent.element.querySelector(".e-frozen-right-scrollbar"),h=this.parent.getContent().querySelector(".e-frozen-right-content").firstElementChild.getBoundingClientRect().width;"auto"!==this.parent.height&&(h+=t),a.style.width=h+"px"}else{if(this.parent.enableColumnVirtualization){var d=this.parent.getMovableVirtualContent().querySelector(".e-virtualtrack");d&&(l=d.scrollWidth)}"Right"!==this.parent.getFrozenMode()&&"auto"!==this.parent.height&&(l+=t)}r.firstElementChild.style.width=l+"px"}},e.prototype.getSiblingsHeight=function(e){return this.getHeightFromDirection(e,"previous")+this.getHeightFromDirection(e,"next")},e.prototype.getHeightFromDirection=function(e,t){for(var i=e[t+"ElementSibling"],r=0,n=[Wo,Qo,"e-groupdroparea","e-gridpager","e-toolbar"];i;)n.some(function(e){return i.classList.contains(e)})&&(r+=i.offsetHeight),i=i[t+"ElementSibling"];return r},e.prototype.isWidthUndefined=function(){var e=this.parent.getColumns().filter(function(e){return t.isNullOrUndefined(e.width)&&t.isNullOrUndefined(e.minWidth)}).length;return this.parent.getColumns().length===e},e.prototype.getWidth=function(e){if(t.isNullOrUndefined(e.width)&&this.parent.allowResizing&&t.isNullOrUndefined(e.minWidth)&&!this.isWidthUndefined()&&(e.width=200),this.parent.isFrozenGrid()&&t.isNullOrUndefined(e.width)&&(e.getFreezeTableName()===ps||e.getFreezeTableName()===ds)&&(e.width=200),!e.width)return null;var i=parseInt(e.width.toString(),10);return e.minWidth&&i<parseInt(e.minWidth.toString(),10)?e.minWidth:e.maxWidth&&i>parseInt(e.maxWidth.toString(),10)?e.maxWidth:e.width},e.prototype.getTableWidth=function(e){for(var t=0,i=0,r=e;i<r.length;i++){var n=r[i],o=this.getWidth(n);"auto"===n.width&&(o=0),!1!==n.visible&&null!==o&&(t+=parseInt(o.toString(),10))}return t},e.prototype.calcMovableOrFreezeColWidth=function(e){var i=this.parent.getColumns().slice(),r=this.parent.getFrozenLeftColumnsCount()||this.parent.getFrozenColumns(),n=this.parent.getMovableColumnsCount(),o=this.parent.getFrozenRightColumnsCount();return"movable"===e?(o&&i.splice(r+n,i.length),r&&i.splice(0,r)):"freeze-left"===e?i.splice(r,i.length):"freeze-right"===e&&i.splice(0,r+n),t.formatUnit(this.getTableWidth(i))},e.prototype.setWidthToFrozenRightTable=function(){var e=this.calcMovableOrFreezeColWidth("freeze-right");e=this.isAutoResize()?"100%":e;var t=this.parent.getHeaderContent().querySelector(".e-frozen-right-header").querySelector("."+ts),i=this.parent.getContent().querySelector(".e-frozen-right-content").querySelector("."+ts);t.style.width=e,i.style.width=e},e.prototype.setWidthToFrozenLeftTable=function(){var e=this.calcMovableOrFreezeColWidth("freeze-left");e=this.isAutoResize()?"100%":e,this.parent.getHeaderTable().style.width=e,this.parent.getContentTable().style.width=e},e.prototype.setWidthToMovableTable=function(){var e="",i=this.parent.getColumns().filter(function(e){return t.isNullOrUndefined(e.width)}).length>=1,r=this.parent.getColumns().filter(function(e){return"auto"===e.width}).length>=1;"number"!=typeof this.parent.width||i||r?i||r||(e=this.calcMovableOrFreezeColWidth("movable")):e=t.formatUnit(this.parent.width-parseInt(this.calcMovableOrFreezeColWidth("freeze").split("px")[0],10)-5),e=this.isAutoResize()?"100%":e,this.parent.getHeaderContent().querySelector("."+Jo).firstElementChild&&(this.parent.getHeaderContent().querySelector("."+Jo).firstElementChild.style.width=e),this.parent.getContent().querySelector("."+Yo).firstElementChild.style.width=e},e.prototype.setWidthToFrozenEditTable=function(){var e=this.calcMovableOrFreezeColWidth("freeze");e=this.isAutoResize()?"100%":e,this.parent.element.querySelectorAll(".e-table.e-inline-edit")[0].style.width=e},e.prototype.setWidthToMovableEditTable=function(){var e=this.calcMovableOrFreezeColWidth("movable");e=this.isAutoResize()?"100%":e,this.parent.element.querySelectorAll(".e-table.e-inline-edit")[1].style.width=e},e.prototype.setWidthToTable=function(){var e=t.formatUnit(this.getTableWidth(this.parent.getColumns()));this.parent.isFrozenGrid()?((this.parent.getFrozenColumns()||this.parent.getFrozenLeftColumnsCount())&&this.setWidthToFrozenLeftTable(),this.setWidthToMovableTable(),this.parent.getFrozenRightColumnsCount()&&this.setWidthToFrozenRightTable()):((this.parent.detailTemplate||this.parent.childGrid)&&this.setColumnWidth(new St({width:"30px"})),e=this.isAutoResize()?"100%":e,this.parent.getHeaderTable().style.width=e,this.parent.getContentTable().style.width=e);var i=this.parent.element.querySelector(".e-table.e-inline-edit");i&&this.parent.getFrozenColumns()?(this.setWidthToFrozenEditTable(),this.setWidthToMovableEditTable()):i&&(i.style.width=e)},e.prototype.isAutoResize=function(){return this.parent.allowResizing&&"Auto"===this.parent.resizeSettings.mode},e}(),pl=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),cl=function(){function e(e){this.currentInfo={},this.oneTime=!0,this.swap={},this.isInfiniteScroll=!1,this.forget=!1,this.skipFocus=!0,this.focusByClick=!1,this.prevIndexes={},this.refMatrix=this.refreshMatrix(!0),this.actions=["downArrow","upArrow"],this.isVirtualScroll=!1,this.parent=e,this.rowModelGen=new Es(this.parent),this.addEventListener()}return e.prototype.focusCheck=function(e){var t=e.target;this.focusByClick=!0,this.skipFocus=t.classList.contains("e-grid")},e.prototype.onFocus=function(e){if(!(this.parent.isDestroyed||t.Browser.isDevice||this.parent.enableVirtualization)){this.setActive(!this.parent.enableHeaderFocus&&0===this.parent.frozenRows,this.parent.isFrozenGrid()),this.parent.enableHeaderFocus||this.parent.getCurrentViewRecords().length||"Batch"===this.parent.editSettings.mode&&("Batch"!==this.parent.editSettings.mode||this.parent.editModule.getBatchChanges()[ls].length)||this.getContent().matrix.generate(this.rowModelGen.generateRows({rows:[new jo({isDataRow:!0})]}),this.getContent().selector,!1);var i=this.getContent().matrix.get(0,-1,[0,1],null,this.getContent().validator());this.getContent().matrix.select(i[0],i[1]),this.skipFocus&&(this.focus(e),this.skipFocus=!1)}},e.prototype.passiveFocus=function(e){this.parent.isDestroyed||e.target&&e.target.classList.contains("e-detailcell")&&(this.currentInfo.skipAction=!1,t.addClass([this.currentInfo.element],["e-focused","e-focus"]))},e.prototype.onBlur=function(e){(!this.parent.isEdit&&(!e||e.relatedTarget&&!t.closest(e.relatedTarget,".e-grid"))||t.isNullOrUndefined(e.relatedTarget)&&0===parseInt(e.target.getAttribute("aria-colindex"),10)&&0===parseInt(e.target.getAttribute("index"),10))&&(this.removeFocus(),this.skipFocus=!0,this.currentInfo.skipAction=!1,this.parent.element.tabIndex=0)},e.prototype.onClick=function(e,i){if(!D(e.target,"e-filterbarcell")||!D(e.target,"e-multiselect")&&!e.target.classList.contains("e-input-group-icon")){var r=!t.isNullOrUndefined(t.closest(e.target,"."+Ko)),n=!t.isNullOrUndefined(t.closest(e.target,"."+Wo));r=r&&n?!r:r;var o=!t.isNullOrUndefined(t.closest(e.target,"."+Zo))||!t.isNullOrUndefined(t.closest(e.target,"."+$o)),s=!1;if(this.parent.getFrozenMode()===hs&&(s=!t.isNullOrUndefined(t.closest(e.target,".e-frozen-right-content"))||!t.isNullOrUndefined(t.closest(e.target,".e-frozen-right-header")),o=o&&!s),!(!r&&t.isNullOrUndefined(t.closest(e.target,"."+Wo))||e.target.classList.contains(es))&&t.isNullOrUndefined(t.closest(e.target,".e-unboundcell")))if(this.setActive(r,o,s),r||!t.isNullOrUndefined(t.closest(e.target,"."+Wo))){var l={cancel:!1,byKey:!1,byClick:!t.isNullOrUndefined(e.target),clickArgs:e};if(this.parent.notify(Vi,l),!l.cancel&&!t.closest(e.target,".e-inline-edit")&&(this.setActive(r,o,s),this.getContent())){if(!1===this.getContent().onClick(e,i))return;this.focus()}}else this.clearOutline()}},e.prototype.onKeyPress=function(e){if(!this.skipOn(e)){this.activeKey=e.action;var t={cancel:!1,byKey:!0,byClick:!1,keyArgs:e};if(this.parent.notify(Vi,t),!t.cancel){var i=this.getContent().matrix.current;this.currentInfo.outline=!0;var r=this.getContent().jump(e.action,i);this.swap=r,r.swap&&(this.setActive(!r.toHeader,r.toFrozen,r.toFrozenRight),this.getContent().matrix.current=this.getContent().getNextCurrent(i,r,this.active,e.action),this.prevIndexes={}),this.setActiveByKey(e.action,this.getContent());if(!1===(!this.content.lastIdxCell&&this.getContent().onKeyPress(e)))return this.clearIndicator(),void("shiftTab"===e.action&&i.toString()===[0,0].toString()&&(this.parent.element.tabIndex=-1));e.preventDefault(),this.focus(e)}}},e.prototype.skipOn=function(e){var i=e.target;if(!i)return!1;if(this.currentInfo.skipAction)return this.clearIndicator(),!0;if(["pageUp","pageDown","altDownArrow"].indexOf(e.action)>-1)return this.clearIndicator(),!0;var r=t.closest(i,"th")&&!t.closest(i,"th").tabIndex;if(e.target.classList.contains("e-filterbaroperator")&&(13===e.keyCode||27===e.keyCode)){t.closest(e.target,".e-filterbarcell").querySelector("input").focus()}r&&null!==t.closest(document.activeElement,".e-filterbarcell")&&this.removeFocus();var n=null!==t.closest(document.activeElement,".e-filterbarcell");if(this.parent.enableHeaderFocus&&n){var o=this.active.matrix,s=o.current;n=o.matrix[s[0]].lastIndexOf(1)!==s[1]}return"delete"===e.action||"Batch"!==this.parent.editSettings.mode&&(this.parent.isEdit||["insert","f2"].indexOf(e.action)>-1)||n||null!==t.closest(document.activeElement,"#"+this.parent.element.id+"_searchbar")&&["enter","leftArrow","rightArrow","shiftLeft","shiftRight","ctrlPlusA"].indexOf(e.action)>-1||null===t.closest(i,"."+Ko)&&null===t.closest(i,"."+Wo)||"space"===e.action&&!i.classList.contains(rs)&&null===t.closest(i,"."+rs)&&null===t.closest(i,".e-headerchkcelldiv")||null!==t.closest(i,".e-filter-popup")},e.prototype.focusVirtualElement=function(e){var t=this;if(this.parent.enableVirtualization||this.parent.enableInfiniteScrolling){var i={virtualData:{},isAdd:!1,isCancel:!1};this.parent.notify(zn,i);var r=this.actions.some(function(e){return e===t.activeKey}),n=!!this.parent.contentModule&&this.parent.contentModule.selectedRowIndex>-1;i.isAdd||Object.keys(i.virtualData).length||r||i.isCancel||n?(this.parent.notify(Io,{isCancel:!1}),i.isCancel=!1,this.parent.contentModule.selectedRowIndex=-1,r&&(this.activeKey=this.empty,this.parent.notify("virtaul-key-handler",e)),this.currentInfo.elementToFocus.focus({preventScroll:!0})):this.isVirtualScroll||this.isInfiniteScroll?this.currentInfo.elementToFocus.focus({preventScroll:!0}):this.currentInfo.elementToFocus.focus()}this.isVirtualScroll=this.isInfiniteScroll=!1},e.prototype.getFocusedElement=function(){return this.currentInfo.elementToFocus},e.prototype.getContent=function(){return this.active||this.content},e.prototype.setActive=function(e,t,i){this.active=e?t?this.fContent:i?this.frContent:this.content:t?this.fHeader:i?this.frHeader:this.header},e.prototype.setFocusedElement=function(e,i){var r=this;this.currentInfo.elementToFocus=e,setTimeout(function(){t.isNullOrUndefined(r.currentInfo.elementToFocus)||(r.parent.enableVirtualization||r.parent.enableInfiniteScrolling?r.focusVirtualElement(i):r.currentInfo.elementToFocus.focus())},0)},e.prototype.focus=function(e){this.parent.notify(bn,e),this.removeFocus(),this.addFocus(this.getContent().getFocusInfo(),e)},e.prototype.removeFocus=function(e){this.currentInfo.element&&(t.removeClass([this.currentInfo.element,this.currentInfo.elementToFocus],["e-focused","e-focus"]),this.currentInfo.element.tabIndex=-1)},e.prototype.addOutline=function(){var e=this.getContent().getFocusInfo();e.element&&(t.addClass([e.element],["e-focused"]),t.addClass([e.elementToFocus],["e-focus"]))},e.prototype.focusHeader=function(){this.setActive(!1,this.parent.isFrozenGrid()),this.resetFocus()},e.prototype.focusContent=function(){this.setActive(!0,this.parent.isFrozenGrid()),this.resetFocus()},e.prototype.resetFocus=function(){var e=this.getContent().matrix.get(0,-1,[0,1],null,this.getContent().validator());this.getContent().matrix.select(e[0],e[1]),this.focus()},e.prototype.addFocus=function(e,i){if(this.currentInfo=e,this.currentInfo.outline=e.outline&&!t.isNullOrUndefined(i),this.isInfiniteScroll&&(this.currentInfo.outline=!0),e.element){var r=e.elementToFocus.classList.contains("e-focus");if(!r){this.currentInfo.outline&&t.addClass([e.element],["e-focused"]),t.addClass([e.elementToFocus],["e-focus"]),e.element.tabIndex=0,r||this.setFocusedElement(e.elementToFocus,i),this.parent.notify(Gi,{element:e.elementToFocus,parent:e.element,indexes:this.getContent().matrix.current,byKey:!t.isNullOrUndefined(i),byClick:t.isNullOrUndefined(i),keyArgs:i,isJump:this.swap.swap,container:this.getContent().getInfo(i),outline:!t.isNullOrUndefined(i),swapInfo:this.swap});var n=this.getContent().matrix.current,o=n[0],s=n[1];this.prevIndexes={rowIndex:o,cellIndex:s},this.focusedColumnUid=this.parent.getColumnByIndex(s).uid,this.focusByClick=!1}}},e.prototype.refreshMatrix=function(e){var i=this;return function(r){e&&r.args&&r.args.isFrozen&&!i.fContent?i.fContent=new ml(i.parent):e&&!i.frContent&&r.args&&r.args.renderFrozenRightContent?i.frContent=new Cl(i.parent):e&&!i.content&&(i.content=new gl(i.parent)),!e&&r.args&&r.args.isFrozen&&!i.fHeader?i.fHeader=new yl(i.parent):!e&&r.args&&r.args.renderFrozenRightContent&&!i.frHeader?i.frHeader=new wl(i.parent):e||i.header||(i.header=new fl(i.parent));var n=e?r.args&&r.args.isFrozen?i.fContent:r.args&&r.args.renderFrozenRightContent?i.frContent:i.content:r.args&&r.args.isFrozen?i.fHeader:r.args&&r.args.renderFrozenRightContent?i.frHeader:i.header,o=e?r.rows.slice(i.parent.frozenRows):r.rows,s=e?r.rows.slice(0,i.parent.frozenRows):r.rows;i.parent.isCollapseStateEnabled()&&e&&(o=o.filter(function(e){return!1!==e.visible}));var l=!t.isNullOrUndefined(i.parent.rowTemplate),a=n.matrix.generate(s,n.selector,l);if("batchAdd"===r.name&&i.parent.isFrozenGrid()){var h=i.parent.getMovableRowsObject().map(function(e){return e.clone()}),d=o.map(function(e){return e.clone()});if(i.fContent.matrix.generate(d,i.fContent.selector,l),i.content.matrix.generate(h,i.content.selector,l),i.parent.getFrozenMode()===hs){var p=i.parent.getFrozenRightRowsObject().map(function(e){return e.clone()});i.frContent.matrix.generate(p,i.frContent.selector,l)}}else n.matrix.generate(o,n.selector,l);if(n.generateRows(s,{matrix:a,handlerInstance:r.args&&r.args.isFrozen?i.fHeader:r.args&&r.args.renderFrozenRightContent?i.frHeader:i.header}),!t.Browser.isDevice&&r&&r.args&&(i.focusByClick||"paging"!==r.args.requestType||(i.skipFocus=!1,i.parent.element.focus()),"grouping"===r.args.requestType&&(i.skipFocus=!0)),r&&r.args&&"virtualscroll"===r.args.requestType)if(i.currentInfo.uid){var c;if(r.rows.some(function(e,t){return c=t,e.uid===i.currentInfo.uid})){i.content.matrix.current[0]=c,i.content.matrix.current[1]=i.parent.getColumnIndexByUid(i.focusedColumnUid)||0;if(f=i.getContent().getFocusInfo().elementToFocus){var u=f.getBoundingClientRect(),g=i.parent.element.getBoundingClientRect();u.top>=0&&u.left>=0&&u.right<=Math.min(g.right,window.innerWidth||document.documentElement.clientWidth)&&u.bottom<=Math.min(g.bottom,window.innerHeight||document.documentElement.clientHeight)&&(i.isVirtualScroll=!0,i.focus())}}}else if(r.args.focusElement&&r.args.focusElement.classList.contains("e-filtertext")){var f;(f=i.parent.element.querySelector("#"+r.args.focusElement.id))&&f.focus()}}},e.prototype.addEventListener=function(){var e=this;this.parent.isDestroyed||(t.EventHandler.add(this.parent.element,"mousedown",this.focusCheck,this),t.EventHandler.add(this.parent.element,"focus",this.onFocus,this),this.parent.element.addEventListener("focus",this.passiveHandler=function(t){return e.passiveFocus(t)},!0),t.EventHandler.add(this.parent.element,"focusout",this.onBlur,this),this.evtHandlers=[{event:_i,handler:this.onKeyPress},{event:Wi,handler:this.onClick},{event:xi,handler:this.refMatrix},{event:an,handler:this.refMatrix},{event:Co,handler:this.refMatrix},{event:Di,handler:this.refreshMatrix()},{event:Eo,handler:this.restoreFocus},{event:vn,handler:this.restoreFocus},{event:"start-edit",handler:this.clearIndicator},{event:"start-add",handler:this.clearIndicator},{event:"sorting-complete",handler:this.restoreFocus},{event:"filtering-complete",handler:this.filterfocus},{event:"grouping-complete",handler:this.restoreFocusWithAction},{event:"ungrouping-complete",handler:this.restoreFocusWithAction},{event:ti,handler:this.refMatrix},{event:ii,handler:this.refMatrix},{event:ri,handler:this.refMatrix},{event:ei,handler:this.refMatrix},{event:Ei,handler:this.refMatrix},{event:Gi,handler:this.internalCellFocus}],_e(this.parent,this.evtHandlers,!0,this))},e.prototype.filterfocus=function(){"FilterBar"!==this.parent.filterSettings.type&&this.restoreFocus()},e.prototype.removeEventListener=function(){this.parent.isDestroyed||(t.EventHandler.remove(this.parent.element,"mousedown",this.focusCheck),t.EventHandler.remove(this.parent.element,"focus",this.onFocus),t.EventHandler.remove(this.parent.element,"focusout",this.onBlur),this.parent.element.removeEventListener("focus",this.passiveHandler,!0),_e(this.parent,this.evtHandlers,!1))},e.prototype.destroy=function(){this.removeEventListener()},e.prototype.restoreFocus=function(){this.addFocus(this.getContent().getFocusInfo())},e.prototype.restoreFocusWithAction=function(e){if(!this.parent.enableInfiniteScrolling){var i=this.getContent().matrix,r=i.current;switch(e.requestType){case"grouping":case"ungrouping":r[1]=!r.length||this.parent.groupSettings.showGroupedColumn||t.isNullOrUndefined(i.matrix[r[0]])?"grouping"===e.requestType?r[1]+1:r[1]-1:i.matrix[r[0]].indexOf(1)}this.getContent().matrix.current=r,this.addFocus(this.getContent().getFocusInfo())}},e.prototype.clearOutline=function(){this.getContent().matrix.current=this.getContent().matrix.get(0,-1,[0,1],"downArrow",this.getContent().validator()),this.clearIndicator()},e.prototype.clearIndicator=function(){this.currentInfo.element&&this.currentInfo.elementToFocus&&t.removeClass([this.currentInfo.element,this.currentInfo.elementToFocus],["e-focus","e-focused"])},e.prototype.getPrevIndexes=function(){var e=this.forget;return this.forget=!1,e||!Object.keys(this.prevIndexes).length?{rowIndex:null,cellIndex:null}:this.prevIndexes},e.prototype.forgetPrevious=function(){this.forget=!0},e.prototype.setActiveByKey=function(e,t){var i=this;if(this.parent.isFrozenGrid()||0!==this.parent.frozenRows){var r,n={home:function(){return{toHeader:!r.isContent,toFrozen:!0}},end:function(){return{toHeader:!r.isContent,toFrozen:!1}},ctrlHome:function(){return{toHeader:!0,toFrozen:i.parent.isFrozenGrid()}},ctrlEnd:function(){return{toHeader:!1,toFrozen:!1}}};if(e in n){r=t.getInfo();var o=n[e]();this.setActive(!o.toHeader,o.toFrozen),this.getContent().matrix.current=t.matrix.current}}},e.prototype.internalCellFocus=function(e){if(e.byKey&&e.container.isContent&&"enter"===e.keyArgs.action&&(e.parent.classList.contains("e-detailcell")||e.parent.classList.contains("e-unboundcell")||e.parent.classList.contains("e-templatecell"))){this.clearIndicator();var t=this.getContent().getFocusable(this.getFocusedElement());this.setFocusedElement(t),this.currentInfo.skipAction=!0}},e}(),ul=function(){function e(){this.matrix=[],this.current=[]}return e.prototype.set=function(e,t,i){e=Math.max(0,Math.min(e,this.rows)),t=Math.max(0,Math.min(t,this.columns)),this.matrix[e]=this.matrix[e]||[],this.matrix[e][t]=i?1:0},e.prototype.get=function(e,i,r,n,o){var s=i;if(e+r[0]<0)return[e,i];e=Math.max(0,Math.min(e+r[0],this.rows));var l=!0;if(t.isNullOrUndefined(this.matrix[e]))return null;if(i=Math.max(0,Math.min(i+r[1],this.matrix[e].length-1)),s+r[1]>this.matrix[e].length-1&&o(e,i,n))return[e,s];var a=this.first(this.matrix[e],i,r,!0,n);i=null===a?s:a;var h=t.getValue(e+"."+i,this.matrix);if(e!==this.rows||"downArrow"!==n&&"enter"!==n||(r[0]=-1),null===a){for(var d=0;d<this.rows;d++)if(this.matrix[d].some(function(e){return 1===e})){l=!1;break}if(l)return e=this.current[0],[e,i]}return this.inValid(h)||!o(e,i,n)?this.get(e,s,r,n,o):[e,i]},e.prototype.first=function(e,t,i,r,n){return(t<0||t===e.length)&&this.inValid(e[t])&&"upArrow"!==n&&"downArrow"!==n||!e.some(function(e){return 1===e})?null:this.inValid(e[t])?this.first(e,-1!==["upArrow","downArrow","shiftUp","shiftDown"].indexOf(n)?r?0:++t:t+i[1],i,!1,n):t},e.prototype.select=function(e,t){e=Math.max(0,Math.min(e,this.rows)),t=Math.max(0,Math.min(t,this.matrix[e].length-1)),this.current=[e,t]},e.prototype.generate=function(e,t,i){this.rows=e.length-1,this.matrix=[];for(var r=0;r<e.length;r++){var n=e[r].cells.filter(function(e){return!0!==e.isSpanned});this.columns=Math.max(n.length-1,0|this.columns);for(var o=0;o<n.length;o++)this.set(r,o,!1!==e[r].visible&&t(e[r],n[o],i))}return this.matrix},e.prototype.inValid=function(e){return 0===e||void 0===e},e}(),gl=function(){function i(e){var t=this;this.matrix=new ul,this.lastIdxCell=!1,this.parent=e,this.keyActions={rightArrow:[0,1],tab:[0,1],leftArrow:[0,-1],shiftTab:[0,-1],upArrow:[-1,0],downArrow:[1,0],shiftUp:[-1,0],shiftDown:[1,0],shiftRight:[0,1],shiftLeft:[0,-1],enter:[1,0],shiftEnter:[-1,0]},this.indexesByKey=function(e){return{home:[t.matrix.current[0],-1,0,1],end:[t.matrix.current[0],t.matrix.columns+1,0,-1],ctrlHome:[0,-1,0,1],ctrlEnd:[t.matrix.rows,t.matrix.columns+1,0,-1]}[e]||null}}return i.prototype.getTable=function(){return this.parent.isFrozenGrid()?this.parent.getContent().querySelector(".e-movablecontent .e-table"):this.parent.getContentTable()},i.prototype.onKeyPress=function(e){var t=this.keyActions[e.action],i=this.getCurrentFromAction(e.action,t,e.action in this.keyActions,e);if(i){if((["tab","shiftTab"].indexOf(e.action)>-1&&this.matrix.current||[]).toString()===i.toString()){if(i.toString()===[this.matrix.rows,this.matrix.columns].toString()||i.toString()===[0,0].toString()||this.matrix.current[0]===this.matrix.rows&&this.matrix.current.toString()===i.toString())return!1;i=this.editNextRow(i[0],i[1],e.action)}this.matrix.select(i[0],i[1])}},i.prototype.editNextRow=function(e,t,i){var r=this.parent,n=r.editSettings.allowNextRowEdit&&(r.isEdit||r.isLastCellPrimaryKey),o=r.getColumnIndexByField(r.getVisibleColumns()[0].field),s=this.getTable().rows[e].cells[t];if("tab"===i&&n){e++;t=o+(this.getTable().rows[e].getElementsByClassName("e-indentcell").length+this.getTable().rows[e].getElementsByClassName("e-detailrowcollapse").length)}return"shiftTab"===i&&n&&(e--,t=r.getColumnIndexByField(r.getVisibleColumns()[r.getVisibleColumns().length-1].field)),s.classList.contains(_o)||s.classList.contains("e-headercell")||s.classList.contains("e-groupcaption")?[e,t]:this.editNextRow(e,t,i)},i.prototype.getCurrentFromAction=function(e,t,i,r){if(void 0===t&&(t=[0,0]),!i&&!this.indexesByKey(e)||0===this.matrix.current.length)return null;if(!this.shouldFocusChange(r))return this.matrix.current;var n=this.indexesByKey(e)||this.matrix.current.concat(t),o=n[0],s=n[1],l=n[2],a=n[3];return this.matrix.get(o,s,[l,a],e,this.validator())},i.prototype.onClick=function(e,i){var r=e.target;if(this.target=r,r=r.classList.contains(_o)?r:t.closest(r,"td"),r=r||(t.closest(e.target,"td.e-detailrowcollapse")||t.closest(e.target,"td.e-detailrowexpand")),r=t.closest(e.target,"td.e-detailcell")&&t.isNullOrUndefined(t.closest(t.closest(e.target,".e-grid"),"td.e-detailcell"))?null:r,!(r=r&&t.closest(r,"table").classList.contains(ts)?r:null))return!1;var n=[r.parentElement.rowIndex,r.cellIndex],o=n[0],s=n[1],l=this.matrix.current,a=l[0],h=l[1],d=t.getValue(o+"."+s,this.matrix.matrix);if(this.matrix.inValid(d)||!i&&a===o&&h===s||!D(e.target,_o)&&!D(e.target,"e-groupcaption"))return!1;this.matrix.select(o,s)},i.prototype.getFocusInfo=function(){var e={},i=this.matrix.current,r=i[0],n=void 0===r?0:r,o=i[1],s=void 0===o?0:o;return this.matrix.current=[n,s],e.element=t.isNullOrUndefined(this.getTable().rows[n])?null:this.getTable().rows[n].cells[s],e.element?(e.elementToFocus=e.element.classList.contains("e-unboundcell")||e.element.classList.contains("e-detailcell")?e.element:this.getFocusable(e.element),e.outline=!0,e.uid=e.element.parentElement.getAttribute("data-uid"),e):e},i.prototype.getFocusable=function(e){var i='button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])',r=!t.isNullOrUndefined(t.closest(e,".e-templatecell"));this.parent.isEdit&&(i='input:not([type="hidden"]), select:not([aria-hidden="true"]), textarea');var n=[].slice.call(e.querySelectorAll(i));return n.length?r&&n.length>1?this.target:n[0]:e},i.prototype.selector=function(i,r,n){var o=[e.CellType.Expand,e.CellType.GroupCaption,e.CellType.CaptionSummary,e.CellType.GroupSummary];return(i.isDataRow&&r.visible&&(r.isDataCell||r.isTemplate)||i.isDataRow&&r.cellType===e.CellType.DetailExpand&&t.isNullOrUndefined(r.visible)||!i.isDataRow&&o.indexOf(r.cellType)>-1||r.column&&r.visible&&"checkbox"===r.column.type||r.cellType===e.CellType.CommandColumn||i.isDataRow&&n)&&!("delete"===i.edit&&i.isDirty)},i.prototype.nextRowFocusValidate=function(e){for(var t=e,i=e,r=this.matrix.rows;i<=r;i++){if(-1!==this.matrix.matrix[e].indexOf(1))return e;e+=1}return this.lastIdxCell=!0,t},i.prototype.previousRowFocusValidate=function(e){for(var t=e,i=e;i>=0;i--){if(-1!==this.matrix.matrix[e].indexOf(1))return e;if((e-=1)<0)return this.lastIdxCell=!0,t}return t},i.prototype.jump=function(e,t){var i=this.parent.getFrozenLeftCount()&&("leftArrow"===e||"shiftTab"===e)&&0===t[1],r=("rightArrow"===e||"tab"===e)&&t[1]===this.matrix.columns,n=this.parent.getFrozenMode()===hs&&r;"Right"===this.parent.getFrozenMode()&&(i=r),this.lastIdxCell=!1;var o=0!==this.parent.frozenRows&&"shiftEnter"===e;"tab"!==e||this.parent.isEdit||t[1]!==this.matrix.matrix[t[0]].lastIndexOf(1)||this.matrix.matrix.length-1===t[0]||(this.matrix.current[0]=this.nextRowFocusValidate(this.matrix.current[0]+1),this.matrix.current[1]=-1,i=this.parent.isFrozenGrid()),"shiftTab"!==e||this.parent.isEdit||0===t[0]||this.matrix.matrix[t[0]].indexOf(1)!==t[1]||(this.matrix.current[0]=this.previousRowFocusValidate(this.matrix.current[0]-1),this.matrix.current[1]=this.matrix.matrix[t[0]].length);var s=!1,l=document.activeElement.parentElement;if((this.parent.enableVirtualization||this.parent.infiniteScrollSettings.enableCache)&&l.classList.contains(is)){s=parseInt(l.getAttribute(us),10)>0}return{swap:!s&&(("upArrow"===e||o)&&0===t[0]||i||n),toHeader:("upArrow"===e||o)&&0===t[0],toFrozen:i,toFrozenRight:n}},i.prototype.getNextCurrent=function(e,t,i,r){void 0===e&&(e=[]);var n=[];return"Right"===this.parent.getFrozenMode()||this.parent.getFrozenMode()===hs?("leftArrow"!==r&&"shiftTab"!==r||(n[0]=e[0],n[1]=i.matrix.columns+1),this.parent.getFrozenMode()!==hs||"rightArrow"!==r&&"tab"!==r||(n[0]=e[0],n[1]=-1)):"rightArrow"!==r&&"tab"!==r||(n[0]=e[0],n[1]=-1),"downArrow"!==r&&"enter"!==r||(n[0]=-1,n[1]=e[1]),n},i.prototype.generateRows=function(e,t){var i,r=t.matrix,n=t.handlerInstance,o=n.matrix.matrix.length,s=this.parent.allowFiltering&&"FilterBar"===this.parent.filterSettings.type?o+1:o;n.matrix.matrix=n.matrix.matrix.slice(0,s),n.matrix.rows=s,(i=n.matrix.matrix).push.apply(i,r),n.matrix.rows+=r.length},i.prototype.getInfo=function(e){var t=this.getFocusInfo(),i=this.matrix.current,r=i[0],n=i[1],o=t.element.classList.contains(_o),s=o||e&&"enter"!==e.action&&(t.element.classList.contains("e-detailrowcollapse")||t.element.classList.contains("e-detailrowexpand")),l=[Math.min(parseInt(t.element.parentElement.getAttribute(us),10),r),Math.min(parseInt(t.element.getAttribute(cs),10),n)];return{isContent:!0,isDataCell:o,indexes:[l[0],l[1]],isSelectable:s}},i.prototype.validator=function(){var e=this.getTable();return function(i,r,n){if(!t.isNullOrUndefined(e.rows[i])){var o=void 0;r=e.querySelector(".e-emptyrow")?0:r;var s=0!==(o=e.rows[i].cells[0].classList.contains("e-editcell")?e.rows[i].cells[0].querySelectorAll("td")[r]:e.rows[i].cells[r]).getBoundingClientRect().width;if("enter"===n||"shiftEnter"===n)return s&&o.classList.contains(_o);if(("shiftUp"===n||"shiftDown"===n)&&o.classList.contains(_o))return s;if("shiftUp"!==n&&"shiftDown"!==n)return s}return!1}},i.prototype.shouldFocusChange=function(e){var i=this.matrix.current,r=i[0],n=void 0===r?-1:r,o=i[1],s=void 0===o?-1:o;if(n<0||s<0)return!0;var l=t.getValue(n+".cells."+s,this.getTable().rows);return!l||("enter"!==e.action&&"shiftEnter"!==e.action||l.classList.contains(_o)&&!l.classList.contains("e-unboundcell")&&(!l.classList.contains("e-templatecell")||l.classList.contains("e-editedbatchcell"))&&!l.classList.contains("e-detailcell"))},i.prototype.getGridSeletion=function(){return this.parent.allowSelection&&this.parent.selectionSettings.allowColumnSelection},i}(),fl=function(i){function r(e){return i.call(this,e)||this}return pl(r,i),r.prototype.getTable=function(){return this.parent.isFrozenGrid()?this.parent.getHeaderContent().querySelector(".e-movableheader .e-table"):this.parent.getHeaderTable()},r.prototype.onClick=function(e){var i=e.target;if(this.target=i,(i=i.classList.contains("e-headercell")?i:t.closest(i,"th"))||0===this.parent.frozenRows||(i=e.target.classList.contains(_o)?e.target:t.closest(e.target,"td")),e.target.classList.contains("e-columnheader")||e.target.querySelector(".e-stackedheadercell"))return!1;if(i){var r=[i.parentElement.rowIndex,i.cellIndex],n=r[0],o=r[1],s=t.getValue(n+"."+o,this.matrix.matrix);if(this.matrix.inValid(s))return!1;this.matrix.select(i.parentElement.rowIndex,i.cellIndex)}},r.prototype.getFocusInfo=function(){var e={},i=this.matrix.current,r=i[0],n=void 0===r?0:r,o=i[1],s=void 0===o?0:o;return e.element=this.getTable().rows[n].cells[s],t.isNullOrUndefined(e.element)||(e.elementToFocus=this.getFocusable(e.element),e.outline=!e.element.classList.contains("e-filterbarcell")),e},r.prototype.selector=function(i,r){return r.visible&&(void 0!==r.column.field||r.isTemplate||!t.isNullOrUndefined(r.column.template))||"checkbox"===r.column.type||r.cellType===e.CellType.StackedHeader},r.prototype.jump=function(e,i){var r=this.parent.getFrozenLeftCount()&&("leftArrow"===e||"shiftLeft"===e&&this.getGridSeletion()||"shiftTab"===e)&&0===i[1],n=("rightArrow"===e||"shiftRight"===e&&this.getGridSeletion()||"tab"===e)&&i[1]===this.matrix.columns,o=this.parent.getFrozenMode()===hs&&n;"Right"===this.parent.getFrozenMode()&&(r=n);var s,l,a=0!==this.parent.frozenRows&&"enter"===e,h=r||o,d=this.parent.focusModule.fHeader&&this.parent.focusModule.fHeader.matrix.matrix,p=d&&!t.isNullOrUndefined(d[i[0]]);return this.parent.enableHeaderFocus&&"tab"===e&&(l=this.matrix.matrix.length-1===i[0],(s=i[1]===this.matrix.matrix[i[0]].lastIndexOf(1))&&(this.matrix.current[0]=l?0:this.matrix.current[0]+1,this.matrix.current[1]=-1),this.parent.isFrozenGrid()&&l&&s&&(r=!0,h=!1)),{swap:("downArrow"===e||a)&&i[0]===this.matrix.matrix.length-1||p&&(r||o)||"tab"===e&&l&&s,toHeader:h,toFrozen:r,toFrozenRight:o}},r.prototype.getNextCurrent=function(e,t,i,r){void 0===e&&(e=[]);var n=[];return"Right"===this.parent.getFrozenMode()||this.parent.getFrozenMode()===hs?(("leftArrow"===r||"shiftLeft"===r&&this.getGridSeletion()||"shiftTab"===r)&&(n[0]=e[0],n[1]=i.matrix.columns+1),this.parent.getFrozenMode()===hs&&("rightArrow"===r||"shiftRight"===r&&this.getGridSeletion()||"tab"===r)&&(n[0]=e[0],n[1]=-1)):("rightArrow"===r||"shiftRight"===r&&this.getGridSeletion()||"tab"===r)&&(n[0]=e[0],n[1]=-1),"upArrow"!==r&&"shiftEnter"!==r||(n[0]=this.matrix.matrix.length,n[1]=e[1]),n},r.prototype.generateRows=function(e){var t=this.matrix.matrix.length;if(this.parent.allowFiltering&&"FilterBar"===this.parent.filterSettings.type){this.matrix.rows=++this.matrix.rows;for(var i=e[0].cells,r=0;r<i.length;r++)this.matrix.set(t,r,i[r].visible&&!1!==i[r].column.allowFiltering)}},r.prototype.getInfo=function(e){return t.extend(i.prototype.getInfo.call(this,e),{isContent:!1,isHeader:!0})},r.prototype.validator=function(){return function(){return!0}},r.prototype.shouldFocusChange=function(e){var i=this.matrix.current,r=i[0],n=i[1];if(r<0||n<0)return!0;var o=t.getValue(r+".cells."+n,this.getTable().rows);return!o||("enter"!==e.action&&"altDownArrow"!==e.action||!o.classList.contains("e-headercell"))},r}(gl),ml=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return pl(t,e),t.prototype.getTable=function(){return this.parent.getContent().querySelector(".e-frozencontent .e-table")},t.prototype.jump=function(e,t){var i=0!==this.parent.frozenRows&&"shiftEnter"===e,r=("upArrow"===e||i)&&0===t[0];if("Right"===this.parent.getFrozenMode()){return{swap:r||("shiftTab"===e||"leftArrow"===e)&&0===t[1],toHeader:r,toFrozen:r}}return{swap:r||("tab"===e||"rightArrow"===e)&&t[1]===this.matrix.columns,toHeader:r,toFrozen:r}},t.prototype.getNextCurrent=function(e,t,i,r){void 0===e&&(e=[]);var n=[];return"Right"===this.parent.getFrozenMode()?"rightArrow"!==r&&"tab"!==r||(n[0]=e[0],n[1]=-1):("tab"===r&&this.parent.enableHeaderFocus&&(n[0]=e[0],n[1]=-1),"leftArrow"!==r&&"shiftTab"!==r||(n[0]=e[0],n[1]=i.matrix.columns+1)),"downArrow"!==r&&"enter"!==r||(n[0]=-1,n[1]=e[1]),n},t}(gl),yl=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return pl(i,e),i.prototype.jump=function(e,i){var r=0!==this.parent.frozenRows&&"enter"===e,n=this.parent.focusModule.header&&this.parent.focusModule.header.matrix.matrix,o=n&&!t.isNullOrUndefined(n[i[0]]);if("Right"===this.parent.getFrozenMode()){var s=("leftArrow"===e||"shiftLeft"===e&&this.getGridSeletion()||"shiftTab"===e)&&0===i[1];return{swap:("downArrow"===e||r)&&i[0]===this.matrix.matrix.length-1||o&&s,toHeader:s,toFrozen:("downArrow"===e||r)&&i[0]===this.matrix.matrix.length-1}}return{swap:("downArrow"===e||r)&&i[0]===this.matrix.matrix.length-1||("rightArrow"===e||"shiftRight"===e&&this.getGridSeletion()||"tab"===e)&&i[1]===this.matrix.columns&&o,toHeader:("rightArrow"===e||"shiftRight"===e&&this.getGridSeletion()||"tab"===e)&&i[1]===this.matrix.columns,toFrozen:("downArrow"===e||r)&&i[0]===this.matrix.matrix.length-1}},i.prototype.getTable=function(){return this.parent.getHeaderContent().querySelector(".e-frozenheader .e-table")},i.prototype.getNextCurrent=function(e,t,i,r){void 0===e&&(e=[]);var n=[];return"Right"===this.parent.getFrozenMode()?("rightArrow"===r||"shiftRight"===r&&this.getGridSeletion()||"tab"===r)&&(n[0]=e[0],n[1]=-1):("leftArrow"===r||"shiftLeft"===r&&this.getGridSeletion()||"shiftTab"===r)&&(n[0]=e[0],n[1]=i.matrix.columns+1),"upArrow"!==r&&"shiftEnter"!==r||(n[0]=this.matrix.matrix.length,n[1]=e[1]),n},i}(fl),vl=function(){function e(e){this.searchBox=e}return e.prototype.searchFocus=function(e){e.target.parentElement.classList.add("e-input-focus")},e.prototype.searchBlur=function(e){e.target.parentElement.classList.remove("e-input-focus")},e.prototype.wireEvent=function(){this.searchBox&&(t.EventHandler.add(this.searchBox,"focus",this.searchFocus,this),t.EventHandler.add(this.searchBox,"blur",this.searchBlur,this))},e.prototype.unWireEvent=function(){this.searchBox&&(t.EventHandler.remove(this.searchBox,"focus",this.searchFocus),t.EventHandler.remove(this.searchBox,"blur",this.searchBlur))},e}(),Cl=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return pl(t,e),t.prototype.getTable=function(){return this.parent.getContent().querySelector(".e-frozen-right-content .e-table")},t.prototype.jump=function(e,t){var i=0!==this.parent.frozenRows&&"shiftEnter"===e,r=("upArrow"===e||i)&&0===t[0];return{swap:r||("shiftTab"===e||"leftArrow"===e)&&0===t[1],toHeader:r,toFrozenRight:r}},t.prototype.getNextCurrent=function(e,t,i,r){void 0===e&&(e=[]);var n=[];return"rightArrow"!==r&&"tab"!==r||(n[0]=e[0],n[1]=-1),"downArrow"!==r&&"enter"!==r||(n[0]=-1,n[1]=e[1]),n},t}(gl),wl=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return pl(i,e),i.prototype.jump=function(e,i){var r=this.parent.focusModule.header&&this.parent.focusModule.header.matrix.matrix,n=r&&!t.isNullOrUndefined(r[i[0]]),o=0!==this.parent.frozenRows&&"enter"===e,s=("leftArrow"===e||"shiftLeft"===e&&this.getGridSeletion()||"shiftTab"===e)&&0===i[1];return{swap:("downArrow"===e||o)&&i[0]===this.matrix.matrix.length-1||n&&s,toHeader:s,toFrozenRight:("downArrow"===e||o)&&i[0]===this.matrix.matrix.length-1}},i.prototype.getTable=function(){return this.parent.getHeaderContent().querySelector(".e-frozen-right-header .e-table")},i.prototype.getNextCurrent=function(e,t,i,r){void 0===e&&(e=[]);var n=[];return("rightArrow"===r||"shiftRight"===r&&this.getGridSeletion()||"tab"===r)&&(n[0]=e[0],n[1]=0),"upArrow"!==r&&"shiftEnter"!==r||(n[0]=this.matrix.matrix.length,n[1]=e[1]),n},i}(fl),bl=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Sl=function(e,t,i,r){var n,o=arguments.length,s=o<3?t:null===r?r=Object.getOwnPropertyDescriptor(t,i):r;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,i,r);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(o<3?n(s):o>3?n(t,i,s):n(t,i))||s);return o>3&&s&&Object.defineProperty(t,i,s),s},Rl=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return bl(i,e),Sl([t.Property(12)],i.prototype,"pageSize",void 0),Sl([t.Property(8)],i.prototype,"pageCount",void 0),Sl([t.Property(1)],i.prototype,"currentPage",void 0),Sl([t.Property()],i.prototype,"totalRecordsCount",void 0),Sl([t.Property(!1)],i.prototype,"enableQueryString",void 0),Sl([t.Property(!1)],i.prototype,"pageSizes",void 0),Sl([t.Property(null)],i.prototype,"template",void 0),i}(t.ChildProperty),xl=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Fl=function(e,t,i,r){var n,o=arguments.length,s=o<3?t:null===r?r=Object.getOwnPropertyDescriptor(t,i):r;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,i,r);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(o<3?n(s):o>3?n(t,i,s):n(t,i))||s);return o>3&&s&&Object.defineProperty(t,i,s),s},El=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return xl(i,e),Fl([t.Property("startsWith")],i.prototype,"operator",void 0),Fl([t.Property(!1)],i.prototype,"ignoreAccent",void 0),i}(t.ChildProperty),Il=function(){return(Il=Object.assign||function(e){for(var t,i=1,r=arguments.length;i<r;i++){t=arguments[i];for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])}return e}).apply(this,arguments)},Tl=function(){function r(e,t,i){this.selectedRowIndexes=[],this.selectedRowCellIndexes=[],this.selectedRecords=[],this.preventFocus=!1,this.selectedColumnsIndexes=[],this.checkBoxState=!1,this.isMultiShiftRequest=!1,this.isMultiCtrlRequest=!1,this.enableSelectMultiTouch=!1,this.clearRowCheck=!1,this.selectRowCheck=!1,this.selectedRowState={},this.totalRecordsCount=0,this.chkAllCollec=[],this.isCheckedOnAdd=!1,this.persistSelectedData=[],this.deSelectedData=[],this.needColumnSelection=!1,this.isCancelDeSelect=!1,this.isPreventCellSelect=!1,this.disableUI=!1,this.isPersisted=!1,this.cmdKeyPressed=!1,this.cellselected=!1,this.isMultiSelection=!1,this.isAddRowsToSelection=!1,this.initialRowSelection=!1,this.isPrevRowSelection=!1,this.isKeyAction=!1,this.isRowDragSelected=!1,this.autoFillRLselection=!0,this.bottom="0 0 2px 0",this.top="2px 0 0 0",this.right_bottom="0 2px 2px 0",this.bottom_left="0 0 2px 2px",this.top_right="2px 2px 0 0",this.top_left="2px 0 0 2px",this.top_bottom="2px 0 2px 0",this.top_right_bottom="2px 2px 2px 0",this.top_bottom_left="2px 0 2px 2px",this.top_right_left="2px 2px 0 2px",this.right_bottom_left="0 2px 2px 2px",this.all_border="2px",this.parent=e,this.selectionSettings=t,this.factory=i.getService("rendererFactory"),this.focus=i.getService("focus"),this.addEventListener(),this.wireEvents()}return r.prototype.initializeSelection=function(){this.parent.log("selection_key_missing"),this.render()},r.prototype.onActionBegin=function(e,t){this.parent.trigger(t,this.fDataUpdate(e))},r.prototype.fDataUpdate=function(e){if(!(this.isMultiSelection||t.isNullOrUndefined(e.cellIndex)&&t.isNullOrUndefined(e.rowIndex))){var i=this.getRowObj(t.isNullOrUndefined(e.rowIndex)?t.isNullOrUndefined(e.cellIndex)?this.currentIndex:e.cellIndex.rowIndex:e.rowIndex);e.foreignKeyData=i.foreignKeyData}return e},r.prototype.onActionComplete=function(e,t){this.parent.trigger(t,this.fDataUpdate(e)),this.isMultiSelection=!1},r.prototype.getModuleName=function(){return"selection"},r.prototype.destroy=function(){var e=this.parent.element;e&&(e.querySelector("."+Wo)||e.querySelector("."+Ko))&&(this.hidePopUp(),this.clearSelection(),this.removeEventListener(),this.unWireEvents(),t.EventHandler.remove(this.parent.getContent(),"mousedown",this.mouseDownHandler),t.EventHandler.remove(this.parent.getHeaderContent(),"mousedown",this.mouseDownHandler))},r.prototype.isEditing=function(){return("Normal"===this.parent.editSettings.mode||"Batch"===this.parent.editSettings.mode&&this.parent.editModule&&this.parent.editModule.formObj&&!this.parent.editModule.formObj.validate())&&this.parent.isEdit&&!this.parent.isPersistSelection},r.prototype.getSelectedMovableRow=function(e){var t=this.parent;return t.isFrozenGrid()&&this.parent.getContent().querySelector("."+Yo)?t.getMovableRowByIndex(e):null},r.prototype.getSelectedFrozenRightRow=function(e){var t=this.parent;return t.isFrozenGrid()&&t.getFrozenMode()===hs&&t.getFrozenRightContent()?t.getFrozenRightRowByIndex(e):null},r.prototype.getCurrentBatchRecordChanges=function(){var e=this.parent;if("Batch"===e.editSettings.mode&&e.editModule){var t=S(this.parent.getCurrentViewRecords());t="Bottom"===e.editSettings.newRowPosition?t.concat(this.parent.editModule.getBatchChanges()[ls]):this.parent.editModule.getBatchChanges()[ls].concat(t);for(var i=this.parent.editModule.getBatchChanges()[as],r=this.parent.getPrimaryKeyFieldNames()[0],n=0;n<i.length;n++)for(var o=0;o<t.length;o++)if(i[n][r]===t[o][r]){t.splice(o,1);break}return t}return e.getCurrentViewRecords()},r.prototype.selectRow=function(e,t){if(this.selectedRowIndexes.length&&this.selectionSettings.enableSimpleMultiRowSelection)this.addRowsToSelection([e]);else{var i,r=this.parent,n=r.getRowByIndex(e),o=this.getSelectedMovableRow(e),s=this.getSelectedFrozenRightRow(e);if(r.enableVirtualization&&e>-1){var l={selectedIndex:e,isAvailable:!0};this.parent.notify(dn,l);var a=r.isFrozenGrid()?r.contentModule.getRowObjectByIndex(e):null;if(!n||!r.getRowObjectFromUID(n.getAttribute("data-uid"))&&!a){if(l.isAvailable&&!r.selectionSettings.persistSelection){this.parent.getSelectedRecords().length>0&&this.clearRowSelection()}return}i=a||r.getRowObjectFromUID(n.getAttribute("data-uid")).data}else i=this.getRowObj(e).data;if(this.isRowType()&&n&&!this.isEditing()){var h=n.hasAttribute("aria-selected");this.activeTarget(),t=t?!!this.selectedRowIndexes.length&&(1===this.selectedRowIndexes.length&&((!this.isKeyAction||!this.parent.isCheckBoxSelection)&&e===this.selectedRowIndexes[0])):t,this.isKeyAction=!1;var d;t?this.rowSelectingCallBack(d,t,e,i,!1,h,"cancel")(d):(d={data:i,rowIndex:e,isCtrlPressed:this.isMultiCtrlRequest,isShiftPressed:this.isMultiShiftRequest,row:n,previousRow:r.getRowByIndex(this.prevRowIndex),previousRowIndex:this.prevRowIndex,target:this.actualTarget,cancel:!1,isInteracted:this.isInteracted,isHeaderCheckboxClicked:this.isHeaderCheckboxClicked},d=this.addMovableArgs(d,o,s),this.parent.trigger(kt,this.fDataUpdate(d),this.rowSelectingCallBack(d,t,e,i,!1,h,"cancel")))}}},r.prototype.rowSelectingCallBack=function(e,i,r,n,o,s,l){var a=this;return function(e){t.isNullOrUndefined(e)||!0!==e[l]?(a.index=r,a.toggle=i,a.data=n,a.removed=o,s&&a.selectionSettings.persistSelection&&"ResetOnRowClick"!==a.selectionSettings.checkboxMode?(a.clearSelectedRow(r),a.selectRowCallBack()):!s&&a.selectionSettings.persistSelection&&"ResetOnRowClick"!==a.selectionSettings.checkboxMode&&a.selectRowCallBack(),"ResetOnRowClick"===a.selectionSettings.checkboxMode&&a.clearSelection(),(!a.selectionSettings.persistSelection||"ResetOnRowClick"===a.selectionSettings.checkboxMode||!a.parent.isCheckBoxSelection&&a.selectionSettings.persistSelection)&&(a.selectRowCheck=!0,a.clearRow())):a.disableInteracted()}},r.prototype.selectRowCallBack=function(){var e,t=this.parent,i=this.index,r=this.toggle,n=this.data,o=this.removed,s=t.getRowByIndex(i),l=this.getSelectedMovableRow(i),a=this.getSelectedFrozenRightRow(i);r||o||(this.selectedRowIndexes.indexOf(i)<=-1&&(this.updateRowSelection(s,i),this.selectMovableRow(l,a,i)),this.selectRowIndex(i)),r||(e={data:n,rowIndex:i,row:s,previousRow:t.getRowByIndex(this.prevRowIndex),previousRowIndex:this.prevRowIndex,target:this.actualTarget,isInteracted:this.isInteracted,isHeaderCheckBoxClicked:this.isHeaderCheckboxClicked},e=this.addMovableArgs(e,l,a),this.onActionComplete(e,At)),this.isInteracted=!1,this.updateRowProps(i)},r.prototype.selectMovableRow=function(e,t,i){this.parent.isFrozenGrid()&&(this.updateRowSelection(e,i),this.parent.getFrozenMode()===hs&&t&&this.updateRowSelection(t,i))},r.prototype.addMovableArgs=function(e,t,i){if(this.parent.isFrozenGrid()){var r={mRow:t,previousMovRow:this.parent.getMovableRows()[this.prevRowIndex]};this.parent.getFrozenMode()===hs&&i&&(r.frozenRightRow=i,r.previousFrozenRightRow=this.parent.getFrozenRightDataRows()[this.prevRowIndex]),e=Il({},e,r)}return e},r.prototype.selectRowsByRange=function(e,t){this.selectRows(this.getCollectionFromIndexes(e,t)),this.selectRowIndex(t)},r.prototype.selectedDataUpdate=function(e,t,i,r){for(var n=0,o=r.length;n<o;n++){var s=this.parent.getDataRows()[r[n]],l=this.getRowObj(s);l&&(e.push(l.data),i.push(s),t.push(l.foreignKeyData))}},r.prototype.selectRows=function(e){var i=this,r=this.parent,n=this.isSingleSel()?e[e.length-1]:e[0];this.isMultiSelection=!0;var o=[],s=[],l=this.getSelectedMovableRow(n),a=this.getSelectedFrozenRightRow(n),h=[];if(this.isRowType()&&!this.isEditing()){this.selectedDataUpdate(h,s,o,e),this.activeTarget();var d={cancel:!1,rowIndexes:e,row:o,rowIndex:n,target:this.actualTarget,prevRow:r.getRows()[this.prevRowIndex],previousRowIndex:this.prevRowIndex,isInteracted:this.isInteracted,isCtrlPressed:this.isMultiCtrlRequest,isShiftPressed:this.isMultiShiftRequest,data:h,isHeaderCheckboxClicked:this.isHeaderCheckboxClicked,foreignKeyData:s};d=this.addMovableArgs(d,l,a),this.parent.trigger(kt,this.fDataUpdate(d),function(h){if(t.isNullOrUndefined(h)||!0!==h.cancel){i.clearRow(),i.selectRowIndex(e.slice(-1)[0]);var d=function(e){if(i.updateRowSelection(r.getRowByIndex(e),e),r.isFrozenGrid()){var t=i.parent.getFrozenMode()===hs?r.getFrozenRightRowByIndex(e):void 0;i.selectMovableRow(r.getMovableRowByIndex(e),t,e)}i.updateRowProps(n)};if(i.isSingleSel())d(n);else for(var p=0,c=e;p<c.length;p++){d(c[p])}h={rowIndexes:e,row:o,rowIndex:n,target:i.actualTarget,prevRow:r.getRows()[i.prevRowIndex],previousRowIndex:i.prevRowIndex,data:i.getSelectedRecords(),isInteracted:i.isInteracted,isHeaderCheckboxClicked:i.isHeaderCheckboxClicked,foreignKeyData:s},h=i.addMovableArgs(h,l,a),i.isRowSelected&&i.onActionComplete(h,At),i.isInteracted=!1}else i.disableInteracted()})}},r.prototype.addRowsToSelection=function(e){var i=this.parent,r=this.target;this.isMultiSelection=!0;var n=[],o=[],s=[],l=i.getSelectedRowIndexes().concat(e),a=this.isSingleSel()?i.getRowByIndex(e[e.length-1]):i.getRowByIndex(e[0]),h=this.isSingleSel()?this.getSelectedMovableRow(e[e.length-1]):this.getSelectedMovableRow(e[0]),d=this.isSingleSel()?this.getSelectedFrozenRightRow(e[e.length-1]):this.getSelectedFrozenRightRow(e[0]);if(this.isRowType()&&!this.isEditing()||this.selectionSettings.checkboxOnly){var p,c=this.parent.getColumns().filter(function(e){return"checkbox"===e.type});this.isMultiCtrlRequest&&!c.length&&this.selectedDataUpdate(s,o,n,l);for(var u=0,g=e;u<g.length;u++){var f=g[u],m=this.getRowObj(f),y=this.selectedRowIndexes.indexOf(f)>-1;if(this.selectRowIndex(f),y&&(c.length||this.selectionSettings.enableToggle||this.isMultiCtrlRequest)){if(this.isAddRowsToSelection=!0,this.rowDeselect(Bt,[f],[m.data],[a],[m.foreignKeyData],r),this.isCancelDeSelect)return;this.selectedRowIndexes.splice(this.selectedRowIndexes.indexOf(f),1),this.selectedRecords.splice(this.selectedRecords.indexOf(a),1),this.selectRowIndex(this.selectedRowIndexes.length?this.selectedRowIndexes[this.selectedRowIndexes.length-1]:-1),a.removeAttribute("aria-selected"),this.addRemoveClassesForRow(a,!1,null,"e-selectionbackground","e-active"),h&&(this.selectedRecords.splice(this.selectedRecords.indexOf(h),1),h.removeAttribute("aria-selected"),this.addRemoveClassesForRow(h,!1,null,"e-selectionbackground","e-active")),d&&(this.selectedRecords.splice(this.selectedRecords.indexOf(d),1),d.removeAttribute("aria-selected"),this.addRemoveClassesForRow(d,!1,null,"e-selectionbackground","e-active")),this.rowDeselect(Nt,[f],[m.data],[a],[m.foreignKeyData],r,[h],void 0,[d]),this.isInteracted=!1,this.isMultiSelection=!1,this.isAddRowsToSelection=!1}else{if(this.activeTarget(),p={cancel:!1,data:s.length?s:m.data,rowIndex:f,row:n.length?n:a,target:this.actualTarget,prevRow:i.getRows()[this.prevRowIndex],previousRowIndex:this.prevRowIndex,isCtrlPressed:this.isMultiCtrlRequest,isShiftPressed:this.isMultiShiftRequest,foreignKeyData:o.length?o:m.foreignKeyData,isInteracted:this.isInteracted,isHeaderCheckboxClicked:this.isHeaderCheckboxClicked,rowIndexes:l},p=this.addMovableArgs(p,h,d),this.parent.trigger(kt,this.fDataUpdate(p)),!t.isNullOrUndefined(p)&&!0===p.cancel)return void this.disableInteracted();this.isSingleSel()&&this.clearRow(),this.updateRowSelection(a,f),this.selectMovableRow(h,d,f)}if(y||(p={data:s.length?s:m.data,rowIndex:f,row:n.length?n:a,target:this.actualTarget,prevRow:i.getRows()[this.prevRowIndex],previousRowIndex:this.prevRowIndex,foreignKeyData:o.length?o:m.foreignKeyData,isInteracted:this.isInteracted,isHeaderCheckboxClicked:this.isHeaderCheckboxClicked,rowIndexes:l},p=this.addMovableArgs(p,h,d),this.onActionComplete(p,At)),this.isInteracted=!1,this.updateRowProps(f),this.isSingleSel())break}}},r.prototype.getCollectionFromIndexes=function(e,t){for(var i=[],r=e<=t?{i:e,max:t}:{i:t,max:e},n=r.i,o=r.max;n<=o;n++)i.push(n);return e>t&&i.reverse(),i},r.prototype.clearRow=function(){this.clearRowCheck=!0,this.clearRowSelection()},r.prototype.clearRowCallBack=function(){this.isCancelDeSelect&&"Check"!==this.parent.checkAllRows||(this.selectedRowIndexes=[],this.selectedRecords=[],this.selectRowIndex(-1),this.isSingleSel()&&this.parent.isPersistSelection&&(this.selectedRowState={}))},r.prototype.clearSelectedRow=function(e){if(this.toggle){var t=this.parent.getRowByIndex(e);this.disableUI||(t.removeAttribute("aria-selected"),this.addRemoveClassesForRow(t,!1,!0,"e-selectionbackground","e-active")),this.removed=!0,this.updatePersistCollection(t,!1),this.updateCheckBoxes(t),this.selectedRowIndexes.splice(this.selectedRowIndexes.indexOf(e),1),this.selectedRecords.splice(this.selectedRecords.indexOf(this.parent.getRowByIndex(e)),1)}},r.prototype.updateRowProps=function(e){this.prevRowIndex=e,this.isRowSelected=this.selectedRowIndexes.length&&!0},r.prototype.updatePersistCollection=function(e,i){var r=this;if((this.parent.isPersistSelection||this.parent.selectionSettings.persistSelection&&this.parent.getPrimaryKeyFieldNames().length>0)&&!t.isNullOrUndefined(e)){this.parent.isPersistSelection||this.ensureCheckboxFieldSelection();var n=this.getRowObj(e),o=n.data?n.data[this.primaryKey]:null;if(null===o)return;n.isSelected=i,i?(this.selectedRowState[o]=i,this.persistSelectedData.some(function(e){return e[r.primaryKey]===o})||this.persistSelectedData.push(n.data)):this.updatePersistDelete(o)}},r.prototype.updatePersistDelete=function(e){var t=this;delete this.selectedRowState[e];var i;this.persistSelectedData.some(function(r,n){return i=n,r[t.primaryKey]===e})&&this.persistSelectedData.splice(i,1)},r.prototype.updateCheckBoxes=function(e,i,r){if(!t.isNullOrUndefined(e)){var n=e.querySelector(".e-checkselect");t.isNullOrUndefined(n)||(ie(n.nextElementSibling,i),ee(n,i),(t.isNullOrUndefined(this.checkedTarget)||!t.isNullOrUndefined(this.checkedTarget)&&!this.checkedTarget.classList.contains("e-checkselectall"))&&this.setCheckAllState(r))}},r.prototype.updateRowSelection=function(e,t){if(e){this.selectedRowIndexes.push(t);var i=this.selectedRowIndexes.length;if(this.parent.isFrozenGrid()&&i>1&&this.selectedRowIndexes[i-2]===this.selectedRowIndexes[i-1]&&this.selectedRowIndexes.pop(),this.selectedRecords.push(e),e.setAttribute("aria-selected","true"),this.updatePersistCollection(e,!0),this.updateCheckBoxes(e,!0),this.addRemoveClassesForRow(e,!0,null,"e-selectionbackground","e-active"),!this.preventFocus){var r=this.focus.getPrevIndexes().cellIndex?e.cells[this.focus.getPrevIndexes().cellIndex]:e.querySelector(".e-selectionbackground:not(.e-hide):not(.e-detailrowcollapse):not(.e-detailrowexpand)");if(this.parent.contextMenuModule&&2===this.mouseButton&&(r=this.parent.contextMenuModule.cell),!r)return;this.focus.onClick({target:r},!0)}}},r.prototype.clearSelection=function(){if(this.checkSelectAllClicked=!0,this.selectionSettings.persistSelection&&this.persistSelectedData.length&&(this.deSelectedData=S(this.persistSelectedData)),!this.parent.isPersistSelection||this.parent.isPersistSelection&&!this.parent.isEdit||!t.isNullOrUndefined(this.checkedTarget)&&this.checkedTarget.classList.contains("e-checkselectall")){var e=this.parent.element.querySelector(".e-gridpopup").querySelector("span");e.classList.contains("e-rowselect")&&e.classList.remove("e-spanclicked"),this.parent.isPersistSelection&&(this.persistSelectedData=[],this.selectedRowState={}),this.clearRowSelection(),this.clearCellSelection(),this.clearColumnSelection(),this.prevRowIndex=void 0,this.prevCIdxs=void 0,this.prevECIdxs=void 0,this.enableSelectMultiTouch=!1,this.isInteracted=!1,this.checkSelectAllClicked=!1}},r.prototype.clearRowSelection=function(){var e=this;if(this.isRowSelected){for(var t=this.parent,i=this.parent.getDataRows(),r=[],n=[],o=[],s=[],l=[],a=[],h=this.target,d=0,p=this.selectedRowIndexes.length;d<p;d++){var c="Batch"===this.parent.editSettings.mode?this.parent.getRows()[this.selectedRowIndexes[d]]:this.parent.getDataRows()[this.selectedRowIndexes[d]],u=this.getRowObj(c);if(u&&(r.push(u.data),n.push(c),l.push(this.selectedRowIndexes[d]),a.push(u.foreignKeyData)),t.isFrozenGrid()){var g=t.getMovableRows();if(g&&g.length&&o.push(g[this.selectedRowIndexes[d]]),t.getFrozenMode()===hs){var f=t.getFrozenRightRows();f&&f.length&&s.push(f[this.selectedRowIndexes[d]])}}}this.selectionSettings.persistSelection&&"ResetOnRowClick"!==this.selectionSettings.checkboxMode&&(this.isRowClicked=!!this.checkSelectAllClicked),this.rowDeselect(Bt,l,r,n,a,h,o,function(){if(e.isCancelDeSelect&&(e.isRowClicked||e.checkSelectAllClicked||e.isInteracted&&!e.parent.isPersistSelection)){if(e.parent.isPersistSelection)if("Intermediate"===e.getCheckAllStatus(e.parent.element.querySelector(".e-checkselectall")))for(var t=0;t<e.selectedRecords.length;t++)e.updatePersistCollection(e.selectedRecords[t],!0);else e.parent.checkAllRows="Check",e.updatePersistSelectedData(!0);e.clearRowCheck&&(e.clearRowCallBack(),e.clearRowCheck=!1,e.selectRowCheck&&(e.selectRowCallBack(),e.selectRowCheck=!1))}else{for(var d=[].slice.call(i.filter(function(e){return e.hasAttribute("aria-selected")})),p=0;p<d.length;p++)e.disableUI||(d[p].removeAttribute("aria-selected"),e.addRemoveClassesForRow(d[p],!1,!0,"e-selectionbackground","e-active")),e.isPrevRowSelection||e.updatePersistCollection(d[p],!1),e.updateCheckBoxes(d[p]);t=0;for(var c=e.selectedRowIndexes.length;t<c;t++){var u=e.getSelectedMovableRow(e.selectedRowIndexes[t]);u&&(e.disableUI||(u.removeAttribute("aria-selected"),e.addRemoveClassesForRow(u,!1,!0,"e-selectionbackground","e-active")),e.updateCheckBoxes(u),e.isPrevRowSelection||e.updatePersistCollection(u,!1));var g=e.getSelectedFrozenRightRow(e.selectedRowIndexes[t]);g&&(e.disableUI||(g.removeAttribute("aria-selected"),e.addRemoveClassesForRow(g,!1,!0,"e-selectionbackground","e-active")),e.updateCheckBoxes(g),e.isPrevRowSelection||e.updatePersistCollection(g,!1))}e.selectedRowIndexes=[],e.selectedRecords=[],e.isRowSelected=!1,e.selectRowIndex(-1),e.isPrevRowSelection=!1,e.rowDeselect(Nt,l,r,n,a,h,o,void 0,s),e.clearRowCheck&&(e.clearRowCallBack(),e.clearRowCheck=!1,e.selectRowCheck&&(e.selectRowCallBack(),e.selectRowCheck=!1))}},s)}else this.clearRowCheck&&(this.clearRowCallBack(),this.clearRowCheck=!1,this.selectRowCheck&&(this.selectRowCallBack(),this.selectRowCheck=!1))},r.prototype.rowDeselect=function(e,i,r,n,o,s,l,a,h){var d=this;if(this.selectionSettings.persistSelection&&(this.isRowClicked||this.checkSelectAllClicked)||!this.selectionSettings.persistSelection){var p=1===i.length&&1===this.deSelectedData.length,c={rowIndex:i[0],data:this.selectionSettings.persistSelection&&"Uncheck"===this.parent.checkAllRows&&!p&&"ResetOnRowClick"!==this.selectionSettings.checkboxMode?this.deSelectedData:r,foreignKeyData:o,cancel:!1,isInteracted:this.isInteracted,isHeaderCheckboxClicked:this.isHeaderCheckboxClicked};"rowDeselected"===e&&delete c.cancel;c.row=n,c.target=this.actualTarget;this.actualTarget&&!t.isNullOrUndefined(t.closest(this.actualTarget,"thead"))||i.length>1?(c.rowIndex=i[0],c.rowIndexes=i):1===i.length&&(c.data=c.data[0],c.row=c.row[0],c.foreignKeyData=c.foreignKeyData[0],this.isAddRowsToSelection&&(c.rowIndexes=i)),this.parent.trigger(e,this.parent.isFrozenGrid()?Il({},c,{mRow:l,frozenRightRow:h}):c,function(e){d.isCancelDeSelect=e.cancel,d.isCancelDeSelect&&(d.isRowClicked||d.isInteracted||d.checkSelectAllClicked)||(d.updatePersistCollection(n[0],!1),d.updateCheckBoxes(n[0],void 0,i[0]),l&&d.updateCheckBoxes(l[0],void 0,i[0]),h&&d.updateCheckBoxes(h[0],void 0,i[0])),void 0!==a&&a()})}else this.selectionSettings.persistSelection&&!this.isInteracted&&void 0!==a&&a()},r.prototype.getRowObj=function(e){return void 0===e&&(e=this.currentIndex),t.isNullOrUndefined(e)?{}:("number"==typeof e&&(e=this.parent.getRowByIndex(e)),e?this.parent.getRowObjectFromUID(e.getAttribute("data-uid"))||{}:{})},r.prototype.getSelectedMovableCell=function(e){var t=this.parent,i=t.getColumnByIndex(e.cellIndex);return t.isFrozenGrid()&&"movable"===i.getFreezeTableName()?t.getMovableCellFromIndex(e.rowIndex,this.getColIndex(e.rowIndex,e.cellIndex)):null},r.prototype.selectCell=function(e,i){if(this.isCellType()){var r,n=this.parent,o=this.getSelectedMovableCell(e);o||(o=n.getCellFromIndex(e.rowIndex,this.getColIndex(e.rowIndex,e.cellIndex))),this.currentIndex=e.rowIndex;var s=this.getCurrentBatchRecordChanges()[this.currentIndex];if(this.isCellType()&&o&&!this.isEditing()){var l=o.classList.contains("e-cellselectionbackground");if(i=i?!t.isUndefined(this.prevCIdxs)&&e.rowIndex===this.prevCIdxs.rowIndex&&e.cellIndex===this.prevCIdxs.cellIndex&&l:i)this.successCallBack(r,i,e,o,s)(r);else{(r={data:s,cellIndex:e,isCtrlPressed:this.isMultiCtrlRequest,isShiftPressed:this.isMultiShiftRequest,previousRowCell:this.prevECIdxs?this.getCellIndex(this.prevECIdxs.rowIndex,this.prevECIdxs.cellIndex):void 0,cancel:!1}).currentCell=o;r.previousRowCellIndex=this.prevECIdxs,this.parent.trigger(Pt,this.fDataUpdate(r),this.successCallBack(r,i,e,o,s)),this.cellselected=!0}}}},r.prototype.successCallBack=function(e,i,r,n,o){var s=this;return function(e){var l="currentCell";if((t.isNullOrUndefined(e)||!0!==e.cancel)&&(i||(e[l]=e[l]?e[l]:n),s.clearCell(),i||s.updateCellSelection(n,r.rowIndex,r.cellIndex),!i)){var a={data:o,cellIndex:r,currentCell:n,selectedRowCellIndex:s.selectedRowCellIndexes,previousRowCell:s.prevECIdxs?s.getCellIndex(s.prevECIdxs.rowIndex,s.prevECIdxs.cellIndex):void 0};a.previousRowCellIndex=s.prevECIdxs,s.updateCellProps(r,r),s.onActionComplete(a,Lt)}}},r.prototype.getCellIndex=function(e,t){return this.parent.getFrozenColumns()&&t>=this.parent.getFrozenColumns()?this.parent.getMovableCellFromIndex(e,t):this.parent.getCellFromIndex(e,t)},r.prototype.selectCellsByRange=function(e,i){var r=this;if(this.isCellType()){var n=this.parent,o=this.getSelectedMovableCell(e),s=n.getFrozenColumns();o||(o=n.getCellFromIndex(e.rowIndex,e.cellIndex));var l,a,h,d=e,p=i=i||e;this.currentIndex=e.rowIndex;var c=this.getCurrentBatchRecordChanges()[this.currentIndex];if(!this.isSingleSel()&&this.isCellType()&&!this.isEditing()){var u={data:c,cellIndex:e,currentCell:o,isCtrlPressed:this.isMultiCtrlRequest,isShiftPressed:this.isMultiShiftRequest,previousRowCell:this.prevECIdxs?this.getCellIndex(this.prevECIdxs.rowIndex,this.prevECIdxs.cellIndex):void 0};u.previousRowCellIndex=this.prevECIdxs,this.parent.trigger(Pt,this.fDataUpdate(u),function(u){if(t.isNullOrUndefined(u)||!0!==u.cancel){if(r.clearCell(),e.rowIndex>i.rowIndex){var g=e;e=i,i=g}for(var f=e.rowIndex;f<=i.rowIndex;f++){r.selectionSettings.cellSelectionMode.indexOf("Box")<0?(l=f===e.rowIndex?e.cellIndex:0,a=f===i.rowIndex?i.cellIndex:r.getLastColIndex(f)):(l=e.cellIndex,a=i.cellIndex),h=[];for(var m=l<a?l:a,y=l>a?l:a;m<=y;m++)(o=s?m<s?n.getCellFromIndex(f,m):n.getMovableCellFromIndex(f,m):n.getCellFromIndex(f,m))&&(h.push(m),r.updateCellSelection(o),r.addAttribute(o));r.selectedRowCellIndexes.push({rowIndex:f,cellIndexes:h})}var v={data:c,cellIndex:p,currentCell:n.getCellFromIndex(p.rowIndex,p.cellIndex),selectedRowCellIndex:r.selectedRowCellIndexes,previousRowCell:r.prevECIdxs?r.getCellIndex(r.prevECIdxs.rowIndex,r.prevECIdxs.cellIndex):void 0};v.previousRowCellIndex=r.prevECIdxs,r.isDragged||(r.onActionComplete(v,Lt),r.cellselected=!0),r.updateCellProps(d,p)}})}}},r.prototype.selectCells=function(e){if(this.isCellType()){var t=this.parent,i=this.getSelectedMovableCell(e[0]),r=t.getFrozenColumns();i||(i=t.getCellFromIndex(e[0].rowIndex,e[0].cellIndexes[0])),this.currentIndex=e[0].rowIndex;var n=this.getCurrentBatchRecordChanges()[this.currentIndex];if(!this.isSingleSel()&&this.isCellType()&&!this.isEditing()){var o={data:n,cellIndex:e[0].cellIndexes[0],currentCell:i,isCtrlPressed:this.isMultiCtrlRequest,isShiftPressed:this.isMultiShiftRequest,previousRowCell:this.prevECIdxs?this.getCellIndex(this.prevECIdxs.rowIndex,this.prevECIdxs.cellIndex):void 0};o.previousRowCellIndex=this.prevECIdxs,this.onActionBegin(o,Pt);for(var s=0,l=e.length;s<l;s++)for(var a=0,h=e[s].cellIndexes.length;a<h;a++)(i=r?e[s].cellIndexes[a]<r?t.getCellFromIndex(e[s].rowIndex,e[s].cellIndexes[a]):t.getMovableCellFromIndex(e[s].rowIndex,e[s].cellIndexes[a]):t.getCellFromIndex(e[s].rowIndex,e[s].cellIndexes[a]))&&(this.updateCellSelection(i),this.addAttribute(i),this.addRowCellIndex({rowIndex:e[s].rowIndex,cellIndex:e[s].cellIndexes[a]}));this.updateCellProps({rowIndex:e[0].rowIndex,cellIndex:e[0].cellIndexes[0]},{rowIndex:e[0].rowIndex,cellIndex:e[0].cellIndexes[0]});var d={data:n,cellIndex:e[0].cellIndexes[0],currentCell:i,selectedRowCellIndex:this.selectedRowCellIndexes,previousRowCell:this.prevECIdxs?this.getCellIndex(this.prevECIdxs.rowIndex,this.prevECIdxs.cellIndex):void 0};d.previousRowCellIndex=this.prevECIdxs,this.onActionComplete(d,Lt)}}},r.prototype.addCellsToSelection=function(e){if(this.isCellType()){var i,r,n=this.parent;this.currentIndex=e[0].rowIndex;var o=this.getCurrentBatchRecordChanges()[this.currentIndex],s=n.getFrozenLeftCount(),l=n.getMovableColumnsCount();if(!this.isSingleSel()&&this.isCellType()&&!this.isEditing()){this.hideAutoFill();var a,h=n.getColumnByIndex(e[0].cellIndex);Me(this.parent,function(t,i){a=i[e[0].rowIndex]},[h.getFreezeTableName()&&h.getFreezeTableName()!==ps?[]:n.getRowsObject(),"movable"===h.getFreezeTableName()?n.getMovableRowsObject():[],h.getFreezeTableName()===ds?n.getFrozenRightRowsObject():[]]);for(var d=[],p=0,c=e;p<c.length;p++){for(var u=c[p],g=0,f=this.selectedRowCellIndexes.length;g<f;g++)if(this.selectedRowCellIndexes[g].rowIndex===u.rowIndex){r=g;break}(i=this.getSelectedMovableCell(u))||(i=n.getCellFromIndex(u.rowIndex,this.getColIndex(u.rowIndex,u.cellIndex)));var m="movable"===h.getFreezeTableName()?u.cellIndex-s:h.getFreezeTableName()===ds?u.cellIndex-(s+l):u.cellIndex;d.push(a.cells[m].foreignKeyData);var y={cancel:!1,data:o,cellIndex:e[0],isShiftPressed:this.isMultiShiftRequest,currentCell:i,isCtrlPressed:this.isMultiCtrlRequest,previousRowCell:this.prevECIdxs?n.getCellFromIndex(this.prevECIdxs.rowIndex,this.prevECIdxs.cellIndex):void 0},v="previousRowCellIndex";y[v]=this.prevECIdxs;var C=r>-1;if(C){var w=this.selectedRowCellIndexes[r].cellIndexes;w.indexOf(u.cellIndex)>-1?(this.cellDeselect(qt,[{rowIndex:u.rowIndex,cellIndexes:[u.cellIndex]}],o,[i],d),w.splice(w.indexOf(u.cellIndex),1),0===w.length&&this.selectedRowCellIndexes.splice(r,1),i.classList.remove("e-cellselectionbackground"),i.removeAttribute("aria-selected"),this.cellDeselect(Ht,[{rowIndex:u.rowIndex,cellIndexes:[u.cellIndex]}],o,[i],d)):(C=!1,this.onActionBegin(y,Pt),this.addRowCellIndex({rowIndex:u.rowIndex,cellIndex:u.cellIndex}),this.updateCellSelection(i),this.addAttribute(i))}else{if(this.onActionBegin(y,Pt),!t.isNullOrUndefined(y)&&!0===y.cancel)return;this.updateCellSelection(i,u.rowIndex,u.cellIndex)}if(!C){var b={data:o,cellIndex:e[0],currentCell:i,previousRowCell:this.prevECIdxs?this.getCellIndex(this.prevECIdxs.rowIndex,this.prevECIdxs.cellIndex):void 0,selectedRowCellIndex:this.selectedRowCellIndexes};b[v]=this.prevECIdxs,this.onActionComplete(b,Lt),this.cellselected=!0}this.updateCellProps(u,u)}}}},r.prototype.getColIndex=function(e,t){var i=this.parent.isFrozenGrid(),r=this.parent.getColumnByIndex(t),n=Be(this.parent,r,e);if(n)for(var o=0;o<n.length;o++){if(parseInt(n[o].getAttribute(cs),10)===t)return i&&("movable"===r.getFreezeTableName()?o+=this.parent.getFrozenLeftCount():r.getFreezeTableName()===ds&&(o+=this.parent.getFrozenLeftColumnsCount()+this.parent.getMovableColumnsCount())),o}return-1},r.prototype.getLastColIndex=function(e){var t=this.parent.getFrozenColumns()?this.parent.getMovableDataRows()[e].querySelectorAll("td.e-rowcell"):this.parent.getDataRows()[e].querySelectorAll("td.e-rowcell");return parseInt(t[t.length-1].getAttribute(cs),10)},r.prototype.clearCell=function(){this.clearCellSelection()},r.prototype.cellDeselect=function(e,i,r,n,o){n[0]&&n[0].classList.contains(rs)&&this.updateCheckBoxes(t.closest(n[0],"tr"));var s={cells:n,data:r,cellIndexes:i,foreignKeyData:o,cancel:!1};this.parent.trigger(e,s),this.isPreventCellSelect=s.cancel},r.prototype.updateCellSelection=function(e,i,r){t.isNullOrUndefined(i)||this.addRowCellIndex({rowIndex:i,cellIndex:r}),e.classList.add("e-cellselectionbackground"),e.classList.contains(rs)&&this.updateCheckBoxes(t.closest(e,"tr"),!0),this.addAttribute(e)},r.prototype.addAttribute=function(e){this.target=e,t.isNullOrUndefined(e)||(e.setAttribute("aria-selected","true"),this.preventFocus||this.focus.onClick({target:e},!0))},r.prototype.updateCellProps=function(e,t){this.prevCIdxs=e,this.prevECIdxs=t,this.isCellSelected=this.selectedRowCellIndexes.length&&!0},r.prototype.addRowCellIndex=function(e){for(var t,i,r=0,n=this.selectedRowCellIndexes.length;r<n;r++)if(this.selectedRowCellIndexes[r].rowIndex===e.rowIndex){t=!0,i=r;break}t?this.selectedRowCellIndexes[i].cellIndexes.indexOf(e.cellIndex)<0&&this.selectedRowCellIndexes[i].cellIndexes.push(e.cellIndex):this.selectedRowCellIndexes.push({rowIndex:e.rowIndex,cellIndexes:[e.cellIndex]})},r.prototype.clearCellSelection=function(){if(this.isCellSelected){var e=this.parent,t=this.getSelectedCellsElement(),i=this.selectedRowCellIndexes,r=[],n=[],o=[],s=this.getCurrentBatchRecordChanges(),l=e.isFrozenGrid();this.hideAutoFill();for(var a=0,h=i.length;a<h;a++){r.push(s[i[a].rowIndex]);for(var d=this.getRowObj(i[a].rowIndex),p=0,c=i[a].cellIndexes.length;p<c;p++)if(l){var u=e.getColumnByIndex(i[a].cellIndexes[p]);n.push(Ne(this.parent,u,i[a].rowIndex,i[a].cellIndexes[p]))}else d.cells&&o.push(d.cells[i[a].cellIndexes[p]].foreignKeyData),n.push(e.getCellFromIndex(i[a].rowIndex,i[a].cellIndexes[p]))}if(this.cellDeselect(qt,i,r,n,o),!0===this.isPreventCellSelect)return;for(a=0,h=t.length;a<h;a++)t[a].classList.remove("e-cellselectionbackground"),t[a].removeAttribute("aria-selected");this.bdrElement&&this.showHideBorders("none"),this.selectedRowCellIndexes=[],this.isCellSelected=!1,!this.isDragged&&this.cellselected&&this.cellDeselect(Ht,i,r,n,o)}},r.prototype.getSelectedCellsElement=function(){var e,t=this.parent,i=t.getDataRows();t.isFrozenGrid()&&(e=t.getMovableDataRows(),i=t.addMovableRows(i,e),t.getFrozenMode()===hs&&(i=t.addMovableRows(i,t.getFrozenRightDataRows())));for(var r=[],n=0,o=i.length;n<o;n++)r=r.concat([].slice.call(i[n].getElementsByClassName("e-cellselectionbackground")));return r},r.prototype.mouseMoveHandler=function(e){e.preventDefault();var i,r=this.parent.element.getBoundingClientRect(),n=this.x,o=this.y,s=B(e),l=s.x-r.left,a=s.y-r.top,h=t.closest(e.target,"tr");if(this.isDragged=!0,this.isCellDrag||(h||(h=t.closest(document.elementFromPoint(this.parent.element.offsetLeft+2,e.clientY),"tr")),n>l&&(i=l,l=n,n=i),o>a&&(i=a,a=o,o=i),this.element.style.left=n+"px",this.element.style.top=o+"px",this.element.style.width=l-n+"px",this.element.style.height=a-o+"px"),h&&!e.ctrlKey&&!e.shiftKey){var d=parseInt(h.getAttribute(us),10);if(this.isCellDrag){var p=D(e.target,_o);p&&(this.startAFCell=this.startCell,this.endAFCell=D(e.target,_o),this.selectLikeExcel(e,d,parseInt(p.getAttribute(cs),10)))}else this.hideAutoFill(),this.selectRowsByRange(this.startDIndex,d),this.isRowDragSelected=!0}},r.prototype.selectLikeExcel=function(e,t,i){this.isAutoFillSel?(this.showAFBorders(),this.selectLikeAutoFill(e)):(this.clearCellSelection(),this.selectCellsByRange({rowIndex:this.startDIndex,cellIndex:this.startDCellIndex},{rowIndex:t,cellIndex:i}),this.drawBorders())},r.prototype.drawBorders=function(){"BoxWithBorder"===this.selectionSettings.cellSelectionMode&&this.selectedRowCellIndexes.length&&!this.parent.isEdit?(this.parent.element.classList.add("e-enabledboxbdr"),this.bdrElement||this.createBorders(),this.positionBorders()):this.showHideBorders("none")},r.prototype.isLastCell=function(e){var t=[].slice.call(e.parentElement.querySelectorAll(".e-rowcell:not(.e-hide)"));return t[t.length-1]===e},r.prototype.isLastRow=function(e){var i=[].slice.call(t.closest(e,gs).querySelectorAll(".e-row:not(.e-hiddenrow)"));return e.parentElement===i[i.length-1]},r.prototype.isFirstRow=function(e){var i=[].slice.call(t.closest(e,gs).querySelectorAll(".e-row:not(.e-hiddenrow)"));return e.parentElement===i[0]},r.prototype.isFirstCell=function(e){return[].slice.call(e.parentElement.querySelectorAll(".e-rowcell:not(.e-hide)"))[0]===e},r.prototype.setBorders=function(e,t,i){var r=[].slice.call(e.getElementsByClassName("e-cellselectionbackground")).filter(function(e){return""===e.style.display});if(r.length){var n=this.parent.isFrozenGrid(),o=r[0],s=r[r.length-1],l=o.getBoundingClientRect(),a=s.getBoundingClientRect(),h=o.offsetParent.getBoundingClientRect(),d=!this.isLastRow(s)||"1"!==i&&"2"!==i&&"5"!==i?0:2,p=this.parent.frozenRows&&("1"===i||"2"===i)&&this.isFirstRow(o)?1.5:0,c=n&&("2"===i||"4"===i)&&this.isFirstCell(o)?1:0,u=("Right"!==this.parent.getFrozenMode()||"1"!==i&&"3"!==i)&&(this.parent.getFrozenMode()!==hs||"5"!==i&&"6"!==i)||!this.isFirstCell(o)?0:1;this.parent.enableRtl?(t.style.right=h.right-l.right-c+"px",t.style.width=l.right-a.left+c+1+"px"):(t.style.left=l.left-h.left-c-u+"px",t.style.width=a.right-l.left+c-u+1+"px"),t.style.top=l.top-h.top-p+"px",t.style.height=a.top-l.top>0?a.top-h.top+a.height+1-(l.top-h.top)-d+p+"px":a.height+p-d+1+"px",this.selectDirection+=i}else t.style.display="none"},r.prototype.positionBorders=function(){this.updateStartEndCells(),this.startCell&&this.bdrElement&&this.selectedRowCellIndexes.length&&(this.selectDirection="",this.showHideBorders(""),this.setBorders(this.parent.getContentTable(),this.bdrElement,"1"),this.parent.isFrozenGrid()&&(this.setBorders(this.parent.contentModule.getMovableContent(),this.mcBdrElement,"2"),this.parent.getFrozenMode()===hs&&this.setBorders(this.parent.contentModule.getFrozenRightContent(),this.frcBdrElement,"5")),this.parent.frozenRows&&(this.setBorders(this.parent.getHeaderTable(),this.fhBdrElement,"3"),this.parent.isFrozenGrid()&&(this.setBorders(this.parent.headerModule.getMovableHeader(),this.mhBdrElement,"4"),this.parent.getFrozenMode()===hs&&this.setBorders(this.parent.headerModule.getFrozenRightHeader(),this.frhBdrElement,"6"))),this.applyBorders(this.selectDirection))},r.prototype.applyBothFrozenBorders=function(e){var t=this.parent.enableRtl;switch(e.length){case 6:this.bdrElement.style.borderWidth=t?this.right_bottom:this.bottom_left,this.mcBdrElement.style.borderWidth=this.bottom,this.fhBdrElement.style.borderWidth=t?this.top_right:this.top_left,this.mhBdrElement.style.borderWidth=this.top,this.frcBdrElement.style.borderWidth=t?this.bottom_left:this.right_bottom,this.frhBdrElement.style.borderWidth=t?this.top_left:this.top_right;break;case 4:e.includes("1")&&e.includes("2")&&e.includes("3")&&e.includes("4")&&(this.fhBdrElement.style.borderWidth=t?this.top_right:this.top_left,this.mhBdrElement.style.borderWidth=t?this.top_left:this.top_right,this.bdrElement.style.borderWidth=t?this.right_bottom:this.bottom_left,this.mcBdrElement.style.borderWidth=t?this.bottom_left:this.right_bottom),e.includes("2")&&e.includes("4")&&e.includes("5")&&e.includes("6")&&(this.mcBdrElement.style.borderWidth=t?this.right_bottom:this.bottom_left,this.mhBdrElement.style.borderWidth=t?this.top_right:this.top_left,this.frcBdrElement.style.borderWidth=t?this.bottom_left:this.right_bottom,this.frhBdrElement.style.borderWidth=t?this.top_left:this.top_right);break;case 3:this.bdrElement.style.borderWidth=t?this.top_right_bottom:this.top_bottom_left,this.mcBdrElement.style.borderWidth=this.top_bottom,this.frcBdrElement.style.borderWidth=t?this.top_bottom_left:this.top_right_bottom,this.parent.frozenRows&&(this.fhBdrElement.style.borderWidth=t?this.top_right_bottom:this.top_bottom_left,this.mhBdrElement.style.borderWidth=this.top_bottom,this.frcBdrElement.style.borderWidth=t?this.top_bottom_left:this.top_right_bottom);break;case 2:e.includes("1")&&(this.mcBdrElement.style.borderWidth=t?this.top_bottom_left:this.top_right_bottom,this.parent.frozenRows&&(this.fhBdrElement.style.borderWidth=this.top_right_left)),e.includes("2")&&(this.bdrElement.style.borderWidth=t?this.top_right_bottom:this.top_bottom_left,this.frcBdrElement.style.borderWidth=t?this.top_bottom_left:this.top_right_bottom,this.parent.frozenRows&&(this.mhBdrElement.style.borderWidth=this.top_right_left)),e.includes("3")&&(this.mhBdrElement.style.borderWidth=t?this.top_bottom_left:this.top_right_bottom,this.bdrElement.style.borderWidth=this.right_bottom_left),e.includes("4")&&(this.fhBdrElement.style.borderWidth=t?this.top_right_bottom:this.top_bottom_left,this.frhBdrElement.style.borderWidth=t?this.top_bottom_left:this.top_right_bottom,this.mcBdrElement.style.borderWidth=this.right_bottom_left),e.includes("5")&&(this.mcBdrElement.style.borderWidth=t?this.top_right_bottom:this.top_bottom_left,this.parent.frozenRows&&(this.frhBdrElement.style.borderWidth=this.top_right_left)),e.includes("6")&&(this.mhBdrElement.style.borderWidth=t?this.top_right_bottom:this.top_bottom_left,this.frcBdrElement.style.borderWidth=this.right_bottom_left);break;default:this.bdrElement.style.borderWidth=this.all_border,this.mcBdrElement.style.borderWidth=this.all_border,this.frcBdrElement.style.borderWidth=this.all_border,this.parent.frozenRows&&(this.fhBdrElement.style.borderWidth=this.all_border,this.mhBdrElement.style.borderWidth=this.all_border,this.frhBdrElement.style.borderWidth=this.all_border)}},r.prototype.applyBorders=function(e){var t=this.parent.enableRtl;if(this.parent.getFrozenMode()===hs)this.applyBothFrozenBorders(e);else switch(e.length){case 4:"Right"===this.parent.getFrozenMode()?(this.bdrElement.style.borderWidth=t?this.bottom_left:this.right_bottom,this.mcBdrElement.style.borderWidth=t?this.right_bottom:this.bottom_left,this.fhBdrElement.style.borderWidth=t?this.top_left:this.top_right,this.mhBdrElement.style.borderWidth=t?this.top_right:this.top_left):(this.bdrElement.style.borderWidth=t?this.right_bottom:this.bottom_left,this.mcBdrElement.style.borderWidth=t?this.bottom_left:this.right_bottom,this.fhBdrElement.style.borderWidth=t?this.top_right:this.top_left,this.mhBdrElement.style.borderWidth=t?this.top_left:this.top_right);break;case 2:"Right"===this.parent.getFrozenMode()?(this.bdrElement.style.borderWidth=e.includes("2")?t?this.top_bottom_left:this.top_right_bottom:this.right_bottom_left,this.mcBdrElement.style.borderWidth=e.includes("1")?t?this.top_right_bottom:this.top_bottom_left:this.right_bottom_left,this.parent.frozenRows&&(this.fhBdrElement.style.borderWidth=e.includes("1")?this.top_right_left:t?this.top_bottom_left:this.top_right_bottom,this.mhBdrElement.style.borderWidth=e.includes("2")?this.top_right_left:t?this.top_right_bottom:this.top_bottom_left)):(this.bdrElement.style.borderWidth=e.includes("2")?t?this.top_right_bottom:this.top_bottom_left:this.right_bottom_left,this.parent.isFrozenGrid()&&(this.mcBdrElement.style.borderWidth=e.includes("1")?t?this.top_bottom_left:this.top_right_bottom:this.right_bottom_left),this.parent.frozenRows&&(this.fhBdrElement.style.borderWidth=e.includes("1")?this.top_right_left:t?this.top_right_bottom:this.top_bottom_left,this.parent.isFrozenGrid()&&(this.mhBdrElement.style.borderWidth=e.includes("2")?this.top_right_left:t?this.top_bottom_left:this.top_right_bottom)));break;default:this.bdrElement.style.borderWidth=this.all_border,this.parent.isFrozenGrid()&&(this.mcBdrElement.style.borderWidth=this.all_border),this.parent.frozenRows&&(this.fhBdrElement.style.borderWidth=this.all_border,this.parent.isFrozenGrid()&&(this.mhBdrElement.style.borderWidth=this.all_border))}},r.prototype.createBorders=function(){this.bdrElement||(this.bdrElement=this.parent.getContentTable().parentElement.appendChild(t.createElement("div",{className:"e-xlsel",id:this.parent.element.id+"_bdr",styles:"width: 2px; border-width: 0;"})),this.parent.isFrozenGrid()&&(this.mcBdrElement=this.parent.contentModule.getMovableContent().appendChild(t.createElement("div",{className:"e-xlsel",id:this.parent.element.id+"_mcbdr",styles:"height: 2px; border-width: 0;"})),this.parent.getFrozenMode()===hs&&(this.frcBdrElement=this.parent.contentModule.getFrozenRightContent().appendChild(t.createElement("div",{className:"e-xlsel",id:this.parent.element.id+"_frcbdr",styles:"height: 2px; border-width: 0;"})))),this.parent.frozenRows&&(this.fhBdrElement=this.parent.getHeaderTable().parentElement.appendChild(t.createElement("div",{className:"e-xlsel",id:this.parent.element.id+"_fhbdr",styles:"height: 2px;"}))),this.parent.frozenRows&&this.parent.isFrozenGrid()&&(this.mhBdrElement=this.parent.headerModule.getMovableHeader().appendChild(t.createElement("div",{className:"e-xlsel",id:this.parent.element.id+"_mhbdr",styles:"height: 2px;"})),this.parent.getFrozenMode()===hs&&(this.frhBdrElement=this.parent.headerModule.getFrozenRightHeader().appendChild(t.createElement("div",{className:"e-xlsel",id:this.parent.element.id+"_frhbdr",styles:"height: 2px;"})))))},r.prototype.showHideBorders=function(e){this.bdrElement&&(this.bdrElement.style.display=e,this.parent.isFrozenGrid()&&(this.mcBdrElement.style.display=e,this.parent.getFrozenMode()===hs&&(this.frcBdrElement.style.display=e)),this.parent.frozenRows&&(this.fhBdrElement.style.display=e),this.parent.frozenRows&&this.parent.isFrozenGrid()&&(this.mhBdrElement.style.display=e,this.parent.getFrozenMode()===hs&&(this.frhBdrElement.style.display=e)))},r.prototype.drawAFBorders=function(){this.bdrAFBottom||this.createAFBorders(),this.positionAFBorders()},r.prototype.positionAFBorders=function(){if(this.startCell&&this.bdrAFLeft){var e=this.startAFCell.getBoundingClientRect(),t=this.endAFCell.getBoundingClientRect(),i=t.top-e.top>0?1:0,r=t.top-e.top>=0&&(D(this.startAFCell,Yo)||D(this.startAFCell,"e-frozencontent"))&&this.isFirstRow(this.startAFCell)?1.5:0,n=(D(this.startAFCell,Yo)||D(this.startAFCell,Jo))&&this.isFirstCell(this.startAFCell)?1:0,o=this.isLastRow(this.endAFCell)&&(D(this.endAFCell,Yo)||D(this.endAFCell,"e-frozencontent"))?2:0,s=this.startAFCell.offsetParent.getBoundingClientRect(),l=this.parent.element.getBoundingClientRect(),a=this.startAFCell.offsetParent.parentElement.scrollTop,h=this.startAFCell.offsetParent.parentElement.scrollLeft,d=a-this.startAFCell.offsetTop,p=h-this.startAFCell.offsetLeft,c=this.parent.element.clientHeight,u=this.parent.element.clientWidth;d=d>0?Math.floor(d)-1:0,p=p>0?p:0;var g=e.left-l.left;if(this.parent.enableRtl){var f=D(this.startAFCell,Yo)||D(this.startAFCell,Jo)?e.right-this.startAFCell.offsetParent.parentElement.getBoundingClientRect().width-l.left:0;this.bdrAFLeft.style.right=l.right-t.right-2+t.width+"px",this.bdrAFLeft.style.width=u<=parseInt(this.bdrAFLeft.style.right,10)?"0px":"2px",this.bdrAFRight.style.right=l.right-e.right-n+f-1+"px",this.bdrAFTop.style.left=t.left-l.left-.5+"px",this.bdrAFTop.style.width=parseInt(this.bdrAFLeft.style.right,10)-parseInt(this.bdrAFRight.style.right,10)-n+1+"px",parseInt(this.bdrAFTop.style.left,10)<0&&(this.bdrAFTop.style.width=parseInt(this.bdrAFTop.style.width,10)+parseInt(this.bdrAFTop.style.left,10)+"px",this.bdrAFTop.style.left="0px")}else if(this.bdrAFLeft.style.left=g-n+p-1+"px",this.bdrAFRight.style.left=t.left-l.left-2+t.width+"px",this.bdrAFRight.style.width=u<=parseInt(this.bdrAFRight.style.left,10)?"0px":"2px",this.bdrAFTop.style.left=g+p-.5+"px",this.bdrAFTop.style.width=parseInt(this.bdrAFRight.style.left,10)-parseInt(this.bdrAFLeft.style.left,10)-n+1+"px",u<=parseInt(this.bdrAFTop.style.width,10)+parseInt(this.bdrAFTop.style.left,10)){var m=parseInt(this.bdrAFTop.style.width,10)+parseInt(this.bdrAFTop.style.left,10)-u;this.bdrAFTop.style.width=parseInt(this.bdrAFTop.style.width,10)-m+"px"}if(this.bdrAFLeft.style.top=e.top-l.top-r+d+"px",this.bdrAFLeft.style.height=t.top-e.top>0?t.top-s.top+t.height+1-(e.top-s.top)+r-o-d+"px":t.height+r-o-d+"px",this.bdrAFRight.style.top=this.bdrAFLeft.style.top,this.bdrAFRight.style.height=parseInt(this.bdrAFLeft.style.height,10)+"px",this.bdrAFTop.style.top=this.bdrAFRight.style.top,this.bdrAFBottom.style.left=this.bdrAFTop.style.left,this.bdrAFBottom.style.top=parseFloat(this.bdrAFLeft.style.top)+parseFloat(this.bdrAFLeft.style.height)-i-1+"px",this.bdrAFBottom.style.width=c<=parseFloat(this.bdrAFBottom.style.top)?"0px":this.bdrAFTop.style.width,c<=parseInt(this.bdrAFLeft.style.height,10)+parseInt(this.bdrAFLeft.style.top,10)){var y=parseInt(this.bdrAFLeft.style.height,10)+parseInt(this.bdrAFLeft.style.top,10)-c;this.bdrAFLeft.style.height=parseInt(this.bdrAFLeft.style.height,10)-y+"px",this.bdrAFRight.style.height=parseInt(this.bdrAFLeft.style.height,10)+"px"}}},r.prototype.createAFBorders=function(){this.bdrAFLeft||(this.bdrAFLeft=this.parent.element.appendChild(t.createElement("div",{className:"e-xlselaf",id:this.parent.element.id+"_bdrafleft",styles:"width: 2px;"})),this.bdrAFRight=this.parent.element.appendChild(t.createElement("div",{className:"e-xlselaf",id:this.parent.element.id+"_bdrafright",styles:"width: 2px;"})),this.bdrAFBottom=this.parent.element.appendChild(t.createElement("div",{className:"e-xlselaf",id:this.parent.element.id+"_bdrafbottom",styles:"height: 2px;"})),this.bdrAFTop=this.parent.element.appendChild(t.createElement("div",{className:"e-xlselaf",id:this.parent.element.id+"_bdraftop",styles:"height: 2px;"})))},r.prototype.showAFBorders=function(){this.bdrAFLeft&&(this.bdrAFLeft.style.display="",this.bdrAFRight.style.display="",this.bdrAFBottom.style.display="",this.bdrAFTop.style.display="")},r.prototype.hideAFBorders=function(){this.bdrAFLeft&&(this.bdrAFLeft.style.display="none",this.bdrAFRight.style.display="none",this.bdrAFBottom.style.display="none",this.bdrAFTop.style.display="none")},r.prototype.updateValue=function(e,t,i){var r=this.createBeforeAutoFill(e,t,i);if(!r.cancel){var n=this.parent.getColumnByIndex(t);this.parent.editModule&&i&&("number"===n.type?this.parent.editModule.updateCell(e,n.field,parseFloat(r.value)):this.parent.editModule.updateCell(e,n.field,r.value))}},r.prototype.createBeforeAutoFill=function(e,t,i){var r={column:this.parent.getColumnByIndex(t),value:i.innerText};return this.parent.trigger(ui,r),r},r.prototype.getAutoFillCells=function(e,t){var i=".e-cellselectionbackground",r=[].slice.call(this.parent.getDataRows()[e].querySelectorAll(i));return this.parent.isFrozenGrid()&&(r=r.concat([].slice.call(this.parent.getMovableDataRows()[e].querySelectorAll(i))),this.parent.getFrozenMode()===hs&&(r=r.concat([].slice.call(this.parent.getFrozenRightDataRows()[e].querySelectorAll(i))))),r},r.prototype.selectLikeAutoFill=function(e,t){var i=parseInt(D(this.startAFCell,is).getAttribute(us),10),r=parseInt(this.startAFCell.getAttribute(cs),10),n=parseInt(D(this.endAFCell,is).getAttribute(us),10),o=parseInt(this.endAFCell.getAttribute(cs),10),s=this.selectedRowCellIndexes.length-1,l=this.selectedRowCellIndexes[0].cellIndexes.length-1;switch(!0){case!t&&this.endAFCell.classList.contains("e-cellselectionbackground")&&!!D(e.target,_o):this.startAFCell=this.parent.getCellFromIndex(i,r),this.endAFCell=this.parent.getCellFromIndex(i+s,r+l),this.drawAFBorders();break;case this.autoFillRLselection&&r+l<o&&o-r-l+1>n-i-s&&o-r-l+1>i-n:if(this.endAFCell=this.parent.getCellFromIndex(i+s,o),n=parseInt(D(this.endAFCell,is).getAttribute(us),10),o=parseInt(this.endAFCell.getAttribute(cs),10),t){for(var a=parseInt(this.endCell.getAttribute(cs),10),h=i;h<=n;h++)for(var d=this.getAutoFillCells(h,r),p=0,c=a+1;c<=o;c++)p>l&&(p=0),this.updateValue(h,c,d[p]),p++;this.selectCellsByRange({rowIndex:i,cellIndex:this.startCellIndex},{rowIndex:n,cellIndex:o})}else this.drawAFBorders();break;case this.autoFillRLselection&&r>o&&r-o+1>n-i-s&&r-o+1>i-n:if(this.startAFCell=this.parent.getCellFromIndex(i,o),this.endAFCell=this.endCell,t){for(h=i;h<=i+s;h++){(d=this.getAutoFillCells(h,r)).reverse();for(p=0,c=this.startCellIndex-1;c>=o;c--)p>l&&(p=0),this.updateValue(h,c,d[p]),p++}this.selectCellsByRange({rowIndex:i,cellIndex:o},{rowIndex:i+s,cellIndex:this.startCellIndex+l})}else this.drawAFBorders();break;case i>n:if(this.startAFCell=this.parent.getCellFromIndex(n,r),this.endAFCell=this.endCell,t){var u=g=parseInt(this.endCell.parentElement.getAttribute(us),10);for(h=i-1;h>=n;h--){u===this.startIndex-1&&(u=g);d=this.getAutoFillCells(u,r),p=0;u--;for(c=this.startCellIndex;c<=this.startCellIndex+l;c++)this.updateValue(h,c,d[p]),p++}this.selectCellsByRange({rowIndex:n,cellIndex:r+l},{rowIndex:i+s,cellIndex:r})}else this.drawAFBorders();break;default:if(this.endAFCell=this.parent.getCellFromIndex(n,r+l),t){var g=parseInt(this.endCell.parentElement.getAttribute(us),10);for(u=this.startIndex,h=g+1;h<=n;h++){u===g+1&&(u=this.startIndex);d=this.getAutoFillCells(u,r);u++;p=0;for(var f=this.startCellIndex;f<=this.startCellIndex+l;f++)this.updateValue(h,f,d[p]),p++}this.selectCellsByRange({rowIndex:g-s,cellIndex:r},{rowIndex:n,cellIndex:r+l})}else this.drawAFBorders()}},r.prototype.mouseUpHandler=function(e){if(document.body.classList.remove("e-disableuserselect"),this.element&&t.remove(this.element),this.isDragged&&1===this.selectedRowCellIndexes.length&&1===this.selectedRowCellIndexes[0].cellIndexes.length?this.mUPTarget=D(e.target,_o):this.mUPTarget=null,this.isDragged&&!this.isAutoFillSel&&"Cell"===this.selectionSettings.mode&&e.target.classList.contains(_o)){var i=e.target,r=parseInt(i.parentElement.getAttribute(us),10),n=parseInt(i.getAttribute(cs),10);this.isDragged=!1,this.clearCellSelection(),this.selectCellsByRange({rowIndex:this.startDIndex,cellIndex:this.startDCellIndex},{rowIndex:r,cellIndex:n})}if(this.isDragged=!1,this.updateAutoFillPosition(),this.isAutoFillSel){var o=D(e.target,_o);this.endAFCell=o||(this.endCell===this.endAFCell?this.startAFCell:this.endAFCell),this.startAFCell=this.startCell,this.updateStartCellsIndex(),this.selectLikeAutoFill(e,!0),this.updateAutoFillPosition(),this.hideAFBorders(),this.positionBorders(),this.isAutoFillSel=!1}t.EventHandler.remove(this.parent.getContent(),"mousemove",this.mouseMoveHandler),this.parent.frozenRows&&t.EventHandler.remove(this.parent.getHeaderContent(),"mousemove",this.mouseMoveHandler),t.EventHandler.remove(document,"mouseup",this.mouseUpHandler)},r.prototype.hideAutoFill=function(){this.autofill&&(this.autofill.style.display="none")},r.prototype.updateAutoFillPosition=function(){if(this.parent.enableAutoFill&&!this.parent.isEdit&&this.selectionSettings.cellSelectionMode.indexOf("Box")>-1&&!this.isRowType()&&!this.isSingleSel()&&this.selectedRowCellIndexes.length){var e=parseInt(this.target.getAttribute(cs),10),i=parseInt(this.target.getAttribute("index"),10),r=this.selectedRowCellIndexes[this.selectedRowCellIndexes.length-1].rowIndex,n=this.getAutoFillCells(r,e).filter(function(e){return""===e.style.display}),o=this.parent.getColumnByIndex(e),s="movable"===o.getFreezeTableName(),l=i<this.parent.frozenRows,a=this.parent.getFrozenMode()===hs&&o.getFreezeTableName()===ds;t.select("#"+this.parent.element.id+"_autofill",D(this.target,ts))||(t.select("#"+this.parent.element.id+"_autofill",this.parent.element)&&t.select("#"+this.parent.element.id+"_autofill",this.parent.element).remove(),this.autofill=t.createElement("div",{className:"e-autofill",id:this.parent.element.id+"_autofill"}),this.autofill.style.display="none",l?s?this.parent.headerModule.getMovableHeader().appendChild(this.autofill):this.parent.getHeaderTable().parentElement.appendChild(this.autofill):s?this.parent.contentModule.getMovableContent().appendChild(this.autofill):this.parent.getContentTable().parentElement.appendChild(this.autofill),a&&(l?this.parent.getFrozenRightHeader().appendChild(this.autofill):this.parent.getFrozenRightContent().appendChild(this.autofill)));var h=n[n.length-1];if(h&&h.offsetParent){var d=h.getBoundingClientRect(),p=h.offsetParent.getBoundingClientRect(),c=this.isLastCell(h)?4:0,u=this.isLastRow(h)?3:0;this.parent.enableRtl?this.autofill.style.right=p.right-d.right+d.width-4-c+"px":this.autofill.style.left=d.left-p.left+d.width-4-c+"px",this.autofill.style.top=d.top-p.top+d.height-5-u+"px"}this.autofill.style.display=""}else this.hideAutoFill()},r.prototype.mouseDownHandler=function(e){this.mouseButton=e.button;var i,r=e.target,n=this.parent,o=D(r,"e-grid");if(!(o&&o.id!==n.element.id||D(r,Xo)&&!this.parent.frozenRows||D(r,"e-editedbatchcell")||D(r,ns))){if((e.shiftKey||e.ctrlKey)&&e.preventDefault(),D(r,_o)&&!e.shiftKey&&!e.ctrlKey){if(n.selectionSettings.cellSelectionMode.indexOf("Box")>-1&&!this.isRowType()&&!this.isSingleSel())this.isCellDrag=!0,i=!0;else if(n.allowRowDragAndDrop&&!n.isEdit&&!this.parent.selectionSettings.checkboxOnly){if(this.isRowDragSelected=!1,!this.isRowType()||this.isSingleSel()||t.closest(r,"td").classList.contains("e-selectionbackground"))return void(this.isDragged=!1);i=!0,this.element=this.parent.createElement("div",{className:"e-griddragarea"}),n.getContent().appendChild(this.element)}i&&this.enableDrag(e,!0)}this.updateStartEndCells(),(r.classList.contains("e-autofill")||r.classList.contains("e-xlsel"))&&(this.isCellDrag=!0,this.isAutoFillSel=!0,this.enableDrag(e))}},r.prototype.updateStartEndCells=function(){var e=[].slice.call(this.parent.element.getElementsByClassName("e-cellselectionbackground"));this.startCell=e[0],this.endCell=e[e.length-1],this.startCell&&(this.startIndex=parseInt(this.startCell.parentElement.getAttribute(us),10),this.startCellIndex=parseInt(D(this.startCell,_o).getAttribute(cs),10))},r.prototype.updateStartCellsIndex=function(){this.startCell&&(this.startIndex=parseInt(this.startCell.parentElement.getAttribute(us),10),this.startCellIndex=parseInt(D(this.startCell,_o).getAttribute(cs),10))},r.prototype.enableDrag=function(e,i){var r=this.parent;if(i){var n=t.closest(e.target,"tr");this.startDIndex=parseInt(n.getAttribute(us),10),this.startDCellIndex=parseInt(D(e.target,_o).getAttribute(cs),10)}document.body.classList.add("e-disableuserselect");var o=r.element.getBoundingClientRect(),s=B(e);this.x=s.x-o.left,this.y=s.y-o.top,t.EventHandler.add(r.getContent(),"mousemove",this.mouseMoveHandler,this),this.parent.frozenRows&&t.EventHandler.add(r.getHeaderContent(),"mousemove",this.mouseMoveHandler,this),t.EventHandler.add(document,"mouseup",this.mouseUpHandler,this)},r.prototype.clearSelAfterRefresh=function(e){var t=this.parent.enableInfiniteScrolling&&"infiniteScroll"===e.requestType;"virtualscroll"===e.requestType||this.parent.isPersistSelection||t||this.clearSelection()},r.prototype.addEventListener=function(){this.parent.isDestroyed||(this.evtHandlers=[{event:Fi,handler:this.enableAfterRender},{event:Si,handler:this.initializeSelection},{event:"rowselected",handler:this.onActionComplete},{event:"cellselected",handler:this.onActionComplete},{event:Ii,handler:this.onPropertyChanged},{event:Gi,handler:this.onCellFocused},{event:_r,handler:this.clearSelAfterRefresh},{event:Ji,handler:this.columnPositionChanged},{event:xi,handler:this.initialEnd},{event:$i,handler:this.rowsRemoved},{event:Di,handler:this.refreshHeader},{event:Ki,handler:this.destroy}],_e(this.parent,this.evtHandlers,!0,this),this.actionBeginFunction=this.actionBegin.bind(this),this.actionCompleteFunction=this.actionComplete.bind(this),this.parent.addEventListener(zt,this.actionBeginFunction),this.parent.addEventListener(Dt,this.actionCompleteFunction),this.addEventListener_checkbox())},r.prototype.removeEventListener=function(){this.parent.isDestroyed||(_e(this.parent,this.evtHandlers,!1),this.parent.removeEventListener(zt,this.actionBeginFunction),this.parent.removeEventListener(Dt,this.actionCompleteFunction),this.removeEventListener_checkbox())},r.prototype.wireEvents=function(){this.isMacOS=-1!==navigator.userAgent.indexOf("Mac OS"),this.isMacOS&&(t.EventHandler.add(this.parent.element,"keydown",this.keyDownHandler,this),t.EventHandler.add(this.parent.element,"keyup",this.keyUpHandler,this))},r.prototype.unWireEvents=function(){this.isMacOS&&(t.EventHandler.remove(this.parent.element,"keydown",this.keyDownHandler),t.EventHandler.remove(this.parent.element,"keyup",this.keyUpHandler))},r.prototype.columnPositionChanged=function(){this.parent.isPersistSelection||this.clearSelection()},r.prototype.refreshHeader=function(){this.setCheckAllState()},r.prototype.rowsRemoved=function(e){for(var t=0;t<e.records.length;t++)delete this.selectedRowState[e.records[t][this.primaryKey]],--this.totalRecordsCount;this.setCheckAllState()},r.prototype.beforeFragAppend=function(e){"virtualscroll"===e.requestType||this.parent.isPersistSelection||this.clearSelection()},r.prototype.getCheckAllBox=function(){return this.parent.getHeaderContent().querySelector(".e-checkselectall")},r.prototype.enableAfterRender=function(e){e.module===this.getModuleName()&&e.enable&&(this.render(),this.initPerisistSelection())},r.prototype.render=function(e){t.EventHandler.add(this.parent.getContent(),"mousedown",this.mouseDownHandler,this),t.EventHandler.add(this.parent.getHeaderContent(),"mousedown",this.mouseDownHandler,this)},r.prototype.onPropertyChanged=function(e){if(e.module===this.getModuleName()){var i=this.parent;t.isNullOrUndefined(e.properties.type)||"Single"!==this.selectionSettings.type||(this.selectedRowCellIndexes.length>1&&(this.clearCellSelection(),this.prevCIdxs=void 0),this.selectedRowIndexes.length>1&&(this.clearRowSelection(),this.prevRowIndex=void 0),this.selectedColumnsIndexes.length>1&&(this.clearColumnSelection(),this.prevColIndex=void 0),this.enableSelectMultiTouch=!1,this.hidePopUp()),t.isNullOrUndefined(e.properties.mode)&&t.isNullOrUndefined(e.properties.cellSelectionMode)||(this.clearSelection(),this.prevRowIndex=void 0,this.prevCIdxs=void 0,this.prevColIndex=void 0),this.isPersisted=!0,this.checkBoxSelectionChanged(),this.isPersisted=!1,this.parent.isCheckBoxSelection||this.initPerisistSelection();this.parent.getColumns().filter(function(e){return"checkbox"===e.type}).length&&(i.isCheckBoxSelection=!("ResetOnRowClick"===this.selectionSettings.checkboxMode)),this.drawBorders()}},r.prototype.hidePopUp=function(){this.parent.element.querySelector(".e-gridpopup").getElementsByClassName("e-rowselect").length&&(this.parent.element.querySelector(".e-gridpopup").style.display="none")},r.prototype.initialEnd=function(e){var t=this.parent.isFrozenGrid(),i=this.parent.getFrozenMode()===hs;(!t||t&&!i&&!e.args.isFrozen||i&&e.args.renderFrozenRightContent)&&!this.selectedRowIndexes.length&&(this.parent.off(xi,this.initialEnd),this.selectRow(this.parent.selectedRowIndex))},r.prototype.checkBoxSelectionChanged=function(){var e=this.parent;e.off(xi,this.checkBoxSelectionChanged);var i=e.getColumns().filter(function(e){return"checkbox"===e.type});i.length>0&&(e.isCheckBoxSelection=!0,this.chkField=i[0].field,this.totalRecordsCount=this.parent.pageSettings.totalRecordsCount,t.isNullOrUndefined(this.totalRecordsCount)&&(this.totalRecordsCount=this.getCurrentBatchRecordChanges().length),this.isSingleSel()?(e.selectionSettings.type="Multiple",e.dataBind()):this.initPerisistSelection()),e.isCheckBoxSelection||this.isPersisted||(this.chkField=null,this.initPerisistSelection())},r.prototype.initPerisistSelection=function(){var e=this.parent;this.parent.selectionSettings.persistSelection&&this.parent.getPrimaryKeyFieldNames().length>0?(e.isPersistSelection=!0,this.ensureCheckboxFieldSelection()):this.parent.getPrimaryKeyFieldNames().length>0?(e.isPersistSelection=!1,this.ensureCheckboxFieldSelection()):(e.isPersistSelection=!1,this.selectedRowState={})},r.prototype.ensureCheckboxFieldSelection=function(){var e=this.parent;if(this.primaryKey=this.parent.getPrimaryKeyFieldNames()[0],!e.enableVirtualization&&this.chkField&&(e.isPersistSelection&&0===Object.keys(this.selectedRowState).length||!e.isPersistSelection)){var t=this.parent.getDataModule(),r=(new i.Query).where(this.chkField,"equal",!0);r.params||(r.params=this.parent.query.params);var n=t.getData({},r),o=this;this.parent.showSpinner(),n.then(function(e){o.dataSuccess(e.result),o.refreshPersistSelection(),o.parent.hideSpinner()})}},r.prototype.dataSuccess=function(e){for(var i=0;i<e.length;i++)t.isNullOrUndefined(this.selectedRowState[e[i][this.primaryKey]])&&e[i][this.chkField]&&(this.selectedRowState[e[i][this.primaryKey]]=e[i][this.chkField]);this.persistSelectedData=e},r.prototype.setRowSelection=function(e){if(!this.parent.getDataModule().isRemote())if(e)if(this.parent.groupSettings.columns.length)for(var t=0,i=this.getData().records;t<i.length;t++){var r=i[t];this.selectedRowState[r[this.primaryKey]]=!0}else for(var n=0,o=this.getData();n<o.length;n++){r=o[n];this.selectedRowState[r[this.primaryKey]]=!0}else this.selectedRowState={}},r.prototype.getData=function(){return this.parent.getDataModule().dataManager.executeLocal(this.parent.getDataModule().generateQuery(!0))},r.prototype.refreshPersistSelection=function(){var e=this.parent.getRows();if(this.parent.isCheckBoxSelection&&this.parent.isFrozenGrid()){if(this.parent.getMovableContentTbody().querySelector(".e-checkselect")&&(e=this.parent.getMovableRows()),this.parent.getFrozenMode()===hs){this.parent.getFrozenRightContentTbody().querySelector(".e-checkselect")&&(e=this.parent.getFrozenRightRows())}}if(this.totalRecordsCount=this.parent.getCurrentViewRecords().length,this.parent.allowPaging&&(this.totalRecordsCount=this.parent.pageSettings.totalRecordsCount),null!==e&&e.length>0&&(this.parent.isPersistSelection||this.chkField)){for(var i=[],r=0;r<e.length;r++){var n=this.getRowObj(e[r]),o=n&&n.data?n.data[this.primaryKey]:null;if(null===o)return;var s=void 0,l=e[r].querySelector(".e-checkselect");this.selectedRowState[o]||"Check"===this.parent.checkAllRows&&this.selectedRowState[o]&&this.totalRecordsCount===Object.keys(this.selectedRowState).length&&this.chkAllCollec.indexOf(o)<0||"Uncheck"===this.parent.checkAllRows&&this.chkAllCollec.indexOf(o)>0||"Intermediate"===this.parent.checkAllRows&&!t.isNullOrUndefined(this.chkField)&&n.data[this.chkField]?(i.push(parseInt(e[r].getAttribute(us),10)),s=!0):(s=!1,this.checkedTarget!==l&&this.parent.isCheckBoxSelection&&l&&ie(l.nextElementSibling,s)),this.updatePersistCollection(e[r],s)}this.isSingleSel()&&i.length>0?this.selectRow(i[0],!0):this.selectRows(i)}this.parent.isCheckBoxSelection&&this.getCurrentBatchRecordChanges().length>0&&this.setCheckAllState()},r.prototype.actionBegin=function(e){if("save"===e.requestType&&this.parent.isPersistSelection){var i=this.parent.element.querySelector(".e-edit-checkselect");if(!t.isNullOrUndefined(i)){var r=t.closest(i,"."+ns);if(r){"Dialog"===this.parent.editSettings.mode&&(r=this.parent.element.querySelector(".e-dlgeditrow"));var n=this.getRowObj(r);if(!n)return;this.selectedRowState[n.data[this.primaryKey]]=n.isSelected=i.checked}else this.isCheckedOnAdd=i.checked}}},r.prototype.actionComplete=function(e){if("save"===e.requestType&&this.parent.isPersistSelection){if("add"===e.action&&this.isCheckedOnAdd){var i=this.parent.getRowObjectFromUID(this.parent.getRows()[e.selectedRow].getAttribute("data-uid"));this.selectedRowState[i.data[this.primaryKey]]=i.isSelected=this.isCheckedOnAdd}this.refreshPersistSelection()}if("delete"===e.requestType&&this.parent.isPersistSelection){for(var r=e.data.slice(),n=0;n<r.length;n++)t.isNullOrUndefined(r[n][this.primaryKey])||this.updatePersistDelete(r[n][this.primaryKey]);this.setCheckAllState(),this.totalRecordsCount=this.parent.pageSettings.totalRecordsCount}"paging"===e.requestType&&(this.prevRowIndex=void 0,this.prevCIdxs=void 0,this.prevECIdxs=void 0)},r.prototype.onDataBound=function(){if(!this.parent.enableVirtualization&&this.parent.isPersistSelection&&(this.selectedRecords.length&&(this.isPrevRowSelection=!0),this.refreshPersistSelection()),this.parent.enableVirtualization&&this.setCheckAllState(),this.initialRowSelection=!!(this.isRowType()&&this.parent.element.querySelectorAll(".e-selectionbackground")&&this.parent.getSelectedRows().length),this.parent.isCheckBoxSelection&&!this.initialRowSelection){for(var e=this.parent.getRowsObject(),t=[],i=0;i<e.length;i++)e[i].isSelected&&t.push(i);t.length&&this.selectRows(t),this.initialRowSelection=!0}},r.prototype.updatePersistSelectedData=function(e){if(this.parent.isPersistSelection){for(var t=this.parent.getRows(),i=0;i<t.length;i++)this.updatePersistCollection(t[i],e);"Uncheck"===this.parent.checkAllRows?(this.setRowSelection(!1),this.persistSelectedData=this.parent.getDataModule().isRemote()?this.persistSelectedData:[]):"Check"===this.parent.checkAllRows&&(this.setRowSelection(!0),this.persistSelectedData=this.parent.getDataModule().isRemote()?this.persistSelectedData:this.parent.groupSettings.columns.length?this.getData().records.slice():this.getData().slice())}},r.prototype.checkSelectAllAction=function(e){var i=this.getRenderer(),r=this.parent.element.querySelector(".e-gridform");if(this.checkedTarget=this.getCheckAllBox(),e&&this.getCurrentBatchRecordChanges().length?(this.parent.checkAllRows="Check",this.updatePersistSelectedData(e),this.selectRowsByRange(i.getVirtualRowIndex(0),i.getVirtualRowIndex(this.getCurrentBatchRecordChanges().length-1))):(this.parent.checkAllRows="Uncheck",this.updatePersistSelectedData(e),this.clearSelection()),this.chkAllCollec=[],!t.isNullOrUndefined(r)){var n=r.querySelector(".e-edit-checkselect");t.isNullOrUndefined(n)||ie(n.nextElementSibling,e)}},r.prototype.checkSelectAll=function(e){var t=this,i=this.getCheckAllStatus(e),r="Check"===i;this.isHeaderCheckboxClicked=!0,"Intermediate"===i&&(r=this.getCurrentBatchRecordChanges().some(function(e){return e[t.primaryKey]in t.selectedRowState})),this.parent.isPersistSelection&&this.parent.allowPaging&&(this.totalRecordsCount=this.parent.pageSettings.totalRecordsCount),this.checkSelectAllAction(!r),this.target=null,this.getCurrentBatchRecordChanges().length>0&&this.setCheckAllState(),this.triggerChkChangeEvent(e,!r)},r.prototype.getCheckAllStatus=function(e){var t=e?e.nextElementSibling.classList:this.getCheckAllBox().nextElementSibling.classList;return t.contains("e-check")?"Check":t.contains("e-uncheck")?"Uncheck":t.contains("e-stop")?"Intermediate":"None"},r.prototype.checkSelect=function(e){var i=t.closest(this.checkedTarget,"."+_o),r=this.parent;this.isMultiCtrlRequest=!0;var n=0;if(this.isHeaderCheckboxClicked=!1,ae(r)){var o=i.parentElement.getAttribute("data-uid");n=r.getRows().map(function(e){return e.getAttribute("data-uid")}).indexOf(o)}else n=parseInt(i.parentElement.getAttribute(us),10);this.parent.isPersistSelection&&this.parent.element.getElementsByClassName(os).length>0&&"Top"===this.parent.editSettings.newRowPosition&&++n,this.rowCellSelectionHandler(n,parseInt(i.getAttribute(cs),10)),this.moveIntoUncheckCollection(t.closest(i,"."+is)),this.setCheckAllState(),this.isMultiCtrlRequest=!1,this.triggerChkChangeEvent(e,e.nextElementSibling.classList.contains("e-check"))},r.prototype.moveIntoUncheckCollection=function(e){if("Check"===this.parent.checkAllRows||"Uncheck"===this.parent.checkAllRows){var t=this.getRowObj(e),i=t&&t.data?t.data[this.primaryKey]:null;if(!i)return;this.chkAllCollec.indexOf(i)<0?this.chkAllCollec.push(i):this.chkAllCollec.splice(this.chkAllCollec.indexOf(i),1)}},r.prototype.triggerChkChangeEvent=function(e,t){this.parent.trigger(ci,{checked:t,selectedRowIndexes:this.parent.getSelectedRowIndexes(),target:e}),this.parent.isEdit||(this.checkedTarget=null)},r.prototype.updateSelectedRowIndex=function(e){if(this.parent.isCheckBoxSelection&&(this.parent.enableVirtualization||this.parent.enableInfiniteScrolling)&&!this.parent.getDataModule().isRemote())if("Check"===this.parent.checkAllRows){this.selectedRowIndexes=[];for(var t=this.getData().length,i=0;i<t;i++)this.selectedRowIndexes.push(i)}else if("Uncheck"===this.parent.checkAllRows)this.selectedRowIndexes=[];else{var r=this.parent.getRowByIndex(e);if(e&&r&&"false"===r.getAttribute("aria-selected")){var n=this.selectedRowIndexes.indexOf(e);this.selectedRowIndexes.splice(n,1)}}},r.prototype.isAllSelected=function(){for(var e=this.getData(),t=0;t<e.length;t++){var i=e[t][this.primaryKey];if(!this.selectedRowState[i])return!1}return!0},r.prototype.setCheckAllState=function(e,i){if(this.parent.isCheckBoxSelection||"ResetOnRowClick"===this.parent.selectionSettings.checkboxMode){var r=!0,n=Object.keys(this.selectedRowState).length;this.parent.isPersistSelection||(n=this.selectedRowIndexes.length,this.totalRecordsCount=this.getCurrentBatchRecordChanges().length),this.parent.isPersistSelection&&!this.parent.getDataModule().isRemote()&&(this.parent.searchSettings.key.length||this.parent.filterSettings.columns.length)&&(r=this.isAllSelected());var o=this.getCheckAllBox();if(o){var s=o.nextElementSibling;t.removeClass([s],["e-check","e-stop","e-uncheck"]),ee(o,!1),o.indeterminate=!1,r&&n===this.totalRecordsCount&&this.totalRecordsCount||(this.parent.enableVirtualization||this.parent.enableInfiniteScrolling)&&!this.parent.allowPaging&&!this.parent.getDataModule().isRemote()&&this.getData().length&&n===this.getData().length?(t.addClass([s],["e-check"]),ee(o,!0),i&&this.getRenderer().setSelection(null,!0,!0),this.parent.checkAllRows="Check"):!this.selectedRowIndexes.length||0===n&&0===this.getCurrentBatchRecordChanges().length?(t.addClass([s],["e-uncheck"]),i&&this.getRenderer().setSelection(null,!1,!0),this.parent.checkAllRows="Uncheck",0===n&&0===this.getCurrentBatchRecordChanges().length?t.addClass([s.parentElement],["e-checkbox-disabled"]):t.removeClass([s.parentElement],["e-checkbox-disabled"])):(t.addClass([s],["e-stop"]),this.parent.checkAllRows="Intermediate",o.indeterminate=!0),!this.parent.enableVirtualization&&!this.parent.enableInfiniteScrolling||this.parent.allowPaging||this.parent.getDataModule().isRemote()||this.updateSelectedRowIndex(e)}}},r.prototype.keyDownHandler=function(e){(("chrome"===t.Browser.info.name||"safari"===t.Browser.info.name)&&(91===e.keyCode||93===e.keyCode)||"opera"===t.Browser.info.name&&17===e.keyCode||"mozilla"===t.Browser.info.name&&224===e.keyCode)&&(this.cmdKeyPressed=!0)},r.prototype.keyUpHandler=function(e){(("chrome"===t.Browser.info.name||"safari"===t.Browser.info.name)&&(91===e.keyCode||93===e.keyCode)||"opera"===t.Browser.info.name&&17===e.keyCode||"mozilla"===t.Browser.info.name&&224===e.keyCode)&&(this.cmdKeyPressed=!1)},r.prototype.clickHandler=function(e){var i=e.target;this.actualTarget=i,this.selectionSettings.persistSelection&&(this.deSelectedData=S(this.persistSelectedData)),(D(i,is)||D(i,"e-headerchkcelldiv")||this.selectionSettings.allowColumnSelection&&i.classList.contains("e-headercell"))&&(this.isInteracted=!0),this.isMultiCtrlRequest=e.ctrlKey||this.enableSelectMultiTouch||this.isMacOS&&this.cmdKeyPressed,this.isMultiShiftRequest=e.shiftKey,this.popUpClickHandler(e);var r=!1;this.preventFocus=!0;var n,o=D(i,"e-checkbox-wrapper");if(this.checkSelectAllClicked=!!(o&&o.getElementsByClassName("e-checkselectall")||this.selectionSettings.persistSelection&&D(i,is)),o&&o.querySelectorAll(".e-checkselect,.e-checkselectall").length>0&&(n=o.querySelector('input[type="checkbox"]'),r=!0),this.drawBorders(),this.updateAutoFillPosition(),((i=D(i,_o))&&i.parentElement.classList.contains(is)&&!this.parent.selectionSettings.checkboxOnly||r)&&!this.isRowDragSelected){if(this.parent.isCheckBoxSelection&&(this.isMultiCtrlRequest=!0),this.target=i,t.isNullOrUndefined(n)){var s=this.parent,l=0;if(ae(s)){var a=i.parentElement.getAttribute("data-uid");l=s.getRows().map(function(e){return e.getAttribute("data-uid")}).indexOf(a)}else l=parseInt(i.parentElement.getAttribute(us),10);this.parent.isPersistSelection&&this.parent.element.getElementsByClassName(os).length>0&&++l,this.mUPTarget&&this.mUPTarget.isEqualNode(i)||this.rowCellSelectionHandler(l,parseInt(i.getAttribute(cs),10)),this.parent.hoverFrozenRows(e),this.parent.isCheckBoxSelection&&(this.moveIntoUncheckCollection(t.closest(i,"."+is)),this.setCheckAllState())}else this.checkedTarget=n,n.classList.contains("e-checkselectall")?this.checkSelectAll(n):this.checkSelect(n);this.parent.isCheckBoxSelection||!t.Browser.isDevice||this.isSingleSel()||this.showPopup(e)}else if(e.target.classList.contains("e-headercell")&&!e.target.classList.contains("e-stackedheadercell")){a=e.target.querySelector(".e-headercelldiv").getAttribute("e-mappinguid");this.headerSelectionHandler(this.parent.getColumnIndexByUid(a))}this.isMultiCtrlRequest=!1,this.isMultiShiftRequest=!1,t.isNullOrUndefined(t.closest(e.target,".e-unboundcell"))&&(this.preventFocus=!1)},r.prototype.popUpClickHandler=function(e){var i=e.target;t.closest(i,".e-headercell")||e.target.classList.contains(_o)||t.closest(i,".e-gridpopup")?i.classList.contains("e-rowselect")&&(i.classList.contains("e-spanclicked")?(i.classList.remove("e-spanclicked"),this.enableSelectMultiTouch=!1,this.parent.element.querySelector(".e-gridpopup").style.display="none"):(i.classList.add("e-spanclicked"),this.enableSelectMultiTouch=!0)):this.parent.element.querySelector(".e-gridpopup").style.display="none"},r.prototype.showPopup=function(e){this.selectionSettings.enableSimpleMultiRowSelection||T(this.parent.element.querySelector(".e-gridpopup"),e,"e-rowselect e-icons e-icon-rowselect"+(!this.isSingleSel()&&(this.selectedRecords.length>(this.parent.getFrozenColumns()?2:1)||this.selectedRowCellIndexes.length>1)?" e-spanclicked":""))},r.prototype.rowCellSelectionHandler=function(e,i){!this.isMultiCtrlRequest&&!this.isMultiShiftRequest||this.isSingleSel()?(this.isDragged||this.selectRow(e,this.selectionSettings.enableToggle),this.selectCell({rowIndex:e,cellIndex:i},this.selectionSettings.enableToggle),this.selectedRowCellIndexes.length&&this.updateAutoFillPosition(),this.drawBorders()):this.isMultiShiftRequest?(this.parent.isCheckBoxSelection||!this.parent.isCheckBoxSelection&&!t.closest(this.target,"."+_o).classList.contains(rs)?this.selectRowsByRange(t.isUndefined(this.prevRowIndex)?e:this.prevRowIndex,e):this.addRowsToSelection([e]),this.selectCellsByRange(t.isUndefined(this.prevCIdxs)?{rowIndex:e,cellIndex:i}:this.prevCIdxs,{rowIndex:e,cellIndex:i}),this.updateAutoFillPosition(),this.drawBorders()):(this.addRowsToSelection([e]),this.addCellsToSelection([{rowIndex:e,cellIndex:i}]),this.showHideBorders("none")),this.isDragged=!1},r.prototype.onCellFocused=function(e){if(this.parent.frozenRows&&e.container.isHeader&&e.byKey)if("upArrow"===e.keyArgs.action)this.parent.allowFiltering?e.isJump="INPUT"===e.element.tagName:e.isJump="TH"===e.element.tagName;else if("downArrow"===e.keyArgs.action){var i=Number(e.element.parentElement.getAttribute(us));e.isJump=0===i}else"ctrlHome"===e.keyArgs.action&&(e.isJump=!0);var r=this.parent.isFrozenGrid()?(e.container.isHeader&&"TD"!==e.element.tagName&&e.isJump&&!this.selectionSettings.allowColumnSelection||(e.container.isContent||"TD"===e.element.tagName)&&!(e.container.isSelectable||"TD"===e.element.tagName))&&!(e.byKey&&"space"===e.keyArgs.action):(e.container.isHeader&&e.isJump||e.container.isContent&&!e.container.isSelectable)&&!(e.byKey&&"space"===e.keyArgs.action)&&!(e.element.classList.contains("e-detailrowexpand")||e.element.classList.contains("e-detailrowcollapse")),n=e.container.isHeader&&"TD"!==e.element.tagName&&!t.closest(e.element,"."+_o)&&!(e.byKey&&"space"===e.keyArgs.action);if(e.byKey&&!r){var o=e.container.isContent?e.container.indexes:e.indexes,s=o[0],l=o[1],a=this.focus.getPrevIndexes();if(this.parent.frozenRows)if(e.container.isHeader&&("TD"===e.element.tagName||t.closest(e.element,"."+_o))){var h=this.parent.getHeaderTable().querySelector("thead").childElementCount;s-=h,a.rowIndex=t.isNullOrUndefined(a.rowIndex)?null:a.rowIndex-h}else s+=this.parent.frozenRows,a.rowIndex=0!==a.rowIndex&&t.isNullOrUndefined(a.rowIndex)?null:a.rowIndex+this.parent.frozenRows;if(this.parent.isFrozenGrid()){var d=Number(e.element.getAttribute(cs)),p=this.parent.getSelectedRowCellIndexes();p.length&&0===a.cellIndex&&(a.cellIndex=p[p.length-1].cellIndexes[0]),a.cellIndex=t.isNullOrUndefined(a.cellIndex)?null:a.cellIndex===l?d:d-1,l=d}if(this.parent.enableInfiniteScrolling&&this.parent.infiniteScrollSettings.enableCache&&(s=parseInt(e.element.parentElement.getAttribute("aria-rowindex"),10)),!(n||-1===["ctrlPlusA","escape"].indexOf(e.keyArgs.action)&&"space"!==e.keyArgs.action&&s===a.rowIndex&&l===a.cellIndex)||this.selectionSettings.allowColumnSelection){this.preventFocus=!0;var c=this.getKeyColIndex(e);switch(this.needColumnSelection&&(l=c),e.keyArgs.action){case"downArrow":case"upArrow":case"enter":case"shiftEnter":this.target=e.element,this.isKeyAction=!0,this.applyDownUpKey(s,l);break;case"rightArrow":case"leftArrow":this.applyRightLeftKey(s,l);break;case"shiftDown":case"shiftUp":this.shiftDownKey(s,l);break;case"shiftLeft":case"shiftRight":this.applyShiftLeftRightKey(s,l);break;case"home":case"end":l="end"===e.keyArgs.action?this.getLastColIndex(s):0,this.applyHomeEndKey(s,l);break;case"ctrlHome":case"ctrlEnd":this.applyCtrlHomeEndKey(s,l);break;case"escape":this.clearSelection();break;case"ctrlPlusA":this.ctrlPlusA();break;case"space":this.applySpaceSelection(e.element);break;case"tab":this.parent.editSettings.allowNextRowEdit&&this.selectRow(s)}this.needColumnSelection=!1,this.preventFocus=!1,this.positionBorders(),this.updateAutoFillPosition()}}else r&&!this.parent.isCheckBoxSelection&&this.clearSelection()},r.prototype.getKeyColIndex=function(e){var t,i=null,r=e.element.querySelector(".e-stackedheadercelldiv");if(this.selectionSettings.allowColumnSelection&&D(e.element,"e-columnheader"))if(this.needColumnSelection=!!e.container.isHeader,r){if("rightArrow"===e.keyArgs.action||"leftArrow"===e.keyArgs.action)return i;t=r.getAttribute("e-mappinguid");var n=this.getstackedColumns(this.parent.getColumnByUid(t).columns),o=this.parent.getColumnIndexByUid(n[n.length-1].uid),s=this.parent.getColumnIndexByUid(n[0].uid);i=this.prevColIndex>=o?s:o}else i=this.parent.getColumnIndexByUid(e.element.querySelector(".e-headercelldiv").getAttribute("e-mappinguid"));return i},r.prototype.ctrlPlusA=function(){this.isRowType()&&!this.isSingleSel()&&this.selectRowsByRange(0,this.getCurrentBatchRecordChanges().length-1),this.isCellType()&&!this.isSingleSel()&&this.selectCellsByRange({rowIndex:0,cellIndex:0},{rowIndex:this.parent.getRows().length-1,cellIndex:this.parent.getColumns().length-1})},r.prototype.applySpaceSelection=function(e){e.classList.contains("e-checkselectall")?(this.checkedTarget=e,this.checkSelectAll(this.checkedTarget)):e.classList.contains("e-checkselect")&&(this.checkedTarget=e,this.checkSelect(this.checkedTarget))},r.prototype.applyDownUpKey=function(e,t){var i=this.parent;this.parent.isCheckBoxSelection&&"Check"===this.parent.checkAllRows&&!this.selectionSettings.persistSelection&&(this.checkSelectAllAction(!1),this.checkedTarget=null),this.isRowType()&&(this.parent.frozenRows,this.selectRow(e,!0),this.applyUpDown(i.selectedRowIndex)),this.isCellType()&&this.selectCell({rowIndex:e,cellIndex:t},!0),this.selectionSettings.allowColumnSelection&&this.needColumnSelection&&this.selectColumn(t)},r.prototype.applyUpDown=function(e){if(!(e<0)){this.target||(this.target=this.parent.getRows()[0].children[this.parent.groupSettings.columns.length||0]);var t=parseInt(this.target.getAttribute(cs),10),i=this.parent.getFrozenColumns();if(i)this.target=t>=i?this.contentRenderer.getMovableRowByIndex(e).getElementsByClassName(_o)[t-i]:this.contentRenderer.getRowByIndex(e).getElementsByClassName(_o)[t];else{var r=this.contentRenderer.getRowByIndex(e);r&&(this.target=r.getElementsByClassName(_o)[t])}this.addAttribute(this.target)}},r.prototype.applyRightLeftKey=function(e,t){this.selectionSettings.allowColumnSelection&&this.needColumnSelection?this.selectColumn(t):this.isCellType()&&(this.selectCell({rowIndex:e,cellIndex:t},!0),this.addAttribute(this.target))},r.prototype.applyHomeEndKey=function(e,t){this.isCellType()?this.selectCell({rowIndex:e,cellIndex:t},!0):this.addAttribute(this.parent.getCellFromIndex(e,t))},r.prototype.shiftDownKey=function(e,i){this.isMultiShiftRequest=!0,this.isRowType()&&!this.isSingleSel()&&(t.isUndefined(this.prevRowIndex)?this.selectRow(0,!0):(this.selectRowsByRange(this.prevRowIndex,e),this.applyUpDown(e))),this.isCellType()&&!this.isSingleSel()&&this.selectCellsByRange(this.prevCIdxs||{rowIndex:0,cellIndex:0},{rowIndex:e,cellIndex:i}),this.isMultiShiftRequest=!1},r.prototype.applyShiftLeftRightKey=function(e,t){this.isMultiShiftRequest=!0,this.selectionSettings.allowColumnSelection&&this.needColumnSelection?this.selectColumnsByRange(this.prevColIndex,t):this.selectCellsByRange(this.prevCIdxs,{rowIndex:e,cellIndex:t}),this.isMultiShiftRequest=!1},r.prototype.getstackedColumns=function(e){for(var t=[],i=0,r=e.length;i<r;i++)e[i].columns?this.getstackedColumns(e[i].columns):t.push(e[i]);return t},r.prototype.applyCtrlHomeEndKey=function(e,t){this.isRowType()&&(this.selectRow(e,!0),this.addAttribute(this.parent.getCellFromIndex(e,t))),this.isCellType()&&this.selectCell({rowIndex:e,cellIndex:t},!0)},r.prototype.addRemoveClassesForRow=function(e,t,i){for(var r=[],n=3;n<arguments.length;n++)r[n-3]=arguments[n];if(e){var o=[].slice.call(e.getElementsByClassName(_o)),s=e.querySelector(".e-detailrowcollapse")||e.querySelector(".e-detailrowexpand"),l=e.querySelector(".e-rowdragdrop");s&&o.push(s),l&&o.push(l),X.apply(void 0,[o,t].concat(r))}this.getRenderer().setSelection(e?e.getAttribute("data-uid"):null,t,i)},r.prototype.isRowType=function(){return"Row"===this.selectionSettings.mode||"Both"===this.selectionSettings.mode},r.prototype.isCellType=function(){return"Cell"===this.selectionSettings.mode||"Both"===this.selectionSettings.mode},r.prototype.isSingleSel=function(){return"Single"===this.selectionSettings.type},r.prototype.getRenderer=function(){return t.isNullOrUndefined(this.contentRenderer)&&(this.contentRenderer=this.factory.getRenderer(e.RenderType.Content)),this.contentRenderer},r.prototype.getSelectedRecords=function(){return this.selectionSettings.persistSelection?this.persistSelectedData:this.parent.getRowsObject().filter(function(e){return e.isSelected}).map(function(e){return e.data})},r.prototype.selectColumn=function(e){var i=this.parent;if(!t.isNullOrUndefined(i.getColumns()[e])){var r=i.getColumnByIndex(e),n=i.getColumnHeaderByUid(r.uid),o=n.classList.contains("e-columnselection");if(i.selectionSettings.allowColumnSelection){var s=this.selectedColumnsIndexes.length>1&&this.selectedColumnsIndexes.indexOf(e)>-1;if(this.clearColDependency(),!o||!this.selectionSettings.enableToggle||s){var l={columnIndex:e,headerCell:n,column:r,cancel:!1,target:this.actualTarget,isInteracted:this.isInteracted,previousColumnIndex:this.prevColIndex,isCtrlPressed:this.isMultiCtrlRequest,isShiftPressed:this.isMultiShiftRequest};if(this.onActionBegin(l,Ut),l.cancel)return void this.disableInteracted();i.selectionSettings.enableToggle&&e===this.prevColIndex&&o&&!s||this.updateColSelection(n,e);var a={columnIndex:e,headerCell:n,column:r,target:this.actualTarget,isInteracted:this.isInteracted,previousColumnIndex:this.prevColIndex};this.onActionComplete(a,jt)}this.updateColProps(e)}}},r.prototype.selectColumnsByRange=function(e,i){var r=this.parent;if(!t.isNullOrUndefined(r.getColumns()[e])){var n=[];if("Single"===r.selectionSettings.type||t.isNullOrUndefined(i))n[0]=e;else for(var o=e<i,s=e;o?s<=i:s>=i;o?s++:s--)n.push(s);this.selectColumns(n)}},r.prototype.selectColumns=function(e){var t=this.parent,i=this.getselectedCols();if("Single"===t.selectionSettings.type&&(e=[e[0]]),t.selectionSettings.allowColumnSelection){this.clearColDependency();var r={columnIndex:e[0],headerCell:i,columnIndexes:e,column:t.getColumnByIndex(e[0]),cancel:!1,target:this.actualTarget,isInteracted:this.isInteracted,previousColumnIndex:this.prevColIndex,isCtrlPressed:this.isMultiCtrlRequest,isShiftPressed:this.isMultiShiftRequest};if(this.onActionBegin(r,Ut),r.cancel)this.disableInteracted();else{for(var n=0,o=e.length;n<o;n++)this.updateColSelection(t.getColumnHeaderByUid(t.getColumnByIndex(e[n]).uid),e[n]);i=this.getselectedCols();var s={columnIndex:e[0],headerCell:i,columnIndexes:e,column:t.getColumnByIndex(e[0]),target:this.actualTarget,isInteracted:this.isInteracted,previousColumnIndex:this.prevColIndex};this.onActionComplete(s,jt),this.updateColProps(e[0])}}},r.prototype.selectColumnWithExisting=function(e){var i=this.parent;if(!t.isNullOrUndefined(i.getColumns()[e])){var r=i.getColumnHeaderByUid(i.getColumnByIndex(e).uid),n=this.getselectedCols();if("Single"===i.selectionSettings.type&&this.clearColDependency(),i.selectionSettings.allowColumnSelection){if(this.selectedColumnsIndexes.indexOf(e)>-1)this.clearColumnSelection(e);else{var o={columnIndex:e,headerCell:n,columnIndexes:this.selectedColumnsIndexes,column:i.getColumnByIndex(e),cancel:!1,target:this.actualTarget,isInteracted:this.isInteracted,previousColumnIndex:this.prevColIndex,isCtrlPressed:this.isMultiCtrlRequest,isShiftPressed:this.isMultiShiftRequest};if(this.onActionBegin(o,Ut),o.cancel)return void this.disableInteracted();this.updateColSelection(r,e);var s={columnIndex:e,headerCell:n=this.getselectedCols(),column:i.getColumnByIndex(e),columnIndexes:this.selectedColumnsIndexes,target:this.actualTarget,isInteracted:this.isInteracted,previousColumnIndex:this.prevColIndex};this.onActionComplete(s,jt)}this.updateColProps(e)}}},r.prototype.clearColumnSelection=function(e){if(this.isColumnSelected){var i=this.parent;if(!t.isNullOrUndefined(e)&&-1===this.selectedColumnsIndexes.indexOf(e))return;var r=t.isNullOrUndefined(e)?this.selectedColumnsIndexes[this.selectedColumnsIndexes.length-1]:e,n=i.getColumnByIndex(r),o=void 0,s=i.getColumnByIndex(r),l={columnIndex:r,headerCell:o=n.getFreezeTableName()===ds?i.getFrozenRightColumnHeaderByIndex(r):"movable"===n.getFreezeTableName()?i.getMovableColumnHeaderByIndex(r):i.getColumnHeaderByUid(s.uid),columnIndexes:this.selectedColumnsIndexes,column:s,cancel:!1,target:this.actualTarget,isInteracted:this.isInteracted};if(this.columnDeselect(l,Vt))return void this.disableInteracted();for(var a=t.isNullOrUndefined(e)?[].slice.call(i.getHeaderContent().getElementsByClassName("e-columnselection")):[o],h=this.getSelectedColumnCells(e),d=0,p=a.length;d<p;d++)X([a[d]],!1,"e-columnselection");for(d=0,p=h.length;d<p;d++)X([h[d]],!1,"e-columnselection");t.isNullOrUndefined(e)?(this.columnDeselect(l,Gt),this.selectedColumnsIndexes=[],this.isColumnSelected=!1,this.parent.getColumns().filter(function(e){return e.isSelected=!1})):(this.selectedColumnsIndexes.splice(this.selectedColumnsIndexes.indexOf(e),1),this.parent.getColumns()[e].isSelected=!1)}},r.prototype.getselectedCols=function(){var e,t=this.parent;if(this.selectedColumnsIndexes.length>1){e=[];for(var i=0;i<this.selectedColumnsIndexes.length;i++)e.push(t.getColumnHeaderByUid(t.getColumnByIndex(this.selectedColumnsIndexes[i]).uid))}else e=t.getColumnHeaderByUid(t.getColumnByIndex(this.selectedColumnsIndexes[0]).uid);return e},r.prototype.getSelectedColumnCells=function(e){var i,r,n=this.parent,o=!t.isNullOrUndefined(this.parent.rowTemplate),s=o?n.getRows():n.getDataRows();n.isFrozenGrid()&&n.getContent().querySelector("."+Yo)&&(i=o?n.getMovableRows():n.getMovableDataRows(),s=n.addMovableRows(s,i),n.getFrozenMode()===hs&&(r=o?n.getFrozenRightRows():n.getFrozenRightDataRows(),s=n.addMovableRows(s,r)));for(var l=[],a=t.isNullOrUndefined(e)?".e-columnselection":'[aria-colindex="'+e+'"]',h=0,d=s.length;h<d;h++)l=l.concat([].slice.call(s[h].querySelectorAll(a)));return l},r.prototype.columnDeselect=function(e,t){return"columnDeselected"===t&&delete e.cancel,this.onActionComplete(e,t),e.cancel},r.prototype.updateColProps=function(e){this.prevColIndex=e,this.isColumnSelected=this.selectedColumnsIndexes.length&&!0},r.prototype.clearColDependency=function(){this.clearColumnSelection(),this.selectedColumnsIndexes=[]},r.prototype.updateColSelection=function(e,i){if(!t.isNullOrUndefined(this.parent.getColumns()[i])){var r,n=this.parent.getFrozenLeftCount(),o=this.parent.getMovableColumnsCount(),s=this.parent.getColumnByIndex(i),l=!t.isNullOrUndefined(this.parent.rowTemplate);this.selectedColumnsIndexes.push(i),this.parent.getColumns()[i].isSelected=!0,s.getFreezeTableName()===ds?(i-=n+o,r=l?this.parent.getFrozenRightRows():this.parent.getFrozenRightDataRows()):"movable"===s.getFreezeTableName()?(i-=n,r=l?this.parent.getMovableRows():this.parent.getMovableDataRows()):(i+=this.parent.getIndentCount(),r=l?this.parent.getRows():this.parent.getDataRows()),X([e],!0,"e-columnselection");for(var a=0,h=r.length;a<h;a++)r[a].classList.contains(is)&&(!r[a].classList.contains(ns)&&!r[a].classList.contains(os)||"Normal"!==this.parent.editSettings.mode||t.isNullOrUndefined(r[a].querySelector("tr").childNodes[i])?t.isNullOrUndefined(r[a].childNodes[i])||X([r[a].childNodes[i]],!0,"e-columnselection"):X([r[a].querySelector("tr").childNodes[i]],!0,"e-columnselection"))}},r.prototype.headerSelectionHandler=function(e){!this.isMultiCtrlRequest&&!this.isMultiShiftRequest||this.isSingleSel()?this.selectColumn(e):this.isMultiShiftRequest?this.selectColumnsByRange(t.isUndefined(this.prevColIndex)?e:this.prevColIndex,e):this.selectColumnWithExisting(e)},r.prototype.addEventListener_checkbox=function(){var e=this;this.parent.on(Ri,this.dataReady,this),this.onDataBoundFunction=this.onDataBound.bind(this),this.parent.addEventListener(Ot,this.onDataBoundFunction),this.parent.on(No,this.onDataBoundFunction),this.parent.on(xi,this.checkBoxSelectionChanged,this),this.parent.on(to,this.initPerisistSelection,this),this.parent.on(Ei,this.setCheckAllForEmptyGrid,this),this.actionCompleteFunc=this.actionCompleteHandler.bind(this),this.parent.addEventListener(Dt,this.actionCompleteFunc),this.parent.on(Wi,this.clickHandler,this),this.resizeEndFn=function(){e.updateAutoFillPosition(),e.drawBorders()},this.resizeEndFn.bind(this),this.parent.addEventListener(pi,this.resizeEndFn)},r.prototype.removeEventListener_checkbox=function(){this.parent.off(Ri,this.dataReady),this.parent.removeEventListener(Ot,this.onDataBoundFunction),this.parent.removeEventListener(Dt,this.actionCompleteFunc),this.parent.off(No,this.onDataBoundFunction),this.parent.off(Ei,this.setCheckAllForEmptyGrid),this.parent.off(Wi,this.clickHandler),this.parent.off(to,this.initPerisistSelection)},r.prototype.setCheckAllForEmptyGrid=function(){var e=this.getCheckAllBox();if(e){this.parent.isCheckBoxSelection=!0;var i=e.nextElementSibling;t.removeClass([i],["e-check","e-stop","e-uncheck"])}},r.prototype.dataReady=function(e){this.isHeaderCheckboxClicked=!1;var t=this.parent.enableInfiniteScrolling&&"infiniteScroll"===e.requestType;"virtualscroll"===e.requestType||this.parent.isPersistSelection||t||(this.disableUI=!this.parent.enableImmutableMode,this.clearSelection(),this.setCheckAllState(),this.disableUI=!1)},r.prototype.actionCompleteHandler=function(e){"save"===e.requestType&&this.parent.isPersistSelection&&this.refreshPersistSelection()},r.prototype.selectRowIndex=function(e){this.parent.isSelectedRowIndexUpdating=!0,this.parent.selectedRowIndex=e},r.prototype.disableInteracted=function(){this.isInteracted=!1},r.prototype.activeTarget=function(){this.actualTarget=this.isInteracted?this.actualTarget:null},r}(),zl=function(){function e(e){this.parent=e,this.addEventListener()}return e.prototype.search=function(e){var i=this.parent;e=t.isNullOrUndefined(e)?"":e,W(i)?i.notify(ur,{instance:this,handler:this.search,arg1:e}):e!==i.searchSettings.key?(i.searchSettings.key=e.toString(),i.dataBind()):this.refreshSearch&&i.refresh()},e.prototype.addEventListener=function(){this.parent.isDestroyed||(this.parent.on(Ii,this.onPropertyChanged,this),this.parent.on(Ai,this.onSearchComplete,this),this.parent.on(Ki,this.destroy,this),this.actionCompleteFunc=this.onActionComplete.bind(this),this.parent.addEventListener(Dt,this.actionCompleteFunc),this.parent.on(Xr,this.cancelBeginEvent,this))},e.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(Ii,this.onPropertyChanged),this.parent.off(Ai,this.onSearchComplete),this.parent.off(Ki,this.destroy),this.parent.removeEventListener(Dt,this.actionCompleteFunc),this.parent.off(Xr,this.cancelBeginEvent))},e.prototype.destroy=function(){this.removeEventListener()},e.prototype.onPropertyChanged=function(e){e.module===this.getModuleName()&&(t.isNullOrUndefined(e.properties.key)?this.parent.notify(Ti,{requestType:"searching",type:zt}):this.parent.notify(Ti,{requestType:"searching",type:zt,searchString:this.parent.searchSettings.key}))},e.prototype.onSearchComplete=function(e){this.parent.trigger(Dt,t.extend(e,{searchString:this.parent.searchSettings.key,requestType:"searching",type:Dt}))},e.prototype.onActionComplete=function(e){this.refreshSearch="searching"!==e.requestType},e.prototype.cancelBeginEvent=function(e){"searching"===e.requestType&&this.parent.setProperties({searchSettings:{key:""}},!0)},e.prototype.getModuleName=function(){return"search"},e}(),Dl=function(){function e(e){this.parent=e}return e.prototype.show=function(e,t){var i=this.getToggleFields(e),r=this.getColumns(i,t);this.parent.notify(hr,{module:"edit"});for(var n=0;n<r.length;n++)r[n].visible=!0;this.setVisible(r)},e.prototype.hide=function(e,t){var i=this.getToggleFields(e),r=this.getColumns(i,t);this.parent.notify(hr,{module:"edit"});for(var n=0;n<r.length;n++)r[n].visible=!1;this.setVisible(r)},e.prototype.getToggleFields=function(e){return"string"==typeof e?[e]:e},e.prototype.getColumns=function(e,t){var i=this;return b(e,function(e){return b(i.parent.columnModel,function(i){if(i[t]===e)return i})[0]})},e.prototype.setVisible=function(e,i){var r=this;void 0===i&&(i=[]);var n={requestType:"columnstate",cancel:!1,columns:i=i.length>0?i:e};this.parent.trigger(zt,n,function(n){var o=r.parent.getColumns();if(e=t.isNullOrUndefined(e)?o:e,n.cancel)return r.parent.notify(Vn,{showHideArgs:n}),void(e.length>0&&(e[0].visible=!0));if(ae(r.parent)&&r.parent.contentModule.emptyVcRows(),r.parent.allowSelection&&r.parent.getSelectedRecords().length&&!r.parent.selectionSettings.persistSelection&&r.parent.clearSelection(),r.parent.enableColumnVirtualization){e.filter(function(e){return o.some(function(t){return e.field===t.field})}).length&&r.parent.notify(Qi,e)}else r.parent.notify(Qi,e);var s={requestType:"columnstate",columns:i};r.parent.trigger(Dt,s),"All"!==r.parent.columnQueryMode&&r.parent.refresh()})},e}(),Ml=function(){function e(e){this.previousValues={top:0,left:0},this.oneTimeReady=!0,this.parent=e,this.widthService=new dl(e),this.addEventListener()}return e.prototype.getModuleName=function(){return"scroll"},e.prototype.setWidth=function(e){this.parent.element.style.width=t.formatUnit(this.parent.width),e&&this.widthService.setWidthToColumns(),this.parent.toolbarModule&&this.parent.toolbarModule.toolbar&&this.parent.toolbarModule.toolbar.element&&this.parent.toolbarModule.toolbar.refreshOverflow()},e.prototype.setHeight=function(){var i=0,r=this.parent.getContent().querySelector("."+es),n=this.parent.height;if(this.parent.isFrozenGrid()&&"auto"!==this.parent.height&&this.parent.height.toString().indexOf("%")<0&&(n=parseInt(n,10)-e.getScrollBarWidth()),!this.parent.enableVirtualization&&this.parent.frozenRows&&"auto"!==this.parent.height){var o=this.parent.getHeaderContent().querySelector(gs);if(i=o?o.offsetHeight:0,o&&i){i-=o.getElementsByClassName(os).length*this.parent.getRowHeight()}r.style.height=t.formatUnit(n-i)}else r.style.height=t.formatUnit(n);this.ensureOverflow(r),this.parent.isFrozenGrid()&&this.refresh()},e.prototype.setPadding=function(){var t=this.parent.getHeaderContent(),i=e.getScrollBarWidth()-this.getThreshold(),r=this.getCssProperties(),n="Right"===this.parent.getFrozenMode()||this.parent.getFrozenMode()===hs?"0.5px":"1px";t.querySelector("."+Xo).style[r.border]=i>0?n:"0px",t.style[r.padding]=i>0?i+"px":"0px"},e.prototype.removePadding=function(e){var t=this.getCssProperties(e),i=this.parent.getHeaderContent().querySelector("."+Xo);i.style[t.border]="",i.parentElement.style[t.padding]="";var r=this.parent.getFooterContent();r&&r.classList.contains("e-footerpadding")&&r.classList.remove("e-footerpadding")},e.prototype.refresh=function(){if("100%"===this.parent.height){var e=this.parent.getContent();this.parent.element.style.height="100%";var t=this.widthService.getSiblingsHeight(e);e.style.height="calc(100% - "+t+"px)",this.parent.isFrozenGrid()&&(e.firstElementChild.style.height="calc(100% - "+H()+"px)")}},e.prototype.getThreshold=function(){return"mozilla"===t.Browser.info.name?.5:1},e.prototype.addEventListener=function(){this.parent.isDestroyed||(this.parent.on(Ei,this.wireEvents,this),this.parent.on(xi,this.wireEvents,this),this.parent.on(Fi,this.onPropertyChanged,this),this.parent.on(Kr,this.wireEvents,this),this.parent.on(Di,this.setScrollLeft,this))},e.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(Ei,this.wireEvents),this.parent.off(xi,this.wireEvents),this.parent.off(Fi,this.onPropertyChanged),this.parent.off(Kr,this.wireEvents),this.parent.off(Di,this.setScrollLeft))},e.prototype.setScrollLeft=function(){this.parent.isFrozenGrid()?this.parent.headerModule.getMovableHeader().scrollLeft=this.previousValues.left:this.parent.getHeaderContent().querySelector("."+Xo).scrollLeft=this.previousValues.left},e.prototype.onFrozenContentScroll=function(){var e=this;return function(i){null===e.content.querySelector(gs)||e.parent.isPreventScrollEvent||(!t.isNullOrUndefined(e.parent.infiniteScrollModule)&&e.parent.enableInfiniteScrolling&&e.parent.notify(On,i),e.previousValues.top=i.target.scrollTop)}},e.prototype.onContentScroll=function(e){var i=this,r=e,n=r.classList.contains(Xo);return function(e){if(null!==i.content.querySelector(gs)&&!i.parent.isPreventScrollEvent){var o=e.target,s=o.scrollLeft;if(!t.isNullOrUndefined(i.parent.infiniteScrollModule)&&i.parent.enableInfiniteScrolling&&i.parent.notify(On,{target:e.target,isLeft:i.previousValues.left!==s}),i.parent.groupSettings.columns.length&&i.parent.groupSettings.enableLazyLoading){var l=i.previousValues.top<i.parent.getContent().firstElementChild.scrollTop;i.parent.notify(Kn,{scrollDown:l})}i.parent.notify(Fn,{});var a=o.classList.contains("e-summarycontent");i.previousValues.left!==s?(i.parent.notify(Hn,e),r.scrollLeft=s,a&&(i.header.scrollLeft=s),i.previousValues.left=s,i.parent.notify(Xi,{left:s})):i.previousValues.top=n?o.scrollTop:i.previousValues.top}}},e.prototype.onCustomScrollbarScroll=function(e,t){var i=this,r=e,n=t;return function(e){if(null!==i.content.querySelector(gs)){var t=e.target.scrollLeft;i.previousValues.left!==t&&(r.scrollLeft=t,n.scrollLeft=t,i.previousValues.left=t,i.parent.notify(Xi,{left:t}),i.parent.isDestroyed)}}},e.prototype.onTouchScroll=function(e){var t=this,i=e;return function(e){if("mouse"!==e.pointerType){var r=t.parent.isFrozenGrid(),n=t.getPointXY(e),o=i.scrollLeft+(t.pageXY.x-n.x),s=r?t.parent.getHeaderContent().querySelector("."+Jo):t.parent.getHeaderContent().querySelector("."+Xo),l=r?t.parent.getContent().querySelector("."+Yo):t.parent.getContent().querySelector("."+es);if(!(t.previousValues.left===o||o<0||s.scrollWidth-s.clientWidth<o)){if(e.preventDefault(),s.scrollLeft=o,l.scrollLeft=o,r){t.parent.getContent().querySelector(".e-movablescrollbar").scrollLeft=o}t.pageXY.x=n.x,t.previousValues.left=o}}}},e.prototype.setPageXY=function(){var e=this;return function(t){"mouse"!==t.pointerType&&(e.pageXY=e.getPointXY(t))}},e.prototype.getPointXY=function(e){var t={x:0,y:0};return e.touches&&e.touches.length?(t.x=e.touches[0].pageX,t.y=e.touches[0].pageY):(t.x=e.pageX,t.y=e.pageY),t},e.prototype.getScrollbleParent=function(e){if(null===e)return null;var i=t.isNullOrUndefined(e.tagName)?e.scrollingElement:e,r=document.defaultView.getComputedStyle(i,null).overflowY;return i.scrollHeight>i.clientHeight&&"hidden"!==r&&"visible"!==r||"HTML"===e.tagName||"BODY"===e.tagName?e:this.getScrollbleParent(e.parentNode)},e.prototype.addStickyListener=function(e){this.parentElement=this.getScrollbleParent(this.parent.element.parentElement),e?this.parentElement&&t.EventHandler.add("HTML"===this.parentElement.tagName||"BODY"===this.parentElement.tagName?document:this.parentElement,"scroll",this.makeStickyHeader,this):t.EventHandler.remove(this.parentElement,"scroll",this.makeStickyHeader)},e.prototype.wireEvents=function(){var e=this;if(this.oneTimeReady){var i=this.parent.isFrozenGrid();this.content=this.parent.getContent().querySelector("."+es),this.header=this.parent.getHeaderContent().querySelector("."+Xo);var r=this.content.querySelector("."+Yo),n=this.header.querySelector("."+Jo),o=this.parent.getContent().querySelector(".e-movablescrollbar");this.parent.frozenRows&&(t.EventHandler.add(i?n:this.header,"touchstart pointerdown",this.setPageXY(),this),t.EventHandler.add(i?n:this.header,"touchmove pointermove",this.onTouchScroll(i?r:this.content),this)),this.parent.isFrozenGrid()?(t.EventHandler.add(o,"scroll",this.onCustomScrollbarScroll(r,n),this),t.EventHandler.add(r,"scroll",this.onCustomScrollbarScroll(o,n),this),t.EventHandler.add(n,"scroll",this.onCustomScrollbarScroll(o,r),this),t.EventHandler.add(this.content,"scroll",this.onFrozenContentScroll(),this),t.EventHandler.add(n,"touchstart pointerdown",this.setPageXY(),this),t.EventHandler.add(n,"touchmove pointermove",this.onTouchScroll(r),this),t.EventHandler.add(r,"touchstart pointerdown",this.setPageXY(),this),/macintosh|ipad/.test(t.Browser.userAgent.toLowerCase())&&t.Browser.isDevice||t.EventHandler.add(r,"touchmove pointermove",this.onTouchScroll(n),this)):(t.EventHandler.add(this.content,"scroll",this.onContentScroll(this.header),this),t.EventHandler.add(this.header,"scroll",this.onContentScroll(this.content),this)),this.parent.aggregates.length&&t.EventHandler.add(this.parent.getFooterContent().firstChild,"scroll",this.onContentScroll(this.content),this),this.parent.enableStickyHeader&&this.addStickyListener(!0),this.refresh(),this.oneTimeReady=!1}var s,l,a,h=this.parent.getContentTable();f(function(){s=e.header.scrollLeft,l=h.scrollHeight,a=e.parent.getContent().clientHeight},function(){var i={cancel:!1};e.parent.notify(no,i),e.parent.enableVirtualization||e.parent.enableInfiniteScrolling||(l<a&&(t.addClass(h.querySelectorAll("tr:last-child td"),"e-lastrowcell"),e.parent.isFrozenGrid()&&(t.addClass(e.parent.getContent().querySelector("."+Yo).querySelectorAll("tr:last-child td"),"e-lastrowcell"),e.parent.getFrozenRightColumnsCount()&&t.addClass(e.parent.getContent().querySelector(".e-frozen-right-content").querySelectorAll("tr:last-child td"),"e-lastrowcell"))),i.cancel||((e.parent.frozenRows>0||e.parent.isFrozenGrid())&&e.header.querySelector("."+Jo)?e.header.querySelector("."+Jo).scrollLeft=e.previousValues.left:e.header.scrollLeft=e.previousValues.left,e.content.scrollLeft=e.previousValues.left,e.content.scrollTop=e.previousValues.top)),e.parent.enableColumnVirtualization||(e.content.scrollLeft=s),e.parent.isFrozenGrid()&&e.header.querySelector("."+Jo)&&(e.header.querySelector("."+Jo).scrollLeft=e.content.querySelector("."+Yo).scrollLeft)}),this.parent.isPreventScrollEvent=!1},e.prototype.getCssProperties=function(e){var i={},r=t.isNullOrUndefined(e)?this.parent.enableRtl:e;return i.border=r?"borderLeftWidth":"borderRightWidth",i.padding=r?"paddingLeft":"paddingRight",i},e.prototype.ensureOverflow=function(e){e.style.overflowY="auto"===this.parent.height?"auto":"scroll"},e.prototype.onPropertyChanged=function(e){if(e.module===this.getModuleName()){this.setPadding(),this.oneTimeReady=!0,"auto"===this.parent.height&&this.removePadding(),this.wireEvents(),this.setHeight();this.setWidth(!t.isNullOrUndefined(e.properties.width))}},e.prototype.makeStickyHeader=function(){if(this.parent.enableStickyHeader&&this.parent.element&&this.parent.getContent()){var e=this.parent.getContent().getClientRects()[0];if(e){var t=this.parent.getHeaderContent(),i=this.parent.element.querySelector(".e-toolbar"),r=this.parent.element.querySelector(".e-groupdroparea"),n=t.offsetHeight+(i?i.offsetHeight:0)+(r?r.offsetHeight:0),o=this.parentElement.getClientRects()[0].top,s=e.top-(o<0?0:o),l=e.left;if(s<n&&e.bottom>0){t.classList.add("e-sticky");var a=0;r&&this.parent.groupSettings.showDropArea&&(this.setSticky(r,a,e.width,l,!0),a+=r.getClientRects()[0].height),i&&(this.setSticky(i,a,e.width,l,!0),a+=i.getClientRects()[0].height),this.setSticky(t,a,e.width,l,!0)}else if(t.classList.contains("e-sticky")){this.setSticky(t,null,null,null,!1),i&&this.setSticky(i,null,null,null,!1),r&&this.setSticky(r,null,null,null,!1);var h=this.parent.element.querySelector(".e-ccdlg");h&&h.classList.remove("e-sticky")}this.parent.notify(Ao,{})}}},e.prototype.setSticky=function(e,t,i,r,n){n?(e.style.width=i+"px",e.classList.add("e-sticky")):e.classList.remove("e-sticky"),e.style.top=null!=t?t+"px":"",e.style.left=null!==r?parseInt(e.style.left,10)!==r?r+"px":e.style.left:""},e.prototype.destroy=function(){var e=this.parent.element;if(e&&(e.querySelector("."+Wo)||e.querySelector("."+Ko))){this.removeEventListener();var i=this.parent.getContent().querySelector("."+es);t.EventHandler.remove(i,"scroll",this.onContentScroll),this.parent.enableStickyHeader&&this.addStickyListener(!1),this.removePadding(),t.removeClass([this.parent.getHeaderContent().querySelector("."+Xo)],Xo),t.removeClass([i],es),i.style.height="",this.parent.element.style.width=""}},e.getScrollBarWidth=function(){return H()},e}(),Ol=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),kl=function(e,t,i,r){var n,o=arguments.length,s=o<3?t:null===r?r=Object.getOwnPropertyDescriptor(t,i):r;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,i,r);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(o<3?n(s):o>3?n(t,i,s):n(t,i))||s);return o>3&&s&&Object.defineProperty(t,i,s),s},Al=function(i){function r(){var e=null!==i&&i.apply(this,arguments)||this;return e.templateFn={},e}return Ol(r,i),r.prototype.setFormatter=function(e){this.formatFn=e},r.prototype.getFormatter=function(){return this.formatFn},r.prototype.setTemplate=function(i){void 0===i&&(i={}),void 0!==this.footerTemplate&&(this.templateFn[t.getEnumValue(e.CellType,e.CellType.Summary)]={fn:t.compile(this.footerTemplate,i),property:"footerTemplate"}),void 0!==this.groupFooterTemplate&&(this.templateFn[t.getEnumValue(e.CellType,e.CellType.GroupSummary)]={fn:t.compile(this.groupFooterTemplate,i),property:"groupFooterTemplate"}),void 0!==this.groupCaptionTemplate&&(this.templateFn[t.getEnumValue(e.CellType,e.CellType.CaptionSummary)]={fn:t.compile(this.groupCaptionTemplate,i),property:"groupCaptionTemplate"})},r.prototype.getTemplate=function(i){return this.templateFn[t.getEnumValue(e.CellType,i)]},r.prototype.setPropertiesSilent=function(e){this.setProperties(e,!0)},kl([t.Property()],r.prototype,"type",void 0),kl([t.Property()],r.prototype,"field",void 0),kl([t.Property()],r.prototype,"columnName",void 0),kl([t.Property()],r.prototype,"format",void 0),kl([t.Property()],r.prototype,"footerTemplate",void 0),kl([t.Property()],r.prototype,"groupFooterTemplate",void 0),kl([t.Property()],r.prototype,"groupCaptionTemplate",void 0),kl([t.Property()],r.prototype,"customAggregate",void 0),r}(t.ChildProperty),Bl=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return Ol(i,e),kl([t.Collection([],Al)],i.prototype,"columns",void 0),i}(t.ChildProperty),Nl=function(){function e(e){this.copyContent="",this.isSelect=!1,this.parent=e,this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.isDestroyed||(this.parent.on(xi,this.initialEnd,this),this.parent.on(_i,this.keyDownHandler,this),this.parent.on(Wi,this.clickHandler,this),t.EventHandler.add(this.parent.element,"keydown",this.pasteHandler,this))},e.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(_i,this.keyDownHandler),this.parent.off(xi,this.initialEnd),this.parent.off(Wi,this.clickHandler),t.EventHandler.remove(this.parent.element,"keydown",this.pasteHandler))},e.prototype.clickHandler=function(e){var t=e.target;t=D(t,"e-rowcell")},e.prototype.pasteHandler=function(e){var i=this,r=this.parent,n=/(Mac)/i.test(navigator.platform);if(67===e.keyCode&&n&&e.metaKey&&!r.isEdit&&this.copy(),86===e.keyCode&&(e.ctrlKey||n&&e.metaKey)&&!r.isEdit){if(!t.closest(document.activeElement,"."+_o)||!r.editSettings.allowEditing||"Batch"!==r.editSettings.mode||"Cell"!==r.selectionSettings.mode||"Flow"===r.selectionSettings.cellSelectionMode)return;this.activeElement=document.activeElement,this.clipBoardTextArea.value="";var o=window.scrollX,s=window.scrollY;this.clipBoardTextArea.focus(),setTimeout(function(){i.activeElement.focus(),window.scrollTo(o,s),i.paste(i.clipBoardTextArea.value,i.parent.getSelectedRowCellIndexes()[0].rowIndex,i.parent.getSelectedRowCellIndexes()[0].cellIndexes[0])},10)}},e.prototype.paste=function(e,i,r){var n,o,s,l=this.parent,a=r,h=i;if(l.editSettings.allowEditing&&"Batch"===l.editSettings.mode&&"Cell"===l.selectionSettings.mode&&"Flow"!==l.selectionSettings.cellSelectionMode){var d,p,c,u=e.split("\n"),g=l.getDataRows(),f=this.parent.isFrozenGrid();f&&(p=l.getMovableDataRows(),l.getFrozenRightColumnsCount()&&(c=l.getFrozenRightDataRows()));for(var m=0;m<u.length;m++){if(d=u[m].split("\t"),a=r,m===u.length-1&&""===u[m]||t.isUndefined(l.getRowByIndex(h))){a++;break}for(var y=0;y<d.length;y++){if(s=l.getCellFromIndex(h,a),f){var v=g[h],C=p[h];if(s=!!v.querySelector('[aria-colindex="'+a+'"]')||C.querySelector('[aria-colindex="'+a+'"]'),c&&!s){s=c[h].querySelector('[aria-colindex="'+a+'"]')}}if(!s){a++;break}if(n=l.getColumnByIndex(a),o=n.getParser()?n.getParser()(d[y]):d[y],n.allowEditing&&!n.isPrimaryKey&&!n.template){var w={column:n,data:o,rowIndex:h};this.parent.trigger("beforePaste",w),h=w.rowIndex,w.cancel||l.editModule&&("number"===n.type?this.parent.editModule.updateCell(h,n.field,parseFloat(w.data)):l.editModule.updateCell(h,n.field,w.data))}a++}h++}l.selectionModule.selectCellsByRange({rowIndex:i,cellIndex:r},{rowIndex:h-1,cellIndex:a-1});var b=this.parent.getCellFromIndex(h-1,a-1);b&&t.classList(b,["e-focus","e-focused"],[])}},e.prototype.initialEnd=function(){this.parent.off(xi,this.initialEnd),this.clipBoardTextArea=this.parent.createElement("textarea",{className:"e-clipboard",styles:"opacity: 0",attrs:{tabindex:"-1","aria-label":"clipboard"}}),this.parent.element.appendChild(this.clipBoardTextArea)},e.prototype.keyDownHandler=function(e){"ctrlPlusC"===e.action?this.copy():"ctrlShiftPlusH"===e.action&&this.copy(!0)},e.prototype.setCopyData=function(e){if(""===window.getSelection().toString()){var i=this.parent.isFrozenGrid();this.clipBoardTextArea.value=this.copyContent="";var r=void 0,n=void 0,o=this.parent.getRows();if(i&&(r=this.parent.getMovableDataRows(),this.parent.getFrozenMode()===hs&&(n=this.parent.getFrozenRightRows())),"Cell"!==this.parent.selectionSettings.mode){var s=this.parent.getSelectedRowIndexes().sort(function(e,t){return e-t});if(e){for(var l=[],a=0;a<this.parent.getVisibleColumns().length;a++)l[a]=this.parent.getVisibleColumns()[a].headerText;this.getCopyData(l,!1,"\t",e),this.copyContent+="\n"}for(a=0;a<s.length;a++){a>0&&(this.copyContent+="\n");var h=[].slice.call(o[s[a]].querySelectorAll(".e-rowcell:not(.e-hide)"));i&&(h.push.apply(h,[].slice.call(r[s[a]].querySelectorAll(".e-rowcell:not(.e-hide)"))),n&&h.push.apply(h,[].slice.call(n[s[a]].querySelectorAll(".e-rowcell:not(.e-hide)")))),this.getCopyData(h,!1,"\t",e)}}else{var d=this.checkBoxSelection();if(d.status){if(e){var p=[];for(a=0;a<d.colIndexes.length;a++)p.push(this.parent.getColumnHeaderByIndex(d.colIndexes[a]));this.getCopyData(p,!1,"\t",e),this.copyContent+="\n"}for(a=0;a<d.rowIndexes.length;a++){a>0&&(this.copyContent+="\n");h=[].slice.call(o[d.rowIndexes[a]].getElementsByClassName("e-cellselectionbackground"));i&&(h.push.apply(h,[].slice.call(r[d.rowIndexes[a]].getElementsByClassName("e-cellselectionbackground"))),n&&h.push.apply(h,[].slice.call(n[d.rowIndexes[a]].getElementsByClassName("e-cellselectionbackground")))),this.getCopyData(h,!1,"\t",e)}}else this.getCopyData([].slice.call(this.parent.element.getElementsByClassName("e-cellselectionbackground")),!0,"\n",e)}var c={data:this.copyContent,cancel:!1};if(this.parent.trigger("beforeCopy",c),c.cancel)return;this.clipBoardTextArea.value=this.copyContent=c.data,t.Browser.userAgent.match(/ipad|ipod|iphone/i)?this.clipBoardTextArea.setSelectionRange(0,this.clipBoardTextArea.value.length):this.clipBoardTextArea.select(),this.isSelect=!0}},e.prototype.getCopyData=function(e,t,i,r){for(var n="string"!=typeof e[0],o=0;o<e.length;o++){if(r&&t){var s=parseInt(e[o].getAttribute(cs),10);this.copyContent+=this.parent.getColumns()[s].headerText+"\n"}n?e[o].classList.contains("e-hide")||(this.copyContent+=e[o].innerText):this.copyContent+=e[o],o<e.length-1&&(this.copyContent+=i)}},e.prototype.copy=function(e){document.queryCommandSupported("copy")&&(this.setCopyData(e),document.execCommand("copy"),this.clipBoardTextArea.blur()),this.isSelect&&(window.getSelection().removeAllRanges(),this.isSelect=!1)},e.prototype.getModuleName=function(){return"clipboard"},e.prototype.destroy=function(){this.removeEventListener(),this.clipBoardTextArea&&t.remove(this.clipBoardTextArea)},e.prototype.checkBoxSelection=function(){var e=this.parent,t={status:!1};if("Cell"===e.selectionSettings.mode){var i=e.getSelectedRowCellIndexes(),r=void 0,n=[],o=void 0;for(o=0;o<i.length&&(i[o].cellIndexes.length&&n.push(i[o].rowIndex),!i[o].cellIndexes.length||(r||(r=JSON.stringify(i[o].cellIndexes.sort())),r===JSON.stringify(i[o].cellIndexes.sort())));o++);n.sort(function(e,t){return e-t}),o===i.length&&n[n.length-1]-n[0]==n.length-1&&(t={status:!0,rowIndexes:n,colIndexes:i[0].cellIndexes})}return t},e}(),Pl=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Ll=function(e,t,i,r){var n,o=arguments.length,s=o<3?t:null===r?r=Object.getOwnPropertyDescriptor(t,i):r;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,i,r);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(o<3?n(s):o>3?n(t,i,s):n(t,i))||s);return o>3&&s&&Object.defineProperty(t,i,s),s},ql=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return Pl(i,e),Ll([t.Property()],i.prototype,"field",void 0),Ll([t.Property()],i.prototype,"direction",void 0),Ll([t.Property(!1)],i.prototype,"isFromGroup",void 0),i}(t.ChildProperty),Hl=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return Pl(i,e),Ll([t.Collection([],ql)],i.prototype,"columns",void 0),Ll([t.Property(!0)],i.prototype,"allowUnsort",void 0),i}(t.ChildProperty),Ul=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return Pl(i,e),Ll([t.Property()],i.prototype,"field",void 0),Ll([t.Property()],i.prototype,"operator",void 0),Ll([t.Property()],i.prototype,"value",void 0),Ll([t.Property()],i.prototype,"matchCase",void 0),Ll([t.Property(!1)],i.prototype,"ignoreAccent",void 0),Ll([t.Property()],i.prototype,"predicate",void 0),Ll([t.Property({})],i.prototype,"actualFilterValue",void 0),Ll([t.Property({})],i.prototype,"actualOperator",void 0),Ll([t.Property()],i.prototype,"type",void 0),Ll([t.Property()],i.prototype,"ejpredicate",void 0),Ll([t.Property()],i.prototype,"uid",void 0),Ll([t.Property()],i.prototype,"isForeignKey",void 0),i}(t.ChildProperty),jl=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return Pl(i,e),Ll([t.Property(!1)],i.prototype,"enableCache",void 0),Ll([t.Property(3)],i.prototype,"maxBlocks",void 0),Ll([t.Property(3)],i.prototype,"initialBlocks",void 0),i}(t.ChildProperty),Vl=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return Pl(i,e),Ll([t.Collection([],Ul)],i.prototype,"columns",void 0),Ll([t.Property("FilterBar")],i.prototype,"type",void 0),Ll([t.Property()],i.prototype,"mode",void 0),Ll([t.Property(!0)],i.prototype,"showFilterBarStatus",void 0),Ll([t.Property(1500)],i.prototype,"immediateModeDelay",void 0),Ll([t.Property()],i.prototype,"operators",void 0),Ll([t.Property(!1)],i.prototype,"ignoreAccent",void 0),Ll([t.Property(!1)],i.prototype,"enableCaseSensitivity",void 0),Ll([t.Property(!1)],i.prototype,"showFilterBarOperator",void 0),i}(t.ChildProperty),Gl=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return Pl(i,e),Ll([t.Property("Row")],i.prototype,"mode",void 0),Ll([t.Property("Flow")],i.prototype,"cellSelectionMode",void 0),Ll([t.Property("Single")],i.prototype,"type",void 0),Ll([t.Property(!1)],i.prototype,"checkboxOnly",void 0),Ll([t.Property(!1)],i.prototype,"persistSelection",void 0),Ll([t.Property("Default")],i.prototype,"checkboxMode",void 0),Ll([t.Property(!1)],i.prototype,"enableSimpleMultiRowSelection",void 0),Ll([t.Property(!0)],i.prototype,"enableToggle",void 0),Ll([t.Property(!1)],i.prototype,"allowColumnSelection",void 0),i}(t.ChildProperty),_l=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return Pl(i,e),Ll([t.Property([])],i.prototype,"fields",void 0),Ll([t.Property("")],i.prototype,"key",void 0),Ll([t.Property("contains")],i.prototype,"operator",void 0),Ll([t.Property(!0)],i.prototype,"ignoreCase",void 0),Ll([t.Property(!1)],i.prototype,"ignoreAccent",void 0),i}(t.ChildProperty),Wl=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return Pl(i,e),Ll([t.Property()],i.prototype,"targetID",void 0),i}(t.ChildProperty),Kl=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return Pl(i,e),Ll([t.Property("Both")],i.prototype,"wrapMode",void 0),i}(t.ChildProperty),Ql=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return Pl(i,e),Ll([t.Property("Normal")],i.prototype,"mode",void 0),i}(t.ChildProperty),Xl=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return Pl(i,e),Ll([t.Property(!0)],i.prototype,"showDropArea",void 0),Ll([t.Property(!1)],i.prototype,"allowReordering",void 0),Ll([t.Property(!1)],i.prototype,"showToggleButton",void 0),Ll([t.Property(!1)],i.prototype,"showGroupedColumn",void 0),Ll([t.Property(!0)],i.prototype,"showUngroupButton",void 0),Ll([t.Property(!1)],i.prototype,"disablePageWiseAggregates",void 0),Ll([t.Property([])],i.prototype,"columns",void 0),Ll([t.Property()],i.prototype,"captionTemplate",void 0),Ll([t.Property(!1)],i.prototype,"enableLazyLoading",void 0),i}(t.ChildProperty),Yl=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return Pl(i,e),Ll([t.Property(!1)],i.prototype,"allowAdding",void 0),Ll([t.Property(!1)],i.prototype,"allowEditing",void 0),Ll([t.Property(!1)],i.prototype,"allowDeleting",void 0),Ll([t.Property("Normal")],i.prototype,"mode",void 0),Ll([t.Property(!0)],i.prototype,"allowEditOnDblClick",void 0),Ll([t.Property(!0)],i.prototype,"showConfirmDialog",void 0),Ll([t.Property(!1)],i.prototype,"showDeleteConfirmDialog",void 0),Ll([t.Property("")],i.prototype,"template",void 0),Ll([t.Property("")],i.prototype,"headerTemplate",void 0),Ll([t.Property("")],i.prototype,"footerTemplate",void 0),Ll([t.Property("Top")],i.prototype,"newRowPosition",void 0),Ll([t.Property({})],i.prototype,"dialog",void 0),Ll([t.Property(!1)],i.prototype,"allowNextRowEdit",void 0),i}(t.ChildProperty),Jl=function(n){function o(e,i){var r=n.call(this,e,i)||this;return r.isPreventScrollEvent=!1,r.inViewIndexes=[],r.keyA=!1,r.frozenRightCount=0,r.frozenLeftCount=0,r.tablesCount=1,r.movableCount=0,r.visibleFrozenLeft=0,r.visibleFrozenRight=0,r.visibleMovable=0,r.frozenLeftColumns=[],r.frozenRightColumns=[],r.movableColumns=[],r.media={},r.isFreezeRefresh=!1,r.tableIndex=0,r.componentRefresh=t.Component.prototype.refresh,r.isVirtualAdaptive=!1,r.vRows=[],r.vcRows=[],r.vGroupOffsets={},r.rowUid=0,r.currentViewData=[],r.isManualRefresh=!1,r.isAutoFitColumns=!1,r.enableDeepCompare=!1,r.lockcolPositionCount=0,r.prevPageMoving=!1,r.pageTemplateChange=!1,r.isAutoGen=!1,r.mediaBindInstance={},r.commandDelIndex=void 0,r.asyncTimeOut=50,r.isExportGrid=!1,r.enableLogger=!0,r.needsID=!0,s.Inject(Tl),t.setValue("mergePersistData",r.mergePersistGridData,r),r}Pl(o,n),s=o,o.prototype.getPersistData=function(){for(var e=["pageSettings","sortSettings","filterSettings","groupSettings","columns","searchSettings","selectedRowIndex","scrollPosition"],i={pageSettings:["template","pageSizes","enableQueryString","totalRecordsCount","pageCount"],filterSettings:["type","mode","showFilterBarStatus","immediateModeDelay","ignoreAccent"],groupSettings:["showDropArea","showToggleButton","showGroupedColumn","showUngroupButton","disablePageWiseAggregates","hideCaptionCount"],searchSettings:["fields","operator","ignoreCase"],sortSettings:[],columns:[],selectedRowIndex:[],scrollPosition:[]},r=0;r<e.length;r++)for(var n=this[e[r]],o=0,s=i[e[r]];o<s.length;o++){delete n[s[o]]}var l=this.pageSettings.template,a=Object.assign({template:void 0},this.pageSettings);this.setProperties({pageSettings:a},!0),this.isAngular&&delete this.groupSettings.properties.captionTemplate,this.pageTemplateChange=!t.isNullOrUndefined(this.pagerTemplate);var h=this.addOnPersist(e);return a.template=l,this.setProperties({pageSettings:a},!0),h},o.prototype.requiredModules=function(){this.setFrozenCount(),this.enableInfiniteAggrgate();var e=[];return this.isDestroyed?e:(this.allowFiltering&&e.push({member:"filter",args:[this,this.filterSettings,this.serviceLocator]}),this.allowExcelExport&&e.push({member:"ExcelExport",args:[this,this.serviceLocator]}),this.allowPdfExport&&e.push({member:"PdfExport",args:[this]}),this.allowSorting&&e.push({member:"sort",args:[this,this.sortSettings,this.sortedColumns,this.serviceLocator]}),this.allowPaging&&e.push({member:"pager",args:[this,this.pageSettings]}),this.allowSelection&&e.push({member:"selection",args:[this,this.selectionSettings,this.serviceLocator]}),e.push({member:"resize",args:[this]}),this.allowReordering&&e.push({member:"reorder",args:[this]}),this.allowRowDragAndDrop&&e.push({member:"rowDragAndDrop",args:[this]}),this.allowGrouping&&e.push({member:"group",args:[this,this.groupSettings,this.sortedColumns,this.serviceLocator]}),this.aggregates.length&&e.push({member:"aggregate",args:[this,this.serviceLocator]}),this.isDetail()&&e.push({member:"detailRow",args:[this,this.serviceLocator]}),(this.toolbar||this.toolbarTemplate)&&e.push({member:"toolbar",args:[this,this.serviceLocator]}),(this.enableVirtualization||this.enableColumnVirtualization)&&e.push({member:"virtualscroll",args:[this,this.serviceLocator]}),(this.getFrozenColumns()||this.frozenRows||this.frozenRightCount||this.frozenLeftCount)&&e.push({member:"freeze",args:[this,this.serviceLocator]}),this.isCommandColumn(this.columns)&&e.push({member:"commandColumn",args:[this,this.serviceLocator]}),(this.editSettings.allowAdding||this.editSettings.allowDeleting||this.editSettings.allowEditing)&&e.push({member:"edit",args:[this,this.serviceLocator]}),this.extendRequiredModules(e),e)},o.prototype.extendRequiredModules=function(e){this.enableInfiniteScrolling&&e.push({member:"infiniteScroll",args:[this,this.serviceLocator]}),this.groupSettings.enableLazyLoading&&e.push({member:"lazyLoadGroup",args:[this,this.serviceLocator]}),this.contextMenuItems&&e.push({member:"contextMenu",args:[this,this.serviceLocator]}),this.showColumnMenu&&e.push({member:"columnMenu",args:[this,this.serviceLocator]}),this.showColumnChooser&&e.push({member:"columnChooser",args:[this,this.serviceLocator]}),this.isForeignKeyEnabled(this.columns)&&e.push({member:"foreignKey",args:[this,this.serviceLocator]}),this.enableLogger&&e.push({member:"logger",args:[this]})},o.prototype.preRender=function(){this.serviceLocator=new al,this.initProperties(),this.initializeServices()},o.prototype.initProperties=function(){this.isInitial=!0,this.sortedColumns=[],this.inViewIndexes=[],this.mediaCol=[],this.isInitialLoad=!1,this.allowServerDataBinding=!1,this.ignoreCollectionWatch=!0,this.mergeCells={},this.isEdit=!1,this.checkAllRows="None",this.isCheckBoxSelection=!1,this.isPersistSelection=!1,this.componentRefresh=t.Component.prototype.refresh,this.filterOperators={contains:"contains",endsWith:"endswith",equal:"equal",greaterThan:"greaterthan",greaterThanOrEqual:"greaterthanorequal",lessThan:"lessthan",lessThanOrEqual:"lessthanorequal",notEqual:"notequal",startsWith:"startswith"},this.defaultLocale={EmptyRecord:"No records to display",True:"true",False:"false",InvalidFilterMessage:"Invalid Filter Data",GroupDropArea:"Drag a column header here to group its column",UnGroup:"Click here to ungroup",UnGroupButton:"Click here to ungroup",GroupDisable:"Grouping is disabled for this column",FilterbarTitle:"'s filter bar cell",EmptyDataSourceError:"DataSource must not be empty at initial load since columns are generated from dataSource in AutoGenerate Column Grid",Add:"Add",Edit:"Edit",Cancel:"Cancel",Update:"Update",Delete:"Delete",Print:"Print",Pdfexport:"PDF Export",Excelexport:"Excel Export",Wordexport:"Word Export",Csvexport:"CSV Export",Search:"Search",Columnchooser:"Columns",Save:"Save",Item:"item",Items:"items",EditOperationAlert:"No records selected for edit operation",DeleteOperationAlert:"No records selected for delete operation",SaveButton:"Save",OKButton:"OK",CancelButton:"Cancel",EditFormTitle:"Details of ",AddFormTitle:"Add New Record",BatchSaveConfirm:"Are you sure you want to save changes?",BatchSaveLostChanges:"Unsaved changes will be lost. Are you sure you want to continue?",ConfirmDelete:"Are you sure you want to Delete Record?",CancelEdit:"Are you sure you want to Cancel the changes?",ChooseColumns:"Choose Column",SearchColumns:"search columns",Matchs:"No matches found",FilterButton:"Filter",ClearButton:"Clear",StartsWith:"Starts With",EndsWith:"Ends With",Contains:"Contains",Equal:"Equal",NotEqual:"Not Equal",LessThan:"Less Than",LessThanOrEqual:"Less Than Or Equal",GreaterThan:"Greater Than",GreaterThanOrEqual:"Greater Than Or Equal",ChooseDate:"Choose a Date",EnterValue:"Enter the value",Copy:"Copy",Group:"Group by this column",Ungroup:"Ungroup by this column",autoFitAll:"Autofit all columns",autoFit:"Autofit this column",AutoFitAll:"Autofit all columns",AutoFit:"Autofit this column",Export:"Export",FirstPage:"First Page",LastPage:"Last Page",PreviousPage:"Previous Page",NextPage:"Next Page",SortAscending:"Sort Ascending",SortDescending:"Sort Descending",EditRecord:"Edit Record",DeleteRecord:"Delete Record",FilterMenu:"Filter",SelectAll:"Select All",Blanks:"Blanks",FilterTrue:"True",FilterFalse:"False",NoResult:"No matches found",ClearFilter:"Clear Filter",Clear:"Clear",NumberFilter:"Number Filters",TextFilter:"Text Filters",DateFilter:"Date Filters",DateTimeFilter:"DateTime Filters",MatchCase:"Match Case",Between:"Between",CustomFilter:"Custom Filter",CustomFilterPlaceHolder:"Enter the value",CustomFilterDatePlaceHolder:"Choose a date",AND:"AND",OR:"OR",ShowRowsWhere:"Show rows where:",FilterMenuDialogARIA:"Filter menu dialog",ExcelFilterDialogARIA:"Excel filter dialog",DialogEditARIA:"Edit dialog",ColumnChooserDialogARIA:"Column chooser dialog",ColumnMenuDialogARIA:"Column menu dialog",CustomFilterDialogARIA:"Customer filter dialog",SortAtoZ:"Sort A to Z",SortZtoA:"Sort Z to A",SortByOldest:"Sort by Oldest",SortByNewest:"Sort by Newest",SortSmallestToLargest:"Sort Smallest to Largest",SortLargestToSmallest:"Sort Largest to Smallest",Sort:"Sort"},this.keyConfigs={downArrow:"downarrow",upArrow:"uparrow",rightArrow:"rightarrow",leftArrow:"leftarrow",shiftDown:"shift+downarrow",shiftUp:"shift+uparrow",shiftRight:"shift+rightarrow",shiftLeft:"shift+leftarrow",home:"home",end:"end",escape:"escape",ctrlHome:"ctrl+home",ctrlEnd:"ctrl+end",pageUp:"pageup",pageDown:"pagedown",ctrlAltPageUp:"ctrl+alt+pageup",ctrlAltPageDown:"ctrl+alt+pagedown",altPageUp:"alt+pageup",altPageDown:"alt+pagedown",altDownArrow:"alt+downarrow",altUpArrow:"alt+uparrow",ctrlDownArrow:"ctrl+downarrow",ctrlUpArrow:"ctrl+uparrow",ctrlPlusA:"ctrl+A",ctrlPlusP:"ctrl+P",insert:"insert",delete:"delete",f2:"f2",enter:"enter",ctrlEnter:"ctrl+enter",shiftEnter:"shift+enter",tab:"tab",shiftTab:"shift+tab",space:"space",ctrlPlusC:"ctrl+C",ctrlShiftPlusH:"ctrl+shift+H",ctrlSpace:"ctrl+space",ctrlLeftArrow:"ctrl+leftarrow",ctrlRightArrow:"ctrl+rightarrow"}},o.prototype.render=function(){this.log(["module_missing","promise_enabled","locale_missing","check_datasource_columns"]),this.ariaService.setOptions(this.element,{role:"grid"}),r.createSpinner({target:this.element},this.createElement),this.renderModule=new ol(this,this.serviceLocator),this.searchModule=new zl(this),this.scrollModule=new Ml(this),this.notify(bi,{}),!0!==this.getDataModule().dataManager.dataSource.offline&&void 0!==this.getDataModule().dataManager.dataSource.url||(this.isVirtualAdaptive=!0),this.trigger("load"),I(this.columns,this.enableColumnVirtualization,this),this.enablePersistence&&this.notify(pn,{}),this.getMediaColumns(),E(this.columns),this.checkLockColumns(this.columns),this.getColumns(),this.processModel(),this.gridRender(),this.wireEvents(),this.addListener(),this.updateDefaultCursor(),this.updateStackedFilter(),this.showSpinner(),this.notify(Si,{}),this.refreshing&&this.trigger("created")},o.prototype.showSpinner=function(){this.isExportGrid||r.showSpinner(this.element)},o.prototype.hideSpinner=function(){this.isExportGrid||r.hideSpinner(this.element)},o.prototype.updateStackedFilter=function(){this.allowFiltering&&"FilterBar"===this.filterSettings.type&&this.getHeaderContent().getElementsByClassName("e-stackedheadercell").length?this.getHeaderContent().classList.add("e-stackedfilter"):this.getHeaderContent().classList.remove("e-stackedfilter")},o.prototype.getMediaColumns=function(){if(!this.enableColumnVirtualization){var e=this.getColumns();if(this.getShowHideService=this.serviceLocator.getService("showHideService"),!t.isNullOrUndefined(e))for(var i=0;i<e.length;i++)t.isNullOrUndefined(e[i].hideAtMedia)||!t.isNullOrUndefined(e[i].visible)&&!e[i].visible||this.pushMediaColumn(e[i],i)}},o.prototype.pushMediaColumn=function(e,t){this.mediaCol.push(e),this.media[e.uid]=window.matchMedia(e.hideAtMedia),this.mediaQueryUpdate(t,this.media[e.uid]),this.mediaBindInstance[t]=this.mediaQueryUpdate.bind(this,t),this.media[e.uid].addListener(this.mediaBindInstance[t])},o.prototype.updateMediaColumns=function(e){if(!this.enableColumnVirtualization){for(var t=this.getColumnIndexByUid(e.uid),i=0;i<this.mediaCol.length;i++)if(e.uid===this.mediaCol[i].uid)return void this.mediaCol.splice(i,1);this.pushMediaColumn(e,t)}},o.prototype.mediaQueryUpdate=function(e,t){var i=this.getColumns()[e];this.mediaCol.some(function(e){return e.uid===i.uid})&&(i.visible=t.matches,this.isInitialLoad&&(this.invokedFromMedia=!0,i.visible?this.showHider.show(i.headerText,"headerText"):this.showHider.hide(i.headerText,"headerText")))},o.prototype.refreshMediaCol=function(){this.isInitialLoad=!0;var e=this.element.querySelector("."+Qo);this.aggregates.length&&this.element.scrollHeight>this.height&&e&&t.addClass([e],["e-footerpadding"]);this.getColumns().filter(function(e){return"checkbox"===e.type}).length&&"ResetOnRowClick"===this.selectionSettings.checkboxMode&&(this.isCheckBoxSelection=!1),"Vertical"===this.rowRenderingMode&&this.enableHover&&(this.setProperties({enableAdaptiveUI:!0,enableHover:!1},!0),t.removeClass([this.element],"e-gridhover")),this.enableAdaptiveUI&&this.scrollModule&&this.scrollModule.refresh()},o.prototype.removeMediaListener=function(){for(var e=0;e<this.mediaCol.length;e++)this.media[this.mediaCol[e].uid].removeListener(this.mediaBindInstance[this.mediaCol[e].index])},o.prototype.eventInitializer=function(){},o.prototype.destroy=function(){var e=this.element;if(e){var i=!(!e.querySelector("."+Wo)||!e.querySelector("."+Ko));i&&this.unwireEvents(),this.removeListener(),this.removeMediaListener(),this.notify(Ki,{}),this.destroyDependentModules(),(this.isReact||this.isVue)&&this.destroyTemplate(["template"]),i&&n.prototype.destroy.call(this),this.toolTipObj.destroy();for(var r=["renderModule","headerModule","contentModule","valueFormatterService","serviceLocator","ariaService","keyboardModule","widthService","searchModule","showHider","scrollModule","printModule","clipboardModule","focusModule"],o=0;o<r.length;o++)this[r[o]]&&(this[r[o]]=null);this.element.innerHTML="",t.classList(this.element,[],["e-rtl","e-gridhover","e-responsive","e-default","e-device","e-grid-min-height"]),this.isFreezeRefresh=!1}},o.prototype.destroyDependentModules=function(){var e=this.element;e&&(e.querySelector("."+Wo)||e.querySelector("."+Ko))&&(this.scrollModule.destroy(),this.keyboardModule.destroy(),this.focusModule.destroy(),this.clipboardModule.destroy(),this.printModule.destroy())},o.prototype.getModuleName=function(){return"grid"},o.prototype.enableBoxSelection=function(){this.enableAutoFill?(this.selectionSettings.cellSelectionMode="BoxWithBorder",this.element.classList.add("e-afenabled")):this.element.classList.remove("e-afenabled")},o.prototype.onPropertyChanged=function(e,i){var r,n=!1,o=!1,s=!1;if(!this.isDestroyed){this.log("module_missing"),this.isEllipsisTooltip()&&this.toolTipObj.close();var l=Object.keys(e);l.indexOf("columns")>-1&&(this.enableColumnVirtualization&&(this.columnModel=[]),this.updateColumnObject(),o=!0);for(var a=0,h=l;a<h.length;a++){var d=h[a];switch(d){case"allowPaging":this.notify(Fi,{module:"pager",enable:this.allowPaging}),n=!0;break;case"pageSettings":if(this.pageTemplateChange){this.pageTemplateChange=!1,this.notify(Ii,{module:"pager",properties:e.pageSettings});break}this.notify(Ii,{module:"pager",properties:e.pageSettings}),(t.isNullOrUndefined(e.pageSettings.currentPage)&&t.isNullOrUndefined(e.pageSettings.pageSize)&&t.isNullOrUndefined(e.pageSettings.totalRecordsCount)||!t.isNullOrUndefined(i.pageSettings)&&e.pageSettings.currentPage!==i.pageSettings.currentPage&&!this.enableColumnVirtualization&&!this.enableVirtualization&&this.pageSettings.totalRecordsCount<=this.pageSettings.pageSize)&&(n=!0);break;case"allowSorting":this.notify(Fi,{module:"sort",enable:this.allowSorting}),n=!0,r=!0;break;case"allowFiltering":this.updateStackedFilter(),this.notify(Fi,{module:"filter",enable:this.allowFiltering}),n=!0,"FilterBar"!==this.filterSettings.type&&this.refreshHeader();break;case"height":case"width":this.notify(Fi,{module:"scroll",properties:{width:e.width,height:e.height}});break;case"allowReordering":this.headerModule.refreshUI(),r=!0;break;case"allowRowDragAndDrop":this.notify(Fi,{module:"rowDragAndDrop",enable:this.allowRowDragAndDrop}),this.renderModule.refresh(),this.headerModule.refreshUI();break;case"allowSelection":this.notify(Fi,{module:"selection",enable:this.allowSelection});break;case"enableAutoFill":this.selectionModule&&(this.enableBoxSelection(),this.selectionModule.updateAutoFillPosition());break;case"rowTemplate":this.rowTemplateFn=R(this.rowTemplate),n=!0;break;case"detailTemplate":this.detailTemplateFn=R(this.detailTemplate),n=!0;break;case"allowGrouping":this.notify(Fi,{module:"group",enable:this.allowGrouping}),this.headerModule.refreshUI(),n=!0,r=!0;break;case"enableInfiniteScrolling":case"childGrid":n=!0;break;case"toolbar":this.notify(Fi,{module:"toolbar"});break;case"groupSettings":this.notify(Ii,{module:"group",properties:e.groupSettings,oldProperties:i.groupSettings});break;case"aggregates":!this.aggregates.length&&this.allowGrouping&&this.groupSettings.columns.length&&(n=!0),this.notify(Fi,{module:"aggregate",properties:e});break;case"frozenColumns":case"frozenRows":case"enableVirtualization":case"currencyCode":case"locale":this.log("frozen_rows_columns"),s=!0,o=!0;break;case"query":this.getDataModule().isQueryInvokedFromData||(n=!0),this.getDataModule().isQueryInvokedFromData=!1;break;default:this.extendedPropertyChange(d,e,o)}}r&&this.updateDefaultCursor(),o?s||this.getFrozenColumns()||this.frozenRows?this.freezeRefresh():this.refresh():n&&(this.notify(Ti,{requestType:"refresh"}),n=!1,this.maintainSelection(e.selectedRowIndex))}},o.prototype.extendedPropertyChange=function(e,r,n){switch(e){case"enableRtl":this.updateRTL(),this.allowPaging&&(this.element.querySelector(".e-gridpager").ej2_instances[0].enableRtl=r.enableRtl,this.element.querySelector(".e-gridpager").ej2_instances[0].dataBind()),"auto"!==this.height&&(this.scrollModule.removePadding(!r.enableRtl),this.scrollModule.setPadding()),this.toolbar&&this.toolbarModule&&(this.toolbarModule.getToolbar().ej2_instances[0].enableRtl=r.enableRtl,this.toolbarModule.getToolbar().ej2_instances[0].dataBind()),this.contextMenuItems&&this.contextMenuModule&&(this.contextMenuModule.getContextMenu().ej2_instances[0].enableRtl=r.enableRtl,this.contextMenuModule.getContextMenu().ej2_instances[0].dataBind()),this.showColumnMenu&&this.columnMenuModule&&(this.columnMenuModule.getColumnMenu().ej2_instances[0].enableRtl=r.enableRtl,this.columnMenuModule.getColumnMenu().ej2_instances[0].dataBind()),"FilterBar"===this.filterSettings.type&&this.filterSettings.showFilterBarOperator&&this.refreshHeader(),this.notify(Gr,{});break;case"enableAltRow":this.renderModule.refresh();break;case"allowResizing":this.headerModule.refreshUI(),this.updateResizeLines();break;case"rowHeight":this.rowHeight?t.addClass([this.element],"e-grid-min-height"):t.removeClass([this.element],"e-grid-min-height"),this.renderModule.refresh(),this.headerModule.refreshUI();break;case"gridLines":this.updateGridLines();break;case"showColumnMenu":this.headerModule.refreshUI(),this.notify(Fi,{module:"columnMenu",enable:!0});break;case"columnMenuItems":this.notify(Fi,{module:"columnMenu",enable:this.columnMenuItems});break;case"contextMenuItems":this.notify(Fi,{module:"contextMenu",enable:this.contextMenuItems});break;case"showColumnChooser":this.notify(Fi,{module:"columnChooser",enable:this.showColumnChooser});break;case"filterSettings":this.updateStackedFilter(),this.notify(Ii,{module:"filter",properties:r.filterSettings});break;case"searchSettings":this.notify(Ii,{module:"search",properties:r.searchSettings});break;case"sortSettings":this.notify(Ii,{module:"sort"});break;case"selectionSettings":this.notify(Ii,{module:"selection",properties:r.selectionSettings});break;case"editSettings":this.notify(Ii,{module:"edit",properties:r.editSettings});break;case"allowTextWrap":case"textWrapSettings":this.allowTextWrap?this.applyTextWrap():this.removeTextWrap(),this.notify(zr,{case:"textwrap",isModeChg:"textWrapSettings"===e});break;case"dataSource":var o=this.getDataModule().getState();if(Object.getPrototypeOf(r).deepWatch)for(var s=this.getPrimaryKeyFieldNames()[0],l=0,a=Object.keys(r.dataSource);l<a.length;l++)this.setRowData(t.getValue(s,this.dataSource[a[l]]),this.dataSource[a[l]]);else if(o.isPending){var h=t.isNullOrUndefined(this.dataSource)?[]:this.dataSource.result,d=o.group||[];for(l=0;l<d.length;l++)h=i.DataUtil.group(h,d[l],o.aggregates||[]);this.dataSource={result:h,count:this.dataSource.count,aggregates:this.dataSource.aggregates},this.getDataModule().setState({}),o.resolver(this.dataSource)}else this.getDataModule().setState({isDataChanged:!1}),this.notify(ir,{}),n||(this.renderModule.refresh(),this.isCheckBoxSelection&&this.notify(to,{}));this.scrollRefresh();break;case"enableHover":(r.enableHover?t.addClass:t.removeClass)([this.element],"e-gridhover");break;case"selectedRowIndex":this.isSelectedRowIndexUpdating||this.selectRow(r.selectedRowIndex),this.isSelectedRowIndexUpdating=!1;break;case"resizeSettings":this.widthService.setWidthToTable();break;case"enableAdaptiveUI":this.notify(vo,{});break;case"rowRenderingMode":this.enableVerticalRendering(),this.notify(wo,{}),this.refresh();break;case"enableStickyHeader":this.scrollModule.addStickyListener(r.enableStickyHeader)}},o.prototype.maintainSelection=function(e){var t=this;if(-1!==e){var i=function(){t.selectRow(e),t.off(xi,i)};this.on(xi,i,this)}},o.prototype.setProperties=function(e,t){n.prototype.setProperties.call(this,e,t);e.filterSettings&&this.filterModule&&t&&this.filterModule.refreshFilter()},o.prototype.setTablesCount=function(){var e=this.getFrozenColumns(),t=this.getFrozenLeftColumnsCount(),i=this.getFrozenRightColumnsCount();!e||t||i?e||!t&&!i||(t&&!i||i&&!t?this.tablesCount=2:t&&i&&(this.tablesCount=3)):this.tablesCount=2},o.prototype.getTablesCount=function(){return this.tablesCount},o.prototype.updateDefaultCursor=function(){var e=[].slice.call(this.getHeaderContent().querySelectorAll(".e-headercell:not(.e-stackedheadercell)")),t=[].slice.call(this.getHeaderContent().getElementsByClassName("e-stackedheadercell")),i=this.getColumns();if(this.enableColumnVirtualization&&this.getFrozenColumns()){var r=this.contentModule.getHeaderCells();e=r.length?r:e}for(var n=0;n<e.length;n++){var o=e[n];(this.allowGrouping||this.allowReordering||this.allowSorting)&&(i[n].allowReordering&&i[n].allowSorting&&i[n].allowGrouping?o.classList.add("e-mousepointer"):o.classList.add("e-defaultcursor"))}for(var s=0;s<t.length;s++)this.allowReordering&&t[s].classList.add("e-mousepointer")},o.prototype.updateColumnModel=function(e){for(var t=0,i=e.length;t<i;t++)e[t].columns?this.updateColumnModel(e[t].columns):this.columnModel.push(e[t]);this.updateColumnLevelFrozen(),this.updateFrozenColumns(),this.updateLockableColumns()},o.prototype.updateColumnLevelFrozen=function(){var e=this.columnModel,t=[],i=[],r=[];if(this.frozenLeftCount||this.frozenRightCount){for(var n=0,o=e.length;n<o;n++){var s=e[n];"Left"===s.freeze?(s.freezeTable=ps,t.push(s)):"Right"===s.freeze?(s.freezeTable=ds,i.push(s)):(s.freezeTable="movable",r.push(s))}this.columnModel=t.concat(r).concat(i)}},o.prototype.updateFrozenColumns=function(){if(!this.frozenLeftCount&&!this.frozenRightCount)for(var e=this.columnModel,t=this.frozenColumns,i=this.getFrozenColumns(),r=0,n=0,o=e.length;n<o;n++){var s=e[n];t&&(s.freezeTable=n<t?ps:"movable"),s.isFrozen&&n>=t?(s.freezeTable=ps,e.splice(this.frozenColumns+r,0,e.splice(n,1)[0]),r++):i&&!t&&(s.freezeTable="movable")}},o.prototype.getFrozenLeftCount=function(){return this.getFrozenColumns()||this.getFrozenLeftColumnsCount()},o.prototype.isFrozenGrid=function(){return 0!==this.getFrozenColumns()||0!==this.getFrozenLeftColumnsCount()||0!==this.getFrozenRightColumnsCount()},o.prototype.getFrozenMode=function(){return this.frozenName},o.prototype.updateLockableColumns=function(){for(var e=this.columnModel,t=0,i=0,r=this.getFrozenColumns(),n=0;n<e.length;n++)e[n].lockColumn&&(n<r?(e.splice(t,0,e.splice(n,1)[0]),t++):(e.splice(r+i,0,e.splice(n,1)[0]),i++))},o.prototype.checkLockColumns=function(e){for(var t=0;t<e.length;t++)e[t].columns?this.checkLockColumns(e[t].columns):e[t].lockColumn&&this.lockcolPositionCount++},o.prototype.getColumns=function(e){var i=this,r=this.inViewIndexes.map(function(e){return e-i.groupSettings.columns.length}).filter(function(e){return e>-1}),n=r.length;(!this.enableColumnVirtualization||t.isNullOrUndefined(this.columnModel)||0===this.columnModel.length||e)&&(this.columnModel=[],this.updateColumnModel(this.columns));var o=0===n?this.columnModel:this.columnModel.slice(r[0],r[n-1]+1);if(this.contentModule&&this.enableColumnVirtualization&&this.isFrozenGrid()&&r.length&&r[0]>0){o=this.contentModule.ensureFrozenCols(o)}return o},o.prototype.getStackedHeaderColumnByHeaderText=function(e,t){for(var i=0;i<t.length;i++){var r=t[i];if(r.field===e||r.headerText===e){this.stackedColumn=r;break}r.columns&&this.getStackedHeaderColumnByHeaderText(e,r.columns)}return this.stackedColumn},o.prototype.getColumnIndexesInView=function(){return this.inViewIndexes},o.prototype.getQuery=function(){return this.query},o.prototype.getLocaleConstants=function(){return this.defaultLocale},o.prototype.setColumnIndexesInView=function(e){this.inViewIndexes=e},o.prototype.getVisibleColumns=function(){return this.getCurrentVisibleColumns()},o.prototype.getHeaderContent=function(){return this.headerModule.getPanel()},o.prototype.setGridHeaderContent=function(e){this.headerModule.setPanel(e)},o.prototype.getContentTable=function(){return this.contentModule.getTable()},o.prototype.setGridContentTable=function(e){this.contentModule.setTable(e)},o.prototype.getContent=function(){return this.contentModule.getPanel()},o.prototype.setGridContent=function(e){this.contentModule.setPanel(e)},o.prototype.getHeaderTable=function(){return this.headerModule.getTable()},o.prototype.setGridHeaderTable=function(e){this.headerModule.setTable(e)},o.prototype.getFooterContent=function(){return this.footerElement=this.element.getElementsByClassName(Qo)[0],this.footerElement},o.prototype.getFooterContentTable=function(){return this.footerElement=this.element.getElementsByClassName(Qo)[0],this.footerElement.firstChild.firstChild},o.prototype.getPager=function(){return this.gridPager},o.prototype.setGridPager=function(e){this.gridPager=e},o.prototype.getRowByIndex=function(e){return this.contentModule.getRowByIndex(e)},o.prototype.getMovableRowByIndex=function(e){return this.contentModule.getMovableRowByIndex(e)},o.prototype.getFrozenRowByIndex=function(e){return this.getFrozenDataRows()[e]},o.prototype.getRows=function(){return this.contentModule.getRowElements()},o.prototype.getFrozenRightRowByIndex=function(e){return this.contentModule.getFrozenRightRowByIndex(e)},o.prototype.getRowInfo=function(e){var i=e,r={target:e};if(!t.isNullOrUndefined(e)&&t.isNullOrUndefined(D(i,"e-detailrowcollapse")&&t.isNullOrUndefined(D(i,"e-recordplusexpand")))){var n=t.closest(i,"."+_o);if(!n){var o=t.closest(i,"."+is);if(!t.isNullOrUndefined(o)&&!o.classList.contains("e-addedrow")){var s=this.getRowObjectFromUID(o.getAttribute("data-uid")),l=parseInt(o.getAttribute(us),10);r={row:o,rowData:s.data,rowIndex:l}}return r}var a=parseInt(n.getAttribute(cs),10);if(!t.isNullOrUndefined(n)&&!isNaN(a)){var h=t.closest(n,"."+is),d=(l=parseInt(h.getAttribute(us),10),this.getFrozenColumns()),p=this.columnModel[a].getFreezeTableName(),c=this.contentModule.getRows(),u=a+this.getIndentCount();this.isFrozenGrid()&&(p===ps?c=this.contentModule.getRows():"movable"===p?(u=a-d-this.frozenLeftCount,c=this.contentModule.getMovableRows()):p===ds&&(u=a-(this.frozenLeftCount+this.movableCount),c=this.contentModule.getFrozenRightRows()));var g=c.filter(function(e){return e.uid===h.getAttribute("data-uid")}),f={},m=void 0;Object.keys(g).length&&(f=g[0].data,m=g[0].cells[u].column),r={cell:n,cellIndex:a,row:h,rowIndex:l,rowData:f,column:m,target:e}}}return r},o.prototype.getMovableRows=function(){return this.contentModule.getMovableRowElements()},o.prototype.getFrozenRightRows=function(){return this.contentModule.getFrozenRightRowElements()},o.prototype.getDataRows=function(){return this.getAllDataRows()},o.prototype.getAllDataRows=function(e){if(t.isNullOrUndefined(this.getContentTable().querySelector(gs)))return[];var i=this.isFrozenGrid()?this.getFrozenLeftContentTbody():this.getContentTable().querySelector(gs),r=[].slice.call(i.children);if(this.frozenRows){var n=this.isFrozenGrid()?this.getHeaderContent().querySelector("."+$o).querySelector(gs):this.getHeaderTable().querySelector(gs),o=[].slice.call(n.children);r=this.addMovableRows(o,r)}return this.generateDataRows(r,e)},o.prototype.addMovableRows=function(e,t){for(var i=0,r=t.length;i<r;i++)e.push(t[i]);return e},o.prototype.generateDataRows=function(e,t){for(var i=[],r=0,n=e.length;r<n;r++)!e[r].classList.contains(is)||e[r].classList.contains("e-hiddenrow")&&!t||(this.isCollapseStateEnabled()?i[parseInt(e[r].getAttribute("aria-rowindex"),10)]=e[r]:i.push(e[r]));return i},o.prototype.getMovableDataRows=function(){return this.getAllMovableDataRows()},o.prototype.getAllMovableDataRows=function(e){if(!this.isFrozenGrid())return[];var t=[].slice.call(this.getContent().querySelector("."+Yo).querySelector(gs).children);if(this.frozenRows){var i=[].slice.call(this.getHeaderContent().querySelector("."+Jo).querySelector(gs).children);t=this.addMovableRows(i,t)}return this.generateDataRows(t,e)},o.prototype.getFrozenDataRows=function(){return this.getAllFrozenDataRows()},o.prototype.getAllFrozenDataRows=function(e){var t=[].slice.call(this.getContent().querySelector("."+Zo).querySelector(gs).children);if(this.frozenRows){var i=[].slice.call(this.getHeaderContent().querySelector("."+$o).querySelector(gs).children);t=this.addMovableRows(i,t)}return this.generateDataRows(t,e)},o.prototype.getFrozenRightDataRows=function(){return this.getAllFrozenRightDataRows()},o.prototype.getAllFrozenRightDataRows=function(e){if("Right"!==this.getFrozenMode()&&"Left-Right"!==this.getFrozenMode())return[];var t=[].slice.call(this.getContent().querySelector(".e-frozen-right-content").querySelector(gs).children);if(this.frozenRows){var i=[].slice.call(this.getHeaderContent().querySelector(".e-frozen-right-header").querySelector(gs).children);t=this.addMovableRows(i,t)}return this.generateDataRows(t,e)},o.prototype.setCellValue=function(e,i,r){var n="Right"===this.getFrozenMode(),o=this.getPrimaryKeyFieldNames()[0],s=new Bs(this,this.serviceLocator),l=this.getColumnIndexByField(i),a=this.getColumnByField(i),h=("movable"===a.getFreezeTableName()?this.contentModule.getMovableRows():"frozen-right"===a.getFreezeTableName()?this.getFrozenRightRowsObject():this.contentModule.getRows()).filter(function(i){return t.getValue(o,i.data)===e})[0],d=h?this.element.querySelector("[data-uid="+h.uid+"]"):null;if(!t.isNullOrUndefined(d)){t.setValue(i,r,h.data);var p=this.getFrozenLeftColumnsCount()||this.getFrozenColumns(),c=this.getMovableColumnsCount();this.isRowDragable()&&!n&&p++;var u=p+c,g=this.getCellFromIndex(h.index,l);if(!t.isNullOrUndefined(g)){var f="movable"===a.getFreezeTableName()?p:"frozen-right"===a.getFreezeTableName()?u:0;this.groupSettings.columns.length&&(l+=this.groupSettings.columns.length),(this.childGrid||this.detailTemplate)&&l++,this.isRowDragable()&&!n&&l++;var m=h.cells[l-f];s.refreshTD(g,m,h.data,{index:h.index}),this.aggregates.length>0&&(this.notify(Hi,{}),this.groupSettings.columns.length>0&&this.notify(qi,{})),t.isNullOrUndefined(h)||t.isNullOrUndefined(h.changes)||(h.changes[i]=r),this.trigger(It,{cell:g,column:a,data:h.data})}}},o.prototype.refreshReactColumnTemplateByUid=function(e){var i=this;this.isReact&&this.clearTemplate(["columnTemplate"],void 0,function(){for(var r=i.getDataRows(),n=i.getIndentCount(),o=i.getNormalizedColumnIndex(e),s=0;s<r.length;s++){var l=i.getRowObjectFromUID(r[s].getAttribute("data-uid"));if(l.isDataRow&&!t.isNullOrUndefined(l.index)){var a=l.cells[o],h=new Bs(i,i.serviceLocator),d=i.getCellFromIndex(s,o-n);h.refreshTD(d,a,l.data,{index:l.index})}}})},o.prototype.refreshReactHeaderTemplateByUid=function(e){if(this.isReact)for(var t=this.headerModule.rows,i=this.getNormalizedColumnIndex(e),r=0;r<t.length;r++){var n=t[r].cells[i];if(n&&n.column.uid===e){var o=new qs(this,this.serviceLocator),s=D(this.element.querySelectorAll("[e-mappinguid="+e+"]")[0],"e-templatecell");o.refresh(n,s)}}},o.prototype.setRowData=function(e,i){var r=this.contentModule.getRows(),n=this.getPrimaryKeyFieldNames()[0],o=new Fs(this.serviceLocator,null,this);this.groupSettings.columns.length>0&&this.aggregates.length>0&&(r=r.filter(function(e){return e.isDataRow}));var s=r.filter(function(i){return t.getValue(n,i.data)===e})[0];!t.isNullOrUndefined(s)&&this.element.querySelectorAll("[data-uid="+s.uid+"]").length&&(s.changes=i,re(s,this.getForeignKeyColumns(),s.changes),o.refresh(s,this.getColumns(),!0),this.aggregates.length>0&&(this.notify(Hi,{}),this.groupSettings.columns.length>0&&this.notify(qi,{})))},o.prototype.getCellFromIndex=function(e,t){return Ne(this,this.getColumnByIndex(t),e,t)},o.prototype.getMovableCellFromIndex=function(e,t){if(!("Left-Right"===this.frozenName&&t>=this.movableCount)){var i=this.getFrozenColumns()||this.getFrozenLeftColumnsCount();return this.getMovableDataRows()[e]&&this.getMovableDataRows()[e].getElementsByClassName(_o)[t-i]}},o.prototype.getFrozenRightCellFromIndex=function(e,t){var i=this.getFrozenLeftColumnsCount()+this.getMovableColumnsCount(),r=this.getFrozenRightDataRows();return r[e]&&r[e].getElementsByClassName(_o)[t-i]},o.prototype.getColumnHeaderByIndex=function(e){return this.getHeaderTable().getElementsByClassName("e-headercell")[e]},o.prototype.getMovableColumnHeaderByIndex=function(e){var t=this.getFrozenColumns()||this.getFrozenLeftColumnsCount();return this.getMovableVirtualHeader().getElementsByClassName("e-headercell")[e-t]},o.prototype.getFrozenRightColumnHeaderByIndex=function(e){var t=this.getFrozenLeftColumnsCount()+this.getMovableColumnsCount();return this.getFrozenRightHeader().getElementsByClassName("e-headercell")[e-t]},o.prototype.getFrozenLeftColumnHeaderByIndex=function(e){return this.getFrozenVirtualHeader().getElementsByClassName("e-headercell")[e]},o.prototype.getRowObjectFromUID=function(e,i,r){var n=this.contentModule.getRows(),o=this.rowObject(n,e);return this.isFrozenGrid()&&(!o||i||r)?((!(o=this.rowObject(this.contentModule.getMovableRows(),e))&&"Left-Right"===this.getFrozenMode()||r)&&(o=this.rowObject(this.contentModule.getFrozenRightRows(),e)),o):t.isNullOrUndefined(o)&&this.enableVirtualization&&this.groupSettings.columns.length>0?o=this.rowObject(this.vRows,e):o},o.prototype.rowObject=function(e,t){for(var i=0,r=e;i<r.length;i++){var n=r[i];if(n.uid===t)return n}return null},o.prototype.getRowsObject=function(){return this.contentModule.getRows()},o.prototype.getMovableRowsObject=function(){var e=[];return this.isFrozenGrid()&&(e=this.contentModule.getMovableRows()),e},o.prototype.getFrozenRightRowsObject=function(){var e=[];return"Right"!==this.getFrozenMode()&&"Left-Right"!==this.getFrozenMode()||(e=this.contentModule.getFrozenRightRows()),e},o.prototype.getColumnHeaderByField=function(e){var t=this.getColumnByField(e);return t?this.getColumnHeaderByUid(t.uid):void 0},o.prototype.getColumnHeaderByUid=function(e){var t=this.getHeaderContent().querySelector("[e-mappinguid="+e+"]");return t?t.parentElement:void 0},o.prototype.getColumnByIndex=function(e){var t;return this.getColumns().some(function(i,r){return t=i,r===e}),t},o.prototype.getColumnByField=function(e){return b(this.getColumns(),function(t){if(t.field===e)return t})[0]},o.prototype.getColumnIndexByField=function(e){for(var t=this.getColumns(),i=0;i<t.length;i++)if(t[i].field===e)return i;return-1},o.prototype.getColumnByUid=function(e){return b(this.getColumns().concat(this.getStackedColumns(this.columns)),function(t){if(t.uid===e)return t})[0]},o.prototype.getStackedColumns=function(e,t){void 0===t&&(t=[]);for(var i=0,r=e;i<r.length;i++){var n=r[i];n.columns&&(t.push(n),this.getStackedColumns(n.columns,t))}return t},o.prototype.getColumnIndexByUid=function(e){var i=b(this.getColumns(),function(t,i){if(t.uid===e)return i})[0];return t.isNullOrUndefined(i)?-1:i},o.prototype.getUidByColumnField=function(e){return b(this.getColumns(),function(t){if(t.field===e)return t.uid})[0]},o.prototype.getNormalizedColumnIndex=function(e){return this.getColumnIndexByUid(e)+this.getIndentCount()},o.prototype.getIndentCount=function(){var e=0;return this.allowGrouping&&(e+=this.groupSettings.columns.length),this.isDetail()&&e++,this.isRowDragable()&&t.isNullOrUndefined(this.rowDropSettings.targetID)&&e++,e},o.prototype.getColumnFieldNames=function(){for(var e,t=[],i=0,r=this.getColumns().length;i<r;i++)(e=this.getColumns()[i]).visible&&t.push(e.field);return t},o.prototype.getRowTemplate=function(){return this.rowTemplateFn},o.prototype.getDetailTemplate=function(){return this.detailTemplateFn},o.prototype.getEditTemplate=function(){return this.editTemplateFn},o.prototype.getEditHeaderTemplate=function(){return this.editHeaderTemplateFn},o.prototype.getEditFooterTemplate=function(){return this.editFooterTemplateFn},o.prototype.getPrimaryKeyFieldNames=function(){for(var e=[],t=0;t<this.columnModel.length;t++)this.columnModel[t].isPrimaryKey&&e.push(this.columnModel[t].field);return e},o.prototype.refresh=function(){this.isDestroyed||(this.isManualRefresh=!0,this.headerModule.refreshUI(),this.updateStackedFilter(),this.renderModule.refresh())},o.prototype.refreshHeader=function(){this.headerModule.refreshUI()},o.prototype.getSelectedRows=function(){return this.selectionModule?this.selectionModule.selectedRecords:[]},o.prototype.getSelectedRowIndexes=function(){return this.selectionModule?this.selectionModule.selectedRowIndexes:[]},o.prototype.getSelectedRowCellIndexes=function(){return this.selectionModule?this.selectionModule.selectedRowCellIndexes:[]},o.prototype.getSelectedRecords=function(){return this.selectionModule?this.selectionModule.getSelectedRecords():[]},o.prototype.getSelectedColumnsUid=function(){var e=this,t=[];return this.selectionModule&&this.selectionModule.selectedColumnsIndexes.filter(function(i){return t.push(e.getColumns()[i].uid)}),t},o.prototype.getDataModule=function(){return this.renderModule.data},o.prototype.showColumns=function(e,t){t=t||"headerText",this.showHider.show(e,t)},o.prototype.hideColumns=function(e,t){t=t||"headerText",this.showHider.hide(e,t)},o.prototype.getFrozenColumns=function(){return this.frozenColumns+this.getFrozenCount(this.columns,0,0)},o.prototype.getFrozenRightColumnsCount=function(){return this.frozenRightCount},o.prototype.getFrozenLeftColumnsCount=function(){return this.frozenLeftCount},o.prototype.getMovableColumnsCount=function(){return this.movableCount},o.prototype.setFrozenCount=function(){this.frozenLeftCount=this.frozenRightCount=this.movableCount=0,this.visibleFrozenLeft=this.visibleFrozenRight=this.visibleMovable=0,this.frozenLeftColumns=[],this.frozenRightColumns=[],this.movableColumns=[],this.splitFrozenCount(this.columns),this.frozenColumns&&(this.frozenLeftCount||this.frozenRightCount)&&this.setProperties({frozenColumns:0},!0),this.setTablesCount(),this.frozenLeftCount&&!this.frozenRightCount?this.frozenName="Left":this.frozenRightCount&&!this.frozenLeftCount?this.frozenName="Right":this.frozenLeftCount&&this.frozenRightCount&&(this.frozenName="Left-Right")},o.prototype.getVisibleFrozenLeftCount=function(){return this.visibleFrozenLeft},o.prototype.getVisibleFrozenRightCount=function(){return this.visibleFrozenRight},o.prototype.getVisibleMovableCount=function(){return this.visibleMovable},o.prototype.getFrozenRightColumns=function(){return this.frozenRightColumns},o.prototype.getFrozenLeftColumns=function(){return this.frozenLeftColumns},o.prototype.getMovableColumns=function(){return this.movableColumns},o.prototype.splitFrozenCount=function(e){for(var t=0;t<e.length;t++)e[t].columns?this.splitFrozenCount(e[t].columns):"Right"===e[t].freeze?(!1!==e[t].visible&&this.visibleFrozenRight++,this.frozenRightColumns.push(e[t]),this.frozenRightCount++):"Left"===e[t].freeze?(!1!==e[t].visible&&this.visibleFrozenLeft++,this.frozenLeftColumns.push(e[t]),this.frozenLeftCount++):(!1!==e[t].visible&&this.visibleMovable++,this.movableColumns.push(e[t]),this.movableCount++)},o.prototype.getVisibleFrozenColumns=function(){return this.getVisibleFrozenColumnsCount()+this.getVisibleFrozenCount(this.columns,0)},o.prototype.getFilterUIInfo=function(){return this.filterModule?this.filterModule.getFilterUIInfo():{}},o.prototype.getVisibleFrozenColumnsCount=function(){for(var e=0,t=this.columnModel,i=0;i<this.frozenColumns;i++)t[i].visible&&e++;if(this.frozenLeftCount||this.frozenRightCount)for(i=0;i<t.length;i++)!t[i].visible||"Left"!==t[i].freeze&&"Right"!==t[i].freeze||e++;return e},o.prototype.getVisibleFrozenCount=function(e,t){if(!this.frozenLeftCount&&!this.frozenRightCount)for(var i=0,r=e.length;i<r;i++)e[i].columns?t=this.getVisibleFrozenCount(e[i].columns,t):e[i].isFrozen&&e[i].visible&&t++;return t},o.prototype.getFrozenCount=function(e,t,i){for(var r=0,n=e.length;r<n;r++)e[r].columns?t=this.getFrozenCount(e[r].columns,t,i):(e[r].isFrozen&&i>this.frozenColumns-1&&t++,i++);return t},o.prototype.goToPage=function(e){this.pagerModule&&this.pagerModule.goToPage(e)},o.prototype.updateExternalMessage=function(e){this.pagerModule&&this.pagerModule.updateExternalMessage(e)},o.prototype.sortColumn=function(e,t,i){this.sortModule&&this.sortModule.sortColumn(e,t,i)},o.prototype.clearSorting=function(){this.sortModule&&this.sortModule.clearSorting()},o.prototype.removeSortColumn=function(e){this.sortModule&&this.sortModule.removeSortColumn(e)},o.prototype.clearGridActions=function(){this.setProperties({sortSettings:{columns:[]}},!0),this.setProperties({filterSettings:{columns:[]}},!0),this.setProperties({searchSettings:{key:""}},!0),this.allowGrouping?this.setProperties({groupSettings:{columns:[]}},!1):this.freezeRefresh()},o.prototype.filterByColumn=function(e,t,i,r,n,o,s,l){this.filterModule&&this.filterModule.filterByColumn(e,t,i,r,n,o,s,l)},o.prototype.clearFiltering=function(e){this.filterModule&&this.filterModule.clearFiltering(e)},o.prototype.removeFilteredColsByField=function(e,t){this.filterModule&&this.filterModule.removeFilteredColsByField(e,t)},o.prototype.selectRow=function(e,t){this.selectionModule&&this.selectionModule.selectRow(e,t)},o.prototype.selectRows=function(e){this.selectionModule&&this.selectionModule.selectRows(e)},o.prototype.clearSelection=function(){this.selectionModule&&this.selectionModule.clearSelection()},o.prototype.selectCell=function(e,t){this.selectionModule&&this.selectionModule.selectCell(e,t)},o.prototype.selectCellsByRange=function(e,t){this.selectionModule.selectCellsByRange(e,t)},o.prototype.search=function(e){this.searchModule&&this.searchModule.search(e)},o.prototype.print=function(){this.printModule&&this.printModule.print()},o.prototype.deleteRecord=function(e,t){this.editModule&&this.editModule.deleteRecord(e,t)},o.prototype.startEdit=function(){this.editModule&&this.editModule.startEdit()},o.prototype.endEdit=function(){this.editModule&&this.editModule.endEdit()},o.prototype.closeEdit=function(){this.editModule&&this.editModule.closeEdit()},o.prototype.addRecord=function(e,t){this.editModule&&this.editModule.addRecord(e,t)},o.prototype.deleteRow=function(e){this.editModule&&this.editModule.deleteRow(e)},o.prototype.editCell=function(e,t){this.editModule&&this.editModule.editCell(e,t)},o.prototype.saveCell=function(){this.editModule&&this.editModule.saveCell()},o.prototype.updateCell=function(e,t,i){this.editModule&&this.editModule.updateCell(e,t,i)},o.prototype.updateRow=function(e,t){this.editModule&&this.editModule.updateRow(e,t)},o.prototype.getBatchChanges=function(){return this.editModule?this.editModule.getBatchChanges():{}},o.prototype.enableToolbarItems=function(e,t){this.toolbarModule&&this.toolbarModule.enableItems(e,t)},o.prototype.copy=function(e){this.clipboardModule&&this.clipboardModule.copy(e)},o.prototype.recalcIndentWidth=function(){var e=this;if(this.getHeaderTable().querySelector(".e-emptycell")&&(this.groupSettings.columns.length||this.isDetail()||this.isRowDragable())&&!this.getHeaderTable().querySelector(".e-emptycell").getAttribute("indentRefreshed")&&this.getContentTable()){var t=this.getHeaderTable().querySelector(".e-emptycell").parentElement.offsetWidth,i=[].slice.call(this.getHeaderTable().querySelector(fs).childNodes),r=[].slice.call(this.getContentTable().querySelector(fs).childNodes),n=t/30,o="Right"===this.getFrozenMode()?this.frozenRightCount:0,s=this.element.offsetWidth,l=function(t,n){if(Ee(e)){var o=(n/s*100).toFixed(1)+"%";i[t].style.width=o,r[t].style.width=o}else i[t].style.width=n+"px",r[t].style.width=n+"px";e.notify(Yi,{index:t,width:n})};for(n>=1&&(t=30/n),t<1&&(t=1),(this.enableColumnVirtualization||this.isAutoGen)&&(t=30);o<this.groupSettings.columns.length;)l(o,t),o++;this.isDetail()&&(l(o,t),o++),this.isRowDragable()&&l(o,t),this.isAutoGen=!1,this.getHeaderTable().querySelector(".e-emptycell").setAttribute("indentRefreshed","true")}},o.prototype.resetIndentWidth=function(){if(Ee(this)&&(this.getHeaderTable().querySelector(".e-emptycell").removeAttribute("indentRefreshed"),this.widthService.setWidthToColumns(),this.recalcIndentWidth()),("auto"===this.width||"string"==typeof this.width&&-1!==this.width.indexOf("%"))&&this.getColumns().filter(function(e){return(!e.width||"auto"===e.width)&&e.minWidth}).length>0){var e=this.widthService.getTableWidth(this.getColumns());this.widthService.setMinwidthBycalculation(e)}this.isFrozenGrid()&&this.widthService&&this.widthService.refreshFrozenScrollbar(),this.allowTextWrap&&"Content"!==this.textWrapSettings.wrapMode&&this.notify(Yn,{})},o.prototype.isRowDragable=function(){return this.allowRowDragAndDrop&&!this.rowDropSettings.targetID},o.prototype.reorderColumns=function(e,t){this.reorderModule&&this.reorderModule.reorderColumns(e,t)},o.prototype.reorderColumnByIndex=function(e,t){this.reorderModule&&this.reorderModule.reorderColumnByIndex(e,t)},o.prototype.reorderColumnByTargetIndex=function(e,t){this.reorderModule&&this.reorderModule.reorderColumnByTargetIndex(e,t)},o.prototype.reorderRows=function(e,t){this.rowDragAndDropModule&&this.rowDragAndDropModule.reorderRows(e,t)},o.prototype.refreshDataSource=function(e){this.notify("refreshdataSource",e)},o.prototype.disableRowDD=function(e){var i=this.getHeaderTable(),r=this.getContentTable(),n=i.querySelectorAll("th.e-rowdragheader, th.e-mastercell"),o=this.getRows(),s=e?"none":"";t.setStyleAttribute(i.querySelector(fs).childNodes[0],{display:s}),t.setStyleAttribute(r.querySelector(fs).childNodes[0],{display:s});for(var l=0;l<this.getRows().length;l++){var a=o[l].firstElementChild;e?t.addClass([a],"e-hide"):t.removeClass([a],["e-hide"])}for(var h=0;h<i.querySelectorAll("th.e-rowdragheader, th.e-mastercell").length;h++){a=n[h];e?t.addClass([a],"e-hide"):t.removeClass([a],["e-hide"])}},o.prototype.autoFitColumns=function(e){this.resizeModule&&this.resizeModule.autoFitColumns(e)},o.prototype.createColumnchooser=function(e,t,i){this.columnChooserModule&&this.columnChooserModule.renderColumnChooser(e,t,i)},o.prototype.initializeServices=function(){this.serviceLocator.register("widthService",this.widthService=new dl(this)),this.serviceLocator.register("cellRendererFactory",new sl),this.serviceLocator.register("rendererFactory",new hl),this.serviceLocator.register("localization",this.localeObj=new t.L10n(this.getModuleName(),this.defaultLocale,this.locale)),this.serviceLocator.register("valueFormatter",this.valueFormatterService=new Ct(this.locale)),this.serviceLocator.register("showHideService",this.showHider=new Dl(this)),this.serviceLocator.register("ariaService",this.ariaService=new Ns),this.serviceLocator.register("focus",this.focusModule=new cl(this))},o.prototype.processModel=function(){var e,i,r=this.groupSettings.columns,n=this.sortSettings.columns;if(this.allowGrouping)for(var o=function(t,o){i=0;for(var l=n.length;i<l;i++)if(n[i].field===r[t]){e=!0;break}if(e?s.allowSorting?s.sortedColumns.push(n[i].field):n[i].direction="Ascending":n.push({field:r[t],direction:"Ascending",isFromGroup:!0}),!s.groupSettings.showGroupedColumn){var a=s.enableColumnVirtualization?s.columns.filter(function(e){return e.field===r[t]})[0]:s.getColumnByField(r[t]);a?a.visible=!1:s.log("initial_action",{moduleName:"group",columnName:r[t]})}},s=this,l=0,a=r.length;l<a;l++)o(l);if(!r.length)for(l=0;l<n.length;l++)this.sortedColumns.push(n[l].field);if(this.rowTemplateFn=R(this.rowTemplate),this.detailTemplateFn=R(this.detailTemplate),this.editTemplateFn=R(this.editSettings.template),this.editHeaderTemplateFn=R(this.editSettings.headerTemplate),this.editFooterTemplateFn=R(this.editSettings.footerTemplate),!t.isNullOrUndefined(this.parentDetails)){var h=t.isNullOrUndefined(this.parentDetails.parentKeyFieldValue)?"undefined":this.parentDetails.parentKeyFieldValue;this.query.where(this.queryString,"equal",h,!0)}this.initForeignColumn()},o.prototype.initForeignColumn=function(){this.isForeignKeyEnabled(this.getColumns())&&this.notify(Nr,this.getForeignKeyColumns())},o.prototype.enableVerticalRendering=function(){"Vertical"===this.rowRenderingMode?this.element.classList.add("e-row-responsive"):this.element.classList.remove("e-row-responsive")},o.prototype.gridRender=function(){this.updateRTL(),"Vertical"===this.rowRenderingMode&&this.element.classList.add("e-row-responsive"),this.enableHover&&this.element.classList.add("e-gridhover"),t.Browser.isDevice&&this.element.classList.add("e-device"),this.rowHeight&&this.element.classList.add("e-grid-min-height"),t.classList(this.element,["e-responsive","e-default"],[]);var i=this.serviceLocator.getService("rendererFactory");this.headerModule=i.getRenderer(e.RenderType.Header),this.contentModule=i.getRenderer(e.RenderType.Content),this.printModule=new Zl(this,this.scrollModule),this.clipboardModule=new Nl(this),this.renderModule.render(),this.eventInitializer(),this.createGridPopUpElement(),this.widthService.setWidthToColumns(),this.updateGridLines(),this.applyTextWrap(),this.createTooltip(),this.enableBoxSelection()},o.prototype.dataReady=function(){this.scrollModule.setWidth(),this.scrollModule.setHeight(),"auto"!==this.height&&this.scrollModule.setPadding()},o.prototype.updateRTL=function(){this.enableRtl?this.element.classList.add("e-rtl"):this.element.classList.remove("e-rtl")},o.prototype.createGridPopUpElement=function(){var e=this.createElement("div",{className:"e-gridpopup",styles:"display:none;"}),i=this.createElement("div",{className:es,attrs:{tabIndex:"-1"}});t.append([i,this.createElement("div",{className:"e-uptail e-tail"})],e),i.appendChild(this.createElement("span")),t.append([i,this.createElement("div",{className:"e-downtail e-tail"})],e),this.element.appendChild(e)},o.prototype.updateGridLines=function(){switch(t.classList(this.element,[],["e-verticallines","e-horizontallines","e-hidelines","e-bothlines"]),this.gridLines){case"Horizontal":this.element.classList.add("e-horizontallines");break;case"Vertical":this.element.classList.add("e-verticallines");break;case"None":this.element.classList.add("e-hidelines");break;case"Both":this.element.classList.add("e-bothlines")}this.updateResizeLines()},o.prototype.updateResizeLines=function(){this.allowResizing&&"Vertical"!==this.gridLines&&"Both"!==this.gridLines?this.element.classList.add("e-resize-lines"):this.element.classList.remove("e-resize-lines")},o.prototype.applyTextWrap=function(){if(this.allowTextWrap){var e=[].slice.call(this.element.getElementsByClassName("e-columnheader"));switch(this.textWrapSettings.wrapMode){case"Header":K(this.element,!1),K(this.getContent(),!1),K(e,!0);break;case"Content":K(this.getContent(),!0),K(this.element,!1),K(e,!1);break;default:K(this.element,!0),K(this.getContent(),!1),K(e,!1)}"Content"!==this.textWrapSettings.wrapMode&&this.notify(Yn,{})}},o.prototype.removeTextWrap=function(){K(this.element,!1);K([].slice.call(this.element.getElementsByClassName("e-columnheader")),!1),K(this.getContent(),!1),"Content"!==this.textWrapSettings.wrapMode&&this.notify(Yn,{})},o.prototype.createTooltip=function(){this.toolTipObj=new r.Tooltip({opensOn:"custom",content:""},this.element)},o.prototype.freezeRefresh=function(){this.isFreezeRefresh=!0,this.enableVirtualization&&(this.pageSettings.currentPage=1),this.componentRefresh()},o.prototype.getTooltipStatus=function(e){var t=this.getHeaderTable(),i=this.createTable(t,"e-gridheader","header"),r=this.createTable(t,"e-gridheader","content"),n=e.classList.contains("e-headercell")?i:r,o=e.classList.contains("e-headercell")?"th":"tr";n.querySelector(o).className=e.className,n.querySelector(o).innerHTML=e.innerHTML;var s=n.querySelector(o).getBoundingClientRect().width;return document.body.removeChild(i),document.body.removeChild(r),s>e.getBoundingClientRect().width},o.prototype.mouseMoveHandler=function(e){if(this.isEllipsisTooltip()){var i=D(e.target,"e-ellipsistooltip");this.prevElement===i&&"mouseout"!==e.type||this.toolTipObj.close();var r=e.target.tagName;if(i&&"mouseout"!==e.type&&(!t.Browser.isDevice||-1===["A","BUTTON","INPUT"].indexOf(r))){if(i.getAttribute("aria-describedby"))return;if(this.getTooltipStatus(i)){i.getElementsByClassName("e-headertext").length?this.toolTipObj.content=i.getElementsByClassName("e-headertext")[0].innerText:this.toolTipObj.content=i.innerText,this.prevElement=i;this.getColumns()[parseInt(i.getAttribute(cs),10)].disableHtmlEncode&&(this.toolTipObj.enableHtmlParse=!1),this.toolTipObj.open(i)}}}this.hoverFrozenRows(e)},o.prototype.hoverFrozenRows=function(e){if(this.isFrozenGrid()){var t=D(e.target,is);if([].slice.call(this.element.getElementsByClassName("e-frozenhover")).length&&"mouseout"===e.type)for(var i=[].slice.call(this.element.getElementsByClassName("e-frozenhover")),r=0;r<i.length;r++)i[r].classList.remove("e-frozenhover");else if(t){(i=[].slice.call(this.element.querySelectorAll('tr[aria-rowindex="'+t.getAttribute(us)+'"]'))).splice(i.indexOf(t),1);for(r=0;r<i.length;r++)"true"!==t.getAttribute("aria-selected")&&i[r]?i[r].classList.add("e-frozenhover"):i[r]&&i[r].classList.remove("e-frozenhover")}}},o.prototype.isEllipsisTooltip=function(){var e=this.getColumns();if("EllipsisWithTooltip"===this.clipMode)return!0;for(var t=0;t<e.length;t++)if("EllipsisWithTooltip"===e[t].clipMode)return!0;return!1},o.prototype.scrollHandler=function(){this.isEllipsisTooltip()&&this.toolTipObj.close()},o.prototype.createTable=function(e,t,i){var r=this.createElement("div");r.className=this.element.className,r.style.cssText="display: inline-block;visibility:hidden;position:absolute";var n=this.createElement("div");n.className=t;var o=this.createElement("table");o.className=e.className,o.style.cssText="table-layout: auto;width: auto";var s="header"===i?"th":"td",l=this.createElement("tr"),a=this.createElement(s);return l.appendChild(a),o.appendChild(l),n.appendChild(o),r.appendChild(n),document.body.appendChild(r),r},o.prototype.onKeyPressed=function(e){"tab"!==e.action&&"shiftTab"!==e.action||this.toolTipObj.close()},o.prototype.wireEvents=function(){t.EventHandler.add(this.element,"click",this.mouseClickHandler,this),t.EventHandler.add(this.element,"touchend",this.mouseClickHandler,this),t.EventHandler.add(this.element,"focusout",this.focusOutHandler,this),t.EventHandler.add(this.element,"dblclick",this.dblClickHandler,this),t.EventHandler.add(this.element,"keydown",this.keyPressHandler,this),t.EventHandler.add(window,"resize",this.resetIndentWidth,this),this.allowKeyboard&&(this.element.tabIndex=-1===this.element.tabIndex?0:this.element.tabIndex),this.keyboardModule=new t.KeyboardEvents(this.element,{keyAction:this.keyActionHandler.bind(this),keyConfigs:this.keyConfigs,eventName:"keydown"}),t.EventHandler.add(this.getContent().firstElementChild,"scroll",this.scrollHandler,this),t.EventHandler.add(this.element,"mousemove",this.mouseMoveHandler,this),t.EventHandler.add(this.element,"mouseout",this.mouseMoveHandler,this),t.EventHandler.add(this.getContent(),"touchstart",this.tapEvent,this),t.EventHandler.add(document.body,"keydown",this.keyDownHandler,this)},o.prototype.unwireEvents=function(){t.EventHandler.remove(this.element,"click",this.mouseClickHandler),t.EventHandler.remove(this.element,"touchend",this.mouseClickHandler),t.EventHandler.remove(this.element,"focusout",this.focusOutHandler),t.EventHandler.remove(this.element,"dblclick",this.dblClickHandler),t.EventHandler.remove(this.getContent().firstElementChild,"scroll",this.scrollHandler),t.EventHandler.remove(this.element,"mousemove",this.mouseMoveHandler),t.EventHandler.remove(this.element,"mouseout",this.mouseMoveHandler),t.EventHandler.remove(this.element,"keydown",this.keyPressHandler),t.EventHandler.remove(this.getContent(),"touchstart",this.tapEvent),t.EventHandler.remove(document.body,"keydown",this.keyDownHandler),t.EventHandler.remove(window,"resize",this.resetIndentWidth)},o.prototype.addListener=function(){this.isDestroyed||(this.on(Ri,this.dataReady,this),this.on(xi,this.recalcIndentWidth,this),this.on(Di,this.recalcIndentWidth,this),this.dataBoundFunction=this.refreshMediaCol.bind(this),this.addEventListener(Ot,this.dataBoundFunction),this.on(_i,this.onKeyPressed,this))},o.prototype.removeListener=function(){this.isDestroyed||(this.off(Ri,this.dataReady),this.off(xi,this.recalcIndentWidth),this.off(Di,this.recalcIndentWidth),this.removeEventListener(Ot,this.dataBoundFunction),this.off(_i,this.onKeyPressed))},o.prototype.getCurrentViewRecords=function(){return ae(this)?t.isNullOrUndefined(this.currentViewData.records)?this.currentViewData:this.currentViewData.records:this.groupSettings.enableLazyLoading?this.currentViewData:this.allowGrouping&&this.groupSettings.columns.length&&this.currentViewData.length&&this.currentViewData.records?this.currentViewData.records:this.currentViewData},o.prototype.mouseClickHandler=function(e){if(!(this.isChildGrid(e)||D(e.target,"e-gridpopup")&&e.touches||this.element.getElementsByClassName("e-cloneproperties").length||this.checkEdit(e))&&((this.allowRowDragAndDrop||!D(e.target,Ko)&&"TD"!==e.target.tagName)&&(this.allowGrouping||this.allowReordering||!D(e.target,"e-gridheader"))||!e.touches)){D(e.target,"e-gridheader")&&this.allowRowDragAndDrop&&!D(e.target,"e-filterbarcell")&&e.preventDefault();var i=this.getRowInfo(e.target);i.cancel=!1;var r=!1,n=t.closest(e.target,"tr");if(n&&n.getAttribute("data-uid")){var o=this.getRowObjectFromUID(n.getAttribute("data-uid"));r=!!o&&o.isDataRow}r&&this.trigger("recordClick",i),this.notify(Wi,e)}},o.prototype.checkEdit=function(e){var t=D(e.target,is),i="Batch"!==this.editSettings.mode&&this.isEdit&&t&&(t.classList.contains(ns)||t.classList.contains(os));return!D(e.target,"e-unboundcelldiv")&&(i||D(e.target,_o)&&D(e.target,_o).classList.contains("e-editedbatchcell"))},o.prototype.dblClickHandler=function(e){var i=D(e.target,"e-grid");if(!t.isNullOrUndefined(i)&&i.id===this.element.id&&!t.closest(e.target,".e-unboundcelldiv")){var r=!1,n=t.closest(e.target,"tr");if(n&&n.getAttribute("data-uid")){var o=this.getRowObjectFromUID(n.getAttribute("data-uid"));r=!!o&&o.isDataRow}var s=this.getRowInfo(e.target);s.target=e.target,r&&this.trigger(li,s),this.notify(or,e)}},o.prototype.focusOutHandler=function(e){if(!this.isChildGrid(e)){D(e.target,"e-grid")||(this.element.querySelector(".e-gridpopup").style.display="None");var i=this.element.querySelector(".e-cancel:not(.e-hide)");i&&i.classList.add("e-hide");var r=e.relatedTarget,n=r?r.getAttribute("aria-owns"):null;r&&(D(r,"e-grid")||(!t.isNullOrUndefined(n)&&n)===e.target.getAttribute("aria-owns"))||this.keyPress||!this.isEdit||t.Browser.isDevice||("Batch"!==this.editSettings.mode||(D(r,"e-ddl")||D(r,"e-ddt"))&&D(r,"e-input-group")||(this.editModule.saveCell(),this.notify(Yr,{})),"Normal"===this.editSettings.mode&&this.editModule.editFormValidate()),this.keyPress=!1}},o.prototype.isChildGrid=function(e){var i=D(e.target,"e-grid");return!!(i&&i.id!==this.element.id||D(e.target,"e-unboundcelldiv")&&t.isNullOrUndefined(i))},o.prototype.mergePersistGridData=function(e){var i=this.getLocalData();if(!t.isNullOrUndefined(i)&&""!==i||!t.isNullOrUndefined(e)){var r=t.isNullOrUndefined(e)?JSON.parse(i):e;this.enableVirtualization&&(r.pageSettings.currentPage=1);var n=Object.keys(r);this.isProtectedOnChange=!0;for(var o=0,s=n;o<s.length;o++){var l=s[o];"object"!=typeof this[l]||t.isNullOrUndefined(this[l])?this[l]=r[l]:Array.isArray(this[l])&&"columns"===l?(E(this[l]),this.mergeColumns(r[l],this[l]),this[l]=r[l]):t.extend(this[l],r[l])}this.isProtectedOnChange=!1}},o.prototype.mergeColumns=function(e,i){for(var r=e,n=function(e){var n=i.filter(function(t){return t.index===r[e].index})[0];t.isNullOrUndefined(n)||(n.columns&&n.columns.length?(o.mergeColumns(r[e].columns,n.columns),r[e]=t.extend(n,r[e],{},!0)):r[e]=t.extend(n,r[e],{},!0))},o=this,s=0;s<r.length;s++)n(s)},o.prototype.isDetail=function(){return!t.isNullOrUndefined(this.detailTemplate)||!t.isNullOrUndefined(this.childGrid)},o.prototype.isCommandColumn=function(e){var t=this;return e.some(function(e){return e.columns?t.isCommandColumn(e.columns):!(!e.commands&&!e.commandsTemplate)})},o.prototype.isForeignKeyEnabled=function(e){var t=this;return e.some(function(e){return e.columns?t.isForeignKeyEnabled(e.columns):!(!e.dataSource||!e.foreignKeyValue)})},o.prototype.keyPressHandler=function(e){var i=t.extend(e,{cancel:!1});this.trigger("keyPressed",i),!0===i.cancel&&e.stopImmediatePropagation()},o.prototype.keyDownHandler=function(e){e.altKey&&(74===e.keyCode&&(this.keyA?(this.notify(Qn,{target:e.target,collapse:!1}),this.keyA=!1):(this.focusModule.focusHeader(),this.focusModule.addOutline())),87===e.keyCode&&(this.focusModule.focusContent(),this.focusModule.addOutline()),65===e.keyCode&&(this.keyA=!0),72===e.keyCode&&this.keyA&&(this.notify(Qn,{target:e.target,collapse:!0}),this.keyA=!1)),13===e.keyCode&&this.notify(bo,e)},o.prototype.keyActionHandler=function(e){this.isChildGrid(e)||this.isEdit&&"escape"!==e.action&&"enter"!==e.action&&"shiftEnter"!==e.action&&"tab"!==e.action&&"shiftTab"!==e.action||(this.keyPress=!0,this.allowKeyboard&&("ctrlPlusP"===e.action&&(e.preventDefault(),this.print()),this.notify(_i,e)))},o.prototype.setInjectedModules=function(e){this.injectedModules=e},o.prototype.updateColumnObject=function(){I(this.columns,this.enableColumnVirtualization,this),E(this.columns),this.initForeignColumn(),this.notify(ar,{})},o.prototype.getForeignKeyColumns=function(){return this.getColumns().filter(function(e){return e.isForeignColumn()})},o.prototype.getRowHeight=function(){return this.rowHeight?this.rowHeight:U(this.element)},o.prototype.refreshColumns=function(){this.setFrozenCount();var e=this.getContent().querySelector(".e-frozen-left-content"),i=this.getContent().querySelector(".e-frozen-right-content"),r=!this.frozenRightCount&&!this.frozenLeftCount;if(!(0!==this.getFrozenColumns())&&(!e&&this.frozenLeftCount||!i&&this.frozenRightCount||e&&!this.frozenLeftCount||i&&!this.frozenRightCount))this.tableIndex=0,this.tablesCount=1,this.enableColumnVirtualization&&(this.columnModel=[],this.updateColumnModel(this.columns)),this.freezeRefresh();else if(r&&(1===this.getFrozenColumns()&&!e||0===this.getFrozenColumns()&&e))this.tableIndex=0,this.tablesCount=1,this.enableColumnVirtualization&&(this.columnModel=[],this.updateColumnModel(this.columns)),this.freezeRefresh();else if(this.isPreventScrollEvent=!0,this.updateColumnObject(),this.checkLockColumns(this.getColumns()),this.refresh(),this.isFrozenGrid()){var n=this.contentModule.getMovableContent().querySelector("."+ts);t.remove(n.querySelector(fs));var o=this.getHeaderContent().querySelector("."+Jo).querySelector(fs).cloneNode(!0);if(n.insertBefore(o,n.querySelector(gs)),"Left-Right"===this.getFrozenMode()){var s=this.contentModule.getFrozenRightContent().querySelector("."+ts);t.remove(s.querySelector(fs));var l=this.getHeaderContent().querySelector(".e-frozen-right-header").querySelector(fs).cloneNode(!0);s.insertBefore(l,s.querySelector(gs))}}if(this.isFrozenGrid()){var a=this.getContent().querySelector(".e-movablescrollbar").scrollLeft;this.headerModule.getMovableHeader().scrollLeft=a,this.contentModule.getMovableContent().scrollLeft=a}},o.prototype.excelExport=function(e,t,i,r){return this.excelExportModule?this.excelExportModule.Map(this,e,t,i,!1,r):null},o.prototype.csvExport=function(e,t,i,r){return this.excelExportModule?this.excelExportModule.Map(this,e,t,i,!0,r):null},o.prototype.pdfExport=function(e,t,i,r){return this.pdfExportModule?this.pdfExportModule.Map(this,e,t,i,r):null},o.prototype.groupColumn=function(e){this.groupModule&&this.groupModule.groupColumn(e)},o.prototype.groupExpandAll=function(){this.groupModule&&this.groupModule.expandAll()},o.prototype.groupCollapseAll=function(){this.groupModule&&this.groupModule.collapseAll()},o.prototype.clearGrouping=function(){this.groupModule&&this.groupModule.clearGrouping()},o.prototype.ungroupColumn=function(e){this.groupModule&&this.groupModule.ungroupColumn(e)},o.prototype.openColumnChooser=function(e,t){this.columnChooserModule&&this.columnChooserModule.openColumnChooser(e,t)},o.prototype.scrollRefresh=function(){var e=this,t=function(){e.scrollModule.refresh(),e.off(xi,t)};this.on(xi,t,this)},o.prototype.detailCollapseAll=function(){this.detailRowModule&&this.detailRowModule.collapseAll()},o.prototype.detailExpandAll=function(){this.detailRowModule&&this.detailRowModule.expandAll()},o.prototype.clearCellSelection=function(){this.selectionModule&&this.selectionModule.clearCellSelection()},o.prototype.clearRowSelection=function(){this.selectionModule&&this.selectionModule.clearRowSelection()},o.prototype.selectCells=function(e){this.selectionModule&&this.selectionModule.selectCells(e)},o.prototype.selectRowsByRange=function(e,t){this.selectionModule&&this.selectionModule.selectRowsByRange(e,t)},o.prototype.isContextMenuOpen=function(){return this.contextMenuModule&&this.contextMenuModule.isOpen},o.prototype.ensureModuleInjected=function(e){return this.getInjectedModules().indexOf(e)>=0},o.prototype.destroyTemplate=function(e,t){this.clearTemplate(e,t)},o.prototype.log=function(e,t){this.loggerModule&&this.loggerModule.log(e,t)},o.prototype.applyBiggerTheme=function(e){this.element.classList.contains("e-bigger")&&e.classList.add("e-bigger")},o.prototype.getPreviousRowData=function(){return this.getRowsObject()[this.getRows().length-1].data},o.prototype.hideScroll=function(){var e=this.getContent().querySelector("."+es),t=this.getContent().querySelector(".e-scrollbar");if(e.scrollHeight<=e.clientHeight&&(this.scrollModule.removePadding(),e.style.overflowY="auto"),this.isFrozenGrid()&&t){var i=this.getContent().querySelector(".e-movablescrollbar"),r=this.getContent().querySelector(".e-movablechild");t.style.display="flex",i.offsetWidth>=r.offsetWidth&&(t.style.display="none",this.notify(Wr,0))}},o.prototype.getRowIndexByPrimaryKey=function(e){var t=this.getPrimaryKeyFieldNames()[0];e="object"==typeof e?e[t]:e;for(var i=this.getRowsObject(),r=0;r<i.length;r++)if(!i[r].isDetailRow&&!i[r].isCaptionRow){var n=i[r].data[t];if(t.split(".").length>1&&(n=Ve(t,i[r].data)),n===e)return i[r].index}return-1},o.prototype.grabColumnByFieldFromAllCols=function(e){var t;this.columnModel=[],this.updateColumnModel(this.columns);for(var i=this.columnModel,r=0;r<i.length;r++)e===i[r].field&&(t=i[r]);return t},o.prototype.grabColumnByUidFromAllCols=function(e){var t;this.columnModel=[],this.updateColumnModel(this.columns);for(var i=this.columnModel,r=0;r<i.length;r++)e===i[r].uid&&(t=i[r]);return t},o.prototype.getFilteredRecords=function(){if(this.allowFiltering&&this.filterSettings.columns.length){var e=this.renderModule.data.generateQuery(!0);return this.dataSource&&this.renderModule.data.isRemote()&&this.dataSource instanceof i.DataManager?this.renderModule.data.getData(this.dataSource,e):this.dataSource instanceof i.DataManager?this.dataSource.executeLocal(e):new i.DataManager(this.dataSource,e).executeLocal(e)}return[]},o.prototype.getUserAgent=function(){var e=t.Browser.userAgent.toLowerCase();return/iphone|ipod|ipad/.test(e)},o.prototype.tapEvent=function(t){this.getUserAgent()&&(e.Global.timer?(clearTimeout(e.Global.timer),e.Global.timer=null,this.dblClickHandler(t),this.notify(vr,t)):e.Global.timer=setTimeout(function(){e.Global.timer=null},300))},o.prototype.getRowUid=function(e){return""+e+this.rowUid++},o.prototype.getMovableVirtualContent=function(){return this.getContent().querySelector("."+Yo)},o.prototype.getFrozenVirtualContent=function(){return this.getContent().querySelector("."+Zo)},o.prototype.getMovableVirtualHeader=function(){return this.getHeaderContent().querySelector("."+Jo)},o.prototype.getFrozenVirtualHeader=function(){return this.getHeaderContent().querySelector("."+$o)},o.prototype.getRowElementByUID=function(e){var t,i=[];if(this.isFrozenGrid()){var r=[].slice.call(this.getFrozenVirtualContent().querySelector(gs).children),n=[].slice.call(this.getMovableVirtualContent().querySelector(gs).children),o=[];if(3===this.tablesCount&&(o=[].slice.call(this.getContent().querySelector(".e-frozen-right-content").querySelector(gs).children)),this.frozenRows){if(i=[].slice.call(this.getFrozenVirtualHeader().querySelector(gs).children),i=i.concat([].slice.call(this.getMovableVirtualHeader().querySelector(gs).children)),3===this.tablesCount){var s=this.getHeaderContent().querySelector(".e-frozen-right-header");i=i.concat([].slice.call(s.querySelector(gs).children)).concat(o)}i=i.concat(r).concat(n)}else i=r.concat(n).concat(o)}else{var l=[].slice.call(this.getContent().querySelector(gs).children);i=this.frozenRows?(i=[].slice.call(this.getHeaderContent().querySelector(gs).children)).concat(l):l}for(var a=0,h=i;a<h.length;a++){var d=h[a];if(d.getAttribute("data-uid")===e){t=d;break}}return t},o.prototype.getHiddenColumns=function(){for(var e=[],t=0,i=this.columnModel;t<i.length;t++){var r=i[t];!1===r.visible&&e.push(r)}return e},o.prototype.calculatePageSizeByParentHeight=function(e){if(this.allowPaging&&(this.allowTextWrap&&"Header"===this.textWrapSettings.wrapMode||!this.allowTextWrap)){var t=0;-1!==e.indexOf("%")&&(e=parseInt(e,10)/100*this.element.clientHeight);if(e>this.getNoncontentHeight()+this.getRowHeight()){t=(e-this.getNoncontentHeight())/this.getRowHeight()}if(t>0)return Math.floor(t)}return 0},o.prototype.getNoncontentHeight=function(){var e=0;if(t.isNullOrUndefined(this.getHeaderContent().clientHeight)||(e+=this.getHeaderContent().clientHeight),this.toolbar&&!t.isNullOrUndefined(this.element.querySelector(".e-toolbar").clientHeight)&&(e+=this.element.querySelector(".e-toolbar").clientHeight),this.allowPaging&&!t.isNullOrUndefined(this.element.querySelector(".e-gridpager").clientHeight)&&(e+=this.element.querySelector(".e-gridpager").clientHeight),this.showColumnChooser&&!t.isNullOrUndefined(this.element.querySelector(".e-columnheader").clientHeight)&&(e+=this.element.querySelector(".e-columnheader").clientHeight),this.allowGrouping&&this.groupSettings.showDropArea&&!t.isNullOrUndefined(this.element.querySelector(".e-groupdroparea").clientHeight)&&(e+=this.element.querySelector(".e-groupdroparea").clientHeight),this.aggregates.length>0&&!t.isNullOrUndefined(this.element.querySelector(".e-summaryrow").clientHeight))for(var i=0;i<this.element.getElementsByClassName("e-summaryrow").length;i++)e+=this.element.getElementsByClassName("e-summaryrow")[i].clientHeight;return e},o.prototype.getSummaryValues=function(e,t){return i.DataUtil.aggregates[e.type.toLowerCase()](t,e.field)},o.prototype.serverExcelExport=function(e){this.isExcel=!0,this.exportGrid(e)},o.prototype.serverPdfExport=function(e){this.isExcel=!1,this.exportGrid(e)},o.prototype.serverCsvExport=function(e){this.isExcel=!0,this.exportGrid(e)},o.prototype.exportGrid=function(e){var t=this.getDataModule().generateQuery(!0),r=(new i.UrlAdaptor).processQuery(new i.DataManager({url:""}),t),n=JSON.parse(r.data),o=JSON.parse(this.addOnPersist(["allowGrouping","allowPaging","pageSettings","sortSettings","allowPdfExport","allowExcelExport","aggregates","filterSettings","groupSettings","columns","locale","searchSettings"]));o.filterSettings.columns=n.where,o.searchSettings.fields=n.search&&n.search[0].fields||[],o.sortSettings.columns=n.sorted,o.columns=this.setHeaderText(o.columns,["field","headerText","type","format","visible","foreignKeyValue","foreignKeyField","template","index","width","textAlign","headerTextAlign","columns"]);var s=this.createElement("form",{id:"ExportForm",styles:"display:none;"}),l=this.createElement("input",{id:"gridInput",attrs:{name:"gridModel"}});l.value=JSON.stringify(o),s.method="POST",s.action=e,s.appendChild(l),document.body.appendChild(s),s.submit(),s.remove()},o.prototype.setHeaderText=function(e,i){for(var r=0;r<e.length;r++){var n=this.getColumnByUid(e[r].uid);e[r].headerText=n.headerText,t.isNullOrUndefined(n.template)||(e[r].template="true"),e[r].format&&(e[r].format=Ue(this.getFormat(e[r].format),e[r].type,this.isExcel)),e[r].columns&&this.setHeaderText(e[r].columns,i);for(var o=Object.keys(e[r]),s=0;s<o.length;s++)i.indexOf(o[s])<0&&delete e[r][o[s]]}return e},o.prototype.getFormat=function(e){return"object"==typeof e?t.isNullOrUndefined(e.format)?e.skeleton:e.format:e},o.prototype.isCollapseStateEnabled=function(){return!1===this.isExpanded},o.prototype.updateRowValue=function(e,t){var i={requestType:"save",data:t};this.showSpinner(),this.notify(dr,i),this.refresh()},o.prototype.setForeignKeyData=function(){this.dataBind();var e=this.getDataModule().getForeignKeyDataState();e.isPending?(this.getDataModule().setForeignKeyDataState({}),e.resolver()):(this.getDataModule().setForeignKeyDataState({isDataChanged:!1}),(this.contentModule||this.headerModule)&&this.renderModule.render())},o.prototype.resetFilterDlgPosition=function(e){var t=this.getColumnHeaderByField(e);if(t){var i=t.querySelector(".e-filtermenudiv"),r=this.element.querySelector(".e-filter-popup");if(i&&r){var n=this.element.getBoundingClientRect(),o=i.getBoundingClientRect();r&&(r.offsetWidth+o.right>n.right?r.style.left=(o.right-r.offsetWidth-n.left).toString()+"px":r.style.left=(o.right-n.left).toString()+"px")}}},o.prototype.renderTemplates=function(){this.notify("reactTemplateRender",this.portals),this.renderReactTemplates()},o.prototype.batchUpdate=function(e){this.processRowChanges(e)},o.prototype.batchAsyncUpdate=function(e){this.processBulkRowChanges(e)},o.prototype.processBulkRowChanges=function(e){var t=this;if(this.dataToBeUpdated)for(var i=[ls,ss,as],r=this.getPrimaryKeyFieldNames()[0],n=0;n<i.length;n++)e[i[n]]&&Te(this,e,i[n],r);else this.dataToBeUpdated=Object.assign({addedRecords:[],changedRecords:[],deletedRecords:[]},e),setTimeout(function(){t.processRowChanges(t.dataToBeUpdated),t.dataToBeUpdated=null},this.asyncTimeOut)},o.prototype.processRowChanges=function(e){var t=this,i=this.getPrimaryKeyFieldNames()[0];e=Object.assign({addedRecords:[],changedRecords:[],deletedRecords:[]},e);var r=this.getDataModule().saveChanges(e,i,{},this.getDataModule().generateQuery().requiresCount());this.getDataModule().isRemote()?r.then(function(){t.setNewData()}):this.setNewData()},o.prototype.setNewData=function(){var e=this,t=JSON.parse(JSON.stringify(this.getCurrentViewRecords()));this.getDataModule().getData({},this.getDataModule().generateQuery().requiresCount()).then(function(i){e.bulkRefresh(i.result,t,i.count)})},o.prototype.deleteRowElement=function(e){var i=this.getRowElementByUID(e.uid),r=parseInt(i.getAttribute(us),10);if(t.remove(i),this.getFrozenColumns()){var n=this.getMovableRows()[r];t.remove(n)}},o.prototype.bulkRefresh=function(e,t,i){for(var r,n=this,o=this.getRowsObject(),s=this.getPrimaryKeyFieldNames()[0],l=function(t){e.filter(function(e){return e[s]===o[t].data[s]}).length||(a.deleteRowElement(o[t]),o.splice(t,1),t--),r=t},a=this,h=0;h<o.length;h++)l(h),h=r;var d=function(i){var r;t.filter(function(t){t[s]===e[i][s]&&(t!==e[i]&&n.setRowData(e[i][s],e[i]),r=!0)}),r||p.renderRowElement(e[i],i)},p=this;for(h=0;h<e.length;h++)d(h);this.currentViewData=e;var c=[].slice.call(this.getContentTable().getElementsByClassName(is));Ie(this,this.getRowsObject(),c),ze(this),this.allowPaging&&this.notify(Ii,{module:"pager",properties:{totalRecordsCount:i}})},o.prototype.renderRowElement=function(e,t){var i,r=new Fs(this.serviceLocator,null,this),n=new Es(this).generateRows([e]),o=r.render(n[0],this.getColumns());this.addRowObject(n[0],t);var s=this.getContentTable().querySelector(gs);if(s.querySelector(".e-emptyrow")){var l=s.querySelector(".e-emptyrow");if(l.parentNode.removeChild(l),this.getFrozenColumns()){var a=this.getContent().querySelector("."+Yo).querySelector(gs);a.firstElementChild.parentNode.removeChild(a.firstElementChild)}}this.getFrozenColumns()&&(i=le(o,this.getFrozenColumns(),this),(this.frozenRows&&t<this.frozenRows?this.getHeaderContent().querySelector("."+Jo).querySelector(gs):this.getContent().querySelector("."+Yo).querySelector(gs)).appendChild(i),"auto"===this.height&&this.notify(Wr,{})),s=this.frozenRows&&t<this.frozenRows?this.getHeaderContent().querySelector(gs):this.getContent().querySelector(gs),(s=this.getContent().querySelector(gs)).appendChild(o)},o.prototype.addRowObject=function(e,t){var i=this.getFrozenColumns();if(i){var r=this.getMovableRowsObject(),n=e.clone();n.cells=n.cells.slice(i),e.cells=e.cells.slice(0,i),r.splice(t,1,n)}this.getRowsObject().splice(t,1,e)},o.prototype.updateVisibleExpandCollapseRows=function(){for(var e=this.getRowsObject(),t=0,i=e.length;t<i;t++)(e[t].isDataRow||e[t].isAggregateRow)&&"none"===this.getRowElementByUID(e[t].uid).style.display?e[t].visible=!1:e[t].visible=!0},o.prototype.getHeight=function(e){return e=Number.isInteger(e)||-1===e.indexOf("%")?Number.isInteger(e)||"auto"===this.height?this.height:parseInt(e,10):parseInt(e,10)/100*this.element.clientHeight},o.prototype.getFrozenRightContent=function(){return this.getContent().querySelector(".e-frozen-right-content")},o.prototype.getFrozenRightHeader=function(){return this.getHeaderContent().querySelector(".e-frozen-right-header")},o.prototype.getMovableHeaderTbody=function(){return this.getMovableVirtualHeader().querySelector(gs)},o.prototype.getMovableContentTbody=function(){return this.getMovableVirtualContent().querySelector(gs)},o.prototype.getFrozenHeaderTbody=function(){return this.getFrozenVirtualHeader().querySelector(gs)},o.prototype.getFrozenLeftContentTbody=function(){return this.getFrozenVirtualContent().querySelector(gs)},o.prototype.getFrozenRightHeaderTbody=function(){return this.getFrozenRightHeader().querySelector(gs)},o.prototype.getFrozenRightContentTbody=function(){var e;return this.getFrozenRightContent()&&(e=this.getFrozenRightContent().querySelector(gs)),e},o.prototype.showResponsiveCustomFilter=function(e){this.filterModule&&this.filterModule.showCustomFilter(e||"Vertical"===this.rowRenderingMode)},o.prototype.showResponsiveCustomSort=function(e){this.sortModule&&this.sortModule.showCustomSort(e||"Vertical"===this.rowRenderingMode)},o.prototype.showAdaptiveFilterDialog=function(){this.enableAdaptiveUI&&this.showResponsiveCustomFilter(!0)},o.prototype.showAdaptiveSortDialog=function(){this.enableAdaptiveUI&&this.showResponsiveCustomSort(!0)},o.prototype.getCurrentVisibleColumns=function(e){for(var t=[],i=0,r=e?this.getColumns():this.columnModel;i<r.length;i++){var n=r[i];n.visible&&t.push(n)}return t},o.prototype.enableInfiniteAggrgate=function(){this.enableInfiniteScrolling&&this.groupSettings.columns.length&&!this.groupSettings.disablePageWiseAggregates&&this.setProperties({groupSettings:{disablePageWiseAggregates:!0}},!0)};var s;return Ll([t.Property()],o.prototype,"parentDetails",void 0),Ll([t.Property([])],o.prototype,"columns",void 0),Ll([t.Property(!0)],o.prototype,"enableAltRow",void 0),Ll([t.Property(!0)],o.prototype,"enableHover",void 0),Ll([t.Property(!1)],o.prototype,"enableAutoFill",void 0),Ll([t.Property(!0)],o.prototype,"allowKeyboard",void 0),Ll([t.Property(!1)],o.prototype,"enableStickyHeader",void 0),Ll([t.Property(!1)],o.prototype,"allowTextWrap",void 0),Ll([t.Complex({},Kl)],o.prototype,"textWrapSettings",void 0),Ll([t.Complex({},Ql)],o.prototype,"resizeSettings",void 0),Ll([t.Property(!1)],o.prototype,"allowPaging",void 0),Ll([t.Complex({},Rl)],o.prototype,"pageSettings",void 0),Ll([t.Property(!1)],o.prototype,"enableVirtualization",void 0),Ll([t.Property(!1)],o.prototype,"enableColumnVirtualization",void 0),Ll([t.Property(!1)],o.prototype,"enableInfiniteScrolling",void 0),Ll([t.Complex({},_l)],o.prototype,"searchSettings",void 0),Ll([t.Property(!1)],o.prototype,"allowSorting",void 0),Ll([t.Property("Ellipsis")],o.prototype,"clipMode",void 0),Ll([t.Property(!0)],o.prototype,"allowMultiSorting",void 0),Ll([t.Property(!1)],o.prototype,"allowExcelExport",void 0),Ll([t.Property(!1)],o.prototype,"allowPdfExport",void 0),Ll([t.Complex({},Hl)],o.prototype,"sortSettings",void 0),Ll([t.Complex({},jl)],o.prototype,"infiniteScrollSettings",void 0),Ll([t.Property(!0)],o.prototype,"allowSelection",void 0),Ll([t.Property(-1)],o.prototype,"selectedRowIndex",void 0),Ll([t.Complex({},Gl)],o.prototype,"selectionSettings",void 0),Ll([t.Property(!1)],o.prototype,"allowFiltering",void 0),Ll([t.Property("Horizontal")],o.prototype,"rowRenderingMode",void 0),Ll([t.Property(!1)],o.prototype,"enableAdaptiveUI",void 0),Ll([t.Property(!1)],o.prototype,"allowReordering",void 0),Ll([t.Property(!1)],o.prototype,"allowResizing",void 0),Ll([t.Property(!1)],o.prototype,"allowRowDragAndDrop",void 0),Ll([t.Complex({},Wl)],o.prototype,"rowDropSettings",void 0),Ll([t.Complex({},Vl)],o.prototype,"filterSettings",void 0),Ll([t.Property(!1)],o.prototype,"allowGrouping",void 0),Ll([t.Property(!1)],o.prototype,"enableImmutableMode",void 0),Ll([t.Property(!1)],o.prototype,"showColumnMenu",void 0),Ll([t.Complex({},Xl)],o.prototype,"groupSettings",void 0),Ll([t.Complex({},Yl)],o.prototype,"editSettings",void 0),Ll([t.Collection([],Bl)],o.prototype,"aggregates",void 0),Ll([t.Property(!1)],o.prototype,"showColumnChooser",void 0),Ll([t.Complex({},El)],o.prototype,"columnChooserSettings",void 0),Ll([t.Property(!1)],o.prototype,"enableHeaderFocus",void 0),Ll([t.Property("auto")],o.prototype,"height",void 0),Ll([t.Property("auto")],o.prototype,"width",void 0),Ll([t.Property("Default")],o.prototype,"gridLines",void 0),Ll([t.Property()],o.prototype,"rowTemplate",void 0),Ll([t.Property()],o.prototype,"detailTemplate",void 0),Ll([t.Property()],o.prototype,"childGrid",void 0),Ll([t.Property()],o.prototype,"queryString",void 0),Ll([t.Property("AllPages")],o.prototype,"printMode",void 0),Ll([t.Property("Expanded")],o.prototype,"hierarchyPrintMode",void 0),Ll([t.Property([])],o.prototype,"dataSource",void 0),Ll([t.Property(null)],o.prototype,"rowHeight",void 0),Ll([t.Property()],o.prototype,"query",void 0),Ll([t.Property("USD")],o.prototype,"currencyCode",void 0),Ll([t.Property()],o.prototype,"toolbar",void 0),Ll([t.Property()],o.prototype,"contextMenuItems",void 0),Ll([t.Property()],o.prototype,"columnMenuItems",void 0),Ll([t.Property()],o.prototype,"toolbarTemplate",void 0),Ll([t.Property()],o.prototype,"pagerTemplate",void 0),Ll([t.Property(0)],o.prototype,"frozenRows",void 0),Ll([t.Property(0)],o.prototype,"frozenColumns",void 0),Ll([t.Property("All")],o.prototype,"columnQueryMode",void 0),Ll([t.Property({})],o.prototype,"currentAction",void 0),Ll([t.Property("19.4.56")],o.prototype,"ej2StatePersistenceVersion",void 0),Ll([t.Event()],o.prototype,"created",void 0),Ll([t.Event()],o.prototype,"destroyed",void 0),Ll([t.Event()],o.prototype,"load",void 0),Ll([t.Event()],o.prototype,"rowDataBound",void 0),Ll([t.Event()],o.prototype,"queryCellInfo",void 0),Ll([t.Event()],o.prototype,"headerCellInfo",void 0),Ll([t.Event()],o.prototype,"actionBegin",void 0),Ll([t.Event()],o.prototype,"actionComplete",void 0),Ll([t.Event()],o.prototype,"actionFailure",void 0),Ll([t.Event()],o.prototype,"dataBound",void 0),Ll([t.Event()],o.prototype,"recordDoubleClick",void 0),Ll([t.Event()],o.prototype,"recordClick",void 0),Ll([t.Event()],o.prototype,"rowSelecting",void 0),Ll([t.Event()],o.prototype,"rowSelected",void 0),Ll([t.Event()],o.prototype,"rowDeselecting",void 0),Ll([t.Event()],o.prototype,"rowDeselected",void 0),Ll([t.Event()],o.prototype,"cellSelecting",void 0),Ll([t.Event()],o.prototype,"cellSelected",void 0),Ll([t.Event()],o.prototype,"cellDeselecting",void 0),Ll([t.Event()],o.prototype,"cellDeselected",void 0),Ll([t.Event()],o.prototype,"columnSelecting",void 0),Ll([t.Event()],o.prototype,"columnSelected",void 0),Ll([t.Event()],o.prototype,"columnDeselecting",void 0),Ll([t.Event()],o.prototype,"columnDeselected",void 0),Ll([t.Event()],o.prototype,"columnDragStart",void 0),Ll([t.Event()],o.prototype,"columnDrag",void 0),Ll([t.Event()],o.prototype,"columnDrop",void 0),Ll([t.Event()],o.prototype,"printComplete",void 0),Ll([t.Event()],o.prototype,"beforePrint",void 0),Ll([t.Event()],o.prototype,"pdfQueryCellInfo",void 0),Ll([t.Event()],o.prototype,"pdfHeaderQueryCellInfo",void 0),Ll([t.Event()],o.prototype,"pdfAggregateQueryCellInfo",void 0),Ll([t.Event()],o.prototype,"excelAggregateQueryCellInfo",void 0),Ll([t.Event()],o.prototype,"exportDetailDataBound",void 0),Ll([t.Event()],o.prototype,"excelQueryCellInfo",void 0),Ll([t.Event()],o.prototype,"excelHeaderQueryCellInfo",void 0),Ll([t.Event()],o.prototype,"beforeExcelExport",void 0),Ll([t.Event()],o.prototype,"excelExportComplete",void 0),Ll([t.Event()],o.prototype,"beforePdfExport",void 0),Ll([t.Event()],o.prototype,"pdfExportComplete",void 0),Ll([t.Event()],o.prototype,"rowDragStartHelper",void 0),Ll([t.Event()],o.prototype,"detailDataBound",void 0),Ll([t.Event()],o.prototype,"rowDragStart",void 0),Ll([t.Event()],o.prototype,"rowDrag",void 0),Ll([t.Event()],o.prototype,"rowDrop",void 0),Ll([t.Event()],o.prototype,"toolbarClick",void 0),Ll([t.Event()],o.prototype,"beforeOpenColumnChooser",void 0),Ll([t.Event()],o.prototype,"beforeOpenAdaptiveDialog",void 0),Ll([t.Event()],o.prototype,"batchAdd",void 0),Ll([t.Event()],o.prototype,"batchDelete",void 0),Ll([t.Event()],o.prototype,"batchCancel",void 0),Ll([t.Event()],o.prototype,"beforeBatchAdd",void 0),Ll([t.Event()],o.prototype,"beforeBatchDelete",void 0),Ll([t.Event()],o.prototype,"beforeBatchSave",void 0),Ll([t.Event()],o.prototype,"beginEdit",void 0),Ll([t.Event()],o.prototype,"commandClick",void 0),Ll([t.Event()],o.prototype,"cellEdit",void 0),Ll([t.Event()],o.prototype,"cellSave",void 0),Ll([t.Event()],o.prototype,"cellSaved",void 0),Ll([t.Event()],o.prototype,"resizeStart",void 0),Ll([t.Event()],o.prototype,"resizing",void 0),Ll([t.Event()],o.prototype,"resizeStop",void 0),Ll([t.Event()],o.prototype,"keyPressed",void 0),Ll([t.Event()],o.prototype,"beforeDataBound",void 0),Ll([t.Event()],o.prototype,"contextMenuOpen",void 0),Ll([t.Event()],o.prototype,"contextMenuClick",void 0),Ll([t.Event()],o.prototype,"columnMenuOpen",void 0),Ll([t.Event()],o.prototype,"columnMenuClick",void 0),Ll([t.Event()],o.prototype,"checkBoxChange",void 0),Ll([t.Event()],o.prototype,"beforeCopy",void 0),Ll([t.Event()],o.prototype,"beforePaste",void 0),Ll([t.Event()],o.prototype,"beforeAutoFill",void 0),Ll([t.Event()],o.prototype,"columnDataStateChange",void 0),Ll([t.Event()],o.prototype,"dataStateChange",void 0),Ll([t.Event()],o.prototype,"dataSourceChanged",void 0),Ll([t.Event()],o.prototype,"exportGroupCaption",void 0),Ll([t.Event()],o.prototype,"lazyLoadGroupExpand",void 0),Ll([t.Event()],o.prototype,"lazyLoadGroupCollapse",void 0),o=s=Ll([t.NotifyPropertyChanges],o)}(t.Component),Zl=function(){function e(e,t){this.isAsyncPrint=!1,this.defered=new i.Deferred,this.parent=e,this.parent.isDestroyed||(this.parent.on(xi,this.isContentReady(),this),this.actionBeginFunction=this.actionBegin.bind(this),this.parent.addEventListener(zt,this.actionBeginFunction),this.parent.on(Ei,this.onEmpty.bind(this)),this.parent.on(Jr,this.hierarchyPrint,this),this.scrollModule=t)}return e.prototype.isContentReady=function(){var e=this;return!this.isPrintGrid()||"None"!==this.parent.hierarchyPrintMode&&this.parent.childGrid?function(){e.defered.promise.then(function(){e.contentReady()}),e.isPrintGrid()&&e.hierarchyPrint()}:this.contentReady},e.prototype.hierarchyPrint=function(){this.removeColGroup(this.parent);var e=window.printGridObj;e&&!e.element.querySelector("[aria-busy=true")&&e.printModule.defered.resolve()},e.prototype.print=function(){this.renderPrintGrid()},e.prototype.onEmpty=function(){this.isPrintGrid()&&this.contentReady()},e.prototype.actionBegin=function(){this.isPrintGrid()&&(this.isAsyncPrint=!0)},e.prototype.renderPrintGrid=function(){var e=this.parent,i=t.createElement("div",{id:this.parent.element.id+"_print",className:e.element.className+" e-print-grid"});i.classList.remove("e-gridhover"),document.body.appendChild(i);for(var r=new Jl(ce(e,e.hierarchyPrintMode)),n=0;n<r.columns.length;n++)r.columns[n]=t.extend({},r.columns[n]),e.isFrozenGrid()&&!e.getFrozenColumns()&&(r.columns[n].freeze=void 0);this.parent.isAngular&&(r.viewContainerRef=this.parent.viewContainerRef),r.load=function(){},r.query=e.getQuery().clone(),window.printGridObj=r,r.isPrinting=!0;var o=r.getInjectedModules(),s=e.getInjectedModules();o&&o.length===s.length||r.setInjectedModules(s),e.notify($r,{element:i,printgrid:r}),this.parent.log("exporting_begin",this.getModuleName()),r.registeredTemplate=this.parent.registeredTemplate,r.isVue=this.parent.isVue,r.appendTo(i),r.trigger=e.trigger},e.prototype.contentReady=function(){if(this.isPrintGrid()){var e=this.parent;if(this.isAsyncPrint)return void this.printGrid();var i={requestType:"print",element:e.element,selectedRows:e.getContentTable().querySelectorAll('tr[aria-selected="true"]'),cancel:!1,hierarchyPrintMode:e.hierarchyPrintMode};if(this.isAsyncPrint||e.trigger(Zt,i),i.cancel)return void t.detach(e.element);this.isAsyncPrint||this.printGrid()}},e.prototype.printGrid=function(){var e=this.parent;if("auto"!==e.height){var i=this.scrollModule.getCssProperties(),r=e.element.querySelector("."+es),n=e.element.querySelector("."+Wo);r.style.height="auto",r.style.overflowY="auto",n.style[i.padding]="",n.firstElementChild.style[i.border]=""}e.allowGrouping&&(e.groupSettings.columns.length?this.removeColGroup(e):e.element.querySelector(".e-groupdroparea").style.display="none");for(var o=0,s=[].slice.call(e.element.getElementsByClassName(es));o<s.length;o++){(d=s[o]).style.overflowX="hidden"}for(var l=[].slice.call(e.element.getElementsByClassName("e-spin-show")),a=0,h=[].slice.call(l);a<h.length;a++){var d=h[a];t.classList(d,["e-spin-hide"],["e-spin-show"])}this.printGridElement(e),e.isPrinting=!1,delete window.printGridObj;var p={element:e.element};e.trigger($t,p),e.destroy(),this.parent.log("exporting_complete",this.getModuleName())},e.prototype.printGridElement=function(e){t.classList(e.element,["e-print-grid-layout"],["e-print-grid"]),e.isPrinting&&t.detach(e.element),this.printWind=window.open("","print","height="+window.outerHeight+",width="+window.outerWidth+",tabbar=no"),this.printWind.moveTo(0,0),this.printWind.resizeTo(screen.availWidth,screen.availHeight),this.printWind=t.print(e.element,this.printWind)},e.prototype.removeColGroup=function(e){var i=e.groupSettings.columns.length,r=e.element,n="#"+e.element.id;if(i){for(var o=t.selectAll(n+"captioncell.e-groupcaption",r),s=o[i-1].getAttribute("colspan"),l=0;l<o.length;l++)o[l].setAttribute("colspan",s);var a=t.selectAll("colgroup"+n+"colgroup",r),h=t.selectAll(".e-content colgroup",r);this.hideColGroup(a,i),this.hideColGroup(h,i)}},e.prototype.hideColGroup=function(e,t){for(var i=0;i<e.length;i++)for(var r=0;r<t;r++)e[i].children[r].style.display="none"},e.prototype.isPrintGrid=function(){return this.parent.element.id.indexOf("_print")>0&&this.parent.isPrinting},e.prototype.destroy=function(){this.parent.isDestroyed||(this.parent.off(xi,this.contentReady.bind(this)),this.parent.removeEventListener(zt,this.actionBeginFunction),this.parent.off(Ei,this.onEmpty.bind(this)),this.parent.off(Jr,this.hierarchyPrint))},e.prototype.getModuleName=function(){return"print"},e.printGridProp=["aggregates","allowGrouping","allowFiltering","allowMultiSorting","allowReordering","allowSorting","allowTextWrap","childGrid","columns","currentViewData","dataSource","detailTemplate","enableAltRow","enableColumnVirtualization","filterSettings","gridLines","groupSettings","height","locale","pageSettings","printMode","query","queryString","enableRtl","rowHeight","rowTemplate","sortSettings","textWrapSettings","allowPaging","hierarchyPrintMode","searchSettings","queryCellInfo","beforeDataBound"].concat([Zt,$t,"load"]),e}(),$l=0,ea=0,ta=null;(e.Global||(e.Global={})).timer=null;var ia=function(){function e(e){this.existingPredicate={},this.foreignKeyQuery=new i.Query,this.filterState=!0,this.values={},this.renderEmpty=!1,this.parent=e,this.id=this.parent.element.id,this.valueFormatter=new Ct(this.parent.locale),this.cBoxTrue=n.createCheckBox(this.parent.createElement,!1,{checked:!0,label:" "}),this.cBoxFalse=n.createCheckBox(this.parent.createElement,!1,{checked:!1,label:" "}),this.cBoxTrue.insertBefore(this.parent.createElement("input",{className:"e-chk-hidden",attrs:{type:"checkbox"}}),this.cBoxTrue.firstChild),this.cBoxFalse.insertBefore(this.parent.createElement("input",{className:"e-chk-hidden",attrs:{type:"checkbox"}}),this.cBoxFalse.firstChild),this.cBoxFalse.querySelector(".e-frame").classList.add("e-uncheck"),this.parent.enableRtl&&t.addClass([this.cBoxTrue,this.cBoxFalse],["e-rtl"])}return e.prototype.destroy=function(){this.closeDialog()},e.prototype.wireEvents=function(){t.EventHandler.add(this.dlg,"click",this.clickHandler,this),t.EventHandler.add(this.dlg,"keyup",this.keyupHandler,this),this.searchHandler=t.debounce(this.searchBoxKeyUp,200);var e=this.dialogObj.element.querySelector(".e-searchinput");e&&t.EventHandler.add(e,"keyup",this.searchHandler,this)},e.prototype.unWireEvents=function(){t.EventHandler.remove(this.dlg,"click",this.clickHandler),t.EventHandler.remove(this.dlg,"keyup",this.keyupHandler);var e=this.dialogObj.element.querySelector(".e-searchinput");e&&t.EventHandler.remove(e,"keyup",this.searchHandler)},e.prototype.foreignKeyFilter=function(e,t,i){var r=this,n={},o=[],s=this.foreignKeyQuery.clone();this.options.column.dataSource.executeQuery(s.where(i)).then(function(i){r.options.column.columnData=i.result,r.parent.notify(Lr,{predicate:n,column:r.options.column}),e.ejpredicate=n.predicate.predicates;for(var s=n.predicate.predicates,l=0;l<s.length;l++)o.push({field:s[l].field,predicate:"or",matchCase:s[l].ignoreCase,ignoreAccent:s[l].ignoreAccent,operator:s[l].operator,value:s[l].value,type:r.options.type});e.filterCollection=o.length?o:t.filter(function(e){return e.field=r.options.field}),r.options.handler(e)})},e.prototype.foreignFilter=function(e,t){var r=this.options.isRemote?"string"===this.options.column.type?"contains":"equal":this.options.column.type?"contains":"equal",n=new i.Predicate(this.options.column.foreignKeyValue,r,t,!0,this.options.ignoreAccent);this.foreignKeyFilter(e,[e.filterCollection],n)},e.prototype.searchBoxClick=function(e){e.target.classList.contains("e-searchclear")&&(this.sInput.value="",this.refreshCheckboxes(),this.updateSearchIcon(),this.sInput.focus())},e.prototype.searchBoxKeyUp=function(e){this.refreshCheckboxes(),this.updateSearchIcon()},e.prototype.updateSearchIcon=function(){this.sInput.value.length?t.classList(this.sIcon,["e-chkcancel-icon"],["e-search-icon"]):t.classList(this.sIcon,["e-search-icon"],["e-chkcancel-icon"])},e.prototype.getLocalizedLabel=function(e){return this.localeObj.getConstant(e)},e.prototype.updateDataSource=function(){var e=this.options.dataSource;if(!(e instanceof i.DataManager))for(var t=0;t<e.length;t++)if("object"!=typeof e){var r={};r[this.options.field]=e[t],e[t]=r}},e.prototype.updateModel=function(e){this.options=e,this.existingPredicate=e.actualPredicate||{},this.options.dataSource=e.dataSource,this.options.dataManager=e.dataManager?e.dataManager:e.dataSource,this.updateDataSource(),this.options.type=e.type,this.options.format=e.format||"",this.options.ignoreAccent=e.ignoreAccent||!1,this.options.filteredColumns=e.filteredColumns||this.parent.filterSettings.columns,this.options.query=e.query||new i.Query,this.options.allowCaseSensitive=e.allowCaseSensitive||!1,this.options.uid=e.column.uid,this.values={},this.localeObj=e.localeObj,this.isFiltered=e.filteredColumns.length},e.prototype.getAndSetChkElem=function(e){if(this.dlg=this.parent.createElement("div",{id:this.id+this.options.type+"_excelDlg",attrs:{uid:this.options.column.uid},className:"e-checkboxfilter e-filter-popup"}),this.sBox=this.parent.createElement("div",{className:"e-searchcontainer"}),!e.hideSearchbox){this.sInput=this.parent.createElement("input",{id:this.id+"_SearchBox",className:"e-searchinput"}),this.sIcon=this.parent.createElement("span",{className:"e-searchclear e-search-icon e-icons e-input-group-icon",attrs:{type:"text",title:this.getLocalizedLabel("Search")}}),this.searchBox=this.parent.createElement("span",{className:"e-searchbox e-fields"}),this.searchBox.appendChild(this.sInput),this.sBox.appendChild(this.searchBox);var t={element:this.sInput,floatLabelType:"Never",properties:{placeholder:this.getLocalizedLabel("Search")}};o.Input.createInput(t,this.parent.createElement),this.searchBox.querySelector(".e-input-group").appendChild(this.sIcon)}return this.spinner=this.parent.createElement("div",{className:"e-spinner"}),this.cBox=this.parent.createElement("div",{id:this.id+this.options.type+"_CheckBoxList",className:"e-checkboxlist e-fields"}),this.spinner.appendChild(this.cBox),this.sBox.appendChild(this.spinner),this.sBox},e.prototype.showDialog=function(e){var i={requestType:mi,columnName:this.options.field,columnType:this.options.type,cancel:!1};if(i.filterModel=this,this.parent.notify(cn,i),i.cancel)e.cancel=i.cancel;else{this.dialogObj=new r.Dialog({visible:!1,content:this.sBox,close:this.closeDialog.bind(this),enableRtl:this.parent.enableRtl,width:!t.isNullOrUndefined(D(e.target,"e-bigger"))||this.parent.element.classList.contains("e-device")?260:255,target:this.parent.element,animationSettings:{effect:"None"},buttons:[{click:this.btnClick.bind(this),buttonModel:{content:this.getLocalizedLabel(this.isExcel?"OKButton":"FilterButton"),cssClass:"e-primary",isPrimary:!0}},{click:this.btnClick.bind(this),buttonModel:{cssClass:"e-flat",content:this.getLocalizedLabel(this.isExcel?"CancelButton":"ClearButton")}}],created:this.dialogCreated.bind(this),open:this.dialogOpen.bind(this)});if(this.dialogObj.isStringTemplate=!0,this.renderResponsiveFilter(e),this.dlg.setAttribute("aria-label",this.getLocalizedLabel("ExcelFilterDialogARIA")),e.isResponsiveFilter){document.querySelector(".e-responsive-dialog > .e-dlg-content > .e-mainfilterdiv").appendChild(this.dlg)}else this.parent.element.appendChild(this.dlg);this.dialogObj.appendTo(this.dlg),this.dialogObj.element.style.maxHeight=e.isResponsiveFilter?"none":this.options.height+"px",this.dialogObj.show();this.dialogObj.element.querySelector(".e-dlg-content").appendChild(this.sBox),this.wireEvents(),r.createSpinner({target:this.spinner},this.parent.createElement),r.showSpinner(this.spinner),this.getAllData()}},e.prototype.renderResponsiveFilter=function(e){e.isResponsiveFilter&&(this.dialogObj.buttons=[{}],this.dialogObj.position={X:"",Y:""},this.dialogObj.target=document.querySelector(".e-resfilter > .e-dlg-content > .e-mainfilterdiv"),this.dialogObj.width="100%")},e.prototype.dialogCreated=function(e){this.options.isResponsiveFilter?this.dialogObj.element.style.left="0px":t.Browser.isDevice?this.dialogObj.position={X:"center",Y:"center"}:J(this.options.target,this.dialogObj),this.options.column.showColumnMenu&&this.parent.notify(Ar,e)},e.prototype.openDialog=function(e){this.updateModel(e),this.getAndSetChkElem(e),this.showDialog(e)},e.prototype.closeDialog=function(){if(this.dialogObj&&!this.dialogObj.isDestroyed){this.isBlanks=!1;var e=this.options.columns.filter(function(e){return e.getFilterItemTemplate()}),i=this.parent.registeredTemplate;e.length&&!t.isNullOrUndefined(i)&&i.filterItemTemplate&&this.parent.destroyTemplate(["filterItemTemplate"]),(this.parent.isReact||this.parent.isVue)&&void 0!==this.parent.destroyTemplate&&Je(this.parent,["filterItemTemplate"]),this.parent.notify(Br,{field:this.options.field}),this.dialogObj.destroy(),this.unWireEvents(),t.remove(this.dlg),this.dlg=null,this.parent.notify(co,{})}},e.prototype.clearFilter=function(e){var t={instance:this,handler:this.clearFilter,cancel:!1};this.parent.notify(gn,t),t.cancel||this.options.handler({action:"clear-filter",field:e?e.field:this.options.field})},e.prototype.btnClick=function(e){if(this.filterState){if("input"===e.target.tagName.toLowerCase()&&e.target.classList.contains("e-searchinput")||13===e.keyCode)this.fltrBtnHandler();else{var t=e.target.firstChild.textContent.toLowerCase();this.getLocalizedLabel(this.isExcel?"OKButton":"FilterButton").toLowerCase()===t?this.fltrBtnHandler():this.getLocalizedLabel("ClearButton").toLowerCase()===t&&this.clearFilter()}this.closeDialog()}else"input"!==e.target.tagName.toLowerCase()&&(this.clearFilter(),this.closeDialog());this.options.column.showColumnMenu&&this.parent.notify(Lo,{})},e.prototype.fltrBtnHandler=function(){var i=this,r=[].slice.call(this.cBox.querySelectorAll(".e-check:not(.e-selectall)")),n=r,o="equal",s=this.dialogObj.element.querySelector(".e-dropdownlist");s&&(this.options.operator=o=s.ej2_instances[0].value),this.isMenuNotEqual="notequal"===this.options.operator;var l;this.options.hideSearchbox||(l=this.searchBox.querySelector(".e-searchinput"));var a=this.options.allowCaseSensitive,h={field:this.options.field,predicate:this.isMenuNotEqual?"and":"or",uid:this.options.uid,operator:o,type:this.options.type,matchCase:a,ignoreAccent:this.options.ignoreAccent},d=this.itemsCnt!==r.length&&this.itemsCnt-r.length<r.length;d&&l&&""===l.value&&(o=this.isMenuNotEqual?"equal":"notequal",r=[].slice.call(this.cBox.querySelectorAll(".e-uncheck:not(.e-selectall)")),h.predicate=this.isMenuNotEqual?"or":"and",h.operator=o);var p,c,u,g,f=[];if(r.length!==this.itemsCnt||l&&l.value&&""!==l.value){for(var m=0;m<r.length;m++){p=this.values[D(r[m],"e-ftrchk").getAttribute("uid")],g=t.extend({},{value:p},h),p&&!p.toString().length&&(g.operator=d?"notequal":"equal"),""===p||t.isNullOrUndefined(p)?f=f.concat(e.generateNullValuePredicates(h)):f.push(g);var y={instance:this,handler:this.fltrBtnHandler,arg1:g.field,arg2:g.predicate,arg3:g.operator,arg4:g.matchCase,arg5:g.ignoreAccent,arg6:g.value,cancel:!1};if(this.parent.notify(gn,y),y.cancel)return}"date"!==this.options.type&&"datetime"!==this.options.type||(u=n.length-1,c=this.values[D(n[u],"e-ftrchk").getAttribute("uid")],t.isNullOrUndefined(c)&&d&&f.push({field:h.field,matchCase:h.matchCase,operator:"equal",predicate:"and",value:null})),this.initiateFilter(f)}else{this.options.filteredColumns.some(function(e){return i.options.field===e.field})&&this.clearFilter()}},e.generateNullValuePredicates=function(e){var t=[];return"string"===e.type&&t.push({field:e.field,ignoreAccent:e.ignoreAccent,matchCase:e.matchCase,operator:e.operator,predicate:e.predicate,value:""}),t.push({field:e.field,matchCase:e.matchCase,operator:e.operator,predicate:e.predicate,value:null}),t.push({field:e.field,matchCase:e.matchCase,operator:e.operator,predicate:e.predicate,value:void 0}),t},e.prototype.initiateFilter=function(e){var r,n=e[0];if(!t.isNullOrUndefined(n)){r=n.ejpredicate?n.ejpredicate:new i.Predicate(n.field,n.operator,n.value,!n.matchCase,n.ignoreAccent);for(var o=1;o<e.length;o++)r=void 0!==e[o].ejpredicate?r[e[o].predicate](e[o].ejpredicate):r[e[o].predicate](e[o].field,e[o].operator,e[o].value,!e[o].matchCase,e[o].ignoreAccent);var s={action:"filtering",filterCollection:e,field:this.options.field,ejpredicate:i.Predicate.or(r)};this.options.handler(s)}},e.prototype.isForeignColumn=function(e){return!!e.isForeignColumn&&e.isForeignColumn()},e.prototype.refreshCheckboxes=function(){var n=this,o=this.sInput.value,s=this.options.column,l=this.isForeignColumn(s)?this.foreignKeyQuery.clone():this.options.query.clone(),a=this.options.query.clone(),h=l.queries.filter(function(e){return e&&"onWhere"===e.fn})[0];l.queries=[],a.queries=[];var d="string"!==this.options.type&&parseFloat(o)?parseFloat(o):o,p=this.options.isRemote?"string"===this.options.type?"contains":"equal":this.options.type?"contains":"equal",c=this.options.ignoreAccent,u=this.isForeignColumn(s)?s.foreignKeyValue:s.field;d=""===d||void 0===d?void 0:d;var g,f=[],m={field:u,predicate:"or",uid:this.options.uid,operator:"equal",type:this.options.type,matchCase:!0,ignoreAccent:c},y=this.options.dataManager.adaptor.getModuleName;if("boolean"===this.options.type&&(void 0!==d&&-1!==this.getLocalizedLabel("FilterTrue").toLowerCase().indexOf(d.toLowerCase())?d="true":void 0!==d&&-1!==this.getLocalizedLabel("FilterFalse").toLowerCase().indexOf(d.toLowerCase())&&(d="false"),void 0!==d&&-1!==this.getLocalizedLabel("FilterTrue").toLowerCase().indexOf(d.toLowerCase())&&y?(y(),d=!0):void 0!==d&&-1!==this.getLocalizedLabel("FilterFalse").toLowerCase().indexOf(d.toLowerCase())&&y&&(y(),d=!1),p="equal"),("date"===this.options.type||"datetime"===this.options.type)&&this.options.format){var v=new t.Internationalization,C="string"==typeof this.options.format?this.options.format:this.options.format.format;d=C?v.parseDate(o,{format:C})||new Date(o):new Date(o)}this.addDistinct(l);var w={requestType:yi,filterModel:this,columnName:u,column:s,operator:p,matchCase:!0,ignoreAccent:c,filterChoiceCount:null,query:l,value:d};this.parent.trigger(zt,w,function(y){if(y.operator=y.operator,g=new i.Predicate(u,y.operator,d,y.matchCase,y.ignoreAccent),"date"===n.options.type||"datetime"===n.options.type){var v={field:u,operator:p="equal",value:d,matchCase:!0,ignoreAccent:c};t.isNullOrUndefined(d)||(g=se(v,n.options.type))}if(o&&"string"==typeof o&&n.isBlanks&&n.getLocalizedLabel("Blanks").toLowerCase().indexOf(o.toLowerCase())>=0){f=f.concat(e.generateNullValuePredicates(m));var C=e.generatePredicate(f);C.predicates.push(g),l.where(C)}else o.length?(g=t.isNullOrUndefined(h)?g:g.and(h.e),l.where(g)):t.isNullOrUndefined(h)||l.where(h.e);y.filterChoiceCount=t.isNullOrUndefined(y.filterChoiceCount)?1e3:y.filterChoiceCount;var w={};if(r.showSpinner(n.spinner),n.renderEmpty=!1,n.isForeignColumn(s)&&o.length){("result"in s.dataSource?new i.DataManager(s.dataSource.result):s.dataSource).executeQuery(l).then(function(e){var t=n.options.column.columnData;n.options.column.columnData=e.result,n.parent.notify(Lr,{predicate:w,column:s}),w.predicate.predicates.length?a.where(w.predicate):n.renderEmpty=!0,n.options.column.columnData=t,a.take(y.filterChoiceCount),n.search(y,a)})}else l.take(y.filterChoiceCount),n.search(y,l)})},e.prototype.search=function(e,t){this.parent.dataSource&&"result"in this.parent.dataSource?this.filterEvent(e,t):this.processSearch(t)},e.prototype.getPredicateFromCols=function(t){for(var r=e.getPredicate(t),n=[],o={},s=void 0!==this.parent.getForeignKeyColumns,l=s?this.parent.getForeignKeyColumns():[],a=0,h=Object.keys(r);a<h.length;a++){var d=h[a],p=void 0;s&&this.parent.getColumnByField(d).isForeignColumn()&&(p=oe(d,l)),p?(this.parent.notify(Lr,{predicate:o,column:p}),o.predicate.predicates.length&&n.push(i.Predicate.or(o.predicate.predicates))):n.push(r[d])}return n.length&&i.Predicate.and(n)},e.prototype.getQuery=function(){return this.parent.getQuery?this.parent.getQuery().clone():new i.Query},e.prototype.getAllData=function(){var e=this,i=this.getQuery();i.requiresCount(),this.addDistinct(i);var r={requestType:gi,query:i,filterChoiceCount:null};r.filterModel=this,this.parent.trigger(zt,r,function(r){r.filterChoiceCount=t.isNullOrUndefined(r.filterChoiceCount)?1e3:r.filterChoiceCount,i.take(r.filterChoiceCount),e.parent.dataSource&&"result"in e.parent.dataSource?e.filterEvent(r,i):e.processDataOperation(i,!0)})},e.prototype.addDistinct=function(e){var t=i.DataUtil.distinct(this.options.filteredColumns,"field");return t.indexOf(this.options.column.field)<=-1&&(t=t.concat(this.options.column.field)),e.distinct(t),e},e.prototype.filterEvent=function(e,t){var i=this,r=xe(e,t);this.parent.trigger(jr,r.state);r.deffered.promise.then(function(e){i.dataSuccess(e)})},e.prototype.processDataOperation=function(e,t){var r=this;this.options.dataSource=this.options.dataSource instanceof i.DataManager?this.options.dataSource:new i.DataManager(this.options.dataSource);var n=[],o=[];if(this.isForeignColumn(this.options.column)&&t){var s="result"in this.options.column.dataSource?new i.DataManager(this.options.column.dataSource.result):this.options.column.dataSource;this.foreignKeyQuery.params=e.params,n.push(s.executeQuery(this.foreignKeyQuery)),o.push(function(e){return r.foreignKeyData=e})}n.push(this.options.dataSource.executeQuery(e)),o.push(this.dataSuccess.bind(this));var l=0;Promise.all(n).then(function(e){for(var t=0;t<e.length;t++)o[l++](e[t].result)})},e.prototype.dataSuccess=function(t){this.fullData=t;var r={dataSource:this.fullData,executeQuery:!0,field:this.options.field};if(this.parent.notify(Xn,r),r.executeQuery){var n=new i.Query;if(this.parent.searchSettings&&this.parent.searchSettings.key.length){var o=this.parent.searchSettings,s=o.fields.length?o.fields:this.options.columns.map(function(e){return e.field});n.search(o.key,s,o.operator,o.ignoreCase,o.ignoreAccent)}if(this.options.filteredColumns.length){for(var l=[],a=0;a<this.options.filteredColumns.length;a++){var h=this.options.filteredColumns[a];this.options.uid?(h.uid=h.uid||this.parent.getColumnByField(h.field).uid,h.uid!==this.options.uid&&l.push(this.options.filteredColumns[a])):h.field!==this.options.field&&l.push(this.options.filteredColumns[a])}var d=this.getPredicateFromCols(l);d&&n.where(d)}var p=new i.DataManager(r.dataSource).executeLocal(n),c=this.options.column;this.filteredData=e.getDistinct(p,this.options.field,c,this.foreignKeyData).records||[]}var u=r.executeQuery?this.filteredData:r.dataSource;this.processDataSource(null,!0,u,r),this.sInput&&this.sInput.focus();var g={requestType:fi,columnName:this.options.field,columnType:this.options.type};g.filterModel=this,this.parent.notify(un,g)},e.prototype.processDataSource=function(e,t,i,n){r.showSpinner(this.spinner),this.updateResult(),this.createFilterItems(i,t,n)},e.prototype.processSearch=function(e){this.processDataOperation(e)},e.prototype.updateResult=function(){this.result={};var e=this.getPredicateFromCols(this.options.filteredColumns),t=new i.Query;e&&t.where(e),this.parent.notify(Do,{query:t});for(var r=0,n=new i.DataManager(this.fullData).executeLocal(t);r<n.length;r++){var o=n[r];this.result[he(this.options.field,o)]=!0}},e.prototype.clickHandler=function(e){var t=e.target,i=D(t,"e-checkbox-wrapper");if(D(t,"e-searchbox")&&this.searchBoxClick(e),i){var r=i.querySelector(".e-selectall");r?this.updateAllCBoxes(!r.classList.contains("e-check")):$(i.parentElement),this.updateIndeterminatenBtn(),i.querySelector(".e-chk-hidden").focus()}this.setFocus(D(i,"e-ftrchk"))},e.prototype.keyupHandler=function(e){this.setFocus(D(e.target,"e-ftrchk"))},e.prototype.setFocus=function(e){var t=this.dlg.querySelector(".e-chkfocus");t&&t.classList.remove("e-chkfocus"),e&&e.classList.add("e-chkfocus")},e.prototype.updateAllCBoxes=function(e){for(var t=0,i=[].slice.call(this.cBox.getElementsByClassName("e-frame"));t<i.length;t++){var r=i[t];ie(r,e),ee(r.previousSibling,e)}},e.prototype.dialogOpen=function(){this.parent.element.classList.contains("e-device")&&(this.dialogObj.element.querySelector(".e-input-group").classList.remove("e-input-focus"),this.options.isResponsiveFilter||this.dialogObj.element.querySelector(".e-btn").focus())},e.prototype.createCheckbox=function(e,i,r){var n=i?this.cBoxTrue.cloneNode(!0):this.cBoxFalse.cloneNode(!0);ee(n.querySelector("input"),i);var o=n.querySelector(".e-label"),s=ue({},r,{column:this.options.column,parent:this.parent});if(o.innerHTML=!t.isNullOrUndefined(e)&&e.toString().length?e:this.getLocalizedLabel("Blanks"),o.innerHTML===this.getLocalizedLabel("Blanks")&&(this.isBlanks=!0),"boolean"==typeof e&&(o.innerHTML=!0===e?this.getLocalizedLabel("FilterTrue"):this.getLocalizedLabel("FilterFalse")),t.addClass([o],["e-checkboxfiltertext"]),this.options.template&&r[this.options.column.field]!==this.getLocalizedLabel("SelectAll")){o.innerHTML="";this.parent.isReact&&this.options.column.filter&&"string"!=typeof this.options.column.filter.itemTemplate?(this.options.template(s,this.parent,"filterItemTemplate",null,null,null,o),this.parent.renderTemplates()):P(o,this.options.template(s,this.parent,"filterItemTemplate"))}return n},e.prototype.updateIndeterminatenBtn=function(){var e,i=this.cBox.children.length-1,r=[],n=!1,o=this.cBox.querySelector(".e-selectall"),s=this.cBox.querySelectorAll(".e-check:not(.e-selectall)").length;this.options.isResponsiveFilter||((e=this.dialogObj.btnObj[0]).disabled=!1);var l=o.previousSibling;ee(l,!1),l.indeterminate=!1,i===s?(r=["e-check"],ee(l,!0)):s?(r=["e-stop"],l.indeterminate=!0):(r=["e-uncheck"],n=!0,e&&(e.disabled=!0)),e&&(this.filterState=!e.disabled,e.dataBind()),t.removeClass([o],["e-check","e-stop","e-uncheck"]),t.addClass([o],r),this.parent.notify(uo,{disabled:n})},e.prototype.createFilterItems=function(e,n,o){var s,l,a=this.parent.createElement("div"),h=!1;this.options.isResponsiveFilter||(l=this.dialogObj.btnObj[0]);var d=-1,p="ejValue";o.executeQuery||(p=o.field);for(var c=0;c<e.length;c++){var u=t.getValue(p,e[c]);(""===u||t.isNullOrUndefined(u))&&(d+=1)}if(this.itemsCnt=-1!==d?e.length-d:e.length,e.length&&!this.renderEmpty){var g=this.getLocalizedLabel("SelectAll"),f=this.cBox.querySelector(".e-checkfltrnmdiv");f&&f.classList.remove("e-checkfltrnmdiv");var m=this.createCheckbox(g,!1,(s={},s[this.options.field]=g,s)),y=te(N("cbox"),m,"e-ftrchk");y.querySelector(".e-frame").classList.add("e-selectall"),a.appendChild(y);var v=new i.Predicate("field","equal",this.options.field);this.options.foreignKeyValue&&(v=v.or("field","equal",this.options.foreignKeyValue));var C=new i.DataManager(this.options.filteredColumns).executeLocal((new i.Query).where(v)).length,w=void 0;for(c=0;c<e.length;c++){var b=N("cbox");this.values[b]=t.getValue(p,e[c]);var S=t.getValue(this.options.field,e[c]);this.options.formatFn&&(S=this.valueFormatter.toView(S,this.options.formatFn));var R={value:S,column:this.options.column,data:e[c]};if(this.parent.notify(yn,R),""===(S=R.value)||t.isNullOrUndefined(S)){if(w)continue;w=!0}var x=this.createCheckbox(S,this.getCheckedState(C,this.values[b]),t.getValue("dataObj",e[c]));a.appendChild(te(b,x,"e-ftrchk"))}this.cBox.innerHTML="",P(this.cBox,[].slice.call(a.children)),this.updateIndeterminatenBtn(),l&&(l.disabled=!1),h=!1}else a.appendChild(this.parent.createElement("span",{innerHTML:this.getLocalizedLabel("NoResult")})),this.cBox.innerHTML="",this.cBox.appendChild(this.parent.createElement("div",{className:"e-checkfltrnmdiv"})),P(this.cBox.children[0],[].slice.call(a.children)),l&&(l.disabled=!0),h=!0;l&&(this.filterState=!l.disabled,l.dataBind());var F={requestType:gi,dataSource:this.renderEmpty?[]:e};F.filterModel=this,this.parent.notify(un,F),this.parent.notify(uo,{disabled:h}),r.hideSpinner(this.spinner)},e.prototype.getCheckedState=function(e,t){if(this.isFiltered&&e){var i=this.result[t];return"notequal"===this.options.operator?!i:i}return!0},e.getDistinct=function(e,r,n,o){for(var s,l=e.length,a=[],h={},d=!(!n||!n.isForeignColumn)&&n.isForeignColumn();l--;)if(s=e[l],!((s=he(r,s))in h)){var p={};if(p.ejValue=s,h[s]=!0,d){var c=ne(n,{},s,o)[0];t.setValue(Hr,c,e[l]),s=t.getValue(n.foreignKeyValue,c)}t.setValue(r,t.isNullOrUndefined(s)?null:s,p),t.setValue("dataObj",e[l],p),a.push(p)}return i.DataUtil.group(i.DataUtil.sort(a,r,i.DataUtil.fnAscending),"ejValue")},e.getPredicate=function(t){for(var r=i.DataUtil.distinct(t,"field",!0)||[],n=[],o={},s=0;s<r.length;s++)0!==(n=new i.DataManager(t).executeLocal((new i.Query).where("field","equal",r[s].field))).length&&(o[r[s].field]=e.generatePredicate(n));return o},e.generatePredicate=function(r){var n,o=r?r.length:0,s=e.updateDateFilter(r[0]);s.ignoreAccent=!t.isNullOrUndefined(s.ignoreAccent)&&s.ignoreAccent,n="date"===s.type||"datetime"===s.type?se(s,s.type):s.ejpredicate?s.ejpredicate:new i.Predicate(s.field,s.operator,s.value,!e.getCaseValue(s),s.ignoreAccent);for(var l=1;l<o;l++)r[l]=e.updateDateFilter(r[l]),o>2&&l>1&&"or"===r[l].predicate?"date"===r[l].type||"datetime"===r[l].type?n.predicates.push(se(r[l],r[l].type)):n.predicates.push(new i.Predicate(r[l].field,r[l].operator,r[l].value,!e.getCaseValue(r[l]),r[l].ignoreAccent)):n="date"===r[l].type||"datetime"===r[l].type?"and"===r[l].predicate&&"equal"===r[l].operator?n.or(se(r[l],r[l].type),r[l].type,r[l].ignoreAccent):n[r[l].predicate](se(r[l],r[l].type),r[l].type,r[l].ignoreAccent):r[l].ejpredicate?n[r[l].predicate](r[l].ejpredicate):n[r[l].predicate](r[l].field,r[l].operator,r[l].value,!e.getCaseValue(r[l]),r[l].ignoreAccent);return n||null},e.getCaseValue=function(e){return t.isNullOrUndefined(e.matchCase)?!("string"===e.type||t.isNullOrUndefined(e.type)&&"string"==typeof e.value):e.matchCase},e.updateDateFilter=function(e){return("date"===e.type||"datetime"===e.type||e.value instanceof Date)&&(e.type=e.type||"date"),e},e}(),ra=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),na=function(e){function h(t,i){var r=e.call(this,t)||this;return r.childRefs=[],r.eventHandlers={},r.isDevice=!1,r.customFilterOperators=i,r.isExcel=!0,r}return ra(h,e),h.prototype.getCMenuDS=function(e,t){var i={number:["Equal","NotEqual","","LessThan","LessThanOrEqual","GreaterThan","GreaterThanOrEqual","Between","","CustomFilter"],string:["Equal","NotEqual","","StartsWith","EndsWith","","Contains","","CustomFilter"]};i.date=i.number,i.datetime=i.number;for(var r=[],n=0;n<i[e].length;n++)i[e][n].length?t?r.push({text:this.getLocalizedLabel(i[e][n])+"...",iconCss:"e-icons e-icon-check "+(t===i[e][n].toLowerCase()?"":"e-emptyicon")}):r.push({text:this.getLocalizedLabel(i[e][n])+"..."}):r.push({separator:!0});return r},h.prototype.destroy=function(){if(this.dlg&&(this.unwireExEvents(),e.prototype.closeDialog.call(this)),!this.isDevice&&this.menuObj){var t=this.menuObj.element.querySelector("li.e-focused");t&&D(t,"e-excel-menu")||this.destroyCMenu()}this.dlgObj&&!this.dlgObj.isDestroyed&&this.removeDialog()},h.prototype.createMenu=function(e,t,i,r){this.menu=this.parent.createElement("div",{className:"e-contextmenu-wrapper"}),this.parent.enableRtl?this.menu.classList.add("e-rtl"):this.menu.classList.remove("e-rtl");var n=this.parent.createElement("ul"),o=t?"e-excl-filter-icon e-filtered":"e-excl-filter-icon";if(this.parent.allowSorting&&"grid"===this.parent.getModuleName()&&!this.options.isResponsiveFilter){var s=this.parent.getColumnHeaderByUid(r.uid).getAttribute("aria-sort"),l=this.parent.getColumnByField(r.field).allowSorting,a=l&&"ascending"!==s?"e-excel-ascending":"e-disabled e-excel-ascending",h=l&&"descending"!==s?"e-excel-descending":"e-disabled e-excel-descending",d="string"===e?this.getLocalizedLabel("SortAtoZ"):"datetime"===e||"date"===e?this.getLocalizedLabel("SortByOldest"):this.getLocalizedLabel("SortSmallestToLargest"),p="string"===e?this.getLocalizedLabel("SortZtoA"):"datetime"===e||"date"===e?this.getLocalizedLabel("SortByNewest"):this.getLocalizedLabel("SortLargestToSmallest");n.appendChild(this.createMenuElem(d,a,"e-sortascending")),n.appendChild(this.createMenuElem(p,h,"e-sortdescending"));var c=this.parent.createElement("li",{className:"e-separator e-menu-item e-excel-separator"});n.appendChild(c)}this.options.isResponsiveFilter||n.appendChild(this.createMenuElem(this.getLocalizedLabel("ClearFilter"),t?"":"e-disabled",o)),"boolean"!==e&&n.appendChild(this.createMenuElem(this.getLocalizedLabel({string:"TextFilter",date:"DateFilter",datetime:"DateTimeFilter",number:"NumberFilter"}[e]),"e-submenu",i&&this.ensureTextFilter()?"e-icon-check":o+" e-emptyicon",!0)),this.menu.appendChild(n),this.parent.notify(fn,{element:this.menu}),this.parent.notify(go,{isFiltered:t})},h.prototype.createMenuElem=function(e,t,i,r){var n=this.parent.createElement("li",{className:t+" e-menu-item"});return n.innerHTML=e,n.insertBefore(this.parent.createElement("span",{className:"e-menu-icon e-icons "+i}),n.firstChild),r&&n.appendChild(this.parent.createElement("span",{className:"e-icons e-caret"})),n},h.prototype.wireExEvents=function(){t.EventHandler.add(this.dlg,"mouseover",this.hoverHandler,this),t.EventHandler.add(this.dlg,"click",this.clickExHandler,this)},h.prototype.unwireExEvents=function(){t.EventHandler.remove(this.dlg,"mouseover",this.hoverHandler),t.EventHandler.remove(this.dlg,"click",this.clickExHandler)},h.prototype.clickExHandler=function(e){var t=D(e.target,"e-menu-item");t&&(this.getLocalizedLabel("ClearFilter")===t.innerText.trim()?(this.clearFilter(),this.closeDialog()):this.options.isResponsiveFilter&&this.getLocalizedLabel({string:"TextFilter",date:"DateFilter",datetime:"DateTimeFilter",number:"NumberFilter"}[this.options.type])===t.innerText.trim()&&this.hoverHandler(e))},h.prototype.destroyCMenu=function(){this.isCMenuOpen=!1,this.menuObj&&!this.menuObj.isDestroyed&&(this.menuObj.destroy(),t.remove(this.cmenu),this.parent.notify(fo,{target:null,header:"",isOpen:!1,col:this.options.column}))},h.prototype.hoverHandler=function(e){if(!this.options.isResponsiveFilter||"mouseover"!==e.type){var i,r=e.target.querySelector(".e-contextmenu"),n=D(e.target,"e-menu-item"),o=this.menu.querySelector(".e-focused");if(o&&o.classList.remove("e-focused"),n&&(n.classList.add("e-focused"),i=n.classList.contains("e-submenu")),!r){if(!i){var s=this.menu.querySelector(".e-submenu");t.isNullOrUndefined(s)||s.classList.remove("e-selected"),this.destroyCMenu()}var l=this.ensureTextFilter();if(!this.isCMenuOpen&&i){n.classList.add("e-selected"),this.isCMenuOpen=!0;var h={items:this.getCMenuDS(this.options.type,l?l.replace(/\s/g,""):void 0),select:this.selectHandler.bind(this),onClose:this.destroyCMenu.bind(this),enableRtl:this.parent.enableRtl,beforeClose:this.preventClose.bind(this),cssClass:this.options.isResponsiveFilter?"e-res-contextmenu-wrapper":""};this.parent.element.appendChild(this.cmenu),this.menuObj=new a.ContextMenu(h,this.cmenu);var d=this.menu.querySelector(".e-submenu").getBoundingClientRect(),p={top:0,left:0};if(this.options.isResponsiveFilter){var c=document.querySelector(".e-responsive-dialog > .e-dlg-header-content").offsetHeight+4;this.menuObj.element.style.height="calc(100% - "+c+"px)",this.menuObj.open(c,0,document.body);var u=this.getLocalizedLabel({string:"TextFilter",date:"DateFilter",datetime:"DateTimeFilter",number:"NumberFilter"}[this.options.type]);this.parent.notify(fo,{target:this.menuObj.element.parentElement,header:u,isOpen:!0})}else{if(t.Browser.isDevice){this.isDevice=!0;var g=this.getContextBounds();p.top=(window.innerHeight-g.height)/2,p.left=(window.innerWidth-g.width)/2,this.closeDialog(),this.isDevice=!1}else p.top=t.Browser.isIE?window.pageYOffset+d.top:window.scrollY+d.top,p.left=this.getCMenuYPosition(this.dlg);this.menuObj.open(p.top,p.left,e.target)}ve(this.parent.element,this.menuObj.element.parentElement)}}}},h.prototype.ensureTextFilter=function(){var e,t=this.existingPredicate[this.options.field];return t&&2===t.length?e="greaterthanorequal"===t[0].operator&&"lessthanorequal"===t[1].operator?"between":"customfilter":t&&1===t.length&&(this.optrData=this.customFilterOperators[this.options.type+"Operator"],e=t[0].operator),e},h.prototype.preventClose=function(e){if(this.options&&this.options.isResponsiveFilter&&e.event){var t=e.event.target,i=t.classList.contains("e-resfilterback")||t.classList.contains("e-res-back-btn")||t.classList.contains("e-menu-item");e.cancel=!i}else e.event instanceof MouseEvent&&e.event.target.classList.contains("e-submenu")&&(e.cancel=!0)},h.prototype.getContextBounds=function(){return this.menuObj.element.style.display="block",this.menuObj.element.getBoundingClientRect()},h.prototype.getCMenuYPosition=function(e){var t=this.getContextBounds().width,i=e.getBoundingClientRect(),r=i.right+t-this.parent.element.clientWidth,n=e.offsetWidth-e.clientWidth;return n=n?n+1:0,r<1?i.right+1-n:i.left-t-1+n},h.prototype.openDialog=function(e){var t=this;if(this.updateModel(e),this.getAndSetChkElem(e),this.showDialog(e),!e.cancel){this.dialogObj.dataBind();var i=this.existingPredicate[e.field]&&this.existingPredicate[e.field].length||this.options.filteredColumns.filter(function(e){return t.options.field===e.field}).length;this.createMenu(e.type,i>0,1===i||2===i,e),this.dlg.insertBefore(this.menu,this.dlg.firstChild),this.dlg.classList.add("e-excelfilter"),this.parent.enableRtl&&this.dlg.classList.add("e-rtl"),this.dlg.classList.remove("e-checkboxfilter"),this.cmenu=this.parent.createElement("ul",{className:"e-excel-menu"}),e.column.showColumnMenu&&this.parent.notify(Ar,{}),this.wireExEvents()}},h.prototype.closeDialog=function(){this.destroy()},h.prototype.selectHandler=function(e){e.item&&(this.parent.notify(mo,{}),this.menuItem=e.item,this.renderDialogue(e))},h.prototype.renderDialogue=function(e){var i=this,n=e?e.element:void 0,o=this.options.field,s=!t.isNullOrUndefined(o)&&j(o),l=!t.isNullOrUndefined(o)&&V(o),a=this.parent.createElement("div",{className:"e-xlfl-maindiv",id:s?l+"-xlflmenu":o+"-xlflmenu"});if(this.dlgDiv=this.parent.createElement("div",{className:"e-xlflmenu",id:s?l+"-xlfldlg":o+"-xlfldlg"}),this.options.isResponsiveFilter){document.querySelector(".e-resfilter > .e-dlg-content > .e-xl-customfilterdiv").appendChild(this.dlgDiv)}else this.parent.element.appendChild(this.dlgDiv);this.dlgObj=new r.Dialog({header:this.getLocalizedLabel("CustomFilter"),isModal:!0,overlayClick:this.removeDialog.bind(this),showCloseIcon:!0,closeOnEscape:!1,target:document.body,visible:!1,enableRtl:this.parent.enableRtl,open:function(){var e=i.dlgObj.element.querySelector("table.e-xlfl-table>tr");i.options.column.filterTemplate&&e.querySelector("#"+i.options.column.field+"-xlfl-frstvalue").focus()},close:this.removeDialog.bind(this),created:this.createdDialog.bind(this,n,o),buttons:[{click:this.filterBtnClick.bind(this,o),buttonModel:{content:this.getLocalizedLabel("OKButton"),isPrimary:!0,cssClass:"e-xlfl-okbtn"}},{click:this.removeDialog.bind(this),buttonModel:{content:this.getLocalizedLabel("CancelButton"),cssClass:"e-xlfl-cancelbtn"}}],content:a,width:430,animationSettings:{effect:"None"}});this.dlgObj.isStringTemplate=!0,this.renderResponsiveDialog(),this.dlgDiv.setAttribute("aria-label",this.getLocalizedLabel("CustomFilterDialogARIA")),this.childRefs.push(this.dlgObj),this.dlgObj.appendTo(this.dlgDiv)},h.prototype.renderResponsiveDialog=function(){if(this.options.isResponsiveFilter){var e=document.querySelector(".e-row-responsive-filter");e&&e.classList.remove("e-row-responsive-filter"),this.dlgObj.buttons=[{}],this.dlgObj.header=void 0,this.dlgObj.position={X:"",Y:""},this.dlgObj.target=document.querySelector(".e-resfilter > .e-dlg-content > .e-xl-customfilterdiv"),this.dlgObj.width="100%",this.dlgObj.isModal=!1,this.dlgObj.showCloseIcon=!1}},h.prototype.removeDialog=function(){this.parent.notify(yo,{}),(this.parent.isReact||this.parent.isVue)&&void 0!==this.parent.destroyTemplate&&Je(this.parent,["filterTemplate"]),this.removeObjects(this.childRefs),t.remove(this.dlgDiv),this.parent.notify(co,{})},h.prototype.createdDialog=function(e,i){if(this.renderCustomFilter(e,i),this.dlgObj.element.style.left="0px",this.options.isResponsiveFilter){var r=document.querySelector(".e-responsive-dialog > .e-dlg-header-content").offsetHeight+4;this.dlgObj.element.style.top=r+"px"}else this.dlgObj.element.style.top="0px";!this.options.isResponsiveFilter&&t.Browser.isDevice&&window.innerWidth<440&&(this.dlgObj.element.style.width="90%"),this.parent.notify(hn,{column:i,dialog:this.dialogObj}),this.dlgObj.show(),ve(this.parent.element,this.dlgObj.element.parentElement)},h.prototype.renderCustomFilter=function(e,t){var i=this.dlgObj.element.querySelector(".e-xlfl-maindiv"),r=this.parent.createElement("div",{innerHTML:this.getLocalizedLabel("ShowRowsWhere"),className:"e-xlfl-dlgfields"});i.appendChild(r);var n=this.parent.createElement("div",{innerHTML:this.options.displayName,className:"e-xlfl-fieldset"});i.appendChild(n),this.renderFilterUI(t,i)},h.prototype.filterBtnClick=function(e){var i,r=!t.isNullOrUndefined(e)&&j(e),n=!t.isNullOrUndefined(e)&&V(e),o=r?n:e,s=this.dlgDiv.querySelector("#"+o+"-xlfl-frstvalue").ej2_instances[0],l=this.dlgDiv.querySelector("#"+o+"-xlfl-frstoptr").ej2_instances[0],a=this.dlgDiv.querySelector("#"+o+"-xlfl-secndvalue").ej2_instances[0],h=this.dlgDiv.querySelector("#"+o+"-xlfl-secndoptr").ej2_instances[0];if("string"===this.options.type){i=this.dlgDiv.querySelector("#"+o+"-xlflmtcase").ej2_instances[0].checked}var d=this.dlgDiv.querySelector("#"+o+"e-xlfl-frstpredicate").ej2_instances[0].checked?"and":"or";null===a.value&&(d="or"),this.filterByColumn(this.options.field,l.value,s.value,d,i,this.options.ignoreAccent,h.value,a.value),this.removeDialog()},h.prototype.filterByColumn=function(e,r,n,o,s,l,a,h){var d,p=this.parent.getColumnByField?this.parent.getColumnByField(e):this.options.column,c=this.isForeignColumn(p)?p.foreignKeyValue:e,u=[];u.push({field:c,predicate:o,matchCase:s,ignoreAccent:l,operator:r,value:n,type:this.options.type});var g={instance:this,handler:this.filterByColumn,arg1:e,arg2:r,arg3:n,arg4:o,arg5:s,arg6:l,arg7:a,arg8:h,cancel:!1};if(this.parent.notify(gn,g),!g.cancel){d=new i.Predicate(c,r.toLowerCase(),n,!s,l),t.isNullOrUndefined(h)||t.isNullOrUndefined(a)||(u.push({field:c,predicate:o,matchCase:s,ignoreAccent:l,operator:a,value:h,type:this.options.type}),d=d[o](c,a.toLowerCase(),h,!s,l));var f={action:"filtering",filterCollection:u,field:this.options.field,ejpredicate:d,actualPredicate:u};this.isForeignColumn(p)?this.foreignKeyFilter(f,u,d):this.options.handler(f)}},h.prototype.renderOperatorUI=function(e,i,r,n,o){var l=this.parent.createElement("tr",{className:"e-xlfl-fields"});i.appendChild(l);var a=this.parent.createElement("td",{className:"e-xlfl-optr"});l.appendChild(a);var h=this.parent.createElement("div",{className:"e-xlfl-optrdiv"}),d=!t.isNullOrUndefined(e)&&j(e),p=!t.isNullOrUndefined(e)&&V(e),c=this.parent.createElement("input",{id:d?p+r:e+r});h.appendChild(c),a.appendChild(h);var u=this.options.type+"Operator",g=this.customFilterOperators[u];this.optrData=g;var f=this.dropSelectedVal(this.options.column,n,o),m="";this.menuItem&&((m=this.menuItem.text.slice(0,-3))!==this.getLocalizedLabel("CustomFilter")&&(f=o?m:void 0),m===this.getLocalizedLabel("Between")&&(f=this.getLocalizedLabel(o?"GreaterThanOrEqual":"LessThanOrEqual")));var y=this.options.column,v=new s.DropDownList(F({dataSource:g,fields:{text:"text",value:"value"},text:f,enableRtl:this.parent.enableRtl},y.filter.params));this.childRefs.push(v);var C={open:this.dropDownOpen.bind(this),change:this.dropDownValueChange.bind(this)};Xe(c.id,[ms,ys],C,this),v.addEventListener(ms,this.eventHandlers[c.id].open),v.addEventListener(ys,this.eventHandlers[c.id][ys]),v.appendTo(c);return{fieldElement:l,operator:this.getSelectedValue(f)}},h.prototype.removeHandlersFromComponent=function(e){e.element.classList.contains("e-dropdownlist")?Ye(e,[ms,ys],this):e.element.classList.contains("e-autocomplete")&&Ye(e,[Dt,vs],this)},h.prototype.dropDownOpen=function(e){e.popup.element.style.zIndex=(this.dialogObj.zIndex+1).toString()},h.prototype.dropDownValueChange=function(e){e.element.id.includes("-xlfl-frstoptr")?this.firstOperator=e.value.toString():this.secondOperator=e.value.toString()},h.prototype.getFilterUIInfo=function(){return{firstOperator:this.firstOperator,secondOperator:this.secondOperator,field:this.options.field}},h.prototype.getSelectedValue=function(e){var r=new i.DataManager(this.optrData).executeLocal((new i.Query).where("text","equal",e));return t.isNullOrUndefined(r[0])?"":r[0].value},h.prototype.dropSelectedVal=function(e,t,i){var r;return r=t&&t.length>0?2===t.length?i?t[0].operator:t[1].operator:i?t[0].operator:void 0:i&&"string"===e.type&&!e.filter.operator?"startswith":i?e.filter.operator||"equal":void 0,this.getSelectedText(r)},h.prototype.getSelectedText=function(e){var r=new i.DataManager(this.optrData).executeLocal((new i.Query).where("value","equal",e));return t.isNullOrUndefined(r[0])?"":r[0].text},h.prototype.renderFilterUI=function(e,t){var i=this.existingPredicate[e],r=this.parent.createElement("table",{className:"e-xlfl-table"});t.appendChild(r);var n=this.parent.createElement(fs);n.innerHTML='<col style="width: 50%"></col><col style="width: 50%"></col>',r.appendChild(n);var o=this.renderOperatorUI(e,r,"-xlfl-frstoptr",i,!0);this.firstOperator=o.operator,this.renderFlValueUI(e,o,"-xlfl-frstvalue",i,!0);var s=this.parent.createElement("tr",{className:"e-xlfl-predicate"});r.appendChild(s),this.renderRadioButton(e,s,i),o=this.renderOperatorUI(e,r,"-xlfl-secndoptr",i,!1),this.secondOperator=o.operator,this.renderFlValueUI(e,o,"-xlfl-secndvalue",i,!1)},h.prototype.renderRadioButton=function(e,i,r){var o=this.parent.createElement("td",{className:"e-xlfl-radio",attrs:{colSpan:"2"}});i.appendChild(o);var s=this.parent.createElement("div",{className:"e-xlfl-radiodiv",attrs:{style:"display: inline-block"}}),l=!t.isNullOrUndefined(e)&&j(e),a=!t.isNullOrUndefined(e)&&V(e),h=this.parent.createElement("input",{id:l?a+"e-xlfl-frstpredicate":e+"e-xlfl-frstpredicate",attrs:{type:"radio"}}),d=this.parent.createElement("input",{id:l?a+"e-xlfl-secndpredicate":e+"e-xlfl-secndpredicate",attrs:{type:"radio"}});s.appendChild(h),s.appendChild(d),o.appendChild(s),"string"===this.options.type&&this.renderMatchCase(e,i,o,"-xlflmtcase",r);var p=new n.RadioButton({label:this.getLocalizedLabel("AND"),name:"default",checked:!0,enableRtl:this.parent.enableRtl});this.childRefs.push(p);var c=new n.RadioButton({label:this.getLocalizedLabel("OR"),name:"default",enableRtl:this.parent.enableRtl});this.childRefs.push(c);"and"===(r&&2===r.length?r[1].predicate:"and")?(p.checked=!0,c.checked=!1):(c.checked=!0,p.checked=!1),p.appendTo(h),c.appendTo(d),p.element.nextElementSibling.classList.add("e-xlfl-radio-and"),c.element.nextElementSibling.classList.add("e-xlfl-radio-or")},h.prototype.removeObjects=function(e){for(var t=0,i=e;t<i.length;t++){var r=i[t];r&&!r.isDestroyed&&(this.removeHandlersFromComponent(r),r.destroy())}},h.prototype.renderFlValueUI=function(e,i,r,n,o){var s=this.parent.createElement("td",{className:"e-xlfl-value"});i.fieldElement.appendChild(s);var l=!t.isNullOrUndefined(e)&&j(e),a=!t.isNullOrUndefined(e)&&V(e),h=this.parent.createElement("div",{className:"e-xlfl-valuediv"}),d=this.options.filteredColumns.some(function(t){return e===t.field}),p=this.options.filteredColumns.filter(function(t){return t.field===e});if(this.options.column.filterTemplate){var c={},u=this.options.column;d&&r&&(c=this.getExcelFilterData(r,c,u,n,p));var g=this.parent.isReact&&"string"!=typeof this.options.column.filterTemplate,f=this.parent.element.id+u.uid+"filterTemplate";if(g)this.options.column.getFilterTemplate()(c,this.parent,"filterTemplate",f,null,null,h),this.parent.renderTemplates();else{P(h,this.options.column.getFilterTemplate()(c,this.parent,"filterTemplate",f))}(this.parent.isAngular?h.children[0]:h.querySelector("input")).id=l?a+r:e+r,s.appendChild(h)}else{var m=this.parent.createElement("input",{id:l?a+r:e+r});h.appendChild(m),s.appendChild(h);var y=void 0,v=void 0;n&&n.length>0&&(y=(v=2===n.length?o?n[0]:n[1]:o?n[0]:void 0)&&v.operator===i.operator?v.value:void 0,t.isNullOrUndefined(y)&&(y=void 0));({string:this.renderAutoComplete.bind(this),number:this.renderNumericTextBox.bind(this),date:this.renderDate.bind(this),datetime:this.renderDateTime.bind(this)})[this.options.type](this.options,e,m,y,this.parent.enableRtl)}},h.prototype.getExcelFilterData=function(e,t,i,r,n){var o="-xlfl-frstvalue"===e?0:1;if("-xlfl-frstvalue"===e||n.length>1){t={column:r instanceof Array?r[o]:r};var s=this.options.column.columnData&&n.length>1?1===this.options.column.columnData.length?0:1:o;t[this.options.field]=i.foreignKeyValue?this.options.column.columnData[s][i.foreignKeyValue]:n[s].value,this.options.foreignKeyValue&&(t[this.options.foreignKeyValue]=this.options.column.columnData[s][i.foreignKeyValue])}return t},h.prototype.renderMatchCase=function(e,i,r,o,s){var l=this.parent.createElement("div",{className:"e-xlfl-matchcasediv",attrs:{style:"display: inline-block"}}),a=!t.isNullOrUndefined(e)&&j(e),h=!t.isNullOrUndefined(e)&&V(e),d=this.parent.createElement("input",{id:a?h+o:e+o,attrs:{type:"checkbox"}});l.appendChild(d),r.appendChild(l);var p=!!(s&&s.length>0)&&(s&&2===s.length?s[1].matchCase:s[0].matchCase),c=new n.CheckBox({label:this.getLocalizedLabel("MatchCase"),enableRtl:this.parent.enableRtl,checked:p});this.childRefs.push(c),c.appendTo(d)},h.prototype.renderDate=function(e,t,i,r,n){var o=de(e.format,e.type)||e.format,s=new l.DatePicker(F({format:o,cssClass:"e-popup-flmenu",placeholder:this.getLocalizedLabel("CustomFilterDatePlaceHolder"),width:"100%",enableRtl:n,value:new Date(r),locale:this.parent.locale},e.column.filter.params));this.childRefs.push(s),s.appendTo(i)},h.prototype.renderDateTime=function(e,t,i,r,n){var o=de(e.format,e.type),s=new l.DateTimePicker(F({format:o,cssClass:"e-popup-flmenu",placeholder:this.getLocalizedLabel("CustomFilterDatePlaceHolder"),width:"100%",enableRtl:n,value:new Date(r),locale:this.parent.locale},e.column.filter.params));this.childRefs.push(s),s.appendTo(i)},h.prototype.completeAction=function(e){e.result=Y(e.result)},h.prototype.renderNumericTextBox=function(e,t,i,r,n){var s=new o.NumericTextBox(F({format:e.format,placeholder:this.getLocalizedLabel("CustomFilterPlaceHolder"),enableRtl:n,value:r,locale:this.parent.locale},e.column.filter.params));this.childRefs.push(s),s.appendTo(i)},h.prototype.renderAutoComplete=function(e,t,r,n,o){var l=this.options.column,a=this.isForeignColumn(l),h=a?l.dataSource:e.dataSource,d={value:a?l.foreignKeyValue:t},p=new s.AutoComplete(F({dataSource:h instanceof i.DataManager?h:new i.DataManager(h),fields:d,query:this.getQuery(),sortOrder:"Ascending",locale:this.parent.locale,cssClass:"e-popup-flmenu",autofill:!0,placeholder:this.getLocalizedLabel("CustomFilterPlaceHolder"),enableRtl:o,text:n},l.filter.params));if(h&&"result"in h){var c=xe({requestType:"stringfilterrequest"},this.getQuery());this.parent.trigger(jr,c.state);c.deffered.promise.then(function(e){p.dataSource=new i.DataManager(e)})}this.childRefs.push(p);var u={actionComplete:this.acActionComplete(p,t),focus:this.acFocus(p,t,e,r)};Xe(r.id,[Dt,vs],u,this),p.addEventListener(vs,this.eventHandlers[r.id].focus),p.addEventListener(Dt,this.eventHandlers[r.id][Dt]),p.appendTo(r)},h.prototype.acActionComplete=function(e,i){return function(r){var n=!t.isNullOrUndefined(i)&&j(i);r.result=r.result.filter(function(t,i,r){return r.map(function(t){return n?Ve(e.fields.value,t):t[e.fields.value]}).indexOf(n?Ve(e.fields.value,t):t[e.fields.value])===i})}},h.prototype.acFocus=function(e,i,r,n){var o=this;return function(){var s=!t.isNullOrUndefined(i)&&j(i),l=!t.isNullOrUndefined(i)&&V(i),a=s?l:i;e.filterType=o.dlgDiv.querySelector("#"+a+(n.id===a+"-xlfl-frstvalue"?"-xlfl-frstoptr":"-xlfl-secndoptr")).ej2_instances[0].value,e.ignoreCase="string"!==r.type||!o.dlgDiv.querySelector("#"+a+"-xlflmtcase").ej2_instances[0].checked,e.filterType=t.isNullOrUndefined(e.filterType)?"equal":e.filterType}},h}(ia),oa=function(){function i(e,t,i,r){this.contentRefresh=!0,this.isModelChanged=!0,this.aria=new Ns,this.currentTarget=null,this.parent=e,this.sortSettings=t,this.sortedColumns=i,this.serviceLocator=r,this.focus=r.getService("focus"),this.addEventListener(),this.setFullScreenDialog()}return i.prototype.updateModel=function(){var e,t={field:this.columnName,direction:this.direction},i=this.parent.groupSettings.columns,r=!1;if(this.isMultiSort)(e=this.getSortedColsIndexByField(this.columnName))>-1&&this.sortSettings.columns.splice(e,1),this.sortSettings.columns.push(t),this.sortSettings.columns=this.sortSettings.columns;else if(i.length){for(var n=[],o=0,s=i.length;o<s;o++)if(e=this.getSortedColsIndexByField(i[o],n),this.columnName===i[o])r=!0,n.push(t);else{var l=this.getSortColumnFromField(i[o]);n.push({field:l.field,direction:l.direction,isFromGroup:l.isFromGroup})}r||n.push(t),this.sortSettings.columns=n}else this.sortSettings.columns=[t];this.parent.dataBind(),this.lastSortedCol=this.columnName},i.prototype.onActionComplete=function(e){var i=this.isRemove?{requestType:"sorting",type:Dt}:{columnName:this.columnName,direction:this.direction,requestType:"sorting",type:Dt};this.isRemove=!1,this.parent.trigger(Dt,t.extend(e,i))},i.prototype.sortColumn=function(e,t,i){var r=this.parent;!1===this.parent.getColumnByField(e).allowSorting||this.parent.isContextMenuOpen()?this.parent.log("action_disabled_column",{moduleName:this.getModuleName(),columnName:e}):(r.allowMultiSorting||(i=r.allowMultiSorting),this.isActionPrevent()?r.notify(ur,{instance:this,handler:this.sortColumn,arg1:e,arg2:t,arg3:i}):(this.backupSettings(),this.columnName=e,this.direction=t,this.isMultiSort=i,this.removeSortIcons(),this.updateSortedCols(e,i),this.updateModel()))},i.prototype.setFullScreenDialog=function(){this.serviceLocator&&this.serviceLocator.registerAdaptiveService(this,this.parent.enableAdaptiveUI,e.ResponsiveDialogAction.isSort)},i.prototype.backupSettings=function(){this.lastSortedCols=S(this.sortSettings.columns),this.lastCols=this.sortedColumns},i.prototype.restoreSettings=function(){this.isModelChanged=!1,this.isMultiSort=!0,this.parent.setProperties({sortSettings:{columns:this.lastSortedCols}},!0),this.sortedColumns=this.lastCols,this.isModelChanged=!0},i.prototype.updateSortedCols=function(e,t){if(!t)if(this.parent.allowGrouping)for(var i=0,r=this.sortedColumns.length;i<r;i++)this.parent.groupSettings.columns.indexOf(this.sortedColumns[i])<0&&(this.sortedColumns.splice(i,1),r--,i--);else this.sortedColumns.splice(0,this.sortedColumns.length);this.sortedColumns.indexOf(e)<0&&this.sortedColumns.push(e)},i.prototype.onPropertyChanged=function(e){if(e.module===this.getModuleName()){if(this.contentRefresh){var t=this.sortSettings.columns.length?{columnName:this.columnName,direction:this.direction,requestType:"sorting",type:zt,target:this.currentTarget,cancel:!1}:{requestType:"sorting",type:zt,cancel:!1,target:this.currentTarget};this.parent.notify(Ti,t)}this.refreshSortSettings(),this.removeSortIcons(),this.addSortIcons()}},i.prototype.refreshSortSettings=function(){this.sortedColumns.length=0;for(var e=this.sortSettings.columns,t=0;t<e.length;t++)e[t].isFromGroup||this.sortedColumns.push(e[t].field)},i.prototype.clearSorting=function(){var e=k(this.sortSettings.columns);if(this.isActionPrevent())this.parent.notify(ur,{instance:this,handler:this.clearSorting});else for(var t=0,i=e.length;t<i;t++)this.removeSortColumn(e[t].field)},i.prototype.isActionPrevent=function(){return W(this.parent)},i.prototype.removeSortColumn=function(e){var t=this.parent,i=this.sortSettings.columns;if(!(0===i.length&&this.sortedColumns.indexOf(e)<0))if(this.isActionPrevent())this.parent.notify(ur,{instance:this,handler:this.removeSortColumn,arg1:e});else{this.backupSettings(),this.removeSortIcons();for(var r={requestType:"sorting",type:zt,target:this.currentTarget},n=0,o=i.length;n<o;n++)if(i[n].field===e){if(t.allowGrouping&&t.groupSettings.columns.indexOf(i[n].field)>-1)continue;this.sortedColumns.splice(this.sortedColumns.indexOf(i[n].field),1),i.splice(n,1),this.isRemove=!0,this.isModelChanged&&this.parent.notify(Ti,r);break}r.cancel||this.addSortIcons()}},i.prototype.getSortedColsIndexByField=function(e,t){for(var i=t||this.sortSettings.columns,r=0,n=i.length;r<n;r++)if(i[r].field===e)return r;return-1},i.prototype.getModuleName=function(){return"sort"},i.prototype.initialEnd=function(){if(this.parent.off(xi,this.initialEnd),this.parent.getColumns().length&&this.sortSettings.columns.length){var e=this.parent;this.contentRefresh=!1,this.isMultiSort=this.sortSettings.columns.length>1;for(var t=0,i=e.sortSettings.columns.slice();t<i.length;t++){var r=i[t];this.sortedColumns.indexOf(r.field)>-1&&this.sortColumn(r.field,r.direction,!0)}this.isMultiSort=!1,this.contentRefresh=!0}},i.prototype.addEventListener=function(){this.parent.isDestroyed||(this.evtHandlers=[{event:vo,handler:this.setFullScreenDialog},{event:xi,handler:this.initialEnd},{event:Oi,handler:this.onActionComplete},{event:Ii,handler:this.onPropertyChanged},{event:Wi,handler:this.clickHandler},{event:Di,handler:this.refreshSortIcons},{event:_i,handler:this.keyPressed},{event:Xr,handler:this.cancelBeginEvent},{event:Ki,handler:this.destroy}],_e(this.parent,this.evtHandlers,!0,this))},i.prototype.removeEventListener=function(){this.parent.isDestroyed||_e(this.parent,this.evtHandlers,!1)},i.prototype.destroy=function(){this.isModelChanged=!1;var e=this.parent.element;e&&(e.querySelector("."+Wo)||e.querySelector("."+Ko))&&(this.parent.element.querySelector(".e-gridpopup").getElementsByClassName("e-sortdirect").length&&(this.parent.element.querySelector(".e-gridpopup").style.display="none"),this.parent.refreshing||!this.parent.isDestroyed&&this.parent.allowSorting||this.clearSorting(),this.isModelChanged=!0,this.removeEventListener())},i.prototype.cancelBeginEvent=function(e){"sorting"===e.requestType&&(this.restoreSettings(),this.refreshSortIcons(),this.isMultiSort=!0)},i.prototype.clickHandler=function(e){var i=this.parent;this.currentTarget=null,this.popUpClickHandler(e);var r=t.closest(e.target,".e-headercell");if(r&&!e.target.classList.contains("e-grptogglebtn")&&!r.classList.contains("e-resized")&&!e.target.classList.contains("e-rhandler")&&!e.target.classList.contains("e-columnmenu")&&!e.target.classList.contains("e-filtermenudiv")&&!D(e.target,"e-stackedheadercell")&&!(i.allowSelection&&i.selectionSettings.allowColumnSelection&&e.target.classList.contains("e-headercell"))){var n=this.parent.getColumnByUid(r.querySelector(".e-headercelldiv").getAttribute("e-mappinguid"));"checkbox"!==n.type&&(this.initiateSort(r,e,n),t.Browser.isDevice&&this.showPopUp(e))}if(r&&r.classList.remove("e-resized"),D(e.target,"e-excel-ascending")||D(e.target,"e-excel-descending")){var o=t.closest(e.target,".e-filter-popup").getAttribute("uid"),s=t.isNullOrUndefined(D(e.target,"e-excel-descending"))?"Ascending":"Descending";this.sortColumn(i.getColumnByUid(o).field,s,!1)}},i.prototype.keyPressed=function(e){var i=e.target;if(!this.parent.isEdit&&("enter"===e.action||"ctrlEnter"===e.action||"shiftEnter"===e.action)&&t.closest(i,".e-headercell")){var r=this.focus.getFocusedElement();if(t.isNullOrUndefined(r)||!r.classList.contains("e-headercell")||!r.querySelector(".e-headercelldiv"))return;var n=this.parent.getColumnByUid(r.querySelector(".e-headercelldiv").getAttribute("e-mappinguid"));this.initiateSort(r,e,n)}},i.prototype.initiateSort=function(e,t,i){var r=this.parent,n=i.field;this.currentTarget=t.target;var o=e.getElementsByClassName("e-ascending").length?"Descending":"Ascending";this.isMultiSort=t.ctrlKey||this.enableSortMultiTouch||-1!==navigator.userAgent.indexOf("Mac OS")&&t.metaKey,t.shiftKey||this.sortSettings.allowUnsort&&e.getElementsByClassName("e-descending").length&&!(r.groupSettings.columns.indexOf(n)>-1)?this.removeSortColumn(n):this.sortColumn(n,o,this.isMultiSort)},i.prototype.showPopUp=function(e){var i=t.closest(e.target,".e-headercell");!this.parent.allowMultiSorting||t.isNullOrUndefined(i)&&!this.parent.isContextMenuOpen()||T(this.parent.element.querySelector(".e-gridpopup"),e,"e-sortdirect e-icons e-icon-sortdirect"+(this.sortedColumns.length>1?" e-spanclicked":""))},i.prototype.popUpClickHandler=function(e){var i=e.target;t.closest(i,".e-headercell")||e.target.classList.contains(_o)||t.closest(i,".e-gridpopup")?i.classList.contains("e-sortdirect")&&(i.classList.contains("e-spanclicked")?(i.classList.remove("e-spanclicked"),this.enableSortMultiTouch=!1,this.parent.element.querySelector(".e-gridpopup").style.display="none"):(i.classList.add("e-spanclicked"),this.enableSortMultiTouch=!0)):this.parent.element.querySelector(".e-gridpopup").style.display="none"},i.prototype.addSortIcons=function(){for(var e,i,r=this.parent,n=this.sortSettings.columns,o=this.parent.getColumns().map(function(e){return e.field}),s=0,l=n.length;s<l;s++)e=r.getColumnHeaderByField(n[s].field),-1===o.indexOf(n[s].field)||t.isNullOrUndefined(e)||(this.aria.setSort(e,n[s].direction.toLowerCase()),n.length>1&&e.querySelector(".e-headercelldiv").insertBefore(this.parent.createElement("span",{className:"e-sortnumber",innerHTML:(s+1).toString()}),e.querySelector(".e-headertext")),i=e.querySelector(".e-sortfilterdiv"),"Ascending"===n[s].direction?t.classList(i,["e-ascending","e-icon-ascending"],[]):t.classList(i,["e-descending","e-icon-descending"],[]))},i.prototype.removeSortIcons=function(e){for(var i,r=this.parent,n=this.sortSettings.columns,o=this.parent.getColumns().map(function(e){return e.field}),s=e||0,l=t.isNullOrUndefined(e)?n.length:e+1;s<l;s++)i=r.getColumnHeaderByField(n[s].field),t.isNullOrUndefined(i)||r.allowGrouping&&r.groupSettings.columns.indexOf(n[s].field)>-1&&!i.querySelector(".e-sortfilterdiv")||-1!==o.indexOf(n[s].field)&&(this.aria.setSort(i,"none"),t.classList(i.querySelector(".e-sortfilterdiv"),[],["e-descending","e-icon-descending","e-ascending","e-icon-ascending"]),i.querySelector(".e-sortnumber")&&i.querySelector(".e-headercelldiv").removeChild(i.querySelector(".e-sortnumber")))},i.prototype.getSortColumnFromField=function(e){for(var t=0,i=this.sortSettings.columns.length;t<i;t++)if(this.sortSettings.columns[t].field===e)return this.sortSettings.columns[t];return!1},i.prototype.updateAriaAttr=function(){for(var e=this.parent.getColumns().map(function(e){return e.field}),t=0,i=this.sortedColumns;t<i.length;t++){var r=i[t];if(-1!==e.indexOf(r)){var n=this.parent.getColumnHeaderByField(r);this.aria.setSort(n,this.getSortColumnFromField(r).direction)}}},i.prototype.refreshSortIcons=function(e){void 0===e&&(e={args:{isFrozen:!1}}),e.args.isFrozen||(this.removeSortIcons(),this.isMultiSort=!0,this.removeSortIcons(),this.addSortIcons(),this.isMultiSort=!1,this.updateAriaAttr())},i.prototype.showCustomSort=function(e){this.responsiveDialogRenderer.isCustomDialog=e,this.responsiveDialogRenderer.showResponsiveDialog()},i}(),sa=function(){function e(e){this.pagerModule=e}return e.prototype.render=function(){this.pagerElement=this.pagerModule.element,this.renderNumericContainer(),this.refreshNumericLinks(),this.wireEvents()},e.prototype.refresh=function(){this.pagerModule.updateTotalPages(),this.links.length&&this.updateLinksHtml(),this.updateStyles()},e.prototype.refreshNumericLinks=function(){var e,i=this.pagerModule,r=i.element.querySelector(".e-numericcontainer"),n=document.createDocumentFragment();r.innerHTML="";for(var o=1;o<=i.pageCount;o++)e=t.createElement("a",{className:"e-link e-numericitem e-spacing e-pager-default",attrs:{role:"link",tabindex:"-1","aria-label":"Goto Page "+o,href:"javascript:void(0);",name:"Goto page"+o}}),i.currentPage===o&&t.classList(e,["e-currentitem","e-active"],["e-pager-default"]),n.appendChild(e);r.appendChild(n),this.links=[].slice.call(r.childNodes)},e.prototype.wireEvents=function(){t.EventHandler.add(this.pagerElement,"click",this.clickHandler,this)},e.prototype.unwireEvents=function(){t.EventHandler.remove(this.pagerModule.element,"click",this.clickHandler)},e.prototype.destroy=function(){this.unwireEvents()},e.prototype.renderNumericContainer=function(){this.element=t.createElement("div",{className:"e-pagercontainer",attrs:{role:"navigation"}}),this.renderFirstNPrev(this.element),this.renderPrevPagerSet(this.element),this.element.appendChild(t.createElement("div",{className:"e-numericcontainer"})),this.renderNextPagerSet(this.element),this.renderNextNLast(this.element),this.pagerModule.element.appendChild(this.element)},e.prototype.renderFirstNPrev=function(e){this.first=t.createElement("div",{className:"e-first e-icons e-icon-first",attrs:{title:this.pagerModule.getLocalizedLabel("firstPageTooltip"),"aria-label":this.pagerModule.getLocalizedLabel("firstPageTooltip"),tabindex:"-1"}}),this.prev=t.createElement("div",{className:"e-prev e-icons e-icon-prev",attrs:{title:this.pagerModule.getLocalizedLabel("previousPageTooltip"),"aria-label":this.pagerModule.getLocalizedLabel("previousPageTooltip"),tabindex:"-1"}}),t.append([this.first,this.prev],e)},e.prototype.renderPrevPagerSet=function(e){var i=t.createElement("div");this.PP=t.createElement("a",{className:"e-link e-pp e-spacing",innerHTML:"...",attrs:{title:this.pagerModule.getLocalizedLabel("previousPagerTooltip"),role:"link","aria-label":this.pagerModule.getLocalizedLabel("previousPagerTooltip"),tabindex:"-1",name:this.pagerModule.getLocalizedLabel("previousPagerTooltip"),href:"javascript:void(0);"}}),i.appendChild(this.PP),e.appendChild(i)},e.prototype.renderNextPagerSet=function(e){var i=t.createElement("div");this.NP=t.createElement("a",{className:"e-link e-np e-spacing",innerHTML:"...",attrs:{title:this.pagerModule.getLocalizedLabel("nextPagerTooltip"),role:"link","aria-label":this.pagerModule.getLocalizedLabel("nextPagerTooltip"),tabindex:"-1",name:this.pagerModule.getLocalizedLabel("nextPagerTooltip"),href:"javascript:void(0);"}}),i.appendChild(this.NP),e.appendChild(i)},e.prototype.renderNextNLast=function(e){this.next=t.createElement("div",{className:"e-next e-icons e-icon-next",attrs:{title:this.pagerModule.getLocalizedLabel("nextPageTooltip"),"aria-label":this.pagerModule.getLocalizedLabel("nextPageTooltip"),tabindex:"-1"}}),this.last=t.createElement("div",{className:"e-last e-icons e-icon-last",attrs:{title:this.pagerModule.getLocalizedLabel("lastPageTooltip"),"aria-label":this.pagerModule.getLocalizedLabel("lastPageTooltip"),tabindex:"-1"}}),t.append([this.next,this.last],e)},e.prototype.clickHandler=function(e){var i=this.pagerModule,r=e.target;return i.previousPageNo=i.currentPage,r.classList.contains("e-disable")||t.isNullOrUndefined(r.getAttribute("index"))||(i.currentPage=parseInt(r.getAttribute("index"),10),i.dataBind()),!1},e.prototype.updateLinksHtml=function(){var e,i,r=this.pagerModule;r.currentPage=1===r.totalPages?1:r.currentPage,r.currentPage>r.totalPages&&r.totalPages&&(r.currentPage=r.totalPages),e=parseInt((r.currentPage/r.pageCount).toString(),10),r.currentPage%r.pageCount==0&&e>0&&(e-=1);for(var n=0;n<r.pageCount;n++)(i=e*r.pageCount+1+n)<=r.totalPages?(this.links[n].style.display="",this.links[n].setAttribute("index",i.toString()),this.links[n].innerHTML=r.customText?r.customText+i:i.toString(),r.currentPage!==i?this.links[n].classList.add("e-pager-default"):this.links[n].classList.remove("e-pager-default")):(this.links[n].innerHTML=r.customText?r.customText+i:i.toString(),this.links[n].style.display="none"),t.classList(this.links[n],[],["e-currentitem","e-active"]);this.first.setAttribute("index","1"),this.last.setAttribute("index",r.totalPages.toString()),this.prev.setAttribute("index",(r.currentPage-1).toString()),this.next.setAttribute("index",(r.currentPage+1).toString()),this.pagerElement.querySelector(".e-mfirst").setAttribute("index","1"),this.pagerElement.querySelector(".e-mlast").setAttribute("index",r.totalPages.toString()),this.pagerElement.querySelector(".e-mprev").setAttribute("index",(r.currentPage-1).toString()),this.pagerElement.querySelector(".e-mnext").setAttribute("index",(r.currentPage+1).toString()),this.PP.setAttribute("index",(parseInt(this.links[0].getAttribute("index"),10)-r.pageCount).toString()),this.NP.setAttribute("index",(parseInt(this.links[this.links.length-1].getAttribute("index"),10)+1).toString())},e.prototype.updateStyles=function(){this.updateFirstNPrevStyles(),this.updatePrevPagerSetStyles(),this.updateNextPagerSetStyles(),this.updateNextNLastStyles(),this.links.length&&t.classList(this.links[(this.pagerModule.currentPage-1)%this.pagerModule.pageCount],["e-currentitem","e-active"],[])},e.prototype.updateFirstNPrevStyles=function(){var e=["e-firstpage","e-pager-default"],i=["e-firstpagedisabled","e-disable"],r=["e-prevpage","e-pager-default"],n=["e-prevpagedisabled","e-disable"];this.pagerModule.totalPages>0&&this.pagerModule.currentPage>1?(t.classList(this.prev,r,n),t.classList(this.first,e,i),t.classList(this.pagerElement.querySelector(".e-mfirst"),e,i),t.classList(this.pagerElement.querySelector(".e-mprev"),r,n)):(t.classList(this.prev,n,r),t.classList(this.first,i,e),t.classList(this.pagerElement.querySelector(".e-mprev"),n,r),t.classList(this.pagerElement.querySelector(".e-mfirst"),i,e))},e.prototype.updatePrevPagerSetStyles=function(){this.pagerModule.currentPage>this.pagerModule.pageCount?t.classList(this.PP,["e-numericitem","e-pager-default"],["e-nextprevitemdisabled","e-disable"]):t.classList(this.PP,["e-nextprevitemdisabled","e-disable"],["e-numericitem","e-pager-default"])},e.prototype.updateNextPagerSetStyles=function(){var e=this.pagerModule,i=this.links[0].innerHTML.replace(e.customText,"");!i.length||!this.links.length||parseInt(i,10)+e.pageCount>e.totalPages?t.classList(this.NP,["e-nextprevitemdisabled","e-disable"],["e-numericitem","e-pager-default"]):t.classList(this.NP,["e-numericitem","e-pager-default"],["e-nextprevitemdisabled","e-disable"])},e.prototype.updateNextNLastStyles=function(){var e=["e-lastpage","e-pager-default"],i=["e-lastpagedisabled","e-disable"],r=["e-nextpage","e-pager-default"],n=["e-nextpagedisabled","e-disable"],o=this.pagerModule;o.currentPage===o.totalPages||0===o.totalRecordsCount?(t.classList(this.last,i,e),t.classList(this.next,n,r),t.classList(this.pagerElement.querySelector(".e-mlast"),i,e),t.classList(this.pagerElement.querySelector(".e-mnext"),n,r)):(t.classList(this.last,e,i),t.classList(this.next,r,n),t.classList(this.pagerElement.querySelector(".e-mlast"),e,i),t.classList(this.pagerElement.querySelector(".e-mnext"),r,n))},e}(),la=function(){function e(e){this.pagerModule=e}return e.prototype.render=function(){var e=t.createElement("div",{className:"e-parentmsgbar",attrs:{"aria-label":"Pager Information"}});this.pageNoMsgElem=t.createElement("span",{className:"e-pagenomsg",styles:"textalign:right"}),this.pageCountMsgElem=t.createElement("span",{className:"e-pagecountmsg",styles:"textalign:right"}),t.append([this.pageNoMsgElem,this.pageCountMsgElem],e),this.pagerModule.element.appendChild(e),this.refresh()},e.prototype.refresh=function(){var e=this.pagerModule;this.pageNoMsgElem.textContent=this.format(e.getLocalizedLabel("currentPageInfo"),[0===e.totalRecordsCount?0:e.currentPage,e.totalPages||0,e.totalRecordsCount||0])+" ",this.pageCountMsgElem.textContent=this.format(e.getLocalizedLabel(e.totalRecordsCount<=1?"totalItemInfo":"totalItemsInfo"),[e.totalRecordsCount||0,e.totalRecordsCount?e.pageSize*(e.currentPage-1)+1:0,e.pageSize*e.currentPage>e.totalRecordsCount?e.totalRecordsCount:e.pageSize*e.currentPage]),this.pageNoMsgElem.parentElement.setAttribute("aria-label",this.pageNoMsgElem.textContent+this.pageCountMsgElem.textContent)},e.prototype.hideMessage=function(){this.pageNoMsgElem&&(this.pageNoMsgElem.style.display="none"),this.pageCountMsgElem&&(this.pageCountMsgElem.style.display="none")},e.prototype.showMessage=function(){this.pageNoMsgElem||this.render(),this.pageNoMsgElem.style.display="",this.pageCountMsgElem.style.display=""},e.prototype.destroy=function(){},e.prototype.format=function(e,t){for(var i,r=0;r<t.length;r++)i=new RegExp("\\{"+r+"\\}","gm"),e=e.replace(i,t[r].toString());return e},e}(),aa=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),ha=function(e,t,i,r){var n,o=arguments.length,s=o<3?t:null===r?r=Object.getOwnPropertyDescriptor(t,i):r;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,i,r);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(o<3?n(s):o>3?n(t,i,s):n(t,i))||s);return o>3&&s&&Object.defineProperty(t,i,s),s},da=function(e){function i(t,i){var r=e.call(this,t,i)||this;return r.hasParent=!1,r.pageRefresh="pager-refresh",r}return aa(i,e),i.prototype.requiredModules=function(){var e=[];return this.enableExternalMessage&&e.push({member:"externalMessage",args:[this]}),this.checkpagesizes()&&e.push({member:"pagerdropdown",args:[this]}),e},i.prototype.preRender=function(){this.defaultConstants={currentPageInfo:"{0} of {1} pages",totalItemsInfo:"({0} items)",totalItemInfo:"({0} item)",firstPageTooltip:"Go to first page",lastPageTooltip:"Go to last page",nextPageTooltip:"Go to next page",previousPageTooltip:"Go to previous page",nextPagerTooltip:"Go to next pager",previousPagerTooltip:"Go to previous pager",pagerDropDown:"Items per page",pagerAllDropDown:"Items",CurrentPageInfo:"{0} of {1} pages",TotalItemsInfo:"({0} items)",FirstPageTooltip:"Go to first page",LastPageTooltip:"Go to last page",NextPageTooltip:"Go to next page",PreviousPageTooltip:"Go to previous page",NextPagerTooltip:"Go to next pager",PreviousPagerTooltip:"Go to previous pager",PagerDropDown:"Items per page",PagerAllDropDown:"Items",All:"All"},this.containerModule=new sa(this),this.pagerMessageModule=new la(this)},i.prototype.render=function(){this.template?this.isReactTemplate()?(this.on(this.pageRefresh,this.pagerTemplate,this),this.notify(this.pageRefresh,{})):this.pagerTemplate():(this.initLocalization(),this.updateRTL(),this.totalRecordsCount=this.totalRecordsCount||0,this.renderFirstPrevDivForDevice(),this.containerModule.render(),this.enablePagerMessage&&this.pagerMessageModule.render(),this.renderNextLastDivForDevice(),this.checkpagesizes()&&this.pagerdropdownModule&&this.pagerdropdownModule.render(),this.addAriaLabel(),this.enableExternalMessage&&this.externalMessageModule&&this.externalMessageModule.render(),this.refresh(),this.trigger("created",{currentPage:this.currentPage,totalRecordsCount:this.totalRecordsCount}))},i.prototype.getPersistData=function(){return this.addOnPersist(["currentPage","pageSize"])},i.prototype.destroy=function(){this.isDestroyed||(this.isReactTemplate()&&(this.off(this.pageRefresh,this.pagerTemplate),this.hasParent||this.destroyTemplate(["template"])),e.prototype.destroy.call(this),this.containerModule.destroy(),this.pagerMessageModule.destroy(),this.isReactTemplate()||(this.element.innerHTML=""))},i.prototype.destroyTemplate=function(e,t){this.clearTemplate(e,t)},i.prototype.getModuleName=function(){return"pager"},i.prototype.onPropertyChanged=function(e,t){if(!this.isDestroyed){e.pageCount!==t.pageCount&&(this.containerModule.refreshNumericLinks(),this.containerModule.refresh());for(var i=0,r=Object.keys(e);i<r.length;i++){switch(r[i]){case"currentPage":this.checkGoToPage(e.currentPage,t.currentPage)&&this.currentPageChanged(e,t);break;case"pageSize":case"totalRecordsCount":case"customText":this.checkpagesizes()&&this.pagerdropdownModule&&(t.pageSize!==e.pageSize&&(this.currentPage=1),this.pagerdropdownModule.setDropDownValue("value",this.pageSize)),e.pageSize!==t.pageSize?(this.pageSize=e.pageSize,this.currentPageChanged(e,t)):this.refresh();break;case"pageSizes":this.checkpagesizes()&&this.pagerdropdownModule&&(this.pagerdropdownModule.destroy(),this.pagerdropdownModule.render()),this.refresh();break;case"template":this.templateFn=this.compile(this.template),this.refresh();break;case"locale":this.initLocalization(),this.refresh();break;case"enableExternalMessage":this.enableExternalMessage&&this.externalMessageModule&&this.externalMessageModule.render();break;case"externalMessage":this.externalMessageModule&&this.externalMessageModule.refresh();break;case"enableRtl":this.updateRTL();break;case"enablePagerMessage":this.enablePagerMessage?this.pagerMessageModule.showMessage():this.pagerMessageModule.hideMessage()}}}},i.prototype.getLocalizedLabel=function(e){return this.localeObj.getConstant(e)},i.prototype.goToPage=function(e){this.checkGoToPage(e)&&(this.currentPage=e,this.dataBind())},i.prototype.setPageSize=function(e){this.pageSize=e,this.dataBind()},i.prototype.checkpagesizes=function(){return!(!0!==this.pageSizes&&!this.pageSizes.length)},i.prototype.checkGoToPage=function(e,i){return e!==this.currentPage&&(this.previousPageNo=this.currentPage),t.isNullOrUndefined(i)||(this.previousPageNo=i),this.previousPageNo!==e&&e>=1&&e<=this.totalPages},i.prototype.currentPageChanged=function(e,t){if(this.enableQueryString&&this.updateQueryString(this.currentPage),e.currentPage!==t.currentPage||e.pageSize!==t.pageSize){var i={currentPage:this.currentPage,newProp:e,oldProp:t,cancel:!1};this.trigger("click",i),i.cancel||this.refresh()}},i.prototype.pagerTemplate=function(){if(!this.isReactTemplate()||!this.hasParent){var e;this.element.classList.add("e-pagertemplate"),this.compile(this.template);var t={currentPage:this.currentPage,pageSize:this.pageSize,pageCount:this.pageCount,totalRecordsCount:this.totalRecordsCount,totalPages:this.totalPages},i=this.element.parentElement.id+"_template";this.isReactTemplate()&&!this.isVue?(this.getPagerTemplate()(t,this,"template",i,null,null,this.element),this.renderReactTemplates()):(e=this.isVue?this.getPagerTemplate()(t,this,"template"):this.getPagerTemplate()(t),P(this.element,e))}},i.prototype.updateTotalPages=function(){this.totalPages=this.isAllPage?1:this.totalRecordsCount%this.pageSize==0?this.totalRecordsCount/this.pageSize:parseInt((this.totalRecordsCount/this.pageSize).toString(),10)+1},i.prototype.getPagerTemplate=function(){return this.templateFn},i.prototype.compile=function(e){if(e)try{document.querySelectorAll(e).length&&(this.templateFn=t.compile(document.querySelector(e).innerHTML.trim()))}catch(i){this.templateFn=t.compile(e)}},i.prototype.refresh=function(){this.template?this.isReactTemplate()?(this.updateTotalPages(),this.notify(this.pageRefresh,{})):(this.element.innerHTML="",this.updateTotalPages(),this.pagerTemplate()):(this.updateRTL(),this.containerModule.refresh(),this.enablePagerMessage&&this.pagerMessageModule.refresh(),this.pagerdropdownModule&&this.pagerdropdownModule.refresh(),this.enableExternalMessage&&this.externalMessageModule&&this.externalMessageModule.refresh())},i.prototype.updateRTL=function(){this.enableRtl?this.element.classList.add("e-rtl"):this.element.classList.remove("e-rtl")},i.prototype.initLocalization=function(){this.localeObj=new t.L10n(this.getModuleName(),this.defaultConstants,this.locale)},i.prototype.updateQueryString=function(e){var t=this.getUpdatedURL(window.location.href,"page",e.toString());window.history.pushState({path:t},"",t)},i.prototype.getUpdatedURL=function(e,t,i){var r=new RegExp("([?|&])"+t+"=.*?(&|#|$)","i");if(e.match(r))return e.replace(r,"$1"+t+"="+i+"$2");var n="";return-1!==e.indexOf("#")&&(n=e.replace(/.*#/,"#"),e=e.replace(/#.*/,"")),e+(-1!==e.indexOf("?")?"&":"?")+t+"="+i+n},i.prototype.renderFirstPrevDivForDevice=function(){this.element.appendChild(t.createElement("div",{className:"e-mfirst e-icons e-icon-first",attrs:{title:this.getLocalizedLabel("firstPageTooltip"),tabindex:"-1"}})),this.element.appendChild(t.createElement("div",{className:"e-mprev e-icons e-icon-prev",attrs:{title:this.getLocalizedLabel("previousPageTooltip"),tabindex:"-1"}}))},i.prototype.renderNextLastDivForDevice=function(){this.element.appendChild(t.createElement("div",{className:"e-mnext e-icons e-icon-next",attrs:{title:this.getLocalizedLabel("nextPageTooltip"),tabindex:"-1"}})),this.element.appendChild(t.createElement("div",{className:"e-mlast e-icons e-icon-last",attrs:{title:this.getLocalizedLabel("lastPageTooltip"),tabindex:"-1"}}))},i.prototype.addAriaLabel=function(){var e=[".e-mfirst",".e-mprev",".e-mnext",".e-mlast"];if(!t.Browser.isDevice)for(var i=0;i<e.length;i++){var r=this.element.querySelector(e[i]);r.setAttribute("aria-label",r.getAttribute("title"))}},i.prototype.isReactTemplate=function(){return(this.isReact||this.isVue)&&this.template&&"string"!=typeof this.template},ha([t.Property(!1)],i.prototype,"enableQueryString",void 0),ha([t.Property(!1)],i.prototype,"enableExternalMessage",void 0),ha([t.Property(!0)],i.prototype,"enablePagerMessage",void 0),ha([t.Property(12)],i.prototype,"pageSize",void 0),ha([t.Property(10)],i.prototype,"pageCount",void 0),ha([t.Property(1)],i.prototype,"currentPage",void 0),ha([t.Property()],i.prototype,"totalRecordsCount",void 0),ha([t.Property()],i.prototype,"externalMessage",void 0),ha([t.Property(!1)],i.prototype,"pageSizes",void 0),ha([t.Property()],i.prototype,"template",void 0),ha([t.Property("")],i.prototype,"customText",void 0),ha([t.Event()],i.prototype,"click",void 0),ha([t.Event()],i.prototype,"dropDownChanged",void 0),ha([t.Event()],i.prototype,"created",void 0),i=ha([t.NotifyPropertyChanges],i)}(t.Component),pa=function(){function e(e){this.pagerModule=e}return e.prototype.getModuleName=function(){return"pagerdropdown"},e.prototype.render=function(){var e=this.pagerModule;this.pagerDropDownDiv=t.createElement("div",{className:"e-pagesizes"});var i=t.createElement("div",{className:"e-pagerdropdown"}),r=t.createElement("div",{className:"e-pagerconstant"}),n=t.createElement("input",{attrs:{type:"text",tabindex:"1"}});this.pagerCons=t.createElement("span",{className:"e-constant",innerHTML:this.pagerModule.getLocalizedLabel("pagerDropDown")}),i.appendChild(n),r.appendChild(this.pagerCons),this.pagerDropDownDiv.appendChild(i),this.pagerDropDownDiv.appendChild(r),this.pagerModule.element.appendChild(this.pagerDropDownDiv);var o=this.pagerModule.pageSizes,l=o.length?this.convertValue(o):[this.pagerModule.getLocalizedLabel("All"),"5","10","12","20"],a=this.pagerModule.pageSize;this.dropDownListObject=new s.DropDownList({dataSource:l,value:a.toString(),change:this.onChange.bind(this),cssClass:"e-alldrop"}),this.dropDownListObject.appendTo(n),o.length&&(this.dropDownListObject.element.value=this.pagerModule.pageSize.toString()),e.pageSize=a,e.dataBind(),e.trigger("dropDownChanged",{pageSize:a}),this.addEventListener()},e.prototype.onChange=function(e){this.dropDownListObject.value===this.pagerModule.getLocalizedLabel("All")?(this.pagerModule.pageSize=this.pagerModule.totalRecordsCount,this.pagerModule.isAllPage=!0,this.refresh(),e.value=this.pagerModule.pageSize,document.getElementsByClassName("e-popup-open e-alldrop").length&&(document.getElementsByClassName("e-popup-open e-alldrop")[0].style.display="none")):(this.pagerModule.pageSize=parseInt(this.dropDownListObject.value,10),this.pagerModule.isAllPage=!1,this.pagerCons.innerHTML!==this.pagerModule.getLocalizedLabel("pagerDropDown")&&this.refresh()),this.pagerModule.dataBind(),this.pagerModule.trigger("dropDownChanged",{pageSize:this.pagerModule.isAllPage?this.pagerModule.totalRecordsCount:parseInt(this.dropDownListObject.value,10)})},e.prototype.refresh=function(){this.pagerCons&&(this.pagerModule.pageSize===this.pagerModule.totalRecordsCount?this.pagerCons.innerHTML=this.pagerModule.getLocalizedLabel("pagerAllDropDown"):this.pagerCons.innerHTML=this.pagerModule.getLocalizedLabel("pagerDropDown"))},e.prototype.beforeValueChange=function(e){if("number"==typeof e.newProp.value){var t=e.newProp.value.toString();e.newProp.value=t}},e.prototype.convertValue=function(e){for(var t=e,i=0;i<t.length;i++)t[i]=parseInt(t[i],10)?t[i].toString():""!==this.pagerModule.getLocalizedLabel(t[i])?this.pagerModule.getLocalizedLabel(t[i]):t[i];return t},e.prototype.setDropDownValue=function(e,t){this.dropDownListObject&&(this.dropDownListObject[e]=this.pagerModule.isAllPage?this.pagerModule.getLocalizedLabel("All"):t)},e.prototype.addEventListener=function(){this.dropDownListObject.on("beforeValueChange",this.beforeValueChange,this)},e.prototype.removeEventListener=function(){this.dropDownListObject.off("beforeValueChange",this.beforeValueChange)},e.prototype.destroy=function(e){this.dropDownListObject&&!this.dropDownListObject.isDestroyed&&(this.removeEventListener(),this.dropDownListObject.destroy(),t.remove(this.pagerDropDownDiv))},e}(),ca=function(){function e(e){this.pagerModule=e}return e.prototype.getModuleName=function(){return"externalMessage"},e.prototype.render=function(){this.element=t.createElement("div",{className:"e-pagerexternalmsg",attrs:{"aria-label":"Pager external message"}}),this.pagerModule.element.appendChild(this.element),this.refresh()},e.prototype.refresh=function(){this.pagerModule.externalMessage&&this.pagerModule.externalMessage.toString().length?(this.showMessage(),this.element.innerHTML=this.pagerModule.externalMessage):this.hideMessage()},e.prototype.hideMessage=function(){t.isNullOrUndefined(this.element)||(this.element.style.display="none")},e.prototype.showMessage=function(){this.element.style.display=""},e.prototype.destroy=function(){t.remove(this.element)},e}(),ua=function(){function e(e,t){this.isInitialRender=!0,this.isCancel=!1,da.Inject(ca,pa),this.parent=e,this.pageSettings=t,this.addEventListener()}return e.prototype.getModuleName=function(){return"pager"},e.prototype.render=function(){var e=this.parent;this.pagerDestroy(),t.isNullOrUndefined(this.parent.pagerTemplate)||(this.pageSettings.template=this.parent.pagerTemplate,this.parent.pageTemplateChange=!0),this.element=this.parent.createElement("div",{className:"e-gridpager"});var i=F({},t.extend({},z(this.pageSettings)),{click:this.clickHandler.bind(this),dropDownChanged:this.onSelect.bind(this),enableRtl:e.enableRtl,locale:e.locale,created:this.addAriaAttr.bind(this)},["parentObj","propName"]);this.pagerObj=new da(i),this.pagerObj.hasParent=!0,this.pagerObj.on(Fo,this.renderReactPagerTemplate,this),this.pagerObj.allowServerDataBinding=!1},e.prototype.onSelect=function(e){this.pageSettings.pageSize=e.pageSize,this.isInitialLoad||(this.pageSettings.currentPage=1)},e.prototype.addAriaAttr=function(){if(!this.pageSettings.template){for(var e=this.parent.createElement("div",{className:"e-numericcontainer"}),t=this.element.querySelector(".e-pagercontainer"),i=document.createDocumentFragment(),r=this.element.querySelector(".e-numericcontainer"),n=r.querySelectorAll("a"),o=0;o<n.length;o++){this.parent.getContentTable()?n[o].setAttribute("aria-owns",this.parent.getContentTable().id):n[o].setAttribute("aria-owns",this.parent.element.getAttribute("id")+"_content_table");var s=this.parent.createElement("div");s.appendChild(n[o]),i.appendChild(s)}e.appendChild(i),t.replaceChild(e,r);for(var l=[".e-mfirst",".e-mprev",".e-first",".e-prev",".e-next",".e-last",".e-mnext",".e-mlast"],a=0;a<l.length;a++){var h=this.element.querySelector(l[a]);this.parent.getContentTable()&&h.setAttribute("aria-owns",this.parent.getContentTable().id)}}},e.prototype.dataReady=function(e){this.updateModel(e)},e.prototype.refresh=function(){this.pagerObj.refresh()},e.prototype.goToPage=function(e){this.pagerObj.goToPage(e)},e.prototype.setPageSize=function(e){this.pagerObj.setPageSize(e)},e.prototype.updateModel=function(e){this.parent.pageSettings.totalRecordsCount=e.count,this.parent.dataBind()},e.prototype.onActionComplete=function(e){this.parent.trigger(Dt,t.extend(e,{currentPage:this.parent.pageSettings.currentPage,requestType:"paging",type:Dt}))},e.prototype.onPropertyChanged=function(e){if(e.module===this.getModuleName()){for(var t=e.properties,i=0,r=Object.keys(t);i<r.length;i++){var n=r[i];this.pagerObj[n]=t[n]}this.pagerObj.dataBind()}},e.prototype.clickHandler=function(e){var i=this.parent;if(this.isForceCancel||W(i)&&!i.prevPageMoving&&!this.isCancel)return this.isForceCancel?this.isForceCancel=!1:(t.isNullOrUndefined(e.newProp)||t.isNullOrUndefined(e.newProp.pageSize)?e.currentPage&&(i.notify(ur,{instance:this,handler:this.goToPage,arg1:e.currentPage}),this.pagerObj.currentPage=i.pageSettings.currentPage===this.pagerObj.currentPage?this.pagerObj.previousPageNo:i.pageSettings.currentPage):(i.notify(ur,{instance:this,handler:this.setPageSize,arg1:e.newProp.pageSize}),this.pagerObj.pageSize=e.oldProp.pageSize,i.pageSettings.pageSize=e.newProp.pageSize),this.isForceCancel=!0,this.pagerObj.dataBind()),void(e.cancel=!0);i.pageSettings.pageSize=this.pagerObj.pageSize,i.prevPageMoving=!1;var r=this.pageSettings.currentPage;this.pageSettings.currentPage=e.currentPage;var n={cancel:!1,requestType:"paging",previousPage:r,currentPage:e.currentPage,type:zt};if(this.isCancel||this.parent.notify(Ti,n),n.cancel)return e.cancel=!0,this.pagerObj.currentPage=r,void(this.isCancel=!0);this.isCancel=!1,this.parent.requestTypeAction="paging"},e.prototype.keyPressHandler=function(e){e.action in ga&&(e.preventDefault(),this.element.querySelector(ga[e.action]).click())},e.prototype.updateExternalMessage=function(e){this.pagerObj.enableExternalMessage||(this.pagerObj.enableExternalMessage=!0,this.pagerObj.dataBind()),this.pagerObj.externalMessage=e,this.pagerObj.dataBind()},e.prototype.appendToElement=function(){this.isInitialLoad=!0,this.parent.element.appendChild(this.element),this.parent.setGridPager(this.element),this.pagerObj.isReact=this.parent.isReact,this.pagerObj.isVue=this.parent.isVue,this.pagerObj.appendTo(this.element),this.isInitialLoad=!1},e.prototype.enableAfterRender=function(e){e.module===this.getModuleName()&&e.enable&&(this.render(),this.appendToElement(),this.isReactTemplate()&&(this.pagerObj.updateTotalPages(),this.created()))},e.prototype.addEventListener=function(){this.handlers={load:this.render,end:this.appendToElement,ready:this.dataReady,complete:this.onActionComplete,updateLayout:this.enableAfterRender,inboundChange:this.onPropertyChanged,keyPress:this.keyPressHandler,created:this.created},this.parent.isDestroyed||((this.parent.isReact||this.parent.isVue)&&this.parent.addEventListener(Cs,this.handlers.created.bind(this)),this.evtHandlers=[{event:bi,handler:this.handlers.load},{event:Si,handler:this.handlers.end},{event:Ri,handler:this.handlers.ready},{event:Mi,handler:this.handlers.complete},{event:Fi,handler:this.handlers.updateLayout},{event:Ii,handler:this.handlers.inboundChange},{event:_i,handler:this.handlers.keyPress},{event:Ki,handler:this.destroy}],_e(this.parent,this.evtHandlers,!0,this))},e.prototype.created=function(){this.isInitialRender&&this.isReactTemplate()&&(this.isInitialRender=!1,this.renderReactPagerTemplate())},e.prototype.isReactTemplate=function(){return(this.parent.isReact||this.parent.isVue)&&this.pagerObj.template&&"string"!=typeof this.pagerObj.template},e.prototype.renderReactPagerTemplate=function(){if(!this.isInitialRender&&this.isReactTemplate()){var e=void 0;this.parent.destroyTemplate(["pagerTemplate"]),this.element.classList.add("e-pagertemplate"),this.pagerObj.compile(this.pagerObj.template);var t=this.parent.pageSettings,i={currentPage:t.currentPage,pageSize:t.pageSize,pageCount:t.pageCount,totalRecordsCount:t.totalRecordsCount,totalPages:this.pagerObj.totalPages},r=this.parent.id+"_pagertemplate";this.parent.isReact?(this.pagerObj.templateFn(i,this.parent,"pagerTemplate",r,null,null,this.pagerObj.element),this.parent.renderTemplates()):(e=this.pagerObj.templateFn(i,this.parent,"pagerTemplate"),P(this.pagerObj.element,e))}},e.prototype.removeEventListener=function(){this.parent.isDestroyed||((this.parent.isReact||this.parent.isVue)&&this.parent.removeEventListener(Cs,this.handlers.created),this.parent.off(Fo,this.renderReactPagerTemplate),_e(this.parent,this.evtHandlers,!1))},e.prototype.destroy=function(){this.removeEventListener(),this.isReactTemplate()&&this.parent.destroyTemplate(["pagerTemplate"]),this.pagerObj.destroy()},e.prototype.pagerDestroy=function(){this.pagerObj&&!this.pagerObj.isDestroyed&&(this.pagerObj.destroy(),t.remove(this.element))},e}(),ga={pageUp:".e-prev",pageDown:".e-next",ctrlAltPageDown:".e-last",ctrlAltPageUp:".e-first",altPageUp:".e-pp",altPageDown:".e-np"},fa=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),ma=function(e){function i(){var t=null!==e&&e.apply(this,arguments)||this;return t.element=t.parent.createElement("TH",{className:"e-filterbarcell"}),t}return fa(i,e),i.prototype.getGui=function(){return this.parent.createElement("div")},i.prototype.render=function(e,i){var r,n=this.parent.element.querySelector(".e-filterbar"),s=this.element.cloneNode(),l=this.getGui(),a=e.column;if(n.appendChild(s),s.setAttribute("e-mappinguid",a.uid),a.filterTemplate){var h={};i&&(h[a.field]=i[a.field]);if(h.column=a,a.visible){var d=this.parent.isReact&&"string"!=typeof a.filterTemplate,p=this.parent.element.id+a.uid+"filterTemplate";if(d)a.getFilterTemplate()(h,this.parent,"filterTemplate",p,null,null,s),this.parent.renderTemplates();else{P(s,a.getFilterTemplate()(h,this.parent,"filterTemplate",p))}}else s.classList.add("e-hide")}else if("checkbox"!==a.type){if(!t.isNullOrUndefined(a.allowFiltering)&&!a.allowFiltering||t.isNullOrUndefined(a.filterBarTemplate)){t.attributes(l,{class:"e-filterdiv e-fltrinputdiv"}),r=this.parent.createElement("input",{id:a.field+"_filterBarcell",className:"e-filtertext",attrs:{type:"search",title:a.headerText+e.attributes.title,value:i[e.column.field]?i[e.column.field]:"",role:"search"}}),l.appendChild(r);c={element:r,floatLabelType:"Never",properties:{enableRtl:this.parent.enableRtl,showClearButton:!0}};o.Input.createInput(c,this.parent.createElement)}else if(s.classList.add("e-fltrtemp"),t.attributes(l,{class:"e-fltrtempdiv"}),t.isNullOrUndefined(a.filterBarTemplate.create))r=this.parent.createElement("input",{id:a.field+"_filterBarcell",className:"e-filterUi_input e-filtertext e-fltrTemp",attrs:{type:"search",title:a.headerText}}),l.appendChild(r);else{var c={column:a,node:Element},u=a.filterBarTemplate.create;if("string"==typeof u&&(u=t.getValue(u,window)),"string"==typeof(r=u(c))){var g=this.parent.createElement("div");g.innerHTML=r,r=g.firstChild}t.attributes(l,{class:"e-filterUi_input e-filtertext e-fltrTemp",title:a.headerText,id:a.field+"_filterBarcell"}),l.appendChild(r)}if((!1===a.allowFiltering||""===a.field||t.isNullOrUndefined(a.field))&&(r.setAttribute("disabled","true"),r.classList.add("e-disable")),a.visible||s.classList.add("e-hide"),this.appendHtml(s,l),this.parent.filterSettings.showFilterBarOperator&&"FilterBar"===this.parent.filterSettings.type&&!this.parent.isPrinting&&t.isNullOrUndefined(a.filterTemplate)&&t.isNullOrUndefined(a.filterBarTemplate)&&this.operatorIconRender(l,a,e),(t.isNullOrUndefined(a.allowFiltering)||a.allowFiltering)&&!t.isNullOrUndefined(a.filterBarTemplate)){var f=a.filterBarTemplate.write;c={element:r,column:a};"string"==typeof f&&(f=t.getValue(f,window)),f.call(this,c)}}return s},i.prototype.appendHtml=function(e,t){return e.appendChild(t),e},i.prototype.operatorIconRender=function(e,i,r){var n=this.parent,o=this.parent.createElement("input",{className:" e-filterbaroperator e-icons e-icon-filter",id:r.column.uid});e.querySelector("span").appendChild(o);var l=i.filter&&i.filter.operator?i.filter.operator:"equal";t.isNullOrUndefined(n.filterModule.operators[i.field])||(l=n.filterModule.operators[i.field]),this.dropOptr=new s.DropDownList({fields:{text:"text",value:"value"},popupHeight:"auto",value:l,width:"0px",enabled:i.allowFiltering,popupWidth:"auto",enableRtl:this.parent.enableRtl,change:this.internalEvent.bind(this),beforeOpen:function(){var e=n.filterModule.customOperators;this.dataSource=e[n.getColumnByUid(this.element.id).type+"Operator"];for(var r=0;r<this.dataSource.length;r++)i.filter&&i.filter.operator&&t.isNullOrUndefined(n.filterModule.operators[i.field])&&this.dataSource[r].value===i.filter.operator&&(this.value=i.filter.operator)}}),this.dropOptr.appendTo(o);var a=t.closest(this.dropOptr.element,"span");a.classList.add("e-filterbardropdown"),a.removeAttribute("tabindex")},i.prototype.internalEvent=function(e){var t=this.parent,i=t.getColumnByUid(e.element.getAttribute("id"));e.column=i,t.filterModule.operators[i.field]=e.value,t.notify(jn,e)},i}(Bs),ya=function(){function e(e,t,i,r){this.ddOpen=this.dropDownOpen.bind(this),this.parent=e,this.serviceLocator=i,this.filterSettings=r,this.customFilterOperators=t,this.parent&&(this.parent.on(Br,this.destroyDropDownList,this),this.parent.on(Ki,this.destroyDropDownList,this))}return e.prototype.renderOperatorUI=function(e,i,r,n,o){this.dialogObj=n;var l=r.type+"Operator";this.optrData=this.customOptr=t.isNullOrUndefined(o)?t.isNullOrUndefined(this.parent.filterSettings.operators)||t.isNullOrUndefined(this.parent.filterSettings.operators[l])?this.customFilterOperators[l]:this.parent.filterSettings.operators[l]:o;var a=this.customOptr,h=this.dropSelectedVal(r,l),d=this.parent.createElement("div",{className:"e-flm_optrdiv"});e.appendChild(d);var p=this.parent.createElement("input",{id:r.uid+"-floptr"});d.appendChild(p),this.dropOptr=new s.DropDownList({dataSource:a,fields:{text:"text",value:"value"},cssClass:"e-popup-flmenu",enableRtl:this.parent.enableRtl,text:h}),this.dropOptr.addEventListener(ms,this.ddOpen),this.dropOptr.appendTo("#"+r.uid+"-floptr")},e.prototype.renderResponsiveDropDownList=function(e){e.popup.element.style.width="100%"},e.prototype.dropDownOpen=function(e){e.popup.element.style.zIndex=(this.dialogObj.zIndex+1).toString(),this.parent.enableAdaptiveUI&&this.renderResponsiveDropDownList(e)},e.prototype.dropSelectedVal=function(e,r){for(var n="",o=0,s=this.parent.filterSettings.columns;o<s.length;o++){var l=s[o];if(e.field===l.field||e.isForeignColumn()&&e.foreignKeyValue===l.field){var a=new i.DataManager(this.optrData).executeLocal((new i.Query).where("value","equal",l.operator));n=t.isNullOrUndefined(a[0])?"":a[0].text}}if(""===n)if(e.filter.operator)for(var h=Object.keys(this.optrData).length,d=0;d<h;d++)this.optrData[d].value===e.filter.operator&&(n=this.optrData[d].text);else n=this.optrData[0].text;return n},e.prototype.getFlOperator=function(){return this.dropOptr.value},e.prototype.destroyDropDownList=function(){this.dropOptr.isDestroyed||(this.dropOptr.removeEventListener(ms,this.ddOpen),this.dropOptr.destroy(),this.parent.off(Br,this.destroyDropDownList),this.parent.off(Ki,this.destroyDropDownList))},e}(),va=function(){function e(e,t,i){this.parent=e,this.serLocator=t,this.filterSettings=i,this.parent&&(this.parent.on(Br,this.destroy,this),this.parent.on(Ki,this.destroy,this))}return e.prototype.create=function(e){this.instance=this.parent.createElement("input",{className:"e-flmenu-input",id:"strui-"+e.column.uid}),e.target.appendChild(this.instance),this.dialogObj=e.dialogObj,this.actObj=this.getAutoCompleteOptions(e),this.actObj.appendTo(this.instance)},e.prototype.getAutoCompleteOptions=function(e){var r,n=e.column.isForeignColumn();n&&((r=new i.Query).params=this.parent.query.params);var o=n?e.column.dataSource:this.parent.dataSource,l={value:n?e.column.foreignKeyValue:e.column.field},a=new s.AutoComplete(t.extend({dataSource:o instanceof i.DataManager?o:new i.DataManager(o),fields:l,locale:this.parent.locale,enableRtl:this.parent.enableRtl,query:n?r:this.parent.query.clone(),sortOrder:"Ascending",cssClass:"e-popup-flmenu",autofill:!0,placeholder:e.localizeText.getConstant("EnterValue")},e.column.filter.params));if(this.acFocus=this.focus(a,e),this.acComplete=this.actionComplete(a),this.acOpen=this.openPopup.bind(this),a.addEventListener(vs,this.acFocus),a.addEventListener(ms,this.acOpen),a.addEventListener(Dt,this.acComplete),o&&"result"in o){var h=xe({requestType:"stringfilterrequest"},this.parent.getQuery?this.parent.getQuery().clone():new i.Query);this.parent.trigger(jr,h.state);h.deffered.promise.then(function(e){a.dataSource=new i.DataManager(e)})}return a},e.prototype.write=function(e){if(""!==e.filteredValue&&!t.isNullOrUndefined(e.filteredValue)){document.querySelector("#strui-"+e.column.uid).ej2_instances[0].value=e.filteredValue}},e.prototype.read=function(e,i,r,n){var o=document.querySelector("#strui-"+i.uid).ej2_instances[0];t.Browser.isDevice&&(o.hidePopup(),o.focusOut());var s=o.value;(t.isNullOrUndefined(s)||""===s)&&(s=null),n.filterByColumn(i.field,r,s,"and",this.parent.filterSettings.enableCaseSensitivity)},e.prototype.openPopup=function(e){Z(e,this.dialogObj)},e.prototype.focus=function(e,t){return function(){e.filterType=t.getOptrInstance.getFlOperator()}},e.prototype.actionComplete=function(e){return function(i){i.result=i.result.filter(function(i,r,n){return n.map(function(i){return t.getValue(e.fields.value,i)}).indexOf(t.getValue(e.fields.value,i))===r})}},e.prototype.destroy=function(){this.actObj&&!this.actObj.isDestroyed&&(this.actObj.removeEventListener(vs,this.acFocus),this.actObj.removeEventListener(ms,this.acOpen),this.actObj.removeEventListener(Dt,this.acComplete),this.actObj.destroy(),this.parent.off(Br,this.destroy),this.parent.off(Ki,this.destroy))},e}(),Ca=function(){function e(e,t,i){this.filterSettings=i,this.parent=e,this.serviceLocator=t,this.parent&&(this.parent.on(Br,this.destroy,this),this.parent.on(Ki,this.destroy,this))}return e.prototype.keyEventHandler=function(e){if(13===e.keyCode||9===e.keyCode){var t=document.createEvent("HTMLEvents");t.initEvent("change",!1,!0),this.dispatchEvent(t)}},e.prototype.create=function(e){this.instance=this.parent.createElement("input",{className:"e-flmenu-input",id:"numberui-"+e.column.uid}),e.target.appendChild(this.instance),this.numericTxtObj=new o.NumericTextBox(t.extend({format:"string"==typeof e.column.format||t.isUndefined(e.column.format)?e.column.format:e.column.format.format,locale:this.parent.locale,cssClass:"e-popup-flmenu",placeholder:e.localizeText.getConstant("EnterValue"),enableRtl:this.parent.enableRtl},e.column.filter.params)),this.numericTxtObj.appendTo(this.instance)},e.prototype.write=function(e){var t=document.querySelector("#numberui-"+e.column.uid).ej2_instances[0];t.element.addEventListener("keydown",this.keyEventHandler),t.value=e.filteredValue},e.prototype.read=function(e,t,i,r){var n=document.querySelector("#numberui-"+t.uid).ej2_instances[0].value;r.filterByColumn(t.field,i,n,"and",!0)},e.prototype.destroy=function(){this.numericTxtObj&&!this.numericTxtObj.isDestroyed&&(this.numericTxtObj.destroy(),this.parent.off(Br,this.destroy),this.parent.off(Ki,this.destroy))},e}(),wa=function(){function e(e,t,i){this.parent=e,this.serviceLocator=t,this.filterSettings=i,this.parent&&(this.parent.on(Br,this.destroy,this),this.parent.on(Ki,this.destroy,this))}return e.prototype.create=function(e){var r=e.column.isForeignColumn(),n=r?e.column.dataSource:this.parent.dataSource,o=r?e.column.foreignKeyValue:e.column.field;this.elem=this.parent.createElement("input",{className:"e-flmenu-input",id:"bool-ui-"+e.column.uid}),e.target.appendChild(this.elem),this.dialogObj=e.dialogObj,this.dropInstance=new s.DropDownList(t.extend({dataSource:n instanceof i.DataManager?n:new i.DataManager(n),query:(new i.Query).select(o),fields:{text:o,value:o},placeholder:e.localizeText.getConstant("SelectValue"),cssClass:"e-popup-flmenu",locale:this.parent.locale,enableRtl:this.parent.enableRtl},e.column.filter.params)),this.ddOpen=this.openPopup.bind(this),this.ddComplete=this.actionComplete(o),this.dropInstance.addEventListener(ms,this.ddOpen),this.dropInstance.addEventListener(Dt,this.ddComplete),this.dropInstance.appendTo(this.elem)},e.prototype.write=function(e){var i=document.querySelector("#bool-ui-"+e.column.uid).ej2_instances[0];t.isNullOrUndefined(e.filteredValue)||(i.text=e.filteredValue)},e.prototype.read=function(e,t,i,r){var n=document.querySelector("#bool-ui-"+t.uid).ej2_instances[0].value;r.filterByColumn(t.field,i,n,"and",!1)},e.prototype.openPopup=function(e){Z(e,this.dialogObj)},e.prototype.actionComplete=function(e){return function(t){t.result=i.DataUtil.distinct(t.result,e,!0)}},e.prototype.destroy=function(){this.dropInstance&&!this.dropInstance.isDestroyed&&(this.dropInstance.removeEventListener(ms,this.ddOpen),this.dropInstance.removeEventListener(Dt,this.ddComplete),this.dropInstance.destroy(),this.parent.off(Br,this.destroy),this.parent.off(Ki,this.destroy))},e}(),ba=function(){function e(e,t,i){this.dpOpen=this.openPopup.bind(this),this.parent=e,this.locator=t,this.fltrSettings=i,this.parent&&(this.parent.on(Br,this.destroy,this),this.parent.on(Ki,this.destroy,this))}return e.prototype.create=function(e){var i=de(e.column.format,e.column.type);this.dialogObj=e.dialogObj,this.inputElem=this.parent.createElement("input",{className:"e-flmenu-input",id:"dateui-"+e.column.uid}),e.target.appendChild(this.inputElem),"date"===e.column.type?this.datePickerObj=new l.DatePicker(t.extend({format:i,cssClass:"e-popup-flmenu",placeholder:e.localizeText.getConstant("ChooseDate"),width:"100%",locale:this.parent.locale,enableRtl:this.parent.enableRtl},e.column.filter.params)):"datetime"===e.column.type&&(this.datePickerObj=new l.DateTimePicker(t.extend({format:i,cssClass:"e-popup-flmenu",placeholder:e.localizeText.getConstant("ChooseDate"),width:"100%",locale:this.parent.locale,enableRtl:this.parent.enableRtl},e.column.filter.params))),this.datePickerObj.addEventListener(ms,this.dpOpen),this.datePickerObj.appendTo(this.inputElem)},e.prototype.write=function(e){document.querySelector("#dateui-"+e.column.uid).ej2_instances[0].value=t.isNullOrUndefined(e.filteredValue)?null:new Date(e.filteredValue)},e.prototype.read=function(e,i,r,n){var o=document.querySelector("#dateui-"+i.uid).ej2_instances[0].value;o=t.isNullOrUndefined(o)?null:o,n.filterByColumn(i.field,r,o,"and",!0)},e.prototype.openPopup=function(e){e.popup.element.style.zIndex=(this.dialogObj.zIndex+1).toString()},e.prototype.destroy=function(){this.parent.off(Br,this.destroy),this.parent.off(Ki,this.destroy),t.isNullOrUndefined(this.datePickerObj)||this.datePickerObj.isDestroyed||(this.datePickerObj.removeEventListener(ms,this.dpOpen),this.datePickerObj.destroy())},e}(),Sa=function(){function e(e,t,i,r,n){this.isDialogOpen=!1,this.maxHeight="350px",this.isMenuCheck=!1,this.colTypes={string:va,number:Ca,date:ba,boolean:wa,datetime:ba},this.parent=e,this.filterSettings=t,this.serviceLocator=i,this.customFilterOperators=r,this.filterObj=n,this.flMuiObj=new ya(this.parent,this.customFilterOperators,this.serviceLocator),this.l10n=this.serviceLocator.getService("localization"),this.menuFilterBase=new ia(e)}return e.prototype.clearCustomFilter=function(e){this.clearBtnClick(e)},e.prototype.applyCustomFilter=function(e){this.filterBtnClick(e.col)},e.prototype.openDialog=function(e){this.options=e,this.col=this.parent.getColumnByField(e.field),(t.isNullOrUndefined(this.col.filter)||t.isNullOrUndefined(this.col.filter.type)||"Menu"===this.col.filter.type)&&this.renderDlgContent(e.target,this.col)},e.prototype.closeDialog=function(e){if(this.dlgObj){(this.parent.isReact||this.parent.isVue)&&Je(this.parent,["filterTemplate"]);var i=document.getElementById(this.dlgObj.element.id);if(this.dlgObj&&!this.dlgObj.isDestroyed&&i){var r={cancel:!1,column:this.col,target:e,element:i};if(this.parent.notify(Br,r),r.cancel)return;this.isDialogOpen=!1,this.isMenuCheck&&(this.menuFilterBase.unWireEvents(),this.parent.off(un,this.actionComplete),this.isMenuCheck=!1),this.dlgObj.destroy(),t.remove(i)}this.parent.notify(co,{})}},e.prototype.renderDlgContent=function(e,i){var n={requestType:mi,columnName:i.field,columnType:i.type};n.filterModel=this,this.parent.trigger(zt,n);var o=this.parent.createElement("div",{className:"e-flmenu-maindiv",id:i.uid+"-flmenu"});if(this.dlgDiv=this.parent.createElement("div",{className:"e-flmenu",id:i.uid+"-flmdlg"}),this.dlgDiv.setAttribute("aria-label",this.l10n.getConstant("FilterMenuDialogARIA")),this.parent.enableAdaptiveUI){document.querySelector(".e-resfilter > .e-dlg-content > .e-mainfilterdiv").appendChild(this.dlgDiv)}else this.parent.element.appendChild(this.dlgDiv);this.dlgObj=new r.Dialog({showCloseIcon:!1,closeOnEscape:!1,locale:this.parent.locale,visible:!1,enableRtl:this.parent.enableRtl,created:this.dialogCreated.bind(this,e,i),position:this.parent.element.classList.contains("e-device")?{X:"center",Y:"center"}:{X:"",Y:""},target:this.parent.element.classList.contains("e-device")?document.body:this.parent.element,buttons:[{click:this.filterBtnClick.bind(this,i),buttonModel:{content:this.l10n.getConstant("FilterButton"),isPrimary:!0,cssClass:"e-flmenu-okbtn"}},{click:this.clearBtnClick.bind(this,i),buttonModel:{content:this.l10n.getConstant("ClearButton"),cssClass:"e-flmenu-cancelbtn"}}],content:o,width:!t.isNullOrUndefined(D(e,"e-bigger"))||this.parent.element.classList.contains("e-device")?260:250,animationSettings:{effect:"None"},cssClass:"e-filter-popup"});this.dlgObj.isStringTemplate=!0,this.renderResponsiveDialog(),this.dlgObj.appendTo(this.dlgDiv)},e.prototype.renderResponsiveDialog=function(){this.parent.enableAdaptiveUI&&(this.dlgObj.position={X:"",Y:""},this.dlgObj.target=document.querySelector(".e-resfilter > .e-dlg-content > .e-mainfilterdiv"),this.dlgObj.width="100%",this.dlgObj.isModal=!1,this.dlgObj.buttons=[{}])},e.prototype.dialogCreated=function(e,i){!t.Browser.isDevice&&e&&J(e,this.dlgObj),this.renderFilterUI(e,i),i.showColumnMenu&&this.parent.notify(Ar,{}),this.parent.enableAdaptiveUI?(this.dlgObj.element.style.left="0px",this.dlgObj.element.style.maxHeight="none"):this.dlgObj.element.style.maxHeight=this.maxHeight,this.dlgObj.show(),i.filterTemplate||this.writeMethod(i,this.dlgObj.element.querySelector("#"+i.uid+"-flmenu"));var r={requestType:fi,columnName:i.field,columnType:i.type};r.filterModel=this,this.isDialogOpen=!0,this.isMenuCheck||this.parent.trigger(Dt,r)},e.prototype.renderFilterUI=function(e,t){var i=this.dlgObj.element.querySelector(".e-flmenu-maindiv");this.parent.log("column_type_missing",{column:t}),this.renderOperatorUI(i,e,t),this.renderFlValueUI(i,e,t)},e.prototype.renderOperatorUI=function(e,t,i){this.flMuiObj.renderOperatorUI(e,t,i,this.dlgObj,this.filterObj.menuOperator)},e.prototype.renderFlValueUI=function(e,i,r){var n=this.parent.createElement("div",{className:"e-flmenu-valuediv"}),o=this.filterObj;e.appendChild(n);var s=new this.colTypes[r.type](this.parent,this.serviceLocator,this.parent.filterSettings);if(r.filterTemplate){var l={};l[r.field]=l.value=o.values[r.field],r.foreignKeyValue&&(l[r.foreignKeyValue]=o.values[r.field],l[r.field]=void 0);l.column=r;var a=this.parent.isReact&&"string"!=typeof r.filterTemplate,h=this.parent.element.id+r.uid+"filterTemplate";if(a)r.getFilterTemplate()(l,this.parent,"filterTemplate",h,null,null,n),this.parent.renderTemplates();else{P(n,r.getFilterTemplate()(l,this.parent,"filterTemplate",h))}this.isMenuCheck&&(this.menuFilterBase.cBox=this.dlgObj.element.querySelector(".e-checkboxlist.e-fields"),this.menuFilterBase.wireEvents(),this.parent.on(un,this.actionComplete,this),this.menuFilterBase.getAllData())}else if(t.isNullOrUndefined(r.filter)||t.isNullOrUndefined(r.filter.ui)||t.isNullOrUndefined(r.filter.ui.create))s.create({column:r,target:n,getOptrInstance:this.flMuiObj,localizeText:this.l10n,dialogObj:this.dlgObj});else{var d=r.filter.ui.create;"string"==typeof d&&(d=t.getValue(d,window)),d({column:r,target:n,getOptrInstance:this.flMuiObj,dialogObj:this.dlgObj})}},e.prototype.writeMethod=function(e,i){for(var r,n=i.querySelector(".e-flmenu-valinput"),o=new this.colTypes[e.type](this.parent,this.serviceLocator,this.parent.filterSettings),s=0,l=this.filterSettings.columns;s<l.length;s++){var a=l[s];e.uid===a.uid&&(r=a.value)}if(t.isNullOrUndefined(e.filter)||t.isNullOrUndefined(e.filter.ui)||t.isNullOrUndefined(e.filter.ui.write))o.write({column:e,target:n,parent:this.parent,filteredValue:r});else{var h=e.filter.ui.write;"string"==typeof h&&(h=t.getValue(h,window)),h({column:e,target:n,parent:this.parent,filteredValue:r})}},e.prototype.filterBtnClick=function(e){var i=this.dlgObj.element.querySelector(".e-flmenu-valuediv input"),r=this.flMuiObj.getFlOperator(),n=new this.colTypes[e.type](this.parent,this.serviceLocator,this.parent.filterSettings);if(e.filterTemplate){var o=this.dlgDiv.querySelector(".e-flmenu-valuediv"),s=void 0;if(o.children[0].value)s=o.children[0].value;else if(t.isNullOrUndefined(o.children[0].ej2_instances)){var l=o.querySelector(".e-control");s="boolean"===e.type?l.checked:t.isNullOrUndefined(l.ej2_instances)?l.value:l.ej2_instances[0].value}else s=(this.parent.isAngular?o.children[0]:o.querySelector("input")).ej2_instances[0].value;this.filterObj.filterByColumn(e.field,r,s)}else if(t.isNullOrUndefined(e.filter)||t.isNullOrUndefined(e.filter.ui)||t.isNullOrUndefined(e.filter.ui.read))n.read(i,e,r,this.filterObj);else{var a=e.filter.ui.read;"string"==typeof a&&(a=t.getValue(a,window)),a({element:i,column:e,operator:r,fltrObj:this.filterObj})}this.closeDialog(),this.parent.showColumnMenu&&this.parent.notify(Lo,{})},e.prototype.closeResponsiveDialog=function(){this.closeDialog()},e.prototype.clearBtnClick=function(e){this.filterObj.removeFilteredColsByField(e.field),this.closeDialog();var t=this.parent.showColumnMenu&&e.showColumnMenu?".e-columnmenu":".e-icon-filter",i=this.parent.element.querySelector('[e-mappinguid="'+e.uid+'"]').parentElement.querySelector(t);i&&i.classList.remove("e-filtered")},e.prototype.destroy=function(){this.closeDialog()},e.prototype.getFilterUIInfo=function(){return{field:this.col.field,operator:this.flMuiObj.getFlOperator()}},e.prototype.renderCheckBoxMenu=function(){return this.isMenuCheck=!0,this.menuFilterBase.updateModel(this.options),this.menuFilterBase.getAndSetChkElem(this.options),this.dlgObj.buttons=[{click:this.menuFilterBase.btnClick.bind(this.menuFilterBase),buttonModel:{content:this.menuFilterBase.getLocalizedLabel("FilterButton"),cssClass:"e-primary",isPrimary:!0}},{click:this.menuFilterBase.btnClick.bind(this.menuFilterBase),buttonModel:{cssClass:"e-flat",content:this.menuFilterBase.getLocalizedLabel("ClearButton")}}],this.menuFilterBase.dialogObj=this.dlgObj,this.menuFilterBase.dlg=this.dlgObj.element,this.menuFilterBase.dlg.classList.add("e-menucheckbox"),this.menuFilterBase.dlg.classList.remove("e-checkboxfilter"),this.maxHeight="800px",this.menuFilterBase.sBox.innerHTML},e.prototype.actionComplete=function(e){this.isMenuCheck&&this.parent.trigger(Dt,e)},e}(),Ra=function(){function e(e,t,i){this.parent=e,this.isresetFocus=!0,this.checkBoxBase=new ia(e),this.addEventListener()}return e.prototype.destroy=function(){this.removeEventListener(),this.checkBoxBase.closeDialog()},e.prototype.openDialog=function(e){this.checkBoxBase.openDialog(e),this.parent.log("column_type_missing",{column:e.column})},e.prototype.closeDialog=function(){this.destroy(),this.isresetFocus&&this.parent.notify(vn,{})},e.prototype.closeResponsiveDialog=function(){this.checkBoxBase.closeDialog()},e.prototype.getModuleName=function(){return"checkboxFilter"},e.prototype.actionBegin=function(e){this.parent.trigger(zt,e)},e.prototype.actionComplete=function(e){this.parent.trigger(Dt,e)},e.prototype.actionPrevent=function(e){W(this.parent)&&(this.parent.notify(ur,e),e.cancel=!0)},e.prototype.clearCustomFilter=function(e){this.checkBoxBase.clearFilter(e)},e.prototype.applyCustomFilter=function(){this.checkBoxBase.fltrBtnHandler(),this.checkBoxBase.closeDialog()},e.prototype.addEventListener=function(){this.parent.isDestroyed||(this.parent.on(cn,this.actionBegin,this),this.parent.on(un,this.actionComplete,this),this.parent.on(gn,this.actionPrevent,this))},e.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(cn,this.actionBegin),this.parent.off(un,this.actionComplete),this.parent.off(gn,this.actionPrevent))},e}(),xa=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Fa=function(e){function t(t,i,r,n){var o=e.call(this,t,i,r)||this;return o.parent=t,o.isresetFocus=!0,o.excelFilterBase=new na(t,n),o}return xa(t,e),t.prototype.destroy=function(){this.excelFilterBase.closeDialog()},t.prototype.openDialog=function(e){this.excelFilterBase.openDialog(e)},t.prototype.closeDialog=function(){this.excelFilterBase.closeDialog(),this.isresetFocus&&this.parent.notify(vn,{})},t.prototype.clearCustomFilter=function(e){this.excelFilterBase.clearFilter(e)},t.prototype.closeResponsiveDialog=function(e){e?this.excelFilterBase.removeDialog():this.closeDialog()},t.prototype.applyCustomFilter=function(e){e.isCustomFilter?this.excelFilterBase.filterBtnClick(e.col.field):(this.excelFilterBase.fltrBtnHandler(),this.excelFilterBase.closeDialog())},t.prototype.filterByColumn=function(e,t,i,r,n,o,s,l){this.excelFilterBase.filterByColumn(e,t,i,r,n,o,s,l)},t.prototype.getFilterUIInfo=function(){return this.excelFilterBase.getFilterUIInfo()},t.prototype.getModuleName=function(){return"excelFilter"},t}(Ra),Ea=function(){function r(e,t,i){this.predicate="and",this.contentRefresh=!0,this.filterByMethod=!0,this.refresh=!0,this.values={},this.operators={},this.cellText={},this.nextFlMenuOpen="",this.type={Menu:Sa,CheckBox:Ra,Excel:Fa},this.filterOperators={contains:"contains",endsWith:"endswith",equal:"equal",greaterThan:"greaterthan",greaterThanOrEqual:"greaterthanorequal",lessThan:"lessthan",lessThanOrEqual:"lessthanorequal",notEqual:"notequal",startsWith:"startswith"},this.fltrDlgDetails={field:"",isOpen:!1},this.skipNumberInput=["="," ","!"],this.skipStringInput=[">","<","="],this.actualPredicate={},this.parent=e,this.filterSettings=t,this.serviceLocator=i,this.addEventListener(),this.setFullScreenDialog()}return r.prototype.render=function(r){if(!(i.DataUtil.getObject("args.isFrozen",r)||this.parent.getFrozenMode()===hs&&i.DataUtil.getObject("args.renderFrozenRightContent",r))){var n=this.parent;if(this.l10n=this.serviceLocator.getService("localization"),this.getLocalizedCustomOperators(),"FilterBar"===this.parent.filterSettings.type&&n.columns.length){var o=this.parent.element.querySelector(".e-filterbar");o&&t.remove(o);var s=new Fs(this.serviceLocator,e.CellType.Filter,n);this.serviceLocator.getService("cellRendererFactory").addCellRenderer(e.CellType.Filter,new ma(this.parent,this.serviceLocator)),this.valueFormatter=this.serviceLocator.getService("valueFormatter"),s.element=this.parent.createElement("tr",{className:"e-filterbar"});var l=this.generateRow();if(l.data=this.values,"Right"===n.getFrozenMode()){n.getFrozenRightHeader().querySelector("thead").appendChild(s.element)}else this.parent.getHeaderContent().querySelector("thead").appendChild(s.element);var a=this.parent.element.querySelector(".e-rowdragheader");this.element=s.render(l,n.getColumns(),null,null,s.element);var h=this.element.querySelector(".e-detailheadercell");h&&(h.className="e-filterbarcell e-mastercell"),a&&(a.className="e-dragheadercell e-mastercell");var d=[].slice.call(this.element.getElementsByClassName("e-grouptopleftcell"));d.length&&d[d.length-1].classList.add("e-lastgrouptopleftcell"),this.wireEvents(),this.parent.notify(zr,{case:"filter"})}}},r.prototype.showCustomFilter=function(e){this.responsiveDialogRenderer.isCustomDialog=e,this.responsiveDialogRenderer.showResponsiveDialog(this.column)},r.prototype.setFilterModel=function(e){var t=e.filter.type||this.parent.filterSettings.type;this.filterModule=new this.type[t](this.parent,this.parent.filterSettings,this.serviceLocator,this.customOperators,this)},r.prototype.destroy=function(){var e=this.parent.element;if(e&&(e.querySelector("."+Wo)||e.querySelector("."+Ko))){if(this.filterModule&&this.filterModule.destroy(),this.parent.refreshing||!this.parent.isDestroyed&&this.parent.allowFiltering||(this.filterSettings.columns=[]),this.updateFilterMsg(),this.removeEventListener(),this.unWireEvents(),"FilterBar"===this.filterSettings.type&&this.filterSettings.showFilterBarOperator)for(var i=[].slice.call(this.element.getElementsByClassName("e-filterbaroperator")),r=0;r<i.length;r++)i[r].ej2_instances[0]&&i[r].ej2_instances[0].destroy();if(this.element){this.element.parentElement&&t.remove(this.element);var n=this.parent.getHeaderContent().querySelector(".e-filterbar");this.parent.isFrozenGrid()&&n&&t.remove(n)}}},r.prototype.setFullScreenDialog=function(){this.serviceLocator&&this.serviceLocator.registerAdaptiveService(this,this.parent.enableAdaptiveUI,e.ResponsiveDialogAction.isFilter)},r.prototype.generateRow=function(){var e=new jo({});return e.cells=this.generateCells(),e},r.prototype.generateCells=function(){var t=[];if(this.parent.allowGrouping)for(var i=0,r=this.parent.groupSettings.columns.length;i<r;i++)t.push(this.generateCell({},e.CellType.HeaderIndent));(this.parent.detailTemplate||this.parent.childGrid)&&t.push(this.generateCell({},e.CellType.DetailHeader)),this.parent.isRowDragable()&&"Right"!==this.parent.getFrozenMode()&&t.push(this.generateCell({},e.CellType.RowDragHIcon));for(var n=0,o=this.parent.getColumns();n<o.length;n++){var s=o[n];t.push(this.generateCell(s))}return"Right"===this.parent.getFrozenMode()&&t.push(this.generateCell({},e.CellType.RowDragHIcon)),t},r.prototype.generateCell=function(t,i){var r={visible:t.visible,isDataCell:!1,rowId:"",column:t,cellType:i||e.CellType.Filter,attributes:{title:this.l10n.getConstant("FilterbarTitle")}};return new Vo(r)},r.prototype.updateModel=function(){var e=this.parent.getColumnByField(this.fieldName);this.filterObjIndex=this.getFilteredColsIndexByField(e),this.prevFilterObject=this.filterSettings.columns[this.filterObjIndex];for(var i=Array.isArray(this.value)?this.value:[this.value],r=this.parent.dataSource.adaptor&&this.parent.dataSource.adaptor.getModuleName?this.parent.dataSource.adaptor.getModuleName():void 0,n=0,o=i.length;n<o;n++){var s=e.isForeignColumn()?e.foreignKeyValue:this.fieldName,l="notequal"===this.operator;this.currentFilterObject={field:s,uid:e.uid,isForeignKey:e.isForeignColumn(),operator:this.operator,value:i[n],predicate:this.predicate,matchCase:this.matchCase,ignoreAccent:this.ignoreAccent,actualFilterValue:{},actualOperator:{}};var a=this.getFilteredColsIndexByField(e);a>-1&&!Array.isArray(this.value)?this.filterSettings.columns[a]=this.currentFilterObject:this.filterSettings.columns.push(this.currentFilterObject),!t.isNullOrUndefined(this.value)||"equal"!==this.operator&&"notequal"!==this.operator||"ODataAdaptor"===r||"ODataV4Adaptor"===r||(this.filterSettings.columns=[],"string"===e.type&&this.filterSettings.columns.push({field:s,ignoreAccent:this.ignoreAccent,matchCase:this.matchCase,operator:this.operator,predicate:l?"and":"or",value:""}),this.filterSettings.columns.push({field:s,ignoreAccent:this.ignoreAccent,matchCase:this.matchCase,operator:this.operator,predicate:l?"and":"or",value:void 0}),this.filterSettings.columns.push({field:s,ignoreAccent:this.ignoreAccent,matchCase:this.matchCase,operator:this.operator,predicate:l?"and":"or",value:null}))}this.filterSettings.columns=this.filterSettings.columns,this.parent.dataBind()},r.prototype.getFilteredColsIndexByField=function(e){for(var t=this.filterSettings.columns,i=0,r=t.length;i<r;i++)if(t[i].uid===e.uid||e.isForeignColumn()&&this.parent.getColumnByUid(e.uid).field===e.foreignKeyValue)return i;return-1},r.prototype.onActionComplete=function(e){var i=this.isRemove?{requestType:"filtering",type:Dt}:{currentFilterObject:this.currentFilterObject,currentFilteringColumn:t.isNullOrUndefined(this.column)?void 0:this.column.field,columns:this.filterSettings.columns,requestType:"filtering",type:Dt};this.parent.trigger(Dt,t.extend(e,i)),this.isRemove=!1},r.prototype.wireEvents=function(){t.EventHandler.add(this.parent.getHeaderContent(),"keyup",this.keyUpHandlerImmediate,this)},r.prototype.unWireEvents=function(){t.EventHandler.remove(this.parent.getHeaderContent(),"keyup",this.keyUpHandlerImmediate)},r.prototype.enableAfterRender=function(e){e.module===this.getModuleName()&&e.enable&&(this.parent.getHeaderTable().classList.add("e-sortfilter"),this.render())},r.prototype.refreshFilterValue=function(){"FilterBar"===this.filterSettings.type&&this.filterSettings.columns.length&&!this.parent.getCurrentViewRecords().length&&this.parent.enablePersistence&&(this.initialEnd(),this.parent.removeEventListener(ai,this.refreshFilterValueFn))},r.prototype.initialEnd=function(){if(this.parent.off(xi,this.initialEnd),this.parent.getColumns().length&&this.filterSettings.columns.length){var e=this.parent;this.contentRefresh=!1,this.initialLoad=!0;for(var t=0,i=e.filterSettings.columns;t<i.length;t++){var r=i[t];this.filterByColumn(r.field,r.operator,r.value,r.predicate,r.matchCase,r.ignoreAccent,r.actualFilterValue,r.actualOperator)}this.initialLoad=!1,this.updateFilterMsg(),this.contentRefresh=!0}},r.prototype.addEventListener=function(){this.parent.isDestroyed||(this.parent.on(vo,this.setFullScreenDialog,this),this.parent.on(Fi,this.enableAfterRender,this),this.parent.on(ki,this.onActionComplete,this),this.parent.on(Ii,this.onPropertyChanged,this),this.parent.on(_i,this.keyUpHandler,this),this.parent.on(Ji,this.columnPositionChanged,this),this.parent.on(Di,this.render,this),this.parent.on(xi,this.initialEnd,this),this.parent.on(Br,this.filterMenuClose,this),this.docClickHandler=this.clickHandler.bind(this),t.EventHandler.add(document,"click",this.docClickHandler,this),t.EventHandler.add(this.parent.element,"mousedown",this.refreshClearIcon,this),this.parent.on(kr,this.columnMenuFilter,this),this.parent.on(Wi,this.filterIconClickHandler,this),this.parent.on("persist-data-changed",this.initialEnd,this),this.parent.on(Hn,this.clickHandler,this),this.parent.on(Ki,this.destroy,this),this.refreshFilterValueFn=this.refreshFilterValue.bind(this),this.parent.addEventListener(ai,this.refreshFilterValueFn))},r.prototype.removeEventListener=function(){t.EventHandler.remove(document,"click",this.docClickHandler),t.EventHandler.remove(this.parent.element,"mousedown",this.refreshClearIcon),this.parent.isDestroyed||(this.parent.off(vo,this.setFullScreenDialog),this.parent.off(Fi,this.enableAfterRender),this.parent.off(ki,this.onActionComplete),this.parent.off(Ii,this.onPropertyChanged),this.parent.off(_i,this.keyUpHandler),this.parent.off(Ji,this.columnPositionChanged),this.parent.off(Di,this.render),this.parent.off(kr,this.columnMenuFilter),this.parent.off(Br,this.filterMenuClose),this.parent.off(Wi,this.filterIconClickHandler),this.parent.off(Hn,this.clickHandler),this.parent.off(Ki,this.destroy))},r.prototype.refreshClearIcon=function(e){if(this.parent.allowFiltering&&"FilterBar"===this.parent.filterSettings.type&&e.target.classList.contains("e-clear-icon")){var t=e.target.previousElementSibling;o.Input.setValue(null,t,"Never",!0),"Immediate"===this.filterSettings.mode&&this.removeFilteredColsByField(t.id.slice(0,-14))}},r.prototype.filterMenuClose=function(){this.fltrDlgDetails.isOpen=!1},r.prototype.filterByColumn=function(e,i,r,n,o,s,l,a){var h,d=this,p=this.parent;if(this.column=p.grabColumnByFieldFromAllCols(e),"FilterBar"===this.filterSettings.type&&this.filterSettings.showFilterBarOperator&&t.isNullOrUndefined(this.column.filterBarTemplate)&&(i=this.getOperatorName(e)),this.column)if("FilterBar"===this.filterSettings.type&&(h=p.getHeaderContent().querySelector("[id='"+this.column.field+"_filterBarcell']")),t.isNullOrUndefined(this.column.allowFiltering)||this.column.allowFiltering)if(W(p))p.notify(ur,{instance:this,handler:this.filterByColumn,arg1:e,arg2:i,arg3:r,arg4:n,arg5:o,arg6:s,arg7:l,arg8:a});else{if(this.predicate=n||(Array.isArray(r)?"or":"and"),this.value=r,this.matchCase=o||!1,this.ignoreAccent=this.ignoreAccent=t.isNullOrUndefined(s)?this.parent.filterSettings.ignoreAccent:s,this.fieldName=e,this.operator=i,r=t.isNullOrUndefined(r)?r:r.toString(),"number"!==this.column.type&&"date"!==this.column.type||(this.matchCase=!0),p.getColumnHeaderByField(e).setAttribute("aria-filtered","true"),h&&"FilterBar"===this.filterSettings.type){if(r&&r.length<1||!this.filterByMethod&&this.checkForSkipInput(this.column,r))return this.filterStatusMsg=r&&r.length<1?"":this.l10n.getConstant("InvalidFilterMessage"),void this.updateFilterMsg();h.value!==r&&(h.value=r)}t.isNullOrUndefined(this.column.format)?this.values[this.column.field]=r:(this.applyColumnFormat(r),this.initialLoad&&"FilterBar"===this.filterSettings.type&&(h.value=this.values[this.column.field]));var c={field:this.fieldName,predicate:n,matchCase:o,ignoreAccent:s,operator:this.operator,value:this.value,type:this.column.type};this.parent.filterSettings.columns.filter(function(e){return e.field===d.fieldName}).length>1&&!t.isNullOrUndefined(this.actualPredicate[this.fieldName])?this.actualPredicate[this.fieldName].push(c):this.actualPredicate[this.fieldName]=[c],this.checkAlreadyColFiltered(this.column.field)||this.updateModel()}else this.parent.log("action_disabled_column",{moduleName:this.getModuleName(),columnName:this.column.headerText})},r.prototype.applyColumnFormat=function(e){var t=this,i="date"===this.column.type||"datetime"===this.column.type?new Date(e):parseFloat(e);("date"===this.column.type||"datetime"===this.column.type)&&e&&e.split(",").length>1?this.values[this.column.field]=e.split(",").map(function(e){return t.setFormatForFlColumn(new Date(e),t.column)}):this.values[this.column.field]=this.setFormatForFlColumn(i,this.column)},r.prototype.skipUid=function(e){for(var t=!0,i=Object.keys(e),r=0;r<i.length;r++){var n=Object.keys(e[i[r]]);1===n.length&&"uid"===n[0]&&(t=!1)}return t},r.prototype.onPropertyChanged=function(e){if(e.module===this.getModuleName())for(var i=0,r=Object.keys(e.properties);i<r.length;i++){var n=r[i];switch(n){case"columns":var o={currentFilterObject:this.currentFilterObject,currentFilteringColumn:this.column?this.column.field:void 0,action:"filter",columns:this.filterSettings.columns,requestType:"filtering",type:zt,cancel:!1};if(this.contentRefresh&&this.skipUid(e.properties.columns)){if(this.parent.notify(Ti,o),o.cancel)return void(t.isNullOrUndefined(this.prevFilterObject)?this.filterSettings.columns.splice(this.filterSettings.columns.length-1,1):this.filterSettings.columns[this.filterObjIndex]=this.prevFilterObject);this.updateFilterIcon(),this.refreshFilterSettings(),this.updateFilterMsg(),this.updateFilter()}break;case"showFilterBarStatus":e.properties[n]?this.updateFilterMsg():this.parent.allowPaging&&this.parent.updateExternalMessage("");break;case"showFilterBarOperator":case"type":this.parent.refreshHeader(),this.refreshFilterSettings()}}},r.prototype.refreshFilterSettings=function(){if("FilterBar"===this.filterSettings.type){for(var e=0;e<this.filterSettings.columns.length;e++){this.column=this.parent.grabColumnByUidFromAllCols(this.filterSettings.columns[e].uid);var i=this.filterSettings.columns[e].value;if(i=!t.isNullOrUndefined(i)&&i.toString(),t.isNullOrUndefined(this.column.format)){var r=this.filterSettings.columns[e].field;this.values[r]=this.filterSettings.columns[e].value}else this.applyColumnFormat(i);(o=this.getFilterBarElement(this.column.field))&&(""===this.cellText[this.filterSettings.columns[e].field]||t.isNullOrUndefined(this.cellText[this.filterSettings.columns[e].field])?o.value=this.filterSettings.columns[e].value:o.value=this.cellText[this.column.field])}if(0===this.filterSettings.columns.length){var n=this.parent.getColumns();for(e=0;e<n.length;e++){var o;(o=this.getFilterBarElement(n[e].field))&&""!==o.value&&(o.value="",delete this.values[n[e].field])}}}},r.prototype.updateFilterIcon=function(){if(0===this.filterSettings.columns.length&&this.parent.element.querySelector(".e-filtered"))for(var e=[].slice.call(this.parent.element.getElementsByClassName("e-filtered")),t=0,i=e.length;t<i;t++)e[t].removeAttribute("aria-filtered"),e[t].classList.remove("e-filtered")},r.prototype.getFilterBarElement=function(e){var i,r="[id='"+e+"_filterBarcell']";return r&&!t.isNullOrUndefined(this.element)&&(i=this.element.querySelector(r)),i},r.prototype.refreshFilter=function(){this.refreshFilterSettings(),this.updateFilterMsg()},r.prototype.clearFiltering=function(e){var i=this,r=k(this.filterSettings.columns);if(!t.isNullOrUndefined(e))return this.refresh=!1,e.forEach(function(e){i.removeFilteredColsByField(e,!1)}),this.parent.setProperties({filterSettings:{columns:this.filterSettings.columns}},!0),this.parent.renderModule.refresh(),void(this.refresh=!0);if(W(this.parent))this.parent.notify(ur,{instance:this,handler:this.clearFiltering});else{for(var n=0;n<r.length;n++)r[n].uid=r[n].uid||this.parent.getColumnByField(r[n].field).uid;var o=r.map(function(e){return e.uid}),s=o.filter(function(e,t){return o.indexOf(e)===t});this.refresh=!1;n=0;for(var l=s.length;n<l;n++)this.removeFilteredColsByField(this.parent.getColumnByUid(s[n]).field,!1);if(this.refresh=!0,s.length&&this.parent.renderModule.refresh(),0===this.parent.filterSettings.columns.length&&this.parent.element.querySelector(".e-filtered")){var a=[].slice.call(this.parent.element.getElementsByClassName("e-filtered"));for(n=0,l=a.length;n<l;n++)a[0].removeAttribute("aria-filtered"),a[0].classList.remove("e-filtered")}this.isRemove=!0,this.filterStatusMsg="",this.updateFilterMsg()}},r.prototype.checkAlreadyColFiltered=function(e){for(var t=0,i=this.filterSettings.columns;t<i.length;t++){var r=i[t];if(r.field===e&&r.value===this.value&&r.operator===this.operator&&r.predicate===this.predicate)return!0}return!1},r.prototype.columnMenuFilter=function(e){this.column=e.col;var i=t.closest(e.target,"#"+e.id);e.isClose&&!i?this.filterModule.closeDialog():i&&this.filterDialogOpen(this.column,e.target)},r.prototype.filterDialogOpen=function(e,t,i,r){this.filterModule&&this.filterModule.closeDialog(),this.setFilterModel(e),this.filterModule.openDialog(this.createOptions(e,t,i,r))},r.prototype.createOptions=function(e,i,r,n){var o=this.parent,s=e.filter.dataSource||o.dataSource&&"result"in o.dataSource?o.dataSource:o.getDataModule().dataManager,l=e.filter.type||this.parent.filterSettings.type;return{type:e.type,field:e.field,displayName:e.headerText,dataSource:s,format:e.format,height:800,columns:o.getColumns(),filteredColumns:o.filterSettings.columns,target:i,dataManager:o.getDataModule().dataManager,formatFn:e.getFormatter(),ignoreAccent:o.filterSettings.ignoreAccent,parserFn:e.getParser(),query:o.query,template:e.getFilterItemTemplate(),hideSearchbox:!t.isNullOrUndefined(e.filter.hideSearchbox)&&e.filter.hideSearchbox,handler:this.filterHandler.bind(this),localizedStrings:o.getLocaleConstants(),position:{X:r,Y:n},column:e,foreignKeyValue:e.foreignKeyValue,actualPredicate:this.actualPredicate,localeObj:o.localeObj,isRemote:o.getDataModule().isRemote(),allowCaseSensitive:this.filterSettings.enableCaseSensitivity,isResponsiveFilter:this.parent.enableAdaptiveUI,operator:this.actualPredicate[e.field]&&"Menu"===l?this.actualPredicate[e.field][0].operator:"equal"}},r.prototype.removeFilteredColsByField=function(e,t){var i,r=this.filterSettings.columns;if(W(this.parent)){var n={instance:this,handler:this.removeFilteredColsByField,arg1:e,arg2:t};this.parent.notify(ur,n)}else{for(var o=r.map(function(e){return e.uid}),s=o.filter(function(e,t){return o.indexOf(e)===t}),l=function(n,o){r[n].uid=r[n].uid||a.parent.getColumnByField(r[n].field).uid;var l=r.length,h=a.parent.grabColumnByUidFromAllCols(s[n]);if(h.field===e||h.field===h.foreignKeyValue&&h.isForeignColumn()){var d=a.filterSettings.columns.filter(function(e){return e.uid===h.uid})[0];if("FilterBar"===a.filterSettings.type&&!t){var p="[id='"+h.field+"_filterBarcell']";(i=a.parent.getHeaderContent().querySelector(p))&&(i.value="",delete a.values[e])}for(;l--;)r[l].uid===h.uid&&r.splice(l,1);var c=a.parent.getColumnHeaderByField(h.field);if(c.removeAttribute("aria-filtered"),"FilterBar"!==a.filterSettings.type){var u=a.parent.showColumnMenu&&h.showColumnMenu?".e-columnmenu":".e-icon-filter";c.querySelector(u).classList.remove("e-filtered")}return a.isRemove=!0,a.actualPredicate[e]&&delete a.actualPredicate[e],a.values[e]&&delete a.values[e],a.refresh&&a.parent.notify(Ti,{requestType:"filtering",type:zt,currentFilterObject:d,currentFilterColumn:h,action:"clearFilter"}),"break"}},a=this,h=0,d=s.length;h<d;h++){if("break"===l(h))break}this.updateFilterMsg()}},r.prototype.getModuleName=function(){return"filter"},r.prototype.keyUpHandlerImmediate=function(e){13!==e.keyCode&&this.keyUpHandler(e)},r.prototype.keyUpHandler=function(e){var i=this.parent,r=e.target;if(r&&t.matches(r,".e-filterbar input")){var n=t.closest(r,"th.e-filterbarcell");if(this.column=i.getColumnByUid(n.getAttribute("e-mappinguid")),!this.column)return;if("altDownArrow"===e.action&&this.parent.filterSettings.showFilterBarOperator){var o=t.closest(r,"span").querySelector(".e-filterbaroperator");o.ej2_instances[0].showPopup(),o.focus()}"Immediate"!==this.filterSettings.mode&&(13!==e.keyCode||e.target.classList.contains("e-filterbaroperator"))||9===e.keyCode||this.column.filterTemplate||(this.value=r.value.trim(),this.processFilter(e))}if("altDownArrow"===e.action&&"FilterBar"!==this.filterSettings.type){var s=i.focusModule.currentInfo.element;if(s&&s.classList.contains("e-headercell")){var l=i.getColumnByUid(s.firstElementChild.getAttribute("e-mappinguid"));this.openMenuByField(l.field),this.parent.focusModule.clearIndicator()}}"escape"===e.action&&"Menu"===this.filterSettings.type&&this.filterModule&&(this.filterModule.closeDialog(),i.notify(vn,{}))},r.prototype.updateCrossIcon=function(e){e.value.length&&e.nextElementSibling.classList.remove("e-hide")},r.prototype.updateFilterMsg=function(){if("FilterBar"===this.filterSettings.type){var e=this.parent,i=void 0,r=this.filterSettings.columns,n=void 0;if(!this.filterSettings.showFilterBarStatus)return;if(r.length>0&&this.filterStatusMsg!==this.l10n.getConstant("InvalidFilterMessage")){this.filterStatusMsg="";for(var o=0;o<r.length;o++)if(n=e.grabColumnByUidFromAllCols(r[o].uid)||e.grabColumnByFieldFromAllCols(r[o].field),o&&(this.filterStatusMsg+=" && "),t.isNullOrUndefined(n.format))this.filterStatusMsg+=n.headerText+": "+this.values[n.field];else{var s="date"===n.type||"datetime"===n.type?this.valueFormatter.fromView(this.values[n.field],n.getParser(),n.type):this.values[n.field];if("date"!==n.type&&"datetime"!==n.type){i=this.serviceLocator.getService("valueFormatter").toView(s,n.getParser()).toString()}else i=this.setFormatForFlColumn(s,n);this.filterStatusMsg+=n.headerText+": "+i}}e.allowPaging&&e.updateExternalMessage(this.filterStatusMsg),this.filterStatusMsg=""}},r.prototype.setFormatForFlColumn=function(e,t){return this.serviceLocator.getService("valueFormatter").toView(e,t.getFormatter()).toString()},r.prototype.checkForSkipInput=function(e,t){var r;if("number"===e.type)(i.DataUtil.operatorSymbols[t]||this.skipNumberInput.indexOf(t)>-1)&&(r=!0);else if("string"===e.type)for(var n=0,o=t;n<o.length;n++){var s=o[n];this.skipStringInput.indexOf(s)>-1&&(r=!0)}return r},r.prototype.processFilter=function(e){this.stopTimer(),this.startTimer(e)},r.prototype.startTimer=function(e){var t=this;this.timer=window.setInterval(function(){t.onTimerTick()},13===e.keyCode?0:this.filterSettings.immediateModeDelay)},r.prototype.stopTimer=function(){window.clearInterval(this.timer)},r.prototype.onTimerTick=function(){var e="[id='"+this.column.field+"_filterBarcell']",i=this.element.querySelector(e);!i&&this.parent.isFrozenGrid()&&(i=this.parent.getHeaderContent().querySelector(e));var r;if(this.cellText[this.column.field]=i.value,this.stopTimer(),t.isNullOrUndefined(this.column.filterBarTemplate))r=JSON.parse(JSON.stringify(i.value));else{var n=this.column.filterBarTemplate.read;"string"==typeof n&&(n=t.getValue(n,window)),t.isNullOrUndefined(n)||(this.value=n.call(this,i))}t.isNullOrUndefined(this.value)||""===this.value?this.removeFilteredColsByField(this.column.field):(this.validateFilterValue(this.value),this.filterByMethod=!1,this.filterByColumn(this.column.field,this.operator,this.value,this.predicate,this.filterSettings.enableCaseSensitivity,this.ignoreAccent),this.filterByMethod=!0,i.value=r,this.updateFilterMsg())},r.prototype.validateFilterValue=function(e){var i,r;switch(this.matchCase=this.filterSettings.enableCaseSensitivity,this.column.type){case"number":this.column.filter.operator?this.operator=this.column.filter.operator:this.operator=this.filterOperators.equal,i=[">","<","=","!"];for(var n=0;n<e.length;n++)if(i.indexOf(e[n])>-1){r=n;break}this.getOperator(e.substring(r)),0!==r&&(this.value=e.substring(0,r)),""!==this.value&&e.length>=1&&(this.value=this.valueFormatter.fromView(this.value,this.column.getParser(),this.column.type)),isNaN(this.value)&&(this.filterStatusMsg=this.l10n.getConstant("InvalidFilterMessage"));break;case"date":case"datetime":this.operator=this.filterOperators.equal,""===this.value||this.value instanceof Date||(this.getOperator(e),this.value=this.valueFormatter.fromView(this.value,this.column.getParser(),this.column.type),t.isNullOrUndefined(this.value)&&(this.filterStatusMsg=this.l10n.getConstant("InvalidFilterMessage")));break;case"string":this.matchCase=!1,"*"===e.charAt(0)?(this.value=this.value.slice(1),this.operator=this.filterOperators.startsWith):"%"===e.charAt(e.length-1)?(this.value=this.value.slice(0,-1),this.operator=this.filterOperators.startsWith):"%"===e.charAt(0)?(this.value=this.value.slice(1),this.operator=this.filterOperators.endsWith):this.column.filter.operator?this.operator=this.column.filter.operator:this.operator=this.filterOperators.startsWith;break;case"boolean":"true"===e.toLowerCase()||"1"===e?this.value=!0:"false"===e.toLowerCase()||"0"===e?this.value=!1:e.length&&(this.filterStatusMsg=this.l10n.getConstant("InvalidFilterMessage")),this.operator=this.filterOperators.equal;break;default:this.column.filter.operator?this.operator=this.column.filter.operator:this.operator=this.filterOperators.equal}},r.prototype.getOperator=function(e){var r=e.charAt(0),n=e.slice(0,2),o=t.extend({"=":this.filterOperators.equal,"!":this.filterOperators.notEqual},i.DataUtil.operatorSymbols);(o.hasOwnProperty(r)||o.hasOwnProperty(n))&&(this.operator=o[r],this.value=e.substring(1),this.operator||(this.operator=o[n],this.value=e.substring(2))),this.operator!==this.filterOperators.lessThan&&this.operator!==this.filterOperators.greaterThan||"="===this.value.charAt(0)&&(this.operator=this.operator+"orequal",this.value=this.value.substring(1))},r.prototype.columnPositionChanged=function(){this.parent.filterSettings.type},r.prototype.getLocalizedCustomOperators=function(){var e=[{value:"equal",text:this.l10n.getConstant("Equal")},{value:"greaterthan",text:this.l10n.getConstant("GreaterThan")},{value:"greaterthanorequal",text:this.l10n.getConstant("GreaterThanOrEqual")},{value:"lessthan",text:this.l10n.getConstant("LessThan")},{value:"lessthanorequal",text:this.l10n.getConstant("LessThanOrEqual")},{value:"notequal",text:this.l10n.getConstant("NotEqual")}];this.customOperators={stringOperator:[{value:"startswith",text:this.l10n.getConstant("StartsWith")},{value:"endswith",text:this.l10n.getConstant("EndsWith")},{value:"contains",text:this.l10n.getConstant("Contains")},{value:"equal",text:this.l10n.getConstant("Equal")},{value:"notequal",text:this.l10n.getConstant("NotEqual")}],numberOperator:e,dateOperator:e,datetimeOperator:e,booleanOperator:[{value:"equal",text:this.l10n.getConstant("Equal")},{value:"notequal",text:this.l10n.getConstant("NotEqual")}]}},r.prototype.openMenuByField=function(e){var t=this.parent;if(t.enableAdaptiveUI)this.showCustomFilter(!1);else{var i=t.getColumnByField(e),r=t.getColumnHeaderByField(e).querySelector(".e-filtermenudiv");if(r){var n=t.element.getBoundingClientRect(),o=r.getBoundingClientRect();this.filterDialogOpen(i,r,o.right-n.left,o.bottom-n.top)}}},r.prototype.filterIconClickHandler=function(e){var t=e.target;if(t.classList.contains("e-filtermenudiv")&&("Menu"===this.parent.filterSettings.type||"CheckBox"===this.parent.filterSettings.type||"Excel"===this.parent.filterSettings.type)){var i=this.parent.getColumnByUid(D(t,"e-headercell").firstElementChild.getAttribute("e-mappinguid"));if(this.column=i,this.fltrDlgDetails.field===i.field&&this.fltrDlgDetails.isOpen)return;this.filterModule&&this.filterModule.closeDialog(),this.fltrDlgDetails={field:i.field,isOpen:!0},this.openMenuByField(i.field)}},r.prototype.clickHandler=function(e){if("FilterBar"===this.filterSettings.type&&this.filterSettings.showFilterBarOperator&&(D(e.target,"e-filterbarcell")&&e.target.classList.contains("e-input-group-icon")&&t.closest(e.target,"div").querySelector(".e-filterbaroperator").focus(),e.target.classList.contains("e-list-item"))){var i=document.querySelector(".e-popup-open").getAttribute("id").replace("_popup","");-1!==i.indexOf("grid-column")&&t.closest(document.getElementById(i),"div").querySelector(".e-filtertext").focus()}if("Immediate"===this.filterSettings.mode||"Menu"===this.parent.filterSettings.type||"CheckBox"===this.parent.filterSettings.type||"Excel"===this.parent.filterSettings.type){var r=e.target,n=r.classList.contains("e-day"),o=D(this.parent.element,"e-dialog"),s=!1,l=D(r,"e-popup"),a=this.parent.element.querySelector(".e-filter-popup");if(o&&l&&(s=o.id===l.id),a&&(D(r,"e-excel-ascending")||D(r,"e-excel-descending"))&&this.filterModule.closeDialog(r),D(r,"e-filter-popup")||r.classList.contains("e-filtermenudiv"))return;!this.filterModule||D(r,"e-popup-wrapper")||t.closest(r,".e-filter-item.e-menu-item")||n||(s&&!D(r,"e-filter-popup")&&!D(r,"e-popup-flmenu")||!l&&a)&&(this.filterModule.isresetFocus=D(r,"e-grid")&&D(r,"e-grid").id===this.parent.element.id,this.filterModule.closeDialog(r))}},r.prototype.filterHandler=function(e){this.actualPredicate[e.field]=e.actualPredicate;for(var t=new i.DataManager(this.filterSettings.columns),r=(new i.Query).where("field",this.filterOperators.equal,e.field),n=t.executeLocal(r),o=0;o<n.length;o++){for(var s=-1,l=0;l<this.filterSettings.columns.length;l++)if(n[o].field===this.filterSettings.columns[l].field){s=l;break}-1!==s&&this.filterSettings.columns.splice(s,1)}this.values[e.field]&&delete this.values[e.field];var a=this.parent.getColumnByField(e.field),h=this.parent.showColumnMenu&&a.showColumnMenu?".e-columnmenu":".e-icon-filter",d=this.parent.getColumnHeaderByField(e.field).querySelector(h);"filtering"===e.action?(this.filterSettings.columns=this.filterSettings.columns.concat(e.filterCollection),this.filterSettings.columns.length&&d&&d.classList.add("e-filtered")):(d&&d.classList.remove("e-filtered"),e.requestType="filtering",this.parent.renderModule.refresh(e)),this.parent.dataBind()},r.prototype.updateFilter=function(){var e=this.filterSettings.columns;this.actualPredicate={};for(var t=0;t<e.length;t++){this.column=this.parent.getColumnByField(e[t].field)||oe(e[t].field,this.parent.getForeignKeyColumns());var i=e[t].field;this.parent.getColumnByField(e[t].field)||(i=oe(e[t].field,this.parent.getForeignKeyColumns()).field),this.refreshFilterIcon(i,e[t].operator,e[t].value,e[t].type,e[t].predicate,e[t].matchCase,e[t].ignoreAccent,e[t].uid)}},r.prototype.refreshFilterIcon=function(e,t,i,r,n,o,s,l){var a={field:e,predicate:n,matchCase:o,ignoreAccent:s,operator:t,value:i,type:r};this.actualPredicate[e]?this.actualPredicate[e].push(a):this.actualPredicate[e]=[a];var h=l?this.parent.grabColumnByUidFromAllCols(l).field:e;this.addFilteredClass(h)},r.prototype.addFilteredClass=function(e){var t,i=this.parent.getColumnByField(e);this.parent.showColumnMenu&&i.showColumnMenu?t=this.parent.getColumnHeaderByField(e).querySelector(".e-columnmenu"):i&&(t=this.parent.getColumnHeaderByField(e).querySelector(".e-icon-filter")),t&&t.classList.add("e-filtered")},r.prototype.getFilterUIInfo=function(){return this.filterModule?this.filterModule.getFilterUIInfo():{}},r.prototype.getOperatorName=function(e){return document.getElementById(this.parent.getColumnByField(e).uid).ej2_instances[0].value},r.prototype.renderCheckboxOnFilterMenu=function(){return this.filterModule.renderCheckBoxMenu()},r}(),Ia={root:"e-rhandler",suppress:"e-rsuppress",icon:"e-ricon",helper:"e-rhelper",header:"th.e-headercell",cursor:"e-rcursor"},Ta=function(){function i(e){this.tapped=!1,this.isDblClk=!0,this.parent=e,this.parent.isDestroyed||(this.widthService=new dl(e),this.addEventListener())}return i.prototype.autoFitColumns=function(e){var t=void 0===e||null===e||e.length<=0?this.parent.getColumns().map(function(e){return e.field}):"string"==typeof e?[e]:e;this.parent.isAutoFitColumns=!0,this.findColumn(t)},i.prototype.autoFit=function(){var e=this.parent.getColumns().filter(function(e){return!0===e.autoFit}).map(function(e){return e.field||e.headerText});e.length>0&&this.autoFitColumns(e),"Auto"===this.parent.resizeSettings.mode&&this.widthService.setWidthToTable()},i.prototype.resizeColumn=function(e,i,r){var n,o,s,l,a,h,d=this.parent,p=0,c=Ko,u=0,g=r||this.parent.getUidByColumnField(e),f=this.parent.getNormalizedColumnIndex(g),m=this.parent.getColumnIndexByField(e),y=d.getFrozenColumns()||d.getFrozenLeftColumnsCount(),v=d.getMovableColumnsCount();if(t.isNullOrUndefined(d.getFooterContent())||(s=d.getFooterContentTable()),d.isFrozenGrid()){var C=d.getColumnByField(e);C.getFreezeTableName()===ps?(n=d.getHeaderTable(),o=d.getContentTable(),l=n.querySelector('[e-mappinguid="'+g+'"]').parentElement.cloneNode(!0),a=o.querySelectorAll("td:nth-child("+(f+1)+")"),s&&(h=s.querySelectorAll("td:nth-child("+(f+1)+")"))):"movable"===C.getFreezeTableName()?(n=d.getHeaderContent().querySelector("."+Jo).children[0],o=d.getContent().querySelector("."+Yo).children[0],l=n.querySelector('[e-mappinguid="'+g+'"]').parentElement.cloneNode(!0),a=o.querySelectorAll("td:nth-child("+(f-y+1)+")"),s&&(h=(s=d.getFooterContent().querySelector(".e-movablefootercontent").children[0]).querySelectorAll("td:nth-child("+(f-y+1)+")"))):C.getFreezeTableName()===ds&&(n=d.getHeaderContent().querySelector(".e-frozen-right-header").children[0],o=d.getContent().querySelector(".e-frozen-right-content").children[0],l=n.querySelector('[e-mappinguid="'+g+'"]').parentElement.cloneNode(!0),a=o.querySelectorAll("td:nth-child("+(f-(y+v)+1)+")"),s&&(h=(s=d.getFooterContent().querySelector(".e-movablefootercontent").children[0]).querySelectorAll("td:nth-child("+(f-(y+v)+1)+")")))}else n=d.getHeaderTable(),o=d.getContentTable(),l=n.querySelector('[e-mappinguid="'+g+'"]').parentElement.cloneNode(!0),a=o.querySelectorAll("td:nth-child("+(f+1)+"):not(.e-groupcaption)"),s&&(h=s.querySelectorAll("td:nth-child("+(f+1)+"):not(.e-groupcaption)"));var w=[].slice.call(n.querySelector("tr").getElementsByClassName("e-grouptopleftcell"));if(w.length>0)for(var b=0;b<w.length;b++)u+=w[b].offsetWidth;var S=o.querySelector(".e-detailrowcollapse")||o.querySelector(".e-detailrowexpand");(this.parent.detailTemplate||this.parent.childGrid)&&S&&(u+=S.offsetWidth);var R=[l],x=[],F=[];if(s)for(b=0;b<h.length;b++)F[b]=h[b].cloneNode(!0);for(b=0;b<a.length;b++)x[b]=a[b].cloneNode(!0);var E=this.createTable(n,R,"e-gridheader"),I=null,T=null;d.getCurrentViewRecords().length&&(T=this.createTable(o,x,c)),F.length&&(I=this.createTable(s,F,"e-gridfooter"));var z=d.getColumns()[m],D=z.width=t.formatUnit(Math.max(E,T,I)),M=z.maxWidth&&parseFloat(z.maxWidth.toString());parseInt(D,10)>M&&(z.width=M),this.widthService.setColumnWidth(d.getColumns()[m]);if(!1===d.getColumns().some(function(e){return null===e.width||void 0===e.width||e.width.length<=0})){var O=d.getColumns();for(b=0;b<O.length;b++)O[b].visible&&(p+=parseFloat(O[b].width))}var k=p+u;p>0&&!d.isFrozenGrid()&&((this.parent.detailTemplate||this.parent.childGrid)&&this.widthService.setColumnWidth(new St({width:"30px"})),"Auto"===this.parent.resizeSettings.mode&&(k="100%"),n.style.width=t.formatUnit(k),o.style.width=t.formatUnit(k),t.isNullOrUndefined(s)||(s.style.width=t.formatUnit(k))),d.isFrozenGrid()&&this.widthService.refreshFrozenScrollbar();var A=n.offsetWidth;d.getContent().scrollWidth>A?(n.classList.add("e-tableborder"),o.classList.add("e-tableborder")):(n.classList.remove("e-tableborder"),o.classList.remove("e-tableborder")),t.isNullOrUndefined(s)||s.classList.add("e-tableborder")},i.prototype.destroy=function(){var e=this.parent.element;e&&(e.querySelector("."+Wo)||e.querySelector("."+Ko))&&(this.widthService=null,this.unwireEvents(),this.removeEventListener())},i.prototype.getModuleName=function(){return"resize"},i.prototype.findColumn=function(e){for(var i=0;i<e.length;i++){var r=e[i],n=this.parent.getColumnIndexByField(r),o=this.parent.getColumns()[n];n>-1&&!t.isNullOrUndefined(o)&&!0===o.visible&&this.resizeColumn(r,n)}},i.prototype.createTable=function(e,t,i){var r=this.parent.createElement("div");r.className=this.parent.element.className,r.style.cssText="display: inline-block;visibility:hidden;position:absolute";var n=this.parent.createElement("div");n.className=i;var o=this.parent.createElement("table");o.className=e.className,o.classList.add("e-resizetable"),o.style.cssText="table-layout: auto;width: auto";for(var s=this.parent.createElement("tr"),l=0;l<t.length;l++){var a=s.cloneNode();a.className=e.querySelector("tr").className,a.appendChild(t[l]),o.appendChild(a)}n.appendChild(o),r.appendChild(n),document.body.appendChild(r);var h=o.getBoundingClientRect().width;return document.body.removeChild(r),Math.ceil(h)},i.prototype.addEventListener=function(){this.parent.isDestroyed||(this.parent.on(Di,this.refreshHeight,this),this.parent.on(Si,this.wireEvents,this),this.parent.on(xi,this.autoFit,this),this.parent.on(Yn,this.refreshHeight,this),this.parent.on(Ki,this.destroy,this))},i.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(Di,this.refreshHeight),this.parent.off(Si,this.wireEvents),this.parent.off(Yn,this.refreshHeight),this.parent.off(Ki,this.destroy))},i.prototype.render=function(){this.unwireEvents(),this.wireEvents(),this.setHandlerHeight()},i.prototype.refreshHeight=function(){if(this.parent.getHeaderTable()){for(var e=this.getResizeHandlers(),t=0;t<e.length;t++)e[t].parentElement.offsetHeight>0&&(e[t].style.height=e[t].parentElement.offsetHeight+"px");this.setHandlerHeight()}},i.prototype.wireEvents=function(){t.EventHandler.add(this.parent.getHeaderContent(),t.Browser.touchStartEvent,this.touchResizeStart,this),t.EventHandler.add(this.parent.getHeaderContent(),or,this.callAutoFit,this)},i.prototype.unwireEvents=function(){t.EventHandler.remove(this.parent.getHeaderContent(),t.Browser.touchStartEvent,this.touchResizeStart),t.EventHandler.remove(this.parent.getHeaderContent(),or,this.callAutoFit)},i.prototype.getResizeHandlers=function(){return this.parent.isFrozenGrid()?[].slice.call(this.parent.getHeaderContent().getElementsByClassName(Ia.root)):[].slice.call(this.parent.getHeaderTable().getElementsByClassName(Ia.root))},i.prototype.setHandlerHeight=function(){for(var e=[].slice.call(this.parent.getHeaderTable().getElementsByClassName(Ia.suppress)),t=0;t<e.length;t++)e[t].style.height=e[t].parentElement.offsetHeight+"px"},i.prototype.callAutoFit=function(e){if(e.target.classList.contains("e-rhandler")){var i=this.getTargetColumn(e);if(i.columns)return;this.resizeColumn(i.field,this.parent.getNormalizedColumnIndex(i.uid),i.uid);t.closest(e.target,Ia.header).classList.add("e-resized")}},i.prototype.touchResizeStart=function(t){if(!e.Global.timer)return e.Global.timer=setTimeout(function(){e.Global.timer=null},300),this.resizeStart(t);clearTimeout(e.Global.timer),e.Global.timer=null,this.callAutoFit(t)},i.prototype.resizeStart=function(e){var i=this;if(e.target.classList.contains("e-rhandler")){if(!this.helper){if(0===this.getScrollBarWidth()){if(this.parent.allowGrouping)for(var r=0;r<this.parent.groupSettings.columns.length;r++)this.widthService.setColumnWidth(new St({width:"30px"}),r);for(var n=0,o=this.refreshColumnWidth();n<o.length;n++){var s=o[n];this.widthService.setColumnWidth(s)}this.widthService.setWidthToTable()}if(this.refreshStackedColumnWidth(),this.element=e.target,this.parent.getVisibleFrozenColumns()){var l=this.parent.getMovableContentTbody(),a=this.parent.getFrozenLeftContentTbody(),h=this.parent.getFrozenRightContentTbody(),d=[].slice.call(l.querySelectorAll("tr")),p=[].slice.call(a.querySelectorAll("tr")),c=[];this.parent.getFrozenMode()===hs&&h&&(c=[].slice.call(h.querySelectorAll("tr")));var u=function(e){Me(g.parent,function(t,r){i.parent.rowHeight?r[e].style.height=i.parent.rowHeight+"px":r[e].style.removeProperty("height")},[p,d,c])},g=this;for(r=0;r<d.length;r++)u(r)}this.parentElementWidth=this.parent.element.getBoundingClientRect().width,this.appendHelper(),this.column=this.getTargetColumn(e),this.pageX=this.getPointX(e),this.column.getFreezeTableName()===ds?this.parent.enableRtl?this.minMove=(this.column.minWidth?parseFloat(this.column.minWidth.toString()):0)-parseFloat(t.isNullOrUndefined(this.column.width)?"":this.column.width.toString()):this.minMove=parseFloat(t.isNullOrUndefined(this.column.width)?"":this.column.width.toString())-(this.column.minWidth?parseFloat(this.column.minWidth.toString()):0):this.parent.enableRtl?this.minMove=parseFloat(this.column.width.toString())-(this.column.minWidth?parseFloat(this.column.minWidth.toString()):0):this.minMove=(this.column.minWidth?parseFloat(this.column.minWidth.toString()):0)-parseFloat(t.isNullOrUndefined(this.column.width)?"":this.column.width.toString()),this.minMove+=this.pageX}if(t.Browser.isDevice&&!this.helper.classList.contains(Ia.icon))this.helper.classList.add(Ia.icon),t.EventHandler.add(document,t.Browser.touchStartEvent,this.removeHelper,this),t.EventHandler.add(this.helper,t.Browser.touchStartEvent,this.resizeStart,this);else{var f={e:e,column:this.column};this.parent.trigger("resizeStart",f,function(e){e.cancel||i.parent.isEdit?i.cancelResizeAction():(t.EventHandler.add(document,t.Browser.touchEndEvent,i.resizeEnd,i),t.EventHandler.add(i.parent.element,t.Browser.touchMoveEvent,i.resizing,i),i.updateCursor("add"))})}}},i.prototype.cancelResizeAction=function(e){e&&(t.EventHandler.remove(this.parent.element,t.Browser.touchMoveEvent,this.resizing),t.EventHandler.remove(document,t.Browser.touchEndEvent,this.resizeEnd),this.updateCursor("remove")),t.Browser.isDevice&&(t.EventHandler.remove(document,t.Browser.touchStartEvent,this.removeHelper),t.EventHandler.remove(this.helper,t.Browser.touchStartEvent,this.resizeStart)),t.detach(this.helper),this.refresh()},i.prototype.getWidth=function(e,t,i){return t&&e<t?t:i&&e>i?i:e},i.prototype.updateResizeEleHeight=function(){for(var e=[].slice.call(this.parent.getHeaderContent().getElementsByClassName("e-rhandler")),t=0;t<e.length;t++)e[t].style.height=this.element.parentElement.offsetHeight+"px"},i.prototype.getColData=function(e,i){return{width:parseFloat(t.isNullOrUndefined(this.widthService.getWidth(e))||"auto"===this.widthService.getWidth(e)?"0":this.widthService.getWidth(e).toString())+i,minWidth:e.minWidth?parseFloat(e.minWidth.toString()):null,maxWidth:e.maxWidth?parseFloat(e.maxWidth.toString()):null}},i.prototype.resizing=function(e){if(!t.isNullOrUndefined(this.column)){var i=0;t.isNullOrUndefined(this.column)&&(i=D(this.element,"th").offsetWidth),this.parent.allowTextWrap&&(this.updateResizeEleHeight(),this.setHelperHeight());var r=this.getPointX(e),n=this.parent.enableRtl?-(r-this.pageX):r-this.pageX;this.column.getFreezeTableName()===ds&&(n=this.parent.enableRtl?r-this.pageX:this.pageX-r);var o=this.getColData(this.column,n);o.width||(o.width=t.closest(this.element,"th").offsetWidth);var s=this.getWidth(o.width,o.minWidth,o.maxWidth);if(this.parent.log("resize_min_max",{column:this.column,width:s}),this.column.getFreezeTableName()===ds&&(this.parent.enableRtl&&this.minMove>=r||!this.parent.enableRtl&&this.minMove<=r)&&(s=this.column.minWidth?parseFloat(this.column.minWidth.toString()):10,this.pageX=r=this.minMove),(this.column.getFreezeTableName()!==ds&&(!this.parent.enableRtl&&this.minMove>=r||this.parent.enableRtl&&this.minMove<=r)||this.column.getFreezeTableName()===ds&&(this.parent.enableRtl&&this.minMove>=r||!this.parent.enableRtl&&this.minMove<=r))&&(s=this.column.minWidth?parseFloat(this.column.minWidth.toString()):10,this.pageX=r=this.minMove),s!==parseFloat(t.isNullOrUndefined(this.column.width)||"auto"===this.column.width?i.toString():this.column.width.toString())){this.pageX=r,this.column.width=t.formatUnit(s);var l={e:e,column:this.column};if(this.parent.trigger("resizing",l),l.cancel)return void this.cancelResizeAction(!0);var a=[this.column],h=[this.column];this.column.columns&&(a=this.getSubColumns(this.column,[]),a=this.calulateColumnsWidth(a,!1,n),h=this.calulateColumnsWidth(a,!0,n));for(var d=0,p=h;d<p.length;d++){var c=p[d];this.widthService.setColumnWidth(c,null,"resize")}this.updateHelper()}this.isDblClk=!1}},i.prototype.calulateColumnsWidth=function(e,i,r){for(var n=[],o=0,s=e;o<s.length;o++){for(var l=s[o],a=0,h=0;h<e.length;h++)a+=parseFloat(e[h].width.toString());var d=this.getColData(l,parseFloat(l.width)*r/a),p=this.getWidth(d.width,d.minWidth,d.maxWidth);p!==parseFloat(l.width.toString())&&(i&&(l.width=t.formatUnit(p<1?1:p)),n.push(l))}return n},i.prototype.getSubColumns=function(e,t){for(var i=0,r=e.columns;i<r.length;i++){var n=r[i];!1!==n.visible&&n.allowResizing&&(n.columns?this.getSubColumns(n,t):t.push(n))}return t},i.prototype.resizeEnd=function(e){if(this.helper&&!this.parent.isDestroyed){t.EventHandler.remove(this.parent.element,t.Browser.touchMoveEvent,this.resizing),t.EventHandler.remove(document,t.Browser.touchEndEvent,this.resizeEnd),this.updateCursor("remove"),t.detach(this.helper);var i={e:e,column:this.column},r=this.parent.getContent().querySelector("."+es),n=r.querySelector("."+Yo)?r.querySelector("."+Yo):r;n.scrollHeight>n.clientHeight&&(this.parent.scrollModule.setPadding(),n.style.overflowY="scroll"),this.parent.trigger(pi,i),t.closest(this.element,".e-headercell").classList.add("e-resized"),D(this.element,"e-frozenheader")?this.isFrozenColResized=!0:this.isFrozenColResized=!1,this.parent.isFrozenGrid()&&this.parent.notify(zr,{case:"textwrap"}),this.parent.allowTextWrap&&(this.updateResizeEleHeight(),this.parent.notify(Kr,{case:"textwrap"})),this.refresh(),this.doubleTapEvent(e),this.isDblClk=!0}},i.prototype.getPointX=function(e){return e.touches&&e.touches.length?e.touches[0].pageX:e.pageX},i.prototype.refreshColumnWidth=function(){for(var e=this.parent.getColumns(),t=0,i=[].slice.apply(this.parent.getHeaderContent().querySelectorAll("th.e-headercell"));t<i.length;t++)for(var r=i[t],n=0,o=e;n<o.length;n++){var s=o[n];if(r.querySelector("[e-mappinguid]")&&r.querySelector("[e-mappinguid]").getAttribute("e-mappinguid")===s.uid&&s.visible){s.width=r.getBoundingClientRect().width;break}}return e},i.prototype.refreshStackedColumnWidth=function(){for(var e=0,t=this.parent.getStackedColumns(this.parent.columns);e<t.length;e++){var i=t[e];i.width=this.getStackedWidth(i,0)}},i.prototype.getStackedWidth=function(e,t){for(var i=0,r=e.columns;i<r.length;i++){var n=r[i];!1!==n.visible&&(n.columns?this.getStackedWidth(n,t):t+=n.width)}return t},i.prototype.getTargetColumn=function(e){var i=t.closest(e.target,Ia.header),r=(i=i.querySelector(".e-headercelldiv")||i.querySelector(".e-stackedheadercelldiv")).getAttribute("e-mappinguid");return this.parent.getColumnByUid(r)},i.prototype.updateCursor=function(e){var t=[].slice.call(this.parent.getHeaderContent().querySelectorAll("th"));t.push(this.parent.element);for(var i=0,r=t;i<r.length;i++){r[i].classList[e](Ia.cursor)}},i.prototype.refresh=function(){this.column=null,this.pageX=null,this.element=null,this.helper=null},i.prototype.appendHelper=function(){this.helper=this.parent.createElement("div",{className:Ia.helper}),this.parent.element.appendChild(this.helper),this.setHelperHeight()},i.prototype.setHelperHeight=function(){var e=this.parent.isFrozenGrid(),i=e?this.parent.getContent().querySelector("."+es).offsetHeight:this.parent.getContent().offsetHeight-this.getScrollBarWidth(),r=t.closest(this.element,Ia.header),n=[].slice.call(this.parent.getHeaderContent().querySelectorAll("tr")),o=this.parent.getFrozenRightColumnsCount();e&&(n=D(r,Jo)?[].slice.call(this.parent.getHeaderContent().querySelector("."+Jo).querySelectorAll("tr")):o&&D(r,"e-frozen-right-header")?[].slice.call(this.parent.getHeaderContent().querySelector(".e-frozen-right-header").querySelectorAll("tr")):[].slice.call(this.parent.getHeaderContent().querySelector(".e-frozen-left-header").querySelectorAll("tr")));for(var s=n.indexOf(r.parentElement);s<n.length&&s>-1;s++)i+=n[s].offsetHeight;var l=this.calcPos(r);D(r,"e-frozen-right-header")?l.left+=this.parent.enableRtl?r.offsetWidth-2:-1:l.left+=this.parent.enableRtl?-1:r.offsetWidth-2,this.helper.style.cssText="height: "+i+"px; top: "+l.top+"px; left:"+Math.floor(l.left)+"px;",this.parent.enableVirtualization&&this.helper.classList.add("e-virtual-rhandler")},i.prototype.getScrollBarWidth=function(e){var t=this.parent.getContent().firstChild;return t.scrollHeight>t.clientHeight&&e||t.scrollWidth>t.clientWidth?H():0},i.prototype.removeHelper=function(e){var i=e.target.classList;i.contains(Ia.root)||i.contains(Ia.icon)||!this.helper||(t.EventHandler.remove(document,t.Browser.touchStartEvent,this.removeHelper),t.EventHandler.remove(this.helper,t.Browser.touchStartEvent,this.resizeStart),t.detach(this.helper),this.refresh())},i.prototype.updateHelper=function(){var e,i=t.closest(this.element,Ia.header);if((e=D(i,"e-frozen-right-header")?Math.floor(this.calcPos(i).left+(this.parent.enableRtl?i.offsetWidth-2:-1)):Math.floor(this.calcPos(i).left+(this.parent.enableRtl?-1:i.offsetWidth-2)))>this.parentElementWidth&&(e=this.parentElementWidth-2),this.parent.isFrozenGrid()){var r=t.closest(i,"."+ts).offsetLeft;e<r&&(e=r)}this.helper.style.left=e+"px"},i.prototype.calcPos=function(e){for(var t={top:0,left:0},i=e.getBoundingClientRect(),r=e.ownerDocument,n=D(e,"e-grid")||r.documentElement;n&&(n===r.body||n===r.documentElement)&&"static"===n.style.position;)n=n.parentNode;return n&&n!==e&&1===n.nodeType&&(t=n.getBoundingClientRect()),{top:i.top-t.top,left:i.left-t.left}},i.prototype.doubleTapEvent=function(e){var t=this;this.getUserAgent()&&this.isDblClk&&(this.tapped?(clearTimeout(this.tapped),this.callAutoFit(e),this.tapped=null):this.tapped=setTimeout(function(){t.tapped=null},300))},i.prototype.getUserAgent=function(){var e=t.Browser.userAgent.toLowerCase();return/iphone|ipod|ipad/.test(e)},i.prototype.timeoutHandler=function(){this.tapped=null},i}(),za=function(){function e(e){this.parent=e,this.parent.isDestroyed||(this.parent.on(tr,this.headerDrop,this),this.parent.on(Fi,this.enableAfterRender,this),this.parent.on(Bi,this.onActionComplete,this),this.parent.on(Wt,this.drag,this),this.parent.on(_t,this.dragStart,this),this.parent.on(er,this.dragStop,this),this.parent.on(tr,this.headerDrop,this),this.parent.on(Di,this.createReorderElement,this),this.parent.on(_i,this.keyPressHandler,this),this.parent.on(Ki,this.destroy,this))}return e.prototype.chkDropPosition=function(e,i){var r=this.parent.getColumnByUid(i.firstElementChild.getAttribute("e-mappinguid")),n=!r||!r.lockColumn;return(e.parentElement.isEqualNode(i.parentElement)||this.parent.enableColumnVirtualization||this.parent.isFrozenGrid()&&Array.prototype.indexOf.call(t.closest(e,"thead").children,e.parentElement)===Array.prototype.indexOf.call(t.closest(i,"thead").children,i.parentElement))&&this.targetParentContainerIndex(e,i)>-1&&n},e.prototype.chkDropAllCols=function(e,t){for(var i,r=this.getHeaderCells();!i&&r.length>0;)i=e!==r.pop()&&this.targetParentContainerIndex(e,t)>-1;return i},e.prototype.findColParent=function(e,t,i){i=i;for(var r=0,n=t.length;r<n;r++){if(e===t[r])return!0;if(t[r].columns){var o=i.length;if(i.push(t[r]),this.findColParent(e,t[r].columns,i))return!0;i.splice(o,i.length-o)}}return!1},e.prototype.getColumnsModel=function(e){var t=[],i=[];if(!this.parent.getFrozenColumns()&&this.parent.isFrozenGrid())return this.parent.getColumns();for(var r=0,n=e.length;r<n;r++)t.push(e[r]),e[r].columns&&(i=i.concat(e[r].columns));return i.length&&(t=t.concat(this.getColumnsModel(i))),t},e.prototype.headerDrop=function(e){var i=this.parent,r=(this.element.querySelector(".e-headercelldiv")||this.element.querySelector(".e-stackedheadercelldiv")).getAttribute("e-mappinguid"),n=i.getColumnByUid(r);if(t.closest(e.target,"th")&&(t.isNullOrUndefined(n)||n.allowReordering&&!n.lockColumn)){var o=t.closest(e.target,".e-headercell"),s=(o.querySelector(".e-headercelldiv")||o.querySelector(".e-stackedheadercelldiv")).getAttribute("e-mappinguid");if(!t.isNullOrUndefined(s)){var l=i.getColumnByUid(s);if(t.isNullOrUndefined(l)||!l.allowReordering||l.lockColumn)return void this.parent.log("action_disabled_column",{moduleName:this.getModuleName(),column:n,destColumn:l})}if(o&&this.chkDropPosition(this.element,o)&&this.chkDropAllCols(this.element,o))if(this.parent.enableColumnVirtualization){var a=this.parent.columns,h=this.element.querySelector(".e-headercelldiv").getAttribute("e-mappinguid"),d=null,p=this.parent.columns.filter(function(e){return e.uid===h})[0],c=o.querySelector(".e-headercelldiv").getAttribute("e-mappinguid");a.some(function(e,t){return e.uid===c&&(d=t,e.uid===c)}),t.isNullOrUndefined(d)||this.moveColumns(d,p)}else{var u=this.targetParentContainerIndex(this.element,o),g=this.element.firstElementChild.getAttribute("e-mappinguid");if(this.destElement=o,this.parent.notify(Zn,{ele:o}),g)this.moveColumns(u,this.parent.getColumnByUid(g));else{var f=this.getHeaderCells(),m=M(this.element,f);a=this.getColumnsModel(this.parent.columns);this.moveColumns(u,a[m])}}}else this.parent.log("action_disabled_column",{moduleName:this.getModuleName(),column:n})},e.prototype.isActionPrevent=function(e){return W(e)},e.prototype.moveColumns=function(e,t,i,r){var n=this.parent;if(this.isActionPrevent(n))n.notify(ur,{instance:this,handler:this.moveColumns,arg1:e,arg2:t});else{var o=!n.getFrozenColumns()&&n.isFrozenGrid(),s=this.getColParent(t,this.parent.columns),l=s?s.columns:o?this.parent.getColumns():this.parent.columns,a=O(t,l);if((this.parent.isFrozenGrid()&&s||this.parent.lockcolPositionCount)&&!i&&!this.parent.enableColumnVirtualization){for(var h=0;h<l.length;h++)if(l[h].field===t.field){a=h;break}var d=this.parent.getColumnByUid(this.destElement.firstElementChild.getAttribute("e-mappinguid"));if(d){for(h=0;h<l.length;h++)if(l[h].field===d.field){e=h;break}}else for(h=0;h<l.length;h++)l[h].headerText===this.destElement.innerText.trim()&&(e=h)}if(n.allowReordering&&a!==e&&-1!==a&&-1!==e){l.splice(e,0,l.splice(a,1)[0]);var p={column:t,destIndex:e,columns:l,parent:s,cancel:!1};n.notify(Jn,p),p.cancel||(n.getColumns(!0),n.notify(Ji,{fromIndex:e,toIndex:a}),!1!==r&&n.notify(Ti,{type:zt,requestType:"reorder",fromIndex:e,toIndex:a,toColumnUid:t.uid}))}}},e.prototype.targetParentContainerIndex=function(e,t){var i=!this.parent.getFrozenColumns()&&this.parent.isFrozenGrid()?this.parent.getColumns():this.parent.columns,r=this.getHeaderCells(),n=this.getColumnsModel(i),o=this.getColParent(n[M(e,r)],i);return i=o?o.columns:i,O(n[M(t,r)],i)},e.prototype.getHeaderCells=function(){var e=this.parent.getFrozenColumns();if(e||this.parent.isFrozenGrid()||this.parent.lockcolPositionCount){var t=void 0,i=void 0,r=[],n=[].slice.call(this.parent.getHeaderTable().getElementsByClassName("e-columnheader"));if(e||this.parent.isFrozenGrid()){for(var o=[].slice.call(this.parent.getHeaderContent().querySelector("."+Jo).getElementsByClassName("e-columnheader")),s=0;s<n.length;s++){t=[].slice.call(n[s].getElementsByClassName("e-headercell")),i=[].slice.call(o[s].getElementsByClassName("e-headercell"));for(var l=void 0,a=0;a<t.length;a++){for(var h=0;h<i.length;h++)if(i[h].innerText===t[a].innerText){l=!0;break}l||(r=r.concat([t[a]]))}for(h=0;h<i.length;h++)r.push(i[h])}if(this.parent.getFrozenRightColumnsCount()){var d=void 0,p=[].slice.call(this.parent.getHeaderContent().querySelector(".e-frozen-right-header").getElementsByClassName("e-columnheader"));d=[].slice.call(p[0].getElementsByClassName("e-headercell"));for(s=0;s<d.length;s++)r.push(d[s])}}else for(s=0;s<n.length;s++){i=[].slice.call(n[s].getElementsByClassName("e-headercell"));for(a=0;a<i.length;a++){for(l=void 0,h=a+1;h<i.length;h++)if(i[h].innerText===i[a].innerText){l=!0;break}l||(r=r.concat([i[a]]))}}return r}return[].slice.call(this.parent.element.getElementsByClassName("e-headercell"))},e.prototype.getColParent=function(e,t){var i=[];return this.findColParent(e,t,i),i[i.length-1]},e.prototype.reorderSingleColumn=function(e,i){var r=this.parent.enableColumnVirtualization?this.parent.columns.filter(function(t){return t.field===e})[0]:this.parent.getColumnByField(e),n=this.parent.enableColumnVirtualization?this.parent.columns.filter(function(e){return e.field===i})[0]:this.parent.getColumnByField(i);if((t.isNullOrUndefined(r)||r.allowReordering&&!r.lockColumn)&&(t.isNullOrUndefined(n)||n.allowReordering&&!r.lockColumn)){var o=n,s=this.getColParent(o,this.parent.columns),l=O(o,s?s.columns:this.parent.columns);l>-1&&this.moveColumns(l,r,!0)}else this.parent.log("action_disabled_column",{moduleName:this.getModuleName(),column:r,destColumn:n})},e.prototype.reorderMultipleColumns=function(e,i){var r=this.parent.getColumnIndexByField(i),n=this.parent.getColumnByField(i);if(!(r<0)&&(t.isNullOrUndefined(n)||n.allowReordering&&!n.lockColumn)){for(var o=0;o<e.length;o++){var s=this.parent.getColumnByField(e[o]);if(!t.isNullOrUndefined(s)&&(!s.allowReordering||s.lockColumn))return}for(o=0;o<e.length;o++){s=this.parent.getColumnByIndex(r);var l=this.getColParent(s,this.parent.columns),a=O(s,l?l.columns:this.parent.columns);a>-1&&this.moveColumns(a,this.parent.getColumnByField(e[o]),!0,!0),this.parent.getColumnIndexByField(e[o+1])>=a&&r++}}},e.prototype.moveTargetColumn=function(e,t){t>-1&&this.moveColumns(t,e,!0)},e.prototype.reorderSingleColumnByTarget=function(e,t){this.moveTargetColumn(this.parent.getColumnByField(e),t)},e.prototype.reorderMultipleColumnByTarget=function(e,t){for(var i=0;i<e.length;i++)this.reorderSingleColumnByTarget(e[i],t)},e.prototype.reorderColumns=function(e,t){"string"==typeof e?(this.reorderSingleColumn(e,t),this.fromCol=e):(this.reorderMultipleColumns(e,t),this.fromCol=e[0])},e.prototype.reorderColumnByIndex=function(e,t){this.moveTargetColumn(this.parent.getColumnByIndex(e),t)},e.prototype.reorderColumnByTargetIndex=function(e,t){"string"==typeof e?this.reorderSingleColumnByTarget(e,t):this.reorderMultipleColumnByTarget(e,t)},e.prototype.enableAfterRender=function(e){e.module===this.getModuleName()&&e.enable&&this.createReorderElement()},e.prototype.createReorderElement=function(e){e&&e.args.isXaxis&&this.setDisplay("none");var t=this.parent.element.querySelector("."+Xo);this.upArrow=t.appendChild(this.parent.createElement("div",{className:"e-icons e-icon-reorderuparrow e-reorderuparrow",attrs:{style:"display:none"}})),this.downArrow=t.appendChild(this.parent.createElement("div",{className:"e-icons e-icon-reorderdownarrow e-reorderdownarrow",attrs:{style:"display:none"}}))},e.prototype.onActionComplete=function(e){this.parent.trigger(Dt,t.extend(e,{type:Dt}));var i=this.fromCol&&this.parent.getColumnHeaderByField(this.fromCol);i&&this.parent.focusModule.onClick({target:i},!0)},e.prototype.destroy=function(){var e=this.parent.element;!this.parent.isDestroyed&&e&&(e.querySelector("."+Wo)||e.querySelector("."+Ko))&&(this.upArrow.parentNode&&t.remove(this.upArrow),this.downArrow.parentNode&&t.remove(this.downArrow),this.parent.off(tr,this.headerDrop),this.parent.off(Fi,this.enableAfterRender),this.parent.off(Bi,this.onActionComplete),this.parent.off(Wt,this.drag),this.parent.off(_t,this.dragStart),this.parent.off(er,this.dragStop),this.parent.off(Di,this.createReorderElement),this.parent.off(_i,this.keyPressHandler),this.parent.off(Ki,this.destroy))},e.prototype.keyPressHandler=function(e){var t=this.parent;switch(e.action){case"ctrlLeftArrow":case"ctrlRightArrow":var i=t.focusModule.currentInfo.element;if(i&&i.classList.contains("e-headercell")){var r=t.getColumnByUid(i.firstElementChild.getAttribute("e-mappinguid")),n=t.getVisibleColumns(),o=n.indexOf(r),s="ctrlLeftArrow"===e.action?n[o-1]:n[o+1];s&&s.field&&r.field&&this.reorderColumns(r.field,s.field)}}},e.prototype.drag=function(e){var i=this.parent,r=e.target;if(e.column.allowReordering&&!e.column.lockColumn){var n=t.closest(r,".e-headercell:not(.e-stackedHeaderCell)"),o=i.element.querySelector(".e-cloneproperties"),s=i.isFrozenGrid()?i.getMovableVirtualContent():i.getContent().firstElementChild,l=this.x>B(e.event).x+s.scrollLeft;t.removeClass([].slice.call(i.getHeaderTable().getElementsByClassName("e-reorderindicate")),["e-reorderindicate"]),this.setDisplay("none"),this.stopTimer(),t.classList(o,["e-defaultcur"],["e-notallowedcur"]),this.updateScrollPostion(e.event),n&&!n.isEqualNode(this.element)&&(r=n,this.chkDropPosition(this.element,r)&&this.chkDropAllCols(this.element,r)?(this.updateArrowPosition(r,l),t.classList(r,["e-allowDrop","e-reorderindicate"],[])):i.allowGrouping&&D(e.target,"e-groupdroparea")||t.classList(o,["e-notallowedcur"],["e-defaultcur"])),i.trigger(Wt,{target:r,draggableType:"headercell",column:e.column})}},e.prototype.updateScrollPostion=function(e){var t=this,i=B(e).x,r=this.parent.element.getBoundingClientRect(),n=r.right;if(this.parent.isFrozenGrid())this.updateFrozenScrollPosition(i,r);else{var o=r.left,s=this.parent.getContent().firstElementChild;i>o&&i<o+35?this.timer=window.setInterval(function(){t.setScrollLeft(s,!0)},50):i<n&&i>n-35&&(this.timer=window.setInterval(function(){t.setScrollLeft(s,!1)},50))}},e.prototype.updateFrozenScrollPosition=function(e,t){var i=this,r=this.parent.getContent().querySelector("."+Yo),n=this.parent.element.querySelector("."+Jo).getBoundingClientRect(),o=this.parent.getFrozenLeftCount(),s=this.parent.getFrozenRightColumnsCount()?n.right:t.right,l=o?n.left:t.left;e>l&&e<l+35?this.timer=window.setInterval(function(){i.setScrollLeft(r,!0)},50):e<s&&e>s-35&&(this.timer=window.setInterval(function(){i.setScrollLeft(r,!1)},50))},e.prototype.setScrollLeft=function(e,t){var i=e.scrollLeft;e.scrollLeft=e.scrollLeft+(t?-5:5),i!==e.scrollLeft&&this.setDisplay("none")},e.prototype.stopTimer=function(){window.clearInterval(this.timer)},e.prototype.updateArrowPosition=function(e,t){var i=e.getBoundingClientRect(),r=this.parent.element.getBoundingClientRect();if(!(t&&i.left<r.left||!t&&i.right>r.right)){if(this.parent.isFrozenGrid()&&e.classList.contains("e-headercell")){var n=this.parent.getFrozenLeftCount(),o=this.parent.getFrozenRightColumnsCount(),s=this.element.querySelector(".e-headercelldiv"),l=s?this.parent.getColumnByUid(s.getAttribute("data-uid")):null,a=this.parent.getColumnByUid(e.firstElementChild.getAttribute("e-mappinguid")),h=Math.round(this.parent.getFrozenVirtualHeader().getBoundingClientRect().right),d=Math.round(this.parent.getMovableVirtualHeader().getBoundingClientRect().right);if(a){if(n&&!o&&this.parent.getNormalizedColumnIndex(a.uid)>=n&&(t&&Math.round(i.left)<h||!t&&d<i.right))return;if(!n&&o&&l&&l.getFreezeTableName()!==a.getFreezeTableName()&&!t&&Math.round(i.right)<h)return}}var p=this.parent.getHeaderContent().classList.contains("e-sticky");this.upArrow.style.top=p?i.top+i.height+"px":i.top+i.height-r.top+"px",this.downArrow.style.top=p?i.top-7+"px":i.top-r.top-7+"px",this.upArrow.style.left=this.downArrow.style.left=p?(t?i.left:i.right)-4+"px":(t?i.left:i.right)-r.left-4+"px",this.setDisplay("")}},e.prototype.dragStart=function(e){var t=this.parent,i=e.target;if(this.element=i.classList.contains("e-headercell")?i:D(i,"e-headercell"),e.column.allowReordering&&!e.column.lockColumn){var r=t.isFrozenGrid()?t.getMovableVirtualContent():t.getContent().firstElementChild;this.x=B(e.event).x+r.scrollLeft,t.trigger(_t,{target:i,draggableType:"headercell",column:e.column})}},e.prototype.dragStop=function(e){var i=this.parent;this.setDisplay("none"),this.stopTimer(),e.cancel||i.trigger(Kt,{target:e.target,draggableType:"headercell",column:e.column}),t.removeClass([].slice.call(i.getHeaderTable().getElementsByClassName("e-reorderindicate")),["e-reorderindicate"])},e.prototype.setDisplay=function(e){this.upArrow.style.display=e,this.downArrow.style.display=e},e.prototype.getModuleName=function(){return"reorder"},e}(),Da=function(){function e(e){var i=this;this.selectedRows=[],this.isOverflowBorder=!0,this.selectedRowColls=[],this.isRefresh=!0,this.isReplaceDragEle=!0,this.istargetGrid=!1,this.helper=function(e){var r=i.parent,n=i.draggable.currentStateTarget,o=i.parent.createElement("div",{className:"e-cloneproperties e-draganddrop e-grid e-dragclone",styles:'height:"auto", z-index:2, width:'+r.element.offsetWidth}),s=i.parent.createElement("table",{styles:"width:"+r.element.offsetWidth}),l=i.parent.createElement(gs);if(document.getElementsByClassName("e-griddragarea").length||r.rowDropSettings.targetID&&(!n.classList.contains("e-selectionbackground")&&"Single"!==r.selectionSettings.type||!D(n,"e-rowcell"))||!r.rowDropSettings.targetID&&!D(n,"e-rowdragdrop"))return!1;r.rowDropSettings.targetID&&"Row"===r.selectionSettings.mode&&"Single"===r.selectionSettings.type&&r.selectRow(parseInt(i.draggable.currentStateTarget.parentElement.getAttribute(us),10)),i.startedRow=t.closest(n,"tr").cloneNode(!0);var a=i.parent.isFrozenGrid();if(a){var h=parseInt(t.closest(n,"tr").getAttribute(us),10);i.startedRow.innerHTML="",i.startedRow.innerHTML+=r.getRowByIndex(h).innerHTML,i.startedRow.innerHTML+=r.getMovableRowByIndex(h).innerHTML,r.getFrozenMode()===hs&&(i.startedRow.innerHTML+=r.getFrozenRightRowByIndex(h).innerHTML)}i.processArgs(n);var d={selectedRow:i.rows,dragelement:n,cloneElement:o,cancel:!1,data:i.rowData},p=r.getSelectedRows();r.trigger(Qt,d);if(d.cancel)return!1;A(i.startedRow,".e-indentcell"),A(i.startedRow,".e-detailrowcollapse"),A(i.startedRow,".e-detailrowexpand"),i.removeCell(i.startedRow,rs);var c=new RegExp("e-active","g");if(i.startedRow.innerHTML=i.startedRow.innerHTML.replace(c,""),l.appendChild(i.startedRow),r.getSelectedRowIndexes().length>1&&i.startedRow.hasAttribute("aria-selected")){var u=r.getFrozenMode()===hs?3:2,g=i.parent.createElement("span",{className:"e-dropitemscount",innerHTML:a?""+p.length/u:""+p.length});o.appendChild(g)}var f=t.closest(n,"tr").querySelector(".e-icon-rowdragicon");return f&&f.classList.add("e-dragstartrow"),s.appendChild(l),o.appendChild(s),r.element.appendChild(o),o},this.dragStart=function(e){var t=i.parent;if(document.body.classList.add("e-prevent-select"),!document.getElementsByClassName("e-griddragarea").length){var r=e.target,n=i.parent.element.querySelector(".e-dropitemscount");i.parent.getSelectedRecords().length>1&&n&&(n.style.left=i.parent.element.querySelector(".e-cloneproperties table").offsetWidth-5+"px"),i.processArgs(r),t.trigger(Xt,{rows:i.rows,target:e.target,draggableType:"rows",fromIndex:parseInt(i.rows[0].getAttribute(us),10),data:Object.keys(i.rowData[0]).length>0?i.rowData:i.currentViewData()}),i.dragStartData=i.rowData;var o=document.getElementById(t.rowDropSettings.targetID);t.rowDropSettings.targetID&&o&&o.ej2_instances&&"grid"===o.ej2_instances[0].getModuleName()&&o.ej2_instances[0].getContent().classList.add("e-allowRowDrop")}},this.drag=function(e){var r=i.parent;if(i.isDropGrid=i.parent,i.istargetGrid=!1,i.parent.rowDropSettings.targetID){var n=document.getElementById(r.rowDropSettings.targetID);i.isDropGrid=n.ej2_instances[0],D(e.target,"e-grid")&&(i.istargetGrid=i.parent.rowDropSettings.targetID===D(e.target,"e-grid").id)}var o=i.parent.element.querySelector(".e-cloneproperties"),s=i.getElementFromPosition(o,e.event);t.classList(o,["e-defaultcur"],["e-notallowedcur","e-movecur","e-grabcur"]),i.isOverflowBorder=!0,i.hoverState=r.enableHover;var l=D(s,"e-grid")?t.closest(e.target,"tr"):null;if(e.target){i.processArgs(s);var a={rows:i.rows,target:s,draggableType:"rows",data:i.rowData,originalEvent:e,cancel:!1};if(r.trigger(Yt,a),i.stopTimer(),!a.cancel){if(r.element.classList.add("e-rowdrag"),i.dragTarget=l&&D(s,"e-grid").id===o.parentElement.id?parseInt(l.getAttribute(us),10):parseInt(i.startedRow.getAttribute(us),10),r.rowDropSettings.targetID)D(s,"e-grid")&&D(o.parentElement,"e-grid").id!==D(s,"e-grid").id?t.classList(o,["e-grabcur"],["e-notallowedcur"]):t.classList(o,["e-notallowedcur"],["e-defaultcur"]);else{var h=D(s,"e-grid");h&&h.id===o.parentElement.id?t.classList(o,["e-movecur"],["e-defaultcur"]):t.classList(o,["e-notallowedcur"],["e-movecur"])}if(D(i.isDropGrid.element,"e-grid")){if((!i.isDropGrid.groupSettings.columns.length||e.target.classList.contains("e-selectionbackground"))&&!i.isDropGrid.element.querySelector(".e-emptyrow"))if(D(s,"e-grid")&&D(s,"e-grid").id===i.isDropGrid.element.id&&i.updateScrollPostion(e.event),(i.isOverflowBorder||i.parent.frozenRows>i.dragTarget)&&(parseInt(i.startedRow.getAttribute(us),10)!==i.dragTarget||i.istargetGrid)||i.istargetGrid&&l&&i.isDropGrid.getRowByIndex(i.isDropGrid.getCurrentViewRecords().length-1).getAttribute("data-uid")===l.getAttribute("data-uid"))i.moveDragRows(e,i.startedRow,l);else{var d=void 0;if(i.parent.enableVirtualization)d=l&&parseInt(l.getAttribute(us),10)===i.parent.renderModule.data.dataManager.dataSource.json.length-1;else{var p=i.parent.getRowByIndex(i.parent.getCurrentViewRecords().length-1).getAttribute("data-uid");d=l&&p===l.getAttribute("data-uid")&&p!==i.startedRow.getAttribute("data-uid")}if(d&&!i.parent.rowDropSettings.targetID){var c=i.parent.createElement("div",{className:"e-lastrow-dragborder"}),u=i.parent.getContent();c.style.width=i.parent.element.offsetWidth-i.getScrollWidth()+"px",i.parent.enableVirtualization&&(c.style.zIndex="1"),u.getElementsByClassName("e-lastrow-dragborder").length||(u.classList.add("e-grid-relative"),u.appendChild(c),c.style.bottom=i.getScrollWidth()+"px")}i.removeBorder(l)}if(s&&s.classList.contains(es)&&!i.isDropGrid.element.querySelector(".e-emptyrow")&&i.istargetGrid){i.removeBorder(l);var g=i.isDropGrid.getCurrentViewRecords().length-1,f=".e-rowcell,.e-rowdragdrop,.e-detailrowcollapse",m=[];m=[].slice.call(i.isDropGrid.getRowByIndex(g).querySelectorAll(f)),i.isDropGrid.isFrozenGrid()&&(m=i.borderRowElement(g,f)),m.length>0&&X(m,!0,"e-dragborder")}}}}},this.dragStop=function(e){document.body.classList.remove("e-prevent-select"),W(i.parent)?i.parent.notify(ur,{instance:i,handler:i.processDragStop,arg1:e}):i.processDragStop(e)},this.processDragStop=function(e){var r=i.parent;if(!i.parent.isDestroyed){var n=i.getElementFromPosition(e.helper,e.event),o=n&&!n.classList.contains("e-dlg-overlay")?n:e.target;r.element.classList.remove("e-rowdrag");var s=document.getElementById(r.rowDropSettings.targetID);if(r.rowDropSettings.targetID&&s&&s.ej2_instances&&"grid"===s.ej2_instances[0].getModuleName()&&s.ej2_instances[0].getContent().classList.remove("e-allowRowDrop"),D(i.isDropGrid.element,"e-grid")){i.stopTimer(),i.isDropGrid.enableHover=i.hoverState,i.isDropGrid.getContent().classList.remove("e-grid-relative"),i.removeBorder(n);var l=i.isDropGrid.element.querySelector(".e-dragstartrow");l&&l.classList.remove("e-dragstartrow")}i.processArgs(o);var a={target:o,draggableType:"rows",cancel:!1,fromIndex:parseInt(i.rows[0].getAttribute(us),10),dropIndex:i.dragTarget,rows:i.rows,data:Object.keys(i.dragStartData[0]).length>0?i.dragStartData:i.currentViewData()};r.trigger(Jt,a,function(){if(!(D(o,is)||D(o,"e-emptyrow")||D(o,Ko))||a.cancel)return i.dragTarget=null,void t.remove(e.helper);i.isRefresh=!1;var n=i.parent.getSelectedRowIndexes();r.isRowDragable()&&(!i.parent.rowDropSettings.targetID&&i.startedRow.querySelector("td.e-selectionbackground")&&n.length>1&&n.length!==i.parent.getCurrentViewRecords().length?i.reorderRows(n,a.dropIndex):i.reorderRows([parseInt(i.startedRow.getAttribute(us),10)],i.dragTarget),i.dragTarget=null,r.rowDropSettings.targetID||(t.remove(e.helper),r.enableVirtualization?r.refresh():i.rowOrder(a))),i.isRefresh=!0})}},this.removeCell=function(e,t){return[].slice.call(e.querySelectorAll("td")).filter(function(i){i.classList.contains(t)&&e.deleteCell(i.cellIndex)})},this.parent=e,this.parent.isDestroyed||(this.parent.on(Si,this.initializeDrag,this),this.parent.on(Kt,this.columnDrop,this),this.parent.on(Ni,this.onActionComplete,this),this.onDataBoundFn=this.onDataBound.bind(this),this.parent.addEventListener(Ot,this.onDataBoundFn),this.parent.on(Fi,this.enableAfterRender,this),this.parent.on(Ki,this.destroy,this))}return e.prototype.refreshRow=function(e,t,i,r,n,o,s){var l,a,h,d,p=this.parent,c=p.isFrozenGrid(),u=p.getFrozenMode()===hs,g=p.getContentTable().querySelector(gs),f=p.getHeaderTable().querySelector(gs);c&&(l=p.getMovableHeaderTbody(),a=p.getMovableContentTbody(),u&&(h=p.getFrozenRightHeaderTbody(),d=p.getFrozenRightContentTbody()));for(var m=p.getFrozenMode()===hs?3:2,y=0,v=e.rows.length;y<v;y++)c?y%m==0?t.insertBefore(e.rows[y],n):y%m==1?i.insertBefore(e.rows[y],o):r.insertBefore(e.rows[y],s):t.insertBefore(e.rows[y],n);var C,w,b=[].slice.call(t.getElementsByClassName(is));if(c&&(C=[].slice.call(i.getElementsByClassName(is)),u&&(w=[].slice.call(r.getElementsByClassName(is)))),this.refreshData(b,C,w),this.parent.frozenRows){var S=function(e,t){e<R.parent.frozenRows?He(f,l,h,b,C,w,function(t,i){t.appendChild(i[e])}):He(g,a,d,b,C,w,function(t,i){t.appendChild(i[e])})},R=this;for(y=0,v=b.length;y<v;y++)S(y)}},e.prototype.updateFrozenRowreOrder=function(e){var t,i,r,n,o=this.parent,s=this.parent.isFrozenGrid(),l=o.getFrozenMode()===hs,a=o.getContentTable().querySelector(gs),h=o.getHeaderTable().querySelector(gs);s&&(t=o.getMovableHeaderTbody(),i=o.getMovableContentTbody(),l&&(r=o.getFrozenRightHeaderTbody(),n=o.getFrozenRightContentTbody()));var d,p,c=[].slice.call(h.getElementsByClassName(is)).concat([].slice.call(a.getElementsByClassName(is)));s&&(d=[].slice.call(t.getElementsByClassName(is)).concat([].slice.call(i.getElementsByClassName(is))),l&&(p=[].slice.call(r.getElementsByClassName(is)).concat([].slice.call(n.getElementsByClassName(is)))));var u=o.createElement(gs),g=o.createElement(gs),f=o.createElement(gs);this.parent.clearSelection();for(var m=this.refreshRowTarget(e),y=0,v=c.length;y<v;y++)u.appendChild(c[y]),s&&(g.appendChild(d[y]),l&&f.appendChild(p[y]));this.refreshRow(e,u,g,f,m.target,m.mTarget,m.frTarget)},e.prototype.refreshRowTarget=function(e){var t,i,r=this.parent,n=parseInt(e.target.parentElement.getAttribute(us),10);(e.fromIndex<e.dropIndex||e.fromIndex===e.dropIndex)&&(n+=1);var o=r.getRowByIndex(n);r.isFrozenGrid()&&(t=r.getMovableRowByIndex(n),r.getFrozenMode()===hs&&(i=r.getFrozenRightRowByIndex(n)));return{target:o,mTarget:t,frTarget:i}},e.prototype.updateFrozenColumnreOrder=function(e){var t,i,r=this.parent,n=this.parent.isFrozenGrid(),o=r.getContentTable().querySelector(gs);n&&(t=r.getMovableContentTbody(),r.getFrozenMode()===hs&&(i=r.getFrozenRightContentTbody())),this.parent.clearSelection();var s=this.refreshRowTarget(e);this.refreshRow(e,o,t,i,s.target,s.mTarget,s.frTarget)},e.prototype.refreshData=function(e,t,i){for(var r={},n={},o={},s={},l=this.parent.getRowsObject(),a=this.parent.getMovableRowsObject(),h=this.parent.getFrozenRightRowsObject(),d=this.parent.getCurrentViewRecords(),p=0,c=e.length;p<c;p++){var u=parseInt(e[p].getAttribute(us),10);r[p]=l[u],s[p]=d[u],this.parent.isFrozenGrid()&&(n[p]=a[u],i&&(o[p]=h[u]))}var g,f,m=this.parent.getRows();this.parent.isFrozenGrid()&&(g=this.parent.getMovableRows(),i&&(f=this.parent.getFrozenRightRows()));for(p=0,c=e.length;p<c;p++)m[p]=e[p],l[p]=r[p],d[p]=s[p],this.parent.isFrozenGrid()&&(g[p]=t[p],a[p]=n[p],i&&(f[p]=i[p],h[p]=o[p]));Ie(this.parent,l,e),this.parent.isFrozenGrid()&&(Ie(this.parent,a,t),i&&Ie(this.parent,h,i))},e.prototype.rowOrder=function(e){if(e.dropIndex!==e.fromIndex&&!isNaN(e.dropIndex)){if(this.parent.isDetail()){this.parent.detailCollapseAll();var t=[].slice.call(this.parent.getContentTable().querySelector(gs).children),i=this.parent.getRowsObject();t.filter(function(e){e.classList.contains("e-detailrow")&&e.remove()});for(var r=0,n=i.length;r<n&&i[r];r++)i[r].isDetailRow&&(this.parent.getRowsObject().splice(r,1),r--)}if(e.target.classList.contains("e-rowcelldrag")&&(e.target=e.target.parentElement),this.parent.frozenRows?this.updateFrozenRowreOrder(e):this.updateFrozenColumnreOrder(e),this.selectedRowColls.length>0){this.parent.selectRows(this.selectedRowColls);var o=[];if(this.parent.filterSettings.columns.length||this.parent.sortSettings.columns.length){for(r=0,n=e.rows.length;r<n;r++)o.push(parseInt(e.rows[r].getAttribute(us),10));this.selectedRowColls=o}this.selectedRowColls=[]}}},e.prototype.currentViewData=function(){for(var e=this.parent.getSelectedRowIndexes(),t=[],i=parseInt(this.startedRow.getAttribute(us),10),r=0,n=e.length;r<n;r++){t[r]=this.parent.currentViewData[e[r]]}return this.parent.rowDropSettings.targetID||0!==e.length||(t[0]=this.parent.currentViewData[i]),t},e.prototype.saveChange=function(e,i){var r=this;this.parent.getDataModule().saveChanges(e,this.parent.getPrimaryKeyFieldNames()[0],{},i).then(function(){r.parent.notify(Ti,{type:zt,requestType:"rowdraganddrop"})}).catch(function(e){t.isNullOrUndefined(e.error)||t.isNullOrUndefined(e.error.message)||(e.error=e.error.message),r.parent.trigger(Mt,e)})},e.prototype.reorderRows=function(e,t){for(var i=this.parent.getSelectedRowIndexes(),r=[],n=[],o=this.parent.renderModule.data.dataManager.dataSource.json,s=this.parent.allowPaging?this.parent.pageSettings.currentPage*this.parent.pageSettings.pageSize-this.parent.pageSettings.pageSize:0,l=t+s,a=e[0]+s,h=0,d=e.length;h<d;h++)n[h]=o[e[h]+s];for(h=0,d=i.length;h<d;h++)r[h]=o[i[h]+s];for(h=0,d=n.length;h<d;h++){if(0!==h){for(var p=0,c=o.length;p<c;p++)if(JSON.stringify(this.parent.renderModule.data.dataManager.dataSource.json[p])===JSON.stringify(n[h])){a=p;break}for(p=0,c=o.length;p<c;p++)if(JSON.stringify(this.parent.renderModule.data.dataManager.dataSource.json[p])===JSON.stringify(n[h-1])){a>p&&(l=p+1);break}}this.reorderRow(a-s,l-s)}this.isRefresh&&this.parent.notify(Ti,{type:zt,requestType:"rowdraganddrop"});for(h=0,d=r.length;h<d;h++)for(p=0,c=o.length;p<c;p++)if(JSON.stringify(this.parent.renderModule.data.dataManager.dataSource.json[p])===JSON.stringify(r[h])){i[h]=p-s;break}this.selectedRowColls=i},e.prototype.stopTimer=function(){window.clearInterval(this.timer)},e.prototype.onActionComplete=function(e){this.parent.trigger(Dt,t.extend(e,{type:Dt,requestType:"rowdraganddrop"}))},e.prototype.initializeDrag=function(){var e=this.parent;this.draggable=new t.Draggable(e.element,{dragTarget:".e-rowcelldrag, .e-rowdragdrop, .e-rowcell",distance:5,helper:this.helper,dragStart:this.dragStart,drag:this.drag,dragStop:this.dragStop,isReplaceDragEle:this.isReplaceDragEle,isPreventSelect:!1})},e.prototype.updateScrollPostion=function(e){var t=this,i=B(e).y,r=this.isDropGrid.getContent().getBoundingClientRect(),n=this.isDropGrid.getRowHeight()-15,o=this.isDropGrid.getContent().firstElementChild,s=this.parent.enableVirtualization?20:0;if(r.top>=i){var l=-this.isDropGrid.getRowHeight();this.isOverflowBorder=!1,this.timer=window.setInterval(function(){t.setScrollDown(o,l)},200)}else if(r.top+this.isDropGrid.getContent().clientHeight-n-33-s<=i){var a=this.isDropGrid.getRowHeight();this.isOverflowBorder=!1,this.timer=window.setInterval(function(){t.setScrollDown(o,a)},200)}},e.prototype.setScrollDown=function(e,t){e.scrollTop=e.scrollTop+t},e.prototype.moveDragRows=function(e,i,r){var n=this.parent.element.querySelector(".e-cloneproperties"),o=t.closest(e.target,"tr");if(D(o,"e-grid")&&(D(n.parentElement,"e-grid").id===D(o,"e-grid").id||this.istargetGrid)){var s=o||this.startedRow;this.setBorder(s,e.event,i,r)}},e.prototype.setBorder=function(e,i,r,n){var o=this.parent.element;this.istargetGrid&&(o=this.isDropGrid.element);var s=this.parent.element.querySelector(".e-cloneproperties");if(this.removeFirstRowBorder(e),this.removeLastRowBorder(e),D(e,"e-grid")&&e.classList.contains(is)&&(!this.parent.rowDropSettings.targetID&&D(s.parentElement,"e-grid").id===D(e,"e-grid").id||this.istargetGrid)){t.removeClass(o.querySelectorAll(".e-rowcell,.e-rowdragdrop,.e-detailrowcollapse"),["e-dragborder"]);var l=[],a=parseInt(n.getAttribute(us),10);if(n&&0===a){var h=this.parent.createElement("div",{className:"e-firstrow-dragborder"}),d=this.isDropGrid.getHeaderContent();d.classList.add("e-grid-relative"),h.style.width=o.offsetWidth-this.getScrollWidth()+"px",d.getElementsByClassName("e-firstrow-dragborder").length||d.appendChild(h)}else this.parent.rowDropSettings.targetID&&n?(e=this.isDropGrid.getRowByIndex(a-1),l=[].slice.call(e.querySelectorAll(".e-rowcell,.e-rowdragdrop,.e-detailrowcollapse"))):n&&parseInt(r.getAttribute(us),10)>a?(e=this.parent.getRowByIndex(a-1),l=[].slice.call(e.querySelectorAll(".e-rowcell,.e-rowdragdrop,.e-detailrowcollapse"))):l=[].slice.call(e.querySelectorAll(".e-rowcell,.e-rowdragdrop,.e-detailrowcollapse"));var p=this.parent.isFrozenGrid();if(n&&0!==a&&p){var c=parseInt(e.getAttribute(us),10);l=this.borderRowElement(c,".e-rowcell,.e-rowdragdrop,.e-detailrowcollapse")}l.length>0&&X(l,!0,"e-dragborder")}},e.prototype.borderRowElement=function(e,t){var i=[];return i=[].slice.call(this.isDropGrid.getRowByIndex(e).querySelectorAll(t)).concat([].slice.call(this.isDropGrid.getMovableRowByIndex(e).querySelectorAll(t))),this.isDropGrid.getFrozenMode()===hs&&(i=i.concat([].slice.call(this.isDropGrid.getFrozenRightRowByIndex(e).querySelectorAll(t)))),i},e.prototype.getScrollWidth=function(){var e=this.parent.getContent().firstElementChild;return e.scrollWidth>e.offsetWidth?Ml.getScrollBarWidth():0},e.prototype.removeFirstRowBorder=function(e){this.isDropGrid.element.getElementsByClassName("e-firstrow-dragborder").length>0&&e&&0!==e.rowIndex&&t.remove(this.isDropGrid.element.getElementsByClassName("e-firstrow-dragborder")[0])},e.prototype.removeLastRowBorder=function(e){var i;i=this.parent.enableVirtualization?e&&parseInt(e.getAttribute(us),10)!==this.parent.renderModule.data.dataManager.dataSource.json.length-1:e&&this.parent.getRowByIndex(this.parent.getCurrentViewRecords().length-1).getAttribute("data-uid")!==e.getAttribute("data-uid"),this.parent.element.getElementsByClassName("e-lastrow-dragborder").length>0&&e&&i&&t.remove(this.parent.element.getElementsByClassName("e-lastrow-dragborder")[0])},e.prototype.removeBorder=function(e){if(this.removeFirstRowBorder(e),this.parent.rowDropSettings.targetID||this.removeLastRowBorder(e),e=(this.isDropGrid.isFrozenGrid()?this.isDropGrid.getMovableRows():this.isDropGrid.getRows()).filter(function(e){return e.querySelector("td.e-dragborder")})[0]){var t=[].slice.call(e.getElementsByClassName("e-dragborder"));if(this.parent.isFrozenGrid()){var i=parseInt(e.getAttribute(us),10);t=this.borderRowElement(i,".e-dragborder")}X(t,!1,"e-dragborder")}},e.prototype.getElementFromPosition=function(e,t){var i=B(t);e.style.display="none";var r=document.elementFromPoint(i.x,i.y);return e.style.display="",r},e.prototype.onDataBound=function(){this.selectedRowColls.length>0&&this.parent.enableVirtualization&&(this.parent.selectRows(this.selectedRowColls),this.selectedRowColls=[])},e.prototype.getTargetIdx=function(e){return e?parseInt(e.getAttribute(us),10):0},e.prototype.singleRowDrop=function(e){var i=t.closest(e.target,"tr"),r=e.droppedElement.parentElement.ej2_instances[0],n=i?i.rowIndex:r.currentViewData.length-1;this.reorderRow(this.startedRowIndex,n)},e.prototype.columnDrop=function(e){var i=this.parent;if("grouping"!==e.droppedElement.getAttribute("action")&&(D(e.target,is)||D(e.target,"e-emptyrow")||D(e.target,Ko))){var r=t.closest(e.target,"tr"),n=void 0;if("true"!==e.droppedElement.querySelector("tr").getAttribute("single-dragrow")&&e.droppedElement.parentElement.id===i.element.id||"true"===e.droppedElement.querySelector("tr").getAttribute("single-dragrow")&&e.droppedElement.parentElement.id!==i.element.id)return;if(e.droppedElement.parentElement.id!==i.element.id)n=e.droppedElement.parentElement.ej2_instances[0];else if(this.isSingleRowDragDrop||"true"===e.droppedElement.querySelector("tr").getAttribute("single-dragrow"))return void this.singleRowDrop(e);if(n.element.id!==i.element.id&&n.rowDropSettings.targetID!==i.element.id)return;var o=n.getSelectedRecords(),s=this.getTargetIdx(r);isNaN(s)&&(s=0),i.allowPaging&&(s=s+i.pageSettings.currentPage*i.pageSettings.pageSize-i.pageSettings.pageSize),i.notify(Zi,{toIndex:s,records:o}),i.notify(Ti,{type:zt,requestType:"rowdraganddrop"});var l=n.getSelectedRowIndexes(),a=n.allowPaging?n.pageSettings.currentPage*n.pageSettings.pageSize-n.pageSettings.pageSize:0;this.selectedRows=[];for(var h=0,d=o.length;h<d;h++)this.selectedRows.push(a+l[h]);n.notify($i,{indexes:this.selectedRows,records:o}),n.notify(Ti,{type:zt,requestType:"rowdraganddrop"})}},e.prototype.reorderRow=function(e,t){var i=this.parent;if(!i.sortSettings.columns.length&&!i.groupSettings.columns.length&&!i.filterSettings.columns.length){var r=i.allowPaging?i.pageSettings.currentPage*i.pageSettings.pageSize-i.pageSettings.pageSize:0;t+=r,this.selectedRows=i.getSelectedRowIndexes(),i.notify(rn,{fromIndex:e+r,toIndex:t})}},e.prototype.enableAfterRender=function(e){e.module===this.getModuleName()&&e.enable&&this.initializeDrag()},e.prototype.destroy=function(){var e=this.parent.element;!this.parent.isDestroyed&&e&&(e.querySelector("."+Wo)||e.querySelector("."+Ko))&&(this.draggable.destroy(),this.parent.off(Si,this.initializeDrag),this.parent.off(Kt,this.columnDrop),this.parent.off(Ni,this.onActionComplete),this.parent.removeEventListener(Ot,this.onDataBoundFn),this.parent.off(Fi,this.enableAfterRender),this.parent.off(Ki,this.destroy))},e.prototype.getModuleName=function(){return"rowDragAndDrop"},e.prototype.processArgs=function(e){var t=this.parent,i=parseInt(this.startedRow.getAttribute(us),10);t.getSelectedRecords().length>0&&!1===this.startedRow.cells[0].classList.contains("e-selectionbackground")||0===t.getSelectedRecords().length?(this.parent.enableVirtualization?this.rows=[this.startedRow]:(this.rows=[this.parent.getRowByIndex(i)],t.isFrozenGrid()&&(this.rows=[t.getRowByIndex(i),t.getMovableRowByIndex(i)],t.getFrozenMode()===hs&&(this.rows=[t.getRowByIndex(i),t.getMovableRowByIndex(i),t.getFrozenRightRowByIndex(i)]))),this.rowData=[this.parent.getRowInfo(this.startedRow.querySelector("."+_o)).rowData]):(this.rows=t.getSelectedRows(),this.rowData=t.getSelectedRecords())},e}(),Ma=function(){function e(e,i,r,n){var o=this;this.sortRequired=!0,this.isAppliedGroup=!1,this.isAppliedUnGroup=!1,this.reorderingColumns=[],this.visualElement=t.createElement("div",{className:"e-cloneproperties e-dragclone e-gdclone",styles:"line-height:23px",attrs:{action:"grouping"}}),this.helper=function(e){var t=o.parent,i=e.sender.target,r=i.classList.contains("e-groupheadercell")?i:D(i,"e-groupheadercell");return!(!r||!i.classList.contains("e-drag")&&o.groupSettings.allowReordering)&&(o.column=t.getColumnByField(r.firstElementChild.getAttribute("ej-mappingname")),o.visualElement.textContent=r.textContent,o.visualElement.style.width=r.offsetWidth+2+"px",o.visualElement.style.height=r.offsetHeight+2+"px",o.visualElement.setAttribute("e-mappinguid",o.column.uid),t.element.appendChild(o.visualElement),o.visualElement)},this.dragStart=function(e){o.parent.element.classList.add("e-ungroupdrag")},this.drag=function(e){o.groupSettings.allowReordering&&o.animateDropper(e);var i=e.target,r=o.parent.element.querySelector(".e-cloneproperties");o.parent.trigger(Wt,{target:i,draggableType:"headercell",column:o.column}),o.groupSettings.allowReordering||(t.classList(r,["e-defaultcur"],["e-notallowedcur"]),D(i,Ko)||D(i,"e-headercell")||t.classList(r,["e-notallowedcur"],["e-defaultcur"]))},this.dragStop=function(e){o.parent.element.classList.remove("e-ungroupdrag");var i=!(D(e.target,Ko)||D(e.target,"e-gridheader"));if(o.groupSettings.allowReordering&&i){if(t.remove(e.helper),D(e.target,"e-groupdroparea"))o.rearrangeGroup();else if(!D(e.target,"e-grid")){var r=o.parent.getColumnByUid(e.helper.getAttribute("e-mappinguid")).field;-1!==o.groupSettings.columns.indexOf(r)&&o.ungroupColumn(r)}}else i&&t.remove(e.helper)},this.animateDropper=function(e){var t=o.parent.element.querySelector(".e-cloneproperties").getAttribute("e-mappinguid"),i=o.parent.getColumnByUid(t).field,r=D(e.target,"e-groupdroparea"),n=D(e.target,"e-group-animator"),s=[].slice.call(o.element.getElementsByClassName("e-groupheadercell")).map(function(e){return e.querySelector("div").getAttribute("ej-mappingname")}),l=JSON.parse(JSON.stringify(s));if(n||r){if(n){var a=n.querySelector("div[ej-mappingname]").getAttribute("ej-mappingname"),h=+n.getAttribute("index");if(a!==i){var d=l.indexOf(i);-1!==d&&l.splice(d,1);var p=-1!==h&&d===h;l.splice(h+(p?1:0),0,i)}}else r&&-1===l.indexOf(i)&&l.push(i);o.element.innerHTML="",l.length&&!o.element.classList.contains("e-grouped")&&o.element.classList.add("e-grouped"),o.reorderingColumns=l;for(var c=0;c<l.length;c++)o.addColToGroupDrop(l[c])}else o.addLabel(),o.removeColFromGroupDrop(i)},this.drop=function(e){var i=o.parent,r=i.getColumnByUid(e.droppedElement.getAttribute("e-mappinguid"));o.element.classList.remove("e-hover"),t.remove(e.droppedElement),o.aria.setDropTarget(o.parent.element.querySelector(".e-groupdroparea"),!1),o.aria.setGrabbed(o.parent.getHeaderTable().querySelector("[aria-grabbed=true]"),!1),t.isNullOrUndefined(r)||!1===r.allowGrouping||D(i.getColumnHeaderByUid(r.uid),"e-grid").getAttribute("id")!==i.element.getAttribute("id")?o.parent.log("action_disabled_column",{moduleName:o.getModuleName(),columnName:r.headerText}):o.groupColumn(r.field)},this.contentRefresh=!0,this.aria=new Ns,this.parent=e,this.groupSettings=i,this.serviceLocator=n,this.sortedColumns=r,this.focus=n.getService("focus"),this.addEventListener(),this.groupGenerator=new Os(this.parent)}return e.prototype.addLabel=function(){if(!this.element.getElementsByClassName("e-group-animator").length){var e=this.l10n.getConstant("GroupDropArea");this.element.innerHTML=e,this.element.classList.remove("e-grouped")}},e.prototype.rearrangeGroup=function(){this.sortRequired=!1,this.updateModel()},e.prototype.columnDrag=function(e){this.groupSettings.allowReordering&&e.column.allowGrouping&&this.animateDropper(e);var i=this.parent.element.querySelector(".e-cloneproperties");t.classList(i,["e-defaultcur"],["e-notallowedcur"]),D(e.target,"e-groupdroparea")||this.parent.allowReordering&&D(e.target,"e-headercell")||t.classList(i,["e-notallowedcur"],["e-defaultcur"]),e.target.classList.contains("e-groupdroparea")?this.element.classList.add("e-hover"):this.element.classList.remove("e-hover")},e.prototype.columnDragStart=function(e){if(!e.target.classList.contains("e-stackedheadercell")){var t=this.parent.element.querySelector(".e-groupdroparea");this.aria.setDropTarget(t,e.column.allowGrouping);var i=e.target.classList.contains("e-headercell")?e.target:D(e.target,"e-headercell");this.aria.setGrabbed(i,!0,!e.column.allowGrouping)}},e.prototype.columnDrop=function(e){var i=this.parent;if("grouping"===e.droppedElement.getAttribute("action")){var r=i.getColumnByUid(e.droppedElement.getAttribute("e-mappinguid"));if(t.isNullOrUndefined(r)||!1===r.allowGrouping||D(i.getColumnHeaderByUid(r.uid),"e-grid").getAttribute("id")!==i.element.getAttribute("id"))return;this.ungroupColumn(r.field)}},e.prototype.addEventListener=function(){this.parent.isDestroyed||(this.parent.on(Fi,this.enableAfterRender,this),this.parent.on(Pi,this.onActionComplete,this),this.parent.on(Li,this.onActionComplete,this),this.parent.on(Ii,this.onPropertyChanged,this),this.parent.on(Wi,this.clickHandler,this),this.parent.on(Wt,this.columnDrag,this),this.parent.on(_t,this.columnDragStart,this),this.parent.on(tr,this.columnDrop,this),this.parent.on(Kt,this.columnDrop,this),this.parent.on(Di,this.refreshSortIcons,this),this.parent.on(Oi,this.refreshSortIcons,this),this.parent.on(_i,this.keyPressHandler,this),this.parent.on(xi,this.initialEnd,this),this.parent.on(Ei,this.initialEnd,this),this.parent.on(Si,this.render,this),this.parent.on(qi,this.onGroupAggregates,this),this.parent.on(Ki,this.destroy,this),this.parent.on("group-expand-collapse",this.updateExpand,this),this.parent.on("persist-data-changed",this.initialEnd,this))},e.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(Si,this.render),this.parent.off(Fi,this.enableAfterRender),this.parent.off(Pi,this.onActionComplete),this.parent.off(Li,this.onActionComplete),this.parent.off(Ii,this.onPropertyChanged),this.parent.off(Wi,this.clickHandler),this.parent.off(Wt,this.columnDrag),this.parent.off(_t,this.columnDragStart),this.parent.off(Kt,this.columnDrop),this.parent.off(tr,this.columnDrop),this.parent.off(Di,this.refreshSortIcons),this.parent.off(Oi,this.refreshSortIcons),this.parent.off(_i,this.keyPressHandler),this.parent.off(qi,this.onGroupAggregates),this.parent.off(Ki,this.destroy),this.parent.off("group-expand-collapse",this.updateExpand))},e.prototype.initialEnd=function(){var e=this.parent;if(this.parent.off(xi,this.initialEnd),this.parent.off(Ei,this.initialEnd),this.parent.getColumns().length&&this.groupSettings.columns.length){this.contentRefresh=!1;for(var t=0,i=e.groupSettings.columns;t<i.length;t++){var r=i[t];this.groupColumn(r)}this.contentRefresh=!0}},e.prototype.keyPressHandler=function(e){var i=this.parent;if("ctrlSpace"===e.action||this.groupSettings.columns.length&&-1!==["altDownArrow","altUpArrow","ctrlDownArrow","ctrlUpArrow","enter"].indexOf(e.action))switch(e.preventDefault(),e.action){case"altDownArrow":case"altUpArrow":var r=i.allowSelection?i.getSelectedRowIndexes():[];if(r.length){for(var n=i.getContentTable().querySelector(gs).children,o=void 0,s=i.getDataRows()[r[r.length-1]].rowIndex;s>=0;s--)if(!n[s].classList.contains(is)&&!n[s].classList.contains("e-detailrow")){o=n[s];break}this.expandCollapseRows(o.querySelector("altUpArrow"===e.action?".e-recordplusexpand":".e-recordpluscollapse"))}break;case"ctrlDownArrow":this.expandAll();break;case"ctrlUpArrow":this.collapseAll();break;case"enter":if(this.parent.isEdit||null!==t.closest(e.target,"#"+this.parent.element.id+"_searchbar"))return;var l=this.focus.getFocusedElement(),a=l?l.parentElement.querySelector('[class^="e-record"]'):null;if(!a)break;this.expandCollapseRows(a);break;case"ctrlSpace":var h=i.focusModule.currentInfo.element;if(h&&h.classList.contains("e-headercell")){var d=i.getColumnByUid(h.firstElementChild.getAttribute("e-mappinguid"));d.field&&i.groupSettings.columns.indexOf(d.field)<0?this.groupColumn(d.field):this.ungroupColumn(d.field)}}},e.prototype.clickHandler=function(e){this.expandCollapseRows(e.target),this.applySortFromTarget(e.target),this.unGroupFromTarget(e.target),this.toogleGroupFromHeader(e.target)},e.prototype.unGroupFromTarget=function(e){e.classList.contains("e-ungroupbutton")&&this.ungroupColumn(e.parentElement.getAttribute("ej-mappingname"))},e.prototype.toogleGroupFromHeader=function(e){this.groupSettings.showToggleButton&&(e.classList.contains("e-grptogglebtn")?e.classList.contains("e-toggleungroup")?this.ungroupColumn(this.parent.getColumnByUid(e.parentElement.getAttribute("e-mappinguid")).field):this.groupColumn(this.parent.getColumnByUid(e.parentElement.getAttribute("e-mappinguid")).field):e.classList.contains("e-toggleungroup")&&this.ungroupColumn(e.parentElement.getAttribute("ej-mappingname")))},e.prototype.applySortFromTarget=function(e){var i=this.parent,r=t.closest(e,".e-groupheadercell");if(i.allowSorting&&r&&!e.classList.contains("e-ungroupbutton")&&!e.classList.contains("e-toggleungroup")){var n=r.firstElementChild.getAttribute("ej-mappingname");i.getColumnHeaderByField(n).getElementsByClassName("e-ascending").length?i.sortColumn(n,"Descending",!0):i.sortColumn(n,"Ascending",!0)}},e.prototype.expandCollapseRows=function(e){var i=D(e,"e-recordplusexpand")||D(e,"e-recordpluscollapse");if(i){var r=this.parent.getContentTable().querySelector(gs).children,n=void 0,o=this.parent,s=i.parentElement.getElementsByClassName("e-indentcell").length,l=i.parentElement.getAttribute("data-uid"),a=o.getRowObjectFromUID(l),h=!1;if(i.classList.contains("e-recordpluscollapse")?(t.addClass([i],"e-recordplusexpand"),t.removeClass([i],"e-recordpluscollapse"),i.firstElementChild.className="e-icons e-gdiagonaldown e-icon-gdownarrow",h=!0,a.isExpand=!0,ae(o)&&this.updateVirtualRows(o,e,h,void 0,void 0),this.parent.groupSettings.enableLazyLoading&&this.parent.contentModule.captionExpand(i.parentElement)):(n=!0,a.isExpand=!1,t.removeClass([i],"e-recordplusexpand"),t.addClass([i],"e-recordpluscollapse"),i.firstElementChild.className="e-icons e-gnextforward e-icon-grightarrow",ae(o)&&this.updateVirtualRows(o,e,!n,void 0,void 0),this.parent.groupSettings.enableLazyLoading&&this.parent.contentModule.captionCollapse(i.parentElement)),this.aria.setExpand(i,h),!ae(o)&&!this.parent.groupSettings.enableLazyLoading){for(var d=o.getRowsObject(),p=d.indexOf(a),c={},u=p;u<d.length&&!(u>p&&d[u].indent===s);u++){if(d[u].isDetailRow){var g=d[u-1].isExpand&&d[u-1].visible;r[u].style.display=g?"":"none"}else if(!1===c[d[u].parentUid])d[u].visible=!1,r[u].style.display="none";else{if(!(d[u].isDataRow||d[u].isCaptionRow||d[u].isDetailRow||d[u].isAggregateRow)){if((g=d[u].cells.some(function(e){return e.isDataCell&&e.visible}))===d[u].visible)continue}d[u].visible=!0,r[u].style.display="",r[u].classList.remove("e-hide")}d[u].isCaptionRow&&(c[d[u].uid]=d[u].isExpand&&d[u].visible)}this.parent.notify(Co,{rows:this.parent.getRowsObject()})}this.parent.notify(Bo,{isCollapse:n,parentUid:l})}},e.prototype.updateVirtualRows=function(e,t,i,r,n){var o=e.getRowObjectFromUID(t.closest("tr").getAttribute("data-uid"));o.isExpand=i,v(e),this.parent.notify(So,{}),(r=e.getDataModule().generateQuery(!1)).queries=e.getDataModule().aggregateQuery(e.getQuery().clone()).queries;var s={requestType:"virtualscroll",rowObject:o};e.contentModule&&(s.virtualInfo=e.contentModule.prevInfo),e.getDataModule().getData(s,r.requiresCount()).then(function(t){return e.renderModule.dataManagerSuccess(t,s)})},e.prototype.expandCollapse=function(e){if(this.parent.groupSettings.columns.length){e||this.parent.notify(qn,e);for(var t,i=this.parent.getContentTable().querySelector(gs).children,r=this.parent.getRowsObject(),n=0,o=i.length;n<o;n++)i[n].querySelectorAll(".e-recordplusexpand, .e-recordpluscollapse").length?((t=i[n].querySelector(e?".e-recordpluscollapse":".e-recordplusexpand"))&&(t.className=e?"e-recordplusexpand":"e-recordpluscollapse",t.firstElementChild.className=e?"e-icons e-gdiagonaldown e-icon-gdownarrow":"e-icons e-gnextforward e-icon-grightarrow"),i[n].firstElementChild.classList.contains("e-recordplusexpand")||i[n].firstElementChild.classList.contains("e-recordpluscollapse")||(i[n].style.display=e?"":"none")):i[n].style.display=e?"":"none",r[n].isCaptionRow&&(r[n].isExpand=!!e);this.parent.updateVisibleExpandCollapseRows(),this.parent.notify(Co,{rows:this.parent.getRowsObject()})}},e.prototype.expandAll=function(){this.expandCollapse(!0)},e.prototype.collapseAll=function(){this.expandCollapse(!1)},e.prototype.render=function(){this.l10n=this.serviceLocator.getService("localization"),this.renderGroupDropArea(),this.initDragAndDrop(),this.refreshToggleBtn()},e.prototype.renderGroupDropArea=function(){var e=this.parent.element.querySelector(".e-groupdroparea");e&&t.remove(e),this.element=this.parent.createElement("div",{className:"e-groupdroparea",attrs:{tabindex:"-1"}}),this.groupSettings.allowReordering&&this.element.classList.add("e-group-animate"),this.updateGroupDropArea(),this.parent.element.insertBefore(this.element,this.parent.element.firstChild),this.groupSettings.showDropArea||(this.element.style.display="none")},e.prototype.updateGroupDropArea=function(e){if(this.groupSettings.showDropArea&&!this.groupSettings.columns.length){var t=this.l10n.getConstant("GroupDropArea");this.element.innerHTML=t,this.element.classList.remove("e-grouped")}else(this.element.innerHTML===this.l10n.getConstant("GroupDropArea")&&(1===this.groupSettings.columns.length||!this.isAppliedGroup&&!this.isAppliedUnGroup)||e)&&(this.element.innerHTML=""),this.element.classList.add("e-grouped")},e.prototype.initDragAndDrop=function(){this.initializeGHeaderDrop(),this.initializeGHeaderDrag()},e.prototype.initializeGHeaderDrag=function(){new t.Draggable(this.element,{dragTarget:this.groupSettings.allowReordering?".e-drag":".e-groupheadercell",distance:this.groupSettings.allowReordering?-10:5,helper:this.helper,dragStart:this.dragStart,drag:this.drag,dragStop:this.dragStop})},e.prototype.initializeGHeaderDrop=function(){new t.Droppable(this.element,{accept:".e-dragclone",drop:this.drop})},e.prototype.groupColumn=function(e){var i=this.parent,r=i.getColumnByField(e);t.isNullOrUndefined(r)||!1===r.allowGrouping||this.contentRefresh&&this.groupSettings.columns.indexOf(e)>-1?this.parent.log("action_disabled_column",{moduleName:this.getModuleName(),columnName:r.headerText}):W(i)?i.notify(ur,{instance:this,handler:this.groupColumn,arg1:e}):(r.visible=i.groupSettings.showGroupedColumn,this.colName=e,this.isAppliedGroup=!0,this.contentRefresh?this.updateModel():this.addColToGroupDrop(e),this.updateGroupDropArea(),this.isAppliedGroup=!1)},e.prototype.ungroupColumn=function(e){var i=this.parent,r=this.parent.enableColumnVirtualization?this.parent.columns.filter(function(t){return t.field===e})[0]:i.getColumnByField(e);if(!(t.isNullOrUndefined(r)||!1===r.allowGrouping||this.groupSettings.columns.indexOf(e)<0))if(W(i))i.notify(ur,{instance:this,handler:this.ungroupColumn,arg1:e});else{r.visible=!0,this.colName=r.field;var n=JSON.parse(JSON.stringify(this.groupSettings.columns));if(n.splice(n.indexOf(this.colName),1),this.sortedColumns.indexOf(e)<0)for(var o=0,s=i.sortSettings.columns.length;o<s;o++)if(e===i.sortSettings.columns[o].field){i.sortSettings.columns.splice(o,1);break}this.groupSettings.allowReordering&&(this.reorderingColumns=n),this.groupSettings.columns=n,i.allowGrouping&&(this.isAppliedUnGroup=!0,this.parent.dataBind())}},e.prototype.updateModel=function(){var e=JSON.parse(JSON.stringify(this.groupSettings.columns));e=this.reorderingColumns.length?JSON.parse(JSON.stringify(this.reorderingColumns)):e,this.sortRequired&&(-1===e.indexOf(this.colName)&&e.push(this.colName),this.groupAddSortingQuery(this.colName)),this.sortRequired=!0,this.parent.groupSettings.columns=e,this.parent.dataBind()},e.prototype.onActionComplete=function(e){"grouping"===e.requestType?this.addColToGroupDrop(this.colName):this.removeColFromGroupDrop(this.colName);var i=this.groupSettings.columns.indexOf(this.colName)>-1?{columnName:this.colName,requestType:"grouping",type:Dt}:{requestType:"ungrouping",type:Dt};this.parent.trigger(Dt,t.extend(e,i)),this.colName=null},e.prototype.groupAddSortingQuery=function(e){for(var t=0;t<this.parent.sortSettings.columns.length&&this.parent.sortSettings.columns[t].field!==e;)t++;this.parent.sortSettings.columns.length===t?this.parent.sortSettings.columns.push({field:e,direction:"Ascending",isFromGroup:!0}):this.parent.allowSorting||(this.parent.sortSettings.columns[t].direction="Ascending")},e.prototype.createElement=function(e){var t=this.parent,i="Ascending",r=this.parent.createElement("div",{className:"e-grid-icon e-group-animator"}),n=this.parent.createElement("div",{className:"e-grid-icon e-groupheadercell"}),o=this.parent.createElement("div",{attrs:{"ej-mappingname":e}});j(e)&&o.setAttribute("ej-complexname",V(e));var s=this.parent.getColumnByField(e),l=t.getColumnHeaderByUid(s.uid);return this.groupSettings.allowReordering&&o.appendChild(this.parent.createElement("span",{className:"e-drag e-icons e-icon-drag",innerHTML:"&nbsp;",attrs:{title:"Drag",tabindex:"-1","aria-label":"Drag the grouped column"}})),o.appendChild(this.parent.createElement("span",{className:"e-grouptext",innerHTML:s.headerText,attrs:{tabindex:"-1","aria-label":"sort the grouped column"}})),this.groupSettings.showToggleButton&&o.appendChild(this.parent.createElement("span",{className:"e-togglegroupbutton e-icons e-icon-ungroup e-toggleungroup",innerHTML:"&nbsp;",attrs:{tabindex:"-1","aria-label":"ungroup button"}})),l.querySelectorAll(".e-ascending,.e-descending").length&&(i=l.querySelector(".e-ascending")?"Ascending":"Descending"),o.appendChild(this.parent.createElement("span",{className:"e-groupsort e-icons e-"+i.toLowerCase()+" e-icon-"+i.toLowerCase(),innerHTML:"&nbsp;",attrs:{tabindex:"-1","aria-label":"sort the grouped column"}})),o.appendChild(this.parent.createElement("span",{className:"e-ungroupbutton e-icons e-icon-hide",innerHTML:"&nbsp;",attrs:{title:this.l10n.getConstant("UnGroup"),tabindex:"-1","aria-label":"ungroup the grouped column"},styles:this.groupSettings.showUngroupButton?"":"display:none"})),n.appendChild(o),this.groupSettings.allowReordering&&(r.appendChild(n),r.appendChild(this.createSeparator()),n=r),n},e.prototype.addColToGroupDrop=function(e){var i=j(e)?this.parent.element.querySelector(".e-groupdroparea div[ej-complexname="+V(e)+"]"):this.parent.element.querySelector(".e-groupdroparea div[ej-mappingname="+e+"]");if(!this.groupSettings.allowReordering||!i){var r=this.parent.getColumnByField(e);if(!t.isNullOrUndefined(r)){var n=this.createElement(e);if(this.groupSettings.allowReordering){var o=this.element.getElementsByClassName("e-group-animator").length;n.setAttribute("index",o.toString())}this.element.appendChild(n)}}},e.prototype.createSeparator=function(){return this.parent.createElement("span",{className:"e-nextgroup e-icons e-icon-next",innerHTML:"&nbsp;",attrs:{tabindex:"-1","aria-label":"Separator for the grouped columns"},styles:this.groupSettings.showUngroupButton?"":"display:none"})},e.prototype.refreshToggleBtn=function(e){if(this.groupSettings.showToggleButton)for(var i=[].slice.call(this.parent.getHeaderTable().getElementsByClassName("e-headercelldiv")),r=0,n=i.length;r<n;r++)if(!i[r].classList.contains("e-emptycell")&&!i[r].classList.contains("e-headerchkcelldiv")){var o=this.parent.getColumnByUid(i[r].getAttribute("e-mappinguid"));(!this.parent.showColumnMenu||this.parent.showColumnMenu&&!o.showColumnMenu)&&(i[r].getElementsByClassName("e-grptogglebtn").length&&t.remove(i[r].querySelectorAll(".e-grptogglebtn")[0]),e||i[r].appendChild(this.parent.createElement("span",{className:"e-grptogglebtn e-icons "+(this.groupSettings.columns.indexOf(o.field)>-1?"e-toggleungroup e-icon-ungroup":"e-togglegroup e-icon-group"),attrs:{tabindex:"-1","aria-label":"Group button"}})))}},e.prototype.removeColFromGroupDrop=function(e){if(!t.isNullOrUndefined(this.getGHeaderCell(e))){var i=this.getGHeaderCell(e);if(this.groupSettings.allowReordering){var r=D(i,"e-group-animator");t.remove(r)}else t.remove(i);this.updateGroupDropArea()}this.isAppliedUnGroup=!1},e.prototype.onPropertyChanged=function(e){if(e.module===this.getModuleName())for(var t=0,i=Object.keys(e.properties);t<i.length;t++){var r=i[t];switch(r){case"columns":var n=void 0;if(this.contentRefresh){if(this.isAppliedUnGroup)n={columnName:this.colName,requestType:"ungrouping",type:zt};else{if(!this.isAppliedGroup){this.updateGroupDropArea(!0);for(var o=0;o<this.parent.sortSettings.columns.length;o++)this.parent.sortSettings.columns[o].isFromGroup&&(this.parent.sortSettings.columns.splice(o,1),o--);for(var s=0;s<this.groupSettings.columns.length;s++){this.colName=this.groupSettings.columns[s];this.parent.getColumnByField(this.colName).visible=this.parent.groupSettings.showGroupedColumn,this.groupAddSortingQuery(this.colName),s<this.groupSettings.columns.length-1&&this.addColToGroupDrop(this.groupSettings.columns[s])}}n={columnName:this.colName,requestType:e.properties[r].length?"grouping":"ungrouping",type:zt}}if(!this.groupSettings.showGroupedColumn){var l=e.oldProperties[r];for(s=0;s<l.length;s++)-1===e.properties[r].indexOf(l[s])&&(this.parent.getColumnByField(l[s]).visible=!0)}this.parent.notify(Ti,n)}break;case"showDropArea":this.updateGroupDropArea(),this.groupSettings.showDropArea?this.element.style.display="":this.element.style.display="none";break;case"showGroupedColumn":this.updateGroupedColumn(this.groupSettings.showGroupedColumn),this.parent.notify(Ti,{requestType:"refresh"});break;case"showUngroupButton":this.updateButtonVisibility(this.groupSettings.showUngroupButton,"e-ungroupbutton");break;case"showToggleButton":this.updateButtonVisibility(this.groupSettings.showToggleButton,"e-togglegroupbutton "),this.parent.refreshHeader();break;case"enableLazyLoading":this.parent.freezeRefresh()}}},e.prototype.updateGroupedColumn=function(e){for(var t=0;t<this.groupSettings.columns.length;t++)this.parent.getColumnByField(this.groupSettings.columns[t]).visible=e},e.prototype.updateButtonVisibility=function(e,t){for(var i=[].slice.call(this.element.getElementsByClassName(t)),r=0;r<i.length;r++)i[r].style.display=e?"":"none"},e.prototype.enableAfterRender=function(e){e.module===this.getModuleName()&&e.enable&&this.render()},e.prototype.destroy=function(){var e=this.parent.element;e&&(e.querySelector("."+Wo)||e.querySelector("."+Ko))&&(!this.parent.isDestroyed&&this.parent.allowGrouping||this.parent.refreshing||this.clearGrouping(),this.removeEventListener(),this.refreshToggleBtn(!0),this.element.parentNode&&t.remove(this.element))},e.prototype.clearGrouping=function(){var e=JSON.parse(JSON.stringify(this.groupSettings.columns));this.contentRefresh=!1;for(var t=0,i=e.length;t<i;t++)t===i-1&&(this.contentRefresh=!0),this.ungroupColumn(e[t]);this.contentRefresh=!0},e.prototype.getModuleName=function(){return"group"},e.prototype.refreshSortIcons=function(){var e,i=this.parent,r=i.sortSettings.columns,n=i.groupSettings.columns,o=this.parent.getColumns().map(function(e){return e.field});this.refreshToggleBtn();for(var s=0,l=r.length;s<l;s++)-1!==o.indexOf(r[s].field)&&(e=i.getColumnHeaderByField(r[s].field),!i.allowSorting&&(this.sortedColumns.indexOf(r[s].field)>-1||this.groupSettings.columns.indexOf(r[s].field)>-1)?(t.classList(e.querySelector(".e-sortfilterdiv"),["e-ascending","e-icon-ascending"],[]),r.length>1&&e.querySelector(".e-headercelldiv").appendChild(this.parent.createElement("span",{className:"e-sortnumber",innerHTML:(s+1).toString()}))):this.getGHeaderCell(r[s].field)&&this.getGHeaderCell(r[s].field).getElementsByClassName("e-groupsort").length&&("Ascending"===r[s].direction?t.classList(this.getGHeaderCell(r[s].field).querySelector(".e-groupsort"),["e-ascending","e-icon-ascending"],["e-descending","e-icon-descending"]):t.classList(this.getGHeaderCell(r[s].field).querySelector(".e-groupsort"),["e-descending","e-icon-descending"],["e-ascending","e-icon-ascending"])));for(s=0,l=n.length;s<l;s++)-1!==o.indexOf(n[s])&&i.getColumnHeaderByField(n[s]).setAttribute("aria-grouped","true")},e.prototype.getGHeaderCell=function(e){return this.element&&this.element.querySelector('[ej-mappingname="'+e+'"]')?this.element.querySelector('[ej-mappingname="'+e+'"]').parentElement:null},e.prototype.onGroupAggregates=function(e){var t=this.iterateGroupAggregates(e),i=this.groupGenerator.generateRows(t,{}),r=this.parent.getRowsObject().filter(function(e){return!e.isDataRow}),n=i.filter(function(e){return!e.isDataRow});(this.parent.isReact||this.parent.isVue)&&this.parent.destroyTemplate(["groupFooterTemplate","groupCaptionTemplate","footerTemplate"]);for(var o=0;o<n.length;o++){var s=n[o],l={cells:s.cells.filter(function(e){return e.isDataCell}),data:s.data,dataUid:r[o]?r[o].uid:""};this.parent.notify(Ui,l)}},e.prototype.iterateGroupAggregates=function(e){var t=e instanceof Array?e:[],r=this.parent.getRowsObject(),n=this.parent.getCurrentViewRecords(),o=[],s=r.map(function(e){return"delete"===e.edit&&o.push(e.data),e.changes instanceof Object?e.changes:e.data}),l=this.parent.getPrimaryKeyFieldNames()[0];s=0===t.length?s:t;var a=n.map(function(e){var t,r=i.DataUtil.getObject(l,e);return s.some(function(e){return t=e,r===i.DataUtil.getObject(l,e)})?t:e}),h=e;if((!h.type||"cancel"!==h.type)&&o.length>0)for(var d=0;d<o.length;d++){var p=a.indexOf(o[d]);a.splice(p,1)}for(var c=[],u=this.parent.aggregates,g=0;g<u.length;g++)for(var f=u[g],m=0;m<f.columns.length;m++){var y={};y={type:f.columns[m].type.toString().toLowerCase(),field:f.columns[m].field},c.push(y)}for(var v,C,w=this.parent.groupSettings.columns,b=0;b<w.length;b++)C=v||a,v=i.DataUtil.group(C,w[b],c,null,null);return v},e.prototype.updateExpand=function(e){for(var i=e.uid,r=e.isExpand,n=this.parent.getRowsObject(),o=0;o<n.length;o++){var s=n[o];if(s.uid===i||t.isNullOrUndefined(i)){s.isExpand=r;for(var l=function(e){var r=n[e],o=void 0;if(r.parentUid!==s.uid&&(o=n.filter(function(e){return e.uid===r.parentUid})[0]),r.parentUid===s.uid?r.visible=s.isExpand:t.isNullOrUndefined(o)||r.parentUid!==o.uid||(o.isExpand&&!0===o.visible?r.visible=!0:o.isExpand&&!1===o.visible&&(r.visible=!1)),t.isNullOrUndefined(i))return"break"},a=o+1;a<n.length;a++){if("break"===l(a))break}}}this.parent.notify(xi,{rows:n,args:{isFrozen:!1,rows:n}})},e}(),Oa=function(){function i(e,t){this.aria=new Ns,this.childRefs=[],this.parent=e,this.parent.isDestroyed||(this.focus=t.getService("focus"),this.parent.on(Wi,this.clickHandler,this),this.parent.on(Ki,this.destroy,this),this.parent.on(_i,this.keyPressHandler,this),this.parent.on(Zr,this.expand,this),this.parent.on(Qi,this.refreshColSpan,this),this.parent.on(Ki,this.destroyChildGrids,this),this.parent.on(ko,this.destroyChildGrids,this))}return i.prototype.clickHandler=function(e){this.toogleExpandcollapse(t.closest(e.target,"td"))},i.prototype.toogleExpandcollapse=function(i){var r,n=this.parent,o=this.parent.getContentTable(),s=this.parent.getCurrentViewRecords().length-1,l=i&&i.classList.contains("e-detailrowcollapse");if(i&&(i.classList.contains("e-detailrowcollapse")||i.classList.contains("e-detailrowexpand"))){var a=i.parentElement,h=a.getAttribute("data-uid"),d=n.getRowObjectFromUID(h),p=this.parent.getContentTable().querySelector(gs).children[a.rowIndex+1];if(i.classList.contains("e-detailrowcollapse")){var c=d.data;if(this.isDetailRow(p))p.style.display="",n.notify(Cn,{data:c,childGrid:n.childGrid,detailElement:i,isExpanded:l});else if(n.getDetailTemplate()||n.childGrid){var u=N("grid-row"),g=this.parent.createElement("tr",{className:"e-detailrow",attrs:{"data-uid":u}}),f=this.parent.createElement("td",{className:"e-detailcell"}),m=this.parent.getVisibleColumns().length;this.parent.allowRowDragAndDrop&&m++,f.setAttribute("colspan",m.toString());var y=new jo({isDataRow:!0,isExpand:!0,uid:u,isDetailRow:!0,cells:[new Vo({cellType:e.CellType.Indent}),new Vo({isDataCell:!0,visible:!0})]});y.parentUid=d.uid;for(var v=0,C=n.groupSettings.columns.length;v<C;v++)g.appendChild(this.parent.createElement("td",{className:"e-indentcell"})),y.cells.unshift(new Vo({cellType:e.CellType.Indent}));if(g.appendChild(this.parent.createElement("td",{className:"e-detailindentcell"})),g.appendChild(f),a.parentNode.insertBefore(g,a.nextSibling),n.detailTemplate){var w=this.parent.isReact&&"string"!=typeof n.detailTemplate,b=n.element.id+"detailTemplate";w?(n.getDetailTemplate()(c,n,"detailTemplate",b,null,null,f),this.parent.renderTemplates()):P(f,n.getDetailTemplate()(c,n,"detailTemplate",b))}else{r=new Jl(this.getGridModel(n,d,n.printMode)),this.childRefs.push(r),r.query&&(r.query=r.query.clone()),r.parentDetails={parentID:n.element.id,parentPrimaryKeys:n.getPrimaryKeyFieldNames(),parentKeyField:n.childGrid.queryString,parentKeyFieldValue:c[n.childGrid.queryString],parentRowData:c},r.isLegacyTemplate=n.isReact||n.isLegacyTemplate,n.isPrinting&&(r.isPrinting=!0,r.on(xi,this.promiseResolve(r),this),r.on(Ei,this.promiseResolve(r),this)),d.childGrid=r;var S=r.getInjectedModules(),R=n.getInjectedModules();S&&S.length===R.length||r.setInjectedModules(R);var x=this.parent.createElement("div",{id:"child"+L(a,"e-grid").length+"_grid"+a.rowIndex+N("")});f.appendChild(x),r.appendTo(x)}g.appendChild(f),a.nextSibling?a.parentNode.insertBefore(g,a.nextSibling):a.parentNode.appendChild(g);var F=n.getRows(),E=n.getRowsObject();F.splice(F.indexOf(a)+1,0,g),E.splice(E.indexOf(d)+1,0,y),n.trigger(ei,{detailElement:f,data:c,childGrid:r}),n.notify(ei,{rows:E})}if(t.classList(i,["e-detailrowexpand"],["e-detailrowcollapse"]),t.classList(i.firstElementChild,["e-dtdiagonaldown","e-icon-gdownarrow"],["e-dtdiagonalright","e-icon-grightarrow"]),d.isExpand=!0,i.classList.contains("e-lastrowcell")&&this.parent.getContent().clientHeight>o.scrollHeight){t.removeClass(i.parentElement.querySelectorAll("td"),"e-lastrowcell");var I=o.querySelector(gs).getElementsByClassName("e-detailrow").length-1;t.addClass(o.querySelector(gs).getElementsByClassName("e-detailrow")[I].childNodes,["e-lastrowcell"]),this.lastrowcell=!0}this.aria.setExpand(i,!0)}else this.isDetailRow(p)&&(p.style.display="none",n.notify(Cn,{data:d.data,childGrid:n.childGrid,detailElement:i,isExpanded:l})),t.classList(i,["e-detailrowcollapse"],["e-detailrowexpand"]),t.classList(i.firstElementChild,["e-dtdiagonalright","e-icon-grightarrow"],["e-dtdiagonaldown","e-icon-gdownarrow"]),parseInt(a.getAttribute(us),10)===s&&this.lastrowcell&&(t.addClass(i.parentElement.querySelectorAll("td"),"e-lastrowcell"),this.lastrowcell=!1),d.isExpand=!1,this.aria.setExpand(i,!1);t.isNullOrUndefined(n.detailTemplate)||(n.updateVisibleExpandCollapseRows(),n.notify(Co,{rows:n.getRowsObject()}))}},i.prototype.getGridModel=function(e,i,r){var n;return e.isPrinting&&i.isExpand&&e.expandedRows&&e.expandedRows[i.index]&&e.expandedRows[i.index].gridModel?(e.expandedRows[i.index].gridModel.hierarchyPrintMode=e.childGrid.hierarchyPrintMode,n=e.expandedRows[i.index].gridModel):(e.isPrinting&&e.childGrid.allowPaging&&(e.childGrid.allowPaging="CurrentPage"===r),n=t.extend({},{},e.childGrid,!0)),n},i.prototype.promiseResolve=function(e){var t=this;return function(){e.off(xi,t.promiseResolve),e.off(Ei,t.promiseResolve),e.notify(Jr,{})}},i.prototype.isDetailRow=function(e){return e&&e.classList.contains("e-detailrow")},i.prototype.destroy=function(){var e=this.parent.element;!this.parent.isDestroyed&&e&&(e.querySelector("."+Wo)||e.querySelector("."+Ko))&&(this.parent.off(Wi,this.clickHandler),this.parent.off(Ki,this.destroy),this.parent.off(_i,this.keyPressHandler),this.parent.off(Zr,this.expand),this.parent.off(Qi,this.refreshColSpan),this.parent.off(Ki,this.destroyChildGrids),this.parent.off(ko,this.destroyChildGrids))},i.prototype.getTDfromIndex=function(e,t){var i=this.parent.getDataRows()[e];return i&&i.querySelector(t)?i.querySelector(t):null},i.prototype.expand=function(e){isNaN(e)||(e=this.getTDfromIndex(e,".e-detailrowcollapse")),e&&e.classList.contains("e-detailrowcollapse")&&this.toogleExpandcollapse(e)},i.prototype.collapse=function(e){isNaN(e)||(e=this.getTDfromIndex(e,".e-detailrowexpand")),e&&e.classList.contains("e-detailrowexpand")&&this.toogleExpandcollapse(e)},i.prototype.expandAll=function(){this.expandCollapse(!0),this.parent.trigger(Dt,{requestType:"expandAllComplete",type:Dt,moduleObj:this})},i.prototype.collapseAll=function(){this.expandCollapse(!1),this.parent.trigger(Dt,{requestType:"collapseAllComplete",type:Dt,moduleObj:this})},i.prototype.expandCollapse=function(e){for(var t,i=this.parent.getDataRows(),r=0,n=i.length;r<n;r++)t=i[r].querySelector(".e-detailrowcollapse, .e-detailrowexpand"),e?this.expand(t):this.collapse(t)},i.prototype.keyPressHandler=function(e){var t=this.parent;switch(e.action){case"ctrlDownArrow":this.expandAll();break;case"ctrlUpArrow":this.collapseAll();break;case"altUpArrow":case"altDownArrow":var i=t.allowSelection?t.getSelectedRowIndexes():[];if(i.length){var r=t.getDataRows()[i[i.length-1]].querySelector(".e-detailrowcollapse, .e-detailrowexpand");"altDownArrow"===e.action?this.expand(r):this.collapse(r)}break;case"enter":if(this.parent.isEdit)return;var n=this.focus.getFocusedElement();if(!e.target.classList.contains("e-detailrowcollapse")&&!e.target.classList.contains("e-detailrowexpand"))break;this.toogleExpandcollapse(n)}},i.prototype.refreshColSpan=function(){for(var e=this.parent.contentModule.getTable().querySelectorAll("tr.e-detailrow"),t=this.parent.getVisibleColumns().length,i=0;i<e.length;i++)e[i].querySelector(".e-detailcell").setAttribute("colspan",t+"")},i.prototype.destroyChildGrids=function(){for(var e=this.parent.getRowsObject(),t=0;t<e.length;t++)e[t].childGrid=null;for(t=0;t<this.childRefs.length;t++)this.childRefs[t].isDestroyed||this.childRefs[t].destroy();this.childRefs=[]},i.prototype.getModuleName=function(){return"detailRow"},i}(),ka=function(){function i(e,t){this.predefinedItems={},this.items=["Add","Edit","Update","Delete","Cancel","Print","Search","ColumnChooser","PdfExport","ExcelExport","CsvExport","WordExport"],this.parent=e,this.gridID=e.element.id,this.serviceLocator=t,this.addEventListener()}return i.prototype.render=function(){this.l10n=this.serviceLocator.getService("localization");for(var e=this.parent.enableAdaptiveUI,t=["Edit","Delete","Update","Cancel"],i=0,r=["Add","Edit","Update","Delete","Cancel","Print","PdfExport","ExcelExport","WordExport","CsvExport"];i<r.length;i++){var n=r[i],o=n.toLowerCase(),s=o[0].toUpperCase()+o.slice(1);this.predefinedItems[n]={id:this.gridID+"_"+o,prefixIcon:"e-"+o,text:this.l10n.getConstant(s),tooltipText:this.l10n.getConstant(s)},e&&(this.predefinedItems[n].text="",this.predefinedItems[n].visible=-1===t.indexOf(n))}this.predefinedItems.Search={id:this.gridID+"_search",tooltipText:this.l10n.getConstant("Search"),align:"Right",cssClass:"e-search-wrapper",type:"Input"},this.predefinedItems.ColumnChooser={id:this.gridID+"_columnchooser",cssClass:"e-cc e-ccdiv e-cc-toolbar",suffixIcon:"e-columnchooser-btn",text:e?"":this.l10n.getConstant("Columnchooser"),tooltipText:this.l10n.getConstant("Columnchooser"),align:"Right"},"Vertical"===this.parent.rowRenderingMode&&(this.parent.allowFiltering&&"FilterBar"!==this.parent.filterSettings.type&&(this.predefinedItems.responsiveFilter={id:this.gridID+"_responsivefilter",cssClass:"e-gridresponsiveicons e-icons",suffixIcon:"e-resfilter-icon",tooltipText:this.l10n.getConstant("FilterButton")}),this.parent.allowSorting&&(this.predefinedItems.responsiveSort={id:this.gridID+"_responsivesort",cssClass:"e-gridresponsiveicons e-icons",suffixIcon:"e-ressort-icon",tooltipText:this.l10n.getConstant("Sort")})),this.parent.enableAdaptiveUI&&this.parent.toolbar.indexOf("Search")>-1&&(this.predefinedItems.responsiveBack={id:this.gridID+"_responsiveback",cssClass:"e-gridresponsiveicons e-icons",suffixIcon:"e-resback-icon",visible:!1}),this.createToolbar()},i.prototype.getToolbar=function(){return this.toolbar.element},i.prototype.destroy=function(){this.toolbar&&!this.toolbar.isDestroyed&&(this.toolbar.element?(this.toolbar.off("render-react-toolbar-template",this.addReactToolbarPortals),this.toolbar.destroy()):(this.parent.destroyTemplate(["toolbarTemplate"]),this.parent.isReact&&this.parent.renderTemplates()),this.unWireEvent(),this.removeEventListener(),this.element.parentNode&&t.remove(this.element))},i.prototype.bindSearchEvents=function(){this.searchElement=t.select("#"+this.gridID+"_searchbar",this.element),this.wireEvent(),this.refreshToolbarItems(),this.parent.searchSettings&&this.updateSearchBox()},i.prototype.toolbarCreated=function(e){this.element.querySelector(".e-search-wrapper")&&(!this.parent.enableAdaptiveUI||e?this.element.querySelector(".e-search-wrapper").innerHTML='<div class="e-input-group e-search" role="search">                    <input id="'+this.gridID+'_searchbar" class="e-input" name="input" type="search"                     placeholder= "'+this.l10n.getConstant("Search")+'"/>                    <span id="'+this.gridID+'_searchbutton" class="e-input-group-icon e-search-icon e-icons"                     tabindex="-1" title="'+this.l10n.getConstant("Search")+'" aria-label= "search"></span>                     </div>':this.element.querySelector(".e-search-wrapper").innerHTML='<span id="'+this.gridID+'_searchbutton" class="e-input-group-icon e-search-icon e-icons"                     tabindex="-1" title="'+this.l10n.getConstant("Search")+'" aria-label= "search"></span>                     </div>'),this.bindSearchEvents()},i.prototype.createToolbar=function(){var e=this.getItems();this.toolbar=new a.Toolbar({items:e,clicked:this.toolbarClickHandler.bind(this),enablePersistence:this.parent.enablePersistence,enableRtl:this.parent.enableRtl,created:this.toolbarCreated.bind(this)}),this.toolbar.isReact=this.parent.isReact,this.toolbar.on("render-react-toolbar-template",this.addReactToolbarPortals,this);this.toolbar.isStringTemplate=!0;var t="viewContainerRef";if(this.parent[t]&&(this.toolbar.registeredTemplate={},this.toolbar[t]=this.parent[t]),this.element=this.parent.createElement("div",{id:this.gridID+"_toolbarItems"}),this.parent.enableAdaptiveUI&&this.element.classList.add("e-res-toolbar"),this.parent.toolbarTemplate)if("string"==typeof this.parent.toolbarTemplate)this.toolbar.appendTo(this.parent.toolbarTemplate),this.element=this.toolbar.element;else{var i=this.parent.isReact&&"string"!=typeof this.parent.toolbarTemplate,r=this.parent.element.id+"toolbarTemplate";i?(R(this.parent.toolbarTemplate)({},this.parent,"toolbarTemplate",r,null,null,this.element),this.parent.renderTemplates()):P(this.element,R(this.parent.toolbarTemplate)({},this.parent,"toolbarTemplate"))}else this.toolbar.appendTo(this.element);this.parent.element.insertBefore(this.element,this.parent.getHeaderContent())},i.prototype.addReactToolbarPortals=function(e){this.parent.isReact&&e&&(this.parent.portals=this.parent.portals.concat(e),this.parent.renderTemplates())},i.prototype.renderResponsiveSearch=function(i){if(i){this.toolbarCreated(!0),this.refreshResponsiveToolbarItems(e.ResponsiveToolbarAction.isSearch),this.searchElement=t.select("#"+this.gridID+"_searchbar",this.element);D(this.searchElement,"e-toolbar-right").classList.add("e-responsive-right"),this.parent.searchSettings&&this.updateSearchBox(),this.searchBoxObj.searchFocus({target:this.searchElement}),this.searchElement.focus()}else this.refreshResponsiveToolbarItems(e.ResponsiveToolbarAction.isInitial)},i.prototype.refreshResponsiveToolbarItems=function(t){if(t===e.ResponsiveToolbarAction.isInitial){for(var i=this.parent.element.id,r=[i+"_edit",i+"_delete"],n=this.parent.getSelectedRowIndexes(),o=[i+"_responsiveback",i+"_update",i+"_cancel"],s=0,l=this.toolbar.items;s<l.length;s++){var a=l[s];(p=this.toolbar.element.querySelector("#"+a.id))&&(r.indexOf(a.id)>-1?n.length?p.parentElement.classList.remove("e-hidden"):p.parentElement.classList.add("e-hidden"):-1===o.indexOf(a.id)?p.parentElement.classList.remove("e-hidden"):p.parentElement.classList.add("e-hidden"))}if(this.searchElement){D(this.searchElement,"e-toolbar-right").classList.remove("e-responsive-right"),this.toolbarCreated(!1),this.unWireEvent(),this.searchElement=void 0}}if(t===e.ResponsiveToolbarAction.isSearch){r=[this.parent.element.id+"_responsiveback",this.parent.element.id+"_search"];for(var h=0,d=this.toolbar.items;h<d.length;h++){var p;a=d[h];(p=this.toolbar.element.querySelector("#"+a.id))&&(r.indexOf(a.id)>-1?p.parentElement.classList.remove("e-hidden"):p.parentElement.classList.add("e-hidden"))}}},i.prototype.refreshToolbarItems=function(e){var t=this.parent,i=[],r=[],n=t.editSettings,o=t.currentViewData&&t.currentViewData.length;n.allowAdding?i.push(this.gridID+"_add"):r.push(this.gridID+"_add"),n.allowEditing&&o?i.push(this.gridID+"_edit"):r.push(this.gridID+"_edit"),n.allowDeleting&&o?i.push(this.gridID+"_delete"):r.push(this.gridID+"_delete"),"Batch"===t.editSettings.mode?t.element.getElementsByClassName("e-updatedtd").length&&(n.allowAdding||n.allowEditing)?(i.push(this.gridID+"_update"),i.push(this.gridID+"_cancel")):(r.push(this.gridID+"_update"),r.push(this.gridID+"_cancel")):t.isEdit&&(n.allowAdding||n.allowEditing)?(i=[this.gridID+"_update",this.gridID+"_cancel"],r=[this.gridID+"_add",this.gridID+"_edit",this.gridID+"_delete"]):(r.push(this.gridID+"_update"),r.push(this.gridID+"_cancel")),this.enableItems(i,!0),this.enableItems(r,!1)},i.prototype.getItems=function(){var e=[],t=this.parent.toolbar||[];if("string"==typeof this.parent.toolbar)return[];"Vertical"===this.parent.rowRenderingMode&&(this.parent.allowFiltering&&"FilterBar"!==this.parent.filterSettings.type&&e.push(this.getItemObject("responsiveFilter")),this.parent.allowSorting&&e.push(this.getItemObject("responsiveSort")));for(var i=0,r=t;i<r.length;i++){var n=r[i];switch(typeof n){case"number":e.push(this.getItemObject(this.items[n]));break;case"string":e.push(this.getItemObject(n));break;default:e.push(this.getItem(n))}}return this.parent.enableAdaptiveUI&&this.parent.toolbar.indexOf("Search")>-1&&e.push(this.getItemObject("responsiveBack")),e},i.prototype.getItem=function(e){var i=this.predefinedItems[e.text];return i?t.extend(i,i,e):e},i.prototype.getItemObject=function(e){return this.predefinedItems[e]||{text:e,id:this.gridID+"_"+e}},i.prototype.enableItems=function(e,i){for(var r=0,n=e;r<n.length;r++){var o=n[r],s=t.select("#"+o,this.element);s&&this.toolbar.enableItems(s.parentElement,i)}},i.prototype.toolbarClickHandler=function(e){var i=this,r=this.parent,n=this.gridID;t.extend(e,{cancel:!1});var o=e,s=e.originalEvent;r.trigger("toolbarClick",o,function(e){if(e.originalEvent=e.originalEvent?e.originalEvent:s,!e.cancel)switch(!t.isNullOrUndefined(e.item)&&e.item.id){case n+"_print":r.print();break;case n+"_edit":r.startEdit();break;case n+"_update":r.endEdit();break;case n+"_cancel":r.closeEdit();break;case n+"_add":r.addRecord();break;case n+"_delete":r.deleteRecord();break;case n+"_search":e.originalEvent.target.id===n+"_searchbutton"&&i.searchElement?i.search():!r.enableAdaptiveUI||i.searchElement||!e.originalEvent.target.classList.contains("e-search-wrapper")&&e.originalEvent.target.id!==n+"_searchbutton"||i.renderResponsiveSearch(!0);break;case n+"_columnchooser":var o=i.parent.element.querySelector(".e-ccdiv"),l=o.getBoundingClientRect().top,a=o.getBoundingClientRect().left,h=e.originalEvent.target;l=o.getBoundingClientRect().top+o.offsetTop,r.createColumnchooser(a,l,h);break;case n+"_responsivefilter":r.showResponsiveCustomFilter();break;case n+"_responsivesort":r.showResponsiveCustomSort();break;case n+"_responsiveback":i.renderResponsiveSearch(!1)}})},i.prototype.modelChanged=function(e){"edit"===e.module&&this.refreshToolbarItems()},i.prototype.onPropertyChanged=function(e){e.module===this.getModuleName()&&this.parent.toolbar&&(this.element&&t.remove(this.element),this.render())},i.prototype.keyUpHandler=function(e){13===e.keyCode&&this.search()},i.prototype.search=function(){this.parent.search(this.searchElement.value)},i.prototype.updateSearchBox=function(){this.searchElement&&(this.searchElement.value=this.parent.searchSettings.key)},i.prototype.wireEvent=function(){this.searchElement&&(this.searchBoxObj=new vl(this.searchElement),t.EventHandler.add(this.searchElement,"keyup",this.keyUpHandler,this),this.searchBoxObj.wireEvent())},i.prototype.unWireEvent=function(){this.searchElement&&(t.EventHandler.remove(this.searchElement,"keyup",this.keyUpHandler),this.searchBoxObj.unWireEvent())},i.prototype.reRenderToolbar=function(){this.element&&t.remove(this.element),this.render()},i.prototype.addEventListener=function(){this.parent.isDestroyed||(this.evtHandlers=[{event:vo,handler:this.reRenderToolbar},{event:Si,handler:this.render},{event:Fi,handler:this.onPropertyChanged},{event:Ii,handler:this.updateSearchBox.bind(this)},{event:Ti,handler:this.refreshToolbarItems},{event:sr,handler:this.refreshToolbarItems},{event:Ii,handler:this.modelChanged},{event:Ot,handler:this.refreshToolbarItems},{event:Wi,handler:this.removeResponsiveSearch},{event:wo,handler:this.reRenderToolbar},{event:Ki,handler:this.destroy}],_e(this.parent,this.evtHandlers,!0,this),this.rowSelectedFunction=this.rowSelected.bind(this),this.rowDeSelectedFunction=this.rowSelected.bind(this),this.parent.addEventListener(At,this.rowSelectedFunction),this.parent.addEventListener(Nt,this.rowDeSelectedFunction))},i.prototype.removeEventListener=function(){this.parent.isDestroyed||(_e(this.parent,this.evtHandlers,!1),this.parent.removeEventListener(At,this.rowSelectedFunction),this.parent.removeEventListener(Nt,this.rowDeSelectedFunction))},i.prototype.removeResponsiveSearch=function(e){var t=e.target,i=t.classList.contains("e-search-icon")||t.classList.contains("e-search-wrapper");this.parent.enableAdaptiveUI&&!i&&this.searchElement&&!D(e.target,"e-res-toolbar")&&this.renderResponsiveSearch(!1)},i.prototype.rowSelected=function(){this.parent.enableAdaptiveUI&&this.refreshResponsiveToolbarItems(e.ResponsiveToolbarAction.isInitial)},i.prototype.getModuleName=function(){return"toolbar"},i}(),Aa=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Ba=function(e){function r(t,i){var r=e.call(this,t,i)||this;return r.aggregates={},r.parent=t,r.locator=i,r.modelGenerator=new Ts(r.parent),r.addEventListener(),r}return Aa(r,e),r.prototype.renderPanel=function(){var e=this.parent.createElement("div",{className:Qo}),i=this.parent.createElement("div",{className:"e-summarycontent"}),r=i;if(this.parent.isFrozenGrid()){var n=this.parent.createElement("div",{className:"e-frozenfootercontent e-frozen-left-footercontent"}),o=this.parent.createElement("div",{className:"e-movablefootercontent"}),s=this.parent.createElement("div",{className:"e-frozenfootercontent e-frozen-right-footercontent"});(this.parent.getFrozenColumns()||this.parent.getFrozenLeftColumnsCount())&&(i.appendChild(n),this.frozenContent=n),i.appendChild(o),this.movableContent=o,r=o,this.parent.getFrozenRightColumnsCount()&&(i.appendChild(s),this.frozenRightContent=s)}t.Browser.isDevice&&(r.style.overflowX="scroll"),e.appendChild(i),this.setPanel(e),null!=this.parent.getPager()?this.parent.element.insertBefore(e,this.parent.getPager()):this.parent.element.appendChild(e)},r.prototype.renderTable=function(){var e=this.parent.getFrozenColumns()||this.parent.getFrozenLeftColumnsCount(),i=this.createContentTable("_footer_table").querySelector("."+ts),r=this.parent.createElement("tfoot");if(i.appendChild(r),this.parent.isFrozenGrid()){var n=i.cloneNode(!0),o=i.cloneNode(!0);if(e&&(this.frozenContent.appendChild(n),this.freezeTable=n),this.parent.getFrozenRightColumnsCount()){t.remove(o.querySelector(fs));var s=this.parent.getHeaderContent().querySelector(".e-frozen-right-header").querySelector(fs).cloneNode(!0);o.insertBefore(s,o.querySelector(gs)),this.frozenRightContent.appendChild(o),this.frTable=o}this.movableContent.appendChild(i),t.remove(i.querySelector(fs));var l=this.parent.getHeaderContent().querySelector("."+Jo).querySelector(fs).cloneNode(!0);i.insertBefore(l,i.querySelector(gs)),this.setColGroup(l)}this.setTable(i)},r.prototype.renderSummaryContent=function(e,i,r,n){var o=this.parent.dataSource instanceof Array?!this.parent.getDataModule().isRemote()&&this.parent.parentDetails?this.getData():this.parent.dataSource:this.parent.currentViewData,s=this.modelGenerator.getData(),l=t.isNullOrUndefined(r)?this.modelGenerator.getColumns():this.modelGenerator.getColumns(r,n),a=t.isNullOrUndefined(r)?this.modelGenerator.generateRows(o,e||this.aggregates):this.modelGenerator.generateRows(o,e||this.aggregates,r,n),h=document.createDocumentFragment(),d=new Fs(this.locator,null,this.parent);d.element=this.parent.createElement("TR",{className:"e-summaryrow"});for(var p=0,c=s.length;p<c;p++){var u=a[p];if(u){var g=d.render(u,l);h.appendChild(g)}}i.tFoot.appendChild(h),this.aggregates=t.isNullOrUndefined(e)?this.aggregates:e},r.prototype.refresh=function(e){var i=this.parent.getFrozenColumns()||this.parent.getFrozenLeftColumnsCount(),r=this.parent.getMovableColumnsCount(),n=this.parent.getFrozenRightColumnsCount();if(this.parent.isFrozenGrid()&&(t.remove(this.getPanel()),this.renderPanel(),this.renderTable(),i&&(this.freezeTable.tFoot.innerHTML="",this.renderSummaryContent(e,this.freezeTable,0,i))),this.getTable().tFoot.innerHTML="",this.renderSummaryContent(e,this.getTable(),i,n?i+r:void 0),this.parent.getFrozenRightColumnsCount()){this.frTable.tFoot.innerHTML="",this.renderSummaryContent(e,this.frTable,i+r,i+r+n);var o=[].slice.call(this.getTable().getElementsByClassName("e-lastsummarycell"));if(o.length)for(var s=0;s<o.length;s++)o[s].style.borderRight="0px"}if(this.parent.isFrozenGrid()){var l=[].slice.call(this.parent.element.querySelector(".e-movablefootercontent").getElementsByClassName("e-summaryrow")),a=void 0;if(i){a=[].slice.call(this.parent.element.querySelector(".e-frozen-left-footercontent").getElementsByClassName("e-summaryrow")),this.refreshHeight(a,l);var h=this.frozenContent;h.offsetHeight||(h.style.height=this.getTable().offsetHeight+"px")}if(n){var d=[].slice.call(this.parent.element.querySelector(".e-frozen-right-footercontent").getElementsByClassName("e-summaryrow"));this.refreshHeight(d,l),a&&this.refreshHeight(d,a);var p=this.frTable;p.offsetHeight||(p.style.height=this.getTable().offsetHeight+"px")}this.parent.allowResizing&&this.updateFooterTableWidth(this.getTable())}t.isNullOrUndefined(e)&&this.parent.isAutoFitColumns&&this.parent.autoFitColumns(),this.onScroll()},r.prototype.refreshHeight=function(e,t){for(var i=0;i<e.length;i++){var r=e[i].getBoundingClientRect().height,n=t[i].getBoundingClientRect().height;r<n?(e[i].classList.remove("e-hide"),e[i].style.height=n+"px"):r>n&&(t[i].classList.remove("e-hide"),t[i].style.height=r+"px")}},r.prototype.refreshCol=function(){var e,t=e=this.parent.element.querySelector("."+Wo).querySelector(fs).cloneNode(!0);if(this.parent.getFrozenColumns()){this.parent.enableColumnVirtualization&&this.parent.contentModule.isXaxis()?e=this.parent.getMovableVirtualHeader().querySelector(fs).cloneNode(!0):(e=le(t,this.parent.getFrozenColumns(),this.parent),this.freezeTable.replaceChild(t,this.freezeTable.querySelector(fs)))}this.getTable().replaceChild(e,this.getColGroup()),this.setColGroup(e)},r.prototype.onWidthChange=function(e){this.getColFromIndex(e.index).style.width=t.formatUnit(e.width),this.parent.allowResizing&&"resize"===e.module&&this.updateFooterTableWidth(this.getTable())},r.prototype.onScroll=function(e){void 0===e&&(e={left:this.parent.isFrozenGrid()?this.parent.getContent().querySelector("."+Yo).scrollLeft:this.parent.getContent().firstChild.scrollLeft}),this.getTable().parentElement.scrollLeft=e.left},r.prototype.getColFromIndex=function(e){var t=this.parent.getFrozenLeftColumnsCount()||this.parent.getFrozenColumns(),i=this.parent.getMovableColumnsCount(),r=this.parent.getFrozenRightColumnsCount(),n=this.parent.isRowDragable()&&"Right"!==this.parent.getFrozenMode()?1:0;return t&&e<t+n?this.freezeTable.querySelector(fs).children[e]:r&&e>=t+i+n?this.frTable.querySelector(fs).children[e-(t?t+i+n:t+i)]:this.getColGroup().children[e-(t?t+n:t)]},r.prototype.columnVisibilityChanged=function(){this.refresh()},r.prototype.addEventListener=function(){this.evtHandlers=[{event:zi,handler:this.refreshCol},{event:Yi,handler:this.onWidthChange},{event:Xi,handler:this.onScroll},{event:Qi,handler:this.columnVisibilityChanged},{event:Hi,handler:this.refreshFooterRenderer}],_e(this.parent,this.evtHandlers,!0,this)},r.prototype.removeEventListener=function(){_e(this.parent,this.evtHandlers,!1)},r.prototype.updateFooterTableWidth=function(e){var t=this.parent.getHeaderTable();t&&e&&(e.style.width=t.style.width)},r.prototype.refreshFooterRenderer=function(e){var t=this.onAggregates(e);this.refresh(t)},r.prototype.getIndexByKey=function(e,t){for(var i=this.parent.getPrimaryKeyFieldNames()[0],r=0;r<t.length;r++)if(t[r][i]===e[i])return r;return-1},r.prototype.getData=function(){return this.parent.getDataModule().dataManager.executeLocal(this.parent.getDataModule().generateQuery(!0))},r.prototype.onAggregates=function(e){e=e instanceof Array?e:[];var t=this.parent.getPrimaryKeyFieldNames()[0],r=[],n=!1,o={},s=!1;!this.parent.renderModule.data.isRemote()&&this.parent.allowFiltering&&this.parent.filterSettings.columns.length&&(s=!0);var l=this.parent.dataSource instanceof Array?s?this.parent.getFilteredRecords():this.parent.dataSource:this.parent.dataSource.dataSource.json.length?this.parent.dataSource.dataSource.json:this.parent.getCurrentViewRecords();if(this.parent.parentDetails&&!this.parent.getDataModule().isRemote()&&(l=this.getData()),this.parent.editModule&&(o=this.parent.editModule.getBatchChanges()),Object.keys(o).length){for(var a=0;a<l.length;a++)n=!1,o[ss].length&&this.getIndexByKey(l[a],o[ss])>-1&&(n=!0,r.push(o[ss][this.getIndexByKey(l[a],o[ss])])),o[as].length&&this.getIndexByKey(l[a],o[as])>-1?n=!0:n||r.push(l[a]);if(o[ls].length)for(a=0;a<o[ls].length;a++)r.push(o[ls][a])}else if(e.length){r=S(l).map(function(r){var n,o=i.DataUtil.getObject(t,r);return e.some(function(e){return n=e,o===i.DataUtil.getObject(t,e)})?n:r})}else r=l;var h=e;h.type&&"cancel"===h.type&&(r=l);var d,p={},c=this.parent.aggregates;for(a=0;a<c.length;a++)for(var u=0;u<c[a].columns.length;u++){var g=c[a].columns[u].type.toString();d=q(g,r,c[a].columns[u],this.parent),p[c[a].columns[u].field+" - "+g.toLowerCase()]=d}return{result:r,count:r.length,aggregates:p}},r}(ks),Na=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Pa=function(e){function i(){var t=null!==e&&e.apply(this,arguments)||this;return t.element=t.parent.createElement("TD",{className:"e-summarycell",attrs:{role:"gridcell",tabindex:"-1"}}),t}return Na(i,e),i.prototype.getValue=function(e,i,r){var n=t.isNullOrUndefined(r.type)?r.columnName:r.field+" - "+("string"==typeof r.type?r.type.toLowerCase():"");return i[r.columnName]?i[r.columnName][n]:""},i.prototype.evaluate=function(e,i,r,n){var o=i.column;if(this.parent.on(Ui,this.refreshWithAggregate(e,i),this),!(o.footerTemplate||o.groupFooterTemplate||o.groupCaptionTemplate))return"Vertical"===this.parent.rowRenderingMode&&(e.style.display="none"),!0;"Vertical"===this.parent.rowRenderingMode&&e.classList.add("e-lastsummarycell");var s=o.getTemplate(i.cellType),l=this.parent.getColumnByField(r[o.columnName].field);if(!t.isNullOrUndefined(l)&&(r[o.columnName].headerText=l.headerText,l.isForeignColumn())){var a=l.columnData.filter(function(e){return e[l.foreignKeyField]===r[o.columnName].key})[0];a&&(r[o.columnName].foreignKey=a[l.foreignKeyValue])}if(this.parent.isReact&&(o.footerTemplate?"string"!=typeof o.footerTemplate:o.groupFooterTemplate?"string"!=typeof o.groupFooterTemplate:!!o.groupCaptionTemplate&&"string"!=typeof o.groupCaptionTemplate)){var h=r[o.columnName];if("groupCaptionTemplate"===s.property||"groupFooterTemplate"===s.property){h.groupKey=h.key}s.fn(h,this.parent,s.property,"",null,null,e),this.parent.renderTemplates()}else P(e,s.fn(r[o.columnName],this.parent,s.property,""));return!1},i.prototype.refreshWithAggregate=function(e,i){var r=this,n=i;return function(i){var o=n,s=o.column.columnName?o.column.columnName:null,l=t.isNullOrUndefined(s)?null:i.cells.filter(function(e){return e.column.columnName===s})[0];e.parentElement&&e.parentElement.getAttribute("data-uid")===i.dataUid&&s&&s===l.column.columnName&&r.refreshTD(e,l,i.data)}},i}(Bs),La=function(){function i(e,t){this.parent=e,this.locator=t,this.addEventListener()}return i.prototype.getModuleName=function(){return"aggregate"},i.prototype.initiateRender=function(){for(var i=this,r=this.locator.getService("cellRendererFactory"),n=new Pa(this.parent,this.locator),o=[e.CellType.Summary,e.CellType.CaptionSummary,e.CellType.GroupSummary],s=0;s<o.length;s++)r.addCellRenderer(o[s],n);this.footerRenderer=new Ba(this.parent,this.locator),this.footerRenderer.renderPanel(),this.footerRenderer.renderTable();var l=this.footerRenderer.getPanel();this.parent.element.scrollHeight>=this.parent.getHeight(this.parent.height)&&l&&t.addClass([l],["e-footerpadding"]),this.locator.register("footerRenderer",this.footerRenderer);var a=function(){i.prepareSummaryInfo(),i.parent.off(Ri,a)};this.parent.on(Ri,a,this),this.parent.on(Ri,this.footerRenderer.refresh,this.footerRenderer)},i.prototype.prepareSummaryInfo=function(){var e=this;it(this.parent.aggregates,function(i){var r=t.getValue("customFormat",i);if(t.isNullOrUndefined(r)||i.setPropertiesSilent({format:r}),"object"==typeof i.format){var n=new Ct;i.setFormatter(n.getFormatFunction(t.extend({},i.format)))}else if("string"==typeof i.format){var o=e.locator.getService("valueFormatter");i.setFormatter(o.getFormatFunction({format:i.format}))}i.setPropertiesSilent({columnName:i.columnName||i.field})})},i.prototype.onPropertyChanged=function(e){if(e.module===this.getModuleName()){t.isNullOrUndefined(this.footerRenderer)&&this.initiateRender(),this.prepareSummaryInfo(),this.footerRenderer.refresh();var i=new Ds(this.parent);0===new zs(this.parent).getData().length&&i.isEmpty()||this.parent.notify(Ti,{})}},i.prototype.addEventListener=function(){this.parent.isDestroyed||(this.parent.on(Si,this.initiateRender,this),this.parent.on(Fi,this.onPropertyChanged,this),this.parent.on(ji,this.refresh,this),this.parent.on(Ki,this.destroy,this))},i.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.footerRenderer.removeEventListener(),this.parent.off(Si,this.initiateRender),this.parent.off(Ri,this.footerRenderer.refresh),this.parent.off(Fi,this.onPropertyChanged),this.parent.off(ji,this.refresh),this.parent.off(Ki,this.destroy),t.remove(this.parent.element.querySelector("."+Qo)))},i.prototype.destroy=function(){this.removeEventListener()},i.prototype.refresh=function(e){var t=e instanceof Array?e:[e];this.parent.notify(Hi,t),this.parent.groupSettings.columns.length>0&&this.parent.notify(qi,t)},i}(),qa=function(){function e(e,t,i){var r=this;this.fromWheel=!1,this.touchMove=!1,this.options={},this.sentinelInfo={up:{check:function(e,t){var i=e.top-r.containerRect.top;return t.entered=i>=0,i+r.options.pageHeight/2>=0},axis:"Y"},down:{check:function(e,t){var i=e.bottom;return t.entered=e.bottom<=r.containerRect.bottom,i-r.containerRect.top-r.options.pageHeight/2<=r.options.pageHeight/2},axis:"Y"},right:{check:function(e,t){var i=e.right;return r.movableEle?(t.entered=i<r.movableContainerRect.right,i-r.movableContainerRect.width<=r.movableContainerRect.right):(t.entered=i<r.containerRect.right,i-r.containerRect.width<=r.containerRect.right)},axis:"X"},left:{check:function(e,t){var i=e.left;return t.entered=i>0,r.movableEle?i+r.movableContainerRect.width>=r.movableContainerRect.left:i+r.containerRect.width>=r.containerRect.left},axis:"X"}},this.element=e,this.options=t,this.movableEle=i}return e.prototype.observe=function(e,i){var r=this;this.containerRect=this.options.container.getBoundingClientRect(),t.EventHandler.add(this.options.container,"wheel",function(){return r.fromWheel=!0},this),t.EventHandler.add(this.options.container,"scroll",this.virtualScrollHandler(e,i),this),this.options.movableContainer&&(this.movableContainerRect=this.options.movableContainer.getBoundingClientRect(),t.EventHandler.add(this.options.scrollbar,"wheel",function(){return r.fromWheel=!0},this),t.EventHandler.add(this.options.scrollbar,"scroll",this.virtualScrollHandler(e,i),this))},e.prototype.check=function(e){var t=this.sentinelInfo[e];return!this.movableContainerRect||"left"!==e&&"right"!==e?t.check(this.element.getBoundingClientRect(),t):t.check(this.movableEle.getBoundingClientRect(),t)},e.prototype.virtualScrollHandler=function(e,i){var r=this,n="chrome"===t.Browser.info.name?200:100,o=t.debounce(e,n),s=t.debounce(e,50);return this.options.prevTop=this.options.prevLeft=0,function(e){var t=r.options.movableContainer?r.options.container.scrollTop:e.target.scrollTop,n=r.options.movableContainer?r.options.scrollbar.scrollLeft:e.target.scrollLeft,l=r.options.prevTop<t?"down":"up";l=r.options.prevLeft===n?l:r.options.prevLeft<n?"right":"left",r.options.prevTop=t,r.options.prevLeft=n;var a=r.sentinelInfo[l];if(-1!==r.options.axes.indexOf(a.axis)){var h=r.check(l);if(a.entered&&(!r.movableEle||"right"!==l&&"left"!==l?i(r.element,a,l,{top:t,left:n},r.fromWheel,h):i(r.movableEle,a,l,{top:t,left:n},r.fromWheel,h)),h){var d=o;"X"===a.axis&&(d=s),d({direction:l,sentinel:a,offset:{top:t,left:n},focusElement:document.activeElement})}r.fromWheel=!1}}},e.prototype.setPageHeight=function(e){this.options.pageHeight=e},e}(),Ha=function(){function e(e){this.cOffsets={},this.cache={},this.movableCache={},this.frozenRightCache={},this.rowCache={},this.data={},this.groups={},this.currentInfo={},this.parent=e,this.model=this.parent.pageSettings,this.rowModelGenerator=this.parent.allowGrouping?new Os(this.parent):new Es(this.parent)}return e.prototype.generateRows=function(e,i){var r=this.parent.isFrozenGrid(),n=!1,o=i.virtualInfo=i.virtualInfo||this.getData(),s=o.sentinelInfo&&"X"===o.sentinelInfo.axis,l=s||!o.loadNext||o.loadSelf?o.page:o.nextInfo.page,a=[],h=this.getBlockIndexes(l),d=[];if(this.currentInfo.blockIndexes&&(h=o.blockIndexes=i.virtualInfo.blockIndexes=this.includePrevPage?this.currentInfo.blockIndexes.slice(1):this.currentInfo.blockIndexes.slice(0,this.currentInfo.blockIndexes.length-1),n=!0),(r&&this.parent.getFrozenMode()!==hs&&!i.renderMovableContent||this.parent.getFrozenMode()===hs&&!i.renderMovableContent&&!i.renderFrozenRightContent||!r)&&this.checkAndResetCache(i.requestType),ae(this.parent)&&this.parent.vcRows.length){var p=this.parent.vcRows.filter(function(e){return e.isDataRow});if(this.parent.isManualRefresh&&p.length===e.records.length||!this.parent.isManualRefresh)return a=this.parent.vcRows}if(this.parent.enableColumnVirtualization)for(var c=0;c<o.blockIndexes.length;c++)if(this.isBlockAvailable(o.blockIndexes[c])&&(this.cache[o.blockIndexes[c]]=this.rowModelGenerator.refreshRows(this.cache[o.blockIndexes[c]])),i.renderMovableContent&&this.isMovableBlockAvailable(o.blockIndexes[c])||i.renderFrozenRightContent&&this.isFrozenRightBlockAvailable(o.blockIndexes[c])){(y=i.renderMovableContent?this.movableCache:this.frozenRightCache)[o.blockIndexes[c]]=this.rowModelGenerator.refreshRows(y[o.blockIndexes[c]])}var u=o.blockIndexes;for(c=0;c<u.length;c++){if(!this.isBlockAvailable(u[c])){var g=t.isNullOrUndefined(this.startIndex)?this.getStartIndex(u[c],e):this.startIndex,f=this.rowModelGenerator.generateRows(e,{virtualInfo:o,startIndex:g});ae(this.parent)&&!this.parent.vcRows.length&&(this.parent.vRows=f,this.parent.vcRows=f,this.parent.notify(So,{}));var m=void 0;ae(this.parent)?this.getGroupVirtualRecordsByIndex(f):n?this.setBlockForManualRefresh(this.cache,h,f):(m=~~Math.max(f.length,this.model.pageSize)/2,this.isBlockAvailable(h[0])||(this.cache[h[0]]=f.slice(0,m)),this.isBlockAvailable(h[1])||(this.cache[h[1]]=f.slice(m)))}if(this.parent.groupSettings.columns.length&&!s&&this.cache[u[c]]&&(this.cache[u[c]]=this.updateGroupRow(this.cache[u[c]],u[c])),i.renderMovableContent&&!this.isMovableBlockAvailable(u[c])||i.renderFrozenRightContent&&!this.isFrozenRightBlockAvailable(u[c])){var y=i.renderMovableContent?this.movableCache:this.frozenRightCache;g=t.isNullOrUndefined(this.startIndex)?this.getStartIndex(u[c],e):this.startIndex,f=this.rowModelGenerator.generateRows(e,{virtualInfo:o,startIndex:g});if(n)this.setBlockForManualRefresh(y,h,f);else{m=~~Math.max(f.length,this.model.pageSize)/2;(i.renderFrozenRightContent&&!this.isFrozenRightBlockAvailable(h[0])||i.renderMovableContent&&!this.isMovableBlockAvailable(h[0]))&&(y[h[0]]=f.slice(0,m)),(i.renderFrozenRightContent&&!this.isFrozenRightBlockAvailable(h[1])||i.renderMovableContent&&!this.isMovableBlockAvailable(h[1]))&&(y[h[1]]=f.slice(m))}}if(i.renderMovableContent||i.renderFrozenRightContent||!this.cache[u[c]]){(y=i.renderMovableContent?this.movableCache:this.frozenRightCache)[u[c]]&&a.push.apply(a,y[u[c]])}else a.push.apply(a,this.cache[u[c]]);this.isBlockAvailable(u[c])&&d.push(u[c])}o.blockIndexes=d;return this.parent.allowGrouping&&this.parent.groupSettings.columns.length?this.parent.currentViewData.records=a.map(function(e){return e.data}):r?(i.renderMovableContent&&("Left"===this.parent.getFrozenMode()||"Right"===this.parent.getFrozenMode()||this.parent.getFrozenColumns())||i.renderFrozenRightContent)&&(this.parent.currentViewData=a.map(function(e){return e.data})):this.parent.currentViewData=a.map(function(e){return e.data}),a},e.prototype.setBlockForManualRefresh=function(e,t,i){var r=this.model.pageSize/2;this.includePrevPage?(e[t[0]-1]=i.slice(0,r),e[t[0]]=i.slice(r,2*r),e[t[1]]=i.slice(2*r,3*r),e[t[2]]=i.slice(3*r,4*r)):(e[t[0]]=i.slice(0,r),e[t[1]]=i.slice(r,2*r),e[t[2]]=i.slice(2*r,3*r),e[t[2]+1]=i.slice(3*r,4*r))},e.prototype.getBlockIndexes=function(e){return[e+(e-1),2*e]},e.prototype.getPage=function(e){return e%2==0?e/2:(e+1)/2},e.prototype.isBlockAvailable=function(e){return e in this.cache},e.prototype.isMovableBlockAvailable=function(e){return e in this.movableCache},e.prototype.isFrozenRightBlockAvailable=function(e){return e in this.frozenRightCache},e.prototype.getData=function(){return{page:this.model.currentPage,blockIndexes:this.getBlockIndexes(this.model.currentPage),direction:"down",columnIndexes:this.parent.getColumnIndexesInView()}},e.prototype.getStartIndex=function(e,t,i){void 0===i&&(i=!0);var r=e%2==0,n=(this.getPage(e)-1)*this.model.pageSize;return i||!r?n:n+~~(this.model.pageSize/2)},e.prototype.getColumnIndexes=function(e){var i=this;void 0===e&&(e=this.parent.getHeaderContent().querySelector("."+Xo)),this.parent.isFrozenGrid()&&(e=e.querySelector("."+Jo));var r=[],n=0|e.scrollLeft,o=Object.keys(this.cOffsets),s=e.getBoundingClientRect().width;n=Math.min(this.cOffsets[o.length-1]-s,n);var l=t.Browser.isDevice?2*s:s/2,a=n+s+(0===n?l:0);return o.some(function(e){var t=Number(e),o=i.cOffsets[e];return n-l<=o&&a+l>=o&&r.push(t),a+l<o}),this.addFrozenIndex(r),r},e.prototype.addFrozenIndex=function(e){if(this.parent.getFrozenColumns()&&this.parent.enableColumnVirtualization&&0===e[0])for(var t=0;t<this.parent.getFrozenColumns();t++)e.push(e[e.length-1]+1)},e.prototype.checkAndResetCache=function(e){var t=["paging","refresh","sorting","filtering","searching","grouping","ungrouping","reorder","save","delete"];this.parent.getFrozenColumns()&&this.parent.frozenRows&&this.parent.enableColumnVirtualization&&"reorder"===e&&t.splice(t.indexOf(e),1);var i=t.some(function(t){return e===t});return i&&(this.cache={},this.data={},this.groups={},this.movableCache={},this.frozenRightCache={}),i},e.prototype.refreshColOffsets=function(){var e=this,t=0;this.cOffsets={};for(var i=this.parent.groupSettings.columns.length,r=this.parent.columns,n=r.length,o=function(t){return t.visible&&(e.parent.groupSettings.showGroupedColumn?t.visible:e.parent.groupSettings.columns.indexOf(t.field)<0)},s=this.parent.groupSettings.columns,l=0;l<s.length;l++)this.cOffsets[l]=30+(0|this.cOffsets[l-1]);for(var a=Array.apply(null,Array(n)).map(function(){return t++}),h=0;h<a.length;h++)a[h]=a[h]+i,this.cOffsets[a[h]]=(0|this.cOffsets[a[h]-1])+(o(r[h])?parseInt(r[h].width,10):0)},e.prototype.updateGroupRow=function(e,t){for(var i=e[0],r=[],n=Object.keys(this.cache),o=0;o<n.length;o++)Number(n[o])<t&&(r=r.concat(this.cache[n[o]]));return i&&i.isDataRow||t%2==0?e:this.iterateGroup(e,r)},e.prototype.iterateGroup=function(e,t){var i=e[0],r=0;if(i&&i.isDataRow)return e;return e.some(function(e){return t.some(function(t,i){var n=t&&void 0!==t.data.field&&t.data.field===e.data.field&&t.data.key===e.data.key;return n&&(r=i),n})})&&(e.shift(),e=this.iterateGroup(e,t.slice(r))),e},e.prototype.getRows=function(){for(var e=[],t=Object.keys(this.cache),i=0;i<t.length;i++)e=e.concat(this.cache[t[i]]);return e},e.prototype.generateCells=function(e){for(var t=[],i=this.parent.columnModel,r=0;r<i.length;r++)t.push(this.rowModelGenerator.generateCell(i[r],null,null,null,null,e));return t},e.prototype.getGroupVirtualRecordsByIndex=function(e){for(var t=this.parent.contentModule.getGroupedTotalBlocks(),i=this.parent.contentModule.getBlockSize(),r=1;r<=t;r++){var n=0;this.cache[r]=[];for(var o=(r-1)*i;o<e.length&&n!==i;o++)this.cache[r].push(e[o]),e[o].isDataRow&&n++}},e}(),Ua=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),ja=function(r){function n(e,t){var i=r.call(this,e,t)||this;return i.prevHeight=0,i.startIndex=0,i.preStartIndex=0,i.preventEvent=!1,i.actions=["filtering","searching","grouping","ungrouping"],i.offsets={},i.tmpOffsets={},i.virtualEle=new Ga,i.offsetKeys=[],i.isFocused=!1,i.isSelection=!1,i.isBottom=!1,i.rndrCount=0,i.empty=void 0,i.isCancel=!1,i.requestTypes=["beginEdit","cancel","delete","add","save"],i.isNormaledit="Normal"===i.parent.editSettings.mode,i.virtualData={},i.emptyRowData={},i.vfColIndex=[],i.frzIdx=1,i.isContextMenuOpen=!1,i.isSelectionScroll=!1,i.validationCheck=!1,i.locator=t,i.eventListener("on"),i.parent.on(Qi,i.setVisible,i),i.vgenerator=i.generator,i}return Ua(n,r),n.prototype.renderTable=function(){this.header=this.locator.getService("rendererFactory").getRenderer(e.RenderType.Header),r.prototype.renderTable.call(this),this.virtualEle.table=this.getTable(),this.virtualEle.content=this.content=this.getPanel().querySelector("."+es),this.virtualEle.renderWrapper(this.parent.height),this.virtualEle.renderPlaceHolder(),this.virtualEle.wrapper.style.position="absolute";var t=this.parent.dataSource instanceof i.DataManager&&!this.parent.dataSource.dataSource.offline,n={container:this.content,pageHeight:2*this.getBlockHeight(),debounceEvent:t,axes:this.parent.enableColumnVirtualization?["X","Y"]:["Y"]};this.observer=new qa(this.virtualEle.wrapper,n)},n.prototype.renderEmpty=function(e){this.getTable().appendChild(e),this.virtualEle.adjustTable(0,0)},n.prototype.getReorderedFrozenRows=function(e){var t=e.virtualInfo.blockIndexes,i=e.virtualInfo.columnIndexes,r=e.virtualInfo.page;e.virtualInfo.blockIndexes=[1,2],e.virtualInfo.page=1,e.renderMovableContent||(e.virtualInfo.columnIndexes=[]);var n=this.parent.getCurrentViewRecords().length,o=this.parent.renderModule.data.dataManager.dataSource.json.slice(0,n),s=this.vgenerator.generateRows(o,e);return e.virtualInfo.blockIndexes=t,e.virtualInfo.columnIndexes=i,e.virtualInfo.page=r,s.splice(0,this.parent.frozenRows)},n.prototype.scrollListener=function(e){if(this.scrollAfterEdit(),this.parent.enablePersistence&&(this.parent.scrollPosition=e.offset),this.preventEvent||this.parent.isDestroyed)this.preventEvent=!1;else{t.isNullOrUndefined(document.activeElement)?this.isFocused=!1:this.isFocused=this.content===t.closest(document.activeElement,"."+es)||this.content===document.activeElement;var i=e.sentinel,r=this.currentInfo=this.getInfoFromView(e.direction,i,e.offset);if(ae(this.parent))return r.blockIndexes&&this.prevInfo.blockIndexes.toString()===r.blockIndexes.toString()?void 0:(r.event="refresh-virtual-block",t.isNullOrUndefined(r.offsets)||(r.offsets.top=this.content.scrollTop),this.parent.pageSettings.currentPage=r.page,void this.parent.notify(r.event,{requestType:"virtualscroll",virtualInfo:r,focusElement:e.focusElement}));if(this.prevInfo&&("Y"===i.axis&&this.prevInfo.blockIndexes.toString()===r.blockIndexes.toString()||"X"===i.axis&&this.prevInfo.columnIndexes.toString()===r.columnIndexes.toString()))return t.Browser.isIE&&this.parent.hideSpinner(),this.requestType="virtualscroll"===this.requestType?this.empty:this.requestType,void("Y"===i.axis&&this.restoreEdit());this.parent.setColumnIndexesInView(this.parent.enableColumnVirtualization?r.columnIndexes:[]),this.parent.pageSettings.currentPage=r.loadNext&&!r.loadSelf?r.nextInfo.page:r.page,this.requestType="virtualscroll",this.parent.notify(r.event,{requestType:"virtualscroll",virtualInfo:r,focusElement:e.focusElement})}},n.prototype.block=function(e){return this.vgenerator.isBlockAvailable(e)},n.prototype.getInfoFromView=function(e,t,i){var r=!1,n=[],o={direction:e,sentinelInfo:t,offsets:i,startIndex:this.preStartIndex,endIndex:this.preEndIndex};o.page=this.getPageFromTop(i.top,o),o.blockIndexes=n=this.vgenerator.getBlockIndexes(o.page),o.loadSelf=!this.vgenerator.isBlockAvailable(n[o.block]);var s=this.ensureBlocks(o);if("upArrow"===this.activeKey&&o.blockIndexes.toString()!==s.toString()){var l=s[s.length-1];-1===o.blockIndexes.indexOf(l)&&(r=!0)}if(o.blockIndexes=s,o.loadNext=!s.filter(function(e){return-1===n.indexOf(e)}).every(this.block.bind(this)),o.event=o.loadNext||o.loadSelf?Ti:nr,o.nextInfo=o.loadNext?{page:Math.max(1,o.page+("down"===e?1:-1))}:{},r&&(o.blockIndexes=[o.blockIndexes[0]-1,o.blockIndexes[0],o.blockIndexes[0]+1]),"downArrow"===this.activeKey){var a=Math.ceil(this.rowIndex/this.getBlockSize());1!==a&&(o.blockIndexes[1]!==a||o.blockIndexes.length<3)&&(o.blockIndexes=[a-1,a,a+1])}return o.columnIndexes="X"===t.axis?this.vgenerator.getColumnIndexes():this.parent.getColumnIndexesInView(),this.parent.enableColumnVirtualization&&"X"===t.axis&&(o.event=nr),o},n.prototype.setKeyboardNavIndex=function(){this.blazorDataLoad=!0,"downArrow"!==this.activeKey&&"upArrow"!==this.activeKey||(this.blzRowIndex="downArrow"===this.activeKey?this.rowIndex+1:this.rowIndex-1,document.activeElement.blur())},n.prototype.ensureBlocks=function(e){var t,i=this,r=e.blockIndexes[e.block],n=r,o=Math.max,s="down"===e.direction?[o(r,1),++r,++r]:[o(r-1,1),r,r+1];return this.parent.enableColumnVirtualization&&this.parent.isFrozenGrid()&&("X"===e.sentinelInfo.axis||"Y"===e.sentinelInfo.axis&&e.page===this.prevInfo.page)&&(s=this.prevInfo.blockIndexes),s=s.filter(function(e,t){return s.indexOf(e)===t}),this.prevInfo.blockIndexes.toString()===s.toString()?s:((e.loadSelf||"down"===e.direction&&this.isEndBlock(n))&&(s=this.vgenerator.getBlockIndexes(e.page)),s.some(function(e,r){var n=e===(ae(i.parent)?i.getGroupedTotalBlocks():i.getTotalBlocks());return n&&(t=r),n}),void 0!==t&&(s=s.slice(0,t+1),0===e.block&&1===s.length&&this.vgenerator.isBlockAvailable(s[0]-1)&&(s=[s[0]-1,s[0]])),s)},n.prototype.appendContent=function(e,i,r){var n=this,o=this.parent.isFrozenGrid(),s=this.parent.getFrozenColumns()||this.parent.getFrozenLeftColumnsCount(),l=this.parent.enableColumnVirtualization&&o;this.checkFirstBlockColIndexes(r);var a=r.virtualInfo.sentinelInfo&&"Y"===r.virtualInfo.sentinelInfo.axis&&this.currentInfo.page&&this.currentInfo.page!==r.virtualInfo.page?this.currentInfo:r.virtualInfo;this.prevInfo=this.prevInfo||r.virtualInfo;var h=a.columnIndexes[0]-1;l&&a.columnIndexes[0]===s&&(h=a.columnIndexes[0]-s-1);var d,p=this.getColumnOffset(h),c=a.blockIndexes;this.parent.groupSettings.columns.length&&this.refreshOffsets(),"100%"===this.parent.height&&(this.parent.element.style.height="100%");var u=this.parent.height.toString().indexOf("%")<0?this.content.getBoundingClientRect().height:this.parent.element.getBoundingClientRect().height;if(!this.requestTypes.some(function(e){return e===n.requestType})){var g=this.getTranslateY(this.content.scrollTop,u,a);this.virtualEle.adjustTable(l?0:p,g),l&&this.virtualEle.adjustMovableTable(p,0)}if(this.parent.enableColumnVirtualization&&(this.header.virtualEle.adjustTable(l?0:p,0),l&&this.header.virtualEle.adjustMovableTable(p,0)),this.parent.enableColumnVirtualization){var f=a.columnIndexes;d=this.getColumnOffset(f[f.length-1])-this.getColumnOffset(f[0]-1)+"",l?this.header.virtualEle.setMovableWrapperWidth(d):this.header.virtualEle.setWrapperWidth(d)}l?this.virtualEle.setMovableWrapperWidth(d,t.Browser.isIE||"edge"===t.Browser.info.name):this.virtualEle.setWrapperWidth(d,t.Browser.isIE||"edge"===t.Browser.info.name),t.isNullOrUndefined(e.parentNode)||t.remove(e);var m;o?r.renderFrozenRightContent?m=this.parent.getContent().querySelector(".e-frozen-right-content").querySelector(gs):r.renderMovableContent?r.renderMovableContent&&(m=this.parent.getMovableVirtualContent().querySelector(gs)):m=this.parent.getFrozenVirtualContent().querySelector(gs):m=this.parent.element.querySelector("."+es).querySelector(gs),m&&(t.remove(m),e=null);if(this.parent.isReact&&!t.isNullOrUndefined(this.parent.rowTemplate)?e=i:(e=this.parent.createElement(gs)).appendChild(i),this.parent.frozenRows&&"virtualscroll"===r.requestType&&1===this.parent.pageSettings.currentPage)for(var y=0;y<this.parent.frozenRows;y++)e.children[0].remove();if(o?(r.renderFrozenRightContent?(this.parent.getContent().querySelector(".e-frozen-right-content").querySelector("."+ts).appendChild(e),this.requestType="virtualscroll"===this.requestType?this.empty:this.requestType):r.renderMovableContent?r.renderMovableContent&&(this.parent.getMovableVirtualContent().querySelector("."+ts).appendChild(e),this.parent.getFrozenMode()!==hs&&(this.requestType="virtualscroll"===this.requestType?this.empty:this.requestType)):this.parent.getFrozenVirtualContent().querySelector("."+ts).appendChild(e),this.vfColIndex.length&&(r.virtualInfo.columnIndexes=a.columnIndexes=t.extend([],this.vfColIndex),this.vfColIndex=r.renderMovableContent?[]:this.vfColIndex)):(this.getTable().appendChild(e),this.requestType="virtualscroll"===this.requestType?this.empty:this.requestType),this.parent.groupSettings.columns.length){if(!ae(this.parent)&&"up"===a.direction){var v=this.offsets[this.getTotalBlocks()]-this.prevHeight;this.preventEvent=!0;var C=this.content.scrollTop;this.content.scrollTop=C+v}this.setVirtualHeight(),this.observer.setPageHeight(this.getOffset(c[c.length-1])-this.getOffset(c[0]-1))}this.prevInfo=a,this.isFocused&&"downArrow"!==this.activeKey&&"upArrow"!==this.activeKey&&this.content.focus();var w=Math.ceil(this.getTotalBlocks()/2);if(this.isBottom&&(this.isBottom=!1,this.parent.getContent().firstElementChild.scrollTop=this.offsets[this.offsetKeys.length-1]),this.parent.pageSettings.currentPage===w&&1===c.length&&(this.isBottom=!0,this.parent.getContent().firstElementChild.scrollTop=this.offsets[this.offsetKeys.length-2]),"virtualscroll"===r.requestType&&"X"===r.virtualInfo.sentinelInfo.axis&&this.parent.notify(ar,{}),this.focusCell(r),this.restoreEdit(r),this.restoreAdd(r),this.ensureSelectedRowPosition(),this.validationScrollLeft(r,o),!this.initialRowTop){var b=this.parent.element.getBoundingClientRect().top;this.initialRowTop=this.parent.getRowByIndex(0).getBoundingClientRect().top-b}var S=r.tableName,R="Left-Right"===this.parent.getFrozenMode()?"frozen-right"===S:"movable"===S;o&&!R||(this.vgenerator.startIndex=null,this.vgenerator.currentInfo={},this.vgenerator.includePrevPage=null)},n.prototype.validationScrollLeft=function(e,t){var i=this.parent.getFrozenColumns(),r=this.parent.getFrozenMode(),n=!t||e&&(i||"Left"===r||"Right"===r?e.renderMovableContent:e.renderFrozenRightContent);if(this.validationCheck&&n)if(this.validationCol){var o=this.vgenerator.cOffsets[this.validationCol.index-this.parent.getVisibleFrozenColumns()-1];this.validationCol=null,this.parent.isFrozenGrid()?this.movableContent.scrollLeft=o:this.content.scrollLeft=o}else this.validationCheck=!1,this.parent.editModule.editFormValidate()},n.prototype.ensureSelectedRowPosition=function(){if(!this.isSelection&&this.isSelectionScroll&&!t.isNullOrUndefined(this.selectRowIndex)){this.isSelectionScroll=!1;var e=this.parent.getRowByIndex(this.selectRowIndex);e&&!this.isRowInView(e)&&this.rowSelected({rowIndex:this.selectRowIndex,row:e},!0)}},n.prototype.checkFirstBlockColIndexes=function(e){if(this.parent.enableColumnVirtualization&&this.parent.isFrozenGrid()&&0===e.virtualInfo.columnIndexes[0]){var i=[],r=this.parent.getFrozenColumns()||this.parent.getFrozenLeftColumnsCount();if(!e.renderMovableContent&&e.virtualInfo.columnIndexes.length>r){this.vfColIndex=e.virtualInfo.columnIndexes;for(var n=0;n<r;n++)i.push(n);e.virtualInfo.columnIndexes=i}else e.renderMovableContent&&(this.vfColIndex.length||(this.vfColIndex=t.extend([],e.virtualInfo.columnIndexes)),e.virtualInfo.columnIndexes=t.extend([],this.vfColIndex),e.virtualInfo.columnIndexes.splice(0,r))}},n.prototype.focusCell=function(e){if("upArrow"===this.activeKey||"downArrow"===this.activeKey){var t=this.parent.getRowByIndex(this.rowIndex);t.cells[this.cellIndex].focus({preventScroll:!0}),this.parent.selectRow(parseInt(t.getAttribute(us),10)),this.activeKey=this.empty}},n.prototype.restoreEdit=function(e){if(this.isNormaledit){var i=this.parent.getFrozenColumns(),r=e&&this.parent.isFrozenGrid(),n=this.parent.getFrozenMode(),o=e&&(i||"Left"===n||"Right"===n?e.renderMovableContent:e.renderFrozenRightContent);if((!r||r&&o)&&this.parent.editSettings.allowEditing&&this.parent.editModule&&!t.isNullOrUndefined(this.editedRowIndex)){var s=this.getRowByIndex(this.editedRowIndex),l=this.content,a=Object.keys(this.virtualData),h=e&&e.virtualInfo&&"X"===e.virtualInfo.sentinelInfo.axis;if(r&&h&&(s=this.parent.getMovableRowByIndex(this.editedRowIndex),l=this.movableContent),a.length&&s&&!l.querySelector("."+ns)){var d=s.getBoundingClientRect().top;(h||d<this.content.offsetHeight&&d>this.parent.getRowHeight())&&(this.parent.isEdit=!1,this.parent.editModule.startEdit(s))}if(s&&this.content.querySelector("."+ns)&&!a.length){var p=t.extend({},this.getRowObjectByIndex(this.editedRowIndex));this.virtualData=this.getVirtualEditedData(p)}}this.restoreAdd(e)}},n.prototype.getVirtualEditedData=function(e){var t=[].slice.call(this.parent.element.getElementsByClassName("e-gridform"));if(!(this.parent.editModule&&this.parent.editModule.formObj&&this.parent.editModule.formObj.isDestroyed))for(var i=0;i<t.length;i++)e=this.parent.editModule.getCurrentEditedData(t[i],e);return e},n.prototype.restoreAdd=function(e){var t=this.parent.getFrozenColumns(),i=e&&this.parent.isFrozenGrid(),r=this.parent.getFrozenMode(),n=e&&e.virtualInfo&&e.virtualInfo.sentinelInfo&&"X"===e.virtualInfo.sentinelInfo.axis&&i?!(this.parent.getMovableVirtualHeader().querySelector("."+os)||this.parent.getMovableVirtualContent().querySelector("."+os)):!this.parent.element.querySelector("."+os),o=e&&(t||"Left"===r||"Right"===r?e.renderMovableContent:e.renderFrozenRightContent);if((!i||i&&o)&&this.isNormaledit&&this.isAdd&&n){var s="Top"===this.parent.editSettings.newRowPosition&&this.content.scrollTop<this.parent.getRowHeight(),l="Bottom"===this.parent.editSettings.newRowPosition&&this.parent.pageSettings.currentPage===this.maxPage;(s||l)&&(this.parent.isEdit=!1,this.parent.addRecord())}},n.prototype.onDataReady=function(e){t.isNullOrUndefined(e.count)||(this.count=e.count,this.maxPage=Math.ceil(e.count/this.parent.pageSettings.pageSize)),this.vgenerator.checkAndResetCache(e.requestType),["refresh","filtering","searching","grouping","ungrouping","reorder",void 0].some(function(t){return e.requestType===t})&&this.refreshOffsets(),this.setVirtualHeight(),this.resetScrollPosition(e.requestType)},n.prototype.setVirtualHeight=function(e){var t=this.parent.enableColumnVirtualization?this.getColumnOffset(this.parent.columns.length+this.parent.groupSettings.columns.length-1)+"px":"100%";if(this.parent.isFrozenGrid()){var i=1===this.parent.pageSettings.currentPage&&Object.keys(this.offsets).length<=2?this.offsets[1]:this.offsets[this.getTotalBlocks()-2];i=i>this.content.clientHeight?i:0,this.virtualEle.setVirtualHeight(i,t)}else{var r=this.offsets[ae(this.parent)?this.getGroupedTotalBlocks():this.getTotalBlocks()];this.virtualEle.setVirtualHeight(r,t)}this.parent.enableColumnVirtualization&&(this.header.virtualEle.setVirtualHeight(1,t),this.parent.isFrozenGrid()&&(this.virtualEle.setMovableVirtualHeight(1,t),this.header.virtualEle.setMovableVirtualHeight(1,t)))},n.prototype.getPageFromTop=function(e,t){var i=this,r=ae(this.parent)?this.getGroupedTotalBlocks():this.getTotalBlocks(),n=0;return this.offsetKeys.some(function(o){var s=Number(o),l=e<=i.offsets[o]||s===r&&e>i.offsets[o];return l&&(i.offsetKeys.length%2!=0&&s.toString()===i.offsetKeys[i.offsetKeys.length-2]&&e<=i.offsets[i.offsetKeys.length-1]&&(s+=1),t.block=s%2==0?1:0,n=Math.max(1,Math.min(i.vgenerator.getPage(s),i.maxPage))),l}),n},n.prototype.getTranslateY=function(e,t,i,r){void 0===i&&((i={page:this.getPageFromTop(e,{})}).blockIndexes=this.vgenerator.getBlockIndexes(i.page));var n=(i.blockIndexes[0]||1)-1,o=this.getOffset(n),s=this.getOffset(i.blockIndexes[i.blockIndexes.length-1]);r&&(i=this.prevInfo);var l=o>e?this.getOffset(n-1):s<e+t?this.getOffset(n+1):o,a=this.offsets[i.blockIndexes[i.blockIndexes.length-1]]-this.tmpOffsets[i.blockIndexes[0]],h=ae(this.parent)?this.getGroupedTotalBlocks():this.getTotalBlocks();return l+a>this.offsets[h]&&(l-=l+a-this.offsets[h]),l},n.prototype.getOffset=function(e){return Math.min(0|this.offsets[e],0|this.offsets[this.maxBlock])},n.prototype.onEntered=function(){var e=this;return function(i,r,n,o,s,l){t.Browser.isIE&&!s&&l&&!e.preventEvent&&e.parent.showSpinner();var a=e.parent.enableColumnVirtualization&&e.parent.isFrozenGrid(),h="X"===r.axis,d=e.prevInfo.offsets?e.prevInfo.offsets.top:null,p=e.content.getBoundingClientRect().height,c=e.getColumnOffset(h?e.vgenerator.getColumnIndexes()[0]-1:e.prevInfo.columnIndexes[0]-1);if(h&&!a){var u=Object.keys(e.vgenerator.cOffsets).length-e.prevInfo.columnIndexes.length,g=e.vgenerator.cOffsets[u-1];c=c>g?g:c}var f=e.getTranslateY(o.top,p,h&&d===o.top?e.prevInfo:void 0,!0);e.virtualEle.adjustTable(a?0:c,Math.min(f,e.offsets[e.maxBlock])),a&&e.virtualEle.adjustMovableTable(c,0),e.parent.enableColumnVirtualization&&(e.header.virtualEle.adjustTable(a?0:c,0),a&&e.header.virtualEle.adjustMovableTable(c,0))}},n.prototype.dataBound=function(){this.parent.notify($n,{}),this.isSelection&&"upArrow"!==this.activeKey&&"downArrow"!==this.activeKey?this.parent.selectRow(this.selectedRowIndex):this.activeKey=this.empty},n.prototype.rowSelected=function(e,t){if((this.isSelection||t)&&!this.isLastBlockRow(e.rowIndex)){var i=ye(this.content.firstElementChild),r=this.parent.element.getBoundingClientRect().top,n=e.row.getBoundingClientRect().top-r,o=this.content.getBoundingClientRect().height,s=o<n,l=s?n-o:this.initialRowTop-n,a=s?i.height-l:i.height+l;this.virtualEle.adjustTable(i.width,a);this.content.querySelector("tbody").lastElementChild.getBoundingClientRect().top-r<o&&(a+=o-(e.row.getBoundingClientRect().top-r),this.virtualEle.adjustTable(i.width,a-this.parent.getRowHeight()/2))}this.isSelection=!1},n.prototype.isLastBlockRow=function(e){var t=this.parent.getContent().firstElementChild,i=Math.floor(t.offsetHeight/this.parent.getRowHeight())-1;return e>=this.maxPage*this.parent.pageSettings.pageSize-i},n.prototype.refreshMaxPage=function(){this.parent.groupSettings.columns.length&&this.parent.vcRows.length&&(this.maxPage=Math.ceil(this.parent.vcRows.length/this.parent.pageSettings.pageSize))},n.prototype.setVirtualPageQuery=function(e){var i=this.parent.getContent().querySelector(".e-row");if(i&&this.parent.isManualRefresh&&this.currentInfo.blockIndexes&&3===this.currentInfo.blockIndexes.length){this.vgenerator.startIndex=parseInt(i.getAttribute("aria-rowindex"),10),this.vgenerator.currentInfo=t.extend({},this.currentInfo),this.vgenerator.currentInfo.blockIndexes=this.currentInfo.blockIndexes.slice();(this.vgenerator.includePrevPage=this.currentInfo.blockIndexes[0]%2==0)?(this.vgenerator.startIndex=this.vgenerator.startIndex-this.getBlockSize(),this.vgenerator.currentInfo.blockIndexes.unshift(this.currentInfo.blockIndexes[0]-1)):this.vgenerator.currentInfo.blockIndexes.push(this.currentInfo.blockIndexes[this.currentInfo.blockIndexes.length-1]+1);var r=(this.vgenerator.currentInfo.blockIndexes[0]-1)*this.getBlockSize(),n=this.vgenerator.currentInfo.blockIndexes.length*this.getBlockSize();e.query.skip(r),e.query.take(n),e.skipPage=!0}},n.prototype.eventListener=function(e){var t=this;this.parent[e](Ri,this.onDataReady,this),this.parent.addEventListener(Ot,this.dataBound.bind(this)),this.parent.addEventListener(zt,this.actionBegin.bind(this)),this.parent.addEventListener(Dt,this.actionComplete.bind(this)),this.parent.addEventListener(At,this.rowSelected.bind(this)),this.parent[e](nr,this.refreshContentRows,this),this.parent[e](dn,this.selectVirtualRow,this),this.parent[e](bn,this.virtualCellFocus,this),this.parent[e](Sn,this.editActionBegin,this),this.parent[e](Tn,this.addActionBegin,this),this.parent[e](Fn,this.restoreEdit,this),this.parent[e](Rn,this.editSuccess,this),this.parent[e](En,this.refreshCache,this),this.parent[e](In,this.resetIsedit,this),this.parent[e](zn,this.getVirtualData,this),this.parent[e](xn,this.editCancel,this),this.parent[e](So,this.refreshMaxPage,this),this.parent[e](Ro,this.setVirtualPageQuery,this),this.parent[e](xo,this.selectRowOnContextOpen,this),this.parent[e](Io,this.resetVirtualFocus,this),this.parent[e](To,this.refreshCells,this),this.parent[e](zo,this.scrollToEdit,this);for(var i=this.actions,r=0;r<i.length;r++)this.parent[e](i[r]+"-begin",this.onActionBegin,this);var n=function(){t.observer.observe(function(e){return t.scrollListener(e)},t.onEntered());var e=t.parent;if(e.enablePersistence&&e.scrollPosition){t.content.scrollTop=e.scrollPosition.top;var i={direction:"down",sentinel:t.observer.sentinelInfo.down,offset:e.scrollPosition,focusElement:e.element};t.scrollListener(i),e.enableColumnVirtualization&&(t.content.scrollLeft=e.scrollPosition.left)}t.parent.off(xi,n)};this.parent.on(xi,n,this)},n.prototype.scrollToEdit=function(e){var i=this.parent.isFrozenGrid(),r=!0;if(this.validationCheck=!0,this.isAdd&&this.content.scrollTop>0){r=!1;var n=Object.keys(this.offsets);this.content.scrollTop="Top"===this.parent.editSettings.newRowPosition?0:this.offsets[n.length-1]}var o=this.parent.getRowByIndex(this.editedRowIndex);if(!(o||t.isNullOrUndefined(this.editedRowIndex)||o&&this.isRowInView(o))){var s=this.parent.getRowHeight(),l=this.editedRowIndex*s;t.isNullOrUndefined(l)||(r=!1,this.content.scrollTop=l)}if(e&&r){var a=this.vgenerator.cOffsets[e.index-this.parent.getVisibleFrozenColumns()-1];if(!this.parent.enableColumnVirtualization){var h=this.parent.getHeaderContent().querySelector('.e-headercelldiv[e-mappinguid="'+e.uid+'"]');a=i?h.parentElement.offsetLeft-this.parent.getFrozenVirtualHeader().offsetWidth:h.parentElement.offsetLeft}i?this.parent.getMovableVirtualContent().scrollLeft=this.parent.enableRtl?-Math.abs(a):a:this.content.scrollLeft=this.parent.enableRtl?-Math.abs(a):a}e&&!r&&(this.validationCol=e)},n.prototype.refreshCells=function(e){e.cells=this.vgenerator.generateCells(e.foreignKeyData)},n.prototype.resetVirtualFocus=function(e){this.isCancel=e.isCancel},n.prototype.getVirtualData=function(e){if(this.isNormaledit){var t=this.parent.element.querySelector('.e-griderror:not([style*="display: none"])'),i=Object.keys(this.virtualData);if(e.isScroll=0!==i.length&&this.currentInfo.sentinelInfo&&"X"===this.currentInfo.sentinelInfo.axis,t)return;this.virtualData=i.length?this.virtualData:e.virtualData,this.getVirtualEditedData(this.virtualData),e.virtualData=this.virtualData,e.isAdd=this.isAdd,e.isCancel=this.isCancel}},n.prototype.selectRowOnContextOpen=function(e){this.isContextMenuOpen=e.isOpen},n.prototype.editCancel=function(e){var i=Re(this.parent,e.data);t.isNullOrUndefined(i)||(e.data=this.parent.getCurrentViewRecords()[i])},n.prototype.editSuccess=function(e){this.isNormaledit&&(!this.isAdd&&e.data&&this.updateCurrentViewData(e.data),this.isAdd=!1)},n.prototype.updateCurrentViewData=function(e){var i=Re(this.parent,e);t.isNullOrUndefined(i)||(this.parent.getCurrentViewRecords()[i]=e)},n.prototype.actionBegin=function(e){"virtualscroll"!==e.requestType&&(this.requestType=e.requestType),e.cancel||this.parent.notify(ro,e)},n.prototype.virtualCellFocus=function(e){var i=document.activeElement;if(i.classList.contains(_o)&&e&&("upArrow"===e.action||"downArrow"===e.action)){var r=parseInt(i.parentElement.getAttribute(us),10);if(e&&("downArrow"===e.action||"upArrow"===e.action)){var n=this.parent.getContent().firstElementChild;"downArrow"===e.action?r+=1:r-=1,this.rowIndex=r,this.cellIndex=parseInt(i.getAttribute(cs),10);var o=this.parent.getRowByIndex(r),s=this.parent.pageSettings.currentPage,l=Math.floor(n.offsetHeight/this.parent.getRowHeight())-1,a=!1;t.isNullOrUndefined(o)&&(a=!0,("downArrow"===e.action&&s===this.maxPage-1||"upArrow"===e.action&&1===s)&&(a=!1)),a||we(o,this.parent)&&"downArrow"===e.action||be(o,2*this.parent.getRowHeight())&&"upArrow"===e.action?(this.activeKey=e.action,n.scrollTop="downArrow"===e.action?(r-l)*this.parent.getRowHeight():r*this.parent.getRowHeight()):this.activeKey=this.empty,this.parent.selectRow(r)}}},n.prototype.editActionBegin=function(e){this.editedRowIndex=e.index;var i=t.extend({},this.getRowObjectByIndex(e.index)),r=Object.keys(this.virtualData);e.data=r.length?this.virtualData:i,e.isScroll=0!==r.length&&this.currentInfo.sentinelInfo&&"X"===this.currentInfo.sentinelInfo.axis},n.prototype.refreshCache=function(e){var t=Math.ceil((this.editedRowIndex+1)/this.getBlockSize()),i=this.editedRowIndex-(t-1)*this.getBlockSize();this.vgenerator.cache[t][i].data=e.data,this.vgenerator.movableCache[t]&&(this.vgenerator.movableCache[t][i].data=e.data),this.vgenerator.frozenRightCache[t]&&(this.vgenerator.frozenRightCache[t][i].data=e.data)},n.prototype.actionComplete=function(e){var t=["delete","save","cancel"];t.some(function(t){return t===e.requestType})&&(this.refreshOffsets(),this.parent.isFrozenGrid()?(this.vgenerator.refreshColOffsets(),this.parent.contentModule.virtualRenderer.virtualEle.setVirtualHeight()):this.refreshVirtualElement()),this.isNormaledit&&(["sorting","filtering","grouping","refresh","searching","ungrouping","reorder"].some(function(t){return t===e.requestType})||t.some(function(t){return t===e.requestType}))&&(this.isCancel=!0,this.isAdd=!1,this.editedRowIndex=this.empty,this.virtualData={},this.parent.editModule&&(this.parent.editModule.editModule.previousData=void 0)),this.parent.enableColumnVirtualization&&"filterafteropen"===e.requestType&&this.currentInfo.columnIndexes&&this.currentInfo.columnIndexes[0]>0&&this.parent.resetFilterDlgPosition(e.columnName)},n.prototype.resetIsedit=function(){this.parent.enableVirtualization&&this.isNormaledit&&(this.parent.editSettings.allowEditing&&Object.keys(this.virtualData).length||this.parent.editSettings.allowAdding&&this.isAdd)&&(this.parent.isEdit=!0)},n.prototype.scrollAfterEdit=function(){if(this.parent.editModule&&this.parent.editSettings.allowEditing&&this.isNormaledit&&this.parent.element.querySelector(".e-gridform")){var e=this.parent.element.querySelector("."+ns),i=this.parent.element.querySelector("."+os);if(e||i){var r=e?t.extend({},this.getRowObjectByIndex(this.editedRowIndex)):t.extend({},this.emptyRowData),n=Object.keys(this.virtualData);this.virtualData=n.length?this.getVirtualEditedData(this.virtualData):this.getVirtualEditedData(r)}}},n.prototype.createEmptyRowdata=function(){var e=this;this.parent.columnModel.filter(function(t){e.emptyRowData[t.field]=e.empty})},n.prototype.addActionBegin=function(e){if(this.isNormaledit){Object.keys(this.emptyRowData).length||this.createEmptyRowdata(),this.isAdd=!0;var t=this.parent.pageSettings.currentPage;!this.parent.frozenRows&&this.content.scrollTop>0&&"Top"===this.parent.editSettings.newRowPosition&&(this.isAdd=!0,this.onActionBegin(),e.startEdit=!1,this.content.scrollTop=0),t<this.maxPage-1&&"Bottom"===this.parent.editSettings.newRowPosition&&(this.isAdd=!0,this.parent.setProperties({pageSettings:{currentPage:this.maxPage-1}},!0),e.startEdit=!1,this.content.scrollTop=this.offsets[this.offsetKeys.length])}},n.prototype.getRowObjectByIndex=function(e){return this.getRowCollection(e,!1,!0)},n.prototype.getBlockSize=function(){return this.parent.pageSettings.pageSize>>1},n.prototype.getBlockHeight=function(){return this.getBlockSize()*this.parent.getRowHeight()},n.prototype.isEndBlock=function(e){var t=ae(this.parent)?this.getGroupedTotalBlocks():this.getTotalBlocks();return e>=t||e===t-1},n.prototype.getGroupedTotalBlocks=function(){var e=this.parent.vcRows;return Math.floor(e.length/this.getBlockSize()<1?1:e.length/this.getBlockSize())},n.prototype.getTotalBlocks=function(){return Math.ceil(this.count/this.getBlockSize())},n.prototype.getColumnOffset=function(e){return 0|this.vgenerator.cOffsets[e]},n.prototype.getModelGenerator=function(){return new Ha(this.parent)},n.prototype.resetScrollPosition=function(e){this.actions.some(function(t){return t===e})&&(this.preventEvent=0!==this.content.scrollTop,this.content.scrollTop=0),"virtualscroll"!==e&&(this.isAdd=!1)},n.prototype.onActionBegin=function(e){this.parent.setProperties({pageSettings:{currentPage:1}},!0)},n.prototype.getRows=function(){return this.vgenerator.getRows()},n.prototype.getRowByIndex=function(e){var t;return ae(this.parent)?t=this.parent.getDataRows()[e]:this.prevInfo&&(t=this.getRowCollection(e,!1)),t},n.prototype.getMovableVirtualRowByIndex=function(e){return this.getRowCollection(e,!0)},n.prototype.getFrozenRightVirtualRowByIndex=function(e){return this.getRowCollection(e,!1,!1,!0)},n.prototype.getRowCollection=function(e,i,r,n){var o=(this.prevInfo.blockIndexes[0]-1)*this.getBlockSize(),s=i?this.parent.getMovableDataRows():this.parent.getDataRows();s=n?this.parent.getFrozenRightDataRows():s;var l=r?this.parent.getCurrentViewRecords():s;r&&this.parent.allowGrouping&&this.parent.groupSettings.columns.length&&(o=parseInt(this.parent.getRows()[0].getAttribute(us),10),l=l.filter(function(e){return t.isNullOrUndefined(e.items)}));var a=l[e-o];return this.parent.frozenRows&&this.parent.pageSettings.currentPage>1&&(a=r?e<=this.parent.frozenRows?this.parent.getRowsObject()[e].data:a:e<=this.parent.frozenRows?s[e]:s[e-o+this.parent.frozenRows]),a},n.prototype.getVirtualRowIndex=function(e){return(this.prevInfo.blockIndexes[0]-1)*this.getBlockSize()+e},n.prototype.refreshOffsets=function(){var e=this.parent,t=0,i=this.getBlockSize(),r=ae(this.parent)?this.getGroupedTotalBlocks():this.getTotalBlocks();this.prevHeight=this.offsets[r],this.maxBlock=r%2==0?r-2:r-1,this.offsets={};for(var n=Array.apply(null,Array(r)).map(function(){return++t}),o=0;o<n.length;o++){var s=(this.vgenerator.cache[n[o]]||[]).length,l=ae(this.parent)?e.vcRows.length%i:this.count%i,a=!ae(this.parent)&&n[o]in this.vgenerator.cache?s*this.parent.getRowHeight():l&&n[o]===r?l*this.parent.getRowHeight():this.getBlockHeight();this.offsets[n[o]]=(0|this.offsets[n[o]-1])+a,this.tmpOffsets[n[o]]=0|this.offsets[n[o]-1]}this.offsetKeys=Object.keys(this.offsets),ae(this.parent)&&(this.parent.vGroupOffsets=this.offsets),this.parent.enableColumnVirtualization&&this.vgenerator.refreshColOffsets()},n.prototype.refreshVirtualElement=function(){this.vgenerator.refreshColOffsets(),this.setVirtualHeight()},n.prototype.setVisible=function(e){var i,r,n=this.parent,o=this.parent.getFrozenColumns();o&&(i=[].slice.call(this.parent.getFrozenVirtualContent().querySelectorAll("col")),r=[].slice.call(this.parent.getMovableVirtualContent().querySelectorAll("col")));var s,l=[];(l=this.getRows()).some(function(e){return e.isDataRow&&(s=e),e.isDataRow});var a=!0;!n.groupSettings.columns.length&&s&&(a=!1);for(var h=n.getDataRows(),d=0,p=e.length;d<p;d++){var c=e[d],u=n.getNormalizedColumnIndex(c.uid),g=!0===c.visible?"":"none",f=void 0;if(i&&r?u>=o?(f=r,h=this.parent.getMovableRows(),u-=o):f=i:f=this.getColGroup().children,-1!==u&&s&&u<s.cells.length&&t.setStyleAttribute(f[u],{display:g}),!a){var m=void 0;c.width&&(m=c.visible?this.virtualEle.wrapper.offsetWidth+parseInt(c.width.toString(),10):this.virtualEle.wrapper.offsetWidth-parseInt(c.width.toString(),10)),m>n.width?(this.setDisplayNone(h,u,g,l),this.parent.enableColumnVirtualization&&this.virtualEle.setWrapperWidth(m+""),this.refreshVirtualElement()):a=!0}!this.parent.invokedFromMedia&&c.hideAtMedia&&this.parent.updateMediaColumns(c),this.parent.invokedFromMedia=!1}a||o?this.refreshContentRows({requestType:"refresh"}):this.parent.notify(an,{rows:l,args:{isFrozen:!1,rows:l}})},n.prototype.selectVirtualRow=function(e){var i=this;if(e.isAvailable=e.selectedIndex<this.count,e.isAvailable&&!this.isContextMenuOpen&&"upArrow"!==this.activeKey&&"downArrow"!==this.activeKey&&!this.isSelection&&!this.requestTypes.some(function(e){return e===i.requestType})&&!this.parent.selectionModule.isInteracted){var r=this.parent.getRowByIndex(e.selectedIndex),n=this.parent.getRowHeight();if(!r||!this.isRowInView(r)){this.isSelection=!0,this.selectedRowIndex=e.selectedIndex;var o=(e.selectedIndex+1)*n;if(!t.isNullOrUndefined(o)){var s=this.content.scrollTop<o?"down":"up";this.selectRowIndex=e.selectedIndex,this.content.scrollTop=o,this.isSelectionScroll=this.observer.check(s)}}}this.parent.isFrozenGrid()&&this.requestType?this.parent.getTablesCount()===this.frzIdx?(this.requestType=this.empty,this.frzIdx=1):this.frzIdx++:this.requestType=this.empty},n.prototype.isRowInView=function(e){var t=e.getBoundingClientRect().top,i=e.getBoundingClientRect().bottom;return t>=this.content.getBoundingClientRect().top&&i<=this.content.getBoundingClientRect().bottom},n}(ks),Va=function(e){function i(t,i){var r=e.call(this,t,i)||this;return r.virtualEle=new Ga,r.isMovable=!1,r.gen=new Ha(r.parent),r.parent.on(Qi,r.setVisible,r),r.parent.on(nr,function(e){return"X"===e.virtualInfo.sentinelInfo.axis?r.refreshUI():null},r),r}return Ua(i,e),i.prototype.renderTable=function(){this.gen.refreshColOffsets(),this.parent.setColumnIndexesInView(this.gen.getColumnIndexes(this.getPanel().querySelector("."+Xo))),e.prototype.renderTable.call(this),this.virtualEle.table=this.getTable(),this.virtualEle.content=this.getPanel().querySelector("."+Xo),this.virtualEle.content.style.position="relative",this.virtualEle.renderWrapper(),this.virtualEle.renderPlaceHolder("absolute")},i.prototype.appendContent=function(e){this.isMovable?(this.virtualEle.movableWrapper.appendChild(e),this.isMovable=!1):this.virtualEle.wrapper.appendChild(e)},i.prototype.refreshUI=function(){this.isMovable=this.parent.isFrozenGrid(),this.setFrozenTable(this.parent.getMovableVirtualContent()),this.gen.refreshColOffsets(),this.parent.setColumnIndexesInView(this.gen.getColumnIndexes(this.getPanel().querySelector("."+Xo))),e.prototype.refreshUI.call(this),this.setFrozenTable(this.parent.getFrozenVirtualContent())},i.prototype.setVisible=function(e){var i,r,n,o,s,l=this.parent,a=this.parent.getFrozenColumns();a&&(o=[].slice.call(this.parent.getFrozenVirtualHeader().querySelectorAll("col")),s=[].slice.call(this.parent.getMovableVirtualHeader().querySelectorAll("col")));for(var h=0,d=e.length;h<d;h++){var p=e[h];r=l.getNormalizedColumnIndex(p.uid),i=p.visible?"":"none";var c=void 0;if(o&&s?r>=a?(c=s,r-=a):c=o:c=this.getColGroup().children,t.setStyleAttribute(c[r],{display:i}),l.enableColumnVirtualization&&!l.groupSettings.columns.length){var u=void 0;(u=p.visible?this.virtualEle.wrapper.offsetWidth+parseInt(p.width.toString(),10):this.virtualEle.wrapper.offsetWidth-parseInt(p.width.toString(),10))>l.width?(this.setDisplayNone(p,i),this.virtualEle.setWrapperWidth(u+""),this.gen.refreshColOffsets()):n=!0}else n=!0;n&&!a&&this.refreshUI()}a&&this.parent.notify(Ji,{})},i.prototype.setFrozenTable=function(e){this.parent.isFrozenGrid()&&this.parent.enableColumnVirtualization&&this.parent.contentModule.isXaxis()&&this.parent.contentModule.setTable(e.querySelector("."+ts))},i.prototype.setDisplayNone=function(e,i){var r=this.parent.isFrozenGrid(),n=this.getTable();r&&"movable"===e.getFreezeTableName()&&(n=this.parent.getMovableVirtualHeader().querySelector("."+ts));for(var o=0,s=[].slice.apply(n.querySelectorAll("th.e-headercell"));o<s.length;o++){var l=s[o];if(l.querySelector("[e-mappinguid]")&&l.querySelector("[e-mappinguid]").getAttribute("e-mappinguid")===e.uid){t.setStyleAttribute(l,{display:i}),""===i&&t.removeClass([l],"e-hide");break}}},i}(As),Ga=function(){function e(){}return e.prototype.renderWrapper=function(e){this.wrapper=t.createElement("div",{className:"e-virtualtable",styles:"min-height:"+t.formatUnit(e)}),this.wrapper.appendChild(this.table),this.content.appendChild(this.wrapper)},e.prototype.renderPlaceHolder=function(e){void 0===e&&(e="relative"),this.placeholder=t.createElement("div",{className:"e-virtualtrack",styles:"position:"+e}),this.content.appendChild(this.placeholder)},e.prototype.renderFrozenWrapper=function(e){this.wrapper=t.createElement("div",{className:"e-virtualtable",styles:"min-height:"+t.formatUnit(e)+"; display: flex"}),this.content.appendChild(this.wrapper)},e.prototype.renderFrozenPlaceHolder=function(){this.placeholder=t.createElement("div",{className:"e-virtualtrack"}),this.content.appendChild(this.placeholder)},e.prototype.renderMovableWrapper=function(e){this.movableWrapper=t.createElement("div",{className:"e-virtualtable",styles:"min-height:"+t.formatUnit(e)}),this.movableContent.appendChild(this.movableWrapper)},e.prototype.renderMovablePlaceHolder=function(){this.movablePlaceholder=t.createElement("div",{className:"e-virtualtrack"}),this.movableContent.appendChild(this.movablePlaceholder)},e.prototype.adjustTable=function(e,t){this.wrapper.style.transform="translate("+e+"px, "+t+"px)"},e.prototype.adjustMovableTable=function(e,t){this.movableWrapper.style.transform="translate("+e+"px, "+t+"px)"},e.prototype.setMovableWrapperWidth=function(e,t){this.movableWrapper.style.width=e?e+"px":t?"100%":""},e.prototype.setMovableVirtualHeight=function(e,t){this.movablePlaceholder.style.height=e+"px",this.movablePlaceholder.style.width=t},e.prototype.setWrapperWidth=function(e,t){this.wrapper.style.width=e?e+"px":t?"100%":""},e.prototype.setVirtualHeight=function(e,t){this.placeholder.style.height=e+"px",this.placeholder.style.width=t},e.prototype.setFreezeWrapperWidth=function(e,t,i){e.style.width=t?t+"px":i?"100%":""},e}(),_a=function(){function i(e,t){this.parent=e,this.locator=t,this.addEventListener()}return i.prototype.getModuleName=function(){return"virtualscroll"},i.prototype.instantiateRenderer=function(){this.parent.log(["limitation","virtual_height"],"virtualization");var t=this.locator.getService("rendererFactory");this.parent.isFrozenGrid()||(this.parent.enableColumnVirtualization&&t.addRenderer(e.RenderType.Header,new Va(this.parent,this.locator)),t.addRenderer(e.RenderType.Content,new ja(this.parent,this.locator))),this.ensurePageSize()},i.prototype.ensurePageSize=function(){var e=this.parent.getRowHeight(),t=this.parent.height.toString().indexOf("%")<0?this.parent.height:this.parent.element.getBoundingClientRect().height;this.blockSize=~~(t/e);var i=2*this.blockSize,r=this.parent.pageSettings.pageSize;this.parent.setProperties({pageSettings:{pageSize:r<i?i:r}},!0)},i.prototype.addEventListener=function(){this.parent.isDestroyed||(this.parent.on(bi,this.instantiateRenderer,this),this.parent.on(Yi,this.refreshVirtualElement,this),this.parent.on(Mo,this.createVirtualValidationForm,this),this.parent.on(Oo,this.virtualEditFormValidation,this),this.parent.on(Ki,this.destroy,this))},i.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(bi,this.instantiateRenderer),this.parent.off(Yi,this.refreshVirtualElement),this.parent.off(Mo,this.createVirtualValidationForm),this.parent.off(Oo,this.virtualEditFormValidation),this.parent.off(Ki,this.destroy))},i.prototype.getCurrentEditedData=function(e){var i={virtualData:t.extend({},{},e,!0),isAdd:!1,isScroll:!1,endEdit:!0};return this.parent.notify(zn,i),i.virtualData},i.prototype.createVirtualValidationForm=function(e){var i=this.parent;if(i.enableVirtualization&&"Normal"===i.editSettings.mode){var r=i.columns,n=new Fs(this.locator,null,this.parent),o=t.extend({},{},i.getRowObjectFromUID(e.uid),!0);i.notify(To,o);var s=e.argsCreator(this.getCurrentEditedData(e.prevData),{},!1);s.isCustomFormValidation=!0,s.row=n.render(o,r),e.renderer.update(s);for(var l={},a=0;a<r.length;a++)r[a].visible&&r[a].validationRules&&Pe(r[a],0,l,{},{},r.length,!0);s.form.classList.add("e-virtual-validation"),i.editModule.virtualFormObj=i.editModule.createFormObj(s.form,l)}},i.prototype.virtualEditFormValidation=function(e){var i=this.parent,r=i.element.querySelector('.e-griderror:not([style*="display: none"])');if(i.editModule.virtualFormObj)if(r&&"none"!==r.style.display){var n=r.getBoundingClientRect(),o=i.element.querySelectorAll(".e-gridform"),s=o[0],l=i.getContent().getBoundingClientRect().left;if(o.length>1&&(s="Right"!==i.getFrozenMode()?o[1]:o[0],l=i.getMovableVirtualContent().getBoundingClientRect().left),n.left<l||n.right>i.element.offsetWidth){var a=s.querySelector('.e-tooltip-wrap:not([style*="display: none"])');this.scrollToEdit(a,{editIdx:e.editIdx,addIdx:e.addIdx},!0)}}else if(i.editModule.virtualFormObj&&(!r||"none"===r.style.display)){for(var h=i.editModule.virtualFormObj.element.querySelectorAll('.e-tooltip-wrap:not([style*="display: none"])'),d=0;d<h.length;d++)t.remove(h[d]);if(this.setEditedDataToValidationForm(i.editModule.virtualFormObj.element,this.getCurrentEditedData(e.prevData)),e.isValid=i.editModule.virtualFormObj.validate(),!e.isValid){a=i.editModule.virtualFormObj.element.querySelector('.e-tooltip-wrap:not([style*="display: none"])');this.scrollToEdit(a,{editIdx:e.editIdx,addIdx:e.addIdx})}}},i.prototype.scrollToEdit=function(e,i,r){var n=this.parent;if(e){var o=n.columnModel,s=G(e.id).split("_")[0],l=n.getColumnByField(s),a=this.parent.getContent().firstElementChild.scrollTop,h=n.getRowByIndex(i.editIdx);if(r||!l||!t.isNullOrUndefined(i.addIdx)&&a>0||!t.isNullOrUndefined(i.editIdx)&&!h){for(var d=void 0,p=0;p<o.length&&!l;p++)if(o[p].field===s){d=o[p];break}r&&(d=l),this.parent.notify(zo,d)}}},i.prototype.setEditedDataToValidationForm=function(e,i){for(var r=[].slice.call(e.getElementsByClassName("e-field")),n=0,o=r.length;n<o;n++){var s=Ke(this.parent,r[n].getAttribute("e-mappinguid")),l=t.getValue(s.field,i);l=t.isNullOrUndefined(l)?"":l,r[n].value=l}},i.prototype.refreshVirtualElement=function(t){if(this.parent.enableColumnVirtualization&&"resize"===t.module){this.locator.getService("rendererFactory").getRenderer(e.RenderType.Content).refreshVirtualElement()}},i.prototype.destroy=function(){this.removeEventListener()},i}(),Wa=function(){function e(e){this.parent=e}return e.prototype.addNew=function(e,t){this.isEdit=!1;var i,r=Le(this.parent),n=qe(this.parent),o=this.parent.isFrozenGrid(),s=o&&this.parent.enableColumnVirtualization&&t.isScroll;if(i=this.parent.frozenRows&&"Top"===this.parent.editSettings.newRowPosition?s?this.parent.getMovableHeaderTbody():this.parent.getHeaderTable().querySelector(gs):s?this.parent.getMovableContentTbody():this.parent.getContentTable().querySelector(gs),t.row=this.parent.createElement("tr",{className:"e-row e-addedrow"}),i.querySelector(".e-emptyrow")){var l=i.querySelector(".e-emptyrow");if(l.parentNode.removeChild(l),o&&!s){var a=this.parent.getContent().querySelector("."+Yo).querySelector(gs);if(a.firstElementChild.parentNode.removeChild(a.firstElementChild),this.parent.getFrozenMode()===hs){var h=this.parent.getContent().querySelector(".e-frozen-right-content").querySelector(gs);h.firstElementChild.parentNode.removeChild(h.firstElementChild)}}}if("Top"===this.parent.editSettings.newRowPosition?i.insertBefore(t.row,i.firstChild):i.appendChild(t.row),t.row.appendChild(this.getEditElement(e,!1,void 0,t,!0)),this.parent.editModule.checkLastRow(t.row,t),o&&!s){var d=this.renderMovableform(t.row,t);if("Top"===this.parent.editSettings.newRowPosition?r.insertBefore(d,r.firstChild):r.appendChild(d),t.row.querySelector(".e-normaledit").setAttribute("colspan",this.parent.getVisibleFrozenColumns()+""),d.setAttribute("colspan",""+(this.parent.getVisibleColumns().length-this.parent.getVisibleFrozenColumns())),n){var p=this.renderFrozenRightForm(t.row,t);"Top"===this.parent.editSettings.newRowPosition?n.insertBefore(p,n.firstChild):n.appendChild(p);var c=this.parent.getVisibleFrozenColumns()-this.parent.getFrozenRightColumnsCount();t.row.querySelector(".e-normaledit").setAttribute("colspan",c+""),p.querySelector(".e-normaledit").setAttribute("colspan",""+this.parent.getFrozenRightColumnsCount())}"auto"===this.parent.height&&this.parent.notify(Wr,{})}},e.prototype.renderFrozenRightForm=function(e,t){var i=e.cloneNode(!0),r=t.frozenRightForm=i.querySelector("form");return this.parent.editSettings.template?(r.innerHTML="",this.appendChildren(r,t.rowData,!1),i):(this.renderRightFrozen(e,i),i.querySelector(fs).innerHTML=this.parent.getHeaderContent().querySelector(".e-frozen-right-header").querySelector(fs).innerHTML,i)},e.prototype.renderMovableform=function(e,t){var i=e.cloneNode(!0),r=t.movableForm=i.querySelector("form");return this.parent.editSettings.template?(r.innerHTML="",this.appendChildren(r,t.rowData,!1),i):(this.renderMovable(e,i),i.querySelector(fs).innerHTML=this.parent.getHeaderContent().querySelector("."+Jo).querySelector(fs).innerHTML,i)},e.prototype.updateFreezeEdit=function(e,t){return t=t.concat([].slice.call(this.getFreezeRow(e).querySelectorAll("td.e-rowcell"))),this.parent.getFrozenMode()===hs&&(t=t.concat([].slice.call(this.getFreezeRightRow(e).querySelectorAll("td.e-rowcell")))),t},e.prototype.getFreezeRightRow=function(e){var t=parseInt(e.getAttribute(us),10),i=this.parent.getFrozenLeftContentTbody(),r=this.parent.getFrozenHeaderTbody(),n=this.parent.getFrozenRightHeaderTbody(),o=this.parent.getFrozenRightContentTbody();return i.contains(e)||r.contains(e)?this.parent.getFrozenRightRowByIndex(t):o.contains(e)||n.contains(e)?this.parent.getRowByIndex(t):e},e.prototype.getFreezeRow=function(e){if(this.parent.isFrozenGrid()){var t=parseInt(e.getAttribute(us),10),i=this.parent.getFrozenLeftContentTbody(),r=this.parent.getMovableContentTbody(),n=this.parent.getFrozenHeaderTbody(),o=this.parent.getMovableHeaderTbody();if(i.contains(e)||n.contains(e))return this.parent.getMovableRowByIndex(t);if(r.contains(e)||o.contains(e))return this.parent.getRowByIndex(t)}return e},e.prototype.update=function(e,i){this.isEdit=!0;var r=i.isCustomFormValidation,n=i.isScroll;n||!t.closest(i.row,"."+Yo)&&!t.closest(i.row,"."+Jo)||(i.row=this.getFreezeRow(i.row)),(t.closest(i.row,".e-frozen-right-content")||t.closest(i.row,".e-frozen-right-header"))&&(i.row=this.getFreezeRightRow(i.row));var o=this.parent.isFrozenGrid()&&this.parent.enableColumnVirtualization&&n,s=[].slice.call(i.row.querySelectorAll("td.e-rowcell"));i.row.innerHTML="",o||r||(s=this.updateFreezeEdit(i.row,s)),i.row.appendChild(this.getEditElement(e,!0,s,i,!0)),i.row.classList.add(ns),this.parent.editModule.checkLastRow(i.row,i),o||r||this.refreshFreezeEdit(i.row,i)},e.prototype.refreshFreezeEdit=function(e,t){var i=e.firstChild;this.parent.getVisibleFrozenColumns()&&this.parent.editSettings.template&&(i.querySelector(fs).innerHTML=this.parent.getHeaderContent().querySelector("."+$o).querySelector(fs).innerHTML);var r,n,o=parseInt(e.getAttribute(us),10);if(this.parent.isFrozenGrid()){o<this.parent.frozenRows?(n=this.parent.getHeaderContent(),r="."+$o):(n=this.parent.getContent(),r="."+Zo);var s=i.cloneNode(!0),l=i.cloneNode(!0),a=t.movableForm=s.querySelector("form");this.parent.editSettings.template&&this.refreshEditForm(a,t.rowData);var h=void 0,d=void 0;n.querySelector(r).contains(e)?(h=this.parent.getMovableRowByIndex(o),this.updateFrozenCont(h,i,s),this.parent.getFrozenMode()===hs&&(t.frozenRightForm=l.querySelector("form"),this.refreshEditForm(t.frozenRightForm,t.rowData),d=this.parent.getFrozenRightRowByIndex(o),this.updateFrozenRightCont(d,i,l))):(h=this.parent.getRowByIndex(o),this.updateFrozenCont(h,s,i),this.parent.getFrozenMode()===hs&&(t.frozenRightForm=l.querySelector("form"),this.refreshEditForm(t.frozenRightForm,t.rowData),d=this.parent.getFrozenRightRowByIndex(o),this.updateFrozenRightCont(d,l,i))),h.appendChild(s),h.classList.add(ns),this.parent.getFrozenMode()===hs&&(d.appendChild(l),d.classList.add(ns),Ce(t.frozenRightForm.querySelector("td:not(.e-hide)"),t.form.querySelector("td:not(.e-hide)"))),Ce(t.movableForm.querySelector("td:not(.e-hide)"),t.form.querySelector("td:not(.e-hide)"))}},e.prototype.refreshEditForm=function(e,t){this.parent.editSettings.template&&(e.innerHTML="",this.appendChildren(e,t,!1))},e.prototype.updateFrozenRightCont=function(e,t,i){e.innerHTML="",this.renderRightFrozen(t,i),i.querySelector(fs).innerHTML=this.parent.getHeaderContent().querySelector(".e-frozen-right-header").querySelector(fs).innerHTML,t.setAttribute("colspan",this.parent.getVisibleFrozenColumns()-this.parent.getFrozenRightColumnsCount()+""),i.setAttribute("colspan",this.parent.getFrozenRightColumnsCount()+"")},e.prototype.updateFrozenCont=function(e,t,i){e.innerHTML="",this.renderMovable(t,i),i.querySelector(fs).innerHTML=this.parent.getHeaderContent().querySelector("."+Jo).querySelector(fs).innerHTML,t.setAttribute("colspan",this.parent.getVisibleFrozenColumns()+""),i.setAttribute("colspan",this.parent.getCurrentVisibleColumns(this.parent.enableColumnVirtualization).length-this.parent.getVisibleFrozenColumns()+"")},e.prototype.renderRightFrozen=function(e,t){t.querySelector("tr").innerHTML="";for(var i=this.parent.getColumns(),r=0,n=0;n<i.length;n++,r++)if(i[n].getFreezeTableName()===ds){var o=r-this.parent.getMovableColumnsCount();t.querySelector("tr").appendChild(e.querySelector("tr").removeChild(e.querySelector("tr").children[o])),r--}},e.prototype.renderMovable=function(e,t){t.querySelector("tr").innerHTML="";for(var i=this.parent.getColumns(),r=this.parent.isRowDragable()?1:0,n=0;n<i.length;n++,r++)"movable"===i[n].getFreezeTableName()&&(t.querySelector("tr").appendChild(e.querySelector("tr").removeChild(e.querySelector("tr").children[r])),r--)},e.prototype.getEditElement=function(e,i,r,n,o){var s=this.parent,l=0,a=t.isNullOrUndefined(s.detailTemplate)&&t.isNullOrUndefined(s.childGrid)?0:1;s.allowGrouping&&(l=s.groupSettings.columns.length);var h=this.parent.createElement("td",{className:"e-editcell e-normaledit",attrs:{colspan:(s.getCurrentVisibleColumns(this.parent.enableColumnVirtualization).length-s.getVisibleFrozenColumns()+this.parent.getIndentCount()).toString()}}),d=n.form=this.parent.createElement("form",{id:s.element.id+"EditForm",className:"e-gridform"});if(this.parent.editSettings.template)return this.appendChildren(d,n.rowData,o),h.appendChild(d),h;var p=this.parent.createElement("table",{className:"e-table e-inline-edit",attrs:{cellspacing:"0.25"}});p.appendChild(s.getContentTable().querySelector(fs).cloneNode(!0));var c=this.parent.createElement(gs),u=this.parent.createElement("tr"),g=0;for(a&&u.insertBefore(this.parent.createElement("td",{className:"e-detailrowcollapse"}),u.firstChild),s.isRowDragable()&&u.appendChild(this.parent.createElement("td",{className:"e-dragindentcell"}));g<l;)u.appendChild(this.parent.createElement("td",{className:"e-indentcell"})),g++;var f=0;g=0;for(var m=s.isFrozenGrid()&&s.enableColumnVirtualization&&n.isScroll,y=n.isCustomFormValidation?this.parent.columnModel:s.getColumns();i&&f<r.length&&g<y.length||g<y.length;){var v=i?r[f].getAttribute("colspan"):null,C=y[g];if(m&&"movable"!==C.getFreezeTableName()||n.isCustomFormValidation&&(C.commands||C.commandsTemplate||!C.field))g++;else{var w=this.parent.createElement("td",{className:_o,attrs:{style:"text-align:"+(C.textAlign?C.textAlign:""),colspan:v||""}});C.visible?(w.appendChild(e[C.uid]),"Vertical"===this.parent.rowRenderingMode&&(x(w,{"data-cell":C.headerText}),0===g&&w.classList.add("e-responsive-editcell")),"booleanedit"===C.editType?w.classList.add("e-boolcell"):(C.commands||C.commandsTemplate)&&t.addClass([w],"e-unboundcell")):w.classList.add("e-hide"),u.appendChild(w),g=v?g+parseInt(v,10):g+1,f++}}return c.appendChild(u),p.appendChild(c),d.appendChild(p),h.appendChild(d),h},e.prototype.removeEventListener=function(){},e.prototype.appendChildren=function(e,i,r){var n=t.extend({},i,{isAdd:!this.isEdit,isFrozen:r},!0),o=this.parent.element.id+"editSettingsTemplate";this.parent.isReact&&"string"!=typeof this.parent.editSettings.template?(this.parent.getEditTemplate()(n,this.parent,"editSettingsTemplate",o,null,null,e),this.parent.renderTemplates()):P(e,this.parent.getEditTemplate()(n,this.parent,"editSettingsTemplate",o))},e}(),Ka=function(){function e(e){this.parent=e}return e.prototype.update=function(e,i){if(this.parent.isReact&&i.columnObject&&i.columnObject.template){var r=i.cell.parentElement,n=i.cell.cloneNode(!0);r.insertBefore(n,i.cell),n.focus(),i.cell.remove(),i.cell=n}i.cell.innerHTML="",i.cell.appendChild(this.getEditElement(e,i)),i.cell.classList.remove("e-ellipsistooltip"),i.cell.classList.add("e-editedbatchcell"),t.classList(i.row,[ns,"e-batchrow"],[])},e.prototype.getEditElement=function(e,t){var i=this.parent,r=this.parent.createElement("form",{id:i.element.id+"EditForm",className:"e-gridform"});return r.appendChild(e[t.columnObject.uid]),"booleanedit"===t.columnObject.editType&&t.cell.classList.add("e-boolcell"),t.columnObject.editType||t.cell.classList.add("e-inputbox"),r},e.prototype.removeEventListener=function(){},e}(),Qa=function(){function i(e,t){this.parent=e,this.serviceLocator=t,this.parent.isDestroyed||(this.parent.on(gr,this.destroy,this),this.parent.on(Ki,this.destroy,this))}return i.prototype.setLocaleObj=function(){this.l10n=this.serviceLocator.getService("localization")},i.prototype.addNew=function(e,t){this.isEdit=!1,this.createDialog(e,t)},i.prototype.update=function(e,t){this.isEdit=!0,this.createDialog(e,t)},i.prototype.createDialogHeader=function(t){var i=this.parent;if(this.parent.enableAdaptiveUI){var r=new ll(this.parent,this.serviceLocator);return r.action=this.isEdit?e.ResponsiveDialogAction.isEdit:e.ResponsiveDialogAction.isAdd,r.renderResponsiveHeader(void 0,t)}return i.editSettings.headerTemplate?this.getDialogEditTemplateElement("HeaderTemplate",t):this.isEdit?this.l10n.getConstant("EditFormTitle")+t.primaryKeyValue[0]:this.l10n.getConstant("AddFormTitle")},i.prototype.createDialog=function(e,i){var n=this.parent;this.dialog=this.parent.createElement("div",{id:n.element.id+"_dialogEdit_wrapper",styles:"width: auto"}),n.enableAdaptiveUI&&this.dialog.classList.add("e-responsive-dialog"),this.dialog.setAttribute("aria-label","Dialog edit"),n.element.appendChild(this.dialog),this.setLocaleObj(),this.dialogObj=new r.Dialog(t.extend({header:this.createDialogHeader(i),isModal:!0,visible:!0,cssClass:"e-edit-dialog",content:this.getEditElement(e,i),showCloseIcon:!0,allowDragging:!0,close:this.dialogClose.bind(this),created:this.dialogCreated.bind(this),closeOnEscape:!0,width:n.editSettings.template?"auto":"330px",target:i.target?i.target:document.body,animationSettings:{effect:"None"},footerTemplate:n.editSettings.footerTemplate?this.getDialogEditTemplateElement("FooterTemplate",i):null,buttons:[{click:this.btnClick.bind(this),buttonModel:{content:this.l10n.getConstant("SaveButton"),cssClass:"e-primary",isPrimary:!0}},{click:this.btnClick.bind(this),buttonModel:{cssClass:"e-flat",content:this.l10n.getConstant("CancelButton")}}]},n.editSettings.dialog?n.editSettings.dialog.params||{}:{})),i.dialog=this.dialogObj;this.dialogObj.isStringTemplate=!0,this.renderResponsiveDialog(),this.dialogObj.appendTo(this.dialog),ve(this.parent.element,this.dialogObj.element.parentElement),n.enableAdaptiveUI&&this.dialogObj.show(!0)},i.prototype.dialogCreated=function(){je(this.parent)},i.prototype.renderResponsiveDialog=function(){var e=this;this.parent.enableAdaptiveUI&&(this.parent.adaptiveDlgTarget&&(this.dialogObj.target=this.parent.adaptiveDlgTarget),this.dialogObj.buttons=[{}],this.dialogObj.showCloseIcon=!0,this.dialogObj.visible=!1,this.dialogObj.width="100%",this.dialogObj.open=function(){e.dialogObj.element.style.maxHeight="100%"})},i.prototype.btnClick=function(e){this.l10n.getConstant("CancelButton").toLowerCase()===e.target.innerText.trim().toLowerCase()?this.dialogClose():this.parent.endEdit()},i.prototype.dialogClose=function(){this.parent.closeEdit()},i.prototype.destroy=function(e){for(var i=["template","headerTemplate","footerTemplate"],r=0;r<i.length;r++)if(this.parent.editSettings[i[r]]){var n=i[r].charAt(0).toUpperCase()+i[r].slice(1),o=this.parent.element.id+"editSettings"+n;t.updateBlazorTemplate(o,n,this.parent.editSettings)}this.parent.notify(yr,{}),this.parent.isEdit=!1,this.parent.notify(sr,{}),this.dialog&&!this.dialogObj.isDestroyed&&(this.dialogObj.destroy(),t.remove(this.dialog))},i.prototype.getDialogEditTemplateElement=function(e,i){var r=this.parent.createElement("div",{className:"e-dialog"+e}),n=t.extend({},i.rowData,{isAdd:!this.isEdit},!0),o=this.parent.element.id+"editSettings"+e;return P(r,("HeaderTemplate"===e?this.parent.getEditHeaderTemplate():this.parent.getEditFooterTemplate())(n,this.parent,"editSettings"+e,o)),t.updateBlazorTemplate(o,e,this.parent.editSettings),r},i.prototype.getEditElement=function(e,i){var r=this,n=this.parent,o=this.parent.createElement("div",{className:this.isEdit?ns:"e-insertedrow"}),s=i.form=this.parent.createElement("form",{id:n.element.id+"EditForm",className:"e-gridform"});if(this.parent.editSettings.template){var l=this.parent.element.id+"editSettingsTemplate",a=t.extend({},i.rowData,{isAdd:!this.isEdit},!0);this.parent.isReact&&"string"!=typeof this.parent.editSettings.template?(this.parent.getEditTemplate()(a,this.parent,"editSettingsTemplate",l,null,null,s),this.parent.renderTemplates()):P(s,this.parent.getEditTemplate()(a,this.parent,"editSettingsTemplate",l));return t.updateBlazorTemplate(l,"Template",this.parent.editSettings,!0,function(){for(var e=r.parent.getColumns(),t=0;t<e.length;t++)e[t].validationRules&&(r.parent.editModule.formObj.rules[e[t].field]=e[t].validationRules)}),o.appendChild(s),o}for(var h=this.parent.createElement("table",{className:ts,attrs:{cellspacing:"6px"}}),d=this.parent.createElement(gs),p=n.getColumns(),c=0;c<p.length;c++)if(!(this.parent.editModule.checkColumnIsGrouped(p[c])||p[c].commands||p[c].commandsTemplate||"checkbox"===p[c].type)){var u=this.parent.createElement("tr"),g=this.parent.createElement("td",{className:_o,attrs:{style:"text-align:"+(this.parent.enableRtl?"right":"left")+";width:190px"}});e[p[c].uid].classList.remove("e-input"),g.appendChild(e[p[c].uid]),u.appendChild(g),d.appendChild(u)}return h.appendChild(d),s.appendChild(h),o.appendChild(s),o},i.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(gr,this.destroy),this.parent.off(Ki,this.destroy))},i}(),Xa=function(){function i(e,t){this.editType={Inline:Wa,Normal:Wa,Batch:Ka,Dialog:Qa},this.parent=e,this.serviceLocator=t,this.renderer=new this.editType[this.parent.editSettings.mode](e,t),this.focus=t.getService("focus")}return i.prototype.addNew=function(e){this.renderer.addNew(this.getEditElements(e),e),this.convertWidget(e)},i.prototype.update=function(e){this.renderer.update(this.getEditElements(e),e);e.isCustomFormValidation||(this.parent.notify("edit-form",e),this.convertWidget(e))},i.prototype.convertWidget=function(e){var i,r,n,o,s=this.parent,l=s.isFrozenGrid(),a="Right"===s.getFrozenMode()&&"Normal"===s.editSettings.mode?1:0,h="Dialog"===s.editSettings.mode?t.select("#"+s.element.id+"_dialogEdit_wrapper .e-gridform",document):s.element.getElementsByClassName("e-gridform")[a],d=l&&this.parent.enableColumnVirtualization&&e.isScroll;if(l&&"Normal"===s.editSettings.mode){var p=parseInt(e.row.getAttribute(us),10);s.frozenRows&&("add"===e.requestType&&"Top"===s.editSettings.newRowPosition||p<s.frozenRows)?(n=s.element.querySelector("."+Jo).querySelector(".e-gridform"),this.parent.getFrozenMode()===hs&&(o=e.frozenRightForm)):(n=s.element.querySelector("."+Yo).querySelector(".e-gridform"),this.parent.getFrozenMode()===hs&&(o=e.frozenRightForm))}for(var c=0,u="Batch"!==s.editSettings.mode?s.getColumns():[s.getColumnByField(e.columnName)];c<u.length;c++){var g=u[c];if(!d||"movable"===g.getFreezeTableName())if(!this.parent.editSettings.template||t.isNullOrUndefined(g.field)){if(!this.parent.editModule.checkColumnIsGrouped(g)&&!g.commands){g.valueAccessor(g.field,e.rowData,g),r="movable"===g.getFreezeTableName()&&"Normal"===s.editSettings.mode?n.querySelector("[e-mappinguid="+g.uid+"]"):o&&g.getFreezeTableName()===ds&&"Normal"===s.editSettings.mode?o.querySelector("[e-mappinguid="+g.uid+"]"):h.querySelector("[e-mappinguid="+g.uid+"]");var f=g.edit.write;t.isNullOrUndefined(r)||("string"==typeof f?(f=he(f,window))({rowData:e.rowData,element:r,column:g,requestType:e.requestType,row:e.row,foreignKeyData:g.isForeignColumn()&&he(g.field,e.foreignKeyData)}):g.edit.write({rowData:e.rowData,element:r,column:g,requestType:e.requestType,row:e.row,foreignKeyData:g.isForeignColumn()&&he(g.field,e.foreignKeyData)}),i||r.getAttribute("disabled")||D(r,"e-checkbox-disabled")||(this.focusElement(r,e.type),i=!0))}}else{var m=t.extend({},e);m.element=h.querySelector("[name="+V(g.field)+"]"),t.isNullOrUndefined(m.element)&&l&&(m.element=n.querySelector("[name="+V(g.field)+"]")),"string"==typeof g.edit.write?he(g.edit.write,window)(m):g.edit.write(m)}}if(l&&!this.parent.allowTextWrap&&("add"===e.requestType||"beginEdit"===e.requestType)&&"Dialog"!==this.parent.editSettings.mode&&!t.isNullOrUndefined(h)&&!t.isNullOrUndefined(n)){var y=n.querySelector("tr").children[0],v=h.querySelector("tr").children[0];if(v.offsetHeight>y.offsetHeight){if(y.style.height=v.offsetHeight+"px",o){n.querySelector("tr").children[0].style.height=v.offsetHeight+"px"}}else if(v.style.height=y.offsetHeight+"px",o){n.querySelector("tr").children[0].style.height=y.offsetHeight+"px"}}},i.prototype.focusElement=function(e,i){var r=this.parent.element.querySelector(".e-edit-checkselect");if(t.isNullOrUndefined(r)||r.nextElementSibling.classList.add("e-focus"),"Batch"===this.parent.editSettings.mode)this.focus.onClick({target:t.closest(e,"td")},!0);else{!this.parent.enableVirtualization||"Normal"!==this.parent.editSettings.mode||this.parent.enableVirtualization&&"Bottom"===this.parent.editSettings.newRowPosition&&D(e,os)?e.focus():e.focus({preventScroll:!0})}e.classList.contains("e-defaultcell")&&e.setSelectionRange(e.value.length,e.value.length)},i.prototype.getEditElements=function(i){var r=this.parent,n={},o="Batch"!==r.editSettings.mode?r.getColumns():[r.getColumnByField(i.columnName)];if(i.isCustomFormValidation&&(o=this.parent.columnModel),this.parent.editSettings.template)return{};for(var s=r.isFrozenGrid()&&r.enableColumnVirtualization&&i.isScroll,l=0,a=o.length;l<a;l++){var h=o[l];if(!(this.parent.editModule.checkColumnIsGrouped(h)||s&&"movable"!==o[l].getFreezeTableName()||i.isCustomFormValidation&&(h.commands||h.commandsTemplate||!h.field)))if(h.commands||h.commandsTemplate){var d=this.serviceLocator.getService("cellRendererFactory"),p=new Es(this.parent),c=d.getCellRenderer(e.CellType.CommandColumn),u=p.generateRows(i.rowData)[0].cells.filter(function(e){return e.rowID}),g=c.render(u[l],i.rowData,{index:i.row?i.row.getAttribute(us):0},this.parent.enableVirtualization);(w=g.firstElementChild).setAttribute("textAlign",g.getAttribute("textAlign")),n[h.uid]=w}else{var f={column:h,value:h.valueAccessor(h.field,i.rowData,h),type:i.requestType,data:i.rowData},m=h.edit.create,y=void 0;if(h.editTemplate){y=this.parent.createElement("span",{attrs:{"e-mappinguid":h.uid}});var v=this.parent.element.id+h.uid+"editTemplate",C=ue({},i.rowData,{column:h});if(this.parent.isReact&&"string"!=typeof h.editTemplate)h.getEditTemplate()(t.extend({index:i.rowIndex},C),this.parent,"editTemplate",v,null,null,y),this.parent.renderTemplates();else{P(y,h.getEditTemplate()(t.extend({index:i.rowIndex},C),this.parent,"editTemplate",v))}}else{if("string"==typeof(y="string"==typeof m?(m=he(m,window))(f):h.edit.create(f))){var w;(w=this.parent.createElement("div")).innerHTML=y,y=w.firstChild}var b="input"!==y.tagName&&y.querySelectorAll("input").length,S=V(h.field);t.attributes(b?y.querySelector("input"):y,{name:S,"e-mappinguid":h.uid,id:r.element.id+S}),t.classList(y,["e-input","e-field"],[]),"Right"===h.textAlign&&y.classList.add("e-ralign"),((h.isPrimaryKey||h.isIdentity)&&"beginEdit"===i.requestType||h.isIdentity&&"add"===i.requestType)&&y.setAttribute("disabled","")}n[h.uid]=y}}return n},i.prototype.destroy=function(){this.renderer.removeEventListener()},i}(),Ya=function(){function e(e){this.parent=e}return e.prototype.create=function(e){return We(this.parent,e.column,"e-field",{type:"text"})},e.prototype.read=function(e){return e.ej2_instances[0].value},e.prototype.destroy=function(){this.obj&&!this.obj.isDestroyed&&(this.removeEventHandler&&this.removeEventHandler(),this.obj.destroy())},e}(),Ja=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Za=function(e){function i(){var t=null!==e&&e.apply(this,arguments)||this;return t.activeClasses=["e-selectionbackground","e-active"],t}return Ja(i,e),i.prototype.create=function(e){var t="e-field e-boolcell";return"checkbox"===e.column.type&&(t="e-field e-boolcell e-edit-checkselect"),this.removeEventHandler=this.removeEventListener,We(this.parent,e.column,t,{type:"checkbox",value:e.value})},i.prototype.read=function(e){return e.checked},i.prototype.write=function(e){var i,r;if(t.isNullOrUndefined(e.row)||(i=e.row.querySelector(".e-edit-checkselect")),he(e.column.field,e.rowData)&&(r=JSON.parse(he(e.column.field,e.rowData).toString().toLowerCase())),!t.isNullOrUndefined(i)&&"checkbox"===e.column.type){if(this.editType=this.parent.editSettings.mode,this.editRow=e.row,"add"!==e.requestType){var o=this.parent.getRowObjectFromUID(e.row.getAttribute("data-uid"));r=!!o&&o.isSelected}X.apply(void 0,[[].slice.call(e.row.getElementsByClassName(_o)),r].concat(this.activeClasses))}this.obj=new n.CheckBox(t.extend({label:"Dialog"!==this.parent.editSettings.mode?" ":e.column.headerText,checked:r,disabled:!_(e.column,e.requestType,e.element),enableRtl:this.parent.enableRtl},e.column.edit.params)),this.addEventListener(),this.obj.appendTo(e.element)},i.prototype.addEventListener=function(){this.cbChange=this.checkBoxChange.bind(this),this.obj.addEventListener(ys,this.cbChange)},i.prototype.removeEventListener=function(){this.obj.isDestroyed||this.obj.removeEventListener(ys,this.cbChange)},i.prototype.checkBoxChange=function(e){if(this.editRow&&"Dialog"!==this.editType){var t=!1;e.checked?(t=!0,this.editRow.setAttribute("aria-selected",t.toString())):this.editRow.removeAttribute("aria-selected"),X.apply(void 0,[[].slice.call(this.editRow.getElementsByClassName(_o)),t].concat(this.activeClasses))}},i}(Ya),$a=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),eh=function(e){function r(t){var i=e.call(this)||this;return i.parent=t,i.flag=!1,i.removeEventHandler=i.removeEventListener,i}return $a(r,e),r.prototype.write=function(e){var r="Dialog"!==this.parent.editSettings.mode;this.column=e.column;var n=new i.Predicate(e.column.field,"notequal",null,!0,!1),o={};if(e.column.edit.params)for(var l=Object.keys(e.column.edit.params),a=0;a<l.length;a++)o[l[a]]="query"===l[a]?e.column.edit.params[l[a]].clone():e.column.edit.params[l[a]];this.obj=new s.DropDownList(t.extend({dataSource:this.parent.dataSource instanceof i.DataManager?this.parent.dataSource:new i.DataManager(this.parent.dataSource),query:(new i.Query).where(n).select(e.column.field),enabled:_(e.column,e.requestType,e.element),fields:{value:e.column.field},value:he(e.column.field,e.rowData),enableRtl:this.parent.enableRtl,placeholder:r?"":e.column.headerText,popupHeight:"200px",floatLabelType:r?"Never":"Always",sortOrder:"Ascending"},o)),this.parent.enableVirtualization&&(this.obj.dataSource=e.column.isForeignColumn()?[e.foreignKeyData[0]]:[e.rowData]),this.addEventListener(),this.obj.query.params=this.parent.query.params,this.obj.appendTo(e.element),e.element.setAttribute("name",V(e.column.field))},r.prototype.addEventListener=function(){this.ddCreated=this.dropdownCreated.bind(this),this.ddOpen=this.dropDownOpen.bind(this),this.ddBeforeOpen=this.dropdownBeforeOpen.bind(this),this.ddComplete=this.ddActionComplete.bind(this),this.obj.addEventListener(Cs,this.ddCreated),this.obj.addEventListener(ms,this.ddOpen),this.obj.addEventListener(ws,this.ddBeforeOpen),this.obj.addEventListener(Dt,this.ddComplete)},r.prototype.removeEventListener=function(){this.obj.isDestroyed||(this.obj.removeEventListener(Cs,this.ddCreated),this.obj.removeEventListener(ms,this.ddOpen),this.obj.removeEventListener(ws,this.ddBeforeOpen),this.obj.removeEventListener(Dt,this.ddComplete))},r.prototype.dropdownCreated=function(e){this.flag=!0},r.prototype.dropdownBeforeOpen=function(){this.parent.enableVirtualization&&(this.obj.dataSource=this.column.isForeignColumn()?this.column.dataSource instanceof i.DataManager?this.column.dataSource:new i.DataManager(this.column.dataSource):this.parent.dataSource instanceof i.DataManager?this.parent.dataSource:new i.DataManager(this.parent.dataSource))},r.prototype.ddActionComplete=function(e){e.result=i.DataUtil.distinct(e.result,this.obj.fields.value,!0),this.flag&&this.column.dataSource&&!this.column.edit.params.ddEditedData&&("result"in this.column.dataSource?this.column.dataSource.result=e.result:this.column.dataSource instanceof i.DataManager&&(this.column.dataSource.dataSource.json=e.result)),this.flag=!1},r.prototype.dropDownOpen=function(e){var i=D(this.obj.element,"e-dialog");if("Dialog"===this.parent.editSettings.mode&&!t.isNullOrUndefined(i)){var r=t.select("#"+i.id,document).ej2_instances[0];e.popup.element.style.zIndex=(r.zIndex+1).toString()}},r}(Ya),th=function(){function e(e){this.parent=e}return e.prototype.keyEventHandler=function(e){if(13===e.keyCode||9===e.keyCode){var t=document.createEvent("HTMLEvents");t.initEvent("change",!1,!0),this.dispatchEvent(t)}},e.prototype.create=function(e){return this.instances=new t.Internationalization(this.parent.locale),We(this.parent,e.column,"e-field",{})},e.prototype.read=function(e){return this.obj.value},e.prototype.write=function(e){var i=e.column,r="Dialog"!==this.parent.editSettings.mode;this.obj=new o.NumericTextBox(t.extend({value:parseFloat(he(e.column.field,e.rowData)),enableRtl:this.parent.enableRtl,placeholder:r?"":e.column.headerText,enabled:_(e.column,e.requestType,e.element),floatLabelType:"Dialog"!==this.parent.editSettings.mode?"Never":"Always",locale:this.parent.locale},i.edit.params)),e.element.setAttribute("name",V(e.column.field)),this.obj.appendTo(e.element),this.obj.element.addEventListener("keydown",this.keyEventHandler)},e.prototype.destroy=function(){this.obj&&!this.obj.isDestroyed&&(this.obj.element.removeEventListener("keydown",this.keyEventHandler),this.obj.destroy())},e}(),ih=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),rh=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return ih(i,e),i.prototype.create=function(e){var i={type:"text",value:t.isNullOrUndefined(e.value)?"":e.value,style:"text-align:"+e.column.textAlign};return We(this.parent,e.column,"e-field e-input e-defaultcell",i)},i.prototype.read=function(e){return e.value},i.prototype.write=function(e){var i=e.column,r="Dialog"!==this.parent.editSettings.mode;this.obj=new o.TextBox(t.extend({element:e.element,floatLabelType:"Dialog"!==this.parent.editSettings.mode?"Never":"Always",enableRtl:this.parent.enableRtl,enabled:_(e.column,e.requestType,e.element),placeholder:r?"":e.column.headerText},i.edit.params)),this.obj.appendTo(e.element)},i}(Ya),nh=function(){function e(e,t,i){this.args={},this.currentVirtualData={},this.parent=e,this.renderer=i,this.serviceLocator=t,this.addEventListener()}return e.prototype.clickHandler=function(e){var t=e.target,i=this.parent;(D(t,Ko)&&D(D(t,Ko),"e-grid").id===i.element.id||i.frozenRows&&D(t,Xo))&&!D(t,"e-unboundcelldiv")&&(this.rowIndex=D(t,_o)?parseInt(t.parentElement.getAttribute(us),10):-1,i.isEdit&&i.editModule.endEdit())},e.prototype.dblClickHandler=function(e){D(e.target,_o)&&this.parent.editSettings.allowEditOnDblClick&&this.parent.editModule.startEdit(D(e.target,is))},e.prototype.editComplete=function(e){this.parent.isEdit=!1;switch(e.requestType){case"save":(this.parent.isCheckBoxSelection||"Multiple"===this.parent.selectionSettings.type)&&this.parent.isPersistSelection||"edit"!==e.action&&this.parent.selectRow(0),this.parent.trigger(Dt,t.extend(e,{requestType:"save",type:Dt}));break;case"delete":this.parent.trigger(Dt,t.extend(e,{requestType:"delete",type:Dt})),this.parent.isCheckBoxSelection||this.parent.selectRow(this.editRowIndex)}},e.prototype.getEditArgs=function(e,t,i){for(var r=this.parent.getPrimaryKeyFieldNames(),n=[],o=0;o<r.length;o++)n.push(he(r[o],e));return{primaryKey:r,primaryKeyValue:n,requestType:"beginEdit",rowData:e,rowIndex:this.rowIndex,type:"edit",cancel:!1,foreignKeyData:t&&t.foreignKeyData,target:void 0,isScroll:i}},e.prototype.startEdit=function(e){var i=this,r=this.parent;if(this.rowIndex=this.editRowIndex=parseInt(e.getAttribute(us),10),r.enableVirtualization||r.enableInfiniteScrolling){var n='.e-row[aria-rowindex="'+this.rowIndex+'"]';if(!this.parent.element.querySelector(n))return}var o={data:void 0,index:this.rowIndex,isScroll:!1};if(this.parent.notify(Sn,o),ae(r)){var s=r.getRowObjectFromUID(e.getAttribute("data-uid"));this.previousData=s.data}else this.previousData||!this.parent.enableVirtualization&&!this.parent.enableInfiniteScrolling?this.parent.enableVirtualization||(this.previousData=t.extend({},{},r.getCurrentViewRecords()[this.rowIndex],!0)):this.previousData=o.data;var l=t.extend({},{},o.data||this.previousData,!0);this.uid=e.getAttribute("data-uid");var a=r.getRowObjectFromUID(this.uid),h=this.getEditArgs(l,a,o.isScroll);h.row=e,h.isScroll?this.inlineEditHandler(h,e):(this.parent.notify(Mo,{uid:this.uid,prevData:this.previousData,argsCreator:this.getEditArgs.bind(this),renderer:this.renderer}),r.trigger("beginEdit",h,function(t){t.type="actionBegin",r.trigger(zt,t,function(t){t.cancel||i.inlineEditHandler(t,e)})}))},e.prototype.inlineEditHandler=function(e,t){var i=this.parent;i.isEdit=!0,e.row=e.row?e.row:t,"Dialog"!==i.editSettings.mode&&i.clearSelection(),"Dialog"===i.editSettings.mode&&i.selectionModule&&(i.selectionModule.preventFocus=!0,e.row.classList.add("e-dlgeditrow")),this.renderer.update(e),this.uid=t.getAttribute("data-uid"),i.editModule.applyFormValidation(),e.type="actionComplete",i.trigger(Dt,e),this.args=e,this.parent.allowTextWrap&&this.parent.notify(zr,{case:"textwrap"})},e.prototype.updateRow=function(e,t){var i=this,r=this.parent;this.editRowIndex=e;var n={requestType:"save",action:"edit",type:zt,data:t,cancel:!1,previousData:r.getCurrentViewRecords()[e],row:r.getRowByIndex(e)};if(r.showSpinner(),r.enableInfiniteScrolling){this.uid=n.row.getAttribute("data-uid");var o=parseInt(n.row.getAttribute("aria-rowindex"));this.parent.notify(Po,{index:o})}r.notify(dr,n),n.promise?n.promise.then(function(){return r.refresh()}).catch(function(e){return i.edFail(e)}):r.enableInfiniteScrolling||r.refresh()},e.prototype.editFormValidate=function(){var e=this.parent,t=e.editModule.editFormValidate(),i={prevData:this.previousData,isValid:!0,editIdx:this.editRowIndex,addIdx:this.addedRowIndex};return e.notify(Oo,i),t&&i.isValid},e.prototype.endEdit=function(){var e=this.parent;if(this.parent.isEdit&&this.editFormValidate()){var i=t.extend({},{},this.previousData,!0),r=t.extend(this.args,{requestType:"save",type:zt,data:i,cancel:!1,previousData:this.previousData,selectedRow:e.selectedRowIndex,foreignKeyData:{}}),n="Right"===e.getFrozenMode()?1:0,o="Dialog"===e.editSettings.mode,s=t.select("#"+e.element.id+"_dialogEdit_wrapper",document),l=o?s.querySelector(".e-gridform"):e.element.getElementsByClassName("e-gridform")[n],a={virtualData:t.extend({},{},this.previousData,!0),isAdd:!1,isScroll:!1,endEdit:!0};if(this.parent.notify(zn,a),(this.parent.enableVirtualization||this.parent.enableInfiniteScrolling)&&"Normal"===this.parent.editSettings.mode&&Object.keys(a.virtualData).length?this.parent.isEdit&&(this.currentVirtualData=i=r.data=a.virtualData):i=e.editModule.getCurrentEditedData(l,i),e.isFrozenGrid()&&"Normal"===e.editSettings.mode){var h=e.getMovableVirtualHeader().querySelector(".e-gridform"),d=e.getMovableVirtualContent().querySelector(".e-gridform"),p=[h||d],c=void 0,u=void 0,g=[];e.getFrozenMode()===hs&&(c=e.getFrozenRightHeader().querySelector(".e-gridform"),u=e.getFrozenRightContent().querySelector(".e-gridform"),g=[c||u]),Me(this.parent,function(t,r){for(var n=0,o=r;n<o.length;n++){var s=o[n];s&&(i=e.editModule.getCurrentEditedData(s,i))}},[[],p,g])}var f=[].slice.call(e.element.getElementsByClassName(ns)).length;if(a.isAdd||!Object.keys(this.currentVirtualData).length||f||(f=1),o?s.getElementsByClassName(ns).length:f)r.action="edit",e.trigger(zt,r,function(t){t.cancel||(e.showSpinner(),e.notify(dr,t))});else if(r.action="add",r.selectedRow=0,r.index=this.addedRowIndex,e.notify(Rn,{}),e.notify(Ti,r),this.addedRowIndex=null,r.cancel)return}},e.prototype.destroyElements=function(){var e=this.parent;e.editModule.destroyWidgets(),e.editModule.destroyForm(),this.parent.notify(gr,{})},e.prototype.editHandler=function(e){var t=this;e.promise?e.promise.then(function(i){return t.edSucc(i,e)}).catch(function(e){return t.edFail(e)}):this.editSuccess(e.data,e)},e.prototype.edSucc=function(e,t){this.editSuccess(e,t)},e.prototype.edFail=function(e){this.editFailure(e)},e.prototype.updateCurrentViewData=function(e){this.parent.enableVirtualization||this.parent.enableInfiniteScrolling||(this.parent.getCurrentViewRecords()[this.editRowIndex]=e)},e.prototype.requestSuccess=function(e){this.parent.editModule.formObj&&!this.parent.editModule.formObj.isDestroyed&&(this.destroyElements(),this.stopEditStatus(),"Dialog"===this.parent.editSettings.mode&&"add"!==e.action&&this.parent.selectionModule&&this.parent.element.querySelector(".e-dlgeditrow").classList.remove("e-dlgeditrow"))},e.prototype.editSuccess=function(e,i){if(!(t.isNullOrUndefined(e)||e instanceof Array)){i.data=t.extend({},t.extend({},i.rowData,i.data),e)}this.requestSuccess(i),this.parent.trigger(ai,i),i.type=Dt,this.parent.isEdit=!1,this.refreshRow(i.data),this.parent.notify(Rn,i),this.parent.editModule.checkLastRow(i.row),this.parent.editModule.isLastRow=!1,this.updateCurrentViewData(i.data),this.blazorTemplate(),this.editRowIndex=null,this.parent.trigger(Dt,i),(!this.parent.isCheckBoxSelection&&"Multiple"!==this.parent.selectionSettings.type||!this.parent.isPersistSelection&&!this.parent.selectionSettings.checkboxOnly)&&"Dialog"!==this.parent.editSettings.mode&&this.parent.selectRow(this.rowIndex>-1?this.rowIndex:this.editRowIndex),this.parent.hideSpinner()},e.prototype.closeForm=function(){!this.cloneRow&&this.parent.isEdit&&this.stopEditStatus(),this.cloneRow&&(this.cloneRow.remove(),this.cloneRow=null,this.originalRow.classList.remove("e-hiddenrow")),this.parent.isFrozenGrid()&&this.cloneFrozen&&(this.cloneFrozen.remove(),this.frozen.classList.remove("e-hiddenrow"))},e.prototype.blazorTemplate=function(){var e=this.parent.getColumns();this.parent.editSettings.template&&"Normal"===this.parent.editSettings.mode&&t.updateBlazorTemplate(this.parent.element.id+"editSettingsTemplate","Template",this.parent.editSettings);for(var i=0;i<e.length;i++){var r=e[i];r.template&&t.updateBlazorTemplate(this.parent.element.id+r.uid,"Template",r,!1),r.editTemplate&&t.updateBlazorTemplate(this.parent.element.id+r.uid+"editTemplate","EditTemplate",r)}},e.prototype.editFailure=function(e){this.parent.trigger(Mt,{error:e}),this.parent.hideSpinner(),this.parent.log("actionfailure",{error:e})},e.prototype.needRefresh=function(){var e=!0,t=this.parent.element.querySelector(".e-gridform");return!this.parent.enableVirtualization&&!this.parent.infiniteScrollSettings.enableCache||"Normal"!==this.parent.editSettings.mode||t||(e=!1),e},e.prototype.refreshRow=function(e){var t=this.parent.isFrozenGrid(),i=new Fs(this.serviceLocator,null,this.parent),r=this.parent.getRowObjectFromUID(this.uid);if(r){r.changes=e,this.parent.notify(En,{data:e}),re(r,this.parent.getForeignKeyColumns(),r.changes),this.needRefresh()&&i.refresh(r,this.parent.getColumns(),!0);var n=[].slice.call(this.parent.element.querySelectorAll('[aria-rowindex="'+r.index+'"]'));if(t&&n.length)for(var o=0;o<n.length;o++){var s=n[o].getAttribute("data-uid");s!==this.uid&&((r=this.parent.getRowObjectFromUID(s)).changes=e,i.refresh(r,this.parent.getColumns(),!0),this.parent.editModule.checkLastRow(n[o]))}}},e.prototype.closeEdit=function(){var e=this;if(this.parent.isEdit){var i=this.parent,r=t.extend(this.args,{requestType:"cancel",type:zt,cancel:!1,data:this.previousData,selectedRow:i.selectedRowIndex});i.notify(xn,r),this.blazorTemplate(),i.trigger(zt,r,function(t){if(!t.cancel){"Dialog"===e.parent.editSettings.mode&&e.parent.notify(gr,{}),i.isEdit=!1,e.stopEditStatus(),t.type=Dt,"Dialog"!==i.editSettings.mode&&e.refreshRow(t.data);var r=i.groupSettings.enableLazyLoading&&i.groupSettings.columns.length&&!i.getContentTable().querySelector("tr.e-emptyrow");i.getContentTable().querySelector("tr.e-emptyrow")||i.getContentTable().querySelector("tr.e-row")||r||i.renderModule.emptyRow(),"Dialog"!==i.editSettings.mode&&i.selectRow(e.rowIndex),i.trigger(Dt,t)}})}},e.prototype.addRecord=function(e,r){var n=this,o=this.parent;if(this.addedRowIndex=r=t.isNullOrUndefined(r)?0:r,e)o.notify(Ti,{requestType:"save",type:zt,data:e,selectedRow:0,action:"add",index:r});else if(!o.isEdit){this.previousData={},this.uid="";var s=o.getColumns(),l={virtualData:{},isScroll:!1};this.parent.notify(zn,l);for(var a=0;a<s.length;a++)l.isScroll&&"movable"!==s[a].getFreezeTableName()||s[a].field&&i.DataUtil.setValue(s[a].field,s[a].defaultValue,this.previousData);var h={cancel:!1,foreignKeyData:{},requestType:"add",data:this.previousData,type:zt,index:r,rowData:this.previousData,target:void 0,isScroll:l.isScroll};(this.parent.enableVirtualization||this.parent.infiniteScrollSettings.enableCache)&&Object.keys(l.virtualData).length&&(h.data=h.rowData=l.virtualData),h.isScroll?this.inlineAddHandler(h):(this.parent.notify(Mo,{uid:this.uid,prevData:this.previousData,argsCreator:this.getEditArgs.bind(this),renderer:this.renderer}),o.trigger(zt,h,function(e){e.cancel||n.inlineAddHandler(e)}))}},e.prototype.inlineAddHandler=function(e){var t=this.parent;t.isEdit=!0,"Dialog"!==t.editSettings.mode&&t.clearSelection(),this.renderer.addNew(e),t.editModule.applyFormValidation(),e.type=Dt,e.row=t.element.querySelector("."+os),t.trigger(Dt,e),this.args=e},e.prototype.deleteRecord=function(e,i){if(this.editRowIndex=this.parent.selectedRowIndex,i){i=i instanceof Array?i:[i];var r=this.parent,n=Object.keys(i).length;e=e||this.parent.getPrimaryKeyFieldNames()[0];for(var o=function(t){var n,o,s=r.currentViewData.some(function(r){return o=r,i[t]===he(e,r)||i[t]===r});i[t]=s?o:i[t][e]?i[t]:(n={},n[e]=i[t],n)},s=0;s<n;s++)o(s)}var l={requestType:"delete",type:zt,foreignKeyData:{},data:i||this.parent.getSelectedRecords(),tr:this.parent.getSelectedRows(),cancel:!1};if(t.isNullOrUndefined(this.parent.commandDelIndex)||(l.data[0]=this.parent.getRowObjectFromUID(this.parent.getRowByIndex(this.parent.commandDelIndex).getAttribute("data-uid")).data),this.parent.enableVirtualization&&l.data.length>1){var a=this.parent.getSelectedRows()[0].getAttribute("data-uid");l.data=[this.parent.getRowObjectFromUID(a).data]}this.parent.notify(Ti,l)},e.prototype.stopEditStatus=function(){for(var e=this.parent,i=[].slice.call(e.element.getElementsByClassName(os)),r=[].slice.call(e.element.getElementsByClassName(ns)),n=0;n<i.length;n++)t.remove(i[n]);for(n=0;n<r.length;n++)r[n].classList.remove(ns)},e.prototype.addEventListener=function(){this.parent.isDestroyed||(this.evtHandlers=[{event:fr,handler:this.editHandler},{event:vr,handler:this.dblClickHandler},{event:Wi,handler:this.clickHandler},{event:Qr,handler:this.requestSuccess},{event:or,handler:this.dblClickHandler},{event:cr,handler:this.editComplete},{event:pr,handler:this.editComplete},{event:wo,handler:this.closeEdit},{event:"closeinline",handler:this.closeForm}],_e(this.parent,this.evtHandlers,!0,this))},e.prototype.removeEventListener=function(){this.parent.isDestroyed||_e(this.parent,this.evtHandlers,!1)},e.prototype.destroy=function(){this.removeEventListener(),this.renderer.destroy()},e}(),oh=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),sh=function(e){function t(t,i,r){var n=e.call(this,t,i)||this;return n.parent=t,n.serviceLocator=i,n.renderer=r,n}return oh(t,e),t.prototype.closeEdit=function(){e.prototype.closeEdit.call(this)},t.prototype.addRecord=function(t,i){e.prototype.addRecord.call(this,t,i)},t.prototype.endEdit=function(){e.prototype.endEdit.call(this)},t.prototype.updateRow=function(t,i){e.prototype.updateRow.call(this,t,i)},t.prototype.deleteRecord=function(t,i){e.prototype.deleteRecord.call(this,t,i)},t.prototype.startEdit=function(t){e.prototype.startEdit.call(this,t)},t}(nh),lh=function(){function r(e,t,i){this.cellDetails={},this.originalCell={},this.cloneCell={},this.editNext=!1,this.preventSaveCell=!1,this.parent=e,this.serviceLocator=t,this.renderer=i,this.focus=t.getService("focus"),this.addEventListener()}return r.prototype.addEventListener=function(){this.parent.isDestroyed||(this.evtHandlers=[{event:Wi,handler:this.clickHandler},{event:or,handler:this.dblClickHandler},{event:Vi,handler:this.onBeforeCellFocused},{event:Gi,handler:this.onCellFocused},{event:vr,handler:this.dblClickHandler},{event:_i,handler:this.keyDownHandler},{event:Yr,handler:this.editNextValCell},{event:"closebatch",handler:this.closeForm},{event:Ki,handler:this.destroy}],_e(this.parent,this.evtHandlers,!0,this),this.dataBoundFunction=this.dataBound.bind(this),this.batchCancelFunction=this.batchCancel.bind(this),this.parent.addEventListener(Ot,this.dataBoundFunction),this.parent.addEventListener(ii,this.batchCancelFunction))},r.prototype.removeEventListener=function(){this.parent.isDestroyed||(_e(this.parent,this.evtHandlers,!1),this.parent.removeEventListener(Ot,this.dataBoundFunction),this.parent.removeEventListener(ii,this.batchCancelFunction))},r.prototype.batchCancel=function(){this.parent.focusModule.restoreFocus()},r.prototype.dataBound=function(){this.parent.notify(sr,{})},r.prototype.destroy=function(){this.removeEventListener()},r.prototype.clickHandler=function(e){D(e.target,this.parent.element.id+"_add",!0)||(this.parent.isEdit&&t.closest(this.form,"td")!==t.closest(e.target,"td")&&(this.saveCell(),this.editNextValCell()),D(e.target,_o)&&!this.parent.isEdit&&this.setCellIdx(e.target))},r.prototype.dblClickHandler=function(e){var i=D(e.target,_o),r=D(e.target,is),n=r&&parseInt(r.getAttribute(us),10),o=i&&parseInt(i.getAttribute(cs),10);t.isNullOrUndefined(i)||t.isNullOrUndefined(n)||isNaN(o)||i.parentElement.classList.contains(ns)||this.editCell(n,this.parent.getColumns()[o].field,this.isAddRow(n))},r.prototype.onBeforeCellFocused=function(e){this.parent.isEdit&&this.validateFormObj()&&(e.byClick||["tab","shiftTab","enter","shiftEnter"].indexOf(e.keyArgs.action)>-1)&&(e.cancel=!0,e.byClick?e.clickArgs.preventDefault():e.keyArgs.preventDefault())},r.prototype.onCellFocused=function(e){var t=this.parent.getFrozenLeftCount(),i=this.parent.getFrozenRightColumnsCount(),r=this.parent.getContent().querySelector("."+Yo),n=this.parent.getHeaderContent().querySelector("."+Jo),o=!(e.container.isContent&&e.container.isDataCell||this.parent.frozenRows&&e.container.isHeader);if(e.byKey&&!o){var s=e.container.indexes,l=s[0],a=s[1];if(t&&(r.contains(e.element)||this.parent.frozenRows&&n.contains(e.element))&&(a+=t),i){var h=this.parent.getHeaderContent().querySelector(".e-frozen-right-header");(this.parent.getContent().querySelector(".e-frozen-right-content").contains(e.element)||this.parent.frozenRows&&h.contains(e.element))&&(a+=t+this.parent.getMovableColumnsCount())}this.parent.frozenRows&&e.container.isContent&&(l+=this.parent.frozenRows);var d=this.parent.isEdit;if(!this.parent.element.getElementsByClassName("e-popup-open").length)switch(d=d&&!this.validateFormObj(),e.keyArgs.action){case"tab":case"shiftTab":var p=this.parent.getColumns()[e.indexes[1]];p&&!this.parent.isEdit&&this.editCell(e.indexes[0],p.field),(d||this.parent.isLastCellPrimaryKey)&&this.editCellFromIndex(l,a);break;case"enter":case"shiftEnter":e.keyArgs.preventDefault();var c={cancel:!1,keyArgs:e.keyArgs};this.parent.notify("beforeFocusCellEdit",c),!c.cancel&&d&&this.editCell(l,this.cellDetails.column.field);break;case"f2":this.editCellFromIndex(l,a),this.focus.focus()}}else this.parent.isEdit&&o&&this.saveCell()},r.prototype.isAddRow=function(e){return this.parent.getDataRows()[e].classList.contains("e-insertedrow")},r.prototype.editCellFromIndex=function(e,t){this.cellDetails.rowIndex=e,this.cellDetails.cellIndex=t,this.editCell(e,this.parent.getColumns()[t].field,this.isAddRow(e))},r.prototype.closeEdit=function(){var e=this,t=this.parent,i=this.parent.getRowsObject(),r={cancel:!1,batchChanges:this.getBatchChanges()};if(t.notify(sn,r),!r.cancel){t.isEdit&&this.saveCell(!0),this.isAdded=!1,t.clearSelection();for(var n,o=Oe(this.parent),s=function(t){var r=!1,s=i[t].isDirty;Me(l.parent,function(i,n){(r=e.removeBatchElementChanges(n[t],s))&&n.splice(t,1)},o),r&&t--,n=t},l=this,a=0;a<i.length;a++)s(a),a=n;t.getContentTable().querySelector("tr.e-row")||t.renderModule.renderEmptyRow();var h={requestType:"batchCancel",rows:this.parent.getRowsObject()};t.notify(ii,{rows:this.parent.getRowsObject().length?this.parent.getRowsObject():[new jo({isDataRow:!0,cells:[new Vo({isDataCell:!0,visible:!0})]})]}),t.selectRow(this.cellDetails.rowIndex),this.refreshRowIdx(),t.notify(sr,{}),this.parent.notify(hr,{}),h={requestType:"batchCancel",rows:this.parent.getRowsObject()},t.trigger(ii,h)}},r.prototype.removeBatchElementChanges=function(e,i){var r=this.parent,n=new Fs(this.serviceLocator,null,this.parent),o=!1;if(i){e.isDirty=i;var s=r.getRowElementByUID(e.uid);if(s&&(s.classList.contains("e-insertedrow")?(t.remove(s),o=!0):(re(e,this.parent.getForeignKeyColumns(),e.data),delete e.changes,delete e.edit,e.isDirty=!1,t.classList(s,[],["e-hiddenrow","e-updatedtd"]),n.refresh(e,r.getColumns(),!1)),this.parent.aggregates.length>0)){var l=[];l.type="cancel",this.parent.notify(Hi,l),this.parent.groupSettings.columns.length>0&&this.parent.notify(qi,l)}}return o},r.prototype.removeHideAndSelection=function(e){if(e.classList.contains("e-hiddenrow")){e.removeAttribute("aria-selected");for(var i=[].slice.call(e.getElementsByClassName("e-selectionbackground")),r=0;r<i.length;r++)t.removeClass([i[r]],["e-selectionbackground","e-active"])}t.classList(e,[],["e-hiddenrow","e-updatedtd"])},r.prototype.deleteRecord=function(e,t){this.saveCell(),this.validateFormObj()&&this.saveCell(!0),this.isAdded=!1,this.bulkDelete(e,t),this.parent.aggregates.length>0&&(this.parent.notify(Hi,{}),this.parent.groupSettings.columns.length>0&&this.parent.notify(qi,{}))},r.prototype.addRecord=function(e){this.bulkAddRow(e)},r.prototype.endEdit=function(){this.parent.isEdit&&this.validateFormObj()||this.batchSave()},r.prototype.closeForm=function(){for(var e=0;e<Object.keys(this.originalCell).length;e++)for(var t=0;t<Object.keys(this.cloneCell).length;t++)Object.keys(this.originalCell)[e]===Object.keys(this.cloneCell)[t]&&(this.cloneCell[Object.keys(this.cloneCell)[t]].replaceWith(this.originalCell[Object.keys(this.originalCell)[e]]),this.originalCell[Object.keys(this.originalCell)[e]].classList.contains("e-selectionbackground")&&this.originalCell[Object.keys(this.originalCell)[e]].classList.remove("e-selectionbackground","e-cellselectionbackground","e-active"));this.cloneCell={},this.originalCell={}},r.prototype.validateFormObj=function(){return this.parent.editModule.formObj&&!this.parent.editModule.formObj.validate()},r.prototype.batchSave=function(){var e=this.parent;if(e.isCheckBoxSelection){var i=e.element.querySelector(".e-checkselectall").parentElement;i.classList.contains("e-checkbox-disabled")&&e.pageSettings.totalRecordsCount>e.currentViewData.length&&t.removeClass([i],["e-checkbox-disabled"])}if(this.saveCell(),!(e.isEdit||this.editNextValCell()||e.isEdit)){var r=this.getBatchChanges();"Multiple"===this.parent.selectionSettings.type&&r.deletedRecords.length&&this.parent.selectionSettings.persistSelection&&(r.deletedRecords=this.removeSelectedData,this.removeSelectedData=[]);var n={changedRecords:this.parent.getRowsObject().filter(function(e){return e.isDirty&&-1===["add","delete"].indexOf(e.edit)}).map(function(e){return e.data})},o={batchChanges:r,cancel:!1};e.trigger(si,o,function(t){t.cancel||(e.showSpinner(),e.notify(lr,{changes:r,original:n}))})}},r.prototype.getBatchChanges=function(){for(var e={addedRecords:[],deletedRecords:[],changedRecords:[]},t=0,i=this.parent.getRowsObject();t<i.length;t++){var r=i[t];if(r.isDirty)switch(r.edit){case"add":e.addedRecords.push(r.changes);break;case"delete":e.deletedRecords.push(r.data);break;default:e.changedRecords.push(r.changes)}}return e},r.prototype.removeRowObjectFromUID=function(e){for(var t=this.parent.getRowsObject(),i=0,r=t.length;i<r&&t[i].uid!==e;i++);Me(this.parent,function(e,t){t.splice(i,1)},Oe(this.parent))},r.prototype.addRowObject=function(e){var t=this.parent,i="Top"===t.editSettings.newRowPosition;Me(this.parent,function(r,n){var o=e.clone();o.cells=De(t,o.cells,r),i?n.unshift(o):n.push(o)},Oe(this.parent),!0)},r.prototype.bulkDelete=function(e,i){var r=this;this.removeSelectedData=[];var n=this.parent,o=n.selectedRowIndex,s=n.getSelectedRows(),l={primaryKey:this.parent.getPrimaryKeyFieldNames(),rowIndex:o,rowData:i||n.getSelectedRecords()[0],cancel:!1};l.row=i?n.editModule.deleteRowUid?n.getRowElementByUID(n.editModule.deleteRowUid):n.getRows()[n.getCurrentViewRecords().indexOf(i)]:i?n.getRows()[o]:s[0],l.row&&n.trigger(oi,l,function(e){if(!e.cancel){if(r.removeSelectedData=n.getSelectedRecords(),n.clearSelection(),e.row=e.row?e.row:i?n.getRows()[o]:s[0],r.parent.isFrozenGrid()){i&&(o=parseInt(e.row.getAttribute(us),10),(s=[]).push(n.getRowByIndex(o)),s.push(n.getMovableRowByIndex(o)),n.getFrozenMode()===hs&&s.push(n.getFrozenRightRowByIndex(o)));for(var l=0;l<s.length;l++){var a=s[l].getAttribute("data-uid");if(s[l].classList.contains("e-insertedrow"))r.removeRowObjectFromUID(a),t.remove(s[l]);else{(p=n.getRowObjectFromUID(a)).isDirty=!0,p.edit="delete",t.classList(s[l],["e-hiddenrow","e-updatedtd"],[]),n.frozenRows&&o<n.frozenRows&&n.getMovableDataRows().length>=n.frozenRows&&(n.getMovableHeaderTbody().appendChild(n.getMovableRowByIndex(n.frozenRows-1)),n.getFrozenHeaderTbody().appendChild(n.getRowByIndex(n.frozenRows-1)),n.getFrozenMode()===hs&&n.getFrozenRightHeaderTbody().appendChild(n.getFrozenRightRowByIndex(n.frozenRows-1))),n.frozenRows&&o<n.frozenRows&&n.getDataRows().length>=n.frozenRows&&n.getHeaderTable().querySelector(gs).appendChild(n.getRowByIndex(n.frozenRows-1))}delete s[l]}}else if(r.parent.isFrozenGrid()||1!==s.length&&!i)for(l=0;l<s.length;l++){var h=s[l].getAttribute("data-uid");if(s[l].classList.contains("e-insertedrow"))r.removeRowObjectFromUID(h),t.remove(s[l]);else{t.classList(s[l],["e-hiddenrow","e-updatedtd"],[]);var d=n.getRowObjectFromUID(h);d.isDirty=!0,d.edit="delete",delete s[l]}}else{a=e.row.getAttribute("data-uid");if(a=i&&r.parent.editModule.deleteRowUid?a=r.parent.editModule.deleteRowUid:a,e.row.classList.contains("e-insertedrow"))r.removeRowObjectFromUID(a),t.remove(e.row);else{var p;(p=n.getRowObjectFromUID(a)).isDirty=!0,p.edit="delete",t.classList(e.row,["e-hiddenrow","e-updatedtd"],[])}delete e.row}r.refreshRowIdx(),i&&(n.editModule.deleteRowUid=void 0,n.getSelectedRows().length&&(o=parseInt(n.getSelectedRows()[0].getAttribute(us),10))),n.isCheckBoxSelection||n.selectRow(o),n.trigger(ri,e),n.notify(ri,{rows:r.parent.getRowsObject()}),n.notify(sr,{})}})},r.prototype.refreshRowIdx=function(){for(var e,t=this.parent.getAllDataRows(!0),i=ke(this.parent),r=Oe(this.parent),n=function(n,s,l){t[n].classList.contains(is)&&!t[n].classList.contains("e-hiddenrow")?(Me(o.parent,function(e,t,i){t[n].setAttribute(us,s.toString()),i[n].index=s},i,null,r),s++):Me(o.parent,function(e,t,i){t[n].removeAttribute(us),i[n].index=-1},i,null,r),e=s},o=this,s=0,l=0,a=t.length;s<a;s++)n(s,l),l=e},r.prototype.getIndexFromData=function(e){return O(e,this.parent.getCurrentViewRecords())},r.prototype.bulkAddRow=function(i){var r=this,n=this.parent;if(n.editSettings.allowAdding&&(n.isEdit&&(this.saveCell(),this.parent.notify(Yr,{})),!n.isEdit)){this.parent.element.classList.add("e-editing");var o={defaultData:i||this.getDefaultData(),primaryKey:n.getPrimaryKeyFieldNames(),cancel:!1};n.trigger(ni,o,function(o){if(!o.cancel){r.isAdded=!0,n.clearSelection();for(var s,l,a,h,d=new Fs(r.serviceLocator,null,r.parent),p=new Es(r.parent).generateRows([o.defaultData]),c=d.render(p[0],n.getColumns()),u=0;u<r.parent.groupSettings.columns.length;u++)c.insertBefore(r.parent.createElement("td",{className:"e-indentcell"}),c.firstChild),p[0].cells.unshift(new Vo({cellType:e.CellType.Indent}));var g=n.getContentTable().querySelector(gs);if(c.classList.add("e-insertedrow"),g.querySelector(".e-emptyrow")){var f=g.querySelector(".e-emptyrow");f.parentNode.removeChild(f),r.removeFrozenTbody()}n.isFrozenGrid()&&(l=c.cloneNode(!0),s=r.renderMovable(c,l),c="Right"===n.getFrozenMode()?l:c,r.renderFrozenAddRow(c,s,l)),g=n.frozenRows&&"Top"===n.editSettings.newRowPosition?n.getHeaderTable().querySelector(gs):n.getContentTable().querySelector(gs),"Top"===r.parent.editSettings.newRowPosition?g.insertBefore(c,g.firstChild):g.appendChild(c),t.addClass([].slice.call(c.getElementsByClassName(_o)),["e-updatedtd"]),p[0].isDirty=!0,p[0].changes=t.extend({},{},p[0].data,!0),p[0].edit="add",r.addRowObject(p[0]),r.refreshRowIdx(),r.focus.forgetPrevious(),n.notify(ti,{rows:r.parent.getRowsObject(),args:{isFrozen:r.parent.isFrozenGrid()}});var m=r.getBatchChanges(),y=r.getBottomIndex();"Top"===r.parent.editSettings.newRowPosition?n.selectRow(0):n.selectRow(y),i||(h=r.findNextEditableCell(0,!0),a=n.getColumns()[h],"Top"===r.parent.editSettings.newRowPosition?r.editCell(0,a.field,!0):r.editCell(y,a.field,!0)),r.parent.aggregates.length>0&&(i||m[ls].length)&&r.parent.notify(Hi,{});var v={defaultData:o.defaultData,row:c,columnObject:a,columnIndex:h,primaryKey:o.primaryKey,cell:c.cells[h]};n.trigger(ti,v),n.isFrozenGrid()&&Ce(s.querySelector("td:not(.e-hide)"),c.querySelector("td:not(.e-hide)"))}})}},r.prototype.renderFrozenAddRow=function(e,i,r){var n=this.parent,o=Le(this.parent),s=qe(this.parent);"Top"===n.editSettings.newRowPosition?o.insertBefore(i,o.firstChild):o.appendChild(i),t.addClass([].slice.call(i.getElementsByClassName(_o)),["e-updatedtd"]),s&&r&&("Top"===n.editSettings.newRowPosition?s.insertBefore(r,s.firstChild):s.appendChild(r),t.addClass([].slice.call(r.getElementsByClassName(_o)),["e-updatedtd"]),Ce(r.querySelector("td:not(.e-hide)"),e.querySelector("td:not(.e-hide)"))),"auto"===n.height&&n.notify(Wr,{})},r.prototype.removeFrozenTbody=function(){var e=this.parent;if(e.isFrozenGrid()){var t=e.getContent().querySelector("."+Yo).querySelector(gs);if(t.firstElementChild.parentNode.removeChild(t.firstElementChild),e.getFrozenMode()===hs){var i=e.getContent().querySelector(".e-frozen-right-content").querySelector(gs);i.firstElementChild.parentNode.removeChild(i.firstElementChild)}}},r.prototype.renderMovable=function(e,t){var i=e.cloneNode(!0),r=this.parent.getMovableColumnsCount(),n=this.parent.getFrozenLeftCount(),o=this.parent.getFrozenRightColumnsCount();return Ae(e,0,n),Ae(i,n,o?i.children.length-o:i.children.length),Ae(t,n+r,t.children.length),i},r.prototype.findNextEditableCell=function(e,i,r){for(var n,o=this.parent.getColumns(),s=o.length,l=e;l<s;l++){if(n=!!r&&t.isNullOrUndefined(o[l].validationRules),!i&&this.checkNPCell(o[l]))return l;if(i&&!o[l].template&&o[l].visible&&o[l].allowEditing&&(!o[l].isIdentity||!o[l].isPrimaryKey)&&!n)return l}return-1},r.prototype.checkNPCell=function(e){return!e.template&&e.visible&&!e.isPrimaryKey&&!e.isIdentity&&e.allowEditing},r.prototype.getDefaultData=function(){for(var e={},i={number:0,string:null,boolean:!1,date:null,datetime:null},r=0,n=this.parent.columnModel;r<n.length;r++){var o=n[r];o.field&&t.setValue(o.field,Object.keys(o).indexOf("defaultValue")>=0?o.defaultValue:i[o.type],e)}return e},r.prototype.setCellIdx=function(e){var t=0;this.parent.allowGrouping&&(t=this.parent.groupSettings.columns.length),this.cellDetails.cellIndex=e.cellIndex-t,this.cellDetails.rowIndex=parseInt(e.getAttribute("index"),10)},r.prototype.editCell=function(e,t,i){var r=this.parent,n=r.getColumnByField(t);this.index=e,this.field=t,this.isAdd=i;var o=r.isEdit&&!(this.cellDetails.column.field===t&&this.cellDetails.rowIndex===e&&this.parent.getDataRows().length-1!==e);r.editSettings.allowEditing&&(!o&&n.allowEditing?this.editCellExtend(e,t,i):o&&(this.editNext=!0,this.saveCell()))},r.prototype.editCellExtend=function(e,i,r){var n=this,o=this.parent,s=o.getColumnByField(i),l=o.getPrimaryKeyFieldNames();if(!o.isEdit){var a,h,d=t.extend({},{},this.getDataByIndex(e),!0);if("movable"===s.getFreezeTableName()||s.getFreezeTableName()===ds?(a="movable"===s.getFreezeTableName()?o.getMovableDataRows()[e]:o.getFrozenRightDataRows()[e],h=this.parent.getRowObjectFromUID(a.getAttribute("data-uid")),d=h.changes?t.extend({},{},h.changes,!0):d):(a=o.getDataRows()[e],d=t.extend({},{},this.getDataByIndex(e),!0)),l[0]===s.field&&!a.classList.contains("e-insertedrow")||s.columns||s.isPrimaryKey&&s.isIdentity)this.parent.isLastCellPrimaryKey=!0;else{this.parent.isLastCellPrimaryKey=!1,this.parent.element.classList.add("e-editing");var p=o.getRowObjectFromUID(a.getAttribute("data-uid")),c=[].slice.apply(a.cells),u={columnName:s.field,isForeignKey:!t.isNullOrUndefined(s.foreignKeyValue),primaryKey:l,rowData:d,validationRules:t.extend({},s.validationRules?s.validationRules:{}),value:he(s.field,d),type:r?"add":"edit",cancel:!1,foreignKeyData:p&&p.foreignKeyData};u.cell=c[this.getColIndex(c,this.getCellIdx(s.uid))],u.row=a,u.columnObject=s,u.cell&&o.trigger("cellEdit",u,function(i){i.cancel||(i.cell=i.cell?i.cell:c[n.getColIndex(c,n.getCellIdx(s.uid))],i.row=i.row?i.row:a,i.columnObject=i.columnObject?i.columnObject:s,i.columnObject.index=t.isNullOrUndefined(i.columnObject.index)?0:i.columnObject.index,n.cellDetails={rowData:d,column:s,value:i.value,isForeignKey:i.isForeignKey,rowIndex:e,cellIndex:parseInt(i.cell.getAttribute(cs),10),foreignKeyData:i.foreignKeyData},i.cell.classList.contains("e-updatedtd")&&(n.isColored=!0,i.cell.classList.remove("e-updatedtd")),o.isEdit=!0,o.clearSelection(),o.isCheckBoxSelection&&o.isPersistSelection||o.selectRow(n.cellDetails.rowIndex,!0),n.renderer.update(i),n.parent.notify(ln,i),n.form=t.select("#"+o.element.id+"EditForm",o.element),o.editModule.applyFormValidation([s]),n.parent.element.querySelector(".e-gridpopup").style.display="none")})}}},r.prototype.updateCell=function(e,t,i){var r=this.parent,n=r.getColumnByField(t),o=r.getColumnIndexByField(t);if(n&&!n.isPrimaryKey&&n.allowEditing){var s=Ne(this.parent,n,e,o),l="movable"===n.getFreezeTableName()?this.parent.getMovableRowsObject()[e]:n.getFreezeTableName()===ds?r.getFrozenRightRowsObject()[e]:r.getRowObjectFromUID(s.parentElement.getAttribute("data-uid"));this.refreshTD(s,n,l,i),this.parent.trigger(It,{cell:this.newReactTd||s,column:n,data:l.changes})}},r.prototype.setChanges=function(e,r,n){var o;if(this.parent.isFrozenGrid()){var s=this.parent.getRowElementByUID(e.uid),l=parseInt(s.getAttribute(us),10);(o=this.parent.getRowsObject()[l]).changes||(o.changes=t.extend({},{},e.data,!0)),t.isNullOrUndefined(r)||t.setValue(r,n,o.changes);var a=this.parent.getMovableRowsObject()[l];if(a.changes=t.extend({},{},o.changes,!0),e.data[r]!==n&&(a.isDirty=!0,o.isDirty=!0),this.parent.getFrozenMode()===hs){var h=this.parent.getFrozenRightRowsObject()[l];h.changes=t.extend({},{},o.changes,!0),e.data[r]!==n&&(h.isDirty=!0)}}else if(e.changes||(e.changes=t.extend({},{},e.data,!0)),t.isNullOrUndefined(r)||i.DataUtil.setValue(r,n,e.changes),e.data[r]!==n){var d=this.parent.getColumnByField(r).type;"date"===d||"datetime"===d?new Date(e.data[r]).toString()!==new Date(n).toString()&&(e.isDirty=!0):e.isDirty=!0}},r.prototype.updateRow=function(e,t){for(var i=0,r=Object.keys(t);i<r.length;i++){var n=r[i];this.updateCell(e,n,t[n])}},r.prototype.getCellIdx=function(e){var i=this.parent.getColumnIndexByUid(e)+this.parent.groupSettings.columns.length;return t.isNullOrUndefined(this.parent.detailTemplate)&&t.isNullOrUndefined(this.parent.childGrid)||i++,this.parent.isRowDragable()&&i++,i},r.prototype.refreshTD=function(e,i,r,n){var o,s=new Bs(this.parent,this.serviceLocator);n="number"!==i.type||t.isNullOrUndefined(n)?n:parseFloat(n),this.setChanges(r,i.field,n);var l=this.parent.getFrozenColumns()||this.parent.getFrozenLeftColumnsCount()||this.parent.getFrozenRightColumnsCount();l=l&&this.parent.isRowDragable()?l+1:l,re(r,this.parent.getForeignKeyColumns(),r.changes),o=l&&"movable"===i.getFreezeTableName()&&this.parent.getColumns().length===r.cells.length?r.cells.slice(l,r.cells.length):r.cells;var a,h;this.parent.isReact&&(a=e.parentElement,h=e.cellIndex);var d=0;l&&(d="movable"===i.getFreezeTableName()&&"Right"!==this.parent.getFrozenMode()?l:i.getFreezeTableName()===ds?this.parent.getFrozenLeftColumnsCount()+this.parent.getMovableColumnsCount():d),s.refreshTD(e,o[this.getCellIdx(i.uid)-d],r.changes,{index:this.getCellIdx(i.uid)}),this.parent.isReact?(this.newReactTd=a.cells[h],a.cells[h].classList.add("e-updatedtd")):e.classList.add("e-updatedtd"),e.classList.add("e-updatedtd"),this.parent.notify(sr,{})},r.prototype.getColIndex=function(e,i){var r=0;this.parent.allowGrouping&&this.parent.groupSettings.columns&&(r=this.parent.groupSettings.columns.length),t.isNullOrUndefined(this.parent.detailTemplate)&&t.isNullOrUndefined(this.parent.childGrid)||r++,this.parent.isRowDragable()&&r++;for(var n=0;n<e.length;n++){if(parseInt(e[n].getAttribute(cs),10)===i-r)return n}return-1},r.prototype.editNextValCell=function(){var e=this.parent,t=this.getBottomIndex();if(this.isAdded&&!e.isEdit){for(var i=this.cellDetails.cellIndex;i<e.getColumns().length;i++){if(e.isEdit)return;var r=this.findNextEditableCell(this.cellDetails.cellIndex+1,!0,!0),n=e.getColumns()[r];if(n){if("Bottom"===this.parent.editSettings.newRowPosition)this.editCell(t,n.field,!0);else{var o={index:0,column:n};this.parent.notify(ao,o),this.editCell(o.index,n.field,!0)}this.saveCell()}}e.isEdit||(this.isAdded=!1)}},r.prototype.escapeCellEdit=function(){var e=this.generateCellArgs();e.value=e.previousValue,this.successCallBack(e,e.cell.parentElement,e.column,!0)(e)},r.prototype.generateCellArgs=function(){var e=this.parent;this.parent.element.classList.remove("e-editing");var i=this.cellDetails.column,r={};r[i.field]=he(i.field,this.cellDetails.rowData);var n=e.editModule.getCurrentEditedData(this.form,r),o=t.extend({},n);n=t.extend({},n,this.cellDetails.rowData);var s=he(i.field,o);t.isNullOrUndefined(i.field)||t.isUndefined(s)||t.setValue(i.field,s,n);var l={columnName:i.field,value:he(i.field,n),rowData:this.cellDetails.rowData,column:i,previousValue:this.cellDetails.value,isForeignKey:this.cellDetails.isForeignKey,cancel:!1};return l.cell=this.form.parentElement,l.columnObject=i,l},r.prototype.saveCell=function(e){if(!this.preventSaveCell&&this.form){var t=this.parent;if(e||t.isEdit&&!this.validateFormObj()){this.preventSaveCell=!0;var i=this.generateCellArgs(),r=i.cell.parentElement,n=i.column;e?this.successCallBack(i,r,n)(i):(t.trigger("cellSave",i,this.successCallBack(i,r,n)),t.notify(on,{formObj:this.form}))}}},r.prototype.successCallBack=function(e,i,r,n){var o=this;return function(e){var s=o.parent;if(e.cell=e.cell?e.cell:o.form.parentElement,e.columnObject=e.columnObject?e.columnObject:r,e.columnObject.index=t.isNullOrUndefined(e.columnObject.index)?0:e.columnObject.index,e.cancel){if(o.preventSaveCell=!1,o.editNext){if(o.editNext=!1,o.cellDetails.rowIndex===o.index&&o.cellDetails.column.field===o.field)return;o.editCellExtend(o.index,o.field,o.isAdd)}}else{s.editModule.destroyWidgets([r]),s.isEdit=!1,s.editModule.destroyForm(),o.parent.notify(hr,{});var l=D(e.cell,Yo)||D(e.cell,Jo)?s.getRowObjectFromUID(i.getAttribute("data-uid"),!0):s.getRowObjectFromUID(i.getAttribute("data-uid"));if(s.getFrozenMode()===hs&&(D(e.cell,"e-frozen-right-header")||D(e.cell,"e-frozen-right-content"))&&(l=s.getRowObjectFromUID(i.getAttribute("data-uid"),!1,!0)),o.refreshTD(e.cell,r,l,e.value),o.parent.isReact&&(e.cell=o.newReactTd),t.removeClass([i],[ns,"e-batchrow"]),t.removeClass([e.cell],["e-editedbatchcell","e-boolcell"]),(!t.isNullOrUndefined(e.value)&&e.value.toString()===(t.isNullOrUndefined(o.cellDetails.value)?"":o.cellDetails.value).toString()&&!o.isColored||t.isNullOrUndefined(e.value)&&t.isNullOrUndefined(l.data[r.field])&&t.isNullOrUndefined(o.cellDetails.value)&&!e.cell.parentElement.classList.contains("e-insertedrow"))&&e.cell.classList.remove("e-updatedtd"),t.isNullOrUndefined(n)&&s.trigger("cellSaved",e),s.notify(sr,{}),o.isColored=!1,o.parent.aggregates.length>0&&(o.parent.notify(Hi,{}),o.parent.groupSettings.columns.length>0&&!o.isAddRow(o.cellDetails.rowIndex)&&o.parent.notify(qi,{})),o.preventSaveCell=!1,o.editNext){if(o.editNext=!1,o.cellDetails.rowIndex===o.index&&o.cellDetails.column.field===o.field)return;var a=s.getColumnByField(o.field);a&&a.allowEditing&&o.editCellExtend(o.index,o.field,o.isAdd)}n&&s.notify(vn,{})}}},r.prototype.getDataByIndex=function(e){var t=this.parent.getRowObjectFromUID(this.parent.getDataRows()[e].getAttribute("data-uid"));return t.changes?t.changes:t.data},r.prototype.keyDownHandler=function(e){if(("tab"===e.action||"shiftTab"===e.action)&&this.parent.isEdit){var t=this.parent,i=this.getBottomIndex(),r=D(e.target,_o);if(r){var n=r.querySelector(".e-field");if(n){var o=this.parent.getVisibleColumns();o["tab"===e.action?o.length-1:0].field===n.getAttribute("id").slice(this.parent.element.id.length)&&(this.cellDetails.rowIndex===i&&"tab"===e.action?"Top"===t.editSettings.newRowPosition?(t.editSettings.newRowPosition="Bottom",this.addRecord(),t.editSettings.newRowPosition="Top"):this.addRecord():this.saveCell())}}}},r.prototype.addCancelWhilePaging=function(){this.validateFormObj()&&(this.parent.notify(yr,{}),this.parent.isEdit=!1,this.isColored=!1)},r.prototype.getBottomIndex=function(){var e=this.getBatchChanges();return this.parent.getCurrentViewRecords().length+e[ls].length-e[as].length-1},r}(),ah=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),hh=function(e){function t(t,i,r){var n=e.call(this,t,i)||this;return n.parent=t,n.serviceLocator=i,n.renderer=r,n}return ah(t,e),t.prototype.closeEdit=function(){e.prototype.closeEdit.call(this)},t.prototype.addRecord=function(t,i){e.prototype.addRecord.call(this,t,i)},t.prototype.endEdit=function(){e.prototype.endEdit.call(this)},t.prototype.updateRow=function(t,i){e.prototype.updateRow.call(this,t,i)},t.prototype.deleteRecord=function(t,i){e.prototype.deleteRecord.call(this,t,i)},t.prototype.startEdit=function(t){e.prototype.startEdit.call(this,t)},t}(nh),dh=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),ph=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return dh(i,e),i.prototype.write=function(e){"datepickeredit"===e.column.editType?this.obj=new l.DatePicker(t.extend(rt(e,this.parent.editSettings.mode,this.parent.enableRtl),e.column.edit.params)):"datetimepickeredit"===e.column.editType&&(this.obj=new l.DateTimePicker(t.extend(rt(e,this.parent.editSettings.mode,this.parent.enableRtl),e.column.edit.params))),this.obj.appendTo(e.element)},i}(Ya),ch=function(){function e(e){this.parent=e}return e.prototype.read=function(e,t){return t},e.prototype.write=function(){},e.prototype.destroy=function(){},e}(),uh=function(){function e(e,t){this.editType={Inline:sh,Normal:sh,Batch:lh,Dialog:hh},this.parent=e,this.serviceLocator=t,this.l10n=this.serviceLocator.getService("localization"),this.addEventListener(),this.updateEditObj(),this.createAlertDlg(),this.createConfirmDlg()}return e.prototype.updateColTypeObj=function(){for(var i=this.parent.columnModel,r=0;r<i.length;r++)if(this.parent.editSettings.template||i[r].editTemplate){i[r].edit=t.extend(new e.editCellType.templateedit(this.parent),i[r].edit||{})}else i[r].edit=t.extend(new e.editCellType[i[r].editType&&e.editCellType[i[r].editType]?i[r].editType:"defaultedit"](this.parent,this.serviceLocator),i[r].edit||{});this.parent.log("primary_column_missing")},e.prototype.getModuleName=function(){return"edit"},e.prototype.onPropertyChanged=function(e){if(e.module===this.getModuleName())for(var t=this.parent,i=0,r=Object.keys(e.properties);i<r.length;i++){switch(r[i]){case"allowAdding":case"allowDeleting":case"allowEditing":(t.editSettings.allowAdding||t.editSettings.allowEditing||t.editSettings.allowDeleting)&&this.initialEnd();break;case"mode":this.updateEditObj(),t.isEdit=!1,t.refresh()}}},e.prototype.updateEditObj=function(){this.editModule&&this.editModule.destroy(),this.renderer=new Xa(this.parent,this.serviceLocator),this.editModule=new this.editType[this.parent.editSettings.mode](this.parent,this.serviceLocator,this.renderer)},e.prototype.initialEnd=function(){this.updateColTypeObj()},e.prototype.startEdit=function(e){var t=this.parent;if(t.editSettings.allowEditing&&!t.isEdit&&"Batch"!==t.editSettings.mode){if(this.parent.element.classList.add("e-editing"),t.getSelectedRows().length)e||(e=t.getSelectedRows()[0]);else if(!e)return void this.showDialog("EditOperationAlert",this.alertDObj);this.isLastRow=e.rowIndex===this.parent.getContent().querySelector("tr:last-child").rowIndex,"none"!==e.style.display&&(this.editModule.startEdit(e),this.refreshToolbar(),t.element.querySelector(".e-gridpopup").style.display="none",this.parent.notify("start-edit",{}))}},e.prototype.checkLastRow=function(e,i){var r=this.isLastRow;"auto"!==this.parent.height&&"Bottom"===this.parent.editSettings.newRowPosition&&i&&"add"===i.requestType&&this.parent.getContent().firstElementChild.offsetHeight>this.parent.getContentTable().scrollHeight?t.addClass([].slice.call(e.getElementsByClassName(_o)),"e-lastrowadded"):r&&e&&e.classList&&t.addClass([].slice.call(e.getElementsByClassName(_o)),"e-lastrowcell")},e.prototype.closeEdit=function(){"Batch"===this.parent.editSettings.mode&&this.parent.editSettings.showConfirmDialog&&this.parent.element.getElementsByClassName("e-updatedtd").length?this.showDialog("CancelEdit",this.dialogObj):(this.parent.element.classList.remove("e-editing"),this.editModule.closeEdit(),this.refreshToolbar(),this.parent.notify(Eo,{}))},e.prototype.refreshToolbar=function(){this.parent.notify(sr,{})},e.prototype.addRecord=function(e,t){if(this.parent.editSettings.allowAdding){var i={startEdit:!0};e||this.parent.notify(Tn,i),i.startEdit&&(this.parent.element.classList.add("e-editing"),this.editModule.addRecord(e,t),this.refreshToolbar(),this.parent.notify("start-add",{}))}},e.prototype.deleteRecord=function(e,i){var r=this.parent;r.editSettings.allowDeleting&&(i||r.getSelectedRecords().length||!t.isNullOrUndefined(r.commandDelIndex)?r.editSettings.showDeleteConfirmDialog?this.showDialog("ConfirmDelete",this.dialogObj):this.editModule.deleteRecord(e,i):this.showDialog("DeleteOperationAlert",this.alertDObj))},e.prototype.deleteRow=function(e){this.deleteRowUid=e.getAttribute("data-uid");var i=this.parent.getRowObjectFromUID(this.deleteRowUid);t.isNullOrUndefined(i)||this.deleteRecord(null,i.data)},e.prototype.endEdit=function(){"Batch"===this.parent.editSettings.mode&&this.parent.editSettings.showConfirmDialog&&(t.isNullOrUndefined(this.formObj)||this.formObj.validate())&&(this.parent.editModule.saveCell(),this.parent.notify(Yr,{}),t.isNullOrUndefined(this.formObj)||this.formObj.validate())?this.showDialog("BatchSaveConfirm",this.dialogObj):this.endEditing()},e.prototype.updateCell=function(e,t,i){this.editModule.updateCell(e,t,i)},e.prototype.updateRow=function(e,t){this.editModule.updateRow(e,t)},e.prototype.batchCancel=function(){this.closeEdit()},e.prototype.batchSave=function(){this.endEdit()},e.prototype.editCell=function(e,t){this.editModule.editCell(e,t)},e.prototype.editFormValidate=function(){var e=!this.formObj||this.formObj.validate(),t=!this.mFormObj||this.mFormObj.validate(),i=!this.frFormObj||this.frFormObj.validate();return e&&t&&i},e.prototype.getBatchChanges=function(){return this.editModule.getBatchChanges?this.editModule.getBatchChanges():{}},e.prototype.getCurrentEditCellData=function(){var e=this.getCurrentEditedData(this.formObj.element,{});return e[Object.keys(e)[0]]},e.prototype.saveCell=function(){this.editModule.saveCell()},e.prototype.endEditing=function(){this.parent.element.classList.remove("e-editing"),this.editModule.endEdit(),this.refreshToolbar()},e.prototype.showDialog=function(e,t){t.content="<div>"+this.l10n.getConstant(e)+"</div>",t.dataBind(),t.show()},e.prototype.getValueFromType=function(e,t){var i=t;switch(e.type){case"number":i=isNaN(parseFloat(t))?null:parseFloat(t);break;case"boolean":"booleanedit"!==e.editType&&(i=t===this.l10n.getConstant("True")||!0===t);break;case"date":case"datetime":"datepickeredit"!==e.editType&&"datetimepickeredit"!==e.editType&&t&&t.length?i=new Date(t):""===t&&(i=null)}return i},e.prototype.destroyToolTip=function(){for(var e=0,i=[].slice.call(this.parent.element.getElementsByClassName("e-griderror"));e<i.length;e++){var r=i[e];t.remove(r)}this.parent.getContent().firstElementChild.style.position="relative"},e.prototype.createConfirmDlg=function(){this.dialogObj=this.dlgWidget([{click:this.dlgOk.bind(this),buttonModel:{content:this.l10n.getConstant("OKButton"),cssClass:"e-primary",isPrimary:!0}},{click:this.dlgCancel.bind(this),buttonModel:{cssClass:"e-flat",content:this.l10n.getConstant("CancelButton")}}],"EditConfirm")},e.prototype.createAlertDlg=function(){this.alertDObj=this.dlgWidget([{click:this.alertClick.bind(this),buttonModel:{content:this.l10n.getConstant("OKButton"),cssClass:"e-flat",isPrimary:!0}}],"EditAlert")},e.prototype.alertClick=function(){this.alertDObj.hide()},e.prototype.dlgWidget=function(e,t){var i=this.parent.createElement("div",{id:this.parent.element.id+t});this.parent.element.appendChild(i);var n={showCloseIcon:!1,isModal:!0,visible:!1,closeOnEscape:!0,target:this.parent.element,width:"320px",animationSettings:{effect:"None"}};n.buttons=e;var o=new r.Dialog(n);return o.isStringTemplate=!0,o.appendTo(i),o},e.prototype.dlgCancel=function(){this.parent.focusModule.clearIndicator(),this.parent.focusModule.restoreFocus(),this.dialogObj.hide()},e.prototype.dlgOk=function(){switch(this.dialogObj.element.querySelector(".e-dlg-content").firstElementChild.innerText){case this.l10n.getConstant("ConfirmDelete"):this.editModule.deleteRecord();break;case this.l10n.getConstant("CancelEdit"):this.editModule.closeEdit();break;case this.l10n.getConstant("BatchSaveConfirm"):this.endEditing();break;case this.l10n.getConstant("BatchSaveLostChanges"):"Batch"===this.parent.editSettings.mode&&this.editModule.addCancelWhilePaging(),this.executeAction()}this.dlgCancel()},e.prototype.destroyEditComponents=function(){this.parent.isEdit&&(this.destroyWidgets(),this.destroyForm()),this.destroy()},e.prototype.addEventListener=function(){this.parent.isDestroyed||(this.eventDetails=[{event:Ii,handler:this.onPropertyChanged},{event:Si,handler:this.initialEnd},{event:_i,handler:this.keyPressHandler},{event:ar,handler:this.updateColTypeObj},{event:hr,handler:this.destroyToolTip},{event:ur,handler:this.preventBatch},{event:yr,handler:this.destroyForm},{event:Ki,handler:this.destroyEditComponents}],_e(this.parent,this.eventDetails,!0,this),this.actionBeginFunction=this.onActionBegin.bind(this),this.actionCompleteFunction=this.actionComplete.bind(this),this.parent.addEventListener(zt,this.actionBeginFunction),this.parent.addEventListener(Dt,this.actionCompleteFunction))},e.prototype.removeEventListener=function(){this.parent.isDestroyed||(_e(this.parent,this.eventDetails,!1),this.parent.removeEventListener(Dt,this.actionCompleteFunction),this.parent.removeEventListener(zt,this.actionBeginFunction))},e.prototype.actionComplete=function(e){["add","beginEdit","save","delete","cancel"].indexOf(e.requestType)<0&&(this.parent.isEdit=!1),"batchsave"===e.requestType&&this.parent.focusModule.restoreFocus(),this.refreshToolbar()},e.prototype.getCurrentEditedData=function(e,r){var n=this.parent;if(n.editSettings.template){for(var o=[].slice.call(e.elements),s=0;s<o.length;s++)if((o[s].hasAttribute("name")&&"e-multi-hidden"!==o[s].className||o[s].classList.contains("e-multiselect"))&&("hidden"!==o[s].type||!D(o[s],"e-switch-wrapper")&&!D(o[s],"e-checkbox-wrapper"))){var l=o[s].hasAttribute("name")?G(o[s].getAttribute("name")):G(o[s].getAttribute("id")),a=n.getColumnByField(l)||{field:l,type:o[s].getAttribute("type")},h=void 0;"checkbox"===a.type||"boolean"===a.type?h=o[s].checked:o[s].value?(h=o[s].value,o[s].ej2_instances&&o[s].ej2_instances.length&&!t.isNullOrUndefined(o[s].ej2_instances[0].value)&&(o[s].blur(),h=o[s].ej2_instances[0].value)):o[s].ej2_instances&&(h=o[s].ej2_instances[0].value),a.edit&&"string"==typeof a.edit.read?h=t.getValue(a.edit.read,window)(o[s],h):a.edit&&a.edit.read&&(h=a.edit.read(o[s],h)),h=n.editModule.getValueFromType(a,h),"radio"===o[s].type?o[s].checked&&i.DataUtil.setValue(a.field,h,r):i.DataUtil.setValue(a.field,h,r)}return r}for(var d=n.columnModel.filter(function(e){return e.editTemplate}),p=0;p<d.length;p++)if(e[V(d[p].field)]){var c=[].slice.call(e[V(d[p].field)]),u=(c=c.length?c:[e[V(d[p].field)]]).filter(function(e){return!t.isNullOrUndefined(e.ej2_instances)});0===u.length&&(u=c.filter(function(e){return e.hasAttribute("name")}));for(s=0;s<u.length;s++){h=this.getValue(d[p],u[s],r);i.DataUtil.setValue(d[p].field,h,r)}}for(var g=[].slice.call(e.getElementsByClassName("e-field")),f=0,m=g.length;f<m;f++){var y=n.getColumnByUid(g[f].getAttribute("e-mappinguid"));if(y&&y.field){h=this.getValue(y,g[f],r);i.DataUtil.setValue(y.field,h,r)}}return r},e.prototype.getValue=function(e,i,r){var n=i.ej2_instances?i.ej2_instances[0].value:i.value,o=this.parent,s=e.edit.read;return"checkbox"!==e.type&&"boolean"!==e.type||(n=i.checked),"string"==typeof s?(s=t.getValue(s,window),n=o.editModule.getValueFromType(e,s(i,n))):n=o.editModule.getValueFromType(e,e.edit.read(i,n)),t.isNullOrUndefined(r[e.field])&&""===n&&(n=r[e.field]),n},e.prototype.onActionBegin=function(e){if("columnstate"===e.requestType&&this.parent.isEdit&&"Batch"!==this.parent.editSettings.mode)this.closeEdit();else{var t=this.parent.element.querySelector("."+ns),i=this.parent.element.querySelector("."+os);if(t&&this.parent.frozenRows&&"virtualscroll"===e.requestType&&parseInt(D(t,is).getAttribute(us),10)<this.parent.frozenRows)return;var r=-1===["filterafteropen","filterbeforeopen","filterchoicerequest","save","infiniteScroll","virtualscroll"].indexOf(e.requestType),n=this.parent.enableVirtualization&&this.formObj&&!this.formObj.isDestroyed&&(t||i||"cancel"===e.requestType)&&r;(!this.parent.enableVirtualization&&"Batch"!==this.parent.editSettings.mode&&this.formObj&&!this.formObj.isDestroyed&&r&&!e.cancel||n)&&(this.destroyWidgets(),this.destroyForm())}},e.prototype.destroyWidgets=function(e){this.parent.editSettings.template&&(this.parent.destroyTemplate(["editSettingsTemplate"]),this.parent.isReact&&this.parent.renderTemplates()),(e=e||this.parent.getCurrentVisibleColumns(this.parent.enableColumnVirtualization)).some(function(e){return!t.isNullOrUndefined(e.editTemplate)})&&(this.parent.destroyTemplate(["editTemplate"]),this.parent.isReact&&this.parent.renderTemplates());for(var i=0,r=e;i<r.length;i++){var n=r[i],o=n.edit.destroy;n.edit.destroy&&("string"==typeof o?(o=t.getValue(o,window))():n.edit.destroy())}for(var s=[].slice.call(this.formObj.element.elements),l=0;l<s.length;l++)s[l].hasAttribute("name")&&s[l].ej2_instances&&s[l].ej2_instances.length&&!s[l].ej2_instances[0].isDestroyed&&s[l].ej2_instances[0].destroy()},e.prototype.destroyForm=function(){this.destroyToolTip();for(var e=[this.formObj,this.mFormObj,this.frFormObj,this.virtualFormObj],t=0;t<e.length;t++)e[t]&&e[t].element&&!e[t].isDestroyed&&e[t].destroy();this.destroyToolTip()},e.prototype.destroy=function(){var e=this.parent.element;if(e){var i=!(!e.querySelector("."+Wo)||!e.querySelector("."+Ko));i&&this.destroyForm(),this.removeEventListener();var r=this.dialogObj.element;r.childElementCount>0&&(this.dialogObj.destroy(),t.remove(r)),(r=this.alertDObj.element).childElementCount>0&&(this.alertDObj.destroy(),t.remove(r)),i&&this.editModule&&this.editModule.destroy()}},e.prototype.keyPressHandler=function(e){switch(e.action){case"insert":this.addRecord();break;case"delete":"INPUT"===e.target.tagName&&!e.target.classList.contains("e-checkselect")||document.querySelector(".e-popup-open")||this.deleteRecord();break;case"f2":this.startEdit();break;case"enter":D(e.target,"e-unboundcelldiv")||"Batch"===this.parent.editSettings.mode||!(D(e.target,Ko)||this.parent.frozenRows&&D(e.target,Xo))||document.getElementsByClassName("e-popup-open").length||(e.preventDefault(),this.endEdit());break;case"escape":this.parent.isEdit&&("Batch"===this.parent.editSettings.mode?this.editModule.escapeCellEdit():this.closeEdit())}},e.prototype.preventBatch=function(e){this.preventObj=e,this.showDialog("BatchSaveLostChanges",this.dialogObj)},e.prototype.executeAction=function(){this.preventObj.handler.call(this.preventObj.instance,this.preventObj.arg1,this.preventObj.arg2,this.preventObj.arg3,this.preventObj.arg4,this.preventObj.arg5,this.preventObj.arg6,this.preventObj.arg7,this.preventObj.arg8)},e.prototype.applyFormValidation=function(e){var i=this.parent,r=i.isFrozenGrid(),n="Normal"===this.parent.editSettings.mode,o="Right"===this.parent.getFrozenMode()&&n?1:0,s="Dialog"!==this.parent.editSettings.mode?i.element.getElementsByClassName("e-gridform")[o]:t.select("#"+i.element.id+"_dialogEdit_wrapper .e-gridform",document),l="Right"===this.parent.getFrozenMode()&&n?0:1,a=i.element.getElementsByClassName("e-gridform")[l],h={},d={},p={};e=e||i.getColumns();for(var c=0;c<e.length;c++)(e[c].visible||"Dialog"===i.editSettings.mode&&(-1!==i.groupSettings.columns.indexOf(e[c].field)||"Dialog"!==i.editSettings.mode))&&e[c].validationRules&&Pe(e[c],l,h,d,p,e.length);if(r&&"Dialog"!==this.parent.editSettings.mode){if(this.parent.editModule.mFormObj=this.createFormObj(a,d),this.parent.getFrozenMode()===hs){var u=i.element.getElementsByClassName("e-gridform")[2];this.parent.editModule.frFormObj=this.createFormObj(u,p)}}else h=t.extend(h,d,p);this.parent.editModule.formObj=this.createFormObj(s,h)},e.prototype.createFormObj=function(e,t){var i=this;return new o.FormValidator(e,{rules:t,locale:this.parent.locale,validationComplete:function(e){i.validationComplete(e)},customPlacement:function(e,t){var r=e.getAttribute("e-mappinguid"),n={column:i.parent.getColumnByUid(r),error:t,inputElement:e,value:e.value};i.valErrorPlacement(e,t),i.parent.notify(mn,n)}})},e.prototype.valErrorPlacement=function(e,t){if(this.parent.isEdit){var i=t.getAttribute("for"),r=this.getElemTable(e).querySelector("#"+i+"_Error");r?r.querySelector(".e-tip-content").innerHTML=t.outerHTML:this.createTooltip(e,t,i,"")}},e.prototype.getElemTable=function(e){var i,r,n=this.parent;if("Dialog"!==n.editSettings.mode){i=n.frozenRows&&n.frozenRows>(parseInt(t.closest(e,"."+is).getAttribute(us),10)||0);var o=e.name,s=void 0;o&&(s=Qe(this.parent,G(o))),s&&n.isFrozenGrid()?"frozen-left"===s.getFreezeTableName()?r=i?n.getFrozenVirtualHeader().querySelector("table"):n.getFrozenVirtualContent().querySelector("table"):"frozen-right"===s.getFreezeTableName()?r=i?n.getFrozenRightHeader().querySelector("table"):n.getFrozenRightContent().querySelector("table"):"movable"===s.getFreezeTableName()&&(r=i?n.getMovableVirtualHeader().querySelector("table"):n.getMovableVirtualContent().querySelector("table")):r=i?n.getHeaderTable():n.getContentTable()}else r=t.select("#"+n.element.id+"_dialogEdit_wrapper",document);return r},e.prototype.resetElemPosition=function(e,t){var i=D(t.element,_o);if(i){var r=i.getBoundingClientRect().right,n=e.getBoundingClientRect().right;if(n>r){var o=n-r;e.style.left=e.offsetLeft-o+"px"}}},e.prototype.validationComplete=function(e){if(this.parent.isEdit){var t=this.getElemTable(e.element).querySelector("#"+e.inputName+"_Error");t&&("failure"===e.status?(t.style.display="",this.resetElemPosition(t,e)):t.style.display="none")}},e.prototype.createTooltip=function(e,i,n,o){var s=this.parent.getColumnByField(n),l=this.parent.getFrozenMode()===hs&&"Normal"===this.parent.editSettings.mode&&s.getFreezeTableName()===ds?this.frFormObj.element:this.formObj.element,a=D(e,"e-virtual-validation");a&&(l=this.virtualFormObj.element);var h=this.parent.getContent().firstElementChild,d=this.parent.getFrozenColumns()||this.parent.getFrozenLeftColumnsCount()||this.parent.getFrozenRightColumnsCount();d&&(h=this.parent.getMovableVirtualContent());var p,c,u=h.scrollHeight>h.clientHeight||h.scrollWidth>h.clientWidth,g="Dialog"!==this.parent.editSettings.mode,f=t.closest(e,"."+_o),m=t.closest(e,"."+is),y=this.parent.getContent().querySelector("."+Zo),v=!1,C=!1,w=Math.round(this.parent.getContent().clientHeight/this.parent.getRowHeight())-1,b=y?[].slice.call(this.parent.getFrozenVirtualContent().getElementsByClassName(is)):[].slice.call(this.parent.getContent().getElementsByClassName(is));if("Batch"===this.parent.editSettings.mode&&w>1&&b.length>=w&&b[b.length-1].getAttribute(us)===m.getAttribute(us)&&(C=!0),g){if(this.parent.frozenRows){var S=d?this.parent.getFrozenVirtualHeader().querySelector(gs).children:this.parent.getHeaderTable().querySelector(gs).children;v=(p=S.length>(parseInt(m.getAttribute(us),10)||0))&&parseInt(m.getAttribute(us),10)===S.length-1}(v||w>1&&b.length>=w&&("Bottom"===this.parent.editSettings.newRowPosition&&this.editModule.args&&"add"===this.editModule.args.requestType||f.classList.contains("e-lastrowcell")&&!m.classList.contains(os))||C)&&(c=!0)}var R=g?p?this.parent.getHeaderTable():this.parent.getContentTable():t.select("#"+this.parent.element.id+"_dialogEdit_wrapper .e-dlg-content",document),x=R.getBoundingClientRect(),F=g?this.parent.element.getBoundingClientRect().left:x.left,E=t.closest(e,"td"),I=E?E.getBoundingClientRect():e.parentElement.getBoundingClientRect(),T=this.parent.createElement("div",{className:"e-tooltip-wrap e-lib e-control e-popup e-griderror",id:n+"_Error",styles:"display:"+o+";top:"+((p?I.top+I.height:I.bottom-x.top-(d?y.scrollTop:0))+R.scrollTop+9)+"px;left:"+(I.left-F+R.scrollLeft+I.width/2)+"px;max-width:"+I.width+"px;text-align:center;"});g&&x.left<F&&(T.style.left=parseInt(T.style.left,10)-x.left+F+"px");var z=this.parent.createElement("div",{className:"e-tip-content"});z.appendChild(i);var M;if(c?((M=this.parent.createElement("div",{className:"e-arrow-tip e-tip-bottom"})).appendChild(this.parent.createElement("div",{className:"e-arrow-tip-outer e-tip-bottom"})),M.appendChild(this.parent.createElement("div",{className:"e-arrow-tip-inner e-tip-bottom"}))):((M=this.parent.createElement("div",{className:"e-arrow-tip e-tip-top"})).appendChild(this.parent.createElement("div",{className:"e-arrow-tip-outer e-tip-top"})),M.appendChild(this.parent.createElement("div",{className:"e-arrow-tip-inner e-tip-top"}))),T.appendChild(z),T.appendChild(M),a||!d&&!this.parent.frozenRows||"Dialog"===this.parent.editSettings.mode)a?this.virtualFormObj.element.appendChild(T):this.formObj.element.appendChild(T);else{("Normal"===this.parent.editSettings.mode?t.closest(e,".e-editcell"):t.closest(e,"."+ts)).style.position="relative",T.style.position="absolute","Batch"===this.parent.editSettings.mode||t.closest(e,"."+Zo)||t.closest(e,"."+$o)||this.parent.frozenRows&&!d?l.appendChild(T):this.mFormObj.element.appendChild(T)}!c&&g&&h.getBoundingClientRect().bottom<I.bottom+I.height&&(h.scrollTop=h.scrollTop+T.offsetHeight+M.scrollHeight);var O=parseInt(document.defaultView.getComputedStyle(T,null).getPropertyValue("font-size"),10);if(T.getBoundingClientRect().width<I.width&&T.querySelector("label").getBoundingClientRect().height/(1.2*O)>=2&&(T.style.width=T.style.maxWidth),(d||this.parent.frozenRows)&&"Dialog"!==this.parent.editSettings.mode?T.style.left=E.offsetLeft+(E.offsetWidth/2-T.offsetWidth/2)+"px":T.style.left=parseInt(T.style.left,10)-T.offsetWidth/2+"px",g&&!u&&!this.parent.allowPaging||d||this.parent.frozenRows){h.style.position="static";var k=r.calculateRelativeBasedPosition(E,T);T.style.top=k.top+I.height+9+"px"}if(c){if(!u||d||"auto"===this.parent.height||this.parent.frozenRows||this.parent.enableVirtualization)T.style.bottom=I.height+9+"px";else{var A=h.scrollWidth>h.offsetWidth?H():0;T.style.bottom=this.parent.height-h.querySelector("table").offsetHeight-A+I.height+9+"px"}if(b.length<w&&"Bottom"===this.parent.editSettings.newRowPosition&&this.editModule.args&&"add"===this.editModule.args.requestType){var B=(this.parent.frozenRows?this.parent.frozenRows+(b.length-1):b.length-1)*this.parent.getRowHeight(),N=this.parent.getContent().clientHeight-B;T.style.bottom=N+9+"px"}T.style.top=null}},e.prototype.checkColumnIsGrouped=function(e){return!(e.visible||this.parent.groupSettings.columns.indexOf(e.field)>-1)},e.AddEditors=function(i){e.editCellType=t.extend(e.editCellType,i)},e.editCellType={dropdownedit:eh,numericedit:th,datepickeredit:ph,datetimepickeredit:ph,booleanedit:Za,defaultedit:rh,templateedit:ch},e}(),gh=function(){function e(e,i){this.showColumn=[],this.hideColumn=[],this.changedColumns=[],this.unchangedColumns=[],this.isDlgOpen=!1,this.initialOpenDlg=!0,this.stateChangeColumns=[],this.changedStateColumns=[],this.isInitialOpen=!1,this.isCustomizeOpenCC=!1,this.searchOperator="startswith",this.prevShowedCols=[],this.hideDialogFunction=this.hideDialog.bind(this),this.parent=e,this.serviceLocator=i,this.addEventListener(),this.cBoxTrue=n.createCheckBox(this.parent.createElement,!0,{checked:!0,label:" "}),this.cBoxFalse=n.createCheckBox(this.parent.createElement,!0,{checked:!1,label:" "}),this.cBoxTrue.insertBefore(this.parent.createElement("input",{className:"e-chk-hidden e-cc e-cc-chbox",attrs:{type:"checkbox"}}),this.cBoxTrue.firstChild),this.cBoxFalse.insertBefore(this.parent.createElement("input",{className:"e-chk-hidden e-cc e-cc-chbox",attrs:{type:"checkbox"}}),this.cBoxFalse.firstChild),this.cBoxFalse.querySelector(".e-frame").classList.add("e-uncheck"),this.parent.enableRtl&&t.addClass([this.cBoxTrue,this.cBoxFalse],["e-rtl"])}return e.prototype.destroy=function(){var e=this.parent.element;e&&(e.querySelector("."+Wo)||e.querySelector("."+Ko))&&(this.removeEventListener(),this.unWireEvents(),t.isNullOrUndefined(this.dlgObj)||!this.dlgObj.element||this.dlgObj.isDestroyed||this.dlgObj.destroy())},e.prototype.rtlUpdate=function(){this.parent.enableRtl?t.addClass([].slice.call(this.innerDiv.getElementsByClassName("e-checkbox-wrapper")),["e-rtl"]):t.removeClass([].slice.call(this.innerDiv.getElementsByClassName("e-checkbox-wrapper")),["e-rtl"])},e.prototype.addEventListener=function(){this.parent.isDestroyed||(t.EventHandler.add(document,"click",this.clickHandler,this),this.parent.on(Fi,this.enableAfterRenderEle,this),this.parent.on(Si,this.render,this),this.parent.addEventListener(Ot,this.hideDialogFunction),this.parent.on(Ki,this.destroy,this),this.parent.on(Gr,this.rtlUpdate,this),this.parent.on(_i,this.keyUpHandler,this),this.parent.on(Vn,this.onResetColumns,this))},e.prototype.removeEventListener=function(){this.parent.isDestroyed||(t.EventHandler.remove(document,"click",this.clickHandler),this.parent.off(Si,this.render),this.parent.off(Ki,this.destroy),this.parent.off(Fi,this.enableAfterRenderEle),this.parent.off(Gr,this.rtlUpdate),this.parent.on(_i,this.keyUpHandler,this),this.parent.off(Vn,this.onResetColumns),this.parent.removeEventListener(Ot,this.hideDialogFunction))},e.prototype.render=function(){this.l10n=this.serviceLocator.getService("localization"),this.renderDlgContent(),this.getShowHideService=this.serviceLocator.getService("showHideService")},e.prototype.clickHandler=function(e){var i=e.target;if(!this.isCustomizeOpenCC){if(t.isNullOrUndefined(t.closest(i,".e-cc"))&&t.isNullOrUndefined(t.closest(i,".e-cc-toolbar")))t.isNullOrUndefined(this.dlgObj)||!this.dlgObj.visible||i.classList.contains("e-toolbar-items")||(this.dlgObj.hide(),this.clearActions(),this.refreshCheckboxState(),this.isDlgOpen=!1);else if(i.classList.contains("e-columnchooser-btn")||i.classList.contains("e-cc-toolbar")){if(this.initialOpenDlg&&this.dlgObj.visible||!this.isDlgOpen)return void(this.isDlgOpen=!0)}else i.classList.contains("e-cc-cancel")&&(i.parentElement.querySelector(".e-ccsearch").value="",this.columnChooserSearch(""),this.removeCancelIcon(),this.refreshCheckboxButton());(this.parent.detailTemplate||this.parent.childGrid)&&(this.targetdlg=e.target)}this.isCustomizeOpenCC&&e.target.classList.contains("e-cc-cancel")&&this.refreshCheckboxState(),this.rtlUpdate()},e.prototype.hideDialog=function(){!t.isNullOrUndefined(this.dlgObj)&&this.dlgObj.visible&&(this.dlgObj.hide(),this.isDlgOpen=!1)},e.prototype.renderColumnChooser=function(e,i,n){if(this.dlgObj.visible||!this.parent.detailTemplate&&!this.parent.childGrid||this.hideOpenedDialog(),this.dlgObj.visible)this.hideDialog(),this.addcancelIcon(),this.clearActions(),this.refreshCheckboxState();else{if(this.beforeOpenColumnChooserEvent().cancel)return;n&&(this.targetdlg=n),this.refreshCheckboxState(),this.dlgObj.dataBind(),this.dlgObj.element.style.maxHeight="430px";var o=this.dlgObj.element.style.display;this.dlgObj.element.style.display="block";var s=this.parent.getHeaderContent().classList.contains("e-sticky"),l=t.closest(n,".e-toolbar-item"),a=void 0;s?(a=l.getBoundingClientRect(),this.dlgObj.element.classList.add("e-sticky")):(this.dlgObj.element.classList.remove("e-sticky"),a=r.calculateRelativeBasedPosition(l,this.dlgObj.element)),this.dlgObj.element.style.display=o,this.dlgObj.element.style.top=a.top+t.closest(n,".e-cc-toolbar").getBoundingClientRect().height+"px";t.isNullOrUndefined(t.closest(n,".e-bigger"))||(this.dlgObj.width=258),t.Browser.isDevice?(this.dlgObj.target=document.body,this.dlgObj.position={X:"center",Y:"center"},this.dlgObj.refreshPosition(),this.dlgObj.open=this.mOpenDlg.bind(this)):this.parent.enableRtl?this.dlgObj.element.style.left=n.offsetLeft+"px":this.dlgObj.element.style.left=a.left-250+t.closest(n,".e-cc-toolbar").clientWidth+2+"px",this.removeCancelIcon(),this.dlgObj.show(),this.parent.notify(nn,{dialog:this.dlgObj})}this.rtlUpdate()},e.prototype.openColumnChooser=function(e,i){if(this.isCustomizeOpenCC=!0,this.dlgObj.visible)this.hideDialog();else{this.beforeOpenColumnChooserEvent().cancel||(this.isInitialOpen?this.refreshCheckboxState():(this.dlgObj.content=this.renderChooserList(),this.updateIntermediateBtn()),this.dlgObj.dataBind(),this.dlgObj.position={X:"center",Y:"center"},t.isNullOrUndefined(e)?(this.dlgObj.position={X:"center",Y:"center"},this.dlgObj.refreshPosition()):(this.dlgObj.element.style.top="",this.dlgObj.element.style.left="",this.dlgObj.element.style.top=i+"px",this.dlgObj.element.style.left=e+"px"),this.dlgObj.beforeOpen=this.customDialogOpen.bind(this),this.dlgObj.show(),this.isInitialOpen=!0,this.dlgObj.beforeClose=this.customDialogClose.bind(this))}},e.prototype.enableAfterRenderEle=function(e){e.module===this.getModuleName()&&e.enable&&this.render()},e.prototype.keyUpHandler=function(e){"escape"===e.action&&this.hideDialog()},e.prototype.customDialogOpen=function(){var e=this.dlgObj.content.querySelector("input.e-ccsearch");t.EventHandler.add(e,"keyup",this.columnChooserManualSearch,this)},e.prototype.customDialogClose=function(){var e=this.dlgObj.content.querySelector("input.e-ccsearch");t.EventHandler.remove(e,"keyup",this.columnChooserManualSearch)},e.prototype.getColumns=function(){return this.parent.getColumns().filter(function(e){return"checkbox"!==e.type&&!0===e.showInColumnChooser||"checkbox"===e.type&&void 0!==e.field})},e.prototype.renderDlgContent=function(){this.dlgDiv=this.parent.createElement("div",{className:"e-ccdlg e-cc",id:this.parent.element.id+"_ccdlg"}),this.dlgDiv.setAttribute("aria-label",this.l10n.getConstant("ColumnChooserDialogARIA")),this.parent.element.appendChild(this.dlgDiv),this.dlgObj=new r.Dialog({header:this.l10n.getConstant("ChooseColumns"),showCloseIcon:!1,closeOnEscape:!1,locale:this.parent.locale,visible:!1,enableRtl:this.parent.enableRtl,target:document.getElementById(this.parent.element.id),buttons:[{click:this.confirmDlgBtnClick.bind(this),buttonModel:{content:this.l10n.getConstant("OKButton"),isPrimary:!0,cssClass:"e-cc e-cc_okbtn"}},{click:this.clearBtnClick.bind(this),buttonModel:{cssClass:"e-flat e-cc e-cc-cnbtn",content:this.l10n.getConstant("CancelButton")}}],content:this.renderChooserList(),width:250,cssClass:"e-cc",animationSettings:{effect:"None"}});this.dlgObj.isStringTemplate=!0,this.dlgObj.appendTo(this.dlgDiv),this.wireEvents()},e.prototype.renderChooserList=function(){this.mainDiv=this.parent.createElement("div",{className:"e-main-div e-cc"});var e=this.parent.createElement("div",{className:"e-cc-searchdiv e-cc e-input-group"}),t=this.parent.createElement("input",{className:"e-ccsearch e-cc e-input",attrs:{placeholder:this.l10n.getConstant("Search")}}),i=this.parent.createElement("span",{className:"e-ccsearch-icon e-icons e-cc e-input-group-icon",attrs:{title:this.l10n.getConstant("Search")}}),r=this.parent.createElement("div",{className:"e-cc-contentdiv"});this.innerDiv=this.parent.createElement("div",{className:"e-innerdiv e-cc"}),e.appendChild(t),e.appendChild(i),this.searchBoxObj=new vl(t);var n=this.refreshCheckboxList(this.parent.getColumns());return this.innerDiv.appendChild(n),r.appendChild(this.innerDiv),this.mainDiv.appendChild(e),this.mainDiv.appendChild(r),this.mainDiv},e.prototype.confirmDlgBtnClick=function(e){this.stateChangeColumns=[],this.changedStateColumns=[],this.changedColumns=this.changedColumns.length>0?this.changedColumns:this.unchangedColumns,this.changedColumnState(this.changedColumns);var i=this.ulElement.querySelector(".e-uncheck")&&this.ulElement.querySelectorAll(".e-uncheck:not(.e-selectall)").length;if(!t.isNullOrUndefined(e)&&i<this.parent.getColumns().length&&(this.hideColumn.length&&this.columnStateChange(this.hideColumn,!1),this.showColumn.length&&this.columnStateChange(this.showColumn,!0),this.getShowHideService.setVisible(this.stateChangeColumns,this.changedStateColumns),this.clearActions(),this.parent.notify(hr,{module:"edit"}),0===this.parent.getCurrentViewRecords().length)){this.parent.element.querySelector(".e-emptyrow").querySelector("td").setAttribute("colSpan",this.parent.getVisibleColumns().length.toString())}},e.prototype.onResetColumns=function(e){"columnstate"!==e.requestType||this.resetColumnState()},e.prototype.resetColumnState=function(){this.showColumn=[],this.hideColumn=[],this.hideDialog()},e.prototype.changedColumnState=function(e){for(var t=0;t<e.length;t++){var i=e[t],r=this.parent.getColumnByUid(i);this.changedStateColumns.push(r)}},e.prototype.columnStateChange=function(e,t){for(var i=0;i<e.length;i++){var r=e[i],n=this.parent.getColumnByUid(r);"checkbox"!==n.type&&(n.visible=t),this.stateChangeColumns.push(n)}},e.prototype.clearActions=function(){this.resetColumnState(),this.addcancelIcon()},e.prototype.clearBtnClick=function(){this.clearActions(),this.parent.notify(Un,{dialog:this.dlgObj})},e.prototype.checkstatecolumn=function(e,t,i){void 0===i&&(i=!1),e?(-1!==this.hideColumn.indexOf(t)&&this.hideColumn.splice(this.hideColumn.indexOf(t),1),-1===this.showColumn.indexOf(t)&&this.showColumn.push(t)):(-1!==this.showColumn.indexOf(t)&&this.showColumn.splice(this.showColumn.indexOf(t),1),-1===this.hideColumn.indexOf(t)&&this.hideColumn.push(t)),i?e?this.unchangedColumns.push(t):this.changedColumns.push(t):-1!==this.changedColumns.indexOf(t)?this.changedColumns.splice(this.changedColumns.indexOf(t),1):this.changedColumns.push(t)},e.prototype.columnChooserSearch=function(e){var t,r,n=!1,o=this.dlgDiv.querySelector(".e-footer-content"),s=this.ulElement.querySelector(".e-check")&&this.ulElement.querySelectorAll(".e-check:not(.e-selectall)").length;if(this.isInitialOpen=!0,o&&(r=o.querySelector(".e-btn").ej2_instances[0]),""===e?(this.removeCancelIcon(),t=this.getColumns(),n=!0):t=new i.DataManager(this.getColumns()).executeLocal((new i.Query).where("headerText",this.searchOperator,e,!0,this.parent.columnChooserSettings.ignoreAccent)),t.length)this.innerDiv.innerHTML=" ",this.innerDiv.classList.remove("e-ccnmdiv"),this.innerDiv.appendChild(this.refreshCheckboxList(t)),n?r&&s&&(r.disabled=!1):(this.addcancelIcon(),this.refreshCheckboxButton());else{var l=this.parent.createElement("span",{className:"e-cc e-nmatch"});l.innerHTML=this.l10n.getConstant("Matchs"),this.innerDiv.innerHTML=" ",this.innerDiv.appendChild(l),this.innerDiv.classList.add("e-ccnmdiv"),r&&(r.disabled=!0)}this.flag=!0,this.stopTimer()},e.prototype.wireEvents=function(){t.EventHandler.add(this.dlgObj.element,"click",this.checkBoxClickHandler,this),t.EventHandler.add(this.searchBoxObj.searchBox,"keyup",this.columnChooserManualSearch,this),this.searchBoxObj.wireEvent()},e.prototype.unWireEvents=function(){this.parent.isDestroyed||(this.dlgObj.element&&t.EventHandler.remove(this.dlgObj.element,"click",this.checkBoxClickHandler),t.EventHandler.remove(this.searchBoxObj.searchBox,"keyup",this.columnChooserManualSearch),this.searchBoxObj.unWireEvent())},e.prototype.checkBoxClickHandler=function(e){var t,i=D(e.target,"e-checkbox-wrapper");if(i){if(i.querySelector(".e-selectall")?this.updateSelectAll(!i.querySelector(".e-check")):$(i.parentElement),i.querySelector(".e-chk-hidden").focus(),i.querySelector(".e-check"))t=!0;else{if(!i.querySelector(".e-uncheck"))return;t=!1}this.updateIntermediateBtn();var r=D(i,"e-ccheck").getAttribute("uid"),n=this.parent.getColumns();if("grid-selectAll"===r){this.changedColumns=[],this.unchangedColumns=[];for(var o=0;o<n.length;o++)n[o].showInColumnChooser&&this.checkstatecolumn(t,n[o].uid,!0)}else this.checkstatecolumn(t,r);this.refreshCheckboxButton()}},e.prototype.updateIntermediateBtn=function(){var e=this.ulElement.children.length-1,i=[],r=this.ulElement.children[0].querySelector(".e-frame"),n=this.ulElement.querySelectorAll(".e-check:not(.e-selectall)").length,o=this.dlgObj.btnObj[0];o.disabled=!1,e===n?i=["e-check"]:n?i=["e-stop"]:(i=["e-uncheck"],o.disabled=!0),o.dataBind(),t.removeClass([r],["e-check","e-stop","e-uncheck"]),t.addClass([r],i)},e.prototype.updateSelectAll=function(e){for(var t=0,i=[].slice.call(this.ulElement.getElementsByClassName("e-frame"));t<i.length;t++){ie(i[t],e)}},e.prototype.refreshCheckboxButton=function(){for(var e=this.parent.getVisibleColumns(),t=0;t<e.length;t++){var i=e[t].uid;-1===this.prevShowedCols.indexOf(i)&&this.prevShowedCols.push(i)}for(t=0;t<this.hideColumn.length;t++){var r=this.prevShowedCols.indexOf(this.hideColumn[t]);-1!==r&&this.prevShowedCols.splice(r,1)}var n=0!==this.showColumn.length?1:this.prevShowedCols.length,o=this.dlgDiv.querySelector(".e-footer-content").querySelector(".e-btn").ej2_instances[0];o.disabled=!1;for(var s=[],l=[].slice.call(this.parent.element.getElementsByClassName("e-cc-chbox")),a=(t=0,l.length);t<a;t++){i=D(l[t],"e-ccheck").getAttribute("uid");s.push(i)}var h=this.showColumn.filter(function(e){return-1!==s.indexOf(e)});0===n&&0===h.length&&(o.disabled=!0),o.dataBind()},e.prototype.refreshCheckboxList=function(e){this.ulElement=this.parent.createElement("ul",{className:"e-ccul-ele e-cc"});var t=this.l10n.getConstant("SelectAll"),i=this.parent.createElement("li",{className:"e-cclist e-cc e-cc-selectall"}),r=this.createCheckBox(t,!1,"grid-selectAll");e.length&&(r.querySelector(".e-checkbox-wrapper").firstElementChild.classList.add("e-selectall"),r.querySelector(".e-frame").classList.add("e-selectall"),this.checkState(r.querySelector(".e-icons"),!0),i.appendChild(r),this.ulElement.appendChild(i));for(var n=0;n<e.length;n++){var o=e[n];this.renderCheckbox(o)}return this.ulElement},e.prototype.refreshCheckboxState=function(){this.dlgObj.element.querySelector(".e-cc.e-input").value="",this.columnChooserSearch("");for(var e=this.parent,t=this.dlgObj.element.querySelectorAll(".e-cc-chbox:not(.e-selectall)"),i=0,r=t.length;i<r;i++){var n=t[i],o=void 0;o=this.parent.childGrid||this.parent.detailTemplate?D(this.dlgObj.element.querySelectorAll(".e-cc-chbox:not(.e-selectall)")[i],"e-ccheck").getAttribute("uid"):D(n,"e-ccheck").getAttribute("uid");var s=e.getColumnByUid(o),l=[].slice.call(n.parentElement.getElementsByClassName("e-uncheck"));s.visible&&!l.length?(n.checked=!0,this.checkState(n.parentElement.querySelector(".e-icons"),!0)):(n.checked=!1,this.checkState(n.parentElement.querySelector(".e-icons"),!1))}},e.prototype.checkState=function(e,i){i?t.classList(e,["e-check"],["e-uncheck"]):t.classList(e,["e-uncheck"],["e-check"])},e.prototype.createCheckBox=function(e,t,i){var r=t?this.cBoxTrue.cloneNode(!0):this.cBoxFalse.cloneNode(!0);return r.querySelector(".e-label").innerHTML=e,te(i,r,"e-ccheck")},e.prototype.renderCheckbox=function(e){var t,i,r;if(e.showInColumnChooser){t=this.parent.createElement("li",{className:"e-cclist e-cc",styles:"list-style:None",id:"e-ccli_"+e.uid}),i=-1!==this.hideColumn.indexOf(e.uid),r=-1!==this.showColumn.indexOf(e.uid);var n=this.createCheckBox(e.headerText,e.visible&&!i||r,e.uid);t.appendChild(n),this.ulElement.appendChild(t)}this.isInitialOpen&&this.updateIntermediateBtn()},e.prototype.columnChooserManualSearch=function(e){this.addcancelIcon(),this.searchValue=e.target.value,this.stopTimer(),this.startTimer(e)},e.prototype.startTimer=function(e){var t=this,i=t.flag||13===e.keyCode?0:500;this.timer=window.setInterval(function(){t.columnChooserSearch(t.searchValue)},i)},e.prototype.stopTimer=function(){window.clearInterval(this.timer)},e.prototype.addcancelIcon=function(){this.dlgDiv.querySelector(".e-cc.e-ccsearch-icon").classList.add("e-cc-cancel")},e.prototype.removeCancelIcon=function(){this.dlgDiv.querySelector(".e-cc.e-ccsearch-icon").classList.remove("e-cc-cancel")},e.prototype.mOpenDlg=function(){t.Browser.isDevice&&(this.dlgObj.element.querySelector(".e-cc-searchdiv").classList.remove("e-input-focus"),this.dlgObj.element.querySelectorAll(".e-cc-chbox")[0].focus())},e.prototype.getModuleName=function(){return"columnChooser"},e.prototype.hideOpenedDialog=function(){for(var e=[].slice.call(document.getElementsByClassName("e-ccdlg")).filter(function(e){return e.classList.contains("e-popup-open")}),t=0,i=e.length;t<i;t++)(e[t].classList.contains("e-dialog")||this.parent.element.id+"_ccdlg"!==e[t].id)&&e[t].ej2_instances[0].hide()},e.prototype.beforeOpenColumnChooserEvent=function(){var e={requestType:"beforeOpenColumnChooser",element:this.parent.element,columns:this.getColumns(),cancel:!1,searchOperator:this.parent.columnChooserSettings.operator};return this.parent.trigger(hi,e),this.searchOperator=e.searchOperator,e},e}(),fh=function(){function r(e,t){this.hideColumnInclude=!1,this.foreignKeyData={},this.parent=e,!e.parentDetails&&t&&(this.foreignKeyData=t)}return r.getQuery=function(e,t){var i=t.generateQuery(!0).requiresCount();return t.isRemote()&&(e.groupSettings.enableLazyLoading&&e.groupSettings.columns.length?i.lazyLoad=[]:i.take(e.pageSettings.totalRecordsCount)),i},r.prototype.getFData=function(e,t){return ne(t,{},e,this.foreignKeyData[t.field])[0]},r.prototype.getGridRowModel=function(e,t,i,r){void 0===r&&(r=0);var n=[],o=t.length;if(o){for(var s=0;s<o;s++,r++){var l={isExpand:!1};l.data=t[s],l.index=r,i.childGrid&&("All"===i.hierarchyPrintMode?l.isExpand=!0:"Expanded"===i.hierarchyPrintMode&&this.parent.expandedRows&&this.parent.expandedRows[r]&&(l.isExpand=i.expandedRows[r].isExpand));var a=new jo(l);a.cells=this.generateCells(e,i),n.push(a)}this.processColumns(n)}return n},r.prototype.generateCells=function(t,i){var r=[];if(i.childGridLevel)for(var n=i.childGridLevel,o=0;n>o;o++)r.push(this.generateCell({},e.CellType.Indent));for(var s=0,l=t;s<l.length;s++){var a=l[s];r.push(this.generateCell(a,e.CellType.Data))}return r},r.prototype.getColumnData=function(e){var t,r=this,n=[],o=e.getForeignKeyColumns();if(o.length){for(var s=0;s<o.length;s++){var l="result"in o[s].dataSource?new i.DataManager(o[s].dataSource.result):o[s].dataSource;n.push(l.executeQuery(new i.Query))}t=Promise.all(n).then(function(e){for(var t=0;t<o.length;t++)r.foreignKeyData[o[t].field]=e[t].result})}return t},r.prototype.getHeaders=function(e,t){this.hideColumnInclude=!!t,this.colDepth=ge(e);for(var i=[],r=0;r<this.colDepth;r++)i[r]=new jo({}),i[r].cells=[];return i=this.processColumns(i),i=this.processHeaderCells(i,e),{rows:i,columns:this.generateActualColumns(e)}},r.prototype.getConvertedWidth=function(e){var t=parseFloat(e);return-1!==e.indexOf("%")?this.parent.element.getBoundingClientRect().width*t/100:t},r.prototype.generateActualColumns=function(e,t){void 0===t&&(t=[]);for(var i=0,r=e;i<r.length;i++){var n=r[i];if(!n.commands)if(n.columns){if(n.visible||this.hideColumnInclude){0!==this.getCellCount(n,0)&&this.generateActualColumns(n.columns,t)}}else(n.visible||this.hideColumnInclude)&&t.push(n)}return t},r.prototype.processHeaderCells=function(e,t){for(var i=t,r=0;r<i.length;r++)i[r].commands||(e=this.appendGridCells(i[r],e,0));return e},r.prototype.appendGridCells=function(t,i,r){if(t.columns||!1===t.visible&&!this.hideColumnInclude||t.commands){if(t.columns){var n=this.getCellCount(t,0);n&&i[r].cells.push(new Vo({cellType:e.CellType.StackedHeader,column:t,colSpan:n}));for(var o=void 0,s=0,l=t.columns.length;s<l;s++)t.columns[s].visible&&!o&&(o=!0),i=this.appendGridCells(t.columns[s],i,r+1)}}else i[r].cells.push(this.generateCell(t,e.CellType.Header,this.colDepth-r,r));return i},r.prototype.generateCell=function(t,i,r,n){var o={visible:t.visible,isDataCell:i===e.CellType.Data,column:t,cellType:i,rowSpan:r,index:n};return(!o.rowSpan||o.rowSpan<2)&&delete o.rowSpan,new Vo(o)},r.prototype.processColumns=function(t){var i=this.parent,r=[];i.enableColumnVirtualization&&(r=i.getColumnIndexesInView());for(var n=0,o=t.length;n<o;n++)if(i.allowGrouping)for(var s=0,l=i.groupSettings.columns.length-1;s<l;s++)i.enableColumnVirtualization&&-1===r.indexOf(s)||t[n].cells.splice(0,0,this.generateCell({},e.CellType.HeaderIndent));return t},r.prototype.getCellCount=function(e,t){if(e.columns)for(var i=0;i<e.columns.length;i++)t=this.getCellCount(e.columns[i],t);else(e.visible||this.hideColumnInclude)&&t++;return t},r.prototype.checkAndExport=function(e,t){Object.keys(e).some(function(t){return!e[t]})||t()},r.prototype.failureHandler=function(e,t,i){var r=this;return function(){e[t.id]=!0,r.checkAndExport(e,i)}},r.prototype.createChildGrid=function(e,i,r,n){var o=new Jl(this.parent.detailRowModule.getGridModel(e,i,r));e.isPrinting=!1;o.parentDetails={parentID:e.element.id,parentPrimaryKeys:e.getPrimaryKeyFieldNames(),parentKeyField:e.childGrid.queryString,parentKeyFieldValue:t.getValue(o.queryString,i.data),parentRowData:i.data};var s=N("child-grid"),l=t.createElement("div",{id:s,styles:"display: none"});return document.body.appendChild(l),o.id=s,n[s]=!1,o.isExportGrid=!0,{childGrid:o,element:l}},r.prototype.getGridExportColumns=function(e){for(var t=[],i=0,r=e;i<r.length;i++)"checkbox"!==r[i].type&&t.push(r[i]);return t},r.prototype.getForeignKeyData=function(){return this.foreignKeyData},r}(),mh=function(){function e(e){this.valueFormatter=new Ct(e),this.internationalization=new t.Internationalization(e)}return e.prototype.returnFormattedValue=function(e,i){return!t.isNullOrUndefined(e.value)&&e.value?this.valueFormatter.getFormatFunction(i)(e.value):""},e.prototype.formatCellValue=function(e){if(e.isForeignKey&&(e.value=t.getValue(e.column.foreignKeyValue,ne(e.column,{},e.value)[0])),"number"===e.column.type&&void 0!==e.column.format&&""!==e.column.format)return e.value||0===e.value?this.internationalization.getNumberFormat({format:e.column.format})(e.value):"";if("boolean"===e.column.type&&""!==e.value)return e.value?"true":"false";if("date"!==e.column.type&&"datetime"!==e.column.type&&"time"!==e.column.type||void 0===e.column.format)return(t.isNullOrUndefined(e.column.type)||t.isNullOrUndefined(e.value))&&t.isNullOrUndefined(e.value)?"":e.value.toString();if("string"==typeof e.value&&(e.value=new Date(e.value)),"string"==typeof e.column.format){var i=void 0,r=e.column.format;return i="date"===e.column.type?{type:"date",skeleton:r}:"time"===e.column.type?{type:"time",skeleton:r}:{type:"dateTime",skeleton:r},this.returnFormattedValue(e,i)}if(e.column.format instanceof Object&&void 0===e.column.format.type)return e.value.toString();var n=void 0;return n="date"===e.column.type?{type:e.column.format.type,format:e.column.format.format,skeleton:e.column.format.skeleton}:"time"===e.column.type?{type:"time",format:e.column.format.format,skeleton:e.column.format.skeleton}:{type:"dateTime",format:e.column.format.format,skeleton:e.column.format.skeleton},this.returnFormattedValue(e,n)},e}(),yh=function(){function r(e,t){this.book={},this.workSheet=[],this.rows=[],this.columns=[],this.styles=[],this.rowLength=1,this.expType="AppendToSheet",this.includeHiddenColumn=!1,this.isCsvExport=!1,this.isElementIdChanged=!1,this.gridPool={},this.sheet={},this.parent=e,this.helper=new fh(e),this.locator=t,this.l10n=this.locator.getService("localization")}return r.prototype.getModuleName=function(){return"ExcelExport"},r.prototype.init=function(e){null!==e.element&&""===e.element.id&&(e.element.id=(new Date).toISOString(),this.isElementIdChanged=!0),this.parent=e,this.parent.isDestroyed||(this.isExporting=void 0,this.book={},this.workSheet=[],this.rows=[],this.columns=[],this.styles=[],this.rowLength=1,this.footer=void 0,this.expType="AppendToSheet",this.includeHiddenColumn=!1,this.exportValueFormatter=new mh(e.locale),e.id=N("main-grid"),this.gridPool[e.id]=!1)},r.prototype.Map=function(e,i,r,n,o,s){var l=e;this.gridPool={},e.childGrid&&(t.isNullOrUndefined(i)||"None"!==i.hierarchyExportMode)&&(e.expandedRows=ce(e).expandedRows);var a={requestType:"beforeExcelExport",gridObject:l,cancel:!1,isMultipleExport:r,workbook:n,isCsv:o,isBlob:s};return l.trigger(Cr,a),a.cancel?new Promise(function(e){return e()}):(this.parent.log("exporting_begin",this.getModuleName()),this.data=new Uo(l),this.isExporting=!0,this.isBlob=a.isBlob,this.isCsvExport=!!a.isCsv&&a.isCsv,m(i)&&y(i,l),this.processRecords(l,i,a.isMultipleExport,a.workbook))},r.prototype.exportingSuccess=function(e){this.isExporting=!1,this.parent.trigger(wr,this.isBlob?{promise:this.blobPromise}:{}),this.parent.log("exporting_complete",this.getModuleName()),e(this.book),this.sheet.images=[]},r.prototype.processRecords=function(e,r,n,o){var s=this;if(!t.isNullOrUndefined(r)&&!t.isNullOrUndefined(r.dataSource)&&r.dataSource instanceof i.DataManager){var l=r.query?r.query:new i.Query;return(t.isNullOrUndefined(l.isCountRequired)||e.aggregates)&&(l.isCountRequired=!0),new Promise(function(t){r.dataSource.executeQuery(l).then(function(i){s.init(e),s.processInnerRecords(e,r,n,o,i).then(function(){s.exportingSuccess(t)})})})}if(t.isNullOrUndefined(r)||"CurrentPage"!==r.exportType){var a=[];return a.push(this.data.getData({},fh.getQuery(e,this.data))),a.push(this.helper.getColumnData(e)),new Promise(function(t,i){Promise.all(a).then(function(i){s.init(e),s.processInnerRecords(e,r,n,o,i[0]).then(function(){s.exportingSuccess(t)})}).catch(function(e){i(s.book),s.parent.trigger(Mt,e)})})}return new Promise(function(t){s.init(e),s.processInnerRecords(e,r,n,o,s.parent.getCurrentViewRecords()),s.exportingSuccess(t)})},r.prototype.processInnerRecords=function(e,i,r,n,o){var s=this;this.groupedColLength=e.groupSettings.columns.length;var l,a=5,d=[],p=ge(e.columns),c=!t.isNullOrUndefined(i);return c&&!t.isNullOrUndefined(i.multipleExport)&&(this.expType=t.isNullOrUndefined(i.multipleExport.type)?"AppendToSheet":i.multipleExport.type,t.isNullOrUndefined(i.multipleExport.blankRows)||(a=i.multipleExport.blankRows)),t.isNullOrUndefined(n)?(this.workSheet=[],this.rows=[],this.columns=[],this.styles=[]):"NewSheet"===this.expType?(this.workSheet=n.worksheets,this.rows=[],this.columns=[],this.styles=n.styles):(this.workSheet=[],this.rows=n.worksheets[0].rows,this.columns=n.worksheets[0].columns,this.styles=n.styles,this.rowLength=this.rows[this.rows.length-1].index+a,this.rowLength++),c&&(t.isNullOrUndefined(r)?(t.isNullOrUndefined(i.header)||this.processExcelHeader(JSON.parse(JSON.stringify(i.header))),t.isNullOrUndefined(i.footer)||(this.footer=JSON.parse(JSON.stringify(i.footer)))):(t.isNullOrUndefined(i.header)||!r&&"NewSheet"!==this.expType||this.processExcelHeader(JSON.parse(JSON.stringify(i.header))),t.isNullOrUndefined(i.footer)||("AppendToSheet"===this.expType?r||(this.footer=JSON.parse(JSON.stringify(i.footer))):this.footer=JSON.parse(JSON.stringify(i.footer))))),this.includeHiddenColumn=!!c&&i.includeHiddenColumn,new Promise(function(t,r){e.childGridLevel=0,d=s.processGridExport(e,i,o),s.globalResolve=t,s.gridPool[e.id]=!0,s.helper.checkAndExport(s.gridPool,s.globalResolve)}).then(function(){var o=[];if(s.organiseRows(d,d[0].index,o),s.rows=s.rows.concat(o),t.isNullOrUndefined(s.footer)||("AppendToSheet"===s.expType&&!r||"NewSheet"===s.expType)&&s.processExcelFooter(s.footer),s.columns.length>0&&(s.sheet.columns=s.columns),s.sheet.rows=s.rows,s.sheet.enableRtl=s.parent.enableRtl,s.parent.allowFiltering&&e.getVisibleColumns().length&&c&&i.enableFilter){var a=i.header?i.header.headerRows||i.header.rows.length:0,u={row:p+a,column:s.groupedColLength?s.groupedColLength+1:s.sheet.columns[0].index,lastRow:s.sheet.rows.length,lastColumn:s.sheet.columns.length};s.sheet.autoFilters=u}if(s.workSheet.push(s.sheet),s.book.worksheets=s.workSheet,s.book.styles=s.styles,e.notify("finalPageSetup",s.book),!r){if(s.isCsvExport){c&&!t.isNullOrUndefined(i.separator)&&","!==i.separator&&(l=i.separator);var g=new h.Workbook(s.book,"csv",e.locale,e.currencyCode,l);s.isBlob?s.blobPromise=g.saveAsBlob("text/csv"):c&&i.fileName?g.save(i.fileName):g.save("Export.csv")}else{g=new h.Workbook(s.book,"xlsx",e.locale,e.currencyCode);s.isBlob?s.blobPromise=g.saveAsBlob("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"):c&&i.fileName?g.save(i.fileName):g.save("Export.xlsx")}s.isElementIdChanged&&(e.element.id=""),delete e.expandedRows}return n})},r.prototype.organiseRows=function(e,t,i){if(!e.length)return t;for(var r=0;r<e.length;r++){var n=e[r],o=n.childRows;o?(n.index=t++,delete n.childRows,i.push(n),t=this.organiseRows(o,t,i)):(n.index=t++,i.push(n))}return t},r.prototype.processGridExport=function(e,r,n){var o=[],s=this.parent.isFrozenGrid()&&!this.parent.getFrozenColumns();t.isNullOrUndefined(r)||t.isNullOrUndefined(r.theme)||(this.theme=r.theme),e.childGrid&&!t.isNullOrUndefined(r)&&(e.hierarchyPrintMode=r.hierarchyExportMode||"Expanded");var l=new fh(e,this.helper.getForeignKeyData()),a=m(r)?I(r.columns,e.enableColumnVirtualization):l.getGridExportColumns(s?e.getColumns():e.columns),h=l.getHeaders(a,this.includeHiddenColumn),d=e.groupSettings.columns.length?e.groupSettings.columns.length-1:0;return o=this.processHeaderContent(e,h,d,o),o=t.isNullOrUndefined(r)||t.isNullOrUndefined(r.dataSource)||r.dataSource instanceof i.DataManager?t.isNullOrUndefined(r)||"CurrentPage"!==r.exportType?this.processRecordContent(e,n,h,r,void 0,o,l):this.processRecordContent(e,n,h,r,e.currentViewData,o,l):this.processRecordContent(e,n,h,r,r.dataSource,o,l),e.notify(tn,{excelRows:o,type:"excel"}),o},r.prototype.processRecordContent=function(e,i,r,n,o,s,l){var a;if(a=!t.isNullOrUndefined(o)&&o.length?o:i.result,t.isNullOrUndefined(a.level)?this.processRecordRows(e,a,r,0,0,n,s,l):this.processGroupedRows(e,a,r,a.level,0,n,s,l),!t.isNullOrUndefined(i.aggregates))if(t.isNullOrUndefined(o)){var h=i.result.GroupGuid?i.result.records:i.result;this.processAggregates(e,h,s)}else this.processAggregates(e,i.result,s,o);return s},r.prototype.processGroupedRows=function(e,i,r,n,o,s,l,a){for(var h=0,d=i;h<d.length;h++){var p=d[h],c=[],u={};u.index=1+n-1;var g=e.getColumnByField(p.field),f={value:p.key,column:g,style:void 0,isForeignKey:g.isForeignColumn()},m=e.getColumnByField(p.field).headerText+": "+(g.enableGroupByFormat?p.key:this.exportValueFormatter.formatCellValue(f))+" - ";p.count>1?m+=p.count+" items":m+=p.count+" item";var y={captionText:m,type:this.isCsvExport?"CSV":"Excel",data:p};this.parent.trigger(vi,y),u.value=y.captionText,u.style=this.getCaptionThemeStyle(this.theme);var v=new Ds(e).generateRows(p);if(this.fillAggregates(e,v,i.level+i.childLevels-1,l,this.rowLength),c.push(u),l[l.length-1].cells.length>0){for(var C=i.level+i.childLevels+v[0].cells.length,w=0,b=0,S=l[l.length-1].cells;b<S.length;b++){var R=S[b];R.index<C&&(C=R.index),R.index>w&&(w=R.index),c[c.length-1].index!==R.index&&c.push(R)}for(C-u.index>1&&(u.colSpan=C-u.index);w<r.columns.length+n+i.childLevels;){var x={};x.index=w+1,x.style=this.getCaptionThemeStyle(this.theme),c.push(x),w++}}else{for(var F=0,E=0,I=r.columns;E<I.length;E++){I[E].visible&&F++}u.colSpan=i.childLevels+F}if(l[l.length-1].cells=c,this.rowLength++,this.groupedColLength<8&&n>1){var T={outlineLevel:n-1,isCollapsed:!0};l[l.length-1].grouping=T}!t.isNullOrUndefined(i.childLevels)&&i.childLevels>0?(this.processGroupedRows(e,p.items,r,p.items.level,o,s,l,a),this.processAggregates(e,p,l,void 0,n-1+i.childLevels,!0)):(o=this.processRecordRows(e,p.items,r,n-1,o,s,l,a),this.processAggregates(e,p,l,void 0,n-1,!0))}},r.prototype.processRecordRows=function(i,r,n,o,s,l,a,h){for(var d=1,p=[],c=n.columns,u=0,g=h.getGridRowModel(c,r,i,s);u<g.length;u++){var f=g[u];p=[],s++,d=1;for(var m=void 0,y=0,v=f.cells.length;y<v;y++){var C=f.cells[y];if(C.cellType===e.CellType.Data){var w=C.column,b=w.field,S=t.isNullOrUndefined(b)?"":w.valueAccessor(b,f.data,w),R=t.isNullOrUndefined(S)?"":S,x=void 0;if(w.isForeignColumn&&w.isForeignColumn()&&(x=h.getFData(R,w),R=t.getValue(w.foreignKeyValue,x)),!t.isNullOrUndefined(R)){var F={},E=d+o+i.childGridLevel,I={data:f.data,column:w,foreignKeyData:x,value:R,style:void 0,colSpan:1,cell:F};if(i.trigger(br,I),t.isNullOrUndefined(I.image)||t.isNullOrUndefined(I.image.base64)||(m=this.setImage(I,E)),t.isNullOrUndefined(I.hyperLink)||(I.cell.hyperlink={target:I.hyperLink.target},I.value=I.hyperLink.displayText||I.value),F=I.cell,F.index=E,F.value=I.value,""===I.data&&i.childGridLevel&&1===d){var T={};T.hAlign="left",I={style:T},F.colSpan=i.getVisibleColumns().length,F.value=this.l10n.getConstant("EmptyRecord")}if(I.colSpan>1&&(F.colSpan=I.colSpan),t.isNullOrUndefined(I.style))F.style={name:i.element.id+"column"+(d+o)};else{var z=this.getColumnStyle(i,d+o);F.style=this.mergeOptions(this.styles[z],I.style)}p.push(F)}d++}}var D={index:this.rowLength++,cells:p};if(t.isNullOrUndefined(m)||(D.height=m),this.groupedColLength&&this.groupedColLength<8&&o+1>0?(D.grouping={outlineLevel:o+1,isCollapsed:!0},a.push(D)):a.push(D),f.isExpand&&!t.isNullOrUndefined(i.childGrid)){i.isPrinting=!0;var M=!t.isNullOrUndefined(l)&&l.exportType?l.exportType:"AllPages",O=this.helper.createChildGrid(i,f,M,this.gridPool),k=O.childGrid,A=O.element;k.actionFailure=h.failureHandler(this.gridPool,k,this.globalResolve),k.childGridLevel=i.childGridLevel+1;var B={childGrid:k,row:f,exportProperties:l};this.parent.trigger(Rr,B),k.beforeDataBound=this.childGridCell(D,k,l,f),k.appendTo(A)}i.notify(en,{rowObj:f,type:"excel",excelRows:a})}return s},r.prototype.setImage=function(e,i){t.isNullOrUndefined(this.sheet.images)&&(this.sheet.images=[]);var r={image:e.image.base64,row:this.rowLength,column:i,lastRow:this.rowLength,lastColumn:i};return this.sheet.images.push(r),this.columns[i-1].width=e.image.width||this.columns[i-1].width,e.image.height||50},r.prototype.childGridCell=function(e,i,r,n){var o=this;return function(s){i.beforeDataBound=null,s.cancel=!0,0===s.result.length&&(s.result=[""]),e.childRows=o.processGridExport(i,r,s);for(var l=o.parent.groupSettings.columns.length,a=e.childRows,h=0;h<a.length;h++)a[h].grouping={outlineLevel:l+i.childGridLevel,isCollapsed:!n.isExpand,isHidden:!n.isExpand};return i.destroy(),t.detach(i.element),o.gridPool[i.id]=!0,o.helper.checkAndExport(o.gridPool,o.globalResolve),e}},r.prototype.processAggregates=function(e,i,r,n,o,s){var l=new Ts(e),a=l.getColumns();a=a.filter(function(e){return t.isNullOrUndefined(e.commands)&&"checkbox"!==e.type}),e.aggregates.length&&this.parent!==e&&e.aggregateModule.prepareSummaryInfo();var h=void 0;if(h=t.isNullOrUndefined(n)?i:n,void 0===o&&(o=0),e.groupSettings.columns.length>0&&s){var d=new zs(e).generateRows(h,{level:h.level});d.length>0&&(r=this.fillAggregates(e,d,o,r))}else{o=e.groupSettings.columns.length>0&&!s?e.groupSettings.columns.length:o;var p=l.generateRows(h,i.aggregates,null,null,a);p.length>0&&!s&&(o=e.groupSettings.columns.length?o-1:o,r=this.fillAggregates(e,p,o,r))}return r},r.prototype.fillAggregates=function(i,r,n,o,s){for(var l=0,a=r;l<a.length;l++){for(var h=a[l],d=[],p=!0,c=0,u=0,g=h.cells;u<g.length;u++){var f=g[u],m={};if(f.cellType!==e.CellType.DetailFooterIntent&&(f.visible||this.includeHiddenColumn))if(c++,f.isDataCell){p=!1;var y=!t.isNullOrUndefined(f.column.footerTemplate),v=!t.isNullOrUndefined(f.column.groupFooterTemplate),C=!t.isNullOrUndefined(f.column.groupCaptionTemplate);if(m.index=c+n+i.childGridLevel,y)m.value=this.getAggreateValue(e.CellType.Summary,f.column.footerTemplate,f,h);else if(v)m.value=this.getAggreateValue(e.CellType.GroupSummary,f.column.groupFooterTemplate,f,h);else if(C)m.value=this.getAggreateValue(e.CellType.CaptionSummary,f.column.groupCaptionTemplate,f,h);else for(var w=0,b=Object.keys(h.data[f.column.field]);w<b.length;w++){b[w]===f.column.type&&(t.isNullOrUndefined(h.data[f.column.field].Sum)?t.isNullOrUndefined(h.data[f.column.field].Average)?t.isNullOrUndefined(h.data[f.column.field].Max)?t.isNullOrUndefined(h.data[f.column.field].Min)?t.isNullOrUndefined(h.data[f.column.field].Count)?t.isNullOrUndefined(h.data[f.column.field].TrueCount)?t.isNullOrUndefined(h.data[f.column.field].FalseCount)?t.isNullOrUndefined(h.data[f.column.field].Custom)||(m.value=h.data[f.column.field].Custom):m.value=h.data[f.column.field][f.column.field+" - falsecount"]:m.value=h.data[f.column.field][f.column.field+" - truecount"]:m.value=h.data[f.column.field][f.column.field+" - count"]:m.value=h.data[f.column.field][f.column.field+" - min"]:m.value=h.data[f.column.field][f.column.field+" - max"]:m.value=h.data[f.column.field][f.column.field+" - average"]:m.value=h.data[f.column.field][f.column.field+" - sum"])}m.style=this.getCaptionThemeStyle(this.theme),this.aggregateStyle(f.column,m.style,f.column.field);var S=f.attributes.style;S.textAlign&&(m.style.hAlign=S.textAlign.toLowerCase());var R={row:h,type:y?"Footer":v?"GroupFooter":"GroupCaption",style:m};this.parent.trigger(_n,R),d.push(m)}else void 0===s&&(m.index=c+n+i.childGridLevel,m.style=this.getCaptionThemeStyle(this.theme),d.push(m))}if(t.isNullOrUndefined(s)){var x={};if(this.groupedColLength<8&&this.groupedColLength>0){var F={outlineLevel:o[o.length-1].grouping.outlineLevel,isCollapsed:!0};x={index:this.rowLength++,cells:d,grouping:F}}else x={index:this.rowLength++,cells:d};p||o.push(x)}else o.push({index:s,cells:d})}return o},r.prototype.aggregateStyle=function(e,i,r){var n=this.parent.getColumnByField(r);if("object"==typeof e.format){var o=e.format;i.numberFormat=t.isNullOrUndefined(o.format)?o.skeleton:o.format,t.isNullOrUndefined(o.type)||(i.type=o.type.toLowerCase())}else i.numberFormat=e.format;!t.isNullOrUndefined(n)&&t.isNullOrUndefined(i.type)&&(i.type=n.type.toLowerCase())},r.prototype.getAggreateValue=function(i,r,n,o){var s={};s[t.getEnumValue(e.CellType,n.cellType)]=t.compile(r);var l,a=o.data[n.column.field?n.column.field:n.column.columnName];return this.parent.isReact||this.parent.isVue?(l=s[t.getEnumValue(e.CellType,n.cellType)](a,this.parent),this.parent.isReact&&this.parent.renderTemplates()):l=s[t.getEnumValue(e.CellType,n.cellType)](a),l[0].textContent},r.prototype.mergeOptions=function(e,t){for(var i={},r=Object.keys(e),n=0;n<r.length;n++)"name"!==r[n]&&(i[r[n]]=e[r[n]]);r=Object.keys(t);for(n=0;n<r.length;n++)"name"!==r[n]&&(i[r[n]]=t[r[n]]);return i},r.prototype.getColumnStyle=function(e,t){for(var i=0,r=0,n=this.styles;r<n.length;r++){if(n[r].name===e.element.id+"column"+t)return i;i++}},r.prototype.processHeaderContent=function(i,r,n,o){var s=r.rows,l=r.columns,a=[];if(n>0)for(var h=0;h!==n;)this.columns.push({index:h+1,width:30}),h++;for(var d=0;d<l.length;d++)this.parseStyles(i,l[d],this.getRecordThemeStyle(this.theme),n+d+1);for(var p,c=0;c<s.length;c++){for(var u=1+n,g=[],f=0;f<s[c].cells.length;f++){var m={},y={},v=s[c].cells[f];if(v.cellType!==e.CellType.HeaderIndent&&v.cellType!==e.CellType.DetailHeader){for(var C={contains:!0,index:1};C.contains;)if(C=this.getIndex(a,1,u),u=C.index,!C.contains){y.index=C.index+i.childGridLevel;break}if(!t.isNullOrUndefined(v.rowSpan)&&1!==v.rowSpan){y.rowSpan=v.rowSpan;for(var w=1;w<v.rowSpan+1;w++){var b={rowIndex:0,columnIndex:0};b.rowIndex=w,b.columnIndex=u,a.push(b)}}t.isNullOrUndefined(v.colSpan)||1===v.colSpan||(y.colSpan=v.colSpan,u=u+y.colSpan-1),y.value=v.column.headerText,m=this.getHeaderThemeStyle(this.theme),t.isNullOrUndefined(v.column.textAlign)||(m.hAlign=v.column.textAlign.toLowerCase()),t.isNullOrUndefined(v.column.headerTextAlign)||(m.hAlign=v.column.headerTextAlign.toLowerCase());var S={cell:y,gridCell:v,style:m};i.trigger(Sr,S),t.isNullOrUndefined(S.image)||t.isNullOrUndefined(S.image.base64)||(p=this.setImage(S,u)),t.isNullOrUndefined(S.hyperLink)||(S.cell.hyperlink={target:S.hyperLink.target},y.value=S.hyperLink.displayText||y.value),y.style=S.style,g.push(y),u++}}var R={index:this.rowLength++,cells:g};t.isNullOrUndefined(p)||(R.height=p),o.push(R)}return o},r.prototype.getHeaderThemeStyle=function(e){var i={};return i.fontSize=12,i.borders={color:"#E0E0E0"},i.bold=!0,t.isNullOrUndefined(e)||t.isNullOrUndefined(e.header)||(i=this.updateThemeStyle(e.header,i)),i},r.prototype.updateThemeStyle=function(e,i){return t.extend(i,e)},r.prototype.getCaptionThemeStyle=function(e){var i={};return i.fontSize=13,i.backColor="#F6F6F6",t.isNullOrUndefined(e)||t.isNullOrUndefined(e.caption)||(i=this.updateThemeStyle(e.caption,i)),i},r.prototype.getRecordThemeStyle=function(e){var i={};return i.fontSize=13,i.borders={color:"#E0E0E0"},t.isNullOrUndefined(e)||t.isNullOrUndefined(e.record)||(i=this.updateThemeStyle(e.record,i)),i},r.prototype.processExcelHeader=function(e){if(!t.isNullOrUndefined(e.rows)&&("NewSheet"===this.expType||1===this.rowLength)){var i=void 0;void 0===e.headerRows?this.rowLength=e.rows.length:this.rowLength=e.headerRows,i=this.rowLength<e.rows.length?this.rowLength:e.rows.length,this.rowLength++;for(var r=0;r<i;r++){var n=e.rows[r];(null===n.index||t.isNullOrUndefined(n.index))&&(n.index=r+1),this.updatedCellIndex(n)}}},r.prototype.updatedCellIndex=function(e){for(var i=e.cells.length,r=0;r<i;r++){var n=e.cells[r];(null===n.index||t.isNullOrUndefined(n.index))&&(n.index=r+1)}this.rows.push(e)},r.prototype.processExcelFooter=function(e){if(!t.isNullOrUndefined(e.rows)){var i=void 0;void 0===e.footerRows?this.rowLength+=e.rows.length:e.footerRows>e.rows.length?(this.rowLength+=e.footerRows-e.rows.length,i=e.rows.length):i=e.footerRows;for(var r=0;r<i;r++){var n=e.rows[r];null===n.index||void 0===n.index?n.index=this.rowLength++:n.index+=this.rowLength,this.updatedCellIndex(n)}}},r.prototype.getIndex=function(e,t,i){for(var r=0,n=e;r<n.length;r++){var o=n[r];if(o.rowIndex===t&&o.columnIndex===i)return i+=1,{contains:!0,index:i}}return{contains:!1,index:i}},r.prototype.parseStyles=function(e,i,r,n){if(!t.isNullOrUndefined(i.format))if("object"==typeof i.format){var o=i.format;r.numberFormat=t.isNullOrUndefined(o.format)?o.skeleton:o.format,t.isNullOrUndefined(o.type)||(r.type=o.type.toLowerCase())}else r.numberFormat=i.format,r.type=i.type;t.isNullOrUndefined(i.textAlign)||(r.hAlign=i.textAlign.toLowerCase()),Object.keys(r).length>0&&(r.name=e.element.id+"column"+n,this.styles.push(r)),t.isNullOrUndefined(i.width)||"auto"===i.width||this.columns.push({index:n+e.childGridLevel,width:"number"==typeof i.width?i.width:this.helper.getConvertedWidth(i.width)})},r.prototype.destroy=function(){},r}(),vh=function(){function r(e){this.hideColumnInclude=!1,this.currentViewData=!1,this.customDataSource=!1,this.isGrouping=!1,this.headerOnPages=[],this.drawPosition={xPosition:0,yPosition:0},this.parent=e,this.helper=new fh(e),this.gridPool={}}return r.prototype.getModuleName=function(){return"PdfExport"},r.prototype.init=function(e){this.exportValueFormatter=new mh(e.locale),this.pdfDocument=void 0,this.hideColumnInclude=!1,this.currentViewData=!1,this.parent=e,this.isGrouping=!1,this.isExporting=!0,e.id=N("main-grid"),this.gridPool[e.id]=!1,this.pdfPageSettings=new d.PdfPageSettings},r.prototype.exportWithData=function(e,i,r,n,o,s,l){var a=this;this.init(e),t.isNullOrUndefined(i)?this.pdfDocument=new d.PdfDocument:this.pdfDocument=i,this.processExport(e,n,o,s).then(function(){a.isExporting=!1,e.trigger(Fr,a.isBlob?{promise:a.blobPromise}:{}),a.parent.log("exporting_complete",a.getModuleName()),r(a.pdfDocument)}).catch(function(e){l(a.pdfDocument),a.parent.trigger(Mt,e)})},r.prototype.Map=function(e,r,n,o,s){var l=this;this.data=new Uo(this.parent),this.isBlob=s,this.gridPool={};var a=new i.Query;e.childGrid&&(t.isNullOrUndefined(r)||"None"!==r.hierarchyExportMode)&&(e.expandedRows=ce(e).expandedRows);var h={requestType:"beforePdfExport",cancel:!1,headerPageNumbers:[],gridDrawPosition:{xPosition:0,yPosition:0},generateQuery:!1};h.gridObject=e;if(e.trigger(xr,h),!0===h.cancel)return new Promise(function(e,t){return e()});if(m(r)&&y(r,e),h.generateQuery&&(a=fh.getQuery(e,this.data)),this.headerOnPages=h.headerPageNumbers,this.drawPosition=h.gridDrawPosition,this.parent.log("exporting_begin",this.getModuleName()),!t.isNullOrUndefined(r)&&!t.isNullOrUndefined(r.dataSource)&&r.dataSource instanceof i.DataManager)return new Promise(function(t,i){r.dataSource.executeQuery(a).then(function(s){l.exportWithData(e,o,t,s,r,n,i)})});if(t.isNullOrUndefined(r)||"CurrentPage"!==r.exportType){var p=[];return p.push(this.data.getData({},fh.getQuery(e,this.data))),p.push(this.helper.getColumnData(e)),new Promise(function(i,s){Promise.all(p).then(function(a){l.init(e),t.isNullOrUndefined(o)?l.pdfDocument=new d.PdfDocument:l.pdfDocument=o,l.processExport(e,a[0],r,n).then(function(){l.isExporting=!1,e.trigger(Fr,l.isBlob?{promise:l.blobPromise}:{}),l.parent.log("exporting_complete",l.getModuleName()),i(l.pdfDocument)}).catch(function(e){s(l.pdfDocument),l.parent.trigger(Mt,e)})})})}return new Promise(function(t,i){l.exportWithData(e,o,t,l.parent.getCurrentViewRecords(),r,n,i)})},r.prototype.processExport=function(e,i,r,n){var o,s=this,l=this.pdfDocument.sections.add();this.processSectionExportProperties(l,r);var a=l.pages.add();return new Promise(function(t,n){o=s.processGridExport(e,i,r),s.globalResolve=t,s.gridPool[e.id]=!0,s.helper.checkAndExport(s.gridPool,s.globalResolve)}).then(function(){return o.draw(a,s.drawPosition.xPosition,s.drawPosition.yPosition),s.drawHeader(r),n||(s.isBlob?s.blobPromise=s.pdfDocument.save():!t.isNullOrUndefined(r)&&r.fileName?s.pdfDocument.save(r.fileName):s.pdfDocument.save("Export.pdf"),s.pdfDocument.destroy(),delete e.expandedRows),s.pdfDocument})},r.prototype.processSectionExportProperties=function(e,i){return t.isNullOrUndefined(i)||t.isNullOrUndefined(i.pageOrientation)&&t.isNullOrUndefined(i.pageSize)||(this.pdfPageSettings.orientation="Landscape"===i.pageOrientation?d.PdfPageOrientation.Landscape:d.PdfPageOrientation.Portrait,this.pdfPageSettings.size=this.getPageSize(i.pageSize),e.setPageSettings(this.pdfPageSettings)),e},r.prototype.processGridExport=function(e,i,r){var n=!0,o=this.parent.isFrozenGrid()&&!this.parent.getFrozenColumns();t.isNullOrUndefined(r)||(this.gridTheme=r.theme,n=!!t.isNullOrUndefined(r.allowHorizontalOverflow)||r.allowHorizontalOverflow);var s=new fh(e,this.helper.getForeignKeyData()),l=this.processExportProperties(r,i.result),a=m(r)?I(r.columns,e.enableColumnVirtualization):s.getGridExportColumns(o?e.getColumns():e.columns);a=a.filter(function(e){return t.isNullOrUndefined(e.commands)});var h=!1;e.groupSettings.columns.length&&(h=!0),e.childGrid&&!t.isNullOrUndefined(r)&&(e.hierarchyPrintMode=r.hierarchyExportMode||"Expanded");var p=new d.PdfGrid,c=this.getHeaderThemeStyle(),u=c.border,g=c.font,f=c.brush,y=s.getHeaders(a,this.hideColumnInclude),v=y.columns;p=this.processGridHeaders(e.groupSettings.columns.length,p,y.rows,v,u,g,f,e,n,a),this.setColumnProperties(v,p,s,e,n);var C=this.getSummaryCaptionThemeStyle();if(!t.isNullOrUndefined(l)&&l.length){if(h?(t.isNullOrUndefined(C.border)||(u=C.border),this.processGroupedRecords(p,l,v,e,u,0,C.font,C.brush,C.backgroundBrush,i,r,s,0)):this.processRecord(u,v,e,l,p,0,r,s,0),!t.isNullOrUndefined(i.aggregates)){var w=new Ts(e),b=void 0,S=w.getColumns();S=S.filter(function(e){return t.isNullOrUndefined(e.commands)&&"checkbox"!==e.type}),e.aggregates.length&&this.parent!==e&&e.aggregateModule.prepareSummaryInfo(),b=this.customDataSource?w.generateRows(l,i.aggregates):this.currentViewData?w.generateRows(this.parent.getCurrentViewRecords(),i.aggregates):h?w.generateRows(l.records,i.aggregates):w.generateRows(i.result,i.aggregates,null,null,S),this.processAggregates(b,p,u,C.font,C.brush,C.backgroundBrush,!1,null,null,null,!h)}}else{p.rows.addRow().style.setBorder(u)}return p},r.prototype.getSummaryCaptionThemeStyle=function(){if(t.isNullOrUndefined(this.gridTheme)||t.isNullOrUndefined(this.gridTheme.caption))return{font:new d.PdfStandardFont(d.PdfFontFamily.Helvetica,9.75),brush:new d.PdfSolidBrush(new d.PdfColor(0,0,0)),backgroundBrush:new d.PdfSolidBrush(new d.PdfColor(246,246,246))};var e=t.isNullOrUndefined(this.gridTheme.caption.fontSize)?9.75:this.gridTheme.caption.fontSize,i=t.isNullOrUndefined(this.gridTheme.caption.fontName)?d.PdfFontFamily.Helvetica:this.getFontFamily(this.gridTheme.caption.fontName),r=this.getFontStyle(this.gridTheme.caption),n=new d.PdfColor(0,0,0);if(!t.isNullOrUndefined(this.gridTheme.caption.fontColor)){var o=this.hexToRgb(this.gridTheme.caption.fontColor);n=new d.PdfColor(o.r,o.g,o.b)}var s=this.gridTheme.caption.border?this.getBorderStyle(this.gridTheme.caption.border):null,l=new d.PdfStandardFont(i,e,r);return t.isNullOrUndefined(this.gridTheme.caption.font)||(l=this.gridTheme.caption.font),{font:l,brush:new d.PdfSolidBrush(n),backgroundBrush:new d.PdfSolidBrush(new d.PdfColor(246,246,246)),border:s}},r.prototype.getGridPdfFont=function(e){var i=0;if(e.header&&e.header.font){var r=e.header.font.fontFamily,n=e.header.font.fontSize,o=e.header.font.fontStyle;if(i=t.isNullOrUndefined(d.PdfFontStyle[o])?0:d.PdfFontStyle[o],e.header.font.isTrueType)e.header.font=new d.PdfTrueTypeFont(r,n,i);else{var s=t.isNullOrUndefined(r)?d.PdfFontFamily.Helvetica:this.getFontFamily(r);e.header.font=new d.PdfStandardFont(s,n,i)}}if(e.caption&&e.caption.font){var l=e.caption.font.fontFamily,a=e.caption.font.fontSize,h=e.caption.font.fontStyle;if(i=t.isNullOrUndefined(d.PdfFontStyle[h])?0:d.PdfFontStyle[h],e.caption.font.isTrueType)e.caption.font=new d.PdfTrueTypeFont(l,a,i);else{var p=t.isNullOrUndefined(l)?d.PdfFontFamily.Helvetica:this.getFontFamily(l);e.caption.font=new d.PdfStandardFont(p,a,i)}}if(e.record&&e.record.font){var c=e.record.font.fontFamily,u=e.record.font.fontSize,g=e.record.font.fontStyle;if(i=t.isNullOrUndefined(d.PdfFontStyle[g])?0:d.PdfFontStyle[g],e.record.font.isTrueType)e.record.font=new d.PdfTrueTypeFont(c,u,i);else{var f=t.isNullOrUndefined(c)?d.PdfFontFamily.Helvetica:this.getFontFamily(c);e.record.font=new d.PdfStandardFont(f,u,i)}}},r.prototype.getHeaderThemeStyle=function(){var e=new d.PdfBorders;if(t.isNullOrUndefined(this.gridTheme)||t.isNullOrUndefined(this.gridTheme.header))return e.all=new d.PdfPen(new d.PdfColor(234,234,234)),{border:e,font:new d.PdfStandardFont(d.PdfFontFamily.Helvetica,10.5),brush:new d.PdfSolidBrush(new d.PdfColor(102,102,102))};var i=t.isNullOrUndefined(this.gridTheme.header.fontName)?d.PdfFontFamily.Helvetica:this.getFontFamily(this.gridTheme.header.fontName),r=this.getFontStyle(this.gridTheme.header),n=t.isNullOrUndefined(this.gridTheme.header.fontSize)?10.5:this.gridTheme.header.fontSize,o=new d.PdfColor;if(!t.isNullOrUndefined(this.gridTheme.header.fontColor)){var s=this.hexToRgb(this.gridTheme.header.fontColor);o=new d.PdfColor(s.r,s.g,s.b)}var l=new d.PdfStandardFont(i,n,r);return t.isNullOrUndefined(this.gridTheme.header.font)||(l=this.gridTheme.header.font),{border:this.getBorderStyle(this.gridTheme.header.border),font:l,brush:new d.PdfSolidBrush(o)}},r.prototype.processGroupedRecords=function(e,i,r,n,o,s,l,a,h,p,c,u,g){for(var f=this,m=s,y=function(s){var y=e.rows.addRow(),C=n.getColumnByField(s.field),w={value:s.key,column:C,style:void 0,isForeignKey:C.isForeignColumn()},b={captionText:v.parent.getColumnByField(s.field).headerText+": "+(C.enableGroupByFormat?s.key:v.exportValueFormatter.formatCellValue(w))+" - "+s.count+(i.count>1?" items":" item"),type:"PDF",data:s};v.parent.trigger(vi,b,function(v){y.cells.getCell(m).value=v.captionText,y.cells.getCell(m).style.stringFormat=new d.PdfStringFormat(d.PdfTextAlignment.Left),y.style.setBorder(o),y.style.setFont(l),y.style.setTextBrush(a),y.style.setBackgroundBrush(h);var C,w=new Ds(n);if(C=t.isNullOrUndefined(s.items.records)?w.generateRows(s.items,s):w.generateRows(s.items.records,s),t.isNullOrUndefined(C)||0!==C.length||(y.cells.getCell(m+1).columnSpan=e.columns.count-(m+1)),!t.isNullOrUndefined(i.childLevels)&&i.childLevels>0){f.processAggregates(C,e,o,l,a,h,!0,y,m),f.processGroupedRecords(e,s.items,r,n,o,m+1,l,a,h,p,c,u,g);C=new zs(n).generateRows(s.items.records,s),f.processAggregates(C,e,o,l,a,h,!1)}else{f.processAggregates(C,e,o,l,a,h,!0,y,m),g=f.processRecord(o,r,n,s.items,e,m+1,c,u,g);C=new zs(n).generateRows(s.items,s);f.processAggregates(C,e,o,l,a,h,!1,null,null,!0)}})},v=this,C=0,w=i;C<w.length;C++){y(w[C])}},r.prototype.processGridHeaders=function(i,r,n,o,s,l,a,h,p,c){for(var u=this,g=o.length+i,f=ge(c),m=c,y=0,v=[],C=0;C<n.length;C++)v[C]=0;this.parent.groupSettings.columns.length&&(y=this.parent.groupSettings.columns.length-1,g-=1),r.columns.add(g),r.headers.add(n.length);var w=function(i,o,h,p,c){var g=r.headers.getHeader(i),f=g.cells.getCell(o),m=n[i].cells[v[i]];v[i]=v[i]+1,t.isNullOrUndefined(h.headerTextAlign)||(f.style.stringFormat=u.getHorizontalAlignment(h.headerTextAlign)),p>0&&(f.rowSpan=p,f.style.stringFormat=u.getVerticalAlignment("Bottom",f.style.stringFormat,h.textAlign)),c>0&&(f.columnSpan=c),g.style.setBorder(s),g.style.setFont(l),g.style.setTextBrush(a),f.value=h.headerText,t.isNullOrUndefined(m)||m.cellType!==e.CellType.HeaderIndent&&m.cellType!==e.CellType.DetailHeader||(f.value="",f.width=20);var y={cell:f,gridCell:m,style:f.style};u.parent.trigger(Ir,y);var C=y;t.isNullOrUndefined(C.image)||(f.value=new d.PdfBitmap(C.image.base64)),t.isNullOrUndefined(C.hyperLink)||(f.value=u.setHyperLink(C))},b=function(e,t,i,r,n,o){for(var s=0,l=0;l<e.length;l++)if(o&&(r=s=s+i+(0===l?0:-1),i=0),o||e[l].visible||(r-=1),e[l].columns&&e[l].columns.length){var a=b(e[l].columns,t-1,0,l+r,n+1,!1);w(n,l+r+y,e[l],0,a),i+=a,r=r+a-1}else(e[l].visible||u.hideColumnInclude)&&(i++,w(n,l+r+y,e[l],t,0));return i};return b(m,f,0,0,0,!0),r.columns.count>=6&&p&&(r.style.allowHorizontalOverflow=!0),r},r.prototype.processExportProperties=function(e,r){if(t.isNullOrUndefined(e))this.currentViewData=!1,this.customDataSource=!1;else{t.isNullOrUndefined(e.theme)||(this.gridTheme=e.theme);var n=this.pdfPageSettings.size;if(this.drawHeader(e),!t.isNullOrUndefined(e.footer)){var o=e.footer,s=new d.PointF(0,n.width-80-.75*o.fromBottom),l=new d.SizeF(n.width-80,.75*o.height),a=new d.RectangleF(s,l);this.pdfDocument.template.bottom=this.drawPageTemplate(new d.PdfPageTemplateElement(a),o)}t.isNullOrUndefined(e.includeHiddenColumn)||this.isGrouping||(this.hideColumnInclude=e.includeHiddenColumn),t.isNullOrUndefined(e.dataSource)?t.isNullOrUndefined(e.exportType)?(this.currentViewData=!1,this.customDataSource=!1):"CurrentPage"===e.exportType?(r=this.parent.currentViewData,this.currentViewData=!0,this.customDataSource=!1):(this.currentViewData=!1,this.customDataSource=!1):(e.dataSource instanceof i.DataManager||(r=e.dataSource),this.customDataSource=!0,this.currentViewData=!1)}return r},r.prototype.drawHeader=function(e){var i=this,r=this.pdfPageSettings.size;if(!t.isNullOrUndefined(e)&&!t.isNullOrUndefined(e.header)){var n=e.header,o=new d.PointF(0,n.fromTop),s=new d.SizeF(r.width-80,.75*n.height),l=new d.RectangleF(o,s);if(this.headerOnPages.length){var a=this.drawPageTemplate(new d.PdfPageTemplateElement(l),n);this.headerOnPages.filter(function(e){e-1>=0&&e-1<i.pdfDocument.pages.count-1&&i.pdfDocument.pages.getPageByIndex(e-1).graphics.drawPdfTemplate(a.template,new d.PointF(0,0))})}else this.pdfDocument.template.top=this.drawPageTemplate(new d.PdfPageTemplateElement(l),n)}},r.prototype.drawPageTemplate=function(e,t){for(var i=0,r=t.contents;i<r.length;i++){var n=r[i];switch(this.processContentValidation(n),n.type){case"Text":if(""===n.value||void 0===n.value||null===n.value||"string"!=typeof n.value)throw new Error("please enter the valid input value in text content...");this.drawText(e,n);break;case"PageNumber":this.drawPageNumber(e,n);break;case"Image":if(void 0===n.src||null===n.src||""===n.src)throw new Error("please enter the valid base64 string in image content...");this.drawImage(e,n);break;case"Line":this.drawLine(e,n);break;default:throw new Error("Please set valid content type...")}}return e},r.prototype.processContentValidation=function(e){if(void 0===e.type||null===e.type)throw new Error("please set valid content type...");if("Line"===e.type){if(void 0===e.points||null===e.points)throw new Error("please enter valid points in "+e.type+" content...");if(void 0===e.points.x1||null===e.points.x1||"number"!=typeof e.points.x1)throw new Error("please enter valid x1 co-ordinate in "+e.type+" points...");if(void 0===e.points.y1||null===e.points.y1||"number"!=typeof e.points.y1)throw new Error("please enter valid y1 co-ordinate in "+e.type+" points...");if(void 0===e.points.x2||null===e.points.x2||"number"!=typeof e.points.x2)throw new Error("please enter valid x2 co-ordinate in "+e.type+" points...");if(void 0===e.points.y2||null===e.points.y2||"number"!=typeof e.points.y2)throw new Error("please enter valid y2 co-ordinate in "+e.type+" points...")}else{if(void 0===e.position||null===e.position)throw new Error("please enter valid position in "+e.type+" content...");if(void 0===e.position.x||null===e.position.x||"number"!=typeof e.position.x)throw new Error("please enter valid x co-ordinate in "+e.type+" position...");if(void 0===e.position.y||null===e.position.y||"number"!=typeof e.position.y)throw new Error("please enter valid y co-ordinate in "+e.type+" position...")}},r.prototype.drawText=function(e,i){var r=this.getFont(i),n=this.getBrushFromContent(i),o=null;if(!t.isNullOrUndefined(i.style.textPenColor)){var s=this.hexToRgb(i.style.textPenColor);o=new d.PdfPen(new d.PdfColor(s.r,s.g,s.b))}null==n&&null==o&&(n=new d.PdfSolidBrush(new d.PdfColor(0,0,0)));var l=i.value.toString(),a=.75*i.position.x,h=.75*i.position.y,p=new d.PdfStringFormat,c=this.setContentFormat(i,p);null===c||t.isNullOrUndefined(c.format)||t.isNullOrUndefined(c.size)?e.graphics.drawString(l,r,o,n,a,h,p):e.graphics.drawString(l,r,o,n,a,h,c.size.width,c.size.height,c.format)},r.prototype.drawPageNumber=function(e,i){var r=this.getFont(i),n=null;if(t.isNullOrUndefined(i.style.textBrushColor))n=new d.PdfSolidBrush(new d.PdfColor(0,0,0));else{var o=this.hexToRgb(i.style.textBrushColor);n=new d.PdfSolidBrush(new d.PdfColor(o.r,o.g,o.b))}var s=new d.PdfPageNumberField(r,n);s.numberStyle=this.getPageNumberStyle(i.pageNumberType);var l,a;if(t.isNullOrUndefined(i.format))a="{0}",l=new d.PdfCompositeField(r,n,a,s);else{var h="$current";if(-1!==i.format.indexOf("$total")&&-1!==i.format.indexOf(h)){(p=new d.PdfPageCountField(r)).numberStyle=this.getPageNumberStyle(i.pageNumberType),a=i.format.indexOf("$total")>i.format.indexOf(h)?(a=i.format.replace(h,"0")).replace("$total","1"):(a=i.format.replace(h,"1")).replace("$total","0"),l=new d.PdfCompositeField(r,n,a,s,p)}else if(-1!==i.format.indexOf(h)&&-1===i.format.indexOf("$total"))a=i.format.replace(h,"0"),l=new d.PdfCompositeField(r,n,a,s);else{var p=new d.PdfPageCountField(r);a=i.format.replace("$total","0"),l=new d.PdfCompositeField(r,n,a,p)}}var c=.75*i.position.x,u=.75*i.position.y,g=this.setContentFormat(i,l.stringFormat);null===g||t.isNullOrUndefined(g.format)||t.isNullOrUndefined(g.size)||(l.stringFormat=g.format,l.bounds=new d.RectangleF(c,u,g.size.width,g.size.height)),l.draw(e.graphics,c,u)},r.prototype.drawImage=function(e,i){var r=.75*i.position.x,n=.75*i.position.y,o=t.isNullOrUndefined(i.size)?void 0:.75*i.size.width,s=t.isNullOrUndefined(i.size)?void 0:.75*i.size.height,l=new d.PdfBitmap(i.src);t.isNullOrUndefined(o)?e.graphics.drawImage(l,r,n):e.graphics.drawImage(l,r,n,o,s)},r.prototype.drawLine=function(e,i){var r=.75*i.points.x1,n=.75*i.points.y1,o=.75*i.points.x2,s=.75*i.points.y2,l=this.getPenFromContent(i);t.isNullOrUndefined(i.style)||null===i.style||(t.isNullOrUndefined(i.style.penSize)||null===i.style.penSize||"number"!=typeof i.style.penSize||(l.width=.75*i.style.penSize),l.dashStyle=this.getDashStyle(i.style.dashStyle)),e.graphics.drawLine(l,r,n,o,s)},r.prototype.processAggregates=function(i,r,n,o,s,l,a,h,d,p,c){for(var u=0,g=i;u<g.length;u++){for(var f=g[u],m=-1,y=0,v=!0,C=[],w=c?0:1,b=0;b<r.columns.count+w;b++){var S=f.cells[y];if(S.cellType!==e.CellType.DetailFooterIntent){if(!this.hideColumnInclude){for(;void 0===S.visible;)if(S.cellType!==e.CellType.DetailFooterIntent){if(t.isNullOrUndefined(h))C.push("");else if(t.isNullOrUndefined(h.cells.getCell(b).value))C.push("");else{var R={row:f,type:"GroupCaption",style:h.cells};this.parent.trigger(Gn,R),C.push(h.cells.getCell(b).value),v=!1,a||(b+=1)}b+=1,y+=1,S=f.cells[y]}for(;!t.isNullOrUndefined(S.visible)&&!S.visible;)y+=1,S=f.cells[y]}if(S.isDataCell){var x={};if(t.isNullOrUndefined(S.column.footerTemplate)&&t.isNullOrUndefined(S.column.groupCaptionTemplate)&&t.isNullOrUndefined(S.column.groupFooterTemplate)){F=this.getSummaryWithoutTemplate(f.data[S.column.field]);t.isNullOrUndefined(F)||C.push(F)}else{var F;x=(F=this.getTemplateFunction(x,b,m,S)).templateFunction,m=F.leastCaptionSummaryIndex;var E=void 0,I=f.data[S.column.field?S.column.field:S.column.columnName];this.parent.isReact||this.parent.isVue?(E=x[t.getEnumValue(e.CellType,S.cellType)](I,this.parent),this.parent.isReact&&this.parent.renderTemplates()):E=x[t.getEnumValue(e.CellType,S.cellType)](I),C.push(E[0].textContent),v=!1}}else C.push("");v&&""!==C[b]&&!t.isNullOrUndefined(C[b])&&null!==C[b]&&(v=!1),y+=1}else b--,y++}if(!c)if(a)for(b=this.parent.groupSettings.columns.length;b<C.length-1;b++)C[b]=C[b+1],C[b+1]=C[b+2]?C[b+2]:"";else C.splice(0,1);if(!v)if(a)for(b=0;b<r.columns.count;b++)h.cells.getCell(b).value=C[b].toString(),b===d&&-1!==m&&1!==m?h.cells.getCell(b).columnSpan=m-1-d:b===d&&-1===m&&(h.cells.getCell(b).columnSpan=r.columns.count-d);else{var T=r.rows.addRow();T.style.setBorder(n),T.style.setFont(o),T.style.setTextBrush(s),T.style.setBackgroundBrush(l);R={row:f,type:p?"GroupFooter":"Footer",style:T.cells};this.parent.trigger(Gn,R);for(var b=0;b<r.columns.count;b++)T.cells.getCell(b).value=C[b].toString()}}},r.prototype.getTemplateFunction=function(i,r,n,o){return t.isNullOrUndefined(o.column.footerTemplate)||o.cellType!==e.CellType.Summary?t.isNullOrUndefined(o.column.groupCaptionTemplate)?i[t.getEnumValue(e.CellType,e.CellType.GroupSummary)]=t.compile(o.column.groupFooterTemplate):(-1===n&&(n=r),i[t.getEnumValue(e.CellType,e.CellType.CaptionSummary)]=t.compile(o.column.groupCaptionTemplate)):i[t.getEnumValue(e.CellType,e.CellType.Summary)]=t.compile(o.column.footerTemplate),{templateFunction:i,leastCaptionSummaryIndex:n}},r.prototype.getSummaryWithoutTemplate=function(e){return t.isNullOrUndefined(e.Sum)?t.isNullOrUndefined(e.Average)?t.isNullOrUndefined(e.Max)?t.isNullOrUndefined(e.Min)?t.isNullOrUndefined(e.Count)?t.isNullOrUndefined(e.TrueCount)?t.isNullOrUndefined(e.FalseCount)?t.isNullOrUndefined(e.Custom)?void 0:e.Custom:e.FalseCount:e.TrueCount:e.Count:e.Min:e.Max:e.Average:e.Sum},r.prototype.setColumnProperties=function(e,i,r,n,o){for(var s=n.groupSettings.columns.length?n.groupSettings.columns.length-1:0,l=0;l<s;l++)i.columns.getColumn(l).width=20;for(l=0;l<e.length;l++)t.isNullOrUndefined(e[l].textAlign)||(i.columns.getColumn(l+s).format=this.getHorizontalAlignment(e[l].textAlign)),i.style.allowHorizontalOverflow&&!t.isNullOrUndefined(e[l].width)&&o&&(i.columns.getColumn(l+s).width="number"==typeof e[l].width?.75*e[l].width:.75*r.getConvertedWidth(e[l].width))},r.prototype.setRecordThemeStyle=function(e,i){if(t.isNullOrUndefined(this.gridTheme)||t.isNullOrUndefined(this.gridTheme.record))e.style.setTextBrush(new d.PdfSolidBrush(new d.PdfColor(0,0,0)));else{var r=t.isNullOrUndefined(this.gridTheme.record.fontName)?d.PdfFontFamily.Helvetica:this.getFontFamily(this.gridTheme.record.fontName),n=t.isNullOrUndefined(this.gridTheme.record.fontSize)?9.75:this.gridTheme.record.fontSize,o=this.getFontStyle(this.gridTheme.record),s=new d.PdfStandardFont(r,n,o);t.isNullOrUndefined(this.gridTheme.record.font)||(s=this.gridTheme.record.font),e.style.setFont(s);var l=new d.PdfColor;if(!t.isNullOrUndefined(this.gridTheme.record.fontColor)){var a=this.hexToRgb(this.gridTheme.record.fontColor);l=new d.PdfColor(a.r,a.g,a.b)}e.style.setTextBrush(new d.PdfSolidBrush(l))}var h=this.gridTheme&&this.gridTheme.record&&this.gridTheme.record.border?this.getBorderStyle(this.gridTheme.record.border):i;return e.style.setBorder(h),e},r.prototype.processRecord=function(i,r,n,o,s,l,a,h,p){for(var c=0,u=h.getGridRowModel(r,o,n,p);c<u.length;c++){var g=u[c];p++;for(var f=this.setRecordThemeStyle(s.rows.addRow(),i),m=g.cells.length,y=0;y<m;y++){var v=g.cells[y];if(v.cellType===e.CellType.Data){var C=v.column,w=C.field,b=t.isNullOrUndefined(w)?"":C.valueAccessor(w,g.data,C),S=t.isNullOrUndefined(b)?"":b,R=void 0;C.isForeignColumn&&C.isForeignColumn()&&(R=h.getFData(S,C),S=t.getValue(C.foreignKeyValue,R));if((M={data:g.data,value:S,column:C,style:void 0,colSpan:1,cell:F=f.cells.getCell(y)}).value="boolean"===M.column.type&&"string"==typeof M.value?M.value:this.exportValueFormatter.formatCellValue(M),this.parent.trigger(Er,M),t.isNullOrUndefined(M.image)||(M.value=new d.PdfBitmap(M.image.base64),M.value.height=M.image.height||M.value.height,M.value.width=M.image.width||M.value.width),F.value=M.value,t.isNullOrUndefined(M.hyperLink)||(F.value=this.setHyperLink(M)),t.isNullOrUndefined(M.style)||this.processCellStyle(F,M),M.colSpan>1){y+1+M.colSpan>f.cells.count&&(M.colSpan=f.cells.count-(y+1)),F.columnSpan=M.colSpan;for(var x=1;x<F.columnSpan;x++){f.cells.getCell(y+x).value=""}y+=M.colSpan-1}}}if(g.isExpand){var F,E=this.setRecordThemeStyle(s.rows.addRow(),i);(F=E.cells.getCell(l)).columnSpan=E.cells.count-l,F.style.cellPadding=new d.PdfPaddings(10,10,10,10),n.isPrinting=!0;var I=!t.isNullOrUndefined(a)&&a.exportType?a.exportType:"AllPages",T=this.helper.createChildGrid(n,g,I,this.gridPool),z=T.childGrid,D=T.element;z.actionFailure=h.failureHandler(this.gridPool,z,this.globalResolve);var M={childGrid:z,row:g,cell:F,exportProperties:a};this.parent.trigger(Rr,M),z.beforeDataBound=this.childGridCell(F,z,a),z.appendTo(D)}this.parent.notify(en,{type:"pdf",rowObj:g})}return p},r.prototype.setHyperLink=function(e){var t=new d.PdfTextWebLink;return t.url=e.hyperLink.target,t.text=e.hyperLink.displayText||e.hyperLink.target,t.font=new d.PdfStandardFont(d.PdfFontFamily.Helvetica,9.75),t.brush=new d.PdfSolidBrush(new d.PdfColor(51,102,187)),t},r.prototype.childGridCell=function(e,i,r){var n=this;return function(o){return i.beforeDataBound=null,o.cancel=!0,e.value=n.processGridExport(i,o,r),i.destroy(),t.detach(i.element),n.gridPool[i.id]=!0,n.helper.checkAndExport(n.gridPool,n.globalResolve),e}},r.prototype.processCellStyle=function(e,i){if(!t.isNullOrUndefined(i.style.backgroundColor)){var r=this.hexToRgb(i.style.backgroundColor);e.style.backgroundBrush=new d.PdfSolidBrush(new d.PdfColor(r.r,r.g,r.b))}if(t.isNullOrUndefined(i.style.textAlignment)||(e.style.stringFormat=this.getHorizontalAlignment(i.style.textAlignment)),t.isNullOrUndefined(i.style.cellPadding)||(e.style.cellPadding=i.style.cellPadding),t.isNullOrUndefined(i.style.verticalAlignment)||(e.style.stringFormat=this.getVerticalAlignment(i.style.verticalAlignment,e.style.stringFormat)),!t.isNullOrUndefined(i.style.textBrushColor)){var n=this.hexToRgb(i.style.textBrushColor);e.style.textBrush=new d.PdfSolidBrush(new d.PdfColor(n.r,n.g,n.b))}if(!t.isNullOrUndefined(i.style.textPenColor)){var o=this.hexToRgb(i.style.textPenColor);e.style.textPen=new d.PdfPen(new d.PdfColor(o.r,o.g,o.b))}if(t.isNullOrUndefined(i.style.fontFamily)&&t.isNullOrUndefined(i.style.fontSize)&&t.isNullOrUndefined(i.style.bold)&&t.isNullOrUndefined(i.style.italic)&&t.isNullOrUndefined(i.style.underline)&&t.isNullOrUndefined(i.style.strikeout)||(e.style.font=this.getFont(i)),!t.isNullOrUndefined(i.style.border)){var s=new d.PdfBorders,l=i.style.border.width,a=t.isNullOrUndefined(l)||"number"!=typeof l?void 0:.75*l,h=new d.PdfColor(196,196,196);if(!t.isNullOrUndefined(i.style.border.color)){var p=this.hexToRgb(i.style.border.color);h=new d.PdfColor(p.r,p.g,p.b)}var c=new d.PdfPen(h,a);t.isNullOrUndefined(i.style.border.dashStyle)||(c.dashStyle=this.getDashStyle(i.style.border.dashStyle)),s.all=c,e.style.borders=s}t.isNullOrUndefined(i.style.paragraphIndent)||(e.style.stringFormat=new d.PdfStringFormat,e.style.stringFormat.paragraphIndent=i.style.paragraphIndent)},r.prototype.getHorizontalAlignment=function(e,t){switch(void 0===t&&(t=new d.PdfStringFormat),e){case"Right":t.alignment=d.PdfTextAlignment.Right;break;case"Center":t.alignment=d.PdfTextAlignment.Center;break;case"Justify":t.alignment=d.PdfTextAlignment.Justify;break;case"Left":t.alignment=d.PdfTextAlignment.Left}return t},r.prototype.getVerticalAlignment=function(e,t,i){switch(void 0===t&&(t=new d.PdfStringFormat,t=this.getHorizontalAlignment(i,t)),e){case"Bottom":t.lineAlignment=d.PdfVerticalAlignment.Bottom;break;case"Middle":t.lineAlignment=d.PdfVerticalAlignment.Middle;break;case"Top":t.lineAlignment=d.PdfVerticalAlignment.Top}return t},r.prototype.getFontFamily=function(e){switch(e){case"TimesRoman":return 2;case"Courier":return 1;case"Symbol":return 3;case"ZapfDingbats":return 4;default:return 0}},r.prototype.getFont=function(e){if(e.font)return e.font;var i=t.isNullOrUndefined(e.style.fontSize)?9.75:.75*e.style.fontSize,r=t.isNullOrUndefined(e.style.fontFamily)?d.PdfFontFamily.TimesRoman:this.getFontFamily(e.style.fontFamily),n=d.PdfFontStyle.Regular;return!t.isNullOrUndefined(e.style.bold)&&e.style.bold&&(n|=d.PdfFontStyle.Bold),!t.isNullOrUndefined(e.style.italic)&&e.style.italic&&(n|=d.PdfFontStyle.Italic),!t.isNullOrUndefined(e.style.underline)&&e.style.underline&&(n|=d.PdfFontStyle.Underline),!t.isNullOrUndefined(e.style.strikeout)&&e.style.strikeout&&(n|=d.PdfFontStyle.Strikeout),new d.PdfStandardFont(r,i,n)},r.prototype.getPageNumberStyle=function(e){switch(e){case"LowerLatin":return 2;case"LowerRoman":return 3;case"UpperLatin":return 4;case"UpperRoman":return 5;default:return 1}},r.prototype.setContentFormat=function(e,i){if(!t.isNullOrUndefined(e.size)){var r=.75*e.size.width,n=.75*e.size.height;if(i=new d.PdfStringFormat(d.PdfTextAlignment.Left,d.PdfVerticalAlignment.Middle),!t.isNullOrUndefined(e.style.hAlign))switch(e.style.hAlign){case"Right":i.alignment=d.PdfTextAlignment.Right;break;case"Center":i.alignment=d.PdfTextAlignment.Center;break;case"Justify":i.alignment=d.PdfTextAlignment.Justify;break;default:i.alignment=d.PdfTextAlignment.Left}return t.isNullOrUndefined(e.style.vAlign)||(i=this.getVerticalAlignment(e.style.vAlign,i)),{format:i,size:new d.SizeF(r,n)}}return null},r.prototype.getPageSize=function(e){switch(e){case"Letter":return new d.SizeF(612,792);case"Note":return new d.SizeF(540,720);case"Legal":return new d.SizeF(612,1008);case"A0":return new d.SizeF(2380,3368);case"A1":return new d.SizeF(1684,2380);case"A2":return new d.SizeF(1190,1684);case"A3":return new d.SizeF(842,1190);case"A5":return new d.SizeF(421,595);case"A6":return new d.SizeF(297,421);case"A7":return new d.SizeF(210,297);case"A8":return new d.SizeF(148,210);case"A9":return new d.SizeF(105,148);case"B0":return new d.SizeF(2836,4008);case"B1":return new d.SizeF(2004,2836);case"B2":return new d.SizeF(1418,2004);case"B3":return new d.SizeF(1002,1418);case"B4":return new d.SizeF(709,1002);case"B5":return new d.SizeF(501,709);case"Archa":return new d.SizeF(648,864);case"Archb":return new d.SizeF(864,1296);case"Archc":return new d.SizeF(1296,1728);case"Archd":return new d.SizeF(1728,2592);case"Arche":return new d.SizeF(2592,3456);case"Flsa":return new d.SizeF(612,936);case"HalfLetter":return new d.SizeF(396,612);case"Letter11x17":return new d.SizeF(792,1224);case"Ledger":return new d.SizeF(1224,792);default:return new d.SizeF(595,842)}},r.prototype.getDashStyle=function(e){switch(e){case"Dash":return 1;case"Dot":return 2;case"DashDot":return 3;case"DashDotDot":return 4;default:return 0}},r.prototype.getPenFromContent=function(e){var i=new d.PdfPen(new d.PdfColor(0,0,0));if(!t.isNullOrUndefined(e.style)&&null!==e.style&&!t.isNullOrUndefined(e.style.penColor)){var r=this.hexToRgb(e.style.penColor);i=new d.PdfPen(new d.PdfColor(r.r,r.g,r.b))}return i},r.prototype.getBrushFromContent=function(e){var i=null;if(!t.isNullOrUndefined(e.style.textBrushColor)){var r=this.hexToRgb(e.style.textBrushColor);i=new d.PdfSolidBrush(new d.PdfColor(r.r,r.g,r.b))}return i},r.prototype.hexToRgb=function(e){if(null===e||""===e||7!==e.length)throw new Error("please set valid hex value for color...");e=e.substring(1);var t=parseInt(e,16);return{r:t>>16&255,g:t>>8&255,b:255&t}},r.prototype.getFontStyle=function(e){var i=d.PdfFontStyle.Regular;return!t.isNullOrUndefined(e)&&e.bold&&(i|=d.PdfFontStyle.Bold),!t.isNullOrUndefined(e)&&e.italic&&(i|=d.PdfFontStyle.Italic),!t.isNullOrUndefined(e)&&e.underline&&(i|=d.PdfFontStyle.Underline),!t.isNullOrUndefined(e)&&e.strikeout&&(i|=d.PdfFontStyle.Strikeout),i},r.prototype.getBorderStyle=function(e){var i=new d.PdfBorders;if(t.isNullOrUndefined(e))i.all=new d.PdfPen(new d.PdfColor(234,234,234));else{var r=e.width,n=t.isNullOrUndefined(r)||"number"!=typeof r?void 0:.75*r,o=new d.PdfColor(196,196,196);if(!t.isNullOrUndefined(e.color)){var s=this.hexToRgb(e.color);o=new d.PdfColor(s.r,s.g,s.b)}var l=new d.PdfPen(o,n);t.isNullOrUndefined(e.dashStyle)||(l.dashStyle=this.getDashStyle(e.dashStyle)),i.all=l}return i},r.prototype.destroy=function(){},r}(),Ch=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),wh=function(e){function i(t,i){var r=e.call(this,t,i)||this;return r.buttonElement=r.parent.createElement("button",{}),r.unbounDiv=r.parent.createElement("div",{className:"e-unboundcelldiv",styles:"display: inline-block"}),r.childRefs=[],r.element=r.parent.createElement("TD",{className:"e-rowcell e-unboundcell",attrs:{role:"gridcell",tabindex:"-1"}}),r.parent.on(Ki,r.destroyButtons,r),r}return Ch(i,e),i.prototype.destroyButtons=function(){for(var e=0;e<this.childRefs.length;e++)this.childRefs[e]&&!this.childRefs[e].isDestroyed&&this.childRefs[e].destroy();this.parent.off(Ki,this.destroyButtons)},i.prototype.render=function(e,i,r,n){var o=this.element.cloneNode();if(o.appendChild(this.unbounDiv.cloneNode()),o.setAttribute("aria-label","is Command column column header "+e.column.headerText),e.column.commandsTemplate)if(this.parent.isReact&&"string"!=typeof e.column.commandsTemplate){var s=this.parent+"commandsTemplate";e.column.getColumnTemplate()(i,this.parent,"commandsTemplate",s,null,null,o.firstElementChild),this.parent.renderTemplates()}else P(o.firstElementChild,e.column.getColumnTemplate()(i));else for(var l=0,a=e.commands;l<a.length;l++){var h=a[l];o=this.renderButton(o,h,r.index,h.uid)}return this.setAttributes(o,e,r),!this.parent.enableVirtualization&&this.parent.isEdit||n?(t.addClass([].slice.call(o.getElementsByClassName("e-edit-delete")),"e-hide"),t.removeClass([].slice.call(o.getElementsByClassName("e-save-cancel")),"e-hide")):(t.addClass([].slice.call(o.getElementsByClassName("e-save-cancel")),"e-hide"),t.removeClass([].slice.call(o.getElementsByClassName("e-edit-delete")),"e-hide")),o},i.prototype.renderButton=function(e,i,r,o){var s=this.buttonElement.cloneNode();t.attributes(s,{id:this.parent.element.id+(i.type||"")+"_"+r+"_"+o,type:"button",title:t.isNullOrUndefined(i.title)?i.buttonOption.content||this.localizer.getConstant(i.type)||i.type:i.title,"data-uid":o}),s.onclick=i.buttonOption.click;var l=new n.Button(i.buttonOption,s);switch(this.childRefs.push(l),l.commandType=i.type,e.firstElementChild.appendChild(l.element),i.type){case"Edit":case"Delete":t.addClass([s],["e-edit-delete","e-"+i.type.toLowerCase()+"button"]);break;case"Cancel":case"Save":t.addClass([s],["e-save-cancel","e-"+i.type.toLowerCase()+"button"])}return e},i}(Bs),bh=function(){function i(e,t){this.parent=e,this.locator=t,this.initiateRender(),this.addEventListener()}return i.prototype.initiateRender=function(){this.locator.getService("cellRendererFactory").addCellRenderer(e.CellType.CommandColumn,new wh(this.parent,this.locator))},i.prototype.commandClickHandler=function(e){var i=this.parent,r=t.closest(e.target,"button");if(r&&t.closest(e.target,".e-unboundcell")){for(var n,o=r.ej2_instances[0],s=o.commandType,l=r.getAttribute("data-uid"),a=i.getRowObjectFromUID(t.closest(r,"."+is).getAttribute("data-uid")),h=this.parent.columnModel,d=0;d<h.length;d++)if(h[d].commands)for(var p=h[d].commands,c=0;c<p.length;c++){if(p[c].uid===l&&p[c].type===s)n=p[c];else{var u=[].slice.call(t.closest(r,".e-unboundcell").querySelectorAll("button")).findIndex(function(e){return e===r});u>=0&&p[u].type===s&&(n=p[u])}}var g={cancel:!1,target:r,commandColumn:n,rowData:t.isNullOrUndefined(a)?void 0:a.data};this.parent.trigger("commandClick",g,function(e){if(!o.disabled&&i.editModule&&!e.cancel)switch(s){case"Edit":i.editModule.endEdit(),i.editModule.startEdit(t.closest(r,"tr"));break;case"Cancel":i.editModule.closeEdit();break;case"Save":i.editModule.endEdit();break;case"Delete":"Batch"!==i.editSettings.mode&&i.editModule.endEdit(),i.commandDelIndex=parseInt(t.closest(r,"tr").getAttribute(us),10),i.clearSelection(),i.selectRow(i.commandDelIndex,!1),i.editModule.deleteRecord(),i.commandDelIndex=void 0}})}},i.prototype.getModuleName=function(){return"commandColumn"},i.prototype.destroy=function(){this.parent.isDestroyed||this.removeEventListener()},i.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(Wi,this.commandClickHandler),this.parent.off(_i,this.keyPressHandler),this.parent.off(Si,this.load),this.parent.off(Ki,this.destroy))},i.prototype.addEventListener=function(){this.parent.isDestroyed||(this.parent.on(Wi,this.commandClickHandler,this),this.parent.on(_i,this.keyPressHandler,this),this.parent.on(Si,this.load,this),this.parent.on(Ki,this.destroy,this))},i.prototype.keyPressHandler=function(e){"enter"===e.action&&t.closest(e.target,".e-unboundcelldiv")&&(this.commandClickHandler(e),e.preventDefault())},i.prototype.load=function(){for(var e=this.parent.columnModel,t=0;t<e.length;t++)if(e[t].commands)for(var i=e[t].commands,r=0;r<i.length;r++)i[r].uid=N("gridcommand")},i}(),Sh={header:"."+Wo,content:"."+Ko,edit:".e-inline-edit",batchEdit:".e-editedbatchcell",editIcon:"e-edit",pager:".e-gridpager",delete:"e-delete",save:"e-save",cancel:"e-cancel",copy:"e-copy",pdf:"e-pdfexport",group:"e-icon-group",ungroup:"e-icon-ungroup",csv:"e-csvexport",excel:"e-excelexport",fPage:"e-icon-first",nPage:"e-icon-next",lPage:"e-icon-last",pPage:"e-icon-prev",ascending:"e-icon-ascending",descending:"e-icon-descending",groupHeader:"e-groupdroparea",touchPop:"e-gridpopup"},Rh=function(){function e(e,t){this.defaultItems={},this.disableItems=[],this.hiddenItems=[],this.localeText=this.setLocaleKey(),this.parent=e,this.gridID=e.element.id,this.serviceLocator=t,this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.isDestroyed||(this.parent.on(Fi,this.enableAfterRenderMenu,this),this.parent.on(bi,this.render,this),this.parent.on(Ki,this.destroy,this))},e.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(bi,this.render),this.parent.off(Fi,this.enableAfterRenderMenu),this.parent.off(Ki,this.destroy),t.EventHandler.remove(this.element,"keydown",this.keyDownHandler.bind(this)))},e.prototype.keyDownHandler=function(e){"Tab"!==e.code&&9!==e.which||this.contextMenu.close(),"Escape"===e.code&&(this.contextMenu.close(),this.parent.notify(vn,{}))},e.prototype.render=function(){this.parent.element.classList.add("e-noselect"),this.l10n=this.serviceLocator.getService("localization"),this.element=this.parent.createElement("ul",{id:this.gridID+"_cmenu"}),t.EventHandler.add(this.element,"keydown",this.keyDownHandler.bind(this)),this.parent.element.appendChild(this.element);var e="#"+this.gridID;this.contextMenu=new a.ContextMenu({items:this.getMenuItems(),enableRtl:this.parent.enableRtl,enablePersistence:this.parent.enablePersistence,locale:this.parent.locale,target:e,select:this.contextMenuItemClick.bind(this),beforeOpen:this.contextMenuBeforeOpen.bind(this),onOpen:this.contextMenuOpen.bind(this),onClose:this.contextMenuOnClose.bind(this),cssClass:"e-grid-menu"}),this.contextMenu.appendTo(this.element)},e.prototype.enableAfterRenderMenu=function(e){e.module===this.getModuleName()&&e.enable&&(this.contextMenu&&(this.contextMenu.destroy(),t.remove(this.element),this.parent.element.classList.remove("e-noselect")),this.render())},e.prototype.getMenuItems=function(){for(var e=[],t=[],i=0,r=this.parent.contextMenuItems;i<r.length;i++){var n=r[i];"string"==typeof n&&-1!==this.getDefaultItems().indexOf(n)?-1!==n.toLocaleLowerCase().indexOf("export")?t.push(this.buildDefaultItems(n)):e.push(this.buildDefaultItems(n)):"string"!=typeof n&&e.push(n)}if(t.length>0){var o=this.buildDefaultItems("export");o.items=t,e.push(o)}return e},e.prototype.getLastPage=function(){var e=Math.floor(this.parent.pageSettings.totalRecordsCount/this.parent.pageSettings.pageSize);return this.parent.pageSettings.totalRecordsCount%this.parent.pageSettings.pageSize&&(e+=1),e},e.prototype.contextMenuOpen=function(){this.isOpen=!0},e.prototype.contextMenuItemClick=function(e){switch(this.getKeyFromId(e.item.id)){case"AutoFitAll":this.parent.autoFitColumns([]);break;case"AutoFit":this.parent.autoFitColumns(this.targetColumn.field);break;case"Group":this.parent.groupColumn(this.targetColumn.field);break;case"Ungroup":this.parent.ungroupColumn(this.targetColumn.field);break;case"Edit":this.parent.editModule&&("Batch"===this.parent.editSettings.mode?this.row&&this.cell&&!isNaN(parseInt(this.cell.getAttribute(cs),10))&&this.parent.editModule.editCell(parseInt(this.row.getAttribute(us),10),this.parent.getColumns()[parseInt(this.cell.getAttribute(cs),10)].field):(this.parent.editModule.endEdit(),this.parent.editModule.startEdit(this.row)));break;case"Delete":this.parent.editModule&&("Batch"!==this.parent.editSettings.mode&&this.parent.editModule.endEdit(),1===this.parent.getSelectedRecords().length?this.parent.editModule.deleteRow(this.row):this.parent.deleteRecord());break;case"Save":this.parent.editModule&&this.parent.editModule.endEdit();break;case"Cancel":this.parent.editModule&&this.parent.editModule.closeEdit();break;case"Copy":this.parent.copy();break;case"PdfExport":this.parent.pdfExport();break;case"ExcelExport":this.parent.excelExport();break;case"CsvExport":this.parent.csvExport();break;case"SortAscending":this.isOpen=!1,this.parent.sortColumn(this.targetColumn.field,"Ascending");break;case"SortDescending":this.isOpen=!1,this.parent.sortColumn(this.targetColumn.field,"Descending");break;case"FirstPage":this.parent.goToPage(1);break;case"PrevPage":this.parent.goToPage(this.parent.pageSettings.currentPage-1);break;case"LastPage":this.parent.goToPage(this.getLastPage());break;case"NextPage":this.parent.goToPage(this.parent.pageSettings.currentPage+1)}e.column=this.targetColumn,e.rowInfo=this.targetRowdata,this.parent.trigger(Tr,e)},e.prototype.contextMenuOnClose=function(e){e.items.length>0&&e.items[0].parentObj instanceof a.ContextMenu&&this.updateItemStatus(),this.parent.notify(xo,{isOpen:!1})},e.prototype.getLocaleText=function(e){return this.l10n.getConstant(this.localeText[e])},e.prototype.updateItemStatus=function(){this.contextMenu.showItems(this.hiddenItems),this.contextMenu.enableItems(this.disableItems),this.hiddenItems=[],this.disableItems=[],this.isOpen=!1},e.prototype.contextMenuBeforeOpen=function(e){var i=t.closest(e.event.target,".e-grid");if(e.event&&i&&i!==this.parent.element)e.cancel=!0;else if(e.event&&(t.closest(e.event.target,"."+Sh.groupHeader)||t.closest(e.event.target,"."+Sh.touchPop)||t.closest(e.event.target,".e-summarycell")||t.closest(e.event.target,".e-groupcaption")||t.closest(e.event.target,".e-filterbarcell")))e.cancel=!0;else{this.targetColumn=this.getColumn(e.event),D(e.event.target,"e-grid")&&(this.targetRowdata=this.parent.getRowInfo(e.event.target)),t.isNullOrUndefined(e.parentItem)&&this.targetColumn&&this.targetRowdata.cell&&(this.parent.notify(xo,{isOpen:!0}),this.selectRow(e.event,!this.targetRowdata.cell.classList.contains("e-selectionbackground")||"Multiple"!==this.parent.selectionSettings.type));for(var r=[],n=[],o=0,s=e.items;o<s.length;o++){var l=s[o],a=this.getKeyFromId(l.id),h=this.defaultItems[a];if(-1!==this.getDefaultItems().indexOf(a))if(this.ensureDisabledStatus(a)&&this.disableItems.push(l.text),e.event&&(this.ensureTarget(e.event.target,Sh.edit)||this.ensureTarget(e.event.target,Sh.batchEdit)))"Save"!==a&&"Cancel"!==a&&this.hiddenItems.push(l.text);else{if(this.parent.editModule&&"Batch"===this.parent.editSettings.mode&&(t.closest(e.event.target,".e-gridform")||this.parent.editModule.getBatchChanges()[ss].length||this.parent.editModule.getBatchChanges()[ls].length||this.parent.editModule.getBatchChanges()[as].length)&&("Save"===a||"Cancel"===a))continue;t.isNullOrUndefined(e.parentItem)&&e.event&&!this.ensureTarget(e.event.target,h.target)&&this.hiddenItems.push(l.text)}else l.target&&e.event&&!this.ensureTarget(e.event.target,l.target)?l.separator?r.push(l.id):this.hiddenItems.push(l.text):this.ensureTarget(e.event.target,l.target)&&l.separator&&n.push(l.id)}n.length>0&&this.contextMenu.showItems(n,!0),this.contextMenu.enableItems(this.disableItems,!1),this.contextMenu.hideItems(this.hiddenItems),r.length>0&&this.contextMenu.hideItems(r,!0),this.eventArgs=e.event,e.column=this.targetColumn,e.rowInfo=this.targetRowdata,this.parent.trigger(Dr,e),(e.cancel||this.hiddenItems.length===e.items.length&&!e.parentItem)&&(this.updateItemStatus(),e.cancel=!0)}ve(this.parent.element,this.contextMenu.element.parentElement)},e.prototype.ensureTarget=function(e,i){var r=e;return(r=!this.ensureFrozenHeader(e)||i!==Sh.header&&i!==Sh.content?i===Sh.content||i===Sh.header?D(t.closest(e,"."+ts),i.substr(1,i.length)):t.closest(e,i):t.closest(e,i===Sh.header?"thead":gs))&&D(r,"e-grid")===this.parent.element},e.prototype.ensureFrozenHeader=function(e){return!(!this.parent.isFrozenGrid()&&!this.parent.frozenRows||!t.closest(e,Sh.header))},e.prototype.ensureDisabledStatus=function(e){var t=!1;switch(e){case"AutoFitAll":case"AutoFit":t=!(this.parent.ensureModuleInjected(Ta)&&!this.parent.isEdit)||this.targetColumn&&!this.targetColumn.field&&"AutoFit"===e;break;case"Group":(!this.parent.allowGrouping||this.parent.ensureModuleInjected(Ma)&&this.targetColumn&&this.parent.groupSettings.columns.indexOf(this.targetColumn.field)>=0||this.targetColumn&&!this.targetColumn.field)&&(t=!0);break;case"Ungroup":(!this.parent.allowGrouping||!this.parent.ensureModuleInjected(Ma)||this.parent.ensureModuleInjected(Ma)&&this.targetColumn&&this.parent.groupSettings.columns.indexOf(this.targetColumn.field)<0)&&(t=!0);break;case"Edit":case"Delete":case"Save":case"Cancel":this.parent.editModule&&0!==this.parent.getDataRows().length||(t=!0);break;case"Copy":(0===this.parent.getSelectedRowIndexes().length&&0===this.parent.getSelectedRowCellIndexes().length||0===this.parent.getCurrentViewRecords().length)&&(t=!0);break;case"export":this.parent.allowExcelExport&&this.parent.excelExport&&(this.parent.ensureModuleInjected(vh)||this.parent.ensureModuleInjected(yh))||(t=!0);break;case"PdfExport":this.parent.allowPdfExport&&this.parent.ensureModuleInjected(vh)||(t=!0);break;case"ExcelExport":case"CsvExport":this.parent.allowExcelExport&&this.parent.ensureModuleInjected(yh)||(t=!0);break;case"SortAscending":case"SortDescending":if(!this.parent.allowSorting||!this.parent.ensureModuleInjected(oa)||this.targetColumn&&!this.targetColumn.field)t=!0;else if(this.parent.ensureModuleInjected(oa)&&this.parent.sortSettings.columns.length>0&&this.targetColumn)for(var i=this.parent.sortSettings.columns,r=0;r<i.length;r++)i[r].field===this.targetColumn.field&&i[r].direction.toLowerCase()===e.toLowerCase().replace("sort","").toLocaleLowerCase()&&(t=!0);break;case"FirstPage":case"PrevPage":(!this.parent.allowPaging||!this.parent.ensureModuleInjected(ua)||0===this.parent.getCurrentViewRecords().length||this.parent.ensureModuleInjected(ua)&&1===this.parent.pageSettings.currentPage)&&(t=!0);break;case"LastPage":case"NextPage":(!this.parent.allowPaging||!this.parent.ensureModuleInjected(ua)||0===this.parent.getCurrentViewRecords().length||this.parent.ensureModuleInjected(ua)&&this.parent.pageSettings.currentPage===this.getLastPage())&&(t=!0)}return t},e.prototype.getContextMenu=function(){return this.element},e.prototype.destroy=function(){var e=this.parent.element;e&&(e.querySelector("."+Wo)||e.querySelector("."+Ko))&&(this.contextMenu.destroy(),this.element.parentNode&&t.remove(this.element),this.removeEventListener(),this.parent.element.classList.remove("e-noselect"))},e.prototype.getModuleName=function(){return"contextMenu"},e.prototype.generateID=function(e){return this.gridID+"_cmenu_"+e},e.prototype.getKeyFromId=function(e){return e.replace(this.gridID+"_cmenu_","")},e.prototype.buildDefaultItems=function(e){var t;switch(e){case"AutoFitAll":case"AutoFit":t={target:Sh.header};break;case"Group":t={target:Sh.header,iconCss:Sh.group};break;case"Ungroup":t={target:Sh.header,iconCss:Sh.ungroup};break;case"Edit":t={target:Sh.content,iconCss:Sh.editIcon};break;case"Delete":t={target:Sh.content,iconCss:Sh.delete};break;case"Save":t={target:Sh.edit,iconCss:Sh.save};break;case"Cancel":t={target:Sh.edit,iconCss:Sh.cancel};break;case"Copy":t={target:Sh.content,iconCss:Sh.copy};break;case"export":t={target:Sh.content};break;case"PdfExport":t={target:Sh.content,iconCss:Sh.pdf};break;case"ExcelExport":t={target:Sh.content,iconCss:Sh.excel};break;case"CsvExport":t={target:Sh.content,iconCss:Sh.csv};break;case"SortAscending":t={target:Sh.header,iconCss:Sh.ascending};break;case"SortDescending":t={target:Sh.header,iconCss:Sh.descending};break;case"FirstPage":t={target:Sh.pager,iconCss:Sh.fPage};break;case"PrevPage":t={target:Sh.pager,iconCss:Sh.pPage};break;case"LastPage":t={target:Sh.pager,iconCss:Sh.lPage};break;case"NextPage":t={target:Sh.pager,iconCss:Sh.nPage}}return this.defaultItems[e]={text:this.getLocaleText(e),id:this.generateID(e),target:t.target,iconCss:t.iconCss?"e-icons "+t.iconCss:""},this.defaultItems[e]},e.prototype.getDefaultItems=function(){return["AutoFitAll","AutoFit","Group","Ungroup","Edit","Delete","Save","Cancel","Copy","export","PdfExport","ExcelExport","CsvExport","SortAscending","SortDescending","FirstPage","PrevPage","LastPage","NextPage"]},e.prototype.setLocaleKey=function(){return{AutoFitAll:"autoFitAll",AutoFit:"autoFit",Copy:"Copy",Group:"Group",Ungroup:"Ungroup",Edit:"EditRecord",Delete:"DeleteRecord",Save:"Save",Cancel:"CancelButton",PdfExport:"Pdfexport",ExcelExport:"Excelexport",CsvExport:"Csvexport",export:"Export",SortAscending:"SortAscending",SortDescending:"SortDescending",FirstPage:"FirstPage",LastPage:"LastPage",PrevPage:"PreviousPage",NextPage:"NextPage"}},e.prototype.getColumn=function(e){var i=t.closest(e.target,"th.e-headercell");if(i){var r=i.querySelector(".e-headercelldiv, .e-stackedheadercelldiv").getAttribute("e-mappinguid");return this.parent.getColumnByUid(r)}return this.parent.getRowInfo(e.target).column||null},e.prototype.selectRow=function(e,i){this.cell=e.target,this.row=t.closest(e.target,"tr.e-row")||this.row,this.row&&i&&!D(e.target,"e-gridpager")&&this.parent.selectRow(parseInt(this.row.getAttribute(us),10))},e}(),xh=function(){function e(e){this.parent=e,this.rowModelGenerator=new Es(this.parent)}return e.prototype.generateRows=function(e,t,i){var r;if(r=t.renderFrozenRightContent||t.renderMovableContent&&!this.parent.enableVirtualization?"frozen-right":t.renderMovableContent||t.isFrozen?"movable":this.parent.getFrozenLeftCount()?"frozen-left":"frozen-right","virtualscroll"===t.requestType&&"X"===t.virtualInfo.sentinelInfo.axis&&"movable"!==r)return null;for(var n=this.parent.enableVirtualization&&!t.isFrozenRowsRender?i:this.rowModelGenerator.generateRows(e,t),o=0,s=n.length;o<s;o++)n[o].cells=De(this.parent,n[o].cells,r);return n},e}(),Fh=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Eh=function(e){function i(t,i){var r=e.call(this,t,i)||this;return r.isInitialRender=!0,r.widthService=i.getService("widthService"),r.addEventListener(),r}return Fh(i,e),i.prototype.addEventListener=function(){this.parent.addEventListener(Dt,this.actionComplete.bind(this)),this.parent.addEventListener(ti,this.batchAdd.bind(this)),this.parent.on(ii,this.batchAdd.bind(this)),this.parent.addEventListener(ri,this.batchAdd.bind(this)),this.parent.on(so,this.refreshScrollOffset),this.parent.on(Qi,this.widthService.refreshFrozenScrollbar,this)},i.prototype.batchAdd=function(e){var t="batchCancel"!==e.name&&!(this.parent.frozenRows&&"Top"===this.parent.editSettings.newRowPosition);if("auto"!==this.parent.height&&(t||"batchCancel"===e.name||"batchDelete"===e.name)){this.refreshScrollOffset();var i=this.getTable().offsetHeight;"add"===e.name&&"Bottom"===this.parent.editSettings.newRowPosition&&this.parent.getContent().firstChild.scroll(0,i)}},i.prototype.setHeightToContent=function(e){this.getFrozenContent().style.height=e.toString()+"px",this.getMovableContent().style.height=e.toString()+"px"},i.prototype.actionComplete=function(e){if("Dialog"!==this.parent.editSettings.mode&&("add"===e.requestType||"cancel"===e.requestType&&e.row.classList.contains(os))&&(!this.parent.frozenRows||"Bottom"===this.parent.editSettings.newRowPosition)&&"auto"!==this.parent.height){this.refreshScrollOffset();var t=this.getTable().offsetHeight;"add"===e.requestType&&"Bottom"===this.parent.editSettings.newRowPosition&&this.parent.getContent().firstChild.scroll(0,t)}},i.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.removeEventListener(Dt,this.actionComplete),this.parent.removeEventListener(ti,this.batchAdd),this.parent.off(Qi,this.widthService.refreshFrozenScrollbar))},i.prototype.renderPanel=function(){e.prototype.renderPanel.call(this);var i=this.parent.element.querySelector("."+Zo),r=this.parent.element.querySelector("."+Yo);t.isNullOrUndefined(i)&&(i=this.parent.createElement("div",{className:"e-frozencontent e-frozen-left-content"}),r=this.parent.createElement("div",{className:Yo}),this.getPanel().querySelector("."+es).appendChild(i),this.getPanel().querySelector("."+es).appendChild(r),r.style.scrollbarWidth="none"),this.setFrozenContent(i),this.setMovableContent(r),t.Browser.userAgent.indexOf("Mac OS")>-1&&"safari"===t.Browser.info.name&&!this.parent.enableVirtualization&&this.getPanel().firstElementChild.classList.add("e-mac-safari")},i.prototype.renderFrozenRigthPanel=function(){e.prototype.renderPanel.call(this)},i.prototype.renderEmpty=function(i){e.prototype.renderEmpty.call(this,i),this.getMovableContent().querySelector(gs).innerHTML="<tr><td></td></tr>",t.addClass([this.getMovableContent().querySelector(gs).querySelector("tr")],["e-emptyrow"]),this.getFrozenContent().querySelector(".e-emptyrow").querySelector("td").colSpan=this.parent.getVisibleFrozenColumns(),this.getFrozenContent().style.borderRightWidth="0px",this.parent.frozenRows&&(this.parent.getHeaderContent().querySelector("."+$o).querySelector(gs).innerHTML="",this.parent.getHeaderContent().querySelector("."+Jo).querySelector(gs).innerHTML="")},i.prototype.renderFrozenRightEmpty=function(t){e.prototype.renderEmpty.call(this,t)},i.prototype.setFrozenContent=function(e){this.frozenContent=e},i.prototype.setMovableContent=function(e){this.movableContent=e},i.prototype.getFrozenContent=function(){return this.frozenContent},i.prototype.getMovableContent=function(){return this.movableContent},i.prototype.getModelGenerator=function(){return new xh(this.parent)},i.prototype.renderFrozenRightTable=function(){e.prototype.renderTable.call(this)},i.prototype.renderTable=function(){var i;null==this.getFrozenContent().querySelector("."+ts)?(e.prototype.renderTable.call(this),this.getFrozenContent().appendChild(this.getTable()),i=this.getTable().cloneNode(!0),this.getMovableContent().appendChild(i)):(this.setTable(this.getFrozenContent().querySelector("."+ts)),this.setColGroup(this.parent.element.querySelector("."+Wo).querySelector(fs).cloneNode(!0)),this.getFrozenContent().querySelector("."+ts).appendChild(this.getColGroup()),i=this.getMovableContent().querySelector("."+ts),this.parent.frozenRows&&this.parent.getHeaderContent().classList.add("e-frozenhdrcont")),this.getMovableContent().querySelector(fs)&&t.remove(this.getMovableContent().querySelector(fs));var r=this.parent.getHeaderContent().querySelector("."+Jo).querySelector(fs).cloneNode(!0);i.insertBefore(r,i.querySelector(gs));var n=this.parent.enableVirtualization?"":"flex";this.getPanel().firstChild.style.display=n,this.renderHorizontalScrollbar("e-frozenscrollbar e-frozen-left-scrollbar",this.getScrollbarDisplay())},i.prototype.getScrollbarDisplay=function(){var e="";return(this.parent.getFrozenColumns()&&!this.parent.getVisibleFrozenColumns()||this.parent.getFrozenLeftColumnsCount()&&!this.parent.getVisibleFrozenLeftCount())&&(e="none"),e},i.prototype.renderHorizontalScrollbar=function(e,t,i){var r=this.parent.createElement("div",{className:e,styles:"display:"+t}),n=this.parent.createElement("div",{className:"e-movablescrollbar"}),o=this.parent.createElement("div",{className:"e-movablechild"}),s=H().toString();this.setScrollbarHeight(n,s),this.setScrollbarHeight(o,s),n.appendChild(o),this.appendScrollbar(r,n,i)},i.prototype.appendScrollbar=function(e,t,i){var r=this.parent.createElement("div",{className:"e-scrollbar",styles:"display: flex"});r.appendChild(e),r.appendChild(t),this.parent.getContent().appendChild(r)},i.prototype.setScrollbarHeight=function(e,t){e.style.minHeight=t+"px",e.style.maxHeight=t+"px"},i.prototype.setIsFrozen=function(e,t){e.isFrozen=!e.isFrozen},i.prototype.setTbody=function(e,i){var r;t.isNullOrUndefined(e[0].cells[0])&&(this.getMovableContent().querySelector(gs).innerHTML="");var n=e[0].cells[0],o=n.index;return t.isUndefined(o)&&this.parent.isRowDragable()&&(o=(n=e[0].cells[1]).index),0===o&&(this.getPanel().firstChild.style.overflowX="hidden",this.parent.enableColumnVirtualization&&(this.getMovableContent().style.overflowX="hidden")),this.parent.enableColumnVirtualization&&i.renderMovableContent&&"virtualscroll"===i.requestType&&this.getMovableContent().scrollLeft>0&&0!==i.virtualInfo.columnIndexes[0]&&(o=this.parent.getFrozenColumns()),n&&n.column&&(r=n.column.getFreezeTableName()),this.setIdx(o),i.tableName=r,r},i.prototype.splitRows=function(e){e===ps?(this.freezeRows=this.rows,this.freezeRowElements=this.rowElements):this.movableRows=this.rows},i.prototype.renderNextFrozentPart=function(e,i){var r=this.parent.enableVirtualization;i===ps&&(r&&(e.renderMovableContent=!0),this.refreshContentRows(t.extend({},e)))},i.prototype.appendContent=function(e,i,r,n){this.parent.isReact&&!t.isNullOrUndefined(this.parent.rowTemplate)?e=i:e.appendChild(i),n===ps?(this.isLoaded=!1,this.getFrozenContent().querySelector("table").appendChild(e)):(this.refreshTbody(e),this.isLoaded=!0,this.getMovableContent().querySelector("table").appendChild(e),this.refreshHeight(),this.refreshScrollOffset(),this.widthService.refreshFrozenScrollbar()),this.isInitialRender&&(this.parent.scrollModule.setHeight(),this.isInitialRender=!1)},i.prototype.refreshScrollOffset=function(){if("auto"!==this.parent.height){var e=this.getTable().offsetHeight+1;this.setHeightToContent(e)}this.parent.notify(oo,{})},i.prototype.getFrozenHeader=function(e){return e===ps?this.parent.getHeaderContent().querySelector("."+$o).querySelector(gs):this.parent.getHeaderContent().querySelector("."+Jo).querySelector(gs)},i.prototype.refreshTbody=function(e){e.childElementCount<1&&e.appendChild(this.parent.createElement("tr").appendChild(this.parent.createElement("td")))},i.prototype.refreshHeight=function(){this.parent.allowTextWrap||this.parent.notify(zr,{case:"refreshHeight"}),this.getFrozenContent().style.borderRightWidth="1px"},i.prototype.setIdx=function(e){this.idx=e},i.prototype.getIdx=function(){return this.idx},i.prototype.getTbody=function(e){return e===ps?this.getTable().querySelector(gs):this.getMovableContent().querySelector(gs)},i}(ks),Ih=function(e){function i(t,i){var r=e.call(this,t,i)||this;return r.addEventListener(),r}return Fh(i,e),i.prototype.addEventListener=function(){this.eventHandler=[{event:zr,handler:this.refreshFreeze},{event:Wr,handler:this.setFrozenHeight},{event:Fi,handler:this.enableAfterRender}],_e(this.parent,this.eventHandler,!0,this)},i.prototype.removeEventListener=function(){this.parent.isDestroyed||_e(this.parent,this.eventHandler,!1)},i.prototype.renderTable=function(){e.prototype.renderTable.call(this),this.rfshMovable(),this.updateColgroup(),this.initializeHeaderDrag(),this.initializeHeaderDrop(),this.parent.notify(Di,{rows:this.rows,args:{isFrozen:!1}})},i.prototype.renderPanel=function(){var i=this.parent.element.querySelector("."+$o),r=this.parent.element.querySelector("."+Jo);e.prototype.renderPanel.call(this),t.isNullOrUndefined(i)&&(i=this.parent.createElement("div",{className:"e-frozenheader e-frozen-left-header"}),r=this.parent.createElement("div",{className:Jo}),this.getPanel().querySelector("."+Xo).appendChild(i),this.getPanel().querySelector("."+Xo).appendChild(r)),this.setFrozenHeader(i),this.setMovableHeader(r)},i.prototype.renderFrozenRightPanel=function(){e.prototype.renderPanel.call(this)},i.prototype.renderFrozenRightTable=function(){e.prototype.renderTable.call(this)},i.prototype.refreshUI=function(){var i=this.getMovableHeader().querySelector(gs);t.remove(this.getMovableHeader().querySelector("table")),e.prototype.refreshUI.call(this),this.rfshMovable(),this.getMovableHeader().querySelector(gs).innerHTML=i.innerHTML,this.updateColgroup(),this.widthService.setWidthToColumns(),this.parent.enableVirtualization||this.widthService.setWidthToTable(),this.parent.allowTextWrap&&"Header"===this.parent.textWrapSettings.wrapMode&&K([].slice.call(this.movableHeader.querySelectorAll("tr.e-columnheader")),!0),this.parent.updateDefaultCursor(),le(this.parent.getContentTable().querySelector(fs),this.parent.getFrozenColumns(),this.parent),this.widthService.refreshFrozenScrollbar(),this.initializeHeaderDrag(),this.parent.notify(Di,{rows:this.rows,args:{isFrozen:!1}})},i.prototype.refreshFrozenLeftUI=function(){e.prototype.refreshUI.call(this)},i.prototype.rfshMovable=function(){this.getFrozenHeader().appendChild(this.getTable()),this.getMovableHeader().appendChild(this.createHeader(void 0,"movable")),this.refreshStackedHdrHgt(),this.addMovableFirstCls()},i.prototype.addMovableFirstCls=function(){if(this.parent.getVisibleFrozenColumns())for(var e=[].slice.call(this.parent.element.querySelector("."+Jo).querySelector("thead").getElementsByClassName("e-columnheader")),i=e.length,r=0;r<i;r++){var n=e[r].cells[0];n&&(t.addClass([n],["e-movablefirst"]),e[r].cells[0].rowSpan>1&&(r+=e[r].cells[0].rowSpan-1))}},i.prototype.refreshFreeze=function(e){if("filter"===e.case){var t=this.getTable().querySelector(".e-filterbar");if(this.parent.allowFiltering&&t&&this.getMovableHeader().querySelector("thead")){this.getMovableHeader().querySelector("thead").appendChild(this.filterRenderer(t,this.parent.getFrozenColumns()));for(var i=0,r=[].slice.call(this.getMovableHeader().querySelectorAll("thead .e-filterbarcell .e-input"));i<r.length;i++){var n={element:r[i],floatLabelType:"Never",properties:{enableRtl:this.parent.enableRtl,showClearButton:!0}};o.Input.bindInitialEvent(n)}}}else"textwrap"!==e.case&&"refreshHeight"!==e.case||(this.refreshHeight(e),this.parent.contentModule.refreshScrollOffset())},i.prototype.refreshHeight=function(e){var t,i,r=this.getFrozenHeader(),n=this.getMovableHeader(),o=this.parent.getContent(),s=this.parent.textWrapSettings.wrapMode,l=this.parent.getHeaderContent().querySelector("."+Xo).classList;"textwrap"===e.case?(("Header"!==s||e.isModeChg)&&(t=o.querySelector("."+Zo).querySelectorAll("tr"),i=o.querySelector("."+Yo).querySelectorAll("tr"),this.setWrapHeight(t,i,e.isModeChg,!0)),"Content"===s&&this.parent.allowTextWrap?l.add("e-wrap"):l.remove("e-wrap"),"Both"===s||e.isModeChg?(t=r.querySelectorAll("tr"),i=n.querySelectorAll("tr")):(i=n.querySelector("Content"===s?gs:"thead").querySelectorAll("tr"),t=r.querySelector("Content"===s?gs:"thead").querySelectorAll("tr")),this.parent.getHeaderContent().getElementsByClassName("e-stackedheadercell").length||this.setWrapHeight(t,i,e.isModeChg,!1,this.colDepth>1),this.refreshStackedHdrHgt()):"refreshHeight"===e.case&&(this.setWrapHeight(o.querySelector("."+Zo).querySelectorAll("tr"),o.querySelector("."+Yo).querySelectorAll("tr"),e.isModeChg),this.parent.getHeaderContent().getElementsByClassName("e-stackedheadercell").length||this.setWrapHeight(r.querySelectorAll("tr"),n.querySelectorAll("tr"),e.isModeChg))},i.prototype.enableAfterRender=function(e){"scroll"===e.module&&this.setFrozenHeight()},i.prototype.updateResizeHandler=function(){for(var e=[].slice.call(this.parent.getHeaderContent().getElementsByClassName("e-rhandler")),t=0;t<e.length;t++)e[t].style.height=e[t].parentElement.offsetHeight+"px"},i.prototype.setWrapHeight=function(e,i,r,n,o){for(var s,l,a=this.parent.allowTextWrap,h=this.parent.textWrapSettings.wrapMode,d=this.parent.getHeaderContent().querySelector("thead"),p=this.parent.getHeaderContent().querySelector(gs),c=[],u=[],g=0,f=e.length;g<f;g++)t.isNullOrUndefined(e[g])||t.isNullOrUndefined(i[g])||(c[g]=e[g].getBoundingClientRect().height,u[g]=i[g].getBoundingClientRect().height);for(g=0,f=e.length;g<f;g++)(r&&("Header"===h&&n||"Content"===h&&d.contains(e[g])||"Header"===h&&p.contains(e[g]))||o)&&(e[g].style.height=null,i[g].style.height=null),s=c[g],l=u[g],!t.isNullOrUndefined(e[g])&&e[g].childElementCount&&(a&&s<l||!a&&s<l||this.parent.allowResizing&&this.parent.resizeModule&&!1===this.parent.resizeModule.isFrozenColResized)&&(e[g].style.height=l+"px"),i&&!t.isNullOrUndefined(i[g])&&i[g].childElementCount&&(a&&s>l||!a&&s>l||this.parent.allowResizing&&this.parent.resizeModule&&!0===this.parent.resizeModule.isFrozenColResized)&&(i[g].style.height=s+"px");a&&"auto"!==this.parent.height&&this.setFrozenHeight()},i.prototype.setFrozenHeight=function(e){void 0===e&&(e=H());var t=this.parent.element.querySelector("."+Yo).getBoundingClientRect().height,i=this.parent.element.querySelector("."+Yo),r=this.parent.element.querySelector("."+Zo),n=this.parent.getContent().scrollWidth,o=this.parent.element.querySelector(".e-movablecontent table").scrollWidth+this.parent.getContentTable().scrollWidth;i.scrollWidth-i.clientWidth?(r.style.height=t-e+"px",r.style.borderBottom=""):(r.style.height=t+"px",(r.scrollHeight<=r.clientHeight||i.scrollHeight<=i.clientHeight)&&n===o&&this.parent.scrollModule.removePadding(),r.style.borderBottom="0px")},i.prototype.refreshStackedHdrHgt=function(){for(var e,t,i=[].slice.call(this.getFrozenHeader().getElementsByClassName("e-columnheader")),r=[].slice.call(this.getMovableHeader().getElementsByClassName("e-columnheader")),n=0,o=i.length;n<o;n++)e=this.getRowSpan(i[n]),t=this.getRowSpan(r[n]),e.min>1?this.updateStackedHdrRowHgt(n,e.max,i[n],r):t.min>1&&this.updateStackedHdrRowHgt(n,t.max,r[n],i);this.parent.allowResizing&&this.updateResizeHandler()},i.prototype.getRowSpan=function(e){for(var t,i,r,n=0,o=e.childElementCount;n<o;n++)0===n&&(i=e.children[0].rowSpan),t=e.children[n].rowSpan,i=Math.min(t,i),r=Math.max(t,i);return{min:i,max:r}},i.prototype.updateStackedHdrRowHgt=function(e,t,i,r){for(var n=0,o=0;o<t;o++)n+=r[e+o].style.height?parseInt(r[e+o].style.height,10):r[e+o].offsetHeight;i.style.height=n+"px"},i.prototype.setFrozenHeader=function(e){this.frozenHeader=e},i.prototype.setMovableHeader=function(e){this.movableHeader=e},i.prototype.getFrozenHeader=function(){return this.frozenHeader},i.prototype.getMovableHeader=function(){return this.movableHeader},i.prototype.updateColgroup=function(){var e=this.getMovableHeader().querySelector("table");t.remove(this.getMovableHeader().querySelector(fs)),e.insertBefore(le(this.getFrozenHeader().querySelector(fs),this.parent.getFrozenColumns(),this.parent),e.querySelector("thead"))},i.prototype.filterRenderer=function(e,t,i){var r=e.cloneNode(!0);r.innerHTML="";for(var n=i||this.parent.getColumns().length,o=t;o<n;o++)r.appendChild(e.removeChild(e.children[t]));return r},i}(As),Th=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),zh=function(e){function i(t,i){var r=e.call(this,t,i)||this;return r.addEventListener(),r}return Th(i,e),i.prototype.addEventListener=function(){this.evtHandlers=[{event:zr,handler:this.refreshFreeze},{event:Jn,handler:this.refreshFrozenColumns},{event:Zn,handler:this.setReorderElement},{event:Qi,handler:this.setVisible}],_e(this.parent,this.evtHandlers,!0,this)},i.prototype.removeEventListener=function(){this.parent.isDestroyed||_e(this.parent,this.evtHandlers,!1)},i.prototype.setReorderElement=function(e){this.destEle=e.ele},i.prototype.refreshFrozenColumns=function(e){e.parent||this.parent.setProperties({columns:e.columns},!0);var t=D(this.destEle,"e-frozen-left-header"),i=D(this.destEle,"e-frozen-right-header"),r=this.parent.getFrozenLeftColumnsCount(),n=this.parent.getFrozenRightColumnsCount();e.column.freeze=null,t?e.column.freeze="Left":i&&(e.column.freeze="Right"),this.parent.setFrozenCount(),e.cancel=r!==this.parent.getFrozenLeftColumnsCount()||n!==this.parent.getFrozenRightColumnsCount(),e.cancel&&this.parent.refreshColumns()},i.prototype.setWrapHeight=function(e,i,r,n,o,s){for(var l,a,h,d=this.parent.allowTextWrap,p=this.parent.getHeaderContent().querySelector(gs),c=this.parent.textWrapSettings.wrapMode,u=this.parent.getHeaderContent().querySelector("thead"),g=[],f=[],m=[],y=0,v=e.length;y<v;y++)t.isNullOrUndefined(e[y])||t.isNullOrUndefined(i[y])||(s&&(m[y]=s[y].getBoundingClientRect().height),f[y]=i[y].getBoundingClientRect().height,g[y]=e[y].getBoundingClientRect().height);for(y=0,v=e.length;y<v;y++){(r&&("Content"===c&&u.contains(e[y])||"Header"===c&&p.contains(e[y])||"Header"===c&&n)||o)&&(s[y]&&(s[y].style.height=null),e[y].style.height=null,i[y].style.height=null),l=g[y],a=f[y],h=m[y]?m[y]:0;var C=Math.max(l,a,h);!t.isNullOrUndefined(e[y])&&e[y].childElementCount&&(d&&l<C||!d&&l<C||this.parent.allowResizing&&this.parent.resizeModule&&!1===this.parent.resizeModule.isFrozenColResized)&&(e[y].style.height=C+"px"),i&&!t.isNullOrUndefined(i[y])&&i[y].childElementCount&&(d&&C>a||!d&&C>a||this.parent.allowResizing&&this.parent.resizeModule&&!0===this.parent.resizeModule.isFrozenColResized)&&(i[y].style.height=C+"px"),s&&!t.isNullOrUndefined(s[y])&&s[y].childElementCount&&(d&&C>h||!d&&C>h||this.parent.allowResizing&&this.parent.resizeModule&&!0===this.parent.resizeModule.isFrozenColResized)&&(s[y].style.height=C+"px")}d&&this.setFrozenHeight()},i.prototype.refreshHeight=function(e){var t,i,r,n=this.parent.getFrozenMode()===hs,o=this.getFrozenRightHeader(),s=this.parent.getHeaderContent().querySelector("."+$o),l=this.parent.getContent(),a=this.getMovableHeader(),h=this.parent.getHeaderContent().querySelector("."+Xo).classList,d=this.parent.textWrapSettings.wrapMode;"textwrap"===e.case?(("Header"!==d||e.isModeChg)&&(n&&(i=l.querySelector(".e-frozen-right-content").querySelectorAll("tr")),r=l.querySelector("."+Yo).querySelectorAll("tr"),t=l.querySelector("."+Zo).querySelectorAll("tr"),this.setWrapHeight(t,r,e.isModeChg,!0,!1,i)),"Content"===d&&this.parent.allowTextWrap?h.add("e-wrap"):h.remove("e-wrap"),"Both"===d||e.isModeChg?(n&&(i=o.querySelectorAll("tr")),t=s.querySelectorAll("tr"),r=a.querySelectorAll("tr")):(n&&(i=o.querySelector("Content"===d?gs:"thead").querySelectorAll("tr")),t=s.querySelector("Content"===d?gs:"thead").querySelectorAll("tr"),r=a.querySelector("Content"===d?gs:"thead").querySelectorAll("tr")),this.parent.getHeaderContent().getElementsByClassName("e-stackedheadercell").length||this.setWrapHeight(t,r,e.isModeChg,!1,this.colDepth>1,i),this.refreshStackedHdrHgt()):"refreshHeight"===e.case&&(r=l.querySelector("."+Yo).querySelectorAll("tr"),t=l.querySelector("."+Zo).querySelectorAll("tr"),n&&(i=l.querySelector(".e-frozen-right-content").querySelectorAll("tr")),this.setWrapHeight(t,r,e.isModeChg,!1,!1,i),this.parent.getHeaderContent().getElementsByClassName("e-stackedheadercell").length||(n&&(i=o.querySelectorAll("tr")),t=s.querySelectorAll("tr"),r=a.querySelectorAll("tr"),this.setWrapHeight(t,r,e.isModeChg,!1,!1,i)))},i.prototype.setVisible=function(e){for(var i,r,n=this.parent,o=this.parent.getFrozenLeftColumnsCount(),s=this.parent.getFrozenRightColumnsCount(),l=this.parent.getMovableColumnsCount(),a=0,h=e.length;a<h;a++){var d=e[a];if(r=n.getNormalizedColumnIndex(d.uid),i=d.visible?"":"none","Left"===d.freeze||"Right"===d.freeze){if(o&&!s){var p=n.getHeaderContent().querySelector(".e-frozen-left-header").querySelector(fs);t.setStyleAttribute(p.children[r],{display:i})}else if(!o&&s){var c=n.getHeaderContent().querySelector(".e-frozen-right-header").querySelector(fs);t.setStyleAttribute(c.children[r-l],{display:i})}}else{var u=n.getHeaderContent().querySelector("."+Jo).querySelector(fs);t.setStyleAttribute(u.children[r-o],{display:i})}}this.refreshUI()},i.prototype.filterRenderer=function(t,i,r){return e.prototype.filterRenderer.call(this,t,i,r)},i.prototype.refreshUI=function(){var i,r=this.getMovableHeader().querySelector(gs);t.remove(this.getMovableHeader().querySelector("table")),this.parent.getFrozenMode()===hs&&(i=this.getFrozenRightHeader().querySelector(gs),t.remove(this.getFrozenRightHeader().querySelector("table"))),e.prototype.refreshFrozenLeftUI.call(this),this.rfshMovable(),this.getMovableHeader().querySelector(gs).innerHTML=r.innerHTML,i&&(this.getFrozenRightHeader().querySelector(gs).innerHTML=i.innerHTML),this.updateColgroup(),this.widthService.setWidthToColumns(),this.parent.notify(zi,{}),this.parent.allowTextWrap&&"Header"===this.parent.textWrapSettings.wrapMode&&K([].slice.call(this.getMovableHeader().querySelectorAll("tr.e-columnheader")),!0),this.parent.updateDefaultCursor();var n=this.parent.getContent().querySelector("."+Yo).querySelector("."+ts);t.remove(n.querySelector(fs));var o=this.getMovableHeader().querySelector(fs).cloneNode(!0);if(n.insertBefore(o,n.querySelector(gs)),i){var s=this.parent.getContent().querySelector(".e-frozen-right-content").querySelector("."+ts);t.remove(s.querySelector(fs));var l=this.getFrozenRightHeader().querySelector(fs).cloneNode(!0);s.insertBefore(l,s.querySelector(gs))}this.widthService.refreshFrozenScrollbar(),this.initializeHeaderDrag(),this.parent.notify(Di,{rows:this.rows,args:{isFrozen:!1}})},i.prototype.refreshFreeze=function(e){var t=this.parent.getFrozenLeftColumnsCount(),i=this.parent.getFrozenRightColumnsCount(),r=this.parent.getMovableColumnsCount();if("filter"===e.case){var n=this.getTable().querySelector(".e-filterbar");if(this.parent.allowFiltering&&n&&this.getMovableHeader().querySelector("thead")){var o=this.parent.isRowDragable(),s=t?o?t+1:t:0,l=t+r+(t&&o?1:0);if(this.getMovableHeader().querySelector("thead").appendChild(this.filterRenderer(n,s,l)),this.parent.getFrozenMode()===hs){var a=[].slice.call(this.getMovableHeader().querySelectorAll("thead .e-filterbarcell .e-input"));this.getFrozenRightHeader().querySelector("thead").appendChild(this.filterRenderer(n,s,s+i)),this.adjudtFilterBarCell(a)}var h=[].slice.call(this.getMovableHeader().querySelectorAll("thead .e-filterbarcell .e-input"));this.adjudtFilterBarCell(h)}}else"textwrap"!==e.case&&"refreshHeight"!==e.case||(this.refreshHeight(e),this.parent.contentModule.refreshScrollOffset())},i.prototype.updateFrozenColGroup=function(e,i){e&&!1===e.visible&&t.setStyleAttribute(i,{display:"none"})},i.prototype.adjudtFilterBarCell=function(e){for(var t=0,i=e;t<i.length;t++){var r={element:i[t],floatLabelType:"Never",properties:{enableRtl:this.parent.enableRtl,showClearButton:!0}};o.Input.bindInitialEvent(r)}},i.prototype.renderPanel=function(){this.parent.getFrozenLeftColumnsCount()?(e.prototype.renderPanel.call(this),this.parent.getFrozenRightColumnsCount()&&this.renderLeftWithRightFrozenPanel()):this.renderRightFrozenPanelAlone(),this.getPanel().firstChild.style.display="flex",this.getMovableHeader().style.flex="1"},i.prototype.renderTable=function(){this.parent.getFrozenLeftColumnsCount()?e.prototype.renderTable.call(this):this.renderFrozenRightTableAlone()},i.prototype.rfshMovable=function(){if(this.parent.getFrozenLeftColumnsCount()){if(e.prototype.rfshMovable.call(this),this.parent.getFrozenRightColumnsCount()){var t=this.rows;this.getFrozenRightHeader().appendChild(this.createHeader(void 0,"frozen-right")),this.refreshStackedHdrHgt(),this.parent.notify(Di,{rows:this.rows,args:{renderFrozenRightContent:!0}}),this.rows=t}}else this.getFrozenRightHeader().appendChild(this.getTable()),this.getMovableHeader().appendChild(this.createHeader(void 0,"movable")),this.refreshStackedHdrHgt(),this.addMovableFirstCls()},i.prototype.refreshStackedHdrHgt=function(){this.parent.getFrozenLeftColumnsCount()?(e.prototype.refreshStackedHdrHgt.call(this),this.parent.getFrozenRightColumnsCount()&&this.refreshFrozenRightStackedHdrHgt()):this.refreshFrozenRightStackedHdrHgt()},i.prototype.refreshFrozenRightStackedHdrHgt=function(){for(var e,t=[].slice.call(this.getFrozenRightHeader().getElementsByClassName("e-columnheader")),i=[].slice.call(this.getMovableHeader().getElementsByClassName("e-columnheader")),r=0,n=t.length;r<n;r++)(e=this.getRowSpan(t[r])).min>1&&this.updateStackedHdrRowHgt(r,e.max,t[r],i)},i.prototype.updateColgroup=function(){this.updateMovableColGroup(),this.parent.getFrozenLeftColumnsCount()&&this.updateFrozenLeftColGroup(),this.parent.getFrozenRightColumnsCount()&&this.updateFrozenRightColGroup()},i.prototype.renderRightFrozenPanelAlone=function(){var i=this.parent.element.querySelector("."+Jo),r=this.parent.element.querySelector(".e-frozen-right-header");e.prototype.renderFrozenRightPanel.call(this),t.isNullOrUndefined(r)&&(i=this.parent.createElement("div",{className:Jo}),r=this.parent.createElement("div",{className:"e-frozenheader e-frozen-right-header"}),this.getPanel().querySelector("."+Xo).appendChild(i),this.getPanel().querySelector("."+Xo).appendChild(r)),e.prototype.setMovableHeader.call(this,i),this.setFrozenRightHeader(r)},i.prototype.renderLeftWithRightFrozenPanel=function(){var i=this.parent.element.querySelector(".e-frozen-right-header");e.prototype.renderFrozenRightPanel.call(this),t.isNullOrUndefined(i)&&(i=this.parent.createElement("div",{className:"e-frozenheader e-frozen-right-header"}),this.getPanel().querySelector("."+Xo).appendChild(i)),this.setFrozenRightHeader(i)},i.prototype.renderFrozenRightTableAlone=function(){e.prototype.renderFrozenRightTable.call(this),this.rfshMovable(),this.updateColgroup(),this.initializeHeaderDrag(),this.initializeHeaderDrop(),this.parent.notify(Di,{rows:this.rows,args:{isFrozen:!1}})},i.prototype.updateFrozenLeftColGroup=function(){for(var e=this.getFrozenHeader().querySelector(fs).children,i=this.parent.isRowDragable()?1:0,r=this.parent.isRowDragable()?this.parent.getFrozenLeftColumnsCount()+1:this.parent.getFrozenLeftColumnsCount(),n=i;n<e.length;n++)n>=r&&(t.remove(e[n]),n--)},i.prototype.updateMovableColGroup=function(){var e=this.getMovableHeader().querySelector(fs).children;this.parent.isRowDragable()&&t.remove(e[0]);for(var i=e.length,r=this.parent.getFrozenLeftColumnsCount(),n=this.parent.getMovableColumnsCount(),o=0,s=0;s<i;s++,o++)(s<r||s>=r+n)&&(t.remove(e[o]),o--)},i.prototype.updateFrozenRightColGroup=function(){var e=this.parent.isRowDragable(),i=this.parent.getFrozenRightColumns(),r=this.getFrozenRightHeader().querySelector(fs).children;this.parent.getFrozenMode()===hs&&e&&t.remove(r[0]);for(var n=r.length,o=this.parent.getFrozenLeftColumnsCount(),s=this.parent.getMovableColumnsCount(),l=0,a=0;a<n;a++)a<o+s?t.remove(r[0]):(this.updateFrozenColGroup(i[l],r[l]),l++)},i.prototype.setFrozenRightHeader=function(e){this.frozenRightHeader=e},i.prototype.getFrozenRightHeader=function(){return this.frozenRightHeader},i}(Ih),Dh=function(e){function i(t,i){var r=e.call(this,t,i)||this;return r.frzCount=0,r.isColGroupRefresh=!1,r.widthService=i.getService("widthService"),r}return Th(i,e),i.prototype.renderPanel=function(){this.parent.getFrozenLeftColumnsCount()?(e.prototype.renderPanel.call(this),this.parent.getFrozenRightColumnsCount()&&this.renderFrozenLeftWithRightPanel()):this.renderFrozenRightPanelAlone();var t=this.parent.enableVirtualization?"":"flex";this.getPanel().firstChild.style.display=t},i.prototype.renderTable=function(){if(this.parent.getFrozenLeftColumnsCount()){if(e.prototype.renderTable.call(this),this.parent.getFrozenRightColumnsCount()){this.renderFrozenLeftWithRightTable();var t=this.parent.getVisibleFrozenRightCount()?"":"none";this.renderHorizontalScrollbar("e-frozenscrollbar e-frozen-right-scrollbar",t,!0)}}else{this.renderFrozenRightTableAlone();t=this.parent.getVisibleFrozenRightCount()?"":"none";this.renderHorizontalScrollbar("e-frozenscrollbar e-frozen-right-scrollbar",t)}this.getMovableContent().style.flex="1"},i.prototype.appendScrollbar=function(e,t,i){var r=this.parent.createElement("div",{className:"e-scrollbar",styles:"display: flex"});if(this.parent.getFrozenLeftColumnsCount()){if(i)return void this.parent.getContent().querySelector(".e-scrollbar").appendChild(e);r.appendChild(e),r.appendChild(t)}else r.appendChild(t),r.appendChild(e);this.parent.getContent().appendChild(r)},i.prototype.renderFrozenRightPanelAlone=function(){this.renderFrozenRigthPanel();var i=this.parent.element.querySelector("."+Yo),r=this.parent.element.querySelector(".e-frozen-right-content");t.isNullOrUndefined(r)&&(i=this.parent.createElement("div",{className:Yo}),r=this.parent.createElement("div",{className:"e-frozencontent e-frozen-right-content"}),this.getPanel().querySelector("."+es).appendChild(i),this.getPanel().querySelector("."+es).appendChild(r)),e.prototype.setMovableContent.call(this,i),this.setFrozenRightContent(r)},i.prototype.renderFrozenLeftWithRightPanel=function(){this.renderFrozenRigthPanel();var e=this.parent.element.querySelector(".e-frozen-right-content");t.isNullOrUndefined(e)&&(e=this.parent.createElement("div",{className:"e-frozencontent e-frozen-right-content"}),this.getPanel().querySelector("."+es).appendChild(e)),this.setFrozenRightContent(e)},i.prototype.renderFrozenRightTableAlone=function(){var i;null==this.getFrozenRightContent().querySelector("."+ts)?(e.prototype.renderFrozenRightTable.call(this),this.getFrozenRightContent().appendChild(this.getTable()),i=this.getTable().cloneNode(!0),this.getMovableContent().appendChild(i)):(this.parent.frozenRows&&this.parent.getHeaderContent().classList.add("e-frozenhdrcont"),this.setTable(this.getFrozenRightContent().querySelector("."+ts)),this.setColGroup(this.getFrozenRightHeaderColGroup()),i=this.getMovableContent().querySelector("."+ts),this.getFrozenRightContent().querySelector("."+ts).appendChild(this.getColGroup())),this.getMovableContent().querySelector(fs)&&t.remove(this.getMovableContent().querySelector(fs));var r=this.parent.getHeaderContent().querySelector("."+Jo).querySelector(fs).cloneNode(!0);i.insertBefore(r,i.querySelector(gs))},i.prototype.renderFrozenLeftWithRightTable=function(){var e=this.getTable().cloneNode(!0);this.getFrozenRightContent().appendChild(e);var i=this.getFrozenRightContent().querySelector(fs);i&&t.remove(i);var r=this.getFrozenRightContent().querySelector("."+ts);r.insertBefore(this.getFrozenRightHeaderColGroup(),r.querySelector(gs))},i.prototype.renderFrozenRightEmptyRowAlone=function(i){e.prototype.renderFrozenRightEmpty.call(this,i),this.getMovableContent().querySelector(gs).innerHTML="<tr><td></td></tr>",t.addClass([this.parent.getMovableContentTbody().querySelector("tr")],["e-emptyrow"]),this.getFrozenRightContent().querySelector(".e-emptyrow").querySelector("td").colSpan=this.parent.getVisibleFrozenRightCount(),this.parent.frozenRows&&(this.parent.getFrozenRightHeaderTbody().innerHTML="",this.parent.getMovableHeaderTbody().innerHTML="")},i.prototype.getFrozenHeader=function(e){return e===ps?this.parent.getHeaderContent().querySelector(".e-frozen-left-header").querySelector(gs):"movable"===e?this.parent.getHeaderContent().querySelector("."+Jo).querySelector(gs):this.parent.getHeaderContent().querySelector(".e-frozen-right-header").querySelector(gs)},i.prototype.renderFrozenLeftWithRightEmptyRow=function(){this.getFrozenRightContent().querySelector(gs).innerHTML="<tr><td></td></tr>",t.addClass([this.getFrozenRightContent().querySelector(gs).querySelector("tr")],["e-emptyrow"]),this.parent.frozenRows&&(this.parent.getHeaderContent().querySelector(".e-frozen-right-header").querySelector(gs).innerHTML="")},i.prototype.setFrozenRightContent=function(e){this.frozenRigthContent=e},i.prototype.getFrozenRightContent=function(){return this.frozenRigthContent},i.prototype.getHeaderColGroup=function(){var e=this.parent.element.querySelector("."+Wo).querySelector(fs).cloneNode(!0);if(!this.parent.getFrozenLeftColumnsCount()){var t=this.getFrozenRightHeaderColGroup();e=t&&this.frzCount?t.cloneNode(!0):e,this.frzCount++,this.isColGroupRefresh=!0}return e},i.prototype.getFrozenRightHeaderColGroup=function(){var e=this.parent.getHeaderContent().querySelector(".e-frozen-right-header").querySelector(fs);return e||(e=this.parent.getHeaderContent().querySelector(fs)),e.cloneNode(!0)},i.prototype.setColGroup=function(i){return this.parent.getFrozenLeftColumnsCount()?e.prototype.setColGroup.call(this,i):(i=this.isColGroupRefresh?i:this.getFrozenRightHeaderColGroup(),t.isNullOrUndefined(i)||(i.id="content-"+i.id),this.isColGroupRefresh=!1,2===this.frzCount&&(this.frzCount=0),this.colgroup=i)},i.prototype.renderEmpty=function(t){this.parent.getFrozenLeftColumnsCount()?(e.prototype.renderEmpty.call(this,t),this.getFrozenContent().querySelector(".e-emptyrow").querySelector("td").colSpan=this.parent.getVisibleFrozenLeftCount(),this.parent.getFrozenRightColumnsCount()&&this.renderFrozenLeftWithRightEmptyRow()):this.renderFrozenRightEmptyRowAlone(t),this.parent.notify(zr,{case:"refreshHeight"})},i.prototype.setHeightToContent=function(e){this.parent.getFrozenRightColumnsCount()&&(this.getFrozenRightContent().style.height=e.toString()+"px"),this.parent.getFrozenLeftColumnsCount()&&(this.getFrozenContent().style.height=e.toString()+"px"),this.getMovableContent().style.height=e.toString()+"px"},i.prototype.actionComplete=function(t){e.prototype.actionComplete.call(this,t)},i.prototype.batchAdd=function(t){e.prototype.batchAdd.call(this,t)},i.prototype.getTbody=function(e){var t;return e===ps?t=this.parent.getFrozenLeftContentTbody():"movable"===e?t=this.parent.getMovableContentTbody():e===ds&&(t=this.parent.getFrozenRightContentTbody()),t},i.prototype.setIsFrozen=function(e,t){e.isFrozen=t===ps||"Right"===this.parent.getFrozenMode()&&t===ds,e.renderFrozenRightContent=this.parent.getFrozenMode()===hs&&t===ds,e.renderMovableContent="movable"===t},i.prototype.appendContent=function(e,i,r,n){!t.isNullOrUndefined(this.parent.rowTemplate)&&this.parent.isReact?e=i:e.appendChild(i),"Left"===this.parent.getFrozenMode()?n===ps?(this.isLoaded=!1,this.getFrozenContent().querySelector("table").appendChild(e),this.refreshContentRows(t.extend({},r))):(this.refreshTbody(e),this.isLoaded=!0,this.getMovableContent().querySelector("table").appendChild(e),this.refreshHeight(),this.refreshScrollOffset()):"Right"===this.parent.getFrozenMode()?"movable"===n?(this.refreshTbody(e),this.isLoaded=!0,this.getMovableContent().querySelector("table").appendChild(e),this.refreshHeight(),this.refreshScrollOffset()):(this.isLoaded=!1,this.getFrozenRightContent().querySelector("table").appendChild(e),this.refreshContentRows(t.extend({},r))):this.parent.getFrozenMode()===hs&&(n===ps?(this.isLoaded=!1,this.getFrozenContent().querySelector("table").appendChild(e),this.refreshContentRows(t.extend({},r))):"movable"===n?(this.refreshTbody(e),this.isLoaded=!1,this.getMovableContent().querySelector("table").appendChild(e),this.refreshContentRows(t.extend({},r))):(this.isLoaded=!0,this.getFrozenRightContent().querySelector("table").appendChild(e),this.refreshHeight(),this.refreshScrollOffset())),this.isInitialRender&&(this.parent.scrollModule.setHeight(),this.isInitialRender=!1),this.widthService.refreshFrozenScrollbar()},i.prototype.refreshHeight=function(){this.parent.allowTextWrap||this.parent.notify(zr,{case:"refreshHeight"})},i.prototype.splitRows=function(e){var t=this.parent.getFrozenLeftColumnsCount(),i=this.parent.getFrozenRightColumnsCount();t&&!i?e===ps?(this.freezeRows=this.rows,this.freezeRowElements=this.rowElements):this.movableRows=this.rows:!t&&i?"movable"===e?this.movableRows=this.rows:(this.freezeRows=this.rows,this.freezeRowElements=this.rowElements):t&&i&&(e===ps?(this.freezeRows=this.rows,this.freezeRowElements=this.rowElements):"movable"===e?(this.movableRows=this.rows,this.movableRowElements=this.rowElements):(this.frozenRightRows=this.rows,this.frozenRightRowElements=this.rowElements))},i.prototype.getMovableRowElements=function(){return this.parent.getFrozenMode()!==hs?this.rowElements:this.movableRowElements},i.prototype.getFrozenRightRowElements=function(){return this.parent.getFrozenMode()!==hs?this.freezeRowElements:this.frozenRightRowElements},i.prototype.getFrozenRightRows=function(){return this.parent.getFrozenMode()===hs?this.parent.enableInfiniteScrolling?this.rightFreezeRows:this.frozenRightRows:this.getRows()},i.prototype.getFrozenRightRowByIndex=function(e){return this.parent.getFrozenRightDataRows()[e]},i.prototype.getRows=function(){var e=this.getInfiniteRows();return e.length?e:this.freezeRows},i.prototype.getRowElements=function(){return this.freezeRowElements},i}(Eh),Mh=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Oh=function(t){function i(e,i){var r=t.call(this,e,i)||this;return r.frzRows=[],r.mvblRows=[],r.frRows=[],r.serviceLoc=i,r.eventListener("on"),r.rowModelGenerator=new Es(r.parent),r}return Mh(i,t),i.prototype.eventListener=function(e){this.parent[e](zn,this.getVirtualData,this),this.parent[e](eo,this.setFreezeSelection,this),this.parent[e](ro,this.refreshVirtualFrozenRows,this),this.parent.addEventListener(Dt,this.actionComplete.bind(this))},i.prototype.actionComplete=function(e){if("delete"===e.requestType&&this.parent.frozenRows)for(var t=0;t<this.parent.frozenRows;t++)yt(this,t)},i.prototype.refreshVirtualFrozenRows=function(e){var t=this,i=this.parent;if("delete"===e.requestType&&i.frozenRows){e.isFrozenRowsRender=!0;var r=i.renderModule.data.generateQuery(!0).clone();r.page(1,i.pageSettings.pageSize),i.renderModule.data.getData({},r).then(function(r){nt(e,r.result,i.getSelectedRowIndexes(),i,t.rowModelGenerator,t.serviceLoc,t.virtualRenderer,t)})}},i.prototype.getVirtualData=function(e){this.virtualRenderer.getVirtualData(e)},i.prototype.setFreezeSelection=function(e){lt(e,this.virtualRenderer)},i.prototype.renderTable=function(){this.freezeRowGenerator=new xh(this.parent),this.virtualRenderer=new ja(this.parent,this.serviceLoc),this.virtualRenderer.header=this.serviceLoc.getService("rendererFactory").getRenderer(e.RenderType.Header).virtualHdrRenderer,t.prototype.renderTable.call(this),this.virtualRenderer.setPanel(this.parent.getContent()),this.scrollbar=this.parent.getContent().querySelector(".e-movablescrollbar");var i=this.getMovableContent(),r=this.parent.height;if(this.virtualRenderer.virtualEle.content=this.virtualRenderer.content=this.getPanel().querySelector("."+es),this.virtualRenderer.virtualEle.content.style.overflowX="hidden",this.virtualRenderer.virtualEle.renderFrozenWrapper(r),this.virtualRenderer.virtualEle.renderFrozenPlaceHolder(),this.parent.enableColumnVirtualization){this.virtualRenderer.virtualEle.movableContent=this.virtualRenderer.movableContent=this.getPanel().querySelector("."+Yo),this.virtualRenderer.virtualEle.renderMovableWrapper(r),this.virtualRenderer.virtualEle.renderMovablePlaceHolder();var n=i.querySelector("table");this.virtualRenderer.virtualEle.movableTable=n,this.virtualRenderer.virtualEle.movableWrapper.appendChild(n),i.appendChild(this.virtualRenderer.virtualEle.movableWrapper),i.appendChild(this.virtualRenderer.virtualEle.movablePlaceholder)}this.virtualRenderer.virtualEle.wrapper.appendChild(this.getFrozenContent()),this.virtualRenderer.virtualEle.wrapper.appendChild(i),this.virtualRenderer.virtualEle.table=this.getTable(),vt(this.parent,this.virtualRenderer,this.scrollbar,this.getMovableContent())},i.prototype.appendContent=function(e,t,i){ht(this.virtualRenderer,this.widthService,e,t,i)},i.prototype.generateRows=function(e,t){return this.firstPageRecords||(this.firstPageRecords=e),dt(this.virtualRenderer,e,t,this.freezeRowGenerator,this.parent)},i.prototype.getRowByIndex=function(e){return this.virtualRenderer.getRowByIndex(e)},i.prototype.getMovableRowByIndex=function(e){return this.virtualRenderer.getMovableVirtualRowByIndex(e)},i.prototype.collectRows=function(e){return st(e,this.virtualRenderer,this.parent)},i.prototype.getMovableRows=function(){return this.collectRows("movable")},i.prototype.getRows=function(){return this.collectRows("frozen-left")},i.prototype.getColGroup=function(){var e=this.parent.getMovableVirtualContent();return this.isXaxis()?e.querySelector(fs):this.colgroup},i.prototype.getReorderedFrozenRows=function(e){return pt(e,this.virtualRenderer,this.parent,this.freezeRowGenerator,this.firstPageRecords)},i.prototype.isXaxis=function(){return ct(this.virtualRenderer)},i.prototype.getHeaderCells=function(){return ut(this.virtualRenderer,this.parent)},i.prototype.getVirtualFreezeHeader=function(){return gt(this.virtualRenderer,this.parent)},i.prototype.ensureFrozenCols=function(e){return ft(e,this.parent)},i.prototype.getRowObjectByIndex=function(e){return this.virtualRenderer.getRowObjectByIndex(e)},i.prototype.setColGroup=function(e){return mt(e,this.virtualRenderer,this)},i}(Eh),kh=function(e){function t(t,i){var r=e.call(this,t,i)||this;return r.serviceLoc=i,r}return Mh(t,e),t.prototype.renderTable=function(){this.virtualHdrRenderer=new Va(this.parent,this.serviceLoc),this.virtualHdrRenderer.gen.refreshColOffsets(),this.parent.setColumnIndexesInView(this.virtualHdrRenderer.gen.getColumnIndexes(this.getPanel().querySelector("."+Xo))),this.virtualHdrRenderer.virtualEle.content=this.getPanel().querySelector("."+Xo),this.virtualHdrRenderer.virtualEle.renderFrozenWrapper(),this.virtualHdrRenderer.virtualEle.renderFrozenPlaceHolder(),this.parent.enableColumnVirtualization&&(this.virtualHdrRenderer.virtualEle.movableContent=this.getPanel().querySelector("."+Jo),this.virtualHdrRenderer.virtualEle.renderMovableWrapper(),this.virtualHdrRenderer.virtualEle.renderMovablePlaceHolder()),e.prototype.renderTable.call(this),this.virtualHdrRenderer.setPanel(this.parent.getHeaderContent())},t.prototype.rfshMovable=function(){this.getFrozenHeader().appendChild(this.getTable()),this.virtualHdrRenderer.virtualEle.wrapper.appendChild(this.getFrozenHeader()),this.parent.enableColumnVirtualization?this.virtualHdrRenderer.virtualEle.movableWrapper.appendChild(this.createHeader(void 0,"movable")):this.getMovableHeader().appendChild(this.createTable()),this.virtualHdrRenderer.virtualEle.wrapper.appendChild(this.getMovableHeader())},t}(Ih),Ah=function(i){function r(e,t){var r=i.call(this,e,t)||this;return r.frRows=[],r.frzRows=[],r.mvblRows=[],r.serviceLoc=t,r.eventListener("on"),r.rowModelGenerator=new Es(r.parent),r}return Mh(r,i),r.prototype.actionComplete=function(e){if("delete"===e.requestType&&this.parent.frozenRows)for(var t=0;t<this.parent.frozenRows;t++){if(!this.virtualRenderer.vgenerator.frozenRightCache[1]){this.virtualRenderer.vgenerator.frozenRightCache[1]=this.frRows.length?this.frRows:this.frzRows;break}this.virtualRenderer.vgenerator.frozenRightCache[1][t]=this.frRows.length?this.frRows[t]:this.frzRows[t],yt(this,t)}},r.prototype.eventListener=function(e){this.parent.addEventListener(Dt,this.actionComplete.bind(this)),this.parent[e](ro,this.refreshVirtualFrozenRows,this),this.parent[e](zn,this.getVirtualData,this),this.parent[e](eo,this.setFreezeSelection,this)},r.prototype.refreshVirtualFrozenRows=function(e){var t=this;if("delete"===e.requestType&&this.parent.frozenRows){e.isFrozenRowsRender=!0;var i=this.parent.renderModule.data.generateQuery(!0).clone();i.page(1,this.parent.pageSettings.pageSize);var r=this.parent.getSelectedRowIndexes();this.parent.renderModule.data.getData({},i).then(function(i){nt(e,i.result,r,t.parent,t.rowModelGenerator,t.serviceLoc,t.virtualRenderer,t)})}},r.prototype.setFreezeSelection=function(e){lt(e,this.virtualRenderer)},r.prototype.getVirtualData=function(e){this.virtualRenderer.getVirtualData(e)},r.prototype.renderNextFrozentPart=function(e,i){e.renderMovableContent=this.parent.getFrozenLeftCount()?i===ps:i===ds,e.renderFrozenRightContent=this.parent.getFrozenMode()===hs&&"movable"===i,(e.renderMovableContent||e.renderFrozenRightContent)&&this.refreshContentRows(t.extend({},e))},r.prototype.renderTable=function(){this.virtualRenderer=new ja(this.parent,this.serviceLoc),this.virtualRenderer.header=this.serviceLoc.getService("rendererFactory").getRenderer(e.RenderType.Header).virtualHdrRenderer,this.freezeRowGenerator=new xh(this.parent),i.prototype.renderTable.call(this),this.virtualRenderer.setPanel(this.parent.getContent()),this.scrollbar=this.parent.getContent().querySelector(".e-movablescrollbar");var t=this.getFrozenRightContent(),r=this.getFrozenContent(),n=this.getMovableContent();"Right"===this.parent.getFrozenMode()&&(r=t),this.virtualRenderer.virtualEle.content=this.virtualRenderer.content=this.getPanel().querySelector("."+es),this.virtualRenderer.virtualEle.content.style.overflowX="hidden";var o=this.parent.height;this.virtualRenderer.virtualEle.renderFrozenWrapper(o),this.virtualRenderer.virtualEle.renderFrozenPlaceHolder(),this.renderVirtualFrozenLeft(r,n),this.renderVirtualFrozenRight(r,n),this.renderVirtualFrozenLeftRight(r,n,t),this.virtualRenderer.virtualEle.table=this.getTable(),vt(this.parent,this.virtualRenderer,this.scrollbar,this.getMovableContent())},r.prototype.renderVirtualFrozenLeft=function(e,t){"Left"===this.parent.getFrozenMode()&&(this.virtualRenderer.virtualEle.wrapper.appendChild(e),this.virtualRenderer.virtualEle.wrapper.appendChild(t))},r.prototype.renderVirtualFrozenRight=function(e,t){"Right"===this.parent.getFrozenMode()&&(this.virtualRenderer.virtualEle.wrapper.appendChild(t),this.virtualRenderer.virtualEle.wrapper.appendChild(e))},r.prototype.renderVirtualFrozenLeftRight=function(e,t,i){this.parent.getFrozenMode()===hs&&(this.virtualRenderer.virtualEle.wrapper.appendChild(e),this.virtualRenderer.virtualEle.wrapper.appendChild(t),this.virtualRenderer.virtualEle.wrapper.appendChild(i))},r.prototype.appendContent=function(e,t,i){ht(this.virtualRenderer,this.widthService,e,t,i),this.refreshScrollOffset()},r.prototype.generateRows=function(e,t){return this.firstPageRecords||(this.firstPageRecords=e),dt(this.virtualRenderer,e,t,this.freezeRowGenerator,this.parent)},r.prototype.getRowByIndex=function(e){return this.virtualRenderer.getRowByIndex(e)},r.prototype.getFrozenRightRowByIndex=function(e){return this.virtualRenderer.getFrozenRightVirtualRowByIndex(e)},r.prototype.collectRows=function(e){return st(e,this.virtualRenderer,this.parent)},r.prototype.getMovableRowByIndex=function(e){return this.virtualRenderer.getMovableVirtualRowByIndex(e)},r.prototype.getFrozenRightRows=function(){return this.collectRows("frozen-right")},r.prototype.getMovableRows=function(){return this.collectRows("movable")},r.prototype.getColGroup=function(){var e=this.parent.getMovableVirtualContent();return ct(this.virtualRenderer)?e.querySelector(fs):this.colgroup},r.prototype.getRows=function(){return this.collectRows("Right"===this.parent.getFrozenMode()?"frozen-right":"frozen-left")},r.prototype.getReorderedFrozenRows=function(e){return pt(e,this.virtualRenderer,this.parent,this.freezeRowGenerator,this.firstPageRecords)},r.prototype.getHeaderCells=function(){return ut(this.virtualRenderer,this.parent)},r.prototype.isXaxis=function(){return ct(this.virtualRenderer)},r.prototype.getVirtualFreezeHeader=function(){return gt(this.virtualRenderer,this.parent)},r.prototype.getRowObjectByIndex=function(e){return this.virtualRenderer.getRowObjectByIndex(e)},r.prototype.ensureFrozenCols=function(e){return ft(e,this.parent)},r.prototype.setColGroup=function(e){return mt(e,this.virtualRenderer,this)},r}(Dh),Bh=function(){function t(e,t){this.parent=e,this.locator=t,this.addEventListener()}return t.prototype.getModuleName=function(){return"freeze"},t.prototype.addEventListener=function(){this.parent.isDestroyed||(this.parent.on(bi,this.instantiateRenderer,this),this.parent.on(Ki,this.destroy,this))},t.prototype.instantiateRenderer=function(){this.parent.log("limitation",this.getModuleName());var t=this.locator.getService("rendererFactory");this.parent.getFrozenColumns()&&(this.parent.enableColumnVirtualization?t.addRenderer(e.RenderType.Header,new kh(this.parent,this.locator)):t.addRenderer(e.RenderType.Header,new Ih(this.parent,this.locator)),this.parent.enableVirtualization?t.addRenderer(e.RenderType.Content,new Oh(this.parent,this.locator)):t.addRenderer(e.RenderType.Content,new Eh(this.parent,this.locator))),(this.parent.getFrozenLeftColumnsCount()||this.parent.getFrozenRightColumnsCount())&&(t.addRenderer(e.RenderType.Header,new zh(this.parent,this.locator)),this.parent.enableVirtualization?t.addRenderer(e.RenderType.Content,new Ah(this.parent,this.locator)):t.addRenderer(e.RenderType.Content,new Dh(this.parent,this.locator)))},t.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(bi,this.instantiateRenderer),this.parent.off(Ki,this.destroy))},t.prototype.destroy=function(){this.removeEventListener()},t}(),Nh=function(){function e(e,t){this.defaultItems={},this.localeText=this.setLocaleKey(),this.disableItems=[],this.hiddenItems=[],this.isOpen=!1,this.GROUP="e-icon-group",this.UNGROUP="e-icon-ungroup",this.ASCENDING="e-icon-ascending",this.DESCENDING="e-icon-descending",this.ROOT="e-columnmenu",this.FILTER="e-icon-filter",this.POP="e-filter-popup",this.WRAP="e-col-menu",this.CHOOSER="_chooser_",this.parent=e,this.gridID=e.element.id,this.serviceLocator=t,this.addEventListener()}return e.prototype.wireEvents=function(){for(var e=this.getColumnMenuHandlers(),i=0;i<e.length;i++)t.EventHandler.add(e[i],"mousedown",this.columnMenuHandlerDown,this)},e.prototype.unwireEvents=function(){for(var e=this.getColumnMenuHandlers(),i=0;i<e.length;i++)t.EventHandler.remove(e[i],"mousedown",this.columnMenuHandlerDown)},e.prototype.destroy=function(){var e=this.parent.element;e&&(e.querySelector("."+Wo)||e.querySelector("."+Ko))&&(this.columnMenu.destroy(),this.removeEventListener(),this.unwireFilterEvents(),this.unwireEvents(),this.element.parentNode&&t.remove(this.element))},e.prototype.columnMenuHandlerClick=function(e){e.target.classList.contains("e-columnmenu")&&(this.columnMenu.items=this.getItems(),this.columnMenu.dataBind(),this.isOpen&&this.headerCell!==this.getHeaderCell(e)||document.querySelector(".e-grid-menu .e-menu-parent.e-ul")?(this.columnMenu.close(),this.openColumnMenu(e)):this.isOpen?this.columnMenu.close():this.openColumnMenu(e))},e.prototype.openColumnMenuByField=function(e){this.openColumnMenu({target:this.parent.getColumnHeaderByField(e).querySelector(".e-columnmenu")})},e.prototype.afterFilterColumnMenuClose=function(){this.columnMenu&&(this.columnMenu.items=this.getItems(),this.columnMenu.dataBind(),this.columnMenu.close())},e.prototype.openColumnMenu=function(e){var i={top:0,left:0};this.element.style.cssText="display:block;visibility:hidden";var n=this.element.getBoundingClientRect(),o=this.parent.element.getBoundingClientRect();this.element.style.cssText="display:none;visibility:visible",this.headerCell=this.getHeaderCell(e),t.Browser.isDevice?(i.top=window.innerHeight/2-n.height/2,i.left=window.innerWidth/2-n.width/2):this.parent.enableRtl?i=r.calculatePosition(this.headerCell,"left","bottom"):((i=r.calculatePosition(this.headerCell,"right","bottom")).left-=n.width,i.left+n.width+1>=o.right&&(i.left-=35)),this.columnMenu.open(i.top,i.left),e.preventDefault&&e.preventDefault(),ve(this.parent.element,this.columnMenu.element.parentElement)},e.prototype.columnMenuHandlerDown=function(){this.isOpen=!("none"===this.element.style.display||""===this.element.style.display)},e.prototype.getColumnMenuHandlers=function(){return[].slice.call(this.parent.getHeaderTable().getElementsByClassName(this.ROOT))},e.prototype.addEventListener=function(){this.parent.isDestroyed||(this.parent.on(Di,this.wireEvents,this),this.parent.on(Fi,this.enableAfterRenderMenu,this),this.parent.on(Si,this.render,this),this.isFilterItemAdded()&&this.parent.on(Ar,this.filterPosition,this),this.parent.on(Wi,this.columnMenuHandlerClick,this),this.parent.on(Lo,this.afterFilterColumnMenuClose,this),this.parent.on(_i,this.keyPressHandler,this),this.parent.on(Ki,this.destroy,this))},e.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(Di,this.unwireEvents),this.parent.off(Fi,this.enableAfterRenderMenu),this.parent.off(Si,this.render),this.isFilterItemAdded()&&this.parent.off(Ar,this.filterPosition),this.parent.off(Wi,this.columnMenuHandlerClick),this.parent.on(Lo,this.afterFilterColumnMenuClose),this.parent.off(_i,this.keyPressHandler),this.parent.off(Ki,this.destroy))},e.prototype.keyPressHandler=function(e){var t=this.parent;if("altDownArrow"===e.action){var i=t.focusModule.currentInfo.element;if(i&&i.classList.contains("e-headercell")){var r=t.getColumnByUid(i.firstElementChild.getAttribute("e-mappinguid"));this.openColumnMenuByField(r.field)}}},e.prototype.enableAfterRenderMenu=function(e){e.module===this.getModuleName()&&e.enable&&(this.columnMenu&&(this.columnMenu.destroy(),t.remove(this.element)),this.render())},e.prototype.render=function(){this.l10n=this.serviceLocator.getService("localization"),this.element=this.parent.createElement("ul",{id:this.gridID+"_columnmenu",className:"e-colmenu"}),this.element.setAttribute("aria-label",this.l10n.getConstant("ColumnMenuDialogARIA")),this.parent.element.appendChild(this.element),this.columnMenu=new a.ContextMenu({cssClass:"e-grid-menu",enableRtl:this.parent.enableRtl,enablePersistence:this.parent.enablePersistence,locale:this.parent.locale,items:this.getItems(),select:this.columnMenuItemClick.bind(this),beforeOpen:this.columnMenuBeforeOpen.bind(this),onOpen:this.columnMenuOnOpen.bind(this),onClose:this.columnMenuOnClose.bind(this),beforeItemRender:this.beforeMenuItemRender.bind(this),beforeClose:this.columnMenuBeforeClose.bind(this)}),this.columnMenu.appendTo(this.element),this.wireFilterEvents()},e.prototype.wireFilterEvents=function(){!t.Browser.isDevice&&this.isFilterItemAdded()&&t.EventHandler.add(this.element,"mouseover",this.appendFilter,this)},e.prototype.unwireFilterEvents=function(){!t.Browser.isDevice&&this.isFilterItemAdded()&&t.EventHandler.remove(this.element,"mouseover",this.appendFilter)},e.prototype.beforeMenuItemRender=function(e){if(this.isChooserItem(e.item)){var t=this.getKeyFromId(e.item.id,this.CHOOSER),i=this.parent.columnModel.filter(function(e){return e.field===t}),r=n.createCheckBox(this.parent.createElement,!1,{label:e.item.text,checked:i[0].visible});this.parent.enableRtl&&r.classList.add("e-rtl"),e.element.innerHTML="",e.element.appendChild(r)}else e.item.id&&"Filter"===this.getKeyFromId(e.item.id)&&(e.element.appendChild(this.parent.createElement("span",{className:"e-icons e-caret"})),e.element.className+="e-filter-item e-menu-caret-icon")},e.prototype.columnMenuBeforeClose=function(e){var i=e.event?t.closest(e.event.target,".e-menu-item"):null;!t.isNullOrUndefined(e.parentItem)&&"ColumnChooser"===this.getKeyFromId(e.parentItem.id)&&i&&this.isChooserItem(i)?e.cancel=!0:e.event&&(t.closest(e.event.target,"."+this.POP)||e.event.currentTarget&&e.event.currentTarget.activeElement&&D(e.event.currentTarget.activeElement,"e-filter-popup")||D(e.event.target,"e-popup")||D(e.event.target,"e-popup-wrapper"))&&!t.Browser.isDevice&&(e.cancel=!0)},e.prototype.isChooserItem=function(e){return e.id&&e.id.indexOf("_colmenu_")>=0&&-1===this.getKeyFromId(e.id,this.CHOOSER).indexOf("_colmenu_")},e.prototype.columnMenuBeforeOpen=function(e){e.column=this.targetColumn=this.getColumn(),this.parent.trigger(Or,e);for(var t=0,i=e.items;t<i.length;t++){var r=i[t],n=this.getKeyFromId(r.id),o=this.defaultItems[n];-1!==this.getDefaultItems().indexOf(n)&&this.ensureDisabledStatus(n)&&!o.hide&&this.disableItems.push(r.text),r.hide&&this.hiddenItems.push(r.text)}this.columnMenu.enableItems(this.disableItems,!1),this.columnMenu.hideItems(this.hiddenItems)},e.prototype.columnMenuOnOpen=function(e){"e-menu-parent e-ul "===e.element.className&&(e.element.offsetHeight>window.innerHeight||this.parent.element.offsetHeight>window.innerHeight)&&(e.element.style.maxHeight=.8*window.innerHeight+"px",e.element.style.overflowY="auto")},e.prototype.ensureDisabledStatus=function(e){var t=!1;switch(e){case"Group":(!this.parent.allowGrouping||this.parent.ensureModuleInjected(Ma)&&this.targetColumn&&this.parent.groupSettings.columns.indexOf(this.targetColumn.field)>=0||this.targetColumn&&!this.targetColumn.allowGrouping)&&(t=!0);break;case"AutoFitAll":case"AutoFit":t=!this.parent.ensureModuleInjected(Ta);break;case"Ungroup":(!this.parent.ensureModuleInjected(Ma)||this.parent.ensureModuleInjected(Ma)&&this.targetColumn&&this.parent.groupSettings.columns.indexOf(this.targetColumn.field)<0)&&(t=!0);break;case"SortDescending":case"SortAscending":if(this.parent.allowSorting&&this.parent.ensureModuleInjected(oa)&&this.parent.sortSettings.columns.length>0&&this.targetColumn&&this.targetColumn.allowSorting)for(var i=this.parent.sortSettings.columns,r=0;r<i.length;r++)i[r].field===this.targetColumn.field&&i[r].direction.toLocaleLowerCase()===e.toLocaleLowerCase().replace("sort","")&&(t=!0);else(!this.parent.allowSorting||!this.parent.ensureModuleInjected(oa)||this.parent.allowSorting&&this.targetColumn&&!this.targetColumn.allowSorting)&&(t=!0);break;case"Filter":this.parent.allowFiltering&&"FilterBar"!==this.parent.filterSettings.type&&this.parent.ensureModuleInjected(Ea)&&this.targetColumn&&this.targetColumn.allowFiltering?t=!1:this.parent.ensureModuleInjected(Ea)&&this.parent.allowFiltering&&this.targetColumn&&(!this.targetColumn.allowFiltering||"FilterBar"===this.parent.filterSettings.type)&&(t=!0)}return t},e.prototype.columnMenuItemClick=function(e){switch(this.isChooserItem(e.item)?"ColumnChooser":this.getKeyFromId(e.item.id)){case"AutoFit":this.parent.autoFitColumns(this.targetColumn.field);break;case"AutoFitAll":this.parent.autoFitColumns([]);break;case"Ungroup":this.parent.ungroupColumn(this.targetColumn.field);break;case"Group":this.parent.groupColumn(this.targetColumn.field);break;case"SortAscending":this.parent.sortColumn(this.targetColumn.field,"Ascending");break;case"SortDescending":this.parent.sortColumn(this.targetColumn.field,"Descending");break;case"ColumnChooser":var t=this.getKeyFromId(e.item.id,this.CHOOSER),i=e.element.querySelector(".e-checkbox-wrapper .e-frame");i&&i.classList.contains("e-check")?(i.classList.remove("e-check"),this.parent.hideColumns(t,"field")):i&&(this.parent.showColumns(t,"field"),i.classList.add("e-check"));break;case"Filter":this.getFilter(e.element,e.item.id)}e.column=this.targetColumn,this.parent.trigger(Mr,e)},e.prototype.columnMenuOnClose=function(e){e.items.length>0&&e.items[0].parentObj instanceof a.ContextMenu&&(this.columnMenu.enableItems(this.disableItems,!1),this.disableItems=[],this.columnMenu.showItems(this.hiddenItems),this.hiddenItems=[],this.isFilterPopupOpen()&&this.getFilter(e.element,e.element.id,!0)),this.parent.isFrozenGrid()||this.parent.notify(vn,{})},e.prototype.getDefaultItems=function(){return["AutoFitAll","AutoFit","SortAscending","SortDescending","Group","Ungroup","ColumnChooser","Filter"]},e.prototype.getItems=function(){for(var e=[],t=0,i=this.parent.columnMenuItems?this.parent.columnMenuItems:this.getDefault();t<i.length;t++){var r=i[t];if("string"==typeof r)if("ColumnChooser"===r){var n=this.getDefaultItem(r);n.items=this.createChooserItems(),e.push(n)}else e.push(this.getDefaultItem(r));else e.push(r)}return e},e.prototype.getDefaultItem=function(e){var t={};switch(e){case"SortAscending":t={iconCss:this.ASCENDING};break;case"SortDescending":t={iconCss:this.DESCENDING};break;case"Group":t={iconCss:this.GROUP};break;case"Ungroup":t={iconCss:this.UNGROUP};break;case"Filter":t={iconCss:this.FILTER}}return this.defaultItems[e]={text:this.getLocaleText(e),id:this.generateID(e),iconCss:t.iconCss?"e-icons "+t.iconCss:null},this.defaultItems[e]},e.prototype.getLocaleText=function(e){return this.l10n.getConstant(this.localeText[e])},e.prototype.generateID=function(e,t){return this.gridID+"_colmenu_"+(t?t+e:e)},e.prototype.getKeyFromId=function(e,t){return e.indexOf("_colmenu_")>0&&e.replace(this.gridID+"_colmenu_"+(t||""),"")},e.prototype.getColumnMenu=function(){return this.element},e.prototype.getModuleName=function(){return"columnMenu"},e.prototype.setLocaleKey=function(){return{AutoFitAll:"autoFitAll",AutoFit:"autoFit",Group:"Group",Ungroup:"Ungroup",SortAscending:"SortAscending",SortDescending:"SortDescending",ColumnChooser:"Columnchooser",Filter:"FilterMenu"}},e.prototype.getHeaderCell=function(e){return t.closest(e.target,"th.e-headercell")},e.prototype.getColumn=function(){if(this.headerCell){var e=this.headerCell.querySelector(".e-headercelldiv").getAttribute("e-mappinguid");return this.parent.getColumnByUid(e)}return null},e.prototype.createChooserItems=function(){for(var e=[],t=0,i=this.parent.columnModel;t<i.length;t++){var r=i[t];r.showInColumnChooser&&r.field&&e.push({id:this.generateID(r.field,this.CHOOSER),text:r.headerText?r.headerText:r.field})}return e},e.prototype.appendFilter=function(e){if(this.defaultItems.Filter){var i=this.defaultItems.Filter.id;t.closest(e.target,"#"+i)&&!this.isFilterPopupOpen()?this.getFilter(e.target,i):!t.closest(e.target,"#"+i)&&this.isFilterPopupOpen()&&this.getFilter(e.target,i,!0)}},e.prototype.getFilter=function(e,i,r){var n=this.getFilterPop();n?n.style.display=!t.Browser.isDevice&&r?"none":"block":this.parent.notify(kr,{col:this.targetColumn,target:e,isClose:r,id:i})},e.prototype.setPosition=function(e,t){var i=this.parent.element.getBoundingClientRect(),r=e.getBoundingClientRect(),n=r.left-i.left,o=r.top-i.top;i.height<o?o=o-t.offsetHeight+r.height:i.height<o+t.offsetHeight&&(o=i.height-t.offsetHeight),window.innerHeight<t.offsetHeight+o+i.top&&(o=window.innerHeight-t.offsetHeight-i.top),o+i.top<0&&(o=0),n+=this.parent.enableRtl?-t.offsetWidth:r.width,i.width<=n+t.offsetWidth?(n-=r.width+t.offsetWidth,r.left<t.offsetWidth&&(n=r.left+t.offsetWidth/2)):n<0&&(n+=t.offsetWidth+r.width),t.style.top=o+"px",t.style.left=n+"px"},e.prototype.filterPosition=function(){var e=this.getFilterPop();if(e.classList.add(this.WRAP),!t.Browser.isDevice){var i=e.style.display;e.style.cssText+="display:block;visibility:hidden";var r=this.element.querySelector("."+this.FILTER);r&&(this.setPosition(r.parentElement,e),e.style.cssText+="display:"+i+";visibility:visible")}},e.prototype.getDefault=function(){var e=[];return this.parent.ensureModuleInjected(Ta)&&(e.push("AutoFitAll"),e.push("AutoFit")),this.parent.allowGrouping&&this.parent.ensureModuleInjected(Ma)&&(e.push("Group"),e.push("Ungroup")),this.parent.allowSorting&&this.parent.ensureModuleInjected(oa)&&(e.push("SortAscending"),e.push("SortDescending")),e.push("ColumnChooser"),this.parent.allowFiltering&&"FilterBar"!==this.parent.filterSettings.type&&this.parent.ensureModuleInjected(Ea)&&e.push("Filter"),e},e.prototype.isFilterPopupOpen=function(){var e=this.getFilterPop();return e&&"none"!==e.style.display},e.prototype.getFilterPop=function(){return t.Browser.isDevice&&null!==this.targetColumn&&"Menu"===this.parent.filterSettings.type?document.getElementById(this.targetColumn.uid+"-flmdlg"):this.parent.element.querySelector("."+this.POP)},e.prototype.isFilterItemAdded=function(){return this.parent.columnMenuItems&&this.parent.columnMenuItems.indexOf("Filter")>=0||!this.parent.columnMenuItems},e}(),Ph=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Lh=function(e){function r(t,i){var r=e.call(this,t,i)||this;return r.parent=t,r.serviceLocator=i,r.initEvent(),r}return Ph(r,e),r.prototype.initEvent=function(){this.parent.isDestroyed||(this.parent.on(Nr,this.initForeignKeyColumns,this),this.parent.on(Pr,this.getForeignKeyData,this),this.parent.on(Lr,this.generateQueryFormData,this))},r.prototype.initForeignKeyColumns=function(e){for(var r=0;r<e.length;r++)e[r].dataSource=e[r].dataSource instanceof i.DataManager?e[r].dataSource:t.isNullOrUndefined(e[r].dataSource)?new i.DataManager:"result"in e[r].dataSource?e[r].dataSource:new i.DataManager(e[r].dataSource)},r.prototype.eventfPromise=function(e,r,n,o){var s=this.getStateEventArgument(r),l=new i.Deferred,a=new i.Deferred;s.action=e.action;var h=this.parent.getDataModule();return!t.isNullOrUndefined(e.action)&&e.action.requestType&&!1!==h.foreignKeyDataState.isDataChanged?(h.setForeignKeyDataState({isPending:!0,resolver:a.resolve}),a.promise.then(function(){l.resolve(o.dataSource)}),s.setColumnData=this.parent.setForeignKeyData.bind(this.parent),this.parent.trigger(Ur,s)):(h.setForeignKeyDataState({}),l.resolve(n)),l},r.prototype.getForeignKeyData=function(e){for(var r=this,n=e.column?[e.column]:this.parent.getForeignKeyColumns(),o=[],s=function(t){var i=void 0,r=e.isComplex?l.genarateColumnQuery(n[t]):l.genarateQuery(n[t],e.result.result,!1,!0);r.params=l.parent.query.params;var s=n[t].dataSource;if(s&&"result"in s){i=l.eventfPromise(e,r,s,n[t]).promise}else i=!s.ready||s.dataSource.offline?s.executeQuery(r):s.ready.then(function(){return s.executeQuery(r)});o.push(i)},l=this,a=0;a<n.length;a++)s(a);Promise.all(o).then(function(r){for(var o=0;o<r.length;o++)n[o].columnData=r[o].result,"dropdownedit"===n[o].editType&&"result"in n[o].dataSource&&(n[o].edit.params=t.extend(n[o].edit.params,{dataSource:r[o].result,query:new i.Query,fields:{value:n[o].foreignKeyField||n[o].field,text:n[o].foreignKeyValue}}));e.promise.resolve(e.result)}).catch(function(t){return r.parent.log(["actionfailure","foreign_key_failure"]),e.promise&&e.promise.reject&&e.promise.reject(t),t})},r.prototype.generateQueryFormData=function(e){e.predicate.predicate=this.genarateQuery(e.column,e.column.columnData,!0)},r.prototype.genarateQuery=function(e,t,r,n){var o=this.parent,s=[],l=new i.Query,a=r?e.foreignKeyField:e.field;if(o.allowPaging||o.enableVirtualization||r){t=new i.DataManager(o.allowGrouping&&o.groupSettings.columns.length&&!r?t.records:t).executeLocal((new i.Query).select(a));var h=i.DataUtil.distinct(t,a,!1);a=r?e.field:e.foreignKeyField;for(var d=0;d<h.length;d++)h[d]&&h[d].getDay?s.push(se({field:a,operator:"equal",value:h[d],matchCase:!1})):s.push(new i.Predicate(a,"equal",h[d],!1))}return n?s.length?l.where(i.Predicate.or(s)):l:s.length?i.Predicate.or(s):{predicates:[]}},r.prototype.genarateColumnQuery=function(e){var t=this.parent,r=new i.Query,n=this.isFiltered(e);if(n.isTrue&&(r=this.filterQuery(r,n.column,!0)),t.searchSettings.key.length){var o=t.searchSettings;e.dataSource instanceof i.DataManager&&e.dataSource.adaptor.getModuleName&&"ODataV4Adaptor"===e.dataSource.adaptor.getModuleName()?r=this.searchQuery(r,e,!0):r.search(o.key,e.foreignKeyValue,o.operator,o.ignoreCase)}return r},r.prototype.isFiltered=function(e){var t=this.parent.filterSettings.columns.filter(function(t){return t.field===e.foreignKeyValue&&t.uid===e.uid});return{column:t,isTrue:!!t.length}},r.prototype.getModuleName=function(){return"foreignKey"},r.prototype.destroy=function(){this.destroyEvent()},r.prototype.destroyEvent=function(){this.parent.isDestroyed||(this.parent.off(Nr,this.initForeignKeyColumns),this.parent.off(Pr,this.getForeignKeyData),this.parent.off(Lr,this.generateQueryFormData))},r}(Uo),qh="https://ej2.syncfusion.com/documentation/grid",Hh="https://ej2.syncfusion.com/documentation/",Uh="[EJ2Grid.Warning]",jh="[EJ2Grid.Error]",Vh="[EJ2Grid.Info]",Gh=function(){function e(e){this.parent=e,this.parent.on("initial-end",this.patchadaptor,this)}return e.prototype.getModuleName=function(){return"logger"},e.prototype.log=function(e,t){e instanceof Array||(e=[e]);for(var i=e,r=0;r<i.length;r++){var n=_h[i[r]],o=n.check(t,this.parent);o.success&&console[n.logType](n.generateMessage(t,this.parent,o.options))}},e.prototype.patchadaptor=function(){var e=this.parent.getDataModule().dataManager.adaptor,t=e.beforeSend;t&&(e.beforeSend=function(i,r,n){t.call(e,i,r,n)})},e.prototype.destroy=function(){this.parent.isDestroyed||this.parent.off("initial-end",this.patchadaptor)},e}(),_h={module_missing:{type:"module_missing",logType:"warn",check:function(e,t){var i=t.getInjectedModules().map(function(e){return e.prototype.getModuleName()}),r=t.requiredModules().map(function(e){return e.member}).filter(function(e){return-1===i.indexOf(e)});return{success:r.filter(function(e){return"resize"!==e}).length>0,options:r}},generateMessage:function(e,t,i){return i=i.filter(function(e){return"resize"!==e}).reduce(function(e,t){return e+"* "+t+"\n"},""),Uh+": MODULES MISSING\nThe following modules are not injected:.\n"+i+"Refer to "+qh+"/module.html for documentation on importing feature modules."}},promise_enabled:{type:"promise_enabled",logType:"error",check:function(){return{success:"undefined"==typeof Promise}},generateMessage:function(){return jh+": PROMISE UNDEFINED\nPromise object is not present in the global environment,please use polyfil to support Promise object in your environment.\nRefer to "+Hh+"/base/browser.html?#required-polyfills for more information."}},primary_column_missing:{type:"primary_column_missing",logType:"warn",check:function(e,t){return{success:0===t.getColumns().filter(function(e){return e.isPrimaryKey}).length}},generateMessage:function(){return Uh+": PRIMARY KEY MISSING\nEditing is enabled but primary key column is not specified.\nRefer to "+qh+"/api-column.html?#isprimarykey for documentation on providing primary key columns."}},selection_key_missing:{type:"selection_key_missing",logType:"warn",check:function(e,t){return{success:t.selectionSettings.persistSelection&&0===t.getColumns().filter(function(e){return e.isPrimaryKey}).length}},generateMessage:function(){return Uh+": PRIMARY KEY MISSING\nselectionSettings.persistSelection property is enabled. It requires one primary key column to persist selection.\nRefer to "+qh+"/api-column.html?#isprimarykey for documentation on providing primary key columns."}},actionfailure:{type:"actionfailure",logType:"error",check:function(){return{success:!0}},generateMessage:function(e,t){var i="",r=Wh(e,t),n=Kh(e,t);return i=""!==n?n:""!==r?r:e.error,Uh+": "+i}},locale_missing:{type:"locale_missing",logType:"warn",check:function(e,r){var n=i.DataUtil.getObject("locale."+r.locale+".grid",t.L10n);return{success:"en-US"!==r.locale&&t.isNullOrUndefined(n)}},generateMessage:function(e,t){return Uh+": LOCALE CONFIG MISSING\nLocale configuration for '"+t.locale+"' is not provided.\nRefer to "+qh+"/globalization-and-localization.html?#localization \n             for documentation on setting locale configuration."}},limitation:{type:"limitation",logType:"warn",check:function(e,i){var r;switch(e){case"freeze":r={success:i.allowGrouping||!t.isUndefined(i.detailTemplate)||!t.isUndefined(i.childGrid)||!t.isUndefined(i.rowTemplate)||i.enableVirtualization,options:{name:"freeze"}};break;case"virtualization":r={success:!t.isUndefined(i.detailTemplate)||!t.isUndefined(i.childGrid)||0!==i.frozenRows||0!==i.frozenColumns,options:{name:"virtualization"}};break;default:r={success:!1}}return r},generateMessage:function(e,t,i){var r,n=i.name;switch(n){case"freeze":r="Frozen rows and columns do not support the following features:\n* Virtualization\n* Row Template\n* Details Template\n* Hierarchy Grid\n* Grouping";break;case"virtualization":r="Virtualization does not support the following features.\n* Freeze rows and columns.\n* Details Template.\n* Hierarchy Grid.\n";break;default:r=""}return Uh+": "+n.toUpperCase()+" LIMITATIONS\n"+r}},check_datasource_columns:{type:"check_datasource_columns",logType:"warn",check:function(e,t){return{success:!(t.columns.length||t.dataSource instanceof i.DataManager||t.dataSource.length)}},generateMessage:function(){return Uh+": GRID CONFIG MISSING\ndataSource and columns are not provided in the grid. At least one of either must be provided for grid configuration.\nRefer to "+qh+"/columns.html for documentation on configuring the grid data and columns."}},virtual_height:{type:"virtual_height",logType:"error",check:function(e,i){return{success:t.isNullOrUndefined(i.height)||"auto"===i.height}},generateMessage:function(){return jh+": GRID HEIGHT MISSING \nheight property is required to use virtualization.\nRefer to "+qh+"/virtual.html for documentation on configuring the virtual grid."}},grid_remote_edit:{type:"grid_remote_edit",logType:"error",check:function(e){return{success:Array.isArray(e)||Array.isArray(e.result)}},generateMessage:function(){return jh+": RETRUN VALUE MISSING  \nRemote service returns invalid data. \nRefer to "+qh+"/edit.html for documentation on configuring editing with remote data."}},grid_sort_comparer:{type:"grid_sort_comparer",logType:"warn",check:function(e,t){return{success:t.getDataModule().isRemote()}},generateMessage:function(){return Uh+": SORT COMPARER NOT WORKING  \nSort comparer will not work with remote data.Refer to "+qh+"/sorting/#custom-sort-comparer for documentation on using the sort comparer."}},resize_min_max:{type:"resize_min_max",logType:"info",check:function(e){return{success:e.column.minWidth&&e.column.minWidth>=e.width||e.column.maxWidth&&e.column.maxWidth<=e.width}},generateMessage:function(){return Vh+": RESIZING COLUMN REACHED MIN OR MAX  \nThe column resizing width is at its min or max."}},action_disabled_column:{type:"action_disabled_column",logType:"info",check:function(e){var i;switch(e.moduleName){case"reorder":i=t.isNullOrUndefined(e.destColumn)?"reordering action is disabled for the "+e.column.headerText+" column":"reordering action is disabled for the "+(e.column.allowReordering?e.destColumn.headerText:e.column.headerText)+" column";break;case"group":i="grouping action is disabled for the "+e.columnName+" column.";break;case"filter":i="filtering action is disabled for the "+e.columnName+" column.";break;case"sort":i="sorting action is disabled for the "+e.columnName+" column."}return{success:!0,options:{fn:i}}},generateMessage:function(e,t,i){return Vh+": ACTION DISABLED \n "+i.fn}},exporting_begin:{type:"exporting_begin",logType:"info",check:function(e){return{success:!0,options:{args:e}}},generateMessage:function(e,t,i){return Vh+": EXPORTNIG INPROGRESS \n Grid "+i.args+"ing is in progress"}},exporting_complete:{type:"exporting_complete",logType:"info",check:function(e){return{success:!0,options:{args:e}}},generateMessage:function(e,t,i){return Vh+": EXPORTNIG COMPLETED \n Grid "+i.args+"ing is complete"}},foreign_key_failure:{type:"foreign_key_failure",logType:"error",check:function(){return{success:!0}},generateMessage:function(){return jh+": FOREIGNKEY CONFIG \n  Grid foreign key column needs a valid data source/service.Refer to "+qh+"/columns/#foreign-key-column for documentation on configuring foreign key columns."}},initial_action:{type:"initial_action",logType:"error",check:function(e){var t;switch(e.moduleName){case"group":t="The "+e.columnName+" column is not available in the grid's column model.Please provide a valid field name to group the column";break;case"filter":t="The "+e.columnName+" column is not available in the grid's column model.Please provide a valid field name to filter the column.";break;case"sort":t="The "+e.columnName+" column is not available in the grid's column model.Please provide a valid field name to sort the column."}return{success:!0,options:{fn:t}}},generateMessage:function(e,t,i){return jh+": INITIAL ACTION FAILURE \n "+i.fn}},frozen_rows_columns:{type:"frozen_rows_columns",logType:"error",check:function(e,t){return{success:t.getColumns().length<=t.frozenColumns||t.frozenRows>=t.currentViewData.length}},generateMessage:function(e,t){return jh+": OUT OF RANGE ERROR-\n "+(t.getColumns().length<=t.frozenColumns?"FROZEN COLUMNS,":"")+(t.frozenRows>=t.currentViewData.length?"FROZEN ROWS":"")+" invalid"}},column_type_missing:{type:"column_type_missing",logType:"error",check:function(e){return{success:t.isNullOrUndefined(e.column.type),options:e.column.headerText}},generateMessage:function(e,t,i){return jh+": COLUMN TYPE MISSING-\n  "+i+" column type was invalid or not defined.Please go through below help link: "+Hh+"/grid/columns/#column-type"}},datasource_syntax_mismatch:{type:"datasource_syntax_mismatch",logType:"warn",check:function(e){return{success:e.dataState.dataSource&&!(e.dataState.dataSource instanceof i.DataManager||"result"in e.dataState.dataSource||e.dataState.dataSource instanceof Array)&&!t.isNullOrUndefined(e.dataState.dataStateChange)}},generateMessage:function(){return Uh+": DATASOURCE SYNTAX WARNING\nDataSource should be in the form of {result: Object[], count: number}when dataStateChangeEvent used"}}},Wh=function(e){var t=e.error;return t.indexOf&&0!==t.indexOf("Format options")?"":"INVALID FORMAT\nFor more information, refer to the following documentation links:\nNumber format: "+Hh+"/base/intl.html?#supported-format-string.\nDate format: "+Hh+"/base/intl.html?#manipulating-datetime.\nMessage: "+t},Kh=function(e){var r=i.DataUtil.getObject("error.error",e);if(t.isNullOrUndefined(r))return"";var n="";try{n=JSON.parse(r.responseText)}catch(e){n=""}return"XMLHTTPREQUEST FAILED\nUrl: "+r.responseURL+"\nStatus: "+r.status+" - "+r.statusText+"\n"+(""!==n?"Message: "+n:"")},Qh=function(){function e(e,t){this.infiniteCache={},this.infiniteCurrentViewData={},this.infiniteFrozenCache={},this.isDownScroll=!1,this.isUpScroll=!1,this.isScroll=!0,this.enableContinuousScroll=!1,this.initialRender=!0,this.isRemove=!1,this.isInitialCollapse=!1,this.prevScrollTop=0,this.actions=["filtering","searching","grouping","ungrouping","reorder","sorting","refresh"],this.keys=[bs,Ss,Rs,xs],this.rowTop=0,this.isInitialMovableRender=!0,this.virtualInfiniteData={},this.isCancel=!1,this.emptyRowData={},this.isNormaledit=!1,this.isInfiniteScroll=!1,this.isLastPage=!1,this.isInitialRender=!0,this.isFocusScroll=!1,this.isGroupCollapse=!1,this.parent=e,this.serviceLocator=t,this.isNormaledit="Normal"===this.parent.editSettings.mode,this.addEventListener(),this.widthService=t.getService("widthService"),this.rowModelGenerator=this.parent.isFrozenGrid()?new xh(this.parent):new Es(this.parent)}return e.prototype.getModuleName=function(){return"infiniteScroll"},e.prototype.addEventListener=function(){this.parent.on(Ri,this.onDataReady,this),this.parent.on(ir,this.dataSourceModified,this),this.parent.on(kn,this.infinitePageQuery,this),this.parent.on(On,this.infiniteScrollHandler,this),this.parent.on(Vi,this.infiniteCellFocus,this),this.parent.on(Bn,this.appendInfiniteRows,this),this.parent.on(Nn,this.removeInfiniteCacheRows,this),this.parent.on(Mn,this.resetInfiniteBlocks,this),this.parent.on(Pn,this.setCache,this),this.parent.on(qn,this.ensureIntialCollapse,this),this.parent.on(_i,this.infiniteCellFocus,this),this.parent.on(An,this.setDisplayNone,this),this.parent.on(Sn,this.editActionBegin,this),this.parent.on(zn,this.getVirtualInfiniteData,this),this.parent.on(In,this.resetInfiniteEdit,this),this.parent.on(Rn,this.infiniteEditSuccess,this),this.parent.on(En,this.refreshInfiniteCache,this),this.parent.on(Po,this.refreshInfiniteEditrowindex,this),this.parent.on(Ln,this.infiniteEditHandler,this),this.parent.on(Tn,this.infiniteAddActionBegin,this),this.parent.on(Ti,this.modelChanged,this),this.parent.on(ho,this.refreshInfiniteCurrentViewData,this),this.parent.on(Ki,this.destroy,this),this.parent.on(xi,this.selectNewRow,this),this.parent.on(Bo,this.captionActionComplete,this),this.parent.on(Ro,this.setGroupCollapsePageQuery,this),this.actionBeginFunction=this.actionBegin.bind(this),this.actionCompleteFunction=this.actionComplete.bind(this),this.dataBoundFunction=this.dataBound.bind(this),this.parent.on(cr,this.deleteComplate,this),this.parent.addEventListener(zt,this.actionBeginFunction),this.parent.addEventListener(Dt,this.actionCompleteFunction),this.parent.addEventListener(Ot,this.dataBoundFunction)},e.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(Ri,this.onDataReady),this.parent.off(ir,this.dataSourceModified),this.parent.off(kn,this.infinitePageQuery),this.parent.off(On,this.infiniteScrollHandler),this.parent.off(Vi,this.infiniteCellFocus),this.parent.off(Bn,this.appendInfiniteRows),this.parent.off(Nn,this.removeInfiniteCacheRows),this.parent.off(Mn,this.resetInfiniteBlocks),this.parent.off(Pn,this.setCache),this.parent.off(qn,this.ensureIntialCollapse),this.parent.off(_i,this.infiniteCellFocus),this.parent.off(An,this.setDisplayNone),this.parent.off(Sn,this.editActionBegin),this.parent.off(zn,this.getVirtualInfiniteData),this.parent.off(In,this.resetInfiniteEdit),this.parent.off(Rn,this.infiniteEditSuccess),this.parent.off(En,this.refreshInfiniteCache),this.parent.on(Po,this.refreshInfiniteEditrowindex),this.parent.off(Ln,this.infiniteEditHandler),this.parent.off(Tn,this.infiniteAddActionBegin),this.parent.off(Ti,this.modelChanged),this.parent.off(ho,this.refreshInfiniteCurrentViewData),this.parent.off(Ki,this.destroy),this.parent.off(xi,this.selectNewRow),this.parent.off(Bo,this.captionActionComplete),this.parent.off(Ro,this.setGroupCollapsePageQuery),this.parent.removeEventListener(zt,this.actionBeginFunction),this.parent.removeEventListener(Dt,this.actionCompleteFunction),this.parent.removeEventListener(Ot,this.dataBoundFunction))},e.prototype.dataBound=function(){"collapse"===this.groupCaptionAction?(this.groupCaptionAction="refresh",this.makeGroupCollapseRequest()):"refresh"===this.groupCaptionAction&&(this.parent.hideSpinner(),this.groupCaptionAction=this.empty)},e.prototype.setGroupCollapsePageQuery=function(e){var t=this.parent;if(!t.infiniteScrollSettings.enableCache&&this.isGroupCollapse)if(e.skipPage=!0,this.isGroupCollapse=!1,"collapse"===this.groupCaptionAction){for(var i=t.getRowObjectFromUID(this.parentCapUid),r=t.getRowsObject(),n=0,o=r.length-1;o>=0&&r[o].indent!==i.indent;o--)r[o].isDataRow&&n++;var s=tt(r.indexOf(i),r),l=$e(s.fields,s.keys,this),a=et(l);l=a[a.length-1];for(o=a.length-2;o>=0;o--)l=l.and(a[o]);e.query.where(l),e.query.skip(n),this.parentCapUid=this.empty}else{var h=t.getRows(),d=t.pageSettings.pageSize,p=Ze(h[h.length-1])+1,c=p-p%d+d-p;p%d==0&&(c=0),e.query.skip(p),e.query.take(t.infiniteScrollSettings.initialBlocks*t.pageSettings.pageSize+c)}},e.prototype.captionActionComplete=function(e){var t=this.parent;if(!t.infiniteScrollSettings.enableCache&&e.isCollapse){var i=t.getContent().firstElementChild.getBoundingClientRect(),r=t.contentModule.getTable().getBoundingClientRect();if(Math.round(r.bottom-t.getRowHeight())<=Math.round(i.bottom)){this.parentCapUid=e.parentUid,this.groupCaptionAction="collapse",t.showSpinner();var n=t.getRowObjectFromUID(e.parentUid);this.getCaptionChildCount(n)?this.makeGroupCollapseRequest(e.parentUid):(this.groupCaptionAction="refresh",this.makeGroupCollapseRequest())}}},e.prototype.makeGroupCollapseRequest=function(e){var t=this.parent,i=t.getRows(),r=Ze(i[i.length-1]),n=this.parent.pageSettings.currentPage;if(this.parent.pageSettings.currentPage=Math.ceil(r/this.parent.pageSettings.pageSize)+1,this.parent.pageSettings.currentPage>this.maxPage)t.hideSpinner();else{var o={requestType:"infiniteScroll",currentPage:this.parent.pageSettings.currentPage,prevPage:n,startIndex:r+1,direction:"down",isCaptionCollapse:!0,parentUid:e};this.isGroupCollapse=!0,this.parent.notify("model-changed",o)}},e.prototype.getCaptionChildCount=function(e){for(var t=this.parent.getRowsObject(),i=!1,r=t.indexOf(e);r<t.length&&(!(t[r].indent===e.indent||t[r].indent<e.indent)||t[r].data.key===e.data.key);r++)if(t[r].isCaptionRow&&!this.childCheck(t,t[r],r)){i=!0;break}return i},e.prototype.childCheck=function(e,t,i){for(var r=0,n=i+1;n<e.length&&e[n].indent!==t.indent;n++)e[n].indent===t.indent+1&&e[n].parentUid===t.uid&&r++;return t.data.count===r},e.prototype.updateCurrentViewData=function(){var e=this.parent;if(!e.groupSettings.columns.length){var t=Object.keys(this.infiniteCurrentViewData);e.currentViewData=[];for(var i=e.pageSettings.currentPage,r=e.infiniteScrollSettings.enableCache,n=e.infiniteScrollSettings.maxBlocks,o=r&&(i>n||this.isUpScroll&&i>1),s=o?this.isUpScroll?i:i-n+1:1,l=o?s+n-1:r?n:t.length,a=s;a<=l;a++)this.infiniteCurrentViewData[a]&&(e.currentViewData=e.currentViewData.concat(this.infiniteCurrentViewData[a]))}},e.prototype.refreshInfiniteCurrentViewData=function(e){var t=this.parent.pageSettings.currentPage,i=this.parent.pageSettings.pageSize,r=this.parent.infiniteScrollSettings.initialBlocks,n=Object.keys(this.infiniteCurrentViewData),o=this.parent.infiniteScrollSettings.enableCache;if(!this.parent.groupSettings.columns.length){var s="save"===e.args.requestType,l="delete"===e.args.requestType;o||!s&&!l?r>1&&e.data.length===r*i?this.setInitialCache(e.data.slice(),{},o&&"delete"===e.args.requestType,!0):this.infiniteCurrentViewData[t]=e.data.slice():s?this.infiniteCurrentViewData[1]=e.data.concat(this.infiniteCurrentViewData[1]):this.infiniteCurrentViewData[n[n.length-1]].push(e.data[0])}},e.prototype.deleteComplate=function(){this.parent.isFrozenGrid()&&!this.parent.infiniteScrollSettings.enableCache&&this.parent.contentModule.refreshScrollOffset()},e.prototype.modelChanged=function(e){var t=this.parent.getRows();if(t&&t.length&&"infiniteScroll"!==e.requestType&&("delete"===e.requestType||"add"===this.requestType)){if(this.firstIndex=Ze(t[0]),this.firstBlock=Math.ceil((this.firstIndex+1)/this.parent.pageSettings.pageSize),this.lastIndex=Ze(t[t.length-1]),"delete"===e.requestType){var i=this.parent.getRowsObject();e.startIndex=this.parent.infiniteScrollSettings.enableCache?(this.firstBlock-1)*this.parent.pageSettings.pageSize:i[i.length-1].index}else e.startIndex=this.firstIndex;this.parent.infiniteScrollSettings.enableCache||this.parent.pageSettings.currentPage!==this.maxPage||"delete"!==e.requestType||(this.isLastPage=!0,this.lastIndex=this.lastIndex-1)}},e.prototype.infiniteAddActionBegin=function(e){this.isNormaledit&&(this.isAdd=!0,this.parent.infiniteScrollSettings.enableCache&&(Object.keys(this.emptyRowData).length||this.createEmptyRowdata(),this.parent.pageSettings.currentPage>1&&(e.startEdit=!1,this.resetInfiniteBlocks({},!0),this.makeRequest({currentPage:1}))))},e.prototype.infiniteEditHandler=function(e){if(!this.parent.infiniteScrollSettings.enableCache&&("delete"===e.e.requestType||"save"===e.e.requestType&&"add"===this.requestType)){var i=this.parent.isFrozenGrid(),r=this.parent.getRows(),n=this.parent.getRowsObject();if(this.ensureRowAvailability(n,e.result[0])){if(r.length&&(this.resetRowIndex(n,e.e,r,"add"===this.requestType,!0),i)){var o=this.parent.getMovableRowsObject();if(this.resetRowIndex(o,e.e,this.parent.getMovableDataRows(),"add"===this.requestType),this.parent.getFrozenMode()===hs){var s=this.parent.getFrozenRightRowsObject();this.resetRowIndex(s,e.e,this.parent.getFrozenRightRows(),"add"===this.requestType)}}if(this.isLastPage){if(this.isLastPage=!1,this.parent.pageSettings.currentPage=this.maxPage,this.parent.selectionModule.index<this.parent.frozenRows){if(t.remove(r[this.parent.frozenRows-1]),this.createRow([n[this.parent.frozenRows-1]],e,!1,!0),i){var l=this.parent.getMovableDataRows();if(t.remove(l[this.parent.frozenRows]),this.createRow([this.parent.getMovableRowsObject()[this.parent.frozenRows-1]],e,!0,!0),this.parent.getFrozenMode()===hs){var a=this.parent.getFrozenRightDataRows();t.remove(a[this.parent.frozenRows]),this.createRow([this.parent.getFrozenRightRowsObject()[this.parent.frozenRows-1]],e,!1,!0,!0)}}ze(this.parent)}}else this.createRow(n,e)}this.parent.hideSpinner(),this.parent.notify(No,{}),"delete"===this.requestType?this.parent.notify(cr,e.e):this.parent.notify(pr,e.e)}this.parent.notify(zr,{case:"refreshHeight"})},e.prototype.createRow=function(e,i,r,n,o){var s,l=n?e:this.generateRows(i.result,i.e),a=new Fs(this.serviceLocator,null,this.parent);s=o?this.parent.element.querySelector(".e-frozen-right-content").querySelector(gs):this.parent.isFrozenGrid()?r?this.parent.getMovableVirtualContent().querySelector(gs):this.parent.getFrozenVirtualContent().querySelector(gs):this.parent.getContent().querySelector(gs),this.parent.frozenRows&&(s=n&&"add"!==this.requestType||!n&&"add"===this.requestType?this.parent.isFrozenGrid()?r?this.parent.getMovableVirtualHeader().querySelector(gs):o?this.parent.element.querySelector(".e-frozen-right-header").querySelector(gs):this.parent.getFrozenVirtualHeader().querySelector(gs):this.parent.getHeaderContent().querySelector(gs):s);var h={rows:e,cancel:!1,args:i,isMovable:r,isFrozenRows:n,isFrozenRight:n,row:l};if(this.parent.notify(po,h),!h.cancel)for(var d=l.length-1;d>=0;d--)"delete"===this.requestType?s.appendChild(a.render(l[d],this.parent.getColumns())):s.insertBefore(a.render(l[d],this.parent.getColumns()),s.firstElementChild);if(!n&&this.parent.frozenRows&&(this.parent.selectionModule.index<this.parent.frozenRows||"add"===this.requestType)){var p=r?this.parent.getMovableDataRows():o?this.parent.getFrozenRightDataRows():this.parent.getRows(),c=(r||o)&&"add"===this.requestType?this.parent.frozenRows:this.parent.frozenRows-1;t.remove(p[c]),this.createRow([e[this.parent.frozenRows-1]],i,r,!0,o)}this.parent.infiniteScrollSettings.enableCache||n||(o?(ze(this.parent),this.parent.contentModule.rightFreezeRows="add"===this.requestType?l.concat(e):e.concat(l)):!this.parent.isFrozenGrid()||r?(ze(this.parent),this.parent.contentModule.visibleRows="add"===this.requestType?l.concat(e):e.concat(l),this.parent.getFrozenMode()===hs&&(i.e.renderMovableContent=!0,this.createRow(this.parent.getFrozenRightRowsObject(),i,!1,!1,!0))):(this.parent.contentModule.visibleFrozenRows="add"===this.requestType?l.concat(e):e.concat(l),i.e.isFrozen=!0,this.createRow(this.parent.getMovableRowsObject(),i,!0)))},e.prototype.ensureRowAvailability=function(e,t){var i=!0;if(this.parent.frozenRows&&!this.parent.infiniteScrollSettings.enableCache&&this.parent.sortSettings.columns&&"add"===this.requestType)for(var r=this.parent.getPrimaryKeyFieldNames()[0],n=0;n<e.length;n++)if(e[n].data[r]===t[r]){i=!1;break}return i},e.prototype.generateRows=function(e,t){return this.rowModelGenerator.generateRows(e,t)},e.prototype.resetRowIndex=function(e,i,r,n,o){var s=this,l=this.parent.getPrimaryKeyFieldNames()[0],a=!(r.length%this.parent.pageSettings.pageSize);n?a&&(o&&!this.parent.groupSettings.columns.length&&this.swapCurrentViewData(1,!0),t.remove(r[e.length-1]),r.splice(e.length-1,1),e.splice(e.length-1,1)):e.filter(function(n,a){if(n.data[l]===i.data[0][l]){if(o&&!s.parent.groupSettings.columns.length){var h=Math.ceil((a+1)/s.parent.pageSettings.pageSize);s.resetInfiniteCurrentViewData(h,a)}e.splice(a,1),t.remove(r[a]),r.splice(a,1)}});var h=n?1:0;Ie(this.parent,e,r,h)},e.prototype.resetInfiniteCurrentViewData=function(e,t){t-=(e-1)*this.parent.pageSettings.pageSize,this.infiniteCurrentViewData[e].splice(t,1),this.swapCurrentViewData(e,!1)},e.prototype.swapCurrentViewData=function(e,t){for(var i=Object.keys(this.infiniteCurrentViewData),r=t?i.length+1:i.length,n=e;n<r;n++)if(this.infiniteCurrentViewData[n+1]){var o=t?n:n+1,s=t?this.infiniteCurrentViewData[n].length-1:0,l=this.infiniteCurrentViewData[o].splice(s,1);t?(this.infiniteCurrentViewData[n+1]=l.concat(this.infiniteCurrentViewData[n+1]),n+1===r-1&&this.infiniteCurrentViewData[n+1].splice(this.infiniteCurrentViewData[n+1].length-1,1)):this.infiniteCurrentViewData[n].push(l[0])}this.updateCurrentViewData()},e.prototype.setDisplayNone=function(e){if(this.parent.infiniteScrollSettings.enableCache){for(var t=this.parent.isFrozenGrid(),i=t?Object.keys(this.infiniteFrozenCache):Object.keys(this.infiniteCache),r=1;r<=i.length;r++){(t?e.isFreeze?this.infiniteFrozenCache[r][0]:this.infiniteFrozenCache[r][1]:this.infiniteCache[r]).filter(function(t){t.cells[e.index].visible=""===e.visible})}this.resetContentModuleCache(t?this.infiniteFrozenCache:this.infiniteCache)}},e.prototype.refreshInfiniteCache=function(e){this.getEditedRowObject().data=e.data},e.prototype.refreshInfiniteEditrowindex=function(e){this.editRowIndex=e.index},e.prototype.getEditedRowObject=function(){for(var e,t=this.parent.getRowsObject(),i=0;i<t.length;i++)t[i].index===this.editRowIndex&&(e=t[i]);return e},e.prototype.infiniteEditSuccess=function(e){this.isNormaledit&&(!this.isAdd&&e.data&&this.updateCurrentViewRecords(e.data),this.isAdd=!1)},e.prototype.updateCurrentViewRecords=function(e){var i=Re(this.parent,e);t.isNullOrUndefined(i)||(this.parent.getCurrentViewRecords()[i]=e)},e.prototype.actionBegin=function(e){"add"===e.requestType||"delete"===e.requestType?this.requestType=e.requestType:"add"===e.action&&"save"===e.requestType&&(this.requestType=e.action),(this.parent.isFrozenGrid()&&!e.cancel&&"searching"===e.requestType||"sorting"===e.requestType||"filtering"===e.requestType)&&(this.isInitialRender=!0)},e.prototype.actionComplete=function(e){"delete"!==e.requestType&&"save"!==e.requestType&&"cancel"!==e.requestType||(this.requestType=this.empty,this.isCancel="cancel"===e.requestType||"save"===e.requestType,this.isAdd=this.isEdit=!1,this.isNormaledit&&(this.editRowIndex=this.empty,this.virtualInfiniteData={},this.parent.editModule.previousVirtualData={}))},e.prototype.resetInfiniteEdit=function(){this.parent.enableInfiniteScrolling&&this.isNormaledit&&(this.parent.editSettings.allowEditing&&this.isEdit||this.parent.editSettings.allowAdding&&this.isAdd)&&(this.parent.isEdit=!0)},e.prototype.getVirtualInfiniteData=function(e){e.virtualData=this.virtualInfiniteData,e.isAdd=this.isAdd,e.isCancel=this.isCancel},e.prototype.editActionBegin=function(e){this.isEdit=!0,this.editRowIndex=e.index;var i=t.extend({},this.getEditedRowObject().data);e.data=Object.keys(this.virtualInfiniteData).length?this.virtualInfiniteData:i},e.prototype.dataSourceModified=function(){this.resetInfiniteBlocks({requestType:this.empty},!0)},e.prototype.onDataReady=function(e){t.isNullOrUndefined(e.count)||"infiniteScroll"===e.requestType||(this.maxPage=Math.ceil(e.count/this.parent.pageSettings.pageSize))},e.prototype.ensureIntialCollapse=function(e){this.isInitialCollapse=!e},e.prototype.infiniteScrollHandler=function(e){this.restoreInfiniteEdit(),this.restoreInfiniteAdd();var i=e.target;if(i.classList.contains(es)&&this.parent.enableInfiniteScrolling&&!e.isLeft){var r=this.parent.getContent().firstElementChild;this.prevScrollTop=r.scrollTop;var n=this.parent.getRows();if(!n.length)return;var o=Ze(n[n.length-1])+1,s=this.parent.pageSettings.currentPage,l=void 0,a=i.scrollHeight-i.scrollTop,h=Math.round(i.scrollHeight-i.scrollTop),d=a<i.clientHeight?Math.ceil(a):Math.floor(a);d>i.clientHeight&&(d-=1);var p=d===i.clientHeight||h===i.clientHeight;if(!t.isNullOrUndefined(this.groupCaptionAction))return;if(this.isScroll&&p&&(this.parent.pageSettings.currentPage<=this.maxPage-1||this.enableContinuousScroll)){this.parent.infiniteScrollSettings.enableCache&&(this.isUpScroll=!1,this.isDownScroll=!0);var c=[].slice.call(r.querySelectorAll(".e-row:not(.e-addedrow)")),u=Ze(g=c[c.length-1]);this.parent.pageSettings.currentPage=Math.ceil(u/this.parent.pageSettings.pageSize)+1,l={requestType:"infiniteScroll",currentPage:this.parent.pageSettings.currentPage,prevPage:s,startIndex:o,direction:"down"},this.makeRequest(l)}if(this.isScroll&&this.parent.infiniteScrollSettings.enableCache&&0===i.scrollTop&&1!==this.parent.pageSettings.currentPage){this.parent.infiniteScrollSettings.enableCache&&(this.isDownScroll=!1,this.isUpScroll=!0);u=Ze((g=[].slice.call(r.getElementsByClassName(is)))[this.parent.pageSettings.pageSize-1]);var g,f=Ze(g[0])-this.parent.pageSettings.pageSize;this.parent.pageSettings.currentPage=Math.ceil(u/this.parent.pageSettings.pageSize)-1,this.parent.pageSettings.currentPage&&(l={requestType:"infiniteScroll",currentPage:this.parent.pageSettings.currentPage,prevPage:s,startIndex:f,direction:"up"},this.makeRequest(l))}this.parent.infiniteScrollSettings.enableCache&&!this.isScroll&&t.isNullOrUndefined(l)&&(this.isDownScroll||this.isUpScroll)&&(r.scrollTop=this.top)}},e.prototype.makeRequest=function(e){var i=this;if(this.parent.pageSettings.currentPage!==e.prevPage){this.parent.infiniteScrollSettings.initialBlocks<this.maxPage&&this.parent.pageSettings.currentPage<=this.maxPage?(this.isInfiniteScroll=!0,t.isNullOrUndefined(this.infiniteCache[e.currentPage])?setTimeout(function(){i.getVirtualInfiniteEditedData(),i.parent.notify("model-changed",e)},100):setTimeout(function(){i.getVirtualInfiniteEditedData(),i.parent.notify(Dn,e)},100)):this.parent.pageSettings.currentPage=this.maxPage}},e.prototype.infinitePageQuery=function(e){this.initialRender?(this.initialRender=!1,this.intialPageQuery(e)):this.isInfiniteScroll||"delete"!==this.requestType&&"add"!==this.requestType?e.page(this.parent.pageSettings.currentPage,this.parent.pageSettings.pageSize):this.editPageQuery(e)},e.prototype.editPageQuery=function(e){var t=this.parent.infiniteScrollSettings.initialBlocks;if(this.parent.infiniteScrollSettings.enableCache)this.infiniteCache={},this.infiniteFrozenCache={},this.infiniteCurrentViewData={},e.skip(this.firstIndex),e.take(t*this.parent.pageSettings.pageSize);else{"Dialog"===this.parent.editSettings.mode&&this.parent.clearSelection();var i="delete"===this.requestType?this.lastIndex:this.firstIndex;e.skip(i),e.take(1)}},e.prototype.intialPageQuery=function(e){this.parent.infiniteScrollSettings.enableCache&&this.parent.infiniteScrollSettings.initialBlocks>this.parent.infiniteScrollSettings.maxBlocks&&(this.parent.infiniteScrollSettings.initialBlocks=this.parent.infiniteScrollSettings.maxBlocks);var t=this.parent.pageSettings.pageSize*this.parent.infiniteScrollSettings.initialBlocks;e.page(1,t)},e.prototype.scrollToLastFocusedCell=function(e){var i=this.parent,r=this.lastFocusInfo.rowIdx+(e.keyArgs.action===Ss?-1:1),n=this.lastFocusInfo.cellIdx,o=i.getRowByIndex(r);i.getContent().firstElementChild;if(!o){var s=new Fs(this.serviceLocator,null,this.parent),l=Math.floor(r/this.parent.pageSettings.pageSize)+1;i.pageSettings.currentPage=l;var a=i.getColumns();t.remove(i.getContent().querySelector("tbody")),i.getContent().querySelector("table").appendChild(i.createElement("tbody"));for(var h=[],d=1===l||this.maxPage===l?0:-1,p=0;p<i.infiniteScrollSettings.maxBlocks;this.maxPage===l?d--:d++,p++){var c=this.infiniteCache[l+d];if(c){h=h.concat(c);for(var u=0;u<c.length;u++)i.getContent().querySelector("tbody").appendChild(s.render(c[u],a))}}i.notify(xi,{rows:h,args:{}}),ze(i)}var g=(o=i.getRowByIndex(r)).cells[n];i.focusModule.isInfiniteScroll=!0,i.focusModule.onClick({target:g},!0),i.selectRow(r),g.focus(),this.isFocusScroll=!1,e.cancel=!0},e.prototype.setLastCellFocusInfo=function(e){var t=e.byClick&&e.clickArgs.target||e.byKey&&e.keyArgs.target||(!this.isFocusScroll&&e).target;if(t&&t.classList.contains("e-rowcell")){var i=parseInt(t.getAttribute("aria-colindex"),10),r=parseInt(t.parentElement.getAttribute("aria-rowindex"));this.lastFocusInfo={rowIdx:r,cellIdx:i}}},e.prototype.infiniteCellFocus=function(e){var t=this.parent,i=t.infiniteScrollSettings.enableCache;if(e.byKey){if(i&&this.isFocusScroll)return void this.scrollToLastFocusedCell(e);var r=document.activeElement,n=Ze(r.parentElement);this.cellIndex=parseInt(r.getAttribute(cs),10);var o=t.getContent().firstElementChild,s=this.maxPage*t.pageSettings.pageSize-1,l=Math.floor(o.offsetHeight/this.parent.getRowHeight()),a=o.getBoundingClientRect();if(!isNaN(n))if(e.keyArgs.action===bs||e.keyArgs.action===Rs){this.rowIndex=n+=1;var h=(d=t.getRowByIndex(n))&&d.getBoundingClientRect();i&&(n=r.parentElement.rowIndex+1),this.isFocusScroll||!d&&n<s||h&&h.bottom>=a.bottom?(this.isFocusScroll||(this.pressedKey=e.keyArgs.action),this.isFocusScroll=!1,o.scrollTop=(n-l+1)*this.parent.getRowHeight()):!i&&d&&h&&(h.bottom>=a.bottom||h.top<a.top)&&d.cells[this.cellIndex].scrollIntoView()}else if(e.keyArgs.action===Ss||e.keyArgs.action===xs){this.rowIndex=n-=1;var d;h=(d=t.getRowByIndex(n))&&d.getBoundingClientRect();i&&(n=r.parentElement.rowIndex-1),(!d||h.top<=a.top)&&(this.pressedKey=e.keyArgs.action,o.scrollTop=n*this.parent.getRowHeight())}}else"PageDown"!==e.key&&"PageUp"!==e.key||(this.pressedKey=e.key);this.setLastCellFocusInfo(e)},e.prototype.createEmptyRowdata=function(){var e=this;this.parent.getColumns().filter(function(t){e.emptyRowData[t.field]=e.empty})},e.prototype.getVirtualInfiniteEditedData=function(){var e=this.parent.element.querySelector("."+ns),i=this.parent.element.querySelector("."+os),r=this.parent.element.querySelector(".e-gridform");if(this.parent.infiniteScrollSettings.enableCache&&(e||i)){var n=e?t.extend({},this.getEditedRowObject().data):t.extend({},this.emptyRowData);this.virtualInfiniteData=this.parent.editModule.getCurrentEditedData(r,n),this.parent.isFrozenGrid()&&(this.virtualInfiniteData=this.parent.editModule.getCurrentEditedData(this.parent.getMovableVirtualContent().querySelector(".e-gridform"),n))}},e.prototype.restoreInfiniteEdit=function(){var e=this.parent.getContent().firstElementChild,i=!this.parent.frozenRows||this.editRowIndex>=this.parent.frozenRows;if(this.isNormaledit&&this.parent.infiniteScrollSettings.enableCache&&i&&this.parent.editSettings.allowEditing&&!t.isNullOrUndefined(this.editRowIndex)){var r=this.parent.getRowByIndex(this.editRowIndex);if(Object.keys(this.virtualInfiniteData).length&&r&&!this.parent.getContent().querySelector("."+ns)){var n=r.getBoundingClientRect().top;n<e.offsetHeight&&n>this.parent.getRowHeight()&&(this.parent.isEdit=!1,this.parent.editModule.startEdit(r))}}},e.prototype.restoreInfiniteAdd=function(){var e=this.parent.getContent().firstElementChild;if(this.parent.getCurrentViewRecords().length&&this.parent.getRowByIndex(0)&&this.isNormaledit&&this.parent.infiniteScrollSettings.enableCache&&this.isAdd&&!e.querySelector("."+os)){e.scrollTop<this.parent.getRowHeight()&&(this.parent.isEdit=!1,this.parent.addRecord())}},e.prototype.appendInfiniteRows=function(e){var t=this.parent.isFrozenGrid(),i=this.parent.getContent().firstElementChild,r=this.parent.enableInfiniteScrolling&&"infiniteScroll"===e.args.requestType,n=this.parent.getFrozenMode()===hs&&"movable"===e.tableName;if((!r||e.args.isFrozen||n)&&r||(r&&"up"===e.args.direction?e.tbody.insertBefore(e.frag,e.tbody.firstElementChild):e.tbody.appendChild(e.frag)),t)if(r)if(e.tableName===ps||"Right"===this.parent.getFrozenMode()&&e.tableName===ds)this.frozenFrag=e.frag;else if(this.parent.getFrozenMode()===hs&&"movable"===e.tableName)this.movableFrag=e.frag;else{var o=this.parent.getFrozenVirtualContent().querySelector(gs);"up"===e.args.direction?o.insertBefore(this.frozenFrag,o.firstElementChild):o.appendChild(this.frozenFrag),e.tableName===ds?(this.parent.getMovableVirtualContent().querySelector(gs).appendChild(this.movableFrag),this.parent.element.querySelector(".e-frozen-right-content").querySelector(gs).appendChild(e.frag)):this.parent.getMovableVirtualContent().querySelector("."+ts).appendChild(e.tbody),this.parent.contentModule.refreshScrollOffset(),this.updateCurrentViewData()}else{var s=void 0;e.tableName===ps?s=this.parent.getFrozenVirtualContent().querySelector("."+ts):"movable"===e.tableName?(s=this.parent.getMovableVirtualContent().querySelector("."+ts),this.parent.getFrozenMode()!==hs&&(this.parent.contentModule.refreshScrollOffset(),this.updateCurrentViewData())):(s=this.parent.element.querySelector(".e-frozen-right-content").querySelector("."+ts),this.parent.getFrozenMode()===hs&&(this.parent.contentModule.refreshScrollOffset(),this.updateCurrentViewData())),s.appendChild(e.tbody),this.widthService.refreshFrozenScrollbar()}else this.parent.contentModule.getTable().appendChild(e.tbody),this.updateCurrentViewData();this.isInitialRender&&!e.args.isFrozen&&(this.isInitialRender=!1,this.parent.scrollModule.setHeight()),e.args.isFrozen||(this.rowTop=this.rowTop?this.rowTop:this.parent.getRows()[0].getBoundingClientRect().top,r&&(this.parent.infiniteScrollSettings.enableCache&&this.isRemove&&(i.scrollTop=this.top),ze(this.parent)),this.restoreInfiniteAdd(),this.isScroll=!0),this.isInfiniteScroll=!1},e.prototype.selectNewRow=function(e){var t=this,i=this.parent,r=i.getRowByIndex(this.rowIndex),n=i.infiniteScrollSettings.enableCache;if(r&&this.keys.some(function(e){return e===t.pressedKey})){var o=i.getContent().firstElementChild,s=i.getRowHeight(),l=r.cells[this.cellIndex];(this.pressedKey===bs||this.pressedKey===Rs||n&&(this.pressedKey===Ss||this.pressedKey===xs))&&(n||this.pressedKey===Ss||this.pressedKey===xs||(o.scrollTop=o.scrollTop+s),i.focusModule.isInfiniteScroll=!0,i.focusModule.onClick({target:l},!0),i.selectRow(this.rowIndex))}else if(this.lastFocusInfo||"PageDown"===this.pressedKey||"PageUp"===this.pressedKey){var a=n?0:this.lastFocusInfo.rowIdx;if(i.getRowByIndex(a)){(l=i.getCellFromIndex(a,this.lastFocusInfo.cellIdx))&&(this.isFocusScroll=!0,n?l.focus({preventScroll:!0}):(i.focusModule.isInfiniteScroll=!0,i.focusModule.onClick({target:l},!0)))}}this.pressedKey=void 0},e.prototype.removeInfiniteCacheRows=function(e){var t=this.parent.enableInfiniteScrolling&&"infiniteScroll"===e.args.requestType;if(!e.args.isFrozen&&t&&this.parent.infiniteScrollSettings.enableCache&&this.isRemove){var i=[].slice.call(this.parent.getContentTable().getElementsByClassName(is));if("down"===e.args.direction){if(this.parent.allowGrouping&&this.parent.groupSettings.columns.length){var r=[].slice.call(this.parent.getContentTable().querySelectorAll("tr"));this.removeCaptionRows(r,e.args)}var n=this.parent.element.querySelector("."+os)?0:1;this.removeTopRows(i,this.parent.pageSettings.pageSize-n)}if("up"===e.args.direction)if(this.parent.allowGrouping&&this.parent.groupSettings.columns.length){r=[].slice.call(this.parent.getContentTable().querySelectorAll("tr"));this.removeCaptionRows(r,e.args)}else this.removeBottomRows(i,i.length-1,e.args);this.isScroll=!1,this.top=this.calculateScrollTop(e.args)}},e.prototype.calculateScrollTop=function(e){var i=0,r=this.parent.getContent().firstElementChild;if("down"===e.direction){this.parent.allowGrouping&&this.parent.groupSettings.columns.length&&!this.isInitialCollapse&&(i=this.captionRowHeight());var n=[].slice.call(this.parent.getContent().firstElementChild.querySelectorAll("tr:not(.e-row)")),o=0;this.isInitialCollapse&&!t.isNullOrUndefined(n)&&(o=Math.round((n.length-1)/this.parent.groupSettings.columns.length));for(var s=o||this.parent.pageSettings.pageSize*(this.parent.infiniteScrollSettings.maxBlocks-1),l=0,a=0;l<r.clientHeight;)l=++a*this.parent.getRowHeight();i+=(s-(a-=1))*this.parent.getRowHeight()}if("up"===e.direction)if(this.parent.allowGrouping&&this.parent.groupSettings.columns.length&&!this.isInitialCollapse)i=this.infiniteCache[this.parent.pageSettings.currentPage].length*this.parent.getRowHeight();else if(this.isInitialCollapse){var h=this.infiniteCache[this.parent.pageSettings.currentPage],d=0;for(a=0;a<h.length;a++)h[a].isCaptionRow&&d++;i+=Math.round(d/this.parent.groupSettings.columns.length)*this.parent.getRowHeight()}else i+=this.parent.pageSettings.pageSize*this.parent.getRowHeight()+H();return i},e.prototype.captionRowHeight=function(){return[].slice.call(this.parent.getContent().querySelectorAll("tr:not(.e-row)")).length*this.parent.getRowHeight()},e.prototype.removeTopRows=function(e,i){for(var r=this.parent.isFrozenGrid(),n=this.parent.getFrozenMode()===hs?[].slice.call(this.parent.element.querySelector(".e-frozen-right-content").getElementsByClassName(is)):null,o=r?[].slice.call(this.parent.getMovableVirtualContent().getElementsByClassName(is)):null,s=0;s<=i;s++)this.parent.frozenRows&&this.parent.pageSettings.currentPage===this.parent.infiniteScrollSettings.maxBlocks+1&&s>i-this.parent.frozenRows||(t.remove(e[s]),o&&t.remove(o[s]),n&&t.remove(n[s]))},e.prototype.removeBottomRows=function(e,i,r){var n=0,o=this.parent.isFrozenGrid(),s=o?[].slice.call(this.parent.getMovableVirtualContent().getElementsByClassName(is)):null,l=this.parent.getFrozenMode()===hs?[].slice.call(this.parent.element.querySelector(".e-frozen-right-content").getElementsByClassName(is)):null,a=this.parent.pageSettings.pageSize;!o&&this.infiniteCache[r.prevPage].length<a&&(n=this.parent.pageSettings.pageSize-this.infiniteCache[r.prevPage].length),o&&this.infiniteFrozenCache[r.prevPage][1].length<a&&(n=this.parent.pageSettings.pageSize-this.infiniteFrozenCache[r.prevPage][1].length);for(var h=i;n<a;h--)n++,t.remove(e[h]),s&&t.remove(s[h]),l&&t.remove(l[h])},e.prototype.removeCaptionRows=function(e,i){var r=[].slice.call(this.parent.getContent().getElementsByClassName(is));if("down"===i.direction)for(var n=Ze(r[this.parent.pageSettings.pageSize-1])-1,o=0,s=0;o<n;s++)e[s].classList.contains(is)?o=Ze(e[s]):t.remove(e[s]);if("up"===i.direction){var l=Ze(r[r.length-1]),a=Math.ceil(l/this.parent.pageSettings.pageSize),h=0;for(s=this.parent.pageSettings.currentPage+1;s<a;s++)h+=this.infiniteCache[s].length;for(s=h;s<e.length;s++)t.remove(e[s])}},e.prototype.resetInfiniteBlocks=function(e,i){var r=this.parent.enableInfiniteScrolling&&"infiniteScroll"!==e.requestType;if(!this.initialRender&&!t.isNullOrUndefined(this.parent.infiniteScrollModule)&&r&&(this.actions.some(function(t){return t===e.requestType})||i)){var n=this.parent.getContent().firstElementChild;this.initialRender=!0,n.scrollTop=0,this.parent.pageSettings.currentPage=1,this.infiniteCache=this.infiniteFrozenCache={},this.infiniteCurrentViewData={},this.resetContentModuleCache({}),this.isRemove=!1,this.top=0,this.isInitialMovableRender=!0,this.isInitialCollapse=!1,this.parent.contentModule.isRemove=this.isRemove,this.parent.contentModule.isAddRows=this.isRemove,this.parent.contentModule.visibleRows=[],this.parent.contentModule.visibleFrozenRows=[]}},e.prototype.setCache=function(e){if(this.parent.enableInfiniteScrolling&&this.parent.infiniteScrollSettings.enableCache){var i=this.parent.isFrozenGrid(),r=e.args.isFrozen?1:0,n="infiniteScroll"!==e.args.requestType&&("delete"===this.requestType||"add"===this.requestType),o=this.parent.pageSettings.currentPage;(i&&this.isInitialMovableRender||!i&&!Object.keys(this.infiniteCache).length||n)&&(this.isInitialMovableRender=!e.args.isFrozen,this.setInitialCache(e.modelData,e.args,n)),!i&&t.isNullOrUndefined(this.infiniteCache[this.parent.pageSettings.currentPage])&&(this.infiniteCache[this.parent.pageSettings.currentPage]=e.modelData,this.resetContentModuleCache(this.infiniteCache)),i&&(0===r&&t.isNullOrUndefined(this.infiniteFrozenCache[o])||!this.infiniteFrozenCache[o][r].length)&&(this.createFrozenCache(o),this.infiniteFrozenCache[o][r]=e.modelData,1===r&&this.resetContentModuleCache(this.infiniteFrozenCache)),e.isInfiniteScroll&&!this.isRemove&&(this.isRemove=(o-1)%this.parent.infiniteScrollSettings.maxBlocks==0,this.parent.contentModule.isRemove=this.isRemove)}},e.prototype.setInitialCache=function(e,t,i,r){for(var n=this.parent.isFrozenGrid(),o=t.isFrozen?1:0,s=i?this.firstBlock:1,l=1;l<=this.parent.infiniteScrollSettings.initialBlocks;l++){var a=(l-1)*this.parent.pageSettings.pageSize,h=l*this.parent.pageSettings.pageSize;this.parent.allowGrouping&&this.parent.groupSettings.columns.length&&!r?this.setInitialGroupCache(e,s,a,h):r?this.infiniteCurrentViewData[s]=e.slice(a,h):n?(this.createFrozenCache(s),this.infiniteFrozenCache[s][o]=e.slice(a,h),this.resetContentModuleCache(this.infiniteFrozenCache)):(this.infiniteCache[s]=e.slice(a,h),this.resetContentModuleCache(this.infiniteCache)),s++}},e.prototype.createFrozenCache=function(e){this.infiniteFrozenCache[e]||(this.infiniteFrozenCache[e]=[[],[]])},e.prototype.setInitialGroupCache=function(e,t,i,r){for(var n=[],o=0,s=1;s<=Object.keys(this.infiniteCache).length;s++)o+=this.infiniteCache[s].length;var l=i;for(s=o;s<e.length&&l<r&&((e[s].index<r||e[s].isCaptionRow)&&(l=e[s].isCaptionRow?l:e[s].index,n.push(e[s])),!(e[s].index>=r||e[s].index===r-1));s++);this.infiniteCache[t]=n,this.resetContentModuleCache(this.infiniteCache)},e.prototype.resetContentModuleCache=function(e){this.parent.contentModule.infiniteCache=e},e.prototype.destroy=function(){this.removeEventListener()},e}(),Xh=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Yh=function(e){function i(t,i){var r=e.call(this,t,i)||this;return r.childCount=0,r.scrollData=[],r.isFirstChildRow=!1,r.isScrollDown=!1,r.isScrollUp=!1,r.groupCache={},r.startIndexes={},r.captionCounts={},r.rowsByUid={},r.objIdxByUid={},r.initialGroupCaptions={},r.requestType=["paging","columnstate","reorder","cancel","save","beginEdit","add","delete","filterbeforeopen","filterchoicerequest"],r.cacheMode=!1,r.cacheBlockSize=5,r.ignoreAccent=!!r.parent.allowFiltering&&r.parent.filterSettings.ignoreAccent,r.allowCaseSensitive=!1,r.locator=i,r.groupGenerator=new Os(r.parent),r.summaryModelGen=new zs(r.parent),r.captionModelGen=new Ds(r.parent),r.rowRenderer=new Fs(r.locator,null,r.parent),r.eventListener(),r}return Xh(i,e),i.prototype.eventListener=function(){this.parent.addEventListener(zt,this.actionBegin.bind(this)),this.parent.addEventListener(Dt,this.actionComplete.bind(this)),this.parent.on(Si,this.setLazyLoadPageSize,this),this.parent.on(Wn,this.setCache,this),this.parent.on(Kn,this.scrollHandler,this),this.parent.on(Qi,this.setVisible,this),this.parent.on(Qn,this.collapseShortcut,this)},i.prototype.captionExpand=function(e){var t=this,i=this.parent.pageSettings.currentPage,r=this.groupCache[i],n=e.getAttribute("data-uid"),o=this.getRowObjectIndexByUid(n),s=!!r[o+1]&&r[o].indent<r[o+1].indent,l=r[o],a=tt(o,r),h={captionRowElement:e,groupInfo:l,enableCaching:!0,cancel:!1};this.parent.trigger(Ci,h,function(r){r.cancel||(r.keys=a.keys,r.fields=a.fields,r.rowIndex=e.rowIndex,r.makeRequest=!r.enableCaching||!s,!r.enableCaching&&s&&t.clearCache([n]),r.skip=0,r.take=t.pageSize,l.isExpand=t.rowsByUid[i][l.uid].isExpand=!0,t.captionRowExpand(r))})},i.prototype.captionCollapse=function(e){var t=this,i=this.groupCache[this.parent.pageSettings.currentPage],r=e.rowIndex,n=e.getAttribute("data-uid"),o=this.getRowObjectIndexByUid(n),s={captionRowElement:e,groupInfo:i[o],cancel:!1};this.parent.trigger(wi,s,function(e){e.cancel||(e.isExpand=!1,t.removeRows(o,r))})},i.prototype.setLazyLoadPageSize=function(){var e=this.parent.getContent().firstElementChild,t=Math.floor(e.offsetHeight/this.parent.getRowHeight())-1;this.pageSize=this.pageSize?this.pageSize:3*t,this.blockSize=Math.ceil(this.pageSize/2)},i.prototype.clearLazyGroupCache=function(){this.clearCache()},i.prototype.clearCache=function(e){e=e||this.getInitialCaptionIndexes();var t=this.groupCache[this.parent.pageSettings.currentPage];if(e.length)for(var i=0;i<e.length;i++){var r=this.getRowObjectIndexByUid(e[i]),n=t[r];if(n){if(this.captionCounts[this.parent.pageSettings.currentPage][n.uid])for(var o=r+1;o<t.length;o++){if(t[o].indent===n.indent||t[o].indent<n.indent){delete this.captionCounts[this.parent.pageSettings.currentPage][n.uid];break}t[o].isCaptionRow&&delete this.captionCounts[this.parent.pageSettings.currentPage][t[o].uid]}if(n.isExpand){var s=this.parent.getRowElementByUID(n.uid);if(!s)return;this.parent.groupModule.expandCollapseRows(s.querySelector(".e-recordplusexpand"))}var l=this.getNextChilds(r);if(l.length){var a=[];l[l.length-1].isCaptionRow&&(a=this.getChildRowsByParentIndex(t.indexOf(l[l.length-1]),!1,!1,null,!0,!0));var h=t.indexOf(l[0]),d=a.length?t.indexOf(a[a.length-1]):t.indexOf(l[l.length-1]);t.splice(h,d-(h-1)),this.refreshCaches()}}}},i.prototype.refreshCaches=function(){var e=this.parent.pageSettings.currentPage,t=this.groupCache[e];this.rowsByUid={},this.objIdxByUid={};for(var i=0;i<t.length;i++)this.maintainRows(t[i],i)},i.prototype.getInitialCaptionIndexes=function(){for(var e=this.parent.pageSettings.currentPage,t=[],i=0;i<this.initialGroupCaptions[e].length;i++)t.push(this.initialGroupCaptions[e][i].uid);return t},i.prototype.getRowObjectIndexByUid=function(e){return this.objIdxByUid[this.parent.pageSettings.currentPage][e]},i.prototype.collapseShortcut=function(e){if(this.parent.groupSettings.columns.length&&e.target&&D(e.target,es)&&"TR"===e.target.parentElement.tagName){if(!e.collapse&&D(e.target,is))return;var t=e.target.parentElement.getAttribute("data-uid");if(e.collapse){var i=this.getRowByUid(t);if((n=this.getRowByUid(i.parentUid)).isCaptionRow&&n.isExpand){var r=this.getRowElementByUid(i.parentUid);this.parent.groupModule.expandCollapseRows(r.cells[i.indent-1])}}else{var n;if((n=this.getRowByUid(t)).isCaptionRow&&!n.isExpand){r=this.getRowElementByUid(t);this.parent.groupModule.expandCollapseRows(r.cells[n.indent])}}}},i.prototype.getRowByUid=function(e){return this.rowsByUid[this.parent.pageSettings.currentPage][e]},i.prototype.actionBegin=function(e){if(!e.cancel){if(this.requestType.some(function(t){return t===e.requestType})||(this.groupCache={},this.resetRowMaintenance()),"reorder"===e.requestType&&this.parent.groupSettings.columns.length)for(var t=Object.keys(this.groupCache),i=0;i<t.length;i++)for(var r=this.groupCache[t[i]],n=0;n<r.length;n++)if(r[n].isCaptionRow&&!this.captionModelGen.isEmpty()&&this.changeCaptionRow(r[n],null,t[i]),r[n].isDataRow){var o=e.fromIndex+r[n].indent,s=e.toIndex+r[n].indent;this.moveCells(r[n].cells,o,s)}("delete"===e.requestType||"add"===e.action&&"save"===e.requestType)&&(this.groupCache={},this.resetRowMaintenance())}},i.prototype.actionComplete=function(e){e.cancel||"columnstate"===e.requestType||"beginEdit"===e.requestType||"delete"===e.requestType||"save"===e.requestType||"reorder"===e.requestType||this.scrollReset()},i.prototype.resetRowMaintenance=function(){this.startIndexes={},this.captionCounts={},this.rowsByUid={},this.objIdxByUid={},this.initialGroupCaptions={}},i.prototype.moveCells=function(e,t,i){if(t>=e.length)for(var r=t-e.length;1+r--;)e.push(void 0);e.splice(t,0,e.splice(i,1)[0])},i.prototype.removeRows=function(e,i){var r,n=this.parent.pageSettings.currentPage,o=this.groupCache[n],s=[].slice.call(this.parent.getContent().querySelectorAll("tr"));if(this.parent.aggregates.length){var l=this.getAggregateByCaptionIndex(e);r=l.length?l[l.length-1].uid:void 0}var a=o[e].indent;this.addClass(this.getNextChilds(e)),o[e].isExpand=this.rowsByUid[n][o[e].uid].isExpand=!1;for(var h,d=e+1;d<o.length;d++){if(o[d].indent===a||o[d].indent<a){h=o[d].uid;break}o[d].isCaptionRow&&o[d].isExpand&&this.addClass(this.getNextChilds(d))}for(d=i+1;d<s.length&&s[d].getAttribute("data-uid")!==h;d++){if(s[d].getAttribute("data-uid")===r){t.remove(s[d]);break}t.remove(s[d])}},i.prototype.addClass=function(e){var t=e[this.blockSize];t&&(t.lazyLoadCssClass="e-lazyload-middle-down")},i.prototype.getNextChilds=function(e,t){for(var i=this.groupCache[this.parent.pageSettings.currentPage],r=t||i,n=i[e].indent+1,o=[],s=t?0:e+1;s<r.length&&!(r[s].indent<n);s++)r[s].indent===n&&o.push(r[s]);return o},i.prototype.lazyLoadHandler=function(e){this.setStartIndexes();var t=this.parent.getContent().querySelectorAll("tr")[e.index].getAttribute("data-uid"),i=this.getRowObjectIndexByUid(t),r=this.groupCache[this.parent.pageSettings.currentPage][i],n=e.isRowExist?e.isScroll?this.scrollData:this.getChildRowsByParentIndex(i,!0,!0,null,!0):[];if(this.scrollData=[],!e.isRowExist)if(this.setRowIndexes(i,r),this.refreshCaptionRowCount(this.groupCache[this.parent.pageSettings.currentPage][i],e.count),-1!==Object.keys(e.data).indexOf("GroupGuid"))for(var o=0;o<e.data.length;o++){var s=this.groupGenerator.generateCaptionRow(e.data[o],e.level,r.parentGid,void 0,0,r.uid);n.push(s),this.parent.aggregates.length&&(n=n.concat(this.summaryModelGen.generateRows(e.data[o],{level:e.level+1,parentUid:s.uid})))}else this.groupGenerator.index=this.getStartIndex(i,e.isScroll),n=this.groupGenerator.generateDataRows(e.data,e.level,r.parentGid,0,r.uid);var l=e.isScroll?this.rowIndex:e.index,a=this.getNextChilds(i,n),h=!!e.up||this.hasLastChildRow(e.isScroll,e.count,a.length);e.isRowExist||h||(a[this.blockSize].lazyLoadCssClass="e-lazyload-middle-down"),h||(a[a.length-1].lazyLoadCssClass="e-not-lazyload-end");var d=e.isScroll||e.isRowExist?[]:this.getAggregateByCaptionIndex(i);e.up||e.isRowExist||this.refreshRowObjects(n,e.isScroll?this.rowObjectIndex:i),this.render(l,n,h,d),this.isFirstChildRow&&!e.up&&(this.parent.getContent().firstElementChild.scrollTop=n.length*this.parent.getRowHeight()),this.isFirstChildRow=!1,this.rowIndex=void 0,this.rowObjectIndex=void 0,this.childCount=0},i.prototype.setRowIndexes=function(e,t){this.captionCounts[this.parent.pageSettings.currentPage]||(this.captionCounts[this.parent.pageSettings.currentPage]={}),t.isCaptionRow&&(this.captionCounts[this.parent.pageSettings.currentPage][t.uid]=t.data.count)},i.prototype.getStartIndex=function(e,t){var i=this.parent.pageSettings.currentPage,r=this.groupCache[i];if(t)return r[this.rowObjectIndex].index+1;var n=0,o=0,s=this.getRowByUid(r[e].parentUid);if(s&&(o=this.prevCaptionCount(s)),r[e].indent>0)for(var l=e-1;l>=0&&!(r[l].indent<r[e].indent);l--)r[l].isCaptionRow&&r[l].indent===r[e].indent&&(n+=r[l].data.count);return n+o+this.startIndexes[i][r[e].parentGid]},i.prototype.prevCaptionCount=function(e){for(var t=this.parent.pageSettings.currentPage,i=this.groupCache[t],r=0,n=i.indexOf(e)-1;n>=0&&0!==i[n].indent&&!(i[n].indent<e.indent);n--)if(i[n].isCaptionRow&&i[n].indent===e.indent){var o=this.captionCounts[t][i[n].uid];r+=o||i[n].data.count}var s=this.getRowByUid(e.parentUid);return s&&(r+=this.prevCaptionCount(s)),r},i.prototype.setStartIndexes=function(){var e=this.groupCache[this.parent.pageSettings.currentPage];if(!this.startIndexes[this.parent.pageSettings.currentPage]){for(var t=[],i=void 0,r=0;r<e.length;r++)e[r].isCaptionRow&&(t.length?t.push(e[i].data.count+t[t.length-1]):t.push(0),i=r);this.startIndexes[this.parent.pageSettings.currentPage]=t}},i.prototype.hasLastChildRow=function(e,t,i){return e?t===this.childCount+i:t===i},i.prototype.refreshCaptionRowCount=function(e,t){e.data.count=t},i.prototype.render=function(e,t,i,r){var n=this.parent.getContent().querySelectorAll("tr")[e],o=this.parent.getContent().firstElementChild,s=this.parent.getRowHeight();if(n&&r.length)for(var l=r.length-1;l>=0;l--)n.insertAdjacentElement("afterend",this.rowRenderer.render(r[l],this.parent.getColumns()));if(n&&t.length)for(l=t.length-1;l>=0;l--)this.confirmRowRendering(t[l])&&(n.insertAdjacentElement("afterend",this.rowRenderer.render(t[l],this.parent.getColumns())),this.isScrollDown&&(o.scrollTop=o.scrollTop-s),this.isScrollUp&&(o.scrollTop=o.scrollTop+s));this.isScrollDown=!1,this.isScrollUp=!1},i.prototype.maintainRows=function(e,t){var i=this.parent.pageSettings.currentPage;this.rowsByUid[i]||(this.rowsByUid[i]={},this.objIdxByUid[i]={}),e.uid&&(this.rowsByUid[i][e.uid]=e),this.objIdxByUid[i][e.uid]=t},i.prototype.confirmRowRendering=function(e){var i=!0;if(t.isNullOrUndefined(e.indent)&&!e.isDataRow&&!e.isCaptionRow){var r=this.getRowByUid(e.parentUid);r.isCaptionRow&&!r.isExpand&&(i=!1)}return i},i.prototype.refreshRowObjects=function(e,i){var r=this.parent.pageSettings.currentPage,n=this.groupCache[r];this.rowsByUid[r]={},this.objIdxByUid[r]={};for(var o=[],s=0,l=0;l<n.length;l++)if(l===i){this.maintainRows(n[l],s),o.push(n[l]),s++;for(var a=0;a<e.length;a++)this.maintainRows(e[a],s),o.push(e[a]),s++}else this.maintainRows(n[l],s),o.push(n[l]),s++;this.groupCache[this.parent.pageSettings.currentPage]=t.extend([],o),this.updateCurrentViewData()},i.prototype.getAggregateByCaptionIndex=function(e){for(var i=this.groupCache[this.parent.pageSettings.currentPage],r=i[e],n=r.indent,o=r.uid,s=[],l=e+1;l<i.length&&i[l].indent!==n;l++)t.isNullOrUndefined(i[l].indent)&&i[l].parentUid===o&&s.push(i[l]);return s},i.prototype.getChildRowsByParentIndex=function(e,i,r,n,o,s){var l=n||this.groupCache[this.parent.pageSettings.currentPage],a=l[e],h=[];if(!a.isCaptionRow||a.isCaptionRow&&!a.isExpand&&!s)return[];o&&this.parent.aggregates.length&&(h=this.getAggregateByCaptionIndex(e));for(var d=a.indent,p=a.uid,c=[],u=0,g=e+1;g<l.length;g++){if(l[g].parentUid===p){if(t.isNullOrUndefined(l[g].indent))continue;if(u++,c.push(l[g]),i&&l[g].isCaptionRow&&(c=c.concat(this.getChildRowsByParentIndex(g,i,r,n,o))),r&&u===this.pageSize)break}if(l[g].indent===d)break}return c.concat(h)},i.prototype.initialGroupRows=function(e){var t=[],i=this.groupCache[this.parent.pageSettings.currentPage];if(e)return this.getRenderedRowsObject();for(var r=0;r<i.length;r++)0===i[r].indent&&(t.push(i[r]),t=t.concat(this.getChildRowsByParentIndex(r,!0,!0,i,!0)));return t},i.prototype.getRenderedRowsObject=function(){for(var e=[],t=[].slice.call(this.parent.getContent().querySelectorAll("tr")),i=0;i<t.length;i++)e.push(this.getRowByUid(t[i].getAttribute("data-uid")));return e},i.prototype.getCacheRowsOnDownScroll=function(e){for(var i=[],r=this.groupCache[this.parent.pageSettings.currentPage],n=e,o=0;o<this.pageSize&&(r[n]&&!(r[n].indent<r[e].indent));o++)r[n].indent===r[e].indent&&(i.push(r[n]),r[n].isCaptionRow&&r[n].isExpand&&(i=i.concat(this.getChildRowsByParentIndex(n,!0,!0,null,!0)))),(r[n].indent>r[e].indent||t.isNullOrUndefined(r[n].indent))&&o--,n++;return i},i.prototype.getCacheRowsOnUpScroll=function(e,t,i){for(var r=[],n=this.groupCache[this.parent.pageSettings.currentPage],o=!1,s=0;s<n.length&&(!o||n[s]&&!(n[s].indent<n[i].indent)&&n[s].uid!==t);s++)o||n[s].uid!==e||(o=!0),o&&n[s].indent===n[i].indent&&(r.push(n[s]),n[s].isCaptionRow&&n[s].isExpand&&(r=r.concat(this.getChildRowsByParentIndex(s,!0,!0,null,!0))));return r},i.prototype.scrollHandler=function(e){if(!this.parent.isDestroyed&&!this.childCount){var t,i=[].slice.call(this.parent.getContent().getElementsByClassName("e-lazyload-middle-down")),r=[].slice.call(this.parent.getContent().getElementsByClassName("e-lazyload-middle-up")),n=[].slice.call(this.parent.getContent().getElementsByClassName("e-not-lazyload-end")),o=!1,s=!1,l=!1;if(e.scrollDown&&i.length){t=(p=this.findRowElements(i)).tr,o=p.entered}if(!e.scrollDown&&n)for(var a=0;a<n.length;a++){var h=n[a].getBoundingClientRect().top,d=this.parent.getContent().scrollHeight;if(h>0&&h<d){t=n[a],l=!0,this.rowIndex=t.rowIndex;break}}if(!e.scrollDown&&r.length&&!l){var p;t=(p=this.findRowElements(r)).tr,s=p.entered}t&&(o&&e.scrollDown&&o&&t&&this.scrollDownHandler(t),!e.scrollDown&&l&&t&&this.scrollUpEndRowHandler(t),this.cacheMode&&!e.scrollDown&&!l&&s&&t&&this.scrollUpHandler(t))}},i.prototype.scrollUpEndRowHandler=function(e){var t=this.parent.pageSettings.currentPage,i=this.groupCache[t],r=e.getAttribute("data-uid"),n=this.rowObjectIndex=this.getRowObjectIndexByUid(r),o=n,s=i[n],l=this.getRowByUid(s.parentUid),a=this.getRowObjectIndexByUid(l.uid),h=this.parent.getContent().querySelector("tr[data-uid="+l.uid+"]").rowIndex,d=this.getChildRowsByParentIndex(a).indexOf(s),p=Math.ceil(d/this.pageSize);if(1!==p)if(this.childCount=p*this.pageSize,n=this.getCurrentBlockEndIndex(s,n),this.childCount<l.data.count){e.classList.remove("e-not-lazyload-end"),s.lazyLoadCssClass="";var c=!!i[n+1]&&s.indent===i[n+1].indent;this.scrollData=c?this.getCacheRowsOnDownScroll(n+1):[];var u=tt(a,i),g={rowIndex:h,makeRequest:!c,groupInfo:l,fields:u.fields,keys:u.keys,skip:this.childCount,take:this.pageSize,isScroll:!0};if(this.cacheMode&&this.childCount>=this.pageSize*this.cacheBlockSize){var f=this.getChildRowsByParentIndex(a),m=Math.ceil(f.indexOf(i[o])/this.pageSize)-(this.cacheBlockSize-1);this.removeBlock(r,c,m,f),g.cachedRowIndex=m*this.pageSize}this.captionRowExpand(g)}else this.childCount=0},i.prototype.scrollDownHandler=function(e){var i=this.parent.pageSettings.currentPage,r=this.groupCache[i],n=e.getAttribute("data-uid"),o=this.getRowObjectIndexByUid(n),s=o,l=r[o],a=this.getRowByUid(l.parentUid),h=this.getRowObjectIndexByUid(a.uid),d=this.getRowElementByUid(a.uid).rowIndex,p=this.getChildRowsByParentIndex(h),c=p.indexOf(l),u=Math.ceil(c/this.pageSize);this.childCount=u*this.pageSize;var g=r[o=this.rowObjectIndex=this.getRowObjectIndexByUid(p[this.childCount-1].uid)],f=this.getRowElementByUid(g.uid);if(this.rowIndex=f.rowIndex,o=this.getCurrentBlockEndIndex(g,o),this.childCount<a.data.count){var m=!!r[o+1]&&l.indent===r[o+1].indent;if(m&&!t.isNullOrUndefined(this.getRowElementByUid(r[o+1].uid)))return void(this.childCount=0);(u>1||!this.cacheMode)&&(e.classList.remove("e-lazyload-middle-down"),f.classList.remove("e-not-lazyload-end"),g.lazyLoadCssClass=""),this.scrollData=m?this.getCacheRowsOnDownScroll(this.rowObjectIndex+1):[];var y=tt(h,r),v={rowIndex:d,makeRequest:!m,groupInfo:a,fields:y.fields,keys:y.keys,skip:this.childCount,take:this.pageSize,isScroll:!0};if(this.cacheMode&&this.childCount-this.pageSize>=this.pageSize*this.cacheBlockSize){this.isScrollDown=!0;var C=this.getChildRowsByParentIndex(h),w=Math.ceil(C.indexOf(r[s])/this.pageSize)-1-(this.cacheBlockSize-1)+1;this.removeBlock(n,m,w,C,g),v.cachedRowIndex=w*this.pageSize}this.captionRowExpand(v)}else this.childCount=0},i.prototype.getCurrentBlockEndIndex=function(e,t){var i=this.parent.pageSettings.currentPage,r=this.groupCache[i];if(e.isCaptionRow){if(e.isExpand){var n=this.getChildRowsByParentIndex(t,!0).length;this.rowIndex=this.rowIndex+n}var o=this.getAggregateByCaptionIndex(t);this.rowObjectIndex=this.rowObjectIndex+o.length;for(var s=t,l=s+1;l<r.length;l++){if(r[l].indent===r[t].indent||r[l].indent<r[t].indent){t=s;break}s++}}return t},i.prototype.removeBlock=function(e,t,i,r,n){var o=this.parent.pageSettings.currentPage,s=this.groupCache[o],l=r[(i+1)*this.pageSize-1-this.blockSize].uid,a=r[i*this.pageSize-this.pageSize].uid,h=r[i*this.pageSize].uid;s[this.getRowObjectIndexByUid(l)].lazyLoadCssClass="e-lazyload-middle-up",this.getRowElementByUid(l).classList.add("e-lazyload-middle-up"),n&&(this.getRowElementByUid(h).classList.add("e-not-lazyload-first"),this.getRowByUid(h).lazyLoadCssClass="e-not-lazyload-first",this.getRowByUid(a).lazyLoadCssClass=""),t?this.removeTopRows(n?n.uid:e,a,h):(this.uid1=a,this.uid2=h,this.uid3=n?n.uid:e)},i.prototype.scrollUpHandler=function(e){var i=this.parent.pageSettings.currentPage,r=this.groupCache[i],n=e.getAttribute("data-uid"),o=this.getRowByUid(n),s=this.rowObjectIndex=this.getRowObjectIndexByUid(n),l=this.getRowByUid(o.parentUid),a=this.rowIndex=this.getRowObjectIndexByUid(l.uid),h=this.parent.getRowElementByUID(l.uid).rowIndex,d=this.getChildRowsByParentIndex(a),p=d.indexOf(r[s]),c=Math.floor(p/this.pageSize),u=this.blockSize;2*this.blockSize>this.pageSize&&(u=2*this.blockSize-this.pageSize,u=this.blockSize-u);var g=d[p-(u-1)-this.pageSize].uid,f=d[p-(u-1)].uid;this.scrollData=this.getCacheRowsOnUpScroll(g,f,s-(u-1)),this.isFirstChildRow=c>1,this.isFirstChildRow&&(this.scrollData[0].lazyLoadCssClass="e-not-lazyload-first"),this.getRowByUid(f).lazyLoadCssClass="",this.getRowElementByUid(f).classList.remove("e-not-lazyload-first");var m=c+this.cacheBlockSize;if(d.length!==l.data.count&&m*this.pageSize>d.length)return this.isFirstChildRow=!1,this.scrollData[0].lazyLoadCssClass="",void this.getRowElementByUid(f).classList.add("e-not-lazyload-first");var y=m*this.pageSize>l.data.count?l.data.count:m*this.pageSize,v=m*this.pageSize>l.data.count?this.pageSize-(this.pageSize*m-l.data.count):this.pageSize,C=this.getChildRowsByParentIndex(r.indexOf(d[y-1]),!0,!1,null,!0),w=C.length?C[C.length-1].uid:d[y-1].uid,b=d[y-v].uid,S=d[y-v-1].uid,R=this.objIdxByUid[i][b]-u;if("e-lazyload-middle-down"===r[R].lazyLoadCssClass){var x=this.getRowElementByUid(r[R].uid);x&&x.classList.add("e-lazyload-middle-down")}if(this.getRowByUid(w).lazyLoadCssClass="",this.getRowByUid(S).lazyLoadCssClass="e-not-lazyload-end",this.getRowElementByUid(S).classList.add("e-not-lazyload-end"),this.removeBottomRows(w,b,S),this.rowIndex=e.rowIndex-u,e.classList.length>1?e.classList.remove("e-lazyload-middle-up"):e.removeAttribute("class"),!t.isNullOrUndefined(this.getRowElementByUid(g)))return this.childCount=0,void(this.scrollData=[]);var F=tt(this.getRowObjectIndexByUid(l.uid),r),E={rowIndex:h,makeRequest:!1,groupInfo:l,fields:F.fields,keys:F.keys,skip:this.childCount,take:this.pageSize,isScroll:!0,scrollUp:!0};this.isScrollUp=!0,this.captionRowExpand(E)},i.prototype.findRowElements=function(e){for(var t,i=!1,r=0;r<e.length;r++){var n=e[r].rowIndex;if(Se(n,this.parent)){i=!0,this.rowIndex=n,t=e[r];break}}return{entered:i,tr:t}},i.prototype.getRowElementByUid=function(e){return this.parent.getContent().querySelector("tr[data-uid="+e+"]")},i.prototype.removeTopRows=function(e,i,r){for(var n=[].slice.call(this.parent.getContent().querySelectorAll("tr")),o=!1,s=0;s<n.length;s++){if(n[s].getAttribute("data-uid")===r){var l=this.parent.getContent().querySelector("tr[data-uid="+e+"]");l&&(this.rowIndex=l.rowIndex);break}n[s].getAttribute("data-uid")===i&&(o=!0),o&&t.remove(n[s])}},i.prototype.removeBottomRows=function(e,i,r){for(var n=[].slice.call(this.parent.getContent().querySelectorAll("tr")),o=!1,s=0;s<n.length&&(n[s].getAttribute("data-uid")===i&&(o=!0),!o||(t.remove(n[s]),n[s].getAttribute("data-uid")!==e));s++);},i.prototype.setCache=function(e){var i=this.parent.pageSettings.currentPage;this.groupCache[i]=this.initialGroupCaptions[i]=t.extend([],e.data)},i.prototype.captionRowExpand=function(e){var t=this,i=e.groupInfo,r=this.parent.groupSettings.columns.indexOf(i.data.field)+1,n=et($e(e.fields,e.keys,this)),o={level:r,skip:e.skip,take:e.take,where:n};if(e.makeRequest){var s=this.parent.renderModule.data.generateQuery(!0);s.isCountRequired||(s.isCountRequired=!0),s.lazyLoad.push({key:"onDemandGroupInfo",value:o}),this.parent.showSpinner(),this.parent.renderModule.data.getData({},s).then(function(i){t.parent.hideSpinner(),0!==i.result.length&&(t.cacheMode&&t.uid1&&t.uid2&&(t.removeTopRows(t.uid3,t.uid1,t.uid2),t.uid1=t.uid2=t.uid3=void 0),t.lazyLoadHandler({data:i.result,count:i.count,level:r,index:e.rowIndex,isRowExist:!1,isScroll:e.isScroll,up:!1,rowIndex:e.cachedRowIndex}))}).catch(function(e){return t.parent.renderModule.dataManagerFailure(e,{requestType:"grouping"})})}else this.lazyLoadHandler({data:null,count:e.groupInfo.data.count,level:r,index:e.rowIndex,isRowExist:!0,isScroll:e.isScroll,up:e.scrollUp,rowIndex:e.cachedRowIndex})},i.prototype.scrollReset=function(e){this.parent.getContent().firstElementChild.scrollTop=e?this.parent.getContent().firstElementChild.scrollTop+e:0},i.prototype.updateCurrentViewData=function(){var e=[];this.getRows().filter(function(t){t.isDataRow&&(e[t.index]=t.data)}),this.parent.currentViewData=e.length?e:this.parent.currentViewData},i.prototype.getGroupCache=function(){return this.groupCache},i.prototype.getRows=function(){return this.groupCache[this.parent.pageSettings.currentPage]||[]},i.prototype.getRowElements=function(){return[].slice.call(this.parent.getContent().getElementsByClassName(is))},i.prototype.getRowByIndex=function(e){for(var i,r=[].slice.call(this.parent.getContent().getElementsByClassName(is)),n=0;!t.isNullOrUndefined(e)&&n<r.length;n++)if(r[n].getAttribute(us)===e.toString()){i=r[n];break}return i},i.prototype.setVisible=function(e){var i,r=this.parent;this.getRows().some(function(e){return e.isDataRow&&(i=e),e.isDataRow});for(var n=this.getRows().filter(function(e){return!e.isDetailRow}),o=0;o<e.length;o++){var s=e[o],l=this.parent.getNormalizedColumnIndex(s.uid),a=this.parent.getColumnIndexByUid(s.uid),h=!0===s.visible?"":"none";-1!==l&&i&&l<i.cells.length&&t.setStyleAttribute(this.getColGroup().childNodes[l],{display:h}),this.setDisplayNone(r.getDataRows(),a,h,n,l),!this.parent.invokedFromMedia&&s.hideAtMedia&&this.parent.updateMediaColumns(s),this.parent.invokedFromMedia=!1}},i.prototype.setDisplayNone=function(e,i,r,n,o){if(this.parent.groupSettings.columns.length)for(var s=Object.keys(this.groupCache),l=0;l<s.length;l++)for(var a=this.rowsByUid[s[l]],h=Object.keys(a),d=0;d<h.length;d++){var p=this.parent.getContent().querySelector("tr[data-uid="+h[d]+"]"),c=a[h[d]];c.isCaptionRow&&(this.captionModelGen.isEmpty()?(c.cells[c.indent+1].colSpan=""===r?c.cells[c.indent+1].colSpan+1:c.cells[c.indent+1].colSpan-1,p&&(p.cells[c.indent+1].colSpan=c.cells[c.indent+1].colSpan)):this.changeCaptionRow(c,p,s[l])),c.isDataRow&&(this.showAndHideCells(p,i,r,!1),c.cells[o].visible=""===r),c.isCaptionRow||c.isDataRow||!t.isNullOrUndefined(c.indent)||(c.cells[o].visible=""===r,c.visible=c.cells.some(function(e){return e.isDataCell&&e.visible}),this.showAndHideCells(p,i,r,!0,c))}else Ge(e,i,r,n)},i.prototype.changeCaptionRow=function(e,t,i){var r=e,n=e.data,o=this.groupGenerator.generateCaptionRow(n,r.indent,r.parentGid,void 0,r.tIndex,r.parentUid);if(o.uid=e.uid,o.isExpand=e.isExpand,o.lazyLoadCssClass=e.lazyLoadCssClass,this.rowsByUid[i][e.uid]=o,this.groupCache[i][this.objIdxByUid[i][e.uid]]=o,t){this.parent.getContentTable().querySelector(gs).replaceChild(this.rowRenderer.render(o,this.parent.getColumns()),t)}},i.prototype.showAndHideCells=function(e,i,r,n,o){if(e){var s=n?"td.e-summarycell":"td.e-rowcell";t.setStyleAttribute(e.querySelectorAll(s)[i],{display:r}),e.querySelectorAll(s)[i].classList.contains("e-hide")&&t.removeClass([e.querySelectorAll(s)[i]],["e-hide"]),n&&(o.visible&&e.classList.contains("e-hide")?t.removeClass([e],["e-hide"]):o.visible||t.addClass([e],["e-hide"]))}},i}(ks),Jh=function(){function t(e,t){this.parent=e,this.serviceLocator=t,this.addEventListener()}return t.prototype.getModuleName=function(){return"lazyLoadGroup"},t.prototype.addEventListener=function(){this.parent.isDestroyed||(this.parent.on(bi,this.instantiateRenderer,this),this.parent.on(Ki,this.destroy,this))},t.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(bi,this.instantiateRenderer),this.parent.off(Ki,this.destroy))},t.prototype.instantiateRenderer=function(){"auto"===this.parent.height&&(this.parent.height=this.parent.pageSettings.pageSize*this.parent.getRowHeight());var t=this.serviceLocator.getService("rendererFactory");this.parent.groupSettings.enableLazyLoading&&t.addRenderer(e.RenderType.Content,new Yh(this.parent,this.serviceLocator))},t.prototype.destroy=function(){this.removeEventListener()},t}(),Zh=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),$h=function(e){function r(){return null!==e&&e.apply(this,arguments)||this}return Zh(r,e),r.prototype.write=function(e){this.column=e.column;var r="Dialog"!==this.parent.editSettings.mode;this.object=new s.AutoComplete(t.extend({dataSource:this.parent.dataSource instanceof i.DataManager?this.parent.dataSource:new i.DataManager(this.parent.dataSource),query:(new i.Query).select(e.column.field),enabled:_(e.column,e.requestType,e.element),fields:{value:e.column.field},value:he(e.column.field,e.rowData),actionComplete:this.selectedValues.bind(this),placeholder:r?"":e.column.headerText,floatLabelType:r?"Never":"Always"},e.column.edit.params)),this.object.appendTo(e.element),e.element.setAttribute("name",V(e.column.field))},r.prototype.selectedValues=function(e){e.result=i.DataUtil.distinct(e.result,this.object.fields.value,!0),this.column.dataSource&&(this.column.dataSource.dataSource.json=e.result)},r}(Ya),ed=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),td=function(e){function r(){return null!==e&&e.apply(this,arguments)||this}return ed(r,e),r.prototype.write=function(e){this.column=e.column;var r="Dialog"!==this.parent.editSettings.mode;this.obj=new s.ComboBox(t.extend({dataSource:this.parent.dataSource instanceof i.DataManager?this.parent.dataSource:new i.DataManager(this.parent.dataSource),query:(new i.Query).select(e.column.field),fields:{value:e.column.field},value:he(e.column.field,e.rowData),enableRtl:this.parent.enableRtl,actionComplete:this.finalValue.bind(this),placeholder:r?"":e.column.headerText,floatLabelType:r?"Never":"Always",enabled:_(e.column,e.requestType,e.element)},e.column.edit.params)),this.obj.appendTo(e.element)},r.prototype.finalValue=function(e){e.result=i.DataUtil.distinct(e.result,this.obj.fields.value,!0),this.column.dataSource&&(this.column.dataSource.dataSource.json=e.result)},r}(Ya),id=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),rd=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return id(i,e),i.prototype.write=function(e){this.column=e.column;var i="Dialog"!==this.parent.editSettings.mode;this.obj=new s.MultiSelect(t.extend({fields:{text:e.column.field,value:e.column.field},value:t.getValue(e.column.field,e.rowData),enableRtl:this.parent.enableRtl,placeholder:i?"":e.column.headerText,popupHeight:"200px",floatLabelType:i?"Never":"Always"},e.column.edit.params)),this.obj.appendTo(e.element),e.element.setAttribute("name",V(e.column.field))},i}(Ya),nd=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),od=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return nd(i,e),i.prototype.write=function(e){var i="Dialog"!==this.parent.editSettings.mode,r=he(e.column.field,e.rowData);r=r?new Date(r):null,this.obj=new l.TimePicker(t.extend({floatLabelType:i?"Never":"Always",value:r,placeholder:i?"":e.column.headerText,enableRtl:this.parent.enableRtl,enabled:_(e.column,e.requestType,e.element)},e.column.edit.params)),this.obj.appendTo(e.element)},i}(Ya),sd=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),ld=function(e){function i(){var t=null!==e&&e.apply(this,arguments)||this;return t.activeClasses=["e-selectionbackground","e-active"],t}return sd(i,e),i.prototype.create=function(e){var t="e-field e-boolcell";return"checkbox"===e.column.type&&(t="e-field e-boolcell e-edit-checkselect"),We(this.parent,e.column,t,{type:"checkbox",value:e.value})},i.prototype.read=function(e){return e.checked},i.prototype.write=function(e){var i=!t.isNullOrUndefined(e.row)&&e.row.querySelector(".e-edit-checkselect"),r=he(e.column.field,e.rowData),o=r&&JSON.parse(r.toString().toLowerCase());if(!t.isNullOrUndefined(i)){if(this.editType=this.parent.editSettings.mode,this.editRow=e.row,"add"!==e.requestType){var s=this.parent.getRowObjectFromUID(e.row.getAttribute("data-uid"));o=!!s&&s.isSelected}X.apply(void 0,[[].slice.call(e.row.getElementsByClassName(_o)),o].concat(this.activeClasses))}this.obj=new n.Switch(t.extend({label:"Dialog"!==this.parent.editSettings.mode?" ":e.column.headerText,checked:o,disabled:!_(e.column,e.requestType,e.element),enableRtl:this.parent.enableRtl,change:this.switchModeChange.bind(this)},e.column.edit.params)),this.obj.appendTo(e.element)},i.prototype.switchModeChange=function(e){if(this.editRow&&"Dialog"!==this.editType){var t=!1;e.checked?(t=!0,this.editRow.setAttribute("aria-selected",t.toString())):this.editRow.removeAttribute("aria-selected"),X.apply(void 0,[[].slice.call(this.editRow.getElementsByClassName(_o)),t].concat(this.activeClasses))}},i}(Ya),ad=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function r(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),hd=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return ad(i,e),i.prototype.write=function(e){this.column=e.column;var i="Dialog"!==this.parent.editSettings.mode;this.obj=new o.MaskedTextBox(t.extend({fields:{value:e.column.field},value:he(e.column.field,e.rowData),floatLabelType:i?"Never":"Always",mask:"000-000-0000",enabled:_(e.column,e.requestType,e.element)},e.column.edit.params)),this.obj.appendTo(e.element)},i}(Ya);e.CheckBoxFilterBase=ia,e.ExcelFilterBase=na,e.SortDescriptor=ql,e.SortSettings=Hl,e.Predicate=Ul,e.InfiniteScrollSettings=jl,e.FilterSettings=Vl,e.SelectionSettings=Gl,e.SearchSettings=_l,e.RowDropSettings=Wl,e.TextWrapSettings=Kl,e.ResizeSettings=Ql,e.GroupSettings=Xl,e.EditSettings=Yl,e.Grid=Jl,e.doesImplementInterface=u,e.valueAccessor=g,e.headerValueAccessor=function(e,r){return t.isNullOrUndefined(e)||""===e?"":i.DataUtil.getObject(e,r)},e.getUpdateUsingRaf=f,e.isExportColumns=m,e.updateColumnTypeForExportColumns=y,e.updatecloneRow=v,e.getCollapsedRowsCount=C,e.recursive=w,e.iterateArrayOrObject=b,e.iterateExtend=S,e.templateCompiler=R,e.setStyleAndAttributes=x,e.extend=F,e.setColumnIndex=E,e.prepareColumns=I,e.setCssInGridPopUp=T,e.getActualProperties=z,e.parentsUntil=D,e.getElementIndex=M,e.inArray=O,e.getActualPropFromColl=k,e.removeElement=A,e.getPosition=B,e.getUid=N,e.appendChildren=P,e.parents=L,e.calculateAggregate=q,e.getScrollBarWidth=H,e.getRowHeight=U,e.getActualRowHeight=function(e){if(void 0!==Ho)return qo;var i=t.createElement("table",{className:ts,styles:"visibility: hidden"});i.innerHTML='<tr><td class="e-rowcell">A<td></tr>',e.appendChild(i);var r=i.querySelector("tr").getBoundingClientRect();return e.removeChild(i),r.height},e.isComplexField=j,e.getComplexFieldID=V,e.setComplexFieldID=G,e.isEditable=_,e.isActionPrevent=W,e.wrap=K,e.setFormatter=Q,e.addRemoveActiveClasses=X,e.distinctStringValues=Y,e.getFilterMenuPostion=J,e.getZIndexCalcualtion=Z,e.toogleCheckbox=$,e.setChecked=ee,e.createCboxWithWrap=te,e.removeAddCboxClasses=ie,e.refreshForeignData=re,e.getForeignData=ne,e.getColumnByForeignKeyValue=oe,e.getDatePredicate=se,e.renderMovable=le,e.isGroupAdaptive=ae,e.getObject=he,e.getCustomDateFormat=de,e.getExpandedState=pe,e.getPrintGridModel=ce,e.extendObjWithFn=ue,e.measureColumnDepth=ge,e.checkDepth=fe,e.refreshFilteredColsUid=me,e.getTransformValues=ye,e.applyBiggerTheme=ve,e.alignFrozenEditForm=Ce,e.ensureLastRow=we,e.ensureFirstRow=be,e.isRowEnteredInGrid=Se,e.getEditedDataIndex=Re,e.eventPromise=xe,e.getStateEventArgument=Fe,e.ispercentageWidth=Ee,e.resetRowIndex=Ie,e.compareChanges=Te,e.setRowElements=ze,e.splitFrozenRowObjectCells=De,e.gridActionHandler=Me,e.getGridRowObjects=Oe,e.getGridRowElements=ke,e.sliceElements=Ae,e.getCellsByTableName=Be,e.getCellByColAndRowIndex=Ne,e.setValidationRuels=Pe,e.getMovableTbody=Le,e.getFrozenRightTbody=qe,e.setRowsInTbody=He,e.getNumberFormat=Ue,e.addBiggerDialog=je,e.performComplexDataOperation=Ve,e.setDisplayValue=Ge,e.addRemoveEventListener=_e,e.createEditElement=We,e.getColumnModelByUid=Ke,e.getColumnModelByFieldName=Qe,e.registerEventHandlers=Xe,e.removeEventHandlers=Ye,e.clearReactVueTemplates=Je,e.getRowIndexFromElement=Ze,e.generateExpandPredicates=$e,e.getPredicates=et,e.getGroupKeysAndFields=tt,e.created="create",e.destroyed="destroy",e.load="load",e.rowDataBound=Et,e.queryCellInfo=It,e.headerCellInfo=Tt,e.actionBegin=zt,e.actionComplete=Dt,e.actionFailure=Mt,e.dataBound=Ot,e.rowSelecting=kt,e.rowSelected=At,e.rowDeselecting=Bt,e.rowDeselected=Nt,e.cellSelecting=Pt,e.cellSelected=Lt,e.cellDeselecting=qt,e.cellDeselected=Ht,e.columnSelecting=Ut,e.columnSelected=jt,e.columnDeselecting=Vt,e.columnDeselected=Gt,e.columnDragStart=_t,e.columnDrag=Wt,e.columnDrop=Kt,e.rowDragStartHelper=Qt,e.rowDragStart=Xt,e.rowDrag=Yt,e.rowDrop=Jt,e.beforePrint=Zt,e.printComplete=$t,e.detailDataBound=ei,e.toolbarClick="toolbarClick",e.batchAdd=ti,e.batchCancel=ii,e.batchDelete=ri,e.beforeBatchAdd=ni,e.beforeBatchDelete=oi,e.beforeBatchSave=si,e.beginEdit="beginEdit",e.cellEdit="cellEdit",e.cellSave="cellSave",e.cellSaved="cellSaved",e.endAdd="endAdd",e.endDelete="endDelete",e.endEdit="endEdit",e.recordDoubleClick=li,e.recordClick="recordClick",e.beforeDataBound=ai,e.beforeOpenColumnChooser=hi,e.beforeOpenAdaptiveDialog=di,e.resizeStart="resizeStart",e.onResize="resizing",e.resizeStop=pi,e.checkBoxChange=ci,e.beforeCopy="beforeCopy",e.beforePaste="beforePaste",e.beforeAutoFill=ui,e.filterChoiceRequest=gi,e.filterAfterOpen=fi,e.filterBeforeOpen=mi,e.filterSearchBegin=yi,e.commandClick="commandClick",e.exportGroupCaption=vi,e.lazyLoadGroupExpand=Ci,e.lazyLoadGroupCollapse=wi,e.initialLoad=bi,e.initialEnd=Si,e.dataReady=Ri,e.contentReady=xi,e.uiUpdate=Fi,e.onEmpty=Ei,e.inBoundModelChanged=Ii,e.modelChanged=Ti,e.colGroupRefresh=zi,e.headerRefreshed=Di,e.pageBegin="paging-begin",e.pageComplete=Mi,e.sortBegin="sorting-begin",e.sortComplete=Oi,e.filterBegin="filtering-begin",e.filterComplete=ki,e.searchBegin="searching-begin",e.searchComplete=Ai,e.reorderBegin="reorder-begin",e.reorderComplete=Bi,e.rowDragAndDropBegin="rowdraganddrop-begin",e.rowDragAndDropComplete=Ni,e.groupBegin="grouping-begin",e.groupComplete=Pi,e.ungroupBegin="ungrouping-begin",e.ungroupComplete=Li,e.groupAggregates=qi,e.refreshFooterRenderer=Hi,e.refreshAggregateCell=Ui,e.refreshAggregates=ji,e.rowSelectionBegin="rowselecting",e.rowSelectionComplete="rowselected",e.columnSelectionBegin="columnselecting",e.columnSelectionComplete="columnselected",e.cellSelectionBegin="cellselecting",e.cellSelectionComplete="cellselected",e.beforeCellFocused=Vi,e.cellFocused=Gi,e.keyPressed=_i,e.click=Wi,e.destroy=Ki,e.columnVisibilityChanged=Qi,e.scroll=Xi,e.columnWidthChanged=Yi,e.columnPositionChanged=Ji,e.rowDragAndDrop="row-drag-and-drop",e.rowsAdded=Zi,e.rowsRemoved=$i,e.columnDragStop=er,e.headerDrop=tr,e.dataSourceModified=ir,e.refreshComplete=rr,e.refreshVirtualBlock=nr,e.dblclick=or,e.toolbarRefresh=sr,e.bulkSave=lr,e.autoCol=ar,e.tooltipDestroy=hr,e.updateData=dr,e.editBegin="edit-begin",e.editComplete="edit-complete",e.addBegin="add-begin",e.addComplete="add-complete",e.saveComplete=pr,e.deleteBegin="delete-begin",e.deleteComplete=cr,e.preventBatch=ur,e.dialogDestroy=gr,e.crudAction=fr,e.addDeleteAction=mr,e.destroyForm=yr,e.doubleTap=vr,e.beforeExcelExport=Cr,e.excelExportComplete=wr,e.excelQueryCellInfo=br,e.excelHeaderQueryCellInfo=Sr,e.exportDetailDataBound=Rr,e.beforePdfExport=xr,e.pdfExportComplete=Fr,e.pdfQueryCellInfo=Er,e.pdfHeaderQueryCellInfo=Ir,e.accessPredicate="access-predicate",e.contextMenuClick=Tr,e.freezeRender=zr,e.freezeRefresh="freezerefresh",e.contextMenuOpen=Dr,e.columnMenuClick=Mr,e.columnMenuOpen=Or,e.filterOpen=kr,e.filterDialogCreated=Ar,e.filterMenuClose=Br,e.initForeignKeyColumn=Nr,e.getForeignKeyData=Pr,e.generateQuery=Lr,e.showEmptyGrid=qr,e.foreignKeyData=Hr,e.columnDataStateChange=Ur,e.dataStateChange=jr,e.dataSourceChanged=Vr,e.rtlUpdated=Gr,e.beforeFragAppend=_r,e.frozenHeight=Wr,e.textWrapRefresh=Kr,e.recordAdded=Qr,e.cancelBegin=Xr,e.editNextValCell=Yr,e.hierarchyPrint=Jr,e.expandChildGrid=Zr,e.printGridInit=$r,e.exportRowDataBound=en,e.exportDataBound=tn,e.rowPositionChanged=rn,e.columnChooserOpened=nn,e.batchForm=on,e.beforeStartEdit="edit-form",e.beforeBatchCancel=sn,e.batchEditFormRendered=ln,e.partialRefresh=an,e.beforeCustomFilterOpen=hn,e.selectVirtualRow=dn,e.columnsPrepared=pn,e.cBoxFltrBegin=cn,e.cBoxFltrComplete=un,e.fltrPrevent=gn,e.beforeFltrcMenuOpen=fn,e.valCustomPlacement=mn,e.filterCboxValue=yn,e.componentRendered="component-rendered",e.restoreFocus=vn,e.detailStateChange=Cn,e.detailIndentCellInfo=wn,e.virtaulKeyHandler="virtaul-key-handler",e.virtaulCellFocus=bn,e.virtualScrollEditActionBegin=Sn,e.virtualScrollEditSuccess=Rn,e.virtualScrollEditCancel=xn,e.virtualScrollEdit=Fn,e.refreshVirtualCache=En,e.editReset=In,e.virtualScrollAddActionBegin=Tn,e.getVirtualData=zn,e.refreshInfiniteModeBlocks=Dn,e.resetInfiniteBlocks=Mn,e.infiniteScrollHandler=On,e.infinitePageQuery=kn,e.infiniteShowHide=An,e.appendInfiniteContent=Bn,e.removeInfiniteRows=Nn,e.setInfiniteCache=Pn,e.infiniteEditHandler=Ln,e.initialCollapse=qn,e.getAggregateQuery="get-aggregate-query",e.closeFilterDialog=Hn,e.columnChooserCancelBtnClick=Un,e.getFilterBarOperator=jn,e.resetColumns=Vn,e.pdfAggregateQueryCellInfo=Gn,e.excelAggregateQueryCellInfo=_n,e.setGroupCache=Wn,e.lazyLoadScrollHandler=Kn,e.groupCollapse=Qn,e.beforeCheckboxRenderer=Xn,e.refreshHandlers=Yn,e.refreshFrozenColumns=Jn,e.setReorderDestinationElement=Zn,e.refreshVirtualFrozenHeight=$n,e.setFreezeSelection=eo,e.setInfiniteFrozenHeight="set-infinite-frozen-height",e.setInfiniteColFrozenHeight="set-infinite-col-frozen-height",e.beforeRefreshOnDataChange=to,e.immutableBatchCancel=io,e.refreshVirtualFrozenRows=ro,e.checkScrollReset=no,e.refreshFrozenHeight=oo,e.setHeightToFrozenElement=so,e.preventFrozenScrollRefresh=lo,e.nextCellIndex=ao,e.refreshInfiniteCurrentViewData=ho,e.infiniteCrudCancel=po,e.filterDialogClose=co,e.refreshCustomFilterOkBtn=uo,e.refreshCustomFilterClearBtn=go,e.renderResponsiveCmenu=fo,e.filterCmenuSelect=mo,e.customFilterClose=yo,e.setFullScreenDialog=vo,e.refreshExpandandCollapse=Co,e.rowModeChange=wo,e.enterKeyHandler=bo,e.refreshVirtualMaxPage=So,e.setVirtualPageQuery=Ro,e.selectRowOnContextOpen=xo,e.pagerRefresh=Fo,e.closeInline="closeinline",e.closeBatch="closebatch",e.closeEdit=Eo,e.resetVirtualFocus=Io,e.afterContentRender="after-content-renderer",e.refreshVirtualEditFormCells=To,e.scrollToEdit=zo,e.beforeCheckboxRendererQuery=Do,e.createVirtualValidationForm=Mo,e.validateVirtualForm=Oo,e.destroyChildGrid=ko,e.stickyScrollComplete=Ao,e.captionActionComplete=Bo,e.refreshInfinitePersistSelection=No,e.refreshInfiniteEditrowindex=Po,e.afterFilterColumnMenuClose=Lo,e.rowCell=_o,e.gridHeader=Wo,e.gridContent=Ko,e.gridFooter=Qo,e.headerContent=Xo,e.movableContent=Yo,e.movableHeader=Jo,e.frozenContent=Zo,e.frozenHeader=$o,e.content=es,e.table=ts,e.row=is,e.gridChkBox=rs,e.editedRow=ns,e.addedRow=os,e.changedRecords=ss,e.addedRecords=ls,e.deletedRecords=as,e.leftRight=hs,e.frozenRight=ds,e.frozenLeft=ps,e.ariaColIndex=cs,e.ariaRowIndex=us,e.tbody=gs,e.colGroup=fs,e.open=ms,e.change=ys,e.focus=vs,e.create=Cs,e.beforeOpen=ws,e.downArrow=bs,e.upArrow=Ss,e.pageUp="PageUp",e.pageDown="PageDown",e.enter=Rs,e.shiftEnter=xs,e.tab="tab",e.shiftTab="shiftTab",e.Data=Uo,e.Sort=oa,e.Page=ua,e.Selection=Tl,e.Filter=Ea,e.Search=zl,e.Scroll=Ml,e.resizeClassList=Ia,e.Resize=Ta,e.Reorder=za,e.RowDD=Da,e.Group=Ma,e.getCloneProperties=c,e.Print=Zl,e.DetailRow=Oa,e.Toolbar=ka,e.Aggregate=La,e.summaryIterator=it,e.VirtualScroll=_a,e.Edit=uh,e.BatchEdit=lh,e.InlineEdit=sh,e.NormalEdit=nh,e.DialogEdit=hh,e.ColumnChooser=gh,e.ExcelExport=yh,e.PdfExport=vh,e.ExportHelper=fh,e.ExportValueFormatter=mh,e.Clipboard=Nl,e.CommandColumn=bh,e.CheckBoxFilter=Ra,e.menuClass=Sh,e.ContextMenu=Rh,e.Freeze=Bh,e.ColumnMenu=Nh,e.ExcelFilter=Fa,e.ForeignKey=Lh,e.Logger=Gh,e.detailLists=_h,e.InfiniteScroll=Qh,e.LazyLoadGroup=Jh,e.Column=St,e.CommandColumnModel=Rt,e.GridColumn=xt,e.StackedColumn=Ft,e.Row=jo,e.Cell=Vo,e.HeaderRender=As,e.ContentRender=ks,e.RowRenderer=Fs,e.CellRenderer=Bs,e.HeaderCellRenderer=qs,e.FilterCellRenderer=ma,e.StackedHeaderCellRenderer=Us,e.Render=ol,e.IndentCellRenderer=Vs,e.GroupCaptionCellRenderer=_s,e.GroupCaptionEmptyCellRenderer=Ws,e.BatchEditRender=Ka,e.DialogEditRender=Qa,e.InlineEditRender=Wa,e.EditRender=Xa,e.BooleanEditCell=Za,e.DefaultEditCell=rh,e.DropDownEditCell=eh,e.NumericEditCell=th,e.DatePickerEditCell=ph,e.CommandColumnRenderer=wh,e.FreezeContentRender=Eh,e.FreezeRender=Ih,e.StringFilterUI=va,e.NumberFilterUI=Ca,e.DateFilterUI=ba,e.BooleanFilterUI=wa,e.FlMenuOptrUI=ya,e.AutoCompleteEditCell=$h,e.ComboboxEditCell=td,e.MultiSelectEditCell=rd,e.TimePickerEditCell=od,e.ToggleEditCell=ld,e.MaskedTextBoxCellEdit=hd,e.VirtualContentRenderer=ja,e.VirtualHeaderRenderer=Va,e.VirtualElementHandler=Ga,e.GroupLazyLoadRenderer=Yh,e.ColumnFreezeHeaderRenderer=zh,e.ColumnFreezeContentRenderer=Dh,e.ResponsiveDialogRenderer=ll,e.EditCellBase=Ya,e.CellRendererFactory=sl,e.ServiceLocator=al,e.RowModelGenerator=Es,e.GroupModelGenerator=Os,e.FreezeRowModelGenerator=xh,e.ValueFormatter=Ct,e.VirtualRowModelGenerator=Ha,e.InterSectionObserver=qa,e.Pager=da,e.ExternalMessage=ca,e.NumericContainer=sa,e.PagerMessage=la,e.PagerDropDown=pa,Object.defineProperty(e,"__esModule",{value:!0})});
	//# sourceMappingURL=ej2-grids.umd.min.js.map


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	*  filename: ej2-layouts.umd.min.js
	*  version : 19.4.52
	*  Copyright Syncfusion Inc. 2001 - 2020. All rights reserved.
	*  Use of this code is subject to the terms of our license.
	*  A copy of the current license can be obtained at any time by e-mailing
	*  licensing@syncfusion.com. Any infringement will be prosecuted under
	*  applicable laws. 
	*/
	!function(e,t){ true?t(exports,__webpack_require__(23)):"function"==typeof define&&define.amd?define(["exports","@syncfusion/ej2-base"],t):t(e.ej={},e.ej2Base)}(this,function(e,t){"use strict";var i=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),s=function(e,t,i,s){var n,a=arguments.length,l=a<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)l=Reflect.decorate(e,t,i,s);else for(var r=e.length-1;r>=0;r--)(n=e[r])&&(l=(a<3?n(l):a>3?n(t,i,l):n(t,i))||l);return a>3&&l&&Object.defineProperty(t,i,l),l},n="e-splitter",a="e-splitter-horizontal",l="e-splitter-vertical",r="e-pane",o="e-pane-horizontal",h="e-pane-vertical",d="e-split-bar",p="e-split-bar-horizontal",c="e-split-bar-vertical",u="e-static-pane",g="e-scrollable",m="e-resize-handler",f="e-resizable-split-bar",v="e-split-bar-hover",P="e-split-bar-active",y="e-hide-handler",C="e-disabled",x="e-collapsible",S="e-navigate-arrow",w="e-arrow-right",b="e-arrow-left",z="e-arrow-up",A="e-arrow-down",I="e-icon-hidden",E="e-expanded",O="e-collapsed",R="e-pane-hidden",B="e-resizable",H="e-last-bar",M=function(e){function n(){return null!==e&&e.apply(this,arguments)||this}return i(n,e),s([t.Property()],n.prototype,"size",void 0),s([t.Property(!1)],n.prototype,"collapsible",void 0),s([t.Property(!1)],n.prototype,"collapsed",void 0),s([t.Property(!0)],n.prototype,"resizable",void 0),s([t.Property(null)],n.prototype,"min",void 0),s([t.Property(null)],n.prototype,"max",void 0),s([t.Property()],n.prototype,"content",void 0),s([t.Property("")],n.prototype,"cssClass",void 0),n}(t.ChildProperty),L=function(e){function L(t,i){return e.call(this,t,i)||this}return i(L,e),L.prototype.onPropertyChanged=function(e,i){if(this.element.classList.contains(n))for(var s=0,a=Object.keys(e);s<a.length;s++){switch(a[s]){case"height":this.setSplitterSize(this.element,e.height,"height");break;case"width":this.setSplitterSize(this.element,e.width,"width");break;case"cssClass":this.setCssClass(this.element,e.cssClass);break;case"enabled":this.isEnabled(this.enabled);break;case"enableReversePanes":this.setReversePane();break;case"separatorSize":this.setSeparatorSize(e.separatorSize);break;case"orientation":this.changeOrientation(e.orientation);break;case"paneSettings":if(e.paneSettings instanceof Array&&i.paneSettings instanceof Array)this.destroyPaneSettings(),this.allBars=[],this.allPanes=[],this.createSplitPane(this.element),this.addSeparator(this.element),this.getPanesDimensions(),this.setRTL(this.enableRtl),this.isCollapsed();else for(var l=Object.keys(e.paneSettings),r=0;r<l.length;r++)for(var o=parseInt(Object.keys(e.paneSettings)[r],10),h=Object.keys(e.paneSettings[o]).length,d=0;d<h;d++){var p=Object.keys(e.paneSettings[o])[d];switch(p){case"content":var c=Object(e.paneSettings[o])[p];t.isNullOrUndefined(c)||(this.allPanes[o].innerHTML="",this.setTemplate(c,this.allPanes[o]));break;case"resizable":var u=Object(e.paneSettings[o])[p];this.resizableModel(o,u);break;case"collapsible":this.collapsibleModelUpdate(o);break;case"collapsed":e.paneSettings[o].collapsed?this.isCollapsed(o):this.collapsedOnchange(o);break;case"cssClass":this.setCssClass(this.allPanes[o],e.paneSettings[o].cssClass);break;case"size":var g=Object(e.paneSettings[o])[p];""===g||t.isNullOrUndefined(g)||this.updatePaneSize(g,o)}}break;case"enableRtl":this.setRTL(e.enableRtl)}}},L.prototype.updatePaneSize=function(e,t){this.allPanes[t].style.flexBasis=e;for(var i,s=[],n=0,a=0;a<this.allPanes.length;a++)this.paneSettings[a].size||""===this.allPanes[a].innerText?this.paneSettings[a].size&&(i="Horizontal"===this.orientation?this.allPanes[t].offsetWidth:this.allPanes[t].offsetHeight):(s[n]=a,n++);i="Horizontal"===this.orientation?this.allBars[0].offsetWidth*this.allBars.length+i:this.allBars[0].offsetHeight*this.allBars.length+i;for(var l=(("Horizontal"===this.orientation?this.element.offsetWidth:this.element.offsetHeight)-i-2*this.border)/s.length,r=0;r<s.length;r++)this.allPanes[s[r]].style.flexBasis=l+"px";this.allPanes[t].classList.add(u)},L.prototype.initializeValues=function(){this.allPanes=[],this.paneOrder=[],this.separatorOrder=[],this.allBars=[],this.previousCoordinates={},this.currentCoordinates={},this.updatePrePaneInPercentage=!1,this.updateNextPaneInPercentage=!1,this.panesDimensions=[],this.border=0,this.validDataAttributes=["data-size","data-min","data-max","data-collapsible","data-resizable","data-content","data-collapsed"],this.validElementAttributes=["data-orientation","data-width","data-height"],this.iconsDelay=300,this.templateElement=[],this.collapseFlag=!1,this.expandFlag=!0},L.prototype.preRender=function(){this.initializeValues(),this.onReportWindowSize=this.reportWindowSize.bind(this),this.onMouseMoveHandler=this.onMouseMove.bind(this),this.onMouseUpHandler=this.onMouseUp.bind(this),this.onTouchMoveHandler=this.onMouseMove.bind(this),this.onTouchEndHandler=this.onMouseUp.bind(this),this.wrapper=this.element.cloneNode(!0),this.wrapperParent=this.element.parentElement,t.removeClass([this.wrapper],["e-control","e-lib",n]);var e="Horizontal"===this.orientation?a:l;t.addClass([this.element],e);var i="msie"===t.Browser.info.name?"e-ie":"";this.setCssClass(this.element,i),t.Browser.isDevice&&t.addClass([this.element],"e-splitter-touch")},L.prototype.getPersistData=function(){return this.addOnPersist(["paneSettings"])},L.prototype.getModuleName=function(){return"splitter"},L.prototype.render=function(){this.checkDataAttributes(),this.setCssClass(this.element,this.cssClass),this.isEnabled(this.enabled),this.setDimension(this.getHeight(this.element),this.getWidth(this.element)),this.createSplitPane(this.element),this.addSeparator(this.element),this.getPanesDimensions(),this.setPaneSettings(),this.setRTL(this.enableRtl),this.enableReversePanes&&this.setReversePane(),this.collapseFlag=!0,this.isCollapsed(),this.collapseFlag=!1,t.EventHandler.add(document,"touchstart click",this.onDocumentClick,this),this.renderComplete(),this.element.ownerDocument.defaultView.addEventListener("resize",this.onReportWindowSize,!0),t.EventHandler.add(this.element,"keydown",this.onMove,this)},L.prototype.onDocumentClick=function(e){e.target.classList.contains(d)||t.isNullOrUndefined(this.currentSeparator)||(this.currentSeparator.classList.remove(v),this.currentSeparator.classList.remove(P))},L.prototype.checkPaneSize=function(e){var i="Horizontal"===this.orientation?this.previousPane.offsetWidth:this.previousPane.offsetHeight,s="Horizontal"===this.orientation?this.nextPane.offsetWidth:this.nextPane.offsetHeight,n=t.isNullOrUndefined(this.separatorSize)?1:this.separatorSize;if(this.previousPane.style.flexBasis.indexOf("%")>0||this.nextPane.style.flexBasis.indexOf("%")>0){var a=this.updatePaneFlexBasis(this.previousPane),l=this.updatePaneFlexBasis(this.nextPane);this.totalPercent=a+l,this.totalWidth=this.convertPercentageToPixel(this.totalPercent+"%"),"keydown"!==e.type||t.isNullOrUndefined(e.keyCode)||((39===e.keyCode||40===e.keyCode)&&s>0&&this.getMinInPixel(this.paneSettings[this.nextPaneIndex].min)<this.convertPercentageToPixel(l-1+"%")?(this.previousPane.style.flexBasis=a+1+"%",this.nextPane.style.flexBasis=l-1+"%"):(37===e.keyCode||38===e.keyCode)&&i>0&&this.getMinInPixel(this.paneSettings[this.prevPaneIndex].min)<this.convertPercentageToPixel(a-1+"%")&&(this.previousPane.style.flexBasis=a-1+"%",this.nextPane.style.flexBasis=l+1+"%"))}else this.totalWidth="Horizontal"===this.orientation?this.previousPane.offsetWidth+this.nextPane.offsetWidth:this.previousPane.offsetHeight+this.nextPane.offsetHeight,"keydown"!==e.type||t.isNullOrUndefined(e.keyCode)||((39===e.keyCode||40===e.keyCode)&&s>0&&this.getMinInPixel(this.paneSettings[this.nextPaneIndex].min)<s+n?(this.addStaticPaneClass(),this.previousPane.style.flexBasis=i+n+"px",this.nextPane.style.flexBasis=s<n?"0px":s-n+"px"):(37===e.keyCode||38===e.keyCode)&&i>0&&this.getMinInPixel(this.paneSettings[this.prevPaneIndex].min)<i-n&&(this.addStaticPaneClass(),this.previousPane.style.flexBasis=i<n?"0px":i-n+"px",this.nextPane.style.flexBasis=s+n+"px"))},L.prototype.onMove=function(e){if(this.allPanes.length>1){var i=this.getSeparatorIndex(this.currentSeparator),s=this.previousPane.classList.contains(O),n=this.previousPane.classList.contains(E),a=this.nextPane.classList.contains(O);("Horizontal"!==this.orientation&&38===e.keyCode||"Horizontal"===this.orientation&&39===e.keyCode||"Horizontal"===this.orientation&&37===e.keyCode||"Horizontal"!==this.orientation&&40===e.keyCode)&&(!n&&!a&&!s||n&&!a)&&document.activeElement.classList.contains(d)&&this.paneSettings[i].resizable&&this.paneSettings[i+1].resizable?(e.preventDefault(),this.checkPaneSize(e),this.triggerResizing(e)):13===e.keyCode&&this.paneSettings[i].collapsible&&document.activeElement.classList.contains(d)&&this.currentSeparator.classList.contains(P)&&(this.previousPane.classList.contains(O)?(this.expand(i),t.addClass([this.currentSeparator],P)):(this.collapse(i),t.addClass([this.currentSeparator],P)))}},L.prototype.getMinInPixel=function(e){if(t.isNullOrUndefined(e))return 0;var i=this.convertPixelToNumber(e.toString());return e.indexOf("%")>0&&(i=this.convertPercentageToPixel(e)),this.convertPixelToNumber(i.toString())},L.prototype.sanitizeHelper=function(e){if(this.enableHtmlSanitizer){var i=t.SanitizeHtmlHelper.beforeSanitize();t.extend(i,i,{cancel:!1,helper:null}),this.trigger("beforeSanitizeHtml",i),i.cancel&&!t.isNullOrUndefined(i.helper)?e=i.helper(e):i.cancel||(e=t.SanitizeHtmlHelper.serializeValue(i,e))}return e},L.prototype.checkDataAttributes=function(){for(var e,i,s=0;s<this.validElementAttributes.length;s++)i=this.element.getAttribute(this.validElementAttributes[s]),t.isNullOrUndefined(i)||(this[e=this.removeDataPrefix(this.validElementAttributes[s])]=i);for(var n=0;n<this.element.children.length;n++)for(var a=0;a<this.validDataAttributes.length;a++)if(i=this.element.children[n].getAttribute(this.validDataAttributes[a]),!t.isNullOrUndefined(i)){i="collapsible"===(e=this.removeDataPrefix(this.validDataAttributes[a]))||"resizable"===e?"true"===i:i,t.isNullOrUndefined(this.paneSettings[n])&&(this.paneSettings[n]={size:"",min:null,max:null,content:"",resizable:!0,collapsible:!1,collapsed:!1});var l=this.paneSettings[n][e];"resizable"!==e&&"collapsible"!==e&&"collapsed"!==e||(this.paneSettings[n][e]=i),(t.isNullOrUndefined(l)||""===l)&&(this.paneSettings[n][e]=i)}},L.prototype.destroyPaneSettings=function(){[].slice.call(this.element.children).forEach(function(e){t.detach(e)}),this.restoreElem()},L.prototype.setPaneSettings=function(){for(var e=this.allPanes.length,i=[],s={size:"",min:null,max:null,content:"",resizable:!0,collapsed:!1,collapsible:!1,cssClass:""},n=0;n<e;n++)t.isNullOrUndefined(this.paneSettings[n])?i[n]=s:i[n]=this.paneSettings[n];this.setProperties({paneSettings:i},!0)},L.prototype.checkArrow=function(e,t){return this.allBars[e].querySelector("."+S+"."+t)},L.prototype.removeDataPrefix=function(e){return e.slice(e.lastIndexOf("-")+1)},L.prototype.setRTL=function(e){e?t.addClass([this.element],"e-rtl"):t.removeClass([this.element],"e-rtl")},L.prototype.setReversePane=function(){this.allPanes=this.allPanes.reverse(),this.allBars=this.allBars.reverse(),t.addClass([this.allBars[this.allBars.length-1]],H),t.removeClass([this.allBars[0]],H),this.setProperties({paneSettings:this.paneSettings.reverse()},!0),this.enableReversePanes?this.element.setAttribute("dir","rtl"):this.element.removeAttribute("dir")},L.prototype.setSplitterSize=function(e,i,s){var n="width"===s?{width:t.formatUnit(i)}:{height:t.formatUnit(i)};t.setStyleAttribute(e,n)},L.prototype.getPanesDimensions=function(){for(var e=0;e<this.allPanes.length;e++)"Horizontal"===this.orientation?this.panesDimensions.push(this.allPanes[e].getBoundingClientRect().width):this.panesDimensions.push(this.allPanes[e].getBoundingClientRect().height)},L.prototype.setCssClass=function(e,i){i&&t.addClass([e],i.split(i.indexOf(",")>-1?",":" "))},L.prototype.hideResizer=function(e){t.addClass([t.select("."+m,e)],y)},L.prototype.showResizer=function(e){!t.isNullOrUndefined(this.previousPane)&&this.previousPane.classList.contains(B)&&!t.isNullOrUndefined(this.nextPane)&&this.nextPane.classList.contains(B)&&t.removeClass([t.select("."+m,e)],y)},L.prototype.resizableModel=function(e,i){var s=e===this.allBars.length?e-1:e,n=e;t.EventHandler.remove(this.allBars[s],"mousedown",this.onMouseDown),i?(t.EventHandler.add(this.allBars[s],"mousedown",this.onMouseDown,this),this.isResizable()&&(this.showResizer(this.allBars[s]),t.removeClass([t.select("."+m,this.allBars[s])],y),this.allBars[s].classList.add(f),e===this.allBars.length?this.allPanes[e].classList.add(B):this.allPanes[s].classList.add(B),this.updateResizablePanes(n))):(this.updateResizablePanes(n),this.hideResizer(this.allBars[s]),this.allBars[s].classList.remove(f),e===this.allBars.length?this.allPanes[e].classList.remove(B):this.allPanes[s].classList.remove(B))},L.prototype.collapsibleModelUpdate=function(e){var t=e===this.allBars.length?e-1:e,i="Horizontal"===this.orientation?this.checkArrow(t,b):this.checkArrow(t,z),s="Horizontal"===this.orientation?this.checkArrow(t,w):this.checkArrow(t,A);this.paneCollapsible(this.allPanes[e],e),this.updateCollapseIcons(t,s,i)},L.prototype.collapseArrow=function(e,i){return t.selectAll("."+i,this.allBars[e])[0]},L.prototype.updateIsCollapsed=function(e,i,s){if(!t.isNullOrUndefined(e)){var n=e===this.allBars.length,a=n?e-1:e;(!n&&this.allPanes[e+1].classList.contains(O)&&0!==e?this.collapseArrow(a-1,s):n?this.collapseArrow(a,s):this.collapseArrow(a,i)).click()}},L.prototype.isCollapsed=function(e){var i=this;if(t.isNullOrUndefined(e)||!this.paneSettings[e].collapsed||!t.isNullOrUndefined(this.allPanes[e].classList.contains(O))){if(this.expandFlag=!1,t.isNullOrUndefined(e)){for(var s=0;s<this.allPanes.length;s++)!t.isNullOrUndefined(this.paneSettings[s])&&this.paneSettings[s].collapsed&&this.updateIsCollapsed(s,this.targetArrows().collapseArrow,this.targetArrows().lastBarArrow);for(s=this.allPanes.length-1;s>=0;s--)if(!t.isNullOrUndefined(this.paneSettings[s])&&this.paneSettings[s].collapsed&&!this.allPanes[s].classList.contains(O)){var n="Horizontal"===this.orientation?w:A;if(0!==s){this.collapseArrow(s-1,n).click()}if(!this.nextPane.classList.contains(O)){this.collapseArrow(s-1,n).click()}}}else{this.collapseFlag=!0;var a=e===this.allBars.length,l=a?e-1:e,r={target:!a&&this.allPanes[e+1].classList.contains(O)&&0!==e?this.collapseArrow(l-1,this.targetArrows().lastBarArrow):a?this.collapseArrow(l,this.targetArrows().lastBarArrow):this.collapseArrow(l,this.targetArrows().collapseArrow)},o=this.beforeAction(r);this.trigger("beforeCollapse",o,function(t){if(!t.cancel){var s=[];s[0]=e;for(var n=1,a=0;a<i.allPanes.length;a++)i.allPanes[a].classList.contains(O)&&(s[n]=a,n++);s=s.sort(),i.updateIsCollapsed(e,i.targetArrows().collapseArrow,i.targetArrows().lastBarArrow);for(a=0;a<s.length;a++)i.allPanes[s[a]].classList.contains(O)||i.updateIsCollapsed(s[a],i.targetArrows().collapseArrow,i.targetArrows().lastBarArrow);for(a=s.length;a>0;a--)if(!i.allPanes[s[a-1]].classList.contains(O)){var l=i.targetArrows();i.updateIsCollapsed(s[a-1],l.collapseArrow,l.lastBarArrow)}var o=i.afterAction(r);i.trigger("collapsed",o),i.collapseFlag=!1}})}this.expandFlag=!0}},L.prototype.targetArrows=function(){return this.splitterProperty(),{collapseArrow:"Horizontal"===this.orientation?b:z,lastBarArrow:"Vertical"===this.orientation?A:w}},L.prototype.collapsedOnchange=function(e){t.isNullOrUndefined(this.paneSettings[e])||t.isNullOrUndefined(this.paneSettings[e].collapsed)||!this.allPanes[e].classList.contains(O)||this.updateIsCollapsed(e,this.targetArrows().lastBarArrow,this.targetArrows().collapseArrow)},L.prototype.isEnabled=function(e){e?t.removeClass([this.element],C):t.addClass([this.element],C)},L.prototype.setSeparatorSize=function(e){for(var i=t.isNullOrUndefined(e)?"auto":e+"px",s="Horizontal"===this.orientation?p:c,n=0;n<this.allBars.length;n++){var a=t.selectAll("."+s,this.element)[n],l=t.selectAll("."+m,a)[0];"Horizontal"===this.orientation?(a.style.width=i,t.isNullOrUndefined(l)||(l.style.width=i)):(a.style.height=i,t.isNullOrUndefined(l)||(l.style.height=i))}},L.prototype.changeOrientation=function(e){var i="Vertical"===e;this.element.classList.remove(i?a:l),this.element.classList.add(i?l:a);for(var s=0;s<this.allPanes.length;s++)this.allPanes[s].classList.remove(i?o:h),this.allPanes[s].classList.add(i?h:o);for(s=0;s<this.allBars.length;s++)t.detach(this.allBars[s]);this.allBars=[],this.addSeparator(this.element)},L.prototype.checkSplitPane=function(e,t){return this.collectPanes(e.parentElement.children)[t]},L.prototype.collectPanes=function(e){for(var t=[],i=0;i<e.length;i++)e[i].classList.contains(r)&&t.push(e[i]);return t},L.prototype.getPrevPane=function(e){return this.enableReversePanes?this.getOrderPane(e+1):this.getOrderPane(e-1)},L.prototype.getNextPane=function(e){return this.enableReversePanes?this.getOrderPane(e-1):this.getOrderPane(e+1)},L.prototype.getOrderPane=function(e){for(var t,i=0;i<this.element.children.length;i++)parseInt(this.element.children[i].style.order,10)===e&&(t=this.element.children[i]);return t},L.prototype.getOrderIndex=function(e,t){var i,s;s="pane"===t?this.allPanes:this.allBars;for(var n=0;n<s.length;n++)parseInt(s[n].style.order,10)===e&&(i=n);return i},L.prototype.updateSeparatorSize=function(e){var i=t.isNullOrUndefined(this.separatorSize)?"1px":this.separatorSize+"px";"Horizontal"===this.orientation?e.style.width=i:e.style.height=i},L.prototype.addResizeHandler=function(e){var i=this.createElement("div");t.addClass([i],[m,"e-icons"]),this.updateSeparatorSize(i),e.appendChild(i)},L.prototype.getHeight=function(e){this.height;return""!==e.style.height&&"100%"===this.height?e.style.height:this.height},L.prototype.getWidth=function(e){this.width;return""!==e.style.width&&"100%"===this.width?e.style.width:this.width},L.prototype.setDimension=function(e,i){t.setStyleAttribute(this.element,{height:e,width:i})},L.prototype.updateCollapseIcons=function(e,i,s){t.isNullOrUndefined(this.paneSettings[e])||t.isNullOrUndefined(this.paneSettings[e].collapsible)||(this.paneSettings[e].collapsible?t.removeClass([s],[I]):t.addClass([s],[I]),t.isNullOrUndefined(this.paneSettings[e+1])||(this.paneSettings[e+1].collapsible?t.removeClass([i],[I]):t.addClass([i],[I])),t.isNullOrUndefined(this.paneSettings[e+1])||this.paneSettings[e+1].collapsible&&(this.paneSettings[e+1].collapsible?t.removeClass([i],[I]):t.addClass([i],[I])))},L.prototype.updateIconClass=function(){"Horizontal"===this.orientation?(this.leftArrow=b,this.rightArrow=w):(this.leftArrow=z,this.rightArrow=A)},L.prototype.createSeparator=function(e){var i=this.createElement("div");this.allBars.push(i);var s=this.createElement("button"),n=this.createElement("button");s.setAttribute("tabindex","-1"),n.setAttribute("tabindex","-1"),s.setAttribute("aria-label","Toggle navigation"),n.setAttribute("aria-label","Toggle navigation"),s.setAttribute("type","button"),n.setAttribute("type","button");var a=t.isNullOrUndefined(this.separatorSize)?"1px":this.separatorSize+"px",l=this;return"Horizontal"===this.orientation?(this.updateIconClass(),t.addClass([n],[S,b,I]),t.addClass([s],[S,w,I]),t.addClass([i],[d,p]),i.style.width=a):(t.addClass([s],[S,A,I]),t.addClass([n],[S,z,I]),t.addClass([i],[d,c]),this.updateIconClass(),i.style.height=a),this.addMouseActions(i),i.appendChild(n),this.addResizeHandler(i),i.appendChild(s),this.updateCollapseIcons(e,s,n),i.setAttribute("tabindex","0"),this.enableReversePanes?i.setAttribute("dir","ltr"):i.removeAttribute("dir"),i.addEventListener("focus",function(){i.classList.add(P),l.currentSeparator=i,l.getPaneDetails()}),i.addEventListener("blur",function(){i.classList.remove(P)}),i},L.prototype.updateResizablePanes=function(e){this.getPaneDetails(),this.isResizable()?this.allPanes[e].classList.add(B):this.allPanes[e].classList.remove(B)},L.prototype.addSeparator=function(e){for(var i,s=this.allPanes.length,n=e.children,a=0;a<s;a++)if(a<s-1){if(i=this.createSeparator(a),t.setStyleAttribute(i,{order:2*a+1}),this.separatorOrder.push(2*a+1),n[a].parentNode.appendChild(i),this.currentSeparator=i,i.setAttribute("role","separator"),i.setAttribute("aria-orientation",this.orientation.toLowerCase()),this.wireClickEvents(),!t.isNullOrUndefined(i))if(this.isResizable()){t.EventHandler.add(i,"mousedown",this.onMouseDown,this);var l="msie"===t.Browser.info.name?"pointerdown":"touchstart";t.EventHandler.add(i,l,this.onMouseDown,this),i.classList.add(f),this.updateResizablePanes(a)}else t.addClass([t.select("."+m,i)],y)}else i&&t.addClass([i],H),s>1&&this.updateResizablePanes(a);if("msie"===t.Browser.info.name){var r=this.element.querySelectorAll(".e-splitter .e-resize-handler");for(a=0;a<r.length;a++){var o=t.isNullOrUndefined(this.separatorSize)?1:this.separatorSize;r[a].style.paddingLeft=o/2+"px",r[a].style.paddingRight=o/2+"px"}}},L.prototype.isResizable=function(){var e=!1;return(!t.isNullOrUndefined(this.paneSettings[this.getPreviousPaneIndex()])&&this.paneSettings[this.getPreviousPaneIndex()].resizable&&!t.isNullOrUndefined(this.paneSettings[this.getNextPaneIndex()])&&this.paneSettings[this.getNextPaneIndex()].resizable||t.isNullOrUndefined(this.paneSettings[this.getNextPaneIndex()]))&&(e=!0),e},L.prototype.addMouseActions=function(e){var i,s,n=this;e.addEventListener("mouseenter",function(){i=setTimeout(function(){t.addClass([e],[v])},n.iconsDelay)}),e.addEventListener("mouseleave",function(){clearTimeout(i),t.removeClass([e],[v])}),e.addEventListener("mouseout",function(){clearTimeout(s)}),e.addEventListener("mouseover",function(){s=setTimeout(function(){t.addClass([e],[v])},n.iconsDelay)})},L.prototype.getEventType=function(e){return e.indexOf("mouse")>-1?"mouse":"touch"},L.prototype.updateCurrentSeparator=function(e){this.currentSeparator=this.isSeparator(e)?e.parentElement:e},L.prototype.isSeparator=function(e){return!e.classList.contains(d)},L.prototype.isMouseEvent=function(e){var i=!1;return("mouse"===this.getEventType(e.type)||!t.isNullOrUndefined(e.pointerType)&&"mouse"===this.getEventType(e.pointerType))&&(i=!0),i},L.prototype.updateCursorPosition=function(e,i){if(this.isMouseEvent(e))this.changeCoordinates({x:e.pageX,y:e.pageY},i);else{var s="msie"!==t.Browser.info.name?e.touches[0]:e;this.changeCoordinates({x:s.pageX,y:s.pageY},i)}},L.prototype.changeCoordinates=function(e,t){"previous"===t?this.previousCoordinates=e:this.currentCoordinates=e},L.prototype.reportWindowSize=function(){var e=this,i=this.allPanes.length;if(document.body.contains(this.element)){for(var s=0;s<i;s++)if(t.isNullOrUndefined(this.paneSettings[s].size)&&this.allPanes[s].classList.remove(u),i-1===s){this.element.querySelectorAll("."+u).length===i&&t.removeClass([this.allPanes[s]],u)}i>0&&setTimeout(function(){e.updateSplitterSize(!0)},200)}else document.defaultView.removeEventListener("resize",this.onReportWindowSize)},L.prototype.updateSplitterSize=function(e){for(var i=0,s=[],n=0,a=this.element.children,l=0;l<a.length;l++)i+="Horizontal"===this.orientation?a[l].offsetWidth:a[l].offsetHeight;for(var r=0;r<this.allBars.length;r++)i+="Horizontal"===this.orientation?parseInt(getComputedStyle(this.allBars[r]).marginLeft,10)+parseInt(getComputedStyle(this.allBars[r]).marginLeft,10):parseInt(getComputedStyle(this.allBars[r]).marginTop,10)+parseInt(getComputedStyle(this.allBars[r]).marginBottom,10);var o="Horizontal"===this.orientation?this.element.offsetWidth-(2*this.border+i):this.element.offsetHeight-(2*this.border+i);for(l=0;l<this.allPanes.length;l++)this.paneSettings[l].size||""===this.allPanes[l].innerText||(s[n]=l,n++);var h=o/s.length;for(r=0;r<s.length;r++)this.allPanes[s[r]].style.flexBasis="Horizontal"===this.orientation?this.allPanes[s[r]].offsetWidth+h+"px":this.allPanes[s[r]].offsetHeight+h+"px";if(2===this.allPanes.length&&e){var d=this.allPanes.length,p=void 0,c=void 0,u=void 0,g=void 0;for(l=0;l<d;l++)if(!t.isNullOrUndefined(this.paneSettings[l].min)&&(c=this.convertPixelToNumber(this.paneSettings[l].min.toString()),this.paneSettings[l].min.indexOf("%")>0&&(c=this.convertPercentageToPixel(this.paneSettings[l].min)),p=this.convertPixelToNumber(c.toString()),this.allPanes[l].offsetWidth<p)){0===l?(u=this.allPanes[l],g=this.allPanes[l+1]):(u=this.allPanes[l],g=this.allPanes[l-1]);var m=p-this.allPanes[l].offsetWidth,f=u.style.flexBasis.indexOf("%")>-1;u.style.flexBasis=f?this.convertPixelToPercentage(u.offsetWidth+m)+"%":u.offsetWidth+m+"px",g.style.flexBasis=g.style.flexBasis.indexOf("%")>-1?this.convertPixelToPercentage(g.offsetWidth-m)+"%":g.offsetWidth-m+"px"}}},L.prototype.wireResizeEvents=function(){document.addEventListener("mousemove",this.onMouseMoveHandler,!0),document.addEventListener("mouseup",this.onMouseUpHandler,!0);var e="msie"===t.Browser.info.name?"pointermove":"touchmove",i="msie"===t.Browser.info.name?"pointerup":"touchend";document.addEventListener(e,this.onTouchMoveHandler,!0),document.addEventListener(i,this.onTouchEndHandler,!0)},L.prototype.unwireResizeEvents=function(){this.element.ownerDocument.defaultView.removeEventListener("resize",this.onReportWindowSize);var e="msie"===t.Browser.info.name?"pointermove":"touchmove",i="msie"===t.Browser.info.name?"pointerup":"touchend";document.removeEventListener("mousemove",this.onMouseMoveHandler,!0),document.removeEventListener("mouseup",this.onMouseUpHandler,!0),document.removeEventListener(e,this.onTouchMoveHandler,!0),document.removeEventListener(i,this.onTouchEndHandler,!0)},L.prototype.wireClickEvents=function(){t.EventHandler.add(this.currentSeparator,"touchstart click",this.clickHandler,this)},L.prototype.clickHandler=function(e){if(!e.target.classList.contains(S)){var i=t.selectAll("."+n+" > ."+d+"."+v);i.length>0&&t.removeClass(i,v),e.target.classList.add(v)}var s=e.target;(s.classList.contains(b)||s.classList.contains(z))&&this.collapseAction(e),(s.classList.contains(w)||s.classList.contains(A))&&this.expandAction(e);for(var a=0,l=this.element.children,r=0;r<l.length;r++)a+="Horizontal"===this.orientation?l[r].offsetWidth:l[r].offsetHeight;a>this.element.offsetWidth&&this.updateSplitterSize()},L.prototype.expandAction=function(e){var t=this;this.splitterDetails(e);var i=this.beforeAction(e);this.expandFlag?this.trigger("beforeExpand",i,function(i){i.cancel||t.expandPane(e);var s=t.afterAction(e);t.trigger("expanded",s)}):this.expandPane(e)},L.prototype.expandPane=function(e){this.removeStaticPanes();var i=this.element.querySelectorAll("."+O).length,s=!this.previousPane.classList.contains(O)&&this.previousPane.classList.contains(u)&&!this.nextPane.classList.contains(O)&&!this.nextPane.classList.contains(E)&&this.nextPane.nextElementSibling.classList.contains(r)&&!this.nextPane.nextElementSibling.classList.contains(u)&&!(i===this.allPanes.length-2),n=[O,R];this.previousPane.classList.contains(O)?(t.removeClass([this.previousPane],n),t.removeClass([this.nextPane],E),this.expandFlag&&this.updatePaneSettings(this.prevPaneIndex,!1)):(t.removeClass([this.nextPane],E),t.removeClass([this.previousPane],n),t.addClass([this.previousPane],E),t.addClass([this.nextPane],n),this.expandFlag&&this.updatePaneSettings(this.nextPaneIndex,!0)),this.updateIconsOnExpand(e),this.previousPane.setAttribute("aria-expanded","true"),this.nextPane.setAttribute("aria-expanded","false"),this.updateFlexGrow(this.checkStaticPanes()),s&&(this.previousPane.classList.remove(E),this.previousPane.style.flexGrow="")},L.prototype.checkStaticPanes=function(){for(var e=!0,t=0;t<this.allPanes.length;t++)!this.allPanes[t].classList.contains(O)&&e&&(e=!!this.allPanes[t].classList.contains(u));return e},L.prototype.updateFlexGrow=function(e){for(var t=0,i=0;i<this.element.children.length;i++)this.element.children[i].classList.contains(O)&&(t+=1);for(var s=t===this.allPanes.length-2,n=this.allPanes,a=0;a<n.length;a++)n[a].classList.contains(E)?n[a].style.flexGrow="1":n[a].classList.contains(O)?n[a].style.flexGrow="0":n[a].style.flexGrow="",e&&!this.nextPane.classList.contains(O)&&(this.nextPane.style.flexGrow="1"),s&&!this.allPanes[a].classList.contains(O)&&this.paneSettings[a].size&&a!==this.allPanes.length-1&&(n[a].style.flexGrow="")},L.prototype.hideTargetBarIcon=function(e,i){t.addClass([t.select("."+i,e)],I)},L.prototype.showTargetBarIcon=function(e,i){t.removeClass([t.select("."+i,e)],I)},L.prototype.updateIconsOnCollapse=function(e){this.splitterProperty(),this.previousPane.classList.contains(O)&&!this.nextPane.classList.contains(O)?(t.addClass([e.target],I),this.paneSettings[this.prevPaneIndex].collapsible&&this.showCurrentBarIcon(),this.resizableModel(this.currentBarIndex,!1),!this.previousPane.classList.contains(O)||this.nextPane.classList.contains(O)||this.paneSettings[this.prevPaneIndex].collapsible||this.hideTargetBarIcon(this.prevBar,this.rightArrow),this.previousPane.previousElementSibling&&!this.previousPane.previousElementSibling.classList.contains(O)&&(this.previousPane.classList.contains(O)&&this.paneSettings[this.prevPaneIndex].collapsible?this.showTargetBarIcon(this.prevBar,this.leftArrow):this.paneSettings[this.prevPaneIndex].collapsible||this.hideTargetBarIcon(this.prevBar,this.leftArrow)),t.isNullOrUndefined(this.prevBar)||(this.resizableModel(this.currentBarIndex-1,!1),this.hideTargetBarIcon(this.prevBar,this.arrow)),this.paneSettings[this.prevPaneIndex].collapsible||this.hideTargetBarIcon(this.currentSeparator,this.rightArrow)):this.splitInstance.prevPaneCollapsed||this.splitInstance.nextPaneExpanded||(this.paneSettings[this.currentBarIndex].resizable&&this.resizableModel(this.currentBarIndex,!0),!this.splitInstance.nextPaneNextEle.classList.contains(O)&&this.paneSettings[this.currentBarIndex+1].resizable&&this.resizableModel(this.currentBarIndex+1,!0),this.paneSettings[this.currentBarIndex].collapsible||t.addClass([e.target],I),this.previousPane&&0===this.prevPaneIndex&&this.paneSettings[this.prevPaneIndex].collapsible&&this.showTargetBarIcon(this.currentSeparator,this.leftArrow),this.nextPane&&this.nextPaneIndex===this.allPanes.length-1&&this.paneSettings[this.nextPaneIndex].collapsible&&this.showTargetBarIcon(this.getPrevBar(this.nextPaneIndex),this.rightArrow),!this.previousPane.classList.contains(O)&&this.paneSettings[this.nextPaneIndex].collapsible&&this.showTargetBarIcon(this.currentSeparator,this.rightArrow),t.isNullOrUndefined(this.nextBar)||(this.nextPane.nextElementSibling&&this.nextPane.nextElementSibling.classList.contains(O)&&this.paneSettings[this.nextPaneIndex+1].collapsible||!this.nextPane.nextElementSibling.classList.contains(O)&&this.paneSettings[this.nextPaneIndex].collapsible?this.showTargetBarIcon(this.nextBar,this.leftArrow):!this.paneSettings[this.splitInstance.nextPaneIndex+1].collapsible&&this.paneSettings[this.currentBarIndex]&&this.hideTargetBarIcon(this.nextBar,this.arrow)),this.nextPaneIndex===this.allPanes.length-1||!this.nextPane.nextElementSibling||this.nextPane.classList.contains(O)||this.nextPane.nextElementSibling.classList.contains(O)||this.paneSettings[this.nextPaneIndex+1].collapsible||this.hideTargetBarIcon(this.nextBar,this.rightArrow))},L.prototype.collapseAction=function(e){var t=this;this.splitterDetails(e);var i=this.beforeAction(e);this.collapseFlag?this.collapsePane(e):this.trigger("beforeCollapse",i,function(i){if(!i.cancel){t.collapsePane(e);var s=t.afterAction(e);t.trigger("collapsed",s)}})},L.prototype.collapsePane=function(e){this.removeStaticPanes();var i=this.element.querySelectorAll("."+O).length,s=this.previousPane.classList.contains(u)&&!this.previousPane.classList.contains(O)&&!this.nextPane.classList.contains(O)&&this.nextPane.nextElementSibling.classList.contains(r)&&!this.nextPane.nextElementSibling.classList.contains(u)&&!this.nextPane.nextElementSibling.classList.contains(O)&&!(i===this.allPanes.length-2)||this.nextPane.classList.contains(O)&&!this.previousPane.classList.contains(u)&&this.nextPane.classList.contains(u),n=[O,R];this.nextPane.classList.contains(O)?(t.removeClass([this.previousPane],E),t.removeClass([this.nextPane],n),this.collapseFlag||this.updatePaneSettings(this.nextPaneIndex,!1)):(t.removeClass([this.previousPane],E),t.removeClass([this.nextPane],n),t.addClass([this.nextPane],E),t.addClass([this.previousPane],n),this.collapseFlag||this.updatePaneSettings(this.prevPaneIndex,!0)),this.updateIconsOnCollapse(e),this.previousPane.setAttribute("aria-expanded","false"),this.nextPane.setAttribute("aria-expanded","true"),this.updateFlexGrow(this.checkStaticPanes()),s&&(this.nextPane.classList.remove(E),this.nextPane.style.flexGrow="")},L.prototype.removeStaticPanes=function(){for(var e=0;e<this.allPanes.length;e++)t.isNullOrUndefined(this.paneSettings[e].size)&&this.allPanes[e].classList.remove(u)},L.prototype.beforeAction=function(e){return{element:this.element,event:e,pane:[this.previousPane,this.nextPane],index:[this.prevPaneIndex,this.nextPaneIndex],separator:this.currentSeparator,cancel:!1}},L.prototype.updatePaneSettings=function(e,t){var i=this.paneSettings;i[e].collapsed=t,this.setProperties({paneSettings:i},!0)},L.prototype.splitterProperty=function(){this.splitInstance={currentBarIndex:this.currentBarIndex,nextPaneCollapsible:this.nextPane.classList.contains(x),prevPaneCollapsible:this.previousPane.classList.contains(x),prevPaneExpanded:this.previousPane.classList.contains(E),nextPaneExpanded:this.nextPane.classList.contains(E),nextPaneCollapsed:this.nextPane.classList.contains(O),prevPaneCollapsed:this.previousPane.classList.contains(O),nextPaneIndex:this.getNextPaneIndex(),prevPaneIndex:this.getPreviousPaneIndex(),nextPaneNextEle:this.nextPane.nextElementSibling,prevPanePreEle:this.previousPane.previousElementSibling}},L.prototype.showCurrentBarIcon=function(){t.removeClass([t.select("."+this.arrow,this.currentSeparator)],I)},L.prototype.updateIconsOnExpand=function(e){this.splitterProperty(),t.addClass([e.target],I),this.splitInstance.prevPaneExpanded||this.splitInstance.nextPaneCollapsed?this.splitInstance.prevPaneExpanded&&this.splitInstance.nextPaneCollapsed&&(this.resizableModel(this.currentBarIndex,!1),this.resizableModel(this.currentBarIndex+1,!1),this.paneSettings[this.nextPaneIndex].collapsible&&this.showCurrentBarIcon(),t.isNullOrUndefined(this.nextBar)||this.hideTargetBarIcon(this.nextBar,this.arrow),this.nextPane&&this.nextPaneIndex===this.allPanes.length-1&&!this.paneSettings[this.nextPaneIndex].collapsible&&this.splitInstance.nextPaneCollapsed&&this.hideTargetBarIcon(this.currentSeparator,this.arrow),this.nextPaneIndex!==this.allPanes.length-1&&this.nextPane.nextElementSibling&&this.nextPane.classList.contains(O)&&!this.nextPane.nextElementSibling.classList.contains(O)&&this.paneSettings[this.nextPaneIndex].collapsible&&this.showTargetBarIcon(this.nextBar,this.rightArrow)):(this.paneSettings[this.prevPaneIndex].collapsible&&this.showCurrentBarIcon(),this.paneSettings[this.nextPaneIndex].collapsible&&t.removeClass([e.target],I),this.paneSettings[this.currentBarIndex].resizable&&this.resizableModel(this.currentBarIndex,!0),t.isNullOrUndefined(this.prevBar)||this.splitInstance.prevPanePreEle.classList.contains(O)?(this.previousPane.previousElementSibling&&this.paneSettings[this.prevPaneIndex].collapsible&&this.previousPane.previousElementSibling.classList.contains(O)&&this.paneSettings[this.prevPaneIndex-1].collapsible&&this.showTargetBarIcon(this.prevBar,this.rightArrow),this.paneSettings[this.currentBarIndex+1].collapsible||this.hideTargetBarIcon(this.currentSeparator,this.rightArrow)):(this.paneSettings[this.currentBarIndex-1].resizable&&this.resizableModel(this.currentBarIndex-1,!0),this.paneSettings[this.prevPaneIndex].collapsible&&this.showTargetBarIcon(this.prevBar,this.rightArrow),this.paneSettings[this.currentBarIndex-1].collapsible?this.paneSettings[this.currentBarIndex].collapsible&&!this.paneSettings[this.currentBarIndex+1].collapsible&&this.hideTargetBarIcon(this.currentSeparator,this.rightArrow):(this.hideTargetBarIcon(this.prevBar,this.arrow),this.paneSettings[this.currentBarIndex].collapsible&&!this.paneSettings[this.currentBarIndex+1].collapsible&&this.hideTargetBarIcon(this.currentSeparator,this.rightArrow))))},L.prototype.afterAction=function(e){return{element:this.element,event:e,pane:[this.previousPane,this.nextPane],index:[this.prevPaneIndex,this.nextPaneIndex],separator:this.currentSeparator}},L.prototype.currentIndex=function(e){this.currentBarIndex=this.getOrderIndex(parseInt(e.target.parentElement.style.order,10),"splitbar")},L.prototype.getSeparatorIndex=function(e){var t=[].slice.call(this.allBars);return(t=this.enableReversePanes?t.reverse():t).indexOf(e)},L.prototype.getPrevBar=function(e){return this.allBars[e-1]},L.prototype.getNextBar=function(e){return this.allBars[e+1]},L.prototype.updateBars=function(e){this.prevBar=this.getPrevBar(e),this.nextBar=this.getNextBar(e)},L.prototype.splitterDetails=function(e){"Horizontal"===this.orientation?this.arrow=e.target.classList.contains(b)?w:b:this.arrow=e.target.classList.contains(z)?A:z,this.updateCurrentSeparator(e.target),this.currentIndex(e),this.updateBars(this.currentBarIndex),this.getPaneDetails()},L.prototype.triggerResizing=function(e){var t={element:this.element,event:e,pane:[this.previousPane,this.nextPane],index:[this.prevPaneIndex,this.nextPaneIndex],paneSize:[this.prePaneDimenson,this.nextPaneDimension],separator:this.currentSeparator};this.trigger("resizing",t)},L.prototype.onMouseDown=function(e){var i=this;e.preventDefault();var s=e.target;if(!s.classList.contains(S)){this.updateCurrentSeparator(s),t.addClass([this.currentSeparator],P),this.updateCursorPosition(e,"previous"),this.getPaneDetails();for(var n={element:this.element,event:e,pane:[this.previousPane,this.nextPane],index:[this.getPreviousPaneIndex(),this.getNextPaneIndex()],separator:this.currentSeparator,cancel:!1},a=0;a<this.element.querySelectorAll("iframe").length;a++)this.element.querySelectorAll("iframe")[a].style.pointerEvents="none";this.trigger("resizeStart",n,function(t){t.cancel||(i.wireResizeEvents(),i.checkPaneSize(e))})}},L.prototype.updatePaneFlexBasis=function(e){var t;if(e.style.flexBasis.indexOf("%")>0)t=this.removePercentageUnit(e.style.flexBasis);else if(""!==e.style.flexBasis)t=this.convertPixelToPercentage(this.convertPixelToNumber(e.style.flexBasis));else{var i="Horizontal"===this.orientation?e.offsetWidth:e.offsetHeight;t=this.convertPixelToPercentage(i)}return t},L.prototype.removePercentageUnit=function(e){return parseFloat(e.slice(0,e.indexOf("%")))},L.prototype.convertPercentageToPixel=function(e,i){var s,n=e.toString();if(n.indexOf("%")>-1){s=parseFloat(n.slice(0,n.indexOf("%")));var a=void 0;a=t.isNullOrUndefined(i)?"Horizontal"===this.orientation?this.element.offsetWidth:this.element.offsetHeight:this.panesDimensions[this.allPanes.indexOf(i)],s=Math.ceil(a*(s/100))}else s=parseInt(n,10);return s},L.prototype.convertPixelToPercentage=function(e){return e/("Horizontal"===this.orientation?this.element.offsetWidth:this.element.offsetHeight)*100},L.prototype.convertPixelToNumber=function(e){return e.indexOf("p")>-1?parseFloat(e.slice(0,e.indexOf("p"))):parseFloat(e)},L.prototype.calcDragPosition=function(e,t){var i;return i=("Horizontal"===this.orientation?this.currentCoordinates.x-e:this.currentCoordinates.y-e)/t,(i=i>1?1:i<0?0:i)*t},L.prototype.getSeparatorPosition=function(e){this.updateCursorPosition(e,"current");var t="Horizontal"===this.orientation?this.element.getBoundingClientRect().left+window.scrollX:this.element.getBoundingClientRect().top+window.scrollY,i="Horizontal"===this.orientation?this.element.offsetWidth:this.element.offsetHeight;return this.calcDragPosition(t,i)},L.prototype.getMinMax=function(e,i,s){var n="min"===s?0:null,a=null;return"min"===s?t.isNullOrUndefined(this.paneSettings[e])||t.isNullOrUndefined(this.paneSettings[e].min)||(a=this.paneSettings[e].min):t.isNullOrUndefined(this.paneSettings[e])||t.isNullOrUndefined(this.paneSettings[e].max)||(a=this.paneSettings[e].max),this.paneSettings.length>0&&!t.isNullOrUndefined(this.paneSettings[e])&&!t.isNullOrUndefined(a)?(a.indexOf("%")>0&&(a=this.convertPercentageToPixel(a).toString()),this.convertPixelToNumber(a)):n},L.prototype.getPreviousPaneIndex=function(){var e=this.enableReversePanes?parseInt(this.currentSeparator.style.order,10)+1:parseInt(this.currentSeparator.style.order,10)-1;return this.getOrderIndex(e,"pane")},L.prototype.getNextPaneIndex=function(){var e=this.enableReversePanes?parseInt(this.currentSeparator.style.order,10)-1:parseInt(this.currentSeparator.style.order,10)+1;return this.getOrderIndex(e,"pane")},L.prototype.getPaneDetails=function(){var e=null,t=null;this.order=parseInt(this.currentSeparator.style.order,10),this.allPanes.length>1&&(e=this.getPrevPane(this.order),t=this.getNextPane(this.order)),e&&t&&(this.previousPane=e,this.nextPane=t,this.prevPaneIndex=this.getPreviousPaneIndex(),this.nextPaneIndex=this.getNextPaneIndex())},L.prototype.getPaneHeight=function(e){return"Horizontal"===this.orientation?e.offsetWidth.toString():e.offsetHeight.toString()},L.prototype.isValidSize=function(e){var i=!1;return!t.isNullOrUndefined(this.paneSettings[e])&&!t.isNullOrUndefined(this.paneSettings[e].size)&&this.paneSettings[e].size.indexOf("%")>-1&&(i=!0),i},L.prototype.getPaneDimensions=function(){this.previousPaneHeightWidth=""===this.previousPane.style.flexBasis?this.getPaneHeight(this.previousPane):this.previousPane.style.flexBasis,this.nextPaneHeightWidth=""===this.nextPane.style.flexBasis?this.getPaneHeight(this.nextPane):this.nextPane.style.flexBasis,this.isValidSize(this.prevPaneIndex)&&(this.previousPaneHeightWidth=this.convertPercentageToPixel(this.previousPaneHeightWidth).toString(),this.updatePrePaneInPercentage=!0),this.isValidSize(this.nextPaneIndex)&&(this.nextPaneHeightWidth=this.convertPercentageToPixel(this.nextPaneHeightWidth).toString(),this.updateNextPaneInPercentage=!0),this.prePaneDimenson=this.convertPixelToNumber(this.previousPaneHeightWidth.toString()),this.nextPaneDimension=this.convertPixelToNumber(this.nextPaneHeightWidth.toString())},L.prototype.checkCoordinates=function(e,t){var i=!0;return e!==this.previousCoordinates.x&&t!==this.previousCoordinates.y||(i=!1),i},L.prototype.isCursorMoved=function(e){return"mouse"===this.getEventType(e.type)||!t.isNullOrUndefined(e.pointerType)&&"mouse"===this.getEventType(e.pointerType)?this.checkCoordinates(e.pageX,e.pageY):"msie"!==t.Browser.info.name?this.checkCoordinates(e.touches[0].pageX,e.touches[0].pageY):this.checkCoordinates(e.pageX,e.pageY)},L.prototype.getBorder=function(){this.border=0;var e="Horizontal"===this.orientation?(this.element.offsetWidth-this.element.clientWidth)/2:(this.element.offsetHeight-this.element.clientHeight)/2;this.border="chrome"!==t.Browser.info.name?this.border:e},L.prototype.onMouseMove=function(e){if(this.isCursorMoved(e)){this.getPaneDetails(),this.getPaneDimensions(),this.triggerResizing(e);var t,i=this.validateDraggedPosition(this.getSeparatorPosition(e),this.prePaneDimenson,this.nextPaneDimension);if(this.getBorder(),t="Horizontal"===this.orientation?this.element.getBoundingClientRect().left+i-this.currentSeparator.getBoundingClientRect().left+this.border:this.element.getBoundingClientRect().top+i-this.currentSeparator.getBoundingClientRect().top+this.border,this.nextPaneHeightWidth="string"==typeof this.nextPaneHeightWidth&&this.nextPaneHeightWidth.indexOf("p")>-1?this.convertPixelToNumber(this.nextPaneHeightWidth):parseInt(this.nextPaneHeightWidth,10),this.prevPaneCurrentWidth=t+this.convertPixelToNumber(this.previousPaneHeightWidth),this.nextPaneCurrentWidth=this.nextPaneHeightWidth-t,this.validateMinMaxValues(),this.nextPaneCurrentWidth<0&&(this.nextPaneCurrentWidth=0),this.prevPaneCurrentWidth<0&&(this.prevPaneCurrentWidth=0),this.nextPaneCurrentWidth+this.prevPaneCurrentWidth>this.totalWidth&&(this.nextPaneCurrentWidth<this.prevPaneCurrentWidth?this.prevPaneCurrentWidth=this.prevPaneCurrentWidth-(this.nextPaneCurrentWidth+this.prevPaneCurrentWidth-this.totalWidth):this.nextPaneCurrentWidth=this.nextPaneCurrentWidth-(this.nextPaneCurrentWidth+this.prevPaneCurrentWidth-this.totalWidth)),this.nextPaneCurrentWidth+this.prevPaneCurrentWidth<this.totalWidth){var s=this.totalWidth-(this.nextPaneCurrentWidth+this.prevPaneCurrentWidth);this.nextPaneCurrentWidth=this.nextPaneCurrentWidth+s}this.calculateCurrentDimensions(),this.addStaticPaneClass(),this.previousPane.style.flexBasis=this.prevPaneCurrentWidth,this.nextPane.style.flexBasis=this.nextPaneCurrentWidth,this.allPanes.length>2||this.updateSplitterSize()}},L.prototype.validateMinRange=function(e,i,s){var n,a,l=null,r=0;return t.isNullOrUndefined(this.paneSettings[e])||t.isNullOrUndefined(this.paneSettings[e].min)||(l=this.paneSettings[e].min.toString()),t.isNullOrUndefined(l)||(l.indexOf("%")>0&&(l=this.convertPercentageToPixel(l).toString()),i<(n=this.convertPixelToNumber(l))&&(r=i-n<=0?0:i-n,this.totalWidth=this.totalWidth-r,this.totalPercent=this.convertPixelToPercentage(this.totalWidth),a=n)),t.isNullOrUndefined(a)?i:a},L.prototype.validateMaxRange=function(e,i,s){var n,a,l=null;return t.isNullOrUndefined(this.paneSettings[e])||t.isNullOrUndefined(this.paneSettings[e].max)||(l=this.paneSettings[e].max.toString()),t.isNullOrUndefined(l)||(l.indexOf("%")>0&&(l=this.convertPercentageToPixel(l).toString()),i>(n=this.convertPixelToNumber(l))&&(this.totalWidth=this.totalWidth-(i-n),this.totalPercent=this.convertPixelToPercentage(this.totalWidth),a=n)),t.isNullOrUndefined(a)?i:a},L.prototype.validateMinMaxValues=function(){this.prevPaneCurrentWidth=this.validateMinRange(this.prevPaneIndex,this.prevPaneCurrentWidth,this.previousPane),this.nextPaneCurrentWidth=this.validateMinRange(this.nextPaneIndex,this.nextPaneCurrentWidth,this.nextPane),this.prevPaneCurrentWidth=this.validateMaxRange(this.prevPaneIndex,this.prevPaneCurrentWidth,this.previousPane),this.nextPaneCurrentWidth=this.validateMaxRange(this.nextPaneIndex,this.nextPaneCurrentWidth,this.nextPane)},L.prototype.equatePaneWidths=function(){var e;this.prevPaneCurrentWidth+this.nextPaneCurrentWidth>this.totalPercent&&(e=this.prevPaneCurrentWidth+this.nextPaneCurrentWidth-this.totalPercent,this.prevPaneCurrentWidth=this.prevPaneCurrentWidth-e/2+"%",this.nextPaneCurrentWidth=this.nextPaneCurrentWidth-e/2+"%"),this.prevPaneCurrentWidth+this.nextPaneCurrentWidth<this.totalPercent&&(e=this.totalPercent-(this.prevPaneCurrentWidth+this.nextPaneCurrentWidth),this.prevPaneCurrentWidth=this.prevPaneCurrentWidth+e/2+"%",this.nextPaneCurrentWidth=this.nextPaneCurrentWidth+e/2+"%")},L.prototype.calculateCurrentDimensions=function(){this.updatePrePaneInPercentage||this.updateNextPaneInPercentage?(this.prevPaneCurrentWidth=Math.round(Number(Math.round(10*this.convertPixelToPercentage(this.prevPaneCurrentWidth))/10)),this.nextPaneCurrentWidth=Math.round(Number(Math.round(10*this.convertPixelToPercentage(this.nextPaneCurrentWidth))/10)),0===this.prevPaneCurrentWidth&&(this.nextPaneCurrentWidth=this.totalPercent),0===this.nextPaneCurrentWidth&&(this.prevPaneCurrentWidth=this.totalPercent),this.prevPaneCurrentWidth+this.nextPaneCurrentWidth!==this.totalPercent?this.equatePaneWidths():(this.prevPaneCurrentWidth=this.prevPaneCurrentWidth+"%",this.nextPaneCurrentWidth=this.nextPaneCurrentWidth+"%"),this.prevPaneCurrentWidth=this.updatePrePaneInPercentage?this.prevPaneCurrentWidth:this.convertPercentageToPixel(this.prevPaneCurrentWidth)+"px",this.nextPaneCurrentWidth=this.updateNextPaneInPercentage?this.nextPaneCurrentWidth:this.convertPercentageToPixel(this.nextPaneCurrentWidth)+"px",this.updatePrePaneInPercentage=!1,this.updateNextPaneInPercentage=!1):(this.prevPaneCurrentWidth=this.prevPaneCurrentWidth+"px",this.nextPaneCurrentWidth=this.nextPaneCurrentWidth+"px")},L.prototype.addStaticPaneClass=function(){this.previousPane.classList.contains(u)||this.previousPane.classList.add(u),this.nextPane.classList.contains(u)||this.nextPane.classList.add(u)},L.prototype.validateDraggedPosition=function(e,i,s){var n="Horizontal"===this.orientation?this.currentSeparator.offsetLeft+window.scrollX:this.currentSeparator.offsetTop,a=n-i,l=s+n,r=this.getMinMax(this.prevPaneIndex,this.previousPane,"min"),o=this.getMinMax(this.nextPaneIndex,this.nextPane,"min"),h=this.getMinMax(this.prevPaneIndex,this.previousPane,"max"),d=this.getMinMax(this.nextPaneIndex,this.nextPane,"max"),p=e;return e>l-o?p=l-o:e<a+r&&(p=a+r),t.isNullOrUndefined(h)?t.isNullOrUndefined(d)||e<l-d&&(p=l-d):e>a+h&&(p=a+h),p},L.prototype.onMouseUp=function(e){t.removeClass([this.currentSeparator],P),this.unwireResizeEvents();for(var i={event:e,element:this.element,pane:[this.previousPane,this.nextPane],index:[this.prevPaneIndex,this.nextPaneIndex],separator:this.currentSeparator,paneSize:[this.prePaneDimenson,this.nextPaneDimension]},s=0;s<this.element.querySelectorAll("iframe").length;s++)this.element.querySelectorAll("iframe")[s].style.pointerEvents="auto";if(this.trigger("resizeStop",i),this.enablePersistence){var n=this.paneSettings;n[this.getPreviousPaneIndex()].size=this.allPanes[this.getPreviousPaneIndex()].style.flexBasis,n[this.getNextPaneIndex()].size=this.allPanes[this.getNextPaneIndex()].style.flexBasis,this.setProperties({paneSettings:n},!0)}},L.prototype.panesDimension=function(e,i){var s,n=i.length;parseInt(this.getHeight(this.element),10),t.isNullOrUndefined(this.paneSettings[e])?t.setStyleAttribute(i[e],{order:2*e}):t.isNullOrUndefined(this.paneSettings[e].size)?(this.sizeFlag=!0,t.setStyleAttribute(i[e],{order:2*e})):(s=this.paneSettings[e].size,e<n&&(t.setStyleAttribute(i[e],{"flex-basis":s,order:2*e}),e<n-1&&""!==this.paneSettings[e].size?t.addClass([i[e]],u):this.sizeFlag||(i[e].style.flexBasis=null),e===n-1&&this.sizeFlag&&""!==this.paneSettings[e].size&&t.addClass([i[e]],u))),this.paneOrder.push(2*e)},L.prototype.setTemplate=function(e,t){t.innerHTML="",e="string"==typeof e?this.sanitizeHelper(e):e,this.templateCompile(t,e),this.isReact&&this.renderReactTemplates()},L.prototype.templateCompile=function(e,t){var i=this.createElement("div");this.compileElement(i,t,"content"),0!==i.childNodes.length&&[].slice.call(i.childNodes).forEach(function(t){e.appendChild(t)})},L.prototype.compileElement=function(e,i,s){if("string"==typeof i)if("."===i[0]||"#"===i[0]){var n=document.querySelector(i);if(!t.isNullOrUndefined(n))return this.templateElement.push(n),"none"===n.style.display&&n.style.removeProperty("display"),""===n.getAttribute("style")&&n.removeAttribute("style"),void e.appendChild(n);i=i.trim()}else i=i.trim();var a;a=t.isNullOrUndefined(i.outerHTML)?t.compile(i):t.compile(i.outerHTML);var l;t.isNullOrUndefined(a)||(l=a({},this,s,this.element.id+"content"+this.allPanes.length.toString(),!0)),!t.isNullOrUndefined(a)&&l&&l.length>0&&[].slice.call(l).forEach(function(t){e.appendChild(t)})},L.prototype.paneCollapsible=function(e,i){this.paneSettings[i].collapsible?t.addClass([e],x):t.removeClass([e],x)},L.prototype.createSplitPane=function(e){for(var i=e.children.length,s=0;s<this.paneSettings.length;s++)if(i<this.paneSettings.length){var n=this.createElement("div");this.element.appendChild(n),i+=1}i=e.children.length;var a=[].slice.call(e.children);if(this.sizeFlag=!1,i>0)for(s=0;s<i;s++)"DIV"!==a[s].nodeName&&"SPAN"!==a[s].nodeName||(this.allPanes.push(a[s]),"Horizontal"===this.orientation?(t.addClass([a[s]],[r,o,g]),this.panesDimension(s,a)):(t.addClass([a[s]],[r,h,g]),this.panesDimension(s,a)),t.isNullOrUndefined(this.paneSettings[s])||t.isNullOrUndefined(this.paneSettings[s].content)||this.setTemplate(this.paneSettings[s].content,a[s]),!t.isNullOrUndefined(this.paneSettings[s])&&this.paneSettings[s].cssClass&&this.setCssClass(a[s],this.paneSettings[s].cssClass),t.isNullOrUndefined(this.paneSettings[s])||this.paneCollapsible(a[s],s))},L.prototype.expand=function(e){this.collapsedOnchange(e),this.updatePaneSettings(e,!1)},L.prototype.collapse=function(e){this.isCollapsed(e),this.updatePaneSettings(e,!0)},L.prototype.destroy=function(){if(!this.isDestroyed){for(e.prototype.destroy.call(this),t.EventHandler.remove(document,"touchstart click",this.onDocumentClick),this.element.ownerDocument.defaultView.removeEventListener("resize",this.onReportWindowSize,!0);this.element.attributes.length>0;)this.element.removeAttribute(this.element.attributes[0].name);this.element.innerHTML=this.wrapper.innerHTML;for(var i=0;i<this.wrapper.attributes.length;i++)this.element.setAttribute(this.wrapper.attributes[i].name,this.wrapper.attributes[i].value);this.refreshing&&(t.addClass([this.element],["e-control","e-lib",n]),this.allBars=[],this.allPanes=[]),this.restoreElem(),this.isReact&&this.clearTemplate()}},L.prototype.restoreElem=function(){if(this.templateElement.length>0)for(var e=0;e<this.templateElement.length;e++)this.templateElement[e].style.display="none",document.body.appendChild(this.templateElement[e])},L.prototype.addPaneClass=function(e){return"Horizontal"===this.orientation?t.addClass([e],[r,o,g]):t.addClass([e],[r,h,g]),e},L.prototype.removePaneOrders=function(e){for(var t=this.element.childNodes,i=[],s=0;t.length<0;s++)t[s].classList.contains(e)&&i.push(t[s]);for(s=0;s<i.length;s++)i[s].style.removeProperty("order")},L.prototype.setPaneOrder=function(){for(var e=0;e<this.allPanes.length;e++)this.panesDimension(e,this.allPanes)},L.prototype.removeSeparator=function(){for(var e=0;e<this.allBars.length;e++)t.detach(this.allBars[e]);this.allBars=[]},L.prototype.updatePanes=function(){this.setPaneOrder(),this.removeSeparator(),this.addSeparator(this.element)},L.prototype.addPane=function(e,i){var s=this.createElement("div");s=this.addPaneClass(s),i=i>this.allPanes.length+1?this.allPanes.length:i;var n={size:t.isNullOrUndefined(e.size)?"":e.size,min:t.isNullOrUndefined(e.min)?null:e.min,max:t.isNullOrUndefined(e.max)?null:e.max,content:t.isNullOrUndefined(e.content)?"":e.content,resizable:!!t.isNullOrUndefined(e.resizable)||e.resizable,collapsible:!t.isNullOrUndefined(e.collapsible)&&e.collapsible,collapsed:!t.isNullOrUndefined(e.collapsed)&&e.collapsed,cssClass:t.isNullOrUndefined(e.cssClass)?"":e.cssClass};this.paneSettings.splice(i,0,n),this.setProperties({paneSettings:this.paneSettings},!0),"Horizontal"===this.orientation?(this.element.insertBefore(s,this.element.querySelectorAll("."+o)[i]),this.removePaneOrders(o)):(this.element.insertBefore(s,this.element.querySelectorAll("."+h)[i]),this.removePaneOrders(h)),this.allPanes.splice(i,0,s),this.updatePanes(),this.setTemplate(this.paneSettings[i].content,s),this.setCssClass(this.allPanes[i],e.cssClass),this.allPanes[this.allPanes.length-1].classList.remove(u)},L.prototype.removePane=function(e){e=e>this.allPanes.length+1?this.allPanes.length:e;var i="Horizontal"===this.orientation?o:h;t.isNullOrUndefined(this.element.querySelectorAll("."+i)[e])||(t.detach(this.element.querySelectorAll("."+i)[e]),this.allPanes.splice(e,1),this.removePaneOrders(i),this.updatePanes(),this.paneSettings.splice(e,1),this.setProperties({paneSettings:this.paneSettings},!0),this.allPanes.length>0&&this.allPanes[this.allPanes.length-1].classList.remove(u))},s([t.Property("100%")],L.prototype,"height",void 0),s([t.Property(!1)],L.prototype,"enableReversePanes",void 0),s([t.Property("100%")],L.prototype,"width",void 0),s([t.Property(!1)],L.prototype,"enablePersistence",void 0),s([t.Collection([],M)],L.prototype,"paneSettings",void 0),s([t.Property("Horizontal")],L.prototype,"orientation",void 0),s([t.Property("")],L.prototype,"cssClass",void 0),s([t.Property(!0)],L.prototype,"enabled",void 0),s([t.Property(!0)],L.prototype,"enableHtmlSanitizer",void 0),s([t.Property(null)],L.prototype,"separatorSize",void 0),s([t.Event()],L.prototype,"beforeSanitizeHtml",void 0),s([t.Event()],L.prototype,"created",void 0),s([t.Event()],L.prototype,"resizeStart",void 0),s([t.Event()],L.prototype,"resizing",void 0),s([t.Event()],L.prototype,"resizeStop",void 0),s([t.Event()],L.prototype,"beforeCollapse",void 0),s([t.Event()],L.prototype,"beforeExpand",void 0),s([t.Event()],L.prototype,"collapsed",void 0),s([t.Event()],L.prototype,"expanded",void 0),L=s([t.NotifyPropertyChanges],L)}(t.Component),W=function(){var e=function(t,i){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i])})(t,i)};return function(t,i){function s(){this.constructor=t}e(t,i),t.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}}(),k=function(e,t,i,s){var n,a=arguments.length,l=a<3?t:null===s?s=Object.getOwnPropertyDescriptor(t,i):s;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)l=Reflect.decorate(e,t,i,s);else for(var r=e.length-1;r>=0;r--)(n=e[r])&&(l=(a<3?n(l):a>3?n(t,i,l):n(t,i))||l);return a>3&&l&&Object.defineProperty(t,i,l),l},X="e-prevent",Y="e-dragging",T="e-drag",N="e-responsive",D="e-panel-content",U="e-panel-container",j="e-panel-header",V=function(e){function i(){return null!==e&&e.apply(this,arguments)||this}return W(i,e),k([t.Property("")],i.prototype,"id",void 0),k([t.Property("")],i.prototype,"cssClass",void 0),k([t.Property("")],i.prototype,"header",void 0),k([t.Property("")],i.prototype,"content",void 0),k([t.Property(!0)],i.prototype,"enabled",void 0),k([t.Property(0)],i.prototype,"row",void 0),k([t.Property(0)],i.prototype,"col",void 0),k([t.Property(1)],i.prototype,"sizeX",void 0),k([t.Property(1)],i.prototype,"sizeY",void 0),k([t.Property(1)],i.prototype,"minSizeY",void 0),k([t.Property(1)],i.prototype,"minSizeX",void 0),k([t.Property(null)],i.prototype,"maxSizeY",void 0),k([t.Property(null)],i.prototype,"maxSizeX",void 0),k([t.Property(1e3)],i.prototype,"zIndex",void 0),i}(t.ChildProperty),q=function(e){function i(i,s){var n=e.call(this,i,s)||this;return n.rows=1,n.panelID=0,n.movePanelCalled=!1,n.resizeCalled=!1,n.mOffX=0,n.mOffY=0,n.maxTop=9999,n.maxRows=100,n.mouseX=0,n.mouseY=0,n.minTop=0,n.minLeft=0,n.isInlineRendering=!1,n.removeAllCalled=!1,n.isPanelRemoved=!1,n.panelsSizeY=0,n.resizeHeight=!1,t.setValue("mergePersistData",n.mergePersistPanelData,n),n}return W(i,e),i.prototype.preRender=function(){this.panelCollection=[],this.sortedArray=[],this.gridPanelCollection=[],this.overlapElement=[],this.overlapElementClone=[],this.overlapSubElementClone=[],this.collisionChecker={},this.dragCollection=[],this.elementRef={top:"",left:"",height:"",width:""},this.dimensions=[],this.allItems=[],this.oldRowCol={},this.availableClasses=[],this.setOldRowCol(),this.calculateCellSize(),this.contentTemplateChild=[].slice.call(this.element.children)},i.prototype.setOldRowCol=function(){for(var e=0;e<this.panels.length;e++)this.panels[e].id||(this.panelPropertyChange(this.panels[e],{id:"layout_"+this.panelID.toString()}),this.panelID=this.panelID+1),this.oldRowCol[this.panels[e].id]={row:this.panels[e].row,col:this.panels[e].col}},i.prototype.createPanelElement=function(e,i){var s=this.createElement("div");return e&&e.length>0&&t.addClass([s],e),i&&s.setAttribute("id",i),s},i.prototype.render=function(){this.initialize(),this.isRenderComplete=!0,this.showGridLines&&!this.checkMediaQuery()&&this.initGridLines(),this.updateDragArea(),this.renderComplete(),this.renderReactTemplates()},i.prototype.initGridLines=function(){this.table=document.createElement("table");var e=document.createElement("tbody");this.table.classList.add("e-dashboard-gridline-table");for(var t=0;t<this.maxRow();t++){for(var i=document.createElement("tr"),s=0;s<this.columns;s++){var n=document.createElement("td");n.classList.add("e-dashboard-gridline"),this.setAttributes({value:{row:t.toString(),col:s.toString(),sizeX:"1",sizeY:"1"}},n),n.setAttribute("id",""+s),this.setPanelPosition(n,t,s),this.setHeightAndWidth(n,{row:t,col:s,sizeX:1,sizeY:1}),i.appendChild(n)}e.appendChild(i)}this.table.appendChild(e),this.element.appendChild(this.table),this.renderReactTemplates()},i.prototype.initialize=function(){if(this.updateRowHeight(),this.element.childElementCount>0&&this.element.querySelectorAll(".e-panel").length>0){var e=[];this.setProperties({panels:[]},!0),this.isInlineRendering=!0;for(var i=0;i<this.element.querySelectorAll(".e-panel").length;i++)e.push(this.element.querySelectorAll(".e-panel")[i]);for(i=0;i<e.length;i++){var s=e[i];this.enableRtl&&t.addClass([s],"e-rtl"),this.getInlinePanels(s),this.maxCol(),this.maxRow()}for(i=0;i<this.panels.length;i++){s=this.element.querySelector("#"+this.panels[i].id);if(this.setMinMaxValues(this.panels[i]),this.maxColumnValue<this.panels[i].col||this.maxColumnValue<this.panels[i].col+this.panels[i].sizeX){var n=this.maxColumnValue-this.panels[i].sizeX;this.panelPropertyChange(this.panels[i],{col:n<0?0:n})}this.setXYAttributes(s,this.panels[i]);var a=this.renderPanels(s,this.panels[i],this.panels[i].id,!1);this.panelCollection.push(a),this.setHeightAndWidth(s,this.panels[i]),this.tempObject=this,this.mediaQuery&&!window.matchMedia("("+this.mediaQuery+")").matches&&(this.setPanelPosition(s,this.panels[i].row,this.panels[i].col),this.mainElement=s,this.updatePanelLayout(s,this.panels[i]),this.mainElement=null),this.setClasses([s])}this.updateOldRowColumn(),this.checkMediaQuery()&&this.checkMediaQuerySizing()}else this.renderDashBoardCells(this.panels);!this.allowDragging||this.mediaQuery&&window.matchMedia("("+this.mediaQuery+")").matches||this.enableDraggingContent(this.panelCollection),this.sortedPanel(),this.bindEvents(),this.updatePanels(),this.updateCloneArrayObject(),this.checkColumnValue=this.maxColumnValue,this.checkMediaQuery()||this.panelResponsiveUpdate(),this.setEnableRtl()},i.prototype.checkMediaQuery=function(){return this.mediaQuery&&window.matchMedia("("+this.mediaQuery+")").matches},i.prototype.calculateCellSize=function(){this.cellSize=[],this.checkMediaQuery()?this.cellSize[1]=this.element.parentElement&&this.element.parentElement.offsetWidth/this.cellAspectRatio:(this.cellSize[0]=this.element.parentElement&&this.element.parentElement.offsetWidth,this.cellSize[0]=this.element.parentElement&&(this.element.parentElement.offsetWidth-(this.maxCol()-1)*this.cellSpacing[0])/this.maxCol(),this.cellSize[1]=this.cellSize[0]/this.cellAspectRatio)},i.prototype.maxRow=function(e){var i=1;if(this.rows>1&&t.isNullOrUndefined(e))return i=this.rows;for(var s=0;s<this.panels.length;s++)this.panels[s].sizeY+this.panels[s].row>i&&(i=this.panels[s].sizeY+this.panels[s].row);return 0===this.panels.length&&(i=this.columns),i},i.prototype.maxCol=function(){var e=1;return e=this.columns,this.maxColumnValue=e,e},i.prototype.updateOldRowColumn=function(){for(var e=0;e<this.panels.length;e++){var t=this.panels[e].id;if(document.getElementById(t)){var i=parseInt(document.getElementById(t).getAttribute("data-row"),10),s=parseInt(document.getElementById(t).getAttribute("data-col"),10);this.oldRowCol[this.panels[e].id]={row:i,col:s}}}},i.prototype.createSubElement=function(e,i,s){var n=this.createElement("div");return s&&t.addClass([n],[s]),e&&e.length>0&&t.addClass([n],e),i&&n.setAttribute("id",i),n},i.prototype.templateParser=function(e){if(e)try{if(document.querySelectorAll(e).length)return t.compile(document.querySelector(e).innerHTML.trim())}catch(s){var i=t.SanitizeHtmlHelper.sanitize(e);return t.compile(this.enableHtmlSanitizer&&"string"==typeof e?i:e)}},i.prototype.renderTemplate=function(e,i,s,n,a){var l=this.templateParser(e),r=[];if("."!==e[0]&&"#"!==e[0]||"SCRIPT"===document.querySelector(e).tagName){var o=l({},this,a,s,n,null,i);if(o){for(var h=0,d=o;h<d.length;h++){var p=d[h];r.push(p)}t.append([].slice.call(r),i)}}else{var c=document.querySelector(e);if(!t.isNullOrUndefined(c))return"none"===c.style.display&&c.style.removeProperty("display"),""===c.getAttribute("style")&&c.removeAttribute("style"),void i.appendChild(c);e=e.trim()}},i.prototype.renderPanels=function(e,i,s,n){t.addClass([e],["e-panel","e-panel-transition"]);var a=i.cssClass?i.cssClass.split(" "):null;if(this.panelContent=e.querySelector(".e-panel-container")?e.querySelector(".e-panel-container"):this.createSubElement(a,e.id+"_content",U),e.appendChild(this.panelContent),i.enabled||this.disablePanel(e),i.header){var l=e.querySelector(".e-panel-header")?e.querySelector(".e-panel-header"):this.createSubElement([],e.id+"template","");if(t.addClass([l],[j]),!e.querySelector(".e-panel-header")){var r=this.element.id+"HeaderTemplate"+s;this.renderTemplate(i.header,l,r,n,"header"),this.panelContent.appendChild(l),this.renderReactTemplates()}}if(i.content){var o=i.cssClass?i.cssClass.split(" "):null;this.panelBody=e.querySelector(".e-panel-content")?e.querySelector(".e-panel-content"):this.createSubElement(o,e.id+"_body",D);var h="calc( 100% - "+(this.panelContent.querySelector(".e-panel-header")?window.getComputedStyle(this.panelContent.querySelector(".e-panel-header")).height:"0px")+")";if(t.setStyleAttribute(this.panelBody,{height:h}),!e.querySelector(".e-panel-content")){r=this.element.id+"ContentTemplate"+s;this.renderTemplate(i.content,this.panelBody,r,n,"content"),this.panelContent.appendChild(this.panelBody),this.renderReactTemplates()}}return e},i.prototype.disablePanel=function(e){t.addClass([e],["e-disabled"])},i.prototype.getInlinePanels=function(e){var i={sizeX:e.hasAttribute("data-sizex")?parseInt(e.getAttribute("data-sizex"),10):1,sizeY:e.hasAttribute("data-sizey")?parseInt(e.getAttribute("data-sizey"),10):1,minSizeX:e.hasAttribute("data-minsizex")?parseInt(e.getAttribute("data-minsizex"),10):1,minSizeY:e.hasAttribute("data-minsizey")?parseInt(e.getAttribute("data-minsizey"),10):1,maxSizeX:e.hasAttribute("data-maxsizex")?parseInt(e.getAttribute("data-maxsizex"),10):null,maxSizeY:e.hasAttribute("data-maxsizey")?parseInt(e.getAttribute("data-maxsizey"),10):null,row:e.hasAttribute("data-row")?parseInt(e.getAttribute("data-row"),10):0,col:e.hasAttribute("data-col")?parseInt(e.getAttribute("data-col"),10):0,id:e.getAttribute("id"),zIndex:e.hasAttribute("data-zindex")?parseInt(e.getAttribute("data-zIndex"),10):1e3,header:e.querySelector(".e-panel-header")&&".e-panel-header",content:e.querySelector(".e-panel-content")&&".e-panel-content"};i.id||(i.id="layout_"+this.panelID.toString(),e.setAttribute("id",i.id),this.panelID=this.panelID+1),t.isUndefined(i.enabled)&&(i.enabled=!0),e.style.zIndex=""+i.zIndex;var s=new V(this,"panels",i,!0);this.panels.push(s)},i.prototype.resizeEvents=function(){if(this.allowResizing)for(var e=this.element.querySelectorAll(".e-panel .e-panel-container .e-resize"),i=0;i<e.length;i++){var s="msie"===t.Browser.info.name?"mousedown pointerdown":"mousedown";t.EventHandler.add(e[i],s,this.downResizeHandler,this),"msie"!==t.Browser.info.name&&t.EventHandler.add(e[i],"touchstart",this.touchDownResizeHandler,this)}},i.prototype.bindEvents=function(){this.refreshListener=this.refresh.bind(this),t.EventHandler.add(window,"resize",this.refreshListener),this.resizeEvents()},i.prototype.downResizeHandler=function(e){this.downHandler(e),this.lastMouseX=e.pageX,this.lastMouseY=e.pageY;var i="msie"===t.Browser.info.name?"mousemove pointermove":"mousemove",s="msie"===t.Browser.info.name?"mouseup pointerup":"mouseup";this.isMouseMoveBound||(t.EventHandler.add(document,i,this.moveResizeHandler,this),this.isMouseMoveBound=!0),this.isMouseUpBound||(t.EventHandler.add(document,s,this.upResizeHandler,this),this.isMouseUpBound=!0)},i.prototype.downHandler=function(e){this.resizeCalled=!1,this.panelsInitialModel=this.cloneModels(this.panels);var i=t.closest(e.currentTarget,".e-panel"),s={event:e,element:i,isInteracted:!0};this.trigger("resizeStart",s),this.downTarget=e.currentTarget,this.shadowEle=document.createElement("div"),this.shadowEle.classList.add("e-holder"),t.addClass([this.element],[X]),this.element.appendChild(this.shadowEle),this.renderReactTemplates(),this.elementX=parseFloat(i.style.left),this.elementY=parseFloat(i.style.top),this.elementWidth=i.offsetWidth,this.elementHeight=i.offsetHeight,this.originalWidth=this.getCellInstance(i.id).sizeX,this.originalHeight=this.getCellInstance(i.id).sizeY,this.previousRow=this.getCellInstance(i.id).row},i.prototype.touchDownResizeHandler=function(e){this.downHandler(e),this.lastMouseX=e.changedTouches[0].pageX,this.lastMouseY=e.changedTouches[0].pageY,this.isMouseMoveBound||(t.EventHandler.add(document,"touchmove",this.touchMoveResizeHandler,this),this.isMouseMoveBound=!0),this.isMouseUpBound||(t.EventHandler.add(document,"touchend",this.upResizeHandler,this),this.isMouseUpBound=!0)},i.prototype.getCellSize=function(){return[this.cellSize[0],this.cellSize[1]]},i.prototype.updateMaxTopLeft=function(e){this.moveTarget=this.downTarget;var i={event:e,element:t.closest(this.moveTarget,".e-panel"),isInteracted:!0};this.trigger("resize",i)},i.prototype.updateResizeElement=function(e){this.maxLeft=this.element.offsetWidth-1,this.maxTop=this.cellSize[1]*this.maxRows-1,t.removeClass([e],"e-panel-transition"),t.addClass([e],[Y]);for(var i=["e-east","e-west","e-north","e-south","e-south-east","e-north-east","e-north-west","e-south-west"],s=0;s<this.moveTarget.classList.length;s++)-1!==i.indexOf(this.moveTarget.classList[s])&&(this.handleClass=this.moveTarget.classList[s])},i.prototype.moveResizeHandler=function(e){this.updateMaxTopLeft(e);var i=t.closest(this.moveTarget,".e-panel");if(this.lastMouseX!==e.pageX&&this.lastMouseY!==e.pageY){this.updateResizeElement(i);var s=this.getCellInstance(i.getAttribute("id"));this.mouseX=e.pageX,this.mouseY=e.pageY;var n=this.mouseY-this.lastMouseY+this.mOffY,a=this.mouseX-this.lastMouseX+this.mOffX;this.mOffX=this.mOffY=0,this.lastMouseY=this.mouseY,this.lastMouseX=this.mouseX,this.resizingPanel(i,s,a,n)}},i.prototype.touchMoveResizeHandler=function(e){this.updateMaxTopLeft(e);var i=t.closest(this.moveTarget,".e-panel");if(this.lastMouseX!==e.changedTouches[0].pageX&&this.lastMouseY!==e.changedTouches[0].pageY){this.updateResizeElement(i);var s=this.getCellInstance(i.getAttribute("id"));this.mouseX=e.changedTouches[0].pageX,this.mouseY=e.changedTouches[0].pageY;var n=this.mouseX-this.lastMouseX+this.mOffX,a=this.mouseY-this.lastMouseY+this.mOffY;this.mOffX=this.mOffY=0,this.lastMouseX=this.mouseX,this.lastMouseY=this.mouseY,this.resizingPanel(i,s,n,a)}},i.prototype.resizingPanel=function(e,t,i,s){var n=this.getCellInstance(e.id).sizeX,a=this.getCellInstance(e.id).sizeY,l=s,r=i;this.handleClass.indexOf("north")>=0&&(this.elementHeight-l<this.getMinHeight(t)?(s=this.elementHeight-this.getMinHeight(t),this.mOffY=l-s):t.maxSizeY&&this.elementHeight-l>this.getMaxHeight(t)?(s=this.elementHeight-this.getMaxHeight(t),this.mOffY=l-s):this.elementY+l<this.minTop&&(s=this.minTop-this.elementY,this.mOffY=l-s),this.elementY+=s,this.elementHeight-=s),this.handleClass.indexOf("south")>=0&&(this.elementHeight+l<this.getMinHeight(t)?(s=this.getMinHeight(t)-this.elementHeight,this.mOffY=l-s):t.maxSizeY&&this.elementHeight+l>this.getMaxHeight(t)&&(s=this.getMaxHeight(t)-this.elementHeight,this.mOffY=l-s),this.elementHeight+=s),this.handleClass.indexOf("west")>=0&&(this.elementWidth-r<this.getMinWidth(t)?(i=this.elementWidth-this.getMinWidth(t),this.mOffX=r-i):t.maxSizeX&&this.elementWidth-r>this.getMaxWidth(t)?(i=this.elementWidth-this.getMaxWidth(t),this.mOffX=r-i):this.elementX+r<this.minLeft&&(i=this.minLeft-this.elementX,this.mOffX=r-i),this.elementX+=i,this.elementWidth-=i),this.handleClass.indexOf("east")>=0&&(this.elementWidth+r<this.getMinWidth(t)?(i=this.getMinWidth(t)-this.elementWidth,this.mOffX=r-i):t.maxSizeX&&this.elementWidth+r>this.getMaxWidth(t)&&(i=this.getMaxWidth(t)-this.elementWidth,this.mOffX=r-i),this.elementWidth+=i),e.style.top=this.elementY+"px",e.style.left=this.elementX+"px",e.style.width=this.elementWidth+"px",e.style.height=this.elementHeight+"px";var o=this.getResizeRowColumn(t);if(o.col+o.sizeX>this.columns&&this.panelPropertyChange(o,{sizeX:o.sizeX-1}),this.shadowEle.style.top=o.row*this.getCellSize()[1]+o.row*this.cellSpacing[1]+"px",this.shadowEle.style.left=o.col*this.getCellSize()[0]+o.col*this.cellSpacing[0]+"px",this.shadowEle.style.height=o.sizeY*(this.getCellSize()[1]+this.cellSpacing[1])+"px",this.shadowEle.style.width=o.sizeX*(this.getCellSize()[0]+this.cellSpacing[0])+"px",n!==o.sizeX||a!==o.sizeY){n=o.sizeX,a=o.sizeY;var h=this.getCellInstance(e.id),d={attributes:{row:h.row.toString(),col:h.col.toString(),sizeX:h.sizeX.toString(),sizeY:h.sizeY.toString()}};this.setAttributes(d,e),this.mainElement=e,this.updatePanelLayout(e,this.getCellInstance(e.id)),this.updateOldRowColumn(),this.sortedPanel()}},i.prototype.upResizeHandler=function(e){if(!t.isNullOrUndefined(this.downTarget)){this.upTarget=this.downTarget;var i=t.closest(this.upTarget,".e-panel"),s={event:e,element:i,isInteracted:!0};if(i){t.addClass([i],"e-panel-transition");var n="msie"===t.Browser.info.name?"mousemove pointermove":"mousemove",a="msie"===t.Browser.info.name?"mouseup pointerup":"mouseup";t.EventHandler.remove(document,n,this.moveResizeHandler),t.EventHandler.remove(document,a,this.upResizeHandler),"msie"!==t.Browser.info.name&&(t.EventHandler.remove(document,"touchmove",this.touchMoveResizeHandler),t.EventHandler.remove(document,"touchend",this.upResizeHandler)),this.isMouseUpBound=!1,this.isMouseMoveBound=!1,this.shadowEle&&t.detach(this.shadowEle),this.shadowEle=null;var l=this.getCellInstance(i.getAttribute("id"));this.setPanelPosition(i,l.row,l.col),this.setHeightAndWidth(i,l)}t.removeClass([i],[Y]),this.trigger("resizeStop",s),this.resizeCalled=!1,this.lastMouseX=this.lastMouseY=void 0,this.mOffX=this.mOffY=0,this.mainElement=null,this.allowFloating&&this.moveItemsUpwards(),this.updatePanels(),this.updateCloneArrayObject(),this.checkForChanges(!0)}},i.prototype.getResizeRowColumn=function(e){var t=!1,i=e.col;-1!==["e-west","e-south-west"].indexOf(this.handleClass)&&(i=this.pixelsToColumns(this.elementX,!1));var s=e.row;-1!==["e-north"].indexOf(this.handleClass)&&(s=this.pixelsToRows(this.elementY,!1),this.previousRow!==s&&(this.previousRow=s,t=!0));var n=e.sizeX;-1===["e-north","e-south"].indexOf(this.handleClass)&&(n=this.pixelsToColumns(this.elementWidth-n*this.cellSpacing[1],!0));var a=e.sizeY;-1===["e-east","e-west"].indexOf(this.handleClass)&&("e-north"!==this.handleClass||t)&&(a=this.pixelsToRows(this.elementHeight-a*this.cellSpacing[0],!0)),e.col+e.sizeX>this.columns&&(e.sizeX=e.sizeX-1);return(s>-1&&i>-1&&n+i<=this.maxCol()&&a+s<=this.maxRow()&&0===this.collisions(s,i,n,a,this.getPanelBase(e.id)).length||!1!==this.allowPushing)&&this.panelPropertyChange(e,{row:s,col:i,sizeX:n,sizeY:a}),e},i.prototype.pixelsToColumns=function(e,t){var i=this.cellSize[0];return t?Math.ceil(e/i):Math.floor(e/i)},i.prototype.pixelsToRows=function(e,t){return t?Math.round(e/this.cellSize[1]):Math.round(e/(this.cellSize[1]+this.cellSpacing[0]))},i.prototype.getMinWidth=function(e){return e.minSizeX*this.getCellSize()[0]},i.prototype.getMaxWidth=function(e){return e.maxSizeX*this.getCellSize()[0]},i.prototype.getMinHeight=function(e){return e.minSizeY*this.getCellSize()[1]},i.prototype.getMaxHeight=function(e){return e.maxSizeY*this.getCellSize()[1]},i.prototype.sortedPanel=function(){this.sortedArray=[];for(var e=0,t=this.panelCollection.length;e<t;++e)this.sortItem(this.panelCollection[e])},i.prototype.moveItemsUpwards=function(){if(!1!==this.allowFloating){for(var e=0,t=this.sortedArray.length;e<t;++e){var i=this.sortedArray[e];if(i)for(var s=0,n=i.length;s<n;++s){var a=i[s];a&&this.moveItemUpwards(a)}}this.updateGridLines()}},i.prototype.moveItemUpwards=function(e){if(!1!==this.allowFloating&&e!==this.mainElement){for(var t=this.getCellInstance(e.id).col,i=parseInt(e.getAttribute("data-sizeY"),10),s=parseInt(e.getAttribute("data-sizeX"),10),n=null,a=null,l=parseInt(e.getAttribute("data-row"),10)-1;l>-1;){if(0!==this.collisions(l,t,s,i,e).length)break;n=l,a=t,--l}null!==n&&this.sortItem(e,n,a)}},i.prototype.sortItem=function(e,t,i){this.overlapElement=[];var s=parseInt(e.getAttribute("data-col"),10),n=parseInt(e.getAttribute("data-row"),10);if(this.sortedArray[n]||(this.sortedArray[n]=[]),this.sortedArray[n][s]=e,void 0!==e&&void 0!==t&&void 0!==i){if(void 0!==this.oldRowCol[e.id]&&null!==this.oldRowCol[e.id].row&&void 0!==this.oldRowCol[e.id].col){var a=this.sortedArray[this.oldRowCol[e.id].row];this.oldRowCol[e.id]&&a[this.oldRowCol[e.id].col]===e&&(delete a[this.oldRowCol[e.id].col],this.updateOldRowColumn(),this.sortedPanel())}this.oldRowCol[e.id].row=t,this.oldRowCol[e.id].row=i,this.sortedArray[n]||(this.sortedArray[n]=[]),this.sortedArray[n][s]=e,-1===this.allItems.indexOf(e)&&this.allItems.push(e),this.panelPropertyChange(this.getCellInstance(e.id),{row:t,col:i});var l=this.getCellInstance(e.id);this.setAttributes({value:{col:l.col.toString(),row:l.row.toString()}},e),this.updateLayout(e,this.getCellInstance(e.id))}},i.prototype.updateLayout=function(e,t){this.setPanelPosition(e,t.row,t.col),this.setHeightAndWidth(e,t),this.updateRowHeight(),this.sortedPanel()},i.prototype.refresh=function(){if(this.panelsSizeY=0,this.updateDragArea(),this.checkMediaQuery())this.checkMediaQuerySizing();else{if(this.element.classList.contains(N)){t.removeClass([this.element],[N]);for(var e=this.element.querySelectorAll((this.element.id?"#"+this.element.id+" > ":"")+".e-panel"),i=0;i<e.length;i++){var s=e[i],n=this.getCellInstance(s.id),a=parseInt(s.getAttribute("data-row"),10),l=parseInt(s.getAttribute("data-col"),10);this.panelPropertyChange(n,{row:a,col:l}),this.setHeightAndWidth(s,this.getCellInstance(s.id)),this.setPanelPosition(s,a,l),this.updateRowHeight()}}this.panelResponsiveUpdate(),this.updateGridLines()}this.removeResizeClasses(this.panelCollection),this.setClasses(this.panelCollection),this.resizeEvents(),this.checkDragging(this.dragCollection)},i.prototype.updateGridLines=function(){this.element.querySelector(".e-dashboard-gridline-table")&&(this.table&&t.detach(this.table),this.initGridLines())},i.prototype.checkDragging=function(e){if(this.checkMediaQuery()||!this.allowDragging)for(var t=0;t<e.length;t++)e[t].destroy();else{for(t=0;t<e.length;t++)e[t].destroy();this.enableDraggingContent(this.panelCollection)}},i.prototype.sortPanels=function(){for(var e=[],t=function(t){for(var s=function(s){i.panels.filter(function(i){i.row===t&&i.col===s&&e.push(i)})},n=0;n<i.columns;n++)s(n)},i=this,s=0;s<=this.rows;s++)t(s);return e},i.prototype.checkMediaQuerySizing=function(){t.addClass([this.element],[N]);var e;e=this.isPanelRemoved&&this.panels?this.panels:this.sortPanels(),this.updatedRows=e.length;for(var i=0;i<e.length;i++){var s=document.getElementById(e[i].id),n=void 0;s&&(t.setStyleAttribute(s,{width:"100%"}),s.style.height=" "+(this.element.parentElement&&this.element.parentElement.offsetWidth/this.cellAspectRatio)*e[i].sizeY+"px",e[i].sizeY>1&&(n=(this.element.parentElement&&this.element.parentElement.offsetWidth/this.cellAspectRatio)*e[i].sizeY+parseInt((Math.round(e[i].sizeY/2)*this.cellSpacing[1]).toString(),0),s.style.height=n+"px"),this.resizeHeight=!0,this.panelPropertyChange(e[i],{row:i,col:0}),this.setPanelPosition(s,e[i].row,e[i].col),this.panelsSizeY=this.panelsSizeY+e[i].sizeY,this.setClasses(this.panelCollection),this.checkDragging(this.dragCollection),this.removeResizeClasses(this.panelCollection))}this.updateRowHeight()},i.prototype.panelResponsiveUpdate=function(){this.element.classList.add("e-responsive"),this.calculateCellSize();for(var e=0;e<this.element.querySelectorAll(".e-panel").length;e++){var t=this.element.querySelectorAll(".e-panel")[e],i=this.getCellInstance(t.id);this.setHeightAndWidth(t,i)}for(e=0;e<this.panels.length;e++)this.setPanelPosition(document.getElementById(this.panels[e].id),this.panels[e].row,this.panels[e].col);this.updateRowHeight()},i.prototype.updateRowHeight=function(){this.getRowColumn(),this.setHeightWidth()},i.prototype.setHeightWidth=function(){var e,i;e=this.checkMediaQuery()?this.maxRow()*(this.element.parentElement&&this.element.parentElement.offsetWidth/this.cellAspectRatio)+(this.maxRow()-1)*this.cellSpacing[1]+"px":this.maxRow()*(this.cellSize[0]/this.cellAspectRatio)+(this.maxRow()-1)*this.cellSpacing[1]+"px",t.setStyleAttribute(this.element,{height:e}),i=window.getComputedStyle(this.element).width,t.setStyleAttribute(this.element,{width:i})},i.prototype.setHeightAndWidth=function(e,i){t.setStyleAttribute(e,{height:t.formatUnit(this.setXYDimensions(i)[0])}),t.setStyleAttribute(e,{width:t.formatUnit(this.setXYDimensions(i)[1])})},i.prototype.renderCell=function(e,i,s){var n;this.dimensions=this.setXYDimensions(e),t.isUndefined(e.enabled)&&(e.enabled=!0),this.contentTemplateChild.length>0&&!t.isNullOrUndefined(s)?(n=this.contentTemplateChild[s],e.cssClass&&t.addClass([n],[e.cssClass]),e.id&&n.setAttribute("id",e.id)):n=this.createPanelElement(e.cssClass?e.cssClass.split(" "):null,e.id),n.style.zIndex=""+e.zIndex,this.element.appendChild(n),this.renderReactTemplates();var a=this.renderPanels(n,e,e.id,i);return this.panelCollection.push(a),this.setXYAttributes(n,e),this.setHeightAndWidth(n,e),n},i.prototype.setPanelPosition=function(e,i,s){if(e){this.checkMediaQuery()&&this.calculateCellSize();var n=this.getCellSize()[1],a=this.getCellSize()[0],l=0===s?0:s*(a+this.cellSpacing[0]),r=0===i?0:i*(n+this.cellSpacing[1]);this.checkMediaQuery()&&(r=0===i?0:this.panelsSizeY*(n+this.cellSpacing[1])),t.setStyleAttribute(e,{left:l+"px",top:r+"px"})}},i.prototype.getRowColumn=function(){if(this.rows=null,this.element.querySelectorAll(".e-panel").length>0&&!this.updatedRows)for(var e=this.element.querySelectorAll(".e-panel"),t=0;t<e.length;t++){var i=e[t],s=parseInt(i.getAttribute("data-row"),10),n=parseInt(i.getAttribute("data-sizeY"),10);this.rows=Math.max(this.rows,s+n)}else{this.updatedRows&&(this.rows=this.updatedRows,this.updatedRows=null);for(t=0;t<this.panels.length;t++)this.rows=Math.max(this.rows,this.panels[t].row)}},i.prototype.setMinMaxValues=function(e){!e.sizeX||e.sizeX<e.minSizeX?this.panelPropertyChange(e,{sizeX:e.minSizeX}):e.maxSizeX&&e.sizeX>e.maxSizeX?this.panelPropertyChange(e,{sizeX:e.maxSizeX}):e.sizeX>this.columns?this.panelPropertyChange(e,{sizeX:this.columns}):this.panelPropertyChange(e,{sizeX:e.sizeX}),!e.sizeY||e.sizeY<e.minSizeY?this.panelPropertyChange(e,{sizeY:e.minSizeY}):e.maxSizeY&&e.sizeY>e.maxSizeY?this.panelPropertyChange(e,{sizeY:e.maxSizeY}):this.panelPropertyChange(e,{sizeY:e.sizeY})},i.prototype.checkMinMaxValues=function(e){e.col+e.sizeX>this.columns&&this.panelPropertyChange(e,{sizeX:e.sizeX+(this.columns-(e.col+e.sizeX))})},i.prototype.panelPropertyChange=function(e,t){e.setProperties(t,!0)},i.prototype.renderDashBoardCells=function(e){if(this.element.querySelectorAll(".e-panel").length>0||this.panels.length>0)for(var i=0;i<e.length;i++){this.gridPanelCollection.push(e[i]),this.setMinMaxValues(e[i]),(this.maxColumnValue<e[i].col||this.maxColumnValue<e[i].col+e[i].sizeX)&&this.panelPropertyChange(e[i],{col:this.maxColumnValue-e[i].sizeX});var s=this.renderCell(e[i],!1,i);this.enableRtl&&t.addClass([s],"e-rtl"),this.element.appendChild(s),this.renderReactTemplates(),this.checkMediaQuery()&&i===e.length-1?this.checkMediaQuerySizing():(this.setPanelPosition(s,e[i].row,e[i].col),this.mainElement=s,this.updatePanelLayout(s,e[i]),this.mainElement=null)}this.setClasses(this.panelCollection)},i.prototype.collisions=function(e,t,i,s,n){var a=[];i&&s||(i=s=1),!n||n instanceof Array||(n=[n]);for(var l,r=0;r<s;++r)for(var o=0;o<i;++o)!(l=this.getPanel(e+r,t+o,n))||n&&-1!==n.indexOf(document.getElementById(l.id))||-1!==a.indexOf(document.getElementById(l.id))||a.push(document.getElementById(l.id));return a},i.prototype.rightWardsSpaceChecking=function(e,t,i){var s=this,n=[],a=[];if(e.forEach(function(e){var i=parseInt(e.getAttribute("data-col"),10),a=parseInt(e.getAttribute("data-sizeX"),10);if(t<s.columns&&i>=t)if(a>1)for(var l=i;l<i+a;l++)n.push(l);else n.push(i)}),n.length>0)for(var l=t+1;l<=this.columns-1;l++)-1===n.indexOf(l)&&l!==t&&-1===a.indexOf(l)&&a.push(l);var r=this.getOccupiedColumns(i);r.forEach(function(e){e>t&&-1!==a.indexOf(e)&&a.splice(a.indexOf(e),1)});return this.getOccupiedColumns(this.checkingElement).forEach(function(e){e>parseInt(i.getAttribute("data-col"),10)&&-1===r.indexOf(e)&&-1===a.indexOf(e)&&a.push(e)}),a=a.sort(function(e,t){return e-t})},i.prototype.getOccupiedColumns=function(e){for(var t=[],i=parseInt(e.getAttribute("data-sizeX"),10),s=parseInt(e.getAttribute("data-col"),10),n=s;n<s+i&&n<=this.columns;n++)t.push(n);return t},i.prototype.leftWardsSpaceChecking=function(e,t,i){var s=this,n=[],a=[];if(e.forEach(function(e){var i=parseInt(e.getAttribute("data-col"),10),n=parseInt(e.getAttribute("data-sizeX"),10);if(t<=s.columns&&i<=t)if(n>1)for(var l=i;l<i+n;l++)a.push(l);else a.push(i)}),a.length>0)for(var l=0;l<=t;l++)-1===a.indexOf(l)&&l!==t&&-1===n.indexOf(l)&&n.push(l);var r=this.getOccupiedColumns(i);r.forEach(function(e){e<t&&-1!==n.indexOf(e)&&n.splice(n.indexOf(e),1)});return this.getOccupiedColumns(this.checkingElement).forEach(function(e){e<parseInt(i.getAttribute("data-col"),10)&&-1===r.indexOf(e)&&-1===n.indexOf(e)&&n.push(e)}),n=n.sort(function(e,t){return e-t}),n=n.reverse()},i.prototype.adjustmentAvailable=function(e,i,s,n,a){this.leftAdjustable=void 0,this.rightAdjustable=void 0;var l,r=!1,o=[];this.topAdjustable=void 0;var h=parseInt(a.getAttribute("data-sizeX"),10),d=parseInt(a.getAttribute("data-col"),10);-1===(o=this.getRowElements(this.collisions(e,0,this.columns,s,[]))).indexOf(a)&&o.push(a);var p=this.leftWardsSpaceChecking(o,i,a);if(p.length>0?(this.leftAdjustable=this.isLeftAdjustable(p,a,e,i,n,s),this.spacedColumnValue!==d-this.getCellInstance(this.checkingElement.id).sizeX&&(this.leftAdjustable=!1),this.leftAdjustable?this.rightAdjustable=!1:(this.leftAdjustable=!1,l=this.rightWardsSpaceChecking(o,i,a),this.rightAdjustable=l.length>0&&this.isRightAdjustable(l,a,e,i,n,s),this.spacedColumnValue!==h+d&&(this.rightAdjustable=!1),this.rightAdjustable||(this.rightAdjustable=!1))):(l=this.rightWardsSpaceChecking(o,i,a),this.rightAdjustable=l.length>0&&this.isRightAdjustable(l,a,e,i,n,s),this.spacedColumnValue!==h+d&&(this.rightAdjustable=!1),this.rightAdjustable&&(this.leftAdjustable=!1)),!this.rightAdjustable&&!this.leftAdjustable&&e>0){var c=this.getCellInstance(a.id).row,u=!1;this.startRow!==c&&(u=!0);for(var g=e;g>=0;g--){var m=this.getCellInstance(a.id).sizeY>1&&u?this.checkingElement:a;g!==c&&g===c-s&&0===this.collisions(g,i,n,s,m).length&&(u=!1,this.topAdjustable=!0,this.spacedRowValue=t.isNullOrUndefined(this.spacedRowValue)?g:this.spacedRowValue,this.spacedColumnValue=i)}}return(this.rightAdjustable||this.leftAdjustable||this.topAdjustable)&&(r=!0,t.isNullOrUndefined(this.spacedRowValue)&&(this.spacedRowValue=e)),r},i.prototype.isXSpacingAvailable=function(e,t){for(var i=!1,s=[],n=0;n<e.length;n++)if(e[n+1]-e[n]==1||e[n+1]-e[n]==-1){if(s.push(e[n]),2===t&&s.push(e[n+1]),n===e.length-2&&(s.push(e[n+1]),s.length>t&&s.splice(-1)),s.length===t)return i=!0,this.spacedColumnValue=s.sort(function(e,t){return e-t})[0],this.spacedColumnValue<0&&(this.spacedColumnValue=1),i}else s=[];return i},i.prototype.getRowElements=function(e){for(var t=[],i=0;i<e.length;i++)t.push(e[i]);return t},i.prototype.isLeftAdjustable=function(e,t,i,s,n,a){var l;if(1===n&&1===a&&e.length>0)this.spacedColumnValue=e[0],l=!0;else if(n>1&&1===a)l=this.isXSpacingAvailable(e,n);else if(a>1)if(1===n){var r=void 0;if(e.length>=1&&(r=!0),r)for(var o=0;o<e.length;o++){if(0===this.collisions(i,e[o],n,a,this.checkingElement).length)return this.spacedColumnValue=e[o],l=!0;l=!1}}else l=this.replacable(e,n,i,a,t);return l},i.prototype.isRightAdjustable=function(e,t,i,s,n,a){var l;if(1===n&&1===a&&e.length>0)this.spacedColumnValue=e[0],l=!0;else if(n>1&&1===a)l=this.isXSpacingAvailable(e,n);else if(a>1)if(1===n){var r=void 0;if(e.length>=1&&(r=!0),r)for(var o=0;o<e.length;o++){for(var h=this.collisions(i,e[o],n,a,this.checkingElement),d=0;d<h.length;d++)parseInt(t.getAttribute("data-col"),10)!==e[o]&&h.splice(h.indexOf(h[d]),1);if(0===h.length)return l=!0,this.spacedColumnValue=e[o],l;l=!1}}else l=this.replacable(e,n,i,a,t);return l},i.prototype.replacable=function(e,t,i,s,n){for(var a,l=[],r=0;r<e.length;r++){if(this.isXSpacingAvailable(e,t)){var o=[];if(o.push(this.checkingElement),o.push(n),0===l.length)return a=!0,this.spacedColumnValue=this.spacedColumnValue,a;a=!1}}return a},i.prototype.sortCollisionItems=function(e){for(var t,i=[],s=function(s){t=[],e.forEach(function(e){e&&e.getAttribute("data-row")===s.toString()&&t.push(e)});for(var a=function(e){t.forEach(function(t){t&&t.getAttribute("data-col")===e.toString()&&i.push(t)})},l=n.columns-1;l>=0;l--)a(l)},n=this,a=this.rows-1;a>=0;a--)s(a);return i},i.prototype.updatedModels=function(e,t,i){var s=this,n=[];return this.mainElement||this.sortedPanel(),e.forEach(function(a){s.checkingElement=a;var l=s.getCellInstance(a.id),r=!s.adjustmentAvailable(l.row,l.col,l.sizeY,l.sizeX,i);if(l.sizeX>1&&r)for(var o=l.row;o<t.row+t.sizeY;o++){s.collisions(o,l.col,l.sizeX,l.sizeY,a).forEach(function(t){e.indexOf(t)>=0&&-1===n.indexOf(t)&&n.push(t)})}}),n.forEach(function(t){n.indexOf(t)>=0&&e.splice(e.indexOf(t),1)}),e},i.prototype.resetLayout=function(e){var t=this.collisions(e.row,e.col,e.sizeX,e.sizeY,this.mainElement);if(!this.mainElement||this.addPanelCalled||this.resizeCalled||this.movePanelCalled)return t;if(this.mainElement&&this.oldRowCol!==this.cloneObject)for(var i=0;i<this.panels.length;i++){var s=document.getElementById(this.panels[i].id);if(s!==this.mainElement){var n=this.cloneObject[s.id].row,a=this.cloneObject[s.id].col;this.setPanelPosition(s,n,a),this.panelPropertyChange(this.getCellInstance(s.id),{row:n,col:a}),this.setAttributes({value:{col:a.toString(),row:n.toString()}},s),this.updateOldRowColumn()}}return this.sortedArray=this.cloneArray,t=this.collisions(e.row,e.col,e.sizeX,e.sizeY,this.mainElement),this.sortedPanel(),this.updateOldRowColumn(),this.checkCollision&&this.checkCollision.length>0&&-1===t.indexOf(this.checkCollision[0])&&this.cloneObject[this.checkCollision[0].id].row===e.row&&t.push(this.checkCollision[0]),t},i.prototype.swapAvailability=function(e,t){for(var i=!0,s=this.getCellInstance(t.id),n=0;n<e.length;n++)for(var a=this.getCellInstance(e[n].id),l=1;l<s.sizeY;l++){var r=[];r.push(t),r.push(e[n]);if(this.collisions(s.row+l,a.col,a.sizeX,a.sizeY,r).length>0)return i=!1,!1}return i},i.prototype.checkForSwapping=function(e,t){if(!this.mainElement||0===e.length)return!1;var i,s=parseInt(e[0].getAttribute("data-row"),10);if(this.startRow<s?i=1:this.startRow>s&&(i=0),!this.swapAvailability(e,t))return!1;for(var n=!1,a=0;a<e.length;a++)if(e.length>=1&&this.cloneObject[this.mainElement.id].row===this.oldRowCol[this.mainElement.id].row)return!1;for(var l=0===i?this.getCellInstance(this.mainElement.id).row+this.getCellInstance(this.mainElement.id).sizeY:this.startRow,r=0;r<e.length;r++){var o=this.getCellInstance(e[r].id),h=this.getCellInstance(t.id),d=[];if(1===o.sizeY&&-1===d.indexOf(e[r]))d.push(e[r]);else if(o.sizeY>1&&-1===d.indexOf(e[r]))if(1===i&&h.row===this.cloneObject[o.id].row+o.sizeY-1)d.push(e[r]);else{if(0!==i||h.row!==this.cloneObject[o.id].row)return!1;d.push(e[r])}o.sizeY<=h.sizeY&&-1===d.indexOf(e[r])&&d.push(e[r]),d.push(this.mainElement);if(this.collisions(l,o.col,o.sizeX,o.sizeY,d).length>0)return n=!1;r===e.length-1&&(n=!0)}return n},i.prototype.swapItems=function(e,t,i){var s,n=this,a=[];a.push(t);var l=parseInt(e[0].getAttribute("data-row"),10);this.startRow<l?s=1:this.startRow>l&&(s=0);var r=0===s?l+i.sizeY:this.startRow;if(!this.movePanelCalled){var o=this.getCellInstance(e[0].id);this.panelPropertyChange(i,{row:0===s?l:r+o.sizeY})}for(var h=0;h<e.length;h++)a.push(e[h]),this.setPanelPosition(e[h],r,this.getCellInstance(e[h].id).col),this.panelPropertyChange(this.getCellInstance(e[h].id),{row:r}),e[h].setAttribute("data-row",r.toString());t.setAttribute("data-row",i.row.toString()),this.setPanelPosition(this.shadowEle,i.row,i.col);for(var d=0;d<this.panels.length;d++)this.oldRowCol[this.panels[d].id]={row:this.panels[d].row,col:this.panels[d].col};this.startRow=i.row,this.updateOldRowColumn(),a.forEach(function(e){n.cloneObject[e.id]=n.oldRowCol[e.id];for(var t=n.getCellInstance(e.id),i=0;i<n.sortedArray.length;i++)if(n.sortedArray[i])for(var s=0;s<n.sortedArray[i].length;s++)n.sortedArray[i][s]===e&&(n.sortedArray[i][s]=void 0);n.sortedArray[t.row]||(n.sortedArray[t.row]=[]),n.sortedArray[t.row][t.col]=e,n.cloneArray=n.sortedArray})},i.prototype.updatePanelLayout=function(e,i){this.collisionChecker={};var s=[],n=[];if((s=this.mainElement&&this.isRenderComplete?this.resetLayout(i):this.collisions(i.row,i.col,i.sizeX,i.sizeY,e)).length>0)if(s=this.sortCollisionItems(s),s=this.updatedModels(s,i,e),!t.isNullOrUndefined(this.startRow)&&this.checkForSwapping(s,e))this.swapItems(s,e,i);else for(var a=0;a<s.length;a++){var l=this.getCellInstance(s[a].id);if(this.checkingElement=s[a],this.spacedRowValue=null,this.spacedColumnValue=null,this.adjustmentAvailable(l.row,l.col,l.sizeY,l.sizeX,e)&&!t.isNullOrUndefined(this.spacedColumnValue)){this.setPanelPosition(s[a],this.spacedRowValue,this.spacedColumnValue),this.oldRowCol[s[a].id]={row:this.spacedRowValue,col:this.spacedColumnValue};var r={attributes:{row:this.spacedRowValue.toString(),col:this.spacedColumnValue.toString()}};if(this.setAttributes(r,s[a]),this.panelPropertyChange(l,{col:this.spacedColumnValue,row:this.spacedRowValue}),this.topAdjustable&&this.allowFloating&&(this.updatePanels(),this.updateCloneArrayObject()),this.spacedRowValue=null,a<s.length)continue}else n.push(s[a])}if(n.length>0){var o=this;n.forEach(function(e){-1===o.overlapElement.indexOf(e)&&o.overlapElement.push(e)}),this.overlapElement&&-1!==this.overlapElement.indexOf(e)&&this.overlapElement.splice(this.overlapElement.indexOf(e),1),n.length>0&&(this.updateRowColumn(i.row,this.overlapElement,e),this.checkForCompletePushing())}this.isSubValue||this.sortedPanel(),this.updateRowHeight(),this.updateGridLines()},i.prototype.checkForCompletePushing=function(){for(var e=0;e<this.panels.length;e++)if(this.collisionChecker[this.panels[e].id]&&null!==this.collisionChecker[this.panels[e].id]){this.overlapElement=[this.collisionChecker[this.panels[e].id].ele];var t=this.panels[e].id;this.updateRowColumn(this.collisionChecker[t].row,this.overlapElement,this.collisionChecker[t].srcEle)}},i.prototype.updateCollisionChecked=function(e){for(var t=0;t<Object.keys(this.collisionChecker).length;t++)this.collisionChecker[e.id]=null},i.prototype.updateRowColumn=function(e,t,i){if(i){var s=parseInt(i.getAttribute("data-sizeY"),10),n=parseInt(i.getAttribute("data-row"),10);this.overlapElementClone=(this.overlapElement&&this.shouldRestrict,this.overlapElement);for(var a=0;a<this.overlapElementClone.length;a++){if(0===this.overlapElementClone.length)return;for(var l=0;l<this.overlapElementClone.length;l++)this.collisionChecker[this.overlapElementClone[l].id]={ele:this.overlapElementClone[l],row:e,srcEle:i};var r=n+s,o=parseInt(this.overlapElementClone[a].getAttribute("data-sizeY"),10),h=parseInt(this.overlapElementClone[a].getAttribute("data-col"),10),d=parseInt(this.overlapElementClone[a].getAttribute("data-sizeX"),10),p=void 0,c=void 0;if(-1===this.overlapSubElementClone.indexOf(i)&&this.overlapSubElementClone.push(i),-1===this.overlapSubElementClone.indexOf(this.overlapElementClone[a])&&this.overlapSubElementClone.push(this.overlapElementClone[a]),o>1||d>1){var u=this.getCellInstance(this.overlapElementClone[a].id);p=u.col;for(var g=document.getElementById(u.id),m=u.row;m<n+s;m++){this.isSubValue=!0,this.panelPropertyChange(u,{row:u.row+1}),g.setAttribute("data-row",u.row.toString()),this.setPanelPosition(g,u.row,p),this.updateCollisionChecked(g),this.oldRowCol[g.id]={row:u.row,col:p};var f=this.getCellInstance(g.id);this.panelPropertyChange(f,{col:p,row:u.row});var v=parseInt(g.getAttribute("data-row"),10),P=parseInt(g.getAttribute("data-col"),10),y=parseInt(g.getAttribute("data-sizeX"),10),C=parseInt(g.getAttribute("data-sizeY"),10),x=[];x.push(g),x.push(i),c=this.collisions(v,P,y,C,x),this.mainElement&&-1!==c.indexOf(this.mainElement)&&c.splice(c.indexOf(this.mainElement),1),this.collisionPanel(c,P,v,g)}this.isSubValue=!1}else{this.addPanelCalled&&(this.addPanelCalled=!1),this.overlapElementClone[a].setAttribute("data-row",r.toString());var S=[];S.push(this.overlapElementClone[a]),S.push(i),c=this.collisions(r,h,d,o,S),this.mainElement&&-1!==c.indexOf(this.mainElement)&&c.splice(c.indexOf(this.mainElement),1),p=parseInt(this.overlapElementClone[a].getAttribute("data-col"),10),this.setPanelPosition(this.overlapElementClone[a],r,p),this.updateCollisionChecked(this.overlapElementClone[a]),this.oldRowCol[this.overlapElementClone[a].id]={row:r,col:p};f=this.getCellInstance(this.overlapElementClone[a].id);this.panelPropertyChange(f,{col:p,row:r}),this.collisionPanel(c,p,r,this.overlapElementClone[a])}}}},i.prototype.collisionPanel=function(e,t,i,s){var n=this.getCellInstance(s.id);if(this.panelPropertyChange(n,{row:i,col:t}),e.length>0){var a=this;this.overlapElement=[],this.shouldRestrict=!0,e.forEach(function(e){a.overlapElement.push(e)});for(var l=parseInt(s.getAttribute("data-row"),10),r=0;r<this.overlapElement.length;r++)this.updateRowColumn(l,this.overlapElement,s);this.shouldRestrict=!1}else{if(this.addPanelCalled||this.sortedPanel(),this.overlapSubElementClone.length>0)for(var o=function(e){var t=parseInt(h.overlapSubElementClone[e].getAttribute("data-row"),10),i=parseInt(h.overlapSubElementClone[e].getAttribute("data-col"),10),s=parseInt(h.overlapSubElementClone[e].getAttribute("data-sizeX"),10),n=parseInt(h.overlapSubElementClone[e].getAttribute("data-sizeY"),10),a=h.collisions(t,i,s,n,h.overlapSubElementClone);h.mainElement&&-1!==a.indexOf(h.mainElement)&&a.splice(a.indexOf(h.mainElement),1);var l=h;a.forEach(function(e){l.overlapElement.push(e)}),a.length>0&&h.updateRowColumn(t,h.overlapElement,h.overlapSubElementClone[e])},h=this,d=0;d<this.overlapSubElementClone.length;d++)o(d);this.overlapSubElementClone=[]}},i.prototype.removeResizeClasses=function(e){for(var i=0;i<e.length;i++)for(var s=e[i].querySelectorAll(".e-resize"),n=0;n<s.length;n++)t.detach(s[n])},i.prototype.ensureDrag=function(){this.checkDragging(this.dragCollection);var e=this.element.querySelectorAll("."+T);t.removeClass(e,[T]),this.setClasses(this.panelCollection)},i.prototype.setClasses=function(e){for(var i=0;i<e.length;i++){var s=e[i],n=e[i].querySelector(".e-panel-container");this.allowDragging&&(this.draggableHandle&&s.querySelectorAll(this.draggableHandle)[0]?t.addClass([s.querySelectorAll(this.draggableHandle)[0]],[T]):t.addClass([s],[T])),this.allowResizing&&this.mediaQuery&&!this.checkMediaQuery()&&this.setResizingClass(s,n)}},i.prototype.setResizingClass=function(e,i){if(this.availableClasses=this.resizableHandles,!e.querySelector(".e-resize"))for(var s=0;s<this.availableClasses.length;s++){var n=this.createElement("span"),a=void 0;i.appendChild(n),a="e-east"===this.availableClasses[s]||"e-west"===this.availableClasses[s]||"e-north"===this.availableClasses[s]||"e-south"===this.availableClasses[s]?"e-single":"e-double",t.addClass([n],[a,this.availableClasses[s],"e-resize","e-dl-icon"])}},i.prototype.setXYAttributes=function(e,i){var s={value:{sizeX:i.sizeX.toString(),sizeY:i.sizeY.toString(),minSizeX:i.minSizeX.toString(),minSizeY:i.minSizeY.toString(),maxSizeX:t.isNullOrUndefined(i.maxSizeX)?void 0:i.maxSizeX.toString(),maxSizeY:t.isNullOrUndefined(i.maxSizeY)?void 0:i.maxSizeY.toString(),row:i.row.toString(),col:i.col.toString()}};this.setAttributes(s,e)},i.prototype.setXYDimensions=function(e){var i,s,n=this.getCellSize()[1],a=this.getCellSize()[0];return i=e&&"number"==typeof a&&"number"==typeof e.sizeX&&e.sizeX>1?e.sizeX*a+(e.sizeX-1)*this.cellSpacing[0]:a,s=e&&"number"==typeof n&&e.sizeY>1&&"number"==typeof e.sizeY?e.sizeY*n+(e.sizeY-1)*this.cellSpacing[1]:t.formatUnit(n),[s,i]},i.prototype.getRowColumnDragValues=function(e){var t=parseFloat(e.element.style.top),i=parseFloat(e.element.style.left);return[Math.round(t/(this.getCellSize()[1]+this.cellSpacing[1])),Math.round(i/(this.getCellSize()[0]+ +this.cellSpacing[0]))]},i.prototype.checkForChanges=function(e,i,s){var n=[];if(this.removeAllCalled)n=[];else for(var a=0;a<this.panels.length;a++)!t.isNullOrUndefined(i)&&this.panels[a].id===i[0].id||!t.isNullOrUndefined(s)&&this.panels[a].id===s[0].id||this.panels[a].row===this.panelsInitialModel[a].row&&this.panels[a].col===this.panelsInitialModel[a].col||n.push(this.panels[a]);if(n.length>0||this.removeAllCalled){var l={changedPanels:n,isInteracted:e,addedPanels:t.isNullOrUndefined(i)?[]:i,removedPanels:t.isNullOrUndefined(s)?[]:s};this.trigger("change",l)}},i.prototype.enableDraggingContent=function(e){for(var i=this,s=0;s<e.length;s++){var n=[".e-resize",".e-drag-restrict"],a=e[s];this.dragobj=new t.Draggable(a,{preventDefault:!1,clone:!1,dragArea:this.element,isDragScroll:!0,handle:this.draggableHandle?this.draggableHandle:".e-panel",abort:n,dragStart:this.onDraggingStart.bind(this),dragStop:function(e){var s=i.getCellInstance(i.mainElement.id);i.allowPushing&&i.collisions(s.row,s.col,s.sizeX,s.sizeY,i.mainElement).length>0?(i.setHolderPosition(e),i.setPanelPosition(i.mainElement,s.row,s.col),i.updatePanelLayout(i.mainElement,s)):i.setPanelPosition(i.mainElement,s.row,s.col),i.mainElement=null;var n=i.getPanelBase(e);i.shadowEle&&t.detach(i.shadowEle),t.removeClass([i.element],[X]),t.removeClass([e.element],[Y]),i.shadowEle=null,e.element.classList.remove("e-dragging");var a=i.getRowColumnDragValues(e)[0],l=i.getRowColumnDragValues(e)[1],r=i.getCellInstance(e.element.id);i.allowPushing&&0===i.collisions(a,l,r.sizeX,r.sizeY,document.getElementById(n.id)).length?(i.panelPropertyChange(i.getCellInstance(e.element.id),{row:a,col:l}),i.oldRowCol[e.element.id].row=a,i.oldRowCol[e.element.id].col=l,i.setAttributes({value:{col:l.toString(),row:a.toString()}},e.element),i.sortedPanel()):(i.panelPropertyChange(i.getCellInstance(e.element.id),{row:i.oldRowCol[e.element.id].row,col:i.oldRowCol[e.element.id].col}),e.element.setAttribute("data-col",i.getCellInstance(e.element.id).col.toString()),e.element.setAttribute("data-row",i.getCellInstance(e.element.id).row.toString()),i.sortedPanel());var o=i.getCellInstance(e.element.id);i.setPanelPosition(e.element,o.row,o.col),i.updatePanels(),i.updateCloneArrayObject(),i.checkForChanges(!0),i.dragStopEventArgs={event:e.event,element:e.element},i.trigger("dragStop",e),i.resizeEvents(),i.rows=i.maxRow(!0),i.setHeightWidth(),i.updateDragArea()},drag:function(e){i.draggedEventArgs={event:e.event,element:e.element,target:t.closest(e.target,".e-panel")},i.trigger("drag",i.draggedEventArgs),i.onDragStart(e)}}),-1===this.dragCollection.indexOf(this.dragobj)&&this.dragCollection.push(this.dragobj)}},i.prototype.updatePanels=function(){this.moveItemsUpwards(),this.updateOldRowColumn(),this.sortedPanel()},i.prototype.updateDragArea=function(){this.dragCollection.forEach(function(e){e.setDragArea()})},i.prototype.updateRowsHeight=function(e,t,i){e+t>=this.rows&&(this.rows=this.rows+i,this.setHeightWidth())},i.prototype.onDraggingStart=function(e){var i=e;this.trigger("dragStart",i,function(e){}),this.panelsInitialModel=this.cloneModels(this.panels),this.mainElement=e.element,this.cloneObject=JSON.parse(JSON.stringify(this.cloneObject));var s=this.startRow=parseInt(e.element.getAttribute("data-row"),10);this.startCol=parseInt(e.element.getAttribute("data-col"),10);var n=parseInt(e.element.getAttribute("data-sizeY"),10);this.updateRowsHeight(s,n,n),this.updateDragArea(),this.shadowEle=document.createElement("div"),this.shadowEle.classList.add("e-holder"),this.shadowEle.classList.add("e-holder-transition"),t.setStyleAttribute(this.shadowEle,{position:"absolute"}),t.addClass([this.element],[X]),t.addClass([e.element],[Y]),this.element.appendChild(this.shadowEle),this.renderReactTemplates(),this.shadowEle=document.querySelector(".e-holder"),this.shadowEle.style.height=this.getCellInstance(e.element.id).sizeY*this.cellSize[1]+"px",this.shadowEle.style.width=this.getCellInstance(e.element.id).sizeX*this.cellSize[0]+"px";var a=this.getCellInstance(e.element.id);this.setPanelPosition(this.shadowEle,a.row,a.col)},i.prototype.cloneModels=function(e,t){void 0===t&&(t=[]);for(var i=0;i<e.length;i++){t[i]||(t[i]={});for(var s in e[i])t[i][s]=e[i][s]}return t},i.prototype.onDragStart=function(e){var t,i,s,n=s=this.getRowColumnDragValues(e)[1],a=this.getRowColumnDragValues(e)[0];if(!(n<0||a<0)){this.panelPropertyChange(this.getCellInstance(e.element.id),{row:a,col:n});var l=this.getCellInstance(e.element.id);if(this.updateRowsHeight(l.row,l.sizeY,1),this.updateDragArea(),this.allowPushing&&(this.setAttributes({value:{col:n.toString(),row:a.toString()}},e.element),this.panelPropertyChange(this.getCellInstance(e.element.id),{row:a,col:n}),t=this.oldRowCol[e.element.id].col,i=this.oldRowCol[e.element.id].row,this.oldRowCol[e.element.id]={row:a,col:n},this.updateOldRowColumn(),(this.startCol!==t||this.startRow!==i)&&(this.setHolderPosition(e),this.startCol!==t&&(this.startRow=i),this.startRow!==i&&(this.startCol=t),this.allowPushing))){this.mainElement=e.element;var r=l;this.checkCollision=this.collisions(r.row,r.col,r.sizeX,r.sizeY,e.element),l.col>=this.checkColumnValue&&(this.checkCollision=[]),this.updatePanelLayout(e.element,l),this.moveItemsUpwards()}!1!==this.allowPushing&&this.panelPropertyChange(this.getCellInstance(e.element.id),{row:a,col:n}),this.oldRowCol[e.element.id].row===a&&this.oldRowCol[e.element.id].col===n||(this.panelPropertyChange(this.getCellInstance(e.element.id),{row:a,col:n}),this.setAttributes({value:{col:n.toString(),row:a.toString()}},e.element)),this.startCol!==s&&(this.startCol=t,this.moveItemsUpwards()),this.allowPushing||this.setHolderPosition(e),this.removeResizeClasses(this.panelCollection),this.setClasses(this.panelCollection),this.allowPushing}},i.prototype.getPanelBase=function(e){for(var t,i=0;i<this.panelCollection.length;i++)this.panelCollection[i].id===(e.element&&e.element.id||e)&&(t=this.panelCollection[i]);return t},i.prototype.getPanel=function(e,t,i){!i||i instanceof Array||(i=[i]);for(var s=1;e>-1;){for(var n=1,a=t;a>-1;){var l=this.sortedArray[e];if(l){var r=l[a];if(r&&(!i||-1===i.indexOf(r))&&parseInt(r.getAttribute("data-sizeX"),10)>=n&&parseInt(r.getAttribute("data-sizeY"),10)>=s)return r}++n,--a}--e,++s}return null},i.prototype.setHolderPosition=function(e){var t=parseInt(e.element.getAttribute("data-sizeY"),10),i=parseInt(e.element.getAttribute("data-col"),10),s=parseInt(e.element.getAttribute("data-row"),10),n=parseInt(e.element.getAttribute("data-sizeX"),10),a=this.getCellSize()[0],l=this.getCellSize()[1],r=0===s?0:s*(l+this.cellSpacing[1]),o=0===i?0:i*(a+this.cellSpacing[0]),h=this.getCellSize()[1],d=this.getCellSize()[0];this.elementRef.top=this.shadowEle.style.top=r+"px",this.elementRef.left=this.shadowEle.style.left=o+"px",this.elementRef.height=this.shadowEle.style.height=t*h+(t-1)*this.cellSpacing[1]+"px",this.elementRef.width=this.shadowEle.style.width=n*d+(n-1)*this.cellSpacing[0]+"px"},i.prototype.getCellInstance=function(e){for(var t,i=0;i<this.panels.length;i++)this.panels[i].id===e&&(t=this.panels[i]);return t},i.prototype.addPanel=function(e){this.panelsSizeY=0,this.maxCol(),e.minSizeX||(e.minSizeX=1),e.minSizeY||(e.minSizeY=1),e.id||(e.id="layout_"+this.panelID.toString(),this.panelID=this.panelID+1);var i=new V(this,"panels",e,!0);this.panels.push(i),this.panelsInitialModel=this.cloneModels(this.panels),this.setMinMaxValues(i),(this.maxColumnValue<i.col||this.maxColumnValue<i.col+i.sizeX)&&this.panelPropertyChange(i,{col:this.maxColumnValue-i.sizeX});var s=this.renderCell(i,!0,null);if(this.oldRowCol[i.id]={row:i.row,col:i.col},this.cloneObject[i.id]={row:i.row,col:i.col},this.updateOldRowColumn(),this.element.insertAdjacentElement("afterbegin",s),this.addPanelCalled=!0,this.checkMediaQuery()?(this.checkMediaQuerySizing(),this.removeResizeClasses(this.panelCollection)):(this.mainElement=s,this.checkCollision||(this.checkCollision=[]),this.setPanelPosition(s,i.row,i.col),this.updatePanelLayout(s,i)),this.addPanelCalled=!1,this.allowDragging&&this.mediaQuery&&!this.checkMediaQuery()&&this.enableDraggingContent([document.getElementById(i.id)]),this.setClasses([s]),this.allowFloating&&(this.mainElement=null,this.moveItemsUpwards()),this.updateOldRowColumn(),this.sortedPanel(),this.updateCloneArrayObject(),this.allowResizing)for(var n=0;n<s.querySelectorAll(".e-resize").length;n++){var a="msie"===t.Browser.info.name?"mousedown pointerdown":"mousedown";t.EventHandler.add(s.querySelectorAll(".e-resize")[n],a,this.downResizeHandler,this),"msie"!==t.Browser.info.name&&t.EventHandler.add(s.querySelectorAll(".e-resize")[n],"touchstart",this.touchDownResizeHandler,this)}this.checkForChanges(!1,[i])},i.prototype.updatePanel=function(e){if(this.panelsSizeY=0,e.id){var i=this.getCellInstance(e.id);if(i){this.maxCol(),e.col=e.col<1?0:e.col>this.columns?this.columns-1:e.col,t.isNullOrUndefined(e.col)&&(e.col=i.col),this.panelPropertyChange(i,e),this.setMinMaxValues(i);var s=document.getElementById(e.id);this.mainElement=s;var n=i.cssClass?i.cssClass.split(" "):null;if(this.panelContent=s.querySelector(".e-panel-container")?s.querySelector(".e-panel-container"):this.createSubElement(n,s.id+"_content",U),s.appendChild(this.panelContent),i.header){var a=s.querySelector(".e-panel-header")?s.querySelector(".e-panel-header"):this.createSubElement([],s.id+"template","");t.addClass([a],[j]),a.innerHTML="";var l=this.element.id+"HeaderTemplate"+i.id;this.renderTemplate(i.header,a,l,!0,"header"),this.panelContent.appendChild(a),this.renderReactTemplates()}else s.querySelector(".e-panel-header")&&t.detach(s.querySelector(".e-panel-header"));if(i.content){var r=i.cssClass?i.cssClass.split(" "):null;this.panelBody=s.querySelector(".e-panel-content")?s.querySelector(".e-panel-content"):this.createSubElement(r,s.id+"_body",D),this.panelBody.innerHTML="";var o="calc( 100% - "+(this.panelContent.querySelector(".e-panel-header")?window.getComputedStyle(this.panelContent.querySelector(".e-panel-header")).height:"0px")+")";t.setStyleAttribute(this.panelBody,{height:o});l=this.element.id+"ContentTemplate"+i.id;this.renderTemplate(i.content,this.panelBody,l,!0,"content"),this.panelContent.appendChild(this.panelBody),this.renderReactTemplates()}else s.querySelector(".e-panel-content")&&t.detach(s.querySelector(".e-panel-content"));this.setXYAttributes(s,i),this.setHeightAndWidth(s,i),this.setPanelPosition(s,i.row,i.col),this.updatePanelLayout(s,i),this.checkMediaQuery()&&this.checkMediaQuerySizing(),this.mainElement=null,this.updatePanels(),this.updateCloneArrayObject()}}},i.prototype.updateCloneArrayObject=function(){this.cloneArray=this.sortedArray,this.cloneObject=JSON.parse(JSON.stringify(this.oldRowCol))},i.prototype.serialize=function(){for(var e=this.cloneModels(this.panels),t=[],i=0;i<e.length;i++)t.push({id:e[i].id,row:e[i].row,col:e[i].col,sizeX:e[i].sizeX,sizeY:e[i].sizeY,minSizeX:e[i].minSizeX,minSizeY:e[i].minSizeY,maxSizeX:e[i].maxSizeX,maxSizeY:e[i].maxSizeY});return t},i.prototype.removeAll=function(){this.removeAllCalled=!0;for(var e=0;e<this.panelCollection.length;e++)t.detach(this.panelCollection[e]),this.clearTemplate();this.removeAllPanel(),this.rows=0,this.gridPanelCollection=[],this.setHeightWidth(),this.sortedPanel(),this.sortedArray=[],this.overlapElementClone=[],this.overlapElement=[],this.overlapSubElementClone=[],this.panelCollection=[],this.oldRowCol={},this.cloneObject={};var i=this.cloneModels(this.panels);this.setProperties({panels:[]},!0),this.updatePanels(),this.updateCloneArrayObject(),this.checkForChanges(!1,null,i),this.removeAllCalled=!1},i.prototype.removePanel=function(e){var i=this;this.panelsSizeY=0,this.panelsInitialModel=this.cloneModels(this.panels);for(var s,n=0;n<this.panelCollection.length;n++)this.panelCollection[n].id===e&&(t.detach(this.panelCollection[n]),this.panelCollection.splice(n,1)),this.panels[n].id===e&&(s=this.panels[n],this.panels.splice(n,1),this.panelsInitialModel.splice(n,1),this.updateOldRowColumn(),this.sortedPanel());this.updatePanels(),this.checkMediaQuery()&&(this.isPanelRemoved=!0,this.checkMediaQuerySizing(),this.isPanelRemoved=!1),this.gridPanelCollection.forEach(function(t){t.id===e&&i.gridPanelCollection.splice(i.gridPanelCollection.indexOf(t),1)}),this.updateCloneArrayObject(),this.checkForChanges(!1,null,[s])},i.prototype.movePanel=function(e,t,i){this.movePanelCalled=!0,this.panelsInitialModel=this.cloneModels(this.panels);var s=this.getCellInstance(e);if(!isNaN(t)&&null!==t&&!isNaN(i)&&null!==i&&s){i<0?i=0:i>this.columns&&(i=this.columns-s.sizeX),this.panelPropertyChange(s,{row:t,col:i});var n=document.getElementById(e);this.mainElement=n,this.startRow=parseInt(n.getAttribute("data-row"),10),this.startCol=parseInt(n.getAttribute("data-col"),10),this.setAttributes({value:{col:i.toString(),row:t.toString()}},n),this.updateOldRowColumn(),this.setPanelPosition(n,t,i),this.updatePanelLayout(n,s),this.updateRowHeight(),this.updatePanels(),this.updateCloneArrayObject(),this.mainElement=null,this.allowFloating&&this.moveItemsUpwards(),this.movePanelCalled=!1,this.checkForChanges(!1)}},i.prototype.setAttributes=function(e,t){for(var i=0;i<Object.keys(e).length;i++)Object.keys(e)&&(e[Object.keys(e)[i]].col&&t.setAttribute("data-col",e[Object.keys(e)[i]].col.toString()),e[Object.keys(e)[i]].row&&t.setAttribute("data-row",e[Object.keys(e)[i]].row.toString()),e[Object.keys(e)[i]].sizeX&&t.setAttribute("data-sizeX",e[Object.keys(e)[i]].sizeX.toString()),e[Object.keys(e)[i]].sizeY&&t.setAttribute("data-sizeY",e[Object.keys(e)[i]].sizeY.toString()),e[Object.keys(e)[i]].minSizeX&&t.setAttribute("data-minSizeX",e[Object.keys(e)[i]].minSizeX.toString()),e[Object.keys(e)[i]].minSizeY&&t.setAttribute("data-minSizeY",e[Object.keys(e)[i]].minSizeY.toString()),e[Object.keys(e)[i]].maxSizeX&&t.setAttribute("data-maxSizeY",e[Object.keys(e)[i]].maxSizeX.toString()),e[Object.keys(e)[i]].maxSizeY&&t.setAttribute("data-maxSizeY",e[Object.keys(e)[i]].maxSizeY.toString()))},i.prototype.resizePanel=function(e,t,i){this.panelsInitialModel=this.cloneModels(this.panels);var s=this.getCellInstance(e);this.resizeCalled=!0;var n=document.getElementById(e),a={event:null,element:n,isInteracted:!1};this.trigger("resizeStart",a),this.panelPropertyChange(s,{sizeX:t,sizeY:i}),this.setMinMaxValues(s),this.checkMinMaxValues(s),this.mainElement=n,this.setAttributes({value:{sizeX:s.sizeX.toString(),sizeY:s.sizeY.toString()}},n),this.setHeightAndWidth(n,s),this.updatePanelLayout(n,s),this.updatePanels(),this.updateRowHeight(),this.resizeCalled=!1,this.trigger("resizeStop",a),this.checkForChanges(!1)},i.prototype.destroy=function(){t.EventHandler.remove(window,"resize",this.refreshListener),t.removeClass([this.element],["e-dashboardlayout","e-lib","e-responsive","e-control"]),this.element.removeAttribute("style");for(var i=0;i<this.dragCollection.length;i++)this.dragCollection[i].destroy();this.removeAllPanel(),e.prototype.destroy.call(this),this.clearTemplate(),this.renderReactTemplates()},i.prototype.removeAllPanel=function(){for(;this.element.firstElementChild;)t.detach(this.element.firstElementChild),this.clearTemplate()},i.prototype.setEnableRtl=function(){!0===this.enableRtl?t.addClass([this.element],"e-rtl"):t.removeClass([this.element],"e-rtl")},i.prototype.updateCellSizeAndSpacing=function(){this.panelResponsiveUpdate(),this.setHeightWidth(),this.getRowColumn();for(var e=0;e<this.element.querySelectorAll(".e-panel").length;e++){var t=this.element.querySelectorAll(".e-panel")[e],i=this.getCellInstance(t.id);this.setHeightAndWidth(t,i),this.setPanelPosition(t,i.row,i.col)}},i.prototype.updatePanelsDynamically=function(e){this.removeAll(),this.setProperties({panels:e},!0),this.setOldRowCol(),this.table&&this.table.remove(),this.initialize(),this.checkMediaQuery()&&this.refresh(),this.showGridLines&&this.initGridLines()},i.prototype.checkForIDValues=function(e){var i=this;!t.isNullOrUndefined(e)&&e.length>0?(this.panelID=0,e.forEach(function(e){e.id||(i.panelPropertyChange(e,{id:"layout_"+i.panelID.toString()}),i.panelID=i.panelID+1)})):this.restrictDynamicUpdate=!0},i.prototype.onPropertyChanged=function(e,i){var s=this;e.panels&&e.panels.length>0&&e.panels[0]instanceof V&&this.checkForIDValues(e.panels);for(var n=0,a=Object.keys(e);n<a.length;n++){switch(a[n]){case"enableRtl":this.setProperties({enableRtl:e.enableRtl},!0),this.setEnableRtl();break;case"mediaQuery":this.setProperties({mediaQuery:e.mediaQuery},!0),this.checkMediaQuery()&&this.checkMediaQuerySizing();break;case"allowDragging":this.setProperties({allowDragging:e.allowDragging},!0),this.ensureDrag();break;case"allowResizing":if(this.setProperties({allowResizing:e.allowResizing},!0),this.allowResizing)this.setClasses(this.panelCollection),this.resizeEvents();else{for(var l=this.element.querySelectorAll(".e-panel .e-panel-container .e-resize"),r=0;r<l.length;r++){var o="msie"===t.Browser.info.name?"mousedown pointerdown":"mousedown",h=l[r];t.EventHandler.remove(h,o,this.downResizeHandler),"msie"!==t.Browser.info.name&&t.EventHandler.remove(h,"touchstart",this.touchDownResizeHandler)}this.removeResizeClasses(this.panelCollection)}break;case"cellSpacing":this.setProperties({cellSpacing:e.cellSpacing},!0),this.updateCellSizeAndSpacing(),this.updateGridLines();break;case"draggableHandle":this.setProperties({draggableHandle:e.draggableHandle},!0),this.ensureDrag();break;case"allowFloating":this.setProperties({allowFloating:e.allowFloating},!0),this.moveItemsUpwards();break;case"showGridLines":this.showGridLines?(this.setProperties({showGridLines:e.showGridLines},!0),this.initGridLines()):this.table&&t.detach(this.table);break;case"allowPushing":this.setProperties({allowPushing:e.allowPushing},!0);break;case"panels":!e.columns&&!this.restrictDynamicUpdate&&e.panels[0]&&e.panels.length>0?(this.isRenderComplete=!1,this.updatePanelsDynamically(e.panels),this.isRenderComplete=!0):e.panels[0]&&e.panels.length?this.restrictDynamicUpdate=!1:(this.isRenderComplete=!1,this.updatePanelsDynamically(this.panels),this.isRenderComplete=!0);break;case"columns":this.isRenderComplete=!1,e.panels&&this.updatePanelsDynamically(e.panels),this.setProperties({columns:e.columns},!0),this.panelCollection=[],this.maxColumnValue=this.columns,this.calculateCellSize(),this.panels.forEach(function(e){if(s.setMinMaxValues(e),s.maxColumnValue<e.col||s.maxColumnValue<e.col+e.sizeX){var t=s.maxColumnValue-e.sizeX;s.panelPropertyChange(e,{col:t<0?0:t}),s.setXYAttributes(document.getElementById(e.id),e)}s.setHeightAndWidth(document.getElementById(e.id),e),s.panelCollection.push(document.getElementById(e.id)),s.setPanelPosition(document.getElementById(e.id),e.row,e.col),s.mainElement=document.getElementById(e.id),s.updatePanelLayout(document.getElementById(e.id),e),s.mainElement=null}),this.updatePanels(),this.updateCloneArrayObject(),this.isRenderComplete=!0,this.updateGridLines()}}},i.prototype.getPersistData=function(){return this.addOnPersist(["panels"])},i.prototype.mergePersistPanelData=function(e){var i=window.localStorage.getItem(this.getModuleName()+this.element.id);if(!t.isNullOrUndefined(i)&&""!==i||!t.isNullOrUndefined(e)){var s=t.isNullOrUndefined(e)?JSON.parse(i):e,n=Object.keys(s);this.isProtectedOnChange=!0;for(var a=0,l=n;a<l.length;a++){var r=l[a];"object"!=typeof t.getValue(r,this)||t.isNullOrUndefined(t.getValue(r,this))||Array.isArray(t.getValue(r,this))&&"panels"===r&&this.mergePanels(s[r],this[r])}this.isProtectedOnChange=!1}},i.prototype.mergePanels=function(e,i){for(var s=e,n=function(e){a.checkForIDValues(i);var n=i.filter(function(t){return t.id===s[e].id})[0];t.isNullOrUndefined(n)||(s[e]=t.extend(n,s[e],{},!0))},a=this,l=0;l<s.length;l++)n(l)},i.prototype.getModuleName=function(){return"DashboardLayout"},k([t.Property(!0)],i.prototype,"allowDragging",void 0),k([t.Property(!1)],i.prototype,"allowResizing",void 0),k([t.Property(!0)],i.prototype,"allowPushing",void 0),k([t.Property(!0)],i.prototype,"enableHtmlSanitizer",void 0),k([t.Property(!0)],i.prototype,"allowFloating",void 0),k([t.Property(1)],i.prototype,"cellAspectRatio",void 0),k([t.Property([5,5])],i.prototype,"cellSpacing",void 0),k([t.Property(1)],i.prototype,"columns",void 0),k([t.Property(!1)],i.prototype,"showGridLines",void 0),k([t.Property(null)],i.prototype,"draggableHandle",void 0),k([t.Property("en-US")],i.prototype,"locale",void 0),k([t.Property("max-width: 600px")],i.prototype,"mediaQuery",void 0),k([t.Collection([],V)],i.prototype,"panels",void 0),k([t.Property(["e-south-east"])],i.prototype,"resizableHandles",void 0),k([t.Event()],i.prototype,"change",void 0),k([t.Event()],i.prototype,"dragStart",void 0),k([t.Event()],i.prototype,"drag",void 0),k([t.Event()],i.prototype,"dragStop",void 0),k([t.Event()],i.prototype,"resizeStart",void 0),k([t.Event()],i.prototype,"resize",void 0),k([t.Event()],i.prototype,"resizeStop",void 0),k([t.Event()],i.prototype,"created",void 0),k([t.Event()],i.prototype,"destroyed",void 0),i=k([t.NotifyPropertyChanges],i)}(t.Component);e.PaneProperties=M,e.Splitter=L,e.Panel=V,e.DashboardLayout=q,Object.defineProperty(e,"__esModule",{value:!0})});
	//# sourceMappingURL=ej2-layouts.umd.min.js.map


/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	*  filename: ej2-pdf-export.umd.min.js
	*  version : 19.4.52
	*  Copyright Syncfusion Inc. 2001 - 2020. All rights reserved.
	*  Use of this code is subject to the terms of our license.
	*  A copy of the current license can be obtained at any time by e-mailing
	*  licensing@syncfusion.com. Any infringement will be prosecuted under
	*  applicable laws. 
	*/
	!function(t,e){ true?e(exports,__webpack_require__(210),__webpack_require__(211)):"function"==typeof define&&define.amd?define(["exports","@syncfusion/ej2-compression","@syncfusion/ej2-file-utils"],e):e(t.ej={},t.ej2Compression,t.ej2FileUtils)}(this,function(t,e,i){"use strict";function r(t){return"[object String]"===Object.prototype.toString.call(t)?"$s"+t:"$o"+t.toString()}var n=function(){function t(t){this.table={},this.nElements=0,this.toStr=t||r}return t.prototype.getValue=function(t){var e=this.table["$"+this.toStr(t)];if(void 0!==e)return e.value},t.prototype.setValue=function(t,e){var i="$"+this.toStr(t);this.table[i];this.nElements++,this.table[i]={key:t,value:e}},t.prototype.remove=function(t){var e="$"+this.toStr(t),i=this.table[e];return delete this.table[e],this.nElements--,i.value},t.prototype.keys=function(){for(var t=[],e=Object.keys(this.table),i=0;i<e.length;i++){var r=this.table[e[i]];t.push(r.key)}return t},t.prototype.values=function(){for(var t=[],e=Object.keys(this.table),i=0;i<e.length;i++){var r=this.table[e[i]];t.push(r.value)}return t},t.prototype.containsKey=function(t){return!(void 0===this.getValue(t))},t.prototype.clear=function(){this.table={},this.nElements=0},t.prototype.size=function(){return this.nElements},t}(),o=function(){function t(t){this.stringStartMark="/",this.internalValue="",this.isSaving6=!1,this.position6=-1,this.internalValue=this.normalizeValue(t)}return Object.defineProperty(t.prototype,"status",{get:function(){return this.status6},set:function(t){this.status6=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"isSaving",{get:function(){return this.isSaving6},set:function(t){this.isSaving6=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"objectCollectionIndex",{get:function(){return this.index6},set:function(t){this.index6=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"position",{get:function(){return this.position6},set:function(t){this.position6=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"clonedObject",{get:function(){return null},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"value",{get:function(){return this.internalValue},set:function(t){var e=t;null!==t&&t.length>0?(e=t,this.internalValue=this.normalizeValue(e)):this.internalValue=e},enumerable:!0,configurable:!0}),t.prototype.save=function(t){t.write(this.toString())},t.prototype.toString=function(){return this.stringStartMark+this.escapeString(this.value)},t.prototype.clone=function(e){var i=new t;return i.value=this.internalValue,i},t.prototype.escapeString=function(e){for(var i="",r=0,n=e.length;r<n;r++){var o=e[r];t.delimiters.indexOf(o);i+=o}return i},t.prototype.normalizeValue=function(t,e){return t},t.delimiters="()<>[]{}/%}",t.replacements=[" ","\t","\n","\r"],t}(),s=function(){function t(){this.forTest="test",this.forTest=t.obj}return t.obj="obj",t.endObj="endobj",t.r="R",t.whiteSpace=" ",t.slash="/",t.newLine="\r\n",t.stream="stream",t.endStream="endstream",t.xref="xref",t.f="f",t.n="n",t.trailer="trailer",t.startxref="startxref",t.eof="%%EOF",t.header="%PDF-1.5",t.beginText="BT",t.endText="ET",t.beginPath="m",t.appendLineSegment="l",t.stroke="S",t.fill="f",t.fillEvenOdd="f*",t.fillStroke="B",t.fillStrokeEvenOdd="B*",t.appendbeziercurve="c",t.appendRectangle="re",t.saveState="q",t.restoreState="Q",t.paintXObject="Do",t.modifyCtm="cm",t.modifyTM="Tm",t.setLineWidth="w",t.setLineCapStyle="J",t.setLineJoinStyle="j",t.setDashPattern="d",t.setFlatnessTolerance="i",t.closePath="h",t.closeStrokePath="s",t.closeFillStrokePath="b",t.setCharacterSpace="Tc",t.setWordSpace="Tw",t.setHorizontalScaling="Tz",t.setTextLeading="TL",t.setFont="Tf",t.setRenderingMode="Tr",t.setTextRise="Ts",t.setTextScaling="Tz",t.setCoords="Td",t.goToNextLine="T*",t.setText="Tj",t.setTextWithFormatting="TJ",t.setTextOnNewLine="'",t.selectcolorspaceforstroking="CS",t.selectcolorspacefornonstroking="cs",t.setrbgcolorforstroking="RG",t.setrbgcolorfornonstroking="rg",t.setcmykcolorforstroking="K",t.setcmykcolorfornonstroking="k",t.setgraycolorforstroking="G",t.setgraycolorfornonstroking="g",t.clipPath="W",t.clipPathEvenOdd="W*",t.endPath="n",t.setGraphicsState="gs",t.comment="%",t.evenOdd="*",t.setMiterLimit="M",t.setColorAndPattern="scn",t.setColorAndPatternStroking="SCN",t}(),a=function(){return function(){this.pages="Pages",this.kids="Kids",this.count="Count",this.resources="Resources",this.type="Type",this.size="Size",this.mediaBox="MediaBox",this.parent="Parent",this.root="Root",this.decodeParms="DecodeParms",this.filter="Filter",this.font="Font",this.type1="Type1",this.baseFont="BaseFont",this.encoding="Encoding",this.subtype="Subtype",this.contents="Contents",this.procset="ProcSet",this.colorSpace="ColorSpace",this.extGState="ExtGState",this.pattern="Pattern",this.xObject="XObject",this.length="Length",this.width="Width",this.height="Height",this.bitsPerComponent="BitsPerComponent",this.image="Image",this.dctdecode="DCTDecode",this.columns="Columns",this.blackIs1="BlackIs1",this.k="K",this.s="S",this.predictor="Predictor",this.deviceRgb="DeviceRGB",this.next="Next",this.action="Action",this.link="Link",this.a="A",this.annot="Annot",this.p="P",this.c="C",this.rect="Rect",this.uri="URI",this.annots="Annots",this.ca="ca",this.CA="CA",this.xyz="XYZ",this.fit="Fit",this.dest="Dest",this.BM="BM",this.flatedecode="FlateDecode",this.rotate="Rotate",this.bBox="BBox",this.form="Form",this.w="W",this.cIDFontType2="CIDFontType2",this.cIDToGIDMap="CIDToGIDMap",this.identity="Identity",this.dw="DW",this.fontDescriptor="FontDescriptor",this.cIDSystemInfo="CIDSystemInfo",this.fontName="FontName",this.flags="Flags",this.fontBBox="FontBBox",this.missingWidth="MissingWidth",this.stemV="StemV",this.italicAngle="ItalicAngle",this.capHeight="CapHeight",this.ascent="Ascent",this.descent="Descent",this.leading="Leading",this.avgWidth="AvgWidth",this.fontFile2="FontFile2",this.maxWidth="MaxWidth",this.xHeight="XHeight",this.stemH="StemH",this.registry="Registry",this.ordering="Ordering",this.supplement="Supplement",this.type0="Type0",this.identityH="Identity-H",this.toUnicode="ToUnicode",this.descendantFonts="DescendantFonts",this.background="Background",this.shading="Shading",this.matrix="Matrix",this.antiAlias="AntiAlias",this.function="Function",this.extend="Extend",this.shadingType="ShadingType",this.coords="Coords",this.domain="Domain",this.range="Range",this.functionType="FunctionType",this.bitsPerSample="BitsPerSample",this.patternType="PatternType",this.paintType="PaintType",this.tilingType="TilingType",this.xStep="XStep",this.yStep="YStep"}}(),h=function(){function t(t){if(this.position7=-1,this.primitiveItems=new n,this.prefix="<<",this.suffix=">>",this.resources=[],this.object=null,this.archive=!0,this.isFont=!1,void 0===t)this.primitiveItems=new n,this.encrypt=!0,this.dictionaryProperties=new a;else{this.primitiveItems=new n;for(var e=t.items.keys(),i=t.items.values(),r=0;r<t.items.size();r++)this.primitiveItems.setValue(e[r],i[r]);this.status=t.status,this.freezeChanges(this),this.encrypt=!0,this.dictionaryProperties=new a}}return Object.defineProperty(t.prototype,"items",{get:function(){return this.primitiveItems},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"status",{get:function(){return this.status7},set:function(t){this.status7=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"isSaving",{get:function(){return this.isSaving7},set:function(t){this.isSaving7=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"objectCollectionIndex",{get:function(){return this.index7},set:function(t){this.index7=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"clonedObject",{get:function(){return this.object},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"position",{get:function(){return this.position7},set:function(t){this.position7=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"Count",{get:function(){return this.primitiveItems.size()},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"Dictionary",{get:function(){return this},enumerable:!0,configurable:!0}),t.prototype.getArchive=function(){return this.archive},t.prototype.setArchive=function(t){this.archive=t},t.prototype.setEncrypt=function(t){this.encrypt=t,this.modify()},t.prototype.getEncrypt=function(){return this.encrypt},t.prototype.freezeChanges=function(t){this.bChanged=!1},t.prototype.clone=function(e){return new t},t.prototype.modify=function(){this.bChanged=!0},t.prototype.remove=function(t){"string"!=typeof t?(this.primitiveItems.remove(t.value),this.modify()):this.remove(new o(t))},t.prototype.containsKey=function(t){return this.primitiveItems.containsKey(t.toString())},t.prototype.onBeginSave=function(){this.beginSave.sender.beginSave()},t.prototype.onFontDictionaryBeginSave=function(){this.fontDictionaryBeginSave.sender.fontDictionaryBeginSave()},t.prototype.onDescendantFontBeginSave=function(){this.descendantFontBeginSave.sender.descendantFontBeginSave()},t.prototype.onTemplateBeginSave=function(){this.pageBeginDrawTemplate.sender.pageBeginSave()},t.prototype.onBeginAnnotationSave=function(){this.annotationBeginSave.sender.beginSave()},t.prototype.onSectionBeginSave=function(t){var e=this.sectionBeginSave;e.sender.beginSave(e.state,t)},t.prototype.save=function(t,e){void 0===e?this.save(t,!0):(t.write(this.prefix),void 0!==this.beginSave&&this.onBeginSave(),void 0!==this.descendantFontBeginSave&&this.onDescendantFontBeginSave(),void 0!==this.fontDictionaryBeginSave&&this.onFontDictionaryBeginSave(),void 0!==this.annotationBeginSave&&this.onBeginAnnotationSave(),void 0!==this.sectionBeginSave&&this.onSectionBeginSave(t),void 0!==this.pageBeginDrawTemplate&&this.onTemplateBeginSave(),this.Count>0&&this.saveItems(t),t.write(this.suffix),t.write(s.newLine))},t.prototype.saveItems=function(t){t.write(s.newLine);for(var e=this.primitiveItems.keys(),i=this.primitiveItems.values(),r=0;r<e.length;r++){var n=e[r];new o(n).save(t),t.write(s.whiteSpace);i[r].save(t),t.write(s.newLine)}},t}(),l=function(){return function(t){this.sender=t}}(),u=function(){return function(t){this.sender=t}}(),c=function(){return function(t){this.sender=t}}(),p=function(){return function(t){this.sender=t}}(),d=function(){return function(t,e){this.sender=t,this.state=e}}(),f=function(){return function(t){this.sender=t}}(),g=function(){function t(t){this.position5=-1,this.value=t}return Object.defineProperty(t.prototype,"intValue",{get:function(){return this.value},set:function(t){this.value=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"isInteger",{get:function(){return this.integer},set:function(t){this.integer=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"status",{get:function(){return this.status5},set:function(t){this.status5=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"isSaving",{get:function(){return this.isSaving5},set:function(t){this.isSaving5=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"objectCollectionIndex",{get:function(){return this.index5},set:function(t){this.index5=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"position",{get:function(){return this.position5},set:function(t){this.position5=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"clonedObject",{get:function(){return null},enumerable:!0,configurable:!0}),t.prototype.save=function(t){t.write(this.intValue.toString())},t.prototype.clone=function(e){return new t(this.value)},t.floatToString=function(t){var e=t.toFixed(2);return"0.00"===e&&(e=".00"),e},t.min=function(t,e,i){var r=Math.min(t,e);return Math.min(i,r)},t}(),m=function(){function t(e){if(this.startMark="[",this.endMark="]",this.position9=-1,this.clonedObject9=null,this.isFont=!1,void 0===e)this.internalElements=[];else if(void 0===e||e instanceof t){var i=e;this.internalElements=[];for(n=0;n<i.elements.length;n++)this.internalElements.push(i.elements[n])}else for(var r=e,n=0;n<r.length;n++){var o=new g(r[n]);this.add(o)}}return t.prototype.items=function(t){return this.internalElements[t]},Object.defineProperty(t.prototype,"count",{get:function(){return this.internalElements.length},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"status",{get:function(){return this.status9},set:function(t){this.status9=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"isSaving",{get:function(){return this.isSaving9},set:function(t){this.isSaving9=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"clonedObject",{get:function(){return this.clonedObject9},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"position",{get:function(){return this.position9},set:function(t){this.position9=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"objectCollectionIndex",{get:function(){return this.index9},set:function(t){this.index9=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"CrossTable",{get:function(){return this.pdfCrossTable},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"elements",{get:function(){return this.internalElements},enumerable:!0,configurable:!0}),t.prototype.add=function(t){void 0===this.internalElements&&(this.internalElements=[]),this.internalElements.push(t),this.markedChange()},t.prototype.markedChange=function(){this.bChanged=!0},t.prototype.contains=function(t){for(var e=0;e<this.internalElements.length;e++){var i=this.internalElements[e],r=t;if(null!=i&&void 0!==i&&null!=r&&void 0!==r&&i.value===r.value)return!0}return!1},t.prototype.getItems=function(t){return this.internalElements[t]},t.prototype.save=function(t){t.write(this.startMark);for(var e=0,i=this.count;e<i;e++)this.getItems(e).save(t),e+1!==i&&t.write(s.whiteSpace);t.write(this.endMark)},t.prototype.clone=function(e){this.clonedObject9=null;for(var i=new t,r=0;r<this.internalElements.length;r++){var n=this.internalElements[r];i.add(n.clone(e))}return i.pdfCrossTable=e,this.clonedObject9=i,i},t.fromRectangle=function(e){return new t([e.x,e.y,e.width,e.height])},t.prototype.insert=function(t,e){if(t<this.internalElements.length&&t>0){for(var i=[],r=0;r<t;r++)i.push(this.internalElements[r]);i.push(e);for(r=t;r<this.internalElements.length;r++)i.push(this.internalElements[r]);this.internalElements=i}else this.internalElements.push(e);this.markChanged()},t.prototype.indexOf=function(t){return this.internalElements.indexOf(t)},t.prototype.remove=function(t){var e=this.internalElements.indexOf(t);this.internalElements[e]=null,this.markChanged()},t.prototype.removeAt=function(t){if(this.internalElements.length>t){for(var e=[],i=0;i<t;i++)e.push(this.internalElements[i]);for(i=t+1;i<this.internalElements.length;i++)e.push(this.internalElements[i]);this.internalElements=e}this.markChanged()},t.prototype.clear=function(){this.internalElements=[],this.markChanged()},t.prototype.markChanged=function(){this.bChanged=!0},t}(),y=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),b=function(t){function i(e,i){var r=t.call(this,e)||this;return r.dicPrefix="stream",r.dicSuffix="endstream",r.clonedObject2=null,r.bCompress=!0,r.isImageStream=!1,r.isFontStream=!1,void 0!==e||void 0!==i?(r.dataStream2=[],r.dataStream2=i,r.bCompress2=!1):(r.dataStream2=[],r.bCompress2=!0),r}return y(i,t),Object.defineProperty(i.prototype,"internalStream",{get:function(){return this.dataStream2},set:function(t){this.dataStream2=[],this.dataStream2=t,this.modify()},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"isImage",{get:function(){return this.isImageStream},set:function(t){this.isImageStream=t},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"isFont",{get:function(){return this.isFontStream},set:function(t){this.isFontStream=t},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"compress",{get:function(){return this.bCompress},set:function(t){this.bCompress=t,this.modify()},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"data",{get:function(){return this.dataStream2},set:function(t){this.dataStream2=[],this.dataStream2=t,this.modify()},enumerable:!0,configurable:!0}),i.prototype.clearStream=function(){this.internalStream=[],this.items.containsKey(this.dictionaryProperties.filter)&&this.remove(this.dictionaryProperties.filter),this.bCompress=!0,this.modify()},i.prototype.write=function(t){if(null==t)throw new Error("ArgumentNullException:text");if(t.length<=0)throw new Error("ArgumentException: Can not write an empty string, text");this.dataStream2.push(t),this.modify()},i.prototype.writeBytes=function(t){if(null===t)throw new Error("ArgumentNullException:data");if(t.length<=0)throw new Error("ArgumentException: Can not write an empty bytes, data");for(var e="",i=0;i<t.length;i++)e+=String.fromCharCode(t[i]);this.dataStream2.push(e),this.modify()},i.prototype.onCmapBeginSave=function(){this.cmapBeginSave.sender.cmapBeginSave()},i.prototype.onFontProgramBeginSave=function(){this.fontProgramBeginSave.sender.fontProgramBeginSave()},i.prototype.compressContent=function(t,i){if(this.bCompress){for(var r=[],n=0;n<t.length;n++)r.push(t.charCodeAt(n));var o=new Uint8Array(r),s=new e.CompressedStreamWriter;s.write(o,0,o.length),s.close(),t=s.getCompressedString,this.addFilter(this.dictionaryProperties.flatedecode)}return t},i.prototype.addFilter=function(t){var e=this.items.getValue(this.dictionaryProperties.filter);if(e instanceof C){e=e.object}var i=e,r=e;null!=r&&((i=new m).insert(0,r),this.items.setValue(this.dictionaryProperties.filter,i)),r=new o(t),null==i?this.items.setValue(this.dictionaryProperties.filter,r):i.insert(0,r)},i.prototype.save=function(e){void 0!==this.cmapBeginSave&&this.onCmapBeginSave(),void 0!==this.fontProgramBeginSave&&this.onFontProgramBeginSave();for(var i="",r=0;r<this.data.length;r++)i+=this.data[r];i.length>1&&!this.isImage&&!this.isFont&&(i="q\r\n"+i+"Q\r\n");var n=(i=this.compressContent(i,e)).length;this.items.setValue(this.dictionaryProperties.length,new g(n)),t.prototype.save.call(this,e,!1),e.write(this.dicPrefix),e.write(s.newLine),i.length>0&&e.write(i),e.write(s.newLine),e.write(this.dicSuffix),e.write(s.newLine)},i.bytesToString=function(t){for(var e="",i=0;i<t.length;i++)e+=String.fromCharCode(t[i]);return e},i}(h),w=function(){return function(t){this.sender=t}}(),P=function(){return function(t){this.sender=t}}();!function(t){!function(t){t[t.None=0]="None",t[t.Ascii=1]="Ascii",t[t.Unicode=2]="Unicode"}(t.ForceEncoding||(t.ForceEncoding={}));var e;!function(t){t[t.StringValue=0]="StringValue",t[t.ByteBuffer=1]="ByteBuffer"}(e||(e={}))}(t.InternalEnum||(t.InternalEnum={}));var S=function(){function e(t){if(this.bHex=!1,this.position1=-1,this.clonedObject1=null,this.bDecrypted=!1,this.isParentDecrypted=!1,this.isPacked=!1,this.isFormField=!1,this.isColorSpace=!1,this.isHexString=!0,void 0===t)this.bHex=!1;else if(!(t.length>0&&"0xfeff"===t[0])){this.stringValue=t,this.data=[];for(var e=0;e<t.length;++e)this.data.push(t.charCodeAt(e))}}return Object.defineProperty(e.prototype,"hex",{get:function(){return this.bHex},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"value",{get:function(){return this.stringValue},set:function(t){this.stringValue=t,this.data=null},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"status",{get:function(){return this.status1},set:function(t){this.status1=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"isSaving",{get:function(){return this.isSaving1},set:function(t){this.isSaving1=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"objectCollectionIndex",{get:function(){return this.index1},set:function(t){this.index1=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"clonedObject",{get:function(){return this.clonedObject1},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"position",{get:function(){return this.position1},set:function(t){this.position1=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"CrossTable",{get:function(){return this.crossTable},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"converted",{get:function(){return this.bConverted},set:function(t){this.bConverted=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"encode",{get:function(){return this.bForceEncoding},set:function(t){this.bForceEncoding=t},enumerable:!0,configurable:!0}),e.bytesToHex=function(t){if(null==t)return"";return""},e.prototype.save=function(i){if(null===i)throw new Error("ArgumentNullException : writer");void 0!==this.encode&&this.encode===t.InternalEnum.ForceEncoding.Ascii?i.write(this.pdfEncode()):i.write(e.stringMark[0]+this.value+e.stringMark[1])},e.prototype.pdfEncode=function(){var i="";if(void 0!==this.encode&&this.encode===t.InternalEnum.ForceEncoding.Ascii){for(var r=this.escapeSymbols(this.value),n=0;n<r.length;n++)i+=String.fromCharCode(r[n]);i=e.stringMark[0]+i+e.stringMark[1]}else i=this.value;return i},e.prototype.escapeSymbols=function(t){for(var e=[],i=0;i<t.length;i++){var r=t.charCodeAt(i);switch(r){case 40:case 41:e.push(92),e.push(r);break;case 13:e.push(92),e.push(114);break;case 92:e.push(92),e.push(r);break;default:e.push(r)}}return e},e.prototype.clone=function(t){if(null!==this.clonedObject1&&this.clonedObject1.CrossTable===t)return this.clonedObject1;this.clonedObject1=null;var i=new e(this.stringValue);return i.bHex=this.bHex,i.crossTable=t,i.isColorSpace=this.isColorSpace,this.clonedObject1=i,i},e.toUnicodeArray=function(t,e){if(null==t)throw new Error("Argument Null Exception : value");for(var i=[],r=0;r<t.length;r++){var n=t.charCodeAt(r);i.push(n/256>>>0),i.push(255&n)}return i},e.byteToString=function(t){if(null==t)throw new Error("Argument Null Exception : stream");for(var e="",i=0;i<t.length;++i)e+=String.fromCharCode(t[i]);return e},e.stringMark="()",e.hexStringMark="<>",e.hexFormatPattern="{0:X2}",e}(),v=function(){function t(t,e){this.index3=-1,this.position3=-1,this.objNumber=0,this.genNumber=0,"number"==typeof t&&"number"==typeof e?(this.objNumber=t,this.genNumber=e):(this.objNumber=Number(t),this.genNumber=Number(e))}return Object.defineProperty(t.prototype,"status",{get:function(){return this.status3},set:function(t){this.status3=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"isSaving",{get:function(){return this.isSaving3},set:function(t){this.isSaving3=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"objectCollectionIndex",{get:function(){return this.index3},set:function(t){this.index3=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"position",{get:function(){return this.position3},set:function(t){this.position3=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"clonedObject",{get:function(){return null},enumerable:!0,configurable:!0}),t.prototype.save=function(t){t.write(this.toString())},t.prototype.toString=function(){return this.objNumber.toString()+" "+this.genNumber.toString()+" R"},t.prototype.clone=function(t){return null},t}(),C=function(){function t(t,e){this.index4=-1,this.position4=-1,this.objectIndex=-1,this.dictionaryProperties=new a,this.initialize(t)}return Object.defineProperty(t.prototype,"status",{get:function(){return this.status4},set:function(t){this.status4=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"isSaving",{get:function(){return this.isSaving4},set:function(t){this.isSaving4=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"objectCollectionIndex",{get:function(){return this.index4},set:function(t){this.index4=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"position",{get:function(){return this.position4},set:function(t){this.position4=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"clonedObject",{get:function(){return null},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"object",{get:function(){return this.primitiveObject},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"reference",{get:function(){return this.pdfReference},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"index",{get:function(){return this.objectIndex},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"element",{get:function(){return this.primitiveObject},enumerable:!0,configurable:!0}),t.prototype.initialize=function(t){if(t instanceof m||t instanceof h||t instanceof o||t instanceof g||t instanceof b||t instanceof v||t instanceof S)this.primitiveObject=t;else{var e=t;this.initialize(e.element)}},t.prototype.save=function(t){t.position;var e=t.document.crossTable;this.object.isSaving=!0;e.getReference(this.object).save(t)},t.prototype.clone=function(t){return null},t}(),B=function(){function t(){this.action=null,this.dictionaryProperties=new a,this.initialize()}return Object.defineProperty(t.prototype,"next",{get:function(){return this.action},set:function(t){this.action=t,this.dictionary.items.setValue(this.dictionaryProperties.next,new C(this.action))},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"dictionary",{get:function(){return void 0===this.pdfDictionary&&(this.pdfDictionary=new h),this.pdfDictionary},enumerable:!0,configurable:!0}),t.prototype.initialize=function(){this.dictionary.items.setValue(this.dictionaryProperties.type,new o(this.dictionaryProperties.action))},Object.defineProperty(t.prototype,"element",{get:function(){return this.dictionary},enumerable:!0,configurable:!0}),t}(),O=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),x=function(t){function e(e){var i=t.call(this)||this;return i.uniformResourceIdentifier="",i}return O(e,t),Object.defineProperty(e.prototype,"uri",{get:function(){return this.uniformResourceIdentifier},set:function(t){this.uniformResourceIdentifier=t,this.dictionary.items.setValue(this.dictionaryProperties.uri,new S(this.uniformResourceIdentifier))},enumerable:!0,configurable:!0}),e.prototype.initialize=function(){t.prototype.initialize.call(this),this.dictionary.items.setValue(this.dictionaryProperties.s,new o(this.dictionaryProperties.uri))},e}(B);!function(t){t[t.Left=0]="Left",t[t.Center=1]="Center",t[t.Right=2]="Right"}(t.PdfHorizontalAlignment||(t.PdfHorizontalAlignment={})),function(t){t[t.Top=0]="Top",t[t.Middle=1]="Middle",t[t.Bottom=2]="Bottom"}(t.PdfVerticalAlignment||(t.PdfVerticalAlignment={})),function(t){t[t.Left=0]="Left",t[t.Center=1]="Center",t[t.Right=2]="Right",t[t.Justify=3]="Justify"}(t.PdfTextAlignment||(t.PdfTextAlignment={})),function(t){t[t.Fill=0]="Fill",t[t.Stroke=1]="Stroke",t[t.FillStroke=2]="FillStroke",t[t.None=3]="None",t[t.ClipFlag=4]="ClipFlag",t[t.ClipFill=4]="ClipFill",t[t.ClipStroke=5]="ClipStroke",t[t.ClipFillStroke=6]="ClipFillStroke",t[t.Clip=7]="Clip"}(t.TextRenderingMode||(t.TextRenderingMode={})),function(t){t[t.Miter=0]="Miter",t[t.Round=1]="Round",t[t.Bevel=2]="Bevel"}(t.PdfLineJoin||(t.PdfLineJoin={})),function(t){t[t.Flat=0]="Flat",t[t.Round=1]="Round",t[t.Square=2]="Square"}(t.PdfLineCap||(t.PdfLineCap={})),function(t){t[t.Solid=0]="Solid",t[t.Dash=1]="Dash",t[t.Dot=2]="Dot",t[t.DashDot=3]="DashDot",t[t.DashDotDot=4]="DashDotDot",t[t.Custom=5]="Custom"}(t.PdfDashStyle||(t.PdfDashStyle={})),function(t){t[t.Winding=0]="Winding",t[t.Alternate=1]="Alternate"}(t.PdfFillMode||(t.PdfFillMode={})),function(t){t[t.Rgb=0]="Rgb",t[t.Cmyk=1]="Cmyk",t[t.GrayScale=2]="GrayScale",t[t.Indexed=3]="Indexed"}(t.PdfColorSpace||(t.PdfColorSpace={})),function(t){t[t.Normal=0]="Normal",t[t.Multiply=1]="Multiply",t[t.Screen=2]="Screen",t[t.Overlay=3]="Overlay",t[t.Darken=4]="Darken",t[t.Lighten=5]="Lighten",t[t.ColorDodge=6]="ColorDodge",t[t.ColorBurn=7]="ColorBurn",t[t.HardLight=8]="HardLight",t[t.SoftLight=9]="SoftLight",t[t.Difference=10]="Difference",t[t.Exclusion=11]="Exclusion",t[t.Hue=12]="Hue",t[t.Saturation=13]="Saturation",t[t.Color=14]="Color",t[t.Luminosity=15]="Luminosity"}(t.PdfBlendMode||(t.PdfBlendMode={})),function(t){t[t.Centimeter=0]="Centimeter",t[t.Pica=1]="Pica",t[t.Pixel=2]="Pixel",t[t.Point=3]="Point",t[t.Inch=4]="Inch",t[t.Document=5]="Document",t[t.Millimeter=6]="Millimeter"}(t.PdfGraphicsUnit||(t.PdfGraphicsUnit={})),function(t){t[t.Fit=0]="Fit",t[t.Center=1]="Center",t[t.Stretch=2]="Stretch",t[t.Tile=3]="Tile"}(t.PdfGridImagePosition||(t.PdfGridImagePosition={})),function(t){t[t.None=0]="None",t[t.LeftToRight=1]="LeftToRight",t[t.RightToLeft=2]="RightToLeft"}(t.PdfTextDirection||(t.PdfTextDirection={}));var L=function(){function e(t,i,r,n){void 0===t?void 0!==i&&void 0!==r&&void 0!==n?this.assignRGB(i,r,n):this.filled=!1:t instanceof e?(this.redColor=t.r,this.greenColor=t.g,this.blueColor=t.b,this.grayColor=t.gray,this.alpha=t.alpha,this.filled=0!==this.alpha):"number"==typeof t&&void 0===i&&void 0===r&&void 0===n?(t<0&&(t=0),t>1&&(t=1),this.redColor=t*e.maxColourChannelValue,this.greenColor=t*e.maxColourChannelValue,this.blueColor=t*e.maxColourChannelValue,this.cyanColor=t,this.magentaColor=t,this.yellowColor=t,this.blackColor=t,this.grayColor=t,this.alpha=e.maxColourChannelValue,this.filled=!0):void 0===n?this.assignRGB(t,i,r):this.assignRGB(i,r,n,t)}return e.prototype.assignRGB=function(t,i,r,n){void 0===t||void 0===i||void 0===r?this.filled=!1:(this.cyanColor=0,this.magentaColor=0,this.yellowColor=0,this.blackColor=0,this.grayColor=0,this.redColor=t,this.greenColor=i,this.blueColor=r,this.alpha=void 0===n?e.maxColourChannelValue:n,this.filled=!0,this.assignCMYK(t,i,r))},e.prototype.assignCMYK=function(t,i,r){var n=t/e.maxColourChannelValue,o=i/e.maxColourChannelValue,s=r/e.maxColourChannelValue,a=g.min(1-n,1-o,1-s),h=1===a?0:(1-n-a)/(1-a),l=1===a?0:(1-o-a)/(1-a),u=1===a?0:(1-s-a)/(1-a);this.blackColor=a,this.cyanColor=h,this.magentaColor=l,this.yellowColor=u},Object.defineProperty(e.prototype,"r",{get:function(){return this.redColor},set:function(t){this.redColor=t,this.assignCMYK(this.redColor,this.greenColor,this.blueColor),this.filled=!0},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"red",{get:function(){return this.r/e.maxColourChannelValue},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"b",{get:function(){return this.blueColor},set:function(t){this.blueColor=t,this.assignCMYK(this.redColor,this.greenColor,this.blueColor),this.filled=!0},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"blue",{get:function(){return this.b/e.maxColourChannelValue},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"c",{get:function(){return this.cyanColor},set:function(t){this.cyanColor=t<0?0:t>1?1:t,this.assignRGB(this.cyanColor,this.magentaColor,this.yellowColor,this.blackColor),this.filled=!0},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"k",{get:function(){return this.blackColor},set:function(t){this.blackColor=t<0?0:t>1?1:t,this.assignRGB(this.cyanColor,this.magentaColor,this.yellowColor,this.blackColor),this.filled=!0},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"m",{get:function(){return this.magentaColor},set:function(t){this.magentaColor=t<0?0:t>1?1:t,this.assignRGB(this.cyanColor,this.magentaColor,this.yellowColor,this.blackColor),this.filled=!0},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"y",{get:function(){return this.yellowColor},set:function(t){this.yellowColor=t<0?0:t>1?1:t,this.assignRGB(this.cyanColor,this.magentaColor,this.yellowColor,this.blackColor),this.filled=!0},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"g",{get:function(){return this.greenColor},set:function(t){this.greenColor=t,this.assignCMYK(this.redColor,this.greenColor,this.blueColor),this.filled=!0},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"green",{get:function(){return this.g/e.maxColourChannelValue},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"gray",{get:function(){return(this.redColor+this.greenColor+this.blueColor)/(3*e.maxColourChannelValue)},set:function(t){this.grayColor=t<0?0:t>1?1:t,this.r=this.grayColor*e.maxColourChannelValue,this.g=this.grayColor*e.maxColourChannelValue,this.b=this.grayColor*e.maxColourChannelValue,this.assignCMYK(this.redColor,this.greenColor,this.blueColor),this.filled=!0},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"isEmpty",{get:function(){return!this.filled},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"a",{get:function(){return this.alpha},set:function(t){this.alpha=t<0?0:t,this.filled=!0},enumerable:!0,configurable:!0}),e.prototype.toString=function(e,i){if(this.isEmpty)return"";var r="";switch(e){case t.PdfColorSpace.Rgb:r=this.rgbToString(i);break;case t.PdfColorSpace.GrayScale:r=this.grayScaleToString(i);break;case t.PdfColorSpace.Cmyk:r=this.cmykToString(i)}return r},e.prototype.grayScaleToString=function(t){var i=this.gray,r="",n=null;return null==(n=t?e.grayStringsSroke.containsKey(i)?e.grayStringsSroke.getValue(i):null:e.grayStringsFill.containsKey(i)?e.grayStringsFill.getValue(i):null)?t&&(r=i.toString()+" G",e.grayStringsSroke.setValue(i,r)):r=n.toString(),r+s.newLine},e.prototype.rgbToString=function(t){var i=this.r,r=this.g,n=this.b,o=(i<<16)+(r<<8)+n;t&&(o+=1<<24);var a="",h=null;if(e.rgbStrings.containsKey(o)&&(h=e.rgbStrings.getValue(o)),null==h){var l=i/e.maxColourChannelValue,u=r/e.maxColourChannelValue,c=n/e.maxColourChannelValue;a=t?l.toString()+" "+u.toString()+" "+c.toString()+" RG":l.toString()+" "+u.toString()+" "+c.toString()+" rg",e.rgbStrings.setValue(o,a)}else a=h.toString();return a+s.newLine},e.prototype.cmykToString=function(t){var e=this.c,i=this.m,r=this.y,n=this.b;return e.toString()+" "+i.toString()+" "+r.toString()+" "+n.toString()+" K"+s.newLine},e.prototype.toArray=function(e){var i=new m;switch(e){case t.PdfColorSpace.Rgb:i.add(new g(this.red)),i.add(new g(this.green)),i.add(new g(this.blue))}return i},e.rgbStrings=new n,e.grayStringsSroke=new n,e.grayStringsFill=new n,e.maxColourChannelValue=255,e}(),T=function(){return function(t,e){void 0===t?(this.x=0,this.y=0):(this.x=null!==t?t:0,this.y=null!==e?e:0)}}(),j=function(){return function(t,e){void 0===e?(this.height=0,this.width=0):(this.height=null!==e?e:0,this.width=null!==t?t:0)}}(),k=function(){return function(t,e,i,r){if(typeof t==typeof t&&void 0===t)this.x=0,this.y=0,this.height=0,this.width=0;else if(t instanceof T&&e instanceof j&&void 0===i){var n=t;this.x=n.x,this.y=n.y;var o=e;this.height=o.height,this.width=o.width}else{var s=t,a=e,h=i,l=r;this.x=s,this.y=a,this.height=l,this.width=h}}}(),V=function(){function t(t,e,i,r){this.left=t,this.top=e,this.right=i,this.bottom=r}return Object.defineProperty(t.prototype,"width",{get:function(){return this.right-this.left},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"height",{get:function(){return this.bottom-this.top},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"topLeft",{get:function(){return new T(this.left,this.top)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"size",{get:function(){return new j(this.width,this.height)},enumerable:!0,configurable:!0}),t.prototype.toString=function(){return this.topLeft+"x"+this.size},t}(),R=function(){function t(){}return t.prototype.clone=function(){return this},t}(),N=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),M=function(e){function i(t){var i=e.call(this)||this;return i.pdfColor=t,i}return N(i,e),Object.defineProperty(i.prototype,"color",{get:function(){return this.pdfColor},set:function(t){this.pdfColor=t},enumerable:!0,configurable:!0}),i.prototype.monitorChanges=function(t,e,i,r,n){if(null==e)throw new Error("ArgumentNullException:streamWriter");var o=!1;return o=!0,e.setColorAndSpace(this.pdfColor,n,!1),o},i.prototype.resetChanges=function(e){e.setColorAndSpace(new L(0,0,0),t.PdfColorSpace.Rgb,!1)},i}(R);!function(t){t[t.Regular=0]="Regular",t[t.Bold=1]="Bold",t[t.Italic=2]="Italic",t[t.Underline=4]="Underline",t[t.Strikeout=8]="Strikeout"}(t.PdfFontStyle||(t.PdfFontStyle={})),function(t){t[t.Helvetica=0]="Helvetica",t[t.Courier=1]="Courier",t[t.TimesRoman=2]="TimesRoman",t[t.Symbol=3]="Symbol",t[t.ZapfDingbats=4]="ZapfDingbats"}(t.PdfFontFamily||(t.PdfFontFamily={})),function(t){t[t.Standard=0]="Standard",t[t.TrueType=1]="TrueType",t[t.TrueTypeEmbedded=2]="TrueTypeEmbedded"}(t.PdfFontType||(t.PdfFontType={})),function(t){t[t.None=0]="None",t[t.Word=1]="Word",t[t.WordOnly=2]="WordOnly",t[t.Character=3]="Character"}(t.PdfWordWrapType||(t.PdfWordWrapType={})),function(t){t[t.None=0]="None",t[t.SuperScript=1]="SuperScript",t[t.SubScript=2]="SubScript"}(t.PdfSubSuperScript||(t.PdfSubSuperScript={})),function(t){t[t.Unknown=0]="Unknown",t[t.StandardEncoding=1]="StandardEncoding",t[t.MacRomanEncoding=2]="MacRomanEncoding",t[t.MacExpertEncoding=3]="MacExpertEncoding",t[t.WinAnsiEncoding=4]="WinAnsiEncoding",t[t.PdfDocEncoding=5]="PdfDocEncoding",t[t.IdentityH=6]="IdentityH"}(t.FontEncoding||(t.FontEncoding={})),function(t){t[t.Apple=0]="Apple",t[t.Microsoft=4]="Microsoft",t[t.Trimmed=6]="Trimmed"}(t.TtfCmapFormat||(t.TtfCmapFormat={})),function(t){t[t.Unknown=0]="Unknown",t[t.Symbol=1]="Symbol",t[t.Unicode=2]="Unicode",t[t.Macintosh=3]="Macintosh"}(t.TtfCmapEncoding||(t.TtfCmapEncoding={})),function(t){t[t.AppleUnicode=0]="AppleUnicode",t[t.Macintosh=1]="Macintosh",t[t.Iso=2]="Iso",t[t.Microsoft=3]="Microsoft"}(t.TtfPlatformID||(t.TtfPlatformID={})),function(t){t[t.Undefined=0]="Undefined",t[t.Unicode=1]="Unicode"}(t.TtfMicrosoftEncodingID||(t.TtfMicrosoftEncodingID={})),function(t){t[t.Roman=0]="Roman",t[t.Japanese=1]="Japanese",t[t.Chinese=2]="Chinese"}(t.TtfMacintoshEncodingID||(t.TtfMacintoshEncodingID={})),function(t){t[t.FixedPitch=1]="FixedPitch",t[t.Serif=2]="Serif",t[t.Symbolic=4]="Symbolic",t[t.Script=8]="Script",t[t.Nonsymbolic=32]="Nonsymbolic",t[t.Italic=64]="Italic",t[t.ForceBold=262144]="ForceBold"}(t.FontDescriptorFlags||(t.FontDescriptorFlags={})),function(t){t[t.Arg1And2AreWords=1]="Arg1And2AreWords",t[t.ArgsAreXyValues=2]="ArgsAreXyValues",t[t.RoundXyToGrid=4]="RoundXyToGrid",t[t.WeHaveScale=8]="WeHaveScale",t[t.Reserved=16]="Reserved",t[t.MoreComponents=32]="MoreComponents",t[t.WeHaveAnXyScale=64]="WeHaveAnXyScale",t[t.WeHaveTwoByTwo=128]="WeHaveTwoByTwo",t[t.WeHaveInstructions=256]="WeHaveInstructions",t[t.UseMyMetrics=512]="UseMyMetrics"}(t.TtfCompositeGlyphFlags||(t.TtfCompositeGlyphFlags={}));var A=function(){function e(e,i){this.scalingFactor=100,this.wordWrapType=t.PdfWordWrapType.Word,this.internalLineLimit=!0,this.wordWrapType=t.PdfWordWrapType.Word,void 0!==e&&"string"!=typeof e&&(this.textAlignment=e),void 0!==i&&(this.verticalAlignment=i)}return Object.defineProperty(e.prototype,"alignment",{get:function(){return this.textAlignment},set:function(t){this.textAlignment=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"textDirection",{get:function(){return this.direction},set:function(t){this.direction=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"lineAlignment",{get:function(){return void 0===this.verticalAlignment||null==this.verticalAlignment?t.PdfVerticalAlignment.Top:this.verticalAlignment},set:function(t){this.verticalAlignment=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"rightToLeft",{get:function(){return void 0!==this.isRightToLeft&&null!=this.isRightToLeft&&this.isRightToLeft},set:function(t){this.isRightToLeft=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"characterSpacing",{get:function(){return void 0===this.internalCharacterSpacing||null==this.internalCharacterSpacing?0:this.internalCharacterSpacing},set:function(t){this.internalCharacterSpacing=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"wordSpacing",{get:function(){return void 0===this.internalWordSpacing||null==this.internalWordSpacing?0:this.internalWordSpacing},set:function(t){this.internalWordSpacing=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"lineSpacing",{get:function(){return void 0===this.leading||null==this.leading?0:this.leading},set:function(t){this.leading=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"clipPath",{get:function(){return void 0!==this.clip&&null!=this.clip&&this.clip},set:function(t){this.clip=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"subSuperScript",{get:function(){return void 0===this.pdfSubSuperScript||null==this.pdfSubSuperScript?t.PdfSubSuperScript.None:this.pdfSubSuperScript},set:function(t){this.pdfSubSuperScript=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"paragraphIndent",{get:function(){return void 0===this.internalParagraphIndent||null==this.internalParagraphIndent?0:this.internalParagraphIndent},set:function(t){this.internalParagraphIndent=t,this.firstLineIndent=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"lineLimit",{get:function(){return this.internalLineLimit},set:function(t){this.internalLineLimit=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"measureTrailingSpaces",{get:function(){return void 0!==this.trailingSpaces&&null!=this.trailingSpaces&&this.trailingSpaces},set:function(t){this.trailingSpaces=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"noClip",{get:function(){return void 0!==this.isNoClip&&null!=this.isNoClip&&this.isNoClip},set:function(t){this.isNoClip=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"wordWrap",{get:function(){return this.wordWrapType},set:function(t){this.wordWrapType=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"horizontalScalingFactor",{get:function(){return this.scalingFactor},set:function(t){if(t<=0)throw new Error("ArgumentOutOfRangeException:The scaling factor cant be less of equal to zero, ScalingFactor");this.scalingFactor=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"firstLineIndent",{get:function(){return void 0===this.initialLineIndent||null==this.initialLineIndent?0:this.initialLineIndent},set:function(t){this.initialLineIndent=t},enumerable:!0,configurable:!0}),e.prototype.clone=function(){return this},e}(),D=function(){function t(t){if(this.currentPosition=0,null==t)throw new Error("ArgumentNullException:text");this.text=t}return Object.defineProperty(t.prototype,"length",{get:function(){return this.text.length},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"end",{get:function(){return this.currentPosition===this.text.length},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"position",{get:function(){return this.currentPosition},set:function(t){this.currentPosition=t},enumerable:!0,configurable:!0}),t.getCharsCount=function(t,e){if("string"==typeof e){if(null==t)throw new Error("ArgumentNullException:wholeText");for(var i=0,r=0;-1!==(r=t.indexOf(e,r));)i++,r++;return i}if(null==t)throw new Error("ArgumentNullException:text");if(null==e)throw new Error("ArgumentNullException:symbols");for(var n=0,o=0,s=t.length;o<s;o++){var a=t[o];this.contains(e,a)&&n++}return n},t.prototype.readLine=function(){for(var t=this.currentPosition;t<this.length;){var e=this.text[t];switch(e){case"\r":case"\n":var i=this.text.substr(this.currentPosition,t-this.currentPosition);return this.currentPosition=t+1,"\r"===e&&this.currentPosition<this.length&&"\n"===this.text[this.currentPosition]&&this.currentPosition++,i}t++}if(t>this.currentPosition){var r=this.text.substr(this.currentPosition,t-this.currentPosition);return this.currentPosition=t,r}return null},t.prototype.peekLine=function(){var t=this.currentPosition,e=this.readLine();return this.currentPosition=t,e},t.prototype.readWord=function(){for(var t=this.currentPosition;t<this.length;){var e=this.text[t];switch(e){case"\r":case"\n":var i=this.text.substr(this.currentPosition,t-this.currentPosition);return this.currentPosition=t+1,"\r"===e&&this.currentPosition<this.length&&"\n"===this.text[this.currentPosition]&&this.currentPosition++,i;case" ":case"\t":t===this.currentPosition&&t++;var r=this.text.substr(this.currentPosition,t-this.currentPosition);return this.currentPosition=t,r}t++}if(t>this.currentPosition){var n=this.text.substr(this.currentPosition,t-this.currentPosition);return this.currentPosition=t,n}return null},t.prototype.peekWord=function(){var t=this.currentPosition,e=this.readWord();return this.currentPosition=t,e},t.prototype.read=function(t){if(void 0===t){var e="0";return this.end||(e=this.text[this.currentPosition],this.currentPosition++),e}for(var i=0,r="";!this.end&&i<t;){r+=e=this.read(),i++}return r},t.prototype.peek=function(){var t="0";return this.end||(t=this.text[this.currentPosition]),t},t.prototype.close=function(){this.text=null},t.prototype.readToEnd=function(){var t;return t=0===this.currentPosition?this.text:this.text.substr(this.currentPosition,this.length-this.currentPosition),this.currentPosition=this.length,t},t.contains=function(t,e){for(var i=!1,r=0;r<t.length;r++)if(t[r]===e){i=!0;break}return i},t.whiteSpace=" ",t.tab="\t",t.spaces=[t.whiteSpace,t.tab],t.whiteSpacePattern="^[ \t]+$",t}(),F=function(){function e(){this.isOverloadWithPosition=!1}return e.prototype.layout=function(t,e,i,r,n,o,s){if(r instanceof k){this.initialize(t,e,i,r,n),this.isOverloadWithPosition=o,this.clientSize=s;var a=this.doLayout();return this.clear(),a}this.initialize(t,e,i,r),this.isOverloadWithPosition=n,this.clientSize=o;a=this.doLayout();return this.clear(),a},e.prototype.initialize=function(t,e,i,r,n){if("number"==typeof n){if(null==t)throw new Error("ArgumentNullException:text");if(null==e)throw new Error("ArgumentNullException:font");this.text=t,this.font=e,this.format=i,this.size=new j(r.width,r.height),this.rectangle=r,this.pageHeight=n,this.reader=new D(t)}else this.initialize(t,e,i,new k(new T(0,0),r),0)},e.prototype.clear=function(){this.font=null,this.format=null,this.reader.close(),this.reader=null,this.text=null},e.prototype.doLayout=function(){for(var t=new I,e=new I,i=[],r=this.reader.peekLine(),n=this.getLineIndent(!0);null!=r;){if(null!==(e=this.layoutLine(r,n))||void 0!==e){var o=0,s=this.copyToResult(t,e,i,o),a=s.success;if(o=s.numInserted,!a){this.reader.read(o);break}}this.reader.readLine(),r=this.reader.peekLine(),n=this.getLineIndent(!1)}return this.finalizeResult(t,i),t},e.prototype.getLineIndent=function(t){var e=0;return null!=this.format&&(e=t?this.format.firstLineIndent:this.format.paragraphIndent,e=this.size.width>0?Math.min(this.size.width,e):e),e},e.prototype.getLineHeight=function(){var t=this.font.height;return null!=this.format&&0!==this.format.lineSpacing&&(t=this.format.lineSpacing+this.font.height),t},e.prototype.getLineWidth=function(t){return this.font.getLineWidth(t,this.format)},e.prototype.layoutLine=function(e,i){var r=new I;r.layoutLineHeight=this.getLineHeight();var n=[],o=this.size.width,s=this.getLineWidth(e)+i,a=t.LineType.FirstParagraphLine,h=!0;if(o<=0||Math.round(s)<=Math.round(o))this.addToLineResult(r,n,e,s,t.LineType.NewLineBreak|a);else{var l="",u="";s=i;var c=i,p=new D(e),d=p.peekWord();for(d.length!==p.length&&" "===d&&(u+=d,l+=d,p.position+=1,d=p.peekWord());null!=d;){u+=d;var f=this.getLineWidth(u.toString())+c;if(" "===u.toString()&&(u="",f=0),f>o){if(this.getWrapType()===t.PdfWordWrapType.None)break;if(u.length===d.length){if(this.getWrapType()===t.PdfWordWrapType.WordOnly){r.textRemainder=e.substring(p.position);break}if(1===u.length){l+=d;break}h=!1,u="",d=p.peek().toString();continue}if(this.getLineWidth(d.toString())>o?this.format.wordWrap=t.PdfWordWrapType.Character:void 0!==this.format&&null!==this.format&&(this.format.wordWrap=t.PdfWordWrapType.Word),this.getWrapType()===t.PdfWordWrapType.Character&&h)h=!1,u="",u+=l.toString(),d=p.peek().toString();else{" "!==(g=l.toString())&&this.addToLineResult(r,n,g,s,t.LineType.LayoutBreak|a),this.isOverloadWithPosition&&(o=this.clientSize.width),u="",l="",s=0,c=0,f=0,a=t.LineType.None,d=h?d:p.peekWord(),h=!0}}else l+=d,s=f,h?(p.readWord(),d=p.peekWord()):(p.read(),d=p.peek().toString())}if(l.length>0){var g=l.toString();this.addToLineResult(r,n,g,s,t.LineType.NewLineBreak|t.LineType.LastParagraphLine)}p.close()}r.layoutLines=[];for(var m=0;m<n.length;m++)r.layoutLines.push(n[m]);return n=[],r},e.prototype.addToLineResult=function(t,e,i,r,n){var o=new E;o.text=i,o.width=r,o.lineType=n,e.push(o);var s=t.actualSize;s.height+=this.getLineHeight(),s.width=Math.max(s.width,r),t.size=s},e.prototype.copyToResult=function(t,e,i,r){var n=!0,o=null!=this.format&&!this.format.lineLimit,s=t.actualSize.height,a=this.size.height;if(this.pageHeight>0&&a+this.rectangle.y>this.pageHeight&&(a=this.rectangle.y-this.pageHeight,a=Math.max(a,-a)),r=0,null!=e.lines)for(var h=0,l=e.lines.length;h<l;h++){var u=s+e.lineHeight;if(!(u<=a||a<=0||o)){n=!1;break}var c=e.lines[h];r+=c.text.length,c=this.trimLine(c,0===i.length),i.push(c);var p=t.actualSize;p.width=Math.max(p.width,c.width),t.size=p,s=u}if(s!=t.size.height){var d=t.actualSize;d.height=s,t.size=d}return{success:n,numInserted:r}},e.prototype.finalizeResult=function(t,e){t.layoutLines=[];for(var i=0;i<e.length;i++)t.layoutLines.push(e[i]);t.layoutLineHeight=this.getLineHeight(),this.reader.end||(t.textRemainder=this.reader.readToEnd()),e=[]},e.prototype.trimLine=function(e,i){var r=e.text,n=e.width;e.lineType,t.LineType.FirstParagraphLine,null==this.format||this.format.rightToLeft;return(r=r.trim()).length!==e.text.length&&(n=this.getLineWidth(r),(e.lineType&t.LineType.FirstParagraphLine)>0&&(n+=this.getLineIndent(i))),e.text=r,e.width=n,e},e.prototype.getWrapType=function(){return null!=this.format?this.format.wordWrap:t.PdfWordWrapType.Word},e}(),I=function(){function t(){}return Object.defineProperty(t.prototype,"remainder",{get:function(){return this.textRemainder},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"actualSize",{get:function(){return void 0===this.size&&(this.size=new j(0,0)),this.size},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"lines",{get:function(){return this.layoutLines},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"lineHeight",{get:function(){return this.layoutLineHeight},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"empty",{get:function(){return null==this.layoutLines||0===this.layoutLines.length},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"lineCount",{get:function(){return this.empty?0:this.layoutLines.length},enumerable:!0,configurable:!0}),t}(),E=function(){function t(){}return Object.defineProperty(t.prototype,"lineType",{get:function(){return this.type},set:function(t){this.type=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"text",{get:function(){return this.content},set:function(t){this.content=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"width",{get:function(){return this.lineWidth},set:function(t){this.lineWidth=t},enumerable:!0,configurable:!0}),t}();!function(t){t[t.None=0]="None",t[t.NewLineBreak=1]="NewLineBreak",t[t.LayoutBreak=2]="LayoutBreak",t[t.FirstParagraphLine=4]="FirstParagraphLine",t[t.LastParagraphLine=8]="LastParagraphLine"}(t.LineType||(t.LineType={}));var G=function(){function e(e,i){this.fontStyle=t.PdfFontStyle.Regular,"number"==typeof e&&void 0===i?this.fontSize=e:(this.fontSize=e,this.setStyle(i))}return Object.defineProperty(e.prototype,"name",{get:function(){return this.metrics.name},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"size",{get:function(){return this.fontSize},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"height",{get:function(){return this.metrics.getHeight(null)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"style",{get:function(){return this.fontStyle},set:function(t){this.fontStyle=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"bold",{get:function(){return(this.style&t.PdfFontStyle.Bold)>0},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"italic",{get:function(){return(this.style&t.PdfFontStyle.Italic)>0},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"strikeout",{get:function(){return(this.style&t.PdfFontStyle.Strikeout)>0},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"underline",{get:function(){return(this.style&t.PdfFontStyle.Underline)>0},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"metrics",{get:function(){return this.fontMetrics},set:function(t){this.fontMetrics=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"element",{get:function(){return this.pdfFontInternals},enumerable:!0,configurable:!0}),e.prototype.measureString=function(t,e,i,r,n){if("string"==typeof t&&void 0===e)return this.measureString(t,null);if("string"==typeof t&&(e instanceof A||null==e)&&void 0===i&&void 0===r){var o=e;return this.measureString(t,o,0,0)}if("string"==typeof t&&(e instanceof A||null==e)&&"number"==typeof i&&"number"==typeof r){o=e;return this.measureString(t,0,o,i,r)}if("string"==typeof t&&"number"==typeof e&&(i instanceof A||null==i)&&"number"==typeof r&&"number"==typeof n){var s=new j(e,0),a=i;return this.measureString(t,s,a,r,n)}if(null==t)throw Error('ArgumentNullException("text")');o=e,a=i;var h=(new F).layout(t,this,a,o,!1,new j(0,0));return r=t.length,n=h.empty?0:h.lines.length,h.actualSize},e.prototype.equalsTo=function(t){return this.equalsToFont(t)},e.prototype.getInternals=function(){return this.pdfFontInternals},e.prototype.setInternals=function(t){if(null==t)throw new Error("ArgumentNullException:internals");this.pdfFontInternals=t},e.prototype.setStyle=function(t){this.fontStyle=t},e.prototype.applyFormatSettings=function(t,e,i){var r=i;if(null!=e&&i>0&&(0!==e.characterSpacing&&(r+=(t.length-1)*e.characterSpacing),0!==e.wordSpacing)){var n=D.spaces;r+=D.getCharsCount(t,n)*e.wordSpacing}return r},e.charSizeMultiplier=.001,e.syncObject=new Object,e}(),z=function(){function t(t){this.streamWriter=t}return Object.defineProperty(t.prototype,"document",{get:function(){return this.pdfDocument},set:function(t){this.pdfDocument=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"position",{get:function(){return this.streamWriter.buffer.size},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"length",{get:function(){return this.streamWriter.buffer.size},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"stream",{get:function(){return this.streamWriter},enumerable:!0,configurable:!0}),t.prototype.write=function(t){var e=t;this.streamWriter.write(e)},t}();!function(t){t[t.None=0]="None",t[t.Registered=1]="Registered"}(t.ObjectStatus||(t.ObjectStatus={}));var W=function(){function e(){this.objectCollections=[],this.mainObjectCollection=new n,this.primitiveObjectCollection=new n}return Object.defineProperty(e.prototype,"count",{get:function(){return this.objectCollections.length},enumerable:!0,configurable:!0}),e.prototype.items=function(t){return this.objectCollections[t]},Object.defineProperty(e.prototype,"outIsNew",{get:function(){return this.isNew},enumerable:!0,configurable:!0}),e.prototype.add=function(e){var i=new H(e);this.objectCollections.push(i),this.primitiveObjectCollection.containsKey(e)||this.primitiveObjectCollection.setValue(e,this.objectCollections.length-1),e.position=this.index=this.objectCollections.length-1,e.status=t.ObjectStatus.Registered},e.prototype.lookFor=function(t){var e=-1;if(-1!==t.position)return t.position;if(this.primitiveObjectCollection.containsKey(t)&&this.count===this.primitiveObjectCollection.size())e=this.primitiveObjectCollection.getValue(t);else for(var i=this.count-1;i>=0;i--){if(this.objectCollections[i].object===t){e=i;break}}return e},e.prototype.getReference=function(t,e){this.index=this.lookFor(t);this.isNew=!1;return{reference:this.objectCollections[this.index].reference,wasNew:e}},e.prototype.trySetReference=function(t,e,i){this.index=this.lookFor(t);return this.objectCollections[this.index].setReference(e),!0},e.prototype.destroy=function(){for(var t=0,e=this.objectCollections;t<e.length;t++){var i=e[t];void 0!==i&&(i.pdfObject.position=-1,i.pdfObject.isSaving=void 0,i.pdfObject.objectCollectionIndex=void 0,i.pdfObject.position=void 0)}this.objectCollections=[],this.mainObjectCollection=new n,this.primitiveObjectCollection=new n},e}(),H=function(){function t(t,e){this.pdfObject=t,this.pdfReference=e}return Object.defineProperty(t.prototype,"object",{get:function(){return this.pdfObject},set:function(t){this.pdfObject=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"reference",{get:function(){return this.pdfReference},enumerable:!0,configurable:!0}),t.prototype.setReference=function(t){this.pdfReference=t},t}(),_=function(){function t(t){this.isStreamCopied=!1,t instanceof Ce&&(this.document=t)}return Object.defineProperty(t.prototype,"pdfObjects",{get:function(){return this.objects},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"crossTable",{get:function(){return this.pdfCrossTable},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"currentSavingObj",{get:function(){return this.currentSavingObject},set:function(t){this.currentSavingObject=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"catalog",{get:function(){return this.pdfCatalog},set:function(t){this.pdfCatalog=t},enumerable:!0,configurable:!0}),t.prototype.setMainObjectCollection=function(t){this.objects=t},t.prototype.setCrossTable=function(t){this.pdfCrossTable=t},t.prototype.setCatalog=function(t){this.pdfCatalog=t},t.prototype.save=function(t){var e=this,r=new i.Encoding(!0),n=new i.StreamWriter(r);if(void 0===t){var o=new i.Encoding(!0),s=new i.StreamWriter(o);return new Promise(function(t,i){var r={};r.blobData=new Blob([e.document.docSave(s,!0)],{type:"application/pdf"}),t(r)})}this.document.docSave(n,t,!0)},t.prototype.clone=function(){return this.document},t}();!function(t){t[t.Free=0]="Free",t[t.Normal=1]="Normal",t[t.Packed=2]="Packed"}(t.ObjectType||(t.ObjectType={}));var K=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),U=function(t){function e(){var e=t.call(this)||this;return e.sections=null,e.tempDictionaryProperties=new a,e.items.setValue((new a).type,new o("Catalog")),e}return K(e,t),Object.defineProperty(e.prototype,"pages",{get:function(){return this.sections},set:function(t){t.element;this.sections=t,this.items.setValue(this.tempDictionaryProperties.pages,new C(t))},enumerable:!0,configurable:!0}),e}(h),q=function(){function e(){this.objects=new n,this.maxGenNumIndex=0,this.objectCount=0,this.dictionaryProperties=new a}return Object.defineProperty(e.prototype,"isMerging",{get:function(){return this.merging},set:function(t){this.merging=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"trailer",{get:function(){return null==this.internalTrailer&&(this.internalTrailer=new b),this.internalTrailer},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"document",{get:function(){return this.pdfDocument},set:function(t){this.pdfDocument=t,this.items=this.pdfDocument.pdfObjects},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"pdfObjects",{get:function(){return this.items},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"objectCollection",{get:function(){return this.pdfDocument.pdfObjects},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"count",{get:function(){return this.objectCount},set:function(t){this.objectCount=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"nextObjNumber",{get:function(){return this.count=this.count+1,this.count},enumerable:!0,configurable:!0}),e.prototype.save=function(t,e){this.saveHead(t),this.mappedReferences=null,this.objects.clear(),this.markTrailerReferences(),this.saveObjects(t);var i=this.count,r=t.position;this.registerObject(0,new v(0,-1),!0);t.write(s.xref),t.write(s.newLine),this.saveSections(t),this.saveTrailer(t,this.count,0),this.saveTheEndess(t,r),this.count=i;for(var n=0;n<this.objectCollection.count;++n){this.objectCollection.items(n).object.isSaving=!1}if(void 0===e)return t.stream.buffer;t.stream.save(e)},e.prototype.saveTheEndess=function(t,e){t.write(s.newLine+s.startxref+s.newLine),t.write(e.toString()+s.newLine),t.write(s.eof+s.newLine)},e.prototype.saveTrailer=function(t,e,i){t.write(s.trailer+s.newLine);var r=this.trailer;r.items.setValue(this.dictionaryProperties.size,new g(this.objectCount+1)),(r=new h(r)).setEncrypt(!1),r.save(t)},e.prototype.saveSections=function(t){var e=0,i=0;do{i=this.prepareSubsection(e),this.saveSubsection(t,e,i),e+=i}while(0!==i)},e.prototype.saveSubsection=function(e,i,r){if(!(r<=0||i>=this.count)){e.write(i+" "+(r+1)+s.newLine);for(var n=i;n<=i+r;++n){var o=this.objects.getValue(n),a="";a=o.type===t.ObjectType.Free?this.getItem(o.offset,65535,!0):this.getItem(o.offset,o.generation,!1),e.write(a)}}},e.prototype.getItem=function(t,e,i){var r="",n=10-t.toString().length;e<=0&&(e=0);for(var o=5-e.toString().length<=0?0:5-e.toString().length,a=0;a<n;a++)r+="0";r=r+t.toString()+" ";for(a=0;a<o;a++)r+="0";return r=r+e.toString()+" ",r=r+(i?s.f:s.n)+s.newLine},e.prototype.prepareSubsection=function(t){for(var e,i=0,r=this.count,n=0;n<this.document.pdfObjects.count;n++)this.document.pdfObjects.items(n).reference.toString().split(" ");if(t>=r)return i;for(e=t;e<r;++e)break;for(t=e;e<r;++e)++i;return i},e.prototype.markTrailerReferences=function(){this.trailer.items.keys(),this.trailer.items.values()},e.prototype.saveHead=function(t){var e=this.generateFileVersion(t.document);t.write("%PDF-"+e),t.write(s.newLine)},e.prototype.generateFileVersion=function(t){return"1."+4..toString()},e.prototype.getReference=function(t,e){if(void 0===e){return this.getReference(t,!1)}return this.getSubReference(t,e)},e.prototype.getSubReference=function(e,i){var r,n=!1,o=null;if(this.items.count>0&&e.objectCollectionIndex>0&&this.items.count>e.objectCollectionIndex-1){var s=this.document.pdfObjects.getReference(e,r);o=s.reference,r=s.wasNew}if(r=null==o&&e.status!==t.ObjectStatus.Registered,null==o){var a=this.nextObjNumber;o=new v(a,0);if(r){this.document.pdfObjects.add(e),this.document.pdfObjects.trySetReference(e,o,void 0);var h=this.document.pdfObjects.count-1,l=this.document.pdfObjects.objectCollections[h].reference.objNumber,u=this.document.pdfObjects.objectCollections[this.document.pdfObjects.count-1];this.document.pdfObjects.mainObjectCollection.setValue(l,u),e.position=-1}else this.document.pdfObjects.trySetReference(e,o,void 0);e.objectCollectionIndex=o.objNumber,e.status=t.ObjectStatus.None,n=!0}return n||this.bForceNew,o},e.prototype.saveObjects=function(t){for(var e=this.objectCollection,i=0;i<e.count;++i){var r=e.items(i).object;r.isSaving=!0,this.saveIndirectObject(r,t)}},e.prototype.saveIndirectObject=function(t,e){var i=this.getReference(t);t instanceof U&&this.trailer.items.setValue(this.dictionaryProperties.root,i),this.pdfDocument.currentSavingObj=i;t.getArchive(),this.registerObject(e.position,i),this.doSaveObject(t,i,e)},e.prototype.doSaveObject=function(t,e,i){i.length;i.write(e.objNumber.toString()),i.write(s.whiteSpace),i.write(e.genNumber.toString()),i.write(s.whiteSpace),i.write(s.obj),i.write(s.newLine),t.save(i);i.stream;i.write(s.endObj),i.write(s.newLine)},e.prototype.registerObject=function(t,e,i){"boolean"==typeof i?(this.objects.setValue(e.objNumber,new Y(t,e,i)),this.maxGenNumIndex=Math.max(this.maxGenNumIndex,e.genNumber)):void 0===i&&(this.objects.setValue(e.objNumber,new Y(t,e)),this.maxGenNumIndex=Math.max(this.maxGenNumIndex,e.genNumber))},e.dereference=function(t){return null!=t&&(t=t.object),t},e}(),Y=function(){function e(e,i,r){var n=e;this.offsetNumber=n;var o=i;this.generation=o.genNumber,this.object=o.objNumber,this.type=void 0===r?t.ObjectType.Normal:t.ObjectType.Free}return Object.defineProperty(e.prototype,"objectNumber",{get:function(){return this.object},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"offset",{get:function(){return this.offsetNumber},enumerable:!0,configurable:!0}),e}(),X=function(){function t(){}return t.letter=new j(612,792),t.note=new j(540,720),t.legal=new j(612,1008),t.a0=new j(2380,3368),t.a1=new j(1684,2380),t.a2=new j(1190,1684),t.a3=new j(842,1190),t.a4=new j(595,842),t.a5=new j(421,595),t.a6=new j(297,421),t.a7=new j(210,297),t.a8=new j(148,210),t.a9=new j(105,148),t.a10=new j(74,105),t.b0=new j(2836,4008),t.b1=new j(2004,2836),t.b2=new j(1418,2004),t.b3=new j(1002,1418),t.b4=new j(709,1002),t.b5=new j(501,709),t.archE=new j(2592,3456),t.archD=new j(1728,2592),t.archC=new j(1296,1728),t.archB=new j(864,1296),t.archA=new j(648,864),t.flsa=new j(612,936),t.halfLetter=new j(396,612),t.letter11x17=new j(792,1224),t.ledger=new j(1224,792),t}();!function(t){t[t.Portrait=0]="Portrait",t[t.Landscape=1]="Landscape"}(t.PdfPageOrientation||(t.PdfPageOrientation={})),function(t){t[t.RotateAngle0=0]="RotateAngle0",t[t.RotateAngle90=1]="RotateAngle90",t[t.RotateAngle180=2]="RotateAngle180",t[t.RotateAngle270=3]="RotateAngle270"}(t.PdfPageRotateAngle||(t.PdfPageRotateAngle={})),function(t){t[t.None=0]="None",t[t.Numeric=1]="Numeric",t[t.LowerLatin=2]="LowerLatin",t[t.LowerRoman=3]="LowerRoman",t[t.UpperLatin=4]="UpperLatin",t[t.UpperRoman=5]="UpperRoman"}(t.PdfNumberStyle||(t.PdfNumberStyle={})),function(t){t[t.None=0]="None",t[t.Bottom=1]="Bottom",t[t.Top=2]="Top",t[t.Left=3]="Left",t[t.Right=4]="Right",t[t.Fill=5]="Fill"}(t.PdfDockStyle||(t.PdfDockStyle={})),function(t){t[t.None=0]="None",t[t.TopLeft=1]="TopLeft",t[t.TopCenter=2]="TopCenter",t[t.TopRight=3]="TopRight",t[t.MiddleLeft=4]="MiddleLeft",t[t.MiddleCenter=5]="MiddleCenter",t[t.MiddleRight=6]="MiddleRight",t[t.BottomLeft=7]="BottomLeft",t[t.BottomCenter=8]="BottomCenter",t[t.BottomRight=9]="BottomRight"}(t.PdfAlignmentStyle||(t.PdfAlignmentStyle={})),function(t){t[t.None=0]="None",t[t.Top=1]="Top",t[t.Bottom=2]="Bottom",t[t.Left=3]="Left",t[t.Right=4]="Right"}(t.TemplateType||(t.TemplateType={}));var J=function(){function t(){this.pdfMargin=40,this.setMargins(this.pdfMargin)}return Object.defineProperty(t.prototype,"left",{get:function(){return this.leftMargin},set:function(t){this.leftMargin=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"top",{get:function(){return this.topMargin},set:function(t){this.topMargin=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"right",{get:function(){return this.rightMargin},set:function(t){this.rightMargin=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"bottom",{get:function(){return this.bottomMargin},set:function(t){this.bottomMargin=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"all",{set:function(t){this.setMargins(t)},enumerable:!0,configurable:!0}),t.prototype.setMargins=function(t,e,i,r){void 0===e?this.leftMargin=this.topMargin=this.rightMargin=this.bottomMargin=t:void 0===i?(this.leftMargin=this.rightMargin=t,this.bottomMargin=this.topMargin=e):(this.leftMargin=t,this.topMargin=e,this.rightMargin=i,this.bottomMargin=r)},t.prototype.clone=function(){return this},t}(),Z=function(){function e(e){this.pageMargins=new J,this.pageSize=X.a4,this.rotateAngle=t.PdfPageRotateAngle.RotateAngle0,this.pageOrientation=t.PdfPageOrientation.Portrait,this.pageOrigin=new T(0,0),this.isRotation=!1,"number"==typeof e&&this.pageMargins.setMargins(e)}return Object.defineProperty(e.prototype,"size",{get:function(){return this.pageSize},set:function(t){this.setSize(t)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"orientation",{get:function(){return this.pageOrientation},set:function(t){this.pageOrientation!==t&&(this.pageOrientation=t,this.updateSize(t))},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"margins",{get:function(){return this.pageMargins},set:function(t){this.pageMargins=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"width",{get:function(){return this.pageSize.width},set:function(t){this.pageSize.width=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"height",{get:function(){return this.pageSize.height},set:function(t){this.pageSize.height=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"origin",{get:function(){return this.pageOrigin},set:function(t){this.pageOrigin=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"rotate",{get:function(){return this.rotateAngle},set:function(t){this.rotateAngle=t,this.isRotation=!0},enumerable:!0,configurable:!0}),e.prototype.updateSize=function(e){var i=Math.min(this.pageSize.width,this.pageSize.height),r=Math.max(this.pageSize.width,this.pageSize.height);switch(e){case t.PdfPageOrientation.Portrait:this.pageSize=new j(i,r);break;case t.PdfPageOrientation.Landscape:this.pageSize=new j(r,i)}},e.prototype.clone=function(){return this.pageMargins=this.pageMargins.clone(),this},e.prototype.getActualSize=function(){var t=this.width-(this.margins.left+this.margins.right),e=this.height-(this.margins.top+this.margins.bottom);return new j(t,e)},e.prototype.setSize=function(e){var i=Math.min(e.width,e.height),r=Math.max(e.width,e.height);this.orientation===t.PdfPageOrientation.Portrait?this.pageSize=new j(i,r):this.pageSize=new j(r,i)},e}(),$=function(){function t(t){if(null==t)throw new Error("ArgumentNullException:stream");this.stream=t}return t.prototype.clear=function(){this.stream.clearStream()},t.prototype.setGraphicsState=function(t){t instanceof o?(this.stream.write(t.toString()),this.stream.write(s.whiteSpace),this.writeOperator(s.setGraphicsState)):(this.stream.write(s.slash),this.stream.write(t),this.stream.write(s.whiteSpace),this.writeOperator(s.setGraphicsState))},t.prototype.executeObject=function(t){this.stream.write(t.toString()),this.stream.write(s.whiteSpace),this.writeOperator(s.paintXObject),this.stream.write(s.newLine)},t.prototype.closePath=function(){this.writeOperator(s.closePath)},t.prototype.clipPath=function(t){this.stream.write(s.clipPath),t&&this.stream.write(s.evenOdd),this.stream.write(s.whiteSpace),this.stream.write(s.endPath),this.stream.write(s.newLine)},t.prototype.closeFillStrokePath=function(t){this.stream.write(s.closeFillStrokePath),t?(this.stream.write(s.evenOdd),this.stream.write(s.newLine)):this.stream.write(s.newLine)},t.prototype.fillStrokePath=function(t){this.stream.write(s.fillStroke),t?(this.stream.write(s.evenOdd),this.stream.write(s.newLine)):this.stream.write(s.newLine)},t.prototype.fillPath=function(t){this.stream.write(s.fill),t?(this.stream.write(s.evenOdd),this.stream.write(s.newLine)):this.stream.write(s.newLine)},t.prototype.endPath=function(){this.writeOperator(s.n)},t.prototype.closeFillPath=function(t){this.writeOperator(s.closePath),this.stream.write(s.fill),t?(this.stream.write(s.evenOdd),this.stream.write(s.newLine)):this.stream.write(s.newLine)},t.prototype.closeStrokePath=function(){this.writeOperator(s.closeStrokePath)},t.prototype.setTextScaling=function(t){this.stream.write(g.floatToString(t)),this.stream.write(s.whiteSpace),this.writeOperator(s.setTextScaling)},t.prototype.strokePath=function(){this.writeOperator(s.stroke)},t.prototype.restoreGraphicsState=function(){this.writeOperator(s.restoreState)},t.prototype.saveGraphicsState=function(){this.writeOperator(s.saveState)},t.prototype.startNextLine=function(t,e){void 0===t?this.writeOperator(s.goToNextLine):t instanceof T?(this.writePoint(t),this.writeOperator(s.setCoords)):(this.writePoint(t,e),this.writeOperator(s.setCoords))},t.prototype.showText=function(t){this.checkTextParam(t),this.writeText(t),this.writeOperator(s.setText)},t.prototype.setLeading=function(t){this.stream.write(g.floatToString(t)),this.stream.write(s.whiteSpace),this.writeOperator(s.setTextLeading)},t.prototype.beginPath=function(t,e){this.writePoint(t,e),this.writeOperator(s.beginPath)},t.prototype.beginText=function(){this.writeOperator(s.beginText)},t.prototype.endText=function(){this.writeOperator(s.endText)},t.prototype.appendRectangle=function(t,e,i,r){t instanceof k?this.appendRectangle(t.x,t.y,t.width,t.height):(this.writePoint(t,e),this.writePoint(i,r),this.writeOperator(s.appendRectangle))},t.prototype.appendLineSegment=function(t,e){t instanceof T?this.appendLineSegment(t.x,t.y):(this.writePoint(t,e),this.writeOperator(s.appendLineSegment))},t.prototype.setTextRenderingMode=function(t){this.stream.write(t.toString()),this.stream.write(s.whiteSpace),this.writeOperator(s.setRenderingMode)},t.prototype.setCharacterSpacing=function(t){this.stream.write(g.floatToString(t)),this.stream.write(s.whiteSpace),this.stream.write(s.setCharacterSpace),this.stream.write(s.newLine)},t.prototype.setWordSpacing=function(t){this.stream.write(g.floatToString(t)),this.stream.write(s.whiteSpace),this.writeOperator(s.setWordSpace)},t.prototype.showNextLineText=function(t,e){t instanceof S?(this.checkTextParam(t),this.writeText(t),this.writeOperator(s.setTextOnNewLine)):(this.checkTextParam(t),this.writeText(t,e),this.writeOperator(s.setTextOnNewLine))},t.prototype.setColorSpace=function(t,e){if(t instanceof o&&"boolean"==typeof e){var i=t,r=(n=e)?s.selectcolorspaceforstroking:s.selectcolorspacefornonstroking;this.stream.write(i.toString()),this.stream.write(s.whiteSpace),this.stream.write(r),this.stream.write(s.newLine)}else{i=t;var n=e;this.setColorSpace(new o(i),n)}},t.prototype.modifyCtm=function(t){if(null==t)throw new Error("ArgumentNullException:matrix");this.stream.write(t.toString()),this.stream.write(s.whiteSpace),this.writeOperator(s.modifyCtm)},t.prototype.setFont=function(t,e,i){if("string"==typeof e)this.setFont(t,new o(e),i);else{if(null==t)throw new Error("ArgumentNullException:font");this.stream.write(e.toString()),this.stream.write(s.whiteSpace),this.stream.write(g.floatToString(i)),this.stream.write(s.whiteSpace),this.writeOperator(s.setFont)}},t.prototype.writeOperator=function(t){this.stream.write(t),this.stream.write(s.newLine)},t.prototype.checkTextParam=function(t){if(null==t)throw new Error("ArgumentNullException:text");if("string"==typeof t&&""===t)throw new Error("ArgumentException:The text can not be an empty string, text")},t.prototype.writeText=function(t,e){if(t instanceof S&&void 0===e)this.stream.write(t.pdfEncode());else{var i=void 0,r=void 0;e?(i=S.hexStringMark[0],r=S.hexStringMark[1]):(i=S.stringMark[0],r=S.stringMark[1]),this.stream.write(i),this.stream.write(t),this.stream.write(r)}},t.prototype.writePoint=function(t,e){if(t instanceof T&&void 0===e)this.writePoint(t.x,t.y);else{var i=t;this.stream.write(g.floatToString(i)),this.stream.write(s.whiteSpace),e=this.updateY(e),this.stream.write(g.floatToString(e)),this.stream.write(s.whiteSpace)}},t.prototype.updateY=function(t){return-t},t.prototype.write=function(t){var e="";e+=t,e+=s.newLine,this.writeOperator(e)},t.prototype.writeComment=function(t){if(!(null!=t&&t.length>0))throw new Error("Invalid comment");var e="";e+=s.comment,e+=s.whiteSpace,e+=t,this.writeOperator(e)},t.prototype.setColorAndSpace=function(t,e,i){t.isEmpty||(this.stream.write(t.toString(e,i)),this.stream.write(s.newLine))},t.prototype.setLineDashPattern=function(t,e){this.setLineDashPatternHelper(t,e)},t.prototype.setLineDashPatternHelper=function(t,e){var i="[";if(t.length>1)for(var r=0;r<t.length;r++)r===t.length-1?i+=t[r].toString():i+=t[r].toString()+" ";i+="] ",i+=e.toString(),i+=" "+s.setDashPattern,this.stream.write(i),this.stream.write(s.newLine)},t.prototype.setMiterLimit=function(t){this.stream.write(g.floatToString(t)),this.stream.write(s.whiteSpace),this.writeOperator(s.setMiterLimit)},t.prototype.setLineWidth=function(t){this.stream.write(g.floatToString(t)),this.stream.write(s.whiteSpace),this.writeOperator(s.setLineWidth)},t.prototype.setLineCap=function(t){this.stream.write(t.toString()),this.stream.write(s.whiteSpace),this.writeOperator(s.setLineCapStyle)},t.prototype.setLineJoin=function(t){this.stream.write(t.toString()),this.stream.write(s.whiteSpace),this.writeOperator(s.setLineJoinStyle)},Object.defineProperty(t.prototype,"position",{get:function(){return this.stream.position},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"length",{get:function(){var t=0;if(0!==this.stream.data.length&&-1!==this.stream.data.length)for(var e=0;e<this.stream.data.length;e++)t+=this.stream.data[e].length;return t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"document",{get:function(){return null},enumerable:!0,configurable:!0}),t.prototype.appendBezierSegment=function(t,e,i,r,n,o){t instanceof T&&e instanceof T&&i instanceof T?(this.writePoint(t.x,t.y),this.writePoint(e.x,e.y),this.writePoint(i.x,i.y)):(this.writePoint(t,e),this.writePoint(i,r),this.writePoint(n,o)),this.writeOperator(s.appendbeziercurve)},t.prototype.setColourWithPattern=function(t,e,i){if(null!=t){var r=t.length,n=0;for(n=0;n<r;++n)this.stream.write(t[n].toString()),this.stream.write(s.whiteSpace)}null!=e&&(this.stream.write(e.toString()),this.stream.write(s.whiteSpace)),i?this.writeOperator(s.setColorAndPatternStroking):this.writeOperator(s.setColorAndPattern)},t}(),Q=function(){function e(e,i){this.pdfColor=new L(0,0,0),this.dashOffsetValue=0,this.penDashPattern=[0],this.pdfDashStyle=t.PdfDashStyle.Solid,this.pdfLineCap=0,this.pdfLineJoin=0,this.penWidth=1,this.internalMiterLimit=0,this.colorSpace=t.PdfColorSpace.Rgb,e instanceof R?this.setBrush(e):e instanceof L&&(this.color=e),"number"==typeof i&&(this.width=i)}return Object.defineProperty(e.prototype,"color",{get:function(){return this.pdfColor},set:function(t){this.pdfColor=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"dashOffset",{get:function(){return void 0===this.dashOffsetValue||null==this.dashOffsetValue?0:this.dashOffsetValue},set:function(t){this.dashOffsetValue=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"dashPattern",{get:function(){return this.penDashPattern},set:function(t){this.penDashPattern=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"dashStyle",{get:function(){return this.pdfDashStyle},set:function(e){if(this.pdfDashStyle!==e)switch(this.pdfDashStyle=e,this.pdfDashStyle){case t.PdfDashStyle.Custom:break;case t.PdfDashStyle.Dash:this.penDashPattern=[3,1];break;case t.PdfDashStyle.Dot:this.penDashPattern=[1,1];break;case t.PdfDashStyle.DashDot:this.penDashPattern=[3,1,1,1];break;case t.PdfDashStyle.DashDotDot:this.penDashPattern=[3,1,1,1,1,1];break;case t.PdfDashStyle.Solid:break;default:this.pdfDashStyle=t.PdfDashStyle.Solid,this.penDashPattern=[0]}},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"lineCap",{get:function(){return this.pdfLineCap},set:function(t){this.pdfLineCap=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"lineJoin",{get:function(){return this.pdfLineJoin},set:function(t){this.pdfLineJoin=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"miterLimit",{get:function(){return this.internalMiterLimit},set:function(t){this.internalMiterLimit=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"width",{get:function(){return this.penWidth},set:function(t){this.penWidth=t},enumerable:!0,configurable:!0}),e.prototype.clone=function(){return this},e.prototype.setBrush=function(t){var e=t;null!=e&&e instanceof M&&(this.color=e.color,this.pdfBrush=e),this.color=e.color,this.pdfBrush=e},e.prototype.monitorChanges=function(t,e,i,r,n,o){r=!0,this.dashControl(t,r,e),e.setLineWidth(this.width),e.setLineJoin(this.lineJoin),e.setLineCap(this.lineCap);var s=this.miterLimit;s>0&&e.setMiterLimit(s);this.pdfBrush;return e.setColorAndSpace(this.color,n,!0),!0},e.prototype.dashControl=function(t,e,i){e=!0;var r=this.width,n=this.getPattern();return i.setLineDashPattern(n,this.dashOffset*r),e},e.prototype.getPattern=function(){for(var t=this.dashPattern,e=0;e<t.length;++e)t[e]*=this.width;return t},e}(),tt=function(){function t(t){this.radDegFactor=180/Math.PI,this.transformationMatrix=new et(1,0,0,void 0===t?1:-1,0,0)}return Object.defineProperty(t.prototype,"matrix",{get:function(){return this.transformationMatrix},set:function(t){this.transformationMatrix=t},enumerable:!0,configurable:!0}),t.prototype.translate=function(t,e){this.transformationMatrix.translate(t,e)},t.prototype.scale=function(t,e){this.transformationMatrix.elements[0]=t,this.transformationMatrix.elements[3]=e},t.prototype.rotate=function(t){t=t*Math.PI/180,this.transformationMatrix.elements[0]=Math.cos(t),this.transformationMatrix.elements[1]=Math.sin(t),this.transformationMatrix.elements[2]=-Math.sin(t),this.transformationMatrix.elements[3]=Math.cos(t)},t.prototype.toString=function(){for(var t="",e=0,i=this.transformationMatrix.elements.length;e<i;e++){this.matrix.elements[e];t+=g.floatToString(this.transformationMatrix.elements[e]),t+=" "}return t},t.prototype.multiply=function(t){this.transformationMatrix.multiply(t.matrix)},t.degreesToRadians=function(t){return this.degRadFactor*t},t.prototype.radiansToDegrees=function(t){return this.radDegFactor*t},t.prototype.clone=function(){return this},t.degRadFactor=Math.PI/180,t}(),et=function(){function t(t,e,i,r,n,o){void 0===t?this.metrixElements=[]:"number"==typeof t?(this.metrixElements=[],this.metrixElements.push(t),this.metrixElements.push(e),this.metrixElements.push(i),this.metrixElements.push(r),this.metrixElements.push(n),this.metrixElements.push(o)):this.metrixElements=t}return Object.defineProperty(t.prototype,"elements",{get:function(){return this.metrixElements},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"offsetX",{get:function(){return this.metrixElements[4]},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"offsetY",{get:function(){return this.metrixElements[5]},enumerable:!0,configurable:!0}),t.prototype.translate=function(t,e){this.metrixElements[4]=t,this.metrixElements[5]=e},t.prototype.transform=function(t){var e=t.x,i=t.y,r=e*this.elements[0]+i*this.elements[2]+this.offsetX,n=e*this.elements[1]+i*this.elements[3]+this.offsetY;return new T(r,n)},t.prototype.multiply=function(t){var e=[];e.push(this.elements[0]*t.elements[0]+this.elements[1]*t.elements[2]),e[1]=this.elements[0]*t.elements[1]+this.elements[1]*t.elements[3],e[2]=this.elements[2]*t.elements[0]+this.elements[3]*t.elements[2],e[3]=this.elements[2]*t.elements[1]+this.elements[3]*t.elements[3],e[4]=this.offsetX*t.elements[0]+this.offsetY*t.elements[2]+t.offsetX,e[5]=this.offsetX*t.elements[1]+this.offsetY*t.elements[3]+t.offsetY;for(var i=0;i<e.length;i++)this.elements[i]=e[i]},t.prototype.dispose=function(){this.metrixElements=null},t.prototype.clone=function(){return new t(this.metrixElements)},t}(),it=function(){return function(){this.pdf="PDF",this.text="Text",this.imageB="ImageB",this.imageC="ImageC",this.imageI="ImageI"}}(),rt=function(){function t(){this.mKeys=[],this.mValues=[]}return t.prototype.size=function(){return this.mKeys.length},t.prototype.add=function(t,e){if(void 0===t||null===t||void 0===e||null===e)throw new ReferenceError("Provided key or value is not valid.");if(this.mKeys.indexOf(t)<0)return this.mKeys.push(t),this.mValues.push(e),1;throw new RangeError("An item with the same key has already been added.")},t.prototype.keys=function(){return this.mKeys},t.prototype.values=function(){return this.mValues},t.prototype.getValue=function(t){if(void 0===t||null===t)throw new ReferenceError("Provided key is not valid.");var e=this.mKeys.indexOf(t);if(e<0)throw new RangeError("No item with the specified key has been added.");return this.mValues[e]},t.prototype.setValue=function(t,e){if(void 0===t||null===t)throw new ReferenceError("Provided key is not valid.");var i=this.mKeys.indexOf(t);i<0?(this.mKeys.push(t),this.mValues.push(e)):this.mValues[i]=e},t.prototype.remove=function(t){if(void 0===t||null===t)throw new ReferenceError("Provided key is not valid.");var e=this.mKeys.indexOf(t);if(e<0)throw new RangeError("No item with the specified key has been added.");return this.mKeys.splice(e,1),this.mValues.splice(e,1),!0},t.prototype.containsKey=function(t){if(void 0===t||null===t)throw new ReferenceError("Provided key is not valid.");return!(this.mKeys.indexOf(t)<0)},t.prototype.clear=function(){this.mKeys=[],this.mValues=[]},t}(),nt=function(){function t(t,e,i){this.dictionary=new h,this.dictionaryProperties=new a,this.dictionary.items.setValue(this.dictionaryProperties.CA,new g(t)),this.dictionary.items.setValue(this.dictionaryProperties.ca,new g(e)),this.dictionary.items.setValue(this.dictionaryProperties.BM,new o(i.toString()))}return Object.defineProperty(t.prototype,"element",{get:function(){return this.dictionary},enumerable:!0,configurable:!0}),t}(),ot=function(){function t(){this.automaticFieldsInformation=[]}return Object.defineProperty(t.prototype,"automaticFields",{get:function(){return this.automaticFieldsInformation},enumerable:!0,configurable:!0}),t.prototype.add=function(t){return this.automaticFields.push(t)},t}(),st=function(){function t(){}return t.prototype.drawHelper=function(t,e,i){var r=0!==e||0!==i,n=null;r&&(n=t.save(),t.translateTransform(e,i)),this.drawInternal(t),r&&t.restore(n)},t}(),at=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),ht=function(t){function e(){var e=t.call(this)||this;return e.internalBounds=new k(0,0,0,0),e.internalTemplateSize=new j(0,0),e}return at(e,t),Object.defineProperty(e.prototype,"bounds",{get:function(){return this.internalBounds},set:function(t){this.internalBounds=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"size",{get:function(){return new j(this.bounds.width,this.bounds.height)},set:function(t){this.bounds.width=t.width,this.bounds.height=t.height},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"location",{get:function(){return new T(this.bounds.x,this.bounds.y)},set:function(t){this.bounds.x=t.x,this.bounds.y=t.y},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"font",{get:function(){return this.internalFont},set:function(t){this.internalFont=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"brush",{get:function(){return this.internalBrush},set:function(t){this.internalBrush=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"pen",{get:function(){return this.internalPen},set:function(t){this.internalPen=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"stringFormat",{get:function(){return this.internalStringFormat},set:function(t){this.internalStringFormat=t},enumerable:!0,configurable:!0}),e.prototype.performDrawHelper=function(t,e,i,r){if(0===this.bounds.height||0===this.bounds.width){var n=this.getValue(t);this.internalTemplateSize=this.getFont().measureString(n,this.size,this.stringFormat)}},e.prototype.draw=function(t,e,i){if(void 0===e){var r=new T(0,0);this.draw(t,r)}else if(e instanceof T)this.draw(t,e.x,e.y);else{this.drawHelper(t,e,i);var n=new lt(this,new T(e,i));t.automaticFields.add(n)}},e.prototype.getSize=function(){return 0===this.bounds.height||0===this.bounds.width?this.internalTemplateSize:this.size},e.prototype.drawInternal=function(t){},e.prototype.getBrush=function(){return void 0===this.internalBrush||null==this.internalBrush?new M(new L(0,0,0)):this.internalBrush},e.prototype.getFont=function(){return void 0===this.internalFont||null==this.internalFont?Ce.defaultFont:this.internalFont},e.prototype.getPageFromGraphics=function(t){if(void 0!==t.page&&null!==t.page){return t.page}return t.currentPage},e}(st),lt=function(){function t(e,i,r,n){this.pageNumberFieldLocation=new T,this.pageNumberField=null,this.scaleX=1,this.scaleY=1,void 0===i&&e instanceof t?(this.pageNumberField=e.field,this.pageNumberFieldLocation=e.location,this.scaleX=e.scalingX,this.scaleY=e.scalingY):void 0===r&&i instanceof T&&e instanceof ht?(this.pageNumberField=e,this.pageNumberFieldLocation=i):(this.pageNumberField=e,this.pageNumberFieldLocation=i,this.scaleX=r,this.scaleY=n)}return Object.defineProperty(t.prototype,"location",{get:function(){return this.pageNumberFieldLocation},set:function(t){this.pageNumberFieldLocation=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"field",{get:function(){return this.pageNumberField},set:function(t){this.pageNumberField=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"scalingX",{get:function(){return this.scaleX},set:function(t){this.scaleX=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"scalingY",{get:function(){return this.scaleY},set:function(t){this.scaleY=t},enumerable:!0,configurable:!0}),t}(),ut=function(){function t(t){this.mPosition=0,this.buffer=new Uint8Array(t),this.dataView=new DataView(this.buffer.buffer)}return Object.defineProperty(t.prototype,"position",{get:function(){return this.mPosition},set:function(t){this.mPosition=t},enumerable:!0,configurable:!0}),t.prototype.read=function(t,e,i){for(var r=e;r<i;r++){var n=this.position;t.buffer[r]=this.readByte(n),this.position++}},t.prototype.getBuffer=function(t){return this.buffer[t]},t.prototype.writeFromBase64String=function(t){var e=this.encodedString(t);this.buffer=e},t.prototype.encodedString=function(t){var e,i,r,n,o,s="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",a=0,h=0,l=3*(t=t.replace(/[^A-Za-z0-9\+\/\=]/g,"")).length/4;t.charAt(t.length-1)===s.charAt(64)&&l--;for(var u=new Uint8Array(0|l);a<t.length;)e=s.indexOf(t.charAt(a++))<<2|(n=s.indexOf(t.charAt(a++)))>>4,i=(15&n)<<4|(o=s.indexOf(t.charAt(a++)))>>2,r=(3&o)<<6|s.indexOf(t.charAt(a++)),u[h++]=e,u[h++]=i,u[h++]=r;return u},t.prototype.readByte=function(t){return this.buffer[t]},Object.defineProperty(t.prototype,"internalBuffer",{get:function(){return this.buffer},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"count",{get:function(){return this.buffer.byteLength},enumerable:!0,configurable:!0}),t.prototype.readNextTwoBytes=function(t){var e=t.readByte(this.position);return this.position++,e<<=8,e|=t.readByte(this.position),this.position++,e},t}(),ct=function(){function t(t){this.currentPosition=-1,this.value=t}return Object.defineProperty(t.prototype,"status",{get:function(){return this.objectStatus},set:function(t){this.objectStatus=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"isSaving",{get:function(){return this.saving},set:function(t){this.saving=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"objectCollectionIndex",{get:function(){return this.index},set:function(t){this.index=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"position",{get:function(){return this.currentPosition},set:function(t){this.currentPosition=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"clonedObject",{get:function(){return null},enumerable:!0,configurable:!0}),t.prototype.save=function(t){t.write(this.boolToStr(this.value))},t.prototype.clone=function(e){return new t(this.value)},t.prototype.boolToStr=function(t){return t?"true":"false"},t}();!function(t){t[t.Unknown=0]="Unknown",t[t.Bmp=1]="Bmp",t[t.Emf=2]="Emf",t[t.Gif=3]="Gif",t[t.Jpeg=4]="Jpeg",t[t.Png=5]="Png",t[t.Wmf=6]="Wmf",t[t.Icon=7]="Icon"}(t.ImageFormat||(t.ImageFormat={}));var pt=function(){function e(e){this.sof1Marker=193,this.sof2Marker=194,this.sof3Marker=195,this.sof5Marker=197,this.sof6Marker=198,this.sof7Marker=199,this.sof9Marker=201,this.sof10Marker=202,this.sof11Marker=203,this.sof13Marker=205,this.sof14Marker=206,this.sof15Marker=207,this.mFormat=t.ImageFormat.Unknown,this.mbitsPerComponent=8,this.dictionaryProperties=new a,this.mStream=e,this.initialize()}return Object.defineProperty(e.prototype,"height",{get:function(){return this.mHeight},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"width",{get:function(){return this.mWidth},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"bitsPerComponent",{get:function(){return this.mbitsPerComponent},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"size",{get:function(){return this.mImageData.count},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"imageData",{get:function(){return this.mImageData},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"imageDataAsNumberArray",{get:function(){return this.mImageData.internalBuffer.buffer},enumerable:!0,configurable:!0}),e.prototype.initialize=function(){this.mFormat===t.ImageFormat.Unknown&&this.checkIfJpeg()&&(this.mFormat=t.ImageFormat.Jpeg,this.parseJpegImage()),this.reset(),this.mImageData=new ut(this.mStream.count),this.mStream.read(this.mImageData,0,this.mImageData.count)},e.prototype.reset=function(){this.mStream.position=0},e.prototype.parseJpegImage=function(){this.reset();var t=new ut(this.mStream.count);this.mStream.read(t,0,t.count);for(var e=4,i=!1,r=256*t.getBuffer(e)+t.getBuffer(e+1);e<t.count;){if(!((e+=r)<t.count)){i=!0;break}if(192===t.getBuffer(e+1))return this.mHeight=256*t.getBuffer(e+5)+t.getBuffer(e+6),void(this.mWidth=256*t.getBuffer(e+7)+t.getBuffer(e+8));e+=2,r=256*t.getBuffer(e)+t.getBuffer(e+1)}i&&(this.mStream.position=0,this.skip(this.mStream,2),this.readExceededJPGImage(this.mStream))},Object.defineProperty(e.prototype,"format",{get:function(){return this.mFormat},enumerable:!0,configurable:!0}),e.prototype.checkIfJpeg=function(){this.reset();for(var t=0;t<e.mJpegHeader.length;t++){if(e.mJpegHeader[t]!==this.mStream.readByte(t))return!1;this.mStream.position++}return!0},e.prototype.getImageDictionary=function(){if(this.mFormat===t.ImageFormat.Jpeg){this.imageData.internalBuffer.length;this.imageStream=new b,this.imageStream.isImage=!0;for(var e="",i="",r=0;r<this.imageDataAsNumberArray.byteLength;r++)e+=String.fromCharCode(null,this.mStream.readByte(r));for(r=0;r<e.length;r++)r%2!=0&&(i+=e[r]);return this.imageStream.data=[i],this.imageStream.compress=!1,this.imageStream.items.setValue(this.dictionaryProperties.type,new o(this.dictionaryProperties.xObject)),this.imageStream.items.setValue(this.dictionaryProperties.subtype,new o(this.dictionaryProperties.image)),this.imageStream.items.setValue(this.dictionaryProperties.width,new g(this.width)),this.imageStream.items.setValue(this.dictionaryProperties.height,new g(this.height)),this.imageStream.items.setValue(this.dictionaryProperties.bitsPerComponent,new g(this.bitsPerComponent)),this.imageStream.items.setValue(this.dictionaryProperties.filter,new o(this.dictionaryProperties.dctdecode)),this.imageStream.items.setValue(this.dictionaryProperties.colorSpace,new o(this.getColorSpace())),this.imageStream.items.setValue(this.dictionaryProperties.decodeParms,this.getDecodeParams()),this.imageStream}return this.imageStream},e.prototype.getColorSpace=function(){return this.dictionaryProperties.deviceRgb},e.prototype.getDecodeParams=function(){var t=new h;return t.items.setValue(this.dictionaryProperties.columns,new g(this.width)),t.items.setValue(this.dictionaryProperties.blackIs1,new ct(!0)),t.items.setValue(this.dictionaryProperties.k,new g(-1)),t.items.setValue(this.dictionaryProperties.predictor,new g(15)),t.items.setValue(this.dictionaryProperties.bitsPerComponent,new g(this.bitsPerComponent)),t},e.prototype.readExceededJPGImage=function(t){this.mStream=t;for(var e=!0;e;){switch(this.getMarker(t)){case this.sof1Marker:case this.sof2Marker:case this.sof3Marker:case this.sof5Marker:case this.sof6Marker:case this.sof7Marker:case this.sof9Marker:case this.sof10Marker:case this.sof11Marker:case this.sof13Marker:case this.sof14Marker:case this.sof15Marker:t.position+=3,this.mHeight=this.mStream.readNextTwoBytes(t),this.mWidth=this.mStream.readNextTwoBytes(t),e=!1;break;default:this.skipStream(t)}}},e.prototype.skip=function(t,e){this.mStream=t;var i=new ut(e);this.mStream.read(i,0,i.count)},e.prototype.getMarker=function(t){var e=32;for(e=t.readByte(this.mStream.position),t.position++;255!==e;)e=t.readByte(this.mStream.position),t.position++;do{e=t.readByte(this.mStream.position),t.position++}while(255===e);return e},e.prototype.skipStream=function(t){var e=this.mStream.readNextTwoBytes(t)-2;e>0&&(t.position+=e)},e.mPngHeader=[137,80,78,71,13,10,26,10],e.mJpegHeader=[255,216],e.GIF_HEADER="G,I,F,8",e.BMP_HEADER="B,M",e}(),dt=function(){function t(t){this.updateProportionsHelper(t)}return t.prototype.convertUnits=function(t,e,i){return this.convertFromPixels(this.convertToPixels(t,e),i)},t.prototype.convertToPixels=function(t,e){var i=e;return t*this.proportions[i]},t.prototype.convertFromPixels=function(t,e){var i=e;return t/this.proportions[i]},t.prototype.updateProportionsHelper=function(t){this.proportions=[t/2.54,t/6,1,t/72,t,t/300,t/25.4]},t.horizontalResolution=96,t.verticalResolution=96,t}(),ft=function(){function e(){}return Object.defineProperty(e.prototype,"width",{get:function(){return this.imageWidth},set:function(t){this.imageWidth=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"height",{get:function(){return this.imageHeight},set:function(t){this.imageHeight=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"size",{set:function(t){this.width=t.width,this.height=t.height},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"physicalDimension",{get:function(){return this.imagePhysicalDimension=this.getPointSize(this.width,this.height,this.horizontalResolution,this.verticalResolution),new j(this.width,this.height)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"element",{get:function(){return this.imageStream},enumerable:!0,configurable:!0}),e.prototype.getPointSize=function(e,i,r,n){if(void 0===r){var o=dt.horizontalResolution,s=dt.verticalResolution;return this.getPointSize(e,i,o,s)}var a=new dt(r),h=new dt(n),l=a.convertUnits(e,t.PdfGraphicsUnit.Pixel,t.PdfGraphicsUnit.Point),u=h.convertUnits(i,t.PdfGraphicsUnit.Pixel,t.PdfGraphicsUnit.Point);return new j(l,u)},e}(),gt=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),mt=function(t){function e(e){var i=t.call(this)||this;return i.imageStatus=!0,i.dictionaryProperties=new a,i.loadImage(e),i}return gt(e,t),e.prototype.loadImage=function(t){this.initializeAsync(t)},e.prototype.initializeAsync=function(t){var e=new ut(t.length);e.writeFromBase64String(t),this.decoder=new pt(e),this.height=this.decoder.height,this.width=this.decoder.width,this.bitsPerComponent=this.decoder.bitsPerComponent},e.prototype.save=function(){this.imageStatus=!0,this.imageStream=this.decoder.getImageDictionary()},e}(ft),yt=function(){function t(){}return Object.defineProperty(t.prototype,"empty",{get:function(){return this.offset===this.length&&this.length===this.checksum&&0===this.checksum},enumerable:!0,configurable:!0}),t}(),bt=function(){return function(){}}(),wt=function(){return function(){}}(),Pt=function(){return function(){}}(),St=function(){function t(){}return Object.defineProperty(t.prototype,"isItalic",{get:function(){return 0!=(2&this.macStyle)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"isBold",{get:function(){return 0!=(1&this.macStyle)},enumerable:!0,configurable:!0}),t}(),vt=function(){return function(){}}(),Ct=function(){return function(){}}(),Bt=function(){return function(){}}(),Ot=function(){return function(){}}(),xt=function(){return function(){}}(),Lt=function(){return function(){}}(),Tt=function(){function t(){}return Object.defineProperty(t.prototype,"empty",{get:function(){return this.index===this.width&&this.width===this.charCode&&0===this.charCode},enumerable:!0,configurable:!0}),t.prototype.compareTo=function(t){var e=t;return this.index-e.index},t}(),jt=function(){return function(){}}(),kt=function(){return function(){}}(),Vt=function(){return function(){}}(),Rt=function(){return function(){}}(),Nt=function(){return function(){}}(),Mt=function(){function t(t){this.int32Size=4,this.int16Size=2,this.int64Size=8,this.bufferLength=t,this.buffer=[]}return Object.defineProperty(t.prototype,"data",{get:function(){if(this.buffer.length<this.bufferLength)for(var t=this.bufferLength-this.buffer.length,e=0;e<t;e++)this.buffer.push(0);return this.buffer},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"position",{get:function(){return void 0!==this.internalPosition&&null!==this.internalPosition||(this.internalPosition=0),this.internalPosition},enumerable:!0,configurable:!0}),t.prototype.writeShort=function(t){var e=[(65280&t)>>8,255&t];this.flush(e)},t.prototype.writeInt=function(t){var e=[(4278190080&t)>>24,(16711680&t)>>16,(65280&t)>>8,255&t];this.flush(e)},t.prototype.writeUInt=function(t){var e=[(4278190080&t)>>24,(16711680&t)>>16,(65280&t)>>8,255&t];this.flush(e)},t.prototype.writeString=function(t){if(null==t)throw new Error("Argument Null Exception : value");for(var e=[],i=0;i<t.length;i++)e.push(t.charCodeAt(i));this.flush(e)},t.prototype.writeBytes=function(t){this.flush(t)},t.prototype.flush=function(t){if(null===t)throw new Error("Argument Null Exception : buff");for(var e=this.position,i=0;i<t.length;i++)this.buffer[e]=t[i],e++;this.internalPosition+=t.length},t}(),At=function(){function e(t){this.int32Size=4,this.isTtcFont=!1,this.isMacTtf=!1,this.metricsName="",this.isMacTTF=!1,this.missedGlyphs=0,this.tableNames=["cvt ","fpgm","glyf","head","hhea","hmtx","loca","maxp","prep"],this.entrySelectors=[0,0,1,1,2,2,2,2,3,3,3,3,3,3,3,3,4,4,4,4,4],this.fontData=t,this.initialize()}return Object.defineProperty(e.prototype,"macintosh",{get:function(){return null!==this.macintoshDictionary&&void 0!==this.macintoshDictionary||(this.macintoshDictionary=new n),this.macintoshDictionary},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"microsoft",{get:function(){return null!==this.microsoftDictionary&&void 0!==this.microsoftDictionary||(this.microsoftDictionary=new n),this.microsoftDictionary},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"macintoshGlyphs",{get:function(){return null!==this.internalMacintoshGlyphs&&void 0!==this.internalMacintoshGlyphs||(this.internalMacintoshGlyphs=new n),this.internalMacintoshGlyphs},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"microsoftGlyphs",{get:function(){return null!==this.internalMicrosoftGlyphs&&void 0!==this.internalMicrosoftGlyphs||(this.internalMicrosoftGlyphs=new n),this.internalMicrosoftGlyphs},enumerable:!0,configurable:!0}),e.prototype.initialize=function(){void 0===this.metrics&&(this.metrics=new St),this.readFontDictionary();var t=this.readNameTable(),e=this.readHeadTable();this.initializeFontName(t),this.metrics.macStyle=e.macStyle},e.prototype.readFontDictionary=function(){this.offset=0;this.checkPreambula();var t=this.readInt16(this.offset);this.readInt16(this.offset),this.readInt16(this.offset),this.readInt16(this.offset);void 0===this.tableDirectory&&(this.tableDirectory=new n);for(var e=0;e<t;++e){var i=new yt,r=this.readString(this.int32Size);i.checksum=this.readInt32(this.offset),i.offset=this.readInt32(this.offset),i.length=this.readInt32(this.offset),this.tableDirectory.setValue(r,i)}this.lowestPosition=this.offset,this.isTtcFont||this.fixOffsets()},e.prototype.fixOffsets=function(){for(var t=Number.MAX_VALUE,e=this.tableDirectory.keys(),i=0;i<e.length;i++){var r=(a=this.tableDirectory.getValue(e[i])).offset;if(t>r&&(t=r)<=this.lowestPosition)break}var o=t-this.lowestPosition;if(0!==o){var s=new n;for(i=0;i<e.length;i++){var a;(a=this.tableDirectory.getValue(e[i])).offset-=o,s.setValue(e[i],a)}this.tableDirectory=s}},e.prototype.checkPreambula=function(){var t=this.readInt32(this.offset);if(this.isMacTtf=1953658213===t,65536!==t&&1953658213!==t&&1330926671!==t){this.isTtcFont=!0,this.offset=0;if("ttcf"!==this.readString(4))throw new Error("Can not read TTF font data");this.offset+=4;if(this.readInt32(this.offset)<0)throw new Error("Can not read TTF font data");this.offset=this.readInt32(this.offset),t=this.readInt32(this.offset)}return t},e.prototype.readNameTable=function(){var t=this.getTable("name");this.offset=t.offset;var e=new bt;e.formatSelector=this.readUInt16(this.offset),e.recordsCount=this.readUInt16(this.offset),e.offset=this.readUInt16(this.offset),e.nameRecords=[];for(var i=this.offset,r=0;r<e.recordsCount;r++){this.offset=i;var n=new wt;n.platformID=this.readUInt16(this.offset),n.encodingID=this.readUInt16(this.offset),n.languageID=this.readUInt16(this.offset),n.nameID=this.readUInt16(this.offset),n.length=this.readUInt16(this.offset),n.offset=this.readUInt16(this.offset),this.offset=t.offset+e.offset+n.offset;var o=0===n.platformID||3===n.platformID;n.name=this.readString(n.length,o),e.nameRecords[r]=n,i+=12}return e},e.prototype.readHeadTable=function(){var t=this.getTable("head");this.offset=t.offset;var e=new Pt;return e.version=this.readFixed(this.offset),e.fontRevision=this.readFixed(this.offset),e.checkSumAdjustment=this.readUInt32(this.offset),e.magicNumber=this.readUInt32(this.offset),e.flags=this.readUInt16(this.offset),e.unitsPerEm=this.readUInt16(this.offset),e.created=this.readInt64(this.offset),e.modified=this.readInt64(this.offset),e.xMin=this.readInt16(this.offset),e.yMin=this.readInt16(this.offset),e.xMax=this.readInt16(this.offset),e.yMax=this.readInt16(this.offset),e.macStyle=this.readUInt16(this.offset),e.lowestReadableSize=this.readUInt16(this.offset),e.fontDirectionHint=this.readInt16(this.offset),e.indexToLocalFormat=this.readInt16(this.offset),e.glyphDataFormat=this.readInt16(this.offset),e},e.prototype.readHorizontalHeaderTable=function(){var t=this.getTable("hhea");this.offset=t.offset;var e=new vt;return e.version=this.readFixed(this.offset),e.ascender=this.readInt16(this.offset),e.descender=this.readInt16(this.offset),e.lineGap=this.readInt16(this.offset),e.advanceWidthMax=this.readUInt16(this.offset),e.minLeftSideBearing=this.readInt16(this.offset),e.minRightSideBearing=this.readInt16(this.offset),e.xMaxExtent=this.readInt16(this.offset),e.caretSlopeRise=this.readInt16(this.offset),e.caretSlopeRun=this.readInt16(this.offset),this.offset+=10,e.metricDataFormat=this.readInt16(this.offset),e.numberOfHMetrics=this.readUInt16(this.offset),e},e.prototype.readOS2Table=function(){var t=this.getTable("OS/2");this.offset=t.offset;var e=new Ct;return e.version=this.readUInt16(this.offset),e.xAvgCharWidth=this.readInt16(this.offset),e.usWeightClass=this.readUInt16(this.offset),e.usWidthClass=this.readUInt16(this.offset),e.fsType=this.readInt16(this.offset),e.ySubscriptXSize=this.readInt16(this.offset),e.ySubscriptYSize=this.readInt16(this.offset),e.ySubscriptXOffset=this.readInt16(this.offset),e.ySubscriptYOffset=this.readInt16(this.offset),e.ySuperscriptXSize=this.readInt16(this.offset),e.ySuperscriptYSize=this.readInt16(this.offset),e.ySuperscriptXOffset=this.readInt16(this.offset),e.ySuperscriptYOffset=this.readInt16(this.offset),e.yStrikeoutSize=this.readInt16(this.offset),e.yStrikeoutPosition=this.readInt16(this.offset),e.sFamilyClass=this.readInt16(this.offset),e.panose=this.readBytes(10),e.ulUnicodeRange1=this.readUInt32(this.offset),e.ulUnicodeRange2=this.readUInt32(this.offset),e.ulUnicodeRange3=this.readUInt32(this.offset),e.ulUnicodeRange4=this.readUInt32(this.offset),e.vendorIdentifier=this.readBytes(4),e.fsSelection=this.readUInt16(this.offset),e.usFirstCharIndex=this.readUInt16(this.offset),e.usLastCharIndex=this.readUInt16(this.offset),e.sTypoAscender=this.readInt16(this.offset),e.sTypoDescender=this.readInt16(this.offset),e.sTypoLineGap=this.readInt16(this.offset),e.usWinAscent=this.readUInt16(this.offset),e.usWinDescent=this.readUInt16(this.offset),e.ulCodePageRange1=this.readUInt32(this.offset),e.ulCodePageRange2=this.readUInt32(this.offset),e.version>1?(e.sxHeight=this.readInt16(this.offset),e.sCapHeight=this.readInt16(this.offset),e.usDefaultChar=this.readUInt16(this.offset),e.usBreakChar=this.readUInt16(this.offset),e.usMaxContext=this.readUInt16(this.offset)):(e.sxHeight=0,e.sCapHeight=0,e.usDefaultChar=0,e.usBreakChar=0,e.usMaxContext=0),e},e.prototype.readPostTable=function(){var t=this.getTable("post");this.offset=t.offset;var e=new Bt;return e.formatType=this.readFixed(this.offset),e.italicAngle=this.readFixed(this.offset),e.underlinePosition=this.readInt16(this.offset),e.underlineThickness=this.readInt16(this.offset),e.isFixedPitch=this.readUInt32(this.offset),e.minType42=this.readUInt32(this.offset),e.maxType42=this.readUInt32(this.offset),e.minType1=this.readUInt32(this.offset),e.maxType1=this.readUInt32(this.offset),e},e.prototype.readWidthTable=function(t,e){var i=this.getTable("hmtx");this.offset=i.offset;for(var r=[],n=0;n<t;n++){var o=new Ot;o.advanceWidth=this.readUInt16(this.offset),o.lsb=this.readInt16(this.offset);var s=1e3*o.advanceWidth/e;r.push(Math.floor(s))}return r},e.prototype.readCmapTable=function(){var t=this.getTable("cmap");this.offset=t.offset;var e=new Lt;e.version=this.readUInt16(this.offset),e.tablesCount=this.readUInt16(this.offset);for(var i=this.offset,r=[],n=0;n<e.tablesCount;n++){this.offset=i;var o=new xt;o.platformID=this.readUInt16(this.offset),o.encodingID=this.readUInt16(this.offset),o.offset=this.readUInt32(this.offset),i=this.offset,this.readCmapSubTable(o),r[n]=o}return r},e.prototype.readCmapSubTable=function(e){var i=this.getTable("cmap");this.offset=i.offset+e.offset;var r=this.readUInt16(this.offset),n=this.getCmapEncoding(e.platformID,e.encodingID);n===t.TtfCmapEncoding.Macintosh?t.TtfPlatformID.Macintosh:t.TtfPlatformID.Microsoft;if(n!==t.TtfCmapEncoding.Unknown)switch(r){case t.TtfCmapFormat.Apple:this.readAppleCmapTable(e,n);break;case t.TtfCmapFormat.Microsoft:this.readMicrosoftCmapTable(e,n);break;case t.TtfCmapFormat.Trimmed:this.readTrimmedCmapTable(e,n)}},e.prototype.readAppleCmapTable=function(t,e){var i=this.getTable("cmap");this.offset=i.offset+t.offset;var r=new kt;r.format=this.readUInt16(this.offset),r.length=this.readUInt16(this.offset),r.version=this.readUInt16(this.offset),null!==this.maxMacIndex&&void 0!==this.maxMacIndex||(this.maxMacIndex=0);for(var n=0;n<256;++n){var o=new Tt;o.index=this.readByte(this.offset),o.width=this.getWidth(o.index),o.charCode=n,this.macintosh.setValue(n,o),this.addGlyph(o,e),this.maxMacIndex=Math.max(n,this.maxMacIndex)}},e.prototype.readMicrosoftCmapTable=function(e,i){var r=this.getTable("cmap");this.offset=r.offset+e.offset;var n=i===t.TtfCmapEncoding.Unicode?this.microsoft:this.macintosh,o=new Vt;o.format=this.readUInt16(this.offset),o.length=this.readUInt16(this.offset),o.version=this.readUInt16(this.offset),o.segCountX2=this.readUInt16(this.offset),o.searchRange=this.readUInt16(this.offset),o.entrySelector=this.readUInt16(this.offset),o.rangeShift=this.readUInt16(this.offset);var s=o.segCountX2/2;o.endCount=this.readUshortArray(s),o.reservedPad=this.readUInt16(this.offset),o.startCount=this.readUshortArray(s),o.idDelta=this.readUshortArray(s),o.idRangeOffset=this.readUshortArray(s);var a=o.length/2-8-4*s;o.glyphID=this.readUshortArray(a);for(var h=0,l=0,u=0;u<s;u++)for(var c=o.startCount[u];c<=o.endCount[u]&&65535!==c;c++){if(0===o.idRangeOffset[u])h=c+o.idDelta[u]&65535;else{if((l=u+o.idRangeOffset[u]/2-s+c-o.startCount[u])>=o.glyphID.length)continue;h=o.glyphID[l]+o.idDelta[u]&65535}var p=new Tt;p.index=h,p.width=this.getWidth(p.index);var d=i===t.TtfCmapEncoding.Symbol&&61440==(65280&c)?255&c:c;p.charCode=d,n.setValue(d,p),this.addGlyph(p,i)}},e.prototype.readTrimmedCmapTable=function(t,e){var i=this.getTable("cmap");this.offset=i.offset+t.offset;var r=new Rt;r.format=this.readUInt16(this.offset),r.length=this.readUInt16(this.offset),r.version=this.readUInt16(this.offset),r.firstCode=this.readUInt16(this.offset),r.entryCount=this.readUInt16(this.offset);for(var n=0;n<r.entryCount;++n){var o=new Tt;o.index=this.readUInt16(this.offset),o.width=this.getWidth(o.index),o.charCode=n+r.firstCode,this.macintosh.setValue(n,o),this.addGlyph(o,e),this.maxMacIndex=Math.max(n,this.maxMacIndex)}},e.prototype.initializeFontName=function(t){for(var e=0;e<t.recordsCount;e++){var i=t.nameRecords[e];if(1===i.nameID?this.metrics.fontFamily=i.name:6===i.nameID&&(this.metrics.postScriptName=i.name),null!==this.metrics.fontFamily&&void 0!==this.metrics.fontFamily&&null!==this.metrics.postScriptName&&void 0!==this.metrics.postScriptName)break}},e.prototype.getTable=function(t){var e,i=new yt;return this.tableDirectory.containsKey(t)&&(e=this.tableDirectory.getValue(t)),null!==e&&void 0!==e&&(i=e),i},e.prototype.getWidth=function(t){return t=t<this.width.length?t:this.width.length-1,this.width[t]},e.prototype.getCmapEncoding=function(e,i){var r=t.TtfCmapEncoding.Unknown;return e==t.TtfPlatformID.Microsoft&&i==t.TtfMicrosoftEncodingID.Undefined?r=t.TtfCmapEncoding.Symbol:e==t.TtfPlatformID.Microsoft&&i==t.TtfMicrosoftEncodingID.Unicode?r=t.TtfCmapEncoding.Unicode:e==t.TtfPlatformID.Macintosh&&i==t.TtfMacintoshEncodingID.Roman&&(r=t.TtfCmapEncoding.Macintosh),r},e.prototype.addGlyph=function(e,i){var r=null;switch(i){case t.TtfCmapEncoding.Unicode:r=this.microsoftGlyphs;break;case t.TtfCmapEncoding.Macintosh:case t.TtfCmapEncoding.Symbol:r=this.macintoshGlyphs}r.setValue(e.index,e)},e.prototype.initializeMetrics=function(e,i,r,n,o,s){this.initializeFontName(e);for(var a=!1,h=0;h<s.length;h++){var l=s[h];if(this.getCmapEncoding(l.platformID,l.encodingID)===t.TtfCmapEncoding.Symbol){a=!0;break}}this.metrics.isSymbol=a,this.metrics.macStyle=i.macStyle,this.metrics.isFixedPitch=0!==o.isFixedPitch,this.metrics.italicAngle=o.italicAngle;var u=1e3/i.unitsPerEm;this.metrics.winAscent=n.sTypoAscender*u,this.metrics.macAscent=r.ascender*u,this.metrics.capHeight=0!==n.sCapHeight?n.sCapHeight:.7*i.unitsPerEm*u,this.metrics.winDescent=n.sTypoDescender*u,this.metrics.macDescent=r.descender*u,this.metrics.leading=(n.sTypoAscender-n.sTypoDescender+n.sTypoLineGap)*u,this.metrics.lineGap=Math.ceil(r.lineGap*u);var c=i.xMin*u,p=Math.ceil(this.metrics.macAscent+this.metrics.lineGap),d=i.xMax*u,f=this.metrics.macDescent;this.metrics.fontBox=new V(c,p,d,f),this.metrics.stemV=80,this.metrics.widthTable=this.updateWidth(),this.metrics.contains=this.tableDirectory.containsKey("CFF"),this.metrics.subScriptSizeFactor=i.unitsPerEm/n.ySubscriptYSize,this.metrics.superscriptSizeFactor=i.unitsPerEm/n.ySuperscriptYSize},e.prototype.updateWidth=function(){var t=[];if(this.metrics.isSymbol)for(var e=0;e<256;e++){var i=this.getGlyph(String.fromCharCode(e));t[e]=i.empty?0:i.width}else{var r=[],n=String.fromCharCode(32);for(e=0;e<256;e++){r[0]=e;var o=this.getString(r,0,r.length),s=o.length>0?o[0]:"?";(i=this.getGlyph(s)).empty?(i=this.getGlyph(n),t[e]=i.empty?0:i.width):t[e]=i.width}}return t},e.prototype.getDefaultGlyph=function(){return this.getGlyph(D.whiteSpace)},e.prototype.getString=function(t,e,i){for(var r="",n=0;n<i;n++)r+=String.fromCharCode(t[n+e]);return r},e.prototype.readLocaTable=function(t){var e=this.getTable("loca");this.offset=e.offset;var i=new jt,r=null;if(t){var n=e.length/2;r=[];for(var o=0;o<n;o++)r[o]=2*this.readUInt16(this.offset)}else{n=e.length/4;r=[];for(o=0;o<n;o++)r[o]=this.readUInt32(this.offset)}return i.offsets=r,i},e.prototype.updateGlyphChars=function(t,e){t.containsKey(0)||t.setValue(0,0);for(var i=new n,r=t.keys(),o=0;o<r.length;o++)i.setValue(r[o],t.getValue(r[o]));for(o=0;o<r.length;o++){var s=r[o];this.processCompositeGlyph(t,s,e)}},e.prototype.processCompositeGlyph=function(e,i,r){if(i<r.offsets.length-1){var n=r.offsets[i];if(n!==r.offsets[i+1]){var o=this.getTable("glyf");this.offset=o.offset+n;var s=new Nt;if(s.numberOfContours=this.readInt16(this.offset),s.xMin=this.readInt16(this.offset),s.yMin=this.readInt16(this.offset),s.xMax=this.readInt16(this.offset),s.yMax=this.readInt16(this.offset),s.numberOfContours<0)for(var a=0;;){var h=this.readUInt16(this.offset),l=this.readUInt16(this.offset);if(e.containsKey(l)||e.setValue(l,0),0==(h&t.TtfCompositeGlyphFlags.MoreComponents))break;a=0!=(h&t.TtfCompositeGlyphFlags.Arg1And2AreWords)?4:2,0!=(h&t.TtfCompositeGlyphFlags.WeHaveScale)?a+=2:0!=(h&t.TtfCompositeGlyphFlags.WeHaveAnXyScale)?a+=4:0!=(h&t.TtfCompositeGlyphFlags.WeHaveTwoByTwo)&&(a+=8),this.offset+=a}}}},e.prototype.generateGlyphTable=function(t,e,i,r){i=[];var n=t.keys();n.sort(function(t,e){return t-e});for(var o=0,s=0;s<n.length;s++){var a=n[s];e.offsets.length>0&&(o+=e.offsets[a+1]-e.offsets[a])}var h=this.align(o);r=[];for(s=0;s<h;s++)r.push(0);var l=0,u=0,c=this.getTable("glyf");for(s=0;s<e.offsets.length;s++)if(i.push(l),u<n.length&&n[u]===s){++u,i[s]=l;var p=e.offsets[s],d=e.offsets[s+1]-p;if(d>0){this.offset=c.offset+p;r=this.read(r,l,d).buffer,l+=d}}return{glyphTableSize:o,newLocaTable:i,newGlyphTable:r}},e.prototype.updateLocaTable=function(t,e,i){if(null===t)throw new Error("Argument Null Exception : newLocaTable");for(var r=e?2*t.length:4*t.length,n=this.align(r),o=new Mt(n),s=0;s<t.length;s++){var a=t[s];e?(a/=2,o.writeShort(a)):o.writeInt(a)}return{newLocaUpdated:o.data,newLocaSize:r}},e.prototype.align=function(t){return t+3&-4},e.prototype.getFontProgram=function(t,e,i,r){if(null===t)throw new Error("Argument Null Exception : newLocaTableOut");if(null===e)throw new Error("Argument Null Exception : newGlyphTable");this.tableNames;var n=this.getFontProgramLength(t,e,0),o=n.fontProgramLength,s=n.numTables,a=new Mt(o);a.writeInt(65536),a.writeShort(s);var h=this.entrySelectors[s];return a.writeShort(16*(1<<(31&h))),a.writeShort(h),a.writeShort(16*(s-(1<<(31&h)))),this.writeCheckSums(a,s,t,e,i,r),this.writeGlyphs(a,t,e),a.data},e.prototype.getFontProgramLength=function(t,e,i){if(null===t)throw new Error("Argument Null Exception : newLocaTableOut");if(null===e)throw new Error("Argument Null Exception : newGlyphTable");i=2;for(var r=this.tableNames,n=0,o=0;o<r.length;o++){var s=r[o];if("glyf"!==s&&"loca"!==s){var a=this.getTable(s);a.empty||(++i,n+=this.align(a.length))}}n+=t.length,n+=e.length;return n+=16*i+12,{fontProgramLength:n,numTables:i}},e.prototype.writeCheckSums=function(t,e,i,r,n,o){if(null===t)throw new Error("Argument Null Exception : writer");if(null===i)throw new Error("Argument Null Exception : newLocaTableOut");if(null===r)throw new Error("Argument Null Exception : newGlyphTable");for(var s=this.tableNames,a=16*e+12,h=0,l=0;l<s.length;l++){var u=s[l],c=this.getTable(u);if(!c.empty){if(t.writeString(u),"glyf"===u){var p=this.calculateCheckSum(r);t.writeInt(p),h=n}else if("loca"===u){p=this.calculateCheckSum(i);t.writeInt(p),h=o}else t.writeInt(c.checksum),h=c.length;t.writeUInt(a),t.writeUInt(h),a+=this.align(h)}}},e.prototype.calculateCheckSum=function(t){if(null===t)throw new Error("Argument Null Exception : bytes");for(var e=0,i=0,r=0,n=0,o=0,s=0;s<(t.length+1)/4;s++)o+=255&t[e++],n+=255&t[e++],r+=255&t[e++],i+=255&t[e++];var a=i;return a+=r<<8,a+=n<<16,a+=o<<24},e.prototype.writeGlyphs=function(t,e,i){if(null===t)throw new Error("Argument Null Exception : writer");if(null===e)throw new Error("Argument Null Exception : newLocaTableOut");if(null===i)throw new Error("Argument Null Exception : newGlyphTable");for(var r=this.tableNames,n=0;n<r.length;n++){var o=r[n],s=this.getTable(o);if(!s.empty)if("glyf"===o)t.writeBytes(i);else if("loca"===o)t.writeBytes(e);else{for(var a=this.align(s.length),h=[],l=0;l<a;l++)h.push(0);this.offset=s.offset;var u=this.read(h,0,s.length);t.writeBytes(u.buffer)}}},e.prototype.setOffset=function(t){this.offset=t},e.prototype.createInternals=function(){this.metrics=new St;var t=this.readNameTable(),e=this.readHeadTable();this.bIsLocaShort=0===e.indexToLocalFormat;var i=this.readHorizontalHeaderTable(),r=this.readOS2Table(),n=this.readPostTable();this.width=this.readWidthTable(i.numberOfHMetrics,e.unitsPerEm);var o=this.readCmapTable();this.initializeMetrics(t,e,i,r,n,o)},e.prototype.getGlyph=function(t){if("number"==typeof t){var e=null;this.metrics.isSymbol||null==this.microsoftGlyphs?this.metrics.isSymbol&&null!=this.macintoshGlyphs&&this.macintoshGlyphs.containsKey(t)&&(e=this.macintoshGlyphs.getValue(t)):this.microsoftGlyphs.containsKey(t)&&(e=this.microsoftGlyphs.getValue(t));return null!=e?e:this.getDefaultGlyph()}var i=null,r=t.charCodeAt(0);this.metrics.isSymbol||null===this.microsoft?(this.metrics.isSymbol&&null!==this.macintosh||this.isMacTTF)&&(0!==this.maxMacIndex?r%=this.maxMacIndex+1:r=61440==(65280&r)?255&r:r,this.macintosh.containsKey(r)&&(i=this.macintosh.getValue(r),this.isFontPresent=!0)):this.microsoft.containsKey(r)?(i=this.microsoft.getValue(r),r!==D.whiteSpace.charCodeAt(0)&&(this.isFontPresent=!0)):r!==D.whiteSpace.charCodeAt(0)&&(this.isFontPresent=!1),t===D.whiteSpace&&null===i&&(i=new Tt);return null!==i?i:this.getDefaultGlyph()},e.prototype.getGlyphChars=function(t){if(null===t||void 0===t)throw new Error("Argument Null Exception : chars");for(var e=new n,i=t.keys(),r=0;r<i.length;r++){var o=i[r],s=this.getGlyph(o);s.empty||e.setValue(s.index,o.charCodeAt(0))}return e},e.prototype.getAllGlyphs=function(){for(var t=[],e=new Tt,i=0,r=0;r<this.width.length;r++){var n=this.width[r];e.index=i,e.width=n,t.push(e),i++}return t},e.prototype.readFontProgram=function(t){var e=this.getGlyphChars(t),i=this.readLocaTable(this.bIsLocaShort);e.size()<t.size()&&(this.missedGlyphs=t.size()-e.size()),this.updateGlyphChars(e,i);var r=this.generateGlyphTable(e,i,null,null),n=r.glyphTableSize,o=r.newLocaTable,s=r.newGlyphTable,a=this.updateLocaTable(o,this.bIsLocaShort,null),h=a.newLocaSize,l=a.newLocaUpdated;return this.getFontProgram(l,s,n,h)},e.prototype.convertString=function(t){if(null===t)throw new Error("Argument Null Exception : text");for(var e="",i=0;i<t.length;i++){var r=t[i],n=this.getGlyph(r);n.empty||(e+=String.fromCharCode(n.index))}return e},e.prototype.getCharWidth=function(t){var e=this.getGlyph(t);return(e=e.empty?this.getDefaultGlyph():e).empty?0:e.width},e.prototype.readString=function(t,e){if(void 0===e)return this.readString(t,!1);var i="";if(e)for(var r=0;r<t;r++)r%2!=0&&(i+=String.fromCharCode(this.fontData[this.offset])),this.offset+=1;else for(r=0;r<t;r++)i+=String.fromCharCode(this.fontData[this.offset]),this.offset+=1;return i},e.prototype.readFixed=function(t){return this.readInt16(t)+this.readInt16(t+2)/16384},e.prototype.readInt32=function(t){var e=this.fontData[t+3],i=this.fontData[t+2],r=this.fontData[t+1],n=this.fontData[t];return this.offset+=4,e+(i<<8)+(r<<16)+(n<<24)},e.prototype.readUInt32=function(t){var e=this.fontData[t+3],i=this.fontData[t+2],r=this.fontData[t+1],n=this.fontData[t];return this.offset+=4,e|i<<8|r<<16|n<<24},e.prototype.readInt16=function(t){var e=(this.fontData[t]<<8)+this.fontData[t+1];return e=32768&e?e-65536:e,this.offset+=2,e},e.prototype.readInt64=function(t){var e=this.readInt32(t+4),i=4294967296*this.readInt32(t)+e;return e<0&&(i+=4294967296),i},e.prototype.readUInt16=function(t){var e=this.fontData[t]<<8|this.fontData[t+1];return this.offset+=2,e},e.prototype.readUshortArray=function(t){for(var e=[],i=0;i<t;i++)e[i]=this.readUInt16(this.offset);return e},e.prototype.readBytes=function(t){for(var e=[],i=0;i<t;i++)e.push(this.fontData[this.offset]),this.offset+=1;return e},e.prototype.readByte=function(t){var e=this.fontData[t];return this.offset+=1,e},e.prototype.read=function(t,e,i){if(null===t)throw new Error("Argument Null Exception : buffer");var r=0,n=0;do{for(var o=0;o<i-r&&this.offset+o<this.fontData.length;o++)t[e+o]=this.fontData[this.offset+o];n=i-r,this.offset+=n,r+=n}while(r<i);return{buffer:t,written:r}},e}(),Dt=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Ft=function(){function e(){this.lineGap=0}return e.prototype.getAscent=function(t){return this.ascent*G.charSizeMultiplier*this.getSize(t)},e.prototype.getDescent=function(t){return this.descent*G.charSizeMultiplier*this.getSize(t)},e.prototype.getLineGap=function(t){return this.lineGap*G.charSizeMultiplier*this.getSize(t)},e.prototype.getHeight=function(t){for(var e=["cambria","candara","constantia","corbel","cariadings"],i=[],r=0;r<e.length;r++){var n=e[r];i.push(n)}return this.getDescent(t)<0?this.getAscent(t)-this.getDescent(t)+this.getLineGap(t):this.getAscent(t)+this.getDescent(t)+this.getLineGap(t)},e.prototype.getSize=function(e){var i=this.size;if(null!=e)switch(e.subSuperScript){case t.PdfSubSuperScript.SubScript:i/=this.subScriptSizeFactor;break;case t.PdfSubSuperScript.SuperScript:i/=this.superscriptSizeFactor}return i},e.prototype.clone=function(){return this.widthTable=It.clone(),this},Object.defineProperty(e.prototype,"widthTable",{get:function(){return this.internalWidthTable},set:function(t){this.internalWidthTable=t},enumerable:!0,configurable:!0}),e}(),It=function(){function t(){}return t.clone=function(){return null},t}(),Et=function(t){function e(e){var i=t.call(this)||this;if(null==e)throw new Error("ArgumentNullException:widths");return i.widths=e,i}return Dt(e,t),e.prototype.items=function(t){if(t<0||t>=this.widths.length)throw new Error("ArgumentOutOfRangeException:index, The character is not supported by the font.");return this.widths[t]},Object.defineProperty(e.prototype,"length",{get:function(){return this.widths.length},enumerable:!0,configurable:!0}),e.prototype.clone=function(){return this.widths=this.widths,this},e.prototype.toArray=function(){return new m(this.widths)},e}(It),Gt=function(){function e(t,e){if(this.nameString="ABCDEFGHIJKLMNOPQRSTUVWXYZ",this.dictionaryProperties=new a,this.isCompress=!1,this.isEmbedFont=!1,this.cmapPrefix="/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap"+s.newLine+"/CIDSystemInfo << /Registry (Adobe)/Ordering (UCS)/Supplement 0>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange"+s.newLine,this.cmapEndCodespaceRange="endcodespacerange"+s.newLine,this.cmapBeginRange="beginbfrange"+s.newLine,this.cmapEndRange="endbfrange"+s.newLine,this.cmapSuffix="endbfrange\nendcmap\nCMapName currentdict /CMap defineresource pop\nend end"+s.newLine,null===t||void 0===t)throw new Error("ArgumentNullException:base64String");this.fontSize=e,this.fontString=t,this.Initialize()}return e.prototype.getCharWidth=function(t){return this.ttfReader.getCharWidth(t)},e.prototype.getLineWidth=function(t){for(var e=0,i=0,r=t.length;i<r;i++){var n=t[i];e+=this.getCharWidth(n)}return e},e.prototype.Initialize=function(){var t=new ut(this.fontString.length);t.writeFromBase64String(this.fontString),this.fontData=t.internalBuffer,this.ttfReader=new At(this.fontData),this.ttfMetrics=this.ttfReader.metrics},e.prototype.createInternals=function(){this.fontDictionary=new h,this.fontProgram=new b,this.cmap=new b,this.descendantFont=new h,this.metrics=new Ft,this.ttfReader.createInternals(),this.ttfMetrics=this.ttfReader.metrics,this.initializeMetrics(),this.subsetName=this.getFontName(),this.createDescendantFont(),this.createCmap(),this.createFontDictionary(),this.createFontProgram()},e.prototype.getInternals=function(){return this.fontDictionary},e.prototype.initializeMetrics=function(){var t=this.ttfReader.metrics;this.metrics.ascent=t.macAscent,this.metrics.descent=t.macDescent,this.metrics.height=t.macAscent-t.macDescent+t.lineGap,this.metrics.name=t.fontFamily,this.metrics.postScriptName=t.postScriptName,this.metrics.size=this.fontSize,this.metrics.widthTable=new Et(t.widthTable),this.metrics.lineGap=t.lineGap,this.metrics.subScriptSizeFactor=t.subScriptSizeFactor,this.metrics.superscriptSizeFactor=t.superscriptSizeFactor,this.metrics.isBold=t.isBold},e.prototype.getFontName=function(){for(var t,e="",i=0;i<6;i++){var r=Math.floor(26*Math.random())+0;e+=this.nameString[r]}return e+="+",e+=this.ttfReader.metrics.postScriptName,t=e.toString(),t=this.formatName(t)},e.prototype.formatName=function(t){var e=t.replace("(","#28");return e=e.replace(")","#29"),e=e.replace("[","#5B"),e=e.replace("]","#5D"),e=e.replace("<","#3C"),e=e.replace(">","#3E"),e=e.replace("{","#7B"),e=e.replace("}","#7D"),e=e.replace("/","#2F"),(e=e.replace("%","#25")).replace(" ","#20")},e.prototype.createDescendantFont=function(){this.descendantFont.isFont=!0,this.descendantFont.descendantFontBeginSave=new u(this),this.descendantFont.items.setValue(this.dictionaryProperties.type,new o(this.dictionaryProperties.font)),this.descendantFont.items.setValue(this.dictionaryProperties.subtype,new o(this.dictionaryProperties.cIDFontType2)),this.descendantFont.items.setValue(this.dictionaryProperties.baseFont,new o(this.subsetName)),this.descendantFont.items.setValue(this.dictionaryProperties.cIDToGIDMap,new o(this.dictionaryProperties.identity)),this.descendantFont.items.setValue(this.dictionaryProperties.dw,new g(1e3)),this.fontDescriptor=this.createFontDescriptor(),this.descendantFont.items.setValue(this.dictionaryProperties.fontDescriptor,new C(this.fontDescriptor));var t=this.createSystemInfo();this.descendantFont.items.setValue(this.dictionaryProperties.cIDSystemInfo,t)},e.prototype.createFontDescriptor=function(){var t=new h,e=this.ttfReader.metrics;return t.isFont=!0,t.items.setValue(this.dictionaryProperties.type,new o(this.dictionaryProperties.fontDescriptor)),t.items.setValue(this.dictionaryProperties.fontName,new o(this.subsetName)),t.items.setValue(this.dictionaryProperties.flags,new g(this.getDescriptorFlags())),t.items.setValue(this.dictionaryProperties.fontBBox,m.fromRectangle(this.getBoundBox())),t.items.setValue(this.dictionaryProperties.missingWidth,new g(e.widthTable[32])),t.items.setValue(this.dictionaryProperties.stemV,new g(e.stemV)),t.items.setValue(this.dictionaryProperties.italicAngle,new g(e.italicAngle)),t.items.setValue(this.dictionaryProperties.capHeight,new g(e.capHeight)),t.items.setValue(this.dictionaryProperties.ascent,new g(e.winAscent)),t.items.setValue(this.dictionaryProperties.descent,new g(e.winDescent)),t.items.setValue(this.dictionaryProperties.leading,new g(e.leading)),t.items.setValue(this.dictionaryProperties.avgWidth,new g(e.widthTable[32])),t.items.setValue(this.dictionaryProperties.fontFile2,new C(this.fontProgram)),t.items.setValue(this.dictionaryProperties.maxWidth,new g(e.widthTable[32])),t.items.setValue(this.dictionaryProperties.xHeight,new g(0)),t.items.setValue(this.dictionaryProperties.stemH,new g(0)),t},e.prototype.createCmap=function(){this.cmap.cmapBeginSave=new w(this)},e.prototype.createFontDictionary=function(){this.fontDictionary.isFont=!0,this.fontDictionary.fontDictionaryBeginSave=new c(this),this.fontDictionary.items.setValue(this.dictionaryProperties.type,new o(this.dictionaryProperties.font)),this.fontDictionary.items.setValue(this.dictionaryProperties.baseFont,new o(this.subsetName)),this.fontDictionary.items.setValue(this.dictionaryProperties.subtype,new o(this.dictionaryProperties.type0)),this.fontDictionary.items.setValue(this.dictionaryProperties.encoding,new o(this.dictionaryProperties.identityH));var t=new m,e=new C(this.descendantFont);t.isFont=!0,t.add(e),this.fontDictionary.items.setValue(this.dictionaryProperties.descendantFonts,t)},e.prototype.createFontProgram=function(){this.fontProgram.fontProgramBeginSave=new P(this)},e.prototype.createSystemInfo=function(){var t=new h;return t.items.setValue(this.dictionaryProperties.registry,new S("Adobe")),t.items.setValue(this.dictionaryProperties.ordering,new S(this.dictionaryProperties.identity)),t.items.setValue(this.dictionaryProperties.supplement,new g(0)),t},e.prototype.descendantFontBeginSave=function(){if(null!==this.usedChars&&void 0!==this.usedChars&&this.usedChars.size()>0){var t=this.getDescendantWidth();null!==t&&this.descendantFont.items.setValue(this.dictionaryProperties.w,t)}},e.prototype.cmapBeginSave=function(){this.generateCmap()},e.prototype.fontDictionaryBeginSave=function(){null!==this.usedChars&&void 0!==this.usedChars&&this.usedChars.size()>0&&!this.fontDictionary.containsKey(this.dictionaryProperties.toUnicode)&&this.fontDictionary.items.setValue(this.dictionaryProperties.toUnicode,new C(this.cmap))},e.prototype.fontProgramBeginSave=function(){this.isCompress=!0,this.generateFontProgram()},e.prototype.getDescendantWidth=function(){var t=new m;if(null!==this.usedChars&&void 0!==this.usedChars&&this.usedChars.size()>0){for(var e=[],i=this.usedChars.keys(),r=0;r<i.length;r++){var n=i[r];(l=this.ttfReader.getGlyph(n)).empty||e.push(l)}e.sort(function(t,e){return t.index-e.index});var o=0,s=0,a=!1,h=new m;for(r=0;r<e.length;r++){var l=e[r];a||(a=!0,o=l.index,s=l.index-1),(s+1!==l.index||r+1===e.length)&&e.length>1&&(t.add(new g(o)),0!==r&&t.add(h),o=l.index,h=new m),h.add(new g(l.width)),r+1===e.length&&(t.add(new g(o)),t.add(h)),s=l.index}}return t},e.prototype.generateCmap=function(){if(null!==this.usedChars&&void 0!==this.usedChars&&this.usedChars.size()>0){var t=this.ttfReader.getGlyphChars(this.usedChars);if(t.size()>0){var e=t.keys().sort(),i=e[0],r=e[e.length-1],n=this.toHexString(i,!1)+this.toHexString(r,!1)+s.newLine,o="";o+=this.cmapPrefix,o+=n,o+=this.cmapEndCodespaceRange;for(var a=0,h=0;h<e.length;h++){0===a&&(0!==h&&(o+=this.cmapEndRange),o+=a=Math.min(100,e.length-h),o+=s.whiteSpace,o+=this.cmapBeginRange),a-=1;var l=e[h];o+=this.toHexString(l,!0)+this.toHexString(l,!0)+this.toHexString(t.getValue(l),!0)+"\n"}o+=this.cmapSuffix,this.cmap.clearStream(),this.cmap.isFont=!0,this.cmap.write(o)}}},e.prototype.generateFontProgram=function(){var t=null;this.usedChars=null===this.usedChars||void 0===this.usedChars?new n:this.usedChars,this.ttfReader.setOffset(0),t=this.ttfReader.readFontProgram(this.usedChars),this.fontProgram.clearStream(),this.fontProgram.isFont=!0,this.fontProgram.writeBytes(t)},e.prototype.getDescriptorFlags=function(){var e=0,i=this.ttfReader.metrics;return i.isFixedPitch&&(e|=t.FontDescriptorFlags.FixedPitch),i.isSymbol?e|=t.FontDescriptorFlags.Symbolic:e|=t.FontDescriptorFlags.Nonsymbolic,i.isItalic&&(e|=t.FontDescriptorFlags.Italic),i.isBold&&(e|=t.FontDescriptorFlags.ForceBold),e},e.prototype.getBoundBox=function(){var t=this.ttfReader.metrics.fontBox,e=Math.abs(t.right-t.left),i=Math.abs(t.top-t.bottom);return new k(t.left,t.bottom,e,i)},e.prototype.toHexString=function(t,e){var i=t.toString(16);return e&&(i=i.toUpperCase()),"<0000".substring(0,5-i.length)+i+">"},e.prototype.setSymbols=function(t){if(null===t)throw new Error("Argument Null Exception : text");null!==this.usedChars&&void 0!==this.usedChars||(this.usedChars=new n);for(var e=0;e<t.length;e++){var i=t[e];this.usedChars.setValue(i,String.fromCharCode(0))}!1===this.isEmbedFont&&this.getDescendantWidth()},e}(),zt=function(){function t(){this.arabicCharTable=[["ء","ﺀ"],["آ","ﺁ","ﺂ"],["أ","ﺃ","ﺄ"],["ؤ","ﺅ","ﺆ"],["إ","ﺇ","ﺈ"],["ئ","ﺉ","ﺊ","ﺋ","ﺌ"],["ا","ﺍ","ﺎ"],["ب","ﺏ","ﺐ","ﺑ","ﺒ"],["ة","ﺓ","ﺔ"],["ت","ﺕ","ﺖ","ﺗ","ﺘ"],["ث","ﺙ","ﺚ","ﺛ","ﺜ"],["ج","ﺝ","ﺞ","ﺟ","ﺠ"],["ح","ﺡ","ﺢ","ﺣ","ﺤ"],["خ","ﺥ","ﺦ","ﺧ","ﺨ"],["د","ﺩ","ﺪ"],["ذ","ﺫ","ﺬ"],["ر","ﺭ","ﺮ"],["ز","ﺯ","ﺰ"],["س","ﺱ","ﺲ","ﺳ","ﺴ"],["ش","ﺵ","ﺶ","ﺷ","ﺸ"],["ص","ﺹ","ﺺ","ﺻ","ﺼ"],["ض","ﺽ","ﺾ","ﺿ","ﻀ"],["ط","ﻁ","ﻂ","ﻃ","ﻄ"],["ظ","ﻅ","ﻆ","ﻇ","ﻈ"],["ع","ﻉ","ﻊ","ﻋ","ﻌ"],["غ","ﻍ","ﻎ","ﻏ","ﻐ"],["ـ","ـ","ـ","ـ","ـ"],["ف","ﻑ","ﻒ","ﻓ","ﻔ"],["ق","ﻕ","ﻖ","ﻗ","ﻘ"],["ك","ﻙ","ﻚ","ﻛ","ﻜ"],["ل","ﻝ","ﻞ","ﻟ","ﻠ"],["م","ﻡ","ﻢ","ﻣ","ﻤ"],["ن","ﻥ","ﻦ","ﻧ","ﻨ"],["ه","ﻩ","ﻪ","ﻫ","ﻬ"],["و","ﻭ","ﻮ"],["ى","ﻯ","ﻰ","ﯨ","ﯩ"],["ي","ﻱ","ﻲ","ﻳ","ﻴ"],["ٱ","ﭐ","ﭑ"],["ٹ","ﭦ","ﭧ","ﭨ","ﭩ"],["ٺ","ﭞ","ﭟ","ﭠ","ﭡ"],["ٻ","ﭒ","ﭓ","ﭔ","ﭕ"],["پ","ﭖ","ﭗ","ﭘ","ﭙ"],["ٿ","ﭢ","ﭣ","ﭤ","ﭥ"],["ڀ","ﭚ","ﭛ","ﭜ","ﭝ"],["ڃ","ﭶ","ﭷ","ﭸ","ﭹ"],["ڄ","ﭲ","ﭳ","ﭴ","ﭵ"],["چ","ﭺ","ﭻ","ﭼ","ﭽ"],["ڇ","ﭾ","ﭿ","ﮀ","ﮁ"],["ڈ","ﮈ","ﮉ"],["ڌ","ﮄ","ﮅ"],["ڍ","ﮂ","ﮃ"],["ڎ","ﮆ","ﮇ"],["ڑ","ﮌ","ﮍ"],["ژ","ﮊ","ﮋ"],["ڤ","ﭪ","ﭫ","ﭬ","ﭭ"],["ڦ","ﭮ","ﭯ","ﭰ","ﭱ"],["ک","ﮎ","ﮏ","ﮐ","ﮑ"],["ڭ","ﯓ","ﯔ","ﯕ","ﯖ"],["گ","ﮒ","ﮓ","ﮔ","ﮕ"],["ڱ","ﮚ","ﮛ","ﮜ","ﮝ"],["ڳ","ﮖ","ﮗ","ﮘ","ﮙ"],["ں","ﮞ","ﮟ"],["ڻ","ﮠ","ﮡ","ﮢ","ﮣ"],["ھ","ﮪ","ﮫ","ﮬ","ﮭ"],["ۀ","ﮤ","ﮥ"],["ہ","ﮦ","ﮧ","ﮨ","ﮩ"],["ۅ","ﯠ","ﯡ"],["ۆ","ﯙ","ﯚ"],["ۇ","ﯗ","ﯘ"],["ۈ","ﯛ","ﯜ"],["ۉ","ﯢ","ﯣ"],["ۋ","ﯞ","ﯟ"],["ی","ﯼ","ﯽ","ﯾ","ﯿ"],["ې","ﯤ","ﯥ","ﯦ","ﯧ"],["ے","ﮮ","ﮯ"],["ۓ","ﮰ","ﮱ"]],this.alef="ا",this.alefHamza="أ",this.alefHamzaBelow="إ",this.alefMadda="آ",this.lam="ل",this.hamza="ء",this.zeroWidthJoiner="‍",this.hamzaAbove="ٔ",this.hamzaBelow="ٕ",this.wawHamza="ؤ",this.yehHamza="ئ",this.waw="و",this.alefMaksura="ى",this.yeh="ي",this.farsiYeh="ی",this.shadda="ّ",this.madda="ٓ",this.lwa="ﻻ",this.lwawh="ﻷ",this.lwawhb="ﻹ",this.lwawm="ﻵ",this.bwhb="ۓ",this.fathatan="ً",this.superScriptalef="ٰ",this.vowel=1,this.arabicMapTable=new n;for(var t=0;t<this.arabicCharTable.length;t++)this.arabicMapTable.setValue(this.arabicCharTable[t][0],this.arabicCharTable[t])}return t.prototype.getCharacterShape=function(t,e){if(t>=this.hamza&&t<=this.bwhb){if(this.arabicMapTable.getValue(t))return this.arabicMapTable.getValue(t)[e+1]}else if(t>=this.lwawm&&t<=this.lwa)return t;return t},t.prototype.shape=function(t,e){for(var i="",r="",n=0;n<t.length;n++){var o=t[n];if(o>="؀"&&o<="ۿ")r+=o;else{if(r.length>0){i+=this.doShape(r.toString(),0),r=""}i+=o}}if(r.length>0){i+=this.doShape(r.toString(),0)}return i.toString()},t.prototype.doShape=function(t,e){for(var i="",r=0,n=0,o="",s=new Wt,a=new Wt;n<t.length;)if(o=t[n++],0===this.ligature(o,a)){var h=this.getShapeCount(o);r=1===h?0:2,s.Shapes>2&&(r+=1),r%=a.Shapes,a.Value=this.getCharacterShape(a.Value,r),i=this.append(i,s,e),s=a,(a=new Wt).Value=o,a.Shapes=h,a.Ligature++}return r=s.Shapes>2?1:0,r%=a.Shapes,a.Value=this.getCharacterShape(a.Value,r),i=this.append(i,s,e),(i=this.append(i,a,e)).toString()},t.prototype.append=function(t,e,i){return""!==e.Value&&(t+=e.Value,e.Ligature-=1,""!==e.Type&&(0==(i&this.vowel)?(t+=e.Type,e.Ligature-=1):e.Ligature-=1),""!==e.vowel&&(0==(i&this.vowel)?(t+=e.vowel,e.Ligature-=1):e.Ligature-=1)),t},t.prototype.ligature=function(t,e){if(""!==e.Value){var i=0;if(t>=this.fathatan&&t<=this.hamzaBelow||t===this.superScriptalef){if(i=1,""!==e.vowel&&t!==this.shadda&&(i=2),t===this.shadda){if(null!=e.Type)return 0;e.Type=this.shadda}else t===this.hamzaBelow?e.Value===this.alef?(e.Value=this.alefHamzaBelow,i=2):t===this.lwa?(e.Value=this.lwawhb,i=2):e.Type=this.hamzaBelow:t===this.hamzaAbove?e.Value===this.alef?(e.Value=this.alefHamza,i=2):e.Value===this.lwa?(e.Value=this.lwawh,i=2):e.Value===this.waw?(e.Value=this.wawHamza,i=2):e.Value===this.yeh||e.Value===this.alefMaksura||e.Value===this.farsiYeh?(e.Value=this.yehHamza,i=2):e.Type=this.hamzaAbove:t===this.madda?e.Value===this.alef&&(e.Value=this.alefMadda,i=2):e.vowel=t;return 1===i&&e.Ligature++,i}return""!==e.vowel?0:(e.Value===this.lam&&(t===this.alef?(e.Value=this.lwa,e.Shapes=2,i=3):t===this.alefHamza?(e.Value=this.lwawh,e.Shapes=2,i=3):t===this.alefHamzaBelow?(e.Value=this.lwawhb,e.Shapes=2,i=3):t===this.alefMadda&&(e.Value=this.lwawm,e.Shapes=2,i=3)),i)}return 0},t.prototype.getShapeCount=function(t){if(t>=this.hamza&&t<=this.bwhb&&!(t>=this.fathatan&&t<=this.hamzaBelow||t===this.superScriptalef)){if(this.arabicMapTable.getValue(t))return this.arabicMapTable.getValue(t).length-1}else if(t===this.zeroWidthJoiner)return 4;return 1},t}(),Wt=function(){function t(){this.shapeValue="",this.shapeType="",this.shapeVowel="",this.shapeLigature=0,this.shapeShapes=1}return Object.defineProperty(t.prototype,"Value",{get:function(){return this.shapeValue},set:function(t){this.shapeValue=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"Type",{get:function(){return this.shapeType},set:function(t){this.shapeType=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"vowel",{get:function(){return this.shapeVowel},set:function(t){this.shapeVowel=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"Ligature",{get:function(){return this.shapeLigature},set:function(t){this.shapeLigature=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"Shapes",{get:function(){return this.shapeShapes},set:function(t){this.shapeShapes=t},enumerable:!0,configurable:!0}),t}(),Ht=function(){function t(){this.indexes=[],this.indexLevels=[],this.mirroringShapeCharacters=new n,this.update()}return t.prototype.doMirrorShaping=function(t){for(var e=[],i=0;i<t.length;i++)1==(1&this.indexLevels[i])&&this.mirroringShapeCharacters.containsKey(t[i].charCodeAt(0))?e[i]=String.fromCharCode(this.mirroringShapeCharacters.getValue(t[i].charCodeAt(0))):e[i]=t[i].toString();for(var r="",n=0;n<e.length;n++)r+=e[n];return r},t.prototype.getLogicalToVisualString=function(t,e){var i=new _t;this.indexLevels=i.getVisualOrder(t,e),this.setDefaultIndexLevel(),this.doOrder(0,this.indexLevels.length-1);for(var r=this.doMirrorShaping(t),n="",o=0;o<this.indexes.length;o++){n+=r[this.indexes[o]]}return n.toString()},t.prototype.setDefaultIndexLevel=function(){for(var t=0;t<this.indexLevels.length;t++)this.indexes[t]=t},t.prototype.doOrder=function(t,e){for(var i=this.indexLevels[t],r=i,n=i,o=i,s=t+1;s<=e;++s){var a=this.indexLevels[s];a>i?i=a:a<r&&(r=a),n&=a,o|=a}if(0!=(1&o))if(1!=(1&n))for(r|=1;i>=r;){for(var h=t;;){for(;h<=e&&!(this.indexLevels[h]>=i);)h+=1;if(h>e)break;for(var l=h+1;l<=e&&!(this.indexLevels[l]<i);)l+=1;this.reArrange(h,l),h=l+1}i-=1}else this.reArrange(t,e+1)},t.prototype.reArrange=function(t,e){var i=(t+e)/2;for(--e;t<i;++t,--e){var r=this.indexes[t];this.indexes[t]=this.indexes[e],this.indexes[e]=r}},t.prototype.update=function(){this.mirroringShapeCharacters.setValue(40,41),this.mirroringShapeCharacters.setValue(41,40),this.mirroringShapeCharacters.setValue(60,62),this.mirroringShapeCharacters.setValue(62,60),this.mirroringShapeCharacters.setValue(91,93),this.mirroringShapeCharacters.setValue(93,91),this.mirroringShapeCharacters.setValue(123,125),this.mirroringShapeCharacters.setValue(125,123),this.mirroringShapeCharacters.setValue(171,187),this.mirroringShapeCharacters.setValue(187,171),this.mirroringShapeCharacters.setValue(8249,8250),this.mirroringShapeCharacters.setValue(8250,8249),this.mirroringShapeCharacters.setValue(8261,8262),this.mirroringShapeCharacters.setValue(8262,8261),this.mirroringShapeCharacters.setValue(8317,8318),this.mirroringShapeCharacters.setValue(8318,8317),this.mirroringShapeCharacters.setValue(8333,8334),this.mirroringShapeCharacters.setValue(8334,8333),this.mirroringShapeCharacters.setValue(8712,8715),this.mirroringShapeCharacters.setValue(8713,8716),this.mirroringShapeCharacters.setValue(8714,8717),this.mirroringShapeCharacters.setValue(8715,8712),this.mirroringShapeCharacters.setValue(8716,8713),this.mirroringShapeCharacters.setValue(8717,8714),this.mirroringShapeCharacters.setValue(8725,10741),this.mirroringShapeCharacters.setValue(8764,8765),this.mirroringShapeCharacters.setValue(8765,8764),this.mirroringShapeCharacters.setValue(8771,8909),this.mirroringShapeCharacters.setValue(8786,8787),this.mirroringShapeCharacters.setValue(8787,8786),this.mirroringShapeCharacters.setValue(8788,8789),this.mirroringShapeCharacters.setValue(8789,8788),this.mirroringShapeCharacters.setValue(8804,8805),this.mirroringShapeCharacters.setValue(8805,8804),this.mirroringShapeCharacters.setValue(8806,8807),this.mirroringShapeCharacters.setValue(8807,8806),this.mirroringShapeCharacters.setValue(8808,8809),this.mirroringShapeCharacters.setValue(8809,8808),this.mirroringShapeCharacters.setValue(8810,8811),this.mirroringShapeCharacters.setValue(8811,8810),this.mirroringShapeCharacters.setValue(8814,8815),this.mirroringShapeCharacters.setValue(8815,8814),this.mirroringShapeCharacters.setValue(8816,8817),this.mirroringShapeCharacters.setValue(8817,8816),this.mirroringShapeCharacters.setValue(8818,8819),this.mirroringShapeCharacters.setValue(8819,8818),this.mirroringShapeCharacters.setValue(8820,8821),this.mirroringShapeCharacters.setValue(8821,8820),this.mirroringShapeCharacters.setValue(8822,8823),this.mirroringShapeCharacters.setValue(8823,8822),this.mirroringShapeCharacters.setValue(8824,8825),this.mirroringShapeCharacters.setValue(8825,8824),this.mirroringShapeCharacters.setValue(8826,8827),this.mirroringShapeCharacters.setValue(8827,8826),this.mirroringShapeCharacters.setValue(8828,8829),this.mirroringShapeCharacters.setValue(8829,8828),this.mirroringShapeCharacters.setValue(8830,8831),this.mirroringShapeCharacters.setValue(8831,8830),this.mirroringShapeCharacters.setValue(8832,8833),this.mirroringShapeCharacters.setValue(8833,8832),this.mirroringShapeCharacters.setValue(8834,8835),this.mirroringShapeCharacters.setValue(8835,8834),this.mirroringShapeCharacters.setValue(8836,8837),this.mirroringShapeCharacters.setValue(8837,8836),this.mirroringShapeCharacters.setValue(8838,8839),this.mirroringShapeCharacters.setValue(8839,8838),this.mirroringShapeCharacters.setValue(8840,8841),this.mirroringShapeCharacters.setValue(8841,8840),this.mirroringShapeCharacters.setValue(8842,8843),this.mirroringShapeCharacters.setValue(8843,8842),this.mirroringShapeCharacters.setValue(8847,8848),this.mirroringShapeCharacters.setValue(8848,8847),this.mirroringShapeCharacters.setValue(8849,8850),this.mirroringShapeCharacters.setValue(8850,8849),this.mirroringShapeCharacters.setValue(8856,10680),this.mirroringShapeCharacters.setValue(8866,8867),this.mirroringShapeCharacters.setValue(8867,8866),this.mirroringShapeCharacters.setValue(8870,10974),this.mirroringShapeCharacters.setValue(8872,10980),this.mirroringShapeCharacters.setValue(8873,10979),this.mirroringShapeCharacters.setValue(8875,10981),this.mirroringShapeCharacters.setValue(8880,8881),this.mirroringShapeCharacters.setValue(8881,8880),this.mirroringShapeCharacters.setValue(8882,8883),this.mirroringShapeCharacters.setValue(8883,8882),this.mirroringShapeCharacters.setValue(8884,8885),this.mirroringShapeCharacters.setValue(8885,8884),this.mirroringShapeCharacters.setValue(8886,8887),this.mirroringShapeCharacters.setValue(8887,8886),this.mirroringShapeCharacters.setValue(8905,8906),this.mirroringShapeCharacters.setValue(8906,8905),this.mirroringShapeCharacters.setValue(8907,8908),this.mirroringShapeCharacters.setValue(8908,8907),this.mirroringShapeCharacters.setValue(8909,8771),this.mirroringShapeCharacters.setValue(8912,8913),this.mirroringShapeCharacters.setValue(8913,8912),this.mirroringShapeCharacters.setValue(8918,8919),this.mirroringShapeCharacters.setValue(8919,8918),this.mirroringShapeCharacters.setValue(8920,8921),this.mirroringShapeCharacters.setValue(8921,8920),this.mirroringShapeCharacters.setValue(8922,8923),this.mirroringShapeCharacters.setValue(8923,8922),this.mirroringShapeCharacters.setValue(8924,8925),this.mirroringShapeCharacters.setValue(8925,8924),this.mirroringShapeCharacters.setValue(8926,8927),this.mirroringShapeCharacters.setValue(8927,8926),this.mirroringShapeCharacters.setValue(8928,8929),this.mirroringShapeCharacters.setValue(8929,8928),this.mirroringShapeCharacters.setValue(8930,8931),this.mirroringShapeCharacters.setValue(8931,8930),this.mirroringShapeCharacters.setValue(8932,8933),this.mirroringShapeCharacters.setValue(8933,8932),this.mirroringShapeCharacters.setValue(8934,8935),this.mirroringShapeCharacters.setValue(8935,8934),this.mirroringShapeCharacters.setValue(8936,8937),this.mirroringShapeCharacters.setValue(8937,8936),this.mirroringShapeCharacters.setValue(8938,8939),this.mirroringShapeCharacters.setValue(8939,8938),this.mirroringShapeCharacters.setValue(8940,8941),this.mirroringShapeCharacters.setValue(8941,8940),this.mirroringShapeCharacters.setValue(8944,8945),this.mirroringShapeCharacters.setValue(8945,8944),this.mirroringShapeCharacters.setValue(8946,8954),this.mirroringShapeCharacters.setValue(8947,8955),this.mirroringShapeCharacters.setValue(8948,8956),this.mirroringShapeCharacters.setValue(8950,8957),this.mirroringShapeCharacters.setValue(8951,8958),this.mirroringShapeCharacters.setValue(8954,8946),this.mirroringShapeCharacters.setValue(8955,8947),this.mirroringShapeCharacters.setValue(8956,8948),this.mirroringShapeCharacters.setValue(8957,8950),this.mirroringShapeCharacters.setValue(8958,8951),this.mirroringShapeCharacters.setValue(8968,8969),this.mirroringShapeCharacters.setValue(8969,8968),this.mirroringShapeCharacters.setValue(8970,8971),this.mirroringShapeCharacters.setValue(8971,8970),this.mirroringShapeCharacters.setValue(9001,9002),this.mirroringShapeCharacters.setValue(9002,9001),this.mirroringShapeCharacters.setValue(10088,10089),this.mirroringShapeCharacters.setValue(10089,10088),this.mirroringShapeCharacters.setValue(10090,10091),this.mirroringShapeCharacters.setValue(10091,10090),this.mirroringShapeCharacters.setValue(10092,10093),this.mirroringShapeCharacters.setValue(10093,10092),this.mirroringShapeCharacters.setValue(10094,10095),this.mirroringShapeCharacters.setValue(10095,10094),this.mirroringShapeCharacters.setValue(10096,10097),this.mirroringShapeCharacters.setValue(10097,10096),this.mirroringShapeCharacters.setValue(10098,10099),this.mirroringShapeCharacters.setValue(10099,10098),this.mirroringShapeCharacters.setValue(10100,10101),this.mirroringShapeCharacters.setValue(10101,10100),this.mirroringShapeCharacters.setValue(10197,10198),this.mirroringShapeCharacters.setValue(10198,10197),this.mirroringShapeCharacters.setValue(10205,10206),this.mirroringShapeCharacters.setValue(10206,10205),this.mirroringShapeCharacters.setValue(10210,10211),this.mirroringShapeCharacters.setValue(10211,10210),this.mirroringShapeCharacters.setValue(10212,10213),this.mirroringShapeCharacters.setValue(10213,10212),this.mirroringShapeCharacters.setValue(10214,10215),this.mirroringShapeCharacters.setValue(10215,10214),this.mirroringShapeCharacters.setValue(10216,10217),this.mirroringShapeCharacters.setValue(10217,10216),this.mirroringShapeCharacters.setValue(10218,10219),this.mirroringShapeCharacters.setValue(10219,10218),this.mirroringShapeCharacters.setValue(10627,10628),this.mirroringShapeCharacters.setValue(10628,10627),this.mirroringShapeCharacters.setValue(10629,10630),this.mirroringShapeCharacters.setValue(10630,10629),this.mirroringShapeCharacters.setValue(10631,10632),this.mirroringShapeCharacters.setValue(10632,10631),this.mirroringShapeCharacters.setValue(10633,10634),this.mirroringShapeCharacters.setValue(10634,10633),this.mirroringShapeCharacters.setValue(10635,10636),this.mirroringShapeCharacters.setValue(10636,10635),this.mirroringShapeCharacters.setValue(10637,10640),this.mirroringShapeCharacters.setValue(10638,10639),this.mirroringShapeCharacters.setValue(10639,10638),this.mirroringShapeCharacters.setValue(10640,10637),this.mirroringShapeCharacters.setValue(10641,10642),this.mirroringShapeCharacters.setValue(10642,10641),this.mirroringShapeCharacters.setValue(10643,10644),this.mirroringShapeCharacters.setValue(10644,10643),this.mirroringShapeCharacters.setValue(10645,10646),this.mirroringShapeCharacters.setValue(10646,10645),this.mirroringShapeCharacters.setValue(10647,10648),this.mirroringShapeCharacters.setValue(10648,10647),this.mirroringShapeCharacters.setValue(10680,8856),this.mirroringShapeCharacters.setValue(10688,10689),this.mirroringShapeCharacters.setValue(10689,10688),this.mirroringShapeCharacters.setValue(10692,10693),this.mirroringShapeCharacters.setValue(10693,10692),this.mirroringShapeCharacters.setValue(10703,10704),this.mirroringShapeCharacters.setValue(10704,10703),this.mirroringShapeCharacters.setValue(10705,10706),this.mirroringShapeCharacters.setValue(10706,10705),this.mirroringShapeCharacters.setValue(10708,10709),this.mirroringShapeCharacters.setValue(10709,10708),this.mirroringShapeCharacters.setValue(10712,10713),this.mirroringShapeCharacters.setValue(10713,10712),this.mirroringShapeCharacters.setValue(10714,10715),this.mirroringShapeCharacters.setValue(10715,10714),this.mirroringShapeCharacters.setValue(10741,8725),this.mirroringShapeCharacters.setValue(10744,10745),this.mirroringShapeCharacters.setValue(10745,10744),this.mirroringShapeCharacters.setValue(10748,10749),this.mirroringShapeCharacters.setValue(10749,10748),this.mirroringShapeCharacters.setValue(10795,10796),this.mirroringShapeCharacters.setValue(10796,10795),this.mirroringShapeCharacters.setValue(10797,10796),this.mirroringShapeCharacters.setValue(10798,10797),this.mirroringShapeCharacters.setValue(10804,10805),this.mirroringShapeCharacters.setValue(10805,10804),this.mirroringShapeCharacters.setValue(10812,10813),this.mirroringShapeCharacters.setValue(10813,10812),this.mirroringShapeCharacters.setValue(10852,10853),this.mirroringShapeCharacters.setValue(10853,10852),this.mirroringShapeCharacters.setValue(10873,10874),this.mirroringShapeCharacters.setValue(10874,10873),this.mirroringShapeCharacters.setValue(10877,10878),this.mirroringShapeCharacters.setValue(10878,10877),this.mirroringShapeCharacters.setValue(10879,10880),this.mirroringShapeCharacters.setValue(10880,10879),this.mirroringShapeCharacters.setValue(10881,10882),this.mirroringShapeCharacters.setValue(10882,10881),this.mirroringShapeCharacters.setValue(10883,10884),this.mirroringShapeCharacters.setValue(10884,10883),this.mirroringShapeCharacters.setValue(10891,10892),this.mirroringShapeCharacters.setValue(10892,10891),this.mirroringShapeCharacters.setValue(10897,10898),this.mirroringShapeCharacters.setValue(10898,10897),this.mirroringShapeCharacters.setValue(10899,10900),this.mirroringShapeCharacters.setValue(10900,10899),this.mirroringShapeCharacters.setValue(10901,10902),this.mirroringShapeCharacters.setValue(10902,10901),this.mirroringShapeCharacters.setValue(10903,10904),this.mirroringShapeCharacters.setValue(10904,10903),this.mirroringShapeCharacters.setValue(10905,10906),this.mirroringShapeCharacters.setValue(10906,10905),this.mirroringShapeCharacters.setValue(10907,10908),this.mirroringShapeCharacters.setValue(10908,10907),this.mirroringShapeCharacters.setValue(10913,10914),this.mirroringShapeCharacters.setValue(10914,10913),this.mirroringShapeCharacters.setValue(10918,10919),this.mirroringShapeCharacters.setValue(10919,10918),this.mirroringShapeCharacters.setValue(10920,10921),this.mirroringShapeCharacters.setValue(10921,10920),this.mirroringShapeCharacters.setValue(10922,10923),this.mirroringShapeCharacters.setValue(10923,10922),this.mirroringShapeCharacters.setValue(10924,10925),this.mirroringShapeCharacters.setValue(10925,10924),this.mirroringShapeCharacters.setValue(10927,10928),this.mirroringShapeCharacters.setValue(10928,10927),this.mirroringShapeCharacters.setValue(10931,10932),this.mirroringShapeCharacters.setValue(10932,10931),this.mirroringShapeCharacters.setValue(10939,10940),this.mirroringShapeCharacters.setValue(10940,10939),this.mirroringShapeCharacters.setValue(10941,10942),this.mirroringShapeCharacters.setValue(10942,10941),this.mirroringShapeCharacters.setValue(10943,10944),this.mirroringShapeCharacters.setValue(10944,10943),this.mirroringShapeCharacters.setValue(10945,10946),this.mirroringShapeCharacters.setValue(10946,10945),this.mirroringShapeCharacters.setValue(10947,10948),this.mirroringShapeCharacters.setValue(10948,10947),this.mirroringShapeCharacters.setValue(10949,10950),this.mirroringShapeCharacters.setValue(10950,10949),this.mirroringShapeCharacters.setValue(10957,10958),this.mirroringShapeCharacters.setValue(10958,10957),this.mirroringShapeCharacters.setValue(10959,10960),this.mirroringShapeCharacters.setValue(10960,10959),this.mirroringShapeCharacters.setValue(10961,10962),this.mirroringShapeCharacters.setValue(10962,10961),this.mirroringShapeCharacters.setValue(10963,10964),this.mirroringShapeCharacters.setValue(10964,10963),this.mirroringShapeCharacters.setValue(10965,10966),this.mirroringShapeCharacters.setValue(10966,10965),this.mirroringShapeCharacters.setValue(10974,8870),this.mirroringShapeCharacters.setValue(10979,8873),this.mirroringShapeCharacters.setValue(10980,8872),this.mirroringShapeCharacters.setValue(10981,8875),this.mirroringShapeCharacters.setValue(10988,10989),this.mirroringShapeCharacters.setValue(10989,10988),this.mirroringShapeCharacters.setValue(10999,11e3),this.mirroringShapeCharacters.setValue(11e3,10999),this.mirroringShapeCharacters.setValue(11001,11002),this.mirroringShapeCharacters.setValue(11002,11001),this.mirroringShapeCharacters.setValue(12296,12297),this.mirroringShapeCharacters.setValue(12297,12296),this.mirroringShapeCharacters.setValue(12298,12299),this.mirroringShapeCharacters.setValue(12299,12298),this.mirroringShapeCharacters.setValue(12300,12301),this.mirroringShapeCharacters.setValue(12301,12300),this.mirroringShapeCharacters.setValue(12302,12303),this.mirroringShapeCharacters.setValue(12303,12302),this.mirroringShapeCharacters.setValue(12304,12305),this.mirroringShapeCharacters.setValue(12305,12304),this.mirroringShapeCharacters.setValue(12308,12309),this.mirroringShapeCharacters.setValue(12309,12308),this.mirroringShapeCharacters.setValue(12310,12311),this.mirroringShapeCharacters.setValue(12311,12310),this.mirroringShapeCharacters.setValue(12312,12313),this.mirroringShapeCharacters.setValue(12313,12312),this.mirroringShapeCharacters.setValue(12314,12315),this.mirroringShapeCharacters.setValue(12315,12314),this.mirroringShapeCharacters.setValue(65288,65289),this.mirroringShapeCharacters.setValue(65289,65288),this.mirroringShapeCharacters.setValue(65308,65310),this.mirroringShapeCharacters.setValue(65310,65308),this.mirroringShapeCharacters.setValue(65339,65341),this.mirroringShapeCharacters.setValue(65341,65339),this.mirroringShapeCharacters.setValue(65371,65373),this.mirroringShapeCharacters.setValue(65373,65371),this.mirroringShapeCharacters.setValue(65375,65376),this.mirroringShapeCharacters.setValue(65376,65375),this.mirroringShapeCharacters.setValue(65378,65379),this.mirroringShapeCharacters.setValue(65379,65378)},t}(),_t=function(){function t(){this.types=[],this.textOrder=-1,this.rtlCharacterTypes=new Array(65536),this.L=0,this.LRE=1,this.LRO=2,this.R=3,this.AL=4,this.RLE=5,this.RLO=6,this.PDF=7,this.EN=8,this.ES=9,this.ET=10,this.AN=11,this.CS=12,this.NSM=13,this.BN=14,this.B=15,this.S=16,this.WS=17,this.ON=18,this.charTypes=[this.L,this.EN,this.BN,this.ES,this.ES,this.S,this.ET,this.ET,this.B,this.AN,this.AN,this.S,this.CS,this.CS,this.WS,this.NSM,this.NSM,this.B,this.BN,27,this.BN,28,30,this.B,31,31,this.S,32,32,this.WS,33,34,this.ON,35,37,this.ET,38,42,this.ON,43,43,this.ET,44,44,this.CS,45,45,this.ET,46,46,this.CS,47,47,this.CS,48,57,this.EN,58,58,this.CS,59,64,this.ON,65,90,this.L,91,96,this.ON,97,122,this.L,123,126,this.ON,127,132,this.BN,133,133,this.B,134,159,this.BN,160,160,this.CS,161,161,this.ON,162,165,this.ET,166,169,this.ON,170,170,this.L,171,175,this.ON,176,177,this.ET,178,179,this.EN,180,180,this.ON,181,181,this.L,182,184,this.ON,185,185,this.EN,186,186,this.L,187,191,this.ON,192,214,this.L,215,215,this.ON,216,246,this.L,247,247,this.ON,248,696,this.L,697,698,this.ON,699,705,this.L,706,719,this.ON,720,721,this.L,722,735,this.ON,736,740,this.L,741,749,this.ON,750,750,this.L,751,767,this.ON,768,855,this.NSM,856,860,this.L,861,879,this.NSM,880,883,this.L,884,885,this.ON,886,893,this.L,894,894,this.ON,895,899,this.L,900,901,this.ON,902,902,this.L,903,903,this.ON,904,1013,this.L,1014,1014,this.ON,1015,1154,this.L,1155,1158,this.NSM,1159,1159,this.L,1160,1161,this.NSM,1162,1417,this.L,1418,1418,this.ON,1419,1424,this.L,1425,1441,this.NSM,1442,1442,this.L,1443,1465,this.NSM,1466,1466,this.L,1467,1469,this.NSM,1470,1470,this.R,1471,1471,this.NSM,1472,1472,this.R,1473,1474,this.NSM,1475,1475,this.R,1476,1476,this.NSM,1477,1487,this.L,1488,1514,this.R,1515,1519,this.L,1520,1524,this.R,1525,1535,this.L,1536,1539,this.AL,1540,1547,this.L,1548,1548,this.CS,1549,1549,this.AL,1550,1551,this.ON,1552,1557,this.NSM,1558,1562,this.L,1563,1563,this.AL,1564,1566,this.L,1567,1567,this.AL,1568,1568,this.L,1569,1594,this.AL,1595,1599,this.L,1600,1610,this.AL,1611,1624,this.NSM,1625,1631,this.L,1632,1641,this.AN,1642,1642,this.ET,1643,1644,this.AN,1645,1647,this.AL,1648,1648,this.NSM,1649,1749,this.AL,1750,1756,this.NSM,1757,1757,this.AL,1758,1764,this.NSM,1765,1766,this.AL,1767,1768,this.NSM,1769,1769,this.ON,1770,1773,this.NSM,1774,1775,this.AL,1776,1785,this.EN,1786,1805,this.AL,1806,1806,this.L,1807,1807,this.BN,1808,1808,this.AL,1809,1809,this.NSM,1810,1839,this.AL,1840,1866,this.NSM,1867,1868,this.L,1869,1871,this.AL,1872,1919,this.L,1920,1957,this.AL,1958,1968,this.NSM,1969,1969,this.AL,1970,2304,this.L,2305,2306,this.NSM,2307,2363,this.L,2364,2364,this.NSM,2365,2368,this.L,2369,2376,this.NSM,2377,2380,this.L,2381,2381,this.NSM,2382,2384,this.L,2385,2388,this.NSM,2389,2401,this.L,2402,2403,this.NSM,2404,2432,this.L,2433,2433,this.NSM,2434,2491,this.L,2492,2492,this.NSM,2493,2496,this.L,2497,2500,this.NSM,2501,2508,this.L,2509,2509,this.NSM,2510,2529,this.L,2530,2531,this.NSM,2532,2545,this.L,2546,2547,this.ET,2548,2560,this.L,2561,2562,this.NSM,2563,2619,this.L,2620,2620,this.NSM,2621,2624,this.L,2625,2626,this.NSM,2627,2630,this.L,2631,2632,this.NSM,2633,2634,this.L,2635,2637,this.NSM,2638,2671,this.L,2672,2673,this.NSM,2674,2688,this.L,2689,2690,this.NSM,2691,2747,this.L,2748,2748,this.NSM,2749,2752,this.L,2753,2757,this.NSM,2758,2758,this.L,2759,2760,this.NSM,2761,2764,this.L,2765,2765,this.NSM,2766,2785,this.L,2786,2787,this.NSM,2788,2800,this.L,2801,2801,this.ET,2802,2816,this.L,2817,2817,this.NSM,2818,2875,this.L,2876,2876,this.NSM,2877,2878,this.L,2879,2879,this.NSM,2880,2880,this.L,2881,2883,this.NSM,2884,2892,this.L,2893,2893,this.NSM,2894,2901,this.L,2902,2902,this.NSM,2903,2945,this.L,2946,2946,this.NSM,2947,3007,this.L,3008,3008,this.NSM,3009,3020,this.L,3021,3021,this.NSM,3022,3058,this.L,3059,3064,this.ON,3065,3065,this.ET,3066,3066,this.ON,3067,3133,this.L,3134,3136,this.NSM,3137,3141,this.L,3142,3144,this.NSM,3145,3145,this.L,3146,3149,this.NSM,3150,3156,this.L,3157,3158,this.NSM,3159,3259,this.L,3260,3260,this.NSM,3261,3275,this.L,3276,3277,this.NSM,3278,3392,this.L,3393,3395,this.NSM,3396,3404,this.L,3405,3405,this.NSM,3406,3529,this.L,3530,3530,this.NSM,3531,3537,this.L,3538,3540,this.NSM,3541,3541,this.L,3542,3542,this.NSM,3543,3632,this.L,3633,3633,this.NSM,3634,3635,this.L,3636,3642,this.NSM,3643,3646,this.L,3647,3647,this.ET,3648,3654,this.L,3655,3662,this.NSM,3663,3760,this.L,3761,3761,this.NSM,3762,3763,this.L,3764,3769,this.NSM,3770,3770,this.L,3771,3772,this.NSM,3773,3783,this.L,3784,3789,this.NSM,3790,3863,this.L,3864,3865,this.NSM,3866,3892,this.L,3893,3893,this.NSM,3894,3894,this.L,3895,3895,this.NSM,3896,3896,this.L,3897,3897,this.NSM,3898,3901,this.ON,3902,3952,this.L,3953,3966,this.NSM,3967,3967,this.L,3968,3972,this.NSM,3973,3973,this.L,3974,3975,this.NSM,3976,3983,this.L,3984,3991,this.NSM,3992,3992,this.L,3993,4028,this.NSM,4029,4037,this.L,4038,4038,this.NSM,4039,4140,this.L,4141,4144,this.NSM,4145,4145,this.L,4146,4146,this.NSM,4147,4149,this.L,4150,4151,this.NSM,4152,4152,this.L,4153,4153,this.NSM,4154,4183,this.L,4184,4185,this.NSM,4186,5759,this.L,5760,5760,this.WS,5761,5786,this.L,5787,5788,this.ON,5789,5905,this.L,5906,5908,this.NSM,5909,5937,this.L,5938,5940,this.NSM,5941,5969,this.L,5970,5971,this.NSM,5972,6001,this.L,6002,6003,this.NSM,6004,6070,this.L,6071,6077,this.NSM,6078,6085,this.L,6086,6086,this.NSM,6087,6088,this.L,6089,6099,this.NSM,6100,6106,this.L,6107,6107,this.ET,6108,6108,this.L,6109,6109,this.NSM,6110,6127,this.L,6128,6137,this.ON,6138,6143,this.L,6144,6154,this.ON,6155,6157,this.NSM,6158,6158,this.WS,6159,6312,this.L,6313,6313,this.NSM,6314,6431,this.L,6432,6434,this.NSM,6435,6438,this.L,6439,6443,this.NSM,6444,6449,this.L,6450,6450,this.NSM,6451,6456,this.L,6457,6459,this.NSM,6460,6463,this.L,6464,6464,this.ON,6465,6467,this.L,6468,6469,this.ON,6470,6623,this.L,6624,6655,this.ON,6656,8124,this.L,8125,8125,this.ON,8126,8126,this.L,8127,8129,this.ON,8130,8140,this.L,8141,8143,this.ON,8144,8156,this.L,8157,8159,this.ON,8160,8172,this.L,8173,8175,this.ON,8176,8188,this.L,8189,8190,this.ON,8191,8191,this.L,8192,8202,this.WS,8203,8205,this.BN,8206,8206,this.L,8207,8207,this.R,8208,8231,this.ON,8232,8232,this.WS,8233,8233,this.B,8234,8234,this.LRE,8235,8235,this.RLE,8236,8236,this.PDF,8237,8237,this.LRO,8238,8238,this.RLO,8239,8239,this.WS,8240,8244,this.ET,8245,8276,this.ON,8277,8278,this.L,8279,8279,this.ON,8280,8286,this.L,8287,8287,this.WS,8288,8291,this.BN,8292,8297,this.L,8298,8303,this.BN,8304,8304,this.EN,8305,8307,this.L,8308,8313,this.EN,8314,8315,this.ET,8316,8318,this.ON,8319,8319,this.L,8320,8329,this.EN,8330,8331,this.ET,8332,8334,this.ON,8335,8351,this.L,8352,8369,this.ET,8370,8399,this.L,8400,8426,this.NSM,8427,8447,this.L,8448,8449,this.ON,8450,8450,this.L,8451,8454,this.ON,8455,8455,this.L,8456,8457,this.ON,8458,8467,this.L,8468,8468,this.ON,8469,8469,this.L,8470,8472,this.ON,8473,8477,this.L,8478,8483,this.ON,8484,8484,this.L,8485,8485,this.ON,8486,8486,this.L,8487,8487,this.ON,8488,8488,this.L,8489,8489,this.ON,8490,8493,this.L,8494,8494,this.ET,8495,8497,this.L,8498,8498,this.ON,8499,8505,this.L,8506,8507,this.ON,8508,8511,this.L,8512,8516,this.ON,8517,8521,this.L,8522,8523,this.ON,8524,8530,this.L,8531,8543,this.ON,8544,8591,this.L,8592,8721,this.ON,8722,8723,this.ET,8724,9013,this.ON,9014,9082,this.L,9083,9108,this.ON,9109,9109,this.L,9110,9168,this.ON,9169,9215,this.L,9216,9254,this.ON,9255,9279,this.L,9280,9290,this.ON,9291,9311,this.L,9312,9371,this.EN,9372,9449,this.L,9450,9450,this.EN,9451,9751,this.ON,9752,9752,this.L,9753,9853,this.ON,9854,9855,this.L,9856,9873,this.ON,9874,9887,this.L,9888,9889,this.ON,9890,9984,this.L,9985,9988,this.ON,9989,9989,this.L,9990,9993,this.ON,9994,9995,this.L,9996,10023,this.ON,10024,10024,this.L,10025,10059,this.ON,10060,10060,this.L,10061,10061,this.ON,10062,10062,this.L,10063,10066,this.ON,10067,10069,this.L,10070,10070,this.ON,10071,10071,this.L,10072,10078,this.ON,10079,10080,this.L,10081,10132,this.ON,10133,10135,this.L,10136,10159,this.ON,10160,10160,this.L,10161,10174,this.ON,10175,10191,this.L,10192,10219,this.ON,10220,10223,this.L,10224,11021,this.ON,11022,11903,this.L,11904,11929,this.ON,11930,11930,this.L,11931,12019,this.ON,12020,12031,this.L,12032,12245,this.ON,12246,12271,this.L,12272,12283,this.ON,12284,12287,this.L,12288,12288,this.WS,12289,12292,this.ON,12293,12295,this.L,12296,12320,this.ON,12321,12329,this.L,12330,12335,this.NSM,12336,12336,this.ON,12337,12341,this.L,12342,12343,this.ON,12344,12348,this.L,12349,12351,this.ON,12352,12440,this.L,12441,12442,this.NSM,12443,12444,this.ON,12445,12447,this.L,12448,12448,this.ON,12449,12538,this.L,12539,12539,this.ON,12540,12828,this.L,12829,12830,this.ON,12831,12879,this.L,12880,12895,this.ON,12896,12923,this.L,12924,12925,this.ON,12926,12976,this.L,12977,12991,this.ON,12992,13003,this.L,13004,13007,this.ON,13008,13174,this.L,13175,13178,this.ON,13179,13277,this.L,13278,13279,this.ON,13280,13310,this.L,13311,13311,this.ON,13312,19903,this.L,19904,19967,this.ON,19968,42127,this.L,42128,42182,this.ON,42183,64284,this.L,64285,64285,this.R,64286,64286,this.NSM,64287,64296,this.R,64297,64297,this.ET,64298,64310,this.R,64311,64311,this.L,64312,64316,this.R,64317,64317,this.L,64318,64318,this.R,64319,64319,this.L,64320,64321,this.R,64322,64322,this.L,64323,64324,this.R,64325,64325,this.L,64326,64335,this.R,64336,64433,this.AL,64434,64466,this.L,64467,64829,this.AL,64830,64831,this.ON,64832,64847,this.L,64848,64911,this.AL,64912,64913,this.L,64914,64967,this.AL,64968,65007,this.L,65008,65020,this.AL,65021,65021,this.ON,65022,65023,this.L,65024,65039,this.NSM,65040,65055,this.L,65056,65059,this.NSM,65060,65071,this.L,65072,65103,this.ON,65104,65104,this.CS,65105,65105,this.ON,65106,65106,this.CS,65107,65107,this.L,65108,65108,this.ON,65109,65109,this.CS,65110,65118,this.ON,65119,65119,this.ET,65120,65121,this.ON,65122,65123,this.ET,65124,65126,this.ON,65127,65127,this.L,65128,65128,this.ON,65129,65130,this.ET,65131,65131,this.ON,65132,65135,this.L,65136,65140,this.AL,65141,65141,this.L,65142,65276,this.AL,65277,65278,this.L,65279,65279,this.BN,65280,65280,this.L,65281,65282,this.ON,65283,65285,this.ET,65286,65290,this.ON,65291,65291,this.ET,65292,65292,this.CS,65293,65293,this.ET,65294,65294,this.CS,65295,65295,this.ES,65296,65305,this.EN,65306,65306,this.CS,65307,65312,this.ON,65313,65338,this.L,65339,65344,this.ON,65345,65370,this.L,65371,65381,this.ON,65382,65503,this.L,65504,65505,this.ET,65506,65508,this.ON,65509,65510,this.ET,65511,65511,this.L,65512,65518,this.ON,65519,65528,this.L,65529,65531,this.BN,65532,65533,this.ON,65534,65535,this.L];for(var t=0;t<this.charTypes.length;++t)for(var e=this.charTypes[t],i=this.charTypes[++t],r=this.charTypes[++t];e<=i;)this.rtlCharacterTypes[e++]=r}return t.prototype.getVisualOrder=function(t,e){this.types=this.getCharacterCode(t),this.textOrder=e?this.LRE:this.L,this.doVisualOrder();for(var i=[],r=0;r<this.levels.length;r++)i[r]=this.levels[r];return i},t.prototype.getCharacterCode=function(t){for(var e=[],i=0;i<t.length;i++)e[i]=this.rtlCharacterTypes[t[i].charCodeAt(0)];return e},t.prototype.setDefaultLevels=function(){for(var t=0;t<this.length;t++)this.levels[t]=this.textOrder},t.prototype.setLevels=function(){this.setDefaultLevels();for(var t=0;t<this.length;++t){var e=this.levels[t];0!=(128&e)&&(e&=127,this.result[t]=0==(1&e)?this.L:this.R),this.levels[t]=e}},t.prototype.updateLevels=function(t,e,i){if(0==(1&e))for(var r=t;r<i;++r)this.result[r]===this.R?this.levels[r]+=1:this.result[r]!==this.L&&(this.levels[r]+=2);else for(r=t;r<i;++r)this.result[r]!==this.R&&(this.levels[r]+=1)},t.prototype.doVisualOrder=function(){this.length=this.types.length,this.result=this.types,this.levels=[],this.setLevels(),this.length=this.getEmbeddedCharactersLength();for(var t=this.textOrder,e=0;e<this.length;){for(var i=this.levels[e],r=0==(1&Math.max(t,i))?this.L:this.R,n=e+1;n<this.length&&this.levels[n]===i;)++n;var o=n<this.length?this.levels[n]:this.textOrder,s=0==(1&Math.max(o,i))?this.L:this.R;this.checkNSM(e,n,i,r,s),this.updateLevels(e,i,n),t=i,e=n}this.checkEmbeddedCharacters(this.length)},t.prototype.getEmbeddedCharactersLength=function(){for(var t=0,e=0;e<this.length;++e)this.types[e]!==this.LRE&&this.types[e]!==this.RLE&&this.types[e]!==this.LRO&&this.types[e]!==this.RLO&&this.types[e]!==this.PDF&&this.types[e]!==this.BN&&(this.result[t]=this.result[e],this.levels[t]=this.levels[e],t++);return t},t.prototype.checkEmbeddedCharacters=function(t){for(var e=this.types.length-1;e>=0;--e)this.types[e]===this.LRE||this.types[e]===this.RLE||this.types[e]===this.LRO||this.types[e]===this.RLO||this.types[e]===this.PDF||this.types[e]===this.BN?(this.result[e]=this.types[e],this.levels[e]=-1):(t-=1,this.result[e]=this.result[t],this.levels[e]=this.levels[t]);for(e=0;e<this.types.length;e++)-1===this.levels[e]&&(this.levels[e]=0===e?this.textOrder:this.levels[e-1])},t.prototype.checkNSM=function(t,e,i,r,n){for(var o=r,s=t;s<e;++s)this.result[s]===this.NSM?this.result[s]=o:o=this.result[s];this.checkEuropeanDigits(t,e,i,r,n)},t.prototype.checkEuropeanDigits=function(t,e,i,r,n){for(var o=t;o<e;++o)if(this.result[o]===this.EN)for(var s=o-1;s>=t;--s)if(this.result[s]===this.L||this.result[s]===this.R||this.result[s]===this.AL){this.result[s]===this.AL&&(this.result[o]=this.AN);break}this.checkArabicCharacters(t,e,i,r,n)},t.prototype.checkArabicCharacters=function(t,e,i,r,n){for(var o=t;o<e;++o)this.result[o]===this.AL&&(this.result[o]=this.R);this.checkEuropeanNumberSeparator(t,e,i,r,n)},t.prototype.checkEuropeanNumberSeparator=function(t,e,i,r,n){for(var o=t+1;o<e-1;++o)if(this.result[o]===this.ES||this.result[o]===this.CS){var s=this.result[o-1],a=this.result[o+1];s===this.EN&&a===this.EN?this.result[o]=this.EN:this.result[o]===this.CS&&s===this.AN&&a===this.AN&&(this.result[o]=this.AN)}this.checkEuropeanNumberTerminator(t,e,i,r,n)},t.prototype.checkEuropeanNumberTerminator=function(t,e,i,r,n){for(var o=t;o<e;++o)if(this.result[o]===this.ET){var s=o,a=[];a.push(this.ET);var h=this.getLength(s,e,a),l=s===t?r:this.result[s-1];if(l!==this.EN&&(l=h===e?n:this.result[h]),l===this.EN)for(var u=s;u<h;++u)this.result[u]=this.EN;o=h}this.checkOtherNeutrals(t,e,i,r,n)},t.prototype.checkOtherNeutrals=function(t,e,i,r,n){for(var o=t;o<e;++o)this.result[o]!==this.ES&&this.result[o]!==this.ET&&this.result[o]!==this.CS||(this.result[o]=this.ON);this.checkOtherCharacters(t,e,i,r,n)},t.prototype.checkOtherCharacters=function(t,e,i,r,n){for(var o=t;o<e;++o)if(this.result[o]===this.EN){for(var s=r,a=o-1;a>=t;--a)if(this.result[a]===this.L||this.result[a]===this.R){s=this.result[a];break}s===this.L&&(this.result[o]=this.L)}this.checkCommanCharacters(t,e,i,r,n)},t.prototype.getLength=function(t,e,i){for(--t;++t<e;){for(var r=this.result[t],n=0;n<i.length;++n)r===i[n]&&(t=this.getLength(++t,e,i));return t}return e},t.prototype.checkCommanCharacters=function(t,e,i,r,n){for(var o=t;o<e;++o)if(this.result[o]===this.WS||this.result[o]===this.ON||this.result[o]===this.B||this.result[o]===this.S){var s=o,a=[this.B,this.S,this.WS,this.ON],h=this.getLength(s,e,a),l=0,u=0,c=0;s===t?l=r:(l=this.result[s-1])===this.AN?l=this.R:l===this.EN&&(l=this.R),h===e?u=n:(u=this.result[h])===this.AN?u=this.R:u===this.EN&&(u=this.R),c=l===u?l:0==(1&i)?this.L:this.R;for(var p=s;p<h;++p)this.result[p]=c;o=h}},t}(),Kt=function(){function e(){this.openBracket="(",this.closeBracket=")"}return e.prototype.layout=function(t,e,i,r,n){if(null==t)throw new Error("ArgumentNullException : line");if(null==e)throw new Error("ArgumentNullException : font");var o=[];return e.Unicode?o=this.customLayout(t,i,n,e,r):(o=[])[0]=t,o},e.prototype.splitLayout=function(t,e,i,r,n){if(null==t)throw new Error("ArgumentNullException : line");if(null==e)throw new Error("ArgumentNullException : font");return this.customSplitLayout(t,e,i,r,n)},e.prototype.getGlyphIndex=function(t,e,i,r,n){if(null==t)throw new Error("ArgumentNullException : line");if(null==e)throw new Error("ArgumentNullException : font");if(r=null,0===t.length)return{success:!1,glyphs:r};var o=(new zt).shape(t,0),s=e.fontInternal.ttfReader;r=new Uint16Array(o.length);for(var a=0,h=0,l=o.length;h<l;h++){var u=o[h],c=s.getGlyph(u);null!==c&&void 0!==c&&(r[a++]=c.index)}return{success:!0,glyphs:r}},e.prototype.customLayout=function(e,i,r,n,o){if(null===o||void 0===o){if(null==e)throw new Error("ArgumentNullException : line");var s=null;if(null!==r&&void 0!==r&&r.textDirection!==t.PdfTextDirection.None){s=(new Ht).getLogicalToVisualString(e,i)}return s}if(null==e)throw new Error("ArgumentNullException : line");if(null==n)throw new Error("ArgumentNullException : font");var a=null;if(null!==r&&void 0!==r&&r.textDirection!==t.PdfTextDirection.None){var h=(new zt).shape(e,0);a=this.customLayout(h,i,r)}s=[];if(o){for(var l=a.split(""),u=l.length,c=0;c<u;c++)l[c]=this.addChars(n,l[c]);s=l}else(s=[])[0]=this.addChars(n,a);return s},e.prototype.addChars=function(t,e){var i=e;if(null==t)throw new Error("ArgumentNullException : font");if(null==i)throw new Error("ArgumentNullException : line");var r=i,n=t.fontInternal.ttfReader;t.setSymbols(r),r=n.convertString(r);var o=S.toUnicodeArray(r,!1);return r=S.byteToString(o)},e.prototype.customSplitLayout=function(t,e,i,r,n){if(null==t)throw new Error("ArgumentNullException : line");if(null==e)throw new Error("ArgumentNullException : font");return this.customLayout(t,i,n).split("")},e}();!function(t){t[t.Paginate=0]="Paginate",t[t.OnePage=1]="OnePage"}(t.PdfLayoutType||(t.PdfLayoutType={})),function(t){t[t.FitPage=0]="FitPage",t[t.FitElement=1]="FitElement",t[t.FitColumnsToPage=2]="FitColumnsToPage"}(t.PdfLayoutBreakType||(t.PdfLayoutBreakType={})),function(t){t[t.Start=0]="Start",t[t.Line=1]="Line",t[t.Bezier3=3]="Bezier3",t[t.Bezier=3]="Bezier",t[t.PathTypeMask=7]="PathTypeMask",t[t.DashMode=16]="DashMode",t[t.PathMarker=32]="PathMarker",t[t.CloseSubpath=128]="CloseSubpath"}(t.PathPointType||(t.PathPointType={}));var Ut=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),qt=function(e){function i(i){var r=e.call(this)||this;return r.mbackground=new L(255,255,255),r.mbStroking=!1,r.mfunction=null,r.dictionaryProperties=new a,r.mpatternDictionary=new h,r.mpatternDictionary.items.setValue(r.dictionaryProperties.type,new o(r.dictionaryProperties.pattern)),r.mpatternDictionary.items.setValue(r.dictionaryProperties.patternType,new g(2)),r.shading=i,r.colorSpace=t.PdfColorSpace.Rgb,r}return Ut(i,e),Object.defineProperty(i.prototype,"background",{get:function(){return this.mbackground},set:function(t){this.mbackground=t;var e=this.shading;t.isEmpty?e.remove(this.dictionaryProperties.background):e.items.setValue(this.dictionaryProperties.background,t.toArray(this.colorSpace))},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"antiAlias",{get:function(){return this.shading.items.getValue(this.dictionaryProperties.antiAlias).value},set:function(t){var e=this.shading,i=e.items.getValue(this.dictionaryProperties.antiAlias);null==i&&void 0===i?(i=new ct(t),e.items.setValue(this.dictionaryProperties.antiAlias,i)):i.value=t},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"function",{get:function(){return this.mfunction},set:function(t){this.mfunction=t,null!=t&&void 0!==t?this.shading.items.setValue(this.dictionaryProperties.function,new C(this.mfunction)):this.shading.remove(this.dictionaryProperties.function)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"bBox",{get:function(){return this.shading.items.getValue(this.dictionaryProperties.bBox)},set:function(t){var e=this.shading;null==t&&void 0===t?e.remove(this.dictionaryProperties.bBox):e.items.setValue(this.dictionaryProperties.bBox,t)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"colorSpace",{get:function(){return this.mcolorSpace},set:function(t){var e=this.shading.items.getValue(this.dictionaryProperties.colorSpace);if(t!==this.mcolorSpace||null==e){this.mcolorSpace=t;var i=this.colorSpaceToDeviceName(t);this.shading.items.setValue(this.dictionaryProperties.colorSpace,new o(i))}},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"stroking",{get:function(){return this.mbStroking},set:function(t){this.mbStroking=t},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"patternDictionary",{get:function(){return null==this.mpatternDictionary&&(this.mpatternDictionary=new h),this.mpatternDictionary},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"shading",{get:function(){return this.mshading},set:function(t){if(null==t)throw new Error("ArgumentNullException : Shading");t!==this.mshading&&(this.mshading=t,this.patternDictionary.items.setValue(this.dictionaryProperties.shading,new C(this.mshading)))},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"matrix",{get:function(){return this.mmatrix},set:function(t){if(null==t)throw new Error("ArgumentNullException : Matrix");if(t!==this.mmatrix){this.mmatrix=t.clone();var e=new m(this.mmatrix.matrix.elements);this.mpatternDictionary.items.setValue(this.dictionaryProperties.matrix,e)}},enumerable:!0,configurable:!0}),i.prototype.monitorChanges=function(t,e,r,n,o){var s=!1;if(t instanceof i){this.colorSpace!==o&&(this.colorSpace=o,this.resetFunction()),e.setColorSpace("Pattern",this.mbStroking);var a=r.getResources().getName(this);e.setColourWithPattern(null,a,this.mbStroking),s=!0}return s},i.prototype.resetChanges=function(t){},i.prototype.colorSpaceToDeviceName=function(e){var i;switch(e){case t.PdfColorSpace.Rgb:i="DeviceRGB"}return i},i.prototype.resetPatternDictionary=function(t){this.mpatternDictionary=t},i.prototype.cloneAntiAliasingValue=function(t){if(null==t)throw new Error("ArgumentNullException : brush");var e=this.shading.items.getValue(this.dictionaryProperties.antiAlias);null!=e&&t.shading.items.setValue(this.dictionaryProperties.antiAlias,new ct(e.value))},i.prototype.cloneBackgroundValue=function(t){var e=this.background;e.isEmpty||(t.background=e)},Object.defineProperty(i.prototype,"element",{get:function(){return this.patternDictionary},enumerable:!0,configurable:!0}),i}(R),Yt=function(){function t(t,e){if(this.dictionaryProperties=new a,this.writeTransformation=!0,void 0===t);else if(t instanceof j&&void 0===e){this.content=new b;var i=new j(t.width,t.height);this.setSize(i),this.initialize()}else this.content=new b,this.setSize(new j(t,e)),this.initialize()}return Object.defineProperty(t.prototype,"size",{get:function(){return this.templateSize},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"width",{get:function(){return this.size.width},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"height",{get:function(){return this.size.height},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"graphics",{get:function(){if(null==this.pdfGraphics||void 0===this.pdfGraphics){var t=new ee(this),e=new te(this.size,t,this.content);this.pdfGraphics=e,this.pdfGraphics.initializeCoordinates()}return this.pdfGraphics},enumerable:!0,configurable:!0}),t.prototype.getResources=function(){return null==this.resources&&(this.resources=new Jt,this.content.items.setValue(this.dictionaryProperties.resources,this.resources)),this.resources},t.prototype.initialize=function(){this.addType(),this.addSubType()},t.prototype.addType=function(){var t=new o(this.dictionaryProperties.xObject);this.content.items.setValue(this.dictionaryProperties.type,t)},t.prototype.addSubType=function(){var t=new o(this.dictionaryProperties.form);this.content.items.setValue(this.dictionaryProperties.subtype,t)},t.prototype.reset=function(t){void 0===t?(null!=this.resources&&(this.resources=null,this.content.remove(this.dictionaryProperties.resources)),null!=this.graphics&&this.graphics.reset(this.size)):(this.setSize(t),this.reset())},t.prototype.setSize=function(t){var e=new k(new T(0,0),t),i=m.fromRectangle(e);this.content.items.setValue(this.dictionaryProperties.bBox,i),this.templateSize=t},Object.defineProperty(t.prototype,"element",{get:function(){return this.content},enumerable:!0,configurable:!0}),t}(),Xt=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Jt=function(t){function e(e){var i=t.call(this,e)||this;return i.properties=new h,i}return Xt(e,t),Object.defineProperty(e.prototype,"names",{get:function(){return this.getNames()},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"document",{get:function(){return this.pdfDocument},set:function(t){this.pdfDocument=t},enumerable:!0,configurable:!0}),e.prototype.getName=function(t){var e=t.element,i=null;if(this.names.containsKey(e)&&(i=this.names.getValue(e)),null==i){var r=this.generateName();i=new o(r),this.names.setValue(e,i),t instanceof G?this.add(t,i):t instanceof Yt?this.add(t,i):t instanceof qt||t instanceof Qt?this.add(t,i):t instanceof nt?this.add(t,i):(t instanceof ft||t instanceof mt)&&this.add(t,i)}return i},e.prototype.getNames=function(){null==this.pdfNames&&(this.pdfNames=new rt);var t=this.items.getValue(this.dictionaryProperties.font);if(null!=t){q.dereference(t)}return this.pdfNames},e.prototype.requireProcedureSet=function(t){if(null==t)throw new Error("ArgumentNullException:procedureSetName");var e=this.items.getValue(this.dictionaryProperties.procset);null==e&&(e=new m,this.items.setValue(this.dictionaryProperties.procset,e));var i=new o(t);e.contains(i)||e.add(i)},e.prototype.removeFont=function(t){for(var e=null,i=this.pdfNames.keys(),r=0;r<this.pdfNames.size();r++)if(this.pdfNames.getValue(i[r])===new o(t)){e=i[r];break}null!=e&&this.pdfNames.remove(e)},e.prototype.generateName=function(){return Zt.getNewGuidString()},e.prototype.add=function(t,e){if(t instanceof G){var i=null,r=this.items.getValue(this.dictionaryProperties.font);if(null!=r){var n=r;i=r,i=r}else i=new h,this.items.setValue(this.dictionaryProperties.font,i);i.items.setValue(e.value,new C(t.element))}else if(t instanceof Yt){var o=void 0;null==(o=this.items.getValue(this.dictionaryProperties.xObject))&&(o=new h,this.items.setValue(this.dictionaryProperties.xObject,o)),o.items.setValue(e.value,new C(t.element))}else if(t instanceof R){if(t instanceof qt||t instanceof Qt){if(null!=(a=t.element)){var s=this.items.getValue(this.dictionaryProperties.pattern);null==s&&(s=new h,this.items.setValue(this.dictionaryProperties.pattern,s)),s.items.setValue(e.value,new C(a))}}}else if(t instanceof nt){var a=t.element,l=null;null==(l=this.items.getValue(this.dictionaryProperties.extGState))&&(l=new h,this.items.setValue(this.dictionaryProperties.extGState,l)),l.items.setValue(e.value,new C(a))}else{o=this.Dictionary.items.getValue(this.dictionaryProperties.xObject);var u=void 0;void 0!==this.pdfDocument&&(u=this.pdfDocument.sections.element.items.getValue(this.dictionaryProperties.resources).items.getValue(this.dictionaryProperties.xObject));this.Dictionary.items.values();var c=!1,p=void 0;if(void 0===this.pdfDocument||void 0!==typeof u&&null!=u){if(void 0!==this.pdfDocument)for(var d=u.items.values(),f=0;f<d.length;f++)void 0!==d[f]&&void 0!==d[f].element&&d[f].element.data[0]===t.element.data[0]&&(p=d[f],c=!0)}else u=new h,this.pdfDocument.sections.element.items.getValue(this.dictionaryProperties.resources).items.setValue(this.dictionaryProperties.xObject,u);if(null==o&&(o=new h,this.Dictionary.items.setValue(this.dictionaryProperties.xObject,o)),c&&void 0!==p)o.items.setValue(e.value,p);else{n=new C(t.element);o.items.setValue(e.value,n),void 0!==this.pdfDocument&&u.items.setValue(e.value,n)}}},e}(h),Zt=function(){function t(){}return t.getNewGuidString=function(){return"aaaaaaaa-aaaa-4aaa-baaa-aaaaaaaaaaaa".replace(/[ab]/g,function(t){var e=16*Math.random()|0;return("a"===t?e:3&e|8).toString(16)})},t}(),$t=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Qt=function(t){function e(e,i){var r=t.call(this)||this;r.mStroking=!1,r.mLocation=new T(0,0),r.mDictionaryProperties=new a;var n=null;return e instanceof V?n=e:e instanceof j&&(n=new V(0,0,e.width,e.height)),null!==i&&i instanceof ce&&(r.mPage=i),r.brushStream=new b,r.mResources=new Jt,r.brushStream.items.setValue(r.mDictionaryProperties.resources,r.mResources),r.setBox(n),r.setObligatoryFields(),null!==i&&i instanceof ce&&(r.mPage=i,r.graphics.colorSpace=i.document.colorSpace),r}return $t(e,t),e.prototype.initialize=function(t,e,i,r){this.mPage=e,this.mLocation=i,this.mTransformationMatrix=r,this.tempBrushStream=this.brushStream,this.brushStream=new b;var n=new Jt;return this.brushStream.items.setValue(this.mDictionaryProperties.resources,n),this.setBox(t),this.setObligatoryFields(),this},Object.defineProperty(e.prototype,"location",{get:function(){return this.mLocation},set:function(t){this.mLocation=t},enumerable:!0,configurable:!0}),e.prototype.setObligatoryFields=function(){if(this.brushStream.items.setValue(this.mDictionaryProperties.patternType,new g(1)),this.brushStream.items.setValue(this.mDictionaryProperties.paintType,new g(1)),this.brushStream.items.setValue(this.mDictionaryProperties.tilingType,new g(1)),this.brushStream.items.setValue(this.mDictionaryProperties.xStep,new g(this.mBox.right-this.mBox.left)),this.brushStream.items.setValue(this.mDictionaryProperties.yStep,new g(this.mBox.bottom-this.mBox.top)),null!=this.mPage&&null!=this.mLocation)if(null==this.mTransformationMatrix&&void 0===this.mTransformationMatrix){var t=this.mPage.size.height%this.rectangle.size.height-this.mLocation.y;this.brushStream.items.setValue(this.mDictionaryProperties.matrix,new m([1,0,0,1,this.mLocation.x,t]))}else{t=0;var e=this.mTransformationMatrix.matrix.elements;t=this.mPage.size.height>this.rectangle.size.height?this.mTransformationMatrix.matrix.offsetY-this.mPage.size.height%this.rectangle.size.height:this.mPage.size.height%this.rectangle.size.height+this.mTransformationMatrix.matrix.offsetY,this.brushStream.items.setValue(this.mDictionaryProperties.matrix,new m([e[0],e[1],e[2],e[3],e[4],t]))}},e.prototype.setBox=function(t){this.mBox=t;var e=new k(this.mBox.left,this.mBox.top,this.mBox.right,this.mBox.bottom);this.brushStream.items.setValue(this.mDictionaryProperties.bBox,m.fromRectangle(e))},Object.defineProperty(e.prototype,"rectangle",{get:function(){return this.mBox},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"size",{get:function(){return this.mBox.size},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"graphics",{get:function(){if(null==this.mGraphics&&void 0===this.mGraphics){var t=new ee(this),e=new te(this.size,t,this.brushStream);this.mGraphics=e,this.mResources=this.getResources(),this.mGraphics.initializeCoordinates()}return this.mGraphics},enumerable:!0,configurable:!0}),e.prototype.getResources=function(){return this.mResources},Object.defineProperty(e.prototype,"stroking",{get:function(){return this.mStroking},set:function(t){this.mStroking=t},enumerable:!0,configurable:!0}),e.prototype.clone=function(){var t=this.initialize(this.rectangle,this.mPage,this.location,this.mTransformationMatrix);return null!=this.mTransformationMatrix&&null!=this.mTransformationMatrix.matrix&&t.brushStream.items.setValue(this.mDictionaryProperties.matrix,new m(this.mTransformationMatrix.matrix.elements)),t.brushStream.data=this.tempBrushStream.data,t.mResources=new Jt(this.mResources),t.brushStream.items.setValue(this.mDictionaryProperties.resources,t.mResources),t},e.prototype.monitorChanges=function(t,i,r,n,o){var s=!1;if(t!==this){i.setColorSpace("Pattern",this.mStroking);var a=r.getResources().getName(this);i.setColourWithPattern(null,a,this.mStroking),s=!0}else if(t instanceof e){i.setColorSpace("Pattern",this.mStroking);var h=r.getResources().getName(this);i.setColourWithPattern(null,h,this.mStroking),s=!0}return s},e.prototype.resetChanges=function(t){},Object.defineProperty(e.prototype,"element",{get:function(){return this.brushStream},enumerable:!0,configurable:!0}),e}(R),te=function(){function e(e,i,r){this.currentColorSpace=t.PdfColorSpace.Rgb,this.previousTextRenderingMode=t.TextRenderingMode.Fill,this.previousCharacterSpacing=0,this.previousWordSpacing=0,this.previousTextScaling=100,this.procedureSets=new it,this.isNormalRender=!0,this.isUseFontSize=!1,this.isItalic=!1,this.isEmfTextScaled=!1,this.isEmf=!1,this.isEmfPlus=!1,this.isBaselineFormat=!0,this.emfScalingFactor=new j(0,0),this.colorSpaceChanged=!1,this.dictionaryProperties=new a,this.isOverloadWithPosition=!1,this.isPointOverload=!1,this.currentColorSpaces=["RGB","CMYK","GrayScale","Indexed"],this.isImageOptimized=!1,this.graphicsState=[],this.istransparencySet=!1,this.internalAutomaticFields=null,this.startCutIndex=-1,this.getResources=i,this.canvasSize=e,this.pdfStreamWriter=r instanceof $?r:new $(r),this.initialize()}return Object.defineProperty(e.prototype,"stringLayoutResult",{get:function(){return this.pdfStringLayoutResult},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"size",{get:function(){return this.canvasSize},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"mediaBoxUpperRightBound",{get:function(){return void 0===this.internalMediaBoxUpperRightBound&&(this.internalMediaBoxUpperRightBound=0),this.internalMediaBoxUpperRightBound},set:function(t){this.internalMediaBoxUpperRightBound=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"clientSize",{get:function(){return new j(this.clipBounds.width,this.clipBounds.height)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"colorSpace",{get:function(){return this.currentColorSpace},set:function(t){this.currentColorSpace=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"streamWriter",{get:function(){return this.pdfStreamWriter},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"matrix",{get:function(){return null==this.transformationMatrix&&(this.transformationMatrix=new tt),this.transformationMatrix},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"layer",{get:function(){return this.pageLayer},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"page",{get:function(){return this.pageLayer.page},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"automaticFields",{get:function(){return null!=this.internalAutomaticFields&&void 0!==this.internalAutomaticFields||(this.internalAutomaticFields=new ot),this.internalAutomaticFields},enumerable:!0,configurable:!0}),e.prototype.initialize=function(){this.bStateSaved=!1,this.currentPen=null,this.currentBrush=null,this.currentFont=null,this.currentColorSpace=t.PdfColorSpace.Rgb,this.bCSInitialized=!1,this.transformationMatrix=null,this.previousTextRenderingMode=-1,this.previousCharacterSpacing=-1,this.previousWordSpacing=-1,this.previousTextScaling=-100,this.currentStringFormat=null,this.clipBounds=new k(new T(0,0),this.size),this.getResources.getResources().requireProcedureSet(this.procedureSets.pdf)},e.prototype.drawPdfTemplate=function(t,e,i){if(void 0===i){if(null==t)throw Error("ArgumentNullException-template");this.drawPdfTemplate(t,e,t.size)}else{if(null==t)throw Error("ArgumentNullException-template");var r=t.width>0?i.width/t.width:1,n=t.height>0?i.height/t.height:1,o=!(1===r&&1===n),s=this.save(),a=new tt;null!=this.pageLayer&&this.getTranslateTransform(e.x,e.y+i.height,a),o&&this.getScaleTransform(r,n,a),this.pdfStreamWriter.modifyCtm(a);var h=this.getResources.getResources().getName(t);this.pdfStreamWriter.executeObject(h),this.restore(s);var l=t.graphics;if(null!=l)for(var u=0;u<l.automaticFields.automaticFields.length;u++){var c=l.automaticFields.automaticFields[u],p=new T(c.location.x+e.x,c.location.y+e.y),d=0==t.size.width?0:i.width/t.size.width,f=0==t.size.height?0:i.height/t.size.height;this.automaticFields.add(new lt(c.field,p,d,f)),this.page.dictionary.modify()}this.getResources.getResources().requireProcedureSet(this.procedureSets.imageB),this.getResources.getResources().requireProcedureSet(this.procedureSets.imageC),this.getResources.getResources().requireProcedureSet(this.procedureSets.imageI),this.getResources.getResources().requireProcedureSet(this.procedureSets.text)}},e.prototype.drawString=function(t,e,i,r,n,o,s,a,h){if("string"==typeof t&&e instanceof G&&(i instanceof Q||null===i)&&(r instanceof R||null===r)&&"number"==typeof n&&"number"==typeof o&&(s instanceof A||null===s)&&void 0===a)this.isOverloadWithPosition=!0,this.drawString(t,e,i,r,n,o,this.clientSize.width-n,0,s);else{var l=i,u=r,c=n,p=o,d=s,f=a,g=h,m=(new F).layout(t,e,g,new j(d,f),this.isOverloadWithPosition,this.clientSize);if(!m.empty){var y=this.checkCorrectLayoutRectangle(m.actualSize,c,p,g);d<=0&&(c=y.x,d=y.width),f<=0&&(p=y.y,f=y.height),this.drawStringLayoutResult(m,e,l,u,new k(c,p,d,f),g),this.isEmfTextScaled=!1,this.emfScalingFactor=new j(0,0)}this.getResources.getResources().requireProcedureSet(this.procedureSets.text),this.isNormalRender=!0,this.pdfStringLayoutResult=m,this.isUseFontSize=!1}},e.prototype.drawLine=function(t,e,i,r,n){if(e instanceof T){var o=e,s=i;this.drawLine(t,o.x,o.y,s.x,s.y)}else{o=e,s=i;var a=r,h=n;this.stateControl(t,null,null);var l=this.streamWriter;l.beginPath(o,s),l.appendLineSegment(a,h),l.strokePath(),this.getResources.getResources().requireProcedureSet(this.procedureSets.pdf)}},e.prototype.drawRectangle=function(t,e,i,r,n,o){if(t instanceof Q&&"number"==typeof e){var s=i;this.drawRectangle(t,null,e,s,r,n)}else if(t instanceof R&&"number"==typeof e){s=i;this.drawRectangle(null,t,e,s,r,n)}else{s=i;var a=r,h=n,l=o;if(e instanceof Qt){this.bCSInitialized=!1;var u=this.matrix.matrix.offsetX+s,c=void 0;c=null!=this.layer&&null!=this.layer.page?this.layer.page.size.height-this.matrix.matrix.offsetY+a:this.clientSize.height-this.matrix.matrix.offsetY+a,e.location=new T(u,c),e.graphics.colorSpace=this.colorSpace}else e instanceof qt&&(e.colorSpace=this.colorSpace);e instanceof M&&e.color.isEmpty&&(e=null);var p=t,d=e;this.stateControl(p,d,null),this.streamWriter.appendRectangle(s,a,h,l),this.drawPathHelper(p,d,!1)}},e.prototype.drawPathHelper=function(e,i,r,n){if("boolean"==typeof r){var o=r;this.drawPathHelper(e,i,t.PdfFillMode.Winding,o)}else{var s=null!=e,a=null!=i,h=(o=r)===t.PdfFillMode.Alternate;s&&a?this.streamWriter.fillStrokePath(h):s||a?s?this.streamWriter.strokePath():this.streamWriter.fillPath(h):this.streamWriter.endPath()}},e.prototype.drawImage=function(t,e,i,r,n){if("number"==typeof e&&"number"==typeof i&&void 0===r){var o=t.physicalDimension;this.drawImage(t,e,i,o.width,o.height)}else{var a=e,h=i,l=n;t.save();var u=new tt;this.getTranslateTransform(a,h+l,u),this.getScaleTransform(r,n,u),this.pdfStreamWriter.write("q"),this.pdfStreamWriter.modifyCtm(u);var c=this.getResources.getResources();void 0!==this.pageLayer&&null!=this.page&&(c.document=this.page.document);var p=c.getName(t);void 0!==this.pageLayer&&this.page.setResources(c),this.pdfStreamWriter.executeObject(p),this.pdfStreamWriter.write(s.restoreState),this.pdfStreamWriter.write(s.newLine);var d=this.getResources.getResources();d.requireProcedureSet(this.procedureSets.imageB),d.requireProcedureSet(this.procedureSets.imageC),d.requireProcedureSet(this.procedureSets.imageI),d.requireProcedureSet(this.procedureSets.text)}},e.prototype.getLineBounds=function(t,e,i,r,n){var o;if(!e.empty&&t<e.lineCount&&t>=0){var s=e.lines[t],a=this.getTextVerticalAlignShift(e.actualSize.height,r.height,n)+r.y+e.lineHeight*t,h=s.width,l=this.getHorizontalAlignShift(h,r.width,n),u=this.getLineIndent(s,n,r,0===t);l+=this.rightToLeft(n)?0:u;var c=r.x+l,p=this.shouldJustify(s,r.width,n)?r.width-u:h-u,d=e.lineHeight;o=new k(c,a,p,d)}else o=new k(0,0,0,0);return o},e.prototype.checkCorrectLayoutRectangle=function(e,i,r,n){var o=new k(i,r,e.width,e.width);if(null!=n){switch(n.alignment){case t.PdfTextAlignment.Center:o.x-=o.width/2;break;case t.PdfTextAlignment.Right:o.x-=o.width}switch(n.lineAlignment){case t.PdfVerticalAlignment.Middle:o.y-=o.height/2;break;case t.PdfVerticalAlignment.Bottom:o.y-=o.height}}return o},e.prototype.setLayer=function(t){this.pageLayer=t;var e=t.page;null!=e&&void 0!==e&&(e.beginSave=this.pageSave)},e.prototype.pageSave=function(t){if(null!=t.graphics.automaticFields)for(var e=0;e<t.graphics.automaticFields.automaticFields.length;e++){var i=t.graphics.automaticFields.automaticFields[e];i.field.performDraw(t.graphics,i.location,i.scalingX,i.scalingY)}},e.prototype.drawStringLayoutResult=function(e,i,r,n,o,s){if(e.empty)throw new Error("ArgumentNullException:result");this.applyStringSettings(i,r,n,s,o);var a=null!=s?s.horizontalScalingFactor:100;a===this.previousTextScaling||this.isEmfTextScaled||(this.pdfStreamWriter.setTextScaling(a),this.previousTextScaling=a);var h=null==s||0===s.lineSpacing?i.height:s.lineSpacing+i.height,l=0;l=null!=s&&s.subSuperScript===t.PdfSubSuperScript.SubScript?h-(i.height+i.metrics.getDescent(s)):h-i.metrics.getAscent(s),this.shift=l,this.pdfStreamWriter.startNextLine(o.x,o.y-l),this.pdfStreamWriter.setLeading(+h);for(var u=0,c="",p=0;p<e.lines.length;p++)if(u+=e.lineHeight,o.y+u>this.clientSize.height){this.startCutIndex=p;break}for(var d=this.startCutIndex;d<e.lines.length&&d>=0;d++)c+=e.lines[d].text;var f=new k(o.x,o.y,o.width,o.height);if(this.drawLayoutResult(e,i,s,o),this.underlineStrikeoutText(r,n,e,i,f,s),this.isEmfPlus=!1,this.isUseFontSize=!1,-1!==this.startCutIndex){this.getNextPage().graphics.drawString(c,i,r,n,o.x,0,o.width,0,s)}},e.prototype.getNextPage=function(){var t=this.currentPage.section,e=t.indexOf(this.currentPage);return e===t.count-1?t.add():t.getPages()[e+1]},e.prototype.setClip=function(e,i){void 0===i?this.setClip(e,t.PdfFillMode.Winding):(this.pdfStreamWriter.appendRectangle(e),this.pdfStreamWriter.clipPath(i===t.PdfFillMode.Alternate))},e.prototype.applyStringSettings=function(t,e,i,r,n){i instanceof Qt?(this.bCSInitialized=!1,i.graphics.colorSpace=this.colorSpace):i instanceof qt&&(this.bCSInitialized=!1,i.colorSpace=this.colorSpace);var o=this.getTextRenderingMode(e,i,r);this.stateControl(e,i,t,r),this.pdfStreamWriter.beginText(),o!==this.previousTextRenderingMode&&(this.pdfStreamWriter.setTextRenderingMode(o),this.previousTextRenderingMode=o);var s=null!=r?r.characterSpacing:0;s===this.previousCharacterSpacing||this.isEmfTextScaled||(this.pdfStreamWriter.setCharacterSpacing(s),this.previousCharacterSpacing=s);var a=null!=r?r.wordSpacing:0;a!==this.previousWordSpacing&&(this.pdfStreamWriter.setWordSpacing(a),this.previousWordSpacing=a)},e.prototype.getTextVerticalAlignShift=function(e,i,r){var n=0;if(i>=0&&null!=r&&r.lineAlignment!==t.PdfVerticalAlignment.Top)switch(r.lineAlignment){case t.PdfVerticalAlignment.Middle:n=(i-e)/2;break;case t.PdfVerticalAlignment.Bottom:n=i-e}return n},e.prototype.drawLayoutResult=function(t,e,i,r){var n=this.getTextVerticalAlignShift(t.actualSize.height,r.height,i);0!==n&&this.pdfStreamWriter.startNextLine(0,n);for(var o=e,s=null!=o&&o.isUnicode,a=(null!=o&&o.isEmbedFont,t.lines),h=0,l=a.length;h<l&&h!==this.startCutIndex;h++){var u=a[h],c=(u.text,u.width),p=this.getHorizontalAlignShift(c,r.width,i),d=this.getLineIndent(u,i,r,0===h);0===(p+=this.rightToLeft(i)?0:d)||this.isEmfTextScaled||this.pdfStreamWriter.startNextLine(p,0),s?this.drawUnicodeLine(u,r,e,i):this.drawAsciiLine(u,r,e,i),0===p||this.isEmfTextScaled||this.pdfStreamWriter.startNextLine(-p,0),this.isOverloadWithPosition&&a.length>1&&(this.pdfStreamWriter.startNextLine(-r.x,0),r.x=0,r.width=this.clientSize.width,this.isOverloadWithPosition=!1,this.isPointOverload=!0)}this.getResources.getResources().requireProcedureSet(this.procedureSets.text),0!==n&&this.pdfStreamWriter.startNextLine(0,-(n-t.lineHeight)),this.pdfStreamWriter.endText()},e.prototype.drawAsciiLine=function(t,e,i,r){this.justifyLine(t,e.width,r);var n="";if(-1!==t.text.indexOf("(")||-1!==t.text.indexOf(")"))for(var o=0;o<t.text.length;o++)"("===t.text[o]?n+="\\(":")"===t.text[o]?n+="\\)":n+=t.text[o];""===n&&(n=t.text);var s="("+n+")";this.pdfStreamWriter.showNextLineText(new S(s))},e.prototype.drawUnicodeLine=function(e,i,r,n){var o=e.text,s=(e.width,null!==n&&void 0!==n&&n.rightToLeft),a=null!==n&&void 0!==n&&(0!==n.wordSpacing||n.alignment===t.PdfTextAlignment.Justify),h=r,l=this.justifyLine(e,i.width,n),u=new Kt;if(s||null!==n&&void 0!==n&&n.textDirection!==t.PdfTextDirection.None){var c=null,p=null!==n&&void 0!==n&&n.alignment===t.PdfTextAlignment.Right,d=null;d=(c=null!==n&&void 0!==n&&n.textDirection!==t.PdfTextDirection.None?u.layout(o,h,n.textDirection===t.PdfTextDirection.RightToLeft,a,n):u.layout(o,h,p,a,n)).length>1?null!==n&&void 0!==n&&n.textDirection!==t.PdfTextDirection.None?u.splitLayout(o,h,n.textDirection===t.PdfTextDirection.RightToLeft,a,n):u.splitLayout(o,h,p,a,n):[o],this.drawUnicodeBlocks(c,d,h,n,l)}else if(a){var f=this.breakUnicodeLine(o,h,null);c=f.tokens,d=f.words;this.drawUnicodeBlocks(c,d,h,n,l)}else{var g=this.convertToUnicode(o,h),m=this.getUnicodeString(g);this.streamWriter.showNextLineText(m)}},e.prototype.drawUnicodeBlocks=function(t,e,i,r,n){if(null==t)throw new Error("Argument Null Exception : blocks");if(null==e)throw new Error("Argument Null Exception : words");if(null==i)throw new Error("Argument Null Exception : font");this.streamWriter.startNextLine();var o=0,s=0,a=0,h=0;try{null!==r&&void 0!==r&&(a=r.firstLineIndent,h=r.paragraphIndent,r.firstLineIndent=0,r.paragraphIndent=0);var l=i.getCharWidth(D.whiteSpace,r)+n,u=null!=r?r.characterSpacing:0;l+=u+(null!==r&&void 0!==r&&0===n?r.wordSpacing:0);for(var c=0;c<t.length;c++){var p=t[c],d=e[c],f=0;if(0!==o&&this.streamWriter.startNextLine(o,0),d.length>0){f+=i.measureString(d,r).width,f+=u;var g=this.getUnicodeString(p);this.streamWriter.showText(g)}c!==t.length-1&&(s+=o=f+l)}s>0&&this.streamWriter.startNextLine(-s,0)}finally{null!==r&&void 0!==r&&(r.firstLineIndent=a,r.paragraphIndent=h)}},e.prototype.breakUnicodeLine=function(t,e,i){if(null===t)throw new Error("Argument Null Exception : line");i=t.split(null);for(var r=[],n=0;n<i.length;n++){var o=i[n],s=this.convertToUnicode(o,e);r[n]=s}return{tokens:r,words:i}},e.prototype.getUnicodeString=function(e){if(null===e)throw new Error("Argument Null Exception : token");var i=new S(e);return i.converted=!0,i.encode=t.InternalEnum.ForceEncoding.Ascii,i},e.prototype.convertToUnicode=function(t,e){var i=null;if(null==t)throw new Error("Argument Null Exception : text");if(null==e)throw new Error("Argument Null Exception : ttfFont");if(e.fontInternal instanceof Gt){var r=e.fontInternal.ttfReader;e.setSymbols(t),i=r.convertString(t);var n=S.toUnicodeArray(i,!1);i=S.byteToString(n)}return i},e.prototype.justifyLine=function(t,e,i){var r=t.text,n=t.width,o=this.shouldJustify(t,e,i),s=null!=i&&0!==i.wordSpacing,a=D.spaces,h=D.getCharsCount(r,a),l=0;if(o){s&&(n-=h*i.wordSpacing);l=(e-n)/h,this.pdfStreamWriter.setWordSpacing(l)}else s?this.pdfStreamWriter.setWordSpacing(i.wordSpacing):this.pdfStreamWriter.setWordSpacing(0);return l},e.prototype.reset=function(t){this.canvasSize=t,this.streamWriter.clear(),this.initialize(),this.initializeCoordinates()},e.prototype.shouldJustify=function(e,i,r){var n=e.text,o=e.width,s=null!=r&&r.alignment===t.PdfTextAlignment.Justify,a=i>=0&&o<i,h=D.spaces,l=D.getCharsCount(n,h)>0&&n[0]!==D.whiteSpace,u=(e.lineType&t.LineType.LayoutBreak)>0;return s&&a&&l&&(u||r.alignment===t.PdfTextAlignment.Justify)},e.prototype.underlineStrikeoutText=function(t,e,i,r,n,o){if(r.underline||r.strikeout){var s=this.createUnderlineStikeoutPen(t,e,r,o);if(null!=s){var a=this.getTextVerticalAlignShift(i.actualSize.height,n.height,o),h=0;h=n.y+a+r.metrics.getAscent(o)+1.5*s.width;for(var l=n.y+a+r.metrics.getHeight(o)/2+1.5*s.width,u=i.lines,c=0,p=i.lineCount;c<p;c++){var d=u[c],f=(d.text,d.width),g=this.getHorizontalAlignShift(f,n.width,o),m=this.getLineIndent(d,o,n,0===c);g+=this.rightToLeft(o)?0:m;var y=n.x+g,b=this.shouldJustify(d,n.width,o)?y+n.width-m:y+f-m;if(r.underline){var w=h;this.drawLine(s,y,w,b,w),h+=i.lineHeight}if(r.strikeout){w=l;this.drawLine(s,y,w,b,w),l+=i.lineHeight}this.isPointOverload&&u.length>1&&(n.x=0,n.width=this.clientSize.width)}this.isPointOverload=!1}}},e.prototype.createUnderlineStikeoutPen=function(t,e,i,r){var n=i.metrics.getSize(r)/20,o=null;return null!=t?o=new Q(t.color,n):null!=e&&(o=new Q(e,n)),o},e.prototype.getTextRenderingMode=function(e,i,r){var n=t.TextRenderingMode.None;return n=null!=e&&null!=i?t.TextRenderingMode.FillStroke:null!=e?t.TextRenderingMode.Stroke:t.TextRenderingMode.Fill,null!=r&&r.clipPath&&(n|=t.TextRenderingMode.ClipFlag),n},e.prototype.getLineIndent=function(e,i,r,n){var o=0,s=(e.lineType&t.LineType.FirstParagraphLine)>0;return null!=i&&s&&(o=n?i.firstLineIndent:i.paragraphIndent,o=r.width>0?Math.min(r.width,o):o),o},e.prototype.getHorizontalAlignShift=function(e,i,r){var n=0;if(i>=0&&null!=r&&r.alignment!==t.PdfTextAlignment.Left)switch(r.alignment){case t.PdfTextAlignment.Center:n=(i-e)/2;break;case t.PdfTextAlignment.Right:n=i-e}return n},e.prototype.rightToLeft=function(e){var i=null!==e&&void 0!==e&&e.rightToLeft;return null!==e&&void 0!==e&&e.textDirection!==t.PdfTextDirection.None&&void 0!==e.textDirection&&(i=!0),i},e.prototype.stateControl=function(t,e,i,r){if(void 0===r)this.stateControl(t,e,i,null);else{e instanceof qt&&(this.bCSInitialized=!1,e.colorSpace=this.colorSpace),e instanceof Qt&&(this.bCSInitialized=!1,e.graphics.colorSpace=this.colorSpace);null!==e?(void 0!==this.pageLayer&&null!=this.pageLayer&&!1===this.colorSpaceChanged&&(this.lastDocumentCS=this.pageLayer.page.document.colorSpace,this.lastGraphicsCS=this.pageLayer.page.graphics.colorSpace,this.colorSpace=this.pageLayer.page.document.colorSpace,this.currentColorSpace=this.pageLayer.page.document.colorSpace,this.colorSpaceChanged=!0),this.initCurrentColorSpace(this.currentColorSpace)):null!=t&&(void 0!==this.pageLayer&&null!=this.pageLayer&&(this.colorSpace=this.pageLayer.page.document.colorSpace,this.currentColorSpace=this.pageLayer.page.document.colorSpace),this.initCurrentColorSpace(this.currentColorSpace)),this.penControl(t,!1),this.brushControl(e,!1),this.fontControl(i,r,!1)}},e.prototype.initCurrentColorSpace=function(e){this.getResources.getResources();this.bCSInitialized||(this.currentColorSpace!=t.PdfColorSpace.GrayScale?(this.pdfStreamWriter.setColorSpace("Device"+this.currentColorSpaces[this.currentColorSpace],!0),this.pdfStreamWriter.setColorSpace("Device"+this.currentColorSpaces[this.currentColorSpace],!1),this.bCSInitialized=!0):(this.pdfStreamWriter.setColorSpace("DeviceGray",!0),this.pdfStreamWriter.setColorSpace("DeviceGray",!1),this.bCSInitialized=!0))},e.prototype.penControl=function(t,e){null!=t&&(this.currentPen=t,t.monitorChanges(this.currentPen,this.pdfStreamWriter,this.getResources,e,this.colorSpace,this.matrix.clone()),this.currentPen=t.clone())},e.prototype.brushControl=function(t,e){if(null!=t&&void 0!==t){var i=t.clone(),r=i;if(!(null===r||void 0===r||t instanceof M||t instanceof Qt)){var n=r.matrix,o=this.matrix.clone();null!=n&&(n.multiply(o),o=n),r.matrix=o}this.currentBrush=r,i.monitorChanges(this.currentBrush,this.pdfStreamWriter,this.getResources,e,this.colorSpace),this.currentBrush=t,t=null}},e.prototype.fontControl=function(e,i,r){if(null!=e){var n=null!=i?i.subSuperScript:t.PdfSubSuperScript.None,o=null!=this.currentStringFormat?this.currentStringFormat.subSuperScript:t.PdfSubSuperScript.None;if(r||e!==this.currentFont||n!==o){var s=this.getResources.getResources();this.currentFont=e,this.currentStringFormat=i;var a=e.metrics.getSize(i);this.isEmfTextScaled=!1;var h=s.getName(e);this.pdfStreamWriter.setFont(e,h,a)}}},e.prototype.setTransparency=function(e,i,r){if(void 0===i)this.istransparencySet=!0,this.setTransparency(e,e,t.PdfBlendMode.Normal);else if("number"==typeof i&&void 0===r)this.setTransparency(e,i,t.PdfBlendMode.Normal);else{null==this.trasparencies&&(this.trasparencies=new rt);var n=null,o=new re(e,i,r);this.trasparencies.containsKey(o)&&(n=this.trasparencies.getValue(o)),null==n&&(n=new nt(e,i,r),this.trasparencies.setValue(o,n));var s=this.getResources.getResources().getName(n);this.streamWriter.setGraphicsState(s)}},e.prototype.clipTranslateMargins=function(t,e,i,r,n,o){if(t instanceof k&&void 0===e)this.clipBounds=t,this.pdfStreamWriter.writeComment("Clip margins."),this.pdfStreamWriter.appendRectangle(t),this.pdfStreamWriter.closePath(),this.pdfStreamWriter.clipPath(!1),this.pdfStreamWriter.writeComment("Translate co-ordinate system."),this.translateTransform(t.x,t.y);else if("number"==typeof t){var s=new k(i,r,this.size.width-i-n,this.size.height-r-o);this.clipBounds=s,this.pdfStreamWriter.writeComment("Clip margins."),this.pdfStreamWriter.appendRectangle(s),this.pdfStreamWriter.closePath(),this.pdfStreamWriter.clipPath(!1),this.pdfStreamWriter.writeComment("Translate co-ordinate system."),this.translateTransform(t,e)}},e.prototype.updateY=function(t){return-t},e.prototype.translateTransform=function(t,e){var i=new tt;this.getTranslateTransform(t,e,i),this.pdfStreamWriter.modifyCtm(i),this.matrix.multiply(i)},e.prototype.getTranslateTransform=function(t,e,i){return i.translate(t,this.updateY(e)),i},e.prototype.scaleTransform=function(t,e){var i=new tt;this.getScaleTransform(t,e,i),this.pdfStreamWriter.modifyCtm(i),this.matrix.multiply(i)},e.prototype.getScaleTransform=function(t,e,i){return null==i&&(i=new tt),i.scale(t,e),i},e.prototype.rotateTransform=function(t){var e=new tt;this.getRotateTransform(t,e),this.pdfStreamWriter.modifyCtm(e),this.matrix.multiply(e)},e.prototype.initializeCoordinates=function(){this.pdfStreamWriter.writeComment("Change co-ordinate system to left/top."),this.mediaBoxUpperRightBound!==-this.size.height&&null==this.cropBox&&(this.mediaBoxUpperRightBound===this.size.height||0===this.mediaBoxUpperRightBound?this.translateTransform(0,this.updateY(this.size.height)):this.translateTransform(0,this.updateY(this.mediaBoxUpperRightBound)))},e.prototype.getRotateTransform=function(t,e){return null!=e&&void 0!==e||(e=new tt),e.rotate(this.updateY(t)),e},e.prototype.save=function(){var t=new ie(this,this.matrix.clone());return t.brush=this.currentBrush,t.pen=this.currentPen,t.font=this.currentFont,t.colorSpace=this.currentColorSpace,t.characterSpacing=this.previousCharacterSpacing,t.wordSpacing=this.previousWordSpacing,t.textScaling=this.previousTextScaling,t.textRenderingMode=this.previousTextRenderingMode,this.graphicsState.push(t),this.pdfStreamWriter.saveGraphicsState(),t},e.prototype.restore=function(t){if(void 0===t)this.graphicsState.length>0&&this.doRestoreState();else if(-1!==this.graphicsState.indexOf(t))for(;0!==this.graphicsState.length;){if(this.doRestoreState()===t)break}},e.prototype.doRestoreState=function(){var t=this.graphicsState.pop();return this.transformationMatrix=t.matrix,this.currentBrush=t.brush,this.currentPen=t.pen,this.currentFont=t.font,this.currentColorSpace=t.colorSpace,this.previousCharacterSpacing=t.characterSpacing,this.previousWordSpacing=t.wordSpacing,this.previousTextScaling=t.textScaling,this.previousTextRenderingMode=t.textRenderingMode,this.pdfStreamWriter.restoreGraphicsState(),t},e.prototype.drawPath=function(t,e,i){e instanceof Qt?(this.bCSInitialized=!1,e.graphics.colorSpace=this.colorSpace):e instanceof qt&&(this.bCSInitialized=!1,e.colorSpace=this.colorSpace),this.stateControl(t,e,null),this.buildUpPath(i.pathPoints,i.pathTypes),this.drawPathHelper(t,e,i.fillMode,!1)},e.prototype.drawArc=function(t,e,i,r,n,o,s){e instanceof k?this.drawArc(t,e.x,e.y,e.width,e.height,i,r):0!==s&&(this.stateControl(t,null,null),this.constructArcPath(e,i,e+r,i+n,o,s),this.drawPathHelper(t,null,!1))},e.prototype.buildUpPath=function(i,r){for(var n=i.length,o=0;o<n;++o){var s=0,a=i[o];switch(r[o]&e.pathTypesValuesMask){case t.PathPointType.Start:this.pdfStreamWriter.beginPath(a.x,a.y);break;case t.PathPointType.Bezier3:var h=new T(0,0),l=new T(0,0),u=this.getBezierPoints(i,r,o,h,l);this.pdfStreamWriter.appendBezierSegment(a,u.p2,u.p3),o=u.i;break;case t.PathPointType.Line:this.pdfStreamWriter.appendLineSegment(a);break;default:throw new Error("ArithmeticException - Incorrect path formation.")}s=r[o],this.checkFlags(s)}},e.prototype.getBezierPoints=function(i,r,n,o,s){if(++n,(r[n]&e.pathTypesValuesMask)!==t.PathPointType.Bezier3)throw new Error("ArgumentException : errorMsg");if(o=i[n],++n,(r[n]&e.pathTypesValuesMask)!==t.PathPointType.Bezier3)throw new Error("ArgumentException : errorMsg");return s=i[n],{i:n,p2:o,p3:s}},e.prototype.checkFlags=function(e){(e&t.PathPointType.CloseSubpath)===t.PathPointType.CloseSubpath&&this.pdfStreamWriter.closePath()},e.prototype.constructArcPath=function(t,e,i,r,n,o){var s=this.getBezierArc(t,e,i,r,n,o);if(0!==s.length){var a=[s[0],s[1],s[2],s[3],s[4],s[5],s[6],s[7]];this.pdfStreamWriter.beginPath(a[0],a[1]);var h=0;for(h=0;h<s.length;h+=8)a=[s[h],s[h+1],s[h+2],s[h+3],s[h+4],s[h+5],s[h+6],s[h+7]],this.pdfStreamWriter.appendBezierSegment(a[2],a[3],a[4],a[5],a[6],a[7])}},e.prototype.getBezierArc=function(t,e,i,r,n,o){if(t>i){var s=void 0;s=t,t=i,i=s}if(r>e){s=void 0;s=e,e=r,r=s}var a,h;Math.abs(o)<=90?(a=o,h=1):a=o/(h=Math.ceil(Math.abs(o)/90));for(var l=(t+i)/2,u=(e+r)/2,c=(i-t)/2,p=(r-e)/2,d=a*(Math.PI/360),f=Math.abs(4/3*(1-Math.cos(d))/Math.sin(d)),g=[],m=0;m<h;m++){var y=(n+m*a)*(Math.PI/180),b=(n+(m+1)*a)*(Math.PI/180),w=Math.cos(y),P=Math.cos(b),S=Math.sin(y),v=Math.sin(b);a>0?g.push(l+c*w,u-p*S,l+c*(w-f*S),u-p*(S+f*w),l+c*(P+f*v),u-p*(v-f*P),l+c*P,u-p*v):g.push(l+c*w,u-p*S,l+c*(w+f*S),u-p*(S-f*w),l+c*(P-f*v),u-p*(v+f*P),l+c*P,u-p*v)}return g},e.pathTypesValuesMask=15,e.transparencyObject=!1,e}(),ee=function(){function t(t){this.sender=t}return t.prototype.getResources=function(){return this.sender.getResources()},t}(),ie=function(){function e(e,i){this.internalTextRenderingMode=t.TextRenderingMode.Fill,this.internalCharacterSpacing=0,this.internalWordSpacing=0,this.internalTextScaling=100,this.pdfColorSpace=t.PdfColorSpace.Rgb,void 0!==e&&(this.pdfGraphics=e,this.transformationMatrix=i)}return Object.defineProperty(e.prototype,"graphics",{get:function(){return this.pdfGraphics},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"matrix",{get:function(){return this.transformationMatrix},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"characterSpacing",{get:function(){return this.internalCharacterSpacing},set:function(t){this.internalCharacterSpacing=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"wordSpacing",{get:function(){return this.internalWordSpacing},set:function(t){this.internalWordSpacing=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"textScaling",{get:function(){return this.internalTextScaling},set:function(t){this.internalTextScaling=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"pen",{get:function(){return this.pdfPen},set:function(t){this.pdfPen=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"brush",{get:function(){return this.pdfBrush},set:function(t){this.pdfBrush=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"font",{get:function(){return this.pdfFont},set:function(t){this.pdfFont=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"colorSpace",{get:function(){return this.pdfColorSpace},set:function(t){this.pdfColorSpace=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"textRenderingMode",{get:function(){return this.internalTextRenderingMode},set:function(t){this.internalTextRenderingMode=t},enumerable:!0,configurable:!0}),e}(),re=function(){return function(t,e,i){this.alphaPen=t,this.alphaBrush=e,this.blendMode=i}}(),ne=function(){function e(e,i){if(this.pdfColorSpace=t.PdfColorSpace.Rgb,this.isVisible=!0,this.sublayer=!1,this.contentLength=0,this.dictionaryProperties=new a,null===e)throw new Error("ArgumentNullException:page");if(this.pdfPage=e,this.clipPageTemplates=!0,void 0===i)this.content=new b;else if(i instanceof b||null===i){if(null===i)throw new Error("ArgumentNullException:stream");this.content=i}else this.content=new b,this.clipPageTemplates=i}return Object.defineProperty(e.prototype,"colorSpace",{get:function(){return this.pdfColorSpace},set:function(t){this.pdfColorSpace=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"page",{get:function(){return this.pdfPage},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"layerId",{get:function(){return this.layerid},set:function(t){this.layerid=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"name",{get:function(){return this.layerName},set:function(t){this.layerName=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"visible",{get:function(){return this.isVisible},set:function(t){this.isVisible=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"graphics",{get:function(){return null==this.pdfGraphics&&this.initializeGraphics(this.page),this.pdfGraphics},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"layers",{get:function(){return null==this.layer?(this.layer=new ae(this.page),this.layer.sublayer=!0,this.layer):this.layer},enumerable:!0,configurable:!0}),e.prototype.add=function(){var t=new e(this.pdfPage);return t.name="",t},e.prototype.sign=function(t){return 0===t?0:t>0?1:-1},e.prototype.initializeGraphics=function(t){var e=t,i=new ee(this.page);if(this.pdfGraphics=new te(t.size,i,this.content),this.pdfGraphics.mediaBoxUpperRightBound=0,null!=e){var r=e.section.parent;null!=r&&(this.pdfGraphics.colorSpace=r.document.colorSpace,this.colorSpace=r.document.colorSpace)}var n=this.sign(t.origin.y)===this.sign(t.origin.x);(t.origin.x>=0&&t.origin.y>=0||!n)&&this.pdfGraphics.initializeCoordinates();var o=e.section.getActualBounds(e,!0),s=e.section.pageSettings.margins;this.clipPageTemplates?t.origin.x>=0&&t.origin.y>=0&&this.pdfGraphics.clipTranslateMargins(o):this.graphics.clipTranslateMargins(o.x,o.y,s.left,s.top,s.right,s.bottom),this.pdfGraphics.setLayer(this)},Object.defineProperty(e.prototype,"element",{get:function(){return this.content},enumerable:!0,configurable:!0}),e}(),oe=function(){function t(){}return Object.defineProperty(t.prototype,"count",{get:function(){return void 0===this.collection&&(this.collection=[]),this.collection.length},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"list",{get:function(){return void 0===this.collection&&(this.collection=[]),this.collection},enumerable:!0,configurable:!0}),t}(),se=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),ae=function(t){function e(e){var i=t.call(this)||this;if(i.parentLayerCount=0,i.sublayer=!1,i.optionalContent=new h,e instanceof he){i.page=e;var r=e;i.parseLayers(r)}return i}return se(e,t),e.prototype.items=function(t,e){if("number"==typeof t&&void 0===e){return this.list[t]}if(null==e)throw new Error("ArgumentNullException: layer");if(e.page!==this.page)throw new Error("ArgumentException: The layer belongs to another page")},e.prototype.add=function(t,e){if(void 0===t){var i=new ne(this.page);return i.name="",this.add(i),i}if(t instanceof ne){var r=this.list.push(t);return this.addLayer(r,t),r}return 0},e.prototype.addLayer=function(t,e){var i=new C(e);this.page.contents.add(i)},e.prototype.insert=function(t,e){for(var i=[],r=this.list.length,n=t;n<r;n++)i.push(this.list.pop());this.list.push(e);for(n=0;n<i.length;n++)this.list.push(i[n]);this.insertLayer(t,e)},e.prototype.insertLayer=function(t,e){if(null==e)throw new Error("ArgumentNullException:layer");var i=new C(e);this.page.contents.insert(t,i)},e.prototype.parseLayers=function(t){var e=this.page.contents;this.page.getResources();t.crossTable;var i=new b,r=new b,n=[];n.push("q"),i.data=n,e.insert(0,new C(i)),(n=[]).push("Q"),r.data=n,e.insert(e.count,new C(r))},e.prototype.indexOf=function(t){if(null==t)throw new Error("ArgumentNullException: layer");return this.list.indexOf(t)},e}(oe),he=function(){function t(t){this.defLayerIndex=-1,this.modified=!1,this.dictionaryProperties=new a,this.pageDictionary=t}return Object.defineProperty(t.prototype,"section",{get:function(){return this.pdfSection},set:function(t){this.pdfSection=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"dictionary",{get:function(){return this.pageDictionary},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"element",{get:function(){return this.pageDictionary},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"defaultLayer",{get:function(){var t=this.layers,e=this.defaultLayerIndex;return t.items(e)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"defaultLayerIndex",{get:function(){if(0===this.layerCollection.count||-1===this.defLayerIndex){var t=this.layerCollection.add();this.defLayerIndex=this.layerCollection.indexOf(t)}return this.defLayerIndex},set:function(t){if(t<0||t>this.layers.count-1)throw new Error("ArgumentOutOfRangeException : value, Index can not be less 0 and greater Layers.Count - 1");this.defLayerIndex=t,this.modified=!0},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"layers",{get:function(){return null!=this.layerCollection&&void 0!==this.layerCollection||(this.layerCollection=new ae(this)),this.layerCollection},enumerable:!0,configurable:!0}),t.prototype.getResources=function(){return null==this.resources&&(this.resources=new Jt,this.dictionary.items.setValue(this.dictionaryProperties.resources,this.resources)),this.resources},Object.defineProperty(t.prototype,"contents",{get:function(){var t=this.pageDictionary.items.getValue(this.dictionaryProperties.contents);return null==t&&(t=new m,this.pageDictionary.items.setValue(this.dictionaryProperties.contents,t)),t},enumerable:!0,configurable:!0}),t.prototype.setResources=function(t){this.resources=t,this.dictionary.items.setValue(this.dictionaryProperties.resources,this.resources),this.modified=!0},t}(),le=function(){function e(t){this.alreadyExistsAnnotationError="This annotatation had been already added to page",this.missingAnnotationException="Annotation is not contained in collection.",this.dictionaryProperties=new a,this.internalAnnotations=new m,this.lists=[],void 0!==t&&(this.page=t)}return Object.defineProperty(e.prototype,"annotations",{get:function(){return this.internalAnnotations},set:function(t){this.internalAnnotations=t},enumerable:!0,configurable:!0}),e.prototype.add=function(t){this.doAdd(t)},e.prototype.doAdd=function(t){if(void 0===t.destination)return t.setPage(this.page),this.internalAnnotations.add(new C(t)),this.lists.push(t);var e=(new F).layout(t.text,t.font,t.stringFormat,new j(t.bounds.width,0),!1,new j(0,0)),i=t.bounds.y;if(1===e.lines.length){var r=t.font.measureString(e.lines[0].text);t.bounds=new k(new T(t.bounds.x,i),r),t.text=e.lines[0].text,this.page.graphics.drawString(t.text,t.font,null,t.brush,t.bounds.x,t.bounds.y,t.bounds.width,t.bounds.height,null),t.setPage(this.page),this.setColor(t),this.internalAnnotations.add(new C(t)),this.lists.push(t)}else for(var n=0;n<e.lines.length;n++){r=t.font.measureString(e.lines[n].text);if(0===n)t.bounds=new k(t.bounds.x,i,r.width,r.height),t.text=e.lines[n].text,this.page.graphics.drawString(t.text,t.font,null,t.brush,t.bounds.x,i,r.width,r.height,null),t.setPage(this.page),this.setColor(t),this.internalAnnotations.add(new C(t)),this.lists.push(t),i+=t.bounds.height;else{var o=t.clone();o.bounds=new k(new T(t.bounds.x,i),r),o.text=e.lines[n].text,this.page.graphics.drawString(o.text,o.font,null,o.brush,o.bounds.x,o.bounds.y,o.bounds.width,o.bounds.height,null),o.setPage(this.page),this.setColor(o),this.internalAnnotations.add(new C(o)),this.lists.push(o),i+=o.bounds.height}}},e.prototype.setColor=function(e){var i=t.PdfColorSpace.Rgb,r=e.color.toArray(i);e.dictionary.items.setValue(this.dictionaryProperties.c,r)},Object.defineProperty(e.prototype,"element",{get:function(){return this.internalAnnotations},enumerable:!0,configurable:!0}),e}(),ue=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),ce=function(t){function e(){var e=t.call(this,new h)||this;return e.annotationCollection=null,e.beginSave=null,e.initialize(),e}return ue(e,t),Object.defineProperty(e.prototype,"document",{get:function(){return null!==this.section&&null!==this.section.parent?this.section.parent.document:null},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"graphics",{get:function(){var t=this.defaultLayer.graphics;return t.currentPage=this,t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"crossTable",{get:function(){if(null===this.section)throw new Error("PdfDocumentException : Page is not created");return null===this.section.parent?this.section.parentDocument.crossTable:this.section.parent.document.crossTable},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"size",{get:function(){return this.section.pageSettings.size},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"origin",{get:function(){return this.section.pageSettings.origin},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"annotations",{get:function(){return null==this.annotationCollection&&(this.annotationCollection=new le(this),this.dictionary.items.setValue(this.dictionaryProperties.annots,this.annotationCollection.element),this.annotationCollection.annotations=this.dictionary.items.getValue(this.dictionaryProperties.annots)),this.annotationCollection},enumerable:!0,configurable:!0}),e.prototype.initialize=function(){this.dictionary.items.setValue(this.dictionaryProperties.type,new o("Page")),this.dictionary.pageBeginDrawTemplate=new f(this)},e.prototype.setSection=function(t){this.section=t,this.dictionary.items.setValue(this.dictionaryProperties.parent,new C(t))},e.prototype.resetProgress=function(){this.isProgressOn=!1},e.prototype.getClientSize=function(){var t=this.section.getActualBounds(this,!0);return new j(t.width,t.height)},e.prototype.pageBeginSave=function(){var t=this.document;void 0!==typeof t&&null!=t&&this.drawPageTemplates(t),null!=this.beginSave&&void 0!==this.beginSave&&this.beginSave(this)},e.prototype.drawPageTemplates=function(t){if(this.section.containsTemplates(t,this,!1)){var e=new ne(this,!1);if(this.layers.insert(0,e),this.section.drawTemplates(this,e,t,!1),null!==e.graphics&&void 0!==e.graphics)for(var i=0;i<e.graphics.automaticFields.automaticFields.length;i++){var r=e.graphics.automaticFields.automaticFields[i];r.field.performDraw(e.graphics,r.location,r.scalingX,r.scalingY)}}if(this.section.containsTemplates(t,this,!0)){var n=new ne(this,!1);this.layers.add(n),this.section.drawTemplates(this,n,t,!0)}},e}(he),pe=function(){function t(t){this.pdfPage=void 0!==t?t:null}return Object.defineProperty(t.prototype,"page",{get:function(){return this.pdfPage},enumerable:!0,configurable:!0}),t}(),de=function(){function t(t){if(this.pdfSection=null,null==t)throw Error('ArgumentNullException("section")');this.section=t}return Object.defineProperty(t.prototype,"section",{get:function(){return this.pdfSection},set:function(t){this.pdfSection=t},enumerable:!0,configurable:!0}),t.prototype.contains=function(t){return this.section.contains(t)},t.prototype.remove=function(t){this.section.remove(t)},t.prototype.add=function(){return this.section.add()},t}(),fe=function(){function e(){}return Object.defineProperty(e.prototype,"left",{get:function(){return this.leftTemplate},set:function(e){this.leftTemplate=this.checkElement(e,t.TemplateType.Left)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"top",{get:function(){return this.topTemplate},set:function(e){this.topTemplate=this.checkElement(e,t.TemplateType.Top)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"right",{get:function(){return this.rightTemplate},set:function(e){this.rightTemplate=this.checkElement(e,t.TemplateType.Right)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"bottom",{get:function(){return this.bottomTemplate},set:function(e){this.bottomTemplate=this.checkElement(e,t.TemplateType.Bottom)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"EvenLeft",{get:function(){return this.evenLeft},set:function(e){this.evenLeft=this.checkElement(e,t.TemplateType.Left)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"EvenTop",{get:function(){return this.evenTop},set:function(e){this.evenTop=this.checkElement(e,t.TemplateType.Top)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"EvenRight",{get:function(){return this.evenRight},set:function(e){this.evenRight=this.checkElement(e,t.TemplateType.Right)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"EvenBottom",{get:function(){return this.evenBottom},set:function(e){this.evenBottom=this.checkElement(e,t.TemplateType.Bottom)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"OddLeft",{get:function(){return this.oddLeft},set:function(e){this.oddLeft=this.checkElement(e,t.TemplateType.Left)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"OddTop",{get:function(){return this.oddTop},set:function(e){this.oddTop=this.checkElement(e,t.TemplateType.Top)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"OddRight",{get:function(){return this.oddRight},set:function(e){this.oddRight=this.checkElement(e,t.TemplateType.Right)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"OddBottom",{get:function(){return this.oddBottom},set:function(e){this.oddBottom=this.checkElement(e,t.TemplateType.Bottom)},enumerable:!0,configurable:!0}),e.prototype.getLeft=function(t){if(null==t)throw new Error("ArgumentNullException:page");return this.isEven(t)?null!=this.EvenLeft?this.EvenLeft:this.left:null!=this.OddLeft?this.OddLeft:this.left},e.prototype.getTop=function(t){if(null==t)throw new Error("ArgumentNullException:page");return this.isEven(t)?null!=this.EvenTop?this.EvenTop:this.top:null!=this.OddTop?this.OddTop:this.top},e.prototype.getRight=function(t){if(null==t)throw new Error("ArgumentNullException:page");return this.isEven(t)?null!=this.EvenRight?this.EvenRight:this.right:null!=this.OddRight?this.OddRight:this.right},e.prototype.getBottom=function(t){if(null==t)throw new Error("ArgumentNullException:page");return this.isEven(t)?null!=this.EvenBottom?this.EvenBottom:this.bottom:null!=this.OddBottom?this.OddBottom:this.bottom},e.prototype.isEven=function(t){var e=t.section.document.pages;return(e.pageCollectionIndex.containsKey(t)?e.pageCollectionIndex.getValue(t)+1:e.indexOf(t)+1)%2==0},e.prototype.checkElement=function(e,i){if(null!=e){if(void 0!==e.type&&e.type!==t.TemplateType.None)throw new Error("NotSupportedException:Can not reassign the template element. Please, create new one.");e.type=i}return e},e}(),ge=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),me=function(t){function e(){var e=t.call(this)||this;return e.leftValue=e.topValue=e.rightValue=e.bottomValue=e.stampValue=!0,e}return ge(e,t),Object.defineProperty(e.prototype,"applyDocumentLeftTemplate",{get:function(){return this.leftValue},set:function(t){this.leftValue=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"applyDocumentTopTemplate",{get:function(){return this.topValue},set:function(t){this.topValue=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"applyDocumentRightTemplate",{get:function(){return this.rightValue},set:function(t){this.rightValue=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"applyDocumentBottomTemplate",{get:function(){return this.bottomValue},set:function(t){this.bottomValue=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"applyDocumentStamps",{get:function(){return this.stampValue},set:function(t){this.stampValue=t},enumerable:!0,configurable:!0}),e}(fe),ye=function(){function t(t,e){this.pageAdded=new pe,this.pdfPages=[],this.dictionaryProperties=new a,this.pdfDocument=t,void 0===e?(this.settings=t.pageSettings.clone(),this.initialSettings=this.settings.clone()):(this.settings=e.clone(),this.initialSettings=this.settings.clone()),this.initialize()}return Object.defineProperty(t.prototype,"parent",{get:function(){return this.sectionCollection},set:function(t){this.sectionCollection=t,this.section.items.setValue(this.dictionaryProperties.parent,new C(t))},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"parentDocument",{get:function(){return this.pdfDocument},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"pageSettings",{get:function(){return this.settings},set:function(t){if(null==t)throw Error("Value can not be null.");this.settings=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"element",{get:function(){return this.section},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"count",{get:function(){return this.pagesReferences.count},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"template",{get:function(){return null==this.pageTemplate&&(this.pageTemplate=new me),this.pageTemplate},set:function(t){this.pageTemplate=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"document",{get:function(){return this.sectionCollection.document},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"pages",{get:function(){return null!=this.pagesCollection&&void 0!==this.pagesCollection||(this.pagesCollection=new de(this)),this.pagesCollection},enumerable:!0,configurable:!0}),t.prototype.getPages=function(){return this.pdfPages},t.prototype.pointToNativePdf=function(t,e){var i=this.getActualBounds(t,!0);return e.x+=i.x,e.y=this.pageSettings.height-e.y,e},t.prototype.setPageSettings=function(t){this.settings=t,this.state.orientation=t.orientation,this.state.rotate=t.rotate,this.state.size=t.size,this.state.origin=t.origin},t.prototype.initialize=function(){this.pagesReferences=new m,this.section=new h,this.state=new be(this.pdfDocument),this.section.sectionBeginSave=new d(this,this.state),this.pageCount=new g(0),this.section.items.setValue(this.dictionaryProperties.count,this.pageCount),this.section.items.setValue(this.dictionaryProperties.type,new o(this.dictionaryProperties.pages)),this.section.items.setValue(this.dictionaryProperties.kids,this.pagesReferences)},t.prototype.containsTemplates=function(t,e,i){var r=this.getDocumentTemplates(t,e,i),n=this.getSectionTemplates(e,i);return r.length>0||n.length>0},t.prototype.getDocumentTemplates=function(t,e,i){var r=[];return this.template.applyDocumentTopTemplate&&null!=t.template.getTop(e)&&(!t.template.getTop(e).foreground&&!i||t.template.getTop(e).foreground&&i)&&r.push(t.template.getTop(e)),this.template.applyDocumentBottomTemplate&&null!=t.template.getBottom(e)&&(!t.template.getBottom(e).foreground&&!i||t.template.getBottom(e).foreground&&i)&&r.push(t.template.getBottom(e)),this.template.applyDocumentLeftTemplate&&null!=t.template.getLeft(e)&&(!t.template.getLeft(e).foreground&&!i||t.template.getLeft(e).foreground&&i)&&r.push(t.template.getLeft(e)),this.template.applyDocumentRightTemplate&&null!=t.template.getRight(e)&&(!t.template.getRight(e).foreground&&!i||t.template.getRight(e).foreground&&i)&&r.push(t.template.getRight(e)),r},t.prototype.getSectionTemplates=function(t,e){var i=[];if(null!=this.template.getTop(t)){(!(r=this.template.getTop(t)).foreground&&!e||r.foreground&&e)&&i.push(r)}if(null!=this.template.getBottom(t)){(!(r=this.template.getBottom(t)).foreground&&!e||r.foreground&&e)&&i.push(r)}if(null!=this.template.getLeft(t)){(!(r=this.template.getLeft(t)).foreground&&!e||r.foreground&&e)&&i.push(r)}if(null!=this.template.getRight(t)){var r;(!(r=this.template.getRight(t)).foreground&&!e||r.foreground&&e)&&i.push(r)}return i},t.prototype.add=function(t){if(void 0===t){var e=new ce;return this.add(e),e}var i=this.checkPresence(t);this.pdfPages.push(t),this.pagesReferences.add(i),t.setSection(this),t.resetProgress(),this.pageAddedMethod(t)},t.prototype.checkPresence=function(t){for(var e=new C(t),i=!1,r=this.parent,n=0;n<r.section.length;n++){var o=r.section[n];i=i||o.contains(t)}return e},t.prototype.contains=function(t){return 0<=this.indexOf(t)},t.prototype.indexOf=function(t){for(var e=0;e<this.pdfPages.length;e++)if(this.pdfPages[e]===t)return this.pdfPages.indexOf(t);var i=new C(t);return this.pagesReferences.indexOf(i)},t.prototype.pageAddedMethod=function(t){var e=new pe(t);this.onPageAdded(e);this.parent.document.pages.onPageAdded(e),this.pageCount.intValue=this.count},t.prototype.onPageAdded=function(t){},t.prototype.getActualBounds=function(t,e,i){if(t instanceof ce&&"boolean"==typeof e){var r=this.parent.document;return this.getActualBounds(r,t,e)}t=t,e=e,i=i;var n=new k(0,0,0,0);n.height=i?this.pageSettings.size.height:this.pageSettings.getActualSize().height,n.width=i?this.pageSettings.size.width:this.pageSettings.getActualSize().width;var o=this.getLeftIndentWidth(t,e,i),s=this.getTopIndentHeight(t,e,i),a=this.getRightIndentWidth(t,e,i),h=this.getBottomIndentHeight(t,e,i);return n.x+=o,n.y+=s,n.width-=o+a,n.height-=s+h,n},t.prototype.getLeftIndentWidth=function(t,e,i){if(null==t)throw new Error("ArgumentNullException:document");if(null==e)throw new Error("ArgumentNullException:page");var r=i?this.pageSettings.margins.left:0,n=null!=this.template.getLeft(e)?this.template.getLeft(e).width:0,o=null!=t.template.getLeft(e)?t.template.getLeft(e).width:0;return r+=this.template.applyDocumentLeftTemplate?Math.max(n,o):n},t.prototype.getTopIndentHeight=function(t,e,i){if(null==t)throw new Error("ArgumentNullException:document");if(null==e)throw new Error("ArgumentNullException:page");var r=i?this.pageSettings.margins.top:0,n=null!=this.template.getTop(e)?this.template.getTop(e).height:0,o=null!=t.template.getTop(e)?t.template.getTop(e).height:0;return r+=this.template.applyDocumentTopTemplate?Math.max(n,o):n},t.prototype.getRightIndentWidth=function(t,e,i){if(null==t)throw new Error("ArgumentNullException:document");if(null==e)throw new Error("ArgumentNullException:page");var r=i?this.pageSettings.margins.right:0,n=null!=this.template.getRight(e)?this.template.getRight(e).width:0,o=null!=t.template.getRight(e)?t.template.getRight(e).width:0;return r+=this.template.applyDocumentRightTemplate?Math.max(n,o):n},t.prototype.getBottomIndentHeight=function(t,e,i){if(null==t)throw new Error("ArgumentNullException:document");if(null==e)throw new Error("ArgumentNullException:page");var r=i?this.pageSettings.margins.bottom:0,n=null!=this.template.getBottom(e)?this.template.getBottom(e).height:0,o=null!=t.template.getBottom(e)?t.template.getBottom(e).height:0;return r+=this.template.applyDocumentBottomTemplate?Math.max(n,o):n},t.prototype.remove=function(t){if(null==t)throw Error('ArgumentNullException("page")');var e=this.pdfPages.indexOf(t);this.pagesReferences.removeAt(e);for(var i=[],r=0;r<e;r++)i.push(this.pdfPages[r]);for(r=e+1;r<this.pdfPages.length;r++)i.push(this.pdfPages[r]);this.pdfPages=i},t.prototype.applyPageSettings=function(t,e,i){var r=new k(i.origin,i.size);t.items.setValue(this.dictionaryProperties.mediaBox,m.fromRectangle(r));var n=0;n=we.rotateFactor*i.rotate;var o=new g(n);t.items.setValue(this.dictionaryProperties.rotate,o)},t.prototype.beginSave=function(t,e){var i=e.document;this.applyPageSettings(this.section,i.pageSettings,t)},t.prototype.drawTemplates=function(t,e,i,r){var n=this.getDocumentTemplates(i,t,r),o=this.getSectionTemplates(t,r);this.drawTemplatesHelper(e,i,n),this.drawTemplatesHelper(e,i,o)},t.prototype.drawTemplatesHelper=function(t,e,i){if(null!=i&&i.length>0)for(var r=i.length,n=0;n<r;n++){i[n].draw(t,e)}},t}(),be=function(){function t(t){this.pageOrientation=t.pageSettings.orientation,this.pageRotate=t.pageSettings.rotate,this.pageSize=t.pageSettings.size,this.pageOrigin=t.pageSettings.origin}return Object.defineProperty(t.prototype,"orientation",{get:function(){return this.pageOrientation},set:function(t){this.pageOrientation=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"rotate",{get:function(){return this.pageRotate},set:function(t){this.pageRotate=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"size",{get:function(){return this.pageSize},set:function(t){this.pageSize=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"origin",{get:function(){return this.pageOrigin},set:function(t){this.pageOrigin=t},enumerable:!0,configurable:!0}),t}(),we=function(){function t(t){this.sections=[],this.dictionaryProperties=new a,this.pdfDocument=t.clone(),this.initialize()}return Object.defineProperty(t.prototype,"section",{get:function(){return this.sections},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"document",{get:function(){return this.pdfDocument},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"count",{get:function(){return this.sections.length},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"element",{get:function(){return this.pages},enumerable:!0,configurable:!0}),t.prototype.initialize=function(){this.sectionCount=new g(0),this.sectionCollection=new m,this.pages=new h,this.pages.beginSave=new l(this),this.pages.items.setValue(this.dictionaryProperties.type,new o("Pages")),this.pages.items.setValue(this.dictionaryProperties.kids,this.sectionCollection),this.pages.items.setValue(this.dictionaryProperties.count,this.sectionCount),this.pages.items.setValue(this.dictionaryProperties.resources,new h),this.setPageSettings(this.pages,this.pdfDocument.pageSettings)},t.prototype.pdfSectionCollection=function(t){if(t<0||t>=this.count)throw new Error("IndexOutOfRangeException()");return this.sections[t]},t.prototype.setPageSettings=function(t,e){var i=new k(new T,e.size);t.items.setValue(this.dictionaryProperties.mediaBox,m.fromRectangle(i))},t.prototype.add=function(t){if(void 0===t){var e=new ye(this.pdfDocument);return this.add(e),e}var i=this.checkSection(t);return this.sections.push(t),t.parent=this,this.sectionCollection.add(i),this.sections.indexOf(t)},t.prototype.checkSection=function(t){var e=new C(t);this.sectionCollection.contains(e);return e},t.prototype.countPages=function(){var t=0;return this.sections.forEach(function(e){return t+=e.count}),t},t.prototype.beginSave=function(){this.sectionCount.intValue=this.countPages()},t.rotateFactor=90,t}(),Pe=function(){function t(t){this.pdfPageCollectionIndex=new n,this.document=t}return Object.defineProperty(t.prototype,"count",{get:function(){return this.countPages()},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"pageCollectionIndex",{get:function(){return this.pdfPageCollectionIndex},enumerable:!0,configurable:!0}),t.prototype.add=function(t){if(void 0===t){var e=new ce;return this.add(e),e}this.getLastSection().add(t)},t.prototype.getLastSection=function(){var t=this.document.sections;0===t.section.length&&t.add();return t.section[t.section.length-1]},t.prototype.onPageAdded=function(t){},t.prototype.countPages=function(){for(var t=this.document.sections,e=0,i=0;i<t.section.length;i++)e+=t.section[i].count;return e},t.prototype.getPageByIndex=function(t){return this.getPage(t)},t.prototype.getPage=function(t){if(t<0||t>=this.count)throw Error('ArgumentOutOfRangeException("index", "Value can not be less 0")');for(var e=null,i=0,r=0,n=0,o=this.document.sections.count,s=0;s<o;s++){var a=this.document.sections.section[s];if(r=a.count,n=t-i,t>=i&&n<r){e=a.getPages()[n];break}i+=r}return e},t.prototype.indexOf=function(t){var e=-1;if(null==t)throw new Error("ArgumentNullException: page");for(var i=0,r=0,n=this.document.sections.count;r<n;r++){var o=this.document.sections.pdfSectionCollection(r);if((e=o.indexOf(t))>=0){e+=i;break}e=-1,i+=o.count}return e},t.prototype.remove=function(t){if(null==t)throw Error('ArgumentNullException("page")');for(var e=null,i=0,r=this.document.sections.count;i<r;i++)if((e=this.document.sections.pdfSectionCollection(i)).pages.contains(t)){e.pages.remove(t);break}return e},t}(),Se=function(){function t(){this.referenceObjects=[],this.pdfFontCollection=new n}return t.prototype.search=function(t){var e=null,i=this.getGroup(t);return null==i?i=this.createNewGroup():i.length>0&&(e=i[0]),i.push(t),e},t.prototype.createNewGroup=function(){var t=[];return this.referenceObjects.push(t),t},t.prototype.getGroup=function(t){var e=null;if(null!==t)for(var i=this.referenceObjects.length,r=0;r<i;r++){if(this.referenceObjects.length>0){var n=this.referenceObjects[r];if(n.length>0){var o=n[0];if(t.equalsTo(o)){e=n;break}}else this.removeGroup(n)}i=this.referenceObjects.length}return e},t.prototype.removeGroup=function(t){if(null!==t){var e=this.referenceObjects.indexOf(t);this.referenceObjects.slice(e,e+1)}},t.prototype.destroy=function(){this.pdfFontCollection=void 0,this.referenceObjects=void 0},t}(),ve=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Ce=function(e){function i(t){var r=e.call(this)||this;r.defaultMargin=40,r.streamWriter=null,r.document=r;var n=!1;void 0===t?(i.cacheCollection=new Se,n=!1):n=t;var o=new W;r.setMainObjectCollection(o);var s=new q;s.isMerging=n,s.document=r,r.setCrossTable(s);var a=new U;return r.setCatalog(a),o.add(a),a.position=-1,r.sectionCollection=new we(r),r.documentPageCollection=new Pe(r),a.pages=r.sectionCollection,r}return ve(i,e),Object.defineProperty(i,"defaultFont",{get:function(){return null==this.defaultStandardFont&&(this.defaultStandardFont=new xe(t.PdfFontFamily.Helvetica,8)),this.defaultStandardFont},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"sections",{get:function(){return this.sectionCollection},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"pageSettings",{get:function(){return null==this.settings&&(this.settings=new Z(this.defaultMargin)),this.settings},set:function(t){this.settings=t},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"pages",{get:function(){return this.documentPageCollection},enumerable:!0,configurable:!0}),Object.defineProperty(i,"cache",{get:function(){return void 0===i.cacheCollection||null==i.cacheCollection?new Se:i.cacheCollection},set:function(t){this.cacheCollection=t},enumerable:!0,configurable:!0}),Object.defineProperty(i,"enableCache",{get:function(){return this.isCacheEnabled},set:function(t){this.isCacheEnabled=t},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"colorSpace",{get:function(){return this.pdfColorSpace===t.PdfColorSpace.Rgb||this.pdfColorSpace===t.PdfColorSpace.Cmyk||this.pdfColorSpace===t.PdfColorSpace.GrayScale?this.pdfColorSpace:t.PdfColorSpace.Rgb},set:function(e){e===t.PdfColorSpace.Rgb||e===t.PdfColorSpace.Cmyk||e===t.PdfColorSpace.GrayScale?this.pdfColorSpace=e:this.pdfColorSpace=t.PdfColorSpace.Rgb},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"template",{get:function(){return null==this.pageTemplate&&(this.pageTemplate=new fe),this.pageTemplate},set:function(t){this.pageTemplate=t},enumerable:!0,configurable:!0}),i.prototype.docSave=function(t,e,i){if(this.checkPagesPresence(),null===t)throw new Error("ArgumentNullException : stream");this.streamWriter=t;var r=new z(t);if(r.document=this,"boolean"==typeof e&&void 0===i)return this.crossTable.save(r);this.crossTable.save(r,e)},i.prototype.checkPagesPresence=function(){0===this.pages.count&&this.pages.add()},i.prototype.destroy=function(){this.catalog=void 0,this.colorSpace=void 0,this.currentSavingObj=void 0,this.documentPageCollection=void 0,this.isStreamCopied=void 0,this.pageSettings=void 0,this.pageTemplate=void 0,this.pdfColorSpace=void 0,this.sectionCollection=void 0,i.cache.destroy(),this.crossTable.pdfObjects.destroy(),i.cache=void 0,this.streamWriter.destroy()},i.defaultStandardFont=null,i.isCacheEnabled=!0,i}(_),Be=function(){function e(){}return e.getMetrics=function(e,i,r){var n=null;switch(e){case t.PdfFontFamily.Helvetica:n=this.getHelveticaMetrics(e,i,r);break;case t.PdfFontFamily.Courier:n=this.getCourierMetrics(e,i,r);break;case t.PdfFontFamily.TimesRoman:n=this.getTimesMetrics(e,i,r);break;case t.PdfFontFamily.Symbol:n=this.getSymbolMetrics(e,i,r);break;case t.PdfFontFamily.ZapfDingbats:n=this.getZapfDingbatsMetrics(e,i,r);break;default:n=this.getHelveticaMetrics(t.PdfFontFamily.Helvetica,i,r)}return n.name=e.toString(),n.subScriptSizeFactor=this.subSuperScriptFactor,n.superscriptSizeFactor=this.subSuperScriptFactor,n},e.getHelveticaMetrics=function(e,i,r){var n=new Ft;return(i&t.PdfFontStyle.Bold)>0&&(i&t.PdfFontStyle.Italic)>0?(n.ascent=this.helveticaBoldItalicAscent,n.descent=this.helveticaBoldItalicDescent,n.postScriptName=this.helveticaBoldItalicName,n.size=r,n.widthTable=new Et(this.arialBoldWidth),n.height=n.ascent-n.descent):(i&t.PdfFontStyle.Bold)>0?(n.ascent=this.helveticaBoldAscent,n.descent=this.helveticaBoldDescent,n.postScriptName=this.helveticaBoldName,n.size=r,n.widthTable=new Et(this.arialBoldWidth),n.height=n.ascent-n.descent):(i&t.PdfFontStyle.Italic)>0?(n.ascent=this.helveticaItalicAscent,n.descent=this.helveticaItalicDescent,n.postScriptName=this.helveticaItalicName,n.size=r,n.widthTable=new Et(this.arialWidth),n.height=n.ascent-n.descent):(n.ascent=this.helveticaAscent,n.descent=this.helveticaDescent,n.postScriptName=this.helveticaName,n.size=r,n.widthTable=new Et(this.arialWidth),n.height=n.ascent-n.descent),n},e.getCourierMetrics=function(e,i,r){var n=new Ft;return(i&t.PdfFontStyle.Bold)>0&&(i&t.PdfFontStyle.Italic)>0?(n.ascent=this.courierBoldItalicAscent,n.descent=this.courierBoldItalicDescent,n.postScriptName=this.courierBoldItalicName,n.size=r,n.widthTable=new Et(this.fixedWidth),n.height=n.ascent-n.descent):(i&t.PdfFontStyle.Bold)>0?(n.ascent=this.courierBoldAscent,n.descent=this.courierBoldDescent,n.postScriptName=this.courierBoldName,n.size=r,n.widthTable=new Et(this.fixedWidth),n.height=n.ascent-n.descent):(i&t.PdfFontStyle.Italic)>0?(n.ascent=this.courierItalicAscent,n.descent=this.courierItalicDescent,n.postScriptName=this.courierItalicName,n.size=r,n.widthTable=new Et(this.fixedWidth),n.height=n.ascent-n.descent):(n.ascent=this.courierAscent,n.descent=this.courierDescent,n.postScriptName=this.courierName,n.size=r,n.widthTable=new Et(this.fixedWidth),n.height=n.ascent-n.descent),n},e.getTimesMetrics=function(e,i,r){var n=new Ft;return(i&t.PdfFontStyle.Bold)>0&&(i&t.PdfFontStyle.Italic)>0?(n.ascent=this.timesBoldItalicAscent,n.descent=this.timesBoldItalicDescent,n.postScriptName=this.timesBoldItalicName,n.size=r,n.widthTable=new Et(this.timesRomanBoldItalicWidths),n.height=n.ascent-n.descent):(i&t.PdfFontStyle.Bold)>0?(n.ascent=this.timesBoldAscent,n.descent=this.timesBoldDescent,n.postScriptName=this.timesBoldName,n.size=r,n.widthTable=new Et(this.timesRomanBoldWidth),n.height=n.ascent-n.descent):(i&t.PdfFontStyle.Italic)>0?(n.ascent=this.timesItalicAscent,n.descent=this.timesItalicDescent,n.postScriptName=this.timesItalicName,n.size=r,n.widthTable=new Et(this.timesRomanItalicWidth),n.height=n.ascent-n.descent):(n.ascent=this.timesAscent,n.descent=this.timesDescent,n.postScriptName=this.timesName,n.size=r,n.widthTable=new Et(this.timesRomanWidth),n.height=n.ascent-n.descent),n},e.getSymbolMetrics=function(t,e,i){var r=new Ft;return r.ascent=this.symbolAscent,r.descent=this.symbolDescent,r.postScriptName=this.symbolName,r.size=i,r.widthTable=new Et(this.symbolWidth),r.height=r.ascent-r.descent,r},e.getZapfDingbatsMetrics=function(t,e,i){var r=new Ft;return r.ascent=this.zapfDingbatsAscent,r.descent=this.zapfDingbatsDescent,r.postScriptName=this.zapfDingbatsName,r.size=i,r.widthTable=new Et(this.zapfDingbatsWidth),r.height=r.ascent-r.descent,r},e.subSuperScriptFactor=1.52,e.helveticaAscent=931,e.helveticaDescent=-225,e.helveticaName="Helvetica",e.helveticaBoldAscent=962,e.helveticaBoldDescent=-228,e.helveticaBoldName="Helvetica-Bold",e.helveticaItalicAscent=931,e.helveticaItalicDescent=-225,e.helveticaItalicName="Helvetica-Oblique",e.helveticaBoldItalicAscent=962,e.helveticaBoldItalicDescent=-228,e.helveticaBoldItalicName="Helvetica-BoldOblique",e.courierAscent=805,e.courierDescent=-250,e.courierName="Courier",e.courierBoldAscent=801,e.courierBoldDescent=-250,e.courierBoldName="Courier-Bold",e.courierItalicAscent=805,e.courierItalicDescent=-250,e.courierItalicName="Courier-Oblique",e.courierBoldItalicAscent=801,e.courierBoldItalicDescent=-250,e.courierBoldItalicName="Courier-BoldOblique",e.timesAscent=898,e.timesDescent=-218,e.timesName="Times-Roman",e.timesBoldAscent=935,e.timesBoldDescent=-218,e.timesBoldName="Times-Bold",e.timesItalicAscent=883,e.timesItalicDescent=-217,e.timesItalicName="Times-Italic",e.timesBoldItalicAscent=921,e.timesBoldItalicDescent=-218,e.timesBoldItalicName="Times-BoldItalic",e.symbolAscent=1010,e.symbolDescent=-293,e.symbolName="Symbol",e.zapfDingbatsAscent=820,e.zapfDingbatsDescent=-143,e.zapfDingbatsName="ZapfDingbats",e.arialWidth=[278,278,355,556,556,889,667,191,333,333,389,584,278,333,278,278,556,556,556,556,556,556,556,556,556,556,278,278,584,584,584,556,1015,667,667,722,722,667,611,778,722,278,500,667,556,833,722,778,667,778,722,667,611,722,667,944,667,667,611,278,278,278,469,556,333,556,556,500,556,556,278,556,556,222,222,500,222,833,556,556,556,556,333,500,278,556,500,722,500,500,500,334,260,334,584,0,556,0,222,556,333,1e3,556,556,333,1e3,667,333,1e3,0,611,0,0,222,222,333,333,350,556,1e3,333,1e3,500,333,944,0,500,667,0,333,556,556,556,556,260,556,333,737,370,556,584,0,737,333,400,584,333,333,333,556,537,278,333,333,365,556,834,834,834,611,667,667,667,667,667,667,1e3,722,667,667,667,667,278,278,278,278,722,722,778,778,778,778,778,584,778,722,722,722,722,667,667,611,556,556,556,556,556,556,889,500,556,556,556,556,278,278,278,278,556,556,556,556,556,556,556,584,611,556,556,556,556,500,556,500],e.arialBoldWidth=[278,333,474,556,556,889,722,238,333,333,389,584,278,333,278,278,556,556,556,556,556,556,556,556,556,556,333,333,584,584,584,611,975,722,722,722,722,667,611,778,722,278,556,722,611,833,722,778,667,778,722,667,611,722,667,944,667,667,611,333,278,333,584,556,333,556,611,556,611,556,333,611,611,278,278,556,278,889,611,611,611,611,389,556,333,611,556,778,556,556,500,389,280,389,584,0,556,0,278,556,500,1e3,556,556,333,1e3,667,333,1e3,0,611,0,0,278,278,500,500,350,556,1e3,333,1e3,556,333,944,0,500,667,0,333,556,556,556,556,280,556,333,737,370,556,584,0,737,333,400,584,333,333,333,611,556,278,333,333,365,556,834,834,834,611,722,722,722,722,722,722,1e3,722,667,667,667,667,278,278,278,278,722,722,778,778,778,778,778,584,778,722,722,722,722,667,667,611,556,556,556,556,556,556,889,556,556,556,556,556,278,278,278,278,611,611,611,611,611,611,611,584,611,611,611,611,611,556,611,556],e.fixedWidth=[600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600,600],e.timesRomanWidth=[250,333,408,500,500,833,778,180,333,333,500,564,250,333,250,278,500,500,500,500,500,500,500,500,500,500,278,278,564,564,564,444,921,722,667,667,722,611,556,722,722,333,389,722,611,889,722,722,556,722,667,556,611,722,722,944,722,722,611,333,278,333,469,500,333,444,500,444,500,444,333,500,500,278,278,500,278,778,500,500,500,500,333,389,278,500,500,722,500,500,444,480,200,480,541,0,500,0,333,500,444,1e3,500,500,333,1e3,556,333,889,0,611,0,0,333,333,444,444,350,500,1e3,333,980,389,333,722,0,444,722,0,333,500,500,500,500,200,500,333,760,276,500,564,0,760,333,400,564,300,300,333,500,453,250,333,300,310,500,750,750,750,444,722,722,722,722,722,722,889,667,611,611,611,611,333,333,333,333,722,722,722,722,722,722,722,564,722,722,722,722,722,722,556,500,444,444,444,444,444,444,667,444,444,444,444,444,278,278,278,278,500,500,500,500,500,500,500,564,500,500,500,500,500,500,500,500],e.timesRomanBoldWidth=[250,333,555,500,500,1e3,833,278,333,333,500,570,250,333,250,278,500,500,500,500,500,500,500,500,500,500,333,333,570,570,570,500,930,722,667,722,722,667,611,778,778,389,500,778,667,944,722,778,611,778,722,556,667,722,722,1e3,722,722,667,333,278,333,581,500,333,500,556,444,556,444,333,500,556,278,333,556,278,833,556,500,556,556,444,389,333,556,500,722,500,500,444,394,220,394,520,0,500,0,333,500,500,1e3,500,500,333,1e3,556,333,1e3,0,667,0,0,333,333,500,500,350,500,1e3,333,1e3,389,333,722,0,444,722,0,333,500,500,500,500,220,500,333,747,300,500,570,0,747,333,400,570,300,300,333,556,540,250,333,300,330,500,750,750,750,500,722,722,722,722,722,722,1e3,722,667,667,667,667,389,389,389,389,722,722,778,778,778,778,778,570,778,722,722,722,722,722,611,556,500,500,500,500,500,500,722,444,444,444,444,444,278,278,278,278,500,556,500,500,500,500,500,570,500,556,556,556,556,500,556,500],e.timesRomanItalicWidth=[250,333,420,500,500,833,778,214,333,333,500,675,250,333,250,278,500,500,500,500,500,500,500,500,500,500,333,333,675,675,675,500,920,611,611,667,722,611,611,722,722,333,444,667,556,833,667,722,611,722,611,500,556,722,611,833,611,556,556,389,278,389,422,500,333,500,500,444,500,444,278,500,500,278,278,444,278,722,500,500,500,500,389,389,278,500,444,667,444,444,389,400,275,400,541,0,500,0,333,500,556,889,500,500,333,1e3,500,333,944,0,556,0,0,333,333,556,556,350,500,889,333,980,389,333,667,0,389,556,0,389,500,500,500,500,275,500,333,760,276,500,675,0,760,333,400,675,300,300,333,500,523,250,333,300,310,500,750,750,750,500,611,611,611,611,611,611,889,667,611,611,611,611,333,333,333,333,722,667,722,722,722,722,722,675,722,722,722,722,722,556,611,500,500,500,500,500,500,500,667,444,444,444,444,444,278,278,278,278,500,500,500,500,500,500,500,675,500,500,500,500,500,444,500,444],e.timesRomanBoldItalicWidths=[250,389,555,500,500,833,778,278,333,333,500,570,250,333,250,278,500,500,500,500,500,500,500,500,500,500,333,333,570,570,570,500,832,667,667,667,722,667,667,722,778,389,500,667,611,889,722,722,611,722,667,556,611,722,667,889,667,611,611,333,278,333,570,500,333,500,500,444,500,444,333,500,556,278,278,500,278,778,556,500,500,500,389,389,278,556,444,667,500,444,389,348,220,348,570,0,500,0,333,500,500,1e3,500,500,333,1e3,556,333,944,0,611,0,0,333,333,500,500,350,500,1e3,333,1e3,389,333,722,0,389,611,0,389,500,500,500,500,220,500,333,747,266,500,606,0,747,333,400,570,300,300,333,576,500,250,333,300,300,500,750,750,750,500,667,667,667,667,667,667,944,667,667,667,667,667,389,389,389,389,722,722,722,722,722,722,722,570,722,722,722,722,722,611,611,500,500,500,500,500,500,500,722,444,444,444,444,444,278,278,278,278,500,556,500,500,500,500,500,570,500,556,556,556,556,444,500,444],e.symbolWidth=[250,333,713,500,549,833,778,439,333,333,500,549,250,549,250,278,500,500,500,500,500,500,500,500,500,500,278,278,549,549,549,444,549,722,667,722,612,611,763,603,722,333,631,722,686,889,722,722,768,741,556,592,611,690,439,768,645,795,611,333,863,333,658,500,500,631,549,549,494,439,521,411,603,329,603,549,549,576,521,549,549,521,549,603,439,576,713,686,493,686,494,480,200,480,549,750,620,247,549,167,713,500,753,753,753,753,1042,987,603,987,603,400,549,411,549,549,713,494,460,549,549,549,549,1e3,603,1e3,658,823,686,795,987,768,768,823,768,768,713,713,713,713,713,713,713,768,713,790,790,890,823,549,250,713,603,603,1042,987,603,987,603,494,329,790,790,786,713,384,384,384,384,384,384,494,494,494,494,329,274,686,686,686,384,384,384,384,384,384,494,494,494,-1],e.zapfDingbatsWidth=[278,974,961,974,980,719,789,790,791,690,960,939,549,855,911,933,911,945,974,755,846,762,761,571,677,763,760,759,754,494,552,537,577,692,786,788,788,790,793,794,816,823,789,841,823,833,816,831,923,744,723,749,790,792,695,776,768,792,759,707,708,682,701,826,815,789,789,707,687,696,689,786,787,713,791,785,791,873,761,762,762,759,759,892,892,788,784,438,138,277,415,392,392,668,668,390,390,317,317,276,276,509,509,410,410,234,234,334,334,732,544,544,910,667,760,760,776,595,694,626,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,788,894,838,1016,458,748,924,748,918,927,928,928,834,873,828,924,924,917,930,931,463,883,836,836,867,867,696,696,874,874,760,946,771,865,771,888,967,888,831,873,927,970,918],e}(),Oe=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),xe=function(e){function i(r,n,o){var s=e.call(this,n,void 0===o?r instanceof i?r.style:t.PdfFontStyle.Regular:o)||this;return s.dictionaryProperties=new a,s.encodings=["Unknown","StandardEncoding","MacRomanEncoding","MacExpertEncoding","WinAnsiEncoding","PDFDocEncoding","IdentityH"],s.pdfFontFamily=void 0===r?t.PdfFontFamily.Helvetica:r instanceof i?r.fontFamily:r,s.checkStyle(),s.initializeInternals(),s}return Oe(i,e),Object.defineProperty(i.prototype,"fontFamily",{get:function(){return this.pdfFontFamily},enumerable:!0,configurable:!0}),i.prototype.checkStyle=function(){if(this.fontFamily===t.PdfFontFamily.Symbol||this.fontFamily===t.PdfFontFamily.ZapfDingbats){var e=this.style;e&=~(t.PdfFontStyle.Bold|t.PdfFontStyle.Italic),this.setStyle(e)}},i.prototype.getLineWidth=function(t,e){if(null==t)throw new Error("ArgumentNullException:line");for(var r=0,n=(this.name,0),o=(t=i.convert(t)).length;n<o;n++){var s=t[n];r+=this.getCharWidthInternal(s,e)}var a=this.metrics.getSize(e);return r*=G.charSizeMultiplier*a,r=this.applyFormatSettings(t,e,r)},i.prototype.equalsToFont=function(e){var i=!1,r=e;if(null!=r){var n=this.fontFamily===r.fontFamily,o=~(t.PdfFontStyle.Underline|t.PdfFontStyle.Strikeout),s=(this.style&o)==(r.style&o);i=n&&s}return i},i.prototype.initializeInternals=function(){Ce.cache.search(this);var t=null,e=Be.getMetrics(this.pdfFontFamily,this.style,this.size);this.metrics=e,t=this.createInternals(),this.setInternals(t)},i.prototype.createInternals=function(){var e=new h;if(e.items.setValue(this.dictionaryProperties.type,new o(this.dictionaryProperties.font)),e.items.setValue(this.dictionaryProperties.subtype,new o(this.dictionaryProperties.type1)),e.items.setValue(this.dictionaryProperties.baseFont,new o(this.metrics.postScriptName)),this.fontFamily!==t.PdfFontFamily.Symbol&&this.fontFamily!==t.PdfFontFamily.ZapfDingbats){var i=this.encodings[t.FontEncoding.WinAnsiEncoding];e.items.setValue(this.dictionaryProperties.encoding,new o(i))}return e},i.prototype.getCharWidthInternal=function(t,e){var r=0;r=t.charCodeAt(0),"0"!==this.name&&"1"!==this.name&&"2"!==this.name&&"3"!==this.name&&"4"!==this.name||(r-=i.charOffset),r=r>=0&&128!==r?r:0;return this.metrics.widthTable.items(r)},i.convert=function(t){return t},i.charOffset=32,i}(G),Le=function(){function e(e){this.dictionaryProperties=new a,this.pdfColor=new L(255,255,255),this.rectangle=new k(0,0,0,0),this.pdfPage=null,this.textBrush=new M(new L(0,0,0)),this.textFont=new xe(t.PdfFontFamily.TimesRoman,10),this.format=new A(t.PdfTextAlignment.Left),this.content="",this.pdfDictionary=new h,this.internalColor=new L,this.darkness=1,void 0===e?this.initialize():(this.initialize(),this.bounds=e)}return Object.defineProperty(e.prototype,"color",{get:function(){return this.pdfColor},set:function(t){this.pdfColor=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"innerColor",{get:function(){return this.internalColor},set:function(t){this.internalColor=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"bounds",{get:function(){return this.rectangle},set:function(t){this.rectangle=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"page",{get:function(){return this.pdfPage},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"font",{get:function(){return this.textFont},set:function(t){this.textFont=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"stringFormat",{get:function(){return this.format},set:function(t){this.format=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"brush",{get:function(){return this.textBrush},set:function(t){this.textBrush=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"text",{get:function(){return this.content},set:function(t){this.content=t,this.dictionary.items.setValue(this.dictionaryProperties.contents,new S(this.content))},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"dictionary",{get:function(){return this.pdfDictionary},set:function(t){this.pdfDictionary=t},enumerable:!0,configurable:!0}),e.prototype.initialize=function(){this.pdfDictionary.annotationBeginSave=new p(this),this.pdfDictionary.items.setValue(this.dictionaryProperties.type,new o(this.dictionaryProperties.annot))},e.prototype.setPage=function(t){this.pdfPage=t,this.pdfDictionary.items.setValue(this.dictionaryProperties.p,new C(this.pdfPage))},e.prototype.beginSave=function(){this.save()},e.prototype.save=function(){var t=new k(this.rectangle.x,this.rectangle.y,this.rectangle.width,this.rectangle.height),e=this.pdfPage.section,i=t.height,r=e.pointToNativePdf(this.page,new T(t.x,t.y));t.x=r.x,t.width=r.x+t.width,t.y=r.y-this.page.document.pageSettings.margins.top,t.height=t.y-i,this.pdfDictionary.items.setValue(this.dictionaryProperties.rect,m.fromRectangle(t)),this.dictionary.items.setValue(this.dictionaryProperties.ca,new g(this.darkness))},Object.defineProperty(e.prototype,"element",{get:function(){return this.pdfDictionary},enumerable:!0,configurable:!0}),e}(),Te=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),je=function(t){function e(e){return t.call(this,e)||this}return Te(e,t),e.prototype.initialize=function(){t.prototype.initialize.call(this),this.dictionary.items.setValue(this.dictionaryProperties.subtype,new o(this.dictionaryProperties.link))},e}(Le),ke=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Ve=function(t){function e(e){var i=t.call(this,e)||this;return i.pdfAction=null,i}return ke(e,t),e.prototype.getSetAction=function(t){if(void 0===t)return this.pdfAction;this.pdfAction=t},e}(je),Re=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Ne=function(t){function e(e,i){var r=t.call(this,e)||this;return r.pdfDestination=null,void 0!==i&&(r.destination=i),r}return Re(e,t),Object.defineProperty(e.prototype,"destination",{get:function(){return this.pdfDestination},set:function(t){this.pdfDestination=t},enumerable:!0,configurable:!0}),e.prototype.save=function(){t.prototype.save.call(this),null!=this.pdfDestination&&this.dictionary.items.setValue(this.dictionaryProperties.dest,this.pdfDestination.element)},e.prototype.clone=function(){var t=new e(this.bounds,this.destination);return t.color=this.color,t.brush=this.brush,t.destination=this.destination,t.font=this.font,t},e}(je),Me=function(){function t(t){this.layoutElement=t}return Object.defineProperty(t.prototype,"elements",{get:function(){return this.layoutElement},enumerable:!0,configurable:!0}),t.prototype.getElement=function(){return this.layoutElement},t.prototype.layout=function(t){return this.layoutInternal(t)},t.prototype.Layouter=function(t){return this.layoutInternal(t)},t.prototype.getNextPage=function(t){return t.section.add()},t.prototype.getPaginateBounds=function(t){if(null==t)throw new Error("ArgumentNullException : param");return t.format.usePaginateBounds?t.format.paginateBounds:new k(t.bounds.x,0,t.bounds.width,t.bounds.height)},t}(),Ae=function(){function t(t){void 0===t||(this.break=t.break,this.layout=t.layout,this.paginateBounds=t.paginateBounds,this.boundsSet=t.usePaginateBounds)}return Object.defineProperty(t.prototype,"layout",{get:function(){return this.layoutType},set:function(t){this.layoutType=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"break",{get:function(){return this.breakType},set:function(t){this.breakType=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"paginateBounds",{get:function(){return void 0===this.layoutPaginateBounds&&null==this.layoutPaginateBounds&&(this.layoutPaginateBounds=new k(0,0,0,0)),this.layoutPaginateBounds},set:function(t){this.layoutPaginateBounds=t,this.boundsSet=!0},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"usePaginateBounds",{get:function(){return this.boundsSet},enumerable:!0,configurable:!0}),t}(),De=function(){function t(){}return Object.defineProperty(t.prototype,"page",{get:function(){return this.pdfPage},set:function(t){this.pdfPage=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"bounds",{get:function(){return new k(this.layoutBounds.x,this.layoutBounds.y,this.layoutBounds.width,this.layoutBounds.height)},set:function(t){this.layoutBounds=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"format",{get:function(){return this.layoutFormat},set:function(t){this.layoutFormat=t},enumerable:!0,configurable:!0}),t}(),Fe=function(){function t(t,e){this.pdfPage=t,this.layoutBounds=e}return Object.defineProperty(t.prototype,"page",{get:function(){return this.pdfPage},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"bounds",{get:function(){return this.layoutBounds},enumerable:!0,configurable:!0}),t}(),Ie=function(){function e(){var e=new Q(new L(0,0,0));e.dashStyle=t.PdfDashStyle.Solid;var i=new Q(new L(0,0,0));i.dashStyle=t.PdfDashStyle.Solid;var r=new Q(new L(0,0,0));r.dashStyle=t.PdfDashStyle.Solid;var n=new Q(new L(0,0,0));n.dashStyle=t.PdfDashStyle.Solid,this.leftPen=e,this.rightPen=i,this.topPen=r,this.bottomPen=n}return Object.defineProperty(e.prototype,"left",{get:function(){return this.leftPen},set:function(t){this.leftPen=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"right",{get:function(){return this.rightPen},set:function(t){this.rightPen=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"top",{get:function(){return this.topPen},set:function(t){this.topPen=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"bottom",{get:function(){return this.bottomPen},set:function(t){this.bottomPen=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"all",{set:function(t){this.leftPen=this.rightPen=this.topPen=this.bottomPen=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"isAll",{get:function(){return this.leftPen===this.rightPen&&this.leftPen===this.topPen&&this.leftPen===this.bottomPen},enumerable:!0,configurable:!0}),Object.defineProperty(e,"default",{get:function(){return new e},enumerable:!0,configurable:!0}),e}(),Ee=function(){function t(t,e,i,r){this.hasLeftPad=!1,this.hasRightPad=!1,this.hasTopPad=!1,this.hasBottomPad=!1,void 0===t?(this.leftPad=this.rightPad=5.76,this.bottomPad=this.topPad=.5):(this.leftPad=t,this.rightPad=e,this.topPad=i,this.bottomPad=r,this.hasLeftPad=!0,this.hasRightPad=!0,this.hasTopPad=!0,this.hasBottomPad=!0)}return Object.defineProperty(t.prototype,"left",{get:function(){return this.leftPad},set:function(t){this.leftPad=t,this.hasLeftPad=!0},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"right",{get:function(){return this.rightPad},set:function(t){this.rightPad=t,this.hasRightPad=!0},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"top",{get:function(){return this.topPad},set:function(t){this.topPad=t,this.hasTopPad=!0},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"bottom",{get:function(){return this.bottomPad},set:function(t){this.bottomPad=t,this.hasBottomPad=!0},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"all",{set:function(t){this.leftPad=this.rightPad=this.topPad=this.bottomPad=t,this.hasLeftPad=!0,this.hasRightPad=!0,this.hasTopPad=!0,this.hasBottomPad=!0},enumerable:!0,configurable:!0}),t}(),Ge=function(){function t(){}return Object.defineProperty(t.prototype,"raiseBeginPageLayout",{get:function(){return void 0!==this.beginPageLayout},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"raiseEndPageLayout",{get:function(){return void 0!==this.endPageLayout},enumerable:!0,configurable:!0}),t.prototype.onBeginPageLayout=function(t){this.beginPageLayout&&this.beginPageLayout(this,t)},t.prototype.onEndPageLayout=function(t){this.endPageLayout&&this.endPageLayout(this,t)},t.prototype.drawHelper=function(t,e,i,r){if(e instanceof T&&void 0===e.width&&void 0===i)return this.drawHelper(t,e.x,e.y);if("number"==typeof e&&"number"==typeof i&&void 0===r)return this.drawHelper(t,e,i,null);if(e instanceof k&&void 0!==e.width&&void 0===i)return this.drawHelper(t,e,null);if(e instanceof T&&void 0===e.width&&i instanceof Ae)return this.drawHelper(t,e.x,e.y,i);if("number"==typeof e&&"number"==typeof i&&(r instanceof Ae||null==r)){var n=t.graphics.clientSize.width-e,o=new k(e,i,n,0);return this.drawHelper(t,o,r)}if(e instanceof k&&void 0!==e.width&&"boolean"==typeof i)return this.bEmbedFonts=i,this.drawHelper(t,e,null);var s=new De,a=e,h=i;if(s.page=t,s.bounds=a,null!=s){var l=s.bounds.x,u=s.bounds.y;0===s.bounds.x&&(l=Ie.default.right.width/2),0===s.bounds.y&&(u=Ie.default.top.width/2);var c=new k(l,u,s.bounds.width,s.bounds.height);s.bounds=c}s.format=null!=h?h:new Ae;return this.layout(s)},t}(),ze=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),We=function(e){function i(t){return e.call(this,t)||this}return ze(i,e),Object.defineProperty(i.prototype,"element",{get:function(){return e.prototype.getElement.call(this)},enumerable:!0,configurable:!0}),i.prototype.layoutInternal=function(t){this.format=null!==this.element.stringFormat&&void 0!==this.element.stringFormat?this.element.stringFormat:null;var e=t.page,i=t.bounds,r=this.element.value,n=null,o=new He;for(o.page=e,o.remainder=r;;){o=this.layoutOnPage(r,e,i,t),n=this.getLayoutResult(o);break}return n},i.prototype.getLayoutResult=function(t){return new _e(t.page,t.bounds,t.remainder,t.lastLineBounds)},i.prototype.layoutOnPage=function(e,i,r,n){var o=new He;o.remainder=e,o.page=i,r=this.checkCorrectBounds(i,r);var s=(new F).layout(e,this.element.font,this.format,r,i.getClientSize().height,!1,new j(0,0)),a=null==s.remainder,h=(n.format.break===t.PdfLayoutBreakType.FitElement||s.empty,i.graphics),l=this.element.getBrush();this.element instanceof Je&&(l.color=new L(0,0,255)),h.drawStringLayoutResult(s,this.element.font,this.element.pen,l,r,this.format);s.lines[s.lineCount-1];return o.lastLineBounds=h.getLineBounds(s.lineCount-1,s,this.element.font,r,this.format),o.bounds=this.getTextPageBounds(i,r,s),o.remainder=s.remainder,o.end=a,o},i.prototype.checkCorrectBounds=function(t,e){var i=t.graphics.clientSize;return e.height=e.height>0?e.height:i.height-e.y,e},i.prototype.getTextPageBounds=function(t,e,i){var r=i.actualSize,n=e.x,o=e.y,s=e.width>0?e.width:r.width,a=r.height;n=t.graphics.checkCorrectLayoutRectangle(r,e.x,e.y,this.format).x;var h=t.graphics.getTextVerticalAlignShift(r.height,e.height,this.format);return new k(n,o+=h,s,a)},i}(Me),He=function(){return function(){}}(),_e=function(t){function e(e,i,r,n){var o=t.call(this,e,i)||this;return o.remainderText=r,o.lastLineTextBounds=n,o}return ze(e,t),Object.defineProperty(e.prototype,"remainder",{get:function(){return this.remainderText},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"lastLineBounds",{get:function(){return this.lastLineTextBounds},enumerable:!0,configurable:!0}),e}(Fe),Ke=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Ue=function(e){function i(t,i,r,n,o){var s=e.call(this)||this;return s.content="",s.elementValue="",s.hasPointOverload=!1,s.isPdfTextElement=!1,void 0===t||("string"==typeof t&&void 0===i?(s.content=t,s.elementValue=t):"string"==typeof t&&i instanceof G&&void 0===r?(s.content=t,s.elementValue=t,s.pdfFont=i):"string"==typeof t&&i instanceof G&&r instanceof Q&&void 0===n?(s.content=t,s.elementValue=t,s.pdfFont=i,s.pdfPen=r):"string"==typeof t&&i instanceof G&&r instanceof R&&void 0===n?(s.content=t,s.elementValue=t,s.pdfFont=i,s.pdfBrush=r):(s.content=t,s.elementValue=t,s.pdfFont=i,s.pdfPen=r,s.pdfBrush=n,s.format=o)),s}return Ke(i,e),Object.defineProperty(i.prototype,"text",{get:function(){return this.content},set:function(t){this.elementValue=t,this.content=t},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"value",{get:function(){return this.elementValue},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"pen",{get:function(){return this.pdfPen},set:function(t){this.pdfPen=t},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"brush",{get:function(){return this.pdfBrush},set:function(t){this.pdfBrush=t},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"font",{get:function(){return this.pdfFont},set:function(t){this.pdfFont=t,this.pdfFont instanceof xe&&null!=this.content?this.elementValue=xe.convert(this.content):this.elementValue=this.content},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"stringFormat",{get:function(){return this.format},set:function(t){this.format=t},enumerable:!0,configurable:!0}),i.prototype.getBrush=function(){return null==this.pdfBrush||void 0===this.pdfBrush?new M(new L(0,0,0)):this.pdfBrush},i.prototype.layout=function(t){return new We(this).layout(t)},i.prototype.drawText=function(t,e,i,r){if(e instanceof T&&void 0===e.width&&void 0===i)return this.hasPointOverload=!0,this.drawText(t,e.x,e.y);if("number"==typeof e&&"number"==typeof i&&void 0===r)return this.hasPointOverload=!0,this.drawText(t,e,i,null);if(e instanceof k&&void 0!==e.width&&void 0===i)return this.drawText(t,e,null);if(e instanceof T&&void 0===e.width&&i instanceof Ae)return this.hasPointOverload=!0,this.drawText(t,e.x,e.y,i);if("number"==typeof e&&"number"==typeof i&&(r instanceof Ae||null==r)){this.hasPointOverload=!0;var n=t.graphics.clientSize.width-e,o=new k(e,i,n,0);return this.drawText(t,o,r)}if(e instanceof k&&void 0!==e.width&&"boolean"==typeof i)return this.drawText(t,e,null);var s=new F;if(this.hasPointOverload){var a=s.layout(this.value,this.font,this.stringFormat,new j(t.graphics.clientSize.width-e.x,0),!0,t.graphics.clientSize),h=void 0,l=e,u=i;if((m=new De).page=t,m.bounds=l,m.format=null!=u?u:new Ae,a.lines.length>1){if(this.text=a.layoutLines[0].text,m.bounds.y<=m.page.graphics.clientSize.height){var c=new T(m.bounds.x,m.bounds.y);h=this.layout(m);for(var p=new k(0,h.bounds.y+a.lineHeight,t.graphics.clientSize.width,a.lineHeight),d=1;d<a.lines.length;d++)if(m.page=h.page,m.bounds=new k(new T(p.x,p.y),new j(p.width,p.height)),this.text=a.layoutLines[d].text,p.y+a.lineHeight>h.page.graphics.clientSize.height&&(m.page=m.page.graphics.getNextPage(),p=c.y>h.page.graphics.clientSize.height-h.bounds.height?new k(0,h.bounds.height,h.page.graphics.clientSize.width,a.lineHeight):new k(0,0,h.page.graphics.clientSize.width,a.lineHeight),m.bounds=p),h=this.layout(m),d!==a.lines.length-1)p=new k(0,h.bounds.y+a.lineHeight,h.page.graphics.clientSize.width,a.lineHeight);else{var f=this.font.measureString(this.text,this.format).width;h=this.calculateResultBounds(h,f,h.page.graphics.clientSize.width,0)}}return h}var g=this.font.measureString(this.text,this.format);return m.bounds.y<=m.page.graphics.clientSize.height&&(h=this.layout(m),h=this.calculateResultBounds(h,g.width,h.page.graphics.clientSize.width,0)),h}h=s.layout(this.value,this.font,this.stringFormat,new j(e.width,0),!1,t.graphics.clientSize);var m,y=void 0;l=e,u=i;if((m=new De).page=t,m.bounds=l,m.format=null!=u?u:new Ae,h.lines.length>1){if(this.text=h.layoutLines[0].text,m.bounds.y<=m.page.graphics.clientSize.height){c=new T(m.bounds.x,m.bounds.y);y=this.layout(m);for(p=new k(l.x,y.bounds.y+h.lineHeight,l.width,h.lineHeight),d=1;d<h.lines.length;d++)if(m.page=y.page,m.bounds=new k(p.x,p.y,p.width,p.height),this.text=h.layoutLines[d].text,p.y+h.lineHeight>y.page.graphics.clientSize.height&&(m.page=m.page.graphics.getNextPage(),p=c.y>y.page.graphics.clientSize.height-y.bounds.height?new k(l.x,h.lineHeight,l.width,h.lineHeight):new k(l.x,0,l.width,h.lineHeight),m.bounds=p),y=this.layout(m),d!==h.lines.length-1)p=new k(l.x,y.bounds.y+h.lineHeight,l.width,h.lineHeight);else{f=this.font.measureString(this.text,this.format).width;y=this.calculateResultBounds(y,f,l.width,l.x)}}return y}g=this.font.measureString(this.text,this.format);return m.bounds.y<=m.page.graphics.clientSize.height&&(y=this.layout(m),y=this.calculateResultBounds(y,g.width,l.width,l.x)),y},i.prototype.calculateResultBounds=function(e,i,r,n){return null!=this.stringFormat&&void 0!==this.stringFormat&&this.stringFormat.alignment===t.PdfTextAlignment.Center?(e.bounds.x=n+(r-i)/2,e.bounds.width=i):null!=this.stringFormat&&void 0!==this.stringFormat&&this.stringFormat.alignment===t.PdfTextAlignment.Right?(e.bounds.x=n+(r-i),e.bounds.width=i):null!=this.stringFormat&&void 0!==this.stringFormat&&this.stringFormat.alignment===t.PdfTextAlignment.Justify?(e.bounds.x=n,e.bounds.width=r):(e.bounds.width=n,e.bounds.width=i),e},i}(Ge),qe=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Ye=function(t){function e(e,i){var r=t.call(this,e)||this;return void 0!==i&&(r.uri=i),r}return qe(e,t),Object.defineProperty(e.prototype,"uriAction",{get:function(){return void 0===this.pdfUriAction&&(this.pdfUriAction=new x),this.pdfUriAction},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"uri",{get:function(){return this.uriAction.uri},set:function(t){this.uriAction.uri!==t&&(this.uriAction.uri=t)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"action",{get:function(){return this.getSetAction()},set:function(t){this.getSetAction(t),this.uriAction.next=t},enumerable:!0,configurable:!0}),e.prototype.initialize=function(){t.prototype.initialize.call(this),this.dictionary.items.setValue(this.dictionaryProperties.subtype,new o(this.dictionaryProperties.link));this.uriAction.element;this.dictionary.items.setValue(this.dictionaryProperties.a,this.uriAction.element)},e}(Ve),Xe=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Je=function(e){function i(){var t=e.call(this)||this;t.uniformResourceLocator="",t.uriAnnotation=null,t.recalculateBounds=!1,t.defaultBorder=new m;for(var i=0;i<3;i++)t.defaultBorder.add(new g(0));return t}return Xe(i,e),Object.defineProperty(i.prototype,"url",{get:function(){return this.uniformResourceLocator},set:function(t){if(0===t.length)throw new Error("ArgumentException : Url - string can not be empty");this.uniformResourceLocator=t},enumerable:!0,configurable:!0}),i.prototype.draw=function(e,i){if(e instanceof ce){var r=new F,n=this.font.style;if(i instanceof T){this.recalculateBounds=!0,this.font.style=t.PdfFontStyle.Underline;if(1===(h=r.layout(this.value,this.font,this.stringFormat,new j(e.graphics.clientSize.width-i.x,0),!0,e.graphics.clientSize)).lines.length){var o=this.font.measureString(this.value),s=new k(i,o);s=this.calculateBounds(s,o.width,e.graphics.clientSize.width,i.x),this.uriAnnotation=new Ye(s,this.url),this.uriAnnotation.dictionary.items.setValue("Border",this.defaultBorder),e.annotations.add(this.uriAnnotation);var a=this.drawText(e,i);return this.font.style=n,a}a=this.drawMultipleLineWithPoint(h,e,i);return this.font.style=n,a}var h=r.layout(this.value,this.font,this.stringFormat,new j(i.width,0),!1,new j(0,0));if(this.font.style=t.PdfFontStyle.Underline,1===h.lines.length){o=this.font.measureString(this.value),s=new k(new T(i.x,i.y),o);s=this.calculateBounds(s,o.width,i.width,i.x),this.uriAnnotation=new Ye(s,this.url),this.uriAnnotation.dictionary.items.setValue("Border",this.defaultBorder),e.annotations.add(this.uriAnnotation);var l=this.drawText(e,i);return this.font.style=n,l}l=this.drawMultipleLineWithBounds(h,e,i);return this.font.style=n,l}var u=new ce;return u=e.page,this.draw(u,i)},i.prototype.drawMultipleLineWithPoint=function(t,e,i){for(var r,n=0;n<t.layoutLines.length;n++){var o=this.font.measureString(t.lines[n].text),s=new k(i,o);if(0!==n&&(s.x=0),this.text=t.lines[n].text,s.y+o.height>e.graphics.clientSize.height){if(0===n)break;e=e.graphics.getNextPage(),s=new k(0,0,e.graphics.clientSize.width,o.height),i.y=0}s=this.calculateBounds(s,o.width,e.graphics.clientSize.width,s.x),this.uriAnnotation=new Ye(s,this.url),this.uriAnnotation.dictionary.items.setValue("Border",this.defaultBorder),e.annotations.add(this.uriAnnotation),r=0!==n?this.drawText(e,new T(0,s.y)):this.drawText(e,s.x,s.y),i.y+=o.height}return r},i.prototype.drawMultipleLineWithBounds=function(t,e,i){for(var r,n=0;n<t.layoutLines.length;n++){var o=this.font.measureString(t.lines[n].text),s=new k(new T(i.x,i.y),o);if(s=this.calculateBounds(s,o.width,i.width,i.x),this.text=t.lines[n].text,i.y+o.height>e.graphics.clientSize.height){if(0===n)break;e=e.graphics.getNextPage(),i=new k(i.x,0,i.width,o.height),s.y=0}this.uriAnnotation=new Ye(s,this.url),this.uriAnnotation.dictionary.items.setValue("Border",this.defaultBorder),e.annotations.add(this.uriAnnotation),r=this.drawText(e,i),i.y+=o.height}return r},i.prototype.calculateBounds=function(e,i,r,n){return null!=this.stringFormat&&void 0!==this.stringFormat&&this.stringFormat.alignment===t.PdfTextAlignment.Center?(e.x=n+(r-i)/2,e.width=i):null!=this.stringFormat&&void 0!==this.stringFormat&&this.stringFormat.alignment===t.PdfTextAlignment.Right?(e.x=n+(r-i),e.width=i):null!=this.stringFormat&&void 0!==this.stringFormat&&this.stringFormat.alignment===t.PdfTextAlignment.Justify?(e.x=n,e.width=r):(e.width=n,e.width=i),e},i}(Ue),Ze=function(){function e(){}return e.convert=function(e,i){var r="";switch(i){case t.PdfNumberStyle.None:r="";break;case t.PdfNumberStyle.Numeric:r=e.toString();break;case t.PdfNumberStyle.LowerLatin:r=this.arabicToLetter(e).toLowerCase();break;case t.PdfNumberStyle.LowerRoman:r=this.arabicToRoman(e).toLowerCase();break;case t.PdfNumberStyle.UpperLatin:r=this.arabicToLetter(e);break;case t.PdfNumberStyle.UpperRoman:r=this.arabicToRoman(e)}return r},e.arabicToRoman=function(t){var e="",i=this.generateNumber(t,1e3,"M");e+=i.returnValue,t=i.intArabic;var r=this.generateNumber(t,900,"CM");e+=r.returnValue,t=r.intArabic;var n=this.generateNumber(t,500,"D");e+=n.returnValue,t=n.intArabic;var o=this.generateNumber(t,400,"CD");e+=o.returnValue,t=o.intArabic;var s=this.generateNumber(t,100,"C");e+=s.returnValue,t=s.intArabic;var a=this.generateNumber(t,90,"XC");e+=a.returnValue,t=a.intArabic;var h=this.generateNumber(t,50,"L");e+=h.returnValue,t=h.intArabic;var l=this.generateNumber(t,40,"XL");e+=l.returnValue,t=l.intArabic;var u=this.generateNumber(t,10,"X");e+=u.returnValue,t=u.intArabic;var c=this.generateNumber(t,9,"IX");e+=c.returnValue,t=c.intArabic;var p=this.generateNumber(t,5,"V");e+=p.returnValue,t=p.intArabic;var d=this.generateNumber(t,4,"IV");e+=d.returnValue,t=d.intArabic;var f=this.generateNumber(t,1,"I");return e+=f.returnValue,t=f.intArabic,e.toString()},e.arabicToLetter=function(t){for(var e=this.convertToLetter(t),i="";e.length>0;){var r=e.pop();i=this.appendChar(i,r)}return i.toString()},e.generateNumber=function(t,e,i){for(var r="";t>=e;)t-=e,r+=i;return{returnValue:r.toString(),intArabic:t}},e.convertToLetter=function(t){if(t<=0)throw Error("ArgumentOutOfRangeException-arabic, Value can not be less 0");for(var e=[];t>this.letterLimit;){var i=t%this.letterLimit;0===i?(t=t/this.letterLimit-1,i=this.letterLimit):t/=this.letterLimit,e.push(i)}return e.push(t),e},e.appendChar=function(t,i){return t+=String.fromCharCode(e.acsiiStartIndex+i)},e.letterLimit=26,e.acsiiStartIndex=64,e}(),$e=function(){function t(t,e){this.pdfTemplate=null,this.content="",void 0===t||(this.template=t,this.value=e)}return Object.defineProperty(t.prototype,"template",{get:function(){return this.pdfTemplate},set:function(t){this.pdfTemplate=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"value",{get:function(){return this.content},set:function(t){this.content=t},enumerable:!0,configurable:!0}),t}(),Qe=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),ti=function(t){function e(){var e=t.call(this)||this;return e.list=new rt,e}return Qe(e,t),e.prototype.performDraw=function(e,i,r,n){t.prototype.performDrawHelper.call(this,e,i,r,n);var o=this.getValue(e),s=new Yt(this.getSize());this.list.setValue(e,new $e(s,o));var a=this.getSize();s.graphics.drawString(o,this.getFont(),this.pen,this.getBrush(),0,0,a.width,a.height,this.stringFormat);var h=new T(i.x+this.location.x,i.y+this.location.y);e.drawPdfTemplate(s,h,new j(s.width*r,s.height*n))},e}(ht),ei=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),ii=function(e){function i(i,r){var n=e.call(this)||this;return n.internalNumberStyle=t.PdfNumberStyle.Numeric,void 0===r?n.font=i:r instanceof R?(n.font=i,n.brush=r):(n.font=i,n.bounds=r),n}return ei(i,e),Object.defineProperty(i.prototype,"numberStyle",{get:function(){return this.internalNumberStyle},set:function(t){this.internalNumberStyle=t},enumerable:!0,configurable:!0}),i.prototype.getValue=function(t){var e=this.getPageFromGraphics(t);return this.internalGetValue(e)},i.prototype.internalGetValue=function(t){var e=t.document.pages.indexOf(t)+1;return Ze.convert(e,this.numberStyle)},i}(ti),ri=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),ni=function(t){function e(e,i,r){for(var n=[],o=3;o<arguments.length;o++)n[o-3]=arguments[o];var s=t.call(this)||this;return s.internalAutomaticFields=null,s.internalText="",s.font=e,s.brush=i,s.text=r,s.automaticFields=n,s}return ri(e,t),Object.defineProperty(e.prototype,"text",{get:function(){return this.internalText},set:function(t){this.internalText=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"automaticFields",{get:function(){return this.internalAutomaticFields},set:function(t){this.internalAutomaticFields=t},enumerable:!0,configurable:!0}),e.prototype.getValue=function(t){var e=this.text.toString();if(void 0!==this.automaticFields&&null!=this.automaticFields&&this.automaticFields.length>0)for(var i=0;i<this.automaticFields.length;i++){var r=this.automaticFields[i];e=e.replace("{"+i+"}",r.getValue(t))}return e},e}(ti),oi=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),si=function(t){function e(){var e=t.call(this)||this;return e.list=new rt,e.painterGraphics=[],e}return oi(e,t),e.prototype.performDraw=function(e,i,r,n){t.prototype.performDrawHelper.call(this,e,i,r,n);var o=this.getPageFromGraphics(e).document,s=this.getValue(e);if(this.list.containsKey(o)){var a=this.list.getValue(o),h=new T(i.x+this.location.x,i.y+this.location.y);e.drawPdfTemplate(a.template,h,new j(a.template.width*r,a.template.height*n)),this.painterGraphics.push(e)}else{var l=this.getSize(),u=new Yt(l);this.list.setValue(o,new $e(u,s)),u.graphics.drawString(s,this.getFont(),this.pen,this.getBrush(),0,0,l.width,l.height,this.stringFormat);h=new T(i.x+this.location.x,i.y+this.location.y);e.drawPdfTemplate(u,h,new j(u.width*r,u.height*n)),this.painterGraphics.push(e)}},e}(ht),ai=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),hi=function(e){function i(i,r){var n=e.call(this)||this;return n.internalNumberStyle=t.PdfNumberStyle.Numeric,void 0===r?n.font=i:r instanceof R?(n.font=i,n.brush=r):(n.font=i,n.bounds=r),n}return ai(i,e),Object.defineProperty(i.prototype,"numberStyle",{get:function(){return this.internalNumberStyle},set:function(t){this.internalNumberStyle=t},enumerable:!0,configurable:!0}),i.prototype.getValue=function(t){var e=this.getPageFromGraphics(t).section.parent.document.pages.count;return Ze.convert(e,this.numberStyle)},i}(si);!function(t){t[t.Location=0]="Location",t[t.FitToPage=1]="FitToPage",t[t.FitR=2]="FitR"}(t.PdfDestinationMode||(t.PdfDestinationMode={}));var li,ui=function(){function e(e,i){this.dictionaryProperties=new a,this.destinationMode=t.PdfDestinationMode.Location,this.zoomFactor=0,this.destinationLocation=new T(0,0),this.bounds=new k,this.array=new m;t.PdfPageRotateAngle.RotateAngle0;this.destinationLocation=new T(0,this.destinationLocation.y),this.pdfPage=e,i instanceof T?this.destinationLocation=i:this.bounds=i}return Object.defineProperty(e.prototype,"zoom",{get:function(){return this.zoomFactor},set:function(t){this.zoomFactor=t,this.initializePrimitive()},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"page",{get:function(){return this.pdfPage},set:function(t){this.pdfPage=t,this.initializePrimitive()},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"mode",{get:function(){return this.destinationMode},set:function(t){this.destinationMode=t,this.initializePrimitive()},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"location",{get:function(){return this.destinationLocation},set:function(t){this.destinationLocation=t,this.initializePrimitive()},enumerable:!0,configurable:!0}),e.prototype.pointToNativePdf=function(t,e){return t.section.pointToNativePdf(t,e)},e.prototype.initializePrimitive=function(){switch(this.array.clear(),this.array.add(new C(this.pdfPage)),this.destinationMode){case t.PdfDestinationMode.Location:var e=this.pdfPage,i=new T;i=this.pointToNativePdf(e,this.destinationLocation),this.array.add(new o(this.dictionaryProperties.xyz)),this.array.add(new g(i.x)),this.array.add(new g(i.y)),this.array.add(new g(this.zoomFactor));break;case t.PdfDestinationMode.FitToPage:this.array.add(new o(this.dictionaryProperties.fit))}},Object.defineProperty(e.prototype,"element",{get:function(){return this.initializePrimitive(),this.array},enumerable:!0,configurable:!0}),e}(),ci=function(){function t(t){this.mDictionary=null,this.mDictionaryProperties=new a,this.mDictionary=t}return Object.defineProperty(t.prototype,"domain",{get:function(){return this.mDictionary.items.getValue(this.mDictionaryProperties.domain)},set:function(t){this.mDictionary.items.setValue(this.mDictionaryProperties.domain,t)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"range",{get:function(){return this.mDictionary.items.getValue(this.mDictionaryProperties.range)},set:function(t){this.mDictionary.items.setValue(this.mDictionaryProperties.range,t)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"dictionary",{get:function(){return this.mDictionary},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"element",{get:function(){return this.mDictionary},enumerable:!0,configurable:!0}),t}(),pi=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),di=function(t){function e(e,i,r,n){var o=t.call(this,new b)||this;return void 0===e?o.dictionary.items.setValue(o.mDictionaryProperties.functionType,new g(0)):(o.dictionary.items.setValue(o.mDictionaryProperties.functionType,new g(0)),o.checkParams(e,i,r,n),o.setDomainAndRange(e,i),o.setSizeAndValues(r,n)),o}return pi(e,t),e.prototype.checkParams=function(t,e,i,r){e.length,t.length,r.length},e.prototype.setDomainAndRange=function(t,e){this.domain=new m(t),this.range=new m(e)},e.prototype.setSizeAndValues=function(t,e){var i=this.dictionary;this.dictionary.items.setValue(this.mDictionaryProperties.size,new m(t)),this.dictionary.items.setValue(this.mDictionaryProperties.bitsPerSample,new g(8)),i.writeBytes(e)},e}(ci);!function(t){t[t.None=0]="None",t[t.Start=1]="Start",t[t.End=2]="End",t[t.Both=3]="Both"}(li||(li={}));var fi;!function(t){t[t.BackwardDiagonal=0]="BackwardDiagonal",t[t.ForwardDiagonal=1]="ForwardDiagonal",t[t.Horizontal=2]="Horizontal",t[t.Vertical=3]="Vertical"}(fi||(fi={}));var gi;!function(t){t[t.Function=1]="Function",t[t.Axial=2]="Axial",t[t.Radial=3]="Radial"}(gi||(gi={}));var mi;!function(t){t[t.ActiveBorder=1]="ActiveBorder",t[t.ActiveCaption=2]="ActiveCaption",t[t.ActiveCaptionText=3]="ActiveCaptionText",t[t.AppWorkspace=4]="AppWorkspace",t[t.Control=5]="Control",t[t.ControlDark=6]="ControlDark",t[t.ControlDarkDark=7]="ControlDarkDark",t[t.ControlLight=8]="ControlLight",t[t.ControlLightLight=9]="ControlLightLight",t[t.ControlText=10]="ControlText",t[t.Desktop=11]="Desktop",t[t.GrayText=12]="GrayText",t[t.Highlight=13]="Highlight",t[t.HighlightText=14]="HighlightText",t[t.HotTrack=15]="HotTrack",t[t.InactiveBorder=16]="InactiveBorder",t[t.InactiveCaption=17]="InactiveCaption",t[t.InactiveCaptionText=18]="InactiveCaptionText",t[t.Info=19]="Info",t[t.InfoText=20]="InfoText",t[t.Menu=21]="Menu",t[t.MenuText=22]="MenuText",t[t.ScrollBar=23]="ScrollBar",t[t.Window=24]="Window",t[t.WindowFrame=25]="WindowFrame",t[t.WindowText=26]="WindowText",t[t.Transparent=27]="Transparent",t[t.AliceBlue=28]="AliceBlue",t[t.AntiqueWhite=29]="AntiqueWhite",t[t.Aqua=30]="Aqua",t[t.Aquamarine=31]="Aquamarine",t[t.Azure=32]="Azure",t[t.Beige=33]="Beige",t[t.Bisque=34]="Bisque",t[t.Black=35]="Black",t[t.BlanchedAlmond=36]="BlanchedAlmond",t[t.Blue=37]="Blue",t[t.BlueViolet=38]="BlueViolet",t[t.Brown=39]="Brown",t[t.BurlyWood=40]="BurlyWood",t[t.CadetBlue=41]="CadetBlue",t[t.Chartreuse=42]="Chartreuse",t[t.Chocolate=43]="Chocolate",t[t.Coral=44]="Coral",t[t.CornflowerBlue=45]="CornflowerBlue",t[t.Cornsilk=46]="Cornsilk",t[t.Crimson=47]="Crimson",t[t.Cyan=48]="Cyan",t[t.DarkBlue=49]="DarkBlue",t[t.DarkCyan=50]="DarkCyan",t[t.DarkGoldenrod=51]="DarkGoldenrod",t[t.DarkGray=52]="DarkGray",t[t.DarkGreen=53]="DarkGreen",t[t.DarkKhaki=54]="DarkKhaki",t[t.DarkMagenta=55]="DarkMagenta",t[t.DarkOliveGreen=56]="DarkOliveGreen",t[t.DarkOrange=57]="DarkOrange",t[t.DarkOrchid=58]="DarkOrchid",t[t.DarkRed=59]="DarkRed",t[t.DarkSalmon=60]="DarkSalmon",t[t.DarkSeaGreen=61]="DarkSeaGreen",t[t.DarkSlateBlue=62]="DarkSlateBlue",t[t.DarkSlateGray=63]="DarkSlateGray",t[t.DarkTurquoise=64]="DarkTurquoise",t[t.DarkViolet=65]="DarkViolet",t[t.DeepPink=66]="DeepPink",t[t.DeepSkyBlue=67]="DeepSkyBlue",t[t.DimGray=68]="DimGray",t[t.DodgerBlue=69]="DodgerBlue",t[t.Firebrick=70]="Firebrick",t[t.FloralWhite=71]="FloralWhite",t[t.ForestGreen=72]="ForestGreen",t[t.Fuchsia=73]="Fuchsia",t[t.Gainsboro=74]="Gainsboro",t[t.GhostWhite=75]="GhostWhite",t[t.Gold=76]="Gold",t[t.Goldenrod=77]="Goldenrod",t[t.Gray=78]="Gray",t[t.Green=79]="Green",t[t.GreenYellow=80]="GreenYellow",t[t.Honeydew=81]="Honeydew",t[t.HotPink=82]="HotPink",t[t.IndianRed=83]="IndianRed",t[t.Indigo=84]="Indigo",t[t.Ivory=85]="Ivory",t[t.Khaki=86]="Khaki",t[t.Lavender=87]="Lavender",t[t.LavenderBlush=88]="LavenderBlush",t[t.LawnGreen=89]="LawnGreen",t[t.LemonChiffon=90]="LemonChiffon",t[t.LightBlue=91]="LightBlue",t[t.LightCoral=92]="LightCoral",t[t.LightCyan=93]="LightCyan",t[t.LightGoldenrodYellow=94]="LightGoldenrodYellow",t[t.LightGray=95]="LightGray",t[t.LightGreen=96]="LightGreen",t[t.LightPink=97]="LightPink",t[t.LightSalmon=98]="LightSalmon",t[t.LightSeaGreen=99]="LightSeaGreen",t[t.LightSkyBlue=100]="LightSkyBlue",t[t.LightSlateGray=101]="LightSlateGray",t[t.LightSteelBlue=102]="LightSteelBlue",t[t.LightYellow=103]="LightYellow",t[t.Lime=104]="Lime",t[t.LimeGreen=105]="LimeGreen",t[t.Linen=106]="Linen",t[t.Magenta=107]="Magenta",t[t.Maroon=108]="Maroon",t[t.MediumAquamarine=109]="MediumAquamarine",t[t.MediumBlue=110]="MediumBlue",t[t.MediumOrchid=111]="MediumOrchid",t[t.MediumPurple=112]="MediumPurple",t[t.MediumSeaGreen=113]="MediumSeaGreen",t[t.MediumSlateBlue=114]="MediumSlateBlue",t[t.MediumSpringGreen=115]="MediumSpringGreen",t[t.MediumTurquoise=116]="MediumTurquoise",t[t.MediumVioletRed=117]="MediumVioletRed",t[t.MidnightBlue=118]="MidnightBlue",t[t.MintCream=119]="MintCream",t[t.MistyRose=120]="MistyRose",t[t.Moccasin=121]="Moccasin",t[t.NavajoWhite=122]="NavajoWhite",t[t.Navy=123]="Navy",t[t.OldLace=124]="OldLace",t[t.Olive=125]="Olive",t[t.OliveDrab=126]="OliveDrab",t[t.Orange=127]="Orange",t[t.OrangeRed=128]="OrangeRed",t[t.Orchid=129]="Orchid",t[t.PaleGoldenrod=130]="PaleGoldenrod",t[t.PaleGreen=131]="PaleGreen",t[t.PaleTurquoise=132]="PaleTurquoise",t[t.PaleVioletRed=133]="PaleVioletRed",t[t.PapayaWhip=134]="PapayaWhip",t[t.PeachPuff=135]="PeachPuff",t[t.Peru=136]="Peru",t[t.Pink=137]="Pink",t[t.Plum=138]="Plum",t[t.PowderBlue=139]="PowderBlue",t[t.Purple=140]="Purple",t[t.Red=141]="Red",t[t.RosyBrown=142]="RosyBrown",t[t.RoyalBlue=143]="RoyalBlue",t[t.SaddleBrown=144]="SaddleBrown",t[t.Salmon=145]="Salmon",t[t.SandyBrown=146]="SandyBrown",t[t.SeaGreen=147]="SeaGreen",t[t.SeaShell=148]="SeaShell",t[t.Sienna=149]="Sienna",t[t.Silver=150]="Silver",t[t.SkyBlue=151]="SkyBlue",t[t.SlateBlue=152]="SlateBlue",t[t.SlateGray=153]="SlateGray",t[t.Snow=154]="Snow",t[t.SpringGreen=155]="SpringGreen",t[t.SteelBlue=156]="SteelBlue",t[t.Tan=157]="Tan",t[t.Teal=158]="Teal",t[t.Thistle=159]="Thistle",t[t.Tomato=160]="Tomato",t[t.Turquoise=161]="Turquoise",t[t.Violet=162]="Violet",t[t.Wheat=163]="Wheat",t[t.White=164]="White",t[t.WhiteSmoke=165]="WhiteSmoke",t[t.Yellow=166]="Yellow",t[t.YellowGreen=167]="YellowGreen",t[t.ButtonFace=168]="ButtonFace",t[t.ButtonHighlight=169]="ButtonHighlight",t[t.ButtonShadow=170]="ButtonShadow",t[t.GradientActiveCaption=171]="GradientActiveCaption",t[t.GradientInactiveCaption=172]="GradientInactiveCaption",t[t.MenuBar=173]="MenuBar",t[t.MenuHighlight=174]="MenuHighlight"}(mi||(mi={}));var yi=function(){function t(){}return Object.defineProperty(t,"AliceBlue",{get:function(){var t=null;return this.sBrushes.containsKey(mi.AliceBlue)&&(t=this.sBrushes.getValue(mi.AliceBlue)),null==t&&(t=this.getBrush(mi.AliceBlue)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"AntiqueWhite",{get:function(){var t=null;return this.sBrushes.containsKey(mi.AntiqueWhite)&&(t=this.sBrushes.getValue(mi.AntiqueWhite)),null==t&&(t=this.getBrush(mi.AntiqueWhite)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Aqua",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Aqua)&&(t=this.sBrushes.getValue(mi.Aqua)),null==t&&(t=this.getBrush(mi.Aqua)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Aquamarine",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Aquamarine)&&(t=this.sBrushes.getValue(mi.Aquamarine)),null==t&&(t=this.getBrush(mi.Aquamarine)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Azure",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Azure)&&(t=this.sBrushes.getValue(mi.Azure)),null==t&&(t=this.getBrush(mi.Azure)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Beige",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Beige)&&(t=this.sBrushes.getValue(mi.Beige)),null==t&&(t=this.getBrush(mi.Beige)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Bisque",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Bisque)&&(t=this.sBrushes.getValue(mi.Bisque)),null==t&&(t=this.getBrush(mi.Bisque)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Black",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Black)&&(t=this.sBrushes.getValue(mi.Black)),null==t&&(t=this.getBrush(mi.Black)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"BlanchedAlmond",{get:function(){var t=null;return this.sBrushes.containsKey(mi.BlanchedAlmond)&&(t=this.sBrushes.getValue(mi.BlanchedAlmond)),null==t&&(t=this.getBrush(mi.BlanchedAlmond)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Blue",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Blue)&&(t=this.sBrushes.getValue(mi.Blue)),null==t&&(t=this.getBrush(mi.Blue)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"BlueViolet",{get:function(){var t=null;return this.sBrushes.containsKey(mi.BlueViolet)&&(t=this.sBrushes.getValue(mi.BlueViolet)),null==t&&(t=this.getBrush(mi.BlueViolet)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Brown",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Brown)&&(t=this.sBrushes.getValue(mi.Brown)),null==t&&(t=this.getBrush(mi.Brown)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"BurlyWood",{get:function(){var t=null;return this.sBrushes.containsKey(mi.BurlyWood)&&(t=this.sBrushes.getValue(mi.BurlyWood)),null==t&&(t=this.getBrush(mi.BurlyWood)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"CadetBlue",{get:function(){var t=null;return this.sBrushes.containsKey(mi.CadetBlue)&&(t=this.sBrushes.getValue(mi.CadetBlue)),null==t&&(t=this.getBrush(mi.CadetBlue)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Chartreuse",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Chartreuse)&&(t=this.sBrushes.getValue(mi.Chartreuse)),null==t&&(t=this.getBrush(mi.Chartreuse)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Chocolate",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Chocolate)&&(t=this.sBrushes.getValue(mi.Chocolate)),null==t&&(t=this.getBrush(mi.Chocolate)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Coral",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Coral)&&(t=this.sBrushes.getValue(mi.Coral)),null==t&&(t=this.getBrush(mi.Coral)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"CornflowerBlue",{get:function(){var t=null;return this.sBrushes.containsKey(mi.CornflowerBlue)&&(t=this.sBrushes.getValue(mi.CornflowerBlue)),null==t&&(t=this.getBrush(mi.CornflowerBlue)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Cornsilk",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Cornsilk)&&(t=this.sBrushes.getValue(mi.Cornsilk)),null==t&&(t=this.getBrush(mi.Cornsilk)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Crimson",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Crimson)&&(t=this.sBrushes.getValue(mi.Crimson)),null==t&&(t=this.getBrush(mi.Crimson)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Cyan",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Cyan)&&(t=this.sBrushes.getValue(mi.Cyan)),null==t&&(t=this.getBrush(mi.Cyan)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"DarkBlue",{get:function(){var t=null;return this.sBrushes.containsKey(mi.DarkBlue)&&(t=this.sBrushes.getValue(mi.DarkBlue)),null==t&&(t=this.getBrush(mi.DarkBlue)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"DarkCyan",{get:function(){var t=null;return this.sBrushes.containsKey(mi.DarkCyan)&&(t=this.sBrushes.getValue(mi.DarkCyan)),null==t&&(t=this.getBrush(mi.DarkCyan)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"DarkGoldenrod",{get:function(){var t=null;return this.sBrushes.containsKey(mi.DarkGoldenrod)&&(t=this.sBrushes.getValue(mi.DarkGoldenrod)),null==t&&(t=this.getBrush(mi.DarkGoldenrod)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"DarkGray",{get:function(){var t=null;return this.sBrushes.containsKey(mi.DarkGray)&&(t=this.sBrushes.getValue(mi.DarkGray)),null==t&&(t=this.getBrush(mi.DarkGray)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"DarkGreen",{get:function(){var t=null;return this.sBrushes.containsKey(mi.DarkGreen)&&(t=this.sBrushes.getValue(mi.DarkGreen)),null==t&&(t=this.getBrush(mi.DarkGreen)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"DarkKhaki",{get:function(){var t=null;return this.sBrushes.containsKey(mi.DarkKhaki)&&(t=this.sBrushes.getValue(mi.DarkKhaki)),null==t&&(t=this.getBrush(mi.DarkKhaki)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"DarkMagenta",{get:function(){var t=null;return this.sBrushes.containsKey(mi.DarkMagenta)&&(t=this.sBrushes.getValue(mi.DarkMagenta)),null==t&&(t=this.getBrush(mi.DarkMagenta)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"DarkOliveGreen",{get:function(){var t=null;return this.sBrushes.containsKey(mi.DarkOliveGreen)&&(t=this.sBrushes.getValue(mi.DarkOliveGreen)),null==t&&(t=this.getBrush(mi.DarkOliveGreen)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"DarkOrange",{get:function(){var t=null;return this.sBrushes.containsKey(mi.DarkOrange)&&(t=this.sBrushes.getValue(mi.DarkOrange)),null==t&&(t=this.getBrush(mi.DarkOrange)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"DarkOrchid",{get:function(){var t=null;return this.sBrushes.containsKey(mi.DarkOrchid)&&(t=this.sBrushes.getValue(mi.DarkOrchid)),null==t&&(t=this.getBrush(mi.DarkOrchid)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"DarkRed",{get:function(){var t=null;return this.sBrushes.containsKey(mi.DarkRed)&&(t=this.sBrushes.getValue(mi.DarkRed)),null==t&&(t=this.getBrush(mi.DarkRed)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"DarkSalmon",{get:function(){var t=null;return this.sBrushes.containsKey(mi.DarkSalmon)&&(t=this.sBrushes.getValue(mi.DarkSalmon)),null==t&&(t=this.getBrush(mi.DarkSalmon)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"DarkSeaGreen",{get:function(){var t=null;return this.sBrushes.containsKey(mi.DarkSeaGreen)&&(t=this.sBrushes.getValue(mi.DarkSeaGreen)),null==t&&(t=this.getBrush(mi.DarkSeaGreen)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"DarkSlateBlue",{get:function(){var t=null;return this.sBrushes.containsKey(mi.DarkSlateBlue)&&(t=this.sBrushes.getValue(mi.DarkSlateBlue)),null==t&&(t=this.getBrush(mi.DarkSlateBlue)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"DarkSlateGray",{get:function(){var t=null;return this.sBrushes.containsKey(mi.DarkSlateGray)&&(t=this.sBrushes.getValue(mi.DarkSlateGray)),null==t&&(t=this.getBrush(mi.DarkSlateGray)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"DarkTurquoise",{get:function(){var t=null;return this.sBrushes.containsKey(mi.DarkTurquoise)&&(t=this.sBrushes.getValue(mi.DarkTurquoise)),null==t&&(t=this.getBrush(mi.DarkTurquoise)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"DarkViolet",{get:function(){var t=null;return this.sBrushes.containsKey(mi.DarkViolet)&&(t=this.sBrushes.getValue(mi.DarkViolet)),null==t&&(t=this.getBrush(mi.DarkViolet)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"DeepPink",{get:function(){var t=null;return this.sBrushes.containsKey(mi.DeepPink)&&(t=this.sBrushes.getValue(mi.DeepPink)),null==t&&(t=this.getBrush(mi.DeepPink)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"DeepSkyBlue",{get:function(){var t=null;return this.sBrushes.containsKey(mi.DeepSkyBlue)&&(t=this.sBrushes.getValue(mi.DeepSkyBlue)),null==t&&(t=this.getBrush(mi.DeepSkyBlue)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"DimGray",{get:function(){var t=null;return this.sBrushes.containsKey(mi.DimGray)&&(t=this.sBrushes.getValue(mi.DimGray)),null==t&&(t=this.getBrush(mi.DimGray)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"DodgerBlue",{get:function(){var t=null;return this.sBrushes.containsKey(mi.DodgerBlue)&&(t=this.sBrushes.getValue(mi.DodgerBlue)),null==t&&(t=this.getBrush(mi.DodgerBlue)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Firebrick",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Firebrick)&&(t=this.sBrushes.getValue(mi.Firebrick)),null==t&&(t=this.getBrush(mi.Firebrick)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"FloralWhite",{get:function(){var t=null;return this.sBrushes.containsKey(mi.FloralWhite)&&(t=this.sBrushes.getValue(mi.FloralWhite)),null==t&&(t=this.getBrush(mi.FloralWhite)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"ForestGreen",{get:function(){var t=null;return this.sBrushes.containsKey(mi.ForestGreen)&&(t=this.sBrushes.getValue(mi.ForestGreen)),null==t&&(t=this.getBrush(mi.ForestGreen)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Fuchsia",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Fuchsia)&&(t=this.sBrushes.getValue(mi.Fuchsia)),null==t&&(t=this.getBrush(mi.Fuchsia)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Gainsboro",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Gainsboro)&&(t=this.sBrushes.getValue(mi.Gainsboro)),null==t&&(t=this.getBrush(mi.Gainsboro)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"GhostWhite",{get:function(){var t=null;return this.sBrushes.containsKey(mi.GhostWhite)&&(t=this.sBrushes.getValue(mi.GhostWhite)),null==t&&(t=this.getBrush(mi.GhostWhite)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Gold",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Gold)&&(t=this.sBrushes.getValue(mi.Gold)),null==t&&(t=this.getBrush(mi.Gold)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Goldenrod",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Goldenrod)&&(t=this.sBrushes.getValue(mi.Goldenrod)),null==t&&(t=this.getBrush(mi.Goldenrod)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Gray",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Gray)&&(t=this.sBrushes.getValue(mi.Gray)),null==t&&(t=this.getBrush(mi.Gray)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Green",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Green)&&(t=this.sBrushes.getValue(mi.Green)),null==t&&(t=this.getBrush(mi.Green)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"GreenYellow",{get:function(){var t=null;return this.sBrushes.containsKey(mi.GreenYellow)&&(t=this.sBrushes.getValue(mi.GreenYellow)),null==t&&(t=this.getBrush(mi.GreenYellow)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Honeydew",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Honeydew)&&(t=this.sBrushes.getValue(mi.Honeydew)),null==t&&(t=this.getBrush(mi.Honeydew)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"HotPink",{get:function(){var t=null;return this.sBrushes.containsKey(mi.HotPink)&&(t=this.sBrushes.getValue(mi.HotPink)),null==t&&(t=this.getBrush(mi.HotPink)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"IndianRed",{get:function(){var t=null;return this.sBrushes.containsKey(mi.IndianRed)&&(t=this.sBrushes.getValue(mi.IndianRed)),null==t&&(t=this.getBrush(mi.IndianRed)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Indigo",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Indigo)&&(t=this.sBrushes.getValue(mi.Indigo)),null==t&&(t=this.getBrush(mi.Indigo)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Ivory",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Ivory)&&(t=this.sBrushes.getValue(mi.Ivory)),null==t&&(t=this.getBrush(mi.Ivory)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Khaki",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Khaki)&&(t=this.sBrushes.getValue(mi.Khaki)),null==t&&(t=this.getBrush(mi.Khaki)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Lavender",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Lavender)&&(t=this.sBrushes.getValue(mi.Lavender)),null==t&&(t=this.getBrush(mi.Lavender)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"LavenderBlush",{get:function(){var t=null;return this.sBrushes.containsKey(mi.LavenderBlush)&&(t=this.sBrushes.getValue(mi.LavenderBlush)),null==t&&(t=this.getBrush(mi.LavenderBlush)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"LawnGreen",{get:function(){var t=null;return this.sBrushes.containsKey(mi.LawnGreen)&&(t=this.sBrushes.getValue(mi.LawnGreen)),null==t&&(t=this.getBrush(mi.LawnGreen)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"LemonChiffon",{get:function(){var t=null;return this.sBrushes.containsKey(mi.LemonChiffon)&&(t=this.sBrushes.getValue(mi.LemonChiffon)),null==t&&(t=this.getBrush(mi.LemonChiffon)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"LightBlue",{get:function(){var t=null;return this.sBrushes.containsKey(mi.LightBlue)&&(t=this.sBrushes.getValue(mi.LightBlue)),null==t&&(t=this.getBrush(mi.LightBlue)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"LightCoral",{get:function(){var t=null;return this.sBrushes.containsKey(mi.LightCoral)&&(t=this.sBrushes.getValue(mi.LightCoral)),null==t&&(t=this.getBrush(mi.LightCoral)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"LightCyan",{get:function(){var t=null;return this.sBrushes.containsKey(mi.LightCyan)&&(t=this.sBrushes.getValue(mi.LightCyan)),null==t&&(t=this.getBrush(mi.LightCyan)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"LightGoldenrodYellow",{get:function(){var t=null;return this.sBrushes.containsKey(mi.LightGoldenrodYellow)&&(t=this.sBrushes.getValue(mi.LightGoldenrodYellow)),null==t&&(t=this.getBrush(mi.LightGoldenrodYellow)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"LightGray",{get:function(){var t=null;return this.sBrushes.containsKey(mi.LightGray)&&(t=this.sBrushes.getValue(mi.LightGray)),null==t&&(t=this.getBrush(mi.LightGray)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"LightGreen",{get:function(){var t=null;return this.sBrushes.containsKey(mi.LightGreen)&&(t=this.sBrushes.getValue(mi.LightGreen)),null==t&&(t=this.getBrush(mi.LightGreen)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"LightPink",{get:function(){var t=null;return this.sBrushes.containsKey(mi.LightPink)&&(t=this.sBrushes.getValue(mi.LightPink)),null==t&&(t=this.getBrush(mi.LightPink)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"LightSalmon",{get:function(){var t=null;return this.sBrushes.containsKey(mi.LightSalmon)&&(t=this.sBrushes.getValue(mi.LightSalmon)),null==t&&(t=this.getBrush(mi.LightSalmon)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"LightSeaGreen",{get:function(){var t=null;return this.sBrushes.containsKey(mi.LightSeaGreen)&&(t=this.sBrushes.getValue(mi.LightSeaGreen)),null==t&&(t=this.getBrush(mi.LightSeaGreen)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"LightSkyBlue",{get:function(){var t=null;return this.sBrushes.containsKey(mi.LightSkyBlue)&&(t=this.sBrushes.getValue(mi.LightSkyBlue)),null==t&&(t=this.getBrush(mi.LightSkyBlue)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"LightSlateGray",{get:function(){var t=null;return this.sBrushes.containsKey(mi.LightSlateGray)&&(t=this.sBrushes.getValue(mi.LightSlateGray)),null==t&&(t=this.getBrush(mi.LightSlateGray)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"LightSteelBlue",{get:function(){var t=null;return this.sBrushes.containsKey(mi.LightSteelBlue)&&(t=this.sBrushes.getValue(mi.LightSteelBlue)),null==t&&(t=this.getBrush(mi.LightSteelBlue)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"LightYellow",{get:function(){var t=null;return this.sBrushes.containsKey(mi.LightYellow)&&(t=this.sBrushes.getValue(mi.LightYellow)),null==t&&(t=this.getBrush(mi.LightYellow)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Lime",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Lime)&&(t=this.sBrushes.getValue(mi.Lime)),null==t&&(t=this.getBrush(mi.Lime)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"LimeGreen",{get:function(){var t=null;return this.sBrushes.containsKey(mi.LimeGreen)&&(t=this.sBrushes.getValue(mi.LimeGreen)),null==t&&(t=this.getBrush(mi.LimeGreen)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Linen",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Linen)&&(t=this.sBrushes.getValue(mi.Linen)),null==t&&(t=this.getBrush(mi.Linen)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Magenta",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Magenta)&&(t=this.sBrushes.getValue(mi.Magenta)),null==t&&(t=this.getBrush(mi.Magenta)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Maroon",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Maroon)&&(t=this.sBrushes.getValue(mi.Maroon)),null==t&&(t=this.getBrush(mi.Maroon)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"MediumAquamarine",{get:function(){var t=null;return this.sBrushes.containsKey(mi.MediumAquamarine)&&(t=this.sBrushes.getValue(mi.MediumAquamarine)),null==t&&(t=this.getBrush(mi.MediumAquamarine)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"MediumBlue",{get:function(){var t=null;return this.sBrushes.containsKey(mi.MediumBlue)&&(t=this.sBrushes.getValue(mi.MediumBlue)),null==t&&(t=this.getBrush(mi.MediumBlue)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"MediumOrchid",{get:function(){var t=null;return this.sBrushes.containsKey(mi.MediumOrchid)&&(t=this.sBrushes.getValue(mi.MediumOrchid)),null==t&&(t=this.getBrush(mi.MediumOrchid)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"MediumPurple",{get:function(){var t=null;return this.sBrushes.containsKey(mi.MediumPurple)&&(t=this.sBrushes.getValue(mi.MediumPurple)),null==t&&(t=this.getBrush(mi.MediumPurple)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"MediumSeaGreen",{get:function(){var t=null;return this.sBrushes.containsKey(mi.MediumSeaGreen)&&(t=this.sBrushes.getValue(mi.MediumSeaGreen)),null==t&&(t=this.getBrush(mi.MediumSeaGreen)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"MediumSlateBlue",{get:function(){var t=null;return this.sBrushes.containsKey(mi.MediumSlateBlue)&&(t=this.sBrushes.getValue(mi.MediumSlateBlue)),null==t&&(t=this.getBrush(mi.MediumSlateBlue)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"MediumSpringGreen",{get:function(){var t=null;return this.sBrushes.containsKey(mi.MediumSpringGreen)&&(t=this.sBrushes.getValue(mi.MediumSpringGreen)),null==t&&(t=this.getBrush(mi.MediumSpringGreen)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"MediumTurquoise",{get:function(){var t=null;return this.sBrushes.containsKey(mi.MediumTurquoise)&&(t=this.sBrushes.getValue(mi.MediumTurquoise)),null==t&&(t=this.getBrush(mi.MediumTurquoise)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"MediumVioletRed",{get:function(){var t=null;return this.sBrushes.containsKey(mi.MediumVioletRed)&&(t=this.sBrushes.getValue(mi.MediumVioletRed)),null==t&&(t=this.getBrush(mi.MediumVioletRed)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"MidnightBlue",{get:function(){var t=null;return this.sBrushes.containsKey(mi.MidnightBlue)&&(t=this.sBrushes.getValue(mi.MidnightBlue)),null==t&&(t=this.getBrush(mi.MidnightBlue)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"MintCream",{get:function(){var t=null;return this.sBrushes.containsKey(mi.MintCream)&&(t=this.sBrushes.getValue(mi.MintCream)),null==t&&(t=this.getBrush(mi.MintCream)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"MistyRose",{get:function(){var t=null;return this.sBrushes.containsKey(mi.MistyRose)&&(t=this.sBrushes.getValue(mi.MistyRose)),null==t&&(t=this.getBrush(mi.MistyRose)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Moccasin",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Moccasin)&&(t=this.sBrushes.getValue(mi.Moccasin)),null==t&&(t=this.getBrush(mi.Moccasin)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"NavajoWhite",{get:function(){var t=null;return this.sBrushes.containsKey(mi.NavajoWhite)&&(t=this.sBrushes.getValue(mi.NavajoWhite)),null==t&&(t=this.getBrush(mi.NavajoWhite)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Navy",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Navy)&&(t=this.sBrushes.getValue(mi.Navy)),null==t&&(t=this.getBrush(mi.Navy)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"OldLace",{get:function(){var t=null;return this.sBrushes.containsKey(mi.OldLace)&&(t=this.sBrushes.getValue(mi.OldLace)),null==t&&(t=this.getBrush(mi.OldLace)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Olive",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Olive)&&(t=this.sBrushes.getValue(mi.Olive)),null==t&&(t=this.getBrush(mi.Olive)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"OliveDrab",{get:function(){var t=null;return this.sBrushes.containsKey(mi.OliveDrab)&&(t=this.sBrushes.getValue(mi.OliveDrab)),null==t&&(t=this.getBrush(mi.OliveDrab)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Orange",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Orange)&&(t=this.sBrushes.getValue(mi.Orange)),null==t&&(t=this.getBrush(mi.Orange)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"OrangeRed",{get:function(){var t=null;return this.sBrushes.containsKey(mi.OrangeRed)&&(t=this.sBrushes.getValue(mi.OrangeRed)),null==t&&(t=this.getBrush(mi.OrangeRed)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Orchid",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Orchid)&&(t=this.sBrushes.getValue(mi.Orchid)),null==t&&(t=this.getBrush(mi.Orchid)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"PaleGoldenrod",{get:function(){var t=null;return this.sBrushes.containsKey(mi.PaleGoldenrod)&&(t=this.sBrushes.getValue(mi.PaleGoldenrod)),null==t&&(t=this.getBrush(mi.PaleGoldenrod)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"PaleGreen",{get:function(){var t=null;return this.sBrushes.containsKey(mi.PaleGreen)&&(t=this.sBrushes.getValue(mi.PaleGreen)),null==t&&(t=this.getBrush(mi.PaleGreen)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"PaleTurquoise",{get:function(){var t=null;return this.sBrushes.containsKey(mi.PaleTurquoise)&&(t=this.sBrushes.getValue(mi.PaleTurquoise)),null==t&&(t=this.getBrush(mi.PaleTurquoise)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"PaleVioletRed",{get:function(){var t=null;return this.sBrushes.containsKey(mi.PaleVioletRed)&&(t=this.sBrushes.getValue(mi.PaleVioletRed)),null==t&&(t=this.getBrush(mi.PaleVioletRed)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"PapayaWhip",{get:function(){var t=null;return this.sBrushes.containsKey(mi.PapayaWhip)&&(t=this.sBrushes.getValue(mi.PapayaWhip)),null==t&&(t=this.getBrush(mi.PapayaWhip)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"PeachPuff",{get:function(){var t=null;return this.sBrushes.containsKey(mi.PeachPuff)&&(t=this.sBrushes.getValue(mi.PeachPuff)),null==t&&(t=this.getBrush(mi.PeachPuff)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Peru",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Peru)&&(t=this.sBrushes.getValue(mi.Peru)),null==t&&(t=this.getBrush(mi.Peru)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Pink",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Pink)&&(t=this.sBrushes.getValue(mi.Pink)),null==t&&(t=this.getBrush(mi.Pink)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Plum",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Plum)&&(t=this.sBrushes.getValue(mi.Plum)),null==t&&(t=this.getBrush(mi.Plum)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"PowderBlue",{get:function(){var t=null;return this.sBrushes.containsKey(mi.PowderBlue)&&(t=this.sBrushes.getValue(mi.PowderBlue)),null==t&&(t=this.getBrush(mi.PowderBlue)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Purple",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Purple)&&(t=this.sBrushes.getValue(mi.Purple)),null==t&&(t=this.getBrush(mi.Purple)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Red",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Red)&&(t=this.sBrushes.getValue(mi.Red)),null==t&&(t=this.getBrush(mi.Red)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"RosyBrown",{get:function(){var t=null;return this.sBrushes.containsKey(mi.RosyBrown)&&(t=this.sBrushes.getValue(mi.RosyBrown)),null==t&&(t=this.getBrush(mi.RosyBrown)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"RoyalBlue",{get:function(){var t=null;return this.sBrushes.containsKey(mi.RoyalBlue)&&(t=this.sBrushes.getValue(mi.RoyalBlue)),null==t&&(t=this.getBrush(mi.RoyalBlue)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"SaddleBrown",{get:function(){var t=null;return this.sBrushes.containsKey(mi.SaddleBrown)&&(t=this.sBrushes.getValue(mi.SaddleBrown)),null==t&&(t=this.getBrush(mi.SaddleBrown)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Salmon",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Salmon)&&(t=this.sBrushes.getValue(mi.Salmon)),null==t&&(t=this.getBrush(mi.Salmon)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"SandyBrown",{get:function(){var t=null;return this.sBrushes.containsKey(mi.SandyBrown)&&(t=this.sBrushes.getValue(mi.SandyBrown)),null==t&&(t=this.getBrush(mi.SandyBrown)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"SeaGreen",{get:function(){var t=null;return this.sBrushes.containsKey(mi.SeaGreen)&&(t=this.sBrushes.getValue(mi.SeaGreen)),null==t&&(t=this.getBrush(mi.SeaGreen)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"SeaShell",{get:function(){var t=null;return this.sBrushes.containsKey(mi.SeaShell)&&(t=this.sBrushes.getValue(mi.SeaShell)),null==t&&(t=this.getBrush(mi.SeaShell)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Sienna",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Sienna)&&(t=this.sBrushes.getValue(mi.Sienna)),null==t&&(t=this.getBrush(mi.Sienna)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Silver",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Silver)&&(t=this.sBrushes.getValue(mi.Silver)),null==t&&(t=this.getBrush(mi.Silver)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"SkyBlue",{get:function(){var t=null;return this.sBrushes.containsKey(mi.SkyBlue)&&(t=this.sBrushes.getValue(mi.SkyBlue)),null==t&&(t=this.getBrush(mi.SkyBlue)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"SlateBlue",{get:function(){var t=null;return this.sBrushes.containsKey(mi.SlateBlue)&&(t=this.sBrushes.getValue(mi.SlateBlue)),null==t&&(t=this.getBrush(mi.SlateBlue)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"SlateGray",{get:function(){var t=null;return this.sBrushes.containsKey(mi.SlateGray)&&(t=this.sBrushes.getValue(mi.SlateGray)),null==t&&(t=this.getBrush(mi.SlateGray)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Snow",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Snow)&&(t=this.sBrushes.getValue(mi.Snow)),null==t&&(t=this.getBrush(mi.Snow)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"SpringGreen",{get:function(){var t=null;return this.sBrushes.containsKey(mi.SpringGreen)&&(t=this.sBrushes.getValue(mi.SpringGreen)),null==t&&(t=this.getBrush(mi.SpringGreen)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"SteelBlue",{get:function(){var t=null;return this.sBrushes.containsKey(mi.SteelBlue)&&(t=this.sBrushes.getValue(mi.SteelBlue)),null==t&&(t=this.getBrush(mi.SteelBlue)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Tan",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Tan)&&(t=this.sBrushes.getValue(mi.Tan)),null==t&&(t=this.getBrush(mi.Tan)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Teal",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Teal)&&(t=this.sBrushes.getValue(mi.Teal)),null==t&&(t=this.getBrush(mi.Teal)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Thistle",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Thistle)&&(t=this.sBrushes.getValue(mi.Thistle)),null==t&&(t=this.getBrush(mi.Thistle)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Tomato",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Tomato)&&(t=this.sBrushes.getValue(mi.Tomato)),null==t&&(t=this.getBrush(mi.Tomato)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Transparent",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Transparent)&&(t=this.sBrushes.getValue(mi.Transparent)),null==t&&(t=this.getBrush(mi.Transparent)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Turquoise",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Turquoise)&&(t=this.sBrushes.getValue(mi.Turquoise)),null==t&&(t=this.getBrush(mi.Turquoise)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Violet",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Violet)&&(t=this.sBrushes.getValue(mi.Violet)),null==t&&(t=this.getBrush(mi.Violet)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Wheat",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Wheat)&&(t=this.sBrushes.getValue(mi.Wheat)),null==t&&(t=this.getBrush(mi.Wheat)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"White",{get:function(){var t=null;return this.sBrushes.containsKey(mi.White)&&(t=this.sBrushes.getValue(mi.White)),null==t&&(t=this.getBrush(mi.White)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"WhiteSmoke",{get:function(){var t=null;return this.sBrushes.containsKey(mi.WhiteSmoke)&&(t=this.sBrushes.getValue(mi.WhiteSmoke)),null==t&&(t=this.getBrush(mi.WhiteSmoke)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"Yellow",{get:function(){var t=null;return this.sBrushes.containsKey(mi.Yellow)&&(t=this.sBrushes.getValue(mi.Yellow)),null==t&&(t=this.getBrush(mi.Yellow)),t},enumerable:!0,configurable:!0}),Object.defineProperty(t,"YellowGreen",{get:function(){var t=null;return this.sBrushes.containsKey(mi.YellowGreen)&&(t=this.sBrushes.getValue(mi.YellowGreen)),null==t&&(t=this.getBrush(mi.YellowGreen)),t},enumerable:!0,configurable:!0}),t.getBrush=function(t){var e=this.getColorValue(t),i=new M(e);return this.sBrushes.setValue(t,i),i},t.getColorValue=function(t){var e=new L;switch(t){case mi.Transparent:e=new L(0,255,255,255);break;case mi.AliceBlue:e=new L(255,240,248,255);break;case mi.AntiqueWhite:e=new L(255,250,235,215);break;case mi.Aqua:e=new L(255,0,255,255);break;case mi.Aquamarine:e=new L(255,127,255,212);break;case mi.Azure:e=new L(255,240,255,255);break;case mi.Beige:e=new L(255,245,245,220);break;case mi.Bisque:e=new L(255,255,228,196);break;case mi.Black:e=new L(255,0,0,0);break;case mi.BlanchedAlmond:e=new L(255,255,235,205);break;case mi.Blue:e=new L(255,0,0,255);break;case mi.BlueViolet:e=new L(255,138,43,226);break;case mi.Brown:e=new L(255,165,42,42);break;case mi.BurlyWood:e=new L(255,222,184,135);break;case mi.CadetBlue:e=new L(255,95,158,160);break;case mi.Chartreuse:e=new L(255,127,255,0);break;case mi.Chocolate:e=new L(255,210,105,30);break;case mi.Coral:e=new L(255,255,127,80);break;case mi.CornflowerBlue:e=new L(255,100,149,237);break;case mi.Cornsilk:e=new L(255,255,248,220);break;case mi.Crimson:e=new L(255,220,20,60);break;case mi.Cyan:e=new L(255,0,255,255);break;case mi.DarkBlue:e=new L(255,0,0,139);break;case mi.DarkCyan:e=new L(255,0,139,139);break;case mi.DarkGoldenrod:e=new L(255,184,134,11);break;case mi.DarkGray:e=new L(255,169,169,169);break;case mi.DarkGreen:e=new L(255,0,100,0);break;case mi.DarkKhaki:e=new L(255,189,183,107);break;case mi.DarkMagenta:e=new L(255,139,0,139);break;case mi.DarkOliveGreen:e=new L(255,85,107,47);break;case mi.DarkOrange:e=new L(255,255,140,0);break;case mi.DarkOrchid:e=new L(255,153,50,204);break;case mi.DarkRed:e=new L(255,139,0,0);break;case mi.DarkSalmon:e=new L(255,233,150,122);break;case mi.DarkSeaGreen:e=new L(255,143,188,139);break;case mi.DarkSlateBlue:e=new L(255,72,61,139);break;case mi.DarkSlateGray:e=new L(255,47,79,79);break;case mi.DarkTurquoise:e=new L(255,0,206,209);break;case mi.DarkViolet:e=new L(255,148,0,211);break;case mi.DeepPink:e=new L(255,255,20,147);break;case mi.DeepSkyBlue:e=new L(255,0,191,255);break;case mi.DimGray:e=new L(255,105,105,105);break;case mi.DodgerBlue:e=new L(255,30,144,255);break;case mi.Firebrick:e=new L(255,178,34,34);break;case mi.FloralWhite:e=new L(255,255,250,240);break;case mi.ForestGreen:e=new L(255,34,139,34);break;case mi.Fuchsia:e=new L(255,255,0,255);break;case mi.Gainsboro:e=new L(255,220,220,220);break;case mi.GhostWhite:e=new L(255,248,248,255);break;case mi.Gold:e=new L(255,255,215,0);break;case mi.Goldenrod:e=new L(255,218,165,32);break;case mi.Gray:e=new L(255,128,128,128);break;case mi.Green:e=new L(255,0,128,0);break;case mi.GreenYellow:e=new L(255,173,255,47);break;case mi.Honeydew:e=new L(255,240,255,240);break;case mi.HotPink:e=new L(255,255,105,180);break;case mi.IndianRed:e=new L(255,205,92,92);break;case mi.Indigo:e=new L(255,75,0,130);break;case mi.Ivory:e=new L(255,255,255,240);break;case mi.Khaki:e=new L(255,240,230,140);break;case mi.Lavender:e=new L(255,230,230,250);break;case mi.LavenderBlush:e=new L(255,255,240,245);break;case mi.LawnGreen:e=new L(255,124,252,0);break;case mi.LemonChiffon:e=new L(255,255,250,205);break;case mi.LightBlue:e=new L(255,173,216,230);break;case mi.LightCoral:e=new L(255,240,128,128);break;case mi.LightCyan:e=new L(255,224,255,255);break;case mi.LightGoldenrodYellow:e=new L(255,250,250,210);break;case mi.LightGreen:e=new L(255,144,238,144);break;case mi.LightGray:e=new L(255,211,211,211);break;case mi.LightPink:e=new L(255,255,182,193);break;case mi.LightSalmon:e=new L(255,255,160,122);break;case mi.LightSeaGreen:e=new L(255,32,178,170);break;case mi.LightSkyBlue:e=new L(255,135,206,250);break;case mi.LightSlateGray:e=new L(255,119,136,153);break;case mi.LightSteelBlue:e=new L(255,176,196,222);break;case mi.LightYellow:e=new L(255,255,255,224);break;case mi.Lime:e=new L(255,0,255,0);break;case mi.LimeGreen:e=new L(255,50,205,50);break;case mi.Linen:e=new L(255,250,240,230);break;case mi.Magenta:e=new L(255,255,0,255);break;case mi.Maroon:e=new L(255,128,0,0);break;case mi.MediumAquamarine:e=new L(255,102,205,170);break;case mi.MediumBlue:e=new L(255,0,0,205);break;case mi.MediumOrchid:e=new L(255,186,85,211);break;case mi.MediumPurple:e=new L(255,147,112,219);break;case mi.MediumSeaGreen:e=new L(255,60,179,113);break;case mi.MediumSlateBlue:e=new L(255,123,104,238);break;case mi.MediumSpringGreen:e=new L(255,0,250,154);break;case mi.MediumTurquoise:e=new L(255,72,209,204);break;case mi.MediumVioletRed:e=new L(255,199,21,133);break;case mi.MidnightBlue:e=new L(255,25,25,112);break;case mi.MintCream:e=new L(255,245,255,250);break;case mi.MistyRose:e=new L(255,255,228,225);break;case mi.Moccasin:e=new L(255,255,228,181);break;case mi.NavajoWhite:e=new L(255,255,222,173);break;case mi.Navy:e=new L(255,0,0,128);break;case mi.OldLace:e=new L(255,253,245,230);break;case mi.Olive:e=new L(255,128,128,0);break;case mi.OliveDrab:e=new L(255,107,142,35);break;case mi.Orange:e=new L(255,255,165,0);break;case mi.OrangeRed:e=new L(255,255,69,0);break;case mi.Orchid:e=new L(255,218,112,214);break;case mi.PaleGoldenrod:e=new L(255,238,232,170);break;case mi.PaleGreen:e=new L(255,152,251,152);break;case mi.PaleTurquoise:e=new L(255,175,238,238);break;case mi.PaleVioletRed:e=new L(255,219,112,147);break;case mi.PapayaWhip:e=new L(255,255,239,213);break;case mi.PeachPuff:e=new L(255,255,218,185);break;case mi.Peru:e=new L(255,205,133,63);break;case mi.Pink:e=new L(255,255,192,203);break;case mi.Plum:e=new L(255,221,160,221);break;case mi.PowderBlue:e=new L(255,176,224,230);break;case mi.Purple:e=new L(255,128,0,128);break;case mi.Red:e=new L(255,255,0,0);break;case mi.RosyBrown:e=new L(255,188,143,143);break;case mi.RoyalBlue:e=new L(255,65,105,225);break;case mi.SaddleBrown:e=new L(255,139,69,19);break;case mi.Salmon:e=new L(255,250,128,114);break;case mi.SandyBrown:e=new L(255,244,164,96);break;case mi.SeaGreen:e=new L(255,46,139,87);break;case mi.SeaShell:e=new L(255,255,245,238);break;case mi.Sienna:e=new L(255,160,82,45);break;case mi.Silver:e=new L(255,192,192,192);break;case mi.SkyBlue:e=new L(255,135,206,235);break;case mi.SlateBlue:e=new L(255,106,90,205);break;case mi.SlateGray:e=new L(255,112,128,144);break;case mi.Snow:e=new L(255,255,250,250);break;case mi.SpringGreen:e=new L(255,0,255,127);break;case mi.SteelBlue:e=new L(255,70,130,180);break;case mi.Tan:e=new L(255,210,180,140);break;case mi.Teal:e=new L(255,0,128,128);break;case mi.Thistle:e=new L(255,216,191,216);break;case mi.Tomato:e=new L(255,255,99,71);break;case mi.Turquoise:e=new L(255,64,224,208);break;case mi.Violet:e=new L(255,238,130,238);break;case mi.Wheat:e=new L(255,245,222,179);break;case mi.White:e=new L(255,255,255,255);break;case mi.WhiteSmoke:e=new L(255,245,245,245);break;case mi.Yellow:e=new L(255,255,255,0);break;case mi.YellowGreen:e=new L(255,154,205,50)}return e},t.sBrushes=new n,t}(),bi=function(){function e(t){this.precision=1e3}return Object.defineProperty(e.prototype,"factors",{get:function(){return this.mFactors},set:function(t){if(null==t)throw new Error("ArgumentNullException : Factors");this.mFactors=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"positions",{get:function(){return this.mPositions},set:function(t){for(var e=t,i=0;i<e.length;i++)(e[i]<0||e[i]>1)&&(e[i]=0);this.mPositions=e,this.mPositions=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"count",{get:function(){return this.mCount},enumerable:!0,configurable:!0}),e.prototype.generateColorBlend=function(t,e){if(null==t)throw new Error("ArgumentNullException : colours");null==this.positions&&(this.positions=[0]);var i=new Pi(this.count),r=this.positions,n=null;if(1===r.length)(r=[3])[0]=0,r[1]=this.positions[0],r[2]=1,(n=new Array(3))[0]=t[0],n[1]=t[0],n[2]=t[1];else{var o=t[0],s=t[1];n=new Array(this.count);var a=0,h=this.count;for(a=0;a<h;++a)n[a]=this.interpolate(this.mFactors[a],o,s,e)}return i.positions=r,i.colors=n,i},e.prototype.clonePdfBlend=function(){return null!=this.mFactors&&(this.factors=this.mFactors),null!=this.positions&&(this.positions=this.positions),this},e.prototype.gcd=function(t,e){if("number"==typeof t&&"number"==typeof e&&void 0!==e){if(t<0||t>1)throw new Error("ArgumentOutOfRangeException : u");if(e<0||e>1)throw new Error("ArgumentOutOfRangeException : v");var i=Math.max(1,t*this.precision),r=Math.max(1,e*this.precision);return this.gcdInt(i,r)/this.precision}var n=t;if(null==n)throw new Error("ArgumentNullException : values");if(n.length<1)throw new Error("ArgumentException : Not enough values in the array. - values");var o=n[0];if(n.length>1)for(var s=n.length,a=1;a<s&&(o=this.gcd(n[a],o))!==1/this.precision;++a);return o},e.prototype.gcdInt=function(t,e){if(t<=0)throw new Error("ArgumentOutOfRangeException"+t+"The arguments cannot be less or equal to zero.");if(e<=0)throw new Error("ArgumentOutOfRangeException"+e+"The arguments cannot be less or equal to zero.");if(1===t||1===e)return 1;for(var i=0;this.isEven(t,e);)++i,t>>=1,e>>=1;for(;(1&t)<=0;)t>>=1;do{for(;(1&e)<=0;)e>>=1;if(t>e){var r=e;e=t,t=r}e-=t}while(0!==e);return t<<i},e.prototype.isEven=function(t,e){if("number"==typeof e&&void 0!==e){var i=!0;return i=i&&(1&t)<=0,i=i&&(1&e)<=0}return(1&t)<=0},e.prototype.interpolate=function(e,i,r,n){if(i instanceof L){var o=new L;switch(n){case t.PdfColorSpace.Rgb:var s=this.interpolate(e,i.red,r.red),a=this.interpolate(e,i.green,r.green),h=this.interpolate(e,i.blue,r.blue);o=new L(s,a,h);break;case t.PdfColorSpace.GrayScale:var l=this.interpolate(e,i.gray,r.gray);o=new L(l);break;case t.PdfColorSpace.Cmyk:var u=this.interpolate(e,i.c,r.c),c=this.interpolate(e,i.m,r.m),p=this.interpolate(e,i.y,r.y),d=this.interpolate(e,i.k,r.k);o=new L(u,c,p,d)}return o}return 0===e?i:1===e?r:i+(r-i)/1*(e-0)},e}(),wi=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Pi=function(e){function i(t){var i=e.call(this)||this;return"number"==typeof t&&(i=e.call(this,t)||this),i}return wi(i,e),Object.defineProperty(i.prototype,"colors",{get:function(){return this.mcolors},set:function(t){if(null==t)throw new Error("ArgumentNullException : Colors");this.mcolors=t},enumerable:!0,configurable:!0}),i.prototype.getFunction=function(t){var e=this.getColorComponentsCount(t),i=this.getMaxComponentValue(t),r=this.setRange(e,i),n=null;if(null==this.mbrush&&void 0===this.mbrush){var o=[1],s=void 0,a=1;if(2===this.positions.length)s=2;else{var h=this.positions,l=this.getIntervals(h),u=this.gcd(l);a=u,s=1/u+1}o[0]=s;var c=this.getSamplesValues(t,s,i,a);return n=new di([0,1],r,o,c)}return n},i.prototype.cloneColorBlend=function(){return null!=this.mcolors&&void 0!==this.mcolors&&(this.colors=this.mcolors),null!=this.positions&&void 0!==this.positions&&(this.positions=this.positions),this},i.prototype.setRange=function(t,e){for(var i=[2*t],r=0;r<t;++r)i[2*r]=0,i[2*r+1]=1;return i},i.prototype.getColorComponentsCount=function(e){var i=0;switch(e){case t.PdfColorSpace.Rgb:i=3;break;case t.PdfColorSpace.Cmyk:i=4;break;case t.PdfColorSpace.GrayScale:i=1;break;default:throw new Error("ArgumentException - Unsupported color space: "+e+" colorSpace")}return i},i.prototype.getSamplesValues=function(e,i,r,n){var o;switch(e){case t.PdfColorSpace.GrayScale:o=this.getGrayscaleSamples(i,r,n);break;case t.PdfColorSpace.Cmyk:o=this.getCmykSamples(i,r,n);break;case t.PdfColorSpace.Rgb:o=this.getRgbSamples(i,r,n);break;default:throw new Error("ArgumentException - Unsupported color space: "+e+" colorSpace")}return o},i.prototype.getGrayscaleSamples=function(e,i,r){for(var n=[2*e],o=0;o<e;++o)this.getNextColor(o,r,t.PdfColorSpace.GrayScale);return n},i.prototype.getRgbSamples=function(e,i,r){for(var n=[3*e],o=0;o<e;++o){var s=this.getNextColor(o,r,t.PdfColorSpace.Rgb),a=3*o;n[a]=s.r,n[a+1]=s.g,n[a+2]=s.b}return n},i.prototype.getCmykSamples=function(e,i,r){for(var n=[4*e],o=0;o<e;o++){var s=this.getNextColor(o,r,t.PdfColorSpace.Cmyk),a=4*o;n[a]=s.c*i,n[a+1]=s.m*i,n[a+2]=s.y*i,n[a+3]=s.k*i}return n},i.prototype.getNextColor=function(t,e,i){var r,n,o,s=e*t,a=this.getIndices(s,n,r);if((n=a.indexLow)===(r=a.indexHi))o=this.mcolors[n];else{var h=this.positions[n],l=this.positions[r],u=this.mcolors[n],c=this.mcolors[r],p=(s-h)/(l-h);o=this.interpolate(p,u,c,i)}return o},i.prototype.getIndices=function(t,e,i){var r=this.positions;e=0,i=0;for(var n=0;n<this.mcolors.length;++n){var o=r[n];if(o===t){i=n,e=n;break}if(o>t){i=n;break}e=n,i=n}return{indexLow:e,indexHi:i}},i.prototype.getMaxComponentValue=function(e){var i=0;switch(e){case t.PdfColorSpace.Cmyk:case t.PdfColorSpace.Rgb:i=255;break;case t.PdfColorSpace.GrayScale:i=65535;break;default:throw new Error("ArgumentException - Unsupported color space: "+e+"colorSpace")}return i},i.prototype.getIntervals=function(t){for(var e=t.length,i=[e-1],r=t[0],n=1;n<e;++n){var o=t[n];i[n-1]=o-r,r=o}return i},i}(bi),Si=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),vi=function(e){function i(t,i,r,n){var o=e.call(this,new h)||this;if(o.mDictionaryProperties=new a,t instanceof T&&i instanceof T&&r instanceof L&&n instanceof L)o.initialize(r,n),o.mPointStart=t,o.mPointEnd=i,o.setPoints(o.mPointStart,o.mPointEnd);else if(t instanceof V)if(o.initialize(i,r),n===fi.BackwardDiagonal||n===fi.ForwardDiagonal||n===fi.Horizontal||n===fi.Vertical){switch(o.mBoundaries=t,n){case fi.BackwardDiagonal:o.mPointStart=new T(t.right,t.top),o.mPointEnd=new T(t.left,t.bottom);break;case fi.ForwardDiagonal:o.mPointStart=new T(t.left,t.top),o.mPointEnd=new T(t.right,t.bottom);break;case fi.Horizontal:o.mPointStart=new T(t.left,t.top),o.mPointEnd=new T(t.right,t.top);break;case fi.Vertical:o.mPointStart=new T(t.left,t.top),o.mPointEnd=new T(t.left,t.bottom);break;default:throw new Error("ArgumentException -- Unsupported linear gradient mode: "+n+" mode")}o.setPoints(o.mPointStart,o.mPointEnd)}else if("number"==typeof n&&void 0!==n){if(o.mBoundaries=t,0===(n%=360))o.mPointStart=new T(t.left,t.top),o.mPointEnd=new T(t.right,t.top);else if(90===n)o.mPointStart=new T(t.left,t.top),o.mPointEnd=new T(t.left,t.bottom);else if(180===n)o.mPointEnd=new T(t.left,t.top),o.mPointStart=new T(t.right,t.top);else if(270===n)o.mPointEnd=new T(t.left,t.top),o.mPointStart=new T(t.left,t.bottom);else{var s=n*(Math.PI/180),l=Math.tan(s),u=o.mBoundaries.left+(o.mBoundaries.right-o.mBoundaries.left)/2,c=o.mBoundaries.top+(o.mBoundaries.bottom-o.mBoundaries.top)/2,p=new T(u,c);c=l*(u=o.mBoundaries.width/(2*Math.cos(s))),u+=p.x,c+=p.y;var d=new T(u,c),f=o.subPoints(d,p),g=o.choosePoint(n),m=o.mulPoints(o.subPoints(g,p),f)/o.mulPoints(f,f);o.mPointEnd=o.addPoints(p,o.mulPoint(f,m)),o.mPointStart=o.addPoints(p,o.mulPoint(f,-1*m))}o.setPoints(o.mPointEnd,o.mPointStart)}return o}return Si(i,e),i.prototype.initialize=function(t,e){this.mColours=[t,e],this.mColourBlend=new Pi(2),this.mColourBlend.positions=[0,1],this.mColourBlend.colors=this.mColours,this.initShading()},Object.defineProperty(i.prototype,"blend",{get:function(){return this.mBlend},set:function(t){if(null==t)throw new Error("ArgumentNullException : Blend");if(null==this.mColours)throw new Error("NotSupportedException : There is no starting and ending colours specified.");this.mBlend=t,this.mColourBlend=this.mBlend.generateColorBlend(this.mColours,this.colorSpace),this.resetFunction()},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"interpolationColors",{get:function(){return this.mColourBlend},set:function(t){if(null==t)throw new Error("ArgumentNullException : InterpolationColors");this.mBlend=null,this.mColours=null,this.mColourBlend=t,this.resetFunction()},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"linearColors",{get:function(){return this.mColours},set:function(t){if(null==t)throw new Error("ArgumentNullException : LinearColors");if(t.length<2)throw new Error("ArgumentException : The array is too small - LinearColors");null==this.mColours&&void 0===this.mColours?this.mColours=[t[0],t[1]]:(this.mColours[0]=t[0],this.mColours[1]=t[1]),null==this.mBlend&&void 0===this.mBlend?(this.mColourBlend=new Pi(2),this.mColourBlend.colors=this.mColours,this.mColourBlend.positions=[0,1]):this.mColourBlend=this.mBlend.generateColorBlend(this.mColours,this.colorSpace),this.resetFunction()},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"rectangle",{get:function(){return this.mBoundaries},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"extend",{get:function(){var t=li.None,e=this.shading.items.getValue(this.mDictionaryProperties.extend);if(null!=e){var i=e.items(0),r=e.items(1);i.value&&(t|=li.Start),r.value&&(t|=li.End)}return t},set:function(t){var e,i,r=this.shading.items.getValue(this.mDictionaryProperties.extend);null==r?(e=new ct(!1),i=new ct(!1),(r=new m).add(e),r.add(i),this.shading.items.setValue(this.mDictionaryProperties.extend,r)):(e=r.items(0),i=r.items(1))},enumerable:!0,configurable:!0}),i.prototype.addPoints=function(t,e){var i=t.x+e.x,r=t.y+e.y;return new T(i,r)},i.prototype.subPoints=function(t,e){var i=t.x-e.x,r=t.y-e.y;return new T(i,r)},i.prototype.mulPoints=function(t,e){return t.x*e.x+t.y*e.y},i.prototype.mulPoint=function(t,e){return t.x=t.x*e,t.y=t.y*e,t},i.prototype.choosePoint=function(t){var e=new T(0,0);if(t<90&&t>0)e=new T(this.mBoundaries.right,this.mBoundaries.bottom);else if(t<180&&t>90)e=new T(this.mBoundaries.left,this.mBoundaries.bottom);else if(t<270&&t>180)e=new T(this.mBoundaries.left,this.mBoundaries.top);else{if(!(t>270))throw new Error("PdfException - Internal error.");e=new T(this.mBoundaries.right,this.mBoundaries.top)}return e},i.prototype.setPoints=function(t,e){var i=new m;i.add(new g(t.x)),i.add(new g(this.updateY(t.y))),i.add(new g(e.x)),i.add(new g(this.updateY(e.y))),this.shading.items.setValue(this.mDictionaryProperties.coords,i)},i.prototype.updateY=function(t){return 0!==t?-t:t},i.prototype.initShading=function(){this.colorSpace=t.PdfColorSpace.Rgb,this.function=this.mColourBlend.getFunction(this.colorSpace),this.shading.items.setValue(this.mDictionaryProperties.shadingType,new g(gi.Axial))},i.prototype.clone=function(){return this.resetPatternDictionary(new h(this.patternDictionary)),this.shading=new h,this.initShading(),this.setPoints(this.mPointStart,this.mPointEnd),null!==this&&this instanceof i&&null!=this.matrix&&void 0!==this.matrix&&(this.matrix=this.matrix.clone()),null!=this.mColours&&void 0!==this.mColours&&(this.mColours=this.mColours),null!=this.blend&&void 0!==this.blend?this.blend=this.blend.clonePdfBlend():null!=this.interpolationColors&&void 0!==this.interpolationColors&&(this.interpolationColors=this.interpolationColors.cloneColorBlend()),this.extend=this.extend,this.cloneBackgroundValue(this),this.cloneAntiAliasingValue(this),this},i.prototype.resetFunction=function(){this.function=this.mColourBlend.getFunction(this.colorSpace)},i}(qt),Ci=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Bi=function(e){function i(t,i,r,n,o,s){var l=e.call(this,new h)||this;if(l.mDictionaryProperties=new a,l.initialize(o,s),i<0)throw new Error("ArgumentOutOfRangeException : radiusStart - The radius cannot be less then zero.");if(n<0)throw new Error("ArgumentOutOfRangeException : radiusEnd - The radius cannpt be less then zero.");return l.mPointEnd=r,l.mPointStart=t,l.mRadiusStart=i,l.mRadiusEnd=n,l.setPoints(l.mPointStart,l.mPointEnd,l.mRadiusStart,l.mRadiusEnd),l}return Ci(i,e),i.prototype.initialize=function(t,e){this.mColour=[t,e],this.mColourBlends=new Pi(2),this.mColourBlends.positions=[0,1],this.mColourBlends.colors=this.mColour,this.initShading()},Object.defineProperty(i.prototype,"blend",{get:function(){return this.mBlend},set:function(t){if(null==t)throw new Error("ArgumentNullException : Blend");if(null==this.mColour&&void 0===this.mColour)throw new Error("NotSupportedException : There is no starting and ending colours specified.");this.mBlend=t,this.mColourBlends=this.mBlend.generateColorBlend(this.mColour,this.colorSpace),this.resetFunction()},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"interpolationColors",{get:function(){return this.mColourBlends},set:function(t){if(null==t)throw new Error("ArgumentNullException : InterpolationColors");this.mBlend=null,this.mColour=null,this.mColourBlends=t,this.resetFunction()},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"linearColors",{get:function(){return this.mColour},set:function(t){if(null==t)throw new Error("ArgumentNullException : radial LinearColors");if(t.length<2)throw new Error("ArgumentException : The array is too small LinearColors");null==this.mColour&&void 0===this.mColour?this.mColour=[t[0],t[1]]:(this.mColour[0]=t[0],this.mColour[1]=t[1]),null==this.mBlend&&void 0===this.mBlend?(this.mColourBlends=new Pi(2),this.mColourBlends.colors=this.mColour,this.mColourBlends.positions=[0,1]):this.mColourBlends=this.mBlend.generateColorBlend(this.mColour,this.colorSpace),this.resetFunction()},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"rectangle",{get:function(){return this.mBoundaries},set:function(t){this.mBoundaries=t,this.bBox=m.fromRectangle(t)},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"extend",{get:function(){var t=li.None,e=this.shading.items.getValue(this.mDictionaryProperties.extend);if(null!==e&&void 0!==e){var i=e.items(0),r=e.items(1);i.value&&(t|=li.Start),r.value&&(t|=li.End)}return t},set:function(t){var e,i,r=this.shading.items.getValue(this.mDictionaryProperties.extend);null==r&&void 0===r?(e=new ct(!1),i=new ct(!1),(r=new m).add(e),r.add(i),this.shading.items.setValue(this.mDictionaryProperties.extend,r)):(e=r.items(0),i=r.items(1))},enumerable:!0,configurable:!0}),i.prototype.setPoints=function(t,e,i,r){var n=new m;n.add(new g(t.x)),n.add(new g(this.updateY(t.y))),n.add(new g(i)),n.add(new g(e.x)),n.add(new g(this.updateY(e.y))),i!==r?n.add(new g(r)):n.add(new g(0)),this.shading.items.setValue(this.mDictionaryProperties.coords,n)},i.prototype.updateY=function(t){return 0!==t?-t:t},i.prototype.initShading=function(){this.colorSpace=t.PdfColorSpace.Rgb,this.function=this.mColourBlends.getFunction(this.colorSpace),this.shading.items.setValue(this.mDictionaryProperties.shadingType,new g(gi.Radial))},i.prototype.clone=function(){return this.resetPatternDictionary(new h(this.patternDictionary)),this.shading=new h,this.initShading(),this.setPoints(this.mPointStart,this.mPointEnd,this.mRadiusStart,this.mRadiusEnd),this instanceof i&&null!==this.matrix&&void 0!==this.matrix&&(this.matrix=this.matrix.clone()),null!==this.mColour&&void 0!==this.mColour&&(this.mColour=this.mColour),null!==this.blend&&void 0!==this.blend?this.blend=this.blend.clonePdfBlend():null!==this.interpolationColors&&void 0!==this.interpolationColors&&(this.interpolationColors=this.interpolationColors.cloneColorBlend()),this.extend=this.extend,this.cloneBackgroundValue(this),this.cloneAntiAliasingValue(this),this},i.prototype.resetFunction=function(){this.function=this.mColourBlends.getFunction(this.colorSpace)},i}(qt);!function(t){t[t.Overlap=0]="Overlap",t[t.Inside=1]="Inside"}(t.PdfBorderOverlapStyle||(t.PdfBorderOverlapStyle={}));var Oi=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),xi=function(){function t(){}return Object.defineProperty(t.prototype,"backgroundBrush",{get:function(){return this.gridBackgroundBrush},set:function(t){this.gridBackgroundBrush=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"textBrush",{get:function(){return this.gridTextBrush},set:function(t){this.gridTextBrush=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"textPen",{get:function(){return this.gridTextPen},set:function(t){this.gridTextPen=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"font",{get:function(){return this.gridFont},set:function(t){this.gridFont=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"backgroundImage",{get:function(){return this.gridBackgroundImage},set:function(t){this.gridBackgroundImage=t},enumerable:!0,configurable:!0}),t}(),Li=function(e){function i(){var i=e.call(this)||this;return i.gridBorderOverlapStyle=t.PdfBorderOverlapStyle.Overlap,i.bAllowHorizontalOverflow=!1,i.gridHorizontalOverflowType=t.PdfHorizontalOverflowType.LastPage,i}return Oi(i,e),Object.defineProperty(i.prototype,"cellSpacing",{get:function(){return void 0===this.gridCellSpacing&&(this.gridCellSpacing=0),this.gridCellSpacing},set:function(t){this.gridCellSpacing=t},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"horizontalOverflowType",{get:function(){return this.gridHorizontalOverflowType},set:function(t){this.gridHorizontalOverflowType=t},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"allowHorizontalOverflow",{get:function(){return this.bAllowHorizontalOverflow},set:function(t){this.bAllowHorizontalOverflow=t},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"cellPadding",{get:function(){return void 0===this.gridCellPadding&&(this.gridCellPadding=new Ee),this.gridCellPadding},set:function(t){void 0===this.gridCellPadding?(this.gridCellPadding=new Ee,this.gridCellPadding=t):this.gridCellPadding=t},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"borderOverlapStyle",{get:function(){return this.gridBorderOverlapStyle},set:function(t){this.gridBorderOverlapStyle=t},enumerable:!0,configurable:!0}),i}(xi),Ti=function(t){function e(){var e=t.call(this)||this;return e.gridCellBorders=Ie.default,e}return Oi(e,t),Object.defineProperty(e.prototype,"stringFormat",{get:function(){return this.format},set:function(t){this.format=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"borders",{get:function(){return this.gridCellBorders},set:function(t){this.gridCellBorders=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"cellPadding",{get:function(){return this.gridCellPadding},set:function(t){null!=this.gridCellPadding&&void 0!==this.gridCellPadding||(this.gridCellPadding=new Ee),this.gridCellPadding=t},enumerable:!0,configurable:!0}),e}(xi),ji=function(){function t(){}return Object.defineProperty(t.prototype,"backgroundBrush",{get:function(){return this.gridRowBackgroundBrush},enumerable:!0,configurable:!0}),t.prototype.setBackgroundBrush=function(t){if(this.gridRowBackgroundBrush=t,void 0!==this.parent)for(var e=0;e<this.parent.cells.count;e++)this.parent.cells.getCell(e).style.backgroundBrush=t},Object.defineProperty(t.prototype,"textBrush",{get:function(){return this.gridRowTextBrush},enumerable:!0,configurable:!0}),t.prototype.setTextBrush=function(t){if(this.gridRowTextBrush=t,void 0!==this.parent)for(var e=0;e<this.parent.cells.count;e++)this.parent.cells.getCell(e).style.textBrush=t},Object.defineProperty(t.prototype,"textPen",{get:function(){return this.gridRowTextPen},enumerable:!0,configurable:!0}),t.prototype.setTextPen=function(t){if(this.gridRowTextPen=t,void 0!==this.parent)for(var e=0;e<this.parent.cells.count;e++)this.parent.cells.getCell(e).style.textPen=t},Object.defineProperty(t.prototype,"font",{get:function(){return this.gridRowFont},enumerable:!0,configurable:!0}),t.prototype.setFont=function(t){if(this.gridRowFont=t,void 0!==this.parent)for(var e=0;e<this.parent.cells.count;e++)this.parent.cells.getCell(e).style.font=t},Object.defineProperty(t.prototype,"border",{get:function(){return void 0===this.gridRowBorder&&this.setBorder(new Ie),this.gridRowBorder},enumerable:!0,configurable:!0}),t.prototype.setBorder=function(t){if(this.gridRowBorder=t,void 0!==this.parent)for(var e=0;e<this.parent.cells.count;e++)this.parent.cells.getCell(e).style.borders=t},t.prototype.setParent=function(t){this.parent=t},Object.defineProperty(t.prototype,"backgroundImage",{get:function(){return this.gridRowBackgroundImage},enumerable:!0,configurable:!0}),t.prototype.setBackgroundImage=function(t){this.gridRowBackgroundImage=t},t}();!function(t){t[t.NextPage=0]="NextPage",t[t.LastPage=1]="LastPage"}(t.PdfHorizontalOverflowType||(t.PdfHorizontalOverflowType={}));var ki=function(){function e(t){this.cellWidth=0,this.cellHeight=0,this.tempval=0,this.fontSpilt=!1,this.finsh=!0,this.rowSpanRemainingHeight=0,this.hasRowSpan=!1,this.hasColSpan=!1,this.isFinish=!0,this.present=!1,this.gridRowSpan=1,this.colSpan=1,void 0!==t&&(this.gridRow=t)}return Object.defineProperty(e.prototype,"isCellMergeContinue",{get:function(){return this.internalIsCellMergeContinue},set:function(t){this.internalIsCellMergeContinue=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"isRowMergeContinue",{get:function(){return this.internalIsRowMergeContinue},set:function(t){this.internalIsRowMergeContinue=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"isCellMergeStart",{get:function(){return this.internalIsCellMergeStart},set:function(t){this.internalIsCellMergeStart=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"isRowMergeStart",{get:function(){return this.internalIsRowMergeStart},set:function(t){this.internalIsRowMergeStart=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"remainingString",{get:function(){return this.remaining},set:function(t){this.remaining=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"FinishedDrawingCell",{get:function(){return this.isFinish},set:function(t){this.isFinish=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"stringFormat",{get:function(){return null==this.format&&(this.format=new A),this.format},set:function(t){this.format=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"row",{get:function(){return this.gridRow},set:function(t){this.gridRow=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"value",{get:function(){return this.objectValue},set:function(t){if(this.objectValue=t,this.objectValue instanceof Ii){this.row.grid.isSingleGrid=!1;this.objectValue.ParentCell=this,this.objectValue.isChildGrid=!0;for(var e=this.row.grid.rows.count,i=0;i<e;i++)for(var r=this.row.grid.rows.getRow(i),n=r.cells.count,o=0;o<n;o++){r.cells.getCell(o).parent=this}}},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"rowSpan",{get:function(){return this.gridRowSpan},set:function(t){if(t<1)throw new Error("ArgumentException : Invalid span specified, must be greater than or equal to 1");this.gridRowSpan=t,this.row.rowSpanExists=!0,this.row.grid.hasRowSpanSpan=!0},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"style",{get:function(){return null==this.cellStyle&&(this.cellStyle=new Ti),this.cellStyle},set:function(t){this.cellStyle=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"height",{get:function(){return 0===this.cellHeight&&(this.cellHeight=this.measureHeight()),this.cellHeight},set:function(t){this.cellHeight=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"columnSpan",{get:function(){return this.colSpan},set:function(t){if(t<1)throw Error("Invalid span specified, must be greater than or equal to 1");this.colSpan=t,this.row.columnSpanExists=!0},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"width",{get:function(){return(0===this.cellWidth||this.row.grid.isComplete)&&(this.cellWidth=this.measureWidth()),Math.round(this.cellWidth)},set:function(t){this.cellWidth=t},enumerable:!0,configurable:!0}),e.prototype.measureWidth=function(){var t=0,e=new F;if("string"==typeof this.objectValue){t+=e.layout(this.objectValue,this.getTextFont(),this.stringFormat,new j(Number.MAX_VALUE,Number.MAX_VALUE),!1,new j(0,0)).actualSize.width,t+=2*(this.style.borders.left.width+this.style.borders.right.width)}else if(this.objectValue instanceof Ii)t=this.objectValue.size.width;else if(this.objectValue instanceof ft||this.objectValue instanceof mt)t+=this.objectValue.width;else if(this.objectValue instanceof Je){var i=this.objectValue;t+=e.layout(i.text,i.font,i.stringFormat,new j(0,0),!1,new j(0,0)).actualSize.width,t+=2*(this.style.borders.left.width+this.style.borders.right.width)}return this.objectValue instanceof Ii?null!=this.style.cellPadding||void 0!==this.style.cellPadding?(void 0!==this.style.cellPadding.left&&this.style.cellPadding.hasLeftPad&&(t+=this.style.cellPadding.left),void 0!==this.style.cellPadding.right&&this.style.cellPadding.hasRightPad&&(t+=this.style.cellPadding.right)):(void 0!==this.row.grid.style.cellPadding.left&&this.row.grid.style.cellPadding.hasLeftPad&&(t+=this.row.grid.style.cellPadding.left),void 0!==this.row.grid.style.cellPadding.right&&this.row.grid.style.cellPadding.hasRightPad&&(t+=this.row.grid.style.cellPadding.right)):null!=this.style.cellPadding?t+=this.style.cellPadding.left+this.style.cellPadding.right:t+=this.row.grid.style.cellPadding.left+this.row.grid.style.cellPadding.right,t+=this.row.grid.style.cellSpacing},e.prototype.drawCellBackground=function(t,e){var i=this.getBackgroundBrush();if(null!=i&&(t.save(),t.drawRectangle(i,e.x,e.y,e.width,e.height),t.restore()),null!=this.style.backgroundImage){this.getBackgroundImage();t.drawImage(this.style.backgroundImage,e.x,e.y,e.width,e.height)}},e.prototype.adjustContentLayoutArea=function(t){var e=new k(t.x,t.y,t.width,t.height);return this.objectValue instanceof Ii?(null==this.style.cellPadding||void 0===this.style.cellPadding?(void 0!==this.gridRow.grid.style.cellPadding.left&&this.gridRow.grid.style.cellPadding.hasLeftPad&&(e.x+=this.gridRow.grid.style.cellPadding.left+this.cellStyle.borders.left.width,e.width-=this.gridRow.grid.style.cellPadding.left),void 0!==this.gridRow.grid.style.cellPadding.top&&this.gridRow.grid.style.cellPadding.hasTopPad&&(e.y+=this.gridRow.grid.style.cellPadding.top+this.cellStyle.borders.top.width,e.height-=this.gridRow.grid.style.cellPadding.top),void 0!==this.gridRow.grid.style.cellPadding.right&&this.gridRow.grid.style.cellPadding.hasRightPad&&(e.width-=this.gridRow.grid.style.cellPadding.right),void 0!==this.gridRow.grid.style.cellPadding.bottom&&this.gridRow.grid.style.cellPadding.hasBottomPad&&(e.height-=this.gridRow.grid.style.cellPadding.bottom)):(void 0!==this.style.cellPadding.left&&this.style.cellPadding.hasLeftPad&&(e.x+=this.style.cellPadding.left+this.cellStyle.borders.left.width,e.width-=this.style.cellPadding.left),void 0!==this.style.cellPadding.top&&this.style.cellPadding.hasTopPad&&(e.y+=this.style.cellPadding.top+this.cellStyle.borders.top.width,e.height-=this.style.cellPadding.top),void 0!==this.style.cellPadding.right&&this.style.cellPadding.hasRightPad&&(e.width-=this.style.cellPadding.right),void 0!==this.style.cellPadding.bottom&&this.style.cellPadding.hasBottomPad&&(e.height-=this.style.cellPadding.bottom)),e.width-=this.cellStyle.borders.left.width+this.cellStyle.borders.right.width,e.height-=this.cellStyle.borders.top.width+this.cellStyle.borders.bottom.width):void 0===this.style.cellPadding||null==this.style.cellPadding?(e.x+=this.gridRow.grid.style.cellPadding.left+this.cellStyle.borders.left.width,e.y+=this.gridRow.grid.style.cellPadding.top+this.cellStyle.borders.top.width,e.width-=this.gridRow.grid.style.cellPadding.right+this.gridRow.grid.style.cellPadding.left,e.height-=this.gridRow.grid.style.cellPadding.bottom+this.gridRow.grid.style.cellPadding.top,e.height-=this.cellStyle.borders.top.width+this.cellStyle.borders.bottom.width):(e.x+=this.style.cellPadding.left+this.cellStyle.borders.left.width,e.y+=this.style.cellPadding.top+this.cellStyle.borders.top.width,e.width-=this.style.cellPadding.right+this.style.cellPadding.left,e.width-=this.cellStyle.borders.left.width+this.cellStyle.borders.right.width,e.height-=this.style.cellPadding.bottom+this.style.cellPadding.top,e.height-=this.cellStyle.borders.top.width+this.cellStyle.borders.bottom.width,1===this.rowSpan&&(e.width-=this.style.borders.left.width)),e},e.prototype.draw=function(e,i,r){var n=null;if(this.internalIsCellMergeContinue||this.internalIsRowMergeContinue){if(!this.internalIsCellMergeContinue||!this.row.grid.style.allowHorizontalOverflow)return n;if(this.row.rowOverflowIndex>0&&this.row.cells.indexOf(this)!=this.row.rowOverflowIndex+1||0==this.row.rowOverflowIndex&&this.internalIsCellMergeContinue)return n}i=this.adjustOuterLayoutArea(i,e),this.drawCellBackground(e,i);var o=this.getTextPen(),s=this.getTextBrush();void 0===o&&void 0===s&&(s=new M(new L(0,0,0)));var a=this.getTextFont(),h=this.getStringFormat(),l=i;if(l.height>=e.clientSize.height&&this.row.grid.allowRowBreakAcrossPages&&(l.height-=l.y),l=this.adjustContentLayoutArea(l),"string"==typeof this.objectValue||"string"==typeof this.remaining){var u=void 0,c=void 0;if(c=l.height<a.height?new k(l.x,l.y,l.width,a.height):l,l.height<a.height&&this.row.grid.isChildGrid&&null!=this.row.grid.ParentCell){var p=c.height-this.row.grid.ParentCell.row.grid.style.cellPadding.bottom-this.row.grid.style.cellPadding.bottom;-1!=this.row.grid.splitChildRowIndex&&(this.fontSpilt=!0,this.row.rowFontSplit=!0),p>0&&p<a.height&&(c.height=p)}0!=this.gridRow.grid.style.cellSpacing&&(c.width-=this.gridRow.grid.style.cellSpacing,i.width-=this.gridRow.grid.style.cellSpacing),this.isFinish?(u=""===this.remaining?this.remaining:this.objectValue,e.drawString(u,a,o,s,c.x,c.y,c.width,c.height,h),-1==this.row.grid.splitChildRowIndex||this.row.grid.isChildGrid||void 0!==this.remaining||(this.remaining="")):(void 0!==this.remaining&&null!==this.remaining||(this.remaining=""),this.row.repeatFlag&&e.drawString(this.remaining,a,o,s,c.x,c.y,c.width,c.height,h),this.isFinish=!0),n=e.stringLayoutResult}else if(this.objectValue instanceof Ii){var d=this.objectValue;d.isChildGrid=!0,d.ParentCell=this;var f=void 0;f=l,0!=this.gridRow.grid.style.cellSpacing&&(i.width-=this.gridRow.grid.style.cellSpacing);var g=new Gi(d),m=new Wi;null!=this.row.grid.LayoutFormat?m=this.row.grid.LayoutFormat:m.layout=t.PdfLayoutType.Paginate;var y=new De;if(null!=e.layer){y.page=e.page,y.bounds=f,y.format=m,d.setSpan(),d.checkSpan();var b=g.Layouter(y);this.value=d,-1!==this.row.grid.splitChildRowIndex&&(this.height=this.row.rowBreakHeightValue),y.page!=b.page&&(b.bounds.height=this.row.rowBreakHeightValue,0==this.row.rowBreakHeight?this.row.NestedGridLayoutResult=b:this.row.rowBreakHeight=this.row.rowBreakHeightValue)}}else if(this.objectValue instanceof ft||this.objectValue instanceof mt){var w=void 0;w=this.objectValue.width<=l.width?new k(l.x,l.y,this.objectValue.width,l.height):l,e.drawImage(this.objectValue,w.x,w.y,w.width,w.height)}else this.objectValue instanceof Je?this.objectValue.draw(e.currentPage,l):void 0===this.objectValue&&(this.objectValue="",e.drawString(this.objectValue,a,o,s,l.x,l.y,l.width,l.height,h),null!=this.style.cellPadding&&0==this.style.cellPadding.bottom&&0==this.style.cellPadding.left&&0==this.style.cellPadding.right&&0==this.style.cellPadding.top&&(i.width-=this.style.borders.left.width+this.style.borders.right.width),0!=this.gridRow.grid.style.cellSpacing&&(i.width-=this.gridRow.grid.style.cellSpacing));return null!=this.style.borders&&(this.fontSpilt?-1!=this.row.grid.ParentCell.row.grid.splitChildRowIndex&&(this.row.rowFontSplit=!1,this.drawCellBorders(e,i)):this.drawCellBorders(e,i)),n},e.prototype.drawCellBorders=function(e,i){this.row.grid.style.borderOverlapStyle===t.PdfBorderOverlapStyle.Inside&&(i.x+=this.style.borders.left.width,i.y+=this.style.borders.top.width,i.width-=this.style.borders.right.width,i.height-=this.style.borders.bottom.width);var r=new T(i.x,i.y+i.height),n=new T(i.x,i.y),o=this.cellStyle.borders.left;this.cellStyle.borders.left.dashStyle===t.PdfDashStyle.Solid&&(o.lineCap=t.PdfLineCap.Square),0!==o.width&&e.drawLine(o,r,n),r=new T(i.x+i.width,i.y),n=new T(i.x+i.width,i.y+i.height),o=this.cellStyle.borders.right,i.x+i.width>e.clientSize.width-o.width/2&&(r=new T(e.clientSize.width-o.width/2,i.y),n=new T(e.clientSize.width-o.width/2,i.y+i.height)),this.cellStyle.borders.right.dashStyle===t.PdfDashStyle.Solid&&(o.lineCap=t.PdfLineCap.Square),0!==o.width&&e.drawLine(o,r,n),r=new T(i.x,i.y),n=new T(i.x+i.width,i.y),o=this.cellStyle.borders.top,this.cellStyle.borders.top.dashStyle===t.PdfDashStyle.Solid&&(o.lineCap=t.PdfLineCap.Square),0!==o.width&&e.drawLine(o,r,n),r=new T(i.x+i.width,i.y+i.height),n=new T(i.x,i.y+i.height),o=this.cellStyle.borders.bottom,i.y+i.height>e.clientSize.height-o.width/2&&(r=new T(i.x+i.width,e.clientSize.height-o.width/2),n=new T(i.x,e.clientSize.height-o.width/2)),this.cellStyle.borders.bottom.dashStyle===t.PdfDashStyle.Solid&&(o.lineCap=t.PdfLineCap.Square),0!==o.width&&e.drawLine(o,r,n)},e.prototype.adjustOuterLayoutArea=function(t,e){var i=!1,r=this.row.grid.style.cellSpacing;r>0&&(t=new k(t.x+r,t.y+r,t.width-r,t.height-r));var n=this.row.cells.indexOf(this);if(this.columnSpan>1||this.row.rowOverflowIndex>0&&n==this.row.rowOverflowIndex+1&&this.isCellMergeContinue){if(1==(l=this.columnSpan)&&this.isCellMergeContinue)for(var o=n+1;o<this.row.grid.columns.count&&this.row.cells.getCell(o).isCellMergeContinue;o++)l++;for(var s=0,a=n;a<n+l;a++){if(this.row.grid.style.allowHorizontalOverflow){var h=this.row.grid.size.width<e.clientSize.width?this.row.grid.size.width:e.clientSize.width;if((this.row.grid.size.width>e.clientSize.width?t.x+s+this.row.grid.columns.getColumn(a).width:s+this.row.grid.columns.getColumn(a).width)>h)break}s+=this.row.grid.columns.getColumn(a).width}s-=this.row.grid.style.cellSpacing,t.width=s}if(this.rowSpan>1||this.row.rowSpanExists){var l=this.rowSpan,u=this.row.grid.rows.rowCollection.indexOf(this.row);-1==u&&-1!=(u=this.row.grid.headers.indexOf(this.row))&&(i=!0);var c=0;for(a=u;a<u+l;a++){c+=i?this.row.grid.headers.getHeader(a).height:this.row.grid.rows.getRow(a).height;var p=this.row.grid.rows.getRow(a);this.row.grid.rows.rowCollection.indexOf(p)}this.row.cells.indexOf(this);c-=this.row.grid.style.cellSpacing,t.height=c,this.row.rowMergeComplete||(t.height=c)}return t},e.prototype.getTextFont=function(){return void 0!==this.style.font&&null!=this.style.font?this.style.font:void 0!==this.row.style.font&&null!=this.row.style.font?this.row.style.font:void 0!==this.row.grid.style.font&&null!=this.row.grid.style.font?this.row.grid.style.font:Ce.defaultFont},e.prototype.getTextBrush=function(){return void 0!==this.style.textBrush&&null!=this.style.textBrush?this.style.textBrush:void 0!==this.row.style.textBrush&&null!=this.row.style.textBrush?this.row.style.textBrush:this.row.grid.style.textBrush},e.prototype.getTextPen=function(){return void 0!==this.style.textPen&&null!=this.style.textPen?this.style.textPen:void 0!==this.row.style.textPen&&null!=this.row.style.textPen?this.row.style.textPen:this.row.grid.style.textPen},e.prototype.getBackgroundBrush=function(){return void 0!==this.style.backgroundBrush&&null!=this.style.backgroundBrush?this.style.backgroundBrush:void 0!==this.row.style.backgroundBrush&&null!=this.row.style.backgroundBrush?this.row.style.backgroundBrush:this.row.grid.style.backgroundBrush},e.prototype.getBackgroundImage=function(){return void 0!==this.style.backgroundImage&&null!=this.style.backgroundImage?this.style.backgroundImage:void 0!==this.row.style.backgroundImage&&null!=this.row.style.backgroundImage?this.row.style.backgroundImage:this.row.grid.style.backgroundImage},e.prototype.getStringFormat=function(){return void 0!==this.style.stringFormat&&null!=this.style.stringFormat?this.style.stringFormat:this.stringFormat},e.prototype.measureHeight=function(){var t=this.calculateWidth();null==this.style.cellPadding||void 0===this.style.cellPadding?t-=this.gridRow.grid.style.cellPadding.right+this.gridRow.grid.style.cellPadding.left:(t-=this.style.cellPadding.right+this.style.cellPadding.left,t-=this.style.borders.left.width+this.style.borders.right.width);var e=0,i=new F;if("string"==typeof this.objectValue||"string"==typeof this.remaining){var r=this.objectValue;this.isFinish||(r=null!==this.remaining&&""!==this.remaining&&void 0!==this.remaining?this.remaining:this.objectValue);var n=this.row.cells.indexOf(this);0!=this.gridRow.grid.style.cellSpacing&&(t-=2*this.gridRow.grid.style.cellSpacing),this.row.cells.getCell(n).hasColSpan||this.row.cells.getCell(n).hasRowSpan||(this.gridRow.grid.isChildGrid?(t<0?(this.tempval=t,null==this.style.cellPadding||void 0===this.style.cellPadding?this.tempval+=this.gridRow.grid.style.cellPadding.right+this.gridRow.grid.style.cellPadding.left:(this.tempval+=this.style.cellPadding.right+this.style.cellPadding.left,this.tempval+=this.style.borders.left.width+this.style.borders.right.width)):this.tempval=t,e+=i.layout(r,this.getTextFont(),this.stringFormat,new j(this.tempval,0),!1,new j(0,0)).actualSize.height):e+=i.layout(r,this.getTextFont(),this.stringFormat,new j(t,0),!1,new j(0,0)).actualSize.height),e+=2*(this.style.borders.top.width+this.style.borders.bottom.width)}else if(this.objectValue instanceof Ii){n=this.row.cells.indexOf(this);var o=0;null!=this.style.cellPadding||void 0!==this.style.cellPadding?(o=this.calculateWidth(),void 0!==this.style.cellPadding.left&&this.style.cellPadding.hasLeftPad&&(o-=this.style.cellPadding.left),void 0!==this.style.cellPadding.right&&this.style.cellPadding.hasRightPad&&(o-=this.style.cellPadding.right)):null!=this.row.grid.style.cellPadding||void 0!==this.row.grid.style.cellPadding?(o=this.calculateWidth(),void 0!==this.row.grid.style.cellPadding.left&&this.row.grid.style.cellPadding.hasLeftPad&&(o-=this.row.grid.style.cellPadding.left),void 0!==this.row.grid.style.cellPadding.right&&this.row.grid.style.cellPadding.hasRightPad&&(o-=this.row.grid.style.cellPadding.right)):o=this.calculateWidth(),this.objectValue.tempWidth=o,this.row.cells.getCell(n).hasColSpan||this.row.cells.getCell(n).hasRowSpan?e+=2*(this.style.borders.top.width+this.style.borders.bottom.width):e=this.objectValue.size.height,0!==this.gridRow.grid.style.cellSpacing&&(t-=2*this.gridRow.grid.style.cellSpacing),null==this.style.cellPadding&&void 0===this.style.cellPadding||(void 0!==this.row.grid.style.cellPadding.top&&this.row.grid.style.cellPadding.hasTopPad&&(e+=this.row.grid.style.cellPadding.top),this.row.grid.style.cellPadding.hasBottomPad&&void 0!==this.row.grid.style.cellPadding.bottom&&(e+=this.row.grid.style.cellPadding.bottom)),e+=this.objectValue.style.cellSpacing}else if(this.objectValue instanceof ft||this.objectValue instanceof mt)e+=this.objectValue.height;else if(this.objectValue instanceof Je){var s=this.objectValue;e+=i.layout(s.text,s.font,s.stringFormat,new j(t,0),!1,new j(0,0)).actualSize.height,e+=2*(this.style.borders.top.width+this.style.borders.bottom.width)}else void 0===this.objectValue&&(null==this.style.cellPadding||void 0===this.style.cellPadding?t-=this.gridRow.grid.style.cellPadding.right+this.gridRow.grid.style.cellPadding.left:(t-=this.style.cellPadding.right+this.style.cellPadding.left,t-=this.style.borders.left.width+this.style.borders.right.width),e+=2*(this.style.borders.top.width+this.style.borders.bottom.width));return this.objectValue instanceof Ii?null==this.style.cellPadding||void 0===this.style.cellPadding?(void 0!==this.row.grid.style.cellPadding.top&&this.row.grid.style.cellPadding.hasTopPad&&(e+=this.row.grid.style.cellPadding.top),void 0!==this.row.grid.style.cellPadding.bottom&&this.row.grid.style.cellPadding.hasBottomPad&&(e+=this.row.grid.style.cellPadding.bottom)):(void 0!==this.style.cellPadding.top&&this.style.cellPadding.hasTopPad&&(e+=this.style.cellPadding.top),void 0!==this.style.cellPadding.bottom&&this.style.cellPadding.hasBottomPad&&(e+=this.style.cellPadding.bottom)):null==this.style.cellPadding||void 0===this.style.cellPadding?e+=this.row.grid.style.cellPadding.top+this.row.grid.style.cellPadding.bottom:e+=this.style.cellPadding.top+this.style.cellPadding.bottom,e+=this.row.grid.style.cellSpacing},e.prototype.calculateWidth=function(){var t=this.row.cells.indexOf(this),e=(this.row.grid.rows.rowCollection.indexOf(this.row),this.columnSpan),i=0;if(1===e)for(var r=0;r<e;r++)i+=this.row.grid.columns.getColumn(t+r).width;else if(e>1)for(r=0;r<e;r++)i+=this.row.grid.columns.getColumn(t+r).width,r+1<e&&(this.row.cells.getCell(t+r+1).hasColSpan=!0);if(null!=this.parent&&this.parent.row.width>0&&this.row.grid.isChildGrid&&null!=this.parent&&this.row.width>this.parent.row.width){i=0;for(var n=0;n<this.parent.columnSpan;n++)i+=this.parent.row.grid.columns.getColumn(n).width;i/=this.row.cells.count}return i},e}(),Vi=function(){function t(t){this.cells=[],this.gridRow=t}return t.prototype.getCell=function(t){if(t<0||t>=this.count)throw new Error("IndexOutOfRangeException");return this.cells[t]},Object.defineProperty(t.prototype,"count",{get:function(){return this.cells.length},enumerable:!0,configurable:!0}),t.prototype.add=function(t){if(void 0===t){var e=new ki;return this.add(e),t}t.row=this.gridRow,this.cells.push(t)},t.prototype.indexOf=function(t){return this.cells.indexOf(t)},t}(),Ri=function(){function t(t){this.columnWidth=0,this.grid=t}return Object.defineProperty(t.prototype,"width",{get:function(){return this.columnWidth},set:function(t){this.isCustomWidth=!0,this.columnWidth=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"format",{get:function(){return null==this.stringFormat&&(this.stringFormat=new A),this.stringFormat},set:function(t){this.stringFormat=t},enumerable:!0,configurable:!0}),t}(),Ni=function(){function t(t){this.internalColumns=[],this.columnWidth=0,this.grid=t,this.internalColumns=[]}return t.prototype.add=function(t){for(var e=0;e<t;e++){this.internalColumns.push(new Ri(this.grid));for(var i=0;i<this.grid.rows.count;i++){var r=this.grid.rows.getRow(i),n=new ki;n.value="",r.cells.add(n)}}},Object.defineProperty(t.prototype,"count",{get:function(){return this.internalColumns.length},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"width",{get:function(){return 0===this.columnWidth&&(this.columnWidth=this.measureColumnsWidth()),0===this.grid.initialWidth||this.columnWidth===this.grid.initialWidth||this.grid.style.allowHorizontalOverflow||(this.columnWidth=this.grid.initialWidth,this.grid.isPageWidth=!0),this.columnWidth},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"columns",{get:function(){return this.internalColumns},enumerable:!0,configurable:!0}),t.prototype.getColumn=function(t){if(t>=0&&t<=this.columns.length)return this.columns[t];throw Error("can not get the column from the index: "+t)},t.prototype.measureColumnsWidth=function(){var t=0;this.grid.measureColumnsWidth();for(var e=0,i=this.internalColumns.length;e<i;e++)t+=this.internalColumns[e].width;return t},t.prototype.getDefaultWidths=function(t){for(var e=[],i=this.count,r=0;r<this.count;r++)this.grid.isPageWidth&&t>=0&&!this.internalColumns[r].isCustomWidth?this.internalColumns[r].width=0:(e[r]=this.internalColumns[r].width,this.internalColumns[r].width>0&&this.internalColumns[r].isCustomWidth?(t-=this.internalColumns[r].width,i--):e[r]=0);for(r=0;r<this.count;r++){var n=t/i;e[r]<=0&&(e[r]=n)}return e},t}(),Mi=function(){function t(t){this.gridRowOverflowIndex=0,this.rowHeight=0,this.rowWidth=0,this.isrowFinish=!1,this.isRowSpanRowHeightSet=!1,this.noOfPageCount=0,this.isRowHeightSet=!1,this.isPageBreakRowSpanApplied=!1,this.isRowMergeComplete=!0,this.repeatFlag=!1,this.rowFontSplit=!1,this.isHeaderRow=!1,this.pdfGrid=t}return Object.defineProperty(t.prototype,"rowSpanExists",{get:function(){return this.bRowSpanExists},set:function(t){this.bRowSpanExists=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"cells",{get:function(){return null==this.gridCells&&(this.gridCells=new Vi(this)),this.gridCells},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"grid",{get:function(){return this.pdfGrid},set:function(t){this.pdfGrid=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"style",{get:function(){return void 0===this.rowStyle&&(this.rowStyle=new ji,this.rowStyle.setParent(this)),this.rowStyle},set:function(t){this.rowStyle=t;for(var e=0;e<this.cells.count;e++)this.cells.getCell(e).style.borders=t.border,void 0!==t.font&&(this.cells.getCell(e).style.font=t.font),void 0!==t.backgroundBrush&&(this.cells.getCell(e).style.backgroundBrush=t.backgroundBrush),void 0!==t.backgroundImage&&(this.cells.getCell(e).style.backgroundImage=t.backgroundImage),void 0!==t.textBrush&&(this.cells.getCell(e).style.textBrush=t.textBrush),void 0!==t.textPen&&(this.cells.getCell(e).style.textPen=t.textPen)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"rowBreakHeight",{get:function(){return void 0===this.gridRowBreakHeight&&(this.gridRowBreakHeight=0),this.gridRowBreakHeight},set:function(t){this.gridRowBreakHeight=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"rowOverflowIndex",{get:function(){return this.gridRowOverflowIndex},set:function(t){this.gridRowOverflowIndex=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"height",{get:function(){return this.isRowHeightSet||(this.rowHeight=this.measureHeight()),this.rowHeight},set:function(t){this.rowHeight=t,this.isRowHeightSet=!0},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"width",{get:function(){return 0!==this.rowWidth&&void 0!==this.rowWidth||(this.rowWidth=this.measureWidth()),this.rowWidth},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"NestedGridLayoutResult",{get:function(){return this.gridResult},set:function(t){this.gridResult=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"columnSpanExists",{get:function(){return this.bColumnSpanExists},set:function(t){this.bColumnSpanExists=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"rowMergeComplete",{get:function(){return this.isRowMergeComplete},set:function(t){this.isRowMergeComplete=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"rowIndex",{get:function(){return this.grid.rows.rowCollection.indexOf(this)},enumerable:!0,configurable:!0}),t.prototype.measureHeight=function(){var t,e=0,i=0;t=this.cells.getCell(0).rowSpan>1?0:this.cells.getCell(0).height;for(var r=0;r<this.cells.count;r++){var n=this.cells.getCell(r);if(n.rowSpanRemainingHeight>e&&(e=n.rowSpanRemainingHeight),this.rowMergeComplete=!1,n.rowSpan>1){for(var o=r,s=this.isHeaderRow?this.grid.headers.indexOf(this):this.grid.rows.rowCollection.indexOf(this),a=0;a<n.rowSpan;a++)a+1<n.rowSpan&&((this.isHeaderRow?this.grid.headers.getHeader(s+a+1):this.grid.rows.getRow(s+a+1)).cells.getCell(o).hasRowSpan=!0);i<n.height&&(i=n.height)}else t=Math.max(t,n.height)}return i>t&&(t=i),0===t?t=i:e>0&&(t+=e),t},t.prototype.measureWidth=function(){for(var t=0,e=0;e<this.grid.columns.count;e++){t+=this.grid.columns.getColumn(e).width}return t},t}(),Ai=function(){function t(t){this.rows=[],this.grid=t}return Object.defineProperty(t.prototype,"count",{get:function(){return this.rows.length},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"rowCollection",{get:function(){return this.rows},enumerable:!0,configurable:!0}),t.prototype.addRow=function(t){if(void 0===t){var e=new Mi(this.grid);return this.addRow(e),e}if(t.style.setBackgroundBrush(this.grid.style.backgroundBrush),t.style.setFont(this.grid.style.font),t.style.setTextBrush(this.grid.style.textBrush),t.style.setTextPen(this.grid.style.textPen),0===t.cells.count)for(var i=0;i<this.grid.columns.count;i++)t.cells.add(new ki);this.rows.push(t)},t.prototype.getRow=function(t){return this.rows[t]},t}(),Di=function(){function t(t){this.rows=[],this.grid=t,this.rows=[]}return t.prototype.getHeader=function(t){return this.rows[t]},Object.defineProperty(t.prototype,"count",{get:function(){return this.rows.length},enumerable:!0,configurable:!0}),t.prototype.add=function(t){if("number"==typeof t){for(var e=void 0,i=0;i<t;i++){(e=new Mi(this.grid)).isHeaderRow=!0;for(var r=0;r<this.grid.columns.count;r++)e.cells.add(new ki);this.rows.push(e)}return this.rows}this.rows.push(t)},t.prototype.indexOf=function(t){return this.rows.indexOf(t)},t}(),Fi=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Ii=function(t){function e(){var e=t.call(this)||this;return e.gridSize=new j(0,0),e.isGridSplit=!1,e.isRearranged=!1,e.pageBounds=new k,e.listOfNavigatePages=[],e.parentCellIndex=0,e.tempWidth=0,e.breakRow=!0,e.splitChildRowIndex=-1,e.hasRowSpanSpan=!1,e.hasColumnSpan=!1,e.isSingleGrid=!0,e}return Fi(e,t),Object.defineProperty(e.prototype,"raiseBeginCellDraw",{get:function(){return void 0!==this.beginCellDraw&&null!==typeof this.beginCellDraw},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"raiseEndCellDraw",{get:function(){return void 0!==this.endCellDraw&&null!==typeof this.endCellDraw},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"repeatHeader",{get:function(){return null!=this.bRepeatHeader&&void 0!==this.bRepeatHeader||(this.bRepeatHeader=!1),this.bRepeatHeader},set:function(t){this.bRepeatHeader=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"allowRowBreakAcrossPages",{get:function(){return this.breakRow},set:function(t){this.breakRow=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"columns",{get:function(){return null!=this.gridColumns&&void 0!==this.gridColumns||(this.gridColumns=new Ni(this)),this.gridColumns},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"rows",{get:function(){return null==this.gridRows&&(this.gridRows=new Ai(this)),this.gridRows},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"headers",{get:function(){return null!=this.gridHeaders&&void 0!==this.gridHeaders||(this.gridHeaders=new Di(this)),this.gridHeaders},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"initialWidth",{get:function(){return this.gridInitialWidth},set:function(t){this.gridInitialWidth=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"style",{get:function(){return null==this.gridStyle&&(this.gridStyle=new Li),this.gridStyle},set:function(t){null==this.gridStyle&&(this.gridStyle=t)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"isPageWidth",{get:function(){return this.ispageWidth},set:function(t){this.ispageWidth=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"isChildGrid",{get:function(){return this.ischildGrid},set:function(t){this.ischildGrid=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"size",{get:function(){return 0!==this.gridSize.width&&void 0!==this.gridSize.width||0!==this.gridSize.height||(this.gridSize=this.measure()),this.gridSize},set:function(t){this.gridSize=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"ParentCell",{get:function(){return this.parentCell},set:function(t){this.parentCell=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"LayoutFormat",{get:function(){return this.layoutFormat},enumerable:!0,configurable:!0}),e.prototype.draw=function(t,e,i,r){if(e instanceof T&&void 0===e.width&&void 0===i)return this.drawHelper(t,e.x,e.y);if("number"==typeof e&&"number"==typeof i&&void 0===r)return this.drawHelper(t,e,i,null);if(e instanceof k&&void 0!==e.width&&void 0===i)return this.drawHelper(t,e,null);if(e instanceof T&&void 0===e.width&&i instanceof Ae)return this.drawHelper(t,e.x,e.y,i);if("number"==typeof e&&"number"==typeof i&&(r instanceof Ae||null==r)){var n=t.graphics.clientSize.width-e,o=new k(e,i,n,0);return this.drawHelper(t,o,r)}return e instanceof k&&void 0!==e.width&&"boolean"==typeof i?this.drawHelper(t,e,null):this.drawHelper(t,e,i)},e.prototype.measure=function(){for(var t=0,e=this.columns.width,i=0;i<this.headers.count;i++){t+=this.headers.getHeader(i).height}for(i=0;i<this.rows.count;i++){t+=this.rows.getRow(i).height}return new j(e,t)},e.prototype.onBeginCellDraw=function(t){this.raiseBeginCellDraw&&this.beginCellDraw(this,t)},e.prototype.onEndCellDraw=function(t){this.raiseEndCellDraw&&this.endCellDraw(this,t)},e.prototype.layout=function(t){var e=t.bounds.width,i=t.bounds.height,r=!1;if(void 0!==t.bounds.width&&0!==t.bounds.width||(e=t.page.getClientSize().width-t.bounds.x,r=!0),void 0!==t.bounds.height&&0!==t.bounds.height||(i=t.page.getClientSize().height-t.bounds.y,r=!0),r&&(t.bounds=new k(t.bounds.x,t.bounds.y,e,i)),0!==this.rows.count){var n=this.rows.getRow(0).cells.getCell(0).style;if(null!=n.borders&&(null!=n.borders.left&&1!==n.borders.left.width||null!=n.borders.top&&1!==n.borders.top.width)){var o=n.borders.left.width/2,s=n.borders.top.width/2;if(t.bounds.x===Ie.default.right.width/2&&t.bounds.y===Ie.default.right.width/2){var a=new k(o,s,this.gridSize.width,this.gridSize.height);t.bounds=a}}}this.setSpan(),this.checkSpan(),this.layoutFormat=t.format,this.gridLocation=t.bounds;return new Gi(this).Layouter(t)},e.prototype.setSpan=function(){for(var t=1,e=1,i=0,r=0,n=0,o=this.headers.count,s=0;s<o;s++){var a=this.headers.getHeader(s);n=0;for(var h=a.cells.count,l=0;l<h;l++){var u=a.cells.getCell(l);if(n=Math.max(n,u.rowSpan),!u.isCellMergeContinue&&!u.isRowMergeContinue&&(u.columnSpan>1||u.rowSpan>1)){if(u.columnSpan+l>a.cells.count)throw new Error("Invalid span specified at row "+l.toString()+" column "+s.toString());if(u.rowSpan+s>this.headers.count)throw new Error("Invalid span specified at Header "+l.toString()+" column "+s.toString());if(u.columnSpan>1&&u.rowSpan>1){for(t=u.columnSpan,e=u.rowSpan,i=l,r=s,u.isCellMergeStart=!0,u.isRowMergeStart=!0;t>1;)i++,a.cells.getCell(i).isCellMergeContinue=!0,a.cells.getCell(i).isRowMergeContinue=!0,a.cells.getCell(i).rowSpan=e,t--;for(i=l,t=u.columnSpan;e>1;){for(r++,this.headers.getHeader(r).cells.getCell(l).isRowMergeContinue=!0,this.headers.getHeader(r).cells.getCell(i).isRowMergeContinue=!0,e--;t>1;)i++,this.headers.getHeader(r).cells.getCell(i).isCellMergeContinue=!0,this.headers.getHeader(r).cells.getCell(i).isRowMergeContinue=!0,t--;t=u.columnSpan,i=l}}else if(u.columnSpan>1&&1===u.rowSpan)for(t=u.columnSpan,i=l,u.isCellMergeStart=!0;t>1;)i++,a.cells.getCell(i).isCellMergeContinue=!0,t--;else if(1===u.columnSpan&&u.rowSpan>1)for(e=u.rowSpan,r=s;e>1;)r++,this.headers.getHeader(r).cells.getCell(l).isRowMergeContinue=!0,e--}}a.maximumRowSpan=n}},e.prototype.checkSpan=function(){var t,e,i=1,r=0,n=0;if(t=i=1,e=n=0,this.hasRowSpanSpan||this.hasColumnSpan)for(var o=this.rows.count,s=0;s<o;s++){var a=this.rows.getRow(s);r=0;for(var h=a.cells.count,l=0;l<h;l++){var u=a.cells.getCell(l);if(r=Math.max(r,u.rowSpan),!u.isCellMergeContinue&&!u.isRowMergeContinue&&(u.columnSpan>1||u.rowSpan>1)){if(u.columnSpan+l>a.cells.count)throw new Error("Invalid span specified at row  "+l.toString()+" column "+s.toString());if(u.rowSpan+s>this.rows.count)throw new Error("Invalid span specified at row  "+l.toString()+" column "+s.toString());if(u.columnSpan>1&&u.rowSpan>1){for(t=u.columnSpan,i=u.rowSpan,e=l,n=s,u.isCellMergeStart=!0,u.isRowMergeStart=!0;t>1;)e++,a.cells.getCell(e).isCellMergeContinue=!0,a.cells.getCell(e).isRowMergeContinue=!0,t--;for(e=l,t=u.columnSpan;i>1;){for(n++,this.rows.getRow(n).cells.getCell(l).isRowMergeContinue=!0,this.rows.getRow(n).cells.getCell(e).isRowMergeContinue=!0,i--;t>1;)e++,this.rows.getRow(n).cells.getCell(e).isCellMergeContinue=!0,this.rows.getRow(n).cells.getCell(e).isRowMergeContinue=!0,t--;t=u.columnSpan,e=l}}else if(u.columnSpan>1&&1===u.rowSpan)for(t=u.columnSpan,e=l,u.isCellMergeStart=!0;t>1;)e++,a.cells.getCell(e).isCellMergeContinue=!0,t--;else if(1===u.columnSpan&&u.rowSpan>1)for(i=u.rowSpan,n=s;i>1;)n++,this.rows.getRow(n).cells.getCell(l).isRowMergeContinue=!0,i--}}a.maximumRowSpan=r}},e.prototype.measureColumnsWidth=function(t){if(void 0!==t){this.isPageWidth=!1;for(var e=this.columns.getDefaultWidths(t.width-t.x),i=0,r=this.columns.count;i<r;i++)this.columns.getColumn(i).columnWidth=e[i],this.tempWidth=e[i];if(null!=this.ParentCell&&0==this.style.allowHorizontalOverflow&&0==this.ParentCell.row.grid.style.allowHorizontalOverflow){var n=0,o=0,s=this.columns.count,a=0;null==this.ParentCell.style.cellPadding&&void 0===this.ParentCell.style.cellPadding||(void 0!==this.ParentCell.style.cellPadding.left&&this.ParentCell.style.cellPadding.hasLeftPad&&(n+=this.ParentCell.style.cellPadding.left),void 0!==this.ParentCell.style.cellPadding.right&&this.ParentCell.style.cellPadding.hasRightPad&&(n+=this.ParentCell.style.cellPadding.right));for(i=0;i<this.ParentCell.columnSpan;i++)o+=this.ParentCell.row.grid.columns.getColumn(this.parentCellIndex+i).width;for(var h=0;h<this.columns.count;h++)this.gridColumns.getColumn(h).width>0&&this.gridColumns.getColumn(h).isCustomWidth&&(o-=this.gridColumns.getColumn(h).width,s--);if(null==this.ParentCell.row.grid.style.cellPadding&&void 0===this.ParentCell.row.grid.style.cellPadding||(void 0!==this.ParentCell.row.grid.style.cellPadding.top&&this.ParentCell.row.grid.style.cellPadding.hasTopPad&&(n+=this.ParentCell.row.grid.style.cellPadding.top),void 0!==this.ParentCell.row.grid.style.cellPadding.bottom&&this.ParentCell.row.grid.style.cellPadding.hasBottomPad&&(n+=this.ParentCell.row.grid.style.cellPadding.bottom)),0!=this.ParentCell.row.grid.style.cellSpacing&&(o-=2*this.ParentCell.row.grid.style.cellSpacing),o>n&&(a=(o-n)/s,this.tempWidth=a,null!=this.ParentCell))for(h=0;h<this.columns.count;h++)this.columns.getColumn(h).isCustomWidth||(this.columns.getColumn(h).columnWidth=a)}}else{e=[this.columns.count];for(var l=0;l<this.columns.count;l++)e[l]=0;var u=0;if((void 0===this.isChildGrid&&void 0!==this.gridLocation||null===this.isChildGrid&&void 0!==this.gridLocation)&&(this.initialWidth=this.gridLocation.width),this.headers.count>0){var c=this.headers.getHeader(0).cells.count,p=this.headers.count;for(i=0;i<c;i++){u=0;for(h=0;h<p;h++){var d=Math.min(this.initialWidth,this.headers.getHeader(h).cells.getCell(i).width);u=Math.max(u,d)}e[i]=u}}u=0;i=0;for(var f=this.columns.count;i<f;i++){for(h=0,p=this.rows.count;h<p;h++)if(1==this.rows.getRow(h).cells.getCell(i).columnSpan&&!this.rows.getRow(h).cells.getCell(i).isCellMergeContinue||null!=this.rows.getRow(h).cells.getCell(i).value){if(null!=this.rows.getRow(h).cells.getCell(i).value&&!this.rows.getRow(h).grid.style.allowHorizontalOverflow)this.rows.getRow(h).grid.style.cellPadding.right,this.rows.getRow(h).grid.style.cellPadding.left,this.rows.getRow(h).cells.getCell(i).style.borders.left.width;d=0;d=this.initialWidth>0?Math.min(this.initialWidth,this.rows.getRow(h).cells.getCell(i).width):this.rows.getRow(h).cells.getCell(i).width,u=Math.max(e[i],Math.max(u,d)),u=Math.max(this.columns.getColumn(i).width,u)}0!=this.rows.count&&(e[i]=u),u=0}i=0;for(var g=this.rows.count;i<g;i++){h=0;for(var m=this.columns.count;h<m;h++)if(this.rows.getRow(i).cells.getCell(h).columnSpan>1){e[h];for(var y=1;y<this.rows.getRow(i).cells.getCell(h).columnSpan;y++)e[h+y]}}for(i=0,r=this.columns.count;i<r;i++)this.columns.getColumn(i).width<=0?this.columns.getColumn(i).columnWidth=e[i]:this.columns.getColumn(i).width>0&&!this.columns.getColumn(i).isCustomWidth&&(this.columns.getColumn(i).columnWidth=e[i]);n=0;var b=0,w=this.columns.count,P=0;b=this.tempWidth;for(h=0;h<this.columns.count;h++)this.gridColumns.getColumn(h).width>0&&this.gridColumns.getColumn(h).isCustomWidth&&(b-=this.gridColumns.getColumn(h).width,w--);if(b>0&&0!=this.ParentCell.row.grid.style.cellSpacing&&(b-=2*this.ParentCell.row.grid.style.cellSpacing),b>n&&(P=b/w,null!=this.ParentCell))for(h=0;h<this.columns.count;h++)this.columns.getColumn(h).isCustomWidth||(this.columns.getColumn(h).columnWidth=P)}},e}(Ge),Ei=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Gi=function(e){function i(t){var i=e.call(this,t)||this;return i.gridInitialWidth=0,i.gridSize=new j(0,0),i.parentCellIndex=0,i.tempWidth=0,i.childheight=0,i.isChildGrid=!1,i.hasRowSpanSpan=!1,i.isRearranged=!1,i.pageBounds=new k,i.listOfNavigatePages=[],i.flag=!0,i.columnRanges=[],i.currentLocation=new T(0,0),i.breakRow=!0,i.slr=null,i.remainderText=null,i.isPaginate=!1,i.isOverloadWithPosition=!1,i}return Ei(i,e),Object.defineProperty(i.prototype,"Grid",{get:function(){return this.elements},enumerable:!0,configurable:!0}),i.prototype.getFormat=function(t){return t},i.prototype.layoutInternal=function(e){var i=this.getFormat(e.format);if(this.gridLayoutFormat=this.getFormat(e.format),this.currentPage=e.page,null===this.currentPage)throw Error("Can not set page as null");this.currentPage.getClientSize().height,this.currentPage.getClientSize().width;this.currentPageBounds=this.currentPage.getClientSize(),this.currentGraphics=this.currentPage.graphics;var r=0;if(r=this.currentGraphics.page.section.indexOf(this.currentGraphics.page),this.listOfNavigatePages.push(r),null!=i&&i.break===t.PdfLayoutBreakType.FitColumnsToPage?this.currentBounds=new k(new T(e.bounds.x,e.bounds.y),new j(this.Grid.columns.width,this.currentGraphics.clientSize.height)):this.currentBounds=new k(new T(e.bounds.x,e.bounds.y),this.currentGraphics.clientSize),0!==this.Grid.rows.count)this.currentBounds.width=e.bounds.width>0?e.bounds.width:this.currentBounds.width-this.Grid.rows.getRow(0).cells.getCell(0).style.borders.left.width/2;else{if(0===this.Grid.headers.count)throw Error("Please add row or header into grid");this.currentBounds.width=e.bounds.width}if(this.startLocation=new T(e.bounds.x,e.bounds.y),e.bounds.height>0&&!this.Grid.isChildGrid&&(this.currentBounds.height=e.bounds.height),this.Grid.isChildGrid||(this.hType=this.Grid.style.horizontalOverflowType),this.Grid.style.allowHorizontalOverflow?(this.Grid.measureColumnsWidth(),this.determineColumnDrawRanges()):(this.columnRanges=[],void 0!==this.Grid.isChildGrid&&(this.Grid.isChildGrid,1)?this.Grid.measureColumnsWidth(this.currentBounds):this.Grid.measureColumnsWidth(new k(this.currentBounds.x,this.currentBounds.y,this.currentBounds.x+this.currentBounds.width,this.currentBounds.height)),this.columnRanges.push([0,this.Grid.columns.count-1])),this.Grid.hasRowSpanSpan)for(var n=0;n<this.Grid.rows.count;n++)-1===this.Grid.rows.getRow(n).height||this.Grid.rows.getRow(n).isRowHeightSet||(this.Grid.rows.getRow(n).isRowHeightSet=!0);return this.layoutOnPage(e)},i.prototype.determineColumnDrawRanges=function(){for(var t=0,e=0,i=0,r=this.currentGraphics.clientSize.width-this.currentBounds.x,n=0;n<this.Grid.columns.count;n++)if((i+=this.Grid.columns.getColumn(n).width)>=r){for(var o=0,s=t;s<=n&&!((o+=this.Grid.columns.getColumn(s).width)>r);s++)e=s;this.columnRanges.push([t,e]),i=(e=t=e+1)<=n?this.Grid.columns.getColumn(n).width:0}this.columnRanges.push([t,this.Grid.columns.count-1])},i.prototype.layoutOnPage=function(e){this.pageBounds.x=e.bounds.x,this.pageBounds.y=e.bounds.y,this.pageBounds.height=e.bounds.height;for(var r=this.getFormat(e.format),n=null,o=new rt,s=e.page,a=[],h=0;h<this.columnRanges.length;h++){var l=this.columnRanges[h];this.cellStartIndex=l[0],this.cellEndIndex=l[1];var u=this.raiseBeforePageLayout(this.currentPage,this.currentBounds,this.currentRowIndex);this.currentBounds=u.currentBounds,this.currentRowIndex=u.currentRowIndex;for(var c=void 0,p=0;p<this.Grid.headers.count;p++){var d=this.Grid.headers.getHeader(p),f=this.currentBounds.y;if(this.isHeader=!0,s!=this.currentPage)for(var g=this.cellStartIndex;g<=this.cellEndIndex;g++)d.cells.getCell(g).isCellMergeContinue&&(d.cells.getCell(g).isCellMergeContinue=!1,d.cells.getCell(g).value="");var m=this.drawRow(d);f===this.currentBounds.y?(c=!0,-1===i.repeatRowIndex&&(i.repeatRowIndex=p)):c=!1,!m.isFinish&&null!==s&&r.layout!==t.PdfLayoutType.OnePage&&c&&(this.startLocation.x=this.currentBounds.x,this.currentPage=this.getNextPageformat(r),this.startLocation.y=this.currentBounds.y,void 0!==r.paginateBounds&&0===r.paginateBounds.x&&0===r.paginateBounds.y&&0===r.paginateBounds.width&&0===r.paginateBounds.height&&(this.currentBounds.x+=this.startLocation.x),this.drawRow(d)),this.isHeader=!1}var y=0,b=(this.Grid.rows.count,void 0),w=!0;a=[];for(var P=0;P<this.Grid.rows.count;P++){d=this.Grid.rows.getRow(P);y++,this.currentRowIndex=y-1;var S=this.currentBounds.y;s=this.currentPage,i.repeatRowIndex=-1,w&&d.grid.isChildGrid&&(w=!1);var v=null;if(-1==this.Grid.splitChildRowIndex)v=this.drawRow(d),d.isrowFinish=!0;else{if(!(d.grid.ParentCell.row.grid.isGridSplit&&this.Grid.splitChildRowIndex<=d.rowIndex)){if(d.isrowFinish)continue;break}v=this.drawRow(d),d.isrowFinish=!0}for(a.push(v.bounds.width),S===this.currentBounds.y?(b=!0,i.repeatRowIndex=this.Grid.rows.rowCollection.indexOf(d)):(b=!1,i.repeatRowIndex=-1);!v.isFinish&&null!=s;){var C=this.getLayoutResult();if(this.raisePageLayouted(C).cancel||b)break;if(this.Grid.allowRowBreakAcrossPages){this.currentPage=this.getNextPageformat(r),S=this.currentBounds.y;var B=new T(Ie.default.right.width/2,Ie.default.top.width/2);if(0===r.paginateBounds.x&&0===r.paginateBounds.y&&0===r.paginateBounds.width&&0===r.paginateBounds.height&&this.startLocation.x===B.x&&this.startLocation.y===B.y&&(this.currentBounds.x+=this.startLocation.x,this.currentBounds.y+=this.startLocation.y),this.isPaginate&&(this.startLocation.y=this.currentBounds.y,this.isPaginate=!1),this.Grid.isChildGrid&&null!=d.grid.ParentCell&&null!=this.Grid.ParentCell.row.grid.style.cellPadding&&d.rowBreakHeight+this.Grid.ParentCell.row.grid.style.cellPadding.top<this.currentBounds.height&&(this.currentBounds.y=this.Grid.ParentCell.row.grid.style.cellPadding.top),null!=d.grid.ParentCell){d.grid.ParentCell.row.isRowBreaksNextPage=!0,d.grid.ParentCell.row.rowBreakHeightValue=d.rowBreakHeight+this.Grid.ParentCell.row.grid.style.cellPadding.top+this.Grid.ParentCell.row.grid.style.cellPadding.bottom;for(var O=d.rowIndex+1;O<d.grid.rows.count;O++)d.grid.ParentCell.row.rowBreakHeightValue+=d.grid.rows.getRow(O).height}if(d.grid.isChildGrid){d.isrowFinish=!1,d.grid.splitChildRowIndex=d.rowIndex,d.grid.ParentCell.row.grid.splitChildRowIndex=d.grid.ParentCell.row.rowIndex,d.grid.ParentCell.row.grid.isGridSplit&&(d.grid.ParentCell.row.noOfPageCount+=1,d.grid.ParentCell.row.grid.isGridSplit=!1);break}if(d.noOfPageCount<1){if(-1!=d.grid.splitChildRowIndex&&(d.grid.isGridSplit=!0),null!=d.style.border&&(null!=d.style.border.left&&1!==d.style.border.left.width||null!=d.style.border.top&&1!==d.style.border.top.width)){var x=d.style.border.left.width/2,L=d.style.border.top.width/2;if(this.currentBounds.x===Ie.default.right.width/2&&this.currentBounds.y===Ie.default.right.width/2){var V=new k(x,L,this.currentBounds.width,this.currentBounds.height);this.currentBounds=V}}if(this.Grid.repeatHeader)for(var R=0;R<this.Grid.headers.count;R++){var N=this.Grid.headers.getHeader(R);this.drawRow(N)}if(v=this.drawRow(d),d.noOfPageCount>=1){d.rowBreakHeightValue;for(var M=0;M<d.noOfPageCount;M++){var A=this.getLayoutResult();if(this.raisePageLayouted(A),this.currentPage=this.getNextPageformat(r),S=this.currentBounds.y,-1!=d.grid.splitChildRowIndex&&(d.grid.isGridSplit=!0),this.currentBounds.y=.5,this.Grid.repeatHeader)for(var D=0;D<this.Grid.headers.count;D++){var F=this.Grid.headers.getHeader(D);this.drawRow(F)}this.drawRow(d)}}d.grid.splitChildRowIndex=-1,d.grid.isGridSplit=!1,v.isFinish=this.checkIsFisished(d);for(var I=0;I<d.cells.count;I++)d.cells.getCell(I).value instanceof Ii&&(d.cells.getCell(I).value.splitChildRowIndex=-1)}}}if(!v.isFinish&&null!==s&&r.layout!==t.PdfLayoutType.OnePage&&b){if(this.startLocation.x=this.currentBounds.x,this.currentPage=this.getNextPageformat(r),this.raiseBeforePageLayout(this.currentPage,this.currentBounds,this.currentRowIndex).returnValue)break;if(null!==e.format&&!e.format.usePaginateBounds&&null!==e.bounds&&e.bounds.height>0&&!this.Grid.isChildGrid&&(this.currentBounds.height=e.bounds.height),void 0===e.format||null==e.format||void 0===e.format.usePaginateBounds||e.format.usePaginateBounds||0===e.format.paginateBounds.x&&0===e.format.paginateBounds.y&&0===e.format.paginateBounds.width&&0===e.format.paginateBounds.height||0!==e.format.paginateBounds.y?(this.currentBounds.y=null==r?0:r.paginateBounds.y,null==r||0===r.paginateBounds.x&&0===r.paginateBounds.y&&0===r.paginateBounds.height&&0===r.paginateBounds.width||(this.currentBounds.x=r.paginateBounds.x,this.currentBounds.width=r.paginateBounds.width,this.currentBounds.height=r.paginateBounds.height)):this.currentBounds.y=Ie.default.top.width/2,void 0!==e.format&&null!==e.format&&void 0!==e.format.usePaginateBounds&&!e.format.usePaginateBounds&&null!==e.bounds&&e.bounds.y>0&&!this.Grid.isChildGrid&&(this.currentBounds.y=e.bounds.y),this.startLocation.y=this.currentBounds.y,r.paginateBounds.x===r.paginateBounds.y&&r.paginateBounds.y===r.paginateBounds.height&&r.paginateBounds.height===r.paginateBounds.width&&0===r.paginateBounds.width&&(this.currentBounds.x+=this.startLocation.x),this.currentBounds.x===Ie.default.left.width/2&&(this.currentBounds.y+=this.startLocation.x),this.Grid.repeatHeader)for(var E=0;E<this.Grid.headers.count;E++){F=this.Grid.headers.getHeader(E);this.drawRow(F)}this.drawRow(d),null===this.currentPage||o.containsKey(this.currentPage)||o.add(this.currentPage,l)}if(null!=d.NestedGridLayoutResult){this.currentPage=d.NestedGridLayoutResult.page,this.currentGraphics=this.currentPage.graphics,this.startLocation=new T(d.NestedGridLayoutResult.bounds.x,d.NestedGridLayoutResult.bounds.y);var G=this.ReCalculateHeight(d,d.NestedGridLayoutResult.bounds.height);if(this.currentBounds.y=G,s!=this.currentPage){for(var z=this.currentPage.section,W=z.indexOf(s)+1,H=z.indexOf(this.currentPage),_=W;_<H+1;_++){var K=this.currentPage.graphics,U=new T(r.paginateBounds.x,r.paginateBounds.y),q=_==H?d.NestedGridLayoutResult.bounds.height-e.bounds.y:this.currentBounds.height-U.y;q<=K.clientSize.height&&(q+=e.bounds.y),U.y=null==r?.5:r.paginateBounds.y;for(var Y=0;Y<d.cells.count;Y++){var X=d.cells.getCell(Y),J=0,Z=0;if(X.value instanceof Ii)for(var $=0;$<X.value.columns.count;$++)Z+=X.value.columns.getColumn($).columnWidth;else Z=X.width;J=Math.max(Z,d.grid.columns.getColumn(Y).width),X.drawCellBorders(K,new k(U,new j(J,q))),U.x+=J,Y+=X.columnSpan-1}}s=this.currentPage}}}var Q=!1,tt=0;a.length>0&&(tt=a[0]);var et=[[1,2]];for(Y=0;Y<this.Grid.rows.count;Y++)if(-1!=this.cellEndIndex&&this.Grid.rows.getRow(Y).cells.getCell(this.cellEndIndex).value instanceof Ii){var it=this.Grid.rows.getRow(Y).cells.getCell(this.cellEndIndex).value;this.rowLayoutBoundsWidth=it.rowLayoutBoundsWidth,Q=!0}if(!Q&&a.length>0){for(Y=0;Y<y-1;Y++)tt<a[Y]&&(tt=a[Y]);this.rowLayoutBoundsWidth=tt}else this.rowLayoutBoundsWidth=et[0][1];if(this.columnRanges.indexOf(l)<this.columnRanges.length-1&&null!=s&&r.layout!=t.PdfLayoutType.OnePage)if(this.Grid.isChildGrid,0!=et[0][0]){this.currentPage.section.indexOf(this.currentPage);this.currentGraphics=this.currentPage.graphics,this.currentBounds=new k(new T(0,0),this.currentPage.getClientSize());this.currentGraphics.page.section.indexOf(this.currentGraphics.page)}else this.currentPage=this.getNextPageformat(r);this.columnRanges.length-1!==h&&this.columnRanges.length>1&&r.layout!==t.PdfLayoutType.OnePage&&(this.currentPage=this.getNextPageformat(r),r.paginateBounds.x===r.paginateBounds.y&&r.paginateBounds.y===r.paginateBounds.height&&r.paginateBounds.height===r.paginateBounds.width&&0===r.paginateBounds.width&&(this.currentBounds.x+=this.startLocation.x,this.currentBounds.y+=this.startLocation.y))}return n=this.getLayoutResult(),this.Grid.style.allowHorizontalOverflow&&this.Grid.style.horizontalOverflowType==t.PdfHorizontalOverflowType.NextPage&&this.reArrangePages(o),this.raisePageLayouted(n),n},i.prototype.checkIsFisished=function(t){for(var e=!0,i=0;i<t.cells.count;i++)t.cells.getCell(i).FinishedDrawingCell||(e=!1);return e},i.prototype.getNextPageformat=function(t){var e=this.currentPage.section,i=null,r=e.indexOf(this.currentPage);this.flag=!1,i=r===e.count-1?e.add():e.getPages()[r+1],this.currentGraphics=i.graphics;var n=this.currentGraphics.page.section.indexOf(this.currentGraphics.page);return-1===this.listOfNavigatePages.indexOf(n)&&this.listOfNavigatePages.push(n),this.currentBounds=new k(new T(0,0),i.getClientSize()),void 0!==t&&null!=t&&t.usePaginateBounds&&void 0!==t.paginateBounds&&null!=t.paginateBounds&&t.paginateBounds.x!==t.paginateBounds.y&&t.paginateBounds.y!==t.paginateBounds.height&&t.paginateBounds.height!==t.paginateBounds.width&&0!==t.paginateBounds.width&&(this.currentBounds.x=t.paginateBounds.x,this.currentBounds.y=t.paginateBounds.y,this.currentBounds.height=t.paginateBounds.height),i},i.prototype.CheckIfDefaultFormat=function(t){var e=new A;return t.alignment===e.alignment&&t.characterSpacing===e.characterSpacing&&t.clipPath===e.clipPath&&t.firstLineIndent===e.firstLineIndent&&t.horizontalScalingFactor===e.horizontalScalingFactor&&t.lineAlignment===e.lineAlignment&&t.lineLimit===e.lineLimit&&t.lineSpacing===e.lineSpacing&&t.measureTrailingSpaces===e.measureTrailingSpaces&&t.noClip===e.noClip&&t.paragraphIndent===e.paragraphIndent&&t.rightToLeft===e.rightToLeft&&t.subSuperScript===e.subSuperScript&&t.wordSpacing===e.wordSpacing&&t.wordWrap===e.wordWrap},i.prototype.RaiseBeforeCellDraw=function(t,e,i,r,n,o){var s=null;return this.Grid.raiseBeginCellDraw&&(s=new _i(t,e,i,r,n,o),this.Grid.onBeginCellDraw(s),o=s.style),o},i.prototype.raiseAfterCellDraw=function(t,e,i,r,n,o){var s=null;this.Grid.raiseEndCellDraw&&(s=new Ki(t,e,i,r,n,o),this.Grid.onEndCellDraw(s))},i.prototype.reArrangePages=function(t){for(var e=this.currentPage.document,i=[],r=t.keys(),n=(t.values(),0);n<r.length;n++){(a=r[n]).section=null,i.push(a),e.pages.remove(a)}for(n=0;n<t.size();n++)for(var o=n,s=t.size()/this.columnRanges.length;o<t.size();o+=s){var a;void 0!==(a=i[o])&&-1===e.pages.indexOf(a)&&e.pages.add(a)}},i.prototype.getLayoutResult=function(){if(this.Grid.isChildGrid&&this.Grid.allowRowBreakAcrossPages)for(var t=0;t<this.Grid.rows.count;t++){var e=this.Grid.rows.getRow(t);e.rowBreakHeight>0&&e.repeatFlag&&(this.startLocation.y=this.currentPage.origin.y)}var i;return this.isChanged||(i=new k(this.startLocation,new j(this.currentBounds.width,this.currentBounds.y-this.startLocation.y))),new zi(this.currentPage,i)},i.prototype.ReCalculateHeight=function(t,e){for(var i=0,r=this.cellStartIndex;r<=this.cellEndIndex;r++)null!==t.cells.getCell(r).remainingString&&""!==t.cells.getCell(r).remainingString&&void 0!==t.cells.getCell(r).remainingString&&(i=Math.max(i,t.cells.getCell(r).measureHeight()));return Math.max(e,i)},i.prototype.raiseBeforePageLayout=function(t,e,i){var r=!1;if(this.Grid.raiseBeginPageLayout){var n=new Xi(e,t,i);this.Grid.onBeginPageLayout(n),r=void 0!==n.cancel&&n.cancel,e=n.bounds,i=n.startRowIndex}return{returnValue:r,currentBounds:e,currentRowIndex:i}},i.prototype.raisePageLayouted=function(t){var e=new Ji(t);return this.Grid.raiseEndPageLayout&&this.Grid.onEndPageLayout(e),e},i.prototype.drawRow=function(e,r,n){if(void 0===r){var o=new Zi,s=0,a=new j(0,0),h=!1;if(e.rowSpanExists){var l=0,u=this.Grid.rows.rowCollection.indexOf(e);-1===u&&-1!==(u=this.Grid.headers.indexOf(e))&&(h=!0);for(var c=0;c<e.cells.count;c++){var p=e.cells.getCell(c);l=Math.max(l,p.rowSpan)}for(c=u;c<u+l;c++)s+=h?this.Grid.headers.getHeader(c).height:this.Grid.rows.getRow(c).height}var d=e.rowBreakHeight>0?e.rowBreakHeight:e.height;if(void 0!==this.Grid.isChildGrid&&this.Grid.isChildGrid&&void 0!==this.Grid.ParentCell&&null!=this.Grid.ParentCell)this.currentBounds.y+this.Grid.ParentCell.row.grid.style.cellPadding.bottom+d>this.currentPageBounds.height||this.currentBounds.y+this.Grid.ParentCell.row.grid.style.cellPadding.bottom+d>this.currentBounds.height||this.currentBounds.y+this.Grid.ParentCell.row.grid.style.cellPadding.bottom+s>this.currentPageBounds.height?(void 0!==this.Grid.ParentCell.row.grid.LayoutFormat&&this.Grid.ParentCell.row.grid.LayoutFormat.break===t.PdfLayoutBreakType.FitPage&&(i.repeatRowIndex=this.Grid.rows.rowCollection.indexOf(e),this.Grid.splitChildRowIndex=this.Grid.rows.rowCollection.indexOf(e)),i.repeatRowIndex>-1&&i.repeatRowIndex===e.rowIndex&&this.Grid.allowRowBreakAcrossPages&&(o.isFinish=!0,o.bounds=this.currentBounds,this.drawRowWithBreak(o,e,d),e.repeatFlag=!0,e.repeatRowNumber=i.repeatRowIndex)):(o.isFinish=!0,e.grid.ParentCell.row.rowBreakHeightValue>0?e.repeatFlag=!0:(e.repeatFlag=!1,d=e.height),this.Grid.isChildGrid&&e.rowBreakHeight>0&&null!=this.Grid.ParentCell.row.grid.style.cellPadding&&(d+=this.Grid.ParentCell.row.grid.style.cellPadding.bottom),this.drawRow(e,o,d));else if(d>this.currentPageBounds.height)this.Grid.allowRowBreakAcrossPages&&(o.isFinish=!0,this.drawRowWithBreak(o,e,d),e.isrowFinish=!0,e.repeatFlag=!0,-1!==e.grid.splitChildRowIndex&&(o.isFinish=!1));else if(this.currentBounds.y+d>this.currentPageBounds.height||this.currentBounds.y+d>this.currentBounds.height+this.startLocation.y||this.currentBounds.y+s>this.currentPageBounds.height){var f=!1;!this.Grid.allowRowBreakAcrossPages||this.Grid.repeatHeader||e.isRowHeightSet||e.rowMergeComplete?this.Grid.allowRowBreakAcrossPages&&null!=this.Grid.LayoutFormat&&this.Grid.LayoutFormat.layout==t.PdfLayoutType.Paginate&&this.Grid.LayoutFormat.break!=t.PdfLayoutBreakType.FitElement&&e.isRowHeightSet&&this.currentBounds.y+n>this.currentPageBounds.height&&((f=this.isFitToCell(this.currentPageBounds.height-this.currentBounds.y,this.Grid,e))||(f=!(null!==this.slr&&0==this.slr.actualSize.height&&null!=this.slr.remainder&&this.slr.remainder.length>0&&this.remainderText==this.slr.remainder)),f&&null!=this.slr&&this.slr.lineCount>1&&(f=!1),this.remainderText=null):(f=null!==this.Grid.LayoutFormat&&this.Grid.LayoutFormat.paginateBounds.height>0?this.isFitToCell(this.currentBounds.height+this.startLocation.y-this.currentBounds.y,this.Grid,e):this.isFitToCell(this.currentPageBounds.height-this.currentBounds.y,this.Grid,e))&&(this.isPaginate=!0),i.repeatRowIndex>-1&&i.repeatRowIndex===e.rowIndex||f?this.Grid.allowRowBreakAcrossPages?(o.isFinish=!0,this.drawRowWithBreak(o,e,d),e.repeatFlag=!0,e.repeatRowNumber=i.repeatRowIndex,-1!==e.grid.splitChildRowIndex&&(o.isFinish=!1)):(o.isFinish=!1,this.drawRow(e,o,d)):o.isFinish=!1}else o.isFinish=!0,this.drawRow(e,o,d),e.repeatFlag=!1;return o}var g=new T(this.currentBounds.x,this.currentBounds.y);r.bounds=new k(g,new j(0,0)),n=this.ReCalculateHeight(e,n);for(c=this.cellStartIndex;c<=this.cellEndIndex;c++){var m=c>this.cellEndIndex+1&&e.cells.getCell(c).columnSpan>1;if(!m)for(var y=1;y<e.cells.getCell(c).columnSpan;y++)e.cells.getCell(c+y).isCellMergeContinue=!0;a=new j(this.Grid.columns.getColumn(c).width,n);!this.CheckIfDefaultFormat(this.Grid.columns.getColumn(c).format)&&this.CheckIfDefaultFormat(e.cells.getCell(c).stringFormat)&&(e.cells.getCell(c).stringFormat=this.Grid.columns.getColumn(c).format);var b=e.cells.getCell(c).style,w="string"==typeof e.cells.getCell(c).value&&null!==e.cells.getCell(c).value?e.cells.getCell(c).value:"";if(e.cells.getCell(c).style=this.RaiseBeforeCellDraw(this.currentGraphics,this.currentRowIndex,c,new k(g,a),w,b),e.cells.getCell(c).value instanceof Ii){(S=e.cells.getCell(c).value).parentCellIndex=c}var P=e.cells.getCell(c).draw(this.currentGraphics,new k(g,a),m);if(e.grid.style.allowHorizontalOverflow&&(e.cells.getCell(c).columnSpan>this.cellEndIndex||c+e.cells.getCell(c).columnSpan>this.cellEndIndex+1)&&this.cellEndIndex<e.cells.count-1&&(e.rowOverflowIndex=this.cellEndIndex),e.grid.style.allowHorizontalOverflow&&e.rowOverflowIndex>0&&(e.cells.getCell(c).columnSpan>this.cellEndIndex||c+e.cells.getCell(c).columnSpan>this.cellEndIndex+1)&&e.cells.getCell(c).columnSpan-this.cellEndIndex+c-1>0&&(e.cells.getCell(e.rowOverflowIndex+1).value=null!==P&&void 0!==P.remainder?P.remainder:"",e.cells.getCell(e.rowOverflowIndex+1).stringFormat=e.cells.getCell(c).stringFormat,e.cells.getCell(e.rowOverflowIndex+1).style=e.cells.getCell(c).style,e.cells.getCell(e.rowOverflowIndex+1).columnSpan=e.cells.getCell(c).columnSpan-this.cellEndIndex+c-1),w="string"==typeof e.cells.getCell(c).value&&null!==e.cells.getCell(c).value?e.cells.getCell(c).value:"",m||this.raiseAfterCellDraw(this.currentGraphics,this.currentRowIndex,c,new k(g,a),w,e.cells.getCell(c).style),e.cells.getCell(c).value instanceof Ii){var S=e.cells.getCell(c).value;this.Grid.columns.getColumn(c).width>=this.currentGraphics.clientSize.width?(g.x=S.rowLayoutBoundsWidth,g.x+=S.style.cellSpacing):g.x+=this.Grid.columns.getColumn(c).width}else g.x+=this.Grid.columns.getColumn(c).width}e.rowMergeComplete&&!e.isRowHeightSet||(this.currentBounds.y+=n),r.bounds=new k(new T(r.bounds.x,r.bounds.y),new j(g.x,g.y))},i.prototype.isFitToCell=function(t,e,i){for(var r=!1,n=new F,o=0;o<i.cells.count;o++){var s=i.cells.getCell(o);if(void 0!==s.value&&null!==s.value&&"string"==typeof s.value){var a=null;a=void 0!==s.style.font&&null!=s.style.font?s.style.font:void 0!==s.row.style.font&&null!=s.row.style.font?s.row.style.font:void 0!==s.row.grid.style.font&&null!=s.row.grid.style.font?s.row.grid.style.font:Ce.defaultFont,this.remainderText=i.cells.getCell(o).value;var h=i.cells.getCell(o).width;e.columns.getColumn(o).isCustomWidth&&i.cells.getCell(o).width>e.columns.getColumn(o).width&&(h=e.columns.getColumn(o).width),this.slr=n.layout(i.cells.getCell(o).value,a,i.cells.getCell(o).stringFormat,new j(h,t),!1,this.currentPageBounds);var l=this.slr.actualSize.height;if(0==l){r=!1;break}if(null!=i.cells.getCell(o).style&&null!=i.cells.getCell(o).style.borders&&null!=i.cells.getCell(o).style.borders.top&&null!=i.cells.getCell(o).style.borders.bottom&&(l+=2*(i.cells.getCell(o).style.borders.top.width+i.cells.getCell(o).style.borders.bottom.width)),this.slr.lineCount>1&&null!=i.cells.getCell(o).stringFormat&&0!=i.cells.getCell(o).stringFormat.lineSpacing&&(l+=(this.slr.lineCount-1)*i.cells.getCell(o).style.stringFormat.lineSpacing),i.cells.getCell(o).style.cellPadding,l+=e.style.cellPadding.top+e.style.cellPadding.bottom,l+=e.style.cellSpacing,t>l||void 0!==this.slr.remainder&&null!==this.slr.remainder){r=!0;break}}}return r},i.prototype.drawRowWithBreak=function(t,e,i){var r=new T(this.currentBounds.x,this.currentBounds.y);e.grid.isChildGrid&&e.grid.allowRowBreakAcrossPages&&this.startLocation.x!==this.currentBounds.x&&(r.x=this.startLocation.x),t.bounds=new k(r,new j(0,0)),this.gridHeight=e.rowBreakHeight>0?this.currentPageBounds.height:0,e.grid.style.cellPadding.top+this.currentBounds.y+e.grid.style.cellPadding.bottom<this.currentPageBounds.height&&(e.rowBreakHeight=this.currentBounds.y+i-this.currentPageBounds.height);for(var n=0;n<e.cells.count;n++){var o=e.cells.getCell(n);o.measureHeight()===i&&o.value instanceof Ii&&(e.rowBreakHeight=0)}for(n=this.cellStartIndex;n<=this.cellEndIndex;n++){var s=e.cells.getCell(n).columnSpan+n>this.cellEndIndex+1&&e.cells.getCell(n).columnSpan>1,a=new j(this.Grid.columns.getColumn(n).width,this.gridHeight>0?this.gridHeight:this.currentPageBounds.height),h=e.cells.getCell(n).style;e.cells.getCell(n).style=h;var l=null;if(l=e.cells.getCell(n).draw(this.currentGraphics,new k(r,a),s),e.rowBreakHeight>0&&null!=l&&void 0!==l.remainder&&(e.cells.getCell(n).FinishedDrawingCell=!1,e.cells.getCell(n).remainingString=null==l.remainder?" ":l.remainder,e.rowBreakHeight=i-l.actualSize.height),t.isFinish=t.isFinish?e.cells.getCell(n).FinishedDrawingCell:t.isFinish,e.cells.getCell(n).value instanceof Ii){var u=e.cells.getCell(n).value;this.rowBreakPageHeightCellIndex=n,this.Grid.columns.getColumn(n).width>=this.currentGraphics.clientSize.width?(r.x=this.rowLayoutBoundsWidth,r.x+=u.style.cellSpacing):r.x+=this.Grid.columns.getColumn(n).width}else r.x+=this.Grid.columns.getColumn(n).width}this.currentBounds.y+=this.gridHeight>0?this.gridHeight:i,t.bounds=new k(new T(t.bounds.x,t.bounds.y),new j(r.x,r.y))},i.repeatRowIndex=-1,i}(Me),zi=function(t){function e(e,i){return t.call(this,e,i)||this}return Ei(e,t),e}(Fe),Wi=function(t){function e(e){return t.call(this,e)||this}return Ei(e,t),e}(Ae),Hi=function(){function t(t,e,i,r,n){this.gridRowIndex=e,this.gridCellIndex=i,this.internalValue=n,this.gridBounds=r,this.pdfGraphics=t}return Object.defineProperty(t.prototype,"rowIndex",{get:function(){return this.gridRowIndex},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"cellIndex",{get:function(){return this.gridCellIndex},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"value",{get:function(){return this.internalValue},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"bounds",{get:function(){return this.gridBounds},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"graphics",{get:function(){return this.pdfGraphics},enumerable:!0,configurable:!0}),t}(),_i=function(t){function e(e,i,r,n,o,s){var a=t.call(this,e,i,r,n,o)||this;return a.style=s,a}return Ei(e,t),Object.defineProperty(e.prototype,"skip",{get:function(){return this.bSkip},set:function(t){this.bSkip=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"style",{get:function(){return this.cellStyle},set:function(t){this.cellStyle=t},enumerable:!0,configurable:!0}),e}(Hi),Ki=function(t){function e(e,i,r,n,o,s){var a=t.call(this,e,i,r,n,o)||this;return a.cellStyle=s,a}return Ei(e,t),Object.defineProperty(e.prototype,"style",{get:function(){return this.cellStyle},enumerable:!0,configurable:!0}),e}(Hi),Ui=function(){function t(){}return Object.defineProperty(t.prototype,"cancel",{get:function(){return this.isCancel},set:function(t){this.isCancel=t},enumerable:!0,configurable:!0}),t}(),qi=function(t){function e(e,i){var r=t.call(this)||this;return r.bounds=e,r.pdfPage=i,r}return Ei(e,t),Object.defineProperty(e.prototype,"bounds",{get:function(){return this.cellBounds},set:function(t){this.cellBounds=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"page",{get:function(){return this.pdfPage},enumerable:!0,configurable:!0}),e}(Ui),Yi=function(t){function e(e){var i=t.call(this)||this;return i.layoutResult=e,i}return Ei(e,t),Object.defineProperty(e.prototype,"result",{get:function(){return this.layoutResult},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"nextPage",{get:function(){return this.nextPdfPage},set:function(t){this.nextPdfPage=t},enumerable:!0,configurable:!0}),e}(Ui),Xi=function(t){function e(e,i,r){var n=t.call(this,e,i)||this;return n.startRow=r,n}return Ei(e,t),Object.defineProperty(e.prototype,"startRowIndex",{get:function(){return this.startRow},enumerable:!0,configurable:!0}),e}(qi),Ji=function(t){function e(e){return t.call(this,e)||this}return Ei(e,t),e}(Yi),Zi=function(){function t(){this.layoutedBounds=new k(0,0,0,0)}return Object.defineProperty(t.prototype,"isFinish",{get:function(){return this.bIsFinished},set:function(t){this.bIsFinished=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"bounds",{get:function(){return this.layoutedBounds},set:function(t){this.layoutedBounds=t},enumerable:!0,configurable:!0}),t}(),$i=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),Qi=function(e){function i(t){var i=e.call(this,t)||this;return i.olderPdfForm=0,i.shapeBounds=new k,i.totalPageSize=0,i}return $i(i,e),Object.defineProperty(i.prototype,"element",{get:function(){return this.elements},enumerable:!0,configurable:!0}),i.prototype.layoutInternal=function(t){var e=t.page,i=t.bounds,r=this.element.getBounds();r.x=0,r.y=0;var n=this.shapeBounds.x===this.shapeBounds.y&&this.shapeBounds.y===this.shapeBounds.width&&this.shapeBounds.width===this.shapeBounds.height&&0===this.shapeBounds.height;this.isPdfGrid&&!n&&(r=this.shapeBounds);var o=null,s=new tr;for(s.page=e;;){var a=this.raiseBeforePageLayout(e,i);i=a.currentBounds;var h=null;if(a.cancel||(s=this.layoutOnPage(e,i,r,t),h=this.raiseEndPageLayout(s),a.cancel=null!==h&&h.cancel),s.end||a.cancel){o=this.getLayoutResult(s);break}if(i=this.getPaginateBounds(t),r=this.getNextShapeBounds(r,s),e=null===h||null===h.nextPage?this.getNextPage(e):h.nextPage,this.isPdfGrid){o=this.getLayoutResult(s);break}}return o},i.prototype.raiseBeforePageLayout=function(t,e){var i=!1;if(this.element.raiseBeginPageLayout){var r=new qi(e,t);this.element.onBeginPageLayout(r),i=r.cancel,e=r.bounds}return{currentBounds:e,cancel:i}},i.prototype.raiseEndPageLayout=function(t){var e=null;if(this.element.raiseEndPageLayout){var i=this.getLayoutResult(t);e=new Yi(i),this.element.onEndPageLayout(e)}return e},i.prototype.getLayoutResult=function(t){return new Fe(t.page,t.bounds)},i.prototype.getNextShapeBounds=function(t,e){var i=e.bounds;return t.y=t.y+i.height,t.height=t.height-i.height,t},i.prototype.layoutOnPage=function(e,i,r,n){var o=new tr;i=this.checkCorrectCurrentBounds(e,i,n);var s=this.fitsToBounds(i,r),a=!1;if(!(n.format.break===t.PdfLayoutBreakType.FitElement&&!s&&e===n.page)){var h=this.getDrawBounds(i,r);this.drawShape(e.graphics,i,h),o.bounds=this.getPageResultBounds(i,r),a=i.height>=r.height}return o.end=a||n.format.layout===t.PdfLayoutType.OnePage,o.page=e,o},i.prototype.getDrawBounds=function(t,e){var i=t;return i.y=i.y-e.y,i.height=i.height+e.y,i},i.prototype.drawShape=function(t,e,i){var r=t.save();try{t.setClip(e),this.element.drawGraphicsHelper(t,new T(i.x,i.y))}finally{t.restore(r)}},i.prototype.checkCorrectCurrentBounds=function(t,e,i){var r=t.graphics.clientSize;return e.width=e.width>0?e.width:r.width-e.x,e.height=e.height>0?e.height:r.height-e.y,this.isPdfGrid&&(e.height=e.height-this.bottomCellPadding),e},i.prototype.getPageResultBounds=function(t,e){var i=t;return i.height=Math.min(i.height,e.height),i},i.prototype.fitsToBounds=function(t,e){return e.height<=t.height},i.index=0,i.splitDiff=0,i.last=!1,i.borderWidth=0,i}(Me),tr=function(){return function(){}}(),er=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),ir=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return er(e,t),e.prototype.getBounds=function(){return this.getBoundsInternal()},e.prototype.drawGraphicsHelper=function(t,e){if(null==t)throw new Error("ArgumentNullException :graphics");this.drawShapeHelper(t,e.x,e.y)},e.prototype.drawShapeHelper=function(t,e,i){var r=.5!==e||.5!==i,n=null;r&&(n=t.save(),t.translateTransform(e,i)),this.drawInternal(t),r&&t.restore(n)},e.prototype.layout=function(t){return new Qi(this).layout(t)},e}(Ge),rr=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),nr=function(t){function e(e){var i=t.call(this)||this;return void 0!==e&&(i.mpen=e),i}return rr(e,t),Object.defineProperty(e.prototype,"pen",{get:function(){return this.mpen},set:function(t){this.mpen=t},enumerable:!0,configurable:!0}),e}(ir),or=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),sr=function(t){function e(e,i){var r=t.call(this)||this;return r.mbrush=null,void 0===e||(e instanceof Q?r=t.call(this,e)||this:r.mbrush=i),r}return or(e,t),Object.defineProperty(e.prototype,"brush",{get:function(){return this.mbrush},set:function(t){this.mbrush=t},enumerable:!0,configurable:!0}),e.prototype.obtainPen=function(){return null==this.mbrush&&null==this.pen?new Q(new L(0,0,0)):this.pen},e}(nr),ar=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),hr=function(e){function i(i,r,n,o){var s=e.call(this)||this;return s.mpoints=null,s.mpathTypes=null,s.mStartFigure=!0,s.mfillMode=t.PdfFillMode.Alternate,s.isBeziers3=!1,s.isXps=!1,void 0===i||(i instanceof Q?(s=e.call(this,i)||this,r instanceof R?(s=e.call(this,i,r)||this).fillMode=n:null!==r&&void 0!==r&&null!==n&&void 0!==n&&s.addPath(r,n)):i instanceof R?(s=e.call(this,i)||this,null!==r&&void 0!==r&&(s.fillMode=r),null!==n&&void 0!==n&&null!==o&&void 0!==o&&s.addPath(n,o)):s.addPath(i,r)),s}return ar(i,e),Object.defineProperty(i.prototype,"fillMode",{get:function(){return this.mfillMode},set:function(t){this.mfillMode=t},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"pathPoints",{get:function(){return this.points},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"pathTypes",{get:function(){return this.types},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"pointCount",{get:function(){var t=0;return null!=this.mpoints&&(t=this.mpoints.length),t},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"lastPoint",{get:function(){return this.getLastPoint()},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"points",{get:function(){return null==this.mpoints&&(this.mpoints=[]),this.mpoints},enumerable:!0,configurable:!0}),Object.defineProperty(i.prototype,"types",{get:function(){return null==this.mpathTypes&&(this.mpathTypes=[]),this.mpathTypes},enumerable:!0,configurable:!0}),i.prototype.draw=function(t,e,i,r){if(e instanceof T&&void 0===e.width&&void 0===i)return this.drawHelper(t,e.x,e.y);if(e instanceof k&&void 0!==e.width&&void 0===i)return this.drawHelper(t,e,null);if("number"==typeof e&&"number"==typeof i&&void 0===r)return this.drawHelper(t,e,i,null);if(e instanceof T&&i instanceof Ae)return this.drawHelper(t,e.x,e.y,i);if("number"==typeof e&&(r instanceof Ae||null==r)&&"number"==typeof i){var n=t.graphics.clientSize.width-e,o=new k(e,i,n,0);return this.drawHelper(t,o,r)}return this.drawHelper(t,e,i)},i.prototype.addArc=function(e,i,r,n,o,s){if(e instanceof k)this.addArc(e.x,e.y,e.width,e.height,i,r);else for(var a=this.getBezierArcPoints(e,i,i+r,i+n,o,s),h=0;h<a.length;h+=8){var l=[a[h],a[h+1],a[h+2],a[h+3],a[h+4],a[h+5],a[h+6],a[h+7]];this.addPoints(l,t.PathPointType.Bezier3)}},i.prototype.addBezier=function(e,i,r,n,o,s,a,h){if(e instanceof T&&i instanceof T&&r instanceof T&&n instanceof T)this.addBezier(e.x,e.y,i.x,i.y,r.x,r.y,n.x,n.y);else{var l=[];l.push(e),l.push(i),l.push(r),l.push(n),l.push(o),l.push(s),l.push(a),l.push(h),this.addPoints(l,t.PathPointType.Bezier3)}},i.prototype.addEllipse=function(t,e,i,r){t instanceof k?this.addEllipse(t.x,t.y,t.width,t.height):(this.startFigure(),this.addArc(t,e,i,r,0,360),this.closeFigure())},i.prototype.addLine=function(e,i,r,n){if(e instanceof T&&i instanceof T)this.addLine(e.x,e.y,i.x,i.y);else{var o=[];o.push(e),o.push(i),o.push(r),o.push(n),this.addPoints(o,t.PathPointType.Line)}},i.prototype.addPath=function(t,e){if(t instanceof i)this.addPath(t.pathPoints,t.pathTypes);else{if(null==t)throw new Error("ArgumentNullException:pathPoints");if(null==e)throw new Error("ArgumentNullException:pathTypes");if(t.length!==e.length)throw new Error("The argument arrays should be of equal length.")}},i.prototype.addPie=function(e,i,r,n,o,s){e instanceof k?this.addPie(e.x,e.y,e.width,e.height,i,r):(this.startFigure(),this.addArc(e,i,r,n,o,s),this.addPoint(new T(e+r/2,i+n/2),t.PathPointType.Line),this.closeFigure())},i.prototype.addPolygon=function(e){e.length;var i=[];this.startFigure();for(var r=0;r<e.length;r++)i.push(e[r].x),i.push(e[r].y);this.addPoints(i,t.PathPointType.Line),this.closeFigure()},i.prototype.addRectangle=function(e,i,r,n){if(e instanceof k)this.addRectangle(e.x,e.y,e.width,e.height);else{var o=[];this.startFigure(),o.push(e),o.push(i),o.push(e+r),o.push(i),o.push(e+r),o.push(i+n),o.push(e),o.push(i+n),this.addPoints(o,t.PathPointType.Line),this.closeFigure()}},i.prototype.startFigure=function(){this.mStartFigure=!0},i.prototype.closeAllFigures=function(){for(var e=this.pathPoints[0],i=0;i<this.mpathTypes.length;i++){var r=this.types[i],n=!1;0!==i&&r===t.PathPointType.Start?(this.closeFigure(i-1),n=!0):i===this.mpathTypes.length-1&&!n&&this.isXps&&e.x===this.pathPoints[i].y&&this.closeFigure(i)}},i.prototype.getLastPoint=function(){var t=new T(0,0),e=this.pointCount;return e>0&&null!=this.mpoints&&(t.x=this.mpoints[e-1].x,t.y=this.mpoints[e-1].y),t},i.prototype.getBezierArcPoints=function(t,e,i,r,n,o){if(t>i){var s=void 0;s=t,t=i,i=s}if(r>e){s=void 0;s=e,e=r,r=s}var a,h;Math.abs(o)<=90?(a=o,h=1):a=o/(h=Math.ceil(Math.abs(o)/90));for(var l=(t+i)/2,u=(e+r)/2,c=(i-t)/2,p=(r-e)/2,d=a*(Math.PI/360),f=Math.abs(4/3*(1-Math.cos(d))/Math.sin(d)),g=[],m=0;m<h;m++){var y=(n+m*a)*(Math.PI/180),b=(n+(m+1)*a)*(Math.PI/180),w=Math.cos(y),P=Math.cos(b),S=Math.sin(y),v=Math.sin(b);a>0?g.push(l+c*w,u-p*S,l+c*(w-f*S),u-p*(S+f*w),l+c*(P+f*v),u-p*(v-f*P),l+c*P,u-p*v):g.push(l+c*w,u-p*S,l+c*(w+f*S),u-p*(S-f*w),l+c*(P-f*v),u-p*(v+f*P),l+c*P,u-p*v)}return g},i.prototype.getBoundsInternal=function(){var t=this.pathPoints,e=new k(0,0,0,0);if(t.length>0){for(var i=t[0].x,r=t[0].x,n=t[0].y,o=t[0].y,s=1;s<t.length;s++){var a=t[s];i=Math.min(a.x,i),r=Math.max(a.x,r),n=Math.min(a.y,n),o=Math.max(a.y,o)}e=new k(i,n,r-i,o-n)}return e},i.prototype.drawInternal=function(t){if(null==t)throw new Error("ArgumentNullException :graphics");t.drawPath(this.obtainPen(),this.brush,this)},i.prototype.addPoints=function(e,i,r,n){if(void 0===r&&void 0===n)this.addPoints(e,i,0,e.length);else for(var o=r;o<n;o++){var s=new T(e[o],e[o+1]);o===r?this.pointCount<=0||this.mStartFigure?(this.addPoint(s,t.PathPointType.Start),this.mStartFigure=!1):s.x===this.lastPoint.x||s.y===this.lastPoint.y||this.isBeziers3?s.x!==this.lastPoint.x&&s.y!==this.lastPoint.y&&this.addPoint(s,t.PathPointType.Bezier3):this.addPoint(s,t.PathPointType.Line):this.addPoint(s,i),o++}},i.prototype.addPoint=function(t,e){this.points.push(t),this.types.push(e)},i.prototype.closeFigure=function(e){if(void 0===e)this.pointCount>0&&this.closeFigure(this.pointCount-1),this.startFigure();else{if(e<0)throw new Error("IndexOutOfRangeException()");var i=this.types[e];i|=t.PathPointType.CloseSubpath,this.types[e]=i}},i}(sr),lr=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),ur=function(t){function e(e,i,r,n,o,s){var a=t.call(this)||this;return a.bounds=new k(0,0,0,0),void 0===e||(e instanceof Q?(a=t.call(this,e,i)||this).bounds=r instanceof k?r:new k(r,n,o,s):a.bounds=e instanceof k?e:new k(e,i,r,n)),a}return lr(e,t),Object.defineProperty(e.prototype,"x",{get:function(){return this.bounds.x},set:function(t){this.bounds.x=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"y",{get:function(){return this.bounds.y},set:function(t){this.bounds.y=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"width",{get:function(){return this.bounds.width},set:function(t){this.bounds.width=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"height",{get:function(){return this.bounds.height},set:function(t){this.bounds.height=t},enumerable:!0,configurable:!0}),e.prototype.getBoundsInternal=function(){return this.bounds},e}(sr),cr=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),pr=function(t){function e(e,i,r,n,o,s,a,h){var l=t.call(this)||this;return l.startAngle=0,l.sweepAngle=0,void 0===e||(e instanceof k&&void 0!==i&&void 0!==r?((l=t.call(this,e)||this).startAngle=i,l.sweepAngle=r):e instanceof Q?r instanceof k?((l=t.call(this,e,i,r)||this).startAngle=n,l.sweepAngle=o):((l=t.call(this,e,i,r,n,o,s)||this).startAngle=a,l.sweepAngle=h):((l=t.call(this,e,i,r,n)||this).startAngle=o,l.sweepAngle=s)),l}return cr(e,t),e}(ur),dr=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),fr=function(t){function e(e,i,r,n,o,s,a){var h=this;return void 0===e?h=t.call(this)||this:e instanceof k?h=t.call(this,e,i,r)||this:e instanceof Q?i instanceof k?h=t.call(this,e,null,i,r,n)||this:void 0===s&&void 0===a?h=t.call(this,e,null,0,0,i,r,n,o)||this:void 0!==s&&void 0!==a&&(h=t.call(this,e,null,i,r,n,o,s,a)||this):void 0!==e&&void 0===o&&void 0===s?h=t.call(this,0,0,e,i,r,n)||this:void 0!==e&&void 0!==o&&void 0!==s&&(h=t.call(this,e,i,r,n,o,s)||this),h}return dr(e,t),e.prototype.draw=function(t,e,i,r){if(e instanceof T&&void 0===e.width&&void 0===i)return this.drawHelper(t,e.x,e.y);if(e instanceof k&&void 0!==e.width&&void 0===i)return this.drawHelper(t,e,null);if("number"==typeof e&&"number"==typeof i&&void 0===r)return this.drawHelper(t,e,i,null);if(e instanceof T&&i instanceof Ae)return this.drawHelper(t,e.x,e.y,i);if("number"==typeof e&&(r instanceof Ae||null==r)&&"number"==typeof i){var n=t.graphics.clientSize.width-e,o=new k(e,i,n,0);return this.drawHelper(t,o,r)}return this.drawHelper(t,e,i)},e.prototype.drawInternal=function(t){if(null==t)throw new Error("ArgumentNullException : graphics");t.drawArc(this.obtainPen(),this.bounds,this.startAngle,this.sweepAngle)},e}(pr),gr=function(){var t=function(e,i){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(e,i)};return function(e,i){function r(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(r.prototype=i.prototype,new r)}}(),mr=function(e){function i(i,r,n){var o=e.call(this,r)||this;return o.isEmbedFont=!1,o.isUnicode=!0,void 0!==n?o.createFontInternal(i,n):o.createFontInternal(i,t.PdfFontStyle.Regular),o}return gr(i,e),i.prototype.equalsToFont=function(t){return!1},i.prototype.getLineWidth=function(e,i){var r=0;if(null!==i&&void 0!==i&&i.textDirection!==t.PdfTextDirection.None){r=this.getUnicodeLineWidth(e,r,i).width}else r=this.fontInternal.getLineWidth(e);var n=this.metrics.getSize(i);return r*=G.charSizeMultiplier*n,r=this.applyFormatSettings(e,i,r)},i.prototype.getCharWidth=function(t,e){var i=this.fontInternal.getCharWidth(t);return i*=.001*this.metrics.getSize(e)},i.prototype.createFontInternal=function(t,e){this.fontInternal=new Gt(t,this.size),this.calculateStyle(e),this.initializeInternals()},i.prototype.calculateStyle=function(e){var i=this.fontInternal.ttfMetrics.macStyle;0!=(e&t.PdfFontStyle.Underline)&&(i|=t.PdfFontStyle.Underline),0!=(e&t.PdfFontStyle.Strikeout)&&(i|=t.PdfFontStyle.Strikeout),this.setStyle(i)},i.prototype.initializeInternals=function(){var t=null;Ce.enableCache&&(t=Ce.cache.search(this));var e=null;if(null!==t&&void 0!==t){e=t.getInternals();var i=t.metrics;(i=i.clone()).size=this.size,this.metrics=i,this.fontInternal=t.fontInternal}else null==t&&(this.fontInternal instanceof Gt&&(this.fontInternal.isEmbed=this.isEmbedFont),this.fontInternal.createInternals(),e=this.fontInternal.getInternals(),this.metrics=this.fontInternal.metrics);this.metrics.isUnicodeFont=!0,this.setInternals(e)},i.prototype.setSymbols=function(t){var e=this.fontInternal;null!=e&&e.setSymbols(t)},Object.defineProperty(i.prototype,"Unicode",{get:function(){return this.isUnicode},enumerable:!0,configurable:!0}),i.prototype.getUnicodeLineWidth=function(e,i,r){i=0;var n=null,o=(new Kt).getGlyphIndex(e,this,r.textDirection===t.PdfTextDirection.RightToLeft,n,!0),s=o.success;if(n=o.glyphs,s&&null!==n)for(var a=this.fontInternal.ttfReader,h=0,l=n.length;h<l;h++){var u=n[h],c=a.getGlyph(u);null!==c&&void 0!==c&&(i+=c.width)}return{success:s,width:i}},i}(G),yr=function(){function e(t,e,i,r,n){t instanceof k&&void 0===e?this.InitiateBounds(t.x,t.y,t.width,t.height,null):t instanceof k&&e instanceof ce&&void 0===i?this.InitiateBounds(t.x,t.y,t.width,t.height,e):t instanceof T&&e instanceof j&&void 0===i?this.InitiateBounds(t.x,t.y,e.width,e.height,null):t instanceof T&&e instanceof j&&i instanceof ce&&void 0===r?this.InitiateBounds(t.x,t.y,e.width,e.height,i):t instanceof j&&void 0===e?this.InitiateBounds(0,0,t.width,t.height,null):"number"==typeof t&&"number"==typeof e&&void 0===i?this.InitiateBounds(0,0,t,e,null):"number"==typeof t&&"number"==typeof e&&i instanceof ce&&void 0===r?this.InitiateBounds(0,0,t,e,i):this.InitiateBounds(t,e,i,r,null)}return Object.defineProperty(e.prototype,"dock",{get:function(){return this.dockStyle},set:function(t){this.dockStyle=t,this.resetAlignment()},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"alignment",{get:function(){return this.alignmentStyle},set:function(t){this.setAlignment(t)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"foreground",{get:function(){return this.isForeground},set:function(t){this.isForeground=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"background",{get:function(){return!this.isForeground},set:function(t){this.isForeground=!t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"location",{get:function(){return this.currentLocation},set:function(e){this.type===t.TemplateType.None&&(this.currentLocation=e)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"x",{get:function(){return void 0!==this.currentLocation?this.currentLocation.x:0},set:function(e){this.type===t.TemplateType.None&&(this.currentLocation.x=e)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"y",{get:function(){return void 0!==this.currentLocation?this.currentLocation.y:0},set:function(e){this.type===t.TemplateType.None&&(this.currentLocation.y=e)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"size",{get:function(){return this.template.size},set:function(e){this.type===t.TemplateType.None&&this.template.reset(e)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"width",{get:function(){return this.template.width},set:function(e){if(this.template.width!==e&&this.type===t.TemplateType.None){var i=this.template.size;i.width=e,this.template.reset(i)}},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"height",{get:function(){return this.template.height},set:function(e){if(this.template.height!==e&&this.type===t.TemplateType.None){var i=this.template.size;i.height=e,this.template.reset(i)}},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"graphics",{get:function(){return this.template.graphics},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"template",{get:function(){return this.pdfTemplate},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"type",{get:function(){return this.templateType},set:function(t){this.updateDocking(t),this.templateType=t},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"bounds",{get:function(){return new k(new T(this.x,this.y),this.size)},set:function(e){this.type===t.TemplateType.None&&(this.location=new T(e.x,e.y),this.size=new j(e.width,e.height))},enumerable:!0,configurable:!0}),e.prototype.InitiateBounds=function(t,e,i,r,n){this.x=t,this.y=e,this.pdfTemplate=new Yt(i,r)},e.prototype.updateDocking=function(e){if(e!==t.TemplateType.None){switch(e){case t.TemplateType.Top:this.dock=t.PdfDockStyle.Top;break;case t.TemplateType.Bottom:this.dock=t.PdfDockStyle.Bottom;break;case t.TemplateType.Left:this.dock=t.PdfDockStyle.Left;break;case t.TemplateType.Right:this.dock=t.PdfDockStyle.Right}this.resetAlignment()}},e.prototype.resetAlignment=function(){this.alignment=t.PdfAlignmentStyle.None},e.prototype.setAlignment=function(e){if(this.dock===t.PdfDockStyle.None)this.alignmentStyle=e;else{var i=!1;switch(this.dock){case t.PdfDockStyle.Left:i=e===t.PdfAlignmentStyle.TopLeft||e===t.PdfAlignmentStyle.MiddleLeft||e===t.PdfAlignmentStyle.BottomLeft||e===t.PdfAlignmentStyle.None;break;case t.PdfDockStyle.Top:i=e===t.PdfAlignmentStyle.TopLeft||e===t.PdfAlignmentStyle.TopCenter||e===t.PdfAlignmentStyle.TopRight||e===t.PdfAlignmentStyle.None;break;case t.PdfDockStyle.Right:i=e===t.PdfAlignmentStyle.TopRight||e===t.PdfAlignmentStyle.MiddleRight||e===t.PdfAlignmentStyle.BottomRight||e===t.PdfAlignmentStyle.None;break;case t.PdfDockStyle.Bottom:i=e===t.PdfAlignmentStyle.BottomLeft||e===t.PdfAlignmentStyle.BottomCenter||e===t.PdfAlignmentStyle.BottomRight||e===t.PdfAlignmentStyle.None;break;case t.PdfDockStyle.Fill:i=e===t.PdfAlignmentStyle.MiddleCenter||e===t.PdfAlignmentStyle.None}i&&(this.alignmentStyle=e)}},e.prototype.draw=function(t,e){var i=t.page,r=this.calculateBounds(i,e);-0===r.x&&(r.x=0),t.graphics.drawPdfTemplate(this.template,new T(r.x,r.y),new j(r.width,r.height))},e.prototype.calculateBounds=function(e,i){var r=this.bounds;return this.alignmentStyle!==t.PdfAlignmentStyle.None?r=this.getAlignmentBounds(e,i):this.dockStyle!==t.PdfDockStyle.None&&(r=this.getDockBounds(e,i)),r},e.prototype.getAlignmentBounds=function(e,i){this.bounds;return this.type===t.TemplateType.None?this.getSimpleAlignmentBounds(e,i):this.getTemplateAlignmentBounds(e,i)},e.prototype.getSimpleAlignmentBounds=function(e,i){var r=this.bounds,n=e.section.getActualBounds(i,e,!1),o=this.x,s=this.y;switch(this.alignmentStyle){case t.PdfAlignmentStyle.TopLeft:o=0,s=0;break;case t.PdfAlignmentStyle.TopCenter:o=(n.width-this.width)/2,s=0;break;case t.PdfAlignmentStyle.TopRight:o=n.width-this.width,s=0;break;case t.PdfAlignmentStyle.MiddleLeft:o=0,s=(n.height-this.height)/2;break;case t.PdfAlignmentStyle.MiddleCenter:o=(n.width-this.width)/2,s=(n.height-this.height)/2;break;case t.PdfAlignmentStyle.MiddleRight:o=n.width-this.width,s=(n.height-this.height)/2;break;case t.PdfAlignmentStyle.BottomLeft:o=0,s=n.height-this.height;break;case t.PdfAlignmentStyle.BottomCenter:o=(n.width-this.width)/2,s=n.height-this.height;break;case t.PdfAlignmentStyle.BottomRight:o=n.width-this.width,s=n.height-this.height}return r.x=o,r.y=s,r},e.prototype.getTemplateAlignmentBounds=function(e,i){var r=this.bounds,n=e.section,o=n.getActualBounds(i,e,!1),s=this.x,a=this.y;switch(this.alignmentStyle){case t.PdfAlignmentStyle.TopLeft:this.type===t.TemplateType.Left?(s=-o.x,a=0):this.type===t.TemplateType.Top&&(s=-o.x,a=-o.y);break;case t.PdfAlignmentStyle.TopCenter:s=(o.width-this.width)/2,a=-o.y;break;case t.PdfAlignmentStyle.TopRight:this.type===t.TemplateType.Right?(s=o.width+n.getRightIndentWidth(i,e,!1)-this.width,a=0):this.type===t.TemplateType.Top&&(s=o.width+n.getRightIndentWidth(i,e,!1)-this.width,a=-o.y);break;case t.PdfAlignmentStyle.MiddleLeft:s=-o.x,a=(o.height-this.height)/2;break;case t.PdfAlignmentStyle.MiddleCenter:s=(o.width-this.width)/2,a=(o.height-this.height)/2;break;case t.PdfAlignmentStyle.MiddleRight:s=o.width+n.getRightIndentWidth(i,e,!1)-this.width,a=(o.height-this.height)/2;break;case t.PdfAlignmentStyle.BottomLeft:this.type===t.TemplateType.Left?(s=-o.x,a=o.height-this.height):this.type===t.TemplateType.Bottom&&(s=-o.x,a=o.height+n.getBottomIndentHeight(i,e,!1)-this.height);break;case t.PdfAlignmentStyle.BottomCenter:s=(o.width-this.width)/2,a=o.height+n.getBottomIndentHeight(i,e,!1)-this.height;break;case t.PdfAlignmentStyle.BottomRight:this.type===t.TemplateType.Right?(s=o.width+n.getRightIndentWidth(i,e,!1)-this.width,a=o.height-this.height):this.type===t.TemplateType.Bottom&&(s=o.width+n.getRightIndentWidth(i,e,!1)-this.width,a=o.height+n.getBottomIndentHeight(i,e,!1)-this.height)}return r.x=s,r.y=a,r},e.prototype.getDockBounds=function(e,i){this.bounds;return this.type===t.TemplateType.None?this.getSimpleDockBounds(e,i):this.getTemplateDockBounds(e,i)},e.prototype.getSimpleDockBounds=function(e,i){this.bounds;var r=e.section.getActualBounds(i,e,!1),n=this.x,o=this.y,s=this.width,a=this.height;switch(this.dockStyle){case t.PdfDockStyle.Left:n=0,o=0,s=this.width,a=r.height;break;case t.PdfDockStyle.Top:n=0,o=0,s=r.width,a=this.height;break;case t.PdfDockStyle.Right:n=r.width-this.width,o=0,s=this.width,a=r.height;break;case t.PdfDockStyle.Bottom:n=0,o=r.height-this.height,s=r.width,a=this.height;break;case t.PdfDockStyle.Fill:n=0,n=0,s=r.width,a=r.height}return new k(n,o,s,a)},e.prototype.getTemplateDockBounds=function(e,i){this.bounds;var r=e.section,n=r.getActualBounds(i,e,!1),o=r.pageSettings.getActualSize(),s=this.x,a=this.y,h=this.width,l=this.height;switch(this.dockStyle){case t.PdfDockStyle.Left:s=-n.x,a=0,h=this.width,l=n.height;break;case t.PdfDockStyle.Top:s=-n.x,a=-n.y,h=o.width,l=this.height,n.height<0&&(a=-n.y+o.height);break;case t.PdfDockStyle.Right:s=n.width+r.getRightIndentWidth(i,e,!1)-this.width,a=0,h=this.width,l=n.height;break;case t.PdfDockStyle.Bottom:s=-n.x,a=n.height+r.getBottomIndentHeight(i,e,!1)-this.height,h=o.width,l=this.height,n.height<0&&(a-=o.height);break;case t.PdfDockStyle.Fill:s=0,s=0,h=n.width,l=n.height}return new k(s,a,h,l)},e}();t.PdfAction=B,t.PdfUriAction=x,t.PdfActionLinkAnnotation=Ve,t.PdfAnnotation=Le,t.PdfAnnotationCollection=le,t.PdfDocumentLinkAnnotation=Ne,t.PdfLinkAnnotation=je,t.PdfTextWebLink=Je,t.PdfUriAnnotation=Ye,t.Dictionary=n,t.defaultToString=r,t.PdfCatalog=U,t.PdfDocument=Ce,t.PdfDocumentBase=_,t.PdfDocumentTemplate=fe,t.PdfPageNumberField=ii,t.PdfCompositeField=ni,t.PdfPageCountField=hi,t.PointF=T,t.SizeF=j,t.RectangleF=k,t.Rectangle=V,t.PdfCacheCollection=Se,t.PdfCollection=oe,t.PdfDestination=ui,t.PdfFunction=ci,t.PdfSampledFunction=di,t.ProcedureSets=it,t.PdfColor=L,t.PdfGraphics=te,t.GetResourceEventHandler=ee,t.PdfGraphicsState=ie,t.PdfMargins=J,t.PdfPen=Q,t.PdfResources=Jt,t.Guid=Zt,t.PdfTransformationMatrix=tt,t.Matrix=et,t.PdfBrush=R,t.PdfBrushes=yi,t.PdfSolidBrush=M,t.PdfLinearGradientBrush=vi,t.PdfRadialGradientBrush=Bi,t.PdfTilingBrush=Qt,t.PdfGradientBrush=qt,t.PdfColorBlend=Pi,t.PdfBlend=bi,t.PdfTemplate=Yt,t.PdfLayoutElement=Ge,t.PdfPath=hr,t.PdfArc=fr,t.PdfTextElement=Ue,t.ElementLayouter=Me,t.PdfLayoutFormat=Ae,t.PdfLayoutParams=De,t.PdfLayoutResult=Fe,t.TextLayouter=We,t.TextPageLayoutResult=He,t.PdfTextLayoutResult=_e,t.PdfFont=G,t.PdfFontMetrics=Ft,t.WidthTable=It,t.StandardWidthTable=Et,t.PdfStandardFont=xe,t.PdfStandardFontMetricsFactory=Be,t.PdfStringFormat=A,t.PdfStringLayouter=F,t.PdfStringLayoutResult=I,t.LineInfo=E,t.StringTokenizer=D,t.PdfTrueTypeFont=mr,t.RtlRenderer=Kt,t.ArabicShapeRenderer=zt,t.ArabicShape=Wt,t.Bidi=Ht,t.RtlCharacters=_t,t.ByteArray=ut,t.ImageDecoder=pt,t.PdfBitmap=mt,t.PdfImage=ft,t.PdfTransparency=nt,t.PdfCrossTable=q,t.RegisteredObject=Y,t.DictionaryProperties=a,t.PdfMainObjectCollection=W,t.ObjectInfo=H,t.Operators=s,t.PdfStreamWriter=$,t.PdfWriter=z,t.PageAddedEventArgs=pe,t.PdfDocumentPageCollection=Pe,t.PdfPage=ce,t.PdfPageBase=he,t.PdfPageLayer=ne,t.PdfPageLayerCollection=ae,t.PdfPageSettings=Z,t.PdfPageSize=X,t.PdfPageTemplateElement=yr,t.PdfSection=ye,t.PageSettingsState=be,t.PdfSectionCollection=we,t.PdfSectionPageCollection=de,t.PdfSectionTemplate=me,t.PdfArray=m,t.PdfDictionary=h,t.SaveSectionCollectionEventHandler=l,t.SaveDescendantFontEventHandler=u,t.SaveFontDictionaryEventHandler=c,t.SaveAnnotationEventHandler=p,t.SaveSectionEventHandler=d,t.SaveTemplateEventHandler=f,t.PdfName=o,t.PdfNumber=g,t.PdfReference=v,t.PdfReferenceHolder=C,t.PdfStream=b,t.SaveCmapEventHandler=w,t.SaveFontProgramEventHandler=P,t.PdfString=S,t.PdfGridStyleBase=xi,t.PdfGridStyle=Li,t.PdfGridCellStyle=Ti,t.PdfGridRowStyle=ji,t.PdfBorders=Ie,t.PdfPaddings=Ee,t.PdfGridLayouter=Gi,t.PdfGridLayoutResult=zi,t.PdfGridLayoutFormat=Wi,t.GridCellEventArgs=Hi,t.PdfGridBeginCellDrawEventArgs=_i,t.PdfGridEndCellDrawEventArgs=Ki,t.PdfCancelEventArgs=Ui,t.BeginPageLayoutEventArgs=qi,t.EndPageLayoutEventArgs=Yi,t.PdfGridBeginPageLayoutEventArgs=Xi,t.PdfGridEndPageLayoutEventArgs=Ji,t.RowLayoutResult=Zi,t.PdfGrid=Ii,t.PdfGridColumn=Ri,t.PdfGridColumnCollection=Ni,t.PdfGridRow=Mi,t.PdfGridRowCollection=Ai,t.PdfGridHeaderCollection=Di,t.PdfGridCell=ki,t.PdfGridCellCollection=Vi,Object.defineProperty(t,"__esModule",{value:!0})});
	//# sourceMappingURL=ej2-pdf-export.umd.min.js.map


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	*  filename: ej2-react-base.umd.min.js
	*  version : 19.4.56
	*  Copyright Syncfusion Inc. 2001 - 2020. All rights reserved.
	*  Use of this code is subject to the terms of our license.
	*  A copy of the current license can be obtained at any time by e-mailing
	*  licensing@syncfusion.com. Any infringement will be prosecuted under
	*  applicable laws. 
	*/
	!function(e,t){ true?t(exports,__webpack_require__(3),__webpack_require__(366),__webpack_require__(23)):"function"==typeof define&&define.amd?define(["exports","react","react-dom","@syncfusion/ej2-base"],t):t(e.ej={},e.React,e.ReactDOM,e.ej2Base)}(this,function(e,t,r,i){"use strict";function s(e,s){return"string"==typeof e?f(e,s):function(s,o,n,a){var p=e,l=s;"object"==typeof p&&(p=e.template,l=i.extend({},s,e.data||{}));var c;if(c=a||document.createElement("div"),o&&o.isLegacyTemplate)r.render(p(l),c),a||i.detach(c);else{var h=t.createElement(p,l),d=r.createPortal(h,c);d.propName=n,o.portals?o.portals.push(d):o.portals=[d]}if(!a)return[c]}}var o=function(){var e=function(t,r){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])})(t,r)};return function(t,r){function i(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(i.prototype=r.prototype,new i)}}(),n=["alt","className","disabled","form","id","readOnly","style","tabIndex","title","type","name","onClick","onFocus","onBlur"],a=["accordion","tab","splitter"],p=new RegExp("]"),l=function(e){function s(){var t=null!==e&&e.apply(this,arguments)||this;return t.attrKeys=[],t.cachedTimeOut=0,t.isAppendCalled=!1,t.initRenderCalled=!1,t.isReactForeceUpdate=!1,t.isReact=!0,t.isshouldComponentUpdateCalled=!1,t}return o(s,e),s.prototype.componentDidMount=function(){this.refreshChild(!0),this.canDelayUpdate=-1!==a.indexOf(this.getModuleName()),this.renderReactComponent(),this.portals&&this.portals.length&&this.renderReactTemplates()},s.prototype.componentDidUpdate=function(e){this.isshouldComponentUpdateCalled||!this.initRenderCalled||this.isReactForeceUpdate||(this.isshouldComponentUpdateCalled=!0,e!==this.props&&this.refreshProperties(this.props,!0))},s.prototype.renderReactComponent=function(){var e=this.reactElement;e&&(this.isAppendCalled=!0,this.appendTo(e))},s.prototype.shouldComponentUpdate=function(e){return this.isshouldComponentUpdateCalled=!0,this.initRenderCalled?(this.isAppendCalled||(clearTimeout(this.cachedTimeOut),this.isAppendCalled=!0,this.appendTo(this.reactElement)),this.updateProperties(e),!0):(this.updateProperties(e,!0),!0)},s.prototype.updateProperties=function(e,t){for(var r=this,s=i.extend({},e),o=0,n=Object.keys(e);o<n.length;o++){var a=n[o],p="className"===a;if("children"!==a)if(p||i.isNullOrUndefined(this.htmlattributes[a])||this.htmlattributes[a]===s[a]||(this.htmlattributes[a]=s[a]),this.compareValues(this.props[a],e[a]))delete s[a];else if(-1!==this.attrKeys.indexOf(a))if(p){this.clsName=!0;for(var l=this.props[a].split(" "),c=0;c<l.length;c++)this.element.classList.remove(l[c]);for(var h=s[a].split(" "),d=0;d<h.length;d++)this.element.classList.add(h[d])}else"disabled"!==a&&delete s[a];else"value"===a&&e[a]===this[a]?delete s[a]:"valueTemplate"!==a&&"itemTemplate"!==a&&"headerTemplate"!==a||e[a].toString()!==this[a].toString()||delete s[a]}s.children&&delete s.children,this.initRenderCalled&&(this.canDelayUpdate||this.props.delayUpdate)?setTimeout(function(){r.refreshProperties(s,e,t)}):this.refreshProperties(s,e,t)},s.prototype.refreshProperties=function(e,t,r){Object.keys(e).length&&(r||this.processComplexTemplate(e,this),this.setProperties(e,r)),this.refreshChild(r,t)},s.prototype.processComplexTemplate=function(e,t){var r=t.complexTemplate;if(r)for(var s in r){var o=r[s];e[s]&&i.setValue(o,i.getValue(s,e),e)}},s.prototype.getDefaultAttributes=function(){var e=this;this.isReact=!0;var t=Object.keys(this.props);this.htmlattributes||(this.htmlattributes={}),this.attrKeys=n.concat(this.controlAttributes||[]);for(var r=0,i=t;r<i.length;r++){var o=i[r];-1===o.indexOf("data-")&&-1===o.indexOf("aria-")&&-1===this.attrKeys.indexOf(o)||this.htmlattributes[o]!==this.props[o]&&(this.htmlattributes[o]=this.props[o])}if(!this.htmlattributes.ref){this.htmlattributes.ref=function(t){e.reactElement=t};-1!==["autocomplete","combobox","dropdownlist","dropdowntree","multiselect","listbox","colorpicker","numerictextbox","textbox","uploader","maskedtextbox","slider","datepicker","datetimepicker","daterangepicker","timepicker","checkbox","switch","radio"].indexOf(this.getModuleName())&&(this.htmlattributes.key=""+s.reactUid,s.reactUid++)}if(this.clsName){for(var a=this.element.classList,p=this.htmlattributes.className,l=0;l<a.length;l++)-1==p.indexOf(a[l])&&(this.htmlattributes.className=this.htmlattributes.className+" "+a[l]);this.clsName=!1}return this.htmlattributes},s.prototype.trigger=function(e,t,r){var s=this;if(!0!==this.isDestroyed&&this.modelObserver){if(p.test(e)){var o=i.getValue(e,this);o?(o.call(this,t),r&&r.call(this,t)):r&&r.call(this,t)}"change"!==e&&"input"!==e||this.props.onChange&&t.event&&this.props.onChange.call(void 0,{syntheticEvent:t.event,nativeEvent:{text:t.value},value:t.value,target:this});var n=this.isProtectedOnChange;this.isProtectedOnChange=!1,"created"===e?setTimeout(function(){s.isDestroyed||s.modelObserver.notify(e,t,r)}):this.modelObserver.notify(e,t,r),this.isProtectedOnChange=n}},s.prototype.compareValues=function(e,t){if(typeof e===typeof t){if(e===t)return!0;if((!i.isNullOrUndefined(e)&&e.constructor)!==(!i.isNullOrUndefined(t)&&t.constructor))return!1;if(e instanceof Date||e instanceof RegExp||e instanceof String||e instanceof Number)return e.toString()===t.toString();if(i.isObject(e)||Array.isArray(e)){var r=e,s=t;return i.isObject(r)&&(r=[e],s=[t]),this.compareObjects(r,s).status}}return!1},s.prototype.compareObjects=function(e,t,r){var i=!0,s=[];if(e.length===t.length)for(var o=0,n=t.length;o<n;o++){var a={},p=e[o],l=t[o],c=Object.keys(l);if(0!==c.length)for(var h=0,d=c;h<d.length;h++){var u=d[h],f=p[u],m=l[u];if("items"===u)for(var y=0;y<m.length;y++)if("richtexteditor"===this.getModuleName()&&"object"==typeof m[y])return{status:!0};if("grid"===this.getModuleName()&&"field"===u&&(a[u]=m),!p.hasOwnProperty(u)||!this.compareValues(f,m)){if(!r)return{status:!1};i=!1,a[u]=m}}else{if(!r)return{status:!1};i=!1}Object.keys(a).length&&s.push({index:o,value:a,key:r})}else i=!1;return{status:i,changedProperties:s}},s.prototype.refreshChild=function(e,t){if(this.checkInjectedModules){for(var r=this.getInjectedModules()||[],s=0,o=this.getInjectedServices()||[];s<o.length;s++){var n=o[s];-1===r.indexOf(n)&&r.push(n)}this.injectedModules=r}if(this.directivekeys){var a=[],p=this.validateChildren({},this.directivekeys,t||this.props);if(p&&Object.keys(p).length){if(!e&&this.skipRefresh)for(var l=0,c=this.skipRefresh;l<c.length;l++){delete p[c[l]]}if(this.prevProperties)for(var h=Object.keys(this.prevProperties),d=0;d<h.length;d++){var u=h[d];if(p.hasOwnProperty(u)){var f=this.compareObjects(this.prevProperties[u],p[u],u);if(f.status)delete p[u];else{f.changedProperties.length&&(a=a.concat(f.changedProperties));var m={};m[u]=p[u],this.prevProperties=i.extend(this.prevProperties,m)}}}else this.prevProperties=i.extend({},p,{},!0);if(a.length)if("grid"===this.getModuleName()&&"columns"===u)for(var y=0,v=this.columns;y<v.length;y++){if(i.getValue("field",v[y])===i.getValue(y+".value.field",a)){var g=i.getValue(a[y].key+"."+a[y].index,this);g&&g.setProperties?g.setProperties(a[y].value):i.extend(g,a[y].value)}}else for(var b=0,O=a;b<O.length;b++){var C=O[b],x=i.getValue(C.key+"."+C.index,this);x&&x.setProperties?x.setProperties(C.value):i.extend(x,C.value)}else this.setProperties(p,e)}}},s.prototype.componentWillUnmount=function(){clearTimeout(this.cachedTimeOut);(this.initRenderCalled&&this.isAppendCalled&&this.element&&!["dropdowntree","checkbox"].indexOf(this.getModuleName())?document.body.contains(this.element):!this.isDestroyed)&&this.destroy()},s.prototype.appendReactElement=function(e,t){r.render(r.createPortal(e,t),t)},s.prototype.renderReactTemplates=function(e){this.isReactForeceUpdate=!0,e?this.forceUpdate(e):this.forceUpdate(),this.isReactForeceUpdate=!1},s.prototype.clearTemplate=function(e,t,r){var i=this,s=[];e&&e.length?Array.prototype.forEach.call(e,function(e){var r=0,o=0;if(i.portals.forEach(function(t){t.propName===e&&(s.push(o),o++)}),t&&i.portals[s[t[r]]].propName==e)i.portals.splice(t,1),r++;else for(var n=0;n<i.portals.length;n++)i.portals[n].propName==e&&(i.portals.splice(n,1),n--)}):this.portals=[],this.renderReactTemplates(r)},s.prototype.validateChildren=function(e,r,i){for(var s=!1,o=0,n=t.Children.toArray(i.children);o<n.length;o++){var a=n[o],p=this.getChildType(a),l=r[p];if(p&&r){var c=this.getChildProps(t.Children.toArray(a.props.children),l);c.length&&(s=!0,e[a.type.propertyName||p]=c)}}return s?e:null},s.prototype.getChildType=function(e){return e.type&&e.type.isDirective?e.type.moduleName||"":""},s.prototype.getChildProps=function(e,t){for(var r=[],s=0,o=e;s<o.length;s++){var n=o[s],a=!1,p=void 0;"string"==typeof t?(a=!0,p=t):p=Object.keys(t)[0];var l=n.props;if(this.getChildType(n)===p)if(a||!l.children){var c=i.extend({},l,{},!0);this.processComplexTemplate(c,n.type),r.push(c)}else{var h=this.validateChildren(i.extend({},l),t[p],l)||l;h.children&&delete h.children,this.processComplexTemplate(h,n.type),r.push(h)}}return r},s.prototype.getInjectedServices=function(){for(var e=0,r=t.Children.toArray(this.props.children);e<r.length;e++){var i=r[e];if(i.type.isService)return i.props.services}return[]},s.reactUid=1,s}(t.Component),c=function(){var e=function(t,r){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])})(t,r)};return function(t,r){function i(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(i.prototype=r.prototype,new i)}}(),h=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return c(t,e),t.prototype.render=function(){return null},t.isDirective=!0,t}(t.PureComponent),d=function(){var e=function(t,r){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])})(t,r)};return function(t,r){function i(){this.constructor=t}e(t,r),t.prototype=null===r?Object.create(r):(i.prototype=r.prototype,new i)}}(),u=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return d(t,e),t.prototype.render=function(){return null},t.isService=!0,t}(t.PureComponent),f=i.getTemplateEngine();i.setTemplateEngine({compile:s}),e.ComponentBase=l,e.applyMixins=function(e,t){t.forEach(function(t){Object.getOwnPropertyNames(t.prototype).forEach(function(r){"isMounted"!==r&&"replaceState"!==r&&(e.prototype[r]=t.prototype[r])})})},e.ComplexBase=h,e.Inject=u,e.compile=s,Object.defineProperty(e,"__esModule",{value:!0})});
	//# sourceMappingURL=ej2-react-base.umd.min.js.map


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	*  filename: ej2-react-richtexteditor.umd.min.js
	*  version : 19.4.56
	*  Copyright Syncfusion Inc. 2001 - 2020. All rights reserved.
	*  Use of this code is subject to the terms of our license.
	*  A copy of the current license can be obtained at any time by e-mailing
	*  licensing@syncfusion.com. Any infringement will be prosecuted under
	*  applicable laws. 
	*/
	!function(e,t){ true?t(exports,__webpack_require__(3),__webpack_require__(537),__webpack_require__(535)):"function"==typeof define&&define.amd?define(["exports","react","@syncfusion/ej2-richtexteditor","@syncfusion/ej2-react-base"],t):t(e.ej={},e.React,e.ej2Richtexteditor,e.ej2ReactBase)}(this,function(e,t,n,r){"use strict";var i=function(){var e=function(t,n){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(t,n)};return function(t,n){function r(){this.constructor=t}e(t,n),t.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}(),o=function(e){function n(t){var n=e.call(this,t)||this;return n.initRenderCalled=!1,n.checkInjectedModules=!0,n.immediateRender=!1,n.portals=[],n}return i(n,e),n.prototype.render=function(){if(!(this.element&&!this.initRenderCalled||this.refreshing)||this.isReactForeceUpdate)return t.createElement("div",this.getDefaultAttributes(),[].concat(this.props.children,this.portals));e.prototype.render.call(this),this.initRenderCalled=!0},n}(n.RichTextEditor);r.applyMixins(o,[r.ComponentBase,t.Component]),e.Inject=r.Inject,e.RichTextEditorComponent=o,Object.keys(n).forEach(function(t){e[t]=n[t]}),Object.defineProperty(e,"__esModule",{value:!0})});
	//# sourceMappingURL=ej2-react-richtexteditor.umd.min.js.map


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	*  filename: ej2-richtexteditor.umd.min.js
	*  version : 19.4.56
	*  Copyright Syncfusion Inc. 2001 - 2020. All rights reserved.
	*  Use of this code is subject to the terms of our license.
	*  A copy of the current license can be obtained at any time by e-mailing
	*  licensing@syncfusion.com. Any infringement will be prosecuted under
	*  applicable laws. 
	*/
	!function(e,t){ true?t(exports,__webpack_require__(23),__webpack_require__(102),__webpack_require__(136),__webpack_require__(46),__webpack_require__(59),__webpack_require__(42),__webpack_require__(531)):"function"==typeof define&&define.amd?define(["exports","@syncfusion/ej2-base","@syncfusion/ej2-navigations","@syncfusion/ej2-splitbuttons","@syncfusion/ej2-popups","@syncfusion/ej2-inputs","@syncfusion/ej2-buttons","@syncfusion/ej2-filemanager"],t):t(e.ej={},e.ej2Base,e.ej2Navigations,e.ej2Splitbuttons,e.ej2Popups,e.ej2Inputs,e.ej2Buttons,e.ej2Filemanager)}(this,function(e,t,n,i,r,o,s,a){"use strict";function l(e,t,n){for(var i=0;t.length>i;i++)if(t[i].value===n.subCommand)return e.localeObj.getConstant(t[i].locale);return n.text}function d(e,t){var n=-1;return t.some(function(t,i){return"string"==typeof t&&e===t.toLocaleLowerCase()&&(n=i,!0)}),n}function c(e,t){var n=!1;return e.classList.contains(t)&&(n=!0),n}function p(e,n,i,r){for(var o,s,a=0;a<e.length;a++){if("value"===i&&e[a].value.toLocaleLowerCase()===n.toLocaleLowerCase()){o=e[a];break}if("text"===i&&e[a].text.toLocaleLowerCase()===n.toLocaleLowerCase()){o=e[a];break}if("subCommand"===i&&e[a].subCommand.toLocaleLowerCase()===n.toLocaleLowerCase()){o=e[a];break}}if(!t.isNullOrUndefined(o))switch(r){case"text":s=o.text;break;case"value":s=o.value;break;case"iconCss":s=o.iconCss}return s}function h(){var e=!1;return t.Browser.isDevice&&t.Browser.isIos&&(e=!0),e}function u(e){return t.isNullOrUndefined(e)?"":e}function m(e,t,n){return n?window.pageYOffset+t.getBoundingClientRect().top+e.clientY:e.pageY}function g(e,t){var n=t.getService("rteLocale"),i=Ui[e];return n.getConstant(i)}function f(e,n,i){R(i);for(var r=e.dropDownModule,o=e.args,s=0,a=Object.keys(e.args);s<a.length;s++)for(var l=a[s],c=0;c<e.tbItems.length;c++){var h=e.tbItems[c].subCommand,m=h&&h.toLocaleLowerCase();if(h&&m===l||"UL"===h&&"unorderedlist"===l||"OL"===h&&"orderedlist"===l||"pre"===m&&"insertcode"===l)if("boolean"==typeof o[l])!0===o[l]?t.addClass([e.tbElements[c]],[bn]):t.removeClass([e.tbElements[c]],[bn]);else if(("string"==typeof o[l]||null===o[l])&&d(l,e.parent.toolbarSettings.items)>-1){var g=o[l]?o[l]:"",f="";switch(l){case"formats":if(t.isNullOrUndefined(r.formatDropDown)||n||!t.isNullOrUndefined(r.formatDropDown)&&r.formatDropDown.isDestroyed)break;var b=e.parent.format.types,v=t.isNullOrUndefined(e.parent.format.default)?b[0].text:e.parent.format.default;f=p(b,g,"subCommand","text"),r.formatDropDown.content='<span style="display: inline-flex;width:'+e.parent.format.width+'" ><span class="e-rte-dropdown-btn-text">'+(t.isNullOrUndefined(f)?v:f)+"</span></span>",r.formatDropDown.dataBind();break;case"alignments":if(t.isNullOrUndefined(r.alignDropDown)||!t.isNullOrUndefined(r.alignDropDown)&&r.alignDropDown.isDestroyed)break;f=p(gi,g,"subCommand","iconCss"),r.alignDropDown.iconCss=t.isNullOrUndefined(f)?"e-icons e-justify-left":f,r.alignDropDown.dataBind();break;case"fontname":if(t.isNullOrUndefined(r.fontNameDropDown)||n||!t.isNullOrUndefined(r.fontNameDropDown)&&r.fontNameDropDown.isDestroyed)break;var y=e.parent.fontFamily.items;f=p(y,g,"value","text");var C=t.isNullOrUndefined(e.parent.fontFamily.default)?y[0].text:e.parent.fontFamily.default,S=t.isNullOrUndefined(f)?C:f;e.tbElements[c].title=S,r.fontNameDropDown.content='<span style="display: inline-flex;width:'+e.parent.fontFamily.width+'" ><span class="e-rte-dropdown-btn-text">'+S+"</span></span>",r.fontNameDropDown.dataBind();break;case"fontsize":if(t.isNullOrUndefined(r.fontSizeDropDown)||!t.isNullOrUndefined(r.fontSizeDropDown)&&r.fontSizeDropDown.isDestroyed)break;var N=e.parent.fontSize.items,E=t.isNullOrUndefined(e.parent.fontSize.default)?N[1].text:e.parent.fontSize.default;f=p(N,""===g?E.replace(/\s/g,""):g,"value","text"),r.fontSizeDropDown.content='<span style="display: inline-flex;width:'+e.parent.fontSize.width+'" ><span class="e-rte-dropdown-btn-text">'+u(f)+"</span></span>",r.fontSizeDropDown.dataBind()}}}}function b(e){return"object"==typeof e?e:[e]}function v(e,t){for(var n=[],i=0;i<e.length;i++)for(var r=0;r<t.length;r++)if("Separator"!==t[r].type){if("OrderedList"===e[i]&&"OL"===t[r].subCommand){n.push(r);break}if("UnorderedList"===e[i]&&"UL"===t[r].subCommand){n.push(r);break}if("InsertCode"===e[i]&&"Pre"===t[r].subCommand){n.push(r);break}if("FileManager"===e[i]&&"File"===t[r].subCommand){n.push(r);break}if("object"==typeof e[i]&&"Custom"===e[i].command){n.push(i);break}if(e[i]===t[r].subCommand){n.push(r);break}}return n}function y(e,n){for(var i=0,r=v(b(zi),e.toolbarObj.items),o=t.selectAll("."+$t,e.toolbarObj.element),s=0,a=Object.keys(n);s<a.length;s++){var l=a[s],d=o[r[i]];d&&e.toolbarObj.enableItems(d,n[l]),i++}}function C(e,t){var n=document.createEvent("HTMLEvents");n.initEvent(t,!1,!0),e.dispatchEvent(n)}function S(e){var n=t.createElement("template");return n.innerHTML=e,n.content instanceof DocumentFragment?n.content:document.createRange().createContextualFragment(e)}function N(e,t){var n=[];for(t=t.firstChild;t;t=t.nextSibling)3===t.nodeType?n.push(t):n=n.concat(N(e,t));return n}function E(e){for(var t={},n=Object.keys(e),i=0;i<Object.keys(e).length;i++)t[n[i].toLocaleLowerCase()]=e[n[i]];return t}function T(e,t){var n;return null!==e&&""!==e?(n=t.enableHtmlEncode?w(O(e),t):w(e,t),t.setProperties({value:n},!0)):n="DIV"===t.enterKey?t.enableHtmlEncode?"&lt;div&gt;&lt;br/&gt;&lt;/div&gt;":"<div><br/></div>":"BR"===t.enterKey?t.enableHtmlEncode?"&lt;br/&gt;":"<br/>":t.enableHtmlEncode?"&lt;p&gt;&lt;br/&gt;&lt;/p&gt;":"<p><br/></p>",n}function w(e,n){var i=document.createElement("div"),r=document.createElement("div"),o=i.childNodes;if(i.innerHTML=e,i.setAttribute("class","tempDiv"),o.length>0){for(var s=void 0,a=void 0,l=void 0;i.firstChild;)"BR"!==n.enterKey&&("#text"===i.firstChild.nodeName&&(i.firstChild.textContent.indexOf("\n")<0||""!==i.firstChild.textContent.trim())||_i.indexOf(i.firstChild.nodeName.toLocaleLowerCase())>=0)?(s?a.appendChild(i.firstChild):(l="DIV"===n.enterKey?t.createElement("div"):t.createElement("p"),r.appendChild(l),l.appendChild(i.firstChild)),a=l,s=!0):"#text"===i.firstChild.nodeName&&("\n"===i.firstChild.textContent||i.firstChild.textContent.indexOf("\n")>=0&&""===i.firstChild.textContent.trim())?t.detach(i.firstChild):(r.appendChild(i.firstChild),s=!1);for(var d=r.querySelectorAll("img"),c=0;c<d.length;c++)d[c].classList.contains($n)||d[c].classList.add($n),d[c].classList.contains(hn)||d[c].classList.contains(ln)||d[c].classList.add(hn)}return r.innerHTML}function k(e){return"DIV"===e.enterKey?e.enableHtmlEncode?"&lt;div&gt;&lt;br/&gt;&lt;/div&gt;":"<div><br/></div>":"BR"===e.enterKey?e.enableHtmlEncode?"&lt;br/&gt;":"<br/>":e.enableHtmlEncode?"&lt;p&gt;&lt;br/&gt;&lt;/p&gt;":"<p><br/></p>"}function L(e){return"<p><br></p>"===e||"&lt;p&gt;&lt;br&gt;&lt;/p&gt;"===e||"<div><br></div>"===e||"&lt;div&gt;&lt;br&gt;&lt;/div&gt;"===e||"<br>"===e||"&lt;br&gt;"===e||""===e}function O(e){return e.replace(/&amp;/g,"&").replace(/&amp;lt;/g,"<").replace(/&lt;/g,"<").replace(/&amp;gt;/g,">").replace(/&gt;/g,">").replace(/&nbsp;/g," ").replace(/&amp;nbsp;/g," ").replace(/&quot;/g,"")}function x(e,n){if(n.enableHtmlSanitizer){var i=t.SanitizeHtmlHelper.beforeSanitize();t.extend(i,i,{cancel:!1,helper:null}),n.trigger("beforeSanitizeHtml",i),i.cancel&&!t.isNullOrUndefined(i.helper)?e=i.helper(e):i.cancel||(e=t.SanitizeHtmlHelper.serializeValue(i,e))}return e}function D(e){for(var t=e.split(","),n=t[0].match(/:(.*?);/)[1],i=atob(t[1]),r=i.length,o=new Uint8Array(r);r--;)o[r]=i.charCodeAt(r);return new Blob([o],{type:n})}function M(e,t,n){for(var i=0;t.length>i;i++)if(t[i].value===n.value||t[i].value===n.subCommand)return e.localeObj.getConstant(t[i].locale);return n.text}function R(e){xi.forEach(function(t,n){xi[n].text=M(e,Hi,xi[n])}),Mi.forEach(function(t,n){Mi[n].text=M(e,ji,Mi[n])}),Bi.forEach(function(t,n){Bi[n].text=M(e,Fi,Bi[n])}),Pi.forEach(function(t,n){Pi[n].text=M(e,qi,Pi[n])})}function I(){var e=!1;return t.Browser.isDevice&&t.Browser.isIos&&(e=!0),e}function B(e,n){if("BODY"===e.nodeName&&!t.isNullOrUndefined(n)){var i=top.window.document.querySelector(n);t.isNullOrUndefined(i)||i.contentWindow.focus()}}function P(e,t,n,i){var r;if(n){r=t.contentModule.getDocument().querySelector("body")}else r=t.element;if(Object.keys(e).length)for(var o=0,s=Object.keys(e);o<s.length;o++){var a=s[o];if("class"===a)r.classList.add(e[a]);else if("disabled"===a&&"disabled"===e[a])t.enabled=!1,t.setEnable();else if("readonly"===a&&"readonly"===e[a])t.readonly=!0,t.setReadOnly(i);else if("style"===a)r.setAttribute("style",e[a]);else if("tabindex"===a)t.inputElement.setAttribute("tabindex",e[a]);else if("placeholder"===a)t.placeholder=e[a],t.setPlaceHolder();else{["name","required"].indexOf(a)>-1?t.valueContainer.setAttribute(a,e[a]):r.setAttribute(a,e[a])}}}var A="initial-load",U="content-changed",H="initial-end",j="iframe-click",F="destroy",q="toolbarClick",z="toolbar-refresh",_="refresh-begin",Q="toolbar-updated",V="bind-on-end",W="render-color-picker",K="html-toolbar-click",G="markdown-toolbar-click",X="destroy-color-picker",Y="model-changed",J="keyUp",$="keyDown",Z="mouseUp",ee="toolbarCreated",te="toolbarRenderComplete",ne="enableFullScreen",ie="disableFullScreen",re="dropDownSelect",oe="beforeDropDownItemRender",se="execCommandCallBack",ae="image-toolbar-action",le="link-toolbar-action",de="resize",ce="resizeStart",pe="resizing",he="resizeStop",ue="insertLink",me="unLink",ge="editLink",fe="openLink",be="actionBegin",ve="actionComplete",ye="updatedToolbarStatus",Ce="updateToolbarItem",Se="insertImage",Ne="insertCompleted",Ee="insertImgLink",Te="imgAltText",we="delete",ke="caption",Le="imageSize",Oe="sourceCode",xe="updateSource",De="beforeDropDownOpen",Me="selection-save",Re="selection-restore",Ie="expandPopupClick",Be="count",Pe="mouseDown",Ae="sourceCodeMouseDown",Ue="editAreaClick",He="scroll",je="contentscroll",Fe="colorPickerChanged",qe="tableColorPickerChanged",ze="focusChange",_e="selectAll",Qe="selectRange",Ve="getSelectedHtml",We="renderInlineToolbar",Ke="paste-content",Ge="rtl-mode",Xe="createTable",Ye="docClick",Je="table-toolbar-action",$e="checkUndoStack",Ze="readOnlyMode",et="pasteClean",tt="enterHandler",nt="beforeDialogOpen",it="clearDialogObj",rt="beforeDialogClose",ot="beforeQuickToolbarOpen",st="quickToolbarOpen",at="quickToolbarClose",lt="imageSelected",dt="imageUploading",ct="imageUploadSuccess",pt="imageUploadFailed",ht="imageRemoving",ut="afterImageDelete",mt="xhtmlValidation",gt="beforeImageUpload",ft="resizeInitialized",bt="renderFileManager",vt="beforeImageDrop",yt="dynamicModule",Ct="beforePasteCleanup",St="afterPasteCleanup",Nt="updateTbItemsStatus",Et="showLinkDialog",Tt="closeLinkDialog",wt="showImageDialog",kt="closeImageDialog",Lt="showTableDialog",Ot="closeTableDialog",xt="e-richtexteditor",Dt="e-disabled",Mt="rte-iframe-script-sheet",Rt="rte-iframe-style-sheet",It="e-rte-toolbar",Bt="e-rte-tb-fixed",Pt="e-rte-tb-float",At="e-rte-tb-abs-float",Ut="e-rte-inline",Ht="e-rte-tb-expand",jt="e-rte-full-screen",Ft="e-rte-quick-toolbar",qt="e-rte-pop",zt="e-rte-quick-popup",_t="e-quick-dropdown",Qt="e-rte-image-popup",Vt="e-rte-inline-popup",Wt="e-rte-inline-dropdown",Kt="e-rte-dropdown-popup",Gt="e-rte-dropdown-icons",Xt="e-rte-dropdown-items",Yt="e-rte-dropdown-btn",Jt="e-rte-content",$t="e-toolbar-item",Zt="e-toolbar-wrapper",en="e-hide",tn="e-visible",nn="e-focused",rn="e-remove-white-space",on="e-imgright",sn="e-imgleft",an="e-imgcenter",ln="e-imgbreak",dn="e-img-caption",cn="e-rte-img-caption",pn="e-caption-inline",hn="e-imginline",un="e-rte-character-count",mn="e-warning",gn="e-error",fn="e-icons",bn="e-active",vn="e-expand-open",yn="e-rte-elements",Cn="e-tbar-btn",Sn="e-rte-horizontal-separator",Nn="e-tbar-ios-fixed",En="e-rte-list-primary-content",Tn="e-rte-numberformatlist-dropdown",wn="e-rte-bulletformatlist-dropdown",kn="e-formats-tbar-btn",Ln="e-font-name-tbar-btn",On="e-font-size-tbar-btn",xn="e-rte-fontcolor-element",Dn="e-rte-backgroundcolor-element",Mn="e-rte-color-content",Rn="e-rte-fontcolor-dropdown",In="e-rte-backgroundcolor-dropdown",Bn="e-rte-square-palette",Pn="e-rte-fontcolor-colorpicker",An="e-rte-backgroundcolor-colorpicker",Un="e-rte-readonly",Hn="e-cell-select",jn="e-dashed-border",Fn="e-alternate-border",qn="e-column-resize",zn="e-row-resize",_n="e-table-box",Qn="e-rte-hidden",Vn="e-rte-keepformat",Wn="e-rte-removeformat",Kn="e-rte-plainformat",Gn="e-rte-pasteok",Xn="e-rte-pastecancel",Yn="e-rte-dialog-minheight",Jn="e-resize-handle",$n="e-rte-image",Zn="e-rte-drag-image",ei="e-rte-upload-popup",ti="e-popup-open",ni="e-upload-files",ii="e-rte-dialog-upload",ri="e-rte-resize",oi="e-custom-tile",si="e-nocolor-item",ai="e-rte-table",li="e-rte-table-border",di="e-rte-table-resize",ci="e-rte-fixed-tb-expand",pi="e-rte-toolbar-enabled";!function(e){e[e.Toolbar=0]="Toolbar",e[e.Content=1]="Content",e[e.Popup=2]="Popup",e[e.LinkToolbar=3]="LinkToolbar",e[e.TextToolbar=4]="TextToolbar",e[e.ImageToolbar=5]="ImageToolbar",e[e.InlineToolbar=6]="InlineToolbar",e[e.TableToolbar=7]="TableToolbar"}(e.RenderType||(e.RenderType={})),function(e){e.Expand="Expand",e.MultiRow="MultiRow",e.Scrollable="Scrollable"}(e.ToolbarType||(e.ToolbarType={})),function(e){e.InsertLink="InsertLink",e.InsertImage="InsertImage",e.InsertTable="InsertTable"}(e.DialogType||(e.DialogType={}));var hi=["alignments","formats","fontname","fontsize","fontcolor","backgroundcolor","align","display","tablerows","tablecolumns","tablecell","tablecellhorizontalalign","tablecellverticalalign","styles","numberformatlist","bulletformatlist"],ui={alignments:{id:"Alignments",icon:"e-alignments",tooltip:"Alignments",command:"Alignments",subCommand:"Alignments"},justifyleft:{id:"JustifyLeft",icon:"e-justify-left",tooltip:"JustifyLeft",command:"Alignments",subCommand:"JustifyLeft"},justifycenter:{id:"JustifyCenter",icon:"e-justify-center",tooltip:"JustifyCenter",command:"Alignments",subCommand:"JustifyCenter"},justifyright:{id:"JustifyRight",icon:"e-justify-right",tooltip:"JustifyRight",command:"Alignments",subCommand:"JustifyRight"},justifyfull:{id:"JustifyFull",icon:"e-justify-full",tooltip:"JustifyFull",command:"Alignments",subCommand:"JustifyFull"},fontname:{id:"FontName",icon:"e-font-name",tooltip:"Font Name",command:"Font",subCommand:"FontName"},fontsize:{id:"FontSize",icon:"e-font-size",tooltip:"Font Size",command:"Font",subCommand:"FontSize"},fontcolor:{id:"FontColor",icon:"e-font-color",tooltip:"Font Color",command:"Font",subCommand:"FontColor",value:"#ff0000ff"},backgroundcolor:{id:"BackgroundColor",icon:"e-background-color",tooltip:"Background Color",command:"Font",subCommand:"BackgroundColor",value:"#ffff00ff"},bold:{id:"Bold",icon:"e-bold",tooltip:"Bold",command:"Style",subCommand:"Bold"},italic:{id:"Italic",icon:"e-italic",tooltip:"Italic",command:"Style",subCommand:"Italic"},underline:{id:"Underline",icon:"e-underline",tooltip:"Underline",command:"Style",subCommand:"Underline"},strikethrough:{id:"StrikeThrough",icon:"e-strike-through",tooltip:"StrikeThrough",command:"Style",subCommand:"StrikeThrough"},clearformat:{id:"ClearFormat",icon:"e-clear-format",tooltip:"Clear Format",command:"Clear",subCommand:"ClearFormat"},clearall:{id:"ClearAll",icon:"e-clear-all",tooltip:"Clear All",command:"Clear",subCommand:"ClearAll"},cut:{id:"Cut",icon:"e-cut",tooltip:"Cut",command:"ClipBoard",subCommand:"Cut"},copy:{id:"Copy",icon:"e-copy",tooltip:"Copy",command:"ClipBoard",subCommand:"Copy"},paste:{id:"Paste",icon:"e-paste",tooltip:"Paste",command:"ClipBoard",subCommand:"Paste"},unorderedlist:{id:"UnorderedList",icon:"e-unorder-list",tooltip:"Bulleted List",command:"Lists",subCommand:"UL"},orderedlist:{id:"OrderedList",icon:"e-order-list",tooltip:"Numbered List",command:"Lists",subCommand:"OL"},numberformatlist:{id:"NumberFormatList",icon:"e-order-list",tooltip:"Number Format List",command:"NumberFormatList",subCommand:"NumberFormatList"},bulletformatlist:{id:"BulletFormatList",icon:"e-unorder-list",tooltip:"Bullet Format List",command:"BulletFormatList",subCommand:"BulletFormatList"},indent:{id:"Indent",icon:"e-indent",tooltip:"Increase Indent",command:"Indents",subCommand:"Indent"},outdent:{id:"Outdent",icon:"e-outdent",tooltip:"Decrease Indent",command:"Indents",subCommand:"Outdent"},undo:{id:"Undo",icon:"e-undo",tooltip:"Undo",command:"Actions",subCommand:"Undo"},redo:{id:"Redo",icon:"e-redo",tooltip:"Redo",command:"Actions",subCommand:"Redo"},superscript:{id:"SuperScript",icon:"e-super-script",tooltip:"Superscript",command:"Effects",subCommand:"SuperScript"},subscript:{id:"SubScript",icon:"e-sub-script",tooltip:"Subscript",command:"Effects",subCommand:"SubScript"},createlink:{id:"CreateLink",icon:"e-create-link",tooltip:"Insert Hyperlink",command:"Links",subCommand:"CreateLink"},openlink:{id:"OpenLink",icon:"e-open-link",tooltip:"Open Link",command:"Links",subCommand:"OpenLink"},editlink:{id:"EditLink",icon:"e-edit-link",tooltip:"Edit Link",command:"Links",subCommand:"EditLink"},removelink:{id:"RemoveLink",icon:"e-remove-link",tooltip:"Remove Link",command:"Links",subCommand:"RemoveLink"},image:{id:"Image",icon:"e-image",tooltip:"Insert Image",command:"Images",subCommand:"Image"},filemanager:{id:"FileManager",icon:"e-rte-file-manager",tooltip:"File Manager",command:"Files",subCommand:"File"},createtable:{id:"CreateTable",icon:"e-create-table",tooltip:"Create Table",command:"Table",subCommand:"CreateTable"},removetable:{id:"removeTable",icon:"e-remove-table",tooltip:"Remove Table",command:"removeTable",subCommand:"removeTable"},replace:{id:"Replace",icon:"e-replace",tooltip:"Replace",command:"Images",subCommand:"Replace"},align:{id:"Align",icon:"e-align",tooltip:"Align",command:"Images",subCommand:"Align"},caption:{id:"Caption",icon:"e-caption",tooltip:"Image Caption",command:"Images",subCommand:"Caption"},remove:{id:"Remove",icon:"e-remove",tooltip:"Remove",command:"Images",subCommand:"Remove"},openimagelink:{id:"OpenImageLink",icon:"e-open-link",tooltip:"Open Link",command:"Images",subCommand:"OpenImageLink"},editimagelink:{id:"EditImageLink",icon:"e-edit-link",tooltip:"Edit Link",command:"Images",subCommand:"EditImageLink"},removeimagelink:{id:"RemoveImageLink",icon:"e-remove-link",tooltip:"Remove Link",command:"Images",subCommand:"RemoveImageLink"},insertlink:{id:"InsertLink",icon:"e-insert-link",tooltip:"Insert Link",command:"Images",subCommand:"InsertLink"},display:{id:"Display",icon:"e-display",tooltip:"Display",command:"Images",subCommand:"Display"},alttext:{id:"AltText",icon:"e-alt-text",tooltip:"Alternative Text",command:"Images",subCommand:"AltText"},dimension:{id:"Dimension",icon:"e-img-dimension",tooltip:"Change Size",command:"Images",subCommand:"Dimension"},fullscreen:{id:"Maximize",icon:"e-maximize",tooltip:"Maximize",command:"View",subCommand:"Maximize"},maximize:{id:"Maximize",icon:"e-maximize",tooltip:"Maximize",command:"FullScreen",subCommand:"Maximize"},minimize:{id:"Minimize",icon:"e-minimize",tooltip:"Minimize",command:"FullScreen",subCommand:"Minimize"},lowercase:{id:"LowerCase",icon:"e-lower-case",tooltip:"Lower Case",command:"Casing",subCommand:"LowerCase"},uppercase:{id:"UpperCase",icon:"e-upper-case",tooltip:"Upper Case",command:"Casing",subCommand:"UpperCase"},print:{id:"Print",icon:"e-print",tooltip:"Print",command:"Print",subCommand:"Print"},formats:{id:"Formats",icon:"e-formats",tooltip:"Formats",command:"Formats",subCommand:"Formats"},sourcecode:{id:"SourceCode",icon:"e-source-code",tooltip:"Source Code",command:"SourceCode",subCommand:"SourceCode"},preview:{id:"Preview",icon:"e-preview",tooltip:"Preview",command:"Preview",subCommand:"Preview"},viewside:{id:"ViewSide",icon:"e-view-side",tooltip:"ViewSide",command:"ViewSide",subCommand:"ViewSide"},insertcode:{id:"InsertCode",icon:"e-insert-code",tooltip:"Insert Code",command:"Formats",subCommand:"Pre"},tableheader:{id:"TableHeader",icon:"e-table-header",tooltip:"Table Header",command:"Table",subCommand:"TableHeader"},tableremove:{id:"TableRemove",icon:"e-table-remove",tooltip:"Table Remove",command:"Table",subCommand:"TableRemove"},tablerows:{id:"TableRows",icon:"e-table-rows",tooltip:"Table Rows",command:"Table",subCommand:"TableRows"},tablecolumns:{id:"TableColumns",icon:"e-table-columns",tooltip:"Table Columns",command:"Table",subCommand:"TableColumns"},tablecell:{id:"TableCell",icon:"e-table-cell",tooltip:"Table Cell",command:"Table",subCommand:"TableCell"},tablecellbackground:{id:"TableCellBackground",icon:"e-table-cell-background",tooltip:"Table Cell Background",command:"Table",subCommand:"TableCellBackground"},tablecellhorizontalalign:{id:"TableCellHorizontalAlign",icon:"e-table-cell-horizontalAlign",tooltip:"Table Cell HorizontalAlign",command:"Table",subCommand:"TableCellHorizontalAlign"},tablecellverticalalign:{id:"TableCellVerticalAlign",icon:"e-table-cell-verticalAlign",tooltip:"Table Cell VerticalAlign",command:"Table",subCommand:"TableCellVerticalAlign"},tableeditproperties:{id:"TableEditProperties",icon:"e-table-edit-properties",tooltip:"Table Edit Properties",command:"Table",subCommand:"TableEditProperties"},styles:{id:"Styles",icon:"e-table-styles",tooltip:"Styles",command:"Table",subCommand:"Styles"}},mi=[{locale:"alignmentsDropDownLeft",value:"JustifyLeft"},{locale:"alignmentsDropDownCenter",value:"JustifyCenter"},{locale:"alignmentsDropDownRight",value:"JustifyRight"},{locale:"alignmentsDropDownJustify",value:"JustifyFull"}],gi=[{iconCss:"e-icons e-justify-left",text:"Align Left",command:"Alignments",subCommand:"JustifyLeft"},{iconCss:"e-icons e-justify-center",text:"Align Center",command:"Alignments",subCommand:"JustifyCenter"},{iconCss:"e-icons e-justify-right",text:"Align Right",command:"Alignments",subCommand:"JustifyRight"},{iconCss:"e-icons e-justify-full",text:"Align Justify",command:"Alignments",subCommand:"JustifyFull"}],fi=[{iconCss:"e-icons e-justify-left",command:"Images",subCommand:"JustifyLeft"},{iconCss:"e-icons e-justify-center",command:"Images",subCommand:"JustifyCenter"},{iconCss:"e-icons e-justify-right",command:"Images",subCommand:"JustifyRight"}],bi=[{locale:"imageDisplayDropDownInline",value:"Inline"},{locale:"imageDisplayDropDownBreak",value:"Break"}],vi=[{text:"Inline",cssClass:"e-inline",command:"Images",subCommand:"Inline"},{text:"Break",cssClass:"e-break",command:"Images",subCommand:"Break"}],yi=[{iconCss:"e-icons e-cell-merge",text:"Merge cells",command:"Table",subCommand:"Merge"},{iconCss:"e-icons e-cell-horizontal-split",text:"Horizontal split",command:"Table",subCommand:"HorizontalSplit"},{iconCss:"e-icons e-cell-vertical-split",text:"Vertical split",command:"Table",subCommand:"VerticalSplit"}],Ci=[{locale:"tableInsertRowDropDownBefore",value:"InsertRowBefore"},{locale:"tableInsertRowDropDownAfter",value:"InsertRowAfter"},{locale:"tableInsertRowDropDownDelete",value:"DeleteRow"}],Si=[{iconCss:"e-icons e-insert-row-before",text:"Insert row before",command:"Table",subCommand:"InsertRowBefore"},{iconCss:"e-icons e-insert-row-after",text:"Insert row after",command:"Table",subCommand:"InsertRowAfter"},{iconCss:"e-icons e-delete-row",text:"Delete row",command:"Table",subCommand:"DeleteRow"}],Ni=[{locale:"tableInsertColumnDropDownLeft",value:"InsertColumnLeft"},{locale:"tableInsertColumnDropDownRight",value:"InsertColumnRight"},{locale:"tableInsertColumnDropDownDelete",value:"DeleteColumn"}],Ei=[{iconCss:"e-icons e-insert-column-left",text:"Insert column left",command:"Table",subCommand:"InsertColumnLeft"},{iconCss:"e-icons e-insert-column-right",text:"Insert column right",command:"Table",subCommand:"InsertColumnRight"},{iconCss:"e-icons e-delete-column",text:"Delete column",command:"Table",subCommand:"DeleteColumn"}],Ti=[{locale:"tableVerticalAlignDropDownTop",value:"AlignTop"},{locale:"tableVerticalAlignDropDownMiddle",value:"AlignMiddle"},{locale:"tableVerticalAlignDropDownBottom",value:"AlignBottom"}],wi=[{iconCss:"e-icons e-align-top",text:"Align Top",command:"Table",subCommand:"AlignTop"},{iconCss:"e-icons e-align-middle",text:"Align Middle",command:"Table",subCommand:"AlignMiddle"},{iconCss:"e-icons e-align-bottom",text:"Align Bottom",command:"Table",subCommand:"AlignBottom"}],ki=[{locale:"tableStylesDropDownDashedBorder",value:"Dashed"},{locale:"tableStylesDropDownAlternateRows",value:"Alternate"}],Li=[{text:"Dashed Borders",cssClass:"e-dashed-borders",command:"Table",subCommand:"Dashed"},{text:"Alternate Rows",cssClass:"e-alternate-rows",command:"Table",subCommand:"Alternate"}],Oi=["Bold","Italic","Underline","|","Formats","Alignments","OrderedList","UnorderedList","|","CreateLink","Image","|","SourceCode","Undo","Redo"],xi=[{cssClass:"e-segoe-ui",text:"Segoe UI",command:"Font",subCommand:"FontName",value:"Segoe UI"},{cssClass:"e-arial",text:"Arial",command:"Font",subCommand:"FontName",value:"Arial,Helvetica,sans-serif"},{cssClass:"e-georgia",text:"Georgia",command:"Font",subCommand:"FontName",value:"Georgia,serif"},{cssClass:"e-impact",text:"Impact",command:"Font",subCommand:"FontName",value:"Impact,Charcoal,sans-serif"},{cssClass:"e-tahoma",text:"Tahoma",command:"Font",subCommand:"FontName",value:"Tahoma,Geneva,sans-serif"},{cssClass:"e-times-new-roman",text:"Times New Roman",command:"Font",subCommand:"FontName",value:"Times New Roman,Times,serif"},{cssClass:"e-verdana",text:"Verdana",command:"Font",subCommand:"FontName",value:"Verdana,Geneva,sans-serif"}],Di=[{text:"8 pt",value:"8pt"},{text:"10 pt",value:"10pt"},{text:"12 pt",value:"12pt"},{text:"14 pt",value:"14pt"},{text:"18 pt",value:"18pt"},{text:"24 pt",value:"24pt"},{text:"36 pt",value:"36pt"}],Mi=[{cssClass:"e-paragraph",text:"Paragraph",command:"Formats",subCommand:"P",value:"P"},{cssClass:"e-code",text:"Code",command:"Formats",subCommand:"Pre",value:"Pre"},{cssClass:"e-quote",text:"Quotation",command:"Formats",subCommand:"BlockQuote",value:"BlockQuote"},{cssClass:"e-h1",text:"Heading 1",command:"Formats",subCommand:"H1",value:"H1"},{cssClass:"e-h2",text:"Heading 2",command:"Formats",subCommand:"H2",value:"H2"},{cssClass:"e-h3",text:"Heading 3",command:"Formats",subCommand:"H3",value:"H3"},{cssClass:"e-h4",text:"Heading 4",command:"Formats",subCommand:"H4",value:"H4"}],Ri={Custom:["","#000000","#e7e6e6","#44546a","#4472c4","#ed7d31","#a5a5a5","#ffc000","#70ad47","#ff0000","#f2f2f2","#808080","#cfcdcd","#d5dce4","#d9e2f3","#fbe4d5","#ededed","#fff2cc","#e2efd9","#ffcccc","#d9d9d9","#595959","#aeaaaa","#acb9ca","#b4c6e7","#f7caac","#dbdbdb","#ffe599","#c5e0b3","#ff8080","#bfbfbf","#404040","#747070","#8496b0","#8eaadb","#f4b083","#c9c9c9","#ffd966","#a8d08d","#ff3333","#a6a6a6","#262626","#3b3838","#323e4f","#2f5496","#c45911","#7b7b7b","#bf8f00","#538135","#b30000","#7f7f7f","#0d0d0d","#161616","#212934","#1f3763","#823b0b","#525252","#7f5f00","#375623","#660000"]},Ii={Custom:["","#000000","#ffff00","#00ff00","#00ffff","#0000ff","#ff0000","#000080","#800080","#996633","#f2f2f2","#808080","#ffffcc","#b3ffb3","#ccffff","#ccccff","#ffcccc","#ccccff","#ff80ff","#f2e6d9","#d9d9d9","#595959","#ffff80","#80ff80","#b3ffff","#8080ff","#ff8080","#8080ff","#ff00ff","#dfbf9f","#bfbfbf","#404040","#ffff33","#33ff33","#33ffff","#3333ff","#ff3333","#0000b3","#b300b3","#c68c53","#a6a6a6","#262626","#e6e600","#00b300","#009999","#000099","#b30000","#000066","#660066","#86592d","#7f7f7f","#0d0d0d","#999900","#006600","#006666","#000066","#660000","#00004d","#4d004d","#734d26"]},Bi=[{text:"None",command:"Lists",subCommand:"NumberFormatList",value:"none"},{text:"Number",command:"Lists",subCommand:"NumberFormatList",value:"decimal"},{text:"Lower Greek",command:"Lists",subCommand:"NumberFormatList",value:"lowerGreek"},{text:"Lower Roman",command:"Lists",subCommand:"NumberFormatList",value:"lowerRoman"},{text:"Upper Alpha",command:"Lists",subCommand:"NumberFormatList",value:"upperAlpha"},{text:"Lower Alpha",command:"Lists",subCommand:"NumberFormatList",value:"lowerAlpha"},{text:"Upper Roman",command:"Lists",subCommand:"NumberFormatList",value:"upperRoman"}],Pi=[{text:"None",command:"Lists",subCommand:"BulletFormatList",value:"none"},{text:"Disc",command:"Lists",subCommand:"BulletFormatList",value:"disc"},{text:"Circle",command:"Lists",subCommand:"BulletFormatList",value:"circle"},{text:"Square",command:"Lists",subCommand:"BulletFormatList",value:"square"}],Ai={alignments:"Alignments",justifyLeft:"Align Left",justifyCenter:"Align Center",justifyRight:"Align Right",justifyFull:"Align Justify",fontName:"Font Name",fontSize:"Font Size",fontColor:"Font Color",backgroundColor:"Background Color",bold:"Bold",italic:"Italic",underline:"Underline",strikethrough:"Strikethrough",clearFormat:"Clear Format",clearAll:"Clear All",cut:"Cut",copy:"Copy",paste:"Paste",unorderedList:"Bulleted List",orderedList:"Numbered List",indent:"Increase Indent",outdent:"Decrease Indent",undo:"Undo",redo:"Redo",superscript:"Superscript",subscript:"Subscript",createLink:"Insert Link",openLink:"Open Link",editLink:"Edit Link",removeLink:"Remove Link",image:"Insert Image",replace:"Replace",align:"Align",caption:"Image Caption",remove:"Remove",insertLink:"Insert Link",display:"Display",altText:"Alternative Text",dimension:"Change Size",fullscreen:"Maximize",maximize:"Maximize",minimize:"Minimize",lowerCase:"Lower Case",upperCase:"Upper Case",print:"Print",formats:"Formats",sourcecode:"Code View",preview:"Preview",viewside:"ViewSide",insertCode:"Insert Code",linkText:"Display Text",linkTooltipLabel:"Title",linkWebUrl:"Web Address",linkTitle:"Enter a title",linkurl:"http://example.com",linkOpenInNewWindow:"Open Link in New Window",linkHeader:"Insert Link",dialogInsert:"Insert",dialogCancel:"Cancel",dialogUpdate:"Update",imageHeader:"Insert Image",imageLinkHeader:"You can also provide a link from the web",mdimageLink:"Please provide a URL for your image",imageUploadMessage:"Drop image here or browse to upload",imageDeviceUploadMessage:"Click here to upload",imageAlternateText:"Alternate Text",alternateHeader:"Alternative Text",browse:"Browse",imageUrl:"http://example.com/image.png",imageCaption:"Caption",imageSizeHeader:"Image Size",imageHeight:"Height",imageWidth:"Width",textPlaceholder:"Enter Text",inserttablebtn:"Insert Table",tabledialogHeader:"Insert Table",tableWidth:"Width",cellpadding:"Cell Padding",cellspacing:"Cell Spacing",columns:"Number of columns",rows:"Number of rows",tableRows:"Table Rows",tableColumns:"Table Columns",tableCellHorizontalAlign:"Table Cell Horizontal Align",tableCellVerticalAlign:"Table Cell Vertical Align",createTable:"Create Table",removeTable:"Remove Table",tableHeader:"Table Header",tableRemove:"Table Remove",tableCellBackground:"Table Cell Background",tableEditProperties:"Table Edit Properties",styles:"Styles",insertColumnLeft:"Insert Column Left",insertColumnRight:"Insert Column Right",deleteColumn:"Delete Column",insertRowBefore:"Insert Row Before",insertRowAfter:"Insert Row After",deleteRow:"Delete Row",tableEditHeader:"Edit Table",TableHeadingText:"Heading",TableColText:"Col",imageInsertLinkHeader:"Insert Link",editImageHeader:"Edit Image",alignmentsDropDownLeft:"Align Left",alignmentsDropDownCenter:"Align Center",alignmentsDropDownRight:"Align Right",alignmentsDropDownJustify:"Align Justify",imageDisplayDropDownInline:"Inline",imageDisplayDropDownBreak:"Break",tableInsertRowDropDownBefore:"Insert row before",tableInsertRowDropDownAfter:"Insert row after",tableInsertRowDropDownDelete:"Delete row",tableInsertColumnDropDownLeft:"Insert column left",tableInsertColumnDropDownRight:"Insert column right",tableInsertColumnDropDownDelete:"Delete column",tableVerticalAlignDropDownTop:"Align Top",tableVerticalAlignDropDownMiddle:"Align Middle",tableVerticalAlignDropDownBottom:"Align Bottom",tableStylesDropDownDashedBorder:"Dashed Borders",tableStylesDropDownAlternateRows:"Alternate Rows",pasteFormat:"Paste Format",pasteFormatContent:"Choose the formatting action",plainText:"Plain Text",cleanFormat:"Clean",keepFormat:"Keep",pasteDialogOk:"OK",pasteDialogCancel:"Cancel",fileManager:"File Manager",fileDialogHeader:"File Browser",formatsDropDownParagraph:"Paragraph",formatsDropDownCode:"Code",formatsDropDownQuotation:"Quotation",formatsDropDownHeading1:"Heading 1",formatsDropDownHeading2:"Heading 2",formatsDropDownHeading3:"Heading 3",formatsDropDownHeading4:"Heading 4",fontNameSegoeUI:"Segoe UI",fontNameArial:"Arial",fontNameGeorgia:"Georgia",fontNameImpact:"Impact",fontNameTahoma:"Tahoma",fontNameTimesNewRoman:"Times New Roman",fontNameVerdana:"Verdana",numberFormatListNumber:"Number",numberFormatListLowerAlpha:"LowerAlpha",numberFormatListUpperAlpha:"UpperAlpha",numberFormatListLowerRoman:"LowerRoman",numberFormatListUpperRoman:"UpperRoman",numberFormatListLowerGreek:"LowerGreek",bulletFormatListDisc:"Disc",bulletFormatListCircle:"Circle",bulletFormatListSquare:"Square",numberFormatListNone:"None",bulletFormatListNone:"None"},Ui={alignments:"alignments",justifyleft:"justifyLeft",justifycenter:"justifyCenter",justifyright:"justifyRight",justifyfull:"justifyFull",fontname:"fontName",fontsize:"fontSize",fontcolor:"fontColor",backgroundcolor:"backgroundColor",bold:"bold",italic:"italic",underline:"underline",strikethrough:"strikethrough",clearformat:"clearFormat",clearall:"clearAll",cut:"cut",copy:"copy",paste:"paste",unorderedlist:"unorderedList",orderedlist:"orderedList",indent:"indent",outdent:"outdent",undo:"undo",redo:"redo",superscript:"superscript",subscript:"subscript",createlink:"createLink",openlink:"openLink",editlink:"editLink",removelink:"removeLink",openimagelink:"openLink",editimagelink:"editLink",removeimagelink:"removeLink",image:"image",replace:"replace",align:"align",caption:"caption",remove:"remove",insertlink:"insertLink",display:"display",alttext:"altText",dimension:"dimension",fullscreen:"fullscreen",maximize:"maximize",minimize:"minimize",lowercase:"lowerCase",uppercase:"upperCase",print:"print",formats:"formats",sourcecode:"sourcecode",preview:"preview",viewside:"viewside",insertcode:"insertCode",tablerows:"tableRows",tablecolumns:"tableColumns",tablecellhorizontalalign:"tableCellHorizontalAlign",tablecellverticalalign:"tableCellVerticalAlign",createtable:"createTable",removetable:"removeTable",tableheader:"tableHeader",tableremove:"tableRemove",tablecellbackground:"tableCellBackground",tableeditproperties:"tableEditProperties",styles:"styles",insertcolumnleft:"insertColumnLeft",insertcolumnright:"insertColumnRight",deletecolumn:"deleteColumn",aligntop:"AlignTop",alignmiddle:"AlignMiddle",alignbottom:"AlignBottom",insertrowbefore:"insertRowBefore",insertrowafter:"insertRowAfter",deleterow:"deleteRow"},Hi=[{locale:"fontNameSegoeUI",value:"Segoe UI"},{locale:"fontNameArial",value:"Arial,Helvetica,sans-serif"},{locale:"fontNameGeorgia",value:"Georgia,serif"},{locale:"fontNameImpact",value:"Impact,Charcoal,sans-serif"},{locale:"fontNameTahoma",value:"Tahoma,Geneva,sans-serif"},{locale:"fontNameTimesNewRoman",value:"Times New Roman,Times,serif"},{locale:"fontNameVerdana",value:"Verdana,Geneva,sans-serif"}],ji=[{locale:"formatsDropDownParagraph",value:"P"},{locale:"formatsDropDownCode",value:"Pre"},{locale:"formatsDropDownQuotation",value:"BlockQuote"},{locale:"formatsDropDownHeading1",value:"H1"},{locale:"formatsDropDownHeading2",value:"H2"},{locale:"formatsDropDownHeading3",value:"H3"},{locale:"formatsDropDownHeading4",value:"H4"}],Fi=[{locale:"numberFormatListNone",value:"none"},{locale:"numberFormatListNumber",value:"decimal"},{locale:"numberFormatListLowerAlpha",value:"lower-alpha"},{locale:"numberFormatListUpperAlpha",value:"upper-alpha"},{locale:"numberFormatListLowerRoman",value:"lower-roman"},{locale:"numberFormatListUpperRoman",value:"upper-roman"},{locale:"numberFormatListLowerGreek",value:"lower-greek"}],qi=[{locale:"bulletFormatListNone",value:"none"},{locale:"bulletFormatListDisc",value:"disc"},{locale:"bulletFormatListCircle",value:"circle"},{locale:"bulletFormatListSquare",value:"square"}],zi=["Undo","Redo"],_i=["a","abbr","acronym","audio","b","bdi","bdo","big","br","button","canvas","cite","code","data","datalist","del","dfn","em","embed","font","i","iframe","img","input","ins","kbd","label","map","mark","meter","noscript","object","output","picture","progress","q","ruby","s","samp","script","select","slot","small","span","strong","strike","sub","sup","svg","template","textarea","time","u","tt","var","video","wbr"],Qi=function(){function e(e){this.parent=e,this.wireEvent()}return e.prototype.wireEvent=function(){this.parent.on(F,this.unWireEvent,this)},e.prototype.unWireEvent=function(){this.parent.off(F,this.unWireEvent),this.popupOverlay&&t.EventHandler.remove(this.popupOverlay,"click touchmove",this.onPopupOverlay),this.removePopupContainer()},e.prototype.toolbarBeforeCreate=function(e){"Extended"===this.mode&&(e.enableCollision=!1)},e.prototype.toolbarCreated=function(){this.parent.notify(ee,this)},e.prototype.toolbarClicked=function(e){this.parent.enabled&&(this.parent.readonly&&!t.isNullOrUndefined(e.item)||this.parent.notify(q,e),this.parent.trigger("toolbarClick",e))},e.prototype.dropDownSelected=function(e){this.parent.notify(re,e),this.onPopupOverlay()},e.prototype.beforeDropDownItemRender=function(e){!this.parent.readonly&&this.parent.enabled&&this.parent.notify(oe,e)},e.prototype.dropDownOpen=function(e){if(e.element.parentElement.getAttribute("id").indexOf("TableCell")>-1&&!t.isNullOrUndefined(e.element.parentElement.querySelector(".e-cell-merge"))&&(!t.isNullOrUndefined(e.element.parentElement.querySelector(".e-cell-horizontal-split"))||!t.isNullOrUndefined(e.element.parentElement.querySelector(".e-cell-vertical-split")))){var n=e.element.querySelectorAll("li");1===this.parent.inputElement.querySelectorAll(".e-cell-select").length?(t.addClass([n[0]],"e-disabled"),t.removeClass([n[1],n[2]],"e-disabled")):this.parent.inputElement.querySelectorAll(".e-cell-select").length>1&&(t.removeClass([n[0]],"e-disabled"),t.addClass([n[1],n[2]],"e-disabled"))}t.Browser.isDevice&&!e.element.parentElement.classList.contains(_t)&&this.popupModal(e.element.parentElement),this.parent.notify(Me,e)},e.prototype.dropDownClose=function(e){this.removePopupContainer(),this.parent.notify(Re,e)},e.prototype.removePopupContainer=function(){if(t.Browser.isDevice&&!t.isNullOrUndefined(this.popupContainer)){var e=this.popupContainer.querySelector(".e-dropdown-popup.e-tbar-btn.e-control");e&&(this.popupContainer.parentNode.insertBefore(e,this.popupContainer.nextSibling),e.style.removeProperty("position"),t.removeClass([e],"e-popup-modal")),t.detach(this.popupContainer),this.popupContainer=void 0}},e.prototype.renderToolbar=function(e){this.setPanel(e.target),this.renderPanel(),this.mode=e.overflowMode,e.rteToolbarObj.toolbarObj=new n.Toolbar({items:e.items,width:"100%",overflowMode:e.overflowMode,beforeCreate:this.toolbarBeforeCreate.bind(this),created:this.toolbarCreated.bind(this),clicked:this.toolbarClicked.bind(this),enablePersistence:e.enablePersistence,enableRtl:e.enableRtl}),e.rteToolbarObj.toolbarObj.isStringTemplate=!0,e.rteToolbarObj.toolbarObj.createElement=this.parent.createElement,e.rteToolbarObj.toolbarObj.appendTo(e.target)},e.prototype.renderDropDownButton=function(e){var n,r=this;e.element.classList.add(Yt),n=e.cssClass+" "+yn+" "+Cn,this.parent.inlineMode.enable&&t.Browser.isDevice&&(n=n+" "+Wt);var o=this,s=new i.DropDownButton({items:e.items,iconCss:e.iconCss,cssClass:n,content:e.content,enablePersistence:this.parent.enablePersistence,enableRtl:this.parent.enableRtl,select:this.dropDownSelected.bind(this),beforeOpen:function(e){if(!o.parent.readonly&&o.parent.enabled){for(var n=0;n<e.element.childNodes.length;n++){var i=r.parent.createElement("div");i.innerHTML=s.content.trim(),""!==i.textContent.trim()&&e.element.childNodes[n].textContent.trim()===i.textContent.trim()?e.element.childNodes[n].classList.contains("e-active")||t.addClass([e.element.childNodes[n]],"e-active"):t.removeClass([e.element.childNodes[n]],"e-active")}o.parent.notify(De,e)}else e.cancel=!0},close:this.dropDownClose.bind(this),open:this.dropDownOpen.bind(this),beforeItemRender:this.beforeDropDownItemRender.bind(this)});s.isStringTemplate=!0,s.createElement=o.parent.createElement,s.appendTo(e.element),e.element.tabIndex=-1;return document.getElementById(s.element.id+"-popup").setAttribute("aria-owns",this.parent.getID()),s},e.prototype.renderListDropDown=function(e){var t=this,n=yn+" "+Cn+(this.parent.inlineMode?" "+Wt:"");n+=" "+("NumberFormatList"===e.itemName?Tn:wn);var r=t.parent.createElement("span",{className:En}),o=t.parent.createElement("span",{className:e.cssClass});r.appendChild(o);var s=new i.DropDownButton({items:e.items,cssClass:n,content:e.content,enablePersistence:this.parent.enablePersistence,enableRtl:this.parent.enableRtl,select:this.dropDownSelected.bind(this),beforeOpen:function(e){if(!t.parent.readonly&&t.parent.enabled){var n=e.event?e.event.target:null;t.currentElement=s.element,t.currentDropdown=s,e.event&&"click"===e.event.type&&(n.classList.contains(En)||n.parentElement.classList.contains(En))?e.cancel=!0:t.parent.notify(De,e)}else e.cancel=!0},close:this.dropDownClose.bind(this),open:this.dropDownOpen.bind(this),beforeItemRender:this.beforeDropDownItemRender.bind(this)});s.isStringTemplate=!0,s.createElement=t.parent.createElement,s.appendTo(e.element),e.element.tabIndex=-1;return document.getElementById(s.element.id+"-popup").setAttribute("aria-owns",this.parent.getID()),1===e.element.childElementCount&&s.element.insertBefore(r,s.element.querySelector(".e-caret")),e.element.tabIndex=-1,s.element.removeAttribute("type"),s},e.prototype.onPopupOverlay=function(e){t.isNullOrUndefined(this.popupOverlay)||(t.closest(this.popupOverlay,".e-popup-container").style.display="none",this.popupOverlay.style.display="none",t.removeClass([this.popupOverlay],"e-popup-overlay"))},e.prototype.setIsModel=function(e){t.closest(e,".e-popup-container")?(e.parentElement.style.display="flex",this.popupOverlay=e.nextElementSibling,this.popupOverlay.style.display="block",t.addClass([this.popupOverlay],"e-popup-overlay")):(this.popupContainer=this.parent.createElement("div",{className:"e-rte-modal-popup e-popup-container e-center"}),e.parentNode.insertBefore(this.popupContainer,e),this.popupContainer.appendChild(e),this.popupContainer.style.zIndex=e.style.zIndex,this.popupContainer.style.display="flex",e.style.position="relative",t.addClass([e],"e-popup-modal"),this.popupOverlay=this.parent.createElement("div",{className:"e-popup-overlay"}),this.popupOverlay.style.zIndex=(parseInt(e.style.zIndex,null)-1).toString(),this.popupOverlay.style.display="block",this.popupContainer.appendChild(this.popupOverlay),t.EventHandler.add(this.popupOverlay,"click touchmove",this.onPopupOverlay,this))},e.prototype.paletteSelection=function(e,n){var i=e.element.querySelector(".e-control.e-colorpicker"),r=[].slice.call(t.selectAll(".e-tile",i.parentElement));t.removeClass(r,"e-selected");var o=n.querySelector("."+yn).style.borderBottomColor;r.filter(function(e){e.style.backgroundColor===o&&t.addClass([e],"e-selected")})},e.prototype.renderColorPickerDropDown=function(e,n,r,s){var a=this,l=this,d=yn+" "+Cn+(this.parent.inlineMode?" "+Wt:"");d+=" "+("backgroundcolor"===n?In:Rn);var p,h=l.parent.createElement("span",{className:Mn}),u=l.parent.createElement("span",{className:e.cssClass}),m=t.isNullOrUndefined(s)?l.parent.backgroundColor.default:s;u.style.borderBottomColor="backgroundcolor"===n?m:l.parent.fontColor.default,h.appendChild(u);var g=new i.DropDownButton({target:r.element.parentElement,cssClass:d,enablePersistence:this.parent.enablePersistence,enableRtl:this.parent.enableRtl,beforeOpen:function(n){if(!l.parent.readonly&&l.parent.enabled){var i=n.event?n.event.target:null;if(l.currentElement=g.element,l.currentDropdown=g,l.paletteSelection(n,l.currentElement),n.event&&"click"===n.event.type&&(i.classList.contains(Mn)||i.parentElement.classList.contains(Mn))){n.cancel=!0;var r=i.classList.contains(yn)?i.style.borderBottomColor:i.querySelector("."+yn).style.borderBottomColor;l.parent.notify(Re,{});var s=(p=l.parent.formatter.editorManager.nodeSelection.getRange(l.parent.contentModule.getDocument())).startContainer.parentNode;("TD"===p.startContainer.nodeName||"TH"===p.startContainer.nodeName||t.closest(p.startContainer.parentNode,"td,th")||l.parent.iframeSettings.enable&&!c(s.ownerDocument.querySelector("body"),"e-lib"))&&p.collapsed&&"BackgroundColor"===e.subCommand?l.parent.notify(qe,{item:{command:e.command,subCommand:e.subCommand,value:r}}):l.parent.notify(Fe,{item:{command:e.command,subCommand:e.subCommand,value:r}})}else{var a=n.element.querySelector(".e-control.e-colorpicker"),d=t.getInstance(a,o.ColorPicker);d.showButtons=!n.element.querySelector(".e-color-palette"),d.dataBind(),n.element.onclick=function(e){e.target.classList.contains("e-cancel")&&g.toggle()}}}else n.cancel=!0},open:function(e){a.setColorPickerContentWidth(r);var n,i=e.element.querySelector(".e-control.e-colorpicker");(n=e.element.querySelector(".e-color-palette")?i.parentElement.querySelector(".e-palette"):i.parentElement.querySelector("e-handler"))&&n.focus(),t.Browser.isDevice&&a.popupModal(e.element.parentElement),a.pickerRefresh(e)},beforeClose:function(n){var i=n.event?n.event.target:null;if(n.event&&"click"===n.event.type&&(i.classList.contains(Mn)||i.parentElement.classList.contains(Mn))){var r=i.classList.contains(yn)?i.style.borderBottomColor:i.querySelector("."+yn).style.borderBottomColor;("TD"===(p=l.parent.formatter.editorManager.nodeSelection.getRange(l.parent.contentModule.getDocument())).startContainer.nodeName||"TH"===p.startContainer.nodeName||t.closest(p.startContainer.parentNode,"td,th"))&&p.collapsed?l.parent.notify(qe,{item:{command:e.command,subCommand:e.subCommand,value:r}}):l.parent.notify(Fe,{item:{command:e.command,subCommand:e.subCommand,value:r}})}else;},close:function(e){l.parent.notify(Re,{});var n=t.closest(e.element.parentElement,".e-popup-container");if(n&&(n.style.display="none",n.lastElementChild.style.display="none",t.removeClass([n.lastElementChild],"e-popup-overlay")),t.Browser.isDevice&&!t.isNullOrUndefined(n)){var i=n.querySelector(".e-dropdown-popup.e-tbar-btn.e-control");i&&(n.parentNode.insertBefore(i,n.nextSibling),i.style.removeProperty("position"),t.removeClass([i],"e-popup-modal")),t.detach(n),l.popupContainer=void 0}}});g.isStringTemplate=!0,g.createElement=l.parent.createElement,e.element.setAttribute("role","button"),g.appendTo(e.element);return document.getElementById(g.element.id+"-popup").setAttribute("aria-owns",this.parent.getID()),g.element.insertBefore(h,g.element.querySelector(".e-caret")),e.element.tabIndex=-1,g.element.removeAttribute("type"),g.element.onmousedown=function(){l.parent.notify(Me,{})},g.element.onkeydown=function(){l.parent.notify(Me,{})},g},e.prototype.pickerRefresh=function(e){if("Picker"===this.parent.backgroundColor.mode){var n=e.element.parentElement;n.style.width=(n.offsetWidth+5).toString()+"px",t.getInstance(n,r.Popup).refreshPosition(n),n.style.width=(n.offsetWidth-5).toString()+"px"}},e.prototype.popupModal=function(e){var n=t.getInstance(e,r.Popup);n.relateTo=document.body,n.position={X:0,Y:0},n.targetType="container",n.collision={X:"fit",Y:"fit"},n.offsetY=4,n.dataBind(),this.setIsModel(e)},e.prototype.setColorPickerContentWidth=function(e){var n=e.element.nextSibling;if("0px"===n.style.width){n.style.width="";var i=parseInt(getComputedStyle(n).borderBottomWidth,10);n.style.width=t.formatUnit(n.children[0].offsetWidth+i+i)}},e.prototype.renderColorPicker=function(e,n){var i=this,r=new o.ColorPicker({enablePersistence:this.parent.enablePersistence,enableRtl:this.parent.enableRtl,inline:!0,value:"#fff",created:function(){var e="backgroundcolor"===n?i.parent.backgroundColor.default:i.parent.fontColor.default;r.setProperties({value:e})},mode:"backgroundcolor"===n?i.parent.backgroundColor.mode:i.parent.fontColor.mode,modeSwitcher:"backgroundcolor"===n?i.parent.backgroundColor.modeSwitcher:i.parent.fontColor.modeSwitcher,beforeTileRender:function(e){e.element.classList.add(Bn),e.element.classList.add(oi),""===e.value&&e.element.classList.add(si)},change:function(n){var r=n.currentValue.rgba;n.item={command:e.command,subCommand:e.subCommand,value:r},i.parent.notify(Re,{}),i.currentElement.querySelector("."+yn).style.borderBottomColor=r;var o=i.parent.formatter.editorManager.nodeSelection.getRange(i.parent.contentModule.getDocument());("TD"===o.startContainer.nodeName||"TH"===o.startContainer.nodeName||"BODY"===o.startContainer.nodeName||t.closest(o.startContainer.parentNode,"td,th"))&&o.collapsed&&"BackgroundColor"===e.subCommand?i.parent.notify(qe,n):i.parent.notify(Fe,n),i.currentDropdown.toggle()},beforeModeSwitch:function(e){""===r.value&&r.setProperties({value:"Picker"===e.mode?"#008000ff":""},!0),r.showButtons="Palette"!==e.mode}});return r.isStringTemplate=!0,r.columns="backgroundcolor"===n?this.parent.backgroundColor.columns:this.parent.fontColor.columns,r.presetColors="backgroundcolor"===n?this.parent.backgroundColor.colorCode:this.parent.fontColor.colorCode,r.cssClass="backgroundcolor"===n?An:Pn,r.createElement=this.parent.createElement,r.appendTo(document.getElementById(e.target)),r},e.prototype.renderPanel=function(){this.getPanel().classList.add(It)},e.prototype.getPanel=function(){return this.toolbarPanel},e.prototype.setPanel=function(e){this.toolbarPanel=e},e}(),Vi=function(){function n(e,n){this.tools={},this.parent=e,this.locator=n,this.renderFactory=this.locator.getService("rendererFactory"),this.addEventListener(),this.parent.toolbarSettings&&Object.keys(this.parent.toolbarSettings.itemConfigs).length>0?t.extend(this.tools,ui,E(this.parent.toolbarSettings.itemConfigs),!0):this.tools=ui}return n.prototype.addEventListener=function(){this.parent.on(Ge,this.setRtl,this),this.parent.on(F,this.removeEventListener,this)},n.prototype.removeEventListener=function(){this.parent.off(Ge,this.setRtl),this.parent.off(F,this.removeEventListener)},n.prototype.setRtl=function(e){t.isNullOrUndefined(this.toolbarObj)||this.toolbarObj.setProperties({enableRtl:e.enableRtl})},n.prototype.getClass=function(e){var t;switch(e){case"fontsize":t="e-rte-inline-size-template";break;case"fontcolor":case"backgroundcolor":t="e-rte-inline-color-template";break;default:t="e-rte-inline-template"}return t},n.prototype.getTemplateObject=function(e,t){var n;switch(e){case"fontcolor":case"backgroundcolor":case"numberformatlist":case"bulletformatlist":n="span";break;default:n="button"}return{command:this.tools[e.toLocaleLowerCase()].command,subCommand:this.tools[e.toLocaleLowerCase()].subCommand,template:this.parent.createElement(n,{id:this.parent.getID()+"_"+t+"_"+this.tools[e.toLocaleLowerCase()].id}).outerHTML,cssClass:this.parent.inlineMode.enable?this.getClass(e):"",tooltipText:g(e,this.locator)}},n.prototype.getObject=function(e,t){var n=e.toLowerCase();if(-1!==hi.indexOf(n))return this.getTemplateObject(n,t);switch(n){case"|":return{type:"Separator"};case"-":return{type:"Separator",cssClass:Sn};default:return{id:this.parent.getID()+"_"+t+"_"+this.tools[n.toLocaleLowerCase()].id,prefixIcon:this.tools[n.toLocaleLowerCase()].icon,tooltipText:g(n,this.locator),command:this.tools[n.toLocaleLowerCase()].command,subCommand:this.tools[n.toLocaleLowerCase()].subCommand}}},n.prototype.getItems=function(e,n){var i=this;if(this.parent.toolbarSettings.items.length<1)return[];for(var r=[],o=function(e){switch(typeof e){case"string":r.push(s.getObject(e,n));break;default:if(!t.isNullOrUndefined(e.click)){var o=e,a=o.click;o.click=function(){o.undo&&0===i.parent.formatter.getUndoRedoStack().length&&i.parent.formatter.saveData(),a.call(i),i.parent.formatter.getUndoRedoStack()[i.parent.formatter.getUndoRedoStack().length-1].text.trim()!==i.parent.inputElement.innerHTML.trim()&&o.undo&&i.parent.formatter.saveData()}}r.push(e)}},s=this,a=0,l=e;a<l.length;a++){o(l[a])}return r},n.prototype.getToolbarOptions=function(e){return{target:e.target,rteToolbarObj:this,items:this.getItems(e.items,e.container),overflowMode:e.mode,enablePersistence:this.parent.enablePersistence,enableRtl:this.parent.enableRtl}},n.prototype.render=function(t){this.toolbarRenderer=this.renderFactory.getRenderer(e.RenderType.Toolbar),this.toolbarRenderer.renderToolbar(this.getToolbarOptions(t))},n}(),Wi=function(){function n(e,t){this.parent=e,this.locator=t,this.renderFactory=this.locator.getService("rendererFactory"),this.addEventListener()}return n.prototype.initializeInstance=function(){this.toolbarRenderer=this.renderFactory.getRenderer(e.RenderType.Toolbar)},n.prototype.beforeRender=function(e){var n=e.item;n.cssClass&&t.addClass([e.element],n.cssClass),"Alignments"!==n.command&&"JustifyLeft"!==n.subCommand&&"JustifyRight"!==n.subCommand&&"JustifyCenter"!==n.subCommand||e.element.setAttribute("title",g(n.subCommand.toLocaleLowerCase(),this.locator))},n.prototype.dropdownContent=function(e,t,n){return'<span style="display: inline-flex;width:'+("quick"===t?"auto":e)+'" ><span class="e-rte-dropdown-btn-text">'+n+"</span></span>"},n.prototype.renderDropDowns=function(e){var n=this;this.initializeInstance();var i=e.containerType,r=e.container;hi.forEach(function(o){var s=void 0;if(-1!==d(o,e.items))switch(o){case"numberformatlist":if(s=t.select("#"+n.parent.getID()+"_"+i+"_NumberFormatList",r),t.isNullOrUndefined(s)||s.classList.contains(Yt))return;var a=n.parent.numberFormatList.types.slice();a.forEach(function(e){Object.defineProperties(e,{command:{value:"Lists",enumerable:!0},subCommand:{value:"NumberFormatList",enumerable:!0}})}),n.numberFormatListDropDown=n.toolbarRenderer.renderListDropDown({cssClass:"e-order-list "+yn+" "+fn,itemName:"NumberFormatList",items:a,element:s});break;case"bulletformatlist":if(s=t.select("#"+n.parent.getID()+"_"+i+"_BulletFormatList",r),t.isNullOrUndefined(s)||s.classList.contains(Yt))return;var l=n.parent.bulletFormatList.types.slice();l.forEach(function(e){Object.defineProperties(e,{command:{value:"Lists",enumerable:!0},subCommand:{value:"BulletFormatList",enumerable:!0}})}),n.bulletFormatListDropDown=n.toolbarRenderer.renderListDropDown({cssClass:"e-unorder-list "+yn+" "+fn,itemName:"BulletFormatList",items:l,element:s});break;case"formats":if(s=t.select("#"+n.parent.getID()+"_"+i+"_Formats",r),t.isNullOrUndefined(s)||s.classList.contains(Yt))return;var c=n.parent.format.types.slice();c.forEach(function(e){Object.defineProperties(e,{command:{value:"Formats",enumerable:!0},subCommand:{value:e.value,enumerable:!0}})});var h=t.isNullOrUndefined(n.parent.format.default)?c[0].text:n.parent.format.default;n.formatDropDown=n.toolbarRenderer.renderDropDownButton({iconCss:"quick"===i?"e-formats e-icons":"",content:n.dropdownContent(n.parent.format.width,i,"quick"===i?"":p(c,h,"text","text")),cssClass:Kt+" "+Xt+" "+kn,itemName:"Formats",items:c,element:s});break;case"fontname":if(s=t.select("#"+n.parent.getID()+"_"+i+"_FontName",r),t.isNullOrUndefined(s)||s.classList.contains(Yt))return;var m=n.parent.fontFamily.items.slice();m.forEach(function(e){Object.defineProperties(e,{command:{value:"Font",enumerable:!0},subCommand:{value:"FontName",enumerable:!0}})});var g=t.isNullOrUndefined(n.parent.fontFamily.default)?m[0].text:n.parent.fontFamily.default;n.fontNameDropDown=n.toolbarRenderer.renderDropDownButton({iconCss:"quick"===i?"e-font-name e-icons":"",content:n.dropdownContent(n.parent.fontFamily.width,i,"quick"===i?"":p(m,g,"text","text")),cssClass:Kt+" "+Xt+" "+Ln,itemName:"FontName",items:m,element:s}),t.isNullOrUndefined(n.parent.fontFamily.default)||(n.getEditNode().style.fontFamily=n.parent.fontFamily.default);break;case"fontsize":if(s=t.select("#"+n.parent.getID()+"_"+i+"_FontSize",r),t.isNullOrUndefined(s)||s.classList.contains(Yt))return;var f=n.parent.fontSize.items.slice();f.forEach(function(e){Object.defineProperties(e,{command:{value:"Font",enumerable:!0},subCommand:{value:"FontSize",enumerable:!0}})});var b=t.isNullOrUndefined(n.parent.fontSize.default)?f[1].text:n.parent.fontSize.default;n.fontSizeDropDown=n.toolbarRenderer.renderDropDownButton({content:n.dropdownContent(n.parent.fontSize.width,i,u(p(f,b.replace(/\s/g,""),"value","text"))),cssClass:Kt+" "+Xt+" "+On,itemName:"FontSize",items:f,element:s}),t.isNullOrUndefined(n.parent.fontSize.default)||(n.getEditNode().style.fontSize=n.parent.fontSize.default);break;case"alignments":if(s=t.select("#"+n.parent.getID()+"_"+i+"_Alignments",r),t.isNullOrUndefined(s)||s.classList.contains(Yt))return;n.alignDropDown=n.toolbarRenderer.renderDropDownButton({iconCss:"e-justify-left e-icons",cssClass:Kt+" "+Xt,itemName:"Alignments",items:gi,element:s});break;case"align":n.imageAlignmentDropDown(i,r,s);break;case"display":n.imageDisplayDropDown(i,r,s);break;case"tablerows":n.rowDropDown(i,r,s);break;case"tablecolumns":n.columnDropDown(i,r,s);break;case"tablecell":n.cellDropDown(i,r,s);break;case"tablecellverticalalign":n.verticalAlignDropDown(i,r,s);break;case"styles":n.tableStylesDropDown(i,r,s)}})},n.prototype.getUpdateItems=function(e,t){var n=e.slice();return n.forEach(function(e){Object.defineProperties(e,{command:{value:"Format"===t?"Formats":"Font",enumerable:!0},subCommand:{value:"Format"===t?e.value:t,enumerable:!0}})}),n},n.prototype.onPropertyChanged=function(e){for(var n,i,r=e.newProp,o=0,s=Object.keys(r);o<s.length;o++){switch(s[o]){case"fontFamily":if(this.fontNameDropDown)for(var a=0,l=Object.keys(r.fontFamily);a<l.length;a++){switch(l[a]){case"default":case"width":var d=this.fontNameDropDown.items;n=t.isNullOrUndefined(t.closest(this.fontNameDropDown.element,"."+Ft))?"toolbar":"quick";var c=t.isNullOrUndefined(this.parent.fontFamily.default)?d[0].text:this.parent.fontFamily.default;i=this.dropdownContent(this.parent.fontFamily.width,n,"quick"===n?"":p(d,c,"text","text")),this.fontNameDropDown.setProperties({content:i}),t.isNullOrUndefined(this.parent.fontFamily.default)?this.getEditNode().style.removeProperty("font-family"):this.getEditNode().style.fontFamily=this.parent.fontFamily.default;break;case"items":this.fontNameDropDown.setProperties({items:this.getUpdateItems(r.fontFamily.items,"FontName")})}}break;case"fontSize":if(this.fontSizeDropDown)for(var h=0,m=Object.keys(r.fontSize);h<m.length;h++){switch(m[h]){case"default":case"width":var g=this.fontSizeDropDown.items;n=t.isNullOrUndefined(t.closest(this.fontSizeDropDown.element,"."+Ft))?"toolbar":"quick";var f=t.isNullOrUndefined(this.parent.fontSize.default)?g[1].text:this.parent.fontSize.default;i=this.dropdownContent(this.parent.fontSize.width,n,u(p(g,f.replace(/\s/g,""),"value","text"))),this.fontSizeDropDown.setProperties({content:i}),t.isNullOrUndefined(this.parent.fontSize.default)?this.getEditNode().style.removeProperty("font-size"):this.getEditNode().style.fontSize=this.parent.fontSize.default;break;case"items":this.fontSizeDropDown.setProperties({items:this.getUpdateItems(r.fontSize.items,"FontSize")})}}break;case"format":if(this.formatDropDown)for(var b=0,v=Object.keys(r.format);b<v.length;b++){switch(v[b]){case"default":case"width":var y=this.formatDropDown.items;n=t.isNullOrUndefined(t.closest(this.formatDropDown.element,"."+Ft))?"toolbar":"quick";var C=t.isNullOrUndefined(this.parent.format.default)?y[0].text:this.parent.format.default;i=this.dropdownContent(this.parent.format.width,n,"quick"===n?"":p(y,C,"text","text")),this.formatDropDown.setProperties({content:i});break;case"types":this.formatDropDown.setProperties({items:this.getUpdateItems(r.format.types,"Format")})}}}}},n.prototype.getEditNode=function(){return this.parent.contentModule.getEditPanel()},n.prototype.rowDropDown=function(e,n,i){(i=t.select("#"+this.parent.getID()+"_"+e+"_TableRows",n)).classList.contains(Yt)||(this.tableRowsDropDown=this.toolbarRenderer.renderDropDownButton({iconCss:"e-table-rows e-icons",cssClass:Kt+" "+Xt+" "+_t,itemName:"TableRows",items:Si,element:i}))},n.prototype.columnDropDown=function(e,n,i){(i=t.select("#"+this.parent.getID()+"_"+e+"_TableColumns",n)).classList.contains(Yt)||(this.tableColumnsDropDown=this.toolbarRenderer.renderDropDownButton({iconCss:"e-table-columns e-icons",cssClass:Kt+" "+Xt+" "+_t,itemName:"TableColumns",items:Ei,element:i}))},n.prototype.cellDropDown=function(e,n,i){(i=t.select("#"+this.parent.getID()+"_"+e+"_TableCell",n)).classList.contains(Yt)||(this.tableRowsDropDown=this.toolbarRenderer.renderDropDownButton({iconCss:"e-table-cell e-icons",cssClass:Kt+" "+Xt+" "+_t,itemName:"TableCell",items:yi,element:i}))},n.prototype.verticalAlignDropDown=function(e,n,i){(i=t.select("#"+this.parent.getID()+"_"+e+"_TableCellVerticalAlign",n)).classList.contains(Yt)||(this.tableCellVerticalAlignDropDown=this.toolbarRenderer.renderDropDownButton({iconCss:"e-table-cell-ver-align e-icons",cssClass:Kt+" "+Xt+" "+_t,itemName:"TableCellVerticalAlign",items:wi,element:i}))},n.prototype.imageDisplayDropDown=function(e,n,i){(i=t.select("#"+this.parent.getID()+"_"+e+"_Display",n)).classList.contains(Yt)||(this.displayDropDown=this.toolbarRenderer.renderDropDownButton({iconCss:"e-display e-icons",cssClass:Kt+" "+Xt+" "+_t,itemName:"Display",items:vi,element:i}))},n.prototype.imageAlignmentDropDown=function(e,n,i){(i=t.select("#"+this.parent.getID()+"_"+e+"_Align",n)).classList.contains(Yt)||(this.imageAlignDropDown=this.toolbarRenderer.renderDropDownButton({iconCss:"e-justify-left e-icons",cssClass:Kt+" "+Gt+" "+_t,itemName:"Align",items:fi,element:i}))},n.prototype.tableStylesDropDown=function(e,n,i){(i=t.select("#"+this.parent.getID()+"_"+e+"_Styles",n)).classList.contains(Yt)||(this.imageAlignDropDown=this.toolbarRenderer.renderDropDownButton({iconCss:"e-style e-icons",cssClass:Kt+" "+Gt+" "+_t,itemName:"Styles",items:this.parent.tableSettings.styles,element:i}))},n.prototype.removeDropDownClasses=function(e){t.removeClass([e],[Yt,Kt,Gt,Xt])},n.prototype.destroyDropDowns=function(){this.formatDropDown&&(this.removeDropDownClasses(this.formatDropDown.element),this.formatDropDown.destroy()),this.fontNameDropDown&&(this.removeDropDownClasses(this.fontNameDropDown.element),this.fontNameDropDown.destroy()),this.fontSizeDropDown&&(this.removeDropDownClasses(this.fontSizeDropDown.element),this.fontSizeDropDown.destroy()),this.alignDropDown&&(this.removeDropDownClasses(this.alignDropDown.element),this.alignDropDown.destroy()),this.imageAlignDropDown&&(this.removeDropDownClasses(this.imageAlignDropDown.element),this.imageAlignDropDown.destroy()),this.displayDropDown&&(this.removeDropDownClasses(this.displayDropDown.element),this.displayDropDown.destroy()),this.tableRowsDropDown&&(this.removeDropDownClasses(this.tableRowsDropDown.element),this.tableRowsDropDown.destroy()),this.tableColumnsDropDown&&(this.removeDropDownClasses(this.tableColumnsDropDown.element),this.tableColumnsDropDown.destroy()),this.tableCellVerticalAlignDropDown&&(this.removeDropDownClasses(this.tableCellVerticalAlignDropDown.element),this.tableCellVerticalAlignDropDown.destroy()),this.numberFormatListDropDown&&(this.removeDropDownClasses(this.numberFormatListDropDown.element),this.numberFormatListDropDown.destroy()),this.bulletFormatListDropDown&&(this.removeDropDownClasses(this.bulletFormatListDropDown.element),this.bulletFormatListDropDown.destroy())},n.prototype.setRtl=function(e){this.formatDropDown&&this.formatDropDown.setProperties({enableRtl:e.enableRtl}),this.fontNameDropDown&&this.fontNameDropDown.setProperties({enableRtl:e.enableRtl}),this.fontSizeDropDown&&this.fontSizeDropDown.setProperties({enableRtl:e.enableRtl}),this.alignDropDown&&this.alignDropDown.setProperties({enableRtl:e.enableRtl}),this.imageAlignDropDown&&this.imageAlignDropDown.setProperties({enableRtl:e.enableRtl}),this.displayDropDown&&this.displayDropDown.setProperties({enableRtl:e.enableRtl}),this.numberFormatListDropDown&&this.numberFormatListDropDown.setProperties({enableRtl:e.enableRtl}),this.bulletFormatListDropDown&&this.bulletFormatListDropDown.setProperties({enableRtl:e.enableRtl})},n.prototype.addEventListener=function(){this.parent.isDestroyed||(this.parent.on(oe,this.beforeRender,this),this.parent.on(j,this.onIframeMouseDown,this),this.parent.on(Ge,this.setRtl,this),this.parent.on(F,this.removeEventListener,this),this.parent.on(Y,this.onPropertyChanged,this))},n.prototype.onIframeMouseDown=function(){C(document,"mousedown")},n.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(j,this.onIframeMouseDown),this.parent.off(Ge,this.setRtl),this.parent.off(oe,this.beforeRender),this.parent.off(F,this.removeEventListener),this.parent.off(Y,this.onPropertyChanged))},n}(),Ki=function(){function e(){this.services={}}return e.prototype.register=function(e,n){t.isNullOrUndefined(this.services[e])&&(this.services[e]=n)},e.prototype.getService=function(e){if(t.isNullOrUndefined(this.services[e]))throw"The service "+e+" is not registered";return this.services[e]},e}(),Gi=function(){function n(){this.rendererMap={}}return n.prototype.addRenderer=function(n,i){var r=t.getEnumValue(e.RenderType,n);t.isNullOrUndefined(this.rendererMap[r])&&(this.rendererMap[r]=i)},n.prototype.getRenderer=function(n){var i=t.getEnumValue(e.RenderType,n);if(t.isNullOrUndefined(this.rendererMap[i]))throw"The renderer "+i+" is not found";return this.rendererMap[i]},n}(),Xi=function(){function e(e){this.parent=e,this.addEventListener(),this.serviceLocator=new Ki,this.serviceLocator.register("rendererFactory",new Gi)}return e.prototype.addEventListener=function(){this.parent.on(q,this.toolbarClick,this),this.parent.on(re,this.dropDownSelect,this),this.parent.on(Fe,this.renderSelection,this),this.parent.on(F,this.removeEventListener,this)},e.prototype.toolbarClick=function(e){if(!t.isNullOrUndefined(e.item)){if(!t.isNullOrUndefined(e.item.controlParent)){var n=e.item.controlParent.activeEle;n&&(n.tabIndex=-1)}"NumberFormatList"!==e.item.command&&"BulletFormatList"!==e.item.command||(e.originalEvent.target.classList.contains("e-order-list")||e.originalEvent.target.classList.contains("e-unorder-list"))&&(e.item.command="Lists",e.item.subCommand="NumberFormatList"===e.item.subCommand?"OL":"UL"),"Lists"===e.item.command&&e.originalEvent.target.classList.contains("e-caret")&&(e.originalEvent.target.parentElement.classList.contains("e-rte-bulletformatlist-dropdown")||e.originalEvent.target.parentElement.classList.contains("e-rte-numberformatlist-dropdown"))&&(e.item.command=e.item.subCommand=null),this.parent.notify(K,e),this.parent.notify(G,e)}},e.prototype.dropDownSelect=function(e){if(this.parent.notify(Re,{}),!document.body.contains(document.body.querySelector(".e-rte-quick-toolbar"))||!e.item||"Images"!==e.item.command&&"Display"!==e.item.command&&"Table"!==e.item.command){var t=e.item.controlParent&&this.parent.quickToolbarModule&&this.parent.quickToolbarModule.tableQTBar&&this.parent.quickToolbarModule.tableQTBar.element.contains(e.item.controlParent.element)?"Table":null;if("Lists"===e.item.command){var n={listStyle:e.item.value,listImage:e.item.listImage,type:e.item.subCommand};this.parent.formatter.process(this.parent,e,e.originalEvent,n)}else this.parent.formatter.process(this.parent,e,e.originalEvent,t)}this.parent.notify(Me,{})},e.prototype.renderSelection=function(e){this.parent.notify(Re,{}),this.parent.formatter.process(this.parent,e,e.originalEvent,null),this.parent.notify(Me,{})},e.prototype.removeEventListener=function(){this.parent.off(q,this.toolbarClick),this.parent.off(re,this.dropDownSelect),this.parent.off(Fe,this.renderSelection),this.parent.off(F,this.removeEventListener)},e}(),Yi=function(){function n(n,i){this.parent=n,this.isToolbar=!1,this.locator=i,this.isTransformChild=!1,this.renderFactory=this.locator.getService("rendererFactory"),function(e){gi.forEach(function(t,n){gi[n].text=l(e,mi,gi[n])}),vi.forEach(function(t,n){vi[n].text=l(e,bi,vi[n])}),Si.forEach(function(t,n){Si[n].text=l(e,Ci,Si[n])}),Ei.forEach(function(t,n){Ei[n].text=l(e,Ni,Ei[n])}),wi.forEach(function(t,n){wi[n].text=l(e,Ti,wi[n])}),Li.forEach(function(t,n){Li[n].text=l(e,ki,Li[n])})}(this.parent),R(this.parent),this.renderFactory.addRenderer(e.RenderType.Toolbar,new Qi(this.parent)),this.toolbarRenderer=this.renderFactory.getRenderer(e.RenderType.Toolbar),this.baseToolbar=new Vi(this.parent,this.locator),this.addEventListener(),this.parent.toolbarSettings&&Object.keys(this.parent.toolbarSettings.itemConfigs).length>0?t.extend(this.tools,ui,E(this.parent.toolbarSettings.itemConfigs),!0):this.tools=ui}return n.prototype.initializeInstance=function(){this.contentRenderer=this.renderFactory.getRenderer(e.RenderType.Content),this.editableElement=this.contentRenderer.getEditPanel(),this.editPanel=this.contentRenderer.getPanel()},n.prototype.toolbarBindEvent=function(){this.parent.inlineMode.enable||(this.keyBoardModule=new t.KeyboardEvents(this.getToolbarElement(),{keyAction:this.toolBarKeyDown.bind(this),keyConfigs:this.parent.formatter.keyConfig,eventName:"keydown"}))},n.prototype.toolBarKeyDown=function(e){switch(e.action){case"escape":this.parent.contentModule.getEditPanel().focus()}},n.prototype.createToolbarElement=function(){this.tbElement=this.parent.createElement("div",{id:this.parent.getID()+"_toolbar"}),!t.Browser.isDevice&&this.parent.inlineMode.enable&&h()||(this.parent.toolbarSettings.enableFloating&&!this.parent.inlineMode.enable?(this.tbWrapper=this.parent.createElement("div",{id:this.parent.getID()+"_toolbar_wrapper",innerHTML:this.tbElement.outerHTML,className:Zt}),this.tbElement=this.tbWrapper.firstElementChild,this.parent.element.insertBefore(this.tbWrapper,this.editPanel)):this.parent.element.insertBefore(this.tbElement,this.editPanel))},n.prototype.getToolbarMode=function(){var t;switch(this.parent.toolbarSettings.type){case e.ToolbarType.Expand:t="Extended";break;case e.ToolbarType.Scrollable:t="Scrollable";break;default:t="MultiRow"}return h()&&this.parent.toolbarSettings.type===e.ToolbarType.Expand&&(t=e.ToolbarType.Scrollable),t},n.prototype.checkToolbarResponsive=function(n){if(!t.Browser.isDevice||h())return!1;var i;return i=this.parent.toolbarSettings.type===e.ToolbarType.Expand?e.ToolbarType.MultiRow:this.parent.toolbarSettings.type,this.baseToolbar.render({container:this.parent.inlineMode.enable?"quick":"toolbar",items:this.parent.toolbarSettings.items,mode:i,target:n}),this.parent.toolbarSettings.type===e.ToolbarType.Expand&&(t.addClass([n],["e-rte-tb-mobile"]),this.parent.inlineMode.enable?this.addFixedTBarClass():t.addClass([n],["e-tb-static"])),this.wireEvents(),this.dropDownModule.renderDropDowns({container:n,containerType:this.parent.inlineMode.enable?"quick":"toolbar",items:this.parent.toolbarSettings.items}),this.parent.notify(W,{container:this.tbElement,containerType:this.parent.inlineMode.enable?"quick":"toolbar",items:this.parent.toolbarSettings.items}),!0},n.prototype.checkIsTransformChild=function(){this.isTransformChild=!1;for(var e=t.selectAll('[style*="transform"]',document),n=0;n<e.length;n++)if(!t.isNullOrUndefined(e[n].contains)&&e[n].contains(this.parent.element)){this.isTransformChild=!0;break}},n.prototype.toggleFloatClass=function(e){var n,i,r=!1,o=!1,s=this.parent.floatingToolbarOffset;e&&this.parent.iframeSettings.enable&&this.parent.inputElement.ownerDocument===e.target?i=e.target.body:e&&e.target!==document?i=e.target:(r=!0,i=document.body);var a=this.getToolbarHeight()+this.getExpandTBarPopHeight();if(this.isTransformChild){n=0;var l=0,d=this.parent.element.offsetHeight;if(r){var c=window.getComputedStyle(i);l=parseFloat(c.marginTop.split("px")[0])+parseFloat(c.paddingTop.split("px")[0])}var p=this.parent.element.getBoundingClientRect().top,h=t.Browser.isMSPointer&&r?window.pageYOffset:i.parentElement.scrollTop,u=i.getBoundingClientRect(),m=r?u.top+h:u.top;p>m+s||p<-d||p<0&&!(p-(r?0:m)+d>a+s)?(o=!1,t.removeClass([this.tbElement],[At])):p<m+s&&(n=p<0?-p+m:m-p,n=r?n-l:n,t.addClass([this.tbElement],[At]),o=!0)}else{var g=this.parent.element.getBoundingClientRect();if(window.innerHeight<g.top)return;n=e&&e.target!==document?i.getBoundingClientRect().top:0,g.bottom<s+a+n||g.bottom<0||g.top>s+n?o=!1:g.top<s&&(o=!0)}o?(t.addClass([this.tbElement],[Pt]),t.setStyleAttribute(this.tbElement,{width:this.parent.element.offsetWidth+"px",top:s+n+"px"})):(t.removeClass([this.tbElement],[Pt]),t.setStyleAttribute(this.tbElement,{top:"0px",width:"100%"}))},n.prototype.renderToolbar=function(){if(this.initializeInstance(),this.createToolbarElement(),!this.checkToolbarResponsive(this.tbElement)){this.parent.inlineMode.enable?this.parent.notify(We,{}):(this.baseToolbar.render({container:"toolbar",items:this.parent.toolbarSettings.items,mode:this.getToolbarMode(),target:this.tbElement}),this.parent.inlineMode.enable||(this.parent.toolbarSettings.enableFloating&&(this.checkIsTransformChild(),this.toggleFloatClass()),t.addClass([this.parent.element],[pi]),this.parent.toolbarSettings.type===e.ToolbarType.Expand&&t.addClass([this.parent.element],[Ht]))),this.wireEvents(),this.parent.inlineMode.enable&&!h()&&this.addFixedTBarClass(),this.parent.inlineMode.enable||(this.dropDownModule.renderDropDowns({container:this.tbElement,containerType:"toolbar",items:this.parent.toolbarSettings.items}),this.parent.notify(W,{container:this.tbElement,containerType:"toolbar",items:this.parent.toolbarSettings.items}),this.refreshToolbarOverflow());var n=this.parent.element.querySelector(".e-rte-srctextarea"),i=this.parent.element.querySelector(".e-source-content");(!this.parent.iframeSettings.enable&&!t.isNullOrUndefined(n)&&"block"===n.style.display||this.parent.iframeSettings.enable&&!t.isNullOrUndefined(i)&&"block"===i.style.display)&&(this.parent.notify(Ce,{targetItem:"SourceCode",updateItem:"Preview",baseToolbar:this.parent.getBaseToolbarObject()}),this.parent.disableToolbarItem(this.parent.toolbarSettings.items))}},n.prototype.addFixedTBarClass=function(){t.addClass([this.tbElement],[Bt])},n.prototype.removeFixedTBarClass=function(){t.removeClass([this.tbElement],[Bt])},n.prototype.showFixedTBar=function(){t.addClass([this.tbElement],["e-show"]),t.Browser.isIos&&t.addClass([this.tbElement],[Nn])},n.prototype.hideFixedTBar=function(){this.isToolbar?this.isToolbar=!1:t.removeClass([this.tbElement],["e-show",Nn])},n.prototype.updateItem=function(e){var n=this.tools[e.updateItem.toLocaleLowerCase()],i=v(b(this.tools[e.targetItem.toLocaleLowerCase()].subCommand),e.baseToolbar.toolbarObj.items)[0];if(t.isNullOrUndefined(i))this.addTBarItem(e,0);else{var r=this.parent.inlineMode.enable?"_quick_":"_toolbar_";e.baseToolbar.toolbarObj.items[i].id=this.parent.getID()+r+n.id,e.baseToolbar.toolbarObj.items[i].prefixIcon=n.icon,e.baseToolbar.toolbarObj.items[i].tooltipText=n.tooltip,e.baseToolbar.toolbarObj.items[i].subCommand=n.subCommand,e.baseToolbar.toolbarObj.dataBind()}},n.prototype.updateToolbarStatus=function(e){if(this.tbElement&&(!this.parent.inlineMode.enable||!h()&&t.Browser.isDevice)){f({args:e,dropDownModule:this.dropDownModule,parent:this.parent,tbElements:t.selectAll("."+$t,this.tbElement),tbItems:this.baseToolbar.toolbarObj.items},!!this.parent.inlineMode.enable,this.parent)}},n.prototype.fullScreen=function(e){this.parent.fullScreenModule.showFullScreen(e)},n.prototype.hideScreen=function(e){this.parent.fullScreenModule.hideFullScreen(e)},n.prototype.getBaseToolbar=function(){return this.baseToolbar},n.prototype.addTBarItem=function(e,t){e.baseToolbar.toolbarObj.addItems([e.baseToolbar.getObject(e.updateItem,"toolbar")],t)},n.prototype.enableTBarItems=function(e,n,i,r){var o=v(b(n),e.toolbarObj.items);this.tbItems=t.selectAll("."+$t,e.toolbarObj.element);for(var s=0;s<o.length;s++){var a=this.tbItems[o[s]];a&&e.toolbarObj.enableItems(a,i)}t.select(".e-rte-srctextarea",this.parent.element)||r||y(e,this.parent.formatter.editorManager.undoRedoManager.getUndoStatus())},n.prototype.removeTBarItems=function(e){t.isNullOrUndefined(this.baseToolbar.toolbarObj)&&(this.baseToolbar=this.parent.getBaseToolbarObject());var n=v(b(e),this.baseToolbar.toolbarObj.items);this.tbItems=this.parent.inlineMode.enable?t.selectAll("."+$t,this.baseToolbar.toolbarObj.element):t.selectAll("."+$t,this.parent.element);for(var i=0;i<n.length;i++)this.baseToolbar.toolbarObj.removeItems(this.tbItems[n[i]])},n.prototype.getExpandTBarPopHeight=function(){var n=0;if(this.parent.toolbarSettings.type===e.ToolbarType.Expand&&this.tbElement.classList.contains("e-extended-toolbar")){var i=t.select(".e-toolbar-extended",this.tbElement);i&&this.tbElement.classList.contains("e-expand-open")||i&&i.classList.contains("e-popup-open")?(t.addClass([i],[tn]),n+=i.offsetHeight,t.removeClass([i],[tn])):t.removeClass([this.tbElement],[vn])}return n},n.prototype.getToolbarHeight=function(){return this.tbElement.offsetHeight},n.prototype.getToolbarElement=function(){return t.select("."+It,this.parent.element)},n.prototype.refreshToolbarOverflow=function(){this.baseToolbar.toolbarObj.refreshOverflow()},n.prototype.isToolbarDestroyed=function(){return this.baseToolbar.toolbarObj&&!this.baseToolbar.toolbarObj.isDestroyed},n.prototype.destroyToolbar=function(){if(this.isToolbarDestroyed()){this.parent.unWireScrollElementsEvents(),this.unWireEvents(),this.parent.notify(X,{}),this.dropDownModule.destroyDropDowns(),this.baseToolbar.toolbarObj.destroy(),this.removeEventListener(),t.removeClass([this.parent.element],[pi]),t.removeClass([this.parent.element],[Ht]);var e=t.select("."+Zt,this.parent.element),n=t.select("."+It,this.parent.element);t.isNullOrUndefined(e)?t.isNullOrUndefined(n)||t.detach(n):t.detach(e)}},n.prototype.destroy=function(){this.isToolbarDestroyed()&&(this.destroyToolbar(),this.keyBoardModule&&this.keyBoardModule.destroy())},n.prototype.scrollHandler=function(e){this.parent.inlineMode.enable||this.parent.toolbarSettings.enableFloating&&this.getDOMVisibility(this.tbElement)&&this.toggleFloatClass(e.args)},n.prototype.getDOMVisibility=function(e){return!(!e.offsetParent&&0===e.offsetWidth&&0===e.offsetHeight)},n.prototype.mouseDownHandler=function(){t.Browser.isDevice&&this.parent.inlineMode.enable&&!h()&&this.showFixedTBar()},n.prototype.focusChangeHandler=function(){t.Browser.isDevice&&this.parent.inlineMode.enable&&!h()&&(this.isToolbar=!1,this.hideFixedTBar())},n.prototype.dropDownBeforeOpenHandler=function(){this.isToolbar=!0},n.prototype.tbFocusHandler=function(e){var n=document.activeElement,i=t.closest(n,".e-rte-toolbar");if(n===this.parent.getToolbarElement()||i===this.parent.getToolbarElement())for(var r=this.parent.getToolbarElement().querySelectorAll(".e-expended-nav"),o=0;o<r.length;o++)t.isNullOrUndefined(this.parent.getToolbarElement().querySelector(".e-insert-table-btn"))?r[o].setAttribute("tabindex","0"):r[o].setAttribute("tabindex","1")},n.prototype.tbKeydownHandler=function(e){(e.target.classList.contains("e-dropdown-btn")||e.target.getAttribute("id")===this.parent.getID()+"_toolbar_CreateTable")&&e.target.setAttribute("tabindex","0")},n.prototype.toolbarClickHandler=function(n){var i=t.closest(n.originalEvent.target,".e-hor-nav");i&&this.parent.toolbarSettings.type===e.ToolbarType.Expand&&!t.isNullOrUndefined(i)?i.classList.contains("e-nav-active")?(t.addClass([this.tbElement],[vn]),this.parent.setContentHeight("toolbar",!0)):(t.removeClass([this.tbElement],[vn]),this.parent.setContentHeight("toolbar",!1)):(t.Browser.isDevice||this.parent.inlineMode.enable)&&(this.isToolbar=!0),t.isNullOrUndefined(i)&&this.parent.toolbarSettings.type===e.ToolbarType.Expand&&t.removeClass([this.tbElement],[vn])},n.prototype.wireEvents=function(){this.parent.inlineMode.enable&&h()||(t.EventHandler.add(this.tbElement,"focusin",this.tbFocusHandler,this),t.EventHandler.add(this.tbElement,"keydown",this.tbKeydownHandler,this))},n.prototype.unWireEvents=function(){t.EventHandler.remove(this.tbElement,"focusin",this.tbFocusHandler),t.EventHandler.remove(this.tbElement,"keydown",this.tbKeydownHandler)},n.prototype.addEventListener=function(){this.parent.isDestroyed||(this.dropDownModule=new Wi(this.parent,this.locator),this.toolbarActionModule=new Xi(this.parent),this.parent.on(H,this.renderToolbar,this),this.parent.on(He,this.scrollHandler,this),this.parent.on(V,this.toolbarBindEvent,this),this.parent.on(Q,this.updateToolbarStatus,this),this.parent.on(Y,this.onPropertyChanged,this),this.parent.on(_,this.onRefresh,this),this.parent.on(F,this.destroy,this),this.parent.on(ne,this.fullScreen,this),this.parent.on(ie,this.hideScreen,this),this.parent.on(Ce,this.updateItem,this),this.parent.on(De,this.dropDownBeforeOpenHandler,this),this.parent.on(Ie,this.parent.setContentHeight,this.parent),this.parent.on(ze,this.focusChangeHandler,this),this.parent.on(Pe,this.mouseDownHandler,this),this.parent.on(Ae,this.mouseDownHandler,this),this.parent.inlineMode.enable||h()||this.parent.on(q,this.toolbarClickHandler,this))},n.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(H,this.renderToolbar),this.parent.off(He,this.scrollHandler),this.parent.off(V,this.toolbarBindEvent),this.parent.off(Q,this.updateToolbarStatus),this.parent.off(Y,this.onPropertyChanged),this.parent.off(_,this.onRefresh),this.parent.off(F,this.destroy),this.parent.off(ne,this.parent.fullScreenModule.showFullScreen),this.parent.off(ie,this.parent.fullScreenModule.hideFullScreen),this.parent.off(Ce,this.updateItem),this.parent.off(De,this.dropDownBeforeOpenHandler),this.parent.off(Ie,this.parent.setContentHeight),this.parent.off(ze,this.focusChangeHandler),this.parent.off(Pe,this.mouseDownHandler),this.parent.off(Ae,this.mouseDownHandler),this.parent.inlineMode.enable||h()||this.parent.off(q,this.toolbarClickHandler))},n.prototype.onRefresh=function(){this.refreshToolbarOverflow(),this.parent.setContentHeight("",!0)},n.prototype.onPropertyChanged=function(e){if(!t.isNullOrUndefined(e.newProp.inlineMode))for(var n=0,i=Object.keys(e.newProp.inlineMode);n<i.length;n++){switch(i[n]){case"enable":this.refreshToolbar()}}e.module===this.getModuleName()&&this.refreshToolbar()},n.prototype.refreshToolbar=function(){t.isNullOrUndefined(this.baseToolbar.toolbarObj)&&(this.baseToolbar=this.parent.getBaseToolbarObject());var e=t.select("."+Zt,this.parent.element);(t.select("."+It,this.parent.element)||e)&&this.destroyToolbar(),this.parent.toolbarSettings.enable&&(this.addEventListener(),this.renderToolbar(),this.parent.wireScrollElementsEvents(),t.select(".e-rte-srctextarea",this.parent.element)||y(this.baseToolbar,this.parent.formatter.editorManager.undoRedoManager.getUndoStatus()),this.parent.notify(yt,{}))},n.prototype.getModuleName=function(){return"toolbar"},n}(),Ji=function(){var e=function(t,n){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(t,n)};return function(t,n){function i(){this.constructor=t}e(t,n),t.prototype=null===n?Object.create(n):(i.prototype=n.prototype,new i)}}(),$i=function(e,t,n,i){var r,o=arguments.length,s=o<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,n):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,n,i);else for(var a=e.length-1;a>=0;a--)(r=e[a])&&(s=(o<3?r(s):o>3?r(t,n,s):r(t,n))||s);return o>3&&s&&Object.defineProperty(t,n,s),s},Zi={backspace:8,tab:9,enter:13,shift:16,control:17,alt:18,pause:19,capslock:20,space:32,escape:27,pageup:33,pagedown:34,end:35,home:36,leftarrow:37,uparrow:38,rightarrow:39,downarrow:40,insert:45,delete:46,f1:112,f2:113,f3:114,f4:115,f5:116,f6:117,f7:118,f8:119,f9:120,f10:121,f11:122,f12:123,semicolon:186,plus:187,comma:188,minus:189,dot:190,forwardslash:191,graveaccent:192,openbracket:219,backslash:220,closebracket:221,singlequote:222,"]":221,"[":219,"=":187},er=function(e){function n(t,n){var r=e.call(this,n,t)||this;return r.keyPressHandler=function(e){for(var t=e.altKey,n=e.ctrlKey,o=e.shiftKey,s=e.metaKey,a=e.which,l=0,d=Object.keys(r.keyConfigs);l<d.length;l++)for(var c=d[l],p=0,h=r.keyConfigs[c].split(",");p<h.length;p++){var u=h[p],m=i.getKeyConfigData(u.trim());t!==m.altKey||n!==m.ctrlKey&&!s||o!==m.shiftKey||a!==m.keyCode||(e.action=c)}r.keyAction&&r.keyAction(e)},r.bind(),r}Ji(n,e),i=n,n.prototype.destroy=function(){this.unwireEvents(),e.prototype.destroy.call(this)},n.prototype.onPropertyChanged=function(e,t){},n.prototype.bind=function(){this.wireEvents()},n.prototype.getModuleName=function(){return"keyboard"},n.prototype.wireEvents=function(){this.element.addEventListener(this.eventName,this.keyPressHandler)},n.prototype.unwireEvents=function(){this.element.removeEventListener(this.eventName,this.keyPressHandler)},n.getKeyConfigData=function(e){if(e in this.configCache)return this.configCache[e];var t=e.toLowerCase().split("+"),n={altKey:-1!==t.indexOf("alt"),ctrlKey:-1!==t.indexOf("ctrl"),shiftKey:-1!==t.indexOf("shift"),keyCode:null};return t[t.length-1].length>1&&Number(t[t.length-1])?n.keyCode=Number(t[t.length-1]):n.keyCode=i.getKeyCode(t[t.length-1]),i.configCache[e]=n,n},n.getKeyCode=function(e){return Zi[e]||e.toUpperCase().charCodeAt(0)};var i;return n.configCache={},$i([t.Property({})],n.prototype,"keyConfigs",void 0),$i([t.Property("keyup")],n.prototype,"eventName",void 0),$i([t.Event()],n.prototype,"keyAction",void 0),n=i=$i([t.NotifyPropertyChanges],n)}(t.Base),tr=function(){function n(e,n){this.tools={},this.parent=e,this.locator=n,this.renderFactory=this.locator.getService("rendererFactory"),this.addEventListener(),this.parent.toolbarSettings&&Object.keys(this.parent.toolbarSettings.itemConfigs).length>0?t.extend(this.tools,ui,E(this.parent.toolbarSettings.itemConfigs),!0):this.tools=ui}return n.prototype.initializeInstance=function(){this.toolbarRenderer=this.renderFactory.getRenderer(e.RenderType.Toolbar)},n.prototype.renderColorPickerInput=function(e){var n=this;this.initializeInstance();var i,r,o=e.containerType,s=e.container;hi.forEach(function(a){if(-1!==d(a,e.items))switch(a){case"fontcolor":i=n.parent.getID()+"_"+o+"_FontColor_Target";var l=n.parent.createElement("input");l.id=i,l.classList.add(xn),document.body.appendChild(l),r={cssClass:n.tools[a.toLocaleLowerCase()].icon+" "+yn+" "+fn,value:n.tools[a.toLocaleLowerCase()].value,command:n.tools[a.toLocaleLowerCase()].command,subCommand:n.tools[a.toLocaleLowerCase()].subCommand,element:t.select("#"+n.parent.getID()+"_"+o+"_FontColor",s),target:i},n.fontColorPicker=n.toolbarRenderer.renderColorPicker(r,"fontcolor"),n.fontColorDropDown=n.toolbarRenderer.renderColorPickerDropDown(r,"fontcolor",n.fontColorPicker);break;case"backgroundcolor":i=n.parent.getID()+"_"+o+"_BackgroundColor_Target";var c=n.parent.createElement("input");c.id=i,c.classList.add(Dn),document.body.appendChild(c),r={cssClass:n.tools[a.toLocaleLowerCase()].icon+" "+yn+" "+fn,value:n.tools[a.toLocaleLowerCase()].value,command:n.tools[a.toLocaleLowerCase()].command,subCommand:n.tools[a.toLocaleLowerCase()].subCommand,element:t.select("#"+n.parent.getID()+"_"+o+"_BackgroundColor",s),target:i},n.backgroundColorPicker=n.toolbarRenderer.renderColorPicker(r,"backgroundcolor"),n.backgroundColorDropDown=n.toolbarRenderer.renderColorPickerDropDown(r,"backgroundcolor",n.backgroundColorPicker,n.defaultColorPicker)}})},n.prototype.destroy=function(){this.removeEventListener(),this.destroyColorPicker()},n.prototype.destroyColorPicker=function(){if(this.fontColorPicker&&!this.fontColorPicker.isDestroyed&&this.fontColorPicker.destroy(),this.backgroundColorPicker&&!this.backgroundColorPicker.isDestroyed&&this.backgroundColorPicker.destroy(),this.fontColorDropDown&&!this.fontColorDropDown.isDestroyed){(e=this.fontColorDropDown.element.querySelector(".e-rte-color-content"))&&t.detach(e),this.fontColorDropDown.destroy()}if(this.backgroundColorDropDown&&!this.backgroundColorDropDown.isDestroyed){var e;(e=this.backgroundColorDropDown.element.querySelector(".e-rte-color-content"))&&(this.defaultColorPicker=e.children[0].style.borderBottomColor,t.detach(e)),this.backgroundColorDropDown.destroy()}},n.prototype.setRtl=function(e){this.fontColorPicker&&(this.fontColorPicker.setProperties({enableRtl:e.enableRtl}),this.fontColorDropDown.setProperties({enableRtl:e.enableRtl})),this.backgroundColorPicker&&(this.backgroundColorPicker.setProperties({enableRtl:e.enableRtl}),this.backgroundColorDropDown.setProperties({enableRtl:e.enableRtl}))},n.prototype.addEventListener=function(){this.parent.on(te,this.renderColorPickerInput,this),this.parent.on(Ge,this.setRtl,this),this.parent.on(F,this.destroy,this),this.parent.on(X,this.destroyColorPicker,this),this.parent.on(Y,this.onPropertyChanged,this)},n.prototype.onPropertyChanged=function(e){for(var t=e.newProp,n=0,i=Object.keys(t);n<i.length;n++){switch(i[n]){case"fontColor":if(this.fontColorPicker)for(var r=0,o=Object.keys(t.fontColor);r<o.length;r++){switch(o[r]){case"default":this.fontColorPicker.setProperties({value:t.fontColor.default});this.fontColorDropDown.element.querySelector("."+this.tools.fontcolor.icon).style.borderBottomColor=t.fontColor.default;break;case"mode":this.fontColorPicker.setProperties({mode:t.fontColor.mode});break;case"columns":this.fontColorPicker.setProperties({columns:t.fontColor.columns});break;case"colorCode":this.fontColorPicker.setProperties({presetColors:t.fontColor.colorCode});break;case"modeSwitcher":this.fontColorPicker.setProperties({modeSwitcher:t.fontColor.modeSwitcher})}}break;case"backgroundColor":if(this.backgroundColorPicker)for(var s=0,a=Object.keys(t.backgroundColor);s<a.length;s++){switch(a[s]){case"default":this.backgroundColorPicker.setProperties({value:t.backgroundColor.default});this.backgroundColorDropDown.element.querySelector("."+this.tools.backgroundcolor.icon).style.borderBottomColor=t.backgroundColor.default;break;case"mode":this.backgroundColorPicker.setProperties({mode:t.backgroundColor.mode});break;case"columns":this.backgroundColorPicker.setProperties({columns:t.backgroundColor.columns});break;case"colorCode":this.backgroundColorPicker.setProperties({presetColors:t.backgroundColor.colorCode});break;case"modeSwitcher":this.backgroundColorPicker.setProperties({modeSwitcher:t.backgroundColor.modeSwitcher})}}}}},n.prototype.removeEventListener=function(){this.parent.off(te,this.renderColorPickerInput),this.parent.off(F,this.destroy),this.parent.off(Ge,this.setRtl),this.parent.off(X,this.destroyColorPicker),this.parent.off(Y,this.onPropertyChanged)},n}(),nr=function(){function n(t,n){this.parent=t,this.locator=n,this.isDOMElement=!1,this.renderFactory=this.locator.getService("rendererFactory"),this.contentRenderer=this.renderFactory.getRenderer(e.RenderType.Content),this.popupRenderer=this.renderFactory.getRenderer(e.RenderType.Popup),this.dropDownButtons=new Wi(this.parent,this.locator),this.colorPickerObj=new tr(this.parent,this.locator)}return n.prototype.appendPopupContent=function(){this.toolbarElement=this.parent.createElement("div",{className:Ft}),this.element.appendChild(this.toolbarElement)},n.prototype.render=function(e){var n;n="Image"===e.popupType?Qt:"Inline"===e.popupType?Vt:"";var i=t.getUniqueID(e.popupType+"_Quick_Popup");this.stringItems=e.toolbarItems,this.element=this.parent.createElement("div",{id:i,className:n+" "+yn}),this.element.setAttribute("aria-owns",this.parent.getID()),this.appendPopupContent(),this.createToolbar(e.toolbarItems,e.mode),this.popupRenderer.renderPopup(this),this.addEventListener()},n.prototype.createToolbar=function(e,t){this.quickTBarObj=new Vi(this.parent,this.locator),this.quickTBarObj.render({container:"quick",target:this.toolbarElement,items:e,mode:t}),this.quickTBarObj.toolbarObj.refresh()},n.prototype.setPosition=function(e){var n,i,r=t.closest(e.target,".e-img-caption"),o=t.isNullOrUndefined(r)?e.target:r;t.addClass([this.toolbarElement],[rn]);var s=o.offsetTop,a=window.pageYOffset+e.parentData.top;i=s-e.editTop>e.popHeight?a+e.tBarElementHeight+(s-e.editTop)-e.popHeight-5:e.editTop+e.editHeight-(s+o.offsetHeight)>e.popHeight?a+e.tBarElementHeight+(s-e.editTop)+o.offsetHeight+5:e.y,n=o.offsetWidth>e.popWidth?o.offsetWidth/2-e.popWidth/2+e.parentData.left+o.offsetLeft:e.parentData.left+o.offsetLeft,this.popupObj.position.X=n+e.popWidth>e.parentData.right?e.parentData.right-e.popWidth:n,this.popupObj.position.Y=i>=0?i:e.y+5,this.popupObj.dataBind(),t.removeClass([this.toolbarElement],[rn])},n.prototype.checkCollision=function(e,t,n){var i,o,s=e.parentData.top,a=e.windowY+s+e.tBarElementHeight,l=[];l="document"===t?r.isCollide(e.popup):r.isCollide(e.popup,e.parentElement);for(var d=0;d<l.length;d++)switch(l[d]){case"top":o="document"===t?e.windowY:window.pageYOffset+s+e.tBarElementHeight;break;case"bottom":o="document"===t?"inline"===n?e.y-e.popHeight-10:e.windowHeight-(s+e.tBarElementHeight)>e.popHeight?a-e.windowHeight>e.popHeight?a+(e.windowHeight-s)-e.popHeight:a:e.windowY+(s+e.tBarElementHeight):"IMG"!==e.target.tagName?e.parentData.bottom+window.pageYOffset-e.popHeight-10:e.parentData.bottom+window.pageYOffset-e.popHeight-5;break;case"right":i="inline"===n?window.pageXOffset+(e.windowWidth-(e.popWidth+e.bodyRightSpace+10)):e.x-e.popWidth;break;case"left":i="inline"===n?0:e.parentData.left}this.popupObj.position.X=i||this.popupObj.position.X,this.popupObj.position.Y=o||this.popupObj.position.Y,this.popupObj.dataBind()},n.prototype.showPopup=function(e,n,i){var r=this,o={popup:this.popupObj,cancel:!1,targetElement:i};this.parent.trigger(ot,o,function(o){if(!o.cancel){var s=void 0,a=void 0,l=window.getComputedStyle(document.body),d=parseFloat(l.marginRight.split("px")[0])+parseFloat(l.paddingRight.split("px")[0]),c=window.innerHeight,p=window.innerWidth,u=r.parent.element,m=!t.isNullOrUndefined(r.parent.getToolbar()),g=m&&r.parent.toolbarModule.getToolbarHeight(),f=m&&r.parent.toolbarModule.getExpandTBarPopHeight(),b=m?g+f:0;if(t.addClass([r.element],[en]),t.Browser.isDevice&&!h()&&t.addClass([r.parent.getToolbar()],[en]),r.parent.iframeSettings.enable){s=(v=r.contentRenderer.getPanel().contentWindow).pageYOffset,a=v.innerHeight}else{var v;s=(v=t.closest(i,"."+Jt))?v.scrollTop:0,a=v?v.offsetHeight:0}r.parent.inlineMode.enable||t.closest(i,"table")||(r.parent.disableToolbarItem(r.parent.toolbarSettings.items),r.parent.enableToolbarItem(["Undo","Redo"])),t.append([r.element],document.body),r.popupObj.position.X=e+20,r.popupObj.position.Y=n+20,r.popupObj.dataBind(),r.popupObj.element.classList.add("e-popup-open"),r.dropDownButtons.renderDropDowns({container:r.toolbarElement,containerType:"quick",items:r.stringItems}),r.colorPickerObj.renderColorPickerInput({container:r.toolbarElement,containerType:"quick",items:r.stringItems});var y={x:e,y:n,target:i,editTop:s,editHeight:a,popup:r.popupObj.element,popHeight:r.popupObj.element.offsetHeight,popWidth:r.popupObj.element.offsetWidth,parentElement:u,bodyRightSpace:d,windowY:window.pageYOffset,windowHeight:c,windowWidth:p,parentData:u.getBoundingClientRect(),tBarElementHeight:b};"IMG"===i.tagName&&r.setPosition(y),r.parent.inlineMode.enable||r.checkCollision(y,"parent",""),r.checkCollision(y,"document",r.parent.inlineMode.enable?"inline":""),r.popupObj.element.classList.remove("e-popup-open"),t.removeClass([r.element],[en]),r.popupObj.show({name:"ZoomIn",duration:t.Browser.isIE?250:400}),t.setStyleAttribute(r.element,{maxWidth:window.outerWidth+"px"}),t.addClass([r.element],[qt]),r.isDOMElement=!0}})},n.prototype.hidePopup=function(){var e=this.parent.sourceCodeModule.getViewPanel();t.Browser.isDevice&&!h()&&t.removeClass([this.parent.getToolbar()],[en]),t.isNullOrUndefined(this.parent.getToolbar())||this.parent.inlineMode.enable||(t.isNullOrUndefined(e)||"none"===e.style.display)&&this.parent.enableToolbarItem(this.parent.toolbarSettings.items),this.removeEleFromDOM(),this.isDOMElement=!1},n.prototype.addQTBarItem=function(e,t){this.quickTBarObj.toolbarObj.addItems(this.quickTBarObj.getItems(e,"toolbar"),t)},n.prototype.removeQTBarItem=function(e){this.quickTBarObj.toolbarObj.removeItems(e)},n.prototype.removeEleFromDOM=function(){var e=this.popupObj.element;if(this.isDOMElement){this.dropDownButtons.destroyDropDowns(),this.colorPickerObj.destroyColorPicker(),t.removeClass([this.element],[qt]),t.detach(e);var n=this.popupObj;this.parent.trigger(at,n)}},n.prototype.updateStatus=function(e){f({args:e,dropDownModule:this.dropDownButtons,parent:this.parent,tbElements:t.selectAll("."+$t,this.element),tbItems:this.quickTBarObj.toolbarObj.items},!0,this.parent),t.select(".e-rte-srctextarea",this.parent.element)||y(this.parent.getBaseToolbarObject(),this.parent.formatter.editorManager.undoRedoManager.getUndoStatus())},n.prototype.destroy=function(){this.popupObj&&!this.popupObj.isDestroyed&&(this.popupObj.destroy(),this.removeEleFromDOM()),this.removeEventListener()},n.prototype.addEventListener=function(){this.parent.isDestroyed||(this.parent.on(F,this.destroy,this),this.parent.on(Y,this.onPropertyChanged,this),this.parent.inlineMode.enable&&this.parent.on(Q,this.updateStatus,this))},n.prototype.onPropertyChanged=function(e){if(!t.isNullOrUndefined(e.newProp.inlineMode))for(var n=0,i=Object.keys(e.newProp.inlineMode);n<i.length;n++){switch(i[n]){case"enable":e.newProp.inlineMode.enable?this.parent.on(Q,this.updateStatus,this):this.parent.off(Q,this.updateStatus)}}},n.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(F,this.destroy),this.parent.off(Y,this.onPropertyChanged),this.parent.inlineMode.enable&&this.parent.off(Q,this.updateStatus))},n}(),ir=function(){function e(e){this.parent=e}return e.prototype.quickToolbarOpen=function(){var e=this.popupObj;this.parent.trigger(st,e)},e.prototype.renderPopup=function(e){this.setPanel(e.element),this.renderPanel(),e.popupObj=new r.Popup(e.element,{targetType:"relative",relateTo:this.parent.element,open:this.quickToolbarOpen.bind(this)}),this.popupObj=e.popupObj,e.popupObj.hide()},e.prototype.renderPanel=function(){this.getPanel().classList.add(zt)},e.prototype.getPanel=function(){return this.popupPanel},e.prototype.setPanel=function(e){this.popupPanel=e},e}(),rr=function(){function n(t,n){this.parent=t,this.locator=n,this.renderFactory=this.locator.getService("rendererFactory"),this.renderFactory.addRenderer(e.RenderType.Popup,new ir(this.parent)),this.addEventListener()}return n.prototype.formatItems=function(e){var t=[];return e.forEach(function(e){if("string"==typeof e)switch(e.toLocaleLowerCase()){case"open":t.push("openLink");break;case"edit":t.push("editLink");break;case"unlink":t.push("removeLink");break;default:t.push(e)}else t.push(e)}),t},n.prototype.getQTBarOptions=function(e,t,n,i){return{popupType:e,toolbarItems:n,mode:t,renderType:i}},n.prototype.createQTBar=function(e,t,n,i){if(n.length<1)return null;var r=new nr(this.parent,this.locator);return r.render(this.getQTBarOptions(e,t,this.formatItems(n),i)),r},n.prototype.initializeQuickToolbars=function(){this.parent.quickToolbarModule=this,this.contentRenderer=this.renderFactory.getRenderer(e.RenderType.Content),this.parent.inlineMode.enable&&this.parent.inlineMode.onSelection&&h()&&t.EventHandler.add(this.contentRenderer.getDocument(),"selectionchange",this.selectionChangeHandler,this)},n.prototype.onMouseDown=function(e){this.parent.isBlur=!1,this.parent.isRTE=!0},n.prototype.keyUpQT=function(e){27==e.which&&this.hideQuickToolbars()},n.prototype.renderQuickToolbars=function(){this.linkQTBar||this.imageQTBar||this.textQTBar||this.tableQTBar||(this.linkQTBar=this.createQTBar("Link","Scrollable",this.parent.quickToolbarSettings.link,e.RenderType.LinkToolbar),this.renderFactory.addRenderer(e.RenderType.LinkToolbar,this.linkQTBar),this.textQTBar=this.createQTBar("Text","Scrollable",this.parent.quickToolbarSettings.text,e.RenderType.TextToolbar),this.renderFactory.addRenderer(e.RenderType.TextToolbar,this.textQTBar),this.imageQTBar=this.createQTBar("Image","MultiRow",this.parent.quickToolbarSettings.image,e.RenderType.ImageToolbar),this.renderFactory.addRenderer(e.RenderType.ImageToolbar,this.imageQTBar),this.tableQTBar=this.createQTBar("Table","MultiRow",this.parent.quickToolbarSettings.table,e.RenderType.TableToolbar),this.renderFactory.addRenderer(e.RenderType.TableToolbar,this.tableQTBar),this.linkQTBar&&(t.EventHandler.add(this.linkQTBar.element,"mousedown",this.onMouseDown,this),t.EventHandler.add(this.linkQTBar.element,"keyup",this.keyUpQT,this)),this.imageQTBar&&(t.EventHandler.add(this.imageQTBar.element,"mousedown",this.onMouseDown,this),t.EventHandler.add(this.imageQTBar.element,"keyup",this.keyUpQT,this)),this.textQTBar&&(t.EventHandler.add(this.textQTBar.element,"mousedown",this.onMouseDown,this),t.EventHandler.add(this.textQTBar.element,"keyup",this.keyUpQT,this)),this.tableQTBar&&(t.EventHandler.add(this.tableQTBar.element,"mousedown",this.onMouseDown,this),t.EventHandler.add(this.tableQTBar.element,"keyup",this.keyUpQT,this)))},n.prototype.renderInlineQuickToolbar=function(){!this.parent.inlineMode.enable||t.Browser.isDevice&&!h()||(t.addClass([this.parent.element],[Ut]),this.inlineQTBar=this.createQTBar("Inline","MultiRow",this.parent.toolbarSettings.items,e.RenderType.InlineToolbar),this.renderFactory.addRenderer(e.RenderType.InlineToolbar,this.inlineQTBar),t.EventHandler.add(this.inlineQTBar.element,"mousedown",this.onMouseDown,this),t.EventHandler.add(this.inlineQTBar.element,"keyup",this.keyUpQT,this))},n.prototype.showInlineQTBar=function(e,t,n){this.parent.readonly||"img"===n.tagName.toLowerCase()||this.inlineQTBar.showPopup(e,t,n)},n.prototype.hideInlineQTBar=function(){this.inlineQTBar&&!c(this.inlineQTBar.element,"e-popup-close")&&this.inlineQTBar.hidePopup()},n.prototype.hideQuickToolbars=function(){this.linkQTBar&&!c(this.linkQTBar.element,"e-popup-close")&&document.body.contains(this.linkQTBar.element)&&this.linkQTBar.hidePopup(),this.textQTBar&&!c(this.textQTBar.element,"e-popup-close")&&document.body.contains(this.textQTBar.element)&&this.textQTBar.hidePopup(),this.imageQTBar&&!c(this.imageQTBar.element,"e-popup-close")&&document.body.contains(this.imageQTBar.element)&&this.imageQTBar.hidePopup(),this.tableQTBar&&!c(this.tableQTBar.element,"e-popup-close")&&document.body.contains(this.tableQTBar.element)&&this.tableQTBar.hidePopup(),!this.parent.inlineMode.enable||t.Browser.isDevice&&!h()||this.hideInlineQTBar()},n.prototype.deBounce=function(e,t,n){var i=this;clearTimeout(this.deBouncer),this.deBouncer=window.setTimeout(function(){i.showInlineQTBar(e,t,n)},1e3)},n.prototype.mouseUpHandler=function(e){if(this.parent.inlineMode.enable&&(!t.Browser.isDevice||h())){var n=e.args.touches?e.args.changedTouches[0]:e.args,i=this.parent.getRange(),r=e.args.target;if(t.isNullOrUndefined(t.select("."+Vt,document.body))){if(h()&&e.touchData&&e.touchData.prevClientX!==e.touchData.clientX&&e.touchData.prevClientY!==e.touchData.clientY)return;this.hideInlineQTBar();var o=this.parent.element.getBoundingClientRect().left;if(this.offsetX=this.parent.iframeSettings.enable?window.pageXOffset+o+n.clientX:n.pageX,this.offsetY=m(n,this.parent.element,this.parent.iframeSettings.enable),"TEXTAREA"===r.nodeName)this.showInlineQTBar(this.offsetX,this.offsetY,r);else{var s=t.closest(r,"a");r=s||r;var a=this.parent.getRange().startContainer.parentElement,l=this.parent.getRange().endContainer.parentElement;if((t.isNullOrUndefined(t.closest(a,"A"))||t.isNullOrUndefined(t.closest(l,"A")))&&(!t.closest(r,"td,th")||!i.collapsed)&&("IMG"!==r.tagName||this.parent.getRange().startOffset!==this.parent.getRange().endOffset)){if(this.parent.inlineMode.onSelection&&i.collapsed)return;this.target=r,this.showInlineQTBar(this.offsetX,this.offsetY,r)}}}}},n.prototype.keyDownHandler=function(){!this.parent.inlineMode.enable||t.Browser.isDevice&&!h()||t.isNullOrUndefined(t.select("."+Vt,document))||this.hideInlineQTBar()},n.prototype.inlineQTBarMouseDownHandler=function(){!this.parent.inlineMode.enable||t.Browser.isDevice&&!h()||t.isNullOrUndefined(t.select("."+Vt,document))||this.hideInlineQTBar()},n.prototype.keyUpHandler=function(e){if(this.parent.inlineMode.enable&&!t.Browser.isDevice){if(this.parent.inlineMode.onSelection)return;var n=e.args;this.deBounce(this.offsetX,this.offsetY,n.target)}},n.prototype.selectionChangeHandler=function(e){var t=this;clearTimeout(this.deBouncer),this.deBouncer=window.setTimeout(function(){t.onSelectionChange(e)},1e3)},n.prototype.onSelectionChange=function(e){if(t.isNullOrUndefined(t.select("."+Vt,document.body))){this.contentRenderer.getDocument().getSelection().isCollapsed||this.mouseUpHandler({args:e})}},n.prototype.getInlineBaseToolbar=function(){return this.inlineQTBar&&this.inlineQTBar.quickTBarObj},n.prototype.destroy=function(){this.linkQTBar&&(t.EventHandler.remove(this.linkQTBar.element,"mousedown",this.onMouseDown),t.EventHandler.remove(this.linkQTBar.element,"keyup",this.keyUpQT),this.linkQTBar.destroy()),this.textQTBar&&(t.EventHandler.remove(this.textQTBar.element,"mousedown",this.onMouseDown),t.EventHandler.remove(this.textQTBar.element,"keyup",this.keyUpQT),this.textQTBar.destroy()),this.imageQTBar&&(t.EventHandler.remove(this.imageQTBar.element,"mousedown",this.onMouseDown),t.EventHandler.remove(this.imageQTBar.element,"keyup",this.keyUpQT),this.imageQTBar.destroy()),this.tableQTBar&&(t.EventHandler.remove(this.tableQTBar.element,"mousedown",this.onMouseDown),t.EventHandler.remove(this.tableQTBar.element,"keyup",this.keyUpQT),this.tableQTBar.destroy()),this.inlineQTBar&&(t.EventHandler.remove(this.inlineQTBar.element,"mousedown",this.onMouseDown),t.EventHandler.remove(this.inlineQTBar.element,"keyup",this.keyUpQT),h()&&t.EventHandler.remove(document,"selectionchange",this.selectionChangeHandler),this.inlineQTBar.destroy()),this.removeEventListener()},n.prototype.wireInlineQTBarEvents=function(){this.parent.on(Z,this.mouseUpHandler,this),this.parent.on(Pe,this.inlineQTBarMouseDownHandler,this),this.parent.on($,this.keyDownHandler,this),this.parent.on(J,this.keyUpHandler,this),this.parent.on(Ae,this.mouseUpHandler,this),this.parent.on(We,this.renderInlineQuickToolbar,this)},n.prototype.unWireInlineQTBarEvents=function(){this.parent.off(Z,this.mouseUpHandler),this.parent.off(Pe,this.inlineQTBarMouseDownHandler),this.parent.off($,this.keyDownHandler),this.parent.off(J,this.keyUpHandler),this.parent.off(Ae,this.mouseUpHandler),this.parent.off(We,this.renderInlineQuickToolbar)},n.prototype.toolbarUpdated=function(e){this.linkQTBar&&!c(this.linkQTBar.element,"e-popup-close")&&this.linkQTBar.hidePopup(),this.imageQTBar&&!c(this.imageQTBar.element,"e-popup-close")&&this.imageQTBar.hidePopup(),this.tableQTBar&&!c(this.tableQTBar.element,"e-popup-close")&&this.tableQTBar.hidePopup()},n.prototype.addEventListener=function(){this.parent.isDestroyed||(this.parent.on(H,this.initializeQuickToolbars,this),this.parent.on(Pe,this.renderQuickToolbars,this),this.parent.on(Q,this.toolbarUpdated,this),this.parent.on("drop",this.renderQuickToolbars,this),this.wireInlineQTBarEvents(),this.parent.on(Y,this.onPropertyChanged,this),"hide"===this.parent.quickToolbarSettings.actionOnScroll&&(this.parent.on(He,this.hideQuickToolbars,this),this.parent.on(je,this.hideQuickToolbars,this)),this.parent.on(ze,this.hideQuickToolbars,this),this.parent.on(j,this.onIframeMouseDown,this),this.parent.on(F,this.destroy,this),this.parent.on($,this.onKeyDown,this),this.parent.on(Ge,this.setRtl,this))},n.prototype.onKeyDown=function(e){var t=e.args;8!==t.which&&46!==t.which||this.imageQTBar&&!c(this.imageQTBar.element,"e-popup-close")&&this.imageQTBar.hidePopup()},n.prototype.onIframeMouseDown=function(){this.hideQuickToolbars(),this.hideInlineQTBar()},n.prototype.setRtl=function(e){this.inlineQTBar&&this.inlineQTBar.quickTBarObj.toolbarObj.setProperties({enableRtl:e.enableRtl}),this.imageQTBar&&this.imageQTBar.quickTBarObj.toolbarObj.setProperties({enableRtl:e.enableRtl}),this.linkQTBar&&this.imageQTBar.quickTBarObj.toolbarObj.setProperties({enableRtl:e.enableRtl})},n.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(H,this.initializeQuickToolbars),this.parent.off(Pe,this.renderQuickToolbars),this.parent.off(Q,this.toolbarUpdated),this.parent.off("drop",this.renderQuickToolbars),this.unWireInlineQTBarEvents(),this.parent.off(Y,this.onPropertyChanged),"hide"===this.parent.quickToolbarSettings.actionOnScroll&&(this.parent.off(He,this.hideQuickToolbars),this.parent.off(je,this.hideQuickToolbars)),this.parent.off(ze,this.hideQuickToolbars),this.parent.off(F,this.destroy),this.parent.off(j,this.onIframeMouseDown),this.parent.off($,this.onKeyDown),this.parent.off(Ge,this.setRtl))},n.prototype.onPropertyChanged=function(e){if(!t.isNullOrUndefined(e.newProp.quickToolbarSettings))for(var n=0,i=Object.keys(e.newProp.quickToolbarSettings);n<i.length;n++){switch(i[n]){case"actionOnScroll":"none"===e.newProp.quickToolbarSettings.actionOnScroll?(this.parent.off(He,this.hideQuickToolbars),this.parent.off(je,this.hideQuickToolbars)):(this.parent.on(He,this.hideQuickToolbars,this),this.parent.on(je,this.hideQuickToolbars,this))}}e.module===this.getModuleName()&&(this.inlineQTBar&&(t.removeClass([this.parent.element],[Ut]),this.unWireInlineQTBarEvents(),this.hideInlineQTBar()),!this.parent.inlineMode.enable||t.Browser.isDevice&&!h()||(t.addClass([this.parent.element],[Ut]),this.wireInlineQTBarEvents()))},n.prototype.getModuleName=function(){return"quickToolbar"},n}(),or=function(){function n(e,t){this.parent=e,this.locator=t,this.renderFactory=this.locator.getService("rendererFactory"),this.addEventListener()}return n.prototype.initializeInstance=function(){this.contentRenderer=this.renderFactory.getRenderer(e.RenderType.Content),this.editPanel=this.contentRenderer.getEditPanel(),this.addEventListener()},n.prototype.renderCount=function(){this.initializeInstance(),this.element=this.parent.createElement("span",{className:un}),this.contentRenderer.getPanel().parentElement.appendChild(this.element),this.appendCount(),-1!==this.parent.maxLength&&this.charCountBackground(this.htmlLength)},n.prototype.appendCount=function(){var e="Markdown"===this.parent.editorMode?this.editPanel.value.trim():this.editPanel.textContent.trim();"Markdown"!==this.parent.editorMode&&-1!==e.indexOf("​")?this.htmlLength=e.replace(/\u200B/g,"").length:this.htmlLength=e.length;var t=-1===this.parent.maxLength?this.htmlLength:this.htmlLength+" / "+this.parent.maxLength;this.element.innerHTML=t},n.prototype.charCountBackground=function(e){var t=e/this.parent.maxLength*100;t<85?(this.element.classList.remove(mn),this.element.classList.remove(gn)):t>85&&t<=90?(this.element.classList.remove(gn),this.element.classList.add(mn)):t>90&&(this.element.classList.remove(mn),this.element.classList.add(gn))},n.prototype.refresh=function(){t.isNullOrUndefined(this.editPanel)||(this.appendCount(),-1!==this.parent.maxLength&&this.charCountBackground(this.htmlLength))},n.prototype.destroy=function(){this.element&&!t.isNullOrUndefined(this.parent.element.querySelector("."+un))&&t.detach(this.element),this.removeEventListener()},n.prototype.toggle=function(e){this.element.style.display="viewSource"===e.member?"none":"block"},n.prototype.addEventListener=function(){this.parent.isDestroyed||(this.parent.on(H,this.renderCount,this),this.parent.on(J,this.refresh,this),this.parent.on(Be,this.refresh,this),this.parent.on(_,this.refresh,this),this.parent.on(Pe,this.refresh,this),this.parent.on(F,this.destroy,this),this.parent.on(Oe,this.toggle,this),this.parent.on(xe,this.toggle,this))},n.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(H,this.renderCount),this.parent.off(J,this.refresh),this.parent.off(_,this.refresh),this.parent.off(Be,this.refresh),this.parent.off(Pe,this.refresh),this.parent.off(F,this.destroy),this.parent.off(Oe,this.toggle),this.parent.off(xe,this.toggle))},n.prototype.getModuleName=function(){return"count"},n}(),sr=function(){function e(){}return e.prototype.getLineNumber=function(e,t){return e.value.substr(0,t).split("\n").length},e.prototype.getSelectedText=function(e){var t=e.selectionStart,n=e.selectionEnd;return e.value.substring(t,n)},e.prototype.getAllParents=function(e){return e.split("\n")},e.prototype.getSelectedLine=function(e){return this.getAllParents(e.value)[this.getLineNumber(e,e.selectionStart)-1]},e.prototype.getLine=function(e,t){return this.getAllParents(e.value)[t]},e.prototype.getSelectedParentPoints=function(e){var t=this.getAllParents(e.value),n=this.getLineNumber(e,e.selectionStart),i=this.getLineNumber(e,e.selectionEnd),r=this.getSelectedText(e).split("\n"),o=[],s=t[n-1],a=t.slice(0,n-1).join("").length,l={};if(l.line=n-1,l.start=a+l.line,l.end=""!==s?l.start+s.length+1:l.start+s.length,l.text=s,o.push(l),r.length>1){for(var d=1;d<r.length-1;d++){var c={};c.line=o[d-1].line+1,c.start=(r[d],o[d-1].end),c.end=c.start+r[d].length+1,c.text=r[d],o.push(c)}var p={};p.line=o[o.length-1].line+1,p.start=o[o.length-1].end,p.end=p.start+t[i-1].length+1,p.text=t[i-1],o.push(p)}return o},e.prototype.setSelection=function(e,t,n){e.setSelectionRange(t,n),e.focus()},e.prototype.save=function(e,t){this.selectionStart=e,this.selectionEnd=t},e.prototype.restore=function(e){this.setSelection(e,this.selectionStart,this.selectionEnd)},e.prototype.isStartWith=function(e,t){var n=!1;if(e){n=(e.trim()===t.trim()?new RegExp("^("+this.replaceSpecialChar(t.trim())+")","gim"):new RegExp("^("+this.replaceSpecialChar(t)+")","gim")).test(e.trim())}return n},e.prototype.replaceSpecialChar=function(e){return e.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g,"\\$&")},e.prototype.isClear=function(e,t){for(var n=0;n<e.length;n++)if(new RegExp(t,"gim").test(e[n].text))return!0;return!1},e.prototype.getSelectedInlinePoints=function(e){return{start:e.selectionStart,end:e.selectionEnd,text:this.getSelectedText(e)}},e}(),ar=["a","abbr","acronym","audio","b","bdi","bdo","big","br","button","canvas","cite","code","data","datalist","del","dfn","em","embed","font","i","iframe","img","input","ins","kbd","label","map","mark","meter","noscript","object","output","picture","progress","q","ruby","s","samp","script","select","slot","small","span","strong","strike","sub","sup","svg","template","textarea","time","u","tt","var","video","wbr"],lr=function(){function e(e){this.toolbarStatus=this.prevToolbarStatus={bold:!1,italic:!1,subscript:!1,superscript:!1,strikethrough:!1,orderedlist:!1,uppercase:!1,lowercase:!1,inlinecode:!1,unorderedlist:!1,formats:null},this.selection=new sr,this.parent=e,this.element=this.parent.contentModule.getEditPanel(),this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.on(z,this.onRefreshHandler,this),this.parent.on(F,this.removeEventListener,this)},e.prototype.removeEventListener=function(){this.parent.off(z,this.onRefreshHandler),this.parent.off(F,this.removeEventListener)},e.prototype.onRefreshHandler=function(e){var t=this.selection.getSelectedParentPoints(this.element);this.toolbarStatus={orderedlist:!e.documentNode&&this.isListsApplied(t,"OL"),unorderedlist:!e.documentNode&&this.isListsApplied(t,"UL"),formats:this.currentFormat(t,e.documentNode),bold:!e.documentNode&&this.parent.formatter.editorManager.mdSelectionFormats.isAppliedCommand("Bold"),italic:!e.documentNode&&this.parent.formatter.editorManager.mdSelectionFormats.isAppliedCommand("Italic"),inlinecode:!e.documentNode&&this.parent.formatter.editorManager.mdSelectionFormats.isAppliedCommand("InlineCode"),strikethrough:!e.documentNode&&this.parent.formatter.editorManager.mdSelectionFormats.isAppliedCommand("StrikeThrough"),subscript:!e.documentNode&&this.parent.formatter.editorManager.mdSelectionFormats.isAppliedCommand("SubScript"),superscript:!e.documentNode&&this.parent.formatter.editorManager.mdSelectionFormats.isAppliedCommand("SuperScript"),uppercase:!e.documentNode&&this.parent.formatter.editorManager.mdSelectionFormats.isAppliedCommand("UpperCase")},this.parent.formatter.editorManager.mdSelectionFormats.isAppliedCommand("InlineCode")&&(this.toolbarStatus.formats="pre");var n=JSON.stringify(this.toolbarStatus);this.parent.notify(Q,this.toolbarStatus),JSON.stringify(this.prevToolbarStatus)!==n&&(this.parent.notify(Nt,{html:null,markdown:JSON.parse(n)}),this.prevToolbarStatus=JSON.parse(n))},e.prototype.isListsApplied=function(e,t){var n=!0;if("OL"===t)for(var i=0;i<e.length;i++){var r=e[i].text.trim().split(" ",2)[0]+" ";if(!/^[\d.]+[ ]+$/.test(r)){n=!1;break}}else for(i=0;i<e.length;i++)if(!this.selection.isStartWith(e[i].text,this.parent.formatter.listTags[t])){n=!1;break}return n},e.prototype.currentFormat=function(e,t){for(var n="p",i=Object.keys(this.parent.formatter.formatTags),r="backward"===this.element.selectionDirection?e[0].text:e[e.length-1].text,o=0;!t&&o<i.length;o++){if("pre"!==i[o]&&this.selection.isStartWith(r,this.parent.formatter.formatTags[i[o]])){n=i[o];break}if("pre"===i[o]&&this.codeFormat()){n=i[o];break}}return n},e.prototype.codeFormat=function(){var e=!1,t=this.parent.inputElement,n=function(e){return function(t){return[t.slice(0,e),t.slice(e)]}}(t.selectionStart)(t.value),i=this.parent.formatter.formatTags.pre,r=this.getSelectedText(t);if(""!==r&&r===r.toLocaleUpperCase())return!0;if(""===r){var o=t.value.substr(n[0].length-1,1),s=n[1].substr(0,1);if(""!==o&&""!==s&&o.match(/[a-z]/i)&&o===o.toLocaleUpperCase()&&s===s.toLocaleUpperCase())return!0}return this.isCode(n[0],i)&&this.isCode(n[1],i)&&n[0].match(this.multiCharRegx(i)).length%2==1&&n[1].match(this.multiCharRegx(i)).length%2==1&&(e=!0),e},e.prototype.getSelectedText=function(e){return e.value.substring(e.selectionStart,e.selectionEnd)},e.prototype.isCode=function(e,t){return-1!==e.search("\\"+t)},e.prototype.multiCharRegx=function(e){return new RegExp("(\\"+e+")","g")},e}(),dr=function(){function e(e){this.parent=e,this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.on(se,this.commandCallBack,this),this.parent.on(F,this.removeEventListener,this)},e.prototype.commandCallBack=function(e){"Undo"!==e.requestType&&"Redo"!==e.requestType&&this.parent.formatter.saveData(),this.parent.notify(z,{args:e}),this.parent.notify(Be,{})},e.prototype.removeEventListener=function(){this.parent.off(se,this.commandCallBack),this.parent.off(F,this.removeEventListener)},e}(),cr="action",pr="format-type",hr="keydown-handler",ur="keyup-handler",mr="model_changed_plugin",gr="model_changed",fr="ms_word_cleanup_plugin",br="ms_word_cleanup",vr="actionBegin",yr=function(){function e(){}return e.prototype.process=function(e,n,i,r){var o,s=this,a=e.contentModule.getDocument().getSelection(),l=a.rangeCount>0?a.getRangeAt(a.rangeCount-1):null;if("HTML"===e.editorMode&&(o=this.editorManager.nodeSelection.save(l,e.contentModule.getDocument())),t.isNullOrUndefined(n)||!n.item.command||"Table"===n.item.command||"Actions"===n.item.command||"Links"===n.item.command||"Images"===n.item.command||"Files"===n.item.command||!l||e.contentModule.getEditPanel().contains(this.getAncestorNode(l.commonAncestorContainer))||e.contentModule.getEditPanel()===l.commonAncestorContainer||e.contentModule.getPanel()===l.commonAncestorContainer){if(t.isNullOrUndefined(n)){var d=i.action;if("tab"!==d&&"enter"!==d&&"space"!==d&&"escape"!==d){n={},"Markdown"===e.editorMode&&"insert-table"===d&&(r={headingText:e.localeObj.getConstant("TableHeadingText"),colText:e.localeObj.getConstant("TableColText")});var c={originalEvent:i,cancel:!1,requestType:d||i.key+"Key",itemCollection:r};t.extend(n,n,c,!0),e.trigger(be,n,function(e){e.cancel&&("paste"!==d&&"cut"!==d&&"copy"!==d||i.preventDefault())})}var p=!!t.isNullOrUndefined(e.tableModule)||!!e.tableModule&&e.tableModule.ensureInsideTableList;(9===i.which&&p||9!==i.which)&&(13===i.which&&"HTML"===e.editorMode&&(r={enterAction:e.enterKey}),this.editorManager.observer.notify("keydown"===i.type?"keydown":"keyup",{event:i,callBack:this.onSuccess.bind(this,e),value:r,enterAction:e.enterKey}))}else!t.isNullOrUndefined(n)&&n.item.command&&n.item.subCommand&&(n.item.command!==n.item.subCommand&&"Font"!==n.item.command||("FontName"===n.item.subCommand||"FontSize"===n.item.subCommand)&&"dropDownSelect"===n.name||("BackgroundColor"===n.item.subCommand||"FontColor"===n.item.subCommand)&&"colorPickerChanged"===n.name)&&(t.extend(n,n,{requestType:n.item.subCommand,cancel:!1,itemCollection:r,selectType:n.name},!0),e.trigger(be,n,function(t){if(!t.cancel){0===s.getUndoRedoStack().length&&"Links"!==t.item.command&&"Images"!==t.item.command&&s.saveData(),e.isBlur=!1,e.contentModule.getEditPanel().focus(),"HTML"===e.editorMode&&o.restore();var n=t.item.subCommand.toLocaleLowerCase();"paste"===n||"cut"===n||"copy"===n?e.clipboardAction(n,i):(s.editorManager.observer.notify($e,{subCommand:t.item.subCommand}),s.editorManager.execCommand(t.item.command,t.item.subCommand,i,s.onSuccess.bind(s,e),t.item.value,"Pre"===t.item.subCommand&&"dropDownSelect"===t.selectType?{name:t.selectType}:r,"#"+e.getID()+" iframe",e.enterKey))}}));(t.isNullOrUndefined(i)||i&&"copy"!==i.action)&&this.enableUndo(e)}},e.prototype.getAncestorNode=function(e){return e=3===e.nodeType?e.parentNode:e},e.prototype.onKeyHandler=function(e,t){var n=this;this.editorManager.observer.notify("keyup",{event:t,callBack:function(){e.notify(U,{}),n.enableUndo(e)}})},e.prototype.onSuccess=function(e,n){e.notify(U,{}),n&&(t.isNullOrUndefined(n.event)||"copy"!==n.event.action)&&(this.enableUndo(e),e.notify(se,n)),e.trigger(ve,n,function(t){if(e.setPlaceHolder(),"Images"===t.requestType||"Links"===t.requestType&&"HTML"===e.editorMode){var n=t;if("Links"===t.requestType&&t.event&&"keydown"===t.event.type&&32===t.event.keyCode)return;e.notify(Ne,{args:n.event,type:t.requestType,isNotify:!0,elements:n.elements})}e.autoResize()})},e.prototype.saveData=function(e){this.editorManager.undoRedoManager.saveData(e)},e.prototype.getUndoStatus=function(){return this.editorManager.undoRedoManager.getUndoStatus()},e.prototype.getUndoRedoStack=function(){return this.editorManager.undoRedoManager.undoRedoStack},e.prototype.enableUndo=function(e){var n=this.getUndoStatus();!e.inlineMode.enable||t.Browser.isDevice&&!h()?e.toolbarModule&&y(e.toolbarModule.baseToolbar,n):y(e.quickToolbarModule.inlineQTBar.quickTBarObj,n)},e}(),Cr="lists-commands",Sr="command-type",Nr="link-commands",Er="clear-commands",Tr="insert-table",wr=function(){function e(e){t.extend(this,this,e,!0),this.selection=this.parent.markdownSelection,this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.observer.on(Cr,this.applyListsHandler,this),this.parent.observer.on(hr,this.keyDownHandler,this),this.parent.observer.on(ur,this.keyUpHandler,this)},e.prototype.keyDownHandler=function(e){switch(e.event.which){case 9:this.tabKey(e)}switch(e.event.action){case"ordered-list":this.applyListsHandler({subCommand:"OL",callBack:e.callBack}),e.event.preventDefault();break;case"unordered-list":this.applyListsHandler({subCommand:"UL",callBack:e.callBack}),e.event.preventDefault()}},e.prototype.keyUpHandler=function(e){switch(e.event.which){case 13:this.enterKey(e)}},e.prototype.tabKey=function(e){var t=this.parent.element;this.selection.save(t.selectionStart,t.selectionEnd);var n=t.selectionStart,i=t.selectionEnd,r=this.selection.getSelectedParentPoints(t),o=0,s=this.isNotFirstLine(t,r[0]);if(s||e.event.shiftKey){var a=this.olListType(),l=this.getListRegex();this.currentAction=this.getAction(r[0].text);for(var d=0;d<r.length;d++){var c=(e.event.shiftKey,r[d].line-1),p=this.selection.getLine(t,c);if(p&&(!e.event.shiftKey&&s||e.event.shiftKey)){var h=p.split(". "),u=e.event.shiftKey?-"\t".length:"\t".length,m=r[d].text.split("\t");if(e.event.shiftKey&&1===m.length)break;if("OL"===this.currentAction&&/^\d+$/.test(h[0].trim())&&a){e.event.preventDefault(),r[d].text=e.event.shiftKey?m.splice(1,m.length).join("\t"):"\t"+r[d].text;var g=this.getTabSpace(r[d].text),f=this.getTabSpace(p),b=r[d].text.split(". ");if(g===f)this.changeTextAreaValue(b,this.nextOrderedListValue(h[0].trim()),e,t,r,d,i);else if(f<g)this.changeTextAreaValue(b,"1. ",e,t,r,d,i);else for(;f.length>g.length;null){c-=1;var v=(p=this.selection.getLine(t,c)).trim().split(". ");if(/^\d+$/.test(v[0])&&(f=this.getTabSpace(p)).length<=g.length){this.changeTextAreaValue(b,this.nextOrderedListValue(v[0]),e,t,r,d,i);break}}}else("UL"===this.currentAction&&l.test(p.trim())||!a)&&(e.event.preventDefault(),r[d].text=e.event.shiftKey?m.splice(1,m.length).join("\t"):"\t"+r[d].text,t.value=t.value.substr(0,r[d].start)+r[d].text+"\n"+t.value.substr(r[d].end,t.value.length));if(n=0===d?n+u:n,o+=u,1!==r.length)for(var y=d;y<r.length;y++)r[y].start=0!==y?r[y].start+u:r[y].start,r[y].end=r[y].end+u}}this.restore(t,n,i+o,e)}else this.restore(t,n,i+o,e)},e.prototype.changeTextAreaValue=function(e,n,i,r,o,s,a){var l=n;e.splice(0,1);var d,c=this.selection.getAllParents(r.value).length,p="",h=this.getTabSpace(o[s].text),u=parseInt(l.split(".")[0],null),m=this.getTabSpace(o[s].text),g=!0,f=!0,b=-1,v=!0,y=0,C="";p=""!==this.selection.getLine(r,o[0].line+1)?"":p+r.value.substr(o[0].end,r.value.length);for(var S=1;S<c&&!t.isNullOrUndefined(this.selection.getLine(r,o[0].line+S))&&""!==this.selection.getLine(r,o[0].line+S);S++){var N=this.selection.getLine(r,o[0].line+S),E=this.getTabSpace(N),T=N.split(". ");if(1===T.length){p+=r.value.substr(o[0].end+y,r.value.length);break}y+=N.length;var w=!1;if(d=i.event.shiftKey?h.length+1:h.length-1,E.length>m.length&&(v=!1),h.length!==E.length&&E.length<m.length?(f=!0,g=!1,w=!(!i.event.shiftKey||h.length!==E.length)&&(f=!1,!0)):v&&i.event.shiftKey&&h.length===E.length&&E.length===m.length&&(f=!1,w=!0),C=""===p?"":"\n",d===E.length&&f){var k=i.event.shiftKey?(b++,this.nextOrderedListValue(b.toString())):this.previousOrderedListValue(T[0]);T.splice(0,1),p=p+C+E+k+T.join(". ")}else if(h.length===E.length&&g||w){k=this.nextOrderedListValue(u.toString());u++,T.splice(0,1),p=p+C+E+k+T.join(". ")}else p=p+C+N,f=!1;m=this.getTabSpace(N)}o[s].text=this.getTabSpace(o[s].text)+l+e.join(". ")+"\n",r.value=r.value.substr(0,o[s].start)+o[s].text+p},e.prototype.getTabSpace=function(e){for(var t=e.split("\t"),n="",i=0;i<t.length&&""===t[i];i++)n+="\t";return n},e.prototype.isNotFirstLine=function(e,t){var n,i=t.text,r=t.line-1,o=this.selection.getLine(e,r),s=this.getListRegex(),a=!1;if(o){this.currentAction=this.getAction(o);var l=o.split(". ");n="OL"===this.currentAction?/^\d+$/.test(l[0].trim()):s.test(o.trim())}if(o&&n){var d=this.getTabSpace(i),c=this.getTabSpace(o);for(a=d===c||a;c.length>d.length;null){r-=1;l=(o=this.selection.getLine(e,r)).trim().split(". ");if(("OL"===this.currentAction?/^\d+$/.test(l[0]):s.test(o.trim()))&&(c=this.getTabSpace(o)).length<=d.length){a=!0;break}}}return a},e.prototype.getAction=function(e){var t=e.split(". ")[0],n=/^\d+$/.test(t.trim()),i=e.trim().split(new RegExp("^("+this.selection.replaceSpecialChar(this.syntax.UL).trim()+")"))[1];return n?"OL":i?"UL":"NOTLIST"},e.prototype.nextOrderedListValue=function(e){return(parseInt(e,null)+1).toString()+". "},e.prototype.previousOrderedListValue=function(e){return(parseInt(e,null)-1).toString()+". "},e.prototype.enterKey=function(e){var n=this.parent.element;this.selection.save(n.selectionStart,n.selectionEnd);var i=n.selectionStart,r=n.selectionEnd,o=this.selection.getSelectedParentPoints(n),s=this.selection.getLine(n,o[0].line-1),a=this.olListType(),l=this.getListRegex(),d=[];t.isNullOrUndefined(s)||(d=s.split(". "),this.currentAction=this.getAction(s));var c=0;if("OL"===this.currentAction&&d.length>1&&/^\d+$/.test(d[0].trim())&&a&&""!==d[1]){var p=this.getTabSpace(s);this.currentAction=this.getAction(s);var h=this.nextOrderedListValue(d[0]);o[0].text=p+h+o[0].text;for(var u=this.selection.getAllParents(n.value).length,m="\n",g=this.getTabSpace(s),f=this.getTabSpace(o[0].text),b=!0,v=1;v<u&&""!==n.value.substr(o[0].end,n.value.length);v++){var y=this.selection.getLine(n,o[0].line+v);if(t.isNullOrUndefined(y))m+="";else{var C=y.split(". "),S=this.getTabSpace(y);if(S.length<f.length&&(b=!1),C.length>1&&/^\d+$/.test(C[0].trim())&&g.length===S.length&&b){var N=this.nextOrderedListValue(C[0]);C.splice(0,1),m=m+S+N+C.join(". ")+"\n"}else m=m+y+"\n",f=this.getTabSpace(y)}}n.value=n.value.substr(0,o[0].start)+g+h+this.selection.getLine(n,o[0].line)+m,i=i+h.length+p.length,c+=h.length+p.length}else if("UL"===this.currentAction&&s&&l.test(s.trim())&&""!==s.trim().replace(l,"")||"OL"===this.currentAction&&!a){p=this.getTabSpace(s),h=this.syntax[this.currentAction];o[0].text=p+h+o[0].text+(o[0].text.trim().length>0?"\n":""),n.value=n.value.substr(0,o[0].start)+o[0].text+n.value.substr(o[0].end,n.value.length),i=i+h.length+p.length,c+=h.length+p.length}this.restore(n,i,r+c,e)},e.prototype.olListType=function(){var e=this.syntax.OL.split(".,");return(1===e.length?null:parseInt(e[2].trim(),null)-parseInt(e[0].trim(),null))?1:0},e.prototype.applyListsHandler=function(e){var n=this.parent.element;this.selection.save(n.selectionStart,n.selectionEnd),this.currentAction=e.subCommand;for(var i,r=n.selectionStart,o=n.selectionEnd,s=0,a=0,l=0,d=this.selection.getSelectedParentPoints(n),c="",p=this.olListType(),h={},u=0;u<d.length;u++)if(i=p?"OL"===this.currentAction?u+p+". ":this.syntax[this.currentAction]:"OL"===this.currentAction?this.syntax.OL:this.syntax[this.currentAction],this.selection.isStartWith(d[u].text,i))d[u].text=d[u].text.replace(i,""),n.value=n.value.substr(0,d[u].start+l)+d[u].text+"\n"+n.value.substr(d[u].end+l,n.value.length),l-=i.length,a=i.length,this.restore(n,r-a,o+l,null);else{if(""===d[u].text&&0===u&&(this.selection.save(r,o),1!==d.length))for(var m=u;m<d.length;m++)d[m].start=0!==m?1+d[m].start:d[m].start,d[m].end=1+d[m].end;var g=t.isNullOrUndefined(d[u-1])?0:this.getTabSpace(d[u-1].text).length,f=this.appliedLine(d[u].text,i,h,g);if(c=f.line?c:i,d[u].text=f.line?f.line:c+d[u].text,f.space=f.space?f.space:0,n.value=n.value.substr(0,d[u].start+l)+d[u].text+"\n"+n.value.substr(d[u].end,n.value.length),r=0===u?r+c.length+f.space>0?r+c.length+f.space:0:r,s+=c.length+f.space,1!==d.length)for(m=u;m<d.length;m++)d[m].start=0!==m?c.length+d[m].start+f.space:d[m].start,d[m].end=c.length+d[m].end+f.space;this.restore(n,r,o+s,null)}this.restore(n,null,null,e)},e.prototype.appliedLine=function(e,n,i,r){var o={},s=new RegExp("^["+this.syntax.UL.trim()+"]"),a=e.split(". "),l=a[0]+". ",d=s.test(e.trim())||e.trim()===this.syntax.OL.trim()||e.trim()===this.syntax.UL.trim()||/^\d+$/.test(a[0].trim()),c=this.olListType(),p=this.getTabSpace(e).length;if("OL"===this.currentAction&&c&&(i[p.toString()]=t.isNullOrUndefined(i[p.toString()])?1:i[p.toString()].valueOf()+1,n=i[p.toString()].valueOf().toString()+". ",!t.isNullOrUndefined(r)&&r>p&&(i[r.toString()]=0)),d){var h=void 0,u=void 0;s.test(e.trim())?(u=this.syntax.UL,h=n,o.space=n.trim().length-this.syntax.UL.trim().length):/^\d+$/.test(a[0].trim())&&c?(u=a[0].trim()+". ",h=n,o.space=this.syntax.UL.trim().length-l.trim().length):/^\d+$/.test(a[0].trim())&&(u=a[0].trim()+". ",h=this.syntax.UL,o.space=this.syntax.UL.trim().length-l.trim().length),o.line=e.replace(u,h)}return o},e.prototype.restore=function(e,n,i,r){t.isNullOrUndefined(n)||t.isNullOrUndefined(n)||this.selection.save(n,i),t.isNullOrUndefined(r)||this.selection.restore(e),r&&r.callBack&&r.callBack({requestType:this.currentAction,selectedText:this.selection.getSelectedText(e),editorMode:"Markdown",event:r.event})},e.prototype.getListRegex=function(){for(var e="",t=Object.keys(this.syntax),n=0;n<t.length;n++){var i=this.selection.replaceSpecialChar(this.syntax[t[n]]);e+=""===e?"^("+i+")|^("+i.trim()+")":"|^("+i+")|^("+i.trim()+")"}return new RegExp(e)},e}(),kr=function(){function e(e){t.extend(this,this,e,!0),this.selection=this.parent.markdownSelection,this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.observer.on(pr,this.applyFormats,this)},e.prototype.applyFormats=function(e){e.subCommand=e.subCommand.toLowerCase();var n=this.parent.element;this.selection.save(n.selectionStart,n.selectionEnd);var i=this.selection.getSelectedParentPoints(n);if(this.isAppliedFormat(i)===e.subCommand){if("pre"===e.subCommand){if(!(i.length>1))return;this.applyCodeBlock(n,e,i)}return this.cleanFormat(n),void this.restore(n,n.selectionStart,n.selectionEnd,e)}if("p"===e.subCommand)return this.cleanFormat(n),void this.restore(n,n.selectionStart,n.selectionEnd,e);("pre"===e.subCommand&&1!==i.length||"pre"!==e.subCommand)&&this.cleanFormat(n,e.subCommand);var r=n.selectionStart,o=n.selectionEnd,s=0;if(i=this.selection.getSelectedParentPoints(n),"pre"!==e.subCommand){for(var a=0;a<i.length;a++)if(""===i[a].text||this.selection.isStartWith(i[a].text,"\\"+this.syntax[e.subCommand])){if(""===i[a].text&&0===a&&(this.selection.save(r,o),0===this.selection.getSelectedText(n).length&&(i[a].text=this.syntax[e.subCommand],n.value=n.value.substr(0,i[a].start)+this.syntax[e.subCommand]+n.value.substr(i[a].end,n.value.length),r=0===a?r+this.syntax[e.subCommand].length:r,s+=this.syntax[e.subCommand].length),1!==i.length))for(l=a;l<i.length;l++)i[l].start=0!==l?1+i[l].start:i[l].start,i[l].end=1+i[l].end}else if(i[a].text=this.syntax[e.subCommand]+i[a].text,n.value=n.value.substr(0,i[a].start)+i[a].text+"\n"+n.value.substr(i[a].end,n.value.length),r=0===a?r+this.syntax[e.subCommand].length:r,s+=this.syntax[e.subCommand].length,1!==i.length)for(var l=a;l<i.length;l++)i[l].start=0!==l?this.syntax[e.subCommand].length+i[l].start:i[l].start,i[l].end=this.syntax[e.subCommand].length+i[l].end;this.restore(n,r,o+s,e)}else i.length>1?this.applyCodeBlock(n,e,i):(t.extend(e,e,{subCommand:"InlineCode"},!0),this.parent.observer.notify(Sr,e))},e.prototype.clearRegex=function(){for(var e="",t=Object.keys(this.syntax),n=0;n<t.length&&"pre"!==t[n]&&"p"!==t[n];n++)e+=""===e?"^("+this.selection.replaceSpecialChar(this.syntax[t[n]].trim())+")":"|^("+this.selection.replaceSpecialChar(this.syntax[t[n]].trim())+")";return e},e.prototype.cleanFormat=function(e,t){var n=this.selection.getSelectedParentPoints(e),i=e.selectionStart,r=e.selectionEnd,o=0;if(this.selection.isClear(n,this.clearRegex())){for(var s=0;s<n.length;s++){for(var a=Object.keys(this.syntax),l=0;""!==n[s].text&&l<a.length;l++){var d=this.syntax[a[l]];if(a[l]!==t){var c=new RegExp("^("+this.selection.replaceSpecialChar(d)+")","gim");if(c.test(n[s].text)){if(n[s].text=n[s].text.replace(c,""),e.value=e.value.substr(0,n[s].start)+n[s].text+"\n"+e.value.substr(n[s].end,e.value.length),i=0===s?i-d.length>0?i-d.length:0:i,o+=d.length,1!==n.length)for(var p=0;p<n.length;p++)n[p].start=0!==p?n[p].start-d.length:n[p].start,n[p].end=n[p].end-d.length;break}}}if(""===n[s].text&&0===s&&(this.selection.save(i,r),1!==n.length))for(l=s;l<n.length;l++)n[l].start=0!==l?1+n[l].start:n[l].start,n[l].end=1+n[l].end}this.restore(e,i,r-o)}},e.prototype.applyCodeBlock=function(e,t,n){var i=t.subCommand,r=n[0].start,o=n[n.length-1].end,s=this.selection.getAllParents(e.value),a=s[n[0].line-1],l=s[n.length+1+1];if(this.selection.isStartWith(a,this.syntax.pre.split("\n")[0])||this.selection.isStartWith(l,this.syntax.pre.split("\n")[0])){var d=this.syntax[i],c=this.parent.markdownSelection.getSelectedInlinePoints(e),p=e.value.substr(0,e.selectionStart).lastIndexOf(d),h=e.value.substr(e.selectionEnd,e.selectionEnd).indexOf(d);h+=c.end;var u=this.replaceAt(e.value.substr(0,c.start),d,"",p,c.start),m=this.replaceAt(e.value.substr(c.end,e.value.length),d,"",0,h);e.value=u+c.text+m,r=this.selection.selectionStart-d.length,o=this.selection.selectionEnd-d.length}else{var g=e.value.substring(r,o).split("\n"),f=""===g[g.length-1]?"":"\n";e.value=e.value.substr(0,r)+this.syntax[i]+e.value.substring(r,o)+f+this.syntax[i]+e.value.substr(o,e.value.length),r=this.selection.selectionStart+this.syntax[i].length,o=this.selection.selectionEnd+this.syntax[i].length-1}this.restore(e,r,o,t)},e.prototype.replaceAt=function(e,t,n,i,r){return e.slice(0,i)+e.slice(i,r).replace(t,n)+e.slice(r)},e.prototype.restore=function(e,t,n,i){this.selection.save(t,n),this.selection.restore(e),i&&i.callBack&&i.callBack({requestType:i.subCommand,selectedText:this.selection.getSelectedText(e),editorMode:"Markdown",event:i.event})},e.prototype.isAppliedFormat=function(e,t){for(var n="p",i=(Object.keys(this.syntax),Object.keys(this.syntax)),r="backward"===this.parent.element.selectionDirection?e[0].text:e[e.length-1].text,o=0;!t&&o<i.length;o++){if("pre"!==i[o]&&this.selection.isStartWith(r,this.syntax[i[o]])){n=i[o];break}if("pre"===i[o]){var s=this.selection.getAllParents(this.parent.element.value),a=s[e[0].line-1],l=s[e.length+1];if(this.selection.isStartWith(a,this.syntax[i[o]].split("\n")[0])&&this.selection.isStartWith(l,this.syntax[i[o]].split("\n")[0])){n=i[o];break}}}return n},e}(),Lr=function(){function e(e){t.extend(this,this,e,!0),this.selection=this.parent.markdownSelection,this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.observer.on(Sr,this.applyCommands,this),this.parent.observer.on(hr,this.keyDownHandler,this)},e.prototype.keyDownHandler=function(e){switch(e.event.action){case"bold":this.applyCommands({subCommand:"Bold",callBack:e.callBack}),e.event.preventDefault();break;case"italic":this.applyCommands({subCommand:"Italic",callBack:e.callBack}),e.event.preventDefault();break;case"strikethrough":this.applyCommands({subCommand:"StrikeThrough",callBack:e.callBack}),e.event.preventDefault();break;case"uppercase":this.applyCommands({subCommand:"UpperCase",callBack:e.callBack}),e.event.preventDefault();break;case"lowercase":this.applyCommands({subCommand:"LowerCase",callBack:e.callBack}),e.event.preventDefault();break;case"superscript":this.applyCommands({subCommand:"SuperScript",callBack:e.callBack}),e.event.preventDefault();break;case"subscript":this.applyCommands({subCommand:"SubScript",callBack:e.callBack}),e.event.preventDefault()}},e.prototype.isBold=function(e,t){return-1!==e.search("\\"+t+"\\"+t)},e.prototype.isItalic=function(e,t){return-1!==e.search("\\"+t)},e.prototype.isMatch=function(e,t){var n=[""];switch(t){case this.syntax.Italic:case this.syntax.InlineCode:case this.syntax.StrikeThrough:n=e.match(this.singleCharRegx(t))}return n},e.prototype.multiCharRegx=function(e){return new RegExp("(\\"+e+"\\"+e+")","g")},e.prototype.singleCharRegx=function(e){return new RegExp("(\\"+e+")","g")},e.prototype.isAppliedCommand=function(e){var n=!1,i=this.parent.element,r=function(e){return function(t){return[t.slice(0,e),t.slice(e)]}}(i.selectionStart)(i.value),o=this.syntax.Bold.substr(0,1),s=this.syntax.Italic,a=this.parent.markdownSelection.getSelectedText(i);if(""!==a&&a===a.toLocaleUpperCase()&&"UpperCase"===e)return!0;if(""===a){var l=i.value.substr(r[0].length-1,1),d=r[1].substr(0,1);if(""!==l&&""!==d&&l.match(/[a-z]/i)&&l===l.toLocaleUpperCase()&&d===d.toLocaleUpperCase()&&"UpperCase"===e)return!0}return this.isBold(r[0],o)||this.isItalic(r[0],s)||this.isBold(r[1],o)||this.isItalic(r[1],s)||(t.isNullOrUndefined(this.isMatch(r[0],this.syntax.StrikeThrough))||t.isNullOrUndefined(this.isMatch(r[1],this.syntax.StrikeThrough))||this.isMatch(r[0],this.syntax.StrikeThrough).length%2!=1||this.isMatch(r[1],this.syntax.StrikeThrough).length%2!=1||"StrikeThrough"!==e||(n=!0),t.isNullOrUndefined(this.isMatch(r[0],this.syntax.InlineCode))||t.isNullOrUndefined(this.isMatch(r[1],this.syntax.InlineCode))||this.isMatch(r[0],this.syntax.InlineCode).length%2!=1||this.isMatch(r[1],this.syntax.InlineCode).length%2!=1||"InlineCode"!==e||(n=!0),t.isNullOrUndefined(r[0].match(/\<sub>/g))||t.isNullOrUndefined(r[1].match(/\<\/sub>/g))||r[0].match(/\<sub>/g).length%2!=1||r[1].match(/\<\/sub>/g).length%2!=1||"SubScript"!==e||(n=!0),t.isNullOrUndefined(r[0].match(/\<sup>/g))||t.isNullOrUndefined(r[1].match(/\<\/sup>/g))||r[0].match(/\<sup>/g).length%2!=1||r[1].match(/\<\/sup>/g).length%2!=1||"SuperScript"!==e||(n=!0)),this.isBold(r[0],o)&&this.isBold(r[1],o)&&r[0].match(this.multiCharRegx(o)).length%2==1&&r[1].match(this.multiCharRegx(o)).length%2==1&&"Bold"===e&&(n=!0),r[0]=this.isBold(r[0],o)?r[0].replace(this.multiCharRegx(o),"$%@"):r[0],r[1]=this.isBold(r[1],o)?r[1].replace(this.multiCharRegx(o),"$%@"):r[1],t.isNullOrUndefined(this.isMatch(r[0],this.syntax.Italic))||t.isNullOrUndefined(this.isMatch(r[1],this.syntax.Italic))||this.isMatch(r[0],this.syntax.Italic).length%2!=1||this.isMatch(r[1],this.syntax.Italic).length%2!=1||"Italic"!==e||(n=!0),t.isNullOrUndefined(this.isMatch(r[0],this.syntax.StrikeThrough))||t.isNullOrUndefined(this.isMatch(r[1],this.syntax.StrikeThrough))||this.isMatch(r[0],this.syntax.StrikeThrough).length%2!=1||this.isMatch(r[1],this.syntax.StrikeThrough).length%2!=1||"StrikeThrough"!==e||(n=!0),t.isNullOrUndefined(this.isMatch(r[0],this.syntax.InlineCode))||t.isNullOrUndefined(this.isMatch(r[1],this.syntax.InlineCode))||this.isMatch(r[0],this.syntax.InlineCode).length%2!=1||this.isMatch(r[1],this.syntax.InlineCode).length%2!=1||"InlineCode"!==e||(n=!0),t.isNullOrUndefined(r[0].match(/\<sub>/g))||t.isNullOrUndefined(r[1].match(/\<\/sub>/g))||r[0].match(/\<sub>/g).length%2!=1||r[1].match(/\<\/sub>/g).length%2!=1||"SubScript"!==e||(n=!0),t.isNullOrUndefined(r[0].match(/\<sup>/g))||t.isNullOrUndefined(r[1].match(/\<\/sup>/g))||r[0].match(/\<sup>/g).length%2!=1||r[1].match(/\<\/sup>/g).length%2!=1||"SuperScript"!==e||(n=!0),n},e.prototype.applyCommands=function(e){this.currentAction=e.subCommand;var t=this.parent.element;this.selection.save(t.selectionStart,t.selectionEnd);var n=t.selectionStart,i=t.selectionEnd,r=0,o=this.parent.markdownSelection.getSelectedInlinePoints(t);if(this.isAppliedCommand(e.subCommand)&&""!==o.text){var s=this.syntax[e.subCommand],a="SubScript"===e.subCommand?"</sub>":"SuperScript"===e.subCommand?"</sup>":this.syntax[e.subCommand],l="UpperCase"===e.subCommand||"LowerCase"===e.subCommand?0:s.length,d=t.value.substr(0,o.start).lastIndexOf(s),c=t.value.substr(o.end,t.value.length).indexOf(a);c+=o.end;var p=this.replaceAt(t.value.substr(0,o.start),s,"",d,o.start),h=this.replaceAt(t.value.substr(o.end,t.value.length),a,"",0,c);return t.value=p+o.text+h,void this.restore(t,n-l,i-l,e)}if(""===o.text||this.isApplied(o,e.subCommand))"UpperCase"!==e.subCommand&&"LowerCase"!==e.subCommand?("SubScript"===e.subCommand||"SuperScript"===e.subCommand?(o.text=this.textReplace(o.text,e.subCommand),o.text=this.syntax[e.subCommand]+o.text+"</"+this.syntax[e.subCommand].substring(1,5)):(o.text=this.textReplace(o.text,e.subCommand),o.text=this.syntax[e.subCommand]+o.text+this.syntax[e.subCommand]),t.value=t.value.substr(0,o.start)+o.text+t.value.substr(o.end,t.value.length),r=this.syntax[e.subCommand].length,o.start===o.end?this.restore(t,n+r,i+r,e):this.restore(t,n+r,i-r,e)):this.restore(t,n,i,e);else{r="UpperCase"===e.subCommand||"LowerCase"===e.subCommand?0:this.syntax[e.subCommand].length;var u=t.value.substr(o.start-this.syntax[e.subCommand].length,this.syntax[e.subCommand].length),m=void 0;if(u===e.subCommand||o.start-this.syntax[e.subCommand].length===t.value.indexOf(this.syntax[e.subCommand])&&(o.end===t.value.lastIndexOf(this.syntax[e.subCommand])||o.end===t.value.lastIndexOf("</"+this.syntax[e.subCommand].substring(1,5)))){m="SubScript"===e.subCommand||"SuperScript"===e.subCommand?t.value.substr(o.end,this.syntax[e.subCommand].length+1):t.value.substr(o.end,this.syntax[e.subCommand].length);p=this.replaceAt(t.value.substr(0,o.start),u,"",o.start-this.syntax[e.subCommand].length,o.start),h=this.replaceAt(t.value.substr(o.end,t.value.length),m,"",0,m.length);t.value=p+o.text+h,this.restore(t,n-r,i-r,e)}else"SubScript"===e.subCommand||"SuperScript"===e.subCommand?o.text=this.syntax[e.subCommand]+o.text+"</"+this.syntax[e.subCommand].substring(1,5):"UpperCase"===e.subCommand||"LowerCase"===e.subCommand?o.text="UpperCase"===e.subCommand?o.text.toUpperCase():o.text.toLowerCase():o.text=this.syntax[e.subCommand]+o.text+this.syntax[e.subCommand],t.value=t.value.substr(0,o.start)+o.text+t.value.substr(o.end,t.value.length),this.restore(t,n+r,i+r,e)}this.parent.undoRedoManager.saveData()},e.prototype.replaceAt=function(e,t,n,i,r){return e.slice(0,i)+e.slice(i,r).replace(t,n)+e.slice(r)},e.prototype.restore=function(e,t,n,i){this.selection.save(t,n),this.selection.restore(e),i&&i.callBack&&i.callBack({requestType:this.currentAction,selectedText:this.selection.getSelectedText(e),editorMode:"Markdown",event:i.event})},e.prototype.textReplace=function(e,t){var n=this.singleCharRegx(this.syntax[t]);switch(t){case"Bold":n=this.multiCharRegx(this.syntax[t].substr(0,1)),e=e.replace(n,"");break;case"Italic":if(this.isBold(e,this.syntax[t].substr(0,1))){var i=this.multiCharRegx(this.syntax[t].substr(0,1)),r=e;r=r.replace(i,"$%@").replace(n,"");var o=new RegExp("\\$%@","g");e=r.replace(o,this.syntax[t].substr(0,1)+this.syntax[t].substr(0,1))}else e=e.replace(n,"");break;case"StrikeThrough":case"InlineCode":e=e.replace(n,"");break;case"SubScript":e=e.replace(/<sub>/g,"").replace(/<\/sub>/g,"");break;case"SuperScript":e=e.replace(/<sup>/g,"").replace(/<\/sup>/g,"")}return e},e.prototype.isApplied=function(e,t){var n=this.singleCharRegx(this.syntax[t]);switch(t){case"SubScript":case"SuperScript":return(n=this.singleCharRegx(this.syntax[t])).test(e.text);case"Bold":case"StrikeThrough":return(n=this.multiCharRegx(this.syntax[t].substr(0,1))).test(e.text);case"UpperCase":case"LowerCase":return(n=new RegExp("^["+this.syntax[t]+"]*$","g")).test(e.text);case"Italic":var i=void 0,r=this.multiCharRegx(this.syntax[t].substr(0,1));if(r.test(e.text)){var o=e.text;o=o.replace(r,"$%#"),i=n.test(o)}else i=n.test(e.text);return i;case"InlineCode":return n.test(e.text)}},e}(),Or={h6:"###### ",h5:"##### ",h4:"#### ",h3:"### ",h2:"## ",h1:"# ",blockquote:"> ",pre:"```\n",p:""},xr={Bold:"**",Italic:"*",StrikeThrough:"~~",InlineCode:"`",SubScript:"<sub>",SuperScript:"<sup>",UpperCase:"A-Z",LowerCase:"a-z"},Dr={OL:"1. ",UL:"- "},Mr={"toolbar-focus":"alt+f10",escape:"27","insert-link":"ctrl+k","insert-image":"ctrl+shift+i","insert-table":"ctrl+shift+e",undo:"ctrl+z",redo:"ctrl+y",copy:"ctrl+c",cut:"ctrl+x",paste:"ctrl+v",bold:"ctrl+b",italic:"ctrl+i",underline:"ctrl+u",strikethrough:"ctrl+shift+s",uppercase:"ctrl+shift+u",lowercase:"ctrl+shift+l",superscript:"ctrl+shift+=",subscript:"ctrl+=",indents:"ctrl+]",outdents:"ctrl+[","html-source":"ctrl+shift+h","full-screen":"ctrl+shift+f","decrease-fontsize":"ctrl+shift+<","increase-fontsize":"ctrl+shift+>","justify-center":"ctrl+e","justify-full":"ctrl+j","justify-left":"ctrl+l","justify-right":"ctrl+r","clear-format":"ctrl+shift+r","ordered-list":"ctrl+shift+o","unordered-list":"ctrl+alt+o",space:"32",enter:"13",tab:"tab",delete:"46"},Rr={"toolbar-focus":"alt+f10",escape:"27","insert-link":"ctrl+k","insert-image":"ctrl+shift+i","insert-table":"ctrl+shift+e",undo:"ctrl+z",redo:"ctrl+y",copy:"ctrl+c",cut:"ctrl+x",paste:"ctrl+v",bold:"ctrl+b",italic:"ctrl+i",strikethrough:"ctrl+shift+s",uppercase:"ctrl+shift+u",lowercase:"ctrl+shift+l",superscript:"ctrl+shift+=",subscript:"ctrl+=","full-screen":"ctrl+shift+f","ordered-list":"ctrl+shift+o","unordered-list":"ctrl+alt+o"},Ir={b:["strong"],strong:["b"],i:["emp","cite"],emp:["i","cite"],cite:["i","emp"]},Br=["BR","IMG"],Pr=function(){function e(e,n){this.undoRedoStack=[],this.parent=e,this.undoRedoSteps=t.isNullOrUndefined(n)?30:n.undoRedoSteps,this.undoRedoTimer=t.isNullOrUndefined(n)?300:n.undoRedoTimer,this.selection=this.parent.markdownSelection,this.addEventListener()}return e.prototype.addEventListener=function(){var e=t.debounce(this.keyUp,this.undoRedoTimer);this.parent.observer.on(ur,e,this),this.parent.observer.on(hr,this.keyDown,this),this.parent.observer.on(cr,this.onAction,this),this.parent.observer.on(mr,this.onPropertyChanged,this)},e.prototype.onPropertyChanged=function(e){for(var t=0,n=Object.keys(e.newProp);t<n.length;t++){switch(n[t]){case"undoRedoSteps":this.undoRedoSteps=e.newProp.undoRedoSteps;break;case"undoRedoTimer":this.undoRedoTimer=e.newProp.undoRedoTimer}}},e.prototype.removeEventListener=function(){var e=t.debounce(this.keyUp,300);this.parent.observer.off(ur,e),this.parent.observer.off(hr,this.keyDown),this.parent.observer.off(cr,this.onAction),this.parent.observer.off(mr,this.onPropertyChanged)},e.prototype.destroy=function(){this.removeEventListener()},e.prototype.onAction=function(e){"Undo"===e.subCommand?this.undo(e):this.redo(e)},e.prototype.keyDown=function(e){var t=e.event;switch(t.action){case"undo":t.preventDefault(),this.undo(e);break;case"redo":t.preventDefault(),this.redo(e)}},e.prototype.keyUp=function(e){17===e.event.keyCode||e.event.ctrlKey||this.saveData(e)},e.prototype.saveData=function(e){var t=this.parent.element;this.selection.save(t.selectionStart,t.selectionEnd);var n=t.selectionStart,i=t.selectionEnd,r={text:this.parent.element.value,start:n,end:i};this.undoRedoStack.length>=this.steps&&(this.undoRedoStack=this.undoRedoStack.slice(0,this.steps+1)),this.undoRedoStack.length>1&&this.undoRedoStack[this.undoRedoStack.length-1].start===n&&this.undoRedoStack[this.undoRedoStack.length-1].end===i||(this.undoRedoStack.push(r),this.steps=this.undoRedoStack.length-1,this.steps>this.undoRedoSteps&&(this.undoRedoStack.shift(),this.steps--),e&&e.callBack&&e.callBack())},e.prototype.undo=function(e){if(this.steps>0){this.currentAction="Undo";var t=this.undoRedoStack[this.steps-1].start,n=this.undoRedoStack[this.steps-1].end,i=this.undoRedoStack[this.steps-1].text;this.parent.element.value=i,this.parent.element.focus(),this.steps--,this.restore(this.parent.element,t,n,e)}},e.prototype.redo=function(e){if(null!=this.undoRedoStack[this.steps+1]){this.currentAction="Redo";var t=this.undoRedoStack[this.steps+1].start,n=this.undoRedoStack[this.steps+1].end;this.parent.element.value=this.undoRedoStack[this.steps+1].text,this.parent.element.focus(),this.steps++,this.restore(this.parent.element,t,n,e)}},e.prototype.restore=function(e,t,n,i){this.selection.save(t,n),this.selection.restore(e),i&&i.callBack&&i.callBack({requestType:this.currentAction,selectedText:this.selection.getSelectedText(e),editorMode:"Markdown",event:i.event})},e.prototype.getUndoStatus=function(){var e={undo:!1,redo:!1};return this.steps>0&&(e.undo=!0),null!=this.undoRedoStack[this.steps+1]&&(e.redo=!0),e},e}(),Ar=function(){function e(e){this.parent=e,this.selection=this.parent.markdownSelection,this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.observer.on(Nr,this.createLink,this)},e.prototype.createLink=function(e){var t=this.parent.element;t.focus();var n=t.selectionStart,i=t.selectionEnd,r="Image"===e.subCommand?this.selection.getSelectedText(t):e.item.text,o="Image"===e.subCommand?n+2:n+1,s="Image"===e.subCommand?i+2:i+1;r="Image"===e.subCommand?"!["+r+"]("+e.item.url+")":"["+r+"]("+e.item.url+")",t.value=t.value.substr(0,n)+r+t.value.substr(i,t.value.length),this.parent.markdownSelection.setSelection(t,o,s),this.restore(t,o,s,e)},e.prototype.restore=function(e,t,n,i){this.selection.save(t,n),this.selection.restore(e),i&&i.callBack&&i.callBack({requestType:i.subCommand,selectedText:this.selection.getSelectedText(e),editorMode:"Markdown",event:i.event})},e}(),Ur=function(){function e(e){t.extend(this,this,e,!0),this.selection=this.parent.markdownSelection,this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.observer.on(Tr,this.createTable,this),this.parent.observer.on(hr,this.onKeyDown,this)},e.prototype.removeEventListener=function(){this.parent.observer.off(Tr,this.createTable),this.parent.observer.off(hr,this.onKeyDown)},e.prototype.destroy=function(){this.removeEventListener()},e.prototype.onKeyDown=function(e){"insert-table"===e.event.action&&(e.item=e.value,this.createTable(e))},e.prototype.createTable=function(e){this.element=this.parent.element;var t=this.element.selectionStart,n=this.element.selectionEnd,i=this.element.value;this.locale=e,this.selection.save(t,n),this.restore(this.element.selectionStart,this.element.selectionEnd,null),this.insertTable(t,n,i,e)},e.prototype.getTable=function(){var e="";return e+=this.textNonEmpty(),e+=this.tableHeader(this.locale),e+=this.tableCell(this.locale)},e.prototype.tableHeader=function(e){for(var t="",n=1;n<=2;n++){t+="|";for(var i=1;i<=2;i++)t+=1===n?e.item.headingText+" "+i+"|":"---------|";t+=this.insertLine()}return t},e.prototype.tableCell=function(e){for(var t="",n=1;n<=2;n++){t+="|";for(var i=1;i<=2;i++)t+=e.item.colText+" "+this.convertToLetters(n)+i+"|";t+=this.insertLine()}return t+=this.insertLine()},e.prototype.insertLine=function(){var e=document.createElement("div");return e.innerHTML="\n",e.textContent},e.prototype.insertTable=function(e,t,n,i){var r=this.selection.getSelectedParentPoints(this.element),o=r[r.length-1].text.split(" ",2),s=this.getFormatTag();o.length<2?(this.element.value=this.updateValue(this.getTable()),this.makeSelection(n,e,t)):this.ensureFormatApply(r[r.length-1].text)?this.checkValid(e,t,this.getTable(),n,i,o,r,s):(this.element.value=this.updateValue(this.getTable()),this.makeSelection(n,e,t)),this.restore(this.element.selectionStart,this.element.selectionEnd,i)},e.prototype.makeSelection=function(e,t,n){n=t+(e.length>0?12:10),t+=e.length>0?3:1,this.selection.setSelection(this.element,t,n)},e.prototype.getFormatTag=function(){for(var e=Object.keys(this.syntaxTag.Formats),t=Object.keys(this.syntaxTag.List),n=[],i=0;i<e.length;i++)n.push(this.syntaxTag.Formats[e[i]]);for(var r=0;r<t.length;r++)n.push(this.syntaxTag.List[t[r]]);return n},e.prototype.ensureFormatApply=function(e){for(var t=this.getFormatTag(),n=e.trim().split(" ",2)[0]+" ",i=0;i<t.length;i++)if(n===t[i]||/^[\d.]+[ ]+$/.test(n))return!0;return!1},e.prototype.ensureStartValid=function(e,t){for(var n=t[0].text.split(" ",2),i=e+1;i<=e+n[0].length+1;i++)if(this.element.selectionStart===i||this.element.selectionEnd===i)return!1;return!0},e.prototype.ensureEndValid=function(e,t){for(var n=e+1;n<=e+t+1;n++)if(this.element.selectionEnd===n)return!1;return!0},e.prototype.updateValueWithFormat=function(e,t){var n=this.element.value.substring(this.element.selectionEnd,this.element.value.length);return t+=n.replace(n,e[0]+" "+n),this.element.value.substr(0,this.element.selectionStart)+t},e.prototype.updateValue=function(e){return this.element.value.substr(0,this.element.selectionStart)+e+this.element.value.substr(this.element.selectionEnd,this.element.value.length)},e.prototype.checkValid=function(e,t,n,i,r,o,s,a){this.ensureStartValid(s[0].start,s)&&this.ensureEndValid(s[s.length-1].start,o[0].length)&&(e===s[0].start?e!==t&&t!==s[s.length-1].end-1?this.element.value=this.updateValueWithFormat(o,n):this.element.value=this.updateValue(n):t===s[s.length-1].end-1?this.element.value=this.updateValue(n):this.element.value=this.updateValueWithFormat(o,n),this.makeSelection(i,e,t))},e.prototype.convertToLetters=function(e){var t="A".charCodeAt(0),n="";do{e-=1,n=String.fromCharCode(t+e%26)+n,e=e/26>>0}while(e>0);return n},e.prototype.textNonEmpty=function(){var e="";return(this.isCursorBased()||this.isSelectionBased())&&this.element.value.length>0&&(e+=this.insertLine(),e+=this.insertLine()),e},e.prototype.isCursorBased=function(){return this.element.selectionStart===this.element.selectionEnd},e.prototype.isSelectionBased=function(){return this.element.selectionStart!==this.element.selectionEnd},e.prototype.restore=function(e,t,n){this.selection.save(e,t),this.selection.restore(this.element),n&&n.callBack&&n.callBack({requestType:n.subCommand,selectedText:this.selection.getSelectedText(this.element),editorMode:"Markdown",event:n.event})},e}(),Hr=function(){function e(e){this.parent=e,this.selection=this.parent.markdownSelection,this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.observer.on(Er,this.clear,this)},e.prototype.replaceRegex=function(e){return e.replace(/\*/gi,"\\*").replace(/\&/gi,"\\&").replace(/\-/gi,"\\-").replace(/\^/gi,"\\^").replace(/\$/gi,"\\$").replace(/\./gi,"\\.").replace(/\|/gi,"\\|").replace(/\?/gi,"\\?").replace(/\+/gi,"\\+").replace(/\-/gi,"\\-").replace(/\&/gi,"\\&")},e.prototype.clearSelectionTags=function(e){for(var t=this.parent.selectionTags,n=Object.keys(t),i=0;i<n.length;i++){var r=n[i];if(t.hasOwnProperty(r)&&""!==t[r]){var o=this.replaceRegex(t[r]),s=void 0,a=t[r].length,l="<sup>"===t[r]||"<sub>"===t[r]?t[r].length+1:t[r].length;s="<sup>"===t[r]?new RegExp("<sup>(.*?)</sup>","ig"):"<sub>"===t[r]?new RegExp("<sub>(.*?)</sub>","ig"):new RegExp(o+"(.*?)"+o,"ig");for(var d=e.match(s),c=0;d&&c<d.length&&""!==d[c];c++)e=e.replace(d[c],d[c].substr(a,d[c].length-l-a))}}return e},e.prototype.clearFormatTags=function(e){var t=e.split("\n");return this.clearFormatLines(t)},e.prototype.clearFormatLines=function(e){for(var t=[this.parent.formatTags,this.parent.listTags],n="",i=0;i<e.length;i++){for(var r=0;r<t.length;r++)for(var o=t[r],s=Object.keys(o),a=0;a<s.length;a++){var l=s[a];o.hasOwnProperty(l)&&""!==o[l]&&0===e[i].indexOf(o[l])&&(e[i]=e[i].replace(o[l],""),e[i]=this.clearFormatLines([e[i]]))}n=n+e[i]+(i!==e.length-1?"\n":"")}return n},e.prototype.clear=function(e){var t=this.parent.element;t.focus();var n=t.selectionStart,i=t.selectionEnd,r=this.selection.getSelectedText(t);r=this.clearSelectionTags(r),r=this.clearFormatTags(r),t.value=t.value.substr(0,n)+r+t.value.substr(i,t.value.length),this.parent.markdownSelection.setSelection(t,n,n+r.length),this.restore(t,n,n+r.length,e)},e.prototype.restore=function(e,t,n,i){this.selection.save(t,n),this.selection.restore(e),i&&i.callBack&&i.callBack({requestType:i.subCommand,selectedText:this.selection.getSelectedText(e),editorMode:"Markdown",event:i.event})},e}(),jr=function(){function e(e){this.initialize(),t.extend(this,this,e,!0),this.observer=new t.Observer(this),this.markdownSelection=new sr,this.listObj=new wr({parent:this,syntax:this.listTags}),this.formatObj=new kr({parent:this,syntax:this.formatTags}),this.undoRedoManager=new Pr(this,e.options),this.mdSelectionFormats=new Lr({parent:this,syntax:this.selectionTags}),this.linkObj=new Ar(this),this.tableObj=new Ur({parent:this,syntaxTag:{Formats:this.formatTags,List:this.listTags}}),this.clearObj=new Hr(this),this.wireEvents()}return e.prototype.initialize=function(){this.formatTags=Or,this.listTags=Dr,this.selectionTags=xr},e.prototype.wireEvents=function(){this.observer.on("keydown",this.editorKeyDown,this),this.observer.on("keyup",this.editorKeyUp,this),this.observer.on(gr,this.onPropertyChanged,this)},e.prototype.onPropertyChanged=function(e){this.observer.notify(mr,e)},e.prototype.editorKeyDown=function(e){this.observer.notify(hr,e)},e.prototype.editorKeyUp=function(e){this.observer.notify(ur,e)},e.prototype.execCommand=function(e,t,n,i,r,o){switch(e.toLocaleLowerCase()){case"lists":this.observer.notify(Cr,{subCommand:t,event:n,callBack:i});break;case"formats":this.observer.notify(pr,{subCommand:t,event:n,callBack:i});break;case"actions":this.observer.notify(cr,{subCommand:t,event:n,callBack:i});break;case"style":case"effects":case"casing":this.observer.notify(Sr,{subCommand:t,event:n,callBack:i});break;case"links":case"images":this.observer.notify(Nr,{subCommand:t,event:n,callBack:i,item:o});break;case"table":switch(t.toString().toLocaleLowerCase()){case"createtable":this.observer.notify(Tr,{subCommand:t,item:o,event:n,callBack:i})}break;case"clear":this.observer.notify(Er,{subCommand:t,event:n,callBack:i})}},e}(),Fr=function(){var e=function(t,n){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(t,n)};return function(t,n){function i(){this.constructor=t}e(t,n),t.prototype=null===n?Object.create(n):(i.prototype=n.prototype,new i)}}(),qr=function(e){function n(n){var i=e.call(this)||this;return i.initialize(),t.extend(i,i,n,!0),n&&i.element&&i.updateFormatter(i.element,document,n.options),i}return Fr(n,e),n.prototype.initialize=function(){this.keyConfig=Rr,this.formatTags=Or,this.listTags=Dr,this.selectionTags=xr},n.prototype.updateFormatter=function(e,t,n){e&&(this.editorManager=new jr({element:e,formatTags:this.formatTags,listTags:this.listTags,selectionTags:this.selectionTags,options:n}))},n}(yr),zr=function(){function e(e){this.parent=e}return e.prototype.renderPanel=function(){var e=this.parent,t=this.parent.createElement("div",{id:this.parent.getID()+"_view",className:"e-rte-content"});this.editableElement=this.parent.createElement("textarea",{className:"e-content",id:this.parent.getID()+"_editable-content"}),t.appendChild(this.editableElement),this.setPanel(t),e.element.appendChild(t)},e.prototype.getPanel=function(){return this.contentPanel},e.prototype.getEditPanel=function(){return this.editableElement},e.prototype.getText=function(){return this.getEditPanel().value},e.prototype.setPanel=function(e){this.contentPanel=e},e.prototype.getDocument=function(){return this.getEditPanel().ownerDocument},e}(),_r=function(){function n(e,t){this.parent=e,this.locator=t,this.renderFactory=this.locator.getService("rendererFactory"),this.addEventListener()}return n.prototype.destroy=function(){this.removeEventListener()},n.prototype.addEventListener=function(){this.parent.isDestroyed||(this.saveSelection=new sr,this.parent.on(A,this.instantiateRenderer,this),this.parent.on(H,this.render,this),this.parent.on(Y,this.onPropertyChanged,this),this.parent.on(G,this.onToolbarClick,this),this.parent.on(F,this.destroy,this),this.parent.on(_e,this.selectAll,this),this.parent.on(Ve,this.getSelectedHtml,this),this.parent.on(Me,this.onSelectionSave,this),this.parent.on(Re,this.onSelectionRestore,this),this.parent.on(Ze,this.updateReadOnly,this))},n.prototype.updateReadOnly=function(){this.parent.readonly?(this.parent.contentModule.getEditPanel().setAttribute("readonly","readonly"),t.addClass([this.parent.element],Un)):(this.parent.contentModule.getEditPanel().removeAttribute("readonly"),t.removeClass([this.parent.element],Un))},n.prototype.onSelectionSave=function(){var e=this.parent.contentModule.getEditPanel();this.saveSelection.save(e.selectionStart,e.selectionEnd)},n.prototype.onSelectionRestore=function(e){this.contentRenderer.getEditPanel().focus();var t=this.parent.contentModule.getEditPanel();this.saveSelection.restore(t)},n.prototype.onToolbarClick=function(e){var t=e.item,n=this.parent.contentModule.getEditPanel();n.focus();var i=n.selectionStart,r=n.selectionEnd,o=n.value.substring(i,r);switch(t.subCommand){case"Maximize":this.parent.notify(ne,{args:e});break;case"Minimize":this.parent.notify(ie,{args:e});break;case"CreateLink":this.parent.notify(ue,{member:"link",args:e,text:o,module:"Markdown"});break;case"Image":this.parent.notify(Se,{member:"image",args:e,text:o,module:"Markdown"});break;case"CreateTable":var s={headingText:this.parent.localeObj.getConstant("TableHeadingText"),colText:this.parent.localeObj.getConstant("TableColText")};this.parent.formatter.process(this.parent,e,e.originalEvent,s);break;default:this.parent.formatter.process(this.parent,e,e.originalEvent,null)}},n.prototype.instantiateRenderer=function(){this.renderFactory.addRenderer(e.RenderType.Content,new zr(this.parent))},n.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(H,this.render),this.parent.off(Y,this.onPropertyChanged),this.parent.off(F,this.destroy),this.parent.off(G,this.onToolbarClick),this.parent.off(A,this.instantiateRenderer),this.parent.off(_e,this.selectAll),this.parent.off(Ve,this.getSelectedHtml),this.parent.off(Me,this.onSelectionSave),this.parent.off(Re,this.onSelectionRestore),this.parent.off(Ze,this.updateReadOnly))},n.prototype.render=function(){this.contentRenderer=this.renderFactory.getRenderer(e.RenderType.Content);var n=this.contentRenderer.getEditPanel(),i={undoRedoSteps:this.parent.undoRedoSteps,undoRedoTimer:this.parent.undoRedoTimer};t.isNullOrUndefined(this.parent.formatter)?this.parent.formatter=new qr({element:n,options:i}):this.parent.formatter.updateFormatter(n,this.contentRenderer.getDocument(),i),this.parent.toolbarSettings.enable&&(this.toolbarUpdate=new lr(this.parent)),this.parent.notify(V,{})},n.prototype.onPropertyChanged=function(e){if(!t.isNullOrUndefined(e.newProp.formatter)){var n=this.contentRenderer.getEditPanel(),i={undoRedoSteps:this.parent.undoRedoSteps,undoRedoTimer:this.parent.undoRedoTimer};this.parent.formatter.updateFormatter(n,this.contentRenderer.getDocument(),i)}},n.prototype.getModuleName=function(){return"markdownEditor"},n.prototype.selectAll=function(){this.parent.formatter.editorManager.markdownSelection.setSelection(this.parent.contentModule.getEditPanel(),0,this.parent.contentModule.getEditPanel().value.length)},n.prototype.getSelectedHtml=function(e){e.callBack(this.parent.formatter.editorManager.markdownSelection.getSelectedText(this.parent.contentModule.getEditPanel()))},n}(),Qr="INSERT-IMAGE",Vr="INSERT-TABLE",Wr="INSERT-LINK",Kr="INSERT-ROW",Gr="INSERT-COLUMN",Xr="DELETE-ROW",Yr="DELETE-COLUMN",Jr="REMOVE-TABLE",$r="TABLE-HEADER",Zr="TABLE_VERTICAL_ALIGN",eo="TABLE_MERGE",to="TABLE_VERTICAL_SPLIT",no="TABLE_HORIZONTAL_SPLIT",io="alignment-type",ro="indent-type",oo=["address","article","aside","audio","blockquote","canvas","details","dd","div","dl","dt","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","header","hgroup","hr","li","main","nav","noscript","ol","output","p","pre","section","table","tbody","td","tfoot","th","thead","tr","ul","video","body"],so=["td","th"],ao=["table","tbody","td","tfoot","th","thead","tr"],lo="selection-type",co="inserthtml-type",po="insert-text-type",ho="clear-type",uo=function(){function e(){this.startNodeName=[],this.endNodeName=[]}return e.prototype.saveInstance=function(e,t){return this.range=e.cloneRange(),this.rootNode=this.documentFromRange(e),this.body=t,this.startContainer=this.getNodeArray(e.startContainer,!0),this.endContainer=this.getNodeArray(e.endContainer,!1),this.startOffset=e.startOffset,this.endOffset=e.endOffset,this.html=this.body.innerHTML,this},e.prototype.documentFromRange=function(e){return 9===e.startContainer.nodeType?e.startContainer:e.startContainer.ownerDocument},e.prototype.getRange=function(e){var t=this.get(e),n=t&&t.rangeCount>0?t.getRangeAt(t.rangeCount-1):e.createRange();return n.startContainer!==e||n.endContainer!==e||n.startOffset||n.endOffset||(n.setStart(e.body,0),n.collapse(!0)),n},e.prototype.get=function(e){return e.defaultView.getSelection()},e.prototype.save=function(e,t){return e=e?e.cloneRange():this.getRange(t),this.saveInstance(e,t.body)},e.prototype.getIndex=function(e){var t=0;if(e=e.previousSibling||"BR"!==e.tagName?e.previousSibling:e)for(e.nodeType;e;null)t++,e.nodeType,e=e.previousSibling;return t},e.prototype.isChildNode=function(e,t){for(var n=0;n<t.childNodes.length;n++)if(e.indexOf(t.childNodes[n])>-1)return!0;return!1},e.prototype.getNode=function(e,t,n){return t!==e||3!==e.nodeType&&e.firstChild&&-1===n.indexOf(e.firstChild)&&!this.isChildNode(n,e)?-1===n.indexOf(e.firstChild)&&e.firstChild&&!this.isChildNode(n,e)?e.firstChild:e.nextSibling?e.nextSibling:e.parentNode?e.parentNode:null:null},e.prototype.getNodeCollection=function(e){var t=e.startContainer.childNodes[e.startOffset]||e.startContainer,n=e.endContainer.childNodes[e.endOffset>0?e.endOffset-1:e.endOffset]||e.endContainer;if((t===n||"BR"===t.nodeName&&t===e.endContainer.childNodes[e.endOffset])&&0===t.childNodes.length)return[t];if(e.startOffset===e.endOffset&&0!==e.startOffset&&"PRE"===e.startContainer.nodeName)return["BR"===t.nodeName||"#text"===t.nodeName?t:t.childNodes[0]];var i=[];do{-1===i.indexOf(t)&&i.push(t),t=this.getNode(t,n,i)}while(t);return i},e.prototype.getParentNodeCollection=function(e){return this.getParentNodes(this.getNodeCollection(e),e)},e.prototype.getParentNodes=function(e,t){e=e.reverse();for(var n=0;n<e.length;n++)-1!==e.indexOf(e[n].parentNode)||3===e[n].nodeType&&t.startContainer!==t.endContainer&&t.startContainer.parentNode!==t.endContainer.parentNode?(e.splice(n,1),n--):3===e[n].nodeType&&(e[n]=e[n].parentNode);return e},e.prototype.getSelectionNodeCollection=function(e){return this.getSelectionNodes(this.getNodeCollection(e))},e.prototype.getSelectionNodeCollectionBr=function(e){return this.getSelectionNodesBr(this.getNodeCollection(e))},e.prototype.getSelectionNodes=function(e){e=e.reverse();for(var t=new RegExp(String.fromCharCode(8203),"g"),n=0;n<e.length;n++)(3!==e[n].nodeType||""===e[n].textContent.trim()||1===e[n].textContent.length&&e[n].textContent.match(t))&&(e.splice(n,1),n--);return e.reverse()},e.prototype.getSelectionNodesBr=function(e){e=e.reverse();for(var t=new RegExp(String.fromCharCode(8203),"g"),n=0;n<e.length;n++)"BR"!==e[n].nodeName&&(3!==e[n].nodeType||""===e[n].textContent.trim()||1===e[n].textContent.length&&e[n].textContent.match(t))&&(e.splice(n,1),n--);return e.reverse()},e.prototype.getInsertNodeCollection=function(e){return this.getInsertNodes(this.getNodeCollection(e))},e.prototype.getInsertNodes=function(e){e=e.reverse();for(var t=0;t<e.length;t++)(0!==e[t].childNodes.length&&3!==e[t].nodeType||3===e[t].nodeType&&""===e[t].textContent)&&(e.splice(t,1),t--);return e.reverse()},e.prototype.getNodeArray=function(e,n,i){var r=[];for(n?this.startNodeName=[]:this.endNodeName=[];e!==(i||this.rootNode)&&!t.isNullOrUndefined(e);null)n?this.startNodeName.push(e.nodeName.toLowerCase()):this.endNodeName.push(e.nodeName.toLowerCase()),r.push(this.getIndex(e)),e=e.parentNode;return r},e.prototype.setRangePoint=function(e,t,n,i){for(var r=this.rootNode,o=n.length,s=i;o--;null)r=r&&r.childNodes[n[o]];return r&&s>=0&&"html"!==r.nodeName&&e[t?"setStart":"setEnd"](r,s),e},e.prototype.restore=function(){var e=this.range.cloneRange();return e=this.setRangePoint(e,!0,this.startContainer,this.startOffset),e=this.setRangePoint(e,!1,this.endContainer,this.endOffset),this.selectRange(this.rootNode,e),e},e.prototype.selectRange=function(e,t){this.setRange(e,t),this.save(t,e)},e.prototype.setRange=function(e,t){var n=this.get(e);n.removeAllRanges(),n.addRange(t)},e.prototype.setSelectionText=function(e,t,n,i,r){var o=e.createRange();o.setStart(t,i),o.setEnd(n,r),this.setRange(e,o)},e.prototype.setSelectionContents=function(e,t){var n=e.createRange();n.selectNode(t),this.setRange(e,n)},e.prototype.setSelectionNode=function(e,t){var n=e.createRange();n.selectNodeContents(t),this.setRange(e,n)},e.prototype.getSelectedNodes=function(e){return this.getNodeCollection(this.getRange(e))},e.prototype.Clear=function(e){this.get(e).removeAllRanges()},e.prototype.insertParentNode=function(e,t,n){n.surroundContents(t),this.selectRange(e,n)},e.prototype.setCursorPoint=function(e,t,n){var i=e.createRange(),r=e.defaultView.getSelection();i.setStart(t,n),i.collapse(!0),r.removeAllRanges(),r.addRange(i)},e}(),mo={startSelection:"e-editor-select-start",endSelection:"e-editor-select-end"},go=function(){function e(e,t){this.parent=e,this.nodeSelection=new uo,this.currentDocument=t}return e.prototype.contents=function(e){return e&&"IFRAME"!==e.tagName?Array.prototype.slice.call(e.childNodes||[]):[]},e.prototype.isBlockNode=function(e){return!!e&&e.nodeType===Node.ELEMENT_NODE&&oo.indexOf(e.tagName.toLowerCase())>=0},e.prototype.isLink=function(e){return!!e&&e.nodeType===Node.ELEMENT_NODE&&"a"===e.tagName.toLowerCase()},e.prototype.blockParentNode=function(e){for(;e&&e.parentNode!==this.parent&&(!e.parentNode||!this.hasClass(e.parentNode,"e-node-inner"));null)if(e=e.parentNode,this.isBlockNode(e))return e;return e},e.prototype.rawAttributes=function(e){var t={},n=e.attributes;if(n.length>0)for(var i=0;i<n.length;i++){var r=n[i];t[r.nodeName]=r.value}return t},e.prototype.attributes=function(e){if(!e)return"";for(var t="",n=this.rawAttributes(e),i=Object.keys(n).sort(),r=0;r<i.length;r++){var o=i[r],s=n[o];s.indexOf("'")<0&&s.indexOf('"')>=0?t+=" "+o+"='"+s+"'":s.indexOf('"')>=0&&s.indexOf("'")>=0?t+=" "+o+'="'+(s=s.replace(/"/g,"&quot;"))+'"':t+=" "+o+'="'+s+'"'}return t},e.prototype.clearAttributes=function(e){for(var t=e.attributes,n=t.length-1;n>=0;n--){var i=t[n];e.removeAttribute(i.nodeName)}},e.prototype.openTagString=function(e){return"<"+e.tagName.toLowerCase()+this.attributes(e)+">"},e.prototype.closeTagString=function(e){return"</"+e.tagName.toLowerCase()+">"},e.prototype.createTagString=function(e,t,n){return"<"+e.toLowerCase()+this.attributes(t)+">"+n+"</"+e.toLowerCase()+">"},e.prototype.isList=function(e){return!!e&&["UL","OL"].indexOf(e.tagName)>=0},e.prototype.isElement=function(e){return e===this.parent},e.prototype.isEditable=function(e){return(!e.getAttribute||"true"===e.getAttribute("contenteditable"))&&["STYLE","SCRIPT"].indexOf(e.tagName)<0},e.prototype.hasClass=function(e,t){return e&&e.classList&&e.classList.contains(t)},e.prototype.replaceWith=function(e,n){e.parentNode.insertBefore(this.parseHTMLFragment(n),e),t.detach(e)},e.prototype.parseHTMLFragment=function(e){var n=t.createElement("template");return n.innerHTML=e,n.content instanceof DocumentFragment?n.content:document.createRange().createContextualFragment(e)},e.prototype.wrap=function(e,t){return e.parentNode.insertBefore(t,e),(t=e.previousSibling).appendChild(e),t},e.prototype.insertAfter=function(e,t){t.parentNode.insertBefore(e,t.nextSibling)},e.prototype.wrapInner=function(e,t){for(e.appendChild(t),(t=e.querySelector(".e-rte-wrap-inner")).classList.remove("e-rte-wrap-inner"),0===t.classList.length&&t.removeAttribute("class");e.firstChild!==t;)t.appendChild(e.firstChild);return t},e.prototype.unWrap=function(e){for(var t=e.parentNode,n=[];e.firstChild;)n.push(e.firstChild),t.insertBefore(e.firstChild,e);return n=n.length>0?n:[e.parentNode],t.removeChild(e),n},e.prototype.getSelectedNode=function(e,t){return e.nodeType===Node.ELEMENT_NODE&&e.childNodes.length>0&&e.childNodes[t-1]&&e.childNodes[t-1].nodeType===Node.ELEMENT_NODE&&(e.childNodes[t-1].classList.contains(mo.startSelection)||e.childNodes[t-1].classList.contains(mo.endSelection))?e=e.childNodes[t-1]:e.nodeType===Node.ELEMENT_NODE&&e.childNodes.length>0&&e.childNodes[t]&&(e=e.childNodes[t]),e.nodeType===Node.TEXT_NODE&&(e=e.parentNode),e},e.prototype.nodeFinds=function(e,t){for(var n=[],i=0;i<t.length;i++)e.contains(t[i])&&e!==t[i]&&n.push(t[i]);return n},e.prototype.isEditorArea=function(){var e;for(e=this.getRangePoint(0).commonAncestorContainer;e&&!this.isElement(e);null)e=e.parentNode;return!!this.isElement(e)},e.prototype.getRangePoint=function(e){var t=this.getSelection(),n=[];if(t&&t.getRangeAt&&t.rangeCount){n=[];for(var i=0;i<t.rangeCount;i++)n.push(t.getRangeAt(i))}else n=[this.currentDocument.createRange()];return void 0!==e?n[e]:n},e.prototype.getSelection=function(){return this.nodeSelection.get(this.currentDocument)},e.prototype.getPreviousNode=function(e){for(e=e.previousElementSibling;e&&"\n"===e.textContent;null)e=e.previousElementSibling;return e},e.prototype.encode=function(e){var t=document.createElement("div");return t.innerText=e,t.innerHTML.replace(/<br\s*[\/]?>/gi,"\n")},e.prototype.saveMarker=function(e,n){var i,r,o=this.parent.querySelector("."+mo.startSelection),s=this.parent.querySelector("."+mo.endSelection);if(""===o.textContent&&t.isNullOrUndefined(s)&&"tab"!==n&&(1===o.childNodes.length&&"BR"===o.childNodes[0].nodeName?o.innerHTML="&#65279;&#65279;<br>":o.innerHTML="&#65279;&#65279;"),this.hasClass(o,mo.startSelection)&&o.classList.length>1){var a=this.createTagString("p",o,this.encode(o.textContent));this.replaceWith(o,a),(o=this.parent.querySelector("."+mo.startSelection)).classList.remove(mo.startSelection),i=o.childNodes[0]}else i=this.unWrap(o)[0];if(this.hasClass(s,mo.endSelection)&&s.classList.length>1){a=this.createTagString("p",s,this.encode(s.textContent));this.replaceWith(s,a),(s=this.parent.querySelector("."+mo.endSelection)).classList.remove(mo.endSelection),r=s.childNodes[0]}else r=s?this.unWrap(s)[0]:i;return e.startContainer=e.getNodeArray(i,!0),e.endContainer=e.getNodeArray(r,!1),e},e.prototype.marker=function(e,t){return'<span class="'+e+'">'+t+"</span>"},e.prototype.setMarker=function(e){var t=e.range,n=t.startContainer.childNodes,i=(n.length>1&&"TABLE"===n[0].nodeName?function(e){var t=e;do{t.childNodes.length>0&&(t=t.childNodes[0])}while(t.childNodes.length>0);return t}(n[t.startOffset+1]):n[t.startOffset>0?t.startOffset-1:t.startOffset])||t.startContainer,r=t.endContainer.childNodes[t.endOffset>0?t.endOffset-1:t.endOffset]||t.endContainer;if(i.nodeType===Node.ELEMENT_NODE&&r.nodeType===Node.ELEMENT_NODE&&(i.contains(r)||r.contains(i))){var o=i.contains(r)?i:r;if(o.nodeType!==Node.TEXT_NODE){for(var s=[],a=[],l=o;o.contains(l);null)s.indexOf(l)<0&&l.childNodes&&l.childNodes.length?(s.push(l),l=l.childNodes[0]):l.nextSibling?l=l.nextSibling:l.parentNode&&(l=l.parentNode,s.push(l)),a.indexOf(l)<0&&(l.nodeType===Node.TEXT_NODE||so.indexOf(l.parentNode.tagName.toLocaleLowerCase())>=0&&("BR"===l.tagName||"IMG"===l.tagName))&&a.push(l);a.length&&(i=i.contains(r)?a[0]:i,r=a[a.length-1])}}if(i!==r){if(i.nodeType!==Node.TEXT_NODE&&("BR"===i.tagName&&so.indexOf(i.parentNode.tagName.toLocaleLowerCase())>=0||"IMG"===i.tagName)){this.replaceWith(i,this.marker(mo.startSelection,this.encode(i.textContent)));t.startContainer.querySelector("."+mo.startSelection).appendChild(i)}else this.replaceWith(i,this.marker(mo.startSelection,this.encode(i.textContent)));if(r.nodeType!==Node.TEXT_NODE&&"BR"===r.tagName&&so.indexOf(r.parentNode.tagName.toLocaleLowerCase())>=0){this.replaceWith(r,this.marker(mo.endSelection,this.encode(r.textContent)));t.endContainer.querySelector("."+mo.endSelection).appendChild(r)}else this.ensureSelfClosingTag(r,mo.endSelection,t)}else this.ensureSelfClosingTag(i,mo.startSelection,t)},e.prototype.ensureSelfClosingTag=function(e,n,i){var r=!1;if(3===e.nodeType)this.replaceWith(e,this.marker(n,this.encode(e.textContent)));else if("BR"===e.tagName){this.replaceWith(e,this.marker(n,this.encode(e.textContent)));i.startContainer.querySelector("."+n).appendChild(e)}else{if("IMG"===e.tagName){var o=document.createElement("p");e.parentElement.insertBefore(o,e),o.appendChild(e),e=o.children[0]}if("TABLE"===e.tagName)if(r=!0,""===e.textContent){var s=e.querySelectorAll("td");e=s[s.length-1],e=t.isNullOrUndefined(e.childNodes[0])?e:e.childNodes[0]}else{for(var a=e.lastChild;3!==a.nodeType&&"#text"!==a.nodeName&&"BR"!==a.nodeName;)a=a.lastChild;e=a}for(var l=0;l<Br.length;l++)e=e.tagName!==Br[l]||r?e:e.parentNode;if(3===e.nodeType&&"#text"===e.nodeName)this.replaceWith(e,this.marker(n,this.encode(e.textContent)));else if("BR"===e.nodeName){this.replaceWith(e,this.marker(mo.endSelection,this.encode(e.textContent)));i.endContainer.querySelector("."+mo.endSelection).appendChild(e)}else{var d=this.marker(n,"");t.append([this.parseHTMLFragment(d)],e)}}},e.prototype.createTempNode=function(e){var t=e.textContent;if("BR"===e.tagName){var n="<p></p>",i=e.parentNode;so.indexOf(i.tagName.toLocaleLowerCase())>=0&&(e=this.wrap(e,this.parseHTMLFragment(n)))}else if(e.nodeType!==Node.TEXT_NODE&&(e.classList.contains(mo.startSelection)||e.classList.contains(mo.endSelection))||t.replace(/\n/g,"").replace(/(^ *)|( *$)/g,"").length>0||t.length&&t.indexOf("\n")<0){n="<p></p>";var r=e;e=this.wrap(e,this.parseHTMLFragment(n));!(r.nodeType===Node.ELEMENT_NODE&&r.firstChild&&"BR"===r.firstChild.nodeName&&(r.classList.contains(mo.startSelection)||r.classList.contains(mo.endSelection)))&&e.nextElementSibling&&"BR"===e.nextElementSibling.tagName&&e.appendChild(e.nextElementSibling)}return e},e.prototype.getImageTagInSelection=function(){var e=this.getSelection();return this.isEditorArea()&&e.rangeCount?e.focusNode.querySelectorAll("img"):null},e.prototype.blockNodes=function(){var e=[],n=this.getSelection();if(this.isEditorArea()&&n.rangeCount)for(var i=this.getRangePoint(),r=0;r<i.length;r++){var o=void 0,s=i[r],a=this.getSelectedNode(s.startContainer,s.startOffset),l=this.getSelectedNode(s.endContainer,s.endOffset);if(this.isBlockNode(a)&&e.indexOf(a)<0&&e.push(a),(o=this.blockParentNode(a))&&e.indexOf(o)<0)if(so.indexOf(o.tagName.toLocaleLowerCase())>=0&&("BR"===a.tagName||a.nodeType===Node.TEXT_NODE||a.classList.contains(mo.startSelection)||a.classList.contains(mo.endSelection))){var d=a.previousSibling&&a.previousSibling.nodeType===Node.TEXT_NODE?a.previousSibling:a;a.nextSibling||a.previousSibling||"BR"!==a.tagName?e.push(this.createTempNode(d)):e.push(d)}else e.push(o);for(var c=[],p=a;p!==l&&p!==this.parent;null)c.indexOf(p)<0&&p.childNodes&&p.childNodes.length?(c.push(p),p=p.childNodes[0]):p&&8!==p.nodeType&&("BR"===p.tagName||p.nodeType===Node.TEXT_NODE&&""!==p.textContent.trim()||p.nodeType!==Node.TEXT_NODE&&(p.classList.contains(mo.startSelection)||p.classList.contains(mo.endSelection)))&&so.indexOf(p.parentNode.tagName.toLocaleLowerCase())>=0?p=this.createTempNode(p):p.nextSibling&&8!==p.nextSibling.nodeType&&("BR"===p.nextSibling.tagName||p.nextSibling.nodeType===Node.TEXT_NODE||p.nextSibling.classList.contains(mo.startSelection)||p.nextSibling.classList.contains(mo.endSelection))&&so.indexOf(p.nextSibling.parentNode.tagName.toLocaleLowerCase())>=0?p=this.createTempNode(p.nextSibling):p.nextSibling?p=p.nextSibling:p.parentNode&&(p=p.parentNode,c.push(p)),e.indexOf(p)<0&&p.nodeType===Node.ELEMENT_NODE&&so.indexOf(p.parentNode.tagName.toLocaleLowerCase())>=0&&(p.classList.contains(mo.startSelection)||p.classList.contains(mo.endSelection))&&e.push(this.createTempNode(p)),this.isBlockNode(p)&&this.ignoreTableTag(p)&&c.indexOf(p)<0&&e.indexOf(p)<0&&(p!==l||s.endOffset>0)&&e.push(p),"IMG"===p.nodeName&&"true"===p.parentElement.contentEditable&&e.push(p);(o=this.blockParentNode(l))&&this.ignoreTableTag(o)&&e.indexOf(o)<0&&!t.isNullOrUndefined(o.previousElementSibling)&&"IMG"!==o.previousElementSibling.tagName&&e.push(o)}for(var h=e.length-1;h>0;h--){if((c=this.nodeFinds(e[h],e)).length){var u=e[h].querySelectorAll("ul, ol");if("LI"===e[h].tagName&&u.length>0)continue;e.splice(h,1)}}return e},e.prototype.ignoreTableTag=function(e){return!(ao.indexOf(e.tagName.toLocaleLowerCase())>=0)},e}(),fo=function(){function e(e){this.parent=e,this.domNode=this.parent.domNode,this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.observer.on("list-type",this.applyListsHandler,this),this.parent.observer.on(hr,this.keyDownHandler,this),this.parent.observer.on(vr,this.spaceKeyAction,this)},e.prototype.testList=function(e){var n=[/^[\d]+[.]+$/,/^(?=[MDCLXVI])M*(C[MD]|D?C{0,3})(X[CL]|L?X{0,3})(I[XV]|V?I{0,3})[.]$/gi,/^[a-zA-Z][.]+$/],i=t.isNullOrUndefined(e)?null:e.innerText.trim().split(".")[0]+".";if(!t.isNullOrUndefined(i))for(var r=0;r<n.length;r++)if(n[r].test(i))return!0;return!1},e.prototype.testCurrentList=function(e){var n=[/^[1]+[.]+$/,/^[i]+[.]+$/,/^[a]+[.]+$/];if(!t.isNullOrUndefined(e.startContainer.textContent.slice(0,e.startOffset)))for(var i=e.startContainer.textContent.replace(/\u200B/g,"").slice(0,e.startOffset).trim(),r=0;r<n.length;r++)if(n[r].test(i)&&2===i.length)return!0;return!1},e.prototype.spaceList=function(e){var n=this.parent.nodeSelection.getRange(this.parent.currentDocument);this.saveSelection=this.parent.nodeSelection.save(n,this.parent.currentDocument);var i=this.parent.domNode.getSelectedNode(n.startContainer,n.startOffset),r=(this.parent.domNode.getSelectedNode(n.endContainer,n.endOffset),i.previousElementSibling),o=i.nextElementSibling,s=t.isNullOrUndefined(r)?null:r.innerText.trim().substring(0,1),a=t.isNullOrUndefined(o)?null:o.innerText.trim().substring(0,1),l=this.testCurrentList(n),d=this.testList(r),c=this.testList(o);d||c||"*"===s||"*"===a||(l?(n.startContainer.textContent=n.startContainer.textContent.slice(n.startOffset,n.startContainer.textContent.length),this.applyListsHandler({subCommand:"OL",callBack:e.callBack}),e.event.preventDefault()):"*"!==n.startContainer.textContent.replace(/\u200B/g,"").slice(0,n.startOffset).trim()&&"-"!==n.startContainer.textContent.replace(/\u200B/g,"").slice(0,n.startOffset).trim()||(n.startContainer.textContent=n.startContainer.textContent.slice(n.startOffset,n.startContainer.textContent.length),this.applyListsHandler({subCommand:"UL",callBack:e.callBack}),e.event.preventDefault()))},e.prototype.enterList=function(e){var n=this.parent.nodeSelection.getRange(this.parent.currentDocument),i="LI"===n.startContainer.nodeName?n.startContainer:n.startContainer.parentElement.closest("LI"),r="LI"===n.endContainer.nodeName?n.endContainer:n.endContainer.parentElement.closest("LI");if(!t.isNullOrUndefined(i)&&!t.isNullOrUndefined(r)&&i===r&&"LI"===i.tagName&&""===i.textContent.trim()&&0===i.querySelectorAll("IMG").length){65279===i.textContent.charCodeAt(0)&&(i.textContent="");var o=i.parentElement;if(t.isNullOrUndefined(o.parentElement.closest("UL"))&&t.isNullOrUndefined(o.parentElement.closest("OL"))){if(!t.isNullOrUndefined(i.nextElementSibling)){var s=this.parent.domNode.blockParentNode(i);this.parent.nodeCutter.GetSpliceNode(n,s)}var a=void 0;"DIV"===e.enterAction?(a=t.createElement("div")).innerHTML="<br>":"P"===e.enterAction?(a=t.createElement("p")).innerHTML="<br>":a=t.createElement("br"),this.parent.domNode.insertAfter(a,o),e.event.preventDefault(),this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument,a,0),""===o.textContent?t.detach(o):t.detach(i)}}},e.prototype.backspaceList=function(e){var n=this.parent.nodeSelection.getRange(this.parent.currentDocument),i=this.parent.domNode.getSelectedNode(n.startContainer,n.startOffset),r=this.parent.domNode.getSelectedNode(n.endContainer,n.endOffset);if(i="BR"===i.nodeName?i.parentElement:i,r="BR"===r.nodeName?r.parentElement:r,i===r&&!t.isNullOrUndefined(t.closest(i,"li"))&&(""===i.textContent.trim()&&65279===i.textContent.charCodeAt(0)||1===i.textContent.length&&8203===i.textContent.charCodeAt(0))&&(i.textContent=""),i===r&&""===i.textContent){if("LI"===i.parentElement.tagName&&"LI"===r.parentElement.tagName)t.detach(i);else if(i.closest("ul")||i.closest("ol")){if((o=t.isNullOrUndefined(i.closest("ul"))?i.closest("ol"):i.closest("ul")).firstElementChild===i&&!t.isNullOrUndefined(o.children[1])&&("OL"===o.children[1].tagName||"UL"===o.children[1].tagName))if(o.tagName===o.children[1].tagName){for(;o.children[1].lastChild;)this.parent.domNode.insertAfter(o.children[1].lastChild,o.children[1]);t.detach(o.children[1])}else o.parentElement.insertBefore(o.children[1],o)}}else if(!(t.isNullOrUndefined(i.firstChild)||"BR"!==i.firstChild.nodeName||t.isNullOrUndefined(i.childNodes[1])||"UL"!==i.childNodes[1].nodeName&&"OL"!==i.childNodes[1].nodeName)){var o;if((o=t.isNullOrUndefined(i.closest("ul"))?i.closest("ol"):i.closest("ul")).tagName===i.childNodes[1].nodeName){for(;i.childNodes[1].lastChild;)this.parent.domNode.insertAfter(i.children[1].lastChild,i);t.detach(i.childNodes[1])}else o.parentElement.insertBefore(i.children[1],o)}},e.prototype.keyDownHandler=function(e){if(13===e.event.which&&this.enterList(e),32===e.event.which&&this.spaceList(e),8===e.event.which&&this.backspaceList(e),46===e.event.which&&"delete"===e.event.action){var n=(a=this.parent.nodeSelection.getRange(this.parent.currentDocument)).commonAncestorContainer,i=a.startContainer,r=a.endContainer,o=3===i.nodeType?i.parentElement:i,s=3===r.nodeType?r.parentElement:r;"UL"!==n.nodeName&&"OL"!==n.nodeName||o===s||t.isNullOrUndefined(t.closest(o,"ul"))&&t.isNullOrUndefined(t.closest(o,"ol"))||t.isNullOrUndefined(t.closest(s,"ul"))&&t.isNullOrUndefined(t.closest(s,"ol"))||n.lastElementChild!==t.closest(s,"li")||a.collapsed||t.detach(n)}if(9===e.event.which){var a=this.parent.nodeSelection.getRange(this.parent.currentDocument);e.event.action&&"indent"===e.event.action||(this.saveSelection=this.parent.nodeSelection.save(a,this.parent.currentDocument));var l=void 0,d=a.startOffset,c=a.endOffset;if((o=this.parent.domNode.getSelectedNode(a.startContainer,a.startOffset))===(s=this.parent.domNode.getSelectedNode(a.endContainer,a.endOffset))&&("BR"===o.nodeName||"#text"===o.nodeName)&&so.indexOf(o.parentNode.tagName.toLocaleLowerCase())>=0)return;e.event.action&&"indent"===e.event.action||this.domNode.setMarker(this.saveSelection),l=this.domNode.blockNodes();for(var p=[],h=!0,u=0;u<l.length;u++)"LI"===l[u].parentNode.tagName?p.push(l[u].parentNode):"LI"===l[u].tagName&&"P"!==l[u].childNodes[0].tagName&&"OL"!==l[u].childNodes[0].tagName&&"UL"!==l[u].childNodes[0].tagName&&p.push(l[u]);p.length>1||p.length&&(0===d&&0===c||e.ignoreDefault)?(e.event.preventDefault(),e.event.stopPropagation(),this.currentAction=this.getAction(p[0]),e.event.shiftKey?(this.revertList(p),this.revertClean()):h=this.nestedList(p),h&&(this.cleanNode(),this.parent.editableElement.focus()),e.event.action&&"indent"===e.event.action||(this.saveSelection=this.domNode.saveMarker(this.saveSelection),this.saveSelection.restore(),e.callBack&&e.callBack({requestType:this.currentAction,editorMode:"HTML",range:this.parent.nodeSelection.getRange(this.parent.currentDocument),elements:this.parent.domNode.blockNodes(),event:e.event}))):e.event.action&&"indent"===e.event.action||(e.event&&e.event.shiftKey&&"Tab"===e.event.key&&(e.event.action="tab"),this.saveSelection=this.domNode.saveMarker(this.saveSelection,e.event.action),this.saveSelection.restore())}else switch(e.event.action){case"ordered-list":this.applyListsHandler({subCommand:"OL",callBack:e.callBack}),e.event.preventDefault();break;case"unordered-list":this.applyListsHandler({subCommand:"UL",callBack:e.callBack}),e.event.preventDefault()}},e.prototype.spaceKeyAction=function(e){32===e.event.which&&this.spaceList(e)},e.prototype.getAction=function(e){return"OL"===e.parentNode.nodeName?"OL":"UL"},e.prototype.revertClean=function(){for(var e=this.parent.editableElement.querySelectorAll("ul, ol"),t=0;t<e.length;t++){var n=e[t].querySelectorAll("ul, ol");if(n.length>0)for(var i=0;i<n.length;i++){var r=n[i].previousSibling;r&&"LI"===r.tagName&&r.appendChild(n[i])}}},e.prototype.noPreviousElement=function(e){var n,i,r=e.querySelectorAll("ol, ul"),o=e.querySelectorAll("li"),s=this.domNode.contents(o[0])[0];if(o.length>0&&("OL"===s.nodeName||"UL"===s.nodeName)?n=o[0]:i=r[0],n)for(var a=this.domNode.contents(e)[0];a&&!this.domNode.isList(a);null){var l=a.nextSibling;t.prepend([a],n),t.setStyleAttribute(e,{"list-style-type":"none"}),t.setStyleAttribute(n,{"list-style-type":""}),a=l}else if(i){var d=t.createElement("li");t.prepend([d],i);for(a=this.domNode.contents(e)[0];a&&!this.domNode.isList(a);null){l=a.nextSibling;d.appendChild(a),a=l}t.prepend([i],e.parentNode),t.detach(e);var c=t.createElement("li",{styles:"list-style-type: none;"});t.prepend([c],i.parentNode),t.append([i],c)}else{c=t.createElement("li",{styles:"list-style-type: none;"});t.prepend([c],e.parentNode);d=t.createElement(e.parentNode.tagName);t.prepend([d],c),t.append([e],d)}},e.prototype.nestedList=function(e){for(var n=!1,i=0;i<e.length;i++){var r=this.domNode.getPreviousNode(e[i]);if(r){n=!0;var o=void 0,s=void 0,a=e[i].querySelectorAll("ol, ul"),l=e[i].querySelectorAll("li"),d=this.domNode.contents(l[0])[0];if(l.length>0&&("OL"===d.nodeName||"UL"===d.nodeName)?s=l[0]:o=a[0],o){var c=t.createElement("li");t.prepend([c],o);for(var p=this.domNode.contents(e[i])[0];p&&!this.domNode.isList(p);null){var h=p.nextSibling;c.appendChild(p),p=h}t.append([o],r),t.detach(e[i])}else if(s){if("LI"===r.tagName){for(p=this.domNode.contents(e[i])[0];p&&!this.domNode.isList(p);null){h=p.nextSibling;t.prepend([p],s),t.setStyleAttribute(e[i],{"list-style-type":"none"}),t.setStyleAttribute(s,{"list-style-type":""}),p=h}t.append([s.parentNode],r),t.detach(e[i])}}else if("LI"===r.tagName){c=t.createElement(e[i].parentNode.tagName);t.append([c],r),t.append([e[i]],c)}}else{var u=e[i];n=!0,this.noPreviousElement(u)}}return n},e.prototype.applyListsHandler=function(e){var n=this.parent.nodeSelection.getRange(this.parent.currentDocument);if(n.startContainer===n.endContainer&&n.startContainer===this.parent.editableElement&&n.startOffset===n.endOffset&&0===n.startOffset&&0===this.parent.editableElement.textContent.length&&"TABLE"!=this.parent.editableElement.childNodes[0].nodeName&&"IMG"!=this.parent.editableElement.childNodes[0].nodeName){var i=n.startContainer.childNodes[0];this.parent.nodeSelection.setSelectionText(this.parent.currentDocument,i,i,0,0),n=this.parent.nodeSelection.getRange(this.parent.currentDocument)}this.saveSelection=this.parent.nodeSelection.save(n,this.parent.currentDocument),this.currentAction=e.subCommand,this.currentAction=e.subCommand="NumberFormatList"===this.currentAction?"OL":"BulletFormatList"===this.currentAction?"UL":this.currentAction,this.domNode.setMarker(this.saveSelection);var r=this.domNode.blockNodes();if("BR"===e.enterAction){this.setSelectionBRConfig();var o=this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument),s=this.parent.nodeSelection.getSelectionNodes(o),a=[];0===s.length&&s.push(r[0]);for(var l=0;l<s.length;l++){for(var d=s[l],c=void 0;!this.parent.domNode.isBlockNode(d)&&d!==this.parent.editableElement;)c=d,d=d.parentElement;this.parent.domNode.isBlockNode(d)&&d===this.parent.editableElement&&a.push(c)}for(l=0;l<a.length;l++)if(!this.parent.domNode.isBlockNode(a[l])){for(var p=d=a[l];d===this.parent.editableElement;)p=d,d=d.parentElement;var h=void 0;this.parent.domNode.isBlockNode(p.parentElement)&&p.parentElement===this.parent.editableElement?(h=t.createElement("p"),p.parentElement.insertBefore(h,p),h.appendChild(p)):h=p;for(var u=h.previousSibling;!t.isNullOrUndefined(u)&&"BR"!==u.nodeName&&!this.parent.domNode.isBlockNode(u);)h.firstChild.parentElement.insertBefore(u,h.firstChild),u=h.previousSibling;t.isNullOrUndefined(u)||"BR"!==u.nodeName||t.detach(u);for(var m=h.nextSibling;!t.isNullOrUndefined(m)&&"BR"!==m.nodeName&&!this.parent.domNode.isBlockNode(m);)h.appendChild(m),m=h.nextSibling;t.isNullOrUndefined(m)||"BR"!==m.nodeName||t.detach(m)}this.setSelectionBRConfig(),r=this.parent.domNode.blockNodes()}for(l=0;l<r.length;l++)"TABLE"!==r[l].tagName||n.collapsed||r.splice(l,1),r.length>0&&"LI"!==r[l].tagName&&"LI"===r[l].parentNode.tagName&&(r[l]=r[l].parentNode);this.applyLists(r,this.currentAction,e.selector,e.item),e.callBack&&e.callBack({requestType:this.currentAction,event:e.event,editorMode:"HTML",range:this.parent.nodeSelection.getRange(this.parent.currentDocument),elements:this.parent.domNode.blockNodes()})},e.prototype.setSelectionBRConfig=function(){var e=this.parent.editableElement.querySelector("."+mo.startSelection),n=this.parent.editableElement.querySelector("."+mo.endSelection);t.isNullOrUndefined(n)?this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument,e,0):this.parent.nodeSelection.setSelectionText(this.parent.currentDocument,e,n,0,0)},e.prototype.applyLists=function(e,n,i,r){if(this.isRevert(e,n)&&t.isNullOrUndefined(r))this.revertList(e),this.removeEmptyListElements();else{this.checkLists(e,n,r);for(var o=0;o<e.length;o++)if(t.isNullOrUndefined(r)||t.isNullOrUndefined(r.listStyle)||("listImage"===r.listStyle?t.setStyleAttribute(e[o],{"list-style-image":r.listImage}):(t.setStyleAttribute(e[o],{"list-style-image":"none"}),t.setStyleAttribute(e[o],{"list-style-type":r.listStyle.replace(/([a-z])([A-Z])/g,"$1-$2").toLowerCase()}))),"true"===e[o].getAttribute("contenteditable")&&1===e[o].childNodes.length&&"TABLE"===e[o].childNodes[0].nodeName){var s=document.createElement(n);s.innerHTML="<li><br/></li>",e[o].appendChild(s)}else if("LI"!==e[o].tagName&&t.isNullOrUndefined(r)){var a="<"+n+">",l="</"+n+">",d="li"+("IMG"===e[o].tagName?"":this.domNode.attributes(e[o])),c="p"===e[o].tagName.toLowerCase()?e[o].innerHTML:e[o].outerHTML,p=a+this.domNode.createTagString(d,null,c)+l;this.domNode.replaceWith(e[o],p)}else if(!t.isNullOrUndefined(r)&&"LI"!==e[o].tagName){a="<"+n+("IMG"===e[o].tagName?"":this.domNode.attributes(e[o]))+">",l="</"+n+">",d="li",c="p"===e[o].tagName.toLowerCase()?e[o].innerHTML:e[o].outerHTML,p=a+this.domNode.createTagString(d,null,c)+l;this.domNode.replaceWith(e[o],p)}}this.cleanNode(),this.parent.editableElement.focus(),I()&&B(this.parent.editableElement,i),this.saveSelection=this.domNode.saveMarker(this.saveSelection),this.saveSelection.restore()},e.prototype.removeEmptyListElements=function(){for(var e=this.parent.editableElement.querySelectorAll("ol, ul"),n=0;n<e.length;n++)""===e[n].textContent.trim()&&t.detach(e[n])},e.prototype.isRevert=function(e,t){for(var n=!0,i=0;i<e.length;i++){if("LI"!==e[i].tagName)return!1;e[i].parentNode.tagName!==t&&(n=!1)}return n},e.prototype.checkLists=function(e,n,i){for(var r=[],o=0;o<e.length;o++){var s=e[o].parentNode;t.isNullOrUndefined(i)||"LI"!==e[o].tagName||t.isNullOrUndefined(i.listStyle)||("listImage"===i.listStyle?t.setStyleAttribute(s,{"list-style-image":i.listImage}):(t.setStyleAttribute(s,{"list-style-image":"none"}),t.setStyleAttribute(s,{"list-style-type":i.listStyle.replace(/([a-z])([A-Z])/g,"$1-$2").toLowerCase()}))),("LI"===e[o].tagName&&s.tagName!==n&&r.indexOf(s)<0||"LI"===e[o].tagName&&s.tagName===n&&r.indexOf(s)<0&&null!==i)&&r.push(s)}for(var a=r.length-1;a>=0;a--){var l=r[a],d="<"+n.toLowerCase()+" "+this.domNode.attributes(l)+">"+l.innerHTML+"</"+n.toLowerCase()+">";this.domNode.replaceWith(r[a],d)}},e.prototype.cleanNode=function(){for(var e=this.parent.editableElement.querySelectorAll("ol + ol, ul + ul"),t=0;t<e.length;t++){var n=e[t];if(this.domNode.isList(n.previousElementSibling)&&this.domNode.openTagString(n)===this.domNode.openTagString(n.previousElementSibling)){for(var i=this.domNode.contents(n),r=0;r<i.length;r++)n.previousElementSibling.appendChild(i[r]);n.parentNode.removeChild(n)}}},e.prototype.findUnSelected=function(e,t){if((e=e.slice().reverse()).length>0){var n=[],i=[],r=[],o=[];r=t[t.length-1].childNodes;for(var s=0;s<r.length;s++)if("OL"===r[s].tagName||"UL"===r[s].tagName){var a=r[s].querySelectorAll("li");if(a.length>0)for(var l=0;l<a.length;l++)o.push(a[l])}for(var d=0;d<o.length;d++){for(var c=0,p=0;p<e.length;p++)o[d].contains(e[p])||(c+=1);c===e.length&&i.push(o[d])}if(i.length>0)for(var h=0;h<i.length;h++)"OL"!==this.domNode.contents(i[h])[0].nodeName&&"UL"!==this.domNode.contents(i[h])[0].nodeName&&n.push(i[h]);n.length>0&&this.nestedList(n)}},e.prototype.revertList=function(e){for(var n=[],i=e.length-1;i>=0;i--)for(var r=i-1;r>=0;r--)if(e[r].contains(e[i])||e[r]===e[i]){n.push(e[i]),e.splice(i,1);break}this.findUnSelected(n,e);var o=[];for(i=0;i<e.length;i++){var s=e[i];3===this.domNode.contents(s)[0].nodeType&&0===this.domNode.contents(s)[0].textContent.trim().length&&t.detach(this.domNode.contents(s)[0]);var a=e[i].parentNode,l=s.getAttribute("class");if(0===n.length){var d=e[i].querySelectorAll("ul, ol")[0];if(d){if(d.querySelectorAll("li")){var c=t.createElement(d.tagName);t.append([c],d.parentNode);var p=t.createElement("li",{styles:"list-style-type: none;"});t.append([p],c),t.append([d],p)}}}if(s.parentNode.insertBefore(this.closeTag(a.tagName),s),"LI"===a.parentNode.tagName)s.parentNode.insertBefore(this.closeTag("LI"),s);else{if(0===s.querySelectorAll(oo.join(", ")).length){var h="<p"+(t.isNullOrUndefined(l)?' class="e-rte-wrap-inner"':' class="'+l+' e-rte-wrap-inner"')+this.domNode.attributes(a)+"></p>";this.domNode.wrapInner(s,this.domNode.parseHTMLFragment(h))}else if(3===this.domNode.contents(s)[0].nodeType){var u=this.domNode.createTagString("p",a,this.parent.domNode.encode(this.domNode.contents(s)[0].textContent));this.domNode.replaceWith(this.domNode.contents(s)[0],u)}else if(this.domNode.contents(s)[0].classList.contains(mo.startSelection)||this.domNode.contents(s)[0].classList.contains(mo.endSelection)){u=this.domNode.createTagString("p",a,this.domNode.contents(s)[0].outerHTML);this.domNode.replaceWith(this.domNode.contents(s)[0],u)}else{var m=s.firstChild;l=m.getAttribute("class"),t.attributes(m,this.domNode.rawAttributes(a)),l&&m.getAttribute("class")&&t.attributes(m,{class:l+" "+m.getAttribute("class")})}t.append([this.openTag("LI")],s),t.prepend([this.closeTag("LI")],s)}this.domNode.insertAfter(this.openTag(a.tagName),s),"LI"===a.parentNode.tagName&&(a=a.parentNode.parentNode),o.indexOf(a)<0&&o.push(a)}for(i=0;i<o.length;i++){var g=o[i],f=g.innerHTML;f=(f=f.replace(/<span class="e-rte-list-close-([a-z]*)"><\/span>/g,"</$1>")).replace(/<span class="e-rte-list-open-([a-z]*)"><\/span>/g,"<$1 "+this.domNode.attributes(g)+">"),this.domNode.replaceWith(g,this.domNode.openTagString(g)+f.trim()+this.domNode.closeTagString(g))}var b=this.parent.editableElement.querySelectorAll("ul:empty, ol:empty");for(i=0;i<b.length;i++)t.detach(b[i]);var v=this.parent.editableElement.querySelectorAll("li:empty");for(i=0;i<v.length;i++)t.detach(v[i])},e.prototype.openTag=function(e){return this.domNode.parseHTMLFragment('<span class="e-rte-list-open-'+e.toLowerCase()+'"></span>')},e.prototype.closeTag=function(e){return this.domNode.parseHTMLFragment('<span class="e-rte-list-close-'+e.toLowerCase()+'"></span>')},e}(),bo=function(){function e(){}return e.WrapBefore=function(e,t,n){return t.innerText=e.textContent,n?this.AppendBefore(t,e,!0):this.AppendBefore(t,e),e.parentNode&&e.parentNode.removeChild(e),t.childNodes[0]},e.Wrap=function(e,t){return this.AppendBefore(t,e),t.appendChild(e),e},e.unwrap=function(e){for(var t=e.parentNode,n=[];e.firstChild;null)n.push(t.insertBefore(e.firstChild,e));return t.removeChild(e),n},e.AppendBefore=function(e,t,n){return t.parentNode?n?t.parentNode.insertBefore(e,t.nextSibling):t.parentNode.insertBefore(e,t):t},e}(),vo=function(){function e(){this.enterAction="P",this.position=-1,this.nodeSelection=new uo}return e.prototype.GetSpliceNode=function(e,t){return t=this.SplitNode(e,t,!0),t=this.SplitNode(e,t,!1)},e.prototype.SplitNode=function(e,t,n){if(t){var i=e.cloneRange(),r=t.parentNode,o=this.nodeSelection.getIndex(t);i.collapse(n),n?i.setStartBefore(t):i.setEndAfter(t);var s=i.extractContents();if(n){if(t=r.childNodes[o],(s=this.spliceEmptyNode(s,!1))&&s.childNodes.length>0){if(!!(1!==s.childNodes.length||"IMG"===s.childNodes[0].nodeName||!this.isImgElm(s)||""!==s.textContent))if(t)bo.AppendBefore(s,t);else{r.appendChild(s);(a=document.createElement("div")).innerHTML="&#65279;&#65279;",t=a.firstChild,r.appendChild(t)}}}else if(t=r.childNodes.length>1?r.childNodes[o]:r.childNodes[0],(s=this.spliceEmptyNode(s,!0))&&s.childNodes.length>0){if(!!(1!==s.childNodes.length||"IMG"===s.childNodes[0].nodeName||!this.isImgElm(s)||""!==s.textContent.trim()))if(t)bo.AppendBefore(s,t,!0);else{r.appendChild(s);var a;(a=document.createElement("div")).innerHTML="&#65279;&#65279;",r.insertBefore(a.firstChild,r.firstChild),t=r.firstChild}}return t}return null},e.prototype.isImgElm=function(e){var n=!0;if(1===e.childNodes.length&&"IMG"!==e.childNodes[0].nodeName)for(var i=e.childNodes[0],r=0;!t.isNullOrUndefined(i.childNodes)&&r<i.childNodes.length;r++)"IMG"===i.childNodes[r].nodeName&&(n=!1);else n=!0;return n},e.prototype.spliceEmptyNode=function(e,t){var n;return(n=1===e.childNodes.length&&"#text"===e.childNodes[0].nodeName&&""===e.childNodes[0].textContent||""===e.textContent?-1:e.childNodes.length-1)>-1&&!t?this.spliceEmptyNode(e.childNodes[n],t):n>-1?this.spliceEmptyNode(e.childNodes[0],t):3!==e.nodeType&&11!==e.nodeType&&e.parentNode.removeChild(e),e},e.prototype.GetCursorStart=function(e,t,n){for(var i=(e=n?e:e.reverse())[0],r=0;r<e.length&&(n?e[r]<t:e[r]>=t);r++)i=e[r];return i},e.prototype.GetCursorRange=function(e,t,n){var i=e.createRange(),r=[];r.push(0);for(var o=this.TrimLineBreak(n.data),s=o.indexOf(" ",0);-1!==s;)r.indexOf(s)<0&&r.push(s),new RegExp("\\s").test(o[s-1])&&r.indexOf(s-1)<0&&r.push(s-1),new RegExp("\\s").test(o[s+1])&&r.push(s+1),s=o.indexOf(" ",s+1);if(r.push(o.length),r.indexOf(t.startOffset)>=0||r.indexOf(t.startOffset-1)>=0&&(1!==t.startOffset||1===t.startOffset&&new RegExp("\\s").test(o[0]))||r[r.length-1]-1===t.startOffset)i=t,this.position=1;else{var a=this.GetCursorStart(r,t.startOffset,!0);this.position=t.startOffset-a,i.setStart(t.startContainer,a),i.setEnd(t.startContainer,this.GetCursorStart(r,t.startOffset,!1))}return i},e.prototype.GetCursorNode=function(e,t,n){return this.GetSpliceNode(this.GetCursorRange(e,t,n),n)},e.prototype.TrimLineBreak=function(e){return e.replace(/(\r\n\t|\n|\r\t)/gm," ")},e}(),yo=function(){function e(e){this.parent=e,this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.observer.on(pr,this.applyFormats,this),this.parent.observer.on(ur,this.onKeyUp,this),this.parent.observer.on(hr,this.onKeyDown,this)},e.prototype.getParentNode=function(e){for(;e.parentNode&&e.parentNode!==this.parent.editableElement;null)e=e.parentNode;return e},e.prototype.onKeyUp=function(e){var n=this.parent.nodeSelection.getRange(this.parent.currentDocument),i=n.endContainer,r=i.lastChild;if(13===e.event.which&&n.startContainer===i&&3!==i.nodeType){var o=t.createElement("p");if(o.innerHTML="<br>",!t.isNullOrUndefined(r)&&r&&"BR"===r.nodeName&&r.previousSibling&&"TABLE"===r.previousSibling.nodeName)i.replaceChild(o,r),this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument,o,0);else{var s=this.parent.nodeSelection.getSelectionNodeCollectionBr(n)[0];!t.isNullOrUndefined(s)&&"BR"===s.nodeName&&s.previousSibling&&"TABLE"===s.previousSibling.nodeName&&(i.replaceChild(o,s),this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument,o,0))}}},e.prototype.onKeyDown=function(e){if(13===e.event.which){var n=this.parent.nodeSelection.getRange(this.parent.currentDocument),i=0===n.startContainer.textContent.length||"PRE"===n.startContainer.nodeName?n.startContainer:n.startContainer.parentElement,r=0===n.endContainer.textContent.length||"PRE"===n.endContainer.nodeName?n.endContainer:n.endContainer.parentElement,o=t.closest(i,"pre"),s=t.closest(r,"pre");if(!t.isNullOrUndefined(o)&&!t.isNullOrUndefined(o.parentElement)&&"LI"===o.parentElement.tagName)return;if((t.isNullOrUndefined(o)&&!t.isNullOrUndefined(s)||!t.isNullOrUndefined(o)&&t.isNullOrUndefined(s))&&(e.event.preventDefault(),this.deleteContent(n),this.removeCodeContent(n),n=this.parent.nodeSelection.getRange(this.parent.currentDocument),this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument,r,0)),13===e.event.which&&!t.isNullOrUndefined(o)&&!t.isNullOrUndefined(s)){e.event.preventDefault(),this.deleteContent(n),this.removeCodeContent(n);var a=(n=this.parent.nodeSelection.getRange(this.parent.currentDocument)).startContainer.childNodes[n.endOffset],l=n.startContainer.childNodes[n.endOffset-1],d=n.startContainer;if(t.isNullOrUndefined(a)||t.isNullOrUndefined(l)||!t.isNullOrUndefined(a.nextSibling)||"BR"!==a.nodeName||"BR"!==l.nodeName)if(8203===d.textContent.charCodeAt(0)&&1===d.textContent.length||0===d.textContent.length){for(;"PRE"!==d.parentElement.nodeName&&(1===d.textContent.length||0===d.textContent.length);)d=d.parentElement;!t.isNullOrUndefined(d.previousSibling)&&"BR"===d.previousSibling.nodeName&&t.isNullOrUndefined(d.nextSibling)?this.paraFocus(d.parentElement):this.isNotEndCursor(o,n)}else this.isNotEndCursor(o,n);else this.paraFocus(n.startContainer,e.enterAction)}}},e.prototype.removeCodeContent=function(e){var n=new RegExp(String.fromCharCode(65279),"g");if(!t.isNullOrUndefined(e.endContainer.textContent.match(n))){var i=65279===e.endContainer.textContent.charCodeAt(e.endOffset-1)?e.endOffset-2:e.endOffset;e.endContainer.textContent=e.endContainer.textContent.replace(n,""),""===e.endContainer.textContent?this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument,e.endContainer.parentElement,0):this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument,e.endContainer,i)}},e.prototype.deleteContent=function(e){e.startContainer===e.endContainer&&e.startOffset===e.endOffset||e.deleteContents()},e.prototype.paraFocus=function(e,n){var i;"DIV"===n?(i=t.createElement("div")).innerHTML="<br>":"BR"===n?i=t.createElement("br"):(i=t.createElement("p")).innerHTML="<br>",this.parent.domNode.insertAfter(i,e),this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument,i,0),t.detach(e.lastChild)},e.prototype.isNotEndCursor=function(e,n){var i=new vo,r=n.startOffset===e.lastChild.textContent.length&&e.lastChild.textContent===n.startContainer.textContent;if(0===e.textContent.indexOf(n.startContainer.textContent)&&(0===n.startOffset&&0===n.endOffset||"PRE"===n.startContainer.nodeName)){this.insertMarker(e,n);var o=t.createElement("br");e.childNodes[n.endOffset].parentElement.insertBefore(o,e.childNodes[n.endOffset])}else{var s=i.SplitNode(n,e,!0);this.insertMarker(e,n);var a=e.previousElementSibling;"PRE"===a.tagName&&(a.insertAdjacentHTML("beforeend","<br>"+s.innerHTML),t.detach(e))}this.setCursorPosition(r,e)},e.prototype.setCursorPosition=function(e,n){var i=!1,r=this.parent.editableElement.querySelector(".tempSpan"),o=r.parentElement;if(""===r.parentNode.textContent?i=!0:this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument,r,0),e)if(i)o===n?(this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument,r,0),t.detach(r)):this.focusSelectionParent(r,o);else{var s=t.createElement("br");this.parent.domNode.insertAfter(s,r),this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument,r,0),t.detach(r)}else i?this.focusSelectionParent(r,o):t.detach(r)},e.prototype.focusSelectionParent=function(e,n){t.detach(e),n.innerHTML="​",this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument,n,0)},e.prototype.insertMarker=function(e,n){var i=t.createElement("span",{className:"tempSpan"});"PRE"===n.startContainer.nodeName?e.childNodes[n.endOffset].parentElement.insertBefore(i,e.childNodes[n.endOffset]):n.startContainer.parentElement.insertBefore(i,n.startContainer)},e.prototype.applyFormats=function(e){var n=this.parent.nodeSelection.getRange(this.parent.currentDocument),i=!1;this.parent.editableElement!==n.endContainer||t.isNullOrUndefined(this.parent.editableElement.children[n.endOffset-1])||"TABLE"!==this.parent.editableElement.children[n.endOffset-1].tagName||n.collapsed||(i=!0);var r=this.parent.nodeSelection.save(n,this.parent.currentDocument);this.parent.domNode.setMarker(r);var o=this.parent.domNode.blockNodes();if("BR"===e.enterAction){this.setSelectionBRConfig();var s=this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument),a=this.parent.nodeSelection.getSelectionNodes(s),l=[];0===a.length&&a.push(o[0]);for(var d=0;d<a.length;d++){for(var c=a[d],p=void 0;!this.parent.domNode.isBlockNode(c)&&c!==this.parent.editableElement;)p=c,c=c.parentElement;this.parent.domNode.isBlockNode(c)&&c===this.parent.editableElement&&l.push(p)}for(d=0;d<l.length;d++)if(!this.parent.domNode.isBlockNode(l[d])){for(var h=c=l[d];c===this.parent.editableElement;)h=c,c=c.parentElement;var u=void 0;this.parent.domNode.isBlockNode(h.parentElement)&&h.parentElement===this.parent.editableElement?(u=t.createElement("div"),h.parentElement.insertBefore(u,h),u.appendChild(h)):u=h;for(var m=u.previousSibling;!t.isNullOrUndefined(m)&&"BR"!==m.nodeName&&!this.parent.domNode.isBlockNode(m);)u.firstChild.parentElement.insertBefore(m,u.firstChild),m=u.previousSibling;t.isNullOrUndefined(m)||"BR"!==m.nodeName||t.detach(m);for(var g=u.nextSibling;!t.isNullOrUndefined(g)&&"BR"!==g.nodeName&&!this.parent.domNode.isBlockNode(g);)u.appendChild(g),g=u.nextSibling;t.isNullOrUndefined(g)||"BR"!==g.nodeName||t.detach(g)}this.setSelectionBRConfig(),o=this.parent.domNode.blockNodes()}for(d=0;d<o.length;d++){var f=void 0,b=void 0;if("blockquote"===e.subCommand.toLowerCase()?(f=this.getParentNode(o[d]),b=this.parent.domNode.isList(f)||"TABLE"===f.tagName?f.outerHTML:f.innerHTML):b=(f=o[d]).innerHTML,!(e.subCommand.toLowerCase()===f.tagName.toLowerCase()&&("pre"!==e.subCommand.toLowerCase()||!t.isNullOrUndefined(e.exeValue)&&"dropDownSelect"===e.exeValue.name)||t.isNullOrUndefined(f.parentNode)||"TABLE"===f.tagName&&"pre"===e.subCommand.toLowerCase())){this.cleanFormats(f,e.subCommand);var v="pre"===e.subCommand.toLowerCase()&&"pre"===f.tagName.toLowerCase()?"p":e.subCommand,y=this.parent.domNode.createTagString(v,f,b.replace(/>\s+</g,"><"));"LI"===f.tagName?(f.innerHTML="",f.insertAdjacentHTML("beforeend",y)):this.parent.domNode.replaceWith(f,y)}}this.preFormatMerge();var C=this.parent.editableElement.querySelector("."+mo.startSelection),S=this.parent.editableElement.querySelector("."+mo.endSelection);t.isNullOrUndefined(C)||t.isNullOrUndefined(S)||(C=C.lastChild,S=S.lastChild),r=this.parent.domNode.saveMarker(r,null),I()&&B(this.parent.editableElement,e.selector),i?this.parent.nodeSelection.setSelectionText(this.parent.currentDocument,C,S,0,S.textContent.length):r.restore(),e.callBack&&e.callBack({requestType:e.subCommand,editorMode:"HTML",event:e.event,range:this.parent.nodeSelection.getRange(this.parent.currentDocument),elements:this.parent.domNode.blockNodes()})},e.prototype.setSelectionBRConfig=function(){var e=this.parent.editableElement.querySelector("."+mo.startSelection),n=this.parent.editableElement.querySelector("."+mo.endSelection);t.isNullOrUndefined(n)?this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument,e,0):this.parent.nodeSelection.setSelectionText(this.parent.currentDocument,e,n,0,0)},e.prototype.preFormatMerge=function(){var e=this.parent.editableElement.querySelectorAll("PRE");if(!t.isNullOrUndefined(e))for(var n=0;n<e.length;n++){var i=e[n].previousElementSibling;t.isNullOrUndefined(i)||"PRE"!==i.tagName||(i.insertAdjacentHTML("beforeend","<br>"+e[n].innerHTML),t.detach(e[n]))}},e.prototype.cleanFormats=function(e,t){var n=["display","font-size","margin-top","margin-bottom","margin-left","margin-right","font-weight"];t=t.toLowerCase();for(var i=0;i<n.length&&"p"!==t&&"blockquote"!==t&&"pre"!==t;i++)e.style.removeProperty(n[i])},e}(),Co=function(){function e(){}return e.Insert=function(e,n,i,r){var o;if("string"==typeof n){(s=document.createElement("div")).innerHTML=n,o=r?s:s.firstChild}else if(r&&(t.isNullOrUndefined(n)||t.isNullOrUndefined(n.classList)||!n.classList.contains("pasteContent"))){var s;(s=document.createElement("div")).appendChild(n),o=s}else o=n;var a=new uo,l=new vo,d=a.getRange(e);d.startContainer===i&&d.startContainer===d.endContainer&&0===d.startOffset&&d.startOffset===d.endOffset&&0===i.textContent.length&&"P"===i.children[0].tagName&&(a.setSelectionText(e,d.startContainer.children[0],d.startContainer.children[0],0,0),d=a.getRange(e));var c=d.startOffset===d.endOffset&&0===d.startOffset&&d.startContainer===d.endContainer,p=d.collapsed,h=this.getNodeCollection(d,a,o),u="table"===o.nodeName.toLowerCase()?this.closestEle(h[0].parentNode,i):h[0];if(r||!t.isNullOrUndefined(o)&&!t.isNullOrUndefined(o.classList)&&o.classList.contains("pasteContent"))this.pasteInsertHTML(h,o,d,a,l,e,p,u,i);else if(i!==d.startContainer&&(!p&&(u.nodeType!==Node.ELEMENT_NODE||-1===ao.indexOf(u.tagName.toLocaleLowerCase()))||"table"===o.nodeName.toLowerCase()&&u&&-1===ao.indexOf(u.tagName.toLocaleLowerCase()))){var m=l.GetSpliceNode(d,u),g=m.previousSibling,f=m.parentNode;if(1===h.length||"table"===o.nodeName.toLowerCase()&&0===m.childElementCount)a.setSelectionContents(e,m),d=a.getRange(e);else{var b=l.GetSpliceNode(d,h[h.length-1].parentElement);b=t.isNullOrUndefined(b)?m:b,a.setSelectionText(e,m,b,0,3===b.nodeType?b.textContent.length:b.childNodes.length),d=a.getRange(e)}d.extractContents(),"TABLE"===n.tagName&&this.removeEmptyElements(i);for(var v=0;v<h.length;v++)if(3!==h[v].nodeType&&null!=h[v].parentNode){if("IMG"===h[v].nodeName)continue;h[v].parentNode.removeChild(h[v])}if(g)bo.AppendBefore(o,g,!0);else{for(var y=null;f!==i&&f.firstChild&&""===f.textContent.trim();){y=f,f=f.parentNode}null!==y&&(f=y),f.firstChild&&(f!==i||"TABLE"===o.nodeName&&c&&f===d.startContainer&&f===d.endContainer)?""===f.textContent.trim()&&f!==i?(bo.AppendBefore(o,f,!1),t.detach(f)):bo.AppendBefore(o,f.firstChild,!1):f.appendChild(o)}"IMG"===o.nodeName?this.imageFocus(o,a,e):3!==o.nodeType?a.setSelectionText(e,o,o,0,o.childNodes.length):a.setSelectionText(e,o,o,0,o.textContent.length)}else{if(d.deleteContents(),c&&""===d.startContainer.textContent&&"BR"!==d.startContainer.nodeName&&(d.startContainer.innerHTML=""),t.Browser.isIE){var C=e.createDocumentFragment();C.appendChild(o),d.insertNode(C)}else if(1===d.startContainer.nodeType&&"hr"===d.startContainer.nodeName.toLowerCase()&&"hr"===d.endContainer.nodeName.toLowerCase()){var S=d.startContainer.nextElementSibling;S&&(S.querySelector("br")&&t.detach(S.querySelector("br")),S.appendChild(o))}else"BR"===d.startContainer.nodeName?d.startContainer.parentElement.insertBefore(o,d.startContainer):d.insertNode(o);3!==o.nodeType&&o.childNodes.length>0?a.setSelectionText(e,o,o,1,1):"IMG"===o.nodeName?this.imageFocus(o,a,e):3!==o.nodeType?a.setSelectionContents(e,o):a.setSelectionText(e,o,o,o.textContent.length,o.textContent.length)}},e.pasteInsertHTML=function(e,n,i,r,o,s,a,l,d){var c=i.startOffset===i.endOffset&&i.startContainer===i.endContainer;if(c&&i.startContainer===d&&""===d.textContent){var p=this.getImmediateBlockNode(e[e.length-1],d);r.setSelectionText(s,p,p,0,0),i=r.getRange(s)}var h,u,m,g;d!==i.startContainer&&(!a&&(l.nodeType!==Node.ELEMENT_NODE||-1===ao.indexOf(l.tagName.toLocaleLowerCase()))||"table"===n.nodeName.toLowerCase()&&l&&-1===ao.indexOf(l.tagName.toLocaleLowerCase()))&&(g=o.GetSpliceNode(i,l),u=t.isNullOrUndefined(g.previousSibling)?g.parentNode.previousSibling:g.previousSibling,1===e.length?(r.setSelectionContents(s,g),i=r.getRange(s),m=!0):(h=o.GetSpliceNode(i,e[e.length-1].parentElement),h=t.isNullOrUndefined(h)?g:h,r.setSelectionText(s,g,h,0,3===h.nodeType?h.textContent.length:h.childNodes.length),i=r.getRange(s),m=!1));var f=!1;this.removingComments(n);for(var b=n.childNodes,v=0;v<b.length;v++)if(oo.indexOf(b[v].nodeName.toLocaleLowerCase())>=0){f=!0;break}var y,C=document.createDocumentFragment();if(f){this.insertTempNode(i,n,e,o,d);var S=!0,N=void 0,E=void 0,T=void 0;for(i.deleteContents();n.firstChild;)if("#text"!==n.firstChild.nodeName||""!==n.firstChild.textContent.trim())if("#text"===n.firstChild.nodeName&&S||this.inlineNode.indexOf(n.firstChild.nodeName.toLocaleLowerCase())>=0&&S){if(y=n.firstChild,t.isNullOrUndefined(n.previousElementSibling)){var w=t.createElement("p");n.parentElement.insertBefore(w,n)}n.previousElementSibling.appendChild(n.firstChild)}else y=n.firstChild,"#text"===n.firstChild.nodeName||this.inlineNode.indexOf(n.firstChild.nodeName.toLocaleLowerCase())>=0?(N?(T.appendChild(n.firstChild),C.appendChild(T)):((E=t.createElement("p")).appendChild(n.firstChild),C.appendChild(E)),T=E,N=!0):(C.appendChild(n.firstChild),N=!1),S=!1;else t.detach(n.firstChild);n.parentNode.replaceChild(C,n)}else if(c){var k=t.createElement("span",{className:"tempSpan"}),L=t.closest(i.startContainer.parentElement,"a");if(3===i.startContainer.nodeType&&L){var O=this.getImmediateBlockNode(i.startContainer,d);O.querySelectorAll("br").length>0&&t.detach(O.querySelector("br"));t.closest(L,"span").appendChild(k)}else i.insertNode(k);for(;n.firstChild;)y=n.firstChild,C.appendChild(n.firstChild);k.parentNode.replaceChild(C,k)}else{for(;n.firstChild;)y=n.firstChild,C.appendChild(n.firstChild);m?g.parentNode.replaceChild(C,g):(i.deleteContents(),t.detach(h),t.isNullOrUndefined(u)?d.appendChild(C):u.parentNode.appendChild(C))}"#text"===y.nodeName?this.placeCursorEnd(y,n,r,s,d):this.cursorPos(y,n,r,s,d)},e.placeCursorEnd=function(e,n,i,r,o){for(e="BR"===e.nodeName?t.isNullOrUndefined(e.previousSibling)?e.parentNode:e.previousSibling:e;!t.isNullOrUndefined(e)&&"#text"!==e.nodeName&&"IMG"!==e.nodeName&&"BR"!==e.nodeName&&"HR"!==e.nodeName;)e=e.lastChild;"IMG"===(e=t.isNullOrUndefined(e)?n:e).nodeName?this.imageFocus(e,i,r):i.setSelectionText(r,e,e,e.textContent.length,e.textContent.length),this.removeEmptyElements(o)},e.getNodeCollection=function(e,t,n){var i=[];return e.startOffset===e.endOffset&&e.startContainer===e.endContainer&&"BR"!=e.startContainer.nodeName&&("TD"===e.startContainer.nodeName||3!==e.startContainer.nodeType&&n.classList&&n.classList.contains("pasteContent"))?i.push(e.startContainer.childNodes[e.endOffset]):i=t.getInsertNodeCollection(e),i},e.insertTempNode=function(e,n,i,r,o){if(e.startContainer!==o||t.isNullOrUndefined(e.startContainer.childNodes[e.endOffset-1])||"TABLE"!==e.startContainer.childNodes[e.endOffset-1].nodeName)if(e.startContainer!==o||t.isNullOrUndefined(e.startContainer.childNodes[e.endOffset])||"TABLE"!==e.startContainer.childNodes[e.endOffset].nodeName)if(e.startContainer===e.endContainer&&3!==e.startContainer.nodeType&&"HR"===n.firstChild.nodeName)e.startContainer.classList.contains("e-content")||"BODY"===e.startContainer.nodeName?e.startContainer.appendChild(n):e.startContainer.parentNode.insertBefore(n,e.startContainer);else{var s=this.getImmediateBlockNode(i[i.length-1],o);if((t.isNullOrUndefined(s)||t.isNullOrUndefined(s.parentElement))&&3!==e.endContainer.nodeType&&(s=e.endContainer,e.setEnd(s,e.endContainer.textContent.length)),"BODY"===s.nodeName&&e.startContainer===e.endContainer&&1===e.startContainer.nodeType&&(s=e.startContainer),s.closest("LI")&&n&&n.firstElementChild&&("OL"===n.firstElementChild.tagName||"UL"===n.firstElementChild.tagName))for(var a=void 0;n.firstElementChild.lastElementChild&&"LI"===n.firstElementChild.lastElementChild.tagName;)(a=n.firstElementChild.lastElementChild).style.removeProperty("margin-left"),a.style.removeProperty("margin-top"),a.style.removeProperty("margin-bottom"),n.firstElementChild.insertAdjacentElement("afterend",a);if("TD"===s.nodeName||"TH"===s.nodeName){var l=t.createElement("span",{className:"tempSpan"});e.insertNode(l),l.parentNode.replaceChild(n,l)}else{var d=i[i.length-1],c=void 0;(c="BR"!==d.nodeName&&"HR"!==d.nodeName||t.isNullOrUndefined(d.parentElement)||0!==d.parentElement.textContent.trim().length?r.GetSpliceNode(e,s):d).parentNode.replaceChild(n,c)}}else e.startContainer.insertBefore(n,e.startContainer.childNodes[e.endOffset]);else t.isNullOrUndefined(e.startContainer.childNodes[e.endOffset-1].nextSibling)?e.startContainer.appendChild(n):e.startContainer.insertBefore(n,e.startContainer.childNodes[e.endOffset-1].nextSibling)},e.cursorPos=function(e,n,i,r,o){e.classList.add("lastNode"),o.innerHTML=function(e){var n=document.createElement("div");n.innerHTML=e,n.setAttribute("class","tempDiv");var i=document.createElement("div");if(n.childNodes.length>0){for(var r=void 0,o=void 0,s=void 0;n.firstChild;)"#text"===n.firstChild.nodeName&&(n.firstChild.textContent.indexOf("\n")<0||""!==n.firstChild.textContent.trim())||ar.indexOf(n.firstChild.nodeName.toLocaleLowerCase())>=0?(r?o.appendChild(n.firstChild):(s=t.createElement("p"),i.appendChild(s),s.appendChild(n.firstChild)),o=s,r=!0):"#text"===n.firstChild.nodeName&&("\n"===n.firstChild.textContent||n.firstChild.textContent.indexOf("\n")>=0&&""===n.firstChild.textContent.trim())?t.detach(n.firstChild):(i.appendChild(n.firstChild),r=!1);for(var a=i.querySelectorAll("table"),l=0;l<a.length;l++){"0"===a[l].getAttribute("border")&&a[l].removeAttribute("border");for(var d=a[l].querySelectorAll("td"),c=0;c<d.length;c++)"none"===d[c].style.borderLeft&&d[c].style.removeProperty("border-left"),"none"===d[c].style.borderRight&&d[c].style.removeProperty("border-right"),"none"===d[c].style.borderBottom&&d[c].style.removeProperty("border-bottom"),"none"===d[c].style.borderTop&&d[c].style.removeProperty("border-top"),"none"===d[c].style.border&&d[c].style.removeProperty("border");a[l].classList.contains(ai)||a[l].classList.add(ai)}var p=i.querySelectorAll("img");for(l=0;l<p.length;l++)p[l].classList.contains($n)||p[l].classList.add($n),p[l].classList.contains(hn)||p[l].classList.contains(ln)||p[l].classList.add(hn)}return i.innerHTML}(o.innerHTML),e=o.querySelector(".lastNode"),t.isNullOrUndefined(e)||(this.placeCursorEnd(e,n,i,r,o),e.classList.remove("lastNode"),0===e.classList.length&&e.removeAttribute("class"))},e.imageFocus=function(e,t,n){var i=document.createTextNode(" ");e.parentNode.insertBefore(i,e.nextSibling),t.setSelectionText(n,e.nextSibling,e.nextSibling,0,0)},e.getImmediateBlockNode=function(e,t){do{e=e.parentNode}while(e&&oo.indexOf(e.nodeName.toLocaleLowerCase())<0);return e},e.removingComments=function(e){var t=e.innerHTML;t=t.replace(/<!--[\s\S]*?-->/g,""),e.innerHTML=t},e.findDetachEmptyElem=function(e){return t.isNullOrUndefined(e.parentElement)?null:""===e.parentElement.textContent.trim()&&"true"!==e.parentElement.contentEditable?this.findDetachEmptyElem(e.parentElement):e},e.removeEmptyElements=function(e){for(var n=e.querySelectorAll(":empty"),i=0;i<n.length;i++)if("IMG"!==n[i].tagName&&"BR"!==n[i].tagName&&"IFRAME"!==n[i].tagName&&"TD"!==n[i].tagName&&"SOURCE"!==n[i].tagName&&"HR"!==n[i].tagName){var r=this.findDetachEmptyElem(n[i]);t.isNullOrUndefined(r)||t.detach(r)}},e.closestEle=function(e,n){for(var i=e;i&&1===i.nodeType;){if(i.parentNode===n||!t.isNullOrUndefined(i.parentNode.tagName)&&-1!==so.indexOf(i.parentNode.tagName.toLocaleLowerCase()))return i;i=i.parentNode}return null},e.inlineNode=["a","abbr","acronym","audio","b","bdi","bdo","big","br","button","canvas","cite","code","data","datalist","del","dfn","em","embed","font","i","iframe","img","input","ins","kbd","label","map","mark","meter","noscript","object","output","picture","progress","q","ruby","s","samp","script","select","slot","small","span","strong","sub","sup","svg","template","textarea","time","u","tt","var","video","wbr"],e}(),So=function(){function e(e){this.parent=e,this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.observer.on(Wr,this.linkCommand,this)},e.prototype.linkCommand=function(e){switch(e.value.toString().toLocaleLowerCase()){case"createlink":case"editlink":this.createLink(e);break;case"openlink":this.openLink(e);break;case"removelink":this.removeLink(e)}},e.prototype.createLink=function(e){var n=!t.isNullOrUndefined(e.item.selectParent)&&e.item.selectParent.length>0&&t.closest(e.item.selectParent[0],"a");if(n=t.isNullOrUndefined(n)?!t.isNullOrUndefined(e.item.selectParent)&&e.item.selectParent.length>0?e.item.selectParent[0]:null:n,t.isNullOrUndefined(n)||"A"!==n.tagName){var i=new uo,r=i.getRange(this.parent.currentDocument);"#text"===r.endContainer.nodeName&&r.startContainer.textContent.length===r.endOffset+1&&" "===r.endContainer.textContent.charAt(r.endOffset)&&"A"===r.endContainer.nextSibling.nodeName&&(i.setSelectionText(this.parent.currentDocument,r.startContainer,r.endContainer,r.startOffset,r.endOffset+1),r=i.getRange(this.parent.currentDocument));var o=!!t.isNullOrUndefined(e.item.text)||e.item.text.replace(/ /g,"").localeCompare(r.toString().replace(/\n/g," ").replace(/ /g,""))<0;if(e.event&&"keydown"===e.event.type&&(32===e.event.keyCode||13===e.event.keyCode)||"Paste"===e.item.action||r.collapsed||o){var s=this.createAchorNode(e);if(s.innerText=""===e.item.text?e.item.url:e.item.text,e.item.selection.restore(),Co.Insert(this.parent.currentDocument,s,this.parent.editableElement),!e.event||"keydown"!==e.event.type||32!==e.event.keyCode&&13!==e.event.keyCode){c="Paste"===e.item.action?s.childNodes[0].textContent.length:0;e.item.selection.setSelectionText(this.parent.currentDocument,s.childNodes[0],s.childNodes[0],c,s.childNodes[0].textContent.length)}else{var a=e.item.selection.range.startContainer;a.textContent=this.removeText(a.textContent,e.item.text)}}else this.createLinkNode(e)}else{var l=n,d="";if(t.isNullOrUndefined(e.item.url)||l.setAttribute("href",e.item.url),t.isNullOrUndefined(e.item.title)||l.setAttribute("title",e.item.title),t.isNullOrUndefined(e.item.text)||""===e.item.text||(d=l.innerText,l.innerText=e.item.text),t.isNullOrUndefined(e.item.target)?l.removeAttribute("target"):l.setAttribute("target",e.item.target),d===e.item.text)e.item.selection.setSelectionText(this.parent.currentDocument,l,l,1,1),e.item.selection.restore();else{var c="Paste"===e.item.action?l.childNodes[0].textContent.length:0;e.item.selection.setSelectionText(this.parent.currentDocument,l.childNodes[0],l.childNodes[0],c,l.childNodes[0].textContent.length)}}e.callBack&&e.callBack({requestType:"Links",editorMode:"HTML",event:e.event,range:this.parent.nodeSelection.getRange(this.parent.currentDocument),elements:this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)})},e.prototype.createLinkNode=function(e){for(var t,n,i=new uo,r=new vo,o=i.getRange(this.parent.currentDocument),s=this.getSelectionNodes(i.getNodeCollection(o)),a=i.save(o,this.parent.currentDocument),l=[],d=[],c=[],p=[],h=[],u=0;u<s.length;u++)s[u]=r.GetSpliceNode(o,s[u]),l[u]=s[u];for(var m=0;m<l.length;m++){var g=!0;for(t=l[m];!0===g;){if("A"===t.parentNode.nodeName){var f=t.parentNode;t.parentNode.parentNode.insertBefore(f.firstChild,f),t.parentNode.removeChild(f)}this.isBlockNode(t.parentNode)||0===l.length||0===m||m===l.length-1||3===o.startContainer.nodeType?(d[m]=t,g=!1):t=t.parentNode}}m=0;for(var b=0;m<d.length;m++)if(0===m&&(h[b]=d[m]),d.length>1&&m<d.length-1){if(d[m].parentElement===d[m+1].parentElement&&d[m]===d[m+1])continue;h[b+1]=d[m+1],b++}var v=0;p[v]=this.createAchorNode(e);for(m=0;m<h.length;m++)if(0===m&&(n=h[m].cloneNode(!0),p[m].appendChild(n)),m<h.length-1)if(h[m].parentNode===h[m+1].parentNode){var y=h[m+1].cloneNode(!0);p[v].appendChild(y)}else p[v+=1]=this.createAchorNode(e),n=h[m+1].cloneNode(!0),p[v].appendChild(n);this.parent.nodeSelection.setRange(document,a.range);m=0;for(var C=0,S=0;m<=h.length;m++)0===m&&(h[m].parentNode.insertBefore(p[C],h[m].nextSibling),1===this.parent.domNode.blockNodes().length&&this.parent.nodeSelection.setSelectionNode(this.parent.currentDocument,p[C]),c[S]=h[m],S++),m<h.length-1&&(h[m].parentNode===h[m+1].parentNode?(c[S]=h[m+1],S++):(C+=1,h[m+1].parentNode.insertBefore(p[C],h[m+1]),c[S]=h[m+1],S++));for(m=0;m<c.length;m++)c[m].parentNode&&c[m].parentNode.removeChild(c[m])},e.prototype.createAchorNode=function(e){var n=t.createElement("a",{className:"e-rte-anchor",attrs:{href:e.item.url,title:t.isNullOrUndefined(e.item.title)||""===e.item.title?e.item.url:e.item.title}});return t.isNullOrUndefined(e.item.target)||n.setAttribute("target",e.item.target),n},e.prototype.getSelectionNodes=function(e){e=e.reverse();for(var t=0;t<e.length;t++)3===e[t].nodeType&&""!==e[t].textContent.trim()||"IMG"!==e[t].nodeName&&(e.splice(t,1),t--);return e.reverse()},e.prototype.isBlockNode=function(e){return!!e&&e.nodeType===Node.ELEMENT_NODE&&oo.indexOf(e.tagName.toLowerCase())>=0},e.prototype.removeText=function(e,t){for(var n=e.split(" "),i=0;i<n.length;i++)n[i]===t&&(n.splice(i,1),i--);return n.join(" ")+" "},e.prototype.openLink=function(e){document.defaultView.open(e.item.url,e.item.target),this.callBack(e)},e.prototype.removeLink=function(e){var n=this.parent.domNode.blockNodes();if(n.length<2){this.parent.domNode.setMarker(e.item.selection);for(var i=t.closest(e.item.selectParent[0],"a"),r=i||e.item.selectParent[0],o=r.parentNode,s=[];r.firstChild;null)s.push(o.insertBefore(r.firstChild,r));o.removeChild(r),s&&1===s.length&&(e.item.selection.startContainer=e.item.selection.getNodeArray(s[s.length-1],!0),e.item.selection.endContainer=e.item.selection.startContainer),e.item.selection=this.parent.domNode.saveMarker(e.item.selection)}else for(var a=0;a<n.length;a++)for(var l=n[a].querySelectorAll("a"),d=0;d<l.length;d++)document.getSelection().containsNode(l[d],!0)&&(l[d].outerHTML=l[d].innerHTML);e.item.selection.restore(),this.callBack(e)},e.prototype.callBack=function(e){e.callBack&&e.callBack({requestType:e.item.subCommand,editorMode:"HTML",event:e.event,range:this.parent.nodeSelection.getRange(this.parent.currentDocument),elements:this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)})},e}(),No=function(){function e(e){this.alignments={JustifyLeft:"left",JustifyCenter:"center",JustifyRight:"right",JustifyFull:"justify"},this.parent=e,this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.observer.on(io,this.applyAlignment,this),this.parent.observer.on(hr,this.onKeyDown,this)},e.prototype.onKeyDown=function(e){switch(e.event.action){case"justify-center":this.applyAlignment({subCommand:"JustifyCenter",callBack:e.callBack}),e.event.preventDefault();break;case"justify-full":this.applyAlignment({subCommand:"JustifyFull",callBack:e.callBack}),e.event.preventDefault();break;case"justify-left":this.applyAlignment({subCommand:"JustifyLeft",callBack:e.callBack}),e.event.preventDefault();break;case"justify-right":this.applyAlignment({subCommand:"JustifyRight",callBack:e.callBack}),e.event.preventDefault()}},e.prototype.getTableNode=function(e){var n=e.startContainer.nodeType===Node.ELEMENT_NODE?e.startContainer:e.startContainer.parentNode;return[t.closest(n,"td,th")]},e.prototype.applyAlignment=function(e){var n="Table"===e.value,i=this.parent.nodeSelection.getRange(this.parent.currentDocument),r=this.parent.nodeSelection.save(i,this.parent.currentDocument);if(n)t.setStyleAttribute(this.getTableNode(i)[0],{"text-align":this.alignments[e.subCommand]});else{this.parent.domNode.setMarker(r);for(var o=this.parent.domNode.blockNodes(),s=0;s<o.length;s++){var a=o[s];t.setStyleAttribute(a,{"text-align":this.alignments[e.subCommand]})}var l=this.parent.domNode.getImageTagInSelection();for(s=0;s<l.length;s++){var d=[];d.push(l[s]),this.parent.imgObj.imageCommand({item:{selectNode:d},subCommand:e.subCommand,value:e.subCommand,callBack:e.callBack,selector:e.selector})}this.parent.editableElement.focus(),r=this.parent.domNode.saveMarker(r),I()&&B(this.parent.editableElement,e.selector),r.restore()}e.callBack&&e.callBack({requestType:e.subCommand,editorMode:"HTML",event:e.event,range:this.parent.nodeSelection.getRange(this.parent.currentDocument),elements:n?this.getTableNode(i):this.parent.domNode.blockNodes()})},e}(),Eo=function(){function e(e){this.indentValue=20,this.parent=e,this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.observer.on(ro,this.applyIndents,this),this.parent.observer.on(hr,this.onKeyDown,this)},e.prototype.onKeyDown=function(e){switch(e.event.action){case"indents":this.applyIndents({subCommand:"Indent",callBack:e.callBack}),e.event.preventDefault();break;case"outdents":this.applyIndents({subCommand:"Outdent",callBack:e.callBack}),e.event.preventDefault()}},e.prototype.applyIndents=function(e){var t=this.parent.editableElement,n=t.classList.contains("e-rtl"),i=this.parent.nodeSelection.getRange(this.parent.currentDocument),r=this.parent.nodeSelection.save(i,this.parent.currentDocument);this.parent.domNode.setMarker(r);for(var o=this.parent.domNode.blockNodes(),s=o.slice(),a=[],l=0;l<s.length;l++)"LI"!==s[l].tagName&&"LI"===s[l].parentNode.tagName?(o.splice(o.indexOf(s[l]),1),a.push(s[l].parentNode)):"LI"===s[l].tagName&&(o.splice(o.indexOf(s[l]),1),a.push(s[l]));a.length>0&&this.parent.observer.notify(hr,{event:{preventDefault:function(){},stopPropagation:function(){},shiftKey:"Indent"!==e.subCommand,which:9,action:"indent"},ignoreDefault:!0});for(l=0;l<o.length;l++){var d=o[l],c=n?d.style.marginRight:d.style.marginLeft,p=void 0;"Indent"===e.subCommand?(p=""===c?this.indentValue+"px":parseInt(c,null)+this.indentValue+"px",n?d.style.marginRight=p:d.style.marginLeft=p):(p=""===c||"0px"===c?"":parseInt(c,null)-this.indentValue+"px",n?d.style.marginRight=p:d.style.marginLeft=p)}t.focus(),I()&&B(t,e.selector),(r=this.parent.domNode.saveMarker(r)).restore(),e.callBack&&e.callBack({requestType:e.subCommand,editorMode:"HTML",event:e.event,range:this.parent.nodeSelection.getRange(this.parent.currentDocument),elements:this.parent.domNode.blockNodes()})},e}(),To="e-imgright",wo="e-imgleft",ko="e-imgcenter",Lo="e-imgbreak",Oo="e-img-caption",xo="e-caption-inline",Do=function(){function e(e){this.parent=e,this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.observer.on(Qr,this.imageCommand,this)},e.prototype.imageCommand=function(e){switch(e.value.toString().toLowerCase()){case"image":case"replace":this.createImage(e);break;case"insertlink":this.insertImageLink(e);break;case"openimagelink":this.openImageLink(e);break;case"editimagelink":this.editImageLink(e);break;case"removeimagelink":this.removeImageLink(e);break;case"remove":this.removeImage(e);break;case"alttext":this.insertAltTextImage(e);break;case"dimension":this.imageDimension(e);break;case"caption":this.imageCaption(e);break;case"justifyleft":this.imageJustifyLeft(e);break;case"justifycenter":this.imageJustifyCenter(e);break;case"justifyright":this.imageJustifyRight(e);break;case"inline":this.imageInline(e);break;case"break":this.imageBreak(e)}},e.prototype.createImage=function(e){var n=this,i=!1;if(e.item.url=t.isNullOrUndefined(e.item.url)||"undefined"===e.item.url?e.item.src:e.item.url,t.isNullOrUndefined(e.item.selectParent)||"IMG"!==e.item.selectParent[0].tagName){var r=t.createElement("img");this.setStyle(r,e),t.isNullOrUndefined(e.item.selection)||e.item.selection.restore(),t.isNullOrUndefined(e.selector)||"pasteCleanupModule"!==e.selector?Co.Insert(this.parent.currentDocument,r,this.parent.editableElement):e.callBack({requestType:"Images",editorMode:"HTML",event:e.event,range:this.parent.nodeSelection.getRange(this.parent.currentDocument),elements:[r]})}else{var o=e.item.selectParent[0];this.setStyle(o,e),i=!0}if(e.callBack&&(t.isNullOrUndefined(e.selector)||!t.isNullOrUndefined(e.selector)&&"pasteCleanupModule"!==e.selector)){var s=this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)[0],a="Replace"===e.value||i?e.item.selectParent[0]:t.Browser.isIE?s.previousSibling:s.previousElementSibling;a.addEventListener("load",function(){"Replace"===e.value&&i||e.callBack({requestType:"Images",editorMode:"HTML",event:e.event,range:n.parent.nodeSelection.getRange(n.parent.currentDocument),elements:[a]})})}},e.prototype.setStyle=function(e,n){t.isNullOrUndefined(n.item.url)||e.setAttribute("src",n.item.url),e.setAttribute("class","e-rte-image"+(t.isNullOrUndefined(n.item.cssClass)?"":" "+n.item.cssClass)),t.isNullOrUndefined(n.item.altText)||e.setAttribute("alt",n.item.altText),t.isNullOrUndefined(n.item.width)||t.isNullOrUndefined(n.item.width.width)||e.setAttribute("width",this.calculateStyleValue(n.item.width.width)),t.isNullOrUndefined(n.item.height)||t.isNullOrUndefined(n.item.height.height)||e.setAttribute("height",this.calculateStyleValue(n.item.height.height)),t.isNullOrUndefined(n.item.width)||t.isNullOrUndefined(n.item.width.minWidth)||(e.style.minWidth=this.calculateStyleValue(n.item.width.minWidth)),t.isNullOrUndefined(n.item.width)||t.isNullOrUndefined(n.item.width.maxWidth)||(e.style.maxWidth=this.calculateStyleValue(n.item.width.maxWidth)),t.isNullOrUndefined(n.item.height)||t.isNullOrUndefined(n.item.height.minHeight)||(e.style.minHeight=this.calculateStyleValue(n.item.height.minHeight)),t.isNullOrUndefined(n.item.height)||t.isNullOrUndefined(n.item.height.maxHeight)||(e.style.maxHeight=this.calculateStyleValue(n.item.height.maxHeight))},e.prototype.calculateStyleValue=function(e){return"string"==typeof e&&(e.indexOf("px")||e.indexOf("%")||e.indexOf("auto"))?e:e+"px"},e.prototype.insertImageLink=function(e){var n=t.createElement("a",{attrs:{href:e.item.url}});e.item.selectNode[0].parentElement.classList.contains("e-img-wrap")&&(e.item.selection.restore(),n.setAttribute("contenteditable","true")),n.appendChild(e.item.selectNode[0]),t.isNullOrUndefined(e.item.target)||n.setAttribute("target",e.item.target),Co.Insert(this.parent.currentDocument,n,this.parent.editableElement),this.callBack(e)},e.prototype.openImageLink=function(e){document.defaultView.open(e.item.url,e.item.target),this.callBack(e)},e.prototype.removeImageLink=function(e){var n=e.item.selectParent[0];if(n.classList.contains("e-img-caption")){var i=t.select(".e-img-wrap",n),r=t.select(".e-img-inner",n),o=r.cloneNode(!0);t.detach(t.select("a",n)),t.detach(r),i.appendChild(e.item.insertElement),i.appendChild(o)}else t.detach(n),t.Browser.isIE&&e.item.selection.restore(),Co.Insert(this.parent.currentDocument,e.item.insertElement,this.parent.editableElement);this.callBack(e)},e.prototype.editImageLink=function(e){e.item.selectNode[0].parentElement.href=e.item.url,t.isNullOrUndefined(e.item.target)?e.item.selectNode[0].parentElement.removeAttribute("target"):e.item.selectNode[0].parentElement.target=e.item.target,this.callBack(e)},e.prototype.removeImage=function(e){t.closest(e.item.selectNode[0],"a")&&("A"!==e.item.selectNode[0].parentElement.nodeName||t.isNullOrUndefined(e.item.selectNode[0].parentElement.innerText))?t.detach(t.closest(e.item.selectNode[0],"a")):t.isNullOrUndefined(t.closest(e.item.selectNode[0],"."+Oo))?t.detach(e.item.selectNode[0]):t.detach(t.closest(e.item.selectNode[0],"."+Oo)),this.callBack(e)},e.prototype.insertAltTextImage=function(e){e.item.selectNode[0].setAttribute("alt",e.item.altText),this.callBack(e)},e.prototype.imageDimension=function(e){var n=e.item.selectNode[0];n.style.height="",n.style.width="","auto"!==e.item.width?n.style.width=t.formatUnit(e.item.width):n.removeAttribute("width"),"auto"!==e.item.height?n.style.height=t.formatUnit(e.item.height):n.removeAttribute("height"),this.callBack(e)},e.prototype.imageCaption=function(e){Co.Insert(this.parent.currentDocument,e.item.insertElement,this.parent.editableElement),this.callBack(e)},e.prototype.imageJustifyLeft=function(e){var n=e.item.selectNode[0];t.isNullOrUndefined(n)||(n.removeAttribute("class"),t.addClass([n],"e-rte-image"),t.isNullOrUndefined(t.closest(n,"."+Oo))||(t.removeClass([t.closest(n,"."+Oo)],To),t.addClass([t.closest(n,"."+Oo)],wo)),"A"===n.parentElement.nodeName?(t.removeClass([n.parentElement],To),t.addClass([n.parentElement],wo),t.addClass([n],wo)):t.addClass([n],wo),this.callBack(e))},e.prototype.imageJustifyCenter=function(e){var n=e.item.selectNode[0];t.isNullOrUndefined(n)||(n.removeAttribute("class"),t.addClass([n],"e-rte-image"),t.isNullOrUndefined(t.closest(n,"."+Oo))||(t.removeClass([t.closest(n,"."+Oo)],wo),t.removeClass([t.closest(n,"."+Oo)],To),t.addClass([t.closest(n,"."+Oo)],ko)),"A"===n.parentElement.nodeName?(t.removeClass([n.parentElement],wo),t.removeClass([n.parentElement],To),t.addClass([n.parentElement],ko),t.addClass([n],ko)):t.addClass([n],ko),this.callBack(e))},e.prototype.imageJustifyRight=function(e){var n=e.item.selectNode[0];t.isNullOrUndefined(n)||(n.removeAttribute("class"),t.addClass([n],"e-rte-image"),t.isNullOrUndefined(t.closest(n,"."+Oo))||(t.removeClass([t.closest(n,"."+Oo)],wo),t.addClass([t.closest(n,"."+Oo)],To)),"A"===n.parentElement.nodeName?(t.removeClass([n.parentElement],wo),t.addClass([n.parentElement],To),t.addClass([n],To)):t.addClass([n],To),this.callBack(e))},e.prototype.imageInline=function(e){var n=e.item.selectNode[0];n.removeAttribute("class"),t.addClass([n],"e-rte-image"),t.addClass([n],"e-imginline"),t.isNullOrUndefined(t.closest(n,"."+Oo))||(t.removeClass([t.closest(n,"."+Oo)],Lo),t.removeClass([t.closest(n,"."+Oo)],ko),t.removeClass([t.closest(n,"."+Oo)],wo),t.removeClass([t.closest(n,"."+Oo)],To),t.addClass([t.closest(n,"."+Oo)],xo)),this.callBack(e)},e.prototype.imageBreak=function(e){var n=e.item.selectNode[0];n.removeAttribute("class"),t.addClass([n],Lo),t.addClass([n],"e-rte-image"),t.isNullOrUndefined(t.closest(n,"."+Oo))||(t.removeClass([t.closest(n,"."+Oo)],xo),t.removeClass([t.closest(n,"."+Oo)],ko),t.removeClass([t.closest(n,"."+Oo)],wo),t.removeClass([t.closest(n,"."+Oo)],To),t.addClass([t.closest(n,"."+Oo)],Lo)),this.callBack(e)},e.prototype.callBack=function(e){e.callBack&&e.callBack({requestType:e.item.subCommand,editorMode:"HTML",event:e.event,range:this.parent.nodeSelection.getRange(this.parent.currentDocument),elements:this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)})},e}(),Mo=function(){function e(e){this.parent=e,this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.observer.on(Vr,this.createTable,this),this.parent.observer.on(Kr,this.insertRow,this),this.parent.observer.on(Gr,this.insertColumn,this),this.parent.observer.on(Xr,this.deleteRow,this),this.parent.observer.on(Yr,this.deleteColumn,this),this.parent.observer.on(Jr,this.removeTable,this),this.parent.observer.on($r,this.tableHeader,this),this.parent.observer.on(Zr,this.tableVerticalAlign,this),this.parent.observer.on(eo,this.cellMerge,this),this.parent.observer.on(no,this.HorizontalSplit,this),this.parent.observer.on(to,this.VerticalSplit,this),this.parent.observer.on("TABLE_MOVE",this.tableMove,this)},e.prototype.createTable=function(e){var n=t.createElement("table",{className:"e-rte-table"}),i=t.createElement("tbody");t.isNullOrUndefined(e.item.width.width)||(n.style.width=this.calculateStyleValue(e.item.width.width)),t.isNullOrUndefined(e.item.width.minWidth)||(n.style.minWidth=this.calculateStyleValue(e.item.width.minWidth)),t.isNullOrUndefined(e.item.width.maxWidth)||(n.style.maxWidth=this.calculateStyleValue(e.item.width.maxWidth));for(var r=parseInt(e.item.width.width,10)>100?100/e.item.columns:parseInt(e.item.width.width,10)/e.item.columns,o=0;o<e.item.rows;o++){for(var s=t.createElement("tr"),a=0;a<e.item.columns;a++){var l=t.createElement("td");l.appendChild(t.createElement("br")),l.style.width=r+"%",s.appendChild(l)}i.appendChild(s)}if(n.appendChild(i),e.item.selection.restore(),Co.Insert(this.parent.currentDocument,n,this.parent.editableElement),this.removeEmptyNode(),e.item.selection.setSelectionText(this.parent.currentDocument,n.querySelector("td"),n.querySelector("td"),0,0),null===n.nextElementSibling){var d=void 0;"DIV"===e.enterAction?(d=t.createElement("div")).appendChild(t.createElement("br")):"BR"===e.enterAction?d=t.createElement("br"):(d=t.createElement("p")).appendChild(t.createElement("br")),this.insertAfter(d,n)}return n.querySelector("td").classList.add("e-cell-select"),e.callBack&&e.callBack({requestType:"Table",editorMode:"HTML",event:e.event,range:this.parent.nodeSelection.getRange(this.parent.currentDocument),elements:[n]}),n},e.prototype.calculateStyleValue=function(e){return"string"==typeof e&&(e.indexOf("px")||e.indexOf("%")||e.indexOf("auto"))?e:e+"px"},e.prototype.removeEmptyNode=function(){for(var e=this.parent.editableElement.querySelectorAll("ul:empty, ol:empty"),n=0;n<e.length;n++)t.detach(e[n]);var i=this.parent.editableElement.querySelectorAll("li *:empty");for(n=0;n<i.length;n++)t.detach(i[n]),i.length===n+1&&(i=this.parent.editableElement.querySelectorAll("li *:empty"),n=-1);var r=this.parent.editableElement.querySelectorAll("li:empty");for(n=0;n<r.length;n++)t.detach(r[n])},e.prototype.insertAfter=function(e,t){t.parentNode.insertBefore(e,t.nextSibling)},e.prototype.getSelectedCellMinMaxIndex=function(e){for(var t=this.curTable.querySelectorAll(".e-cell-select"),n=0,i=e.length,r=0,o=e[0].length,s=0;n<t.length;n++){var a=this.getCorrespondingIndex(t[n],e),l=this.FindIndex(a[0],a[1],e);i=Math.min(a[0],i),r=Math.max(l[0],r),o=Math.min(a[1],o),s=Math.max(l[1],s)}return{startRow:i,endRow:r,startColumn:o,endColumn:s}},e.prototype.insertRow=function(e){var n="InsertRowBefore"!==e.item.subCommand,i=e.item.selection.range.startContainer;if("TH"!==i.nodeName&&"TD"!==i.nodeName&&(i=t.closest(i.parentElement,"td,th")),"th"!==i.nodeName.toLowerCase()||"InsertRowBefore"!==e.item.subCommand){if(this.curTable=t.closest(this.parent.nodeSelection.range.startContainer.parentElement,"table"),0===this.curTable.querySelectorAll(".e-cell-select").length){var r=this.curTable.rows[this.curTable.rows.length-1],o=r.cloneNode(!0);o.removeAttribute("rowspan"),this.insertAfter(o,r)}else{for(var s=this.getCorrespondingColumns(),a=this.getSelectedCellMinMaxIndex(s),l=n?a.endRow:a.startRow,d=t.createElement("tr"),c=this.curTable.querySelectorAll("th.e-cell-select").length>0,p=0;p<s[l].length;p++)if(n&&l<s.length-1&&s[l][p]===s[l+1][p]||!n&&0<l&&s[l][p]===s[l-1][p])(0===p||0<p&&s[l][p]!==s[l][p-1])&&s[l][p].setAttribute("rowspan",(parseInt(s[l][p].getAttribute("rowspan"),10)+1).toString());else{var h=t.createElement("td");h.appendChild(t.createElement("br")),d.appendChild(h),h.setAttribute("style",s[c&&n?l+1:l][p].getAttribute("style"))}var u=void 0;u=c&&n?this.curTable.querySelector("tbody").childNodes[0]:this.curTable.rows[l],"InsertRowBefore"===e.item.subCommand?u.parentElement.insertBefore(d,u):c?u.parentElement.insertBefore(d,u):this.insertAfter(d,u)}e.item.selection.setSelectionText(this.parent.currentDocument,e.item.selection.range.startContainer,e.item.selection.range.startContainer,0,0),e.callBack&&e.callBack({requestType:e.item.subCommand,editorMode:"HTML",event:e.event,range:this.parent.nodeSelection.getRange(this.parent.currentDocument),elements:this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)})}},e.prototype.insertColumn=function(e){var n=e.item.selection.range.startContainer;"TH"!==n.nodeName&&"TD"!==n.nodeName&&(n=t.closest(n.parentElement,"td,th"));for(var i,r=t.closest(n,"tr"),o=t.closest(r,"table").rows,s=Array.prototype.slice.call(r.querySelectorAll(":scope > td, :scope > th")).indexOf(n),a=parseInt(e.item.width,10)/r.querySelectorAll(":scope > td, :scope > th").length,l=parseInt(e.item.width,10)/(r.querySelectorAll(":scope > td, :scope > th").length+1),d=t.closest(r,"table"),c=t.closest(r,"table").querySelectorAll("th,td"),p=0;p<c.length;p++)c[p].dataset.oldWidth=c[p].offsetWidth/d.offsetWidth*100+"%";for(p=0;p<o.length;p++){var h=(i=o[p].querySelectorAll(":scope > td, :scope > th")[s]).cloneNode(!0);h.innerHTML="",h.appendChild(t.createElement("br")),h.removeAttribute("class"),h.removeAttribute("colspan"),h.removeAttribute("rowspan"),"InsertColumnLeft"===e.item.subCommand?i.parentElement.insertBefore(h,i):this.insertAfter(h,i),h.style.width=l.toFixed(4)+"%",delete h.dataset.oldWidth}for(p=0;p<c.length;p++)c[p].style.width=(Number(c[p].dataset.oldWidth.split("%")[0])*l/a).toFixed(4)+"%",delete c[p].dataset.oldWidth;e.item.selection.setSelectionText(this.parent.currentDocument,n,n,0,0),e.callBack&&e.callBack({requestType:e.item.subCommand,editorMode:"HTML",event:e.event,range:this.parent.nodeSelection.getRange(this.parent.currentDocument),elements:this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)})},e.prototype.deleteColumn=function(e){var n=e.item.selection.range.startContainer;3===n.nodeType&&(n=t.closest(n.parentElement,"td,th"));var i=t.closest(n,"TH"===n.tagName?"thead":"tbody"),r=i&&Array.prototype.indexOf.call(i.childNodes,n.parentNode);this.curTable=t.closest(n,"table");if(1===t.closest(n,"tr").querySelectorAll("th,td").length)e.item.selection.restore(),t.detach(t.closest(n.parentElement,"table"));else{for(var o=void 0,s=this.getCorrespondingColumns(),a=this.getSelectedCellMinMaxIndex(s),l=a.startColumn,d=a.endColumn,c=0;c<s.length;c++)for(var p=s[c],h=0;h<p.length;h++){var u=p[h],m=this.getCorrespondingIndex(u,s),g=parseInt(u.getAttribute("colspan"),10)||1;m[1]+(g-1)>=l&&m[1]<=d&&(g>1?u.setAttribute("colspan",(g-1).toString()):(t.detach(u),o=h,t.Browser.isIE&&(e.item.selection.setSelectionText(this.parent.currentDocument,this.curTable.querySelector("td"),this.curTable.querySelector("td"),0,0),this.curTable.querySelector("td, th").classList.add("e-cell-select"))))}if(o>-1){var f=i.children[r],b=f&&f.children[o<=f.children.length-1?o:o-1];b&&(e.item.selection.setSelectionText(this.parent.currentDocument,b,b,0,0),b.classList.add("e-cell-select"))}}if(e.callBack){var v=this.parent.nodeSelection.getRange(this.parent.currentDocument).startContainer;if("TD"!==v.nodeName){var y=this.parent.nodeSelection.getRange(this.parent.currentDocument).startOffset,C=v.children[y];C&&this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument,C,0)}e.callBack({requestType:e.item.subCommand,editorMode:"HTML",event:e.event,range:this.parent.nodeSelection.getRange(this.parent.currentDocument),elements:this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)})}},e.prototype.deleteRow=function(e){var n=e.item.selection.range.startContainer;3===n.nodeType&&(n=t.closest(n.parentElement,"td,th"));var i=Array.prototype.indexOf.call(n.parentNode.childNodes,n);this.curTable=t.closest(n,"table");var r,o,s,a=this.getCorrespondingColumns(),l=this.getSelectedCellMinMaxIndex(a);if(1===this.curTable.rows.length)e.item.selection.restore(),t.detach(t.closest(n.parentElement,"table"));else for(o=l.endRow;o>=l.startRow;o--){for(r=this.curTable.rows[o],s=0;s<a[o].length;s++){if((0===s||a[o][s]!==a[o][s-1])&&1<parseInt(a[o][s].getAttribute("rowspan"),10)){var d=parseInt(a[o][s].getAttribute("rowspan"),10)-1;1===d?a[o][s].removeAttribute("rowspan"):a[o][s].setAttribute("rowspan",d.toString())}if(o<a.length-1&&a[o][s]===a[o+1][s]&&(0===o||a[o][s]!==a[o-1][s])){var c=a[o][s],p=void 0;for(p=s;0<p&&a[o][p]===a[o][p-1];p--)0===p?this.curTable.rows[o+1].prepend(c):a[o+1][p-1].insertAdjacentElement("afterend",c)}}var h=r.rowIndex;this.curTable.deleteRow(h);var u=t.isNullOrUndefined(this.curTable.rows[h])?this.curTable.querySelectorAll("tbody tr")[h-1]:this.curTable.querySelectorAll("tbody tr")[h],m=u&&u.querySelectorAll("td")[i];m?(e.item.selection.setSelectionText(this.parent.currentDocument,m,m,0,0),m.classList.add("e-cell-select")):(e.item.selection.setSelectionText(this.parent.currentDocument,this.curTable.querySelector("td"),this.curTable.querySelector("td"),0,0),this.curTable.querySelector("td, th").classList.add("e-cell-select"))}e.callBack&&e.callBack({requestType:e.item.subCommand,editorMode:"HTML",event:e.event,range:this.parent.nodeSelection.getRange(this.parent.currentDocument),elements:this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)})},e.prototype.removeTable=function(e){var n=e.item.selection.range.startContainer;n=3===n.nodeType?n.parentNode:n;var i=t.closest(n.parentElement,"table");i&&(e.item.selection.restore(),t.detach(i)),e.callBack&&e.callBack({requestType:e.item.subCommand,editorMode:"HTML",event:e.event,range:this.parent.nodeSelection.getRange(this.parent.currentDocument),elements:this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)})},e.prototype.tableHeader=function(e){var n=!1,i=e.item.selection.range.startContainer;i=3===i.nodeType?i.parentNode:i;var r=t.closest(i.parentElement,"table");if([].slice.call(r.childNodes).forEach(function(e){"THEAD"===e.nodeName&&(n=!0)}),r&&!n){for(var o=r.querySelector("tr").childElementCount,s=0,a=0;a<o;a++)s+=parseInt(r.querySelector("tr").children[a].getAttribute("colspan"),10)||1;for(var l=r.createTHead().insertRow(0),d=0;d<s;d++){var c=t.createElement("th");c.appendChild(t.createElement("br")),l.appendChild(c)}}else r.deleteTHead();e.callBack&&e.callBack({requestType:e.item.subCommand,editorMode:"HTML",event:e.event,range:this.parent.nodeSelection.getRange(this.parent.currentDocument),elements:this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)})},e.prototype.tableVerticalAlign=function(e){"AlignTop"===e.item.subCommand?e.item.tableCell.style.verticalAlign="top":"AlignMiddle"===e.item.subCommand?e.item.tableCell.style.verticalAlign="middle":e.item.tableCell.style.verticalAlign="bottom",e.callBack&&e.callBack({requestType:e.item.subCommand,editorMode:"HTML",event:e.event,range:this.parent.nodeSelection.getRange(this.parent.currentDocument),elements:this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)})},e.prototype.cellMerge=function(e){t.isNullOrUndefined(this.curTable)&&(this.curTable=t.closest(this.parent.nodeSelection.range.startContainer.parentElement,"table"));var n=this.curTable.querySelectorAll(".e-cell-select");if(!(n.length<2)){this.mergeCellContent();var i=this.getSelectedMinMaxIndexes(this.getCorrespondingColumns()),r=n[0],o=r.parentElement.querySelectorAll(".e-cell-select");i.startColumn<i.endColumn&&r.setAttribute("colspan",(i.endColumn-i.startColumn+1).toString()),i.startRow<i.endRow&&r.setAttribute("rowspan",(i.endRow-i.startRow+1).toString());for(var s=0,a=o.length-1;a>=0;a--)s+=parseFloat(o[a].style.width);r.style.width=s+"%";for(var l=1;l<=n.length-1;l++)t.detach(n[l]);for(l=0;l<this.curTable.rows.length;l++)""===this.curTable.rows[l].innerHTML&&t.detach(this.curTable.rows[l]);this.updateRowSpanStyle(i.startRow,i.endRow,this.getCorrespondingColumns()),this.updateColSpanStyle(i.startColumn,i.endColumn,this.getCorrespondingColumns()),e.item.selection.setSelectionText(this.parent.currentDocument,e.item.selection.range.startContainer,e.item.selection.range.startContainer,0,0),this.parent.nodeSelection.range&&this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument,this.parent.nodeSelection.range.endContainer,0),e.callBack&&e.callBack({requestType:e.item.subCommand,editorMode:"HTML",event:e.event,range:this.parent.nodeSelection.getRange(this.parent.currentDocument),elements:this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)})}},e.prototype.updateColSpanStyle=function(e,t,n){var i,r,o,s,a=0,l=0,d=n;if(e<(t=Math.min(t,d[0].length-1))){for(;r<=t;r++)if(!(e<r&&d[0][r]===d[0][r-1])&&1<(a=Math.min(parseInt(d[0][r].getAttribute("colspan"),10)||1,t-e+1))&&d[0][r]===d[0][r+1])for(l=a-1,i=1;i<d.length;i++){if(d[i][r]!==d[i-1][r])for(o=r;o<r+a;o++)if(1<(s=parseInt(d[i][o].getAttribute("colspan"),10)||1)&&d[i][o]===d[i][o+1])o+=l=Math.min(l,s-1);else if(!(l=Math.max(0,l-1)))break;if(!l)break}l&&this.updateCellAttribute(d,l,"colspan",0,d.length-1,e,t)}},e.prototype.updateRowSpanStyle=function(e,t,n){var i,r,o,s,a=0,l=0,d=n;if(e<(t=Math.min(t,d.length-1))){for(i=e;i<=t;i++)if(!(e<i&&d[i][0]===d[i-1][0])&&1<(a=Math.min(parseInt(d[i][0].getAttribute("rowspan"),10)||1,t-e+1))&&d[i][0]===d[i+1][0])for(l=a-1,r=1;r<d[0].length;r++)if(d[i][r]!==d[i][r-1]){for(o=i;o<i+a;o++)if(1<(s=parseInt(d[o][r].getAttribute("rowspan"),10)||1)&&d[o][r]===d[o+1][r])o+=l=Math.min(l,s-1);else if(!(l=Math.max(0,l-1)))break;if(!l)break}l&&this.updateCellAttribute(d,l,"rowspan",e,t,0,d[0].length-1)}},e.prototype.updateCellAttribute=function(e,t,n,i,r,o,s){var a,l,d;for(a=i;a<=r;a++)for(l=o;l<=s;l++)i<a&&e[a][l]===e[a-1][l]||o<l&&e[a][l]===e[a][l-1]||1<(d=parseInt(e[a][l].getAttribute(n),10)||1)&&(1<d-t?e[a][l].setAttribute(n,(d-t).toString()):e[a][l].removeAttribute(n))},e.prototype.mergeCellContent=function(){for(var e=this.curTable.querySelectorAll(".e-cell-select"),t=e[0].innerHTML,n=1;n<e.length-1;n++)"<br>"!==e[n].innerHTML&&(t+=e[n].innerHTML);e[0].innerHTML=t},e.prototype.getSelectedMinMaxIndexes=function(e){var t=this.curTable.querySelectorAll(".e-cell-select");if(0<t.length){for(var n=e.length,i=0,r=e[0].length,o=0,s=0;s<t.length;s++){var a=this.getCorrespondingIndex(t[s],e),l=this.FindIndex(a[0],a[1],e);n=Math.min(a[0],n),i=Math.max(l[0],i),r=Math.min(a[1],r),o=Math.max(l[1],o)}return{startRow:n,endRow:i,startColumn:r,endColumn:o}}return null},e.prototype.HorizontalSplit=function(e){var n=e.item.selection.range.startContainer;if(this.curTable=t.closest(n.parentElement,"table"),!(this.curTable.querySelectorAll(".e-cell-select").length>1)){this.activeCell=this.curTable.querySelector(".e-cell-select");var i=this.activeCell.cloneNode(!0);i.removeAttribute("class"),i.innerHTML="</br>";var r=this.getCorrespondingIndex(this.activeCell,this.getCorrespondingColumns()),o=this.getCorrespondingColumns(),s=this.activeCell.getAttribute("rowspan")?parseInt(this.activeCell.getAttribute("rowspan"),10):1;if(s>1){var a=Math.ceil(s/2);1<a?this.activeCell.setAttribute("rowspan",a.toString()):this.activeCell.removeAttribute("rowspan"),1<s-a?i.setAttribute("rowspan",(s-a).toString()):i.removeAttribute("rowspan");var l=void 0,d=void 0;for(l=r[0]+Math.ceil(s/2),d=0===r[1]?r[1]:r[1]-1;0<=d&&(o[l][d]===o[l][d-1]||0<l&&o[l][d]===o[l-1][d]);)d--;-1===d?this.curTable.rows[l].firstChild?this.curTable.rows[l].prepend(i):this.curTable.appendChild(i):o[l][d].insertAdjacentElement("afterend",i)}else{var c=t.createElement("tr");c.appendChild(i);for(var p=o[r[0]],h=0;h<=p.length-1;h++)p[h]!==p[h-1]&&p[h]!==this.activeCell&&p[h].setAttribute("rowspan",((parseInt(p[h].getAttribute("rowspan"),10)?parseInt(p[h].getAttribute("rowspan"),10):1)+1).toString());this.activeCell.parentNode.insertAdjacentElement("afterend",c)}e.callBack&&e.callBack({requestType:e.item.subCommand,editorMode:"HTML",event:e.event,range:this.parent.nodeSelection.getRange(this.parent.currentDocument),elements:this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)})}},e.prototype.VerticalSplit=function(e){var n=e.item.selection.range.startContainer;if(this.curTable=t.closest(n.parentElement,"table"),!(this.curTable.querySelectorAll(".e-cell-select").length>1)){this.activeCell=this.curTable.querySelector(".e-cell-select");var i=this.curTable.rows,r=this.activeCell.cloneNode(!0);r.removeAttribute("class"),r.innerHTML="</br>";var o=parseFloat(this.activeCell.style.width)/2;if("TH"===this.activeCell.tagName&&isNaN(o)){for(var s=this.curTable.querySelector("tr").childElementCount,a=0;a<s;a++)parseInt(this.curTable.querySelector("tr").children[a].getAttribute("colspan"),10)||1;o=parseFloat((this.activeCell.offsetWidth/2/this.curTable.offsetWidth*100).toFixed(1))}var l=this.getCorrespondingIndex(this.activeCell,this.getCorrespondingColumns()),d=this.getCorrespondingColumns(),c=parseInt(this.activeCell.getAttribute("colspan"),10);if(c>1)1<Math.ceil(c/2)?this.activeCell.setAttribute("colspan",(c/2).toString()):this.activeCell.removeAttribute("colspan"),1<c-c/2?r.setAttribute("colspan",(c-c/2).toString()):r.removeAttribute("colspan");else for(a=0;a<=i.length-1;a++)if(0===a||d[a][l[1]]!==d[a-1][l[1]]){var p=d[a][l[1]];p!==this.activeCell&&p.setAttribute("colspan",((parseInt(p.getAttribute("colspan"),10)?parseInt(p.getAttribute("colspan"),10):1)+1).toString())}this.activeCell.style.width=o+"%",r.style.width=o+"%",this.activeCell.parentNode.insertBefore(r,this.activeCell.nextSibling),e.callBack&&e.callBack({requestType:e.item.subCommand,editorMode:"HTML",event:e.event,range:this.parent.nodeSelection.getRange(this.parent.currentDocument),elements:this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)})}},e.prototype.getCorrespondingColumns=function(){for(var e=[],t=this.curTable.rows,n=0;n<=t.length-1;n++)for(var i=t[n],r=0,o=0;o<=i.children.length-1;o++){for(var s=i.children[o],a=s,l=parseInt(a.getAttribute("colspan"),10)||1,d=parseInt(a.getAttribute("rowspan"),10)||1,c=n;c<n+d;c++)for(var p=r;p<r+l;p++)e[c]||(e[c]=[]),e[c][p]?r++:e[c][p]=s;r+=0}return e},e.prototype.FindIndex=function(e,t,n){var i,r;for(i=e+1,r=t+1;i<n.length;){if(n[i][t]!==n[e][t]){i--;break}i++}for(i===n.length&&i--;r<n[e].length;){if(n[e][r]!==n[e][t]){r--;break}r++}return r===n[e].length&&r--,[i,r]},e.prototype.getCorrespondingIndex=function(e,t){for(var n=0;n<t.length;n++)for(var i=0;i<t[n].length;i++)if(t[n][i]===e)return[n,i];return[]},e.prototype.highlightCells=function(e,t,n,i,r){var o,s,a,l,d=e,c=t,p=n,h=i,u=new Ro;for(o=d;o<=c;o++){for((1<(parseInt(r[o][p].getAttribute("rowspan"),10)||1)||1<(parseInt(r[o][p].getAttribute("colspan"),10)||1))&&(l=this.FindIndex((a=this.getCorrespondingIndex(r[o][p],r))[0],a[1],r))?(d=Math.min(a[0],d),c=Math.max(l[0],c),p=Math.min(a[1],p),h=Math.max(l[1],h)):(1<(parseInt(r[o][h].getAttribute("rowspan"),10)||1)||1<(parseInt(r[o][h].getAttribute("colspan"),10)||1))&&(l=this.FindIndex((a=this.getCorrespondingIndex(r[o][h],r))[0],a[1],r))&&(d=Math.min(a[0],d),c=Math.max(l[0],c),p=Math.min(a[1],p),h=Math.max(l[1],h)),s=p;s<=h;s++)(1<(parseInt(r[d][s].getAttribute("rowspan"),10)||1)||1<(parseInt(r[d][s].getAttribute("colspan"),10)||1))&&(l=this.FindIndex((a=this.getCorrespondingIndex(r[d][s],r))[0],a[1],r))?(d=Math.min(a[0],d),c=Math.max(l[0],c),p=Math.min(a[1],p),h=Math.max(l[1],h)):(1<(parseInt(r[c][s].getAttribute("rowspan"),10)||1)||1<(parseInt(r[c][s].getAttribute("colspan"),10)||1))&&(l=this.FindIndex((a=this.getCorrespondingIndex(r[c][s],r))[0],a[1],r))&&(d=Math.min(a[0],d),c=Math.max(l[0],c),p=Math.min(a[1],p),h=Math.max(l[1],h));u=d===e&&c===t&&p===n&&h===i?{startRow:e,endRow:t,startColumn:n,endColumn:i}:this.highlightCells(d,c,p,h,r)}return u},e.prototype.tableMove=function(e){this.activeCell=e.selectNode[0];var n=e.event.target,i=this.activeCell.tagName,r=n.tagName;if(this.curTable=t.closest(n,"table"),this.curTable.querySelectorAll(".e-cell-select").length>1&&this.parent.nodeSelection.Clear(this.parent.currentDocument),"TD"===n.tagName||"TH"===n.tagName||i===r){for(var o=Array.prototype.slice.call(this.activeCell.parentElement.parentElement.children).indexOf(this.activeCell.parentElement),s=Array.prototype.slice.call(this.activeCell.parentElement.children).indexOf(this.activeCell),a=Array.prototype.slice.call(n.parentElement.parentElement.children).indexOf(n.parentElement),l=Array.prototype.slice.call(n.parentElement.children).indexOf(n),d=this.curTable.querySelectorAll(".e-cell-select"),c=d.length-1;c>=0;c--)this.activeCell!==d[c]&&d[c].classList.remove("e-cell-select");if(o!==a||s!==l){for(var p=this.getCorrespondingColumns(),h=this.getCorrespondingIndex(this.activeCell,p),u=this.getCorrespondingIndex(n,p),m=this.highlightCells(Math.min(h[0],u[0]),Math.max(h[0],u[0]),Math.min(h[1],u[1]),Math.max(h[1],u[1]),p),g=m.startRow;g<=m.endRow;g++)for(var f=m.startColumn;f<=m.endColumn;f++)p[g][f].classList.add("e-cell-select");this.parent.nodeSelection.range&&(this.parent.nodeSelection.setSelectionText(this.parent.currentDocument,this.parent.nodeSelection.range.endContainer,this.parent.nodeSelection.range.endContainer,0,0),this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument,this.parent.nodeSelection.range.endContainer,0))}}},e}(),Ro=function(){return function(){}}(),Io=function(){function e(){}return e.prototype.getFormattedNode=function(e,t,n){var i=this.getFormatParent(e,t,n);return null!==i&&i!==n?i:null},e.prototype.getFormatParent=function(e,t,n){do{e=e.parentNode}while(e&&e!==n&&!this.isFormattedNode(e,t));return e},e.prototype.isFormattedNode=function(t,n){switch(n){case"bold":return e.isBold(t);case"italic":return e.isItalic(t);case"underline":return e.isUnderline(t);case"strikethrough":return e.isStrikethrough(t);case"superscript":return e.isSuperscript(t);case"subscript":return e.isSubscript(t);case"fontcolor":return this.isFontColor(t);case"fontname":return this.isFontName(t);case"fontsize":return this.isFontSize(t);case"backgroundcolor":return this.isBackgroundColor(t);default:return!1}},e.isBold=function(e){return-1!==["strong","b"].indexOf(e.nodeName.toLowerCase())||!(-1===this.inlineTags.indexOf(e.nodeName.toLowerCase())||!e.style||"bold"!==e.style.fontWeight)},e.isItalic=function(e){return-1!==["em","i"].indexOf(e.nodeName.toLowerCase())||!(-1===this.inlineTags.indexOf(e.nodeName.toLowerCase())||!e.style||"italic"!==e.style.fontStyle)},e.isUnderline=function(e){return-1!==["u"].indexOf(e.nodeName.toLowerCase())||!(-1===this.inlineTags.indexOf(e.nodeName.toLowerCase())||!e.style||"underline"!==e.style.textDecoration)},e.isStrikethrough=function(e){return-1!==["del","strike"].indexOf(e.nodeName.toLowerCase())||!(-1===this.inlineTags.indexOf(e.nodeName.toLowerCase())||!e.style||"line-through"!==e.style.textDecoration)},e.isSuperscript=function(e){return-1!==["sup"].indexOf(e.nodeName.toLowerCase())},e.isSubscript=function(e){return-1!==["sub"].indexOf(e.nodeName.toLowerCase())},e.prototype.isFontColor=function(t){var n=t.style&&t.style.color;return-1!==e.inlineTags.indexOf(t.nodeName.toLowerCase())&&null!==n&&""!==n&&void 0!==n},e.prototype.isBackgroundColor=function(t){var n=t.style&&t.style.backgroundColor;return-1!==e.inlineTags.indexOf(t.nodeName.toLowerCase())&&null!==n&&""!==n&&void 0!==n},e.prototype.isFontSize=function(t){var n=t.style&&t.style.fontSize;return-1!==e.inlineTags.indexOf(t.nodeName.toLowerCase())&&null!==n&&""!==n&&void 0!==n},e.prototype.isFontName=function(t){var n=t.style&&t.style.fontFamily;return-1!==e.inlineTags.indexOf(t.nodeName.toLowerCase())&&null!==n&&""!==n&&void 0!==n},e.inlineTags=["a","abbr","acronym","b","bdo","big","cite","code","dfn","em","i","kbd","label","q","samp","small","span","strong","sub","sup","tt","u","var","del"],e}(),Bo=function(){function e(){}return e.applyFormat=function(e,n,i,r,o,s){this.enterAction=r;if(["bold","italic","underline","strikethrough","superscript","subscript","uppercase","lowercase","fontcolor","fontname","fontsize","backgroundcolor"].indexOf(n)>-1){"backgroundcolor"===n&&""===o&&(o="transparent");var a=new uo,l=new go(i,e),d=new vo,c=new Io,p=a.getRange(e),h=a.save(p,e),u=p.collapsed?a.getSelectionNodeCollection(p):a.getSelectionNodeCollectionBr(p),m=!1,g=!1,f=!1,b=!1,v=["fontcolor","fontname","fontsize","backgroundcolor"].indexOf(n)>-1;if(p.collapsed)if(u.length>0)m=!0,p=d.GetCursorRange(e,p,u[0]);else if(3===p.startContainer.nodeType&&p.startContainer.parentElement.childElementCount>0&&p.startOffset>0&&"br"!==p.startContainer.parentElement.firstElementChild.tagName.toLowerCase())m=!0,p=d.GetCursorRange(e,p,p.startContainer),u.push(p.startContainer);else{var y=this.insertCursorNode(e,a,p,c,d,n,o,i);a.endContainer=a.startContainer=a.getNodeArray(y,!0);var C="BR"===y.nodeName&&y.parentNode.childNodes;t.isNullOrUndefined(C)||1!==C.length||"BR"!==C[0].nodeName||0!==u.length?a.endOffset=a.startOffset=1:(a.setSelectionText(e,p.startContainer,p.endContainer,0,0),b=!0),"BR"===y.nodeName&&0===y.parentNode.textContent.length&&(b=!0)}f=p.collapsed;for(var S=!1,N=0;N<u.length;N++){var E=c.getFormattedNode(u[N],n,i);null===E&&("subscript"===n?S=null!==(E=c.getFormattedNode(u[N],"superscript",i)):"superscript"===n&&(S=null!==(E=c.getFormattedNode(u[N],"subscript",i)))),0===N&&null===E&&(g=!0),u[N]=null===E||g&&!v?this.insertFormat(e,u,N,E,f,g,v,p,d,n,o):this.removeFormat(u,N,E,f,g,v,p,d,n,o,a,i,l),a=this.applySelection(u,a,d,N,m)}I()&&B(i,s),b||h.restore(),S&&this.applyFormat(e,n,i,r)}},e.insertCursorNode=function(e,n,i,r,o,s,a,l){var d=n.getNodeCollection(i),c=new go(l,e),p=d.length>0?d.length>1&&i.startContainer===i.endContainer?this.getCursorFormat(r,d,s,l):r.getFormattedNode(d[0],s,l):null,h=null;if(p){if(h=d[0],8203===p.firstChild.textContent.charCodeAt(0)&&3===p.firstChild.nodeType){var u=new RegExp(String.fromCharCode(8203),"g"),m=void 0;p.firstChild===h?(h.textContent=p.parentElement&&(c.isBlockNode(p.parentElement)&&p.parentElement.textContent.length<=1?p.parentElement.childElementCount>1:0===p.childElementCount)&&(p.parentElement.textContent.length>1||p.parentElement.firstChild&&1===p.parentElement.firstChild.nodeType)?h.textContent:h.textContent.replace(u,""),m=h):(p.firstChild.textContent=p.firstChild.textContent.replace(u,""),m=p.firstChild);var g=void 0;if(0===m.textContent.length)if(t.isNullOrUndefined(m.previousSibling)){if(!t.isNullOrUndefined(m.parentElement)&&0===m.parentElement.textContent.length){var f=document.createElement("BR");m.parentElement.appendChild(f),t.detach(m),h=f,n.setCursorPoint(e,h.parentElement,0)}}else h=m.previousSibling,g=m.textContent.length-1,n.setCursorPoint(e,m,g)}["fontcolor","fontname","fontsize","backgroundcolor"].indexOf(s)>-1?("fontcolor"===s?p.style.color=a:"fontname"===s?p.style.fontFamily=a:"fontsize"===s?p.style.fontSize=a:p.style.backgroundColor=a,h=p):bo.unwrap(p)}else d.length>1&&i.startOffset>0&&d[0].firstElementChild&&"br"===d[0].firstElementChild.tagName.toLowerCase()&&(d[0].innerHTML=""),1!==d.length||0!==i.startOffset||"BR"!==d[0].nodeName&&"BR"!==d[0].nextSibling.nodeName||t.detach("#text"===d[0].nodeName?d[0].nextSibling:d[0]),h=this.getInsertNode(e,i,s,a).firstChild;return h},e.getCursorFormat=function(e,t,n,i){for(var r,o=0;o<t.length;o++)r=t[o].lastElementChild?t[o].lastElementChild:t[o];return e.getFormattedNode(r,n,i)},e.removeFormat=function(e,n,i,r,o,s,a,l,d,c,p,h,u){var m=null,g="#text"===a.startContainer.nodeName?a.startContainer.textContent.substring(a.startOffset,a.startContainer.textContent.length):a.startContainer.textContent;if(a.startContainer!==a.endContainer||0!==a.startOffset||a.endOffset!==a.startContainer.length){var f=[],b=e[n];do{f.push(p.getIndex(b)),b=b.parentNode}while(b&&b!==i);if("BR"!==e[n].nodeName&&(b=m=r&&i.textContent.length-1===a.startOffset?l.SplitNode(a,i,!0):l.GetSpliceNode(a,i)),r){for(var v=m;null!==v.firstChild&&3!==v.firstChild.nodeType;null)v=v.firstChild;v.innerHTML="&#8203;",e[n]=v.firstChild}else{for(;b&&b.childNodes.length>0&&f.length-1>=0&&b.childNodes.length>f[f.length-1];)b=b.childNodes[f[f.length-1]],f.pop();if("BR"!==e[n].nodeName)if(3!==b.nodeType||r&&""===b.nodeValue){var y=document.createElement("div");y.innerHTML="&#8203;",3!==b.nodeType?(b.insertBefore(y.firstChild,b.firstChild),e[n]=b.firstChild):(b.parentNode.insertBefore(y.firstChild,b),e[n]=b.previousSibling,b.parentNode.removeChild(b))}else e[n]=b}}var C;"backgroundcolor"===d&&(C=i.style.fontSize);var S;if("fontsize"===d){var N=t.closest(e[n].parentElement,"span[style*=background-color]");t.isNullOrUndefined(N)||(S=N.style.backgroundColor)}var E=i.getAttribute("style"),T=i.tagName,w=bo.unwrap(i);if(w[0]&&!s)for(var k=w[n]?w[n]:w[0],L=k;k&&k.parentElement&&k.parentElement!==h;k=k)if(k.parentElement&&k.parentElement.tagName.toLocaleLowerCase()===i.tagName.toLocaleLowerCase()&&(k.parentElement.childElementCount>1||a.startOffset>1)){if(L.parentElement&&L.parentElement.tagName.toLocaleLowerCase()===i.tagName.toLocaleLowerCase()&&a.startOffset===a.endOffset&&1!==L.nodeType&&!t.isNullOrUndefined(L.textContent)&&L.parentElement.childElementCount>1&&(a.setStart(L,0),a.setEnd(L,L.textContent.length),l.SplitNode(a,L.parentElement,!1)),"span"===k.parentElement.tagName.toLocaleLowerCase()&&"underline"===i.style.textDecoration&&"underline"!==k.parentElement.style.textDecoration){k=k.parentElement;continue}bo.unwrap(k.parentElement),k=t.isNullOrUndefined(k.parentElement)||u.isBlockNode(k.parentElement)?k.parentElement:L}else k=k.parentElement;if(w.length>0&&s){for(var O=0;O<w.length;O++)(3!==w[O].nodeType||w[O].textContent&&w[O].textContent.trim().length>0)&&(w[O]=bo.Wrap(w[O],this.GetFormatNode(d,c,T,E)),w[O].textContent===g&&(0===O?a.setStartBefore(w[O]):O===w.length-1&&a.setEndAfter(w[O])));var x=e[n].parentElement;if(t.isNullOrUndefined(C)||""===C||(x.style.fontSize=C),t.isNullOrUndefined(S)||""===S||(x.style.backgroundColor=S),"backgroundcolor"===d&&!t.isNullOrUndefined(C)&&""!==C&&x.parentElement.innerHTML===x.outerHTML){var D=x.parentElement;D.parentElement.insertBefore(x,D),t.detach(D)}if("fontsize"===d||"fontcolor"===d){for(var M=e[n].parentElement,R=e[n].parentElement;!t.isNullOrUndefined(R)&&"li"!==R.tagName.toLowerCase();)M=R=R.parentElement;t.isNullOrUndefined(M)||"li"!==M.tagName.toLowerCase()||M.textContent.trim()!==e[n].textContent.trim()||("fontsize"===d?M.style.fontSize=c:(M.style.color=c,M.style.textDecoration="inherit"))}}return e[n]},e.insertFormat=function(e,n,i,r,o,s,a,l,d,c,p){if(o)if("uppercase"!==c&&"lowercase"!==c){h=this.getInsertNode(e,l,c,p);n[i]=h.firstChild,d.position=1}else d.position=l.startOffset;else if(null===r&&s||a){if("BR"!==n[i].nodeName&&(n[i]=d.GetSpliceNode(l,n[i]),n[i].textContent=d.TrimLineBreak(n[i].textContent)),"uppercase"===c||"lowercase"===c)n[i].textContent="uppercase"===c?n[i].textContent.toLocaleUpperCase():n[i].textContent.toLocaleLowerCase();else if(!0!==a||""!==p){var h=this.GetFormatNode(c,p);if("fontsize"===c||"fontcolor"===c){for(var u=n[i].parentElement,m=n[i].parentElement;!t.isNullOrUndefined(m)&&"li"!==m.tagName.toLowerCase();)u=m=m.parentElement;if(t.isNullOrUndefined(u)||"li"!==u.tagName.toLowerCase()||u.textContent.trim()!==n[i].textContent.trim()||("fontsize"===c?u.style.fontSize=p:(u.style.color=p,u.style.textDecoration="inherit")),n[i]=this.applyStyles(n,i,h),"fontsize"===c){var g=t.closest(n[i].parentElement,"span[style*=background-color]");t.isNullOrUndefined(g)||(n[i].parentElement.style.backgroundColor=g.style.backgroundColor)}}else n[i]=this.applyStyles(n,i,h)}}else n[i]=d.GetSpliceNode(l,n[i]);return n[i]},e.applyStyles=function(e,t,n){return"BR"===e[t].nodeName&&"BR"===this.enterAction||(e[t]=t===e.length-1||"BR"===e[t].nodeName?bo.Wrap(e[t],n):bo.WrapBefore(e[t],n,!0),e[t]=this.getChildNode(e[t],n)),e[t]},e.getInsertNode=function(e,n,i,r){var o=this.GetFormatNode(i,r);if(o.innerHTML="&#8203;",t.Browser.isIE){var s=e.createDocumentFragment();s.appendChild(o),n.insertNode(s)}else n.insertNode(o);return o},e.getChildNode=function(e,t){return void 0!==e&&null!==e||(t.innerHTML="&#8203;",e=t.firstChild),e},e.applySelection=function(e,t,n,i,r){return 1!==e.length||r?1===e.length&&r?(t.startContainer=t.getNodeArray(e[i],!0),t.endContainer=t.startContainer,t.startOffset=n.position,t.endOffset=n.position):0===i?(t.startContainer=t.getNodeArray(e[i],!0),t.startOffset=0):i===e.length-1&&(t.endContainer=t.getNodeArray(e[i],!1),t.endOffset=e[i].textContent.length):(t.startContainer=t.getNodeArray(e[i],!0),t.endContainer=t.startContainer,t.startOffset=0,t.endOffset=e[i].textContent.length),t},e.GetFormatNode=function(e,t,n,i){var r;switch(e){case"bold":return document.createElement("strong");case"italic":return document.createElement("em");case"underline":return r=document.createElement("span"),this.updateStyles(r,n,i),r.style.textDecoration="underline",r;case"strikethrough":return r=document.createElement("span"),this.updateStyles(r,n,i),r.style.textDecoration="line-through",r;case"superscript":return document.createElement("sup");case"subscript":return document.createElement("sub");case"fontcolor":return r=document.createElement("span"),this.updateStyles(r,n,i),r.style.color=t,r.style.textDecoration="inherit",r;case"fontname":return r=document.createElement("span"),this.updateStyles(r,n,i),r.style.fontFamily=t,r;case"fontsize":return r=document.createElement("span"),this.updateStyles(r,n,i),r.style.fontSize=t,r;default:return r=document.createElement("span"),this.updateStyles(r,n,i),r.style.backgroundColor=t,r}},e.updateStyles=function(e,t,n){null!==n&&"SPAN"===t&&e.setAttribute("style",n)},e.enterAction="P",e}(),Po=function(){function e(e){this.parent=e,this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.observer.on(lo,this.applySelection,this),this.parent.observer.on(hr,this.keyDownHandler,this)},e.prototype.keyDownHandler=function(e){e.event.ctrlKey&&["bold","italic","underline","strikethrough","superscript","subscript","uppercase","lowercase"].indexOf(e.event.action)>-1&&(e.event.preventDefault(),Bo.applyFormat(this.parent.currentDocument,e.event.action,this.parent.editableElement,e.enterAction),this.callBack(e,e.event.action))},e.prototype.applySelection=function(e){Bo.applyFormat(this.parent.currentDocument,e.subCommand.toLocaleLowerCase(),this.parent.editableElement,e.enterAction,e.value,e.selector),this.callBack(e,e.subCommand)},e.prototype.callBack=function(e,t){e.callBack&&e.callBack({requestType:t,event:e.event,editorMode:"HTML",range:this.parent.nodeSelection.getRange(this.parent.currentDocument),elements:this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)})},e}(),Ao=function(){function e(e){this.parent=e,this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.observer.on(co,this.applyHtml,this)},e.prototype.applyHtml=function(e){if(Co.Insert(this.parent.currentDocument,e.value,this.parent.editableElement,!0),"pasteCleanup"===e.subCommand){var t=this.parent.editableElement.querySelectorAll(".pasteContent_RTE"),n=[].slice.call(t),i=this.parent.editableElement.querySelectorAll(".pasteContent_Img"),r=[].slice.call(i);e.callBack({requestType:e.subCommand,editorMode:"HTML",elements:n,imgElem:r})}else e.callBack&&e.callBack({requestType:e.subCommand,editorMode:"HTML",event:e.event,range:this.parent.nodeSelection.getRange(this.parent.currentDocument),elements:this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)})},e}(),Uo=function(){function e(){}return e.clear=function(e,n,i,r){this.domNode=new go(n,e),this.defaultTag="P"===i?this.defaultTag:"div";var o=new uo,s=new vo,a=o.getRange(e),l=a.collapsed,d=o.getInsertNodeCollection(a),c=o.save(a,e);if(!l){var p=void 0;if(p="BR"===d[0].nodeName&&t.closest(d[0],"table")?s.GetSpliceNode(a,t.closest(d[0],"table")):s.GetSpliceNode(a,d[d.length>1&&"IMG"===d[0].nodeName?1:0]),1===d.length)o.setSelectionContents(e,p),a=o.getRange(e);else{for(var h=1,u=d[d.length-h];d.length<=h&&"BR"===d[d.length-h].nodeName;)h++,u=d[d.length-h];var m=s.GetSpliceNode(a,u);o.setSelectionText(e,p,m,0,3===m.nodeType?m.textContent.length:m.childNodes.length),a=o.getRange(e)}var g=o.getNodeCollection(a),f=g.slice();this.clearInlines(o.getSelectionNodes(f),f,o.getRange(e),s,n),this.reSelection(e,c,g),a=o.getRange(e);var b=(g=o.getNodeCollection(a)).slice();this.clearBlocks(e,b,n,s,o),I()&&B(n,r),this.reSelection(e,c,g)}},e.reSelection=function(e,t,n){var i=t.getInsertNodes(n);t.startContainer=t.getNodeArray(i[0],!0,e),t.startOffset=0,t.endContainer=t.getNodeArray(i[i.length-1],!1,e);var r=i[i.length-1];t.endOffset=3===r.nodeType?r.textContent.length:r.childNodes.length,t.restore()},e.clearBlocks=function(e,t,n,i,r){for(var o=[],s=0;s<t.length;s++)this.BLOCK_TAGS.indexOf(t[s].nodeName.toLocaleLowerCase())>-1&&-1===o.indexOf(t[s])?o.push(t[s]):this.BLOCK_TAGS.indexOf(t[s].parentNode.nodeName.toLocaleLowerCase())>-1&&-1===o.indexOf(t[s].parentNode)&&n!==t[s].parentNode&&o.push(t[s].parentNode);o=this.spliceParent(o,t)[0],o=this.removeParent(o),this.unWrap(e,o,i,r)},e.spliceParent=function(e,t){for(var n=0;n<e.length;n++)for(var i=e[n].childNodes.length,r=0;r<i;r++)if(t.indexOf(e[n].childNodes[r])>0&&e[n].childNodes[r].childNodes.length>0&&(t=this.spliceParent([e[n].childNodes[r]],t)[1]),t.indexOf(e[n].childNodes[r])<=-1&&""!==e[n].childNodes[r].textContent.trim()){for(var o=0;o<i;o++)t.indexOf(e[n].childNodes[o])>-1&&t.splice(t.indexOf(e[n].childNodes[o]),1);r=e[n].childNodes.length;var s=e.indexOf(e[n].parentNode),a=t.indexOf(e[n].parentNode);s>-1&&e.splice(s,1),a>-1&&t.splice(a,1);var l=t.indexOf(e[n]);l>-1&&t.splice(l,1),e.splice(n,1),n--}return[e,t]},e.removeChild=function(e,t){var n=t.childNodes.length;if(n>0)for(var i=0;i<n;i++)e.indexOf(t.childNodes[i])>-1&&(e=this.removeChild(e,t.childNodes[i])).splice(e.indexOf(t.childNodes[i]),1);return e},e.removeParent=function(e){for(var t=0;t<e.length;t++)e.indexOf(e[t].parentNode)>-1&&((e=this.removeChild(e,e[t])).splice(t,1),t--);return e},e.unWrap=function(e,t,n,i){for(var r=0;r<t.length;r++)if(this.NONVALID_TAGS.indexOf(t[r].nodeName.toLowerCase())>-1&&t[r].parentNode&&this.NONVALID_PARENT_TAGS.indexOf(t[r].parentNode.nodeName.toLowerCase())>-1&&(i.setSelectionText(e,t[r],t[r],0,t[r].childNodes.length),bo.unwrap(n.GetSpliceNode(i.getRange(e),t[r].parentNode))),"p"!==t[r].nodeName.toLocaleLowerCase()){!(this.NONVALID_PARENT_TAGS.indexOf(t[r].nodeName.toLowerCase())<0&&"p"!==t[r].parentNode.nodeName.toLocaleLowerCase())||("blockquote"===t[r].nodeName.toLocaleLowerCase()||"li"===t[r].nodeName.toLocaleLowerCase())&&this.IGNORE_PARENT_TAGS.indexOf(t[r].childNodes[0].nodeName.toLocaleLowerCase())>-1||1===t[r].childNodes.length&&"p"===t[r].childNodes[0].nodeName.toLocaleLowerCase()||bo.Wrap(t[r],e.createElement(this.defaultTag));var o=bo.unwrap(t[r]);1===o.length&&"p"===o[0].parentNode.nodeName.toLocaleLowerCase()&&(bo.Wrap(t[r],e.createElement(this.defaultTag)),bo.unwrap(t[r]));for(var s=0;s<o.length;s++)if(this.NONVALID_TAGS.indexOf(o[s].nodeName.toLowerCase())>-1)this.unWrap(e,[o[s]],n,i);else if(this.BLOCK_TAGS.indexOf(o[s].nodeName.toLocaleLowerCase())>-1&&"p"!==o[s].nodeName.toLocaleLowerCase()){var a=this.removeParent([o[s]]);this.unWrap(e,a,n,i)}else this.BLOCK_TAGS.indexOf(o[s].nodeName.toLocaleLowerCase())>-1&&o[s].parentNode.nodeName.toLocaleLowerCase()===o[s].nodeName.toLocaleLowerCase()?bo.unwrap(o[s]):this.BLOCK_TAGS.indexOf(o[s].nodeName.toLocaleLowerCase())>-1&&"p"===o[s].nodeName.toLocaleLowerCase()&&(bo.Wrap(o[s],e.createElement(this.defaultTag)),bo.unwrap(o[s]))}else bo.Wrap(t[r],e.createElement(this.defaultTag)),bo.unwrap(t[r])},e.clearInlines=function(e,t,n,i,r){for(var o=0;o<e.length;o++){for(var s=e[o],a=void 0;!this.domNode.isBlockNode(s);)a=s,s=s.parentElement;a&&Io.inlineTags.indexOf(a.nodeName.toLocaleLowerCase())>-1&&(i.GetSpliceNode(n,a),this.removeInlineParent(a))}},e.removeInlineParent=function(e){for(var t=bo.unwrap(e),n=0;n<t.length;n++)1===t[n].parentNode.childNodes.length&&Io.inlineTags.indexOf(t[n].parentNode.nodeName.toLocaleLowerCase())>-1?this.removeInlineParent(t[n].parentNode):Io.inlineTags.indexOf(t[n].nodeName.toLocaleLowerCase())>-1&&this.removeInlineParent(t[n])},e.BLOCK_TAGS=["address","article","aside","blockquote","details","dd","div","dl","dt","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","header","hgroup","li","main","nav","noscript","ol","p","pre","section","ul"],e.NONVALID_PARENT_TAGS=["thead","tbody","ul","ol","table","tfoot","tr"],e.IGNORE_PARENT_TAGS=["ul","ol","table"],e.NONVALID_TAGS=["thead","tbody","figcaption","td","tr","th","tfoot","figcaption","li"],e.defaultTag="p",e}(),Ho=function(){function e(e){this.parent=e,this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.observer.on(ho,this.applyClear,this),this.parent.observer.on(hr,this.onKeyDown,this)},e.prototype.onKeyDown=function(e){switch(e.event.action){case"clear-format":this.applyClear({subCommand:"ClearFormat",callBack:e.callBack,enterAction:e.enterAction}),e.event.preventDefault()}},e.prototype.applyClear=function(e){"ClearFormat"===e.subCommand&&(Uo.clear(this.parent.currentDocument,this.parent.editableElement,e.enterAction,e.selector),e.callBack&&e.callBack({requestType:e.subCommand,event:e.event,editorMode:"HTML",range:this.parent.nodeSelection.getRange(this.parent.currentDocument),elements:this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)}))},e}(),jo=function(){function e(e,n){this.undoRedoStack=[],this.parent=e,this.undoRedoSteps=t.isNullOrUndefined(n)?30:n.undoRedoSteps,this.undoRedoTimer=t.isNullOrUndefined(n)?300:n.undoRedoTimer,this.addEventListener()}return e.prototype.addEventListener=function(){var e=t.debounce(this.keyUp,this.undoRedoTimer);this.parent.observer.on(ur,e,this),this.parent.observer.on(hr,this.keyDown,this),this.parent.observer.on(cr,this.onAction,this),this.parent.observer.on(mr,this.onPropertyChanged,this)},e.prototype.onPropertyChanged=function(e){for(var t=0,n=Object.keys(e.newProp);t<n.length;t++){switch(n[t]){case"undoRedoSteps":this.undoRedoSteps=e.newProp.undoRedoSteps;break;case"undoRedoTimer":this.undoRedoTimer=e.newProp.undoRedoTimer}}},e.prototype.removeEventListener=function(){this.parent.observer.off(ur,this.keyUp),this.parent.observer.off(hr,this.keyDown),this.parent.observer.off(cr,this.onAction)},e.prototype.onAction=function(e){"Undo"===e.subCommand?this.undo(e):this.redo(e)},e.prototype.destroy=function(){this.removeEventListener()},e.prototype.keyDown=function(e){var t=e.event;switch(t.action){case"undo":t.preventDefault(),this.undo(e);break;case"redo":t.preventDefault(),this.redo(e)}},e.prototype.keyUp=function(e){17===e.event.keyCode||e.event.ctrlKey||this.saveData(e)},e.prototype.saveData=function(e){for(var n=(new uo).getRange(this.parent.currentDocument),i=n.startContainer,r=i.childNodes.length-1;r>=0;r--)!t.isNullOrUndefined(i.childNodes[r])&&"#text"===i.childNodes[r].nodeName&&0===i.childNodes[r].textContent.length&&"IMG"!==i.childNodes[r].nodeName&&"BR"!==i.childNodes[r].nodeName&&i.childNodes[r].nodeName&&t.detach(i.childNodes[r]);n=(new uo).getRange(this.parent.currentDocument);var o=(new uo).save(n,this.parent.currentDocument),s={text:this.parent.editableElement.innerHTML,range:o};this.undoRedoStack.length>=this.steps&&(this.undoRedoStack=this.undoRedoStack.slice(0,this.steps+1)),this.undoRedoStack.length>1&&this.undoRedoStack[this.undoRedoStack.length-1].range.range.collapsed===n.collapsed&&this.undoRedoStack[this.undoRedoStack.length-1].range.startOffset===o.range.startOffset&&this.undoRedoStack[this.undoRedoStack.length-1].range.endOffset===o.range.endOffset&&this.undoRedoStack[this.undoRedoStack.length-1].range.range.startContainer===o.range.startContainer&&this.undoRedoStack[this.undoRedoStack.length-1].text.trim()===s.text.trim()||(this.undoRedoStack.push(s),this.steps=this.undoRedoStack.length-1,this.steps>this.undoRedoSteps&&(this.undoRedoStack.shift(),this.steps--),e&&e.callBack&&e.callBack())},e.prototype.undo=function(e){if(this.steps>0){var t=this.undoRedoStack[this.steps-1].range,n=this.undoRedoStack[this.steps-1].text;this.parent.editableElement.innerHTML=n,this.parent.editableElement.focus(),I()&&B(this.parent.editableElement,e.selector),t.restore(),this.steps--,e.callBack&&e.callBack({requestType:"Undo",editorMode:"HTML",range:t,elements:this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument),event:e.event})}},e.prototype.redo=function(e){if(null!=this.undoRedoStack[this.steps+1]){var t=this.undoRedoStack[this.steps+1].range;this.parent.editableElement.innerHTML=this.undoRedoStack[this.steps+1].text,this.parent.editableElement.focus(),I()&&B(this.parent.editableElement,e.selector),t.restore(),this.steps++,e.callBack&&e.callBack({requestType:"Redo",editorMode:"HTML",range:t,elements:this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument),event:e.event})}},e.prototype.getUndoStatus=function(){var e={undo:!1,redo:!1};return this.steps>0&&(e.undo=!0),null!=this.undoRedoStack[this.steps+1]&&(e.redo=!0),e},e}(),Fo=function(){function e(e){this.olData=["decimal","lower-alpha","lower-roman","upper-alpha","upper-roman","lower-greek"],this.ulData=["disc","square","circle","disc","square","circle"],this.ignorableNodes=["A","APPLET","B","BLOCKQUOTE","BR","BUTTON","CENTER","CODE","COL","COLGROUP","DD","DEL","DFN","DIR","DIV","DL","DT","EM","FIELDSET","FONT","FORM","FRAME","FRAMESET","H1","H2","H3","H4","H5","H6","HR","I","IMG","IFRAME","INPUT","INS","LABEL","LI","OL","OPTION","P","PARAM","PRE","Q","S","SELECT","SPAN","STRIKE","STRONG","SUB","SUP","TABLE","TBODY","TD","TEXTAREA","TFOOT","TH","THEAD","TITLE","TR","TT","U","UL"],this.blockNode=["div","p","h1","h2","h3","h4","h5","h6","address","blockquote","button","center","dd","dir","dl","dt","fieldset","frameset","hr","iframe","isindex","li","map","menu","noframes","noscript","object","ol","pre","table","tbody","td","tfoot","th","thead","tr","ul","header","article","nav","footer","section","aside","main","figure","figcaption"],this.borderStyle=["border-top","border-right","border-bottom","border-left"],this.removableElements=["o:p","style"],this.listContents=[],this.parent=e,this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.observer.on(fr,this.wordCleanup,this)},e.prototype.wordCleanup=function(e){var n=t.isNullOrUndefined(e.allowedStylePropertiesArray)?[]:e.allowedStylePropertiesArray,i=[],r=e.args.clipboardData.getData("text/HTML"),o=e.args.clipboardData.getData("text/rtf"),s=t.createElement("p");s.setAttribute("id","MSWord-Content"),s.innerHTML=r;var a=/style='mso-width-source:/i;/class='?Mso|style='[^ ]*\bmso-/i.test(r)||/class="?Mso|style="[^ ]*\bmso-/i.test(r)||/(class="?Mso|class='?Mso|class="?Xl|class='?Xl|class=Xl|style="[^"]*\bmso-|style='[^']*\bmso-|w:WordDocument)/gi.test(r)||a.test(r)?(this.imageConversion(s,o),r=r.replace(/<img[^>]+>/i,""),this.addListClass(s),i=this.cleanUp(s,i),t.isNullOrUndefined(i[0])||"UL"===i[0].parentElement.tagName||"OL"===i[0].parentElement.tagName||this.listConverter(i),this.styleCorrection(s,n),this.removingComments(s),this.removeUnwantedElements(s),this.removeEmptyElements(s),this.breakLineAddition(s),this.removeClassName(s),a.test(r)&&this.addTableBorderClass(s),e.callBack(s.innerHTML)):e.callBack(s.innerHTML)},e.prototype.addListClass=function(e){for(var n=e.querySelectorAll("*"),i=0;i<n.length;i++)!t.isNullOrUndefined(n[i].getAttribute("style"))&&n[i].getAttribute("style").replace(/ /g,"").replace("\n","").indexOf("mso-list:l")>=0&&-1===n[i].className.toLowerCase().indexOf("msolistparagraph")&&"H"!==n[i].tagName.charAt(0)&&n[i].classList.add("msolistparagraph")},e.prototype.addTableBorderClass=function(e){for(var t=e.querySelectorAll("table"),n=!1,i=0;i<t.length;i++){for(var r=0;r<this.borderStyle.length;r++)if(t[i].innerHTML.indexOf(this.borderStyle[r])>=0){n=!0;break}n&&(t[i].classList.add("e-rte-table-border"),n=!1)}},e.prototype.imageConversion=function(e,t){this.checkVShape(e);var n=e.querySelectorAll("img"),i=[],r=[],o=[],s=new RegExp(/([^\S]|^)(((https?\:\/\/)|(www\.))(\S+))/gi);if(n.length>0){for(var a=0;a<n.length;a++)i.push(n[a].getAttribute("src")),o.push(n[a].getAttribute("src").split("/")[n[a].getAttribute("src").split("/").length-1].split(".")[0]);var l=this.hexConversion(t);for(a=0;a<l.length;a++)r.push(this.convertToBase64(l[a]));for(a=0;a<n.length;a++)i[a].match(s)?n[a].setAttribute("src",i[a]):n[a].setAttribute("src",r[a]),n[a].setAttribute("id","msWordImg-"+o[a])}},e.prototype.checkVShape=function(e){for(var n=e.querySelectorAll("*"),i=0;i<n.length;i++)switch(n[i].nodeName){case"V:SHAPETYPE":t.detach(n[i]);break;case"V:SHAPE":if("V:IMAGEDATA"===n[i].firstElementChild.nodeName){var r=n[i].firstElementChild.getAttribute("src"),o=t.createElement("img");o.setAttribute("src",r),n[i].parentElement.insertBefore(o,n[i]),t.detach(n[i])}}},e.prototype.convertToBase64=function(e){var t=this.conHexStringToBytes(e.hex),n=this.conBytesToBase64(t);return e.type?"data:"+e.type+";base64,"+n:null},e.prototype.conBytesToBase64=function(e){for(var t="",n=e.length,i=0;i<n;i+=3){var r=e.slice(i,i+3),o=r.length,s=[];if(o<3)for(var a=o;a<3;a++)r[a]=0;s[0]=(252&r[0])>>2,s[1]=(3&r[0])<<4|r[1]>>4,s[2]=(15&r[1])<<2|(192&r[2])>>6,s[3]=63&r[2];for(a=0;a<4;a++)t+=a<=o?"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(s[a]):"="}return t},e.prototype.conHexStringToBytes=function(e){for(var t=[],n=e.length/2,i=0;i<n;i++)t.push(parseInt(e.substr(2*i,2),16));return t},e.prototype.hexConversion=function(e){var n,i=/\{\\pict[\s\S]+?\\bliptag\-?\d+(\\blipupi\-?\d+)?(\{\\\*\\blipuid\s?[\da-fA-F]+)?[\s\}]*?/,r=new RegExp("(?:("+i.source+"))([\\da-fA-F\\s]+)\\}","g"),o=e.match(r),s=[];if(!t.isNullOrUndefined(o))for(var a=0;a<o.length;a++)if(i.test(o[a])){if(-1!==o[a].indexOf("\\pngblip"))n="image/png";else{if(-1===o[a].indexOf("\\jpegblip"))continue;n="image/jpeg"}s.push({hex:n?o[a].replace(i,"").replace(/[^\da-fA-F]/g,""):null,type:n})}return s},e.prototype.removeClassName=function(e){for(var t=e.querySelectorAll("*[class]"),n=0;n<t.length;n++)t[n].removeAttribute("class")},e.prototype.breakLineAddition=function(e){for(var n=e.querySelectorAll("*"),i=0;i<n.length;i++)if(0===n[i].children.length&&"&nbsp;"===n[i].innerHTML&&"&nbsp;"===n[i].innerHTML&&!n[i].closest("li")&&!n[i].closest("td")){var r=this.findDetachElem(n[i]),o=t.createElement("br");t.isNullOrUndefined(r.parentElement)||(r.parentElement.insertBefore(o,r),t.detach(r))}},e.prototype.findDetachElem=function(e){return!t.isNullOrUndefined(e.parentElement)&&""===e.parentElement.textContent.trim()&&"TD"!==e.parentElement.tagName&&t.isNullOrUndefined(e.parentElement.querySelector("img"))?this.findDetachElem(e.parentElement):e},e.prototype.removeUnwantedElements=function(e){for(var t=e.innerHTML,n=0;n<this.removableElements.length;n++){var i=new RegExp("<"+this.removableElements[n]+">","g"),r=new RegExp("</"+this.removableElements[n]+">","g");t=(t=t.replace(i,"")).replace(r,"")}e.innerHTML=t,e.querySelectorAll(":empty")},e.prototype.findDetachEmptyElem=function(e){return t.isNullOrUndefined(e.parentElement)?null:""===e.parentElement.textContent.trim()&&"MSWord-Content"!==e.parentElement.getAttribute("id")&&t.isNullOrUndefined(e.parentElement.querySelector("img"))?this.findDetachEmptyElem(e.parentElement):e},e.prototype.removeEmptyElements=function(e){for(var n=e.querySelectorAll(":empty"),i=0;i<n.length;i++)if(t.isNullOrUndefined(n[i].closest("td"))||t.isNullOrUndefined(n[i].closest("td").querySelector(".MsoNormal"))||(n[i].innerHTML="-"),"IMG"!==n[i].tagName&&"BR"!==n[i].tagName&&"IFRAME"!==n[i].tagName&&"TD"!==n[i].tagName&&"HR"!==n[i].tagName){var r=this.findDetachEmptyElem(n[i]);t.isNullOrUndefined(r)||t.detach(r)}},e.prototype.styleCorrection=function(e,n){var i=e.querySelectorAll("style");if(i.length>0){var r=i[0].innerHTML.match(/[\S ]+\s+{[\s\S]+?}/gi),o=t.isNullOrUndefined(r)?null:this.findStyleObject(r),s=Object.keys(o),a=s.map(function(e){return o[e]});a=this.removeUnwantedStyle(a,n),this.filterStyles(e,n);for(var l=void 0,d=!1,c=0;c<s.length;c++){if(""===s[c].split(".")[0])l=e.getElementsByClassName(s[c].split(".")[1]),d=!0;else{if(1===s[c].split(".").length&&s[c].split(".")[0].indexOf("@")>=0)continue;l=1===s[c].split(".").length&&s[c].split(".")[0].indexOf("@")<0?e.getElementsByTagName(s[c]):e.querySelectorAll(s[c])}for(var p=0;p<l.length;p++){var h=l[p].getAttribute("style");if(t.isNullOrUndefined(h)||""===h.trim())a[c]=a[c].replace(/text-indent:-(.*?)(?=;|$)/gm,""),l[p].setAttribute("style",a[c]);else{var u=a[c].split(";");if(!d)for(var m=0;m<u.length;m++)h.indexOf(u[m].split(":")[0])>=0&&(u.splice(m,1),m--);a[c]=u.join(";")+";";var g=h+a[c];l[p].setAttribute("style",g)}}d=!1}}},e.prototype.filterStyles=function(e,t){for(var n=e.querySelectorAll("*[style]"),i=0;i<n.length;i++){for(var r=n[i].getAttribute("style").split(";"),o="",s=0;s<r.length;s++)t.indexOf(r[s].split(":")[0].trim())>=0&&(o+=r[s]+";");n[i].setAttribute("style",o)}},e.prototype.removeUnwantedStyle=function(e,t){for(var n=0;n<e.length;n++){var i=e[n].split(";");e[n]="";for(var r=0;r<i.length;r++)t.indexOf(i[r].split(":")[0])>=0&&(e[n]+=i[r]+";")}return e},e.prototype.findStyleObject=function(e){for(var t={},n=0;n<e.length;n++){var i=e[n],r=i.replace(/([\S ]+\s+){[\s\S]+?}/gi,"$1"),o=i.replace(/[\S ]+\s+{([\s\S]+?)}/gi,"$1");r=r.replace(/^[\s]|[\s]$/gm,""),o=o.replace(/^[\s]|[\s]$/gm,""),r=r.replace(/\n|\r|\n\r/g,""),o=o.replace(/\n|\r|\n\r/g,"");for(var s=r.split(", "),a=0;a<s.length;a++)t[s[a]]=o}return t},e.prototype.removingComments=function(e){var t=e.innerHTML;t=t.replace(/<!--[\s\S]*?-->/g,""),e.innerHTML=t},e.prototype.cleanUp=function(e,n){for(var i,r=[],o=e.querySelectorAll("*"),s=0;s<o.length;s++)-1===this.ignorableNodes.indexOf(o[s].nodeName)||3===o[s].nodeType&&""===o[s].textContent.trim()?r.push(o[s]):(o[s].className&&-1!==o[s].className.toLowerCase().indexOf("msolistparagraph")&&1!==o[s].childElementCount&&!t.isNullOrUndefined(o[s].getAttribute("style"))&&o[s].getAttribute("style").indexOf("mso-list:")>=0&&(o[s].className.indexOf("MsoListParagraphCxSpFirst")>=0&&n.length>0&&null!==n[n.length-1]&&n.push(null),n.push(o[s])),!i||-1===this.blockNode.indexOf(o[s].nodeName.toLowerCase())||o[s].className&&-1!==o[s].className.toLowerCase().indexOf("msolistparagraph")&&!t.isNullOrUndefined(o[s].getAttribute("style"))&&o[s].getAttribute("style").indexOf("mso-list:")>=0||n.push(null),-1!==this.blockNode.indexOf(o[s].nodeName.toLowerCase())&&(i=!!(o[s].className&&-1!==o[s].className.toLowerCase().indexOf("msolistparagraph")&&!t.isNullOrUndefined(o[s].getAttribute("style"))&&o[s].getAttribute("style").indexOf("mso-list:")>=0)));return n.length&&null!==n[n.length-1]&&n.push(null),n},e.prototype.listConverter=function(e){for(var n,i,r=[],o=[],s="",a="",l=0;l<e.length;l++)if(null!==e[l]){e[l].getAttribute("style")&&-1!==e[l].getAttribute("style").indexOf("mso-outline-level")&&e[l].setAttribute("style",e[l].getAttribute("style").replace("mso-outline-level","mso-outline")),n=(s=e[l].getAttribute("style"))&&-1!==s.indexOf("level")?parseInt(s.charAt(s.indexOf("level")+5),null):1,this.listContents=[],this.getListContent(e[l]);var d=void 0,c=void 0;if(!t.isNullOrUndefined(this.listContents[0])){d=this.listContents[0].trim().length>1?"ol":"ul",c=this.getlistStyleType(this.listContents[0],d);for(var p=[],h=1;h<this.listContents.length;h++)p.push(this.listContents[h]);var u=void 0;t.isNullOrUndefined(e[l].className)||(u=e[l].className),t.isNullOrUndefined(e[l].getAttribute("style"))||(e[l].setAttribute("style",e[l].getAttribute("style").replace("text-align:start;","")),""!==e[l].style.textAlign&&(e[l].setAttribute("style","text-align:"+e[l].style.textAlign),a=e[l].getAttribute("style"))),o.push({listType:d,content:p,nestedLevel:n,class:u,listStyle:a,listStyleTypeName:c})}}else r.push({content:this.makeConversion(o),node:e[l-1]}),o=[];for(i=e.shift();i;){for(var m=[],g=0;g<r.length;g++)if(r[g].node===i){for(var f=0;f<r[g].content.childNodes.length;f++)m.push(r[g].content.childNodes[f]);for(f=0;f<m.length;f++)i.parentElement.insertBefore(m[f],i);break}i.remove(),(i=e.shift())||(i=e.shift())}},e.prototype.getlistStyleType=function(e,t){var n;if("ol"===t)switch(e.split(".")[0]){case"A":n="upper-alpha";break;case"a":n="lower-alpha";break;case"I":n="upper-roman";break;case"i":n="lower-roman";break;case"α":n="lower-greek";break;default:n="decimal"}else switch(e.split(".")[0]){case"o":n="circle";break;case"§":n="square";break;default:n="disc"}return n},e.prototype.makeConversion=function(e){for(var n,i,r,o=t.createElement("div"),s=1,a=0,l=0;l<e.length;l++){var d=t.createElement("p");if(d.innerHTML=e[l].content.join(" "),1===e[l].nestedLevel&&0===a&&e[l].content)o.appendChild(n=t.createElement(e[l].listType)),(i=t.createElement("li")).appendChild(d),n.appendChild(i),n.setAttribute("level",e[l].nestedLevel.toString()),n.style.listStyleType=e[l].listStyleTypeName;else if(e[l].nestedLevel===s)i.parentElement.tagName.toLowerCase()===e[l].listType?(i.parentElement.appendChild(i=t.createElement("li")),i.appendChild(d)):((n=t.createElement(e[l].listType)).style.listStyleType=e[l].listStyleTypeName,i.parentElement.parentElement.appendChild(n),(i=t.createElement("li")).appendChild(d),n.appendChild(i),n.setAttribute("level",e[l].nestedLevel.toString()));else if(e[l].nestedLevel>s)if(t.isNullOrUndefined(i))o.appendChild(n=t.createElement(e[l].listType)),(i=t.createElement("li")).appendChild(d),n.appendChild(i),n.setAttribute("level",e[l].nestedLevel.toString()),n.style.listStyleType=e[l].listStyleTypeName;else{for(var c=0;c<e[l].nestedLevel-s;c++)i.appendChild(n=t.createElement(e[l].listType)),i=t.createElement("li"),c!=e[l].nestedLevel-s-1&&e[l].nestedLevel-s>1&&(i.style.listStyleType="none"),n.appendChild(i);i.appendChild(d),n.setAttribute("level",e[l].nestedLevel.toString()),n.style.listStyleType=e[l].listStyleTypeName}else if(1===e[l].nestedLevel)o.lastChild.tagName.toLowerCase()===e[l].listType?n=o.lastChild:(o.appendChild(n=t.createElement(e[l].listType)),n.style.listStyleType=e[l].listStyleTypeName),(i=t.createElement("li")).appendChild(d),n.appendChild(i),n.setAttribute("level",e[l].nestedLevel.toString());else for(r=i;r.parentElement;)if((r=r.parentElement).attributes.getNamedItem("level")){if(parseInt(r.attributes.getNamedItem("level").textContent,null)===e[l].nestedLevel){(i=t.createElement("li")).appendChild(d),r.appendChild(i);break}if(e[l].nestedLevel>parseInt(r.attributes.getNamedItem("level").textContent,null)){r.appendChild(n=t.createElement(e[l].listType)),(i=t.createElement("li")).appendChild(d),n.appendChild(i),n.setAttribute("level",e[l].nestedLevel.toString()),n.style.listStyleType=e[l].listStyleTypeName;break}}i.setAttribute("class",e[l].class);var p=i.getAttribute("style");i.setAttribute("style",t.isNullOrUndefined(p)?"":p),s=e[l].nestedLevel,a++}return o},e.prototype.getListContent=function(e){var n="",i=e.firstElementChild;if(""!==i.textContent.trim()||t.isNullOrUndefined(i.firstElementChild)||"IMG"!==i.firstElementChild.nodeName){var r=["b","em"];if(i.childNodes.length>0&&(i.querySelectorAll("b").length>0||i.querySelectorAll("em").length>0))for(var o=0;o<i.childNodes.length;o++){var s=i.childNodes[o].nodeName.toLowerCase();i.childNodes[o].textContent.trim().length>1&&-1!==r.indexOf(s)?(n="<"+s+">"+i.childNodes[o].textContent+"</"+s+">",this.listContents.push(n)):1===i.childNodes[o].textContent.trim().length&&this.listContents.push(i.childNodes[o].textContent.trim())}else n=i.textContent.trim(),this.listContents.push(n)}else n=e.innerHTML.trim(),this.listContents.push(""),this.listContents.push(n);t.detach(i),this.listContents.push(e.innerHTML)},e}(),qo=function(){function e(e){this.parent=e,this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.observer.on(po,this.insertText,this)},e.prototype.insertText=function(e){var t=document.createTextNode(e.value);Co.Insert(this.parent.currentDocument,t),e.callBack&&e.callBack({requestType:e.subCommand,editorMode:"HTML",event:e.event,range:this.parent.nodeSelection.getRange(this.parent.currentDocument),elements:this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)})},e}(),zo=function(){function e(e){this.currentDocument=e.document,this.editableElement=e.editableElement,this.nodeSelection=new uo,this.nodeCutter=new vo,this.domNode=new go(this.editableElement,this.currentDocument),this.observer=new t.Observer(this),this.listObj=new fo(this),this.formatObj=new yo(this),this.alignmentObj=new No(this),this.indentsObj=new Eo(this),this.linkObj=new So(this),this.imgObj=new Do(this),this.selectionObj=new Po(this),this.inserthtmlObj=new Ao(this),this.insertTextObj=new qo(this),this.clearObj=new Ho(this),this.tableObj=new Mo(this),this.undoRedoManager=new jo(this,e.options),this.msWordPaste=new Fo(this),this.wireEvents()}return e.prototype.wireEvents=function(){this.observer.on("keydown",this.editorKeyDown,this),this.observer.on("keyup",this.editorKeyUp,this),this.observer.on("keyup",this.editorKeyUp,this),this.observer.on(gr,this.onPropertyChanged,this),this.observer.on(br,this.onWordPaste,this),this.observer.on("onBegin",this.onBegin,this)},e.prototype.onWordPaste=function(e){this.observer.notify(fr,e)},e.prototype.onPropertyChanged=function(e){this.observer.notify(mr,e)},e.prototype.editorKeyDown=function(e){this.observer.notify(hr,e)},e.prototype.editorKeyUp=function(e){this.observer.notify(ur,e)},e.prototype.onBegin=function(e){this.observer.notify(vr,e)},e.prototype.execCommand=function(e,t,n,i,r,o,s,a){switch(e.toLowerCase()){case"lists":this.observer.notify("list-type",{subCommand:t,event:n,callBack:i,selector:s,item:o,enterAction:a});break;case"formats":this.observer.notify(pr,{subCommand:t,event:n,callBack:i,selector:s,exeValue:o,enterAction:a});break;case"alignments":this.observer.notify(io,{subCommand:t,event:n,callBack:i,selector:s,value:o});break;case"indents":this.observer.notify(ro,{subCommand:t,event:n,callBack:i,selector:s});break;case"links":this.observer.notify(Wr,{command:e,value:t,item:o,event:n,callBack:i});break;case"files":this.observer.notify(Qr,{command:e,value:"Image",item:o,event:n,callBack:i,selector:s});break;case"images":this.observer.notify(Qr,{command:e,value:t,item:o,event:n,callBack:i,selector:s});break;case"table":switch(t.toString().toLocaleLowerCase()){case"createtable":this.observer.notify(Vr,{item:o,event:n,callBack:i,enterAction:a});break;case"insertrowbefore":case"insertrowafter":this.observer.notify(Kr,{item:o,event:n,callBack:i});break;case"insertcolumnleft":case"insertcolumnright":this.observer.notify(Gr,{item:o,event:n,callBack:i});break;case"deleterow":this.observer.notify(Xr,{item:o,event:n,callBack:i});break;case"deletecolumn":this.observer.notify(Yr,{item:o,event:n,callBack:i});break;case"tableremove":this.observer.notify(Jr,{item:o,event:n,callBack:i});break;case"tableheader":this.observer.notify($r,{item:o,event:n,callBack:i});break;case"aligntop":case"alignmiddle":case"alignbottom":this.observer.notify(Zr,{item:o,event:n,callBack:i});break;case"merge":this.observer.notify(eo,{item:o,event:n,callBack:i});break;case"horizontalsplit":this.observer.notify(no,{item:o,event:n,callBack:i});break;case"verticalsplit":this.observer.notify(to,{item:o,event:n,callBack:i})}break;case"font":case"style":case"effects":case"casing":this.observer.notify(lo,{subCommand:t,event:n,callBack:i,value:r,selector:s,enterAction:a});break;case"inserthtml":this.observer.notify(co,{subCommand:t,callBack:i,value:r});break;case"inserttext":this.observer.notify(po,{subCommand:t,callBack:i,value:r});break;case"clear":this.observer.notify(ho,{subCommand:t,event:n,callBack:i,selector:s,enterAction:a});break;case"actions":this.observer.notify(cr,{subCommand:t,event:n,callBack:i,selector:s})}},e}(),_o=function(){var e=function(t,n){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(t,n)};return function(t,n){function i(){this.constructor=t}e(t,n),t.prototype=null===n?Object.create(n):(i.prototype=n.prototype,new i)}}(),Qo=function(e){function n(n){var i=e.call(this)||this;return i.initialize(),t.extend(i,i,n,!0),i.currentDocument&&i.element&&i.updateFormatter(i.element,i.currentDocument,n.options),i}return _o(n,e),n.prototype.initialize=function(){this.keyConfig=Mr},n.prototype.updateFormatter=function(e,t,n){e&&t&&(this.editorManager=new zo({document:t,editableElement:e,options:n}))},n}(yr),Vo={bold:!1,italic:!1,subscript:!1,superscript:!1,strikethrough:!1,orderedlist:!1,unorderedlist:!1,underline:!1,alignments:null,backgroundcolor:null,fontcolor:null,fontname:null,fontsize:null,formats:null,createlink:!1,insertcode:!1},Wo=function(){function e(){}return e.get=function(e,t,n,i,r,o){for(var s=JSON.parse(JSON.stringify(Vo)),a=JSON.parse(JSON.stringify(Vo)),l=new uo,d=o?[o]:l.getNodeCollection(l.getRange(e)),c=d.length,p=!1,h=l.getRange(e),u=0;u<d.length;u++){for(;3===d[u].nodeType&&3===h.startContainer.nodeType&&d[u].parentNode&&d[u].parentNode.lastElementChild&&"BR"!==d[u].parentNode.lastElementChild.nodeName&&0===this.getImmediateBlockNode(d[u].parentNode).textContent.replace(/\u200B/g,"").length&&0===h.startContainer.textContent.replace(/\u200B/g,"").length&&0===l.get(e).toString().replace(/\u200B/g,"").length;)d[u]=d[u].parentNode.lastElementChild.firstChild,p=!0;p&&d[u]&&(l.setCursorPoint(e,d[u],d[u].textContent.length),p=!1),("BR"!==d[u].nodeName&&3!==d[u].nodeType||c>1&&3===d[u].nodeType&&""===d[u].textContent.trim())&&(d.splice(u,1),u--)}for(u=0;u<d.length;u++)s=this.getFormatParent(e,s,d[u],t,n,i,r),(0===u&&s.bold||!s.bold)&&(a.bold=s.bold),(0===u&&s.insertcode||!s.insertcode)&&(a.insertcode=s.insertcode),(0===u&&s.italic||!s.italic)&&(a.italic=s.italic),(0===u&&s.underline||!s.underline)&&(a.underline=s.underline),(0===u&&s.strikethrough||!s.strikethrough)&&(a.strikethrough=s.strikethrough),(0===u&&s.superscript||!s.superscript)&&(a.superscript=s.superscript),(0===u&&s.subscript||!s.subscript)&&(a.subscript=s.subscript),(0===u&&s.fontcolor||!s.fontcolor)&&(a.fontcolor=s.fontcolor),(0===u&&s.fontname||!s.fontname)&&(a.fontname=s.fontname),(0===u&&s.fontsize||!s.fontsize)&&(a.fontsize=s.fontsize),(0===u&&s.backgroundcolor||!s.backgroundcolor)&&(a.backgroundcolor=s.backgroundcolor),(0===u&&s.orderedlist||!s.orderedlist)&&(a.orderedlist=s.orderedlist),(0===u&&s.unorderedlist||!s.unorderedlist)&&(a.unorderedlist=s.unorderedlist),(0===u&&s.alignments||!s.alignments)&&(a.alignments=s.alignments),(0===u&&s.formats||!s.formats)&&(a.formats=s.formats),(0===u&&s.createlink||!s.createlink)&&(a.createlink=s.createlink),(0===u&&s.numberFormatList||!s.numberFormatList)&&(a.numberFormatList=s.numberFormatList),(0===u&&s.bulletFormatList||!s.bulletFormatList)&&(a.bulletFormatList=s.bulletFormatList),s=JSON.parse(JSON.stringify(Vo));return a},e.getImmediateBlockNode=function(e){do{e=e.parentNode}while(e&&oo.indexOf(e.nodeName.toLocaleLowerCase())<0);return e},e.getFormatParent=function(e,t,n,i,r,o,s){if(i.contains(n)||3===n.nodeType&&3!==i.nodeType&&i.contains(n.parentNode))do{t=this.isFormattedNode(e,t,n,r,o,s),n=n.parentNode}while(n&&n!==i);return t},e.isFormattedNode=function(e,t,n,i,r,o){return t.bold||(t.bold=Io.isBold(n)),t.italic||(t.italic=Io.isItalic(n)),t.underline||(t.underline=Io.isUnderline(n)),t.strikethrough||(t.strikethrough=Io.isStrikethrough(n)),t.superscript||(t.superscript=Io.isSuperscript(n)),t.subscript||(t.subscript=Io.isSubscript(n)),t.fontcolor||(t.fontcolor=this.isFontColor(e,n)),t.fontname||(t.fontname=this.isFontName(e,n,o)),t.fontsize||(t.fontsize=this.isFontSize(n,r)),t.backgroundcolor||(t.backgroundcolor=this.isBackgroundColor(n)),t.orderedlist||(t.orderedlist=this.isOrderedList(n)),t.unorderedlist||(t.unorderedlist=this.isUnorderedList(n)),t.alignments||(t.alignments=this.isAlignment(n)),t.formats||(t.formats=this.isFormats(n,i),"pre"===t.formats&&(t.insertcode=!0)),t.createlink||(t.createlink=this.isLink(n)),t.numberFormatList||(t.numberFormatList=this.isNumberFormatList(n)),t.bulletFormatList||(t.bulletFormatList=this.isBulletFormatList(n)),t},e.isFontColor=function(e,t){var n=t.style&&t.style.color;return null!==n&&void 0!==n&&""!==n||3===t.nodeType||(n=this.getComputedStyle(e,t,"color")),null!==n&&""!==n&&void 0!==n?n:null},e.isLink=function(e){return"a"===e.nodeName.toLocaleLowerCase()},e.isBackgroundColor=function(e){var t=e.style&&e.style.backgroundColor;return null!==t&&""!==t&&void 0!==t?t:null},e.isFontSize=function(e,t){var n=e.style&&e.style.fontSize;return null!==n&&""!==n&&void 0!==n&&(null===t||void 0===t||t.indexOf(n)>-1)?n:null},e.isFontName=function(e,t,n){var i=t.style&&t.style.fontFamily;null!==i&&void 0!==i&&""!==i||3===t.nodeType||(i=this.getComputedStyle(e,t,"font-family"));var r=null;return null!==i&&""!==i&&void 0!==i&&(null===n||void 0===n||n.filter(function(e,t){var n=new RegExp(i,"i");(e.replace(/"/g,"").replace(/ /g,"")===i.replace(/"/g,"").replace(/ /g,"")||e.search(n)>-1)&&(r=t)})&&null!==r)?null!==r?n[r]:i.replace(/"/g,""):null},e.isOrderedList=function(e){return"ol"===e.nodeName.toLocaleLowerCase()},e.isUnorderedList=function(e){return"ul"===e.nodeName.toLocaleLowerCase()},e.isAlignment=function(e){var t=e.style&&e.style.textAlign;return"left"===t?"justifyleft":"center"===t?"justifycenter":"right"===t?"justifyright":"justify"===t?"justifyfull":null},e.isFormats=function(e,t){return(void 0===t||null===t)&&oo.indexOf(e.nodeName.toLocaleLowerCase())>-1||null!==t&&void 0!==t&&t.indexOf(e.nodeName.toLocaleLowerCase())>-1?e.nodeName.toLocaleLowerCase():null},e.getComputedStyle=function(e,t,n){return e.defaultView.getComputedStyle(t,null).getPropertyValue(n)},e.isNumberFormatList=function(e){var t=e.style&&e.style.listStyleType;return"lower-alpha"===t?"Lower Alpha":"number"===t?"Number":"upper-alpha"===t?"Upper Alpha":"lower-roman"===t?"Lower Roman":"upper-roman"===t?"Upper Roman":"lower-greek"===t?"Lower Greek":"none"===t?"None":null},e.isBulletFormatList=function(e){var t=e.style&&e.style.listStyleType;return"circle"===t?"Circle":"square"===t?"Square":"none"===t?"None":"disc"===t?"Disc":null},e}(),Ko=function(){function e(e){this.parent=e,this.toolbarStatus=this.prevToolbarStatus={bold:!1,italic:!1,subscript:!1,superscript:!1,strikethrough:!1,orderedlist:!1,unorderedlist:!1,underline:!1,alignments:null,backgroundcolor:null,fontcolor:null,fontname:null,fontsize:null,formats:null,createlink:!1,insertcode:!1},this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.on(z,this.onRefreshHandler,this),this.parent.on(F,this.removeEventListener,this)},e.prototype.removeEventListener=function(){this.parent.off(z,this.onRefreshHandler),this.parent.off(F,this.removeEventListener)},e.prototype.onRefreshHandler=function(e){if(!this.parent.readonly){var t=[],n=[],i=[];this.parent.fontSize.items.forEach(function(e){t.push(e.value)}),this.parent.fontFamily.items.forEach(function(e){n.push(e.value)}),this.parent.format.types.forEach(function(e){i.push(e.value.toLocaleLowerCase())}),this.toolbarStatus=Wo.get(this.parent.contentModule.getDocument(),this.parent.contentModule.getEditPanel(),i,t,n,e.documentNode);var r=JSON.stringify(this.toolbarStatus);this.parent.notify(Q,this.toolbarStatus),JSON.stringify(this.prevToolbarStatus)!==r&&(this.parent.notify(Nt,{html:JSON.parse(r),markdown:null}),this.prevToolbarStatus=JSON.parse(r))}},e}(),Go=function(){function e(e,t){this.parent=e,this.serviceLocator=t}return e.prototype.renderPanel=function(){var e=this.parent,t=this.parent.createElement("div",{className:"e-rte-content",id:this.parent.getID()+"rte-view"}),n=T(e.value,e);this.editableElement=this.parent.createElement("div",{className:"e-content",id:this.parent.getID()+"_rte-edit-view",attrs:{contenteditable:"true"},innerHTML:n}),t.appendChild(this.editableElement),this.setPanel(t),e.element.appendChild(t)},e.prototype.getPanel=function(){return this.contentPanel},e.prototype.getEditPanel=function(){return this.editableElement},e.prototype.getText=function(){return this.getEditPanel().innerText},e.prototype.setPanel=function(e){this.contentPanel=e},e.prototype.getDocument=function(){return this.getEditPanel().ownerDocument},e}(),Xo=function(){var e=function(t,n){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(t,n)};return function(t,n){function i(){this.constructor=t}e(t,n),t.prototype=null===n?Object.create(n):(i.prototype=n.prototype,new i)}}(),Yo=function(e){function n(){return null!==e&&e.apply(this,arguments)||this}return Xo(n,e),n.prototype.renderPanel=function(){var e=this.parent,t="\n<!DOCTYPE html> \n    <html>\n         <head>\n            <meta charset='utf-8' /> \n            <style>\n                @charset \"UTF-8\";\n                body {\n                    font-family: \"Roboto\", sans-serif;\n                    font-size: 14px;\n                }\n                html, body{height: 100%;margin: 0;}\n                body.e-cursor{cursor:default}\n                span.e-selected-node\t{background-color: #939393;color: white;}\n                span.e-selected-node.e-highlight {background-color: #1d9dd8;}\n                body{color:#333;word-wrap:break-word;padding: 8px;box-sizing: border-box;}\n                .e-rte-image {border: 0;cursor: pointer;display:\n                    block;float: none;height: auto;margin: 5px auto;max-width: 100%;position: relative;}\n                .e-img-caption { display: inline-block; float: none; margin: 5px auto; max-width: 100%;position: relative;}\n                .e-img-caption.e-caption-inline {display: inline-block;float: none;\n                    margin: 5px auto;margin-left: 5px;margin-right: 5px;max-width: calc(100% - (2 * 5px));\n                    position: relativetext-align: center;vertical-align: bottom;}\n                .e-img-inner {box-sizing: border-box;display: block;font-size: 16px;font-weight: initial;\n                    margin: auto;opacity: .9;text-align: center;width: 100%;}\n                .e-img-wrap {display: inline-block;margin: auto;padding: 0;text-align: center;width: 100%;}\n                .e-imgleft {float: left;margin: 0 5px 0 0;text-align: left;}\n                .e-imgright {float: right;margin: 0 0 0 5px;text-align: right;}\n                .e-imgcenter {cursor: pointer;display: block;float: none;height: auto;margin: 5px auto;max-width: 100%;position: relative;}\n                .e-control img:not(.e-resize) {border: 2px solid transparent; z-index: 1000}\n                .e-imginline {display: inline-block;float: none;margin-left: 5px;margin-right: 5px;\n                    max-width: calc(100% - (2 * 5px));vertical-align: bottom;}\n                .e-imgbreak {border: 0;cursor: pointer;\n                    display: block;float: none;height: auto;margin: 5px auto;max-width: 100%;position: relative;}\n                .e-rte-image.e-img-focus:not(.e-resize) {border: solid 2px #4a90e2;}\n                img.e-img-focus::selection { background: transparent;color: transparent;}\n                span.e-rte-imageboxmark {  width: 10px; height: 10px; position: absolute; display: block;\n                    background: #4a90e2; border: 1px solid #fff; z-index: 1000;}\n                .e-mob-rte.e-mob-span span.e-rte-imageboxmark { background: #4a90e2; border: 1px solid #fff; }\n                .e-mob-rte span.e-rte-imageboxmark { background: #fff; border: 1px solid #4a90e2;\n                    border-radius: 15px; height: 20px; width: 20px; }\n                .e-mob-rte.e-mob-span span.e-rte-imageboxmark { background: #4a90e2; border: 1px solid #fff; }\n                .e-rte-content .e-content img.e-resize { z-index: 1000; }\n                .e-img-caption .e-img-inner { outline: 0; }\n                .e-img-caption a:focus-visible { outline: none; }\n                .e-img-caption .e-rte-image.e-imgright, .e-img-caption .e-rte-image.e-imgleft { float: none; margin: 0;}\n                body{box-sizing: border-box;min-height: 100px;outline: 0 solid transparent;\n                    overflow-x: auto;padding: 16px;position: relative;text-align: inherit;z-index: 2;}\n                p{margin: 0 0 10px;margin-bottom: 10px;}\n                li{margin-bottom: 10px;}\n                h1{font-size: 2.17em;font-weight: 400;line-height: 1;margin: 10px 0;}\n                h2{font-size: 1.74em;font-weight: 400;margin: 10px 0;}\n                h3{font-size: 1.31em;font-weight: 400;margin: 10px 0;}\n                h4{font-size: 16px;font-weight: 400;line-height: 1.5;margin: 0;}\n                h5{font-size: 00.8em;font-weight: 400;margin: 0;}\n                h6{font-size: 00.65em;font-weight: 400;margin: 0;}\n                blockquote{margin: 10px 0;margin-left: 0;padding-left: 5px;border-left: solid 2px #5c5c5c;}\n                pre{background-color: inherit;border: 0;border-radius: 0;color: #333;\n                    font-size: inherit;line-height: inherit;margin: 0 0 10px;overflow: visible;padding: 0;\n                    white-space: pre-wrap;word-break: inherit;word-wrap: break-word;}\n                strong, b{font-weight: 700;}\n                a{text-decoration: none;user-select: auto;}\n                a:hover{text-decoration: underline;};\n                p:last-child, pre:last-child, blockquote:last-child{margin-bottom: 0;}\n                h3+h4, h4+h5, h5+h6{margin-top: 00.6em;}\n                ul:last-child{margin-bottom: 0;}\n                table { border-collapse: collapse; empty-cells: show;}\n                table td,table th {border: 1px solid #BDBDBD; height: 20px; vertical-align: middle;}\n                table.e-alternate-border tbody tr:nth-child(2n) {background-color: #F5F5F5;}\n                table th {background-color: #E0E0E0;}\n                table.e-dashed-border td,table.e-dashed-border th { border: 1px dashed #BDBDBD} \n                table .e-cell-select {border: 1px double #4a90e2;}\n                span.e-table-box { cursor: nwse-resize; display: block; height: 10px; position: absolute; width: 10px; }\n                span.e-table-box.e-rmob {height: 14px;width: 14px;}\n                .e-row-resize, .e-column-resize { background-color: transparent; background-repeat: repeat;\n                    bottom: 0;cursor: col-resize;height: 1px;overflow: visible;position: absolute;width: 1px; }\n                .e-row-resize { cursor: row-resize; height: 1px;}\n                .e-table-rhelper { cursor: col-resize; opacity: .87;position: absolute;}\n                .e-table-rhelper.e-column-helper { width: 1px; }\n                .e-table-rhelper.e-row-helper {height: 1px;}\n                .e-reicon::before { border-bottom: 6px solid transparent; border-right: 6px solid;\n                    border-top: 6px solid transparent; content: ''; display: block; height: 0;\n                    position: absolute; right: 4px; top: 4px; width: 20px; }\n                .e-reicon::after { border-bottom: 6px solid transparent; border-left: 6px solid;\n                    border-top: 6px solid transparent; content: ''; display: block;\n                    height: 0; left: 4px; position: absolute; top: 4px; width: 20px; z-index: 3; }\n                .e-row-helper.e-reicon::after { top: 10px; transform: rotate(90deg); }\n                .e-row-helper.e-reicon::before { left: 4px; top: -20px; transform: rotate(90deg); }\n                span.e-table-box { background-color: #ffffff; border: 1px solid #BDBDBD; }\n                span.e-table-box.e-rbox-select { background-color: #BDBDBD; border: 1px solid #BDBDBD; }\n                .e-table-rhelper { background-color: #4a90e2;}\n                .e-rtl { direction: rtl; }\n            </style>\n        </head>"+('<body spellcheck="false" autocorrect="off" contenteditable="true">'+T(e.value,e)+"</body></html>"),n=this.parent.createElement("iframe",{id:this.parent.getID()+"_rte-view",className:"e-rte-content",styles:"display:block;",attrs:{srcdoc:t}});this.setPanel(n),e.element.appendChild(n),n.contentDocument.body.id=this.parent.getID()+"_rte-edit-view",n.contentDocument.body.setAttribute("aria-owns",this.parent.getID()),n.contentDocument.open(),t=this.setThemeColor(t,{color:"#333"}),n.contentDocument.write(t),n.contentDocument.close(),e.enableRtl&&this.contentPanel.contentDocument.body.setAttribute("class","e-rtl")},n.prototype.setThemeColor=function(e,t){var n=getComputedStyle(this.parent.element,".e-richtexteditor").getPropertyValue("color");return e.replace(t.color,n)},n.prototype.getEditPanel=function(){return t.isNullOrUndefined(this.contentPanel.contentDocument)?this.parent.inputElement:this.contentPanel.contentDocument.body},n.prototype.getDocument=function(){return this.getEditPanel().ownerDocument},n}(Go),Jo=function(){function e(e){this.parent=e,this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.on(mt,this.enableXhtmlValidation,this),this.parent.on(F,this.removeEventListener,this)},e.prototype.removeEventListener=function(){this.parent.off(mt,this.enableXhtmlValidation),this.parent.off(F,this.removeEventListener)},e.prototype.enableXhtmlValidation=function(){this.parent.enableXhtml&&(t.isNullOrUndefined(this.parent.inputElement)?this.currentElement=this.parent.element:this.currentElement=this.parent.inputElement,this.clean(this.currentElement),this.AddRootElement(),this.ImageTags(),this.removeTags(),this.RemoveUnsupported(),this.currentElement.innerHTML=this.selfEncloseValidation(this.currentElement.innerHTML,"\n"===this.currentElement.innerText?this.currentElement.innerText.length:this.currentElement.innerText.trim().length),this.parent.setProperties({value:this.currentElement.innerHTML},!0))},e.prototype.selfEncloseValidation=function(e,t){if(0===t&&e.indexOf("table")<0&&e.indexOf("img")<0){var n=e.split("&nbsp;");n[n.length-1]="&#8203;"+n[n.length-1],e=n.join("")}e=e.replace(/<br>/g,"<br/>").replace(/<hr>/g,"<hr/>").replace(/ /g," ");for(var i,r=[],o=[],s=[/<img(.*?)>/gi,/<area(.*?)>/gi,/<base(.*?)>/gi,/<col (.*?)>/gi,/<embed(.*?)>/gi,/<input(.*?)>/gi,/<link(.*?)>/gi,/<meta(.*?)>/gi,/<param(.*?)>/gi,/<source(.*?)>/gi,/<track(.*?)>/gi,/<wbr(.*?)>/gi],a=0;a<s.length;a++){for(i=s[a].exec(e);null!==i;)r.push(i[0].toString()),i=s[a].exec(e);o=r.slice(0);for(var l=0;l<r.length;l++)-1!==r[l].indexOf("/")&&r[l].lastIndexOf("/")===r[l].length-2||(r[l]=r[l].substr(0,r[l].length-1)+" /"+r[l].substr(r[l].length-1,r[l].length));for(var d=0;d<=r.length-1;d++)e=e.replace(o[d],r[d])}return e},e.prototype.AddRootElement=function(){if(1===this.currentElement.childNodes.length&&"DIV"!==this.currentElement.firstChild.nodeName||this.currentElement.childNodes.length>1){for(var e=this.parent.createElement("div");this.currentElement.childNodes.length>0;)e.appendChild(this.currentElement.childNodes[0]);this.currentElement.appendChild(e)}},e.prototype.clean=function(e){for(var t=0;t<e.childNodes.length;t++){var n=e.childNodes[t];8===n.nodeType||"V:IMAGE"===n.nodeName?(e.removeChild(n),t--):1===n.nodeType&&this.clean(n)}return this.currentElement.innerHTML},e.prototype.ImageTags=function(){for(var e=this.currentElement.querySelectorAll("IMG"),t=e.length-1;t>=0;t--)if(!e[t].hasAttribute("alt")){e[t].setAttribute("alt","")}},e.prototype.removeTags=function(){for(var e=[["br","ul"],["br","ol"],["table","span"],["div","span"],["p","span"]],t=0;t<e.length;t++)this.RemoveElementNode(e[t][0],e[t][1])},e.prototype.RemoveElementNode=function(e,n){for(var i=this.currentElement.querySelectorAll(n),r=0;r<i.length;r++)for(var o=i[r].querySelectorAll(e),s=o.length;s>0;s--)t.detach(o[s-1])},e.prototype.RemoveUnsupported=function(){for(var e=this.currentElement.querySelectorAll("u"),n=e.length-1;n>=0;n--){var i=this.parent.createElement("span");i.style.textDecoration="underline",i.innerHTML=e[n].innerHTML,e[n].parentNode.insertBefore(i,e[n]),t.detach(e[n])}var r=this.currentElement.querySelectorAll("strong");for(n=r.length-1;n>=0;n--){var o=this.parent.createElement("b");o.innerHTML=r[n].innerHTML,r[n].parentNode.insertBefore(o,r[n]),t.detach(r[n])}var s=["language","role","target","contenteditable","cellspacing","cellpadding","border","valign","colspan"];for(n=0;n<=s.length;n++)this.RemoveAttributeByName(s[n])},e.prototype.RemoveAttributeByName=function(e){if(null!==this.currentElement.firstChild&&3!==this.currentElement.firstChild.nodeType)for(var t=0;t<this.currentElement.childNodes.length;t++){var n=this.currentElement.childNodes[t];if(3!==n.nodeType&&"TABLE"!==n.nodeName&&"TBODY"!==n.nodeName&&"THEAD"!==n.nodeName&&"TH"!==n.nodeName&&"TR"!==n.nodeName&&"TD"!==n.nodeName&&(n.hasAttribute(e)&&n.removeAttribute(e),n.hasChildNodes()))for(var i=0;i<n.childNodes.length;i++){var r=n.childNodes[i];if(3!==r.nodeType&&"TABLE"!==r.nodeName&&"TBODY"!==r.nodeName&&"THEAD"!==r.nodeName&&"TH"!==r.nodeName&&"TR"!==r.nodeName&&"TD"!==r.nodeName&&r.hasAttribute(e)&&r.removeAttribute(e),r.hasChildNodes())for(var o=0;o<r.childNodes.length;o++)3!==r.childNodes[o].nodeType&&"TABLE"!==r.childNodes[o].nodeName&&"TBODY"!==r.childNodes[o].nodeName&&"THEAD"!==r.childNodes[o].nodeName&&"TH"!==r.childNodes[o].nodeName&&"TR"!==r.childNodes[o].nodeName&&"TD"!==r.childNodes[o].nodeName&&r.childNodes[o].hasAttribute(e)&&r.childNodes[o].removeAttribute(e)}}},e}(),$o=function(){function n(e,t){this.rangeCollection=[],this.isImageDelete=!1,this.parent=e,this.locator=t,this.renderFactory=this.locator.getService("rendererFactory"),this.xhtmlValidation=new Jo(e),this.addEventListener()}return n.prototype.destroy=function(){this.removeEventListener()},n.prototype.sanitizeHelper=function(e){return e=x(e,this.parent)},n.prototype.addEventListener=function(){this.parent.isDestroyed||(this.nodeSelectionObj=new uo,this.colorPickerModule=new tr(this.parent,this.locator),this.parent.on(A,this.instantiateRenderer,this),this.parent.on(K,this.onToolbarClick,this),this.parent.on($,this.onKeyDown,this),this.parent.on(J,this.onKeyUp,this),this.parent.on(W,this.renderColorPicker,this),this.parent.on(H,this.render,this),this.parent.on(Y,this.onPropertyChanged,this),this.parent.on(F,this.destroy,this),this.parent.on(_e,this.selectAll,this),this.parent.on(Qe,this.selectRange,this),this.parent.on(Ve,this.getSelectedHtml,this),this.parent.on(Me,this.onSelectionSave,this),this.parent.on(Re,this.onSelectionRestore,this),this.parent.on(Ze,this.updateReadOnly,this),this.parent.on(Ke,this.onPaste,this))},n.prototype.updateReadOnly=function(){this.parent.readonly?(t.attributes(this.parent.contentModule.getEditPanel(),{contenteditable:"false"}),t.addClass([this.parent.element],Un)):(t.attributes(this.parent.contentModule.getEditPanel(),{contenteditable:"true"}),t.removeClass([this.parent.element],Un))},n.prototype.onSelectionSave=function(){var e=this.contentRenderer.getDocument(),t=this.nodeSelectionObj.getRange(e);this.saveSelection=this.nodeSelectionObj.save(t,e)},n.prototype.onSelectionRestore=function(e){this.parent.isBlur=!1,this.contentRenderer.getEditPanel().focus(),(t.isNullOrUndefined(e.items)||e.items)&&this.saveSelection.restore()},n.prototype.onKeyUp=function(e){var n,i=e.args,r=this.parent.getRange(),o=new RegExp(String.fromCharCode(8203),"g");[8,9,13,16,17,18,20,27,37,38,39,40,44,45,46,91,112,113,114,115,116,117,118,119,120,121,122,123].indexOf(i.keyCode)<0&&!i.shiftKey&&!i.ctrlKey&&!i.altKey&&(8203===r.startContainer.textContent.charCodeAt(0)&&(n=r.startOffset-1,r.startContainer.textContent=r.startContainer.textContent.replace(o,""),this.parent.formatter.editorManager.nodeSelection.setCursorPoint(this.parent.contentModule.getDocument(),r.startContainer,n)),!t.isNullOrUndefined(r.startContainer.previousSibling)&&!t.isNullOrUndefined(r.startContainer.previousSibling.parentElement)&&r.startContainer.parentElement===r.startContainer.previousSibling.parentElement&&8203===r.startContainer.previousSibling.textContent.charCodeAt(0)&&r.startContainer.previousSibling.textContent.length<=1&&(r.startContainer.previousSibling.textContent=r.startContainer.previousSibling.textContent.replace(o,"")),8203===r.endContainer.textContent.charCodeAt(r.endOffset)&&(n=r.startOffset,r.endContainer.textContent=r.endContainer.textContent.replace(o,""),this.parent.formatter.editorManager.nodeSelection.setCursorPoint(this.parent.contentModule.getDocument(),r.startContainer,n)))},n.prototype.onKeyDown=function(e){var n,i=this,r=e.args;if("chrome"===t.Browser.info.name&&(n=this.parent.getRange(),this.backSpaceCleanup(e,n),this.deleteCleanup(e,n)),9===r.keyCode&&this.parent.enableTabKey&&!t.isNullOrUndefined(r.target)&&t.isNullOrUndefined(t.closest(r.target,".e-rte-toolbar"))){var o=this.nodeSelectionObj.getRange(this.contentRenderer.getDocument()),s=this.nodeSelectionObj.getParentNodeCollection(o);if("LI"!==s[0].nodeName&&!t.closest(s[0],"li")&&!t.closest(s[0],"table")||0!==o.startOffset)if(r.preventDefault(),r.shiftKey){if(this.rangeCollection.length>0&&4===this.rangeCollection[this.rangeCollection.length-1].startContainer.textContent.length){var a=this.rangeCollection[this.rangeCollection.length-1].startContainer;this.nodeSelectionObj.setSelectionText(this.contentRenderer.getDocument(),a,a,0,a.textContent.length),Co.Insert(this.contentRenderer.getDocument(),document.createTextNode("")),this.rangeCollection.pop()}}else Co.Insert(this.contentRenderer.getDocument(),"&nbsp;&nbsp;&nbsp;&nbsp;"),this.rangeCollection.push(this.nodeSelectionObj.getRange(this.contentRenderer.getDocument()))}if("space"!==e.args.action&&"enter"!==e.args.action&&13!==e.args.keyCode||(this.spaceLink(e.args),"HTML"!==this.parent.editorMode||this.parent.readonly||this.parent.notify(tt,{args:e.args})),"space"===e.args.action){var l=this.parent.getRange(),d=l.startContainer.textContent.slice(0,l.startOffset),c=this.isOrderedList(d),p=this.isUnOrderedList(d);if(c&&!p||p&&!c){var h={callBack:null,event:e.args,name:"keydown-handler"},u={cancel:!1,item:{command:"Lists",subCommand:c?"OL":"UL"},name:"actionBegin",originalEvent:e.args,requestType:c?"OL":"UL"};this.parent.trigger(be,u,function(t){t.cancel||(i.parent.formatter.editorManager.observer.notify("onBegin",h),i.parent.trigger(ve,{editorMode:i.parent.editorMode,elements:i.parent.formatter.editorManager.domNode.blockNodes(),event:e.args,name:ve,range:i.parent.getRange(),requestType:c?"OL":"UL"}))})}}"chrome"!==t.Browser.info.name||(t.isNullOrUndefined(this.rangeElement)||t.isNullOrUndefined(this.oldRangeElement))&&(t.isNullOrUndefined(this.deleteRangeElement)||t.isNullOrUndefined(this.deleteOldRangeElement))||"TD"===n.startContainer.parentElement.tagName||"TH"===n.startContainer.parentElement.tagName||(this.rangeElement=null,this.oldRangeElement=null,this.deleteRangeElement=null,this.deleteOldRangeElement=null,this.isImageDelete||r.preventDefault())},n.prototype.isOrderedList=function(e){e=e.replace(/\u200B/g,"");var n=[/^[1]+[.]+$/,/^[i]+[.]+$/,/^[a]+[.]+$/];if(!t.isNullOrUndefined(e))for(var i=0;i<n.length;i++)if(n[i].test(e))return!0;return!1},n.prototype.isUnOrderedList=function(e){e=e.replace(/\u200B/g,"");var n=[/^[*]$/,/^[-]$/];if(!t.isNullOrUndefined(e))for(var i=0;i<n.length;i++)if(n[i].test(e))return!0;return!1},n.prototype.backSpaceCleanup=function(e,n){var i=!1;if("Backspace"===e.args.code&&8===e.args.keyCode&&0===n.startOffset&&0===n.endOffset&&0===this.parent.getSelection().length&&n.startContainer.textContent.length>0&&"TD"!==n.startContainer.parentElement.tagName&&"TH"!==n.startContainer.parentElement.tagName){if(this.rangeElement=this.getRootBlockNode(n.startContainer),"OL"===this.rangeElement.tagName||"UL"===this.rangeElement.tagName){var r=this.getRangeLiNode(n.startContainer);r.previousElementSibling&&r.previousElementSibling.childElementCount>0&&(this.oldRangeElement="BR"===r.previousElementSibling.lastElementChild.nodeName?r.previousElementSibling:r.previousElementSibling.lastElementChild,t.isNullOrUndefined(r.lastElementChild)||"BR"===r.lastElementChild.nodeName?this.rangeElement=r:(this.rangeElement=r.lastElementChild,i=!0))}else{if("TABLE"===this.rangeElement.tagName||!t.isNullOrUndefined(this.rangeElement.previousElementSibling)&&"TABLE"===this.rangeElement.previousElementSibling.tagName)return;this.oldRangeElement=this.rangeElement.previousElementSibling}if(t.isNullOrUndefined(this.oldRangeElement))return;if("OL"!==this.oldRangeElement.tagName&&"UL"!==this.oldRangeElement.tagName||(this.oldRangeElement=this.oldRangeElement.lastElementChild.lastElementChild?this.oldRangeElement.lastElementChild.lastElementChild:this.oldRangeElement.lastElementChild),this.parent.formatter.editorManager.nodeSelection.setCursorPoint(this.parent.contentModule.getDocument(),this.oldRangeElement,this.oldRangeElement.childNodes.length),this.oldRangeElement.querySelector("BR")&&t.detach(this.oldRangeElement.querySelector("BR")),!t.isNullOrUndefined(this.rangeElement)&&this.oldRangeElement!==this.rangeElement){for(;this.rangeElement.firstChild;)this.oldRangeElement.appendChild(this.rangeElement.childNodes[0]);i?t.detach(this.rangeElement.parentElement):t.detach(this.rangeElement),this.oldRangeElement.normalize()}}},n.prototype.deleteCleanup=function(e,n){var i,r,o=!1;if("Delete"===e.args.code&&46===e.args.keyCode&&0!==this.parent.contentModule.getText().trim().length&&0===this.parent.getSelection().length&&"TD"!==n.startContainer.parentElement.tagName&&"TH"!==n.startContainer.parentElement.tagName){if(this.deleteRangeElement=r=this.getRootBlockNode(n.startContainer),"OL"===this.deleteRangeElement.tagName||"UL"===this.deleteRangeElement.tagName)(i=this.getRangeLiNode(n.startContainer)).nextElementSibling&&i.nextElementSibling.childElementCount>0&&!i.nextElementSibling.querySelector("BR")?t.isNullOrUndefined(i.lastElementChild)?this.deleteRangeElement=i:(this.deleteRangeElement=i.lastElementChild,o=!0):this.deleteRangeElement=this.getRangeElement(i);else if(3===this.deleteRangeElement.nodeType||"TABLE"===this.deleteRangeElement.tagName||!t.isNullOrUndefined(this.deleteRangeElement.nextElementSibling)&&"TABLE"===this.deleteRangeElement.nextElementSibling.tagName)return;if(this.getCaretIndex(n,this.deleteRangeElement)===this.deleteRangeElement.textContent.length){if(t.isNullOrUndefined(i)?this.deleteOldRangeElement=this.deleteRangeElement.nextElementSibling:o||!t.isNullOrUndefined(i.nextElementSibling)?this.deleteOldRangeElement=this.getRangeElement(i.nextElementSibling):this.deleteOldRangeElement=r.nextElementSibling,t.isNullOrUndefined(this.deleteOldRangeElement))return;if(0===n.startOffset&&1===n.endOffset&&"IMG"===this.deleteRangeElement.childNodes[0].nodeName?(this.parent.formatter.editorManager.nodeSelection.setSelectionText(this.parent.contentModule.getDocument(),this.deleteRangeElement,this.deleteRangeElement,0,1),this.isImageDelete=!0):(this.parent.formatter.editorManager.nodeSelection.setCursorPoint(this.parent.contentModule.getDocument(),this.deleteRangeElement,this.deleteRangeElement.childNodes.length),this.isImageDelete=!1),this.deleteRangeElement.querySelector("BR")&&t.detach(this.deleteRangeElement.querySelector("BR")),t.isNullOrUndefined(this.deleteRangeElement)||"OL"===this.deleteOldRangeElement.tagName||"UL"===this.deleteOldRangeElement.tagName||this.deleteOldRangeElement===this.deleteRangeElement)this.deleteRangeElement=null,this.deleteOldRangeElement=null;else{for(;this.deleteOldRangeElement.firstChild;)this.deleteRangeElement.appendChild(this.deleteOldRangeElement.childNodes[0]);o?t.detach(this.deleteOldRangeElement.parentElement):t.detach(this.deleteOldRangeElement),this.deleteRangeElement.normalize()}}else this.deleteRangeElement=null}},n.prototype.getCaretIndex=function(e,t){var n=0;if(0!==this.parent.contentModule.getDocument().getSelection().rangeCount){var i=e.cloneRange();i.selectNodeContents(t),i.setEnd(e.endContainer,e.endOffset),n=i.toString().length}return n},n.prototype.getRangeElement=function(e){return e.lastElementChild?"BR"===e.lastElementChild.tagName?e.lastElementChild.previousElementSibling?e.lastElementChild.previousElementSibling:e:e.lastElementChild:e},n.prototype.getRootBlockNode=function(e){for(;e&&this.parent&&this.parent.inputElement!==e&&e.parentElement!==this.parent.inputElement;e=e)e=e.parentElement;return e},n.prototype.getRangeLiNode=function(e){for(var t=e.parentElement;t!==this.parent.inputElement&&(1!==t.nodeType||"LI"!==t.tagName);)t=t.parentElement;return t},n.prototype.onPaste=function(e){var n=new RegExp(/([^\S]|^)(((https?\:\/\/)|(www\.))(\S+))/gi);if(e.text.match(n)){if(e.isWordPaste)return;e.args.preventDefault();for(var i=this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument()),r=(this.parent.formatter.editorManager.nodeSelection.save(i,this.parent.contentModule.getDocument()),new RegExp(/([^\S]|^)(((https?\:\/\/)))/gi)),o=new RegExp(/([^\S]|^)(((www\.))(\S+))/gi),s=e.text.split("\n"),a="",l=0;l<s.length;l++)if(""===s[l].trim())a+=k(this.parent);else{for(var d="",c=!0,p=s[l].split(" "),h=0;h<p.length;h++)""===p[h].trim()?d+=c?"&nbsp;":" ":(c=!1,d+=p[h]+" ");a+=0===l?"<span>"+d.trim()+"</span>":"<p>"+d.trim()+"</p>"}var u=this.parent.createElement("div");u.setAttribute("class","pasteContent"),u.style.display="inline",u.innerHTML=a.replace("&para","&amp;para");var m=u.querySelectorAll("span, p");for(l=0;l<m.length;l++){var g=m[l].innerHTML.split(" "),f="";for(h=0;h<g.length;h++)g[h].match(r)||g[h].match(o)?f+='<a className="e-rte-anchor" href="'+g[h]+'" title="'+g[h]+'"target="_blank">'+g[h]+" </a>":f+=g[h]+" ";m[l].innerHTML=f.trim()}t.isNullOrUndefined(this.parent.pasteCleanupModule)?this.parent.formatter.editorManager.execCommand("insertHTML",null,null,null,u):e.callBack(u.innerHTML)}},n.prototype.spaceLink=function(e){var t=this.nodeSelectionObj.getRange(this.contentRenderer.getDocument()),n=this.nodeSelectionObj.getParentNodeCollection(t),i=t.startContainer.textContent.substr(0,t.endOffset),r=i.split(" "),o=r[r.length-1],s=t.startOffset-(i.length-r[r.length-1].length);o=o.slice(0,s);var a=new RegExp(/([^\S]|^)(((https?\:\/\/)|(www\.))(\S+))/gi);if("A"!==n[0].nodeName&&o.match(a)){var l=this.nodeSelectionObj.save(t,this.parent.contentModule.getDocument()),d={url:o.indexOf("http")>-1?o:"http://"+o,selection:l,selectParent:this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(t),text:o,title:"",target:"_blank"};this.parent.formatter.process(this.parent,{item:{command:"Links",subCommand:"CreateLink"}},e,d)}},n.prototype.onToolbarClick=function(e){var n,i,r,o=e.item,s=t.closest(e.originalEvent.target,".e-rte-quick-popup");if(s&&!s.classList.contains("e-rte-inline-popup")){if("SourceCode"!==o.subCommand&&"Preview"!==o.subCommand&&"FontColor"!==o.subCommand&&"BackgroundColor"!==o.subCommand){I()&&"Images"===o.command&&this.nodeSelectionObj.restore();var a=this.nodeSelectionObj.getRange(this.parent.contentModule.getDocument());n=this.nodeSelectionObj.save(a,this.parent.contentModule.getDocument()),i=this.nodeSelectionObj.getNodeCollection(a),r=this.nodeSelectionObj.getParentNodeCollection(a)}"Images"===o.command&&this.parent.notify(ae,{member:"image",args:e,selectNode:i,selection:n,selectParent:r}),"Links"===o.command&&this.parent.notify(le,{member:"link",args:e,selectNode:i,selection:n,selectParent:r}),"Table"===o.command&&this.parent.notify(Je,{member:"table",args:e,selectNode:i,selection:n,selectParent:r})}else{var l=document.getElementById(this.parent.getID()+"_rtelink"),d=document.getElementById(this.parent.getID()+"_image");if("SourceCode"!==o.subCommand&&"Preview"!==o.subCommand&&"FontColor"!==o.subCommand&&"BackgroundColor"!==o.subCommand){a=this.nodeSelectionObj.getRange(this.parent.contentModule.getDocument());t.isNullOrUndefined(l)&&t.isNullOrUndefined(d)&&(n=this.nodeSelectionObj.save(a,this.parent.contentModule.getDocument())),i=this.nodeSelectionObj.getNodeCollection(a),r=this.nodeSelectionObj.getParentNodeCollection(a)}switch(o.subCommand){case"Maximize":this.parent.notify(ne,{args:e});break;case"Minimize":this.parent.notify(ie,{args:e});break;case"CreateLink":this.parent.notify(ue,{member:"link",args:e,selectNode:i,selection:n,selectParent:r});break;case"RemoveLink":this.parent.notify(me,{member:"link",args:e,selectNode:i,selection:n,selectParent:r});break;case"Print":this.parent.print();break;case"Image":this.parent.notify(Se,{member:"image",args:e,selectNode:i,selection:n,selectParent:r});break;case"CreateTable":this.parent.notify(Xe,{member:"table",args:e,selection:n});break;case"SourceCode":this.parent.notify(Oe,{member:"viewSource",args:e});break;case"Preview":this.parent.notify(xe,{member:"updateSource",args:e});break;case"FontColor":case"BackgroundColor":break;case"File":this.parent.notify(bt,{member:"fileManager",args:e,selectNode:i,selection:n,selectParent:r});break;default:this.parent.formatter.process(this.parent,e,e.originalEvent,null)}}},n.prototype.renderColorPicker=function(e){this.colorPickerModule.renderColorPickerInput(e)},n.prototype.instantiateRenderer=function(){this.parent.iframeSettings.enable?this.renderFactory.addRenderer(e.RenderType.Content,new Yo(this.parent,this.locator)):this.renderFactory.addRenderer(e.RenderType.Content,new Go(this.parent,this.locator))},n.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(H,this.render),this.parent.off(Y,this.onPropertyChanged),this.parent.off(K,this.onToolbarClick),this.parent.off(W,this.renderColorPicker),this.parent.off(F,this.destroy),this.parent.off($,this.onKeyDown),this.parent.off(A,this.instantiateRenderer),this.parent.off(_e,this.selectAll),this.parent.off(Qe,this.selectRange),this.parent.off(Ve,this.getSelectedHtml),this.parent.off(Me,this.onSelectionSave),this.parent.off(Re,this.onSelectionRestore),this.parent.off(Ze,this.updateReadOnly),this.parent.off(Ke,this.onPaste))},n.prototype.render=function(){this.contentRenderer=this.renderFactory.getRenderer(e.RenderType.Content);var n=this.contentRenderer.getEditPanel(),i={undoRedoSteps:this.parent.undoRedoSteps,undoRedoTimer:this.parent.undoRedoTimer};if(t.isNullOrUndefined(this.parent.formatter)){var r=new Qo({currentDocument:this.contentRenderer.getDocument(),element:n,options:i});this.parent.setProperties({formatter:r},!0)}else this.parent.formatter.updateFormatter(n,this.contentRenderer.getDocument(),i);this.parent.enableXhtml&&this.parent.notify(mt,{}),this.parent.toolbarSettings.enable&&(this.toolbarUpdate=new Ko(this.parent)),this.parent.inlineMode.enable&&(t.isNullOrUndefined(this.parent.fontFamily.default)||(n.style.fontFamily=this.parent.fontFamily.default),t.isNullOrUndefined(this.parent.fontSize.default)||(n.style.fontSize=this.parent.fontSize.default)),this.parent.notify(V,{})},n.prototype.onPropertyChanged=function(e){if(!t.isNullOrUndefined(e.newProp.formatter)){var n=this.contentRenderer.getEditPanel(),i={undoRedoSteps:this.parent.undoRedoSteps,undoRedoTimer:this.parent.undoRedoTimer};this.parent.formatter.updateFormatter(n,this.contentRenderer.getDocument(),i)}},n.prototype.getModuleName=function(){return"htmlEditor"},n.prototype.selectAll=function(){var e=N(this.parent.contentModule.getDocument(),this.parent.contentModule.getEditPanel());e.length>0&&this.parent.formatter.editorManager.nodeSelection.setSelectionText(this.parent.contentModule.getDocument(),e[0],e[e.length-1],0,e[e.length-1].textContent.length)},n.prototype.selectRange=function(e){this.parent.formatter.editorManager.nodeSelection.setRange(this.parent.contentModule.getDocument(),e.range)},n.prototype.getSelectedHtml=function(e){e.callBack(this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument()).toString())},n}(),Zo=function(){function n(e,t){this.inlineNode=["a","abbr","acronym","audio","b","bdi","bdo","big","br","button","canvas","cite","code","data","datalist","del","dfn","em","embed","font","i","iframe","img","input","ins","kbd","label","map","mark","meter","noscript","object","output","picture","progress","q","ruby","s","samp","script","select","slot","small","span","strong","sub","sup","svg","template","textarea","time","u","tt","var","video","wbr"],this.blockNode=["div","h1","h2","h3","h4","h5","h6","address","blockquote","button","center","dd","dir","dl","dt","fieldset","frameset","hr","iframe","isindex","li","map","menu","noframes","noscript","object","ol","pre","td","tr","th","tbody","tfoot","thead","table","ul","header","article","nav","footer","section","aside","main","figure","figcaption"],this.isNotFromHtml=!1,this.containsHtml=!1,this.parent=e,this.locator=t,this.renderFactory=this.locator.getService("rendererFactory"),this.i10n=t.getService("rteLocale"),this.dialogRenderObj=t.getService("dialogRenderObject"),this.addEventListener()}return n.prototype.addEventListener=function(){this.nodeSelectionObj=new uo,this.parent.isDestroyed||(this.parent.on(et,this.pasteClean,this),this.parent.on(F,this.destroy,this))},n.prototype.destroy=function(){this.removeEventListener()},n.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(et,this.pasteClean),this.parent.off(F,this.destroy))},n.prototype.pasteClean=function(n){var i,r=this,o={requestType:"Paste",editorMode:this.parent.editorMode,event:n},s=null;if(n.args&&!t.isNullOrUndefined(n.args.clipboardData)&&(s=n.args.clipboardData.getData("text/html")),this.parent.trigger(Ct,{value:s}),n.args&&null!==s&&"HTML"===this.parent.editorMode){if(0===s.length){var a=new RegExp(/<\/[a-z][\s\S]*>/i);s=n.args.clipboardData.getData("text/plain"),this.isNotFromHtml=""!==s,s=(s=s.replace(/</g,"&lt;")).replace(/>/g,"&gt;"),this.containsHtml=a.test(s);var l=n&&n.args.clipboardData&&n.args.clipboardData.items.length>0?n.args.clipboardData.items[0].getAsFile():null;if(this.parent.notify(Ke,{file:l,args:n.args,text:s,callBack:function(e){"object"==typeof(i=e)?r.parent.formatter.editorManager.execCommand("Images","Image",n.args,r.imageFormatting.bind(r,o),"pasteCleanup",i,"pasteCleanupModule"):s=i}}),!a.test(s)){var d=this.parent.createElement("div");d.innerHTML=this.splitBreakLine(s),s=d.innerHTML}}else s.length>0&&this.parent.formatter.editorManager.observer.notify(br,{args:n.args,text:n.text,allowedStylePropertiesArray:this.parent.pasteCleanupSettings.allowedStyleProps,callBack:function(e){s=e.trim()}});this.contentRenderer=this.renderFactory.getRenderer(e.RenderType.Content);var c=this.contentRenderer.getDocument(),p=this.nodeSelectionObj.getRange(c);if(this.saveSelection=this.nodeSelectionObj.save(p,c),this.parent.trigger(St,{value:s},function(e){s=e.value}),this.parent.pasteCleanupSettings.prompt){n.args.preventDefault();var h=this.parent.createElement("div");h.innerHTML=s,""===h.textContent&&t.isNullOrUndefined(h.querySelector("img"))&&t.isNullOrUndefined(h.querySelector("table"))||this.pasteDialog(s,o)}else this.parent.pasteCleanupSettings.plainText?(n.args.preventDefault(),this.plainFormatting(s,o)):this.parent.pasteCleanupSettings.keepFormat?(n.args.preventDefault(),this.formatting(s,!1,o)):(n.args.preventDefault(),this.formatting(s,!0,o))}},n.prototype.splitBreakLine=function(e){for(var t=e.split("\n"),n="",i=0;i<t.length;i++)if(""===t[i].trim())n+=k(this.parent);else{n+="<p>"+this.makeSpace(t[i]).trim()+"</p>"}return n},n.prototype.makeSpace=function(e){for(var t="",n=!0,i=e.split(" "),r=0;r<i.length;r++)""===i[r].trim()?t+=n?"&nbsp;":" ":(n=!1,t+=i[r]+" ");return t},n.prototype.imgUploading=function(e){var n=e.querySelectorAll(".pasteContent_Img");if(this.parent.insertImageSettings.saveUrl&&n.length>0){for(var i=[],r=[],o=[],s=0;s<n.length;s++)n[s].getAttribute("src").split(",")[0].indexOf("base64")>=0&&(i.push(n[s].getAttribute("src")),r.push(t.getUniqueID("rte_image")),o.push(n[s]));var a=[];for(s=0;s<i.length;s++)a.push(this.base64ToFile(i[s],r[s]));for(s=0;s<a.length;s++)this.uploadMethod(a[s],o[s]);t.isNullOrUndefined(this.parent.insertImageSettings.path)&&"Blob"===this.parent.insertImageSettings.saveFormat&&this.getBlob(n)}else"Blob"===this.parent.insertImageSettings.saveFormat&&this.getBlob(n);var l=e.querySelectorAll(".pasteContent_Img");for(s=0;s<l.length;s++)l[s].classList.remove("pasteContent_Img"),""===l[s].getAttribute("class").trim()&&n[s].removeAttribute("class")},n.prototype.getBlob=function(e){for(var n=0;n<e.length;n++)if(!t.isNullOrUndefined(e[n].getAttribute("src"))&&e[n].getAttribute("src").split(",")[0].indexOf("base64")>=0){var i=URL.createObjectURL(D(e[n].getAttribute("src")));e[n].setAttribute("src",i)}},n.prototype.toolbarEnableDisable=function(e){this.parent.inlineMode.enable||this.parent.toolbarModule.baseToolbar.toolbarObj.disable(e)},n.prototype.uploadMethod=function(e,n){var i=this,s=document.createElement("div");document.body.appendChild(s),s.setAttribute("display","none"),n.style.opacity="0.5";var a=this.parent.createElement("div");this.parent.element.appendChild(a);var l=this.parent.createElement("input",{id:this.parent.element.id+"_upload",attrs:{type:"File",name:"UploadFiles"}}),d=this.parent.iframeSettings.enable?-50:-90,c=new r.Popup(a,{relateTo:n,height:"85px",width:"300px",offsetY:d,content:l,viewPortElement:this.parent.element,position:{X:"center",Y:"top"},enableRtl:this.parent.enableRtl,zIndex:10001,close:function(e){i.parent.isBlur=!1,c.destroy(),t.detach(c.element)}});c.element.style.display="none",t.addClass([c.element],[ti,ei]);var p=e.size>1e6?300:100;setTimeout(function(){i.refreshPopup(n,c)},p);var h,u,m=new o.Uploader({asyncSettings:{saveUrl:this.parent.insertImageSettings.saveUrl,removeUrl:this.parent.insertImageSettings.removeUrl},cssClass:ii,dropArea:this.parent.inputElement,allowedExtensions:this.parent.insertImageSettings.allowedTypes.toString(),success:function(e){setTimeout(function(){i.popupClose(c,m,n,e)},900)},uploading:function(e){i.parent.isServerRendered||i.parent.trigger(dt,e,function(e){e.cancel?(t.isNullOrUndefined(n)||t.detach(n),t.isNullOrUndefined(c.element)||t.detach(c.element)):i.parent.inputElement.contentEditable="false"})},beforeUpload:function(e){i.parent.isServerRendered?((u=JSON.parse(JSON.stringify(e))).filesData=h,e.cancel=!0,i.parent.trigger(dt,u,function(e){e.cancel||(i.toolbarEnableDisable(!0),m.currentRequestHeader=e.currentRequest?e.currentRequest:m.currentRequestHeader,m.customFormDatas=e.customFormData&&e.customFormData.length>0?e.customFormData:m.customFormDatas,m.uploadFiles(h,null))})):(i.parent.trigger(gt,e),i.toolbarEnableDisable(!0))},failure:function(e){setTimeout(function(){i.uploadFailure(n,m,c,e)},900)},canceling:function(){i.parent.inputElement.contentEditable="true"," "===n.nextSibling.textContent&&t.detach(n.nextSibling),t.detach(n),c.close()},selected:function(e){e.cancel=!0,i.parent.isServerRendered&&(h=e.filesData)},removing:function(){i.parent.inputElement.contentEditable="true"," "===n.nextSibling.textContent&&t.detach(n.nextSibling),t.detach(n),c.close()}});m.appendTo(c.element.childNodes[0]);var g=[{name:e.name,rawFile:e,size:e.size,type:e.type,validationMessages:{minSize:"",maxSize:""},statusCode:"1"}];m.createFileList(g),m.filesData.push(g[0]),h=g,m.upload(g),c.element.getElementsByClassName("e-file-select-wrap")[0].style.display="none",t.detach(c.element.querySelector(".e-rte-dialog-upload .e-file-select-wrap"))},n.prototype.uploadFailure=function(e,n,i,r){this.parent.inputElement.contentEditable="true",t.detach(e),i&&i.close(),this.parent.trigger(pt,r),n.destroy()},n.prototype.popupClose=function(e,n,i,r){var o=this;this.parent.inputElement.contentEditable="true",r.element=i,this.parent.trigger(ct,r,function(e){if(!t.isNullOrUndefined(o.parent.insertImageSettings.path)){var n=o.parent.insertImageSettings.path+e.file.name;i.src=n,i.setAttribute("alt",e.file.name)}}),e.close(),i.style.opacity="1",n.destroy(),this.toolbarEnableDisable(!1)},n.prototype.refreshPopup=function(e,t){(this.parent.iframeSettings.enable?this.parent.element.offsetTop+e.offsetTop:e.offsetTop)>this.parent.element.offsetTop+this.parent.element.offsetHeight?(t.relateTo=this.parent.inputElement,t.offsetY=this.parent.iframeSettings.enable?-30:-65,t.element.style.display="block"):t&&(t.refreshPosition(e),t.element.style.display="block")},n.prototype.base64ToFile=function(e,n){for(var i=e.split(","),r=i[0].match(/:(.*?);/)[1].split("/")[1],o=atob(i[1]),s=o.length,a=new Uint8Array(s);s--;)a[s]=o.charCodeAt(s);if(t.Browser.isIE||navigator.appVersion.indexOf("Edge")>-1){var l=new Blob([a],{type:r});return t.extend(l,{name:n+"."+(t.isNullOrUndefined(r)?"":r)}),l}return new File([a],n+"."+(t.isNullOrUndefined(r)?"":r),{type:r})},n.prototype.imageFormatting=function(t,n){var i=this.parent.createElement("span");i.appendChild(n.elements[0]);var r=i.innerHTML;this.contentRenderer=this.renderFactory.getRenderer(e.RenderType.Content);var o=this.contentRenderer.getDocument(),s=this.nodeSelectionObj.getRange(o);this.saveSelection=this.nodeSelectionObj.save(s,o),this.parent.pasteCleanupSettings.prompt?this.pasteDialog(r,t):this.parent.pasteCleanupSettings.plainText?this.plainFormatting(r,t):this.parent.pasteCleanupSettings.keepFormat?this.formatting(r,!1,t):this.formatting(r,!0,t)},n.prototype.radioRender=function(){var e=new s.RadioButton({label:this.i10n.getConstant("keepFormat"),name:"pasteOption",checked:!0});e.isStringTemplate=!0;var t=this.parent.element.querySelector("#keepFormating");e.appendTo(t);var n=new s.RadioButton({label:this.i10n.getConstant("cleanFormat"),name:"pasteOption"});n.isStringTemplate=!0;var i=this.parent.element.querySelector("#cleanFormat");n.appendTo(i);var r=new s.RadioButton({label:this.i10n.getConstant("plainText"),name:"pasteOption"});r.isStringTemplate=!0;var o=this.parent.element.querySelector("#plainTextFormat");r.appendTo(o)},n.prototype.selectFormatting=function(e,t,n,i){n?this.formatting(e,!1,t):i?this.formatting(e,!0,t):this.plainFormatting(e,t)},n.prototype.pasteDialog=function(e,t){var n=this,i=!1,r=this.parent.height,o={buttons:[{click:function(){if(!s.isDestroyed){var o=n.parent.element.querySelector("#keepFormating").checked,a=n.parent.element.querySelector("#cleanFormat").checked;s.hide(),n.parent.height=i?r:n.parent.height,i=!1;var l=s;n.dialogRenderObj.close(l),s.destroy(),n.selectFormatting(e,t,o,a)}},buttonModel:{isPrimary:!0,cssClass:"e-flat "+Gn,content:this.i10n.getConstant("pasteDialogOk")}},{click:function(){if(!s.isDestroyed){s.hide(),n.parent.height=i?r:n.parent.height,i=!1;var e=s;n.dialogRenderObj.close(e),s.destroy()}},buttonModel:{cssClass:"e-flat "+Xn,content:this.i10n.getConstant("pasteDialogCancel")}}],header:this.i10n.getConstant("pasteFormat"),content:this.i10n.getConstant("pasteFormatContent")+'<br/><div><div style="padding-top:24px;"><input type="radio" class="'+Vn+'" id="keepFormating"/></div><div style="padding-top:20px;"><input type="radio" class="'+Wn+'" id="cleanFormat"/></div><div style="padding-top:20px;"><input type="radio" class="'+Kn+'" id="plainTextFormat"/></div></div>',target:this.parent.element,width:"300px",height:"265px",cssClass:Yn,isModal:!0,visible:!1},s=this.dialogRenderObj.render(o),a=this.parent.element.querySelector("#"+this.parent.getID()+"_pasteCleanupDialog");null!==a&&""!==a.innerHTML&&this.destroyDialog(a),null===a&&(a=this.parent.createElement("div",{id:this.parent.getID()+"_pasteCleanupDialog"}),this.parent.element.appendChild(a)),s.appendTo(a),this.radioRender(),this.parent.element.offsetHeight<parseInt(s.height.split("px")[0],null)&&(this.parent.height=parseInt(s.height.split("px")[0],null)+40,i=!0),s.show()},n.prototype.destroyDialog=function(e){var n=this.parent.element.querySelector(".e-dlg-container");t.detach(n);for(var i=e.children.length,r=0;r<i;r++)t.detach(e.children[0])},n.prototype.formatting=function(e,n,i){var r=this,o=this.parent.createElement("div",{className:"pasteContent",styles:"display:inline;"});this.isNotFromHtml&&this.containsHtml&&(e=this.splitBreakLine(e)),o.innerHTML=e,null!==this.parent.pasteCleanupSettings.deniedTags&&(o=this.deniedTags(o)),n?o=this.deniedAttributes(o,n):null!==this.parent.pasteCleanupSettings.deniedAttrs&&(o=this.deniedAttributes(o,n)),null!==this.parent.pasteCleanupSettings.allowedStyleProps&&(o=this.allowedStyle(o)),this.saveSelection.restore(),o.innerHTML=this.sanitizeHelper(o.innerHTML);for(var s=o.querySelectorAll("img"),a=0;a<s.length;a++)s[a].classList.add("pasteContent_Img"),"auto"!==this.parent.insertImageSettings.width&&s[a].setAttribute("width",this.parent.insertImageSettings.width),"0"!==this.parent.insertImageSettings.minWidth&&0!==this.parent.insertImageSettings.minWidth&&(s[a].style.minWidth=this.parent.insertImageSettings.minWidth.toString()),null!==this.parent.insertImageSettings.maxWidth&&(s[a].style.maxWidth=this.parent.getInsertImgMaxWidth().toString()),"auto"!==this.parent.insertImageSettings.height&&s[a].setAttribute("height",this.parent.insertImageSettings.height),"0"!==this.parent.insertImageSettings.minHeight&&0!==this.parent.insertImageSettings.minHeight&&(s[a].style.minHeight=this.parent.insertImageSettings.minHeight.toString()),null!==this.parent.insertImageSettings.maxHeight&&(s[a].style.maxHeight=this.parent.insertImageSettings.maxHeight.toString());this.addTempClass(o),""===o.textContent&&t.isNullOrUndefined(o.querySelector("img"))&&t.isNullOrUndefined(o.querySelector("table"))||(this.parent.formatter.editorManager.execCommand("inserthtml","pasteCleanup",i,function(e){t.extend(i,{elements:e.elements,imageElements:e.imgElem},!0),r.parent.formatter.onSuccess(r.parent,i)},o),this.removeTempClass(),this.parent.notify(z,{}),this.imgUploading(this.parent.inputElement),this.parent.iframeSettings.enable&&this.parent.updateValue())},n.prototype.addTempClass=function(e){for(var t=e.children,n=0;n<t.length;n++)t[n].classList.add("pasteContent_RTE")},n.prototype.removeTempClass=function(){for(var e=this.parent.inputElement.querySelectorAll(".pasteContent_RTE"),t=0;t<e.length;t++)e[t].classList.remove("pasteContent_RTE"),""===e[t].getAttribute("class")&&e[t].removeAttribute("class")},n.prototype.sanitizeHelper=function(e){return e=x(e,this.parent)},n.prototype.plainFormatting=function(e,n){var i=this,r=this.parent.createElement("div",{className:"pasteContent",styles:"display:inline;"});if(r.innerHTML=e,this.detachInlineElements(r),this.getTextContent(r),""!==r.textContent.trim()){if(!t.isNullOrUndefined(r.firstElementChild)&&"BR"!==r.firstElementChild.tagName){var o=r.firstElementChild;if(!t.isNullOrUndefined(r.firstElementChild)){for(var s=this.parent.createElement("span"),a=0,l=0;a<o.childNodes.length;a++,l++)if("#text"===o.childNodes[a].nodeName)s.appendChild(o.childNodes[a]),r.insertBefore(s,r.firstElementChild),a--;else{if("#text"===o.childNodes[a].nodeName||0!==l)break;for(var d=0;d<o.childNodes[a].childNodes.length;d++)s.appendChild(o.childNodes[a].childNodes[d]),r.insertBefore(s,r.firstElementChild),d--;a--}o.hasChildNodes()||t.detach(o)}}this.removeEmptyElements(r),this.saveSelection.restore(),r.innerHTML=this.sanitizeHelper(r.innerHTML),this.addTempClass(r),this.parent.formatter.editorManager.execCommand("inserthtml","pasteCleanup",n,function(e){t.extend(n,{elements:e.elements,imageElements:e.imgElem},!0),i.parent.formatter.onSuccess(i.parent,n)},r),this.removeTempClass()}else this.saveSelection.restore(),t.extend(n,{elements:[]},!0),this.parent.formatter.onSuccess(this.parent,n)},n.prototype.getTextContent=function(e){for(var n=0;n<this.blockNode.length;n++)for(var i=e.querySelectorAll(this.blockNode[n]),r=0;r<i.length;r++){for(var o=void 0,s=0,a=0,l=void 0;s<i[r].childNodes.length;s++,a++)if("DIV"===i[r].childNodes[s].nodeName||"P"===i[r].childNodes[s].nodeName||"#text"===i[r].childNodes[s].nodeName&&"&nbsp;"!==i[r].childNodes[s].nodeValue.replace(/\u00a0/g,"&nbsp;")&&""===i[r].childNodes[s].textContent.trim())o=i[r].childNodes[s].parentElement,i[r].childNodes[s].parentElement.parentElement.insertBefore(i[r].childNodes[s],i[r].childNodes[s].parentElement),s--;else{if(o=i[r].childNodes[s].parentElement,"text"===l){o.previousElementSibling.appendChild(i[r].childNodes[s])}else{var d=this.parent.createElement("div",{id:"newDiv"});d.appendChild(i[r].childNodes[s]),o.parentElement.insertBefore(d,o)}s--,l="text"}t.isNullOrUndefined(o)||t.detach(o)}var c=e.querySelectorAll("*");for(n=0;n<c.length;n++){var p=c[n].attributes;for(r=0;r<p.length;r++)c[n].removeAttribute(p[r].name),r--}},n.prototype.detachInlineElements=function(e){for(var n=0;n<this.inlineNode.length;n++)for(var i=e.querySelectorAll(this.inlineNode[n]),r=0;r<i.length;r++){for(var o=void 0,s=0;s<i[r].childNodes.length;s++)o=i[r].childNodes[s].parentElement,i[r].childNodes[s].parentElement.parentElement.insertBefore(i[r].childNodes[s],i[r].childNodes[s].parentElement),s--;t.isNullOrUndefined(o)||t.detach(o)}},n.prototype.findDetachEmptyElem=function(e){return t.isNullOrUndefined(e.parentElement)?null:""===e.parentElement.textContent.trim()&&"pasteContent"!==e.parentElement.getAttribute("class")?this.findDetachEmptyElem(e.parentElement):e},n.prototype.removeEmptyElements=function(e){for(var n=e.querySelectorAll(":empty"),i=0;i<n.length;i++)if("BR"!==n[i].tagName){var r=this.findDetachEmptyElem(n[i]);t.isNullOrUndefined(r)||t.detach(r)}},n.prototype.tagGrouping=function(e){for(var t=e.slice(),n=Object.keys(Ir),i=n.map(function(e){return Ir[e]}),r=[],o=0;o<t.length;o++)if(t[o].split("[").length>1&&(t[o]=t[o].split("[")[0].trim()),n.indexOf(t[o])>-1)for(var s=0;s<i[n.indexOf(t[o])].length;s++)t.indexOf(i[n.indexOf(t[o])][s])<0&&r.indexOf(i[n.indexOf(t[o])][s])<0&&r.push(i[n.indexOf(t[o])][s]);return e=e.concat(r)},n.prototype.attributesfilter=function(e){for(var t=0;t<e.length;t++)if(e[t].split("[").length>1){for(var n=e[t].split("[")[1].split("]")[0].split(","),i=[],r=[],o=0;o<n.length;o++)n[o].indexOf("!")<0?i.push(n[o].trim()):r.push(n[o].split("!")[1].trim());var s=i.length>1?i.join("]["):i.join(),a=r.length>1?r.join("]["):r.join();if(a.length>0){var l=""!==s?e[t].split("[")[0]+"["+s+"]":e[t].split("[")[0];e[t]=l+":not(["+a+"])"}else e[t]=e[t].split("[")[0]+"["+s+"]"}return e},n.prototype.deniedTags=function(e){var n=t.isNullOrUndefined(this.parent.pasteCleanupSettings.deniedTags)?[]:this.parent.pasteCleanupSettings.deniedTags.slice();n=this.attributesfilter(n),n=this.tagGrouping(n);for(var i=0;i<n.length;i++)for(var r=e.querySelectorAll(n[i]),o=r.length-1;o>=0;o--){for(var s=r[o].parentNode;r[o].firstChild;)s.insertBefore(r[o].firstChild,r[o]);s.removeChild(r[o])}return e},n.prototype.deniedAttributes=function(e,n){var i=t.isNullOrUndefined(this.parent.pasteCleanupSettings.deniedAttrs)?[]:this.parent.pasteCleanupSettings.deniedAttrs.slice();n&&i.push("style");for(var r=0;r<i.length;r++)for(var o=e.querySelectorAll("["+i[r]+"]"),s=0;s<o.length;s++)o[s].removeAttribute(i[r]);return e},n.prototype.allowedStyle=function(e){var n=t.isNullOrUndefined(this.parent.pasteCleanupSettings.allowedStyleProps)?[]:this.parent.pasteCleanupSettings.allowedStyleProps.slice();n.push("list-style-type","list-style");for(var i=e.querySelectorAll("[style]"),r=0;r<i.length;r++){for(var o="",s=[],a=i[r].getAttribute("style").split(";"),l=0;l<a.length;l++)n.indexOf(a[l].split(":")[0].trim())>=0&&s.push(a[l]);i[r].removeAttribute("style"),(o=""===s.join(";").trim()?s.join(";"):s.join(";")+";")&&i[r].setAttribute("style",o)}return e},n.prototype.getModuleName=function(){return"pasteCleanup"},n}(),es=function(){function e(e){this.parent=e,this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.isDestroyed||(this.parent.on(H,this.renderResizable,this),this.parent.on(F,this.destroy,this))},e.prototype.renderResizable=function(){this.resizer=this.parent.createElement("div",{id:this.parent.getID()+"-resizable",className:"e-icons "+Jn+" e-south-east"}),this.parent.element.classList.add(ri),this.parent.element.appendChild(this.resizer),this.touchStartEvent="msie"===t.Browser.info.name?"pointerdown":"touchstart",t.EventHandler.add(this.resizer,"mousedown",this.resizeStart,this),t.EventHandler.add(this.resizer,this.touchStartEvent,this.resizeStart,this)},e.prototype.resizeStart=function(e){var t=this;e.cancelable&&e.preventDefault(),this.wireResizeEvents(),this.parent.notify(ft,{});var n={event:e,requestType:"editor"};this.parent.trigger(ce,n,function(e){e.cancel&&t.unwireResizeEvents()})},e.prototype.performResize=function(e){var n=this,i={event:e,requestType:"editor"};this.parent.trigger(pe,i,function(e){e.cancel&&n.unwireResizeEvents()});var r=this.parent.element.getBoundingClientRect();if(this.isMouseEvent(e))this.parent.element.style.height=e.clientY-r.top+"px",this.parent.element.style.width=e.clientX-r.left+"px";else{var o="msie"!==t.Browser.info.name?e.touches[0]:e;this.parent.element.style.height=o.clientY-r.top+"px",this.parent.element.style.width=o.clientX-r.left+"px"}this.parent.toolbarSettings.enable||this.parent.setContentHeight("",!1),this.parent.refreshUI()},e.prototype.stopResize=function(e){this.parent.refreshUI(),this.unwireResizeEvents();var t={event:e,requestType:"editor"};this.parent.trigger(he,t)},e.prototype.getEventType=function(e){return e.indexOf("mouse")>-1?"mouse":"touch"},e.prototype.isMouseEvent=function(e){var n=!1;return("mouse"===this.getEventType(e.type)||!t.isNullOrUndefined(e.pointerType)&&"mouse"===this.getEventType(e.pointerType))&&(n=!0),n},e.prototype.wireResizeEvents=function(){t.EventHandler.add(document,"mousemove",this.performResize,this),t.EventHandler.add(document,"mouseup",this.stopResize,this),this.touchMoveEvent="msie"===t.Browser.info.name?"pointermove":"touchmove",this.touchEndEvent="msie"===t.Browser.info.name?"pointerup":"touchend",t.EventHandler.add(document,this.touchMoveEvent,this.performResize,this),t.EventHandler.add(document,this.touchEndEvent,this.stopResize,this)},e.prototype.unwireResizeEvents=function(){t.EventHandler.remove(document,"mousemove",this.performResize),t.EventHandler.remove(document,"mouseup",this.stopResize),t.EventHandler.remove(document,this.touchMoveEvent,this.performResize),t.EventHandler.remove(document,this.touchEndEvent,this.stopResize)},e.prototype.destroy=function(){this.removeEventListener()},e.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(H,this.renderResizable),this.parent.element.classList.remove(ri),t.EventHandler.remove(this.resizer,"mousedown",this.resizeStart),t.EventHandler.remove(this.resizer,this.touchStartEvent,this.resizeStart),this.resizer&&t.detach(this.resizer),this.parent.off(F,this.destroy))},e.prototype.getModuleName=function(){return"resize"},e}(),ts=function(){function n(e,t){a.FileManager.Inject(a.ContextMenu,a.DetailsView,a.NavigationPane,a.Toolbar),this.parent=e,this.i10n=t.getService("rteLocale"),this.dialogRenderObj=t.getService("dialogRenderObject"),this.rendererFactory=t.getService("rendererFactory"),this.addEventListener()}return n.prototype.initialize=function(){this.parent.fileManagerModule=this,this.contentModule=this.rendererFactory.getRenderer(e.RenderType.Content)},n.prototype.render=function(e){var n,i=this;n=e.selectNode&&"IMG"===e.selectNode[0].nodeName?this.parent.localeObj.getConstant("dialogUpdate"):this.i10n.getConstant("dialogInsert");var r=this.parent.localeObj.getConstant("fileDialogHeader"),o=this.i10n.getConstant("dialogCancel");this.dlgButtons=[{click:this.insertImageUrl.bind(this),buttonModel:{content:n,cssClass:"e-flat e-insertImage",isPrimary:!0}},{click:function(e){i.cancelDialog()},buttonModel:{cssClass:"e-flat e-cancel",content:o}}],this.dlgButtons[0].buttonModel.disabled=!0,this.selectObj={selection:e.selection,args:e.args,selectParent:e.selectParent};var s=this.parent.createElement("div",{className:"e-rte-file-manager-dialog",id:this.parent.getID()+"_file-manager-dialog",attrs:{"aria-owns":this.parent.getID()}});document.body.appendChild(s),this.fileWrap=this.parent.createElement("div",{id:this.parent.getID()+"_rte-file-manager",className:"e-img-file-wrap"}),s.appendChild(this.fileWrap),s.appendChild(this.getInputUrlElement());var a={visible:!1,isModal:!0,header:r,target:document.body,locale:this.parent.locale,enableRtl:this.parent.enableRtl,cssClass:yn,animationSettings:{effect:"None"},showCloseIcon:!0,closeOnEscape:!0,width:"720px",height:"auto",position:{X:"center",Y:"center"},buttons:this.dlgButtons,created:this.renderFileManager.bind(this),close:function(e){i.parent.isBlur=!1,e&&e.event.returnValue&&i.selectObj.selection.restore(),i.destroyComponents(),i.dialogRenderObj.close(e)}};this.dialogObj=this.dialogRenderObj.render(a),this.dialogObj.createElement=this.parent.createElement,this.dialogObj.appendTo(s),this.dialogObj.show(!!t.Browser.isDevice)},n.prototype.renderFileManager=function(){var e=this,n=this;this.fileObj=new a.FileManager({allowMultiSelection:!1,locale:this.parent.locale,enableRtl:this.parent.enableRtl,path:this.parent.fileManagerSettings.path,view:this.parent.fileManagerSettings.view,enablePersistence:this.parent.enablePersistence,cssClass:this.parent.fileManagerSettings.cssClass,sortOrder:this.parent.fileManagerSettings.sortOrder,ajaxSettings:this.parent.fileManagerSettings.ajaxSettings,showThumbnail:this.parent.fileManagerSettings.showThumbnail,rootAliasName:this.parent.fileManagerSettings.rootAliasName,uploadSettings:this.parent.fileManagerSettings.uploadSettings,searchSettings:this.parent.fileManagerSettings.searchSettings,toolbarSettings:this.parent.fileManagerSettings.toolbarSettings,showHiddenItems:this.parent.fileManagerSettings.showHiddenItems,allowDragAndDrop:this.parent.fileManagerSettings.allowDragAndDrop,showFileExtension:this.parent.fileManagerSettings.showFileExtension,detailsViewSettings:this.parent.fileManagerSettings.detailsViewSettings,contextMenuSettings:this.parent.fileManagerSettings.contextMenuSettings,navigationPaneSettings:this.parent.fileManagerSettings.navigationPaneSettings,fileSelect:function(t){var i=t.fileDetails;i.isFile&&n.parent.insertImageSettings.allowedTypes.indexOf(i.type)>-1?(n.inputUrl.value=n.parent.fileManagerSettings.ajaxSettings.getImageUrl+"?path="+(i.filterPath&&i.filterPath.replace(/\\/g,"/"))+i.name,e.dlgButtons[0].buttonModel.disabled=!1):(n.inputUrl.value="",e.dlgButtons[0].buttonModel.disabled=!0),e.dialogObj.buttons=e.dlgButtons},created:function(){e.inputUrl.removeAttribute("disabled")},success:function(){e.fileObj.refreshLayout()}}),t.Browser.isDevice&&(this.fileObj.height="85%"),this.fileObj.appendTo(this.fileWrap),t.EventHandler.add(this.parent.element.ownerDocument,"mousedown",this.onDocumentClick,this)},n.prototype.getInputUrlElement=function(){var e=this.parent.createElement("div",{className:"imgUrl"}),t=this.parent.createElement("div",{className:"e-rte-label"});t.innerHTML='<label for="rteSample_img_url">'+this.i10n.getConstant("linkWebUrl")+"</label>",e.appendChild(t);var n=this.i10n.getConstant("imageUrl");return this.inputUrl=this.parent.createElement("input",{className:"e-input e-img-url",attrs:{placeholder:n,spellcheck:"false",disabled:"true"}}),e.appendChild(this.inputUrl),e},n.prototype.insertImageUrl=function(e){var n=this.inputUrl.value;if(0===this.parent.formatter.getUndoRedoStack().length&&this.parent.formatter.saveData(),""!==n){if("HTML"===this.parent.editorMode&&t.isNullOrUndefined(t.closest(this.selectObj.selection.range.startContainer.parentNode,"#"+this.contentModule.getPanel().id))){this.contentModule.getEditPanel().focus();var i=this.parent.formatter.editorManager.nodeSelection.getRange(this.contentModule.getDocument());this.selectObj.selection=this.parent.formatter.editorManager.nodeSelection.save(i,this.contentModule.getDocument()),this.selectObj.selectParent=this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(i)}var r=/[\w-]+.(jpg|png|jpeg|gif)/g,o=t.isNullOrUndefined(n.match(r))||"HTML"!==this.parent.editorMode?"":n.match(r)[0],s={cssClass:"inline"===this.parent.insertImageSettings.display?hn:ln,url:n,selection:this.selectObj.selection,altText:o,selectParent:this.selectObj.selectParent,width:{width:this.parent.insertImageSettings.width,minWidth:this.parent.insertImageSettings.minWidth,maxWidth:this.parent.getInsertImgMaxWidth()},height:{height:this.parent.insertImageSettings.height,minHeight:this.parent.insertImageSettings.minHeight,maxHeight:this.parent.insertImageSettings.maxHeight}};this.parent.formatter.process(this.parent,this.selectObj.args,this.selectObj.args.originalEvent,s),this.dialogObj.hide({returnValue:!1})}},n.prototype.cancelDialog=function(){this.parent.isBlur=!1,this.dialogObj.hide({returnValue:!0})},n.prototype.onDocumentClick=function(e){var n=e.target,i="#document"!==n.nodeName&&!t.isNullOrUndefined(n.previousElementSibling)&&n.previousElementSibling;t.isNullOrUndefined(this.dialogObj)||t.closest(n,"#"+this.parent.getID()+"_file-manager-dialog")||t.closest(n,"#"+this.parent.getID()+"_rte-file-manager_tb_sortby-popup")||t.closest(n,"#"+this.parent.getID()+"_rte-file-manager_tb_view-popup")||t.closest(n,"#"+this.parent.getID()+"_rte-file-manager_contextmenu")||!t.isNullOrUndefined(t.closest(n,".e-contextmenu-wrapper"))&&t.closest(n,".e-contextmenu-wrapper").querySelector("#"+this.parent.getID()+"_rte-file-manager_contextmenu")||t.isNullOrUndefined(i)||i.classList.contains("e-rte-file-manager-dialog")||t.isNullOrUndefined(i)||i.id===this.parent.getID()+"_rte-file-manager_contextmenu"?this.parent.isRTE=!0:(this.dialogObj.hide({returnValue:!0}),this.parent.isBlur=!0,C(this.parent.element,"focusout"))},n.prototype.addEventListener=function(){this.parent.on(H,this.initialize,this),this.parent.on(bt,this.render,this),this.parent.on(F,this.destroy,this)},n.prototype.removeEventListener=function(){t.EventHandler.remove(this.parent.element.ownerDocument,"mousedown",this.onDocumentClick),this.parent.off(H,this.initialize),this.parent.off(bt,this.render),this.parent.off(F,this.destroy)},n.prototype.destroyComponents=function(){this.fileObj&&(this.fileObj.destroy(),this.fileObj=null),this.dialogObj&&(this.dialogObj.destroy(),t.detach(this.dialogObj.element),this.dialogObj=null)},n.prototype.destroy=function(){this.parent.isDestroyed||(this.destroyComponents(),this.removeEventListener())},n.prototype.getModuleName=function(){return"fileManager"},n}(),ns=function(){function e(e){this.parent=e,this.addEventListener()}return e.prototype.showFullScreen=function(e){var n=this;if(!0!==this.parent.toolbarSettings.enable||"Markdown"===this.parent.editorMode||t.isNullOrUndefined(this.parent.quickToolbarModule)||this.parent.quickToolbarModule.hideQuickToolbars(),this.scrollableParent=r.getScrollableParent(this.parent.element),!this.parent.element.classList.contains(jt)){var i={cancel:!1,requestType:"Maximize",targetItem:"Maximize",args:e};this.parent.trigger(be,i,function(i){i.cancel||(n.parent.toolbarSettings.enableFloating&&!n.parent.inlineMode.enable&&n.parent.toolbarSettings.enable&&(n.parent.getToolbarElement().style.width="100%",n.parent.getToolbarElement().style.top="0px"),n.parent.element.classList.add(jt),n.toggleParentOverflow(!0),n.parent.setContentHeight(),n.parent.toolbarModule&&(n.parent.getBaseToolbarObject().toolbarObj.items[0].properties||n.parent.getBaseToolbarObject().toolbarObj.removeItems(0),t.Browser.isDevice&&n.parent.toolbarModule.removeFixedTBarClass(),n.parent.toolbarModule.updateItem({targetItem:"Maximize",updateItem:"Minimize",baseToolbar:n.parent.getBaseToolbarObject()})),n.parent.trigger(ve,{requestType:"Maximize",targetItem:"Maximize",args:e}))})}},e.prototype.hideFullScreen=function(e){var n=this;if(!0!==this.parent.toolbarSettings.enable||"Markdown"===this.parent.editorMode||t.isNullOrUndefined(this.parent.quickToolbarModule)||this.parent.quickToolbarModule.hideQuickToolbars(),this.parent.element.classList.contains(jt)){var i={cancel:!1,requestType:"Minimize",targetItem:"Minimize",args:e};this.parent.trigger(be,i,function(i){if(!i.cancel){n.parent.element.classList.remove(jt);for(var r=document.querySelectorAll(".e-rte-overflow"),o=0;o<r.length;o++)t.removeClass([r[o]],["e-rte-overflow"]);n.parent.setContentHeight(),n.parent.toolbarModule&&(n.parent.getBaseToolbarObject().toolbarObj.items[0].properties||n.parent.getBaseToolbarObject().toolbarObj.removeItems(0),n.parent.toolbarModule.updateItem({targetItem:"Minimize",updateItem:"Maximize",baseToolbar:n.parent.getBaseToolbarObject()}),t.Browser.isDevice&&n.parent.inlineMode.enable&&n.parent.toolbarModule.addFixedTBarClass()),n.parent.trigger(ve,{requestType:"Minimize",targetItem:"Minimize",args:e})}})}},e.prototype.toggleParentOverflow=function(e){if(!t.isNullOrUndefined(this.scrollableParent))for(var n=0;n<this.scrollableParent.length;n++)if("#document"===this.scrollableParent[n].nodeName){var i=document.querySelector("body");t.addClass([i],["e-rte-overflow"])}else{i=this.scrollableParent[n];t.addClass([i],["e-rte-overflow"])}},e.prototype.onKeyDown=function(e){var t=e.args;switch(t.action){case"full-screen":this.showFullScreen(e.args),t.preventDefault();break;case"escape":this.hideFullScreen(e.args),t.preventDefault()}},e.prototype.addEventListener=function(){this.parent.on($,this.onKeyDown,this),this.parent.on(F,this.destroy,this)},e.prototype.removeEventListener=function(){this.parent.off($,this.onKeyDown),this.parent.off(F,this.destroy)},e.prototype.destroy=function(){this.parent.element.classList.contains(jt)&&this.toggleParentOverflow(!1);for(var e=document.querySelectorAll(".e-rte-overflow"),n=0;n<e.length;n++)t.removeClass([e[n]],["e-rte-overflow"]);this.removeEventListener()},e}(),is=function(){function t(e,t){this.parent=e,this.locator=t,this.renderer=this.locator.getService("rendererFactory"),this.addEventListener()}return t.prototype.render=function(){this.parent;this.contentRenderer=this.renderer.getRenderer(e.RenderType.Content),this.contentRenderer.renderPanel()},t.prototype.refresh=function(e){void 0===e&&(e={requestType:"refresh"}),this.parent.notify(e.requestType+"-begin",e)},t.prototype.destroy=function(){this.removeEventListener()},t.prototype.addEventListener=function(){this.parent.isDestroyed||(this.parent.on(Y,this.refresh,this),this.parent.on(J,this.keyUp,this))},t.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(Y,this.refresh),this.parent.off(J,this.keyUp))},t.prototype.keyUp=function(e){if("HTML"===this.parent.editorMode)switch(e.args.which){case 46:case 8:var t=this.parent.contentModule.getEditPanel().childNodes;if(0===t.length||1===t.length&&0===t[0].childNodes.length&&("BR"===t[0].tagName||("P"===t[0].tagName||"DIV"===t[0].tagName)&&""===t[0].textContent)){var n=this.parent.contentModule.getEditPanel();"DIV"===this.parent.enterKey?n.innerHTML="<div><br/></div>":"BR"===this.parent.enterKey?n.innerHTML="<br/>":n.innerHTML="<p><br/></p>",this.parent.formatter.editorManager.nodeSelection.setCursorPoint(this.parent.contentModule.getDocument(),n.childNodes[0],0)}}},t}(),rs=function(){function n(e,t){this.parent=e,this.rteID=e.element.id,this.i10n=t.getService("rteLocale"),this.addEventListener(),this.serviceLocator=t,this.rendererFactory=t.getService("rendererFactory"),this.dialogRenderObj=t.getService("dialogRenderObject")}return n.prototype.addEventListener=function(){this.parent.isDestroyed||(this.parent.on(ue,this.linkDialog,this),this.parent.on(Et,this.showDialog,this),this.parent.on(Tt,this.closeDialog,this),this.parent.on($,this.onKeyDown,this),this.parent.on(Ne,this.showLinkQuickToolbar,this),this.parent.on(it,this.clearDialogObj,this),this.parent.on(le,this.onToolbarAction,this),this.parent.on(j,this.onIframeMouseDown,this),this.parent.on(me,this.removeLink,this),this.parent.on(ge,this.editLink,this),this.parent.on(fe,this.openLink,this),this.parent.on(Ue,this.editAreaClickHandler,this),this.parent.on(F,this.destroy,this))},n.prototype.onToolbarAction=function(e){switch(e.args.item.subCommand){case"OpenLink":this.parent.notify(fe,e);break;case"EditLink":this.parent.notify(ge,e);break;case"RemoveLink":this.parent.notify(me,e)}},n.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(ue,this.linkDialog),this.parent.off(Et,this.showDialog),this.parent.off(Tt,this.closeDialog),this.parent.off($,this.onKeyDown),this.parent.off(Ne,this.showLinkQuickToolbar),this.parent.off(it,this.clearDialogObj),this.parent.off(le,this.onToolbarAction),this.parent.off(me,this.removeLink),this.parent.off(j,this.onIframeMouseDown),this.parent.off(ge,this.editLink),this.parent.off(fe,this.openLink),this.parent.off(Ue,this.editAreaClickHandler),this.parent.off(F,this.destroy))},n.prototype.onIframeMouseDown=function(){this.dialogObj&&this.dialogObj.hide({returnValue:!0})},n.prototype.showLinkQuickToolbar=function(e){if(!t.isNullOrUndefined(e.args)&&"enter"!==e.args.action&&"space"!==e.args.action){var n=void 0,i=void 0;if("Links"!==e.type||t.isNullOrUndefined(this.parent.quickToolbarModule)||t.isNullOrUndefined(this.parent.quickToolbarModule.linkQTBar))return;this.quickToolObj=this.parent.quickToolbarModule;var r,o=this.parent.element.getBoundingClientRect().top,s=this.parent.element.getBoundingClientRect().left,a=this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());if([].forEach.call(e.elements,function(e,t){0===t&&(r="#text"===e.nodeName?e.parentNode:e)}),e.isNotify){var l=this.parent.toolbarModule.getToolbarElement(),d=r.getBoundingClientRect().top,c=r.getBoundingClientRect().left,p=d-o,h=l?l.offsetHeight+this.parent.toolbarModule.getExpandTBarPopHeight():0;n=this.parent.iframeSettings.enable?s+c:r.getBoundingClientRect().left,i=window.pageYOffset+(this.parent.iframeSettings.enable?o+h+d:o+p)}else{var u=void 0;u=e.args.touches?e.args.changedTouches[0]:u=e.args,n=this.parent.iframeSettings.enable?window.pageXOffset+s+u.clientX:u.pageX,i=this.parent.iframeSettings.enable?window.pageYOffset+o+u.clientY:u.pageY}this.quickToolObj.linkQTBar&&this.quickToolObj.linkQTBar.showPopup(n,i,a.endContainer)}},n.prototype.hideLinkQuickToolbar=function(){this.quickToolObj&&this.quickToolObj.linkQTBar&&document.body.contains(this.quickToolObj.linkQTBar.element)&&this.quickToolObj.linkQTBar.hidePopup()},n.prototype.editAreaClickHandler=function(n){if(this.parent.readonly)this.hideLinkQuickToolbar();else{var i=n.args,r=this.parent.quickToolbarSettings.showOnRightClick;if(!(2===i.which||r&&1===i.which||!r&&3===i.which)&&"HTML"===this.parent.editorMode&&this.parent.quickToolbarModule&&this.parent.quickToolbarModule.linkQTBar){this.quickToolObj=this.parent.quickToolbarModule;var o=i.target;o=this.getAnchorNode(o),this.contentModule=this.rendererFactory.getRenderer(e.RenderType.Content);var s=this.quickToolObj.linkQTBar.element.classList.contains("e-rte-pop");if("A"===o.nodeName&&o.childNodes.length>0&&"IMG"!==o.childNodes[0].nodeName&&"IMG"!==n.args.target.nodeName&&!t.isNullOrUndefined(t.closest(this.parent.getRange().startContainer.parentElement,"A"))&&!t.isNullOrUndefined(t.closest(this.parent.getRange().endContainer.parentElement,"A"))){if(s)return;this.showLinkQuickToolbar({args:i,isNotify:!1,type:"Links",elements:[i.target]})}else this.hideLinkQuickToolbar()}}},n.prototype.onKeyDown=function(e){var n=e.args;switch(n.action){case"escape":t.isNullOrUndefined(this.dialogObj)||this.dialogObj.close();break;case"insert-link":this.openDialog(!0,e),n.preventDefault()}},n.prototype.openDialog=function(e,t){if(e||this.parent.contentModule.getEditPanel().focus(),"HTML"===this.parent.editorMode){var n=this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument()),i=this.parent.formatter.editorManager.nodeSelection.save(n,this.parent.contentModule.getDocument()),r=this.parent.formatter.editorManager.nodeSelection.getNodeCollection(n),o=this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(n),s={args:t?t.args:{item:{command:"Links",subCommand:"CreateLink"},originalEvent:void 0},selectNode:r,selection:i,selectParent:o};this.linkDialog(s)}else{var a=this.parent.contentModule.getEditPanel();this.parent.formatter.editorManager.markdownSelection.save(a.selectionStart,a.selectionEnd),this.linkDialog({args:{item:{command:"Links",subCommand:"Link"},originalEvent:t&&t.args},member:"link",text:this.parent.formatter.editorManager.markdownSelection.getSelectedText(this.parent.contentModule.getEditPanel()),module:"Markdown",name:"insertLink"})}},n.prototype.showDialog=function(){this.openDialog(!1)},n.prototype.closeDialog=function(){this.dialogObj&&this.dialogObj.hide({returnValue:!0})},n.prototype.clearDialogObj=function(){this.dialogObj&&(this.dialogObj.destroy(),t.detach(this.dialogObj.element),this.dialogObj=null)},n.prototype.linkDialog=function(e,n){var i=this;if(this.dialogObj)this.dialogObj.hide({returnValue:!0});else if("HTML"===this.parent.editorMode&&e.selectParent.length>0&&!t.isNullOrUndefined(e.selectParent[0].classList)&&e.selectParent[0].classList.contains("e-rte-anchor")&&t.isNullOrUndefined(n))this.editLink(e);else{var r=this.i10n.getConstant("linkWebUrl"),o=this.i10n.getConstant("linkText"),a=this.i10n.getConstant("linkTooltipLabel"),l=this.i10n.getConstant("linkurl"),d=this.i10n.getConstant("textPlaceholder"),c=this.i10n.getConstant("linkTitle"),p=this.parent.createElement("div",{className:"e-rte-link-dialog",id:this.rteID+"_rtelink"});this.parent.element.appendChild(p);var h=this.parent.createElement("div",{className:"e-rte-linkcontent",id:this.rteID+"_linkContent"}),u=S('<div class="e-rte-label"><label>'+r+'</label></div><div class="e-rte-field"><input type="text" data-role ="none" spellcheck="false" placeholder="'+l+'" class="e-input e-rte-linkurl"/></div><div class="e-rte-label"><label>'+o+'</label></div><div class="e-rte-field"> <input type="text" data-role ="none" spellcheck="false" class="e-input e-rte-linkText" placeholder="'+d+'"></div><div class="e-rte-label">'+("HTML"===this.parent.editorMode?"<label>"+a+'</label></div><div class="e-rte-field"><input type="text" data-role ="none" spellcheck="false" placeholder = "'+c+'" class="e-input e-rte-linkTitle"></div><div class="e-rte-label"></div><div class="e-rte-field"><input type="checkbox" class="e-rte-linkTarget"  data-role ="none"></div>':""));h.appendChild(u);var m=h.querySelector(".e-rte-linkTarget"),g=h.querySelector(".e-rte-linkurl"),f=h.querySelector(".e-rte-linkText"),b=h.querySelector(".e-rte-linkTitle"),v=this.i10n.getConstant("linkOpenInNewWindow");this.checkBoxObj=new s.CheckBox({label:v,checked:!0,enableRtl:this.parent.enableRtl}),this.checkBoxObj.isStringTemplate=!0,this.checkBoxObj.createElement=this.parent.createElement,this.checkBoxObj.appendTo(m);var y="HTML"===this.parent.editorMode?e.selection.getRange(this.parent.contentModule.getDocument()).toString():e.text,C=this.i10n.getConstant("dialogInsert"),N=this.i10n.getConstant("dialogCancel"),E=e.selection,T={selfLink:this,selection:e.selection,selectParent:e.selectParent,args:e.args},w={header:this.i10n.getConstant("linkHeader"),content:h,cssClass:yn,enableRtl:this.parent.enableRtl,locale:this.parent.locale,showCloseIcon:!0,closeOnEscape:!0,width:t.Browser.isDevice?"290px":"310px",height:"inherit",isModal:t.Browser.isDevice,buttons:[{click:this.insertlink.bind(T),buttonModel:{content:C,cssClass:"e-flat e-insertLink",isPrimary:!0}},{click:this.cancelDialog.bind(T),buttonModel:{cssClass:"e-flat",content:N}}],target:t.Browser.isDevice?document.body:this.parent.element,animationSettings:{effect:"None"},close:function(e){i.parent.isBlur=!1,e&&e.event.returnValue&&("HTML"===i.parent.editorMode?E.restore():i.parent.formatter.editorManager.markdownSelection.restore(i.parent.contentModule.getEditPanel())),i.dialogObj.destroy(),t.detach(i.dialogObj.element);var n=i.dialogObj;i.dialogRenderObj.close(n),i.dialogObj=null}};this.dialogObj=this.dialogRenderObj.render(w),this.dialogObj.createElement=this.parent.createElement,this.dialogObj.appendTo(p),p.style.maxHeight="inherit",t.isNullOrUndefined(this.dialogObj)||(t.isNullOrUndefined(n)||(g.value=n.url,f.value=n.text,b.value=n.title,n.target?this.checkBoxObj.checked=!0:this.checkBoxObj.checked=!1,this.dialogObj.header=n.header,this.dialogObj.element.querySelector(".e-insertLink").textContent=n.btnText),this.checkUrl(!1),("HTML"===this.parent.editorMode&&t.isNullOrUndefined(n)&&(!t.isNullOrUndefined(y)&&""!==y&&0===e.selection.range.startOffset||e.selection.range.startOffset!==e.selection.range.endOffset)||"Markdown"===e.module)&&(f.value=y),t.EventHandler.add(this.parent.element.ownerDocument,"mousedown",this.onDocumentClick,this),this.quickToolObj&&(this.hideLinkQuickToolbar(),this.quickToolObj.inlineQTBar&&document.body.contains(this.quickToolObj.inlineQTBar.element)&&this.quickToolObj.inlineQTBar.hidePopup()))}},n.prototype.insertlink=function(e){var n,i=this.selfLink.dialogObj.element,r=i.querySelector(".e-rte-linkurl").value,o=i.querySelector(".e-rte-linkText").value;"HTML"===this.selfLink.parent.editorMode&&(n=i.querySelector(".e-rte-linkTitle").value);var s=this.selfLink.checkBoxObj.checked?"_blank":null;if(""!==r){this.selfLink.isUrl(r)?this.selfLink.checkUrl(!1):(o=""===o?r:o,r=this.selfLink.parent.enableAutoUrl?r:r.indexOf("http")>-1?r:"http://"+r);var a=this.selfLink;if("HTML"===a.parent.editorMode&&t.isNullOrUndefined(t.closest(this.selection.range.startContainer.parentNode,"[id='"+a.parent.contentModule.getPanel().id+"']"))){a.parent.contentModule.getEditPanel().focus(),t.Browser.isIE&&a.parent.iframeSettings.enable&&this.selection.restore();var l=a.parent.formatter.editorManager.nodeSelection.getRange(a.parent.contentModule.getDocument());this.selection=a.parent.formatter.editorManager.nodeSelection.save(l,a.parent.contentModule.getDocument()),this.selectParent=a.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(l)}var d={url:r,text:o,title:n,target:s,selection:this.selection,selectParent:this.selectParent};document.body.contains(a.dialogObj.element)&&this.selfLink.dialogObj.hide({returnValue:!1}),I()&&a.parent.iframeSettings.enable&&t.select("iframe",a.parent.element).contentWindow.focus(),"HTML"===a.parent.editorMode&&this.selection.restore(),0===a.parent.formatter.getUndoRedoStack().length&&a.parent.formatter.saveData();var c;if(t.isNullOrUndefined(this.args)||"KeyK"!==this.args.code)c=this.args;else{var p=this.args;t.extend(this.args,{item:{command:"Links",subCommand:"CreateLink"},originalEvent:p},!0);c={item:{command:"Links",subCommand:"CreateLink"},originalEvent:p}}this.selfLink.parent.formatter.process(this.selfLink.parent,c,!t.isNullOrUndefined(this.args)&&this.args.originalEvent,d),this.selfLink.parent.contentModule.getEditPanel().focus()}else this.selfLink.checkUrl(!0)},n.prototype.isUrl=function(e){return/(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/gi.test(e)},n.prototype.checkUrl=function(e){var n=this.dialogObj.element.querySelector(".e-rte-linkurl");e?(t.addClass([n],"e-error"),n.setSelectionRange(0,n.value.length),n.focus()):t.removeClass([n],"e-error")},n.prototype.removeLink=function(e){0===this.parent.formatter.getUndoRedoStack().length&&this.parent.formatter.saveData(),this.parent.formatter.process(this.parent,e.args,e.args,{selectNode:e.selectNode,selectParent:e.selectParent,selection:e.selection,subCommand:e.args.item.subCommand}),I()&&this.parent.iframeSettings.enable?t.select("iframe",this.parent.element).contentWindow.focus():this.parent.contentModule.getEditPanel().focus(),this.hideLinkQuickToolbar()},n.prototype.openLink=function(e){var t=this.getAnchorNode(e.selectParent[0]);(t.classList.contains("e-rte-anchor")||"A"===t.tagName)&&this.parent.formatter.process(this.parent,e.args,e.args,{url:t.href,target:""===t.target?"_self":"_blank",selectNode:e.selectNode,subCommand:e.args.item.subCommand})},n.prototype.getAnchorNode=function(e){var n=t.closest(e,"a");return n||e},n.prototype.editLink=function(e){var t=this.getAnchorNode(e.selectNode[0]),n=this.getAnchorNode(e.selectParent[0]);if((n="A"===t.nodeName?t:n).classList.contains("e-rte-anchor")||"A"===n.tagName){var i=this.i10n.getConstant("dialogUpdate"),r={url:n.getAttribute("href"),text:n.innerText,title:n.title,target:n.target,header:this.i10n.getConstant("editLink"),btnText:i};this.linkDialog(e,r)}},n.prototype.cancelDialog=function(e){this.selfLink.parent.isBlur=!1,this.selfLink.dialogObj.hide({returnValue:!0}),I()?this.selection.restore():this.selfLink.parent.contentModule.getEditPanel().focus()},n.prototype.onDocumentClick=function(e){var n=e.target;!t.isNullOrUndefined(this.dialogObj)&&(!t.closest(n,"[id='"+this.dialogObj.element.id+"']")&&this.parent.toolbarSettings.enable&&this.parent.getToolbarElement()&&!this.parent.getToolbarElement().contains(e.target)||(this.parent.getToolbarElement()&&this.parent.getToolbarElement().contains(e.target)||this.parent.inlineMode.enable&&!t.closest(n,"#"+this.dialogObj.element.id))&&!t.closest(n,"#"+this.parent.getID()+"_toolbar_CreateLink")&&!n.querySelector("#"+this.parent.getID()+"_toolbar_CreateLink"))&&(this.dialogObj.hide({returnValue:!0}),t.EventHandler.remove(this.parent.element.ownerDocument,"mousedown",this.onDocumentClick),this.parent.isBlur=!0,C(this.parent.element,"focusout"))},n.prototype.destroy=function(){this.removeEventListener()},n.prototype.getModuleName=function(){return"link"},n}(),os=function(){function n(e,t){this.isImgUploaded=!1,this.isAllowedTypes=!0,this.pageX=null,this.pageY=null,this.deletedImg=[],this.parent=e,this.rteID=e.element.id,this.i10n=t.getService("rteLocale"),this.rendererFactory=t.getService("rendererFactory"),this.dialogRenderObj=t.getService("dialogRenderObject"),this.addEventListener()}return n.prototype.addEventListener=function(){this.parent.isDestroyed||(this.parent.on($,this.onKeyDown,this),this.parent.on(J,this.onKeyUp,this),this.parent.on(Se,this.insertImage,this),this.parent.on(wt,this.showDialog,this),this.parent.on(kt,this.closeDialog,this),this.parent.on(de,this.onWindowResize,this),this.parent.on(Ne,this.showImageQuickToolbar,this),this.parent.on(it,this.clearDialogObj,this),this.parent.on(ae,this.onToolbarAction,this),this.parent.on(ke,this.caption,this),this.parent.on(we,this.deleteImg,this),this.parent.on(Ee,this.insertImgLink,this),this.parent.on(Te,this.insertAltText,this),this.parent.on(Ue,this.editAreaClickHandler,this),this.parent.on(j,this.onIframeMouseDown,this),this.parent.on(Le,this.imageSize,this),this.parent.on(re,this.alignmentSelect,this),this.parent.on(H,this.afterRender,this),this.parent.on(yt,this.afterRender,this),this.parent.on(Ke,this.imagePaste,this),this.parent.on(F,this.removeEventListener,this))},n.prototype.removeEventListener=function(){if(!this.parent.isDestroyed){this.parent.off($,this.onKeyDown),this.parent.off(J,this.onKeyUp),this.parent.off(de,this.onWindowResize),this.parent.off(Se,this.insertImage),this.parent.off(wt,this.showDialog),this.parent.off(kt,this.closeDialog),this.parent.off(Ne,this.showImageQuickToolbar),this.parent.off(it,this.clearDialogObj),this.parent.off(ke,this.caption),this.parent.off(ae,this.onToolbarAction),this.parent.off(we,this.deleteImg),this.parent.off(Ee,this.insertImgLink),this.parent.off(Te,this.insertAltText),this.parent.off(Ue,this.editAreaClickHandler),this.parent.off(j,this.onIframeMouseDown),this.parent.off(Le,this.imageSize),this.parent.off(re,this.alignmentSelect),this.parent.off(H,this.afterRender),this.parent.off(yt,this.afterRender),this.parent.off(Ke,this.imagePaste),this.parent.off(F,this.removeEventListener);var e=this.parent.iframeSettings.enable?this.parent.inputElement.ownerDocument:this.parent.inputElement;e.removeEventListener("drop",this.dragDrop.bind(this),!0),e.removeEventListener("dragstart",this.dragStart.bind(this),!0),e.removeEventListener("dragenter",this.dragEnter.bind(this),!0),e.removeEventListener("dragover",this.dragOver.bind(this),!0),t.isNullOrUndefined(this.contentModule)||(t.EventHandler.remove(this.contentModule.getEditPanel(),t.Browser.touchEndEvent,this.imageClick),this.parent.formatter.editorManager.observer.off($e,this.undoStack),this.parent.insertImageSettings.resize&&(t.EventHandler.remove(this.parent.contentModule.getEditPanel(),t.Browser.touchStartEvent,this.resizeStart),t.EventHandler.remove(this.parent.element.ownerDocument,"mousedown",this.onDocumentClick),t.EventHandler.remove(this.contentModule.getEditPanel(),"cut",this.onCutHandler)))}},n.prototype.onIframeMouseDown=function(){this.dialogObj&&this.dialogObj.hide({returnValue:!0})},n.prototype.afterRender=function(){this.contentModule=this.rendererFactory.getRenderer(e.RenderType.Content),t.EventHandler.add(this.contentModule.getEditPanel(),t.Browser.touchEndEvent,this.imageClick,this),this.parent.insertImageSettings.resize&&(t.EventHandler.add(this.parent.contentModule.getEditPanel(),t.Browser.touchStartEvent,this.resizeStart,this),t.EventHandler.add(this.parent.element.ownerDocument,"mousedown",this.onDocumentClick,this),t.EventHandler.add(this.contentModule.getEditPanel(),"cut",this.onCutHandler,this));var n=this.parent.iframeSettings.enable?this.parent.inputElement.ownerDocument:this.parent.inputElement;n.addEventListener("drop",this.dragDrop.bind(this),!0),n.addEventListener("dragstart",this.dragStart.bind(this),!0),n.addEventListener("dragenter",this.dragOver.bind(this),!0),n.addEventListener("dragover",this.dragOver.bind(this),!0)},n.prototype.undoStack=function(e){if("undo"===e.subCommand.toLowerCase()||"redo"===e.subCommand.toLowerCase())for(var n=0;n<this.parent.formatter.getUndoRedoStack().length;n++){var i=this.parent.createElement("div"),r=S(this.parent.formatter.getUndoRedoStack()[n].text);i.appendChild(r);var o=i.querySelectorAll("img");if(i.querySelector(".e-img-resize")&&o.length>0){for(var s=0;s<o.length;s++)o[s].style.outline="";t.detach(i.querySelector(".e-img-resize")),this.parent.formatter.getUndoRedoStack()[n].text=i.innerHTML}}},n.prototype.resizeEnd=function(e){this.resizeBtnInit(),this.imgEle.parentElement.style.cursor="auto",t.Browser.isDevice&&t.removeClass([e.target.parentElement],"e-mob-span");var n={event:e,requestType:"images"};this.parent.trigger(he,n);this.getPointX(e),this.parent.iframeSettings.enable?(window.pageYOffset,this.parent.element.getBoundingClientRect().top,e.clientY):e.pageY;this.parent.formatter.editorManager.observer.on($e,this.undoStack,this),this.parent.formatter.saveData()},n.prototype.resizeStart=function(e,n){var i=this;if(!this.parent.readonly){var r=n||e.target;if(this.prevSelectedImgEle=this.imgEle,"IMG"===r.tagName){this.parent.preventDefaultResize(e);var o=r;this.imgResizeDiv&&this.contentModule.getEditPanel().contains(this.imgResizeDiv)&&t.detach(this.imgResizeDiv),this.imageResize(o)}if(r.classList.contains("e-rte-imageboxmark")){if(0===this.parent.formatter.getUndoRedoStack().length&&this.parent.formatter.saveData(),this.pageX=this.getPointX(e),this.pageY=this.getPointY(e),e.preventDefault(),e.stopImmediatePropagation(),this.resizeBtnInit(),this.quickToolObj&&this.quickToolObj.imageQTBar.hidePopup(),r.classList.contains("e-rte-topLeft")&&(this.resizeBtnStat.topLeft=!0),r.classList.contains("e-rte-topRight")&&(this.resizeBtnStat.topRight=!0),r.classList.contains("e-rte-botLeft")&&(this.resizeBtnStat.botLeft=!0),r.classList.contains("e-rte-botRight")&&(this.resizeBtnStat.botRight=!0),t.Browser.isDevice&&this.contentModule.getEditPanel().contains(this.imgResizeDiv)&&!this.imgResizeDiv.classList.contains("e-mob-span"))t.addClass([this.imgResizeDiv],"e-mob-span");else{var s={event:e,requestType:"images"};this.parent.trigger(ce,s,function(e){e.cancel&&i.cancelResizeAction()})}t.EventHandler.add(this.contentModule.getDocument(),t.Browser.touchEndEvent,this.resizeEnd,this)}}},n.prototype.imageClick=function(e){t.Browser.isDevice&&("IMG"===e.target.tagName&&"A"===e.target.parentElement.tagName||"IMG"===e.target.tagName?(this.contentModule.getEditPanel().setAttribute("contenteditable","false"),e.target.focus()):this.parent.readonly||this.contentModule.getEditPanel().setAttribute("contenteditable","true")),"IMG"===e.target.tagName&&"A"===e.target.parentElement.tagName&&e.preventDefault()},n.prototype.onCutHandler=function(){this.imgResizeDiv&&this.contentModule.getEditPanel().contains(this.imgResizeDiv)&&this.cancelResizeAction()},n.prototype.imageResize=function(e){this.resizeBtnInit(),this.imgEle=e,t.addClass([this.imgEle],"e-resize"),this.imgResizeDiv=this.parent.createElement("span",{className:"e-img-resize",id:this.rteID+"_imgResize"}),this.imgResizeDiv.appendChild(this.parent.createElement("span",{className:"e-rte-imageboxmark e-rte-topLeft",styles:"cursor: nwse-resize"})),this.imgResizeDiv.appendChild(this.parent.createElement("span",{className:"e-rte-imageboxmark e-rte-topRight",styles:"cursor: nesw-resize"})),this.imgResizeDiv.appendChild(this.parent.createElement("span",{className:"e-rte-imageboxmark e-rte-botLeft",styles:"cursor: nesw-resize"})),this.imgResizeDiv.appendChild(this.parent.createElement("span",{className:"e-rte-imageboxmark e-rte-botRight",styles:"cursor: nwse-resize"})),t.Browser.isDevice&&t.addClass([this.imgResizeDiv],"e-mob-rte"),e.style.outline="2px solid #4a90e2",this.imgResizePos(e,this.imgResizeDiv),this.resizeImgDupPos(e),this.contentModule.getEditPanel().appendChild(this.imgResizeDiv),t.EventHandler.add(this.contentModule.getDocument(),t.Browser.touchMoveEvent,this.resizing,this)},n.prototype.getPointX=function(e){return e.touches&&e.touches.length?e.touches[0].pageX:e.pageX},n.prototype.getPointY=function(e){return e.touches&&e.touches.length?e.touches[0].pageY:e.pageY},n.prototype.imgResizePos=function(e,n){var i=this.calcPos(e),r=i.top,o=i.left,s=e.width,a=e.height,l=t.Browser.isDevice?4*parseInt(e.style.outline.slice(-3),10)+2:2*parseInt(e.style.outline.slice(-3),10)+2,d=t.Browser.isDevice?0:2;n.querySelector(".e-rte-botLeft").style.left=o-l+"px",n.querySelector(".e-rte-botLeft").style.top=a-l+r+"px",n.querySelector(".e-rte-botRight").style.left=s-(l-d)+o+"px",n.querySelector(".e-rte-botRight").style.top=a-l+r+"px",n.querySelector(".e-rte-topRight").style.left=s-(l-d)+o+"px",n.querySelector(".e-rte-topRight").style.top=r-l+"px",n.querySelector(".e-rte-topLeft").style.left=o-l+"px",n.querySelector(".e-rte-topLeft").style.top=r-l+"px"},n.prototype.calcPos=function(e){for(var n=e.ownerDocument,i=(e.offsetParent&&(e.offsetParent.classList.contains("e-img-caption")||["TD","TH","TABLE","A"].indexOf(e.offsetParent.tagName)>-1)?t.closest(e,"#"+this.parent.getID()+"_rte-edit-view"):e.offsetParent)||n.documentElement;i&&(i===n.body||i===n.documentElement)&&"static"===i.style.position;)i=i.parentNode;return i&&i!==e&&1===i.nodeType&&i.getBoundingClientRect(),{top:e.offsetTop,left:e.offsetLeft}},n.prototype.setAspectRatio=function(e,n,i,r){if(!t.isNullOrUndefined(e.width)){var o=""!==e.style.width?e.style.width.match(/^\d+(\.\d*)?%$/g)?parseFloat(e.style.width):parseInt(e.style.width,10):e.width,s=""!==e.style.height?parseInt(e.style.height,10):e.height;if(o>s)if(e.style.minWidth="20px",this.parent.insertImageSettings.resizeByPercent){if(0!==parseInt(""+e.getBoundingClientRect().width,10)&&0!==parseInt(""+o,10)){var a=this.pixToPerc(o/s*i,e.previousElementSibling||e.parentElement);e.style.width=Math.min(Math.round(a/e.getBoundingClientRect().width*n*100)/100,100)+"%"}else e.style.width=this.pixToPerc(o/s*i,e.previousElementSibling||e.parentElement)+"%";e.style.height=null,e.removeAttribute("height")}else if(""===e.style.width&&""!==e.style.height)e.style.height=i+"px";else if(""!==e.style.width&&""===e.style.height){var l=o/s*i+o/s<this.parent.inputElement.getBoundingClientRect().right-32?o/s*i+o/s:this.parent.inputElement.getBoundingClientRect().right-32;e.style.width=l.toString()+"px"}else if(""!==e.style.width){l=o/s*i<this.parent.inputElement.getBoundingClientRect().right-32?o/s*i:this.parent.inputElement.getBoundingClientRect().right-32;e.style.width=l+"px",e.style.height=i+"px"}else e.setAttribute("width",(o/s*i+o/s).toString());else s>o?this.parent.insertImageSettings.resizeByPercent?(0!==parseInt(""+e.getBoundingClientRect().width,10)&&0!==parseInt(""+o,10)?e.style.width=Math.min(Math.round(o/e.getBoundingClientRect().width*n*100)/100,100)+"%":e.style.width=this.pixToPerc(n/s*i,e.previousElementSibling||e.parentElement)+"%",e.style.height=null,e.removeAttribute("height")):""!==e.style.width?(e.style.width=n+"px",e.style.height=s/o*n+"px"):e.setAttribute("width",this.resizeBtnStat.botRight?(this.getPointX(r.event)-e.getBoundingClientRect().left).toString():n.toString()):this.parent.insertImageSettings.resizeByPercent?(e.style.width=this.pixToPerc(n,e.previousElementSibling||e.parentElement)+"%",e.style.height=null,e.removeAttribute("height")):""!==e.style.width?(e.style.width=n+"px",e.style.height=n+"px"):(e.setAttribute("width",n.toString()),e.setAttribute("height",n.toString()))}},n.prototype.pixToPerc=function(e,t){return e/parseFloat(getComputedStyle(t).width)*100},n.prototype.imgDupMouseMove=function(e,n,i){var r=this,o={event:i,requestType:"images"};this.parent.trigger(pe,o,function(i){if(i.cancel)r.cancelResizeAction();else{if(parseInt(r.parent.insertImageSettings.minWidth,10)>=parseInt(e,10)||parseInt(r.parent.getInsertImgMaxWidth(),10)<=parseInt(e,10)&&t.isNullOrUndefined(r.imgEle.style.width))return;if(!r.parent.insertImageSettings.resizeByPercent&&(parseInt(r.parent.insertImageSettings.minHeight,10)>=parseInt(n,10)||parseInt(r.parent.insertImageSettings.maxHeight,10)<=parseInt(n,10)))return;r.imgEle.parentElement.style.cursor="pointer",r.setAspectRatio(r.imgEle,parseInt(e,10),parseInt(n,10),o),r.resizeImgDupPos(r.imgEle),r.imgResizePos(r.imgEle,r.imgResizeDiv),r.parent.setContentHeight("",!1)}})},n.prototype.resizing=function(e){this.imgEle.offsetWidth>=this.parent.getInsertImgMaxWidth()&&(this.imgEle.style.maxHeight=this.imgEle.offsetHeight+"px");var t=this.getPointX(e),n=this.getPointY(e),i=this.resizeBtnStat.botLeft||this.resizeBtnStat.topLeft?-(t-this.pageX):t-this.pageX,r=this.resizeBtnStat.topLeft||this.resizeBtnStat.topRight?-(n-this.pageY):n-this.pageY,o=parseInt(this.imgDupPos.width,10)+i,s=parseInt(this.imgDupPos.height,10)+r;this.pageX=t,this.pageY=n,this.resizeBtnStat.botRight?this.imgDupMouseMove(o+"px",s+"px",e):this.resizeBtnStat.botLeft?this.imgDupMouseMove(o+"px",s+"px",e):this.resizeBtnStat.topRight?this.imgDupMouseMove(o+"px",s+"px",e):this.resizeBtnStat.topLeft&&this.imgDupMouseMove(o+"px",s+"px",e)},n.prototype.cancelResizeAction=function(){t.EventHandler.remove(this.contentModule.getDocument(),t.Browser.touchMoveEvent,this.resizing),t.EventHandler.remove(this.contentModule.getDocument(),t.Browser.touchEndEvent,this.resizeEnd),this.imgEle&&this.imgResizeDiv&&this.contentModule.getEditPanel().contains(this.imgResizeDiv)&&(t.detach(this.imgResizeDiv),this.imgEle.style.outline="",this.imgResizeDiv=null,this.pageX=null,this.pageY=null)},n.prototype.resizeImgDupPos=function(e){this.imgDupPos={width:""!==e.style.width&&this.parent.insertImageSettings&&!this.parent.insertImageSettings.resizeByPercent?this.imgEle.style.width:e.width+"px",height:""!==e.style.height?this.imgEle.style.height:e.height+"px"}},n.prototype.resizeBtnInit=function(){return this.resizeBtnStat={botLeft:!1,botRight:!1,topRight:!1,topLeft:!1}},n.prototype.onToolbarAction=function(e){I()&&this.parent.notify(Re,{});switch(e.args.item.subCommand){case"Replace":this.parent.fileManagerSettings.enable?this.parent.notify(bt,e):this.parent.notify(Se,e);break;case"Caption":this.parent.notify(ke,e);break;case"InsertLink":this.parent.notify(Ee,e);break;case"AltText":this.parent.notify(Te,e);break;case"Remove":this.parent.notify(we,e);break;case"Dimension":this.parent.notify(Le,e);break;case"OpenImageLink":this.openImgLink(e);break;case"EditImageLink":this.editImgLink(e);break;case"RemoveImageLink":this.removeImgLink(e)}},n.prototype.openImgLink=function(e){var t=""===e.selectParent[0].parentNode.target?"_self":"_blank";this.parent.formatter.process(this.parent,e.args,e.args,{url:e.selectParent[0].parentNode.href,target:t,selectNode:e.selectNode,subCommand:e.args.item.subCommand})},n.prototype.editImgLink=function(e){var t=e.selectParent[0].parentNode,n=this.i10n.getConstant("dialogUpdate"),i={url:t.href,target:t.target,header:"Edit Link",btnText:n};this.insertImgLink(e,i)},n.prototype.removeImgLink=function(e){t.Browser.isIE&&this.contentModule.getEditPanel().focus(),e.selection.restore();var n=!(!this.contentModule.getEditPanel().contains(this.captionEle)||!t.select("a",this.captionEle)),i=n?[this.captionEle]:[e.selectNode[0].parentElement];this.parent.formatter.process(this.parent,e.args,e.args,{insertElement:e.selectNode[0],selectParent:i,selection:e.selection,subCommand:e.args.item.subCommand}),this.quickToolObj&&document.body.contains(this.quickToolObj.imageQTBar.element)&&(this.quickToolObj.imageQTBar.hidePopup(),t.isNullOrUndefined(e.selectParent)||t.removeClass([e.selectParent[0]],"e-img-focus")),n&&t.select(".e-img-inner",this.captionEle).focus()},n.prototype.onKeyDown=function(e){var n,i,r,o,s=e.args;this.deletedImg=[];var a;if("HTML"===this.parent.editorMode&&(a=(n=this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument())).startContainer===n.endContainer&&n.startOffset===n.endOffset),!a&&"HTML"===this.parent.editorMode&&[27,112,113,114,115,116,117,118,119,120,121,122,123,44,45,9,16,17,18,19,20,33,34,35,36,37,38,39,40,91,92,93,144,145,182,183].indexOf(s.which)<0)for(var l=this.parent.formatter.editorManager.nodeSelection.getNodeCollection(n),d=0;d<l.length;d++)"IMG"===l[d].nodeName&&this.deletedImg.push(l[d]);if("HTML"===this.parent.editorMode&&(8===s.which&&"Backspace"===s.code||46===s.which&&"Delete"===s.code)){var c=n.startContainer===n.endContainer&&n.startOffset===n.endOffset;8===s.which&&"Backspace"===s.code&&c?this.checkImageBack(n):46===s.which&&"Delete"===s.code&&c&&this.checkImageDel(n)}if(!t.isNullOrUndefined(this.parent.formatter.editorManager.nodeSelection)&&"KeyK"!==s.code&&(n=this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument()),i=this.parent.formatter.editorManager.nodeSelection.save(n,this.parent.contentModule.getDocument()),r=this.parent.formatter.editorManager.nodeSelection.getNodeCollection(n),o=this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(n),!s.ctrlKey&&s.key&&(1===s.key.length||"enter"===s.action)&&"IMG"===o[0].tagName&&o[0].parentElement)){var p=o[0].parentElement.childNodes[0];this.contentModule.getEditPanel().querySelector(".e-img-resize")&&this.removeResizeEle(),this.parent.formatter.editorManager.nodeSelection.setSelectionText(this.contentModule.getDocument(),p,p,p.textContent.length,p.textContent.length),t.removeClass([o[0]],"e-img-focus"),this.quickToolObj.imageQTBar.hidePopup()}if(!s.ctrlKey||89!==s.keyCode&&90!==s.keyCode||this.undoStack({subCommand:90===s.keyCode?"undo":"redo"}),8===s.keyCode||46===s.keyCode){if(r&&"IMG"===r[0].nodeName&&r.length<1){s.preventDefault();var h={selectNode:r,selection:i,selectParent:o,args:{item:{command:"Images",subCommand:"Remove"},originalEvent:s}};this.deleteImg(h,s.keyCode)}this.parent.contentModule.getEditPanel().querySelector(".e-img-resize")&&this.removeResizeEle()}switch("Backspace"===s.code&&(s.action="backspace"),s.action){case"escape":t.isNullOrUndefined(this.dialogObj)||this.dialogObj.close();break;case"backspace":case"delete":for(d=0;d<this.deletedImg.length;d++){var u=this.deletedImg[d].src;this.imageRemovePost(u)}"Markdown"!==this.parent.editorMode&&(3===n.startContainer.nodeType?"Backspace"===s.code?n.startContainer.previousElementSibling&&0===n.startOffset&&n.startContainer.previousElementSibling.classList.contains(dn)&&n.startContainer.previousElementSibling.classList.contains(pn)&&t.detach(n.startContainer.previousElementSibling):n.startContainer.nextElementSibling&&n.endContainer.textContent.length===n.endOffset&&n.startContainer.nextElementSibling.classList.contains(dn)&&n.startContainer.nextElementSibling.classList.contains(pn)&&t.detach(n.startContainer.nextElementSibling):1===n.startContainer.nodeType&&n.startContainer.querySelector("."+dn+"."+pn)&&t.detach(n.startContainer.querySelector("."+dn+"."+pn)));break;case"insert-image":this.openDialog(!0,s,i,r,o),s.preventDefault()}},n.prototype.openDialog=function(e,n,i,r,o){var s,a,l,d;e||t.isNullOrUndefined(this.parent.formatter.editorManager.nodeSelection)?(a=i,l=r,d=o):(s=this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument()),a=this.parent.formatter.editorManager.nodeSelection.save(s,this.parent.contentModule.getDocument()),l=this.parent.formatter.editorManager.nodeSelection.getNodeCollection(s),d=this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(s)),"HTML"===this.parent.editorMode?this.insertImage({args:{item:{command:"Images",subCommand:"Image"},originalEvent:n},selectNode:l,selection:a,selectParent:d}):this.insertImage({args:{item:{command:"Images",subCommand:"Image"},originalEvent:n},member:"image",text:this.parent.formatter.editorManager.markdownSelection.getSelectedText(this.parent.contentModule.getEditPanel()),module:"Markdown",name:"insertImage"})},n.prototype.showDialog=function(){this.openDialog(!1)},n.prototype.closeDialog=function(){this.dialogObj&&this.dialogObj.hide({returnValue:!0})},n.prototype.onKeyUp=function(e){if(!t.isNullOrUndefined(this.deletedImg)&&this.deletedImg.length>0)for(var n=0;n<this.deletedImg.length;n++){var i={element:this.deletedImg[n],src:this.deletedImg[n].getAttribute("src")};this.parent.trigger(ut,i)}},n.prototype.checkImageBack=function(e){"#text"!==e.startContainer.nodeName||0!==e.startOffset||t.isNullOrUndefined(e.startContainer.previousSibling)||"IMG"!==e.startContainer.previousSibling.nodeName?"#text"===e.startContainer.nodeName||t.isNullOrUndefined(e.startContainer.childNodes[e.startOffset-1])||"IMG"!==e.startContainer.childNodes[e.startOffset-1].nodeName||this.deletedImg.push(e.startContainer.childNodes[e.startOffset-1]):this.deletedImg.push(e.startContainer.previousSibling)},n.prototype.checkImageDel=function(e){"#text"!==e.startContainer.nodeName||e.startOffset!==e.startContainer.textContent.length||t.isNullOrUndefined(e.startContainer.nextSibling)||"IMG"!==e.startContainer.nextSibling.nodeName?"#text"===e.startContainer.nodeName||t.isNullOrUndefined(e.startContainer.childNodes[e.startOffset])||"IMG"!==e.startContainer.childNodes[e.startOffset].nodeName||this.deletedImg.push(e.startContainer.childNodes[e.startOffset]):this.deletedImg.push(e.startContainer.nextSibling)},n.prototype.alignmentSelect=function(e){var n=e.item;if(document.body.contains(document.body.querySelector(".e-rte-quick-toolbar"))&&"Images"===n.command){var i=this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument()),r=this.parent.formatter.editorManager.nodeSelection.getNodeCollection(i),o={args:e,selectNode:r="IMG"===r[0].nodeName?r:[this.imgEle]};switch(0===this.parent.formatter.getUndoRedoStack().length&&this.parent.formatter.saveData(),n.subCommand){case"JustifyLeft":this.alignImage(o,"JustifyLeft");break;case"JustifyCenter":this.alignImage(o,"JustifyCenter");break;case"JustifyRight":this.alignImage(o,"JustifyRight");break;case"Inline":this.inline(o);break;case"Break":this.break(o)}this.quickToolObj&&document.body.contains(this.quickToolObj.imageQTBar.element)&&(this.quickToolObj.imageQTBar.hidePopup(),t.removeClass([r[0]],"e-img-focus")),this.cancelResizeAction()}},n.prototype.imageWithLinkQTBarItemUpdate=function(){for(var e=this.quickToolObj.imageQTBar.toolbarElement.querySelectorAll(".e-toolbar-item"),n=0;n<e.length;n++)e[n].getAttribute("title")===this.i10n.getConstant("openLink")||e[n].getAttribute("title")===this.i10n.getConstant("editLink")||e[n].getAttribute("title")===this.i10n.getConstant("removeLink")?(t.addClass([e[n]],"e-link-groups"),e[n].style.display="none"):"Insert Link"===e[n].getAttribute("title")?e[n].style.display="":e[n].classList.contains("e-rte-horizontal-separator")&&(e[n],t.detach(e[n]));var i=this.quickToolObj.imageQTBar.toolbarElement.querySelectorAll(".e-toolbar-item:not(.e-link-groups)");this.quickToolObj.imageQTBar.addQTBarItem(["-"],Math.round(i.length/2))},n.prototype.showImageQuickToolbar=function(e){var n=this;if(!("Images"!==e.type||t.isNullOrUndefined(this.parent.quickToolbarModule)||t.isNullOrUndefined(this.parent.quickToolbarModule.imageQTBar)||t.isNullOrUndefined(e.args))){this.quickToolObj=this.parent.quickToolbarModule;var i=e.args,r=e.elements;[].forEach.call(e.elements,function(e,t){0===t&&(r=e)}),r&&!t.closest(r,"a")&&this.imageWithLinkQTBarItemUpdate(),"IMG"===r.nodeName&&t.addClass([r],["e-img-focus"]);var o=this.parent.iframeSettings.enable?window.pageYOffset+this.parent.element.getBoundingClientRect().top+i.clientY:i.pageY;this.parent.quickToolbarModule.imageQTBar&&(e.isNotify?setTimeout(function(){n.quickToolObj.imageQTBar.showPopup(i.pageX,o,r)},400):this.quickToolObj.imageQTBar.showPopup(i.pageX,o,r))}},n.prototype.hideImageQuickToolbar=function(){t.isNullOrUndefined(this.contentModule.getEditPanel().querySelector(".e-img-focus"))||(t.removeClass([this.contentModule.getEditPanel().querySelector(".e-img-focus")],"e-img-focus"),this.quickToolObj&&this.quickToolObj.imageQTBar&&document.body.contains(this.quickToolObj.imageQTBar.element)&&this.quickToolObj.imageQTBar.hidePopup())},n.prototype.editAreaClickHandler=function(n){if(this.parent.readonly)this.hideImageQuickToolbar();else{var i=n.args,r=this.parent.quickToolbarSettings.showOnRightClick;if(2===i.which||r&&1===i.which||!r&&3===i.which)r&&1===i.which&&!t.isNullOrUndefined(i.target)&&"IMG"===i.target.tagName&&(this.parent.formatter.editorManager.nodeSelection.Clear(this.contentModule.getDocument()),this.parent.formatter.editorManager.nodeSelection.setSelectionContents(this.contentModule.getDocument(),i.target));else if("HTML"===this.parent.editorMode&&this.parent.quickToolbarModule&&this.parent.quickToolbarModule.imageQTBar){this.quickToolObj=this.parent.quickToolbarModule;var o=i.target;this.contentModule=this.rendererFactory.getRenderer(e.RenderType.Content);var s=this.quickToolObj.imageQTBar.element.classList.contains("e-rte-pop");if("IMG"===o.nodeName&&this.parent.quickToolbarModule){if(s)return;this.parent.formatter.editorManager.nodeSelection.Clear(this.contentModule.getDocument()),this.parent.formatter.editorManager.nodeSelection.setSelectionContents(this.contentModule.getDocument(),o),I()&&this.parent.notify(Me,n),t.addClass([o],"e-img-focus");var a=this.quickToolObj.imageQTBar.toolbarElement.querySelectorAll(".e-toolbar-item");if(t.closest(o,"a")){for(var l=0;l<a.length;l++)a[l].getAttribute("title")===this.i10n.getConstant("openLink")||a[l].getAttribute("title")===this.i10n.getConstant("editLink")||a[l].getAttribute("title")===this.i10n.getConstant("removeLink")?(a[l].style.display="",t.removeClass([a[l]],"e-link-groups")):"Insert Link"===a[l].getAttribute("title")?a[l].style.display="none":a[l].classList.contains("e-rte-horizontal-separator")&&(a[l],t.detach(a[l]));var d=this.quickToolObj.imageQTBar.toolbarElement.querySelectorAll(".e-toolbar-item:not(.e-link-groups)");this.quickToolObj.imageQTBar.addQTBarItem(["-"],Math.round(d.length/2))}else t.closest(o,"a")||this.imageWithLinkQTBarItemUpdate();this.showImageQuickToolbar({args:i,type:"Images",elements:[i.target]})}else this.hideImageQuickToolbar()}}},n.prototype.insertImgLink=function(e,n){var i=this;if("IMG"===e.selectNode[0].nodeName&&(this.imagDialog(e),!t.isNullOrUndefined(this.dialogObj))){var r=this.parent.createElement("div",{className:"e-img-linkwrap"}),o=S('<div class="e-rte-field"><input type="text" data-role ="none" class="e-input e-img-link" spellcheck="false" placeholder="'+this.i10n.getConstant("linkurl")+'"/></div><div class="e-rte-label"></div><div class="e-rte-field"><input type="checkbox" class="e-rte-linkTarget"  data-role ="none"></div>');r.appendChild(o);var a=r.querySelector(".e-rte-linkTarget"),l=r.querySelector(".e-img-link"),d=this.i10n.getConstant("linkOpenInNewWindow");this.checkBoxObj=new s.CheckBox({label:d,checked:!0,enableRtl:this.parent.enableRtl,change:function(e){c=e.checked?"_blank":null}}),this.checkBoxObj.isStringTemplate=!0,this.checkBoxObj.createElement=this.parent.createElement,this.checkBoxObj.appendTo(a);var c=this.checkBoxObj.checked?"_blank":null,p=this.i10n.getConstant("dialogUpdate"),h={args:e.args,selfImage:this,selection:e.selection,selectNode:e.selectNode,selectParent:e.selectParent,link:l,target:c};this.dialogObj.setProperties({height:"inherit",width:"290px",header:this.parent.localeObj.getConstant("imageInsertLinkHeader"),content:r,position:{X:"center",Y:"center"},buttons:[{click:function(e){i.insertlink(h)},buttonModel:{content:p,cssClass:"e-flat e-update-link",isPrimary:!0}}]}),t.isNullOrUndefined(n)||(l.value=n.url,n.target?this.checkBoxObj.checked=!0:this.checkBoxObj.checked=!1,this.dialogObj.header=n.header),this.dialogObj.element.style.maxHeight="inherit",this.dialogObj.content.querySelector("input").focus()}},n.prototype.insertAltText=function(e){var n=this;if("IMG"===e.selectNode[0].nodeName){this.imagDialog(e);var i=this.i10n.getConstant("altText");if(!t.isNullOrUndefined(this.dialogObj)){var r=this.parent.createElement("div",{className:"e-img-altwrap"}),o=this.i10n.getConstant("alternateHeader"),s=this.i10n.getConstant("dialogUpdate"),a=S('<div class="e-rte-field"><input type="text" spellcheck="false" value="'+(null===e.selectNode[0].getAttribute("alt")?"":e.selectNode[0].getAttribute("alt"))+'" class="e-input e-img-alt" placeholder="'+i+'"/></div>');r.appendChild(a);var l=r.querySelector(".e-img-alt"),d={args:e.args,selfImage:this,selection:e.selection,selectNode:e.selectNode,alt:l};this.dialogObj.setProperties({height:"inherit",width:"290px",header:o,content:r,position:{X:"center",Y:"center"},buttons:[{click:function(e){n.insertAlt(d)},buttonModel:{content:s,cssClass:"e-flat e-update-alt",isPrimary:!0}}]}),this.dialogObj.element.style.maxHeight="inherit",this.dialogObj.content.querySelector("input").focus()}}},n.prototype.insertAlt=function(e){if(!t.isNullOrUndefined(e.alt)){e.selection.restore(),0===this.parent.formatter.getUndoRedoStack().length&&this.parent.formatter.saveData();var n=e.alt.value;this.parent.formatter.process(this.parent,e.args,e.args,{altText:n,selectNode:e.selectNode,subCommand:e.args.item.subCommand}),this.dialogObj.hide({returnValue:!1})}},n.prototype.insertlink=function(e){if("IMG"===e.selectNode[0].nodeName){var n=e.link.value;if(""===n)return t.addClass([e.link],"e-error"),e.link.setSelectionRange(0,n.length),void e.link.focus();this.isUrl(n)?t.removeClass([e.link],"e-error"):n="http://"+n;var i=e.selfImage;if("HTML"===i.parent.editorMode&&e.selection.restore(),0===i.parent.formatter.getUndoRedoStack().length&&i.parent.formatter.saveData(),"A"===e.selectNode[0].parentElement.nodeName)return i.parent.formatter.process(i.parent,e.args,e.args,{url:n,target:i.checkBoxObj.checked?"_blank":null,selectNode:e.selectNode,subCommand:e.args.item.subCommand}),void i.dialogObj.hide({returnValue:!0});i.parent.formatter.process(i.parent,e.args,e.args,{url:n,target:i.checkBoxObj.checked?"_blank":null,selectNode:e.selectNode,subCommand:e.args.item.subCommand,selection:e.selection});var r=t.closest(e.selectNode[0],".e-img-caption");r&&t.select(".e-img-inner",r).focus(),r&&t.select(".e-img-inner",r).focus(),i.dialogObj.hide({returnValue:!1})}},n.prototype.isUrl=function(e){return/(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/gi.test(e)},n.prototype.deleteImg=function(e,n){if("IMG"===e.selectNode[0].nodeName){var i={element:e.selectNode[0],src:e.selectNode[0].getAttribute("src")};0===this.parent.formatter.getUndoRedoStack().length&&this.parent.formatter.saveData(),e.selection.restore(),this.contentModule.getEditPanel().querySelector(".e-img-resize")&&this.removeResizeEle(),this.parent.formatter.process(this.parent,e.args,e.args,{selectNode:e.selectNode,captionClass:dn,subCommand:e.args.item.subCommand}),this.imageRemovePost(i.src),this.quickToolObj&&document.body.contains(this.quickToolObj.imageQTBar.element)&&this.quickToolObj.imageQTBar.hidePopup(),this.cancelResizeAction(),t.isNullOrUndefined(n)&&this.parent.trigger(ut,i)}},n.prototype.imageRemovePost=function(e){var n=this,i="";if(!t.isNullOrUndefined(this.parent.insertImageSettings.removeUrl)&&""!==this.parent.insertImageSettings.removeUrl){i=e.indexOf("http://")>-1||e.indexOf("https://")>-1?e:new URL(e,document.baseURI).href,this.removingImgName=i.replace(/^.*[\\\/]/,"");var r=new XMLHttpRequest;r.addEventListener("readystatechange",function(){4==this.readyState&&200==this.status&&n.triggerPost(this.response)}),r.open("GET",i),r.responseType="blob",r.send()}},n.prototype.triggerPost=function(e){var n=this.parent.insertImageSettings.removeUrl;if(!t.isNullOrUndefined(n)&&""!==n){var i=new File([e],this.removingImgName),r=new t.Ajax(n,"POST",!0,null),o=new FormData;o.append("UploadFiles",i),r.send(o)}},n.prototype.caption=function(e){var n=e.selectNode[0];if("IMG"===n.nodeName){e.selection.restore(),0===this.parent.formatter.getUndoRedoStack().length&&this.parent.formatter.saveData(),this.cancelResizeAction(),t.addClass([n],"e-rte-image");var i=e.args.item?e.args.item.subCommand:"Caption";if(t.isNullOrUndefined(t.closest(n,"."+dn))){this.captionEle=this.parent.createElement("span",{className:dn+" "+cn,attrs:{contenteditable:"false",draggable:"false",style:"width:"+this.parent.insertImageSettings.width}});var r=this.parent.createElement("span",{className:"e-img-wrap"}),o=this.parent.createElement("span",{className:"e-img-inner",attrs:{contenteditable:"true"}}),s=e.selectNode[0].parentElement;"A"===s.tagName&&s.setAttribute("contenteditable","true"),r.appendChild("A"===s.tagName?s:e.selectNode[0]),r.appendChild(o);var a=this.i10n.getConstant("imageCaption");o.innerHTML=a,this.captionEle.appendChild(r),n.classList.contains(hn)&&t.addClass([this.captionEle],pn),n.classList.contains(ln)&&t.addClass([this.captionEle],ln),n.classList.contains(sn)&&t.addClass([this.captionEle],sn),n.classList.contains(on)&&t.addClass([this.captionEle],on),n.classList.contains(an)&&t.addClass([this.captionEle],an),this.parent.formatter.process(this.parent,e.args,e.args,{insertElement:this.captionEle,selectNode:e.selectNode,subCommand:i}),this.parent.formatter.editorManager.nodeSelection.setSelectionText(this.contentModule.getDocument(),o.childNodes[0],o.childNodes[0],0,o.childNodes[0].textContent.length)}else t.detach(t.closest(n,"."+dn)),t.Browser.isIE&&(this.contentModule.getEditPanel().focus(),e.selection.restore()),"A"===n.parentElement.tagName?this.parent.formatter.process(this.parent,e.args,e.args,{insertElement:n.parentElement,selectNode:e.selectNode,subCommand:i}):this.parent.formatter.process(this.parent,e.args,e.args,{insertElement:n,selectNode:e.selectNode,subCommand:i});this.quickToolObj&&document.body.contains(this.quickToolObj.imageQTBar.element)&&(this.quickToolObj.imageQTBar.hidePopup(),t.removeClass([n],"e-img-focus"))}},n.prototype.imageSize=function(e){var n=this;if("IMG"===e.selectNode[0].nodeName&&(this.imagDialog(e),!t.isNullOrUndefined(this.dialogObj))){var i=this.i10n.getConstant("imageSizeHeader"),r=this.i10n.getConstant("dialogUpdate"),o=this.imgsizeInput(e),s={args:e.args,selfImage:this,selection:e.selection,selectNode:e.selectNode};this.dialogObj.setProperties({height:"inherit",width:"290px",header:i,content:o,position:{X:"center",Y:"center"},buttons:[{click:function(e){n.insertSize(s)},buttonModel:{content:r,cssClass:"e-flat e-update-size",isPrimary:!0}}]}),this.dialogObj.element.style.maxHeight="inherit",this.dialogObj.content.querySelector("input").focus()}},n.prototype.break=function(e){if("IMG"===e.selectNode[0].nodeName){var t=e.args.item?e.args.item.subCommand:"Break";this.parent.formatter.process(this.parent,e.args,e.args,{selectNode:e.selectNode,subCommand:t})}},n.prototype.inline=function(e){if("IMG"===e.selectNode[0].nodeName){var t=e.args.item?e.args.item.subCommand:"Inline";this.parent.formatter.process(this.parent,e.args,e.args,{selectNode:e.selectNode,subCommand:t})}},n.prototype.alignImage=function(e,t){var n=e.args.item?e.args.item.subCommand:t;this.parent.formatter.process(this.parent,e.args,e.args,{selectNode:e.selectNode,subCommand:n})},n.prototype.clearDialogObj=function(){this.dialogObj&&(this.dialogObj.destroy(),t.detach(this.dialogObj.element),this.dialogObj=null)},n.prototype.imagDialog=function(e){var n=this;if(this.dialogObj)this.dialogObj.hide({returnValue:!0});else{var i=this.parent.createElement("div",{className:"e-rte-img-dialog",id:this.rteID+"_image"});this.parent.element.appendChild(i);var r=this.i10n.getConstant("dialogInsert"),o=this.i10n.getConstant("dialogCancel"),s=this.i10n.getConstant("imageHeader"),a=e.selection,l={selfImage:this,selection:e.selection,args:e.args,selectParent:e.selectParent},d={header:s,cssClass:yn,enableRtl:this.parent.enableRtl,locale:this.parent.locale,showCloseIcon:!0,closeOnEscape:!0,width:t.Browser.isDevice?"290px":"340px",height:"inherit",position:{X:"center",Y:t.Browser.isDevice?"center":"top"},isModal:t.Browser.isDevice,buttons:[{click:this.insertImageUrl.bind(l),buttonModel:{content:r,cssClass:"e-flat e-insertImage",isPrimary:!0,disabled:!0}},{click:function(e){n.cancelDialog(e)},buttonModel:{cssClass:"e-flat e-cancel",content:o}}],target:t.Browser.isDevice?document.body:this.parent.element,animationSettings:{effect:"None"},close:function(e){n.isImgUploaded&&n.uploadObj.removing(),n.parent.isBlur=!1,e&&e.event.returnValue&&("HTML"===n.parent.editorMode?a.restore():n.parent.formatter.editorManager.markdownSelection.restore(n.parent.contentModule.getEditPanel())),n.dialogObj.destroy(),t.detach(n.dialogObj.element),n.dialogRenderObj.close(e),n.dialogObj=null}},c=this.parent.createElement("div",{className:"e-img-content"});(!t.isNullOrUndefined(this.parent.insertImageSettings.path)&&"Markdown"===this.parent.editorMode||"HTML"===this.parent.editorMode)&&c.appendChild(this.imgUpload(e));var p=this.parent.createElement("div",{className:"e-linkheader"}),h=this.i10n.getConstant("imageLinkHeader");"HTML"===this.parent.editorMode?p.innerHTML=h:p.innerHTML=this.i10n.getConstant("mdimageLink"),c.appendChild(p),c.appendChild(this.imageUrlPopup(e)),e.selectNode&&"IMG"===e.selectNode[0].nodeName?(d.header=this.parent.localeObj.getConstant("editImageHeader"),d.content=c):d.content=c,this.dialogObj=this.dialogRenderObj.render(d),this.dialogObj.createElement=this.parent.createElement,this.dialogObj.appendTo(i),t.isNullOrUndefined(this.dialogObj)||(e.selectNode&&"IMG"===e.selectNode[0].nodeName&&"insertImage"===e.name&&(this.dialogObj.element.querySelector(".e-insertImage").textContent=this.parent.localeObj.getConstant("dialogUpdate")),i.style.maxHeight="inherit",this.quickToolObj&&(this.quickToolObj.imageQTBar&&document.body.contains(this.quickToolObj.imageQTBar.element)&&(this.quickToolObj.imageQTBar.hidePopup(),t.isNullOrUndefined(e.selectParent)||t.removeClass([e.selectParent[0]],"e-img-focus")),this.quickToolObj.inlineQTBar&&document.body.contains(this.quickToolObj.inlineQTBar.element)&&this.quickToolObj.inlineQTBar.hidePopup()))}},n.prototype.cancelDialog=function(e){this.parent.isBlur=!1,this.dialogObj.hide({returnValue:!0}),this.isImgUploaded&&this.uploadObj.removing()},n.prototype.onDocumentClick=function(e){var n=e.target;"IMG"===n.nodeName&&(this.imgEle=n),!t.isNullOrUndefined(this.dialogObj)&&(!t.closest(n,"[id='"+this.dialogObj.element.id+"']")&&this.parent.toolbarSettings.enable&&this.parent.getToolbarElement()&&!this.parent.getToolbarElement().contains(e.target)||this.parent.getToolbarElement()&&this.parent.getToolbarElement().contains(e.target)&&!t.closest(n,"#"+this.parent.getID()+"_toolbar_Image")&&!n.querySelector("#"+this.parent.getID()+"_toolbar_Image"))&&(e.offsetX>e.target.clientWidth||e.offsetY>e.target.clientHeight||(this.dialogObj.hide({returnValue:!0}),this.parent.isBlur=!0,C(this.parent.element,"focusout"))),"IMG"===e.target.tagName||!this.imgResizeDiv||this.quickToolObj&&this.quickToolObj.imageQTBar&&this.quickToolObj.imageQTBar.element.contains(e.target)||!this.contentModule.getEditPanel().contains(this.imgResizeDiv)||this.cancelResizeAction(),this.contentModule.getEditPanel().querySelector(".e-img-resize")&&("IMG"!==n.tagName&&this.removeResizeEle(),"IMG"===n.tagName||t.isNullOrUndefined(this.imgEle)?t.isNullOrUndefined(this.prevSelectedImgEle)||this.prevSelectedImgEle===n||(this.prevSelectedImgEle.style.outline=""):this.imgEle.style.outline="")},n.prototype.removeResizeEle=function(){t.EventHandler.remove(this.contentModule.getDocument(),t.Browser.touchMoveEvent,this.resizing),t.EventHandler.remove(this.contentModule.getDocument(),t.Browser.touchEndEvent,this.resizeEnd),t.detach(this.contentModule.getEditPanel().querySelector(".e-img-resize"))},n.prototype.onWindowResize=function(){t.isNullOrUndefined(this.contentModule)||t.isNullOrUndefined(this.contentModule.getEditPanel().querySelector(".e-img-resize"))||this.cancelResizeAction()},n.prototype.imageUrlPopup=function(e){var n=this,i=this.parent.createElement("div",{className:"imgUrl"}),r=this.i10n.getConstant("imageUrl");return this.inputUrl=this.parent.createElement("input",{className:"e-input e-img-url",attrs:{placeholder:r,spellcheck:"false"}}),this.inputUrl.addEventListener("input",function(){t.isNullOrUndefined(n.inputUrl)||(0===n.inputUrl.value.length?n.dialogObj.getButtons(0).element.disabled=!0:n.dialogObj.getButtons(0).element.removeAttribute("disabled"))}),i.appendChild(this.inputUrl),i},n.prototype.insertImageUrl=function(e){var n=this.selfImage;n.isImgUploaded=!1;var i=n.inputUrl.value;if(0===n.parent.formatter.getUndoRedoStack().length&&n.parent.formatter.saveData(),t.isNullOrUndefined(n.uploadUrl)||""===n.uploadUrl.url){if(""!==i){if("HTML"===n.parent.editorMode&&t.isNullOrUndefined(t.closest(this.selection.range.startContainer.parentNode,"[id='"+n.contentModule.getPanel().id+"']"))){n.contentModule.getEditPanel().focus();var r=n.parent.formatter.editorManager.nodeSelection.getRange(n.contentModule.getDocument());this.selection=n.parent.formatter.editorManager.nodeSelection.save(r,n.contentModule.getDocument()),this.selectParent=n.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(r)}var o=/[\w-]+.(jpg|png|jpeg|gif)/g,s=t.isNullOrUndefined(i.match(o))||"HTML"!==n.parent.editorMode?"":i.match(o)[0],a={cssClass:"inline"===n.parent.insertImageSettings.display?hn:ln,url:i,selection:this.selection,altText:s,selectParent:this.selectParent,width:{width:n.parent.insertImageSettings.width,minWidth:n.parent.insertImageSettings.minWidth,maxWidth:n.parent.getInsertImgMaxWidth()},height:{height:n.parent.insertImageSettings.height,minHeight:n.parent.insertImageSettings.minHeight,maxHeight:n.parent.insertImageSettings.maxHeight}};n.parent.formatter.process(n.parent,this.args,this.args.originalEvent,a),n.dialogObj.hide({returnValue:!1})}}else n.uploadUrl.cssClass="inline"===n.parent.insertImageSettings.display?hn:ln,n.dialogObj.hide({returnValue:!1}),n.parent.formatter.process(n.parent,this.args,this.args.originalEvent,n.uploadUrl),n.uploadUrl.url="",n.contentModule.getEditPanel().querySelector(".e-img-resize")&&(n.imgEle.style.outline="",n.removeResizeEle())},n.prototype.imgsizeInput=function(e){var n=this,i=e.selectNode[0],r=this.i10n.getConstant("imageHeight"),s=this.i10n.getConstant("imageWidth"),a=this.parent.createElement("div",{className:"e-img-sizewrap"}),l=!t.isNullOrUndefined(this.changedWidthValue)||"auto"!==i.style.width.toString()&&""===i.style.width?t.isNullOrUndefined(this.changedWidthValue)?parseInt(i.getClientRects()[0].width.toString(),10).toString():this.changedWidthValue:i.style.width,d=!t.isNullOrUndefined(this.changedHeightValue)||"auto"!==i.style.height.toString()&&""===i.style.height?t.isNullOrUndefined(this.changedHeightValue)?parseInt(i.getClientRects()[0].height.toString(),10).toString():this.changedHeightValue:i.style.height;this.changedWidthValue=null,this.changedHeightValue=null;var c=S('<div class="e-rte-label"><label>'+s+'</label></div><div class="e-rte-field"><input type="text" id="imgwidth" class="e-img-width" value='+l+' /></div><div class="e-rte-label"><label>'+r+'</label></div><div class="e-rte-field"> <input type="text" id="imgheight" class="e-img-height" value='+d+" /></div>");a.appendChild(c);var p=new o.TextBox({value:t.formatUnit(l),enableRtl:this.parent.enableRtl,input:function(e){n.inputWidthValue=t.formatUnit(n.inputValue(e.value))}});p.createElement=this.parent.createElement,p.appendTo(a.querySelector("#imgwidth"));var h=new o.TextBox({value:t.formatUnit(d),enableRtl:this.parent.enableRtl,input:function(e){n.inputHeightValue=t.formatUnit(n.inputValue(e.value))}});return h.createElement=this.parent.createElement,h.appendTo(a.querySelector("#imgheight")),a},n.prototype.inputValue=function(e){return"auto"===e||-1!==e.indexOf("%")||-1!==e.indexOf("px")||e.match(/(\d+)/)?e:"auto"},n.prototype.insertSize=function(e){e.selection.restore();var t=e.selfImage;0===t.parent.formatter.getUndoRedoStack().length&&t.parent.formatter.saveData();var n=t.dialogObj.element;this.changedWidthValue=this.inputWidthValue,this.changedHeightValue=this.inputHeightValue;var i=n.querySelector(".e-img-width").value,r=n.parentElement.querySelector(".e-img-height").value;t.parent.formatter.process(this.parent,e.args,e.args,{width:i,height:r,selectNode:e.selectNode,subCommand:e.args.item.subCommand}),this.imgResizeDiv&&t.imgResizePos(e.selectNode[0],this.imgResizeDiv),t.dialogObj.hide({returnValue:!0})},n.prototype.insertImage=function(e){if(this.imagDialog(e),!t.isNullOrUndefined(this.dialogObj)){this.dialogObj.element.style.maxHeight="inherit";var n=this.dialogObj.element.querySelector(".e-img-content");!t.isNullOrUndefined(this.parent.insertImageSettings.path)&&"Markdown"===this.parent.editorMode||"HTML"===this.parent.editorMode?document.getElementById(this.rteID+"_insertImage").focus():n.querySelector(".e-img-url").focus()}},n.prototype.imgUpload=function(e){var n,i,r=this,a=this,l=a.parent.iframeSettings.enable;if("HTML"===a.parent.editorMode&&(!l&&t.isNullOrUndefined(t.closest(e.selection.range.startContainer.parentNode,"[id='"+this.parent.contentModule.getPanel().id+"']"))||l&&!c(e.selection.range.startContainer.parentNode.ownerDocument.querySelector("body"),"e-lib"))){this.contentModule.getEditPanel().focus();var d=this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());n=this.parent.formatter.editorManager.nodeSelection.save(d,this.parent.contentModule.getDocument()),i=this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(d)}else n=e.selection,i=e.selectParent;var p=this.parent.createElement("div",{className:"e-img-uploadwrap e-droparea"}),h=this.i10n.getConstant("imageDeviceUploadMessage"),u=this.i10n.getConstant("imageUploadMessage"),m=this.parent.createElement("span",{className:"e-droptext"}),g=this.parent.createElement("span",{className:"e-rte-upload-text",innerHTML:t.Browser.isDevice?h:u});m.appendChild(g);var f=this.parent.createElement("button",{className:"e-browsebtn",id:this.rteID+"_insertImage",attrs:{autofocus:"true",type:"button"}});m.appendChild(f),p.appendChild(m);var b=this.i10n.getConstant("browse"),v=new s.Button({content:b,enableRtl:this.parent.enableRtl});v.isStringTemplate=!0,v.createElement=this.parent.createElement,v.appendTo(f);var y=t.Browser.isDevice?m:f;t.EventHandler.add(y,"click",this.fileSelect,this);var C=this.parent.createElement("input",{id:this.rteID+"_upload",attrs:{type:"File",name:"UploadFiles"}});p.appendChild(C);var S,N,E,T,w;return this.uploadObj=new o.Uploader({asyncSettings:{saveUrl:this.parent.insertImageSettings.saveUrl,removeUrl:this.parent.insertImageSettings.removeUrl},dropArea:m,multiple:!1,enableRtl:this.parent.enableRtl,allowedExtensions:this.parent.insertImageSettings.allowedTypes.toString(),selected:function(e){a.isImgUploaded=!0,E=e,T=e.filesData,r.parent.isServerRendered&&(E=JSON.parse(JSON.stringify(e)),e.cancel=!0,N=e.filesData,E.filesData=N),r.parent.trigger(lt,E,function(e){if(!e.cancel){if(r.checkExtension(e.filesData[0]),S=e.filesData[0].name,"HTML"===r.parent.editorMode&&t.isNullOrUndefined(r.parent.insertImageSettings.path)){var o=new FileReader;o.addEventListener("load",function(e){var s="Base64"===r.parent.insertImageSettings.saveFormat?o.result:URL.createObjectURL(D(o.result));a.uploadUrl={url:s,selection:n,altText:S,selectParent:i,width:{width:a.parent.insertImageSettings.width,minWidth:a.parent.insertImageSettings.minWidth,maxWidth:a.parent.getInsertImgMaxWidth()},height:{height:a.parent.insertImageSettings.height,minHeight:a.parent.insertImageSettings.minHeight,maxHeight:a.parent.insertImageSettings.maxHeight}},a.inputUrl.setAttribute("disabled","true"),t.isNullOrUndefined(a.parent.insertImageSettings.saveUrl)&&r.isAllowedTypes&&!t.isNullOrUndefined(r.dialogObj)&&r.dialogObj.getButtons(0).element.removeAttribute("disabled")}),o.readAsDataURL(e.filesData[0].rawFile)}r.parent.isServerRendered&&r.uploadObj._internalRenderSelect(e,N)}})},beforeUpload:function(e){r.parent.isServerRendered?((w=JSON.parse(JSON.stringify(e))).filesData=T,e.cancel=!0,r.parent.trigger(dt,w,function(e){e.cancel||(r.uploadObj.currentRequestHeader=e.currentRequest?e.currentRequest:r.uploadObj.currentRequestHeader,r.uploadObj.customFormDatas=e.customFormData&&e.customFormData.length>0?e.customFormData:r.uploadObj.customFormDatas,r.uploadObj.uploadFiles(N,null))})):r.parent.trigger(gt,e)},uploading:function(e){r.parent.isServerRendered||r.parent.trigger(dt,e)},success:function(e){r.parent.trigger(ct,e,function(e){if(!t.isNullOrUndefined(r.parent.insertImageSettings.path)){var o=r.parent.insertImageSettings.path+e.file.name;a.uploadUrl={url:o,selection:n,altText:S,selectParent:i,width:{width:a.parent.insertImageSettings.width,minWidth:a.parent.insertImageSettings.minWidth,maxWidth:a.parent.getInsertImgMaxWidth()},height:{height:a.parent.insertImageSettings.height,minHeight:a.parent.insertImageSettings.minHeight,maxHeight:a.parent.insertImageSettings.maxHeight}},a.inputUrl.setAttribute("disabled","true")}"upload"!==e.operation||t.isNullOrUndefined(r.dialogObj)||r.dialogObj.getButtons(0).element.removeAttribute("disabled")})},failure:function(e){r.parent.trigger(pt,e)},removing:function(){r.parent.trigger(ht,e,function(e){a.isImgUploaded=!1,r.dialogObj.getButtons(0).element.disabled=!0,a.inputUrl.removeAttribute("disabled"),a.uploadUrl&&(a.uploadUrl.url="")})}}),this.uploadObj.isStringTemplate=!0,this.uploadObj.createElement=this.parent.createElement,this.uploadObj.appendTo(C),p},n.prototype.checkExtension=function(e){this.uploadObj.allowedExtensions&&(-1===this.uploadObj.allowedExtensions.toLocaleLowerCase().indexOf(("."+e.type).toLocaleLowerCase())?(this.dialogObj.getButtons(0).element.setAttribute("disabled","disabled"),this.isAllowedTypes=!1):this.isAllowedTypes=!0)},n.prototype.fileSelect=function(){return this.dialogObj.element.getElementsByClassName("e-file-select-wrap")[0].querySelector("button").click(),!1},n.prototype.dragStart=function(e){if("IMG"!==e.target.nodeName)return!0;this.parent.trigger(be,e,function(t){t.cancel?e.preventDefault():(e.dataTransfer.effectAllowed="copyMove",e.target.classList.add(Zn))})},n.prototype.dragEnter=function(e){e.dataTransfer.dropEffect="copy",e.preventDefault()},n.prototype.dragOver=function(e){if(!("edge"===t.Browser.info.name&&e.dataTransfer.items[0].type.split("/")[0].indexOf("image")>-1||t.Browser.isIE&&"Files"===e.dataTransfer.types[0]))return!0;e.preventDefault()},n.prototype.dragDrop=function(e){var n=this;this.parent.trigger(vt,e,function(e){var i=n.parent.inputElement.ownerDocument.querySelector("."+Zn),r=i&&"IMG"===i.tagName||e.dataTransfer.files.length>0;!e.cancel&&r?n.parent.trigger(be,e,function(i){if(i.cancel)e.preventDefault();else{if(t.closest(e.target,"#"+n.parent.getID()+"_toolbar")||"false"===n.parent.inputElement.contentEditable)return void e.preventDefault();n.parent.element.querySelector(".e-img-resize")&&t.detach(n.imgResizeDiv),e.preventDefault();var r=void 0;n.contentModule.getDocument().caretRangeFromPoint?r=n.contentModule.getDocument().caretRangeFromPoint(e.clientX,e.clientY):e.rangeParent?(r=n.contentModule.getDocument().createRange()).setStart(e.rangeParent,e.rangeOffset):r=n.getDropRange(e.clientX,e.clientY),n.parent.notify(Qe,{range:r});if(n.parent.element.querySelector(".e-droparea"))return;n.insertDragImage(e)}}):r&&e.preventDefault()})},n.prototype.getDropRange=function(e,t){var n=this.contentModule.getDocument().createRange();this.parent.formatter.editorManager.nodeSelection.setRange(this.contentModule.getDocument(),n);var i=this.contentModule.getDocument().elementFromPoint(e,t),r=i.childNodes.length>0?i.childNodes[0]:i,o=0;if("<br>"===this.parent.inputElement.firstChild.innerHTML)n.setStart(r,o),n.setEnd(r,o);else{var s=void 0;do{o++,n.setStart(r,o),n.setEnd(r,o+1),s=n.getBoundingClientRect()}while(s.left<e&&o<r.length-1)}return n},n.prototype.insertDragImage=function(e){var t=this;e.preventDefault();var n=this.parent.element.querySelector(""+ti);this.parent.notify("drop",{args:e}),n&&n.classList.add(en);var i=this.parent.inputElement.ownerDocument.querySelector("."+Zn);if(e.dataTransfer.files.length>0&&null===i){if(e.dataTransfer.files.length>1)return;for(var r=e.dataTransfer.files,o=r[0].name,s=o.substring(o.lastIndexOf(".")),a=this.parent.insertImageSettings.allowedTypes,l=0;l<a.length;l++)if(s.toLocaleLowerCase()===a[l].toLowerCase())if(this.parent.insertImageSettings.saveUrl)this.onSelect(e);else{var d={args:e,text:"",file:r[0]};e.preventDefault(),this.imagePaste(d)}}else{var c=this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument());if(i&&"IMG"===i.tagName){i.nextElementSibling&&i.nextElementSibling.classList.contains("e-img-inner")?c.insertNode(i.parentElement.parentElement):c.insertNode(i),i.classList.remove(Zn);var p={elements:[i]};i.addEventListener("load",function(){t.parent.trigger(ve,p)}),this.parent.formatter.editorManager.nodeSelection.Clear(this.contentModule.getDocument());d=e;this.resizeStart(d,i),this.hideImageQuickToolbar()}}},n.prototype.onSelect=function(e){var n=this,i=this,r=this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument()),o=this.parent.createElement("ul",{className:ni});this.parent.element.appendChild(o);var s={name:"",size:0,status:"",statusCode:"",type:"",rawFile:e.dataTransfer.files[0],validationMessages:{}},a=this.parent.createElement("IMG");a.style.opacity="0.5",a.classList.add($n),a.classList.add(hn),a.classList.add("e-resize");var l=s.rawFile,d=new FileReader;d.addEventListener("load",function(){var e=URL.createObjectURL(D(d.result));a.src="Blob"===i.parent.insertImageSettings.saveFormat?e:d.result}),l&&d.readAsDataURL(l),r.insertNode(a),this.uploadMethod(e,a);var c={elements:[a]};a.addEventListener("load",function(){n.parent.trigger(ve,c)}),t.detach(o)},n.prototype.uploadMethod=function(e,n){var i=this,s=!1,a=this,l=this.parent.createElement("div");this.parent.element.appendChild(l);var d=this.parent.createElement("input",{id:this.rteID+"_upload",attrs:{type:"File",name:"UploadFiles"}}),c=this.parent.iframeSettings.enable?-50:-90;this.popupObj=new r.Popup(l,{relateTo:n,height:"85px",width:"300px",offsetY:c,content:d,viewPortElement:this.parent.element,position:{X:"center",Y:"top"},enableRtl:this.parent.enableRtl,zIndex:10001,close:function(e){i.parent.isBlur=!1,i.popupObj.destroy(),t.detach(i.popupObj.element),i.popupObj=null,i.parent.inlineMode.enable||i.parent.toolbarModule.baseToolbar.toolbarObj.disable(!1)}}),this.popupObj.element.style.display="none",t.addClass([this.popupObj.element],ti),t.addClass([this.popupObj.element],ei);var p=this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument()),h=e.dataTransfer.files[0].size>1e6?300:100;setTimeout(function(){a.refreshPopup(n)},h);var u,m;this.uploadObj=new o.Uploader({asyncSettings:{saveUrl:this.parent.insertImageSettings.saveUrl,removeUrl:this.parent.insertImageSettings.removeUrl},cssClass:ii,dropArea:this.parent.element,allowedExtensions:this.parent.insertImageSettings.allowedTypes.toString(),removing:function(){i.parent.inputElement.contentEditable="true",s=!1,t.detach(n),i.popupObj.close()},canceling:function(){i.parent.inputElement.contentEditable="true",s=!1,t.detach(n),i.popupObj.close(),i.quickToolObj.imageQTBar.hidePopup(),setTimeout(function(){i.uploadObj.destroy()},900)},beforeUpload:function(e){i.parent.isServerRendered?((m=JSON.parse(JSON.stringify(e))).filesData=u,s=!0,e.cancel=!0,i.parent.trigger(dt,m,function(e){e.cancel||(i.parent.inlineMode.enable||i.parent.toolbarModule.baseToolbar.toolbarObj.disable(!0),i.uploadObj.currentRequestHeader=e.currentRequest?e.currentRequest:i.uploadObj.currentRequestHeader,i.uploadObj.customFormDatas=e.customFormData&&e.customFormData.length>0?e.customFormData:i.uploadObj.customFormDatas,i.uploadObj.uploadFiles(u,null),i.parent.inputElement.contentEditable="false")})):(i.parent.trigger(gt,e),i.parent.inlineMode.enable||i.parent.toolbarModule.baseToolbar.toolbarObj.disable(!0))},uploading:function(e){i.parent.isServerRendered||(s=!0,i.parent.trigger(dt,e,function(e){e.cancel?(t.isNullOrUndefined(n)||t.detach(n),t.isNullOrUndefined(i.popupObj.element)||t.detach(i.popupObj.element)):i.parent.inputElement.contentEditable="false"}))},selected:function(e){s&&(e.cancel=!0),i.parent.isServerRendered&&(u=e.filesData)},failure:function(t){s=!1,i.parent.inputElement.contentEditable="true";var r={args:e,type:"Images",isNotify:void 0,elements:n};setTimeout(function(){i.uploadFailure(n,r,t)},900)},success:function(t){if("cancel"!==t.operation){s=!1,i.parent.inputElement.contentEditable="true";var r={args:e,type:"Images",isNotify:void 0,elements:n};setTimeout(function(){i.uploadSuccess(n,e,r,t)},900)}}}),this.uploadObj.appendTo(this.popupObj.element.childNodes[0]),this.popupObj.element.querySelector(".e-rte-dialog-upload .e-file-select-wrap").style.display="none",p.selectNodeContents(n),this.parent.formatter.editorManager.nodeSelection.setRange(this.contentModule.getDocument(),p)},n.prototype.refreshPopup=function(e){(this.parent.iframeSettings.enable?this.parent.element.offsetTop+e.offsetTop:e.offsetTop)>this.parent.element.offsetTop+this.parent.element.offsetHeight?(this.popupObj.relateTo=this.parent.inputElement,this.popupObj.offsetY=this.parent.iframeSettings.enable?-30:-65,this.popupObj.element.style.display="block"):this.popupObj&&(this.popupObj.refreshPosition(e),this.popupObj.element.style.display="block")},n.prototype.uploadFailure=function(e,n,i){t.detach(e),this.popupObj&&this.popupObj.close(),this.parent.trigger(pt,i),this.uploadObj.destroy()},n.prototype.uploadSuccess=function(e,n,i,r){var o=this;e.style.opacity="1",e.classList.add("e-img-focus"),r.element=e,this.parent.trigger(ct,r,function(n){if(!t.isNullOrUndefined(o.parent.insertImageSettings.path)){var i=o.parent.insertImageSettings.path+n.file.name;e.src=i,e.setAttribute("alt",n.file.name)}}),this.popupObj&&(this.popupObj.close(),this.uploadObj.destroy()),this.showImageQuickToolbar(i),this.resizeStart(n,e)},n.prototype.imagePaste=function(e){var n=this;if(0===e.text.length&&!t.isNullOrUndefined(e.file)){var i=this,r=new FileReader;e.args.preventDefault(),r.addEventListener("load",function(o){var s={cssClass:"inline"===i.parent.insertImageSettings.display?hn:ln,url:"Base64"!==n.parent.insertImageSettings.saveFormat&&t.isNullOrUndefined(e.callBack)?URL.createObjectURL(D(r.result)):r.result,width:{width:i.parent.insertImageSettings.width,minWidth:i.parent.insertImageSettings.minWidth,maxWidth:i.parent.getInsertImgMaxWidth()},height:{height:i.parent.insertImageSettings.height,minHeight:i.parent.insertImageSettings.minHeight,maxHeight:i.parent.insertImageSettings.maxHeight}};t.isNullOrUndefined(e.callBack)?(i.parent.formatter.process(i.parent,{item:{command:"Images",subCommand:"Image"}},e.args,s),n.showPopupToolBar(e,s)):e.callBack(s)}),r.readAsDataURL(e.file)}},n.prototype.showPopupToolBar=function(t,n){var i=this,r='img[src="'+n.url+'"]',o=this.parent.inputElement.querySelector(r);this.parent.quickToolbarModule.createQTBar("Image","MultiRow",this.parent.quickToolbarSettings.image,e.RenderType.ImageToolbar);var s={args:t.args,type:"Images",isNotify:void 0,elements:o};o&&setTimeout(function(){i.showImageQuickToolbar(s),i.resizeStart(t.args,o)},0)},n.prototype.destroy=function(){this.prevSelectedImgEle=void 0,this.removeEventListener()},n.prototype.getModuleName=function(){return"image"},n}(),ss=function(){function n(e,t){this.parent=e;var n=t;this.rendererFactory=n.getService("rendererFactory"),this.addEventListener()}return n.prototype.addEventListener=function(){this.parent.on(Oe,this.sourceCode,this),this.parent.on(H,this.onInitialEnd,this),this.parent.on(xe,this.updateSourceCode,this),this.parent.on(F,this.destroy,this)},n.prototype.onInitialEnd=function(){this.parent.formatter.editorManager.observer.on(hr,this.onKeyDown,this)},n.prototype.removeEventListener=function(){this.unWireEvent(),this.parent.off(Oe,this.sourceCode),this.parent.off(xe,this.updateSourceCode),this.parent.off(H,this.onInitialEnd),this.parent.off(F,this.destroy),this.parent.formatter.editorManager.observer.off(hr,this.onKeyDown)},n.prototype.getSourceCode=function(){return this.parent.createElement("textarea",{className:"e-rte-srctextarea"})},n.prototype.wireEvent=function(e){this.keyboardModule=new er(e,{keyAction:this.previewKeyDown.bind(this),keyConfigs:this.parent.formatter.keyConfig,eventName:"keydown"}),t.EventHandler.add(this.previewElement,"mousedown",this.mouseDownHandler,this)},n.prototype.unWireEvent=function(){this.keyboardModule&&this.keyboardModule.destroy(),this.previewElement&&t.EventHandler.remove(this.previewElement,"mousedown",this.mouseDownHandler)},n.prototype.wireBaseKeyDown=function(){this.parent.keyboardModule=new er(this.contentModule.getEditPanel(),{keyAction:this.parent.keyDown.bind(this.parent),keyConfigs:this.parent.formatter.keyConfig,eventName:"keydown"})},n.prototype.unWireBaseKeyDown=function(){this.parent.keyboardModule.destroy()},n.prototype.mouseDownHandler=function(e){this.parent.notify(Ae,{args:e})},n.prototype.previewKeyDown=function(e){switch(e.action){case"html-source":this.updateSourceCode(e),e.preventDefault();break;case"toolbar-focus":if(this.parent.toolbarSettings.enable){this.parent.toolbarModule.baseToolbar.toolbarObj.element.querySelector('.e-toolbar-item[aria-disabled="false"][title] [tabindex]').focus()}}},n.prototype.onKeyDown=function(e){switch(e.event.action){case"html-source":e.event.preventDefault(),this.sourceCode(e),e.callBack({requestType:"SourceCode",editorMode:"HTML",event:e.event})}},n.prototype.sourceCode=function(n){this.parent.isBlur=!1,this.parent.trigger(be,{requestType:"SourceCode",targetItem:"SourceCode",args:n});var i=t.selectAll("."+$t,this.parent.element);if(this.contentModule=this.rendererFactory.getRenderer(e.RenderType.Content),this.parent.notify(Ce,{targetItem:"SourceCode",updateItem:"Preview",baseToolbar:this.parent.getBaseToolbarObject()}),t.isNullOrUndefined(this.previewElement)&&(this.previewElement=this.getSourceCode()),this.parent.updateValueData(),this.parent.iframeSettings.enable){var r=void 0;(r=t.isNullOrUndefined(this.parent.element.querySelector("#"+this.parent.element.id+"_source-view"))?this.parent.createElement("div",{className:"e-source-content",id:this.parent.element.id+"_source-view"}):this.parent.element.querySelector("#"+this.parent.element.id+"_source-view")).appendChild(this.previewElement),this.parent.element.appendChild(r),r.style.height=this.contentModule.getPanel().style.height,r.style.marginTop=this.contentModule.getPanel().style.marginTop,this.getPanel().value=this.getTextAreaValue(),this.contentModule.getPanel().style.display="none",r.style.display="block",this.getPanel().style.display="block"}else this.contentModule.getPanel().appendChild(this.previewElement),this.getPanel().value=this.getTextAreaValue(),this.contentModule.getEditPanel().style.display="none",this.previewElement.style.display="block";if(this.parent.isBlur=!1,this.parent.disableToolbarItem(this.parent.toolbarSettings.items),this.parent.enableToolbarItem("SourceCode"),this.parent.getToolbar()&&t.removeClass([this.parent.getToolbar()],[vn]),t.removeClass(i,[bn]),this.parent.setContentHeight("sourceCode",!0),this.wireEvent(this.previewElement),this.unWireBaseKeyDown(),this.previewElement.focus(),this.parent.updateValue(),!t.isNullOrUndefined(this.parent.placeholder)&&!this.parent.iframeSettings.enable){this.parent.element.querySelector(".rte-placeholder.e-rte-placeholder").style.display="none"}this.parent.trigger(ve,{requestType:"SourceCode",targetItem:"SourceCode",args:n}),this.parent.invokeChangeEvent()},n.prototype.updateSourceCode=function(e){this.parent.isBlur=!1,this.parent.trigger(be,{requestType:"Preview",targetItem:"Preview",args:e});var n=this.getPanel();this.parent.notify(Ce,{targetItem:"Preview",updateItem:"SourceCode",baseToolbar:this.parent.getBaseToolbarObject()});var i,r=this.parent.serializeValue(n.value);if(i=null===r||""===r?"DIV"===this.parent.enterKey?"<div><br/></div>":"BR"===this.parent.enterKey?"<br/>":"<p><br/></p>":r,this.parent.iframeSettings.enable?(n.parentElement.style.display="none",n.style.display="none",this.contentModule.getPanel().style.display="block",this.contentModule.getEditPanel().innerHTML=i):(n.style.display="none",this.contentModule.getEditPanel().style.display="block",this.contentModule.getEditPanel().innerHTML=i),this.parent.isBlur=!1,this.parent.enableToolbarItem(this.parent.toolbarSettings.items),this.parent.getToolbar()&&t.removeClass([this.parent.getToolbar()],[vn]),this.parent.setContentHeight("preview",!0),this.unWireEvent(),this.wireBaseKeyDown(),this.contentModule.getEditPanel().focus(),this.parent.updateValue(),!t.isNullOrUndefined(this.parent.placeholder)&&0===this.contentModule.getEditPanel().innerText.length){this.parent.element.querySelector(".rte-placeholder.e-rte-placeholder").style.display="block"}this.parent.trigger(ve,{requestType:"Preview",targetItem:"Preview",args:e}),this.parent.formatter.enableUndo(this.parent),this.parent.invokeChangeEvent()},n.prototype.getTextAreaValue=function(){return"<p><br></p>"===this.contentModule.getEditPanel().innerHTML||"<div><br></div>"===this.contentModule.getEditPanel().innerHTML||"<br>"===this.contentModule.getEditPanel().innerHTML||1===this.contentModule.getEditPanel().childNodes.length&&"P"===this.contentModule.getEditPanel().childNodes[0].tagName&&7===this.contentModule.getEditPanel().innerHTML.length||"DIV"===this.contentModule.getEditPanel().childNodes[0].tagName&&11===this.contentModule.getEditPanel().innerHTML.length?"":this.parent.value},n.prototype.getPanel=function(){return this.parent.element&&this.parent.element.querySelector(".e-rte-srctextarea")},n.prototype.getViewPanel=function(){return this.parent.iframeSettings.enable&&this.getPanel()?this.getPanel().parentElement:this.getPanel()},n.prototype.destroy=function(){this.removeEventListener()},n}(),as=function(){function n(e,t){this.ensureInsideTableList=!0,this.pageX=null,this.pageY=null,this.moveEle=null,this.parent=e,this.rteID=e.element.id,this.l10n=t.getService("rteLocale"),this.rendererFactory=t.getService("rendererFactory"),this.dialogRenderObj=t.getService("dialogRenderObject"),this.addEventListener()}return n.prototype.addEventListener=function(){this.parent.isDestroyed||(this.parent.on(Xe,this.renderDlgContent,this),this.parent.on(H,this.afterRender,this),this.parent.on(yt,this.afterRender,this),this.parent.on(Lt,this.showDialog,this),this.parent.on(Ot,this.closeDialog,this),this.parent.on(Ye,this.docClick,this),this.parent.on(Ue,this.editAreaClickHandler,this),this.parent.on(it,this.clearDialogObj,this),this.parent.on(Je,this.onToolbarAction,this),this.parent.on(re,this.dropdownSelect,this),this.parent.on($,this.keyDown,this),this.parent.on(Z,this.selectionTable,this),this.parent.on(F,this.destroy,this))},n.prototype.removeEventListener=function(){this.parent.isDestroyed||(this.parent.off(Xe,this.renderDlgContent),this.parent.off(H,this.afterRender),this.parent.off(yt,this.afterRender),this.parent.off(Ye,this.docClick),this.parent.off(Lt,this.showDialog),this.parent.off(Ot,this.closeDialog),this.parent.off(Ue,this.editAreaClickHandler),this.parent.off(it,this.clearDialogObj),this.parent.off(Je,this.onToolbarAction),this.parent.off(re,this.dropdownSelect),this.parent.off(Pe,this.cellSelect),this.parent.off(qe,this.setBGColor),this.parent.off($,this.keyDown),this.parent.off(Z,this.selectionTable),this.parent.off(F,this.destroy))},n.prototype.selectionTable=function(e){var n=e.args.target;"mozilla"!==t.Browser.info.name||t.isNullOrUndefined(t.closest(n,"table"))||"TABLE"!==t.closest(n,"table").tagName||this.parent.contentModule.getEditPanel().setAttribute("contenteditable","true")},n.prototype.afterRender=function(){t.isNullOrUndefined(this.contentModule)&&(this.contentModule=this.rendererFactory.getRenderer(e.RenderType.Content),this.parent.on(qe,this.setBGColor,this),this.parent.on(Pe,this.cellSelect,this),this.parent.tableSettings.resize&&t.EventHandler.add(this.parent.contentModule.getEditPanel(),t.Browser.touchStartEvent,this.resizeStart,this),!t.Browser.isDevice&&this.parent.tableSettings.resize&&t.EventHandler.add(this.contentModule.getEditPanel(),"mouseover",this.resizeHelper,this))},n.prototype.dropdownSelect=function(e){var t=e.item;if(document.body.contains(document.body.querySelector(".e-rte-quick-toolbar"))&&"Table"===t.command){var n=this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument()),i={args:e,selection:this.parent.formatter.editorManager.nodeSelection.save(n,this.contentModule.getDocument()),selectParent:this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(n)};switch(t.subCommand){case"InsertRowBefore":case"InsertRowAfter":this.addRow(i.selection,e);break;case"InsertColumnLeft":case"InsertColumnRight":this.addColumn(i.selection,e);break;case"DeleteColumn":case"DeleteRow":this.removeRowColumn(i.selection,e);break;case"AlignTop":case"AlignMiddle":case"AlignBottom":this.verticalAlign(i,e);break;case"Dashed":case"Alternate":case"Custom":this.tableStyles(i,t.subCommand);break;case"Merge":case"VerticalSplit":case"HorizontalSplit":this.UpdateCells(i.selection,e)}}},n.prototype.UpdateCells=function(e,t){this.parent.formatter.process(this.parent,t,t,{selection:e,subCommand:t.item.subCommand}),this.hideTableQuickToolbar()},n.prototype.keyDown=function(e){var n=e.args;switch(n.action){case"escape":break;case"insert-table":this.openDialog(!0,e),n.preventDefault()}if(!t.isNullOrUndefined(this.parent.formatter.editorManager.nodeSelection)&&this.contentModule&&"KeyK"!==n.code){var i=this.parent.formatter.editorManager.nodeSelection.getRange(this.parent.contentModule.getDocument()),r=this.parent.formatter.editorManager.nodeSelection.save(i,this.contentModule.getDocument()),o=this.parent.formatter.editorManager.nodeSelection.getParentNodeCollection(i)[0];if(o=o&&"TD"!==o.tagName&&"TH"!==o.tagName?o.parentElement:o,(8===n.keyCode||46===n.keyCode||n.ctrlKey&&88===n.keyCode)&&(o&&"TBODY"===o.tagName?(n.preventDefault(),this.removeTable(r,n,!0)):o&&o.querySelectorAll("table").length>0&&this.removeResizeElement()),o&&"TD"!==o.tagName&&"TH"!==o.tagName){var s=t.closest(o,"td");o=!t.isNullOrUndefined(s)&&this.parent.inputElement.contains(s)?s:o}if(o&&("TD"===o.tagName||"TH"===o.tagName))switch(n.keyCode){case 9:case 37:case 39:this.tabSelection(n,r,o);break;case 40:case 38:this.tableArrowNavigation(n,r,o)}}},n.prototype.openDialog=function(e,t){if(e||this.parent.contentModule.getEditPanel().focus(),"HTML"===this.parent.editorMode){var n=this.parent.contentModule.getDocument(),i=this.parent.formatter.editorManager.nodeSelection.getRange(n),r=this.parent.formatter.editorManager.nodeSelection.save(i,n),o={originalEvent:t?t.args:{action:"insert-table"},item:{command:"Table",subCommand:"CreateTable"}};this.insertTableDialog({self:this,args:o,selection:r})}},n.prototype.showDialog=function(){this.openDialog(!1)},n.prototype.closeDialog=function(){this.editdlgObj&&this.editdlgObj.hide({returnValue:!0})},n.prototype.onToolbarAction=function(e){switch(e.args.item.subCommand){case"TableHeader":this.tableHeader(e.selection,e.args);break;case"TableRemove":this.removeTable(e.selection,e.args);break;case"TableEditProperties":this.editTable(e)}},n.prototype.verticalAlign=function(e,n){var i=t.closest(e.selectParent[0],"td")||t.closest(e.selectParent[0],"th");i&&this.parent.formatter.process(this.parent,n,n,{tableCell:i,subCommand:n.item.subCommand})},n.prototype.tableStyles=function(e,n){var i=t.closest(e.selectParent[0],"table");if("Dashed"===n&&(this.parent.element.classList.contains(jn)?this.parent.element.classList.remove(jn):this.parent.element.classList.add(jn),i.classList.contains(jn)?i.classList.remove(jn):i.classList.add(jn)),"Alternate"===n&&(this.parent.element.classList.contains(Fn)?this.parent.element.classList.remove(Fn):this.parent.element.classList.add(Fn),i.classList.contains(Fn)?i.classList.remove(Fn):i.classList.add(Fn)),e.args&&e.args.item.cssClass)for(var r=e.args.item.cssClass.split(" "),o=0;o<r.length;o++)i.classList.contains(r[o])?i.classList.remove(r[o]):i.classList.add(r[o]);this.parent.formatter.saveData(),this.parent.formatter.editorManager.nodeSelection.restore()},n.prototype.insideList=function(e){for(var t=this.parent.formatter.editorManager.domNode.blockNodes(),n=[],i=0;i<t.length;i++)"LI"===t[i].parentNode.tagName?n.push(t[i].parentNode):"LI"===t[i].tagName&&"P"!==t[i].childNodes[0].tagName&&"OL"!==t[i].childNodes[0].tagName&&"UL"!==t[i].childNodes[0].tagName&&n.push(t[i]);return n.length>1||n.length&&0===e.startOffset&&0===e.endOffset?(this.ensureInsideTableList=!0,!0):(this.ensureInsideTableList=!1,!1)},n.prototype.tabSelection=function(e,n,i){var r=this.insideList(n.range);if((37!==e.keyCode&&39!==e.keyCode||3!==n.range.startContainer.nodeType)&&!r)if(e.preventDefault(),i.classList.remove(Hn),e.shiftKey||37===e.keyCode){var o=t.isNullOrUndefined(i.previousSibling)?t.isNullOrUndefined(t.closest(i,"tr").previousSibling)?t.isNullOrUndefined(t.closest(i,"table").previousSibling)?i:"td"===t.closest(i,"table").previousSibling.nodeName.toLowerCase()?t.closest(i,"table").previousSibling:i:t.closest(i,"tr").previousSibling.childNodes[t.closest(i,"tr").previousSibling.childNodes.length-1]:i.previousSibling;if(i===o&&0===i.cellIndex&&t.closest(i,"table").tHead){var s=t.closest(i,"table");o=s.rows[0].cells[s.rows[0].cells.length-1]}37===e.keyCode&&i===o&&(o=t.closest(i,"table").previousSibling),o&&(""!==o.textContent.trim()&&t.closest(o,"td")?n.setSelectionNode(this.contentModule.getDocument(),o):n.setSelectionText(this.contentModule.getDocument(),o,o,0,0))}else{var a=t.isNullOrUndefined(i.nextSibling)?t.isNullOrUndefined(t.closest(i,"tr").nextSibling)?t.isNullOrUndefined(t.closest(i,"table").nextSibling)?i:"td"===t.closest(i,"table").nextSibling.nodeName.toLowerCase()?t.closest(i,"table").nextSibling:i:t.closest(i,"tr").nextSibling.childNodes[0]:i.nextSibling;i===a&&"TH"===i.nodeName&&(a=t.closest(i,"table").rows[1].cells[0]),39===e.keyCode&&i===a&&(a=t.closest(i,"table").nextSibling),a&&(""!==a.textContent.trim()&&t.closest(a,"td")?n.setSelectionNode(this.contentModule.getDocument(),a):n.setSelectionText(this.contentModule.getDocument(),a,a,0,0)),i===a&&39!==e.keyCode&&a&&(i.classList.add(Hn),this.addRow(n,e,!0),i.classList.remove(Hn),""!==(a=a.parentElement.nextSibling.firstChild).textContent.trim()&&t.closest(a,"td")?n.setSelectionNode(this.contentModule.getDocument(),a):n.setSelectionText(this.contentModule.getDocument(),a,a,0,0))}},n.prototype.tableArrowNavigation=function(e,n,i){var r=n.range.startContainer;40===e.keyCode&&3===r.nodeType&&(r.nextSibling&&"BR"===r.nextSibling.nodeName||r.parentNode&&"TD"!==r.parentNode.nodeName)||38===e.keyCode&&3===r.nodeType&&(r.previousSibling&&"BR"===r.previousSibling.nodeName||r.parentNode&&"TD"!==r.parentNode.nodeName)||(e.preventDefault(),i.classList.remove(Hn),(i=40===e.keyCode?t.isNullOrUndefined(t.closest(i,"tr").nextElementSibling)?t.closest(i,"table").tHead&&"TH"===i.nodeName?t.closest(i,"table").rows[1].cells[i.cellIndex]:t.isNullOrUndefined(t.closest(i,"table").nextSibling)?i:t.closest(i,"table").nextSibling:t.closest(i,"tr").nextElementSibling.children[i.cellIndex]:t.isNullOrUndefined(t.closest(i,"tr").previousElementSibling)?t.closest(i,"table").tHead&&"TH"!==i.nodeName?t.closest(i,"table").tHead.rows[0].cells[i.cellIndex]:t.isNullOrUndefined(t.closest(i,"table").previousSibling)?i:t.closest(i,"table").previousSibling:t.closest(i,"tr").previousElementSibling.children[i.cellIndex])&&n.setSelectionText(this.contentModule.getDocument(),i,i,0,0))},n.prototype.setBGColor=function(e){for(var t=this.parent.formatter.editorManager.nodeSelection.getRange(this.contentModule.getDocument()),n=(this.parent.formatter.editorManager.nodeSelection.save(t,this.contentModule.getDocument()),this.curTable.querySelectorAll(".e-cell-select")),i=0;i<n.length;i++)n[i].style.backgroundColor=e.item.value;this.parent.formatter.saveData()},n.prototype.hideTableQuickToolbar=function(){this.quickToolObj&&this.quickToolObj.tableQTBar&&document.body.contains(this.quickToolObj.tableQTBar.element)&&this.quickToolObj.tableQTBar.hidePopup()},n.prototype.tableHeader=function(e,t){this.parent.formatter.process(this.parent,t,t.originalEvent,{selection:e,subCommand:t.item.subCommand})},n.prototype.editAreaClickHandler=function(n){if(!this.parent.readonly&&t.isNullOrUndefined(t.closest(n.args.target,".e-img-caption"))){var i=n.args,r=this.parent.quickToolbarSettings.showOnRightClick;if(!(2===i.which||r&&1===i.which||!r&&3===i.which)&&"HTML"===this.parent.editorMode&&this.parent.quickToolbarModule&&this.parent.quickToolbarModule.tableQTBar){this.quickToolObj=this.parent.quickToolbarModule;var o=i.target;this.contentModule=this.rendererFactory.getRenderer(e.RenderType.Content);if(this.quickToolObj.tableQTBar.element.classList.contains("e-rte-pop"))return;var s=this.parent.formatter.editorManager.nodeSelection.getRange(this.contentModule.getDocument()),a=t.closest(o,"table"),l=this.parent.getRange().startContainer.parentElement,d=this.parent.getRange().endContainer.parentElement;if(o&&"A"!==o.nodeName&&"IMG"!==o.nodeName&&l===d&&("TD"===o.nodeName||"TH"===o.nodeName||"TABLE"===o.nodeName||a&&this.parent.contentModule.getEditPanel().contains(a))&&(3!==s.startContainer.nodeType||s.collapsed)){var c=this.parent.formatter.editorManager.nodeSelection.getRange(this.contentModule.getDocument());this.parent.formatter.editorManager.nodeSelection.save(c,this.contentModule.getDocument()),this.parent.formatter.editorManager.nodeSelection.Clear(this.contentModule.getDocument());var p=this.parent.iframeSettings.enable?window.pageYOffset+this.parent.element.getBoundingClientRect().top+i.clientY:i.pageY;this.quickToolObj.tableQTBar.showPopup(i.pageX,p,o),this.parent.formatter.editorManager.nodeSelection.restore()}else this.hideTableQuickToolbar()}}},n.prototype.tableCellSelect=function(e){var n=e.target,i=Array.prototype.slice.call(n.parentElement.parentElement.children).indexOf(n.parentElement),r=Array.prototype.slice.call(n.parentElement.children).indexOf(n),o=this.dlgDiv.querySelectorAll(".e-rte-tablecell");Array.prototype.forEach.call(o,function(e){var n=Array.prototype.slice.call(e.parentElement.parentElement.children).indexOf(e.parentElement),o=Array.prototype.slice.call(e.parentElement.children).indexOf(e);t.removeClass([e],"e-active"),n<=i&&o<=r&&t.addClass([e],"e-active")}),this.tblHeader.innerHTML=r+1+"x"+(i+1)},n.prototype.tableMouseUp=function(e){t.EventHandler.remove(this.curTable,"mousemove",this.tableMove)},n.prototype.tableCellLeave=function(e){t.removeClass(this.dlgDiv.querySelectorAll(".e-rte-tablecell"),"e-active"),t.addClass([this.dlgDiv.querySelector(".e-rte-tablecell")],"e-active"),this.tblHeader.innerHTML="1x1"},n.prototype.tableCellClick=function(e){var t=e.target,n=Array.prototype.slice.call(t.parentElement.parentElement.children).indexOf(t.parentElement)+1,i=Array.prototype.slice.call(t.parentElement.children).indexOf(t)+1;this.self.tableInsert(n,i,e,this)},n.prototype.tableInsert=function(e,n,i,r){var o=r.self?r.self:this,s=r.selection.range.startContainer;"P"!==s.nodeName||""!==s.textContent.trim()||s.childNodes.length>0||(s.innerHTML="<br />");var a=s.parentNode;if("HTML"===o.parent.editorMode&&(o.parent.iframeSettings.enable&&!c(a.ownerDocument.querySelector("body"),"e-lib")||!o.parent.iframeSettings.enable&&t.isNullOrUndefined(t.closest(a,"[id='"+o.contentModule.getPanel().id+"']")))){o.contentModule.getEditPanel().focus();var l=o.parent.formatter.editorManager.nodeSelection.getRange(o.contentModule.getDocument());r.selection=o.parent.formatter.editorManager.nodeSelection.save(l,o.contentModule.getDocument())}var d={rows:e,columns:n,width:{minWidth:o.parent.tableSettings.minWidth,maxWidth:o.parent.tableSettings.maxWidth,width:o.parent.tableSettings.width},selection:r.selection};o.popupObj&&o.popupObj.hide(),o.editdlgObj&&o.editdlgObj.hide(),o.parent.formatter.process(o.parent,r.args,r.args.originalEvent,d),o.contentModule.getEditPanel().focus(),o.parent.on(Pe,o.cellSelect,o)},n.prototype.cellSelect=function(e){var n=e.args.target,i=t.closest(n,"td,th");n="TD"!==n.nodeName&&i&&this.parent.contentModule.getEditPanel().contains(i)?i:n,t.removeClass(this.contentModule.getEditPanel().querySelectorAll("table td, table th"),Hn),!n||"TD"!==n.tagName&&"TH"!==n.tagName||(t.addClass([n],Hn),this.activeCell=n,this.curTable=this.curTable?this.curTable:t.closest(n,"table"),t.EventHandler.add(this.curTable,"mousemove",this.tableMove,this),t.EventHandler.add(this.curTable,"mouseup",this.tableMouseUp,this),this.removeResizeElement(),this.helper&&this.contentModule.getEditPanel().contains(this.helper)&&t.detach(this.helper)),"mozilla"!==t.Browser.info.name||t.isNullOrUndefined(t.closest(n,"table"))||"TABLE"!==t.closest(n,"table").tagName||this.parent.contentModule.getEditPanel().setAttribute("contenteditable","false")},n.prototype.tableMove=function(e){this.parent.formatter.editorManager.observer.notify("TABLE_MOVE",{event:e,selectNode:[this.activeCell]})},n.prototype.resizeHelper=function(e){if(!this.parent.readonly){var n=e.target||e.targetTouches[0].target,i=t.closest(n,"table.e-rte-table");t.isNullOrUndefined(this.curTable)||t.isNullOrUndefined(i)||i===this.curTable||(this.removeResizeElement(),this.removeHelper(e),this.cancelResizeAction()),"TABLE"!==n.nodeName&&"TD"!==n.nodeName&&"TH"!==n.nodeName||(this.curTable=i&&this.parent.contentModule.getEditPanel().contains(i)&&("TD"===n.nodeName||"TH"===n.nodeName)?i:n,this.removeResizeElement(),this.tableResizeEleCreation(this.curTable,e))}},n.prototype.tableResizeEleCreation=function(e,n){this.parent.preventDefaultResize(n);for(var i=Array.prototype.slice.call(e.rows[this.calMaxCol(e)].cells,1),r=[],o=0;o<e.rows.length;o++)r.push(Array.prototype.slice.call(e.rows[o].cells,0,1)[0]);var s=parseInt(getComputedStyle(e).height,10),a=parseInt(getComputedStyle(e).width,10),l=this.calcPos(e);for(o=0;i.length>o;o++){var d=this.parent.createElement("span",{attrs:{"data-col":(o+1).toString(),unselectable:"on",contenteditable:"false"}});d.classList.add(di,qn),d.style.cssText="height: "+s+"px; width: 4px; top: "+l.top+"px; left:"+(l.left+this.calcPos(i[o]).left)+"px;",this.contentModule.getEditPanel().appendChild(d)}for(o=0;r.length>o;o++){var c=this.parent.createElement("span",{attrs:{"data-row":o.toString(),unselectable:"on",contenteditable:"false"}});c.classList.add(di,zn);var p=t.isNullOrUndefined(e.getAttribute("cellspacing"))&&""===e.getAttribute("cellspacing")?this.calcPos(r[o]).left:0;c.style.cssText="width: "+a+"px; height: 4px; top: "+(this.calcPos(r[o]).top+l.top+r[o].offsetHeight-2)+"px; left:"+(p+l.left)+"px;",this.contentModule.getEditPanel().appendChild(c)}var h=this.parent.createElement("span",{className:_n,attrs:{"data-col":i.length.toString(),unselectable:"on",contenteditable:"false"}});h.style.cssText="top: "+(l.top+s-4)+"px; left:"+(l.left+a-4)+"px;",t.Browser.isDevice&&h.classList.add("e-rmob"),this.contentModule.getEditPanel().appendChild(h)},n.prototype.removeResizeElement=function(){var e=this.parent.contentModule.getEditPanel().querySelectorAll(".e-column-resize, .e-row-resize, .e-table-box");if(e.length>0)for(var n=0;n<e.length;n++)t.detach(e[n])},n.prototype.calcPos=function(e){e.getBoundingClientRect();for(var n=e.ownerDocument,i=e.offsetParent||n.documentElement;i&&(i===n.body||i===n.documentElement)&&"static"===i.style.position;)i=i.parentNode;return"TD"===i.nodeName&&"TABLE"===e.nodeName&&(i=t.closest(i,".e-rte-content")),i&&i!==e&&1===i.nodeType&&i.getBoundingClientRect(),{top:e.offsetTop,left:e.offsetLeft}},n.prototype.getPointX=function(e){return e.touches&&e.touches.length?e.touches[0].pageX:e.pageX},n.prototype.getPointY=function(e){return e.touches&&e.touches.length?e.touches[0].pageY:e.pageY},n.prototype.resizeStart=function(e){var n=this;if(!this.parent.readonly){t.Browser.isDevice&&this.resizeHelper(e);var i=e.target;if(i.classList.contains(qn)||i.classList.contains(zn)||i.classList.contains(_n)){if(e.preventDefault(),this.parent.preventDefaultResize(e),t.removeClass(this.curTable.querySelectorAll("td,th"),Hn),this.parent.formatter.editorManager.nodeSelection.Clear(this.contentModule.getDocument()),this.pageX=this.getPointX(e),this.pageY=this.getPointY(e),this.resizeBtnInit(),this.hideTableQuickToolbar(),i.classList.contains(qn)&&(this.resizeBtnStat.column=!0,this.columnEle=this.curTable.rows[this.calMaxCol(this.curTable)].cells[parseInt(i.getAttribute("data-col"),10)],this.colIndex=this.columnEle.cellIndex,this.moveEle=e.target,this.appendHelper()),i.classList.contains(zn)&&(this.rowEle=this.curTable.rows[parseInt(i.getAttribute("data-row"),10)],this.resizeBtnStat.row=!0,this.appendHelper()),i.classList.contains(_n)&&(this.resizeBtnStat.tableBox=!0),t.Browser.isDevice&&this.helper&&!this.helper.classList.contains("e-reicon"))this.helper.classList.add("e-reicon"),t.EventHandler.add(document,t.Browser.touchStartEvent,this.removeHelper,this),t.EventHandler.add(this.helper,t.Browser.touchStartEvent,this.resizeStart,this);else{var r={event:e,requestType:"Table"};this.parent.trigger(ce,r,function(e){e.cancel&&n.cancelResizeAction()})}t.EventHandler.add(this.contentModule.getDocument(),t.Browser.touchMoveEvent,this.resizing,this),t.EventHandler.add(this.contentModule.getDocument(),t.Browser.touchEndEvent,this.resizeEnd,this)}}},n.prototype.removeHelper=function(e){!e.target.classList.contains("e-reicon")&&this.helper&&(t.EventHandler.remove(document,t.Browser.touchStartEvent,this.removeHelper),t.EventHandler.remove(this.helper,t.Browser.touchStartEvent,this.resizeStart),this.helper&&this.contentModule.getEditPanel().contains(this.helper)&&t.detach(this.helper),this.pageX=null,this.helper=null)},n.prototype.appendHelper=function(){this.helper=this.parent.createElement("div",{className:"e-table-rhelper"}),t.Browser.isDevice&&this.helper.classList.add("e-reicon"),this.contentModule.getEditPanel().appendChild(this.helper),this.setHelperHeight()},n.prototype.setHelperHeight=function(){var e=this.calcPos(this.curTable);this.resizeBtnStat.column?(this.helper.classList.add("e-column-helper"),this.helper.style.cssText="height: "+getComputedStyle(this.curTable).height+"; top: "+e.top+"px; left:"+(e.left+this.calcPos(this.columnEle).left-1)+"px;"):(this.helper.classList.add("e-row-helper"),this.helper.style.cssText="width: "+getComputedStyle(this.curTable).width+"; top: "+(this.calcPos(this.rowEle).top+e.top+this.rowEle.offsetHeight)+"px; left:"+(this.calcPos(this.rowEle).left+e.left)+"px;")},n.prototype.updateHelper=function(){var e=this.calcPos(this.curTable);if(this.resizeBtnStat.column){var t=e.left+this.calcPos(this.columnEle).left-1;this.helper.style.left=t+"px"}else{var n=this.calcPos(this.rowEle).top+e.top+this.rowEle.offsetHeight;this.helper.style.top=n+"px"}},n.prototype.calMaxCol=function(e){for(var t,n=0,i=0;i<e.rows.length;i++)n<e.rows[i].cells.length&&(t=i,n=e.rows[i].cells.length);return t},n.prototype.resizing=function(e){var n=this,i=this.getPointX(e),r=this.getPointY(e),o=this.parent.enableRtl?-(i-this.pageX):i-this.pageX,s=this.parent.enableRtl?-(r-this.pageY):r-this.pageY;this.pageX=i,this.pageY=r;var a={event:e,requestType:"table"};this.parent.trigger(pe,a,function(i){if(i.cancel)n.cancelResizeAction();else{var r=n.contentModule.getEditPanel().querySelector(".e-table-box"),a=parseInt(getComputedStyle(n.curTable).width,10),l=parseInt(getComputedStyle(n.curTable).height,10),d=+getComputedStyle(n.contentModule.getEditPanel()).paddingRight.match(/\d/g).join(""),c=n.contentModule.getEditPanel().offsetWidth-2*d;if(n.resizeBtnStat.column){for(var p=n.curTable.rows[n.calMaxCol(n.curTable)].cells,h=parseFloat(n.columnEle.offsetWidth.toString())-o,u=parseFloat(n.columnEle.offsetWidth.toString())+parseFloat(p[n.colIndex-1].offsetWidth.toString()),m=0;m<n.curTable.rows.length;m++)if(u-h>20&&h>20){var g=u-h,f=h;t.isNullOrUndefined(n.curTable.rows[m].cells[n.colIndex-1])||(n.curTable.rows[m].cells[n.colIndex-1].style.width=n.convertPixelToPercentage(g,a)+"%"),t.isNullOrUndefined(n.curTable.rows[m].cells[n.colIndex])||(n.curTable.rows[m].cells[n.colIndex].style.width=n.convertPixelToPercentage(f,a)+"%")}n.updateHelper()}else if(n.resizeBtnStat.row){n.parent.preventDefaultResize(e);var b=parseFloat(n.rowEle.clientHeight.toString())+s;b>20&&(n.rowEle.style.height=b+"px"),n.curTable.style.height="",t.isNullOrUndefined(r)||(r.style.cssText="top: "+(n.calcPos(n.curTable).top+l-4)+"px; left:"+(n.calcPos(n.curTable).left+a-4)+"px;"),n.updateHelper()}else if(n.resizeBtnStat.tableBox){t.Browser.isDevice||t.EventHandler.remove(n.contentModule.getEditPanel(),"mouseover",n.resizeHelper);var v=n.curTable.style.width.indexOf("%")>-1;n.curTable.style.width=v?n.convertPixelToPercentage(a+o,c)+"%":a+o+"px",n.curTable.style.height=l+s+"px",r.classList.add("e-rbox-select"),r.style.cssText="top: "+(n.calcPos(n.curTable).top+l-4)+"px; left:"+(n.calcPos(n.curTable).left+a-4)+"px;"}}})},n.prototype.convertPixelToPercentage=function(e,t){return e/t*100},n.prototype.cancelResizeAction=function(){t.EventHandler.remove(this.contentModule.getDocument(),t.Browser.touchMoveEvent,this.resizing),t.EventHandler.remove(this.contentModule.getDocument(),t.Browser.touchEndEvent,this.resizeEnd),this.removeResizeElement()},n.prototype.resizeEnd=function(e){this.resizeBtnInit(),t.EventHandler.remove(this.contentModule.getDocument(),t.Browser.touchMoveEvent,this.resizing),t.EventHandler.remove(this.contentModule.getDocument(),t.Browser.touchEndEvent,this.resizeEnd),this.contentModule.getEditPanel().querySelector(".e-table-box")&&this.contentModule.getEditPanel().contains(this.contentModule.getEditPanel().querySelector(".e-table-box"))&&(t.Browser.isDevice||t.EventHandler.add(this.contentModule.getEditPanel(),"mouseover",this.resizeHelper,this),this.removeResizeElement(),this.helper&&this.contentModule.getEditPanel().contains(this.helper)&&(t.detach(this.helper),this.helper=null),this.pageX=null,this.pageY=null,this.moveEle=null);var n={event:e,requestType:"table"};this.parent.trigger(he,n),this.parent.formatter.saveData()},n.prototype.resizeBtnInit=function(){return this.resizeBtnStat={column:!1,row:!1,tableBox:!1}},n.prototype.addRow=function(e,t,n){var i;n&&(i={item:{command:"Table",subCommand:"InsertRowAfter"}});var r={selection:e,subCommand:n?i.item.subCommand:t.item.subCommand};this.parent.formatter.process(this.parent,n?i:t,t,r)},n.prototype.addColumn=function(e,t){this.parent.formatter.process(this.parent,t,t,{selection:e,width:this.parent.tableSettings.width,subCommand:t.item.subCommand})},n.prototype.removeRowColumn=function(e,t){this.parent.formatter.process(this.parent,t,t,{selection:e,subCommand:t.item.subCommand}),this.hideTableQuickToolbar()},n.prototype.removeTable=function(e,t,n){var i;n&&(i={item:{command:"Table",subCommand:"TableRemove"}});var r={selection:e,subCommand:n?i.item.subCommand:t.item.subCommand};this.parent.formatter.process(this.parent,n?i:t,t.originalEvent,r),this.contentModule.getEditPanel().focus(),this.removeResizeElement(),this.hideTableQuickToolbar()},n.prototype.renderDlgContent=function(e){var n=this;if(t.Browser.isDevice||this.parent.inlineMode.enable)this.insertTableDialog(e);else if(this.popupObj)this.popupObj.hide();else{this.hideTableQuickToolbar();var i=this.l10n.getConstant("inserttablebtn");this.dlgDiv=this.parent.createElement("div",{className:"e-rte-table-popup",id:this.rteID+"_table"}),this.tblHeader=this.parent.createElement("div",{className:"e-rte-popup-header"}),this.tblHeader.innerHTML="1X1",this.dlgDiv.appendChild(this.tblHeader);var o=this.parent.createElement("div",{className:"e-rte-table-span"});this.drawTable(o,e),this.dlgDiv.appendChild(o),this.dlgDiv.appendChild(this.parent.createElement("span",{className:"e-span-border"}));var a=this.parent.createElement("button",{className:"e-insert-table-btn",id:this.rteID+"_insertTable",attrs:{type:"button",tabindex:"0"}});t.isNullOrUndefined(this.parent.getToolbarElement().querySelector(".e-expended-nav"))||this.parent.getToolbarElement().querySelector(".e-expended-nav").setAttribute("tabindex","1"),this.dlgDiv.appendChild(a);var l=new s.Button({iconCss:"e-icons e-create-table",content:i,cssClass:"e-flat",enableRtl:this.parent.enableRtl,locale:this.parent.locale});l.isStringTemplate=!0,l.appendTo(a),t.EventHandler.add(a,"click",this.insertTableDialog,{self:this,args:e.args,selection:e.selection}),this.parent.getToolbar().appendChild(this.dlgDiv);var d=e.args.originalEvent.target;d=d.classList.contains("e-toolbar-item")?d.firstChild:d.parentElement,this.popupObj=new r.Popup(this.dlgDiv,{targetType:"relative",relateTo:d,collision:{X:"fit",Y:"none"},offsetY:8,viewPortElement:this.parent.element,position:{X:"left",Y:"bottom"},enableRtl:this.parent.enableRtl,zIndex:10001,close:function(e){n.parent.isBlur=!1,n.popupObj.destroy(),t.detach(n.popupObj.element),n.popupObj=null}}),t.addClass([this.popupObj.element],"e-popup-open"),this.popupObj.refreshPosition(d)}},n.prototype.docClick=function(e){var n=e.args.target;n&&n.classList&&(this.popupObj&&!t.closest(n,"[id='"+this.popupObj.element.id+"']")||this.editdlgObj&&!t.closest(n,"#"+this.editdlgObj.element.id))&&!n.classList.contains("e-create-table")&&n.offsetParent&&!n.offsetParent.classList.contains("e-rte-backgroundcolor-dropdown")&&(this.popupObj&&this.popupObj.hide(),this.editdlgObj&&this.editdlgObj.hide(),this.parent.isBlur=!0,C(this.parent.element,"focusout"));var i=t.closest(n,"td"),r=!(!i||!this.parent.contentModule.getEditPanel().contains(i));!n||"TD"===n.tagName||"TH"===n.tagName||r||null!==t.closest(n,".e-rte-quick-popup")||!n.offsetParent||n.offsetParent.classList.contains("e-quick-dropdown")||n.offsetParent.classList.contains("e-rte-backgroundcolor-dropdown")||t.closest(n,".e-rte-dropdown-popup")||t.closest(n,".e-rte-elements")||(t.removeClass(this.parent.element.querySelectorAll("table td"),Hn),t.Browser.isIE||this.hideTableQuickToolbar()),!n||!n.classList||n.classList.contains(qn)||n.classList.contains(zn)||n.classList.contains(_n)||this.removeResizeElement()},n.prototype.drawTable=function(e,n){for(var i,r,o=0;o<3;o++){i=this.parent.createElement("div",{className:"e-rte-table-row",attrs:{"data-column":""+o}});for(var s=0;s<10;s++){var a=o>2?"none":"inline-block";r=this.parent.createElement("div",{className:"e-rte-tablecell e-default",attrs:{"data-cell":""+s}}),i.appendChild(r),r.style.display=a,0===s&&0===o&&t.addClass([r],"e-active"),t.EventHandler.add(r,"mousemove",this.tableCellSelect,this),t.EventHandler.add(i,"mouseleave",this.tableCellLeave,this),t.EventHandler.add(r,"mouseup",this.tableCellClick,{self:this,args:n.args,selection:n.selection})}e.appendChild(i)}},n.prototype.editTable=function(e){var t=this;this.createDialog(e);var n=this.tableDlgContent(e),i=this.l10n.getConstant("dialogUpdate"),r=this.l10n.getConstant("dialogCancel"),o=this.l10n.getConstant("tableEditHeader");this.editdlgObj.setProperties({height:"initial",width:"290px",content:n,header:o,buttons:[{click:this.applyProperties.bind(this,e),buttonModel:{content:i,cssClass:"e-flat e-size-update",isPrimary:!0}},{click:function(e){t.cancelDialog(e)},buttonModel:{cssClass:"e-flat e-cancel",content:r}}]}),this.editdlgObj.element.style.maxHeight="none",this.editdlgObj.content.querySelector("input").focus(),this.hideTableQuickToolbar()},n.prototype.insertTableDialog=function(e){var n=this.self?this.self:this;n.popupObj&&n.popupObj.hide(),n.createDialog(e);var i=n.tableCellDlgContent(),r=n.l10n.getConstant("dialogInsert"),o=n.l10n.getConstant("dialogCancel");t.isNullOrUndefined(n.editdlgObj)||(n.editdlgObj.setProperties({height:"initial",width:"290px",content:i,buttons:[{click:n.customTable.bind(this,e),buttonModel:{content:r,cssClass:"e-flat e-insert-table",isPrimary:!0}},{click:function(e){n.cancelDialog(e)},buttonModel:{cssClass:"e-flat e-cancel",content:o}}]}),n.editdlgObj.element.style.maxHeight="none",n.editdlgObj.content.querySelector("input").focus())},n.prototype.tableCellDlgContent=function(){var e=this.l10n.getConstant("columns"),t=this.l10n.getConstant("rows"),n=this.parent.createElement("div",{className:"e-cell-wrap"}),i=S('<div class="e-rte-field"><input type="text"  data-role ="none" id="tableColumn" class="e-table-column"/></div><div class="e-rte-field"><input type="text" data-role ="none" id="tableRow" class="e-table-row" /></div>');return n.appendChild(i),this.columnTextBox=new o.NumericTextBox({format:"n0",min:1,value:3,placeholder:e,floatLabelType:"Auto",max:50,enableRtl:this.parent.enableRtl,locale:this.parent.locale}),this.columnTextBox.isStringTemplate=!0,this.columnTextBox.appendTo(n.querySelector("#tableColumn")),this.rowTextBox=new o.NumericTextBox({format:"n0",min:1,value:3,placeholder:t,floatLabelType:"Auto",max:50,enableRtl:this.parent.enableRtl,locale:this.parent.locale}),this.rowTextBox.isStringTemplate=!0,this.rowTextBox.appendTo(n.querySelector("#tableRow")),n},n.prototype.clearDialogObj=function(){this.editdlgObj&&(this.editdlgObj.destroy(),t.detach(this.editdlgObj.element),this.editdlgObj=null)},n.prototype.createDialog=function(e){var n=this;if(this.editdlgObj)this.editdlgObj.hide({returnValue:!0});else{var i=this.parent.createElement("div",{className:"e-rte-edit-table",id:this.rteID+"_tabledialog"});this.parent.element.appendChild(i);var r=this.l10n.getConstant("dialogInsert"),o=this.l10n.getConstant("dialogCancel"),s={header:this.l10n.getConstant("tabledialogHeader"),cssClass:yn,enableRtl:this.parent.enableRtl,locale:this.parent.locale,showCloseIcon:!0,closeOnEscape:!0,width:t.Browser.isDevice?"290px":"340px",height:"initial",position:{X:"center",Y:t.Browser.isDevice?"center":"top"},isModal:t.Browser.isDevice,buttons:[{buttonModel:{content:r,cssClass:"e-flat e-insert-table",isPrimary:!0}},{click:function(e){n.cancelDialog(e)},buttonModel:{cssClass:"e-flat e-cancel",content:o}}],target:t.Browser.isDevice?document.body:this.parent.element,animationSettings:{effect:"None"},close:function(e){n.parent.isBlur=!1,n.editdlgObj.destroy(),t.detach(n.editdlgObj.element),n.dialogRenderObj.close(e),n.editdlgObj=null}};this.editdlgObj=this.dialogRenderObj.render(s),this.editdlgObj.appendTo(i),this.quickToolObj&&this.quickToolObj.inlineQTBar&&document.body.contains(this.quickToolObj.inlineQTBar.element)&&this.quickToolObj.inlineQTBar.hidePopup()}},n.prototype.customTable=function(e,n){var i=this.self?this.self:this;if(i.rowTextBox.value&&i.columnTextBox.value){var r=t.Browser.isDevice||!t.isNullOrUndefined(e.args)&&!t.isNullOrUndefined(e.args.originalEvent)&&"insert-table"===e.args.originalEvent.action||i.parent.inlineMode.enable?e:this;i.tableInsert(i.rowTextBox.value,i.columnTextBox.value,n,r)}},n.prototype.cancelDialog=function(e){this.parent.isBlur=!1,this.editdlgObj.hide({returnValue:!0})},n.prototype.applyProperties=function(e,n){var i=this.editdlgObj.element,r=t.closest(e.selectNode[0],"table");if(r.style.width=i.querySelector(".e-table-width").value+"px",""!==i.querySelector(".e-cell-padding").value)for(var o=r.querySelectorAll("td"),s=0;s<o.length;s++){var a="";""===o[s].style.padding?a=o[s].getAttribute("style")+" padding:"+i.querySelector(".e-cell-padding").value+"px;":(o[s].style.padding=i.querySelector(".e-cell-padding").value+"px",a=o[s].getAttribute("style")),o[s].setAttribute("style",a)}r.cellSpacing=i.querySelector(".e-cell-spacing").value,t.isNullOrUndefined(r.cellSpacing)&&"0"===r.cellSpacing?t.removeClass([r],li):t.addClass([r],li),this.parent.formatter.saveData(),this.editdlgObj.hide({returnValue:!0})},n.prototype.tableDlgContent=function(e){var n=e.selectParent[0],i=this.l10n.getConstant("tableWidth"),r=this.l10n.getConstant("cellpadding"),s=this.l10n.getConstant("cellspacing"),a=this.parent.createElement("div",{className:"e-table-sizewrap"}),l=t.closest(n,"table").getClientRects()[0].width,d=t.closest(n,"td").style.padding,c=t.closest(n,"table").getAttribute("cellspacing"),p=S('<div class="e-rte-field"><input type="text" data-role ="none" id="tableWidth" class="e-table-width"  /></div><div class="e-rte-field"><input type="text" data-role ="none" id="cellPadding" class="e-cell-padding" /> </div><div class="e-rte-field"><input type="text" data-role ="none" id="cellSpacing" class="e-cell-spacing" /></div>');a.appendChild(p);var h=new o.NumericTextBox({format:"n0",min:0,value:l,placeholder:i,floatLabelType:"Auto",enableRtl:this.parent.enableRtl,locale:this.parent.locale});h.isStringTemplate=!0,h.appendTo(a.querySelector("#tableWidth"));var u=new o.NumericTextBox({format:"n0",min:0,value:""!==d?parseInt(d,null):0,placeholder:r,floatLabelType:"Auto",enableRtl:this.parent.enableRtl,locale:this.parent.locale});u.isStringTemplate=!0,u.appendTo(a.querySelector("#cellPadding"));var m=new o.NumericTextBox({format:"n0",min:0,value:""===c||t.isNullOrUndefined(c)?0:parseInt(c,null),placeholder:s,floatLabelType:"Auto",enableRtl:this.parent.enableRtl,locale:this.parent.locale});return m.isStringTemplate=!0,m.appendTo(a.querySelector("#cellSpacing")),a},n.prototype.destroy=function(){this.removeEventListener()},n.prototype.getModuleName=function(){return"table"},n}(),ls=function(){function e(e){this.parent=e}return e.prototype.render=function(e){var n;return e.beforeOpen=this.beforeOpen.bind(this),e.open=this.open.bind(this),t.isNullOrUndefined(e.close)&&(e.close=this.close.bind(this)),e.beforeClose=this.beforeClose.bind(this),n=new r.Dialog(e),n.isStringTemplate=!0,n},e.prototype.beforeOpen=function(e){this.parent.trigger(nt,e,this.beforeOpenCallback.bind(this,e))},e.prototype.beforeOpenCallback=function(e){e.cancel&&this.parent.notify(it,null)},e.prototype.open=function(e){this.parent.trigger("dialogOpen",e)},e.prototype.beforeClose=function(e){this.parent.trigger(rt,e,function(e){e.cancel||e.container.classList.contains("e-popup-close")&&(e.cancel=!0)})},e.prototype.close=function(e){this.parent.trigger("dialogClose",e)},e}(),ds={bold:{command:"Style",subCommand:"Bold",value:"strong"},italic:{command:"Style",subCommand:"Italic",value:"em"},underline:{command:"Style",subCommand:"Underline",value:"span"},strikeThrough:{command:"Style",subCommand:"StrikeThrough",value:"span"},insertCode:{command:"Formats",subCommand:"Pre",value:"pre"},superscript:{command:"Effects",subCommand:"SuperScript",value:"sup"},subscript:{command:"Effects",subCommand:"SubScript",value:"sub"},uppercase:{command:"Casing",subCommand:"UpperCase"},lowercase:{command:"Casing",subCommand:"LowerCase"},fontColor:{command:"font",subCommand:"fontcolor",value:"#ff0000"},fontName:{command:"font",subCommand:"fontname",value:"Segoe UI"},fontSize:{command:"font",subCommand:"fontsize",value:"10pt"},backColor:{command:"font",subCommand:"backgroundcolor",value:"#ffff00"},justifyCenter:{command:"Alignments",subCommand:"JustifyCenter"},justifyFull:{command:"Alignments",subCommand:"JustifyFull"},justifyLeft:{command:"Alignments",subCommand:"JustifyLeft"},justifyRight:{command:"Alignments",subCommand:"JustifyRight"},undo:{command:"Actions",subCommand:"Undo"},redo:{command:"Actions",subCommand:"Redo"},createLink:{command:"Links",subCommand:"createLink"},editLink:{command:"Links",subCommand:"createLink"},createImage:{command:"Images",subCommand:"Images"},formatBlock:{command:"Formats",value:"P"},heading:{command:"Formats",value:"H1"},indent:{command:"Indents",subCommand:"Indent"},outdent:{command:"Indents",subCommand:"Outdent"},insertHTML:{command:"InsertHTML",subCommand:"InsertHTML",value:""},insertText:{command:"InsertText",subCommand:"InsertText",value:""},insertHorizontalRule:{command:"InsertHTML",subCommand:"InsertHTML",value:"<hr/>"},insertImage:{command:"Images",subCommand:"Image"},editImage:{command:"Images",subCommand:"Image"},insertTable:{command:"Table",subCommand:"CreateTable"},insertBrOnReturn:{command:"InsertHTML",subCommand:"InsertHTML",value:"<br/>"},insertOrderedList:{command:"Lists",value:"OL"},insertUnorderedList:{command:"Lists",value:"UL"},insertParagraph:{command:"Formats",value:"P"},removeFormat:{command:"Clear",subCommand:"ClearFormat"}},cs=function(){var e=function(t,n){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(t,n)};return function(t,n){function i(){this.constructor=t}e(t,n),t.prototype=null===n?Object.create(n):(i.prototype=n.prototype,new i)}}(),ps=function(e,t,n,i){var r,o=arguments.length,s=o<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,n):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,n,i);else for(var a=e.length-1;a>=0;a--)(r=e[a])&&(s=(o<3?r(s):o>3?r(t,n,s):r(t,n))||s);return o>3&&s&&Object.defineProperty(t,n,s),s},hs=function(n){function i(){return null!==n&&n.apply(this,arguments)||this}return cs(i,n),ps([t.Property(!0)],i.prototype,"enable",void 0),ps([t.Property(!0)],i.prototype,"enableFloating",void 0),ps([t.Property(e.ToolbarType.Expand)],i.prototype,"type",void 0),ps([t.Property(Oi)],i.prototype,"items",void 0),ps([t.Property({})],i.prototype,"itemConfigs",void 0),i}(t.ChildProperty),us=function(e){function n(){return null!==e&&e.apply(this,arguments)||this}return cs(n,e),ps([t.Property([".jpeg",".jpg",".png"])],n.prototype,"allowedTypes",void 0),ps([t.Property("inline")],n.prototype,"display",void 0),ps([t.Property("Blob")],n.prototype,"saveFormat",void 0),ps([t.Property("auto")],n.prototype,"width",void 0),ps([t.Property("auto")],n.prototype,"height",void 0),ps([t.Property(null)],n.prototype,"saveUrl",void 0),ps([t.Property(null)],n.prototype,"path",void 0),ps([t.Property(!0)],n.prototype,"resize",void 0),ps([t.Property(null)],n.prototype,"removeUrl",void 0),ps([t.Property(0)],n.prototype,"minWidth",void 0),ps([t.Property(null)],n.prototype,"maxWidth",void 0),ps([t.Property(0)],n.prototype,"minHeight",void 0),ps([t.Property(null)],n.prototype,"maxHeight",void 0),ps([t.Property(!1)],n.prototype,"resizeByPercent",void 0),n}(t.ChildProperty),ms=function(e){function n(){return null!==e&&e.apply(this,arguments)||this}return cs(n,e),ps([t.Complex({getImageUrl:null,url:null,uploadUrl:null},a.AjaxSettings)],n.prototype,"ajaxSettings",void 0),ps([t.Property(!1)],n.prototype,"allowDragAndDrop",void 0),ps([t.Complex({visible:!0,file:["Open","|","Cut","Copy","|","Delete","Rename","|","Details"],folder:["Open","|","Cut","Copy","Paste","|","Delete","Rename","|","Details"],layout:["SortBy","View","Refresh","|","Paste","|","NewFolder","Upload","|","Details","|","SelectAll"]},a.ContextMenuSettings)],n.prototype,"contextMenuSettings",void 0),ps([t.Property("")],n.prototype,"cssClass",void 0),ps([t.Complex({},a.DetailsViewSettings)],n.prototype,"detailsViewSettings",void 0),ps([t.Property(!1)],n.prototype,"enable",void 0),ps([t.Complex({maxWidth:"650px",minWidth:"240px",visible:!0},a.NavigationPaneSettings)],n.prototype,"navigationPaneSettings",void 0),ps([t.Property("/")],n.prototype,"path",void 0),ps([t.Property(null)],n.prototype,"rootAliasName",void 0),ps([t.Complex({},a.SearchSettings)],n.prototype,"searchSettings",void 0),ps([t.Property(!0)],n.prototype,"showFileExtension",void 0),ps([t.Property(!1)],n.prototype,"showHiddenItems",void 0),ps([t.Property(!0)],n.prototype,"showThumbnail",void 0),ps([t.Property("Ascending")],n.prototype,"sortOrder",void 0),ps([t.Complex({visible:!0,items:["NewFolder","Upload","Cut","Copy","Paste","Delete","Download","Rename","SortBy","Refresh","Selection","View","Details"]},a.ToolbarSettings)],n.prototype,"toolbarSettings",void 0),ps([t.Complex({autoUpload:!0,minFileSize:0,maxFileSize:3e7,allowedExtensions:"",autoClose:!1},a.UploadSettings)],n.prototype,"uploadSettings",void 0),ps([t.Property("LargeIcons")],n.prototype,"view",void 0),n}(t.ChildProperty),gs=function(e){function n(){return null!==e&&e.apply(this,arguments)||this}return cs(n,e),ps([t.Property("100%")],n.prototype,"width",void 0),ps([t.Property(Li)],n.prototype,"styles",void 0),ps([t.Property(!0)],n.prototype,"resize",void 0),ps([t.Property(0)],n.prototype,"minWidth",void 0),ps([t.Property(null)],n.prototype,"maxWidth",void 0),n}(t.ChildProperty),fs=function(e){function n(){return null!==e&&e.apply(this,arguments)||this}return cs(n,e),ps([t.Property(!0)],n.prototype,"enable",void 0),ps([t.Property(!1)],n.prototype,"showOnRightClick",void 0),ps([t.Property("hide")],n.prototype,"actionOnScroll",void 0),ps([t.Property(["Open","Edit","UnLink"])],n.prototype,"link",void 0),ps([t.Property(["Replace","Align","Caption","Remove","-","InsertLink","OpenImageLink","EditImageLink","RemoveImageLink","Display","AltText","Dimension"])],n.prototype,"image",void 0),ps([t.Property(["Cut","Copy","Paste"])],n.prototype,"text",void 0),ps([t.Property(["TableHeader","TableRows","TableColumns","BackgroundColor","-","TableRemove","Alignments","TableCellVerticalAlign","Styles"])],n.prototype,"table",void 0),n}(t.ChildProperty),bs=function(e){function n(){return null!==e&&e.apply(this,arguments)||this}return cs(n,e),ps([t.Property(!1)],n.prototype,"prompt",void 0),ps([t.Property(null)],n.prototype,"deniedAttrs",void 0),ps([t.Property(["background","background-color","border","border-bottom","border-left","border-radius","border-right","border-style","border-top","border-width","clear","color","cursor","direction","display","float","font","font-family","font-size","font-weight","font-style","height","left","line-height","list-style-type","margin","margin-top","margin-left","margin-right","margin-bottom","max-height","max-width","min-height","min-width","overflow","overflow-x","overflow-y","padding","padding-bottom","padding-left","padding-right","padding-top","position","right","table-layout","text-align","text-decoration","text-indent","top","vertical-align","visibility","white-space","width"])],n.prototype,"allowedStyleProps",void 0),ps([t.Property(null)],n.prototype,"deniedTags",void 0),ps([t.Property(!0)],n.prototype,"keepFormat",void 0),ps([t.Property(!1)],n.prototype,"plainText",void 0),n}(t.ChildProperty),vs=function(e){function n(){return null!==e&&e.apply(this,arguments)||this}return cs(n,e),ps([t.Property(null)],n.prototype,"default",void 0),ps([t.Property("65px")],n.prototype,"width",void 0),ps([t.Property(xi)],n.prototype,"items",void 0),n}(t.ChildProperty),ys=function(e){function n(){return null!==e&&e.apply(this,arguments)||this}return cs(n,e),ps([t.Property(null)],n.prototype,"default",void 0),ps([t.Property("35px")],n.prototype,"width",void 0),ps([t.Property(Di)],n.prototype,"items",void 0),n}(t.ChildProperty),Cs=function(e){function n(){return null!==e&&e.apply(this,arguments)||this}return cs(n,e),ps([t.Property(null)],n.prototype,"default",void 0),ps([t.Property("65px")],n.prototype,"width",void 0),ps([t.Property(Mi)],n.prototype,"types",void 0),n}(t.ChildProperty),Ss=function(e){function n(){return null!==e&&e.apply(this,arguments)||this}return cs(n,e),ps([t.Property("#ff0000")],n.prototype,"default",void 0),ps([t.Property("Palette")],n.prototype,"mode",void 0),ps([t.Property(10)],n.prototype,"columns",void 0),ps([t.Property(Ri)],n.prototype,"colorCode",void 0),ps([t.Property(!1)],n.prototype,"modeSwitcher",void 0),n}(t.ChildProperty),Ns=function(e){function n(){return null!==e&&e.apply(this,arguments)||this}return cs(n,e),ps([t.Property("#ffff00")],n.prototype,"default",void 0),ps([t.Property("Palette")],n.prototype,"mode",void 0),ps([t.Property(10)],n.prototype,"columns",void 0),ps([t.Property(Ii)],n.prototype,"colorCode",void 0),ps([t.Property(!1)],n.prototype,"modeSwitcher",void 0),n}(t.ChildProperty),Es=function(e){function n(){return null!==e&&e.apply(this,arguments)||this}return cs(n,e),ps([t.Property(Bi)],n.prototype,"types",void 0),n}(t.ChildProperty),Ts=function(e){function n(){return null!==e&&e.apply(this,arguments)||this}return cs(n,e),ps([t.Property(Pi)],n.prototype,"types",void 0),n}(t.ChildProperty),ws=function(){var e=function(t,n){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(t,n)};return function(t,n){function i(){this.constructor=t}e(t,n),t.prototype=null===n?Object.create(n):(i.prototype=n.prototype,new i)}}(),ks=function(e,t,n,i){var r,o=arguments.length,s=o<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,n):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,n,i);else for(var a=e.length-1;a>=0;a--)(r=e[a])&&(s=(o<3?r(s):o>3?r(t,n,s):r(t,n))||s);return o>3&&s&&Object.defineProperty(t,n,s),s},Ls=function(e){function n(){return null!==e&&e.apply(this,arguments)||this}return ws(n,e),ks([t.Property([])],n.prototype,"styles",void 0),ks([t.Property([])],n.prototype,"scripts",void 0),n}(t.ChildProperty),Os=function(e){function n(){return null!==e&&e.apply(this,arguments)||this}return ws(n,e),ks([t.Property(!1)],n.prototype,"enable",void 0),ks([t.Property(null)],n.prototype,"attributes",void 0),ks([t.Complex({},Ls)],n.prototype,"resources",void 0),n}(t.ChildProperty),xs=function(){var e=function(t,n){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(t,n)};return function(t,n){function i(){this.constructor=t}e(t,n),t.prototype=null===n?Object.create(n):(i.prototype=n.prototype,new i)}}(),Ds=function(e,t,n,i){var r,o=arguments.length,s=o<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,n):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,n,i);else for(var a=e.length-1;a>=0;a--)(r=e[a])&&(s=(o<3?r(s):o>3?r(t,n,s):r(t,n))||s);return o>3&&s&&Object.defineProperty(t,n,s),s},Ms=function(e){function n(){return null!==e&&e.apply(this,arguments)||this}return xs(n,e),Ds([t.Property(!1)],n.prototype,"enable",void 0),Ds([t.Property(!0)],n.prototype,"onSelection",void 0),n}(t.ChildProperty),Rs=function(){function e(e){this.parent=e,this.addEventListener()}return e.prototype.addEventListener=function(){this.parent.on(tt,this.enterHandler,this),this.parent.on(F,this.destroy,this)},e.prototype.destroy=function(){this.removeEventListener()},e.prototype.removeEventListener=function(){this.parent.off(tt,this.enterHandler),this.parent.off(F,this.destroy)},e.prototype.getRangeNode=function(){this.range=this.parent.getRange(),this.startNode="#text"===this.range.startContainer.nodeName?this.range.startContainer.parentElement:this.range.startContainer,this.endNode="#text"===this.range.endContainer.nodeName?this.range.endContainer.parentElement:this.range.endContainer},e.prototype.enterHandler=function(e){var n=this;this.getRangeNode();var i=!0;if(!t.isNullOrUndefined(this.startNode.closest("TABLE"))&&!t.isNullOrUndefined(this.endNode.closest("TABLE"))){i=!1;for(var r=this.startNode,o=r;!this.parent.formatter.editorManager.domNode.isBlockNode(r);)o=r,r=r.parentElement;i="TD"!==o.tagName}if(13===e.args.which&&"Enter"===e.args.code&&t.isNullOrUndefined(this.startNode.closest("LI"))&&t.isNullOrUndefined(this.endNode.closest("LI"))&&i&&t.isNullOrUndefined(this.startNode.closest("PRE"))&&t.isNullOrUndefined(this.endNode.closest("PRE"))){var s=e.args.shiftKey,a={cancel:!1,name:be,requestType:s?"ShiftEnterAction":"EnterAction",originalEvent:e.args};this.parent.trigger(be,a,function(r){if(!r.cancel){if(n.range.startOffset!==n.range.endOffset||n.range.startContainer!==n.range.endContainer)if(n.range.deleteContents(),"#text"===n.range.startContainer.nodeName&&0===n.range.startContainer.textContent.length&&n.range.startContainer.parentElement!==n.parent.inputElement)"BR"===n.parent.enterKey?n.range.startContainer.parentElement.innerHTML="&#8203;":n.range.startContainer.parentElement.innerHTML="<br>";else if(n.range.startContainer===n.parent.inputElement&&""===n.range.startContainer.innerHTML){n.range.startContainer.innerHTML="<br>";var o=n.range.startContainer.childNodes[n.range.startOffset];n.parent.formatter.editorManager.nodeSelection.setCursorPoint(n.parent.contentModule.getDocument(),o,0)}else if(n.parent.inputElement===n.range.startContainer){if("#text"===(o=n.range.startContainer.childNodes[n.range.startOffset]).nodeName&&0===o.textContent.length)n.parent.formatter.editorManager.nodeSelection.setCursorPoint(n.parent.contentModule.getDocument(),o,o.previousSibling.textContent.length);else if(n.parent.formatter.editorManager.nodeSelection.setCursorPoint(n.parent.contentModule.getDocument(),o,o.textContent.length>=0?0:1),0===o.previousSibling.textContent.length)t.detach(o.previousSibling);else if(0===o.textContent.length){for(var a=o.previousSibling.lastChild;"#text"!==a.nodeName;)a=a.lastChild;n.parent.formatter.editorManager.nodeSelection.setCursorPoint(n.parent.contentModule.getDocument(),a,a.textContent.length),t.detach(o)}else if("BR"!==n.parent.enterKey&&0!==o.previousSibling.textContent.length&&0!==o.textContent.length)return void e.args.preventDefault();n.getRangeNode()}if(n.range.startContainer===n.range.endContainer&&n.range.startOffset===n.range.endOffset&&n.range.startContainer===n.parent.inputElement&&(n.parent.formatter.editorManager.nodeSelection.setCursorPoint(n.parent.contentModule.getDocument(),n.range.startContainer.childNodes[n.range.startOffset],0),n.getRangeNode()),"P"===n.parent.enterKey&&!s||"DIV"===n.parent.enterKey&&!s||"P"===n.parent.shiftEnterKey&&s||"DIV"===n.parent.shiftEnterKey&&s){var l=void 0;l=i&&n.parent.formatter.editorManager.domNode.isBlockNode(n.startNode)?n.startNode:n.parent.formatter.editorManager.domNode.blockParentNode(n.startNode);var d=!1,c=!1;if(0==n.range.startOffset||0==n.range.endOffset||n.range.startContainer!==n.range.endContainer||!t.isNullOrUndefined(l.childNodes[0])&&"IMG"===l.childNodes[0].nodeName)0===n.range.startOffset&&0===n.range.endOffset&&(c=!0);else{var p=n.range.startContainer.textContent.substring(0,n.range.startOffset);160!=p.charCodeAt(n.range.startOffset-1)&&0===p.trim().length&&(c=!0)}if(n.removeBRElement(l),(0===n.range.startOffset&&0===n.range.endOffset||c)&&(t.isNullOrUndefined(n.range.startContainer.previousSibling)||"IMG"!==n.range.startContainer.previousSibling.nodeName&&"BR"!==n.range.startContainer.previousSibling.nodeName)){var h=void 0,u=void 0;"IMG"===n.range.startContainer.nodeName?(u=n.createInsertElement(s),d=!0,h=!1):0!==l.textContent.trim().length?(u=n.parent.formatter.editorManager.nodeCutter.SplitNode(n.range,l,!1).cloneNode(!0),h=!1):(u=n.parent.formatter.editorManager.nodeCutter.SplitNode(n.range,l,!0).cloneNode(!0),h=!0);for(var m=n.createInsertElement(s);u.firstChild;)m.appendChild(u.firstChild);if(l.parentElement.insertBefore(m,l),!h){a=m;for(var g=void 0;!t.isNullOrUndefined(a)&&"#text"!==a.nodeName;)g=a,a=a.lastChild;g.innerHTML="<br>",d||t.detach(l)}n.parent.formatter.editorManager.nodeSelection.setCursorPoint(n.parent.contentModule.getDocument(),m.nextElementSibling,0)}else if(0!==l.textContent.length||!t.isNullOrUndefined(l.childNodes[0])&&"IMG"===l.childNodes[0].nodeName){u=n.parent.formatter.editorManager.nodeCutter.SplitNode(n.range,l,!0);if(t.isNullOrUndefined(u.childNodes[0])||"#text"!==u.childNodes[0].nodeName||0!==u.childNodes[0].textContent.length||t.detach(u.childNodes[0]),0===u.textContent.trim().length){var f=n.parent.createElement("br");if("A"===n.startNode.nodeName){var b=n.startNode.parentElement;n.startNode.parentElement.insertBefore(f,n.startNode),t.detach(n.startNode),n.startNode=b}else n.startNode.appendChild(f);"\n"===u.childNodes[0].textContent&&t.detach(u.childNodes[0]),n.parent.formatter.editorManager.nodeSelection.setCursorPoint(n.parent.contentModule.getDocument(),n.startNode,0)}if(("P"===n.parent.enterKey||"DIV"===n.parent.enterKey)&&!s||("DIV"===n.parent.shiftEnterKey||"P"===n.parent.shiftEnterKey)&&s){for(var v=n.createInsertElement(s);u.firstChild;)v.appendChild(u.firstChild);n.parent.formatter.editorManager.domNode.insertAfter(v,u),t.detach(u),n.parent.formatter.editorManager.nodeSelection.setCursorPoint(n.parent.contentModule.getDocument(),n.parent.formatter.editorManager.domNode.isBlockNode(n.startNode)?v:n.startNode,0)}}else if(t.isNullOrUndefined(l.children[0])||"BR"===l.children[0].tagName){(m=n.createInsertElement(s)).innerHTML="<br>",n.parent.formatter.editorManager.domNode.insertAfter(m,l),n.parent.formatter.editorManager.nodeSelection.setCursorPoint(n.parent.contentModule.getDocument(),m,0)}else{var u=n.parent.formatter.editorManager.nodeCutter.SplitNode(n.range,l,!1).cloneNode(!0);n.parent.formatter.editorManager.domNode.insertAfter(u,l),n.parent.formatter.editorManager.nodeSelection.setCursorPoint(n.parent.contentModule.getDocument(),u,u.textContent.length>=0?0:1)}e.args.preventDefault()}if("BR"===n.parent.enterKey&&!s||"BR"===n.parent.shiftEnterKey&&s){var y=void 0;if(n.parent.formatter.editorManager.domNode.isBlockNode(n.startNode))y=n.startNode;else{for(var C=n.startNode,S=C;!n.parent.formatter.editorManager.domNode.isBlockNode(C);)S=C,C=C.parentElement;y=C===n.parent.inputElement?S:C}n.removeBRElement(y);for(var N=y.lastChild;!t.isNullOrUndefined(N)&&"#text"!==N.nodeName&&"BR"!==N.nodeName;)N=N.lastChild;var E=n.range.startContainer===N?n.range.startContainer.textContent.length:y.textContent.length;if(y!==n.parent.inputElement&&n.parent.formatter.editorManager.domNode.isBlockNode(y)&&n.range.startOffset===n.range.endOffset&&n.range.startOffset===E){var T=n.parent.createElement("br");if("BR"===N.nodeName&&0===y.textContent.length)n.parent.formatter.editorManager.domNode.insertAfter(T,N);else{var w=n.parent.createElement("br");n.parent.formatter.editorManager.domNode.insertAfter(T,n.range.startContainer),n.parent.formatter.editorManager.domNode.insertAfter(w,n.range.startContainer)}n.parent.formatter.editorManager.nodeSelection.setCursorPoint(n.parent.contentModule.getDocument(),T,0)}else if(t.isNullOrUndefined(y)||y===n.parent.inputElement||"BR"===y.nodeName)n.insertBRElement();else if(0===y.textContent.trim().length||1===y.textContent.trim().length&&8203===y.textContent.charCodeAt(0)){u=n.parent.formatter.editorManager.nodeCutter.SplitNode(n.range,y,!0).cloneNode(!0);n.parent.formatter.editorManager.domNode.insertAfter(u,y);var k=n.parent.createElement("br");u.parentElement.insertBefore(k,u),n.parent.formatter.editorManager.nodeSelection.setCursorPoint(n.parent.contentModule.getDocument(),u,0)}else{u=void 0,k=n.parent.createElement("br");if(0!==n.range.startOffset||0!==n.range.endOffset||t.isNullOrUndefined(y.previousSibling)||"BR"!==y.previousSibling.nodeName)n.insertBRElement();else{u=n.parent.formatter.editorManager.nodeCutter.SplitNode(n.range,y,!1).cloneNode(!0),n.parent.formatter.editorManager.domNode.insertAfter(k,y),n.insertFocusContent();for(a=k.nextSibling;!t.isNullOrUndefined(a)&&"#text"!==a.nodeName;)a=a.lastChild;n.parent.formatter.editorManager.nodeSelection.setCursorPoint(n.parent.contentModule.getDocument(),a,0)}}e.args.preventDefault()}n.parent.trigger(ve,{requestType:s?"ShiftEnterAction":"EnterAction",args:e.args})}})}},e.prototype.removeBRElement=function(e){-1!=t.Browser.userAgent.indexOf("Firefox")&&this.range.endOffset===e.textContent.length&&"BR"===e.lastChild.nodeName&&t.detach(e.lastChild)},e.prototype.insertBRElement=function(){var e=!1,n=this.parent.createElement("br");if("BR"===this.startNode.nodeName&&"BR"===this.endNode.nodeName&&0===this.range.startOffset&&this.range.startOffset===this.range.endOffset?(this.parent.formatter.editorManager.domNode.insertAfter(n,this.startNode),e=!0):(this.startNode!==this.parent.inputElement||t.isNullOrUndefined(this.range.startContainer.previousSibling)||"BR"!==this.range.startContainer.previousSibling.nodeName||0!==this.range.startContainer.textContent.length||(e=!0),this.range.insertNode(n)),e||!t.isNullOrUndefined(n.nextElementSibling)&&"BR"===n.nextElementSibling.tagName||!t.isNullOrUndefined(n.nextSibling)&&n.nextSibling.textContent.length>0)this.parent.formatter.editorManager.nodeSelection.setCursorPoint(this.parent.contentModule.getDocument(),t.isNullOrUndefined(n.nextSibling)?n:n.nextSibling,0),e=!1;else{var i=this.parent.createElement("br");this.range.insertNode(i),this.parent.formatter.editorManager.nodeSelection.setCursorPoint(this.parent.contentModule.getDocument(),n,0)}},e.prototype.insertFocusContent=function(){0===this.range.startContainer.textContent.length&&("#text"===this.range.startContainer.nodeName?this.range.startContainer.parentElement.innerHTML="&#8203;":this.range.startContainer.innerHTML="&#8203;")},e.prototype.createInsertElement=function(e){var t;return"DIV"===this.parent.enterKey&&!e||"DIV"===this.parent.shiftEnterKey&&e?t=this.parent.createElement("div"):("P"===this.parent.enterKey&&!e||"P"===this.parent.shiftEnterKey&&e)&&(t=this.parent.createElement("p")),t},e}(),Is=function(){var e=function(t,n){return(e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(t,n)};return function(t,n){function i(){this.constructor=t}e(t,n),t.prototype=null===n?Object.create(n):(i.prototype=n.prototype,new i)}}(),Bs=function(){return(Bs=Object.assign||function(e){for(var t,n=1,i=arguments.length;n<i;n++){t=arguments[n];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r])}return e}).apply(this,arguments)},Ps=function(e,t,n,i){var r,o=arguments.length,s=o<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,n):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,n,i);else for(var a=e.length-1;a>=0;a--)(r=e[a])&&(s=(o<3?r(s):o>3?r(t,n,s):r(t,n))||s);return o>3&&s&&Object.defineProperty(t,n,s),s},As=function(n){function i(e,t){var i=n.call(this,e,t)||this;return i.defaultResetValue=null,i.isResizeInitialized=!1,i.isFocusOut=!1,i.isRTE=!1,i.isBlur=!0,i.needsID=!0,i}return Is(i,n),i.prototype.requiredModules=function(){var e=[];return this.toolbarSettings.enable&&(e.push({member:"toolbar",args:[this,this.serviceLocator]}),e.push({member:"link",args:[this,this.serviceLocator]}),e.push({member:"table",args:[this,this.serviceLocator]}),e.push({member:"image",args:[this,this.serviceLocator]}),this.quickToolbarSettings.enable&&e.push({member:"quickToolbar",args:[this,this.serviceLocator]})),this.showCharCount&&e.push({member:"count",args:[this,this.serviceLocator]}),"Markdown"===this.editorMode&&e.push({member:"markdownEditor",args:[this,this.serviceLocator]}),"HTML"===this.editorMode&&(e.push({member:"htmlEditor",args:[this,this.serviceLocator]}),e.push({member:"pasteCleanup",args:[this,this.serviceLocator]})),this.fileManagerSettings.enable&&e.push({member:"fileManager",args:[this,this.serviceLocator]}),this.enableResize&&e.push({member:"resize",args:[this]}),e},i.prototype.updateEnable=function(){this.enabled?(t.removeClass([this.element],Dt),this.element.setAttribute("aria-disabled","false"),t.isNullOrUndefined(this.htmlAttributes.tabindex)?this.inputElement.setAttribute("tabindex","0"):this.inputElement.setAttribute("tabindex",this.htmlAttributes.tabindex)):(this.getToolbar()&&(t.removeClass(this.getToolbar().querySelectorAll("."+bn),bn),t.removeClass([this.getToolbar()],[Pt,At])),t.addClass([this.element],Dt),this.element.tabIndex=-1,this.element.setAttribute("aria-disabled","true"),this.inputElement.setAttribute("tabindex","-1"))},i.prototype.setEnable=function(){this.updateEnable(),this.enabled?this.eventInitializer():this.unWireEvents()},i.prototype.preRender=function(){this.onBlurHandler=this.blurHandler.bind(this),this.onFocusHandler=this.focusHandler.bind(this),this.onResizeHandler=this.resizeHandler.bind(this),this.clickPoints={clientX:0,clientY:0},this.initialValue=this.value,this.serviceLocator=new Ki,this.initializeServices(),this.setContainer(),this.persistData(),t.setStyleAttribute(this.element,{width:t.formatUnit(this.width)}),t.attributes(this.element,{role:"application"})},i.prototype.persistData=function(){if(this.enablePersistence&&"TEXTAREA"===this.originalElement.tagName){this.element.id=this.originalElement.id+"_wrapper";var e=window.localStorage.getItem(this.getModuleName()+this.element.id);t.isNullOrUndefined(e)||""===e||this.setProperties(JSON.parse(e),!0)}},i.prototype.setContainer=function(){this.originalElement=this.element.cloneNode(!0),null!==this.value&&null===this.valueTemplate||this.setValue(),this.element.hasAttribute("tabindex")&&(this.htmlAttributes={tabindex:this.element.getAttribute("tabindex")},this.element.removeAttribute("tabindex")),this.element.innerHTML="";for(var e=["class","style","id","ejs-for"],n={},i=0;i<this.element.attributes.length;i++)-1!==e.indexOf(this.element.attributes[i].name)||/^data-val/.test(this.element.attributes[i].name)||(n[this.element.attributes[i].name]=this.element.getAttribute(this.element.attributes[i].name));if(t.extend(n,this.htmlAttributes,n),this.setProperties({htmlAttributes:n},!0),t.isNullOrUndefined(this.htmlAttributes.id)||(this.element.id=this.htmlAttributes.id),"TEXTAREA"===this.element.tagName){var r=this.createElement("div",{className:this.element.getAttribute("class")});this.element.innerHTML="",this.element.parentElement.insertBefore(r,this.element),this.valueContainer=this.element,t.removeClass([this.valueContainer],this.element.getAttribute("class").split(" ")),this.element=r}else this.valueContainer=this.createElement("textarea",{id:this.getID()+"-value"});this.valueContainer.name=this.getID(),t.addClass([this.valueContainer],Qn),this.element.appendChild(this.valueContainer)},i.prototype.getPersistData=function(){return this.addOnPersist(["value"])},i.prototype.focusIn=function(){this.enabled&&(this.inputElement.focus(),this.focusHandler({}))},i.prototype.focusOut=function(){this.enabled&&(this.inputElement.blur(),this.blurHandler({}))},i.prototype.selectAll=function(){this.notify(_e,{})},i.prototype.selectRange=function(e){this.notify(Qe,{range:e})},i.prototype.getSelection=function(){var e="";return this.notify(Ve,{callBack:function(t){e=t}}),e},i.prototype.executeCommand=function(e,t,n){if(t=this.htmlPurifier(e,t),"HTML"===this.editorMode){var i=this.getRange();this.iframeSettings.enable&&this.formatter.editorManager.nodeSelection.Clear(this.element.ownerDocument);(!(!this.iframeSettings.enable||i.startContainer!==this.inputElement)||!this.inputElement.contains(i.startContainer))&&this.focusIn()}var r=ds[e];n&&n.undo&&n.undo&&0===this.formatter.getUndoRedoStack().length&&this.formatter.saveData(),this.formatter.editorManager.execCommand(r.command,r.subCommand?r.subCommand:t||r.value,null,null,t||r.value,t||r.value),n&&n.undo&&(this.formatter.saveData(),this.formatter.enableUndo(this)),this.setPlaceHolder(),this.notify(U,{})},i.prototype.htmlPurifier=function(e,n){if("HTML"===this.editorMode)switch(e){case"insertHTML":this.enableHtmlSanitizer&&(n="string"==typeof n?this.htmlEditorModule.sanitizeHelper(n):this.htmlEditorModule.sanitizeHelper(n.outerHTML));break;case"insertTable":t.isNullOrUndefined(n.width)&&(n.width={minWidth:this.tableSettings.minWidth,maxWidth:this.tableSettings.maxWidth,width:this.tableSettings.width});break;case"insertImage":var i=this.createElement("img",{attrs:{src:n.url}}),r=i.outerHTML;this.enableHtmlSanitizer&&(r=this.htmlEditorModule.sanitizeHelper(i.outerHTML));var o=""!==r&&this.createElement("div",{innerHTML:r}).firstElementChild.getAttribute("src")||null;o=t.isNullOrUndefined(o)?"":o,n.url=o,t.isNullOrUndefined(n.width)&&(n.width={minWidth:this.insertImageSettings.minWidth,maxWidth:this.insertImageSettings.maxWidth,width:this.insertImageSettings.width}),t.isNullOrUndefined(n.height)&&(n.height={minHeight:this.insertImageSettings.minHeight,maxHeight:this.insertImageSettings.maxHeight,height:this.insertImageSettings.height});break;case"createLink":var s=this.createElement("a",{attrs:{href:n.url}}),a=s.outerHTML;this.enableHtmlSanitizer&&(a=this.htmlEditorModule.sanitizeHelper(s.outerHTML));var l=""!==a&&this.createElement("div",{innerHTML:a}).firstElementChild.getAttribute("href")||null;l=t.isNullOrUndefined(l)?"":l,n.url=l}return n},i.prototype.encode=function(e){var t=this.createElement("div");return t.innerText=e.trim(),t.innerHTML.replace(/<br\s*[\/]?>/gi,"\n")},i.prototype.render=function(){this.value&&!this.valueTemplate&&this.setProperties({value:this.serializeValue(this.value)},!0),this.renderModule=new is(this,this.serviceLocator),this.sourceCodeModule=new ss(this,this.serviceLocator),this.notify(A,{}),this.trigger("load"),this.RTERender();new dr(this);this.notify(H,{}),this.enableXhtml&&this.setProperties({value:this.getXhtml()},!0),this.toolbarSettings.enable&&"Expand"===this.toolbarSettings.type&&!t.isNullOrUndefined(this.getToolbar())&&this.toolbarSettings.items.indexOf("Undo")>-1&&this.toolbarSettings.items.indexOf("Redo")>-1&&this.disableToolbarItem(["Undo","Redo"]),this.setContentHeight(),null!==this.value&&(this.valueContainer.defaultValue=this.value),this.enabled?this.eventInitializer():this.unWireEvents(),this.renderComplete()},i.prototype.eventInitializer=function(){this.wireEvents()},i.prototype.cleanList=function(e){var n=this.getRange(),i=n.startContainer,r=n.endContainer,o=n.startOffset,s=i===r,a="#text"===n.endContainer.nodeName?n.endContainer.parentElement:n.endContainer,l=t.closest(a,"LI");if(!t.isNullOrUndefined(l)&&a.textContent.length===n.endOffset&&!n.collapsed){l.textContent=l.textContent.trim(),l.textContent.length-1;for(var d=l;"#text"!==d.nodeName;)d=d.lastChild;this.formatter.editorManager.nodeSelection.setSelectionText(this.contentModule.getDocument(),s?d:i,d,o,d.textContent.length)}},i.prototype.keyDown=function(e){if(this.notify($,{member:"keydown",args:e}),this.restrict(e),"HTML"===this.editorMode&&this.cleanList(e),"HTML"===this.editorMode&&(8===e.which&&"Backspace"===e.code||46===e.which&&"Delete"===e.code)){var n=this.getRange(),i="#text"===n.startContainer.nodeName?n.startContainer.parentElement:n.startContainer;if(t.closest(i,"pre")&&8===e.which&&8203===n.startContainer.textContent.charCodeAt(n.startOffset-1)||46===e.which&&8203===n.startContainer.textContent.charCodeAt(n.startOffset)){var r=new RegExp(String.fromCharCode(8203),"g"),o=8===e.which?n.startOffset-1:n.startOffset;n.startContainer.textContent=n.startContainer.textContent.replace(r,""),this.formatter.editorManager.nodeSelection.setCursorPoint(this.contentModule.getDocument(),n.startContainer,o)}else if("Backspace"===e.code&&8===e.which&&8203===n.startContainer.textContent.charCodeAt(0)&&n.collapsed){var s=n.startContainer.parentElement,a=void 0,l=void 0;for(l=0;l<s.childNodes.length;l++)s.childNodes[l]===n.startContainer&&(a=l);var d=!0,c=[];for(l=a;l>=0;l--)3===s.childNodes[l].nodeType&&8203===s.childNodes[l].textContent.charCodeAt(0)&&d?c.push(l):d=!1;if(c.length>0)for(l=c.length-1;l>0;l--)s.childNodes[c[l]].textContent="";this.formatter.editorManager.nodeSelection.setCursorPoint(this.contentModule.getDocument(),n.startContainer,n.startOffset)}}if(0===this.formatter.getUndoRedoStack().length&&this.formatter.saveData(),"insert-link"!==e.action&&(e.action&&"paste"!==e.action&&"space"!==e.action||9===e.which||"Backspace"===e.code&&8===e.which))switch(this.formatter.process(this,null,e),e.action){case"toolbar-focus":if(this.toolbarSettings.enable){this.toolbarModule.baseToolbar.toolbarObj.element.querySelector('.e-toolbar-item[aria-disabled="false"][title] [tabindex]').focus()}break;case"escape":this.contentModule.getEditPanel().focus()}t.isNullOrUndefined(this.placeholder)||(t.isNullOrUndefined(this.placeHolderWrapper)||1===this.inputElement.textContent.length?this.setPlaceHolder():this.placeHolderWrapper.style.display="none"),this.autoResize()},i.prototype.keyUp=function(e){this.notify(J,{member:"keyup",args:e}),"KeyX"!==e.code||88!==e.which||88!==e.keyCode||!e.ctrlKey||""!==this.inputElement.innerHTML&&"<br>"!==this.inputElement.innerHTML||(this.inputElement.innerHTML=T(k(this),this));var n=32===e.which||13===e.which||8===e.which||46===e.which;("shift"!==e.key&&!e.ctrlKey&&e.key&&1===e.key.length||n||"Markdown"===this.editorMode&&("shift"!==e.key&&!e.ctrlKey&&e.key&&1===e.key.length||n)&&!this.inlineMode.enable)&&this.formatter.onKeyHandler(this,e),(this.inputElement&&0!==this.inputElement.textContent.length||this.element.querySelectorAll(".e-toolbar-item.e-active").length>0)&&this.notify(z,{args:e}),t.isNullOrUndefined(this.placeholder)||"Enter"===e.key&&13===e.keyCode||"<p><br></p>"!==this.inputElement.innerHTML&&"<div><br></div>"!==this.inputElement.innerHTML&&"<br>"!==this.inputElement.innerHTML||this.setPlaceHolder()},i.prototype.serializeValue=function(e){return"HTML"!==this.editorMode||t.isNullOrUndefined(e)||(this.enableHtmlEncode?(e=this.htmlEditorModule.sanitizeHelper(O(e)),e=this.encode(e)):e=this.htmlEditorModule.sanitizeHelper(e)),e},i.prototype.sanitizeHtml=function(e){return this.serializeValue(e)},i.prototype.updateValue=function(e){if(t.isNullOrUndefined(e)){var n=this.inputElement.innerHTML;this.setProperties({value:L(n)?null:n})}else this.setProperties({value:e})},i.prototype.triggerEditArea=function(e){if(h()){var t=e.touches?e.changedTouches[0]:e;this.clickPoints.clientX===t.clientX&&this.clickPoints.clientY===t.clientY&&this.notify(Ue,{member:"editAreaClick",args:e})}else this.notify(Ue,{member:"editAreaClick",args:e})},i.prototype.notifyMouseUp=function(e){var t=e.touches?e.changedTouches[0]:e;this.notify(Z,{member:"mouseUp",args:e,touchData:{prevClientX:this.clickPoints.clientX,prevClientY:this.clickPoints.clientY,clientX:t.clientX,clientY:t.clientY}}),this.inputElement&&("HTML"===this.editorMode&&0!==this.inputElement.textContent.length||"Markdown"===this.editorMode&&0!==this.inputElement.value.length)&&this.notify(z,{args:e}),this.triggerEditArea(e)},i.prototype.mouseUp=function(e){if(this.quickToolbarSettings.showOnRightClick&&t.Browser.isDevice){var n=e.target,i=t.closest(n,"table");if(n&&"A"===n.nodeName||"IMG"===n.nodeName||"TD"===n.nodeName||"TH"===n.nodeName||"TABLE"===n.nodeName||i&&this.contentModule.getEditPanel().contains(i))return}if(this.notifyMouseUp(e),3===e.detail){var r=this.getRange(),o=this.formatter.editorManager.domNode.getSelection();/\s+$/.test(o.toString())&&((t.isNullOrUndefined(r.startContainer.parentElement)||(t.isNullOrUndefined(r.startContainer.parentElement.nextSibling)||3===r.startContainer.parentElement.nextSibling.nodeType&&!/\s+$/.test(r.startContainer.parentElement.nextSibling.textContent))&&r.startOffset!==r.endOffset)&&"li"!==r.startContainer.parentElement.tagName.toLocaleLowerCase()||(r.setStart(r.startContainer,r.startOffset),r.setEnd(r.startContainer,r.startContainer.textContent.length)))}},i.prototype.ensureModuleInjected=function(e){return this.getInjectedModules().indexOf(e)>=0},i.prototype.onCopy=function(){this.contentModule.getDocument().execCommand("copy",!1,null)},i.prototype.onCut=function(){this.contentModule.getDocument().execCommand("cut",!1,null)},i.prototype.onPaste=function(e){var n=this,i={originalEvent:e,cancel:!1,requestType:"Paste"};this.trigger(be,i,function(i){var r=n.getText().trim().length-n.getSelection().length+(t.isNullOrUndefined(e)||t.isNullOrUndefined(e.clipboardData)?0:e.clipboardData.getData("text/plain").length);if("Markdown"!==n.editorMode)if(!i.cancel&&"true"===n.inputElement.contentEditable&&(-1===n.maxLength||r<=n.maxLength))if(t.isNullOrUndefined(n.pasteCleanupModule)){var o={requestType:"Paste",editorMode:n.editorMode,event:e},s=null,a=!1;e&&!t.isNullOrUndefined(e.clipboardData)&&(s=e.clipboardData.getData("text/plain"),a=e.clipboardData.getData("text/html").indexOf("MsoNormal")>0);var l=e&&e.clipboardData&&e.clipboardData.items.length>0?e.clipboardData.items[0].getAsFile():null;null!==s&&n.notify(Ke,{file:l,args:e,text:s,isWordPaste:a}),setTimeout(function(){n.formatter.onSuccess(n,o)},0)}else n.notify(et,{args:e});else e.preventDefault();else-1===n.maxLength||r<=n.maxLength||e.preventDefault()})},i.prototype.clipboardAction=function(e,t){switch(e.toLowerCase()){case"cut":this.onCut(),this.formatter.onSuccess(this,{requestType:"Cut",editorMode:this.editorMode,event:t});break;case"copy":this.onCopy(),this.formatter.onSuccess(this,{requestType:"Copy",editorMode:this.editorMode,event:t});break;case"paste":this.onPaste(t)}},i.prototype.destroy=function(){if(!this.isDestroyed&&this.isRendered)if(null!==this.element.offsetParent||t.isNullOrUndefined(this.toolbarModule)){if(this.notify(F,{}),this.destroyDependentModules(),t.isNullOrUndefined(this.timeInterval)||(clearInterval(this.timeInterval),this.timeInterval=null),this.unWireEvents(),"TEXTAREA"===this.originalElement.tagName){this.element.parentElement.insertBefore(this.valueContainer,this.element),this.valueContainer.id=this.getID(),this.valueContainer.removeAttribute("name"),t.detach(this.element),""!==this.originalElement.innerHTML.trim()?(this.valueContainer.value=this.originalElement.innerHTML.trim(),this.setProperties({value:t.isNullOrUndefined(this.initialValue)?null:this.initialValue},!0)):this.valueContainer.value=this.valueContainer.defaultValue,this.element=this.valueContainer;for(var e=0;e<this.originalElement.classList.length;e++)t.addClass([this.element],this.originalElement.classList[e]);t.removeClass([this.element],Qn)}else""!==this.originalElement.innerHTML.trim()?(this.element.innerHTML=this.originalElement.innerHTML.trim(),this.setProperties({value:t.isNullOrUndefined(this.initialValue)?null:this.initialValue},!0)):this.element.innerHTML="";if(this.placeholder&&this.placeHolderWrapper&&(this.placeHolderWrapper=null),!t.isNullOrUndefined(this.cssClass)){var i=this.cssClass.split(" ");for(e=0;e<i.length;e++)""!==i[e].trim()&&t.removeClass([this.element],i[e])}this.removeHtmlAttributes(),this.removeAttributes(),n.prototype.destroy.call(this),this.isRendered=!1,this.enablePersistence&&window.localStorage.removeItem(this.getModuleName()+this.element.id)}else this.toolbarModule.destroy()},i.prototype.removeHtmlAttributes=function(){if(this.htmlAttributes)for(var e=Object.keys(this.htmlAttributes),t=0;t<e.length&&this.element.hasAttribute(e[t]);t++)this.element.removeAttribute(e[t])},i.prototype.removeAttributes=function(){this.enabled||t.removeClass([this.element],Dt),this.enableRtl&&t.removeClass([this.element],"e-rtl"),this.readonly&&t.removeClass([this.element],Un),""!==this.element.style.width&&""===this.originalElement.style.width&&this.element.style.removeProperty("width"),""!==this.element.style.height&&""===this.originalElement.style.height&&this.element.style.removeProperty("height"),this.element.removeAttribute("aria-disabled"),this.element.removeAttribute("role"),this.element.removeAttribute("tabindex")},i.prototype.destroyDependentModules=function(){this.renderModule.destroy(),this.formatter.editorManager.undoRedoManager.destroy(),this.sourceCodeModule.destroy()},i.prototype.getContent=function(){return this.contentModule.getPanel()},i.prototype.getText=function(){return this.contentModule.getText()},i.prototype.getSelectedHtml=function(){var e=this.createElement("div"),t=this.contentModule.getDocument().getSelection();if(t.rangeCount>0){var n=t.getRangeAt(0).cloneContents();e.appendChild(n)}return e.innerHTML},i.prototype.showInlineToolbar=function(){if(this.inlineMode.enable){var e=this.getRange(),t="#text"===e.endContainer.nodeName?e.endContainer.parentElement:e.endContainer,n=e.getClientRects()[0].left,i=e.getClientRects()[0].top;this.quickToolbarModule.showInlineQTBar(n,i,t)}},i.prototype.hideInlineToolbar=function(){this.quickToolbarModule.hideInlineQTBar()},i.prototype.getModuleName=function(){return"richtexteditor"},i.prototype.onPropertyChanged=function(e,i){for(var r=0,o=Object.keys(e);r<o.length;r++){var s=o[r];switch(s){case"enterKey":case"value":var a=void 0;a="enterKey"===s?null===this.value||"<div><br></div>"===this.value||"<p><br></p>"===this.value||"<br>"===this.value?null:this.value:e[s];var l="HTML"===this.editorMode?T(a,this):a;(!t.isNullOrUndefined(a)&&""!==a||"enterKey"===s)&&(this.value=this.serializeValue(this.enableHtmlEncode?this.encode(O(l)):l)),this.updatePanelValue(),this.setPlaceHolder(),this.notify(mt,{module:"XhtmlValidation",newProp:e,oldProp:i}),this.enableXhtml&&this.setProperties({value:this.getXhtml()},!0),this.showCharCount&&this.countModule.refresh();break;case"valueTemplate":this.setValue(),this.showCharCount&&this.countModule.refresh();break;case"width":this.setWidth(e[s]),this.toolbarSettings.enable&&!this.inlineMode.enable&&(this.toolbarModule.refreshToolbarOverflow(),this.resizeHandler());break;case"height":this.setHeight(e[s]),this.setContentHeight(),this.autoResize();break;case"readonly":this.setReadOnly(!1);break;case"cssClass":this.element.classList.remove(i[s]),this.setCssClass(e[s]);break;case"enabled":this.setEnable();break;case"enableRtl":this.updateRTL();break;case"placeholder":this.placeholder=e[s],this.setPlaceHolder();break;case"htmlAttributes":P(this.htmlAttributes,this,!1,!1);break;case"iframeSettings":var d=i[s];if(d.resources){var c=this.contentModule.getDocument().querySelector("head"),p=void 0;d.resources.scripts&&(p=c.querySelectorAll("."+Mt),this.removeSheets(p)),d.resources.styles&&(p=c.querySelectorAll("."+Rt),this.removeSheets(p))}this.setIframeSettings();break;case"locale":n.prototype.refresh.call(this);break;case"inlineMode":this.notify(Y,{module:"quickToolbar",newProp:e,oldProp:i}),this.setContentHeight();break;case"toolbarSettings":this.notify(Y,{module:"toolbar",newProp:e,oldProp:i}),this.setContentHeight();break;case"maxLength":this.showCharCount&&this.countModule.refresh();break;case"showCharCount":e[s]&&this.countModule?this.countModule.renderCount():!1===e[s]&&this.countModule&&this.countModule.destroy();break;case"enableHtmlEncode":this.updateValueData(),this.updatePanelValue(),this.setPlaceHolder(),this.showCharCount&&this.countModule.refresh();break;case"undoRedoSteps":case"undoRedoTimer":this.formatter.editorManager.observer.notify(gr,{newProp:e,oldProp:i});break;case"enableXhtml":this.notify(mt,{module:"XhtmlValidation",newProp:e,oldProp:i});break;case"quickToolbarSettings":e.quickToolbarSettings.showOnRightClick?this.wireContextEvent():this.unWireContextEvent(),this.notify(Y,{newProp:e,oldProp:i});break;default:this.notify(Y,{newProp:e,oldProp:i})}}},i.prototype.updateValueData=function(){this.enableHtmlEncode?this.setProperties({value:this.encode(O(this.inputElement.innerHTML))},!0):this.setProperties({value:/<[a-z][\s\S]*>/i.test(this.inputElement.innerHTML)?this.inputElement.innerHTML:O(this.inputElement.innerHTML)})},i.prototype.removeSheets=function(e){var n;for(n=0;n<e.length;n++)t.detach(e[n])},i.prototype.updatePanelValue=function(){var e=this.value;e=this.enableHtmlEncode&&this.value?O(e):e;var t=this.element.querySelector(".e-rte-srctextarea");e?(t&&"block"===t.style.display&&(t.value=this.value),this.valueContainer&&(this.valueContainer.value=this.enableHtmlEncode?this.value:e),"HTML"===this.editorMode&&this.inputElement&&this.inputElement.innerHTML.trim()!==e.trim()?this.inputElement.innerHTML=e:"Markdown"===this.editorMode&&this.inputElement&&this.inputElement.value.trim()!==e.trim()&&(this.inputElement.value=e)):(t&&"block"===t.style.display&&(t.value=""),"HTML"===this.editorMode?"DIV"===this.enterKey?this.inputElement.innerHTML="<div><br/></div>":"BR"===this.enterKey?this.inputElement.innerHTML="<br/>":(this.inputElement.innerHTML="<p><br/></p>",""===e&&this.formatter&&this.inputElement&&this.formatter.editorManager.nodeSelection.setCursorPoint(this.contentModule.getDocument(),this.inputElement.firstElementChild,this.inputElement.firstElementChild.childElementCount)):this.inputElement.value="",this.valueContainer&&(this.valueContainer.value="")),this.showCharCount&&this.countModule.refresh()},i.prototype.setHeight=function(e){this.element.style.height="auto"!==e?t.formatUnit(e):"auto","Expand"===this.toolbarSettings.type&&("string"==typeof this.height&&this.height.indexOf("px")>-1||"number"==typeof this.height)?this.element.classList.add(ci):this.element.classList.remove(ci)},i.prototype.setPlaceHolder=function(){this.inputElement&&this.placeholder&&!0!==this.iframeSettings.enable&&("Markdown"!==this.editorMode?(this.placeHolderWrapper||(this.placeHolderWrapper=this.createElement("span",{className:"rte-placeholder e-rte-placeholder"}),this.inputElement&&this.inputElement.parentElement.insertBefore(this.placeHolderWrapper,this.inputElement),t.attributes(this.placeHolderWrapper,{style:"font-size: 14px; padding: 16px; margin-left: 0px; margin-right: 0px;"})),this.placeHolderWrapper.innerHTML=this.placeholder,0!==this.inputElement.textContent.length||t.isNullOrUndefined(this.inputElement.firstChild)||"BR"!==this.inputElement.firstChild.nodeName&&("P"!==this.inputElement.firstChild.nodeName&&"DIV"!==this.inputElement.firstChild.nodeName||t.isNullOrUndefined(this.inputElement.firstChild.firstChild)||"BR"!==this.inputElement.firstChild.firstChild.nodeName)?this.placeHolderWrapper.style.display="none":this.placeHolderWrapper.style.display="block"):this.inputElement.setAttribute("placeholder",this.placeholder))},i.prototype.setWidth=function(e){"auto"!==e?t.setStyleAttribute(this.element,{width:t.formatUnit(this.width)}):this.element.style.width="auto"},i.prototype.setCssClass=function(e){if(!t.isNullOrUndefined(e))for(var n=e.split(" "),i=0;i<n.length;i++)""!==n[i].trim()&&this.element.classList.add(n[i])},i.prototype.updateRTL=function(){this.notify(Ge,{enableRtl:this.enableRtl}),this.enableRtl?this.element.classList.add("e-rtl"):this.element.classList.remove("e-rtl")},i.prototype.updateReadOnly=function(){this.notify(Ze,{editPanel:this.inputElement,mode:this.readonly})},i.prototype.setReadOnly=function(e){this.updateReadOnly(),e||(this.readonly&&this.enabled?this.unbindEvents():this.enabled&&this.bindEvents())},i.prototype.print=function(){var e,n=this,i={element:this.inputElement,requestType:"print",cancel:!1};this.trigger(be,i,function(i){if(e=window.open("","print","height="+window.outerHeight+",width="+window.outerWidth),"msie"===t.Browser.info.name&&e.resizeTo(screen.availWidth,screen.availHeight),e=t.print(n.inputElement,e),!i.cancel){n.trigger(ve,{requestType:"print"})}})},i.prototype.refreshUI=function(){this.renderModule.refresh()},i.prototype.showFullScreen=function(){this.fullScreenModule.showFullScreen()},i.prototype.enableToolbarItem=function(e,t){this.toolbarModule.enableTBarItems(this.getBaseToolbarObject(),e,!0,t)},i.prototype.disableToolbarItem=function(e,t){this.toolbarModule.enableTBarItems(this.getBaseToolbarObject(),e,!1,t)},i.prototype.removeToolbarItem=function(e){this.toolbarModule.removeTBarItems(e)},i.prototype.getRange=function(){return this.formatter.editorManager.nodeSelection.getRange(this.contentModule.getDocument())},i.prototype.initializeServices=function(){this.serviceLocator.register("rendererFactory",new Gi),this.serviceLocator.register("rteLocale",this.localeObj=new t.L10n(this.getModuleName(),Ai,this.locale)),this.serviceLocator.register("dialogRenderObject",new ls(this))},i.prototype.RTERender=function(){var n=this.serviceLocator.getService("rendererFactory");this.contentModule=n.getRenderer(e.RenderType.Content),this.fullScreenModule=new ns(this),this.enterKeyModule=new Rs(this),this.renderModule.render(),this.inputElement=this.contentModule.getEditPanel(),this.setHeight(this.height),P(this.htmlAttributes,this,!1,!0),this.iframeSettings&&this.setIframeSettings(),this.setCssClass(this.cssClass),this.updateEnable(),this.setPlaceHolder(),this.updateRTL(),this.updateReadOnly(),this.updatePanelValue(),this.enableHtmlEncode&&!t.isNullOrUndefined(this.value)&&this.setProperties({value:this.encode(O(this.value))})},i.prototype.setIframeSettings=function(){if(this.iframeSettings.resources){var e=this.iframeSettings.resources.styles,t=this.iframeSettings.resources.scripts;this.iframeSettings.resources.scripts.length>0&&this.InjectSheet(!0,t),this.iframeSettings.resources.styles.length>0&&this.InjectSheet(!1,e)}this.iframeSettings.attributes&&P(this.iframeSettings.attributes,this,!0,!1)},i.prototype.InjectSheet=function(e,t){try{if(t&&t.length>0)for(var n=this.contentModule.getDocument().querySelector("head"),i=0;i<t.length;i++)if(e){var r=this.createScriptElement();r.src=t[i],n.appendChild(r)}else{var o=this.createStyleElement();o.href=t[i],n.appendChild(o)}}catch(e){return}},i.prototype.createScriptElement=function(){var e=this.createElement("script",{className:Mt});return e.type="text/javascript",e},i.prototype.createStyleElement=function(){var e=this.createElement("link",{className:Rt});return e.rel="stylesheet",e},i.prototype.setValue=function(){if(this.valueTemplate)if("string"==typeof this.valueTemplate)this.setProperties({value:this.valueTemplate});else{for(var e=t.compile(this.valueTemplate)("",this,"valueTemplate"),n=0;n<e.length;n++){var i=e[n];t.append([i],this.element)}this.setProperties({value:this.element.innerHTML.trim()})}else{var r=!t.isNullOrUndefined(this.element.innerHTML)&&this.element.innerHTML.replace(/<(\/?|\!?)(!--!--)>/g,"").trim();""!==r&&("TEXTAREA"===this.element.tagName?this.setProperties({value:O(r)}):this.setProperties({value:r}))}},i.prototype.updateResizeFlag=function(){this.isResizeInitialized=!0},i.prototype.getInsertImgMaxWidth=function(){var e=this.insertImageSettings.maxWidth,n=this.contentModule.getEditPanel(),i=window.getComputedStyle(n),r=n.offsetWidth-(14+parseFloat(i.paddingLeft.split("px")[0])+parseFloat(i.paddingRight.split("px")[0])+parseFloat(i.marginLeft.split("px")[0])+parseFloat(i.marginRight.split("px")[0]));return t.isNullOrUndefined(e)?r:e},i.prototype.setContentHeight=function(n,i){var r,o,s=0,a="string"==typeof this.height&&this.height.indexOf("%")>-1,l=this.sourceCodeModule.getPanel()&&"block"===this.sourceCodeModule.getPanel().parentElement.style.display?this.sourceCodeModule.getPanel().parentElement:this.contentModule.getPanel(),d=this.element.offsetHeight;0!==d||"auto"===this.height||this.getToolbar()||(d=parseInt(this.height,10),a&&(o=this.height));var c=this.getToolbar()?this.toolbarModule.getToolbarHeight():0,p=this.element.querySelector("."+Jn),h=this.enableResize?t.isNullOrUndefined(p)?0:p.offsetHeight+8:0,u=this.getToolbar()?this.toolbarModule.getExpandTBarPopHeight():0;if(this.toolbarSettings.type===e.ToolbarType.Expand&&i&&"preview"!==n?(r="auto"===this.height&&0===h?"auto":d-(c+u+h)+"px",s=this.toolbarSettings.enableFloating?0:u):r="auto"!==this.height||this.element.classList.contains("e-rte-full-screen")||this.isResizeInitialized?a&&o?o:d-(c+h)+"px":"auto","windowResize"!==n&&(this.iframeSettings.enable?"auto"!==r&&t.setStyleAttribute(l,{height:r,marginTop:s+"px"}):t.setStyleAttribute(l,{height:r,marginTop:s+"px"})),this.iframeSettings.enable&&"sourceCode"===n){var m=t.select("."+Jt,this.element);t.setStyleAttribute(m,{height:r,marginTop:s+"px"})}if(this.toolbarSettings.enableFloating&&this.getToolbar()&&!this.inlineMode.enable){var g=(i?c+u:c)+"px";t.setStyleAttribute(this.getToolbar().parentElement,{height:g})}0===h&&this.autoResize()},i.prototype.getHtml=function(){return this.serializeValue(this.contentModule.getEditPanel().innerHTML)},i.prototype.getXhtml=function(){var e=this.value;return!t.isNullOrUndefined(e)&&this.enableXhtml&&(e=this.htmlEditorModule.xhtmlValidation.selfEncloseValidation(e)),e},i.prototype.showSourceCode=function(){this.readonly||this.notify(Oe,{})},i.prototype.getCharCount=function(){var e="Markdown"===this.editorMode?this.inputElement.value.trim():this.inputElement.textContent.trim();return"Markdown"!==this.editorMode&&-1!==e.indexOf("​")?e.replace(/\u200B/g,"").length:e.length},i.prototype.showDialog=function(t){t===e.DialogType.InsertLink?this.notify(Et,{}):t===e.DialogType.InsertImage?this.notify(wt,{}):t===e.DialogType.InsertTable&&this.notify(Lt,{})},i.prototype.closeDialog=function(t){t===e.DialogType.InsertLink?this.notify(Tt,{}):t===e.DialogType.InsertImage?this.notify(kt,{}):t===e.DialogType.InsertTable&&this.notify(Ot,{})},i.prototype.getBaseToolbarObject=function(){return!this.inlineMode.enable||t.Browser.isDevice&&!h()?this.toolbarModule&&this.toolbarModule.getBaseToolbar():this.quickToolbarModule&&this.quickToolbarModule.getInlineBaseToolbar()},i.prototype.getToolbar=function(){return this.toolbarModule?this.toolbarModule.getToolbarElement():null},i.prototype.getToolbarElement=function(){return this.toolbarModule&&this.toolbarModule.getToolbarElement()},i.prototype.getID=function(){return"TEXTAREA"===this.originalElement.tagName?this.valueContainer.id:this.element.id},i.prototype.mouseDownHandler=function(e){var n=e.touches?e.changedTouches[0]:e;t.addClass([this.element],[nn]),this.preventDefaultResize(e),this.notify(Pe,{args:e}),this.clickPoints={clientX:n.clientX,clientY:n.clientY}},i.prototype.preventImgResize=function(e){"img"===e.target.nodeName.toLocaleLowerCase()&&e.preventDefault()},i.prototype.preventDefaultResize=function(e){"msie"===t.Browser.info.name?this.contentModule.getEditPanel().addEventListener("mscontrolselect",this.preventImgResize):"mozilla"===t.Browser.info.name&&(this.contentModule.getDocument().execCommand("enableObjectResizing",!1,"false"),this.contentModule.getDocument().execCommand("enableInlineTableEditing",!1,"false"))},i.prototype.defaultResize=function(e){"msie"===t.Browser.info.name?this.contentModule.getEditPanel().removeEventListener("mscontrolselect",this.preventImgResize):"mozilla"===t.Browser.info.name&&(this.contentModule.getDocument().execCommand("enableObjectResizing",!0,"true"),this.contentModule.getDocument().execCommand("enableInlineTableEditing",!0,"true"))},i.prototype.resizeHandler=function(){var e=!1;document.body.contains(this.element)?(this.toolbarSettings.enable&&!this.inlineMode.enable&&(this.toolbarModule.refreshToolbarOverflow(),e=this.toolbarModule.baseToolbar.toolbarObj.element.classList.contains(vn)),this.setContentHeight("windowResize",e),this.notify(de,null)):document.defaultView.removeEventListener("resize",this.onResizeHandler,!0)},i.prototype.scrollHandler=function(e){this.notify(He,{args:e})},i.prototype.contentScrollHandler=function(e){this.notify(je,{args:e})},i.prototype.focusHandler=function(e){if(!this.isRTE||this.isFocusOut){this.isRTE=!this.isFocusOut,this.isFocusOut=!1,t.addClass([this.element],[nn]),"HTML"===this.editorMode?this.cloneValue="<p><br></p>"===this.inputElement.innerHTML||"<div><br></div>"===this.inputElement.innerHTML||"<br>"===this.inputElement.innerHTML?null:this.enableHtmlEncode?this.encode(O(this.inputElement.innerHTML)):this.inputElement.innerHTML:this.cloneValue=""===this.inputElement.value?null:this.inputElement.value;var n=document.activeElement;if((n===this.element||n===this.getToolbarElement()||n===this.contentModule.getEditPanel()||this.iframeSettings.enable&&n===this.contentModule.getPanel()&&e.target&&!e.target.classList.contains("e-img-inner")&&e.target&&e.target.parentElement&&!e.target.parentElement.classList.contains("e-img-wrap")||t.closest(n,".e-rte-toolbar")===this.getToolbarElement())&&(this.contentModule.getEditPanel().focus(),!t.isNullOrUndefined(this.getToolbarElement()))){this.getToolbarElement().setAttribute("tabindex","-1");for(var i=this.getToolbarElement().querySelectorAll('[tabindex="0"]'),r=0;r<i.length;r++)i[r].setAttribute("tabindex","-1")}this.preventDefaultResize(e),this.trigger("focus",{event:e,isInteracted:0!==Object.keys(e).length}),!t.isNullOrUndefined(this.saveInterval)&&this.saveInterval>0&&!this.autoSaveOnIdle&&(this.timeInterval=setInterval(this.updateValueOnIdle.bind(this),this.saveInterval)),t.EventHandler.add(document,"mousedown",this.onDocumentClick,this)}if(!t.isNullOrUndefined(this.getToolbarElement())){var o=this.getToolbarElement().querySelectorAll("input,select,button,a,[tabindex]");for(r=0;r<o.length;r++)o[r].classList.contains("e-rte-dropdown-btn")||o[r].classList.contains("e-insert-table-btn")||o[r].hasAttribute("tabindex")&&"-1"===o[r].getAttribute("tabindex")||o[r].setAttribute("tabindex","-1")}},i.prototype.getUpdatedValue=function(){var e;t.isNullOrUndefined(this.tableModule)||this.tableModule.removeResizeElement();var n=this.element.querySelector(".e-rte-srctextarea");return"HTML"===this.editorMode?(e="<p><br></p>"===this.inputElement.innerHTML||"<div><br></div>"===this.inputElement.innerHTML||"<br>"===this.inputElement.innerHTML?null:this.enableHtmlEncode?this.encode(O(this.inputElement.innerHTML)):this.inputElement.innerHTML,n&&"block"===n.style.display&&(e=n.value)):e=""===this.inputElement.value?null:this.inputElement.value,e},i.prototype.updateValueOnIdle=function(){(t.isNullOrUndefined(this.tableModule)||t.isNullOrUndefined(this.inputElement.querySelector(".e-table-box.e-rbox-select")))&&(this.setProperties({value:this.getUpdatedValue()},!0),this.valueContainer.value=this.value,this.invokeChangeEvent())},i.prototype.updateIntervalValue=function(){clearTimeout(this.idleInterval),this.idleInterval=setTimeout(this.updateValueOnIdle.bind(this),0)},i.prototype.updateStatus=function(e){if(!t.isNullOrUndefined(e.html)||!t.isNullOrUndefined(e.markdown)){var n=this.formatter.editorManager.undoRedoManager.getUndoStatus(),i={undo:n.undo,redo:n.redo,html:e.html,markdown:e.markdown};this.trigger(ye,i)}},i.prototype.onDocumentClick=function(e){var n=e.target,i=t.closest(n,"."+xt);this.element.contains(e.target)||document===e.target||i===this.element||t.closest(n,'[aria-owns="'+this.getID()+'"]')||(this.isBlur=!0,this.isRTE=!1),this.notify(Ye,{args:e}),"msie"!==t.Browser.info.name&&e.detail>3&&e.preventDefault()},i.prototype.blurHandler=function(e){var n=e.relatedTarget;if(n){var i=t.closest(n,"."+xt);i&&i===this.element?(this.isBlur=!1,n===this.getToolbarElement()&&n.setAttribute("tabindex","-1")):t.closest(n,'[aria-owns="'+this.getID()+'"]')?this.isBlur=!1:(this.isBlur=!0,n=null)}if(this.isBlur&&t.isNullOrUndefined(n)){t.removeClass([this.element],[nn]),this.notify(ze,{});var r=this.getUpdatedValue();this.setProperties({value:r}),this.notify(z,{args:e,documentNode:document}),this.invokeChangeEvent(),this.isFocusOut=!0,this.isBlur=!1,C(this.valueContainer,"focusout"),this.defaultResize(e),this.trigger("blur",{event:e,isInteracted:0!==Object.keys(e).length}),t.isNullOrUndefined(this.timeInterval)||(clearInterval(this.timeInterval),this.timeInterval=null),t.EventHandler.remove(document,"mousedown",this.onDocumentClick)}else this.isRTE=!0},i.prototype.contentChanged=function(){this.autoSaveOnIdle&&(t.isNullOrUndefined(this.saveInterval)||(clearTimeout(this.timeInterval),this.timeInterval=setTimeout(this.updateIntervalValue.bind(this),this.saveInterval)))},i.prototype.invokeChangeEvent=function(){var e={value:this.enableXhtml?this.getXhtml():this.value};this.value!==this.cloneValue&&(this.trigger("change",e),this.cloneValue=this.value)},i.prototype.wireScrollElementsEvents=function(){this.scrollParentElements=r.getScrollableParent(this.element);for(var e=0,n=this.scrollParentElements;e<n.length;e++){var i=n[e];t.EventHandler.add(i,"scroll",this.scrollHandler,this)}this.iframeSettings.enable||t.EventHandler.add(this.contentModule.getPanel(),"scroll",this.contentScrollHandler,this)},i.prototype.wireContextEvent=function(){this.quickToolbarSettings.showOnRightClick&&(t.EventHandler.add(this.inputElement,"contextmenu",this.contextHandler,this),t.Browser.isDevice&&(this.touchModule=new t.Touch(this.inputElement,{tapHold:this.touchHandler.bind(this),tapHoldThreshold:500})))},i.prototype.unWireContextEvent=function(){t.EventHandler.remove(this.inputElement,"contextmenu",this.contextHandler),t.Browser.isDevice&&this.touchModule&&this.touchModule.destroy()},i.prototype.unWireScrollElementsEvents=function(){this.scrollParentElements=r.getScrollableParent(this.element);for(var e=0,n=this.scrollParentElements;e<n.length;e++){var i=n[e];t.EventHandler.remove(i,"scroll",this.scrollHandler)}this.iframeSettings.enable||t.EventHandler.remove(this.contentModule.getPanel(),"scroll",this.contentScrollHandler)},i.prototype.touchHandler=function(e){this.notifyMouseUp(e.originalEvent),this.triggerEditArea(e.originalEvent)},i.prototype.contextHandler=function(e){var n=t.closest(e.target,"a, table, img");!1!==this.inlineMode.onSelection&&(t.isNullOrUndefined(n)||!this.inputElement.contains(n)||"IMG"!==n.tagName&&"TABLE"!==n.tagName&&"A"!==n.tagName)||e.preventDefault()},i.prototype.resetHandler=function(){var e=this.valueContainer.defaultValue.trim();this.setProperties({value:""===e?null:e})},i.prototype.autoResize=function(){var e=this;if("auto"===this.height){if("Markdown"===this.editorMode)setTimeout(function(){e.setAutoHeight(e.inputElement)},0);else if(this.iframeSettings.enable){var t=this.element.querySelector("#"+this.getID()+"_rte-view");setTimeout(function(){e.setAutoHeight(t)},100),this.inputElement.style.overflow="hidden"}}else this.inputElement.style.overflow=null},i.prototype.setAutoHeight=function(e){t.isNullOrUndefined(e)||(e.style.height="",e.style.height=this.inputElement.scrollHeight+"px",e.style.overflow="hidden")},i.prototype.wireEvents=function(){this.element.addEventListener("focusin",this.onFocusHandler,!0),this.element.addEventListener("focusout",this.onBlurHandler,!0),this.on(U,this.contentChanged,this),this.on(ft,this.updateResizeFlag,this),this.on(Nt,this.updateStatus,this),this.readonly&&this.enabled||this.bindEvents()},i.prototype.restrict=function(e){if(this.maxLength>=0){for(var t="Markdown"===this.editorMode?this.contentModule.getText():e.currentTarget.textContent.trim(),n=[8,16,17,37,38,39,40,46,65],i=void 0,r=0;r<=n.length-1;r++)if(e.which===n[r]){if(e.ctrlKey&&65===e.which)return;if(65!==e.which)return void(i=n[r])}t.length>=this.maxLength&&-1!==this.maxLength&&e.which!==i&&e.preventDefault()}},i.prototype.bindEvents=function(){this.keyboardModule=new er(this.inputElement,{keyAction:this.keyDown.bind(this),keyConfigs:Bs({},this.formatter.keyConfig,this.keyConfig),eventName:"keydown"});var e=t.closest(this.valueContainer,"form");e&&t.EventHandler.add(e,"reset",this.resetHandler,this),t.EventHandler.add(this.inputElement,"keyup",this.keyUp,this),t.EventHandler.add(this.inputElement,"paste",this.onPaste,this),t.EventHandler.add(this.inputElement,t.Browser.touchEndEvent,t.debounce(this.mouseUp,30),this),t.EventHandler.add(this.inputElement,t.Browser.touchStartEvent,this.mouseDownHandler,this),this.wireContextEvent(),this.formatter.editorManager.observer.on(hr,this.editorKeyDown,this),this.element.ownerDocument.defaultView.addEventListener("resize",this.onResizeHandler,!0),this.iframeSettings.enable&&(t.EventHandler.add(this.inputElement,"focusin",this.focusHandler,this),t.EventHandler.add(this.inputElement,"focusout",this.blurHandler,this),t.EventHandler.add(this.inputElement.ownerDocument,"scroll",this.contentScrollHandler,this),t.EventHandler.add(this.inputElement.ownerDocument,t.Browser.touchStartEvent,this.onIframeMouseDown,this)),this.wireScrollElementsEvents()},i.prototype.onIframeMouseDown=function(e){this.isBlur=!1,this.notify(j,e)},i.prototype.editorKeyDown=function(e){switch(e.event.action){case"copy":this.onCopy();break;case"cut":this.onCut()}!e.callBack||"copy"!==e.event.action&&"cut"!==e.event.action&&"delete"!==e.event.action||e.callBack({requestType:e.event.action,editorMode:"HTML",event:e.event})},i.prototype.unWireEvents=function(){this.element.removeEventListener("focusin",this.onFocusHandler,!0),this.element.removeEventListener("focusout",this.onBlurHandler,!0),this.off(U,this.contentChanged),this.off(ft,this.updateResizeFlag),this.off(Nt,this.updateStatus),this.readonly&&this.enabled||this.unbindEvents()},i.prototype.unbindEvents=function(){this.keyboardModule&&this.keyboardModule.destroy();var e=t.closest(this.valueContainer,"form");e&&t.EventHandler.remove(e,"reset",this.resetHandler),t.EventHandler.remove(this.inputElement,"keyup",this.keyUp),t.EventHandler.remove(this.inputElement,"paste",this.onPaste),t.EventHandler.remove(this.inputElement,t.Browser.touchEndEvent,t.debounce(this.mouseUp,30)),t.EventHandler.remove(this.inputElement,t.Browser.touchStartEvent,this.mouseDownHandler),this.unWireContextEvent(),this.formatter&&this.formatter.editorManager.observer.off(hr,this.editorKeyDown),this.element.ownerDocument.defaultView.removeEventListener("resize",this.onResizeHandler,!0),this.iframeSettings.enable&&(t.EventHandler.remove(this.inputElement,"focusin",this.focusHandler),t.EventHandler.remove(this.inputElement,"focusout",this.blurHandler),t.EventHandler.remove(this.inputElement.ownerDocument,"scroll",this.contentScrollHandler),t.EventHandler.remove(this.inputElement.ownerDocument,t.Browser.touchStartEvent,this.onIframeMouseDown)),this.unWireScrollElementsEvents()},Ps([t.Complex({},hs)],i.prototype,"toolbarSettings",void 0),Ps([t.Complex({},fs)],i.prototype,"quickToolbarSettings",void 0),Ps([t.Complex({},bs)],i.prototype,"pasteCleanupSettings",void 0),Ps([t.Complex({},Os)],i.prototype,"iframeSettings",void 0),Ps([t.Complex({},us)],i.prototype,"insertImageSettings",void 0),Ps([t.Complex({},gs)],i.prototype,"tableSettings",void 0),Ps([t.Property(0)],i.prototype,"floatingToolbarOffset",void 0),Ps([t.Complex({},Ms)],i.prototype,"inlineMode",void 0),Ps([t.Complex({},ms)],i.prototype,"fileManagerSettings",void 0),Ps([t.Property("100%")],i.prototype,"width",void 0),Ps([t.Property(!1)],i.prototype,"enablePersistence",void 0),Ps([t.Property(!1)],i.prototype,"enableResize",void 0),Ps([t.Property({})],i.prototype,"htmlAttributes",void 0),Ps([t.Property(null)],i.prototype,"placeholder",void 0),Ps([t.Property(!1)],i.prototype,"autoSaveOnIdle",void 0),Ps([t.Property(!1)],i.prototype,"readonly",void 0),Ps([t.Property(!0)],i.prototype,"enabled",void 0),Ps([t.Property(!0)],i.prototype,"enableHtmlSanitizer",void 0),Ps([t.Property(!1)],i.prototype,"enableHtmlEncode",void 0),Ps([t.Property(!1)],i.prototype,"enableXhtml",void 0),Ps([t.Property("auto")],i.prototype,"height",void 0),Ps([t.Property(null)],i.prototype,"cssClass",void 0),Ps([t.Property(null)],i.prototype,"value",void 0),Ps([t.Property("P")],i.prototype,"enterKey",void 0),Ps([t.Property("BR")],i.prototype,"shiftEnterKey",void 0),Ps([t.Property(30)],i.prototype,"undoRedoSteps",void 0),Ps([t.Property(300)],i.prototype,"undoRedoTimer",void 0),Ps([t.Property("HTML")],i.prototype,"editorMode",void 0),Ps([t.Property(null)],i.prototype,"keyConfig",void 0),Ps([t.Property(!1)],i.prototype,"showCharCount",void 0),Ps([t.Property(!1)],i.prototype,"enableTabKey",void 0),Ps([t.Property(!1)],i.prototype,"enableAutoUrl",void 0),Ps([t.Property(-1)],i.prototype,"maxLength",void 0),Ps([t.Complex({},Cs)],i.prototype,"format",void 0),Ps([t.Complex({},Es)],i.prototype,"numberFormatList",void 0),Ps([t.Complex({},Ts)],i.prototype,"bulletFormatList",void 0),Ps([t.Complex({},vs)],i.prototype,"fontFamily",void 0),Ps([t.Complex({},ys)],i.prototype,"fontSize",void 0),Ps([t.Complex({},Ss)],i.prototype,"fontColor",void 0),Ps([t.Complex({},Ns)],i.prototype,"backgroundColor",void 0),Ps([t.Property(null)],i.prototype,"valueTemplate",void 0),Ps([t.Property(1e4)],i.prototype,"saveInterval",void 0),Ps([t.Event()],i.prototype,"actionBegin",void 0),Ps([t.Event()],i.prototype,"actionComplete",void 0),Ps([t.Event()],i.prototype,"beforeDialogOpen",void 0),Ps([t.Event()],i.prototype,"dialogOpen",void 0),Ps([t.Event()],i.prototype,"beforeDialogClose",void 0),Ps([t.Event()],i.prototype,"dialogClose",void 0),Ps([t.Event()],i.prototype,"beforeQuickToolbarOpen",void 0),Ps([t.Event()],i.prototype,"quickToolbarOpen",void 0),Ps([t.Event()],i.prototype,"quickToolbarClose",void 0),Ps([t.Event()],i.prototype,"toolbarStatusUpdate",void 0),Ps([t.Event()],i.prototype,"updatedToolbarStatus",void 0),Ps([t.Event()],i.prototype,"imageSelected",void 0),Ps([t.Event()],i.prototype,"beforeImageUpload",void 0),Ps([t.Event()],i.prototype,"imageUploading",void 0),Ps([t.Event()],i.prototype,"imageUploadSuccess",void 0),Ps([t.Event()],i.prototype,"imageUploadFailed",void 0),Ps([t.Event()],i.prototype,"imageRemoving",void 0),Ps([t.Event()],i.prototype,"afterImageDelete",void 0),Ps([t.Event()],i.prototype,"created",void 0),Ps([t.Event()],i.prototype,"destroyed",void 0),Ps([t.Event()],i.prototype,"beforeSanitizeHtml",void 0),Ps([t.Event()],i.prototype,"blur",void 0),Ps([t.Event()],i.prototype,"toolbarClick",void 0),Ps([t.Event()],i.prototype,"focus",void 0),Ps([t.Event()],i.prototype,"change",void 0),Ps([t.Event()],i.prototype,"resizing",void 0),Ps([t.Event()],i.prototype,"resizeStart",void 0),Ps([t.Event()],i.prototype,"resizeStop",void 0),Ps([t.Event()],i.prototype,"beforePasteCleanup",void 0),Ps([t.Event()],i.prototype,"afterPasteCleanup",void 0),Ps([t.Event()],i.prototype,"beforeImageDrop",void 0),Ps([t.Property(null)],i.prototype,"formatter",void 0),i=Ps([t.NotifyPropertyChanges],i)}(t.Component);e.Toolbar=Yi,e.KeyboardEvents=er,e.BaseToolbar=Vi,e.BaseQuickToolbar=nr,e.QuickToolbar=rr,e.Count=or,e.ColorPickerInput=tr,e.MarkdownToolbarStatus=lr,e.ExecCommandCallBack=dr,e.ToolbarAction=Xi,e.MarkdownEditor=_r,e.HtmlEditor=$o,e.PasteCleanup=Zo,e.Resize=es,e.DropDownButtons=Wi,e.FileManager=ts,e.FullScreen=ns,e.setAttributes=P,e.HtmlToolbarStatus=Ko,e.XhtmlValidation=Jo,e.HTMLFormatter=Qo,e.Formatter=yr,e.MarkdownFormatter=qr,e.ContentRender=Go,e.Render=is,e.ToolbarRenderer=Qi,e.Link=rs,e.Image=os,e.ViewSource=ss,e.Table=as,e.DialogRenderer=ls,e.IframeContentRender=Yo,e.MarkdownRender=zr,e.PopupRenderer=ir,e.RichTextEditor=As,e.executeGroup=ds,e.created="create",e.destroyed="destroy",e.load="load",e.initialLoad=A,e.contentChanged=U,e.initialEnd=H,e.iframeMouseDown=j,e.destroy=F,e.toolbarClick=q,e.toolbarRefresh=z,e.refreshBegin=_,e.toolbarUpdated=Q,e.bindOnEnd=V,e.renderColorPicker=W,e.htmlToolbarClick=K,e.markdownToolbarClick=G,e.destroyColorPicker=X,e.modelChanged=Y,e.keyUp=J,e.keyDown=$,e.mouseUp=Z,e.toolbarCreated=ee,e.toolbarRenderComplete=te,e.enableFullScreen=ne,e.disableFullScreen=ie,e.dropDownSelect=re,e.beforeDropDownItemRender=oe,e.execCommandCallBack=se,e.imageToolbarAction=ae,e.linkToolbarAction=le,e.windowResize=de,e.resizeStart=ce,e.onResize=pe,e.resizeStop=he,e.undo="undo",e.redo="redo",e.insertLink=ue,e.unLink=me,e.editLink=ge,e.openLink=fe,e.actionBegin=be,e.actionComplete=ve,e.updatedToolbarStatus=ye,e.actionSuccess="actionSuccess",e.updateToolbarItem=Ce,e.insertImage=Se,e.insertCompleted=Ne,e.imageLeft="justifyLeft",e.imageRight="justifyRight",e.imageCenter="justifyCenter",e.imageBreak="break",e.imageInline="inline",e.imageLink=Ee,e.imageAlt=Te,e.imageDelete=we,e.imageCaption=ke,e.imageSize=Le,e.sourceCode=Oe,e.updateSource=xe,e.toolbarOpen="toolbarOpen",e.beforeDropDownOpen=De,e.selectionSave=Me,e.selectionRestore=Re,e.expandPopupClick=Ie,e.count=Be,e.contentFocus="contentFocus",e.contentBlur="contentBlur",e.mouseDown=Pe,e.sourceCodeMouseDown=Ae,e.editAreaClick=Ue,e.scroll=He,e.contentscroll=je,e.colorPickerChanged=Fe,e.tableColorPickerChanged=qe,e.focusChange=ze,e.selectAll=_e,e.selectRange=Qe,e.getSelectedHtml=Ve,e.renderInlineToolbar=We,e.paste=Ke,e.imgModule="imageModule",e.rtlMode=Ge,e.createTable=Xe,e.docClick=Ye,e.tableToolbarAction=Je,e.checkUndo=$e,e.readOnlyMode=Ze,e.pasteClean=et,e.enterHandler=tt,e.beforeDialogOpen=nt,e.clearDialogObj=it,e.dialogOpen="dialogOpen",e.beforeDialogClose=rt,e.dialogClose="dialogClose",e.beforeQuickToolbarOpen=ot,e.quickToolbarOpen=st,e.quickToolbarClose=at,e.popupHide="popupHide",e.imageSelected=lt,e.imageUploading=dt,e.imageUploadSuccess=ct,e.imageUploadFailed=pt,e.imageRemoving=ht,e.afterImageDelete=ut,e.drop="drop",e.xhtmlValidation=mt,e.beforeImageUpload=gt,e.resizeInitialized=ft,e.renderFileManager=bt,e.beforeImageDrop=vt,e.dynamicModule=yt,e.beforePasteCleanup=Ct,e.afterPasteCleanup=St,e.updateTbItemsStatus=Nt,e.showLinkDialog=Et,e.closeLinkDialog=Tt,e.showImageDialog=wt,e.closeImageDialog=kt,e.showTableDialog=Lt,e.closeTableDialog=Ot,e.CLS_RTE=xt,e.CLS_RTL="e-rtl",e.CLS_CONTENT="e-content",e.CLS_DISABLED=Dt,e.CLS_SCRIPT_SHEET=Mt,e.CLS_STYLE_SHEET=Rt,e.CLS_TOOLBAR=It,e.CLS_TB_FIXED=Bt,e.CLS_TB_FLOAT=Pt,e.CLS_TB_ABS_FLOAT=At,e.CLS_INLINE=Ut,e.CLS_TB_INLINE="e-rte-tb-inline",e.CLS_RTE_EXPAND_TB=Ht,e.CLS_FULL_SCREEN=jt,e.CLS_QUICK_TB=Ft,e.CLS_POP=qt,e.CLS_TB_STATIC="e-tb-static",e.CLS_QUICK_POP=zt,e.CLS_QUICK_DROPDOWN=_t,e.CLS_IMAGE_POP=Qt,e.CLS_INLINE_POP=Vt,e.CLS_INLINE_DROPDOWN=Wt,e.CLS_DROPDOWN_POPUP=Kt,e.CLS_DROPDOWN_ICONS=Gt,e.CLS_DROPDOWN_ITEMS=Xt,e.CLS_DROPDOWN_BTN=Yt,e.CLS_RTE_CONTENT=Jt,e.CLS_TB_ITEM=$t,e.CLS_TB_EXTENDED="e-toolbar-extended",e.CLS_TB_WRAP=Zt,e.CLS_POPUP="e-popup",e.CLS_SEPARATOR="e-separator",e.CLS_MINIMIZE="e-minimize",e.CLS_MAXIMIZE="e-maximize",e.CLS_BACK="e-back",e.CLS_SHOW="e-show",e.CLS_HIDE=en,e.CLS_VISIBLE=tn,e.CLS_FOCUS=nn,e.CLS_RM_WHITE_SPACE=rn,e.CLS_IMGRIGHT=on,e.CLS_IMGLEFT=sn,e.CLS_IMGCENTER=an,e.CLS_IMGBREAK=ln,e.CLS_CAPTION=dn,e.CLS_RTE_CAPTION=cn,e.CLS_CAPINLINE=pn,e.CLS_IMGINLINE=hn,e.CLS_COUNT=un,e.CLS_WARNING=mn,e.CLS_ERROR=gn,e.CLS_ICONS=fn,e.CLS_ACTIVE=bn,e.CLS_EXPAND_OPEN=vn,e.CLS_RTE_ELEMENTS=yn,e.CLS_TB_BTN=Cn,e.CLS_HR_SEPARATOR=Sn,e.CLS_TB_IOS_FIX=Nn,e.CLS_LIST_PRIMARY_CONTENT=En,e.CLS_NUMBERFORMATLIST_TB_BTN=Tn,e.CLS_BULLETFORMATLIST_TB_BTN=wn,e.CLS_FORMATS_TB_BTN=kn,e.CLS_FONT_NAME_TB_BTN=Ln,e.CLS_FONT_SIZE_TB_BTN=On,e.CLS_FONT_COLOR_TARGET=xn,e.CLS_BACKGROUND_COLOR_TARGET=Dn,e.CLS_COLOR_CONTENT=Mn,e.CLS_FONT_COLOR_DROPDOWN=Rn,e.CLS_BACKGROUND_COLOR_DROPDOWN=In,e.CLS_COLOR_PALETTE=Bn,e.CLS_FONT_COLOR_PICKER=Pn,e.CLS_BACKGROUND_COLOR_PICKER=An,e.CLS_RTE_READONLY=Un,e.CLS_TABLE_SEL=Hn,e.CLS_TB_DASH_BOR=jn,e.CLS_TB_ALT_BOR=Fn,e.CLS_TB_COL_RES=qn,e.CLS_TB_ROW_RES=zn,e.CLS_TB_BOX_RES=_n,e.CLS_RTE_HIDDEN=Qn,e.CLS_RTE_PASTE_KEEP_FORMAT=Vn,e.CLS_RTE_PASTE_REMOVE_FORMAT=Wn,e.CLS_RTE_PASTE_PLAIN_FORMAT=Kn,e.CLS_RTE_PASTE_OK=Gn,e.CLS_RTE_PASTE_CANCEL=Xn,e.CLS_RTE_DIALOG_MIN_HEIGHT=Yn,e.CLS_RTE_RES_HANDLE=Jn,e.CLS_RTE_RES_EAST="e-south-east",e.CLS_RTE_IMAGE=$n,e.CLS_RESIZE="e-resize",e.CLS_IMG_FOCUS="e-img-focus",e.CLS_RTE_DRAG_IMAGE=Zn,e.CLS_RTE_UPLOAD_POPUP=ei,e.CLS_POPUP_OPEN=ti,e.CLS_IMG_RESIZE="e-img-resize",e.CLS_DROPAREA="e-droparea",e.CLS_IMG_INNER="e-img-inner",e.CLS_UPLOAD_FILES=ni,e.CLS_RTE_DIALOG_UPLOAD=ii,e.CLS_RTE_RES_CNT=ri,e.CLS_CUSTOM_TILE=oi,e.CLS_NOCOLOR_ITEM=si,e.CLS_TABLE=ai,e.CLS_TABLE_BORDER=li,e.CLS_RTE_TABLE_RESIZE=di,e.CLS_RTE_FIXED_TB_EXPAND=ci,e.CLS_RTE_TB_ENABLED=pi,e.getIndex=d,e.hasClass=c,e.getDropDownValue=p,e.isIDevice=h,e.getFormattedFontSize=u,e.pageYOffset=m,e.getTooltipText=g,e.setToolbarStatus=f,e.getCollection=b,e.getTBarItemsIndex=v,e.updateUndoRedoStatus=y,e.dispatchEvent=C,e.parseHtml=S,e.getTextNodesUnder=N,e.toObjectLowerCase=E,e.getEditValue=T,e.updateTextNode=w,e.getDefaultValue=k,e.isEditableValueEmpty=L,e.decode=O,e.sanitizeHelper=x,e.convertToBlob=D,e.getLocaleFontFormat=M,e.updateDropDownFontFormatLocale=R,e.ServiceLocator=Ki,e.RendererFactory=Gi,e.EditorManager=zo,e.IMAGE=Qr,e.TABLE=Vr,e.LINK=Wr,e.INSERT_ROW=Kr,e.INSERT_COLUMN=Gr,e.DELETEROW=Xr,e.DELETECOLUMN=Yr,e.REMOVETABLE=Jr,e.TABLEHEADER=$r,e.TABLE_VERTICAL_ALIGN=Zr,e.TABLE_MERGE=eo,e.TABLE_VERTICAL_SPLIT=to,e.TABLE_HORIZONTAL_SPLIT=no,e.TABLE_MOVE="TABLE_MOVE",e.ALIGNMENT_TYPE=io,e.INDENT_TYPE=ro,e.DEFAULT_TAG="p",e.BLOCK_TAGS=oo,e.IGNORE_BLOCK_TAGS=so,e.TABLE_BLOCK_TAGS=ao,e.SELECTION_TYPE=lo,e.INSERTHTML_TYPE=co,e.INSERT_TEXT_TYPE=po,e.CLEAR_TYPE=ho,e.CLASS_IMAGE_RIGHT=To,e.CLASS_IMAGE_LEFT=wo,e.CLASS_IMAGE_CENTER=ko,e.CLASS_IMAGE_BREAK=Lo,e.CLASS_CAPTION=Oo,e.CLASS_RTE_CAPTION="e-rte-img-caption",e.CLASS_CAPTION_INLINE=xo,e.CLASS_IMAGE_INLINE="e-imginline",e.Lists=fo,e.markerClassName=mo,e.DOMNode=go,e.Alignments=No,e.Indents=Eo,e.Formats=yo,e.LinkCommand=So,e.InsertMethods=bo,e.InsertTextExec=qo,e.InsertHtmlExec=Ao,e.InsertHtml=Co,e.IsFormatted=Io,e.MsWordPaste=Fo,e.NodeCutter=vo,e.ImageCommand=Do,e.SelectionCommands=Bo,e.SelectionBasedExec=Po,e.ClearFormatExec=Ho,e.UndoRedoManager=jo,e.TableCommand=Mo,e.statusCollection=Vo,e.ToolbarStatus=Wo,e.NodeSelection=uo,e.MarkdownParser=jr,e.LISTS_COMMAND=Cr,e.selectionCommand=Sr,e.LINK_COMMAND=Nr,e.CLEAR_COMMAND=Er,e.MD_TABLE=Tr,e.ClearFormat=Hr,e.MDLists=wr,e.MDFormats=kr,e.MarkdownSelection=sr,e.UndoRedoCommands=Pr,e.MDSelectionFormats=Lr,e.MDLink=Ar,e.MDTable=Ur,e.markdownFormatTags=Or,e.markdownSelectionTags=xr,e.markdownListsTags=Dr,e.htmlKeyConfig=Mr,e.markdownKeyConfig=Rr,e.pasteCleanupGroupingTags=Ir,e.listConversionFilters={first:"MsoListParagraphCxSpFirst",middle:"MsoListParagraphCxSpMiddle",last:"MsoListParagraphCxSpLast"},e.selfClosingTags=Br,e.KEY_DOWN="keydown",e.ACTION=cr,e.FORMAT_TYPE=pr,e.KEY_DOWN_HANDLER=hr,e.LIST_TYPE="list-type",e.KEY_UP_HANDLER=ur,e.KEY_UP="keyup",e.MODEL_CHANGED_PLUGIN=mr,e.MODEL_CHANGED=gr,e.MS_WORD_CLEANUP_PLUGIN=fr,e.MS_WORD_CLEANUP=br,e.ON_BEGIN="onBegin",e.SPACE_ACTION=vr,Object.defineProperty(e,"__esModule",{value:!0})});
	//# sourceMappingURL=ej2-richtexteditor.umd.min.js.map


/***/ },
/* 538 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _firebase = __webpack_require__(6);
	
	var _requestMessagingPermission = __webpack_require__(605);
	
	var _requestMessagingPermission2 = _interopRequireDefault(_requestMessagingPermission);
	
	var _reactFileInput = __webpack_require__(738);
	
	var _reactFileInput2 = _interopRequireDefault(_reactFileInput);
	
	var _reactLogo = __webpack_require__(642);
	
	var _reactLogo2 = _interopRequireDefault(_reactLogo);
	
	var _firebaseLogo = __webpack_require__(638);
	
	var _firebaseLogo2 = _interopRequireDefault(_firebaseLogo);
	
	__webpack_require__(619);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App(props) {
	    _classCallCheck(this, App);
	
	    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));
	
	    _this.state = {
	      guides: null,
	      newData: '',
	      currentUser: {},
	      userImages: null
	    };
	
	    _this.userRef = _firebase.database.ref('/users').child('Anonymous');
	    _this.guidesRef = _firebase.database.ref('/guides');
	    _this.userStorageRef = _firebase.storage.ref('/user-files').child('Anonymous');
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.handleFileSubmit = _this.handleFileSubmit.bind(_this);
	    _this.displayCurrentUser = _this.displayCurrentUser.bind(_this);
	    return _this;
	  }
	
	  _createClass(App, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      _firebase.auth.onAuthStateChanged(function (currentUser) {
	        _this2.setState({ currentUser: currentUser || {} });
	
	        if (currentUser) {
	          // Init current user Refs
	          _this2.userRef = _firebase.database.ref('/users').child(currentUser.uid);
	          _this2.userStorageRef = _firebase.storage.ref('/user-files').child(currentUser.uid);
	
	          _this2.guidesRef.on('value', function (snapshot) {
	            var guides = snapshot.val();
	            _this2.setState({ guides: guides });
	          });
	
	          _this2.userRef.child('images').on('value', function (snapshot) {
	            var userImages = snapshot.val();
	            if (userImages) {
	              _this2.setState({ userImages: userImages });
	            }
	          });
	          // register function messaging alert for this user
	          (0, _requestMessagingPermission2.default)(currentUser);
	          // Add user to users database if not exist
	          _this2.userRef.once('value', function (snapshot) {
	            var userData = snapshot.val();
	            if (!userData) {
	              _this2.userRef.set({ name: currentUser.displayName });
	            }
	          });
	        } else {
	          _this2.setState({ guides: null, userImages: null });
	        }
	      });
	    }
	
	    // Form Events
	
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      var newData = event.target.value;
	      this.setState({ newData: newData });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(event) {
	      event.preventDefault();
	      var _state = this.state,
	          newData = _state.newData,
	          currentUser = _state.currentUser;
	
	      this.guidesRef.push({
	        uid: currentUser.uid,
	        content: newData
	      });
	    }
	  }, {
	    key: 'handleFileSubmit',
	    value: function handleFileSubmit(event) {
	      var _this3 = this;
	
	      var file = event.target.files[0];
	      var uploadTask = this.userStorageRef.child(file.name).put(file, { contentType: file.type });
	
	      uploadTask.on('state_changed', function (snapshot) {
	        console.log(snapshot.bytesTransferred / snapshot.totalBytes * 100 + '%');
	      });
	
	      uploadTask.then(function (snapshot) {
	        _this3.userRef.child('images').push(snapshot.downloadURL);
	      });
	    }
	
	    // Auth Events
	
	  }, {
	    key: 'signIn',
	    value: function signIn() {
	      _firebase.auth.signInWithPopup(_firebase.googleAuthProvider);
	    }
	  }, {
	    key: 'signOut',
	    value: function signOut() {
	      _firebase.auth.signOut();
	    }
	  }, {
	    key: 'displayCurrentUser',
	    value: function displayCurrentUser() {
	      return _react2.default.createElement('img', { className: 'App-nav-img', onClick: this.signOut,
	        src: this.state.currentUser.photoURL,
	        alt: this.state.currentUser.displayName
	      });
	    }
	  }, {
	    key: 'displayUserImages',
	    value: function displayUserImages() {
	      var userImages = this.state.userImages;
	
	      if (userImages) {
	        var imageIds = Object.keys(userImages);
	        return imageIds.map(function (id) {
	          return _react2.default.createElement('img', {
	            key: id,
	            className: 'App-image',
	            src: userImages[id]
	          });
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'App' },
	        _react2.default.createElement(
	          'div',
	          { className: 'App-nav' },
	          _react2.default.createElement(
	            'span',
	            { className: 'App-nav-title' },
	            'React + Firebase Setup'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'App-nav-button' },
	            this.state.currentUser.email ? this.displayCurrentUser() : _react2.default.createElement(
	              'a',
	              { href: '#', onClick: this.signIn },
	              'Sign In'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'App-header' },
	          _react2.default.createElement('img', { src: _reactLogo2.default, className: 'main-logo', alt: 'logo' }),
	          _react2.default.createElement('img', { src: _firebaseLogo2.default, className: 'main-logo', alt: 'logo' }),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Welcome to React and Firebase'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'App-intro' },
	          _react2.default.createElement(
	            'code',
	            null,
	            _react2.default.createElement(
	              'b',
	              null,
	              'Database'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'AppBody' },
	          _react2.default.createElement(
	            'form',
	            { className: 'App-form', onSubmit: this.handleSubmit },
	            _react2.default.createElement('input', { className: 'text', name: 'name', placeholder: 'New data', type: 'text', onChange: this.handleChange }),
	            _react2.default.createElement('input', { className: 'button', type: 'submit', value: 'Push' })
	          ),
	          _react2.default.createElement(
	            'pre',
	            { className: 'AppBody-fb-db' },
	            JSON.stringify(this.state.guides, null, 2)
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'App-intro' },
	          _react2.default.createElement(
	            'code',
	            null,
	            _react2.default.createElement(
	              'b',
	              null,
	              'Cloud Storage'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'AppBody' },
	          _react2.default.createElement(_reactFileInput2.default, {
	            className: 'file',
	            accept: '.png,.gif,.jpg',
	            placeholder: 'Select an image',
	            onChange: this.handleFileSubmit
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'App-images' },
	            this.displayUserImages()
	          )
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	exports.default = App;

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _edit = __webpack_require__(21);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _delete = __webpack_require__(45);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _firebase = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { getFirestore, collection, getDocs } from 'firebase/firestore/lite';
	
	//import $ from 'jquery';
	
	
	var Insights = function (_Component) {
	  _inherits(Insights, _Component);
	
	  function Insights(props) {
	    _classCallCheck(this, Insights);
	
	    var _this = _possibleConstructorReturn(this, (Insights.__proto__ || Object.getPrototypeOf(Insights)).call(this, props));
	
	    _this.state = {
	      insightData: []
	    };
	
	    return _this;
	  }
	
	  _createClass(Insights, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.renderList();
	    }
	  }, {
	    key: "renderList",
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var dataList;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                dataList = [];
	                _context.next = 3;
	                return _firebase.database.ref("Course").once('value', function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    dataList.push({ key: ChildSnapshot.key, CourseName: ChildSnapshot.val().CourseName
	
	                    });
	                  });
	                });
	
	              case 3:
	                this.setState({ insightData: dataList });
	
	              case 4:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function renderList() {
	        return _ref.apply(this, arguments);
	      }
	
	      return renderList;
	    }()
	  }, {
	    key: "editData",
	    value: function editData(key) {
	
	      this.props.history.push("/newInsights/keyId=" + key);
	    }
	  }, {
	    key: "deleteData",
	    value: function deleteData(key) {
	      var _this2 = this;
	
	      _firebase.database.ref("Course/" + key).remove().then(function () {
	        alert("Deleted Successfully");
	        _this2.renderList();
	      }).catch(function () {
	        alert("Somthing went wrong");
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content" },
	          _react2.default.createElement(_doctorLeftmenu2.default, null),
	          _react2.default.createElement(
	            "div",
	            { className: "content-right-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "div",
	                { className: "form-wrapper" },
	                _react2.default.createElement(
	                  "ul",
	                  { className: "breadcrumb" },
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                      "a",
	                      { href: "/dashboard" },
	                      "Dashboard"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Career Tracks"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-head" },
	                  "Career Tracks",
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { to: "/newCourse/keyId=0" },
	                    _react2.default.createElement(
	                      "button",
	                      { className: "addNewBtn btn" },
	                      " New Courses"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "table" },
	                  _react2.default.createElement(
	                    "table",
	                    { className: "table table-bordered" },
	                    _react2.default.createElement(
	                      "thead",
	                      null,
	                      _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "col" },
	                          "No"
	                        ),
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "col" },
	                          "Courses Name"
	                        ),
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "col" },
	                          "Actions"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tbody",
	                      null,
	                      this.renderList,
	                      this.state.insightData.map(function (data, i) {
	
	                        return _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "row" },
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            data.CourseName
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            _react2.default.createElement(
	                              _reactRouterDom.Link,
	                              { to: '/newCourse/keyId=' + data.key, params: data.key },
	                              _react2.default.createElement("img", { src: _edit2.default, className: "actionIcon" })
	                            ),
	                            _react2.default.createElement("img", { src: _delete2.default, className: "actionIcon", onClick: function onClick() {
	                                return _this3.deleteData(data.key);
	                              } })
	                          )
	                        );
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_footer2.default, null)
	      );
	    }
	  }]);
	
	  return Insights;
	}(_react.Component);
	
	exports.default = Insights;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _firebase = __webpack_require__(6);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _close = __webpack_require__(411);
	
	var _close2 = _interopRequireDefault(_close);
	
	var _newStoriesEditor = __webpack_require__(103);
	
	var _newStoriesEditor2 = _interopRequireDefault(_newStoriesEditor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewInsights = function (_Component) {
	  _inherits(NewInsights, _Component);
	
	  function NewInsights(props) {
	    _classCallCheck(this, NewInsights);
	
	    var _this = _possibleConstructorReturn(this, (NewInsights.__proto__ || Object.getPrototypeOf(NewInsights)).call(this, props));
	
	    _this.handleChange = function (event) {
	      var _event$target = event.target,
	          value = _event$target.value,
	          name = _event$target.name;
	
	      _this.setState(_defineProperty({}, name, value));
	    };
	
	    _this.handleNumberChange = function (event) {
	      var re = /^[0-9\b]+$/;
	      if (event.target.value === "" || re.test(event.target.value)) {
	        if (parseFloat(event.target.value) > 10) {
	          (0, _jquery2.default)("#" + event.target.name).val("");
	        }
	      } else {
	        (0, _jquery2.default)("#" + event.target.name).val("");
	      }
	    };
	
	    _this.handleChangePlatformsToolsFile = function (e) {
	      if (e.target.files[0]) {
	        _this.setState({
	          PlatformsToolsFileName: e.target.files[0],
	          PlatformsToolsFileNameFlag: true
	        });
	      }
	    };
	
	    _this.handleChangeCertifications = function (e) {
	      if (e.target.files[0]) {
	        _this.setState({
	          CertificationsFileName: e.target.files[0],
	          CertificationsFileNameFlag: true
	        });
	      }
	    };
	
	    _this.handleChangeiconCourse = function (e) {
	      if (e.target.files[0]) {
	        _this.setState({
	          iconCourseName: e.target.files[0],
	          iconCourseFlag: true
	        });
	      }
	    };
	
	    _this.handleImageChange = function (e) {
	      if (e.target.files[0]) {
	        _this.setState({
	          courseImage: e.target.files[0],
	          fileName: true
	        });
	      }
	    };
	
	    _this.validateSubmission = function () {
	      console.log("this.state.courseImage...", _this.state.courseImage);
	      console.log("this.state.CourseUrl...", _this.state.CourseUrl);
	      if ((0, _jquery2.default)("#CourseName").val() === "") {
	        alert("Enter Course Name");
	      } else if (_this.state.courseImage === "" || _this.state.courseImage === null) {
	        alert("Upload File ");
	      } else if ((0, _jquery2.default)("#universityName").val() === "") {
	        alert("Enter University Name");
	      } else if ((0, _jquery2.default)("#courseDescription").val() === "") {
	        alert("Enter Course Description");
	      }
	      // else if (this.state.modelRight.length === 0) {
	      //     alert("Please Fill What you'll do")
	      // }
	      // else if (this.state.WhatYouWillLearnArray.length === 0) {
	      //     alert("Please Fill What You Will Learn")
	      // }
	      // else if (this.state.WhatYouWillGetArray.length === 0) {
	      //     alert("Please Fill What You Will Get")
	      // }
	      // else if (this.state.HowdoesitworkArray.length === 0) {
	      //     alert("Please Fill How does it work ")
	      // }
	      // else if (this.state.PlatformsToolsFiles.length === 0) {
	      //     alert("Please Fill Plat forms Tools Files ")
	      // }
	      // else if (this.state.CertificationsFiles.length === 0) {
	      //     alert("Please Fill Certifications Files ")
	      // }
	      // else if(this.state.skillArray.length === 0 ) {
	      //     alert("Please select skills  ")
	      // }
	      else {
	          console.log("this.state.courseImage...", _this.state.courseImage);
	          if (_this.state.fileName) {
	            var uploadTask = _firebase.storage.ref("Course/" + _this.state.courseImage.name).put(_this.state.courseImage);
	            uploadTask.on("state_changed", function (snapshot) {
	              var progress = Math.round(snapshot.bytesTransferred / snapshot.totalBytes * 100);
	              _this.setState({
	                progress: progress
	              });
	            }, function (error) {
	              console.log(error);
	            }, function () {
	              _firebase.storage.ref("Course").child(_this.state.courseImage.name).getDownloadURL().then(function (url) {
	                console.log("url...", url);
	                (0, _jquery2.default)("#imageUrl").attr("src", url);
	                _this.setState({
	                  url: url
	                });
	                if (_this.state.id == null) {
	                  _this.handleSubmit(url);
	                } else {
	                  _this.updateValidateSubmission(url);
	                }
	              });
	            });
	          } else {
	            if (_this.state.id == null) {
	              _this.handleSubmit("");
	            } else {
	              _this.updateValidateSubmission("");
	            }
	          }
	        }
	    };
	
	    _this.updateValidateSubmission = function (url) {
	      // alert($("#expertise").val());
	      _this.scoreCalculate();
	      console.log(">>>>>", _this.state.HowdoesitworkArray === undefined ? [] : _this.state.HowdoesitworkArray);
	      var bannerDescriptionContent = document.getElementById("toolsRTEbanner_rte-edit-view").innerHTML;
	      var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	      var outcomes = [];
	      var CareerTransition = "False";
	      var QuickUpskills = "False";
	      var Jobs = "False";
	      var CertificatesCheck = "False";
	
	      var careerTransitionScore = 0;
	      var quickUpskillsScore = 0;
	      var jobsScore = 0;
	      var certificatesScore = 0;
	
	      if ((0, _jquery2.default)("#CareerTransition:checked").val() != undefined) {
	        CareerTransition = "True";
	      }
	      if ((0, _jquery2.default)("#QuickUpskills:checked").val() != undefined) {
	        QuickUpskills = "True";
	      }
	      if ((0, _jquery2.default)("#Jobs:checked").val() != undefined) {
	        Jobs = "True";
	      }
	      if ((0, _jquery2.default)("#CertificatesCheck:checked").val() != undefined) {
	        CertificatesCheck = "True";
	      }
	
	      if ((0, _jquery2.default)("#careerTransitionScore").val() != "") {
	        careerTransitionScore = (0, _jquery2.default)("#careerTransitionScore").val();
	      }
	      if ((0, _jquery2.default)("#quickUpskillsScore").val() != "") {
	        quickUpskillsScore = (0, _jquery2.default)("#quickUpskillsScore").val();
	      }
	      if ((0, _jquery2.default)("#jobsScore").val() != "") {
	        jobsScore = (0, _jquery2.default)("#jobsScore").val();
	      }
	      if ((0, _jquery2.default)("#certificatesScore").val() != "") {
	        certificatesScore = (0, _jquery2.default)("#certificatesScore").val();
	      }
	
	      outcomes.push({
	        CareerTransition: CareerTransition,
	        QuickUpskills: QuickUpskills,
	        Jobs: Jobs,
	        Certificates: CertificatesCheck
	      });
	      outcomes.push({
	        CareerTransitionScore: careerTransitionScore,
	        QuickUpskillsScore: quickUpskillsScore,
	        JobsScore: jobsScore,
	        CertificatesScore: certificatesScore
	      });
	      var skillArray = _this.state.skillArray;
	      var newArray = [];
	      skillArray.map(function (data, i) {
	
	        if (data.skillRating == "" || data.skillRating == undefined) {
	          data.skillRating = 0;
	        }
	        newArray.push({ skill: data.skill, skillRating: data.skillRating });
	      });
	      _this.setState({ skillArray: newArray });
	      var item = {
	        CourseName: (0, _jquery2.default)("#CourseName").val(),
	        imageUrl: url ? url : _this.state.courseImage,
	        createdAt: newDate,
	        bannerDetails: [{
	          title: _this.state.bannerTitle,
	          description: bannerDescriptionContent
	        }],
	        whatyoudo_Description: _this.state.whatyoudo_Description,
	        whatyoudo_rightModel: [{
	          rightModelTitle: _this.state.rightModelTitle,
	          modelData: _this.state.modelRight
	        }],
	        WhatYouWillLearn: _this.state.WhatYouWillLearnArray,
	        WhatYouWillGet: _this.state.WhatYouWillGetArray,
	        Howdoesitwork: _this.state.HowdoesitworkArray === undefined ? [] : _this.state.HowdoesitworkArray,
	        PlatformsToolsFiles: _this.state.PlatformsToolsFiles,
	        CertificationsFiles: _this.state.CertificationsFiles,
	        universityName: (0, _jquery2.default)("#universityName").val(),
	        courseDescription: (0, _jquery2.default)("#courseDescription").val(),
	        Websitelink: _this.state.Websitelink,
	        Accrediation: _this.state.Accrediation,
	        Accredtionscore: _this.state.Accredtionscore,
	        Modeoflearning: (0, _jquery2.default)("#Modeoflearning").val(),
	        Country: (0, _jquery2.default)("#Country").val(),
	        Level: _this.state.Level,
	        Courserating: _this.state.Courserating,
	        Language: _this.state.Language,
	        skills: _this.state.skillArray,
	        expertise: (0, _jquery2.default)("#expertise").val(),
	        CourseFields: [{
	          CourseScore: _this.state.CourseScore,
	          LengthandBreadth: (0, _jquery2.default)("#LengthandBreadth").val() == "" ? 0 : (0, _jquery2.default)("#LengthandBreadth").val(),
	          RelevantCaseStudies: (0, _jquery2.default)("#RelevantCaseStudies").val() == "" ? 0 : (0, _jquery2.default)("#RelevantCaseStudies").val(),
	          ToolsCovered: (0, _jquery2.default)("#ToolsCovered").val() == "" ? 0 : (0, _jquery2.default)("#ToolsCovered").val(),
	          CapstoneProjectCovered: (0, _jquery2.default)("#CapstoneProjectCovered").val() == "" ? 0 : (0, _jquery2.default)("#CapstoneProjectCovered").val(),
	
	          TrainerExperience: (0, _jquery2.default)("#TrainerExperience").val() == "" ? 0 : (0, _jquery2.default)("#TrainerExperience").val(),
	          TrainerEducation: (0, _jquery2.default)("#TrainerEducation").val() == "" ? 0 : (0, _jquery2.default)("#TrainerEducation").val(),
	          TeachingStyle: (0, _jquery2.default)("#TeachingStyle").val() == "" ? 0 : (0, _jquery2.default)("#TeachingStyle").val(),
	
	          Ranking: (0, _jquery2.default)("#Ranking").val() == "" ? 0 : (0, _jquery2.default)("#Ranking").val(),
	          GovtBodies: (0, _jquery2.default)("#GovtBodies").val() == "" ? 0 : (0, _jquery2.default)("#GovtBodies").val(),
	          ProfessionalBodies: (0, _jquery2.default)("#ProfessionalBodies").val() == "" ? 0 : (0, _jquery2.default)("#ProfessionalBodies").val(),
	
	          Mentorship: (0, _jquery2.default)("#Mentorship").val() == "" ? 0 : (0, _jquery2.default)("#Mentorship").val(),
	          CareerCoach: (0, _jquery2.default)("#CareerCoach").val() == "" ? 0 : (0, _jquery2.default)("#CareerCoach").val(),
	          Liveclasses: (0, _jquery2.default)("#Liveclasses").val() == "" ? 0 : (0, _jquery2.default)("#Liveclasses").val(),
	          QuickUpskilling: (0, _jquery2.default)("#QuickUpskilling").val() == "" ? 0 : (0, _jquery2.default)("#QuickUpskilling").val(),
	          ActiveLearning: (0, _jquery2.default)("#ActiveLearning").val() == "" ? 0 : (0, _jquery2.default)("#ActiveLearning").val(),
	          JobAssistance: (0, _jquery2.default)("#JobAssistance").val() == "" ? 0 : (0, _jquery2.default)("#JobAssistance").val(),
	          StudyMaterials: (0, _jquery2.default)("#StudyMaterials").val() == "" ? 0 : (0, _jquery2.default)("#StudyMaterials").val()
	        }],
	        outcomes: outcomes
	        // courseDetails:[{universityName:$("#universityName").val(),courseDescription:$("#courseDescription").val(),shortDescription:this.state.courseDetails}]
	      };
	      console.log(">>>>>>>>>>>>>>>>>>>>>>::::::", item);
	      _firebase.database.ref("Course/" + _this.state.id).update(item).then(function () {
	        alert("Updated Successfully");
	        window.location.href = "/career-tracks";
	        _this.renderList();
	      }).catch(function () {
	        alert("Somthing went wrong");
	      });
	    };
	
	    _this.handleSubmit = function (url) {
	      _this.scoreCalculate();
	      var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	      var bannerDescriptionContent = document.getElementById("toolsRTEbanner_rte-edit-view").innerHTML;
	      var whatyoudoDescriptionContent = document.getElementById("toolsRTEwhatyoudo_rte-edit-view").innerHTML;
	      var outcomes = [];
	      var CareerTransition = "False";
	      var QuickUpskills = "False";
	      var Jobs = "False";
	      var CertificatesCheck = "False";
	
	      var careerTransitionScore = 0;
	      var quickUpskillsScore = 0;
	      var jobsScore = 0;
	      var certificatesScore = 0;
	
	      if ((0, _jquery2.default)("#CareerTransition:checked").val() != undefined) {
	        CareerTransition = "True";
	      }
	      if ((0, _jquery2.default)("#QuickUpskills:checked").val() != undefined) {
	        QuickUpskills = "True";
	      }
	      if ((0, _jquery2.default)("#Jobs:checked").val() != undefined) {
	        Jobs = "True";
	      }
	      if ((0, _jquery2.default)("#CertificatesCheck:checked").val() != undefined) {
	        CertificatesCheck = "True";
	      }
	
	      if ((0, _jquery2.default)("#careerTransitionScore").val() != "") {
	        careerTransitionScore = (0, _jquery2.default)("#careerTransitionScore").val();
	      }
	      if ((0, _jquery2.default)("#quickUpskillsScore").val() != "") {
	        quickUpskillsScore = (0, _jquery2.default)("#quickUpskillsScore").val();
	      }
	      if ((0, _jquery2.default)("#jobsScore").val() != "") {
	        jobsScore = (0, _jquery2.default)("#jobsScore").val();
	      }
	      if ((0, _jquery2.default)("#certificatesScore").val() != "") {
	        certificatesScore = (0, _jquery2.default)("#certificatesScore").val();
	      }
	
	      outcomes.push({
	        CareerTransition: CareerTransition,
	        QuickUpskills: QuickUpskills,
	        Jobs: Jobs,
	        Certificates: CertificatesCheck
	      });
	      outcomes.push({
	        CareerTransitionScore: careerTransitionScore,
	        QuickUpskillsScore: quickUpskillsScore,
	        JobsScore: jobsScore,
	        CertificatesScore: certificatesScore
	      });
	      var item = {
	        CourseName: (0, _jquery2.default)("#CourseName").val(),
	        expertise: (0, _jquery2.default)("#expertise").val(),
	        imageUrl: url ? url : _this.state.courseImage,
	        createdAt: newDate,
	        bannerDetails: [{
	          title: _this.state.bannerTitle,
	          description: bannerDescriptionContent
	        }],
	        whatyoudo_Description: whatyoudoDescriptionContent,
	        whatyoudo_rightModel: [{
	          rightModelTitle: _this.state.rightModelTitle,
	          modelData: _this.state.modelRight
	        }],
	        WhatYouWillLearn: _this.state.WhatYouWillLearnArray,
	        WhatYouWillGet: _this.state.WhatYouWillGetArray,
	        Howdoesitwork: _this.state.HowdoesitworkArray,
	        PlatformsToolsFiles: _this.state.PlatformsToolsFiles,
	        CertificationsFiles: _this.state.CertificationsFiles,
	        universityName: (0, _jquery2.default)("#universityName").val(),
	        courseDescription: (0, _jquery2.default)("#courseDescription").val(),
	        Websitelink: _this.state.Websitelink,
	        Accrediation: _this.state.Accrediation,
	        Accredtionscore: _this.state.Accredtionscore,
	        Modeoflearning: (0, _jquery2.default)("#Modeoflearning").val(),
	        Country: (0, _jquery2.default)("#Country").val(),
	        Level: _this.state.Level,
	        Courserating: _this.state.Courserating,
	        Language: _this.state.Language,
	        skills: _this.state.skillArray,
	
	        CourseFields: [{
	          CourseScore: _this.state.CourseScore,
	          LengthandBreadth: (0, _jquery2.default)("#LengthandBreadth").val() == "" ? 0 : (0, _jquery2.default)("#LengthandBreadth").val(),
	          RelevantCaseStudies: (0, _jquery2.default)("#RelevantCaseStudies").val() == "" ? 0 : (0, _jquery2.default)("#RelevantCaseStudies").val(),
	          ToolsCovered: (0, _jquery2.default)("#ToolsCovered").val() == "" ? 0 : (0, _jquery2.default)("#ToolsCovered").val(),
	          CapstoneProjectCovered: (0, _jquery2.default)("#CapstoneProjectCovered").val() == "" ? 0 : (0, _jquery2.default)("#CapstoneProjectCovered").val(),
	
	          TrainerExperience: (0, _jquery2.default)("#TrainerExperience").val() == "" ? 0 : (0, _jquery2.default)("#TrainerExperience").val(),
	          TrainerEducation: (0, _jquery2.default)("#TrainerEducation").val() == "" ? 0 : (0, _jquery2.default)("#TrainerEducation").val(),
	          TeachingStyle: (0, _jquery2.default)("#TeachingStyle").val() == "" ? 0 : (0, _jquery2.default)("#TeachingStyle").val(),
	
	          Ranking: (0, _jquery2.default)("#Ranking").val() == "" ? 0 : (0, _jquery2.default)("#Ranking").val(),
	          GovtBodies: (0, _jquery2.default)("#GovtBodies").val() == "" ? 0 : (0, _jquery2.default)("#GovtBodies").val(),
	          ProfessionalBodies: (0, _jquery2.default)("#ProfessionalBodies").val() == "" ? 0 : (0, _jquery2.default)("#ProfessionalBodies").val(),
	
	          Mentorship: (0, _jquery2.default)("#Mentorship").val() == "" ? 0 : (0, _jquery2.default)("#Mentorship").val(),
	          CareerCoach: (0, _jquery2.default)("#CareerCoach").val() == "" ? 0 : (0, _jquery2.default)("#CareerCoach").val(),
	          Liveclasses: (0, _jquery2.default)("#Liveclasses").val() == "" ? 0 : (0, _jquery2.default)("#Liveclasses").val(),
	          QuickUpskilling: (0, _jquery2.default)("#QuickUpskilling").val() == "" ? 0 : (0, _jquery2.default)("#QuickUpskilling").val(),
	          ActiveLearning: (0, _jquery2.default)("#ActiveLearning").val() == "" ? 0 : (0, _jquery2.default)("#ActiveLearning").val(),
	          JobAssistance: (0, _jquery2.default)("#JobAssistance").val() == "" ? 0 : (0, _jquery2.default)("#JobAssistance").val(),
	          StudyMaterials: (0, _jquery2.default)("#StudyMaterials").val() == "" ? 0 : (0, _jquery2.default)("#StudyMaterials").val()
	        }],
	        outcomes: outcomes
	        //courseDetails:[{universityName:$("#universityName").val(),
	        //courseDescription:$("#courseDescription").val(),shortDescription:this.state.courseDetails}]
	      };
	      console.log(item);
	      _firebase.courseRef.push(item).then(function () {
	        alert("Saved Successfully");
	        window.location.href = "/career-tracks";
	      }).catch(function () {
	        alert("Somthing went wrong");
	      });
	    };
	
	    _this.courseDetailsIconAdd = function () {
	      if (_this.state.iconCourseFlag === true) {
	        var uploadTask = _firebase.storage.ref("Course/" + _this.state.iconCourseName.name).put(_this.state.iconCourseName);
	        uploadTask.on("state_changed", function (snapshot) {
	          var progress = Math.round(snapshot.bytesTransferred / snapshot.totalBytes * 100);
	          _this.setState({
	            progress: progress
	          });
	        }, function (error) {
	          console.log(error);
	        }, function () {
	          _firebase.storage.ref("Course").child(_this.state.iconCourseName.name).getDownloadURL().then(function (url) {
	            console.log("url...", url);
	            (0, _jquery2.default)("#imageUrl").attr("src", url);
	            var newArrays = _this.state.courseDetails;
	
	            newArrays.push({
	              url: url,
	              shortDescription: (0, _jquery2.default)("#shortDescription").val()
	            });
	            _this.setState({
	              courseDetails: newArrays,
	              iconCourseFlag: false,
	              iconCourseName: null
	            });
	            (0, _jquery2.default)("#shortDescription").val("");
	          });
	        });
	      }
	    };
	
	    _this.PlatformsToolsAdd = function () {
	      if (_this.state.PlatformsToolsFileNameFlag === true) {
	        var uploadTask = _firebase.storage.ref("Course/" + _this.state.PlatformsToolsFileName.name).put(_this.state.PlatformsToolsFileName);
	        uploadTask.on("state_changed", function (snapshot) {
	          var progress = Math.round(snapshot.bytesTransferred / snapshot.totalBytes * 100);
	          _this.setState({
	            progress: progress
	          });
	        }, function (error) {
	          console.log(error);
	        }, function () {
	          _firebase.storage.ref("Course").child(_this.state.PlatformsToolsFileName.name).getDownloadURL().then(function (url) {
	            console.log("url...", url);
	            (0, _jquery2.default)("#imageUrl").attr("src", url);
	            var newArray = _this.state.PlatformsToolsFiles;
	            newArray.push({ url: url });
	            _this.setState({
	              PlatformsToolsFiles: newArray,
	              PlatformsToolsFileNameFlag: false,
	              PlatformsToolsFileName: null
	            });
	          });
	        });
	      }
	    };
	
	    _this.CertificationsAdd = function () {
	      if (_this.state.CertificationsFileNameFlag === true) {
	        var uploadTask = _firebase.storage.ref("Course/" + _this.state.CertificationsFileName.name).put(_this.state.CertificationsFileName);
	        uploadTask.on("state_changed", function (snapshot) {
	          var progress = Math.round(snapshot.bytesTransferred / snapshot.totalBytes * 100);
	          _this.setState({
	            progress: progress
	          });
	        }, function (error) {
	          console.log(error);
	        }, function () {
	          _firebase.storage.ref("Course").child(_this.state.CertificationsFileName.name).getDownloadURL().then(function (url) {
	            console.log("url...", url);
	            (0, _jquery2.default)("#imageUrl").attr("src", url);
	            var newArrays = _this.state.CertificationsFiles;
	            newArrays.push({ url: url });
	            _this.setState({
	              CertificationsFiles: newArrays,
	              CertificationsFileNameFlag: false,
	              CertificationsFileName: null
	            });
	          });
	        });
	      }
	    };
	
	    _this.state = {
	      CourseName: "",
	      courseImage: null,
	      fileName: false,
	      progress: 0,
	      id: null,
	      // bannerFlag: false,
	      bannerTitle: "",
	      bannerDescription: "",
	      whatyoudo: false,
	      modelRight: [],
	      CourseFields: [],
	      CourseScore: "",
	      whatyoudo_Description: "",
	      rightModelTitle: "",
	      WhatYouWillLearn: false,
	      WhatYouWillLearnArray: [],
	      WhatYouWillGet: false,
	      WhatYouWillGetArray: [],
	      Howdoesitwork: false,
	      HowdoesitworkArray: [],
	      PlatformsToolsFiles: [],
	      PlatformsToolsFileNameFlag: false,
	      PlatformsToolsFileName: null,
	      CertificationsFiles: [],
	
	      courseDetails: [],
	      CertificationsFileNameFlag: false,
	      CertificationsFileName: null,
	      iconCourseFlag: false,
	      iconCourseName: null,
	
	      Websitelink: "",
	      Accrediation: "",
	      Accredtionscore: "",
	      Modeoflearning: "",
	      Level: "",
	      Courserating: "",
	      Language: "",
	      skillsObj: [],
	      skillArray: [],
	      LengthandBreadth: "",
	      RelevantCaseStudies: "",
	      ToolsCovered: "",
	      CapstoneProjectCovered: "",
	
	      TrainerExperience: "",
	      TrainerEducation: "",
	      TeachingStyle: "",
	
	      Ranking: "",
	      GovtBodies: "",
	      ProfessionalBodies: "",
	
	      Mentorship: "",
	      CareerCoach: "",
	      Liveclasses: "",
	      QuickUpskilling: "",
	      ActiveLearning: "",
	      JobAssistance: "",
	      StudyMaterials: "",
	      expertiseDataList: [],
	      modeoflearning: [],
	      institution: [],
	      country: []
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleImageChange = _this.handleImageChange.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.updateValidateSubmission = _this.updateValidateSubmission.bind(_this);
	    _this.handleChangePlatformsToolsFile = _this.handleChangePlatformsToolsFile.bind(_this);
	    _this.handleChangeCertifications = _this.handleChangeCertifications.bind(_this);
	    _this.handleChangeiconCourse = _this.handleChangeiconCourse.bind(_this);
	    _this.handleNumberChange = _this.handleNumberChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(NewInsights, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // const url = new URL(window.location.href);
	      //const searchParams3 = new URLSearchParams(url.search);
	      var url_path = window.location.href.split("=");
	      var keyId = url_path[1];
	      this.renderList(keyId);
	      this.getSkills();
	    }
	  }, {
	    key: "getSkills",
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var dataList;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                dataList = [];
	                _context.next = 3;
	                return _firebase.database.ref("skills").once("value", function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    if (ChildSnapshot.val().status == 'Active') {
	                      dataList.push({
	                        key: ChildSnapshot.key,
	                        skills: ChildSnapshot.val().skill
	                      });
	                    }
	                  });
	                });
	
	              case 3:
	
	                this.setState({ skillsObj: dataList });
	
	              case 4:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function getSkills() {
	        return _ref.apply(this, arguments);
	      }
	
	      return getSkills;
	    }()
	  }, {
	    key: "renderList",
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(keyId) {
	        var id, ref, userRef, valueRef, snapshot, val;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                //let dataList = []
	                this.experienceList();
	                this.modeoflearningList();
	                this.institutionList();
	                this.countryList();
	                id = keyId;
	                ref = id ? "/Course/" + id : "Course";
	                userRef = _firebase.database.ref(ref);
	
	                if (!id) {
	                  _context2.next = 11;
	                  break;
	                }
	
	                _context2.t0 = userRef;
	                _context2.next = 14;
	                break;
	
	              case 11:
	                _context2.next = 13;
	                return userRef.orderByChild("key").equalTo("value");
	
	              case 13:
	                _context2.t0 = _context2.sent;
	
	              case 14:
	                valueRef = _context2.t0;
	                _context2.next = 17;
	                return valueRef.once("value");
	
	              case 17:
	                snapshot = _context2.sent;
	                val = snapshot.val();
	
	                console.log();
	                if (val) {
	                  (0, _jquery2.default)("#CourseName").val(val.CourseName);
	                  (0, _jquery2.default)("#bannerTitle").val(val.bannerDetails[0].title);
	                  //$("#bannerDescription").val(val.bannerDetails[0].description)
	                  document.getElementById("toolsRTEbanner_rte-edit-view").innerHTML = val.bannerDetails[0].description;
	                  (0, _jquery2.default)("#toolsRTEbanner-value").val(val.bannerDetails[0].description);
	                  (0, _jquery2.default)("#whatyoudo_Description").val(val.whatyoudo_Description);
	                  (0, _jquery2.default)("#rightModelTitle").val(val.whatyoudo_rightModel[0].rightModelTitle);
	                  //alert(val.expertise);
	                  (0, _jquery2.default)("#universityName").val(val.universityName);
	                  (0, _jquery2.default)("#courseDescription").val(val.courseDescription);
	                  (0, _jquery2.default)("#expertise").val(val.expertise);
	                  (0, _jquery2.default)("#Websitelink").val(val.Websitelink);
	                  (0, _jquery2.default)("#Accrediation").val(val.Accrediation);
	                  (0, _jquery2.default)("#Country").val(val.Country);
	                  (0, _jquery2.default)("#Accredtionscore").val(val.Accredtionscore);
	                  (0, _jquery2.default)("#Modeoflearning").val(val.Modeoflearning);
	                  (0, _jquery2.default)("#Level").val(val.Level);
	                  (0, _jquery2.default)("#Courserating").val(val.Courserating);
	                  (0, _jquery2.default)("#Language").val(val.Language);
	                  if (val.CourseFields) {
	                    (0, _jquery2.default)("#LengthandBreadth").val(val.CourseFields[0].LengthandBreadth);
	                    (0, _jquery2.default)("#RelevantCaseStudies").val(val.CourseFields[0].RelevantCaseStudies);
	                    (0, _jquery2.default)("#ToolsCovered").val(val.CourseFields[0].ToolsCovered);
	                    (0, _jquery2.default)("#CapstoneProjectCovered").val(val.CourseFields[0].CapstoneProjectCovered);
	
	                    (0, _jquery2.default)("#TrainerExperience").val(val.CourseFields[0].TrainerExperience);
	                    (0, _jquery2.default)("#TrainerEducation").val(val.CourseFields[0].TrainerEducation);
	                    (0, _jquery2.default)("#TeachingStyle").val(val.CourseFields[0].TeachingStyle);
	
	                    (0, _jquery2.default)("#Ranking").val(val.CourseFields[0].Ranking);
	                    (0, _jquery2.default)("#GovtBodies").val(val.CourseFields[0].GovtBodies);
	                    (0, _jquery2.default)("#ProfessionalBodies").val(val.CourseFields[0].ProfessionalBodies);
	
	                    (0, _jquery2.default)("#Mentorship").val(val.CourseFields[0].Mentorship);
	                    (0, _jquery2.default)("#CareerCoach").val(val.CourseFields[0].CareerCoach);
	                    (0, _jquery2.default)("#Liveclasses").val(val.CourseFields[0].Liveclasses);
	                    (0, _jquery2.default)("#QuickUpskilling").val(val.CourseFields[0].QuickUpskilling);
	                    (0, _jquery2.default)("#ActiveLearning").val(val.CourseFields[0].ActiveLearning);
	                    (0, _jquery2.default)("#JobAssistance").val(val.CourseFields[0].JobAssistance);
	                    (0, _jquery2.default)("#StudyMaterials").val(val.CourseFields[0].StudyMaterials);
	
	                    if (val.outcomes[0].CareerTransition === "True") {
	                      (0, _jquery2.default)("#CareerTransition").prop("checked", true);
	                    }
	                    if (val.outcomes[0].QuickUpskills === "True") {
	                      (0, _jquery2.default)("#QuickUpskills").prop("checked", true);
	                    }
	                    if (val.outcomes[0].Jobs === "True") {
	                      (0, _jquery2.default)("#Jobs").prop("checked", true);
	                    }
	                    if (val.outcomes[0].Certificates === "True") {
	                      (0, _jquery2.default)("#CertificatesCheck").prop("checked", true);
	                    }
	                    if (val.outcomes.length == 2) {
	                      if (val.outcomes[1].CareerTransitionScore) {
	                        (0, _jquery2.default)("#careerTransitionScore").val(val.outcomes[1].CareerTransitionScore);
	                      }
	                      if (val.outcomes[1].QuickUpskillsScore) {
	                        (0, _jquery2.default)("#quickUpskillsScore").val(val.outcomes[1].QuickUpskillsScore);
	                      }
	                      if (val.outcomes[1].JobsScore) {
	                        (0, _jquery2.default)("#jobsScore").val(val.outcomes[1].JobsScore);
	                      }
	                      if (val.outcomes[1].CertificatesScore) {
	                        (0, _jquery2.default)("#certificatesScore").val(val.outcomes[1].CertificatesScore);
	                      }
	                    }
	                  }
	                  this.setState({
	                    modelRight: val.whatyoudo_rightModel[0].modelData ? val.whatyoudo_rightModel[0].modelData : []
	                  });
	
	                  this.setState({
	                    CourseUrl: val.imageUrl ? val.imageUrl : null,
	                    courseImage: val.imageUrl ? val.imageUrl : null,
	                    id: id
	                  });
	                  this.setState({
	                    CourseUrl: val.imageUrl ? val.imageUrl : null,
	                    courseImage: val.imageUrl ? val.imageUrl : null,
	                    id: id,
	                    CourseName: (0, _jquery2.default)("#CourseName").val(),
	                    bannerTitle: val.bannerDetails[0].title,
	                    bannerDescription: val.bannerDetails[0].description,
	                    whatyoudo_Description: val.whatyoudo_Description,
	                    rightModelTitle: val.whatyoudo_rightModel[0].rightModelTitle,
	                    //  modelRight: val.whatyoudo_rightModel[0].modelData,
	                    WhatYouWillLearnArray: val.WhatYouWillLearn ? val.WhatYouWillLearn : [],
	                    WhatYouWillGetArray: val.WhatYouWillGet ? val.WhatYouWillGet : [],
	                    HowdoesitworkArray: val.Howdoesitwork ? val.HowdoesitworkArray : [],
	                    PlatformsToolsFiles: val.PlatformsToolsFiles ? val.PlatformsToolsFiles : [],
	                    CertificationsFiles: val.CertificationsFiles ? val.CertificationsFiles : [],
	
	                    Websitelink: val.Websitelink,
	                    Accrediation: val.Accrediation,
	                    Accredtionscore: val.Accredtionscore,
	                    Modeoflearning: val.Modeoflearning,
	                    Level: val.Level,
	                    Courserating: val.Courserating,
	                    Language: val.Language,
	                    skillArray: val.skills ? val.skills : [],
	                    CourseScore: val.CourseFields[0].CourseScore
	                    //courseDetails:val.courseDetails[0].shortDescription
	                  });
	                }
	
	              case 21:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function renderList(_x) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return renderList;
	    }()
	  }, {
	    key: "whatyoudo",
	
	
	    // addBannerDetails() {
	
	    //     if (this.state.bannerFlag == true) {
	    //         $("#bannerDetails").hide();
	    //         this.setState({ bannerFlag: false })
	    //     }
	    //     else {
	    //         $("#bannerDetails").show();
	    //         this.setState({ bannerFlag: true })
	    //     }
	    // }
	    value: function whatyoudo() {
	      if (this.state.whatyoudo == true) {
	        (0, _jquery2.default)("#whatyoudo").hide();
	        this.setState({ whatyoudo: false });
	      } else {
	        (0, _jquery2.default)("#whatyoudo").show();
	        this.setState({ whatyoudo: true });
	      }
	    }
	  }, {
	    key: "whatyoudoRight",
	    value: function whatyoudoRight() {
	      var modelRight = this.state.modelRight;
	      modelRight.push({
	        date: (0, _jquery2.default)("#modelDate").val(),
	        price: (0, _jquery2.default)("#modelPrice").val(),
	        duration: (0, _jquery2.default)("#modelDuration").val()
	      });
	      this.setState({ modelRight: modelRight });
	      (0, _jquery2.default)("#modelDate").val("");
	      (0, _jquery2.default)("#modelPrice").val("");
	      (0, _jquery2.default)("#modelDuration").val("");
	    }
	  }, {
	    key: "courseDetailsAdd",
	    value: function courseDetailsAdd() {
	      // var courseDetails=this.state.courseDetails;
	      // courseDetails.push({ shortIcon: $("#modelDate").val(), shortDescription: $("#shortDescription").val()})
	      //  this.setState({ courseDetails: courseDetails });
	      (0, _jquery2.default)("#iconCourse").val("");
	      (0, _jquery2.default)("#courseDetails").val("");
	    }
	  }, {
	    key: "WhatYouWillLearnAdd",
	    value: function WhatYouWillLearnAdd() {
	      var WhatYouWillLearnArray = this.state.WhatYouWillLearnArray;
	      WhatYouWillLearnArray.push({
	        title: (0, _jquery2.default)("#WhatYouWillLearnTitle").val(),
	        description: document.getElementById("toolsRTEWhatYouWillLearn_rte-edit-view").innerHTML
	      });
	      this.setState({ WhatYouWillLearnArray: WhatYouWillLearnArray });
	      (0, _jquery2.default)("#WhatYouWillLearnTitle").val("");
	      (0, _jquery2.default)("#WhatYouWillLearnDescription").val("");
	    }
	  }, {
	    key: "HowdoesitworkAdd",
	    value: function HowdoesitworkAdd() {
	      var HowdoesitworkArray = this.state.HowdoesitworkArray;
	      HowdoesitworkArray.push({
	        title: (0, _jquery2.default)("#HowdoesitworkTitle").val(),
	        description: document.getElementById("toolsRTEHowdoesitwork_rte-edit-view").innerHTML
	      });
	      this.setState({ HowdoesitworkArray: HowdoesitworkArray });
	      (0, _jquery2.default)("#HowdoesitworkTitle").val("");
	      (0, _jquery2.default)("#HowdoesitworkDescription").val("");
	    }
	  }, {
	    key: "skillAdd",
	    value: function skillAdd() {
	      if ((0, _jquery2.default)("#skilsName").val() === "") {
	        alert("please select skill");
	      } else {
	        var skillRating = 0;
	        if ((0, _jquery2.default)("#skillRating").val() != "") {
	          skillRating = (0, _jquery2.default)("#skillRating").val();
	        }
	        var skillArray = this.state.skillArray;
	        skillArray.push({ skill: (0, _jquery2.default)("#skilsName").val(), skillRating: skillRating });
	        this.setState({ skillArray: skillArray });
	        (0, _jquery2.default)("#skilsName").val("");
	        (0, _jquery2.default)("#skillRating").val("");
	      }
	    }
	  }, {
	    key: "WhatYouWillGetAdd",
	    value: function WhatYouWillGetAdd() {
	      var WhatYouWillGetArray = this.state.WhatYouWillGetArray;
	      WhatYouWillGetArray.push({ title: (0, _jquery2.default)("#WhatYouWillGetTitle").val() });
	      this.setState({ WhatYouWillGetArray: WhatYouWillGetArray });
	      (0, _jquery2.default)("#WhatYouWillGetTitle").val("");
	    }
	  }, {
	    key: "WhatYouWillLearn",
	    value: function WhatYouWillLearn() {
	      if (this.state.WhatYouWillLearn == true) {
	        (0, _jquery2.default)("#WhatYouWillLearn").hide();
	        this.setState({ WhatYouWillLearn: false });
	      } else {
	        (0, _jquery2.default)("#WhatYouWillLearn").hide();
	        this.setState({ WhatYouWillLearn: false });
	      }
	    }
	  }, {
	    key: "WhatYouWillGet",
	    value: function WhatYouWillGet() {
	      if (this.state.WhatYouWillGet == true) {
	        (0, _jquery2.default)("#WhatYouWillGet").hide();
	        this.setState({ WhatYouWillGet: false });
	      } else {
	        (0, _jquery2.default)("#WhatYouWillGet").hide();
	        this.setState({ WhatYouWillGet: false });
	      }
	    }
	  }, {
	    key: "Howdoesitwork",
	    value: function Howdoesitwork() {
	      if (this.state.Howdoesitwork == true) {
	        (0, _jquery2.default)("#Howdoesitwork").hide();
	        this.setState({ Howdoesitwork: false });
	      } else {
	        (0, _jquery2.default)("#Howdoesitwork").hide();
	        this.setState({ Howdoesitwork: false });
	      }
	    }
	  }, {
	    key: "PlatformsTools",
	    value: function PlatformsTools() {
	      if (this.state.PlatformsTools == true) {
	        (0, _jquery2.default)("#PlatformsTools").hide();
	        this.setState({ PlatformsTools: false });
	      } else {
	        (0, _jquery2.default)("#PlatformsTools").hide();
	        this.setState({ PlatformsTools: false });
	      }
	    }
	  }, {
	    key: "Certifications",
	    value: function Certifications() {
	      if (this.state.Certifications == true) {
	        (0, _jquery2.default)("#Certifications").hide();
	        this.setState({ Certifications: false });
	      } else {
	        (0, _jquery2.default)("#Certifications").hide();
	        this.setState({ Certifications: false });
	      }
	    }
	  }, {
	    key: "modelRightRemove",
	    value: function modelRightRemove(a, b, c) {
	      var modelRight = this.state.modelRight;
	      var newArray = [];
	      modelRight.map(function (data, i) {
	        if (data.date !== a && data.price !== b && data.duration !== c) {
	          newArray.push({
	            date: data.date,
	            price: data.price,
	            duration: data.duration
	          });
	        }
	      });
	      this.setState({ modelRight: newArray });
	    }
	  }, {
	    key: "WhatYouWillLearnArrayRemove",
	    value: function WhatYouWillLearnArrayRemove(a, b) {
	      var WhatYouWillLearnArray = this.state.WhatYouWillLearnArray;
	      var newArray = [];
	      WhatYouWillLearnArray.map(function (data, i) {
	        if (data.title !== a && data.description !== b) {
	          newArray.push({ title: data.title, description: data.description });
	        }
	      });
	      this.setState({ WhatYouWillLearnArray: newArray });
	    }
	  }, {
	    key: "PlatformsToolsRemove",
	    value: function PlatformsToolsRemove(a) {
	      var PlatformsToolsFiles = this.state.PlatformsToolsFiles;
	      var newArray = [];
	      PlatformsToolsFiles.map(function (data, i) {
	        if (data.url !== a) {
	          newArray.push({ url: data.url });
	        }
	      });
	      this.setState({ PlatformsToolsFiles: newArray });
	    }
	  }, {
	    key: "CertificationsRemove",
	    value: function CertificationsRemove(a) {
	      var CertificationsFiles = this.state.CertificationsFiles;
	      var newArray = [];
	      CertificationsFiles.map(function (data, i) {
	        if (data.url !== a) {
	          newArray.push({ url: data.url });
	        }
	      });
	      this.setState({ CertificationsFiles: newArray });
	    }
	  }, {
	    key: "courseDetailsRemove",
	    value: function courseDetailsRemove(a) {
	      var courseDetails = this.state.courseDetails;
	      var newArray = [];
	      courseDetails.map(function (data, i) {
	        if (data.url !== a) {
	          newArray.push({
	            url: data.url,
	            shortDescription: data.shortDescription
	          });
	        }
	      });
	      this.setState({ courseDetails: newArray });
	    }
	  }, {
	    key: "HowdoesitworkArrayRemove",
	    value: function HowdoesitworkArrayRemove(a, b) {
	      var HowdoesitworkArray = this.state.HowdoesitworkArray;
	      var newArray = [];
	      HowdoesitworkArray.map(function (data, i) {
	        if (data.title !== a && data.description !== b) {
	          newArray.push({ title: data.title, description: data.description });
	        }
	      });
	      this.setState({ HowdoesitworkArray: newArray });
	    }
	  }, {
	    key: "WhatYouWillGetRemove",
	    value: function WhatYouWillGetRemove(a) {
	      var WhatYouWillGetArray = this.state.WhatYouWillGetArray;
	      var newArray = [];
	      WhatYouWillGetArray.map(function (data, i) {
	        if (data.title !== a) {
	          newArray.push({ title: data.title });
	        }
	      });
	      this.setState({ WhatYouWillGetArray: newArray });
	    }
	  }, {
	    key: "skillRemove",
	    value: function skillRemove(a) {
	      var skillArray = this.state.skillArray;
	      var newArray = [];
	      skillArray.map(function (data, i) {
	        if (data.skill !== a) {
	          if (data.skillRating == "" || data.skillRating == undefined) {
	            data.skillRating = 0;
	          }
	          newArray.push({ skill: data.skill, skillRating: data.skillRating });
	        }
	      });
	      this.setState({ skillArray: newArray });
	    }
	  }, {
	    key: "scoreCalculate",
	    value: function scoreCalculate() {
	      var LengthandBreadth = (0, _jquery2.default)("#LengthandBreadth").val();
	      var RelevantCaseStudies = (0, _jquery2.default)("#RelevantCaseStudies").val();
	      var ToolsCovered = (0, _jquery2.default)("#ToolsCovered").val();
	      var CapstoneProjectCovered = (0, _jquery2.default)("#CapstoneProjectCovered").val();
	      LengthandBreadth = LengthandBreadth == "" ? 0 : parseFloat(LengthandBreadth);
	      RelevantCaseStudies = RelevantCaseStudies == "" ? 0 : parseFloat(RelevantCaseStudies);
	      ToolsCovered = ToolsCovered == "" ? 0 : parseFloat(ToolsCovered);
	      CapstoneProjectCovered = CapstoneProjectCovered == "" ? 0 : parseFloat(CapstoneProjectCovered);
	      var total1 = (LengthandBreadth + RelevantCaseStudies + ToolsCovered + CapstoneProjectCovered) * 100 / 40;
	
	      total1 = total1 * 25 / 100;
	      //-----------------------------------------------------------------
	      var TrainerExperience = (0, _jquery2.default)("#TrainerExperience").val() == "" ? 0 : parseFloat((0, _jquery2.default)("#TrainerExperience").val());
	      var TrainerEducation = (0, _jquery2.default)("#TrainerEducation").val() == "" ? 0 : parseFloat((0, _jquery2.default)("#TrainerEducation").val());
	      var TeachingStyle = (0, _jquery2.default)("#TeachingStyle").val() == "" ? 0 : parseFloat((0, _jquery2.default)("#TeachingStyle").val());
	      var total2 = (TrainerExperience + TrainerEducation + TeachingStyle) * 100 / 30;
	
	      total2 = total2 * 25 / 100;
	      //-------------------------------------------------------------------------
	      var Ranking = (0, _jquery2.default)("#Ranking").val() == "" ? 0 : parseFloat((0, _jquery2.default)("#Ranking").val());
	      var GovtBodies = (0, _jquery2.default)("#GovtBodies").val() == "" ? 0 : parseFloat((0, _jquery2.default)("#GovtBodies").val());
	      var ProfessionalBodies = (0, _jquery2.default)("#ProfessionalBodies").val() == "" ? 0 : parseFloat((0, _jquery2.default)("#ProfessionalBodies").val());
	      var total3 = Ranking
	      // +GovtBodies + ProfessionalBodies
	      * 100 / 10;
	      total3 = total3 * 20 / 100;
	      //-------------------------------------------------------------------------
	      var Mentorship = (0, _jquery2.default)("#Mentorship").val() == "" ? 0 : parseFloat((0, _jquery2.default)("#Mentorship").val());
	      var CareerCoach = (0, _jquery2.default)("#CareerCoach").val() == "" ? 0 : parseFloat((0, _jquery2.default)("#CareerCoach").val());
	      var Liveclasses = (0, _jquery2.default)("#Liveclasses").val() == "" ? 0 : parseFloat((0, _jquery2.default)("#Liveclasses").val());
	      var QuickUpskilling = (0, _jquery2.default)("#QuickUpskilling").val() == "" ? 0 : parseFloat((0, _jquery2.default)("#QuickUpskilling").val());
	      var ActiveLearning = (0, _jquery2.default)("#ActiveLearning").val() == "" ? 0 : parseFloat((0, _jquery2.default)("#ActiveLearning").val());
	      var JobAssistance = (0, _jquery2.default)("#JobAssistance").val() == "" ? 0 : parseFloat((0, _jquery2.default)("#JobAssistance").val());
	      var StudyMaterials = (0, _jquery2.default)("#StudyMaterials").val() == "" ? 0 : parseFloat((0, _jquery2.default)("#StudyMaterials").val());
	      var total4 = (
	      // Mentorship +
	      // CareerCoach +
	      // Liveclasses +
	      QuickUpskilling + ActiveLearning + JobAssistance + StudyMaterials) * 100 / 40;
	      total4 = total4 * 30 / 100;
	
	      var finalTotal = total1 + total2 + total3 + total4;
	      finalTotal = finalTotal.toFixed(2);
	
	      (0, _jquery2.default)("#scoreValue").html(finalTotal + " %");
	      this.setState({ CourseScore: finalTotal });
	    }
	  }, {
	    key: "experienceList",
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var dataList;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                dataList = [];
	                _context3.next = 3;
	                return _firebase.database.ref("expertise").once("value", function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    dataList.push({
	                      key: ChildSnapshot.key,
	                      expertise: ChildSnapshot.val().expertise,
	                      expertiseStatus: ChildSnapshot.val().status
	                    });
	                  });
	                });
	
	              case 3:
	                this.setState({
	                  expertiseDataList: dataList
	                });
	
	              case 4:
	              case "end":
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function experienceList() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return experienceList;
	    }()
	  }, {
	    key: "modeoflearningList",
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var dataList;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                dataList = [];
	                _context4.next = 3;
	                return _firebase.database.ref("modeOfLearning").once("value", function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    if (ChildSnapshot.val().status == 'Active') {
	                      dataList.push({
	                        key: ChildSnapshot.key,
	                        modeOfLearning: ChildSnapshot.val().modeOfLearning,
	                        modeOfLearningStatus: ChildSnapshot.val().status,
	                        internalId: ChildSnapshot.val().internalId
	                      });
	                    }
	                  });
	                });
	
	              case 3:
	                this.setState({
	                  modeoflearning: dataList
	                });
	
	              case 4:
	              case "end":
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function modeoflearningList() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return modeoflearningList;
	    }()
	  }, {
	    key: "institutionList",
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        var dataList;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                dataList = [];
	                _context5.next = 3;
	                return _firebase.database.ref("institution").once("value", function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    if (ChildSnapshot.val().status == 'Active') {
	                      dataList.push({
	                        key: ChildSnapshot.key,
	                        institution: ChildSnapshot.val().institution,
	                        modeOfLearningStatus: ChildSnapshot.val().status,
	                        internalId: ChildSnapshot.val().internalId
	                      });
	                    }
	                  });
	                });
	
	              case 3:
	                this.setState({
	                  institution: dataList
	                });
	
	              case 4:
	              case "end":
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function institutionList() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return institutionList;
	    }()
	  }, {
	    key: "countryList",
	    value: function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	        var countryList;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                countryList = [];
	                _context6.next = 3;
	                return _firebase.database.ref("country").once('value', function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    if (ChildSnapshot.val().status == 'Active') {
	                      countryList.push({
	                        key: ChildSnapshot.key,
	                        country: ChildSnapshot.val().country
	                      });
	                    }
	                  });
	                });
	
	              case 3:
	                this.setState({
	                  country: countryList
	                });
	
	              case 4:
	              case "end":
	                return _context6.stop();
	            }
	          }
	        }, _callee6, this);
	      }));
	
	      function countryList() {
	        return _ref6.apply(this, arguments);
	      }
	
	      return countryList;
	    }()
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content" },
	          _react2.default.createElement(_doctorLeftmenu2.default, null),
	          _react2.default.createElement(
	            "div",
	            { className: "content-right-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "form",
	                { className: "form-wrapper" },
	                _react2.default.createElement(
	                  "ul",
	                  { className: "breadcrumb" },
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                      "a",
	                      { href: "/dashboard" },
	                      "Dashboard"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                      "a",
	                      { href: "/career-tracks" },
	                      "Career Tracks List"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Career Tracks"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-head" },
	                  "Courses"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group" },
	                  _react2.default.createElement(
	                    "label",
	                    { "for": "insightTitle" },
	                    "Expertise"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      id: "expertise",
	                      name: "expertise",
	                      className: "form-control"
	                    },
	                    this.state.expertiseDataList.map(function (data, i) {
	                      return _react2.default.createElement(
	                        "option",
	                        { value: data.expertise },
	                        data.expertise
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group" },
	                  _react2.default.createElement(
	                    "label",
	                    { "for": "insightTitle" },
	                    "Course Name"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    className: "form-control",
	                    name: "CourseName",
	                    id: "CourseName",
	                    onChange: this.handleChange,
	                    defaultValue: this.state.CourseName
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group" },
	                  _react2.default.createElement(
	                    "label",
	                    { "for": "imageUrl" },
	                    "Image"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "file",
	                    onChange: this.handleImageChange,
	                    id: "imageUrl",
	                    name: "imageUrl",
	                    className: "form-control"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group" },
	                  _react2.default.createElement(
	                    "button",
	                    { type: "button", className: "btn btn-primary" },
	                    " ",
	                    "Banner"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group" },
	                  _react2.default.createElement(
	                    "label",
	                    { "for": "bannerTitle" },
	                    "Banner Title"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    className: "form-control",
	                    name: "bannerTitle",
	                    id: "bannerTitle",
	                    onChange: this.handleChange,
	                    defaultValue: this.state.bannerTitle
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group", style: { display: "none" } },
	                  _react2.default.createElement(
	                    "label",
	                    { "for": "bannerDescription" },
	                    "Banner Description"
	                  ),
	                  _react2.default.createElement(_newStoriesEditor2.default, {
	                    textEditorName: "banner",
	                    id: "bannerDescription",
	                    name: "bannerDescription",
	                    defaultValue: this.state.bannerDescription,
	                    onChange: this.handleChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group mt-4", style: { display: "none" } },
	                  _react2.default.createElement(
	                    "button",
	                    { type: "button", className: "btn btn-primary" },
	                    " ",
	                    "What you'll do"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { id: "whatyoudo" },
	                  _react2.default.createElement(
	                    "label",
	                    { "for": "bannerTitle" },
	                    "Course Details"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group", style: { display: "none" } },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "whatyoudo_Description" },
	                      " Description"
	                    ),
	                    _react2.default.createElement(_newStoriesEditor2.default, {
	                      textEditorName: "whatyoudo"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "" },
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "",
	                      name: "rightModelTitle", style: { display: "none" },
	                      id: "rightModelTitle",
	                      onChange: this.handleChange,
	                      placeholder: "Right Model Title"
	                    }),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      name: "modelDate",
	                      id: "modelDate",
	                      onChange: this.handleChange,
	                      placeholder: "Course Date",
	                      style: { width: "250px" }
	                    }),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      name: "modelPrice",
	                      id: "modelPrice",
	                      onChange: this.handleChange,
	                      style: { width: "250px", marginLeft: "270px", marginTop: "-34px" },
	                      placeholder: "Course Price"
	                    }),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      name: "modelDuration",
	                      id: "modelDuration",
	                      onChange: this.handleChange,
	                      style: { width: "250px", marginLeft: "542px", marginTop: "-34px" },
	                      placeholder: "Course Duration"
	                    }),
	                    _react2.default.createElement("input", {
	                      type: "button",
	                      value: "Add",
	                      onClick: function onClick() {
	                        return _this2.whatyoudoRight();
	                      },
	                      style: { marginTop: "10px" }
	                    }),
	                    console.log("hhhh", this.state.modelRight),
	                    this.state.modelRight.length > 0 && _react2.default.createElement(
	                      "table",
	                      {
	                        className: "table table-bordered",
	                        style: { marginTop: "10px" }
	                      },
	                      _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            "Date"
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            "Price"
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            "Duration"
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            "Action"
	                          )
	                        )
	                      ),
	                      " ",
	                      _react2.default.createElement(
	                        "tbody",
	                        null,
	                        this.state.modelRight.map(function (data, i) {
	                          return _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              data.date
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              data.price
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              data.duration
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              _react2.default.createElement("img", {
	                                src: _close2.default,
	                                alt: "",
	                                onClick: function onClick() {
	                                  return _this2.modelRightRemove(data.date, data.price, data.duration);
	                                }
	                              })
	                            )
	                          );
	                        })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group mt-4", style: { display: "none" } },
	                  _react2.default.createElement(
	                    "button",
	                    { type: "button", className: "btn btn-primary" },
	                    " ",
	                    "What You Will Learn"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { id: "WhatYouWillLearn", style: { display: "none" } },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "WhatYouWillLearnTitle" },
	                      "Title"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      name: "WhatYouWillLearnTitle",
	                      id: "WhatYouWillLearnTitle"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "WhatYouWillLearnDescription" },
	                      "Description"
	                    ),
	                    _react2.default.createElement(_newStoriesEditor2.default, {
	                      textEditorName: "WhatYouWillLearn"
	                    }),
	                    _react2.default.createElement("input", {
	                      type: "button",
	                      value: "Add",
	                      onClick: function onClick() {
	                        return _this2.WhatYouWillLearnAdd();
	                      },
	                      style: { marginTop: "10px" }
	                    })
	                  ),
	                  this.state.WhatYouWillLearnArray.length > 0 && _react2.default.createElement(
	                    "table",
	                    { className: "table table-bordered" },
	                    _react2.default.createElement(
	                      "thead",
	                      null,
	                      _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          "Title"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          "Description"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          "Delete"
	                        )
	                      )
	                    ),
	                    " ",
	                    _react2.default.createElement(
	                      "tbody",
	                      null,
	                      this.state.WhatYouWillLearnArray.map(function (data, i) {
	                        return _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            data.title
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            data.description
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            _react2.default.createElement("img", {
	                              src: _close2.default,
	                              alt: "",
	                              onClick: function onClick() {
	                                return _this2.WhatYouWillLearnArrayRemove(data.title, data.description);
	                              }
	                            })
	                          )
	                        );
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group mt-4", style: { display: "none" } },
	                  _react2.default.createElement(
	                    "button",
	                    { type: "button", className: "btn btn-primary" },
	                    "What You Will Get"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { id: "WhatYouWillGet", style: { display: "none" } },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "WhatYouWillGetTitle" },
	                      "Title"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      name: "WhatYouWillGetTitle",
	                      id: "WhatYouWillGetTitle"
	                    }),
	                    _react2.default.createElement("input", {
	                      type: "button",
	                      value: "Add",
	                      onClick: function onClick() {
	                        return _this2.WhatYouWillGetAdd();
	                      },
	                      style: { marginTop: "10px" }
	                    })
	                  ),
	                  this.state.WhatYouWillGetArray.length > 0 && _react2.default.createElement(
	                    "table",
	                    { className: "table table-bordered" },
	                    _react2.default.createElement(
	                      "thead",
	                      null,
	                      _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          "Title"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          "Delete"
	                        )
	                      )
	                    ),
	                    " ",
	                    _react2.default.createElement(
	                      "tbody",
	                      null,
	                      this.state.WhatYouWillGetArray.map(function (data, i) {
	                        return _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            data.title
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            _react2.default.createElement("img", {
	                              src: _close2.default,
	                              alt: "",
	                              onClick: function onClick() {
	                                return _this2.WhatYouWillGetRemove(data.title);
	                              }
	                            })
	                          )
	                        );
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group mt-4", style: { display: "none" } },
	                  _react2.default.createElement(
	                    "button",
	                    { type: "button", className: "btn btn-primary" },
	                    " ",
	                    "How does it work"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { id: "Howdoesitwork", style: { display: "none" } },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "HowdoesitworkTitle" },
	                      "Title"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      name: "HowdoesitworkTitle",
	                      id: "HowdoesitworkTitle"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "HowdoesitworkDescription" },
	                      "Description"
	                    ),
	                    _react2.default.createElement(_newStoriesEditor2.default, {
	                      textEditorName: "Howdoesitwork"
	                    }),
	                    _react2.default.createElement("input", {
	                      type: "button",
	                      value: "Add",
	                      onClick: function onClick() {
	                        return _this2.HowdoesitworkAdd();
	                      },
	                      style: { marginTop: "10px" }
	                    })
	                  ),
	                  this.state.HowdoesitworkArray.length > 0 && _react2.default.createElement(
	                    "table",
	                    { className: "table table-bordered" },
	                    _react2.default.createElement(
	                      "thead",
	                      null,
	                      _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          "Title"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          "Description"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          "Delete"
	                        )
	                      )
	                    ),
	                    " ",
	                    _react2.default.createElement(
	                      "tbody",
	                      null,
	                      this.state.HowdoesitworkArray.map(function (data, i) {
	                        return _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            data.title
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            data.description
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            _react2.default.createElement("img", {
	                              src: _close2.default,
	                              alt: "",
	                              onClick: function onClick() {
	                                return _this2.HowdoesitworkArrayRemove(data.title, data.description);
	                              }
	                            })
	                          )
	                        );
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group mt-4", style: { display: "none" } },
	                  _react2.default.createElement(
	                    "button",
	                    { type: "button", className: "btn btn-primary" },
	                    "Platforms & Tools"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { id: "PlatformsTools", style: { display: "none" } },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement("input", {
	                      type: "file",
	                      className: "form-control",
	                      name: "PlatformsToolsFile",
	                      id: "PlatformsToolsFile",
	                      onChange: this.handleChangePlatformsToolsFile
	                    }),
	                    _react2.default.createElement("input", {
	                      type: "button",
	                      value: "Add",
	                      onClick: function onClick() {
	                        return _this2.PlatformsToolsAdd();
	                      },
	                      style: { marginTop: "10px" }
	                    })
	                  ),
	                  this.state.PlatformsToolsFiles.length > 0 && _react2.default.createElement(
	                    "table",
	                    { className: "table table-bordered" },
	                    _react2.default.createElement(
	                      "thead",
	                      null,
	                      _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          "Url"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          "Delete"
	                        )
	                      )
	                    ),
	                    " ",
	                    _react2.default.createElement(
	                      "tbody",
	                      null,
	                      this.state.PlatformsToolsFiles.map(function (data, i) {
	                        return _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            _react2.default.createElement("img", { src: data.url, width: "20%" })
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            _react2.default.createElement("img", {
	                              src: _close2.default,
	                              alt: "",
	                              onClick: function onClick() {
	                                return _this2.PlatformsToolsRemove(data.url);
	                              }
	                            })
	                          )
	                        );
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group mt-4", style: { display: "none" } },
	                  _react2.default.createElement(
	                    "button",
	                    { type: "button", className: "btn btn-primary" },
	                    "Certifications"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { id: "Certifications", style: { display: "none" } },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement("input", {
	                      type: "file",
	                      className: "form-control",
	                      name: "CertificationsFile",
	                      id: "CertificationsFile",
	                      onChange: this.handleChangeCertifications
	                    }),
	                    _react2.default.createElement("input", {
	                      type: "button",
	                      value: "Add",
	                      onClick: function onClick() {
	                        return _this2.CertificationsAdd();
	                      },
	                      style: { marginTop: "10px" }
	                    })
	                  ),
	                  this.state.CertificationsFiles.length > 0 && _react2.default.createElement(
	                    "table",
	                    { className: "table table-bordered" },
	                    _react2.default.createElement(
	                      "thead",
	                      null,
	                      _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          "Url"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          "Delete"
	                        )
	                      )
	                    ),
	                    " ",
	                    _react2.default.createElement(
	                      "tbody",
	                      null,
	                      this.state.CertificationsFiles.map(function (data, i) {
	                        return _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            _react2.default.createElement("img", { src: data.url, width: "20%" })
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            _react2.default.createElement("img", {
	                              src: _close2.default,
	                              alt: "",
	                              onClick: function onClick() {
	                                return _this2.CertificationsRemove(data.url);
	                              }
	                            })
	                          )
	                        );
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group mt-4", style: { display: "none" } },
	                  _react2.default.createElement(
	                    "button",
	                    { type: "button", className: "btn btn-primary" },
	                    "Course Details"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { id: "Certifications" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "WhatYouWillLearnTitle" },
	                      "University Name"
	                    ),
	                    _react2.default.createElement(
	                      "select",
	                      {
	                        id: "universityName",
	                        name: "universityName",
	                        className: "form-control"
	                      },
	                      this.state.institution.map(function (data, i) {
	                        return _react2.default.createElement(
	                          "option",
	                          { value: data.internalId },
	                          data.institution
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "WhatYouWillLearnTitle" },
	                      "Course Description"
	                    ),
	                    _react2.default.createElement("textarea", {
	                      className: "form-control",
	                      name: "courseDescription",
	                      placeholder: "Course Description",
	                      onChange: this.handleChange,
	                      id: "courseDescription"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "WhatYouWillLearnTitle" },
	                      "Language"
	                    ),
	                    _react2.default.createElement("textarea", {
	                      className: "form-control",
	                      name: "Language",
	                      placeholder: "Language",
	                      onChange: this.handleChange,
	                      id: "Language"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group", style: { display: "none" } },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "WhatYouWillLearnTitle" },
	                      "Course rating"
	                    ),
	                    _react2.default.createElement("textarea", {
	                      className: "form-control",
	                      name: "Courserating",
	                      placeholder: "Course rating",
	                      onChange: this.handleChange,
	                      id: "Courserating"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "WhatYouWillLearnTitle" },
	                      "Level"
	                    ),
	                    _react2.default.createElement("textarea", {
	                      className: "form-control",
	                      name: "Level",
	                      placeholder: "Level",
	                      onChange: this.handleChange,
	                      id: "Level"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "WhatYouWillLearnTitle" },
	                      "Mode of learning"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group" },
	                      _react2.default.createElement(
	                        "select",
	                        {
	                          id: "Modeoflearning",
	                          name: "Modeoflearning",
	                          className: "form-control"
	                        },
	                        this.state.modeoflearning.map(function (data, i) {
	                          return _react2.default.createElement(
	                            "option",
	                            { value: data.internalId },
	                            data.modeOfLearning
	                          );
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "WhatYouWillLearnTitle" },
	                      "Country"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group" },
	                      _react2.default.createElement(
	                        "select",
	                        {
	                          id: "Country",
	                          name: "Country",
	                          className: "form-control"
	                        },
	                        this.state.country.map(function (data, i) {
	                          return _react2.default.createElement(
	                            "option",
	                            { value: data.key },
	                            data.country
	                          );
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "WhatYouWillLearnTitle" },
	                      "Accrediation"
	                    ),
	                    _react2.default.createElement("textarea", {
	                      className: "form-control",
	                      name: "Accrediation",
	                      placeholder: "Accrediation",
	                      onChange: this.handleChange,
	                      id: "Accrediation"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group", style: { display: "none" } },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "WhatYouWillLearnTitle" },
	                      "Accredtion score"
	                    ),
	                    _react2.default.createElement("textarea", {
	                      className: "form-control",
	                      name: "Accredtionscore",
	                      placeholder: "Accredtion score",
	                      onChange: this.handleChange,
	                      id: "Accredtionscore"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "WhatYouWillLearnTitle" },
	                      "Website link"
	                    ),
	                    _react2.default.createElement("textarea", {
	                      className: "form-control",
	                      name: "Websitelink",
	                      placeholder: "Website link",
	                      onChange: this.handleChange,
	                      id: "Websitelink"
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group mt-4" },
	                  _react2.default.createElement(
	                    "button",
	                    { type: "button", className: "btn btn-primary" },
	                    "Skills"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { id: "WhatYouWillGet" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "WhatYouWillGetTitle" },
	                      "Skills"
	                    ),
	                    _react2.default.createElement(
	                      "select",
	                      {
	                        className: "form-control",
	                        name: "skilsName",
	                        id: "skilsName",
	                        style: { width: "500px" }
	                      },
	                      _react2.default.createElement(
	                        "option",
	                        { value: "" },
	                        "Please select...."
	                      ),
	                      this.state.skillsObj.map(function (data, i) {
	                        return _react2.default.createElement(
	                          "option",
	                          { value: data.skills },
	                          data.skills
	                        );
	                      })
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control", style: { marginLeft: "524px", marginTop: "-34px", width: "255px", display: "none" },
	                      name: "skillRating",
	                      id: "skillRating",
	                      onChange: this.handleChange,
	                      placeholder: "Skill Rating",
	                      onKeyUp: this.handleNumberChange
	                    }),
	                    _react2.default.createElement("input", {
	                      type: "button",
	                      value: "Add",
	                      onClick: function onClick() {
	                        return _this2.skillAdd();
	                      },
	                      style: { marginTop: "10px" }
	                    })
	                  ),
	                  this.state.skillArray.length > 0 && _react2.default.createElement(
	                    "table",
	                    { className: "table table-bordered" },
	                    _react2.default.createElement(
	                      "thead",
	                      null,
	                      _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          "Skill"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { style: { display: "none" } },
	                          "Rating"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          "Delete"
	                        )
	                      )
	                    ),
	                    " ",
	                    _react2.default.createElement(
	                      "tbody",
	                      null,
	                      this.state.skillArray.map(function (data, i) {
	                        return _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            data.skill
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            { style: { display: "none" } },
	                            data.skillRating
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            _react2.default.createElement("img", {
	                              src: _close2.default,
	                              alt: "",
	                              onClick: function onClick() {
	                                return _this2.skillRemove(data.skill);
	                              }
	                            })
	                          )
	                        );
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { id: "Certifications" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "WhatYouWillLearnTitle" },
	                      "Course Fields"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "WhatYouWillLearnTitle" },
	                      "What Does the Course Cover?"
	                    ),
	                    _react2.default.createElement("br", null),
	                    "Length and Breadth of the Skills Being Covered - out of 10",
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      name: "LengthandBreadth",
	                      onChange: this.handleChange,
	                      id: "LengthandBreadth",
	                      style: { width: "100px" },
	                      placeholder: "out of 10",
	                      title: "Length and Breadth of the Skills Being Covered - out of 10",
	                      onKeyUp: this.handleNumberChange
	                    }),
	                    _react2.default.createElement("br", null),
	                    "Relevant Case Studies Covered by the Course - out of 10",
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      name: "RelevantCaseStudies",
	                      onChange: this.handleChange,
	                      id: "RelevantCaseStudies",
	                      style: { width: "100px" },
	                      placeholder: "out of 10",
	                      title: "Relevant Case Studies Covered by the Course - out of 10",
	                      onKeyUp: this.handleNumberChange
	                    }),
	                    _react2.default.createElement("br", null),
	                    "Tools Covered by the Course - out of 10",
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      name: "ToolsCovered",
	                      onChange: this.handleChange,
	                      id: "ToolsCovered",
	                      style: { width: "100px" },
	                      placeholder: "out of 10",
	                      title: "Tools Covered by the Course - out of 10",
	                      onKeyUp: this.handleNumberChange
	                    }),
	                    _react2.default.createElement("br", null),
	                    "Capstone Project Covered by the Course - out of 10",
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      name: "CapstoneProjectCovered",
	                      onChange: this.handleChange,
	                      id: "CapstoneProjectCovered",
	                      style: { width: "100px" },
	                      placeholder: "out of 10",
	                      title: "Capstone Project Covered by the Course- out of 10",
	                      onKeyUp: this.handleNumberChange
	                    }),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "WhatYouWillLearnTitle" },
	                      "Trainers - Who are the Trainers Behind the Course?"
	                    ),
	                    _react2.default.createElement("br", null),
	                    "Trainer's Experience - out of 10",
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      name: " TrainerExperience",
	                      onChange: this.handleChange,
	                      id: "TrainerExperience",
	                      style: { width: "100px" },
	                      placeholder: "out of 10",
	                      title: "Trainer's Experience - out of 10",
	                      onKeyUp: this.handleNumberChange
	                    }),
	                    _react2.default.createElement("br", null),
	                    "Trainer's Education - out of 10",
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      name: "TrainerEducation",
	                      onChange: this.handleChange,
	                      id: "TrainerEducation",
	                      style: { width: "100px" },
	                      placeholder: "out of 10",
	                      title: "Trainer's Education - out of 10",
	                      onKeyUp: this.handleNumberChange
	                    }),
	                    _react2.default.createElement("br", null),
	                    "Teaching Style of the Trainers - out of 10",
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      name: "TeachingStyle",
	                      onChange: this.handleChange,
	                      id: "TeachingStyle",
	                      style: { width: "100px" },
	                      placeholder: "out of 10",
	                      title: "Teaching Style of the Trainers - out of 10",
	                      onKeyUp: this.handleNumberChange
	                    }),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "WhatYouWillLearnTitle" },
	                      "Accreditations - What are the Certificates and Accreditations of this Course?"
	                    ),
	                    _react2.default.createElement("br", null),
	                    "Ranking/Govt. Bodies/Professional Bodies - out of 10",
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      name: "Ranking",
	                      onChange: this.handleChange,
	                      id: "Ranking",
	                      style: { width: "100px" },
	                      placeholder: "out of 10",
	                      title: "Ranking - out of 10",
	                      onKeyUp: this.handleNumberChange
	                    }),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      name: "GovtBodies",
	                      onChange: this.handleChange,
	                      id: "GovtBodies",
	                      style: { width: "100px", display: "none" },
	                      placeholder: "out of 10",
	                      title: "Govt. Bodies - out of 10",
	                      onKeyUp: this.handleNumberChange
	                    }),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      name: "ProfessionalBodies",
	                      onChange: this.handleChange,
	                      id: "ProfessionalBodies",
	                      style: { width: "100px", display: "none" },
	                      placeholder: "out of 10",
	                      title: "Professional Bodies - out of 10",
	                      onKeyUp: this.handleNumberChange
	                    }),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "WhatYouWillLearnTitle" },
	                      "Delivery Methods Grading - What are the Delivery Methods of the course?"
	                    ),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      name: "Mentorship",
	                      onChange: this.handleChange,
	                      id: "Mentorship",
	                      style: { width: "100px", display: "none" },
	                      placeholder: "out of 10",
	                      title: "Mentorship - out of 10",
	                      onKeyUp: this.handleNumberChange
	                    }),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      name: "CareerCoach",
	                      onChange: this.handleChange,
	                      id: "CareerCoach",
	                      style: { width: "100px", display: "none" },
	                      placeholder: "out of 10",
	                      title: "Career Coach - out of 10",
	                      onKeyUp: this.handleNumberChange
	                    }),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      name: "Liveclasses",
	                      onChange: this.handleChange,
	                      id: "Liveclasses",
	                      style: { width: "100px", display: "none" },
	                      placeholder: "out of 10",
	                      title: "Live classes - out of 10",
	                      onKeyUp: this.handleNumberChange
	                    }),
	                    "Quick Upskilling - out of 10",
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      name: "QuickUpskilling",
	                      onChange: this.handleChange,
	                      id: "QuickUpskilling",
	                      style: { width: "100px" },
	                      placeholder: "out of 10",
	                      title: "Quick Upskilling - out of 10",
	                      onKeyUp: this.handleNumberChange
	                    }),
	                    _react2.default.createElement("br", null),
	                    "Active Learning - out of 10",
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      name: "ActiveLearning",
	                      onChange: this.handleChange,
	                      id: "ActiveLearning",
	                      style: { width: "100px" },
	                      placeholder: "out of 10",
	                      title: "Active Learning  - out of 10",
	                      onKeyUp: this.handleNumberChange
	                    }),
	                    _react2.default.createElement("br", null),
	                    "Job Assistance - out of 10",
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      name: "JobAssistance",
	                      onChange: this.handleChange,
	                      id: "JobAssistance",
	                      style: { width: "100px" },
	                      placeholder: "out of 10",
	                      title: "Job Assistance - out of 10",
	                      onKeyUp: this.handleNumberChange
	                    }),
	                    _react2.default.createElement("br", null),
	                    "Study Materials Provided by the Course - out of 10",
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control",
	                      name: "StudyMaterials",
	                      onChange: this.handleChange,
	                      id: "StudyMaterials",
	                      style: { width: "100px" },
	                      placeholder: "out of 10",
	                      title: "Study Materials Provided by the Course - out of 10",
	                      onKeyUp: this.handleNumberChange
	                    }),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "WhatYouWillLearnTitle", style: { display: "none" } },
	                      "Overall Outcome- What are the final outcomes of this course?"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { style: { display: "none" } },
	                      "Career Transition",
	                      _react2.default.createElement("input", {
	                        type: "checkbox",
	                        className: "form-control",
	                        name: "CareerTransition",
	                        onChange: this.handleChange,
	                        id: "CareerTransition",
	                        style: { width: "20px", height: "20px" },
	                        placeholder: "",
	                        value: "Career Transition",
	                        title: " Career Transition"
	                      }),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        className: "form-control",
	                        name: "careerTransitionScore",
	                        onChange: this.handleChange,
	                        id: "careerTransitionScore",
	                        style: { width: "100px", marginLeft: "50px", marginTop: "-25px" },
	                        placeholder: "out of 10",
	                        title: "Mentorship - out of 10",
	                        onKeyUp: this.handleNumberChange
	                      }),
	                      "Quick Upskills",
	                      _react2.default.createElement("input", {
	                        type: "checkbox",
	                        className: "form-control",
	                        name: "QuickUpskills",
	                        onChange: this.handleChange,
	                        id: "QuickUpskills",
	                        style: { width: "20px", height: "20px" },
	                        placeholder: "",
	                        value: " Quick Upskills",
	                        title: " Quick Upskills"
	                      }),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        className: "form-control",
	                        name: "quickUpskillsScore",
	                        onChange: this.handleChange,
	                        id: "quickUpskillsScore",
	                        style: { width: "100px", marginLeft: "50px", marginTop: "-25px" },
	                        placeholder: "out of 10",
	                        title: "Mentorship - out of 10",
	                        onKeyUp: this.handleNumberChange
	                      }),
	                      "Jobs",
	                      _react2.default.createElement("input", {
	                        type: "checkbox",
	                        className: "form-control",
	                        name: "Jobs",
	                        onChange: this.handleChange,
	                        id: "Jobs",
	                        style: { width: "20px", height: "20px" },
	                        placeholder: "",
	                        value: "Jobs",
	                        title: "Jobs"
	                      }),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        className: "form-control",
	                        name: "jobsScore",
	                        onChange: this.handleChange,
	                        id: "jobsScore",
	                        style: { width: "100px", marginLeft: "50px", marginTop: "-25px" },
	                        placeholder: "out of 10",
	                        title: "Mentorship - out of 10",
	                        onKeyUp: this.handleNumberChange
	                      }),
	                      "Certificates",
	                      _react2.default.createElement("input", {
	                        type: "checkbox",
	                        className: "form-control",
	                        name: "CertificatesCheck",
	                        onChange: this.handleChange,
	                        id: "CertificatesCheck",
	                        style: { width: "20px", height: "20px" },
	                        placeholder: "",
	                        value: "Certificates",
	                        title: "Certificates"
	                      }),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        className: "form-control",
	                        name: "certificatesScore",
	                        onChange: this.handleChange,
	                        id: "certificatesScore",
	                        style: { width: "100px", marginLeft: "50px", marginTop: "-25px" },
	                        placeholder: "out of 10",
	                        title: "Mentorship - out of 10",
	                        onKeyUp: this.handleNumberChange
	                      })
	                    ),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement("input", {
	                      type: "button",
	                      id: "",
	                      value: "Calculate Score",
	                      onClick: function onClick() {
	                        return _this2.scoreCalculate();
	                      }
	                    }),
	                    _react2.default.createElement(
	                      "span",
	                      { id: "scoreValue", style: { marginLeft: "10px" } },
	                      _react2.default.createElement(
	                        "b",
	                        null,
	                        this.state.CourseScore,
	                        " %"
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group mt-4" },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { to: "/career-tracks" },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        type: "button",
	                        className: "btn btn-primary",
	                        style: { float: "right", marginLeft: "10px" }
	                      },
	                      "Cancel"
	                    )
	                  ),
	                  this.state.id == null ? _react2.default.createElement(
	                    "button",
	                    {
	                      type: "button",
	                      className: "btn btn-primary",
	                      onClick: this.validateSubmission,
	                      style: { float: "right" }
	                    },
	                    "Submit"
	                  ) : _react2.default.createElement(
	                    "button",
	                    {
	                      type: "button",
	                      className: "btn btn-primary",
	                      onClick: this.validateSubmission,
	                      style: { float: "right" }
	                    },
	                    "Update"
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_footer2.default, null)
	      );
	    }
	  }]);
	
	  return NewInsights;
	}(_react.Component);
	
	exports.default = NewInsights;

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _edit = __webpack_require__(21);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _firebase = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Country = function (_Component) {
	    _inherits(Country, _Component);
	
	    function Country(props) {
	        _classCallCheck(this, Country);
	
	        var _this = _possibleConstructorReturn(this, (Country.__proto__ || Object.getPrototypeOf(Country)).call(this, props));
	
	        _this.state = {
	            countryData: []
	        };
	        return _this;
	    }
	
	    _createClass(Country, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.renderList();
	        }
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var dataList;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                dataList = [];
	                                _context.next = 3;
	                                return _firebase.database.ref("country").once('value', function (snapshot) {
	                                    snapshot.forEach(function (ChildSnapshot) {
	                                        dataList.push({
	                                            key: ChildSnapshot.key,
	                                            country: ChildSnapshot.val().country,
	                                            countryStatus: ChildSnapshot.val().status
	                                        });
	                                    });
	                                });
	
	                            case 3:
	                                this.setState({
	                                    countryData: dataList
	                                });
	
	                            case 4:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function renderList() {
	                return _ref.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "Country"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Country",
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/newCountry/keyId=0" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { className: "addNewBtn btn" },
	                                            " New Country"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "table" },
	                                    _react2.default.createElement(
	                                        "table",
	                                        { className: "table table-bordered" },
	                                        _react2.default.createElement(
	                                            "thead",
	                                            null,
	                                            _react2.default.createElement(
	                                                "tr",
	                                                null,
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "ID"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Country"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Status"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Actions"
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tbody",
	                                            null,
	                                            this.state.countryData.map(function (data, i) {
	                                                return _react2.default.createElement(
	                                                    "tr",
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        "th",
	                                                        { scope: "row" },
	                                                        i + 1
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.country
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.countryStatus
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            _reactRouterDom.Link,
	                                                            { to: '/newCountry/keyId=' + data.key, params: data.key },
	                                                            _react2.default.createElement("img", { src: _edit2.default, className: "actionIcon" })
	                                                        )
	                                                    )
	                                                );
	                                            })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return Country;
	}(_react.Component);
	
	exports.default = Country;

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dashboard = function (_Component) {
	  _inherits(Dashboard, _Component);
	
	  function Dashboard() {
	    _classCallCheck(this, Dashboard);
	
	    return _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).apply(this, arguments));
	  }
	
	  _createClass(Dashboard, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var role = localStorage.getItem('Role');
	      if (role != "ADMIN") {
	        alert("You are not authorized to view the page");
	        window.location.href = "/";
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { "class": "main-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content" },
	          _react2.default.createElement(_doctorLeftmenu2.default, null),
	          _react2.default.createElement(
	            "div",
	            { className: "content-right-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "div",
	                { className: "dashboard-btns-wrapper" },
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: "dashboard-btns", to: "/testimonials" },
	                  "Testimonials"
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: "dashboard-btns", to: "/stories" },
	                  "Stories"
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: "dashboard-btns", to: "/career-tracks" },
	                  "Master Class"
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: "dashboard-btns", to: "/expertise" },
	                  "Expertise"
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: "dashboard-btns", to: "/skills" },
	                  "Skills"
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: "dashboard-btns", to: "/experience" },
	                  "Experience"
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: "dashboard-btns", to: "/education" },
	                  "Education"
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: "dashboard-btns", to: "/priceRange" },
	                  "Price Range"
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: "dashboard-btns", to: "/country" },
	                  "Country"
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: "dashboard-btns", to: "/modeOfLearning" },
	                  "Mode of learning"
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: "dashboard-btns", to: "/institution" },
	                  "Institution"
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: "dashboard-btns", to: "/personna" },
	                  "Personna"
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: "dashboard-btns", to: "/goals" },
	                  "Goals"
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: "dashboard-btns", to: "/storyCategory" },
	                  "Story Category"
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: "dashboard-btns", to: "/userReport" },
	                  "Report"
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_footer2.default, null)
	      );
	    }
	  }]);
	
	  return Dashboard;
	}(_react.Component);
	
	exports.default = Dashboard;

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _edit = __webpack_require__(21);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _firebase = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Education = function (_Component) {
	    _inherits(Education, _Component);
	
	    function Education(props) {
	        _classCallCheck(this, Education);
	
	        var _this = _possibleConstructorReturn(this, (Education.__proto__ || Object.getPrototypeOf(Education)).call(this, props));
	
	        _this.state = {
	            educationData: []
	        };
	        return _this;
	    }
	
	    _createClass(Education, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.renderList();
	        }
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var dataList;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                dataList = [];
	                                _context.next = 3;
	                                return _firebase.database.ref("education").once('value', function (snapshot) {
	                                    snapshot.forEach(function (ChildSnapshot) {
	                                        console.log("ChildSnapshot.val()...", ChildSnapshot.val());
	                                        dataList.push({
	                                            key: ChildSnapshot.key,
	                                            education: ChildSnapshot.val().education,
	                                            educationStatus: ChildSnapshot.val().status
	                                        });
	                                    });
	                                });
	
	                            case 3:
	                                this.setState({
	                                    educationData: dataList
	                                });
	
	                            case 4:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function renderList() {
	                return _ref.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "Education"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Education",
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/newEducation/keyId=0" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { className: "addNewBtn btn" },
	                                            " New Education"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "table" },
	                                    _react2.default.createElement(
	                                        "table",
	                                        { className: "table table-bordered" },
	                                        _react2.default.createElement(
	                                            "thead",
	                                            null,
	                                            _react2.default.createElement(
	                                                "tr",
	                                                null,
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "ID"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Education"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Status"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Actions"
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tbody",
	                                            null,
	                                            this.state.educationData.map(function (data, i) {
	                                                return _react2.default.createElement(
	                                                    "tr",
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        "th",
	                                                        { scope: "row" },
	                                                        i + 1
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.education
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.educationStatus
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            _reactRouterDom.Link,
	                                                            { to: '/newEducation/keyId=' + data.key, params: data.key },
	                                                            _react2.default.createElement("img", { src: _edit2.default, className: "actionIcon" })
	                                                        )
	                                                    )
	                                                );
	                                            })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return Education;
	}(_react.Component);
	
	exports.default = Education;

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _edit = __webpack_require__(21);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _firebase = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Experience = function (_Component) {
	    _inherits(Experience, _Component);
	
	    function Experience(props) {
	        _classCallCheck(this, Experience);
	
	        var _this = _possibleConstructorReturn(this, (Experience.__proto__ || Object.getPrototypeOf(Experience)).call(this, props));
	
	        _this.state = {
	            experienceData: []
	        };
	        return _this;
	    }
	
	    _createClass(Experience, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.renderList();
	        }
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var dataList;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                dataList = [];
	                                _context.next = 3;
	                                return _firebase.database.ref("experience").once('value', function (snapshot) {
	                                    snapshot.forEach(function (ChildSnapshot) {
	                                        dataList.push({
	                                            key: ChildSnapshot.key,
	                                            experience: ChildSnapshot.val().experience,
	                                            experienceStatus: ChildSnapshot.val().status
	                                        });
	                                    });
	                                });
	
	                            case 3:
	                                this.setState({
	                                    experienceData: dataList
	                                });
	
	                            case 4:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function renderList() {
	                return _ref.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "Experience"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Experience",
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/newExperience/keyId=0" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { className: "addNewBtn btn" },
	                                            " New Experience"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "table" },
	                                    _react2.default.createElement(
	                                        "table",
	                                        { className: "table table-bordered" },
	                                        _react2.default.createElement(
	                                            "thead",
	                                            null,
	                                            _react2.default.createElement(
	                                                "tr",
	                                                null,
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "ID"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Experience"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Status"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Actions"
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tbody",
	                                            null,
	                                            this.state.experienceData.map(function (data, i) {
	                                                return _react2.default.createElement(
	                                                    "tr",
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        "th",
	                                                        { scope: "row" },
	                                                        i + 1
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.experience
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.experienceStatus
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            _reactRouterDom.Link,
	                                                            { to: '/newExperience/keyId=' + data.key, params: data.key },
	                                                            _react2.default.createElement("img", { src: _edit2.default, className: "actionIcon" })
	                                                        )
	                                                    )
	                                                );
	                                            })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return Experience;
	}(_react.Component);
	
	exports.default = Experience;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _edit = __webpack_require__(21);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _delete = __webpack_require__(45);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _firebase = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Testimonials = function (_Component) {
	    _inherits(Testimonials, _Component);
	
	    function Testimonials(props) {
	        _classCallCheck(this, Testimonials);
	
	        var _this = _possibleConstructorReturn(this, (Testimonials.__proto__ || Object.getPrototypeOf(Testimonials)).call(this, props));
	
	        _this.state = {
	            expertiseData: []
	        };
	        return _this;
	    }
	
	    _createClass(Testimonials, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.renderList();
	        }
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var dataList;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                dataList = [];
	                                _context.next = 3;
	                                return _firebase.database.ref("expertise").once('value', function (snapshot) {
	                                    snapshot.forEach(function (ChildSnapshot) {
	                                        dataList.push({
	                                            key: ChildSnapshot.key,
	                                            expertise: ChildSnapshot.val().expertise,
	                                            expertiseStatus: ChildSnapshot.val().status
	                                        });
	                                    });
	                                });
	
	                            case 3:
	                                this.setState({
	                                    expertiseData: dataList
	                                });
	
	                            case 4:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function renderList() {
	                return _ref.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "Expertise"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Expertise",
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/newExpertise/keyId=0" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { className: "addNewBtn btn" },
	                                            " New Expertise"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "table" },
	                                    _react2.default.createElement(
	                                        "table",
	                                        { className: "table table-bordered" },
	                                        _react2.default.createElement(
	                                            "thead",
	                                            null,
	                                            _react2.default.createElement(
	                                                "tr",
	                                                null,
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "ID"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Expertise"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Status"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Actions"
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tbody",
	                                            null,
	                                            this.state.expertiseData.map(function (data, i) {
	                                                return _react2.default.createElement(
	                                                    "tr",
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        "th",
	                                                        { scope: "row" },
	                                                        i + 1
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.expertise
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.expertiseStatus
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            _reactRouterDom.Link,
	                                                            { to: '/newExpertise/keyId=' + data.key, params: data.key },
	                                                            _react2.default.createElement("img", { src: _edit2.default, className: "actionIcon" })
	                                                        )
	                                                    )
	                                                );
	                                            })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return Testimonials;
	}(_react.Component);
	
	exports.default = Testimonials;

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _edit = __webpack_require__(21);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _delete = __webpack_require__(45);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _firebase = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Goals = function (_Component) {
	    _inherits(Goals, _Component);
	
	    function Goals(props) {
	        _classCallCheck(this, Goals);
	
	        var _this = _possibleConstructorReturn(this, (Goals.__proto__ || Object.getPrototypeOf(Goals)).call(this, props));
	
	        _this.state = {
	            goalsData: []
	        };
	        return _this;
	    }
	
	    _createClass(Goals, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.renderList();
	        }
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var dataList, personnaData;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                dataList = [];
	                                personnaData = [];
	                                _context.next = 4;
	                                return _firebase.database.ref("personna").once('value', function (snapshot) {
	                                    snapshot.forEach(function (ChildSnapshot) {
	                                        personnaData.push({
	                                            internalId: ChildSnapshot.val().internalId,
	                                            name: ChildSnapshot.val().name
	                                        });
	                                    });
	                                });
	
	                            case 4:
	                                _context.next = 6;
	                                return _firebase.database.ref("goals").once('value', function (snapshot) {
	                                    snapshot.forEach(function (ChildSnapshot) {
	                                        var id = ChildSnapshot.val().personna;
	                                        var personnaName = personnaData.filter(function (el) {
	                                            return el.internalId.toString() === id.toString();
	                                        });
	                                        dataList.push({
	                                            key: ChildSnapshot.key,
	                                            name: ChildSnapshot.val().name,
	                                            status: ChildSnapshot.val().status,
	                                            personna: ChildSnapshot.val().personna,
	                                            personnaName: personnaName[0].name,
	                                            internalId: ChildSnapshot.val().internalId
	                                        });
	                                    });
	                                });
	
	                            case 6:
	                                this.setState({
	                                    goalsData: dataList
	                                });
	
	                            case 7:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function renderList() {
	                return _ref.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "Goals"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Goals",
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/newGoals/keyId=0" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { className: "addNewBtn btn" },
	                                            " New Goals"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "table" },
	                                    _react2.default.createElement(
	                                        "table",
	                                        { className: "table table-bordered" },
	                                        _react2.default.createElement(
	                                            "thead",
	                                            null,
	                                            _react2.default.createElement(
	                                                "tr",
	                                                null,
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "ID"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Personna"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Goal"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Status"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Actions"
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tbody",
	                                            null,
	                                            this.state.goalsData.map(function (data, i) {
	                                                return _react2.default.createElement(
	                                                    "tr",
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        "th",
	                                                        { scope: "row" },
	                                                        data.internalId
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.personnaName
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.name
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.status
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            _reactRouterDom.Link,
	                                                            { to: '/newGoals/keyId=' + data.key, params: data.key },
	                                                            _react2.default.createElement("img", { src: _edit2.default, className: "actionIcon" })
	                                                        )
	                                                    )
	                                                );
	                                            })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return Goals;
	}(_react.Component);
	
	exports.default = Goals;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _edit = __webpack_require__(21);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _delete = __webpack_require__(45);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _firebase = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { getFirestore, collection, getDocs } from 'firebase/firestore/lite';
	
	//import $ from 'jquery';
	
	
	var Insights = function (_Component) {
	  _inherits(Insights, _Component);
	
	  function Insights(props) {
	    _classCallCheck(this, Insights);
	
	    var _this = _possibleConstructorReturn(this, (Insights.__proto__ || Object.getPrototypeOf(Insights)).call(this, props));
	
	    _this.state = {
	      insightData: []
	    };
	
	    return _this;
	  }
	
	  _createClass(Insights, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.renderList();
	    }
	  }, {
	    key: "renderList",
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var dataList;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                dataList = [];
	                _context.next = 3;
	                return _firebase.database.ref("insights").once('value', function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    dataList.push({ key: ChildSnapshot.key, insightTitle: ChildSnapshot.val().insightTitle,
	                      description: ChildSnapshot.val().description,
	                      titleShortDescription: ChildSnapshot.val().titleShortDescription
	                    });
	                  });
	                });
	
	              case 3:
	                this.setState({ insightData: dataList });
	
	              case 4:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function renderList() {
	        return _ref.apply(this, arguments);
	      }
	
	      return renderList;
	    }()
	  }, {
	    key: "editData",
	    value: function editData(key) {
	
	      this.props.history.push("/newInsights/keyId=" + key);
	    }
	  }, {
	    key: "deleteData",
	    value: function deleteData(key) {
	      var _this2 = this;
	
	      _firebase.database.ref("insights/" + key).remove().then(function () {
	        alert("Deleted Successfully");
	        _this2.renderList();
	      }).catch(function () {
	        alert("Somthing went wrong");
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content" },
	          _react2.default.createElement(_doctorLeftmenu2.default, null),
	          _react2.default.createElement(
	            "div",
	            { className: "content-right-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "div",
	                { className: "form-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-head" },
	                  "Insights",
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { to: "/newInsights/keyId=0" },
	                    _react2.default.createElement(
	                      "button",
	                      { className: "addNewBtn btn" },
	                      " New Insights"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "table" },
	                  _react2.default.createElement(
	                    "table",
	                    { className: "table table-bordered" },
	                    _react2.default.createElement(
	                      "thead",
	                      null,
	                      _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "col" },
	                          "No"
	                        ),
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "col" },
	                          "Title"
	                        ),
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "col" },
	                          "Description"
	                        ),
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "col" },
	                          "Actions"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tbody",
	                      null,
	                      this.renderList,
	                      this.state.insightData.map(function (data, i) {
	
	                        return _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "row" },
	                            i + 1
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            data.insightTitle
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            data.description
	                          ),
	                          _react2.default.createElement(
	                            "td",
	                            null,
	                            _react2.default.createElement(
	                              _reactRouterDom.Link,
	                              { to: '/newInsights/keyId=' + data.key, params: data.key },
	                              _react2.default.createElement("img", { src: _edit2.default, className: "actionIcon" })
	                            ),
	                            _react2.default.createElement("img", { src: _delete2.default, className: "actionIcon", onClick: function onClick() {
	                                return _this3.deleteData(data.key);
	                              } })
	                          )
	                        );
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "nav",
	                    { "aria-label": "Page navigation example" },
	                    _react2.default.createElement(
	                      "ul",
	                      { className: "pagination justify-content-end" },
	                      _react2.default.createElement(
	                        "li",
	                        { className: "page-item" },
	                        _react2.default.createElement(
	                          "a",
	                          { className: "page-link", href: "#", "aria-label": "Previous" },
	                          _react2.default.createElement(
	                            "span",
	                            { "aria-hidden": "true" },
	                            "\xAB"
	                          ),
	                          _react2.default.createElement(
	                            "span",
	                            { className: "sr-only" },
	                            "Previous"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        { className: "page-item" },
	                        _react2.default.createElement(
	                          "a",
	                          { className: "page-link", href: "#" },
	                          "1"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        { className: "page-item" },
	                        _react2.default.createElement(
	                          "a",
	                          { className: "page-link", href: "#" },
	                          "2"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        { className: "page-item" },
	                        _react2.default.createElement(
	                          "a",
	                          { className: "page-link", href: "#" },
	                          "3"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        { className: "page-item" },
	                        _react2.default.createElement(
	                          "a",
	                          { className: "page-link", href: "#", "aria-label": "Next" },
	                          _react2.default.createElement(
	                            "span",
	                            { "aria-hidden": "true" },
	                            "\xBB"
	                          ),
	                          _react2.default.createElement(
	                            "span",
	                            { className: "sr-only" },
	                            "Next"
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_footer2.default, null)
	      );
	    }
	  }]);
	
	  return Insights;
	}(_react.Component);
	
	exports.default = Insights;

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _edit = __webpack_require__(21);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _firebase = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Institution = function (_Component) {
	    _inherits(Institution, _Component);
	
	    function Institution(props) {
	        _classCallCheck(this, Institution);
	
	        var _this = _possibleConstructorReturn(this, (Institution.__proto__ || Object.getPrototypeOf(Institution)).call(this, props));
	
	        _this.state = {
	            institutionData: []
	        };
	        return _this;
	    }
	
	    _createClass(Institution, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.renderList();
	        }
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var dataList;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                dataList = [];
	                                _context.next = 3;
	                                return _firebase.database.ref("institution").once('value', function (snapshot) {
	                                    snapshot.forEach(function (ChildSnapshot) {
	                                        dataList.push({
	                                            key: ChildSnapshot.key,
	                                            institution: ChildSnapshot.val().institution,
	                                            institutionStatus: ChildSnapshot.val().status,
	                                            internalId: ChildSnapshot.val().internalId
	                                        });
	                                    });
	                                });
	
	                            case 3:
	                                this.setState({
	                                    institutionData: dataList
	                                });
	
	                            case 4:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function renderList() {
	                return _ref.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "Institution"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Institution",
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/newInstitution/keyId=0" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { className: "addNewBtn btn" },
	                                            " New Institution"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "table" },
	                                    _react2.default.createElement(
	                                        "table",
	                                        { className: "table table-bordered" },
	                                        _react2.default.createElement(
	                                            "thead",
	                                            null,
	                                            _react2.default.createElement(
	                                                "tr",
	                                                null,
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "ID"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Institution"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Status"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Actions"
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tbody",
	                                            null,
	                                            this.state.institutionData.map(function (data, i) {
	                                                return _react2.default.createElement(
	                                                    "tr",
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        "th",
	                                                        { scope: "row" },
	                                                        data.internalId
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.institution
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.institutionStatus
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            _reactRouterDom.Link,
	                                                            { to: '/newInstitution/keyId=' + data.key, params: data.key },
	                                                            _react2.default.createElement("img", { src: _edit2.default, className: "actionIcon" })
	                                                        )
	                                                    )
	                                                );
	                                            })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return Institution;
	}(_react.Component);
	
	exports.default = Institution;

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _edit = __webpack_require__(21);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _firebase = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModeOfLearning = function (_Component) {
	    _inherits(ModeOfLearning, _Component);
	
	    function ModeOfLearning(props) {
	        _classCallCheck(this, ModeOfLearning);
	
	        var _this = _possibleConstructorReturn(this, (ModeOfLearning.__proto__ || Object.getPrototypeOf(ModeOfLearning)).call(this, props));
	
	        _this.state = {
	            modeOfLearningData: []
	        };
	        return _this;
	    }
	
	    _createClass(ModeOfLearning, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.renderList();
	        }
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var dataList;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                dataList = [];
	                                _context.next = 3;
	                                return _firebase.database.ref("modeOfLearning").once('value', function (snapshot) {
	                                    snapshot.forEach(function (ChildSnapshot) {
	                                        dataList.push({
	                                            key: ChildSnapshot.key,
	                                            modeOfLearning: ChildSnapshot.val().modeOfLearning,
	                                            modeOfLearningStatus: ChildSnapshot.val().status,
	                                            internalId: ChildSnapshot.val().internalId
	                                        });
	                                    });
	                                });
	
	                            case 3:
	                                this.setState({
	                                    modeOfLearningData: dataList
	                                });
	
	                            case 4:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function renderList() {
	                return _ref.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "Mode Of Learning"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Mode Of Learning",
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/newModeOfLearning/keyId=0" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { className: "addNewBtn btn" },
	                                            " New Mode Of Learning"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "table" },
	                                    _react2.default.createElement(
	                                        "table",
	                                        { className: "table table-bordered" },
	                                        _react2.default.createElement(
	                                            "thead",
	                                            null,
	                                            _react2.default.createElement(
	                                                "tr",
	                                                null,
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "ID"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Mode Of Learning"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Status"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Actions"
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tbody",
	                                            null,
	                                            this.state.modeOfLearningData.map(function (data, i) {
	                                                return _react2.default.createElement(
	                                                    "tr",
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        "th",
	                                                        { scope: "row" },
	                                                        data.internalId
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.modeOfLearning
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.modeOfLearningStatus
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            _reactRouterDom.Link,
	                                                            { to: '/newModeOfLearning/keyId=' + data.key, params: data.key },
	                                                            _react2.default.createElement("img", { src: _edit2.default, className: "actionIcon" })
	                                                        )
	                                                    )
	                                                );
	                                            })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return ModeOfLearning;
	}(_react.Component);
	
	exports.default = ModeOfLearning;

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _firebase = __webpack_require__(6);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var country = function (_Component) {
	    _inherits(country, _Component);
	
	    function country(props) {
	        _classCallCheck(this, country);
	
	        var _this = _possibleConstructorReturn(this, (country.__proto__ || Object.getPrototypeOf(country)).call(this, props));
	
	        _this.updateValidateSubmission = function () {
	            var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	            var item = {
	                country: _this.state.country,
	                status: _this.state.status,
	                createdAt: newDate
	            };
	            _firebase.database.ref("country/" + _this.state.id).update(item).then(function () {
	                alert("Updated Successfully");
	                window.location.href = "/country";
	                _this.renderList();
	            }).catch(function () {
	                alert("Somthing went wrong");
	            });
	        };
	
	        _this.handleStatusChange = function (e) {
	            _this.setState({
	                status: e.target.value
	            });
	        };
	
	        _this.handleChange = function (e) {
	            _this.setState({
	                country: e.target.value
	            });
	        };
	
	        _this.validateSubmission = function () {
	            if (_this.state.country === '') {
	                alert('Enter Country');
	            } else if (_this.state.status === '') {
	                alert('Select status');
	            } else {
	                if (_this.state.id == null) {
	                    _this.handleSubmit("");
	                } else {
	                    _this.updateValidateSubmission("");
	                }
	            }
	        };
	
	        _this.handleSubmit = function () {
	            var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	            var item = {
	                country: _this.state.country,
	                status: _this.state.status,
	                createdAt: newDate
	            };
	            _firebase.countryRef.push(item).then(function () {
	                alert("Saved Successfully");
	                window.location.href = "/country";
	            }).catch(function () {
	                alert("Somthing went wrong");
	            });
	        };
	
	        _this.state = {
	
	            country: "",
	            status: "",
	            id: null
	
	        };
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.validateSubmission = _this.validateSubmission.bind(_this);
	        _this.handleStatusChange = _this.handleStatusChange.bind(_this);
	        _this.updateValidateSubmission = _this.updateValidateSubmission.bind(_this);
	        return _this;
	    }
	
	    _createClass(country, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var url = new URL(window.location.href);
	            var url_path = window.location.href.split("=");
	            var keyId = url_path[1];
	            this.renderList(keyId);
	        }
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(keyId) {
	                var id, ref, userRef, valueRef, snapshot, val;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                id = keyId;
	                                ref = id ? '/country/' + id : 'country';
	                                userRef = _firebase.database.ref(ref);
	
	                                if (!id) {
	                                    _context.next = 7;
	                                    break;
	                                }
	
	                                _context.t0 = userRef;
	                                _context.next = 10;
	                                break;
	
	                            case 7:
	                                _context.next = 9;
	                                return userRef.orderByChild('key').equalTo('value');
	
	                            case 9:
	                                _context.t0 = _context.sent;
	
	                            case 10:
	                                valueRef = _context.t0;
	                                _context.next = 13;
	                                return valueRef.once('value');
	
	                            case 13:
	                                snapshot = _context.sent;
	                                val = snapshot.val();
	
	                                if (val) {
	                                    (0, _jquery2.default)("#country").val(val.country);
	                                    (0, _jquery2.default)("#countryStatus").val(val.status);
	                                    this.setState({
	                                        id: id,
	                                        country: val.country,
	                                        status: val.status
	                                    });
	                                }
	
	                            case 16:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function renderList(_x) {
	                return _ref.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "form",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/country" },
	                                            "Country"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "New Country"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Country"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "testimonialAuthor" },
	                                        "Country"
	                                    ),
	                                    _react2.default.createElement("input", { type: "text", className: "form-control", name: "country", onChange: this.handleChange,
	                                        id: "country"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "countryStatus" },
	                                        " Status"
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        { className: "form-control", onChange: this.handleStatusChange, id: "countryStatus", name: "countryStatus" },
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "" },
	                                            "Select"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Active" },
	                                            "Active"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Inactive" },
	                                            "Inactive"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group mt-4" },
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/country" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { type: "button", className: "btn btn-primary", style: { float: "right", marginLeft: "10px" } },
	                                            "Cancel"
	                                        )
	                                    ),
	                                    this.state.id == null ? _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", onClick: this.validateSubmission, style: { float: "right" } },
	                                        "Submit"
	                                    ) : _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", onClick: this.validateSubmission, style: { float: "right" } },
	                                        "Update"
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return country;
	}(_react.Component);
	
	exports.default = country;

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _firebase = __webpack_require__(6);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewSkill = function (_Component) {
	    _inherits(NewSkill, _Component);
	
	    function NewSkill(props) {
	        _classCallCheck(this, NewSkill);
	
	        var _this = _possibleConstructorReturn(this, (NewSkill.__proto__ || Object.getPrototypeOf(NewSkill)).call(this, props));
	
	        _this.updateValidateSubmission = function () {
	            var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	            var item = {
	                education: _this.state.education,
	                status: _this.state.status,
	                createdAt: newDate
	            };
	            _firebase.database.ref("education/" + _this.state.id).update(item).then(function () {
	                alert("Updated Successfully");
	                window.location.href = "/education";
	                _this.renderList();
	            }).catch(function () {
	                alert("Somthing went wrong");
	            });
	        };
	
	        _this.handleStatusChange = function (e) {
	            _this.setState({
	                status: e.target.value
	            });
	        };
	
	        _this.handleChange = function (e) {
	            _this.setState({
	                education: e.target.value
	            });
	        };
	
	        _this.validateSubmission = function () {
	            if (_this.state.education === '') {
	                alert('Enter Education');
	            } else if (_this.state.status === '') {
	                alert('Select status');
	            } else {
	                if (_this.state.id == null) {
	                    _this.handleSubmit("");
	                } else {
	                    _this.updateValidateSubmission("");
	                }
	            }
	        };
	
	        _this.handleSubmit = function () {
	            var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	            var item = {
	                education: _this.state.education,
	                status: _this.state.status,
	                createdAt: newDate
	            };
	            _firebase.educationRef.push(item).then(function () {
	                alert("Saved Successfully");
	                window.location.href = "/education";
	            }).catch(function () {
	                alert("Somthing went wrong");
	            });
	        };
	
	        _this.state = {
	
	            education: "",
	            status: "",
	            id: null
	
	        };
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.validateSubmission = _this.validateSubmission.bind(_this);
	        _this.handleStatusChange = _this.handleStatusChange.bind(_this);
	        _this.updateValidateSubmission = _this.updateValidateSubmission.bind(_this);
	        return _this;
	    }
	
	    _createClass(NewSkill, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var url = new URL(window.location.href);
	            var url_path = window.location.href.split("=");
	            var keyId = url_path[1];
	            this.renderList(keyId);
	        }
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(keyId) {
	                var id, ref, userRef, valueRef, snapshot, val;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                id = keyId;
	                                ref = id ? '/education/' + id : 'education';
	                                userRef = _firebase.database.ref(ref);
	
	                                if (!id) {
	                                    _context.next = 7;
	                                    break;
	                                }
	
	                                _context.t0 = userRef;
	                                _context.next = 10;
	                                break;
	
	                            case 7:
	                                _context.next = 9;
	                                return userRef.orderByChild('key').equalTo('value');
	
	                            case 9:
	                                _context.t0 = _context.sent;
	
	                            case 10:
	                                valueRef = _context.t0;
	                                _context.next = 13;
	                                return valueRef.once('value');
	
	                            case 13:
	                                snapshot = _context.sent;
	                                val = snapshot.val();
	
	                                if (val) {
	                                    (0, _jquery2.default)("#education").val(val.education);
	                                    (0, _jquery2.default)("#educationStatus").val(val.status);
	                                    this.setState({
	                                        id: id,
	                                        education: val.education,
	                                        status: val.status
	                                    });
	                                }
	
	                            case 16:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function renderList(_x) {
	                return _ref.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "form",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/education" },
	                                            "Education"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "New Education"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Education"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "testimonialAuthor" },
	                                        "Education"
	                                    ),
	                                    _react2.default.createElement("input", { type: "text", className: "form-control", name: "education", onChange: this.handleChange,
	                                        id: "education"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "educationStatus" },
	                                        " Status"
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        { className: "form-control", onChange: this.handleStatusChange, id: "educationStatus", name: "educationStatus" },
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "" },
	                                            "Select"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Active" },
	                                            "Active"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Inactive" },
	                                            "Inactive"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group mt-4" },
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/education" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { type: "button", className: "btn btn-primary", style: { float: "right", marginLeft: "10px" } },
	                                            "Cancel"
	                                        )
	                                    ),
	                                    this.state.id == null ? _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", onClick: this.validateSubmission, style: { float: "right" } },
	                                        "Submit"
	                                    ) : _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", onClick: this.validateSubmission, style: { float: "right" } },
	                                        "Update"
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return NewSkill;
	}(_react.Component);
	
	exports.default = NewSkill;

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _firebase = __webpack_require__(6);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Experience = function (_Component) {
	    _inherits(Experience, _Component);
	
	    function Experience(props) {
	        _classCallCheck(this, Experience);
	
	        var _this = _possibleConstructorReturn(this, (Experience.__proto__ || Object.getPrototypeOf(Experience)).call(this, props));
	
	        _this.updateValidateSubmission = function () {
	            var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	            var item = {
	                experience: _this.state.experience,
	                status: _this.state.status,
	                createdAt: newDate
	            };
	            _firebase.database.ref("experience/" + _this.state.id).update(item).then(function () {
	                alert("Updated Successfully");
	                window.location.href = "/experience";
	                _this.renderList();
	            }).catch(function () {
	                alert("Somthing went wrong");
	            });
	        };
	
	        _this.handleStatusChange = function (e) {
	            _this.setState({
	                status: e.target.value
	            });
	        };
	
	        _this.handleChange = function (e) {
	            _this.setState({
	                experience: e.target.value
	            });
	        };
	
	        _this.validateSubmission = function () {
	            if (_this.state.experience === '') {
	                alert('Enter Experience');
	            } else if (_this.state.status === '') {
	                alert('Select status');
	            } else {
	                if (_this.state.id == null) {
	                    _this.handleSubmit("");
	                } else {
	                    _this.updateValidateSubmission("");
	                }
	            }
	        };
	
	        _this.handleSubmit = function () {
	            var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	            var item = {
	                experience: _this.state.experience,
	                status: _this.state.status,
	                createdAt: newDate
	            };
	            _firebase.experienceRef.push(item).then(function () {
	                alert("Saved Successfully");
	                window.location.href = "/experience";
	            }).catch(function () {
	                alert("Somthing went wrong");
	            });
	        };
	
	        _this.state = {
	
	            experience: "",
	            status: "",
	            id: null
	
	        };
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.validateSubmission = _this.validateSubmission.bind(_this);
	        _this.handleStatusChange = _this.handleStatusChange.bind(_this);
	        _this.updateValidateSubmission = _this.updateValidateSubmission.bind(_this);
	        return _this;
	    }
	
	    _createClass(Experience, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var url = new URL(window.location.href);
	            var url_path = window.location.href.split("=");
	            var keyId = url_path[1];
	            this.renderList(keyId);
	        }
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(keyId) {
	                var id, ref, userRef, valueRef, snapshot, val;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                id = keyId;
	                                ref = id ? '/experience/' + id : 'experience';
	                                userRef = _firebase.database.ref(ref);
	
	                                if (!id) {
	                                    _context.next = 7;
	                                    break;
	                                }
	
	                                _context.t0 = userRef;
	                                _context.next = 10;
	                                break;
	
	                            case 7:
	                                _context.next = 9;
	                                return userRef.orderByChild('key').equalTo('value');
	
	                            case 9:
	                                _context.t0 = _context.sent;
	
	                            case 10:
	                                valueRef = _context.t0;
	                                _context.next = 13;
	                                return valueRef.once('value');
	
	                            case 13:
	                                snapshot = _context.sent;
	                                val = snapshot.val();
	
	                                if (val) {
	                                    (0, _jquery2.default)("#experience").val(val.experience);
	                                    (0, _jquery2.default)("#experienceStatus").val(val.status);
	                                    this.setState({
	                                        id: id,
	                                        experience: val.experience,
	                                        status: val.status
	                                    });
	                                }
	
	                            case 16:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function renderList(_x) {
	                return _ref.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "form",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/experience" },
	                                            "Experience"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "New Experience"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Experience"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "testimonialAuthor" },
	                                        "Experience"
	                                    ),
	                                    _react2.default.createElement("input", { type: "text", className: "form-control", name: "experience", onChange: this.handleChange,
	                                        id: "experience"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "experienceStatus" },
	                                        " Status"
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        { className: "form-control", onChange: this.handleStatusChange, id: "experienceStatus", name: "experienceStatus" },
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "" },
	                                            "Select"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Active" },
	                                            "Active"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Inactive" },
	                                            "Inactive"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group mt-4" },
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/experience" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { type: "button", className: "btn btn-primary", style: { float: "right", marginLeft: "10px" } },
	                                            "Cancel"
	                                        )
	                                    ),
	                                    this.state.id == null ? _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", onClick: this.validateSubmission, style: { float: "right" } },
	                                        "Submit"
	                                    ) : _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", onClick: this.validateSubmission, style: { float: "right" } },
	                                        "Update"
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return Experience;
	}(_react.Component);
	
	exports.default = Experience;

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _firebase = __webpack_require__(6);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _close = __webpack_require__(411);
	
	var _close2 = _interopRequireDefault(_close);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewSkill = function (_Component) {
	    _inherits(NewSkill, _Component);
	
	    function NewSkill(props) {
	        _classCallCheck(this, NewSkill);
	
	        var _this = _possibleConstructorReturn(this, (NewSkill.__proto__ || Object.getPrototypeOf(NewSkill)).call(this, props));
	
	        _this.updateValidateSubmission = function () {
	            var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	            var item = {
	                expertise: _this.state.expertise,
	                status: _this.state.status,
	                createdAt: newDate,
	                experienceSalaryDetails: _this.state.salExpData
	            };
	            _firebase.database.ref("expertise/" + _this.state.id).update(item).then(function () {
	                alert("Updated Successfully");
	                window.location.href = "/expertise";
	                _this.renderList();
	            }).catch(function () {
	                alert("Somthing went wrong");
	            });
	        };
	
	        _this.handleStatusChange = function (e) {
	            _this.setState({
	                status: e.target.value
	            });
	        };
	
	        _this.handleChange = function (event) {
	            var _event$target = event.target,
	                value = _event$target.value,
	                name = _event$target.name;
	
	            _this.setState(_defineProperty({}, name, value));
	        };
	
	        _this.validateSubmission = function () {
	            if (_this.state.expertise === '') {
	                alert('Enter Expertise');
	            } else if (_this.state.salExpData.length == 0) {
	                alert('Add Experience and salary details');
	            } else if (_this.state.status === '') {
	                alert('Select status');
	            } else {
	                if (_this.state.id == null) {
	                    _this.handleSubmit("");
	                } else {
	                    _this.updateValidateSubmission("");
	                }
	            }
	        };
	
	        _this.handleSubmit = function () {
	            var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	            var item = {
	                expertise: _this.state.expertise,
	                status: _this.state.status,
	                createdAt: newDate,
	                experienceSalaryDetails: _this.state.salExpData
	            };
	            _firebase.expertiseRef.push(item).then(function () {
	                alert("Saved Successfully");
	                window.location.href = "/expertise";
	            }).catch(function () {
	                alert("Somthing went wrong");
	            });
	        };
	
	        _this.handleNumberChange = function (event) {
	            var re = /^[0-9\b]+$/;
	            if (event.target.value === "" || re.test(event.target.value)) {} else {
	                (0, _jquery2.default)("#" + event.target.name).val("");
	            }
	        };
	
	        _this.state = {
	
	            expertise: "",
	            status: "",
	            id: null,
	            experienceData: [],
	            salExpData: []
	        };
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.validateSubmission = _this.validateSubmission.bind(_this);
	        _this.handleStatusChange = _this.handleStatusChange.bind(_this);
	        _this.updateValidateSubmission = _this.updateValidateSubmission.bind(_this);
	        _this.handleNumberChange = _this.handleNumberChange.bind(_this);
	        return _this;
	    }
	
	    _createClass(NewSkill, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var url = new URL(window.location.href);
	            var url_path = window.location.href.split("=");
	            var keyId = url_path[1];
	            this.renderList(keyId);
	        }
	    }, {
	        key: "addExpSalary",
	        value: function addExpSalary() {
	            var salExpData = this.state.salExpData;
	            salExpData.push({
	                experience: (0, _jquery2.default)("#experience").val(),
	                salaryMin: (0, _jquery2.default)("#salaryMin").val(),
	                salaryMax: (0, _jquery2.default)("#salaryMax").val()
	            });
	            this.setState({ salExpData: salExpData });
	            (0, _jquery2.default)("#experience").val("");
	            (0, _jquery2.default)("#salaryMin").val("");
	            (0, _jquery2.default)("#salaryMax").val("");
	        }
	    }, {
	        key: "removeExpSalary",
	        value: function removeExpSalary(a, b, c) {
	            var salExpData = this.state.salExpData;
	            var newArray = [];
	            salExpData.map(function (data, i) {
	                if (data.experience !== a && data.salaryMin !== b && data.salaryMax !== c) {
	                    newArray.push({
	                        experience: data.experience,
	                        salaryMin: data.salaryMin,
	                        salaryMax: data.salaryMax
	                    });
	                }
	            });
	            this.setState({ salExpData: newArray });
	        }
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(keyId) {
	                var dataList, id, ref, userRef, valueRef, snapshot, val, experienceList;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                dataList = [];
	                                id = keyId;
	                                ref = id ? '/expertise/' + id : 'expertise';
	                                userRef = _firebase.database.ref(ref);
	
	                                if (!id) {
	                                    _context.next = 8;
	                                    break;
	                                }
	
	                                _context.t0 = userRef;
	                                _context.next = 11;
	                                break;
	
	                            case 8:
	                                _context.next = 10;
	                                return userRef.orderByChild('key').equalTo('value');
	
	                            case 10:
	                                _context.t0 = _context.sent;
	
	                            case 11:
	                                valueRef = _context.t0;
	                                _context.next = 14;
	                                return valueRef.once('value');
	
	                            case 14:
	                                snapshot = _context.sent;
	                                val = snapshot.val();
	
	                                if (val) {
	                                    (0, _jquery2.default)("#expertise").val(val.expertise);
	                                    (0, _jquery2.default)("#expertiseStatus").val(val.status);
	                                    console.log("experienceSalaryDetails...", val.hasOwnProperty('experienceSalaryDetails'));
	                                    this.setState({
	                                        id: id,
	                                        expertise: val.expertise,
	                                        status: val.status
	                                    });
	                                    if (val.hasOwnProperty('experienceSalaryDetails')) {
	                                        this.setState({
	                                            salExpData: val.experienceSalaryDetails
	                                        });
	                                    }
	                                }
	                                experienceList = [];
	                                _context.next = 20;
	                                return _firebase.database.ref("experience").once('value', function (snapshot) {
	                                    snapshot.forEach(function (ChildSnapshot) {
	                                        if (ChildSnapshot.val().status == 'Active') {
	                                            experienceList.push({
	                                                experience: ChildSnapshot.val().experience
	                                            });
	                                        }
	                                    });
	                                });
	
	                            case 20:
	                                this.setState({
	                                    experienceData: experienceList
	                                });
	
	                            case 21:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function renderList(_x) {
	                return _ref.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "form",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/expertise" },
	                                            "Expertise"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "New Expertise"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Expertise"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "testimonialAuthor" },
	                                        "Expertise"
	                                    ),
	                                    _react2.default.createElement("input", { type: "text", className: "form-control", name: "expertise", onChange: this.handleChange,
	                                        id: "expertise"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { id: "whatyoudo", className: "form-group" },
	                                    _react2.default.createElement(
	                                        "select",
	                                        { className: "form-control", style: { marginLeft: "1px", marginTop: "50px", width: "255px" }, onChange: this.handleChange, id: "experience", name: "experience" },
	                                        _react2.default.createElement(
	                                            "option",
	                                            { key: "", value: "" },
	                                            "Select Experience"
	                                        ),
	                                        this.state.experienceData.map(function (x, y) {
	                                            return _react2.default.createElement(
	                                                "option",
	                                                { key: y },
	                                                x.experience
	                                            );
	                                        })
	                                    ),
	                                    _react2.default.createElement("input", {
	                                        type: "text",
	                                        className: "form-control", style: { marginLeft: "293px", marginTop: "-33px", width: "255px" },
	                                        name: "salaryMin",
	                                        id: "salaryMin",
	                                        onChange: this.handleChange,
	                                        placeholder: "Salary Min Value",
	                                        onKeyUp: this.handleNumberChange
	                                    }),
	                                    _react2.default.createElement("input", {
	                                        type: "text",
	                                        className: "form-control",
	                                        name: "salaryMax",
	                                        id: "salaryMax",
	                                        onChange: this.handleChange,
	                                        style: { marginLeft: "575px", marginTop: "-33px", width: "255px" },
	                                        placeholder: "Salary Max Value",
	                                        onKeyUp: this.handleNumberChange
	                                    }),
	                                    _react2.default.createElement("input", {
	                                        type: "button",
	                                        value: "Add",
	                                        onClick: function onClick() {
	                                            return _this2.addExpSalary();
	                                        },
	                                        style: { marginLeft: "857px", marginTop: "-36px", float: "right" }
	                                    }),
	                                    this.state.salExpData.length > 0 && _react2.default.createElement(
	                                        "table",
	                                        {
	                                            className: "table table-bordered",
	                                            style: { marginTop: "10px" }
	                                        },
	                                        _react2.default.createElement(
	                                            "thead",
	                                            null,
	                                            _react2.default.createElement(
	                                                "tr",
	                                                null,
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    "Experience"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    "Salary Min"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    "Salary Max"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "td",
	                                                    null,
	                                                    "Action"
	                                                )
	                                            )
	                                        ),
	                                        " ",
	                                        _react2.default.createElement(
	                                            "tbody",
	                                            null,
	                                            this.state.salExpData.map(function (data, i) {
	                                                return _react2.default.createElement(
	                                                    "tr",
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.experience
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.salaryMin
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.salaryMax
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        _react2.default.createElement("img", {
	                                                            src: _close2.default,
	                                                            alt: "",
	                                                            onClick: function onClick() {
	                                                                return _this2.removeExpSalary(data.experience, data.salaryMin, data.salaryMax);
	                                                            }
	                                                        })
	                                                    )
	                                                );
	                                            })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "skillStatus" },
	                                        " Status"
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        { className: "form-control", onChange: this.handleStatusChange, id: "expertiseStatus", name: "expertiseStatus" },
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "" },
	                                            "Select"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Active" },
	                                            "Active"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Inactive" },
	                                            "Inactive"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group mt-4" },
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/expertise" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { type: "button", className: "btn btn-primary", style: { float: "right", marginLeft: "10px" } },
	                                            "Cancel"
	                                        )
	                                    ),
	                                    this.state.id == null ? _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", onClick: this.validateSubmission, style: { float: "right" } },
	                                        "Submit"
	                                    ) : _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", onClick: this.validateSubmission, style: { float: "right" } },
	                                        "Update"
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return NewSkill;
	}(_react.Component);
	
	exports.default = NewSkill;

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _firebase = __webpack_require__(6);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewSkill = function (_Component) {
	    _inherits(NewSkill, _Component);
	
	    function NewSkill(props) {
	        var _this2 = this;
	
	        _classCallCheck(this, NewSkill);
	
	        var _this = _possibleConstructorReturn(this, (NewSkill.__proto__ || Object.getPrototypeOf(NewSkill)).call(this, props));
	
	        _this.updateValidateSubmission = function () {
	            var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	            var item = {
	                name: _this.state.name,
	                status: _this.state.status,
	                personna: _this.state.personna,
	                createdAt: newDate
	            };
	            _firebase.database.ref("goals/" + _this.state.id).update(item).then(function () {
	                alert("Updated Successfully");
	                window.location.href = "/goals";
	                _this.renderList();
	            }).catch(function () {
	                alert("Somthing went wrong");
	            });
	        };
	
	        _this.handleStatusChange = function (e) {
	            _this.setState({
	                status: e.target.value
	            });
	        };
	
	        _this.handlePersonnaChange = function (e) {
	            _this.setState({
	                personna: e.target.value
	            });
	        };
	
	        _this.handleChange = function (e) {
	            _this.setState({
	                name: e.target.value
	            });
	        };
	
	        _this.validateSubmission = function () {
	            if (_this.state.personna === '') {
	                alert('Enter Personna');
	            } else if (_this.state.name === '') {
	                alert('Enter Goal');
	            } else if (_this.state.status === '') {
	                alert('Select status');
	            } else {
	                if (_this.state.id == null) {
	                    _this.handleSubmit("");
	                } else {
	                    _this.updateValidateSubmission("");
	                }
	            }
	        };
	
	        _this.handleSubmit = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var newDate, count, item;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	                            count = 0;
	                            _context.next = 4;
	                            return _firebase.database.ref("goals").once('value', function (snapshot) {
	                                snapshot.forEach(function (ChildSnapshot) {
	                                    count = count + 1;
	                                });
	                            });
	
	                        case 4:
	                            item = {
	                                name: _this.state.name,
	                                status: _this.state.status,
	                                createdAt: newDate,
	                                personna: _this.state.personna,
	                                internalId: count + 1
	
	                            };
	
	                            _firebase.goalsRef.push(item).then(function () {
	                                alert("Saved Successfully");
	                                window.location.href = "/goals";
	                            }).catch(function () {
	                                alert("Somthing went wrong");
	                            });
	
	                        case 6:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2);
	        }));
	
	        _this.state = {
	
	            name: "",
	            status: "",
	            id: null,
	            personnaData: [],
	            personna: ''
	
	        };
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.validateSubmission = _this.validateSubmission.bind(_this);
	        _this.handleStatusChange = _this.handleStatusChange.bind(_this);
	        _this.updateValidateSubmission = _this.updateValidateSubmission.bind(_this);
	        _this.handlePersonnaChange = _this.handlePersonnaChange.bind(_this);
	        return _this;
	    }
	
	    _createClass(NewSkill, [{
	        key: "componentDidMount",
	        value: function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	                var url, url_path, keyId, personnaList;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                url = new URL(window.location.href);
	                                url_path = window.location.href.split("=");
	                                keyId = url_path[1];
	                                personnaList = [];
	                                _context2.next = 6;
	                                return _firebase.database.ref("personna").once('value', function (snapshot) {
	                                    snapshot.forEach(function (ChildSnapshot) {
	                                        if (ChildSnapshot.val().status == 'Active') {
	                                            personnaList.push({
	                                                key: ChildSnapshot.key,
	                                                name: ChildSnapshot.val().name,
	                                                internalId: ChildSnapshot.val().internalId
	                                            });
	                                        }
	                                    });
	                                });
	
	                            case 6:
	                                this.setState({
	                                    personnaData: personnaList
	                                });
	                                this.renderList(keyId);
	
	                            case 8:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function componentDidMount() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(keyId) {
	                var dataList, id, ref, userRef, valueRef, snapshot, val;
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                dataList = [];
	                                id = keyId;
	                                ref = id ? '/goals/' + id : 'goals';
	                                userRef = _firebase.database.ref(ref);
	
	                                if (!id) {
	                                    _context3.next = 8;
	                                    break;
	                                }
	
	                                _context3.t0 = userRef;
	                                _context3.next = 11;
	                                break;
	
	                            case 8:
	                                _context3.next = 10;
	                                return userRef.orderByChild('key').equalTo('value');
	
	                            case 10:
	                                _context3.t0 = _context3.sent;
	
	                            case 11:
	                                valueRef = _context3.t0;
	                                _context3.next = 14;
	                                return valueRef.once('value');
	
	                            case 14:
	                                snapshot = _context3.sent;
	                                val = snapshot.val();
	
	                                if (val) {
	                                    (0, _jquery2.default)("#name").val(val.name);
	                                    (0, _jquery2.default)("#goalsStatus").val(val.status);
	                                    (0, _jquery2.default)("#personna").val(val.personna);
	
	                                    this.setState({
	                                        id: id,
	                                        skill: val.skill,
	                                        status: val.status,
	                                        personna: val.personna,
	                                        name: val.name
	                                    });
	                                }
	
	                            case 17:
	                            case "end":
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function renderList(_x) {
	                return _ref3.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "form",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/goals" },
	                                            "Goals"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "New Goals"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Goals"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "expertisein" },
	                                        " Personna"
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        { className: "form-control", onChange: this.handlePersonnaChange, id: "personna", name: "personna" },
	                                        _react2.default.createElement(
	                                            "option",
	                                            { key: "" },
	                                            "Select Personna"
	                                        ),
	                                        this.state.personnaData.map(function (x, y) {
	                                            return _react2.default.createElement(
	                                                "option",
	                                                { key: x.internalId, value: x.internalId },
	                                                x.name
	                                            );
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "testimonialAuthor" },
	                                        "Goals"
	                                    ),
	                                    _react2.default.createElement("input", { type: "text", className: "form-control", name: "name", onChange: this.handleChange,
	                                        id: "name"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "goalsStatus" },
	                                        " Status"
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        { className: "form-control", onChange: this.handleStatusChange, id: "goalsStatus", name: "goalsStatus" },
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "" },
	                                            "Select"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Active" },
	                                            "Active"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Inactive" },
	                                            "Inactive"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group mt-4" },
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/goals" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { type: "button", className: "btn btn-primary", style: { float: "right", marginLeft: "10px" } },
	                                            "Cancel"
	                                        )
	                                    ),
	                                    this.state.id == null ? _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", onClick: this.validateSubmission, style: { float: "right" } },
	                                        "Submit"
	                                    ) : _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", onClick: this.validateSubmission, style: { float: "right" } },
	                                        "Update"
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return NewSkill;
	}(_react.Component);
	
	exports.default = NewSkill;

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _firebase = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewInsights = function (_Component) {
	  _inherits(NewInsights, _Component);
	
	  function NewInsights(props) {
	    _classCallCheck(this, NewInsights);
	
	    var _this = _possibleConstructorReturn(this, (NewInsights.__proto__ || Object.getPrototypeOf(NewInsights)).call(this, props));
	
	    _this.handleChange = function (event) {
	      var _event$target = event.target,
	          value = _event$target.value,
	          name = _event$target.name;
	
	      _this.setState(_defineProperty({}, name, value));
	    };
	
	    _this.state = {
	      insightTitle: '',
	      titleShortDescription: '',
	      description: ""
	
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(NewInsights, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var url = new URL(window.location.href);
	      var searchParams3 = new URLSearchParams(url.search);
	      var url_path = window.location.href.split("=");
	      var keyId = url_path[1];
	      this.renderList(keyId);
	    }
	  }, {
	    key: "renderList",
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(keyId) {
	        var dataList, id, batchesRef, ref, userRef, valueRef, snapshot, val;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                dataList = [];
	                id = keyId;
	                batchesRef = _firebase.database.ref(); // parent key of "batch-1", "batch-2", etc.
	                // assumed to be the database root here
	
	                ref = id ? '/insights/' + id : 'insights';
	                userRef = _firebase.database.ref(ref);
	
	                if (!id) {
	                  _context.next = 9;
	                  break;
	                }
	
	                _context.t0 = userRef;
	                _context.next = 12;
	                break;
	
	              case 9:
	                _context.next = 11;
	                return userRef.orderByChild('key').equalTo('value');
	
	              case 11:
	                _context.t0 = _context.sent;
	
	              case 12:
	                valueRef = _context.t0;
	                _context.next = 15;
	                return valueRef.once('value');
	
	              case 15:
	                snapshot = _context.sent;
	                val = snapshot.val();
	
	                if (val) {
	                  this.setState({ insightTitle: "2222" });
	                  (0, _jquery2.default)("#insightTitle").val(val.insightTitle);
	                  (0, _jquery2.default)("#description").val(val.description);
	                  (0, _jquery2.default)("#titleShortDescription").val(val.titleShortDescription);
	
	                  // dataList.push({key:id,insightTitle:val.insightTitle,
	                  //              description:val.description,
	                  //              titleShortDescription:val.titleShortDescription
	                  //            } )    
	                }
	
	              case 18:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function renderList(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return renderList;
	    }()
	  }, {
	    key: "saveInsights",
	    value: function saveInsights() {
	      if (this.state.insightTitle === '') {
	        alert('Enter Title');
	      } else if (this.state.titleShortDescription === '') {
	        alert('Enter title short description');
	      } else if (this.state.description === '') {
	        alert('Enter description');
	      } else {
	        var item = {
	          insightTitle: this.state.insightTitle,
	          titleShortDescription: this.state.titleShortDescription,
	          description: this.state.description
	        };
	        _firebase.insightRef.push(item).then(function () {
	          alert("Saved Successfully");
	          window.location.reload();
	        }).catch(function () {
	          alert("Somthing went wrong");
	        });
	        console.log(_firebase.insightRef);
	
	        this.setState({ description: '', titleShortDescription: '', insightTitle: '' });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content" },
	          _react2.default.createElement(_doctorLeftmenu2.default, null),
	          _react2.default.createElement(
	            "div",
	            { className: "content-right-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "form",
	                { className: "form-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-head" },
	                  "Insights"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group" },
	                  _react2.default.createElement(
	                    "label",
	                    { "for": "insightTitle" },
	                    "Title"
	                  ),
	                  _react2.default.createElement("input", { type: "text", className: "form-control", name: "insightTitle",
	                    id: "insightTitle", onChange: this.handleChange,
	                    defaultValue: this.state.insightTitle
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group" },
	                  _react2.default.createElement(
	                    "label",
	                    { "for": "titleShortDescription" },
	                    "Title Short Description"
	                  ),
	                  _react2.default.createElement("textarea", { className: "form-control", id: "titleShortDescription",
	                    name: "titleShortDescription", rows: "3", onChange: this.handleChange })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group" },
	                  _react2.default.createElement(
	                    "label",
	                    { "for": "description" },
	                    " Description"
	                  ),
	                  _react2.default.createElement("textarea", { className: "form-control", id: "description", name: "description",
	                    rows: "3", onChange: this.handleChange })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group mt-4" },
	                  _react2.default.createElement(
	                    "button",
	                    { type: "button", className: "btn btn-primary", onClick: function onClick() {
	                        return _this2.saveInsights();
	                      } },
	                    "Submit"
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_footer2.default, null)
	      );
	    }
	  }]);
	
	  return NewInsights;
	}(_react.Component);
	
	exports.default = NewInsights;

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _firebase = __webpack_require__(6);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Experience = function (_Component) {
	    _inherits(Experience, _Component);
	
	    function Experience(props) {
	        var _this2 = this;
	
	        _classCallCheck(this, Experience);
	
	        var _this = _possibleConstructorReturn(this, (Experience.__proto__ || Object.getPrototypeOf(Experience)).call(this, props));
	
	        _this.updateValidateSubmission = function () {
	            var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	            var item = {
	                institution: _this.state.institution,
	                status: _this.state.status,
	                createdAt: newDate
	            };
	            _firebase.database.ref("institution/" + _this.state.id).update(item).then(function () {
	                alert("Updated Successfully");
	                window.location.href = "/institution";
	                _this.renderList();
	            }).catch(function () {
	                alert("Somthing went wrong");
	            });
	        };
	
	        _this.handleStatusChange = function (e) {
	            _this.setState({
	                status: e.target.value
	            });
	        };
	
	        _this.handleChange = function (e) {
	            _this.setState({
	                institution: e.target.value
	            });
	        };
	
	        _this.validateSubmission = function () {
	            if (_this.state.institution === '') {
	                alert('Enter institution');
	            } else if (_this.state.status === '') {
	                alert('Select status');
	            } else {
	                if (_this.state.id == null) {
	                    _this.handleSubmit("");
	                } else {
	                    _this.updateValidateSubmission("");
	                }
	            }
	        };
	
	        _this.handleSubmit = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var newDate, count, item;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	                            count = 0;
	                            _context.next = 4;
	                            return _firebase.database.ref("institution").once('value', function (snapshot) {
	                                snapshot.forEach(function (ChildSnapshot) {
	                                    count = count + 1;
	                                });
	                            });
	
	                        case 4:
	                            item = {
	                                institution: _this.state.institution,
	                                status: _this.state.status,
	                                createdAt: newDate,
	                                internalId: count + 1
	                            };
	
	                            _firebase.institutionRef.push(item).then(function () {
	                                alert("Saved Successfully");
	                                window.location.href = "/institution";
	                            }).catch(function () {
	                                alert("Somthing went wrong");
	                            });
	
	                        case 6:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2);
	        }));
	
	        _this.state = {
	            institution: "",
	            status: "",
	            id: null
	
	        };
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.validateSubmission = _this.validateSubmission.bind(_this);
	        _this.handleStatusChange = _this.handleStatusChange.bind(_this);
	        _this.updateValidateSubmission = _this.updateValidateSubmission.bind(_this);
	        return _this;
	    }
	
	    _createClass(Experience, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var url = new URL(window.location.href);
	            var url_path = window.location.href.split("=");
	            var keyId = url_path[1];
	            this.renderList(keyId);
	        }
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(keyId) {
	                var id, ref, userRef, valueRef, snapshot, val;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                id = keyId;
	                                ref = id ? '/institution/' + id : 'institution';
	                                userRef = _firebase.database.ref(ref);
	
	                                if (!id) {
	                                    _context2.next = 7;
	                                    break;
	                                }
	
	                                _context2.t0 = userRef;
	                                _context2.next = 10;
	                                break;
	
	                            case 7:
	                                _context2.next = 9;
	                                return userRef.orderByChild('key').equalTo('value');
	
	                            case 9:
	                                _context2.t0 = _context2.sent;
	
	                            case 10:
	                                valueRef = _context2.t0;
	                                _context2.next = 13;
	                                return valueRef.once('value');
	
	                            case 13:
	                                snapshot = _context2.sent;
	                                val = snapshot.val();
	
	                                if (val) {
	                                    (0, _jquery2.default)("#institution").val(val.institution);
	                                    (0, _jquery2.default)("#institutionStatus").val(val.status);
	                                    this.setState({
	                                        id: id,
	                                        institution: val.institution,
	                                        status: val.status
	                                    });
	                                }
	
	                            case 16:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function renderList(_x) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "form",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/institution" },
	                                            "Institution"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "New institution"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Institution"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "testimonialAuthor" },
	                                        "institution"
	                                    ),
	                                    _react2.default.createElement("input", { type: "text", className: "form-control", name: "institution", onChange: this.handleChange,
	                                        id: "institution"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "institutionStatus" },
	                                        " Status"
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        { className: "form-control", onChange: this.handleStatusChange, id: "institutionStatus", name: "institutionStatus" },
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "" },
	                                            "Select"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Active" },
	                                            "Active"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Inactive" },
	                                            "Inactive"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group mt-4" },
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/institution" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { type: "button", className: "btn btn-primary", style: { float: "right", marginLeft: "10px" } },
	                                            "Cancel"
	                                        )
	                                    ),
	                                    this.state.id == null ? _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", onClick: this.validateSubmission, style: { float: "right" } },
	                                        "Submit"
	                                    ) : _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", onClick: this.validateSubmission, style: { float: "right" } },
	                                        "Update"
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return Experience;
	}(_react.Component);
	
	exports.default = Experience;

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _firebase = __webpack_require__(6);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Experience = function (_Component) {
	    _inherits(Experience, _Component);
	
	    function Experience(props) {
	        var _this2 = this;
	
	        _classCallCheck(this, Experience);
	
	        var _this = _possibleConstructorReturn(this, (Experience.__proto__ || Object.getPrototypeOf(Experience)).call(this, props));
	
	        _this.updateValidateSubmission = function () {
	            var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	            var item = {
	                modeOfLearning: _this.state.modeOfLearning,
	                status: _this.state.status,
	                createdAt: newDate
	            };
	            _firebase.database.ref("modeOfLearning/" + _this.state.id).update(item).then(function () {
	                alert("Updated Successfully");
	                window.location.href = "/modeOfLearning";
	                _this.renderList();
	            }).catch(function () {
	                alert("Somthing went wrong");
	            });
	        };
	
	        _this.handleStatusChange = function (e) {
	            _this.setState({
	                status: e.target.value
	            });
	        };
	
	        _this.handleChange = function (e) {
	            _this.setState({
	                modeOfLearning: e.target.value
	            });
	        };
	
	        _this.validateSubmission = function () {
	            if (_this.state.modeOfLearning === '') {
	                alert('Enter Mode Of Learning');
	            } else if (_this.state.status === '') {
	                alert('Select status');
	            } else {
	                if (_this.state.id == null) {
	                    _this.handleSubmit("");
	                } else {
	                    _this.updateValidateSubmission("");
	                }
	            }
	        };
	
	        _this.handleSubmit = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var newDate, count, item;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	                            count = 0;
	                            _context.next = 4;
	                            return _firebase.database.ref("modeOfLearning").once('value', function (snapshot) {
	                                snapshot.forEach(function (ChildSnapshot) {
	                                    count = count + 1;
	                                });
	                            });
	
	                        case 4:
	                            item = {
	                                modeOfLearning: _this.state.modeOfLearning,
	                                status: _this.state.status,
	                                createdAt: newDate,
	                                internalId: count + 1
	                            };
	
	                            _firebase.modeOfLearningRef.push(item).then(function () {
	                                alert("Saved Successfully");
	                                window.location.href = "/modeOfLearning";
	                            }).catch(function () {
	                                alert("Somthing went wrong");
	                            });
	
	                        case 6:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2);
	        }));
	
	        _this.state = {
	            modeOfLearning: "",
	            status: "",
	            id: null
	
	        };
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.validateSubmission = _this.validateSubmission.bind(_this);
	        _this.handleStatusChange = _this.handleStatusChange.bind(_this);
	        _this.updateValidateSubmission = _this.updateValidateSubmission.bind(_this);
	        return _this;
	    }
	
	    _createClass(Experience, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var url = new URL(window.location.href);
	            var url_path = window.location.href.split("=");
	            var keyId = url_path[1];
	            this.renderList(keyId);
	        }
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(keyId) {
	                var id, ref, userRef, valueRef, snapshot, val;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                id = keyId;
	                                ref = id ? '/modeOfLearning/' + id : 'modeOfLearning';
	                                userRef = _firebase.database.ref(ref);
	
	                                if (!id) {
	                                    _context2.next = 7;
	                                    break;
	                                }
	
	                                _context2.t0 = userRef;
	                                _context2.next = 10;
	                                break;
	
	                            case 7:
	                                _context2.next = 9;
	                                return userRef.orderByChild('key').equalTo('value');
	
	                            case 9:
	                                _context2.t0 = _context2.sent;
	
	                            case 10:
	                                valueRef = _context2.t0;
	                                _context2.next = 13;
	                                return valueRef.once('value');
	
	                            case 13:
	                                snapshot = _context2.sent;
	                                val = snapshot.val();
	
	                                if (val) {
	                                    (0, _jquery2.default)("#modeOfLearning").val(val.modeOfLearning);
	                                    (0, _jquery2.default)("#modeOfLearningStatus").val(val.status);
	                                    this.setState({
	                                        id: id,
	                                        modeOfLearning: val.modeOfLearning,
	                                        status: val.status
	                                    });
	                                }
	
	                            case 16:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function renderList(_x) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "form",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/modeOfLearning" },
	                                            "Mode Of Learning"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "New Mode Of Learning"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Mode Of Learning"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "testimonialAuthor" },
	                                        "Mode Of Learning"
	                                    ),
	                                    _react2.default.createElement("input", { type: "text", className: "form-control", name: "modeOfLearning", onChange: this.handleChange,
	                                        id: "modeOfLearning"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "modeOfLearningStatus" },
	                                        " Status"
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        { className: "form-control", onChange: this.handleStatusChange, id: "modeOfLearningStatus", name: "modeOfLearningStatus" },
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "" },
	                                            "Select"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Active" },
	                                            "Active"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Inactive" },
	                                            "Inactive"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group mt-4" },
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/modeOfLearning" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { type: "button", className: "btn btn-primary", style: { float: "right", marginLeft: "10px" } },
	                                            "Cancel"
	                                        )
	                                    ),
	                                    this.state.id == null ? _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", onClick: this.validateSubmission, style: { float: "right" } },
	                                        "Submit"
	                                    ) : _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", onClick: this.validateSubmission, style: { float: "right" } },
	                                        "Update"
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return Experience;
	}(_react.Component);
	
	exports.default = Experience;

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _firebase = __webpack_require__(6);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Personna = function (_Component) {
	    _inherits(Personna, _Component);
	
	    function Personna(props) {
	        var _this2 = this;
	
	        _classCallCheck(this, Personna);
	
	        var _this = _possibleConstructorReturn(this, (Personna.__proto__ || Object.getPrototypeOf(Personna)).call(this, props));
	
	        _this.updateValidateSubmission = function () {
	            var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	            var item = {
	                name: _this.state.name,
	                status: _this.state.status,
	                createdAt: newDate
	            };
	            _firebase.database.ref("personna/" + _this.state.id).update(item).then(function () {
	                alert("Updated Successfully");
	                window.location.href = "/personna";
	                _this.renderList();
	            }).catch(function () {
	                alert("Somthing went wrong");
	            });
	        };
	
	        _this.handleStatusChange = function (e) {
	            _this.setState({
	                status: e.target.value
	            });
	        };
	
	        _this.handleChange = function (e) {
	            _this.setState({
	                name: e.target.value
	            });
	        };
	
	        _this.validateSubmission = function () {
	            if (_this.state.name === '') {
	                alert('Enter Personna');
	            } else if (_this.state.status === '') {
	                alert('Select status');
	            } else {
	                if (_this.state.id == null) {
	                    _this.handleSubmit("");
	                } else {
	                    _this.updateValidateSubmission("");
	                }
	            }
	        };
	
	        _this.handleSubmit = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var newDate, count, item;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	                            count = 0;
	                            _context.next = 4;
	                            return _firebase.database.ref("personna").once('value', function (snapshot) {
	                                snapshot.forEach(function (ChildSnapshot) {
	                                    count = count + 1;
	                                });
	                            });
	
	                        case 4:
	                            item = {
	                                name: _this.state.name,
	                                status: _this.state.status,
	                                createdAt: newDate,
	                                internalId: count + 1
	                            };
	
	                            _firebase.personnaRef.push(item).then(function () {
	                                alert("Saved Successfully");
	                                window.location.href = "/personna";
	                            }).catch(function () {
	                                alert("Somthing went wrong");
	                            });
	
	                        case 6:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2);
	        }));
	
	        _this.state = {
	            name: "",
	            status: "",
	            id: null
	
	        };
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.validateSubmission = _this.validateSubmission.bind(_this);
	        _this.handleStatusChange = _this.handleStatusChange.bind(_this);
	        _this.updateValidateSubmission = _this.updateValidateSubmission.bind(_this);
	        return _this;
	    }
	
	    _createClass(Personna, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var url = new URL(window.location.href);
	            var url_path = window.location.href.split("=");
	            var keyId = url_path[1];
	            this.renderList(keyId);
	        }
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(keyId) {
	                var id, ref, userRef, valueRef, snapshot, val;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                id = keyId;
	                                ref = id ? '/personna/' + id : 'personna';
	
	                                console.log("ref...", ref);
	                                userRef = _firebase.database.ref(ref);
	
	                                if (!id) {
	                                    _context2.next = 8;
	                                    break;
	                                }
	
	                                _context2.t0 = userRef;
	                                _context2.next = 11;
	                                break;
	
	                            case 8:
	                                _context2.next = 10;
	                                return userRef.orderByChild('key').equalTo('value');
	
	                            case 10:
	                                _context2.t0 = _context2.sent;
	
	                            case 11:
	                                valueRef = _context2.t0;
	                                _context2.next = 14;
	                                return valueRef.once('value');
	
	                            case 14:
	                                snapshot = _context2.sent;
	                                val = snapshot.val();
	
	                                if (val) {
	                                    console.log("val...", val);
	                                    (0, _jquery2.default)("#name").val(val.name);
	                                    (0, _jquery2.default)("#personnaStatus").val(val.status);
	                                    this.setState({
	                                        id: id,
	                                        name: val.name,
	                                        status: val.status
	                                    });
	                                }
	
	                            case 17:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function renderList(_x) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "form",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/personna" },
	                                            "Personna"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "New Personna"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Personna"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "testimonialAuthor" },
	                                        "Personna"
	                                    ),
	                                    _react2.default.createElement("input", { type: "text", className: "form-control", name: "name", onChange: this.handleChange,
	                                        id: "name"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "personnaStatus" },
	                                        " Status"
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        { className: "form-control", onChange: this.handleStatusChange, id: "personnaStatus", name: "personnaStatus" },
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "" },
	                                            "Select"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Active" },
	                                            "Active"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Inactive" },
	                                            "Inactive"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group mt-4" },
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/personna" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { type: "button", className: "btn btn-primary", style: { float: "right", marginLeft: "10px" } },
	                                            "Cancel"
	                                        )
	                                    ),
	                                    this.state.id == null ? _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", onClick: this.validateSubmission, style: { float: "right" } },
	                                        "Submit"
	                                    ) : _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", onClick: this.validateSubmission, style: { float: "right" } },
	                                        "Update"
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return Personna;
	}(_react.Component);
	
	exports.default = Personna;

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _firebase = __webpack_require__(6);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Experience = function (_Component) {
	    _inherits(Experience, _Component);
	
	    function Experience(props) {
	        _classCallCheck(this, Experience);
	
	        var _this = _possibleConstructorReturn(this, (Experience.__proto__ || Object.getPrototypeOf(Experience)).call(this, props));
	
	        _this.updateValidateSubmission = function () {
	            var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	            var item = {
	                priceRange: _this.state.priceRange,
	                status: _this.state.status,
	                createdAt: newDate
	            };
	            _firebase.database.ref("priceRange/" + _this.state.id).update(item).then(function () {
	                alert("Updated Successfully");
	                window.location.href = "/priceRange";
	                _this.renderList();
	            }).catch(function () {
	                alert("Somthing went wrong");
	            });
	        };
	
	        _this.handleStatusChange = function (e) {
	            _this.setState({
	                status: e.target.value
	            });
	        };
	
	        _this.handleChange = function (e) {
	            _this.setState({
	                priceRange: e.target.value
	            });
	        };
	
	        _this.validateSubmission = function () {
	            if (_this.state.priceRange === '') {
	                alert('Enter Price Range');
	            } else if (_this.state.status === '') {
	                alert('Select status');
	            } else {
	                if (_this.state.id == null) {
	                    _this.handleSubmit("");
	                } else {
	                    _this.updateValidateSubmission("");
	                }
	            }
	        };
	
	        _this.handleSubmit = function () {
	            var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	            var item = {
	                priceRange: _this.state.priceRange,
	                status: _this.state.status,
	                createdAt: newDate
	            };
	            _firebase.priceRangeRef.push(item).then(function () {
	                alert("Saved Successfully");
	                window.location.href = "/priceRange";
	            }).catch(function () {
	                alert("Somthing went wrong");
	            });
	        };
	
	        _this.state = {
	            priceRange: "",
	            status: "",
	            id: null
	
	        };
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.validateSubmission = _this.validateSubmission.bind(_this);
	        _this.handleStatusChange = _this.handleStatusChange.bind(_this);
	        _this.updateValidateSubmission = _this.updateValidateSubmission.bind(_this);
	        return _this;
	    }
	
	    _createClass(Experience, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var url = new URL(window.location.href);
	            var url_path = window.location.href.split("=");
	            var keyId = url_path[1];
	            this.renderList(keyId);
	        }
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(keyId) {
	                var id, ref, userRef, valueRef, snapshot, val;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                id = keyId;
	                                ref = id ? '/priceRange/' + id : 'priceRange';
	                                userRef = _firebase.database.ref(ref);
	
	                                if (!id) {
	                                    _context.next = 7;
	                                    break;
	                                }
	
	                                _context.t0 = userRef;
	                                _context.next = 10;
	                                break;
	
	                            case 7:
	                                _context.next = 9;
	                                return userRef.orderByChild('key').equalTo('value');
	
	                            case 9:
	                                _context.t0 = _context.sent;
	
	                            case 10:
	                                valueRef = _context.t0;
	                                _context.next = 13;
	                                return valueRef.once('value');
	
	                            case 13:
	                                snapshot = _context.sent;
	                                val = snapshot.val();
	
	                                if (val) {
	                                    (0, _jquery2.default)("#priceRange").val(val.priceRange);
	                                    (0, _jquery2.default)("#priceRangeStatus").val(val.status);
	                                    this.setState({
	                                        id: id,
	                                        priceRange: val.priceRange,
	                                        status: val.status
	                                    });
	                                }
	
	                            case 16:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function renderList(_x) {
	                return _ref.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "form",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/priceRange" },
	                                            "Price Range"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "New Price Range"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Price Range"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "testimonialAuthor" },
	                                        "Price Range"
	                                    ),
	                                    _react2.default.createElement("input", { type: "text", className: "form-control", name: "priceRange", onChange: this.handleChange,
	                                        id: "priceRange"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "priceRangeStatus" },
	                                        " Status"
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        { className: "form-control", onChange: this.handleStatusChange, id: "priceRangeStatus", name: "priceRangeStatus" },
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "" },
	                                            "Select"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Active" },
	                                            "Active"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Inactive" },
	                                            "Inactive"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group mt-4" },
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/priceRange" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { type: "button", className: "btn btn-primary", style: { float: "right", marginLeft: "10px" } },
	                                            "Cancel"
	                                        )
	                                    ),
	                                    this.state.id == null ? _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", onClick: this.validateSubmission, style: { float: "right" } },
	                                        "Submit"
	                                    ) : _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", onClick: this.validateSubmission, style: { float: "right" } },
	                                        "Update"
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return Experience;
	}(_react.Component);
	
	exports.default = Experience;

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _firebase = __webpack_require__(6);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewSkill = function (_Component) {
	    _inherits(NewSkill, _Component);
	
	    function NewSkill(props) {
	        _classCallCheck(this, NewSkill);
	
	        var _this = _possibleConstructorReturn(this, (NewSkill.__proto__ || Object.getPrototypeOf(NewSkill)).call(this, props));
	
	        _this.updateValidateSubmission = function () {
	            var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	            var item = {
	                skill: _this.state.skill,
	                status: _this.state.status,
	                expertise: _this.state.expertise,
	                createdAt: newDate
	            };
	            _firebase.database.ref("skills/" + _this.state.id).update(item).then(function () {
	                alert("Updated Successfully");
	                window.location.href = "/skills";
	                _this.renderList();
	            }).catch(function () {
	                alert("Somthing went wrong");
	            });
	        };
	
	        _this.handleStatusChange = function (e) {
	            _this.setState({
	                status: e.target.value
	            });
	        };
	
	        _this.handleExpertiseChange = function (e) {
	            _this.setState({
	                expertise: e.target.value
	            });
	        };
	
	        _this.handleChange = function (e) {
	            _this.setState({
	                author: e.target.value
	            });
	        };
	
	        _this.validateSubmission = function () {
	            if (_this.state.expertise === '') {
	                alert('Enter Expertise');
	            }
	            if (_this.state.skill === '') {
	                alert('Enter Skill');
	            } else if (_this.state.status === '') {
	                alert('Select status');
	            } else {
	                if (_this.state.id == null) {
	                    _this.handleSubmit("");
	                } else {
	                    _this.updateValidateSubmission("");
	                }
	            }
	        };
	
	        _this.handleSubmit = function () {
	            var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	            var item = {
	                skill: _this.state.author,
	                status: _this.state.status,
	                createdAt: newDate,
	                expertise: _this.state.expertise
	
	            };
	            _firebase.skillsRef.push(item).then(function () {
	                alert("Saved Successfully");
	                window.location.href = "/skills";
	            }).catch(function () {
	                alert("Somthing went wrong");
	            });
	        };
	
	        _this.state = {
	
	            skills: "",
	            status: "",
	            id: null,
	            expertiseData: [],
	            expertise: ''
	
	        };
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.validateSubmission = _this.validateSubmission.bind(_this);
	        _this.handleStatusChange = _this.handleStatusChange.bind(_this);
	        _this.updateValidateSubmission = _this.updateValidateSubmission.bind(_this);
	        _this.handleExpertiseChange = _this.handleExpertiseChange.bind(_this);
	        return _this;
	    }
	
	    _createClass(NewSkill, [{
	        key: "componentDidMount",
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var url, url_path, keyId, expertiseList;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                url = new URL(window.location.href);
	                                url_path = window.location.href.split("=");
	                                keyId = url_path[1];
	                                expertiseList = [];
	                                _context.next = 6;
	                                return _firebase.database.ref("expertise").once('value', function (snapshot) {
	                                    snapshot.forEach(function (ChildSnapshot) {
	                                        if (ChildSnapshot.val().status == 'Active') {
	                                            expertiseList.push({
	                                                key: ChildSnapshot.key,
	                                                expertise: ChildSnapshot.val().expertise
	                                            });
	                                        }
	                                    });
	                                });
	
	                            case 6:
	                                this.setState({
	                                    expertiseData: expertiseList
	                                });
	                                this.renderList(keyId);
	
	                            case 8:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentDidMount() {
	                return _ref.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(keyId) {
	                var dataList, id, ref, userRef, valueRef, snapshot, val;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                dataList = [];
	                                id = keyId;
	                                ref = id ? '/skills/' + id : 'skills';
	                                userRef = _firebase.database.ref(ref);
	
	                                if (!id) {
	                                    _context2.next = 8;
	                                    break;
	                                }
	
	                                _context2.t0 = userRef;
	                                _context2.next = 11;
	                                break;
	
	                            case 8:
	                                _context2.next = 10;
	                                return userRef.orderByChild('key').equalTo('value');
	
	                            case 10:
	                                _context2.t0 = _context2.sent;
	
	                            case 11:
	                                valueRef = _context2.t0;
	                                _context2.next = 14;
	                                return valueRef.once('value');
	
	                            case 14:
	                                snapshot = _context2.sent;
	                                val = snapshot.val();
	
	                                if (val) {
	                                    (0, _jquery2.default)("#skill").val(val.skill);
	                                    (0, _jquery2.default)("#skillStatus").val(val.status);
	                                    (0, _jquery2.default)("#expertise").val(val.expertise);
	
	                                    this.setState({
	                                        id: id,
	                                        skill: val.skill,
	                                        status: val.status,
	                                        expertise: val.expertise
	                                    });
	                                }
	
	                            case 17:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function renderList(_x) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "form",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/skills" },
	                                            "Skills"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "New Skills"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Skills"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "expertisein" },
	                                        " Expertise"
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        { className: "form-control", onChange: this.handleExpertiseChange, id: "expertise", name: "expertise" },
	                                        _react2.default.createElement(
	                                            "option",
	                                            { key: "" },
	                                            "Select Expertise"
	                                        ),
	                                        this.state.expertiseData.map(function (x, y) {
	                                            return _react2.default.createElement(
	                                                "option",
	                                                { key: y },
	                                                x.expertise
	                                            );
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "testimonialAuthor" },
	                                        "Skills"
	                                    ),
	                                    _react2.default.createElement("input", { type: "text", className: "form-control", name: "skill", onChange: this.handleChange,
	                                        id: "skill"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "skillStatus" },
	                                        " Status"
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        { className: "form-control", onChange: this.handleStatusChange, id: "skillStatus", name: "skillStatus" },
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "" },
	                                            "Select"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Active" },
	                                            "Active"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Inactive" },
	                                            "Inactive"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group mt-4" },
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/skills" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { type: "button", className: "btn btn-primary", style: { float: "right", marginLeft: "10px" } },
	                                            "Cancel"
	                                        )
	                                    ),
	                                    this.state.id == null ? _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", onClick: this.validateSubmission, style: { float: "right" } },
	                                        "Submit"
	                                    ) : _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", onClick: this.validateSubmission, style: { float: "right" } },
	                                        "Update"
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return NewSkill;
	}(_react.Component);
	
	exports.default = NewSkill;

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _firebase = __webpack_require__(6);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _newStoriesEditor = __webpack_require__(103);
	
	var _newStoriesEditor2 = _interopRequireDefault(_newStoriesEditor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewStories = function (_Component) {
	    _inherits(NewStories, _Component);
	
	    function NewStories(props) {
	        var _this2 = this;
	
	        _classCallCheck(this, NewStories);
	
	        var _this = _possibleConstructorReturn(this, (NewStories.__proto__ || Object.getPrototypeOf(NewStories)).call(this, props));
	
	        _this.updateValidateSubmission = function (url) {
	            var textEditorContent = document.getElementById("toolsRTEstory_rte-edit-view");
	            var description = textEditorContent.innerHTML;
	            var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	            var item = {
	                title: _this.state.title,
	                imageUrl: url ? url : _this.state.storyUrl,
	                description: description,
	                shortDescription: _this.state.shortDescription,
	                category: _this.state.category,
	                mainCategory: _this.state.mainCategory,
	                status: _this.state.status,
	                createdAt: newDate
	
	            };
	            _firebase.database.ref("stories/" + _this.state.id).update(item).then(function () {
	                alert("Updated Successfully");
	                window.location.href = "/stories";
	                _this.renderList();
	            }).catch(function () {
	                alert("Somthing went wrong");
	            });
	        };
	
	        _this.validateSubmission = function () {
	
	            if (_this.state.title === '') {
	                alert('Enter Title');
	            } else if (_this.state.storyImage === '' || _this.state.storyImage === undefined) {
	                alert('Upload File ');
	            } else if (_this.state.mainCategory === '') {
	                alert('Select main category');
	            } else if (_this.state.category === '') {
	                alert('Select category');
	            } else if (_this.state.status === '') {
	                alert('Select status');
	            } else if (_this.state.shortDescription === '') {
	                alert('Enter short description');
	            } else {
	                if (_this.state.fileName) {
	                    var uploadTask = _firebase.storage.ref("stories/" + _this.state.storyImage.name).put(_this.state.storyImage);
	                    uploadTask.on("state_changed", function (snapshot) {
	                        var progress = Math.round(snapshot.bytesTransferred / snapshot.totalBytes * 100);
	                        _this.setState({
	                            progress: progress
	                        });
	                    }, function (error) {
	                        console.log(error);
	                    }, function () {
	                        _firebase.storage.ref("stories").child(_this.state.storyImage.name).getDownloadURL().then(function (url) {
	                            (0, _jquery2.default)("#imageUrl").attr('src', url);
	                            _this.setState({
	                                url: url
	                            });
	                            if (_this.state.id == null) {
	                                _this.handleSubmit(url);
	                            } else {
	                                _this.updateValidateSubmission(url);
	                            }
	                        });
	                    });
	                } else {
	                    if (_this.state.id == null) {
	                        _this.handleSubmit("");
	                    } else {
	                        _this.updateValidateSubmission("");
	                    }
	                }
	            }
	        };
	
	        _this.handleSubmit = function (url) {
	            var textEditorContent = document.getElementById("toolsRTEstory_rte-edit-view");
	            var description = textEditorContent.innerHTML;
	            var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	            var item = {
	                title: _this.state.title,
	                imageUrl: url ? url : _this.state.storyUrl,
	                description: description,
	                shortDescription: _this.state.shortDescription,
	                category: _this.state.category,
	                mainCategory: _this.state.mainCategory,
	                status: _this.state.status,
	                createdAt: newDate
	            };
	            _firebase.storyRef.push(item).then(function () {
	                alert("Saved Successfully");
	                window.location.href = "/stories";
	            }).catch(function () {
	                alert("Somthing went wrong");
	            });
	        };
	
	        _this.handleImageChange = function (e) {
	            if (e.target.files[0]) {
	                _this.setState({
	                    storyImage: e.target.files[0],
	                    fileName: true
	                });
	            }
	        };
	
	        _this.handleStatusChange = function (e) {
	            _this.setState({
	                status: e.target.value
	            });
	        };
	
	        _this.handleMainCategoryChange = function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(e) {
	                var mainCategory, storyCategoryList;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _this.setState({
	                                    mainCategory: e.target.value
	                                });
	                                mainCategory = e.target.value;
	                                storyCategoryList = [];
	                                _context.next = 5;
	                                return _firebase.database.ref("storyCategory").once('value', function (snapshot) {
	                                    snapshot.forEach(function (ChildSnapshot) {
	                                        if (ChildSnapshot.val().status == 'Active' && mainCategory === ChildSnapshot.val().mainCategory) {
	                                            storyCategoryList.push({
	                                                key: ChildSnapshot.key,
	                                                name: ChildSnapshot.val().name
	                                            });
	                                        }
	                                    });
	                                });
	
	                            case 5:
	                                _this.setState({
	                                    storyCategoryData: storyCategoryList
	                                });
	
	                            case 6:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, _this2);
	            }));
	
	            return function (_x) {
	                return _ref.apply(this, arguments);
	            };
	        }();
	
	        _this.handleCategoryChange = function (e) {
	            _this.setState({
	                category: e.target.value
	            });
	        };
	
	        _this.handleChange = function (e) {
	            _this.setState({
	                title: e.target.value
	            });
	        };
	
	        _this.handleShortDescriptionChange = function (e) {
	            _this.setState({
	                shortDescription: e.target.value
	            });
	        };
	
	        _this.state = {
	            title: "",
	            status: "",
	            category: "",
	            mainCategory: "",
	            description: "",
	            shortDescription: "",
	            storyCategoryData: []
	        };
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleStatusChange = _this.handleStatusChange.bind(_this);
	        _this.handleCategoryChange = _this.handleCategoryChange.bind(_this);
	        _this.handleImageChange = _this.handleImageChange.bind(_this);
	        _this.handleShortDescriptionChange = _this.handleShortDescriptionChange.bind(_this);
	        _this.validateSubmission = _this.validateSubmission.bind(_this);
	        _this.updateValidateSubmission = _this.updateValidateSubmission.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.handleMainCategoryChange = _this.handleMainCategoryChange.bind(_this);
	        return _this;
	    }
	
	    _createClass(NewStories, [{
	        key: "componentDidMount",
	        value: function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	                var url, url_path, keyId;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                url = new URL(window.location.href);
	                                url_path = window.location.href.split("=");
	                                keyId = url_path[1];
	
	                                this.renderList(keyId);
	
	                            case 4:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function componentDidMount() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(keyId) {
	                var dataList, id, ref, userRef, valueRef, snapshot, val, storyCategoryList, textEditorContent;
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                dataList = [];
	                                id = keyId;
	                                ref = id ? '/stories/' + id : 'stories';
	                                userRef = _firebase.database.ref(ref);
	
	                                if (!id) {
	                                    _context3.next = 8;
	                                    break;
	                                }
	
	                                _context3.t0 = userRef;
	                                _context3.next = 11;
	                                break;
	
	                            case 8:
	                                _context3.next = 10;
	                                return userRef.orderByChild('key').equalTo('value');
	
	                            case 10:
	                                _context3.t0 = _context3.sent;
	
	                            case 11:
	                                valueRef = _context3.t0;
	                                _context3.next = 14;
	                                return valueRef.once('value');
	
	                            case 14:
	                                snapshot = _context3.sent;
	                                val = snapshot.val();
	
	                                if (!val) {
	                                    _context3.next = 30;
	                                    break;
	                                }
	
	                                (0, _jquery2.default)("#storyTitle").val(val.title);
	                                (0, _jquery2.default)("#storyImage").val(val.imageUrl);
	                                (0, _jquery2.default)("#storyStatus").val(val.status);
	                                storyCategoryList = [];
	                                _context3.next = 23;
	                                return _firebase.database.ref("storyCategory").once('value', function (snapshot) {
	                                    snapshot.forEach(function (ChildSnapshot) {
	                                        if (ChildSnapshot.val().status == 'Active' && val.mainCategory === ChildSnapshot.val().mainCategory) {
	                                            storyCategoryList.push({
	                                                key: ChildSnapshot.key,
	                                                name: ChildSnapshot.val().name
	                                            });
	                                        }
	                                    });
	                                });
	
	                            case 23:
	                                this.setState({
	                                    storyCategoryData: storyCategoryList
	                                });
	                                (0, _jquery2.default)("#storyCategory").val(val.category);
	                                (0, _jquery2.default)("#mainCategory").val(val.mainCategory);
	                                (0, _jquery2.default)("#shortDescription").val(val.shortDescription);
	                                textEditorContent = document.getElementById("toolsRTEstory_rte-edit-view");
	
	                                textEditorContent.innerHTML = val.description;
	
	                                this.setState({
	                                    storyUrl: val.imageUrl,
	                                    id: id,
	                                    title: val.title,
	                                    status: val.status,
	                                    storyImage: val.imageUrl,
	                                    description: val.description,
	                                    shortDescription: val.shortDescription,
	                                    category: val.category,
	                                    mainCategory: val.mainCategory
	                                });
	
	                            case 30:
	                            case "end":
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function renderList(_x2) {
	                return _ref3.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	
	
	        // uploadImageCallBack = (file, callback) => {
	        //     console.log(file);
	        //     return new Promise((resolve, reject) => {
	        //         const reader = new window.FileReader();
	        //         console.log(reader);
	        //         reader.onloadend = async () => {
	        //             const form_data = new FormData();
	        //             form_data.append("file", file);
	        //             // const res = await uploadFile(form_data);
	        //             // setValue("thumbnail", res.data);
	        //             // resolve({ data: { link: process.env.REACT_APP_API + res.data } });
	        //         };
	        //         reader.readAsDataURL(file);
	        //     });
	        // };
	
	
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "form",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/stories" },
	                                            "Stories"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "New Stories"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Stories"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "storyTitle" },
	                                        "Title"
	                                    ),
	                                    _react2.default.createElement("input", { type: "text", className: "form-control", name: "storyTitle", onChange: this.handleChange,
	                                        id: "storyTitle"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "imageUrl" },
	                                        "Image/Video"
	                                    ),
	                                    _react2.default.createElement("input", { type: "file", onChange: this.handleImageChange, id: "imageUrl", name: "imageUrl", className: "form-group" }),
	                                    this.state.fileName || this.state.storyUrl && _react2.default.createElement("img", { src: this.state.storyUrl, id: "imageUrl", style: { width: "100px", height: "100px" } })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "storyCategory" },
	                                        "Main Category"
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        { className: "form-control", onChange: this.handleMainCategoryChange, id: "mainCategory", name: "mainCategory" },
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "" },
	                                            "Select"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Course Reviews" },
	                                            "Course Reviews"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Stories" },
	                                            "Stories"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Blogs" },
	                                            "Blogs"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "storyCategory" },
	                                        " Category"
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        { className: "form-control", onChange: this.handleCategoryChange, id: "storyCategory", name: "storyCategory" },
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "" },
	                                            "Select"
	                                        ),
	                                        this.state.storyCategoryData.map(function (x, y) {
	                                            return _react2.default.createElement(
	                                                "option",
	                                                { key: y },
	                                                x.name
	                                            );
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "storyStatus" },
	                                        " Status"
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        { className: "form-control", onChange: this.handleStatusChange, id: "storyStatus", name: "storyStatus" },
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "" },
	                                            "Select"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Active" },
	                                            "Active"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Inactive" },
	                                            "Inactive"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "storyStatus" },
	                                        " Short Description"
	                                    ),
	                                    _react2.default.createElement("textarea", { className: "form-control", name: "shortDescription",
	                                        id: "shortDescription", onChange: this.handleShortDescriptionChange,
	                                        defaultValue: this.state.shortDescription
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "storyStatus" },
	                                        "Description"
	                                    ),
	                                    _react2.default.createElement(_newStoriesEditor2.default, { textEditorName: "story" })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group mt-4" },
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/stories" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { type: "button", className: "btn btn-primary", style: { float: "right", marginLeft: "10px" } },
	                                            "Cancel"
	                                        )
	                                    ),
	                                    this.state.id == null ? _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", style: { float: "right" }, onClick: this.validateSubmission },
	                                        "Submit"
	                                    ) : _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", style: { float: "right" }, onClick: this.validateSubmission },
	                                        "Update"
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return NewStories;
	}(_react.Component);
	
	exports.default = NewStories;
	
	var styles = {
	    editor: {
	        border: '1px solid gray',
	        minHeight: '6em'
	    }
	};

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _firebase = __webpack_require__(6);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _newStoriesEditor = __webpack_require__(103);
	
	var _newStoriesEditor2 = _interopRequireDefault(_newStoriesEditor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewStories = function (_Component) {
	    _inherits(NewStories, _Component);
	
	    function NewStories(props) {
	        _classCallCheck(this, NewStories);
	
	        var _this = _possibleConstructorReturn(this, (NewStories.__proto__ || Object.getPrototypeOf(NewStories)).call(this, props));
	
	        _this.updateValidateSubmission = function (url) {
	            var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	            var item = {
	                name: _this.state.name,
	                mainCategory: _this.state.mainCategory,
	                status: _this.state.status,
	                createdAt: newDate
	
	            };
	            _firebase.database.ref("storyCategory/" + _this.state.id).update(item).then(function () {
	                alert("Updated Successfully");
	                window.location.href = "/storyCategory";
	                _this.renderList();
	            }).catch(function () {
	                alert("Somthing went wrong");
	            });
	        };
	
	        _this.validateSubmission = function () {
	
	            if (_this.state.name === '') {
	                alert('Enter name');
	            } else if (_this.state.mainCategory === '') {
	                alert('Select category');
	            } else if (_this.state.status === '') {
	                alert('Select status');
	            } else {
	
	                if (_this.state.id == null) {
	                    _this.handleSubmit("");
	                } else {
	                    _this.updateValidateSubmission("");
	                }
	            }
	        };
	
	        _this.handleSubmit = function (url) {
	            var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	            var item = {
	                name: _this.state.name,
	                mainCategory: _this.state.mainCategory,
	                status: _this.state.status,
	                createdAt: newDate
	            };
	            _firebase.storyCategoryRef.push(item).then(function () {
	                alert("Saved Successfully");
	                window.location.href = "/storyCategory";
	            }).catch(function () {
	                alert("Somthing went wrong");
	            });
	        };
	
	        _this.handleStatusChange = function (e) {
	            _this.setState({
	                status: e.target.value
	            });
	        };
	
	        _this.handleMainCategoryChange = function (e) {
	            _this.setState({
	                mainCategory: e.target.value
	            });
	        };
	
	        _this.handleChange = function (e) {
	            _this.setState({
	                name: e.target.value
	            });
	        };
	
	        _this.state = {
	            name: "",
	            status: "",
	            mainCategory: ""
	        };
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleStatusChange = _this.handleStatusChange.bind(_this);
	        _this.handleMainCategoryChange = _this.handleMainCategoryChange.bind(_this);
	        _this.validateSubmission = _this.validateSubmission.bind(_this);
	        _this.updateValidateSubmission = _this.updateValidateSubmission.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        return _this;
	    }
	
	    _createClass(NewStories, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var url = new URL(window.location.href);
	            var url_path = window.location.href.split("=");
	            var keyId = url_path[1];
	            this.renderList(keyId);
	        }
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(keyId) {
	                var dataList, id, ref, userRef, valueRef, snapshot, val;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                dataList = [];
	                                id = keyId;
	                                ref = id ? '/storyCategory/' + id : 'storyCategory';
	                                userRef = _firebase.database.ref(ref);
	
	                                if (!id) {
	                                    _context.next = 8;
	                                    break;
	                                }
	
	                                _context.t0 = userRef;
	                                _context.next = 11;
	                                break;
	
	                            case 8:
	                                _context.next = 10;
	                                return userRef.orderByChild('key').equalTo('value');
	
	                            case 10:
	                                _context.t0 = _context.sent;
	
	                            case 11:
	                                valueRef = _context.t0;
	                                _context.next = 14;
	                                return valueRef.once('value');
	
	                            case 14:
	                                snapshot = _context.sent;
	                                val = snapshot.val();
	
	                                if (val) {
	                                    (0, _jquery2.default)("#name").val(val.name);
	                                    (0, _jquery2.default)("#status").val(val.status);
	                                    (0, _jquery2.default)("#mainCategory").val(val.mainCategory);
	                                    this.setState({
	                                        id: id,
	                                        name: val.name,
	                                        status: val.status,
	                                        mainCategory: val.mainCategory
	
	                                    });
	                                }
	
	                            case 17:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function renderList(_x) {
	                return _ref.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "form",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/storyCategory" },
	                                            "Story Category"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "New Story Category"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Story Category"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "name" },
	                                        "Name"
	                                    ),
	                                    _react2.default.createElement("input", { type: "text", className: "form-control", name: "name", onChange: this.handleChange,
	                                        id: "name"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "storyCategory" },
	                                        "Main Category"
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        { className: "form-control", onChange: this.handleMainCategoryChange, id: "mainCategory", name: "mainCategory" },
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "" },
	                                            "Select"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Course Reviews" },
	                                            "Course Reviews"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Stories" },
	                                            "Stories"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Blogs" },
	                                            "Blogs"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "storyStatus" },
	                                        " Status"
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        { className: "form-control", onChange: this.handleStatusChange, id: "status", name: "status" },
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "" },
	                                            "Select"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Active" },
	                                            "Active"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Inactive" },
	                                            "Inactive"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group mt-4" },
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/storyCategory" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { type: "button", className: "btn btn-primary", style: { float: "right", marginLeft: "10px" } },
	                                            "Cancel"
	                                        )
	                                    ),
	                                    this.state.id == null ? _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", style: { float: "right" }, onClick: this.validateSubmission },
	                                        "Submit"
	                                    ) : _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", style: { float: "right" }, onClick: this.validateSubmission },
	                                        "Update"
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return NewStories;
	}(_react.Component);
	
	exports.default = NewStories;
	
	var styles = {
	    editor: {
	        border: '1px solid gray',
	        minHeight: '6em'
	    }
	};

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _firebase = __webpack_require__(6);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewTestimonials = function (_Component) {
	    _inherits(NewTestimonials, _Component);
	
	    function NewTestimonials(props) {
	        _classCallCheck(this, NewTestimonials);
	
	        var _this = _possibleConstructorReturn(this, (NewTestimonials.__proto__ || Object.getPrototypeOf(NewTestimonials)).call(this, props));
	
	        _this.updateValidateSubmission = function () {
	            var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	            var item = {
	                author: _this.state.author,
	                imageUrl: _this.state.url ? _this.state.url : _this.state.testimonialUrl,
	                videoUrl: _this.state.urlVideo ? _this.state.urlVideo : _this.state.testimonialVideo,
	                status: _this.state.status,
	                createdAt: newDate
	            };
	            _firebase.database.ref("testimonials/" + _this.state.id).update(item).then(function () {
	                alert("Updated Successfully");
	                window.location.href = "/testimonials";
	                _this.renderList();
	            }).catch(function () {
	                alert("Somthing went wrong");
	            });
	        };
	
	        _this.handleImageChange = function (e) {
	            if (e.target.files[0]) {
	                _this.setState({
	                    testimonialImage: e.target.files[0],
	                    fileName: true
	                });
	            }
	        };
	
	        _this.handleVideoChange = function (e) {
	            if (e.target.files[0]) {
	                _this.setState({
	                    testimonialVideo: e.target.files[0],
	                    fileVideoName: true
	                });
	            }
	        };
	
	        _this.handleStatusChange = function (e) {
	            _this.setState({
	                status: e.target.value
	            });
	        };
	
	        _this.handleChange = function (e) {
	            _this.setState({
	                author: e.target.value
	            });
	        };
	
	        _this.validateSubmission = function () {
	            console.log("testimonialVideo...", _this.state.testimonialVideo);
	            if (_this.state.author === '') {
	                alert('Enter Author');
	            } else if (_this.state.testimonialImage === '' || _this.state.testimonialImage === null) {
	                alert('Upload Image ');
	            } else if (_this.state.testimonialVideo === '' || _this.state.testimonialVideo === null) {
	                alert('Upload Video ');
	            } else if (_this.state.status === '') {
	                alert('Select status');
	            } else {
	                if (_this.state.fileName) {
	                    var uploadTask = _firebase.storage.ref("testimonials/" + _this.state.testimonialImage.name).put(_this.state.testimonialImage);
	                    uploadTask.on("state_changed", function (snapshot) {
	                        var progress = Math.round(snapshot.bytesTransferred / snapshot.totalBytes * 100);
	                        _this.setState({
	                            progress: progress
	                        });
	                    }, function (error) {
	                        console.log(error);
	                    }, function () {
	                        _firebase.storage.ref("testimonials").child(_this.state.testimonialImage.name).getDownloadURL().then(function (url) {
	                            console.log("url...", url);
	                            (0, _jquery2.default)("#imageUrl").attr('src', url);
	                            _this.setState({
	                                url: url
	                            });
	
	                            // if (this.state.id == null) {
	                            //     this.handleSubmit(url);
	                            // }
	                            // else {
	                            //     this.updateValidateSubmission(url)
	                            // }
	                        });
	                    });
	                }
	
	                if (_this.state.fileVideoName) {
	                    var _uploadTask = _firebase.storage.ref("testimonials/" + _this.state.testimonialVideo.name).put(_this.state.testimonialVideo);
	                    _uploadTask.on("state_changed", function (snapshot) {
	                        var progress = Math.round(snapshot.bytesTransferred / snapshot.totalBytes * 100);
	                        _this.setState({
	                            progress: progress
	                        });
	                    }, function (error) {
	                        console.log(error);
	                    }, function () {
	                        _firebase.storage.ref("testimonials").child(_this.state.testimonialVideo.name).getDownloadURL().then(function (url) {
	                            console.log("url1111...", url);
	                            (0, _jquery2.default)("#imageVideoUrl").attr('src', url);
	                            _this.setState({
	                                urlVideo: url
	                            });
	                            if (_this.state.id == null) {
	                                _this.handleSubmit();
	                            } else {
	                                _this.updateValidateSubmission();
	                            }
	                        });
	                    });
	                } else {
	                    if (_this.state.id == null) {
	                        _this.handleSubmit("");
	                    } else {
	                        _this.updateValidateSubmission("");
	                    }
	                }
	            }
	        };
	
	        _this.handleSubmit = function () {
	            var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	            var item = {
	                author: _this.state.author,
	                imageUrl: _this.state.url ? _this.state.url : _this.state.testimonialUrl,
	                videoUrl: _this.state.urlVideo ? _this.state.urlVideo : _this.state.testimonialVideo,
	                status: _this.state.status,
	                createdAt: newDate
	            };
	            _firebase.testimonialRef.push(item).then(function () {
	                alert("Saved Successfully");
	                window.location.href = "/testimonials";
	            }).catch(function () {
	                alert("Somthing went wrong");
	            });
	        };
	
	        _this.state = {
	            testimonialImage: null,
	            progress: 0,
	            author: "",
	            status: "",
	            url: "",
	            urlVideo: "",
	            testimonialUrl: null,
	            id: null,
	            fileName: false,
	            testimonialVideo: null
	
	        };
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        _this.handleImageChange = _this.handleImageChange.bind(_this);
	        _this.handleVideoChange = _this.handleVideoChange.bind(_this);
	        _this.validateSubmission = _this.validateSubmission.bind(_this);
	        _this.handleStatusChange = _this.handleStatusChange.bind(_this);
	        _this.updateValidateSubmission = _this.updateValidateSubmission.bind(_this);
	        return _this;
	    }
	
	    _createClass(NewTestimonials, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var url = new URL(window.location.href);
	            var url_path = window.location.href.split("=");
	            var keyId = url_path[1];
	            this.renderList(keyId);
	        }
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(keyId) {
	                var dataList, id, ref, userRef, valueRef, snapshot, val;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                dataList = [];
	                                id = keyId;
	                                ref = id ? '/testimonials/' + id : 'testimonials';
	                                userRef = _firebase.database.ref(ref);
	
	                                if (!id) {
	                                    _context.next = 8;
	                                    break;
	                                }
	
	                                _context.t0 = userRef;
	                                _context.next = 11;
	                                break;
	
	                            case 8:
	                                _context.next = 10;
	                                return userRef.orderByChild('key').equalTo('value');
	
	                            case 10:
	                                _context.t0 = _context.sent;
	
	                            case 11:
	                                valueRef = _context.t0;
	                                _context.next = 14;
	                                return valueRef.once('value');
	
	                            case 14:
	                                snapshot = _context.sent;
	                                val = snapshot.val();
	
	                                if (val) {
	                                    (0, _jquery2.default)("#testimonialAuthor").val(val.author);
	                                    (0, _jquery2.default)("#testimonialImage").val(val.imageUrl);
	                                    (0, _jquery2.default)("#testimonialVideo").val(val.videoUrl);
	                                    (0, _jquery2.default)("#testimonialStatus").val(val.status);
	                                    this.setState({
	                                        testimonialUrl: val.imageUrl,
	                                        id: id,
	                                        author: val.author,
	                                        status: val.status,
	                                        testimonialImage: val.imageUrl,
	                                        testimonialVideo: val.videoUrl
	                                    });
	                                }
	
	                            case 17:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function renderList(_x) {
	                return _ref.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "form",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/testimonials" },
	                                            "Testimonials"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "New Testimonials"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Testimonials"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "testimonialAuthor" },
	                                        "Author"
	                                    ),
	                                    _react2.default.createElement("input", { type: "text", className: "form-control", name: "testimonialAuthor", onChange: this.handleChange,
	                                        id: "testimonialAuthor"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "imageUrl" },
	                                        "Image"
	                                    ),
	                                    _react2.default.createElement("input", { type: "file", onChange: this.handleImageChange, id: "imageUrl", name: "imageUrl", className: "form-group" }),
	                                    this.state.fileName || this.state.testimonialUrl && _react2.default.createElement("img", { src: this.state.testimonialUrl, id: "imageUrl", style: { width: "100px", height: "100px" } })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "imageVideoUrl" },
	                                        "Video"
	                                    ),
	                                    _react2.default.createElement("input", { type: "file", onChange: this.handleVideoChange, id: "imageVideoUrl", name: "imageVideoUrl", className: "form-group" }),
	                                    this.state.fileVideoName || this.state.testimonialVideo && _react2.default.createElement("video", { src: this.state.testimonialVideo, id: "imageVideoUrl", style: { width: "100px", height: "100px" } })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        { "for": "testimonialStatus" },
	                                        " Status"
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        { className: "form-control", onChange: this.handleStatusChange, id: "testimonialStatus", name: "testimonialStatus" },
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "" },
	                                            "Select"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Active" },
	                                            "Active"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "Inactive" },
	                                            "Inactive"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group mt-4" },
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/testimonials" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { type: "button", className: "btn btn-primary", style: { float: "right", marginLeft: "10px" } },
	                                            "Cancel"
	                                        )
	                                    ),
	                                    this.state.id == null ? _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", onClick: this.validateSubmission, style: { float: "right" } },
	                                        "Submit"
	                                    ) : _react2.default.createElement(
	                                        "button",
	                                        { type: "button", className: "btn btn-primary", onClick: this.validateSubmission, style: { float: "right" } },
	                                        "Update"
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return NewTestimonials;
	}(_react.Component);
	
	exports.default = NewTestimonials;

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _edit = __webpack_require__(21);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _firebase = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Personna = function (_Component) {
	    _inherits(Personna, _Component);
	
	    function Personna(props) {
	        _classCallCheck(this, Personna);
	
	        var _this = _possibleConstructorReturn(this, (Personna.__proto__ || Object.getPrototypeOf(Personna)).call(this, props));
	
	        _this.state = {
	            personnaData: []
	        };
	        return _this;
	    }
	
	    _createClass(Personna, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.renderList();
	        }
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var dataList;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                dataList = [];
	                                _context.next = 3;
	                                return _firebase.database.ref("personna").once('value', function (snapshot) {
	                                    snapshot.forEach(function (ChildSnapshot) {
	                                        dataList.push({
	                                            key: ChildSnapshot.key,
	                                            name: ChildSnapshot.val().name,
	                                            status: ChildSnapshot.val().status,
	                                            internalId: ChildSnapshot.val().internalId
	                                        });
	                                    });
	                                });
	
	                            case 3:
	                                this.setState({
	                                    personnaData: dataList
	                                });
	
	                            case 4:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function renderList() {
	                return _ref.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "Personna"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Personna",
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/newPersonna/keyId=0" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { className: "addNewBtn btn" },
	                                            " New Personna"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "table" },
	                                    _react2.default.createElement(
	                                        "table",
	                                        { className: "table table-bordered" },
	                                        _react2.default.createElement(
	                                            "thead",
	                                            null,
	                                            _react2.default.createElement(
	                                                "tr",
	                                                null,
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "ID"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Name"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Status"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Actions"
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tbody",
	                                            null,
	                                            this.state.personnaData.map(function (data, i) {
	                                                return _react2.default.createElement(
	                                                    "tr",
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        "th",
	                                                        { scope: "row" },
	                                                        data.internalId
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.name
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.status
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            _reactRouterDom.Link,
	                                                            { to: '/newPersonna/keyId=' + data.key, params: data.key },
	                                                            _react2.default.createElement("img", { src: _edit2.default, className: "actionIcon" })
	                                                        )
	                                                    )
	                                                );
	                                            })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return Personna;
	}(_react.Component);
	
	exports.default = Personna;

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _edit = __webpack_require__(21);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _firebase = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PriceRange = function (_Component) {
	    _inherits(PriceRange, _Component);
	
	    function PriceRange(props) {
	        _classCallCheck(this, PriceRange);
	
	        var _this = _possibleConstructorReturn(this, (PriceRange.__proto__ || Object.getPrototypeOf(PriceRange)).call(this, props));
	
	        _this.state = {
	            priceRangeData: []
	        };
	        return _this;
	    }
	
	    _createClass(PriceRange, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.renderList();
	        }
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var dataList;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                dataList = [];
	                                _context.next = 3;
	                                return _firebase.database.ref("priceRange").once('value', function (snapshot) {
	                                    snapshot.forEach(function (ChildSnapshot) {
	                                        dataList.push({
	                                            key: ChildSnapshot.key,
	                                            priceRange: ChildSnapshot.val().priceRange,
	                                            priceRangeStatus: ChildSnapshot.val().status
	                                        });
	                                    });
	                                });
	
	                            case 3:
	                                this.setState({
	                                    priceRangeData: dataList
	                                });
	
	                            case 4:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function renderList() {
	                return _ref.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "Price Range"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Price Range",
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/newPriceRange/keyId=0" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { className: "addNewBtn btn" },
	                                            " New Price Range"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "table" },
	                                    _react2.default.createElement(
	                                        "table",
	                                        { className: "table table-bordered" },
	                                        _react2.default.createElement(
	                                            "thead",
	                                            null,
	                                            _react2.default.createElement(
	                                                "tr",
	                                                null,
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "ID"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Price Range"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Status"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Actions"
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tbody",
	                                            null,
	                                            this.state.priceRangeData.map(function (data, i) {
	                                                return _react2.default.createElement(
	                                                    "tr",
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        "th",
	                                                        { scope: "row" },
	                                                        i + 1
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.priceRange
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.priceRangeStatus
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            _reactRouterDom.Link,
	                                                            { to: '/newPriceRange/keyId=' + data.key, params: data.key },
	                                                            _react2.default.createElement("img", { src: _edit2.default, className: "actionIcon" })
	                                                        )
	                                                    )
	                                                );
	                                            })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return PriceRange;
	}(_react.Component);
	
	exports.default = PriceRange;

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _edit = __webpack_require__(21);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _delete = __webpack_require__(45);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _firebase = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Testimonials = function (_Component) {
	    _inherits(Testimonials, _Component);
	
	    function Testimonials(props) {
	        _classCallCheck(this, Testimonials);
	
	        var _this = _possibleConstructorReturn(this, (Testimonials.__proto__ || Object.getPrototypeOf(Testimonials)).call(this, props));
	
	        _this.state = {
	            skillData: []
	        };
	        return _this;
	    }
	
	    _createClass(Testimonials, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.renderList();
	        }
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var dataList;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                dataList = [];
	                                _context.next = 3;
	                                return _firebase.database.ref("skills").once('value', function (snapshot) {
	                                    snapshot.forEach(function (ChildSnapshot) {
	                                        dataList.push({
	                                            key: ChildSnapshot.key,
	                                            skill: ChildSnapshot.val().skill,
	                                            skillStatus: ChildSnapshot.val().status,
	                                            expertise: ChildSnapshot.val().expertise
	                                        });
	                                    });
	                                });
	
	                            case 3:
	                                this.setState({
	                                    skillData: dataList
	                                });
	
	                            case 4:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function renderList() {
	                return _ref.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "Skills"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Skills",
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/newSkill/keyId=0" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { className: "addNewBtn btn" },
	                                            " New Skills"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "table" },
	                                    _react2.default.createElement(
	                                        "table",
	                                        { className: "table table-bordered" },
	                                        _react2.default.createElement(
	                                            "thead",
	                                            null,
	                                            _react2.default.createElement(
	                                                "tr",
	                                                null,
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "ID"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Expertise"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Skill"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Status"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Actions"
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tbody",
	                                            null,
	                                            this.state.skillData.map(function (data, i) {
	                                                return _react2.default.createElement(
	                                                    "tr",
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        "th",
	                                                        { scope: "row" },
	                                                        i + 1
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.expertise
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.skill
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.skillStatus
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            _reactRouterDom.Link,
	                                                            { to: '/newSkill/keyId=' + data.key, params: data.key },
	                                                            _react2.default.createElement("img", { src: _edit2.default, className: "actionIcon" })
	                                                        )
	                                                    )
	                                                );
	                                            })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return Testimonials;
	}(_react.Component);
	
	exports.default = Testimonials;

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _edit = __webpack_require__(21);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	__webpack_require__(218);
	
	var _delete = __webpack_require__(45);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _firebase = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
	
	
	var Stories = function (_Component) {
	    _inherits(Stories, _Component);
	
	    function Stories(props) {
	        _classCallCheck(this, Stories);
	
	        var _this = _possibleConstructorReturn(this, (Stories.__proto__ || Object.getPrototypeOf(Stories)).call(this, props));
	
	        _this.state = {
	            storyData: []
	        };
	        return _this;
	    }
	
	    _createClass(Stories, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.renderList();
	        }
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var dataList;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                dataList = [];
	                                _context.next = 3;
	                                return _firebase.database.ref("stories").once('value', function (snapshot) {
	                                    snapshot.forEach(function (ChildSnapshot) {
	
	                                        dataList.push({
	                                            key: ChildSnapshot.key,
	                                            storyTitle: ChildSnapshot.val().title,
	                                            storyImage: ChildSnapshot.val().imageUrl,
	                                            storyStatus: ChildSnapshot.val().status,
	                                            storyDescription: ChildSnapshot.val().description,
	                                            storyCategory: ChildSnapshot.val().category,
	                                            mainCategory: ChildSnapshot.val().mainCategory
	                                        });
	                                        //console.log("dataList...",dataList)
	                                    });
	                                });
	
	                            case 3:
	                                this.setState({
	                                    storyData: dataList
	                                });
	
	                            case 4:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function renderList() {
	                return _ref.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            var html = '<div>Example HTML string</div>';
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "Stories"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Stories",
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/newStories/keyId=0" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { className: "addNewBtn btn" },
	                                            " New Stories"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "table" },
	                                    _react2.default.createElement(
	                                        "table",
	                                        { className: "table table-bordered" },
	                                        _react2.default.createElement(
	                                            "thead",
	                                            null,
	                                            _react2.default.createElement(
	                                                "tr",
	                                                null,
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "ID"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Title"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Main Category"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Category"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Banner"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Status"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Actions"
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tbody",
	                                            null,
	                                            this.state.storyData.map(function (data, i) {
	                                                return _react2.default.createElement(
	                                                    "tr",
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        "th",
	                                                        { scope: "row" },
	                                                        i + 1
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.storyTitle
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.mainCategory
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.storyCategory
	                                                    ),
	                                                    _react2.default.createElement("img", { src: data.storyImage, style: { width: "100px", height: "100px" }, className: "actionIcon" }),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.storyStatus
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            _reactRouterDom.Link,
	                                                            { to: '/newstories/keyId=' + data.key, params: data.key },
	                                                            _react2.default.createElement("img", { src: _edit2.default, className: "actionIcon" })
	                                                        )
	                                                    )
	                                                );
	                                            })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return Stories;
	}(_react.Component);
	
	exports.default = Stories;

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _edit = __webpack_require__(21);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	__webpack_require__(218);
	
	var _delete = __webpack_require__(45);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _firebase = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
	
	
	var StoryCategory = function (_Component) {
	    _inherits(StoryCategory, _Component);
	
	    function StoryCategory(props) {
	        _classCallCheck(this, StoryCategory);
	
	        var _this = _possibleConstructorReturn(this, (StoryCategory.__proto__ || Object.getPrototypeOf(StoryCategory)).call(this, props));
	
	        _this.state = {
	            storyData: []
	        };
	        return _this;
	    }
	
	    _createClass(StoryCategory, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.renderList();
	        }
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var dataList;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                dataList = [];
	                                _context.next = 3;
	                                return _firebase.database.ref("storyCategory").once('value', function (snapshot) {
	                                    snapshot.forEach(function (ChildSnapshot) {
	
	                                        dataList.push({
	                                            key: ChildSnapshot.key,
	                                            name: ChildSnapshot.val().name,
	                                            mainCategory: ChildSnapshot.val().mainCategory,
	                                            status: ChildSnapshot.val().status
	                                        });
	                                        //console.log("dataList...",dataList)
	                                    });
	                                });
	
	                            case 3:
	                                this.setState({
	                                    storyData: dataList
	                                });
	
	                            case 4:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function renderList() {
	                return _ref.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            var html = '<div>Example HTML string</div>';
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "Story Category"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Story Category",
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/newStoryCategory/keyId=0" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { className: "addNewBtn btn" },
	                                            " New Story Category"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "table" },
	                                    _react2.default.createElement(
	                                        "table",
	                                        { className: "table table-bordered" },
	                                        _react2.default.createElement(
	                                            "thead",
	                                            null,
	                                            _react2.default.createElement(
	                                                "tr",
	                                                null,
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "ID"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Name"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Main Category"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Status"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Actions"
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tbody",
	                                            null,
	                                            this.state.storyData.map(function (data, i) {
	                                                return _react2.default.createElement(
	                                                    "tr",
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        "th",
	                                                        { scope: "row" },
	                                                        i + 1
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.name
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.mainCategory
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.status
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            _reactRouterDom.Link,
	                                                            { to: '/newStoryCategory/keyId=' + data.key, params: data.key },
	                                                            _react2.default.createElement("img", { src: _edit2.default, className: "actionIcon" })
	                                                        )
	                                                    )
	                                                );
	                                            })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return StoryCategory;
	}(_react.Component);
	
	exports.default = StoryCategory;

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _edit = __webpack_require__(21);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _delete = __webpack_require__(45);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _firebase = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Testimonials = function (_Component) {
	    _inherits(Testimonials, _Component);
	
	    function Testimonials(props) {
	        _classCallCheck(this, Testimonials);
	
	        var _this = _possibleConstructorReturn(this, (Testimonials.__proto__ || Object.getPrototypeOf(Testimonials)).call(this, props));
	
	        _this.state = {
	            testimonialData: []
	        };
	        return _this;
	    }
	
	    _createClass(Testimonials, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.renderList();
	        }
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var dataList;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                dataList = [];
	                                _context.next = 3;
	                                return _firebase.database.ref("testimonials").once('value', function (snapshot) {
	                                    snapshot.forEach(function (ChildSnapshot) {
	                                        dataList.push({
	                                            key: ChildSnapshot.key,
	                                            testimonialAuthor: ChildSnapshot.val().author,
	                                            testimonialImage: ChildSnapshot.val().imageUrl,
	                                            testimonialStatus: ChildSnapshot.val().status
	                                        });
	                                    });
	                                });
	
	                            case 3:
	                                this.setState({
	                                    testimonialData: dataList
	                                });
	
	                            case 4:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function renderList() {
	                return _ref.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "Testimonials"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "Testimonials",
	                                    _react2.default.createElement(
	                                        _reactRouterDom.Link,
	                                        { to: "/newTestimonials/keyId=0" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            { className: "addNewBtn btn" },
	                                            " New Testimonial"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "table" },
	                                    _react2.default.createElement(
	                                        "table",
	                                        { className: "table table-bordered" },
	                                        _react2.default.createElement(
	                                            "thead",
	                                            null,
	                                            _react2.default.createElement(
	                                                "tr",
	                                                null,
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "ID"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Author"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Image/Video"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Status"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Actions"
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tbody",
	                                            null,
	                                            this.state.testimonialData.map(function (data, i) {
	                                                return _react2.default.createElement(
	                                                    "tr",
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        "th",
	                                                        { scope: "row" },
	                                                        i + 1
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.testimonialAuthor
	                                                    ),
	                                                    _react2.default.createElement("img", { src: data.testimonialImage, style: { width: "100px", height: "100px" }, className: "actionIcon" }),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.testimonialStatus
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        _react2.default.createElement(
	                                                            _reactRouterDom.Link,
	                                                            { to: '/newTestimonials/keyId=' + data.key, params: data.key },
	                                                            _react2.default.createElement("img", { src: _edit2.default, className: "actionIcon" })
	                                                        )
	                                                    )
	                                                );
	                                            })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return Testimonials;
	}(_react.Component);
	
	exports.default = Testimonials;

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserAdd = function (_Component) {
	  _inherits(UserAdd, _Component);
	
	  function UserAdd() {
	    _classCallCheck(this, UserAdd);
	
	    return _possibleConstructorReturn(this, (UserAdd.__proto__ || Object.getPrototypeOf(UserAdd)).apply(this, arguments));
	  }
	
	  _createClass(UserAdd, [{
	    key: "render",
	    value: function render() {
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content" },
	          _react2.default.createElement(_doctorLeftmenu2.default, null),
	          _react2.default.createElement(
	            "div",
	            { className: "content-right-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "form",
	                { className: "form-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-head" },
	                  "Userlist"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group" },
	                  _react2.default.createElement(
	                    "label",
	                    { "for": "exampleFormControlInput1" },
	                    "Email address"
	                  ),
	                  _react2.default.createElement("input", { type: "email", className: "form-control", id: "exampleFormControlInput1", placeholder: "name@example.com" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group" },
	                  _react2.default.createElement(
	                    "label",
	                    { "for": "exampleFormControlSelect1" },
	                    "Example select"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    { className: "form-control", id: "exampleFormControlSelect1" },
	                    _react2.default.createElement(
	                      "option",
	                      null,
	                      "1"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      null,
	                      "2"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      null,
	                      "3"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      null,
	                      "4"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      null,
	                      "5"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group" },
	                  _react2.default.createElement(
	                    "label",
	                    { "for": "exampleFormControlSelect2" },
	                    "Example multiple select"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    { multiple: true, className: "form-control", id: "exampleFormControlSelect2" },
	                    _react2.default.createElement(
	                      "option",
	                      null,
	                      "1"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      null,
	                      "2"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      null,
	                      "3"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      null,
	                      "4"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      null,
	                      "5"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group" },
	                  _react2.default.createElement(
	                    "label",
	                    { "for": "exampleFormControlTextarea1" },
	                    "Example textarea"
	                  ),
	                  _react2.default.createElement("textarea", { className: "form-control", id: "exampleFormControlTextarea1", rows: "3" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-check" },
	                  _react2.default.createElement("input", { type: "checkbox", className: "form-check-input", id: "exampleCheck1" }),
	                  _react2.default.createElement(
	                    "label",
	                    { className: "form-check-label", "for": "exampleCheck1" },
	                    "Check me out"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-check" },
	                  _react2.default.createElement("input", { className: "form-check-input", type: "radio", name: "exampleRadios", id: "exampleRadios1", value: "option1" }),
	                  _react2.default.createElement(
	                    "label",
	                    { className: "form-check-label", "for": "exampleRadios1" },
	                    "Default radio"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group mt-4" },
	                  _react2.default.createElement(
	                    "button",
	                    { type: "submit", className: "btn btn-primary" },
	                    "Submit"
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_footer2.default, null)
	      );
	    }
	  }]);
	
	  return UserAdd;
	}(_react.Component);
	
	exports.default = UserAdd;

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _edit = __webpack_require__(21);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _firebase = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Report = function (_Component) {
	    _inherits(Report, _Component);
	
	    function Report(props) {
	        _classCallCheck(this, Report);
	
	        var _this = _possibleConstructorReturn(this, (Report.__proto__ || Object.getPrototypeOf(Report)).call(this, props));
	
	        _this.state = {
	            reportData: []
	        };
	        return _this;
	    }
	
	    _createClass(Report, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.renderList();
	        }
	    }, {
	        key: "renderList",
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var dataList;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                dataList = [];
	                                _context.next = 3;
	                                return _firebase.database.ref("Guidance").once('value', function (snapshot) {
	                                    snapshot.forEach(function (ChildSnapshot) {
	
	                                        if (ChildSnapshot.val().hasOwnProperty('userDate')) {
	                                            if (ChildSnapshot.val().userDate.role === "User") {
	                                                dataList.push({
	                                                    key: ChildSnapshot.key,
	                                                    userData: ChildSnapshot.val().userDate,
	                                                    Expertise: ChildSnapshot.val().Expertise,
	                                                    Experience: ChildSnapshot.val().Experience,
	                                                    CreatedAt: ChildSnapshot.val().createdAt
	                                                });
	                                            }
	                                        }
	                                    });
	                                });
	
	                            case 3:
	                                this.setState({
	                                    reportData: dataList
	                                });
	
	                            case 4:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function renderList() {
	                return _ref.apply(this, arguments);
	            }
	
	            return renderList;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content" },
	                    _react2.default.createElement(_doctorLeftmenu2.default, null),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "content-right-wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "container" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "form-wrapper" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "breadcrumb" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            "a",
	                                            { href: "/dashboard" },
	                                            "Dashboard"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        "Report"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-head" },
	                                    "User Details"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "table" },
	                                    _react2.default.createElement(
	                                        "table",
	                                        { className: "table table-bordered" },
	                                        _react2.default.createElement(
	                                            "thead",
	                                            null,
	                                            _react2.default.createElement(
	                                                "tr",
	                                                null,
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Name"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Email Id"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Phone"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Expertise"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Experience"
	                                                ),
	                                                _react2.default.createElement(
	                                                    "th",
	                                                    { scope: "col" },
	                                                    "Created On"
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "tbody",
	                                            null,
	                                            this.state.reportData.map(function (data, i) {
	                                                return _react2.default.createElement(
	                                                    "tr",
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        "th",
	                                                        { scope: "row" },
	                                                        data.userData.fullName
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.userData.emailId
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.userData.phoneno
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.Expertise
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.Experience
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "td",
	                                                        null,
	                                                        data.CreatedAt
	                                                    )
	                                                );
	                                            })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_footer2.default, null)
	            );
	        }
	    }]);
	
	    return Report;
	}(_react.Component);
	
	exports.default = Report;

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _edit = __webpack_require__(21);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _delete = __webpack_require__(45);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Userlist = function (_Component) {
	  _inherits(Userlist, _Component);
	
	  function Userlist() {
	    _classCallCheck(this, Userlist);
	
	    return _possibleConstructorReturn(this, (Userlist.__proto__ || Object.getPrototypeOf(Userlist)).apply(this, arguments));
	  }
	
	  _createClass(Userlist, [{
	    key: "render",
	    value: function render() {
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content" },
	          _react2.default.createElement(_doctorLeftmenu2.default, null),
	          _react2.default.createElement(
	            "div",
	            { className: "content-right-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "div",
	                { className: "form-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-head" },
	                  "User Add",
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { to: "/UserAdd" },
	                    _react2.default.createElement(
	                      "button",
	                      { className: "addNewBtn btn" },
	                      "Add New"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "table" },
	                  _react2.default.createElement(
	                    "table",
	                    { className: "table table-bordered" },
	                    _react2.default.createElement(
	                      "thead",
	                      null,
	                      _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "col" },
	                          "#"
	                        ),
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "col" },
	                          "First"
	                        ),
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "col" },
	                          "Last"
	                        ),
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "col" },
	                          "Handle"
	                        ),
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "col" },
	                          "Actions"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "tbody",
	                      null,
	                      _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "row" },
	                          "1"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          "Mark"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          "Otto"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          "@mdo"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          _react2.default.createElement("img", { src: _edit2.default, className: "actionIcon" }),
	                          _react2.default.createElement("img", { src: _delete2.default, className: "actionIcon" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "row" },
	                          "2"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          "Jacob"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          "Thornton"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          "@fat"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "row" },
	                          "3"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          { colspan: "2" },
	                          "Larry the Bird"
	                        ),
	                        _react2.default.createElement(
	                          "td",
	                          null,
	                          "@twitter"
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement(
	                    "nav",
	                    { "aria-label": "Page navigation example" },
	                    _react2.default.createElement(
	                      "ul",
	                      { className: "pagination justify-content-end" },
	                      _react2.default.createElement(
	                        "li",
	                        { className: "page-item" },
	                        _react2.default.createElement(
	                          "a",
	                          { className: "page-link", href: "#", "aria-label": "Previous" },
	                          _react2.default.createElement(
	                            "span",
	                            { "aria-hidden": "true" },
	                            "\xAB"
	                          ),
	                          _react2.default.createElement(
	                            "span",
	                            { className: "sr-only" },
	                            "Previous"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        { className: "page-item" },
	                        _react2.default.createElement(
	                          "a",
	                          { className: "page-link", href: "#" },
	                          "1"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        { className: "page-item" },
	                        _react2.default.createElement(
	                          "a",
	                          { className: "page-link", href: "#" },
	                          "2"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        { className: "page-item" },
	                        _react2.default.createElement(
	                          "a",
	                          { className: "page-link", href: "#" },
	                          "3"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        { className: "page-item" },
	                        _react2.default.createElement(
	                          "a",
	                          { className: "page-link", href: "#", "aria-label": "Next" },
	                          _react2.default.createElement(
	                            "span",
	                            { "aria-hidden": "true" },
	                            "\xBB"
	                          ),
	                          _react2.default.createElement(
	                            "span",
	                            { className: "sr-only" },
	                            "Next"
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_footer2.default, null)
	      );
	    }
	  }]);
	
	  return Userlist;
	}(_react.Component);
	
	exports.default = Userlist;

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _newBg = __webpack_require__(640);
	
	var _newBg2 = _interopRequireDefault(_newBg);
	
	var _home = __webpack_require__(412);
	
	var _home2 = _interopRequireDefault(_home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Banner = function (_Component) {
	  _inherits(Banner, _Component);
	
	  function Banner() {
	    _classCallCheck(this, Banner);
	
	    return _possibleConstructorReturn(this, (Banner.__proto__ || Object.getPrototypeOf(Banner)).apply(this, arguments));
	  }
	
	  _createClass(Banner, [{
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'banner-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'banner-content-wrapper row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'banner-content-textWrapper col-lg-6' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'banner-content-text' },
	                'Course Selection Made Easy'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'banner-content-listText', style: { marginBottom: "10px", fontSize: "16px", position: "relative" } },
	                'With Ivanooo, you get the best recommendation on courses. We consider your uniqueness and provide you with unbiased suggestions.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'banner-content-btn mt-5' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '/assesment/apply', className: 'btn-theme' },
	                  'Get Started'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-6 css-15mcevo' },
	              _react2.default.createElement(
	                'svg',
	                { viewBox: '0 0 987 985', fill: 'none', className: 'css-oxmfkf' },
	                _react2.default.createElement('path', { 'fill-rule': 'evenodd', 'clip-rule': 'evenodd', d: 'M610.785.176c103.18 4.753 192.163 75.656 260.812 152.847C934.169 223.38 957.1 316.19 974.186 408.794c16.261 88.13 19.677 176.634-7.021 262.183-28.914 92.649-66.298 192.155-150.059 241.156-83.319 48.741-185.964 4.766-282.233 11.734-121.799 8.816-256.619 105.803-355.723 34.443-97.55-70.244-45.927-227.086-74.115-343.961-28.384-117.682-144.252-233.38-91.399-342.288 53.302-109.833 216.055-92.912 327.147-143.493C433.757 86.237 508.741-4.525 610.785.176z', fill: '#e7ebe4' })
	              ),
	              _react2.default.createElement(
	                'svg',
	                { viewBox: '0 0 1321 1325', fill: 'none', className: 'css-15e64if' },
	                _react2.default.createElement('path', { 'clip-rule': 'evenodd', d: 'M930.913 228.473C1027.46 265.19 1089.87 360.321 1131 455.081c37.49 86.371 30.31 181.702 17.64 275.013-12.05 88.803-36.43 173.953-88.49 246.897-56.39 78.999-122.959 161.869-217.829 182.279-94.368 20.31-178.163-53.51-271.798-76.93-118.467-29.64-276.823 20.43-348.706-78.29-70.755-97.183 27.238-230.081 36.932-349.917 9.761-120.662-64.213-266.742 19.989-353.715 84.917-87.714 234.26-20.844 355.589-34.229 101.542-11.202 201.106-74.029 296.586-37.716z', stroke: 'url(#yellow-line_svg__paint0_linear)', 'stroke-width': '3' }),
	                _react2.default.createElement(
	                  'defs',
	                  null,
	                  _react2.default.createElement(
	                    'linearGradient',
	                    { id: 'yellow-line_svg__paint0_linear', x1: '1348.09', y1: '-77.403', x2: '543.755', y2: '1828.3', gradientUnits: 'userSpaceOnUse' },
	                    _react2.default.createElement('stop', { 'stop-color': '#FFEB6A' }),
	                    _react2.default.createElement('stop', { offset: '0.705', 'stop-color': '#FFDADA' }),
	                    _react2.default.createElement('stop', { offset: '1', 'stop-color': '#fff' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'banner-content-ImgWrapper col-md-6' },
	                _react2.default.createElement('img', { src: _home2.default, className: 'banner-content-Img', alt: '' })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Banner;
	}(_react.Component);
	
	exports.default = Banner;

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _carrer = __webpack_require__(825);
	
	var _carrer2 = _interopRequireDefault(_carrer);
	
	var _firebase = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Career = function (_Component) {
	  _inherits(Career, _Component);
	
	  function Career(props) {
	    _classCallCheck(this, Career);
	
	    var _this = _possibleConstructorReturn(this, (Career.__proto__ || Object.getPrototypeOf(Career)).call(this, props));
	
	    _this.state = {
	      careerData: []
	    };
	
	    return _this;
	  }
	
	  _createClass(Career, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderList();
	    }
	  }, {
	    key: 'renderList',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var dataList;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                dataList = [];
	                _context.next = 3;
	                return _firebase.database.ref("Course").once('value', function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    dataList.push({ key: ChildSnapshot.key, CourseName: ChildSnapshot.val().CourseName,
	                      imageUrl: ChildSnapshot.val().imageUrl
	
	                    });
	                  });
	                });
	
	              case 3:
	                this.setState({ careerData: dataList });
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function renderList() {
	        return _ref.apply(this, arguments);
	      }
	
	      return renderList;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'career-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'career-panel' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'career-head' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Career Tracks'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Career assistance service to fina a suitable opportunituy - Resume writing,  Interview Coaching'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'career-body' },
	                  this.state.careerData.map(function (data, i) {
	
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'career-box' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: "/course-details/id=" + data.key, className: 'career-box-a' },
	                        _react2.default.createElement('img', { src: data.imageUrl, alt: '', className: 'career-img' }),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'career-box-text' },
	                          data.CourseName
	                        )
	                      )
	                    );
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'view-all' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/careerTracks', className: 'view-all-btn' },
	                    'View all'
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Career;
	}(_react.Component);
	
	exports.default = Career;

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _courses = __webpack_require__(114);
	
	var _courses2 = _interopRequireDefault(_courses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Courses = function (_Component) {
	  _inherits(Courses, _Component);
	
	  function Courses() {
	    _classCallCheck(this, Courses);
	
	    return _possibleConstructorReturn(this, (Courses.__proto__ || Object.getPrototypeOf(Courses)).apply(this, arguments));
	  }
	
	  _createClass(Courses, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	
	      var acc = document.getElementsByClassName("accordion");
	      var i;
	
	      for (i = 0; i < acc.length; i++) {
	        acc[i].addEventListener("click", function () {
	          this.classList.toggle("active");
	          var panel = this.nextElementSibling;
	          if (panel.style.display === "block") {
	            panel.style.display = "none";
	          } else {
	            panel.style.display = "block";
	          }
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	
	      return _react2.default.createElement(
	        "section",
	        { className: "home-course-wrapper" },
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12" },
	              _react2.default.createElement(
	                "div",
	                { className: "career-panel row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-6" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "home-head py-5" },
	                    "Problems with course selection today"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-6" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "get-accordian" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "accordion-list" },
	                      _react2.default.createElement(
	                        "button",
	                        { className: "accordion active" },
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Random Results"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "panel", style: { display: "block" } },
	                        "Since internet search is not customized, browsing for something means you will be hit with way more results than you can handle."
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "accordion-list" },
	                      _react2.default.createElement(
	                        "button",
	                        { className: "accordion" },
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Bias"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "panel" },
	                        "More often than not, course portals are sponsored, making them inherently biased."
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "accordion-list" },
	                      _react2.default.createElement(
	                        "button",
	                        { className: "accordion" },
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Prejudice"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "panel" },
	                        "Recommendations from peers are influenced by personal bias, making them incompatible with your needs."
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "accordion-list" },
	                      _react2.default.createElement(
	                        "button",
	                        { className: "accordion" },
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Information Overload"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "panel" },
	                        "Millions of course promotions suffer from hard-selling. Even if you know what you want, it is impossible not to be distracted by some of them."
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "accordion-list" },
	                      _react2.default.createElement(
	                        "button",
	                        { className: "accordion" },
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Non Personalized"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "panel" },
	                        "Course portals do not factor your individual traits into the search. As a result, the offered courses are generic and superficial at best."
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Courses;
	}(_react.Component);
	
	exports.default = Courses;

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _courses = __webpack_require__(576);
	
	var _courses2 = _interopRequireDefault(_courses);
	
	var _hurdle = __webpack_require__(578);
	
	var _hurdle2 = _interopRequireDefault(_hurdle);
	
	var _testimonial = __webpack_require__(212);
	
	var _testimonial2 = _interopRequireDefault(_testimonial);
	
	var _ivanoWorks = __webpack_require__(579);
	
	var _ivanoWorks2 = _interopRequireDefault(_ivanoWorks);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _banner = __webpack_require__(574);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Home = function (_Component) {
	  _inherits(Home, _Component);
	
	  function Home() {
	    _classCallCheck(this, Home);
	
	    return _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).apply(this, arguments));
	  }
	
	  _createClass(Home, [{
	    key: "render",
	    value: function render() {
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper home-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content px-0" },
	          _react2.default.createElement(_banner2.default, null),
	          _react2.default.createElement(_courses2.default, null),
	          _react2.default.createElement(_hurdle2.default, null),
	          _react2.default.createElement(_ivanoWorks2.default, null),
	          _react2.default.createElement(_testimonial2.default, null)
	        ),
	        _react2.default.createElement(_footer2.default, null)
	      );
	    }
	  }]);
	
	  return Home;
	}(_react.Component);
	
	exports.default = Home;

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _home = __webpack_require__(412);
	
	var _home2 = _interopRequireDefault(_home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Hurdle = function (_Component) {
	  _inherits(Hurdle, _Component);
	
	  function Hurdle() {
	    _classCallCheck(this, Hurdle);
	
	    return _possibleConstructorReturn(this, (Hurdle.__proto__ || Object.getPrototypeOf(Hurdle)).apply(this, arguments));
	  }
	
	  _createClass(Hurdle, [{
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'hurdle-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'hurdle-panel' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'home-head' },
	                  'How Ivanooo overcomes these hurdles'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'hurdle-body' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'hurdle-box' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'hurdle-box-img col-md-5' },
	                      _react2.default.createElement('img', { alt: '', className: 'hurdle-img', src: _home2.default })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'hurdle-box-content col-md-7' },
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'hurdle-box-text' },
	                        'Personalized'
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'hurdle-box-subtext' },
	                        'Our discovery sessions are aimed at drawing out your uniqueness.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'hurdle-box' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'hurdle-box-img col-md-5 d-md-none' },
	                      _react2.default.createElement('img', { alt: '', className: 'hurdle-img', src: _home2.default })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'hurdle-box-content col-md-7' },
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'hurdle-box-text' },
	                        'Unbiased'
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'hurdle-box-subtext' },
	                        'The courses recommended in our platform are selected through stringent criteria. We are also not attached to any institute, so we don\u2019t need to please others.'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'hurdle-box-img col-md-5 text-right d-none d-md-block' },
	                      _react2.default.createElement('img', { alt: '', className: 'hurdle-img', src: _home2.default })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'hurdle-box' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'hurdle-box-img col-md-5' },
	                      _react2.default.createElement('img', { alt: '', className: 'hurdle-img', src: _home2.default })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'hurdle-box-content col-md-7' },
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'hurdle-box-text' },
	                        'Skill Quotient'
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'hurdle-box-subtext' },
	                        'Our unique S.Q formula takes into consideration your years of experience, hard and soft skills, and academic aptitudes to filter out irrelevant courses from our recommendations.'
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Hurdle;
	}(_react.Component);
	
	exports.default = Hurdle;

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _career = __webpack_require__(823);
	
	var _career2 = _interopRequireDefault(_career);
	
	var _ivano = __webpack_require__(836);
	
	var _ivano2 = _interopRequireDefault(_ivano);
	
	var _ivano3 = __webpack_require__(837);
	
	var _ivano4 = _interopRequireDefault(_ivano3);
	
	var _ivano5 = __webpack_require__(838);
	
	var _ivano6 = _interopRequireDefault(_ivano5);
	
	var _ivano7 = __webpack_require__(839);
	
	var _ivano8 = _interopRequireDefault(_ivano7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IvanoWorks = function (_Component) {
	  _inherits(IvanoWorks, _Component);
	
	  function IvanoWorks() {
	    _classCallCheck(this, IvanoWorks);
	
	    return _possibleConstructorReturn(this, (IvanoWorks.__proto__ || Object.getPrototypeOf(IvanoWorks)).apply(this, arguments));
	  }
	
	  _createClass(IvanoWorks, [{
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'iavno-works-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'iavno-works-panel' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'iavno-works-head text-center' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'How ivanooo works'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'iavno-works-body' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'iavno-works-box' },
	                    _react2.default.createElement(
	                      'a',
	                      { href: '#', className: 'iavno-works-box-a' },
	                      _react2.default.createElement('img', { alt: '', className: 'iavno-works-img', src: _career2.default }),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'iavno-works-box-subtext' },
	                        'Get started with the discovery session. There we will assess your skills and identify your career goals.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'iavno-works-box' },
	                    _react2.default.createElement(
	                      'a',
	                      { href: '#', className: 'iavno-works-box-a' },
	                      _react2.default.createElement('img', { alt: '', className: 'iavno-works-img', src: _career2.default }),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'iavno-works-box-subtext' },
	                        'Based on your goals and skillsets, we will run a skill-gap analysis which will help in refining our recommendations.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'iavno-works-box' },
	                    _react2.default.createElement(
	                      'a',
	                      { href: '#', className: 'iavno-works-box-a' },
	                      _react2.default.createElement('img', { alt: '', className: 'iavno-works-img', src: _career2.default }),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'iavno-works-box-subtext' },
	                        'Get access to a dashboard where you can track our recommendations.'
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return IvanoWorks;
	}(_react.Component);
	
	exports.default = IvanoWorks;

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(366);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _App = __webpack_require__(539);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _dashboard = __webpack_require__(543);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _userlist = __webpack_require__(573);
	
	var _userlist2 = _interopRequireDefault(_userlist);
	
	var _userAdd = __webpack_require__(571);
	
	var _userAdd2 = _interopRequireDefault(_userAdd);
	
	var _insights = __webpack_require__(548);
	
	var _insights2 = _interopRequireDefault(_insights);
	
	var _newInsights = __webpack_require__(556);
	
	var _newInsights2 = _interopRequireDefault(_newInsights);
	
	var _careerTracks = __webpack_require__(590);
	
	var _careerTracks2 = _interopRequireDefault(_careerTracks);
	
	var _courses = __webpack_require__(593);
	
	var _courses2 = _interopRequireDefault(_courses);
	
	var _experts = __webpack_require__(596);
	
	var _experts2 = _interopRequireDefault(_experts);
	
	var _insights3 = __webpack_require__(599);
	
	var _insights4 = _interopRequireDefault(_insights3);
	
	var _firebase = __webpack_require__(6);
	
	var _home = __webpack_require__(577);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _testimonials = __webpack_require__(570);
	
	var _testimonials2 = _interopRequireDefault(_testimonials);
	
	var _newTestimonials = __webpack_require__(564);
	
	var _newTestimonials2 = _interopRequireDefault(_newTestimonials);
	
	var _stories = __webpack_require__(568);
	
	var _stories2 = _interopRequireDefault(_stories);
	
	var _newStories = __webpack_require__(562);
	
	var _newStories2 = _interopRequireDefault(_newStories);
	
	var _newStoriesEditor = __webpack_require__(103);
	
	var _newStoriesEditor2 = _interopRequireDefault(_newStoriesEditor);
	
	var _profile = __webpack_require__(603);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _lostPassword = __webpack_require__(600);
	
	var _lostPassword2 = _interopRequireDefault(_lostPassword);
	
	var _myAccount = __webpack_require__(601);
	
	var _myAccount2 = _interopRequireDefault(_myAccount);
	
	var _expertsDetails = __webpack_require__(595);
	
	var _expertsDetails2 = _interopRequireDefault(_expertsDetails);
	
	var _insightsDetails = __webpack_require__(598);
	
	var _insightsDetails2 = _interopRequireDefault(_insightsDetails);
	
	var _courseDetails = __webpack_require__(592);
	
	var _courseDetails2 = _interopRequireDefault(_courseDetails);
	
	var _freeAssesment = __webpack_require__(597);
	
	var _freeAssesment2 = _interopRequireDefault(_freeAssesment);
	
	var _careerTracksSave = __webpack_require__(540);
	
	var _careerTracksSave2 = _interopRequireDefault(_careerTracksSave);
	
	var _newCourse = __webpack_require__(541);
	
	var _newCourse2 = _interopRequireDefault(_newCourse);
	
	var _assesmentApply = __webpack_require__(582);
	
	var _assesmentApply2 = _interopRequireDefault(_assesmentApply);
	
	var _assessmentPersonna = __webpack_require__(589);
	
	var _assessmentPersonna2 = _interopRequireDefault(_assessmentPersonna);
	
	var _assessmentGoal = __webpack_require__(588);
	
	var _assessmentGoal2 = _interopRequireDefault(_assessmentGoal);
	
	var _assesmentApply3 = __webpack_require__(583);
	
	var _assesmentApply4 = _interopRequireDefault(_assesmentApply3);
	
	var _assesmentApply5 = __webpack_require__(584);
	
	var _assesmentApply6 = _interopRequireDefault(_assesmentApply5);
	
	var _assesmentApply7 = __webpack_require__(585);
	
	var _assesmentApply8 = _interopRequireDefault(_assesmentApply7);
	
	var _assesmentApply9 = __webpack_require__(586);
	
	var _assesmentApply10 = _interopRequireDefault(_assesmentApply9);
	
	var _assesmentApply11 = __webpack_require__(587);
	
	var _assesmentApply12 = _interopRequireDefault(_assesmentApply11);
	
	var _about = __webpack_require__(581);
	
	var _about2 = _interopRequireDefault(_about);
	
	var _contact = __webpack_require__(591);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _dashboard3 = __webpack_require__(594);
	
	var _dashboard4 = _interopRequireDefault(_dashboard3);
	
	var _privacyPolicy = __webpack_require__(602);
	
	var _privacyPolicy2 = _interopRequireDefault(_privacyPolicy);
	
	var _userProfile = __webpack_require__(604);
	
	var _userProfile2 = _interopRequireDefault(_userProfile);
	
	var _skills = __webpack_require__(567);
	
	var _skills2 = _interopRequireDefault(_skills);
	
	var _newSkill = __webpack_require__(561);
	
	var _newSkill2 = _interopRequireDefault(_newSkill);
	
	var _expertise = __webpack_require__(546);
	
	var _expertise2 = _interopRequireDefault(_expertise);
	
	var _newExpertise = __webpack_require__(554);
	
	var _newExpertise2 = _interopRequireDefault(_newExpertise);
	
	var _education = __webpack_require__(544);
	
	var _education2 = _interopRequireDefault(_education);
	
	var _newEducation = __webpack_require__(552);
	
	var _newEducation2 = _interopRequireDefault(_newEducation);
	
	var _experience = __webpack_require__(545);
	
	var _experience2 = _interopRequireDefault(_experience);
	
	var _newExperience = __webpack_require__(553);
	
	var _newExperience2 = _interopRequireDefault(_newExperience);
	
	var _priceRange = __webpack_require__(566);
	
	var _priceRange2 = _interopRequireDefault(_priceRange);
	
	var _newPriceRange = __webpack_require__(560);
	
	var _newPriceRange2 = _interopRequireDefault(_newPriceRange);
	
	var _personna = __webpack_require__(565);
	
	var _personna2 = _interopRequireDefault(_personna);
	
	var _newPersonna = __webpack_require__(559);
	
	var _newPersonna2 = _interopRequireDefault(_newPersonna);
	
	var _institution = __webpack_require__(549);
	
	var _institution2 = _interopRequireDefault(_institution);
	
	var _newInstitution = __webpack_require__(557);
	
	var _newInstitution2 = _interopRequireDefault(_newInstitution);
	
	var _storyCategory = __webpack_require__(569);
	
	var _storyCategory2 = _interopRequireDefault(_storyCategory);
	
	var _newStoryCategory = __webpack_require__(563);
	
	var _newStoryCategory2 = _interopRequireDefault(_newStoryCategory);
	
	var _goals = __webpack_require__(547);
	
	var _goals2 = _interopRequireDefault(_goals);
	
	var _newGoals = __webpack_require__(555);
	
	var _newGoals2 = _interopRequireDefault(_newGoals);
	
	var _country = __webpack_require__(542);
	
	var _country2 = _interopRequireDefault(_country);
	
	var _newCountry = __webpack_require__(551);
	
	var _newCountry2 = _interopRequireDefault(_newCountry);
	
	var _modeOfLearning = __webpack_require__(550);
	
	var _modeOfLearning2 = _interopRequireDefault(_modeOfLearning);
	
	var _userReport = __webpack_require__(572);
	
	var _userReport2 = _interopRequireDefault(_userReport);
	
	var _newModeOfLearning = __webpack_require__(558);
	
	var _newModeOfLearning2 = _interopRequireDefault(_newModeOfLearning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactDom2.default.render(_react2.default.createElement(
	  _reactRouterDom.BrowserRouter,
	  null,
	  _react2.default.createElement(
	    _reactRouterDom.Switch,
	    null,
	    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/', component: _home2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/dashboard', component: _dashboard2.default, exact: true }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/userlist', component: _userlist2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/userAdd', component: _userAdd2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/insights', component: _insights2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/newInsights/keyId=:key', component: _newInsights2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/careerTracks', component: _careerTracks2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/courses', component: _courses2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/experts', component: _experts2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/insightss', component: _insights4.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/testimonials', component: _testimonials2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/newTestimonials/keyId=:key', component: _newTestimonials2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/stories', component: _stories2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/newStories/keyId=:key', component: _newStories2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/newStoriesEditor/keyId=:key', component: _newStoriesEditor2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/profile', component: _profile2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/lost-password', component: _lostPassword2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/my-account', component: _myAccount2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/experts-details', component: _expertsDetails2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/insights-details', component: _insightsDetails2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/course-details/id=:key', component: _courseDetails2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/free-assesment', component: _freeAssesment2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/career-tracks', component: _careerTracksSave2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/newCourse/keyId=:key', component: _newCourse2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/assesment/apply', component: _assesmentApply2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/assesment/personna/id=:key', component: _assessmentPersonna2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/assesment/goal/id=:key', component: _assessmentGoal2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/assesment/apply-1/id=:key', component: _assesmentApply4.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/assesment/apply-2/id=:key', component: _assesmentApply6.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/assesment/apply-3/id=:key', component: _assesmentApply8.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/assesment/apply-4/id=:key', component: _assesmentApply10.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/assesment/apply-5', component: _assesmentApply12.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/about', component: _about2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/contact', component: _contact2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/user-dashboard', component: _dashboard4.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/privacy-policy', component: _privacyPolicy2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/skills', component: _skills2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/newSkill', component: _newSkill2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/expertise', component: _expertise2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/newExpertise', component: _newExpertise2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/education', component: _education2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/newEducation', component: _newEducation2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/experience', component: _experience2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/newExperience', component: _newExperience2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/priceRange', component: _priceRange2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/newPriceRange', component: _newPriceRange2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/goals', component: _goals2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/newGoals', component: _newGoals2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/personna', component: _personna2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/newPersonna', component: _newPersonna2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/institution', component: _institution2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/newInstitution', component: _newInstitution2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/storyCategory', component: _storyCategory2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/newStoryCategory', component: _newStoryCategory2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/country', component: _country2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/newCountry', component: _newCountry2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/modeOfLearning', component: _modeOfLearning2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/userReport', component: _userReport2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/newModeOfLearning', component: _newModeOfLearning2.default }),
	    _react2.default.createElement(_reactRouterDom.Route, { path: '/user-profile', component: _userProfile2.default }),
	    ' ,'
	  )
	), document.getElementById('root'));
	
	// logging our messaging notification
	_firebase.messaging.onMessage(function (payload) {
	  console.log(payload);
	});

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _courses = __webpack_require__(114);
	
	var _courses2 = _interopRequireDefault(_courses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = function (_Component) {
	  _inherits(About, _Component);
	
	  function About() {
	    _classCallCheck(this, About);
	
	    return _possibleConstructorReturn(this, (About.__proto__ || Object.getPrototypeOf(About)).apply(this, arguments));
	  }
	
	  _createClass(About, [{
	    key: "render",
	    value: function render() {
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper" },
	        _react2.default.createElement(
	          "div",
	          { className: "heaerBgImg" },
	          _react2.default.createElement(_header2.default, null),
	          _react2.default.createElement(
	            "div",
	            { className: "header-head" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "h4",
	                null,
	                "About Us"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content px-0" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 my-5" },
	              _react2.default.createElement(
	                "div",
	                { className: "header-head-thin mb-4" },
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Ivanooo was born out of our passion, the same passion you have for your dream career.\""
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Hey you all, stuck in the middle. Like you, we too know what it feels not to be whiz-kids or super talented. But what the heck. This beautiful world is as much about us as it is about the rest."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Like many of you out there, we too have our limitations. We too know what struggle is and the sacrifices that have to be made to reach that goal. Ivanooo was born out of that struggle. It is not that we lack talent. What we need the most is guidance, and the desire to follow it."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Ivanooo is a guidance platform that handholds you through important phases of your education and career."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "To ease matters, we have built a skill-gap analysis tool which lets you figure out the deficit, if any, in your education and skill set. It then prepares an impartial career plan which consists of the best-fit jobs, courses, institutions and expert analysis that can help you achieve your goals."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "We realise that when it comes to careers, no two journeys are the same. So, let Ivanooo be your guide and help you connect the dots in your journey forward."
	              ),
	              _react2.default.createElement("hr", { className: "my-4" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12" },
	              _react2.default.createElement(
	                "div",
	                { className: "header-head-thin" },
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Our Promise"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-6 promise-list" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "subhead" },
	                    "Always Be Searching"
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "Keep searching, keep looking and keep updating yourself with Ivanooo. We curate and identify opportunities that you can use to improve yourself."
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-6 promise-list" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "subhead" },
	                    "Always Be Searching"
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "Keep searching, keep looking and keep updating yourself with Ivanooo. We curate and identify opportunities that you can use to improve yourself."
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-6 promise-list" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "subhead" },
	                    "Always Be Searching"
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "Keep searching, keep looking and keep updating yourself with Ivanooo. We curate and identify opportunities that you can use to improve yourself."
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-6 promise-list" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "subhead" },
	                    "Always Be Searching"
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "Keep searching, keep looking and keep updating yourself with Ivanooo. We curate and identify opportunities that you can use to improve yourself."
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_footer2.default, null)
	      );
	    }
	  }]);
	
	  return About;
	}(_react.Component);
	
	exports.default = About;

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _checkmarkB = __webpack_require__(60);
	
	var _checkmarkB2 = _interopRequireDefault(_checkmarkB);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _firebase = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AssesmentApply = function (_Component) {
	  _inherits(AssesmentApply, _Component);
	
	  function AssesmentApply(props) {
	    _classCallCheck(this, AssesmentApply);
	
	    var _this = _possibleConstructorReturn(this, (AssesmentApply.__proto__ || Object.getPrototypeOf(AssesmentApply)).call(this, props));
	
	    _this.handleChange = function (event) {
	      var _event$target = event.target,
	          value = _event$target.value,
	          name = _event$target.name;
	
	      _this.setState(_defineProperty({}, name, value));
	    };
	
	    _this.state = {
	      fullName: "",
	      emailId: "",
	      phoneno: "",
	      password: "",
	      country: "",
	      countryData: []
	    };
	    _this.submituserData = _this.submituserData.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(AssesmentApply, [{
	    key: "componentDidMount",
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var countryList;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                countryList = [];
	                _context.next = 3;
	                return _firebase.database.ref("country").once('value', function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    if (ChildSnapshot.val().status == 'Active') {
	                      countryList.push({
	                        key: ChildSnapshot.key,
	                        country: ChildSnapshot.val().country
	                      });
	                    }
	                  });
	                });
	
	              case 3:
	                this.setState({
	                  countryData: countryList
	                });
	
	              case 4:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "submituserData",
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var newDate, userData, regex, userDataNew, valueRef;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	                userData = {
	                  fullName: this.state.fullName,
	                  emailId: this.state.emailId,
	                  createdAt: newDate,
	                  phoneno: this.state.phoneno,
	                  password: this.state.password,
	                  country: this.state.country,
	                  role: "User"
	
	                };
	                regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
	
	                if (this.state.fullName === '') {
	                  alert('Name Required');
	                } else if (this.state.emailId === '') {
	                  alert('Email Id Required');
	                } else if (this.state.emailId !== '' && regex.test(this.state.emailId) === false) {
	                  alert('Email Id is not valid');
	                } else if (this.state.phoneno === '') {
	                  alert('Phone Required');
	                } else if (this.state.password === '') {
	                  alert('Password Required');
	                } else if (this.state.country === '') {
	                  alert('Located In Required');
	                } else {
	                  localStorage.setItem("userName", this.state.fullName);
	                  userDataNew = {
	                    fullName: this.state.fullName,
	                    emailId: this.state.emailId,
	                    phoneno: this.state.phoneno,
	                    password: this.state.password,
	                    country: this.state.country,
	                    role: "User"
	                  };
	                  valueRef = _firebase.secUser.orderByChild('emailId').equalTo(this.state.emailId);
	
	                  valueRef.once('value', function (snapshot) {
	                    console.log("snapshot...", snapshot);
	                    if (!snapshot.exists()) {
	                      var userKey = _firebase.secUser.push(userData).key;
	
	                      if (userKey != null) {
	                        localStorage.setItem("userId", userKey);
	                        userDataNew.userId = userKey;
	                        // localStorage.setItem("userName", this.state.fullName);
	                        // const userDataNew = {
	                        //   userId: userKey,
	                        //   fullName: this.state.fullName,
	                        //   emailId: this.state.emailId,
	                        //   phoneno: this.state.phoneno,
	                        //   password: this.state.password,
	                        //   country: this.state.country,
	                        //   role: "User"
	                        // }
	
	                        var dataSet = {
	                          userDate: userDataNew,
	                          createdAt: newDate,
	                          resumeFile: "",
	                          resumeLink: "",
	                          Expertise: "",
	                          Experience: "",
	                          Education: "",
	                          SkillRating: "",
	                          userId: userKey,
	                          step2: "false",
	                          step3: "false",
	                          step4: "false",
	                          step5: "false",
	                          progressInfo: 20
	                        };
	                        var guidanceKey = _firebase.guidance.push(dataSet).key;
	                        var userDataKey = {
	                          userId: userKey,
	                          guidanceId: guidanceKey
	                        };
	
	                        _firebase.database.ref("SecUser/" + userKey).update(userDataKey).then(function () {
	                          localStorage.setItem("guidanceId", guidanceKey);
	                          window.location.href = "/assesment/personna/id=" + guidanceKey;
	                        });
	                      }
	                    } else {
	                      alert('Email Id already exists!');
	                    }
	                  });
	                }
	
	              case 4:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function submituserData() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return submituserData;
	    }()
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content assessment-wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "container pt-5" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-6" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "assessment-left" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "iavno-works-head text-center my-4" },
	                    _react2.default.createElement(
	                      "h4",
	                      null,
	                      "Get Started for Ivanooo today"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "At Ivanooo, you gain access to recommendations that are not only unbiased but also backed by substantial research. We also take your unique skills into consideration, which makes our recommendations further personalized."
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-6 m-auto px-md-5" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-main-wrapper" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      "Name ",
	                      _react2.default.createElement(
	                        "span",
	                        { style: { color: "#535fe5" } },
	                        "*"
	                      )
	                    ),
	                    _react2.default.createElement("input", { type: "text", name: "fullName", id: "fullName", className: "form-control", onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      "Email ",
	                      _react2.default.createElement(
	                        "span",
	                        { style: { color: "#535fe5" } },
	                        "*"
	                      )
	                    ),
	                    _react2.default.createElement("input", { type: "email", name: "emailId", id: "emailId", className: "form-control", onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      " Phone ",
	                      _react2.default.createElement(
	                        "span",
	                        { style: { color: "#535fe5" } },
	                        "*"
	                      )
	                    ),
	                    _react2.default.createElement("input", { type: "text", name: "phoneno", id: "phoneno", className: "form-control", onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      " Password ",
	                      _react2.default.createElement(
	                        "span",
	                        { style: { color: "#535fe5" } },
	                        "*"
	                      )
	                    ),
	                    _react2.default.createElement("input", { type: "password", name: "password", id: "password", className: "form-control", onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      "Located in",
	                      _react2.default.createElement(
	                        "span",
	                        { style: { color: "#535fe5" } },
	                        "*"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "select",
	                      { className: "form-control", id: "country", name: "country", onChange: this.handleChange },
	                      _react2.default.createElement(
	                        "option",
	                        { value: "0" },
	                        "Country"
	                      ),
	                      this.state.countryData.map(function (x, y) {
	                        return _react2.default.createElement(
	                          "option",
	                          { key: x.key, value: x.key },
	                          x.country
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group mt-4" },
	                    _react2.default.createElement(
	                      "a",
	                      { href: "#", className: "btn btn-theme w-100", onClick: function onClick() {
	                          return _this2.submituserData();
	                        } },
	                      "Submit"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AssesmentApply;
	}(_react.Component);
	
	exports.default = AssesmentApply;

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _linkedin = __webpack_require__(140);
	
	var _linkedin2 = _interopRequireDefault(_linkedin);
	
	var _uploadFolder = __webpack_require__(141);
	
	var _uploadFolder2 = _interopRequireDefault(_uploadFolder);
	
	var _arrowForward = __webpack_require__(52);
	
	var _arrowForward2 = _interopRequireDefault(_arrowForward);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _firebase = __webpack_require__(6);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AssesmentApply1 = function (_Component) {
	  _inherits(AssesmentApply1, _Component);
	
	  function AssesmentApply1(props) {
	    _classCallCheck(this, AssesmentApply1);
	
	    var _this = _possibleConstructorReturn(this, (AssesmentApply1.__proto__ || Object.getPrototypeOf(AssesmentApply1)).call(this, props));
	
	    _this.handleChange = function (event) {
	      var _event$target = event.target,
	          value = _event$target.value,
	          name = _event$target.name;
	
	      _this.setState(_defineProperty({}, name, value));
	    };
	
	    _this.handleImageChange = function (e) {
	      if (e.target.files[0]) {
	        _this.setState({
	          resumeImage: e.target.files[0],
	          fileName: true
	
	        });
	      }
	    };
	
	    _this.updateValidateSubmission = function () {
	      if (_this.state.fileName === true) {
	        var uploadTask = _firebase.storage.ref("Guidance/" + _this.state.resumeImage.name).put(_this.state.resumeImage);
	        uploadTask.on("state_changed", function (snapshot) {
	          var progress = Math.round(snapshot.bytesTransferred / snapshot.totalBytes * 100);
	          _this.setState({
	            progress: progress
	          });
	        }, function (error) {
	          console.log(error);
	        }, function () {
	          _firebase.storage.ref("Guidance").child(_this.state.resumeImage.name).getDownloadURL().then(function (url) {
	            console.log("url...", url);
	            (0, _jquery2.default)("#imageUrl").attr('src', url);
	            _this.setState({
	              url: url
	            });
	            _this.updateData();
	          });
	        });
	      } else {
	
	        _this.updateData();
	      }
	    };
	
	    _this.state = {
	      fileName: false,
	      resumeImage: null,
	      progress: 0,
	      url: null,
	      resumeLink: ""
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleImageChange = _this.handleImageChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(AssesmentApply1, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      //localStorage.setItem("guidanceId", this.props.match.params.key);
	      //alert(this.props.match.params.key)
	    }
	  }, {
	    key: "updateData",
	    value: function updateData() {
	      var _this2 = this;
	
	      var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	      var dataSet = {
	        resumeFile: this.state.url === null ? "" : this.state.url,
	        resumeLink: this.state.resumeLink,
	        step2: "true",
	        progressInfo: 20
	
	      };
	      _firebase.database.ref("Guidance/" + this.props.match.params.key).update(dataSet).then(function () {
	        window.location.href = "/assesment/apply-2/id=" + _this2.props.match.params.key;
	      }).catch(function () {
	        alert("Somthing went wrong");
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper assesment-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content p-0", style: { background: "#f4f6f9" } },
	          _react2.default.createElement(
	            "div",
	            { className: "container p-0 pt-5" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-6 m-auto p-0" },
	                _react2.default.createElement(
	                  "form",
	                  { className: "form-main-wrapper" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group progress-det" },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "progress-content" },
	                      "Step 2/5"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "progress" },
	                      _react2.default.createElement("div", { className: "progress-bar", role: "progressbar", style: { width: "40%" }, "aria-valuenow": "20", "aria-valuemin": "0", "aria-valuemax": "100" })
	                    )
	                  ),
	                  _react2.default.createElement("hr", null),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group subhead text-left" },
	                    "Share your profile"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "To move forward with our course recommendation process, we ask that you share either your resume or a LinkedIn profile.\xA0 ",
	                      _react2.default.createElement(
	                        "span",
	                        { className: "text-danger" },
	                        "*"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "resumeImage", className: "form-fileUpload" },
	                      _react2.default.createElement("input", { name: "resumeImage", id: "resumeImage", type: "file", onChange: this.handleImageChange, accept: ".pdf,.doc,.docx" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "FormFileUpload_uploadContent__1quqH" },
	                        _react2.default.createElement("img", { alt: "Resume Upload", src: _uploadFolder2.default }),
	                        _react2.default.createElement(
	                          "span",
	                          { className: "form-fileUpload-title" },
	                          "Resume Upload"
	                        ),
	                        _react2.default.createElement(
	                          "span",
	                          { className: "form-fileUpload-helpText" },
	                          ".pdf, .doc, or .docx"
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group text-center" },
	                    _react2.default.createElement(
	                      "label",
	                      null,
	                      "OR"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group" },
	                      _react2.default.createElement(
	                        "span",
	                        { className: "input-group-text" },
	                        _react2.default.createElement("img", { src: _linkedin2.default })
	                      ),
	                      _react2.default.createElement("input", { type: "text", onChange: this.handleChange, className: "form-control", name: "resumeLink", id: "resumeLink", placeholder: "https://linkedin.com/in/profile" })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group mt-4" },
	                    _react2.default.createElement(
	                      "a",
	                      { className: "btn btn-gray w-100", onClick: function onClick() {
	                          return _this3.updateValidateSubmission();
	                        } },
	                      "Next ",
	                      _react2.default.createElement("img", { src: _arrowForward2.default, className: "arrow-filter" })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AssesmentApply1;
	}(_react.Component);
	
	exports.default = AssesmentApply1;

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _arrowForward = __webpack_require__(52);
	
	var _arrowForward2 = _interopRequireDefault(_arrowForward);
	
	var _checkmarkB = __webpack_require__(60);
	
	var _checkmarkB2 = _interopRequireDefault(_checkmarkB);
	
	var _uploadFolder = __webpack_require__(141);
	
	var _uploadFolder2 = _interopRequireDefault(_uploadFolder);
	
	var _linkedin = __webpack_require__(140);
	
	var _linkedin2 = _interopRequireDefault(_linkedin);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _firebase = __webpack_require__(6);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AssesmentApply2 = function (_Component) {
	  _inherits(AssesmentApply2, _Component);
	
	  function AssesmentApply2(props) {
	    _classCallCheck(this, AssesmentApply2);
	
	    var _this = _possibleConstructorReturn(this, (AssesmentApply2.__proto__ || Object.getPrototypeOf(AssesmentApply2)).call(this, props));
	
	    _this.handleChangeChk = function (e) {
	      var isChecked = e.target.value;
	      console.log("isChecked...", isChecked);
	      if (isChecked == "No") {
	        _this.setState({
	          expertiseFlag: false
	        });
	      } else {
	        _this.setState({
	          expertiseFlag: true
	        });
	      }
	      _this.setState({
	        checkBoxValue: isChecked
	      });
	    };
	
	    _this.handleChange = function (event) {
	      var _event$target = event.target,
	          value = _event$target.value,
	          name = _event$target.name;
	
	      _this.setState(_defineProperty({}, name, value));
	    };
	
	    _this.handleImageChange = function (e) {
	      if (e.target.files[0]) {
	        _this.setState({
	          resumeImage: e.target.files[0],
	          fileName: true
	
	        });
	      }
	    };
	
	    _this.updateValidateSubmission = function () {
	      if (_this.state.expertise === "") {
	        alert("Expertise required");
	        return false;
	      } else if (_this.state.experience === "") {
	        alert("Experience required");
	        return false;
	      } else if (_this.state.currentSalary === "" && _this.state.experience != "0-1") {
	        alert("Current Salary required");
	        return false;
	      } else if (_this.state.fileName === true) {
	        var uploadTask = _firebase.storage.ref("Guidance/" + _this.state.resumeImage.name).put(_this.state.resumeImage);
	        uploadTask.on("state_changed", function (snapshot) {
	          var progress = Math.round(snapshot.bytesTransferred / snapshot.totalBytes * 100);
	          _this.setState({
	            progress: progress
	          });
	        }, function (error) {
	          console.log(error);
	        }, function () {
	          _firebase.storage.ref("Guidance").child(_this.state.resumeImage.name).getDownloadURL().then(function (url) {
	            console.log("url...", url);
	            (0, _jquery2.default)("#imageUrl").attr('src', url);
	            _this.setState({
	              url: url
	            });
	            _this.updateData();
	          });
	        });
	      } else {
	        if (_this.state.currentSalary === "") {
	          _this.setState({
	            currentSalary: 0
	          });
	        }
	        _this.updateData();
	      }
	    };
	
	    _this.state = {
	      Subject: "",
	      expertise: "",
	      Skills: "",
	      experience: "",
	      education: "",
	      currentSalary: "",
	      BudgetConstriction: "",
	      checkBoxValue: '',
	      expertiseData: [],
	      experienceData: [],
	      educationData: [],
	      resumeImage: null,
	      url: null,
	      resumeLink: "",
	      personna: "",
	      expertiseFlag: false
	    };
	    _this.handleImageChange = _this.handleImageChange.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleChangeChk = _this.handleChangeChk.bind(_this);
	    return _this;
	  }
	
	  _createClass(AssesmentApply2, [{
	    key: "renderList",
	    value: function renderList() {
	      console.log('fooooo', localStorage.getItem("guidanceArray"));
	
	      var data = JSON.parse(localStorage.getItem("guidanceArray"));
	      console.log("data....", data);
	      //alert(data.Expertise)
	      if (data) {
	        (0, _jquery2.default)("#expertise").val(data.Expertise);
	        (0, _jquery2.default)("#experience").val(data.Experience);
	        (0, _jquery2.default)("#currentSalary").val(data.currentSalary);
	        (0, _jquery2.default)("#education").val(data.Education);
	        (0, _jquery2.default)("#resumeLink").val(data.resumeLink);
	        this.setState({ expertise: data.Expertise, experience: data.Experience, education: data.Education, resumeLink: data.resumeLink, currentSalary: data.currentSalary });
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var expertiseList, experienceList, educationList;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                console.log('fooooo1', localStorage.getItem("personna"));
	                expertiseList = [];
	                experienceList = [];
	                educationList = [];
	                _context.next = 6;
	                return _firebase.database.ref("expertise").once('value', function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    if (ChildSnapshot.val().status == 'Active') {
	                      expertiseList.push({
	                        key: ChildSnapshot.key,
	                        expertise: ChildSnapshot.val().expertise
	                      });
	                    }
	                  });
	                });
	
	              case 6:
	                this.setState({
	                  expertiseData: expertiseList
	                });
	                _context.next = 9;
	                return _firebase.database.ref("experience").once('value', function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    if (ChildSnapshot.val().status == 'Active') {
	                      experienceList.push({
	                        experience: ChildSnapshot.val().experience
	                      });
	                    }
	                  });
	                });
	
	              case 9:
	                this.setState({
	                  experienceData: experienceList
	                });
	                _context.next = 12;
	                return _firebase.database.ref("education").once('value', function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    if (ChildSnapshot.val().status == 'Active') {
	                      educationList.push({
	                        education: ChildSnapshot.val().education
	                      });
	                    }
	                  });
	                });
	
	              case 12:
	                this.setState({
	                  educationData: educationList
	                });
	
	                this.renderList();
	
	              case 14:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "updateData",
	    value: function updateData() {
	      var _this2 = this;
	
	      var progressInfo = localStorage.getItem("progressInfo");
	      progressInfo = parseInt(progressInfo);
	      if (this.state.expertise != "") {
	        progressInfo = progressInfo + 5;
	      }
	      if (this.state.experience != "") {
	        progressInfo = progressInfo + 5;
	      }
	      if (this.state.education != "") {
	        progressInfo = progressInfo + 5;
	      }
	      if (this.state.url != "" || this.state.resumeLink != "") {
	        progressInfo = progressInfo + 5;
	      }
	      localStorage.setItem("progressInfo", progressInfo);
	      var dataSet = {
	        //Subject: this.state.Subject,
	        Expertise: this.state.expertise,
	        //Skills:this.state.Skills,
	        Experience: this.state.experience,
	        currentSalary: this.state.currentSalary,
	        Education: this.state.education,
	        // BudgetConstriction:this.state.BudgetConstriction,
	        resumeFile: this.state.url === null ? "" : this.state.url,
	        resumeLink: this.state.resumeLink,
	        progressInfo: progressInfo,
	        expertiseFlag: this.state.expertiseFlag,
	        step3: "true"
	      };
	      console.log("dataSet....", dataSet);
	      _firebase.database.ref("Guidance/" + this.props.match.params.key).update(dataSet).then(function () {
	        localStorage.setItem("userExpertise", _this2.state.expertise);
	        window.location.href = "/assesment/apply-4/id=" + _this2.props.match.params.key;
	      }).catch(function () {
	        alert("Somthing went wrong");
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper assesment-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content", style: { background: "#f4f6f9" } },
	          _react2.default.createElement(
	            "div",
	            { className: "container p-0 pt-5" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-6 m-auto p-0" },
	                _react2.default.createElement(
	                  "form",
	                  { className: "form-main-wrapper" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group progress-det" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group subhead" },
	                      "What are you up to so far?"
	                    )
	                  ),
	                  _react2.default.createElement("hr", null),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      "Expertise",
	                      _react2.default.createElement(
	                        "span",
	                        { style: { color: "#535fe5" } },
	                        "*"
	                      )
	                    ),
	                    localStorage.getItem("personna") !== "I'm a fresh graduate out of college. I'm looking for a course to kickstart my career with." ? _react2.default.createElement(
	                      "div",
	                      { className: "row", onChange: this.handleChangeChk },
	                      _react2.default.createElement(
	                        "label",
	                        { "for": "goal" },
	                        "Do you want to learn new skills from your current expertise?"
	                      ),
	                      _react2.default.createElement(
	                        "label",
	                        { "for": "goalChk", className: "label-radio", style: { width: "100px" } },
	                        _react2.default.createElement("input", { checked: this.state.checkBoxValue === "Yes", name: "goalChk", id: "goalChk", type: "radio", value: "Yes" }),
	                        _react2.default.createElement("img", { className: "label-radio-img", alt: "Yes", src: _checkmarkB2.default }),
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Yes"
	                        ),
	                        _react2.default.createElement("div", { className: "label-radio-checkedBackground" })
	                      ),
	                      _react2.default.createElement(
	                        "label",
	                        { "for": "goalChk", className: "label-radio", style: { width: "100px" } },
	                        _react2.default.createElement("input", { checked: this.state.checkBoxValue === "No", name: "goalChk", id: "goalChk", type: "radio", value: "No" }),
	                        _react2.default.createElement("img", { className: "label-radio-img", alt: "Yes", src: _checkmarkB2.default }),
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "No"
	                        ),
	                        _react2.default.createElement("div", { className: "label-radio-checkedBackground" })
	                      )
	                    ) : "",
	                    _react2.default.createElement(
	                      "select",
	                      { className: "form-control", onChange: this.handleChange, id: "expertise", name: "expertise" },
	                      _react2.default.createElement(
	                        "option",
	                        { key: "", value: "" },
	                        "Select Expertise"
	                      ),
	                      this.state.expertiseData.map(function (x, y) {
	                        return _react2.default.createElement(
	                          "option",
	                          { key: y },
	                          x.expertise
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      "Experience",
	                      _react2.default.createElement(
	                        "span",
	                        { style: { color: "#535fe5" } },
	                        "*"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "select",
	                      { className: "form-control", onChange: this.handleChange, id: "experience", name: "experience" },
	                      _react2.default.createElement(
	                        "option",
	                        { key: "", value: "" },
	                        "Select Experience"
	                      ),
	                      this.state.experienceData.map(function (x, y) {
	                        return _react2.default.createElement(
	                          "option",
	                          { key: y },
	                          x.experience
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      "Current Salary",
	                      _react2.default.createElement(
	                        "span",
	                        { style: { color: "#535fe5" } },
	                        "*"
	                      )
	                    ),
	                    _react2.default.createElement("input", { type: "text", name: "currentSalary", id: "currentSalary", className: "form-control", onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      " Education"
	                    ),
	                    _react2.default.createElement(
	                      "select",
	                      { className: "form-control", onChange: this.handleChange, id: "education", name: "education" },
	                      _react2.default.createElement(
	                        "option",
	                        { key: "", value: "" },
	                        " Select Education"
	                      ),
	                      this.state.educationData.map(function (x, y) {
	                        return _react2.default.createElement(
	                          "option",
	                          { key: y },
	                          x.education
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group subhead text-left" },
	                    "Share your profile"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "To move forward with our course recommendation process, we ask that you share either your resume or a LinkedIn profile.\xA0 ",
	                      _react2.default.createElement(
	                        "span",
	                        { className: "text-danger" },
	                        "*"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "resumeImage", className: "form-fileUpload" },
	                      _react2.default.createElement("input", { name: "resumeImage", id: "resumeImage", type: "file", onChange: this.handleImageChange, accept: ".pdf,.doc,.docx" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "FormFileUpload_uploadContent__1quqH" },
	                        _react2.default.createElement("img", { alt: "Resume Upload", src: _uploadFolder2.default }),
	                        _react2.default.createElement(
	                          "span",
	                          { className: "form-fileUpload-title" },
	                          "Resume Upload"
	                        ),
	                        _react2.default.createElement(
	                          "span",
	                          { className: "form-fileUpload-helpText" },
	                          ".pdf, .doc, or .docx"
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group text-center" },
	                    _react2.default.createElement(
	                      "label",
	                      null,
	                      "OR"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group" },
	                      _react2.default.createElement(
	                        "span",
	                        { className: "input-group-text" },
	                        _react2.default.createElement("img", { src: _linkedin2.default })
	                      ),
	                      _react2.default.createElement("input", { type: "text", onChange: this.handleChange, className: "form-control", name: "resumeLink", id: "resumeLink", placeholder: "https://linkedin.com/in/profile" })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group mt-4" },
	                    _react2.default.createElement(
	                      "a",
	                      { href: "#", className: "btn btn-gray w-100", onClick: function onClick() {
	                          return _this3.updateValidateSubmission();
	                        } },
	                      "Next ",
	                      _react2.default.createElement("img", { src: _arrowForward2.default, className: "arrow-filter" })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AssesmentApply2;
	}(_react.Component);
	
	exports.default = AssesmentApply2;

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _checkmarkB = __webpack_require__(60);
	
	var _checkmarkB2 = _interopRequireDefault(_checkmarkB);
	
	var _arrowForward = __webpack_require__(52);
	
	var _arrowForward2 = _interopRequireDefault(_arrowForward);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _firebase = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AssesmentApply = function (_Component) {
	  _inherits(AssesmentApply, _Component);
	
	  function AssesmentApply(props) {
	    _classCallCheck(this, AssesmentApply);
	
	    var _this = _possibleConstructorReturn(this, (AssesmentApply.__proto__ || Object.getPrototypeOf(AssesmentApply)).call(this, props));
	
	    _this.handleDropDownChange = function (event) {
	      var _event$target = event.target,
	          value = _event$target.value,
	          name = _event$target.name;
	
	      _this.setState(_defineProperty({}, name, value));
	    };
	
	    _this.handleChange = function (event) {
	      var _this$setState2;
	
	      var _event$target2 = event.target,
	          value = _event$target2.value,
	          name = _event$target2.name;
	
	      _this.setState((_this$setState2 = {}, _defineProperty(_this$setState2, name, value), _defineProperty(_this$setState2, "checkboxFlag", true), _defineProperty(_this$setState2, "expertiseFlag", false), _defineProperty(_this$setState2, "skillFlag", false), _defineProperty(_this$setState2, "checkBoxValue", ''), _this$setState2));
	    };
	
	    _this.handleChangeChk = function (e) {
	      var isChecked = e.target.value;
	      if (isChecked == "No" && _this.state.goal == "1") {
	        _this.setState({
	          expertiseFlag: true
	        });
	      } else {
	        _this.setState({
	          expertiseFlag: false
	        });
	      }
	      if (isChecked == "No" && _this.state.goal == "2") {
	        _this.setState({
	          skillFlag: true
	        });
	      } else {
	        _this.setState({
	          skillFlag: false
	        });
	      }
	      if (_this.state.goal == "3" || _this.state.goal == "4") {
	        _this.setState({
	          skillFlag: false,
	          expertiseFlag: false
	        });
	      }
	
	      _this.setState({
	        checkBoxValue: isChecked
	      });
	    };
	
	    _this.state = {
	      checkboxFlag: false,
	      checkBoxValue: '',
	      expertiseFlag: false,
	      skillFlag: false,
	      budgetData: [],
	      modeOfLearningData: [],
	      expertiseData: [],
	      skillData: []
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleChangeChk = _this.handleChangeChk.bind(_this);
	    _this.handleDropDownChange = _this.handleDropDownChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(AssesmentApply, [{
	    key: "componentDidMount",
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var budgetList, expertiseList, skillList, modeOfLearningList, userExpertise;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                budgetList = [];
	                expertiseList = [];
	                skillList = [];
	                modeOfLearningList = [];
	                _context.next = 6;
	                return _firebase.database.ref("modeOfLearning").once('value', function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    if (ChildSnapshot.val().status == 'Active') {
	                      modeOfLearningList.push({
	                        modeOfLearning: ChildSnapshot.val().modeOfLearning
	                      });
	                    }
	                  });
	                });
	
	              case 6:
	                this.setState({
	                  modeOfLearningData: modeOfLearningList
	                });
	                _context.next = 9;
	                return _firebase.database.ref("priceRange").once('value', function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    if (ChildSnapshot.val().status == 'Active') {
	                      budgetList.push({
	                        priceRange: ChildSnapshot.val().priceRange
	                      });
	                    }
	                  });
	                });
	
	              case 9:
	                this.setState({
	                  budgetData: budgetList
	                });
	                _context.next = 12;
	                return _firebase.database.ref("expertise").once('value', function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    if (ChildSnapshot.val().status == 'Active') {
	                      expertiseList.push({
	                        expertise: ChildSnapshot.val().expertise
	                      });
	                    }
	                  });
	                });
	
	              case 12:
	                this.setState({
	                  expertiseData: expertiseList
	                });
	                userExpertise = localStorage.getItem("userExpertise");
	                _context.next = 16;
	                return _firebase.database.ref("skills").once('value', function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    if (ChildSnapshot.val().status == 'Active' && ChildSnapshot.val().expertise == userExpertise) {
	                      skillList.push({
	                        skill: ChildSnapshot.val().skill
	                      });
	                    }
	                  });
	                });
	
	              case 16:
	                this.setState({
	                  skillData: skillList
	                });
	                this.renderList();
	
	              case 18:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "renderList",
	    value: function renderList() {
	      var data = JSON.parse(localStorage.getItem("guidanceArray"));
	      console.log(data);
	      (0, _jquery2.default)("#goal").val(data.goal);
	
	      //$("#education").val(data.Education)
	      //$("#resumeLink").val(data.resumeLink)
	      this.setState({
	        goal: data.goal,
	        checkboxFlag: true,
	        expertiseFlag: false,
	        skillFlag: false,
	        checkBoxValue: ''
	      });
	      this.handleChangeChkFilling(data.isItFromTheCurrentExpertise);
	      // this.setState({expertise:data.Expertise,experience:data.Experience,education:data.Education,resumeLink:data.resumeLink})
	      (0, _jquery2.default)("#expertise").val(data.Expertise);
	      (0, _jquery2.default)("#priceRange").val(data.budgetConstriction);
	      (0, _jquery2.default)("#modeOfLearning").val(data.modeOfLearning);
	      this.setState({
	        checkBoxValue: data.isItFromTheCurrentExpertise,
	        expertise: data.goalExpertise,
	        skill: data.goalSkill,
	        priceRange: data.budgetConstriction,
	        modeOfLearning: data.modeOfLearning
	      });
	    }
	  }, {
	    key: "handleChangeChkFilling",
	    value: function handleChangeChkFilling(value) {
	      var isChecked = value;
	      if (isChecked == "No" && this.state.goal == "1") {
	        this.setState({
	          expertiseFlag: true
	        });
	      } else {
	        this.setState({
	          expertiseFlag: false
	        });
	      }
	      if (isChecked == "No" && this.state.goal == "2") {
	        this.setState({
	          skillFlag: true
	        });
	      } else {
	        this.setState({
	          skillFlag: false
	        });
	      }
	      if (this.state.goal == "3" || this.state.goal == "4") {
	        this.setState({
	          skillFlag: false,
	          expertiseFlag: false
	        });
	      }
	
	      this.setState({
	        checkBoxValue: isChecked
	      });
	    }
	  }, {
	    key: "updateData",
	    value: function updateData() {
	      var _this2 = this;
	
	      var progressInfo = parseInt(localStorage.getItem("progressInfo"));
	      if (this.state.modeOfLearning != "") {
	        progressInfo = progressInfo + 10;
	      }
	      if (this.state.budgetConstriction != "") {
	        progressInfo = progressInfo + 5;
	      }
	      if (this.state.goal != "") {
	        progressInfo = progressInfo + 5;
	      }
	      localStorage.setItem("progressInfo", progressInfo);
	      var dataSet = {
	        goal: this.state.goal ? this.state.goal : "",
	        isItFromTheCurrentExpertise: this.state.checkBoxValue ? this.state.checkBoxValue : "",
	        goalExpertise: this.state.expertise ? this.state.expertise : "",
	        goalSkill: this.state.skill ? this.state.skill : "",
	        budgetConstriction: this.state.priceRange ? this.state.priceRange : "",
	        modeOfLearning: this.state.modeOfLearning ? this.state.modeOfLearning : "",
	        progressInfo: progressInfo
	      };
	      _firebase.database.ref("Guidance/" + this.props.match.params.key).update(dataSet).then(function () {
	        localStorage.setItem("userGoalExpertise", _this2.state.expertise ? _this2.state.expertise : "");
	        window.location.href = "/assesment/apply-4/id=" + _this2.props.match.params.key;
	      }).catch(function () {
	        alert("Somthing went wrong");
	      });
	      //window.location.href = "/assesment/apply-4"
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper assesment-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content", style: { background: "#f4f6f9" } },
	          _react2.default.createElement(
	            "div",
	            { className: "container p-0 pt-5" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-6 m-auto p-0" },
	                _react2.default.createElement(
	                  "form",
	                  { className: "form-main-wrapper" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group progress-det" },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "progress-content" },
	                      "Step 3/5 : Goals"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "progress" },
	                      _react2.default.createElement("div", { className: "progress-bar", role: "progressbar", style: { width: "60%" }, "aria-valuenow": "20", "aria-valuemin": "0", "aria-valuemax": "100" })
	                    )
	                  ),
	                  _react2.default.createElement("hr", null),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "goal" },
	                      "Goals"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "select",
	                        { className: "form-control", id: "goal", name: "goal", onChange: this.handleChange },
	                        _react2.default.createElement(
	                          "option",
	                          { value: "0" },
	                          "Select Goal"
	                        ),
	                        _react2.default.createElement(
	                          "option",
	                          { value: "1" },
	                          "Do you want to acquire a new skill?"
	                        ),
	                        _react2.default.createElement(
	                          "option",
	                          { value: "2" },
	                          "Do you want to upskill yourself?"
	                        ),
	                        _react2.default.createElement(
	                          "option",
	                          { value: "3" },
	                          "Are you looking for a certificate?"
	                        ),
	                        _react2.default.createElement(
	                          "option",
	                          { value: "4" },
	                          "Are you looking for a specific institute?"
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    this.state.checkboxFlag == true && _react2.default.createElement(
	                      "div",
	                      { className: "row", onChange: this.handleChangeChk },
	                      _react2.default.createElement(
	                        "label",
	                        { "for": "goal" },
	                        "Is it from the current expertise?"
	                      ),
	                      _react2.default.createElement(
	                        "label",
	                        { "for": "goalChk", className: "label-radio", style: { width: "100px" } },
	                        _react2.default.createElement("input", { checked: this.state.checkBoxValue === "Yes", name: "goalChk", id: "goalChk", type: "radio", value: "Yes" }),
	                        _react2.default.createElement("img", { className: "label-radio-img", alt: "Yes", src: _checkmarkB2.default }),
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Yes"
	                        ),
	                        _react2.default.createElement("div", { className: "label-radio-checkedBackground" })
	                      ),
	                      _react2.default.createElement(
	                        "label",
	                        { "for": "goalChk", className: "label-radio", style: { width: "100px" } },
	                        _react2.default.createElement("input", { checked: this.state.checkBoxValue === "No", name: "goalChk", id: "goalChk", type: "radio", value: "No" }),
	                        _react2.default.createElement("img", { className: "label-radio-img", alt: "Yes", src: _checkmarkB2.default }),
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "No"
	                        ),
	                        _react2.default.createElement("div", { className: "label-radio-checkedBackground" })
	                      )
	                    )
	                  ),
	                  this.state.expertiseFlag && _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      "Expertise "
	                    ),
	                    _react2.default.createElement(
	                      "select",
	                      { className: "form-control", onChange: this.handleDropDownChange, id: "expertise", name: "expertise" },
	                      _react2.default.createElement(
	                        "option",
	                        { key: "" },
	                        "Select Expertise"
	                      ),
	                      this.state.expertiseData.map(function (x, y) {
	                        return _react2.default.createElement(
	                          "option",
	                          { key: x.expertise, value: x.expertise },
	                          x.expertise
	                        );
	                      })
	                    )
	                  ),
	                  this.state.skillFlag && _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      "Skills "
	                    ),
	                    _react2.default.createElement(
	                      "select",
	                      { className: "form-control", onChange: this.handleDropDownChange, id: "skill", name: "skill" },
	                      _react2.default.createElement(
	                        "option",
	                        { key: "" },
	                        "Select Skill"
	                      ),
	                      this.state.skillData.map(function (x, y) {
	                        return _react2.default.createElement(
	                          "option",
	                          { key: y },
	                          x.skill
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      "Budget Constriction "
	                    ),
	                    _react2.default.createElement(
	                      "select",
	                      { className: "form-control", onChange: this.handleDropDownChange, id: "priceRange", name: "priceRange" },
	                      _react2.default.createElement(
	                        "option",
	                        { key: "" },
	                        "Select Budget Constriction"
	                      ),
	                      this.state.budgetData.map(function (x, y) {
	                        return _react2.default.createElement(
	                          "option",
	                          { key: y },
	                          x.priceRange
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      "Mode of learning"
	                    ),
	                    _react2.default.createElement(
	                      "select",
	                      { className: "form-control", onChange: this.handleDropDownChange, id: "modeOfLearning", name: "modeOfLearning" },
	                      _react2.default.createElement(
	                        "option",
	                        { key: "" },
	                        "Select Mode of learning"
	                      ),
	                      this.state.modeOfLearningData.map(function (x, y) {
	                        return _react2.default.createElement(
	                          "option",
	                          { key: y },
	                          x.modeOfLearning
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group mt-4" },
	                    _react2.default.createElement(
	                      "a",
	                      { href: "#", className: "btn btn-gray w-100", onClick: function onClick() {
	                          return _this3.updateData();
	                        } },
	                      "Next ",
	                      _react2.default.createElement("img", { src: _arrowForward2.default, className: "arrow-filter" })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AssesmentApply;
	}(_react.Component);
	
	exports.default = AssesmentApply;

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _arrowForward = __webpack_require__(52);
	
	var _arrowForward2 = _interopRequireDefault(_arrowForward);
	
	var _lineLast = __webpack_require__(842);
	
	var _lineLast2 = _interopRequireDefault(_lineLast);
	
	var _lineLast3 = __webpack_require__(843);
	
	var _lineLast4 = _interopRequireDefault(_lineLast3);
	
	var _reactRating = __webpack_require__(770);
	
	var _reactRating2 = _interopRequireDefault(_reactRating);
	
	var _firebase = __webpack_require__(6);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AssesmentApply3 = function (_Component) {
	  _inherits(AssesmentApply3, _Component);
	
	  function AssesmentApply3(props) {
	    _classCallCheck(this, AssesmentApply3);
	
	    var _this = _possibleConstructorReturn(this, (AssesmentApply3.__proto__ || Object.getPrototypeOf(AssesmentApply3)).call(this, props));
	
	    _this.changeRating = function (event) {
	      //console.log("jjjjj",event);
	      _this.setState({
	        rateValue: event
	      });
	    };
	
	    _this.state = {
	      skillData: [],
	      rateValue: 0,
	      newSkillFlag: false,
	      skillDataNew: []
	    };
	    _this.changeRating = _this.changeRating.bind(_this);
	    return _this;
	  }
	
	  _createClass(AssesmentApply3, [{
	    key: "testimonialPopup",
	    value: function testimonialPopup(y) {
	      this.state.ratingVal = 0;
	      (0, _jquery2.default)("#hidRating").val(y);
	      (0, _jquery2.default)("body").addClass("modal-open");
	      (0, _jquery2.default)("#skillRatePopup").addClass("show");
	      (0, _jquery2.default)(".modal").show();
	      (0, _jquery2.default)('.modal-backdrop').add();
	      (0, _jquery2.default)("#testimonialPopup video").show();
	      (0, _jquery2.default)('body').append('<div class="modal-backdrop fade show"></div>');
	    }
	  }, {
	    key: "closePopup",
	    value: function closePopup() {
	      (0, _jquery2.default)("body").removeClass("modal-open");
	      (0, _jquery2.default)(".modal").removeClass("show");
	      (0, _jquery2.default)(".modal").hide();
	      (0, _jquery2.default)('.modal-backdrop').remove();
	    }
	  }, {
	    key: "confirmRating",
	    value: function confirmRating(ratingVal) {
	      var hidRating = (0, _jquery2.default)("#hidRating").val();
	      (0, _jquery2.default)("#divRating" + hidRating).text(ratingVal);
	      this.closePopup();
	    }
	  }, {
	    key: "updateData",
	    value: function updateData() {
	      var skillUserRating = [];
	      for (var i = 0; i < (0, _jquery2.default)("#hidNewSkill").val(); i++) {
	        var rating = void 0;
	        var skillName = "";
	        var skillChecked = "false";
	        if ((0, _jquery2.default)("#divRating" + i).text() == "+") {
	          rating = 0;
	        } else {
	          rating = (0, _jquery2.default)("#divRating" + i).text();
	        }
	        if ((0, _jquery2.default)("#divRatingName" + i).text()) {
	          skillName = (0, _jquery2.default)("#divRatingName" + i).text();
	        } else {
	          skillName = (0, _jquery2.default)("#divRatingName" + i).val();
	        }
	        if ((0, _jquery2.default)("#chk" + i).prop('checked')) {
	          skillChecked = "true";
	        }
	        skillUserRating[i] = {
	          skillName: skillName,
	          skillRating: rating,
	          skillChecked: skillChecked
	        };
	      }
	      var progressInfo = parseInt(localStorage.getItem("progressInfo"));
	      if (skillUserRating.length > 0) {
	        progressInfo = progressInfo + 20;
	      }
	      localStorage.setItem("progressInfo", progressInfo);
	
	      var dataSet = {
	        skillUserRating: skillUserRating.length > 0 ? skillUserRating : "",
	        progressInfo: progressInfo
	      };
	      _firebase.database.ref("Guidance/" + this.props.match.params.key).update(dataSet).then(function () {
	        window.location.href = "/user-dashboard";
	      }).catch(function () {
	        alert("Somthing went wrong");
	      });
	      //window.location.href = "/assesment/apply-5"
	    }
	  }, {
	    key: "componentDidMount",
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var skillList, userExpertise, userGoalExpertise, expertise;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                skillList = [];
	                userExpertise = localStorage.getItem("userExpertise");
	                userGoalExpertise = localStorage.getItem("userGoalExpertise");
	                expertise = userGoalExpertise ? userGoalExpertise : userExpertise;
	                _context.next = 6;
	                return _firebase.database.ref("skills").once('value', function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    if (ChildSnapshot.val().status == 'Active' && ChildSnapshot.val().expertise == expertise) {
	                      skillList.push({
	                        skill: ChildSnapshot.val().skill
	                      });
	                    }
	                  });
	                  (0, _jquery2.default)("#hidNewSkill").val(skillList.length);
	                });
	
	              case 6:
	                this.setState({
	                  skillData: skillList
	                });
	                this.renderList();
	
	              case 8:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "renderList",
	    value: function renderList() {
	      var data = JSON.parse(localStorage.getItem("guidanceArray"));
	      console.log(data);
	      data.skillUserRating.forEach(function (d, i) {
	        (0, _jquery2.default)("#divRating" + i).text(d.skillRating);
	        if (d.skillChecked === "true") {
	          (0, _jquery2.default)("#chk" + i).prop('checked', true);
	        }
	      });
	    }
	    // addSkill() {
	
	    //   let newSkillCount
	    //   if($("#hidNewSkill").val()){
	    //     newSkillCount = parseInt($("#hidNewSkill").val())+1
	    //     $("#hidNewSkill").val(newSkillCount)
	    //   }
	    //   else{
	    //     newSkillCount = 1
	    //     $("#hidNewSkill").val(newSkillCount)
	    //   }
	    //   $("#addSkillWrapper").append('<tr><td><i class="fa fa-star text-muted"></i></td><td><div class="form-group m-0 p-0"><input type="text" id="divRatingName'+newSkillCount+'" class="form-control"  /></div></td><td><div id ="divRating'+newSkillCount+'" class="self-rate-num self-rate-active" onClick=ratingPopup('+newSkillCount+')>+</div></td><td class="text-center"><i class="fa fa-close text-muted"></i></td></tr>')
	    // }
	
	  }, {
	    key: "addSkillTemplate",
	    value: function addSkillTemplate() {
	      var newSkillCount = void 0;
	      if ((0, _jquery2.default)("#hidNewSkill").val()) {
	        newSkillCount = parseInt((0, _jquery2.default)("#hidNewSkill").val()) + 1;
	      } else {
	        newSkillCount = 1;
	      }
	      (0, _jquery2.default)("#hidNewSkill").val(newSkillCount);
	      var skillData = this.state.skillDataNew;
	      //alert("123..."+$("#divRatingName"+newSkillCount).val())
	      skillData.push({ skill: '' });
	      this.setState({ skillDataNew: skillData });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper assesment-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content", style: { background: "#f4f6f9" } },
	          _react2.default.createElement(
	            "div",
	            { className: "container p-0 pt-5" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-10 m-auto p-0" },
	                _react2.default.createElement(
	                  "form",
	                  { className: "form-main-wrapper form-main-wrapper-100" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group progress-det" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group subhead" },
	                      "Select the skills you want to develop and rate them accordingly"
	                    )
	                  ),
	                  _react2.default.createElement("hr", null),
	                  _react2.default.createElement("input", { type: "hidden", id: "hidRating" }),
	                  _react2.default.createElement("input", { type: "hidden", id: "hidNewSkill" }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group subhead text-left" },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "btn btn-theme btn-sm my-2", onClick: function onClick() {
	                          return _this2.addSkillTemplate();
	                        }, style: { float: 'right' } },
	                      "Add New Skill"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "table table-main form-group" },
	                    _react2.default.createElement(
	                      "table",
	                      { className: "table" },
	                      _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "th",
	                            { width: "40" },
	                            _react2.default.createElement("i", { className: "fa fa-question-circle" })
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { width: "300" },
	                            "Skill"
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { className: "text-center" },
	                            "Self Rating"
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { className: "text-center" },
	                            "Remove"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "tbody",
	                        null,
	                        this.state.skillData.map(function (x, y) {
	                          return _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              _react2.default.createElement("input", { type: 'checkbox', id: 'chk' + y })
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              _react2.default.createElement("i", { className: "fa fa-star text-muted" })
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              _react2.default.createElement(
	                                "div",
	                                { id: "divRatingName" + y },
	                                x.skill
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              _react2.default.createElement(
	                                "div",
	                                { id: "divRating" + y, className: "self-rate-num self-rate-active", onClick: function onClick() {
	                                    return _this2.testimonialPopup(y);
	                                  } },
	                                "+"
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              { className: "text-center" },
	                              _react2.default.createElement("i", { className: "fa fa-close text-muted" })
	                            )
	                          );
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "tbody",
	                        null,
	                        this.state.skillDataNew.map(function (x, y) {
	                          return _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              _react2.default.createElement("i", { className: "fa fa-star text-muted" })
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { "class": "form-group m-0 p-0" },
	                              _react2.default.createElement("input", { type: "text", id: "divRatingName" + parseInt(_this2.state.skillData.length + y), "class": "form-control" })
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              _react2.default.createElement(
	                                "div",
	                                { id: "divRating" + parseInt(_this2.state.skillData.length + y), className: "self-rate-num self-rate-active", onClick: function onClick() {
	                                    return _this2.testimonialPopup(parseInt(_this2.state.skillData.length + y));
	                                  } },
	                                "+"
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              { className: "text-center" },
	                              _react2.default.createElement("i", { className: "fa fa-close text-muted" })
	                            )
	                          );
	                        })
	                      ),
	                      _react2.default.createElement("tbody", { id: "addSkillWrapper" })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group mt-4" },
	                    _react2.default.createElement(
	                      "a",
	                      { className: "btn btn-gray w-100", onClick: function onClick() {
	                          return _this2.updateData();
	                        } },
	                      "Next ",
	                      _react2.default.createElement("img", { src: _arrowForward2.default, className: "arrow-filter" })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "modal fade skill-rate-popup", id: "skillRatePopup", tabindex: "-1", role: "dialog", "aria-labelledby": "exampleModalLongTitle", "aria-hidden": "true" },
	          _react2.default.createElement(
	            "div",
	            { className: "modal-dialog", role: "document", style: { maxWidth: '706px' } },
	            _react2.default.createElement(
	              "div",
	              { className: "modal-content" },
	              _react2.default.createElement(
	                "div",
	                { className: "modal-header" },
	                _react2.default.createElement(
	                  "h5",
	                  { className: "modal-title", id: "exampleModalLongTitle" },
	                  "Rate your expertise in \"Product Marketing\""
	                ),
	                _react2.default.createElement(
	                  "button",
	                  { type: "button", className: "close", "data-dismiss": "modal", "aria-label": "Close", onClick: function onClick() {
	                      return _this2.closePopup();
	                    } },
	                  _react2.default.createElement(
	                    "span",
	                    { "aria-hidden": "true", style: { marginLeft: '244px' } },
	                    "\xD7"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "modal-body" },
	                _react2.default.createElement(_reactRating2.default, {
	                  onChange: this.changeRating,
	                  className: "skillRate",
	                  stop: 10,
	                  emptySymbol: _react2.default.createElement("img", { src: _lineLast2.default, className: "skillRateIcon" }),
	                  fullSymbol: _react2.default.createElement("img", { src: _lineLast4.default, className: "skillRateIcon" })
	                }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "tracking-btm row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-6" },
	                    "BEGINNER"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-6 text-right" },
	                    "EXPERT"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "skill-rate-det" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "self-rate-num my-2" },
	                    this.state.rateValue
	                  ),
	                  "1.You can complete limited tasks requiring basic skills with continuous guidance.",
	                  _react2.default.createElement("br", null),
	                  "2.You can complete routine technical tasks requiring basic skills with general supervision or guidance.",
	                  _react2.default.createElement("br", null),
	                  "3.You can process less structured technical tasks with well-defined tasks with occasional guidance.",
	                  _react2.default.createElement("br", null),
	                  "4.You can complete specialised tasks by using knowledge from theoretical and practical experiences. May or may not have overall supervision or guidance for these tasks.",
	                  _react2.default.createElement("br", null),
	                  "5.You can complete specialised tasks by using knowledge from theoretical and practical experiences. May or may not have overall supervision or guidance for these tasks. ",
	                  _react2.default.createElement("br", null),
	                  "6.You can complete broad, complex tasks by using knowledge from theoretical and practical experiences without any supervision or guidance.",
	                  _react2.default.createElement("br", null),
	                  "7.You can complete broad, complex tasks by using knowledge from theoretical and practical experiences without any supervision or guidance.",
	                  _react2.default.createElement("br", null),
	                  "8.You can complete complex tasks in several subspecialties of the skill. ",
	                  _react2.default.createElement("br", null),
	                  "9.You can complete new and complex tasks, including choosing the best process for particular situations.",
	                  _react2.default.createElement("br", null),
	                  "10.You can develop new solutions or research using a wide range of scientific and creative strategies.",
	                  _react2.default.createElement("br", null)
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "modal-footer", style: { justifyContent: "space-between" } },
	                _react2.default.createElement(
	                  "button",
	                  { type: "button", className: "btn btn-theme bg-dark", "data-dismiss": "modal", onClick: function onClick() {
	                      return _this2.closePopup();
	                    } },
	                  "Close"
	                ),
	                _react2.default.createElement(
	                  "button",
	                  { type: "button", className: "btn btn-theme", onClick: function onClick() {
	                      return _this2.confirmRating(_this2.state.rateValue);
	                    } },
	                  "Confirm"
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AssesmentApply3;
	}(_react.Component);
	
	exports.default = AssesmentApply3;

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _checkmarkB = __webpack_require__(60);
	
	var _checkmarkB2 = _interopRequireDefault(_checkmarkB);
	
	var _arrowForward = __webpack_require__(52);
	
	var _arrowForward2 = _interopRequireDefault(_arrowForward);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _firebase = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AssesmentApply5 = function (_Component) {
	  _inherits(AssesmentApply5, _Component);
	
	  function AssesmentApply5() {
	    _classCallCheck(this, AssesmentApply5);
	
	    return _possibleConstructorReturn(this, (AssesmentApply5.__proto__ || Object.getPrototypeOf(AssesmentApply5)).apply(this, arguments));
	  }
	
	  _createClass(AssesmentApply5, [{
	    key: "render",
	    value: function render() {
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper assesment-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content", style: { background: "#f4f6f9" } },
	          _react2.default.createElement(
	            "div",
	            { className: "container p-0 pt-5" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-6 m-auto p-0" },
	                _react2.default.createElement(
	                  "form",
	                  { className: "form-main-wrapper" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group progress-det" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-group subhead" },
	                      "Answer the following psychometric questions"
	                    )
	                  ),
	                  _react2.default.createElement("hr", null),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      "Psychometric Question 1?"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "label",
	                        { "for": "authorized_usa", className: "label-radio", style: { width: "100px" } },
	                        _react2.default.createElement("input", { name: "authorized_usa", id: "authorized_usa", type: "radio", value: "Yes", onChange: this.handleChange }),
	                        _react2.default.createElement("img", { className: "label-radio-img", alt: "Yes", src: _checkmarkB2.default }),
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Yes"
	                        ),
	                        _react2.default.createElement("div", { className: "label-radio-checkedBackground" })
	                      ),
	                      _react2.default.createElement(
	                        "label",
	                        { "for": "authorized_usa", className: "label-radio", style: { width: "100px" } },
	                        _react2.default.createElement("input", { name: "authorized_usa", id: "authorized_usa", type: "radio", value: "No", onChange: this.handleChange }),
	                        _react2.default.createElement("img", { className: "label-radio-img", alt: "Yes", src: _checkmarkB2.default }),
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "No"
	                        ),
	                        _react2.default.createElement("div", { className: "label-radio-checkedBackground" })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      "Psychometric Question 2?"
	                    ),
	                    _react2.default.createElement(
	                      "select",
	                      { className: "form-control" },
	                      _react2.default.createElement(
	                        "option",
	                        { value: "" },
	                        "Please select...."
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      "Psychometric Question 3?"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "label",
	                        { "for": "authorized_usa", className: "label-radio", style: { width: "100px" } },
	                        _react2.default.createElement("input", { name: "authorized_usa", id: "authorized_usa", type: "radio", value: "Yes", onChange: this.handleChange }),
	                        _react2.default.createElement("img", { className: "label-radio-img", alt: "Yes", src: _checkmarkB2.default }),
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Yes"
	                        ),
	                        _react2.default.createElement("div", { className: "label-radio-checkedBackground" })
	                      ),
	                      _react2.default.createElement(
	                        "label",
	                        { "for": "authorized_usa", className: "label-radio", style: { width: "100px" } },
	                        _react2.default.createElement("input", { name: "authorized_usa", id: "authorized_usa", type: "radio", value: "No", onChange: this.handleChange }),
	                        _react2.default.createElement("img", { className: "label-radio-img", alt: "Yes", src: _checkmarkB2.default }),
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "No"
	                        ),
	                        _react2.default.createElement("div", { className: "label-radio-checkedBackground" })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      "Psychometric Question 4?"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "label",
	                        { "for": "authorized_usa", className: "label-radio", style: { width: "100px" } },
	                        _react2.default.createElement("input", { name: "authorized_usa", id: "authorized_usa", type: "radio", value: "Yes", onChange: this.handleChange }),
	                        _react2.default.createElement("img", { className: "label-radio-img", alt: "Yes", src: _checkmarkB2.default }),
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Yes"
	                        ),
	                        _react2.default.createElement("div", { className: "label-radio-checkedBackground" })
	                      ),
	                      _react2.default.createElement(
	                        "label",
	                        { "for": "authorized_usa", className: "label-radio", style: { width: "100px" } },
	                        _react2.default.createElement("input", { name: "authorized_usa", id: "authorized_usa", type: "radio", value: "No", onChange: this.handleChange }),
	                        _react2.default.createElement("img", { className: "label-radio-img", alt: "Yes", src: _checkmarkB2.default }),
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "No"
	                        ),
	                        _react2.default.createElement("div", { className: "label-radio-checkedBackground" })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group mt-4" },
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      { to: "/user-dashboard" },
	                      _react2.default.createElement(
	                        "button",
	                        { className: "btn btn-theme w-100" },
	                        "Submit"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Anytime you want to skip this session and book an appointment with your career success manager, please do. "
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AssesmentApply5;
	}(_react.Component);
	
	exports.default = AssesmentApply5;

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _careers = __webpack_require__(824);
	
	var _careers2 = _interopRequireDefault(_careers);
	
	var _job = __webpack_require__(840);
	
	var _job2 = _interopRequireDefault(_job);
	
	var _skill = __webpack_require__(846);
	
	var _skill2 = _interopRequireDefault(_skill);
	
	var _cerificate = __webpack_require__(826);
	
	var _cerificate2 = _interopRequireDefault(_cerificate);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _arrowForward = __webpack_require__(52);
	
	var _arrowForward2 = _interopRequireDefault(_arrowForward);
	
	var _firebase = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AssesmentApply5 = function (_Component) {
	    _inherits(AssesmentApply5, _Component);
	
	    function AssesmentApply5(props) {
	        _classCallCheck(this, AssesmentApply5);
	
	        var _this = _possibleConstructorReturn(this, (AssesmentApply5.__proto__ || Object.getPrototypeOf(AssesmentApply5)).call(this, props));
	
	        _this.state = {
	            goal: "",
	            goalData: []
	        };
	        return _this;
	    }
	
	    _createClass(AssesmentApply5, [{
	        key: "componentDidMount",
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var goalList, personna, data, goals;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                goalList = [];
	                                personna = localStorage.getItem("personna");
	
	                                console.log("personna....", personna);
	                                _context.next = 5;
	                                return _firebase.database.ref("goals").once('value', function (snapshot) {
	                                    snapshot.forEach(function (ChildSnapshot) {
	                                        if (ChildSnapshot.val().status == 'Active') {
	                                            var a = ChildSnapshot.val().personna;
	                                            var b = personna;
	                                            if (a == b) {
	                                                goalList.push({
	                                                    name: ChildSnapshot.val().name,
	                                                    key: ChildSnapshot.val().key,
	                                                    personna: ChildSnapshot.val().personna,
	                                                    internalId: ChildSnapshot.val().internalId
	                                                });
	                                            }
	                                        }
	                                    });
	                                });
	
	                            case 5:
	                                this.setState({
	                                    goalData: goalList
	                                });
	                                data = JSON.parse(localStorage.getItem("guidanceArray"));
	                                goals = data.goals;
	
	                                (0, _jquery2.default)('#' + goals).attr("checked", true);
	
	                            case 9:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentDidMount() {
	                return _ref.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	    }, {
	        key: "updateValidateSubmission",
	        value: function updateValidateSubmission() {
	            var _this2 = this;
	
	            if ((0, _jquery2.default)('input[name="goals"]:checked').length == 0) {
	                alert("Please select What Are You Looking For?");
	                return false;
	            } else {
	                this.setState({
	                    goals: (0, _jquery2.default)('input[name=goals]:checked').val()
	                });
	                localStorage.setItem("progressInfo", 60);
	                var dataSet = {
	                    goals: (0, _jquery2.default)('input[name=goals]:checked').val(),
	                    progressInfo: 60
	                };
	                _firebase.database.ref("Guidance/" + this.props.match.params.key).update(dataSet).then(function () {
	                    localStorage.setItem("goal", _this2.state.goal ? _this2.state.goal : "");
	                    window.location.href = "/assesment/apply-2/id=" + _this2.props.match.params.key;
	                }).catch(function () {
	                    alert("Somthing went wrong");
	                });
	                //window.location.href = "/assesment/apply-1"
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "main-wrapper assesment-wrapper" },
	                _react2.default.createElement(_header2.default, null),
	                _react2.default.createElement(
	                    "div",
	                    { className: "main-content assessment-radio" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "container pt-5" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "col-lg-10 m-auto", style: { float: "none" } },
	                            _react2.default.createElement(
	                                "form",
	                                { className: "form-main-wrapper form-main-wrapper-100 border-0", style: { boxShadow: "unset" } },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "form-group subhead" },
	                                    "What are you looking for?"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "col-md-12 form-group text-center" },
	                                    this.state.goalData.map(function (x, y) {
	                                        return _react2.default.createElement(
	                                            "div",
	                                            { className: "row mb-5" },
	                                            _react2.default.createElement("img", { className: "label-radio1-design-img", src: x.name == "I'm looking for a skill-set to get a job." ? _job2.default : x.name == "I'm looking for a certificate" ? _cerificate2.default : x.name == "I want to learn new skill" ? _skill2.default : x.name == "I want to transit in a new career" ? _careers2.default : _careers2.default }),
	                                            _react2.default.createElement(
	                                                "label",
	                                                { "for": "goals", className: "label-radio1-design" },
	                                                _react2.default.createElement("input", { name: "goals", id: x.internalId, type: "radio", value: x.internalId, onChange: _this3.handleChange }),
	                                                _react2.default.createElement(
	                                                    "span",
	                                                    null,
	                                                    x.name
	                                                ),
	                                                _react2.default.createElement("div", { className: "label-radio1-design-checkedBackground" })
	                                            )
	                                        );
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "col-md-12 mt-4 text-center" },
	                                    _react2.default.createElement(
	                                        "a",
	                                        { href: "#", className: "btn btn-gray w-50", style: { width: "83% !important;" }, onClick: function onClick() {
	                                                return _this3.updateValidateSubmission();
	                                            } },
	                                        "Next ",
	                                        _react2.default.createElement("img", { src: _arrowForward2.default, className: "arrow-filter" })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AssesmentApply5;
	}(_react.Component);
	
	exports.default = AssesmentApply5;

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _checkmarkB = __webpack_require__(60);
	
	var _checkmarkB2 = _interopRequireDefault(_checkmarkB);
	
	var _arrowForward = __webpack_require__(52);
	
	var _arrowForward2 = _interopRequireDefault(_arrowForward);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _firebase = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AssesmentApply5 = function (_Component) {
	  _inherits(AssesmentApply5, _Component);
	
	  function AssesmentApply5(props) {
	    _classCallCheck(this, AssesmentApply5);
	
	    var _this = _possibleConstructorReturn(this, (AssesmentApply5.__proto__ || Object.getPrototypeOf(AssesmentApply5)).call(this, props));
	
	    _this.state = {
	      personna: "",
	      personnaData: []
	    };
	    return _this;
	  }
	
	  _createClass(AssesmentApply5, [{
	    key: "componentDidMount",
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var personnaList, data, personna;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                personnaList = [];
	                _context.next = 3;
	                return _firebase.database.ref("personna").orderByChild("sortOrder").once('value', function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    if (ChildSnapshot.val().status == 'Active') {
	                      personnaList.push({
	                        key: ChildSnapshot.key,
	                        image: ChildSnapshot.val().image,
	                        name: ChildSnapshot.val().name,
	                        internalId: ChildSnapshot.val().internalId
	                      });
	                    }
	                  });
	                });
	
	              case 3:
	                this.setState({
	                  personnaData: personnaList
	                });
	                data = JSON.parse(localStorage.getItem("guidanceArray"));
	
	                console.log("data...", data);
	                personna = data.personna;
	
	                (0, _jquery2.default)('#' + personna).attr("checked", true);
	
	              case 8:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "updateValidateSubmission",
	    value: function updateValidateSubmission() {
	      var _this2 = this;
	
	      if ((0, _jquery2.default)('input[name="personna"]:checked').length == 0) {
	        alert("Please select Where Do You See Yourself?");
	        return false;
	      } else {
	        this.setState({
	          personna: (0, _jquery2.default)('input[name=personna]:checked').val()
	        });
	        localStorage.setItem("progressInfo", 40);
	        var dataSet = {
	          personna: (0, _jquery2.default)('input[name=personna]:checked').val(),
	          progressInfo: 40
	        };
	        _firebase.database.ref("Guidance/" + this.props.match.params.key).update(dataSet).then(function () {
	          localStorage.setItem("personna", _this2.state.personna ? _this2.state.personna : "");
	          window.location.href = "/assesment/goal/id=" + _this2.props.match.params.key;
	        }).catch(function () {
	          alert("Somthing went wrong");
	        });
	        //window.location.href = "/assesment/apply-1"
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper assesment-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content assessment-radio" },
	          _react2.default.createElement(
	            "div",
	            { className: "container-fluid pt-5" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-12 m-auto" },
	              _react2.default.createElement(
	                "form",
	                { className: "form-main-wrapper form-main-wrapper-100 border-0", style: { boxShadow: "unset" } },
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group subhead" },
	                  "Where do you see yourself?"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row justify-content-center" },
	                  this.state.personnaData.map(function (x, y) {
	                    return _react2.default.createElement(
	                      "div",
	                      { className: "col-md-4 col-lg-2 form-group text-center" },
	                      _react2.default.createElement("img", { className: "label-radio-design-img", src: x.image }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row m-0" },
	                        _react2.default.createElement(
	                          "label",
	                          { "for": "personna", className: "label-radio-design" },
	                          _react2.default.createElement("input", { name: "personna", id: x.internalId, type: "radio", value: x.internalId }),
	                          _react2.default.createElement(
	                            "span",
	                            null,
	                            x.name
	                          ),
	                          _react2.default.createElement("div", { className: "label-radio-design-checkedBackground" })
	                        )
	                      )
	                    );
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12 mt-4 text-center" },
	                    _react2.default.createElement(
	                      "a",
	                      { href: "#", className: "btn btn-gray w-50", onClick: function onClick() {
	                          return _this3.updateValidateSubmission();
	                        } },
	                      "Next ",
	                      _react2.default.createElement("img", { src: _arrowForward2.default, className: "arrow-filter" })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AssesmentApply5;
	}(_react.Component);
	
	exports.default = AssesmentApply5;

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _career = __webpack_require__(575);
	
	var _career2 = _interopRequireDefault(_career);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CareerTracks = function (_Component) {
	  _inherits(CareerTracks, _Component);
	
	  function CareerTracks() {
	    _classCallCheck(this, CareerTracks);
	
	    return _possibleConstructorReturn(this, (CareerTracks.__proto__ || Object.getPrototypeOf(CareerTracks)).apply(this, arguments));
	  }
	
	  _createClass(CareerTracks, [{
	    key: "render",
	    value: function render() {
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content px-0" },
	          _react2.default.createElement(_career2.default, null)
	        ),
	        _react2.default.createElement(_footer2.default, null)
	      );
	    }
	  }]);
	
	  return CareerTracks;
	}(_react.Component);
	
	exports.default = CareerTracks;

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _deviderWhite = __webpack_require__(828);
	
	var _deviderWhite2 = _interopRequireDefault(_deviderWhite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Contact = function (_Component) {
	  _inherits(Contact, _Component);
	
	  function Contact() {
	    _classCallCheck(this, Contact);
	
	    return _possibleConstructorReturn(this, (Contact.__proto__ || Object.getPrototypeOf(Contact)).apply(this, arguments));
	  }
	
	  _createClass(Contact, [{
	    key: "render",
	    value: function render() {
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content contact-content" },
	          _react2.default.createElement(
	            "div",
	            { className: "contact-banner" },
	            _react2.default.createElement(
	              "div",
	              { className: "contact-banner-content" },
	              _react2.default.createElement(
	                "h3",
	                null,
	                "contact us"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "devider" },
	                _react2.default.createElement("img", { src: _deviderWhite2.default })
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "We would love to hear from you..."
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "container contact-form" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-6" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "subhead text-left", style: { color: "#666" } },
	                  "For more information, please contact us at :"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "mt-4" },
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    _react2.default.createElement(
	                      "strong",
	                      null,
	                      "E-mail:"
	                    ),
	                    " learning@ivanooo.com"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-6" },
	                _react2.default.createElement(
	                  "form",
	                  { className: "form-main-wrapper p-0" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "subhead text-left", style: { color: "#666" } },
	                    "Or drop us a line here :"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement("input", { type: "email", className: "form-control", placeholder: "Your Name*" }),
	                    _react2.default.createElement(
	                      "small",
	                      { className: "text-danger" },
	                      "Please enter your name."
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement("input", { type: "email", className: "form-control", placeholder: "Your Email*" }),
	                    _react2.default.createElement(
	                      "small",
	                      { className: "text-danger" },
	                      "Please enter your email address."
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement("input", { type: "email", className: "form-control", placeholder: "Your Phone*" }),
	                    _react2.default.createElement(
	                      "small",
	                      { className: "text-danger" },
	                      "Please enter your phone number."
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement("textarea", { className: "form-control", placeholder: "Your Message*" }),
	                    _react2.default.createElement(
	                      "small",
	                      { className: "text-danger" },
	                      "Please enter a message."
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group mt-4" },
	                    _react2.default.createElement(
	                      "button",
	                      { type: "submit", className: "btn btn-theme-rect" },
	                      "SEND MESSAGE"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_footer2.default, null)
	      );
	    }
	  }]);
	
	  return Contact;
	}(_react.Component);
	
	exports.default = Contact;

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _reactTabs = __webpack_require__(161);
	
	__webpack_require__(137);
	
	var _photography = __webpack_require__(414);
	
	var _photography2 = _interopRequireDefault(_photography);
	
	var _certificate = __webpack_require__(827);
	
	var _certificate2 = _interopRequireDefault(_certificate);
	
	var _getHelp = __webpack_require__(639);
	
	var _getHelp2 = _interopRequireDefault(_getHelp);
	
	var _facebook = __webpack_require__(830);
	
	var _facebook2 = _interopRequireDefault(_facebook);
	
	var _tiktok = __webpack_require__(847);
	
	var _tiktok2 = _interopRequireDefault(_tiktok);
	
	var _klaviyo = __webpack_require__(841);
	
	var _klaviyo2 = _interopRequireDefault(_klaviyo);
	
	var _wordpress = __webpack_require__(850);
	
	var _wordpress2 = _interopRequireDefault(_wordpress);
	
	var _googleAdwordsLogo = __webpack_require__(832);
	
	var _googleAdwordsLogo2 = _interopRequireDefault(_googleAdwordsLogo);
	
	var _howDoesWork = __webpack_require__(834);
	
	var _howDoesWork2 = _interopRequireDefault(_howDoesWork);
	
	var _dmInstructor = __webpack_require__(829);
	
	var _dmInstructor2 = _interopRequireDefault(_dmInstructor);
	
	var _testimonial = __webpack_require__(212);
	
	var _testimonial2 = _interopRequireDefault(_testimonial);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactSlick = __webpack_require__(783);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(624);
	
	__webpack_require__(623);
	
	var _firebase = __webpack_require__(6);
	
	var _htmlReactParser = __webpack_require__(654);
	
	var _htmlReactParser2 = _interopRequireDefault(_htmlReactParser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ii = 0;
	
	var CourseDetails = function (_Component) {
	  _inherits(CourseDetails, _Component);
	
	  function CourseDetails(props) {
	    _classCallCheck(this, CourseDetails);
	
	    var _this = _possibleConstructorReturn(this, (CourseDetails.__proto__ || Object.getPrototypeOf(CourseDetails)).call(this, props));
	
	    _this.state = {
	      CourseName: '',
	      id: null,
	      bannerTitle: "",
	      bannerDescription: "",
	
	      modelRight: [],
	      whatyoudo_Description: "",
	      rightModelTitle: "",
	
	      WhatYouWillLearnArray: [],
	
	      WhatYouWillGetArray: [],
	
	      HowdoesitworkArray: [],
	      PlatformsToolsFiles: [],
	
	      CertificationsFiles: []
	
	    };
	
	    return _this;
	  }
	
	  _createClass(CourseDetails, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var url_path = window.location.href.split("=");
	      var keyId = url_path[1];
	      this.renderList(keyId);
	
	      var acc = document.getElementsByClassName("accordion");
	      var i;
	
	      for (i = 0; i < acc.length; i++) {
	        acc[i].addEventListener("click", function () {
	          this.classList.toggle("active");
	          var panel = this.nextElementSibling;
	          if (panel.style.display === "block") {
	            panel.style.display = "none";
	          } else {
	            panel.style.display = "block";
	          }
	        });
	      }
	
	      (0, _jquery2.default)('.get-help-right-button').click(function () {
	        (0, _jquery2.default)('.get-help-right-button.gTactive').removeClass('gTactive');
	        (0, _jquery2.default)(this).addClass('gTactive');
	      });
	    }
	  }, {
	    key: "renderList",
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(keyId) {
	        var id, ref, userRef, valueRef, snapshot, val;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	
	                //let dataList = []
	                id = keyId;
	                ref = id ? '/Course/' + id : 'Course';
	                userRef = _firebase.database.ref(ref);
	
	                if (!id) {
	                  _context.next = 7;
	                  break;
	                }
	
	                _context.t0 = userRef;
	                _context.next = 10;
	                break;
	
	              case 7:
	                _context.next = 9;
	                return userRef.orderByChild('key').equalTo('value');
	
	              case 9:
	                _context.t0 = _context.sent;
	
	              case 10:
	                valueRef = _context.t0;
	                _context.next = 13;
	                return valueRef.once('value');
	
	              case 13:
	                snapshot = _context.sent;
	                val = snapshot.val();
	
	                if (val) {
	
	                  this.setState({
	                    CourseUrl: val.imageUrl,
	                    id: id,
	                    CourseName: val.CourseName,
	                    bannerTitle: val.bannerDetails[0].title,
	                    bannerDescription: val.bannerDetails[0].description,
	                    whatyoudo_Description: val.whatyoudo_Description,
	                    rightModelTitle: val.whatyoudo_rightModel[0].rightModelTitle,
	                    modelRight: val.whatyoudo_rightModel[0].modelData,
	                    WhatYouWillLearnArray: val.WhatYouWillLearn,
	                    WhatYouWillGetArray: val.WhatYouWillGet,
	                    HowdoesitworkArray: val.Howdoesitwork,
	                    PlatformsToolsFiles: val.PlatformsToolsFiles,
	                    CertificationsFiles: val.CertificationsFiles
	
	                  });
	                } else {}
	
	              case 16:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function renderList(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return renderList;
	    }()
	  }, {
	    key: "accordionClick",
	    value: function accordionClick(key) {
	      (0, _jquery2.default)(".panel").hide();
	      (0, _jquery2.default)("#panel" + key).show();
	      (0, _jquery2.default)(".accordion").removeClass("active");
	      (0, _jquery2.default)("#accordion" + key).addClass("active");
	    }
	  }, {
	    key: "accordionWork",
	    value: function accordionWork(key) {
	      (0, _jquery2.default)(".panelWork").hide();
	      (0, _jquery2.default)("#panelWork" + key).show();
	      (0, _jquery2.default)(".accordion").removeClass("active");
	      (0, _jquery2.default)("#accordionClick" + key).addClass("active");
	    }
	  }, {
	    key: "getHelpClick",
	    value: function getHelpClick(key) {
	      (0, _jquery2.default)('.get-help-right-button.gTactive').removeClass('gTactive');
	      (0, _jquery2.default)('.get-help-right-button' + key).addClass('gTactive');
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var settings = {
	        dots: true,
	        infinite: false,
	        speed: 500,
	        slidesToShow: 3,
	        slidesToScroll: 1,
	        responsive: [{
	          breakpoint: 1024,
	          settings: {
	            slidesToShow: 1
	          }
	        }]
	      };
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper course-det-wrapper" },
	        _react2.default.createElement(
	          "div",
	          { className: "heaerBgImg" },
	          _react2.default.createElement(_header2.default, null),
	          _react2.default.createElement(
	            "div",
	            { className: "row head-top-section" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6", style: { position: "relative" } },
	              _react2.default.createElement(
	                "div",
	                { className: "insights-det-head mb-0" },
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  this.state.bannerTitle
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "my-4" },
	                  (0, _htmlReactParser2.default)(this.state.bannerDescription)
	                ),
	                _react2.default.createElement(
	                  "button",
	                  { className: "btn-theme btn-sm" },
	                  "Get Free Guidence"
	                )
	              )
	            ),
	            _react2.default.createElement("div", { className: "col-md-6 bg-icons" })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content p-0" },
	          _react2.default.createElement(
	            "section",
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "container px-4 course-det-what-do" },
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-7" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "insights-det-head" },
	                    _react2.default.createElement(
	                      "h4",
	                      { className: "mb-4" },
	                      "What you'll do"
	                    ),
	                    (0, _htmlReactParser2.default)(this.state.whatyoudo_Description),
	                    _react2.default.createElement(
	                      "a",
	                      { className: "readmore", href: "#" },
	                      "read more"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-lg-4 mt-5 mt-lg-0 offset-md-1" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "courses-det-box" },
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "div",
	                        { className: "course-det-rate" },
	                        " ",
	                        this.state.rightModelTitle,
	                        " "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "courses-det-box-list" },
	                        this.state.modelRight.map(function (data, i) {
	                          return _react2.default.createElement(
	                            "div",
	                            { className: "courses-det-box-list" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "courses-det-box-bottom" },
	                              _react2.default.createElement(
	                                "span",
	                                { className: "courses-det-box-bottom-left" },
	                                " ",
	                                data.date,
	                                " "
	                              ),
	                              _react2.default.createElement(
	                                "span",
	                                { className: "courses-det-box-bottom-right" },
	                                data.price
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "div",
	                              { className: "courses-det-box-bottom" },
	                              _react2.default.createElement(
	                                "small",
	                                { className: "d-block" },
	                                data.duration
	                              ),
	                              _react2.default.createElement(
	                                "button",
	                                { className: "btn-theme btn-sm" },
	                                "Get Guidence"
	                              )
	                            )
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 course-det-learn" },
	              _react2.default.createElement(
	                "div",
	                { className: "container px-4" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "insights-det-head mb-0" },
	                  _react2.default.createElement(
	                    "h4",
	                    null,
	                    "What You Will Learn"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "get-accordian" },
	                  this.state.WhatYouWillLearnArray.map(function (data, i) {
	
	                    return _react2.default.createElement(
	                      "div",
	                      { className: "accordion-list" },
	                      _react2.default.createElement(
	                        "button",
	                        { className: "accordion", id: 'accordion' + i, onClick: function onClick() {
	                            return _this2.accordionClick(i);
	                          } },
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          data.title
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "panel", id: 'panel' + i, style: { display: 'none' } },
	                        (0, _htmlReactParser2.default)(data.description)
	                      )
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "course-det-what-get" },
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-7 col-lg-8" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "course-det-what-get-Content" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "insights-det-head mb-0" },
	                      _react2.default.createElement(
	                        "h4",
	                        null,
	                        "What You Will Get"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "course-det-what-get-img" },
	                      _react2.default.createElement("img", { src: _getHelp2.default, className: "img-fluid" })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-5 col-lg-4" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "get-help-right" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "get-help-right-lists" },
	                      this.state.WhatYouWillGetArray.map(function (data, i) {
	                        return _react2.default.createElement(
	                          "div",
	                          { className: "get-help-right-button get-help-right-button" + i, onClick: function onClick() {
	                              return _this2.getHelpClick(i);
	                            } },
	                          data.title
	                        );
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "platform-tools-main" },
	              _react2.default.createElement(
	                "div",
	                { className: "container" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "insights-det-head" },
	                  _react2.default.createElement(
	                    "h4",
	                    null,
	                    "Platforms & Tools"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row mt-3 platform-tools-list" },
	                  this.state.PlatformsToolsFiles.map(function (data, i) {
	                    return _react2.default.createElement(
	                      "div",
	                      { className: "platform-tools-img" },
	                      _react2.default.createElement("img", { src: data.url, className: "img-fluid mb-2" })
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "course-det-what-get how-does-work-main" },
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-7 col-lg-7" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "course-det-what-get-Content" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "insights-det-head" },
	                      _react2.default.createElement(
	                        "h4",
	                        null,
	                        "How does it work"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "course-det-what-get-img mt-0" },
	                      _react2.default.createElement("img", { src: _howDoesWork2.default, className: "img-fluid" })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-5 col-lg-5" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "how-work-right" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "insights-det-head mb-0" },
	                      _react2.default.createElement(
	                        "h4",
	                        null,
	                        "How does it work"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "how-work-accordion" },
	                      this.state.HowdoesitworkArray.map(function (data, i) {
	                        ii = ii + 1;
	                        return _react2.default.createElement(
	                          "span",
	                          null,
	                          _react2.default.createElement(
	                            "button",
	                            { className: "accordion", id: "accordionClick" + i, onClick: function onClick() {
	                                return _this2.accordionWork(i);
	                              } },
	                            " ",
	                            data.title,
	                            " ",
	                            _react2.default.createElement(
	                              "span",
	                              null,
	                              "0",
	                              ii
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "panel panelWork", id: "panelWork" + i, style: { display: 'none' } },
	                            (0, _htmlReactParser2.default)(data.description)
	                          )
	                        );
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "certification-main" },
	              _react2.default.createElement(
	                "div",
	                { className: "insights-det-head" },
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Certifications"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row mt-3" },
	                _react2.default.createElement(
	                  _reactSlick2.default,
	                  settings,
	                  this.state.CertificationsFiles.map(function (data, i) {
	                    return _react2.default.createElement(
	                      "div",
	                      { className: "certification-list" },
	                      _react2.default.createElement("img", { src: data.url, className: "img-fluid mb-5" })
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(_testimonial2.default, null),
	            _react2.default.createElement(
	              "div",
	              { className: "container px-4 course-det-what-do" },
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "insights-det-head" },
	                    _react2.default.createElement(
	                      "h4",
	                      { className: "mb-4" },
	                      "Meet Your Instructor"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "teacher-head" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "teacher-left" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "teacher-name" },
	                        "Firoz Khan"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "teacher-designation" },
	                        "E-commerce Expert"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "rating" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "stars" },
	                          _react2.default.createElement("i", { className: "fa fa-star" }),
	                          _react2.default.createElement("i", { className: "fa fa-star" }),
	                          _react2.default.createElement("i", { className: "fa fa-star" }),
	                          _react2.default.createElement("i", { className: "fa fa-star" }),
	                          _react2.default.createElement("i", { className: "fa fa-star" })
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          " total reviews"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "a",
	                        { href: "/", className: "btn-theme" },
	                        "View All Course"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "teacher-right" },
	                      _react2.default.createElement("img", { src: _dmInstructor2.default, alt: "", className: "teacher-img" })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "insights-det-head" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "I am a Growth Digital Marketing professional with over 8 years of expertise, specialized in working with established companies for securing and growing their business.  I have assisted organizations in acquiring and retaining customers from various digital channels by using multiple growth strategies."
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Being part of two world-class cities (Singapore & Dubai) helped me acquire expertise and insights by understanding the patterns and underlying principles of the digital fields..."
	                    ),
	                    _react2.default.createElement(
	                      "a",
	                      { className: "readmore", href: "#" },
	                      "read more"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_footer2.default, null)
	      );
	    }
	  }]);
	
	  return CourseDetails;
	}(_react.Component);
	
	exports.default = CourseDetails;

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _courses = __webpack_require__(114);
	
	var _courses2 = _interopRequireDefault(_courses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CoursesIvano = function (_Component) {
	  _inherits(CoursesIvano, _Component);
	
	  function CoursesIvano() {
	    _classCallCheck(this, CoursesIvano);
	
	    return _possibleConstructorReturn(this, (CoursesIvano.__proto__ || Object.getPrototypeOf(CoursesIvano)).apply(this, arguments));
	  }
	
	  _createClass(CoursesIvano, [{
	    key: "render",
	    value: function render() {
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper" },
	        _react2.default.createElement(
	          "div",
	          { className: "heaerBgImg" },
	          _react2.default.createElement(_header2.default, null),
	          _react2.default.createElement(
	            "div",
	            { className: "header-head" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "h4",
	                null,
	                "Courses"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content px-0 career-wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "career-panel" },
	              _react2.default.createElement(
	                "div",
	                { className: "career-head" },
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Courses"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "Live Online Masterclass."
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "career-body" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "career-box" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: "#", className: "career-box-a" },
	                    _react2.default.createElement("img", { alt: "", className: "career-img", src: _courses2.default }),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "career-box-text" },
	                      "Cybersecurity"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "career-box" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: "#", className: "career-box-a" },
	                    _react2.default.createElement("img", { alt: "", className: "career-img", src: _courses2.default }),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "career-box-text" },
	                      "Cybersecurity"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "career-box" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: "#", className: "career-box-a" },
	                    _react2.default.createElement("img", { alt: "", className: "career-img", src: _courses2.default }),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "career-box-text" },
	                      "Cybersecurity"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "career-box" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: "#", className: "career-box-a" },
	                    _react2.default.createElement("img", { alt: "", className: "career-img", src: _courses2.default }),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "career-box-text" },
	                      "Cybersecurity"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "career-box" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: "#", className: "career-box-a" },
	                    _react2.default.createElement("img", { alt: "", className: "career-img", src: _courses2.default }),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "career-box-text" },
	                      "Cybersecurity"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_footer2.default, null)
	      );
	    }
	  }]);
	
	  return CoursesIvano;
	}(_react.Component);
	
	exports.default = CoursesIvano;

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _default = __webpack_require__(163);
	
	var _default2 = _interopRequireDefault(_default);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _firebase = __webpack_require__(6);
	
	var _photography = __webpack_require__(414);
	
	var _photography2 = _interopRequireDefault(_photography);
	
	var _reactTabs = __webpack_require__(161);
	
	__webpack_require__(137);
	
	var _reactStarRatings = __webpack_require__(788);
	
	var _reactStarRatings2 = _interopRequireDefault(_reactStarRatings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dashboard = function (_Component) {
	  _inherits(Dashboard, _Component);
	
	  function Dashboard(props) {
	    _classCallCheck(this, Dashboard);
	
	    var _this = _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call(this, props));
	
	    _this.state = {
	      userData: [],
	      careerData: [],
	      careerData1: [],
	      careerData2: [],
	      careerData3: [],
	      guidanceArray: [],
	      skillData: [],
	      modeOfLearningData: [],
	      institutionData: [],
	      universityName: "",
	      CourseName: "",
	      imageUrl: "",
	      Courserating: 0,
	      Expertise: "",
	      Language: '',
	      Level: '',
	      Modeoflearning: '',
	      courseDescription: '',
	      currentSalary: 0,
	      salaryMax: 0,
	      salaryMin: 0,
	      salaryDifference: 0,
	      ivanooograde: '',
	      price: '',
	      duration: '',
	      progressInfo: "",
	      accrediation: "",
	      outcome: []
	    };
	    _this.logout = _this.logout.bind(_this);
	    return _this;
	  }
	
	  _createClass(Dashboard, [{
	    key: "logout",
	    value: function logout() {
	      localStorage.removeItem("userId");
	      localStorage.removeItem("userName");
	      localStorage.removeItem("userImage");
	      localStorage.removeItem("guidanceArray");
	      window.location.href = "/";
	    }
	  }, {
	    key: "componentDidMount",
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var userKey, userName;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                userKey = localStorage.getItem("userId");
	                userName = localStorage.getItem("userName");
	
	                this.setState({
	                  userName: userName
	                });
	                this.renderList(userKey);
	                _context.next = 6;
	                return this.renderModeOfLearning();
	
	              case 6:
	                _context.next = 8;
	                return this.renderInstitute();
	
	              case 8:
	                _context.next = 10;
	                return this.renderCourse();
	
	              case 10:
	
	                //await this.getGuidanceDetails(userKey)
	                (0, _jquery2.default)("#activeCourse").click(function () {
	
	                  (0, _jquery2.default)(this).toggleClass("fa-bookmark");
	                  (0, _jquery2.default)(this).toggleClass("fa-bookmark-o");
	                });
	
	              case 11:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "getGuidanceDetails",
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(keyId, careerDatas) {
	        var modeOfLearning, budgetConstriction, Expertise, Skills, goals, country, currentSalary, SkillQuotient, progressInfo, newCourse, newCourse1, newCourse2, newCourse3, skillCheckedData, experience, newCourse1Arr, salaryMax, salaryMin, salaryDifference;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                //console.log("inside getGuidanceDetails")
	                modeOfLearning = '';
	                budgetConstriction = '';
	                Expertise = '';
	                Skills = '';
	                goals = '';
	                country = "";
	                currentSalary = 0;
	                SkillQuotient = 0;
	                progressInfo = 0;
	                newCourse = [];
	                newCourse1 = [];
	                newCourse2 = [];
	                newCourse3 = [];
	                skillCheckedData = [];
	                experience = "";
	                _context2.next = 17;
	                return _firebase.database.ref("Guidance").once('value', function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    if (ChildSnapshot.val().hasOwnProperty('userDate')) {
	                      if (ChildSnapshot.val().userDate.hasOwnProperty('userId')) {
	                        if (ChildSnapshot.val().userDate.userId === keyId) {
	                          (0, _jquery2.default)("#Guidance").val(ChildSnapshot.key);
	                          localStorage.setItem("guidanceArray", JSON.stringify(ChildSnapshot.val()));
	                          modeOfLearning = ChildSnapshot.val().modeOfLearning;
	                          budgetConstriction = ChildSnapshot.val().budgetConstriction;
	                          goals = ChildSnapshot.val().goals;
	                          country = ChildSnapshot.val().userDate.country;
	                          Expertise = ChildSnapshot.val().Expertise;
	                          Skills = ChildSnapshot.val().skillUserRating;
	                          currentSalary = ChildSnapshot.val().currentSalary;
	                          if (currentSalary === "") {
	                            currentSalary = 0;
	                          }
	                          skillCheckedData = Skills.filter(function (el) {
	                            return el.skillChecked.includes("true");
	                          });
	                          (0, _jquery2.default)("#progressInfo").text(ChildSnapshot.val().progressInfo);
	                          progressInfo = ChildSnapshot.val().progressInfo;
	                          if (ChildSnapshot.val().Experience != "") {
	                            SkillQuotient = SkillQuotient + 20;
	                          }
	                          experience = ChildSnapshot.val().Experience;
	                          var a = ChildSnapshot.val().skillUserRating;
	                          var skillRating = 0;
	                          if (a) {
	                            a.forEach(function (d) {
	                              skillRating = skillRating + parseInt(d.skillRating);
	                            });
	                            skillRating = skillRating / a.length;
	                          }
	                          var rate = 0;
	                          rate = skillRating <= 3 ? 10 : skillRating <= 7 ? 20 : 30;
	                          SkillQuotient = SkillQuotient + rate;
	                          rate = progressInfo <= 50 ? 10 : 20;
	                          SkillQuotient = SkillQuotient + rate;
	                          (0, _jquery2.default)("#skillquotient").text(SkillQuotient / 10);
	                          var careerData = careerDatas;
	                          careerData.forEach(function (data) {
	                            if (data.hasOwnProperty('expertise')) {
	                              if (data.expertise === Expertise) {
	                                if (data.hasOwnProperty('CourseFields')) {
	                                  if (data.CourseFields != undefined) {
	                                    if (data.CourseFields[0].hasOwnProperty('CourseScore')) {
	                                      var score = data.CourseFields[0].CourseScore;
	                                      if (score) {
	                                        if (goals == 4 || goals == 7 || goals == 10 || goals == 14 || goals == 18) {
	                                          if (data.hasOwnProperty('Country')) {
	                                            if (data.Country == country) {
	                                              newCourse.push(data);
	                                            }
	                                          }
	                                        } else if (goals == 3 || goals == 6 || goals == 9 || goals == 13 || goals == 17) {
	
	                                          if (data.hasOwnProperty('CourseFields')) {
	                                            if (data.CourseFields[0].QuickUpskilling != undefined) {
	                                              newCourse.push(data);
	                                            }
	                                          }
	                                        } else {
	                                          newCourse.push(data);
	                                        }
	                                        // if (goals == "I want to upskill myself quickly.") {
	                                        //   if (data.hasOwnProperty('outcomes')) {
	                                        //     if (data.outcomes[0].QuickUpskills == "True") {
	                                        //       newCourse.push(data)
	                                        //     }
	                                        //     //console.log("inside 1....")
	                                        //   }
	                                        // }
	                                        // if (goals == "I'm looking for a certificate") {
	                                        //   //console.log("123....", data.hasOwnProperty('outcomes'))
	                                        //   if (data.hasOwnProperty('outcomes')) {
	                                        //     if (data.outcomes[0].Certificates == "True") {
	                                        //       newCourse.push(data)
	                                        //     }
	                                        //     //console.log("inside 2....")
	                                        //   }
	                                        // }
	                                        // if (goals == "I'm looking for a skill-set to get a job.") {
	                                        //   if (data.hasOwnProperty('outcomes')) {
	                                        //     if (data.outcomes[0].Jobs == "True") {
	                                        //       newCourse.push(data)
	                                        //     }
	                                        //     //console.log("inside 3....")
	                                        //   }
	                                        // }
	                                        // if (goals == 'I want to transit in a new career') {
	                                        //   if (data.hasOwnProperty('outcomes')) {
	                                        //     if (data.outcomes[0].CareerTransition == "True") {
	                                        //       newCourse.push(data)
	                                        //     }
	                                        //     //console.log("inside 4....")
	                                        //   }
	                                        // }
	
	                                        //Sort by ivanoscore
	                                        if (goals == 4 || goals == 7 || goals == 10 || goals == 14 || goals == 18) {
	                                          newCourse.sort(function (a, b) {
	                                            var keyA = a.CourseFields[0].CourseScore,
	                                                keyB = b.CourseFields[0].CourseScore;
	                                            if (parseFloat(keyA) < parseFloat(keyB)) return -1;
	                                            if (parseFloat(keyA) > parseFloat(keyB)) return 1;
	                                            return 0;
	                                          });
	                                          newCourse = newCourse.reverse();
	                                        }
	                                        //Sort by Certificate
	                                        if (goals == 2 || goals == 5 || goals == 8 || goals == 12) {
	                                          //console.log("inside Certificate")
	                                          newCourse.sort(function (x, y) {
	                                            var n = parseFloat(x.CourseFields[0].Ranking) - parseFloat(y.CourseFields[0].Ranking);
	                                            if (n !== 0) {
	                                              return n;
	                                            }
	                                            return parseFloat(x.CourseFields[0].CourseScore) - parseFloat(y.CourseFields[0].CourseScore);
	                                          });
	                                          newCourse.reverse();
	                                        }
	                                        //Sort by Job Assistance
	                                        if (goals == 1 || goals == 11 || goals == 15) {
	                                          //console.log("inside Job Assistance")
	                                          newCourse.sort(function (x, y) {
	                                            var n = parseFloat(x.CourseFields[0].JobAssistance) - parseFloat(y.CourseFields[0].JobAssistance);
	                                            if (n !== 0) {
	                                              return n;
	                                            }
	                                            return parseFloat(x.CourseFields[0].CourseScore) - parseFloat(y.CourseFields[0].CourseScore);
	                                          });
	                                          newCourse.reverse();
	                                        }
	                                        //Sort by Quick Upskilling
	                                        if (goals == 3 || goals == 6 || goals == 9 || goals == 13 || goals == 17) {
	                                          //console.log("inside Quick Upskilling")
	                                          newCourse.sort(function (x, y) {
	                                            var n = parseFloat(x.CourseFields[0].QuickUpskilling) - parseFloat(y.CourseFields[0].QuickUpskilling);
	                                            if (n !== 0) {
	                                              return n;
	                                            }
	                                            return parseFloat(x.CourseFields[0].CourseScore) - parseFloat(y.CourseFields[0].CourseScore);
	                                          });
	                                          newCourse.reverse();
	                                        }
	                                        //console.log("newCourse...", newCourse)
	                                        // if (goals == "I want to learn a new skill") {
	                                        //   if (data.hasOwnProperty('outcomes')) {
	                                        //     if (data.outcomes.length == 2) {
	                                        //       newCourse.sort(function (a, b) {
	                                        //         var keyA = a.outcomes[1].QuickUpskillsScore,
	                                        //           keyB = b.outcomes[1].QuickUpskillsScore;
	                                        //         if (keyA < keyB) return -1;
	                                        //         if (keyA > keyB) return 1;
	                                        //         return 0;
	                                        //       });
	                                        //       newCourse = newCourse.reverse()
	                                        //     }
	                                        //   }
	                                        // }
	                                        // if (goals == "I want to upskill myself quickly.") {
	                                        //   if (data.hasOwnProperty('outcomes')) {
	                                        //     if (data.outcomes.length == 2) {
	                                        //       newCourse.sort(function (a, b) {
	                                        //         var keyA = a.outcomes[1].QuickUpskillsScore,
	                                        //           keyB = b.outcomes[1].QuickUpskillsScore;
	                                        //         if (keyA < keyB) return -1;
	                                        //         if (keyA > keyB) return 1;
	                                        //         return 0;
	                                        //       });
	                                        //       newCourse = newCourse.reverse()
	                                        //     }
	                                        //   }
	                                        // }
	                                        // if (goals == "I'm looking for a certificate") {
	                                        //   if (data.hasOwnProperty('outcomes')) {
	                                        //     if (data.outcomes.length == 2) {
	                                        //       newCourse.sort(function (a, b) {
	                                        //         var keyA = a.outcomes[1].CertificatesScore,
	                                        //           keyB = b.outcomes[1].CertificatesScore;
	                                        //         if (keyA < keyB) return -1;
	                                        //         if (keyA > keyB) return 1;
	                                        //         return 0;
	                                        //       });
	                                        //       newCourse = newCourse.reverse()
	                                        //     }
	                                        //   }
	                                        // }
	                                        // if (goals == "I'm looking for a skill-set to get a job.") {
	                                        //   if (data.hasOwnProperty('outcomes')) {
	                                        //     if (data.outcomes.length == 2) {
	                                        //       newCourse.sort(function (a, b) {
	                                        //         var keyA = a.outcomes[1].JobsScore,
	                                        //           keyB = b.outcomes[1].JobsScore;
	                                        //         if (keyA < keyB) return -1;
	                                        //         if (keyA > keyB) return 1;
	                                        //         return 0;
	                                        //       });
	                                        //       newCourse = newCourse.reverse()
	                                        //     }
	                                        //   }
	                                        // }
	                                        // if (goals == "I want to transit in a new career") {
	                                        //   if (data.hasOwnProperty('outcomes')) {
	                                        //     if (data.outcomes.length == 2) {
	                                        //       newCourse.sort(function (a, b) {
	                                        //         var keyA = a.outcomes[1].CareerTransitionScore,
	                                        //           keyB = b.outcomes[1].CareerTransitionScore;
	                                        //         if (keyA < keyB) return -1;
	                                        //         if (keyA > keyB) return 1;
	                                        //         return 0;
	                                        //       });
	                                        //       newCourse = newCourse.reverse()
	                                        //     }
	                                        //   }
	                                        // }
	                                        if (skillCheckedData.length > 0) {
	                                          if (data.hasOwnProperty('Skills')) {
	                                            if (data.Skills != undefined) {
	                                              if (skillCheckedData.length == 1) {
	                                                var skillCheckedData1 = data.Skills.filter(function (el) {
	                                                  return el.skill.includes(skillCheckedData[0].skillName);
	                                                });
	                                                if (skillCheckedData1.length > 0) {
	                                                  newCourse1.push(data);
	                                                }
	                                              }
	                                              if (skillCheckedData.length == 2) {
	                                                var _skillCheckedData = data.Skills.filter(function (el) {
	                                                  return el.skill.includes(skillCheckedData[0].skillName);
	                                                });
	                                                var skillCheckedData2 = data.Skills.filter(function (el) {
	                                                  return el.skill.includes(skillCheckedData[1].skillName);
	                                                });
	                                                if (_skillCheckedData.length > 0) {
	                                                  newCourse1.push(data);
	                                                }
	                                                if (skillCheckedData2.length > 0) {
	                                                  newCourse2.push(data);
	                                                }
	                                              }
	                                              if (skillCheckedData.length >= 3) {
	                                                var _skillCheckedData2 = data.Skills.filter(function (el) {
	                                                  return el.skill.includes(skillCheckedData[0].skillName);
	                                                });
	                                                var _skillCheckedData3 = data.Skills.filter(function (el) {
	                                                  return el.skill.includes(skillCheckedData[1].skillName);
	                                                });
	                                                var skillCheckedData3 = data.Skills.filter(function (el) {
	                                                  return el.skill.includes(skillCheckedData[2].skillName);
	                                                });
	                                                if (_skillCheckedData2.length > 0) {
	                                                  newCourse1.push(data);
	                                                }
	                                                if (_skillCheckedData3.length > 0) {
	                                                  newCourse2.push(data);
	                                                }
	                                                if (skillCheckedData3.length > 0) {
	                                                  newCourse3.push(data);
	                                                }
	                                              }
	                                            } else {
	                                              if (skillCheckedData.length == 1) {
	                                                if (data.CourseName.includes(skillCheckedData[0].skillName)) {
	                                                  newCourse1.push(data);
	                                                }
	                                              }
	                                              if (skillCheckedData.length == 2) {
	                                                if (data.CourseName.includes(skillCheckedData[1].skillName)) {
	                                                  newCourse2.push(data);
	                                                }
	                                                if (data.CourseName.includes(skillCheckedData[0].skillName)) {
	                                                  newCourse1.push(data);
	                                                }
	                                              }
	                                              if (skillCheckedData.length == 3) {
	                                                if (data.CourseName.includes(skillCheckedData[1].skillName)) {
	                                                  newCourse2.push(data);
	                                                }
	                                                if (data.CourseName.includes(skillCheckedData[0].skillName)) {
	                                                  newCourse1.push(data);
	                                                }
	                                                if (data.CourseName.includes(skillCheckedData[2].skillName)) {
	                                                  newCourse3.push(data);
	                                                }
	                                              }
	                                            }
	                                            if (newCourse1.length > 0 || newCourse2.length > 0 || newCourse3.length > 0) {
	                                              newCourse = [];
	                                            }
	                                          }
	                                        }
	                                        //console.log("newCourse123...", newCourse)
	                                      }
	                                    }
	                                  }
	                                }
	                              }
	                            }
	                          });
	                        }
	                      }
	                    }
	                  });
	                });
	
	              case 17:
	                //console.log("0.....", newCourse)
	                if (newCourse1.length > 0) {
	                  newCourse1Arr = [];
	
	
	                  newCourse1.sort(function (a, b) {
	                    var keyA = a.CourseFields[0].CourseScore,
	                        keyB = b.CourseFields[0].CourseScore;
	                    if (parseFloat(keyA) < parseFloat(keyB)) return -1;
	                    if (parseFloat(keyA) > parseFloat(keyB)) return 1;
	                    return 0;
	                  });
	                  newCourse1 = newCourse1.reverse();
	
	                  // newCourse1.forEach(function (data) {
	                  //   data.Skills.forEach(function (data1) {
	                  //     if (data1.hasOwnProperty("skillRating") && data1.skill == skillCheckedData[0].skillName) {
	                  //       data.skillRating = data1.skillRating
	                  //       newCourse1Arr.push(data)
	                  //     }
	                  //     else {
	                  //       data.skillRating = 0
	                  //       newCourse1Arr.push(data)
	                  //     }
	                  //   });
	                  // });
	                  // newCourse1 = newCourse1Arr
	                  // newCourse1.sort(function (a, b) {
	                  //   var keyA = a.skillRating,
	                  //     keyB = b.skillRating;
	                  //   if (keyA < keyB) return -1;
	                  //   if (keyA > keyB) return 1;
	                  //   return 0;
	                  // });
	                  // var newCourse1Arr1 = newCourse1.filter(el => el.skillRating > 0);
	                  // if (newCourse1Arr1.length > 0) {
	                  //   newCourse1.reverse()
	                  // }
	                }
	                //console.log("1.....", newCourse)
	                if (newCourse2.length > 0) {
	                  newCourse2.sort(function (a, b) {
	                    var keyA = a.CourseFields[0].CourseScore,
	                        keyB = b.CourseFields[0].CourseScore;
	                    if (parseFloat(keyA) < parseFloat(keyB)) return -1;
	                    if (parseFloat(keyA) > parseFloat(keyB)) return 1;
	                    return 0;
	                  });
	                  newCourse2 = newCourse2.reverse();
	
	                  // var newCourse2Arr = []
	                  // newCourse2.forEach(function (data) {
	                  //   data.Skills.forEach(function (data1) {
	                  //     if (data1.hasOwnProperty("skillRating") && data1.skill == skillCheckedData[1].skillName) {
	                  //       data.skillRating = data1.skillRating
	                  //       newCourse2Arr.push(data)
	                  //     }
	                  //     else {
	                  //       data.skillRating = 0
	                  //       newCourse2Arr.push(data)
	                  //     }
	                  //   });
	                  // });
	                  // newCourse2 = newCourse2Arr
	                  // newCourse2.sort(function (a, b) {
	                  //   var keyA = a.skillRating,
	                  //     keyB = b.skillRating;
	                  //   if (keyA < keyB) return -1;
	                  //   if (keyA > keyB) return 1;
	                  //   return 0;
	                  // });
	                  // var newCourse2Arr1 = newCourse2.filter(el => el.skillRating > 0);
	                  // //console.log("newCourse2...",newCourse2Arr1)
	                  // if (newCourse2Arr1.length > 0) {
	                  //   newCourse2.reverse()
	                  // }
	                }
	                if (newCourse3.length > 0) {
	                  newCourse3.sort(function (a, b) {
	                    var keyA = a.CourseFields[0].CourseScore,
	                        keyB = b.CourseFields[0].CourseScore;
	                    if (parseFloat(keyA) < parseFloat(keyB)) return -1;
	                    if (parseFloat(keyA) > parseFloat(keyB)) return 1;
	                    return 0;
	                  });
	                  newCourse3 = newCourse3.reverse();
	
	                  // var newCourse3Arr = []
	                  // newCourse3.forEach(function (data) {
	                  //   data.Skills.forEach(function (data1) {
	                  //     if (data1.hasOwnProperty("skillRating") && data1.skill == skillCheckedData[2].skillName) {
	                  //       data.skillRating = data1.skillRating
	                  //       newCourse3Arr.push(data)
	                  //     }
	                  //     else {
	                  //       data.skillRating = 0
	                  //       newCourse3Arr.push(data)
	                  //     }
	                  //   });
	                  // });
	                  // newCourse3 = newCourse3Arr
	                  // newCourse3.sort(function (a, b) {
	                  //   var keyA = a.skillRating,
	                  //     keyB = b.skillRating;
	                  //   if (keyA < keyB) return -1;
	                  //   if (keyA > keyB) return 1;
	                  //   return 0;
	                  // });
	                  // var newCourse3Arr1 = newCourse2.filter(el => el.skillRating > 0);
	                  // if (newCourse3Arr1.length > 0) {
	                  //   newCourse3.reverse()
	                  // }
	                }
	                salaryMax = 0;
	                salaryMin = 0;
	                salaryDifference = 0;
	                _context2.next = 25;
	                return _firebase.database.ref("expertise").once('value', function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    if (ChildSnapshot.val().expertise === Expertise) {
	                      //console.log("4.....", ChildSnapshot.val().experienceSalaryDetails)
	                      if (ChildSnapshot.val().hasOwnProperty('experienceSalaryDetails')) {
	                        var salaryData = ChildSnapshot.val().experienceSalaryDetails.filter(function (el) {
	                          return el.experience.includes(experience);
	                        });
	                        //console.log("5.....", newCourse)
	                        salaryMin = salaryData[0].salaryMin;
	                        salaryMax = salaryData[0].salaryMax;
	                        //console.log("salaryMax...",salaryMax)
	                        salaryDifference = parseFloat(salaryMax) - parseFloat(currentSalary);
	                      }
	                    }
	                  });
	                });
	
	              case 25:
	                this.setState({ careerData: this.getUnique(newCourse, 'key'), careerData1: this.getUnique(newCourse1, 'key'), careerData2: this.getUnique(newCourse2, 'key'), careerData3: this.getUnique(newCourse3, 'key'), Expertise: Expertise, progressInfo: progressInfo, currentSalary: currentSalary, salaryMin: salaryMin, salaryMax: salaryMax, salaryDifference: salaryDifference, skillData: skillCheckedData });
	                //Commented 10/10/2022 Starts for new algorithm
	                // budgetConstriction = budgetConstriction.split('-');
	                // let budget1 = parseFloat(budgetConstriction[0])
	                // let budget2 = parseFloat(budgetConstriction[1])
	                // if (Skills.length > 0) {
	                //   Skills = Skills.filter(function (el) {
	                //     return el.skillRating > 0
	                //   }
	                //   );
	                //   console.log("Skills1...", Skills)
	                // }
	                //Commented 10/10/2022 End
	                //careerData.forEach(function (data) {
	                // console.log("data1.....",data)
	                // console.log("Expertise1.....",data.Expertise)
	                // if(data.Expertise.includes(Expertise)){
	                //   newCourse.push(data)
	                // }
	                //Commented 10/10/2022 Starts
	                // if (data.price != "" && data.price != "Free") {
	                //   let price = data.price
	                //   price = price.replace("$", '').replace(" ", '')
	                //   price = parseFloat(price)
	                //   if (data.Modeoflearning.includes(modeOfLearning) && (price > budget1 && price < budget2)) {
	                //     newCourse.push(data)
	                //   }
	                // }
	                // else {
	                //   if (data.Modeoflearning.includes(modeOfLearning)) {
	                //     newCourse.push(data)
	                //   }
	                // }
	                //Commented 10/10/2022 End
	                // let price = data.price
	                // price = price.replace("$", '').replace(" ", '')
	                // price = parseFloat(price)
	
	                // if(price>budget1 && price < budget2) {
	                //   newCourse.push(data)  
	                // } 
	                // if(data.Accrediation.includes(Expertise)){
	                //   newCourse.push(data)  
	                // }
	
	                //});
	
	              case 26:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function getGuidanceDetails(_x, _x2) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return getGuidanceDetails;
	    }()
	  }, {
	    key: "getUnique",
	    value: function getUnique(array, key) {
	      if (typeof key !== 'function') {
	        var property = key;
	        key = function key(item) {
	          return item[property];
	        };
	      }
	      return Array.from(array.reduce(function (map, item) {
	        var k = key(item);
	        if (!map.has(k)) map.set(k, item);
	        return map;
	      }, new Map()).values());
	    }
	  }, {
	    key: "renderList",
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(keyId) {
	        var id, ref, userRef, valueRef, snapshot, val, data;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                id = keyId;
	                ref = id ? '/SecUser/' + id : 'SecUser';
	                userRef = _firebase.database.ref(ref);
	
	                if (!id) {
	                  _context3.next = 7;
	                  break;
	                }
	
	                _context3.t0 = userRef;
	                _context3.next = 10;
	                break;
	
	              case 7:
	                _context3.next = 9;
	                return userRef.orderByChild('key').equalTo('value');
	
	              case 9:
	                _context3.t0 = _context3.sent;
	
	              case 10:
	                valueRef = _context3.t0;
	                _context3.next = 13;
	                return valueRef.once('value');
	
	              case 13:
	                snapshot = _context3.sent;
	                val = snapshot.val();
	
	                if (val) {
	                  data = val;
	                  // localStorage.setItem("userId",data.userDate.userId)
	                  // localStorage.setItem("userFullName",data.userDate.fullName)
	                  // localStorage.setItem("userImage",val.imageUrl)
	
	                  this.setState({
	                    userData: val,
	                    userFullName: data.fullName,
	                    userImage: data.imageUrl
	                  });
	                }
	
	              case 16:
	              case "end":
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function renderList(_x3) {
	        return _ref3.apply(this, arguments);
	      }
	
	      return renderList;
	    }()
	  }, {
	    key: "renderModeOfLearning",
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var dataList;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                dataList = [];
	                _context4.next = 3;
	                return _firebase.database.ref("modeOfLearning").once('value', function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    dataList.push({
	                      key: ChildSnapshot.key,
	                      modeOfLearning: ChildSnapshot.val().modeOfLearning,
	                      modeOfLearningStatus: ChildSnapshot.val().status,
	                      internalId: ChildSnapshot.val().internalId
	                    });
	                  });
	                });
	
	              case 3:
	                this.setState({
	                  modeOfLearningData: dataList
	                });
	
	              case 4:
	              case "end":
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function renderModeOfLearning() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return renderModeOfLearning;
	    }()
	  }, {
	    key: "renderInstitute",
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        var dataList;
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                dataList = [];
	                _context5.next = 3;
	                return _firebase.database.ref("institution").once('value', function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    dataList.push({
	                      key: ChildSnapshot.key,
	                      institution: ChildSnapshot.val().institution,
	                      institutionStatus: ChildSnapshot.val().status,
	                      internalId: ChildSnapshot.val().internalId
	                    });
	                  });
	                });
	
	              case 3:
	                this.setState({
	                  institutionData: dataList
	                });
	
	              case 4:
	              case "end":
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function renderInstitute() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return renderInstitute;
	    }()
	  }, {
	    key: "renderCourse",
	    value: function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	        var dataList, userKey, modeOfLearningData, institutionData;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                dataList = [];
	                userKey = localStorage.getItem("userId");
	                modeOfLearningData = this.state.modeOfLearningData;
	                institutionData = this.state.institutionData;
	                _context6.next = 6;
	                return _firebase.database.ref("Course").once('value', function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    var mode = "";
	                    var modeOfLearning = modeOfLearningData.filter(function (e) {
	                      return e.internalId.toString() === ChildSnapshot.val().Modeoflearning.toString();
	                    });
	                    if (modeOfLearning.length > 0) {
	                      mode = modeOfLearning[0].modeOfLearning;
	                    }
	                    var university = "";
	                    var universityVal = institutionData.filter(function (e) {
	                      return e.internalId.toString() === ChildSnapshot.val().universityName.toString();
	                    });
	                    if (universityVal.length > 0) {
	                      university = universityVal[0].institution;
	                    }
	                    dataList.push({
	                      key: ChildSnapshot.key, CourseName: ChildSnapshot.val().CourseName,
	                      imageUrl: ChildSnapshot.val().imageUrl,
	                      universityName: university,
	                      Courserating: ChildSnapshot.val().Courserating,
	                      Country: ChildSnapshot.val().Country != undefined ? ChildSnapshot.val().Country : "",
	                      Language: ChildSnapshot.val().Language,
	                      Level: ChildSnapshot.val().Level,
	                      Accrediation: ChildSnapshot.val().Accrediation,
	                      CourseFields: ChildSnapshot.val().CourseFields,
	                      outcomes: ChildSnapshot.val().outcomes,
	                      expertise: ChildSnapshot.val().expertise,
	                      Skills: ChildSnapshot.val().skills,
	                      Modeoflearning: mode,
	                      courseDescription: ChildSnapshot.val().courseDescription,
	                      price: ChildSnapshot.val().whatyoudo_rightModel[0].modelData ? ChildSnapshot.val().whatyoudo_rightModel[0].modelData[0].price : "",
	                      duration: ChildSnapshot.val().whatyoudo_rightModel[0].modelData ? ChildSnapshot.val().whatyoudo_rightModel[0].modelData[0].duration : ""
	                    });
	                  });
	                });
	
	              case 6:
	                _context6.next = 8;
	                return Promise.all(this.getGuidanceDetails(userKey, dataList));
	
	              case 8:
	              case "end":
	                return _context6.stop();
	            }
	          }
	        }, _callee6, this);
	      }));
	
	      function renderCourse() {
	        return _ref6.apply(this, arguments);
	      }
	
	      return renderCourse;
	    }()
	  }, {
	    key: "coursePopup",
	    value: function coursePopup(data) {
	      //console.log("data.........", data)
	      var ratingVal = 0;
	      //console.log("this.state.rating...", data.Courserating)
	      if (data.Courserating) {
	        ratingVal = data.Courserating;
	        //console.log("ratingVal1...", ratingVal)
	        ratingVal = ratingVal.split('/')[0];
	        //console.log("ratingVal2...", ratingVal)
	      }
	      this.setState({
	        universityName: data.universityName,
	        CourseName: data.CourseName,
	        imageUrl: data.imageUrl,
	        Language: data.Language,
	        Level: data.Level,
	        Modeoflearning: data.Modeoflearning,
	        courseDescription: data.courseDescription,
	        key: data.key,
	        price: data.price,
	        duration: data.duration,
	        Courserating: parseFloat(ratingVal),
	        ivanooograde: data.CourseFields[0].CourseScore,
	        accrediation: data.Accrediation,
	        outcome: data.outcomes[0]
	      });
	      (0, _jquery2.default)("body").addClass("modal-open");
	      (0, _jquery2.default)("#coursePopup").addClass("show");
	      (0, _jquery2.default)(".modal").show();
	      (0, _jquery2.default)('.modal-backdrop').add();
	      (0, _jquery2.default)('body').append('<div class="modal-backdrop fade show"></div>');
	    }
	  }, {
	    key: "closePopup",
	    value: function closePopup() {
	      (0, _jquery2.default)("body").removeClass("modal-open");
	      (0, _jquery2.default)(".modal").removeClass("show");
	      (0, _jquery2.default)(".modal").hide();
	      (0, _jquery2.default)('.modal-backdrop').remove();
	    }
	  }, {
	    key: "gotoSteps",
	    value: function gotoSteps() {
	      var Guidance = (0, _jquery2.default)("#Guidance").val();
	      window.location.href = "/assesment/personna/id=" + Guidance;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper user-dashboard-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-4 col-lg-3 mt-4" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "usr-dasbrd-menu" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "usr-dasbrd-menuhead" },
	                    "My Account"
	                  ),
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { className: "usr-dasbrd-menuList usr-dasbrd-menuAct", to: "/user-dashboard" },
	                    "Dashoboard"
	                  ),
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { className: "usr-dasbrd-menuList", onClick: function onClick() {
	                        return _this2.gotoSteps();
	                      } },
	                    "Profile"
	                  ),
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { className: "usr-dasbrd-menuList", to: "", onClick: this.logout },
	                    "LogOut"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-8 col-lg-9 mt-4" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "userdash-box-right" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-7 col-lg-8 text-center mb-4" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "header-head-thin" },
	                        _react2.default.createElement(
	                          "h4",
	                          null,
	                          "Welcome, ",
	                          this.state.userName
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "userdash-box-img" },
	                        this.state.userImage ? _react2.default.createElement("img", { alt: "", className: "userdash-img", src: this.state.userImage }) : _react2.default.createElement("img", { alt: "", className: "userdash-img", src: _default2.default })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-5 col-lg-4 text-center mb-4" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "usr-dash-progress" },
	                        _react2.default.createElement(
	                          "p",
	                          null,
	                          _react2.default.createElement("spam", { id: "progressInfo" }),
	                          "% completed"
	                        ),
	                        _react2.default.createElement("input", { type: "hidden", id: "Guidance" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "progress" },
	                          _react2.default.createElement("div", { className: "progress-bar", role: "progressbar", style: { width: this.state.progressInfo + "%" }, "aria-valuenow": "25", "aria-valuemin": "0", "aria-valuemax": "100" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "p",
	                        { className: "progress-info" },
	                        _react2.default.createElement(
	                          "a",
	                          { style: { fontSize: "13px", color: "#0d6efd", cursor: "pointer" },
	                            onClick: function onClick() {
	                              return _this2.gotoSteps();
	                            }
	                          },
	                          "Complete your profile"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-lg-9" },
	                      this.state.currentSalary > 0 ? _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          "div",
	                          { className: "usr-dash-subhead mb-2" },
	                          "Skill Quotient Analysis"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "usr-dash-subhead mb-2" },
	                          "You have a gap of $ ",
	                          parseFloat(this.state.salaryDifference).toFixed(2),
	                          " as per your given salary, $ ",
	                          parseFloat(this.state.currentSalary).toFixed(2),
	                          " in contrast to the average market range of $ ",
	                          parseFloat(this.state.salaryMin).toFixed(2),
	                          " - $ ",
	                          parseFloat(this.state.salaryMax).toFixed(2),
	                          ". You can consider taking up the following courses to bridge that gap."
	                        )
	                      ) : _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          "div",
	                          { className: "usr-dash-subhead mb-2" },
	                          "Skill Quotient Analysis"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "usr-dash-subhead mb-2" },
	                          "Non-applicable (salary range is required to reach an analysis) "
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "p",
	                        { className: "usr-dash-p", style: { color: "red" } },
	                        "Disclaimer: This segment is not applicable to the freshers as they do not have any exposure to working experience yet."
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 mt-5 usr-dash-tab-sec" },
	              _react2.default.createElement(
	                "div",
	                { className: "usr-dash-head" },
	                "Our suggestions"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 related-courses-mainbox" },
	                this.state.careerData.slice(0, 3).map(function (data, i) {
	                  return _react2.default.createElement(
	                    "div",
	                    { className: "related-courses-box", onClick: function onClick() {
	                        return _this2.coursePopup(data);
	                      } },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "related-courses-box-zoom" },
	                      _react2.default.createElement(
	                        "a",
	                        { className: "related-courses-box-a" },
	                        _react2.default.createElement("img", { alt: "", className: "related-courses-img", src: data.imageUrl })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "a",
	                      { className: "related-courses-box-content" },
	                      _react2.default.createElement(
	                        "p",
	                        { className: "m-0", style: { fontSize: "12px" } },
	                        _react2.default.createElement(
	                          "b",
	                          null,
	                          "Institute"
	                        ),
	                        " : ",
	                        data.universityName
	                      ),
	                      _react2.default.createElement(
	                        "p",
	                        { className: "related-courses-box-text", title: data.CourseName },
	                        data.CourseName.substring(0, 100),
	                        " "
	                      ),
	                      _react2.default.createElement(
	                        "p",
	                        { className: "m-0", style: { fontSize: "12px" } },
	                        _react2.default.createElement(
	                          "b",
	                          null,
	                          "ivanooograde"
	                        ),
	                        " : ",
	                        data.CourseFields[0].CourseScore
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "related-courses-box-bottom" },
	                      data.courseDescription
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 related-courses-mainbox" },
	                this.state.careerData1.length > 0 ? _react2.default.createElement(
	                  "div",
	                  { className: "usr-dash-subhead mb-2" },
	                  "Recommendation for Skill : ",
	                  this.state.skillData[0].skillName
	                ) : "",
	                this.state.careerData1.slice(0, 3).map(function (data, i) {
	                  return _react2.default.createElement(
	                    "div",
	                    { className: "related-courses-box", onClick: function onClick() {
	                        return _this2.coursePopup(data);
	                      } },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "related-courses-box-zoom" },
	                      _react2.default.createElement(
	                        "a",
	                        { className: "related-courses-box-a" },
	                        _react2.default.createElement("img", { alt: "", className: "related-courses-img", src: data.imageUrl })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "a",
	                      { className: "related-courses-box-content" },
	                      _react2.default.createElement(
	                        "p",
	                        { className: "m-0", style: { fontSize: "12px" } },
	                        _react2.default.createElement(
	                          "b",
	                          null,
	                          "Institute"
	                        ),
	                        " : ",
	                        data.universityName
	                      ),
	                      _react2.default.createElement(
	                        "p",
	                        { className: "related-courses-box-text", title: data.CourseName },
	                        data.CourseName.substring(0, 100),
	                        " "
	                      ),
	                      _react2.default.createElement(
	                        "p",
	                        { className: "m-0", style: { fontSize: "12px" } },
	                        _react2.default.createElement(
	                          "b",
	                          null,
	                          "ivanooograde"
	                        ),
	                        " : ",
	                        data.CourseFields[0].CourseScore
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "related-courses-box-bottom" },
	                      data.courseDescription
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 related-courses-mainbox" },
	                this.state.careerData2.length > 0 ? _react2.default.createElement(
	                  "div",
	                  { className: "usr-dash-subhead mb-2" },
	                  "Recommendation for Skill : ",
	                  this.state.skillData[1].skillName
	                ) : "",
	                this.state.careerData2.slice(0, 3).map(function (data, i) {
	                  return _react2.default.createElement(
	                    "div",
	                    { className: "related-courses-box", onClick: function onClick() {
	                        return _this2.coursePopup(data);
	                      } },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "related-courses-box-zoom" },
	                      _react2.default.createElement(
	                        "a",
	                        { className: "related-courses-box-a" },
	                        _react2.default.createElement("img", { alt: "", className: "related-courses-img", src: data.imageUrl })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "a",
	                      { className: "related-courses-box-content" },
	                      _react2.default.createElement(
	                        "p",
	                        { className: "m-0", style: { fontSize: "12px" } },
	                        _react2.default.createElement(
	                          "b",
	                          null,
	                          "Institute"
	                        ),
	                        " : ",
	                        data.universityName
	                      ),
	                      _react2.default.createElement(
	                        "p",
	                        { className: "related-courses-box-text", title: data.CourseName },
	                        data.CourseName.substring(0, 100),
	                        " "
	                      ),
	                      _react2.default.createElement(
	                        "p",
	                        { className: "m-0", style: { fontSize: "12px" } },
	                        _react2.default.createElement(
	                          "b",
	                          null,
	                          "ivanooograde"
	                        ),
	                        " : ",
	                        data.CourseFields[0].CourseScore
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "related-courses-box-bottom" },
	                      data.courseDescription
	                    )
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 related-courses-mainbox" },
	                this.state.careerData3.length > 0 ? _react2.default.createElement(
	                  "div",
	                  { className: "usr-dash-subhead mb-2" },
	                  "Recommendation for Skill : ",
	                  this.state.skillData[2].skillName
	                ) : "",
	                this.state.careerData3.slice(0, 3).map(function (data, i) {
	                  return _react2.default.createElement(
	                    "div",
	                    { className: "related-courses-box", onClick: function onClick() {
	                        return _this2.coursePopup(data);
	                      } },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "related-courses-box-zoom" },
	                      _react2.default.createElement(
	                        "a",
	                        { className: "related-courses-box-a" },
	                        _react2.default.createElement("img", { alt: "", className: "related-courses-img", src: data.imageUrl })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "a",
	                      { className: "related-courses-box-content" },
	                      _react2.default.createElement(
	                        "p",
	                        { className: "m-0", style: { fontSize: "12px" } },
	                        _react2.default.createElement(
	                          "b",
	                          null,
	                          "Institute"
	                        ),
	                        " : ",
	                        data.universityName
	                      ),
	                      _react2.default.createElement(
	                        "p",
	                        { className: "related-courses-box-text", title: data.CourseName },
	                        data.CourseName.substring(0, 100),
	                        " "
	                      ),
	                      _react2.default.createElement(
	                        "p",
	                        { className: "m-0", style: { fontSize: "12px" } },
	                        _react2.default.createElement(
	                          "b",
	                          null,
	                          "ivanooograde"
	                        ),
	                        " : ",
	                        data.CourseFields[0].CourseScore
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "p",
	                      { className: "related-courses-box-bottom" },
	                      data.courseDescription
	                    )
	                  );
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "modal fade course-popup-wrapper", id: "coursePopup", tabindex: "-1", role: "dialog", "aria-labelledby": "exampleModalLongTitle", "aria-hidden": "true" },
	          _react2.default.createElement(
	            "div",
	            { className: "modal-dialog", role: "document" },
	            _react2.default.createElement(
	              "div",
	              { className: "modal-content" },
	              _react2.default.createElement(
	                "div",
	                { className: "" },
	                _react2.default.createElement(
	                  "button",
	                  { type: "button", className: "close", "data-dismiss": "modal", "aria-label": "Close", onClick: function onClick() {
	                      return _this2.closePopup();
	                    } },
	                  _react2.default.createElement(
	                    "span",
	                    { "aria-hidden": "true" },
	                    "\xD7"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "modal-body row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "popup-course-left col-md-9" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "popup-course-left-box" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "popup-course-left-top row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "popup-course-left-topImg col-md-3 col-lg-2" },
	                        _react2.default.createElement("img", { alt: "", className: "popup-course-left-img img-fluid", src: this.state.imageUrl })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "popup-course-left-topCont col-md-9 col-lg-10" },
	                        _react2.default.createElement(
	                          "p",
	                          { style: { fontSize: "16px" } },
	                          _react2.default.createElement(
	                            "b",
	                            null,
	                            "Institute"
	                          ),
	                          " : ",
	                          this.state.universityName
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          { className: "popup-course-left-top-head" },
	                          " ",
	                          this.state.CourseName,
	                          " "
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          { className: "popup-course-left-bottom-p" },
	                          _react2.default.createElement(
	                            "b",
	                            null,
	                            "ivanooograde"
	                          ),
	                          " : ",
	                          this.state.ivanooograde
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          { className: "popup-course-left-bottom-p" },
	                          _react2.default.createElement(
	                            "b",
	                            null,
	                            "Course Description"
	                          ),
	                          " : ",
	                          this.state.courseDescription
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "popup-course-left-bottom col-md-122" },
	                      _react2.default.createElement("div", { className: "popup-course-icon" })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "popup-course-right col-md-3" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "popup-course-right-list" },
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "b",
	                        null,
	                        "Accreditation :"
	                      ),
	                      " ",
	                      this.state.accrediation
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "popup-course-right-list" },
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "b",
	                        null,
	                        "Course Fee :"
	                      ),
	                      " ",
	                      this.state.price
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "popup-course-right-list" },
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "b",
	                        null,
	                        "Course Duration :"
	                      ),
	                      " ",
	                      this.state.duration
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "popup-course-right-list" },
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "b",
	                        null,
	                        "Mode of learning :"
	                      ),
	                      " ",
	                      this.state.Modeoflearning
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "popup-course-right-list", style: { display: "none" } },
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "b",
	                        null,
	                        "Course Of Outcome"
	                      ),
	                      " "
	                    ),
	                    this.state.outcome.QuickUpskills == "True" ? _react2.default.createElement(
	                      "div",
	                      null,
	                      "Quick Upskilling"
	                    ) : "",
	                    this.state.outcome.Jobs == "True" ? _react2.default.createElement(
	                      "div",
	                      null,
	                      "Job Assistance"
	                    ) : "",
	                    this.state.outcome.Certificates == "True" ? _react2.default.createElement(
	                      "div",
	                      null,
	                      "Certificates"
	                    ) : ""
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_footer2.default, null)
	      );
	    }
	  }]);
	
	  return Dashboard;
	}(_react.Component);
	
	exports.default = Dashboard;

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _default = __webpack_require__(163);
	
	var _default2 = _interopRequireDefault(_default);
	
	var _reactTabs = __webpack_require__(161);
	
	__webpack_require__(137);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpertsDetails = function (_Component) {
	  _inherits(ExpertsDetails, _Component);
	
	  function ExpertsDetails() {
	    _classCallCheck(this, ExpertsDetails);
	
	    return _possibleConstructorReturn(this, (ExpertsDetails.__proto__ || Object.getPrototypeOf(ExpertsDetails)).apply(this, arguments));
	  }
	
	  _createClass(ExpertsDetails, [{
	    key: "render",
	    value: function render() {
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content" },
	          _react2.default.createElement(
	            "section",
	            { className: "courses-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "py-5" },
	              _react2.default.createElement(
	                "div",
	                { className: "container" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "experts-detail-body col-lg-12" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "experts-detail-box" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "experts-detail-box-img" },
	                        _react2.default.createElement("img", { alt: "", className: "experts-detail-img", src: _default2.default })
	                      ),
	                      _react2.default.createElement(
	                        "p",
	                        { className: "experts-detail-box-text" },
	                        "Anoop"
	                      ),
	                      _react2.default.createElement(
	                        "p",
	                        { className: "experts-detail-box-subtext" },
	                        "AI Consultant|Ph.D. & M.Phil in AI"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 experts-detail-icon" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row justify-content-center align-items-center text-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-md-1" },
	                          _react2.default.createElement(
	                            "svg",
	                            { "class": "svg-icon", "aria-hidden": "true", role: "img", focusable: "false", width: "30", height: "30", viewBox: "0 0 30 30", xmlns: "http://www.w3.org/2000/svg" },
	                            _react2.default.createElement("path", { d: "M26.791 23.5866C25.7884 22.6739 25.0512 21.7007 24.5092 20.7683C24.3178 20.439 24.4139 20.0207 24.7217 19.7962C27.3923 17.8486 29.126 14.6936 29.1199 11.1338C29.1097 5.21907 24.3432 0.461123 18.4285 0.461182C14.396 0.461182 10.8855 2.69408 9.06445 5.99051L20.6419 22.0673C22.6827 23.4597 24.9597 24.0686 26.4226 24.3314C26.8488 24.4081 27.1113 23.8781 26.791 23.5866Z", fill: "#DFEBFA" }),
	                            _react2.default.createElement("path", { d: "M9.51953 6.62305L20.6414 22.0673C21.1802 22.4349 21.7354 22.7474 22.2878 23.0139C23.7299 21.1917 24.5912 18.8887 24.5912 16.3845C24.5912 10.4798 19.8046 5.69317 13.8999 5.69312C12.3374 5.69312 10.8552 6.02539 9.51953 6.62305Z", fill: "#B1DBFC" }),
	                            _react2.default.createElement("path", { d: "M11.5839 5.69312C5.66928 5.69312 0.902727 10.451 0.892594 16.3657C0.886503 19.9255 2.6202 23.0806 5.29074 25.0282C5.59853 25.2526 5.69464 25.6709 5.50323 26.0003C4.96134 26.9326 4.22416 27.9058 3.22149 28.8185C2.90122 29.11 3.16374 29.64 3.59002 29.5634C5.09494 29.293 7.46179 28.6565 9.54644 27.1772C9.7604 27.0253 10.0249 26.9654 10.2854 26.9971C10.7111 27.0489 11.1444 27.0758 11.5839 27.0758C17.4886 27.0758 22.2753 22.2891 22.2753 16.3845C22.2752 10.4798 17.4886 5.69317 11.5839 5.69312Z", fill: "#FEE55A" }),
	                            _react2.default.createElement("path", { d: "M5.53662 28.8185C6.53929 27.9058 7.27647 26.9326 7.81842 26.0002C8.00983 25.6709 7.91372 25.2526 7.60593 25.0281C4.93539 23.0805 3.20163 19.9254 3.20778 16.3657C3.21727 10.8431 7.37352 6.32961 12.7391 5.75538C12.3597 5.71461 11.9744 5.69312 11.5841 5.69312C5.66928 5.69306 0.902727 10.4509 0.892594 16.3657C0.886503 19.9254 2.6202 23.0805 5.29074 25.0281C5.59853 25.2526 5.69464 25.6709 5.50323 26.0002C4.96134 26.9326 4.22416 27.9058 3.22149 28.8185C2.90122 29.11 3.16374 29.6399 3.59002 29.5634C4.10562 29.4707 4.72248 29.3351 5.39441 29.1373C5.393 29.0249 5.43611 28.91 5.53662 28.8185Z", fill: "#FFD301" }),
	                            _react2.default.createElement("path", { d: "M12.0742 27.0642C12.3009 27.054 12.5258 27.0367 12.7486 27.0126C12.6999 27.0073 12.651 27.0029 12.6026 26.9971C12.4222 26.9751 12.2403 26.9982 12.0742 27.0642Z", fill: "#FFD301" }),
	                            _react2.default.createElement("path", { d: "M17.4635 18.2205H5.70498C5.25293 18.2205 4.94292 18.6812 5.11798 19.0981C6.17864 21.6231 8.67376 23.3968 11.5843 23.3968C14.4948 23.3968 16.9899 21.6231 18.0505 19.0981C18.2256 18.6813 17.9157 18.2205 17.4635 18.2205Z", fill: "#DFEBFA" }),
	                            _react2.default.createElement("path", { d: "M7.63261 19.0981C7.45754 18.6812 7.7675 18.2205 8.2196 18.2205H5.70498C5.25293 18.2205 4.94292 18.6812 5.11798 19.0981C6.17864 21.6231 8.67376 23.3968 11.5843 23.3968C12.0136 23.3968 12.4335 23.3573 12.8416 23.2834C10.4838 22.8562 8.53683 21.2507 7.63261 19.0981Z", fill: "#B1DBFC" }),
	                            _react2.default.createElement("path", { d: "M4.70725 19.2575C7.25907 25.3322 15.8946 25.3406 18.4499 19.2575C18.7467 18.551 18.2225 17.7705 17.4578 17.7705H5.69933C4.93293 17.7704 4.41106 18.5523 4.70725 19.2575ZM5.69933 18.649H17.4579C17.5947 18.649 17.694 18.7884 17.6399 18.9172C15.3889 24.276 7.77145 24.2835 5.51729 18.9172C5.46311 18.7882 5.56274 18.649 5.69933 18.649Z", fill: "black" }),
	                            _react2.default.createElement("path", { d: "M6.15005 13.8513C6.15005 12.9804 6.85864 12.2719 7.72953 12.2719C8.60042 12.2719 9.30895 12.9804 9.30895 13.8513C9.30895 14.0939 9.50557 14.2906 9.74823 14.2906C9.99089 14.2906 10.1875 14.0939 10.1875 13.8513C10.1875 12.496 9.08486 11.3933 7.72953 11.3933C6.37414 11.3933 5.27148 12.496 5.27148 13.8513C5.27148 14.0939 5.46811 14.2906 5.71077 14.2906C5.95343 14.2906 6.15005 14.094 6.15005 13.8513Z", fill: "black" }),
	                            _react2.default.createElement("path", { d: "M13.8454 13.8513C13.8454 12.9804 14.554 12.2719 15.4248 12.2719C16.2957 12.2719 17.0043 12.9804 17.0043 13.8513C17.0043 14.0939 17.2009 14.2906 17.4435 14.2906C17.6862 14.2906 17.8828 14.0939 17.8828 13.8513C17.8828 12.496 16.7802 11.3933 15.4248 11.3933C14.0695 11.3933 12.9668 12.496 12.9668 13.8513C12.9668 14.0939 13.1634 14.2906 13.4061 14.2906C13.6487 14.2906 13.8454 14.094 13.8454 13.8513Z", fill: "black" }),
	                            _react2.default.createElement("path", { d: "M13.033 2.41998C13.2393 2.29224 13.3029 2.02152 13.1752 1.81523C13.0475 1.60901 12.7769 1.5454 12.5705 1.67308C10.9996 2.646 9.69006 4.00022 8.77073 5.59651C4.06977 6.80571 0.456302 11.0747 0.447282 16.3541C0.441074 19.9371 2.15158 23.276 5.02583 25.3723C5.15474 25.4663 5.19416 25.6367 5.11737 25.7687C4.53289 26.7744 3.79344 27.6876 2.91973 28.4828C2.27504 29.0697 2.80242 30.1394 3.66159 29.985C5.29021 29.6923 7.67622 29.028 9.79455 27.5247C9.91468 27.4395 10.0679 27.4032 10.2263 27.4224C12.242 27.6676 14.2982 27.3684 16.1886 26.507C16.4094 26.4063 16.5068 26.1458 16.4062 25.9251C16.3056 25.7043 16.0452 25.6069 15.8242 25.7075C14.0715 26.5062 12.1757 26.7745 10.3323 26.5502C9.95638 26.5047 9.58486 26.5962 9.28609 26.8082C7.31196 28.2091 5.07397 28.8359 3.52963 29.1157C4.46179 28.2638 5.25138 27.2865 5.87698 26.2102C6.18061 25.688 6.03723 25.0225 5.54353 24.6624C2.89689 22.7322 1.32028 19.6269 1.32585 16.3556C1.33551 10.7125 5.93461 6.12154 11.578 6.1216C17.2309 6.1216 21.8299 10.7206 21.8299 16.3736C21.8299 19.6792 20.2213 22.8008 17.5267 24.724C17.3293 24.8649 17.2835 25.1393 17.4244 25.3367C17.5653 25.5342 17.8396 25.58 18.0372 25.4391C19.1129 24.6713 20.0285 23.727 20.7571 22.662C22.7355 23.9113 24.863 24.4881 26.3376 24.753C27.1961 24.9072 27.7248 23.8383 27.0795 23.2509C26.2056 22.4555 25.4662 21.5423 24.8818 20.5367C24.805 20.4048 24.8444 20.2343 24.9734 20.1403C27.8405 18.0493 29.5582 14.7156 29.552 11.1221C29.5386 3.29678 21.7272 -2.00476 14.4927 0.726051C14.2657 0.811681 14.1512 1.06518 14.2369 1.29214C14.3226 1.5191 14.5762 1.63367 14.8029 1.54798C21.5092 -0.983281 28.6612 4.00637 28.6733 11.1236C28.679 14.3949 27.1023 17.5002 24.4557 19.4304C23.9619 19.7905 23.8186 20.4559 24.1222 20.9782C24.747 22.0531 25.5355 23.0295 26.4695 23.884C25.0738 23.6311 23.0733 23.0862 21.224 21.9178C22.1817 20.2509 22.7084 18.3426 22.7084 16.3736C22.7084 9.65301 16.7459 4.37982 9.95562 5.35912C10.7627 4.18103 11.8125 3.17584 13.033 2.41998Z", fill: "black" })
	                          ),
	                          _react2.default.createElement(
	                            "span",
	                            { className: "experts-detail-i-span" },
	                            "4"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-md-1" },
	                          _react2.default.createElement(
	                            "svg",
	                            { "class": "svg-icon", "aria-hidden": "true", role: "img", focusable: "false", width: "30", height: "30", viewBox: "0 0 30 30", xmlns: "http://www.w3.org/2000/svg" },
	                            _react2.default.createElement("path", { d: "M29.4738 11.5819C29.2385 10.8577 28.5637 10.3674 27.8022 10.3674L19.2995 10.3673L16.6718 2.28068C16.4365 1.55651 15.7617 1.06616 15.0002 1.06616C14.812 1.06616 14.6292 1.09634 14.457 1.15235L15.0002 14.9993L23.2748 28.8936C23.5117 28.8437 23.7407 28.7455 23.9454 28.5968C24.5614 28.1492 24.8192 27.3559 24.5839 26.6316L21.9565 18.545L28.8353 13.5471C29.4514 13.0995 29.7092 12.3061 29.4738 11.5819Z", fill: "#FFB820" }),
	                            _react2.default.createElement("path", { d: "M27.8013 12.1251L18.0215 12.125L14.4561 1.15234C13.9312 1.32302 13.5048 1.73544 13.3276 2.28074L10.7 10.3673L2.19724 10.3674C1.43574 10.3674 0.760899 10.8577 0.5256 11.5819C0.290301 12.3061 0.54804 13.0995 1.16412 13.5471L8.04293 18.545L5.41556 26.6316C5.1802 27.3558 5.438 28.1492 6.05408 28.5967C6.6701 29.0443 7.50431 29.0443 8.12038 28.5967L14.9993 23.5991L21.8782 28.5968C22.2896 28.8957 22.798 28.9938 23.274 28.8936L19.8894 17.8736L27.8013 12.1251Z", fill: "#FFD06A" }),
	                            _react2.default.createElement("path", { d: "M22.9121 29.3731C22.4594 29.3731 22.0069 29.2328 21.6206 28.9521L15 24.1421L8.37932 28.9521C7.60692 29.5134 6.56887 29.5133 5.79642 28.9521C5.02396 28.3909 4.70318 27.4038 4.99824 26.4957L7.52694 18.7127L5.05695 16.9181C4.86061 16.7754 4.81708 16.5006 4.95975 16.3043C5.10236 16.1078 5.37709 16.0642 5.57354 16.2071L8.30192 18.1894C8.4559 18.3013 8.52035 18.4997 8.46152 18.6807L5.83415 26.7673C5.65715 27.3121 5.84962 27.9044 6.31307 28.2411C6.77652 28.5778 7.39934 28.578 7.86279 28.2411L14.7417 23.2435C14.8957 23.1316 15.1043 23.1316 15.2582 23.2435L22.1372 28.2412C22.6006 28.5779 23.2234 28.5779 23.6869 28.2412C24.1503 27.9044 24.3428 27.3121 24.1658 26.7673L21.5384 18.6807C21.4796 18.4997 21.5441 18.3013 21.698 18.1894L28.5769 13.1915C29.0404 12.8548 29.2328 12.2625 29.0558 11.7177C28.8788 11.1728 28.3749 10.8067 27.802 10.8067L19.2993 10.8066C19.109 10.8066 18.9402 10.684 18.8814 10.5029L16.2538 2.41641C16.0768 1.87158 15.5729 1.50557 15 1.50557C14.4272 1.50557 13.9233 1.87164 13.7463 2.41653L11.1187 10.503C11.0598 10.6841 10.8911 10.8067 10.7007 10.8067L2.19797 10.8068C1.62513 10.8068 1.12125 11.1729 0.944251 11.7177C0.767249 12.2626 0.959661 12.8548 1.42317 13.1916L4.15155 15.174C4.34789 15.3166 4.39142 15.5914 4.24875 15.7877C4.10614 15.984 3.83129 16.0277 3.63496 15.8849L0.906519 13.9026C0.134121 13.3412 -0.186661 12.3541 0.1084 11.4461C0.403462 10.538 1.24318 9.92788 2.19797 9.92788L10.3815 9.92776L12.9104 2.1449C13.2055 1.23681 14.0452 0.626709 15 0.626709C15.9549 0.626709 16.7946 1.23681 17.0896 2.14485L19.6186 9.92776L27.802 9.92788C28.7569 9.92788 29.5966 10.538 29.8916 11.4461C30.1867 12.3541 29.866 13.3413 29.0935 13.9025L22.473 18.7128L25.0017 26.4958C25.2968 27.4038 24.976 28.391 24.2035 28.9523C23.8173 29.2328 23.3646 29.3731 22.9121 29.3731Z", fill: "black" })
	                          ),
	                          _react2.default.createElement(
	                            "span",
	                            { className: "experts-detail-i-span" },
	                            "4"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-md-1" },
	                          _react2.default.createElement(
	                            "svg",
	                            { "aria-hidden": "true", role: "img", focusable: "false", width: "30", height: "30", viewBox: "0 0 30 30", xmlns: "http://www.w3.org/2000/svg" },
	                            _react2.default.createElement("path", { d: "M13.1894 16.9448L10.7189 15.4507L4.08109 26.4266C3.95588 26.6335 4.11385 26.8961 4.35537 26.8825L7.07353 26.7294C7.19746 26.7224 7.31289 26.7923 7.36422 26.9052L8.49086 29.3835C8.59099 29.6037 8.89685 29.6216 9.02201 29.4147L15.6599 18.4388L13.1894 16.9448Z", fill: "#68C4FB" }),
	                            _react2.default.createElement("path", { d: "M16.8104 16.9448L19.2809 15.4507L25.9187 26.4266C26.0439 26.6335 25.886 26.8961 25.6445 26.8825L22.9263 26.7294C22.8024 26.7224 22.6869 26.7923 22.6356 26.9052L21.5089 29.3835C21.4088 29.6037 21.1029 29.6216 20.9778 29.4147L14.3398 18.4388L16.8104 16.9448Z", fill: "#68C4FB" }),
	                            _react2.default.createElement("path", { d: "M25.6432 26.8821L23.8924 26.7841L17.6387 16.443L19.2797 15.4504L25.9173 26.4266C26.0429 26.6332 25.8844 26.8962 25.6432 26.8821Z", fill: "#42A7F9" }),
	                            _react2.default.createElement("path", { d: "M4.35535 26.8821L6.10613 26.7841L12.3598 16.443L10.7188 15.4504L4.08125 26.4266C3.95562 26.6332 4.11412 26.8962 4.35535 26.8821Z", fill: "#42A7F9" }),
	                            _react2.default.createElement("path", { d: "M24.9679 10.4076C24.9679 11.2684 24.1624 12.0119 23.9502 12.8059C23.7306 13.6275 24.05 14.6729 23.6339 15.3922C23.2117 16.1218 22.1426 16.3654 21.5505 16.9575C20.9583 17.5497 20.7148 18.6187 19.9852 19.0409C19.2659 19.457 18.2204 19.1376 17.3989 19.3572C16.6049 19.5694 15.8614 20.3749 15.0005 20.3749C14.1397 20.3749 13.3962 19.5694 12.6022 19.3572C11.7806 19.1376 10.7352 19.457 10.0159 19.0408C9.28629 18.6187 9.04266 17.5496 8.45057 16.9575C7.85842 16.3653 6.78937 16.1217 6.36721 15.3921C5.95107 14.6728 6.27047 13.6274 6.05092 12.8059C5.83869 12.0119 5.0332 11.2684 5.0332 10.4075C5.0332 9.54665 5.83869 8.80315 6.05092 8.00915C6.27047 7.18761 5.95113 6.14218 6.36727 5.42288C6.78937 4.69327 7.85848 4.44964 8.45063 3.85755C9.04277 3.2654 9.28635 2.19636 10.016 1.77419C10.7353 1.35806 11.7807 1.67745 12.6022 1.4579C13.3962 1.24567 14.1397 0.440186 15.0005 0.440186C15.8614 0.440186 16.6049 1.24567 17.3989 1.4579C18.2204 1.67745 19.2659 1.35812 19.9852 1.77425C20.7148 2.19636 20.9584 3.26546 21.5505 3.85761C22.1426 4.44976 23.2117 4.69333 23.6339 5.42294C24.05 6.14224 23.7306 7.18767 23.9501 8.00915C24.1624 8.80315 24.9679 9.54665 24.9679 10.4076Z", fill: "#F45151" }),
	                            _react2.default.createElement("path", { d: "M23.95 12.806C23.7305 13.6277 24.0498 14.673 23.6337 15.3926C23.2117 16.1221 22.1429 16.3657 21.5506 16.9579C20.9584 17.5496 20.7149 18.6189 19.9853 19.0409C19.2657 19.4571 18.2204 19.1378 17.3987 19.3573C16.6052 19.5697 15.8615 20.375 15.0005 20.375C14.3537 20.375 13.7727 19.9201 13.1875 19.6044C13.9088 19.3913 14.5668 18.7797 15.2611 18.5943C16.1362 18.3601 17.2502 18.7005 18.0162 18.2568C18.7938 17.8072 19.0533 16.6685 19.6842 16.0376C20.3146 15.4067 21.4538 15.1472 21.9034 14.3701C22.3465 13.6036 22.0067 12.4902 22.2403 11.6151C22.4663 10.7694 23.3243 9.97701 23.3243 9.0602C23.3243 8.14285 22.4662 7.35107 22.2403 6.50527C22.0548 5.81035 22.2309 4.9652 22.0895 4.26318C22.6547 4.60947 23.3215 4.88299 23.6337 5.42293C24.0498 6.14252 23.7306 7.18783 23.9501 8.00955C24.1625 8.80309 24.9678 9.5467 24.9678 10.4077C24.9678 11.2688 24.1625 12.0119 23.95 12.806Z", fill: "#F42F2F" }),
	                            _react2.default.createElement("path", { d: "M26.2958 26.1987L21.3494 18.0196C21.5127 17.7299 21.6707 17.4596 21.8615 17.2688C22.0677 17.0626 22.3664 16.8947 22.6824 16.7171C23.1874 16.4333 23.7097 16.1396 24.0146 15.6126C24.315 15.0934 24.3096 14.4983 24.3043 13.9228C24.301 13.5558 24.2978 13.2091 24.3752 12.9196C24.4477 12.6481 24.6191 12.3595 24.8005 12.054C25.0852 11.5746 25.4079 11.0312 25.4079 10.4076C25.4079 9.78393 25.0852 9.24047 24.8005 8.76111C24.6191 8.45561 24.4478 8.16703 24.3753 7.89557C24.2979 7.60594 24.301 7.25936 24.3044 6.89232C24.3096 6.31682 24.3151 5.72174 24.0147 5.20254C23.7098 4.67549 23.1875 4.38193 22.6825 4.09805C22.3664 3.92039 22.0678 3.75252 21.8616 3.54633C21.6554 3.34008 21.4875 3.04148 21.3099 2.72537C21.026 2.22035 20.7325 1.69811 20.2054 1.39324C19.6862 1.09277 19.0912 1.09811 18.5156 1.10355C18.1487 1.10678 17.8019 1.11006 17.5124 1.03266C17.2409 0.960117 16.9524 0.788731 16.6469 0.607383C16.1674 0.322676 15.624 0 15.0003 0C14.3767 0 13.8333 0.322676 13.3538 0.607383C13.0483 0.788789 12.7598 0.960117 12.4883 1.03271C12.1987 1.11012 11.852 1.10701 11.485 1.10361C10.9094 1.0984 10.3145 1.09295 9.79526 1.3933C9.26827 1.69822 8.97472 2.22041 8.69083 2.72543C8.51311 3.04154 8.3453 3.3402 8.13905 3.54639C7.93286 3.75258 7.63421 3.92045 7.31815 4.09811C6.81313 4.38193 6.29089 4.67555 5.98597 5.2026C5.68556 5.7218 5.69095 6.31687 5.69628 6.89244C5.69962 7.25941 5.70278 7.60605 5.62538 7.89563C5.55284 8.16709 5.38146 8.45566 5.20005 8.76117C4.9154 9.24059 4.59267 9.78398 4.59267 10.4077C4.59267 11.0313 4.91534 11.5747 5.20005 12.0541C5.3814 12.3596 5.55278 12.6482 5.62532 12.9196C5.70272 13.2093 5.69956 13.5558 5.69622 13.9229C5.69095 14.4984 5.6855 15.0935 5.98591 15.6127C6.29083 16.1397 6.81308 16.4333 7.3181 16.7171C7.63421 16.8948 7.9328 17.0627 8.13899 17.2689C8.32983 17.4598 8.48786 17.7299 8.65122 18.0197L3.70491 26.1987C3.56224 26.4346 3.56189 26.7278 3.70398 26.9641C3.84606 27.2003 4.10569 27.3369 4.38062 27.3219L7.00351 27.1741L8.09071 29.5656C8.20474 29.8166 8.44655 29.9825 8.72183 29.9987C8.73647 29.9995 8.75118 29.9999 8.76577 29.9999C9.0244 29.9999 9.26423 29.8657 9.39923 29.6425L14.7484 20.7974C14.8309 20.8086 14.9149 20.8153 15.0004 20.8153C15.0859 20.8153 15.1698 20.8087 15.2523 20.7974L18.0296 25.3896C18.1554 25.5976 18.4259 25.6643 18.634 25.5384C18.842 25.4126 18.9087 25.1421 18.7828 24.934L16.1078 20.5107C16.2961 20.4158 16.4757 20.3095 16.6469 20.2078C16.9524 20.0264 17.2409 19.8551 17.5124 19.7825C17.802 19.7051 18.1487 19.7083 18.5157 19.7116C19.091 19.7167 19.6862 19.7222 20.2054 19.4219C20.4585 19.2755 20.6574 19.0787 20.8276 18.858L25.4057 26.428L22.9516 26.2897C22.6445 26.2724 22.3629 26.4425 22.2354 26.7229L21.2181 28.9605L20.3887 27.589C20.2629 27.3811 19.9923 27.3144 19.7842 27.4402C19.5762 27.566 19.5095 27.8366 19.6354 28.0447L20.6016 29.6424C20.7366 29.8657 20.9764 29.9999 21.235 29.9999C21.2496 29.9999 21.2643 29.9995 21.279 29.9987C21.5542 29.9825 21.7961 29.8165 21.9101 29.5656L22.9973 27.1741L25.6202 27.3219C25.8955 27.3369 26.1546 27.2002 26.2968 26.964C26.4389 26.7279 26.4385 26.4346 26.2958 26.1987ZM8.78265 28.9606L7.7654 26.7229C7.64382 26.4555 7.38267 26.2885 7.09204 26.2885C7.07786 26.2885 7.06356 26.2889 7.04927 26.2897L4.59513 26.428L9.17317 18.858C9.34333 19.0787 9.54226 19.2755 9.79532 19.4218C10.3146 19.7223 10.9097 19.7169 11.4852 19.7115C11.8521 19.7082 12.1988 19.705 12.4884 19.7824C12.7599 19.855 13.0484 20.0263 13.3539 20.2077C13.5251 20.3094 13.7047 20.4157 13.893 20.5106L8.78265 28.9606ZM19.7645 18.6599C19.4536 18.8398 19.0018 18.8355 18.5237 18.8313C18.1139 18.8274 17.6904 18.8237 17.2851 18.932C16.8961 19.0359 16.5409 19.2469 16.1974 19.4508C15.7783 19.6997 15.3824 19.9348 15.0003 19.9348C14.6183 19.9348 14.2225 19.6997 13.8033 19.4508C13.4597 19.2469 13.1046 19.036 12.7156 18.932C12.3848 18.8436 12.0418 18.8299 11.7041 18.8299C11.6281 18.8299 11.5523 18.8306 11.4769 18.8313C10.9986 18.8356 10.5469 18.8398 10.236 18.6599C9.91749 18.4756 9.69431 18.0786 9.45817 17.6583C9.25913 17.3043 9.05335 16.9381 8.76149 16.6462C8.4697 16.3545 8.10355 16.1486 7.74946 15.9496C7.32917 15.7134 6.9322 15.4903 6.74792 15.1717C6.5681 14.8608 6.5722 14.4091 6.57659 13.9309C6.58028 13.5212 6.58421 13.0976 6.47587 12.6923C6.37192 12.3033 6.16099 11.9481 5.95702 11.6046C5.70817 11.1855 5.47304 10.7896 5.47304 10.4075C5.47304 10.0255 5.70812 9.62971 5.95702 9.21047C6.16099 8.86693 6.37187 8.5118 6.47587 8.12279C6.58421 7.7175 6.58028 7.29387 6.57659 6.88418C6.5722 6.40594 6.5681 5.95418 6.74798 5.64328C6.93226 5.32477 7.32929 5.10158 7.74952 4.86539C8.1036 4.66635 8.46976 4.46057 8.76155 4.16877C9.05335 3.87697 9.25919 3.51082 9.45823 3.15668C9.69448 2.73639 9.91755 2.33941 10.2361 2.1552C10.547 1.97531 10.9988 1.97947 11.4769 1.98381C11.8865 1.98744 12.3102 1.99143 12.7155 1.88309C13.1045 1.77914 13.4597 1.5682 13.8032 1.36424C14.2224 1.11545 14.6184 0.880371 15.0003 0.880371C15.3822 0.880371 15.7782 1.11545 16.1974 1.36436C16.5409 1.56832 16.8961 1.7792 17.2851 1.8832C17.6903 1.99154 18.1138 1.98756 18.5237 1.98393C19.0019 1.9793 19.4537 1.97543 19.7646 2.15531C20.0832 2.33959 20.3063 2.73656 20.5425 3.1568C20.7415 3.51088 20.9473 3.87709 21.2391 4.16889C21.5309 4.46068 21.8971 4.66652 22.2512 4.86557C22.6715 5.10182 23.0684 5.32488 23.2527 5.6434C23.4325 5.9543 23.4284 6.406 23.4241 6.88424C23.4204 7.29393 23.4164 7.71756 23.5248 8.12285C23.6287 8.51186 23.8397 8.86699 24.0436 9.21053C24.2925 9.62971 24.5276 10.0256 24.5276 10.4076C24.5276 10.7895 24.2925 11.1854 24.0436 11.6046C23.8397 11.9481 23.6288 12.3033 23.5248 12.6923C23.4164 13.0976 23.4204 13.5212 23.4241 13.9309C23.4284 14.4091 23.4325 14.8609 23.2527 15.1718C23.0684 15.4903 22.6714 15.7135 22.2511 15.9497C21.897 16.1487 21.5309 16.3545 21.2391 16.6463C20.9473 16.9381 20.7415 17.3043 20.5424 17.6584C20.3062 18.0786 20.083 18.4756 19.7645 18.6599Z", fill: "black" }),
	                            _react2.default.createElement("path", { d: "M15.001 16.3458C18.2808 16.3458 20.9396 13.687 20.9396 10.4073C20.9396 7.12752 18.2808 4.46875 15.001 4.46875C11.7213 4.46875 9.0625 7.12752 9.0625 10.4073C9.0625 13.687 11.7213 16.3458 15.001 16.3458Z", fill: "#F5CA26" }),
	                            _react2.default.createElement("path", { d: "M20.9377 10.4079C20.9377 13.6876 18.279 16.3461 14.9983 16.3461C12.4749 16.3461 10.3196 14.7723 9.45898 12.5522C10.4504 13.2962 11.6824 13.737 13.0189 13.737C16.2986 13.737 18.9571 11.0772 18.9571 7.79762C18.9571 7.04146 18.8154 6.31824 18.5582 5.65332C20.0035 6.73695 20.9377 8.46365 20.9377 10.4079Z", fill: "#EAAF13" }),
	                            _react2.default.createElement("path", { d: "M15.0003 16.7864C13.4777 16.7864 12.0034 16.2411 10.8492 15.251C9.70757 14.2717 8.94608 12.9192 8.70503 11.4424C8.66589 11.2025 8.8286 10.9763 9.06855 10.9371C9.30831 10.8976 9.53466 11.0606 9.57392 11.3005C9.78157 12.5727 10.4381 13.7383 11.4223 14.5827C12.4171 15.436 13.6877 15.9059 15.0003 15.9059C18.0322 15.9059 20.4988 13.4393 20.4988 10.4074C20.4988 7.37544 18.0322 4.90894 15.0003 4.90894C13.8721 4.90894 12.7881 5.24796 11.8655 5.88939C10.9634 6.51663 10.2759 7.38669 9.87749 8.40558C9.7889 8.63204 9.5336 8.74384 9.30726 8.65519C9.08079 8.56659 8.96905 8.3113 9.05765 8.08495C9.51989 6.90294 10.3171 5.89378 11.363 5.16657C12.4339 4.42208 13.6917 4.02856 15.0004 4.02856C18.5177 4.02856 21.3793 6.89017 21.3793 10.4075C21.3793 13.9248 18.5177 16.7864 15.0003 16.7864Z", fill: "black" })
	                          ),
	                          _react2.default.createElement(
	                            "span",
	                            { className: "experts-detail-i-span" },
	                            "4"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-md-2" },
	                          _react2.default.createElement(
	                            "svg",
	                            { "aria-hidden": "true", role: "img", focusable: "false", width: "30", height: "30", viewBox: "0 0 30 30", xmlns: "http://www.w3.org/2000/svg" },
	                            _react2.default.createElement("path", { d: "M23.8101 29.5605H6.18945C5.21861 29.5605 4.43164 28.7736 4.43164 27.8027V2.19727C4.43164 1.22643 5.21861 0.439453 6.18945 0.439453H23.8101C24.781 0.439453 25.5679 1.22643 25.5679 2.19727V27.8027C25.5679 28.7736 24.781 29.5605 23.8101 29.5605Z", fill: "#F9F7F8" }),
	                            _react2.default.createElement("path", { d: "M23.8105 0.439453H22.0527C23.0235 0.439453 23.8105 1.22643 23.8105 2.19727V27.8027C23.8105 28.7736 23.0235 29.5605 22.0527 29.5605H23.8105C24.7813 29.5605 25.5684 28.7736 25.5684 27.8027V2.19727C25.5684 1.22643 24.7814 0.439453 23.8105 0.439453Z", fill: "#E5E1E5" }),
	                            _react2.default.createElement("path", { d: "M20.8871 8.08541C20.8871 11.3374 18.2509 13.973 14.9989 13.973C13.0137 13.973 11.2577 12.9904 10.1911 11.4848C9.51076 10.5247 9.11133 9.35203 9.11133 8.08541C9.11133 7.67332 9.15387 7.27125 9.23414 6.8833C9.78902 4.20773 12.1591 2.19727 14.9989 2.19727C18.2509 2.19727 20.8871 4.83346 20.8871 8.08541Z", fill: "#D7D0D6" }),
	                            _react2.default.createElement("path", { d: "M11.6348 12.9172C12.5886 13.5826 13.7483 13.9731 14.9994 13.9731C16.2507 13.9731 17.4106 13.5825 18.3645 12.9171C18.3076 11.1071 16.8235 9.65698 14.9996 9.65698C13.1758 9.65692 11.6915 11.1071 11.6348 12.9172Z", fill: "#FD8087" }),
	                            _react2.default.createElement("path", { d: "M15.4398 10.9476C16.0271 10.9476 16.5485 10.6658 16.8764 10.2301C16.3399 9.86856 15.6939 9.65698 14.998 9.65698C14.5746 9.65698 14.1701 9.73597 13.7969 9.87864C14.0764 10.5082 14.7065 10.9476 15.4398 10.9476Z", fill: "#FE646F" }),
	                            _react2.default.createElement("path", { d: "M14.9982 10.124C14.0057 10.124 13.2012 9.31942 13.2012 8.32696V6.13433C13.2012 5.55249 13.6729 5.08081 14.2547 5.08081H15.7419C16.3237 5.08081 16.7954 5.55249 16.7954 6.13433V8.32696C16.7953 9.31948 15.9908 10.124 14.9982 10.124Z", fill: "#FFCEBF" }),
	                            _react2.default.createElement("path", { d: "M15.7418 5.08081H14.2547C13.6729 5.08081 13.2012 5.55249 13.2012 6.13433V7.47478L14.7241 6.97304C15.2856 6.78806 15.9012 6.87296 16.3917 7.20308L16.7954 7.47472V6.13427C16.7953 5.55249 16.3236 5.08081 15.7418 5.08081Z", fill: "#C59191" }),
	                            _react2.default.createElement("path", { d: "M15.1586 16.9027L15.5756 17.7475C15.6012 17.7993 15.6507 17.8353 15.7079 17.8436L16.6402 17.9791C16.7844 18.0001 16.842 18.1772 16.7377 18.2789L16.063 18.9365C16.0216 18.9769 16.0027 19.0351 16.0124 19.0921L16.1717 20.0206C16.1963 20.1642 16.0456 20.2738 15.9166 20.206L15.0827 19.7676C15.0315 19.7407 14.9704 19.7407 14.9191 19.7676L14.0852 20.206C13.9563 20.2738 13.8056 20.1642 13.8302 20.0206L13.9894 19.0921C13.9992 19.0351 13.9803 18.9769 13.9389 18.9365L13.2642 18.2789C13.1599 18.1772 13.2175 18 13.3617 17.9791L14.2939 17.8436C14.3512 17.8353 14.4007 17.7993 14.4263 17.7475L14.8433 16.9027C14.9078 16.772 15.0942 16.772 15.1586 16.9027Z", fill: "#FEE45A" }),
	                            _react2.default.createElement("path", { d: "M20.4965 16.9027L20.9135 17.7475C20.9391 17.7993 20.9886 17.8353 21.0458 17.8436L21.9781 17.9791C22.1223 18.0001 22.1799 18.1772 22.0756 18.2789L21.4009 18.9365C21.3595 18.9769 21.3406 19.0351 21.3503 19.0921L21.5096 20.0206C21.5342 20.1642 21.3835 20.2738 21.2545 20.206L20.4206 19.7676C20.3694 19.7407 20.3083 19.7407 20.257 19.7676L19.4231 20.206C19.2942 20.2738 19.1435 20.1642 19.1681 20.0206L19.3273 19.0921C19.3371 19.0351 19.3182 18.9769 19.2768 18.9365L18.6021 18.2789C18.4978 18.1772 18.5554 18 18.6996 17.9791L19.6318 17.8436C19.6891 17.8353 19.7386 17.7993 19.7642 17.7475L20.1812 16.9027C20.2458 16.772 20.4321 16.772 20.4965 16.9027Z", fill: "#FEE45A" }),
	                            _react2.default.createElement("path", { d: "M9.82073 16.9027L10.2377 17.7475C10.2633 17.7993 10.3128 17.8353 10.37 17.8436L11.3023 17.9791C11.4465 18.0001 11.5041 18.1772 11.3998 18.2789L10.7251 18.9365C10.6837 18.9769 10.6648 19.0351 10.6746 19.0921L10.8338 20.0206C10.8584 20.1642 10.7077 20.2738 10.5788 20.206L9.74485 19.7676C9.69364 19.7407 9.63247 19.7407 9.58126 19.7676L8.74735 20.206C8.61838 20.2738 8.46768 20.1642 8.49229 20.0206L8.65155 19.0921C8.66133 19.0351 8.64241 18.9769 8.60098 18.9365L7.92633 18.2789C7.82198 18.1772 7.87958 18 8.02377 17.9791L8.95606 17.8436C9.01331 17.8353 9.06282 17.7993 9.08842 17.7475L9.50538 16.9027C9.56995 16.772 9.75622 16.772 9.82073 16.9027Z", fill: "#FEE45A" }),
	                            _react2.default.createElement("path", { d: "M22.9312 25.9863H9.82707C9.58432 25.9863 9.38762 26.183 9.38762 26.4258C9.38762 26.6685 9.58432 26.8652 9.82707 26.8652H22.9313C23.174 26.8652 23.3707 26.6685 23.3707 26.4258C23.3707 26.183 23.174 25.9863 22.9312 25.9863ZM17.1989 17.963C17.126 17.7386 16.9357 17.5782 16.7022 17.5443L15.9071 17.4287L15.5515 16.7082C15.4471 16.4967 15.2357 16.3652 14.9998 16.3652C14.7639 16.3652 14.5524 16.4967 14.4481 16.7082L14.0925 17.4287L13.2974 17.5443C13.0639 17.5782 12.8737 17.7387 12.8007 17.9631C12.7278 18.1875 12.7875 18.4291 12.9564 18.5937L13.5317 19.1545L13.3959 19.9465C13.3561 20.179 13.4499 20.4096 13.6408 20.5483C13.7486 20.6266 13.8748 20.6664 14.0018 20.6664C14.0995 20.6664 14.1978 20.6428 14.2886 20.5951L14.9998 20.2211L15.7109 20.5949C15.9197 20.7047 16.168 20.6867 16.3588 20.5482C16.5497 20.4095 16.6435 20.1789 16.6037 19.9464L16.4679 19.1544L17.0431 18.5937C17.212 18.4291 17.2718 18.1874 17.1989 17.963ZM15.755 18.6219C15.61 18.7633 15.5439 18.9669 15.5781 19.1664L15.6471 19.5684L15.2863 19.3787C15.107 19.2844 14.8928 19.2843 14.7135 19.3786L14.3526 19.5684L14.4215 19.1665C14.4557 18.9669 14.3896 18.7633 14.2446 18.6218L13.9525 18.3371L14.356 18.2786C14.5563 18.2495 14.7295 18.1237 14.8194 17.942L14.9998 17.5763L15.1805 17.9423C15.2702 18.1238 15.4433 18.2495 15.6435 18.2785L16.0471 18.3371L15.755 18.6219ZM23.8101 0H6.18945C4.97785 0 3.99219 0.985664 3.99219 2.19727V21.1436C3.99219 21.3863 4.18889 21.583 4.43164 21.583C4.67439 21.583 4.87109 21.3863 4.87109 21.1436V2.19727C4.87109 1.47029 5.46254 0.878906 6.18945 0.878906H23.8102C24.5371 0.878906 25.1285 1.47029 25.1285 2.19727V27.8027C25.1285 28.5296 24.5371 29.1211 23.8102 29.1211H6.18945C5.46254 29.1211 4.87109 28.5296 4.87109 27.8027V22.8312C4.87109 22.5884 4.67439 22.3917 4.43164 22.3917C4.18889 22.3917 3.99219 22.5884 3.99219 22.8312V27.8027C3.99219 29.0143 4.97785 30 6.18945 30H23.8102C25.0218 30 26.0074 29.0143 26.0074 27.8027V2.19727C26.0074 0.985664 25.0217 0 23.8101 0ZM22.9312 23.3496H9.82707C9.58432 23.3496 9.38762 23.5463 9.38762 23.7891C9.38762 24.0318 9.58432 24.2285 9.82707 24.2285H22.9313C23.174 24.2285 23.3707 24.0318 23.3707 23.7891C23.3707 23.5463 23.174 23.3496 22.9312 23.3496ZM7.50781 26.8652C7.75051 26.8652 7.94726 26.6685 7.94726 26.4258C7.94726 26.1831 7.75051 25.9863 7.50781 25.9863C7.26512 25.9863 7.06836 26.1831 7.06836 26.4258C7.06836 26.6685 7.26512 26.8652 7.50781 26.8652ZM7.46305 17.9629C7.39016 18.1873 7.44975 18.429 7.61867 18.5937L8.19406 19.1545L8.05818 19.9465C8.01834 20.179 8.11215 20.4095 8.30305 20.5482C8.49389 20.6868 8.74221 20.7047 8.95098 20.595L9.66219 20.2211L10.3733 20.595C10.4642 20.6427 10.5625 20.6664 10.6602 20.6663C10.7872 20.6663 10.9135 20.6265 11.0213 20.5481C11.2122 20.4094 11.3059 20.1788 11.266 19.9464L11.1302 19.1545L11.7056 18.5937C11.8745 18.429 11.9341 18.1873 11.8612 17.9629C11.7883 17.7386 11.598 17.5781 11.3646 17.5442L10.5694 17.4286L10.2138 16.7082C10.1095 16.4966 9.89803 16.3652 9.66213 16.3652C9.66213 16.3652 9.66207 16.3652 9.66201 16.3652C9.42611 16.3652 9.21471 16.4967 9.11047 16.7082L8.75492 17.4287L7.9598 17.5443C7.72625 17.5781 7.53594 17.7386 7.46305 17.9629ZM9.01818 18.2786C9.21875 18.2495 9.39195 18.1236 9.4816 17.942L9.66207 17.5763L9.8426 17.9419C9.93225 18.1237 10.1054 18.2495 10.3058 18.2785L10.7094 18.3371L10.4173 18.6219C10.2723 18.7633 10.2062 18.9669 10.2404 19.1664L10.3094 19.5684L9.94859 19.3787C9.76912 19.2843 9.55502 19.2843 9.37584 19.3786L9.01484 19.5684L9.08381 19.1665C9.11809 18.9669 9.05193 18.7633 8.90686 18.6218L8.61482 18.3371L9.01818 18.2786ZM22.0399 17.5443L21.2447 17.4287L20.8892 16.7082C20.7848 16.4967 20.5735 16.3652 20.3376 16.3652C20.3376 16.3652 20.3376 16.3652 20.3375 16.3652C20.1016 16.3652 19.8901 16.4966 19.7858 16.7082L19.4302 17.4287L18.6351 17.5443C18.4017 17.5781 18.2114 17.7386 18.1384 17.963C18.0655 18.1874 18.1251 18.429 18.294 18.5937L18.8694 19.1545L18.7337 19.9464C18.6937 20.1789 18.7875 20.4094 18.9783 20.5482C19.0862 20.6266 19.2124 20.6664 19.3394 20.6664C19.4372 20.6664 19.5355 20.6428 19.6263 20.5951L20.3375 20.2212L21.0487 20.5951C21.2574 20.7047 21.5058 20.6869 21.6966 20.5482C21.8875 20.4096 21.9812 20.179 21.9414 19.9464L21.8056 19.1545L22.381 18.5937C22.5499 18.429 22.6095 18.1873 22.5366 17.963C22.4637 17.7386 22.2733 17.5781 22.0399 17.5443ZM21.0927 18.6219C20.9476 18.7633 20.8815 18.9669 20.9158 19.1664L20.9847 19.5684L20.6239 19.3787C20.5342 19.3315 20.4358 19.3079 20.3374 19.3079C20.239 19.3079 20.1407 19.3314 20.0511 19.3786L19.6902 19.5684L19.7591 19.1665C19.7933 18.9669 19.7272 18.7633 19.5821 18.6218L19.2901 18.3371L19.6935 18.2786C19.8941 18.2495 20.0673 18.1236 20.1569 17.942L20.3374 17.5763L20.5179 17.9419C20.6076 18.1237 20.7808 18.2495 20.9811 18.2785L21.3847 18.3371L21.0927 18.6219ZM7.06836 23.7891C7.06836 24.0318 7.26512 24.2285 7.50781 24.2285C7.75051 24.2285 7.94726 24.0318 7.94726 23.7891C7.94726 23.5464 7.75051 23.3496 7.50781 23.3496C7.26512 23.3496 7.06836 23.5464 7.06836 23.7891ZM14.9996 1.75781C11.5118 1.75781 8.67248 4.61725 8.67248 8.08541C8.67248 11.4894 11.5335 14.4125 14.9996 14.4125C18.4886 14.4125 21.3271 11.5741 21.3271 8.08541C21.3271 4.59639 18.4886 1.75781 14.9996 1.75781ZM14.9996 13.5336C13.958 13.5336 12.9519 13.2335 12.092 12.6911C12.168 12.02 12.4711 11.3994 12.9611 10.9236C13.2421 10.6506 13.5774 10.4361 13.9389 10.2954C14.2548 10.4663 14.6162 10.5635 14.9998 10.5635C15.3833 10.5635 15.7446 10.4664 16.0604 10.2955C16.6551 10.5265 17.1609 10.9472 17.4977 11.4968C17.5806 11.6321 17.7249 11.7067 17.8728 11.7067C17.951 11.7067 18.0303 11.6858 18.102 11.6419C18.3089 11.5151 18.3738 11.2446 18.2471 11.0377C17.8896 10.4542 17.3853 9.98221 16.7908 9.66504C17.0705 9.29162 17.2363 8.82832 17.2363 8.32699V6.13436C17.2363 5.31111 16.5666 4.64139 15.7434 4.64139H14.2562C13.433 4.64139 12.7633 5.31111 12.7633 6.13436V8.32699C12.7633 8.82873 12.9294 9.29238 13.2095 9.66592C12.8961 9.8335 12.6048 10.0444 12.3488 10.2932C11.8351 10.792 11.48 11.4135 11.3095 12.0929C10.193 11.0679 9.55145 9.60662 9.55145 8.08559C9.55145 7.71152 9.58965 7.33705 9.66506 6.97271C10.186 4.46021 12.4296 2.63672 14.9996 2.63672C18.0039 2.63672 20.4482 5.08102 20.4482 8.08541C20.4482 11.0896 18.0039 13.5336 14.9996 13.5336ZM14.8631 7.39043C15.2989 7.24687 15.7672 7.31145 16.1479 7.56762L16.3574 7.70865V8.32687C16.3574 9.07547 15.7484 9.68449 14.9998 9.68449C14.2512 9.68449 13.6422 9.07547 13.6422 8.32687V7.79262L14.8631 7.39043ZM13.6422 6.8673V6.1343C13.6422 5.79568 13.9176 5.52023 14.2562 5.52023H15.7433C16.0819 5.52023 16.3573 5.79568 16.3573 6.1343V6.67676C15.8086 6.40711 15.1796 6.36076 14.588 6.55564L13.6422 6.8673Z", fill: "black" })
	                          ),
	                          _react2.default.createElement(
	                            "span",
	                            { className: "experts-detail-i-span" },
	                            "Masters"
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "container px-0 pt-5 mt-0 mt-md-5" },
	                      _react2.default.createElement(
	                        _reactTabs.Tabs,
	                        { className: "react-tabs-main" },
	                        _react2.default.createElement(
	                          _reactTabs.TabList,
	                          null,
	                          _react2.default.createElement(
	                            _reactTabs.Tab,
	                            null,
	                            "Overview "
	                          ),
	                          _react2.default.createElement(
	                            _reactTabs.Tab,
	                            null,
	                            "Courses"
	                          ),
	                          _react2.default.createElement(
	                            _reactTabs.Tab,
	                            null,
	                            "Reviews"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactTabs.TabPanel,
	                          null,
	                          _react2.default.createElement(
	                            "div",
	                            { className: "form-head" },
	                            " Overview"
	                          ),
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "Overview"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactTabs.TabPanel,
	                          null,
	                          _react2.default.createElement(
	                            "div",
	                            { className: "form-head" },
	                            " Courses"
	                          ),
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "Courses"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactTabs.TabPanel,
	                          null,
	                          _react2.default.createElement(
	                            "div",
	                            { className: "form-head" },
	                            " Reviews"
	                          ),
	                          _react2.default.createElement(
	                            "p",
	                            null,
	                            "Reviews"
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ExpertsDetails;
	}(_react.Component);
	
	exports.default = ExpertsDetails;

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _default = __webpack_require__(163);
	
	var _default2 = _interopRequireDefault(_default);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Experts = function (_Component) {
	  _inherits(Experts, _Component);
	
	  function Experts() {
	    _classCallCheck(this, Experts);
	
	    return _possibleConstructorReturn(this, (Experts.__proto__ || Object.getPrototypeOf(Experts)).apply(this, arguments));
	  }
	
	  _createClass(Experts, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	
	      var acc = document.getElementsByClassName("accordion");
	      var i;
	
	      for (i = 0; i < acc.length; i++) {
	        acc[i].addEventListener("click", function () {
	          this.classList.toggle("active");
	          var panel = this.nextElementSibling;
	          if (panel.style.display === "block") {
	            panel.style.display = "none";
	          } else {
	            panel.style.display = "block";
	          }
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content" },
	          _react2.default.createElement(
	            "section",
	            { className: "courses-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "page-top-section" },
	              _react2.default.createElement(
	                "div",
	                { className: "page-top-head" },
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Experts"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "breadcrumb" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/" },
	                    "Home"
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "px-2" },
	                    " / "
	                  ),
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/courses" },
	                    "Instructors List"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "py-0 py-md-5" },
	              _react2.default.createElement(
	                "div",
	                { className: "container" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row course-section" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12 row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-lg-3 offset-lg-7 form-group", style: { position: "relative" } },
	                      _react2.default.createElement("input", { type: "text", className: "form-control", placeholder: "Search Instructor..." }),
	                      _react2.default.createElement(
	                        "svg",
	                        { className: "svg-icon search-icon", "aria-hidden": "true", role: "img", focusable: "false", width: "20", height: "20", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" },
	                        _react2.default.createElement("path", { d: "M8.80758 0C3.95121 0 0 3.95121 0 8.80758C0 13.6642 3.95121 17.6152 8.80758 17.6152C13.6642 17.6152 17.6152 13.6642 17.6152 8.80758C17.6152 3.95121 13.6642 0 8.80758 0ZM8.80758 15.9892C4.8477 15.9892 1.62602 12.7675 1.62602 8.80762C1.62602 4.84773 4.8477 1.62602 8.80758 1.62602C12.7675 1.62602 15.9891 4.8477 15.9891 8.80758C15.9891 12.7675 12.7675 15.9892 8.80758 15.9892Z", fill: "currentColor" }),
	                        _react2.default.createElement("path", { d: "M19.762 18.6121L15.1007 13.9509C14.7831 13.6332 14.2687 13.6332 13.9511 13.9509C13.6335 14.2682 13.6335 14.7831 13.9511 15.1005L18.6124 19.7617C18.7712 19.9205 18.9791 19.9999 19.1872 19.9999C19.395 19.9999 19.6032 19.9205 19.762 19.7617C20.0796 19.4444 20.0796 18.9295 19.762 18.6121Z", fill: "currentColor" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-lg-2 form-group" },
	                      _react2.default.createElement(
	                        "select",
	                        { className: "form-control" },
	                        _react2.default.createElement(
	                          "option",
	                          null,
	                          "Sort by: Default"
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "experts-body col-lg-12" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "experts-box" },
	                      _react2.default.createElement(
	                        "a",
	                        { href: "/experts-details", className: "experts-box-a" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "experts-box-img" },
	                          _react2.default.createElement("img", { alt: "", className: "experts-img", src: _default2.default })
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          { className: "experts-box-text" },
	                          "Anoop"
	                        ),
	                        _react2.default.createElement(
	                          "p",
	                          { className: "experts-box-subtext" },
	                          "AI Consultant|Ph.D. & M.Phil in AI"
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_footer2.default, null)
	      );
	    }
	  }]);
	
	  return Experts;
	}(_react.Component);
	
	exports.default = Experts;

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _whatIsTypeform = __webpack_require__(849);
	
	var _whatIsTypeform2 = _interopRequireDefault(_whatIsTypeform);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FreeAssesment = function (_Component) {
	  _inherits(FreeAssesment, _Component);
	
	  function FreeAssesment() {
	    _classCallCheck(this, FreeAssesment);
	
	    return _possibleConstructorReturn(this, (FreeAssesment.__proto__ || Object.getPrototypeOf(FreeAssesment)).apply(this, arguments));
	  }
	
	  _createClass(FreeAssesment, [{
	    key: "getAssesment",
	
	    // componentDidMount() {
	    //     ("#form-free-assessment").hide();
	    //     $("#get-free-assesment").click(function(){
	    //       $("#form-free-assessment").show();
	    //     });
	    // }
	    value: function getAssesment() {
	      (0, _jquery2.default)("#form-free-assessment").show();
	      (0, _jquery2.default)("#get-free-assesment").hide();
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	
	      // $("#emailSubwrapper").addClass("get-free-assesment-active");
	
	      //   $(".form-main-wrapper").scroll(function() {
	      //     var topOfDivScroll = $("#emailSubwrapper").offset().top ;
	      //     var topOfDivScroll1 = $("#nameSubwrapper").offset().top ;
	      //     var topOfDivScroll2 = $("#chooseSubwrapper").offset().top ;
	      //     var topOfDivScroll3 = $("#dateSubwrapper").offset().top ;
	      //     var topOfDivScroll4 = $("#questionSubwrapper").offset().top ;
	      //     var topOfDivScroll5 = $("#resumeSubwrapper").offset().top ;
	      //     var topOfDivScroll6 = $("#question2Subwrapper").offset().top ;
	
	      //     if ($(this).scrollTop() > topOfDivScroll) {
	      //       $(".form-main-subwrapper").removeClass("get-free-assesment-active");
	      //       $("#emailSubwrapper").addClass("get-free-assesment-active");
	      //     } 
	      //     if ($(this).scrollTop() > topOfDivScroll1) {
	      //       $(".form-main-subwrapper").removeClass("get-free-assesment-active");
	      //       $("#nameSubwrapper").addClass("get-free-assesment-active");
	      //     } 
	      //     if (($(this).scrollTop() > (topOfDivScroll2)) ) {
	      //       $(".form-main-subwrapper").removeClass("get-free-assesment-active");
	      //       $("#chooseSubwrapper").addClass("get-free-assesment-active");
	      //     } 
	      //     if ($(this).scrollTop() > (topOfDivScroll3)) {
	      //       $(".form-main-subwrapper").removeClass("get-free-assesment-active");
	      //       $("#dateSubwrapper").addClass("get-free-assesment-active");
	      //     } 
	      //     if ($(this).scrollTop() > topOfDivScroll4) {
	      //       $(".form-main-subwrapper").removeClass("get-free-assesment-active");
	      //       $("#questionSubwrapper").addClass("get-free-assesment-active");
	      //     } 
	      //     if ($(this).scrollTop() > topOfDivScroll5) {
	      //       $(".form-main-subwrapper").removeClass("get-free-assesment-active");
	      //       $("#resumeSubwrapper").addClass("get-free-assesment-active");
	      //     } 
	      //     if ($(this).scrollTop() > topOfDivScroll6) {
	      //       $(".form-main-subwrapper").removeClass("get-free-assesment-active");
	      //       $("#question2Subwrapper").addClass("get-free-assesment-active");
	      //     } 
	      //   });
	
	
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content free-assessment-wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "container px-0 pt-5" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-8 free-assessment-main", style: { margin: "auto" } },
	              _react2.default.createElement(
	                "div",
	                { className: "get-free-assesment", id: "get-free-assesment" },
	                _react2.default.createElement(
	                  "p",
	                  { className: "free-assessment-text" },
	                  "Get your free assesment"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-group mt-4" },
	                  _react2.default.createElement(
	                    "button",
	                    { type: "submit", className: "btn btn-warning", onClick: function onClick() {
	                        return _this2.getAssesment();
	                      } },
	                    _react2.default.createElement(
	                      "svg",
	                      { className: "arrow-svg", "aria-hidden": "true", viewBox: "0 0 20 20" },
	                      _react2.default.createElement("path", { d: "M5 20c-0.128 0-0.256-0.049-0.354-0.146-0.195-0.195-0.195-0.512 0-0.707l8.646-8.646-8.646-8.646c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l9 9c0.195 0.195 0.195 0.512 0 0.707l-9 9c-0.098 0.098-0.226 0.146-0.354 0.146z" })
	                    ),
	                    "                        Next"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "form",
	                { className: "form-main-wrapper", id: "form-free-assessment", style: { display: "none" } },
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-main-subwrapper", id: "emailSubwrapper", style: { paddingTop: "50px" } },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { className: "free-assessment-text", "for": "exampleFormControlInput1" },
	                      "Email "
	                    ),
	                    _react2.default.createElement("input", { type: "email", className: "form-control" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group mt-4" },
	                    _react2.default.createElement(
	                      "a",
	                      { href: "#nameSubwrapper", className: "btn btn-warning" },
	                      _react2.default.createElement(
	                        "svg",
	                        { className: "arrow-svg", "aria-hidden": "true", viewBox: "0 0 20 20" },
	                        _react2.default.createElement("path", { d: "M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z" })
	                      ),
	                      "Next"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-main-subwrapper", id: "nameSubwrapper" },
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "a",
	                      { href: "#emailSubwrapper" },
	                      _react2.default.createElement(
	                        "svg",
	                        { className: "arrow-svg-black", "aria-hidden": "true", viewBox: "0 0 20 20" },
	                        _react2.default.createElement("path", { d: "M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z" })
	                      ),
	                      "Back"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { className: "free-assessment-text", "for": "exampleFormControlInput1" },
	                      "Name "
	                    ),
	                    _react2.default.createElement("input", { type: "name", className: "form-control" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group mt-4" },
	                    _react2.default.createElement(
	                      "a",
	                      { href: "#chooseSubwrapper", className: "btn btn-warning" },
	                      _react2.default.createElement(
	                        "svg",
	                        { className: "arrow-svg", "aria-hidden": "true", viewBox: "0 0 20 20" },
	                        _react2.default.createElement("path", { d: "M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z" })
	                      ),
	                      "Next"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-main-subwrapper", id: "chooseSubwrapper" },
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "a",
	                      { href: "#nameSubwrapper" },
	                      _react2.default.createElement(
	                        "svg",
	                        { className: "arrow-svg-black", "aria-hidden": "true", viewBox: "0 0 20 20" },
	                        _react2.default.createElement("path", { d: "M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z" })
	                      ),
	                      "Back"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { className: "free-assessment-text d-block", "for": "exampleFormControlInput1" },
	                      "choose one "
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "chooseimg1" },
	                      _react2.default.createElement("img", { src: _whatIsTypeform2.default })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "chooseimg1" },
	                      _react2.default.createElement("img", { src: _whatIsTypeform2.default })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group mt-4" },
	                    _react2.default.createElement(
	                      "a",
	                      { href: "#dateSubwrapper", className: "btn btn-warning" },
	                      _react2.default.createElement(
	                        "svg",
	                        { className: "arrow-svg", "aria-hidden": "true", viewBox: "0 0 20 20" },
	                        _react2.default.createElement("path", { d: "M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z" })
	                      ),
	                      "Next"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-main-subwrapper", id: "dateSubwrapper" },
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "a",
	                      { href: "#chooseSubwrapper" },
	                      _react2.default.createElement(
	                        "svg",
	                        { className: "arrow-svg-black", "aria-hidden": "true", viewBox: "0 0 20 20" },
	                        _react2.default.createElement("path", { d: "M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z" })
	                      ),
	                      "Back"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { className: "free-assessment-text", "for": "exampleFormControlInput1" },
	                      "date "
	                    ),
	                    _react2.default.createElement("input", { type: "date", className: "form-control" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group mt-4" },
	                    _react2.default.createElement(
	                      "a",
	                      { href: "#questionSubwrapper", className: "btn btn-warning" },
	                      _react2.default.createElement(
	                        "svg",
	                        { className: "arrow-svg", "aria-hidden": "true", viewBox: "0 0 20 20" },
	                        _react2.default.createElement("path", { d: "M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z" })
	                      ),
	                      "Next"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-main-subwrapper", id: "questionSubwrapper" },
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "a",
	                      { href: "#dateSubwrapper" },
	                      _react2.default.createElement(
	                        "svg",
	                        { className: "arrow-svg-black", "aria-hidden": "true", viewBox: "0 0 20 20" },
	                        _react2.default.createElement("path", { d: "M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z" })
	                      ),
	                      "Back"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { className: "free-assessment-text", "for": "exampleFormControlInput1" },
	                      "question 1 "
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "mb-2" },
	                      _react2.default.createElement(
	                        "button",
	                        { type: "button", className: "btn" },
	                        "america"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "mb-2" },
	                      _react2.default.createElement(
	                        "button",
	                        { type: "button", className: "btn" },
	                        "america"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group mt-4" },
	                    _react2.default.createElement(
	                      "a",
	                      { href: "#resumeSubwrapper", className: "btn btn-warning" },
	                      _react2.default.createElement(
	                        "svg",
	                        { className: "arrow-svg", "aria-hidden": "true", viewBox: "0 0 20 20" },
	                        _react2.default.createElement("path", { d: "M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z" })
	                      ),
	                      "Next"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-main-subwrapper", id: "resumeSubwrapper" },
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "a",
	                      { href: "#questionSubwrapper" },
	                      _react2.default.createElement(
	                        "svg",
	                        { className: "arrow-svg-black", "aria-hidden": "true", viewBox: "0 0 20 20" },
	                        _react2.default.createElement("path", { d: "M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z" })
	                      ),
	                      "Back"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { className: "free-assessment-text", "for": "exampleFormControlInput1" },
	                      "Resume "
	                    ),
	                    _react2.default.createElement("input", { type: "email", className: "form-control" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group mt-4" },
	                    _react2.default.createElement(
	                      "a",
	                      { href: "#question2Subwrapper", className: "btn btn-warning" },
	                      _react2.default.createElement(
	                        "svg",
	                        { className: "arrow-svg", "aria-hidden": "true", viewBox: "0 0 20 20" },
	                        _react2.default.createElement("path", { d: "M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z" })
	                      ),
	                      "Next"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-main-subwrapper", id: "question2Subwrapper" },
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "a",
	                      { href: "#resumeSubwrapper" },
	                      _react2.default.createElement(
	                        "svg",
	                        { className: "arrow-svg-black", "aria-hidden": "true", viewBox: "0 0 20 20" },
	                        _react2.default.createElement("path", { d: "M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z" })
	                      ),
	                      "Back"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { className: "free-assessment-text", "for": "exampleFormControlInput1" },
	                      "question 2 "
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement("input", { type: "checkbox" }),
	                      " Kerala"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement("input", { type: "checkbox" }),
	                      " Kerala"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group mt-4" },
	                    _react2.default.createElement(
	                      "a",
	                      { href: "#free-ass-submit", className: "btn btn-warning" },
	                      _react2.default.createElement(
	                        "svg",
	                        { className: "arrow-svg", "aria-hidden": "true", viewBox: "0 0 20 20" },
	                        _react2.default.createElement("path", { d: "M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z" })
	                      ),
	                      "Next"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-main-subwrapper", id: "free-ass-submit" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group mt-4" },
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        "a",
	                        { href: "#question2Subwrapper" },
	                        _react2.default.createElement(
	                          "svg",
	                          { className: "arrow-svg-black", "aria-hidden": "true", viewBox: "0 0 20 20" },
	                          _react2.default.createElement("path", { d: "M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z" })
	                        ),
	                        "Back"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      { type: "submit", className: "btn btn-warning" },
	                      _react2.default.createElement(
	                        "svg",
	                        { className: "arrow-svg", "aria-hidden": "true", viewBox: "0 0 20 20" },
	                        _react2.default.createElement("path", { d: "M5.5 17.5c-0.128 0-0.256-0.049-0.354-0.146l-5-5c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l4.646 4.646 13.646-13.646c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-14 14c-0.098 0.098-0.226 0.146-0.354 0.146z" })
	                      ),
	                      "Submit"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_footer2.default, null)
	      );
	    }
	  }]);
	
	  return FreeAssesment;
	}(_react.Component);
	
	exports.default = FreeAssesment;

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _insights = __webpack_require__(413);
	
	var _insights2 = _interopRequireDefault(_insights);
	
	var _reactHtmlParser = __webpack_require__(389);
	
	var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _firebase = __webpack_require__(6);
	
	var _authorSm = __webpack_require__(410);
	
	var _authorSm2 = _interopRequireDefault(_authorSm);
	
	var _reactRouterDom = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Insights = function (_Component) {
	  _inherits(Insights, _Component);
	
	  function Insights(props) {
	    _classCallCheck(this, Insights);
	
	    var _this = _possibleConstructorReturn(this, (Insights.__proto__ || Object.getPrototypeOf(Insights)).call(this, props));
	
	    _this.state = {
	      storyCategory: "",
	      storyImage: null,
	      storyTitle: "",
	      storyDescription: "",
	      storyCategories: [],
	      title: ""
	    };
	    return _this;
	  }
	
	  _createClass(Insights, [{
	    key: "componentDidMount",
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var url_path, keyId, title, storyCategoryList;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                url_path = window.location.href.split("=");
	                keyId = url_path[1].split('~')[0];
	                title = url_path[1].split('~')[2];
	
	                this.setState({
	                  title: title
	                });
	                storyCategoryList = [];
	                _context.next = 7;
	                return _firebase.database.ref("storyCategory").once('value', function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    if (ChildSnapshot.val().status == 'Active' && title === ChildSnapshot.val().mainCategory) {
	                      storyCategoryList.push({
	                        key: ChildSnapshot.key,
	                        name: ChildSnapshot.val().name
	                      });
	                    }
	                  });
	                });
	
	              case 7:
	                this.setState({
	                  storyCategories: storyCategoryList
	                });
	                this.renderList(keyId);
	                this.setState({
	                  storyCategory: this.props.location.state.storyCategory,
	                  createdAt: this.props.location.state.createdAt,
	                  storyImage: this.props.location.state.storyImage,
	                  storyTitle: this.props.location.state.storyTitle,
	                  storyDescription: this.props.location.state.storyDescription,
	                  fbLink: "https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fivanooo.com%2F'" + this.props.location.state.title + "'%2F",
	                  twitterLink: "https://twitter.com/intent/tweet/?text=The+Importance+of+Planning+Your+Career&amp;url=https%3A%2F%2Fivanooo.com%2F'" + this.props.location.state.title + "'%2F"
	                });
	
	              case 10:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "renderList",
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(keyId) {
	        var id, ref, userRef, valueRef, snapshot, val;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                id = keyId;
	                ref = id ? "/stories/" + id : "stories";
	                userRef = _firebase.database.ref(ref);
	                valueRef = id;
	                _context2.next = 6;
	                return userRef.once("value");
	
	              case 6:
	                snapshot = _context2.sent;
	                val = snapshot.val();
	
	                this.setState({
	                  storyCategory: val.category,
	                  createdAt: val.createdAt,
	                  storyImage: val.imageUrl,
	                  storyTitle: val.title,
	                  storyDescription: val.description,
	                  //storyCategories : categories,
	                  fbLink: "https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fivanooo.com%2F'" + val.title + "'%2F",
	                  twitterLink: "https://twitter.com/intent/tweet/?text=The+Importance+of+Planning+Your+Career&amp;url=https%3A%2F%2Fivanooo.com%2F'" + val.title + "'%2F"
	                });
	
	              case 9:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function renderList(_x) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return renderList;
	    }()
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "section",
	              { className: "Insights-det-wrapper row" },
	              _react2.default.createElement(
	                "div",
	                { className: "insights-det-body col-lg-8" },
	                _react2.default.createElement(
	                  "nav",
	                  { "aria-label": "breadcrumb" },
	                  _react2.default.createElement(
	                    "ol",
	                    { className: "breadcrumb justify-content-center mb-0 bg-white" },
	                    _react2.default.createElement(
	                      "li",
	                      { className: "breadcrumb-item" },
	                      _react2.default.createElement(
	                        "a",
	                        { href: "/" },
	                        "Home"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      { className: "breadcrumb-item" },
	                      _react2.default.createElement(
	                        "a",
	                        { href: "/insightss" },
	                        "Stories"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      { className: "breadcrumb-item active", "aria-current": "page" },
	                      this.state.storyTitle
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 m-auto px-0" },
	                  _react2.default.createElement(
	                    "h1",
	                    { className: "main-sub-head my-4" },
	                    this.state.storyTitle
	                  ),
	                  _react2.default.createElement(
	                    "ul",
	                    { className: "insights-box-list my-0" },
	                    _react2.default.createElement(
	                      "li",
	                      { className: "insights-list-inline-item" },
	                      this.state.storyCategory
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      { className: "insights-list-inline-item" },
	                      this.state.createdAt
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "insightsDetBanner" },
	                  _react2.default.createElement("img", { src: this.state.storyImage, className: "img-fluid insightsDetBannerImg" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 m-auto" },
	                  _react2.default.createElement("p", { dangerouslySetInnerHTML: { __html: this.state.storyDescription } })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12" },
	                  _react2.default.createElement("hr", null)
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "insights-det-social-share" },
	                  _react2.default.createElement(
	                    "ul",
	                    { className: "social-share-ul" },
	                    _react2.default.createElement(
	                      "li",
	                      { className: "social-share-list" },
	                      _react2.default.createElement(
	                        "a",
	                        { target: "_blank", href: _jquery.data.fbLink },
	                        _react2.default.createElement("i", { className: "fa fa-facebook-f" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      { className: "social-share-list" },
	                      _react2.default.createElement(
	                        "a",
	                        { target: "_blank", href: _jquery.data.twitterLink },
	                        _react2.default.createElement("i", { className: "fa fa-twitter" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      { className: "social-share-list" },
	                      _react2.default.createElement(
	                        "a",
	                        { target: "_blank", href: "#" },
	                        _react2.default.createElement("i", { className: "fa fa-linkedin" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      { className: "social-share-list" },
	                      _react2.default.createElement(
	                        "a",
	                        { target: "_blank", href: "#" },
	                        _react2.default.createElement("i", { className: "fa fa-pinterest" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      { className: "social-share-list" },
	                      _react2.default.createElement(
	                        "a",
	                        { target: "_blank", href: "#" },
	                        _react2.default.createElement("i", { className: "fa fa-paper-plane" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "li",
	                      { className: "social-share-list" },
	                      _react2.default.createElement(
	                        "a",
	                        { target: "_blank", href: "#" },
	                        _react2.default.createElement("i", { className: "fa fa-envelope" })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-4 mt-4" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 mt-5 categories-main" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-head" },
	                    "Categories"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12 p-0" },
	                    this.state.storyCategories.map(function (x, y) {
	                      return _react2.default.createElement(
	                        "div",
	                        { className: "Categories-list" },
	                        _react2.default.createElement("i", { className: "fa fa-angle-right" }),
	                        _react2.default.createElement(
	                          _reactRouterDom.Link,
	                          { to: '/insightss/id=' + _this2.state.title },
	                          x.name,
	                          _react2.default.createElement("span", { className: "Categories-list-count" })
	                        )
	                      );
	                    })
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_footer2.default, null)
	      );
	    }
	  }]);
	
	  return Insights;
	}(_react.Component);
	
	exports.default = Insights;

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _insights = __webpack_require__(413);
	
	var _insights2 = _interopRequireDefault(_insights);
	
	var _authorSm = __webpack_require__(410);
	
	var _authorSm2 = _interopRequireDefault(_authorSm);
	
	var _firebase = __webpack_require__(6);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactHtmlParser = __webpack_require__(389);
	
	var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Insights = function (_Component) {
	  _inherits(Insights, _Component);
	
	  function Insights(props) {
	    _classCallCheck(this, Insights);
	
	    var _this = _possibleConstructorReturn(this, (Insights.__proto__ || Object.getPrototypeOf(Insights)).call(this, props));
	
	    _this.tgglBtnShare = function (data) {
	      console.log("data...", data);
	      _this.setState({
	        socialLinkKey: data.key
	      });
	      (0, _jquery2.default)(".toggle-button-i").toggleClass("fa-share-alt");
	      (0, _jquery2.default)(".toggle-button-i").toggleClass("fa-times-circle-o");
	      (0, _jquery2.default)(".social-share-ul").toggleClass("social-share-ul-visible");
	    };
	
	    _this.filterByCategory = function (text, id) {
	      (0, _jquery2.default)(".insights-tab-span").removeClass("insights-tab-span-act");
	      (0, _jquery2.default)("#" + id).addClass("insights-tab-span-act");
	      if (text == "all") {
	        _this.setState({
	          storyData: _this.state.storyDataBackUp
	        });
	      } else {
	        var newData = _this.state.storyDataBackUp.filter(function (item) {
	          var itemData = item.storyCategory.toUpperCase() + " " + item.storyCategory.toUpperCase() + " " + item.storyCategory.toUpperCase();
	          var textData = text.toUpperCase();
	          return itemData.indexOf(textData) > -1;
	        });
	        _this.setState({
	          storyData: newData
	        });
	      }
	    };
	
	    _this.state = {
	      storyData: [],
	      storyCategories: [],
	      storyDataBackUp: [],
	      socialLinkKey: "",
	      title: "Stories",
	      storyCategoryData: []
	    };
	    return _this;
	  }
	
	  _createClass(Insights, [{
	    key: "componentDidMount",
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var url_path, keyId, storyCategoryList;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                url_path = window.location.href.split("=");
	                keyId = url_path[1].replace("%20", " ");
	
	
	                this.setState({
	                  title: keyId
	                });
	                storyCategoryList = [];
	                _context.next = 6;
	                return _firebase.database.ref("storyCategory").once('value', function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    if (ChildSnapshot.val().status == 'Active' && keyId === ChildSnapshot.val().mainCategory) {
	                      storyCategoryList.push({
	                        key: ChildSnapshot.key,
	                        name: ChildSnapshot.val().name
	                      });
	                    }
	                  });
	                });
	
	              case 6:
	                this.setState({
	                  storyCategoryData: storyCategoryList
	                });
	                this.renderList(keyId);
	
	              case 8:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "renderList",
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(keyId) {
	        var _this2 = this;
	
	        var dataList, dataListCategory, results;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                dataList = [];
	                dataListCategory = [];
	                _context2.next = 4;
	                return _firebase.database.ref("stories").once('value', function (snapshot) {
	                  snapshot.forEach(function (ChildSnapshot) {
	                    if (ChildSnapshot.val().status == 'Active' && keyId == ChildSnapshot.val().mainCategory) {
	                      dataList.push({
	                        key: ChildSnapshot.key,
	                        storyTitle: ChildSnapshot.val().title,
	                        storyImage: ChildSnapshot.val().imageUrl,
	                        storyStatus: ChildSnapshot.val().status,
	                        storyDescription: ChildSnapshot.val().description,
	                        shortDescription: ChildSnapshot.val().shortDescription,
	                        storyCategory: ChildSnapshot.val().category,
	                        createdAt: ChildSnapshot.val().createdAt,
	                        fbLink: "https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fivanooo.com%2F'" + ChildSnapshot.val().title + "'%2F",
	                        twitterLink: "https://twitter.com/intent/tweet/?text=The+Importance+of+Planning+Your+Career&amp;url=https%3A%2F%2Fivanooo.com%2F'" + ChildSnapshot.val().title + "'%2F"
	                      });
	                      dataListCategory.push({
	                        storyCategory: ChildSnapshot.val().category
	                      });
	                    }
	                  });
	                });
	
	              case 4:
	                results = dataList.filter(function (_ref3) {
	                  var id1 = _ref3.storyCategory;
	                  return _this2.state.storyCategoryData.some(function (_ref4) {
	                    var id2 = _ref4.name;
	                    return id2 === id1;
	                  });
	                });
	
	
	                this.setState({
	                  storyData: results,
	                  storyDataBackUp: results,
	                  storyCategories: dataListCategory
	                });
	
	              case 6:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function renderList(_x) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return renderList;
	    }()
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content px-0" },
	          _react2.default.createElement(
	            "section",
	            { className: "Insights-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "" },
	              _react2.default.createElement(
	                "div",
	                { className: "insights-tab" },
	                _react2.default.createElement(
	                  "span",
	                  { id: "all", className: "insights-tab-span insights-tab-span-act", style: { cursor: 'pointer' }, onClick: function onClick() {
	                      return _this3.filterByCategory("all", "all");
	                    } },
	                  "All "
	                ),
	                this.state.storyCategoryData.slice(0, 5).map(function (x, y) {
	                  return _react2.default.createElement(
	                    "span",
	                    { id: x.name.replace(/ /g, ''), className: "insights-tab-span", style: { cursor: 'pointer' }, onClick: function onClick() {
	                        return _this3.filterByCategory(x.name, x.name.replace(/ /g, ''));
	                      } },
	                    x.name
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                "section",
	                { className: "page-header" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "container iavno-works-head text-center" },
	                  _react2.default.createElement(
	                    "h4",
	                    null,
	                    this.state.title
	                  ),
	                  _react2.default.createElement(
	                    "nav",
	                    { "aria-label": "breadcrumb" },
	                    _react2.default.createElement(
	                      "ol",
	                      { className: "breadcrumb justify-content-center mb-0" },
	                      _react2.default.createElement(
	                        "li",
	                        { className: "breadcrumb-item" },
	                        _react2.default.createElement(
	                          "a",
	                          { href: "#" },
	                          "Home"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "li",
	                        { className: "breadcrumb-item active", "aria-current": "page" },
	                        this.state.title
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "container" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "insights-body col-lg-12" },
	                    this.state.storyData.map(function (data, i) {
	                      return _react2.default.createElement(
	                        "div",
	                        { className: "insights-box" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "tag-learning" },
	                          _react2.default.createElement("i", { className: "fa fa-tags" }),
	                          " ",
	                          data.storyCategory
	                        ),
	                        _react2.default.createElement(
	                          _reactRouterDom.Link,
	                          { to: '/insights-details/id=' + data.key + "~" + data.storyTitle + "~" + _this3.state.title, params: data.key },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "insights-img-div" },
	                            _react2.default.createElement("img", { alt: "", className: "insights-img", src: data.storyImage })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "ul",
	                          { className: "insights-box-list" },
	                          _react2.default.createElement(
	                            "li",
	                            { className: "insights-list-inline-item" },
	                            data.createdAt
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactRouterDom.Link,
	                          { to: '/insights-details/id=' + data.key + "~" + data.storyTitle + "~" + _this3.state.title },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "insights-box-text" },
	                            data.storyTitle
	                          ),
	                          _react2.default.createElement(
	                            "p",
	                            { className: "insights-box-subtext" },
	                            (0, _reactHtmlParser2.default)(data.shortDescription.substring(0, 200))
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "insights-box-social-share" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "social-share" },
	                            _react2.default.createElement(
	                              "span",
	                              { className: "toggle-button-share" },
	                              _react2.default.createElement("i", { className: "toggle-button-i fa fa-share-alt", onClick: function onClick() {
	                                  return _this3.tgglBtnShare(data);
	                                }, "aria-hidden": "true" })
	                            ),
	                            data.key == _this3.state.socialLinkKey && _react2.default.createElement(
	                              "ul",
	                              { className: "social-share-ul" },
	                              _react2.default.createElement(
	                                "li",
	                                { className: "social-share-list" },
	                                _react2.default.createElement(
	                                  "a",
	                                  { target: "_blank", href: data.fbLink },
	                                  _react2.default.createElement("i", { className: "fa fa-facebook-f" })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "li",
	                                { className: "social-share-list" },
	                                _react2.default.createElement(
	                                  "a",
	                                  { href: data.twitterLink },
	                                  _react2.default.createElement("i", { className: "fa fa-twitter" })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "li",
	                                { className: "social-share-list" },
	                                _react2.default.createElement(
	                                  "a",
	                                  { href: "#" },
	                                  _react2.default.createElement("i", { className: "fa fa-linkedin" })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "li",
	                                { className: "social-share-list" },
	                                _react2.default.createElement(
	                                  "a",
	                                  { href: "#" },
	                                  _react2.default.createElement("i", { className: "fa fa-pinterest" })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "li",
	                                { className: "social-share-list" },
	                                _react2.default.createElement(
	                                  "a",
	                                  { href: "#" },
	                                  _react2.default.createElement("i", { className: "fa fa-paper-plane" })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "li",
	                                { className: "social-share-list" },
	                                _react2.default.createElement(
	                                  "a",
	                                  { href: "#" },
	                                  _react2.default.createElement("i", { className: "fa fa-envelope" })
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _reactRouterDom.Link,
	                            { to: '/insights-details/id=' + data.key + "~" + data.storyTitle + "~" + _this3.state.title, className: "insights-box-a" },
	                            _react2.default.createElement("i", { className: "fa fa-ellipsis-h", "aria-hidden": "true" })
	                          )
	                        )
	                      );
	                    })
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_footer2.default, null)
	      );
	    }
	  }]);
	
	  return Insights;
	}(_react.Component);
	
	exports.default = Insights;

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LostPassword = function (_Component) {
	  _inherits(LostPassword, _Component);
	
	  function LostPassword() {
	    _classCallCheck(this, LostPassword);
	
	    return _possibleConstructorReturn(this, (LostPassword.__proto__ || Object.getPrototypeOf(LostPassword)).apply(this, arguments));
	  }
	
	  _createClass(LostPassword, [{
	    key: "render",
	    value: function render() {
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content myaccount-wrapper m-0" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-7", style: { margin: "auto" } },
	              _react2.default.createElement(
	                "form",
	                { className: "form-main-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "subhead" },
	                  "SIGN IN"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: " myaccount-form" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      _react2.default.createElement(
	                        "small",
	                        null,
	                        "Lost your password? Please enter your username or email address. You will receive a link to create a new password via email."
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      "Username or email address "
	                    ),
	                    _react2.default.createElement("input", { type: "email", className: "form-control" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group mt-4", style: { textAlign: "right" } },
	                    _react2.default.createElement(
	                      "button",
	                      { type: "submit", className: "btn btn-gray" },
	                      "Reset Password"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_footer2.default, null)
	      );
	    }
	  }]);
	
	  return LostPassword;
	}(_react.Component);
	
	exports.default = LostPassword;

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _firebase = __webpack_require__(6);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MyAccount = function (_Component) {
	  _inherits(MyAccount, _Component);
	
	  function MyAccount(props) {
	    _classCallCheck(this, MyAccount);
	
	    var _this = _possibleConstructorReturn(this, (MyAccount.__proto__ || Object.getPrototypeOf(MyAccount)).call(this, props));
	
	    _this.handleChange = function (event) {
	      var _event$target = event.target,
	          value = _event$target.value,
	          name = _event$target.name;
	
	      _this.setState(_defineProperty({}, name, value));
	    };
	
	    _this.state = {
	      username: "",
	      password: ""
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(MyAccount, [{
	    key: "loginSubmit",
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this2 = this;
	
	        var ref, userRef, valueRef, snapshot;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!(this.state.username === '')) {
	                  _context.next = 5;
	                  break;
	                }
	
	                alert('Please enter your user name');
	                (0, _jquery2.default)("#username").focus();
	                _context.next = 19;
	                break;
	
	              case 5:
	                if (!(this.state.password === '')) {
	                  _context.next = 10;
	                  break;
	                }
	
	                alert('Please enter  password');
	                (0, _jquery2.default)("#password").focus();
	                _context.next = 19;
	                break;
	
	              case 10:
	                ref = 'SecUser/';
	                userRef = _firebase.database.ref(ref);
	                _context.next = 14;
	                return userRef.orderByChild('emailId').equalTo(this.state.username);
	
	              case 14:
	                valueRef = _context.sent;
	                _context.next = 17;
	                return valueRef.once('value');
	
	              case 17:
	                snapshot = _context.sent;
	
	                snapshot.forEach(function (c) {
	                  var val = c.val();
	                  console.log("loginval........", val);
	                  if (val.password === _this2.state.password) {
	                    localStorage.setItem("userId", val.userId);
	                    localStorage.setItem("guidanceId", val.guidanceId);
	                    window.localStorage.setItem('userName', val.fullName);
	                    window.localStorage.setItem('Role', val.role);
	                    window.localStorage.setItem('LoginFlag', 'true');
	                    alert("Login successful", val.role);
	                    console.log("role...", val.role);
	                    if (val.role === 'ADMIN') {
	                      window.location.href = "/dashboard";
	                    }
	                    if (val.role === 'User') {
	                      window.location.href = "/user-dashboard";
	                    }
	                  } else {
	                    alert('Login failed ! incorrect password');
	                  }
	                });
	
	              case 19:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function loginSubmit() {
	        return _ref.apply(this, arguments);
	      }
	
	      return loginSubmit;
	    }()
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content myaccount-wrapper m-0" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-7", style: { margin: "auto" } },
	              _react2.default.createElement(
	                "form",
	                { className: "form-main-wrapper" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "subhead" },
	                  "SIGN IN"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: " myaccount-form" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      "Username or email address ",
	                      _react2.default.createElement(
	                        "span",
	                        { className: "text-danger" },
	                        "*"
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement("input", { type: "text", name: "username", id: "username", className: "form-control", onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      "Password ",
	                      _react2.default.createElement(
	                        "span",
	                        { className: "text-danger" },
	                        "*"
	                      )
	                    ),
	                    _react2.default.createElement("input", { type: "password", name: "password", id: "password", className: "form-control", placeholder: "Password", onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col-lg-7" },
	                      _react2.default.createElement("input", { type: "checkbox", className: "form-check-input", id: "exampleCheck1" }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "exampleCheck1" },
	                        _react2.default.createElement(
	                          "strong",
	                          null,
	                          "Remember me"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col-lg-5", style: { textAlign: "right" } },
	                      _react2.default.createElement(
	                        "button",
	                        { type: "button", className: "btn btn-gray", onClick: function onClick() {
	                            return _this3.loginSubmit();
	                          } },
	                        "Log in."
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_footer2.default, null)
	      );
	    }
	  }]);
	
	  return MyAccount;
	}(_react.Component);
	
	exports.default = MyAccount;

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _courses = __webpack_require__(114);
	
	var _courses2 = _interopRequireDefault(_courses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrivacyPolicy = function (_Component) {
	  _inherits(PrivacyPolicy, _Component);
	
	  function PrivacyPolicy() {
	    _classCallCheck(this, PrivacyPolicy);
	
	    return _possibleConstructorReturn(this, (PrivacyPolicy.__proto__ || Object.getPrototypeOf(PrivacyPolicy)).apply(this, arguments));
	  }
	
	  _createClass(PrivacyPolicy, [{
	    key: "render",
	    value: function render() {
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper privacy-policy-wrapper" },
	        _react2.default.createElement(
	          "div",
	          { className: "heaerBgImg" },
	          _react2.default.createElement(_header2.default, null),
	          _react2.default.createElement(
	            "div",
	            { className: "header-head" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "h4",
	                null,
	                "Privacy Policy"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content px-0" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 my-5" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "At Innova IT Services, accessible from https://innovaitservices.com/, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by Innova IT Services and how we use it."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in Innova IT Services. This policy is not applicable to any information collected offline or via channels other than this website. Our Privacy Policy was created with the help of the Free Privacy Policy Generator."
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "header-head-thin" },
	                _react2.default.createElement(
	                  "h4",
	                  { className: "text-left" },
	                  "Consent"
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "By using our website, you hereby consent to our Privacy Policy and agree to its terms."
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "header-head-thin" },
	                _react2.default.createElement(
	                  "h4",
	                  { className: "text-left" },
	                  "Information we collect"
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "If you contact us directly, we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "When you register for an Account, we may ask for your contact information, including items such as name, company name, address, email address, and telephone number."
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "header-head-thin" },
	                _react2.default.createElement(
	                  "h4",
	                  { className: "text-left" },
	                  " How we use your information"
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "We use the information we collect in various ways, including to:"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                _react2.default.createElement(
	                  "ul",
	                  { className: "list-ul" },
	                  _react2.default.createElement(
	                    "li",
	                    { className: "list-li" },
	                    "Provide, operate, and maintain our website"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    { className: "list-li" },
	                    "Improve, personalize, and expand our website"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    { className: "list-li" },
	                    "Understand and analyze how you use our website"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    { className: "list-li" },
	                    "Develop new products, services, features, and functionality"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    { className: "list-li" },
	                    "Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    { className: "list-li" },
	                    "Send you emails"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    { className: "list-li" },
	                    "Find and prevent fraud"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "header-head-thin" },
	                _react2.default.createElement(
	                  "h4",
	                  { className: "text-left" },
	                  " Log Files"
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Innova IT Services follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services\u2019 analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users\u2019 movement on the website, and gathering demographic information."
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "header-head-thin" },
	                _react2.default.createElement(
	                  "h4",
	                  { className: "text-left" },
	                  "Advertising Partners Privacy Policies"
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "You may consult this list to find the Privacy Policy for each of the advertising partners of Innova IT Services."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on Innova IT Services, which are sent directly to users\u2019 browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Note that Innova IT Services has no access to or control over these cookies that are used by third-party advertisers."
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "header-head-thin" },
	                _react2.default.createElement(
	                  "h4",
	                  { className: "text-left" },
	                  "Third Party Privacy Policies"
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Innova IT Services\u2019s Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers\u2019 respective websites."
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "header-head-thin" },
	                _react2.default.createElement(
	                  "h4",
	                  { className: "text-left" },
	                  "CCPA Privacy Rights (Do Not Sell My Personal Information)"
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Under the CCPA, among other rights, California consumers have the right to:"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Request that a business that collects a consumer\u2019s personal data disclose the categories and specific pieces of personal data that a business has collected about consumers."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Request that a business delete any personal data about the consumer that a business has collected."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Request that a business that sells a consumer\u2019s personal data, not sell the consumer\u2019s personal data."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us."
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "header-head-thin" },
	                _react2.default.createElement(
	                  "h4",
	                  { className: "text-left" },
	                  "GDPR Data Protection Rights"
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The right to access \u2013 You have the right to request copies of your personal data. We may charge you a small fee for this service."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The right to rectification \u2013 You have the right to request that we correct any information you believe is inaccurate. You also have the right to request that we complete the information you believe is incomplete."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The right to erasure \u2013 You have the right to request that we erase your personal data, under certain conditions."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The right to restrict processing \u2013 You have the right to request that we restrict the processing of your personal data, under certain conditions."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The right to object to processing \u2013 You have the right to object to our processing of your personal data, under certain conditions."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The right to data portability \u2013 You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us."
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "header-head-thin" },
	                _react2.default.createElement(
	                  "h4",
	                  { className: "text-left" },
	                  "Children\u2019s Information"
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Innova IT Services does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records."
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_footer2.default, null)
	      );
	    }
	  }]);
	
	  return PrivacyPolicy;
	}(_react.Component);
	
	exports.default = PrivacyPolicy;

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _doctorLeftmenu = __webpack_require__(12);
	
	var _doctorLeftmenu2 = _interopRequireDefault(_doctorLeftmenu);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Profile = function (_Component) {
	  _inherits(Profile, _Component);
	
	  function Profile() {
	    _classCallCheck(this, Profile);
	
	    return _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).apply(this, arguments));
	  }
	
	  _createClass(Profile, [{
	    key: "render",
	    value: function render() {
	
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content" },
	          _react2.default.createElement(
	            "div",
	            { className: "container pt-5" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-6" },
	                _react2.default.createElement(
	                  "form",
	                  { className: "form-main-wrapper" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-head" },
	                    "Log In to Your Skola Account!"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      "Username or email *"
	                    ),
	                    _react2.default.createElement("input", { type: "email", className: "form-control", placeholder: "Email or username" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      "Password *"
	                    ),
	                    _react2.default.createElement("input", { type: "email", className: "form-control", placeholder: "Password" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col-lg-7" },
	                      _react2.default.createElement("input", { type: "checkbox", className: "form-check-input", id: "exampleCheck1" }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "exampleCheck1" },
	                        "Remember me"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col-lg-5", style: { textAlign: "right" } },
	                      _react2.default.createElement(
	                        "a",
	                        { href: "/lost-password" },
	                        "Forgot Password"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group mt-4", style: { textAlign: "right" } },
	                    _react2.default.createElement(
	                      "button",
	                      { type: "submit", className: "btn btn-secondary" },
	                      "Log in"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-6" },
	                _react2.default.createElement(
	                  "form",
	                  { className: "form-main-wrapper" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-head" },
	                    "Sign Up and Start Learning!"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      "Email address *"
	                    ),
	                    _react2.default.createElement("input", { type: "email", className: "form-control", placeholder: "Email" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      "Username *"
	                    ),
	                    _react2.default.createElement("input", { type: "email", className: "form-control", placeholder: "Username" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      "Password *"
	                    ),
	                    _react2.default.createElement("input", { type: "email", className: "form-control", placeholder: "Password" })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group mt-4", style: { textAlign: "right" } },
	                    _react2.default.createElement(
	                      "button",
	                      { type: "submit", className: "btn btn-secondary" },
	                      "Register"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Profile;
	}(_react.Component);
	
	exports.default = Profile;

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(7);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(5);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _checkmarkB = __webpack_require__(60);
	
	var _checkmarkB2 = _interopRequireDefault(_checkmarkB);
	
	var _linkedin = __webpack_require__(140);
	
	var _linkedin2 = _interopRequireDefault(_linkedin);
	
	var _uploadFolder = __webpack_require__(141);
	
	var _uploadFolder2 = _interopRequireDefault(_uploadFolder);
	
	var _anoop = __webpack_require__(822);
	
	var _anoop2 = _interopRequireDefault(_anoop);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _firebase = __webpack_require__(6);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserProfile = function (_Component) {
	  _inherits(UserProfile, _Component);
	
	  function UserProfile(props) {
	    _classCallCheck(this, UserProfile);
	
	    var _this = _possibleConstructorReturn(this, (UserProfile.__proto__ || Object.getPrototypeOf(UserProfile)).call(this, props));
	
	    _this.updateValidateSubmission = function () {
	      var newDate = (0, _moment2.default)(new Date()).format("DD/MM/YYYY");
	      var userDataNew = {
	        userId: _this.state.secUserId,
	        fullName: _this.state.fullName,
	        emailId: _this.state.emailId,
	        phoneno: _this.state.phoneno,
	        imageUrl: _this.state.url ? _this.state.url : _this.state.testimonialUrl,
	        role: "User"
	      };
	      _firebase.database.ref("SecUser/" + _this.state.secUserId).update(userDataNew).then(function () {
	        alert("Updated Successfully");
	
	        localStorage.setItem("userId", _this.state.secUserId);
	        localStorage.setItem("userName", _this.state.fullName);
	        localStorage.setItem("userImage", _this.state.url ? _this.state.url : _this.state.testimonialUrl);
	        window.location.href = "/user-dashboard";
	      }).catch(function () {
	        alert("Somthing went wrong");
	      });
	    };
	
	    _this.handleImageChange = function (e) {
	      _this.setState({
	        image: URL.createObjectURL(e.target.files[0]),
	        imageUrl: e.target.files[0],
	        fileName: true
	      });
	    };
	
	    _this.handleResumeFile = function (e) {
	      if (e.target.files[0]) {
	        _this.setState({
	          resumeImage: e.target.files[0],
	          resumeFileName: true
	        });
	      }
	    };
	
	    _this.validateSubmission = function () {
	      var regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
	      if (_this.state.fullName === '') {
	        alert('Name Required');
	      } else if (_this.state.emailId === '') {
	        alert('Email Id Required');
	      } else if (_this.state.emailId !== '' && regex.test(_this.state.emailId) === false) {
	        alert('Email Id is not valid');
	      } else if (_this.state.phoneno === '') {
	        alert('Phone Required');
	      }
	      // else if (this.state.password === '') {
	      //   alert('Password Required')
	      // }
	      // else if (this.state.authorized_usa === '') {
	      //   alert('Are you located in the UAE Required')
	      // }
	      // else if (this.state.goals === '') {
	      //   alert('Goals Required')
	      // }
	      else {
	          console.log("this.state.fullName...", _this.state.fullName);
	          console.log("this.state.resumeFileName...", _this.state.resumeFileName);
	          if (_this.state.fileName) {
	            var uploadTask = _firebase.storage.ref("SecUser/" + _this.state.imageUrl.name).put(_this.state.imageUrl);
	            uploadTask.on("state_changed", function (snapshot) {
	              var progress = Math.round(snapshot.bytesTransferred / snapshot.totalBytes * 100);
	              _this.setState({
	                progress: progress
	              });
	            }, function (error) {
	              console.log(error);
	            }, function () {
	              _firebase.storage.ref("SecUser").child(_this.state.imageUrl.name).getDownloadURL().then(function (url) {
	                console.log("url...", url);
	                (0, _jquery2.default)("#imageUrl").attr('src', url);
	                _this.setState({
	                  url: url
	                });
	                _this.updateValidateSubmission("");
	              });
	            });
	          }
	          // if (this.state.resumeFileName) {
	          //   const uploadTask = storage.ref(`Guidance/${this.state.resumeImage.name}`).put(this.state.resumeImage);
	          //   uploadTask.on(
	          //     "state_changed",
	          //     snapshot => {
	          //       const progress = Math.round(
	          //         (snapshot.bytesTransferred / snapshot.totalBytes) * 100
	          //       );
	          //       this.setState({
	          //         progress: progress
	          //       })
	          //     },
	          //     error => {
	          //       console.log(error);
	          //     },
	          //     () => {
	          //       storage
	          //         .ref("Guidance")
	          //         .child(this.state.resumeImage.name)
	          //         .getDownloadURL()
	          //         .then(url => {
	          //           console.log("url...", url)
	          //           $("#resumeFile")
	          //             .attr('src', url);
	          //           this.setState({
	          //             resumeFile: url
	          //           })
	          //           this.updateValidateSubmission()
	          //         });
	
	          //     }
	
	          //   );
	          // }
	          else {
	
	              _this.updateValidateSubmission("");
	            }
	        }
	    };
	
	    _this.handleChange = function (event) {
	      var _event$target = event.target,
	          value = _event$target.value,
	          name = _event$target.name;
	
	      console.log("name..", event.target.name);
	      _this.setState(_defineProperty({}, name, value));
	    };
	
	    _this.state = {
	      userData: [],
	      testimonialUrl: null,
	      url: "",
	      resumeImage: null,
	      resumeFile: "",
	      resumeLink: "",
	      emailId: "",
	      phoneno: "",
	      fileName: false,
	      image: null
	
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleImageChange = _this.handleImageChange.bind(_this);
	    _this.validateSubmission = _this.validateSubmission.bind(_this);
	    _this.updateValidateSubmission = _this.updateValidateSubmission.bind(_this);
	    _this.handleResumeFile = _this.handleResumeFile.bind(_this);
	    _this.logout = _this.logout.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(UserProfile, [{
	    key: "logout",
	    value: function logout() {
	      localStorage.removeItem("userId");
	      localStorage.removeItem("userName");
	      localStorage.removeItem("userImage");
	      localStorage.removeItem("guidanceArray");
	      window.location.href = "/";
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var userKey = localStorage.getItem("guidanceId");
	      var secUserId = localStorage.getItem("userId");
	      console.log("userKey....", userKey);
	      console.log("secUserId....", secUserId);
	      this.setState({
	        userKey: userKey,
	        secUserId: secUserId
	      });
	      this.renderList(secUserId);
	    }
	  }, {
	    key: "renderList",
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(keyId) {
	        var dataList, id, ref, userRef, valueRef, snapshot, val, data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                dataList = [];
	                id = keyId;
	                ref = id ? '/SecUser/' + id : 'SecUser';
	                userRef = _firebase.database.ref(ref);
	
	                if (!id) {
	                  _context.next = 8;
	                  break;
	                }
	
	                _context.t0 = userRef;
	                _context.next = 11;
	                break;
	
	              case 8:
	                _context.next = 10;
	                return userRef.orderByChild('key').equalTo('value');
	
	              case 10:
	                _context.t0 = _context.sent;
	
	              case 11:
	                valueRef = _context.t0;
	                _context.next = 14;
	                return valueRef.once('value');
	
	              case 14:
	                snapshot = _context.sent;
	                val = snapshot.val();
	
	                if (val) {
	                  data = val;
	
	                  localStorage.setItem("userName", val.fullName);
	                  (0, _jquery2.default)("#fullName").val(val.fullName);
	                  (0, _jquery2.default)("#emailId").val(val.emailId);
	                  (0, _jquery2.default)("#phoneno").val(val.phoneno);
	                  (0, _jquery2.default)("#password").val(val.password);
	                  (0, _jquery2.default)("#imageUrl").attr('src', val.imageUrl);
	
	                  this.setState({
	                    userData: val,
	                    fullName: val.fullName,
	                    emailId: data.emailId,
	                    phoneno: val.phoneno,
	                    testimonialUrl: val.imageUrl ? val.imageUrl : null,
	                    imageUrl: val.imageUrl ? val.imageUrl : null
	                  });
	                }
	
	              case 17:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function renderList(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return renderList;
	    }()
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "main-wrapper assesment-wrapper" },
	        _react2.default.createElement(_header2.default, null),
	        _react2.default.createElement(
	          "div",
	          { className: "main-content p-0", style: { background: "#f4f6f9" } },
	          _react2.default.createElement(
	            "div",
	            { className: "container p-0 pt-5" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-4 col-lg-3 mt-4" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "usr-dasbrd-menu" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "usr-dasbrd-menuhead" },
	                    "My Account"
	                  ),
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { className: "usr-dasbrd-menuList", to: "/user-dashboard" },
	                    "Dashoboard"
	                  ),
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { className: "usr-dasbrd-menuList usr-dasbrd-menuAct", to: "/user-profile" },
	                    "Profile"
	                  ),
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { className: "usr-dasbrd-menuList", to: "", onClick: this.logout },
	                    "LogOut"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-6 m-auto p-0" },
	                _react2.default.createElement(
	                  "form",
	                  { className: "form-main-wrapper" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      "Name ",
	                      _react2.default.createElement(
	                        "span",
	                        { style: { color: "#535fe5" } },
	                        "*"
	                      )
	                    ),
	                    _react2.default.createElement("input", { type: "text", name: "fullName", id: "fullName", className: "form-control", onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      "Email ",
	                      _react2.default.createElement(
	                        "span",
	                        { style: { color: "#535fe5" } },
	                        "*"
	                      )
	                    ),
	                    _react2.default.createElement("input", { type: "email", name: "emailId", id: "emailId", className: "form-control", onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "exampleFormControlInput1" },
	                      " Phone ",
	                      _react2.default.createElement(
	                        "span",
	                        { style: { color: "#535fe5" } },
	                        "*"
	                      )
	                    ),
	                    _react2.default.createElement("input", { type: "text", name: "phoneno", id: "phoneno", className: "form-control", onChange: this.handleChange })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group" },
	                    _react2.default.createElement(
	                      "label",
	                      { "for": "fellow_cv", className: "form-fileUpload" },
	                      _react2.default.createElement("input", { id: "imageUrl", name: "imageUrl", type: "file", onChange: this.handleImageChange }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "FormFileUpload_uploadContent__1quqH" },
	                        this.state.fileName == true ? _react2.default.createElement("img", { style: { width: '100px',
	                            height: '100px' }, alt: "", src: this.state.image }) : _react2.default.createElement("img", { style: { width: '100px',
	                            height: '100px' }, alt: "", src: this.state.imageUrl }),
	                        _react2.default.createElement(
	                          "span",
	                          { className: "form-fileUpload-title" },
	                          " Upload Image"
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-group mt-4" },
	                    _react2.default.createElement(
	                      "button",
	                      { type: "button", className: "btn btn-secondary w-100", onClick: this.validateSubmission },
	                      "Submit"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return UserProfile;
	}(_react.Component);
	
	exports.default = UserProfile;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (user) {
	  _firebase.messaging.requestPermission().then(function () {
	    return _firebase.messaging.getToken();
	  }).then(function (token) {
	    _firebase.database.ref('users').child(user.uid).child('token').set(token);
	  }).catch(console.error);
	};
	
	var _firebase = __webpack_require__(6);

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(607);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 607 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 608 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(78), __webpack_require__(610), __webpack_require__(215), __webpack_require__(214));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../xml/xml", "../javascript/javascript", "../css/css"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  var defaultTags = {
	    script: [
	      ["lang", /(javascript|babel)/i, "javascript"],
	      ["type", /^(?:text|application)\/(?:x-)?(?:java|ecma)script$|^module$|^$/i, "javascript"],
	      ["type", /./, "text/plain"],
	      [null, null, "javascript"]
	    ],
	    style:  [
	      ["lang", /^css$/i, "css"],
	      ["type", /^(text\/)?(x-)?(stylesheet|css)$/i, "css"],
	      ["type", /./, "text/plain"],
	      [null, null, "css"]
	    ]
	  };
	
	  function maybeBackup(stream, pat, style) {
	    var cur = stream.current(), close = cur.search(pat);
	    if (close > -1) {
	      stream.backUp(cur.length - close);
	    } else if (cur.match(/<\/?$/)) {
	      stream.backUp(cur.length);
	      if (!stream.match(pat, false)) stream.match(cur);
	    }
	    return style;
	  }
	
	  var attrRegexpCache = {};
	  function getAttrRegexp(attr) {
	    var regexp = attrRegexpCache[attr];
	    if (regexp) return regexp;
	    return attrRegexpCache[attr] = new RegExp("\\s+" + attr + "\\s*=\\s*('|\")?([^'\"]+)('|\")?\\s*");
	  }
	
	  function getAttrValue(text, attr) {
	    var match = text.match(getAttrRegexp(attr))
	    return match ? /^\s*(.*?)\s*$/.exec(match[2])[1] : ""
	  }
	
	  function getTagRegexp(tagName, anchored) {
	    return new RegExp((anchored ? "^" : "") + "<\/\\s*" + tagName + "\\s*>", "i");
	  }
	
	  function addTags(from, to) {
	    for (var tag in from) {
	      var dest = to[tag] || (to[tag] = []);
	      var source = from[tag];
	      for (var i = source.length - 1; i >= 0; i--)
	        dest.unshift(source[i])
	    }
	  }
	
	  function findMatchingMode(tagInfo, tagText) {
	    for (var i = 0; i < tagInfo.length; i++) {
	      var spec = tagInfo[i];
	      if (!spec[0] || spec[1].test(getAttrValue(tagText, spec[0]))) return spec[2];
	    }
	  }
	
	  CodeMirror.defineMode("htmlmixed", function (config, parserConfig) {
	    var htmlMode = CodeMirror.getMode(config, {
	      name: "xml",
	      htmlMode: true,
	      multilineTagIndentFactor: parserConfig.multilineTagIndentFactor,
	      multilineTagIndentPastTag: parserConfig.multilineTagIndentPastTag,
	      allowMissingTagName: parserConfig.allowMissingTagName,
	    });
	
	    var tags = {};
	    var configTags = parserConfig && parserConfig.tags, configScript = parserConfig && parserConfig.scriptTypes;
	    addTags(defaultTags, tags);
	    if (configTags) addTags(configTags, tags);
	    if (configScript) for (var i = configScript.length - 1; i >= 0; i--)
	      tags.script.unshift(["type", configScript[i].matches, configScript[i].mode])
	
	    function html(stream, state) {
	      var style = htmlMode.token(stream, state.htmlState), tag = /\btag\b/.test(style), tagName
	      if (tag && !/[<>\s\/]/.test(stream.current()) &&
	          (tagName = state.htmlState.tagName && state.htmlState.tagName.toLowerCase()) &&
	          tags.hasOwnProperty(tagName)) {
	        state.inTag = tagName + " "
	      } else if (state.inTag && tag && />$/.test(stream.current())) {
	        var inTag = /^([\S]+) (.*)/.exec(state.inTag)
	        state.inTag = null
	        var modeSpec = stream.current() == ">" && findMatchingMode(tags[inTag[1]], inTag[2])
	        var mode = CodeMirror.getMode(config, modeSpec)
	        var endTagA = getTagRegexp(inTag[1], true), endTag = getTagRegexp(inTag[1], false);
	        state.token = function (stream, state) {
	          if (stream.match(endTagA, false)) {
	            state.token = html;
	            state.localState = state.localMode = null;
	            return null;
	          }
	          return maybeBackup(stream, endTag, state.localMode.token(stream, state.localState));
	        };
	        state.localMode = mode;
	        state.localState = CodeMirror.startState(mode, htmlMode.indent(state.htmlState, "", ""));
	      } else if (state.inTag) {
	        state.inTag += stream.current()
	        if (stream.eol()) state.inTag += " "
	      }
	      return style;
	    };
	
	    return {
	      startState: function () {
	        var state = CodeMirror.startState(htmlMode);
	        return {token: html, inTag: null, localMode: null, localState: null, htmlState: state};
	      },
	
	      copyState: function (state) {
	        var local;
	        if (state.localState) {
	          local = CodeMirror.copyState(state.localMode, state.localState);
	        }
	        return {token: state.token, inTag: state.inTag,
	                localMode: state.localMode, localState: local,
	                htmlState: CodeMirror.copyState(htmlMode, state.htmlState)};
	      },
	
	      token: function (stream, state) {
	        return state.token(stream, state);
	      },
	
	      indent: function (state, textAfter, line) {
	        if (!state.localMode || /^\s*<\//.test(textAfter))
	          return htmlMode.indent(state.htmlState, textAfter, line);
	        else if (state.localMode.indent)
	          return state.localMode.indent(state.localState, textAfter, line);
	        else
	          return CodeMirror.Pass;
	      },
	
	      innerMode: function (state) {
	        return {state: state.localState || state.htmlState, mode: state.localMode || htmlMode};
	      }
	    };
	  }, "xml", "javascript", "css");
	
	  CodeMirror.defineMIME("text/html", "htmlmixed");
	});


/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(78));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	var htmlConfig = {
	  autoSelfClosers: {'area': true, 'base': true, 'br': true, 'col': true, 'command': true,
	                    'embed': true, 'frame': true, 'hr': true, 'img': true, 'input': true,
	                    'keygen': true, 'link': true, 'meta': true, 'param': true, 'source': true,
	                    'track': true, 'wbr': true, 'menuitem': true},
	  implicitlyClosed: {'dd': true, 'li': true, 'optgroup': true, 'option': true, 'p': true,
	                     'rp': true, 'rt': true, 'tbody': true, 'td': true, 'tfoot': true,
	                     'th': true, 'tr': true},
	  contextGrabbers: {
	    'dd': {'dd': true, 'dt': true},
	    'dt': {'dd': true, 'dt': true},
	    'li': {'li': true},
	    'option': {'option': true, 'optgroup': true},
	    'optgroup': {'optgroup': true},
	    'p': {'address': true, 'article': true, 'aside': true, 'blockquote': true, 'dir': true,
	          'div': true, 'dl': true, 'fieldset': true, 'footer': true, 'form': true,
	          'h1': true, 'h2': true, 'h3': true, 'h4': true, 'h5': true, 'h6': true,
	          'header': true, 'hgroup': true, 'hr': true, 'menu': true, 'nav': true, 'ol': true,
	          'p': true, 'pre': true, 'section': true, 'table': true, 'ul': true},
	    'rp': {'rp': true, 'rt': true},
	    'rt': {'rp': true, 'rt': true},
	    'tbody': {'tbody': true, 'tfoot': true},
	    'td': {'td': true, 'th': true},
	    'tfoot': {'tbody': true},
	    'th': {'td': true, 'th': true},
	    'thead': {'tbody': true, 'tfoot': true},
	    'tr': {'tr': true}
	  },
	  doNotIndent: {"pre": true},
	  allowUnquoted: true,
	  allowMissing: true,
	  caseFold: true
	}
	
	var xmlConfig = {
	  autoSelfClosers: {},
	  implicitlyClosed: {},
	  contextGrabbers: {},
	  doNotIndent: {},
	  allowUnquoted: false,
	  allowMissing: false,
	  allowMissingTagName: false,
	  caseFold: false
	}
	
	CodeMirror.defineMode("xml", function(editorConf, config_) {
	  var indentUnit = editorConf.indentUnit
	  var config = {}
	  var defaults = config_.htmlMode ? htmlConfig : xmlConfig
	  for (var prop in defaults) config[prop] = defaults[prop]
	  for (var prop in config_) config[prop] = config_[prop]
	
	  // Return variables for tokenizers
	  var type, setStyle;
	
	  function inText(stream, state) {
	    function chain(parser) {
	      state.tokenize = parser;
	      return parser(stream, state);
	    }
	
	    var ch = stream.next();
	    if (ch == "<") {
	      if (stream.eat("!")) {
	        if (stream.eat("[")) {
	          if (stream.match("CDATA[")) return chain(inBlock("atom", "]]>"));
	          else return null;
	        } else if (stream.match("--")) {
	          return chain(inBlock("comment", "-->"));
	        } else if (stream.match("DOCTYPE", true, true)) {
	          stream.eatWhile(/[\w\._\-]/);
	          return chain(doctype(1));
	        } else {
	          return null;
	        }
	      } else if (stream.eat("?")) {
	        stream.eatWhile(/[\w\._\-]/);
	        state.tokenize = inBlock("meta", "?>");
	        return "meta";
	      } else {
	        type = stream.eat("/") ? "closeTag" : "openTag";
	        state.tokenize = inTag;
	        return "tag bracket";
	      }
	    } else if (ch == "&") {
	      var ok;
	      if (stream.eat("#")) {
	        if (stream.eat("x")) {
	          ok = stream.eatWhile(/[a-fA-F\d]/) && stream.eat(";");
	        } else {
	          ok = stream.eatWhile(/[\d]/) && stream.eat(";");
	        }
	      } else {
	        ok = stream.eatWhile(/[\w\.\-:]/) && stream.eat(";");
	      }
	      return ok ? "atom" : "error";
	    } else {
	      stream.eatWhile(/[^&<]/);
	      return null;
	    }
	  }
	  inText.isInText = true;
	
	  function inTag(stream, state) {
	    var ch = stream.next();
	    if (ch == ">" || (ch == "/" && stream.eat(">"))) {
	      state.tokenize = inText;
	      type = ch == ">" ? "endTag" : "selfcloseTag";
	      return "tag bracket";
	    } else if (ch == "=") {
	      type = "equals";
	      return null;
	    } else if (ch == "<") {
	      state.tokenize = inText;
	      state.state = baseState;
	      state.tagName = state.tagStart = null;
	      var next = state.tokenize(stream, state);
	      return next ? next + " tag error" : "tag error";
	    } else if (/[\'\"]/.test(ch)) {
	      state.tokenize = inAttribute(ch);
	      state.stringStartCol = stream.column();
	      return state.tokenize(stream, state);
	    } else {
	      stream.match(/^[^\s\u00a0=<>\"\']*[^\s\u00a0=<>\"\'\/]/);
	      return "word";
	    }
	  }
	
	  function inAttribute(quote) {
	    var closure = function(stream, state) {
	      while (!stream.eol()) {
	        if (stream.next() == quote) {
	          state.tokenize = inTag;
	          break;
	        }
	      }
	      return "string";
	    };
	    closure.isInAttribute = true;
	    return closure;
	  }
	
	  function inBlock(style, terminator) {
	    return function(stream, state) {
	      while (!stream.eol()) {
	        if (stream.match(terminator)) {
	          state.tokenize = inText;
	          break;
	        }
	        stream.next();
	      }
	      return style;
	    }
	  }
	
	  function doctype(depth) {
	    return function(stream, state) {
	      var ch;
	      while ((ch = stream.next()) != null) {
	        if (ch == "<") {
	          state.tokenize = doctype(depth + 1);
	          return state.tokenize(stream, state);
	        } else if (ch == ">") {
	          if (depth == 1) {
	            state.tokenize = inText;
	            break;
	          } else {
	            state.tokenize = doctype(depth - 1);
	            return state.tokenize(stream, state);
	          }
	        }
	      }
	      return "meta";
	    };
	  }
	
	  function lower(tagName) {
	    return tagName && tagName.toLowerCase();
	  }
	
	  function Context(state, tagName, startOfLine) {
	    this.prev = state.context;
	    this.tagName = tagName || "";
	    this.indent = state.indented;
	    this.startOfLine = startOfLine;
	    if (config.doNotIndent.hasOwnProperty(tagName) || (state.context && state.context.noIndent))
	      this.noIndent = true;
	  }
	  function popContext(state) {
	    if (state.context) state.context = state.context.prev;
	  }
	  function maybePopContext(state, nextTagName) {
	    var parentTagName;
	    while (true) {
	      if (!state.context) {
	        return;
	      }
	      parentTagName = state.context.tagName;
	      if (!config.contextGrabbers.hasOwnProperty(lower(parentTagName)) ||
	          !config.contextGrabbers[lower(parentTagName)].hasOwnProperty(lower(nextTagName))) {
	        return;
	      }
	      popContext(state);
	    }
	  }
	
	  function baseState(type, stream, state) {
	    if (type == "openTag") {
	      state.tagStart = stream.column();
	      return tagNameState;
	    } else if (type == "closeTag") {
	      return closeTagNameState;
	    } else {
	      return baseState;
	    }
	  }
	  function tagNameState(type, stream, state) {
	    if (type == "word") {
	      state.tagName = stream.current();
	      setStyle = "tag";
	      return attrState;
	    } else if (config.allowMissingTagName && type == "endTag") {
	      setStyle = "tag bracket";
	      return attrState(type, stream, state);
	    } else {
	      setStyle = "error";
	      return tagNameState;
	    }
	  }
	  function closeTagNameState(type, stream, state) {
	    if (type == "word") {
	      var tagName = stream.current();
	      if (state.context && state.context.tagName != tagName &&
	          config.implicitlyClosed.hasOwnProperty(lower(state.context.tagName)))
	        popContext(state);
	      if ((state.context && state.context.tagName == tagName) || config.matchClosing === false) {
	        setStyle = "tag";
	        return closeState;
	      } else {
	        setStyle = "tag error";
	        return closeStateErr;
	      }
	    } else if (config.allowMissingTagName && type == "endTag") {
	      setStyle = "tag bracket";
	      return closeState(type, stream, state);
	    } else {
	      setStyle = "error";
	      return closeStateErr;
	    }
	  }
	
	  function closeState(type, _stream, state) {
	    if (type != "endTag") {
	      setStyle = "error";
	      return closeState;
	    }
	    popContext(state);
	    return baseState;
	  }
	  function closeStateErr(type, stream, state) {
	    setStyle = "error";
	    return closeState(type, stream, state);
	  }
	
	  function attrState(type, _stream, state) {
	    if (type == "word") {
	      setStyle = "attribute";
	      return attrEqState;
	    } else if (type == "endTag" || type == "selfcloseTag") {
	      var tagName = state.tagName, tagStart = state.tagStart;
	      state.tagName = state.tagStart = null;
	      if (type == "selfcloseTag" ||
	          config.autoSelfClosers.hasOwnProperty(lower(tagName))) {
	        maybePopContext(state, tagName);
	      } else {
	        maybePopContext(state, tagName);
	        state.context = new Context(state, tagName, tagStart == state.indented);
	      }
	      return baseState;
	    }
	    setStyle = "error";
	    return attrState;
	  }
	  function attrEqState(type, stream, state) {
	    if (type == "equals") return attrValueState;
	    if (!config.allowMissing) setStyle = "error";
	    return attrState(type, stream, state);
	  }
	  function attrValueState(type, stream, state) {
	    if (type == "string") return attrContinuedState;
	    if (type == "word" && config.allowUnquoted) {setStyle = "string"; return attrState;}
	    setStyle = "error";
	    return attrState(type, stream, state);
	  }
	  function attrContinuedState(type, stream, state) {
	    if (type == "string") return attrContinuedState;
	    return attrState(type, stream, state);
	  }
	
	  return {
	    startState: function(baseIndent) {
	      var state = {tokenize: inText,
	                   state: baseState,
	                   indented: baseIndent || 0,
	                   tagName: null, tagStart: null,
	                   context: null}
	      if (baseIndent != null) state.baseIndent = baseIndent
	      return state
	    },
	
	    token: function(stream, state) {
	      if (!state.tagName && stream.sol())
	        state.indented = stream.indentation();
	
	      if (stream.eatSpace()) return null;
	      type = null;
	      var style = state.tokenize(stream, state);
	      if ((style || type) && style != "comment") {
	        setStyle = null;
	        state.state = state.state(type || style, stream, state);
	        if (setStyle)
	          style = setStyle == "error" ? style + " error" : setStyle;
	      }
	      return style;
	    },
	
	    indent: function(state, textAfter, fullLine) {
	      var context = state.context;
	      // Indent multi-line strings (e.g. css).
	      if (state.tokenize.isInAttribute) {
	        if (state.tagStart == state.indented)
	          return state.stringStartCol + 1;
	        else
	          return state.indented + indentUnit;
	      }
	      if (context && context.noIndent) return CodeMirror.Pass;
	      if (state.tokenize != inTag && state.tokenize != inText)
	        return fullLine ? fullLine.match(/^(\s*)/)[0].length : 0;
	      // Indent the starts of attribute names.
	      if (state.tagName) {
	        if (config.multilineTagIndentPastTag !== false)
	          return state.tagStart + state.tagName.length + 2;
	        else
	          return state.tagStart + indentUnit * (config.multilineTagIndentFactor || 1);
	      }
	      if (config.alignCDATA && /<!\[CDATA\[/.test(textAfter)) return 0;
	      var tagAfter = textAfter && /^<(\/)?([\w_:\.-]*)/.exec(textAfter);
	      if (tagAfter && tagAfter[1]) { // Closing tag spotted
	        while (context) {
	          if (context.tagName == tagAfter[2]) {
	            context = context.prev;
	            break;
	          } else if (config.implicitlyClosed.hasOwnProperty(lower(context.tagName))) {
	            context = context.prev;
	          } else {
	            break;
	          }
	        }
	      } else if (tagAfter) { // Opening tag spotted
	        while (context) {
	          var grabbers = config.contextGrabbers[lower(context.tagName)];
	          if (grabbers && grabbers.hasOwnProperty(lower(tagAfter[2])))
	            context = context.prev;
	          else
	            break;
	        }
	      }
	      while (context && context.prev && !context.startOfLine)
	        context = context.prev;
	      if (context) return context.indent + indentUnit;
	      else return state.baseIndent || 0;
	    },
	
	    electricInput: /<\/[\s\w:]+>$/,
	    blockCommentStart: "<!--",
	    blockCommentEnd: "-->",
	
	    configuration: config.htmlMode ? "html" : "xml",
	    helperType: config.htmlMode ? "html" : "xml",
	
	    skipAttribute: function(state) {
	      if (state.state == attrValueState)
	        state.state = attrState
	    },
	
	    xmlCurrentTag: function(state) {
	      return state.tagName ? {name: state.tagName, close: state.type == "closeTag"} : null
	    },
	
	    xmlCurrentContext: function(state) {
	      var context = []
	      for (var cx = state.context; cx; cx = cx.prev)
	        context.push(cx.tagName)
	      return context.reverse()
	    }
	  };
	});
	
	CodeMirror.defineMIME("text/xml", "xml");
	CodeMirror.defineMIME("application/xml", "xml");
	if (!CodeMirror.mimeModes.hasOwnProperty("text/html"))
	  CodeMirror.defineMIME("text/html", {name: "xml", htmlMode: true});
	
	});


/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	// -- Inlined from fbjs --
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function _invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var warning = function(){};
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	// /-- Inlined from fbjs --
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 612 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
	/** Types of elements found in htmlparser2's DOM */
	var ElementType;
	(function (ElementType) {
	    /** Type for the root element of a document */
	    ElementType["Root"] = "root";
	    /** Type for Text */
	    ElementType["Text"] = "text";
	    /** Type for <? ... ?> */
	    ElementType["Directive"] = "directive";
	    /** Type for <!-- ... --> */
	    ElementType["Comment"] = "comment";
	    /** Type for <script> tags */
	    ElementType["Script"] = "script";
	    /** Type for <style> tags */
	    ElementType["Style"] = "style";
	    /** Type for Any tag */
	    ElementType["Tag"] = "tag";
	    /** Type for <![CDATA[ ... ]]> */
	    ElementType["CDATA"] = "cdata";
	    /** Type for <!doctype ...> */
	    ElementType["Doctype"] = "doctype";
	})(ElementType = exports.ElementType || (exports.ElementType = {}));
	/**
	 * Tests whether an element is a tag or not.
	 *
	 * @param elem Element to test
	 */
	function isTag(elem) {
	    return (elem.type === ElementType.Tag ||
	        elem.type === ElementType.Script ||
	        elem.type === ElementType.Style);
	}
	exports.isTag = isTag;
	// Exports for backwards compatibility
	/** Type for the root element of a document */
	exports.Root = ElementType.Root;
	/** Type for Text */
	exports.Text = ElementType.Text;
	/** Type for <? ... ?> */
	exports.Directive = ElementType.Directive;
	/** Type for <!-- ... --> */
	exports.Comment = ElementType.Comment;
	/** Type for <script> tags */
	exports.Script = ElementType.Script;
	/** Type for <style> tags */
	exports.Style = ElementType.Style;
	/** Type for Any tag */
	exports.Tag = ElementType.Tag;
	/** Type for <![CDATA[ ... ]]> */
	exports.CDATA = ElementType.CDATA;
	/** Type for <!doctype ...> */
	exports.Doctype = ElementType.Doctype;


/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(615);
	var each = __webpack_require__(217).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(613);
	var Util = __webpack_require__(217);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ },
/* 615 */
/***/ function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(614);
	module.exports = new MediaQueryDispatch();


/***/ },
/* 617 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 618 */
137,
/* 619 */
137,
/* 620 */
137,
/* 621 */
137,
/* 622 */
137,
/* 623 */
137,
/* 624 */
137,
/* 625 */
137,
/* 626 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(626);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(636);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(27);
	
	var createArrayFromMixed = __webpack_require__(629);
	var getMarkupWrap = __webpack_require__(631);
	var invariant = __webpack_require__(11);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(27);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 632 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 633 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(633);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 635 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(635);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 637 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/firebase-logo.722d5e83.svg";

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/get-help.cdb033da.svg";

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/new-bg-1.bb057af9.svg";

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/orange-toggle.0e3dd14c.svg";

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/react-logo.ee7cd8ed.svg";

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	__webpack_require__(418);


/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	module.exports = __webpack_require__(419);


/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	__webpack_require__(453);


/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var firebase = __webpack_require__(222);
	__webpack_require__(643);
	__webpack_require__(644);
	__webpack_require__(647);
	__webpack_require__(648);
	
	module.exports = firebase;


/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	__webpack_require__(490);


/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	__webpack_require__(500);


/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(811)),valueEqual=_interopDefault(__webpack_require__(852));__webpack_require__(113);var invariant=_interopDefault(__webpack_require__(162));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(159);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 651 */
/***/ function(module, exports) {

	/**
	 * SVG elements are case-sensitive.
	 *
	 * @see {@link https://developer.mozilla.org/docs/Web/SVG/Element#SVG_elements_A_to_Z}
	 */
	var CASE_SENSITIVE_TAG_NAMES = [
	  'animateMotion',
	  'animateTransform',
	  'clipPath',
	  'feBlend',
	  'feColorMatrix',
	  'feComponentTransfer',
	  'feComposite',
	  'feConvolveMatrix',
	  'feDiffuseLighting',
	  'feDisplacementMap',
	  'feDropShadow',
	  'feFlood',
	  'feFuncA',
	  'feFuncB',
	  'feFuncG',
	  'feFuncR',
	  'feGaussainBlur',
	  'feImage',
	  'feMerge',
	  'feMergeNode',
	  'feMorphology',
	  'feOffset',
	  'fePointLight',
	  'feSpecularLighting',
	  'feSpotLight',
	  'feTile',
	  'feTurbulence',
	  'foreignObject',
	  'linearGradient',
	  'radialGradient',
	  'textPath'
	];
	
	module.exports = {
	  CASE_SENSITIVE_TAG_NAMES: CASE_SENSITIVE_TAG_NAMES
	};


/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	// constants
	var HTML = 'html';
	var HEAD = 'head';
	var BODY = 'body';
	var FIRST_TAG_REGEX = /<([a-zA-Z]+[0-9]?)/; // e.g., <h1>
	var HEAD_TAG_REGEX = /<head.*>/i;
	var BODY_TAG_REGEX = /<body.*>/i;
	
	// falls back to `parseFromString` if `createHTMLDocument` cannot be used
	var parseFromDocument = function () {
	  throw new Error(
	    'This browser does not support `document.implementation.createHTMLDocument`'
	  );
	};
	
	var parseFromString = function () {
	  throw new Error(
	    'This browser does not support `DOMParser.prototype.parseFromString`'
	  );
	};
	
	/**
	 * DOMParser (performance: slow).
	 *
	 * @see https://developer.mozilla.org/docs/Web/API/DOMParser#Parsing_an_SVG_or_HTML_document
	 */
	if (typeof window.DOMParser === 'function') {
	  var domParser = new window.DOMParser();
	  var mimeType = 'text/html';
	
	  /**
	   * Creates an HTML document using `DOMParser.parseFromString`.
	   *
	   * @param  {string} html      - The HTML string.
	   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
	   * @return {HTMLDocument}
	   */
	  parseFromString = function (html, tagName) {
	    if (tagName) {
	      html = '<' + tagName + '>' + html + '</' + tagName + '>';
	    }
	
	    return domParser.parseFromString(html, mimeType);
	  };
	
	  parseFromDocument = parseFromString;
	}
	
	/**
	 * DOMImplementation (performance: fair).
	 *
	 * @see https://developer.mozilla.org/docs/Web/API/DOMImplementation/createHTMLDocument
	 */
	if (document.implementation) {
	  var isIE = __webpack_require__(224).isIE;
	
	  // title parameter is required in IE
	  // https://msdn.microsoft.com/en-us/library/ff975457(v=vs.85).aspx
	  var doc = document.implementation.createHTMLDocument(
	    isIE() ? 'html-dom-parser' : undefined
	  );
	
	  /**
	   * Use HTML document created by `document.implementation.createHTMLDocument`.
	   *
	   * @param  {string} html      - The HTML string.
	   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
	   * @return {HTMLDocument}
	   */
	  parseFromDocument = function (html, tagName) {
	    if (tagName) {
	      doc.documentElement.getElementsByTagName(tagName)[0].innerHTML = html;
	      return doc;
	    }
	
	    doc.documentElement.innerHTML = html;
	    return doc;
	  };
	}
	
	/**
	 * Template (performance: fast).
	 *
	 * @see https://developer.mozilla.org/docs/Web/HTML/Element/template
	 */
	var template = document.createElement('template');
	var parseFromTemplate;
	
	if (template.content) {
	  /**
	   * Uses a template element (content fragment) to parse HTML.
	   *
	   * @param  {string} html - The HTML string.
	   * @return {NodeList}
	   */
	  parseFromTemplate = function (html) {
	    template.innerHTML = html;
	    return template.content.childNodes;
	  };
	}
	
	/**
	 * Parses HTML string to DOM nodes.
	 *
	 * @param  {string}   html - HTML markup.
	 * @return {NodeList}
	 */
	function domparser(html) {
	  var firstTagName;
	  var match = html.match(FIRST_TAG_REGEX);
	
	  if (match && match[1]) {
	    firstTagName = match[1].toLowerCase();
	  }
	
	  var doc;
	  var element;
	  var elements;
	
	  switch (firstTagName) {
	    case HTML:
	      doc = parseFromString(html);
	
	      // the created document may come with filler head/body elements,
	      // so make sure to remove them if they don't actually exist
	      if (!HEAD_TAG_REGEX.test(html)) {
	        element = doc.getElementsByTagName(HEAD)[0];
	        if (element) {
	          element.parentNode.removeChild(element);
	        }
	      }
	
	      if (!BODY_TAG_REGEX.test(html)) {
	        element = doc.getElementsByTagName(BODY)[0];
	        if (element) {
	          element.parentNode.removeChild(element);
	        }
	      }
	
	      return doc.getElementsByTagName(HTML);
	
	    case HEAD:
	    case BODY:
	      elements = parseFromDocument(html).getElementsByTagName(firstTagName);
	
	      // if there's a sibling element, then return both elements
	      if (BODY_TAG_REGEX.test(html) && HEAD_TAG_REGEX.test(html)) {
	        return elements[0].parentNode.childNodes;
	      }
	      return elements;
	
	    // low-level tag or text
	    default:
	      if (parseFromTemplate) {
	        return parseFromTemplate(html);
	      }
	
	      return parseFromDocument(html, BODY).getElementsByTagName(BODY)[0]
	        .childNodes;
	  }
	}
	
	module.exports = domparser;


/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	var domparser = __webpack_require__(652);
	var formatDOM = __webpack_require__(224).formatDOM;
	
	var DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/; // e.g., <!doctype html>
	
	/**
	 * Parses HTML string to DOM nodes in browser.
	 *
	 * @param  {string} html  - HTML markup.
	 * @return {DomElement[]} - DOM elements.
	 */
	function HTMLDOMParser(html) {
	  if (typeof html !== 'string') {
	    throw new TypeError('First argument must be a string');
	  }
	
	  if (html === '') {
	    return [];
	  }
	
	  // match directive
	  var match = html.match(DIRECTIVE_REGEX);
	  var directive;
	
	  if (match && match[1]) {
	    directive = match[1];
	  }
	
	  return formatDOM(domparser(html), null, directive);
	}
	
	module.exports = HTMLDOMParser;


/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	var domToReact = __webpack_require__(655);
	var attributesToProps = __webpack_require__(225);
	var htmlToDOM = __webpack_require__(653);
	
	// support backwards compatibility for ES Module
	htmlToDOM =
	  /* istanbul ignore next */
	  typeof htmlToDOM.default === 'function' ? htmlToDOM.default : htmlToDOM;
	
	var domParserOptions = { lowerCaseAttributeNames: false };
	
	/**
	 * Converts HTML string to React elements.
	 *
	 * @param  {String}   html                    - HTML string.
	 * @param  {Object}   [options]               - Parser options.
	 * @param  {Object}   [options.htmlparser2]   - htmlparser2 options.
	 * @param  {Object}   [options.library]       - Library for React, Preact, etc.
	 * @param  {Function} [options.replace]       - Replace method.
	 * @return {JSX.Element|JSX.Element[]|String} - React element(s), empty array, or string.
	 */
	function HTMLReactParser(html, options) {
	  if (typeof html !== 'string') {
	    throw new TypeError('First argument must be a string');
	  }
	  if (html === '') {
	    return [];
	  }
	  options = options || {};
	  return domToReact(
	    htmlToDOM(html, options.htmlparser2 || domParserOptions),
	    options
	  );
	}
	
	HTMLReactParser.domToReact = domToReact;
	HTMLReactParser.htmlToDOM = htmlToDOM;
	HTMLReactParser.attributesToProps = attributesToProps;
	HTMLReactParser.Element = __webpack_require__(216).Element;
	
	// support CommonJS and ES Modules
	module.exports = HTMLReactParser;
	module.exports.default = HTMLReactParser;


/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(3);
	var attributesToProps = __webpack_require__(225);
	var utilities = __webpack_require__(226);
	
	var setStyleProp = utilities.setStyleProp;
	var canTextBeChildOfNode = utilities.canTextBeChildOfNode;
	
	/**
	 * Converts DOM nodes to JSX element(s).
	 *
	 * @param  {DomElement[]} nodes             - DOM nodes.
	 * @param  {object}       [options={}]      - Options.
	 * @param  {Function}     [options.replace] - Replacer.
	 * @param  {object}       [options.library] - Library (React/Preact/etc.).
	 * @return {string|JSX.Element|JSX.Element[]}
	 */
	function domToReact(nodes, options) {
	  options = options || {};
	
	  var library = options.library || React;
	  var cloneElement = library.cloneElement;
	  var createElement = library.createElement;
	  var isValidElement = library.isValidElement;
	
	  var result = [];
	  var node;
	  var isWhitespace;
	  var hasReplace = typeof options.replace === 'function';
	  var replaceElement;
	  var props;
	  var children;
	  var trim = options.trim;
	
	  for (var i = 0, len = nodes.length; i < len; i++) {
	    node = nodes[i];
	
	    // replace with custom React element (if present)
	    if (hasReplace) {
	      replaceElement = options.replace(node);
	
	      if (isValidElement(replaceElement)) {
	        // set "key" prop for sibling elements
	        // https://fb.me/react-warning-keys
	        if (len > 1) {
	          replaceElement = cloneElement(replaceElement, {
	            key: replaceElement.key || i
	          });
	        }
	        result.push(replaceElement);
	        continue;
	      }
	    }
	
	    if (node.type === 'text') {
	      isWhitespace = !node.data.trim().length;
	
	      if (isWhitespace && node.parent && !canTextBeChildOfNode(node.parent)) {
	        // We have a whitespace node that can't be nested in its parent
	        // so skip it
	        continue;
	      }
	
	      if (trim && isWhitespace) {
	        // Trim is enabled and we have a whitespace node
	        // so skip it
	        continue;
	      }
	
	      // We have a text node that's not whitespace and it can be nested
	      // in its parent so add it to the results
	      result.push(node.data);
	      continue;
	    }
	
	    props = node.attribs;
	    if (skipAttributesToProps(node)) {
	      setStyleProp(props.style, props);
	    } else if (props) {
	      props = attributesToProps(props);
	    }
	
	    children = null;
	
	    switch (node.type) {
	      case 'script':
	      case 'style':
	        // prevent text in <script> or <style> from being escaped
	        // https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
	        if (node.children[0]) {
	          props.dangerouslySetInnerHTML = {
	            __html: node.children[0].data
	          };
	        }
	        break;
	
	      case 'tag':
	        // setting textarea value in children is an antipattern in React
	        // https://reactjs.org/docs/forms.html#the-textarea-tag
	        if (node.name === 'textarea' && node.children[0]) {
	          props.defaultValue = node.children[0].data;
	        } else if (node.children && node.children.length) {
	          // continue recursion of creating React elements (if applicable)
	          children = domToReact(node.children, options);
	        }
	        break;
	
	      // skip all other cases (e.g., comment)
	      default:
	        continue;
	    }
	
	    // set "key" prop for sibling elements
	    // https://fb.me/react-warning-keys
	    if (len > 1) {
	      props.key = i;
	    }
	
	    result.push(createElement(node.name, props, children));
	  }
	
	  return result.length === 1 ? result[0] : result;
	}
	
	/**
	 * Determines whether DOM element attributes should be transformed to props.
	 * Web Components should not have their attributes transformed except for `style`.
	 *
	 * @param  {DomElement} node
	 * @return {boolean}
	 */
	function skipAttributesToProps(node) {
	  return (
	    utilities.PRESERVE_CUSTOM_ATTRIBUTES &&
	    node.type === 'tag' &&
	    utilities.isCustomComponent(node.name, node.attribs)
	  );
	}
	
	module.exports = domToReact;


/***/ },
/* 656 */
/***/ function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 657 */
/***/ function(module, exports) {

	// http://www.w3.org/TR/CSS21/grammar.html
	// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
	var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
	
	var NEWLINE_REGEX = /\n/g;
	var WHITESPACE_REGEX = /^\s*/;
	
	// declaration
	var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
	var COLON_REGEX = /^:\s*/;
	var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
	var SEMICOLON_REGEX = /^[;\s]*/;
	
	// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
	var TRIM_REGEX = /^\s+|\s+$/g;
	
	// strings
	var NEWLINE = '\n';
	var FORWARD_SLASH = '/';
	var ASTERISK = '*';
	var EMPTY_STRING = '';
	
	// types
	var TYPE_COMMENT = 'comment';
	var TYPE_DECLARATION = 'declaration';
	
	/**
	 * @param {String} style
	 * @param {Object} [options]
	 * @return {Object[]}
	 * @throws {TypeError}
	 * @throws {Error}
	 */
	module.exports = function(style, options) {
	  if (typeof style !== 'string') {
	    throw new TypeError('First argument must be a string');
	  }
	
	  if (!style) return [];
	
	  options = options || {};
	
	  /**
	   * Positional.
	   */
	  var lineno = 1;
	  var column = 1;
	
	  /**
	   * Update lineno and column based on `str`.
	   *
	   * @param {String} str
	   */
	  function updatePosition(str) {
	    var lines = str.match(NEWLINE_REGEX);
	    if (lines) lineno += lines.length;
	    var i = str.lastIndexOf(NEWLINE);
	    column = ~i ? str.length - i : column + str.length;
	  }
	
	  /**
	   * Mark position and patch `node.position`.
	   *
	   * @return {Function}
	   */
	  function position() {
	    var start = { line: lineno, column: column };
	    return function(node) {
	      node.position = new Position(start);
	      whitespace();
	      return node;
	    };
	  }
	
	  /**
	   * Store position information for a node.
	   *
	   * @constructor
	   * @property {Object} start
	   * @property {Object} end
	   * @property {undefined|String} source
	   */
	  function Position(start) {
	    this.start = start;
	    this.end = { line: lineno, column: column };
	    this.source = options.source;
	  }
	
	  /**
	   * Non-enumerable source string.
	   */
	  Position.prototype.content = style;
	
	  var errorsList = [];
	
	  /**
	   * Error `msg`.
	   *
	   * @param {String} msg
	   * @throws {Error}
	   */
	  function error(msg) {
	    var err = new Error(
	      options.source + ':' + lineno + ':' + column + ': ' + msg
	    );
	    err.reason = msg;
	    err.filename = options.source;
	    err.line = lineno;
	    err.column = column;
	    err.source = style;
	
	    if (options.silent) {
	      errorsList.push(err);
	    } else {
	      throw err;
	    }
	  }
	
	  /**
	   * Match `re` and return captures.
	   *
	   * @param {RegExp} re
	   * @return {undefined|Array}
	   */
	  function match(re) {
	    var m = re.exec(style);
	    if (!m) return;
	    var str = m[0];
	    updatePosition(str);
	    style = style.slice(str.length);
	    return m;
	  }
	
	  /**
	   * Parse whitespace.
	   */
	  function whitespace() {
	    match(WHITESPACE_REGEX);
	  }
	
	  /**
	   * Parse comments.
	   *
	   * @param {Object[]} [rules]
	   * @return {Object[]}
	   */
	  function comments(rules) {
	    var c;
	    rules = rules || [];
	    while ((c = comment())) {
	      if (c !== false) {
	        rules.push(c);
	      }
	    }
	    return rules;
	  }
	
	  /**
	   * Parse comment.
	   *
	   * @return {Object}
	   * @throws {Error}
	   */
	  function comment() {
	    var pos = position();
	    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;
	
	    var i = 2;
	    while (
	      EMPTY_STRING != style.charAt(i) &&
	      (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))
	    ) {
	      ++i;
	    }
	    i += 2;
	
	    if (EMPTY_STRING === style.charAt(i - 1)) {
	      return error('End of comment missing');
	    }
	
	    var str = style.slice(2, i - 2);
	    column += 2;
	    updatePosition(str);
	    style = style.slice(i);
	    column += 2;
	
	    return pos({
	      type: TYPE_COMMENT,
	      comment: str
	    });
	  }
	
	  /**
	   * Parse declaration.
	   *
	   * @return {Object}
	   * @throws {Error}
	   */
	  function declaration() {
	    var pos = position();
	
	    // prop
	    var prop = match(PROPERTY_REGEX);
	    if (!prop) return;
	    comment();
	
	    // :
	    if (!match(COLON_REGEX)) return error("property missing ':'");
	
	    // val
	    var val = match(VALUE_REGEX);
	
	    var ret = pos({
	      type: TYPE_DECLARATION,
	      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
	      value: val
	        ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING))
	        : EMPTY_STRING
	    });
	
	    // ;
	    match(SEMICOLON_REGEX);
	
	    return ret;
	  }
	
	  /**
	   * Parse declarations.
	   *
	   * @return {Object[]}
	   */
	  function declarations() {
	    var decls = [];
	
	    comments(decls);
	
	    // declarations
	    var decl;
	    while ((decl = declaration())) {
	      if (decl !== false) {
	        decls.push(decl);
	        comments(decls);
	      }
	    }
	
	    return decls;
	  }
	
	  whitespace();
	  return declarations();
	};
	
	/**
	 * Trim `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 */
	function trim(str) {
	  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
	}


/***/ },
/* 658 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 659 */
/***/ function(module, exports) {

	module.exports = {
		"elementNames": {
			"altglyph": "altGlyph",
			"altglyphdef": "altGlyphDef",
			"altglyphitem": "altGlyphItem",
			"animatecolor": "animateColor",
			"animatemotion": "animateMotion",
			"animatetransform": "animateTransform",
			"clippath": "clipPath",
			"feblend": "feBlend",
			"fecolormatrix": "feColorMatrix",
			"fecomponenttransfer": "feComponentTransfer",
			"fecomposite": "feComposite",
			"feconvolvematrix": "feConvolveMatrix",
			"fediffuselighting": "feDiffuseLighting",
			"fedisplacementmap": "feDisplacementMap",
			"fedistantlight": "feDistantLight",
			"fedropshadow": "feDropShadow",
			"feflood": "feFlood",
			"fefunca": "feFuncA",
			"fefuncb": "feFuncB",
			"fefuncg": "feFuncG",
			"fefuncr": "feFuncR",
			"fegaussianblur": "feGaussianBlur",
			"feimage": "feImage",
			"femerge": "feMerge",
			"femergenode": "feMergeNode",
			"femorphology": "feMorphology",
			"feoffset": "feOffset",
			"fepointlight": "fePointLight",
			"fespecularlighting": "feSpecularLighting",
			"fespotlight": "feSpotLight",
			"fetile": "feTile",
			"feturbulence": "feTurbulence",
			"foreignobject": "foreignObject",
			"glyphref": "glyphRef",
			"lineargradient": "linearGradient",
			"radialgradient": "radialGradient",
			"textpath": "textPath"
		},
		"attributeNames": {
			"definitionurl": "definitionURL",
			"attributename": "attributeName",
			"attributetype": "attributeType",
			"basefrequency": "baseFrequency",
			"baseprofile": "baseProfile",
			"calcmode": "calcMode",
			"clippathunits": "clipPathUnits",
			"diffuseconstant": "diffuseConstant",
			"edgemode": "edgeMode",
			"filterunits": "filterUnits",
			"glyphref": "glyphRef",
			"gradienttransform": "gradientTransform",
			"gradientunits": "gradientUnits",
			"kernelmatrix": "kernelMatrix",
			"kernelunitlength": "kernelUnitLength",
			"keypoints": "keyPoints",
			"keysplines": "keySplines",
			"keytimes": "keyTimes",
			"lengthadjust": "lengthAdjust",
			"limitingconeangle": "limitingConeAngle",
			"markerheight": "markerHeight",
			"markerunits": "markerUnits",
			"markerwidth": "markerWidth",
			"maskcontentunits": "maskContentUnits",
			"maskunits": "maskUnits",
			"numoctaves": "numOctaves",
			"pathlength": "pathLength",
			"patterncontentunits": "patternContentUnits",
			"patterntransform": "patternTransform",
			"patternunits": "patternUnits",
			"pointsatx": "pointsAtX",
			"pointsaty": "pointsAtY",
			"pointsatz": "pointsAtZ",
			"preservealpha": "preserveAlpha",
			"preserveaspectratio": "preserveAspectRatio",
			"primitiveunits": "primitiveUnits",
			"refx": "refX",
			"refy": "refY",
			"repeatcount": "repeatCount",
			"repeatdur": "repeatDur",
			"requiredextensions": "requiredExtensions",
			"requiredfeatures": "requiredFeatures",
			"specularconstant": "specularConstant",
			"specularexponent": "specularExponent",
			"spreadmethod": "spreadMethod",
			"startoffset": "startOffset",
			"stddeviation": "stdDeviation",
			"stitchtiles": "stitchTiles",
			"surfacescale": "surfaceScale",
			"systemlanguage": "systemLanguage",
			"tablevalues": "tableValues",
			"targetx": "targetX",
			"targety": "targetY",
			"textlength": "textLength",
			"viewbox": "viewBox",
			"viewtarget": "viewTarget",
			"xchannelselector": "xChannelSelector",
			"ychannelselector": "yChannelSelector",
			"zoomandpan": "zoomAndPan"
		}
	};

/***/ },
/* 660 */
/***/ function(module, exports) {

	module.exports = {
		"0": 65533,
		"128": 8364,
		"130": 8218,
		"131": 402,
		"132": 8222,
		"133": 8230,
		"134": 8224,
		"135": 8225,
		"136": 710,
		"137": 8240,
		"138": 352,
		"139": 8249,
		"140": 338,
		"142": 381,
		"145": 8216,
		"146": 8217,
		"147": 8220,
		"148": 8221,
		"149": 8226,
		"150": 8211,
		"151": 8212,
		"152": 732,
		"153": 8482,
		"154": 353,
		"155": 8250,
		"156": 339,
		"158": 382,
		"159": 376
	};

/***/ },
/* 661 */
/***/ function(module, exports) {

	module.exports = {
		"Aacute": "Á",
		"aacute": "á",
		"Acirc": "Â",
		"acirc": "â",
		"acute": "´",
		"AElig": "Æ",
		"aelig": "æ",
		"Agrave": "À",
		"agrave": "à",
		"amp": "&",
		"AMP": "&",
		"Aring": "Å",
		"aring": "å",
		"Atilde": "Ã",
		"atilde": "ã",
		"Auml": "Ä",
		"auml": "ä",
		"brvbar": "¦",
		"Ccedil": "Ç",
		"ccedil": "ç",
		"cedil": "¸",
		"cent": "¢",
		"copy": "©",
		"COPY": "©",
		"curren": "¤",
		"deg": "°",
		"divide": "÷",
		"Eacute": "É",
		"eacute": "é",
		"Ecirc": "Ê",
		"ecirc": "ê",
		"Egrave": "È",
		"egrave": "è",
		"ETH": "Ð",
		"eth": "ð",
		"Euml": "Ë",
		"euml": "ë",
		"frac12": "½",
		"frac14": "¼",
		"frac34": "¾",
		"gt": ">",
		"GT": ">",
		"Iacute": "Í",
		"iacute": "í",
		"Icirc": "Î",
		"icirc": "î",
		"iexcl": "¡",
		"Igrave": "Ì",
		"igrave": "ì",
		"iquest": "¿",
		"Iuml": "Ï",
		"iuml": "ï",
		"laquo": "«",
		"lt": "<",
		"LT": "<",
		"macr": "¯",
		"micro": "µ",
		"middot": "·",
		"nbsp": " ",
		"not": "¬",
		"Ntilde": "Ñ",
		"ntilde": "ñ",
		"Oacute": "Ó",
		"oacute": "ó",
		"Ocirc": "Ô",
		"ocirc": "ô",
		"Ograve": "Ò",
		"ograve": "ò",
		"ordf": "ª",
		"ordm": "º",
		"Oslash": "Ø",
		"oslash": "ø",
		"Otilde": "Õ",
		"otilde": "õ",
		"Ouml": "Ö",
		"ouml": "ö",
		"para": "¶",
		"plusmn": "±",
		"pound": "£",
		"quot": "\"",
		"QUOT": "\"",
		"raquo": "»",
		"reg": "®",
		"REG": "®",
		"sect": "§",
		"shy": "­",
		"sup1": "¹",
		"sup2": "²",
		"sup3": "³",
		"szlig": "ß",
		"THORN": "Þ",
		"thorn": "þ",
		"times": "×",
		"Uacute": "Ú",
		"uacute": "ú",
		"Ucirc": "Û",
		"ucirc": "û",
		"Ugrave": "Ù",
		"ugrave": "ù",
		"uml": "¨",
		"Uuml": "Ü",
		"uuml": "ü",
		"Yacute": "Ý",
		"yacute": "ý",
		"yen": "¥",
		"yuml": "ÿ"
	};

/***/ },
/* 662 */
660,
/* 663 */
227,
/* 664 */
661,
/* 665 */
228,
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(814);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ },
/* 667 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';var React=__webpack_require__(3),_inheritsLoose=__webpack_require__(415),PropTypes=__webpack_require__(38),warning=__webpack_require__(113);function _interopDefaultLegacy(e){return e&&typeof e==='object'&&'default'in e?e:{'default':e}}var React__default=/*#__PURE__*/_interopDefaultLegacy(React);var _inheritsLoose__default=/*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);var PropTypes__default=/*#__PURE__*/_interopDefaultLegacy(PropTypes);var warning__default=/*#__PURE__*/_interopDefaultLegacy(warning);var MAX_SIGNED_31_BIT_INT = 1073741823;
	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};
	
	function getUniqueId() {
	  var key = '__global_unique_id__';
	  return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
	}
	
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + getUniqueId() + '__';
	
	  var Provider = /*#__PURE__*/function (_Component) {
	    _inheritsLoose__default['default'](Provider, _Component);
	
	    function Provider() {
	      var _this;
	
	      _this = _Component.apply(this, arguments) || this;
	      _this.emitter = createEventEmitter(_this.props.value);
	      return _this;
	    }
	
	    var _proto = Provider.prototype;
	
	    _proto.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0;
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	
	          if (false) {
	            warning__default['default']((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    _proto.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(React.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = PropTypes__default['default'].object.isRequired, _Provider$childContex);
	
	  var Consumer = /*#__PURE__*/function (_Component2) {
	    _inheritsLoose__default['default'](Consumer, _Component2);
	
	    function Consumer() {
	      var _this2;
	
	      _this2 = _Component2.apply(this, arguments) || this;
	      _this2.state = {
	        value: _this2.getValue()
	      };
	
	      _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({
	            value: _this2.getValue()
	          });
	        }
	      };
	
	      return _this2;
	    }
	
	    var _proto2 = Consumer.prototype;
	
	    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
	    };
	
	    _proto2.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	
	      var observedBits = this.props.observedBits;
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
	    };
	
	    _proto2.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    _proto2.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    _proto2.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(React.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = PropTypes__default['default'].object, _Consumer$contextType);
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}var index = React__default['default'].createContext || createReactContext;module.exports=index;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 229,
		"./af.js": 229,
		"./ar": 236,
		"./ar-dz": 230,
		"./ar-dz.js": 230,
		"./ar-kw": 231,
		"./ar-kw.js": 231,
		"./ar-ly": 232,
		"./ar-ly.js": 232,
		"./ar-ma": 233,
		"./ar-ma.js": 233,
		"./ar-sa": 234,
		"./ar-sa.js": 234,
		"./ar-tn": 235,
		"./ar-tn.js": 235,
		"./ar.js": 236,
		"./az": 237,
		"./az.js": 237,
		"./be": 238,
		"./be.js": 238,
		"./bg": 239,
		"./bg.js": 239,
		"./bm": 240,
		"./bm.js": 240,
		"./bn": 242,
		"./bn-bd": 241,
		"./bn-bd.js": 241,
		"./bn.js": 242,
		"./bo": 243,
		"./bo.js": 243,
		"./br": 244,
		"./br.js": 244,
		"./bs": 245,
		"./bs.js": 245,
		"./ca": 246,
		"./ca.js": 246,
		"./cs": 247,
		"./cs.js": 247,
		"./cv": 248,
		"./cv.js": 248,
		"./cy": 249,
		"./cy.js": 249,
		"./da": 250,
		"./da.js": 250,
		"./de": 253,
		"./de-at": 251,
		"./de-at.js": 251,
		"./de-ch": 252,
		"./de-ch.js": 252,
		"./de.js": 253,
		"./dv": 254,
		"./dv.js": 254,
		"./el": 255,
		"./el.js": 255,
		"./en-au": 256,
		"./en-au.js": 256,
		"./en-ca": 257,
		"./en-ca.js": 257,
		"./en-gb": 258,
		"./en-gb.js": 258,
		"./en-ie": 259,
		"./en-ie.js": 259,
		"./en-il": 260,
		"./en-il.js": 260,
		"./en-in": 261,
		"./en-in.js": 261,
		"./en-nz": 262,
		"./en-nz.js": 262,
		"./en-sg": 263,
		"./en-sg.js": 263,
		"./eo": 264,
		"./eo.js": 264,
		"./es": 268,
		"./es-do": 265,
		"./es-do.js": 265,
		"./es-mx": 266,
		"./es-mx.js": 266,
		"./es-us": 267,
		"./es-us.js": 267,
		"./es.js": 268,
		"./et": 269,
		"./et.js": 269,
		"./eu": 270,
		"./eu.js": 270,
		"./fa": 271,
		"./fa.js": 271,
		"./fi": 272,
		"./fi.js": 272,
		"./fil": 273,
		"./fil.js": 273,
		"./fo": 274,
		"./fo.js": 274,
		"./fr": 277,
		"./fr-ca": 275,
		"./fr-ca.js": 275,
		"./fr-ch": 276,
		"./fr-ch.js": 276,
		"./fr.js": 277,
		"./fy": 278,
		"./fy.js": 278,
		"./ga": 279,
		"./ga.js": 279,
		"./gd": 280,
		"./gd.js": 280,
		"./gl": 281,
		"./gl.js": 281,
		"./gom-deva": 282,
		"./gom-deva.js": 282,
		"./gom-latn": 283,
		"./gom-latn.js": 283,
		"./gu": 284,
		"./gu.js": 284,
		"./he": 285,
		"./he.js": 285,
		"./hi": 286,
		"./hi.js": 286,
		"./hr": 287,
		"./hr.js": 287,
		"./hu": 288,
		"./hu.js": 288,
		"./hy-am": 289,
		"./hy-am.js": 289,
		"./id": 290,
		"./id.js": 290,
		"./is": 291,
		"./is.js": 291,
		"./it": 293,
		"./it-ch": 292,
		"./it-ch.js": 292,
		"./it.js": 293,
		"./ja": 294,
		"./ja.js": 294,
		"./jv": 295,
		"./jv.js": 295,
		"./ka": 296,
		"./ka.js": 296,
		"./kk": 297,
		"./kk.js": 297,
		"./km": 298,
		"./km.js": 298,
		"./kn": 299,
		"./kn.js": 299,
		"./ko": 300,
		"./ko.js": 300,
		"./ku": 301,
		"./ku.js": 301,
		"./ky": 302,
		"./ky.js": 302,
		"./lb": 303,
		"./lb.js": 303,
		"./lo": 304,
		"./lo.js": 304,
		"./lt": 305,
		"./lt.js": 305,
		"./lv": 306,
		"./lv.js": 306,
		"./me": 307,
		"./me.js": 307,
		"./mi": 308,
		"./mi.js": 308,
		"./mk": 309,
		"./mk.js": 309,
		"./ml": 310,
		"./ml.js": 310,
		"./mn": 311,
		"./mn.js": 311,
		"./mr": 312,
		"./mr.js": 312,
		"./ms": 314,
		"./ms-my": 313,
		"./ms-my.js": 313,
		"./ms.js": 314,
		"./mt": 315,
		"./mt.js": 315,
		"./my": 316,
		"./my.js": 316,
		"./nb": 317,
		"./nb.js": 317,
		"./ne": 318,
		"./ne.js": 318,
		"./nl": 320,
		"./nl-be": 319,
		"./nl-be.js": 319,
		"./nl.js": 320,
		"./nn": 321,
		"./nn.js": 321,
		"./oc-lnc": 322,
		"./oc-lnc.js": 322,
		"./pa-in": 323,
		"./pa-in.js": 323,
		"./pl": 324,
		"./pl.js": 324,
		"./pt": 326,
		"./pt-br": 325,
		"./pt-br.js": 325,
		"./pt.js": 326,
		"./ro": 327,
		"./ro.js": 327,
		"./ru": 328,
		"./ru.js": 328,
		"./sd": 329,
		"./sd.js": 329,
		"./se": 330,
		"./se.js": 330,
		"./si": 331,
		"./si.js": 331,
		"./sk": 332,
		"./sk.js": 332,
		"./sl": 333,
		"./sl.js": 333,
		"./sq": 334,
		"./sq.js": 334,
		"./sr": 336,
		"./sr-cyrl": 335,
		"./sr-cyrl.js": 335,
		"./sr.js": 336,
		"./ss": 337,
		"./ss.js": 337,
		"./sv": 338,
		"./sv.js": 338,
		"./sw": 339,
		"./sw.js": 339,
		"./ta": 340,
		"./ta.js": 340,
		"./te": 341,
		"./te.js": 341,
		"./tet": 342,
		"./tet.js": 342,
		"./tg": 343,
		"./tg.js": 343,
		"./th": 344,
		"./th.js": 344,
		"./tk": 345,
		"./tk.js": 345,
		"./tl-ph": 346,
		"./tl-ph.js": 346,
		"./tlh": 347,
		"./tlh.js": 347,
		"./tr": 348,
		"./tr.js": 348,
		"./tzl": 349,
		"./tzl.js": 349,
		"./tzm": 351,
		"./tzm-latn": 350,
		"./tzm-latn.js": 350,
		"./tzm.js": 351,
		"./ug-cn": 352,
		"./ug-cn.js": 352,
		"./uk": 353,
		"./uk.js": 353,
		"./ur": 354,
		"./ur.js": 354,
		"./uz": 356,
		"./uz-latn": 355,
		"./uz-latn.js": 355,
		"./uz.js": 356,
		"./vi": 357,
		"./vi.js": 357,
		"./x-pseudo": 358,
		"./x-pseudo.js": 358,
		"./yo": 359,
		"./yo.js": 359,
		"./zh-cn": 360,
		"./zh-cn.js": 360,
		"./zh-hk": 361,
		"./zh-hk.js": 361,
		"./zh-mo": 362,
		"./zh-mo.js": 362,
		"./zh-tw": 363,
		"./zh-tw.js": 363
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 669;


/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {(function (root) {
	
	  // Store setTimeout reference so promise-polyfill will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var setTimeoutFunc = setTimeout;
	
	  function noop() {}
	  
	  // Polyfill for Function.prototype.bind
	  function bind(fn, thisArg) {
	    return function () {
	      fn.apply(thisArg, arguments);
	    };
	  }
	
	  function Promise(fn) {
	    if (!(this instanceof Promise)) throw new TypeError('Promises must be constructed via new');
	    if (typeof fn !== 'function') throw new TypeError('not a function');
	    this._state = 0;
	    this._handled = false;
	    this._value = undefined;
	    this._deferreds = [];
	
	    doResolve(fn, this);
	  }
	
	  function handle(self, deferred) {
	    while (self._state === 3) {
	      self = self._value;
	    }
	    if (self._state === 0) {
	      self._deferreds.push(deferred);
	      return;
	    }
	    self._handled = true;
	    Promise._immediateFn(function () {
	      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
	      if (cb === null) {
	        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
	        return;
	      }
	      var ret;
	      try {
	        ret = cb(self._value);
	      } catch (e) {
	        reject(deferred.promise, e);
	        return;
	      }
	      resolve(deferred.promise, ret);
	    });
	  }
	
	  function resolve(self, newValue) {
	    try {
	      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
	      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
	        var then = newValue.then;
	        if (newValue instanceof Promise) {
	          self._state = 3;
	          self._value = newValue;
	          finale(self);
	          return;
	        } else if (typeof then === 'function') {
	          doResolve(bind(then, newValue), self);
	          return;
	        }
	      }
	      self._state = 1;
	      self._value = newValue;
	      finale(self);
	    } catch (e) {
	      reject(self, e);
	    }
	  }
	
	  function reject(self, newValue) {
	    self._state = 2;
	    self._value = newValue;
	    finale(self);
	  }
	
	  function finale(self) {
	    if (self._state === 2 && self._deferreds.length === 0) {
	      Promise._immediateFn(function() {
	        if (!self._handled) {
	          Promise._unhandledRejectionFn(self._value);
	        }
	      });
	    }
	
	    for (var i = 0, len = self._deferreds.length; i < len; i++) {
	      handle(self, self._deferreds[i]);
	    }
	    self._deferreds = null;
	  }
	
	  function Handler(onFulfilled, onRejected, promise) {
	    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	    this.promise = promise;
	  }
	
	  /**
	   * Take a potentially misbehaving resolver function and make sure
	   * onFulfilled and onRejected are only called once.
	   *
	   * Makes no guarantees about asynchrony.
	   */
	  function doResolve(fn, self) {
	    var done = false;
	    try {
	      fn(function (value) {
	        if (done) return;
	        done = true;
	        resolve(self, value);
	      }, function (reason) {
	        if (done) return;
	        done = true;
	        reject(self, reason);
	      });
	    } catch (ex) {
	      if (done) return;
	      done = true;
	      reject(self, ex);
	    }
	  }
	
	  Promise.prototype['catch'] = function (onRejected) {
	    return this.then(null, onRejected);
	  };
	
	  Promise.prototype.then = function (onFulfilled, onRejected) {
	    var prom = new (this.constructor)(noop);
	
	    handle(this, new Handler(onFulfilled, onRejected, prom));
	    return prom;
	  };
	
	  Promise.all = function (arr) {
	    return new Promise(function (resolve, reject) {
	      if (!arr || typeof arr.length === 'undefined') throw new TypeError('Promise.all accepts an array');
	      var args = Array.prototype.slice.call(arr);
	      if (args.length === 0) return resolve([]);
	      var remaining = args.length;
	
	      function res(i, val) {
	        try {
	          if (val && (typeof val === 'object' || typeof val === 'function')) {
	            var then = val.then;
	            if (typeof then === 'function') {
	              then.call(val, function (val) {
	                res(i, val);
	              }, reject);
	              return;
	            }
	          }
	          args[i] = val;
	          if (--remaining === 0) {
	            resolve(args);
	          }
	        } catch (ex) {
	          reject(ex);
	        }
	      }
	
	      for (var i = 0; i < args.length; i++) {
	        res(i, args[i]);
	      }
	    });
	  };
	
	  Promise.resolve = function (value) {
	    if (value && typeof value === 'object' && value.constructor === Promise) {
	      return value;
	    }
	
	    return new Promise(function (resolve) {
	      resolve(value);
	    });
	  };
	
	  Promise.reject = function (value) {
	    return new Promise(function (resolve, reject) {
	      reject(value);
	    });
	  };
	
	  Promise.race = function (values) {
	    return new Promise(function (resolve, reject) {
	      for (var i = 0, len = values.length; i < len; i++) {
	        values[i].then(resolve, reject);
	      }
	    });
	  };
	
	  // Use polyfill for setImmediate for performance gains
	  Promise._immediateFn = (typeof setImmediate === 'function' && function (fn) { setImmediate(fn); }) ||
	    function (fn) {
	      setTimeoutFunc(fn, 0);
	    };
	
	  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
	    if (typeof console !== 'undefined' && console) {
	      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
	    }
	  };
	
	  /**
	   * Set the immediate function to execute callbacks
	   * @param fn {function} Function to execute
	   * @deprecated
	   */
	  Promise._setImmediateFn = function _setImmediateFn(fn) {
	    Promise._immediateFn = fn;
	  };
	
	  /**
	   * Change the function to execute on unhandled rejection
	   * @param {function} fn Function to execute on unhandled rejection
	   * @deprecated
	   */
	  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
	    Promise._unhandledRejectionFn = fn;
	  };
	  
	  if (typeof module !== 'undefined' && module.exports) {
	    module.exports = Promise;
	  } else if (!root.Promise) {
	    root.Promise = Promise;
	  }
	
	})(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(819).setImmediate))

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	  var has = require('./lib/has');
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (false) {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(365);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(159);
	var assign = __webpack_require__(16);
	
	var ReactPropTypesSecret = __webpack_require__(365);
	var has = __webpack_require__(674);
	var checkPropTypes = __webpack_require__(671);
	
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (false) {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data.hasOwnProperty('expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 674 */
/***/ function(module, exports) {

	module.exports = Function.call.bind(Object.prototype.hasOwnProperty);


/***/ },
/* 675 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(18);
	
	var focusNode = __webpack_require__(220);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(80);
	var ExecutionEnvironment = __webpack_require__(27);
	var FallbackCompositionState = __webpack_require__(683);
	var SyntheticCompositionEvent = __webpack_require__(720);
	var SyntheticInputEvent = __webpack_require__(723);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(367);
	var ExecutionEnvironment = __webpack_require__(27);
	var ReactInstrumentation = __webpack_require__(34);
	
	var camelizeStyleName = __webpack_require__(627);
	var dangerousStyleValue = __webpack_require__(729);
	var hyphenateStyleName = __webpack_require__(634);
	var memoizeStringOnly = __webpack_require__(637);
	var warning = __webpack_require__(15);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(79);
	var EventPropagators = __webpack_require__(80);
	var ExecutionEnvironment = __webpack_require__(27);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactUpdates = __webpack_require__(39);
	var SyntheticEvent = __webpack_require__(43);
	
	var inputValueTracking = __webpack_require__(383);
	var getEventTarget = __webpack_require__(154);
	var isEventSupported = __webpack_require__(155);
	var isTextInputElement = __webpack_require__(385);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var DOMLazyTree = __webpack_require__(61);
	var ExecutionEnvironment = __webpack_require__(27);
	
	var createNodesFromMarkup = __webpack_require__(630);
	var emptyFunction = __webpack_require__(37);
	var invariant = __webpack_require__(11);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 681 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(80);
	var ReactDOMComponentTree = __webpack_require__(18);
	var SyntheticMouseEvent = __webpack_require__(108);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var PooledClass = __webpack_require__(53);
	
	var getTextContentAccessor = __webpack_require__(382);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(62);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(63);
	
	var instantiateReactComponent = __webpack_require__(384);
	var KeyEscapeUtils = __webpack_require__(146);
	var shouldUpdateReactComponent = __webpack_require__(156);
	var traverseAllChildren = __webpack_require__(387);
	var warning = __webpack_require__(15);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(406);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(106)))

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(142);
	var ReactDOMIDOperations = __webpack_require__(693);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14),
	    _assign = __webpack_require__(16);
	
	var React = __webpack_require__(65);
	var ReactComponentEnvironment = __webpack_require__(148);
	var ReactCurrentOwner = __webpack_require__(44);
	var ReactErrorUtils = __webpack_require__(149);
	var ReactInstanceMap = __webpack_require__(81);
	var ReactInstrumentation = __webpack_require__(34);
	var ReactNodeTypes = __webpack_require__(377);
	var ReactReconciler = __webpack_require__(63);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(138);
	var invariant = __webpack_require__(11);
	var shallowEqual = __webpack_require__(139);
	var shouldUpdateReactComponent = __webpack_require__(156);
	var warning = __webpack_require__(15);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactDefaultInjection = __webpack_require__(701);
	var ReactMount = __webpack_require__(376);
	var ReactReconciler = __webpack_require__(63);
	var ReactUpdates = __webpack_require__(39);
	var ReactVersion = __webpack_require__(714);
	
	var findDOMNode = __webpack_require__(730);
	var getHostComponentFromComposite = __webpack_require__(381);
	var renderSubtreeIntoContainer = __webpack_require__(737);
	var warning = __webpack_require__(15);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14),
	    _assign = __webpack_require__(16);
	
	var AutoFocusUtils = __webpack_require__(676);
	var CSSPropertyOperations = __webpack_require__(678);
	var DOMLazyTree = __webpack_require__(61);
	var DOMNamespaces = __webpack_require__(143);
	var DOMProperty = __webpack_require__(62);
	var DOMPropertyOperations = __webpack_require__(369);
	var EventPluginHub = __webpack_require__(79);
	var EventPluginRegistry = __webpack_require__(144);
	var ReactBrowserEventEmitter = __webpack_require__(107);
	var ReactDOMComponentFlags = __webpack_require__(370);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactDOMInput = __webpack_require__(694);
	var ReactDOMOption = __webpack_require__(695);
	var ReactDOMSelect = __webpack_require__(371);
	var ReactDOMTextarea = __webpack_require__(698);
	var ReactInstrumentation = __webpack_require__(34);
	var ReactMultiChild = __webpack_require__(707);
	var ReactServerRenderingTransaction = __webpack_require__(712);
	
	var emptyFunction = __webpack_require__(37);
	var escapeTextContentForBrowser = __webpack_require__(110);
	var invariant = __webpack_require__(11);
	var isEventSupported = __webpack_require__(155);
	var shallowEqual = __webpack_require__(139);
	var inputValueTracking = __webpack_require__(383);
	var validateDOMNesting = __webpack_require__(157);
	var warning = __webpack_require__(15);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(157);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var DOMLazyTree = __webpack_require__(61);
	var ReactDOMComponentTree = __webpack_require__(18);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 692 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(142);
	var ReactDOMComponentTree = __webpack_require__(18);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14),
	    _assign = __webpack_require__(16);
	
	var DOMPropertyOperations = __webpack_require__(369);
	var LinkedValueUtils = __webpack_require__(147);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactUpdates = __webpack_require__(39);
	
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(15);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var React = __webpack_require__(65);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactDOMSelect = __webpack_require__(371);
	
	var warning = __webpack_require__(15);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(27);
	
	var getNodeForCharacterOffset = __webpack_require__(734);
	var getTextContentAccessor = __webpack_require__(382);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14),
	    _assign = __webpack_require__(16);
	
	var DOMChildrenOperations = __webpack_require__(142);
	var DOMLazyTree = __webpack_require__(61);
	var ReactDOMComponentTree = __webpack_require__(18);
	
	var escapeTextContentForBrowser = __webpack_require__(110);
	var invariant = __webpack_require__(11);
	var validateDOMNesting = __webpack_require__(157);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14),
	    _assign = __webpack_require__(16);
	
	var LinkedValueUtils = __webpack_require__(147);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactUpdates = __webpack_require__(39);
	
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(15);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var ReactUpdates = __webpack_require__(39);
	var Transaction = __webpack_require__(109);
	
	var emptyFunction = __webpack_require__(37);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(675);
	var BeforeInputEventPlugin = __webpack_require__(677);
	var ChangeEventPlugin = __webpack_require__(679);
	var DefaultEventPluginOrder = __webpack_require__(681);
	var EnterLeaveEventPlugin = __webpack_require__(682);
	var HTMLDOMPropertyConfig = __webpack_require__(684);
	var ReactComponentBrowserEnvironment = __webpack_require__(686);
	var ReactDOMComponent = __webpack_require__(689);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactDOMEmptyComponent = __webpack_require__(691);
	var ReactDOMTreeTraversal = __webpack_require__(699);
	var ReactDOMTextComponent = __webpack_require__(697);
	var ReactDefaultBatchingStrategy = __webpack_require__(700);
	var ReactEventListener = __webpack_require__(704);
	var ReactInjection = __webpack_require__(705);
	var ReactReconcileTransaction = __webpack_require__(710);
	var SVGDOMPropertyConfig = __webpack_require__(715);
	var SelectEventPlugin = __webpack_require__(716);
	var SimpleEventPlugin = __webpack_require__(717);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 702 */
407,
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(79);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var EventListener = __webpack_require__(219);
	var ExecutionEnvironment = __webpack_require__(27);
	var PooledClass = __webpack_require__(53);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactUpdates = __webpack_require__(39);
	
	var getEventTarget = __webpack_require__(154);
	var getUnboundedScrollPosition = __webpack_require__(632);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(62);
	var EventPluginHub = __webpack_require__(79);
	var EventPluginUtils = __webpack_require__(145);
	var ReactComponentEnvironment = __webpack_require__(148);
	var ReactEmptyComponent = __webpack_require__(372);
	var ReactBrowserEventEmitter = __webpack_require__(107);
	var ReactHostComponent = __webpack_require__(374);
	var ReactUpdates = __webpack_require__(39);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(728);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var ReactComponentEnvironment = __webpack_require__(148);
	var ReactInstanceMap = __webpack_require__(81);
	var ReactInstrumentation = __webpack_require__(34);
	
	var ReactCurrentOwner = __webpack_require__(44);
	var ReactReconciler = __webpack_require__(63);
	var ReactChildReconciler = __webpack_require__(685);
	
	var emptyFunction = __webpack_require__(37);
	var flattenChildren = __webpack_require__(731);
	var invariant = __webpack_require__(11);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 709 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var CallbackQueue = __webpack_require__(368);
	var PooledClass = __webpack_require__(53);
	var ReactBrowserEventEmitter = __webpack_require__(107);
	var ReactInputSelection = __webpack_require__(375);
	var ReactInstrumentation = __webpack_require__(34);
	var Transaction = __webpack_require__(109);
	var ReactUpdateQueue = __webpack_require__(150);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(708);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var PooledClass = __webpack_require__(53);
	var Transaction = __webpack_require__(109);
	var ReactInstrumentation = __webpack_require__(34);
	var ReactServerUpdateQueue = __webpack_require__(713);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(150);
	
	var warning = __webpack_require__(15);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 714 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 715 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(80);
	var ExecutionEnvironment = __webpack_require__(27);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactInputSelection = __webpack_require__(375);
	var SyntheticEvent = __webpack_require__(43);
	
	var getActiveElement = __webpack_require__(221);
	var isTextInputElement = __webpack_require__(385);
	var shallowEqual = __webpack_require__(139);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var EventListener = __webpack_require__(219);
	var EventPropagators = __webpack_require__(80);
	var ReactDOMComponentTree = __webpack_require__(18);
	var SyntheticAnimationEvent = __webpack_require__(718);
	var SyntheticClipboardEvent = __webpack_require__(719);
	var SyntheticEvent = __webpack_require__(43);
	var SyntheticFocusEvent = __webpack_require__(722);
	var SyntheticKeyboardEvent = __webpack_require__(724);
	var SyntheticMouseEvent = __webpack_require__(108);
	var SyntheticDragEvent = __webpack_require__(721);
	var SyntheticTouchEvent = __webpack_require__(725);
	var SyntheticTransitionEvent = __webpack_require__(726);
	var SyntheticUIEvent = __webpack_require__(82);
	var SyntheticWheelEvent = __webpack_require__(727);
	
	var emptyFunction = __webpack_require__(37);
	var getEventCharCode = __webpack_require__(152);
	var invariant = __webpack_require__(11);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(43);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(43);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(43);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(108);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(82);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(43);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(82);
	
	var getEventCharCode = __webpack_require__(152);
	var getEventKey = __webpack_require__(732);
	var getEventModifierState = __webpack_require__(153);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(82);
	
	var getEventModifierState = __webpack_require__(153);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(43);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(108);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 728 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(367);
	var warning = __webpack_require__(15);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(14);
	
	var ReactCurrentOwner = __webpack_require__(44);
	var ReactDOMComponentTree = __webpack_require__(18);
	var ReactInstanceMap = __webpack_require__(81);
	
	var getHostComponentFromComposite = __webpack_require__(381);
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(15);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(146);
	var traverseAllChildren = __webpack_require__(387);
	var warning = __webpack_require__(15);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(406);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(106)))

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(152);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 733 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 734 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(27);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(110);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(376);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(3);
	
	var FileInput = React.createClass({
	  getInitialState: function() {
	    return {
	      value: '',
	      styles: {
	        parent: {
	          position: 'relative'
	        },
	        file: {
	          position: 'absolute',
	          top: 0,
	          left: 0,
	          opacity: 0,
	          width: '100%',
	          zIndex: 1
	        },
	        text: {
	          position: 'relative',
	          zIndex: -1
	        }
	      }
	    };
	  },
	
	  handleChange: function(e) {
	    this.setState({
	      value: e.target.value.split(/(\\|\/)/g).pop()
	    });
	    if (this.props.onChange) this.props.onChange(e);
	  },
	
	  render: function() {
	    return React.DOM.div({
	        style: this.state.styles.parent
	      },
	
	      // Actual file input
	      React.DOM.input({
	        type: 'file',
	        name: this.props.name,
	        className: this.props.className,
	        onChange: this.handleChange,
	        disabled: this.props.disabled,
	        accept: this.props.accept,
	        style: this.state.styles.file
	      }),
	
	      // Emulated file input
	      React.DOM.input({
	        type: 'text',
	        tabIndex: -1,
	        name: this.props.name + '_filename',
	        value: this.state.value,
	        className: this.props.className,
	        onChange: function() {},
	        placeholder: this.props.placeholder,
	        disabled: this.props.disabled,
	        style: this.state.styles.text
	      }));
	  }
	});
	
	module.exports = FileInput;


/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HtmlParser;
	
	var _htmlparser = __webpack_require__(64);
	
	var _htmlparser2 = _interopRequireDefault(_htmlparser);
	
	var _processNodes = __webpack_require__(158);
	
	var _processNodes2 = _interopRequireDefault(_processNodes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Parses a HTML string and returns a list of React components generated from it
	 *
	 * @param {String} html The HTML to convert into React component
	 * @param {Object} options Options to pass
	 * @returns {Array} List of top level React elements
	 */
	function HtmlParser(html) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$decodeEntities = _ref.decodeEntities,
	      decodeEntities = _ref$decodeEntities === undefined ? true : _ref$decodeEntities,
	      transform = _ref.transform,
	      _ref$preprocessNodes = _ref.preprocessNodes,
	      preprocessNodes = _ref$preprocessNodes === undefined ? function (nodes) {
	    return nodes;
	  } : _ref$preprocessNodes;
	
	  var nodes = preprocessNodes(_htmlparser2.default.parseDOM(html, { decodeEntities: decodeEntities }));
	  return (0, _processNodes2.default)(nodes, transform);
	}

/***/ },
/* 740 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * List of boolean attributes
	 * These attributes should have their React attribute value set to be the same as their name
	 * E.g. <input disabled> = <input disabled>
	 *      <input disabled=""> = <input disabled>
	 *      <input disabled="disabled"> = <input disabled>
	 * @type {Array}
	 */
	exports.default = ['allowfullScreen', 'async', 'autoplay', 'capture', 'checked', 'controls', 'default', 'defer', 'disabled', 'formnovalidate', 'hidden', 'loop', 'multiple', 'muted', 'novalidate', 'open', 'playsinline', 'readonly', 'required', 'reversed', 'scoped', 'seamless', 'selected', 'itemscope'];

/***/ },
/* 741 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Mapping of standard HTML attributes to their React counterparts
	 * List taken and reversed from react/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
	 * https://github.com/facebook/react/blob/c9c3c339b757682f1154f1c915eb55e6a8766933/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
	 * @type {Object}
	 */
	exports.default = {
	  /**
	   * Standard Properties
	   */
	  accept: 'accept',
	  'accept-charset': 'acceptCharset',
	  accesskey: 'accessKey',
	  action: 'action',
	  allowfullscreen: 'allowFullScreen',
	  allowtransparency: 'allowTransparency',
	  alt: 'alt',
	  as: 'as',
	  async: 'async',
	  autocomplete: 'autoComplete',
	  autoplay: 'autoPlay',
	  capture: 'capture',
	  cellpadding: 'cellPadding',
	  cellspacing: 'cellSpacing',
	  charset: 'charSet',
	  challenge: 'challenge',
	  checked: 'checked',
	  cite: 'cite',
	  classid: 'classID',
	  class: 'className',
	  cols: 'cols',
	  colspan: 'colSpan',
	  content: 'content',
	  contenteditable: 'contentEditable',
	  contextmenu: 'contextMenu',
	  controls: 'controls',
	  controlsList: 'controlsList',
	  coords: 'coords',
	  crossorigin: 'crossOrigin',
	  data: 'data',
	  datetime: 'dateTime',
	  default: 'default',
	  defer: 'defer',
	  dir: 'dir',
	  disabled: 'disabled',
	  download: 'download',
	  draggable: 'draggable',
	  enctype: 'encType',
	  form: 'form',
	  formaction: 'formAction',
	  formenctype: 'formEncType',
	  formmethod: 'formMethod',
	  formnovalidate: 'formNoValidate',
	  formtarget: 'formTarget',
	  frameborder: 'frameBorder',
	  headers: 'headers',
	  height: 'height',
	  hidden: 'hidden',
	  high: 'high',
	  href: 'href',
	  hreflang: 'hrefLang',
	  for: 'htmlFor',
	  'http-equiv': 'httpEquiv',
	  icon: 'icon',
	  id: 'id',
	  inputmode: 'inputMode',
	  integrity: 'integrity',
	  is: 'is',
	  keyparams: 'keyParams',
	  keytype: 'keyType',
	  kind: 'kind',
	  label: 'label',
	  lang: 'lang',
	  list: 'list',
	  loop: 'loop',
	  low: 'low',
	  manifest: 'manifest',
	  marginheight: 'marginHeight',
	  marginwidth: 'marginWidth',
	  max: 'max',
	  maxlength: 'maxLength',
	  media: 'media',
	  mediagroup: 'mediaGroup',
	  method: 'method',
	  min: 'min',
	  minlength: 'minLength',
	  multiple: 'multiple',
	  muted: 'muted',
	  name: 'name',
	  nonce: 'nonce',
	  novalidate: 'noValidate',
	  open: 'open',
	  optimum: 'optimum',
	  pattern: 'pattern',
	  placeholder: 'placeholder',
	  playsinline: 'playsInline',
	  poster: 'poster',
	  preload: 'preload',
	  profile: 'profile',
	  radiogroup: 'radioGroup',
	  readonly: 'readOnly',
	  referrerpolicy: 'referrerPolicy',
	  rel: 'rel',
	  required: 'required',
	  reversed: 'reversed',
	  role: 'role',
	  rows: 'rows',
	  rowspan: 'rowSpan',
	  sandbox: 'sandbox',
	  scope: 'scope',
	  scoped: 'scoped',
	  scrolling: 'scrolling',
	  seamless: 'seamless',
	  selected: 'selected',
	  shape: 'shape',
	  size: 'size',
	  sizes: 'sizes',
	  slot: 'slot',
	  span: 'span',
	  spellcheck: 'spellCheck',
	  src: 'src',
	  srcdoc: 'srcDoc',
	  srclang: 'srcLang',
	  srcset: 'srcSet',
	  start: 'start',
	  step: 'step',
	  style: 'style',
	  summary: 'summary',
	  tabindex: 'tabIndex',
	  target: 'target',
	  title: 'title',
	  type: 'type',
	  usemap: 'useMap',
	  value: 'value',
	  width: 'width',
	  wmode: 'wmode',
	  wrap: 'wrap',
	  /**
	   * RDFa Properties
	   */
	  about: 'about',
	  datatype: 'datatype',
	  inlist: 'inlist',
	  prefix: 'prefix',
	  property: 'property',
	  resource: 'resource',
	  typeof: 'typeof',
	  vocab: 'vocab',
	  /**
	   * Non-standard Properties
	   */
	  autocapitalize: 'autoCapitalize',
	  autocorrect: 'autoCorrect',
	  autosave: 'autoSave',
	  color: 'color',
	  itemprop: 'itemProp',
	  itemscope: 'itemScope',
	  itemtype: 'itemType',
	  itemid: 'itemID',
	  itemref: 'itemRef',
	  results: 'results',
	  security: 'security',
	  unselectable: 'unselectable'
	};

/***/ },
/* 742 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * List of void elements
	 * These elements are not allowed to have children
	 * @type {Array}
	 */
	exports.default = ['area', 'base', 'br', 'col', 'command', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'meta', 'param', 'source', 'track', 'wbr'];

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StyleElementType;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _generatePropsFromAttributes = __webpack_require__(390);
	
	var _generatePropsFromAttributes2 = _interopRequireDefault(_generatePropsFromAttributes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Converts a <style> element to a React element
	 *
	 * @param {Object} node The style node
	 * @param {String} index The index of the React element relative to it's parent
	 * @returns {React.Element} The React style element
	 */
	function StyleElementType(node, index) {
	
	  // The style element only ever has a single child which is the styles so try and find this to add as
	  // a child to the style element that will be created
	  var styles = void 0;
	  if (node.children.length > 0) {
	    styles = node.children[0].data;
	  }
	
	  // generate props
	  var props = (0, _generatePropsFromAttributes2.default)(node.attribs, index);
	
	  // create and return the element
	  return _react2.default.createElement('style', props, styles);
	}

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TagElementType;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _processNodes = __webpack_require__(158);
	
	var _processNodes2 = _interopRequireDefault(_processNodes);
	
	var _generatePropsFromAttributes = __webpack_require__(390);
	
	var _generatePropsFromAttributes2 = _interopRequireDefault(_generatePropsFromAttributes);
	
	var _VoidElements = __webpack_require__(742);
	
	var _VoidElements2 = _interopRequireDefault(_VoidElements);
	
	var _isValidTagOrAttributeName = __webpack_require__(391);
	
	var _isValidTagOrAttributeName2 = _interopRequireDefault(_isValidTagOrAttributeName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Converts any element (excluding style - see StyleElementType - and script) to a react element.
	 *
	 * @param {Object} node The tag node
	 * @param {String} index The index of the React element relative to it's parent
	 * @param {Function} transform The transform function to apply to all children
	 * @returns {React.Element} The React tag element
	 */
	function TagElementType(node, index, transform) {
	
	  var tagName = node.name;
	
	  // validate tag name
	  if (!(0, _isValidTagOrAttributeName2.default)(tagName)) {
	    return null;
	  }
	
	  // generate props
	  var props = (0, _generatePropsFromAttributes2.default)(node.attribs, index);
	
	  // If the node is not a void element and has children then process them
	  var children = null;
	  if (_VoidElements2.default.indexOf(tagName) === -1) {
	    children = (0, _processNodes2.default)(node.children, transform);
	  }
	
	  // create and return the element
	  return _react2.default.createElement(tagName, props, children);
	}

/***/ },
/* 745 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TextElementType;
	/**
	 * Converts a text node to a React text element
	 *
	 * @param {Object} node The text node
	 * @returns {String} The text
	 */
	function TextElementType(node) {
	
	  // React will accept plain text for rendering so just return the node data
	  return node.data;
	}

/***/ },
/* 746 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = UnsupportedElementType;
	/**
	 * Handles an unsupported element type by returning null so nothing is rendered
	 * @returns {null}
	 */
	function UnsupportedElementType() {
	
	  // do nothing because the element type is unsupported
	  // comment, directive, script, cdata, doctype are all currently unsupported
	  return null;
	}

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ElementType$Text$Ele;
	
	var _htmlparser = __webpack_require__(64);
	
	var _TextElementType = __webpack_require__(745);
	
	var _TextElementType2 = _interopRequireDefault(_TextElementType);
	
	var _TagElementType = __webpack_require__(744);
	
	var _TagElementType2 = _interopRequireDefault(_TagElementType);
	
	var _StyleElementType = __webpack_require__(743);
	
	var _StyleElementType2 = _interopRequireDefault(_StyleElementType);
	
	var _UnsupportedElementType = __webpack_require__(746);
	
	var _UnsupportedElementType2 = _interopRequireDefault(_UnsupportedElementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
	                                                                                                                                                                                                                   * Map each htmlparser2 element type to a function which will convert that element type to a React element
	                                                                                                                                                                                                                   * Not all of the element types are supported so the UnsupportedElementType is used for them which will not return any
	                                                                                                                                                                                                                   * value
	                                                                                                                                                                                                                   */
	
	exports.default = (_ElementType$Text$Ele = {}, _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Text, _TextElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Tag, _TagElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Style, _StyleElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Directive, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Comment, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Script, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.CDATA, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Doctype, _UnsupportedElementType2.default), _ElementType$Text$Ele);

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = htmlAttributesToReact;
	
	var _BooleanAttributes = __webpack_require__(740);
	
	var _BooleanAttributes2 = _interopRequireDefault(_BooleanAttributes);
	
	var _ReactAttributes = __webpack_require__(741);
	
	var _ReactAttributes2 = _interopRequireDefault(_ReactAttributes);
	
	var _isValidTagOrAttributeName = __webpack_require__(391);
	
	var _isValidTagOrAttributeName2 = _interopRequireDefault(_isValidTagOrAttributeName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns the parsed attribute value taking into account things like boolean attributes
	 *
	 * @param {String} attribute The name of the attribute
	 * @param {*} value The value of the attribute from the HTML
	 * @returns {*} The parsed attribute value
	 */
	var getParsedAttributeValue = function getParsedAttributeValue(attribute, value) {
	
	  // if the attribute if a boolean then it's value should be the same as it's name
	  // e.g. disabled="disabled"
	  var lowerBooleanAttributes = _BooleanAttributes2.default.map(function (attr) {
	    return attr.toLowerCase();
	  });
	  if (lowerBooleanAttributes.indexOf(attribute.toLowerCase()) >= 0) {
	    value = attribute;
	  }
	
	  return value;
	};
	
	/**
	 * Takes an object of standard HTML property names and converts them to their React counterpart. If the react
	 * version does not exist for an attribute then just use it as it is
	 *
	 * @param {Object} attributes The HTML attributes to convert
	 * @returns {Object} The React attributes
	 */
	function htmlAttributesToReact(attributes) {
	
	  return Object.keys(attributes).filter(function (attr) {
	    return (0, _isValidTagOrAttributeName2.default)(attr);
	  }).reduce(function (mappedAttributes, attribute) {
	
	    // lowercase the attribute name and find it in the react attribute map
	    var lowerCaseAttribute = attribute.toLowerCase();
	
	    // format the attribute name
	    var name = _ReactAttributes2.default[lowerCaseAttribute] || lowerCaseAttribute;
	
	    // add the parsed attribute value to the mapped attributes
	    mappedAttributes[name] = getParsedAttributeValue(name, attributes[attribute]);
	
	    return mappedAttributes;
	  }, {});
	}

/***/ },
/* 749 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = InlineStyleToObject;
	/**
	 * Converts an inline style string into an object of React style properties
	 *
	 * @param {String} inlineStyle='' The inline style to convert
	 * @returns {Object} The converted style
	 */
	function InlineStyleToObject() {
	  var inlineStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	
	  // just return empty object if the inlineStyle is empty
	  if (inlineStyle === '') {
	    return {};
	  }
	
	  return inlineStyle.split(';').reduce(function (styleObject, stylePropertyValue) {
	
	    // extract the style property name and value
	    var _stylePropertyValue$s = stylePropertyValue.split(/^([^:]+):/).filter(function (val, i) {
	      return i > 0;
	    }).map(function (item) {
	      return item.trim().toLowerCase();
	    }),
	        _stylePropertyValue$s2 = _slicedToArray(_stylePropertyValue$s, 2),
	        property = _stylePropertyValue$s2[0],
	        value = _stylePropertyValue$s2[1];
	
	    // if there is no value (i.e. no : in the style) then ignore it
	
	
	    if (value === undefined) {
	      return styleObject;
	    }
	
	    // convert the property name into the correct React format
	    // remove all hyphens and convert the letter immediately after each hyphen to upper case
	    // additionally don't uppercase any -ms- prefix
	    // e.g. -ms-style-property = msStyleProperty
	    //      -webkit-style-property = WebkitStyleProperty
	    property = property.replace(/^-ms-/, 'ms-').replace(/-(.)/g, function (_, character) {
	      return character.toUpperCase();
	    });
	
	    // add the new style property and value to the style object
	    styleObject[property] = value;
	
	    return styleObject;
	  }, {});
	}

/***/ },
/* 750 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmptyTextNode;
	/**
	 * Tests a htmlparser2 node and returns whether is it a text node at the start and end of the line containing only
	 * white space. This allows these node types to be excluded from the rendering because they are unnecessary.
	 *
	 * @param {Object} node The element object as created by htmlparser2
	 * @returns {boolean} Whether the node is an empty text node
	 */
	function isEmptyTextNode(node) {
	  return node.type === 'text' && /\r?\n/.test(node.data) && node.data.trim() === '';
	}

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	/*
	  Module dependencies
	*/
	var ElementType = __webpack_require__(752);
	var entities = __webpack_require__(754);
	
	/* mixed-case SVG and MathML tags & attributes
	   recognized by the HTML parser, see
	   https://html.spec.whatwg.org/multipage/parsing.html#parsing-main-inforeign
	*/
	var foreignNames = __webpack_require__(659);
	foreignNames.elementNames.__proto__ = null; /* use as a simple dictionary */
	foreignNames.attributeNames.__proto__ = null;
	
	var unencodedElements = {
	  __proto__: null,
	  style: true,
	  script: true,
	  xmp: true,
	  iframe: true,
	  noembed: true,
	  noframes: true,
	  plaintext: true,
	  noscript: true
	};
	
	/*
	  Format attributes
	*/
	function formatAttrs(attributes, opts) {
	  if (!attributes) return;
	
	  var output = '';
	  var value;
	
	  // Loop through the attributes
	  for (var key in attributes) {
	    value = attributes[key];
	    if (output) {
	      output += ' ';
	    }
	
	    if (opts.xmlMode === 'foreign') {
	      /* fix up mixed-case attribute names */
	      key = foreignNames.attributeNames[key] || key;
	    }
	    output += key;
	    if ((value !== null && value !== '') || opts.xmlMode) {
	      output +=
	        '="' +
	        (opts.decodeEntities
	          ? entities.encodeXML(value)
	          : value.replace(/\"/g, '&quot;')) +
	        '"';
	    }
	  }
	
	  return output;
	}
	
	/*
	  Self-enclosing tags (stolen from node-htmlparser)
	*/
	var singleTag = {
	  __proto__: null,
	  area: true,
	  base: true,
	  basefont: true,
	  br: true,
	  col: true,
	  command: true,
	  embed: true,
	  frame: true,
	  hr: true,
	  img: true,
	  input: true,
	  isindex: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	};
	
	var render = (module.exports = function(dom, opts) {
	  if (!Array.isArray(dom) && !dom.cheerio) dom = [dom];
	  opts = opts || {};
	
	  var output = '';
	
	  for (var i = 0; i < dom.length; i++) {
	    var elem = dom[i];
	
	    if (elem.type === 'root') output += render(elem.children, opts);
	    else if (ElementType.isTag(elem)) output += renderTag(elem, opts);
	    else if (elem.type === ElementType.Directive)
	      output += renderDirective(elem);
	    else if (elem.type === ElementType.Comment) output += renderComment(elem);
	    else if (elem.type === ElementType.CDATA) output += renderCdata(elem);
	    else output += renderText(elem, opts);
	  }
	
	  return output;
	});
	
	var foreignModeIntegrationPoints = [
	  'mi',
	  'mo',
	  'mn',
	  'ms',
	  'mtext',
	  'annotation-xml',
	  'foreignObject',
	  'desc',
	  'title'
	];
	
	function renderTag(elem, opts) {
	  // Handle SVG / MathML in HTML
	  if (opts.xmlMode === 'foreign') {
	    /* fix up mixed-case element names */
	    elem.name = foreignNames.elementNames[elem.name] || elem.name;
	    /* exit foreign mode at integration points */
	    if (
	      elem.parent &&
	      foreignModeIntegrationPoints.indexOf(elem.parent.name) >= 0
	    )
	      opts = Object.assign({}, opts, { xmlMode: false });
	  }
	  if (!opts.xmlMode && ['svg', 'math'].indexOf(elem.name) >= 0) {
	    opts = Object.assign({}, opts, { xmlMode: 'foreign' });
	  }
	
	  var tag = '<' + elem.name;
	  var attribs = formatAttrs(elem.attribs, opts);
	
	  if (attribs) {
	    tag += ' ' + attribs;
	  }
	
	  if (opts.xmlMode && (!elem.children || elem.children.length === 0)) {
	    tag += '/>';
	  } else {
	    tag += '>';
	    if (elem.children) {
	      tag += render(elem.children, opts);
	    }
	
	    if (!singleTag[elem.name] || opts.xmlMode) {
	      tag += '</' + elem.name + '>';
	    }
	  }
	
	  return tag;
	}
	
	function renderDirective(elem) {
	  return '<' + elem.data + '>';
	}
	
	function renderText(elem, opts) {
	  var data = elem.data || '';
	
	  // if entities weren't decoded, no need to encode them back
	  if (
	    opts.decodeEntities &&
	    !(elem.parent && elem.parent.name in unencodedElements)
	  ) {
	    data = entities.encodeXML(data);
	  }
	
	  return data;
	}
	
	function renderCdata(elem) {
	  return '<![CDATA[' + elem.children[0].data + ']]>';
	}
	
	function renderComment(elem) {
	  return '<!--' + elem.data + '-->';
	}


/***/ },
/* 752 */
612,
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var decode_json_1 = __importDefault(__webpack_require__(660));
	// Adapted from https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
	var fromCodePoint = 
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	String.fromCodePoint ||
	    function (codePoint) {
	        var output = "";
	        if (codePoint > 0xffff) {
	            codePoint -= 0x10000;
	            output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
	            codePoint = 0xdc00 | (codePoint & 0x3ff);
	        }
	        output += String.fromCharCode(codePoint);
	        return output;
	    };
	function decodeCodePoint(codePoint) {
	    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
	        return "\uFFFD";
	    }
	    if (codePoint in decode_json_1.default) {
	        codePoint = decode_json_1.default[codePoint];
	    }
	    return fromCodePoint(codePoint);
	}
	exports.default = decodeCodePoint;


/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.decodeXMLStrict = exports.decodeHTML5Strict = exports.decodeHTML4Strict = exports.decodeHTML5 = exports.decodeHTML4 = exports.decodeHTMLStrict = exports.decodeHTML = exports.decodeXML = exports.encodeHTML5 = exports.encodeHTML4 = exports.escapeUTF8 = exports.escape = exports.encodeNonAsciiHTML = exports.encodeHTML = exports.encodeXML = exports.encode = exports.decodeStrict = exports.decode = void 0;
	var decode_1 = __webpack_require__(392);
	var encode_1 = __webpack_require__(393);
	/**
	 * Decodes a string with entities.
	 *
	 * @param data String to decode.
	 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
	 * @deprecated Use `decodeXML` or `decodeHTML` directly.
	 */
	function decode(data, level) {
	    return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTML)(data);
	}
	exports.decode = decode;
	/**
	 * Decodes a string with entities. Does not allow missing trailing semicolons for entities.
	 *
	 * @param data String to decode.
	 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
	 * @deprecated Use `decodeHTMLStrict` or `decodeXML` directly.
	 */
	function decodeStrict(data, level) {
	    return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTMLStrict)(data);
	}
	exports.decodeStrict = decodeStrict;
	/**
	 * Encodes a string with entities.
	 *
	 * @param data String to encode.
	 * @param level Optional level to encode at. 0 = XML, 1 = HTML. Default is 0.
	 * @deprecated Use `encodeHTML`, `encodeXML` or `encodeNonAsciiHTML` directly.
	 */
	function encode(data, level) {
	    return (!level || level <= 0 ? encode_1.encodeXML : encode_1.encodeHTML)(data);
	}
	exports.encode = encode;
	var encode_2 = __webpack_require__(393);
	Object.defineProperty(exports, "encodeXML", { enumerable: true, get: function () { return encode_2.encodeXML; } });
	Object.defineProperty(exports, "encodeHTML", { enumerable: true, get: function () { return encode_2.encodeHTML; } });
	Object.defineProperty(exports, "encodeNonAsciiHTML", { enumerable: true, get: function () { return encode_2.encodeNonAsciiHTML; } });
	Object.defineProperty(exports, "escape", { enumerable: true, get: function () { return encode_2.escape; } });
	Object.defineProperty(exports, "escapeUTF8", { enumerable: true, get: function () { return encode_2.escapeUTF8; } });
	// Legacy aliases (deprecated)
	Object.defineProperty(exports, "encodeHTML4", { enumerable: true, get: function () { return encode_2.encodeHTML; } });
	Object.defineProperty(exports, "encodeHTML5", { enumerable: true, get: function () { return encode_2.encodeHTML; } });
	var decode_2 = __webpack_require__(392);
	Object.defineProperty(exports, "decodeXML", { enumerable: true, get: function () { return decode_2.decodeXML; } });
	Object.defineProperty(exports, "decodeHTML", { enumerable: true, get: function () { return decode_2.decodeHTML; } });
	Object.defineProperty(exports, "decodeHTMLStrict", { enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } });
	// Legacy aliases (deprecated)
	Object.defineProperty(exports, "decodeHTML4", { enumerable: true, get: function () { return decode_2.decodeHTML; } });
	Object.defineProperty(exports, "decodeHTML5", { enumerable: true, get: function () { return decode_2.decodeHTML; } });
	Object.defineProperty(exports, "decodeHTML4Strict", { enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } });
	Object.defineProperty(exports, "decodeHTML5Strict", { enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } });
	Object.defineProperty(exports, "decodeXMLStrict", { enumerable: true, get: function () { return decode_2.decodeXML; } });


/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	// DOM-Level-1-compliant structure
	var NodePrototype = __webpack_require__(395);
	var ElementPrototype = module.exports = Object.create(NodePrototype);
	
	var domLvl1 = {
		tagName: "name"
	};
	
	Object.keys(domLvl1).forEach(function(key) {
		var shorthand = domLvl1[key];
		Object.defineProperty(ElementPrototype, key, {
			get: function() {
				return this[shorthand] || null;
			},
			set: function(val) {
				this[shorthand] = val;
				return val;
			}
		});
	});


/***/ },
/* 756 */
/***/ function(module, exports) {

	// removeSubsets
	// Given an array of nodes, remove any member that is contained by another.
	exports.removeSubsets = function(nodes) {
		var idx = nodes.length, node, ancestor, replace;
	
		// Check if each node (or one of its ancestors) is already contained in the
		// array.
		while (--idx > -1) {
			node = ancestor = nodes[idx];
	
			// Temporarily remove the node under consideration
			nodes[idx] = null;
			replace = true;
	
			while (ancestor) {
				if (nodes.indexOf(ancestor) > -1) {
					replace = false;
					nodes.splice(idx, 1);
					break;
				}
				ancestor = ancestor.parent;
			}
	
			// If the node has been found to be unique, re-insert it.
			if (replace) {
				nodes[idx] = node;
			}
		}
	
		return nodes;
	};
	
	// Source: http://dom.spec.whatwg.org/#dom-node-comparedocumentposition
	var POSITION = {
		DISCONNECTED: 1,
		PRECEDING: 2,
		FOLLOWING: 4,
		CONTAINS: 8,
		CONTAINED_BY: 16
	};
	
	// Compare the position of one node against another node in any other document.
	// The return value is a bitmask with the following values:
	//
	// document order:
	// > There is an ordering, document order, defined on all the nodes in the
	// > document corresponding to the order in which the first character of the
	// > XML representation of each node occurs in the XML representation of the
	// > document after expansion of general entities. Thus, the document element
	// > node will be the first node. Element nodes occur before their children.
	// > Thus, document order orders element nodes in order of the occurrence of
	// > their start-tag in the XML (after expansion of entities). The attribute
	// > nodes of an element occur after the element and before its children. The
	// > relative order of attribute nodes is implementation-dependent./
	// Source:
	// http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
	//
	// @argument {Node} nodaA The first node to use in the comparison
	// @argument {Node} nodeB The second node to use in the comparison
	//
	// @return {Number} A bitmask describing the input nodes' relative position.
	//         See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
	//         a description of these values.
	var comparePos = exports.compareDocumentPosition = function(nodeA, nodeB) {
		var aParents = [];
		var bParents = [];
		var current, sharedParent, siblings, aSibling, bSibling, idx;
	
		if (nodeA === nodeB) {
			return 0;
		}
	
		current = nodeA;
		while (current) {
			aParents.unshift(current);
			current = current.parent;
		}
		current = nodeB;
		while (current) {
			bParents.unshift(current);
			current = current.parent;
		}
	
		idx = 0;
		while (aParents[idx] === bParents[idx]) {
			idx++;
		}
	
		if (idx === 0) {
			return POSITION.DISCONNECTED;
		}
	
		sharedParent = aParents[idx - 1];
		siblings = sharedParent.children;
		aSibling = aParents[idx];
		bSibling = bParents[idx];
	
		if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
			if (sharedParent === nodeB) {
				return POSITION.FOLLOWING | POSITION.CONTAINED_BY;
			}
			return POSITION.FOLLOWING;
		} else {
			if (sharedParent === nodeA) {
				return POSITION.PRECEDING | POSITION.CONTAINS;
			}
			return POSITION.PRECEDING;
		}
	};
	
	// Sort an array of nodes based on their relative position in the document and
	// remove any duplicate nodes. If the array contains nodes that do not belong
	// to the same document, sort order is unspecified.
	//
	// @argument {Array} nodes Array of DOM nodes
	//
	// @returns {Array} collection of unique nodes, sorted in document order
	exports.uniqueSort = function(nodes) {
		var idx = nodes.length, node, position;
	
		nodes = nodes.slice();
	
		while (--idx > -1) {
			node = nodes[idx];
			position = nodes.indexOf(node);
			if (position > -1 && position < idx) {
				nodes.splice(idx, 1);
			}
		}
		nodes.sort(function(a, b) {
			var relative = comparePos(a, b);
			if (relative & POSITION.PRECEDING) {
				return -1;
			} else if (relative & POSITION.FOLLOWING) {
				return 1;
			}
			return 0;
		});
	
		return nodes;
	};


/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(83);
	var isTag = exports.isTag = ElementType.isTag;
	
	exports.testElement = function(options, element){
		for(var key in options){
			if(!options.hasOwnProperty(key));
			else if(key === "tag_name"){
				if(!isTag(element) || !options.tag_name(element.name)){
					return false;
				}
			} else if(key === "tag_type"){
				if(!options.tag_type(element.type)) return false;
			} else if(key === "tag_contains"){
				if(isTag(element) || !options.tag_contains(element.data)){
					return false;
				}
			} else if(!element.attribs || !options[key](element.attribs[key])){
				return false;
			}
		}
		return true;
	};
	
	var Checks = {
		tag_name: function(name){
			if(typeof name === "function"){
				return function(elem){ return isTag(elem) && name(elem.name); };
			} else if(name === "*"){
				return isTag;
			} else {
				return function(elem){ return isTag(elem) && elem.name === name; };
			}
		},
		tag_type: function(type){
			if(typeof type === "function"){
				return function(elem){ return type(elem.type); };
			} else {
				return function(elem){ return elem.type === type; };
			}
		},
		tag_contains: function(data){
			if(typeof data === "function"){
				return function(elem){ return !isTag(elem) && data(elem.data); };
			} else {
				return function(elem){ return !isTag(elem) && elem.data === data; };
			}
		}
	};
	
	function getAttribCheck(attrib, value){
		if(typeof value === "function"){
			return function(elem){ return elem.attribs && value(elem.attribs[attrib]); };
		} else {
			return function(elem){ return elem.attribs && elem.attribs[attrib] === value; };
		}
	}
	
	function combineFuncs(a, b){
		return function(elem){
			return a(elem) || b(elem);
		};
	}
	
	exports.getElements = function(options, element, recurse, limit){
		var funcs = Object.keys(options).map(function(key){
			var value = options[key];
			return key in Checks ? Checks[key](value) : getAttribCheck(key, value);
		});
	
		return funcs.length === 0 ? [] : this.filter(
			funcs.reduce(combineFuncs),
			element, recurse, limit
		);
	};
	
	exports.getElementById = function(id, element, recurse){
		if(!Array.isArray(element)) element = [element];
		return this.findOne(getAttribCheck("id", id), element, recurse !== false);
	};
	
	exports.getElementsByTagName = function(name, element, recurse, limit){
		return this.filter(Checks.tag_name(name), element, recurse, limit);
	};
	
	exports.getElementsByTagType = function(type, element, recurse, limit){
		return this.filter(Checks.tag_type(type), element, recurse, limit);
	};


/***/ },
/* 758 */
/***/ function(module, exports) {

	exports.removeElement = function(elem){
		if(elem.prev) elem.prev.next = elem.next;
		if(elem.next) elem.next.prev = elem.prev;
	
		if(elem.parent){
			var childs = elem.parent.children;
			childs.splice(childs.lastIndexOf(elem), 1);
		}
	};
	
	exports.replaceElement = function(elem, replacement){
		var prev = replacement.prev = elem.prev;
		if(prev){
			prev.next = replacement;
		}
	
		var next = replacement.next = elem.next;
		if(next){
			next.prev = replacement;
		}
	
		var parent = replacement.parent = elem.parent;
		if(parent){
			var childs = parent.children;
			childs[childs.lastIndexOf(elem)] = replacement;
		}
	};
	
	exports.appendChild = function(elem, child){
		child.parent = elem;
	
		if(elem.children.push(child) !== 1){
			var sibling = elem.children[elem.children.length - 2];
			sibling.next = child;
			child.prev = sibling;
			child.next = null;
		}
	};
	
	exports.append = function(elem, next){
		var parent = elem.parent,
			currNext = elem.next;
	
		next.next = currNext;
		next.prev = elem;
		elem.next = next;
		next.parent = parent;
	
		if(currNext){
			currNext.prev = next;
			if(parent){
				var childs = parent.children;
				childs.splice(childs.lastIndexOf(currNext), 0, next);
			}
		} else if(parent){
			parent.children.push(next);
		}
	};
	
	exports.prepend = function(elem, prev){
		var parent = elem.parent;
		if(parent){
			var childs = parent.children;
			childs.splice(childs.lastIndexOf(elem), 0, prev);
		}
	
		if(elem.prev){
			elem.prev.next = prev;
		}
		
		prev.parent = parent;
		prev.prev = elem.prev;
		prev.next = elem;
		elem.prev = prev;
	};
	
	


/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	var isTag = __webpack_require__(83).isTag;
	
	module.exports = {
		filter: filter,
		find: find,
		findOneChild: findOneChild,
		findOne: findOne,
		existsOne: existsOne,
		findAll: findAll
	};
	
	function filter(test, element, recurse, limit){
		if(!Array.isArray(element)) element = [element];
	
		if(typeof limit !== "number" || !isFinite(limit)){
			limit = Infinity;
		}
		return find(test, element, recurse !== false, limit);
	}
	
	function find(test, elems, recurse, limit){
		var result = [], childs;
	
		for(var i = 0, j = elems.length; i < j; i++){
			if(test(elems[i])){
				result.push(elems[i]);
				if(--limit <= 0) break;
			}
	
			childs = elems[i].children;
			if(recurse && childs && childs.length > 0){
				childs = find(test, childs, recurse, limit);
				result = result.concat(childs);
				limit -= childs.length;
				if(limit <= 0) break;
			}
		}
	
		return result;
	}
	
	function findOneChild(test, elems){
		for(var i = 0, l = elems.length; i < l; i++){
			if(test(elems[i])) return elems[i];
		}
	
		return null;
	}
	
	function findOne(test, elems){
		var elem = null;
	
		for(var i = 0, l = elems.length; i < l && !elem; i++){
			if(!isTag(elems[i])){
				continue;
			} else if(test(elems[i])){
				elem = elems[i];
			} else if(elems[i].children.length > 0){
				elem = findOne(test, elems[i].children);
			}
		}
	
		return elem;
	}
	
	function existsOne(test, elems){
		for(var i = 0, l = elems.length; i < l; i++){
			if(
				isTag(elems[i]) && (
					test(elems[i]) || (
						elems[i].children.length > 0 &&
						existsOne(test, elems[i].children)
					)
				)
			){
				return true;
			}
		}
	
		return false;
	}
	
	function findAll(test, rootElems){
		var result = [];
		var stack = rootElems.slice();
		while(stack.length){
			var elem = stack.shift();
			if(!isTag(elem)) continue;
			if (elem.children && elem.children.length > 0) {
				stack.unshift.apply(stack, elem.children);
			}
			if(test(elem)) result.push(elem);
		}
		return result;
	}


/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(83),
	    getOuterHTML = __webpack_require__(751),
	    isTag = ElementType.isTag;
	
	module.exports = {
		getInnerHTML: getInnerHTML,
		getOuterHTML: getOuterHTML,
		getText: getText
	};
	
	function getInnerHTML(elem, opts){
		return elem.children ? elem.children.map(function(elem){
			return getOuterHTML(elem, opts);
		}).join("") : "";
	}
	
	function getText(elem){
		if(Array.isArray(elem)) return elem.map(getText).join("");
		if(isTag(elem)) return elem.name === "br" ? "\n" : getText(elem.children);
		if(elem.type === ElementType.CDATA) return getText(elem.children);
		if(elem.type === ElementType.Text) return elem.data;
		return "";
	}


/***/ },
/* 761 */
/***/ function(module, exports) {

	var getChildren = exports.getChildren = function(elem){
		return elem.children;
	};
	
	var getParent = exports.getParent = function(elem){
		return elem.parent;
	};
	
	exports.getSiblings = function(elem){
		var parent = getParent(elem);
		return parent ? getChildren(parent) : [elem];
	};
	
	exports.getAttributeValue = function(elem, name){
		return elem.attribs && elem.attribs[name];
	};
	
	exports.hasAttrib = function(elem, name){
		return !!elem.attribs && hasOwnProperty.call(elem.attribs, name);
	};
	
	exports.getName = function(elem){
		return elem.name;
	};


/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	var decodeMap = __webpack_require__(662);
	
	module.exports = decodeCodePoint;
	
	// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
	function decodeCodePoint(codePoint) {
	    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
	        return "\uFFFD";
	    }
	
	    if (codePoint in decodeMap) {
	        codePoint = decodeMap[codePoint];
	    }
	
	    var output = "";
	
	    if (codePoint > 0xffff) {
	        codePoint -= 0x10000;
	        output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
	        codePoint = 0xdc00 | (codePoint & 0x3ff);
	    }
	
	    output += String.fromCharCode(codePoint);
	    return output;
	}


/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = CollectingHandler;
	
	function CollectingHandler(cbs) {
	    this._cbs = cbs || {};
	    this.events = [];
	}
	
	var EVENTS = __webpack_require__(64).EVENTS;
	Object.keys(EVENTS).forEach(function(name) {
	    if (EVENTS[name] === 0) {
	        name = "on" + name;
	        CollectingHandler.prototype[name] = function() {
	            this.events.push([name]);
	            if (this._cbs[name]) this._cbs[name]();
	        };
	    } else if (EVENTS[name] === 1) {
	        name = "on" + name;
	        CollectingHandler.prototype[name] = function(a) {
	            this.events.push([name, a]);
	            if (this._cbs[name]) this._cbs[name](a);
	        };
	    } else if (EVENTS[name] === 2) {
	        name = "on" + name;
	        CollectingHandler.prototype[name] = function(a, b) {
	            this.events.push([name, a, b]);
	            if (this._cbs[name]) this._cbs[name](a, b);
	        };
	    } else {
	        throw Error("wrong number of arguments");
	    }
	});
	
	CollectingHandler.prototype.onreset = function() {
	    this.events = [];
	    if (this._cbs.onreset) this._cbs.onreset();
	};
	
	CollectingHandler.prototype.restart = function() {
	    if (this._cbs.onreset) this._cbs.onreset();
	
	    for (var i = 0, len = this.events.length; i < len; i++) {
	        if (this._cbs[this.events[i][0]]) {
	            var num = this.events[i].length;
	
	            if (num === 1) {
	                this._cbs[this.events[i][0]]();
	            } else if (num === 2) {
	                this._cbs[this.events[i][0]](this.events[i][1]);
	            } else {
	                this._cbs[this.events[i][0]](
	                    this.events[i][1],
	                    this.events[i][2]
	                );
	            }
	        }
	    }
	};


/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	var DomHandler = __webpack_require__(394);
	var DomUtils = __webpack_require__(396);
	
	//TODO: make this a streamable handler
	function FeedHandler(callback, options) {
	    this.init(callback, options);
	}
	
	__webpack_require__(105)(FeedHandler, DomHandler);
	
	FeedHandler.prototype.init = DomHandler;
	
	function getElements(what, where) {
	    return DomUtils.getElementsByTagName(what, where, true);
	}
	function getOneElement(what, where) {
	    return DomUtils.getElementsByTagName(what, where, true, 1)[0];
	}
	function fetch(what, where, recurse) {
	    return DomUtils.getText(
	        DomUtils.getElementsByTagName(what, where, recurse, 1)
	    ).trim();
	}
	
	function addConditionally(obj, prop, what, where, recurse) {
	    var tmp = fetch(what, where, recurse);
	    if (tmp) obj[prop] = tmp;
	}
	
	var isValidFeed = function(value) {
	    return value === "rss" || value === "feed" || value === "rdf:RDF";
	};
	
	FeedHandler.prototype.onend = function() {
	    var feed = {},
	        feedRoot = getOneElement(isValidFeed, this.dom),
	        tmp,
	        childs;
	
	    if (feedRoot) {
	        if (feedRoot.name === "feed") {
	            childs = feedRoot.children;
	
	            feed.type = "atom";
	            addConditionally(feed, "id", "id", childs);
	            addConditionally(feed, "title", "title", childs);
	            if (
	                (tmp = getOneElement("link", childs)) &&
	                (tmp = tmp.attribs) &&
	                (tmp = tmp.href)
	            )
	                feed.link = tmp;
	            addConditionally(feed, "description", "subtitle", childs);
	            if ((tmp = fetch("updated", childs))) feed.updated = new Date(tmp);
	            addConditionally(feed, "author", "email", childs, true);
	
	            feed.items = getElements("entry", childs).map(function(item) {
	                var entry = {},
	                    tmp;
	
	                item = item.children;
	
	                addConditionally(entry, "id", "id", item);
	                addConditionally(entry, "title", "title", item);
	                if (
	                    (tmp = getOneElement("link", item)) &&
	                    (tmp = tmp.attribs) &&
	                    (tmp = tmp.href)
	                )
	                    entry.link = tmp;
	                if ((tmp = fetch("summary", item) || fetch("content", item)))
	                    entry.description = tmp;
	                if ((tmp = fetch("updated", item)))
	                    entry.pubDate = new Date(tmp);
	                return entry;
	            });
	        } else {
	            childs = getOneElement("channel", feedRoot.children).children;
	
	            feed.type = feedRoot.name.substr(0, 3);
	            feed.id = "";
	            addConditionally(feed, "title", "title", childs);
	            addConditionally(feed, "link", "link", childs);
	            addConditionally(feed, "description", "description", childs);
	            if ((tmp = fetch("lastBuildDate", childs)))
	                feed.updated = new Date(tmp);
	            addConditionally(feed, "author", "managingEditor", childs, true);
	
	            feed.items = getElements("item", feedRoot.children).map(function(
	                item
	            ) {
	                var entry = {},
	                    tmp;
	
	                item = item.children;
	
	                addConditionally(entry, "id", "guid", item);
	                addConditionally(entry, "title", "title", item);
	                addConditionally(entry, "link", "link", item);
	                addConditionally(entry, "description", "description", item);
	                if ((tmp = fetch("pubDate", item)))
	                    entry.pubDate = new Date(tmp);
	                return entry;
	            });
	        }
	    }
	    this.dom = feed;
	    DomHandler.prototype._handleCallback.call(
	        this,
	        feedRoot ? null : Error("couldn't find root of feed")
	    );
	};
	
	module.exports = FeedHandler;


/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = ProxyHandler;
	
	function ProxyHandler(cbs) {
	    this._cbs = cbs || {};
	}
	
	var EVENTS = __webpack_require__(64).EVENTS;
	Object.keys(EVENTS).forEach(function(name) {
	    if (EVENTS[name] === 0) {
	        name = "on" + name;
	        ProxyHandler.prototype[name] = function() {
	            if (this._cbs[name]) this._cbs[name]();
	        };
	    } else if (EVENTS[name] === 1) {
	        name = "on" + name;
	        ProxyHandler.prototype[name] = function(a) {
	            if (this._cbs[name]) this._cbs[name](a);
	        };
	    } else if (EVENTS[name] === 2) {
	        name = "on" + name;
	        ProxyHandler.prototype[name] = function(a, b) {
	            if (this._cbs[name]) this._cbs[name](a, b);
	        };
	    } else {
	        throw Error("wrong number of arguments");
	    }
	});


/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = Stream;
	
	var Parser = __webpack_require__(399);
	
	function Stream(options) {
	    Parser.call(this, new Cbs(this), options);
	}
	
	__webpack_require__(105)(Stream, Parser);
	
	Stream.prototype.readable = true;
	
	function Cbs(scope) {
	    this.scope = scope;
	}
	
	var EVENTS = __webpack_require__(64).EVENTS;
	
	Object.keys(EVENTS).forEach(function(name) {
	    if (EVENTS[name] === 0) {
	        Cbs.prototype["on" + name] = function() {
	            this.scope.emit(name);
	        };
	    } else if (EVENTS[name] === 1) {
	        Cbs.prototype["on" + name] = function(a) {
	            this.scope.emit(name, a);
	        };
	    } else if (EVENTS[name] === 2) {
	        Cbs.prototype["on" + name] = function(a, b) {
	            this.scope.emit(name, a, b);
	        };
	    } else {
	        throw Error("wrong number of arguments!");
	    }
	});


/***/ },
/* 767 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	}
	
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	function _iterableToArrayLimit(arr, i) {
	  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
	
	  if (_i == null) return;
	  var _arr = [];
	  var _n = true;
	  var _d = false;
	
	  var _s, _e;
	
	  try {
	    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);
	
	      if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;
	    _e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }
	
	  return _arr;
	}
	
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	
	  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
	
	  return arr2;
	}
	
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	
	// A reserved attribute.
	// It is handled by React separately and shouldn't be written to the DOM.
	var RESERVED = 0; // A simple string attribute.
	// Attributes that aren't in the filter are presumed to have this type.
	
	var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
	// "enumerated" attributes with "true" and "false" as possible values.
	// When true, it should be set to a "true" string.
	// When false, it should be set to a "false" string.
	
	var BOOLEANISH_STRING = 2; // A real boolean attribute.
	// When true, it should be present (set either to an empty string or its name).
	// When false, it should be omitted.
	
	var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
	// When true, it should be present (set either to an empty string or its name).
	// When false, it should be omitted.
	// For any other value, should be present with that value.
	
	var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
	// When falsy, it should be removed.
	
	var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
	// When falsy, it should be removed.
	
	var POSITIVE_NUMERIC = 6;
	function getPropertyInfo(name) {
	  return properties.hasOwnProperty(name) ? properties[name] : null;
	}
	
	function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
	  this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
	  this.attributeName = attributeName;
	  this.attributeNamespace = attributeNamespace;
	  this.mustUseProperty = mustUseProperty;
	  this.propertyName = name;
	  this.type = type;
	  this.sanitizeURL = sanitizeURL;
	  this.removeEmptyString = removeEmptyString;
	} // When adding attributes to this list, be sure to also add them to
	// the `possibleStandardNames` module to ensure casing and incorrect
	// name warnings.
	
	
	var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
	
	var reservedProps = ['children', 'dangerouslySetInnerHTML', // TODO: This prevents the assignment of defaultValue to regular
	// elements (not just inputs). Now that ReactDOMInput assigns to the
	// defaultValue property -- do we need this?
	'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'style'];
	reservedProps.forEach(function (name) {
	  properties[name] = new PropertyInfoRecord(name, RESERVED, false, // mustUseProperty
	  name, // attributeName
	  null, // attributeNamespace
	  false, // sanitizeURL
	  false);
	}); // A few React string attributes have a different name.
	// This is a mapping from React prop names to the attribute names.
	
	[['acceptCharset', 'accept-charset'], ['className', 'class'], ['htmlFor', 'for'], ['httpEquiv', 'http-equiv']].forEach(function (_ref) {
	  var _ref2 = _slicedToArray(_ref, 2),
	      name = _ref2[0],
	      attributeName = _ref2[1];
	
	  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
	  attributeName, // attributeName
	  null, // attributeNamespace
	  false, // sanitizeURL
	  false);
	}); // These are "enumerated" HTML attributes that accept "true" and "false".
	// In React, we let users pass `true` and `false` even though technically
	// these aren't boolean attributes (they are coerced to strings).
	
	['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (name) {
	  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
	  name.toLowerCase(), // attributeName
	  null, // attributeNamespace
	  false, // sanitizeURL
	  false);
	}); // These are "enumerated" SVG attributes that accept "true" and "false".
	// In React, we let users pass `true` and `false` even though technically
	// these aren't boolean attributes (they are coerced to strings).
	// Since these are SVG attributes, their attribute names are case-sensitive.
	
	['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (name) {
	  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
	  name, // attributeName
	  null, // attributeNamespace
	  false, // sanitizeURL
	  false);
	}); // These are HTML boolean attributes.
	
	['allowFullScreen', 'async', // Note: there is a special case that prevents it from being written to the DOM
	// on the client side because the browsers are inconsistent. Instead we call focus().
	'autoFocus', 'autoPlay', 'controls', 'default', 'defer', 'disabled', 'disablePictureInPicture', 'disableRemotePlayback', 'formNoValidate', 'hidden', 'loop', 'noModule', 'noValidate', 'open', 'playsInline', 'readOnly', 'required', 'reversed', 'scoped', 'seamless', // Microdata
	'itemScope'].forEach(function (name) {
	  properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, // mustUseProperty
	  name.toLowerCase(), // attributeName
	  null, // attributeNamespace
	  false, // sanitizeURL
	  false);
	}); // These are the few React props that we set as DOM properties
	// rather than attributes. These are all booleans.
	
	['checked', // Note: `option.selected` is not updated if `select.multiple` is
	// disabled with `removeAttribute`. We have special logic for handling this.
	'multiple', 'muted', 'selected' // NOTE: if you add a camelCased prop to this list,
	// you'll need to set attributeName to name.toLowerCase()
	// instead in the assignment below.
	].forEach(function (name) {
	  properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, // mustUseProperty
	  name, // attributeName
	  null, // attributeNamespace
	  false, // sanitizeURL
	  false);
	}); // These are HTML attributes that are "overloaded booleans": they behave like
	// booleans, but can also accept a string value.
	
	['capture', 'download' // NOTE: if you add a camelCased prop to this list,
	// you'll need to set attributeName to name.toLowerCase()
	// instead in the assignment below.
	].forEach(function (name) {
	  properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, // mustUseProperty
	  name, // attributeName
	  null, // attributeNamespace
	  false, // sanitizeURL
	  false);
	}); // These are HTML attributes that must be positive numbers.
	
	['cols', 'rows', 'size', 'span' // NOTE: if you add a camelCased prop to this list,
	// you'll need to set attributeName to name.toLowerCase()
	// instead in the assignment below.
	].forEach(function (name) {
	  properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, // mustUseProperty
	  name, // attributeName
	  null, // attributeNamespace
	  false, // sanitizeURL
	  false);
	}); // These are HTML attributes that must be numbers.
	
	['rowSpan', 'start'].forEach(function (name) {
	  properties[name] = new PropertyInfoRecord(name, NUMERIC, false, // mustUseProperty
	  name.toLowerCase(), // attributeName
	  null, // attributeNamespace
	  false, // sanitizeURL
	  false);
	});
	var CAMELIZE = /[\-\:]([a-z])/g;
	
	var capitalize = function capitalize(token) {
	  return token[1].toUpperCase();
	}; // This is a list of all SVG attributes that need special casing, namespacing,
	// or boolean value assignment. Regular attributes that just accept strings
	// and have the same names are omitted, just like in the HTML attribute filter.
	// Some of these attributes can be hard to find. This list was created by
	// scraping the MDN documentation.
	
	
	['accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline', 'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color', 'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1', 'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position', 'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position', 'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic', 'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode', 'xmlns:xlink', 'x-height' // NOTE: if you add a camelCased prop to this list,
	// you'll need to set attributeName to name.toLowerCase()
	// instead in the assignment below.
	].forEach(function (attributeName) {
	  var name = attributeName.replace(CAMELIZE, capitalize);
	  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
	  attributeName, null, // attributeNamespace
	  false, // sanitizeURL
	  false);
	}); // String SVG attributes with the xlink namespace.
	
	['xlink:actuate', 'xlink:arcrole', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type' // NOTE: if you add a camelCased prop to this list,
	// you'll need to set attributeName to name.toLowerCase()
	// instead in the assignment below.
	].forEach(function (attributeName) {
	  var name = attributeName.replace(CAMELIZE, capitalize);
	  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
	  attributeName, 'http://www.w3.org/1999/xlink', false, // sanitizeURL
	  false);
	}); // String SVG attributes with the xml namespace.
	
	['xml:base', 'xml:lang', 'xml:space' // NOTE: if you add a camelCased prop to this list,
	// you'll need to set attributeName to name.toLowerCase()
	// instead in the assignment below.
	].forEach(function (attributeName) {
	  var name = attributeName.replace(CAMELIZE, capitalize);
	  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
	  attributeName, 'http://www.w3.org/XML/1998/namespace', false, // sanitizeURL
	  false);
	}); // These attribute exists both in HTML and SVG.
	// The attribute name is case-sensitive in SVG so we can't just use
	// the React name like we do for attributes that exist only in HTML.
	
	['tabIndex', 'crossOrigin'].forEach(function (attributeName) {
	  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
	  attributeName.toLowerCase(), // attributeName
	  null, // attributeNamespace
	  false, // sanitizeURL
	  false);
	}); // These attributes accept URLs. These must not allow javascript: URLS.
	// These will also need to accept Trusted Types object in the future.
	
	var xlinkHref = 'xlinkHref';
	properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false, // mustUseProperty
	'xlink:href', 'http://www.w3.org/1999/xlink', true, // sanitizeURL
	false);
	['src', 'href', 'action', 'formAction'].forEach(function (attributeName) {
	  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
	  attributeName.toLowerCase(), // attributeName
	  null, // attributeNamespace
	  true, // sanitizeURL
	  true);
	});
	
	var _require = __webpack_require__(769),
	    CAMELCASE = _require.CAMELCASE,
	    SAME = _require.SAME,
	    possibleStandardNamesOptimized = _require.possibleStandardNames;
	
	var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
	var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
	/**
	 * Checks whether a property name is a custom attribute.
	 *
	 * @see {@link https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/HTMLDOMPropertyConfig.js#L23-L25}
	 *
	 * @param {string}
	 * @return {boolean}
	 */
	
	var isCustomAttribute = RegExp.prototype.test.bind( // eslint-disable-next-line no-misleading-character-class
	new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));
	var possibleStandardNames = Object.keys(possibleStandardNamesOptimized).reduce(function (accumulator, standardName) {
	  var propName = possibleStandardNamesOptimized[standardName];
	
	  if (propName === SAME) {
	    accumulator[standardName] = standardName;
	  } else if (propName === CAMELCASE) {
	    accumulator[standardName.toLowerCase()] = standardName;
	  } else {
	    accumulator[standardName] = propName;
	  }
	
	  return accumulator;
	}, {});
	
	exports.BOOLEAN = BOOLEAN;
	exports.BOOLEANISH_STRING = BOOLEANISH_STRING;
	exports.NUMERIC = NUMERIC;
	exports.OVERLOADED_BOOLEAN = OVERLOADED_BOOLEAN;
	exports.POSITIVE_NUMERIC = POSITIVE_NUMERIC;
	exports.RESERVED = RESERVED;
	exports.STRING = STRING;
	exports.getPropertyInfo = getPropertyInfo;
	exports.isCustomAttribute = isCustomAttribute;
	exports.possibleStandardNames = possibleStandardNames;


/***/ },
/* 769 */
/***/ function(module, exports) {

	// An attribute in which the DOM/SVG standard name is the same as the React prop name (e.g., 'accept').
	var SAME = 0;
	exports.SAME = SAME;
	
	// An attribute in which the React prop name is the camelcased version of the DOM/SVG standard name (e.g., 'acceptCharset').
	var CAMELCASE = 1;
	exports.CAMELCASE = CAMELCASE;
	
	exports.possibleStandardNames = {
	  accept: 0,
	  acceptCharset: 1,
	  'accept-charset': 'acceptCharset',
	  accessKey: 1,
	  action: 0,
	  allowFullScreen: 1,
	  alt: 0,
	  as: 0,
	  async: 0,
	  autoCapitalize: 1,
	  autoComplete: 1,
	  autoCorrect: 1,
	  autoFocus: 1,
	  autoPlay: 1,
	  autoSave: 1,
	  capture: 0,
	  cellPadding: 1,
	  cellSpacing: 1,
	  challenge: 0,
	  charSet: 1,
	  checked: 0,
	  children: 0,
	  cite: 0,
	  class: 'className',
	  classID: 1,
	  className: 1,
	  cols: 0,
	  colSpan: 1,
	  content: 0,
	  contentEditable: 1,
	  contextMenu: 1,
	  controls: 0,
	  controlsList: 1,
	  coords: 0,
	  crossOrigin: 1,
	  dangerouslySetInnerHTML: 1,
	  data: 0,
	  dateTime: 1,
	  default: 0,
	  defaultChecked: 1,
	  defaultValue: 1,
	  defer: 0,
	  dir: 0,
	  disabled: 0,
	  disablePictureInPicture: 1,
	  disableRemotePlayback: 1,
	  download: 0,
	  draggable: 0,
	  encType: 1,
	  enterKeyHint: 1,
	  for: 'htmlFor',
	  form: 0,
	  formMethod: 1,
	  formAction: 1,
	  formEncType: 1,
	  formNoValidate: 1,
	  formTarget: 1,
	  frameBorder: 1,
	  headers: 0,
	  height: 0,
	  hidden: 0,
	  high: 0,
	  href: 0,
	  hrefLang: 1,
	  htmlFor: 1,
	  httpEquiv: 1,
	  'http-equiv': 'httpEquiv',
	  icon: 0,
	  id: 0,
	  innerHTML: 1,
	  inputMode: 1,
	  integrity: 0,
	  is: 0,
	  itemID: 1,
	  itemProp: 1,
	  itemRef: 1,
	  itemScope: 1,
	  itemType: 1,
	  keyParams: 1,
	  keyType: 1,
	  kind: 0,
	  label: 0,
	  lang: 0,
	  list: 0,
	  loop: 0,
	  low: 0,
	  manifest: 0,
	  marginWidth: 1,
	  marginHeight: 1,
	  max: 0,
	  maxLength: 1,
	  media: 0,
	  mediaGroup: 1,
	  method: 0,
	  min: 0,
	  minLength: 1,
	  multiple: 0,
	  muted: 0,
	  name: 0,
	  noModule: 1,
	  nonce: 0,
	  noValidate: 1,
	  open: 0,
	  optimum: 0,
	  pattern: 0,
	  placeholder: 0,
	  playsInline: 1,
	  poster: 0,
	  preload: 0,
	  profile: 0,
	  radioGroup: 1,
	  readOnly: 1,
	  referrerPolicy: 1,
	  rel: 0,
	  required: 0,
	  reversed: 0,
	  role: 0,
	  rows: 0,
	  rowSpan: 1,
	  sandbox: 0,
	  scope: 0,
	  scoped: 0,
	  scrolling: 0,
	  seamless: 0,
	  selected: 0,
	  shape: 0,
	  size: 0,
	  sizes: 0,
	  span: 0,
	  spellCheck: 1,
	  src: 0,
	  srcDoc: 1,
	  srcLang: 1,
	  srcSet: 1,
	  start: 0,
	  step: 0,
	  style: 0,
	  summary: 0,
	  tabIndex: 1,
	  target: 0,
	  title: 0,
	  type: 0,
	  useMap: 1,
	  value: 0,
	  width: 0,
	  wmode: 0,
	  wrap: 0,
	  about: 0,
	  accentHeight: 1,
	  'accent-height': 'accentHeight',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 1,
	  'alignment-baseline': 'alignmentBaseline',
	  allowReorder: 1,
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 1,
	  'arabic-form': 'arabicForm',
	  ascent: 0,
	  attributeName: 1,
	  attributeType: 1,
	  autoReverse: 1,
	  azimuth: 0,
	  baseFrequency: 1,
	  baselineShift: 1,
	  'baseline-shift': 'baselineShift',
	  baseProfile: 1,
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 1,
	  capHeight: 1,
	  'cap-height': 'capHeight',
	  clip: 0,
	  clipPath: 1,
	  'clip-path': 'clipPath',
	  clipPathUnits: 1,
	  clipRule: 1,
	  'clip-rule': 'clipRule',
	  color: 0,
	  colorInterpolation: 1,
	  'color-interpolation': 'colorInterpolation',
	  colorInterpolationFilters: 1,
	  'color-interpolation-filters': 'colorInterpolationFilters',
	  colorProfile: 1,
	  'color-profile': 'colorProfile',
	  colorRendering: 1,
	  'color-rendering': 'colorRendering',
	  contentScriptType: 1,
	  contentStyleType: 1,
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  datatype: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 1,
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 1,
	  'dominant-baseline': 'dominantBaseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 1,
	  elevation: 0,
	  enableBackground: 1,
	  'enable-background': 'enableBackground',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 1,
	  fill: 0,
	  fillOpacity: 1,
	  'fill-opacity': 'fillOpacity',
	  fillRule: 1,
	  'fill-rule': 'fillRule',
	  filter: 0,
	  filterRes: 1,
	  filterUnits: 1,
	  floodOpacity: 1,
	  'flood-opacity': 'floodOpacity',
	  floodColor: 1,
	  'flood-color': 'floodColor',
	  focusable: 0,
	  fontFamily: 1,
	  'font-family': 'fontFamily',
	  fontSize: 1,
	  'font-size': 'fontSize',
	  fontSizeAdjust: 1,
	  'font-size-adjust': 'fontSizeAdjust',
	  fontStretch: 1,
	  'font-stretch': 'fontStretch',
	  fontStyle: 1,
	  'font-style': 'fontStyle',
	  fontVariant: 1,
	  'font-variant': 'fontVariant',
	  fontWeight: 1,
	  'font-weight': 'fontWeight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 1,
	  'glyph-name': 'glyphName',
	  glyphOrientationHorizontal: 1,
	  'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
	  glyphOrientationVertical: 1,
	  'glyph-orientation-vertical': 'glyphOrientationVertical',
	  glyphRef: 1,
	  gradientTransform: 1,
	  gradientUnits: 1,
	  hanging: 0,
	  horizAdvX: 1,
	  'horiz-adv-x': 'horizAdvX',
	  horizOriginX: 1,
	  'horiz-origin-x': 'horizOriginX',
	  ideographic: 0,
	  imageRendering: 1,
	  'image-rendering': 'imageRendering',
	  in2: 0,
	  in: 0,
	  inlist: 0,
	  intercept: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  k: 0,
	  kernelMatrix: 1,
	  kernelUnitLength: 1,
	  kerning: 0,
	  keyPoints: 1,
	  keySplines: 1,
	  keyTimes: 1,
	  lengthAdjust: 1,
	  letterSpacing: 1,
	  'letter-spacing': 'letterSpacing',
	  lightingColor: 1,
	  'lighting-color': 'lightingColor',
	  limitingConeAngle: 1,
	  local: 0,
	  markerEnd: 1,
	  'marker-end': 'markerEnd',
	  markerHeight: 1,
	  markerMid: 1,
	  'marker-mid': 'markerMid',
	  markerStart: 1,
	  'marker-start': 'markerStart',
	  markerUnits: 1,
	  markerWidth: 1,
	  mask: 0,
	  maskContentUnits: 1,
	  maskUnits: 1,
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 1,
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 1,
	  'overline-position': 'overlinePosition',
	  overlineThickness: 1,
	  'overline-thickness': 'overlineThickness',
	  paintOrder: 1,
	  'paint-order': 'paintOrder',
	  panose1: 0,
	  'panose-1': 'panose1',
	  pathLength: 1,
	  patternContentUnits: 1,
	  patternTransform: 1,
	  patternUnits: 1,
	  pointerEvents: 1,
	  'pointer-events': 'pointerEvents',
	  points: 0,
	  pointsAtX: 1,
	  pointsAtY: 1,
	  pointsAtZ: 1,
	  prefix: 0,
	  preserveAlpha: 1,
	  preserveAspectRatio: 1,
	  primitiveUnits: 1,
	  property: 0,
	  r: 0,
	  radius: 0,
	  refX: 1,
	  refY: 1,
	  renderingIntent: 1,
	  'rendering-intent': 'renderingIntent',
	  repeatCount: 1,
	  repeatDur: 1,
	  requiredExtensions: 1,
	  requiredFeatures: 1,
	  resource: 0,
	  restart: 0,
	  result: 0,
	  results: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  security: 0,
	  seed: 0,
	  shapeRendering: 1,
	  'shape-rendering': 'shapeRendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 1,
	  specularExponent: 1,
	  speed: 0,
	  spreadMethod: 1,
	  startOffset: 1,
	  stdDeviation: 1,
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 1,
	  stopColor: 1,
	  'stop-color': 'stopColor',
	  stopOpacity: 1,
	  'stop-opacity': 'stopOpacity',
	  strikethroughPosition: 1,
	  'strikethrough-position': 'strikethroughPosition',
	  strikethroughThickness: 1,
	  'strikethrough-thickness': 'strikethroughThickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 1,
	  'stroke-dasharray': 'strokeDasharray',
	  strokeDashoffset: 1,
	  'stroke-dashoffset': 'strokeDashoffset',
	  strokeLinecap: 1,
	  'stroke-linecap': 'strokeLinecap',
	  strokeLinejoin: 1,
	  'stroke-linejoin': 'strokeLinejoin',
	  strokeMiterlimit: 1,
	  'stroke-miterlimit': 'strokeMiterlimit',
	  strokeWidth: 1,
	  'stroke-width': 'strokeWidth',
	  strokeOpacity: 1,
	  'stroke-opacity': 'strokeOpacity',
	  suppressContentEditableWarning: 1,
	  suppressHydrationWarning: 1,
	  surfaceScale: 1,
	  systemLanguage: 1,
	  tableValues: 1,
	  targetX: 1,
	  targetY: 1,
	  textAnchor: 1,
	  'text-anchor': 'textAnchor',
	  textDecoration: 1,
	  'text-decoration': 'textDecoration',
	  textLength: 1,
	  textRendering: 1,
	  'text-rendering': 'textRendering',
	  to: 0,
	  transform: 0,
	  typeof: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 1,
	  'underline-position': 'underlinePosition',
	  underlineThickness: 1,
	  'underline-thickness': 'underlineThickness',
	  unicode: 0,
	  unicodeBidi: 1,
	  'unicode-bidi': 'unicodeBidi',
	  unicodeRange: 1,
	  'unicode-range': 'unicodeRange',
	  unitsPerEm: 1,
	  'units-per-em': 'unitsPerEm',
	  unselectable: 0,
	  vAlphabetic: 1,
	  'v-alphabetic': 'vAlphabetic',
	  values: 0,
	  vectorEffect: 1,
	  'vector-effect': 'vectorEffect',
	  version: 0,
	  vertAdvY: 1,
	  'vert-adv-y': 'vertAdvY',
	  vertOriginX: 1,
	  'vert-origin-x': 'vertOriginX',
	  vertOriginY: 1,
	  'vert-origin-y': 'vertOriginY',
	  vHanging: 1,
	  'v-hanging': 'vHanging',
	  vIdeographic: 1,
	  'v-ideographic': 'vIdeographic',
	  viewBox: 1,
	  viewTarget: 1,
	  visibility: 0,
	  vMathematical: 1,
	  'v-mathematical': 'vMathematical',
	  vocab: 0,
	  widths: 0,
	  wordSpacing: 1,
	  'word-spacing': 'wordSpacing',
	  writingMode: 1,
	  'writing-mode': 'writingMode',
	  x1: 0,
	  x2: 0,
	  x: 0,
	  xChannelSelector: 1,
	  xHeight: 1,
	  'x-height': 'xHeight',
	  xlinkActuate: 1,
	  'xlink:actuate': 'xlinkActuate',
	  xlinkArcrole: 1,
	  'xlink:arcrole': 'xlinkArcrole',
	  xlinkHref: 1,
	  'xlink:href': 'xlinkHref',
	  xlinkRole: 1,
	  'xlink:role': 'xlinkRole',
	  xlinkShow: 1,
	  'xlink:show': 'xlinkShow',
	  xlinkTitle: 1,
	  'xlink:title': 'xlinkTitle',
	  xlinkType: 1,
	  'xlink:type': 'xlinkType',
	  xmlBase: 1,
	  'xml:base': 'xmlBase',
	  xmlLang: 1,
	  'xml:lang': 'xmlLang',
	  xmlns: 0,
	  'xml:space': 'xmlSpace',
	  xmlnsXlink: 1,
	  'xmlns:xlink': 'xmlnsXlink',
	  xmlSpace: 1,
	  y1: 0,
	  y2: 0,
	  y: 0,
	  yChannelSelector: 1,
	  z: 0,
	  zoomAndPan: 1
	};


/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(3));
	
	function _typeof(obj) {
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof = function (obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof = function (obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }
	
	  return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = Object.keys(source);
	
	    if (typeof Object.getOwnPropertySymbols === 'function') {
	      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      _defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (typeof call === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return _assertThisInitialized(self);
	}
	
	var style = {
	  display: 'inline-block',
	  borderRadius: '50%',
	  border: '5px double white',
	  width: 30,
	  height: 30
	};
	var Style = {
	  empty: _objectSpread({}, style, {
	    backgroundColor: '#ccc'
	  }),
	  full: _objectSpread({}, style, {
	    backgroundColor: 'black'
	  }),
	  placeholder: _objectSpread({}, style, {
	    backgroundColor: 'red'
	  })
	};
	
	// Return the corresponding React node for an icon.
	var _iconNode = function _iconNode(icon) {
	  // If it is already a React Element just return it.
	  if (React.isValidElement(icon)) {
	    return icon;
	  } // If it is an object, try to use it as a CSS style object.
	
	
	  if (_typeof(icon) === 'object' && icon !== null) {
	    return React.createElement("span", {
	      style: icon
	    });
	  } // If it is a string, use it as class names.
	
	
	  if (Object.prototype.toString.call(icon) === '[object String]') {
	    return React.createElement("span", {
	      className: icon
	    });
	  }
	};
	
	var RatingSymbol =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(RatingSymbol, _React$PureComponent);
	
	  function RatingSymbol() {
	    _classCallCheck(this, RatingSymbol);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(RatingSymbol).apply(this, arguments));
	  }
	
	  _createClass(RatingSymbol, [{
	    key: "render",
	    value: function render() {
	      var _iconContainerStyle;
	
	      var _this$props = this.props,
	          index = _this$props.index,
	          inactiveIcon = _this$props.inactiveIcon,
	          activeIcon = _this$props.activeIcon,
	          percent = _this$props.percent,
	          direction = _this$props.direction,
	          readonly = _this$props.readonly,
	          onClick = _this$props.onClick,
	          onMouseMove = _this$props.onMouseMove;
	
	      var backgroundNode = _iconNode(inactiveIcon);
	
	      var showbgIcon = percent < 100;
	      var bgIconContainerStyle = showbgIcon ? {} : {
	        visibility: 'hidden'
	      };
	
	      var iconNode = _iconNode(activeIcon);
	
	      var iconContainerStyle = (_iconContainerStyle = {
	        display: 'inline-block',
	        position: 'absolute',
	        overflow: 'hidden',
	        top: 0
	      }, _defineProperty(_iconContainerStyle, direction === 'rtl' ? 'right' : 'left', 0), _defineProperty(_iconContainerStyle, "width", "".concat(percent, "%")), _iconContainerStyle);
	      var style = {
	        cursor: !readonly ? 'pointer' : 'inherit',
	        display: 'inline-block',
	        position: 'relative'
	      };
	
	      function handleMouseMove(e) {
	        if (onMouseMove) {
	          onMouseMove(index, e);
	        }
	      }
	
	      function handleMouseClick(e) {
	        if (onClick) {
	          // [Supporting both TouchEvent and MouseEvent](https://developer.mozilla.org/en-US/docs/Web/API/Touch_events/Supporting_both_TouchEvent_and_MouseEvent)
	          // We must prevent firing click event twice on touch devices.
	          e.preventDefault();
	          onClick(index, e);
	        }
	      }
	
	      return React.createElement("span", {
	        style: style,
	        onClick: handleMouseClick,
	        onMouseMove: handleMouseMove,
	        onTouchMove: handleMouseMove,
	        onTouchEnd: handleMouseClick
	      }, React.createElement("span", {
	        style: bgIconContainerStyle
	      }, backgroundNode), React.createElement("span", {
	        style: iconContainerStyle
	      }, iconNode));
	    }
	  }]);
	
	  return RatingSymbol;
	}(React.PureComponent); // Define propTypes only in development. They will be void in production.
	
	var Rating =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(Rating, _React$PureComponent);
	
	  function Rating(props) {
	    var _this;
	
	    _classCallCheck(this, Rating);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Rating).call(this, props));
	    _this.state = {
	      // Indicates the value that is displayed to the user in the form of symbols.
	      // It can be either 0 (for no displayed symbols) or (0, end]
	      displayValue: _this.props.value,
	      // Indicates if the user is currently hovering over the rating element
	      interacting: false
	    };
	    _this.onMouseLeave = _this.onMouseLeave.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.symbolMouseMove = _this.symbolMouseMove.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.symbolClick = _this.symbolClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    return _this;
	  }
	
	  _createClass(Rating, [{
	    key: "UNSAFE_componentWillReceiveProps",
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      var valueChanged = this.props.value !== nextProps.value;
	      this.setState(function (prevState) {
	        return {
	          displayValue: valueChanged ? nextProps.value : prevState.displayValue
	        };
	      });
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      // Ignore state update due to value changed from props.
	      // Usually originated through an onClick event.
	      if (prevProps.value !== this.props.value) {
	        return;
	      } // When hover ends, call this.props.onHover with no value.
	
	
	      if (prevState.interacting && !this.state.interacting) {
	        return this.props.onHover();
	      } // When hover over.
	
	
	      if (this.state.interacting) {
	        this.props.onHover(this.state.displayValue);
	      }
	    }
	  }, {
	    key: "symbolClick",
	    value: function symbolClick(symbolIndex, event) {
	      var value = this.calculateDisplayValue(symbolIndex, event);
	      this.props.onClick(value, event);
	    }
	  }, {
	    key: "symbolMouseMove",
	    value: function symbolMouseMove(symbolIndex, event) {
	      var value = this.calculateDisplayValue(symbolIndex, event); // This call should cause an update only if the state changes.
	      // Mainly the first time the mouse enters and whenever the value changes.
	      // So DidComponentUpdate is NOT called for every mouse movement.
	
	      this.setState({
	        interacting: !this.props.readonly,
	        displayValue: value
	      });
	    }
	  }, {
	    key: "onMouseLeave",
	    value: function onMouseLeave() {
	      this.setState({
	        displayValue: this.props.value,
	        interacting: false
	      });
	    }
	  }, {
	    key: "calculateDisplayValue",
	    value: function calculateDisplayValue(symbolIndex, event) {
	      var percentage = this.calculateHoverPercentage(event); // Get the closest top fraction.
	
	      var fraction = Math.ceil(percentage % 1 * this.props.fractions) / this.props.fractions; // Truncate decimal trying to avoid float precission issues.
	
	      var precision = Math.pow(10, 3);
	      var displayValue = symbolIndex + (Math.floor(percentage) + Math.floor(fraction * precision) / precision); // ensure the returned value is greater than 0 and lower than totalSymbols
	
	      return displayValue > 0 ? displayValue > this.props.totalSymbols ? this.props.totalSymbols : displayValue : 1 / this.props.fractions;
	    }
	  }, {
	    key: "calculateHoverPercentage",
	    value: function calculateHoverPercentage(event) {
	      var clientX = event.nativeEvent.type.indexOf("touch") > -1 ? event.nativeEvent.type.indexOf("touchend") > -1 ? event.changedTouches[0].clientX : event.touches[0].clientX : event.clientX;
	      var targetRect = event.target.getBoundingClientRect();
	      var delta = this.props.direction === 'rtl' ? targetRect.right - clientX : clientX - targetRect.left; // Returning 0 if the delta is negative solves the flickering issue
	
	      return delta < 0 ? 0 : delta / targetRect.width;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          readonly = _this$props.readonly,
	          quiet = _this$props.quiet,
	          totalSymbols = _this$props.totalSymbols,
	          value = _this$props.value,
	          placeholderValue = _this$props.placeholderValue,
	          direction = _this$props.direction,
	          emptySymbol = _this$props.emptySymbol,
	          fullSymbol = _this$props.fullSymbol,
	          placeholderSymbol = _this$props.placeholderSymbol,
	          className = _this$props.className,
	          id = _this$props.id,
	          style = _this$props.style,
	          tabIndex = _this$props.tabIndex;
	      var _this$state = this.state,
	          displayValue = _this$state.displayValue,
	          interacting = _this$state.interacting;
	      var symbolNodes = [];
	      var empty = [].concat(emptySymbol);
	      var full = [].concat(fullSymbol);
	      var placeholder = [].concat(placeholderSymbol);
	      var shouldDisplayPlaceholder = placeholderValue !== 0 && value === 0 && !interacting; // The value that will be used as base for calculating how to render the symbols
	
	      var renderedValue;
	
	      if (shouldDisplayPlaceholder) {
	        renderedValue = placeholderValue;
	      } else {
	        renderedValue = quiet ? value : displayValue;
	      } // The amount of full symbols
	
	
	      var fullSymbols = Math.floor(renderedValue);
	
	      for (var i = 0; i < totalSymbols; i++) {
	        var percent = void 0; // Calculate each symbol's fullness percentage
	
	        if (i - fullSymbols < 0) {
	          percent = 100;
	        } else if (i - fullSymbols === 0) {
	          percent = (renderedValue - i) * 100;
	        } else {
	          percent = 0;
	        }
	
	        symbolNodes.push(React.createElement(RatingSymbol, _extends({
	          key: i,
	          index: i,
	          readonly: readonly,
	          inactiveIcon: empty[i % empty.length],
	          activeIcon: shouldDisplayPlaceholder ? placeholder[i % full.length] : full[i % full.length],
	          percent: percent,
	          direction: direction
	        }, !readonly && {
	          onClick: this.symbolClick,
	          onMouseMove: this.symbolMouseMove,
	          onTouchMove: this.symbolMouseMove,
	          onTouchEnd: this.symbolClick
	        })));
	      }
	
	      return React.createElement("span", _extends({
	        id: id,
	        style: _objectSpread({}, style, {
	          display: 'inline-block',
	          direction: direction
	        }),
	        className: className,
	        tabIndex: tabIndex,
	        "aria-label": this.props['aria-label']
	      }, !readonly && {
	        onMouseLeave: this.onMouseLeave
	      }), symbolNodes);
	    }
	  }]);
	
	  return Rating;
	}(React.PureComponent); // Define propTypes only in development.
	
	function noop() {}
	
	noop._name = 'react_rating_noop';
	
	var RatingAPILayer =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(RatingAPILayer, _React$PureComponent);
	
	  function RatingAPILayer(props) {
	    var _this;
	
	    _classCallCheck(this, RatingAPILayer);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(RatingAPILayer).call(this, props));
	    _this.state = {
	      value: props.initialRating
	    };
	    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.handleHover = _this.handleHover.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    return _this;
	  }
	
	  _createClass(RatingAPILayer, [{
	    key: "UNSAFE_componentWillReceiveProps",
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      this.setState({
	        value: nextProps.initialRating
	      });
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(value, e) {
	      var _this2 = this;
	
	      var newValue = this.translateDisplayValueToValue(value);
	      this.props.onClick(newValue); // Avoid calling setState if not necessary. Micro optimisation.
	
	      if (this.state.value !== newValue) {
	        // If we have a new value trigger onChange callback.
	        this.setState({
	          value: newValue
	        }, function () {
	          return _this2.props.onChange(_this2.state.value);
	        });
	      }
	    }
	  }, {
	    key: "handleHover",
	    value: function handleHover(displayValue) {
	      var value = displayValue === undefined ? displayValue : this.translateDisplayValueToValue(displayValue);
	      this.props.onHover(value);
	    }
	  }, {
	    key: "translateDisplayValueToValue",
	    value: function translateDisplayValueToValue(displayValue) {
	      var translatedValue = displayValue * this.props.step + this.props.start; // minimum value cannot be equal to start, since it's exclusive
	
	      return translatedValue === this.props.start ? translatedValue + 1 / this.props.fractions : translatedValue;
	    }
	  }, {
	    key: "tranlateValueToDisplayValue",
	    value: function tranlateValueToDisplayValue(value) {
	      if (value === undefined) {
	        return 0;
	      }
	
	      return (value - this.props.start) / this.props.step;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          step = _this$props.step,
	          emptySymbol = _this$props.emptySymbol,
	          fullSymbol = _this$props.fullSymbol,
	          placeholderSymbol = _this$props.placeholderSymbol,
	          readonly = _this$props.readonly,
	          quiet = _this$props.quiet,
	          fractions = _this$props.fractions,
	          direction = _this$props.direction,
	          start = _this$props.start,
	          stop = _this$props.stop,
	          id = _this$props.id,
	          className = _this$props.className,
	          style = _this$props.style,
	          tabIndex = _this$props.tabIndex;
	
	      function calculateTotalSymbols(start, stop, step) {
	        return Math.floor((stop - start) / step);
	      }
	
	      return React.createElement(Rating, {
	        id: id,
	        style: style,
	        className: className,
	        tabIndex: tabIndex,
	        "aria-label": this.props['aria-label'],
	        totalSymbols: calculateTotalSymbols(start, stop, step),
	        value: this.tranlateValueToDisplayValue(this.state.value),
	        placeholderValue: this.tranlateValueToDisplayValue(this.props.placeholderRating),
	        readonly: readonly,
	        quiet: quiet,
	        fractions: fractions,
	        direction: direction,
	        emptySymbol: emptySymbol,
	        fullSymbol: fullSymbol,
	        placeholderSymbol: placeholderSymbol,
	        onClick: this.handleClick,
	        onHover: this.handleHover
	      });
	    }
	  }]);
	
	  return RatingAPILayer;
	}(React.PureComponent);
	
	RatingAPILayer.defaultProps = {
	  start: 0,
	  stop: 5,
	  step: 1,
	  readonly: false,
	  quiet: false,
	  fractions: 1,
	  direction: 'ltr',
	  onHover: noop,
	  onClick: noop,
	  onChange: noop,
	  emptySymbol: Style.empty,
	  fullSymbol: Style.full,
	  placeholderSymbol: Style.placeholder
	}; // Define propTypes only in development.
	
	module.exports = RatingAPILayer;


/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var reactRouter=__webpack_require__(773),React=_interopDefault(__webpack_require__(3)),history=__webpack_require__(223);__webpack_require__(38),__webpack_require__(113);var invariant=_interopDefault(__webpack_require__(162));function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var o in r)Object.prototype.hasOwnProperty.call(r,o)&&(e[o]=r[o])}return e}).apply(this,arguments)}function _inheritsLoose(e,t){e.prototype=Object.create(t.prototype),_setPrototypeOf(e.prototype.constructor=e,t)}function _setPrototypeOf(e,t){return(_setPrototypeOf=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function _objectWithoutPropertiesLoose(e,t){if(null==e)return{};var r,o,n={},a=Object.keys(e);for(o=0;o<a.length;o++)r=a[o],0<=t.indexOf(r)||(n[r]=e[r]);return n}var BrowserRouter=function(n){function e(){for(var e,t=arguments.length,r=new Array(t),o=0;o<t;o++)r[o]=arguments[o];return(e=n.call.apply(n,[this].concat(r))||this).history=history.createBrowserHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),HashRouter=function(n){function e(){for(var e,t=arguments.length,r=new Array(t),o=0;o<t;o++)r[o]=arguments[o];return(e=n.call.apply(n,[this].concat(r))||this).history=history.createHashHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),resolveToLocation=function(e,t){return"function"==typeof e?e(t):e},normalizeToLocation=function(e,t){return"string"==typeof e?history.createLocation(e,null,null,t):e},forwardRefShim=function(e){return e},forwardRef=React.forwardRef;function isModifiedEvent(e){return!!(e.metaKey||e.altKey||e.ctrlKey||e.shiftKey)}void 0===forwardRef&&(forwardRef=forwardRefShim);var LinkAnchor=forwardRef(function(e,t){var r=e.innerRef,o=e.navigate,n=e.onClick,a=_objectWithoutPropertiesLoose(e,["innerRef","navigate","onClick"]),i=a.target,c=_extends({},a,{onClick:function(t){try{n&&n(t)}catch(e){throw t.preventDefault(),e}t.defaultPrevented||0!==t.button||i&&"_self"!==i||isModifiedEvent(t)||(t.preventDefault(),o())}});return c.ref=forwardRefShim!==forwardRef&&t||r,React.createElement("a",c)}),Link=forwardRef(function(e,a){var t=e.component,i=void 0===t?LinkAnchor:t,c=e.replace,u=e.to,f=e.innerRef,s=_objectWithoutPropertiesLoose(e,["component","replace","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(r){r||invariant(!1);var o=r.history,e=normalizeToLocation(resolveToLocation(u,r.location),r.location),t=e?o.createHref(e):"",n=_extends({},s,{href:t,navigate:function(){var e=resolveToLocation(u,r.location),t=history.createPath(r.location)===history.createPath(normalizeToLocation(e));(c||t?o.replace:o.push)(e)}});return forwardRefShim!==forwardRef?n.ref=a||f:n.innerRef=f,React.createElement(i,n)})}),forwardRefShim$1=function(e){return e},forwardRef$1=React.forwardRef;function joinClassnames(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return t.filter(function(e){return e}).join(" ")}void 0===forwardRef$1&&(forwardRef$1=forwardRefShim$1);var NavLink=forwardRef$1(function(e,s){var t=e["aria-current"],l=void 0===t?"page":t,r=e.activeClassName,p=void 0===r?"active":r,R=e.activeStyle,h=e.className,y=e.exact,d=e.isActive,m=e.location,v=e.sensitive,b=e.strict,P=e.style,w=e.to,x=e.innerRef,g=_objectWithoutPropertiesLoose(e,["aria-current","activeClassName","activeStyle","className","exact","isActive","location","sensitive","strict","style","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(e){e||invariant(!1);var t=m||e.location,r=normalizeToLocation(resolveToLocation(w,t),t),o=r.pathname,n=o&&o.replace(/([.+*?=^!:${}()[\]|/\\])/g,"\\$1"),a=n?reactRouter.matchPath(t.pathname,{path:n,exact:y,sensitive:v,strict:b}):null,i=!!(d?d(a,t):a),c="function"==typeof h?h(i):h,u="function"==typeof P?P(i):P;i&&(c=joinClassnames(c,p),u=_extends({},u,R));var f=_extends({"aria-current":i&&l||null,className:c,style:u,to:r},g);return forwardRefShim$1!==forwardRef$1?f.ref=s||x:f.innerRef=x,React.createElement(Link,f)})});Object.defineProperty(exports,"MemoryRouter",{enumerable:!0,get:function(){return reactRouter.MemoryRouter}}),Object.defineProperty(exports,"Prompt",{enumerable:!0,get:function(){return reactRouter.Prompt}}),Object.defineProperty(exports,"Redirect",{enumerable:!0,get:function(){return reactRouter.Redirect}}),Object.defineProperty(exports,"Route",{enumerable:!0,get:function(){return reactRouter.Route}}),Object.defineProperty(exports,"Router",{enumerable:!0,get:function(){return reactRouter.Router}}),Object.defineProperty(exports,"StaticRouter",{enumerable:!0,get:function(){return reactRouter.StaticRouter}}),Object.defineProperty(exports,"Switch",{enumerable:!0,get:function(){return reactRouter.Switch}}),Object.defineProperty(exports,"generatePath",{enumerable:!0,get:function(){return reactRouter.generatePath}}),Object.defineProperty(exports,"matchPath",{enumerable:!0,get:function(){return reactRouter.matchPath}}),Object.defineProperty(exports,"useHistory",{enumerable:!0,get:function(){return reactRouter.useHistory}}),Object.defineProperty(exports,"useLocation",{enumerable:!0,get:function(){return reactRouter.useLocation}}),Object.defineProperty(exports,"useParams",{enumerable:!0,get:function(){return reactRouter.useParams}}),Object.defineProperty(exports,"useRouteMatch",{enumerable:!0,get:function(){return reactRouter.useRouteMatch}}),Object.defineProperty(exports,"withRouter",{enumerable:!0,get:function(){return reactRouter.withRouter}}),exports.BrowserRouter=BrowserRouter,exports.HashRouter=HashRouter,exports.Link=Link,exports.NavLink=NavLink;
	//# sourceMappingURL=react-router-dom.min.js.map


/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(3));__webpack_require__(38);var history=__webpack_require__(223);__webpack_require__(113);var createContext=_interopDefault(__webpack_require__(668)),invariant=_interopDefault(__webpack_require__(162)),pathToRegexp=_interopDefault(__webpack_require__(775));__webpack_require__(159);var hoistStatics=_interopDefault(__webpack_require__(650));function _extends(){return(_extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function _inheritsLoose(t,e){t.prototype=Object.create(e.prototype),_setPrototypeOf(t.prototype.constructor=t,e)}function _setPrototypeOf(t,e){return(_setPrototypeOf=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function _objectWithoutPropertiesLoose(t,e){if(null==t)return{};var n,o,r={},a=Object.keys(t);for(o=0;o<a.length;o++)n=a[o],0<=e.indexOf(n)||(r[n]=t[n]);return r}var createNamedContext=function(t){var e=createContext();return e.displayName=t,e},historyContext=createNamedContext("Router-History"),context=createNamedContext("Router"),Router=function(n){function t(t){var e;return(e=n.call(this,t)||this).state={location:t.history.location},e._isMounted=!1,e._pendingLocation=null,t.staticContext||(e.unlisten=t.history.listen(function(t){e._isMounted?e.setState({location:t}):e._pendingLocation=t})),e}_inheritsLoose(t,n),t.computeRootMatch=function(t){return{path:"/",url:"/",params:{},isExact:"/"===t}};var e=t.prototype;return e.componentDidMount=function(){this._isMounted=!0,this._pendingLocation&&this.setState({location:this._pendingLocation})},e.componentWillUnmount=function(){this.unlisten&&(this.unlisten(),this._isMounted=!1,this._pendingLocation=null)},e.render=function(){return React.createElement(context.Provider,{value:{history:this.props.history,location:this.state.location,match:t.computeRootMatch(this.state.location.pathname),staticContext:this.props.staticContext}},React.createElement(historyContext.Provider,{children:this.props.children||null,value:this.props.history}))},t}(React.Component),MemoryRouter=function(r){function t(){for(var t,e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))||this).history=history.createMemoryHistory(t.props),t}return _inheritsLoose(t,r),t.prototype.render=function(){return React.createElement(Router,{history:this.history,children:this.props.children})},t}(React.Component),Lifecycle=function(t){function e(){return t.apply(this,arguments)||this}_inheritsLoose(e,t);var n=e.prototype;return n.componentDidMount=function(){this.props.onMount&&this.props.onMount.call(this,this)},n.componentDidUpdate=function(t){this.props.onUpdate&&this.props.onUpdate.call(this,this,t)},n.componentWillUnmount=function(){this.props.onUnmount&&this.props.onUnmount.call(this,this)},n.render=function(){return null},e}(React.Component);function Prompt(t){var o=t.message,e=t.when,r=void 0===e||e;return React.createElement(context.Consumer,null,function(t){if(t||invariant(!1),!r||t.staticContext)return null;var n=t.history.block;return React.createElement(Lifecycle,{onMount:function(t){t.release=n(o)},onUpdate:function(t,e){e.message!==o&&(t.release(),t.release=n(o))},onUnmount:function(t){t.release()},message:o})})}var cache={},cacheLimit=1e4,cacheCount=0;function compilePath(t){if(cache[t])return cache[t];var e=pathToRegexp.compile(t);return cacheCount<cacheLimit&&(cache[t]=e,cacheCount++),e}function generatePath(t,e){return void 0===t&&(t="/"),void 0===e&&(e={}),"/"===t?t:compilePath(t)(e,{pretty:!0})}function Redirect(t){var a=t.computedMatch,i=t.to,e=t.push,c=void 0!==e&&e;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=t.history,n=t.staticContext,o=c?e.push:e.replace,r=history.createLocation(a?"string"==typeof i?generatePath(i,a.params):_extends({},i,{pathname:generatePath(i.pathname,a.params)}):i);return n?(o(r),null):React.createElement(Lifecycle,{onMount:function(){o(r)},onUpdate:function(t,e){var n=history.createLocation(e.to);history.locationsAreEqual(n,_extends({},r,{key:n.key}))||o(r)},to:i})})}var cache$1={},cacheLimit$1=1e4,cacheCount$1=0;function compilePath$1(t,e){var n=""+e.end+e.strict+e.sensitive,o=cache$1[n]||(cache$1[n]={});if(o[t])return o[t];var r=[],a={regexp:pathToRegexp(t,r,e),keys:r};return cacheCount$1<cacheLimit$1&&(o[t]=a,cacheCount$1++),a}function matchPath(u,t){void 0===t&&(t={}),"string"!=typeof t&&!Array.isArray(t)||(t={path:t});var e=t,n=e.path,o=e.exact,p=void 0!==o&&o,r=e.strict,h=void 0!==r&&r,a=e.sensitive,l=void 0!==a&&a;return[].concat(n).reduce(function(t,e){if(!e&&""!==e)return null;if(t)return t;var n=compilePath$1(e,{end:p,strict:h,sensitive:l}),o=n.regexp,r=n.keys,a=o.exec(u);if(!a)return null;var i=a[0],c=a.slice(1),s=u===i;return p&&!s?null:{path:e,url:"/"===e&&""===i?"/":i,isExact:s,params:r.reduce(function(t,e,n){return t[e.name]=c[n],t},{})}},null)}function isEmptyChildren(t){return 0===React.Children.count(t)}var Route=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var c=this;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=c.props.location||t.location,n=_extends({},t,{location:e,match:c.props.computedMatch?c.props.computedMatch:c.props.path?matchPath(e.pathname,c.props):t.match}),o=c.props,r=o.children,a=o.component,i=o.render;return Array.isArray(r)&&isEmptyChildren(r)&&(r=null),React.createElement(context.Provider,{value:n},n.match?r?"function"==typeof r?r(n):r:a?React.createElement(a,n):i?i(n):null:"function"==typeof r?r(n):null)})},e}(React.Component);function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function addBasename(t,e){return t?_extends({},e,{pathname:addLeadingSlash(t)+e.pathname}):e}function stripBasename(t,e){if(!t)return e;var n=addLeadingSlash(t);return 0!==e.pathname.indexOf(n)?e:_extends({},e,{pathname:e.pathname.substr(n.length)})}function createURL(t){return"string"==typeof t?t:history.createPath(t)}function staticHandler(t){return function(){invariant(!1)}}function noop(){}var StaticRouter=function(r){function t(){for(var e,t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))||this).handlePush=function(t){return e.navigateTo(t,"PUSH")},e.handleReplace=function(t){return e.navigateTo(t,"REPLACE")},e.handleListen=function(){return noop},e.handleBlock=function(){return noop},e}_inheritsLoose(t,r);var e=t.prototype;return e.navigateTo=function(t,e){var n=this.props,o=n.basename,r=void 0===o?"":o,a=n.context,i=void 0===a?{}:a;i.action=e,i.location=addBasename(r,history.createLocation(t)),i.url=createURL(i.location)},e.render=function(){var t=this.props,e=t.basename,n=void 0===e?"":e,o=t.context,r=void 0===o?{}:o,a=t.location,i=void 0===a?"/":a,c=_objectWithoutPropertiesLoose(t,["basename","context","location"]),s={createHref:function(t){return addLeadingSlash(n+createURL(t))},action:"POP",location:stripBasename(n,history.createLocation(i)),push:this.handlePush,replace:this.handleReplace,go:staticHandler(),goBack:staticHandler(),goForward:staticHandler(),listen:this.handleListen,block:this.handleBlock};return React.createElement(Router,_extends({},c,{history:s,staticContext:r}))},t}(React.Component),Switch=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var t=this;return React.createElement(context.Consumer,null,function(n){n||invariant(!1);var o,r,a=t.props.location||n.location;return React.Children.forEach(t.props.children,function(t){if(null==r&&React.isValidElement(t)){var e=(o=t).props.path||t.props.from;r=e?matchPath(a.pathname,_extends({},t.props,{path:e})):n.match}}),r?React.cloneElement(o,{location:a,computedMatch:r}):null})},e}(React.Component);function withRouter(o){function t(t){var e=t.wrappedComponentRef,n=_objectWithoutPropertiesLoose(t,["wrappedComponentRef"]);return React.createElement(context.Consumer,null,function(t){return t||invariant(!1),React.createElement(o,_extends({},n,t,{ref:e}))})}var e="withRouter("+(o.displayName||o.name)+")";return t.displayName=e,t.WrappedComponent=o,hoistStatics(t,o)}var useContext=React.useContext;function useHistory(){return useContext(historyContext)}function useLocation(){return useContext(context).location}function useParams(){var t=useContext(context).match;return t?t.params:{}}function useRouteMatch(t){var e=useLocation(),n=useContext(context).match;return t?matchPath(e.pathname,t):n}exports.MemoryRouter=MemoryRouter,exports.Prompt=Prompt,exports.Redirect=Redirect,exports.Route=Route,exports.Router=Router,exports.StaticRouter=StaticRouter,exports.Switch=Switch,exports.__HistoryContext=historyContext,exports.__RouterContext=context,exports.generatePath=generatePath,exports.matchPath=matchPath,exports.useHistory=useHistory,exports.useLocation=useLocation,exports.useParams=useParams,exports.useRouteMatch=useRouteMatch,exports.withRouter=withRouter;
	//# sourceMappingURL=react-router.min.js.map


/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(772);
	} else {
	  module.exports = require("./cjs/react-router.js");
	}


/***/ },
/* 774 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(774)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options), options)
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens, options) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options && options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(778).enable();
	  window.Promise = __webpack_require__(777);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(779);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(16);


/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(400);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(400);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 779 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NextArrow = exports.PrevArrow = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(77));
	
	var _innerSliderUtils = __webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var PrevArrow = /*#__PURE__*/function (_React$PureComponent) {
	  _inherits(PrevArrow, _React$PureComponent);
	
	  var _super = _createSuper(PrevArrow);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(PrevArrow, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.clickHandler(options, e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var prevClasses = {
	        "slick-arrow": true,
	        "slick-prev": true
	      };
	      var prevHandler = this.clickHandler.bind(this, {
	        message: "previous"
	      });
	
	      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	        prevClasses["slick-disabled"] = true;
	        prevHandler = null;
	      }
	
	      var prevArrowProps = {
	        key: "0",
	        "data-role": "none",
	        className: (0, _classnames["default"])(prevClasses),
	        style: {
	          display: "block"
	        },
	        onClick: prevHandler
	      };
	      var customProps = {
	        currentSlide: this.props.currentSlide,
	        slideCount: this.props.slideCount
	      };
	      var prevArrow;
	
	      if (this.props.prevArrow) {
	        prevArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.prevArrow, _objectSpread(_objectSpread({}, prevArrowProps), customProps));
	      } else {
	        prevArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
	          key: "0",
	          type: "button"
	        }, prevArrowProps), " ", "Previous");
	      }
	
	      return prevArrow;
	    }
	  }]);
	
	  return PrevArrow;
	}(_react["default"].PureComponent);
	
	exports.PrevArrow = PrevArrow;
	
	var NextArrow = /*#__PURE__*/function (_React$PureComponent2) {
	  _inherits(NextArrow, _React$PureComponent2);
	
	  var _super2 = _createSuper(NextArrow);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _super2.apply(this, arguments);
	  }
	
	  _createClass(NextArrow, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.clickHandler(options, e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var nextClasses = {
	        "slick-arrow": true,
	        "slick-next": true
	      };
	      var nextHandler = this.clickHandler.bind(this, {
	        message: "next"
	      });
	
	      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
	        nextClasses["slick-disabled"] = true;
	        nextHandler = null;
	      }
	
	      var nextArrowProps = {
	        key: "1",
	        "data-role": "none",
	        className: (0, _classnames["default"])(nextClasses),
	        style: {
	          display: "block"
	        },
	        onClick: nextHandler
	      };
	      var customProps = {
	        currentSlide: this.props.currentSlide,
	        slideCount: this.props.slideCount
	      };
	      var nextArrow;
	
	      if (this.props.nextArrow) {
	        nextArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.nextArrow, _objectSpread(_objectSpread({}, nextArrowProps), customProps));
	      } else {
	        nextArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
	          key: "1",
	          type: "button"
	        }, nextArrowProps), " ", "Next");
	      }
	
	      return nextArrow;
	    }
	  }]);
	
	  return NextArrow;
	}(_react["default"].PureComponent);
	
	exports.NextArrow = NextArrow;

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var defaultProps = {
	  accessibility: true,
	  adaptiveHeight: false,
	  afterChange: null,
	  appendDots: function appendDots(dots) {
	    return /*#__PURE__*/_react["default"].createElement("ul", {
	      style: {
	        display: "block"
	      }
	    }, dots);
	  },
	  arrows: true,
	  autoplay: false,
	  autoplaySpeed: 3000,
	  beforeChange: null,
	  centerMode: false,
	  centerPadding: "50px",
	  className: "",
	  cssEase: "ease",
	  customPaging: function customPaging(i) {
	    return /*#__PURE__*/_react["default"].createElement("button", null, i + 1);
	  },
	  dots: false,
	  dotsClass: "slick-dots",
	  draggable: true,
	  easing: "linear",
	  edgeFriction: 0.35,
	  fade: false,
	  focusOnSelect: false,
	  infinite: true,
	  initialSlide: 0,
	  lazyLoad: null,
	  nextArrow: null,
	  onEdge: null,
	  onInit: null,
	  onLazyLoadError: null,
	  onReInit: null,
	  pauseOnDotsHover: false,
	  pauseOnFocus: false,
	  pauseOnHover: true,
	  prevArrow: null,
	  responsive: null,
	  rows: 1,
	  rtl: false,
	  slide: "div",
	  slidesPerRow: 1,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  speed: 500,
	  swipe: true,
	  swipeEvent: null,
	  swipeToSlide: false,
	  touchMove: true,
	  touchThreshold: 5,
	  useCSS: true,
	  useTransform: true,
	  variableWidth: false,
	  vertical: false,
	  waitForAnimate: true
	};
	var _default = defaultProps;
	exports["default"] = _default;

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Dots = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(77));
	
	var _innerSliderUtils = __webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	
	  if (spec.infinite) {
	    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  } else {
	    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
	  }
	
	  return dots;
	};
	
	var Dots = /*#__PURE__*/function (_React$PureComponent) {
	  _inherits(Dots, _React$PureComponent);
	
	  var _super = _createSuper(Dots);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(Dots, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      // In Autoplay the focus stays on clicked button even after transition
	      // to next slide. That only goes away by click somewhere outside
	      e.preventDefault();
	      this.props.clickHandler(options);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          onMouseEnter = _this$props.onMouseEnter,
	          onMouseOver = _this$props.onMouseOver,
	          onMouseLeave = _this$props.onMouseLeave,
	          infinite = _this$props.infinite,
	          slidesToScroll = _this$props.slidesToScroll,
	          slidesToShow = _this$props.slidesToShow,
	          slideCount = _this$props.slideCount,
	          currentSlide = _this$props.currentSlide;
	      var dotCount = getDotCount({
	        slideCount: slideCount,
	        slidesToScroll: slidesToScroll,
	        slidesToShow: slidesToShow,
	        infinite: infinite
	      });
	      var mouseEvents = {
	        onMouseEnter: onMouseEnter,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave
	      };
	      var dots = [];
	
	      for (var i = 0; i < dotCount; i++) {
	        var _rightBound = (i + 1) * slidesToScroll - 1;
	
	        var rightBound = infinite ? _rightBound : (0, _innerSliderUtils.clamp)(_rightBound, 0, slideCount - 1);
	
	        var _leftBound = rightBound - (slidesToScroll - 1);
	
	        var leftBound = infinite ? _leftBound : (0, _innerSliderUtils.clamp)(_leftBound, 0, slideCount - 1);
	        var className = (0, _classnames["default"])({
	          "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
	        });
	        var dotOptions = {
	          message: "dots",
	          index: i,
	          slidesToScroll: slidesToScroll,
	          currentSlide: currentSlide
	        };
	        var onClick = this.clickHandler.bind(this, dotOptions);
	        dots = dots.concat( /*#__PURE__*/_react["default"].createElement("li", {
	          key: i,
	          className: className
	        }, /*#__PURE__*/_react["default"].cloneElement(this.props.customPaging(i), {
	          onClick: onClick
	        })));
	      }
	
	      return /*#__PURE__*/_react["default"].cloneElement(this.props.appendDots(dots), _objectSpread({
	        className: this.props.dotsClass
	      }, mouseEvents));
	    }
	  }]);
	
	  return Dots;
	}(_react["default"].PureComponent);
	
	exports.Dots = Dots;

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _slider = _interopRequireDefault(__webpack_require__(786));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _slider["default"];
	exports["default"] = _default;

/***/ },
/* 784 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var initialState = {
	  animating: false,
	  autoplaying: null,
	  currentDirection: 0,
	  currentLeft: null,
	  currentSlide: 0,
	  direction: 1,
	  dragging: false,
	  edgeDragged: false,
	  initialized: false,
	  lazyLoadedList: [],
	  listHeight: null,
	  listWidth: null,
	  scrolling: false,
	  slideCount: null,
	  slideHeight: null,
	  slideWidth: null,
	  swipeLeft: null,
	  swiped: false,
	  // used by swipeEvent. differentites between touch and swipe.
	  swiping: false,
	  touchObject: {
	    startX: 0,
	    startY: 0,
	    curX: 0,
	    curY: 0
	  },
	  trackStyle: {},
	  trackWidth: 0,
	  targetSlide: 0
	};
	var _default = initialState;
	exports["default"] = _default;

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InnerSlider = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(3));
	
	var _initialState = _interopRequireDefault(__webpack_require__(784));
	
	var _lodash = _interopRequireDefault(__webpack_require__(667));
	
	var _classnames = _interopRequireDefault(__webpack_require__(77));
	
	var _innerSliderUtils = __webpack_require__(84);
	
	var _track = __webpack_require__(787);
	
	var _dots = __webpack_require__(782);
	
	var _arrows = __webpack_require__(780);
	
	var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(809));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var InnerSlider = /*#__PURE__*/function (_React$Component) {
	  _inherits(InnerSlider, _React$Component);
	
	  var _super = _createSuper(InnerSlider);
	
	  function InnerSlider(props) {
	    var _this;
	
	    _classCallCheck(this, InnerSlider);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "listRefHandler", function (ref) {
	      return _this.list = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "trackRefHandler", function (ref) {
	      return _this.track = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "adaptHeight", function () {
	      if (_this.props.adaptiveHeight && _this.list) {
	        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));
	
	        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
	      _this.props.onInit && _this.props.onInit();
	
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));
	
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	
	      var spec = _objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props);
	
	      _this.updateState(spec, true, function () {
	        _this.adaptHeight();
	
	        _this.props.autoplay && _this.autoPlay("update");
	      });
	
	      if (_this.props.lazyLoad === "progressive") {
	        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
	      }
	
	      _this.ro = new _resizeObserverPolyfill["default"](function () {
	        if (_this.state.animating) {
	          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
	
	
	          _this.callbackTimers.push(setTimeout(function () {
	            return _this.onWindowResized();
	          }, _this.props.speed));
	        } else {
	          _this.onWindowResized();
	        }
	      });
	
	      _this.ro.observe(_this.list);
	
	      document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
	        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
	        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
	      });
	
	      if (window.addEventListener) {
	        window.addEventListener("resize", _this.onWindowResized);
	      } else {
	        window.attachEvent("onresize", _this.onWindowResized);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
	      if (_this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	      }
	
	      if (_this.lazyLoadTimer) {
	        clearInterval(_this.lazyLoadTimer);
	      }
	
	      if (_this.callbackTimers.length) {
	        _this.callbackTimers.forEach(function (timer) {
	          return clearTimeout(timer);
	        });
	
	        _this.callbackTimers = [];
	      }
	
	      if (window.addEventListener) {
	        window.removeEventListener("resize", _this.onWindowResized);
	      } else {
	        window.detachEvent("onresize", _this.onWindowResized);
	      }
	
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	
	      _this.ro.disconnect();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
	      _this.checkImagesLoad();
	
	      _this.props.onReInit && _this.props.onReInit();
	
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));
	
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      } // if (this.props.onLazyLoad) {
	      //   this.props.onLazyLoad([leftMostSlide])
	      // }
	
	
	      _this.adaptHeight();
	
	      var spec = _objectSpread(_objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props), _this.state);
	
	      var setTrackStyle = _this.didPropsChange(prevProps);
	
	      setTrackStyle && _this.updateState(spec, setTrackStyle, function () {
	        if (_this.state.currentSlide >= _react["default"].Children.count(_this.props.children)) {
	          _this.changeSlide({
	            message: "index",
	            index: _react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
	            currentSlide: _this.state.currentSlide
	          });
	        }
	
	        if (_this.props.autoplay) {
	          _this.autoPlay("update");
	        } else {
	          _this.pause("paused");
	        }
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onWindowResized", function (setTrackStyle) {
	      if (_this.debouncedResize) _this.debouncedResize.cancel();
	      _this.debouncedResize = (0, _lodash["default"])(function () {
	        return _this.resizeWindow(setTrackStyle);
	      }, 50);
	
	      _this.debouncedResize();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
	      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	      var isTrackMounted = Boolean(_this.track && _this.track.node); // prevent warning: setting state on unmounted component (server side rendering)
	
	      if (!isTrackMounted) return;
	
	      var spec = _objectSpread(_objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props), _this.state);
	
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
	      }); // animating state should be cleared while resizing, otherwise autoplay stops working
	
	
	      _this.setState({
	        animating: false
	      });
	
	      clearTimeout(_this.animationEndCallback);
	      delete _this.animationEndCallback;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "updateState", function (spec, setTrackStyle, callback) {
	      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
	      spec = _objectSpread(_objectSpread(_objectSpread({}, spec), updatedState), {}, {
	        slideIndex: updatedState.currentSlide
	      });
	      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
	      spec = _objectSpread(_objectSpread({}, spec), {}, {
	        left: targetLeft
	      });
	      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
	
	      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
	        updatedState["trackStyle"] = trackStyle;
	      }
	
	      _this.setState(updatedState, callback);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ssrInit", function () {
	      if (_this.props.variableWidth) {
	        var _trackWidth = 0,
	            _trackLeft = 0;
	        var childrenWidths = [];
	        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	          slideCount: _this.props.children.length
	        }));
	        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	          slideCount: _this.props.children.length
	        }));
	
	        _this.props.children.forEach(function (child) {
	          childrenWidths.push(child.props.style.width);
	          _trackWidth += child.props.style.width;
	        });
	
	        for (var i = 0; i < preClones; i++) {
	          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
	          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
	        }
	
	        for (var _i = 0; _i < postClones; _i++) {
	          _trackWidth += childrenWidths[_i];
	        }
	
	        for (var _i2 = 0; _i2 < _this.state.currentSlide; _i2++) {
	          _trackLeft += childrenWidths[_i2];
	        }
	
	        var _trackStyle = {
	          width: _trackWidth + "px",
	          left: -_trackLeft + "px"
	        };
	
	        if (_this.props.centerMode) {
	          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
	          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
	        }
	
	        return {
	          trackStyle: _trackStyle
	        };
	      }
	
	      var childrenCount = _react["default"].Children.count(_this.props.children);
	
	      var spec = _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	        slideCount: childrenCount
	      });
	
	      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
	      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
	      var slideWidth = 100 / slideCount;
	      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
	
	      if (_this.props.centerMode) {
	        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
	      }
	
	      var trackStyle = {
	        width: trackWidth + "%",
	        left: trackLeft + "%"
	      };
	      return {
	        slideWidth: slideWidth + "%",
	        trackStyle: trackStyle
	      };
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "checkImagesLoad", function () {
	      var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
	      var imagesCount = images.length,
	          loadedCount = 0;
	      Array.prototype.forEach.call(images, function (image) {
	        var handler = function handler() {
	          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
	        };
	
	        if (!image.onclick) {
	          image.onclick = function () {
	            return image.parentNode.focus();
	          };
	        } else {
	          var prevClickHandler = image.onclick;
	
	          image.onclick = function () {
	            prevClickHandler();
	            image.parentNode.focus();
	          };
	        }
	
	        if (!image.onload) {
	          if (_this.props.lazyLoad) {
	            image.onload = function () {
	              _this.adaptHeight();
	
	              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
	            };
	          } else {
	            image.onload = handler;
	
	            image.onerror = function () {
	              handler();
	              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
	            };
	          }
	        }
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "progressiveLazyLoad", function () {
	      var slidesToLoad = [];
	
	      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
	
	      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
	        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
	          slidesToLoad.push(index);
	          break;
	        }
	      }
	
	      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
	        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
	          slidesToLoad.push(_index);
	          break;
	        }
	      }
	
	      if (slidesToLoad.length > 0) {
	        _this.setState(function (state) {
	          return {
	            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
	          };
	        });
	
	        if (_this.props.onLazyLoad) {
	          _this.props.onLazyLoad(slidesToLoad);
	        }
	      } else {
	        if (_this.lazyLoadTimer) {
	          clearInterval(_this.lazyLoadTimer);
	          delete _this.lazyLoadTimer;
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slideHandler", function (index) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var _this$props = _this.props,
	          asNavFor = _this$props.asNavFor,
	          beforeChange = _this$props.beforeChange,
	          onLazyLoad = _this$props.onLazyLoad,
	          speed = _this$props.speed,
	          afterChange = _this$props.afterChange; // capture currentslide before state is updated
	
	      var currentSlide = _this.state.currentSlide;
	
	      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread(_objectSpread(_objectSpread({
	        index: index
	      }, _this.props), _this.state), {}, {
	        trackRef: _this.track,
	        useCSS: _this.props.useCSS && !dontAnimate
	      })),
	          state = _slideHandler.state,
	          nextState = _slideHandler.nextState;
	
	      if (!state) return;
	      beforeChange && beforeChange(currentSlide, state.currentSlide);
	      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
	        return _this.state.lazyLoadedList.indexOf(value) < 0;
	      });
	      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
	
	      if (!_this.props.waitForAnimate && _this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	        afterChange && afterChange(currentSlide);
	        delete _this.animationEndCallback;
	      }
	
	      _this.setState(state, function () {
	        // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
	        if (asNavFor && _this.asNavForIndex !== index) {
	          _this.asNavForIndex = index;
	          asNavFor.innerSlider.slideHandler(index);
	        }
	
	        if (!nextState) return;
	        _this.animationEndCallback = setTimeout(function () {
	          var animating = nextState.animating,
	              firstBatch = _objectWithoutProperties(nextState, ["animating"]);
	
	          _this.setState(firstBatch, function () {
	            _this.callbackTimers.push(setTimeout(function () {
	              return _this.setState({
	                animating: animating
	              });
	            }, 10));
	
	            afterChange && afterChange(state.currentSlide);
	            delete _this.animationEndCallback;
	          });
	        }, speed);
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (options) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
	
	      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
	      if (targetSlide !== 0 && !targetSlide) return;
	
	      if (dontAnimate === true) {
	        _this.slideHandler(targetSlide, dontAnimate);
	      } else {
	        _this.slideHandler(targetSlide);
	      }
	
	      _this.props.autoplay && _this.autoPlay("update");
	
	      if (_this.props.focusOnSelect) {
	        var nodes = _this.list.querySelectorAll(".slick-current");
	
	        nodes[0] && nodes[0].focus();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
	      if (_this.clickable === false) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	
	      _this.clickable = true;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (e) {
	      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
	      dir !== "" && _this.changeSlide({
	        message: dir
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "selectHandler", function (options) {
	      _this.changeSlide(options);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "disableBodyScroll", function () {
	      var preventDefault = function preventDefault(e) {
	        e = e || window.event;
	        if (e.preventDefault) e.preventDefault();
	        e.returnValue = false;
	      };
	
	      window.ontouchmove = preventDefault;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "enableBodyScroll", function () {
	      window.ontouchmove = null;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
	      if (_this.props.verticalSwiping) {
	        _this.disableBodyScroll();
	      }
	
	      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
	      state !== "" && _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
	      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	
	      if (state["swiping"]) {
	        _this.clickable = false;
	      }
	
	      _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {
	      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      var triggerSlideHandler = state["triggerSlideHandler"];
	      delete state["triggerSlideHandler"];
	
	      _this.setState(state);
	
	      if (triggerSlideHandler === undefined) return;
	
	      _this.slideHandler(triggerSlideHandler);
	
	      if (_this.props.verticalSwiping) {
	        _this.enableBodyScroll();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "touchEnd", function (e) {
	      _this.swipeEnd(e);
	
	      _this.clickable = true;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
	      // this and fellow methods are wrapped in setTimeout
	      // to make sure initialize setState has happened before
	      // any of such methods are called
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "previous"
	        });
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "next"
	        });
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      slide = Number(slide);
	      if (isNaN(slide)) return "";
	
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "index",
	          index: slide,
	          currentSlide: _this.state.currentSlide
	        }, dontAnimate);
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "play", function () {
	      var nextIndex;
	
	      if (_this.props.rtl) {
	        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
	      } else {
	        if ((0, _innerSliderUtils.canGoNext)(_objectSpread(_objectSpread({}, _this.props), _this.state))) {
	          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
	        } else {
	          return false;
	        }
	      }
	
	      _this.slideHandler(nextIndex);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "autoPlay", function (playType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	
	      var autoplaying = _this.state.autoplaying;
	
	      if (playType === "update") {
	        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
	          return;
	        }
	      } else if (playType === "leave") {
	        if (autoplaying === "paused" || autoplaying === "focused") {
	          return;
	        }
	      } else if (playType === "blur") {
	        if (autoplaying === "paused" || autoplaying === "hovered") {
	          return;
	        }
	      }
	
	      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
	
	      _this.setState({
	        autoplaying: "playing"
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "pause", function (pauseType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	        _this.autoplayTimer = null;
	      }
	
	      var autoplaying = _this.state.autoplaying;
	
	      if (pauseType === "paused") {
	        _this.setState({
	          autoplaying: "paused"
	        });
	      } else if (pauseType === "focused") {
	        if (autoplaying === "hovered" || autoplaying === "playing") {
	          _this.setState({
	            autoplaying: "focused"
	          });
	        }
	      } else {
	        // pauseType  is 'hovered'
	        if (autoplaying === "playing") {
	          _this.setState({
	            autoplaying: "hovered"
	          });
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDotsOver", function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDotsLeave", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTrackOver", function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTrackLeave", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSlideFocus", function () {
	      return _this.props.autoplay && _this.pause("focused");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSlideBlur", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "render", function () {
	      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
	        "slick-vertical": _this.props.vertical,
	        "slick-initialized": true
	      });
	
	      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);
	
	      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]);
	      var pauseOnHover = _this.props.pauseOnHover;
	      trackProps = _objectSpread(_objectSpread({}, trackProps), {}, {
	        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
	        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
	        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
	        focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
	      });
	      var dots;
	
	      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
	        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
	        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
	        dotProps = _objectSpread(_objectSpread({}, dotProps), {}, {
	          clickHandler: _this.changeSlide,
	          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
	          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
	          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
	        });
	        dots = /*#__PURE__*/_react["default"].createElement(_dots.Dots, dotProps);
	      }
	
	      var prevArrow, nextArrow;
	      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
	      arrowProps.clickHandler = _this.changeSlide;
	
	      if (_this.props.arrows) {
	        prevArrow = /*#__PURE__*/_react["default"].createElement(_arrows.PrevArrow, arrowProps);
	        nextArrow = /*#__PURE__*/_react["default"].createElement(_arrows.NextArrow, arrowProps);
	      }
	
	      var verticalHeightStyle = null;
	
	      if (_this.props.vertical) {
	        verticalHeightStyle = {
	          height: _this.state.listHeight
	        };
	      }
	
	      var centerPaddingStyle = null;
	
	      if (_this.props.vertical === false) {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: "0px " + _this.props.centerPadding
	          };
	        }
	      } else {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: _this.props.centerPadding + " 0px"
	          };
	        }
	      }
	
	      var listStyle = _objectSpread(_objectSpread({}, verticalHeightStyle), centerPaddingStyle);
	
	      var touchMove = _this.props.touchMove;
	      var listProps = {
	        className: "slick-list",
	        style: listStyle,
	        onClick: _this.clickHandler,
	        onMouseDown: touchMove ? _this.swipeStart : null,
	        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onMouseUp: touchMove ? _this.swipeEnd : null,
	        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onTouchStart: touchMove ? _this.swipeStart : null,
	        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onTouchEnd: touchMove ? _this.touchEnd : null,
	        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
	      };
	      var innerSliderProps = {
	        className: className,
	        dir: "ltr",
	        style: _this.props.style
	      };
	
	      if (_this.props.unslick) {
	        listProps = {
	          className: "slick-list"
	        };
	        innerSliderProps = {
	          className: className
	        };
	      }
	
	      return /*#__PURE__*/_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/_react["default"].createElement("div", _extends({
	        ref: _this.listRefHandler
	      }, listProps), /*#__PURE__*/_react["default"].createElement(_track.Track, _extends({
	        ref: _this.trackRefHandler
	      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
	    });
	
	    _this.list = null;
	    _this.track = null;
	    _this.state = _objectSpread(_objectSpread({}, _initialState["default"]), {}, {
	      currentSlide: _this.props.initialSlide,
	      slideCount: _react["default"].Children.count(_this.props.children)
	    });
	    _this.callbackTimers = [];
	    _this.clickable = true;
	    _this.debouncedResize = null;
	
	    var ssrState = _this.ssrInit();
	
	    _this.state = _objectSpread(_objectSpread({}, _this.state), ssrState);
	    return _this;
	  }
	
	  _createClass(InnerSlider, [{
	    key: "didPropsChange",
	    value: function didPropsChange(prevProps) {
	      var setTrackStyle = false;
	
	      for (var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++) {
	        var key = _Object$keys[_i3];
	
	        if (!prevProps.hasOwnProperty(key)) {
	          setTrackStyle = true;
	          break;
	        }
	
	        if (_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function") {
	          continue;
	        }
	
	        if (prevProps[key] !== this.props[key]) {
	          setTrackStyle = true;
	          break;
	        }
	      }
	
	      return setTrackStyle || _react["default"].Children.count(this.props.children) !== _react["default"].Children.count(prevProps.children);
	    }
	  }]);
	
	  return InnerSlider;
	}(_react["default"].Component);
	
	exports.InnerSlider = InnerSlider;

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(3));
	
	var _innerSlider = __webpack_require__(785);
	
	var _json2mq = _interopRequireDefault(__webpack_require__(666));
	
	var _defaultProps = _interopRequireDefault(__webpack_require__(781));
	
	var _innerSliderUtils = __webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(616);
	
	var Slider = /*#__PURE__*/function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  var _super = _createSuper(Slider);
	
	  function Slider(props) {
	    var _this;
	
	    _classCallCheck(this, Slider);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function (ref) {
	      return _this.innerSlider = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
	      return _this.innerSlider.slickPrev();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
	      return _this.innerSlider.slickNext();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      return _this.innerSlider.slickGoTo(slide, dontAnimate);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPause", function () {
	      return _this.innerSlider.pause("paused");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPlay", function () {
	      return _this.innerSlider.autoPlay("play");
	    });
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    return _this;
	  }
	
	  _createClass(Slider, [{
	    key: "media",
	    value: function media(query, handler) {
	      // javascript handler for  css media query
	      enquire.register(query, handler);
	
	      this._responsiveMediaHandlers.push({
	        query: query,
	        handler: handler
	      });
	    } // handles responsive breakpoints
	
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // performance monitoring
	      //if (process.env.NODE_ENV !== 'production') {
	      //const { whyDidYouUpdate } = require('why-did-you-update')
	      //whyDidYouUpdate(React)
	      //}
	      if (this.props.responsive) {
	        var breakpoints = this.props.responsive.map(function (breakpt) {
	          return breakpt.breakpoint;
	        }); // sort them in increasing order of their numerical value
	
	        breakpoints.sort(function (x, y) {
	          return x - y;
	        });
	        breakpoints.forEach(function (breakpoint, index) {
	          // media query for each breakpoint
	          var bQuery;
	
	          if (index === 0) {
	            bQuery = (0, _json2mq["default"])({
	              minWidth: 0,
	              maxWidth: breakpoint
	            });
	          } else {
	            bQuery = (0, _json2mq["default"])({
	              minWidth: breakpoints[index - 1] + 1,
	              maxWidth: breakpoint
	            });
	          } // when not using server side rendering
	
	
	          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
	            _this2.setState({
	              breakpoint: breakpoint
	            });
	          });
	        }); // Register media query for full screen. Need to support resize from small to large
	        // convert javascript object to media query string
	
	        var query = (0, _json2mq["default"])({
	          minWidth: breakpoints.slice(-1)[0]
	        });
	        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
	          _this2.setState({
	            breakpoint: null
	          });
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._responsiveMediaHandlers.forEach(function (obj) {
	        enquire.unregister(obj.query, obj.handler);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var settings;
	      var newProps;
	
	      if (this.state.breakpoint) {
	        newProps = this.props.responsive.filter(function (resp) {
	          return resp.breakpoint === _this3.state.breakpoint;
	        });
	        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread(_objectSpread(_objectSpread({}, _defaultProps["default"]), this.props), newProps[0].settings);
	      } else {
	        settings = _objectSpread(_objectSpread({}, _defaultProps["default"]), this.props);
	      } // force scrolling by one if centerMode is on
	
	
	      if (settings.centerMode) {
	        if (settings.slidesToScroll > 1 && ("production") !== "production") {
	          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
	        }
	
	        settings.slidesToScroll = 1;
	      } // force showing one slide and scrolling by one if the fade mode is on
	
	
	      if (settings.fade) {
	        if (settings.slidesToShow > 1 && ("production") !== "production") {
	          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
	        }
	
	        if (settings.slidesToScroll > 1 && ("production") !== "production") {
	          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
	        }
	
	        settings.slidesToShow = 1;
	        settings.slidesToScroll = 1;
	      } // makes sure that children is an array, even when there is only 1 child
	
	
	      var children = _react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
	      // children may also contain string filled with spaces (in certain cases where we use jsx strings)
	
	
	      children = children.filter(function (child) {
	        if (typeof child === "string") {
	          return !!child.trim();
	        }
	
	        return !!child;
	      }); // rows and slidesPerRow logic is handled here
	
	      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
	        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
	        settings.variableWidth = false;
	      }
	
	      var newChildren = [];
	      var currentWidth = null;
	
	      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
	        var newSlide = [];
	
	        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
	          var row = [];
	
	          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
	            if (settings.variableWidth && children[k].props.style) {
	              currentWidth = children[k].props.style.width;
	            }
	
	            if (k >= children.length) break;
	            row.push( /*#__PURE__*/_react["default"].cloneElement(children[k], {
	              key: 100 * i + 10 * j + k,
	              tabIndex: -1,
	              style: {
	                width: "".concat(100 / settings.slidesPerRow, "%"),
	                display: "inline-block"
	              }
	            }));
	          }
	
	          newSlide.push( /*#__PURE__*/_react["default"].createElement("div", {
	            key: 10 * i + j
	          }, row));
	        }
	
	        if (settings.variableWidth) {
	          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
	            key: i,
	            style: {
	              width: currentWidth
	            }
	          }, newSlide));
	        } else {
	          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
	            key: i
	          }, newSlide));
	        }
	      }
	
	      if (settings === "unslick") {
	        var className = "regular slider " + (this.props.className || "");
	        return /*#__PURE__*/_react["default"].createElement("div", {
	          className: className
	        }, children);
	      } else if (newChildren.length <= settings.slidesToShow) {
	        settings.unslick = true;
	      }
	
	      return /*#__PURE__*/_react["default"].createElement(_innerSlider.InnerSlider, _extends({
	        style: this.props.style,
	        ref: this.innerSliderRefHandler
	      }, settings), newChildren);
	    }
	  }]);
	
	  return Slider;
	}(_react["default"].Component);
	
	exports["default"] = Slider;

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Track = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(77));
	
	var _innerSliderUtils = __webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	
	  slickCloned = index < 0 || index >= spec.slideCount;
	
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	
	  var focusedSlide;
	
	  if (spec.targetSlide < 0) {
	    focusedSlide = spec.targetSlide + spec.slideCount;
	  } else if (spec.targetSlide >= spec.slideCount) {
	    focusedSlide = spec.targetSlide - spec.slideCount;
	  } else {
	    focusedSlide = spec.targetSlide;
	  }
	
	  var slickCurrent = index === focusedSlide;
	  return {
	    "slick-slide": true,
	    "slick-active": slickActive,
	    "slick-center": slickCenter,
	    "slick-cloned": slickCloned,
	    "slick-current": slickCurrent // dubious in case of RTL
	
	  };
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = "relative";
	
	    if (spec.vertical) {
	      style.top = -spec.index * parseInt(spec.slideHeight);
	    } else {
	      style.left = -spec.index * parseInt(spec.slideWidth);
	    }
	
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	
	    if (spec.useCSS) {
	      style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  return child.key || fallbackKey;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	
	  var childrenCount = _react["default"].Children.count(spec.children);
	
	  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
	  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);
	
	  _react["default"].Children.forEach(spec.children, function (elem, index) {
	    var child;
	    var childOnClickOptions = {
	      message: "children",
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    }; // in case of lazyLoad, whether or not we want to fetch the slide
	
	    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
	      child = elem;
	    } else {
	      child = /*#__PURE__*/_react["default"].createElement("div", null);
	    }
	
	    var childStyle = getSlideStyle(_objectSpread(_objectSpread({}, spec), {}, {
	      index: index
	    }));
	    var slideClass = child.props.className || "";
	    var slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
	      index: index
	    })); // push a cloned element of the desired slide
	
	    slides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
	      key: "original" + getKey(child, index),
	      "data-index": index,
	      className: (0, _classnames["default"])(slideClasses, slideClass),
	      tabIndex: "-1",
	      "aria-hidden": !slideClasses["slick-active"],
	      style: _objectSpread(_objectSpread({
	        outline: "none"
	      }, child.props.style || {}), childStyle),
	      onClick: function onClick(e) {
	        child.props && child.props.onClick && child.props.onClick(e);
	
	        if (spec.focusOnSelect) {
	          spec.focusOnSelect(childOnClickOptions);
	        }
	      }
	    })); // if slide needs to be precloned or postcloned
	
	    if (spec.infinite && spec.fade === false) {
	      var preCloneNo = childrenCount - index;
	
	      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
	        key = -preCloneNo;
	
	        if (key >= startIndex) {
	          child = elem;
	        }
	
	        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
	          index: key
	        }));
	        preCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
	          key: "precloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames["default"])(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	
	      if (childrenCount !== spec.slidesToShow) {
	        key = childrenCount + index;
	
	        if (key < endIndex) {
	          child = elem;
	        }
	
	        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
	          index: key
	        }));
	        postCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
	          key: "postcloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames["default"])(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = /*#__PURE__*/function (_React$PureComponent) {
	  _inherits(Track, _React$PureComponent);
	
	  var _super = _createSuper(Track);
	
	  function Track() {
	    var _this;
	
	    _classCallCheck(this, Track);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "node", null);
	
	    _defineProperty(_assertThisInitialized(_this), "handleRef", function (ref) {
	      _this.node = ref;
	    });
	
	    return _this;
	  }
	
	  _createClass(Track, [{
	    key: "render",
	    value: function render() {
	      var slides = renderSlides(this.props);
	      var _this$props = this.props,
	          onMouseEnter = _this$props.onMouseEnter,
	          onMouseOver = _this$props.onMouseOver,
	          onMouseLeave = _this$props.onMouseLeave;
	      var mouseEvents = {
	        onMouseEnter: onMouseEnter,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave
	      };
	      return /*#__PURE__*/_react["default"].createElement("div", _extends({
	        ref: this.handleRef,
	        className: "slick-track",
	        style: this.props.trackStyle
	      }, mouseEvents), slides);
	    }
	  }]);
	
	  return Track;
	}(_react["default"].PureComponent);
	
	exports.Track = Track;

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _starRatings = __webpack_require__(789);
	
	var _starRatings2 = _interopRequireDefault(_starRatings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// polyfill for ie
	Number.isInteger = Number.isInteger || function (value) {
	  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
	};
	
	exports.default = _starRatings2.default;

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(401);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(38);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _star = __webpack_require__(790);
	
	var _star2 = _interopRequireDefault(_star);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StarRatings = function (_React$Component) {
	  _inherits(StarRatings, _React$Component);
	
	  function StarRatings() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StarRatings);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StarRatings.__proto__ || Object.getPrototypeOf(StarRatings)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      highestStarHovered: -Infinity
	    }, _this.fillId = 'starGrad' + Math.random().toFixed(15).slice(2), _this.hoverOverStar = function (starRating) {
	      return function () {
	        _this.setState({
	          highestStarHovered: starRating
	        });
	      };
	    }, _this.unHoverOverStar = function () {
	      _this.setState({
	        highestStarHovered: -Infinity
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(StarRatings, [{
	    key: 'stopColorStyle',
	    value: function stopColorStyle(color) {
	      var stopColorStyle = {
	        stopColor: color,
	        stopOpacity: '1'
	      };
	      return this.props.ignoreInlineStyles ? {} : stopColorStyle;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          starRatedColor = _props.starRatedColor,
	          starEmptyColor = _props.starEmptyColor;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'star-ratings',
	          title: this.titleText,
	          style: this.starRatingsStyle
	        },
	        _react2.default.createElement(
	          'svg',
	          {
	            className: 'star-grad',
	            style: this.starGradientStyle
	          },
	          _react2.default.createElement(
	            'defs',
	            null,
	            _react2.default.createElement(
	              'linearGradient',
	              { id: this.fillId, x1: '0%', y1: '0%', x2: '100%', y2: '0%' },
	              _react2.default.createElement('stop', { offset: '0%', className: 'stop-color-first', style: this.stopColorStyle(starRatedColor) }),
	              _react2.default.createElement('stop', { offset: this.offsetValue, className: 'stop-color-first', style: this.stopColorStyle(starRatedColor) }),
	              _react2.default.createElement('stop', { offset: this.offsetValue, className: 'stop-color-final', style: this.stopColorStyle(starEmptyColor) }),
	              _react2.default.createElement('stop', { offset: '100%', className: 'stop-color-final', style: this.stopColorStyle(starEmptyColor) })
	            )
	          )
	        ),
	        this.renderStars
	      );
	    }
	  }, {
	    key: 'starRatingsStyle',
	    get: function get() {
	      var starRatingsStyle = {
	        position: 'relative',
	        boxSizing: 'border-box',
	        display: 'inline-block'
	      };
	      return this.props.ignoreInlineStyles ? {} : starRatingsStyle;
	    }
	  }, {
	    key: 'starGradientStyle',
	    get: function get() {
	      var starGradientStyle = {
	        position: 'absolute',
	        zIndex: '0',
	        width: '0',
	        height: '0',
	        visibility: 'hidden'
	      };
	      return this.props.ignoreInlineStyles ? {} : starGradientStyle;
	    }
	  }, {
	    key: 'titleText',
	    get: function get() {
	      var _props2 = this.props,
	          typeOfWidget = _props2.typeOfWidget,
	          selectedRating = _props2.rating;
	
	      var hoveredRating = this.state.highestStarHovered;
	      var currentRating = hoveredRating > 0 ? hoveredRating : selectedRating;
	      // fix it at 2 decimal places and remove trailing 0s
	      var formattedRating = parseFloat(currentRating.toFixed(2)).toString();
	      if (Number.isInteger(currentRating)) {
	        formattedRating = String(currentRating);
	      }
	      var starText = typeOfWidget + 's';
	      if (formattedRating === '1') {
	        starText = typeOfWidget;
	      }
	      return formattedRating + ' ' + starText;
	    }
	  }, {
	    key: 'offsetValue',
	    get: function get() {
	      var rating = this.props.rating;
	      var ratingIsInteger = Number.isInteger(rating);
	      var offsetValue = '0%';
	      if (!ratingIsInteger) {
	        var firstTwoDecimals = rating.toFixed(2).split('.')[1].slice(0, 2);
	        offsetValue = firstTwoDecimals + '%';
	      }
	      return offsetValue;
	    }
	  }, {
	    key: 'renderStars',
	    get: function get() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          changeRating = _props3.changeRating,
	          selectedRating = _props3.rating,
	          numberOfStars = _props3.numberOfStars,
	          starDimension = _props3.starDimension,
	          starSpacing = _props3.starSpacing,
	          starRatedColor = _props3.starRatedColor,
	          starEmptyColor = _props3.starEmptyColor,
	          starHoverColor = _props3.starHoverColor,
	          gradientPathName = _props3.gradientPathName,
	          ignoreInlineStyles = _props3.ignoreInlineStyles,
	          svgIconPath = _props3.svgIconPath,
	          svgIconViewBox = _props3.svgIconViewBox,
	          name = _props3.name;
	      var highestStarHovered = this.state.highestStarHovered;
	
	
	      var numberOfStarsArray = Array.apply(null, Array(numberOfStars));
	
	      return numberOfStarsArray.map(function (_, index) {
	        var starRating = index + 1;
	        var isStarred = starRating <= selectedRating;
	
	        // hovered only matters when changeRating is true
	        var hoverMode = highestStarHovered > 0;
	        var isHovered = starRating <= highestStarHovered;
	        var isCurrentHoveredStar = starRating === highestStarHovered;
	
	        // only matters when changeRating is false
	        // given star 5 and rating 4.2:  5 > 4.2 && 4 < 4.2;
	        var isPartiallyFullStar = starRating > selectedRating && starRating - 1 < selectedRating;
	
	        var isFirstStar = starRating === 1;
	        var isLastStar = starRating === numberOfStars;
	
	        return _react2.default.createElement(_star2.default, {
	          key: starRating,
	          fillId: _this2.fillId,
	          changeRating: changeRating ? function () {
	            return changeRating(starRating, name);
	          } : null,
	          hoverOverStar: changeRating ? _this2.hoverOverStar(starRating) : null,
	          unHoverOverStar: changeRating ? _this2.unHoverOverStar : null,
	          isStarred: isStarred,
	          isPartiallyFullStar: isPartiallyFullStar,
	          isHovered: isHovered,
	          hoverMode: hoverMode,
	          isCurrentHoveredStar: isCurrentHoveredStar,
	          isFirstStar: isFirstStar,
	          isLastStar: isLastStar,
	          starDimension: starDimension,
	          starSpacing: starSpacing,
	          starHoverColor: starHoverColor,
	          starRatedColor: starRatedColor,
	          starEmptyColor: starEmptyColor,
	          gradientPathName: gradientPathName,
	          ignoreInlineStyles: ignoreInlineStyles,
	          svgIconPath: svgIconPath,
	          svgIconViewBox: svgIconViewBox
	        });
	      });
	    }
	  }]);
	
	  return StarRatings;
	}(_react2.default.Component);
	
	StarRatings.propTypes = {
	  rating: _propTypes2.default.number.isRequired,
	  numberOfStars: _propTypes2.default.number.isRequired,
	  changeRating: _propTypes2.default.func,
	  starHoverColor: _propTypes2.default.string.isRequired,
	  starRatedColor: _propTypes2.default.string.isRequired,
	  starEmptyColor: _propTypes2.default.string.isRequired,
	  starDimension: _propTypes2.default.string.isRequired,
	  starSpacing: _propTypes2.default.string.isRequired,
	  gradientPathName: _propTypes2.default.string.isRequired,
	  ignoreInlineStyles: _propTypes2.default.bool.isRequired,
	  svgIconPath: _propTypes2.default.string.isRequired,
	  svgIconViewBox: _propTypes2.default.string.isRequired,
	  name: _propTypes2.default.string
	};
	
	StarRatings.defaultProps = {
	  rating: 0,
	  typeOfWidget: 'Star',
	  numberOfStars: 5,
	  changeRating: null,
	  starHoverColor: 'rgb(230, 67, 47)',
	  starRatedColor: 'rgb(109, 122, 130)',
	  starEmptyColor: 'rgb(203, 211, 227)',
	  starDimension: '50px',
	  starSpacing: '7px',
	  gradientPathName: '',
	  ignoreInlineStyles: false,
	  svgIconPath: 'm25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z',
	  svgIconViewBox: '0 0 51 48'
	};
	
	exports.default = StarRatings;

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(401);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(77);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(38);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Star = function (_React$Component) {
	  _inherits(Star, _React$Component);
	
	  function Star() {
	    _classCallCheck(this, Star);
	
	    return _possibleConstructorReturn(this, (Star.__proto__ || Object.getPrototypeOf(Star)).apply(this, arguments));
	  }
	
	  _createClass(Star, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          changeRating = _props.changeRating,
	          hoverOverStar = _props.hoverOverStar,
	          unHoverOverStar = _props.unHoverOverStar,
	          svgIconViewBox = _props.svgIconViewBox,
	          svgIconPath = _props.svgIconPath;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'star-container',
	          style: this.starContainerStyle,
	          onMouseEnter: hoverOverStar,
	          onMouseLeave: unHoverOverStar,
	          onClick: changeRating
	        },
	        _react2.default.createElement(
	          'svg',
	          {
	            viewBox: svgIconViewBox,
	            className: this.starClasses,
	            style: this.starSvgStyle
	          },
	          _react2.default.createElement('path', {
	            className: 'star',
	            style: this.pathStyle,
	            d: svgIconPath
	          })
	        )
	      );
	    }
	  }, {
	    key: 'starContainerStyle',
	    get: function get() {
	      var _props2 = this.props,
	          changeRating = _props2.changeRating,
	          starSpacing = _props2.starSpacing,
	          isFirstStar = _props2.isFirstStar,
	          isLastStar = _props2.isLastStar,
	          ignoreInlineStyles = _props2.ignoreInlineStyles;
	
	
	      var starContainerStyle = {
	        position: 'relative',
	        display: 'inline-block',
	        verticalAlign: 'middle',
	        paddingLeft: isFirstStar ? undefined : starSpacing,
	        paddingRight: isLastStar ? undefined : starSpacing,
	        cursor: changeRating ? 'pointer' : undefined
	      };
	      return ignoreInlineStyles ? {} : starContainerStyle;
	    }
	  }, {
	    key: 'starSvgStyle',
	    get: function get() {
	      var _props3 = this.props,
	          ignoreInlineStyles = _props3.ignoreInlineStyles,
	          isCurrentHoveredStar = _props3.isCurrentHoveredStar,
	          starDimension = _props3.starDimension;
	
	      var starSvgStyle = {
	        width: starDimension,
	        height: starDimension,
	        transition: 'transform .2s ease-in-out',
	        transform: isCurrentHoveredStar ? 'scale(1.1)' : undefined
	      };
	
	      return ignoreInlineStyles ? {} : starSvgStyle;
	    }
	  }, {
	    key: 'pathStyle',
	    get: function get() {
	      var _props4 = this.props,
	          isStarred = _props4.isStarred,
	          isPartiallyFullStar = _props4.isPartiallyFullStar,
	          isHovered = _props4.isHovered,
	          hoverMode = _props4.hoverMode,
	          starEmptyColor = _props4.starEmptyColor,
	          starRatedColor = _props4.starRatedColor,
	          starHoverColor = _props4.starHoverColor,
	          gradientPathName = _props4.gradientPathName,
	          fillId = _props4.fillId,
	          ignoreInlineStyles = _props4.ignoreInlineStyles;
	
	
	      var fill = void 0;
	      if (hoverMode) {
	        if (isHovered) fill = starHoverColor;else fill = starEmptyColor;
	      } else {
	        if (isPartiallyFullStar) fill = 'url(\'' + gradientPathName + '#' + fillId + '\')';else if (isStarred) fill = starRatedColor;else fill = starEmptyColor;
	      }
	
	      var pathStyle = {
	        fill: fill,
	        transition: 'fill .2s ease-in-out'
	      };
	
	      return ignoreInlineStyles ? {} : pathStyle;
	    }
	  }, {
	    key: 'starClasses',
	    get: function get() {
	      var _props5 = this.props,
	          isSelected = _props5.isSelected,
	          isPartiallyFullStar = _props5.isPartiallyFullStar,
	          isHovered = _props5.isHovered,
	          isCurrentHoveredStar = _props5.isCurrentHoveredStar,
	          ignoreInlineStyles = _props5.ignoreInlineStyles;
	
	
	      var starClasses = (0, _classnames2.default)({
	        'widget-svg': true,
	        'widget-selected': isSelected,
	        'multi-widget-selected': isPartiallyFullStar,
	        'hovered': isHovered,
	        'current-hovered': isCurrentHoveredStar
	      });
	
	      return ignoreInlineStyles ? {} : starClasses;
	    }
	  }]);
	
	  return Star;
	}(_react2.default.Component);
	
	Star.propTypes = {
	  fillId: _propTypes2.default.string.isRequired,
	  changeRating: _propTypes2.default.func,
	  hoverOverStar: _propTypes2.default.func,
	  unHoverOverStar: _propTypes2.default.func,
	  isStarred: _propTypes2.default.bool.isRequired,
	  isPartiallyFullStar: _propTypes2.default.bool.isRequired,
	  isHovered: _propTypes2.default.bool.isRequired,
	  hoverMode: _propTypes2.default.bool.isRequired,
	  isCurrentHoveredStar: _propTypes2.default.bool.isRequired,
	  isFirstStar: _propTypes2.default.bool.isRequired,
	  isLastStar: _propTypes2.default.bool.isRequired,
	  starDimension: _propTypes2.default.string.isRequired,
	  starSpacing: _propTypes2.default.string.isRequired,
	  starHoverColor: _propTypes2.default.string.isRequired,
	  starRatedColor: _propTypes2.default.string.isRequired,
	  starEmptyColor: _propTypes2.default.string.isRequired,
	  gradientPathName: _propTypes2.default.string.isRequired,
	  ignoreInlineStyles: _propTypes2.default.bool.isRequired,
	  svgIconPath: _propTypes2.default.string.isRequired,
	  svgIconViewBox: _propTypes2.default.string.isRequired
	};
	
	exports.default = Star;

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var l=__webpack_require__(16),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
	60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
	function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
	function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
	function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
	var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
	exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
	key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
	exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(104));
	
	var _excluded = ["children", "className", "disabled", "disabledClassName", "focus", "id", "panelId", "selected", "selectedClassName", "tabIndex", "tabRef"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var DEFAULT_CLASS = 'react-tabs__tab';
	
	var Tab = /*#__PURE__*/function (_Component) {
	  _inheritsLoose(Tab, _Component);
	
	  function Tab() {
	    return _Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Tab.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.checkFocus();
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate() {
	    this.checkFocus();
	  };
	
	  _proto.checkFocus = function checkFocus() {
	    var _this$props = this.props,
	        selected = _this$props.selected,
	        focus = _this$props.focus;
	
	    if (selected && focus) {
	      this.node.focus();
	    }
	  };
	
	  _proto.render = function render() {
	    var _cx,
	        _this = this;
	
	    var _this$props2 = this.props,
	        children = _this$props2.children,
	        className = _this$props2.className,
	        disabled = _this$props2.disabled,
	        disabledClassName = _this$props2.disabledClassName,
	        focus = _this$props2.focus,
	        id = _this$props2.id,
	        panelId = _this$props2.panelId,
	        selected = _this$props2.selected,
	        selectedClassName = _this$props2.selectedClassName,
	        tabIndex = _this$props2.tabIndex,
	        tabRef = _this$props2.tabRef,
	        attributes = _objectWithoutPropertiesLoose(_this$props2, _excluded);
	
	    return /*#__PURE__*/_react["default"].createElement("li", _extends({}, attributes, {
	      className: (0, _clsx["default"])(className, (_cx = {}, _cx[selectedClassName] = selected, _cx[disabledClassName] = disabled, _cx)),
	      ref: function ref(node) {
	        _this.node = node;
	        if (tabRef) tabRef(node);
	      },
	      role: "tab",
	      id: id,
	      "aria-selected": selected ? 'true' : 'false',
	      "aria-disabled": disabled ? 'true' : 'false',
	      "aria-controls": panelId,
	      tabIndex: tabIndex || (selected ? '0' : null),
	      "data-rttab": true
	    }), children);
	  };
	
	  return Tab;
	}(_react.Component);
	
	exports["default"] = Tab;
	Tab.defaultProps = {
	  className: DEFAULT_CLASS,
	  disabledClassName: DEFAULT_CLASS + "--disabled",
	  focus: false,
	  id: null,
	  panelId: null,
	  selected: false,
	  selectedClassName: DEFAULT_CLASS + "--selected"
	};
	Tab.propTypes =  false ? {
	  children: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object, _propTypes["default"].string]),
	  className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
	  disabled: _propTypes["default"].bool,
	  tabIndex: _propTypes["default"].string,
	  disabledClassName: _propTypes["default"].string,
	  focus: _propTypes["default"].bool,
	  // private
	  id: _propTypes["default"].string,
	  // private
	  panelId: _propTypes["default"].string,
	  // private
	  selected: _propTypes["default"].bool,
	  // private
	  selectedClassName: _propTypes["default"].string,
	  tabRef: _propTypes["default"].func // private
	
	} : {};
	Tab.tabsRole = 'Tab';

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(104));
	
	var _excluded = ["children", "className"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var TabList = /*#__PURE__*/function (_Component) {
	  _inheritsLoose(TabList, _Component);
	
	  function TabList() {
	    return _Component.apply(this, arguments) || this;
	  }
	
	  var _proto = TabList.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        className = _this$props.className,
	        attributes = _objectWithoutPropertiesLoose(_this$props, _excluded);
	
	    return /*#__PURE__*/_react["default"].createElement("ul", _extends({}, attributes, {
	      className: (0, _clsx["default"])(className),
	      role: "tablist"
	    }), children);
	  };
	
	  return TabList;
	}(_react.Component);
	
	exports["default"] = TabList;
	TabList.defaultProps = {
	  className: 'react-tabs__tab-list'
	};
	TabList.propTypes =  false ? {
	  children: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array]),
	  className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object])
	} : {};
	TabList.tabsRole = 'TabList';

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(104));
	
	var _excluded = ["children", "className", "forceRender", "id", "selected", "selectedClassName", "tabId"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var DEFAULT_CLASS = 'react-tabs__tab-panel';
	
	var TabPanel = /*#__PURE__*/function (_Component) {
	  _inheritsLoose(TabPanel, _Component);
	
	  function TabPanel() {
	    return _Component.apply(this, arguments) || this;
	  }
	
	  var _proto = TabPanel.prototype;
	
	  _proto.render = function render() {
	    var _cx;
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        className = _this$props.className,
	        forceRender = _this$props.forceRender,
	        id = _this$props.id,
	        selected = _this$props.selected,
	        selectedClassName = _this$props.selectedClassName,
	        tabId = _this$props.tabId,
	        attributes = _objectWithoutPropertiesLoose(_this$props, _excluded);
	
	    return /*#__PURE__*/_react["default"].createElement("div", _extends({}, attributes, {
	      className: (0, _clsx["default"])(className, (_cx = {}, _cx[selectedClassName] = selected, _cx)),
	      role: "tabpanel",
	      id: id,
	      "aria-labelledby": tabId
	    }), forceRender || selected ? children : null);
	  };
	
	  return TabPanel;
	}(_react.Component);
	
	exports["default"] = TabPanel;
	TabPanel.defaultProps = {
	  className: DEFAULT_CLASS,
	  forceRender: false,
	  selectedClassName: DEFAULT_CLASS + "--selected"
	};
	TabPanel.propTypes =  false ? {
	  children: _propTypes["default"].node,
	  className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
	  forceRender: _propTypes["default"].bool,
	  id: _propTypes["default"].string,
	  // private
	  selected: _propTypes["default"].bool,
	  // private
	  selectedClassName: _propTypes["default"].string,
	  tabId: _propTypes["default"].string // private
	
	} : {};
	TabPanel.tabsRole = 'TabPanel';

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(3));
	
	var _propTypes2 = __webpack_require__(403);
	
	var _UncontrolledTabs = _interopRequireDefault(__webpack_require__(796));
	
	var _count = __webpack_require__(402);
	
	var _excluded = ["children", "defaultIndex", "defaultFocus"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var MODE_CONTROLLED = 0;
	var MODE_UNCONTROLLED = 1;
	
	var Tabs = /*#__PURE__*/function (_Component) {
	  _inheritsLoose(Tabs, _Component);
	
	  function Tabs(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	
	    _this.handleSelected = function (index, last, event) {
	      var onSelect = _this.props.onSelect;
	      var mode = _this.state.mode; // Call change event handler
	
	      if (typeof onSelect === 'function') {
	        // Check if the change event handler cancels the tab change
	        if (onSelect(index, last, event) === false) return;
	      }
	
	      var state = {
	        // Set focus if the change was triggered from the keyboard
	        focus: event.type === 'keydown'
	      };
	
	      if (mode === MODE_UNCONTROLLED) {
	        // Update selected index
	        state.selectedIndex = index;
	      }
	
	      _this.setState(state);
	    };
	
	    _this.state = Tabs.copyPropsToState(_this.props, {}, props.defaultFocus);
	    return _this;
	  }
	
	  Tabs.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
	    return Tabs.copyPropsToState(props, state);
	  };
	
	  Tabs.getModeFromProps = function getModeFromProps(props) {
	    return props.selectedIndex === null ? MODE_UNCONTROLLED : MODE_CONTROLLED;
	  };
	
	  // preserve the existing selectedIndex from state.
	  // If the state has not selectedIndex, default to the defaultIndex or 0
	  Tabs.copyPropsToState = function copyPropsToState(props, state, focus) {
	    if (focus === void 0) {
	      focus = false;
	    }
	
	    if (false) {
	      throw new Error("Switching between controlled mode (by using `selectedIndex`) and uncontrolled mode is not supported in `Tabs`.\nFor more information about controlled and uncontrolled mode of react-tabs see https://github.com/reactjs/react-tabs#controlled-vs-uncontrolled-mode.");
	    }
	
	    var newState = {
	      focus: focus,
	      mode: Tabs.getModeFromProps(props)
	    };
	
	    if (newState.mode === MODE_UNCONTROLLED) {
	      var maxTabIndex = Math.max(0, (0, _count.getTabsCount)(props.children) - 1);
	      var selectedIndex = null;
	
	      if (state.selectedIndex != null) {
	        selectedIndex = Math.min(state.selectedIndex, maxTabIndex);
	      } else {
	        selectedIndex = props.defaultIndex || 0;
	      }
	
	      newState.selectedIndex = selectedIndex;
	    }
	
	    return newState;
	  };
	
	  var _proto = Tabs.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        defaultIndex = _this$props.defaultIndex,
	        defaultFocus = _this$props.defaultFocus,
	        props = _objectWithoutPropertiesLoose(_this$props, _excluded);
	
	    var _this$state = this.state,
	        focus = _this$state.focus,
	        selectedIndex = _this$state.selectedIndex;
	    props.focus = focus;
	    props.onSelect = this.handleSelected;
	
	    if (selectedIndex != null) {
	      props.selectedIndex = selectedIndex;
	    }
	
	    return /*#__PURE__*/_react["default"].createElement(_UncontrolledTabs["default"], props, children);
	  };
	
	  return Tabs;
	}(_react.Component);
	
	exports["default"] = Tabs;
	Tabs.defaultProps = {
	  defaultFocus: false,
	  forceRenderTabPanel: false,
	  selectedIndex: null,
	  defaultIndex: null,
	  environment: null,
	  disableUpDownKeys: false
	};
	Tabs.propTypes =  false ? {
	  children: _propTypes2.childrenPropType,
	  direction: _propTypes["default"].oneOf(['rtl', 'ltr']),
	  className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
	  defaultFocus: _propTypes["default"].bool,
	  defaultIndex: _propTypes["default"].number,
	  disabledTabClassName: _propTypes["default"].string,
	  disableUpDownKeys: _propTypes["default"].bool,
	  domRef: _propTypes["default"].func,
	  forceRenderTabPanel: _propTypes["default"].bool,
	  onSelect: _propTypes2.onSelectPropType,
	  selectedIndex: _propTypes2.selectedIndexPropType,
	  selectedTabClassName: _propTypes["default"].string,
	  selectedTabPanelClassName: _propTypes["default"].string,
	  environment: _propTypes["default"].object
	} : {};
	Tabs.tabsRole = 'Tabs';

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(3));
	
	var _clsx = _interopRequireDefault(__webpack_require__(104));
	
	var _uuid = _interopRequireDefault(__webpack_require__(404));
	
	var _propTypes2 = __webpack_require__(403);
	
	var _count = __webpack_require__(402);
	
	var _childrenDeepMap = __webpack_require__(160);
	
	var _elementTypes = __webpack_require__(112);
	
	var _excluded = ["children", "className", "disabledTabClassName", "domRef", "focus", "forceRenderTabPanel", "onSelect", "selectedIndex", "selectedTabClassName", "selectedTabPanelClassName", "environment", "disableUpDownKeys"];
	
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function isNode(node) {
	  return node && 'getAttribute' in node;
	} // Determine if a node from event.target is a Tab element
	
	
	function isTabNode(node) {
	  return isNode(node) && node.getAttribute('data-rttab');
	} // Determine if a tab node is disabled
	
	
	function isTabDisabled(node) {
	  return isNode(node) && node.getAttribute('aria-disabled') === 'true';
	}
	
	var canUseActiveElement;
	
	function determineCanUseActiveElement(environment) {
	  var env = environment || (typeof window !== 'undefined' ? window : undefined);
	
	  try {
	    canUseActiveElement = !!(typeof env !== 'undefined' && env.document && env.document.activeElement);
	  } catch (e) {
	    // Work around for IE bug when accessing document.activeElement in an iframe
	    // Refer to the following resources:
	    // http://stackoverflow.com/a/10982960/369687
	    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12733599
	    canUseActiveElement = false;
	  }
	}
	
	var UncontrolledTabs = /*#__PURE__*/function (_Component) {
	  _inheritsLoose(UncontrolledTabs, _Component);
	
	  function UncontrolledTabs() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	    _this.tabNodes = [];
	
	    _this.handleKeyDown = function (e) {
	      var _this$props = _this.props,
	          direction = _this$props.direction,
	          disableUpDownKeys = _this$props.disableUpDownKeys;
	
	      if (_this.isTabFromContainer(e.target)) {
	        var index = _this.props.selectedIndex;
	        var preventDefault = false;
	        var useSelectedIndex = false;
	
	        if (e.keyCode === 32 || e.keyCode === 13) {
	          preventDefault = true;
	          useSelectedIndex = false;
	
	          _this.handleClick(e);
	        }
	
	        if (e.keyCode === 37 || !disableUpDownKeys && e.keyCode === 38) {
	          // Select next tab to the left, validate if up arrow is not disabled
	          if (direction === 'rtl') {
	            index = _this.getNextTab(index);
	          } else {
	            index = _this.getPrevTab(index);
	          }
	
	          preventDefault = true;
	          useSelectedIndex = true;
	        } else if (e.keyCode === 39 || !disableUpDownKeys && e.keyCode === 40) {
	          // Select next tab to the right, validate if down arrow is not disabled
	          if (direction === 'rtl') {
	            index = _this.getPrevTab(index);
	          } else {
	            index = _this.getNextTab(index);
	          }
	
	          preventDefault = true;
	          useSelectedIndex = true;
	        } else if (e.keyCode === 35) {
	          // Select last tab (End key)
	          index = _this.getLastTab();
	          preventDefault = true;
	          useSelectedIndex = true;
	        } else if (e.keyCode === 36) {
	          // Select first tab (Home key)
	          index = _this.getFirstTab();
	          preventDefault = true;
	          useSelectedIndex = true;
	        } // This prevents scrollbars from moving around
	
	
	        if (preventDefault) {
	          e.preventDefault();
	        } // Only use the selected index in the state if we're not using the tabbed index
	
	
	        if (useSelectedIndex) {
	          _this.setSelected(index, e);
	        }
	      }
	    };
	
	    _this.handleClick = function (e) {
	      var node = e.target;
	
	      do {
	        if (_this.isTabFromContainer(node)) {
	          if (isTabDisabled(node)) {
	            return;
	          }
	
	          var index = [].slice.call(node.parentNode.children).filter(isTabNode).indexOf(node);
	
	          _this.setSelected(index, e);
	
	          return;
	        }
	      } while ((node = node.parentNode) != null);
	    };
	
	    return _this;
	  }
	
	  var _proto = UncontrolledTabs.prototype;
	
	  _proto.setSelected = function setSelected(index, event) {
	    // Check index boundary
	    if (index < 0 || index >= this.getTabsCount()) return;
	    var _this$props2 = this.props,
	        onSelect = _this$props2.onSelect,
	        selectedIndex = _this$props2.selectedIndex; // Call change event handler
	
	    onSelect(index, selectedIndex, event);
	  };
	
	  _proto.getNextTab = function getNextTab(index) {
	    var count = this.getTabsCount(); // Look for non-disabled tab from index to the last tab on the right
	
	    for (var i = index + 1; i < count; i++) {
	      if (!isTabDisabled(this.getTab(i))) {
	        return i;
	      }
	    } // If no tab found, continue searching from first on left to index
	
	
	    for (var _i = 0; _i < index; _i++) {
	      if (!isTabDisabled(this.getTab(_i))) {
	        return _i;
	      }
	    } // No tabs are disabled, return index
	
	
	    return index;
	  };
	
	  _proto.getPrevTab = function getPrevTab(index) {
	    var i = index; // Look for non-disabled tab from index to first tab on the left
	
	    while (i--) {
	      if (!isTabDisabled(this.getTab(i))) {
	        return i;
	      }
	    } // If no tab found, continue searching from last tab on right to index
	
	
	    i = this.getTabsCount();
	
	    while (i-- > index) {
	      if (!isTabDisabled(this.getTab(i))) {
	        return i;
	      }
	    } // No tabs are disabled, return index
	
	
	    return index;
	  };
	
	  _proto.getFirstTab = function getFirstTab() {
	    var count = this.getTabsCount(); // Look for non disabled tab from the first tab
	
	    for (var i = 0; i < count; i++) {
	      if (!isTabDisabled(this.getTab(i))) {
	        return i;
	      }
	    }
	
	    return null;
	  };
	
	  _proto.getLastTab = function getLastTab() {
	    var i = this.getTabsCount(); // Look for non disabled tab from the last tab
	
	    while (i--) {
	      if (!isTabDisabled(this.getTab(i))) {
	        return i;
	      }
	    }
	
	    return null;
	  };
	
	  _proto.getTabsCount = function getTabsCount() {
	    var children = this.props.children;
	    return (0, _count.getTabsCount)(children);
	  };
	
	  _proto.getPanelsCount = function getPanelsCount() {
	    var children = this.props.children;
	    return (0, _count.getPanelsCount)(children);
	  };
	
	  _proto.getTab = function getTab(index) {
	    return this.tabNodes["tabs-" + index];
	  };
	
	  _proto.getChildren = function getChildren() {
	    var _this2 = this;
	
	    var index = 0;
	    var _this$props3 = this.props,
	        children = _this$props3.children,
	        disabledTabClassName = _this$props3.disabledTabClassName,
	        focus = _this$props3.focus,
	        forceRenderTabPanel = _this$props3.forceRenderTabPanel,
	        selectedIndex = _this$props3.selectedIndex,
	        selectedTabClassName = _this$props3.selectedTabClassName,
	        selectedTabPanelClassName = _this$props3.selectedTabPanelClassName,
	        environment = _this$props3.environment;
	    this.tabIds = this.tabIds || [];
	    this.panelIds = this.panelIds || [];
	    var diff = this.tabIds.length - this.getTabsCount(); // Add ids if new tabs have been added
	    // Don't bother removing ids, just keep them in case they are added again
	    // This is more efficient, and keeps the uuid counter under control
	
	    while (diff++ < 0) {
	      this.tabIds.push((0, _uuid["default"])());
	      this.panelIds.push((0, _uuid["default"])());
	    } // Map children to dynamically setup refs
	
	
	    return (0, _childrenDeepMap.deepMap)(children, function (child) {
	      var result = child; // Clone TabList and Tab components to have refs
	
	      if ((0, _elementTypes.isTabList)(child)) {
	        var listIndex = 0; // Figure out if the current focus in the DOM is set on a Tab
	        // If it is we should keep the focus on the next selected tab
	
	        var wasTabFocused = false;
	
	        if (canUseActiveElement == null) {
	          determineCanUseActiveElement(environment);
	        }
	
	        if (canUseActiveElement) {
	          wasTabFocused = _react["default"].Children.toArray(child.props.children).filter(_elementTypes.isTab).some(function (tab, i) {
	            var env = environment || (typeof window !== 'undefined' ? window : undefined);
	            return env && env.document.activeElement === _this2.getTab(i);
	          });
	        }
	
	        result = /*#__PURE__*/(0, _react.cloneElement)(child, {
	          children: (0, _childrenDeepMap.deepMap)(child.props.children, function (tab) {
	            var key = "tabs-" + listIndex;
	            var selected = selectedIndex === listIndex;
	            var props = {
	              tabRef: function tabRef(node) {
	                _this2.tabNodes[key] = node;
	              },
	              id: _this2.tabIds[listIndex],
	              panelId: _this2.panelIds[listIndex],
	              selected: selected,
	              focus: selected && (focus || wasTabFocused)
	            };
	            if (selectedTabClassName) props.selectedClassName = selectedTabClassName;
	            if (disabledTabClassName) props.disabledClassName = disabledTabClassName;
	            listIndex++;
	            return /*#__PURE__*/(0, _react.cloneElement)(tab, props);
	          })
	        });
	      } else if ((0, _elementTypes.isTabPanel)(child)) {
	        var props = {
	          id: _this2.panelIds[index],
	          tabId: _this2.tabIds[index],
	          selected: selectedIndex === index
	        };
	        if (forceRenderTabPanel) props.forceRender = forceRenderTabPanel;
	        if (selectedTabPanelClassName) props.selectedClassName = selectedTabPanelClassName;
	        index++;
	        result = /*#__PURE__*/(0, _react.cloneElement)(child, props);
	      }
	
	      return result;
	    });
	  };
	
	  /**
	   * Determine if a node from event.target is a Tab element for the current Tabs container.
	   * If the clicked element is not a Tab, it returns false.
	   * If it finds another Tabs container between the Tab and `this`, it returns false.
	   */
	  _proto.isTabFromContainer = function isTabFromContainer(node) {
	    // return immediately if the clicked element is not a Tab.
	    if (!isTabNode(node)) {
	      return false;
	    } // Check if the first occurrence of a Tabs container is `this` one.
	
	
	    var nodeAncestor = node.parentElement;
	
	    do {
	      if (nodeAncestor === this.node) return true;
	      if (nodeAncestor.getAttribute('data-rttabs')) break;
	      nodeAncestor = nodeAncestor.parentElement;
	    } while (nodeAncestor);
	
	    return false;
	  };
	
	  _proto.render = function render() {
	    var _this3 = this;
	
	    // Delete all known props, so they don't get added to DOM
	    var _this$props4 = this.props,
	        children = _this$props4.children,
	        className = _this$props4.className,
	        disabledTabClassName = _this$props4.disabledTabClassName,
	        domRef = _this$props4.domRef,
	        focus = _this$props4.focus,
	        forceRenderTabPanel = _this$props4.forceRenderTabPanel,
	        onSelect = _this$props4.onSelect,
	        selectedIndex = _this$props4.selectedIndex,
	        selectedTabClassName = _this$props4.selectedTabClassName,
	        selectedTabPanelClassName = _this$props4.selectedTabPanelClassName,
	        environment = _this$props4.environment,
	        disableUpDownKeys = _this$props4.disableUpDownKeys,
	        attributes = _objectWithoutPropertiesLoose(_this$props4, _excluded);
	
	    return /*#__PURE__*/_react["default"].createElement("div", _extends({}, attributes, {
	      className: (0, _clsx["default"])(className),
	      onClick: this.handleClick,
	      onKeyDown: this.handleKeyDown,
	      ref: function ref(node) {
	        _this3.node = node;
	        if (domRef) domRef(node);
	      },
	      "data-rttabs": true
	    }), this.getChildren());
	  };
	
	  return UncontrolledTabs;
	}(_react.Component);
	
	exports["default"] = UncontrolledTabs;
	UncontrolledTabs.defaultProps = {
	  className: 'react-tabs',
	  focus: false
	};
	UncontrolledTabs.propTypes =  false ? {
	  children: _propTypes2.childrenPropType,
	  direction: _propTypes["default"].oneOf(['rtl', 'ltr']),
	  className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
	  disabledTabClassName: _propTypes["default"].string,
	  disableUpDownKeys: _propTypes["default"].bool,
	  domRef: _propTypes["default"].func,
	  focus: _propTypes["default"].bool,
	  forceRenderTabPanel: _propTypes["default"].bool,
	  onSelect: _propTypes["default"].func.isRequired,
	  selectedIndex: _propTypes["default"].number.isRequired,
	  selectedTabClassName: _propTypes["default"].string,
	  selectedTabPanelClassName: _propTypes["default"].string,
	  environment: _propTypes["default"].object
	} : {};

/***/ },
/* 797 */
146,
/* 798 */
[855, 85],
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(798);
	var ReactElement = __webpack_require__(66);
	
	var emptyFunction = __webpack_require__(37);
	var traverseAllChildren = __webpack_require__(808);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(66);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(66),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(364);
	
	module.exports = factory(isValidElement);

/***/ },
/* 802 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.7.0';


/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(405),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(66),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(408);
	var factory = __webpack_require__(611);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 804 */
733,
/* 805 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(85);
	
	var ReactElement = __webpack_require__(66);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(85);
	
	var ReactCurrentOwner = __webpack_require__(44);
	var REACT_ELEMENT_TYPE = __webpack_require__(407);
	
	var getIteratorFn = __webpack_require__(804);
	var invariant = __webpack_require__(11);
	var KeyEscapeUtils = __webpack_require__(797);
	var warning = __webpack_require__(15);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 810 */
/***/ function(module, exports) {

	"use strict";function isAbsolute(e){return"/"===e.charAt(0)}function spliceOne(e,t){for(var s=t,n=s+1,i=e.length;n<i;s+=1,n+=1)e[s]=e[n];e.pop()}function resolvePathname(e,t){void 0===t&&(t="");var s,n=e&&e.split("/")||[],i=t&&t.split("/")||[],l=e&&isAbsolute(e),r=t&&isAbsolute(t),o=l||r;if(e&&isAbsolute(e)?i=n:n.length&&(i.pop(),i=i.concat(n)),!i.length)return"/";if(i.length){var u=i[i.length-1];s="."===u||".."===u||""===u}else s=!1;for(var a=0,c=i.length;0<=c;c--){var f=i[c];"."===f?spliceOne(i,c):".."===f?(spliceOne(i,c),a++):a&&(spliceOne(i,c),a--)}if(!o)for(;a--;a)i.unshift("..");!o||""===i[0]||i[0]&&isAbsolute(i[0])||i.unshift("");var h=i.join("/");return s&&"/"!==h.substr(-1)&&(h+="/"),h}module.exports=resolvePathname;


/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(810);
	} else {
	  module.exports = require('./cjs/resolve-pathname.js');
	}


/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(213)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(106)))

/***/ },
/* 814 */
/***/ function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(812).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	exports.__esModule = true;
	var style_to_object_1 = __importDefault(__webpack_require__(818));
	var utilities_1 = __webpack_require__(817);
	function StyleToJS(style, options) {
	    var output = {};
	    if (!style || typeof style !== 'string') {
	        return output;
	    }
	    style_to_object_1["default"](style, function (property, value) {
	        if (property && value) {
	            output[utilities_1.camelCase(property, options)] = value;
	        }
	    });
	    return output;
	}
	exports["default"] = StyleToJS;


/***/ },
/* 817 */
/***/ function(module, exports) {

	"use strict";
	exports.__esModule = true;
	exports.camelCase = void 0;
	var CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9-]+$/;
	var HYPHEN_REGEX = /-([a-z])/g;
	var NO_HYPHEN_REGEX = /^[^-]+$/;
	var VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
	var skipCamelCase = function (property) {
	    return !property ||
	        NO_HYPHEN_REGEX.test(property) ||
	        CUSTOM_PROPERTY_REGEX.test(property);
	};
	var capitalize = function (match, character) {
	    return character.toUpperCase();
	};
	var trimHyphen = function (match, prefix) { return prefix + "-"; };
	var camelCase = function (property, options) {
	    if (options === void 0) { options = {}; }
	    if (skipCamelCase(property)) {
	        return property;
	    }
	    property = property.toLowerCase();
	    if (!options.reactCompat) {
	        property = property.replace(VENDOR_PREFIX_REGEX, trimHyphen);
	    }
	    return property.replace(HYPHEN_REGEX, capitalize);
	};
	exports.camelCase = camelCase;


/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(657);
	
	/**
	 * Parses inline style to object.
	 *
	 * @example
	 * // returns { 'line-height': '42' }
	 * StyleToObject('line-height: 42;');
	 *
	 * @param  {String}      style      - The inline style.
	 * @param  {Function}    [iterator] - The iterator function.
	 * @return {null|Object}
	 */
	function StyleToObject(style, iterator) {
	  var output = null;
	  if (!style || typeof style !== 'string') {
	    return output;
	  }
	
	  var declaration;
	  var declarations = parse(style);
	  var hasIterator = typeof iterator === 'function';
	  var property;
	  var value;
	
	  for (var i = 0, len = declarations.length; i < len; i++) {
	    declaration = declarations[i];
	    property = declaration.property;
	    value = declaration.value;
	
	    if (hasIterator) {
	      iterator(property, value, declaration);
	    } else if (value) {
	      output || (output = {});
	      output[property] = value;
	    }
	  }
	
	  return output;
	}
	
	module.exports = StyleToObject;


/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(813);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Ahmed.f49474af.mp4";

/***/ },
/* 821 */
/***/ function(module, exports) {

	module.exports = "data:image/webp;base64,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"

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/anoop.ef08f1be.jpeg";

/***/ },
/* 823 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/careers.f57c87cf.png";

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/carrer.98cfc914.jpg";

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cerificate.0bd0f4b9.png";

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/certificate.9144f927.png";

/***/ },
/* 828 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAAICAYAAAAyRjsTAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAGhJREFUeNpi/A8EDKNg2AKm0SAY/hHMOAKwFxDfwOL/g0DMPZz9PlJy8HYgngLEr5HEzgFxPBB/Gy2ihweYCsTToeybQFwGxA+Hu6dZRliV1AfNsSB/7x0JHmYcbUSPtqJHwRAGAAEGAF8tE2KRCVqfAAAAAElFTkSuQmCC"

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/dm-instructor.18e3e8b5.jpg";

/***/ },
/* 830 */
/***/ function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/facebook.f755f149.png";

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/google-adwords-logo.354a83df.png";

/***/ },
/* 833 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAADsAAAA7AF5KHG9AAAKT2lDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVNnVFPpFj333vRCS4iAlEtvUhUIIFJCi4AUkSYqIQkQSoghodkVUcERRUUEG8igiAOOjoCMFVEsDIoK2AfkIaKOg6OIisr74Xuja9a89+bN/rXXPues852zzwfACAyWSDNRNYAMqUIeEeCDx8TG4eQuQIEKJHAAEAizZCFz/SMBAPh+PDwrIsAHvgABeNMLCADATZvAMByH/w/qQplcAYCEAcB0kThLCIAUAEB6jkKmAEBGAYCdmCZTAKAEAGDLY2LjAFAtAGAnf+bTAICd+Jl7AQBblCEVAaCRACATZYhEAGg7AKzPVopFAFgwABRmS8Q5ANgtADBJV2ZIALC3AMDOEAuyAAgMADBRiIUpAAR7AGDIIyN4AISZABRG8lc88SuuEOcqAAB4mbI8uSQ5RYFbCC1xB1dXLh4ozkkXKxQ2YQJhmkAuwnmZGTKBNA/g88wAAKCRFRHgg/P9eM4Ors7ONo62Dl8t6r8G/yJiYuP+5c+rcEAAAOF0ftH+LC+zGoA7BoBt/qIl7gRoXgugdfeLZrIPQLUAoOnaV/Nw+H48PEWhkLnZ2eXk5NhKxEJbYcpXff5nwl/AV/1s+X48/Pf14L7iJIEyXYFHBPjgwsz0TKUcz5IJhGLc5o9H/LcL//wd0yLESWK5WCoU41EScY5EmozzMqUiiUKSKcUl0v9k4t8s+wM+3zUAsGo+AXuRLahdYwP2SycQWHTA4vcAAPK7b8HUKAgDgGiD4c93/+8//UegJQCAZkmScQAAXkQkLlTKsz/HCAAARKCBKrBBG/TBGCzABhzBBdzBC/xgNoRCJMTCQhBCCmSAHHJgKayCQiiGzbAdKmAv1EAdNMBRaIaTcA4uwlW4Dj1wD/phCJ7BKLyBCQRByAgTYSHaiAFiilgjjggXmYX4IcFIBBKLJCDJiBRRIkuRNUgxUopUIFVIHfI9cgI5h1xGupE7yAAygvyGvEcxlIGyUT3UDLVDuag3GoRGogvQZHQxmo8WoJvQcrQaPYw2oefQq2gP2o8+Q8cwwOgYBzPEbDAuxsNCsTgsCZNjy7EirAyrxhqwVqwDu4n1Y8+xdwQSgUXACTYEd0IgYR5BSFhMWE7YSKggHCQ0EdoJNwkDhFHCJyKTqEu0JroR+cQYYjIxh1hILCPWEo8TLxB7iEPENyQSiUMyJ7mQAkmxpFTSEtJG0m5SI+ksqZs0SBojk8naZGuyBzmULCAryIXkneTD5DPkG+Qh8lsKnWJAcaT4U+IoUspqShnlEOU05QZlmDJBVaOaUt2ooVQRNY9aQq2htlKvUYeoEzR1mjnNgxZJS6WtopXTGmgXaPdpr+h0uhHdlR5Ol9BX0svpR+iX6AP0dwwNhhWDx4hnKBmbGAcYZxl3GK+YTKYZ04sZx1QwNzHrmOeZD5lvVVgqtip8FZHKCpVKlSaVGyovVKmqpqreqgtV81XLVI+pXlN9rkZVM1PjqQnUlqtVqp1Q61MbU2epO6iHqmeob1Q/pH5Z/YkGWcNMw09DpFGgsV/jvMYgC2MZs3gsIWsNq4Z1gTXEJrHN2Xx2KruY/R27iz2qqaE5QzNKM1ezUvOUZj8H45hx+Jx0TgnnKKeX836K3hTvKeIpG6Y0TLkxZVxrqpaXllirSKtRq0frvTau7aedpr1Fu1n7gQ5Bx0onXCdHZ4/OBZ3nU9lT3acKpxZNPTr1ri6qa6UbobtEd79up+6Ynr5egJ5Mb6feeb3n+hx9L/1U/W36p/VHDFgGswwkBtsMzhg8xTVxbzwdL8fb8VFDXcNAQ6VhlWGX4YSRudE8o9VGjUYPjGnGXOMk423GbcajJgYmISZLTepN7ppSTbmmKaY7TDtMx83MzaLN1pk1mz0x1zLnm+eb15vft2BaeFostqi2uGVJsuRaplnutrxuhVo5WaVYVVpds0atna0l1rutu6cRp7lOk06rntZnw7Dxtsm2qbcZsOXYBtuutm22fWFnYhdnt8Wuw+6TvZN9un2N/T0HDYfZDqsdWh1+c7RyFDpWOt6azpzuP33F9JbpL2dYzxDP2DPjthPLKcRpnVOb00dnF2e5c4PziIuJS4LLLpc+Lpsbxt3IveRKdPVxXeF60vWdm7Obwu2o26/uNu5p7ofcn8w0nymeWTNz0MPIQ+BR5dE/C5+VMGvfrH5PQ0+BZ7XnIy9jL5FXrdewt6V3qvdh7xc+9j5yn+M+4zw33jLeWV/MN8C3yLfLT8Nvnl+F30N/I/9k/3r/0QCngCUBZwOJgUGBWwL7+Hp8Ib+OPzrbZfay2e1BjKC5QRVBj4KtguXBrSFoyOyQrSH355jOkc5pDoVQfujW0Adh5mGLw34MJ4WHhVeGP45wiFga0TGXNXfR3ENz30T6RJZE3ptnMU85ry1KNSo+qi5qPNo3ujS6P8YuZlnM1VidWElsSxw5LiquNm5svt/87fOH4p3iC+N7F5gvyF1weaHOwvSFpxapLhIsOpZATIhOOJTwQRAqqBaMJfITdyWOCnnCHcJnIi/RNtGI2ENcKh5O8kgqTXqS7JG8NXkkxTOlLOW5hCepkLxMDUzdmzqeFpp2IG0yPTq9MYOSkZBxQqohTZO2Z+pn5mZ2y6xlhbL+xW6Lty8elQfJa7OQrAVZLQq2QqboVFoo1yoHsmdlV2a/zYnKOZarnivN7cyzytuQN5zvn//tEsIS4ZK2pYZLVy0dWOa9rGo5sjxxedsK4xUFK4ZWBqw8uIq2Km3VT6vtV5eufr0mek1rgV7ByoLBtQFr6wtVCuWFfevc1+1dT1gvWd+1YfqGnRs+FYmKrhTbF5cVf9go3HjlG4dvyr+Z3JS0qavEuWTPZtJm6ebeLZ5bDpaql+aXDm4N2dq0Dd9WtO319kXbL5fNKNu7g7ZDuaO/PLi8ZafJzs07P1SkVPRU+lQ27tLdtWHX+G7R7ht7vPY07NXbW7z3/T7JvttVAVVN1WbVZftJ+7P3P66Jqun4lvttXa1ObXHtxwPSA/0HIw6217nU1R3SPVRSj9Yr60cOxx++/p3vdy0NNg1VjZzG4iNwRHnk6fcJ3/ceDTradox7rOEH0x92HWcdL2pCmvKaRptTmvtbYlu6T8w+0dbq3nr8R9sfD5w0PFl5SvNUyWna6YLTk2fyz4ydlZ19fi753GDborZ752PO32oPb++6EHTh0kX/i+c7vDvOXPK4dPKy2+UTV7hXmq86X23qdOo8/pPTT8e7nLuarrlca7nuer21e2b36RueN87d9L158Rb/1tWeOT3dvfN6b/fF9/XfFt1+cif9zsu72Xcn7q28T7xf9EDtQdlD3YfVP1v+3Njv3H9qwHeg89HcR/cGhYPP/pH1jw9DBY+Zj8uGDYbrnjg+OTniP3L96fynQ89kzyaeF/6i/suuFxYvfvjV69fO0ZjRoZfyl5O/bXyl/erA6xmv28bCxh6+yXgzMV70VvvtwXfcdx3vo98PT+R8IH8o/2j5sfVT0Kf7kxmTk/8EA5jz/GMzLdsAAAAgY0hSTQAAeiUAAICDAAD5/wAAgOkAAHUwAADqYAAAOpgAABdvkl/FRgAAAhJJREFUeNrslz1oFFEUhb/drAlKTIqIJEpAwSBELBQCsQpCsAqKohH8A2uLQBAbU2gtFoLaa2mnjT+FkkZTBC1E/GlSKCSgRA2IGtd8Ft6FYdlkd2d32CYXDo93333nnHkz8+ZNTqWVkW9wfl+gJQZOAG+BD8DZ1CxqvehU7/g/PgaMXGe9fPWK71ffh+B9tUftVu9Fbk4dzsJATp1QfwUmIpesOaf+UJfVK2q+WQa2qA/iCt+p+9ao3aO+jtonam+jBkbUT0F4t8Z7vFG9EXMW1ENpDLTFMhbVJfVMiof1uPpVXQlDG2o10K9OxxXMqgMpxEvYoT4Prhl1ZzUDR9QvCdftDYiXUIjV/Kt+U8crGegIwRX1szrWBOFyjKrziedpU8nAbvVVDDxTt2cgXsJW9VFovVH3EpvHH3Wq1ne3QeTVy6E5h3pUHYrBHvVURsI59XRoEJony4smY3kGMzAwGNyTyXz517CjrG1mVOQupCTrBi4AB6P/FLgFLNVLlMbANmAa2AX8jNwocB4YAeazPpDcDvGLQFfgEjAA3Mz6RNQFjAEPgetAMXANeAwcBjZnaaAXaANeVhibjVval6WBUn2xwlgxDWeeFse6gXUDq+2Ex4ChVV7DajEOLFTI99diYDHaqSoi39fIXa0ydzHZyZX9HReAA1W+hsvATLTJaAeGo10tfgMvkvtIrtW/5/8GALjtR6qlqnbpAAAAAElFTkSuQmCC"

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/how-does-work.ae3e206b.jpg";

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/instagram.4382b2cd.png";

/***/ },
/* 836 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 837 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 838 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 839 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 840 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 841 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 842 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAGBAMAAACMWPXbAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAC1QTFRFAAAASUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJSUlJ3TSmxwAAAA90Uk5TAFC/758QQP/AMKPIkPCgXDZJCgAAADdJREFUeJxjYFR2ZcAHQowEGNLLi/CqaS+vZFheXr6jAzfoLi+vIUpNenkFQbsYe5/iVRN3QwAACNkugRUDKV8AAAAASUVORK5CYII="

/***/ },
/* 843 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAGBAMAAACMWPXbAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAC1QTFRFAAAAAG3/AG3/AG3/AG3/AG3/AG3/AG3/AG3/AG3/AG3/AG3/AG3/AG3/AG3/bOhaKQAAAA90Uk5TAFC/758QQP/AMKPIkPCgXDZJCgAAADdJREFUeJxjYFR2ZcAHQowEGNLLi/CqaS+vZFheXr6jAzfoLi+vIUpNenkFQbsYe5/iVRN3QwAACNkugRUDKV8AAAAASUVORK5CYII="

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/linkedin.a8be4bc8.png";

/***/ },
/* 845 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 846 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tiktok.7f1b39f3.png";

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/twitter.e5e15170.png";

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/what-is-typeform.efb626c7.jpg";

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/wordpress.ca52277d.png";

/***/ },
/* 851 */
/***/ function(module, exports) {

	"use strict";function valueOf(e){return e.valueOf?e.valueOf():Object.prototype.valueOf.call(e)}function valueEqual(u,r){if(u===r)return!0;if(null==u||null==r)return!1;if(Array.isArray(u))return Array.isArray(r)&&u.length===r.length&&u.every(function(e,u){return valueEqual(e,r[u])});if("object"!=typeof u&&"object"!=typeof r)return!1;var e=valueOf(u),t=valueOf(r);return e!==u||t!==r?valueEqual(e,t):Object.keys(Object.assign({},u,r)).every(function(e){return valueEqual(u[e],r[e])})}module.exports=valueEqual;


/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(851);
	} else {
	  module.exports = require('./cjs/value-equal.js');
	}


/***/ },
/* 853 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 854 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.d8ee7c52.js